'use strict';
import * as $i_$0040mlc$002dai$002fweb$002dllm from "@mlc-ai/web-llm";
var $linkingInfo = Object.freeze(({
  "esVersion": 6,
  "assumingES6": true,
  "productionMode": false,
  "linkerVersion": "1.16.0",
  "fileLevelThis": this
}));
var $getOwnPropertyDescriptors = (Object.getOwnPropertyDescriptors || (() => {
  var ownKeysFun;
  if ((((typeof Reflect) !== "undefined") && Reflect.ownKeys)) {
    ownKeysFun = Reflect.ownKeys;
  } else {
    var getOwnPropertySymbols = (Object.getOwnPropertySymbols || ((o) => []));
    ownKeysFun = ((o) => Object.getOwnPropertyNames(o).concat(getOwnPropertySymbols(o)));
  }
  return ((o) => {
    var ownKeys = ownKeysFun(o);
    var descriptors = ({});
    var len = (ownKeys.length | 0);
    var i = 0;
    while ((i !== len)) {
      var key = ownKeys[i];
      Object.defineProperty(descriptors, key, ({
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": Object.getOwnPropertyDescriptor(o, key)
      }));
      i = ((i + 1) | 0);
    }
    return descriptors;
  });
})());
var $L0;
function $Char(c) {
  this.c = c;
}
$Char.prototype.toString = (function() {
  return String.fromCharCode(this.c);
});
function $valueDescription(arg0) {
  return (((typeof arg0) === "number") ? (((arg0 === 0) && ((1 / arg0) < 0)) ? "number(-0)" : (("number(" + arg0) + ")")) : ((arg0 instanceof $c_RTLong) ? "long" : ((arg0 instanceof $Char) ? "char" : ((!(!(arg0 && arg0.$classData))) ? arg0.$classData.name : (typeof arg0)))));
}
function $throwClassCastException(arg0, arg1) {
  throw new $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError($ct_jl_ClassCastException__T__(new $c_jl_ClassCastException(), (($valueDescription(arg0) + " cannot be cast to ") + arg1)));
}
function $throwArrayCastException(arg0, arg1, arg2) {
  while ((--arg2)) {
    arg1 = ("[" + arg1);
  }
  $throwClassCastException(arg0, arg1);
}
function $throwArrayIndexOutOFBoundsException(arg0) {
  throw new $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError($ct_jl_ArrayIndexOutOfBoundsException__T__(new $c_jl_ArrayIndexOutOfBoundsException(), ((arg0 === null) ? null : ("" + arg0))));
}
function $throwArrayStoreException(arg0) {
  throw new $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError(new $c_jl_ArrayStoreException(((arg0 === null) ? null : $valueDescription(arg0))));
}
function $throwNegativeArraySizeException() {
  throw new $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError(new $c_jl_NegativeArraySizeException());
}
function $throwNullPointerException() {
  throw new $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError($ct_jl_NullPointerException__(new $c_jl_NullPointerException()));
}
function $n(arg0) {
  if ((arg0 === null)) {
    $throwNullPointerException();
  }
  return arg0;
}
function $noIsInstance(arg0) {
  throw new TypeError("Cannot call isInstance() on a Class representing a JS trait/object");
}
function $newArrayObject(arg0, arg1) {
  return $newArrayObjectInternal(arg0, arg1, 0);
}
function $newArrayObjectInternal(arg0, arg1, arg2) {
  var result = new arg0.constr(arg1[arg2]);
  if ((arg2 < (arg1.length - 1))) {
    var subArrayClassData = arg0.componentData;
    var subLengthIndex = (arg2 + 1);
    var underlying = result.u;
    for (var i = 0; (i < underlying.length); (i++)) {
      underlying[i] = $newArrayObjectInternal(subArrayClassData, arg1, subLengthIndex);
    }
  }
  return result;
}
function $objectClone(arg0) {
  return Object.create(Object.getPrototypeOf(arg0), $getOwnPropertyDescriptors(arg0));
}
function $objectOrArrayClone(arg0) {
  return (arg0.$classData.isArrayClass ? arg0.clone__O() : $objectClone(arg0));
}
function $objectGetClass(arg0) {
  switch ((typeof arg0)) {
    case "string": {
      return $d_T.getClassOf();
    }
    case "number": {
      if ($isInt(arg0)) {
        if ((((arg0 << 24) >> 24) === arg0)) {
          return $d_jl_Byte.getClassOf();
        } else if ((((arg0 << 16) >> 16) === arg0)) {
          return $d_jl_Short.getClassOf();
        } else {
          return $d_jl_Integer.getClassOf();
        }
      } else if ($isFloat(arg0)) {
        return $d_jl_Float.getClassOf();
      } else {
        return $d_jl_Double.getClassOf();
      }
    }
    case "boolean": {
      return $d_jl_Boolean.getClassOf();
    }
    case "undefined": {
      return $d_jl_Void.getClassOf();
    }
    default: {
      if ((arg0 === null)) {
        $throwNullPointerException();
      } else if ((arg0 instanceof $c_RTLong)) {
        return $d_jl_Long.getClassOf();
      } else if ((arg0 instanceof $Char)) {
        return $d_jl_Character.getClassOf();
      } else if ((!(!(arg0 && arg0.$classData)))) {
        return arg0.$classData.getClassOf();
      } else {
        return null;
      }
    }
  }
}
function $objectClassName(arg0) {
  switch ((typeof arg0)) {
    case "string": {
      return "java.lang.String";
    }
    case "number": {
      if ($isInt(arg0)) {
        if ((((arg0 << 24) >> 24) === arg0)) {
          return "java.lang.Byte";
        } else if ((((arg0 << 16) >> 16) === arg0)) {
          return "java.lang.Short";
        } else {
          return "java.lang.Integer";
        }
      } else if ($isFloat(arg0)) {
        return "java.lang.Float";
      } else {
        return "java.lang.Double";
      }
    }
    case "boolean": {
      return "java.lang.Boolean";
    }
    case "undefined": {
      return "java.lang.Void";
    }
    default: {
      if ((arg0 === null)) {
        $throwNullPointerException();
      } else if ((arg0 instanceof $c_RTLong)) {
        return "java.lang.Long";
      } else if ((arg0 instanceof $Char)) {
        return "java.lang.Character";
      } else if ((!(!(arg0 && arg0.$classData)))) {
        return arg0.$classData.name;
      } else {
        return $throwNullPointerException();
      }
    }
  }
}
function $dp_charAt__I__C(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__charAt__I__C(instance, x0);
  } else {
    return instance.charAt__I__C(x0);
  }
}
function $dp_codePointAt__I__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__codePointAt__I__I(instance, x0);
  } else {
    return instance.codePointAt__I__I(x0);
  }
}
function $dp_compareTo__O__I(instance, x0) {
  switch ((typeof instance)) {
    case "string": {
      return $f_T__compareTo__O__I(instance, x0);
    }
    case "number": {
      return $f_jl_Double__compareTo__O__I(instance, x0);
    }
    case "boolean": {
      return $f_jl_Boolean__compareTo__O__I(instance, x0);
    }
    default: {
      if ((instance instanceof $c_RTLong)) {
        return $f_jl_Long__compareTo__O__I(instance, x0);
      } else if ((instance instanceof $Char)) {
        return $f_jl_Character__compareTo__O__I($uC(instance), x0);
      } else {
        return instance.compareTo__O__I(x0);
      }
    }
  }
}
function $dp_compareTo__T__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__compareTo__T__I(instance, x0);
  } else {
    return instance.compareTo__T__I(x0);
  }
}
function $dp_compareToIgnoreCase__T__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__compareToIgnoreCase__T__I(instance, x0);
  } else {
    return instance.compareToIgnoreCase__T__I(x0);
  }
}
function $dp_endsWith__T__Z(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__endsWith__T__Z(instance, x0);
  } else {
    return instance.endsWith__T__Z(x0);
  }
}
function $dp_equals__O__Z(instance, x0) {
  switch ((typeof instance)) {
    case "string": {
      return $f_T__equals__O__Z(instance, x0);
    }
    case "number": {
      return $f_jl_Double__equals__O__Z(instance, x0);
    }
    case "boolean": {
      return $f_jl_Boolean__equals__O__Z(instance, x0);
    }
    case "undefined": {
      return $f_jl_Void__equals__O__Z(instance, x0);
    }
    default: {
      if (((!(!(instance && instance.$classData))) || (instance === null))) {
        return instance.equals__O__Z(x0);
      } else if ((instance instanceof $c_RTLong)) {
        return $f_jl_Long__equals__O__Z(instance, x0);
      } else if ((instance instanceof $Char)) {
        return $f_jl_Character__equals__O__Z($uC(instance), x0);
      } else {
        return $c_O.prototype.equals__O__Z.call(instance, x0);
      }
    }
  }
}
function $dp_getChars__I__I__AC__I__V(instance, x0, x1, x2, x3) {
  if (((typeof instance) === "string")) {
    return $f_T__getChars__I__I__AC__I__V(instance, x0, x1, x2, x3);
  } else {
    return instance.getChars__I__I__AC__I__V(x0, x1, x2, x3);
  }
}
function $dp_hashCode__I(instance) {
  switch ((typeof instance)) {
    case "string": {
      return $f_T__hashCode__I(instance);
    }
    case "number": {
      return $f_jl_Double__hashCode__I(instance);
    }
    case "boolean": {
      return $f_jl_Boolean__hashCode__I(instance);
    }
    case "undefined": {
      return $f_jl_Void__hashCode__I(instance);
    }
    default: {
      if (((!(!(instance && instance.$classData))) || (instance === null))) {
        return instance.hashCode__I();
      } else if ((instance instanceof $c_RTLong)) {
        return $f_jl_Long__hashCode__I(instance);
      } else if ((instance instanceof $Char)) {
        return $f_jl_Character__hashCode__I($uC(instance));
      } else {
        return $c_O.prototype.hashCode__I.call(instance);
      }
    }
  }
}
function $dp_indexOf__I__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__indexOf__I__I(instance, x0);
  } else {
    return instance.indexOf__I__I(x0);
  }
}
function $dp_lastIndexOf__I__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__lastIndexOf__I__I(instance, x0);
  } else {
    return instance.lastIndexOf__I__I(x0);
  }
}
function $dp_length__I(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__length__I(instance);
  } else {
    return instance.length__I();
  }
}
function $dp_repeat__I__T(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__repeat__I__T(instance, x0);
  } else {
    return instance.repeat__I__T(x0);
  }
}
function $dp_replaceAll__T__T__T(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__replaceAll__T__T__T(instance, x0, x1);
  } else {
    return instance.replaceAll__T__T__T(x0, x1);
  }
}
function $dp_replaceFirst__T__T__T(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__replaceFirst__T__T__T(instance, x0, x1);
  } else {
    return instance.replaceFirst__T__T__T(x0, x1);
  }
}
function $dp_split__T__I__AT(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__split__T__I__AT(instance, x0, x1);
  } else {
    return instance.split__T__I__AT(x0, x1);
  }
}
function $dp_subSequence__I__I__jl_CharSequence(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__subSequence__I__I__jl_CharSequence(instance, x0, x1);
  } else {
    return instance.subSequence__I__I__jl_CharSequence(x0, x1);
  }
}
function $dp_toCharArray__AC(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__toCharArray__AC(instance);
  } else {
    return instance.toCharArray__AC();
  }
}
function $dp_toString__T(instance) {
  return ((instance === (void 0)) ? "undefined" : instance.toString());
}
function $dp_trim__T(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__trim__T(instance);
  } else {
    return instance.trim__T();
  }
}
function $intDiv(arg0, arg1) {
  if ((arg1 === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero");
  } else {
    return ((arg0 / arg1) | 0);
  }
}
function $intMod(arg0, arg1) {
  if ((arg1 === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero");
  } else {
    return ((arg0 % arg1) | 0);
  }
}
function $doubleToInt(arg0) {
  return ((arg0 > 2147483647) ? 2147483647 : ((arg0 < (-2147483648)) ? (-2147483648) : (arg0 | 0)));
}
function $cToS(arg0) {
  return String.fromCharCode(arg0);
}
function $charAt(arg0, arg1) {
  var r = arg0.charCodeAt(arg1);
  if ((r !== r)) {
    throw new $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError($ct_jl_StringIndexOutOfBoundsException__I__(new $c_jl_StringIndexOutOfBoundsException(), arg1));
  } else {
    return r;
  }
}
function $resolveSuperRef(arg0, arg1) {
  var getPrototypeOf = Object.getPrototyeOf;
  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var superProto = arg0.prototype;
  while ((superProto !== null)) {
    var desc = getOwnPropertyDescriptor(superProto, arg1);
    if ((desc !== (void 0))) {
      return desc;
    }
    superProto = getPrototypeOf(superProto);
  }
}
function $superGet(arg0, arg1, arg2) {
  var desc = $resolveSuperRef(arg0, arg2);
  if ((desc !== (void 0))) {
    var getter = desc.get;
    return ((getter !== (void 0)) ? getter.call(arg1) : getter.value);
  }
}
function $superSet(arg0, arg1, arg2, arg3) {
  var desc = $resolveSuperRef(arg0, arg2);
  if ((desc !== (void 0))) {
    var setter = desc.set;
    if ((setter !== (void 0))) {
      setter.call(arg1, arg3);
      return (void 0);
    }
  }
  throw new TypeError((("super has no setter '" + arg2) + "'."));
}
function $arraycopyCheckBounds(arg0, arg1, arg2, arg3, arg4) {
  if ((((((arg1 < 0) || (arg3 < 0)) || (arg4 < 0)) || (arg1 > ((arg0 - arg4) | 0))) || (arg3 > ((arg2 - arg4) | 0)))) {
    $throwArrayIndexOutOFBoundsException(null);
  }
}
function $arraycopyGeneric(arg0, arg1, arg2, arg3, arg4) {
  $arraycopyCheckBounds(arg0.length, arg1, arg2.length, arg3, arg4);
  if ((((arg0 !== arg2) || (arg3 < arg1)) || (((arg1 + arg4) | 0) < arg3))) {
    for (var i = 0; (i < arg4); i = ((i + 1) | 0)) {
      arg2[((arg3 + i) | 0)] = arg0[((arg1 + i) | 0)];
    }
  } else {
    for (var i = ((arg4 - 1) | 0); (i >= 0); i = ((i - 1) | 0)) {
      arg2[((arg3 + i) | 0)] = arg0[((arg1 + i) | 0)];
    }
  }
}
function $systemArraycopy(arg0, arg1, arg2, arg3, arg4) {
  arg0.copyTo(arg1, arg2, arg3, arg4);
}
function $systemArraycopyRefs(arg0, arg1, arg2, arg3, arg4) {
  if (arg2.$classData.isAssignableFrom(arg0.$classData)) {
    $arraycopyGeneric(arg0.u, arg1, arg2.u, arg3, arg4);
  } else {
    var srcArray = arg0.u;
    $arraycopyCheckBounds(srcArray.length, arg1, arg2.u.length, arg3, arg4);
    for (var i = 0; (i < arg4); i = ((i + 1) | 0)) {
      arg2.set(((arg3 + i) | 0), srcArray[((arg1 + i) | 0)]);
    }
  }
}
function $systemArraycopyFull(arg0, arg1, arg2, arg3, arg4) {
  var srcData = (arg0 && arg0.$classData);
  if ((srcData === (arg2 && arg2.$classData))) {
    if ((srcData && srcData.isArrayClass)) {
      $systemArraycopy(arg0, arg1, arg2, arg3, arg4);
    } else {
      $throwArrayStoreException(null);
    }
  } else if (((arg0 instanceof $ac_O) && (arg2 instanceof $ac_O))) {
    $systemArraycopyRefs(arg0, arg1, arg2, arg3, arg4);
  } else {
    $throwArrayStoreException(null);
  }
}
var $lastIDHash = 0;
var $idHashCodeMap = new WeakMap();
function $systemIdentityHashCode(obj) {
  switch ((typeof obj)) {
    case "string": {
      return $f_T__hashCode__I(obj);
    }
    case "number": {
      return $f_jl_Double__hashCode__I(obj);
    }
    case "bigint": {
      var biHash = 0;
      if ((obj < BigInt(0))) {
        obj = (~obj);
      }
      while ((obj !== BigInt(0))) {
        biHash = (biHash ^ Number(BigInt.asIntN(32, obj)));
        obj = (obj >> BigInt(32));
      }
      return biHash;
    }
    case "boolean": {
      return (obj ? 1231 : 1237);
    }
    case "undefined": {
      return 0;
    }
    case "symbol": {
      var description = obj.description;
      return ((description === (void 0)) ? 0 : $f_T__hashCode__I(description));
    }
    default: {
      if ((obj === null)) {
        return 0;
      } else {
        var hash = $idHashCodeMap.get(obj);
        if ((hash === (void 0))) {
          hash = (($lastIDHash + 1) | 0);
          $lastIDHash = hash;
          $idHashCodeMap.set(obj, hash);
        }
        return hash;
      }
    }
  }
}
function $isByte(arg0) {
  return ((((typeof arg0) === "number") && (((arg0 << 24) >> 24) === arg0)) && ((1 / arg0) !== (1 / (-0))));
}
function $isShort(arg0) {
  return ((((typeof arg0) === "number") && (((arg0 << 16) >> 16) === arg0)) && ((1 / arg0) !== (1 / (-0))));
}
function $isInt(arg0) {
  return ((((typeof arg0) === "number") && ((arg0 | 0) === arg0)) && ((1 / arg0) !== (1 / (-0))));
}
function $isFloat(arg0) {
  return (((typeof arg0) === "number") && ((arg0 !== arg0) || (Math.fround(arg0) === arg0)));
}
function $bC(arg0) {
  return new $Char(arg0);
}
var $bC0 = $bC(0);
function $uV(arg0) {
  return (((arg0 === (void 0)) || (arg0 === null)) ? (void 0) : $throwClassCastException(arg0, "java.lang.Void"));
}
function $uZ(arg0) {
  return ((((typeof arg0) === "boolean") || (arg0 === null)) ? (!(!arg0)) : $throwClassCastException(arg0, "java.lang.Boolean"));
}
function $uC(arg0) {
  return (((arg0 instanceof $Char) || (arg0 === null)) ? ((arg0 === null) ? 0 : arg0.c) : $throwClassCastException(arg0, "java.lang.Character"));
}
function $uB(arg0) {
  return (($isByte(arg0) || (arg0 === null)) ? (arg0 | 0) : $throwClassCastException(arg0, "java.lang.Byte"));
}
function $uS(arg0) {
  return (($isShort(arg0) || (arg0 === null)) ? (arg0 | 0) : $throwClassCastException(arg0, "java.lang.Short"));
}
function $uI(arg0) {
  return (($isInt(arg0) || (arg0 === null)) ? (arg0 | 0) : $throwClassCastException(arg0, "java.lang.Integer"));
}
function $uJ(arg0) {
  return (((arg0 instanceof $c_RTLong) || (arg0 === null)) ? ((arg0 === null) ? $L0 : arg0) : $throwClassCastException(arg0, "java.lang.Long"));
}
function $uF(arg0) {
  return (($isFloat(arg0) || (arg0 === null)) ? (+arg0) : $throwClassCastException(arg0, "java.lang.Float"));
}
function $uD(arg0) {
  return ((((typeof arg0) === "number") || (arg0 === null)) ? (+arg0) : $throwClassCastException(arg0, "java.lang.Double"));
}
function $uT(arg0) {
  return ((((typeof arg0) === "string") || (arg0 === null)) ? ((arg0 === null) ? "" : arg0) : $throwClassCastException(arg0, "java.lang.String"));
}
function $ct_O__($thiz) {
  return $thiz;
}
/** @constructor */
function $c_O() {
}
$c_O.prototype.constructor = $c_O;
/** @constructor */
function $h_O() {
}
$h_O.prototype = $c_O.prototype;
$c_O.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this);
});
$c_O.prototype.equals__O__Z = (function(that) {
  return (this === that);
});
$c_O.prototype.toString__T = (function() {
  var i = this.hashCode__I();
  return (($objectClassName(this) + "@") + $as_T($uD((i >>> 0.0)).toString(16)));
});
$c_O.prototype.toString = (function() {
  return this.toString__T();
});
function $ac_O(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException();
    }
    this.u = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.u[i] = null;
    }
  } else {
    this.u = arg;
  }
}
$ac_O.prototype = new $h_O();
$ac_O.prototype.constructor = $ac_O;
$ac_O.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  return this.u[i];
});
$ac_O.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  this.u[i] = v;
});
$ac_O.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyGeneric(this.u, srcPos, dest.u, destPos, length);
});
$ac_O.prototype.clone__O = (function() {
  return new $ac_O(this.u.slice());
});
function $ah_O() {
}
$ah_O.prototype = $ac_O.prototype;
function $ac_Z(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException();
    }
    this.u = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.u[i] = false;
    }
  } else {
    this.u = arg;
  }
}
$ac_Z.prototype = new $h_O();
$ac_Z.prototype.constructor = $ac_Z;
$ac_Z.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  return this.u[i];
});
$ac_Z.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  this.u[i] = v;
});
$ac_Z.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyGeneric(this.u, srcPos, dest.u, destPos, length);
});
$ac_Z.prototype.clone__O = (function() {
  return new $ac_Z(this.u.slice());
});
function $ac_C(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException();
    }
    this.u = new Uint16Array(arg);
  } else {
    this.u = arg;
  }
}
$ac_C.prototype = new $h_O();
$ac_C.prototype.constructor = $ac_C;
$ac_C.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  return this.u[i];
});
$ac_C.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  this.u[i] = v;
});
$ac_C.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$ac_C.prototype.clone__O = (function() {
  return new $ac_C(this.u.slice());
});
function $ac_B(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException();
    }
    this.u = new Int8Array(arg);
  } else {
    this.u = arg;
  }
}
$ac_B.prototype = new $h_O();
$ac_B.prototype.constructor = $ac_B;
$ac_B.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  return this.u[i];
});
$ac_B.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  this.u[i] = v;
});
$ac_B.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$ac_B.prototype.clone__O = (function() {
  return new $ac_B(this.u.slice());
});
function $ac_S(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException();
    }
    this.u = new Int16Array(arg);
  } else {
    this.u = arg;
  }
}
$ac_S.prototype = new $h_O();
$ac_S.prototype.constructor = $ac_S;
$ac_S.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  return this.u[i];
});
$ac_S.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  this.u[i] = v;
});
$ac_S.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$ac_S.prototype.clone__O = (function() {
  return new $ac_S(this.u.slice());
});
function $ac_I(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException();
    }
    this.u = new Int32Array(arg);
  } else {
    this.u = arg;
  }
}
$ac_I.prototype = new $h_O();
$ac_I.prototype.constructor = $ac_I;
$ac_I.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  return this.u[i];
});
$ac_I.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  this.u[i] = v;
});
$ac_I.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$ac_I.prototype.clone__O = (function() {
  return new $ac_I(this.u.slice());
});
function $ac_J(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException();
    }
    this.u = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.u[i] = $L0;
    }
  } else {
    this.u = arg;
  }
}
$ac_J.prototype = new $h_O();
$ac_J.prototype.constructor = $ac_J;
$ac_J.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  return this.u[i];
});
$ac_J.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  this.u[i] = v;
});
$ac_J.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyGeneric(this.u, srcPos, dest.u, destPos, length);
});
$ac_J.prototype.clone__O = (function() {
  return new $ac_J(this.u.slice());
});
function $ac_F(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException();
    }
    this.u = new Float32Array(arg);
  } else {
    this.u = arg;
  }
}
$ac_F.prototype = new $h_O();
$ac_F.prototype.constructor = $ac_F;
$ac_F.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  return this.u[i];
});
$ac_F.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  this.u[i] = v;
});
$ac_F.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$ac_F.prototype.clone__O = (function() {
  return new $ac_F(this.u.slice());
});
function $ac_D(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException();
    }
    this.u = new Float64Array(arg);
  } else {
    this.u = arg;
  }
}
$ac_D.prototype = new $h_O();
$ac_D.prototype.constructor = $ac_D;
$ac_D.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  return this.u[i];
});
$ac_D.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  this.u[i] = v;
});
$ac_D.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$ac_D.prototype.clone__O = (function() {
  return new $ac_D(this.u.slice());
});
function $TypeData() {
  this.constr = (void 0);
  this.ancestors = null;
  this.componentData = null;
  this.arrayBase = null;
  this.arrayDepth = 0;
  this.zero = null;
  this.arrayEncodedName = "";
  this._classOf = (void 0);
  this._arrayOf = (void 0);
  this.isAssignableFromFun = (void 0);
  this.wrapArray = (void 0);
  this.isJSType = false;
  this.name = "";
  this.isPrimitive = false;
  this.isInterface = false;
  this.isArrayClass = false;
  this.isInstance = (void 0);
}
$TypeData.prototype.initPrim = (function(zero, arrayEncodedName, displayName, arrayClass, typedArrayClass) {
  this.ancestors = ({});
  this.zero = zero;
  this.arrayEncodedName = arrayEncodedName;
  var self = this;
  this.isAssignableFromFun = ((that) => (that === self));
  this.name = displayName;
  this.isPrimitive = true;
  this.isInstance = ((obj) => false);
  if ((arrayClass !== (void 0))) {
    this._arrayOf = new $TypeData().initSpecializedArray(this, arrayClass, typedArrayClass);
  }
  return this;
});
$TypeData.prototype.initClass = (function(kindOrCtor, fullName, ancestors, isInstance) {
  var internalName = Object.getOwnPropertyNames(ancestors)[0];
  this.ancestors = ancestors;
  this.arrayEncodedName = (("L" + fullName) + ";");
  this.isAssignableFromFun = ((that) => (!(!that.ancestors[internalName])));
  this.isJSType = (kindOrCtor === 2);
  this.name = fullName;
  this.isInterface = (kindOrCtor === 1);
  this.isInstance = (isInstance || ((obj) => (!(!((obj && obj.$classData) && obj.$classData.ancestors[internalName])))));
  if (((typeof kindOrCtor) !== "number")) {
    kindOrCtor.prototype.$classData = this;
  }
  return this;
});
$TypeData.prototype.initSpecializedArray = (function(componentData, arrayClass, typedArrayClass, isAssignableFromFun) {
  arrayClass.prototype.$classData = this;
  var name = ("[" + componentData.arrayEncodedName);
  this.constr = arrayClass;
  this.ancestors = ({
    jl_Cloneable: 1,
    Ljava_io_Serializable: 1
  });
  this.componentData = componentData;
  this.arrayBase = componentData;
  this.arrayDepth = 1;
  this.arrayEncodedName = name;
  this.name = name;
  this.isArrayClass = true;
  var self = this;
  this.isAssignableFromFun = (isAssignableFromFun || ((that) => (self === that)));
  this.wrapArray = (typedArrayClass ? ((array) => new arrayClass(new typedArrayClass(array))) : ((array) => new arrayClass(array)));
  this.isInstance = ((obj) => (obj instanceof arrayClass));
  return this;
});
$TypeData.prototype.initArray = (function(componentData) {
  function ArrayClass(arg) {
    if (((typeof arg) === "number")) {
      if ((arg < 0)) {
        $throwNegativeArraySizeException();
      }
      this.u = new Array(arg);
      for (var i = 0; (i < arg); (i++)) {
        this.u[i] = null;
      }
    } else {
      this.u = arg;
    }
  }
  ArrayClass.prototype = new $ah_O();
  ArrayClass.prototype.constructor = ArrayClass;
  ArrayClass.prototype.set = (function(i, v) {
    if (((i < 0) || (i >= this.u.length))) {
      $throwArrayIndexOutOFBoundsException(i);
    }
    if ((((v !== null) && (!componentData.isJSType)) && (!componentData.isInstance(v)))) {
      $throwArrayStoreException(v);
    }
    this.u[i] = v;
  });
  ArrayClass.prototype.copyTo = (function(srcPos, dest, destPos, length) {
    $arraycopyGeneric(this.u, srcPos, dest.u, destPos, length);
  });
  ArrayClass.prototype.clone__O = (function() {
    return new ArrayClass(this.u.slice());
  });
  ArrayClass.prototype.$classData = this;
  var arrayBase = (componentData.arrayBase || componentData);
  var arrayDepth = (componentData.arrayDepth + 1);
  var name = ("[" + componentData.arrayEncodedName);
  this.constr = ArrayClass;
  this.ancestors = ({
    jl_Cloneable: 1,
    Ljava_io_Serializable: 1
  });
  this.componentData = componentData;
  this.arrayBase = arrayBase;
  this.arrayDepth = arrayDepth;
  this.arrayEncodedName = name;
  this.name = name;
  this.isArrayClass = true;
  var isAssignableFromFun = ((that) => {
    var thatDepth = that.arrayDepth;
    return ((thatDepth === arrayDepth) ? arrayBase.isAssignableFromFun(that.arrayBase) : ((thatDepth > arrayDepth) && (arrayBase === $d_O)));
  });
  this.isAssignableFromFun = isAssignableFromFun;
  this.wrapArray = ((array) => new ArrayClass(array));
  var self = this;
  this.isInstance = ((obj) => {
    var data = (obj && obj.$classData);
    return ((!(!data)) && ((data === self) || isAssignableFromFun(data)));
  });
  return this;
});
$TypeData.prototype.getArrayOf = (function() {
  if ((!this._arrayOf)) {
    this._arrayOf = new $TypeData().initArray(this);
  }
  return this._arrayOf;
});
$TypeData.prototype.getClassOf = (function() {
  if ((!this._classOf)) {
    this._classOf = new $c_jl_Class(this);
  }
  return this._classOf;
});
$TypeData.prototype.isAssignableFrom = (function(that) {
  return ((this === that) || this.isAssignableFromFun(that));
});
$TypeData.prototype.checkCast = (function(obj) {
  if ((((obj !== null) && (!this.isJSType)) && (!this.isInstance(obj)))) {
    $throwClassCastException(obj, this.name);
  }
});
$TypeData.prototype.getSuperclass = (function() {
  return (this.parentData ? this.parentData.getClassOf() : null);
});
$TypeData.prototype.getComponentType = (function() {
  return (this.componentData ? this.componentData.getClassOf() : null);
});
$TypeData.prototype.newArrayOfThisClass = (function(lengths) {
  var arrayClassData = this;
  for (var i = 0; (i < lengths.length); (i++)) {
    arrayClassData = arrayClassData.getArrayOf();
  }
  return $newArrayObject(arrayClassData, lengths);
});
function $isArrayOf_O(obj, depth) {
  var data = (obj && obj.$classData);
  if ((!data)) {
    return false;
  } else {
    var arrayDepth = data.arrayDepth;
    return ((arrayDepth === depth) ? (!data.arrayBase.isPrimitive) : (arrayDepth > depth));
  }
}
function $isArrayOf_Z(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_Z))));
}
function $isArrayOf_C(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_C))));
}
function $isArrayOf_B(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_B))));
}
function $isArrayOf_S(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_S))));
}
function $isArrayOf_I(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_I))));
}
function $isArrayOf_J(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_J))));
}
function $isArrayOf_F(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_F))));
}
function $isArrayOf_D(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_D))));
}
function $asArrayOf_O(obj, depth) {
  if (($isArrayOf_O(obj, depth) || (obj === null))) {
    return obj;
  } else {
    $throwArrayCastException(obj, "Ljava.lang.Object;", depth);
  }
}
function $asArrayOf_Z(obj, depth) {
  if (($isArrayOf_Z(obj, depth) || (obj === null))) {
    return obj;
  } else {
    $throwArrayCastException(obj, "Z", depth);
  }
}
function $asArrayOf_C(obj, depth) {
  if (($isArrayOf_C(obj, depth) || (obj === null))) {
    return obj;
  } else {
    $throwArrayCastException(obj, "C", depth);
  }
}
function $asArrayOf_B(obj, depth) {
  if (($isArrayOf_B(obj, depth) || (obj === null))) {
    return obj;
  } else {
    $throwArrayCastException(obj, "B", depth);
  }
}
function $asArrayOf_S(obj, depth) {
  if (($isArrayOf_S(obj, depth) || (obj === null))) {
    return obj;
  } else {
    $throwArrayCastException(obj, "S", depth);
  }
}
function $asArrayOf_I(obj, depth) {
  if (($isArrayOf_I(obj, depth) || (obj === null))) {
    return obj;
  } else {
    $throwArrayCastException(obj, "I", depth);
  }
}
function $asArrayOf_J(obj, depth) {
  if (($isArrayOf_J(obj, depth) || (obj === null))) {
    return obj;
  } else {
    $throwArrayCastException(obj, "J", depth);
  }
}
function $asArrayOf_F(obj, depth) {
  if (($isArrayOf_F(obj, depth) || (obj === null))) {
    return obj;
  } else {
    $throwArrayCastException(obj, "F", depth);
  }
}
function $asArrayOf_D(obj, depth) {
  if (($isArrayOf_D(obj, depth) || (obj === null))) {
    return obj;
  } else {
    $throwArrayCastException(obj, "D", depth);
  }
}
var $d_O = new $TypeData();
$d_O.ancestors = ({});
$d_O.arrayEncodedName = "Ljava.lang.Object;";
$d_O.isAssignableFromFun = ((that) => (!that.isPrimitive));
$d_O.name = "java.lang.Object";
$d_O.isInstance = ((obj) => (obj !== null));
$d_O._arrayOf = new $TypeData().initSpecializedArray($d_O, $ac_O, (void 0), ((that) => {
  var thatDepth = that.arrayDepth;
  return ((thatDepth === 1) ? (!that.arrayBase.isPrimitive) : (thatDepth > 1));
}));
$c_O.prototype.$classData = $d_O;
var $d_V = new $TypeData().initPrim((void 0), "V", "void", (void 0), (void 0));
var $d_Z = new $TypeData().initPrim(false, "Z", "boolean", $ac_Z, (void 0));
var $d_C = new $TypeData().initPrim(0, "C", "char", $ac_C, Uint16Array);
var $d_B = new $TypeData().initPrim(0, "B", "byte", $ac_B, Int8Array);
var $d_S = new $TypeData().initPrim(0, "S", "short", $ac_S, Int16Array);
var $d_I = new $TypeData().initPrim(0, "I", "int", $ac_I, Int32Array);
var $d_J = new $TypeData().initPrim(null, "J", "long", $ac_J, (void 0));
var $d_F = new $TypeData().initPrim(0.0, "F", "float", $ac_F, Float32Array);
var $d_D = new $TypeData().initPrim(0.0, "D", "double", $ac_D, Float64Array);
/** @constructor */
function $c_Lcats_Eval$FnStack() {
}
$c_Lcats_Eval$FnStack.prototype = new $h_O();
$c_Lcats_Eval$FnStack.prototype.constructor = $c_Lcats_Eval$FnStack;
/** @constructor */
function $h_Lcats_Eval$FnStack() {
}
$h_Lcats_Eval$FnStack.prototype = $c_Lcats_Eval$FnStack.prototype;
/** @constructor */
function $c_Lcats_EvalInstances1() {
}
$c_Lcats_EvalInstances1.prototype = new $h_O();
$c_Lcats_EvalInstances1.prototype.constructor = $c_Lcats_EvalInstances1;
/** @constructor */
function $h_Lcats_EvalInstances1() {
}
$h_Lcats_EvalInstances1.prototype = $c_Lcats_EvalInstances1.prototype;
function $f_Lcats_FlatMapArityFunctions__flatMap2__O__O__F2__O($thiz, f0, f1, f) {
  return $n($as_Lcats_FlatMap($thiz)).flatten__O__O($n($as_Lcats_FlatMap($thiz)).map2__O__O__F2__O(f0, f1, f));
}
function $f_Lcats_FlatMapArityFunctions__flatMap4__O__O__O__O__F4__O($thiz, f0, f1, f2, f3, f) {
  var $x_1 = $n($as_Lcats_FlatMap($thiz));
  var this$1 = $n($as_Lcats_FlatMap($thiz));
  var this$2 = $m_Lcats_Semigroupal$();
  return $n($x_1).flatten__O__O($f_Lcats_SemigroupalArityFunctions__map4__O__O__O__O__F4__Lcats_Semigroupal__Lcats_Functor__O(this$2, f0, f1, f2, f3, f, this$1, this$1));
}
function $p_Lcats_Foldable$__loop$3__F2__Lcats_Eval__sc_Iterator__Lcats_Eval($thiz, f$19, lb$2, it) {
  var this$2 = $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0((() => ($n(it).hasNext__Z() ? $as_Lcats_Eval($n(f$19).apply__O__O__O($n(it).next__O(), $p_Lcats_Foldable$__loop$3__F2__Lcats_Eval__sc_Iterator__Lcats_Eval($thiz, f$19, lb$2, it))) : lb$2)));
  return new $c_Lcats_Eval$$anon$5(a, this$2);
}
/** @constructor */
function $c_Lcats_Foldable$() {
}
$c_Lcats_Foldable$.prototype = new $h_O();
$c_Lcats_Foldable$.prototype.constructor = $c_Lcats_Foldable$;
/** @constructor */
function $h_Lcats_Foldable$() {
}
$h_Lcats_Foldable$.prototype = $c_Lcats_Foldable$.prototype;
$c_Lcats_Foldable$.prototype.iterateRight__sc_Iterable__Lcats_Eval__F2__Lcats_Eval = (function(iterable, lb, f) {
  $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0((() => $n(iterable).iterator__sc_Iterator()));
  return new $c_Lcats_Always(a).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((it) => {
    var it$1 = $as_sc_Iterator(it);
    return $p_Lcats_Foldable$__loop$3__F2__Lcats_Eval__sc_Iterator__Lcats_Eval(this, f, lb, it$1);
  })));
});
var $d_Lcats_Foldable$ = new $TypeData().initClass($c_Lcats_Foldable$, "cats.Foldable$", ({
  Lcats_Foldable$: 1
}));
var $n_Lcats_Foldable$;
function $m_Lcats_Foldable$() {
  if ((!$n_Lcats_Foldable$)) {
    $n_Lcats_Foldable$ = new $c_Lcats_Foldable$();
  }
  return $n_Lcats_Foldable$;
}
/** @constructor */
function $c_Lcats_Foldable$Source() {
}
$c_Lcats_Foldable$Source.prototype = new $h_O();
$c_Lcats_Foldable$Source.prototype.constructor = $c_Lcats_Foldable$Source;
/** @constructor */
function $h_Lcats_Foldable$Source() {
}
$h_Lcats_Foldable$Source.prototype = $c_Lcats_Foldable$Source.prototype;
function $as_Lcats_Foldable$Source(obj) {
  return (((obj instanceof $c_Lcats_Foldable$Source) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Foldable$Source"));
}
function $isArrayOf_Lcats_Foldable$Source(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Foldable$Source)));
}
function $asArrayOf_Lcats_Foldable$Source(obj, depth) {
  return (($isArrayOf_Lcats_Foldable$Source(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Foldable$Source;", depth));
}
/** @constructor */
function $c_Lcats_Foldable$Source$() {
  this.Lcats_Foldable$Source$__f_Empty = null;
  $n_Lcats_Foldable$Source$ = this;
  this.Lcats_Foldable$Source$__f_Empty = new $c_Lcats_Foldable$Source$$anon$3();
}
$c_Lcats_Foldable$Source$.prototype = new $h_O();
$c_Lcats_Foldable$Source$.prototype.constructor = $c_Lcats_Foldable$Source$;
/** @constructor */
function $h_Lcats_Foldable$Source$() {
}
$h_Lcats_Foldable$Source$.prototype = $c_Lcats_Foldable$Source$.prototype;
$c_Lcats_Foldable$Source$.prototype.fromFoldable__O__Lcats_Foldable__Lcats_Foldable$Source = (function(fa, F) {
  var value = this.Lcats_Foldable$Source$__f_Empty;
  return $as_Lcats_Foldable$Source($n($n(F).foldRight__O__Lcats_Eval__F2__Lcats_Eval(fa, new $c_Lcats_Now(value), new $c_sjsr_AnonFunction2(((a, evalSrc) => {
    var evalSrc$1 = $as_Lcats_Eval(evalSrc);
    var a$1 = new $c_sjsr_AnonFunction0((() => new $c_Lcats_Foldable$Source$$anon$4(a, evalSrc$1, this)));
    return new $c_Lcats_Later(a$1);
  })))).value__O());
});
var $d_Lcats_Foldable$Source$ = new $TypeData().initClass($c_Lcats_Foldable$Source$, "cats.Foldable$Source$", ({
  Lcats_Foldable$Source$: 1
}));
var $n_Lcats_Foldable$Source$;
function $m_Lcats_Foldable$Source$() {
  if ((!$n_Lcats_Foldable$Source$)) {
    $n_Lcats_Foldable$Source$ = new $c_Lcats_Foldable$Source$();
  }
  return $n_Lcats_Foldable$Source$;
}
function $f_Lcats_SemigroupalArityFunctions__map2__O__O__F2__Lcats_Semigroupal__Lcats_Functor__O($thiz, f0, f1, f, semigroupal, functor) {
  return $n(functor).map__O__F1__O($n(semigroupal).product__O__O__O(f0, f1), new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var a0 = $n(x$1$1)._1__O();
      var a1 = $n(x$1$1)._2__O();
      return $n(f).apply__O__O__O(a0, a1);
    }
    throw new $c_s_MatchError(x$1$1);
  })));
}
function $f_Lcats_SemigroupalArityFunctions__imap2__O__O__F2__F1__Lcats_Semigroupal__Lcats_Invariant__O($thiz, f0, f1, f, g, semigroupal, invariant) {
  return $n(invariant).imap__O__F1__F1__O($n(semigroupal).product__O__O__O(f0, f1), new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var a0 = $n(x$1$1)._1__O();
      var a1 = $n(x$1$1)._2__O();
      return $n(f).apply__O__O__O(a0, a1);
    }
    throw new $c_s_MatchError(x$1$1);
  })), new $c_sjsr_AnonFunction1(((z) => {
    matchResult4: {
      var \u03b42$___1;
      var \u03b42$___2;
      var x10 = $as_T2($n(g).apply__O__O(z));
      if ((x10 !== null)) {
        var a0$1 = $n(x10)._1__O();
        var a1$1 = $n(x10)._2__O();
        var \u03b42$___1 = a0$1;
        var \u03b42$___2 = a1$1;
        break matchResult4;
      }
      throw new $c_s_MatchError(x10);
    }
    var a0$2 = \u03b42$___1;
    var a1$2 = \u03b42$___2;
    return new $c_T2(a0$2, a1$2);
  })));
}
function $f_Lcats_SemigroupalArityFunctions__tuple2__O__O__Lcats_Semigroupal__Lcats_Invariant__O($thiz, f0, f1, semigroupal, invariant) {
  var f = new $c_sjsr_AnonFunction2(((_$5, _$6) => new $c_T2(_$5, _$6)));
  var g = new $c_sjsr_AnonFunction1(((x) => {
    var x$1 = $as_T2(x);
    return x$1;
  }));
  return $f_Lcats_SemigroupalArityFunctions__imap2__O__O__F2__F1__Lcats_Semigroupal__Lcats_Invariant__O($thiz, f0, f1, f, g, semigroupal, invariant);
}
function $f_Lcats_SemigroupalArityFunctions__map3__O__O__O__F3__Lcats_Semigroupal__Lcats_Functor__O($thiz, f0, f1, f2, f, semigroupal, functor) {
  return $n(functor).map__O__F1__O($n(semigroupal).product__O__O__O(f0, $n(semigroupal).product__O__O__O(f1, f2)), new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var x18 = $as_T2($n(x$1$1)._2__O());
      var a0 = $n(x$1$1)._1__O();
      if ((x18 !== null)) {
        var a1 = $n(x18)._1__O();
        var a2 = $n(x18)._2__O();
        return $n(f).apply__O__O__O__O(a0, a1, a2);
      }
    }
    throw new $c_s_MatchError(x$1$1);
  })));
}
function $f_Lcats_SemigroupalArityFunctions__map4__O__O__O__O__F4__Lcats_Semigroupal__Lcats_Functor__O($thiz, f0, f1, f2, f3, f, semigroupal, functor) {
  return $n(functor).map__O__F1__O($n(semigroupal).product__O__O__O(f0, $n(semigroupal).product__O__O__O(f1, $n(semigroupal).product__O__O__O(f2, f3))), new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var x41 = $as_T2($n(x$1$1)._2__O());
      var a0 = $n(x$1$1)._1__O();
      if ((x41 !== null)) {
        var x43 = $as_T2($n(x41)._2__O());
        var a1 = $n(x41)._1__O();
        if ((x43 !== null)) {
          var a2 = $n(x43)._1__O();
          var a3 = $n(x43)._2__O();
          return $n(f).apply__O__O__O__O__O(a0, a1, a2, a3);
        }
      }
    }
    throw new $c_s_MatchError(x$1$1);
  })));
}
function $f_Lcats_SemigroupalArityFunctions__map5__O__O__O__O__O__F5__Lcats_Semigroupal__Lcats_Functor__O($thiz, f0, f1, f2, f3, f4, f, semigroupal, functor) {
  return $n(functor).map__O__F1__O($n(semigroupal).product__O__O__O(f0, $n(semigroupal).product__O__O__O(f1, $n(semigroupal).product__O__O__O(f2, $n(semigroupal).product__O__O__O(f3, f4)))), new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var x72 = $as_T2($n(x$1$1)._2__O());
      var a0 = $n(x$1$1)._1__O();
      if ((x72 !== null)) {
        var x74 = $as_T2($n(x72)._2__O());
        var a1 = $n(x72)._1__O();
        if ((x74 !== null)) {
          var x76 = $as_T2($n(x74)._2__O());
          var a2 = $n(x74)._1__O();
          if ((x76 !== null)) {
            var a3 = $n(x76)._1__O();
            var a4 = $n(x76)._2__O();
            return $n(f).apply__O__O__O__O__O__O(a0, a1, a2, a3, a4);
          }
        }
      }
    }
    throw new $c_s_MatchError(x$1$1);
  })));
}
function $f_Lcats_SemigroupalArityFunctions__map6__O__O__O__O__O__O__F6__Lcats_Semigroupal__Lcats_Functor__O($thiz, f0, f1, f2, f3, f4, f5, f, semigroupal, functor) {
  return $n(functor).map__O__F1__O($n(semigroupal).product__O__O__O(f0, $n(semigroupal).product__O__O__O(f1, $n(semigroupal).product__O__O__O(f2, $n(semigroupal).product__O__O__O(f3, $n(semigroupal).product__O__O__O(f4, f5))))), new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var x111 = $as_T2($n(x$1$1)._2__O());
      var a0 = $n(x$1$1)._1__O();
      if ((x111 !== null)) {
        var x113 = $as_T2($n(x111)._2__O());
        var a1 = $n(x111)._1__O();
        if ((x113 !== null)) {
          var x115 = $as_T2($n(x113)._2__O());
          var a2 = $n(x113)._1__O();
          if ((x115 !== null)) {
            var x117 = $as_T2($n(x115)._2__O());
            var a3 = $n(x115)._1__O();
            if ((x117 !== null)) {
              var a4 = $n(x117)._1__O();
              var a5 = $n(x117)._2__O();
              return $n(f).apply__O__O__O__O__O__O__O(a0, a1, a2, a3, a4, a5);
            }
          }
        }
      }
    }
    throw new $c_s_MatchError(x$1$1);
  })));
}
function $f_Lcats_SemigroupalArityFunctions__map7__O__O__O__O__O__O__O__F7__Lcats_Semigroupal__Lcats_Functor__O($thiz, f0, f1, f2, f3, f4, f5, f6, f, semigroupal, functor) {
  return $n(functor).map__O__F1__O($n(semigroupal).product__O__O__O(f0, $n(semigroupal).product__O__O__O(f1, $n(semigroupal).product__O__O__O(f2, $n(semigroupal).product__O__O__O(f3, $n(semigroupal).product__O__O__O(f4, $n(semigroupal).product__O__O__O(f5, f6)))))), new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var x158 = $as_T2($n(x$1$1)._2__O());
      var a0 = $n(x$1$1)._1__O();
      if ((x158 !== null)) {
        var x160 = $as_T2($n(x158)._2__O());
        var a1 = $n(x158)._1__O();
        if ((x160 !== null)) {
          var x162 = $as_T2($n(x160)._2__O());
          var a2 = $n(x160)._1__O();
          if ((x162 !== null)) {
            var x164 = $as_T2($n(x162)._2__O());
            var a3 = $n(x162)._1__O();
            if ((x164 !== null)) {
              var x166 = $as_T2($n(x164)._2__O());
              var a4 = $n(x164)._1__O();
              if ((x166 !== null)) {
                var a5 = $n(x166)._1__O();
                var a6 = $n(x166)._2__O();
                return $n(f).apply__O__O__O__O__O__O__O__O(a0, a1, a2, a3, a4, a5, a6);
              }
            }
          }
        }
      }
    }
    throw new $c_s_MatchError(x$1$1);
  })));
}
/** @constructor */
function $c_Lcats_Traverse$() {
}
$c_Lcats_Traverse$.prototype = new $h_O();
$c_Lcats_Traverse$.prototype.constructor = $c_Lcats_Traverse$;
/** @constructor */
function $h_Lcats_Traverse$() {
}
$h_Lcats_Traverse$.prototype = $c_Lcats_Traverse$.prototype;
$c_Lcats_Traverse$.prototype.traverseDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O = (function(fa, f, G) {
  var this$7 = $n($n(fa).iterator__sc_Iterator());
  var $x_1 = $n(G);
  var this$1 = $m_Lcats_data_Chain$();
  var z = $n($x_1).pure__O__O(this$1.Lcats_data_Chain$__f_nil);
  var f$2 = ((x$1, x$2) => {
    var this$6 = $n(G);
    var fb = $n(f).apply__O__O(x$2);
    var f$1 = new $c_sjsr_AnonFunction2(((x$1$2, x$2$2) => {
      var x$1$1 = $as_Lcats_data_Chain(x$1$2);
      var this$5 = $n(x$1$1);
      return this$5.append__O__Lcats_data_Chain(x$2$2);
    }));
    return $f_Lcats_FlatMap__map2__O__O__F2__O(this$6, x$1, fb, f$1);
  });
  if ($is_sc_IndexedSeq(this$7)) {
    var x2 = $as_sc_IndexedSeq(this$7);
    var at = 0;
    var end = $n(x2).length__I();
    var acc = z;
    while (true) {
      if ((at === end)) {
        return acc;
      } else {
        var temp$at = ((1 + at) | 0);
        var arg1 = acc;
        var arg2 = $n(x2).apply__I__O(at);
        var temp$acc = f$2(arg1, arg2);
        at = temp$at;
        acc = temp$acc;
      }
    }
  } else {
    var result = z;
    while (this$7.hasNext__Z()) {
      var arg1$1 = result;
      var arg2$1 = this$7.next__O();
      result = f$2(arg1$1, arg2$1);
    }
    return result;
  }
});
$c_Lcats_Traverse$.prototype.traverse_Directly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O = (function(fa, f, G) {
  var iter = $n(fa).iterator__sc_Iterator();
  if ($n(iter).hasNext__Z()) {
    var first = $n(iter).next__O();
    var $x_2 = $n(G);
    var this$3 = $n(iter);
    var z = $n(f).apply__O__O(first);
    var f$1 = ((x$1, x$2) => $n(G).productR__O__O__O(x$1, $n(f).apply__O__O(x$2)));
    if ($is_sc_IndexedSeq(this$3)) {
      var x2 = $as_sc_IndexedSeq(this$3);
      var at = 0;
      var end = $n(x2).length__I();
      var acc = z;
      var $x_1;
      while (true) {
        if ((at !== end)) {
          var temp$at = ((1 + at) | 0);
          var arg1 = acc;
          var arg2 = $n(x2).apply__I__O(at);
          var temp$acc = f$1(arg1, arg2);
          at = temp$at;
          acc = temp$acc;
          continue;
        }
        var $x_1 = acc;
        break;
      }
    } else {
      var result = z;
      while (this$3.hasNext__Z()) {
        var arg1$1 = result;
        var arg2$1 = this$3.next__O();
        result = f$1(arg1$1, arg2$1);
      }
      var $x_1 = result;
    }
    return $n($x_2).void__O__O($x_1);
  } else {
    return $n(G).unit__O();
  }
});
var $d_Lcats_Traverse$ = new $TypeData().initClass($c_Lcats_Traverse$, "cats.Traverse$", ({
  Lcats_Traverse$: 1
}));
var $n_Lcats_Traverse$;
function $m_Lcats_Traverse$() {
  if ((!$n_Lcats_Traverse$)) {
    $n_Lcats_Traverse$ = new $c_Lcats_Traverse$();
  }
  return $n_Lcats_Traverse$;
}
/** @constructor */
function $c_Lcats_compat_FoldableCompat$() {
}
$c_Lcats_compat_FoldableCompat$.prototype = new $h_O();
$c_Lcats_compat_FoldableCompat$.prototype.constructor = $c_Lcats_compat_FoldableCompat$;
/** @constructor */
function $h_Lcats_compat_FoldableCompat$() {
}
$h_Lcats_compat_FoldableCompat$.prototype = $c_Lcats_compat_FoldableCompat$.prototype;
$c_Lcats_compat_FoldableCompat$.prototype.toIterable__O__Lcats_Foldable__sc_Iterable = (function(fa, F) {
  $m_Lcats_Eval$();
  var a = $m_sci_LazyList$().sci_LazyList$__f__empty;
  return $as_sc_Iterable($n($n(F).foldRight__O__Lcats_Eval__F2__Lcats_Eval(fa, new $c_Lcats_Now(a), new $c_sjsr_AnonFunction2(((a$1, eb) => {
    var eb$1 = $as_Lcats_Eval(eb);
    return $n(eb$1).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((_$2) => {
      var _$2$1 = $as_sci_LazyList(_$2);
      $m_sci_LazyList$();
      return $m_sci_LazyList$cons$().apply__F0__F0__sci_LazyList(new $c_sjsr_AnonFunction0((() => a$1)), new $c_sjsr_AnonFunction0((() => _$2$1)));
    })));
  })))).value__O());
});
var $d_Lcats_compat_FoldableCompat$ = new $TypeData().initClass($c_Lcats_compat_FoldableCompat$, "cats.compat.FoldableCompat$", ({
  Lcats_compat_FoldableCompat$: 1
}));
var $n_Lcats_compat_FoldableCompat$;
function $m_Lcats_compat_FoldableCompat$() {
  if ((!$n_Lcats_compat_FoldableCompat$)) {
    $n_Lcats_compat_FoldableCompat$ = new $c_Lcats_compat_FoldableCompat$();
  }
  return $n_Lcats_compat_FoldableCompat$;
}
/** @constructor */
function $c_Lcats_data_AndThenInstances1() {
}
$c_Lcats_data_AndThenInstances1.prototype = new $h_O();
$c_Lcats_data_AndThenInstances1.prototype.constructor = $c_Lcats_data_AndThenInstances1;
/** @constructor */
function $h_Lcats_data_AndThenInstances1() {
}
$h_Lcats_data_AndThenInstances1.prototype = $c_Lcats_data_AndThenInstances1.prototype;
function $f_Lcats_data_ChainCompanionCompat__fromSeq__sci_Seq__Lcats_data_Chain($thiz, s) {
  if ($n(s).isEmpty__Z()) {
    return $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil;
  } else if (($n(s).lengthCompare__I__I(1) === 0)) {
    $m_Lcats_data_Chain$();
    var a = $n(s).head__O();
    return new $c_Lcats_data_Chain$Singleton(a);
  } else {
    return new $c_Lcats_data_Chain$Wrap(s);
  }
}
/** @constructor */
function $c_Lcats_data_ChainInstances3() {
}
$c_Lcats_data_ChainInstances3.prototype = new $h_O();
$c_Lcats_data_ChainInstances3.prototype.constructor = $c_Lcats_data_ChainInstances3;
/** @constructor */
function $h_Lcats_data_ChainInstances3() {
}
$h_Lcats_data_ChainInstances3.prototype = $c_Lcats_data_ChainInstances3.prototype;
function $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli($thiz, x) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_Lcats_data_StrictConstFunction1(x);
  return new $c_Lcats_data_Kleisli(run);
}
function $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli($thiz, x, F) {
  var x$1 = $n(F).pure__O__O(x);
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli($thiz, x$1);
}
/** @constructor */
function $c_Lcats_data_KleisliInstances9() {
}
$c_Lcats_data_KleisliInstances9.prototype = new $h_O();
$c_Lcats_data_KleisliInstances9.prototype.constructor = $c_Lcats_data_KleisliInstances9;
/** @constructor */
function $h_Lcats_data_KleisliInstances9() {
}
$h_Lcats_data_KleisliInstances9.prototype = $c_Lcats_data_KleisliInstances9.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyChainInstances3() {
}
$c_Lcats_data_NonEmptyChainInstances3.prototype = new $h_O();
$c_Lcats_data_NonEmptyChainInstances3.prototype.constructor = $c_Lcats_data_NonEmptyChainInstances3;
/** @constructor */
function $h_Lcats_data_NonEmptyChainInstances3() {
}
$h_Lcats_data_NonEmptyChainInstances3.prototype = $c_Lcats_data_NonEmptyChainInstances3.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyChainOps$() {
}
$c_Lcats_data_NonEmptyChainOps$.prototype = new $h_O();
$c_Lcats_data_NonEmptyChainOps$.prototype.constructor = $c_Lcats_data_NonEmptyChainOps$;
/** @constructor */
function $h_Lcats_data_NonEmptyChainOps$() {
}
$h_Lcats_data_NonEmptyChainOps$.prototype = $c_Lcats_data_NonEmptyChainOps$.prototype;
$c_Lcats_data_NonEmptyChainOps$.prototype.uncons$extension__O__T2 = (function(this$) {
  return $as_T2($n($n(($m_Lcats_data_NonEmptyChainImpl$(), $as_Lcats_data_Chain(this$))).uncons__s_Option()).get__O());
});
$c_Lcats_data_NonEmptyChainOps$.prototype.initLast$extension__O__T2 = (function(this$) {
  return $as_T2($n($n(($m_Lcats_data_NonEmptyChainImpl$(), $as_Lcats_data_Chain(this$))).initLast__s_Option()).get__O());
});
$c_Lcats_data_NonEmptyChainOps$.prototype.head$extension__O__O = (function(this$) {
  return $n(this.uncons$extension__O__T2(this$))._1__O();
});
$c_Lcats_data_NonEmptyChainOps$.prototype.init$extension__O__Lcats_data_Chain = (function(this$) {
  return $as_Lcats_data_Chain($n(this.initLast$extension__O__T2(this$))._1__O());
});
$c_Lcats_data_NonEmptyChainOps$.prototype.last$extension__O__O = (function(this$) {
  return $n(this.initLast$extension__O__T2(this$))._2__O();
});
$c_Lcats_data_NonEmptyChainOps$.prototype.find$extension__O__F1__s_Option = (function(this$, f) {
  return $n(($m_Lcats_data_NonEmptyChainImpl$(), $as_Lcats_data_Chain(this$))).find__F1__s_Option(f);
});
$c_Lcats_data_NonEmptyChainOps$.prototype.reduceLeft$extension__O__F2__O = (function(this$, f) {
  var iter = $n(($m_Lcats_data_NonEmptyChainImpl$(), $as_Lcats_data_Chain(this$))).iterator__sc_Iterator();
  var result = $n(iter).next__O();
  while ($n(iter).hasNext__Z()) {
    result = $n(f).apply__O__O__O(result, $n(iter).next__O());
  }
  return result;
});
$c_Lcats_data_NonEmptyChainOps$.prototype.reduceLeftTo$extension__O__F1__F2__O = (function(this$, f, g) {
  var iter = $n(($m_Lcats_data_NonEmptyChainImpl$(), $as_Lcats_data_Chain(this$))).iterator__sc_Iterator();
  var result = $n(f).apply__O__O($n(iter).next__O());
  while ($n(iter).hasNext__Z()) {
    result = $n(g).apply__O__O__O(result, $n(iter).next__O());
  }
  return result;
});
$c_Lcats_data_NonEmptyChainOps$.prototype.map$extension__O__F1__O = (function(this$, f) {
  $m_Lcats_data_NonEmptyChainImpl$();
  var s = $n(($m_Lcats_data_NonEmptyChainImpl$(), $as_Lcats_data_Chain(this$))).map__F1__Lcats_data_Chain(f);
  return s;
});
$c_Lcats_data_NonEmptyChainOps$.prototype.length$extension__O__J = (function(this$) {
  var this$2 = $n(($m_Lcats_data_NonEmptyChainImpl$(), $as_Lcats_data_Chain(this$)));
  return this$2.length__J();
});
$c_Lcats_data_NonEmptyChainOps$.prototype.iterator$extension__O__sc_Iterator = (function(this$) {
  return $n(($m_Lcats_data_NonEmptyChainImpl$(), $as_Lcats_data_Chain(this$))).iterator__sc_Iterator();
});
$c_Lcats_data_NonEmptyChainOps$.prototype.reverse$extension__O__O = (function(this$) {
  $m_Lcats_data_NonEmptyChainImpl$();
  var s = $n(($m_Lcats_data_NonEmptyChainImpl$(), $as_Lcats_data_Chain(this$))).reverse__Lcats_data_Chain();
  return s;
});
var $d_Lcats_data_NonEmptyChainOps$ = new $TypeData().initClass($c_Lcats_data_NonEmptyChainOps$, "cats.data.NonEmptyChainOps$", ({
  Lcats_data_NonEmptyChainOps$: 1
}));
var $n_Lcats_data_NonEmptyChainOps$;
function $m_Lcats_data_NonEmptyChainOps$() {
  if ((!$n_Lcats_data_NonEmptyChainOps$)) {
    $n_Lcats_data_NonEmptyChainOps$ = new $c_Lcats_data_NonEmptyChainOps$();
  }
  return $n_Lcats_data_NonEmptyChainOps$;
}
/** @constructor */
function $c_Lcats_data_NonEmptyListInstances1() {
}
$c_Lcats_data_NonEmptyListInstances1.prototype = new $h_O();
$c_Lcats_data_NonEmptyListInstances1.prototype.constructor = $c_Lcats_data_NonEmptyListInstances1;
/** @constructor */
function $h_Lcats_data_NonEmptyListInstances1() {
}
$h_Lcats_data_NonEmptyListInstances1.prototype = $c_Lcats_data_NonEmptyListInstances1.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptySetInstances1() {
}
$c_Lcats_data_NonEmptySetInstances1.prototype = new $h_O();
$c_Lcats_data_NonEmptySetInstances1.prototype.constructor = $c_Lcats_data_NonEmptySetInstances1;
/** @constructor */
function $h_Lcats_data_NonEmptySetInstances1() {
}
$h_Lcats_data_NonEmptySetInstances1.prototype = $c_Lcats_data_NonEmptySetInstances1.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptySetOps(value) {
  this.Lcats_data_NonEmptySetOps__f_value = null;
  this.Lcats_data_NonEmptySetOps__f_ordering = null;
  this.Lcats_data_NonEmptySetOps__f_value = value;
  var s = this.Lcats_data_NonEmptySetOps__f_value;
  this.Lcats_data_NonEmptySetOps__f_ordering = $n($as_sci_SortedSet(s)).ordering__s_math_Ordering();
  var this$2 = $m_Lcats_kernel_Order$();
  var ev = this.Lcats_data_NonEmptySetOps__f_ordering;
  new $c_Lcats_kernel_Order$$anon$9(ev, this$2);
}
$c_Lcats_data_NonEmptySetOps.prototype = new $h_O();
$c_Lcats_data_NonEmptySetOps.prototype.constructor = $c_Lcats_data_NonEmptySetOps;
/** @constructor */
function $h_Lcats_data_NonEmptySetOps() {
}
$h_Lcats_data_NonEmptySetOps.prototype = $c_Lcats_data_NonEmptySetOps.prototype;
$c_Lcats_data_NonEmptySetOps.prototype.add__O__O = (function(a) {
  $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet);
  var s = this.Lcats_data_NonEmptySetOps__f_value;
  var this$2 = $n($as_sci_SortedSet(s));
  var s$1 = $as_sci_SortedSet(this$2.incl__O__sci_SetOps(a));
  return s$1;
});
$c_Lcats_data_NonEmptySetOps.prototype.toNonEmptyList__Lcats_data_NonEmptyList = (function() {
  var $x_1 = $m_Lcats_data_NonEmptyList$();
  var s = this.Lcats_data_NonEmptySetOps__f_value;
  var this$2 = $n($as_sci_SortedSet(s));
  return $n($x_1).fromListUnsafe__sci_List__Lcats_data_NonEmptyList($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$2));
});
$c_Lcats_data_NonEmptySetOps.prototype.union__O__O = (function(as) {
  var s = this.Lcats_data_NonEmptySetOps__f_value;
  var this$5 = $n($as_sci_SortedSet(s));
  var this$3 = new $c_Lcats_data_NonEmptySetOps(as);
  var s$1 = this$3.Lcats_data_NonEmptySetOps__f_value;
  var that = $as_sci_SortedSet(s$1);
  var s$2 = $as_sci_SortedSet(this$5.concat__sc_IterableOnce__sc_SetOps(that));
  return s$2;
});
$c_Lcats_data_NonEmptySetOps.prototype.filterNot__F1__sci_SortedSet = (function(p) {
  var p$1 = new $c_sjsr_AnonFunction1(((t) => (!$uZ($n(p).apply__O__O(t)))));
  var s = this.Lcats_data_NonEmptySetOps__f_value;
  return $as_sci_SortedSet($n($as_sci_SortedSet(s)).filter__F1__O(p$1));
});
$c_Lcats_data_NonEmptySetOps.prototype.foldRight__Lcats_Eval__F2__Lcats_Eval = (function(lb, f) {
  $m_Lcats_UnorderedFoldable$();
  var instance = $m_Lcats_instances_package$sortedSet$().Lcats_instances_package$sortedSet$__f_catsStdInstancesForSortedSet;
  var $x_1 = $n(instance);
  var s = this.Lcats_data_NonEmptySetOps__f_value;
  return $n($x_1).foldRight__O__Lcats_Eval__F2__Lcats_Eval($as_sci_SortedSet(s), lb, f);
});
$c_Lcats_data_NonEmptySetOps.prototype.reduceLeftTo__F1__F2__O = (function(f, g) {
  var s = this.Lcats_data_NonEmptySetOps__f_value;
  var this$3 = $n($as_sci_SortedSet($n($as_sci_SortedSet(s)).tail__O()));
  var $x_1 = $n(f);
  var s$1 = this.Lcats_data_NonEmptySetOps__f_value;
  var z = $n($x_1).apply__O__O($n($as_sci_SortedSet(s$1)).head__O());
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this$3, z, g);
});
$c_Lcats_data_NonEmptySetOps.prototype.reduce__Lcats_kernel_Semigroup__O = (function(S) {
  var s = this.Lcats_data_NonEmptySetOps__f_value;
  return $n($n(S).combineAllOption__sc_IterableOnce__s_Option($as_sci_SortedSet(s))).get__O();
});
var $d_Lcats_data_NonEmptySetOps = new $TypeData().initClass($c_Lcats_data_NonEmptySetOps, "cats.data.NonEmptySetOps", ({
  Lcats_data_NonEmptySetOps: 1
}));
/** @constructor */
function $c_Lcats_data_ScalaVersionSpecificPackage() {
}
$c_Lcats_data_ScalaVersionSpecificPackage.prototype = new $h_O();
$c_Lcats_data_ScalaVersionSpecificPackage.prototype.constructor = $c_Lcats_data_ScalaVersionSpecificPackage;
/** @constructor */
function $h_Lcats_data_ScalaVersionSpecificPackage() {
}
$h_Lcats_data_ScalaVersionSpecificPackage.prototype = $c_Lcats_data_ScalaVersionSpecificPackage.prototype;
function $f_Lcats_data_ValidatedFunctionsBinCompat0__invalidNec__O__Lcats_data_Validated($thiz, a) {
  var e = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptyChain).one__O__O(a);
  return new $c_Lcats_data_Validated$Invalid(e);
}
/** @constructor */
function $c_Lcats_data_ValidatedInstances2() {
}
$c_Lcats_data_ValidatedInstances2.prototype = new $h_O();
$c_Lcats_data_ValidatedInstances2.prototype.constructor = $c_Lcats_data_ValidatedInstances2;
/** @constructor */
function $h_Lcats_data_ValidatedInstances2() {
}
$h_Lcats_data_ValidatedInstances2.prototype = $c_Lcats_data_ValidatedInstances2.prototype;
/** @constructor */
function $c_Lcats_effect_ContState$() {
  this.Lcats_effect_ContState$__f_cats$effect$ContState$$$waitingSentinel = null;
  $n_Lcats_effect_ContState$ = this;
  this.Lcats_effect_ContState$__f_cats$effect$ContState$$$waitingSentinel = new $c_s_util_Right(null);
}
$c_Lcats_effect_ContState$.prototype = new $h_O();
$c_Lcats_effect_ContState$.prototype.constructor = $c_Lcats_effect_ContState$;
/** @constructor */
function $h_Lcats_effect_ContState$() {
}
$h_Lcats_effect_ContState$.prototype = $c_Lcats_effect_ContState$.prototype;
var $d_Lcats_effect_ContState$ = new $TypeData().initClass($c_Lcats_effect_ContState$, "cats.effect.ContState$", ({
  Lcats_effect_ContState$: 1
}));
var $n_Lcats_effect_ContState$;
function $m_Lcats_effect_ContState$() {
  if ((!$n_Lcats_effect_ContState$)) {
    $n_Lcats_effect_ContState$ = new $c_Lcats_effect_ContState$();
  }
  return $n_Lcats_effect_ContState$;
}
/** @constructor */
function $c_Lcats_effect_CpuStarvationCheckPlatform() {
}
$c_Lcats_effect_CpuStarvationCheckPlatform.prototype = new $h_O();
$c_Lcats_effect_CpuStarvationCheckPlatform.prototype.constructor = $c_Lcats_effect_CpuStarvationCheckPlatform;
/** @constructor */
function $h_Lcats_effect_CpuStarvationCheckPlatform() {
}
$h_Lcats_effect_CpuStarvationCheckPlatform.prototype = $c_Lcats_effect_CpuStarvationCheckPlatform.prototype;
$c_Lcats_effect_CpuStarvationCheckPlatform.prototype.format__s_concurrent_duration_FiniteDuration__T = (function(when) {
  var $x_3 = Date;
  var this$1 = $n(when);
  var this$2 = $n(this$1.s_concurrent_duration_FiniteDuration__f_unit).toMillis__J__J(this$1.s_concurrent_duration_FiniteDuration__f_length);
  var $x_2 = new $x_3($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$2.RTLong__f_lo, this$2.RTLong__f_hi));
  var $x_1 = $x_2.toISOString();
  return $as_T($x_1);
});
function $f_Lcats_effect_IOApp__reportFailure__jl_Throwable__Lcats_effect_IO($thiz, err) {
  var C = $m_Lcats_effect_IO$().Lcats_effect_IO$__f_consoleForIO;
  return $as_Lcats_effect_IO($n(C).printStackTrace__jl_Throwable__O(err));
}
function $f_Lcats_effect_IOApp__main__AT__V($thiz, args) {
  var keepAlive$lzy1 = new $c_sr_LazyRef();
  if (($thiz.Lcats_effect_ResourceApp$Forever$$anon$2__f_cats$effect$IOApp$$_runtime === null)) {
    var this$1 = $m_Lcats_effect_unsafe_IORuntime$();
    if ((this$1.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global === null)) {
      $m_Lcats_effect_unsafe_IORuntime$();
      $m_Lcats_effect_unsafe_IORuntime$();
      var batchSize = 64;
      var reportFailure = new $c_sjsr_AnonFunction1(((t) => {
        var t$1 = $as_jl_Throwable(t);
        $n($f_Lcats_effect_IOApp__reportFailure__jl_Throwable__Lcats_effect_IO($thiz, t$1)).unsafeRunAndForgetWithoutCallback__Lcats_effect_unsafe_IORuntime__V($thiz.Lcats_effect_ResourceApp$Forever$$anon$2__f_cats$effect$IOApp$$_runtime);
      }));
      var compute = new $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor(batchSize, reportFailure);
      var $x_3 = $m_Lcats_effect_unsafe_IORuntime$();
      $m_Lcats_effect_unsafe_IORuntime$();
      var $x_2 = $as_Lcats_effect_unsafe_Scheduler($n($m_Lcats_effect_unsafe_Scheduler$().createDefaultScheduler__T2())._1__O());
      var $x_1 = new $c_sjsr_AnonFunction0((() => {
        $m_Lcats_effect_unsafe_IORuntime$().resetGlobal__V();
      }));
      var this$5 = $m_Lcats_effect_unsafe_IORuntimeConfig$();
      this$1.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global = $n($x_3).apply__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__F0__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_IORuntime(compute, compute, $x_2, $x_1, this$5.Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__f_Default);
      var installed = true;
    } else {
      var installed = false;
    }
    $thiz.Lcats_effect_ResourceApp$Forever$$anon$2__f_cats$effect$IOApp$$_runtime = $m_Lcats_effect_unsafe_IORuntime$().global__Lcats_effect_unsafe_IORuntime();
    var installed$2 = installed;
  } else {
    var this$6 = $m_Lcats_effect_unsafe_IORuntime$();
    if ((this$6.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global === null)) {
      this$6.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global = $thiz.Lcats_effect_ResourceApp$Forever$$anon$2__f_cats$effect$IOApp$$_runtime;
      var installed$2 = true;
    } else {
      var installed$2 = false;
    }
  }
  if ((!installed$2)) {
    $n($m_jl_System$Streams$().jl_System$Streams$__f_err).println__T__V("WARNING: Cats Effect global runtime already initialized; custom configurations will be ignored");
  }
  if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
    var listener = (() => {
      $n($n($thiz.Lcats_effect_ResourceApp$Forever$$anon$2__f_cats$effect$IOApp$$_runtime).Lcats_effect_unsafe_IORuntime__f_fiberMonitor).liveFiberSnapshot__F1__V(new $c_sjsr_AnonFunction1(((_$1) => {
        var _$1$1 = $as_T(_$1);
        $n($m_jl_System$Streams$().jl_System$Streams$__f_err).print__T__V(_$1$1);
      })));
    });
    $m_Lcats_effect_process$().on__T__sjs_js_Function0__V("SIGUSR2", listener);
    $m_Lcats_effect_process$().on__T__sjs_js_Function0__V("SIGINFO", listener);
  }
  var this$10 = $n($m_Lcats_effect_process$().argv__s_Option());
  if (this$10.isEmpty__Z()) {
    var this$11 = $n($m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(args));
    var $x_4 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$11);
  } else {
    var $x_4 = this$10.get__O();
  }
  var argList = $as_sci_List($x_4);
  try {
    var r1 = process.exit;
    var $x_5 = new $c_s_util_Success(r1);
  } catch (e) {
    var $x_5;
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      var $x_5 = new $c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2));
    }
  }
  var hardExit = $as_F1($n($n($x_5).map__F1__s_util_Try(new $c_sjsr_AnonFunction1(((f) => new $c_sjsr_AnonFunction1(((v1) => {
    var i = $uI(v1);
    try {
      f(i);
    } catch (e$1) {
      var e$2$1 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$1)) {
        new $c_s_util_Failure(e$2$1);
      } else {
        throw ((e$2$1 instanceof $c_sjs_js_JavaScriptException) ? e$2$1.sjs_js_JavaScriptException__f_exception : $n(e$2$1));
      }
    }
  })))))).getOrElse__F0__O(new $c_sjsr_AnonFunction0((() => new $c_sjsr_AnonFunction1(((v1$1) => {
    $uI(v1$1);
  }))))));
  var cancelCode = new $c_sr_IntRef(1);
  var F = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO;
  var $x_6 = $m_Lcats_effect_CpuStarvationCheck$();
  var this$17 = $m_Lcats_effect_unsafe_IORuntimeConfig$();
  var \u03b41$ = $n($as_Lcats_effect_IO($n(F).raceOutcome__O__O__O($n($n($n($x_6).run__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_metrics_CpuStarvationMetrics__F1__Lcats_effect_IO(this$17.Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__f_Default, new $c_Lcats_effect_metrics_JsCpuStarvationMetrics(), new $c_sjsr_AnonFunction1(((metrics) => {
    var metrics$1 = $as_Lcats_effect_metrics_CpuStarvationWarningMetrics(metrics);
    return $m_Lcats_effect_CpuStarvationCheck$().logWarning__Lcats_effect_metrics_CpuStarvationWarningMetrics__Lcats_effect_IO(metrics$1);
  })))).background__Lcats_effect_kernel_Resource()).surround__O__Lcats_effect_kernel_MonadCancel__O($thiz.run__sci_List__Lcats_effect_IO(argList), $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO), $ps_Lcats_effect_IOApp__keepAlive$1__sr_LazyRef__Lcats_effect_IO(keepAlive$lzy1)))).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_s_util_Either(x$1);
    if ((x$1$1 instanceof $c_s_util_Left)) {
      var x20 = $as_Lcats_effect_kernel_Outcome($n($as_s_util_Left(x$1$1)).s_util_Left__f_value);
      if (((x20 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x20), true))) {
        $m_Lcats_effect_IO$();
        var t$2 = new $c_ju_concurrent_CancellationException("IOApp main fiber was canceled");
        return new $c_Lcats_effect_IO$Error(t$2);
      }
      if ((x20 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
        var x$1$2 = $as_Lcats_effect_kernel_Outcome$Errored(x20);
        var this$22 = $n(x$1$2);
        var x18 = $as_jl_Throwable(this$22.Lcats_effect_kernel_Outcome$Errored__f_e);
        $m_Lcats_effect_IO$();
        return new $c_Lcats_effect_IO$Error(x18);
      }
      if ((x20 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
        var x$1$3 = $as_Lcats_effect_kernel_Outcome$Succeeded(x20);
        var this$26 = $n(x$1$3);
        var x13 = $as_Lcats_effect_IO(this$26.Lcats_effect_kernel_Outcome$Succeeded__f_fa);
        return x13;
      }
    }
    if ((x$1$1 instanceof $c_s_util_Right)) {
      var x5 = $as_Lcats_effect_kernel_Outcome($n($as_s_util_Right(x$1$1)).s_util_Right__f_value);
      if ((x5 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
        var x$1$4 = $as_Lcats_effect_kernel_Outcome$Errored(x5);
        var this$28 = $n(x$1$4);
        var x8 = $as_jl_Throwable(this$28.Lcats_effect_kernel_Outcome$Errored__f_e);
        $m_Lcats_effect_IO$();
        return new $c_Lcats_effect_IO$Error(x8);
      }
      $m_s_sys_package$().error__T__E("impossible");
    }
    throw new $c_s_MatchError(x$1$1);
  })));
  var fiber = $n(\u03b41$).unsafeRunFiber__F0__F1__F1__Z__Lcats_effect_unsafe_IORuntime__Lcats_effect_IOFiber(new $c_sjsr_AnonFunction0((() => {
    $n(hardExit).apply__O__O(cancelCode.sr_IntRef__f_elem);
  })), new $c_sjsr_AnonFunction1(((t$3) => {
    var t$4 = $as_jl_Throwable(t$3);
    var this$31 = $n(t$4);
    this$31.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err);
    $n(hardExit).apply__O__O(1);
    throw ((t$4 === null) ? $n(null) : t$4);
  })), new $c_sjsr_AnonFunction1(((c) => {
    var c$1 = $as_Lcats_effect_ExitCode(c);
    $n(hardExit).apply__O__O($n(c$1).code__I());
  })), ($n(\u03b41$), true), $thiz.Lcats_effect_ResourceApp$Forever$$anon$2__f_cats$effect$IOApp$$_runtime);
  try {
    process.exit = $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(new $c_sjsr_AnonFunction1(((v1$2) => {
      var _$3 = $uI(v1$2);
      $p_Lcats_effect_IOApp__gracefulExit$1__F1__sr_IntRef__Lcats_effect_IOFiber__I__V($thiz, hardExit, cancelCode, fiber, _$3);
    })));
  } catch (e$3) {
    var e$2$2 = ((e$3 instanceof $c_jl_Throwable) ? e$3 : new $c_sjs_js_JavaScriptException(e$3));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$2)) {
      new $c_s_util_Failure(e$2$2);
    } else {
      throw ((e$2$2 instanceof $c_sjs_js_JavaScriptException) ? e$2$2.sjs_js_JavaScriptException__f_exception : $n(e$2$2));
    }
  }
  $m_Lcats_effect_process$().on__T__sjs_js_Function0__V("SIGTERM", (() => {
    $p_Lcats_effect_IOApp__gracefulExit$1__F1__sr_IntRef__Lcats_effect_IOFiber__I__V($thiz, hardExit, cancelCode, fiber, 143);
  }));
  $m_Lcats_effect_process$().on__T__sjs_js_Function0__V("SIGINT", (() => {
    $p_Lcats_effect_IOApp__gracefulExit$1__F1__sr_IntRef__Lcats_effect_IOFiber__I__V($thiz, hardExit, cancelCode, fiber, 130);
  }));
}
function $ps_Lcats_effect_IOApp__keepAlive$lzyINIT1$1__sr_LazyRef__Lcats_effect_IO(keepAlive$lzy1$1) {
  if ((keepAlive$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ($n(keepAlive$lzy1$1).sr_LazyRef__f__initialized) {
    var $x_1 = $n(keepAlive$lzy1$1).sr_LazyRef__f__value;
  } else {
    var $x_2 = $n(keepAlive$lzy1$1);
    var this$6 = $m_Lcats_effect_IO$();
    var this$2 = new $c_s_concurrent_duration_package$DurationInt(1);
    var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_HOURS;
    var this$ = this$2.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
    $m_s_concurrent_duration_Duration$();
    var hi = (this$ >> 31);
    var finiteDelay = new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(this$, hi), unit);
    var $x_1 = $n($x_2).initialize__O__O($n(this$6.sleep__s_concurrent_duration_Duration__Lcats_effect_IO(finiteDelay)).$greater$greater__F0__Lcats_effect_IO(new $c_sjsr_AnonFunction0((() => $ps_Lcats_effect_IOApp__keepAlive$1__sr_LazyRef__Lcats_effect_IO(keepAlive$lzy1$1)))));
  }
  return $as_Lcats_effect_IO($x_1);
}
function $ps_Lcats_effect_IOApp__keepAlive$1__sr_LazyRef__Lcats_effect_IO(keepAlive$lzy1$2) {
  return $as_Lcats_effect_IO(($n(keepAlive$lzy1$2).sr_LazyRef__f__initialized ? $n(keepAlive$lzy1$2).sr_LazyRef__f__value : $ps_Lcats_effect_IOApp__keepAlive$lzyINIT1$1__sr_LazyRef__Lcats_effect_IO(keepAlive$lzy1$2)));
}
function $p_Lcats_effect_IOApp__gracefulExit$1__F1__sr_IntRef__Lcats_effect_IOFiber__I__V($thiz, hardExit$4, cancelCode$2, fiber$1, code) {
  matchResult2: {
    var x22 = $n($n($thiz.Lcats_effect_ResourceApp$Forever$$anon$2__f_cats$effect$IOApp$$_runtime).Lcats_effect_unsafe_IORuntime__f_config).Lcats_effect_unsafe_IORuntimeConfig__f_shutdownHookTimeout;
    var x = $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Zero;
    if (((x === null) ? (x22 === null) : $n(x).equals__O__Z(x22))) {
      $n(hardExit$4).apply__O__O(code);
      $m_s_None$();
      break matchResult2;
    }
    if ((x22 instanceof $c_s_concurrent_duration_FiniteDuration)) {
      var fd = $as_s_concurrent_duration_FiniteDuration(x22);
      var value = $m_sjs_js_timers_package$().setTimeout__s_concurrent_duration_FiniteDuration__F0__sjs_js_timers_SetTimeoutHandle(fd, new $c_sjsr_AnonFunction0((() => {
        $n(hardExit$4).apply__O__O(code);
      })));
      new $c_s_Some(value);
      break matchResult2;
    }
    $m_s_None$();
  }
  var ev$1 = code;
  $n(cancelCode$2).sr_IntRef__f_elem = ev$1;
  $n($n(fiber$1).cancel__Lcats_effect_IO()).unsafeRunAndForget__Lcats_effect_unsafe_IORuntime__V($thiz.Lcats_effect_ResourceApp$Forever$$anon$2__f_cats$effect$IOApp$$_runtime);
}
/** @constructor */
function $c_Lcats_effect_IOCompanionPlatform() {
}
$c_Lcats_effect_IOCompanionPlatform.prototype = new $h_O();
$c_Lcats_effect_IOCompanionPlatform.prototype.constructor = $c_Lcats_effect_IOCompanionPlatform;
/** @constructor */
function $h_Lcats_effect_IOCompanionPlatform() {
}
$h_Lcats_effect_IOCompanionPlatform.prototype = $c_Lcats_effect_IOCompanionPlatform.prototype;
$c_Lcats_effect_IOCompanionPlatform.prototype.suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_effect_IO = (function(hint, thunk) {
  var this$1 = $n($as_Lcats_effect_IO$(this));
  return this$1.delay__F0__Lcats_effect_IO(thunk);
});
/** @constructor */
function $c_Lcats_effect_IOFiber$() {
  this.Lcats_effect_IOFiber$__f_TypeBlocking = null;
  this.Lcats_effect_IOFiber$__f_OutcomeCanceled = null;
  this.Lcats_effect_IOFiber$__f_RightUnit = null;
  $n_Lcats_effect_IOFiber$ = this;
  this.Lcats_effect_IOFiber$__f_TypeBlocking = $m_Lcats_effect_kernel_Sync$Type$Blocking$();
  this.Lcats_effect_IOFiber$__f_OutcomeCanceled = new $c_Lcats_effect_kernel_Outcome$Canceled();
  this.Lcats_effect_IOFiber$__f_RightUnit = new $c_s_util_Right((void 0));
}
$c_Lcats_effect_IOFiber$.prototype = new $h_O();
$c_Lcats_effect_IOFiber$.prototype.constructor = $c_Lcats_effect_IOFiber$;
/** @constructor */
function $h_Lcats_effect_IOFiber$() {
}
$h_Lcats_effect_IOFiber$.prototype = $c_Lcats_effect_IOFiber$.prototype;
$c_Lcats_effect_IOFiber$.prototype.onFatalFailure__jl_Throwable__N = (function(t) {
  var interrupted = $m_jl_Thread$().interrupted__Z();
  if ($n($m_Lcats_effect_unsafe_IORuntime$().Lcats_effect_unsafe_IORuntime$__f_globalFatalFailureHandled).compareAndSet__Z__Z__Z(false, true)) {
    if (($m_Lcats_effect_unsafe_IORuntime$().Lcats_effect_unsafe_IORuntime$__f_allRuntimes === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
    }
    var r = 0;
    var runtimes = $n($m_Lcats_effect_unsafe_IORuntime$().Lcats_effect_unsafe_IORuntime$__f_allRuntimes).Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable;
    var length = $n(runtimes).u.length;
    while ((r < length)) {
      var ref = $n(runtimes).get(r);
      if ((ref instanceof $c_Lcats_effect_unsafe_IORuntime)) {
        var rt = $as_Lcats_effect_unsafe_IORuntime(ref);
        $n($n(rt).Lcats_effect_unsafe_IORuntime__f_shutdown).apply__O();
        $m_jl_Thread$().interrupted__Z();
        var idx = 0;
        var tables = $n($n(rt).Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs).Lcats_effect_unsafe_StripedHashtable__f_tables;
        var numTables = $n($n(rt).Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs).numTables__I();
        while ((idx < numTables)) {
          var table = $n(tables).get(idx);
          if ((table === null)) {
            throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
          }
          var hashtable = $n(table).Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable;
          var len = $n(hashtable).u.length;
          var i = 0;
          while ((i < len)) {
            var ref$2 = $n(hashtable).get(i);
            if ($is_F1(ref$2)) {
              var cb = $as_F1(ref$2);
              $n(cb).apply__O__O(t);
            }
            i = ((1 + i) | 0);
          }
          idx = ((1 + idx) | 0);
        }
      }
      r = ((1 + r) | 0);
    }
  }
  if (interrupted) {
    var this$1 = $n($m_jl_Thread$().jl_Thread$__f_SingleThread);
    this$1.jl_Thread__f_java$lang$Thread$$interruptedState = true;
  }
  throw ((t === null) ? $n(null) : t);
});
var $d_Lcats_effect_IOFiber$ = new $TypeData().initClass($c_Lcats_effect_IOFiber$, "cats.effect.IOFiber$", ({
  Lcats_effect_IOFiber$: 1
}));
var $n_Lcats_effect_IOFiber$;
function $m_Lcats_effect_IOFiber$() {
  if ((!$n_Lcats_effect_IOFiber$)) {
    $n_Lcats_effect_IOFiber$ = new $c_Lcats_effect_IOFiber$();
  }
  return $n_Lcats_effect_IOFiber$;
}
/** @constructor */
function $c_Lcats_effect_IOPlatform() {
}
$c_Lcats_effect_IOPlatform.prototype = new $h_O();
$c_Lcats_effect_IOPlatform.prototype.constructor = $c_Lcats_effect_IOPlatform;
/** @constructor */
function $h_Lcats_effect_IOPlatform() {
}
$h_Lcats_effect_IOPlatform.prototype = $c_Lcats_effect_IOPlatform.prototype;
function $f_Lcats_effect_ResourceApp$Forever__main__AT__V($thiz, args) {
  var ioApp = new $c_Lcats_effect_ResourceApp$Forever$$anon$2($thiz);
  $f_Lcats_effect_IOApp__main__AT__V(ioApp, args);
}
function $p_Lcats_effect_Trace__renderStackTraceElement__jl_StackTraceElement__T($thiz, ste) {
  return ((((((($n(ste).jl_StackTraceElement__f_declaringClass + ".") + $n(ste).jl_StackTraceElement__f_methodName) + " (") + $n(ste).jl_StackTraceElement__f_fileName) + ":") + $n(ste).jl_StackTraceElement__f_lineNumber) + ")");
}
/** @constructor */
function $c_Lcats_effect_Trace(frames) {
  this.Lcats_effect_Trace__f_frames = null;
  this.Lcats_effect_Trace__f_frames = frames;
}
$c_Lcats_effect_Trace.prototype = new $h_O();
$c_Lcats_effect_Trace.prototype.constructor = $c_Lcats_effect_Trace;
/** @constructor */
function $h_Lcats_effect_Trace() {
}
$h_Lcats_effect_Trace.prototype = $c_Lcats_effect_Trace.prototype;
$c_Lcats_effect_Trace.prototype.compact__T = (function() {
  var this$2 = $n(this.Lcats_effect_Trace__f_frames);
  var f = ((ste) => {
    var ste$1 = $as_jl_StackTraceElement(ste);
    return $p_Lcats_effect_Trace__renderStackTraceElement__jl_StackTraceElement__T(this, ste$1);
  });
  if ((this$2 === $m_sci_Nil$())) {
    var $x_1 = $m_sci_Nil$();
  } else {
    var arg1 = this$2.head__O();
    var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$2.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O());
    }
    var $x_1 = h;
  }
  var this$3 = $n($x_1);
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$3, "", ", ", "");
});
$c_Lcats_effect_Trace.prototype.toString__T = (function() {
  return this.compact__T();
});
function $as_Lcats_effect_Trace(obj) {
  return (((obj instanceof $c_Lcats_effect_Trace) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.Trace"));
}
function $isArrayOf_Lcats_effect_Trace(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_Trace)));
}
function $asArrayOf_Lcats_effect_Trace(obj, depth) {
  return (($isArrayOf_Lcats_effect_Trace(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.Trace;", depth));
}
var $d_Lcats_effect_Trace = new $TypeData().initClass($c_Lcats_effect_Trace, "cats.effect.Trace", ({
  Lcats_effect_Trace: 1
}));
/** @constructor */
function $c_Lcats_effect_Trace$() {
}
$c_Lcats_effect_Trace$.prototype = new $h_O();
$c_Lcats_effect_Trace$.prototype.constructor = $c_Lcats_effect_Trace$;
/** @constructor */
function $h_Lcats_effect_Trace$() {
}
$h_Lcats_effect_Trace$.prototype = $c_Lcats_effect_Trace$.prototype;
$c_Lcats_effect_Trace$.prototype.apply__Lcats_effect_tracing_RingBuffer__Lcats_effect_Trace = (function(events) {
  return new $c_Lcats_effect_Trace($m_Lcats_effect_tracing_Tracing$().getFrames__Lcats_effect_tracing_RingBuffer__sci_List(events));
});
var $d_Lcats_effect_Trace$ = new $TypeData().initClass($c_Lcats_effect_Trace$, "cats.effect.Trace$", ({
  Lcats_effect_Trace$: 1
}));
var $n_Lcats_effect_Trace$;
function $m_Lcats_effect_Trace$() {
  if ((!$n_Lcats_effect_Trace$)) {
    $n_Lcats_effect_Trace$ = new $c_Lcats_effect_Trace$();
  }
  return $n_Lcats_effect_Trace$;
}
/** @constructor */
function $c_Lcats_effect_kernel_MonadCancel$() {
}
$c_Lcats_effect_kernel_MonadCancel$.prototype = new $h_O();
$c_Lcats_effect_kernel_MonadCancel$.prototype.constructor = $c_Lcats_effect_kernel_MonadCancel$;
/** @constructor */
function $h_Lcats_effect_kernel_MonadCancel$() {
}
$h_Lcats_effect_kernel_MonadCancel$.prototype = $c_Lcats_effect_kernel_MonadCancel$.prototype;
$c_Lcats_effect_kernel_MonadCancel$.prototype.monadCancelForKleisli__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_MonadCancel = (function(F0) {
  if ($is_Lcats_effect_kernel_Async(F0)) {
    var async = $as_Lcats_effect_kernel_Async(F0);
    return new $c_Lcats_effect_kernel_Async$$anon$8(async);
  } else if ($is_Lcats_effect_kernel_Sync(F0)) {
    var sync = $as_Lcats_effect_kernel_Sync(F0);
    return new $c_Lcats_effect_kernel_Sync$$anon$6(sync);
  } else if ($is_Lcats_effect_kernel_GenTemporal(F0)) {
    var temporal = $as_Lcats_effect_kernel_GenTemporal(F0);
    return new $c_Lcats_effect_kernel_GenTemporal$$anon$3(temporal);
  } else if ($is_Lcats_effect_kernel_GenConcurrent(F0)) {
    var concurrent = $as_Lcats_effect_kernel_GenConcurrent(F0);
    return new $c_Lcats_effect_kernel_GenConcurrent$$anon$3(concurrent);
  } else if ($is_Lcats_effect_kernel_GenSpawn(F0)) {
    var spawn = $as_Lcats_effect_kernel_GenSpawn(F0);
    return new $c_Lcats_effect_kernel_GenSpawn$$anon$3(spawn);
  } else {
    return new $c_Lcats_effect_kernel_MonadCancel$$anon$4(F0, F0);
  }
});
var $d_Lcats_effect_kernel_MonadCancel$ = new $TypeData().initClass($c_Lcats_effect_kernel_MonadCancel$, "cats.effect.kernel.MonadCancel$", ({
  Lcats_effect_kernel_MonadCancel$: 1
}));
var $n_Lcats_effect_kernel_MonadCancel$;
function $m_Lcats_effect_kernel_MonadCancel$() {
  if ((!$n_Lcats_effect_kernel_MonadCancel$)) {
    $n_Lcats_effect_kernel_MonadCancel$ = new $c_Lcats_effect_kernel_MonadCancel$();
  }
  return $n_Lcats_effect_kernel_MonadCancel$;
}
function $f_Lcats_effect_kernel_MonadCancel$Uncancelable__onCancel__O__O__O($thiz, fa, fin) {
  return fa;
}
/** @constructor */
function $c_Lcats_effect_kernel_Par$() {
  this.Lcats_effect_kernel_Par$__f_instance = null;
  $n_Lcats_effect_kernel_Par$ = this;
  this.Lcats_effect_kernel_Par$__f_instance = new $c_Lcats_effect_kernel_Par$$anon$1();
}
$c_Lcats_effect_kernel_Par$.prototype = new $h_O();
$c_Lcats_effect_kernel_Par$.prototype.constructor = $c_Lcats_effect_kernel_Par$;
/** @constructor */
function $h_Lcats_effect_kernel_Par$() {
}
$h_Lcats_effect_kernel_Par$.prototype = $c_Lcats_effect_kernel_Par$.prototype;
var $d_Lcats_effect_kernel_Par$ = new $TypeData().initClass($c_Lcats_effect_kernel_Par$, "cats.effect.kernel.Par$", ({
  Lcats_effect_kernel_Par$: 1
}));
var $n_Lcats_effect_kernel_Par$;
function $m_Lcats_effect_kernel_Par$() {
  if ((!$n_Lcats_effect_kernel_Par$)) {
    $n_Lcats_effect_kernel_Par$ = new $c_Lcats_effect_kernel_Par$();
  }
  return $n_Lcats_effect_kernel_Par$;
}
/** @constructor */
function $c_Lcats_effect_kernel_ResourceFOInstances1() {
}
$c_Lcats_effect_kernel_ResourceFOInstances1.prototype = new $h_O();
$c_Lcats_effect_kernel_ResourceFOInstances1.prototype.constructor = $c_Lcats_effect_kernel_ResourceFOInstances1;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceFOInstances1() {
}
$h_Lcats_effect_kernel_ResourceFOInstances1.prototype = $c_Lcats_effect_kernel_ResourceFOInstances1.prototype;
function $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O($thiz, wrapped, F) {
  return wrapped;
}
function $f_Lcats_effect_kernel_syntax_MonadCancelSyntax__monadCancelOps__O__Lcats_effect_kernel_MonadCancel__O($thiz, wrapped, F) {
  return wrapped;
}
/** @constructor */
function $c_Lcats_effect_process$() {
}
$c_Lcats_effect_process$.prototype = new $h_O();
$c_Lcats_effect_process$.prototype.constructor = $c_Lcats_effect_process$;
/** @constructor */
function $h_Lcats_effect_process$() {
}
$h_Lcats_effect_process$.prototype = $c_Lcats_effect_process$.prototype;
$c_Lcats_effect_process$.prototype.argv__s_Option = (function() {
  try {
    var array = process.argv;
    var this$3 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), array);
    var this$5 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$3));
    var r1 = $as_sci_List($p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$5, 2, this$5));
    var $x_1 = new $c_s_util_Success(r1);
  } catch (e) {
    var $x_1;
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      var $x_1 = new $c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2));
    }
  }
  return $n($x_1).toOption__s_Option();
});
$c_Lcats_effect_process$.prototype.env__T__s_Option = (function(key) {
  var this$1 = $m_Lcats_effect_std_Env$();
  var F = $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__syncForSyncIO;
  var env = new $c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv(this$1, F);
  var value = env.get__T__O(key);
  return $as_s_Option($n($as_Lcats_effect_SyncIO($n(new $c_Lcats_data_OptionT(value).orElseF__F0__Lcats_Monad__Lcats_data_OptionT(new $c_sjsr_AnonFunction0((() => $as_Lcats_effect_SyncIO(env.get__T__O(("REACT_APP_" + key))))), $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__syncForSyncIO)).Lcats_data_OptionT__f_value)).unsafeRunSync__O());
});
$c_Lcats_effect_process$.prototype.on__T__sjs_js_Function0__V = (function(eventName, listener) {
  try {
    process.on(eventName, listener);
    var r1 = (void 0);
    var $x_1 = new $c_s_util_Success(r1);
  } catch (e) {
    var $x_1;
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      var $x_1 = new $c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2));
    }
  }
  $n($n($x_1).recover__s_PartialFunction__s_util_Try(new $c_Lcats_effect_process$$anon$1())).get__O();
});
var $d_Lcats_effect_process$ = new $TypeData().initClass($c_Lcats_effect_process$, "cats.effect.process$", ({
  Lcats_effect_process$: 1
}));
var $n_Lcats_effect_process$;
function $m_Lcats_effect_process$() {
  if ((!$n_Lcats_effect_process$)) {
    $n_Lcats_effect_process$ = new $c_Lcats_effect_process$();
  }
  return $n_Lcats_effect_process$;
}
/** @constructor */
function $c_Lcats_effect_std_AtomicCell() {
}
$c_Lcats_effect_std_AtomicCell.prototype = new $h_O();
$c_Lcats_effect_std_AtomicCell.prototype.constructor = $c_Lcats_effect_std_AtomicCell;
/** @constructor */
function $h_Lcats_effect_std_AtomicCell() {
}
$h_Lcats_effect_std_AtomicCell.prototype = $c_Lcats_effect_std_AtomicCell.prototype;
function $as_Lcats_effect_std_AtomicCell(obj) {
  return (((obj instanceof $c_Lcats_effect_std_AtomicCell) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.AtomicCell"));
}
function $isArrayOf_Lcats_effect_std_AtomicCell(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_AtomicCell)));
}
function $asArrayOf_Lcats_effect_std_AtomicCell(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_AtomicCell(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.AtomicCell;", depth));
}
/** @constructor */
function $c_Lcats_effect_std_AtomicCell$() {
}
$c_Lcats_effect_std_AtomicCell$.prototype = new $h_O();
$c_Lcats_effect_std_AtomicCell$.prototype.constructor = $c_Lcats_effect_std_AtomicCell$;
/** @constructor */
function $h_Lcats_effect_std_AtomicCell$() {
}
$h_Lcats_effect_std_AtomicCell$.prototype = $c_Lcats_effect_std_AtomicCell$.prototype;
$c_Lcats_effect_std_AtomicCell$.prototype.async__O__Lcats_effect_kernel_Async__O = (function(init, F) {
  var target = $m_Lcats_effect_std_Mutex$().apply__Lcats_effect_kernel_GenConcurrent__O(F);
  var this$3 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, F);
  var f = new $c_sjsr_AnonFunction1(((mutex) => {
    var mutex$1 = $as_Lcats_effect_std_Mutex(mutex);
    return new $c_Lcats_effect_std_AtomicCell$AsyncImpl(init, mutex$1, F);
  }));
  return $n(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
});
$c_Lcats_effect_std_AtomicCell$.prototype.concurrent__O__Lcats_effect_kernel_GenConcurrent__O = (function(init, F) {
  var mk = new $c_Lcats_effect_kernel_Ref$MakeInstances$$anon$1(F);
  var _1 = mk.refOf__O__O(init);
  var _2 = $m_Lcats_effect_std_Mutex$().apply__Lcats_effect_kernel_GenConcurrent__O(F);
  var t2 = new $c_T2(_1, _2);
  return new $c_Lcats_syntax_Tuple2SemigroupalOps(t2).mapN__F2__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction2(((ref, m) => {
    var ref$1 = $as_Lcats_effect_kernel_Ref(ref);
    var m$1 = $as_Lcats_effect_std_Mutex(m);
    return new $c_Lcats_effect_std_AtomicCell$ConcurrentImpl(ref$1, m$1, F);
  })), F, F);
});
var $d_Lcats_effect_std_AtomicCell$ = new $TypeData().initClass($c_Lcats_effect_std_AtomicCell$, "cats.effect.std.AtomicCell$", ({
  Lcats_effect_std_AtomicCell$: 1
}));
var $n_Lcats_effect_std_AtomicCell$;
function $m_Lcats_effect_std_AtomicCell$() {
  if ((!$n_Lcats_effect_std_AtomicCell$)) {
    $n_Lcats_effect_std_AtomicCell$ = new $c_Lcats_effect_std_AtomicCell$();
  }
  return $n_Lcats_effect_std_AtomicCell$;
}
/** @constructor */
function $c_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$() {
}
$c_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$.prototype = new $h_O();
$c_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$.prototype.constructor = $c_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$;
/** @constructor */
function $h_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$() {
}
$h_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$.prototype = $c_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$.prototype;
$c_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$.prototype.of$extension__Z__O__Lcats_effect_kernel_GenConcurrent__O = (function(this$, init, F) {
  if ($is_Lcats_effect_kernel_Async(F)) {
    var f = $as_Lcats_effect_kernel_Async(F);
    return $m_Lcats_effect_std_AtomicCell$().async__O__Lcats_effect_kernel_Async__O(init, f);
  } else {
    return $m_Lcats_effect_std_AtomicCell$().concurrent__O__Lcats_effect_kernel_GenConcurrent__O(init, F);
  }
});
var $d_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$ = new $TypeData().initClass($c_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$, "cats.effect.std.AtomicCell$ApplyPartiallyApplied$", ({
  Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$: 1
}));
var $n_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$;
function $m_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$() {
  if ((!$n_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$)) {
    $n_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$ = new $c_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$();
  }
  return $n_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$;
}
/** @constructor */
function $c_Lcats_effect_std_ConsoleCompanionCrossPlatform() {
}
$c_Lcats_effect_std_ConsoleCompanionCrossPlatform.prototype = new $h_O();
$c_Lcats_effect_std_ConsoleCompanionCrossPlatform.prototype.constructor = $c_Lcats_effect_std_ConsoleCompanionCrossPlatform;
/** @constructor */
function $h_Lcats_effect_std_ConsoleCompanionCrossPlatform() {
}
$h_Lcats_effect_std_ConsoleCompanionCrossPlatform.prototype = $c_Lcats_effect_std_ConsoleCompanionCrossPlatform.prototype;
$c_Lcats_effect_std_ConsoleCompanionCrossPlatform.prototype.printStackTrace__Lcats_effect_std_Console__jl_Throwable__O = (function(c, t) {
  var baos = $ct_Ljava_io_ByteArrayOutputStream__(new $c_Ljava_io_ByteArrayOutputStream());
  var ps = $ct_Ljava_io_PrintStream__Ljava_io_OutputStream__(new $c_Ljava_io_PrintStream(), baos);
  $n(t).printStackTrace__Ljava_io_PrintStream__V(ps);
  var $x_1 = $n(c);
  var bytes = baos.Ljava_io_ByteArrayOutputStream__f_buf;
  var length = baos.Ljava_io_ByteArrayOutputStream__f_count;
  var this$1 = $m_jl_String$();
  return $n($x_1).error__O__Lcats_Show__O(this$1.new__AB__I__I__Ljava_nio_charset_Charset__T(bytes, 0, length, $m_Ljava_nio_charset_UTF\uff3f8$()), $m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString);
});
function $p_Lcats_effect_std_Dispatcher$__impl__Z__Z__Z__Lcats_effect_kernel_Async__Lcats_effect_kernel_Resource($thiz, parallel, await$1, cancelable, evidence$7) {
  var value = new $c_sjsr_AnonFunction1(((_$9) => {
    $as_Lcats_effect_kernel_Outcome(_$9);
    return true;
  }));
  var always = new $c_s_Some(value);
  var this$38 = $n($m_Lcats_effect_std_Supervisor$().apply__Z__s_Option__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(await$1, always, evidence$7));
  var f$3 = new $c_sjsr_AnonFunction1(((supervisor) => {
    var supervisor$1 = $as_Lcats_effect_std_Supervisor(supervisor);
    var termination = $m_Lcats_effect_kernel_Resource$().make__O__F1__Lcats_Functor__Lcats_effect_kernel_Resource($n(evidence$7).delay__F0__O(new $c_sjsr_AnonFunction0((() => $ct_ju_concurrent_atomic_AtomicBoolean__Z__(new $c_ju_concurrent_atomic_AtomicBoolean(), false)))), new $c_sjsr_AnonFunction1(((doneR) => {
      var doneR$1 = $as_ju_concurrent_atomic_AtomicBoolean(doneR);
      return $n(evidence$7).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
        $n(doneR$1).ju_concurrent_atomic_AtomicBoolean__f_value = true;
      })));
    })), evidence$7);
    var awaitTermination = $m_Lcats_effect_kernel_Resource$().make__O__F1__Lcats_Functor__Lcats_effect_kernel_Resource($n(evidence$7).deferred__O(), new $c_sjsr_AnonFunction1(((_$10) => {
      var _$10$1 = $as_Lcats_effect_kernel_Deferred(_$10);
      var target = $n(_$10$1).complete__O__O((void 0));
      var this$7 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, evidence$7);
      return $n(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
    })), evidence$7);
    var t2 = new $c_T2(awaitTermination, termination);
    return $as_Lcats_effect_kernel_Resource(new $c_Lcats_syntax_Tuple2SemigroupalOps(t2).flatMapN__F2__Lcats_FlatMap__O(new $c_sjsr_AnonFunction2(((terminationLatch, doneR$2) => {
      var terminationLatch$1 = $as_Lcats_effect_kernel_Deferred(terminationLatch);
      var doneR$3 = $as_ju_concurrent_atomic_AtomicBoolean(doneR$2);
      if (parallel) {
        var executorF = $m_Lcats_effect_std_Dispatcher$Executor$().parallel__Z__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(await$1, evidence$7);
      } else if (cancelable) {
        var executorF = $m_Lcats_effect_std_Dispatcher$Executor$().sequential__Lcats_effect_std_Supervisor__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(supervisor$1, evidence$7);
      } else {
        var a = new $c_Lcats_effect_std_Dispatcher$Executor$$anon$3(evidence$7);
        var executorF = new $c_Lcats_effect_kernel_Resource$Pure(a);
      }
      var this$35 = $n(executorF);
      var f$2 = new $c_sjsr_AnonFunction1(((executor) => {
        var executor$1 = $as_Lcats_effect_std_Dispatcher$Executor(executor);
        var workerF = $m_Lcats_effect_std_Dispatcher$Worker$().apply__Lcats_effect_std_Dispatcher$Executor__Lcats_effect_kernel_Deferred__Lcats_effect_kernel_Async__Lcats_effect_kernel_Resource(executor$1, terminationLatch$1, evidence$7);
        if (parallel) {
          var n = $thiz.Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$Cpus;
          var F = new $c_Lcats_effect_kernel_ResourceHOInstances0$$anon$9(evidence$7);
          var workersF = $n($as_Lcats_effect_kernel_Resource($f_Lcats_Applicative__replicateA__I__O__O(F, n, workerF))).map__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1(((_$11) => {
            var _$11$1 = $as_sci_List(_$11);
            var this$17 = $n(_$11$1);
            if ((this$17.knownSize__I() >= 0)) {
              var len = this$17.knownSize__I();
              var destination = new ($d_Lcats_effect_std_Dispatcher$Worker.getArrayOf().constr)(len);
              $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$17, destination, 0, 2147483647);
              return destination;
            } else {
              var capacity = 0;
              var jsElems = null;
              capacity = 0;
              jsElems = [];
              var it = this$17.iterator__sc_Iterator();
              while ($n(it).hasNext__Z()) {
                var elem = $n(it).next__O();
                var unboxedElem = ((elem === null) ? null : elem);
                jsElems.push(unboxedElem);
              }
              return new ($d_Lcats_effect_std_Dispatcher$Worker.getArrayOf().constr)(jsElems);
            }
          })));
        } else {
          var workersF = $n(workerF).map__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1(((w) => {
            var w$1 = $as_Lcats_effect_std_Dispatcher$Worker(w);
            return new ($d_Lcats_effect_std_Dispatcher$Worker.getArrayOf().constr)([w$1]);
          })));
        }
        return $n(workersF).evalMap__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1(((workers) => {
          var workers$1 = $asArrayOf_Lcats_effect_std_Dispatcher$Worker(workers, 1);
          var target$1 = $n(evidence$7).executionContext__O();
          var this$34 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, evidence$7);
          var f$1 = new $c_sjsr_AnonFunction1(((ec) => {
            var ec$1 = $as_s_concurrent_ExecutionContext(ec);
            var end = $n(workers$1).u.length;
            var isEmpty = (end <= 0);
            if (isEmpty) {
              var scala$collection$immutable$Range$$numRangeElements = 0;
            } else {
              var hi = (end >> 31);
              var scala$collection$immutable$Range$$numRangeElements = (((hi === 0) ? (((-2147483648) ^ end) > (-1)) : (hi > 0)) ? (-1) : end);
            }
            var scala$collection$immutable$Range$$lastElement = (((-1) + end) | 0);
            var this$28 = $m_sci_Nil$();
            if ((scala$collection$immutable$Range$$numRangeElements < 0)) {
              $m_sci_Range$().scala$collection$immutable$Range$$fail__I__I__I__Z__E(0, end, 1, false);
            }
            if ((scala$collection$immutable$Range$$numRangeElements === 0)) {
              var target$2 = this$28;
            } else {
              var iter = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
              if (iter.sci_RangeIterator__f__hasNext) {
                var result = new $c_sci_$colon$colon(iter.next__I(), this$28);
                var curr = result;
                while (iter.sci_RangeIterator__f__hasNext) {
                  var temp = new $c_sci_$colon$colon(iter.next__I(), this$28);
                  $n(curr).sci_$colon$colon__f_next = temp;
                  curr = temp;
                }
                var target$2 = result;
              } else {
                var target$2 = this$28;
              }
            }
            $m_Lcats_UnorderedFoldable$();
            var tc = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
            var this$31 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(target$2, tc);
            var f = new $c_sjsr_AnonFunction1(((i) => {
              var i$1 = $uI(i);
              return $n(supervisor$1).supervise__O__O($n($n(workers$1).get(i$1)).run__O());
            }));
            var launchAll = $n(this$31.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).traverse___O__F1__Lcats_Applicative__O(this$31.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, f, evidence$7);
            var this$33 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(launchAll, evidence$7);
            var b = new $c_Lcats_effect_std_Dispatcher$$anon$2(parallel, evidence$7, doneR$3, workers$1, ec$1);
            return $n(this$33.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$33.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b);
          }));
          return $n(this$34.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$34.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
        })));
      }));
      return new $c_Lcats_effect_kernel_Resource$Bind(this$35, f$2);
    })), new $c_Lcats_effect_kernel_ResourceHOInstances0$$anon$9(evidence$7)));
  }));
  return new $c_Lcats_effect_kernel_Resource$Bind(this$38, f$3);
}
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$() {
  this.Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$parasiticEC = null;
  this.Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$Cpus = 0;
  this.Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$RightUnit = null;
  $n_Lcats_effect_std_Dispatcher$ = this;
  this.Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$parasiticEC = new $c_Lcats_effect_std_Dispatcher$$anon$1();
  var this$1 = $m_jl_Runtime$();
  $n(this$1.jl_Runtime$__f_currentRuntime);
  this.Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$Cpus = 1;
  this.Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$RightUnit = new $c_s_util_Right((void 0));
}
$c_Lcats_effect_std_Dispatcher$.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$.prototype.constructor = $c_Lcats_effect_std_Dispatcher$;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$() {
}
$h_Lcats_effect_std_Dispatcher$.prototype = $c_Lcats_effect_std_Dispatcher$.prototype;
var $d_Lcats_effect_std_Dispatcher$ = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$, "cats.effect.std.Dispatcher$", ({
  Lcats_effect_std_Dispatcher$: 1
}));
var $n_Lcats_effect_std_Dispatcher$;
function $m_Lcats_effect_std_Dispatcher$() {
  if ((!$n_Lcats_effect_std_Dispatcher$)) {
    $n_Lcats_effect_std_Dispatcher$ = new $c_Lcats_effect_std_Dispatcher$();
  }
  return $n_Lcats_effect_std_Dispatcher$;
}
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Executor() {
}
$c_Lcats_effect_std_Dispatcher$Executor.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$Executor.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Executor;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Executor() {
}
$h_Lcats_effect_std_Dispatcher$Executor.prototype = $c_Lcats_effect_std_Dispatcher$Executor.prototype;
function $as_Lcats_effect_std_Dispatcher$Executor(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$Executor) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$Executor"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$Executor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$Executor)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$Executor(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$Executor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$Executor;", depth));
}
function $p_Lcats_effect_std_Dispatcher$Executor$__TaskState$lzyINIT1$1__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$($thiz, TaskState$lzy1$1) {
  if ((TaskState$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$(($n(TaskState$lzy1$1).sr_LazyRef__f__initialized ? $n(TaskState$lzy1$1).sr_LazyRef__f__value : $n(TaskState$lzy1$1).initialize__O__O(new $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$(TaskState$lzy1$1))));
}
function $p_Lcats_effect_std_Dispatcher$Executor$__loop$lzyINIT1$1__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Ref__O__sr_LazyRef__O($thiz, evidence$11$8, doneR$7, step$2, loop$lzy1$1) {
  if ((loop$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ($n(loop$lzy1$1).sr_LazyRef__f__initialized) {
    return $n(loop$lzy1$1).sr_LazyRef__f__value;
  } else {
    var $x_1 = $n(loop$lzy1$1);
    var fa = $n(doneR$7).get__O();
    var ifTrue = new $c_sjsr_AnonFunction0((() => {
      var this$4 = $n(evidence$11$8);
      return this$4.pure__O__O((void 0));
    }));
    var ifFalse = new $c_sjsr_AnonFunction0((() => $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(step$2, new $c_sjsr_AnonFunction0((() => $p_Lcats_effect_std_Dispatcher$Executor$__loop$1__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Ref__O__sr_LazyRef__O($thiz, evidence$11$8, doneR$7, step$2, loop$lzy1$1))), evidence$11$8)));
    var this$7 = $n(evidence$11$8);
    return $n($x_1).initialize__O__O($f_Lcats_FlatMap__ifM__O__F0__F0__O(this$7, fa, ifTrue, ifFalse));
  }
}
function $p_Lcats_effect_std_Dispatcher$Executor$__loop$1__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Ref__O__sr_LazyRef__O($thiz, evidence$11$11, doneR$9, step$4, loop$lzy1$3) {
  return ($n(loop$lzy1$3).sr_LazyRef__f__initialized ? $n(loop$lzy1$3).sr_LazyRef__f__value : $p_Lcats_effect_std_Dispatcher$Executor$__loop$lzyINIT1$1__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Ref__O__sr_LazyRef__O($thiz, evidence$11$11, doneR$9, step$4, loop$lzy1$3));
}
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Executor$() {
}
$c_Lcats_effect_std_Dispatcher$Executor$.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$Executor$.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Executor$;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Executor$() {
}
$h_Lcats_effect_std_Dispatcher$Executor$.prototype = $c_Lcats_effect_std_Dispatcher$Executor$.prototype;
$c_Lcats_effect_std_Dispatcher$Executor$.prototype.sequential__Lcats_effect_std_Supervisor__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource = (function(supervisor, evidence$11) {
  var TaskState$lzy1 = new $c_sr_LazyRef();
  var fa = $m_Lcats_effect_std_Queue$().unbounded__Lcats_effect_kernel_GenConcurrent__O(evidence$11);
  var this$39 = new $c_Lcats_effect_kernel_Resource$Eval(fa);
  var TaskState$lzy1$2$1 = TaskState$lzy1;
  var f$7 = new $c_sjsr_AnonFunction1(((TaskState$lzy1$2) => ((tasks) => {
    var tasks$1 = $as_Lcats_effect_std_Queue(tasks);
    var target = $n(evidence$11).ref__O__O($n(this.cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(TaskState$lzy1$2)).Dead__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$());
    var this$6 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, evidence$11);
    var f = new $c_sjsr_AnonFunction1(((_$25) => {
      var _$25$1 = $as_Lcats_effect_kernel_Ref(_$25);
      return $n(tasks$1).offer__O__O(_$25$1);
    }));
    var evict = $n(this$6.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$6.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
    return $n($m_Lcats_effect_kernel_Resource$().make__O__F1__Lcats_Functor__Lcats_effect_kernel_Resource($n(evidence$11).ref__O__O(false), new $c_sjsr_AnonFunction1(((r) => {
      var r$1 = $as_Lcats_effect_kernel_Ref(r);
      var fa$1 = $n(r$1).set__O__O(true);
      return $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa$1, new $c_sjsr_AnonFunction0((() => evict)), evidence$11);
    })), evidence$11)).evalMap__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1(((doneR) => {
      var doneR$1 = $as_Lcats_effect_kernel_Ref(doneR);
      var target$1 = $n(evidence$11).ref__O__O($m_s_None$());
      var this$38 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, evidence$11);
      var f$6 = new $c_sjsr_AnonFunction1(((shutoff) => {
        var shutoff$1 = $as_Lcats_effect_kernel_Ref(shutoff);
        var loop$lzy1 = new $c_sr_LazyRef();
        var target$2 = $n(tasks$1).take__O();
        var this$32 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, evidence$11);
        var f$3 = new $c_sjsr_AnonFunction1(((taskR) => {
          var taskR$1 = $as_Lcats_effect_kernel_Ref(taskR);
          var target$3 = $n(taskR$1).getAndSet__O__O($n(this.cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(TaskState$lzy1$2)).Executing__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$());
          var this$31 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$3, evidence$11);
          var f$2 = new $c_sjsr_AnonFunction1(((x$1) => {
            var x$1$1 = $as_Lcats_effect_std_Dispatcher$Executor$TaskState$1(x$1);
            if (((x$1$1 instanceof $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready) && ($n($as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready(x$1$1)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready__f_$outer === this.cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(TaskState$lzy1$2)))) {
              $n($n(this.cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(TaskState$lzy1$2)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Ready$lzy1);
              var x$1$2 = $as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready(x$1$1);
              var this$14 = $n(x$1$2);
              var x84 = this$14.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready__f_task;
              var target$4 = $n(taskR$1).getAndSet__O__O($n(this.cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(TaskState$lzy1$2)).Dead__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$());
              var this$23 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$4, evidence$11);
              var f$1 = new $c_sjsr_AnonFunction1(((x$1$2$1) => {
                var x$1$3 = $as_Lcats_effect_std_Dispatcher$Executor$TaskState$1(x$1$2$1);
                if (((x$1$3 instanceof $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling) && ($n($as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(x$1$3)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_$outer === this.cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(TaskState$lzy1$2)))) {
                  $n($n(this.cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(TaskState$lzy1$2)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Canceling$lzy1);
                  var x$1$4 = $as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(x$1$3);
                  var this$18 = $n(x$1$4);
                  var x77 = this$18.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_latch;
                  var target$5 = $n(x77).complete__O__O((void 0));
                  var this$20 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$5, evidence$11);
                  return $n(this$20.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$20.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
                } else {
                  var this$22 = $n(evidence$11);
                  return this$22.pure__O__O((void 0));
                }
              }));
              var fin = $n(this$23.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$23.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
              return $n(evidence$11).guarantee__O__O__O(x84, fin);
            }
            matchAlts3: {
              matchAlts4: {
                var x = $n(this.cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(TaskState$lzy1$2)).Executing__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$();
                if ((x === null)) {
                  var $x_1 = (x$1$1 === null);
                } else {
                  var this$25 = $n(x);
                  var $x_1 = (this$25 === x$1$1);
                }
                if ($x_1) {
                  break matchAlts4;
                }
                if (((x$1$1 instanceof $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling) && ($n($as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(x$1$1)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_$outer === this.cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(TaskState$lzy1$2)))) {
                  $n($n(this.cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(TaskState$lzy1$2)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Canceling$lzy1);
                  var x$1$5 = $as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(x$1$1);
                  var this$27 = $n(x$1$5);
                  break matchAlts4;
                }
                var x$3 = $n(this.cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(TaskState$lzy1$2)).Dead__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$();
                if ((x$3 === null)) {
                  var $x_2 = (x$1$1 === null);
                } else {
                  var this$28 = $n(x$3);
                  var $x_2 = (this$28 === x$1$1);
                }
                if ($x_2) {
                  break matchAlts4;
                }
                break matchAlts3;
              }
              var this$30 = $n(evidence$11);
              return this$30.pure__O__O((void 0));
            }
            throw new $c_s_MatchError(x$1$1);
          }));
          return $n(this$31.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$31.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
        }));
        var step = $n(this$32.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$32.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
        var spawnExecutor = $n(supervisor).supervise__O__O($p_Lcats_effect_std_Dispatcher$Executor$__loop$1__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Ref__O__sr_LazyRef__O(this, evidence$11, doneR$1, step, loop$lzy1));
        var this$37 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(spawnExecutor, evidence$11);
        var f$5 = new $c_sjsr_AnonFunction1(((fiber) => {
          var fiber$1 = $as_Lcats_effect_kernel_Fiber(fiber);
          var target$6 = $n(evidence$11).ref__O__O(fiber$1);
          var this$36 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$6, evidence$11);
          var f$4 = new $c_sjsr_AnonFunction1(((fiberR) => {
            var fiberR$1 = $as_Lcats_effect_kernel_Ref(fiberR);
            return new $c_Lcats_effect_std_Dispatcher$Executor$$anon$4(evidence$11, tasks$1, shutoff$1, spawnExecutor, fiberR$1, TaskState$lzy1$2);
          }));
          return $n(this$36.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$36.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$4);
        }));
        return $n(this$37.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$37.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$5);
      }));
      return $n(this$38.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$38.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$6);
    })));
  }))(TaskState$lzy1$2$1));
  return new $c_Lcats_effect_kernel_Resource$Bind(this$39, f$7);
});
$c_Lcats_effect_std_Dispatcher$Executor$.prototype.parallel__Z__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource = (function(await$1, evidence$12) {
  var this$1 = $m_Lcats_effect_std_Supervisor$();
  return $n(this$1.apply__Z__s_Option__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(await$1, $m_s_None$(), evidence$12)).map__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1(((supervisor) => {
    var supervisor$1 = $as_Lcats_effect_std_Supervisor(supervisor);
    return new $c_Lcats_effect_std_Dispatcher$Executor$$anon$5(evidence$12, supervisor$1);
  })));
});
$c_Lcats_effect_std_Dispatcher$Executor$.prototype.cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$ = (function(TaskState$lzy1$2) {
  return $as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$(($n(TaskState$lzy1$2).sr_LazyRef__f__initialized ? $n(TaskState$lzy1$2).sr_LazyRef__f__value : $p_Lcats_effect_std_Dispatcher$Executor$__TaskState$lzyINIT1$1__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(this, TaskState$lzy1$2)));
});
var $d_Lcats_effect_std_Dispatcher$Executor$ = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Executor$, "cats.effect.std.Dispatcher$Executor$", ({
  Lcats_effect_std_Dispatcher$Executor$: 1
}));
var $n_Lcats_effect_std_Dispatcher$Executor$;
function $m_Lcats_effect_std_Dispatcher$Executor$() {
  if ((!$n_Lcats_effect_std_Dispatcher$Executor$)) {
    $n_Lcats_effect_std_Dispatcher$Executor$ = new $c_Lcats_effect_std_Dispatcher$Executor$();
  }
  return $n_Lcats_effect_std_Dispatcher$Executor$;
}
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Registration() {
}
$c_Lcats_effect_std_Dispatcher$Registration.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$Registration.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Registration;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Registration() {
}
$h_Lcats_effect_std_Dispatcher$Registration.prototype = $c_Lcats_effect_std_Dispatcher$Registration.prototype;
function $as_Lcats_effect_std_Dispatcher$Registration(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$Registration) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$Registration"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$Registration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$Registration)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$Registration(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$Registration(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$Registration;", depth));
}
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Worker(queue, supervisor, executor, terminationLatch, evidence$8) {
  this.Lcats_effect_std_Dispatcher$Worker__f_queue = null;
  this.Lcats_effect_std_Dispatcher$Worker__f_supervisor = null;
  this.Lcats_effect_std_Dispatcher$Worker__f_executor = null;
  this.Lcats_effect_std_Dispatcher$Worker__f_terminationLatch = null;
  this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8 = null;
  this.Lcats_effect_std_Dispatcher$Worker__f_doneR = null;
  this.Lcats_effect_std_Dispatcher$Worker__f_queue = queue;
  this.Lcats_effect_std_Dispatcher$Worker__f_supervisor = supervisor;
  this.Lcats_effect_std_Dispatcher$Worker__f_executor = executor;
  this.Lcats_effect_std_Dispatcher$Worker__f_terminationLatch = terminationLatch;
  this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8 = evidence$8;
  this.Lcats_effect_std_Dispatcher$Worker__f_doneR = $ct_ju_concurrent_atomic_AtomicBoolean__Z__(new $c_ju_concurrent_atomic_AtomicBoolean(), false);
}
$c_Lcats_effect_std_Dispatcher$Worker.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$Worker.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Worker;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Worker() {
}
$h_Lcats_effect_std_Dispatcher$Worker.prototype = $c_Lcats_effect_std_Dispatcher$Worker.prototype;
$c_Lcats_effect_std_Dispatcher$Worker.prototype.run__O = (function() {
  var target = $n(this.Lcats_effect_std_Dispatcher$Worker__f_queue).take__O();
  var tc = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8;
  var this$54 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f$1 = new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Lcats_effect_std_Dispatcher$Registration(x$1);
    if ((x$1$1 instanceof $c_Lcats_effect_std_Dispatcher$Registration$Primary)) {
      var reg = $as_Lcats_effect_std_Dispatcher$Registration$Primary(x$1$1);
      var F = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8;
      var this$45 = $n(F);
      var thunk$1 = new $c_sjsr_AnonFunction0((() => {
        var x44 = $as_Lcats_effect_std_Dispatcher$RegState($n($n(reg).Lcats_effect_std_Dispatcher$Registration$Primary__f_stateR).ju_concurrent_atomic_AtomicReference__f_value);
        var x = $m_Lcats_effect_std_Dispatcher$RegState$Unstarted$();
        if ((x === x44)) {
          var action = $n(reg).Lcats_effect_std_Dispatcher$Registration$Primary__f_action;
          if ((action === null)) {
            var F$1 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8;
            var fa = $n(F$1).cede__O();
            var F$2 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8;
            var this$7 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa, F$2);
            var F$3 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8;
            var fb = $n(F$3).delay__F0__O(new $c_sjsr_AnonFunction0((() => $as_Lcats_effect_std_Dispatcher$RegState($n($n(reg).Lcats_effect_std_Dispatcher$Registration$Primary__f_stateR).ju_concurrent_atomic_AtomicReference__f_value))));
            var this$8 = $n(this$7.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
            var fa$1 = this$7.Lcats_syntax_ApplySyntax$$anon$1__f_self;
            var check = this$8.productR__O__O__O(fa$1, fb);
            var M = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8;
            var p = new $c_sjsr_AnonFunction1(((_$20) => {
              var _$20$1 = $as_Lcats_effect_std_Dispatcher$RegState(_$20);
              var x$2 = $m_Lcats_effect_std_Dispatcher$RegState$Unstarted$();
              return ((_$20$1 !== null) && $n(_$20$1).equals__O__Z(x$2));
            }));
            var this$11 = $n(M);
            var target$1 = $f_Lcats_Monad__iterateWhile__O__F1__O(this$11, check, p);
            var tc$1 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8;
            var this$18 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
            var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
              var x$1$3 = $as_Lcats_effect_std_Dispatcher$RegState(x$1$2);
              if ((x$1$3 instanceof $c_Lcats_effect_std_Dispatcher$RegState$CancelRequested)) {
                var x36 = $as_Lcats_effect_std_Dispatcher$RegState$CancelRequested(x$1$3);
                var this$14 = $n(x36);
                var x38 = this$14.Lcats_effect_std_Dispatcher$RegState$CancelRequested__f_latch;
                var F$4 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8;
                return $n(F$4).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
                  if ($n($n(reg).Lcats_effect_std_Dispatcher$Registration$Primary__f_stateR).compareAndSet__O__O__Z(x36, $m_Lcats_effect_std_Dispatcher$RegState$Completed$())) {
                    var this$16 = $n(x38);
                    $f_s_concurrent_Promise__success__O__s_concurrent_Promise(this$16, (void 0));
                  } else {
                    var s = $as_Lcats_effect_std_Dispatcher$RegState($n($n(reg).Lcats_effect_std_Dispatcher$Registration$Primary__f_stateR).ju_concurrent_atomic_AtomicReference__f_value);
                    throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), ("d => " + s));
                  }
                })));
              } else {
                var ev = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8;
                return $n(ev).raiseError__O__O($ct_jl_AssertionError__O__(new $c_jl_AssertionError(), ("a => " + x$1$3)));
              }
            }));
            return $n(this$18.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$18.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
          } else {
            return $n(this.Lcats_effect_std_Dispatcher$Worker__f_executor).apply__O__F1__O(action, new $c_sjsr_AnonFunction1(((cancelF) => {
              var F$5 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8;
              var this$36 = $n(F$5);
              var thunk = new $c_sjsr_AnonFunction0((() => {
                if ($n($n(reg).Lcats_effect_std_Dispatcher$Registration$Primary__f_stateR).compareAndSet__O__O__Z($m_Lcats_effect_std_Dispatcher$RegState$Unstarted$(), new $c_Lcats_effect_std_Dispatcher$RegState$Running(cancelF))) {
                  var instance = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8;
                  var this$22 = $n(instance);
                  return this$22.pure__O__O((void 0));
                } else {
                  var x40 = $as_Lcats_effect_std_Dispatcher$RegState($n($n(reg).Lcats_effect_std_Dispatcher$Registration$Primary__f_stateR).ju_concurrent_atomic_AtomicReference__f_value);
                  if ((x40 instanceof $c_Lcats_effect_std_Dispatcher$RegState$CancelRequested)) {
                    var x41 = $as_Lcats_effect_std_Dispatcher$RegState$CancelRequested(x40);
                    var this$24 = $n(x41);
                    var x43 = this$24.Lcats_effect_std_Dispatcher$RegState$CancelRequested__f_latch;
                    if ($n($n(reg).Lcats_effect_std_Dispatcher$Registration$Primary__f_stateR).compareAndSet__O__O__Z(x41, new $c_Lcats_effect_std_Dispatcher$RegState$Running(cancelF))) {
                      var $x_1 = $n(this.Lcats_effect_std_Dispatcher$Worker__f_supervisor);
                      var F$6 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8;
                      var fin = $n(F$6).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
                        var this$28 = $n(x43);
                        $f_s_concurrent_Promise__success__O__s_concurrent_Promise(this$28, (void 0));
                      })));
                      var F$7 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8;
                      var target$2 = $n($x_1).supervise__O__O($n(F$7).guarantee__O__O__O(cancelF, fin));
                      var tc$2 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8;
                      var this$31 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, tc$2);
                      return $n(this$31.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$31.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
                    } else {
                      var x39 = $as_Lcats_effect_std_Dispatcher$RegState($n($n(reg).Lcats_effect_std_Dispatcher$Registration$Primary__f_stateR).ju_concurrent_atomic_AtomicReference__f_value);
                      var x$3 = $m_Lcats_effect_std_Dispatcher$RegState$Completed$();
                      if ((x$3 === x39)) {
                        var instance$1 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8;
                        var this$33 = $n(instance$1);
                        return this$33.pure__O__O((void 0));
                      }
                      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), ("e => " + x39));
                    }
                  }
                  var x$3$1 = $m_Lcats_effect_std_Dispatcher$RegState$Completed$();
                  if ((x$3$1 === x40)) {
                    var instance$2 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8;
                    var this$35 = $n(instance$2);
                    return this$35.pure__O__O((void 0));
                  }
                  throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), ("b => " + x40));
                }
              }));
              return $f_Lcats_effect_kernel_Sync__defer__F0__O(this$36, thunk);
            })));
          }
        }
        matchAlts1: {
          matchAlts2: {
            if ((x44 instanceof $c_Lcats_effect_std_Dispatcher$RegState$Running)) {
              var x$1$4 = $as_Lcats_effect_std_Dispatcher$RegState$Running(x44);
              var this$38 = $n(x$1$4);
              break matchAlts2;
            }
            var x$3$2 = $m_Lcats_effect_std_Dispatcher$RegState$Completed$();
            if ((x$3$2 === x44)) {
              break matchAlts2;
            }
            break matchAlts1;
          }
          throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), ("c => " + x44));
        }
        if ((x44 instanceof $c_Lcats_effect_std_Dispatcher$RegState$CancelRequested)) {
          var x$1$5 = $as_Lcats_effect_std_Dispatcher$RegState$CancelRequested(x44);
          var this$40 = $n(x$1$5);
          var x47 = this$40.Lcats_effect_std_Dispatcher$RegState$CancelRequested__f_latch;
          var F$8 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8;
          var target$3 = $n(F$8).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
            var this$42 = $n(x47);
            return $f_s_concurrent_Promise__success__O__s_concurrent_Promise(this$42, (void 0));
          })));
          var tc$3 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8;
          var this$44 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, tc$3);
          return $n(this$44.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$44.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
        }
        throw new $c_s_MatchError(x44);
      }));
      return $f_Lcats_effect_kernel_Sync__defer__F0__O(this$45, thunk$1);
    }
    if ((x$1$1 instanceof $c_Lcats_effect_std_Dispatcher$Registration$Finalizer)) {
      var x$1$6 = $as_Lcats_effect_std_Dispatcher$Registration$Finalizer(x$1$1);
      var this$47 = $n(x$1$6);
      var x55 = this$47.Lcats_effect_std_Dispatcher$Registration$Finalizer__f_action;
      var target$4 = $n(this.Lcats_effect_std_Dispatcher$Worker__f_supervisor).supervise__O__O(x55);
      var tc$4 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8;
      var this$49 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$4, tc$4);
      var fu = $n(this$49.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$49.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
      var F$9 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8;
      var this$52 = $n(F$9);
      return $f_Lcats_ApplicativeError__voidError__O__O(this$52, fu);
    }
    if (((x$1$1 instanceof $c_Lcats_effect_std_Dispatcher$Registration$PoisonPill) && ($as_Lcats_effect_std_Dispatcher$Registration$PoisonPill(x$1$1), true))) {
      var F$10 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8;
      return $n(F$10).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
        $n(this.Lcats_effect_std_Dispatcher$Worker__f_doneR).ju_concurrent_atomic_AtomicBoolean__f_value = true;
      })));
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  var step = $n(this$54.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$54.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
  var F$11 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8;
  var fa$2 = $n(F$11).delay__F0__O(new $c_sjsr_AnonFunction0((() => $n(this.Lcats_effect_std_Dispatcher$Worker__f_doneR).ju_concurrent_atomic_AtomicBoolean__f_value)));
  var ifTrue = new $c_sjsr_AnonFunction0((() => {
    var fa$3 = $n(this.Lcats_effect_std_Dispatcher$Worker__f_terminationLatch).get__O();
    return $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa$3, new $c_sjsr_AnonFunction0((() => {
      var F$12 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8;
      return $n(F$12).cede__O();
    })), this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8);
  }));
  var ifFalse = new $c_sjsr_AnonFunction0((() => $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(step, new $c_sjsr_AnonFunction0((() => this.run__O())), this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8)));
  var F$13 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$8;
  var this$61 = $n(F$13);
  return $f_Lcats_FlatMap__ifM__O__F0__F0__O(this$61, fa$2, ifTrue, ifFalse);
});
function $as_Lcats_effect_std_Dispatcher$Worker(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$Worker) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$Worker"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$Worker(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$Worker)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$Worker(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$Worker(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$Worker;", depth));
}
var $d_Lcats_effect_std_Dispatcher$Worker = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Worker, "cats.effect.std.Dispatcher$Worker", ({
  Lcats_effect_std_Dispatcher$Worker: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Worker$() {
}
$c_Lcats_effect_std_Dispatcher$Worker$.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$Worker$.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Worker$;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Worker$() {
}
$h_Lcats_effect_std_Dispatcher$Worker$.prototype = $c_Lcats_effect_std_Dispatcher$Worker$.prototype;
$c_Lcats_effect_std_Dispatcher$Worker$.prototype.apply__Lcats_effect_std_Dispatcher$Executor__Lcats_effect_kernel_Deferred__Lcats_effect_kernel_Async__Lcats_effect_kernel_Resource = (function(executor, terminationLatch, evidence$13) {
  var this$1 = $m_Lcats_effect_std_Supervisor$();
  var this$6 = $n(this$1.apply__Z__s_Option__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(false, $m_s_None$(), evidence$13));
  var f = new $c_sjsr_AnonFunction1(((supervisor) => {
    var supervisor$1 = $as_Lcats_effect_std_Supervisor(supervisor);
    var initF = $n(evidence$13).delay__F0__O(new $c_sjsr_AnonFunction0((() => new $c_Lcats_effect_std_Dispatcher$Worker(new $c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue(evidence$13), supervisor$1, executor, terminationLatch, evidence$13))));
    return $m_Lcats_effect_kernel_Resource$().make__O__F1__Lcats_Functor__Lcats_effect_kernel_Resource(initF, new $c_sjsr_AnonFunction1(((w) => {
      var w$1 = $as_Lcats_effect_std_Dispatcher$Worker(w);
      return $n(evidence$13).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
        $n($n(w$1).Lcats_effect_std_Dispatcher$Worker__f_queue).unsafeOffer__O__V(new $c_Lcats_effect_std_Dispatcher$Registration$PoisonPill());
      })));
    })), evidence$13);
  }));
  return new $c_Lcats_effect_kernel_Resource$Bind(this$6, f);
});
var $d_Lcats_effect_std_Dispatcher$Worker$ = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Worker$, "cats.effect.std.Dispatcher$Worker$", ({
  Lcats_effect_std_Dispatcher$Worker$: 1
}));
var $n_Lcats_effect_std_Dispatcher$Worker$;
function $m_Lcats_effect_std_Dispatcher$Worker$() {
  if ((!$n_Lcats_effect_std_Dispatcher$Worker$)) {
    $n_Lcats_effect_std_Dispatcher$Worker$ = new $c_Lcats_effect_std_Dispatcher$Worker$();
  }
  return $n_Lcats_effect_std_Dispatcher$Worker$;
}
/** @constructor */
function $c_Lcats_effect_std_EnvCompanionPlatform() {
}
$c_Lcats_effect_std_EnvCompanionPlatform.prototype = new $h_O();
$c_Lcats_effect_std_EnvCompanionPlatform.prototype.constructor = $c_Lcats_effect_std_EnvCompanionPlatform;
/** @constructor */
function $h_Lcats_effect_std_EnvCompanionPlatform() {
}
$h_Lcats_effect_std_EnvCompanionPlatform.prototype = $c_Lcats_effect_std_EnvCompanionPlatform.prototype;
/** @constructor */
function $c_Lcats_effect_std_Mutex() {
}
$c_Lcats_effect_std_Mutex.prototype = new $h_O();
$c_Lcats_effect_std_Mutex.prototype.constructor = $c_Lcats_effect_std_Mutex;
/** @constructor */
function $h_Lcats_effect_std_Mutex() {
}
$h_Lcats_effect_std_Mutex.prototype = $c_Lcats_effect_std_Mutex.prototype;
function $as_Lcats_effect_std_Mutex(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Mutex) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Mutex"));
}
function $isArrayOf_Lcats_effect_std_Mutex(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Mutex)));
}
function $asArrayOf_Lcats_effect_std_Mutex(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Mutex(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Mutex;", depth));
}
/** @constructor */
function $c_Lcats_effect_std_Mutex$() {
}
$c_Lcats_effect_std_Mutex$.prototype = new $h_O();
$c_Lcats_effect_std_Mutex$.prototype.constructor = $c_Lcats_effect_std_Mutex$;
/** @constructor */
function $h_Lcats_effect_std_Mutex$() {
}
$h_Lcats_effect_std_Mutex$.prototype = $c_Lcats_effect_std_Mutex$.prototype;
$c_Lcats_effect_std_Mutex$.prototype.apply__Lcats_effect_kernel_GenConcurrent__O = (function(F) {
  var mk = new $c_Lcats_effect_kernel_Ref$MakeInstances$$anon$1(F);
  var target = mk.refOf__O__O(null);
  var this$5 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, F);
  var f = new $c_sjsr_AnonFunction1(((state) => {
    var state$1 = $as_Lcats_effect_kernel_Ref(state);
    return new $c_Lcats_effect_std_Mutex$ConcurrentImpl(state$1, F);
  }));
  return $n(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
});
var $d_Lcats_effect_std_Mutex$ = new $TypeData().initClass($c_Lcats_effect_std_Mutex$, "cats.effect.std.Mutex$", ({
  Lcats_effect_std_Mutex$: 1
}));
var $n_Lcats_effect_std_Mutex$;
function $m_Lcats_effect_std_Mutex$() {
  if ((!$n_Lcats_effect_std_Mutex$)) {
    $n_Lcats_effect_std_Mutex$ = new $c_Lcats_effect_std_Mutex$();
  }
  return $n_Lcats_effect_std_Mutex$;
}
/** @constructor */
function $c_Lcats_effect_std_Queue$() {
  this.Lcats_effect_std_Queue$__f_cats$effect$std$Queue$$$EitherUnit = null;
  $n_Lcats_effect_std_Queue$ = this;
  this.Lcats_effect_std_Queue$__f_cats$effect$std$Queue$$$EitherUnit = new $c_s_util_Right((void 0));
}
$c_Lcats_effect_std_Queue$.prototype = new $h_O();
$c_Lcats_effect_std_Queue$.prototype.constructor = $c_Lcats_effect_std_Queue$;
/** @constructor */
function $h_Lcats_effect_std_Queue$() {
}
$h_Lcats_effect_std_Queue$.prototype = $c_Lcats_effect_std_Queue$.prototype;
$c_Lcats_effect_std_Queue$.prototype.boundedForConcurrent__I__Lcats_effect_kernel_GenConcurrent__O = (function(capacity, F) {
  var $x_1 = $n(F);
  var queue = $m_sci_Queue$EmptyQueue$();
  var takers = $m_sci_Queue$EmptyQueue$();
  var offerers = $m_sci_Queue$EmptyQueue$();
  var target = $n($x_1).ref__O__O(new $c_Lcats_effect_std_Queue$State(queue, 0, takers, offerers));
  var this$8 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, F);
  var f = new $c_sjsr_AnonFunction1(((_$5) => {
    var _$5$1 = $as_Lcats_effect_kernel_Ref(_$5);
    return new $c_Lcats_effect_std_Queue$BoundedQueue(capacity, _$5$1, F);
  }));
  return $n(this$8.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$8.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
});
$c_Lcats_effect_std_Queue$.prototype.unboundedForAsync__Lcats_effect_kernel_Async__O = (function(F) {
  return $n(F).delay__F0__O(new $c_sjsr_AnonFunction0((() => new $c_Lcats_effect_std_Queue$UnboundedAsyncQueue(F))));
});
$c_Lcats_effect_std_Queue$.prototype.unbounded__Lcats_effect_kernel_GenConcurrent__O = (function(F) {
  if ($is_Lcats_effect_kernel_Async(F)) {
    var f0 = $as_Lcats_effect_kernel_Async(F);
    return this.unboundedForAsync__Lcats_effect_kernel_Async__O(f0);
  } else {
    return this.boundedForConcurrent__I__Lcats_effect_kernel_GenConcurrent__O(2147483647, F);
  }
});
var $d_Lcats_effect_std_Queue$ = new $TypeData().initClass($c_Lcats_effect_std_Queue$, "cats.effect.std.Queue$", ({
  Lcats_effect_std_Queue$: 1
}));
var $n_Lcats_effect_std_Queue$;
function $m_Lcats_effect_std_Queue$() {
  if ((!$n_Lcats_effect_std_Queue$)) {
    $n_Lcats_effect_std_Queue$ = new $c_Lcats_effect_std_Queue$();
  }
  return $n_Lcats_effect_std_Queue$;
}
function $f_Lcats_effect_std_QueueSource__tryTakeN__s_Option__Lcats_Monad__O($thiz, maxN, F) {
  $m_Lcats_effect_std_QueueSource$().assertMaxNPositive__s_Option__V(maxN);
  if ((maxN instanceof $c_s_Some)) {
    var limit = $uI($n($as_s_Some(maxN)).s_Some__f_value);
    return $p_Lcats_effect_std_QueueSource__loop$4__Lcats_Monad__I__I__sci_List__O($thiz, F, 0, limit, $m_sci_Nil$());
  }
  var x = $m_s_None$();
  if ((x === maxN)) {
    return $p_Lcats_effect_std_QueueSource__loop$4__Lcats_Monad__I__I__sci_List__O($thiz, F, 0, 2147483647, $m_sci_Nil$());
  }
  throw new $c_s_MatchError(maxN);
}
function $p_Lcats_effect_std_QueueSource__loop$4__Lcats_Monad__I__I__sci_List__O($thiz, F$29, i, limit, acc) {
  if ((i >= limit)) {
    return $n(F$29).pure__O__O($n(acc).reverse__sci_List());
  } else {
    var target = $thiz.tryTake__O();
    var this$4 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F$29);
    var f = new $c_sjsr_AnonFunction1(((x$1) => {
      var x$1$1 = $as_s_Option(x$1);
      if ((x$1$1 instanceof $c_s_Some)) {
        var a = $n($as_s_Some(x$1$1)).s_Some__f_value;
        var this$3 = $n(acc);
        return $p_Lcats_effect_std_QueueSource__loop$4__Lcats_Monad__I__I__sci_List__O($thiz, F$29, ((1 + i) | 0), limit, new $c_sci_$colon$colon(a, this$3));
      }
      var x = $m_s_None$();
      if ((x === x$1$1)) {
        return $n(F$29).pure__O__O($n(acc).reverse__sci_List());
      }
      throw new $c_s_MatchError(x$1$1);
    }));
    return $n(this$4.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$4.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  }
}
/** @constructor */
function $c_Lcats_effect_std_QueueSource$() {
}
$c_Lcats_effect_std_QueueSource$.prototype = new $h_O();
$c_Lcats_effect_std_QueueSource$.prototype.constructor = $c_Lcats_effect_std_QueueSource$;
/** @constructor */
function $h_Lcats_effect_std_QueueSource$() {
}
$h_Lcats_effect_std_QueueSource$.prototype = $c_Lcats_effect_std_QueueSource$.prototype;
$c_Lcats_effect_std_QueueSource$.prototype.assertMaxNPositive__s_Option__V = (function(maxN) {
  if ((maxN instanceof $c_s_Some)) {
    var n = $uI($n($as_s_Some(maxN)).s_Some__f_value);
    if ((n <= 0)) {
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Provided maxN parameter must be positive, was " + n));
    }
  }
});
var $d_Lcats_effect_std_QueueSource$ = new $TypeData().initClass($c_Lcats_effect_std_QueueSource$, "cats.effect.std.QueueSource$", ({
  Lcats_effect_std_QueueSource$: 1
}));
var $n_Lcats_effect_std_QueueSource$;
function $m_Lcats_effect_std_QueueSource$() {
  if ((!$n_Lcats_effect_std_QueueSource$)) {
    $n_Lcats_effect_std_QueueSource$ = new $c_Lcats_effect_std_QueueSource$();
  }
  return $n_Lcats_effect_std_QueueSource$;
}
function $is_Lcats_effect_std_Random(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_std_Random)));
}
function $as_Lcats_effect_std_Random(obj) {
  return (($is_Lcats_effect_std_Random(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Random"));
}
function $isArrayOf_Lcats_effect_std_Random(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Random)));
}
function $asArrayOf_Lcats_effect_std_Random(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Random(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Random;", depth));
}
function $is_Lcats_effect_std_Supervisor(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_std_Supervisor)));
}
function $as_Lcats_effect_std_Supervisor(obj) {
  return (($is_Lcats_effect_std_Supervisor(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Supervisor"));
}
function $isArrayOf_Lcats_effect_std_Supervisor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Supervisor)));
}
function $asArrayOf_Lcats_effect_std_Supervisor(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Supervisor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Supervisor;", depth));
}
function $p_Lcats_effect_std_Supervisor$__supervisor__F1__Z__s_Option__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource($thiz, mkState, await$1, checkRestart, F) {
  var fa = $n(F).ref__O__O(false);
  var this$11 = new $c_Lcats_effect_kernel_Resource$Eval(fa);
  var f = new $c_sjsr_AnonFunction1(((doneR) => {
    var doneR$1 = $as_Lcats_effect_kernel_Ref(doneR);
    return $n($m_Lcats_effect_kernel_Resource$().makeCase__O__F2__Lcats_Functor__Lcats_effect_kernel_Resource($n(mkState).apply__O__O(doneR$1), new $c_sjsr_AnonFunction2(((x$1, x$2) => {
      var x$1$1 = $as_Lcats_effect_std_Supervisor$State(x$1);
      var x$2$1 = $as_Lcats_effect_kernel_Resource$ExitCase(x$2);
      var x = $m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$();
      if (((x === x$2$1) && await$1)) {
        var fa$1 = $n(doneR$1).set__O__O(true);
        var this$6 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$1, F);
        var fb = $n(x$1$1).joinAll__O();
        var this$7 = $n(this$6.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
        var fa$2 = this$6.Lcats_syntax_ApplySyntax$$anon$1__f_self;
        return this$7.productR__O__O__O(fa$2, fb);
      } else {
        var fa$3 = $n(doneR$1).set__O__O(true);
        var this$9 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$3, F);
        var fb$1 = $n(x$1$1).cancelAll__O();
        var this$10 = $n(this$9.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
        var fa$4 = this$9.Lcats_syntax_ApplySyntax$$anon$1__f_self;
        return this$10.productR__O__O__O(fa$4, fb$1);
      }
    })), F)).map__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1(((state) => {
      var state$1 = $as_Lcats_effect_std_Supervisor$State(state);
      return new $c_Lcats_effect_std_Supervisor$$anon$1(checkRestart, F, doneR$1, state$1);
    })));
  }));
  return new $c_Lcats_effect_kernel_Resource$Bind(this$11, f);
}
function $p_Lcats_effect_std_Supervisor$__mkState$3__Lcats_effect_kernel_Async__Lcats_effect_kernel_Ref__O($thiz, F$15, doneR) {
  return $n(F$15).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
    var state = $ct_ju_concurrent_ConcurrentHashMap__(new $c_ju_concurrent_ConcurrentHashMap());
    return new $c_Lcats_effect_std_Supervisor$$anon$4(F$15, doneR, state);
  })));
}
/** @constructor */
function $c_Lcats_effect_std_Supervisor$() {
}
$c_Lcats_effect_std_Supervisor$.prototype = new $h_O();
$c_Lcats_effect_std_Supervisor$.prototype.constructor = $c_Lcats_effect_std_Supervisor$;
/** @constructor */
function $h_Lcats_effect_std_Supervisor$() {
}
$h_Lcats_effect_std_Supervisor$.prototype = $c_Lcats_effect_std_Supervisor$.prototype;
$c_Lcats_effect_std_Supervisor$.prototype.apply__Z__s_Option__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource = (function(await$1, checkRestart, F) {
  if ($is_Lcats_effect_kernel_Async(F)) {
    var asyncF = $as_Lcats_effect_kernel_Async(F);
    return this.applyForAsync__Z__s_Option__Lcats_effect_kernel_Async__Lcats_effect_kernel_Resource(await$1, checkRestart, asyncF);
  } else {
    return this.applyForConcurrent__Z__s_Option__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(await$1, checkRestart, F);
  }
});
$c_Lcats_effect_std_Supervisor$.prototype.applyForConcurrent__Z__s_Option__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource = (function(await$1, checkRestart, F) {
  var target = $n(F).ref__O__O($m_sci_Map$EmptyMap$());
  var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, F);
  var f = new $c_sjsr_AnonFunction1(((stateRef) => {
    var stateRef$1 = $as_Lcats_effect_kernel_Ref(stateRef);
    return new $c_Lcats_effect_std_Supervisor$$anon$3(F, stateRef$1);
  }));
  var mkState = $n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  return $p_Lcats_effect_std_Supervisor$__supervisor__F1__Z__s_Option__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(this, new $c_sjsr_AnonFunction1(((_$17) => {
    $as_Lcats_effect_kernel_Ref(_$17);
    return mkState;
  })), await$1, checkRestart, F);
});
$c_Lcats_effect_std_Supervisor$.prototype.applyForAsync__Z__s_Option__Lcats_effect_kernel_Async__Lcats_effect_kernel_Resource = (function(await$1, checkRestart, F) {
  return $p_Lcats_effect_std_Supervisor$__supervisor__F1__Z__s_Option__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(this, new $c_sjsr_AnonFunction1(((doneR) => {
    var doneR$1 = $as_Lcats_effect_kernel_Ref(doneR);
    return $p_Lcats_effect_std_Supervisor$__mkState$3__Lcats_effect_kernel_Async__Lcats_effect_kernel_Ref__O(this, F, doneR$1);
  })), await$1, checkRestart, F);
});
var $d_Lcats_effect_std_Supervisor$ = new $TypeData().initClass($c_Lcats_effect_std_Supervisor$, "cats.effect.std.Supervisor$", ({
  Lcats_effect_std_Supervisor$: 1
}));
var $n_Lcats_effect_std_Supervisor$;
function $m_Lcats_effect_std_Supervisor$() {
  if ((!$n_Lcats_effect_std_Supervisor$)) {
    $n_Lcats_effect_std_Supervisor$ = new $c_Lcats_effect_std_Supervisor$();
  }
  return $n_Lcats_effect_std_Supervisor$;
}
/** @constructor */
function $c_Lcats_effect_std_Supervisor$State() {
}
$c_Lcats_effect_std_Supervisor$State.prototype = new $h_O();
$c_Lcats_effect_std_Supervisor$State.prototype.constructor = $c_Lcats_effect_std_Supervisor$State;
/** @constructor */
function $h_Lcats_effect_std_Supervisor$State() {
}
$h_Lcats_effect_std_Supervisor$State.prototype = $c_Lcats_effect_std_Supervisor$State.prototype;
function $as_Lcats_effect_std_Supervisor$State(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Supervisor$State) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Supervisor$State"));
}
function $isArrayOf_Lcats_effect_std_Supervisor$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Supervisor$State)));
}
function $asArrayOf_Lcats_effect_std_Supervisor$State(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Supervisor$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Supervisor$State;", depth));
}
/** @constructor */
function $c_Lcats_effect_std_UnsafeUnbounded() {
  this.Lcats_effect_std_UnsafeUnbounded__f_first = null;
  this.Lcats_effect_std_UnsafeUnbounded__f_last = null;
  this.Lcats_effect_std_UnsafeUnbounded__f_FailureSignal = null;
  this.Lcats_effect_std_UnsafeUnbounded__f_first = $ct_ju_concurrent_atomic_AtomicReference__(new $c_ju_concurrent_atomic_AtomicReference());
  this.Lcats_effect_std_UnsafeUnbounded__f_last = $ct_ju_concurrent_atomic_AtomicReference__(new $c_ju_concurrent_atomic_AtomicReference());
  this.Lcats_effect_std_UnsafeUnbounded__f_FailureSignal = $m_Lcats_effect_std_FailureSignal$();
}
$c_Lcats_effect_std_UnsafeUnbounded.prototype = new $h_O();
$c_Lcats_effect_std_UnsafeUnbounded.prototype.constructor = $c_Lcats_effect_std_UnsafeUnbounded;
/** @constructor */
function $h_Lcats_effect_std_UnsafeUnbounded() {
}
$h_Lcats_effect_std_UnsafeUnbounded.prototype = $c_Lcats_effect_std_UnsafeUnbounded.prototype;
$c_Lcats_effect_std_UnsafeUnbounded.prototype.size__I = (function() {
  var current = $as_Lcats_effect_std_UnsafeUnbounded$Cell($n(this.Lcats_effect_std_UnsafeUnbounded__f_first).ju_concurrent_atomic_AtomicReference__f_value);
  var count = 0;
  while ((current !== null)) {
    count = ((1 + count) | 0);
    current = $as_Lcats_effect_std_UnsafeUnbounded$Cell($n(current).ju_concurrent_atomic_AtomicReference__f_value);
  }
  return count;
});
$c_Lcats_effect_std_UnsafeUnbounded.prototype.put__O__F0 = (function(data) {
  var cell = new $c_Lcats_effect_std_UnsafeUnbounded$Cell(data);
  var prevLast = $as_Lcats_effect_std_UnsafeUnbounded$Cell($n(this.Lcats_effect_std_UnsafeUnbounded__f_last).getAndSet__O__O(cell));
  if ((prevLast === null)) {
    $n(this.Lcats_effect_std_UnsafeUnbounded__f_first).ju_concurrent_atomic_AtomicReference__f_value = cell;
  } else {
    $n(prevLast).ju_concurrent_atomic_AtomicReference__f_value = cell;
  }
  return cell;
});
$c_Lcats_effect_std_UnsafeUnbounded.prototype.take__O = (function() {
  while (true) {
    var taken = $as_Lcats_effect_std_UnsafeUnbounded$Cell($n(this.Lcats_effect_std_UnsafeUnbounded__f_first).ju_concurrent_atomic_AtomicReference__f_value);
    if ((taken !== null)) {
      var next = $as_Lcats_effect_std_UnsafeUnbounded$Cell($n(taken).ju_concurrent_atomic_AtomicReference__f_value);
      if ($n(this.Lcats_effect_std_UnsafeUnbounded__f_first).compareAndSet__O__O__Z(taken, next)) {
        if (((next === null) && (!$n(this.Lcats_effect_std_UnsafeUnbounded__f_last).compareAndSet__O__O__Z(taken, null)))) {
          var next2 = $as_Lcats_effect_std_UnsafeUnbounded$Cell($n(taken).ju_concurrent_atomic_AtomicReference__f_value);
          while ((next2 === null)) {
            next2 = $as_Lcats_effect_std_UnsafeUnbounded$Cell($n(taken).ju_concurrent_atomic_AtomicReference__f_value);
          }
          $n(this.Lcats_effect_std_UnsafeUnbounded__f_first).ju_concurrent_atomic_AtomicReference__f_value = next2;
        }
        var ret = $n(taken).Lcats_effect_std_UnsafeUnbounded$Cell__f__data;
        $n(taken).apply__V();
        return ret;
      }
    } else if (($n(this.Lcats_effect_std_UnsafeUnbounded__f_last).ju_concurrent_atomic_AtomicReference__f_value !== null)) {
    } else {
      var x = this.Lcats_effect_std_UnsafeUnbounded__f_FailureSignal;
      throw ((x === null) ? $n(null) : x);
    }
  }
});
var $d_Lcats_effect_std_UnsafeUnbounded = new $TypeData().initClass($c_Lcats_effect_std_UnsafeUnbounded, "cats.effect.std.UnsafeUnbounded", ({
  Lcats_effect_std_UnsafeUnbounded: 1
}));
/** @constructor */
function $c_Lcats_effect_tracing_RingBuffer(logSize) {
  this.Lcats_effect_tracing_RingBuffer__f_length = 0;
  this.Lcats_effect_tracing_RingBuffer__f_mask = 0;
  this.Lcats_effect_tracing_RingBuffer__f_buffer = null;
  this.Lcats_effect_tracing_RingBuffer__f_index = 0;
  this.Lcats_effect_tracing_RingBuffer__f_length = (1 << logSize);
  this.Lcats_effect_tracing_RingBuffer__f_mask = (((-1) + this.Lcats_effect_tracing_RingBuffer__f_length) | 0);
  var dimensions = new $ac_I(new Int32Array([this.Lcats_effect_tracing_RingBuffer__f_length]));
  this.Lcats_effect_tracing_RingBuffer__f_buffer = $asArrayOf_Lcats_effect_tracing_TracingEvent($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Lcats_effect_tracing_TracingEvent.getClassOf(), dimensions), 1);
  this.Lcats_effect_tracing_RingBuffer__f_index = 0;
}
$c_Lcats_effect_tracing_RingBuffer.prototype = new $h_O();
$c_Lcats_effect_tracing_RingBuffer.prototype.constructor = $c_Lcats_effect_tracing_RingBuffer;
/** @constructor */
function $h_Lcats_effect_tracing_RingBuffer() {
}
$h_Lcats_effect_tracing_RingBuffer.prototype = $c_Lcats_effect_tracing_RingBuffer.prototype;
$c_Lcats_effect_tracing_RingBuffer.prototype.push__Lcats_effect_tracing_TracingEvent__V = (function(te) {
  var idx = (this.Lcats_effect_tracing_RingBuffer__f_index & this.Lcats_effect_tracing_RingBuffer__f_mask);
  $n(this.Lcats_effect_tracing_RingBuffer__f_buffer).set(idx, te);
  this.Lcats_effect_tracing_RingBuffer__f_index = ((1 + this.Lcats_effect_tracing_RingBuffer__f_index) | 0);
});
$c_Lcats_effect_tracing_RingBuffer.prototype.toList__sci_List = (function() {
  var result = $m_sci_Nil$();
  var buf = this.Lcats_effect_tracing_RingBuffer__f_buffer;
  if ((buf !== null)) {
    var msk = this.Lcats_effect_tracing_RingBuffer__f_mask;
    var idx = this.Lcats_effect_tracing_RingBuffer__f_index;
    var x = ((idx - this.Lcats_effect_tracing_RingBuffer__f_length) | 0);
    var start = ((x > 0) ? x : 0);
    var i = start;
    while ((i < idx)) {
      var this$4 = $n(result);
      var elem = $n(buf).get((i & msk));
      result = new $c_sci_$colon$colon(elem, this$4);
      i = ((1 + i) | 0);
    }
  }
  return result;
});
$c_Lcats_effect_tracing_RingBuffer.prototype.invalidate__V = (function() {
  this.Lcats_effect_tracing_RingBuffer__f_index = 0;
  this.Lcats_effect_tracing_RingBuffer__f_buffer = null;
});
var $d_Lcats_effect_tracing_RingBuffer = new $TypeData().initClass($c_Lcats_effect_tracing_RingBuffer, "cats.effect.tracing.RingBuffer", ({
  Lcats_effect_tracing_RingBuffer: 1
}));
/** @constructor */
function $c_Lcats_effect_tracing_TracingConstants$() {
  this.Lcats_effect_tracing_TracingConstants$__f_isCachedStackTracing = false;
  this.Lcats_effect_tracing_TracingConstants$__f_isFullStackTracing = false;
  this.Lcats_effect_tracing_TracingConstants$__f_isStackTracing = false;
  $n_Lcats_effect_tracing_TracingConstants$ = this;
  var this$1 = $n($m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_TRACING_MODE"));
  if (this$1.isEmpty__Z()) {
    var $x_1 = true;
  } else {
    var arg1 = this$1.get__O();
    var _$1 = $as_T(arg1);
    var this$2 = $n(_$1);
    var $x_1 = (!(this$2 === ""));
  }
  var this$3 = $n(($x_1 ? this$1 : $m_s_None$()));
  if (this$3.isEmpty__Z()) {
    if ((($as_T((typeof process)) !== "undefined") && ($as_T((typeof process.release)) !== "undefined"))) {
      var x = process.release.name;
      var $x_3 = $m_sr_BoxesRunTime$().equals__O__O__Z(x, "node");
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var $x_2 = "cached";
    } else {
      var $x_2 = "none";
    }
  } else {
    var $x_2 = this$3.get__O();
  }
  var stackTracingMode = $as_T($x_2);
  var this$4 = $n(stackTracingMode);
  _return: {
    var len = this$4.length;
    if ((len === 6)) {
      var i = 0;
      while ((i !== len)) {
        var index = i;
        var c = $charAt(this$4, index);
        var $x_5 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c));
        var index$1 = i;
        var c$1 = $charAt("cached", index$1);
        if (($x_5 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$1)))) {
          var $x_4 = false;
          break _return;
        }
        i = ((1 + i) | 0);
      }
      var $x_4 = true;
    } else {
      var $x_4 = false;
    }
  }
  this.Lcats_effect_tracing_TracingConstants$__f_isCachedStackTracing = $x_4;
  var this$5 = $n(stackTracingMode);
  _return$1: {
    var len$1 = this$5.length;
    if ((len$1 === 4)) {
      var i$1 = 0;
      while ((i$1 !== len$1)) {
        var index$2 = i$1;
        var c$2 = $charAt(this$5, index$2);
        var $x_7 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$2));
        var index$3 = i$1;
        var c$3 = $charAt("full", index$3);
        if (($x_7 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$3)))) {
          var $x_6 = false;
          break _return$1;
        }
        i$1 = ((1 + i$1) | 0);
      }
      var $x_6 = true;
    } else {
      var $x_6 = false;
    }
  }
  this.Lcats_effect_tracing_TracingConstants$__f_isFullStackTracing = $x_6;
  this.Lcats_effect_tracing_TracingConstants$__f_isStackTracing = (this.Lcats_effect_tracing_TracingConstants$__f_isFullStackTracing || this.Lcats_effect_tracing_TracingConstants$__f_isCachedStackTracing);
}
$c_Lcats_effect_tracing_TracingConstants$.prototype = new $h_O();
$c_Lcats_effect_tracing_TracingConstants$.prototype.constructor = $c_Lcats_effect_tracing_TracingConstants$;
/** @constructor */
function $h_Lcats_effect_tracing_TracingConstants$() {
}
$h_Lcats_effect_tracing_TracingConstants$.prototype = $c_Lcats_effect_tracing_TracingConstants$.prototype;
var $d_Lcats_effect_tracing_TracingConstants$ = new $TypeData().initClass($c_Lcats_effect_tracing_TracingConstants$, "cats.effect.tracing.TracingConstants$", ({
  Lcats_effect_tracing_TracingConstants$: 1
}));
var $n_Lcats_effect_tracing_TracingConstants$;
function $m_Lcats_effect_tracing_TracingConstants$() {
  if ((!$n_Lcats_effect_tracing_TracingConstants$)) {
    $n_Lcats_effect_tracing_TracingConstants$ = new $c_Lcats_effect_tracing_TracingConstants$();
  }
  return $n_Lcats_effect_tracing_TracingConstants$;
}
function $ct_Lcats_effect_tracing_TracingPlatform__($thiz) {
  var this$1 = $n($as_scm_Map($m_scm_Map$().empty__O()));
  $thiz.Lcats_effect_tracing_TracingPlatform__f_cache = $f_scm_Map__withDefaultValue__O__scm_Map(this$1, null);
  $thiz.Lcats_effect_tracing_TracingPlatform__f_function0Property = $as_T(Object.getOwnPropertyNames(new $c_sjsr_AnonFunction0((() => (void 0))))[0]);
  $thiz.Lcats_effect_tracing_TracingPlatform__f_function1Property = $as_T(Object.getOwnPropertyNames(new $c_sjsr_AnonFunction1(((_$1) => {
    $as_jl_Void(_$1);
  })))[0]);
  $thiz.Lcats_effect_tracing_TracingPlatform__f_calculateTracingEvent = ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isCachedStackTracing ? new $c_sjsr_AnonFunction1(((key) => {
    var current = $as_Lcats_effect_tracing_TracingEvent($n($thiz.Lcats_effect_tracing_TracingPlatform__f_cache).apply__O__O(key));
    if ((current === null)) {
      $n($as_Lcats_effect_tracing_Tracing$($thiz));
      var event = new $c_Lcats_effect_tracing_TracingEvent$StackTrace();
      $n($thiz.Lcats_effect_tracing_TracingPlatform__f_cache).update__O__O__V(key, event);
      return event;
    } else {
      return current;
    }
  })) : ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isFullStackTracing ? new $c_sjsr_AnonFunction1(((_$3) => {
    $n($as_Lcats_effect_tracing_Tracing$($thiz));
    return new $c_Lcats_effect_tracing_TracingEvent$StackTrace();
  })) : new $c_sjsr_AnonFunction1(((_$4) => null))));
  $thiz.Lcats_effect_tracing_TracingPlatform__f_stackTraceFileNameFilter = new ($d_T.getArrayOf().constr)(["githubusercontent.com/typelevel/cats-effect/", "githubusercontent.com/typelevel/cats/", "githubusercontent.com/scala-js/", "githubusercontent.com/scala/"]);
  $thiz.Lcats_effect_tracing_TracingPlatform__f_stackTraceMethodNameFilter = new ($d_T.getArrayOf().constr)(["_Lcats_effect_", "_jl_", "_Lorg_scalajs_"]);
  return $thiz;
}
function $p_Lcats_effect_tracing_TracingPlatform__isInternalFile__T__Z($thiz, fileName) {
  var i = 0;
  var len = $n($thiz.Lcats_effect_tracing_TracingPlatform__f_stackTraceFileNameFilter).u.length;
  while ((i < len)) {
    var this$1 = $n(fileName);
    var s = $n($thiz.Lcats_effect_tracing_TracingPlatform__f_stackTraceFileNameFilter).get(i);
    var this$2 = $n(s);
    if (($uI(this$1.indexOf(this$2)) !== (-1))) {
      return true;
    }
    i = ((1 + i) | 0);
  }
  return false;
}
function $p_Lcats_effect_tracing_TracingPlatform__isInternalMethod__T__Z($thiz, methodName) {
  var i = 0;
  var len = $n($thiz.Lcats_effect_tracing_TracingPlatform__f_stackTraceMethodNameFilter).u.length;
  while ((i < len)) {
    var this$1 = $n(methodName);
    var s = $n($thiz.Lcats_effect_tracing_TracingPlatform__f_stackTraceMethodNameFilter).get(i);
    var this$2 = $n(s);
    if (($uI(this$1.indexOf(this$2)) !== (-1))) {
      return true;
    }
    i = ((1 + i) | 0);
  }
  return false;
}
function $p_Lcats_effect_tracing_TracingPlatform__isInternalScalaFile$1__T__Z($thiz, callSiteFileName$1) {
  return (((callSiteFileName$1 !== null) && (!$f_T__endsWith__T__Z($n(callSiteFileName$1), ".js"))) && $p_Lcats_effect_tracing_TracingPlatform__isInternalFile__T__Z($thiz, callSiteFileName$1));
}
function $p_Lcats_effect_tracing_TracingPlatform__isInternalJSCode$1__T__T__T__Z($thiz, callSiteClassName$1, callSiteMethodName$1, callSiteFileName$2) {
  return ((callSiteClassName$1 === "<jscode>") && ($p_Lcats_effect_tracing_TracingPlatform__isInternalScalaFile$1__T__Z($thiz, callSiteFileName$2) || $p_Lcats_effect_tracing_TracingPlatform__isInternalMethod__T__Z($thiz, callSiteMethodName$1)));
}
/** @constructor */
function $c_Lcats_effect_tracing_TracingPlatform() {
  this.Lcats_effect_tracing_TracingPlatform__f_cache = null;
  this.Lcats_effect_tracing_TracingPlatform__f_function0Property = null;
  this.Lcats_effect_tracing_TracingPlatform__f_function1Property = null;
  this.Lcats_effect_tracing_TracingPlatform__f_calculateTracingEvent = null;
  this.Lcats_effect_tracing_TracingPlatform__f_stackTraceFileNameFilter = null;
  this.Lcats_effect_tracing_TracingPlatform__f_stackTraceMethodNameFilter = null;
}
$c_Lcats_effect_tracing_TracingPlatform.prototype = new $h_O();
$c_Lcats_effect_tracing_TracingPlatform.prototype.constructor = $c_Lcats_effect_tracing_TracingPlatform;
/** @constructor */
function $h_Lcats_effect_tracing_TracingPlatform() {
}
$h_Lcats_effect_tracing_TracingPlatform.prototype = $c_Lcats_effect_tracing_TracingPlatform.prototype;
$c_Lcats_effect_tracing_TracingPlatform.prototype.calculateTracingEvent__F0__Lcats_effect_tracing_TracingEvent = (function(f) {
  return $as_Lcats_effect_tracing_TracingEvent($n(this.Lcats_effect_tracing_TracingPlatform__f_calculateTracingEvent).apply__O__O($dp_toString__T($n(f[this.Lcats_effect_tracing_TracingPlatform__f_function0Property]))));
});
$c_Lcats_effect_tracing_TracingPlatform.prototype.calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent = (function(f) {
  return $as_Lcats_effect_tracing_TracingEvent($n(this.Lcats_effect_tracing_TracingPlatform__f_calculateTracingEvent).apply__O__O($dp_toString__T($n(f[this.Lcats_effect_tracing_TracingPlatform__f_function1Property]))));
});
$c_Lcats_effect_tracing_TracingPlatform.prototype.calculateTracingEvent__Lcats_effect_kernel_Cont__Lcats_effect_tracing_TracingEvent = (function(cont) {
  var $x_1 = this.Lcats_effect_tracing_TracingPlatform__f_calculateTracingEvent;
  var this$1 = $n(cont);
  return $as_Lcats_effect_tracing_TracingEvent($n($x_1).apply__O__O($objectGetClass(this$1)));
});
$c_Lcats_effect_tracing_TracingPlatform.prototype.applyStackTraceFilter__T__T__T__Z = (function(callSiteClassName, callSiteMethodName, callSiteFileName) {
  return ($p_Lcats_effect_tracing_TracingPlatform__isInternalJSCode$1__T__T__T__Z(this, callSiteClassName, callSiteMethodName, callSiteFileName) || $n($as_Lcats_effect_tracing_Tracing$(this)).isInternalClass__T__Z(callSiteClassName));
});
$c_Lcats_effect_tracing_TracingPlatform.prototype.decodeMethodName__T__T = (function(name) {
  var this$1 = $n(name);
  var junk = $uI(this$1.indexOf("__"));
  var $x_2 = $m_s_reflect_NameTransformer$();
  if ((junk === (-1))) {
    var $x_1 = name;
  } else {
    var this$2 = $n(name);
    if ((junk > this$2.length)) {
      $charAt(this$2, junk);
    }
    if ((junk < 0)) {
      $charAt(this$2, (-1));
    }
    var $x_1 = $as_T(this$2.substring(0, junk));
  }
  return $n($x_2).decode__T__T($x_1);
});
/** @constructor */
function $c_Lcats_effect_unsafe_FiberMonitor$() {
}
$c_Lcats_effect_unsafe_FiberMonitor$.prototype = new $h_O();
$c_Lcats_effect_unsafe_FiberMonitor$.prototype.constructor = $c_Lcats_effect_unsafe_FiberMonitor$;
/** @constructor */
function $h_Lcats_effect_unsafe_FiberMonitor$() {
}
$h_Lcats_effect_unsafe_FiberMonitor$.prototype = $c_Lcats_effect_unsafe_FiberMonitor$.prototype;
$c_Lcats_effect_unsafe_FiberMonitor$.prototype.apply__s_concurrent_ExecutionContext__Lcats_effect_unsafe_FiberMonitor = (function(compute) {
  if (this.weakRefsAvailable__Z()) {
    if ((compute instanceof $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor)) {
      var bmec = $as_Lcats_effect_unsafe_BatchingMacrotaskExecutor(compute);
      return new $c_Lcats_effect_unsafe_ES2021FiberMonitor(bmec);
    } else {
      return new $c_Lcats_effect_unsafe_ES2021FiberMonitor(null);
    }
  } else {
    return new $c_Lcats_effect_unsafe_NoOpFiberMonitor();
  }
});
$c_Lcats_effect_unsafe_FiberMonitor$.prototype.weakRefsAvailable__Z = (function() {
  return (($as_T((typeof WeakRef)) !== "undefined") && ($as_T((typeof FinalizationRegistry)) !== "undefined"));
});
var $d_Lcats_effect_unsafe_FiberMonitor$ = new $TypeData().initClass($c_Lcats_effect_unsafe_FiberMonitor$, "cats.effect.unsafe.FiberMonitor$", ({
  Lcats_effect_unsafe_FiberMonitor$: 1
}));
var $n_Lcats_effect_unsafe_FiberMonitor$;
function $m_Lcats_effect_unsafe_FiberMonitor$() {
  if ((!$n_Lcats_effect_unsafe_FiberMonitor$)) {
    $n_Lcats_effect_unsafe_FiberMonitor$ = new $c_Lcats_effect_unsafe_FiberMonitor$();
  }
  return $n_Lcats_effect_unsafe_FiberMonitor$;
}
function $ct_Lcats_effect_unsafe_FiberMonitorShared__($thiz) {
  $thiz.Lcats_effect_unsafe_FiberMonitorShared__f_newline = "\n";
  $thiz.Lcats_effect_unsafe_FiberMonitorShared__f_doubleNewline = (($thiz.Lcats_effect_unsafe_FiberMonitorShared__f_newline + " ") + $thiz.Lcats_effect_unsafe_FiberMonitorShared__f_newline);
  return $thiz;
}
/** @constructor */
function $c_Lcats_effect_unsafe_FiberMonitorShared() {
  this.Lcats_effect_unsafe_FiberMonitorShared__f_newline = null;
  this.Lcats_effect_unsafe_FiberMonitorShared__f_doubleNewline = null;
}
$c_Lcats_effect_unsafe_FiberMonitorShared.prototype = new $h_O();
$c_Lcats_effect_unsafe_FiberMonitorShared.prototype.constructor = $c_Lcats_effect_unsafe_FiberMonitorShared;
/** @constructor */
function $h_Lcats_effect_unsafe_FiberMonitorShared() {
}
$h_Lcats_effect_unsafe_FiberMonitorShared.prototype = $c_Lcats_effect_unsafe_FiberMonitorShared.prototype;
$c_Lcats_effect_unsafe_FiberMonitorShared.prototype.fiberString__Lcats_effect_IOFiber__Lcats_effect_Trace__T__T = (function(fiber, trace, status) {
  var x = $systemIdentityHashCode(fiber);
  var id = $as_T($uD((x >>> 0.0)).toString(16));
  var prefixedTrace = ($n($n(trace).Lcats_effect_Trace__f_frames).isEmpty__Z() ? "" : (("" + this.Lcats_effect_unsafe_FiberMonitorShared__f_newline) + $m_Lcats_effect_tracing_Tracing$().prettyPrint__Lcats_effect_Trace__T(trace)));
  return (((("cats.effect.IOFiber@" + id) + " ") + status) + prefixedTrace);
});
$c_Lcats_effect_unsafe_FiberMonitorShared.prototype.printFibers__sci_Map__T__F1__V = (function(fibers, status, print) {
  $n(fibers).foreach__F1__V(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    matchResult1: {
      if ((x$1$1 !== null)) {
        var fiber = $as_Lcats_effect_IOFiber($n(x$1$1)._1__O());
        var trace = $as_Lcats_effect_Trace($n(x$1$1)._2__O());
        $n(print).apply__O__O(this.Lcats_effect_unsafe_FiberMonitorShared__f_doubleNewline);
        $n(print).apply__O__O(this.fiberString__Lcats_effect_IOFiber__Lcats_effect_Trace__T__T(fiber, trace, status));
        break matchResult1;
      }
      throw new $c_s_MatchError(x$1$1);
    }
  })));
});
/** @constructor */
function $c_Lcats_effect_unsafe_IORuntime(compute, blocking, scheduler, fiberMonitor, shutdown, config) {
  this.Lcats_effect_unsafe_IORuntime__f_compute = null;
  this.Lcats_effect_unsafe_IORuntime__f_blocking = null;
  this.Lcats_effect_unsafe_IORuntime__f_scheduler = null;
  this.Lcats_effect_unsafe_IORuntime__f_fiberMonitor = null;
  this.Lcats_effect_unsafe_IORuntime__f_shutdown = null;
  this.Lcats_effect_unsafe_IORuntime__f_config = null;
  this.Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs = null;
  this.Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold = 0;
  this.Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold = 0;
  this.Lcats_effect_unsafe_IORuntime__f_enhancedExceptions = false;
  this.Lcats_effect_unsafe_IORuntime__f_traceBufferLogSize = 0;
  this.Lcats_effect_unsafe_IORuntime__f_compute = compute;
  this.Lcats_effect_unsafe_IORuntime__f_blocking = blocking;
  this.Lcats_effect_unsafe_IORuntime__f_scheduler = scheduler;
  this.Lcats_effect_unsafe_IORuntime__f_fiberMonitor = fiberMonitor;
  this.Lcats_effect_unsafe_IORuntime__f_shutdown = shutdown;
  this.Lcats_effect_unsafe_IORuntime__f_config = config;
  this.Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs = new $c_Lcats_effect_unsafe_StripedHashtable();
  this.Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold = $n(config).Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold;
  this.Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold = $n(config).Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold;
  this.Lcats_effect_unsafe_IORuntime__f_enhancedExceptions = $n(config).Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions;
  this.Lcats_effect_unsafe_IORuntime__f_traceBufferLogSize = $n(config).Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferLogSize;
}
$c_Lcats_effect_unsafe_IORuntime.prototype = new $h_O();
$c_Lcats_effect_unsafe_IORuntime.prototype.constructor = $c_Lcats_effect_unsafe_IORuntime;
/** @constructor */
function $h_Lcats_effect_unsafe_IORuntime() {
}
$h_Lcats_effect_unsafe_IORuntime.prototype = $c_Lcats_effect_unsafe_IORuntime.prototype;
$c_Lcats_effect_unsafe_IORuntime.prototype.toString__T = (function() {
  return (((((("IORuntime(" + this.Lcats_effect_unsafe_IORuntime__f_compute) + ", ") + this.Lcats_effect_unsafe_IORuntime__f_scheduler) + ", ") + this.Lcats_effect_unsafe_IORuntime__f_config) + ")");
});
function $as_Lcats_effect_unsafe_IORuntime(obj) {
  return (((obj instanceof $c_Lcats_effect_unsafe_IORuntime) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.IORuntime"));
}
function $isArrayOf_Lcats_effect_unsafe_IORuntime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_IORuntime)));
}
function $asArrayOf_Lcats_effect_unsafe_IORuntime(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_IORuntime(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.IORuntime;", depth));
}
var $d_Lcats_effect_unsafe_IORuntime = new $TypeData().initClass($c_Lcats_effect_unsafe_IORuntime, "cats.effect.unsafe.IORuntime", ({
  Lcats_effect_unsafe_IORuntime: 1
}));
function $ct_Lcats_effect_unsafe_IORuntimeCompanionPlatform__($thiz) {
  $thiz.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global = null;
  return $thiz;
}
/** @constructor */
function $c_Lcats_effect_unsafe_IORuntimeCompanionPlatform() {
  this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global = null;
}
$c_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype = new $h_O();
$c_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype.constructor = $c_Lcats_effect_unsafe_IORuntimeCompanionPlatform;
/** @constructor */
function $h_Lcats_effect_unsafe_IORuntimeCompanionPlatform() {
}
$h_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype = $c_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype;
$c_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype.createBatchingMacrotaskExecutor$default$2__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((_$1) => {
    var _$1$1 = $as_jl_Throwable(_$1);
    var this$1 = $n(_$1$1);
    this$1.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err);
  }));
});
$c_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype.resetGlobal__V = (function() {
  this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global = null;
});
$c_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype.global__Lcats_effect_unsafe_IORuntime = (function() {
  if ((this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global === null)) {
    if ((this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global === null)) {
      var $x_5 = $m_Lcats_effect_unsafe_IORuntime$();
      var reportFailure = this.createBatchingMacrotaskExecutor$default$2__F1();
      var $x_4 = new $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor(64, reportFailure);
      var reportFailure$1 = this.createBatchingMacrotaskExecutor$default$2__F1();
      var $x_3 = new $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor(64, reportFailure$1);
      var $x_2 = $as_Lcats_effect_unsafe_Scheduler($n($m_Lcats_effect_unsafe_Scheduler$().createDefaultScheduler__T2())._1__O());
      var $x_1 = new $c_sjsr_AnonFunction0((() => {
        this.resetGlobal__V();
      }));
      var this$2 = $m_Lcats_effect_unsafe_IORuntimeConfig$();
      this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global = $n($x_5).apply__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__F0__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_IORuntime($x_4, $x_3, $x_2, $x_1, this$2.Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__f_Default);
    }
  }
  return this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global;
});
$c_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype.registerFiberMonitorMBean__Lcats_effect_unsafe_FiberMonitor__F0 = (function(fiberMonitor) {
  return new $c_sjsr_AnonFunction0((() => (void 0)));
});
function $ct_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__($thiz) {
  var this$1 = $n($m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_CANCELATION_CHECK_THRESHOLD"));
  if (this$1.isEmpty__Z()) {
    var $x_1 = $m_s_None$();
  } else {
    var arg1 = this$1.get__O();
    var x = $as_T(arg1);
    try {
      var this$5 = $m_jl_Integer$();
      var r1 = this$5.parseInt__T__I__I(x, 10);
      var $x_2 = new $c_s_util_Success(r1);
    } catch (e) {
      var $x_2;
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        var $x_2 = new $c_s_util_Failure(e$2);
      } else {
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2));
      }
    }
    var $x_1 = $n($x_2).toOption__s_Option();
  }
  var this$6 = $n($x_1);
  var cancelationCheckThreshold = $uI((this$6.isEmpty__Z() ? 512 : this$6.get__O()));
  var this$7 = $n($m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_AUTO_YIELD_THRESHOLD_MULTIPLIER"));
  if (this$7.isEmpty__Z()) {
    var $x_3 = $m_s_None$();
  } else {
    var arg1$1 = this$7.get__O();
    var x$1 = $as_T(arg1$1);
    try {
      var this$11 = $m_jl_Integer$();
      var r1$1 = this$11.parseInt__T__I__I(x$1, 10);
      var $x_4 = new $c_s_util_Success(r1$1);
    } catch (e$1) {
      var $x_4;
      var e$2$1 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$1)) {
        var $x_4 = new $c_s_util_Failure(e$2$1);
      } else {
        throw ((e$2$1 instanceof $c_sjs_js_JavaScriptException) ? e$2$1.sjs_js_JavaScriptException__f_exception : $n(e$2$1));
      }
    }
    var $x_3 = $n($x_4).toOption__s_Option();
  }
  var this$12 = $n($x_3);
  var autoYieldThreshold = Math.imul($uI((this$12.isEmpty__Z() ? 2 : this$12.get__O())), cancelationCheckThreshold);
  var this$13 = $n($m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_TRACING_EXCEPTIONS_ENHANCED"));
  if (this$13.isEmpty__Z()) {
    var $x_5 = $m_s_None$();
  } else {
    var arg1$2 = this$13.get__O();
    var x$2 = $as_T(arg1$2);
    try {
      var r1$2 = $m_sc_StringOps$().toBooleanImpl$extension__T__T__Z(x$2, x$2);
      var $x_6 = new $c_s_util_Success(r1$2);
    } catch (e$3) {
      var $x_6;
      var e$2$2 = ((e$3 instanceof $c_jl_Throwable) ? e$3 : new $c_sjs_js_JavaScriptException(e$3));
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$2)) {
        var $x_6 = new $c_s_util_Failure(e$2$2);
      } else {
        throw ((e$2$2 instanceof $c_sjs_js_JavaScriptException) ? e$2$2.sjs_js_JavaScriptException__f_exception : $n(e$2$2));
      }
    }
    var $x_5 = $n($x_6).toOption__s_Option();
  }
  var this$17 = $n($x_5);
  var enhancedExceptions = $uZ((this$17.isEmpty__Z() ? ($n($as_Lcats_effect_unsafe_IORuntimeConfig$($thiz)), true) : this$17.get__O()));
  var this$18 = $n($m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_TRACING_BUFFER_SIZE"));
  if (this$18.isEmpty__Z()) {
    var $x_7 = $m_s_None$();
  } else {
    var arg1$3 = this$18.get__O();
    var x$3 = $as_T(arg1$3);
    try {
      var this$22 = $m_jl_Integer$();
      var r1$3 = this$22.parseInt__T__I__I(x$3, 10);
      var $x_8 = new $c_s_util_Success(r1$3);
    } catch (e$4) {
      var $x_8;
      var e$2$3 = ((e$4 instanceof $c_jl_Throwable) ? e$4 : new $c_sjs_js_JavaScriptException(e$4));
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$3)) {
        var $x_8 = new $c_s_util_Failure(e$2$3);
      } else {
        throw ((e$2$3 instanceof $c_sjs_js_JavaScriptException) ? e$2$3.sjs_js_JavaScriptException__f_exception : $n(e$2$3));
      }
    }
    var $x_7 = $n($x_8).toOption__s_Option();
  }
  var this$23 = $n($x_7);
  var traceBufferSize = $uI((this$23.isEmpty__Z() ? ($n($as_Lcats_effect_unsafe_IORuntimeConfig$($thiz)), 16) : this$23.get__O()));
  var this$24 = $n($m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_SHUTDOWN_HOOK_TIMEOUT"));
  if (this$24.isEmpty__Z()) {
    var $x_9 = $m_s_None$();
  } else {
    var arg1$4 = this$24.get__O();
    var x$4 = $as_T(arg1$4);
    try {
      var r1$4 = $m_s_concurrent_duration_Duration$().apply__T__s_concurrent_duration_Duration(x$4);
      var $x_10 = new $c_s_util_Success(r1$4);
    } catch (e$5) {
      var $x_10;
      var e$2$4 = ((e$5 instanceof $c_jl_Throwable) ? e$5 : new $c_sjs_js_JavaScriptException(e$5));
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$4)) {
        var $x_10 = new $c_s_util_Failure(e$2$4);
      } else {
        throw ((e$2$4 instanceof $c_sjs_js_JavaScriptException) ? e$2$4.sjs_js_JavaScriptException__f_exception : $n(e$2$4));
      }
    }
    var $x_9 = $n($x_10).toOption__s_Option();
  }
  var this$26 = $n($x_9);
  var shutdownHookTimeout = $as_s_concurrent_duration_Duration((this$26.isEmpty__Z() ? ($n($as_Lcats_effect_unsafe_IORuntimeConfig$($thiz)), $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Inf) : this$26.get__O()));
  var this$28 = $n($m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_REPORT_UNHANDLED_FIBER_ERRORS"));
  if (this$28.isEmpty__Z()) {
    var $x_11 = $m_s_None$();
  } else {
    var arg1$5 = this$28.get__O();
    var x$5 = $as_T(arg1$5);
    try {
      var r1$5 = $m_sc_StringOps$().toBooleanImpl$extension__T__T__Z(x$5, x$5);
      var $x_12 = new $c_s_util_Success(r1$5);
    } catch (e$6) {
      var $x_12;
      var e$2$5 = ((e$6 instanceof $c_jl_Throwable) ? e$6 : new $c_sjs_js_JavaScriptException(e$6));
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$5)) {
        var $x_12 = new $c_s_util_Failure(e$2$5);
      } else {
        throw ((e$2$5 instanceof $c_sjs_js_JavaScriptException) ? e$2$5.sjs_js_JavaScriptException__f_exception : $n(e$2$5));
      }
    }
    var $x_11 = $n($x_12).toOption__s_Option();
  }
  var this$32 = $n($x_11);
  var reportUnhandledFiberErrors = $uZ((this$32.isEmpty__Z() ? ($n($as_Lcats_effect_unsafe_IORuntimeConfig$($thiz)), true) : this$32.get__O()));
  var this$33 = $n($m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_CPU_STARVATION_CHECK_INTERVAL"));
  if (this$33.isEmpty__Z()) {
    var $x_13 = $m_s_None$();
  } else {
    var arg1$6 = this$33.get__O();
    var _$1 = $as_T(arg1$6);
    var $x_13 = new $c_s_Some($m_s_concurrent_duration_Duration$().apply__T__s_concurrent_duration_Duration(_$1));
  }
  var this$34 = $n($x_13);
  if (this$34.isEmpty__Z()) {
    var $x_14 = $m_s_None$();
  } else {
    var arg1$7 = this$34.get__O();
    var d = $as_s_concurrent_duration_Duration(arg1$7);
    try {
      var r1$6 = $as_s_concurrent_duration_FiniteDuration(d);
      var $x_15 = new $c_s_util_Success(r1$6);
    } catch (e$7) {
      var $x_15;
      var e$2$6 = ((e$7 instanceof $c_jl_Throwable) ? e$7 : new $c_sjs_js_JavaScriptException(e$7));
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$6)) {
        var $x_15 = new $c_s_util_Failure(e$2$6);
      } else {
        throw ((e$2$6 instanceof $c_sjs_js_JavaScriptException) ? e$2$6.sjs_js_JavaScriptException__f_exception : $n(e$2$6));
      }
    }
    var $x_14 = $n($x_15).toOption__s_Option();
  }
  var this$36 = $n($x_14);
  var cpuStarvationCheckInterval = $as_s_concurrent_duration_FiniteDuration((this$36.isEmpty__Z() ? $n($as_Lcats_effect_unsafe_IORuntimeConfig$($thiz)).DefaultCpuStarvationCheckInterval__s_concurrent_duration_FiniteDuration() : this$36.get__O()));
  var this$37 = $n($m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_CPU_STARVATION_CHECK_INITIAL_DELAY"));
  if (this$37.isEmpty__Z()) {
    var $x_16 = $m_s_None$();
  } else {
    var arg1$8 = this$37.get__O();
    var _$2 = $as_T(arg1$8);
    var $x_16 = new $c_s_Some($m_s_concurrent_duration_Duration$().apply__T__s_concurrent_duration_Duration(_$2));
  }
  var this$38 = $n($x_16);
  var cpuStarvationCheckInitialDelay = $as_s_concurrent_duration_Duration((this$38.isEmpty__Z() ? $n($as_Lcats_effect_unsafe_IORuntimeConfig$($thiz)).DefaultCpuStarvationCheckInitialDelay__s_concurrent_duration_FiniteDuration() : this$38.get__O()));
  var this$39 = $n($m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_CPU_STARVATION_CHECK_THRESHOLD"));
  if (this$39.isEmpty__Z()) {
    var $x_17 = $m_s_None$();
  } else {
    var arg1$9 = this$39.get__O();
    var p = $as_T(arg1$9);
    try {
      var r1$7 = $m_jl_Double$().parseDouble__T__D(p);
      var $x_18 = new $c_s_util_Success(r1$7);
    } catch (e$8) {
      var $x_18;
      var e$2$7 = ((e$8 instanceof $c_jl_Throwable) ? e$8 : new $c_sjs_js_JavaScriptException(e$8));
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$7)) {
        var $x_18 = new $c_s_util_Failure(e$2$7);
      } else {
        throw ((e$2$7 instanceof $c_sjs_js_JavaScriptException) ? e$2$7.sjs_js_JavaScriptException__f_exception : $n(e$2$7));
      }
    }
    var $x_17 = $n($x_18).toOption__s_Option();
  }
  var this$43 = $n($x_17);
  var cpuStarvationCheckThreshold = $uD((this$43.isEmpty__Z() ? ($n($as_Lcats_effect_unsafe_IORuntimeConfig$($thiz)), 0.1) : this$43.get__O()));
  $n($as_Lcats_effect_unsafe_IORuntimeConfig$($thiz));
  $thiz.Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__f_Default = new $c_Lcats_effect_unsafe_IORuntimeConfig(cancelationCheckThreshold, autoYieldThreshold, enhancedExceptions, traceBufferSize, shutdownHookTimeout, reportUnhandledFiberErrors, cpuStarvationCheckInterval, cpuStarvationCheckInitialDelay, cpuStarvationCheckThreshold);
  return $thiz;
}
/** @constructor */
function $c_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform() {
  this.Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__f_Default = null;
}
$c_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform.prototype = new $h_O();
$c_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform.prototype.constructor = $c_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform;
/** @constructor */
function $h_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform() {
}
$h_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform.prototype = $c_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform.prototype;
/** @constructor */
function $c_Lcats_effect_unsafe_JSArrayQueue() {
  this.Lcats_effect_unsafe_JSArrayQueue__f_buffer = null;
  this.Lcats_effect_unsafe_JSArrayQueue__f_startIndex = 0;
  this.Lcats_effect_unsafe_JSArrayQueue__f_endIndex = 0;
  this.Lcats_effect_unsafe_JSArrayQueue__f_empty = false;
  this.Lcats_effect_unsafe_JSArrayQueue__f_buffer = [null];
  this.Lcats_effect_unsafe_JSArrayQueue__f_startIndex = 0;
  this.Lcats_effect_unsafe_JSArrayQueue__f_endIndex = 1;
  this.Lcats_effect_unsafe_JSArrayQueue__f_empty = true;
}
$c_Lcats_effect_unsafe_JSArrayQueue.prototype = new $h_O();
$c_Lcats_effect_unsafe_JSArrayQueue.prototype.constructor = $c_Lcats_effect_unsafe_JSArrayQueue;
/** @constructor */
function $h_Lcats_effect_unsafe_JSArrayQueue() {
}
$h_Lcats_effect_unsafe_JSArrayQueue.prototype = $c_Lcats_effect_unsafe_JSArrayQueue.prototype;
var $d_Lcats_effect_unsafe_JSArrayQueue = new $TypeData().initClass($c_Lcats_effect_unsafe_JSArrayQueue, "cats.effect.unsafe.JSArrayQueue", ({
  Lcats_effect_unsafe_JSArrayQueue: 1
}));
function $is_Lcats_effect_unsafe_Scheduler(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_unsafe_Scheduler)));
}
function $as_Lcats_effect_unsafe_Scheduler(obj) {
  return (($is_Lcats_effect_unsafe_Scheduler(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.Scheduler"));
}
function $isArrayOf_Lcats_effect_unsafe_Scheduler(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_Scheduler)));
}
function $asArrayOf_Lcats_effect_unsafe_Scheduler(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_Scheduler(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.Scheduler;", depth));
}
function $ct_Lcats_effect_unsafe_SchedulerCompanionPlatform__($thiz) {
  var this$2 = new $c_s_concurrent_duration_package$DurationInt(2147483647);
  var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
  var this$ = this$2.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $m_s_concurrent_duration_Duration$();
  var hi = (this$ >> 31);
  $thiz.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$maxTimeout = new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(this$, hi), unit);
  if (($as_T((typeof clearTimeout)) === "function")) {
    var $x_1 = ((handle) => new $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1(handle, $thiz));
  } else {
    var noop = new $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2($thiz);
    var $x_1 = ((_$1) => noop);
  }
  $thiz.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$mkCancelRunnable = $x_1;
  var this$7 = $n($ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__browsers$1__s_Option());
  var this$8 = $n((this$7.isEmpty__Z() ? $ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__nodeJS$1__s_Option() : this$7));
  if (this$8.isEmpty__Z()) {
    var $x_2 = $m_s_None$();
  } else {
    var arg1 = this$8.get__O();
    var $x_2 = new $c_s_Some((() => {
      var this$9 = $m_RTLong$();
      var value = (1000.0 * ($uD(arg1.timeOrigin) + $uD(arg1.now())));
      var lo = this$9.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
      var hi$1 = this$9.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo, hi$1);
    }));
  }
  var this$10 = $n($x_2);
  $thiz.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$nowMicrosImpl = (this$10.isEmpty__Z() ? (() => {
    var this$12 = $m_RTLong$();
    var value$1 = $uD(new Date().getTime());
    var lo$1 = this$12.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$1);
    var hi$2 = this$12.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var b0 = (65535 & lo$1);
    var b1 = ((lo$1 >>> 16) | 0);
    var a0b0 = Math.imul(1000, b0);
    var a0b1 = Math.imul(1000, b1);
    var lo$2 = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$3 = ((Math.imul(1000, hi$2) + ((c1part >>> 16) | 0)) | 0);
    return new $c_RTLong(lo$2, hi$3);
  }) : this$10.get__O());
  return $thiz;
}
function $ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__test$1__Lcats_effect_unsafe_Performance__Z(performance) {
  var x = ($uD(performance.timeOrigin) + $uD(performance.now()));
  return (!(x !== x));
}
function $ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__browsers$1__s_Option() {
  try {
    var x = performance;
    var r1 = (((x === (void 0)) || $ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__test$1__Lcats_effect_unsafe_Performance__Z(x)) ? x : (void 0));
    var $x_1 = new $c_s_util_Success(r1);
  } catch (e) {
    var $x_1;
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      var $x_1 = new $c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2));
    }
  }
  var this$7 = $n($n($x_1).toOption__s_Option());
  if (this$7.isEmpty__Z()) {
    return $m_s_None$();
  } else {
    var arg1 = this$7.get__O();
    return ((arg1 === (void 0)) ? $m_s_None$() : new $c_s_Some(arg1));
  }
}
function $ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__nodeJS$1__s_Option() {
  try {
    var x = require("perf_hooks").performance;
    var r1 = (((x === (void 0)) || $ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__test$1__Lcats_effect_unsafe_Performance__Z(x)) ? x : (void 0));
    var $x_1 = new $c_s_util_Success(r1);
  } catch (e) {
    var $x_1;
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      var $x_1 = new $c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2));
    }
  }
  var this$8 = $n($n($x_1).toOption__s_Option());
  if (this$8.isEmpty__Z()) {
    return $m_s_None$();
  } else {
    var arg1 = this$8.get__O();
    return ((arg1 === (void 0)) ? $m_s_None$() : new $c_s_Some(arg1));
  }
}
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform() {
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$maxTimeout = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$mkCancelRunnable = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$nowMicrosImpl = null;
}
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform.prototype = new $h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform() {
}
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform.prototype.createDefaultScheduler__T2 = (function() {
  var _1 = new $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3(this);
  var _2 = new $c_sjsr_AnonFunction0((() => (void 0)));
  return new $c_T2(_1, _2);
});
/** @constructor */
function $c_Lcats_effect_unsafe_StripedHashtable() {
  this.Lcats_effect_unsafe_StripedHashtable__f_log2NumTables = 0;
  this.Lcats_effect_unsafe_StripedHashtable__f_mask = 0;
  this.Lcats_effect_unsafe_StripedHashtable__f_tables = null;
  this.Lcats_effect_unsafe_StripedHashtable__f_log2NumTables = $m_Lcats_effect_unsafe_StripedHashtable$().Lcats_effect_unsafe_StripedHashtable$__f_log2NumTables;
  this.Lcats_effect_unsafe_StripedHashtable__f_mask = (((-1) + this.numTables__I()) | 0);
  var dimensions = new $ac_I(new Int32Array([this.numTables__I()]));
  var array = $asArrayOf_Lcats_effect_unsafe_ThreadSafeHashtable($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Lcats_effect_unsafe_ThreadSafeHashtable.getClassOf(), dimensions), 1);
  var i = 0;
  while ((i < this.numTables__I())) {
    $n(array).set(i, new $c_Lcats_effect_unsafe_ThreadSafeHashtable(8));
    i = ((1 + i) | 0);
  }
  this.Lcats_effect_unsafe_StripedHashtable__f_tables = array;
}
$c_Lcats_effect_unsafe_StripedHashtable.prototype = new $h_O();
$c_Lcats_effect_unsafe_StripedHashtable.prototype.constructor = $c_Lcats_effect_unsafe_StripedHashtable;
/** @constructor */
function $h_Lcats_effect_unsafe_StripedHashtable() {
}
$h_Lcats_effect_unsafe_StripedHashtable.prototype = $c_Lcats_effect_unsafe_StripedHashtable.prototype;
$c_Lcats_effect_unsafe_StripedHashtable.prototype.numTables__I = (function() {
  return (1 << this.Lcats_effect_unsafe_StripedHashtable__f_log2NumTables);
});
$c_Lcats_effect_unsafe_StripedHashtable.prototype.put__F1__V = (function(cb) {
  var hash = $systemIdentityHashCode(cb);
  var idx = (hash & this.Lcats_effect_unsafe_StripedHashtable__f_mask);
  $n($n(this.Lcats_effect_unsafe_StripedHashtable__f_tables).get(idx)).put__O__I__V(cb, (hash >> this.Lcats_effect_unsafe_StripedHashtable__f_log2NumTables));
});
$c_Lcats_effect_unsafe_StripedHashtable.prototype.remove__F1__V = (function(cb) {
  var hash = $systemIdentityHashCode(cb);
  var idx = (hash & this.Lcats_effect_unsafe_StripedHashtable__f_mask);
  $n($n(this.Lcats_effect_unsafe_StripedHashtable__f_tables).get(idx)).remove__O__I__V(cb, (hash >> this.Lcats_effect_unsafe_StripedHashtable__f_log2NumTables));
});
var $d_Lcats_effect_unsafe_StripedHashtable = new $TypeData().initClass($c_Lcats_effect_unsafe_StripedHashtable, "cats.effect.unsafe.StripedHashtable", ({
  Lcats_effect_unsafe_StripedHashtable: 1
}));
function $p_Lcats_effect_unsafe_StripedHashtable$__minNumTables__I($thiz) {
  var this$1 = $m_jl_Runtime$();
  $n(this$1.jl_Runtime$__f_currentRuntime);
  return (1 << 2);
}
/** @constructor */
function $c_Lcats_effect_unsafe_StripedHashtable$() {
  this.Lcats_effect_unsafe_StripedHashtable$__f_log2NumTables = 0;
  $n_Lcats_effect_unsafe_StripedHashtable$ = this;
  var result = 0;
  var x = $p_Lcats_effect_unsafe_StripedHashtable$__minNumTables__I(this);
  while ((x !== 0)) {
    result = ((1 + result) | 0);
    x = (x >> 1);
  }
  this.Lcats_effect_unsafe_StripedHashtable$__f_log2NumTables = result;
}
$c_Lcats_effect_unsafe_StripedHashtable$.prototype = new $h_O();
$c_Lcats_effect_unsafe_StripedHashtable$.prototype.constructor = $c_Lcats_effect_unsafe_StripedHashtable$;
/** @constructor */
function $h_Lcats_effect_unsafe_StripedHashtable$() {
}
$h_Lcats_effect_unsafe_StripedHashtable$.prototype = $c_Lcats_effect_unsafe_StripedHashtable$.prototype;
var $d_Lcats_effect_unsafe_StripedHashtable$ = new $TypeData().initClass($c_Lcats_effect_unsafe_StripedHashtable$, "cats.effect.unsafe.StripedHashtable$", ({
  Lcats_effect_unsafe_StripedHashtable$: 1
}));
var $n_Lcats_effect_unsafe_StripedHashtable$;
function $m_Lcats_effect_unsafe_StripedHashtable$() {
  if ((!$n_Lcats_effect_unsafe_StripedHashtable$)) {
    $n_Lcats_effect_unsafe_StripedHashtable$ = new $c_Lcats_effect_unsafe_StripedHashtable$();
  }
  return $n_Lcats_effect_unsafe_StripedHashtable$;
}
function $p_Lcats_effect_unsafe_ThreadSafeHashtable__insert__AO__I__O__I__V($thiz, table, mask, a, hash) {
  var idx = (hash & mask);
  var remaining = mask;
  while ((remaining >= 0)) {
    var cur = $n(table).get(idx);
    if (((cur === null) || Object.is(cur, $thiz.Lcats_effect_unsafe_ThreadSafeHashtable__f_Tombstone))) {
      $n(table).set(idx, a);
      return (void 0);
    } else {
      idx = (((1 + idx) | 0) & mask);
    }
    remaining = (((-1) + remaining) | 0);
  }
}
/** @constructor */
function $c_Lcats_effect_unsafe_ThreadSafeHashtable(initialCapacity) {
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_initialCapacity = 0;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable = null;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size = 0;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_mask = 0;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_capacity = 0;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_log2NumTables = 0;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_Tombstone = null;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_initialCapacity = initialCapacity;
  var dimensions = new $ac_I(new Int32Array([initialCapacity]));
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_O.getClassOf(), dimensions), 1);
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size = 0;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_mask = (((-1) + initialCapacity) | 0);
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_capacity = initialCapacity;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_log2NumTables = $m_Lcats_effect_unsafe_StripedHashtable$().Lcats_effect_unsafe_StripedHashtable$__f_log2NumTables;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_Tombstone = $m_Lcats_effect_unsafe_ThreadSafeHashtable$().Lcats_effect_unsafe_ThreadSafeHashtable$__f_Tombstone;
}
$c_Lcats_effect_unsafe_ThreadSafeHashtable.prototype = new $h_O();
$c_Lcats_effect_unsafe_ThreadSafeHashtable.prototype.constructor = $c_Lcats_effect_unsafe_ThreadSafeHashtable;
/** @constructor */
function $h_Lcats_effect_unsafe_ThreadSafeHashtable() {
}
$h_Lcats_effect_unsafe_ThreadSafeHashtable.prototype = $c_Lcats_effect_unsafe_ThreadSafeHashtable.prototype;
$c_Lcats_effect_unsafe_ThreadSafeHashtable.prototype.put__O__I__V = (function(a, hash) {
  var sz = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size;
  var cap = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_capacity;
  if (((sz << 1) >= cap)) {
    var newCap = (cap << 1);
    var newMask = (((-1) + newCap) | 0);
    var dimensions = new $ac_I(new Int32Array([newCap]));
    var newHashtable = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_O.getClassOf(), dimensions), 1);
    var table = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable;
    var i = 0;
    while ((i < cap)) {
      var cur = $n(table).get(i);
      if (((cur !== null) && (!Object.is(cur, this.Lcats_effect_unsafe_ThreadSafeHashtable__f_Tombstone)))) {
        $p_Lcats_effect_unsafe_ThreadSafeHashtable__insert__AO__I__O__I__V(this, newHashtable, newMask, cur, ($systemIdentityHashCode(cur) >> this.Lcats_effect_unsafe_ThreadSafeHashtable__f_log2NumTables));
      }
      i = ((1 + i) | 0);
    }
    this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable = newHashtable;
    this.Lcats_effect_unsafe_ThreadSafeHashtable__f_mask = newMask;
    this.Lcats_effect_unsafe_ThreadSafeHashtable__f_capacity = newCap;
  }
  $p_Lcats_effect_unsafe_ThreadSafeHashtable__insert__AO__I__O__I__V(this, this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable, this.Lcats_effect_unsafe_ThreadSafeHashtable__f_mask, a, hash);
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size = ((1 + sz) | 0);
});
$c_Lcats_effect_unsafe_ThreadSafeHashtable.prototype.remove__O__I__V = (function(a, hash) {
  var msk = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_mask;
  var init = (hash & msk);
  var idx = init;
  var table = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable;
  var remaining = msk;
  while ((remaining >= 0)) {
    var cur = $n(table).get(idx);
    if (Object.is(a, cur)) {
      $n(table).set(idx, this.Lcats_effect_unsafe_ThreadSafeHashtable__f_Tombstone);
      this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size = (((-1) + this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size) | 0);
      var sz = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size;
      var cap = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_capacity;
      if (((cap > this.Lcats_effect_unsafe_ThreadSafeHashtable__f_initialCapacity) && ((sz << 2) < cap))) {
        var newCap = ((cap >>> 1) | 0);
        var newMask = (((-1) + newCap) | 0);
        var dimensions = new $ac_I(new Int32Array([newCap]));
        var newHashtable = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_O.getClassOf(), dimensions), 1);
        var table$2 = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable;
        var i = 0;
        while ((i < cap)) {
          var cur$2 = $n(table$2).get(i);
          if (((cur$2 !== null) && (!Object.is(cur$2, this.Lcats_effect_unsafe_ThreadSafeHashtable__f_Tombstone)))) {
            $p_Lcats_effect_unsafe_ThreadSafeHashtable__insert__AO__I__O__I__V(this, newHashtable, newMask, cur$2, ($systemIdentityHashCode(cur$2) >> this.Lcats_effect_unsafe_ThreadSafeHashtable__f_log2NumTables));
          }
          i = ((1 + i) | 0);
        }
        this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable = newHashtable;
        this.Lcats_effect_unsafe_ThreadSafeHashtable__f_mask = newMask;
        this.Lcats_effect_unsafe_ThreadSafeHashtable__f_capacity = newCap;
      }
      return (void 0);
    } else if ((cur !== null)) {
      idx = (((1 + idx) | 0) & msk);
    } else {
      return (void 0);
    }
    remaining = (((-1) + remaining) | 0);
  }
});
function $as_Lcats_effect_unsafe_ThreadSafeHashtable(obj) {
  return (((obj instanceof $c_Lcats_effect_unsafe_ThreadSafeHashtable) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.ThreadSafeHashtable"));
}
function $isArrayOf_Lcats_effect_unsafe_ThreadSafeHashtable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_ThreadSafeHashtable)));
}
function $asArrayOf_Lcats_effect_unsafe_ThreadSafeHashtable(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_ThreadSafeHashtable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.ThreadSafeHashtable;", depth));
}
var $d_Lcats_effect_unsafe_ThreadSafeHashtable = new $TypeData().initClass($c_Lcats_effect_unsafe_ThreadSafeHashtable, "cats.effect.unsafe.ThreadSafeHashtable", ({
  Lcats_effect_unsafe_ThreadSafeHashtable: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_ThreadSafeHashtable$() {
  this.Lcats_effect_unsafe_ThreadSafeHashtable$__f_Tombstone = null;
  $n_Lcats_effect_unsafe_ThreadSafeHashtable$ = this;
  this.Lcats_effect_unsafe_ThreadSafeHashtable$__f_Tombstone = $ct_O__(new $c_O());
}
$c_Lcats_effect_unsafe_ThreadSafeHashtable$.prototype = new $h_O();
$c_Lcats_effect_unsafe_ThreadSafeHashtable$.prototype.constructor = $c_Lcats_effect_unsafe_ThreadSafeHashtable$;
/** @constructor */
function $h_Lcats_effect_unsafe_ThreadSafeHashtable$() {
}
$h_Lcats_effect_unsafe_ThreadSafeHashtable$.prototype = $c_Lcats_effect_unsafe_ThreadSafeHashtable$.prototype;
var $d_Lcats_effect_unsafe_ThreadSafeHashtable$ = new $TypeData().initClass($c_Lcats_effect_unsafe_ThreadSafeHashtable$, "cats.effect.unsafe.ThreadSafeHashtable$", ({
  Lcats_effect_unsafe_ThreadSafeHashtable$: 1
}));
var $n_Lcats_effect_unsafe_ThreadSafeHashtable$;
function $m_Lcats_effect_unsafe_ThreadSafeHashtable$() {
  if ((!$n_Lcats_effect_unsafe_ThreadSafeHashtable$)) {
    $n_Lcats_effect_unsafe_ThreadSafeHashtable$ = new $c_Lcats_effect_unsafe_ThreadSafeHashtable$();
  }
  return $n_Lcats_effect_unsafe_ThreadSafeHashtable$;
}
/** @constructor */
function $c_Lcats_effect_unsafe_WeakBag() {
  this.Lcats_effect_unsafe_WeakBag__f_MaxSizePow2 = 0;
  this.Lcats_effect_unsafe_WeakBag__f_queue = null;
  this.Lcats_effect_unsafe_WeakBag__f_capacity = 0;
  this.Lcats_effect_unsafe_WeakBag__f_table = null;
  this.Lcats_effect_unsafe_WeakBag__f_index = 0;
  this.Lcats_effect_unsafe_WeakBag__f_MaxSizePow2 = 1073741824;
  this.Lcats_effect_unsafe_WeakBag__f_queue = new $c_Lcats_effect_unsafe_ref_ReferenceQueue();
  this.Lcats_effect_unsafe_WeakBag__f_capacity = 256;
  var dimensions = new $ac_I(new Int32Array([this.Lcats_effect_unsafe_WeakBag__f_capacity]));
  this.Lcats_effect_unsafe_WeakBag__f_table = $asArrayOf_Lcats_effect_unsafe_WeakBag$Entry($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Lcats_effect_unsafe_WeakBag$Entry.getClassOf(), dimensions), 1);
  this.Lcats_effect_unsafe_WeakBag__f_index = 0;
}
$c_Lcats_effect_unsafe_WeakBag.prototype = new $h_O();
$c_Lcats_effect_unsafe_WeakBag.prototype.constructor = $c_Lcats_effect_unsafe_WeakBag;
/** @constructor */
function $h_Lcats_effect_unsafe_WeakBag() {
}
$h_Lcats_effect_unsafe_WeakBag.prototype = $c_Lcats_effect_unsafe_WeakBag.prototype;
$c_Lcats_effect_unsafe_WeakBag.prototype.insert__O__Lcats_effect_unsafe_WeakBag$Handle = (function(a) {
  while (true) {
    var oldEntry = $as_Lcats_effect_unsafe_WeakBag$Entry($n(this.Lcats_effect_unsafe_WeakBag__f_queue).poll__Lcats_effect_unsafe_ref_Reference());
    var cap = this.Lcats_effect_unsafe_WeakBag__f_capacity;
    var idx = this.Lcats_effect_unsafe_WeakBag__f_index;
    if ((oldEntry !== null)) {
      var oldIndex = $n(oldEntry).Lcats_effect_unsafe_WeakBag$Entry__f_index;
      var entry = new $c_Lcats_effect_unsafe_WeakBag$Entry(a, oldIndex, this.Lcats_effect_unsafe_WeakBag__f_queue);
      $n(this.Lcats_effect_unsafe_WeakBag__f_table).set(oldIndex, entry);
      return entry;
    } else if ((idx < cap)) {
      var entry$2 = new $c_Lcats_effect_unsafe_WeakBag$Entry(a, idx, this.Lcats_effect_unsafe_WeakBag__f_queue);
      $n(this.Lcats_effect_unsafe_WeakBag__f_table).set(idx, entry$2);
      this.Lcats_effect_unsafe_WeakBag__f_index = ((1 + this.Lcats_effect_unsafe_WeakBag__f_index) | 0);
      return entry$2;
    } else {
      if ((cap === 2147483647)) {
        return new $c_Lcats_effect_unsafe_WeakBag$$anon$1(this);
      }
      var oldTable = this.Lcats_effect_unsafe_WeakBag__f_table;
      var newCap = ((cap === this.Lcats_effect_unsafe_WeakBag__f_MaxSizePow2) ? 2147483647 : (cap << 1));
      var dimensions = new $ac_I(new Int32Array([newCap]));
      var newTable = $asArrayOf_Lcats_effect_unsafe_WeakBag$Entry($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Lcats_effect_unsafe_WeakBag$Entry.getClassOf(), dimensions), 1);
      $systemArraycopyRefs($n(oldTable), 0, $n(newTable), 0, idx);
      this.Lcats_effect_unsafe_WeakBag__f_table = newTable;
      this.Lcats_effect_unsafe_WeakBag__f_capacity = newCap;
    }
  }
});
var $d_Lcats_effect_unsafe_WeakBag = new $TypeData().initClass($c_Lcats_effect_unsafe_WeakBag, "cats.effect.unsafe.WeakBag", ({
  Lcats_effect_unsafe_WeakBag: 1
}));
function $is_Lcats_effect_unsafe_WeakBag$Handle(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_unsafe_WeakBag$Handle)));
}
function $as_Lcats_effect_unsafe_WeakBag$Handle(obj) {
  return (($is_Lcats_effect_unsafe_WeakBag$Handle(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.WeakBag$Handle"));
}
function $isArrayOf_Lcats_effect_unsafe_WeakBag$Handle(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_WeakBag$Handle)));
}
function $asArrayOf_Lcats_effect_unsafe_WeakBag$Handle(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_WeakBag$Handle(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.WeakBag$Handle;", depth));
}
function $ct_Lcats_effect_unsafe_ref_Reference__O__Lcats_effect_unsafe_ref_ReferenceQueue__($thiz, referent, queue) {
  $thiz.Lcats_effect_unsafe_ref_Reference__f_queue = queue;
  $thiz.Lcats_effect_unsafe_ref_Reference__f_weakRef = new WeakRef(referent);
  $thiz.Lcats_effect_unsafe_ref_Reference__f_enqueued = false;
  if ((queue !== null)) {
    $n(queue).register__Lcats_effect_unsafe_ref_Reference__O__V($thiz, referent);
  }
  return $thiz;
}
/** @constructor */
function $c_Lcats_effect_unsafe_ref_Reference() {
  this.Lcats_effect_unsafe_ref_Reference__f_queue = null;
  this.Lcats_effect_unsafe_ref_Reference__f_weakRef = null;
  this.Lcats_effect_unsafe_ref_Reference__f_enqueued = false;
}
$c_Lcats_effect_unsafe_ref_Reference.prototype = new $h_O();
$c_Lcats_effect_unsafe_ref_Reference.prototype.constructor = $c_Lcats_effect_unsafe_ref_Reference;
/** @constructor */
function $h_Lcats_effect_unsafe_ref_Reference() {
}
$h_Lcats_effect_unsafe_ref_Reference.prototype = $c_Lcats_effect_unsafe_ref_Reference.prototype;
$c_Lcats_effect_unsafe_ref_Reference.prototype.get__O = (function() {
  if ((this.Lcats_effect_unsafe_ref_Reference__f_weakRef === null)) {
    return null;
  } else {
    var x = this.Lcats_effect_unsafe_ref_Reference__f_weakRef.deref();
    return ((x === (void 0)) ? null : x);
  }
});
$c_Lcats_effect_unsafe_ref_Reference.prototype.enqueue__Z = (function() {
  return (((this.Lcats_effect_unsafe_ref_Reference__f_queue !== null) && $n(this.Lcats_effect_unsafe_ref_Reference__f_queue).enqueue__Lcats_effect_unsafe_ref_Reference__Z(this)) && ($n(this.Lcats_effect_unsafe_ref_Reference__f_queue).unregister__Lcats_effect_unsafe_ref_Reference__V(this), true));
});
function $as_Lcats_effect_unsafe_ref_Reference(obj) {
  return (((obj instanceof $c_Lcats_effect_unsafe_ref_Reference) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.ref.Reference"));
}
function $isArrayOf_Lcats_effect_unsafe_ref_Reference(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_ref_Reference)));
}
function $asArrayOf_Lcats_effect_unsafe_ref_Reference(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_ref_Reference(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.ref.Reference;", depth));
}
/** @constructor */
function $c_Lcats_effect_unsafe_ref_ReferenceQueue() {
  this.Lcats_effect_unsafe_ref_ReferenceQueue__f_enqueuedRefs = null;
  this.Lcats_effect_unsafe_ref_ReferenceQueue__f_finalizationRegistry = null;
  this.Lcats_effect_unsafe_ref_ReferenceQueue__f_enqueuedRefs = [];
  this.Lcats_effect_unsafe_ref_ReferenceQueue__f_finalizationRegistry = new FinalizationRegistry(((ref) => {
    var ref$1 = $as_Lcats_effect_unsafe_ref_Reference(ref);
    return this.enqueue__Lcats_effect_unsafe_ref_Reference__Z(ref$1);
  }));
}
$c_Lcats_effect_unsafe_ref_ReferenceQueue.prototype = new $h_O();
$c_Lcats_effect_unsafe_ref_ReferenceQueue.prototype.constructor = $c_Lcats_effect_unsafe_ref_ReferenceQueue;
/** @constructor */
function $h_Lcats_effect_unsafe_ref_ReferenceQueue() {
}
$h_Lcats_effect_unsafe_ref_ReferenceQueue.prototype = $c_Lcats_effect_unsafe_ref_ReferenceQueue.prototype;
$c_Lcats_effect_unsafe_ref_ReferenceQueue.prototype.register__Lcats_effect_unsafe_ref_Reference__O__V = (function(ref, referent) {
  this.Lcats_effect_unsafe_ref_ReferenceQueue__f_finalizationRegistry.register(referent, ref, ref);
});
$c_Lcats_effect_unsafe_ref_ReferenceQueue.prototype.unregister__Lcats_effect_unsafe_ref_Reference__V = (function(ref) {
  $uZ(this.Lcats_effect_unsafe_ref_ReferenceQueue__f_finalizationRegistry.unregister(ref));
});
$c_Lcats_effect_unsafe_ref_ReferenceQueue.prototype.enqueue__Lcats_effect_unsafe_ref_Reference__Z = (function(ref) {
  if ((!$n(ref).Lcats_effect_unsafe_ref_Reference__f_enqueued)) {
    $n(ref).Lcats_effect_unsafe_ref_Reference__f_enqueued = true;
    this.Lcats_effect_unsafe_ref_ReferenceQueue__f_enqueuedRefs.push(ref);
    return true;
  } else {
    return false;
  }
});
$c_Lcats_effect_unsafe_ref_ReferenceQueue.prototype.poll__Lcats_effect_unsafe_ref_Reference = (function() {
  return (($uI(this.Lcats_effect_unsafe_ref_ReferenceQueue__f_enqueuedRefs.length) === 0) ? null : $as_Lcats_effect_unsafe_ref_Reference(this.Lcats_effect_unsafe_ref_ReferenceQueue__f_enqueuedRefs.pop()));
});
var $d_Lcats_effect_unsafe_ref_ReferenceQueue = new $TypeData().initClass($c_Lcats_effect_unsafe_ref_ReferenceQueue, "cats.effect.unsafe.ref.ReferenceQueue", ({
  Lcats_effect_unsafe_ref_ReferenceQueue: 1
}));
function $ct_Lcats_evidence_AsInstances__($thiz) {
  return $thiz;
}
/** @constructor */
function $c_Lcats_evidence_AsInstances() {
}
$c_Lcats_evidence_AsInstances.prototype = new $h_O();
$c_Lcats_evidence_AsInstances.prototype.constructor = $c_Lcats_evidence_AsInstances;
/** @constructor */
function $h_Lcats_evidence_AsInstances() {
}
$h_Lcats_evidence_AsInstances.prototype = $c_Lcats_evidence_AsInstances.prototype;
function $f_Lcats_instances_InvariantInstances__$init$__V($thiz) {
  $thiz.cats$instances$InvariantInstances$_setter_$catsInvariantForNumeric_$eq__Lcats_Invariant__V(new $c_Lcats_instances_InvariantInstances$$anon$10());
  $thiz.cats$instances$InvariantInstances$_setter_$catsInvariantForIntegral_$eq__Lcats_Invariant__V(new $c_Lcats_instances_InvariantInstances$$anon$12());
}
function $f_Lcats_instances_InvariantMonoidalInstances__$init$__V($thiz) {
  $thiz.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalSemigroup_$eq__Lcats_InvariantMonoidal__V(new $c_Lcats_instances_InvariantMonoidalInstances$$anon$1());
  $thiz.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalCommutativeSemigroup_$eq__Lcats_InvariantMonoidal__V(new $c_Lcats_instances_InvariantMonoidalInstances$$anon$4());
}
function $f_Lcats_instances_NTupleBifunctorInstances__catsStdBifunctorForTuple2__Lcats_Bifunctor($thiz) {
  var bim = new $c_sjsr_AnonFunction3(((fab, f, g) => {
    var fab$1 = $as_T2(fab);
    var f$1 = $as_F1(f);
    var g$1 = $as_F1(g);
    $n(fab$1);
    var _1 = $n(f$1).apply__O__O($n(fab$1)._1__O());
    var _2 = $n(g$1).apply__O__O($n(fab$1)._2__O());
    return new $c_T2(_1, _2);
  }));
  return new $c_Lcats_instances_NTupleBifunctorInstances$$anon$1(bim);
}
/** @constructor */
function $c_Lcats_kernel_EqFunctions() {
}
$c_Lcats_kernel_EqFunctions.prototype = new $h_O();
$c_Lcats_kernel_EqFunctions.prototype.constructor = $c_Lcats_kernel_EqFunctions;
/** @constructor */
function $h_Lcats_kernel_EqFunctions() {
}
$h_Lcats_kernel_EqFunctions.prototype = $c_Lcats_kernel_EqFunctions.prototype;
/** @constructor */
function $c_Lcats_kernel_SemigroupFunctions() {
}
$c_Lcats_kernel_SemigroupFunctions.prototype = new $h_O();
$c_Lcats_kernel_SemigroupFunctions.prototype.constructor = $c_Lcats_kernel_SemigroupFunctions;
/** @constructor */
function $h_Lcats_kernel_SemigroupFunctions() {
}
$h_Lcats_kernel_SemigroupFunctions.prototype = $c_Lcats_kernel_SemigroupFunctions.prototype;
/** @constructor */
function $c_Lcats_kernel_compat_HashCompat() {
}
$c_Lcats_kernel_compat_HashCompat.prototype = new $h_O();
$c_Lcats_kernel_compat_HashCompat.prototype.constructor = $c_Lcats_kernel_compat_HashCompat;
/** @constructor */
function $h_Lcats_kernel_compat_HashCompat() {
}
$h_Lcats_kernel_compat_HashCompat.prototype = $c_Lcats_kernel_compat_HashCompat.prototype;
$c_Lcats_kernel_compat_HashCompat.prototype.orderedHash__sc_IterableOnce__Lcats_kernel_Hash__I = (function(xs, A) {
  var it = $n(xs).iterator__sc_Iterator();
  var h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_seqSeed;
  if ((!$n(it).hasNext__Z())) {
    return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 0);
  }
  var x0 = $n(it).next__O();
  if ((!$n(it).hasNext__Z())) {
    return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I($m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, $n(A).hash__O__I(x0)), 1);
  }
  var x1 = $n(it).next__O();
  var initial = $n(A).hash__O__I(x0);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, initial);
  var h0 = h;
  var prev = $n(A).hash__O__I(x1);
  var rangeDiff = ((prev - initial) | 0);
  var i = 2;
  while ($n(it).hasNext__Z()) {
    h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, prev);
    var hash = $n(A).hash__O__I($n(it).next__O());
    if ((rangeDiff !== ((hash - prev) | 0))) {
      h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, hash);
      i = ((1 + i) | 0);
      while ($n(it).hasNext__Z()) {
        h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, $n(A).hash__O__I($n(it).next__O()));
        i = ((1 + i) | 0);
      }
      return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, i);
    }
    prev = hash;
    i = ((1 + i) | 0);
  }
  return this.avalanche__I__I($m_s_util_hashing_MurmurHash3$().mix__I__I__I($m_s_util_hashing_MurmurHash3$().mix__I__I__I(h0, rangeDiff), prev));
});
$c_Lcats_kernel_compat_HashCompat.prototype.avalanche__I__I = (function(hash) {
  var h = hash;
  h = (h ^ ((h >>> 16) | 0));
  h = Math.imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = Math.imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h;
});
function $f_Lcats_kernel_instances_BigDecimalInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdOrderForBigDecimal_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_BigDecimalOrder());
  $thiz.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdGroupForBigDecimal_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_BigDecimalGroup());
}
function $f_Lcats_kernel_instances_BigIntInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdOrderForBigInt_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_BigIntOrder());
  $thiz.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdGroupForBigInt_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_BigIntGroup());
}
function $f_Lcats_kernel_instances_BitSetInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdOrderForBitSet_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_BitSetPartialOrder());
  $thiz.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdSemilatticeForBitSet_$eq__Lcats_kernel_BoundedSemilattice__V(new $c_Lcats_kernel_instances_BitSetSemilattice());
}
function $f_Lcats_kernel_instances_ByteInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdOrderForByte_$eq__Lcats_kernel_BoundedEnumerable__V(new $c_Lcats_kernel_instances_ByteOrder());
  $thiz.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdGroupForByte_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_ByteGroup());
}
function $f_Lcats_kernel_instances_DoubleInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdOrderForDouble_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_DoubleOrder());
  $thiz.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdGroupForDouble_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_DoubleGroup());
}
function $f_Lcats_kernel_instances_DurationInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdOrderForDuration_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_DurationOrder());
  $thiz.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdGroupForDuration_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_DurationGroup());
}
function $f_Lcats_kernel_instances_FiniteDurationInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdOrderForFiniteDuration_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_FiniteDurationOrder());
  $thiz.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdGroupForFiniteDuration_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_FiniteDurationGroup());
}
function $f_Lcats_kernel_instances_FloatInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdOrderForFloat_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_FloatOrder());
  $thiz.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdGroupForFloat_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_FloatGroup());
}
function $f_Lcats_kernel_instances_IntInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$IntInstances$_setter_$catsKernelStdOrderForInt_$eq__Lcats_kernel_BoundedEnumerable__V(new $c_Lcats_kernel_instances_IntOrder());
  $thiz.cats$kernel$instances$IntInstances$_setter_$catsKernelStdGroupForInt_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_IntGroup());
}
/** @constructor */
function $c_Lcats_kernel_instances_LazyListMonoid$() {
  this.Lcats_kernel_instances_LazyListMonoid$__f_singleton = null;
  $n_Lcats_kernel_instances_LazyListMonoid$ = this;
  this.Lcats_kernel_instances_LazyListMonoid$__f_singleton = new $c_Lcats_kernel_instances_LazyListMonoid();
}
$c_Lcats_kernel_instances_LazyListMonoid$.prototype = new $h_O();
$c_Lcats_kernel_instances_LazyListMonoid$.prototype.constructor = $c_Lcats_kernel_instances_LazyListMonoid$;
/** @constructor */
function $h_Lcats_kernel_instances_LazyListMonoid$() {
}
$h_Lcats_kernel_instances_LazyListMonoid$.prototype = $c_Lcats_kernel_instances_LazyListMonoid$.prototype;
var $d_Lcats_kernel_instances_LazyListMonoid$ = new $TypeData().initClass($c_Lcats_kernel_instances_LazyListMonoid$, "cats.kernel.instances.LazyListMonoid$", ({
  Lcats_kernel_instances_LazyListMonoid$: 1
}));
var $n_Lcats_kernel_instances_LazyListMonoid$;
function $m_Lcats_kernel_instances_LazyListMonoid$() {
  if ((!$n_Lcats_kernel_instances_LazyListMonoid$)) {
    $n_Lcats_kernel_instances_LazyListMonoid$ = new $c_Lcats_kernel_instances_LazyListMonoid$();
  }
  return $n_Lcats_kernel_instances_LazyListMonoid$;
}
/** @constructor */
function $c_Lcats_kernel_instances_ListMonoid$() {
  this.Lcats_kernel_instances_ListMonoid$__f_singleton = null;
  $n_Lcats_kernel_instances_ListMonoid$ = this;
  this.Lcats_kernel_instances_ListMonoid$__f_singleton = new $c_Lcats_kernel_instances_ListMonoid();
}
$c_Lcats_kernel_instances_ListMonoid$.prototype = new $h_O();
$c_Lcats_kernel_instances_ListMonoid$.prototype.constructor = $c_Lcats_kernel_instances_ListMonoid$;
/** @constructor */
function $h_Lcats_kernel_instances_ListMonoid$() {
}
$h_Lcats_kernel_instances_ListMonoid$.prototype = $c_Lcats_kernel_instances_ListMonoid$.prototype;
var $d_Lcats_kernel_instances_ListMonoid$ = new $TypeData().initClass($c_Lcats_kernel_instances_ListMonoid$, "cats.kernel.instances.ListMonoid$", ({
  Lcats_kernel_instances_ListMonoid$: 1
}));
var $n_Lcats_kernel_instances_ListMonoid$;
function $m_Lcats_kernel_instances_ListMonoid$() {
  if ((!$n_Lcats_kernel_instances_ListMonoid$)) {
    $n_Lcats_kernel_instances_ListMonoid$ = new $c_Lcats_kernel_instances_ListMonoid$();
  }
  return $n_Lcats_kernel_instances_ListMonoid$;
}
function $f_Lcats_kernel_instances_LongInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$LongInstances$_setter_$catsKernelStdOrderForLong_$eq__Lcats_kernel_BoundedEnumerable__V(new $c_Lcats_kernel_instances_LongOrder());
  $thiz.cats$kernel$instances$LongInstances$_setter_$catsKernelStdGroupForLong_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_LongGroup());
}
/** @constructor */
function $c_Lcats_kernel_instances_SeqMonoid$() {
  this.Lcats_kernel_instances_SeqMonoid$__f_singleton = null;
  $n_Lcats_kernel_instances_SeqMonoid$ = this;
  this.Lcats_kernel_instances_SeqMonoid$__f_singleton = new $c_Lcats_kernel_instances_SeqMonoid();
}
$c_Lcats_kernel_instances_SeqMonoid$.prototype = new $h_O();
$c_Lcats_kernel_instances_SeqMonoid$.prototype.constructor = $c_Lcats_kernel_instances_SeqMonoid$;
/** @constructor */
function $h_Lcats_kernel_instances_SeqMonoid$() {
}
$h_Lcats_kernel_instances_SeqMonoid$.prototype = $c_Lcats_kernel_instances_SeqMonoid$.prototype;
var $d_Lcats_kernel_instances_SeqMonoid$ = new $TypeData().initClass($c_Lcats_kernel_instances_SeqMonoid$, "cats.kernel.instances.SeqMonoid$", ({
  Lcats_kernel_instances_SeqMonoid$: 1
}));
var $n_Lcats_kernel_instances_SeqMonoid$;
function $m_Lcats_kernel_instances_SeqMonoid$() {
  if ((!$n_Lcats_kernel_instances_SeqMonoid$)) {
    $n_Lcats_kernel_instances_SeqMonoid$ = new $c_Lcats_kernel_instances_SeqMonoid$();
  }
  return $n_Lcats_kernel_instances_SeqMonoid$;
}
function $f_Lcats_kernel_instances_ShortInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdOrderForShort_$eq__Lcats_kernel_BoundedEnumerable__V(new $c_Lcats_kernel_instances_ShortOrder());
  $thiz.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdGroupForShort_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_ShortGroup());
}
function $f_Lcats_kernel_instances_StringInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$StringInstances$_setter_$catsKernelStdOrderForString_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_StringOrder());
  $thiz.cats$kernel$instances$StringInstances$_setter_$catsKernelStdMonoidForString_$eq__Lcats_kernel_Monoid__V(new $c_Lcats_kernel_instances_StringMonoid());
}
function $f_Lcats_kernel_instances_UnitInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdOrderForUnit_$eq__Lcats_kernel_BoundedEnumerable__V(new $c_Lcats_kernel_instances_UnitOrder());
  $thiz.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdAlgebraForUnit_$eq__Lcats_kernel_BoundedSemilattice__V(new $c_Lcats_kernel_instances_UnitAlgebra());
}
/** @constructor */
function $c_Lcats_kernel_instances_VectorMonoid$() {
  this.Lcats_kernel_instances_VectorMonoid$__f_singleton = null;
  $n_Lcats_kernel_instances_VectorMonoid$ = this;
  this.Lcats_kernel_instances_VectorMonoid$__f_singleton = new $c_Lcats_kernel_instances_VectorMonoid();
}
$c_Lcats_kernel_instances_VectorMonoid$.prototype = new $h_O();
$c_Lcats_kernel_instances_VectorMonoid$.prototype.constructor = $c_Lcats_kernel_instances_VectorMonoid$;
/** @constructor */
function $h_Lcats_kernel_instances_VectorMonoid$() {
}
$h_Lcats_kernel_instances_VectorMonoid$.prototype = $c_Lcats_kernel_instances_VectorMonoid$.prototype;
var $d_Lcats_kernel_instances_VectorMonoid$ = new $TypeData().initClass($c_Lcats_kernel_instances_VectorMonoid$, "cats.kernel.instances.VectorMonoid$", ({
  Lcats_kernel_instances_VectorMonoid$: 1
}));
var $n_Lcats_kernel_instances_VectorMonoid$;
function $m_Lcats_kernel_instances_VectorMonoid$() {
  if ((!$n_Lcats_kernel_instances_VectorMonoid$)) {
    $n_Lcats_kernel_instances_VectorMonoid$ = new $c_Lcats_kernel_instances_VectorMonoid$();
  }
  return $n_Lcats_kernel_instances_VectorMonoid$;
}
/** @constructor */
function $c_Lcats_package$() {
  this.Lcats_package$__f_catsInstancesForId = null;
  this.Lcats_package$__f_Eq = null;
  this.Lcats_package$__f_PartialOrder = null;
  this.Lcats_package$__f_Order = null;
  this.Lcats_package$__f_Hash = null;
  this.Lcats_package$__f_Semigroup = null;
  $n_Lcats_package$ = this;
  this.Lcats_package$__f_catsInstancesForId = new $c_Lcats_package$$anon$1();
  new $c_Lcats_package$$anon$2();
  new $c_Lcats_package$$anon$3();
  var this$2 = $m_Lcats_Parallel$();
  var evidence$1 = $m_Lcats_package$().Lcats_package$__f_catsInstancesForId;
  new $c_Lcats_Parallel$$anon$2(evidence$1, this$2);
  this.Lcats_package$__f_Eq = $m_Lcats_kernel_Eq$();
  this.Lcats_package$__f_PartialOrder = $m_Lcats_kernel_PartialOrder$();
  this.Lcats_package$__f_Order = $m_Lcats_kernel_Order$();
  $m_Lcats_kernel_Comparison$();
  this.Lcats_package$__f_Hash = $m_Lcats_kernel_Hash$();
  this.Lcats_package$__f_Semigroup = $m_Lcats_kernel_Semigroup$();
}
$c_Lcats_package$.prototype = new $h_O();
$c_Lcats_package$.prototype.constructor = $c_Lcats_package$;
/** @constructor */
function $h_Lcats_package$() {
}
$h_Lcats_package$.prototype = $c_Lcats_package$.prototype;
var $d_Lcats_package$ = new $TypeData().initClass($c_Lcats_package$, "cats.package$", ({
  Lcats_package$: 1
}));
var $n_Lcats_package$;
function $m_Lcats_package$() {
  if ((!$n_Lcats_package$)) {
    $n_Lcats_package$ = new $c_Lcats_package$();
  }
  return $n_Lcats_package$;
}
/** @constructor */
function $c_Lcats_syntax_ApplicativeErrorOps$() {
}
$c_Lcats_syntax_ApplicativeErrorOps$.prototype = new $h_O();
$c_Lcats_syntax_ApplicativeErrorOps$.prototype.constructor = $c_Lcats_syntax_ApplicativeErrorOps$;
/** @constructor */
function $h_Lcats_syntax_ApplicativeErrorOps$() {
}
$h_Lcats_syntax_ApplicativeErrorOps$.prototype = $c_Lcats_syntax_ApplicativeErrorOps$.prototype;
$c_Lcats_syntax_ApplicativeErrorOps$.prototype.orElse$extension__O__F0__Lcats_ApplicativeError__O = (function(this$, other, F) {
  return $n(F).handleErrorWith__O__F1__O(this$, new $c_sjsr_AnonFunction1(((_$7) => $n(other).apply__O())));
});
var $d_Lcats_syntax_ApplicativeErrorOps$ = new $TypeData().initClass($c_Lcats_syntax_ApplicativeErrorOps$, "cats.syntax.ApplicativeErrorOps$", ({
  Lcats_syntax_ApplicativeErrorOps$: 1
}));
var $n_Lcats_syntax_ApplicativeErrorOps$;
function $m_Lcats_syntax_ApplicativeErrorOps$() {
  if ((!$n_Lcats_syntax_ApplicativeErrorOps$)) {
    $n_Lcats_syntax_ApplicativeErrorOps$ = new $c_Lcats_syntax_ApplicativeErrorOps$();
  }
  return $n_Lcats_syntax_ApplicativeErrorOps$;
}
/** @constructor */
function $c_Lcats_syntax_EitherOps$() {
}
$c_Lcats_syntax_EitherOps$.prototype = new $h_O();
$c_Lcats_syntax_EitherOps$.prototype.constructor = $c_Lcats_syntax_EitherOps$;
/** @constructor */
function $h_Lcats_syntax_EitherOps$() {
}
$h_Lcats_syntax_EitherOps$.prototype = $c_Lcats_syntax_EitherOps$.prototype;
$c_Lcats_syntax_EitherOps$.prototype.toValidated$extension__s_util_Either__Lcats_data_Validated = (function(this$) {
  if ((this$ instanceof $c_s_util_Left)) {
    var a = $n($as_s_util_Left(this$)).s_util_Left__f_value;
    $m_Lcats_data_Validated$();
    return new $c_Lcats_data_Validated$Invalid(a);
  }
  if ((this$ instanceof $c_s_util_Right)) {
    var b = $n($as_s_util_Right(this$)).s_util_Right__f_value;
    $m_Lcats_data_Validated$();
    return new $c_Lcats_data_Validated$Valid(b);
  }
  throw new $c_s_MatchError(this$);
});
$c_Lcats_syntax_EitherOps$.prototype.toEitherNec$extension__s_util_Either__s_util_Either = (function(this$) {
  if ((this$ instanceof $c_s_util_Left)) {
    var a = $n($as_s_util_Left(this$)).s_util_Left__f_value;
    var value = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptyChain).one__O__O(a);
    return new $c_s_util_Left(value);
  }
  if ((this$ instanceof $c_s_util_Right)) {
    var r = $as_s_util_Right(this$);
    $m_Lcats_syntax_EitherUtil$();
    return r;
  }
  throw new $c_s_MatchError(this$);
});
var $d_Lcats_syntax_EitherOps$ = new $TypeData().initClass($c_Lcats_syntax_EitherOps$, "cats.syntax.EitherOps$", ({
  Lcats_syntax_EitherOps$: 1
}));
var $n_Lcats_syntax_EitherOps$;
function $m_Lcats_syntax_EitherOps$() {
  if ((!$n_Lcats_syntax_EitherOps$)) {
    $n_Lcats_syntax_EitherOps$ = new $c_Lcats_syntax_EitherOps$();
  }
  return $n_Lcats_syntax_EitherOps$;
}
/** @constructor */
function $c_Lcats_syntax_EitherUtil$() {
  this.Lcats_syntax_EitherUtil$__f_unit = null;
  $n_Lcats_syntax_EitherUtil$ = this;
  this.Lcats_syntax_EitherUtil$__f_unit = new $c_s_util_Right((void 0));
}
$c_Lcats_syntax_EitherUtil$.prototype = new $h_O();
$c_Lcats_syntax_EitherUtil$.prototype.constructor = $c_Lcats_syntax_EitherUtil$;
/** @constructor */
function $h_Lcats_syntax_EitherUtil$() {
}
$h_Lcats_syntax_EitherUtil$.prototype = $c_Lcats_syntax_EitherUtil$.prototype;
var $d_Lcats_syntax_EitherUtil$ = new $TypeData().initClass($c_Lcats_syntax_EitherUtil$, "cats.syntax.EitherUtil$", ({
  Lcats_syntax_EitherUtil$: 1
}));
var $n_Lcats_syntax_EitherUtil$;
function $m_Lcats_syntax_EitherUtil$() {
  if ((!$n_Lcats_syntax_EitherUtil$)) {
    $n_Lcats_syntax_EitherUtil$ = new $c_Lcats_syntax_EitherUtil$();
  }
  return $n_Lcats_syntax_EitherUtil$;
}
/** @constructor */
function $c_Lcats_syntax_FlatMapOps$() {
}
$c_Lcats_syntax_FlatMapOps$.prototype = new $h_O();
$c_Lcats_syntax_FlatMapOps$.prototype.constructor = $c_Lcats_syntax_FlatMapOps$;
/** @constructor */
function $h_Lcats_syntax_FlatMapOps$() {
}
$h_Lcats_syntax_FlatMapOps$.prototype = $c_Lcats_syntax_FlatMapOps$.prototype;
$c_Lcats_syntax_FlatMapOps$.prototype.$greater$greater$extension__O__F0__Lcats_FlatMap__O = (function(this$, fb, F) {
  return $n(F).flatMap__O__F1__O(this$, new $c_sjsr_AnonFunction1(((_$5) => $n(fb).apply__O())));
});
var $d_Lcats_syntax_FlatMapOps$ = new $TypeData().initClass($c_Lcats_syntax_FlatMapOps$, "cats.syntax.FlatMapOps$", ({
  Lcats_syntax_FlatMapOps$: 1
}));
var $n_Lcats_syntax_FlatMapOps$;
function $m_Lcats_syntax_FlatMapOps$() {
  if ((!$n_Lcats_syntax_FlatMapOps$)) {
    $n_Lcats_syntax_FlatMapOps$ = new $c_Lcats_syntax_FlatMapOps$();
  }
  return $n_Lcats_syntax_FlatMapOps$;
}
/** @constructor */
function $c_Lcats_syntax_FoldableOps$() {
}
$c_Lcats_syntax_FoldableOps$.prototype = new $h_O();
$c_Lcats_syntax_FoldableOps$.prototype.constructor = $c_Lcats_syntax_FoldableOps$;
/** @constructor */
function $h_Lcats_syntax_FoldableOps$() {
}
$h_Lcats_syntax_FoldableOps$.prototype = $c_Lcats_syntax_FoldableOps$.prototype;
$c_Lcats_syntax_FoldableOps$.prototype.mkString_$extension__O__T__T__T__Lcats_Show__Lcats_Foldable__T = (function(this$, prefix, delim, suffix, A, F) {
  var b = $as_scm_StringBuilder($n(F).foldLeft__O__O__F2__O(this$, $ct_scm_StringBuilder__(new $c_scm_StringBuilder()), new $c_sjsr_AnonFunction2(((builder, a) => {
    var builder$1 = $as_scm_StringBuilder(builder);
    return $n($n(builder$1).append__T__scm_StringBuilder($n(A).show__O__T(a))).append__T__scm_StringBuilder(delim);
  }))));
  if ($n(b).isEmpty__Z()) {
    var $x_1 = "";
  } else {
    var $x_2 = $m_sc_StringOps$();
    var this$2 = $n(b);
    var x = $n(this$2.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content;
    var this$4 = $n(delim);
    var $x_1 = $n($x_2).dropRight$extension__T__I__T(x, this$4.length);
  }
  return ((("" + prefix) + $x_1) + suffix);
});
var $d_Lcats_syntax_FoldableOps$ = new $TypeData().initClass($c_Lcats_syntax_FoldableOps$, "cats.syntax.FoldableOps$", ({
  Lcats_syntax_FoldableOps$: 1
}));
var $n_Lcats_syntax_FoldableOps$;
function $m_Lcats_syntax_FoldableOps$() {
  if ((!$n_Lcats_syntax_FoldableOps$)) {
    $n_Lcats_syntax_FoldableOps$ = new $c_Lcats_syntax_FoldableOps$();
  }
  return $n_Lcats_syntax_FoldableOps$;
}
/** @constructor */
function $c_Lcats_syntax_MonadErrorRethrowOps$() {
}
$c_Lcats_syntax_MonadErrorRethrowOps$.prototype = new $h_O();
$c_Lcats_syntax_MonadErrorRethrowOps$.prototype.constructor = $c_Lcats_syntax_MonadErrorRethrowOps$;
/** @constructor */
function $h_Lcats_syntax_MonadErrorRethrowOps$() {
}
$h_Lcats_syntax_MonadErrorRethrowOps$.prototype = $c_Lcats_syntax_MonadErrorRethrowOps$.prototype;
$c_Lcats_syntax_MonadErrorRethrowOps$.prototype.rethrow$extension__O__Lcats_MonadError__O = (function(this$, F) {
  return $n(F).flatMap__O__F1__O(this$, new $c_sjsr_AnonFunction1(((_$5) => {
    var _$5$1 = $as_s_util_Either(_$5);
    var this$2 = $n(_$5$1);
    if ((this$2 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$2);
      var b = $n(x2).s_util_Right__f_value;
      return $n(F).pure__O__O(b);
    } else if ((this$2 instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(this$2);
      var a = $n(x3).s_util_Left__f_value;
      return $n(F).raiseError__O__O(a);
    } else {
      throw new $c_s_MatchError(this$2);
    }
  })));
});
var $d_Lcats_syntax_MonadErrorRethrowOps$ = new $TypeData().initClass($c_Lcats_syntax_MonadErrorRethrowOps$, "cats.syntax.MonadErrorRethrowOps$", ({
  Lcats_syntax_MonadErrorRethrowOps$: 1
}));
var $n_Lcats_syntax_MonadErrorRethrowOps$;
function $m_Lcats_syntax_MonadErrorRethrowOps$() {
  if ((!$n_Lcats_syntax_MonadErrorRethrowOps$)) {
    $n_Lcats_syntax_MonadErrorRethrowOps$ = new $c_Lcats_syntax_MonadErrorRethrowOps$();
  }
  return $n_Lcats_syntax_MonadErrorRethrowOps$;
}
/** @constructor */
function $c_Lcats_syntax_SeparateOps$() {
}
$c_Lcats_syntax_SeparateOps$.prototype = new $h_O();
$c_Lcats_syntax_SeparateOps$.prototype.constructor = $c_Lcats_syntax_SeparateOps$;
/** @constructor */
function $h_Lcats_syntax_SeparateOps$() {
}
$h_Lcats_syntax_SeparateOps$.prototype = $c_Lcats_syntax_SeparateOps$.prototype;
$c_Lcats_syntax_SeparateOps$.prototype.equals$extension__O__O__Z = (function(this$, x$0) {
  if ((x$0 instanceof $c_Lcats_syntax_SeparateOps)) {
    var x$0$2 = ((x$0 === null) ? null : $n($as_Lcats_syntax_SeparateOps(x$0)).Lcats_syntax_SeparateOps__f_fgab);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(this$, x$0$2);
  } else {
    return false;
  }
});
var $d_Lcats_syntax_SeparateOps$ = new $TypeData().initClass($c_Lcats_syntax_SeparateOps$, "cats.syntax.SeparateOps$", ({
  Lcats_syntax_SeparateOps$: 1
}));
var $n_Lcats_syntax_SeparateOps$;
function $m_Lcats_syntax_SeparateOps$() {
  if ((!$n_Lcats_syntax_SeparateOps$)) {
    $n_Lcats_syntax_SeparateOps$ = new $c_Lcats_syntax_SeparateOps$();
  }
  return $n_Lcats_syntax_SeparateOps$;
}
function $f_Lcats_syntax_SeparateOpsBinCompat0__separate__Lcats_FlatMap__Lcats_Alternative__Lcats_Bifoldable__T2($thiz, F, A, G) {
  var this$1 = $n(A);
  var fgab = $n($as_Lcats_syntax_SeparateOps($thiz)).Lcats_syntax_SeparateOps__f_fgab;
  return $f_Lcats_Alternative__separate__O__Lcats_FlatMap__Lcats_Bifoldable__T2(this$1, fgab, F, G);
}
/** @constructor */
function $c_Ldev_sungkm_enchantedrealm_AsyncIterableExtensions$() {
}
$c_Ldev_sungkm_enchantedrealm_AsyncIterableExtensions$.prototype = new $h_O();
$c_Ldev_sungkm_enchantedrealm_AsyncIterableExtensions$.prototype.constructor = $c_Ldev_sungkm_enchantedrealm_AsyncIterableExtensions$;
/** @constructor */
function $h_Ldev_sungkm_enchantedrealm_AsyncIterableExtensions$() {
}
$h_Ldev_sungkm_enchantedrealm_AsyncIterableExtensions$.prototype = $c_Ldev_sungkm_enchantedrealm_AsyncIterableExtensions$.prototype;
$c_Ldev_sungkm_enchantedrealm_AsyncIterableExtensions$.prototype.toStream__Ltypings_std_AsyncIterable__Lcats_effect_kernel_Async__Lfs2_Stream = (function(iterable, evidence$1) {
  return $m_Lfs2_Stream$().unfoldEval__O__F1__Lfs2_Stream(iterable, new $c_sjsr_AnonFunction1(((iter) => {
    var this$4 = $n(evidence$1);
    var fut = $n(evidence$1).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
      var p = iter.next([]);
      return $m_sjs_js_Thenable$ThenableOps$().toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p);
    })));
    var target = $f_Lcats_effect_kernel_Async__fromFuture__O__O(this$4, fut);
    var this$9 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, evidence$1);
    var f = new $c_sjsr_AnonFunction1(((result) => {
      var v = result.done;
      if ((v === (void 0))) {
        var cond = true;
      } else {
        var cond = (!$uZ(result.done));
      }
      if (cond) {
        var _1 = result.value;
        return new $c_s_Some(new $c_T2(_1, iter));
      } else {
        return $m_s_None$();
      }
    }));
    return $n(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  })));
});
var $d_Ldev_sungkm_enchantedrealm_AsyncIterableExtensions$ = new $TypeData().initClass($c_Ldev_sungkm_enchantedrealm_AsyncIterableExtensions$, "dev.sungkm.enchantedrealm.AsyncIterableExtensions$", ({
  Ldev_sungkm_enchantedrealm_AsyncIterableExtensions$: 1
}));
var $n_Ldev_sungkm_enchantedrealm_AsyncIterableExtensions$;
function $m_Ldev_sungkm_enchantedrealm_AsyncIterableExtensions$() {
  if ((!$n_Ldev_sungkm_enchantedrealm_AsyncIterableExtensions$)) {
    $n_Ldev_sungkm_enchantedrealm_AsyncIterableExtensions$ = new $c_Ldev_sungkm_enchantedrealm_AsyncIterableExtensions$();
  }
  return $n_Ldev_sungkm_enchantedrealm_AsyncIterableExtensions$;
}
/** @constructor */
function $c_Ldev_sungkm_enchantedrealm_Engine$() {
  this.Ldev_sungkm_enchantedrealm_Engine$__f_selectedModel = null;
  this.Ldev_sungkm_enchantedrealm_Engine$__f_selectedModel = "Llama-3.1-8B-Instruct-q4f32_1-MLC";
}
$c_Ldev_sungkm_enchantedrealm_Engine$.prototype = new $h_O();
$c_Ldev_sungkm_enchantedrealm_Engine$.prototype.constructor = $c_Ldev_sungkm_enchantedrealm_Engine$;
/** @constructor */
function $h_Ldev_sungkm_enchantedrealm_Engine$() {
}
$h_Ldev_sungkm_enchantedrealm_Engine$.prototype = $c_Ldev_sungkm_enchantedrealm_Engine$.prototype;
$c_Ldev_sungkm_enchantedrealm_Engine$.prototype.engine__F1__Lcats_effect_kernel_Async__O = (function(initProgressCallback, evidence$1) {
  var fields = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([]));
  var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var value = $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(initProgressCallback);
  _\uff3fobj.initProgressCallback = value;
  var this$7 = $n(evidence$1);
  var fut = $n(evidence$1).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
    var p = $i_$0040mlc$002dai$002fweb$002dllm.CreateServiceWorkerMLCEngine("Llama-3.1-8B-Instruct-q4f32_1-MLC", _\uff3fobj);
    return $m_sjs_js_Thenable$ThenableOps$().toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p);
  })));
  return $f_Lcats_effect_kernel_Async__fromFuture__O__O(this$7, fut);
});
var $d_Ldev_sungkm_enchantedrealm_Engine$ = new $TypeData().initClass($c_Ldev_sungkm_enchantedrealm_Engine$, "dev.sungkm.enchantedrealm.Engine$", ({
  Ldev_sungkm_enchantedrealm_Engine$: 1
}));
var $n_Ldev_sungkm_enchantedrealm_Engine$;
function $m_Ldev_sungkm_enchantedrealm_Engine$() {
  if ((!$n_Ldev_sungkm_enchantedrealm_Engine$)) {
    $n_Ldev_sungkm_enchantedrealm_Engine$ = new $c_Ldev_sungkm_enchantedrealm_Engine$();
  }
  return $n_Ldev_sungkm_enchantedrealm_Engine$;
}
function $s_Ldev_sungkm_enchantedrealm_Main__main__AT__V(args) {
  var this$1 = $m_Ldev_sungkm_enchantedrealm_Main$();
  $f_Lcats_effect_ResourceApp$Forever__main__AT__V(this$1, args);
}
/** @constructor */
function $c_Ldev_sungkm_enchantedrealm_Message$() {
}
$c_Ldev_sungkm_enchantedrealm_Message$.prototype = new $h_O();
$c_Ldev_sungkm_enchantedrealm_Message$.prototype.constructor = $c_Ldev_sungkm_enchantedrealm_Message$;
/** @constructor */
function $h_Ldev_sungkm_enchantedrealm_Message$() {
}
$h_Ldev_sungkm_enchantedrealm_Message$.prototype = $c_Ldev_sungkm_enchantedrealm_Message$.prototype;
$c_Ldev_sungkm_enchantedrealm_Message$.prototype.user__T__Ltypings_mlcAiWebLlm_libOpenaiApiProtocolsChatCompletionMod_ChatCompletionMessageParam = (function(content) {
  var fields = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([new $c_T2("content", content), new $c_T2("role", "user")]));
  var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  return _\uff3fobj;
});
var $d_Ldev_sungkm_enchantedrealm_Message$ = new $TypeData().initClass($c_Ldev_sungkm_enchantedrealm_Message$, "dev.sungkm.enchantedrealm.Message$", ({
  Ldev_sungkm_enchantedrealm_Message$: 1
}));
var $n_Ldev_sungkm_enchantedrealm_Message$;
function $m_Ldev_sungkm_enchantedrealm_Message$() {
  if ((!$n_Ldev_sungkm_enchantedrealm_Message$)) {
    $n_Ldev_sungkm_enchantedrealm_Message$ = new $c_Ldev_sungkm_enchantedrealm_Message$();
  }
  return $n_Ldev_sungkm_enchantedrealm_Message$;
}
function $p_Ldev_sungkm_enchantedrealm_Prompt$__chooseRandom$1__Lcats_effect_std_Random__Lcats_effect_kernel_Async__sci_Seq__O($thiz, evidence$2$1, evidence$1$1, list) {
  var target = $n(evidence$2$1).betweenInt__I__I__O(0, (((-1) + $n(list).length__I()) | 0));
  var this$3 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, evidence$1$1);
  var f = new $c_sjsr_AnonFunction1(((_$2) => {
    var _$2$1 = $uI(_$2);
    return $n(list).apply__I__O(_$2$1);
  }));
  return $n(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
}
/** @constructor */
function $c_Ldev_sungkm_enchantedrealm_Prompt$() {
}
$c_Ldev_sungkm_enchantedrealm_Prompt$.prototype = new $h_O();
$c_Ldev_sungkm_enchantedrealm_Prompt$.prototype.constructor = $c_Ldev_sungkm_enchantedrealm_Prompt$;
/** @constructor */
function $h_Ldev_sungkm_enchantedrealm_Prompt$() {
}
$h_Ldev_sungkm_enchantedrealm_Prompt$.prototype = $c_Ldev_sungkm_enchantedrealm_Prompt$.prototype;
$c_Ldev_sungkm_enchantedrealm_Prompt$.prototype.sendInitialPrompt__Ltypings_mlcAiWebLlm_libServiceWorkerMod$ServiceWorkerMLCEngine__Lcats_effect_kernel_Async__Lcats_effect_std_Random__O = (function(engine, evidence$1, evidence$2) {
  var target = $p_Ldev_sungkm_enchantedrealm_Prompt$__chooseRandom$1__Lcats_effect_std_Random__Lcats_effect_kernel_Async__sci_Seq__O(this, evidence$2, evidence$1, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["Coastal", "Mountain", "Forest", "Desert", "Swamp"])));
  var this$26 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, evidence$1);
  var f$2 = new $c_sjsr_AnonFunction1(((villageType) => {
    var villageType$1 = $as_T(villageType);
    var target$1 = $p_Ldev_sungkm_enchantedrealm_Prompt$__chooseRandom$1__Lcats_effect_std_Random__Lcats_effect_kernel_Async__sci_Seq__O(this, evidence$2, evidence$1, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["Natural disaster", "Economic crisis", "Magical threat", "Political conflict", "Social issue"])));
    var this$25 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, evidence$1);
    var f$1 = new $c_sjsr_AnonFunction1(((mainChallenge) => {
      var mainChallenge$1 = $as_T(mainChallenge);
      var target$2 = $p_Ldev_sungkm_enchantedrealm_Prompt$__chooseRandom$1__Lcats_effect_std_Random__Lcats_effect_kernel_Async__sci_Seq__O(this, evidence$2, evidence$1, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["Ancient", "Medieval", "Renaissance", "Industrial revolution-esque", "Post-apocalyptic"])));
      var this$24 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, evidence$1);
      var f = new $c_sjsr_AnonFunction1(((timePeriod) => {
        var timePeriod$1 = $as_T(timePeriod);
        var x = ("Village Type: " + villageType$1);
        var this$6 = $m_s_Console$();
        $n(this$6.out__Ljava_io_PrintStream()).println__O__V(x);
        var x$1 = ("Main Challenge: " + mainChallenge$1);
        var this$8 = $m_s_Console$();
        $n(this$8.out__Ljava_io_PrintStream()).println__O__V(x$1);
        var x$2 = ("Time Period: " + timePeriod$1);
        var this$10 = $m_s_Console$();
        $n(this$10.out__Ljava_io_PrintStream()).println__O__V(x$2);
        var messages$proxy1 = [$m_Ldev_sungkm_enchantedrealm_Message$().user__T__Ltypings_mlcAiWebLlm_libOpenaiApiProtocolsChatCompletionMod_ChatCompletionMessageParam($m_Ldev_sungkm_enchantedrealm_Prompt$().initialPrompt__T__T__T__T(villageType$1, mainChallenge$1, timePeriod$1))];
        var fields = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([new $c_T2("messages", messages$proxy1), new $c_T2("stream", true)]));
        var _\uff3fobj = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
        _\uff3fobj.temperature = 0.6;
        _\uff3fobj.max_tokens = 4000.0;
        var fields$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([]));
        var _\uff3fobj$2 = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields$1);
        _\uff3fobj$2.include_usage = true;
        _\uff3fobj.stream_options = _\uff3fobj$2;
        return _\uff3fobj;
      }));
      return $n(this$24.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$24.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
    }));
    return $n(this$25.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$25.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
  }));
  var requestF = $n(this$26.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$26.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
  var this$57 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(requestF, evidence$1);
  var f$4 = new $c_sjsr_AnonFunction1(((request) => {
    var this$33 = $n(evidence$1);
    var fut = $n(evidence$1).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
      var this$31 = $m_s_Console$();
      $n(this$31.out__Ljava_io_PrintStream()).println__O__V("Sending initial prompt");
      var p = engine.chat.completions.create(request);
      return $m_sjs_js_Thenable$ThenableOps$().toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p);
    })));
    var target$3 = $f_Lcats_effect_kernel_Async__fromFuture__O__O(this$33, fut);
    var this$56 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, evidence$1);
    var f$3 = new $c_sjsr_AnonFunction1(((asyncIterable) => $n($m_Ldev_sungkm_enchantedrealm_AsyncIterableExtensions$().toStream__Ltypings_std_AsyncIterable__Lcats_effect_kernel_Async__Lfs2_Stream(asyncIterable, evidence$1)).map__F1__Lfs2_Stream(new $c_sjsr_AnonFunction1(((chunk) => {
      var x$3 = chunk.usage;
      if ((x$3 !== (void 0))) {
        var x$4 = ("Prompt Tokens: " + $uD(x$3.prompt_tokens));
        var this$41 = $m_s_Console$();
        $n(this$41.out__Ljava_io_PrintStream()).println__O__V(x$4);
        var x$5 = ("Completion Tokens: " + $uD(x$3.completion_tokens));
        var this$43 = $m_s_Console$();
        $n(this$43.out__Ljava_io_PrintStream()).println__O__V(x$5);
        var x$6 = ("Total Tokens: " + $uD(x$3.total_tokens));
        var this$45 = $m_s_Console$();
        $n(this$45.out__Ljava_io_PrintStream()).println__O__V(x$6);
      }
      var array = chunk.choices;
      var this$47 = $n($m_sjs_js_ArrayOps$().headOption$extension__sjs_js_Array__s_Option(array));
      if (this$47.isEmpty__Z()) {
        var $x_1 = $m_s_None$();
      } else {
        var arg1 = this$47.get__O();
        var delta = arg1.delta;
        var $x_1 = new $c_s_Some(new $c_T2(arg1, delta));
      }
      var this$49 = $n($x_1);
      if (this$49.isEmpty__Z()) {
        return $m_s_None$();
      } else {
        var arg1$1 = this$49.get__O();
        var x$1$1 = $as_T2(arg1$1);
        if ((x$1$1 !== null)) {
          $n(x$1$1)._1__O();
          var delta$1 = $n(x$1$1)._2__O();
          var x$7 = delta$1.content;
          var this$55 = $n(((x$7 === (void 0)) ? $m_s_None$() : new $c_s_Some(x$7)));
          if (this$55.isEmpty__Z()) {
            return $m_s_None$();
          } else {
            var arg1$2 = this$55.get__O();
            var content = $as_T(arg1$2);
            return new $c_s_Some(content);
          }
        }
        throw new $c_s_MatchError(x$1$1);
      }
    })))));
    return $n(this$56.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$56.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$3);
  }));
  return $n(this$57.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$57.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$4);
});
$c_Ldev_sungkm_enchantedrealm_Prompt$.prototype.initialPrompt__T__T__T__T = (function(villageType, mainChallenge, timePeriod) {
  return (((((("You are a storyteller for a fantasy village management game called \"Enchanted Realm\". Create a unique and diverse initial scenario for the game based on the following parameters:\n\nVillage Type: [" + villageType) + "]\nMain Challenge: [") + mainChallenge) + "]\nTime Period: [") + timePeriod) + "]\n\nInclude:\n\n1. A short description of the village based on the given type and time period (2-3 sentences).\n2. A pressing issue the village is facing, based on the given main challenge (1-2 sentences).\n3. Three distinct NPCs, each with a name and one-line description. Ensure they have diverse backgrounds and perspectives related to the village type, challenge, or time period.\n4. Three meaningful and creative choices the player (as the village leader) can make to address the issue. These should present different approaches to the problem.\n\nYour response should be concise yet evocative, setting the stage for an interesting decision. Format your response as follows:\n\nVillage:\n[Village description]\n\nIssue:\n[The pressing issue]\n\nNPCs:\n1. [Name]: [One-line description]\n2. [Name]: [One-line description]\n3. [Name]: [One-line description]\n\nChoices:\n1. [First choice]\n2. [Second choice]\n3. [Third choice]");
});
var $d_Ldev_sungkm_enchantedrealm_Prompt$ = new $TypeData().initClass($c_Ldev_sungkm_enchantedrealm_Prompt$, "dev.sungkm.enchantedrealm.Prompt$", ({
  Ldev_sungkm_enchantedrealm_Prompt$: 1
}));
var $n_Ldev_sungkm_enchantedrealm_Prompt$;
function $m_Ldev_sungkm_enchantedrealm_Prompt$() {
  if ((!$n_Ldev_sungkm_enchantedrealm_Prompt$)) {
    $n_Ldev_sungkm_enchantedrealm_Prompt$ = new $c_Ldev_sungkm_enchantedrealm_Prompt$();
  }
  return $n_Ldev_sungkm_enchantedrealm_Prompt$;
}
function $f_Lfs2_Compiler$TargetLowPriority__forSync__Lcats_effect_kernel_Sync__Lfs2_Compiler$Target($thiz, F) {
  if ($is_Lcats_effect_kernel_Async(F)) {
    var async = $as_Lcats_effect_kernel_Async(F);
    return new $c_Lfs2_Compiler$Target$ConcurrentTarget(async);
  } else {
    return new $c_Lfs2_Compiler$TargetLowPriority$SyncTarget(F);
  }
}
/** @constructor */
function $c_Lfs2_Pull() {
}
$c_Lfs2_Pull.prototype = new $h_O();
$c_Lfs2_Pull.prototype.constructor = $c_Lfs2_Pull;
/** @constructor */
function $h_Lfs2_Pull() {
}
$h_Lfs2_Pull.prototype = $c_Lfs2_Pull.prototype;
function $as_Lfs2_Pull(obj) {
  return (((obj instanceof $c_Lfs2_Pull) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull"));
}
function $isArrayOf_Lfs2_Pull(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull)));
}
function $asArrayOf_Lfs2_Pull(obj, depth) {
  return (($isArrayOf_Lfs2_Pull(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull;", depth));
}
/** @constructor */
function $c_Lfs2_Pull$IdOps$() {
}
$c_Lfs2_Pull$IdOps$.prototype = new $h_O();
$c_Lfs2_Pull$IdOps$.prototype.constructor = $c_Lfs2_Pull$IdOps$;
/** @constructor */
function $h_Lfs2_Pull$IdOps$() {
}
$h_Lfs2_Pull$IdOps$.prototype = $c_Lfs2_Pull$IdOps$.prototype;
$c_Lfs2_Pull$IdOps$.prototype.covaryId$extension__Lfs2_Pull__Lcats_Applicative__Lfs2_Pull = (function(this$, evidence$4) {
  return $m_Lfs2_Pull$().translate__Lfs2_Pull__Lcats_arrow_FunctionK__Lfs2_Pull(this$, new $c_Lfs2_Pull$IdOps$$anon$10(evidence$4, this));
});
var $d_Lfs2_Pull$IdOps$ = new $TypeData().initClass($c_Lfs2_Pull$IdOps$, "fs2.Pull$IdOps$", ({
  Lfs2_Pull$IdOps$: 1
}));
var $n_Lfs2_Pull$IdOps$;
function $m_Lfs2_Pull$IdOps$() {
  if ((!$n_Lfs2_Pull$IdOps$)) {
    $n_Lfs2_Pull$IdOps$ = new $c_Lfs2_Pull$IdOps$();
  }
  return $n_Lfs2_Pull$IdOps$;
}
function $is_Lfs2_Pull$Run$1(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lfs2_Pull$Run$1)));
}
function $as_Lfs2_Pull$Run$1(obj) {
  return (($is_Lfs2_Pull$Run$1(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Run$1"));
}
function $isArrayOf_Lfs2_Pull$Run$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Run$1)));
}
function $asArrayOf_Lfs2_Pull$Run$1(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Run$1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Run$1;", depth));
}
/** @constructor */
function $c_Lfs2_Pull$StreamPullOps$() {
}
$c_Lfs2_Pull$StreamPullOps$.prototype = new $h_O();
$c_Lfs2_Pull$StreamPullOps$.prototype.constructor = $c_Lfs2_Pull$StreamPullOps$;
/** @constructor */
function $h_Lfs2_Pull$StreamPullOps$() {
}
$h_Lfs2_Pull$StreamPullOps$.prototype = $c_Lfs2_Pull$StreamPullOps$.prototype;
$c_Lfs2_Pull$StreamPullOps$.prototype.flatMapOutput$extension__Lfs2_Pull__F1__Lfs2_Pull = (function(this$, f) {
  if ((this$ instanceof $c_Lfs2_Pull$AlgEffect)) {
    var a = $as_Lfs2_Pull$AlgEffect(this$);
    var $x_1 = a;
  } else if ((this$ instanceof $c_Lfs2_Pull$Terminal)) {
    var r = $as_Lfs2_Pull$Terminal(this$);
    var $x_1 = r;
  } else {
    var $x_1 = new $c_Lfs2_Pull$FlatMapOutput(this$, f);
  }
  return $as_Lfs2_Pull($x_1);
});
$c_Lfs2_Pull$StreamPullOps$.prototype.unconsFlatMap$extension__Lfs2_Pull__F1__Lfs2_Pull = (function(this$, f) {
  var this$4 = $n(this.uncons$extension__Lfs2_Pull__Lfs2_Pull(this$));
  var f$1 = new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_s_Option(x$1);
    var x = $m_s_None$();
    if ((x === x$1$1)) {
      return $m_Lfs2_Pull$().Lfs2_Pull$__f_done;
    }
    if ((x$1$1 instanceof $c_s_Some)) {
      var x35 = $as_T2($n($as_s_Some(x$1$1)).s_Some__f_value);
      if ((x35 !== null)) {
        var hd = $as_Lfs2_Chunk($n(x35)._1__O());
        var tl = $as_Lfs2_Pull($n(x35)._2__O());
        var this$3 = $n($as_Lfs2_Pull($n(f).apply__O__O(hd)));
        var post = new $c_sjsr_AnonFunction0((() => this.unconsFlatMap$extension__Lfs2_Pull__F1__Lfs2_Pull(($m_Lfs2_Pull$(), tl), f)));
        return new $c_Lfs2_Pull$$anon$2(post, this$3);
      }
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return new $c_Lfs2_Pull$$anon$1(f$1, this$4);
});
$c_Lfs2_Pull$StreamPullOps$.prototype.uncons$extension__Lfs2_Pull__Lfs2_Pull = (function(this$) {
  if ((this$ instanceof $c_Lfs2_Pull$Succeeded)) {
    var x$1 = $as_Lfs2_Pull$Succeeded(this$);
    var this$2 = $n(x$1);
    $as_jl_Void(this$2.Lfs2_Pull$Succeeded__f_r);
    var r = $m_s_None$();
    var $x_1 = new $c_Lfs2_Pull$Succeeded(r);
  } else if ((this$ instanceof $c_Lfs2_Pull$Output)) {
    var x$1$1 = $as_Lfs2_Pull$Output(this$);
    var this$5 = $n(x$1$1);
    var x43 = this$5.Lfs2_Pull$Output__f_values;
    var y = $m_Lfs2_Pull$().Lfs2_Pull$__f_fs2$Pull$$$unit;
    var value = new $c_T2(x43, y);
    var r$1 = new $c_s_Some(value);
    var $x_1 = new $c_Lfs2_Pull$Succeeded(r$1);
  } else if ((this$ instanceof $c_Lfs2_Pull$Fail)) {
    var ff = $as_Lfs2_Pull$Fail(this$);
    var $x_1 = ff;
  } else if ((this$ instanceof $c_Lfs2_Pull$Interrupted)) {
    var it = $as_Lfs2_Pull$Interrupted(this$);
    var $x_1 = it;
  } else {
    var $x_1 = new $c_Lfs2_Pull$Uncons(this$);
  }
  return $as_Lfs2_Pull($x_1);
});
var $d_Lfs2_Pull$StreamPullOps$ = new $TypeData().initClass($c_Lfs2_Pull$StreamPullOps$, "fs2.Pull$StreamPullOps$", ({
  Lfs2_Pull$StreamPullOps$: 1
}));
var $n_Lfs2_Pull$StreamPullOps$;
function $m_Lfs2_Pull$StreamPullOps$() {
  if ((!$n_Lfs2_Pull$StreamPullOps$)) {
    $n_Lfs2_Pull$StreamPullOps$ = new $c_Lfs2_Pull$StreamPullOps$();
  }
  return $n_Lfs2_Pull$StreamPullOps$;
}
/** @constructor */
function $c_Lfs2_Stream(underlying) {
  this.Lfs2_Stream__f_underlying = null;
  this.Lfs2_Stream__f_underlying = underlying;
}
$c_Lfs2_Stream.prototype = new $h_O();
$c_Lfs2_Stream.prototype.constructor = $c_Lfs2_Stream;
/** @constructor */
function $h_Lfs2_Stream() {
}
$h_Lfs2_Stream.prototype = $c_Lfs2_Stream.prototype;
$c_Lfs2_Stream.prototype.$plus$plus__F0__Lfs2_Stream = (function(s2) {
  $m_Lfs2_Pull$();
  var this$1 = $n(this.Lfs2_Stream__f_underlying);
  var post = new $c_sjsr_AnonFunction0((() => $n($as_Lfs2_Stream($n(s2).apply__O())).Lfs2_Stream__f_underlying));
  var self = new $c_Lfs2_Pull$$anon$2(post, this$1);
  return new $c_Lfs2_Stream(self);
});
$c_Lfs2_Stream.prototype.attempt__Lfs2_Stream = (function() {
  return $n(this.map__F1__Lfs2_Stream(new $c_sjsr_AnonFunction1(((_$3) => new $c_s_util_Right(_$3))))).handleErrorWith__F1__Lfs2_Stream(new $c_sjsr_AnonFunction1(((e) => {
    var e$1 = $as_jl_Throwable(e);
    return $m_Lfs2_Stream$().emit__O__Lfs2_Stream(new $c_s_util_Left(e$1));
  })));
});
$c_Lfs2_Stream.prototype.flatMap__F1__s_util_NotGiven__Lfs2_Stream = (function(f, ev) {
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
  var self = this.Lfs2_Stream__f_underlying;
  var self$1 = $m_Lfs2_Pull$StreamPullOps$().flatMapOutput$extension__Lfs2_Pull__F1__Lfs2_Pull(self, new $c_sjsr_AnonFunction1(((o) => $n($as_Lfs2_Stream($n(f).apply__O__O(o))).Lfs2_Stream__f_underlying)));
  return new $c_Lfs2_Stream(self$1);
});
$c_Lfs2_Stream.prototype.foreach__F1__Lfs2_Stream = (function(f) {
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
  var self = this.Lfs2_Stream__f_underlying;
  var self$1 = $m_Lfs2_Pull$StreamPullOps$().flatMapOutput$extension__Lfs2_Pull__F1__Lfs2_Pull(self, new $c_sjsr_AnonFunction1(((o) => {
    $m_Lfs2_Pull$();
    var fr = $n(f).apply__O__O(o);
    return new $c_Lfs2_Pull$Eval(fr);
  })));
  return new $c_Lfs2_Stream(self$1);
});
$c_Lfs2_Stream.prototype.handleErrorWith__F1__Lfs2_Stream = (function(h) {
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
  var s = this.Lfs2_Stream__f_underlying;
  var this$3 = new $c_Lfs2_Pull$InScope(s, false);
  var handler = new $c_sjsr_AnonFunction1(((e) => {
    var e$1 = $as_jl_Throwable(e);
    return $n($as_Lfs2_Stream($n(h).apply__O__O(e$1))).Lfs2_Stream__f_underlying;
  }));
  var self = new $c_Lfs2_Pull$$anon$3(handler, this$3);
  return new $c_Lfs2_Stream(self);
});
$c_Lfs2_Stream.prototype.map__F1__Lfs2_Stream = (function(f) {
  $m_Lfs2_Pull$();
  var self = $m_Lfs2_Pull$().mapOutput__Lfs2_Stream__F1__Lfs2_Pull(this, f);
  return new $c_Lfs2_Stream(self);
});
$c_Lfs2_Stream.prototype.repeat__Lfs2_Stream = (function() {
  return this.$plus$plus__F0__Lfs2_Stream(new $c_sjsr_AnonFunction0((() => this.repeat__Lfs2_Stream())));
});
$c_Lfs2_Stream.prototype.toString__T = (function() {
  return "Stream(..)";
});
function $as_Lfs2_Stream(obj) {
  return (((obj instanceof $c_Lfs2_Stream) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Stream"));
}
function $isArrayOf_Lfs2_Stream(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Stream)));
}
function $asArrayOf_Lfs2_Stream(obj, depth) {
  return (($isArrayOf_Lfs2_Stream(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Stream;", depth));
}
var $d_Lfs2_Stream = new $TypeData().initClass($c_Lfs2_Stream, "fs2.Stream", ({
  Lfs2_Stream: 1
}));
/** @constructor */
function $c_Lfs2_Stream$CompileOps(underlying, compiler) {
  this.Lfs2_Stream$CompileOps__f_underlying = null;
  this.Lfs2_Stream$CompileOps__f_compiler = null;
  this.Lfs2_Stream$CompileOps__f_underlying = underlying;
  this.Lfs2_Stream$CompileOps__f_compiler = compiler;
}
$c_Lfs2_Stream$CompileOps.prototype = new $h_O();
$c_Lfs2_Stream$CompileOps.prototype.constructor = $c_Lfs2_Stream$CompileOps;
/** @constructor */
function $h_Lfs2_Stream$CompileOps() {
}
$h_Lfs2_Stream$CompileOps.prototype = $c_Lfs2_Stream$CompileOps.prototype;
$c_Lfs2_Stream$CompileOps.prototype.drain__O = (function() {
  return this.foldChunks__O__F2__O((void 0), new $c_sjsr_AnonFunction2(((_$205, _$206) => {
    $as_jl_Void(_$205);
    $as_Lfs2_Chunk(_$206);
  })));
});
$c_Lfs2_Stream$CompileOps.prototype.foldChunks__O__F2__O = (function(init, f) {
  return $n(this.Lfs2_Stream$CompileOps__f_compiler).apply__Lfs2_Pull__O__F2__O(this.Lfs2_Stream$CompileOps__f_underlying, init, f);
});
var $d_Lfs2_Stream$CompileOps = new $TypeData().initClass($c_Lfs2_Stream$CompileOps, "fs2.Stream$CompileOps", ({
  Lfs2_Stream$CompileOps: 1
}));
/** @constructor */
function $c_Lfs2_Stream$StepLeg(head, scopeId, next) {
}
$c_Lfs2_Stream$StepLeg.prototype = new $h_O();
$c_Lfs2_Stream$StepLeg.prototype.constructor = $c_Lfs2_Stream$StepLeg;
/** @constructor */
function $h_Lfs2_Stream$StepLeg() {
}
$h_Lfs2_Stream$StepLeg.prototype = $c_Lfs2_Stream$StepLeg.prototype;
var $d_Lfs2_Stream$StepLeg = new $TypeData().initClass($c_Lfs2_Stream$StepLeg, "fs2.Stream$StepLeg", ({
  Lfs2_Stream$StepLeg: 1
}));
/** @constructor */
function $c_Lfs2_Stream$ToPull(self) {
  this.Lfs2_Stream$ToPull__f_self = null;
  this.Lfs2_Stream$ToPull__f_self = self;
}
$c_Lfs2_Stream$ToPull.prototype = new $h_O();
$c_Lfs2_Stream$ToPull.prototype.constructor = $c_Lfs2_Stream$ToPull;
/** @constructor */
function $h_Lfs2_Stream$ToPull() {
}
$h_Lfs2_Stream$ToPull.prototype = $c_Lfs2_Stream$ToPull.prototype;
$c_Lfs2_Stream$ToPull.prototype.hashCode__I = (function() {
  var this$ = this.Lfs2_Stream$ToPull__f_self;
  var this$2 = $n(this$);
  return $systemIdentityHashCode(this$2);
});
$c_Lfs2_Stream$ToPull.prototype.equals__O__Z = (function(x$0) {
  return $m_Lfs2_Stream$ToPull$().equals$extension__Lfs2_Stream__O__Z(this.Lfs2_Stream$ToPull__f_self, x$0);
});
function $as_Lfs2_Stream$ToPull(obj) {
  return (((obj instanceof $c_Lfs2_Stream$ToPull) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Stream$ToPull"));
}
function $isArrayOf_Lfs2_Stream$ToPull(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Stream$ToPull)));
}
function $asArrayOf_Lfs2_Stream$ToPull(obj, depth) {
  return (($isArrayOf_Lfs2_Stream$ToPull(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Stream$ToPull;", depth));
}
var $d_Lfs2_Stream$ToPull = new $TypeData().initClass($c_Lfs2_Stream$ToPull, "fs2.Stream$ToPull", ({
  Lfs2_Stream$ToPull: 1
}));
/** @constructor */
function $c_Lfs2_Stream$ToPull$() {
}
$c_Lfs2_Stream$ToPull$.prototype = new $h_O();
$c_Lfs2_Stream$ToPull$.prototype.constructor = $c_Lfs2_Stream$ToPull$;
/** @constructor */
function $h_Lfs2_Stream$ToPull$() {
}
$h_Lfs2_Stream$ToPull$.prototype = $c_Lfs2_Stream$ToPull$.prototype;
$c_Lfs2_Stream$ToPull$.prototype.equals$extension__Lfs2_Stream__O__Z = (function(this$, x$0) {
  if ((x$0 instanceof $c_Lfs2_Stream$ToPull)) {
    var x$0$2 = ((x$0 === null) ? null : $n($as_Lfs2_Stream$ToPull(x$0)).Lfs2_Stream$ToPull__f_self);
    if ((this$ === null)) {
      return (x$0$2 === null);
    } else {
      var this$1 = $n(this$);
      return (this$1 === x$0$2);
    }
  } else {
    return false;
  }
});
var $d_Lfs2_Stream$ToPull$ = new $TypeData().initClass($c_Lfs2_Stream$ToPull$, "fs2.Stream$ToPull$", ({
  Lfs2_Stream$ToPull$: 1
}));
var $n_Lfs2_Stream$ToPull$;
function $m_Lfs2_Stream$ToPull$() {
  if ((!$n_Lfs2_Stream$ToPull$)) {
    $n_Lfs2_Stream$ToPull$ = new $c_Lfs2_Stream$ToPull$();
  }
  return $n_Lfs2_Stream$ToPull$;
}
/** @constructor */
function $c_Lfs2_internal_InterruptContext$() {
}
$c_Lfs2_internal_InterruptContext$.prototype = new $h_O();
$c_Lfs2_internal_InterruptContext$.prototype.constructor = $c_Lfs2_internal_InterruptContext$;
/** @constructor */
function $h_Lfs2_internal_InterruptContext$() {
}
$h_Lfs2_internal_InterruptContext$.prototype = $c_Lfs2_internal_InterruptContext$.prototype;
$c_Lfs2_internal_InterruptContext$.prototype.apply__Lcats_effect_kernel_Unique$Token__O__Lcats_effect_kernel_GenConcurrent__O = (function(newScopeId, cancelParent, F) {
  var target = $n(F).ref__O__O($m_s_None$());
  var this$6 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F);
  var f$1 = new $c_sjsr_AnonFunction1(((ref) => {
    var ref$1 = $as_Lcats_effect_kernel_Ref(ref);
    var target$1 = $n(F).deferred__O();
    var this$5 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, F);
    var f = new $c_sjsr_AnonFunction1(((deferred) => {
      var deferred$1 = $as_Lcats_effect_kernel_Deferred(deferred);
      return new $c_Lfs2_internal_InterruptContext(deferred$1, ref$1, newScopeId, cancelParent, F);
    }));
    return $n(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  }));
  return $n(this$6.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$6.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
});
var $d_Lfs2_internal_InterruptContext$ = new $TypeData().initClass($c_Lfs2_internal_InterruptContext$, "fs2.internal.InterruptContext$", ({
  Lfs2_internal_InterruptContext$: 1
}));
var $n_Lfs2_internal_InterruptContext$;
function $m_Lfs2_internal_InterruptContext$() {
  if ((!$n_Lfs2_internal_InterruptContext$)) {
    $n_Lfs2_internal_InterruptContext$ = new $c_Lfs2_internal_InterruptContext$();
  }
  return $n_Lfs2_internal_InterruptContext$;
}
function $p_Lfs2_internal_Scope__register__Lfs2_internal_ScopedResource__O($thiz, resource) {
  return $n($thiz.Lfs2_internal_Scope__f_state).modify__F1__O(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Lfs2_internal_Scope$State(x$1);
    if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
      var s = $as_Lfs2_internal_Scope$State$Open(x$1$1);
      $n(s);
      var this$1 = $n($n(s).Lfs2_internal_Scope$State$Open__f_resources);
      var resources = this$1.prepend__O__Lcats_data_Chain(resource);
      var this$2 = $n(s);
      var children = this$2.Lfs2_internal_Scope$State$Open__f_children;
      var _1 = new $c_Lfs2_internal_Scope$State$Open(resources, children);
      return new $c_T2(_1, true);
    }
    if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
      var s$2 = $as_Lfs2_internal_Scope$State$Closed(x$1$1);
      return new $c_T2(s$2, false);
    }
    throw new $c_s_MatchError(x$1$1);
  })));
}
function $p_Lfs2_internal_Scope__releaseChildScope__Lcats_effect_kernel_Unique$Token__O($thiz, id) {
  return $n($thiz.Lfs2_internal_Scope__f_state).update__F1__O(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Lfs2_internal_Scope$State(x$1);
    if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
      var s = $as_Lfs2_internal_Scope$State$Open(x$1$1);
      return $n(s).unregisterChild__Lcats_effect_kernel_Unique$Token__Lfs2_internal_Scope$State(id);
    }
    if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
      var s$2 = $as_Lfs2_internal_Scope$State$Closed(x$1$1);
      return s$2;
    }
    throw new $c_s_MatchError(x$1$1);
  })));
}
function $p_Lfs2_internal_Scope__openScope__O($thiz) {
  var target = $n($thiz.Lfs2_internal_Scope__f_state).get__O();
  var tc = $thiz.Lfs2_internal_Scope__f_F;
  var this$4 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f = new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Lfs2_internal_Scope$State(x$1);
    if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
      var this$3 = $n($thiz.Lfs2_internal_Scope__f_F);
      return $n(this$3.F__Lcats_effect_kernel_MonadCancel()).pure__O__O($thiz);
    }
    if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
      return $thiz.openAncestor__O();
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return $n(this$4.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$4.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
}
function $p_Lfs2_internal_Scope__findSelfOrChild__Lcats_effect_kernel_Unique$Token__O($thiz, scopeId) {
  var x = $thiz.Lfs2_internal_Scope__f_id;
  if ((x === null)) {
    var $x_1 = (scopeId === null);
  } else {
    var this$1 = $n(x);
    var $x_1 = (this$1 === scopeId);
  }
  if ($x_1) {
    var this$3 = $n($thiz.Lfs2_internal_Scope__f_F);
    var a = new $c_s_Some($thiz);
    return $n(this$3.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a);
  } else {
    var target = $n($thiz.Lfs2_internal_Scope__f_state).get__O();
    var tc = $thiz.Lfs2_internal_Scope__f_F;
    var this$7 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
    var f = new $c_sjsr_AnonFunction1(((x$1) => {
      var x$1$1 = $as_Lfs2_internal_Scope$State(x$1);
      if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
        var s = $as_Lfs2_internal_Scope$State$Open(x$1$1);
        return $p_Lfs2_internal_Scope__go$4__Lcats_effect_kernel_Unique$Token__Lcats_data_Chain__O($thiz, scopeId, $n(s).Lfs2_internal_Scope$State$Open__f_children);
      }
      if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
        var this$6 = $n($thiz.Lfs2_internal_Scope__f_F);
        var a$1 = $m_s_None$();
        return $n(this$6.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a$1);
      }
      throw new $c_s_MatchError(x$1$1);
    }));
    return $n(this$7.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$7.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  }
}
function $ps_Lfs2_internal_Scope__go$1__Lfs2_internal_Scope__I__I(scope, acc) {
  var acc$tailLocal1 = acc;
  var scope$tailLocal1 = scope;
  while (true) {
    var x1 = $n(scope$tailLocal1).Lfs2_internal_Scope__f_parent;
    var x = $m_s_None$();
    if ((x === x1)) {
      return acc$tailLocal1;
    }
    if ((x1 instanceof $c_s_Some)) {
      var s = $as_Lfs2_internal_Scope($n($as_s_Some(x1)).s_Some__f_value);
      var acc$tailLocal1$tmp1 = ((1 + acc$tailLocal1) | 0);
      scope$tailLocal1 = s;
      acc$tailLocal1 = acc$tailLocal1$tmp1;
      continue;
    }
    throw new $c_s_MatchError(x1);
  }
}
function $ps_Lfs2_internal_Scope__go$3__Lcats_effect_kernel_Unique$Token__Lfs2_internal_Scope__s_Option(scopeId$1, curr) {
  var curr$tailLocal2 = curr;
  while (true) {
    var x = $n(curr$tailLocal2).Lfs2_internal_Scope__f_id;
    if ((x === null)) {
      var $x_1 = (scopeId$1 === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === scopeId$1);
    }
    if ($x_1) {
      var value = curr$tailLocal2;
      return new $c_s_Some(value);
    } else {
      var x68 = $n(curr$tailLocal2).Lfs2_internal_Scope__f_parent;
      if ((x68 instanceof $c_s_Some)) {
        var scope = $as_Lfs2_internal_Scope($n($as_s_Some(x68)).s_Some__f_value);
        curr$tailLocal2 = scope;
        continue;
      }
      var x$3 = $m_s_None$();
      if ((x$3 === x68)) {
        return $m_s_None$();
      }
      throw new $c_s_MatchError(x68);
    }
  }
}
function $p_Lfs2_internal_Scope__go$4__Lcats_effect_kernel_Unique$Token__Lcats_data_Chain__O($thiz, scopeId$3, scopes) {
  var x77 = $n(scopes).uncons__s_Option();
  var x = $m_s_None$();
  if ((x === x77)) {
    var this$1 = $n($thiz.Lfs2_internal_Scope__f_F);
    var a = $m_s_None$();
    return $n(this$1.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a);
  }
  if ((x77 instanceof $c_s_Some)) {
    var x79 = $as_T2($n($as_s_Some(x77)).s_Some__f_value);
    if ((x79 !== null)) {
      var scope = $as_Lfs2_internal_Scope($n(x79)._1__O());
      var tail = $as_Lcats_data_Chain($n(x79)._2__O());
      var x$3 = $n(scope).Lfs2_internal_Scope__f_id;
      if ((x$3 === null)) {
        var $x_1 = (scopeId$3 === null);
      } else {
        var this$2 = $n(x$3);
        var $x_1 = (this$2 === scopeId$3);
      }
      if ($x_1) {
        var this$4 = $n($thiz.Lfs2_internal_Scope__f_F);
        var a$1 = new $c_s_Some(scope);
        return $n(this$4.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a$1);
      } else {
        var target = $n($n(scope).Lfs2_internal_Scope__f_state).get__O();
        var tc = $thiz.Lfs2_internal_Scope__f_F;
        var this$11 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
        var f$1 = new $c_sjsr_AnonFunction1(((x$1) => {
          var x$1$1 = $as_Lfs2_internal_Scope$State(x$1);
          if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
            var s = $as_Lfs2_internal_Scope$State$Open(x$1$1);
            if ($n($n(s).Lfs2_internal_Scope$State$Open__f_children).isEmpty__Z()) {
              return $p_Lfs2_internal_Scope__go$4__Lcats_effect_kernel_Unique$Token__Lcats_data_Chain__O($thiz, scopeId$3, tail);
            } else {
              var target$1 = $p_Lfs2_internal_Scope__go$4__Lcats_effect_kernel_Unique$Token__Lcats_data_Chain__O($thiz, scopeId$3, $n(s).Lfs2_internal_Scope$State$Open__f_children);
              var tc$1 = $thiz.Lfs2_internal_Scope__f_F;
              var this$10 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
              var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
                var x$1$3 = $as_s_Option(x$1$2);
                var x$2 = $m_s_None$();
                if ((x$2 === x$1$3)) {
                  return $p_Lfs2_internal_Scope__go$4__Lcats_effect_kernel_Unique$Token__Lcats_data_Chain__O($thiz, scopeId$3, tail);
                }
                if ((x$1$3 instanceof $c_s_Some)) {
                  var scope$1 = $as_Lfs2_internal_Scope($n($as_s_Some(x$1$3)).s_Some__f_value);
                  var this$9 = $n($thiz.Lfs2_internal_Scope__f_F);
                  var a$2 = new $c_s_Some(scope$1);
                  return $n(this$9.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a$2);
                }
                throw new $c_s_MatchError(x$1$3);
              }));
              return $n(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
            }
          }
          if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
            return $p_Lfs2_internal_Scope__go$4__Lcats_effect_kernel_Unique$Token__Lcats_data_Chain__O($thiz, scopeId$3, tail);
          }
          throw new $c_s_MatchError(x$1$1);
        }));
        return $n(this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
      }
    }
  }
  throw new $c_s_MatchError(x77);
}
function $ps_Lfs2_internal_Scope__go$5__Lfs2_internal_Scope__Lfs2_internal_Scope(scope) {
  var scope$tailLocal2 = scope;
  while (true) {
    var x88 = $n(scope$tailLocal2).Lfs2_internal_Scope__f_parent;
    var x = $m_s_None$();
    if ((x === x88)) {
      return scope$tailLocal2;
    }
    if ((x88 instanceof $c_s_Some)) {
      var parent = $as_Lfs2_internal_Scope($n($as_s_Some(x88)).s_Some__f_value);
      scope$tailLocal2 = parent;
      continue;
    }
    throw new $c_s_MatchError(x88);
  }
}
/** @constructor */
function $c_Lfs2_internal_Scope(id, parent, interruptible, state, F) {
  this.Lfs2_internal_Scope__f_id = null;
  this.Lfs2_internal_Scope__f_parent = null;
  this.Lfs2_internal_Scope__f_interruptible = null;
  this.Lfs2_internal_Scope__f_state = null;
  this.Lfs2_internal_Scope__f_F = null;
  this.Lfs2_internal_Scope__f_id = id;
  this.Lfs2_internal_Scope__f_parent = parent;
  this.Lfs2_internal_Scope__f_interruptible = interruptible;
  this.Lfs2_internal_Scope__f_state = state;
  this.Lfs2_internal_Scope__f_F = F;
}
$c_Lfs2_internal_Scope.prototype = new $h_O();
$c_Lfs2_internal_Scope.prototype.constructor = $c_Lfs2_internal_Scope;
/** @constructor */
function $h_Lfs2_internal_Scope() {
}
$h_Lfs2_internal_Scope.prototype = $c_Lfs2_internal_Scope.prototype;
$c_Lfs2_internal_Scope.prototype.open__Z__O = (function(interruptible) {
  var target = $n(this.Lfs2_internal_Scope__f_F).unique__O();
  var tc = this.Lfs2_internal_Scope__f_F;
  var this$15 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f$2 = new $c_sjsr_AnonFunction1(((newScopeId) => {
    var newScopeId$1 = $as_Lcats_effect_kernel_Unique$Token(newScopeId);
    var x7 = this.Lfs2_internal_Scope__f_interruptible;
    var x = $m_s_None$();
    if ((x === x7)) {
      var optFCtx = (interruptible ? $n(this.Lfs2_internal_Scope__f_F).interruptContext__Lcats_effect_kernel_Unique$Token__s_Option(newScopeId$1) : $m_s_None$());
      $m_Lcats_UnorderedFoldable$();
      var tc$1 = $as_Lcats_Traverse($m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption);
      var this$6 = new $c_Lcats_Traverse$ToTraverseOps$$anon$3(optFCtx, tc$1);
      var this$5 = $m_s_$less$colon$less$();
      var ev$2 = this.Lfs2_internal_Scope__f_F;
      var this$7 = $n(this$6.Lcats_Traverse$ToTraverseOps$$anon$3__f_typeClassInstance);
      var fga = this$6.Lcats_Traverse$ToTraverseOps$$anon$3__f_self;
      var target$1 = $f_Lcats_Traverse__sequence__O__Lcats_Applicative__O(this$7, fga, ev$2);
      var tc$2 = this.Lfs2_internal_Scope__f_F;
      var this$10 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$2);
      var f = new $c_sjsr_AnonFunction1(((iCtx) => {
        var iCtx$1 = $as_s_Option(iCtx);
        return $m_Lfs2_internal_Scope$().fs2$internal$Scope$$$apply__Lcats_effect_kernel_Unique$Token__s_Option__s_Option__Lfs2_Compiler$Target__O(newScopeId$1, new $c_s_Some(this), iCtx$1, this.Lfs2_internal_Scope__f_F);
      }));
      return $n(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
    }
    if ((x7 instanceof $c_s_Some)) {
      var parentICtx = $as_Lfs2_internal_InterruptContext($n($as_s_Some(x7)).s_Some__f_value);
      var target$2 = $n(parentICtx).childContext__Z__Lcats_effect_kernel_Unique$Token__O(interruptible, newScopeId$1);
      var tc$3 = this.Lfs2_internal_Scope__f_F;
      var this$14 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, tc$3);
      var f$1 = new $c_sjsr_AnonFunction1(((iCtx$2) => {
        var iCtx$3 = $as_Lfs2_internal_InterruptContext(iCtx$2);
        return $m_Lfs2_internal_Scope$().fs2$internal$Scope$$$apply__Lcats_effect_kernel_Unique$Token__s_Option__s_Option__Lfs2_Compiler$Target__O(newScopeId$1, new $c_s_Some(this), new $c_s_Some(iCtx$3), this.Lfs2_internal_Scope__f_F);
      }));
      return $n(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
    }
    throw new $c_s_MatchError(x7);
  }));
  var createScope = $n(this$15.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$15.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
  var tc$4 = this.Lfs2_internal_Scope__f_F;
  var this$33 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(createScope, tc$4);
  var f$4 = new $c_sjsr_AnonFunction1(((scope) => {
    var scope$1 = $as_Lfs2_internal_Scope(scope);
    var target$3 = $n(this.Lfs2_internal_Scope__f_state).modify__F1__O(new $c_sjsr_AnonFunction1(((x$1) => {
      var x$1$1 = $as_Lfs2_internal_Scope$State(x$1);
      if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
        var s = $as_Lfs2_internal_Scope$State$Closed(x$1$1);
        var _2 = $m_s_None$();
        return new $c_T2(s, _2);
      }
      if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
        var s$2 = $as_Lfs2_internal_Scope$State$Open(x$1$1);
        var this$18 = $n($n(s$2).Lfs2_internal_Scope$State$Open__f_children);
        var children$1 = this$18.prepend__O__Lcats_data_Chain(scope$1);
        var this$19 = $n(s$2);
        var resources$1 = this$19.Lfs2_internal_Scope$State$Open__f_resources;
        $n(s$2);
        var _1 = new $c_Lfs2_internal_Scope$State$Open(resources$1, children$1);
        var _2$1 = new $c_s_Some(scope$1);
        return new $c_T2(_1, _2$1);
      }
      throw new $c_s_MatchError(x$1$1);
    })));
    var tc$5 = this.Lfs2_internal_Scope__f_F;
    var this$32 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$3, tc$5);
    var f$3 = new $c_sjsr_AnonFunction1(((x$1$2) => {
      var x$1$3 = $as_s_Option(x$1$2);
      if ((x$1$3 instanceof $c_s_Some)) {
        var s$1 = $as_Lfs2_internal_Scope($n($as_s_Some(x$1$3)).s_Some__f_value);
        var this$25 = $n(this.Lfs2_internal_Scope__f_F);
        var a = new $c_s_util_Right(s$1);
        return $n(this$25.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a);
      }
      var x$2 = $m_s_None$();
      if ((x$2 === x$1$3)) {
        var x13 = this.Lfs2_internal_Scope__f_parent;
        if ((x13 instanceof $c_s_Some)) {
          var parent = $as_Lfs2_internal_Scope($n($as_s_Some(x13)).s_Some__f_value);
          var this$26 = $n(this.Lfs2_internal_Scope__f_interruptible);
          if (this$26.isEmpty__Z()) {
            var $x_1 = $m_s_None$();
          } else {
            var arg1 = this$26.get__O();
            var _$2 = $as_Lfs2_internal_InterruptContext(arg1);
            var $x_1 = new $c_s_Some($n(_$2).Lfs2_internal_InterruptContext__f_cancelParent);
          }
          var this$27 = $n($x_1);
          if (this$27.isEmpty__Z()) {
            var this$28 = $n(this.Lfs2_internal_Scope__f_F);
            var fa = $n(this$28.F__Lcats_effect_kernel_MonadCancel()).pure__O__O((void 0));
          } else {
            var fa = this$27.get__O();
          }
          return $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa, new $c_sjsr_AnonFunction0((() => $n(parent).open__Z__O(interruptible))), this.Lfs2_internal_Scope__f_F);
        }
        var x$3 = $m_s_None$();
        if ((x$3 === x13)) {
          var this$31 = $n(this.Lfs2_internal_Scope__f_F);
          var value = $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "cannot re-open root scope");
          var a$1 = new $c_s_util_Left(value);
          return $n(this$31.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a$1);
        }
        throw new $c_s_MatchError(x13);
      }
      throw new $c_s_MatchError(x$1$3);
    }));
    return $n(this$32.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$32.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
  }));
  return $n(this$33.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$33.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$4);
});
$c_Lfs2_internal_Scope.prototype.acquireResource__F1__F2__O = (function(acquire, release) {
  var target = $m_Lfs2_internal_ScopedResource$().create__Lfs2_Compiler$Target__O(this.Lfs2_internal_Scope__f_F);
  var tc = this.Lfs2_internal_Scope__f_F;
  var this$25 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f$4 = new $c_sjsr_AnonFunction1(((resource) => {
    var resource$1 = $as_Lfs2_internal_ScopedResource(resource);
    var this$24 = $n(this.Lfs2_internal_Scope__f_F);
    var f$3 = new $c_sjsr_AnonFunction1(((poll) => {
      var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
      var fa = $n(acquire).apply__O__O(poll$1);
      var recover = new $c_sjsr_AnonFunction1(((t) => {
        var t$1 = $as_jl_Throwable(t);
        var this$5 = $n(this.Lfs2_internal_Scope__f_F);
        var a = new $c_s_util_Left(t$1);
        return $n(this$5.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a);
      }));
      var bind = new $c_sjsr_AnonFunction1(((r) => {
        var finalizer = new $c_sjsr_AnonFunction1(((ec) => {
          var ec$1 = $as_Lcats_effect_kernel_Resource$ExitCase(ec);
          var this$6 = $n(this.Lfs2_internal_Scope__f_F);
          var f = new $c_sjsr_AnonFunction1(((_$3) => {
            $as_Lcats_effect_kernel_Poll(_$3);
            return $n(release).apply__O__O__O(r, ec$1);
          }));
          return $n(this$6.F__Lcats_effect_kernel_MonadCancel()).uncancelable__F1__O(f);
        }));
        var target$1 = $n(resource$1).acquired__F1__O(finalizer);
        var tc$1 = this.Lfs2_internal_Scope__f_F;
        var this$21 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
        var f$2 = new $c_sjsr_AnonFunction1(((result) => {
          var result$1 = $as_s_util_Either(result);
          var this$8 = $n(result$1);
          if ((this$8 instanceof $c_s_util_Right)) {
            var x2 = $as_s_util_Right(this$8);
            var b = $n(x2).s_util_Right__f_value;
            var x = $uZ(b);
            var $x_1 = x;
          } else {
            var $x_1 = false;
          }
          if ($x_1) {
            var target$2 = $p_Lfs2_internal_Scope__register__Lfs2_internal_ScopedResource__O(this, resource$1);
            var tc$2 = this.Lfs2_internal_Scope__f_F;
            var this$16 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, tc$2);
            var f$1 = new $c_sjsr_AnonFunction1(((x$1) => {
              var x$1$1 = $uZ(x$1);
              if ((x$1$1 === false)) {
                var target$3 = finalizer.apply__O__O($m_Lcats_effect_kernel_Resource$ExitCase$Canceled$());
                var tc$3 = this.Lfs2_internal_Scope__f_F;
                var this$13 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, tc$3);
                var value = $m_Lfs2_internal_AcquireAfterScopeClosed$();
                var b$1 = new $c_s_util_Left(value);
                return $n(this$13.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$13.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b$1);
              }
              if ((x$1$1 === true)) {
                var this$15 = $n(this.Lfs2_internal_Scope__f_F);
                var a$1 = new $c_s_util_Right(r);
                return $n(this$15.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a$1);
              }
              throw new $c_s_MatchError(x$1$1);
            }));
            return $n(this$16.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$16.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
          } else {
            var target$4 = finalizer.apply__O__O($m_Lcats_effect_kernel_Resource$ExitCase$Canceled$());
            var tc$4 = this.Lfs2_internal_Scope__f_F;
            var this$20 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$4, tc$4);
            var this$18 = $n($n(result$1).swap__s_util_Either());
            if ((this$18 instanceof $c_s_util_Right)) {
              var x2$1 = $as_s_util_Right(this$18);
              var b$2 = $n(x2$1).s_util_Right__f_value;
              var value$1 = b$2;
            } else {
              var value$1 = $m_Lfs2_internal_AcquireAfterScopeClosed$();
            }
            var b$3 = new $c_s_util_Left(value$1);
            return $n(this$20.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$20.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b$3);
          }
        }));
        return $n(this$21.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$21.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
      }));
      var F$1 = this.Lfs2_internal_Scope__f_F;
      var this$23 = $n(F$1);
      return $f_Lcats_MonadError__redeemWith__O__F1__F1__O(this$23, fa, recover, bind);
    }));
    return $n(this$24.F__Lcats_effect_kernel_MonadCancel()).uncancelable__F1__O(f$3);
  }));
  var target$5 = this.interruptibleEval__O__O($n(this$25.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$25.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$4));
  var tc$5 = this.Lfs2_internal_Scope__f_F;
  var this$38 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$5, tc$5);
  var f$5 = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1$3 = $as_s_util_Either(x$1$2);
    if ((x$1$3 instanceof $c_s_util_Left)) {
      var x38 = $as_Lcats_effect_kernel_Outcome($n($as_s_util_Left(x$1$3)).s_util_Left__f_value);
      if ((x38 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
        var x$1$4 = $as_Lcats_effect_kernel_Outcome$Errored(x38);
        var this$28 = $n(x$1$4);
        var x41 = $as_jl_Throwable(this$28.Lcats_effect_kernel_Outcome$Errored__f_e);
        return new $c_Lcats_effect_kernel_Outcome$Errored(x41);
      }
      if (((x38 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x38), true))) {
        return new $c_Lcats_effect_kernel_Outcome$Canceled();
      }
      if ((x38 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
        var x$1$5 = $as_Lcats_effect_kernel_Outcome$Succeeded(x38);
        var this$32 = $n(x$1$5);
        var x33 = $as_Lcats_effect_kernel_Unique$Token(this$32.Lcats_effect_kernel_Outcome$Succeeded__f_fa);
        var fa$1 = new $c_s_util_Left(x33);
        return new $c_Lcats_effect_kernel_Outcome$Succeeded(fa$1);
      }
    }
    if ((x$1$3 instanceof $c_s_util_Right)) {
      var x26 = $as_s_util_Either($n($as_s_util_Right(x$1$3)).s_util_Right__f_value);
      if ((x26 instanceof $c_s_util_Left)) {
        var t$2 = $as_jl_Throwable($n($as_s_util_Left(x26)).s_util_Left__f_value);
        return new $c_Lcats_effect_kernel_Outcome$Errored(t$2);
      }
      if ((x26 instanceof $c_s_util_Right)) {
        var r$1 = $n($as_s_util_Right(x26)).s_util_Right__f_value;
        var fa$2 = new $c_s_util_Right(r$1);
        return new $c_Lcats_effect_kernel_Outcome$Succeeded(fa$2);
      }
    }
    throw new $c_s_MatchError(x$1$3);
  }));
  return $n(this$38.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$38.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$5);
});
$c_Lfs2_internal_Scope.prototype.fs2$internal$Scope$$traverseError__Lcats_data_Chain__F1__O = (function(ca, f) {
  var instance = $as_Lcats_Traverse($m_Lcats_data_Chain$().Lcats_data_ChainInstances__f_catsDataInstancesForChain);
  var target = $n(instance).traverse__O__F1__Lcats_Applicative__O(ca, f, this.Lfs2_internal_Scope__f_F);
  var tc = this.Lfs2_internal_Scope__f_F;
  var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
  var f$1 = new $c_sjsr_AnonFunction1(((results) => {
    var results$1 = $as_Lcats_data_Chain(results);
    var this$3 = $n($m_Lfs2_CompositeFailure$().fromList__sci_List__s_Option($n($n(results$1).collect__s_PartialFunction__Lcats_data_Chain(new $c_Lfs2_internal_Scope$$anon$1())).toList__sci_List()));
    return (this$3.isEmpty__Z() ? new $c_s_util_Right((void 0)) : new $c_s_util_Left(this$3.get__O()));
  }));
  return $n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
});
$c_Lfs2_internal_Scope.prototype.close__Lcats_effect_kernel_Resource$ExitCase__O = (function(ec) {
  var target = $n(this.Lfs2_internal_Scope__f_state).modify__F1__O(new $c_sjsr_AnonFunction1(((s) => {
    var s$1 = $as_Lfs2_internal_Scope$State(s);
    var self = $m_Lfs2_internal_Scope$State$().Lfs2_internal_Scope$State$__f_closed_;
    return new $c_T2(self, s$1);
  })));
  var tc = this.Lfs2_internal_Scope__f_F;
  var this$20 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f$4 = new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Lfs2_internal_Scope$State(x$1);
    if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
      var previous = $as_Lfs2_internal_Scope$State$Open(x$1$1);
      var target$1 = this.fs2$internal$Scope$$traverseError__Lcats_data_Chain__F1__O($n(previous).Lfs2_internal_Scope$State$Open__f_children, new $c_sjsr_AnonFunction1(((_$4) => {
        var _$4$1 = $as_Lfs2_internal_Scope(_$4);
        return $n(_$4$1).close__Lcats_effect_kernel_Resource$ExitCase__O(ec);
      })));
      var tc$1 = this.Lfs2_internal_Scope__f_F;
      var this$17 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
      var f$3 = new $c_sjsr_AnonFunction1(((resultChildren) => {
        var resultChildren$1 = $as_s_util_Either(resultChildren);
        var target$2 = this.fs2$internal$Scope$$traverseError__Lcats_data_Chain__F1__O($n(previous).Lfs2_internal_Scope$State$Open__f_resources, new $c_sjsr_AnonFunction1(((_$5) => {
          var _$5$1 = $as_Lfs2_internal_ScopedResource(_$5);
          return $n(_$5$1).release__Lcats_effect_kernel_Resource$ExitCase__O(ec);
        })));
        var tc$2 = this.Lfs2_internal_Scope__f_F;
        var this$16 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, tc$2);
        var f$2 = new $c_sjsr_AnonFunction1(((resultResources) => {
          var resultResources$1 = $as_s_util_Either(resultResources);
          var this$7 = $n(this.Lfs2_internal_Scope__f_interruptible);
          if (this$7.isEmpty__Z()) {
            var $x_1 = $m_s_None$();
          } else {
            var arg1 = this$7.get__O();
            var _$6 = $as_Lfs2_internal_InterruptContext(arg1);
            var $x_1 = new $c_s_Some($n(_$6).Lfs2_internal_InterruptContext__f_cancelParent);
          }
          var this$8 = $n($x_1);
          if (this$8.isEmpty__Z()) {
            var this$9 = $n(this.Lfs2_internal_Scope__f_F);
            var target$3 = $n(this$9.F__Lcats_effect_kernel_MonadCancel()).pure__O__O((void 0));
          } else {
            var target$3 = this$8.get__O();
          }
          var tc$3 = this.Lfs2_internal_Scope__f_F;
          var this$15 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$3, tc$3);
          var f$1 = new $c_sjsr_AnonFunction1(((x$1$2) => {
            $as_jl_Void(x$1$2);
            var this$11 = $n(this.Lfs2_internal_Scope__f_parent);
            if (this$11.isEmpty__Z()) {
              var this$12 = $n(this.Lfs2_internal_Scope__f_F);
              var target$4 = $n(this$12.F__Lcats_effect_kernel_MonadCancel()).pure__O__O((void 0));
            } else {
              var arg1$1 = this$11.get__O();
              var _$7 = $as_Lfs2_internal_Scope(arg1$1);
              var target$4 = $p_Lfs2_internal_Scope__releaseChildScope__Lcats_effect_kernel_Unique$Token__O($n(_$7), this.Lfs2_internal_Scope__f_id);
            }
            var tc$4 = this.Lfs2_internal_Scope__f_F;
            var this$14 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$4, tc$4);
            var f = new $c_sjsr_AnonFunction1(((x$1$2$1) => {
              $as_jl_Void(x$1$2$1);
              return $m_Lfs2_CompositeFailure$().fromResults__s_util_Either__s_util_Either__s_util_Either(resultChildren$1, resultResources$1);
            }));
            return $n(this$14.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$14.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
          }));
          return $n(this$15.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$15.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
        }));
        return $n(this$16.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$16.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
      }));
      return $n(this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
    }
    if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
      var this$19 = $n(this.Lfs2_internal_Scope__f_F);
      var a = new $c_s_util_Right((void 0));
      return $n(this$19.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a);
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return $n(this$20.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$20.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$4);
});
$c_Lfs2_internal_Scope.prototype.openAncestor__O = (function() {
  var this$1 = $n(this.Lfs2_internal_Scope__f_parent);
  if (this$1.isEmpty__Z()) {
    var this$2 = $n(this.Lfs2_internal_Scope__f_F);
    return $n(this$2.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(this);
  } else {
    var arg1 = this$1.get__O();
    var parent = $as_Lfs2_internal_Scope(arg1);
    var target = $n($n(parent).Lfs2_internal_Scope__f_state).get__O();
    var tc = this.Lfs2_internal_Scope__f_F;
    var this$6 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
    var f = new $c_sjsr_AnonFunction1(((x$1) => {
      var x$1$1 = $as_Lfs2_internal_Scope$State(x$1);
      if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
        var this$5 = $n(this.Lfs2_internal_Scope__f_F);
        return $n(this$5.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(parent);
      }
      if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
        return $n(parent).openAncestor__O();
      }
      throw new $c_s_MatchError(x$1$1);
    }));
    return $n(this$6.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$6.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  }
});
$c_Lfs2_internal_Scope.prototype.descendsFrom__Lcats_effect_kernel_Unique$Token__Z = (function(scopeId) {
  var this$1 = $n($ps_Lfs2_internal_Scope__go$3__Lcats_effect_kernel_Unique$Token__Lfs2_internal_Scope__s_Option(scopeId, this));
  return (!this$1.isEmpty__Z());
});
$c_Lfs2_internal_Scope.prototype.findInLineage__Lcats_effect_kernel_Unique$Token__O = (function(scopeId) {
  var a = $ps_Lfs2_internal_Scope__go$3__Lcats_effect_kernel_Unique$Token__Lfs2_internal_Scope__s_Option(scopeId, this);
  var F = this.Lfs2_internal_Scope__f_F;
  var this$3 = $n(F);
  var fa = $n(this$3.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a);
  return $m_Lcats_syntax_ApplicativeErrorOps$().orElse$extension__O__F0__Lcats_ApplicativeError__O(fa, new $c_sjsr_AnonFunction0((() => $p_Lfs2_internal_Scope__findSelfOrChild__Lcats_effect_kernel_Unique$Token__O(this, scopeId))), this.Lfs2_internal_Scope__f_F);
});
$c_Lfs2_internal_Scope.prototype.shiftScope__Lcats_effect_kernel_Unique$Token__F0__O = (function(scopeId, context) {
  var target = this.findStepScope__Lcats_effect_kernel_Unique$Token__O(scopeId);
  var tc = this.Lfs2_internal_Scope__f_F;
  var this$7 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f = new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_s_Option(x$1);
    if ((x$1$1 instanceof $c_s_Some)) {
      var scope = $as_Lfs2_internal_Scope($n($as_s_Some(x$1$1)).s_Some__f_value);
      var this$3 = $n(this.Lfs2_internal_Scope__f_F);
      return $n(this$3.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(scope);
    }
    var x = $m_s_None$();
    if ((x === x$1$1)) {
      var x$2 = ((("|Scope lookup failure!\n              |\n              |This is typically caused by uncons-ing from two or more streams in the same Pull.\n              |To do this safely, use `s.pull.stepLeg` instead of `s.pull.uncons` or a variant\n              |thereof. See the implementation of `Stream#zipWith_` for an example.\n              |\n              |Scope id: " + this.Lfs2_internal_Scope__f_id) + "\n              |Step: ") + $n(context).apply__O());
      var msg = $m_sc_StringOps$().stripMargin$extension__T__C__T(x$2, 124);
      var this$6 = $n(this.Lfs2_internal_Scope__f_F);
      var e = $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), msg);
      return $n(this$6.F__Lcats_effect_kernel_MonadCancel()).raiseError__O__O(e);
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return $n(this$7.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$7.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
});
$c_Lfs2_internal_Scope.prototype.findStepScope__Lcats_effect_kernel_Unique$Token__O = (function(scopeId) {
  var x$2 = this.Lfs2_internal_Scope__f_id;
  if ((scopeId === null)) {
    var $x_1 = (x$2 === null);
  } else {
    var this$1 = $n(scopeId);
    var $x_1 = (this$1 === x$2);
  }
  if ($x_1) {
    var this$3 = $n(this.Lfs2_internal_Scope__f_F);
    var a = new $c_s_Some(this);
    return $n(this$3.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a);
  } else {
    var x94 = this.Lfs2_internal_Scope__f_parent;
    var x$3 = $m_s_None$();
    if ((x$3 === x94)) {
      return $p_Lfs2_internal_Scope__findSelfOrChild__Lcats_effect_kernel_Unique$Token__O(this, scopeId);
    }
    if ((x94 instanceof $c_s_Some)) {
      var parent = $as_Lfs2_internal_Scope($n($as_s_Some(x94)).s_Some__f_value);
      var target = $p_Lfs2_internal_Scope__findSelfOrChild__Lcats_effect_kernel_Unique$Token__O($n(parent), scopeId);
      var tc = this.Lfs2_internal_Scope__f_F;
      var this$8 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
      var f = new $c_sjsr_AnonFunction1(((x$1) => {
        var x$1$1 = $as_s_Option(x$1);
        if ((x$1$1 instanceof $c_s_Some)) {
          var scope = $as_Lfs2_internal_Scope($n($as_s_Some(x$1$1)).s_Some__f_value);
          var this$7 = $n(this.Lfs2_internal_Scope__f_F);
          var a$1 = new $c_s_Some(scope);
          return $n(this$7.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a$1);
        }
        var x = $m_s_None$();
        if ((x === x$1$1)) {
          return $p_Lfs2_internal_Scope__findSelfOrChild__Lcats_effect_kernel_Unique$Token__O($n($ps_Lfs2_internal_Scope__go$5__Lfs2_internal_Scope__Lfs2_internal_Scope(this)), scopeId);
        }
        throw new $c_s_MatchError(x$1$1);
      }));
      return $n(this$8.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$8.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
    }
    throw new $c_s_MatchError(x94);
  }
});
$c_Lfs2_internal_Scope.prototype.interruptWhen__O__O = (function(haltWhen) {
  var x97 = this.Lfs2_internal_Scope__f_interruptible;
  var x = $m_s_None$();
  if ((x === x97)) {
    var this$1 = $n(this.Lfs2_internal_Scope__f_F);
    var a = new $c_Lfs2_internal_Scope$$anon$2(this);
    return $n(this$1.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a);
  }
  if ((x97 instanceof $c_s_Some)) {
    var iCtx = $as_Lfs2_internal_InterruptContext($n($as_s_Some(x97)).s_Some__f_value);
    var tc = this.Lfs2_internal_Scope__f_F;
    var this$6 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(haltWhen, tc);
    var f = new $c_sjsr_AnonFunction1(((_$8) => {
      var _$8$1 = $as_s_util_Either(_$8);
      var this$3 = $n(_$8$1);
      if ((this$3 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(this$3);
        var b = $n(x2).s_util_Right__f_value;
        $as_jl_Void(b);
        var fa = $n(iCtx).Lfs2_internal_InterruptContext__f_interruptRoot;
        var $x_1 = new $c_Lcats_effect_kernel_Outcome$Succeeded(fa);
      } else {
        if ((!(this$3 instanceof $c_s_util_Left))) {
          throw new $c_s_MatchError(this$3);
        }
        var x3 = $as_s_util_Left(this$3);
        var a$1 = $n(x3).s_util_Left__f_value;
        var t = $as_jl_Throwable(a$1);
        var $x_1 = new $c_Lcats_effect_kernel_Outcome$Errored(t);
      }
      return $as_Lcats_effect_kernel_Outcome($x_1);
    }));
    var outcome = $n(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
    return $n(iCtx).completeWhen__O__O(outcome);
  }
  throw new $c_s_MatchError(x97);
});
$c_Lfs2_internal_Scope.prototype.isInterrupted__O = (function() {
  var target = $p_Lfs2_internal_Scope__openScope__O(this);
  var tc = this.Lfs2_internal_Scope__f_F;
  var this$4 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f = new $c_sjsr_AnonFunction1(((scope) => {
    var scope$1 = $as_Lfs2_internal_Scope(scope);
    var x100 = $n(scope$1).Lfs2_internal_Scope__f_interruptible;
    var x = $m_s_None$();
    if ((x === x100)) {
      var this$3 = $n(this.Lfs2_internal_Scope__f_F);
      var a = $m_s_None$();
      return $n(this$3.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a);
    }
    if ((x100 instanceof $c_s_Some)) {
      var iCtx = $as_Lfs2_internal_InterruptContext($n($as_s_Some(x100)).s_Some__f_value);
      return $n($n(iCtx).Lfs2_internal_InterruptContext__f_ref).get__O();
    }
    throw new $c_s_MatchError(x100);
  }));
  return $n(this$4.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$4.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
});
$c_Lfs2_internal_Scope.prototype.interruptibleEval__O__O = (function(f) {
  var target = $p_Lfs2_internal_Scope__openScope__O(this);
  var tc = this.Lfs2_internal_Scope__f_F;
  var this$2 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
  var f$1 = new $c_sjsr_AnonFunction1(((_$10) => {
    var _$10$1 = $as_Lfs2_internal_Scope(_$10);
    return $n(_$10$1).Lfs2_internal_Scope__f_interruptible;
  }));
  var target$1 = $n(this$2.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$2.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
  var tc$1 = this.Lfs2_internal_Scope__f_F;
  var this$15 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
  var f$3 = new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_s_Option(x$1);
    var x = $m_s_None$();
    if ((x === x$1$1)) {
      var F$1 = this.Lfs2_internal_Scope__f_F;
      var this$7 = $n(F$1);
      var target$2 = $f_Lcats_ApplicativeError__attempt__O__O(this$7, f);
      var tc$2 = this.Lfs2_internal_Scope__f_F;
      var this$14 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, tc$2);
      var f$2 = new $c_sjsr_AnonFunction1(((_$11) => {
        var _$11$1 = $as_s_util_Either(_$11);
        if ((_$11$1 instanceof $c_s_util_Left)) {
          var a = $n($as_s_util_Left(_$11$1)).s_util_Left__f_value;
          var t = $as_jl_Throwable(a);
          var value = new $c_Lcats_effect_kernel_Outcome$Errored(t);
          return new $c_s_util_Left(value);
        }
        if ((_$11$1 instanceof $c_s_util_Right)) {
          var r = $as_s_util_Right(_$11$1);
          $m_Lcats_syntax_EitherUtil$();
          return r;
        }
        throw new $c_s_MatchError(_$11$1);
      }));
      return $n(this$14.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$14.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$2);
    }
    if ((x$1$1 instanceof $c_s_Some)) {
      var iCtx = $as_Lfs2_internal_InterruptContext($n($as_s_Some(x$1$1)).s_Some__f_value);
      return $n(iCtx).eval__O__O(f);
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return $n(this$15.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$15.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
});
$c_Lfs2_internal_Scope.prototype.toString__T = (function() {
  var $x_1 = this.Lfs2_internal_Scope__f_id;
  var this$1 = $n(this.Lfs2_internal_Scope__f_interruptible);
  return (((("Scope(id=" + $x_1) + ",interruptible=") + (!this$1.isEmpty__Z())) + ")");
});
function $as_Lfs2_internal_Scope(obj) {
  return (((obj instanceof $c_Lfs2_internal_Scope) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.internal.Scope"));
}
function $isArrayOf_Lfs2_internal_Scope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_internal_Scope)));
}
function $asArrayOf_Lfs2_internal_Scope(obj, depth) {
  return (($isArrayOf_Lfs2_internal_Scope(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.internal.Scope;", depth));
}
var $d_Lfs2_internal_Scope = new $TypeData().initClass($c_Lfs2_internal_Scope, "fs2.internal.Scope", ({
  Lfs2_internal_Scope: 1
}));
/** @constructor */
function $c_Lfs2_internal_Scope$() {
}
$c_Lfs2_internal_Scope$.prototype = new $h_O();
$c_Lfs2_internal_Scope$.prototype.constructor = $c_Lfs2_internal_Scope$;
/** @constructor */
function $h_Lfs2_internal_Scope$() {
}
$h_Lfs2_internal_Scope$.prototype = $c_Lfs2_internal_Scope$.prototype;
$c_Lfs2_internal_Scope$.prototype.fs2$internal$Scope$$$apply__Lcats_effect_kernel_Unique$Token__s_Option__s_Option__Lfs2_Compiler$Target__O = (function(id, parent, interruptible, F) {
  var target = $n(F).ref__O__O($m_Lfs2_internal_Scope$State$().Lfs2_internal_Scope$State$__f_initial_);
  var this$3 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, F);
  var f = new $c_sjsr_AnonFunction1(((state) => {
    var state$1 = $as_Lcats_effect_kernel_Ref(state);
    return new $c_Lfs2_internal_Scope(id, parent, interruptible, state$1, F);
  }));
  return $n(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
});
$c_Lfs2_internal_Scope$.prototype.newRoot__Lfs2_Compiler$Target__O = (function(F) {
  var target = $n(F).unique__O();
  var this$3 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F);
  var f = new $c_sjsr_AnonFunction1(((_$17) => {
    var _$17$1 = $as_Lcats_effect_kernel_Unique$Token(_$17);
    return this.fs2$internal$Scope$$$apply__Lcats_effect_kernel_Unique$Token__s_Option__s_Option__Lfs2_Compiler$Target__O(_$17$1, $m_s_None$(), $m_s_None$(), F);
  }));
  return $n(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
});
var $d_Lfs2_internal_Scope$ = new $TypeData().initClass($c_Lfs2_internal_Scope$, "fs2.internal.Scope$", ({
  Lfs2_internal_Scope$: 1
}));
var $n_Lfs2_internal_Scope$;
function $m_Lfs2_internal_Scope$() {
  if ((!$n_Lfs2_internal_Scope$)) {
    $n_Lfs2_internal_Scope$ = new $c_Lfs2_internal_Scope$();
  }
  return $n_Lfs2_internal_Scope$;
}
function $is_Lfs2_internal_Scope$State(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lfs2_internal_Scope$State)));
}
function $as_Lfs2_internal_Scope$State(obj) {
  return (($is_Lfs2_internal_Scope$State(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.internal.Scope$State"));
}
function $isArrayOf_Lfs2_internal_Scope$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_internal_Scope$State)));
}
function $asArrayOf_Lfs2_internal_Scope$State(obj, depth) {
  return (($isArrayOf_Lfs2_internal_Scope$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.internal.Scope$State;", depth));
}
/** @constructor */
function $c_Lfs2_internal_ScopedResource() {
}
$c_Lfs2_internal_ScopedResource.prototype = new $h_O();
$c_Lfs2_internal_ScopedResource.prototype.constructor = $c_Lfs2_internal_ScopedResource;
/** @constructor */
function $h_Lfs2_internal_ScopedResource() {
}
$h_Lfs2_internal_ScopedResource.prototype = $c_Lfs2_internal_ScopedResource.prototype;
function $as_Lfs2_internal_ScopedResource(obj) {
  return (((obj instanceof $c_Lfs2_internal_ScopedResource) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.internal.ScopedResource"));
}
function $isArrayOf_Lfs2_internal_ScopedResource(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_internal_ScopedResource)));
}
function $asArrayOf_Lfs2_internal_ScopedResource(obj, depth) {
  return (($isArrayOf_Lfs2_internal_ScopedResource(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.internal.ScopedResource;", depth));
}
/** @constructor */
function $c_Lfs2_internal_ScopedResource$() {
  this.Lfs2_internal_ScopedResource$__f_initial = null;
  $n_Lfs2_internal_ScopedResource$ = this;
  var finalizer = $m_s_None$();
  this.Lfs2_internal_ScopedResource$__f_initial = new $c_Lfs2_internal_ScopedResource$State(true, finalizer, 0);
}
$c_Lfs2_internal_ScopedResource$.prototype = new $h_O();
$c_Lfs2_internal_ScopedResource$.prototype.constructor = $c_Lfs2_internal_ScopedResource$;
/** @constructor */
function $h_Lfs2_internal_ScopedResource$() {
}
$h_Lfs2_internal_ScopedResource$.prototype = $c_Lfs2_internal_ScopedResource$.prototype;
$c_Lfs2_internal_ScopedResource$.prototype.create__Lfs2_Compiler$Target__O = (function(F) {
  $m_Lcats_implicits$();
  var target = $n(F).ref__O__O(this.Lfs2_internal_ScopedResource$__f_initial);
  var this$5 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F);
  var f$1 = new $c_sjsr_AnonFunction1(((state) => {
    var state$1 = $as_Lcats_effect_kernel_Ref(state);
    $m_Lcats_implicits$();
    var target$1 = $n(F).unique__O();
    var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, F);
    var f = new $c_sjsr_AnonFunction1(((token) => {
      var token$1 = $as_Lcats_effect_kernel_Unique$Token(token);
      return new $c_Lfs2_internal_ScopedResource$$anon$1(F, state$1, token$1);
    }));
    return $n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  }));
  return $n(this$5.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$5.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
});
var $d_Lfs2_internal_ScopedResource$ = new $TypeData().initClass($c_Lfs2_internal_ScopedResource$, "fs2.internal.ScopedResource$", ({
  Lfs2_internal_ScopedResource$: 1
}));
var $n_Lfs2_internal_ScopedResource$;
function $m_Lfs2_internal_ScopedResource$() {
  if ((!$n_Lfs2_internal_ScopedResource$)) {
    $n_Lfs2_internal_ScopedResource$ = new $c_Lfs2_internal_ScopedResource$();
  }
  return $n_Lfs2_internal_ScopedResource$;
}
function $is_Ljava_io_Serializable(obj) {
  return ((((((!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljava_io_Serializable))) || ((typeof obj) === "string")) || ((typeof obj) === "number")) || ((typeof obj) === "boolean")) || (obj instanceof $c_RTLong)) || (obj instanceof $Char));
}
function $as_Ljava_io_Serializable(obj) {
  return (($is_Ljava_io_Serializable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.io.Serializable"));
}
function $isArrayOf_Ljava_io_Serializable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_io_Serializable)));
}
function $asArrayOf_Ljava_io_Serializable(obj, depth) {
  return (($isArrayOf_Ljava_io_Serializable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.io.Serializable;", depth));
}
function $is_jl_Comparable(obj) {
  return ((((((!(!((obj && obj.$classData) && obj.$classData.ancestors.jl_Comparable))) || ((typeof obj) === "string")) || ((typeof obj) === "number")) || ((typeof obj) === "boolean")) || (obj instanceof $c_RTLong)) || (obj instanceof $Char));
}
function $as_jl_Comparable(obj) {
  return (($is_jl_Comparable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Comparable"));
}
function $isArrayOf_jl_Comparable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Comparable)));
}
function $asArrayOf_jl_Comparable(obj, depth) {
  return (($isArrayOf_jl_Comparable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Comparable;", depth));
}
/** @constructor */
function $c_jl_FloatingPointBits$() {
  this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$_areTypedArraysSupported = false;
  this.jl_FloatingPointBits$__f_arrayBuffer = null;
  this.jl_FloatingPointBits$__f_int32Array = null;
  this.jl_FloatingPointBits$__f_float32Array = null;
  this.jl_FloatingPointBits$__f_float64Array = null;
  this.jl_FloatingPointBits$__f_areTypedArraysBigEndian = false;
  this.jl_FloatingPointBits$__f_highOffset = 0;
  this.jl_FloatingPointBits$__f_lowOffset = 0;
  this.jl_FloatingPointBits$__f_floatPowsOf2 = null;
  this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$doublePowsOf2 = null;
  $n_jl_FloatingPointBits$ = this;
  this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$_areTypedArraysSupported = true;
  this.jl_FloatingPointBits$__f_arrayBuffer = new ArrayBuffer(8);
  this.jl_FloatingPointBits$__f_int32Array = new Int32Array(this.jl_FloatingPointBits$__f_arrayBuffer, 0, 2);
  this.jl_FloatingPointBits$__f_float32Array = new Float32Array(this.jl_FloatingPointBits$__f_arrayBuffer, 0, 2);
  this.jl_FloatingPointBits$__f_float64Array = new Float64Array(this.jl_FloatingPointBits$__f_arrayBuffer, 0, 1);
  this.jl_FloatingPointBits$__f_int32Array[0] = 16909060;
  this.jl_FloatingPointBits$__f_areTypedArraysBigEndian = ($uB(new Int8Array(this.jl_FloatingPointBits$__f_arrayBuffer, 0, 8)[0]) === 1);
  this.jl_FloatingPointBits$__f_highOffset = (this.jl_FloatingPointBits$__f_areTypedArraysBigEndian ? 0 : 1);
  this.jl_FloatingPointBits$__f_lowOffset = (this.jl_FloatingPointBits$__f_areTypedArraysBigEndian ? 1 : 0);
  this.jl_FloatingPointBits$__f_floatPowsOf2 = null;
  this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$doublePowsOf2 = null;
}
$c_jl_FloatingPointBits$.prototype = new $h_O();
$c_jl_FloatingPointBits$.prototype.constructor = $c_jl_FloatingPointBits$;
/** @constructor */
function $h_jl_FloatingPointBits$() {
}
$h_jl_FloatingPointBits$.prototype = $c_jl_FloatingPointBits$.prototype;
$c_jl_FloatingPointBits$.prototype.numberHashCode__D__I = (function(value) {
  var iv = $uI((value | 0.0));
  if (((iv === value) && ((1.0 / value) !== (-Infinity)))) {
    return iv;
  } else {
    this.jl_FloatingPointBits$__f_float64Array[0] = value;
    return ($uI(this.jl_FloatingPointBits$__f_int32Array[0]) ^ $uI(this.jl_FloatingPointBits$__f_int32Array[1]));
  }
});
$c_jl_FloatingPointBits$.prototype.intBitsToFloat__I__F = (function(bits) {
  this.jl_FloatingPointBits$__f_int32Array[0] = bits;
  return $uF(this.jl_FloatingPointBits$__f_float32Array[0]);
});
$c_jl_FloatingPointBits$.prototype.floatToIntBits__F__I = (function(value) {
  this.jl_FloatingPointBits$__f_float32Array[0] = value;
  return $uI(this.jl_FloatingPointBits$__f_int32Array[0]);
});
$c_jl_FloatingPointBits$.prototype.doubleToLongBits__D__J = (function(value) {
  this.jl_FloatingPointBits$__f_float64Array[0] = value;
  var value$1 = $uI(this.jl_FloatingPointBits$__f_int32Array[this.jl_FloatingPointBits$__f_highOffset]);
  var value$2 = $uI(this.jl_FloatingPointBits$__f_int32Array[this.jl_FloatingPointBits$__f_lowOffset]);
  return new $c_RTLong(value$2, value$1);
});
var $d_jl_FloatingPointBits$ = new $TypeData().initClass($c_jl_FloatingPointBits$, "java.lang.FloatingPointBits$", ({
  jl_FloatingPointBits$: 1
}));
var $n_jl_FloatingPointBits$;
function $m_jl_FloatingPointBits$() {
  if ((!$n_jl_FloatingPointBits$)) {
    $n_jl_FloatingPointBits$ = new $c_jl_FloatingPointBits$();
  }
  return $n_jl_FloatingPointBits$;
}
/** @constructor */
function $c_jl_Long$StringRadixInfo(chunkLength, radixPowLength, paddingZeros, overflowBarrier) {
  this.jl_Long$StringRadixInfo__f_chunkLength = 0;
  this.jl_Long$StringRadixInfo__f_radixPowLength = $L0;
  this.jl_Long$StringRadixInfo__f_paddingZeros = null;
  this.jl_Long$StringRadixInfo__f_overflowBarrier = $L0;
  this.jl_Long$StringRadixInfo__f_chunkLength = chunkLength;
  this.jl_Long$StringRadixInfo__f_radixPowLength = radixPowLength;
  this.jl_Long$StringRadixInfo__f_paddingZeros = paddingZeros;
  this.jl_Long$StringRadixInfo__f_overflowBarrier = overflowBarrier;
}
$c_jl_Long$StringRadixInfo.prototype = new $h_O();
$c_jl_Long$StringRadixInfo.prototype.constructor = $c_jl_Long$StringRadixInfo;
/** @constructor */
function $h_jl_Long$StringRadixInfo() {
}
$h_jl_Long$StringRadixInfo.prototype = $c_jl_Long$StringRadixInfo.prototype;
function $as_jl_Long$StringRadixInfo(obj) {
  return (((obj instanceof $c_jl_Long$StringRadixInfo) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Long$StringRadixInfo"));
}
function $isArrayOf_jl_Long$StringRadixInfo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Long$StringRadixInfo)));
}
function $asArrayOf_jl_Long$StringRadixInfo(obj, depth) {
  return (($isArrayOf_jl_Long$StringRadixInfo(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Long$StringRadixInfo;", depth));
}
var $d_jl_Long$StringRadixInfo = new $TypeData().initClass($c_jl_Long$StringRadixInfo, "java.lang.Long$StringRadixInfo", ({
  jl_Long$StringRadixInfo: 1
}));
/** @constructor */
function $c_jl_Math$() {
}
$c_jl_Math$.prototype = new $h_O();
$c_jl_Math$.prototype.constructor = $c_jl_Math$;
/** @constructor */
function $h_jl_Math$() {
}
$h_jl_Math$.prototype = $c_jl_Math$.prototype;
$c_jl_Math$.prototype.nextUp__F__F = (function(a) {
  if (((a !== a) || (a === Infinity))) {
    return a;
  } else if ((a === (-0))) {
    return 1.401298464324817E-45;
  } else {
    var abits = $m_jl_FloatingPointBits$().floatToIntBits__F__I(a);
    var rbits = ((a > 0.0) ? ((1 + abits) | 0) : (((-1) + abits) | 0));
    return $m_jl_FloatingPointBits$().intBitsToFloat__I__F(rbits);
  }
});
$c_jl_Math$.prototype.nextDown__F__F = (function(a) {
  if (((a !== a) || (a === (-Infinity)))) {
    return a;
  } else if ((a === 0.0)) {
    return (-1.401298464324817E-45);
  } else {
    var abits = $m_jl_FloatingPointBits$().floatToIntBits__F__I(a);
    var rbits = ((a > 0.0) ? (((-1) + abits) | 0) : ((1 + abits) | 0));
    return $m_jl_FloatingPointBits$().intBitsToFloat__I__F(rbits);
  }
});
var $d_jl_Math$ = new $TypeData().initClass($c_jl_Math$, "java.lang.Math$", ({
  jl_Math$: 1
}));
var $n_jl_Math$;
function $m_jl_Math$() {
  if ((!$n_jl_Math$)) {
    $n_jl_Math$ = new $c_jl_Math$();
  }
  return $n_jl_Math$;
}
function $is_jl_Runnable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.jl_Runnable)));
}
function $as_jl_Runnable(obj) {
  return (($is_jl_Runnable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Runnable"));
}
function $isArrayOf_jl_Runnable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Runnable)));
}
function $asArrayOf_jl_Runnable(obj, depth) {
  return (($isArrayOf_jl_Runnable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Runnable;", depth));
}
var $d_jl_Runnable = new $TypeData().initClass(1, "java.lang.Runnable", ({
  jl_Runnable: 1
}));
/** @constructor */
function $c_jl_Runtime() {
}
$c_jl_Runtime.prototype = new $h_O();
$c_jl_Runtime.prototype.constructor = $c_jl_Runtime;
/** @constructor */
function $h_jl_Runtime() {
}
$h_jl_Runtime.prototype = $c_jl_Runtime.prototype;
var $d_jl_Runtime = new $TypeData().initClass($c_jl_Runtime, "java.lang.Runtime", ({
  jl_Runtime: 1
}));
/** @constructor */
function $c_jl_Runtime$() {
  this.jl_Runtime$__f_currentRuntime = null;
  $n_jl_Runtime$ = this;
  this.jl_Runtime$__f_currentRuntime = new $c_jl_Runtime();
}
$c_jl_Runtime$.prototype = new $h_O();
$c_jl_Runtime$.prototype.constructor = $c_jl_Runtime$;
/** @constructor */
function $h_jl_Runtime$() {
}
$h_jl_Runtime$.prototype = $c_jl_Runtime$.prototype;
var $d_jl_Runtime$ = new $TypeData().initClass($c_jl_Runtime$, "java.lang.Runtime$", ({
  jl_Runtime$: 1
}));
var $n_jl_Runtime$;
function $m_jl_Runtime$() {
  if ((!$n_jl_Runtime$)) {
    $n_jl_Runtime$ = new $c_jl_Runtime$();
  }
  return $n_jl_Runtime$;
}
function $p_jl_StackTrace$__normalizedLinesToStackTrace__O__Ajl_StackTraceElement($thiz, lines) {
  var NormalizedFrameLine = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^([^@]*)@(.*?):([0-9]+)(?::([0-9]+))?$");
  var trace = [];
  var i = 0;
  while ((i < $uI(lines.length))) {
    var line = $as_T(lines[i]);
    var this$1 = $n(line);
    if ((!(this$1 === ""))) {
      var mtch = NormalizedFrameLine.exec(line);
      if ((mtch !== null)) {
        var x = mtch[1];
        var classAndMethodName = $p_jl_StackTrace$__extractClassMethod__T__O($thiz, $as_T(x));
        var $x_6 = $as_T(classAndMethodName[0]);
        var $x_5 = $as_T(classAndMethodName[1]);
        var x$1 = mtch[2];
        var $x_4 = $as_T(x$1);
        var x$2 = mtch[3];
        var s = $as_T(x$2);
        var $x_3 = $uI(parseInt(s));
        var x$3 = mtch[4];
        if ((x$3 !== (void 0))) {
          var x$1$1 = $as_T(x$3);
          var $x_2 = $uI(parseInt(x$1$1));
        } else {
          var $x_2 = (-1);
        }
        var $x_1 = trace.push($ct_jl_StackTraceElement__T__T__T__I__I__(new $c_jl_StackTraceElement(), $x_6, $x_5, $x_4, $x_3, $x_2));
        $uI($x_1);
      } else {
        $uI(trace.push($ct_jl_StackTraceElement__T__T__T__I__I__(new $c_jl_StackTraceElement(), "<jscode>", line, null, (-1), (-1))));
      }
    }
    i = ((1 + i) | 0);
  }
  var len = $uI(trace.length);
  var result = new ($d_jl_StackTraceElement.getArrayOf().constr)(len);
  i = 0;
  while ((i < len)) {
    $n(result).set(i, $as_jl_StackTraceElement(trace[i]));
    i = ((1 + i) | 0);
  }
  return result;
}
function $p_jl_StackTrace$__extractClassMethod__T__O($thiz, functionName) {
  var PatBC = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$[bc]_([^\\.]+)(?:\\.prototype)?\\.([^\\.]+)$");
  var PatS = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$(?:ps?|s|f)_((?:_[^_]|[^_])+)__([^\\.]+)$");
  var PatCT = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$ct_((?:_[^_]|[^_])+)__([^\\.]*)$");
  var PatN = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^new (?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$c_([^\\.]+)$");
  var PatM = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$m_([^\\.]+)$");
  var matchBC = PatBC.exec(functionName);
  var matchBCOrS = ((matchBC !== null) ? matchBC : PatS.exec(functionName));
  if ((matchBCOrS !== null)) {
    var x = matchBCOrS[1];
    var $x_1 = $p_jl_StackTrace$__decodeClassName__T__T($thiz, $as_T(x));
    var x$1 = matchBCOrS[2];
    return [$x_1, $p_jl_StackTrace$__decodeMethodName__T__T($thiz, $as_T(x$1))];
  } else {
    var matchCT = PatCT.exec(functionName);
    var matchCTOrN = ((matchCT !== null) ? matchCT : PatN.exec(functionName));
    if ((matchCTOrN !== null)) {
      var x$2 = matchCTOrN[1];
      return [$p_jl_StackTrace$__decodeClassName__T__T($thiz, $as_T(x$2)), "<init>"];
    } else {
      var matchM = PatM.exec(functionName);
      if ((matchM !== null)) {
        var x$3 = matchM[1];
        return [$p_jl_StackTrace$__decodeClassName__T__T($thiz, $as_T(x$3)), "<clinit>"];
      } else {
        return ["<jscode>", functionName];
      }
    }
  }
}
function $p_jl_StackTrace$__decodeClassName__T__T($thiz, encodedName) {
  var dict = $p_jl_StackTrace$__decompressedClasses__O($thiz);
  if ($uZ($m_jl_Utils$Cache$().jl_Utils$Cache$__f_safeHasOwnProperty.call(dict, encodedName))) {
    var dict$1 = $p_jl_StackTrace$__decompressedClasses__O($thiz);
    var base = $as_T(dict$1[encodedName]);
  } else {
    var base = $p_jl_StackTrace$__loop$1__I__T__T($thiz, 0, encodedName);
  }
  var this$3 = $n(base);
  var this$4 = $n($as_T(this$3.split("_").join(".")));
  return $as_T(this$4.split("\uff3f").join("_"));
}
function $p_jl_StackTrace$__decompressedClasses$lzycompute__O($thiz) {
  if (((((1 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0)) {
    var dict = ({});
    dict.O = "java_lang_Object";
    dict.T = "java_lang_String";
    var index = 0;
    while ((index <= 22)) {
      if ((index >= 2)) {
        var key = ("T" + index);
        var value = ("scala_Tuple" + index);
        dict[key] = value;
      }
      var key$1 = ("F" + index);
      var value$1 = ("scala_Function" + index);
      dict[key$1] = value$1;
      index = ((1 + index) | 0);
    }
    $thiz.jl_StackTrace$__f_decompressedClasses = dict;
    $thiz.jl_StackTrace$__f_bitmap$0 = (((1 | $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.jl_StackTrace$__f_decompressedClasses;
}
function $p_jl_StackTrace$__decompressedClasses__O($thiz) {
  return (((((1 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_StackTrace$__decompressedClasses$lzycompute__O($thiz) : $thiz.jl_StackTrace$__f_decompressedClasses);
}
function $p_jl_StackTrace$__decompressedPrefixes$lzycompute__O($thiz) {
  if (((((2 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0)) {
    var dict = ({});
    dict.sjsr_ = "scala_scalajs_runtime_";
    dict.sjs_ = "scala_scalajs_";
    dict.sci_ = "scala_collection_immutable_";
    dict.scm_ = "scala_collection_mutable_";
    dict.scg_ = "scala_collection_generic_";
    dict.sc_ = "scala_collection_";
    dict.sr_ = "scala_runtime_";
    dict.s_ = "scala_";
    dict.jl_ = "java_lang_";
    dict.ju_ = "java_util_";
    $thiz.jl_StackTrace$__f_decompressedPrefixes = dict;
    $thiz.jl_StackTrace$__f_bitmap$0 = (((2 | $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.jl_StackTrace$__f_decompressedPrefixes;
}
function $p_jl_StackTrace$__decompressedPrefixes__O($thiz) {
  return (((((2 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_StackTrace$__decompressedPrefixes$lzycompute__O($thiz) : $thiz.jl_StackTrace$__f_decompressedPrefixes);
}
function $p_jl_StackTrace$__compressedPrefixes$lzycompute__O($thiz) {
  if (((((4 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_StackTrace$__f_compressedPrefixes = Object.keys($p_jl_StackTrace$__decompressedPrefixes__O($thiz));
    $thiz.jl_StackTrace$__f_bitmap$0 = (((4 | $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.jl_StackTrace$__f_compressedPrefixes;
}
function $p_jl_StackTrace$__compressedPrefixes__O($thiz) {
  return (((((4 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_StackTrace$__compressedPrefixes$lzycompute__O($thiz) : $thiz.jl_StackTrace$__f_compressedPrefixes);
}
function $p_jl_StackTrace$__decodeMethodName__T__T($thiz, encodedName) {
  var this$1 = $n(encodedName);
  if (((this$1.length >= 0) && ($as_T(this$1.substring(0, 7)) === "init___"))) {
    return "<init>";
  } else {
    var this$2 = $n(encodedName);
    var methodNameLen = $uI(this$2.indexOf("__"));
    return ((methodNameLen < 0) ? encodedName : $as_T(encodedName.substring(0, methodNameLen)));
  }
}
function $p_jl_StackTrace$__normalizeStackTraceLines__O__O($thiz, e) {
  return ($uZ((!(!(!e)))) ? [] : ($uZ((!(!(e.arguments && e.stack)))) ? $p_jl_StackTrace$__extractChrome__O__O($thiz, e) : ($uZ((!(!(e.stack && e.sourceURL)))) ? $p_jl_StackTrace$__extractSafari__O__O($thiz, e) : ($uZ((!(!(e.stack && e.number)))) ? $p_jl_StackTrace$__extractIE__O__O($thiz, e) : ($uZ((!(!(e.stack && e.fileName)))) ? $p_jl_StackTrace$__extractFirefox__O__O($thiz, e) : ($uZ((!(!(e.message && e["opera#sourceloc"])))) ? ($uZ((!(!(!e.stacktrace)))) ? $p_jl_StackTrace$__extractOpera9__O__O($thiz, e) : ($uZ((!(!((e.message.indexOf("\n") > (-1.0)) && (e.message.split("\n").length > e.stacktrace.split("\n").length))))) ? $p_jl_StackTrace$__extractOpera9__O__O($thiz, e) : $p_jl_StackTrace$__extractOpera10a__O__O($thiz, e))) : ($uZ((!(!((e.message && e.stack) && e.stacktrace)))) ? ($uZ((!(!(e.stacktrace.indexOf("called from line") < 0.0)))) ? $p_jl_StackTrace$__extractOpera10b__O__O($thiz, e) : $p_jl_StackTrace$__extractOpera11__O__O($thiz, e)) : ($uZ((!(!(e.stack && (!e.fileName))))) ? $p_jl_StackTrace$__extractChrome__O__O($thiz, e) : $p_jl_StackTrace$__extractOther__O__O($thiz, e)))))))));
}
function $p_jl_StackTrace$__extractChrome__O__O($thiz, e) {
  return $as_T($as_T($as_T($as_T($as_T(($as_T(e.stack) + "\n").replace($m_jl_StackTrace$StringRE$().re$extension0__T__O("^[\\s\\S]+?\\s+at\\s+"), " at ")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^\\s+(at eval )?at\\s+", "gm"), "")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^([^\\(]+?)([\\n])", "gm"), "{anonymous}() ($1)$2")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^Object.<anonymous>\\s*\\(([^\\)]+)\\)", "gm"), "{anonymous}() ($1)")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^([^\\(]+|\\{anonymous\\}\\(\\)) \\((.+)\\)$", "gm"), "$1@$2")).split("\n").slice(0, (-1));
}
function $p_jl_StackTrace$__extractFirefox__O__O($thiz, e) {
  return $as_T($as_T($as_T(e.stack).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("(?:\\n@:0)?\\s+$", "m"), "")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^(?:\\((\\S*)\\))?@", "gm"), "{anonymous}($1)@")).split("\n");
}
function $p_jl_StackTrace$__extractIE__O__O($thiz, e) {
  var qual$1 = $as_T($as_T($as_T($as_T(e.stack).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^\\s*at\\s+(.*)$", "gm"), "$1")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^Anonymous function\\s+", "gm"), "{anonymous}() ")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^([^\\(]+|\\{anonymous\\}\\(\\))\\s+\\((.+)\\)$", "gm"), "$1@$2")).split("\n");
  return qual$1.slice(1);
}
function $p_jl_StackTrace$__extractSafari__O__O($thiz, e) {
  return $as_T($as_T($as_T($as_T(e.stack).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("\\[native code\\]\\n", "m"), "")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^(?=\\w+Error\\:).*$\\n", "m"), "")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^@", "gm"), "{anonymous}()@")).split("\n");
}
function $p_jl_StackTrace$__extractOpera9__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().re$extension1__T__T__O("Line (\\d+).*script (?:in )?(\\S+)", "i");
  var lines = $as_T(e.message).split("\n");
  var result = [];
  var i = 2;
  var len = $uI(lines.length);
  while ((i < len)) {
    var mtch = lineRE.exec($as_T(lines[i]));
    if ((mtch !== null)) {
      var x = mtch[2];
      var x$1 = mtch[1];
      var $x_1 = result.push(((("{anonymous}()@" + x) + ":") + x$1));
      $uI($x_1);
    }
    i = ((2 + i) | 0);
  }
  return result;
}
function $p_jl_StackTrace$__extractOpera10a__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().re$extension1__T__T__O("Line (\\d+).*script (?:in )?(\\S+)(?:: In function (\\S+))?$", "i");
  var lines = $as_T(e.stacktrace).split("\n");
  var result = [];
  var i = 0;
  var len = $uI(lines.length);
  while ((i < len)) {
    var mtch = lineRE.exec($as_T(lines[i]));
    if ((mtch !== null)) {
      var x = mtch[3];
      var fnName = $as_T(((x !== (void 0)) ? x : "{anonymous}"));
      var x$1 = mtch[2];
      var x$2 = mtch[1];
      var $x_1 = result.push(((((fnName + "()@") + x$1) + ":") + x$2));
      $uI($x_1);
    }
    i = ((2 + i) | 0);
  }
  return result;
}
function $p_jl_StackTrace$__extractOpera10b__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^(.*)@(.+):(\\d+)$");
  var lines = $as_T(e.stacktrace).split("\n");
  var result = [];
  var i = 0;
  var len = $uI(lines.length);
  while ((i < len)) {
    var mtch = lineRE.exec($as_T(lines[i]));
    if ((mtch !== null)) {
      var x = mtch[1];
      if ((x !== (void 0))) {
        var x$2 = $as_T(x);
        var fnName = (x$2 + "()");
      } else {
        var fnName = "global code";
      }
      var x$1 = mtch[2];
      var x$3 = mtch[3];
      var $x_1 = result.push(((((fnName + "@") + x$1) + ":") + x$3));
      $uI($x_1);
    }
    i = ((1 + i) | 0);
  }
  return result;
}
function $p_jl_StackTrace$__extractOpera11__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^.*line (\\d+), column (\\d+)(?: in (.+))? in (\\S+):$");
  var lines = $as_T(e.stacktrace).split("\n");
  var result = [];
  var i = 0;
  var len = $uI(lines.length);
  while ((i < len)) {
    var mtch = lineRE.exec($as_T(lines[i]));
    if ((mtch !== null)) {
      var x = mtch[4];
      var $x_1 = $as_T(x);
      var x$1 = mtch[1];
      var x$2 = mtch[2];
      var location = (((($x_1 + ":") + x$1) + ":") + x$2);
      var x$3 = mtch[2];
      var fnName0 = $as_T(((x$3 !== (void 0)) ? x$3 : "global code"));
      var fnName = $as_T($as_T(fnName0.replace($m_jl_StackTrace$StringRE$().re$extension0__T__O("<anonymous function: (\\S+)>"), "$1")).replace($m_jl_StackTrace$StringRE$().re$extension0__T__O("<anonymous function>"), "{anonymous}"));
      $uI(result.push(((fnName + "@") + location)));
    }
    i = ((2 + i) | 0);
  }
  return result;
}
function $p_jl_StackTrace$__extractOther__O__O($thiz, e) {
  return [];
}
function $p_jl_StackTrace$__loop$1__I__T__T($thiz, i, encodedName$1) {
  while (true) {
    if ((i < $uI($p_jl_StackTrace$__compressedPrefixes__O($thiz).length))) {
      var prefix = $as_T($p_jl_StackTrace$__compressedPrefixes__O($thiz)[i]);
      var this$1 = $n(encodedName$1);
      if ((this$1.length >= 0)) {
        var this$2 = $n(prefix);
        var $x_2 = this$1.substring(0, this$2.length);
        var $x_1 = ($as_T($x_2) === prefix);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var dict = $p_jl_StackTrace$__decompressedPrefixes__O($thiz);
        var $x_4 = $as_T(dict[prefix]);
        var this$4 = $n(prefix);
        var $x_3 = encodedName$1.substring(this$4.length);
        return (("" + $x_4) + $as_T($x_3));
      } else {
        i = ((1 + i) | 0);
      }
    } else {
      var this$5 = $n(encodedName$1);
      if (((this$5.length >= 0) && ($as_T(this$5.substring(0, 1)) === "L"))) {
        return $as_T(encodedName$1.substring(1));
      } else {
        return encodedName$1;
      }
    }
  }
}
/** @constructor */
function $c_jl_StackTrace$() {
  this.jl_StackTrace$__f_decompressedClasses = null;
  this.jl_StackTrace$__f_decompressedPrefixes = null;
  this.jl_StackTrace$__f_compressedPrefixes = null;
  this.jl_StackTrace$__f_bitmap$0 = 0;
}
$c_jl_StackTrace$.prototype = new $h_O();
$c_jl_StackTrace$.prototype.constructor = $c_jl_StackTrace$;
/** @constructor */
function $h_jl_StackTrace$() {
}
$h_jl_StackTrace$.prototype = $c_jl_StackTrace$.prototype;
$c_jl_StackTrace$.prototype.extract__O__Ajl_StackTraceElement = (function(jsError) {
  var lines = $p_jl_StackTrace$__normalizeStackTraceLines__O__O(this, jsError);
  return $p_jl_StackTrace$__normalizedLinesToStackTrace__O__Ajl_StackTraceElement(this, lines);
});
var $d_jl_StackTrace$ = new $TypeData().initClass($c_jl_StackTrace$, "java.lang.StackTrace$", ({
  jl_StackTrace$: 1
}));
var $n_jl_StackTrace$;
function $m_jl_StackTrace$() {
  if ((!$n_jl_StackTrace$)) {
    $n_jl_StackTrace$ = new $c_jl_StackTrace$();
  }
  return $n_jl_StackTrace$;
}
/** @constructor */
function $c_jl_StackTrace$StringRE$() {
}
$c_jl_StackTrace$StringRE$.prototype = new $h_O();
$c_jl_StackTrace$StringRE$.prototype.constructor = $c_jl_StackTrace$StringRE$;
/** @constructor */
function $h_jl_StackTrace$StringRE$() {
}
$h_jl_StackTrace$StringRE$.prototype = $c_jl_StackTrace$StringRE$.prototype;
$c_jl_StackTrace$StringRE$.prototype.re$extension0__T__O = (function(this$) {
  return new RegExp(this$);
});
$c_jl_StackTrace$StringRE$.prototype.re$extension1__T__T__O = (function(this$, mods) {
  return new RegExp(this$, mods);
});
var $d_jl_StackTrace$StringRE$ = new $TypeData().initClass($c_jl_StackTrace$StringRE$, "java.lang.StackTrace$StringRE$", ({
  jl_StackTrace$StringRE$: 1
}));
var $n_jl_StackTrace$StringRE$;
function $m_jl_StackTrace$StringRE$() {
  if ((!$n_jl_StackTrace$StringRE$)) {
    $n_jl_StackTrace$StringRE$ = new $c_jl_StackTrace$StringRE$();
  }
  return $n_jl_StackTrace$StringRE$;
}
/** @constructor */
function $c_jl_System$NanoTime$() {
  this.jl_System$NanoTime$__f_getHighPrecisionTime = null;
  $n_jl_System$NanoTime$ = this;
  this.jl_System$NanoTime$__f_getHighPrecisionTime = (($as_T((typeof performance)) !== "undefined") ? ($uZ((!(!performance.now))) ? (() => $uD(performance.now())) : ($uZ((!(!performance.webkitNow))) ? (() => $uD(performance.webkitNow())) : (() => $uD(new Date().getTime())))) : (() => $uD(new Date().getTime())));
}
$c_jl_System$NanoTime$.prototype = new $h_O();
$c_jl_System$NanoTime$.prototype.constructor = $c_jl_System$NanoTime$;
/** @constructor */
function $h_jl_System$NanoTime$() {
}
$h_jl_System$NanoTime$.prototype = $c_jl_System$NanoTime$.prototype;
var $d_jl_System$NanoTime$ = new $TypeData().initClass($c_jl_System$NanoTime$, "java.lang.System$NanoTime$", ({
  jl_System$NanoTime$: 1
}));
var $n_jl_System$NanoTime$;
function $m_jl_System$NanoTime$() {
  if ((!$n_jl_System$NanoTime$)) {
    $n_jl_System$NanoTime$ = new $c_jl_System$NanoTime$();
  }
  return $n_jl_System$NanoTime$;
}
/** @constructor */
function $c_jl_System$Streams$() {
  this.jl_System$Streams$__f_out = null;
  this.jl_System$Streams$__f_err = null;
  $n_jl_System$Streams$ = this;
  this.jl_System$Streams$__f_out = new $c_jl_JSConsoleBasedPrintStream(false);
  this.jl_System$Streams$__f_err = new $c_jl_JSConsoleBasedPrintStream(true);
}
$c_jl_System$Streams$.prototype = new $h_O();
$c_jl_System$Streams$.prototype.constructor = $c_jl_System$Streams$;
/** @constructor */
function $h_jl_System$Streams$() {
}
$h_jl_System$Streams$.prototype = $c_jl_System$Streams$.prototype;
var $d_jl_System$Streams$ = new $TypeData().initClass($c_jl_System$Streams$, "java.lang.System$Streams$", ({
  jl_System$Streams$: 1
}));
var $n_jl_System$Streams$;
function $m_jl_System$Streams$() {
  if ((!$n_jl_System$Streams$)) {
    $n_jl_System$Streams$ = new $c_jl_System$Streams$();
  }
  return $n_jl_System$Streams$;
}
function $p_jl_System$SystemProperties$__loadSystemProperties__O($thiz) {
  var result = ({});
  result["java.version"] = "1.8";
  result["java.vm.specification.version"] = "1.8";
  result["java.vm.specification.vendor"] = "Oracle Corporation";
  result["java.vm.specification.name"] = "Java Virtual Machine Specification";
  result["java.vm.name"] = "Scala.js";
  var value = $as_T($linkingInfo.linkerVersion);
  result["java.vm.version"] = value;
  result["java.specification.version"] = "1.8";
  result["java.specification.vendor"] = "Oracle Corporation";
  result["java.specification.name"] = "Java Platform API Specification";
  result["file.separator"] = "/";
  result["path.separator"] = ":";
  result["line.separator"] = "\n";
  return result;
}
/** @constructor */
function $c_jl_System$SystemProperties$() {
  this.jl_System$SystemProperties$__f_dict = null;
  this.jl_System$SystemProperties$__f_properties = null;
  $n_jl_System$SystemProperties$ = this;
  this.jl_System$SystemProperties$__f_dict = $p_jl_System$SystemProperties$__loadSystemProperties__O(this);
  this.jl_System$SystemProperties$__f_properties = null;
}
$c_jl_System$SystemProperties$.prototype = new $h_O();
$c_jl_System$SystemProperties$.prototype.constructor = $c_jl_System$SystemProperties$;
/** @constructor */
function $h_jl_System$SystemProperties$() {
}
$h_jl_System$SystemProperties$.prototype = $c_jl_System$SystemProperties$.prototype;
$c_jl_System$SystemProperties$.prototype.getProperty__T__T__T = (function(key, default$1) {
  if ((this.jl_System$SystemProperties$__f_dict !== null)) {
    var dict = this.jl_System$SystemProperties$__f_dict;
    return $as_T(($uZ($m_jl_Utils$Cache$().jl_Utils$Cache$__f_safeHasOwnProperty.call(dict, key)) ? dict[key] : default$1));
  } else {
    return $n(this.jl_System$SystemProperties$__f_properties).getProperty__T__T__T(key, default$1);
  }
});
var $d_jl_System$SystemProperties$ = new $TypeData().initClass($c_jl_System$SystemProperties$, "java.lang.System$SystemProperties$", ({
  jl_System$SystemProperties$: 1
}));
var $n_jl_System$SystemProperties$;
function $m_jl_System$SystemProperties$() {
  if ((!$n_jl_System$SystemProperties$)) {
    $n_jl_System$SystemProperties$ = new $c_jl_System$SystemProperties$();
  }
  return $n_jl_System$SystemProperties$;
}
/** @constructor */
function $c_jl_Thread$() {
  this.jl_Thread$__f_SingleThread = null;
  $n_jl_Thread$ = this;
  this.jl_Thread$__f_SingleThread = new $c_jl_Thread((void 0));
}
$c_jl_Thread$.prototype = new $h_O();
$c_jl_Thread$.prototype.constructor = $c_jl_Thread$;
/** @constructor */
function $h_jl_Thread$() {
}
$h_jl_Thread$.prototype = $c_jl_Thread$.prototype;
$c_jl_Thread$.prototype.interrupted__Z = (function() {
  var this$1 = $n(this.jl_Thread$__f_SingleThread);
  var ret = this$1.jl_Thread__f_java$lang$Thread$$interruptedState;
  $n(this.jl_Thread$__f_SingleThread).jl_Thread__f_java$lang$Thread$$interruptedState = false;
  return ret;
});
var $d_jl_Thread$ = new $TypeData().initClass($c_jl_Thread$, "java.lang.Thread$", ({
  jl_Thread$: 1
}));
var $n_jl_Thread$;
function $m_jl_Thread$() {
  if ((!$n_jl_Thread$)) {
    $n_jl_Thread$ = new $c_jl_Thread$();
  }
  return $n_jl_Thread$;
}
/** @constructor */
function $c_jl_ThreadLocal() {
  this.jl_ThreadLocal__f_hasValue = false;
  this.jl_ThreadLocal__f_v = null;
  this.jl_ThreadLocal__f_hasValue = false;
}
$c_jl_ThreadLocal.prototype = new $h_O();
$c_jl_ThreadLocal.prototype.constructor = $c_jl_ThreadLocal;
/** @constructor */
function $h_jl_ThreadLocal() {
}
$h_jl_ThreadLocal.prototype = $c_jl_ThreadLocal.prototype;
$c_jl_ThreadLocal.prototype.get__O = (function() {
  if ((!this.jl_ThreadLocal__f_hasValue)) {
    this.set__O__V(null);
  }
  return this.jl_ThreadLocal__f_v;
});
$c_jl_ThreadLocal.prototype.set__O__V = (function(o) {
  this.jl_ThreadLocal__f_v = o;
  this.jl_ThreadLocal__f_hasValue = true;
});
var $d_jl_ThreadLocal = new $TypeData().initClass($c_jl_ThreadLocal, "java.lang.ThreadLocal", ({
  jl_ThreadLocal: 1
}));
/** @constructor */
function $c_jl_Utils$Cache$() {
  this.jl_Utils$Cache$__f_safeHasOwnProperty = null;
  $n_jl_Utils$Cache$ = this;
  this.jl_Utils$Cache$__f_safeHasOwnProperty = Object.prototype.hasOwnProperty;
}
$c_jl_Utils$Cache$.prototype = new $h_O();
$c_jl_Utils$Cache$.prototype.constructor = $c_jl_Utils$Cache$;
/** @constructor */
function $h_jl_Utils$Cache$() {
}
$h_jl_Utils$Cache$.prototype = $c_jl_Utils$Cache$.prototype;
var $d_jl_Utils$Cache$ = new $TypeData().initClass($c_jl_Utils$Cache$, "java.lang.Utils$Cache$", ({
  jl_Utils$Cache$: 1
}));
var $n_jl_Utils$Cache$;
function $m_jl_Utils$Cache$() {
  if ((!$n_jl_Utils$Cache$)) {
    $n_jl_Utils$Cache$ = new $c_jl_Utils$Cache$();
  }
  return $n_jl_Utils$Cache$;
}
function $f_jl_Void__equals__O__Z($thiz, that) {
  return ($thiz === that);
}
function $f_jl_Void__hashCode__I($thiz) {
  return 0;
}
function $f_jl_Void__toString__T($thiz) {
  return "undefined";
}
function $as_jl_Void(obj) {
  return (((obj === (void 0)) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Void"));
}
function $isArrayOf_jl_Void(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Void)));
}
function $asArrayOf_jl_Void(obj, depth) {
  return (($isArrayOf_jl_Void(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Void;", depth));
}
var $d_jl_Void = new $TypeData().initClass(0, "java.lang.Void", ({
  jl_Void: 1
}), ((x) => (x === (void 0))));
function $p_jl_reflect_Array$__mismatch__O__E($thiz, array) {
  var this$1 = $n(array);
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "argument type mismatch");
}
/** @constructor */
function $c_jl_reflect_Array$() {
}
$c_jl_reflect_Array$.prototype = new $h_O();
$c_jl_reflect_Array$.prototype.constructor = $c_jl_reflect_Array$;
/** @constructor */
function $h_jl_reflect_Array$() {
}
$h_jl_reflect_Array$.prototype = $c_jl_reflect_Array$.prototype;
$c_jl_reflect_Array$.prototype.newInstance__jl_Class__I__O = (function(componentType, length) {
  return $n(componentType).newArrayOfThisClass__O__O([length]);
});
$c_jl_reflect_Array$.prototype.newInstance__jl_Class__AI__O = (function(componentType, dimensions) {
  var jsDims = [];
  var len = $n(dimensions).u.length;
  var i = 0;
  while ((i !== len)) {
    jsDims.push($n(dimensions).get(i));
    i = ((1 + i) | 0);
  }
  return $n(componentType).newArrayOfThisClass__O__O(jsDims);
});
$c_jl_reflect_Array$.prototype.getLength__O__I = (function(array) {
  if ((array instanceof $ac_O)) {
    var x2 = $asArrayOf_O(array, 1);
    return $n(x2).u.length;
  } else if ((array instanceof $ac_Z)) {
    var x3 = $asArrayOf_Z(array, 1);
    return $n(x3).u.length;
  } else if ((array instanceof $ac_C)) {
    var x4 = $asArrayOf_C(array, 1);
    return $n(x4).u.length;
  } else if ((array instanceof $ac_B)) {
    var x5 = $asArrayOf_B(array, 1);
    return $n(x5).u.length;
  } else if ((array instanceof $ac_S)) {
    var x6 = $asArrayOf_S(array, 1);
    return $n(x6).u.length;
  } else if ((array instanceof $ac_I)) {
    var x7 = $asArrayOf_I(array, 1);
    return $n(x7).u.length;
  } else if ((array instanceof $ac_J)) {
    var x8 = $asArrayOf_J(array, 1);
    return $n(x8).u.length;
  } else if ((array instanceof $ac_F)) {
    var x9 = $asArrayOf_F(array, 1);
    return $n(x9).u.length;
  } else if ((array instanceof $ac_D)) {
    var x10 = $asArrayOf_D(array, 1);
    return $n(x10).u.length;
  } else {
    $p_jl_reflect_Array$__mismatch__O__E(this, array);
  }
});
var $d_jl_reflect_Array$ = new $TypeData().initClass($c_jl_reflect_Array$, "java.lang.reflect.Array$", ({
  jl_reflect_Array$: 1
}));
var $n_jl_reflect_Array$;
function $m_jl_reflect_Array$() {
  if ((!$n_jl_reflect_Array$)) {
    $n_jl_reflect_Array$ = new $c_jl_reflect_Array$();
  }
  return $n_jl_reflect_Array$;
}
/** @constructor */
function $c_Ljava_math_BigInteger$QuotAndRem(quot, rem) {
  this.Ljava_math_BigInteger$QuotAndRem__f_quot = null;
  this.Ljava_math_BigInteger$QuotAndRem__f_rem = null;
  this.Ljava_math_BigInteger$QuotAndRem__f_quot = quot;
  this.Ljava_math_BigInteger$QuotAndRem__f_rem = rem;
}
$c_Ljava_math_BigInteger$QuotAndRem.prototype = new $h_O();
$c_Ljava_math_BigInteger$QuotAndRem.prototype.constructor = $c_Ljava_math_BigInteger$QuotAndRem;
/** @constructor */
function $h_Ljava_math_BigInteger$QuotAndRem() {
}
$h_Ljava_math_BigInteger$QuotAndRem.prototype = $c_Ljava_math_BigInteger$QuotAndRem.prototype;
$c_Ljava_math_BigInteger$QuotAndRem.prototype.toArray__ALjava_math_BigInteger = (function() {
  return new ($d_Ljava_math_BigInteger.getArrayOf().constr)([this.Ljava_math_BigInteger$QuotAndRem__f_quot, this.Ljava_math_BigInteger$QuotAndRem__f_rem]);
});
var $d_Ljava_math_BigInteger$QuotAndRem = new $TypeData().initClass($c_Ljava_math_BigInteger$QuotAndRem, "java.math.BigInteger$QuotAndRem", ({
  Ljava_math_BigInteger$QuotAndRem: 1
}));
/** @constructor */
function $c_Ljava_math_BitLevel$() {
}
$c_Ljava_math_BitLevel$.prototype = new $h_O();
$c_Ljava_math_BitLevel$.prototype.constructor = $c_Ljava_math_BitLevel$;
/** @constructor */
function $h_Ljava_math_BitLevel$() {
}
$h_Ljava_math_BitLevel$.prototype = $c_Ljava_math_BitLevel$.prototype;
$c_Ljava_math_BitLevel$.prototype.bitLength__Ljava_math_BigInteger__I = (function(bi) {
  if (($n(bi).Ljava_math_BigInteger__f_sign === 0)) {
    return 0;
  } else {
    var bLength = ($n(bi).Ljava_math_BigInteger__f_numberLength << 5);
    var highDigit = $n($n(bi).Ljava_math_BigInteger__f_digits).get((((-1) + $n(bi).Ljava_math_BigInteger__f_numberLength) | 0));
    if (($n(bi).Ljava_math_BigInteger__f_sign < 0)) {
      var i = $n(bi).getFirstNonzeroDigit__I();
      if ((i === (((-1) + $n(bi).Ljava_math_BigInteger__f_numberLength) | 0))) {
        highDigit = (((-1) + highDigit) | 0);
      }
    }
    var $x_1 = bLength;
    var i$1 = highDigit;
    bLength = (($x_1 - $uI(Math.clz32(i$1))) | 0);
    return bLength;
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftLeft__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(source, count) {
  var intCount = ((count >>> 5) | 0);
  var andCount = (31 & count);
  var offset = ((andCount === 0) ? 0 : 1);
  var resLength = (((($n(source).Ljava_math_BigInteger__f_numberLength + intCount) | 0) + offset) | 0);
  $m_Ljava_math_BigInteger$().checkRangeBasedOnIntArrayLength__I__V(resLength);
  var resDigits = new $ac_I(resLength);
  this.shiftLeft__AI__AI__I__I__V(resDigits, $n(source).Ljava_math_BigInteger__f_digits, intCount, andCount);
  var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), $n(source).Ljava_math_BigInteger__f_sign, resLength, resDigits);
  result.cutOffLeadingZeroes__V();
  return result;
});
$c_Ljava_math_BitLevel$.prototype.shiftLeft__AI__AI__I__I__V = (function(result, source, intCount, count) {
  if ((count === 0)) {
    var x4 = (($n(result).u.length - intCount) | 0);
    $systemArraycopy($n(source), 0, $n(result), intCount, x4);
  } else {
    var rightShiftCount = ((32 - count) | 0);
    $n(result).set((((-1) + $n(result).u.length) | 0), 0);
    var i = (((-1) + $n(result).u.length) | 0);
    while ((i > intCount)) {
      var ev$1 = i;
      $n(result).set(ev$1, ($n(result).get(ev$1) | (($n(source).get((((-1) + ((i - intCount) | 0)) | 0)) >>> rightShiftCount) | 0)));
      $n(result).set((((-1) + i) | 0), ($n(source).get((((-1) + ((i - intCount) | 0)) | 0)) << count));
      i = (((-1) + i) | 0);
    }
  }
  var i$1 = 0;
  while ((i$1 < intCount)) {
    var i$2$2 = i$1;
    $n(result).set(i$2$2, 0);
    i$1 = ((1 + i$1) | 0);
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftLeftOneBit__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(source) {
  var srcLen = $n(source).Ljava_math_BigInteger__f_numberLength;
  var resLen = ((1 + srcLen) | 0);
  var resDigits = new $ac_I(resLen);
  this.shiftLeftOneBit__AI__AI__I__V(resDigits, $n(source).Ljava_math_BigInteger__f_digits, srcLen);
  var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), $n(source).Ljava_math_BigInteger__f_sign, resLen, resDigits);
  result.cutOffLeadingZeroes__V();
  return result;
});
$c_Ljava_math_BitLevel$.prototype.shiftLeftOneBit__AI__AI__I__V = (function(result, source, srcLen) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < srcLen)) {
    var i$2 = i;
    var iVal = $n(source).get(i$2);
    $n(result).set(i$2, ((iVal << 1) | elem));
    elem = ((iVal >>> 31) | 0);
    i = ((1 + i) | 0);
  }
  if ((elem !== 0)) {
    $n(result).set(srcLen, elem);
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftRight__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(source, count) {
  var intCount = ((count >>> 5) | 0);
  var andCount = (31 & count);
  if ((intCount >= $n(source).Ljava_math_BigInteger__f_numberLength)) {
    return (($n(source).Ljava_math_BigInteger__f_sign < 0) ? $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_MINUS_ONE : $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO);
  } else {
    var resLength = (($n(source).Ljava_math_BigInteger__f_numberLength - intCount) | 0);
    var resDigits = new $ac_I(((1 + resLength) | 0));
    this.shiftRight__AI__I__AI__I__I__Z(resDigits, resLength, $n(source).Ljava_math_BigInteger__f_digits, intCount, andCount);
    if (($n(source).Ljava_math_BigInteger__f_sign < 0)) {
      var i = 0;
      while (((i < intCount) && ($n($n(source).Ljava_math_BigInteger__f_digits).get(i) === 0))) {
        i = ((1 + i) | 0);
      }
      var cmp = (($n($n(source).Ljava_math_BigInteger__f_digits).get(i) << ((32 - andCount) | 0)) !== 0);
      if (((i < intCount) || ((andCount > 0) && cmp))) {
        i = 0;
        while (((i < resLength) && ($n(resDigits).get(i) === (-1)))) {
          $n(resDigits).set(i, 0);
          i = ((1 + i) | 0);
        }
        if ((i === resLength)) {
          resLength = ((1 + resLength) | 0);
        }
        var ev$1 = i;
        $n(resDigits).set(ev$1, ((1 + $n(resDigits).get(ev$1)) | 0));
      }
    }
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), $n(source).Ljava_math_BigInteger__f_sign, resLength, resDigits);
    result.cutOffLeadingZeroes__V();
    return result;
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftRight__AI__I__AI__I__I__Z = (function(result, resultLen, source, intCount, count) {
  var i = 0;
  var allZero = true;
  while ((i < intCount)) {
    allZero = (!(!(allZero & ($n(source).get(i) === 0))));
    i = ((1 + i) | 0);
  }
  if ((count === 0)) {
    $systemArraycopy($n(source), intCount, $n(result), 0, resultLen);
  } else {
    var leftShiftCount = ((32 - count) | 0);
    allZero = (!(!(allZero & (($n(source).get(i) << leftShiftCount) === 0))));
    i = 0;
    while ((i < (((-1) + resultLen) | 0))) {
      $n(result).set(i, ((($n(source).get(((i + intCount) | 0)) >>> count) | 0) | ($n(source).get(((1 + ((i + intCount) | 0)) | 0)) << leftShiftCount)));
      i = ((1 + i) | 0);
    }
    $n(result).set(i, (($n(source).get(((i + intCount) | 0)) >>> count) | 0));
    i = ((1 + i) | 0);
  }
  return allZero;
});
var $d_Ljava_math_BitLevel$ = new $TypeData().initClass($c_Ljava_math_BitLevel$, "java.math.BitLevel$", ({
  Ljava_math_BitLevel$: 1
}));
var $n_Ljava_math_BitLevel$;
function $m_Ljava_math_BitLevel$() {
  if ((!$n_Ljava_math_BitLevel$)) {
    $n_Ljava_math_BitLevel$ = new $c_Ljava_math_BitLevel$();
  }
  return $n_Ljava_math_BitLevel$;
}
function $p_Ljava_math_Conversion$__dropLeadingZeros__T__T($thiz, s) {
  var zeroPrefixLength = 0;
  var this$1 = $n(s);
  var len = this$1.length;
  while (true) {
    if ((zeroPrefixLength < len)) {
      var this$2 = $n(s);
      var index = zeroPrefixLength;
      var $x_1 = ($charAt(this$2, index) === 48);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      zeroPrefixLength = ((1 + zeroPrefixLength) | 0);
    } else {
      break;
    }
  }
  var this$3 = $n(s);
  var beginIndex = zeroPrefixLength;
  if (((beginIndex < 0) || (beginIndex > this$3.length))) {
    $charAt(this$3, beginIndex);
  }
  return $as_T(this$3.substring(beginIndex));
}
/** @constructor */
function $c_Ljava_math_Conversion$() {
  this.Ljava_math_Conversion$__f_DigitFitInInt = null;
  this.Ljava_math_Conversion$__f_BigRadices = null;
  $n_Ljava_math_Conversion$ = this;
  this.Ljava_math_Conversion$__f_DigitFitInInt = new $ac_I(new Int32Array([(-1), (-1), 31, 19, 15, 13, 11, 11, 10, 9, 9, 8, 8, 8, 8, 7, 7, 7, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 5]));
  this.Ljava_math_Conversion$__f_BigRadices = new $ac_I(new Int32Array([(-2147483648), 1162261467, 1073741824, 1220703125, 362797056, 1977326743, 1073741824, 387420489, 1000000000, 214358881, 429981696, 815730721, 1475789056, 170859375, 268435456, 410338673, 612220032, 893871739, 1280000000, 1801088541, 113379904, 148035889, 191102976, 244140625, 308915776, 387420489, 481890304, 594823321, 729000000, 887503681, 1073741824, 1291467969, 1544804416, 1838265625, 60466176]));
}
$c_Ljava_math_Conversion$.prototype = new $h_O();
$c_Ljava_math_Conversion$.prototype.constructor = $c_Ljava_math_Conversion$;
/** @constructor */
function $h_Ljava_math_Conversion$() {
}
$h_Ljava_math_Conversion$.prototype = $c_Ljava_math_Conversion$.prototype;
$c_Ljava_math_Conversion$.prototype.bigInteger2String__Ljava_math_BigInteger__I__T = (function(bi, radix) {
  var sign = $n(bi).Ljava_math_BigInteger__f_sign;
  var numberLength = $n(bi).Ljava_math_BigInteger__f_numberLength;
  var digits = $n(bi).Ljava_math_BigInteger__f_digits;
  var radixOutOfBounds = ((radix < 2) || (radix > 36));
  if ((sign === 0)) {
    return "0";
  } else if ((numberLength === 1)) {
    var highDigit = $n(digits).get((((-1) + numberLength) | 0));
    var v__lo = highDigit;
    var v__hi = 0;
    if ((sign < 0)) {
      var this$2__lo = v__lo;
      var this$2__hi = v__hi;
      var lo = this$2__lo;
      var hi$1 = this$2__hi;
      var lo$1 = ((-lo) | 0);
      var hi$2 = ((lo !== 0) ? (~hi$1) : ((-hi$1) | 0));
      var $x_1__lo = lo$1;
      var $x_1__hi = hi$2;
      v__lo = $x_1__lo;
      v__hi = $x_1__hi;
    }
    var this$5 = $m_jl_Long$();
    var i__lo = v__lo;
    var i__hi = v__hi;
    return ((((radix === 10) || (radix < 2)) || (radix > 36)) ? $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(i__lo, i__hi) : this$5.java$lang$Long$$toStringImpl__J__I__T(new $c_RTLong(i__lo, i__hi), radix));
  } else if (((radix === 10) || radixOutOfBounds)) {
    var this$6 = $n(bi);
    return $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$6);
  } else {
    var bitsForRadixDigit = 0.0;
    var a = radix;
    bitsForRadixDigit = ($uD(Math.log(a)) / $uD(Math.log(2.0)));
    var addForSign = ((sign < 0) ? 1 : 0);
    var this$9 = $n($n(bi).abs__Ljava_math_BigInteger());
    var biAbsLen = $m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$9);
    var resLenInChars = ((1 + $doubleToInt(((biAbsLen / bitsForRadixDigit) + addForSign))) | 0);
    var elem = null;
    elem = "";
    var elem$1 = 0;
    elem$1 = resLenInChars;
    var elem$2 = 0;
    elem$2 = 0;
    if ((radix !== 16)) {
      var temp = new $ac_I(numberLength);
      $systemArraycopy($n(digits), 0, temp, 0, numberLength);
      var elem$3 = 0;
      elem$3 = numberLength;
      var charsPerInt = $n(this.Ljava_math_Conversion$__f_DigitFitInInt).get(radix);
      var bigRadix = $n(this.Ljava_math_Conversion$__f_BigRadices).get((((-2) + radix) | 0));
      while (true) {
        elem$2 = $m_Ljava_math_Division$().divideArrayByInt__AI__AI__I__I__I(temp, temp, elem$3, bigRadix);
        var previous = elem$1;
        while (true) {
          elem$1 = (((-1) + elem$1) | 0);
          var this$14 = $m_jl_Character$().forDigit__I__I__C($intMod(elem$2, radix), radix);
          elem = (("" + $cToS(this$14)) + $as_T(elem));
          elem$2 = $intDiv(elem$2, radix);
          if (((elem$2 !== 0) && (elem$1 !== 0))) {
            continue;
          }
          break;
        }
        var delta = ((((charsPerInt - previous) | 0) + elem$1) | 0);
        var i$1 = 0;
        while (((i$1 < delta) && (elem$1 > 0))) {
          elem$1 = (((-1) + elem$1) | 0);
          elem = ("0" + $as_T(elem));
          i$1 = ((1 + i$1) | 0);
        }
        i$1 = (((-1) + elem$3) | 0);
        while (((i$1 > 0) && ($n(temp).get(i$1) === 0))) {
          i$1 = (((-1) + i$1) | 0);
        }
        elem$3 = ((1 + i$1) | 0);
        if ((!((elem$3 === 1) && ($n(temp).get(0) === 0)))) {
          continue;
        }
        break;
      }
    } else {
      var i$2 = 0;
      while ((i$2 < numberLength)) {
        var i$2$1 = i$2;
        var j = 0;
        while (((j < 8) && (elem$1 > 0))) {
          elem$2 = (15 & ($n(digits).get(i$2$1) >> (j << 2)));
          elem$1 = (((-1) + elem$1) | 0);
          var i$3 = elem$2;
          elem = (("" + $as_T($uD((i$3 >>> 0.0)).toString(16))) + $as_T(elem));
          j = ((1 + j) | 0);
        }
        i$2 = ((1 + i$2) | 0);
      }
    }
    var dropLen = 0;
    while (true) {
      var this$19 = $n($as_T(elem));
      var index = dropLen;
      if (($charAt(this$19, index) === 48)) {
        dropLen = ((1 + dropLen) | 0);
      } else {
        break;
      }
    }
    if ((dropLen !== 0)) {
      var this$20 = $n($as_T(elem));
      var beginIndex = dropLen;
      if (((beginIndex < 0) || (beginIndex > this$20.length))) {
        $charAt(this$20, beginIndex);
      }
      elem = $as_T(this$20.substring(beginIndex));
    }
    return ((sign === (-1)) ? ("-" + $as_T(elem)) : $as_T(elem));
  }
});
$c_Ljava_math_Conversion$.prototype.toDecimalScaledString__Ljava_math_BigInteger__T = (function(bi) {
  var sign = $n(bi).Ljava_math_BigInteger__f_sign;
  var numberLength = $n(bi).Ljava_math_BigInteger__f_numberLength;
  var digits = $n(bi).Ljava_math_BigInteger__f_digits;
  if ((sign === 0)) {
    return "0";
  } else if ((numberLength === 1)) {
    var i = $n(digits).get(0);
    var absStr = $as_T($uD((i >>> 0.0)).toString(10));
    return ((sign < 0) ? ("-" + absStr) : absStr);
  } else {
    var result = "";
    var temp = new $ac_I(numberLength);
    var tempLen = numberLength;
    var x4 = tempLen;
    $systemArraycopy($n(digits), 0, temp, 0, x4);
    while (true) {
      var rem = 0;
      var i$1 = (((-1) + tempLen) | 0);
      while ((i$1 >= 0)) {
        var value = rem;
        var value$1 = $n(temp).get(i$1);
        var this$5 = $m_RTLong$();
        var lo = this$5.divideUnsignedImpl__I__I__I__I__I(value$1, value, 1000000000, 0);
        $n(temp).set(i$1, lo);
        var hi$3 = (lo >> 31);
        var b0 = (65535 & lo);
        var b1 = ((lo >>> 16) | 0);
        var a0b0 = Math.imul(51712, b0);
        var a1b0 = Math.imul(15258, b0);
        var a0b1 = Math.imul(51712, b1);
        var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$4 = ((((((Math.imul(1000000000, hi$3) + Math.imul(15258, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$2 = ((value$1 - lo$1) | 0);
        rem = lo$2;
        i$1 = (((-1) + i$1) | 0);
      }
      var this$8 = rem;
      var remStr = ("" + this$8);
      var beginIndex = remStr.length;
      if (((beginIndex < 0) || (beginIndex > 9))) {
        $charAt("000000000", beginIndex);
      }
      var padding = $as_T("000000000".substring(beginIndex));
      result = ((padding + remStr) + result);
      while (((tempLen !== 0) && ($n(temp).get((((-1) + tempLen) | 0)) === 0))) {
        tempLen = (((-1) + tempLen) | 0);
      }
      if ((tempLen !== 0)) {
      } else {
        break;
      }
    }
    result = $p_Ljava_math_Conversion$__dropLeadingZeros__T__T(this, result);
    return ((sign < 0) ? ("-" + result) : result);
  }
});
$c_Ljava_math_Conversion$.prototype.toDecimalScaledString__J__I__T = (function(value, scale) {
  if (((value.RTLong__f_lo === 0) && (value.RTLong__f_hi === 0))) {
    switch (scale) {
      case 0: {
        return "0";
        break;
      }
      case 1: {
        return "0.0";
        break;
      }
      case 2: {
        return "0.00";
        break;
      }
      case 3: {
        return "0.000";
        break;
      }
      case 4: {
        return "0.0000";
        break;
      }
      case 5: {
        return "0.00000";
        break;
      }
      case 6: {
        return "0.000000";
        break;
      }
      default: {
        if ((scale === (-2147483648))) {
          var scaleVal = "2147483648";
        } else {
          var i = ((-scale) | 0);
          var scaleVal = ("" + i);
        }
        var result = ((scale < 0) ? "0E+" : "0E");
        return (result + scaleVal);
      }
    }
  } else {
    var ahi = value.RTLong__f_hi;
    var negNumber = (ahi < 0);
    var elem = null;
    elem = "";
    var currentChar = 18;
    if (negNumber) {
      var lo = value.RTLong__f_lo;
      var hi = value.RTLong__f_hi;
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
      var x__lo = lo$1;
      var x__hi = hi$1;
      var t = new $c_RTLong(x__lo, x__hi);
    } else {
      var t = value;
    }
    var lo$2 = t.RTLong__f_lo;
    var hi$2 = t.RTLong__f_hi;
    var v__lo = lo$2;
    var v__hi = hi$2;
    while (true) {
      var prev__lo = v__lo;
      var prev__hi = v__hi;
      var this$5__lo = v__lo;
      var this$5__hi = v__hi;
      var this$6 = $m_RTLong$();
      var lo$3 = this$6.divideImpl__I__I__I__I__I(this$5__lo, this$5__hi, 10, 0);
      var hi$3 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var $x_1__lo = lo$3;
      var $x_1__hi = hi$3;
      v__lo = $x_1__lo;
      v__hi = $x_1__hi;
      currentChar = (((-1) + currentChar) | 0);
      var b__lo = v__lo;
      var b__hi = v__hi;
      var blo = b__lo;
      var b0 = (65535 & blo);
      var b1 = ((blo >>> 16) | 0);
      var a0b0 = Math.imul(10, b0);
      var a0b1 = Math.imul(10, b1);
      var lo$4 = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$4 = ((Math.imul(10, b__hi) + ((c1part >>> 16) | 0)) | 0);
      var alo = prev__lo;
      var ahi$1 = prev__hi;
      var lo$5 = ((alo - lo$4) | 0);
      elem = (("" + lo$5) + $as_T(elem));
      var this$9__lo = v__lo;
      var this$9__hi = v__hi;
      if ((!((this$9__lo === 0) && (this$9__hi === 0)))) {
      } else {
        break;
      }
    }
    var value$1 = ((18 - currentChar) | 0);
    var hi$6 = (value$1 >> 31);
    var hi$7 = (scale >> 31);
    var lo$6 = ((value$1 - scale) | 0);
    var hi$8 = ((((-2147483648) ^ lo$6) > ((-2147483648) ^ value$1)) ? (((-1) + ((hi$6 - hi$7) | 0)) | 0) : ((hi$6 - hi$7) | 0));
    var lo$7 = (((-1) + lo$6) | 0);
    var hi$9 = ((lo$7 !== (-1)) ? hi$8 : (((-1) + hi$8) | 0));
    if (((scale > 0) && ((hi$9 === (-1)) ? (((-2147483648) ^ lo$7) >= 2147483642) : (hi$9 > (-1))))) {
      var index = ((1 + lo$7) | 0);
      if ((index > 0)) {
        var this$14 = $n($as_T(elem));
        if ((index > this$14.length)) {
          $charAt(this$14, index);
        }
        if ((index < 0)) {
          $charAt(this$14, (-1));
        }
        var $x_2 = $as_T(this$14.substring(0, index));
        var this$15 = $n($as_T(elem));
        if (((index < 0) || (index > this$15.length))) {
          $charAt(this$15, index);
        }
        elem = (($x_2 + ".") + $as_T(this$15.substring(index)));
      } else {
        var end = ((-index) | 0);
        var i$1 = 0;
        while ((i$1 < end)) {
          elem = ("0" + $as_T(elem));
          i$1 = ((1 + i$1) | 0);
        }
        elem = ("0." + $as_T(elem));
      }
    } else if ((scale !== 0)) {
      var exponentStr = (((hi$9 === 0) ? (lo$7 !== 0) : (hi$9 > 0)) ? ("E+" + new $c_RTLong(lo$7, hi$9)) : ("E" + new $c_RTLong(lo$7, hi$9)));
      if ((((18 - currentChar) | 0) > 1)) {
        var this$18 = $n($as_T(elem));
        if ((this$18.length < 1)) {
          $charAt(this$18, 1);
        }
        var $x_3 = $as_T(this$18.substring(0, 1));
        var this$19 = $n($as_T(elem));
        if ((this$19.length < 1)) {
          $charAt(this$19, 1);
        }
        elem = ((($x_3 + ".") + $as_T(this$19.substring(1))) + exponentStr);
      } else {
        elem = ($as_T(elem) + exponentStr);
      }
    }
    return (negNumber ? ("-" + $as_T(elem)) : $as_T(elem));
  }
});
var $d_Ljava_math_Conversion$ = new $TypeData().initClass($c_Ljava_math_Conversion$, "java.math.Conversion$", ({
  Ljava_math_Conversion$: 1
}));
var $n_Ljava_math_Conversion$;
function $m_Ljava_math_Conversion$() {
  if ((!$n_Ljava_math_Conversion$)) {
    $n_Ljava_math_Conversion$ = new $c_Ljava_math_Conversion$();
  }
  return $n_Ljava_math_Conversion$;
}
/** @constructor */
function $c_Ljava_math_Division$() {
}
$c_Ljava_math_Division$.prototype = new $h_O();
$c_Ljava_math_Division$.prototype.constructor = $c_Ljava_math_Division$;
/** @constructor */
function $h_Ljava_math_Division$() {
}
$h_Ljava_math_Division$.prototype = $c_Ljava_math_Division$.prototype;
$c_Ljava_math_Division$.prototype.divide__AI__I__AI__I__AI__I__AI = (function(quot, quotLength, a, aLength, b, bLength) {
  var normA = new $ac_I(((1 + aLength) | 0));
  var normB = new $ac_I(((1 + bLength) | 0));
  var i = $n(b).get((((-1) + bLength) | 0));
  var divisorShift = $uI(Math.clz32(i));
  if ((divisorShift !== 0)) {
    $m_Ljava_math_BitLevel$().shiftLeft__AI__AI__I__I__V(normB, b, 0, divisorShift);
    $m_Ljava_math_BitLevel$().shiftLeft__AI__AI__I__I__V(normA, a, 0, divisorShift);
  } else {
    $systemArraycopy($n(a), 0, normA, 0, aLength);
    $systemArraycopy($n(b), 0, normB, 0, bLength);
  }
  var firstDivisorDigit = $n(normB).get((((-1) + bLength) | 0));
  var i$1 = (((-1) + quotLength) | 0);
  var elem = 0;
  elem = aLength;
  while ((i$1 >= 0)) {
    var elem$1 = 0;
    elem$1 = 0;
    if (($n(normA).get(elem) === firstDivisorDigit)) {
      elem$1 = (-1);
    } else {
      var value = $n(normA).get(elem);
      var value$1 = $n(normA).get((((-1) + elem) | 0));
      var this$8 = $m_RTLong$();
      var lo = this$8.divideUnsignedImpl__I__I__I__I__I(value$1, value, firstDivisorDigit, 0);
      var hi$3 = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      elem$1 = lo;
      var a0 = (65535 & lo);
      var a1 = ((lo >>> 16) | 0);
      var b0 = (65535 & firstDivisorDigit);
      var b1 = ((firstDivisorDigit >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$4 = ((((((Math.imul(hi$3, firstDivisorDigit) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var lo$2 = ((value$1 - lo$1) | 0);
      var elem$2 = 0;
      elem$2 = lo$2;
      if ((elem$1 !== 0)) {
        elem$1 = ((1 + elem$1) | 0);
        while (true) {
          elem$1 = (((-1) + elem$1) | 0);
          var value$2 = elem$1;
          var value$3 = $n(normB).get((((-2) + bLength) | 0));
          var a0$1 = (65535 & value$2);
          var a1$1 = ((value$2 >>> 16) | 0);
          var b0$1 = (65535 & value$3);
          var b1$1 = ((value$3 >>> 16) | 0);
          var a0b0$1 = Math.imul(a0$1, b0$1);
          var a1b0$1 = Math.imul(a1$1, b0$1);
          var a0b1$1 = Math.imul(a0$1, b1$1);
          var lo$3 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
          var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
          var hi$8 = ((((Math.imul(a1$1, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
          var value$4 = elem$2;
          var value$5 = $n(normA).get((((-2) + elem) | 0));
          var value$6 = elem$2;
          var lo$4 = ((value$6 + firstDivisorDigit) | 0);
          var hi$13 = ((((-2147483648) ^ lo$4) < ((-2147483648) ^ value$6)) ? 1 : 0);
          if ((hi$13 === 0)) {
            elem$2 = lo$4;
            var hi$14 = ((-2147483648) ^ hi$8);
            var hi$15 = ((-2147483648) ^ value$4);
            if (((hi$14 === hi$15) ? (((-2147483648) ^ lo$3) > ((-2147483648) ^ value$5)) : (hi$14 > hi$15))) {
              continue;
            }
          }
          break;
        }
      }
    }
    if ((elem$1 !== 0)) {
      var borrow = $m_Ljava_math_Division$().multiplyAndSubtract__AI__I__AI__I__I__I(normA, ((elem - bLength) | 0), normB, bLength, elem$1);
      if ((borrow !== 0)) {
        elem$1 = (((-1) + elem$1) | 0);
        var elem$3__lo = 0;
        var elem$3__hi = 0;
        var $x_1__lo = 0;
        var $x_1__hi = 0;
        elem$3__lo = $x_1__lo;
        elem$3__hi = $x_1__hi;
        var i$2 = 0;
        while ((i$2 < bLength)) {
          var k$2 = i$2;
          var this$25__lo = elem$3__lo;
          var this$25__hi = elem$3__hi;
          var value$7 = $n(normA).get(((((elem - bLength) | 0) + k$2) | 0));
          var value$8 = $n(normB).get(k$2);
          var lo$5 = ((value$7 + value$8) | 0);
          var hi$18 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ value$7)) ? 1 : 0);
          var alo = this$25__lo;
          var ahi = this$25__hi;
          var lo$6 = ((alo + lo$5) | 0);
          var hi$19 = ((((-2147483648) ^ lo$6) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + hi$18) | 0)) | 0) : ((ahi + hi$18) | 0));
          var $x_2__lo = lo$6;
          var $x_2__hi = hi$19;
          elem$3__lo = $x_2__lo;
          elem$3__hi = $x_2__hi;
          var $x_4 = $n(normA);
          var $x_3 = elem;
          var this$27__lo = elem$3__lo;
          var this$27__hi = elem$3__hi;
          $x_4.set((((($x_3 - bLength) | 0) + k$2) | 0), this$27__lo);
          var this$28__lo = elem$3__lo;
          var this$28__hi = elem$3__hi;
          var hi$20 = this$28__hi;
          var $x_5__lo = hi$20;
          var $x_5__hi = 0;
          elem$3__lo = $x_5__lo;
          elem$3__hi = $x_5__hi;
          i$2 = ((1 + i$2) | 0);
        }
      }
    }
    if ((quot !== null)) {
      $n(quot).set(i$1, elem$1);
    }
    elem = (((-1) + elem) | 0);
    i$1 = (((-1) + i$1) | 0);
  }
  if ((divisorShift !== 0)) {
    $m_Ljava_math_BitLevel$().shiftRight__AI__I__AI__I__I__Z(normB, bLength, normA, 0, divisorShift);
    return normB;
  } else {
    $systemArraycopy(normA, 0, normB, 0, bLength);
    return normA;
  }
});
$c_Ljava_math_Division$.prototype.divideAndRemainderByInteger__Ljava_math_BigInteger__I__I__Ljava_math_BigInteger$QuotAndRem = (function(bi, divisor, divisorSign) {
  var valDigits = $n(bi).Ljava_math_BigInteger__f_digits;
  var valLen = $n(bi).Ljava_math_BigInteger__f_numberLength;
  var valSign = $n(bi).Ljava_math_BigInteger__f_sign;
  if ((valLen === 1)) {
    var valDigit = $n(valDigits).get(0);
    if ((divisor === 0)) {
      var value = $intDiv(0, 0);
    } else {
      var n = ($uD((valDigit >>> 0.0)) / $uD((divisor >>> 0.0)));
      var value = $uI((n | 0.0));
    }
    var quo__lo = value;
    var quo__hi = 0;
    if ((divisor === 0)) {
      var value$1 = $intMod(0, 0);
    } else {
      var n$1 = ($uD((valDigit >>> 0.0)) % $uD((divisor >>> 0.0)));
      var value$1 = $uI((n$1 | 0.0));
    }
    var rem__lo = value$1;
    var rem__hi = 0;
    if ((valSign !== divisorSign)) {
      var this$5__lo = quo__lo;
      var this$5__hi = quo__hi;
      var lo = this$5__lo;
      var hi$2 = this$5__hi;
      var lo$1 = ((-lo) | 0);
      var hi$3 = ((lo !== 0) ? (~hi$2) : ((-hi$2) | 0));
      var $x_1__lo = lo$1;
      var $x_1__hi = hi$3;
      quo__lo = $x_1__lo;
      quo__hi = $x_1__hi;
    }
    if ((valSign < 0)) {
      var this$8__lo = rem__lo;
      var this$8__hi = rem__hi;
      var lo$2 = this$8__lo;
      var hi$4 = this$8__hi;
      var lo$3 = ((-lo$2) | 0);
      var hi$5 = ((lo$2 !== 0) ? (~hi$4) : ((-hi$4) | 0));
      var $x_2__lo = lo$3;
      var $x_2__hi = hi$5;
      rem__lo = $x_2__lo;
      rem__hi = $x_2__hi;
    }
    return new $c_Ljava_math_BigInteger$QuotAndRem($m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(quo__lo, quo__hi)), $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(rem__lo, rem__hi)));
  } else {
    var quotientSign = ((valSign === divisorSign) ? 1 : (-1));
    var quotientDigits = new $ac_I(valLen);
    var div = this.divideArrayByInt__AI__AI__I__I__I(quotientDigits, valDigits, valLen, divisor);
    var remainderDigits = new $ac_I(new Int32Array([div]));
    var result0 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), quotientSign, valLen, quotientDigits);
    var result1 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), valSign, 1, remainderDigits);
    result0.cutOffLeadingZeroes__V();
    result1.cutOffLeadingZeroes__V();
    return new $c_Ljava_math_BigInteger$QuotAndRem(result0, result1);
  }
});
$c_Ljava_math_Division$.prototype.divideArrayByInt__AI__AI__I__I__I = (function(dest, src, srcLength, divisor) {
  var rem = 0;
  var i = (((-1) + srcLength) | 0);
  while ((i >= 0)) {
    var value = rem;
    var value$1 = $n(src).get(i);
    var this$4 = $m_RTLong$();
    var lo = this$4.divideUnsignedImpl__I__I__I__I__I(value$1, value, divisor, 0);
    var hi$3 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var a0 = (65535 & lo);
    var a1 = ((lo >>> 16) | 0);
    var b0 = (65535 & divisor);
    var b1 = ((divisor >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$4 = ((((((Math.imul(hi$3, divisor) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$2 = ((value$1 - lo$1) | 0);
    rem = lo$2;
    $n(dest).set(i, lo);
    i = (((-1) + i) | 0);
  }
  return rem;
});
$c_Ljava_math_Division$.prototype.multiplyAndSubtract__AI__I__AI__I__I__I = (function(a, start, b, bLen, c) {
  var elem = 0;
  elem = 0;
  var elem$1 = 0;
  elem$1 = 0;
  var i = 0;
  while ((i < bLen)) {
    var i$2 = i;
    $m_Ljava_math_Multiplication$();
    var a$1 = $n(b).get(i$2);
    var c$1 = elem;
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & c);
    var b1 = ((c >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$1 = ((lo + c$1) | 0);
    var hi$4 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + hi$2) | 0) : hi$2);
    var value = $n(a).get(((start + i$2) | 0));
    var lo$2 = ((value - lo$1) | 0);
    var hi$6 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ value)) ? (-1) : 0);
    var value$1 = elem$1;
    var hi$7 = (value$1 >> 31);
    var lo$3 = ((lo$2 + value$1) | 0);
    var hi$8 = ((((-2147483648) ^ lo$3) < ((-2147483648) ^ lo$2)) ? ((1 + ((hi$6 + hi$7) | 0)) | 0) : ((hi$6 + hi$7) | 0));
    $n(a).set(((start + i$2) | 0), lo$3);
    elem$1 = hi$8;
    elem = hi$4;
    i = ((1 + i) | 0);
  }
  var value$2 = $n(a).get(((start + bLen) | 0));
  var value$3 = elem;
  var lo$4 = ((value$2 - value$3) | 0);
  var hi$13 = ((((-2147483648) ^ lo$4) > ((-2147483648) ^ value$2)) ? (-1) : 0);
  var value$4 = elem$1;
  var hi$14 = (value$4 >> 31);
  var lo$5 = ((lo$4 + value$4) | 0);
  var hi$15 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$4)) ? ((1 + ((hi$13 + hi$14) | 0)) | 0) : ((hi$13 + hi$14) | 0));
  $n(a).set(((start + bLen) | 0), lo$5);
  return hi$15;
});
var $d_Ljava_math_Division$ = new $TypeData().initClass($c_Ljava_math_Division$, "java.math.Division$", ({
  Ljava_math_Division$: 1
}));
var $n_Ljava_math_Division$;
function $m_Ljava_math_Division$() {
  if ((!$n_Ljava_math_Division$)) {
    $n_Ljava_math_Division$ = new $c_Ljava_math_Division$();
  }
  return $n_Ljava_math_Division$;
}
function $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI($thiz, a, aSize, b, bSize) {
  var res = new $ac_I(((1 + aSize) | 0));
  $p_Ljava_math_Elementary$__add__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize);
  return res;
}
function $p_Ljava_math_Elementary$__add__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize) {
  var i = 1;
  var value = $n(a).get(0);
  var value$1 = $n(b).get(0);
  var lo = ((value + value$1) | 0);
  var hi$2 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value)) ? 1 : 0);
  $n(res).set(0, lo);
  var carry = hi$2;
  if ((aSize >= bSize)) {
    while ((i < bSize)) {
      var value$2 = $n(a).get(i);
      var value$3 = $n(b).get(i);
      var lo$1 = ((value$2 + value$3) | 0);
      var hi$6 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ value$2)) ? 1 : 0);
      var value$4 = carry;
      var lo$2 = ((lo$1 + value$4) | 0);
      var hi$8 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + hi$6) | 0) : hi$6);
      $n(res).set(i, lo$2);
      carry = hi$8;
      i = ((1 + i) | 0);
    }
    while ((i < aSize)) {
      var value$5 = $n(a).get(i);
      var value$6 = carry;
      var lo$3 = ((value$5 + value$6) | 0);
      var hi$12 = ((((-2147483648) ^ lo$3) < ((-2147483648) ^ value$5)) ? 1 : 0);
      $n(res).set(i, lo$3);
      carry = hi$12;
      i = ((1 + i) | 0);
    }
  } else {
    while ((i < aSize)) {
      var value$7 = $n(a).get(i);
      var value$8 = $n(b).get(i);
      var lo$4 = ((value$7 + value$8) | 0);
      var hi$16 = ((((-2147483648) ^ lo$4) < ((-2147483648) ^ value$7)) ? 1 : 0);
      var value$9 = carry;
      var lo$5 = ((lo$4 + value$9) | 0);
      var hi$18 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$4)) ? ((1 + hi$16) | 0) : hi$16);
      $n(res).set(i, lo$5);
      carry = hi$18;
      i = ((1 + i) | 0);
    }
    while ((i < bSize)) {
      var value$10 = $n(b).get(i);
      var value$11 = carry;
      var lo$6 = ((value$10 + value$11) | 0);
      var hi$22 = ((((-2147483648) ^ lo$6) < ((-2147483648) ^ value$10)) ? 1 : 0);
      $n(res).set(i, lo$6);
      carry = hi$22;
      i = ((1 + i) | 0);
    }
  }
  if ((carry !== 0)) {
    $n(res).set(i, carry);
  }
}
function $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI($thiz, a, aSize, b, bSize) {
  var res = new $ac_I(aSize);
  $p_Ljava_math_Elementary$__subtract__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize);
  return res;
}
function $p_Ljava_math_Elementary$__subtract__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize) {
  var i = 0;
  var borrow = 0;
  while ((i < bSize)) {
    var value = $n(a).get(i);
    var value$1 = $n(b).get(i);
    var lo = ((value - value$1) | 0);
    var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (-1) : 0);
    var value$2 = borrow;
    var hi$3 = (value$2 >> 31);
    var lo$1 = ((lo + value$2) | 0);
    var hi$4 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + ((hi$2 + hi$3) | 0)) | 0) : ((hi$2 + hi$3) | 0));
    $n(res).set(i, lo$1);
    borrow = hi$4;
    i = ((1 + i) | 0);
  }
  while ((i < aSize)) {
    var value$3 = $n(a).get(i);
    var value$4 = borrow;
    var hi$7 = (value$4 >> 31);
    var lo$2 = ((value$3 + value$4) | 0);
    var hi$8 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ value$3)) ? ((1 + hi$7) | 0) : hi$7);
    $n(res).set(i, lo$2);
    borrow = hi$8;
    i = ((1 + i) | 0);
  }
}
/** @constructor */
function $c_Ljava_math_Elementary$() {
}
$c_Ljava_math_Elementary$.prototype = new $h_O();
$c_Ljava_math_Elementary$.prototype.constructor = $c_Ljava_math_Elementary$;
/** @constructor */
function $h_Ljava_math_Elementary$() {
}
$h_Ljava_math_Elementary$.prototype = $c_Ljava_math_Elementary$.prototype;
$c_Ljava_math_Elementary$.prototype.add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(op1, op2) {
  var op1Sign = $n(op1).Ljava_math_BigInteger__f_sign;
  var op2Sign = $n(op2).Ljava_math_BigInteger__f_sign;
  var op1Len = $n(op1).Ljava_math_BigInteger__f_numberLength;
  var op2Len = $n(op2).Ljava_math_BigInteger__f_numberLength;
  if ((op1Sign === 0)) {
    return op2;
  } else if ((op2Sign === 0)) {
    return op1;
  } else if ((((op1Len + op2Len) | 0) === 2)) {
    var value = $n($n(op1).Ljava_math_BigInteger__f_digits).get(0);
    var value$1 = $n($n(op2).Ljava_math_BigInteger__f_digits).get(0);
    if ((op1Sign === op2Sign)) {
      var lo = ((value + value$1) | 0);
      var hi$2 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value)) ? 1 : 0);
      return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), op1Sign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), op1Sign, 2, new $ac_I(new Int32Array([lo, hi$2]))));
    } else {
      var $x_1 = $m_Ljava_math_BigInteger$();
      if ((op1Sign < 0)) {
        var lo$1 = ((value$1 - value) | 0);
        var hi$3 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ value$1)) ? (-1) : 0);
        var x__lo = lo$1;
        var x__hi = hi$3;
      } else {
        var lo$2 = ((value - value$1) | 0);
        var hi$4 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ value)) ? (-1) : 0);
        var x__lo = lo$2;
        var x__hi = hi$4;
      }
      return $n($x_1).valueOf__J__Ljava_math_BigInteger(new $c_RTLong(x__lo, x__hi));
    }
  } else {
    if ((op1Sign === op2Sign)) {
      var res$2 = ((op1Len >= op2Len) ? $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, $n(op1).Ljava_math_BigInteger__f_digits, op1Len, $n(op2).Ljava_math_BigInteger__f_digits, op2Len) : $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, $n(op2).Ljava_math_BigInteger__f_digits, op2Len, $n(op1).Ljava_math_BigInteger__f_digits, op1Len));
      var x1___1 = op1Sign;
      var x1___2 = res$2;
    } else {
      var cmp = ((op1Len !== op2Len) ? ((op1Len > op2Len) ? 1 : (-1)) : this.compareArrays__AI__AI__I__I($n(op1).Ljava_math_BigInteger__f_digits, $n(op2).Ljava_math_BigInteger__f_digits, op1Len));
      if ((cmp === 0)) {
        return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
      }
      if ((cmp === 1)) {
        var _2 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, $n(op1).Ljava_math_BigInteger__f_digits, op1Len, $n(op2).Ljava_math_BigInteger__f_digits, op2Len);
        var x1___1 = op1Sign;
        var x1___2 = _2;
      } else {
        var _2$1 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, $n(op2).Ljava_math_BigInteger__f_digits, op2Len, $n(op1).Ljava_math_BigInteger__f_digits, op1Len);
        var x1___1 = op2Sign;
        var x1___2 = _2$1;
      }
    }
    var resSign = $uI(x1___1);
    var resDigits = $asArrayOf_I(x1___2, 1);
    var res$3 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, $n(resDigits).u.length, resDigits);
    res$3.cutOffLeadingZeroes__V();
    return res$3;
  }
});
$c_Ljava_math_Elementary$.prototype.compareArrays__AI__AI__I__I = (function(a, b, size) {
  var i = (((-1) + size) | 0);
  while (((i >= 0) && ($n(a).get(i) === $n(b).get(i)))) {
    i = (((-1) + i) | 0);
  }
  if ((i < 0)) {
    return 0;
  } else {
    var value = $n(a).get(i);
    var value$1 = $n(b).get(i);
    if ((((-2147483648) ^ value) < ((-2147483648) ^ value$1))) {
      return (-1);
    } else {
      return 1;
    }
  }
});
$c_Ljava_math_Elementary$.prototype.inplaceAdd__AI__I__I__I = (function(a, aSize, addend) {
  var carry = addend;
  var i = 0;
  while (((carry !== 0) && (i < aSize))) {
    var value = carry;
    var value$1 = $n(a).get(i);
    var lo = ((value + value$1) | 0);
    var hi$2 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value)) ? 1 : 0);
    $n(a).set(i, lo);
    carry = hi$2;
    i = ((1 + i) | 0);
  }
  return carry;
});
$c_Ljava_math_Elementary$.prototype.subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(op1, op2) {
  var op1Sign = $n(op1).Ljava_math_BigInteger__f_sign;
  var op2Sign = $n(op2).Ljava_math_BigInteger__f_sign;
  var op1Len = $n(op1).Ljava_math_BigInteger__f_numberLength;
  var op2Len = $n(op2).Ljava_math_BigInteger__f_numberLength;
  if ((op2Sign === 0)) {
    return op1;
  } else if ((op1Sign === 0)) {
    return $n(op2).negate__Ljava_math_BigInteger();
  } else if ((((op1Len + op2Len) | 0) === 2)) {
    var value = $n($n(op1).Ljava_math_BigInteger__f_digits).get(0);
    var a__lo = value;
    var a__hi = 0;
    var value$1 = $n($n(op2).Ljava_math_BigInteger__f_digits).get(0);
    var b__lo = value$1;
    var b__hi = 0;
    if ((op1Sign < 0)) {
      var this$3__lo = a__lo;
      var this$3__hi = a__hi;
      var lo = this$3__lo;
      var hi$2 = this$3__hi;
      var lo$1 = ((-lo) | 0);
      var hi$3 = ((lo !== 0) ? (~hi$2) : ((-hi$2) | 0));
      var $x_1__lo = lo$1;
      var $x_1__hi = hi$3;
      a__lo = $x_1__lo;
      a__hi = $x_1__hi;
    }
    if ((op2Sign < 0)) {
      var this$6__lo = b__lo;
      var this$6__hi = b__hi;
      var lo$2 = this$6__lo;
      var hi$4 = this$6__hi;
      var lo$3 = ((-lo$2) | 0);
      var hi$5 = ((lo$2 !== 0) ? (~hi$4) : ((-hi$4) | 0));
      var $x_2__lo = lo$3;
      var $x_2__hi = hi$5;
      b__lo = $x_2__lo;
      b__hi = $x_2__hi;
    }
    var $x_3 = $m_Ljava_math_BigInteger$();
    var this$9__lo = a__lo;
    var this$9__hi = a__hi;
    var b$1__lo = b__lo;
    var b$1__hi = b__hi;
    var alo = this$9__lo;
    var ahi = this$9__hi;
    var bhi = b$1__hi;
    var lo$4 = ((alo - b$1__lo) | 0);
    var hi$6 = ((((-2147483648) ^ lo$4) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - bhi) | 0)) | 0) : ((ahi - bhi) | 0));
    return $n($x_3).valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo$4, hi$6));
  } else {
    var cmp = ((op1Len !== op2Len) ? ((op1Len > op2Len) ? 1 : (-1)) : $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I($n(op1).Ljava_math_BigInteger__f_digits, $n(op2).Ljava_math_BigInteger__f_digits, op1Len));
    if (((op1Sign === op2Sign) && (cmp === 0))) {
      return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
    }
    if ((cmp === (-1))) {
      var res = ((op1Sign === op2Sign) ? $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, $n(op2).Ljava_math_BigInteger__f_digits, op2Len, $n(op1).Ljava_math_BigInteger__f_digits, op1Len) : $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, $n(op2).Ljava_math_BigInteger__f_digits, op2Len, $n(op1).Ljava_math_BigInteger__f_digits, op1Len));
      var _1 = ((-op2Sign) | 0);
      var x1___1 = _1;
      var x1___2 = res;
    } else if ((op1Sign === op2Sign)) {
      var _2 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, $n(op1).Ljava_math_BigInteger__f_digits, op1Len, $n(op2).Ljava_math_BigInteger__f_digits, op2Len);
      var x1___1 = op1Sign;
      var x1___2 = _2;
    } else {
      var _2$1 = $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, $n(op1).Ljava_math_BigInteger__f_digits, op1Len, $n(op2).Ljava_math_BigInteger__f_digits, op2Len);
      var x1___1 = op1Sign;
      var x1___2 = _2$1;
    }
    var resSign = $uI(x1___1);
    var resDigits = $asArrayOf_I(x1___2, 1);
    var res$2 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, $n(resDigits).u.length, resDigits);
    res$2.cutOffLeadingZeroes__V();
    return res$2;
  }
});
var $d_Ljava_math_Elementary$ = new $TypeData().initClass($c_Ljava_math_Elementary$, "java.math.Elementary$", ({
  Ljava_math_Elementary$: 1
}));
var $n_Ljava_math_Elementary$;
function $m_Ljava_math_Elementary$() {
  if ((!$n_Ljava_math_Elementary$)) {
    $n_Ljava_math_Elementary$ = new $c_Ljava_math_Elementary$();
  }
  return $n_Ljava_math_Elementary$;
}
/** @constructor */
function $c_Ljava_math_MathContext(setPrecision, setRoundingMode) {
  this.Ljava_math_MathContext__f_precision = 0;
  this.Ljava_math_MathContext__f_roundingMode = null;
  this.Ljava_math_MathContext__f_precision = setPrecision;
  this.Ljava_math_MathContext__f_roundingMode = setRoundingMode;
}
$c_Ljava_math_MathContext.prototype = new $h_O();
$c_Ljava_math_MathContext.prototype.constructor = $c_Ljava_math_MathContext;
/** @constructor */
function $h_Ljava_math_MathContext() {
}
$h_Ljava_math_MathContext.prototype = $c_Ljava_math_MathContext.prototype;
$c_Ljava_math_MathContext.prototype.equals__O__Z = (function(x) {
  if ((x instanceof $c_Ljava_math_MathContext)) {
    var x2 = $as_Ljava_math_MathContext(x);
    if ((this.Ljava_math_MathContext__f_precision === $n(x2).Ljava_math_MathContext__f_precision)) {
      var x$2 = this.Ljava_math_MathContext__f_roundingMode;
      var x$3 = $n(x2).Ljava_math_MathContext__f_roundingMode;
      if ((x$2 === null)) {
        return (x$3 === null);
      } else {
        var this$1 = $n(x$2);
        return (this$1 === x$3);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ljava_math_MathContext.prototype.hashCode__I = (function() {
  return ((this.Ljava_math_MathContext__f_precision << 3) | $n(this.Ljava_math_MathContext__f_roundingMode).jl_Enum__f__ordinal);
});
$c_Ljava_math_MathContext.prototype.toString__T = (function() {
  return ((("precision=" + this.Ljava_math_MathContext__f_precision) + " roundingMode=") + this.Ljava_math_MathContext__f_roundingMode);
});
function $as_Ljava_math_MathContext(obj) {
  return (((obj instanceof $c_Ljava_math_MathContext) || (obj === null)) ? obj : $throwClassCastException(obj, "java.math.MathContext"));
}
function $isArrayOf_Ljava_math_MathContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_math_MathContext)));
}
function $asArrayOf_Ljava_math_MathContext(obj, depth) {
  return (($isArrayOf_Ljava_math_MathContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.math.MathContext;", depth));
}
var $d_Ljava_math_MathContext = new $TypeData().initClass($c_Ljava_math_MathContext, "java.math.MathContext", ({
  Ljava_math_MathContext: 1
}));
/** @constructor */
function $c_Ljava_math_MathContext$() {
  this.Ljava_math_MathContext$__f_DECIMAL128 = null;
  $n_Ljava_math_MathContext$ = this;
  var roundingMode = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN;
  this.Ljava_math_MathContext$__f_DECIMAL128 = new $c_Ljava_math_MathContext(34, roundingMode);
  $m_Ljava_math_RoundingMode$();
  $m_Ljava_math_RoundingMode$();
  $m_Ljava_math_RoundingMode$();
}
$c_Ljava_math_MathContext$.prototype = new $h_O();
$c_Ljava_math_MathContext$.prototype.constructor = $c_Ljava_math_MathContext$;
/** @constructor */
function $h_Ljava_math_MathContext$() {
}
$h_Ljava_math_MathContext$.prototype = $c_Ljava_math_MathContext$.prototype;
var $d_Ljava_math_MathContext$ = new $TypeData().initClass($c_Ljava_math_MathContext$, "java.math.MathContext$", ({
  Ljava_math_MathContext$: 1
}));
var $n_Ljava_math_MathContext$;
function $m_Ljava_math_MathContext$() {
  if ((!$n_Ljava_math_MathContext$)) {
    $n_Ljava_math_MathContext$ = new $c_Ljava_math_MathContext$();
  }
  return $n_Ljava_math_MathContext$;
}
function $p_Ljava_math_Multiplication$__initialiseArrays__V($thiz) {
  var elem__lo = 0;
  var elem__hi = 0;
  var $x_1__lo = 1;
  var $x_1__hi = 0;
  elem__lo = $x_1__lo;
  elem__hi = $x_1__hi;
  var i = 0;
  while ((i < 32)) {
    var i$2 = i;
    if ((i$2 <= 18)) {
      $n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows).set(i$2, $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(elem__lo, elem__hi)));
      var $x_3 = $n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows);
      var $x_2 = $m_Ljava_math_BigInteger$();
      var this$4__lo = elem__lo;
      var this$4__hi = elem__hi;
      var lo = this$4__lo;
      var lo$1 = (((32 & i$2) === 0) ? (lo << i$2) : 0);
      var hi = (((32 & i$2) === 0) ? (((((lo >>> 1) | 0) >>> ((31 - i$2) | 0)) | 0) | (this$4__hi << i$2)) : (lo << i$2));
      $x_3.set(i$2, $n($x_2).valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo$1, hi)));
      var b__lo = elem__lo;
      var b__hi = elem__hi;
      var blo = b__lo;
      var b0 = (65535 & blo);
      var b1 = ((blo >>> 16) | 0);
      var a0b0 = Math.imul(5, b0);
      var a0b1 = Math.imul(5, b1);
      var lo$2 = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$1 = ((Math.imul(5, b__hi) + ((c1part >>> 16) | 0)) | 0);
      var $x_4__lo = lo$2;
      var $x_4__hi = hi$1;
      elem__lo = $x_4__lo;
      elem__hi = $x_4__hi;
    } else {
      $n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows).set(i$2, $n($n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows).get((((-1) + i$2) | 0))).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows).get(1)));
      $n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows).set(i$2, $n($n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows).get((((-1) + i$2) | 0))).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN));
    }
    i = ((1 + i) | 0);
  }
}
function $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I($thiz, res, a, aSize, factor) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < aSize)) {
    var i$2 = i;
    $m_Ljava_math_Multiplication$();
    var a$1 = $n(a).get(i$2);
    var c = elem;
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & factor);
    var b1 = ((factor >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$1 = ((lo + c) | 0);
    var hi$4 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + hi$2) | 0) : hi$2);
    $n(res).set(i$2, lo$1);
    elem = hi$4;
    i = ((1 + i) | 0);
  }
  return elem;
}
function $p_Ljava_math_Multiplication$__multPAP__AI__AI__AI__I__I__V($thiz, a, b, t, aLen, bLen) {
  if (((a === b) && (aLen === bLen))) {
    $thiz.square__AI__I__AI__AI(a, aLen, t);
  } else {
    var i = 0;
    while ((i < aLen)) {
      var i$2 = i;
      var elem = 0;
      elem = 0;
      var aI = $n(a).get(i$2);
      var this$6 = new $c_ju_ScalaOps$SimpleRange(0, bLen);
      var i$1 = this$6.ju_ScalaOps$SimpleRange__f_java$util$ScalaOps$SimpleRange$$start;
      while ((i$1 < this$6.ju_ScalaOps$SimpleRange__f_java$util$ScalaOps$SimpleRange$$end)) {
        var j$2 = i$1;
        $m_Ljava_math_Multiplication$();
        var b$1 = $n(b).get(j$2);
        var c = $n(t).get(((i$2 + j$2) | 0));
        var d = elem;
        var a0 = (65535 & aI);
        var a1 = ((aI >>> 16) | 0);
        var b0 = (65535 & b$1);
        var b1 = ((b$1 >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$1 = ((lo + c) | 0);
        var hi$4 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + hi$2) | 0) : hi$2);
        var lo$2 = ((lo$1 + d) | 0);
        var hi$6 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + hi$4) | 0) : hi$4);
        $n(t).set(((i$2 + j$2) | 0), lo$2);
        elem = hi$6;
        i$1 = ((1 + i$1) | 0);
      }
      $n(t).set(((i$2 + bLen) | 0), elem);
      i = ((1 + i) | 0);
    }
  }
}
function $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI($thiz, len, pow) {
  var result = new $ac_I(len);
  $n(result).set(0, 1);
  var i = 1;
  while ((i < len)) {
    var i$2 = i;
    $n(result).set(i$2, Math.imul($n(result).get((((-1) + i$2) | 0)), pow));
    i = ((1 + i) | 0);
  }
  return result;
}
/** @constructor */
function $c_Ljava_math_Multiplication$() {
  this.Ljava_math_Multiplication$__f_TenPows = null;
  this.Ljava_math_Multiplication$__f_BigTenPows = null;
  this.Ljava_math_Multiplication$__f_BigFivePows = null;
  $n_Ljava_math_Multiplication$ = this;
  this.Ljava_math_Multiplication$__f_TenPows = $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI(this, 10, 10);
  $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI(this, 14, 5);
  this.Ljava_math_Multiplication$__f_BigTenPows = new ($d_Ljava_math_BigInteger.getArrayOf().constr)(32);
  this.Ljava_math_Multiplication$__f_BigFivePows = new ($d_Ljava_math_BigInteger.getArrayOf().constr)(32);
  $p_Ljava_math_Multiplication$__initialiseArrays__V(this);
}
$c_Ljava_math_Multiplication$.prototype = new $h_O();
$c_Ljava_math_Multiplication$.prototype.constructor = $c_Ljava_math_Multiplication$;
/** @constructor */
function $h_Ljava_math_Multiplication$() {
}
$h_Ljava_math_Multiplication$.prototype = $c_Ljava_math_Multiplication$.prototype;
$c_Ljava_math_Multiplication$.prototype.multiplyByPosInt__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(bi, factor) {
  var resSign = $n(bi).Ljava_math_BigInteger__f_sign;
  var aNumberLength = $n(bi).Ljava_math_BigInteger__f_numberLength;
  var aDigits = $n(bi).Ljava_math_BigInteger__f_digits;
  if ((resSign === 0)) {
    return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
  } else if ((aNumberLength === 1)) {
    var a = $n(aDigits).get(0);
    var a0 = (65535 & a);
    var a1 = ((a >>> 16) | 0);
    var b0 = (65535 & factor);
    var b1 = ((factor >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), resSign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, 2, new $ac_I(new Int32Array([lo, hi$2]))));
  } else {
    var resLength = ((1 + aNumberLength) | 0);
    var resDigits = new $ac_I(resLength);
    $n(resDigits).set(aNumberLength, $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, aDigits, aNumberLength, factor));
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
    result.cutOffLeadingZeroes__V();
    return result;
  }
});
$c_Ljava_math_Multiplication$.prototype.multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger = (function(bi, exp) {
  var value = $n(this.Ljava_math_Multiplication$__f_TenPows).u.length;
  var hi = (value >> 31);
  var ahi = exp.RTLong__f_hi;
  if (((ahi === hi) ? (((-2147483648) ^ exp.RTLong__f_lo) < ((-2147483648) ^ value)) : (ahi < hi))) {
    return this.multiplyByPosInt__Ljava_math_BigInteger__I__Ljava_math_BigInteger(bi, $n(this.Ljava_math_Multiplication$__f_TenPows).get(exp.RTLong__f_lo));
  } else {
    return $n(bi).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(this.powerOf10__J__Ljava_math_BigInteger(exp));
  }
});
$c_Ljava_math_Multiplication$.prototype.square__AI__I__AI__AI = (function(a, aLen, res) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < aLen)) {
    var i$2 = i;
    elem = 0;
    var _\uff3fself = ((1 + i$2) | 0);
    var this$6 = new $c_ju_ScalaOps$SimpleRange(_\uff3fself, aLen);
    var i$1 = this$6.ju_ScalaOps$SimpleRange__f_java$util$ScalaOps$SimpleRange$$start;
    while ((i$1 < this$6.ju_ScalaOps$SimpleRange__f_java$util$ScalaOps$SimpleRange$$end)) {
      var j$2 = i$1;
      $m_Ljava_math_Multiplication$();
      var a$1 = $n(a).get(i$2);
      var b = $n(a).get(j$2);
      var c = $n(res).get(((i$2 + j$2) | 0));
      var d = elem;
      var a0 = (65535 & a$1);
      var a1 = ((a$1 >>> 16) | 0);
      var b0 = (65535 & b);
      var b1 = ((b >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var lo$1 = ((lo + c) | 0);
      var hi$4 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + hi$2) | 0) : hi$2);
      var lo$2 = ((lo$1 + d) | 0);
      var hi$6 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + hi$4) | 0) : hi$4);
      $n(res).set(((i$2 + j$2) | 0), lo$2);
      elem = hi$6;
      i$1 = ((1 + i$1) | 0);
    }
    $n(res).set(((i$2 + aLen) | 0), elem);
    i = ((1 + i) | 0);
  }
  $m_Ljava_math_BitLevel$().shiftLeftOneBit__AI__AI__I__V(res, res, (aLen << 1));
  elem = 0;
  var i$3 = 0;
  var index = 0;
  while ((i$3 < aLen)) {
    var a$2 = $n(a).get(i$3);
    var b$1 = $n(a).get(i$3);
    var c$1 = $n(res).get(index);
    var d$1 = elem;
    var a0$1 = (65535 & a$2);
    var a1$1 = ((a$2 >>> 16) | 0);
    var b0$1 = (65535 & b$1);
    var b1$1 = ((b$1 >>> 16) | 0);
    var a0b0$1 = Math.imul(a0$1, b0$1);
    var a1b0$1 = Math.imul(a1$1, b0$1);
    var a0b1$1 = Math.imul(a0$1, b1$1);
    var lo$3 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$9 = ((((Math.imul(a1$1, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
    var lo$4 = ((lo$3 + c$1) | 0);
    var hi$11 = ((((-2147483648) ^ lo$4) < ((-2147483648) ^ lo$3)) ? ((1 + hi$9) | 0) : hi$9);
    var lo$5 = ((lo$4 + d$1) | 0);
    var hi$13 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$4)) ? ((1 + hi$11) | 0) : hi$11);
    $n(res).set(index, lo$5);
    index = ((1 + index) | 0);
    var value = $n(res).get(index);
    var lo$6 = ((hi$13 + value) | 0);
    var hi$15 = ((((-2147483648) ^ lo$6) < ((-2147483648) ^ hi$13)) ? 1 : 0);
    $n(res).set(index, lo$6);
    elem = hi$15;
    i$3 = ((1 + i$3) | 0);
    index = ((1 + index) | 0);
  }
  return res;
});
$c_Ljava_math_Multiplication$.prototype.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(val1, val2) {
  if (($n(val2).Ljava_math_BigInteger__f_numberLength > $n(val1).Ljava_math_BigInteger__f_numberLength)) {
    var x1___1 = val2;
    var x1___2 = val1;
  } else {
    var x1___1 = val1;
    var x1___2 = val2;
  }
  var op1 = $as_Ljava_math_BigInteger(x1___1);
  var op2 = $as_Ljava_math_BigInteger(x1___2);
  if (($n(op2).Ljava_math_BigInteger__f_numberLength < 63)) {
    return this.multiplyPAP__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(op1, op2);
  } else {
    var ndiv2 = (((-2) & $n(op1).Ljava_math_BigInteger__f_numberLength) << 4);
    var upperOp1 = $n(op1).shiftRight__I__Ljava_math_BigInteger(ndiv2);
    var upperOp2 = $n(op2).shiftRight__I__Ljava_math_BigInteger(ndiv2);
    var this$1 = $n(op1);
    var bi = $n(upperOp1).shiftLeft__I__Ljava_math_BigInteger(ndiv2);
    var lowerOp1 = $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$1, bi);
    var this$2 = $n(op2);
    var bi$1 = $n(upperOp2).shiftLeft__I__Ljava_math_BigInteger(ndiv2);
    var lowerOp2 = $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$2, bi$1);
    var upper = this.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(upperOp1, upperOp2);
    var lower = this.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(lowerOp1, lowerOp2);
    var this$3 = $n(upperOp1);
    var $x_1 = $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$3, lowerOp1);
    var this$4 = $n(lowerOp2);
    var middle = this.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger($x_1, $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$4, upperOp2));
    var this$5 = $n(middle);
    var bi$2 = upper;
    var this$6 = $n($m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$5, bi$2));
    middle = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$6, lower);
    middle = $n(middle).shiftLeft__I__Ljava_math_BigInteger(ndiv2);
    upper = $n(upper).shiftLeft__I__Ljava_math_BigInteger((ndiv2 << 1));
    var this$7 = $n(upper);
    var bi$3 = middle;
    var this$8 = $n($m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$7, bi$3));
    return $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$8, lower);
  }
});
$c_Ljava_math_Multiplication$.prototype.multArraysPAP__AI__I__AI__I__AI__V = (function(aDigits, aLen, bDigits, bLen, resDigits) {
  if ((!((aLen === 0) || (bLen === 0)))) {
    if ((aLen === 1)) {
      $n(resDigits).set(bLen, $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, bDigits, bLen, $n(aDigits).get(0)));
    } else if ((bLen === 1)) {
      $n(resDigits).set(aLen, $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, aDigits, aLen, $n(bDigits).get(0)));
    } else {
      $p_Ljava_math_Multiplication$__multPAP__AI__AI__AI__I__I__V(this, aDigits, bDigits, resDigits, aLen, bLen);
    }
  }
});
$c_Ljava_math_Multiplication$.prototype.multiplyPAP__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(a, b) {
  var aLen = $n(a).Ljava_math_BigInteger__f_numberLength;
  var bLen = $n(b).Ljava_math_BigInteger__f_numberLength;
  var resLength = ((aLen + bLen) | 0);
  var resSign = (($n(a).Ljava_math_BigInteger__f_sign !== $n(b).Ljava_math_BigInteger__f_sign) ? (-1) : 1);
  if ((resLength === 2)) {
    var a$1 = $n($n(a).Ljava_math_BigInteger__f_digits).get(0);
    var b$1 = $n($n(b).Ljava_math_BigInteger__f_digits).get(0);
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & b$1);
    var b1 = ((b$1 >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), resSign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, 2, new $ac_I(new Int32Array([lo, hi$2]))));
  } else {
    var aDigits = $n(a).Ljava_math_BigInteger__f_digits;
    var bDigits = $n(b).Ljava_math_BigInteger__f_digits;
    var resDigits = new $ac_I(resLength);
    this.multArraysPAP__AI__I__AI__I__AI__V(aDigits, aLen, bDigits, bLen, resDigits);
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
    result.cutOffLeadingZeroes__V();
    return result;
  }
});
$c_Ljava_math_Multiplication$.prototype.pow__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(base, exponent) {
  var exp = exponent;
  var res = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE;
  var acc = base;
  while ((exp > 1)) {
    var res2 = (((1 & exp) !== 0) ? $n(res).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(acc) : res);
    if (($n(acc).Ljava_math_BigInteger__f_numberLength === 1)) {
      var acc2 = $n(acc).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(acc);
    } else {
      var a = new $ac_I(($n(acc).Ljava_math_BigInteger__f_numberLength << 1));
      var sq = this.square__AI__I__AI__AI($n(acc).Ljava_math_BigInteger__f_digits, $n(acc).Ljava_math_BigInteger__f_numberLength, a);
      var acc2 = $ct_Ljava_math_BigInteger__I__AI__(new $c_Ljava_math_BigInteger(), 1, sq);
    }
    var temp$exp = (exp >> 1);
    exp = temp$exp;
    res = res2;
    acc = acc2;
  }
  return $n(res).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(acc);
});
$c_Ljava_math_Multiplication$.prototype.powerOf10__J__Ljava_math_BigInteger = (function(exp) {
  var value = $n(this.Ljava_math_Multiplication$__f_BigTenPows).u.length;
  var hi = (value >> 31);
  var ahi = exp.RTLong__f_hi;
  if (((ahi === hi) ? (((-2147483648) ^ exp.RTLong__f_lo) < ((-2147483648) ^ value)) : (ahi < hi))) {
    return $n(this.Ljava_math_Multiplication$__f_BigTenPows).get(exp.RTLong__f_lo);
  } else {
    var ahi$1 = exp.RTLong__f_hi;
    if (((ahi$1 === 0) ? (((-2147483648) ^ exp.RTLong__f_lo) <= (-2147483598)) : (ahi$1 < 0))) {
      return $n($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN).pow__I__Ljava_math_BigInteger(exp.RTLong__f_lo);
    } else {
      var ahi$2 = exp.RTLong__f_hi;
      if (((ahi$2 === 0) ? (((-2147483648) ^ exp.RTLong__f_lo) <= (-1)) : (ahi$2 < 0))) {
        return $n($n($n(this.Ljava_math_Multiplication$__f_BigFivePows).get(1)).pow__I__Ljava_math_BigInteger(exp.RTLong__f_lo)).shiftLeft__I__Ljava_math_BigInteger(exp.RTLong__f_lo);
      } else {
        var powerOfFive = $n($n(this.Ljava_math_Multiplication$__f_BigFivePows).get(1)).pow__I__Ljava_math_BigInteger(2147483647);
        var res = powerOfFive;
        var bhi = exp.RTLong__f_hi;
        var lo = (((-2147483647) + exp.RTLong__f_lo) | 0);
        var hi$1 = ((((-2147483648) ^ lo) < 1) ? bhi : (((-1) + bhi) | 0));
        var longExp__lo = lo;
        var longExp__hi = hi$1;
        var this$3 = $m_RTLong$();
        var lo$1 = this$3.remainderImpl__I__I__I__I__I(exp.RTLong__f_lo, exp.RTLong__f_hi, 2147483647, 0);
        while (true) {
          var this$4__lo = longExp__lo;
          var this$4__hi = longExp__hi;
          var ahi$3 = this$4__hi;
          if (((ahi$3 === 0) ? (((-2147483648) ^ this$4__lo) > (-1)) : (ahi$3 > 0))) {
            res = $n(res).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(powerOfFive);
            var b__lo = longExp__lo;
            var b__hi = longExp__hi;
            var bhi$1 = b__hi;
            var lo$2 = (((-2147483647) + b__lo) | 0);
            var hi$3 = ((((-2147483648) ^ lo$2) < 1) ? bhi$1 : (((-1) + bhi$1) | 0));
            var $x_1__lo = lo$2;
            var $x_1__hi = hi$3;
            longExp__lo = $x_1__lo;
            longExp__hi = $x_1__hi;
          } else {
            break;
          }
        }
        res = $n(res).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n($n(this.Ljava_math_Multiplication$__f_BigFivePows).get(1)).pow__I__Ljava_math_BigInteger(lo$1));
        res = $n(res).shiftLeft__I__Ljava_math_BigInteger(2147483647);
        var bhi$2 = exp.RTLong__f_hi;
        var lo$3 = (((-2147483647) + exp.RTLong__f_lo) | 0);
        var hi$4 = ((((-2147483648) ^ lo$3) < 1) ? bhi$2 : (((-1) + bhi$2) | 0));
        var $x_2__lo = lo$3;
        var $x_2__hi = hi$4;
        longExp__lo = $x_2__lo;
        longExp__hi = $x_2__hi;
        while (true) {
          var this$7__lo = longExp__lo;
          var this$7__hi = longExp__hi;
          var ahi$4 = this$7__hi;
          if (((ahi$4 === 0) ? (((-2147483648) ^ this$7__lo) > (-1)) : (ahi$4 > 0))) {
            res = $n(res).shiftLeft__I__Ljava_math_BigInteger(2147483647);
            var b$1__lo = longExp__lo;
            var b$1__hi = longExp__hi;
            var bhi$3 = b$1__hi;
            var lo$4 = (((-2147483647) + b$1__lo) | 0);
            var hi$5 = ((((-2147483648) ^ lo$4) < 1) ? bhi$3 : (((-1) + bhi$3) | 0));
            var $x_3__lo = lo$4;
            var $x_3__hi = hi$5;
            longExp__lo = $x_3__lo;
            longExp__hi = $x_3__hi;
          } else {
            break;
          }
        }
        return $n(res).shiftLeft__I__Ljava_math_BigInteger(lo$1);
      }
    }
  }
});
var $d_Ljava_math_Multiplication$ = new $TypeData().initClass($c_Ljava_math_Multiplication$, "java.math.Multiplication$", ({
  Ljava_math_Multiplication$: 1
}));
var $n_Ljava_math_Multiplication$;
function $m_Ljava_math_Multiplication$() {
  if ((!$n_Ljava_math_Multiplication$)) {
    $n_Ljava_math_Multiplication$ = new $c_Ljava_math_Multiplication$();
  }
  return $n_Ljava_math_Multiplication$;
}
function $ct_Ljava_nio_Buffer__I__($thiz, _capacity) {
  $thiz.Ljava_nio_Buffer__f__capacity = _capacity;
  $thiz.Ljava_nio_Buffer__f__limit = $thiz.Ljava_nio_Buffer__f__capacity;
  $thiz.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  $thiz.Ljava_nio_Buffer__f__mark = (-1);
  return $thiz;
}
/** @constructor */
function $c_Ljava_nio_Buffer() {
  this.Ljava_nio_Buffer__f__capacity = 0;
  this.Ljava_nio_Buffer__f__limit = 0;
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  this.Ljava_nio_Buffer__f__mark = 0;
}
$c_Ljava_nio_Buffer.prototype = new $h_O();
$c_Ljava_nio_Buffer.prototype.constructor = $c_Ljava_nio_Buffer;
/** @constructor */
function $h_Ljava_nio_Buffer() {
}
$h_Ljava_nio_Buffer.prototype = $c_Ljava_nio_Buffer.prototype;
$c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer = (function(newPosition) {
  if (((newPosition < 0) || (newPosition > this.Ljava_nio_Buffer__f__limit))) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPosition;
  if ((this.Ljava_nio_Buffer__f__mark > newPosition)) {
    this.Ljava_nio_Buffer__f__mark = (-1);
  }
  return this;
});
$c_Ljava_nio_Buffer.prototype.limit__I__Ljava_nio_Buffer = (function(newLimit) {
  if (((newLimit < 0) || (newLimit > this.Ljava_nio_Buffer__f__capacity))) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  this.Ljava_nio_Buffer__f__limit = newLimit;
  if ((this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position > newLimit)) {
    this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newLimit;
    if ((this.Ljava_nio_Buffer__f__mark > newLimit)) {
      this.Ljava_nio_Buffer__f__mark = (-1);
    }
  }
  return this;
});
$c_Ljava_nio_Buffer.prototype.clear__Ljava_nio_Buffer = (function() {
  this.Ljava_nio_Buffer__f__mark = (-1);
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  this.Ljava_nio_Buffer__f__limit = this.Ljava_nio_Buffer__f__capacity;
  return this;
});
$c_Ljava_nio_Buffer.prototype.flip__Ljava_nio_Buffer = (function() {
  this.Ljava_nio_Buffer__f__mark = (-1);
  this.Ljava_nio_Buffer__f__limit = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  return this;
});
$c_Ljava_nio_Buffer.prototype.toString__T = (function() {
  return ((((((($objectClassName(this) + "[pos=") + this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) + " lim=") + this.Ljava_nio_Buffer__f__limit) + " cap=") + this.Ljava_nio_Buffer__f__capacity) + "]");
});
/** @constructor */
function $c_Ljava_nio_ByteBuffer$() {
}
$c_Ljava_nio_ByteBuffer$.prototype = new $h_O();
$c_Ljava_nio_ByteBuffer$.prototype.constructor = $c_Ljava_nio_ByteBuffer$;
/** @constructor */
function $h_Ljava_nio_ByteBuffer$() {
}
$h_Ljava_nio_ByteBuffer$.prototype = $c_Ljava_nio_ByteBuffer$.prototype;
$c_Ljava_nio_ByteBuffer$.prototype.allocate__I__Ljava_nio_ByteBuffer = (function(capacity) {
  if ((capacity < 0)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  var array = new $ac_B(capacity);
  var length = $n(array).u.length;
  return $m_Ljava_nio_HeapByteBuffer$().wrap__AB__I__I__I__I__Z__Ljava_nio_ByteBuffer(array, 0, $n(array).u.length, 0, length, false);
});
var $d_Ljava_nio_ByteBuffer$ = new $TypeData().initClass($c_Ljava_nio_ByteBuffer$, "java.nio.ByteBuffer$", ({
  Ljava_nio_ByteBuffer$: 1
}));
var $n_Ljava_nio_ByteBuffer$;
function $m_Ljava_nio_ByteBuffer$() {
  if ((!$n_Ljava_nio_ByteBuffer$)) {
    $n_Ljava_nio_ByteBuffer$ = new $c_Ljava_nio_ByteBuffer$();
  }
  return $n_Ljava_nio_ByteBuffer$;
}
/** @constructor */
function $c_Ljava_nio_CharBuffer$() {
}
$c_Ljava_nio_CharBuffer$.prototype = new $h_O();
$c_Ljava_nio_CharBuffer$.prototype.constructor = $c_Ljava_nio_CharBuffer$;
/** @constructor */
function $h_Ljava_nio_CharBuffer$() {
}
$h_Ljava_nio_CharBuffer$.prototype = $c_Ljava_nio_CharBuffer$.prototype;
$c_Ljava_nio_CharBuffer$.prototype.allocate__I__Ljava_nio_CharBuffer = (function(capacity) {
  if ((capacity < 0)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  var array = new $ac_C(capacity);
  var length = $n(array).u.length;
  var capacity$1 = $n(array).u.length;
  if (((capacity$1 < 0) || (capacity$1 > $n(array).u.length))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  if (((length < 0) || (length > capacity$1))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  return new $c_Ljava_nio_HeapCharBuffer(capacity$1, array, 0, 0, length, false);
});
$c_Ljava_nio_CharBuffer$.prototype.wrap__jl_CharSequence__I__I__Ljava_nio_CharBuffer = (function(csq, start, end) {
  return $m_Ljava_nio_StringCharBuffer$().wrap__jl_CharSequence__I__I__I__I__Ljava_nio_CharBuffer(csq, 0, $dp_length__I($n(csq)), start, ((end - start) | 0));
});
var $d_Ljava_nio_CharBuffer$ = new $TypeData().initClass($c_Ljava_nio_CharBuffer$, "java.nio.CharBuffer$", ({
  Ljava_nio_CharBuffer$: 1
}));
var $n_Ljava_nio_CharBuffer$;
function $m_Ljava_nio_CharBuffer$() {
  if ((!$n_Ljava_nio_CharBuffer$)) {
    $n_Ljava_nio_CharBuffer$ = new $c_Ljava_nio_CharBuffer$();
  }
  return $n_Ljava_nio_CharBuffer$;
}
/** @constructor */
function $c_Ljava_nio_HeapByteBuffer$() {
}
$c_Ljava_nio_HeapByteBuffer$.prototype = new $h_O();
$c_Ljava_nio_HeapByteBuffer$.prototype.constructor = $c_Ljava_nio_HeapByteBuffer$;
/** @constructor */
function $h_Ljava_nio_HeapByteBuffer$() {
}
$h_Ljava_nio_HeapByteBuffer$.prototype = $c_Ljava_nio_HeapByteBuffer$.prototype;
$c_Ljava_nio_HeapByteBuffer$.prototype.wrap__AB__I__I__I__I__Z__Ljava_nio_ByteBuffer = (function(array, arrayOffset, capacity, initialPosition, initialLength, isReadOnly) {
  if ((((arrayOffset < 0) || (capacity < 0)) || (((arrayOffset + capacity) | 0) > $n(array).u.length))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  var initialLimit = ((initialPosition + initialLength) | 0);
  if ((((initialPosition < 0) || (initialLength < 0)) || (initialLimit > capacity))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  return new $c_Ljava_nio_HeapByteBuffer(capacity, array, arrayOffset, initialPosition, initialLimit, isReadOnly);
});
var $d_Ljava_nio_HeapByteBuffer$ = new $TypeData().initClass($c_Ljava_nio_HeapByteBuffer$, "java.nio.HeapByteBuffer$", ({
  Ljava_nio_HeapByteBuffer$: 1
}));
var $n_Ljava_nio_HeapByteBuffer$;
function $m_Ljava_nio_HeapByteBuffer$() {
  if ((!$n_Ljava_nio_HeapByteBuffer$)) {
    $n_Ljava_nio_HeapByteBuffer$ = new $c_Ljava_nio_HeapByteBuffer$();
  }
  return $n_Ljava_nio_HeapByteBuffer$;
}
/** @constructor */
function $c_Ljava_nio_StringCharBuffer$() {
}
$c_Ljava_nio_StringCharBuffer$.prototype = new $h_O();
$c_Ljava_nio_StringCharBuffer$.prototype.constructor = $c_Ljava_nio_StringCharBuffer$;
/** @constructor */
function $h_Ljava_nio_StringCharBuffer$() {
}
$h_Ljava_nio_StringCharBuffer$.prototype = $c_Ljava_nio_StringCharBuffer$.prototype;
$c_Ljava_nio_StringCharBuffer$.prototype.wrap__jl_CharSequence__I__I__I__I__Ljava_nio_CharBuffer = (function(csq, csqOffset, capacity, initialPosition, initialLength) {
  if ((((csqOffset < 0) || (capacity < 0)) || (((csqOffset + capacity) | 0) > $dp_length__I($n(csq))))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  var initialLimit = ((initialPosition + initialLength) | 0);
  if ((((initialPosition < 0) || (initialLength < 0)) || (initialLimit > capacity))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  return new $c_Ljava_nio_StringCharBuffer(capacity, csq, csqOffset, initialPosition, initialLimit);
});
var $d_Ljava_nio_StringCharBuffer$ = new $TypeData().initClass($c_Ljava_nio_StringCharBuffer$, "java.nio.StringCharBuffer$", ({
  Ljava_nio_StringCharBuffer$: 1
}));
var $n_Ljava_nio_StringCharBuffer$;
function $m_Ljava_nio_StringCharBuffer$() {
  if ((!$n_Ljava_nio_StringCharBuffer$)) {
    $n_Ljava_nio_StringCharBuffer$ = new $c_Ljava_nio_StringCharBuffer$();
  }
  return $n_Ljava_nio_StringCharBuffer$;
}
function $p_Ljava_nio_charset_CharsetDecoder__grow$1__Ljava_nio_CharBuffer__Ljava_nio_CharBuffer($thiz, out) {
  var this$1 = $n(out);
  if ((this$1.Ljava_nio_Buffer__f__capacity === 0)) {
    return $m_Ljava_nio_CharBuffer$().allocate__I__Ljava_nio_CharBuffer(1);
  } else {
    var $x_1 = $m_Ljava_nio_CharBuffer$();
    var this$2 = $n(out);
    var result = $n($x_1).allocate__I__Ljava_nio_CharBuffer((this$2.Ljava_nio_Buffer__f__capacity << 1));
    var this$3 = $n(out);
    $c_Ljava_nio_Buffer.prototype.flip__Ljava_nio_Buffer.call(this$3);
    $n(result).put__Ljava_nio_CharBuffer__Ljava_nio_CharBuffer(out);
    return result;
  }
}
function $ct_Ljava_nio_charset_CharsetDecoder__Ljava_nio_charset_Charset__F__F__($thiz, cs, _averageCharsPerByte, _maxCharsPerByte) {
  $thiz.Ljava_nio_charset_CharsetDecoder__f__averageCharsPerByte = _averageCharsPerByte;
  $thiz.Ljava_nio_charset_CharsetDecoder__f__replacement = "\ufffd";
  $thiz.Ljava_nio_charset_CharsetDecoder__f__malformedInputAction = $m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPORT;
  $thiz.Ljava_nio_charset_CharsetDecoder__f__unmappableCharacterAction = $m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPORT;
  $thiz.Ljava_nio_charset_CharsetDecoder__f_status = 1;
  return $thiz;
}
/** @constructor */
function $c_Ljava_nio_charset_CharsetDecoder() {
  this.Ljava_nio_charset_CharsetDecoder__f__averageCharsPerByte = 0.0;
  this.Ljava_nio_charset_CharsetDecoder__f__replacement = null;
  this.Ljava_nio_charset_CharsetDecoder__f__malformedInputAction = null;
  this.Ljava_nio_charset_CharsetDecoder__f__unmappableCharacterAction = null;
  this.Ljava_nio_charset_CharsetDecoder__f_status = 0;
}
$c_Ljava_nio_charset_CharsetDecoder.prototype = new $h_O();
$c_Ljava_nio_charset_CharsetDecoder.prototype.constructor = $c_Ljava_nio_charset_CharsetDecoder;
/** @constructor */
function $h_Ljava_nio_charset_CharsetDecoder() {
}
$h_Ljava_nio_charset_CharsetDecoder.prototype = $c_Ljava_nio_charset_CharsetDecoder.prototype;
$c_Ljava_nio_charset_CharsetDecoder.prototype.onMalformedInput__Ljava_nio_charset_CodingErrorAction__Ljava_nio_charset_CharsetDecoder = (function(newAction) {
  if ((newAction === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null CodingErrorAction");
  }
  this.Ljava_nio_charset_CharsetDecoder__f__malformedInputAction = newAction;
  return this;
});
$c_Ljava_nio_charset_CharsetDecoder.prototype.onUnmappableCharacter__Ljava_nio_charset_CodingErrorAction__Ljava_nio_charset_CharsetDecoder = (function(newAction) {
  if ((newAction === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null CodingErrorAction");
  }
  this.Ljava_nio_charset_CharsetDecoder__f__unmappableCharacterAction = newAction;
  return this;
});
$c_Ljava_nio_charset_CharsetDecoder.prototype.decode__Ljava_nio_ByteBuffer__Ljava_nio_CharBuffer__Z__Ljava_nio_charset_CoderResult = (function(in$1, out, endOfInput) {
  if (((this.Ljava_nio_charset_CharsetDecoder__f_status === 4) || ((!endOfInput) && (this.Ljava_nio_charset_CharsetDecoder__f_status === 3)))) {
    throw $ct_jl_IllegalStateException__(new $c_jl_IllegalStateException());
  }
  this.Ljava_nio_charset_CharsetDecoder__f_status = (endOfInput ? 3 : 2);
  while (true) {
    try {
      var result1 = this.decodeLoop__Ljava_nio_ByteBuffer__Ljava_nio_CharBuffer__Ljava_nio_charset_CoderResult(in$1, out);
    } catch (e) {
      var result1;
      if ((e instanceof $c_Ljava_nio_BufferOverflowException)) {
        var ex$2 = $as_Ljava_nio_BufferOverflowException(e);
        throw new $c_Ljava_nio_charset_CoderMalfunctionError(ex$2);
      } else if ((e instanceof $c_Ljava_nio_BufferUnderflowException)) {
        var ex = $as_Ljava_nio_BufferUnderflowException(e);
        throw new $c_Ljava_nio_charset_CoderMalfunctionError(ex);
      } else {
        throw e;
      }
    }
    var this$1 = $n(result1);
    if ((this$1.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 0)) {
      var this$2 = $n(in$1);
      var remaining = ((this$2.Ljava_nio_Buffer__f__limit - this$2.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
      if ((endOfInput && (remaining > 0))) {
        var this$3 = $m_Ljava_nio_charset_CoderResult$();
        switch (remaining) {
          case 1: {
            var result2 = this$3.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
            break;
          }
          case 2: {
            var result2 = this$3.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed2;
            break;
          }
          case 3: {
            var result2 = this$3.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed3;
            break;
          }
          case 4: {
            var result2 = this$3.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed4;
            break;
          }
          default: {
            var result2 = this$3.java$nio$charset$CoderResult$$malformedForLengthImpl__I__Ljava_nio_charset_CoderResult(remaining);
          }
        }
      } else {
        var result2 = result1;
      }
    } else {
      var result2 = result1;
    }
    var this$4 = $n(result2);
    if ((this$4.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 0)) {
      var $x_1 = true;
    } else {
      var this$5 = $n(result2);
      var $x_1 = (this$5.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 1);
    }
    if ($x_1) {
      return result2;
    } else {
      var this$6 = $n(result2);
      if ((this$6.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 3)) {
        var action = this.Ljava_nio_charset_CharsetDecoder__f__unmappableCharacterAction;
      } else {
        var action = this.Ljava_nio_charset_CharsetDecoder__f__malformedInputAction;
      }
      var x = $m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPLACE;
      if ((x === null)) {
        var $x_2 = (action === null);
      } else {
        var this$7 = $n(x);
        var $x_2 = (this$7 === action);
      }
      if ($x_2) {
        var this$8 = $n(out);
        var $x_4 = this$8.Ljava_nio_Buffer__f__limit;
        var $x_3 = this$8.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
        var this$9 = $n(this.Ljava_nio_charset_CharsetDecoder__f__replacement);
        if (((($x_4 - $x_3) | 0) < this$9.length)) {
          return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
        } else {
          var this$10 = $n(out);
          var src = this.Ljava_nio_charset_CharsetDecoder__f__replacement;
          var this$11 = $n(src);
          this$10.put__T__I__I__Ljava_nio_CharBuffer(src, 0, this$11.length);
          var this$14 = $n(in$1);
          var this$12 = $n(in$1);
          var $x_5 = this$12.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
          var this$13 = $n(result2);
          var l = this$13.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$_length;
          if ((l < 0)) {
            throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
          }
          var newPosition = (($x_5 + l) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$14, newPosition);
        }
      } else {
        var x$3 = $m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPORT;
        if ((x$3 === null)) {
          var $x_6 = (action === null);
        } else {
          var this$15 = $n(x$3);
          var $x_6 = (this$15 === action);
        }
        if ($x_6) {
          return result2;
        } else {
          var x$5 = $m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_IGNORE;
          if ((x$5 === null)) {
            var $x_7 = (action === null);
          } else {
            var this$16 = $n(x$5);
            var $x_7 = (this$16 === action);
          }
          if ($x_7) {
            var this$19 = $n(in$1);
            var this$17 = $n(in$1);
            var $x_8 = this$17.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
            var this$18 = $n(result2);
            var l$1 = this$18.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$_length;
            if ((l$1 < 0)) {
              throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
            }
            var newPosition$1 = (($x_8 + l$1) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$19, newPosition$1);
          } else {
            throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), action);
          }
        }
      }
    }
  }
});
$c_Ljava_nio_charset_CharsetDecoder.prototype.flush__Ljava_nio_CharBuffer__Ljava_nio_charset_CoderResult = (function(out) {
  var x1 = this.Ljava_nio_charset_CharsetDecoder__f_status;
  switch (x1) {
    case 3: {
      var result = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
      var this$1 = $n(result);
      if ((this$1.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 0)) {
        this.Ljava_nio_charset_CharsetDecoder__f_status = 4;
      }
      return result;
      break;
    }
    case 4: {
      return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
      break;
    }
    default: {
      throw $ct_jl_IllegalStateException__(new $c_jl_IllegalStateException());
    }
  }
});
$c_Ljava_nio_charset_CharsetDecoder.prototype.reset__Ljava_nio_charset_CharsetDecoder = (function() {
  this.Ljava_nio_charset_CharsetDecoder__f_status = 1;
  return this;
});
$c_Ljava_nio_charset_CharsetDecoder.prototype.decode__Ljava_nio_ByteBuffer__Ljava_nio_CharBuffer = (function(in$1) {
  this.reset__Ljava_nio_charset_CharsetDecoder();
  var this$1 = $n(in$1);
  var initLength = $doubleToInt((((this$1.Ljava_nio_Buffer__f__limit - this$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) * this.Ljava_nio_charset_CharsetDecoder__f__averageCharsPerByte));
  var out = $m_Ljava_nio_CharBuffer$().allocate__I__Ljava_nio_CharBuffer(initLength);
  var out$1;
  while (true) {
    var result = this.decode__Ljava_nio_ByteBuffer__Ljava_nio_CharBuffer__Z__Ljava_nio_charset_CoderResult(in$1, out, true);
    var this$2 = $n(result);
    if ((!(this$2.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 0))) {
      var this$4 = $n(result);
      if ((this$4.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 1)) {
        out = $p_Ljava_nio_charset_CharsetDecoder__grow$1__Ljava_nio_CharBuffer__Ljava_nio_CharBuffer(this, out);
        continue;
      }
      $n(result).throwException__V();
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "should not get here");
    }
    var this$3 = $n(in$1);
    if ((this$3.Ljava_nio_Buffer__f_java$nio$Buffer$$_position !== this$3.Ljava_nio_Buffer__f__limit)) {
      throw $ct_jl_AssertionError__(new $c_jl_AssertionError());
    }
    var out$1 = out;
    break;
  }
  var out$2;
  while (true) {
    var result$1 = this.flush__Ljava_nio_CharBuffer__Ljava_nio_charset_CoderResult(out$1);
    var this$5 = $n(result$1);
    if ((!(this$5.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 0))) {
      var this$6 = $n(result$1);
      if ((this$6.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 1)) {
        out$1 = $p_Ljava_nio_charset_CharsetDecoder__grow$1__Ljava_nio_CharBuffer__Ljava_nio_CharBuffer(this, out$1);
        continue;
      }
      $n(result$1).throwException__V();
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "should not get here");
    }
    var out$2 = out$1;
    break;
  }
  var this$7 = $n(out$2);
  $c_Ljava_nio_Buffer.prototype.flip__Ljava_nio_Buffer.call(this$7);
  return out$2;
});
function $ct_Ljava_nio_charset_CharsetEncoder__Ljava_nio_charset_Charset__F__F__AB__($thiz, cs, _averageBytesPerChar, _maxBytesPerChar, _replacement) {
  $thiz.Ljava_nio_charset_CharsetEncoder__f__averageBytesPerChar = _averageBytesPerChar;
  $thiz.Ljava_nio_charset_CharsetEncoder__f__replacement = _replacement;
  $thiz.Ljava_nio_charset_CharsetEncoder__f__malformedInputAction = $m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPORT;
  $thiz.Ljava_nio_charset_CharsetEncoder__f__unmappableCharacterAction = $m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPORT;
  $thiz.Ljava_nio_charset_CharsetEncoder__f_status = 0;
  return $thiz;
}
function $ct_Ljava_nio_charset_CharsetEncoder__Ljava_nio_charset_Charset__F__F__($thiz, cs, _averageBytesPerChar, _maxBytesPerChar) {
  $ct_Ljava_nio_charset_CharsetEncoder__Ljava_nio_charset_Charset__F__F__AB__($thiz, cs, _averageBytesPerChar, _maxBytesPerChar, new $ac_B(new Int8Array([63])));
  return $thiz;
}
/** @constructor */
function $c_Ljava_nio_charset_CharsetEncoder() {
  this.Ljava_nio_charset_CharsetEncoder__f__averageBytesPerChar = 0.0;
  this.Ljava_nio_charset_CharsetEncoder__f__replacement = null;
  this.Ljava_nio_charset_CharsetEncoder__f__malformedInputAction = null;
  this.Ljava_nio_charset_CharsetEncoder__f__unmappableCharacterAction = null;
  this.Ljava_nio_charset_CharsetEncoder__f_status = 0;
}
$c_Ljava_nio_charset_CharsetEncoder.prototype = new $h_O();
$c_Ljava_nio_charset_CharsetEncoder.prototype.constructor = $c_Ljava_nio_charset_CharsetEncoder;
/** @constructor */
function $h_Ljava_nio_charset_CharsetEncoder() {
}
$h_Ljava_nio_charset_CharsetEncoder.prototype = $c_Ljava_nio_charset_CharsetEncoder.prototype;
$c_Ljava_nio_charset_CharsetEncoder.prototype.onMalformedInput__Ljava_nio_charset_CodingErrorAction__Ljava_nio_charset_CharsetEncoder = (function(newAction) {
  if ((newAction === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null CodingErrorAction");
  }
  this.Ljava_nio_charset_CharsetEncoder__f__malformedInputAction = newAction;
  return this;
});
$c_Ljava_nio_charset_CharsetEncoder.prototype.onUnmappableCharacter__Ljava_nio_charset_CodingErrorAction__Ljava_nio_charset_CharsetEncoder = (function(newAction) {
  if ((newAction === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null CodingErrorAction");
  }
  this.Ljava_nio_charset_CharsetEncoder__f__unmappableCharacterAction = newAction;
  return this;
});
$c_Ljava_nio_charset_CharsetEncoder.prototype.encode__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer__Z__Ljava_nio_charset_CoderResult = (function(in$1, out, endOfInput) {
  if (((this.Ljava_nio_charset_CharsetEncoder__f_status === 3) || ((!endOfInput) && (this.Ljava_nio_charset_CharsetEncoder__f_status === 2)))) {
    throw $ct_jl_IllegalStateException__(new $c_jl_IllegalStateException());
  }
  this.Ljava_nio_charset_CharsetEncoder__f_status = (endOfInput ? 2 : 1);
  while (true) {
    try {
      var result1 = this.encodeLoop__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer__Ljava_nio_charset_CoderResult(in$1, out);
    } catch (e) {
      var result1;
      if ((e instanceof $c_Ljava_nio_BufferOverflowException)) {
        var ex$2 = $as_Ljava_nio_BufferOverflowException(e);
        throw new $c_Ljava_nio_charset_CoderMalfunctionError(ex$2);
      } else if ((e instanceof $c_Ljava_nio_BufferUnderflowException)) {
        var ex = $as_Ljava_nio_BufferUnderflowException(e);
        throw new $c_Ljava_nio_charset_CoderMalfunctionError(ex);
      } else {
        throw e;
      }
    }
    var this$1 = $n(result1);
    if ((this$1.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 0)) {
      var this$2 = $n(in$1);
      var remaining = ((this$2.Ljava_nio_Buffer__f__limit - this$2.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
      if ((endOfInput && (remaining > 0))) {
        var this$3 = $m_Ljava_nio_charset_CoderResult$();
        switch (remaining) {
          case 1: {
            var result2 = this$3.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
            break;
          }
          case 2: {
            var result2 = this$3.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed2;
            break;
          }
          case 3: {
            var result2 = this$3.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed3;
            break;
          }
          case 4: {
            var result2 = this$3.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed4;
            break;
          }
          default: {
            var result2 = this$3.java$nio$charset$CoderResult$$malformedForLengthImpl__I__Ljava_nio_charset_CoderResult(remaining);
          }
        }
      } else {
        var result2 = result1;
      }
    } else {
      var result2 = result1;
    }
    var this$4 = $n(result2);
    if ((this$4.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 0)) {
      var $x_1 = true;
    } else {
      var this$5 = $n(result2);
      var $x_1 = (this$5.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 1);
    }
    if ($x_1) {
      return result2;
    } else {
      var this$6 = $n(result2);
      if ((this$6.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 3)) {
        var action = this.Ljava_nio_charset_CharsetEncoder__f__unmappableCharacterAction;
      } else {
        var action = this.Ljava_nio_charset_CharsetEncoder__f__malformedInputAction;
      }
      var x = $m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPLACE;
      if ((x === null)) {
        var $x_2 = (action === null);
      } else {
        var this$7 = $n(x);
        var $x_2 = (this$7 === action);
      }
      if ($x_2) {
        var this$8 = $n(out);
        if ((((this$8.Ljava_nio_Buffer__f__limit - this$8.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) < $n(this.Ljava_nio_charset_CharsetEncoder__f__replacement).u.length)) {
          return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
        } else {
          var this$9 = $n(out);
          var src = this.Ljava_nio_charset_CharsetEncoder__f__replacement;
          this$9.put__AB__I__I__Ljava_nio_ByteBuffer(src, 0, $n(src).u.length);
          var this$12 = $n(in$1);
          var this$10 = $n(in$1);
          var $x_3 = this$10.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
          var this$11 = $n(result2);
          var l = this$11.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$_length;
          if ((l < 0)) {
            throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
          }
          var newPosition = (($x_3 + l) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$12, newPosition);
        }
      } else {
        var x$3 = $m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPORT;
        if ((x$3 === null)) {
          var $x_4 = (action === null);
        } else {
          var this$13 = $n(x$3);
          var $x_4 = (this$13 === action);
        }
        if ($x_4) {
          return result2;
        } else {
          var x$5 = $m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_IGNORE;
          if ((x$5 === null)) {
            var $x_5 = (action === null);
          } else {
            var this$14 = $n(x$5);
            var $x_5 = (this$14 === action);
          }
          if ($x_5) {
            var this$17 = $n(in$1);
            var this$15 = $n(in$1);
            var $x_6 = this$15.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
            var this$16 = $n(result2);
            var l$1 = this$16.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$_length;
            if ((l$1 < 0)) {
              throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
            }
            var newPosition$1 = (($x_6 + l$1) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$17, newPosition$1);
          } else {
            throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), action);
          }
        }
      }
    }
  }
});
/** @constructor */
function $c_Ljava_nio_charset_CoderResult(kind, _length) {
  this.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind = 0;
  this.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$_length = 0;
  this.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind = kind;
  this.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$_length = _length;
}
$c_Ljava_nio_charset_CoderResult.prototype = new $h_O();
$c_Ljava_nio_charset_CoderResult.prototype.constructor = $c_Ljava_nio_charset_CoderResult;
/** @constructor */
function $h_Ljava_nio_charset_CoderResult() {
}
$h_Ljava_nio_charset_CoderResult.prototype = $c_Ljava_nio_charset_CoderResult.prototype;
$c_Ljava_nio_charset_CoderResult.prototype.throwException__V = (function() {
  var x1 = this.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind;
  switch (x1) {
    case 1: {
      throw new $c_Ljava_nio_BufferOverflowException();
      break;
    }
    case 0: {
      throw new $c_Ljava_nio_BufferUnderflowException();
      break;
    }
    case 2: {
      throw new $c_Ljava_nio_charset_MalformedInputException(this.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$_length);
      break;
    }
    case 3: {
      throw new $c_Ljava_nio_charset_UnmappableCharacterException(this.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$_length);
      break;
    }
    default: {
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), x1);
    }
  }
});
function $as_Ljava_nio_charset_CoderResult(obj) {
  return (((obj instanceof $c_Ljava_nio_charset_CoderResult) || (obj === null)) ? obj : $throwClassCastException(obj, "java.nio.charset.CoderResult"));
}
function $isArrayOf_Ljava_nio_charset_CoderResult(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_nio_charset_CoderResult)));
}
function $asArrayOf_Ljava_nio_charset_CoderResult(obj, depth) {
  return (($isArrayOf_Ljava_nio_charset_CoderResult(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.nio.charset.CoderResult;", depth));
}
var $d_Ljava_nio_charset_CoderResult = new $TypeData().initClass($c_Ljava_nio_charset_CoderResult, "java.nio.charset.CoderResult", ({
  Ljava_nio_charset_CoderResult: 1
}));
/** @constructor */
function $c_Ljava_nio_charset_CoderResult$() {
  this.Ljava_nio_charset_CoderResult$__f_OVERFLOW = null;
  this.Ljava_nio_charset_CoderResult$__f_UNDERFLOW = null;
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1 = null;
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed2 = null;
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed3 = null;
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed4 = null;
  this.Ljava_nio_charset_CoderResult$__f_uniqueMalformed = null;
  $n_Ljava_nio_charset_CoderResult$ = this;
  this.Ljava_nio_charset_CoderResult$__f_OVERFLOW = new $c_Ljava_nio_charset_CoderResult(1, (-1));
  this.Ljava_nio_charset_CoderResult$__f_UNDERFLOW = new $c_Ljava_nio_charset_CoderResult(0, (-1));
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1 = new $c_Ljava_nio_charset_CoderResult(2, 1);
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed2 = new $c_Ljava_nio_charset_CoderResult(2, 2);
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed3 = new $c_Ljava_nio_charset_CoderResult(2, 3);
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed4 = new $c_Ljava_nio_charset_CoderResult(2, 4);
  this.Ljava_nio_charset_CoderResult$__f_uniqueMalformed = [];
}
$c_Ljava_nio_charset_CoderResult$.prototype = new $h_O();
$c_Ljava_nio_charset_CoderResult$.prototype.constructor = $c_Ljava_nio_charset_CoderResult$;
/** @constructor */
function $h_Ljava_nio_charset_CoderResult$() {
}
$h_Ljava_nio_charset_CoderResult$.prototype = $c_Ljava_nio_charset_CoderResult$.prototype;
$c_Ljava_nio_charset_CoderResult$.prototype.java$nio$charset$CoderResult$$malformedForLengthImpl__I__Ljava_nio_charset_CoderResult = (function(length) {
  var x = this.Ljava_nio_charset_CoderResult$__f_uniqueMalformed[length];
  if ((x !== (void 0))) {
    var result = $as_Ljava_nio_charset_CoderResult(x);
    return result;
  } else {
    var result$1 = new $c_Ljava_nio_charset_CoderResult(2, length);
    $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_uniqueMalformed[length] = result$1;
    return result$1;
  }
});
var $d_Ljava_nio_charset_CoderResult$ = new $TypeData().initClass($c_Ljava_nio_charset_CoderResult$, "java.nio.charset.CoderResult$", ({
  Ljava_nio_charset_CoderResult$: 1
}));
var $n_Ljava_nio_charset_CoderResult$;
function $m_Ljava_nio_charset_CoderResult$() {
  if ((!$n_Ljava_nio_charset_CoderResult$)) {
    $n_Ljava_nio_charset_CoderResult$ = new $c_Ljava_nio_charset_CoderResult$();
  }
  return $n_Ljava_nio_charset_CoderResult$;
}
/** @constructor */
function $c_Ljava_nio_charset_CodingErrorAction(name) {
  this.Ljava_nio_charset_CodingErrorAction__f_name = null;
  this.Ljava_nio_charset_CodingErrorAction__f_name = name;
}
$c_Ljava_nio_charset_CodingErrorAction.prototype = new $h_O();
$c_Ljava_nio_charset_CodingErrorAction.prototype.constructor = $c_Ljava_nio_charset_CodingErrorAction;
/** @constructor */
function $h_Ljava_nio_charset_CodingErrorAction() {
}
$h_Ljava_nio_charset_CodingErrorAction.prototype = $c_Ljava_nio_charset_CodingErrorAction.prototype;
$c_Ljava_nio_charset_CodingErrorAction.prototype.toString__T = (function() {
  return this.Ljava_nio_charset_CodingErrorAction__f_name;
});
var $d_Ljava_nio_charset_CodingErrorAction = new $TypeData().initClass($c_Ljava_nio_charset_CodingErrorAction, "java.nio.charset.CodingErrorAction", ({
  Ljava_nio_charset_CodingErrorAction: 1
}));
/** @constructor */
function $c_Ljava_nio_charset_CodingErrorAction$() {
  this.Ljava_nio_charset_CodingErrorAction$__f_IGNORE = null;
  this.Ljava_nio_charset_CodingErrorAction$__f_REPLACE = null;
  this.Ljava_nio_charset_CodingErrorAction$__f_REPORT = null;
  $n_Ljava_nio_charset_CodingErrorAction$ = this;
  this.Ljava_nio_charset_CodingErrorAction$__f_IGNORE = new $c_Ljava_nio_charset_CodingErrorAction("IGNORE");
  this.Ljava_nio_charset_CodingErrorAction$__f_REPLACE = new $c_Ljava_nio_charset_CodingErrorAction("REPLACE");
  this.Ljava_nio_charset_CodingErrorAction$__f_REPORT = new $c_Ljava_nio_charset_CodingErrorAction("REPORT");
}
$c_Ljava_nio_charset_CodingErrorAction$.prototype = new $h_O();
$c_Ljava_nio_charset_CodingErrorAction$.prototype.constructor = $c_Ljava_nio_charset_CodingErrorAction$;
/** @constructor */
function $h_Ljava_nio_charset_CodingErrorAction$() {
}
$h_Ljava_nio_charset_CodingErrorAction$.prototype = $c_Ljava_nio_charset_CodingErrorAction$.prototype;
var $d_Ljava_nio_charset_CodingErrorAction$ = new $TypeData().initClass($c_Ljava_nio_charset_CodingErrorAction$, "java.nio.charset.CodingErrorAction$", ({
  Ljava_nio_charset_CodingErrorAction$: 1
}));
var $n_Ljava_nio_charset_CodingErrorAction$;
function $m_Ljava_nio_charset_CodingErrorAction$() {
  if ((!$n_Ljava_nio_charset_CodingErrorAction$)) {
    $n_Ljava_nio_charset_CodingErrorAction$ = new $c_Ljava_nio_charset_CodingErrorAction$();
  }
  return $n_Ljava_nio_charset_CodingErrorAction$;
}
/** @constructor */
function $c_ju_Arrays$() {
}
$c_ju_Arrays$.prototype = new $h_O();
$c_ju_Arrays$.prototype.constructor = $c_ju_Arrays$;
/** @constructor */
function $h_ju_Arrays$() {
}
$h_ju_Arrays$.prototype = $c_ju_Arrays$.prototype;
$c_ju_Arrays$.prototype.sort__AI__V = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$IntArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$IntArrayOps$();
  var end = $n(a).u.length;
  if ((end > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_I(length), 0, end, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, 0, end, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AI__I__I__V = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$IntArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$IntArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((fromIndex < 0)) {
    $n(a).get(fromIndex);
  }
  if ((toIndex > 0)) {
    var i = (((-1) + toIndex) | 0);
    $n(a).get(i);
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_I(length), fromIndex, toIndex, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, fromIndex, toIndex, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AJ__V = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$LongArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$LongArrayOps$();
  var end = $n(a).u.length;
  if ((end > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_J(length), 0, end, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, 0, end, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AJ__I__I__V = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$LongArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$LongArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((fromIndex < 0)) {
    $n(a).get(fromIndex);
  }
  if ((toIndex > 0)) {
    var i = (((-1) + toIndex) | 0);
    $n(a).get(i);
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_J(length), fromIndex, toIndex, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, fromIndex, toIndex, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AS__V = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$ShortArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$ShortArrayOps$();
  var end = $n(a).u.length;
  if ((end > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_S(length), 0, end, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, 0, end, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AS__I__I__V = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$ShortArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$ShortArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((fromIndex < 0)) {
    $n(a).get(fromIndex);
  }
  if ((toIndex > 0)) {
    var i = (((-1) + toIndex) | 0);
    $n(a).get(i);
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_S(length), fromIndex, toIndex, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, fromIndex, toIndex, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AC__V = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$CharArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$CharArrayOps$();
  var end = $n(a).u.length;
  if ((end > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_C(length), 0, end, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, 0, end, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AC__I__I__V = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$CharArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$CharArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((fromIndex < 0)) {
    $n(a).get(fromIndex);
  }
  if ((toIndex > 0)) {
    var i = (((-1) + toIndex) | 0);
    $n(a).get(i);
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_C(length), fromIndex, toIndex, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, fromIndex, toIndex, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AB__V = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$ByteArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$ByteArrayOps$();
  var end = $n(a).u.length;
  if ((end > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_B(length), 0, end, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, 0, end, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AB__I__I__V = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$ByteArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$ByteArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((fromIndex < 0)) {
    $n(a).get(fromIndex);
  }
  if ((toIndex > 0)) {
    var i = (((-1) + toIndex) | 0);
    $n(a).get(i);
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_B(length), fromIndex, toIndex, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, fromIndex, toIndex, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AO__ju_Comparator__V = (function(array, comparator) {
  var comparator$1 = ((comparator === null) ? $m_ju_Arrays$NaturalComparator$() : comparator);
  var ops = $m_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$();
  var end = $n(array).u.length;
  if ((end > 16)) {
    var length = $n(array).u.length;
    var this$2 = $n(array);
    var clazz = $objectGetClass(this$2);
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(array, $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__I__O(clazz.getComponentType__jl_Class(), length), 1), 0, end, comparator$1, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(array, 0, end, comparator$1, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AO__I__I__ju_Comparator__V = (function(array, fromIndex, toIndex, comparator) {
  var comparator$1 = ((comparator === null) ? $m_ju_Arrays$NaturalComparator$() : comparator);
  var ops = $m_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((fromIndex < 0)) {
    $n(array).get(fromIndex);
  }
  if ((toIndex > 0)) {
    var i = (((-1) + toIndex) | 0);
    $n(array).get(i);
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    var length = $n(array).u.length;
    var this$2 = $n(array);
    var clazz = $objectGetClass(this$2);
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(array, $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__I__O(clazz.getComponentType__jl_Class(), length), 1), fromIndex, toIndex, comparator$1, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(array, fromIndex, toIndex, comparator$1, ops);
  }
});
$c_ju_Arrays$.prototype.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V = (function(a, temp, start, end, comparator, ops) {
  var length = ((end - start) | 0);
  if ((length > 16)) {
    var middle = ((start + ((length / 2) | 0)) | 0);
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, temp, start, middle, comparator, ops);
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, temp, middle, end, comparator, ops);
    var outIndex = start;
    var leftInIndex = start;
    var rightInIndex = middle;
    while ((outIndex < end)) {
      if (((leftInIndex < middle) && ((rightInIndex >= end) || ($n(comparator).compare__O__O__I($n(ops).get__O__I__O(a, leftInIndex), $n(ops).get__O__I__O(a, rightInIndex)) <= 0)))) {
        $n(ops).set__O__I__O__V(temp, outIndex, $n(ops).get__O__I__O(a, leftInIndex));
        leftInIndex = ((1 + leftInIndex) | 0);
      } else {
        $n(ops).set__O__I__O__V(temp, outIndex, $n(ops).get__O__I__O(a, rightInIndex));
        rightInIndex = ((1 + rightInIndex) | 0);
      }
      outIndex = ((1 + outIndex) | 0);
    }
    $systemArraycopyFull($n(temp), start, $n(a), start, length);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, start, end, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V = (function(a, start, end, comparator, ops) {
  var n = ((end - start) | 0);
  if ((n >= 2)) {
    var aStart = $n(ops).get__O__I__O(a, start);
    var aStartPlusOne = $n(ops).get__O__I__O(a, ((1 + start) | 0));
    if (($n(comparator).compare__O__O__I(aStart, aStartPlusOne) > 0)) {
      $n(ops).set__O__I__O__V(a, start, aStartPlusOne);
      $n(ops).set__O__I__O__V(a, ((1 + start) | 0), aStart);
    }
    var m = 2;
    while ((m < n)) {
      var next = $n(ops).get__O__I__O(a, ((start + m) | 0));
      if (($n(comparator).compare__O__O__I(next, $n(ops).get__O__I__O(a, (((-1) + ((start + m) | 0)) | 0))) < 0)) {
        var iA = start;
        var iB = (((-1) + ((start + m) | 0)) | 0);
        while ((((iB - iA) | 0) > 1)) {
          var ix = ((((iA + iB) | 0) >>> 1) | 0);
          if (($n(comparator).compare__O__O__I(next, $n(ops).get__O__I__O(a, ix)) < 0)) {
            iB = ix;
          } else {
            iA = ix;
          }
        }
        var ix$2 = ((iA + (($n(comparator).compare__O__O__I(next, $n(ops).get__O__I__O(a, iA)) < 0) ? 0 : 1)) | 0);
        var i = ((start + m) | 0);
        while ((i > ix$2)) {
          $n(ops).set__O__I__O__V(a, i, $n(ops).get__O__I__O(a, (((-1) + i) | 0)));
          i = (((-1) + i) | 0);
        }
        $n(ops).set__O__I__O__V(a, ix$2, next);
      }
      m = ((1 + m) | 0);
    }
  }
});
$c_ju_Arrays$.prototype.binarySearch__AJ__J__I = (function(a, key) {
  var startIndex = 0;
  var endIndex = $n(a).u.length;
  while (true) {
    if ((startIndex === endIndex)) {
      return (((-1) - startIndex) | 0);
    } else {
      var mid = ((((startIndex + endIndex) | 0) >>> 1) | 0);
      var t = $n(a).get(mid);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var t$1 = $uJ(new $c_RTLong(lo, hi));
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      var cmp = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(key.RTLong__f_lo, key.RTLong__f_hi, lo$1, hi$1);
      if ((cmp < 0)) {
        endIndex = mid;
      } else if ((cmp === 0)) {
        return mid;
      } else {
        startIndex = ((1 + mid) | 0);
      }
    }
  }
});
$c_ju_Arrays$.prototype.binarySearch__AI__I__I = (function(a, key) {
  var startIndex = 0;
  var endIndex = $n(a).u.length;
  while (true) {
    if ((startIndex === endIndex)) {
      return (((-1) - startIndex) | 0);
    } else {
      var mid = ((((startIndex + endIndex) | 0) >>> 1) | 0);
      var elem = $n(a).get(mid);
      var cmp = ((key === elem) ? 0 : ((key < elem) ? (-1) : 1));
      if ((cmp < 0)) {
        endIndex = mid;
      } else if ((cmp === 0)) {
        return mid;
      } else {
        startIndex = ((1 + mid) | 0);
      }
    }
  }
});
$c_ju_Arrays$.prototype.equals__AJ__AJ__Z = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = $n(a).u.length;
  if (($n(b).u.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var t = $n(a).get(i$1);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var i$2 = i;
    var t$1 = $n(b).get(i$2);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    if ((!((lo === lo$1) && (hi === hi$1)))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$c_ju_Arrays$.prototype.equals__AI__AI__Z = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = $n(a).u.length;
  if (($n(b).u.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var a$1 = $n(a).get(i$1);
    var i$2 = i;
    var b$1 = $n(b).get(i$2);
    if ((!(a$1 === b$1))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$c_ju_Arrays$.prototype.equals__AS__AS__Z = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = $n(a).u.length;
  if (($n(b).u.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var a$1 = $n(a).get(i$1);
    var i$2 = i;
    var b$1 = $n(b).get(i$2);
    if ((!(a$1 === b$1))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$c_ju_Arrays$.prototype.equals__AC__AC__Z = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = $n(a).u.length;
  if (($n(b).u.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var a$1 = $n(a).get(i$1);
    var i$2 = i;
    var b$1 = $n(b).get(i$2);
    if ((!(a$1 === b$1))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$c_ju_Arrays$.prototype.equals__AB__AB__Z = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = $n(a).u.length;
  if (($n(b).u.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var a$1 = $n(a).get(i$1);
    var i$2 = i;
    var b$1 = $n(b).get(i$2);
    if ((!(a$1 === b$1))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$c_ju_Arrays$.prototype.equals__AZ__AZ__Z = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = $n(a).u.length;
  if (($n(b).u.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var a$1 = $n(a).get(i$1);
    var i$2 = i;
    var b$1 = $n(b).get(i$2);
    if ((!(a$1 === b$1))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$c_ju_Arrays$.prototype.equals__AD__AD__Z = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = $n(a).u.length;
  if (($n(b).u.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var a$1 = $n(a).get(i$1);
    var i$2 = i;
    var b$1 = $n(b).get(i$2);
    if ((!Object.is(a$1, b$1))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$c_ju_Arrays$.prototype.equals__AF__AF__Z = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = $n(a).u.length;
  if (($n(b).u.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var a$1 = $n(a).get(i$1);
    var i$2 = i;
    var b$1 = $n(b).get(i$2);
    if ((!Object.is(a$1, b$1))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$c_ju_Arrays$.prototype.fill__AJ__I__I__J__V = (function(a, fromIndex, toIndex, value) {
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((fromIndex < 0)) {
    $n(a).get(fromIndex);
  }
  if ((toIndex > 0)) {
    var i = (((-1) + toIndex) | 0);
    $n(a).get(i);
  }
  var i$1 = fromIndex;
  while ((i$1 !== toIndex)) {
    var i$2 = i$1;
    $n(a).set(i$2, value);
    i$1 = ((1 + i$1) | 0);
  }
});
$c_ju_Arrays$.prototype.fill__AO__O__V = (function(a, value) {
  var toIndex = $n(a).u.length;
  var i = 0;
  while ((i !== toIndex)) {
    var i$1 = i;
    $n(a).set(i$1, value);
    i = ((1 + i) | 0);
  }
});
$c_ju_Arrays$.prototype.copyOf__AO__I__AO = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException();
  }
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var this$3 = $n(original);
  var clazz = $objectGetClass(this$3);
  var ret = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__I__O(clazz.getComponentType__jl_Class(), newLength), 1);
  $systemArraycopyRefs($n(original), 0, $n(ret), 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AO__I__jl_Class__AO = (function(original, newLength, newType) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException();
  }
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__I__O($n(newType).getComponentType__jl_Class(), newLength), 1);
  $systemArraycopyRefs($n(original), 0, $n(ret), 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AB__I__AB = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException();
  }
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_B(newLength);
  $systemArraycopy($n(original), 0, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AS__I__AS = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException();
  }
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_S(newLength);
  $systemArraycopy($n(original), 0, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AI__I__AI = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException();
  }
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_I(newLength);
  $systemArraycopy($n(original), 0, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AJ__I__AJ = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException();
  }
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_J(newLength);
  $systemArraycopy($n(original), 0, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AC__I__AC = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException();
  }
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_C(newLength);
  $systemArraycopy($n(original), 0, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AF__I__AF = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException();
  }
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_F(newLength);
  $systemArraycopy($n(original), 0, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AD__I__AD = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException();
  }
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_D(newLength);
  $systemArraycopy($n(original), 0, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AZ__I__AZ = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException();
  }
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_Z(newLength);
  $systemArraycopy($n(original), 0, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AO__I__I__AO = (function(original, from, to) {
  if ((from > to)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((from + " > ") + to));
  }
  var len = $n(original).u.length;
  var retLength = ((to - from) | 0);
  var b = ((len - from) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var this$3 = $n(original);
  var clazz = $objectGetClass(this$3);
  var ret = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__I__O(clazz.getComponentType__jl_Class(), retLength), 1);
  $systemArraycopyRefs($n(original), from, $n(ret), 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AB__I__I__AB = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = $n(original).u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_B(retLength);
  $systemArraycopy($n(original), start, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AS__I__I__AS = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = $n(original).u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_S(retLength);
  $systemArraycopy($n(original), start, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AI__I__I__AI = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = $n(original).u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_I(retLength);
  $systemArraycopy($n(original), start, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AJ__I__I__AJ = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = $n(original).u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_J(retLength);
  $systemArraycopy($n(original), start, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AC__I__I__AC = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = $n(original).u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_C(retLength);
  $systemArraycopy($n(original), start, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AF__I__I__AF = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = $n(original).u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_F(retLength);
  $systemArraycopy($n(original), start, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AD__I__I__AD = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = $n(original).u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_D(retLength);
  $systemArraycopy($n(original), start, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AZ__I__I__AZ = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = $n(original).u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_Z(retLength);
  $systemArraycopy($n(original), start, ret, 0, copyLength);
  return ret;
});
var $d_ju_Arrays$ = new $TypeData().initClass($c_ju_Arrays$, "java.util.Arrays$", ({
  ju_Arrays$: 1
}));
var $n_ju_Arrays$;
function $m_ju_Arrays$() {
  if ((!$n_ju_Arrays$)) {
    $n_ju_Arrays$ = new $c_ju_Arrays$();
  }
  return $n_ju_Arrays$;
}
function $is_ju_Formattable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Formattable)));
}
function $as_ju_Formattable(obj) {
  return (($is_ju_Formattable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Formattable"));
}
function $isArrayOf_ju_Formattable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Formattable)));
}
function $asArrayOf_ju_Formattable(obj, depth) {
  return (($isArrayOf_ju_Formattable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Formattable;", depth));
}
/** @constructor */
function $c_ju_Formatter$() {
  this.ju_Formatter$__f_java$util$Formatter$$FormatSpecifier = null;
  this.ju_Formatter$__f_java$util$Formatter$$ConversionsIllegalFlags = null;
  $n_ju_Formatter$ = this;
  this.ju_Formatter$__f_java$util$Formatter$$FormatSpecifier = new RegExp("(?:(\\d+)\\$)?([-#+ 0,\\(<]*)(\\d+)?(?:\\.(\\d+))?[%A-Za-z]", "g");
  this.ju_Formatter$__f_java$util$Formatter$$ConversionsIllegalFlags = new $ac_I(new Int32Array([96, 126, 638, 770, 32, 256, 2, 126, (-1), (-1), (-1), (-1), (-1), (-1), 800, (-1), (-1), (-1), 124, (-1), (-1), (-1), (-1), 544, (-1), (-1)]));
}
$c_ju_Formatter$.prototype = new $h_O();
$c_ju_Formatter$.prototype.constructor = $c_ju_Formatter$;
/** @constructor */
function $h_ju_Formatter$() {
}
$h_ju_Formatter$.prototype = $c_ju_Formatter$.prototype;
$c_ju_Formatter$.prototype.java$util$Formatter$$strOfZeros__I__T = (function(count) {
  if ((count <= 20)) {
    if ((count > 20)) {
      $charAt("00000000000000000000", count);
    }
    if ((count < 0)) {
      $charAt("00000000000000000000", (-1));
    }
    return $as_T("00000000000000000000".substring(0, count));
  } else {
    var result = "";
    var remaining = count;
    while ((remaining > 20)) {
      result = (result + "00000000000000000000");
      remaining = (((-20) + remaining) | 0);
    }
    var $x_1 = result;
    var endIndex = remaining;
    if ((endIndex > 20)) {
      $charAt("00000000000000000000", endIndex);
    }
    if ((endIndex < 0)) {
      $charAt("00000000000000000000", (-1));
    }
    return (("" + $x_1) + $as_T("00000000000000000000".substring(0, endIndex)));
  }
});
$c_ju_Formatter$.prototype.java$util$Formatter$$numberToDecimal__D__ju_Formatter$Decimal = (function(x) {
  if ((x === 0.0)) {
    var negative = ((1.0 / x) < 0.0);
    return new $c_ju_Formatter$Decimal(negative, "0", 0);
  } else {
    var negative$2 = (x < 0.0);
    var d = (negative$2 ? (-x) : x);
    var s = ("" + d);
    var ePos = $f_T__indexOf__I__I(s, 101);
    if ((ePos < 0)) {
      var e = 0;
    } else {
      var $x_2 = parseInt;
      var beginIndex = ((1 + ePos) | 0);
      if (((beginIndex < 0) || (beginIndex > s.length))) {
        $charAt(s, beginIndex);
      }
      var $x_1 = $x_2($as_T(s.substring(beginIndex)));
      var e = $uI($x_1);
    }
    var significandEnd = ((ePos < 0) ? s.length : ePos);
    var dotPos = $f_T__indexOf__I__I(s, 46);
    if ((dotPos < 0)) {
      if ((significandEnd > s.length)) {
        $charAt(s, significandEnd);
      }
      if ((significandEnd < 0)) {
        $charAt(s, (-1));
      }
      var unscaledValue = $as_T(s.substring(0, significandEnd));
      var scale = ((-e) | 0);
      return new $c_ju_Formatter$Decimal(negative$2, unscaledValue, scale);
    } else {
      if ((dotPos > s.length)) {
        $charAt(s, dotPos);
      }
      if ((dotPos < 0)) {
        $charAt(s, (-1));
      }
      var $x_3 = $as_T(s.substring(0, dotPos));
      var beginIndex$1 = ((1 + dotPos) | 0);
      if ((beginIndex$1 < 0)) {
        $charAt(s, beginIndex$1);
      }
      if ((significandEnd > s.length)) {
        $charAt(s, significandEnd);
      }
      if ((significandEnd < beginIndex$1)) {
        $charAt(s, (-1));
      }
      var digits = (("" + $x_3) + $as_T(s.substring(beginIndex$1, significandEnd)));
      var digitsLen = digits.length;
      var i = 0;
      while (true) {
        if ((i < digitsLen)) {
          var index = i;
          var $x_4 = ($charAt(digits, index) === 48);
        } else {
          var $x_4 = false;
        }
        if ($x_4) {
          i = ((1 + i) | 0);
        } else {
          break;
        }
      }
      var beginIndex$2 = i;
      if (((beginIndex$2 < 0) || (beginIndex$2 > digits.length))) {
        $charAt(digits, beginIndex$2);
      }
      var unscaledValue$2 = $as_T(digits.substring(beginIndex$2));
      var scale$2 = ((((-e) | 0) + ((significandEnd - ((1 + dotPos) | 0)) | 0)) | 0);
      return new $c_ju_Formatter$Decimal(negative$2, unscaledValue$2, scale$2);
    }
  }
});
$c_ju_Formatter$.prototype.java$util$Formatter$$bigDecimalToDecimal__Ljava_math_BigDecimal__ju_Formatter$Decimal = (function(x) {
  var this$1 = $n(x);
  var this$2 = $n(this$1.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
  var unscaledValueWithSign = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$2);
  if ((unscaledValueWithSign === "0")) {
    return new $c_ju_Formatter$Decimal(false, "0", 0);
  } else {
    var this$4 = $n(unscaledValueWithSign);
    var negative = ($charAt(this$4, 0) === 45);
    if (negative) {
      var this$5 = $n(unscaledValueWithSign);
      if ((this$5.length < 1)) {
        $charAt(this$5, 1);
      }
      var unscaledValue = $as_T(this$5.substring(1));
    } else {
      var unscaledValue = unscaledValueWithSign;
    }
    var this$6 = $n(x);
    var scale = this$6.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    return new $c_ju_Formatter$Decimal(negative, unscaledValue, scale);
  }
});
var $d_ju_Formatter$ = new $TypeData().initClass($c_ju_Formatter$, "java.util.Formatter$", ({
  ju_Formatter$: 1
}));
var $n_ju_Formatter$;
function $m_ju_Formatter$() {
  if ((!$n_ju_Formatter$)) {
    $n_ju_Formatter$ = new $c_ju_Formatter$();
  }
  return $n_ju_Formatter$;
}
function $p_ju_Formatter$Decimal__roundAtPos__I__ju_Formatter$Decimal($thiz, roundingPos) {
  var digits = $thiz.ju_Formatter$Decimal__f_unscaledValue;
  var this$1 = $n(digits);
  var digitsLen = this$1.length;
  if ((roundingPos < 0)) {
    var negative = $thiz.ju_Formatter$Decimal__f_negative;
    return new $c_ju_Formatter$Decimal(negative, "0", 0);
  } else if ((roundingPos >= digitsLen)) {
    return $thiz;
  } else {
    var this$3 = $n(digits);
    if (($charAt(this$3, roundingPos) < 53)) {
      if ((roundingPos === 0)) {
        var negative$1 = $thiz.ju_Formatter$Decimal__f_negative;
        return new $c_ju_Formatter$Decimal(negative$1, "0", 0);
      } else {
        var $x_1 = $thiz.ju_Formatter$Decimal__f_negative;
        var this$5 = $n(digits);
        if ((roundingPos > this$5.length)) {
          $charAt(this$5, roundingPos);
        }
        if ((roundingPos < 0)) {
          $charAt(this$5, (-1));
        }
        return new $c_ju_Formatter$Decimal($x_1, $as_T(this$5.substring(0, roundingPos)), (($thiz.ju_Formatter$Decimal__f_scale - ((digitsLen - roundingPos) | 0)) | 0));
      }
    } else {
      var lastNonNinePos = (((-1) + roundingPos) | 0);
      while (true) {
        if ((lastNonNinePos >= 0)) {
          var this$6 = $n(digits);
          var index = lastNonNinePos;
          var $x_2 = ($charAt(this$6, index) === 57);
        } else {
          var $x_2 = false;
        }
        if ($x_2) {
          lastNonNinePos = (((-1) + lastNonNinePos) | 0);
        } else {
          break;
        }
      }
      if ((lastNonNinePos < 0)) {
        var newUnscaledValue = "1";
      } else {
        var this$7 = $n(digits);
        var endIndex = lastNonNinePos;
        if ((endIndex > this$7.length)) {
          $charAt(this$7, endIndex);
        }
        if ((endIndex < 0)) {
          $charAt(this$7, (-1));
        }
        var $x_3 = $as_T(this$7.substring(0, endIndex));
        var this$8 = $n(digits);
        var index$1 = lastNonNinePos;
        var newUnscaledValue = ($x_3 + $cToS((65535 & ((1 + $charAt(this$8, index$1)) | 0))));
      }
      var pos = ((1 + lastNonNinePos) | 0);
      var newScale = (($thiz.ju_Formatter$Decimal__f_scale - ((digitsLen - pos) | 0)) | 0);
      return new $c_ju_Formatter$Decimal($thiz.ju_Formatter$Decimal__f_negative, newUnscaledValue, newScale);
    }
  }
}
/** @constructor */
function $c_ju_Formatter$Decimal(negative, unscaledValue, scale) {
  this.ju_Formatter$Decimal__f_negative = false;
  this.ju_Formatter$Decimal__f_unscaledValue = null;
  this.ju_Formatter$Decimal__f_scale = 0;
  this.ju_Formatter$Decimal__f_negative = negative;
  this.ju_Formatter$Decimal__f_unscaledValue = unscaledValue;
  this.ju_Formatter$Decimal__f_scale = scale;
}
$c_ju_Formatter$Decimal.prototype = new $h_O();
$c_ju_Formatter$Decimal.prototype.constructor = $c_ju_Formatter$Decimal;
/** @constructor */
function $h_ju_Formatter$Decimal() {
}
$h_ju_Formatter$Decimal.prototype = $c_ju_Formatter$Decimal.prototype;
$c_ju_Formatter$Decimal.prototype.isZero__Z = (function() {
  return (this.ju_Formatter$Decimal__f_unscaledValue === "0");
});
$c_ju_Formatter$Decimal.prototype.round__I__ju_Formatter$Decimal = (function(precision) {
  $m_ju_Formatter$();
  var condition = (precision > 0);
  if ((!condition)) {
    throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "Decimal.round() called with non-positive precision");
  }
  return $p_ju_Formatter$Decimal__roundAtPos__I__ju_Formatter$Decimal(this, precision);
});
$c_ju_Formatter$Decimal.prototype.setScale__I__ju_Formatter$Decimal = (function(newScale) {
  var this$1 = $n(this.ju_Formatter$Decimal__f_unscaledValue);
  var roundingPos = ((((this$1.length + newScale) | 0) - this.ju_Formatter$Decimal__f_scale) | 0);
  var rounded = $p_ju_Formatter$Decimal__roundAtPos__I__ju_Formatter$Decimal(this, roundingPos);
  $m_ju_Formatter$();
  var condition = ($n(rounded).isZero__Z() || ($n(rounded).ju_Formatter$Decimal__f_scale <= newScale));
  if ((!condition)) {
    throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "roundAtPos returned a non-zero value with a scale too large");
  }
  return (($n(rounded).isZero__Z() || ($n(rounded).ju_Formatter$Decimal__f_scale === newScale)) ? rounded : new $c_ju_Formatter$Decimal(this.ju_Formatter$Decimal__f_negative, (("" + $n(rounded).ju_Formatter$Decimal__f_unscaledValue) + $m_ju_Formatter$().java$util$Formatter$$strOfZeros__I__T(((newScale - $n(rounded).ju_Formatter$Decimal__f_scale) | 0))), newScale));
});
$c_ju_Formatter$Decimal.prototype.toString__T = (function() {
  return (((((("Decimal(" + this.ju_Formatter$Decimal__f_negative) + ", ") + this.ju_Formatter$Decimal__f_unscaledValue) + ", ") + this.ju_Formatter$Decimal__f_scale) + ")");
});
var $d_ju_Formatter$Decimal = new $TypeData().initClass($c_ju_Formatter$Decimal, "java.util.Formatter$Decimal", ({
  ju_Formatter$Decimal: 1
}));
/** @constructor */
function $c_ju_Formatter$LocaleInfo() {
}
$c_ju_Formatter$LocaleInfo.prototype = new $h_O();
$c_ju_Formatter$LocaleInfo.prototype.constructor = $c_ju_Formatter$LocaleInfo;
/** @constructor */
function $h_ju_Formatter$LocaleInfo() {
}
$h_ju_Formatter$LocaleInfo.prototype = $c_ju_Formatter$LocaleInfo.prototype;
function $is_ju_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Map)));
}
function $as_ju_Map(obj) {
  return (($is_ju_Map(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Map"));
}
function $isArrayOf_ju_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Map)));
}
function $asArrayOf_ju_Map(obj, depth) {
  return (($isArrayOf_ju_Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Map;", depth));
}
function $is_ju_Map$Entry(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Map$Entry)));
}
function $as_ju_Map$Entry(obj) {
  return (($is_ju_Map$Entry(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Map$Entry"));
}
function $isArrayOf_ju_Map$Entry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Map$Entry)));
}
function $asArrayOf_ju_Map$Entry(obj, depth) {
  return (($isArrayOf_ju_Map$Entry(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Map$Entry;", depth));
}
/** @constructor */
function $c_ju_ScalaOps$SimpleRange(start, end) {
  this.ju_ScalaOps$SimpleRange__f_java$util$ScalaOps$SimpleRange$$start = 0;
  this.ju_ScalaOps$SimpleRange__f_java$util$ScalaOps$SimpleRange$$end = 0;
  this.ju_ScalaOps$SimpleRange__f_java$util$ScalaOps$SimpleRange$$start = start;
  this.ju_ScalaOps$SimpleRange__f_java$util$ScalaOps$SimpleRange$$end = end;
}
$c_ju_ScalaOps$SimpleRange.prototype = new $h_O();
$c_ju_ScalaOps$SimpleRange.prototype.constructor = $c_ju_ScalaOps$SimpleRange;
/** @constructor */
function $h_ju_ScalaOps$SimpleRange() {
}
$h_ju_ScalaOps$SimpleRange.prototype = $c_ju_ScalaOps$SimpleRange.prototype;
var $d_ju_ScalaOps$SimpleRange = new $TypeData().initClass($c_ju_ScalaOps$SimpleRange, "java.util.ScalaOps$SimpleRange", ({
  ju_ScalaOps$SimpleRange: 1
}));
/** @constructor */
function $c_ju_internal_MurmurHash3$() {
}
$c_ju_internal_MurmurHash3$.prototype = new $h_O();
$c_ju_internal_MurmurHash3$.prototype.constructor = $c_ju_internal_MurmurHash3$;
/** @constructor */
function $h_ju_internal_MurmurHash3$() {
}
$h_ju_internal_MurmurHash3$.prototype = $c_ju_internal_MurmurHash3$.prototype;
$c_ju_internal_MurmurHash3$.prototype.mix__I__I__I = (function(hash, data) {
  var h = this.mixLast__I__I__I(hash, data);
  var i = h;
  h = ((i << 13) | ((i >>> 19) | 0));
  return (((-430675100) + Math.imul(5, h)) | 0);
});
$c_ju_internal_MurmurHash3$.prototype.mixLast__I__I__I = (function(hash, data) {
  var k = data;
  k = Math.imul((-862048943), k);
  var i = k;
  k = ((i << 15) | ((i >>> 17) | 0));
  k = Math.imul(461845907, k);
  return (hash ^ k);
});
$c_ju_internal_MurmurHash3$.prototype.finalizeHash__I__I__I = (function(hash, length) {
  var hash$1 = (hash ^ length);
  var h = hash$1;
  h = (h ^ ((h >>> 16) | 0));
  h = Math.imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = Math.imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h;
});
var $d_ju_internal_MurmurHash3$ = new $TypeData().initClass($c_ju_internal_MurmurHash3$, "java.util.internal.MurmurHash3$", ({
  ju_internal_MurmurHash3$: 1
}));
var $n_ju_internal_MurmurHash3$;
function $m_ju_internal_MurmurHash3$() {
  if ((!$n_ju_internal_MurmurHash3$)) {
    $n_ju_internal_MurmurHash3$ = new $c_ju_internal_MurmurHash3$();
  }
  return $n_ju_internal_MurmurHash3$;
}
function $p_ju_regex_PatternCompiler__parseError__T__E($thiz, desc) {
  throw new $c_ju_regex_PatternSyntaxException(desc, $thiz.ju_regex_PatternCompiler__f_pattern, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
}
function $p_ju_regex_PatternCompiler__processLeadingEmbeddedFlags__V($thiz) {
  var m = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$leadingEmbeddedFlagSpecifierRegExp.exec($thiz.ju_regex_PatternCompiler__f_pattern);
  if ((m !== null)) {
    var x = m[1];
    if ((x !== (void 0))) {
      var chars = $as_T(x);
      var this$3 = $n(chars);
      var end = this$3.length;
      var i = 0;
      while ((i < end)) {
        var i$2 = i;
        var $x_2 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags;
        var $x_1 = $m_ju_regex_PatternCompiler$();
        var this$5 = $n(chars);
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = ($x_2 | $n($x_1).java$util$regex$PatternCompiler$$charToFlag__C__I($charAt(this$5, i$2)));
        i = ((1 + i) | 0);
      }
    }
    if (((256 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = (64 | $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags);
    }
    var x$1 = m[2];
    if ((x$1 !== (void 0))) {
      var chars$3 = $as_T(x$1);
      var this$8 = $n(chars$3);
      var end$1 = this$8.length;
      var i$1 = 0;
      while ((i$1 < end$1)) {
        var i$2$1 = i$1;
        var $x_4 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags;
        var $x_3 = $m_ju_regex_PatternCompiler$();
        var this$10 = $n(chars$3);
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = ($x_4 & (~$n($x_3).java$util$regex$PatternCompiler$$charToFlag__C__I($charAt(this$10, i$2$1))));
        i$1 = ((1 + i$1) | 0);
      }
    }
    var $x_5 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    var x$2 = m[0];
    var this$12 = $n($as_T(x$2));
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($x_5 + this$12.length) | 0);
  }
}
function $p_ju_regex_PatternCompiler__literal__T__T($thiz, s) {
  var result = "";
  var this$1 = $n(s);
  var len = this$1.length;
  var i = 0;
  while ((i !== len)) {
    var cp = $f_T__codePointAt__I__I($n(s), i);
    result = (("" + result) + $p_ju_regex_PatternCompiler__literal__I__T($thiz, cp));
    i = ((i + ((cp >= 65536) ? 2 : 1)) | 0);
  }
  return result;
}
function $p_ju_regex_PatternCompiler__literal__I__T($thiz, cp) {
  var s = $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(cp);
  if ((cp < 128)) {
    switch (cp) {
      case 94:
      case 36:
      case 92:
      case 46:
      case 42:
      case 43:
      case 63:
      case 40:
      case 41:
      case 91:
      case 93:
      case 123:
      case 125:
      case 124: {
        return ("\\" + s);
        break;
      }
      default: {
        return (((66 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 2) ? s : (((cp >= 65) && (cp <= 90)) ? ((("[" + s) + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(((32 + cp) | 0))) + "]") : (((cp >= 97) && (cp <= 122)) ? ((("[" + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T((((-32) + cp) | 0))) + s) + "]") : s)));
      }
    }
  } else {
    return ((((-1024) & cp) === 56320) ? (("(?:" + s) + ")") : s);
  }
}
function $p_ju_regex_PatternCompiler__skipComments__V($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  while (true) {
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
      var this$2 = $n(pattern);
      var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var x1 = $charAt(this$2, index);
      switch (x1) {
        case 32:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          continue;
          break;
        }
        case 35: {
          $thiz.java$util$regex$PatternCompiler$$skipSharpComment__V();
          continue;
          break;
        }
      }
    }
    break;
  }
}
function $p_ju_regex_PatternCompiler__compileRepeater__I__T__T($thiz, compiledGroupCountBeforeThisToken, compiledToken) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  var startOfRepeater = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  if ((startOfRepeater === len)) {
    var repeaterDispatchChar = 46;
  } else {
    var this$2 = $n(pattern);
    var repeaterDispatchChar = $charAt(this$2, startOfRepeater);
  }
  if (((((repeaterDispatchChar === 63) || (repeaterDispatchChar === 42)) || (repeaterDispatchChar === 43)) || (repeaterDispatchChar === 123))) {
    var this$3 = $n(compiledToken);
    var x1 = $charAt(this$3, 0);
    switch (x1) {
      case 94:
      case 36: {
        var isTokenAnAssertion = true;
        break;
      }
      case 40: {
        var this$4 = $n(compiledToken);
        if (($charAt(this$4, 1) === 63)) {
          var this$5 = $n(compiledToken);
          var isTokenAnAssertion = ($charAt(this$5, 2) !== 58);
        } else {
          var isTokenAnAssertion = false;
        }
        break;
      }
      case 92: {
        var this$6 = $n(compiledToken);
        var c = $charAt(this$6, 1);
        var isTokenAnAssertion = ((c === 98) || (c === 66));
        break;
      }
      default: {
        var isTokenAnAssertion = false;
      }
    }
    var wrappedToken = (isTokenAnAssertion ? (("(?:" + compiledToken) + ")") : compiledToken);
    var baseRepeater = $p_ju_regex_PatternCompiler__parseBaseRepeater__C__T($thiz, repeaterDispatchChar);
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
      var this$7 = $n(pattern);
      var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var x1$2 = $charAt(this$7, index);
      switch (x1$2) {
        case 43: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          return $p_ju_regex_PatternCompiler__buildPossessiveQuantifier__I__T__T__T($thiz, compiledGroupCountBeforeThisToken, wrappedToken, baseRepeater);
          break;
        }
        case 63: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          return ((("" + wrappedToken) + baseRepeater) + "?");
          break;
        }
        default: {
          return (("" + wrappedToken) + baseRepeater);
        }
      }
    } else {
      return (("" + wrappedToken) + baseRepeater);
    }
  } else {
    return compiledToken;
  }
}
function $p_ju_regex_PatternCompiler__parseBaseRepeater__C__T($thiz, repeaterDispatchChar) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var startOfRepeater = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  if ((repeaterDispatchChar === 123)) {
    var this$1 = $n(pattern);
    var len = this$1.length;
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
      var $x_1 = true;
    } else {
      var this$2 = $n(pattern);
      var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var c = $charAt(this$2, index);
      var $x_1 = (!((c >= 48) && (c <= 57)));
    }
    if ($x_1) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal repetition");
    }
    while (true) {
      if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
        var this$4 = $n(pattern);
        var index$1 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
        var c$1 = $charAt(this$4, index$1);
        var $x_2 = ((c$1 >= 48) && (c$1 <= 57));
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      } else {
        break;
      }
    }
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal repetition");
    }
    var this$6 = $n(pattern);
    var index$2 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    if (($charAt(this$6, index$2) === 44)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      while (true) {
        if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
          var this$7 = $n(pattern);
          var index$3 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
          var c$2 = $charAt(this$7, index$3);
          var $x_3 = ((c$2 >= 48) && (c$2 <= 57));
        } else {
          var $x_3 = false;
        }
        if ($x_3) {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
        } else {
          break;
        }
      }
    }
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
      var $x_4 = true;
    } else {
      var this$9 = $n(pattern);
      var index$4 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var $x_4 = ($charAt(this$9, index$4) !== 125);
    }
    if ($x_4) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal repetition");
    }
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  }
  return $as_T(pattern.substring(startOfRepeater, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex));
}
function $p_ju_regex_PatternCompiler__buildPossessiveQuantifier__I__T__T__T($thiz, compiledGroupCountBeforeThisToken, compiledToken, baseRepeater) {
  var end = $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length);
  var i = 0;
  while ((i < end)) {
    var i$2 = i;
    var mapped = $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap[i$2]);
    if ((mapped > compiledGroupCountBeforeThisToken)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap[i$2] = ((1 + mapped) | 0);
    }
    i = ((1 + i) | 0);
  }
  var amendedToken = $as_T(compiledToken.replace($m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$renumberingRegExp, ((arg1$2, arg2$2, arg3$2) => {
    var arg1 = $as_T(arg1$2);
    var arg2 = $as_T(arg2$2);
    var arg3 = $as_T(arg3$2);
    return $thiz.java$util$regex$PatternCompiler$$$anonfun$buildPossessiveQuantifier$2__T__T__T__I__T(arg1, arg2, arg3, compiledGroupCountBeforeThisToken);
  })));
  $thiz.ju_regex_PatternCompiler__f_compiledGroupCount = ((1 + $thiz.ju_regex_PatternCompiler__f_compiledGroupCount) | 0);
  var myGroupNumber = ((1 + compiledGroupCountBeforeThisToken) | 0);
  return ((((("(?:(?=(" + amendedToken) + baseRepeater) + "))\\") + myGroupNumber) + ")");
}
function $p_ju_regex_PatternCompiler__compileEscape__T($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  if ((((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0) === len)) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\ at end of pattern");
  }
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  var this$2 = $n(pattern);
  var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  var dispatchChar = $charAt(this$2, index);
  switch (dispatchChar) {
    case 100:
    case 68:
    case 104:
    case 72:
    case 115:
    case 83:
    case 118:
    case 86:
    case 119:
    case 87:
    case 112:
    case 80: {
      var cls = $p_ju_regex_PatternCompiler__parsePredefinedCharacterClass__C__ju_regex_PatternCompiler$CompiledCharClass($thiz, dispatchChar);
      var x1$2 = $n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_kind;
      switch (x1$2) {
        case 0: {
          return (("\\p{" + $n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_data) + "}");
          break;
        }
        case 1: {
          return (("\\P{" + $n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_data) + "}");
          break;
        }
        case 2: {
          return (("[" + $n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_data) + "]");
          break;
        }
        case 3: {
          return $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointNotAmong__T__T($n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_data);
          break;
        }
        default: {
          throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), x1$2);
        }
      }
      break;
    }
    case 98: {
      if (($as_T(pattern.substring($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex, ((4 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0))) === "b{g}")) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\b{g} is not supported");
      } else if (((320 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
        $thiz.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("\\b with UNICODE_CASE", "2018");
      } else {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
        return "\\b";
      }
      break;
    }
    case 66: {
      if (((320 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
        $thiz.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("\\B with UNICODE_CASE", "2018");
      } else {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
        return "\\B";
      }
      break;
    }
    case 65: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return "^";
      break;
    }
    case 71: {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\G in the middle of a pattern is not supported");
      break;
    }
    case 90: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      var lineTerminator = (((1 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0) ? "\n" : "(?:\r\n?|[\n\u0085\u2028\u2029])");
      return (("(?=" + lineTerminator) + "?$)");
      break;
    }
    case 122: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return "$";
      break;
    }
    case 82: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return "(?:\r\n|[\n-\r\u0085\u2028\u2029])";
      break;
    }
    case 88: {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\X is not supported");
      break;
    }
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57: {
      var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var end = ((1 + start) | 0);
      while (true) {
        if ((end !== len)) {
          var this$7 = $n(pattern);
          var index$1 = end;
          var c = $charAt(this$7, index$1);
          var $x_2 = ((c >= 48) && (c <= 57));
        } else {
          var $x_2 = false;
        }
        if ($x_2) {
          var s = $as_T(pattern.substring(start, ((1 + end) | 0)));
          var $x_1 = ($uI(parseInt(s, 10)) <= (((-1) + $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length)) | 0));
        } else {
          var $x_1 = false;
        }
        if ($x_1) {
          end = ((1 + end) | 0);
        } else {
          break;
        }
      }
      var groupString = $as_T(pattern.substring(start, end));
      var groupNumber = $uI(parseInt(groupString, 10));
      if ((groupNumber > (((-1) + $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length)) | 0))) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("numbered capturing group <" + groupNumber) + "> does not exist"));
      }
      var compiledGroupNumber = $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap[groupNumber]);
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = end;
      return (("(?:\\" + compiledGroupNumber) + ")");
      break;
    }
    case 107: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
        var $x_3 = true;
      } else {
        var this$11 = $n(pattern);
        var index$2 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
        var $x_3 = ($charAt(this$11, index$2) !== 60);
      }
      if ($x_3) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\k is not followed by '<' for named capturing group");
      }
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      var groupName = $p_ju_regex_PatternCompiler__parseGroupName__T($thiz);
      var dict = $thiz.ju_regex_PatternCompiler__f_namedGroups;
      if ((!$uZ($m_jl_Utils$Cache$().jl_Utils$Cache$__f_safeHasOwnProperty.call(dict, groupName)))) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("named capturing group <" + groupName) + "> does not exit"));
      }
      var groupNumber$2 = $uI(dict[groupName]);
      var compiledGroupNumber$2 = $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap[groupNumber$2]);
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return (("(?:\\" + compiledGroupNumber$2) + ")");
      break;
    }
    case 81: {
      var start$2 = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      var this$13 = $n(pattern);
      var end$2 = $uI(this$13.indexOf("\\E", start$2));
      if ((end$2 < 0)) {
        var this$14 = $n(pattern);
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = this$14.length;
        return $p_ju_regex_PatternCompiler__literal__T__T($thiz, $as_T(pattern.substring(start$2)));
      } else {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + end$2) | 0);
        return $p_ju_regex_PatternCompiler__literal__T__T($thiz, $as_T(pattern.substring(start$2, end$2)));
      }
      break;
    }
    default: {
      return $p_ju_regex_PatternCompiler__literal__I__T($thiz, $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz));
    }
  }
}
function $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var x1 = $f_T__codePointAt__I__I($n(pattern), $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
  switch (x1) {
    case 48: {
      return $p_ju_regex_PatternCompiler__parseOctalEscape__I($thiz);
      break;
    }
    case 120: {
      return $p_ju_regex_PatternCompiler__parseHexEscape__I($thiz);
      break;
    }
    case 117: {
      return $p_ju_regex_PatternCompiler__parseUnicodeHexEscape__I($thiz);
      break;
    }
    case 78: {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\N is not supported");
      break;
    }
    case 97: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 7;
      break;
    }
    case 116: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 9;
      break;
    }
    case 110: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 10;
      break;
    }
    case 102: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 12;
      break;
    }
    case 114: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 13;
      break;
    }
    case 101: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 27;
      break;
    }
    case 99: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      var $x_1 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var this$1 = $n(pattern);
      if (($x_1 === this$1.length)) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal control escape sequence");
      }
      var cp = $f_T__codePointAt__I__I($n(pattern), $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((cp >= 65536) ? 2 : 1)) | 0);
      return (64 ^ cp);
      break;
    }
    default: {
      if ((((x1 >= 65) && (x1 <= 90)) || ((x1 >= 97) && (x1 <= 122)))) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal/unsupported escape sequence");
      }
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((x1 >= 65536) ? 2 : 1)) | 0);
      return x1;
    }
  }
}
function $p_ju_regex_PatternCompiler__parseOctalEscape__I($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  if ((((1 + start) | 0) < len)) {
    var this$2 = $n(pattern);
    var index = ((1 + start) | 0);
    var d1 = (((-48) + $charAt(this$2, index)) | 0);
  } else {
    var d1 = (-1);
  }
  if (((d1 < 0) || (d1 > 7))) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal octal escape sequence");
  }
  if ((((2 + start) | 0) < len)) {
    var this$3 = $n(pattern);
    var index$1 = ((2 + start) | 0);
    var d2 = (((-48) + $charAt(this$3, index$1)) | 0);
  } else {
    var d2 = (-1);
  }
  if (((d2 < 0) || (d2 > 7))) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    return d1;
  } else if ((d1 > 3)) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    return (((d1 << 3) + d2) | 0);
  } else {
    if ((((3 + start) | 0) < len)) {
      var this$4 = $n(pattern);
      var index$2 = ((3 + start) | 0);
      var d3 = (((-48) + $charAt(this$4, index$2)) | 0);
    } else {
      var d3 = (-1);
    }
    if (((d3 < 0) || (d3 > 7))) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return (((d1 << 3) + d2) | 0);
    } else {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((4 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return (((((d1 << 6) + (d2 << 3)) | 0) + d3) | 0);
    }
  }
}
function $p_ju_regex_PatternCompiler__parseHexEscape__I($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  var start = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  if ((start !== len)) {
    var this$2 = $n(pattern);
    var $x_1 = ($charAt(this$2, start) === 123);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var innerStart = ((1 + start) | 0);
    var this$3 = $n(pattern);
    var innerEnd = $uI(this$3.indexOf("}", innerStart));
    if ((innerEnd < 0)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed hexadecimal escape sequence");
    }
    var cp = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, innerStart, innerEnd, "hexadecimal");
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + innerEnd) | 0);
    return cp;
  } else {
    var cp$2 = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, start, ((2 + start) | 0), "hexadecimal");
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + start) | 0);
    return cp$2;
  }
}
function $p_ju_regex_PatternCompiler__parseUnicodeHexEscape__I($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var start = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  var end = ((4 + start) | 0);
  var codeUnit = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, start, end, "Unicode");
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = end;
  var lowStart = ((2 + end) | 0);
  var lowEnd = ((4 + lowStart) | 0);
  if (((((-1024) & codeUnit) === 55296) && ($as_T(pattern.substring(end, lowStart)) === "\\u"))) {
    var low = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, lowStart, lowEnd, "Unicode");
    if ((((-1024) & low) === 56320)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = lowEnd;
      return ((((64 + (1023 & codeUnit)) | 0) << 10) | (1023 & low));
    } else {
      return codeUnit;
    }
  } else {
    return codeUnit;
  }
}
function $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, start, end, nameForError) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  if (((start === end) || (end > len))) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("Illegal " + nameForError) + " escape sequence"));
  }
  var i = start;
  while ((i < end)) {
    var i$2 = i;
    var this$4 = $n(pattern);
    var c = $charAt(this$4, i$2);
    if ((!((((c >= 48) && (c <= 57)) || ((c >= 65) && (c <= 70))) || ((c >= 97) && (c <= 102))))) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("Illegal " + nameForError) + " escape sequence"));
    }
    i = ((1 + i) | 0);
  }
  if ((((end - start) | 0) > 6)) {
    var cp = 1114112;
  } else {
    var s = $as_T(pattern.substring(start, end));
    var cp = $uI(parseInt(s, 16));
  }
  if ((cp > 1114111)) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Hexadecimal codepoint is too big");
  }
  return cp;
}
function $p_ju_regex_PatternCompiler__parsePredefinedCharacterClass__C__ju_regex_PatternCompiler$CompiledCharClass($thiz, dispatchChar) {
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  switch (dispatchChar) {
    case 100:
    case 68: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIDigit;
      break;
    }
    case 104:
    case 72: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalHorizontalWhiteSpace;
      break;
    }
    case 115:
    case 83: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWhiteSpace;
      break;
    }
    case 118:
    case 86: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalVerticalWhiteSpace;
      break;
    }
    case 119:
    case 87: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWordChar;
      break;
    }
    case 112:
    case 80: {
      var positive = $p_ju_regex_PatternCompiler__parsePCharacterClass__ju_regex_PatternCompiler$CompiledCharClass($thiz);
      break;
    }
    default: {
      var positive;
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), $bC(dispatchChar));
    }
  }
  return ((dispatchChar >= 97) ? positive : $n(positive).negated__ju_regex_PatternCompiler$CompiledCharClass());
}
function $p_ju_regex_PatternCompiler__parsePCharacterClass__ju_regex_PatternCompiler$CompiledCharClass($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  if ((start === len)) {
    var property = "?";
  } else {
    var this$2 = $n(pattern);
    if (($charAt(this$2, start) === 123)) {
      var innerStart = ((1 + start) | 0);
      var this$3 = $n(pattern);
      var innerEnd = $uI(this$3.indexOf("}", innerStart));
      if ((innerEnd < 0)) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character family");
      }
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = innerEnd;
      var property = $as_T(pattern.substring(innerStart, innerEnd));
    } else {
      var property = $as_T(pattern.substring(start, ((1 + start) | 0)));
    }
  }
  var dict = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$asciiPOSIXCharacterClasses;
  if ((!$uZ($m_jl_Utils$Cache$().jl_Utils$Cache$__f_safeHasOwnProperty.call(dict, property)))) {
    $thiz.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("Unicode character family", "2018");
  }
  var property2 = ((((66 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) === 2) && ((property === "Lower") || (property === "Upper"))) ? "Alpha" : property);
  var dict$1 = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$asciiPOSIXCharacterClasses;
  var result = $as_ju_regex_PatternCompiler$CompiledCharClass(dict$1[property2]);
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  return result;
}
function $p_ju_regex_PatternCompiler__compileCharacterClass__T($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
    var this$2 = $n(pattern);
    var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    var isNegated = ($charAt(this$2, index) === 94);
  } else {
    var isNegated = false;
  }
  if (isNegated) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  }
  var builder = new $c_ju_regex_PatternCompiler$CharacterClassBuilder(((66 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) === 2), isNegated);
  while (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
    var x1 = $f_T__codePointAt__I__I($n(pattern), $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
    matchResult: {
      switch (x1) {
        case 93: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          return builder.finish__T();
          break;
        }
        case 38: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
            var this$3 = $n(pattern);
            var index$1 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
            var $x_1 = ($charAt(this$3, index$1) === 38);
          } else {
            var $x_1 = false;
          }
          if ($x_1) {
            $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
            builder.startNewConjunct__V();
          } else {
            $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, 38, len, pattern, builder);
          }
          break matchResult;
          break;
        }
        case 91: {
          var cls = $p_ju_regex_PatternCompiler__compileCharacterClass__T($thiz);
          $p_ju_regex_PatternCompiler$CharacterClassBuilder__addAlternative__T__V(builder, cls);
          break matchResult;
          break;
        }
        case 92: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
            $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal escape sequence");
          }
          var this$4 = $n(pattern);
          var index$2 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
          var c2 = $charAt(this$4, index$2);
          switch (c2) {
            case 100:
            case 68:
            case 104:
            case 72:
            case 115:
            case 83:
            case 118:
            case 86:
            case 119:
            case 87:
            case 112:
            case 80: {
              builder.addCharacterClass__ju_regex_PatternCompiler$CompiledCharClass__V($p_ju_regex_PatternCompiler__parsePredefinedCharacterClass__C__ju_regex_PatternCompiler$CompiledCharClass($thiz, c2));
              break;
            }
            case 81: {
              $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
              var this$5 = $n(pattern);
              var fromIndex = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
              var end = $uI(this$5.indexOf("\\E", fromIndex));
              if ((end < 0)) {
                $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character class");
              }
              builder.addCodePointsInString__T__I__I__V(pattern, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex, end);
              $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + end) | 0);
              break;
            }
            default: {
              $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz), len, pattern, builder);
            }
          }
          break matchResult;
          break;
        }
        case 32:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13: {
          if (((4 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
            $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          } else {
            break;
          }
          break matchResult;
          break;
        }
        case 35: {
          if (((4 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
            $thiz.java$util$regex$PatternCompiler$$skipSharpComment__V();
          } else {
            break;
          }
          break matchResult;
          break;
        }
      }
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((x1 >= 65536) ? 2 : 1)) | 0);
      $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, x1, len, pattern, builder);
    }
  }
  $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character class");
}
function $p_ju_regex_PatternCompiler__compileGroup__T($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  if ((((1 + start) | 0) === len)) {
    var $x_1 = true;
  } else {
    var this$2 = $n(pattern);
    var index = ((1 + start) | 0);
    var $x_1 = ($charAt(this$2, index) !== 63);
  }
  if ($x_1) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + start) | 0);
    $thiz.ju_regex_PatternCompiler__f_compiledGroupCount = ((1 + $thiz.ju_regex_PatternCompiler__f_compiledGroupCount) | 0);
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.push($thiz.ju_regex_PatternCompiler__f_compiledGroupCount);
    return (("(" + $thiz.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(true)) + ")");
  } else {
    if ((((2 + start) | 0) === len)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed group");
    }
    var this$3 = $n(pattern);
    var index$1 = ((2 + start) | 0);
    var c1 = $charAt(this$3, index$1);
    if ((((c1 === 58) || (c1 === 61)) || (c1 === 33))) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + start) | 0);
      return ((("" + $as_T(pattern.substring(start, ((3 + start) | 0)))) + $thiz.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(true)) + ")");
    } else if ((c1 === 60)) {
      if ((((3 + start) | 0) === len)) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed group");
      }
      var this$4 = $n(pattern);
      var index$2 = ((3 + start) | 0);
      var c2 = $charAt(this$4, index$2);
      if ((((c2 >= 65) && (c2 <= 90)) || ((c2 >= 97) && (c2 <= 122)))) {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + start) | 0);
        var name = $p_ju_regex_PatternCompiler__parseGroupName__T($thiz);
        var dict = $thiz.ju_regex_PatternCompiler__f_namedGroups;
        if ($uZ($m_jl_Utils$Cache$().jl_Utils$Cache$__f_safeHasOwnProperty.call(dict, name))) {
          $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("named capturing group <" + name) + "> is already defined"));
        }
        $thiz.ju_regex_PatternCompiler__f_compiledGroupCount = ((1 + $thiz.ju_regex_PatternCompiler__f_compiledGroupCount) | 0);
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.push($thiz.ju_regex_PatternCompiler__f_compiledGroupCount);
        var dict$1 = $thiz.ju_regex_PatternCompiler__f_namedGroups;
        var value = (((-1) + $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length)) | 0);
        dict$1[name] = value;
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
        return (("(" + $thiz.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(true)) + ")");
      } else {
        if (((c2 !== 61) && (c2 !== 33))) {
          $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unknown look-behind group");
        }
        $thiz.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("Look-behind group", "2018");
      }
    } else if ((c1 === 62)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + start) | 0);
      $thiz.ju_regex_PatternCompiler__f_compiledGroupCount = ((1 + $thiz.ju_regex_PatternCompiler__f_compiledGroupCount) | 0);
      var groupNumber = $thiz.ju_regex_PatternCompiler__f_compiledGroupCount;
      return (((("(?:(?=(" + $thiz.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(true)) + "))\\") + groupNumber) + ")");
    } else {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Embedded flag expression in the middle of a pattern is not supported");
    }
  }
}
function $p_ju_regex_PatternCompiler__parseGroupName__T($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  while (true) {
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
      var this$2 = $n(pattern);
      var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var c = $charAt(this$2, index);
      var $x_1 = ((((c >= 65) && (c <= 90)) || ((c >= 97) && (c <= 122))) || ((c >= 48) && (c <= 57)));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    } else {
      break;
    }
  }
  if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
    var $x_2 = true;
  } else {
    var this$4 = $n(pattern);
    var index$1 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    var $x_2 = ($charAt(this$4, index$1) !== 62);
  }
  if ($x_2) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "named capturing group is missing trailing '>'");
  }
  return $as_T(pattern.substring(start, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex));
}
function $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, startCodePoint, len$2, pattern$3, builder$1) {
  if (((4 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    $p_ju_regex_PatternCompiler__skipComments__V($thiz);
  }
  if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len$2)) {
    var this$1 = $n(pattern$3);
    var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    var $x_1 = ($charAt(this$1, index) === 45);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    if (((4 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
      $p_ju_regex_PatternCompiler__skipComments__V($thiz);
    }
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len$2)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character class");
    }
    var cpEnd = $f_T__codePointAt__I__I($n(pattern$3), $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
    if (((cpEnd === 91) || (cpEnd === 93))) {
      $n(builder$1).addSingleCodePoint__I__V(startCodePoint);
      $n(builder$1).addSingleCodePoint__I__V(45);
    } else {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((cpEnd >= 65536) ? 2 : 1)) | 0);
      var endCodePoint = ((cpEnd === 92) ? $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz) : cpEnd);
      if ((endCodePoint < startCodePoint)) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal character range");
      }
      $n(builder$1).addCodePointRange__I__I__V(startCodePoint, endCodePoint);
    }
  } else {
    $n(builder$1).addSingleCodePoint__I__V(startCodePoint);
  }
}
/** @constructor */
function $c_ju_regex_PatternCompiler(pattern, flags) {
  this.ju_regex_PatternCompiler__f_pattern = null;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = 0;
  this.ju_regex_PatternCompiler__f_sticky = false;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = 0;
  this.ju_regex_PatternCompiler__f_compiledGroupCount = 0;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap = null;
  this.ju_regex_PatternCompiler__f_namedGroups = null;
  this.ju_regex_PatternCompiler__f_pattern = pattern;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = flags;
  this.ju_regex_PatternCompiler__f_sticky = false;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = 0;
  this.ju_regex_PatternCompiler__f_compiledGroupCount = 0;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap = [0];
  this.ju_regex_PatternCompiler__f_namedGroups = ({});
}
$c_ju_regex_PatternCompiler.prototype = new $h_O();
$c_ju_regex_PatternCompiler.prototype.constructor = $c_ju_regex_PatternCompiler;
/** @constructor */
function $h_ju_regex_PatternCompiler() {
}
$h_ju_regex_PatternCompiler.prototype = $c_ju_regex_PatternCompiler.prototype;
$c_ju_regex_PatternCompiler.prototype.compile__ju_regex_Pattern = (function() {
  if (((256 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = (64 | this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags);
  }
  var isLiteral = ((16 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0);
  if ((!isLiteral)) {
    $p_ju_regex_PatternCompiler__processLeadingEmbeddedFlags__V(this);
  }
  if (((128 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    $p_ju_regex_PatternCompiler__parseError__T__E(this, "CANON_EQ is not supported");
  }
  if (((8 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    this.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("MULTILINE", "2018");
  }
  if (((256 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    this.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("UNICODE_CHARACTER_CLASS", "2018");
  }
  if (isLiteral) {
    var jsPattern = $p_ju_regex_PatternCompiler__literal__T__T(this, this.ju_regex_PatternCompiler__f_pattern);
  } else {
    if (($as_T(this.ju_regex_PatternCompiler__f_pattern.substring(this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex, ((2 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0))) === "\\G")) {
      this.ju_regex_PatternCompiler__f_sticky = true;
      this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    }
    var jsPattern = this.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(false);
  }
  var baseJSFlags = ($m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsDotAll ? "us" : "u");
  var jsFlags = (((66 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) === 66) ? (baseJSFlags + "i") : baseJSFlags);
  return new $c_ju_regex_Pattern(this.ju_regex_PatternCompiler__f_pattern, this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags, jsPattern, jsFlags, this.ju_regex_PatternCompiler__f_sticky, (((-1) + $uI(this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length)) | 0), this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap, this.ju_regex_PatternCompiler__f_namedGroups);
});
$c_ju_regex_PatternCompiler.prototype.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E = (function(purpose, es) {
  $p_ju_regex_PatternCompiler__parseError__T__E(this, (((((((purpose + " is not supported because it requires RegExp features of ECMAScript ") + es) + ".\n") + ((("If you only target environments with ES" + es) + "+, you can enable ES") + es)) + " features with\n") + ("  scalaJSLinkerConfig ~= { _.withESFeatures(_.withESVersion(ESVersion.ES" + es)) + ")) }\nor an equivalent configuration depending on your build tool."));
});
$c_ju_regex_PatternCompiler.prototype.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T = (function(insideGroup) {
  var pattern = this.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  var result = "";
  while ((this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
    var dispatchCP = $f_T__codePointAt__I__I($n(pattern), this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
    matchResult: {
      switch (dispatchCP) {
        case 41: {
          if ((!insideGroup)) {
            $p_ju_regex_PatternCompiler__parseError__T__E(this, "Unmatched closing ')'");
          }
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          return result;
          break;
        }
        case 124: {
          if ((this.ju_regex_PatternCompiler__f_sticky && (!insideGroup))) {
            $p_ju_regex_PatternCompiler__parseError__T__E(this, "\\G is not supported when there is an alternative at the top level");
          }
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          result = (result + "|");
          break matchResult;
          break;
        }
        case 32:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13: {
          if (((4 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
            this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          } else {
            break;
          }
          break matchResult;
          break;
        }
        case 35: {
          if (((4 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
            this.java$util$regex$PatternCompiler$$skipSharpComment__V();
          } else {
            break;
          }
          break matchResult;
          break;
        }
        case 63:
        case 42:
        case 43:
        case 123: {
          $p_ju_regex_PatternCompiler__parseError__T__E(this, (("Dangling meta character '" + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(dispatchCP)) + "'"));
          break;
        }
      }
      var compiledGroupCountBeforeThisToken = this.ju_regex_PatternCompiler__f_compiledGroupCount;
      switch (dispatchCP) {
        case 92: {
          var compiledToken = $p_ju_regex_PatternCompiler__compileEscape__T(this);
          break;
        }
        case 91: {
          var compiledToken = $p_ju_regex_PatternCompiler__compileCharacterClass__T(this);
          break;
        }
        case 40: {
          var compiledToken = $p_ju_regex_PatternCompiler__compileGroup__T(this);
          break;
        }
        case 94: {
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          var compiledToken = "^";
          break;
        }
        case 36: {
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          var compiledToken = "$";
          break;
        }
        case 46: {
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          var rejected = (((32 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0) ? "" : (((1 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0) ? "\n" : "\n\r\u0085\u2028\u2029"));
          var compiledToken = $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointNotAmong__T__T(rejected);
          break;
        }
        default: {
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((dispatchCP >= 65536) ? 2 : 1)) | 0);
          var compiledToken = $p_ju_regex_PatternCompiler__literal__I__T(this, dispatchCP);
        }
      }
      result = (("" + result) + $p_ju_regex_PatternCompiler__compileRepeater__I__T__T(this, compiledGroupCountBeforeThisToken, compiledToken));
    }
  }
  if (insideGroup) {
    $p_ju_regex_PatternCompiler__parseError__T__E(this, "Unclosed group");
  }
  return result;
});
$c_ju_regex_PatternCompiler.prototype.java$util$regex$PatternCompiler$$skipSharpComment__V = (function() {
  var pattern = this.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  while (true) {
    if ((this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
      var this$2 = $n(pattern);
      var index = this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var c = $charAt(this$2, index);
      var $x_1 = (!(((((c === 10) || (c === 13)) || (c === 133)) || (c === 8232)) || (c === 8233)));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    } else {
      break;
    }
  }
});
$c_ju_regex_PatternCompiler.prototype.java$util$regex$PatternCompiler$$$anonfun$buildPossessiveQuantifier$2__T__T__T__I__T = (function(str, backslashes, groupString, compiledGroupCountBeforeThisToken$1) {
  var this$1 = $n(backslashes);
  if ((((this$1.length % 2) | 0) === 0)) {
    return str;
  } else {
    var groupNumber = $uI(parseInt(groupString, 10));
    return ((groupNumber > compiledGroupCountBeforeThisToken$1) ? (("" + backslashes) + ((1 + groupNumber) | 0)) : str);
  }
});
var $d_ju_regex_PatternCompiler = new $TypeData().initClass($c_ju_regex_PatternCompiler, "java.util.regex.PatternCompiler", ({
  ju_regex_PatternCompiler: 1
}));
function $p_ju_regex_PatternCompiler$__featureTest__T__Z($thiz, flags) {
  try {
    new RegExp("", flags);
    return true;
  } catch (e) {
    return false;
  }
}
/** @constructor */
function $c_ju_regex_PatternCompiler$() {
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$leadingEmbeddedFlagSpecifierRegExp = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$renumberingRegExp = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsUnicode = false;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsSticky = false;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsDotAll = false;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIDigit = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeDigit = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalHorizontalWhiteSpace = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWhiteSpace = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeWhitespace = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalVerticalWhiteSpace = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWordChar = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeWordChar = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$asciiPOSIXCharacterClasses = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$scriptCanonicalizeRegExp = null;
  $n_ju_regex_PatternCompiler$ = this;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$leadingEmbeddedFlagSpecifierRegExp = new RegExp("^\\(\\?([idmsuxU]*)(?:-([idmsuxU]*))?\\)");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$renumberingRegExp = new RegExp("(\\\\+)(\\d+)", "g");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsUnicode = true;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsSticky = true;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsDotAll = $p_ju_regex_PatternCompiler$__featureTest__T__Z(this, "us");
  $p_ju_regex_PatternCompiler$__featureTest__T__Z(this, "d");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIDigit = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeDigit = new $c_ju_regex_PatternCompiler$CompiledCharClass(0, "Nd");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalHorizontalWhiteSpace = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t \u00a0\u1680\u180e\u2000-\u200a\u202f\u205f\u3000");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWhiteSpace = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t-\r ");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeWhitespace = new $c_ju_regex_PatternCompiler$CompiledCharClass(0, "White_Space");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalVerticalWhiteSpace = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\n-\r\u0085\u2028\u2029");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWordChar = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "a-zA-Z_0-9");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeWordChar = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\\p{Alphabetic}\\p{Mn}\\p{Me}\\p{Mc}\\p{Nd}\\p{Pc}\\p{Join_Control}");
  var r = ({});
  var value = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "a-z");
  r.Lower = value;
  var value$1 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "A-Z");
  r.Upper = value$1;
  var value$2 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\u0000-\u007f");
  r.ASCII = value$2;
  var value$3 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "A-Za-z");
  r.Alpha = value$3;
  var value$4 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9");
  r.Digit = value$4;
  var value$5 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9A-Za-z");
  r.Alnum = value$5;
  var value$6 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "!-/:-@[-`{-~");
  r.Punct = value$6;
  var value$7 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "!-~");
  r.Graph = value$7;
  var value$8 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, " -~");
  r.Print = value$8;
  var value$9 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t ");
  r.Blank = value$9;
  var value$10 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\u0000-\u001f\u007f");
  r.Cntrl = value$10;
  var value$11 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9A-Fa-f");
  r.XDigit = value$11;
  var value$12 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t-\r ");
  r.Space = value$12;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$asciiPOSIXCharacterClasses = r;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$scriptCanonicalizeRegExp = new RegExp("(?:^|_)[a-z]", "g");
}
$c_ju_regex_PatternCompiler$.prototype = new $h_O();
$c_ju_regex_PatternCompiler$.prototype.constructor = $c_ju_regex_PatternCompiler$;
/** @constructor */
function $h_ju_regex_PatternCompiler$() {
}
$h_ju_regex_PatternCompiler$.prototype = $c_ju_regex_PatternCompiler$.prototype;
$c_ju_regex_PatternCompiler$.prototype.compile__T__I__ju_regex_Pattern = (function(regex, flags) {
  return new $c_ju_regex_PatternCompiler(regex, flags).compile__ju_regex_Pattern();
});
$c_ju_regex_PatternCompiler$.prototype.java$util$regex$PatternCompiler$$charToFlag__C__I = (function(c) {
  switch (c) {
    case 105: {
      return 2;
      break;
    }
    case 100: {
      return 1;
      break;
    }
    case 109: {
      return 8;
      break;
    }
    case 115: {
      return 32;
      break;
    }
    case 117: {
      return 64;
      break;
    }
    case 120: {
      return 4;
      break;
    }
    case 85: {
      return 256;
      break;
    }
    default: {
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "bad in-pattern flag");
    }
  }
});
$c_ju_regex_PatternCompiler$.prototype.java$util$regex$PatternCompiler$$codePointNotAmong__T__T = (function(characters) {
  return ((characters !== "") ? (("[^" + characters) + "]") : ($m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsDotAll ? "." : "[\\d\\D]"));
});
$c_ju_regex_PatternCompiler$.prototype.java$util$regex$PatternCompiler$$codePointToString__I__T = (function(codePoint) {
  return $as_T(String.fromCodePoint(codePoint));
});
var $d_ju_regex_PatternCompiler$ = new $TypeData().initClass($c_ju_regex_PatternCompiler$, "java.util.regex.PatternCompiler$", ({
  ju_regex_PatternCompiler$: 1
}));
var $n_ju_regex_PatternCompiler$;
function $m_ju_regex_PatternCompiler$() {
  if ((!$n_ju_regex_PatternCompiler$)) {
    $n_ju_regex_PatternCompiler$ = new $c_ju_regex_PatternCompiler$();
  }
  return $n_ju_regex_PatternCompiler$;
}
function $p_ju_regex_PatternCompiler$CharacterClassBuilder__addAlternative__T__V($thiz, alt) {
  if (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct === "")) {
    $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = alt;
  } else {
    $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct + "|") + alt);
  }
}
function $p_ju_regex_PatternCompiler$CharacterClassBuilder__conjunctResult__T($thiz) {
  if ($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_isNegated) {
    var negThisSegment = $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointNotAmong__T__T($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment);
    return (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct === "") ? negThisSegment : (((("(?:(?!" + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct) + ")") + negThisSegment) + ")"));
  } else {
    return (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment === "") ? (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct === "") ? "[^\\d\\D]" : (("(?:" + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct) + ")")) : (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct === "") ? (("[" + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + "]") : (((("(?:" + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct) + "|[") + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + "])")));
  }
}
function $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T($thiz, codePoint) {
  var s = $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(codePoint);
  return (((((codePoint === 93) || (codePoint === 92)) || (codePoint === 45)) || (codePoint === 94)) ? ("\\" + s) : s);
}
/** @constructor */
function $c_ju_regex_PatternCompiler$CharacterClassBuilder(asciiCaseInsensitive, isNegated) {
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_asciiCaseInsensitive = false;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_isNegated = false;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction = null;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = null;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = null;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_asciiCaseInsensitive = asciiCaseInsensitive;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_isNegated = isNegated;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction = "";
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = "";
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = "";
}
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype = new $h_O();
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.constructor = $c_ju_regex_PatternCompiler$CharacterClassBuilder;
/** @constructor */
function $h_ju_regex_PatternCompiler$CharacterClassBuilder() {
}
$h_ju_regex_PatternCompiler$CharacterClassBuilder.prototype = $c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype;
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.finish__T = (function() {
  var conjunct = $p_ju_regex_PatternCompiler$CharacterClassBuilder__conjunctResult__T(this);
  return ((this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction === "") ? conjunct : ((("(?:" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction) + conjunct) + ")"));
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.startNewConjunct__V = (function() {
  var conjunct = $p_ju_regex_PatternCompiler$CharacterClassBuilder__conjunctResult__T(this);
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction = (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction + (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_isNegated ? (conjunct + "|") : (("(?=" + conjunct) + ")")));
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = "";
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = "";
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.addCharacterClass__ju_regex_PatternCompiler$CompiledCharClass__V = (function(cls) {
  var x1 = $n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_kind;
  switch (x1) {
    case 0: {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ((this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment + ("\\p{" + $n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_data)) + "}");
      break;
    }
    case 1: {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ((this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment + ("\\P{" + $n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_data)) + "}");
      break;
    }
    case 2: {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + $n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_data);
      break;
    }
    case 3: {
      $p_ju_regex_PatternCompiler$CharacterClassBuilder__addAlternative__T__V(this, $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointNotAmong__T__T($n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_data));
      break;
    }
    default: {
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), x1);
    }
  }
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.addCodePointsInString__T__I__I__V = (function(str, start, end) {
  var i = start;
  while ((i !== end)) {
    var codePoint = $f_T__codePointAt__I__I($n(str), i);
    this.addSingleCodePoint__I__V(codePoint);
    i = ((i + ((codePoint >= 65536) ? 2 : 1)) | 0);
  }
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.addSingleCodePoint__I__V = (function(codePoint) {
  var s = $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, codePoint);
  if ((((-1024) & codePoint) === 56320)) {
    this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + s) + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment);
  } else {
    this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + s);
  }
  if (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_asciiCaseInsensitive) {
    if (((codePoint >= 65) && (codePoint <= 90))) {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(((32 + codePoint) | 0)));
    } else if (((codePoint >= 97) && (codePoint <= 122))) {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T((((-32) + codePoint) | 0)));
    }
  }
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.addCodePointRange__I__I__V = (function(startCodePoint, endCodePoint) {
  var s = (($p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, startCodePoint) + "-") + $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, endCodePoint));
  if ((((-1024) & startCodePoint) === 56320)) {
    this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (s + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment);
  } else {
    this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment + s);
  }
  if (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_asciiCaseInsensitive) {
    var start = ((startCodePoint > 65) ? startCodePoint : 65);
    var end = ((endCodePoint < 90) ? endCodePoint : 90);
    if ((start <= end)) {
      var $x_1 = this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment;
      var start$1 = ((32 + start) | 0);
      var end$1 = ((32 + end) | 0);
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ($x_1 + (($p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, start$1) + "-") + $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, end$1)));
    }
    var start$2 = ((startCodePoint > 97) ? startCodePoint : 97);
    var end$2 = ((endCodePoint < 122) ? endCodePoint : 122);
    if ((start$2 <= end$2)) {
      var $x_2 = this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment;
      var start$3 = (((-32) + start$2) | 0);
      var end$3 = (((-32) + end$2) | 0);
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ($x_2 + (($p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, start$3) + "-") + $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, end$3)));
    }
  }
});
var $d_ju_regex_PatternCompiler$CharacterClassBuilder = new $TypeData().initClass($c_ju_regex_PatternCompiler$CharacterClassBuilder, "java.util.regex.PatternCompiler$CharacterClassBuilder", ({
  ju_regex_PatternCompiler$CharacterClassBuilder: 1
}));
function $p_ju_regex_PatternCompiler$CompiledCharClass__negated$lzycompute__ju_regex_PatternCompiler$CompiledCharClass($thiz) {
  if ((!$thiz.ju_regex_PatternCompiler$CompiledCharClass__f_bitmap$0)) {
    $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_negated = new $c_ju_regex_PatternCompiler$CompiledCharClass((1 ^ $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_kind), $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_data);
    $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_bitmap$0 = true;
  }
  return $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_negated;
}
/** @constructor */
function $c_ju_regex_PatternCompiler$CompiledCharClass(kind, data) {
  this.ju_regex_PatternCompiler$CompiledCharClass__f_negated = null;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_kind = 0;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_data = null;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_bitmap$0 = false;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_kind = kind;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_data = data;
}
$c_ju_regex_PatternCompiler$CompiledCharClass.prototype = new $h_O();
$c_ju_regex_PatternCompiler$CompiledCharClass.prototype.constructor = $c_ju_regex_PatternCompiler$CompiledCharClass;
/** @constructor */
function $h_ju_regex_PatternCompiler$CompiledCharClass() {
}
$h_ju_regex_PatternCompiler$CompiledCharClass.prototype = $c_ju_regex_PatternCompiler$CompiledCharClass.prototype;
$c_ju_regex_PatternCompiler$CompiledCharClass.prototype.negated__ju_regex_PatternCompiler$CompiledCharClass = (function() {
  return ((!this.ju_regex_PatternCompiler$CompiledCharClass__f_bitmap$0) ? $p_ju_regex_PatternCompiler$CompiledCharClass__negated$lzycompute__ju_regex_PatternCompiler$CompiledCharClass(this) : this.ju_regex_PatternCompiler$CompiledCharClass__f_negated);
});
function $as_ju_regex_PatternCompiler$CompiledCharClass(obj) {
  return (((obj instanceof $c_ju_regex_PatternCompiler$CompiledCharClass) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.regex.PatternCompiler$CompiledCharClass"));
}
function $isArrayOf_ju_regex_PatternCompiler$CompiledCharClass(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_regex_PatternCompiler$CompiledCharClass)));
}
function $asArrayOf_ju_regex_PatternCompiler$CompiledCharClass(obj, depth) {
  return (($isArrayOf_ju_regex_PatternCompiler$CompiledCharClass(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.regex.PatternCompiler$CompiledCharClass;", depth));
}
var $d_ju_regex_PatternCompiler$CompiledCharClass = new $TypeData().initClass($c_ju_regex_PatternCompiler$CompiledCharClass, "java.util.regex.PatternCompiler$CompiledCharClass", ({
  ju_regex_PatternCompiler$CompiledCharClass: 1
}));
function $p_Llaika_api_MarkupParser__parse__Llaika_internal_parse_markup_DocumentParser$DocumentInput__s_util_Either($thiz, input) {
  var this$1 = $n($as_s_util_Either($n($thiz.Llaika_api_MarkupParser__f_docParser).apply__O__O(input)));
  if ((this$1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$1);
    var b = $n(x2).s_util_Right__f_value;
    var unresolved = $as_Llaika_ast_UnresolvedDocument(b);
    var this$4 = $n($n(unresolved).Llaika_ast_UnresolvedDocument__f_config);
    $m_Llaika_api_config_Origin$();
    var scope = $m_Llaika_api_config_Origin$DocumentScope$();
    var path = $n(input).Llaika_internal_parse_markup_DocumentParser$DocumentInput__f_path;
    $m_Llaika_api_config_Origin$();
    var sourcePath = $m_s_None$();
    var origin = new $c_Llaika_api_config_Origin(scope, path, sourcePath);
    var fallback = $n($thiz.Llaika_api_MarkupParser__f_config).baseConfig__Llaika_api_config_Config();
    var this$5 = $n(this$4.resolve__Llaika_api_config_Origin__Llaika_api_config_Config__sci_Map__s_util_Either(origin, fallback, $m_Llaika_api_config_ConfigParser$().Llaika_api_config_ConfigParser$__f_includesNotSupported));
    var this$6 = new $c_s_util_Either$LeftProjection(this$5);
    var x1 = this$6.s_util_Either$LeftProjection__f_e;
    if ((x1 instanceof $c_s_util_Left)) {
      var x2$1 = $as_s_util_Left(x1);
      var a = $n(x2$1).s_util_Left__f_value;
      var _$3 = $as_Llaika_api_config_ConfigError(a);
      var $x_1 = new $c_s_util_Left(new $c_Llaika_api_errors_InvalidConfig(_$3));
    } else {
      var $x_1 = this$6.s_util_Either$LeftProjection__f_e;
    }
    var this$8 = $n($x_1);
    if ((this$8 instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(this$8);
      var b$1 = $n(x2$2).s_util_Right__f_value;
      var resolvedConfig = $as_Llaika_api_config_Config(b$1);
      var resolvedDoc = $ps_Llaika_api_MarkupParser__resolveDocument$1__Llaika_ast_UnresolvedDocument__Llaika_api_config_Config__Llaika_ast_Document(unresolved, resolvedConfig);
      var $x_2 = new $c_s_util_Right(new $c_T2(resolvedConfig, resolvedDoc));
    } else {
      var $x_2 = this$8;
    }
    var this$10 = $n($x_2);
    if ((this$10 instanceof $c_s_util_Right)) {
      var x2$3 = $as_s_util_Right(this$10);
      var b$2 = $n(x2$3).s_util_Right__f_value;
      var x$1 = $as_T2(b$2);
      if ((x$1 !== null)) {
        $as_Llaika_api_config_Config($n(x$1)._1__O());
        var resolvedDoc$1 = $as_Llaika_ast_Document($n(x$1)._2__O());
        var this$11 = $n($p_Llaika_api_MarkupParser__rewriteDocument$1__Llaika_ast_Document__s_util_Either($thiz, resolvedDoc$1));
        if ((this$11 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(this$11);
          var b$3 = $n(x2$4).s_util_Right__f_value;
          var result = $as_Llaika_ast_Document(b$3);
          return new $c_s_util_Right(result);
        } else {
          return this$11;
        }
      }
      throw new $c_s_MatchError(x$1);
    } else {
      return this$10;
    }
  } else {
    return this$1;
  }
}
function $ps_Llaika_api_MarkupParser__merge$1__Llaika_api_config_Config__sci_Seq__Llaika_api_config_Config(config, values) {
  return $n($as_Llaika_api_config_ConfigBuilder($n(values).foldLeft__O__F2__O(($m_Llaika_api_config_ConfigBuilder$(), new $c_Llaika_api_config_ConfigBuilder($m_sci_Nil$(), $n(config).origin__Llaika_api_config_Origin(), config)), new $c_sjsr_AnonFunction2(((x$1, x$2) => {
    var x$1$1 = $as_Llaika_api_config_ConfigBuilder(x$1);
    var x$2$1 = $as_T2(x$2);
    var x1 = new $c_T2(x$1$1, x$2$1);
    var x3 = $as_T2(x1.T2__f__2);
    var builder = $as_Llaika_api_config_ConfigBuilder(x1.T2__f__1);
    if ((x3 !== null)) {
      var key = $as_T($n(x3)._1__O());
      var value = $as_Llaika_api_config_ConfigValue($n(x3)._2__O());
      return $n(builder).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigBuilder(key, value, $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_configValue);
    }
    throw new $c_s_MatchError(x1);
  }))))).build__Llaika_api_config_Config();
}
function $ps_Llaika_api_MarkupParser__resolveDocument$1__Llaika_ast_UnresolvedDocument__Llaika_api_config_Config__Llaika_ast_Document(unresolved, docConfig) {
  var this$1 = $n($n($n(unresolved).Llaika_ast_UnresolvedDocument__f_document).Llaika_ast_Document__f_content);
  var pf = new $c_Llaika_api_MarkupParser$$anon$1();
  var embeddedConfig = $f_Llaika_ast_ElementTraversal__collect__s_PartialFunction__sci_List(this$1, pf);
  return $n($n(unresolved).Llaika_ast_UnresolvedDocument__f_document).withConfig__Llaika_api_config_Config__Llaika_ast_Document($ps_Llaika_api_MarkupParser__merge$1__Llaika_api_config_Config__sci_Seq__Llaika_api_config_Config(docConfig, embeddedConfig));
}
function $p_Llaika_api_MarkupParser__rewritePhase$1__Llaika_ast_Document__Llaika_ast_RewritePhase__s_util_Either($thiz, doc, phase) {
  var eab = $n($thiz.Llaika_api_MarkupParser__f_config).rewriteRulesFor__Llaika_ast_Document__Llaika_ast_RewritePhase__s_util_Either(doc, phase);
  matchResult23: {
    var $x_1;
    if ((eab instanceof $c_s_util_Left)) {
      var a = $n($as_s_util_Left(eab)).s_util_Left__f_value;
      var _$1 = $as_Llaika_api_config_ConfigError(a);
      var value = new $c_Llaika_api_errors_InvalidConfig(_$1);
      var $x_1 = new $c_s_util_Left(value);
      break matchResult23;
    }
    if ((eab instanceof $c_s_util_Right)) {
      var r = $as_s_util_Right(eab);
      $m_Lcats_syntax_EitherUtil$();
      var $x_1 = r;
      break matchResult23;
    }
    throw new $c_s_MatchError(eab);
  }
  var this$6 = $n($x_1);
  if ((this$6 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$6);
    var b = $n(x2).s_util_Right__f_value;
    var rules = $as_Llaika_ast_RewriteRules(b);
    var eab$1 = $n(doc).rewrite__Llaika_ast_RewriteRules__s_util_Either(rules);
    matchResult23$1: {
      var $x_2;
      if ((eab$1 instanceof $c_s_util_Left)) {
        var a$1 = $n($as_s_util_Left(eab$1)).s_util_Left__f_value;
        var _$2 = $as_Llaika_api_config_ConfigError(a$1);
        var value$1 = new $c_Llaika_api_errors_InvalidConfig(_$2);
        var $x_2 = new $c_s_util_Left(value$1);
        break matchResult23$1;
      }
      if ((eab$1 instanceof $c_s_util_Right)) {
        var r$1 = $as_s_util_Right(eab$1);
        $m_Lcats_syntax_EitherUtil$();
        var $x_2 = r$1;
        break matchResult23$1;
      }
      throw new $c_s_MatchError(eab$1);
    }
    var this$12 = $n($x_2);
    if ((this$12 instanceof $c_s_util_Right)) {
      var x2$1 = $as_s_util_Right(this$12);
      var b$1 = $n(x2$1).s_util_Right__f_value;
      var result = $as_Llaika_ast_Document(b$1);
      return new $c_s_util_Right(result);
    } else {
      return this$12;
    }
  } else {
    return this$6;
  }
}
function $ps_Llaika_api_MarkupParser__createError$1__Llaika_api_errors_InvalidDocument__Llaika_api_errors_ParserError(doc) {
  matchResult4: {
    var $x_1;
    var x10 = $n(doc).Llaika_api_errors_InvalidDocument__f_errors;
    if ((x10 instanceof $c_s_util_Left)) {
      var configErrors = $n($as_s_util_Left(x10)).s_util_Left__f_value;
      var error = new $c_Llaika_api_config_ConfigError$MultipleErrors(configErrors);
      var $x_1 = new $c_Llaika_api_errors_InvalidConfig(error);
      break matchResult4;
    }
    if ((x10 instanceof $c_s_util_Right)) {
      var invalidNodes = $n($as_s_util_Right(x10)).s_util_Right__f_value;
      var $x_1 = new $c_Llaika_api_errors_InvalidElements(invalidNodes);
      break matchResult4;
    }
    throw new $c_s_MatchError(x10);
  }
  return $as_Llaika_api_errors_ParserError($x_1);
}
function $p_Llaika_api_MarkupParser__rewriteDocument$1__Llaika_ast_Document__s_util_Either($thiz, resolvedDoc) {
  var this$1 = $n($p_Llaika_api_MarkupParser__rewritePhase$1__Llaika_ast_Document__Llaika_ast_RewritePhase__s_util_Either($thiz, resolvedDoc, $m_Llaika_ast_RewritePhase$Build$()));
  if ((this$1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$1);
    var b = $n(x2).s_util_Right__f_value;
    var phase1 = $as_Llaika_ast_Document(b);
    var this$2 = $n($p_Llaika_api_MarkupParser__rewritePhase$1__Llaika_ast_Document__Llaika_ast_RewritePhase__s_util_Either($thiz, phase1, $m_Llaika_ast_RewritePhase$Resolve$()));
    if ((this$2 instanceof $c_s_util_Right)) {
      var x2$1 = $as_s_util_Right(this$2);
      var b$1 = $n(x2$1).s_util_Right__f_value;
      var phase2 = $as_Llaika_ast_Document(b$1);
      var this$3 = $n($m_Llaika_api_errors_InvalidDocument$().from__Llaika_ast_Document__Llaika_config_MessageFilter__s_Option(phase2, $n($n($thiz.Llaika_api_MarkupParser__f_config).Llaika_api_builder_OperationConfig__f_messageFilters).Llaika_config_MessageFilters$Impl__f_failOn));
      if (this$3.isEmpty__Z()) {
        var $x_1 = $m_s_None$();
      } else {
        var arg1 = this$3.get__O();
        var doc = $as_Llaika_api_errors_InvalidDocument(arg1);
        var $x_1 = new $c_s_Some($ps_Llaika_api_MarkupParser__createError$1__Llaika_api_errors_InvalidDocument__Llaika_api_errors_ParserError(doc));
      }
      var this$4 = $n($x_1);
      var this$5 = $n((this$4.isEmpty__Z() ? new $c_s_util_Right(phase2) : new $c_s_util_Left(this$4.get__O())));
      if ((this$5 instanceof $c_s_util_Right)) {
        var x2$2 = $as_s_util_Right(this$5);
        var b$2 = $n(x2$2).s_util_Right__f_value;
        var result = $as_Llaika_ast_Document(b$2);
        return new $c_s_util_Right(result);
      } else {
        return this$5;
      }
    } else {
      return this$2;
    }
  } else {
    return this$1;
  }
}
/** @constructor */
function $c_Llaika_api_MarkupParser(format, config) {
  this.Llaika_api_MarkupParser__f_config = null;
  this.Llaika_api_MarkupParser__f_docParser = null;
  this.Llaika_api_MarkupParser__f_config = config;
  $n(format);
  var this$1 = $m_Llaika_ast_Path$Root$();
  $as_Llaika_ast_Path($f_Llaika_ast_GenericPath__$div__T__Llaika_ast_GenericPath(this$1, "doc"));
  this.Llaika_api_MarkupParser__f_docParser = $m_Llaika_internal_parse_markup_DocumentParser$().forMarkup__Llaika_api_format_MarkupFormat__Llaika_api_bundle_MarkupExtensions__Llaika_api_bundle_ConfigProvider__F1(format, $n(config).markupExtensions__Llaika_api_bundle_MarkupExtensions(), $n(config).configProvider__Llaika_api_bundle_ConfigProvider());
}
$c_Llaika_api_MarkupParser.prototype = new $h_O();
$c_Llaika_api_MarkupParser.prototype.constructor = $c_Llaika_api_MarkupParser;
/** @constructor */
function $h_Llaika_api_MarkupParser() {
}
$h_Llaika_api_MarkupParser.prototype = $c_Llaika_api_MarkupParser.prototype;
$c_Llaika_api_MarkupParser.prototype.parse__T__Llaika_ast_Path__s_util_Either = (function(input, path) {
  return $p_Llaika_api_MarkupParser__parse__Llaika_internal_parse_markup_DocumentParser$DocumentInput__s_util_Either(this, $m_Llaika_internal_parse_markup_DocumentParser$DocumentInput$().apply__Llaika_ast_Path__T__Llaika_internal_parse_markup_DocumentParser$DocumentInput(path, input));
});
var $d_Llaika_api_MarkupParser = new $TypeData().initClass($c_Llaika_api_MarkupParser, "laika.api.MarkupParser", ({
  Llaika_api_MarkupParser: 1
}));
function $ct_Llaika_api_Renderer__Llaika_api_builder_OperationConfig__Z__($thiz, config, skipRewrite) {
  $thiz.Llaika_api_Renderer__f_config = config;
  $thiz.Llaika_api_Renderer__f_skipRewrite = skipRewrite;
  $thiz.Llaika_api_Renderer__f_defaultPathTranslator = $m_Llaika_api_bundle_PathTranslator$().Llaika_api_bundle_PathTranslator$__f_noOp;
  return $thiz;
}
function $p_Llaika_api_Renderer__renderFunction__F2($thiz) {
  if ((!$thiz.Llaika_api_Renderer__f_renderFunctionbitmap$1)) {
    $thiz.Llaika_api_Renderer__f_renderFunction$lzy1 = new $c_sjsr_AnonFunction2(((fmt, element) => {
      var element$1 = $as_Llaika_ast_Element(element);
      return $as_T($n($n($n($thiz.Llaika_api_Renderer__f_config).renderOverridesFor__Llaika_api_format_RenderFormat__Llaika_api_format_RenderFormat$Overrides($thiz.format__Llaika_api_format_RenderFormat())).Llaika_api_format_RenderFormat$Overrides__f_value).applyOrElse__O__F1__O(new $c_T2(fmt, element$1), new $c_sjsr_AnonFunction1(((x$1) => {
        var x$1$1 = $as_T2(x$1);
        if ((x$1$1 !== null)) {
          var f = $n(x$1$1)._1__O();
          var e = $as_Llaika_ast_Element($n(x$1$1)._2__O());
          return $as_T($n($n($thiz.format__Llaika_api_format_RenderFormat()).defaultRenderer__F2()).apply__O__O__O(f, e));
        }
        throw new $c_s_MatchError(x$1$1);
      }))));
    }));
    $thiz.Llaika_api_Renderer__f_renderFunctionbitmap$1 = true;
  }
  return $thiz.Llaika_api_Renderer__f_renderFunction$lzy1;
}
function $p_Llaika_api_Renderer__render__Llaika_ast_Document__Llaika_ast_Element__Llaika_api_bundle_PathTranslator__Llaika_ast_styles_StyleDeclarationSet__s_util_Either($thiz, doc, targetElement, pathTranslator, styles) {
  var this$2 = $n(($thiz.Llaika_api_Renderer__f_skipRewrite ? new $c_s_util_Right(targetElement) : $p_Llaika_api_Renderer__rewrite$1__Llaika_ast_Document__Llaika_ast_Element__s_util_Either($thiz, doc, targetElement)));
  if ((this$2 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$2);
    var b = $n(x2).s_util_Right__f_value;
    var elementToRender = $as_Llaika_ast_Element(b);
    var renderContext = new $c_Llaika_api_format_Formatter$Context($p_Llaika_api_Renderer__renderFunction__F2($thiz), elementToRender, $m_sci_Nil$(), styles, $n(doc).path__Llaika_ast_Path(), pathTranslator, ($n($thiz.Llaika_api_Renderer__f_config).Llaika_api_builder_OperationConfig__f_compactRendering ? $m_Llaika_api_format_Formatter$Indentation$().Llaika_api_format_Formatter$Indentation$__f_none : $m_Llaika_api_format_Formatter$Indentation$().Llaika_api_format_Formatter$Indentation$__f_default), $n($n($thiz.Llaika_api_Renderer__f_config).Llaika_api_builder_OperationConfig__f_messageFilters).Llaika_config_MessageFilters$Impl__f_render);
    var formatter = $n($n($thiz.format__Llaika_api_format_RenderFormat()).formatterFactory__F1()).apply__O__O(renderContext);
    return new $c_s_util_Right($as_T($n($p_Llaika_api_Renderer__renderFunction__F2($thiz)).apply__O__O__O(formatter, elementToRender)));
  } else {
    return this$2;
  }
}
function $p_Llaika_api_Renderer__rewrite$1__Llaika_ast_Document__Llaika_ast_Element__s_util_Either($thiz, doc$1, targetElement$1) {
  var $x_1 = $thiz.Llaika_api_Renderer__f_config;
  var context = $m_Llaika_ast_OutputContext$().apply__Llaika_api_format_RenderFormat__Llaika_ast_OutputContext($thiz.format__Llaika_api_format_RenderFormat());
  var this$2 = $n($n($x_1).rewriteRulesFor__Llaika_ast_Document__Llaika_ast_RewritePhase__s_util_Either(doc$1, new $c_Llaika_ast_RewritePhase$Render(context)));
  if ((this$2 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$2);
    var b = $n(x2).s_util_Right__f_value;
    var _$1 = $as_Llaika_ast_RewriteRules(b);
    var eab = new $c_s_util_Right($n(_$1).rewriteElement__Llaika_ast_Element__Llaika_ast_Element(targetElement$1));
  } else {
    var eab = this$2;
  }
  if ((eab instanceof $c_s_util_Left)) {
    var a = $n($as_s_util_Left(eab)).s_util_Left__f_value;
    var _$2 = $as_Llaika_api_config_ConfigError(a);
    var value = new $c_Llaika_api_errors_InvalidConfig(_$2);
    return new $c_s_util_Left(value);
  }
  if ((eab instanceof $c_s_util_Right)) {
    var r = $as_s_util_Right(eab);
    $m_Lcats_syntax_EitherUtil$();
    return r;
  }
  throw new $c_s_MatchError(eab);
}
/** @constructor */
function $c_Llaika_api_Renderer() {
  this.Llaika_api_Renderer__f_config = null;
  this.Llaika_api_Renderer__f_skipRewrite = false;
  this.Llaika_api_Renderer__f_renderFunction$lzy1 = null;
  this.Llaika_api_Renderer__f_renderFunctionbitmap$1 = false;
  this.Llaika_api_Renderer__f_defaultPathTranslator = null;
}
$c_Llaika_api_Renderer.prototype = new $h_O();
$c_Llaika_api_Renderer.prototype.constructor = $c_Llaika_api_Renderer;
/** @constructor */
function $h_Llaika_api_Renderer() {
}
$h_Llaika_api_Renderer.prototype = $c_Llaika_api_Renderer.prototype;
$c_Llaika_api_Renderer.prototype.render__Llaika_ast_Document__s_util_Either = (function(doc) {
  return $p_Llaika_api_Renderer__render__Llaika_ast_Document__Llaika_ast_Element__Llaika_api_bundle_PathTranslator__Llaika_ast_styles_StyleDeclarationSet__s_util_Either(this, doc, $n(doc).Llaika_ast_Document__f_content, this.Llaika_api_Renderer__f_defaultPathTranslator, $m_Llaika_ast_styles_StyleDeclarationSet$().Llaika_ast_styles_StyleDeclarationSet$__f_empty);
});
$c_Llaika_api_Renderer.prototype.render__Llaika_ast_Element__s_util_Either = (function(element) {
  var this$1 = $m_Llaika_ast_Path$Root$();
  var this$2 = $n($f_Llaika_ast_GenericPath__$div__T__Llaika_ast_GenericPath(this$1, "doc"));
  var suffix = $n(this.format__Llaika_api_format_RenderFormat()).fileSuffix__T();
  return this.render__Llaika_ast_Element__Llaika_ast_Path__s_util_Either(element, $as_Llaika_ast_Path($f_Llaika_ast_GenericPath__withSuffix__T__Llaika_ast_GenericPath(this$2, suffix)));
});
$c_Llaika_api_Renderer.prototype.render__Llaika_ast_Element__Llaika_ast_Path__s_util_Either = (function(element, path) {
  return this.render__Llaika_ast_Element__Llaika_ast_Path__Llaika_api_bundle_PathTranslator__Llaika_ast_styles_StyleDeclarationSet__s_util_Either(element, path, this.Llaika_api_Renderer__f_defaultPathTranslator, $m_Llaika_ast_styles_StyleDeclarationSet$().Llaika_ast_styles_StyleDeclarationSet$__f_empty);
});
$c_Llaika_api_Renderer.prototype.render__Llaika_ast_Element__Llaika_ast_Path__Llaika_api_bundle_PathTranslator__Llaika_ast_styles_StyleDeclarationSet__s_util_Either = (function(element, path, pathTranslator, styles) {
  if ((element instanceof $c_Llaika_ast_RootElement)) {
    var root = $as_Llaika_ast_RootElement(element);
    var rootElement = root;
  } else if ($is_Llaika_ast_Block(element)) {
    var block = $as_Llaika_ast_Block(element);
    var this$1 = $m_Llaika_ast_RootElement$();
    var blocks = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Block.getArrayOf().constr)([]));
    var rootElement = $as_Llaika_ast_RootElement($f_Llaika_ast_BlockContainerCompanion__apply__Llaika_ast_Block__sci_Seq__O(this$1, block, blocks));
  } else if ($is_Llaika_ast_Span(element)) {
    var span = $as_Llaika_ast_Span(element);
    var this$3 = $m_Llaika_ast_RootElement$();
    var this$2 = $m_Llaika_ast_Paragraph$();
    var spans = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Span.getArrayOf().constr)([]));
    var block$1 = $as_Llaika_ast_Block($f_Llaika_ast_SpanContainerCompanion__apply__Llaika_ast_Span__sci_Seq__O(this$2, span, spans));
    var blocks$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Block.getArrayOf().constr)([]));
    var rootElement = $as_Llaika_ast_RootElement($f_Llaika_ast_BlockContainerCompanion__apply__Llaika_ast_Block__sci_Seq__O(this$3, block$1, blocks$1));
  } else {
    var this$7 = $m_Llaika_ast_RootElement$();
    var this$6 = $m_Llaika_ast_Paragraph$();
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var span$1 = new $c_Llaika_ast_TemplateElement(element, 0, options);
    var spans$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Span.getArrayOf().constr)([]));
    var block$2 = $as_Llaika_ast_Block($f_Llaika_ast_SpanContainerCompanion__apply__Llaika_ast_Span__sci_Seq__O(this$6, span$1, spans$1));
    var blocks$2 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Block.getArrayOf().constr)([]));
    var rootElement = $as_Llaika_ast_RootElement($f_Llaika_ast_BlockContainerCompanion__apply__Llaika_ast_Block__sci_Seq__O(this$7, block$2, blocks$2));
  }
  return $p_Llaika_api_Renderer__render__Llaika_ast_Document__Llaika_ast_Element__Llaika_api_bundle_PathTranslator__Llaika_ast_styles_StyleDeclarationSet__s_util_Either(this, $m_Llaika_ast_Document$().apply__Llaika_ast_Path__Llaika_ast_RootElement__Llaika_ast_Document(path, rootElement), element, pathTranslator, styles);
});
/** @constructor */
function $c_Llaika_api_Transformer(parser, renderer) {
  this.Llaika_api_Transformer__f_parser = null;
  this.Llaika_api_Transformer__f_renderer = null;
  this.Llaika_api_Transformer__f_parser = parser;
  this.Llaika_api_Transformer__f_renderer = renderer;
}
$c_Llaika_api_Transformer.prototype = new $h_O();
$c_Llaika_api_Transformer.prototype.constructor = $c_Llaika_api_Transformer;
/** @constructor */
function $h_Llaika_api_Transformer() {
}
$h_Llaika_api_Transformer.prototype = $c_Llaika_api_Transformer.prototype;
$c_Llaika_api_Transformer.prototype.transform__T__Llaika_ast_Path__s_util_Either = (function(input, path) {
  var this$1 = $n($n(this.Llaika_api_Transformer__f_parser).parse__T__Llaika_ast_Path__s_util_Either(input, path));
  if ((this$1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$1);
    var b = $n(x2).s_util_Right__f_value;
    var doc = $as_Llaika_ast_Document(b);
    return $n(this.Llaika_api_Transformer__f_renderer).render__Llaika_ast_Document__s_util_Either(doc);
  } else {
    return this$1;
  }
});
var $d_Llaika_api_Transformer = new $TypeData().initClass($c_Llaika_api_Transformer, "laika.api.Transformer", ({
  Llaika_api_Transformer: 1
}));
/** @constructor */
function $c_Llaika_api_Transformer$() {
}
$c_Llaika_api_Transformer$.prototype = new $h_O();
$c_Llaika_api_Transformer$.prototype.constructor = $c_Llaika_api_Transformer$;
/** @constructor */
function $h_Llaika_api_Transformer$() {
}
$h_Llaika_api_Transformer$.prototype = $c_Llaika_api_Transformer$.prototype;
$c_Llaika_api_Transformer$.prototype.from__Llaika_api_format_MarkupFormat__Llaika_api_Transformer$Builder = (function(format) {
  return new $c_Llaika_api_Transformer$Builder(format, $n($m_Llaika_api_builder_OperationConfig$().Llaika_api_builder_OperationConfig$__f_default).withBundlesFor__Llaika_api_format_MarkupFormat__Llaika_api_builder_OperationConfig(format));
});
var $d_Llaika_api_Transformer$ = new $TypeData().initClass($c_Llaika_api_Transformer$, "laika.api.Transformer$", ({
  Llaika_api_Transformer$: 1
}));
var $n_Llaika_api_Transformer$;
function $m_Llaika_api_Transformer$() {
  if ((!$n_Llaika_api_Transformer$)) {
    $n_Llaika_api_Transformer$ = new $c_Llaika_api_Transformer$();
  }
  return $n_Llaika_api_Transformer$;
}
/** @constructor */
function $c_Llaika_api_Transformer$Builder(parser, config) {
  this.Llaika_api_Transformer$Builder__f_parser = null;
  this.Llaika_api_Transformer$Builder__f_config = null;
  this.Llaika_api_Transformer$Builder__f_parser = parser;
  this.Llaika_api_Transformer$Builder__f_config = config;
}
$c_Llaika_api_Transformer$Builder.prototype = new $h_O();
$c_Llaika_api_Transformer$Builder.prototype.constructor = $c_Llaika_api_Transformer$Builder;
/** @constructor */
function $h_Llaika_api_Transformer$Builder() {
}
$h_Llaika_api_Transformer$Builder.prototype = $c_Llaika_api_Transformer$Builder.prototype;
$c_Llaika_api_Transformer$Builder.prototype.to__Llaika_api_format_RenderFormat__Llaika_api_builder_TransformerBuilder = (function(format) {
  return new $c_Llaika_api_builder_TransformerBuilder(this.Llaika_api_Transformer$Builder__f_parser, format, this.Llaika_api_Transformer$Builder__f_config);
});
var $d_Llaika_api_Transformer$Builder = new $TypeData().initClass($c_Llaika_api_Transformer$Builder, "laika.api.Transformer$Builder", ({
  Llaika_api_Transformer$Builder: 1
}));
function $f_Llaika_api_builder_CommonBuilderOps__using__sci_Seq__O($thiz, bundles) {
  return $thiz.withConfig__Llaika_api_builder_OperationConfig__O($n($thiz.config__Llaika_api_builder_OperationConfig()).withBundles__sci_Seq__Llaika_api_builder_OperationConfig(bundles));
}
function $p_Llaika_api_builder_OperationConfig__mergedBundle__Llaika_api_bundle_ExtensionBundle($thiz) {
  if ((!$thiz.Llaika_api_builder_OperationConfig__f_mergedBundlebitmap$1)) {
    $thiz.Llaika_api_builder_OperationConfig__f_mergedBundle$lzy1 = $m_Llaika_api_builder_OperationConfig$().laika$api$builder$OperationConfig$$$mergeBundles__sci_Seq__Llaika_api_bundle_ExtensionBundle($n($thiz.Llaika_api_builder_OperationConfig__f_bundleFilter).apply__sci_Seq__sci_Seq($thiz.Llaika_api_builder_OperationConfig__f_bundles));
    $thiz.Llaika_api_builder_OperationConfig__f_mergedBundlebitmap$1 = true;
  }
  return $thiz.Llaika_api_builder_OperationConfig__f_mergedBundle$lzy1;
}
/** @constructor */
function $c_Llaika_api_builder_OperationConfig(bundles, bundleFilter, configBuilder, messageFilters, compactRendering) {
  this.Llaika_api_builder_OperationConfig__f_bundles = null;
  this.Llaika_api_builder_OperationConfig__f_bundleFilter = null;
  this.Llaika_api_builder_OperationConfig__f_configBuilder = null;
  this.Llaika_api_builder_OperationConfig__f_messageFilters = null;
  this.Llaika_api_builder_OperationConfig__f_compactRendering = false;
  this.Llaika_api_builder_OperationConfig__f_mergedBundle$lzy1 = null;
  this.Llaika_api_builder_OperationConfig__f_mergedBundlebitmap$1 = false;
  this.Llaika_api_builder_OperationConfig__f_baseConfig$lzy1 = null;
  this.Llaika_api_builder_OperationConfig__f_baseConfigbitmap$1 = false;
  this.Llaika_api_builder_OperationConfig__f_markupExtensions$lzy1 = null;
  this.Llaika_api_builder_OperationConfig__f_markupExtensionsbitmap$1 = false;
  this.Llaika_api_builder_OperationConfig__f_configProvider$lzy1 = null;
  this.Llaika_api_builder_OperationConfig__f_configProviderbitmap$1 = false;
  this.Llaika_api_builder_OperationConfig__f_slugBuilder$lzy1 = null;
  this.Llaika_api_builder_OperationConfig__f_slugBuilderbitmap$1 = false;
  this.Llaika_api_builder_OperationConfig__f_bundles = bundles;
  this.Llaika_api_builder_OperationConfig__f_bundleFilter = bundleFilter;
  this.Llaika_api_builder_OperationConfig__f_configBuilder = configBuilder;
  this.Llaika_api_builder_OperationConfig__f_messageFilters = messageFilters;
  this.Llaika_api_builder_OperationConfig__f_compactRendering = compactRendering;
}
$c_Llaika_api_builder_OperationConfig.prototype = new $h_O();
$c_Llaika_api_builder_OperationConfig.prototype.constructor = $c_Llaika_api_builder_OperationConfig;
/** @constructor */
function $h_Llaika_api_builder_OperationConfig() {
}
$h_Llaika_api_builder_OperationConfig.prototype = $c_Llaika_api_builder_OperationConfig.prototype;
$c_Llaika_api_builder_OperationConfig.prototype.baseConfig__Llaika_api_config_Config = (function() {
  if ((!this.Llaika_api_builder_OperationConfig__f_baseConfigbitmap$1)) {
    this.Llaika_api_builder_OperationConfig__f_baseConfig$lzy1 = $n(this.Llaika_api_builder_OperationConfig__f_configBuilder).build__Llaika_api_config_Config__Llaika_api_config_Config($n($p_Llaika_api_builder_OperationConfig__mergedBundle__Llaika_api_bundle_ExtensionBundle(this)).baseConfig__Llaika_api_config_Config());
    this.Llaika_api_builder_OperationConfig__f_baseConfigbitmap$1 = true;
  }
  return this.Llaika_api_builder_OperationConfig__f_baseConfig$lzy1;
});
$c_Llaika_api_builder_OperationConfig.prototype.markupExtensions__Llaika_api_bundle_MarkupExtensions = (function() {
  if ((!this.Llaika_api_builder_OperationConfig__f_markupExtensionsbitmap$1)) {
    this.Llaika_api_builder_OperationConfig__f_markupExtensions$lzy1 = $n($n($p_Llaika_api_builder_OperationConfig__mergedBundle__Llaika_api_bundle_ExtensionBundle(this)).parsers__Llaika_api_bundle_ParserBundle()).markupExtensions__Llaika_api_bundle_MarkupExtensions();
    this.Llaika_api_builder_OperationConfig__f_markupExtensionsbitmap$1 = true;
  }
  return this.Llaika_api_builder_OperationConfig__f_markupExtensions$lzy1;
});
$c_Llaika_api_builder_OperationConfig.prototype.configProvider__Llaika_api_bundle_ConfigProvider = (function() {
  if ((!this.Llaika_api_builder_OperationConfig__f_configProviderbitmap$1)) {
    var this$1 = $n($n($n($p_Llaika_api_builder_OperationConfig__mergedBundle__Llaika_api_bundle_ExtensionBundle(this)).parsers__Llaika_api_bundle_ParserBundle()).Llaika_api_bundle_ParserBundle__f_configProvider);
    var default$1 = $as_Llaika_api_bundle_ConfigProvider((this$1.isEmpty__Z() ? $m_Llaika_api_bundle_ConfigProvider$().Llaika_api_bundle_ConfigProvider$__f_empty : this$1.get__O()));
    if ($n(this.Llaika_api_builder_OperationConfig__f_bundleFilter).Llaika_api_builder_BundleFilter__f_strict) {
      var this$2 = $n(default$1);
      var $x_1 = new $c_Llaika_api_bundle_ConfigProvider$$anon$1(this$2);
    } else {
      var $x_1 = default$1;
    }
    this.Llaika_api_builder_OperationConfig__f_configProvider$lzy1 = $x_1;
    this.Llaika_api_builder_OperationConfig__f_configProviderbitmap$1 = true;
  }
  return this.Llaika_api_builder_OperationConfig__f_configProvider$lzy1;
});
$c_Llaika_api_builder_OperationConfig.prototype.slugBuilder__F1 = (function() {
  if ((!this.Llaika_api_builder_OperationConfig__f_slugBuilderbitmap$1)) {
    var this$1 = $n($n($p_Llaika_api_builder_OperationConfig__mergedBundle__Llaika_api_bundle_ExtensionBundle(this)).slugBuilder__s_Option());
    this.Llaika_api_builder_OperationConfig__f_slugBuilder$lzy1 = $as_F1((this$1.isEmpty__Z() ? new $c_sjsr_AnonFunction1(((text) => {
      var text$1 = $as_T(text);
      return $m_Llaika_api_bundle_SlugBuilder$().default__T__T(text$1);
    })) : this$1.get__O()));
    this.Llaika_api_builder_OperationConfig__f_slugBuilderbitmap$1 = true;
  }
  return this.Llaika_api_builder_OperationConfig__f_slugBuilder$lzy1;
});
$c_Llaika_api_builder_OperationConfig.prototype.rewriteRulesFor__Llaika_ast_DocumentTreeRoot__Llaika_ast_RewritePhase__F1 = (function(root, phase) {
  var $x_1 = $m_Llaika_ast_RewriteRules$();
  var this$1 = $n($as_s_Option($n($n($n($p_Llaika_api_builder_OperationConfig__mergedBundle__Llaika_api_bundle_ExtensionBundle(this)).rewriteRules__s_PartialFunction()).lift__F1()).apply__O__O(phase)));
  var this$2 = $n($as_sc_IterableOps((this$1.isEmpty__Z() ? $m_sci_Nil$() : this$1.get__O())));
  var suffix = $m_Llaika_ast_RewriteRules$().defaultsFor__Llaika_ast_DocumentTreeRoot__Llaika_ast_RewritePhase__F1__sci_Seq(root, phase, this.slugBuilder__F1());
  var baseRules = $n($x_1).chainFactories__sci_Seq__F1($as_sci_Seq(this$2.concat__sc_IterableOnce__O(suffix)));
  return new $c_sjsr_AnonFunction1(((cursor) => {
    var cursor$1 = $as_Llaika_ast_DocumentCursor(cursor);
    var this$3 = $n($as_s_util_Either($n(baseRules).apply__O__O(cursor$1)));
    if ((this$3 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$3);
      var b = $n(x2).s_util_Right__f_value;
      var _$3 = $as_Llaika_ast_RewriteRules(b);
      return new $c_s_util_Right($m_Llaika_internal_rewrite_RecursiveResolverRules$().applyTo__Llaika_ast_DocumentCursor__Llaika_ast_RewriteRules__Llaika_ast_RewritePhase__Llaika_ast_RewriteRules(cursor$1, _$3, phase));
    } else {
      return this$3;
    }
  }));
});
$c_Llaika_api_builder_OperationConfig.prototype.rewriteRulesFor__Llaika_ast_Document__Llaika_ast_RewritePhase__s_util_Either = (function(doc, phase) {
  var this$2 = $n($m_Llaika_ast_DocumentCursor$().apply__Llaika_ast_Document__s_Option__s_util_Either(doc, $m_s_None$()));
  if ((this$2 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$2);
    var b = $n(x2).s_util_Right__f_value;
    var cursor = $as_Llaika_ast_DocumentCursor(b);
    return $as_s_util_Either($n(this.rewriteRulesFor__Llaika_ast_DocumentTreeRoot__Llaika_ast_RewritePhase__F1($n($n(cursor).root__Llaika_ast_RootCursor()).Llaika_ast_RootCursor__f_target, phase)).apply__O__O(cursor));
  } else {
    return this$2;
  }
});
$c_Llaika_api_builder_OperationConfig.prototype.renderOverridesFor__Llaika_api_format_RenderFormat__Llaika_api_format_RenderFormat$Overrides = (function(format) {
  var this$2 = $n($as_sc_SeqOps($n($n($p_Llaika_api_builder_OperationConfig__mergedBundle__Llaika_api_bundle_ExtensionBundle(this)).renderOverrides__sci_Seq()).collect__s_PartialFunction__O(new $c_Llaika_api_builder_OperationConfig$$anon$1(format))));
  var elem = $n($n(format).Overrides__Llaika_api_format_RenderFormat$Overrides$()).apply__s_PartialFunction__Llaika_api_format_RenderFormat$Overrides(($n($n(format).Overrides__Llaika_api_format_RenderFormat$Overrides$()), $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf));
  return $as_Llaika_api_format_RenderFormat$Overrides($n($as_sc_IterableOnceOps(this$2.appended__O__O(elem))).reduceLeft__F2__O(new $c_sjsr_AnonFunction2(((_$4, _$5) => {
    var _$4$1 = $as_Llaika_api_format_RenderFormat$Overrides(_$4);
    var _$5$1 = $as_Llaika_api_format_RenderFormat$Overrides(_$5);
    return $n(_$4$1).withBase__Llaika_api_format_RenderFormat$Overrides__Llaika_api_format_RenderFormat$Overrides(_$5$1);
  }))));
});
$c_Llaika_api_builder_OperationConfig.prototype.withBundles__sci_Seq__Llaika_api_builder_OperationConfig = (function(bundles) {
  var this$1 = $n(this.Llaika_api_builder_OperationConfig__f_bundles);
  var bundles$1 = $as_sci_Seq(this$1.appendedAll__sc_IterableOnce__O(bundles));
  var bundleFilter = this.Llaika_api_builder_OperationConfig__f_bundleFilter;
  var configBuilder = this.Llaika_api_builder_OperationConfig__f_configBuilder;
  var messageFilters = this.Llaika_api_builder_OperationConfig__f_messageFilters;
  var compactRendering = this.Llaika_api_builder_OperationConfig__f_compactRendering;
  return new $c_Llaika_api_builder_OperationConfig(bundles$1, bundleFilter, configBuilder, messageFilters, compactRendering);
});
$c_Llaika_api_builder_OperationConfig.prototype.withBundlesFor__Llaika_api_format_MarkupFormat__Llaika_api_builder_OperationConfig = (function(parser) {
  var docTypeMatcher = new $c_Llaika_api_builder_OperationConfig$$anon$2(parser);
  var this$1 = $n(this.Llaika_api_builder_OperationConfig__f_bundles);
  var suffix = $n(parser).Llaika_format_Markdown$__f_extensions;
  var this$2 = $n($as_sc_SeqOps(this$1.appendedAll__sc_IterableOnce__O(suffix)));
  var bundles = $as_sci_Seq(this$2.appended__O__O(docTypeMatcher));
  var bundleFilter = this.Llaika_api_builder_OperationConfig__f_bundleFilter;
  var configBuilder = this.Llaika_api_builder_OperationConfig__f_configBuilder;
  var messageFilters = this.Llaika_api_builder_OperationConfig__f_messageFilters;
  var compactRendering = this.Llaika_api_builder_OperationConfig__f_compactRendering;
  return new $c_Llaika_api_builder_OperationConfig(bundles, bundleFilter, configBuilder, messageFilters, compactRendering);
});
var $d_Llaika_api_builder_OperationConfig = new $TypeData().initClass($c_Llaika_api_builder_OperationConfig, "laika.api.builder.OperationConfig", ({
  Llaika_api_builder_OperationConfig: 1
}));
function $p_Llaika_api_builder_OperationConfig$__processBundles$1__sci_List__sci_List__sci_List($thiz, past, pending) {
  var pending$tailLocal1 = pending;
  var past$tailLocal1 = past;
  while (true) {
    var x9 = pending$tailLocal1;
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x9)) {
      return past$tailLocal1;
    }
    if ((x9 instanceof $c_sci_$colon$colon)) {
      var x10 = $as_sci_$colon$colon(x9);
      var x12 = $n(x10).sci_$colon$colon__f_next;
      var next = $as_Llaika_api_bundle_ExtensionBundle($n(x10).sci_$colon$colon__f_head);
      var this$3 = $n(past$tailLocal1);
      var f = ((next) => ((ex) => {
        var ex$1 = $as_Llaika_api_bundle_ExtensionBundle(ex);
        var this$2 = $n($as_s_Option($n($n($n(next).processExtension__s_PartialFunction()).lift__F1()).apply__O__O(ex$1)));
        return $as_Llaika_api_bundle_ExtensionBundle((this$2.isEmpty__Z() ? ex$1 : this$2.get__O()));
      }))(next);
      if ((this$3 === $m_sci_Nil$())) {
        var $x_1 = $m_sci_Nil$();
      } else {
        var arg1 = this$3.head__O();
        var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
        var t = h;
        var rest = $as_sci_List(this$3.tail__O());
        while ((rest !== $m_sci_Nil$())) {
          var arg1$1 = $n(rest).head__O();
          var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
          $n(t).sci_$colon$colon__f_next = nx;
          t = nx;
          rest = $as_sci_List($n(rest).tail__O());
        }
        var $x_1 = h;
      }
      var this$4 = $n($x_1);
      var newPast = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$4, next));
      var this$6 = $n(x12);
      var f$1 = ((next) => ((ex$2) => {
        var ex$3 = $as_Llaika_api_bundle_ExtensionBundle(ex$2);
        var this$5 = $n($as_s_Option($n($n($n(next).processExtension__s_PartialFunction()).lift__F1()).apply__O__O(ex$3)));
        return $as_Llaika_api_bundle_ExtensionBundle((this$5.isEmpty__Z() ? ex$3 : this$5.get__O()));
      }))(next);
      if ((this$6 === $m_sci_Nil$())) {
        var newPending = $m_sci_Nil$();
      } else {
        var arg1$2 = this$6.head__O();
        var h$1 = new $c_sci_$colon$colon(f$1(arg1$2), $m_sci_Nil$());
        var t$1 = h$1;
        var rest$1 = $as_sci_List(this$6.tail__O());
        while ((rest$1 !== $m_sci_Nil$())) {
          var arg1$3 = $n(rest$1).head__O();
          var nx$1 = new $c_sci_$colon$colon(f$1(arg1$3), $m_sci_Nil$());
          $n(t$1).sci_$colon$colon__f_next = nx$1;
          t$1 = nx$1;
          rest$1 = $as_sci_List($n(rest$1).tail__O());
        }
        var newPending = h$1;
      }
      past$tailLocal1 = newPast;
      pending$tailLocal1 = newPending;
      continue;
    }
    throw new $c_s_MatchError(x9);
  }
}
/** @constructor */
function $c_Llaika_api_builder_OperationConfig$() {
  this.Llaika_api_builder_OperationConfig$__f_originOrder = null;
  this.Llaika_api_builder_OperationConfig$__f_default = null;
  $n_Llaika_api_builder_OperationConfig$ = this;
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_bundle_BundleOrigin.getArrayOf().constr)([$m_Llaika_api_bundle_BundleOrigin$Library$(), $m_Llaika_api_bundle_BundleOrigin$Parser$(), $m_Llaika_api_bundle_BundleOrigin$Theme$(), $m_Llaika_api_bundle_BundleOrigin$Mixed$(), $m_Llaika_api_bundle_BundleOrigin$User$()]));
  this.Llaika_api_builder_OperationConfig$__f_originOrder = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  this.Llaika_api_builder_OperationConfig$__f_default = new $c_Llaika_api_builder_OperationConfig($as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_bundle_ExtensionBundle.getArrayOf().constr)([$m_Llaika_api_bundle_ExtensionBundle$LaikaDefaults$(), $m_Llaika_internal_directive_DirectiveSupport$(), $m_Llaika_internal_directive_StandardDirectives$()])))), ($m_Llaika_api_builder_OperationConfig$(), new $c_Llaika_api_builder_BundleFilter(false, false)), ($m_Llaika_api_builder_OperationConfig$(), $m_Llaika_api_config_ConfigBuilder$().Llaika_api_config_ConfigBuilder$__f_empty), ($m_Llaika_api_builder_OperationConfig$(), $m_Llaika_config_MessageFilters$().Llaika_config_MessageFilters$__f_defaults), ($m_Llaika_api_builder_OperationConfig$(), false));
  $m_Llaika_api_builder_OperationConfig$();
  $m_Llaika_api_builder_OperationConfig$();
  $m_Llaika_api_builder_OperationConfig$();
  $m_Llaika_api_config_ConfigBuilder$();
  $m_Llaika_api_builder_OperationConfig$();
  $m_Llaika_config_MessageFilters$();
  $m_Llaika_api_builder_OperationConfig$();
}
$c_Llaika_api_builder_OperationConfig$.prototype = new $h_O();
$c_Llaika_api_builder_OperationConfig$.prototype.constructor = $c_Llaika_api_builder_OperationConfig$;
/** @constructor */
function $h_Llaika_api_builder_OperationConfig$() {
}
$h_Llaika_api_builder_OperationConfig$.prototype = $c_Llaika_api_builder_OperationConfig$.prototype;
$c_Llaika_api_builder_OperationConfig$.prototype.laika$api$builder$OperationConfig$$$sortBundles__sci_Seq__sci_Seq = (function(bundles) {
  var this$3 = $n($as_sc_SeqOps($n(bundles).distinct__O()));
  var f = new $c_sjsr_AnonFunction1(((b) => {
    var b$1 = $as_Llaika_api_bundle_ExtensionBundle(b);
    var this$2 = $n(this.Llaika_api_builder_OperationConfig$__f_originOrder);
    var elem = $n(b$1).origin__Llaika_api_bundle_BundleOrigin();
    return $f_sc_SeqOps__indexOf__O__I__I(this$2, elem, 0);
  }));
  var ord = $m_s_math_Ordering$Int$();
  return $as_sci_Seq($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$3, f, ord));
});
$c_Llaika_api_builder_OperationConfig$.prototype.laika$api$builder$OperationConfig$$$mergeBundles__sci_Seq__Llaika_api_bundle_ExtensionBundle = (function(bundles) {
  var this$3 = $n($n($p_Llaika_api_builder_OperationConfig$__processBundles$1__sci_List__sci_List__sci_List(this, $m_sci_Nil$(), $n(this.laika$api$builder$OperationConfig$$$sortBundles__sci_Seq__sci_Seq(bundles)).toList__sci_List())).reverse__sci_List());
  var f = ((_$8, _$9) => {
    var _$8$1 = $as_Llaika_api_bundle_ExtensionBundle(_$8);
    var _$9$1 = $as_Llaika_api_bundle_ExtensionBundle(_$9);
    var this$2 = $n(_$8$1);
    return new $c_Llaika_api_bundle_ExtensionBundle$$anon$1(_$9$1, this$2);
  });
  var x1 = this$3.knownSize__I();
  switch (x1) {
    case (-1): {
      var it = this$3.iterator__sc_Iterator();
      if ($n(it).hasNext__Z()) {
        var acc = $n(it).next__O();
        while ($n(it).hasNext__Z()) {
          var arg1 = acc;
          var arg2 = $n(it).next__O();
          acc = f(arg1, arg2);
        }
        var $x_1 = new $c_s_Some(acc);
      } else {
        var $x_1 = $m_s_None$();
      }
      break;
    }
    case 0: {
      var $x_1 = $m_s_None$();
      break;
    }
    default: {
      matchEnd4: {
        var $x_2;
        if ($is_sc_IndexedSeq(this$3)) {
          var x2 = $as_sc_IndexedSeq(this$3);
          if (($n(x2).length__I() > 0)) {
            var z = $n(x2).apply__I__O(0);
            var at = 1;
            var end = $n(x2).length__I();
            var acc$1 = z;
            while (true) {
              if ((at === end)) {
                var $x_2 = acc$1;
                break matchEnd4;
              } else {
                var temp$at = ((1 + at) | 0);
                var arg1$1 = acc$1;
                var arg2$1 = $n(x2).apply__I__O(at);
                var temp$acc = f(arg1$1, arg2$1);
                at = temp$at;
                acc$1 = temp$acc;
              }
            }
          }
        }
        if ((this$3.knownSize__I() === 0)) {
          throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
        }
        var it$1 = this$3.iterator__sc_Iterator();
        if ($n(it$1).hasNext__Z()) {
          var acc$2 = $n(it$1).next__O();
          while ($n(it$1).hasNext__Z()) {
            var arg1$2 = acc$2;
            var arg2$2 = $n(it$1).next__O();
            acc$2 = f(arg1$2, arg2$2);
          }
          var $x_2 = acc$2;
        } else {
          throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
        }
      }
      var $x_1 = new $c_s_Some($x_2);
    }
  }
  var this$4 = $n($x_1);
  return $as_Llaika_api_bundle_ExtensionBundle((this$4.isEmpty__Z() ? $m_Llaika_api_bundle_ExtensionBundle$().Llaika_api_bundle_ExtensionBundle$__f_empty : this$4.get__O()));
});
var $d_Llaika_api_builder_OperationConfig$ = new $TypeData().initClass($c_Llaika_api_builder_OperationConfig$, "laika.api.builder.OperationConfig$", ({
  Llaika_api_builder_OperationConfig$: 1
}));
var $n_Llaika_api_builder_OperationConfig$;
function $m_Llaika_api_builder_OperationConfig$() {
  if ((!$n_Llaika_api_builder_OperationConfig$)) {
    $n_Llaika_api_builder_OperationConfig$ = new $c_Llaika_api_builder_OperationConfig$();
  }
  return $n_Llaika_api_builder_OperationConfig$;
}
/** @constructor */
function $c_Llaika_api_bundle_AttributeKey() {
}
$c_Llaika_api_bundle_AttributeKey.prototype = new $h_O();
$c_Llaika_api_bundle_AttributeKey.prototype.constructor = $c_Llaika_api_bundle_AttributeKey;
/** @constructor */
function $h_Llaika_api_bundle_AttributeKey() {
}
$h_Llaika_api_bundle_AttributeKey.prototype = $c_Llaika_api_bundle_AttributeKey.prototype;
/** @constructor */
function $c_Llaika_api_bundle_BlockParserBuilder$() {
}
$c_Llaika_api_bundle_BlockParserBuilder$.prototype = new $h_O();
$c_Llaika_api_bundle_BlockParserBuilder$.prototype.constructor = $c_Llaika_api_bundle_BlockParserBuilder$;
/** @constructor */
function $h_Llaika_api_bundle_BlockParserBuilder$() {
}
$h_Llaika_api_bundle_BlockParserBuilder$.prototype = $c_Llaika_api_bundle_BlockParserBuilder$.prototype;
$c_Llaika_api_bundle_BlockParserBuilder$.prototype.standalone__Llaika_parse_Parser__Llaika_api_bundle_BlockParserBuilder = (function(parser) {
  return new $c_Llaika_api_bundle_BlockParserBuilder(new $c_sjsr_AnonFunction1(((_$2) => {
    $as_Llaika_parse_markup_RecursiveParsers(_$2);
    return parser;
  })), false, $m_Llaika_api_bundle_BlockPosition$Any$(), $m_Llaika_api_bundle_Precedence$High$(), $m_s_None$());
});
var $d_Llaika_api_bundle_BlockParserBuilder$ = new $TypeData().initClass($c_Llaika_api_bundle_BlockParserBuilder$, "laika.api.bundle.BlockParserBuilder$", ({
  Llaika_api_bundle_BlockParserBuilder$: 1
}));
var $n_Llaika_api_bundle_BlockParserBuilder$;
function $m_Llaika_api_bundle_BlockParserBuilder$() {
  if ((!$n_Llaika_api_bundle_BlockParserBuilder$)) {
    $n_Llaika_api_bundle_BlockParserBuilder$ = new $c_Llaika_api_bundle_BlockParserBuilder$();
  }
  return $n_Llaika_api_bundle_BlockParserBuilder$;
}
var $d_Llaika_api_bundle_BundleOrigin = new $TypeData().initClass(1, "laika.api.bundle.BundleOrigin", ({
  Llaika_api_bundle_BundleOrigin: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_ConfigHeaderParser$() {
}
$c_Llaika_api_bundle_ConfigHeaderParser$.prototype = new $h_O();
$c_Llaika_api_bundle_ConfigHeaderParser$.prototype.constructor = $c_Llaika_api_bundle_ConfigHeaderParser$;
/** @constructor */
function $h_Llaika_api_bundle_ConfigHeaderParser$() {
}
$h_Llaika_api_bundle_ConfigHeaderParser$.prototype = $c_Llaika_api_bundle_ConfigHeaderParser$.prototype;
$c_Llaika_api_bundle_ConfigHeaderParser$.prototype.betweenLines__T__T__Llaika_parse_Parser = (function(startDelim, endDelim) {
  var $x_2 = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_blankLine;
  var this$1 = $m_Llaika_parse_builders$();
  var p = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_eof;
  var this$2 = $n($n($x_2).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($f_Llaika_parse_combinator_Parsers__not__Llaika_parse_Parser__Llaika_parse_Parser(this$1, p)));
  var $x_1 = $n(new $c_Llaika_parse_combinator_Repeat(this$2, 0, 2147483647, $m_s_None$()).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters())).$tilde__T__Llaika_parse_Parser(startDelim);
  var this$4 = $m_Llaika_parse_builders$();
  var parser = $n($n($x_1).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($f_Llaika_parse_text_TextParsers__delimitedBy__T__Llaika_parse_text_DelimitedText(this$4, endDelim))).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser($m_Llaika_parse_builders$().Llaika_parse_builders$__f_wsEol);
  return this.forTextParser__Llaika_parse_Parser__Llaika_parse_Parser(parser);
});
$c_Llaika_api_bundle_ConfigHeaderParser$.prototype.forTextParser__Llaika_parse_Parser__Llaika_parse_Parser = (function(parser) {
  return $n(parser).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((input) => {
    var input$1 = $as_T(input);
    var this$2 = $m_Llaika_api_config_ConfigParser$();
    return new $c_Llaika_api_config_ConfigParser$$anon$1(input$1, this$2);
  })));
});
var $d_Llaika_api_bundle_ConfigHeaderParser$ = new $TypeData().initClass($c_Llaika_api_bundle_ConfigHeaderParser$, "laika.api.bundle.ConfigHeaderParser$", ({
  Llaika_api_bundle_ConfigHeaderParser$: 1
}));
var $n_Llaika_api_bundle_ConfigHeaderParser$;
function $m_Llaika_api_bundle_ConfigHeaderParser$() {
  if ((!$n_Llaika_api_bundle_ConfigHeaderParser$)) {
    $n_Llaika_api_bundle_ConfigHeaderParser$ = new $c_Llaika_api_bundle_ConfigHeaderParser$();
  }
  return $n_Llaika_api_bundle_ConfigHeaderParser$;
}
function $is_Llaika_api_bundle_ConfigProvider(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_api_bundle_ConfigProvider)));
}
function $as_Llaika_api_bundle_ConfigProvider(obj) {
  return (($is_Llaika_api_bundle_ConfigProvider(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.ConfigProvider"));
}
function $isArrayOf_Llaika_api_bundle_ConfigProvider(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_ConfigProvider)));
}
function $asArrayOf_Llaika_api_bundle_ConfigProvider(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_ConfigProvider(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.ConfigProvider;", depth));
}
/** @constructor */
function $c_Llaika_api_bundle_ConfigProvider$() {
  this.Llaika_api_bundle_ConfigProvider$__f_empty = null;
  $n_Llaika_api_bundle_ConfigProvider$ = this;
  this.Llaika_api_bundle_ConfigProvider$__f_empty = new $c_Llaika_api_bundle_ConfigProvider$$anon$2();
}
$c_Llaika_api_bundle_ConfigProvider$.prototype = new $h_O();
$c_Llaika_api_bundle_ConfigProvider$.prototype.constructor = $c_Llaika_api_bundle_ConfigProvider$;
/** @constructor */
function $h_Llaika_api_bundle_ConfigProvider$() {
}
$h_Llaika_api_bundle_ConfigProvider$.prototype = $c_Llaika_api_bundle_ConfigProvider$.prototype;
var $d_Llaika_api_bundle_ConfigProvider$ = new $TypeData().initClass($c_Llaika_api_bundle_ConfigProvider$, "laika.api.bundle.ConfigProvider$", ({
  Llaika_api_bundle_ConfigProvider$: 1
}));
var $n_Llaika_api_bundle_ConfigProvider$;
function $m_Llaika_api_bundle_ConfigProvider$() {
  if ((!$n_Llaika_api_bundle_ConfigProvider$)) {
    $n_Llaika_api_bundle_ConfigProvider$ = new $c_Llaika_api_bundle_ConfigProvider$();
  }
  return $n_Llaika_api_bundle_ConfigProvider$;
}
function $f_Llaika_api_bundle_DirectiveBuilderContext__eval__T__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$Directive($thiz, name, part) {
  var this$2 = $n(part);
  var f = new $c_sjsr_AnonFunction1(((x) => {
    var x$1 = $as_s_util_Either(x);
    return x$1;
  }));
  return new $c_Llaika_api_bundle_DirectiveBuilderContext$Directive($thiz, name, new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$3(f, this$2));
}
function $f_Llaika_api_bundle_DirectiveBuilderContext__toMap__sc_Iterable__sci_Map($thiz, directives) {
  var $x_1 = $n($as_sc_IterableOnceOps($n(directives).map__F1__O(new $c_sjsr_AnonFunction1(((dir) => {
    var dir$1 = $as_Llaika_api_bundle_DirectiveBuilderContext$Directive(dir);
    var _1 = $n(dir$1).Llaika_api_bundle_DirectiveBuilderContext$Directive__f_name;
    return new $c_T2(_1, dir$1);
  })))));
  var this$2 = $m_s_$less$colon$less$();
  return $n($x_1).toMap__s_$less$colon$less__sci_Map(this$2.s_$less$colon$less$__f_singleton);
}
function $s_Llaika_api_bundle_DirectiveBuilderContext__laika$api$bundle$DirectiveBuilderContext$Combinators$SeparatedBodyPart$$_$splitNextBodyPart$1__sci_Seq__T2(remaining) {
  return $n(remaining).span__F1__T2(new $c_sjsr_AnonFunction1(((_$10) => {
    var _$10$1 = $as_Llaika_ast_Element(_$10);
    return (!$is_Llaika_api_bundle_DirectiveBuilderContext$SeparatorInstanceBase(_$10$1));
  })));
}
function $is_Llaika_api_bundle_DirectiveBuilderContext$BodyContent(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_api_bundle_DirectiveBuilderContext$BodyContent)));
}
function $as_Llaika_api_bundle_DirectiveBuilderContext$BodyContent(obj) {
  return (($is_Llaika_api_bundle_DirectiveBuilderContext$BodyContent(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.DirectiveBuilderContext$BodyContent"));
}
function $isArrayOf_Llaika_api_bundle_DirectiveBuilderContext$BodyContent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_DirectiveBuilderContext$BodyContent)));
}
function $asArrayOf_Llaika_api_bundle_DirectiveBuilderContext$BodyContent(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_DirectiveBuilderContext$BodyContent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.DirectiveBuilderContext$BodyContent;", depth));
}
function $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__laika$api$bundle$DirectiveBuilderContext$Combinators$$getParsedBody__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__s_Option($thiz, context) {
  var this$1 = $n($n(context).Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__f_body);
  if (this$1.isEmpty__Z()) {
    return $m_s_None$();
  } else {
    var arg1 = this$1.get__O();
    var x$1 = $as_Llaika_api_bundle_DirectiveBuilderContext$BodyContent(arg1);
    matchResult28: {
      var $x_1;
      if (((x$1 instanceof $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source) && ($n($as_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source(x$1)).Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source__f_$outer === $n($thiz.Llaika_api_bundle_DirectiveBuilderContext$dsl$__f_$outer).BodyContent__Llaika_api_bundle_DirectiveBuilderContext$BodyContent$()))) {
        $n($n($n($thiz.Llaika_api_bundle_DirectiveBuilderContext$dsl$__f_$outer).BodyContent__Llaika_api_bundle_DirectiveBuilderContext$BodyContent$()).Llaika_api_bundle_DirectiveBuilderContext$BodyContent$__f_Source$lzy1);
        var x$1$1 = $as_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source(x$1);
        var this$3 = $n(x$1$1);
        var x78 = this$3.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source__f_value;
        var $x_1 = $n($thiz.Llaika_api_bundle_DirectiveBuilderContext$dsl$__f_$outer).parse__O__Llaika_parse_SourceFragment__s_util_Either($n(context).Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__f_parser, x78);
        break matchResult28;
      }
      if (((x$1 instanceof $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed) && ($n($as_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed(x$1)).Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed__f_$outer === $n($thiz.Llaika_api_bundle_DirectiveBuilderContext$dsl$__f_$outer).BodyContent__Llaika_api_bundle_DirectiveBuilderContext$BodyContent$()))) {
        $n($n($n($thiz.Llaika_api_bundle_DirectiveBuilderContext$dsl$__f_$outer).BodyContent__Llaika_api_bundle_DirectiveBuilderContext$BodyContent$()).Llaika_api_bundle_DirectiveBuilderContext$BodyContent$__f_Parsed$lzy1);
        var x$1$2 = $as_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed(x$1);
        var this$5 = $n(x$1$2);
        var x75 = this$5.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed__f_value;
        var $x_1 = new $c_s_util_Right(x75);
        break matchResult28;
      }
      throw new $c_s_MatchError(x$1);
    }
    return new $c_s_Some($x_1);
  }
}
function $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($thiz, position) {
  return new $c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($thiz, new $c_Llaika_api_bundle_AttributeKey$PositionalAt(position), $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_configValue, false, new $c_sjsr_AnonFunction0((() => (("required positional attribute at index " + position) + " is missing"))));
}
function $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__T__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($thiz, key) {
  return new $c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($thiz, new $c_Llaika_api_bundle_AttributeKey$Named(key), $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_configValue, false, new $c_sjsr_AnonFunction0((() => (("required attribute '" + key) + "' is missing"))));
}
function $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__allAttributes__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart($thiz) {
  var f = new $c_sjsr_AnonFunction1(((c) => {
    var c$1 = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext(c);
    var value = $n($n(c$1).Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__f_content).Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent__f_attributes;
    return new $c_s_util_Right(value);
  }));
  return new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$11(f, $thiz);
}
function $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__parsedBody__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart($thiz) {
  var accessor = new $c_sjsr_AnonFunction1(((context) => {
    var context$1 = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext(context);
    return $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__laika$api$bundle$DirectiveBuilderContext$Combinators$$getParsedBody__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__s_Option($thiz, context$1);
  }));
  return new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$6(accessor, $thiz);
}
function $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__empty__O__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart($thiz, result) {
  var f = new $c_sjsr_AnonFunction1(((_$16) => {
    $as_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext(_$16);
    return new $c_s_util_Right(result);
  }));
  return new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$11(f, $thiz);
}
function $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__source__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart($thiz) {
  var f = new $c_sjsr_AnonFunction1(((c) => {
    var c$1 = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext(c);
    var value = $n(c$1).Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__f_source;
    return new $c_s_util_Right(value);
  }));
  return new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$11(f, $thiz);
}
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$Directive(outer, name, part) {
  this.Llaika_api_bundle_DirectiveBuilderContext$Directive__f_name = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$Directive__f_part = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$Directive__f_name = name;
  this.Llaika_api_bundle_DirectiveBuilderContext$Directive__f_part = part;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_api_bundle_DirectiveBuilderContext$Directive.prototype = new $h_O();
$c_Llaika_api_bundle_DirectiveBuilderContext$Directive.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$Directive;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$Directive() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$Directive.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$Directive.prototype;
$c_Llaika_api_bundle_DirectiveBuilderContext$Directive.prototype.apply__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__s_util_Either = (function(context) {
  return $n(this.Llaika_api_bundle_DirectiveBuilderContext$Directive__f_part).apply__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__s_util_Either(context);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$Directive.prototype.hasBody__Z = (function() {
  return $n(this.Llaika_api_bundle_DirectiveBuilderContext$Directive__f_part).hasBody__Z();
});
$c_Llaika_api_bundle_DirectiveBuilderContext$Directive.prototype.separators__sci_Set = (function() {
  return $n(this.Llaika_api_bundle_DirectiveBuilderContext$Directive__f_part).separators__sci_Set();
});
$c_Llaika_api_bundle_DirectiveBuilderContext$Directive.prototype.runsIn__Llaika_ast_RewritePhase__Z = (function(phase) {
  if ((phase instanceof $c_Llaika_ast_RewritePhase$Render)) {
    var x$1 = $as_Llaika_ast_RewritePhase$Render(phase);
    var this$2 = $n(x$1);
    return true;
  } else {
    return (!$n(this.Llaika_api_bundle_DirectiveBuilderContext$Directive__f_part).needsCursor__Z());
  }
});
function $as_Llaika_api_bundle_DirectiveBuilderContext$Directive(obj) {
  return (((obj instanceof $c_Llaika_api_bundle_DirectiveBuilderContext$Directive) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.DirectiveBuilderContext$Directive"));
}
function $isArrayOf_Llaika_api_bundle_DirectiveBuilderContext$Directive(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_DirectiveBuilderContext$Directive)));
}
function $asArrayOf_Llaika_api_bundle_DirectiveBuilderContext$Directive(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_DirectiveBuilderContext$Directive(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.DirectiveBuilderContext$Directive;", depth));
}
var $d_Llaika_api_bundle_DirectiveBuilderContext$Directive = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$Directive, "laika.api.bundle.DirectiveBuilderContext$Directive", ({
  Llaika_api_bundle_DirectiveBuilderContext$Directive: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext(outer, content, parser, cursor, source) {
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__f_content = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__f_parser = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__f_cursor = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__f_source = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__f_body = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__f_$outer = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__f_content = content;
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__f_parser = parser;
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__f_cursor = cursor;
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__f_source = source;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__f_$outer = outer;
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__f_body = $n(content).Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent__f_body;
}
$c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext.prototype = new $h_O();
$c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext.prototype;
$c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext.prototype.message__Llaika_api_config_ConfigError__T = (function(error) {
  if ((error instanceof $c_Llaika_api_config_ConfigError$DecodingFailed)) {
    var de = $as_Llaika_api_config_ConfigError$DecodingFailed(error);
    return $n(de).Llaika_api_config_ConfigError$DecodingFailed__f_error;
  } else {
    return $n(error).message__T();
  }
});
$c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext.prototype.withContent__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext = (function(newContent) {
  return new $c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext(this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__f_$outer, newContent, this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__f_parser, this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__f_cursor, this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__f_source);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext.prototype.attribute__Llaika_api_bundle_AttributeKey__Llaika_api_config_ConfigDecoder__Z__s_util_Either = (function(id, decoder, inherit) {
  var this$2 = $n($n(this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__f_content).Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent__f_attributes);
  var key = $n(id).key__T();
  var this$1 = $m_Llaika_api_config_ConfigDecoder$();
  var decoder$1 = new $c_Llaika_api_config_ConfigDecoder$$anon$9(decoder, this$1);
  var this$3 = $n($f_Llaika_api_config_Config__getOpt__T__Llaika_api_config_ConfigDecoder__s_util_Either(this$2, key, decoder$1));
  if ((this$3 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$3);
    var b = $n(x2).s_util_Right__f_value;
    var _$1 = $as_s_Option(b);
    var this$4 = $n(_$1);
    if (this$4.isEmpty__Z()) {
      var $x_2 = $m_s_None$();
    } else {
      var arg1 = this$4.get__O();
      var traced = $as_Llaika_api_config_Traced(arg1);
      var x = $n($n(traced).Llaika_api_config_Traced__f_origin).Llaika_api_config_Origin__f_scope;
      var x$2 = $m_Llaika_api_config_Origin$DirectiveScope$();
      if ((x !== null)) {
        var this$5 = $n(x);
        var $x_3 = (this$5 === x$2);
      } else {
        var $x_3 = false;
      }
      if (($x_3 || inherit)) {
        var value = $n(traced).Llaika_api_config_Traced__f_value;
        var $x_2 = new $c_s_Some(value);
      } else {
        var $x_2 = $m_s_None$();
      }
    }
    var $x_1 = new $c_s_util_Right($x_2);
  } else {
    var $x_1 = this$3;
  }
  var this$7 = $n($x_1);
  var this$8 = new $c_s_util_Either$LeftProjection(this$7);
  var x1 = this$8.s_util_Either$LeftProjection__f_e;
  if ((x1 instanceof $c_s_util_Left)) {
    var x2$1 = $as_s_util_Left(x1);
    var a = $n(x2$1).s_util_Left__f_value;
    var e = $as_Llaika_api_config_ConfigError(a);
    return new $c_s_util_Left($as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([((("error converting " + $n(id).desc__T()) + ": ") + this.message__Llaika_api_config_ConfigError__T(e))])))));
  } else {
    return this$8.s_util_Either$LeftProjection__f_e;
  }
});
function $as_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext(obj) {
  return (((obj instanceof $c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.DirectiveBuilderContext$DirectiveContext"));
}
function $isArrayOf_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext)));
}
function $asArrayOf_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.DirectiveBuilderContext$DirectiveContext;", depth));
}
var $d_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext, "laika.api.bundle.DirectiveBuilderContext$DirectiveContext", ({
  Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext: 1
}));
function $ct_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__Llaika_api_bundle_DirectiveBuilderContext__($thiz, outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $thiz.Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__f_$outer = outer;
  return $thiz;
}
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart() {
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__f_$outer = null;
}
$c_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart.prototype = new $h_O();
$c_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart.prototype;
function $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(obj) {
  return (((obj instanceof $c_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.DirectiveBuilderContext$DirectivePart"));
}
function $isArrayOf_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_DirectiveBuilderContext$DirectivePart)));
}
function $asArrayOf_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.DirectiveBuilderContext$DirectivePart;", depth));
}
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$(outer) {
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_$outer = outer;
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$4(this);
}
$c_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$.prototype = new $h_O();
$c_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$.prototype;
var $d_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$ = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$, "laika.api.bundle.DirectiveBuilderContext$DirectivePart$", ({
  Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$: 1
}));
function $f_Llaika_api_bundle_DirectiveBuilderContext$DirectiveProcessor__process__Llaika_ast_DocumentCursor__s_Option__s_util_Either($thiz, cursor, factory) {
  var this$1 = $n($n(cursor).Llaika_ast_DocumentCursor__f_templatePath);
  var originPath = $as_Llaika_ast_Path((this$1.isEmpty__Z() ? $n(cursor).Llaika_ast_DocumentCursor__f_path : this$1.get__O()));
  $m_Llaika_api_config_Origin$();
  var scope = $m_Llaika_api_config_Origin$DirectiveScope$();
  $m_Llaika_api_config_Origin$();
  var sourcePath = $m_s_None$();
  var origin = new $c_Llaika_api_config_Origin(scope, originPath, sourcePath);
  var this$4 = $n($n($thiz.parsedResult__Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective()).Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_body);
  if (this$4.isEmpty__Z()) {
    var body = $m_s_None$();
  } else {
    var arg1 = this$4.get__O();
    var value = $as_Llaika_parse_SourceFragment(arg1);
    var body = new $c_s_Some($n($n($n($thiz.laika$api$bundle$DirectiveBuilderContext$DirectiveProcessor$$$outer__Llaika_api_bundle_DirectiveBuilderContext()).BodyContent__Llaika_api_bundle_DirectiveBuilderContext$BodyContent$()).Llaika_api_bundle_DirectiveBuilderContext$BodyContent$__f_Source$lzy1).apply__Llaika_parse_SourceFragment__Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source(value));
  }
  var this$5 = $n($p_Llaika_api_bundle_DirectiveBuilderContext$DirectiveProcessor__directiveOrMsg$1__s_Option__s_util_Either($thiz, factory));
  if ((this$5 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$5);
    var b = $n(x2).s_util_Right__f_value;
    var dir = $as_F1(b);
    var this$6 = $n($p_Llaika_api_bundle_DirectiveBuilderContext$DirectiveProcessor__attributes$2__Llaika_api_config_Origin__Llaika_ast_DocumentCursor__s_util_Either($thiz, origin, cursor));
    if ((this$6 instanceof $c_s_util_Right)) {
      var x2$1 = $as_s_util_Right(this$6);
      var b$1 = $n(x2$1).s_util_Right__f_value;
      var attrs = $as_Llaika_api_config_Config(b$1);
      var this$7 = $n($as_s_util_Either($n(dir).apply__O__O($n($n($thiz.laika$api$bundle$DirectiveBuilderContext$DirectiveProcessor$$$outer__Llaika_api_bundle_DirectiveBuilderContext()).DirectiveContent__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent$()).apply__Llaika_api_config_Config__s_Option__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent(attrs, body))));
      if ((this$7 instanceof $c_s_util_Right)) {
        var x2$2 = $as_s_util_Right(this$7);
        var b$2 = $n(x2$2).s_util_Right__f_value;
        return new $c_s_util_Right(b$2);
      } else {
        return this$7;
      }
    } else {
      return this$6;
    }
  } else {
    return this$5;
  }
}
function $p_Llaika_api_bundle_DirectiveBuilderContext$DirectiveProcessor__directiveOrMsg$1__s_Option__s_util_Either($thiz, factory$1) {
  var this$1 = $n(factory$1);
  return (this$1.isEmpty__Z() ? new $c_s_util_Left($as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([((("No " + $thiz.typeName__T()) + " directive registered with name: ") + $n($thiz.parsedResult__Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective()).Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_name)]))))) : new $c_s_util_Right(this$1.get__O()));
}
function $p_Llaika_api_bundle_DirectiveBuilderContext$DirectiveProcessor__attributes$2__Llaika_api_config_Origin__Llaika_ast_DocumentCursor__s_util_Either($thiz, origin$1, cursor$2) {
  var this$2 = $n($m_Llaika_internal_parse_hocon_ConfigResolver$().resolve__Llaika_internal_parse_hocon_ObjectBuilderValue__Llaika_api_config_Origin__Llaika_api_config_Config__sci_Map__s_util_Either($n($thiz.parsedResult__Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective()).Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_attributes, origin$1, $n(cursor$2).Llaika_ast_DocumentCursor__f_config, $m_sci_Map$EmptyMap$()));
  if ((this$2 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$2);
    var b = $n(x2).s_util_Right__f_value;
    var _$4 = $as_Llaika_api_config_ConfigValue$ObjectValue(b);
    var $x_1 = new $c_s_util_Right(new $c_Llaika_api_config_ObjectConfig(_$4, origin$1, $n(cursor$2).Llaika_ast_DocumentCursor__f_config));
  } else {
    var $x_1 = this$2;
  }
  var this$3 = $n($x_1);
  var this$4 = new $c_s_util_Either$LeftProjection(this$3);
  var x1 = this$4.s_util_Either$LeftProjection__f_e;
  if ((x1 instanceof $c_s_util_Left)) {
    var x2$1 = $as_s_util_Left(x1);
    var a = $n(x2$1).s_util_Left__f_value;
    var e = $as_Llaika_api_config_ConfigError(a);
    return new $c_s_util_Left($as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([$n(e).message__T()])))));
  } else {
    return this$4.s_util_Either$LeftProjection__f_e;
  }
}
function $is_Llaika_api_bundle_DirectiveBuilderContext$DirectiveProcessor(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_api_bundle_DirectiveBuilderContext$DirectiveProcessor)));
}
function $as_Llaika_api_bundle_DirectiveBuilderContext$DirectiveProcessor(obj) {
  return (($is_Llaika_api_bundle_DirectiveBuilderContext$DirectiveProcessor(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.DirectiveBuilderContext$DirectiveProcessor"));
}
function $isArrayOf_Llaika_api_bundle_DirectiveBuilderContext$DirectiveProcessor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_DirectiveBuilderContext$DirectiveProcessor)));
}
function $asArrayOf_Llaika_api_bundle_DirectiveBuilderContext$DirectiveProcessor(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_DirectiveBuilderContext$DirectiveProcessor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.DirectiveBuilderContext$DirectiveProcessor;", depth));
}
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective(outer, name, part, min, max) {
  this.Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective__f_name = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective__f_part = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective__f_min = 0;
  this.Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective__f_max = 0;
  this.Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective__f_name = name;
  this.Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective__f_part = part;
  this.Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective__f_min = min;
  this.Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective__f_max = max;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective.prototype = new $h_O();
$c_Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective.prototype;
$c_Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective.prototype.apply__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__s_util_Either = (function(context) {
  return $n(this.Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective__f_part).apply__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__s_util_Either(context);
});
function $as_Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective(obj) {
  return (((obj instanceof $c_Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.DirectiveBuilderContext$SeparatorDirective"));
}
function $isArrayOf_Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective)));
}
function $asArrayOf_Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.DirectiveBuilderContext$SeparatorDirective;", depth));
}
var $d_Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective, "laika.api.bundle.DirectiveBuilderContext$SeparatorDirective", ({
  Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DocumentTypeMatcher$() {
  this.Llaika_api_bundle_DocumentTypeMatcher$__f_base = null;
  $n_Llaika_api_bundle_DocumentTypeMatcher$ = this;
  this.Llaika_api_bundle_DocumentTypeMatcher$__f_base = new $c_Llaika_api_bundle_DocumentTypeMatcher$$anon$1();
}
$c_Llaika_api_bundle_DocumentTypeMatcher$.prototype = new $h_O();
$c_Llaika_api_bundle_DocumentTypeMatcher$.prototype.constructor = $c_Llaika_api_bundle_DocumentTypeMatcher$;
/** @constructor */
function $h_Llaika_api_bundle_DocumentTypeMatcher$() {
}
$h_Llaika_api_bundle_DocumentTypeMatcher$.prototype = $c_Llaika_api_bundle_DocumentTypeMatcher$.prototype;
$c_Llaika_api_bundle_DocumentTypeMatcher$.prototype.laika$api$bundle$DocumentTypeMatcher$$$staticTargetFormats__Llaika_ast_Path__Llaika_config_TargetFormats = (function(path) {
  matchResult1: {
    var $x_1;
    var x1 = $n(path).suffix__s_Option();
    matchAlts1: {
      matchAlts2: {
        if ((x1 instanceof $c_s_Some)) {
          var x5 = $as_T($n($as_s_Some(x1)).s_Some__f_value);
          if ((x5 === "css")) {
            break matchAlts2;
          }
          if ((x5 === "js")) {
            break matchAlts2;
          }
        }
        break matchAlts1;
      }
      var $x_1 = $m_Llaika_config_TargetFormats$Selected$().apply__T__sci_Seq__Llaika_config_TargetFormats$Selected("html", $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["epub", "xhtml"])));
      break matchResult1;
    }
    var $x_1 = $m_Llaika_config_TargetFormats$All$();
  }
  return $as_Llaika_config_TargetFormats($x_1);
});
var $d_Llaika_api_bundle_DocumentTypeMatcher$ = new $TypeData().initClass($c_Llaika_api_bundle_DocumentTypeMatcher$, "laika.api.bundle.DocumentTypeMatcher$", ({
  Llaika_api_bundle_DocumentTypeMatcher$: 1
}));
var $n_Llaika_api_bundle_DocumentTypeMatcher$;
function $m_Llaika_api_bundle_DocumentTypeMatcher$() {
  if ((!$n_Llaika_api_bundle_DocumentTypeMatcher$)) {
    $n_Llaika_api_bundle_DocumentTypeMatcher$ = new $c_Llaika_api_bundle_DocumentTypeMatcher$();
  }
  return $n_Llaika_api_bundle_DocumentTypeMatcher$;
}
function $is_Llaika_api_bundle_ExtensionBundle(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_api_bundle_ExtensionBundle)));
}
function $as_Llaika_api_bundle_ExtensionBundle(obj) {
  return (($is_Llaika_api_bundle_ExtensionBundle(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.ExtensionBundle"));
}
function $isArrayOf_Llaika_api_bundle_ExtensionBundle(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_ExtensionBundle)));
}
function $asArrayOf_Llaika_api_bundle_ExtensionBundle(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_ExtensionBundle(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.ExtensionBundle;", depth));
}
var $d_Llaika_api_bundle_ExtensionBundle = new $TypeData().initClass(1, "laika.api.bundle.ExtensionBundle", ({
  Llaika_api_bundle_ExtensionBundle: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_ExtensionBundle$() {
  this.Llaika_api_bundle_ExtensionBundle$__f_empty = null;
  $n_Llaika_api_bundle_ExtensionBundle$ = this;
  this.Llaika_api_bundle_ExtensionBundle$__f_empty = new $c_Llaika_api_bundle_ExtensionBundle$$anon$4();
}
$c_Llaika_api_bundle_ExtensionBundle$.prototype = new $h_O();
$c_Llaika_api_bundle_ExtensionBundle$.prototype.constructor = $c_Llaika_api_bundle_ExtensionBundle$;
/** @constructor */
function $h_Llaika_api_bundle_ExtensionBundle$() {
}
$h_Llaika_api_bundle_ExtensionBundle$.prototype = $c_Llaika_api_bundle_ExtensionBundle$.prototype;
var $d_Llaika_api_bundle_ExtensionBundle$ = new $TypeData().initClass($c_Llaika_api_bundle_ExtensionBundle$, "laika.api.bundle.ExtensionBundle$", ({
  Llaika_api_bundle_ExtensionBundle$: 1
}));
var $n_Llaika_api_bundle_ExtensionBundle$;
function $m_Llaika_api_bundle_ExtensionBundle$() {
  if ((!$n_Llaika_api_bundle_ExtensionBundle$)) {
    $n_Llaika_api_bundle_ExtensionBundle$ = new $c_Llaika_api_bundle_ExtensionBundle$();
  }
  return $n_Llaika_api_bundle_ExtensionBundle$;
}
/** @constructor */
function $c_Llaika_api_bundle_LinkDirectives$() {
}
$c_Llaika_api_bundle_LinkDirectives$.prototype = new $h_O();
$c_Llaika_api_bundle_LinkDirectives$.prototype.constructor = $c_Llaika_api_bundle_LinkDirectives$;
/** @constructor */
function $h_Llaika_api_bundle_LinkDirectives$() {
}
$h_Llaika_api_bundle_LinkDirectives$.prototype = $c_Llaika_api_bundle_LinkDirectives$.prototype;
var $d_Llaika_api_bundle_LinkDirectives$ = new $TypeData().initClass($c_Llaika_api_bundle_LinkDirectives$, "laika.api.bundle.LinkDirectives$", ({
  Llaika_api_bundle_LinkDirectives$: 1
}));
var $n_Llaika_api_bundle_LinkDirectives$;
function $m_Llaika_api_bundle_LinkDirectives$() {
  if ((!$n_Llaika_api_bundle_LinkDirectives$)) {
    $n_Llaika_api_bundle_LinkDirectives$ = new $c_Llaika_api_bundle_LinkDirectives$();
  }
  return $n_Llaika_api_bundle_LinkDirectives$;
}
function $f_Llaika_api_bundle_LinkDirectives$Directive__asSpanDirective__Llaika_api_bundle_DirectiveBuilderContext$Directive($thiz) {
  var this$6 = $m_Llaika_api_bundle_SpanDirectives$();
  var name = $thiz.Llaika_api_bundle_LinkDirectives$$anon$14__f_directiveName$1;
  $m_Lcats_implicits$();
  var this$1 = $n($m_Llaika_api_bundle_SpanDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
  var _1 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$1, 0)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string);
  var this$2 = $n($m_Llaika_api_bundle_SpanDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
  var _2 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12(this$2);
  var t2 = new $c_T2(_1, _2);
  var part = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(new $c_Lcats_syntax_Tuple2SemigroupalOps(t2).mapN__F2__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction2(((linkId, cursor) => {
    var linkId$1 = $as_T(linkId);
    var cursor$1 = $as_Llaika_ast_DocumentCursor(cursor);
    return $thiz.apply__T__Llaika_ast_DocumentCursor__s_util_Either(linkId$1, cursor$1);
  })), $n($m_Llaika_api_bundle_SpanDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances, $as_Lcats_Semigroupal($n($m_Llaika_api_bundle_SpanDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances)));
  return $f_Llaika_api_bundle_DirectiveBuilderContext__eval__T__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$Directive(this$6, name, part);
}
function $is_Llaika_api_bundle_LinkDirectives$Directive(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_api_bundle_LinkDirectives$Directive)));
}
function $as_Llaika_api_bundle_LinkDirectives$Directive(obj) {
  return (($is_Llaika_api_bundle_LinkDirectives$Directive(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.LinkDirectives$Directive"));
}
function $isArrayOf_Llaika_api_bundle_LinkDirectives$Directive(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_LinkDirectives$Directive)));
}
function $asArrayOf_Llaika_api_bundle_LinkDirectives$Directive(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_LinkDirectives$Directive(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.LinkDirectives$Directive;", depth));
}
var $d_Llaika_api_bundle_LinkDirectives$Directive = new $TypeData().initClass(1, "laika.api.bundle.LinkDirectives$Directive", ({
  Llaika_api_bundle_LinkDirectives$Directive: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_MarkupExtensions(blockParsers, spanParsers, syntaxHighlighters, parserHooks) {
  this.Llaika_api_bundle_MarkupExtensions__f_blockParsers = null;
  this.Llaika_api_bundle_MarkupExtensions__f_spanParsers = null;
  this.Llaika_api_bundle_MarkupExtensions__f_syntaxHighlighters = null;
  this.Llaika_api_bundle_MarkupExtensions__f_parserHooks = null;
  this.Llaika_api_bundle_MarkupExtensions__f_blockParsers = blockParsers;
  this.Llaika_api_bundle_MarkupExtensions__f_spanParsers = spanParsers;
  this.Llaika_api_bundle_MarkupExtensions__f_syntaxHighlighters = syntaxHighlighters;
  this.Llaika_api_bundle_MarkupExtensions__f_parserHooks = parserHooks;
}
$c_Llaika_api_bundle_MarkupExtensions.prototype = new $h_O();
$c_Llaika_api_bundle_MarkupExtensions.prototype.constructor = $c_Llaika_api_bundle_MarkupExtensions;
/** @constructor */
function $h_Llaika_api_bundle_MarkupExtensions() {
}
$h_Llaika_api_bundle_MarkupExtensions.prototype = $c_Llaika_api_bundle_MarkupExtensions.prototype;
var $d_Llaika_api_bundle_MarkupExtensions = new $TypeData().initClass($c_Llaika_api_bundle_MarkupExtensions, "laika.api.bundle.MarkupExtensions", ({
  Llaika_api_bundle_MarkupExtensions: 1
}));
function $is_Llaika_api_bundle_ParserBuilder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_api_bundle_ParserBuilder)));
}
function $as_Llaika_api_bundle_ParserBuilder(obj) {
  return (($is_Llaika_api_bundle_ParserBuilder(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.ParserBuilder"));
}
function $isArrayOf_Llaika_api_bundle_ParserBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_ParserBuilder)));
}
function $asArrayOf_Llaika_api_bundle_ParserBuilder(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_ParserBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.ParserBuilder;", depth));
}
/** @constructor */
function $c_Llaika_api_bundle_ParserBundle(blockParsers, spanParsers, syntaxHighlighters, markupParserHooks, configProvider, templateParser, styleSheetParser) {
  this.Llaika_api_bundle_ParserBundle__f_blockParsers = null;
  this.Llaika_api_bundle_ParserBundle__f_spanParsers = null;
  this.Llaika_api_bundle_ParserBundle__f_syntaxHighlighters = null;
  this.Llaika_api_bundle_ParserBundle__f_markupParserHooks = null;
  this.Llaika_api_bundle_ParserBundle__f_configProvider = null;
  this.Llaika_api_bundle_ParserBundle__f_templateParser = null;
  this.Llaika_api_bundle_ParserBundle__f_styleSheetParser = null;
  this.Llaika_api_bundle_ParserBundle__f_blockParsers = blockParsers;
  this.Llaika_api_bundle_ParserBundle__f_spanParsers = spanParsers;
  this.Llaika_api_bundle_ParserBundle__f_syntaxHighlighters = syntaxHighlighters;
  this.Llaika_api_bundle_ParserBundle__f_markupParserHooks = markupParserHooks;
  this.Llaika_api_bundle_ParserBundle__f_configProvider = configProvider;
  this.Llaika_api_bundle_ParserBundle__f_templateParser = templateParser;
  this.Llaika_api_bundle_ParserBundle__f_styleSheetParser = styleSheetParser;
}
$c_Llaika_api_bundle_ParserBundle.prototype = new $h_O();
$c_Llaika_api_bundle_ParserBundle.prototype.constructor = $c_Llaika_api_bundle_ParserBundle;
/** @constructor */
function $h_Llaika_api_bundle_ParserBundle() {
}
$h_Llaika_api_bundle_ParserBundle.prototype = $c_Llaika_api_bundle_ParserBundle.prototype;
$c_Llaika_api_bundle_ParserBundle.prototype.withBase__Llaika_api_bundle_ParserBundle__Llaika_api_bundle_ParserBundle = (function(base) {
  var this$1 = $n(this.Llaika_api_bundle_ParserBundle__f_blockParsers);
  var suffix = $n(base).Llaika_api_bundle_ParserBundle__f_blockParsers;
  var $x_6 = $as_sci_Seq(this$1.appendedAll__sc_IterableOnce__O(suffix));
  var this$2 = $n(this.Llaika_api_bundle_ParserBundle__f_spanParsers);
  var suffix$1 = $n(base).Llaika_api_bundle_ParserBundle__f_spanParsers;
  var $x_5 = $as_sci_Seq(this$2.appendedAll__sc_IterableOnce__O(suffix$1));
  var this$3 = $n(this.Llaika_api_bundle_ParserBundle__f_syntaxHighlighters);
  var suffix$2 = $n(base).Llaika_api_bundle_ParserBundle__f_syntaxHighlighters;
  var $x_4 = $as_sci_Seq(this$3.appendedAll__sc_IterableOnce__O(suffix$2));
  var this$4 = $n($n($m_s_Option$().option2Iterable__s_Option__sc_Iterable(this.Llaika_api_bundle_ParserBundle__f_markupParserHooks)).toSeq__sci_Seq());
  var suffix$3 = $n($m_s_Option$().option2Iterable__s_Option__sc_Iterable($n(base).Llaika_api_bundle_ParserBundle__f_markupParserHooks)).toSeq__sci_Seq();
  var this$5 = $n($as_sc_IterableOnceOps(this$4.appendedAll__sc_IterableOnce__O(suffix$3)));
  var op = new $c_sjsr_AnonFunction2(((_$1, _$2) => {
    var _$1$1 = $as_Llaika_api_bundle_ParserHooks(_$1);
    var _$2$1 = $as_Llaika_api_bundle_ParserHooks(_$2);
    return $n(_$1$1).withBase__Llaika_api_bundle_ParserHooks__Llaika_api_bundle_ParserHooks(_$2$1);
  }));
  var $x_3 = $f_sc_IterableOnceOps__reduceLeftOption__F2__s_Option(this$5, op);
  var this$6 = $n(this.Llaika_api_bundle_ParserBundle__f_configProvider);
  var $x_2 = (this$6.isEmpty__Z() ? $n(base).Llaika_api_bundle_ParserBundle__f_configProvider : this$6);
  var this$7 = $n(this.Llaika_api_bundle_ParserBundle__f_templateParser);
  var $x_1 = (this$7.isEmpty__Z() ? $n(base).Llaika_api_bundle_ParserBundle__f_templateParser : this$7);
  var this$8 = $n(this.Llaika_api_bundle_ParserBundle__f_styleSheetParser);
  return new $c_Llaika_api_bundle_ParserBundle($x_6, $x_5, $x_4, $x_3, $x_2, $x_1, (this$8.isEmpty__Z() ? $n(base).Llaika_api_bundle_ParserBundle__f_styleSheetParser : this$8));
});
$c_Llaika_api_bundle_ParserBundle.prototype.markupExtensions__Llaika_api_bundle_MarkupExtensions = (function() {
  var $x_3 = this.Llaika_api_bundle_ParserBundle__f_blockParsers;
  var $x_2 = this.Llaika_api_bundle_ParserBundle__f_spanParsers;
  var $x_1 = this.Llaika_api_bundle_ParserBundle__f_syntaxHighlighters;
  var this$1 = $n(this.Llaika_api_bundle_ParserBundle__f_markupParserHooks);
  return new $c_Llaika_api_bundle_MarkupExtensions($x_3, $x_2, $x_1, $as_Llaika_api_bundle_ParserHooks((this$1.isEmpty__Z() ? new $c_Llaika_api_bundle_ParserHooks($m_Llaika_api_bundle_ParserHooks$().$lessinit$greater$default$1__F1(), $m_Llaika_api_bundle_ParserHooks$().$lessinit$greater$default$2__F1(), $m_Llaika_api_bundle_ParserHooks$().$lessinit$greater$default$3__F1()) : this$1.get__O())));
});
var $d_Llaika_api_bundle_ParserBundle = new $TypeData().initClass($c_Llaika_api_bundle_ParserBundle, "laika.api.bundle.ParserBundle", ({
  Llaika_api_bundle_ParserBundle: 1
}));
function $is_Llaika_api_bundle_ParserDefinition(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_api_bundle_ParserDefinition)));
}
function $as_Llaika_api_bundle_ParserDefinition(obj) {
  return (($is_Llaika_api_bundle_ParserDefinition(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.ParserDefinition"));
}
function $isArrayOf_Llaika_api_bundle_ParserDefinition(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_ParserDefinition)));
}
function $asArrayOf_Llaika_api_bundle_ParserDefinition(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_ParserDefinition(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.ParserDefinition;", depth));
}
/** @constructor */
function $c_Llaika_api_bundle_ParserHooks(postProcessBlocks, postProcessDocument, preProcessInput) {
  this.Llaika_api_bundle_ParserHooks__f_postProcessBlocks = null;
  this.Llaika_api_bundle_ParserHooks__f_postProcessDocument = null;
  this.Llaika_api_bundle_ParserHooks__f_preProcessInput = null;
  this.Llaika_api_bundle_ParserHooks__f_postProcessBlocks = postProcessBlocks;
  this.Llaika_api_bundle_ParserHooks__f_postProcessDocument = postProcessDocument;
  this.Llaika_api_bundle_ParserHooks__f_preProcessInput = preProcessInput;
}
$c_Llaika_api_bundle_ParserHooks.prototype = new $h_O();
$c_Llaika_api_bundle_ParserHooks.prototype.constructor = $c_Llaika_api_bundle_ParserHooks;
/** @constructor */
function $h_Llaika_api_bundle_ParserHooks() {
}
$h_Llaika_api_bundle_ParserHooks.prototype = $c_Llaika_api_bundle_ParserHooks.prototype;
$c_Llaika_api_bundle_ParserHooks.prototype.withBase__Llaika_api_bundle_ParserHooks__Llaika_api_bundle_ParserHooks = (function(base) {
  return new $c_Llaika_api_bundle_ParserHooks($n($n(base).Llaika_api_bundle_ParserHooks__f_postProcessBlocks).andThen__F1__F1(this.Llaika_api_bundle_ParserHooks__f_postProcessBlocks), $n($n(base).Llaika_api_bundle_ParserHooks__f_postProcessDocument).andThen__F1__F1(this.Llaika_api_bundle_ParserHooks__f_postProcessDocument), $n($n(base).Llaika_api_bundle_ParserHooks__f_preProcessInput).andThen__F1__F1(this.Llaika_api_bundle_ParserHooks__f_preProcessInput));
});
function $as_Llaika_api_bundle_ParserHooks(obj) {
  return (((obj instanceof $c_Llaika_api_bundle_ParserHooks) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.ParserHooks"));
}
function $isArrayOf_Llaika_api_bundle_ParserHooks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_ParserHooks)));
}
function $asArrayOf_Llaika_api_bundle_ParserHooks(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_ParserHooks(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.ParserHooks;", depth));
}
var $d_Llaika_api_bundle_ParserHooks = new $TypeData().initClass($c_Llaika_api_bundle_ParserHooks, "laika.api.bundle.ParserHooks", ({
  Llaika_api_bundle_ParserHooks: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_ParserHooks$() {
}
$c_Llaika_api_bundle_ParserHooks$.prototype = new $h_O();
$c_Llaika_api_bundle_ParserHooks$.prototype.constructor = $c_Llaika_api_bundle_ParserHooks$;
/** @constructor */
function $h_Llaika_api_bundle_ParserHooks$() {
}
$h_Llaika_api_bundle_ParserHooks$.prototype = $c_Llaika_api_bundle_ParserHooks$.prototype;
$c_Llaika_api_bundle_ParserHooks$.prototype.$lessinit$greater$default$1__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((x) => {
    var x$1 = $as_sci_Seq(x);
    return x$1;
  }));
});
$c_Llaika_api_bundle_ParserHooks$.prototype.$lessinit$greater$default$2__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((x) => {
    var x$1 = $as_Llaika_ast_UnresolvedDocument(x);
    return x$1;
  }));
});
$c_Llaika_api_bundle_ParserHooks$.prototype.$lessinit$greater$default$3__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((x) => {
    var x$1 = $as_T(x);
    return x$1;
  }));
});
var $d_Llaika_api_bundle_ParserHooks$ = new $TypeData().initClass($c_Llaika_api_bundle_ParserHooks$, "laika.api.bundle.ParserHooks$", ({
  Llaika_api_bundle_ParserHooks$: 1
}));
var $n_Llaika_api_bundle_ParserHooks$;
function $m_Llaika_api_bundle_ParserHooks$() {
  if ((!$n_Llaika_api_bundle_ParserHooks$)) {
    $n_Llaika_api_bundle_ParserHooks$ = new $c_Llaika_api_bundle_ParserHooks$();
  }
  return $n_Llaika_api_bundle_ParserHooks$;
}
function $f_Llaika_api_bundle_PathTranslator__translate__Llaika_ast_Target__Llaika_ast_Target($thiz, target) {
  if ((target instanceof $c_Llaika_ast_InternalTarget$Resolved)) {
    var rt = $as_Llaika_ast_InternalTarget$Resolved(target);
    $n(rt);
    var input = $n(rt).Llaika_ast_InternalTarget$Resolved__f_absolutePath;
    var input$1 = $n(rt).Llaika_ast_InternalTarget$Resolved__f_relativePath;
    var this$1 = $n(rt);
    var internalFormats = this$1.Llaika_ast_InternalTarget$Resolved__f_internalFormats;
    return new $c_Llaika_ast_InternalTarget$Resolved(input, input$1, internalFormats);
  } else if ((target instanceof $c_Llaika_ast_InternalTarget$Absolute)) {
    var at = $as_Llaika_ast_InternalTarget$Absolute(target);
    $n(at);
    var input$2 = $n(at).Llaika_ast_InternalTarget$Absolute__f_path;
    return new $c_Llaika_ast_InternalTarget$Absolute(input$2);
  } else if ((target instanceof $c_Llaika_ast_InternalTarget$Relative)) {
    var rt$2 = $as_Llaika_ast_InternalTarget$Relative(target);
    $n(rt$2);
    var input$3 = $n(rt$2).Llaika_ast_InternalTarget$Relative__f_path;
    return new $c_Llaika_ast_InternalTarget$Relative(input$3);
  } else {
    return target;
  }
}
/** @constructor */
function $c_Llaika_api_bundle_PathTranslator$() {
  this.Llaika_api_bundle_PathTranslator$__f_noOp = null;
  $n_Llaika_api_bundle_PathTranslator$ = this;
  this.Llaika_api_bundle_PathTranslator$__f_noOp = new $c_Llaika_api_bundle_PathTranslator$$anon$1();
}
$c_Llaika_api_bundle_PathTranslator$.prototype = new $h_O();
$c_Llaika_api_bundle_PathTranslator$.prototype.constructor = $c_Llaika_api_bundle_PathTranslator$;
/** @constructor */
function $h_Llaika_api_bundle_PathTranslator$() {
}
$h_Llaika_api_bundle_PathTranslator$.prototype = $c_Llaika_api_bundle_PathTranslator$.prototype;
var $d_Llaika_api_bundle_PathTranslator$ = new $TypeData().initClass($c_Llaika_api_bundle_PathTranslator$, "laika.api.bundle.PathTranslator$", ({
  Llaika_api_bundle_PathTranslator$: 1
}));
var $n_Llaika_api_bundle_PathTranslator$;
function $m_Llaika_api_bundle_PathTranslator$() {
  if ((!$n_Llaika_api_bundle_PathTranslator$)) {
    $n_Llaika_api_bundle_PathTranslator$ = new $c_Llaika_api_bundle_PathTranslator$();
  }
  return $n_Llaika_api_bundle_PathTranslator$;
}
function $is_Llaika_api_bundle_Precedence(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_api_bundle_Precedence)));
}
function $as_Llaika_api_bundle_Precedence(obj) {
  return (($is_Llaika_api_bundle_Precedence(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.Precedence"));
}
function $isArrayOf_Llaika_api_bundle_Precedence(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_Precedence)));
}
function $asArrayOf_Llaika_api_bundle_Precedence(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_Precedence(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.Precedence;", depth));
}
function $is_Llaika_api_bundle_RenderOverrides(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_api_bundle_RenderOverrides)));
}
function $as_Llaika_api_bundle_RenderOverrides(obj) {
  return (($is_Llaika_api_bundle_RenderOverrides(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.RenderOverrides"));
}
function $isArrayOf_Llaika_api_bundle_RenderOverrides(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_RenderOverrides)));
}
function $asArrayOf_Llaika_api_bundle_RenderOverrides(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_RenderOverrides(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.RenderOverrides;", depth));
}
/** @constructor */
function $c_Llaika_api_bundle_SlugBuilder$() {
}
$c_Llaika_api_bundle_SlugBuilder$.prototype = new $h_O();
$c_Llaika_api_bundle_SlugBuilder$.prototype.constructor = $c_Llaika_api_bundle_SlugBuilder$;
/** @constructor */
function $h_Llaika_api_bundle_SlugBuilder$() {
}
$h_Llaika_api_bundle_SlugBuilder$.prototype = $c_Llaika_api_bundle_SlugBuilder$.prototype;
$c_Llaika_api_bundle_SlugBuilder$.prototype.default__T__T = (function(text) {
  var $x_7 = $m_sc_StringOps$();
  var $x_6 = $m_sc_StringOps$();
  var v___1 = "";
  var v___2 = true;
  var i = 0;
  var this$4 = $n(text);
  var len = this$4.length;
  while ((i < len)) {
    var arg1___1 = v___1;
    var arg1___2 = v___2;
    var this$5 = $n(text);
    var index = i;
    var arg2 = $charAt(this$5, index);
    var res = $as_T(arg1___1);
    var inWord = $uZ(arg1___2);
    var this$7 = $m_jl_Character$();
    if (this$7.isLetter__I__Z(arg2)) {
      var $x_1 = true;
    } else {
      var this$8 = $m_jl_Character$();
      var $x_1 = this$8.isDigit__I__Z(arg2);
    }
    if ($x_1) {
      var _1 = (res + $cToS($m_jl_Character$().toLowerCase__C__C(arg2)));
      var $x_2___1 = _1;
      var $x_2___2 = true;
      v___1 = $x_2___1;
      v___2 = $x_2___2;
    } else if ((arg2 === 95)) {
      var _1$1 = (res + $cToS(arg2));
      var $x_3___1 = _1$1;
      var $x_3___2 = true;
      v___1 = $x_3___1;
      v___2 = $x_3___2;
    } else if (inWord) {
      var _1$2 = (res + "-");
      var $x_4___1 = _1$2;
      var $x_4___2 = false;
      v___1 = $x_4___1;
      v___2 = $x_4___2;
    } else {
      var $x_5___1 = res;
      var $x_5___2 = false;
      v___1 = $x_5___1;
      v___2 = $x_5___2;
    }
    i = ((1 + i) | 0);
  }
  var x = $as_T(v___1);
  var x$1 = $n($x_6).stripPrefix$extension__T__T__T(x, "-");
  var slug = $n($x_7).stripSuffix$extension__T__T__T(x$1, "-");
  var this$18 = $n($m_sc_StringOps$().headOption$extension__T__s_Option(slug));
  if ((!this$18.isEmpty__Z())) {
    var arg1$1 = this$18.get__O();
    var x$0 = $uC(arg1$1);
    var this$19 = $m_jl_Character$();
    var $x_8 = this$19.isLetter__I__Z(x$0);
  } else {
    var $x_8 = false;
  }
  if ($x_8) {
    return slug;
  } else {
    return ("_" + slug);
  }
});
var $d_Llaika_api_bundle_SlugBuilder$ = new $TypeData().initClass($c_Llaika_api_bundle_SlugBuilder$, "laika.api.bundle.SlugBuilder$", ({
  Llaika_api_bundle_SlugBuilder$: 1
}));
var $n_Llaika_api_bundle_SlugBuilder$;
function $m_Llaika_api_bundle_SlugBuilder$() {
  if ((!$n_Llaika_api_bundle_SlugBuilder$)) {
    $n_Llaika_api_bundle_SlugBuilder$ = new $c_Llaika_api_bundle_SlugBuilder$();
  }
  return $n_Llaika_api_bundle_SlugBuilder$;
}
/** @constructor */
function $c_Llaika_api_bundle_SpanParserBuilder$() {
}
$c_Llaika_api_bundle_SpanParserBuilder$.prototype = new $h_O();
$c_Llaika_api_bundle_SpanParserBuilder$.prototype.constructor = $c_Llaika_api_bundle_SpanParserBuilder$;
/** @constructor */
function $h_Llaika_api_bundle_SpanParserBuilder$() {
}
$h_Llaika_api_bundle_SpanParserBuilder$.prototype = $c_Llaika_api_bundle_SpanParserBuilder$.prototype;
$c_Llaika_api_bundle_SpanParserBuilder$.prototype.standalone__Llaika_parse_text_PrefixedParser__Llaika_api_bundle_SpanParserBuilder = (function(parser) {
  return new $c_Llaika_api_bundle_SpanParserBuilder(new $c_sjsr_AnonFunction1(((_$1) => {
    $as_Llaika_parse_markup_RecursiveSpanParsers(_$1);
    return parser;
  })), false, $m_Llaika_api_bundle_Precedence$High$());
});
var $d_Llaika_api_bundle_SpanParserBuilder$ = new $TypeData().initClass($c_Llaika_api_bundle_SpanParserBuilder$, "laika.api.bundle.SpanParserBuilder$", ({
  Llaika_api_bundle_SpanParserBuilder$: 1
}));
var $n_Llaika_api_bundle_SpanParserBuilder$;
function $m_Llaika_api_bundle_SpanParserBuilder$() {
  if ((!$n_Llaika_api_bundle_SpanParserBuilder$)) {
    $n_Llaika_api_bundle_SpanParserBuilder$ = new $c_Llaika_api_bundle_SpanParserBuilder$();
  }
  return $n_Llaika_api_bundle_SpanParserBuilder$;
}
function $is_Llaika_api_bundle_SyntaxHighlighter(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_api_bundle_SyntaxHighlighter)));
}
function $as_Llaika_api_bundle_SyntaxHighlighter(obj) {
  return (($is_Llaika_api_bundle_SyntaxHighlighter(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.SyntaxHighlighter"));
}
function $isArrayOf_Llaika_api_bundle_SyntaxHighlighter(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_SyntaxHighlighter)));
}
function $asArrayOf_Llaika_api_bundle_SyntaxHighlighter(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_SyntaxHighlighter(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.SyntaxHighlighter;", depth));
}
function $f_Llaika_api_config_Config__hasKey__T__Z($thiz, key) {
  return $thiz.hasKey__Llaika_api_config_Key__Z($m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key(key));
}
function $f_Llaika_api_config_Config__get__T__Llaika_api_config_ConfigDecoder__s_util_Either($thiz, key, decoder) {
  return $thiz.get__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either($m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key(key), decoder);
}
function $f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either($thiz, key, decoder) {
  var this$1 = $n($thiz.get__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(key, decoder));
  if ((this$1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$1);
    var b = $n(x2).s_util_Right__f_value;
    var value = new $c_s_Some(b);
    var $x_1 = new $c_s_util_Right(value);
  } else {
    if ((!(this$1 instanceof $c_s_util_Left))) {
      throw new $c_s_MatchError(this$1);
    }
    var x3 = $as_s_util_Left(this$1);
    var a = $n(x3).s_util_Left__f_value;
    var e = $as_Llaika_api_config_ConfigError(a);
    if ((e instanceof $c_Llaika_api_config_ConfigError$NotFound)) {
      var value$1 = $m_s_None$();
      var $x_1 = new $c_s_util_Right(value$1);
    } else {
      var $x_1 = new $c_s_util_Left(e);
    }
  }
  return $as_s_util_Either($x_1);
}
function $f_Llaika_api_config_Config__getOpt__T__Llaika_api_config_ConfigDecoder__s_util_Either($thiz, key, decoder) {
  var key$1 = $m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key(key);
  return $f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either($thiz, key$1, decoder);
}
function $f_Llaika_api_config_Config__withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigBuilder($thiz, key, value, encoder) {
  return ($m_Llaika_api_config_ConfigBuilder$(), new $c_Llaika_api_config_ConfigBuilder($m_sci_Nil$(), $thiz.origin__Llaika_api_config_Origin(), $thiz)).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigBuilder(key, value, encoder);
}
function $is_Llaika_api_config_Config(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_api_config_Config)));
}
function $as_Llaika_api_config_Config(obj) {
  return (($is_Llaika_api_config_Config(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.Config"));
}
function $isArrayOf_Llaika_api_config_Config(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_Config)));
}
function $asArrayOf_Llaika_api_config_Config(obj, depth) {
  return (($isArrayOf_Llaika_api_config_Config(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.Config;", depth));
}
/** @constructor */
function $c_Llaika_api_config_Config$() {
  this.Llaika_api_config_Config$__f_empty = null;
  $n_Llaika_api_config_Config$ = this;
  this.Llaika_api_config_Config$__f_empty = $m_Llaika_api_config_EmptyConfig$();
}
$c_Llaika_api_config_Config$.prototype = new $h_O();
$c_Llaika_api_config_Config$.prototype.constructor = $c_Llaika_api_config_Config$;
/** @constructor */
function $h_Llaika_api_config_Config$() {
}
$h_Llaika_api_config_Config$.prototype = $c_Llaika_api_config_Config$.prototype;
var $d_Llaika_api_config_Config$ = new $TypeData().initClass($c_Llaika_api_config_Config$, "laika.api.config.Config$", ({
  Llaika_api_config_Config$: 1
}));
var $n_Llaika_api_config_Config$;
function $m_Llaika_api_config_Config$() {
  if ((!$n_Llaika_api_config_Config$)) {
    $n_Llaika_api_config_Config$ = new $c_Llaika_api_config_Config$();
  }
  return $n_Llaika_api_config_Config$;
}
function $p_Llaika_api_config_ConfigBuilder__expandPath__Llaika_api_config_Key__Llaika_api_config_ConfigValue__Llaika_api_config_Field($thiz, key, value) {
  var x1 = $n($n(key).Llaika_api_config_Key__f_segments).toList__sci_List();
  if ((x1 instanceof $c_sci_$colon$colon)) {
    var x5 = $as_sci_$colon$colon(x1);
    var x6 = $as_T($n(x5).sci_$colon$colon__f_head);
    var x7 = $n(x5).sci_$colon$colon__f_next;
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x7)) {
      var origin = $thiz.Llaika_api_config_ConfigBuilder__f_origin;
      return new $c_Llaika_api_config_Field(x6, value, origin);
    }
    var values = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_config_Field.getArrayOf().constr)([$p_Llaika_api_config_ConfigBuilder__expandPath__Llaika_api_config_Key__Llaika_api_config_ConfigValue__Llaika_api_config_Field($thiz, ($m_Llaika_api_config_Key$(), new $c_Llaika_api_config_Key(x7)), value)]))));
    var value$1 = new $c_Llaika_api_config_ConfigValue$ObjectValue(values);
    var origin$1 = $thiz.Llaika_api_config_ConfigBuilder__f_origin;
    return new $c_Llaika_api_config_Field(x6, value$1, origin$1);
  }
  var x$3 = $m_sci_Nil$();
  if (x$3.equals__O__Z(x1)) {
    var origin$2 = $thiz.Llaika_api_config_ConfigBuilder__f_origin;
    return new $c_Llaika_api_config_Field("", value, origin$2);
  }
  throw new $c_s_MatchError(x1);
}
function $p_Llaika_api_config_ConfigBuilder__mergeObjects__Llaika_api_config_ConfigValue$ObjectValue__Llaika_api_config_ConfigValue$ObjectValue($thiz, obj) {
  var this$1 = $n($n(obj).Llaika_api_config_ConfigValue$ObjectValue__f_values);
  var m = $as_scm_Map($m_scm_Map$().empty__O());
  var it = this$1.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    var _$3 = $as_Llaika_api_config_Field(elem);
    var key = $n(_$3).Llaika_api_config_Field__f_key;
    var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0(((this$1) => (() => this$1.newSpecificBuilder__scm_Builder()))(this$1))));
    var this$2 = $n(bldr);
    this$2.addOne__O__scm_Growable(elem);
  }
  var this$3 = $m_sci_HashMap$();
  var result = this$3.sci_HashMap$__f_EmptyMap;
  var mapIt = $n(m).iterator__sc_Iterator();
  while ($n(mapIt).hasNext__Z()) {
    var x1 = $as_T2($n(mapIt).next__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = $n(x1)._1__O();
    var v = $as_scm_Builder($n(x1)._2__O());
    result = $n(result).updated__O__O__sci_HashMap(k, $n(v).result__O());
  }
  var map = result;
  var this$6 = $n(map);
  $m_sci_HashMap$();
  var b = new $c_sci_HashMapBuilder();
  var it$1 = this$6.iterator__sc_Iterator();
  while ($n(it$1).hasNext__Z()) {
    var arg1 = $n(it$1).next__O();
    var x$1 = $as_T2(arg1);
    matchResult2: {
      var elem$1___1;
      var elem$1___2;
      if ((x$1 !== null)) {
        var k$1 = $n(x$1)._1__O();
        var v$1 = $n(x$1)._2__O();
        var _$4 = $as_sci_Seq(v$1);
        var _2 = $as_sci_Seq($n(_$4).map__F1__O(new $c_sjsr_AnonFunction1(((_$5) => {
          var _$5$1 = $as_Llaika_api_config_Field(_$5);
          return $n(_$5$1).Llaika_api_config_Field__f_value;
        }))));
        var elem$1___1 = k$1;
        var elem$1___2 = _2;
        break matchResult2;
      }
      throw new $c_s_MatchError(x$1);
    }
    $p_sci_HashMapBuilder__ensureUnaliased__V(b);
    var x = elem$1___1;
    var h = $m_sr_Statics$().anyHash__O__I(x);
    var im = $m_sc_Hashing$().improve__I__I(h);
    b.update__sci_MapNode__O__O__I__I__I__V(b.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, elem$1___1, elem$1___2, h, im, 0);
  }
  var this$9 = $n(b.result__sci_HashMap());
  var mergedFields = $as_sci_Seq($n($m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$9)).map__F1__O(new $c_sjsr_AnonFunction1(((x$1$1) => {
    var x$1$2 = $as_T2(x$1$1);
    if ((x$1$2 !== null)) {
      var name = $as_T($n(x$1$2)._1__O());
      var values = $as_sci_Seq($n(x$1$2)._2__O());
      var this$11 = $n(values);
      var op = new $c_sjsr_AnonFunction2(((cbv1, cbv2) => {
        var cbv1$1 = $as_Llaika_api_config_ConfigValue(cbv1);
        var cbv2$1 = $as_Llaika_api_config_ConfigValue(cbv2);
        return $p_Llaika_api_config_ConfigBuilder__mergeValues$1__Llaika_api_config_ConfigValue__Llaika_api_config_ConfigValue__Llaika_api_config_ConfigValue($thiz, cbv1$1, cbv2$1);
      }));
      var value = $as_Llaika_api_config_ConfigValue(this$11.reduceLeft__F2__O(op));
      var origin = $thiz.Llaika_api_config_ConfigBuilder__f_origin;
      return new $c_Llaika_api_config_Field(name, value, origin);
    }
    throw new $c_s_MatchError(x$1$2);
  }))));
  return new $c_Llaika_api_config_ConfigValue$ObjectValue(mergedFields);
}
function $p_Llaika_api_config_ConfigBuilder__mergeValues$1__Llaika_api_config_ConfigValue__Llaika_api_config_ConfigValue__Llaika_api_config_ConfigValue($thiz, cbv1, cbv2) {
  if ((cbv1 instanceof $c_Llaika_api_config_ConfigValue$ObjectValue)) {
    var o1 = $as_Llaika_api_config_ConfigValue$ObjectValue(cbv1);
    if ((cbv2 instanceof $c_Llaika_api_config_ConfigValue$ObjectValue)) {
      var o2 = $as_Llaika_api_config_ConfigValue$ObjectValue(cbv2);
      var this$2 = $n($n(o1).Llaika_api_config_ConfigValue$ObjectValue__f_values);
      var suffix = $n(o2).Llaika_api_config_ConfigValue$ObjectValue__f_values;
      var values = $as_sci_Seq(this$2.appendedAll__sc_IterableOnce__O(suffix));
      return $p_Llaika_api_config_ConfigBuilder__mergeObjects__Llaika_api_config_ConfigValue$ObjectValue__Llaika_api_config_ConfigValue$ObjectValue($thiz, new $c_Llaika_api_config_ConfigValue$ObjectValue(values));
    }
  }
  return cbv2;
}
/** @constructor */
function $c_Llaika_api_config_ConfigBuilder(fields, origin, fallback) {
  this.Llaika_api_config_ConfigBuilder__f_fields = null;
  this.Llaika_api_config_ConfigBuilder__f_origin = null;
  this.Llaika_api_config_ConfigBuilder__f_fallback = null;
  this.Llaika_api_config_ConfigBuilder__f_fields = fields;
  this.Llaika_api_config_ConfigBuilder__f_origin = origin;
  this.Llaika_api_config_ConfigBuilder__f_fallback = fallback;
}
$c_Llaika_api_config_ConfigBuilder.prototype = new $h_O();
$c_Llaika_api_config_ConfigBuilder.prototype.constructor = $c_Llaika_api_config_ConfigBuilder;
/** @constructor */
function $h_Llaika_api_config_ConfigBuilder() {
}
$h_Llaika_api_config_ConfigBuilder.prototype = $c_Llaika_api_config_ConfigBuilder.prototype;
$c_Llaika_api_config_ConfigBuilder.prototype.withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigBuilder = (function(key, value, encoder) {
  return this.withValue__Llaika_api_config_Key__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigBuilder($m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key(key), value, encoder);
});
$c_Llaika_api_config_ConfigBuilder.prototype.withValue__Llaika_api_config_Key__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigBuilder = (function(key, value, encoder) {
  var this$1 = $n(this.Llaika_api_config_ConfigBuilder__f_fields);
  var elem = $p_Llaika_api_config_ConfigBuilder__expandPath__Llaika_api_config_Key__Llaika_api_config_ConfigValue__Llaika_api_config_Field(this, key, $n(encoder).apply__O__Llaika_api_config_ConfigValue(value));
  return new $c_Llaika_api_config_ConfigBuilder($as_sci_Seq(this$1.appended__O__O(elem)), this.Llaika_api_config_ConfigBuilder__f_origin, this.Llaika_api_config_ConfigBuilder__f_fallback);
});
$c_Llaika_api_config_ConfigBuilder.prototype.build__Llaika_api_config_Config = (function() {
  return this.build__Llaika_api_config_Config__Llaika_api_config_Config(this.Llaika_api_config_ConfigBuilder__f_fallback);
});
$c_Llaika_api_config_ConfigBuilder.prototype.build__Llaika_api_config_Config__Llaika_api_config_Config = (function(newFallback) {
  if ($n(this.Llaika_api_config_ConfigBuilder__f_fields).isEmpty__Z()) {
    var x = this.Llaika_api_config_ConfigBuilder__f_origin;
    var x$2 = $m_Llaika_api_config_Origin$().Llaika_api_config_Origin$__f_root;
    var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    var $x_2 = false;
  }
  if ($x_2) {
    var x$3 = this.Llaika_api_config_ConfigBuilder__f_fallback;
    var x$4 = $m_Llaika_api_config_EmptyConfig$();
    var $x_1 = ((x$3 !== null) && $n(x$3).equals__O__Z(x$4));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return newFallback;
  } else {
    return new $c_Llaika_api_config_ObjectConfig(this.asObjectValue__Llaika_api_config_ConfigValue$ObjectValue(), this.Llaika_api_config_ConfigBuilder__f_origin, $n(this.Llaika_api_config_ConfigBuilder__f_fallback).withFallback__Llaika_api_config_Config__Llaika_api_config_Config(newFallback));
  }
});
$c_Llaika_api_config_ConfigBuilder.prototype.asObjectValue__Llaika_api_config_ConfigValue$ObjectValue = (function() {
  var values = this.Llaika_api_config_ConfigBuilder__f_fields;
  return $p_Llaika_api_config_ConfigBuilder__mergeObjects__Llaika_api_config_ConfigValue$ObjectValue__Llaika_api_config_ConfigValue$ObjectValue(this, new $c_Llaika_api_config_ConfigValue$ObjectValue(values));
});
function $as_Llaika_api_config_ConfigBuilder(obj) {
  return (((obj instanceof $c_Llaika_api_config_ConfigBuilder) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.ConfigBuilder"));
}
function $isArrayOf_Llaika_api_config_ConfigBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_ConfigBuilder)));
}
function $asArrayOf_Llaika_api_config_ConfigBuilder(obj, depth) {
  return (($isArrayOf_Llaika_api_config_ConfigBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.ConfigBuilder;", depth));
}
var $d_Llaika_api_config_ConfigBuilder = new $TypeData().initClass($c_Llaika_api_config_ConfigBuilder, "laika.api.config.ConfigBuilder", ({
  Llaika_api_config_ConfigBuilder: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigBuilder$() {
  this.Llaika_api_config_ConfigBuilder$__f_empty = null;
  $n_Llaika_api_config_ConfigBuilder$ = this;
  this.Llaika_api_config_ConfigBuilder$__f_empty = new $c_Llaika_api_config_ConfigBuilder($m_sci_Nil$(), $m_Llaika_api_config_Origin$().Llaika_api_config_Origin$__f_root, ($m_Llaika_api_config_ConfigBuilder$(), $m_Llaika_api_config_EmptyConfig$()));
}
$c_Llaika_api_config_ConfigBuilder$.prototype = new $h_O();
$c_Llaika_api_config_ConfigBuilder$.prototype.constructor = $c_Llaika_api_config_ConfigBuilder$;
/** @constructor */
function $h_Llaika_api_config_ConfigBuilder$() {
}
$h_Llaika_api_config_ConfigBuilder$.prototype = $c_Llaika_api_config_ConfigBuilder$.prototype;
var $d_Llaika_api_config_ConfigBuilder$ = new $TypeData().initClass($c_Llaika_api_config_ConfigBuilder$, "laika.api.config.ConfigBuilder$", ({
  Llaika_api_config_ConfigBuilder$: 1
}));
var $n_Llaika_api_config_ConfigBuilder$;
function $m_Llaika_api_config_ConfigBuilder$() {
  if ((!$n_Llaika_api_config_ConfigBuilder$)) {
    $n_Llaika_api_config_ConfigBuilder$ = new $c_Llaika_api_config_ConfigBuilder$();
  }
  return $n_Llaika_api_config_ConfigBuilder$;
}
function $p_Llaika_api_config_ConfigDecoder$__resolvePath__Llaika_ast_VirtualPath__Llaika_api_config_Origin__Llaika_ast_Path($thiz, path, origin) {
  if ((path instanceof $c_Llaika_ast_RelativePath$CurrentDocument)) {
    var c = $as_Llaika_ast_RelativePath$CurrentDocument(path);
    var this$1 = $n($n(origin).Llaika_api_config_Origin__f_path);
    return this$1.$div__Llaika_ast_RelativePath__Llaika_ast_Path(c);
  }
  if ($is_Llaika_ast_RelativePath(path)) {
    var p = $as_Llaika_ast_RelativePath(path);
    var this$2 = $n($n($n(origin).Llaika_api_config_Origin__f_path).parent__Llaika_ast_Path());
    return this$2.$div__Llaika_ast_RelativePath__Llaika_ast_Path(p);
  }
  if ($is_Llaika_ast_Path(path)) {
    var p$2 = $as_Llaika_ast_Path(path);
    return p$2;
  }
  throw new $c_s_MatchError(path);
}
/** @constructor */
function $c_Llaika_api_config_ConfigDecoder$() {
  this.Llaika_api_config_ConfigDecoder$__f_boolean = null;
  this.Llaika_api_config_ConfigDecoder$__f_string = null;
  this.Llaika_api_config_ConfigDecoder$__f_int = null;
  this.Llaika_api_config_ConfigDecoder$__f_double = null;
  this.Llaika_api_config_ConfigDecoder$__f_config = null;
  this.Llaika_api_config_ConfigDecoder$__f_configValue = null;
  this.Llaika_api_config_ConfigDecoder$__f_path$lzy1 = null;
  this.Llaika_api_config_ConfigDecoder$__f_pathbitmap$1 = false;
  this.Llaika_api_config_ConfigDecoder$__f_target$lzy1 = null;
  this.Llaika_api_config_ConfigDecoder$__f_targetbitmap$1 = false;
  this.Llaika_api_config_ConfigDecoder$__f_date$lzy1 = null;
  this.Llaika_api_config_ConfigDecoder$__f_datebitmap$1 = false;
  $n_Llaika_api_config_ConfigDecoder$ = this;
  this.Llaika_api_config_ConfigDecoder$__f_boolean = new $c_Llaika_api_config_ConfigDecoder$$anon$3();
  this.Llaika_api_config_ConfigDecoder$__f_string = new $c_Llaika_api_config_ConfigDecoder$$anon$4();
  this.Llaika_api_config_ConfigDecoder$__f_int = new $c_Llaika_api_config_ConfigDecoder$$anon$5();
  this.Llaika_api_config_ConfigDecoder$__f_double = new $c_Llaika_api_config_ConfigDecoder$$anon$6();
  this.Llaika_api_config_ConfigDecoder$__f_config = new $c_Llaika_api_config_ConfigDecoder$$anon$7();
  this.Llaika_api_config_ConfigDecoder$__f_configValue = new $c_Llaika_api_config_ConfigDecoder$$anon$8();
}
$c_Llaika_api_config_ConfigDecoder$.prototype = new $h_O();
$c_Llaika_api_config_ConfigDecoder$.prototype.constructor = $c_Llaika_api_config_ConfigDecoder$;
/** @constructor */
function $h_Llaika_api_config_ConfigDecoder$() {
}
$h_Llaika_api_config_ConfigDecoder$.prototype = $c_Llaika_api_config_ConfigDecoder$.prototype;
$c_Llaika_api_config_ConfigDecoder$.prototype.path__Llaika_api_config_ConfigDecoder = (function() {
  if ((!this.Llaika_api_config_ConfigDecoder$__f_pathbitmap$1)) {
    var valueDecoder = this.Llaika_api_config_ConfigDecoder$__f_string;
    var this$2 = new $c_Llaika_api_config_ConfigDecoder$$anon$9(valueDecoder, this);
    var f = new $c_sjsr_AnonFunction1(((tracedValue) => {
      var tracedValue$1 = $as_Llaika_api_config_Traced(tracedValue);
      return $p_Llaika_api_config_ConfigDecoder$__resolvePath__Llaika_ast_VirtualPath__Llaika_api_config_Origin__Llaika_ast_Path(this, $m_Llaika_ast_VirtualPath$().parse__T__Llaika_ast_VirtualPath($as_T($n(tracedValue$1).Llaika_api_config_Traced__f_value)), $n(tracedValue$1).Llaika_api_config_Traced__f_origin);
    }));
    this.Llaika_api_config_ConfigDecoder$__f_path$lzy1 = new $c_Llaika_api_config_ConfigDecoder$$anon$2(f, this$2);
    this.Llaika_api_config_ConfigDecoder$__f_pathbitmap$1 = true;
  }
  return this.Llaika_api_config_ConfigDecoder$__f_path$lzy1;
});
$c_Llaika_api_config_ConfigDecoder$.prototype.target__Llaika_api_config_ConfigDecoder = (function() {
  if ((!this.Llaika_api_config_ConfigDecoder$__f_targetbitmap$1)) {
    var valueDecoder = this.Llaika_api_config_ConfigDecoder$__f_string;
    var this$3 = new $c_Llaika_api_config_ConfigDecoder$$anon$9(valueDecoder, this);
    var f = new $c_sjsr_AnonFunction1(((tracedValue) => {
      var tracedValue$1 = $as_Llaika_api_config_Traced(tracedValue);
      var x40 = $m_Llaika_ast_Target$().parse__T__Llaika_ast_Target($as_T($n(tracedValue$1).Llaika_api_config_Traced__f_value));
      if ((x40 instanceof $c_Llaika_ast_ExternalTarget)) {
        var et = $as_Llaika_ast_ExternalTarget(x40);
        return et;
      }
      if ($is_Llaika_ast_InternalTarget(x40)) {
        var it = $as_Llaika_ast_InternalTarget(x40);
        var $x_1 = $m_Llaika_ast_InternalTarget$();
        var this$2 = $n(it);
        return $n($x_1).apply__Llaika_ast_VirtualPath__Llaika_ast_InternalTarget($p_Llaika_api_config_ConfigDecoder$__resolvePath__Llaika_ast_VirtualPath__Llaika_api_config_Origin__Llaika_ast_Path(this, $f_Llaika_ast_InternalTarget__underlying__Llaika_ast_VirtualPath(this$2), $n(tracedValue$1).Llaika_api_config_Traced__f_origin));
      }
      throw new $c_s_MatchError(x40);
    }));
    this.Llaika_api_config_ConfigDecoder$__f_target$lzy1 = new $c_Llaika_api_config_ConfigDecoder$$anon$2(f, this$3);
    this.Llaika_api_config_ConfigDecoder$__f_targetbitmap$1 = true;
  }
  return this.Llaika_api_config_ConfigDecoder$__f_target$lzy1;
});
$c_Llaika_api_config_ConfigDecoder$.prototype.date__Llaika_api_config_ConfigDecoder = (function() {
  if ((!this.Llaika_api_config_ConfigDecoder$__f_datebitmap$1)) {
    var this$7 = $n(this.Llaika_api_config_ConfigDecoder$__f_string);
    var f = new $c_sjsr_AnonFunction1(((dateString) => {
      var dateString$1 = $as_T(dateString);
      var this$3 = $n($m_Llaika_config_PlatformDateTimeImpl$().parse__T__s_util_Either(dateString$1));
      var this$4 = new $c_s_util_Either$LeftProjection(this$3);
      var x1 = this$4.s_util_Either$LeftProjection__f_e;
      if ((x1 instanceof $c_s_util_Left)) {
        var x2 = $as_s_util_Left(x1);
        var a = $n(x2).s_util_Left__f_value;
        var err = $as_T(a);
        var error = ("Invalid date format: " + err);
        var key = $m_s_None$();
        return new $c_s_util_Left(new $c_Llaika_api_config_ConfigError$DecodingFailed(error, key));
      } else {
        return this$4.s_util_Either$LeftProjection__f_e;
      }
    }));
    this.Llaika_api_config_ConfigDecoder$__f_date$lzy1 = new $c_Llaika_api_config_ConfigDecoder$$anon$1(f, this$7);
    this.Llaika_api_config_ConfigDecoder$__f_datebitmap$1 = true;
  }
  return this.Llaika_api_config_ConfigDecoder$__f_date$lzy1;
});
$c_Llaika_api_config_ConfigDecoder$.prototype.nec__Llaika_api_config_ConfigDecoder__Llaika_api_config_ConfigDecoder = (function(elementDecoder) {
  var this$5 = new $c_Llaika_api_config_ConfigDecoder$$anon$10(elementDecoder, this);
  var f = new $c_sjsr_AnonFunction1(((seq) => {
    var seq$1 = $as_sci_Seq(seq);
    var this$2 = $n($n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptyChain).fromSeq__sci_Seq__s_Option(seq$1));
    if (this$2.isEmpty__Z()) {
      var key = $m_s_None$();
      return new $c_s_util_Left(new $c_Llaika_api_config_ConfigError$DecodingFailed("Sequence must not be empty", key));
    } else {
      return new $c_s_util_Right(this$2.get__O());
    }
  }));
  return new $c_Llaika_api_config_ConfigDecoder$$anon$1(f, this$5);
});
var $d_Llaika_api_config_ConfigDecoder$ = new $TypeData().initClass($c_Llaika_api_config_ConfigDecoder$, "laika.api.config.ConfigDecoder$", ({
  Llaika_api_config_ConfigDecoder$: 1
}));
var $n_Llaika_api_config_ConfigDecoder$;
function $m_Llaika_api_config_ConfigDecoder$() {
  if ((!$n_Llaika_api_config_ConfigDecoder$)) {
    $n_Llaika_api_config_ConfigDecoder$ = new $c_Llaika_api_config_ConfigDecoder$();
  }
  return $n_Llaika_api_config_ConfigDecoder$;
}
/** @constructor */
function $c_Llaika_api_config_ConfigEncoder$() {
  this.Llaika_api_config_ConfigEncoder$__f_boolean = null;
  this.Llaika_api_config_ConfigEncoder$__f_string = null;
  this.Llaika_api_config_ConfigEncoder$__f_int = null;
  this.Llaika_api_config_ConfigEncoder$__f_path = null;
  this.Llaika_api_config_ConfigEncoder$__f_configValue = null;
  $n_Llaika_api_config_ConfigEncoder$ = this;
  this.Llaika_api_config_ConfigEncoder$__f_boolean = new $c_Llaika_api_config_ConfigEncoder$$anon$2();
  this.Llaika_api_config_ConfigEncoder$__f_string = new $c_Llaika_api_config_ConfigEncoder$$anon$3();
  this.Llaika_api_config_ConfigEncoder$__f_int = new $c_Llaika_api_config_ConfigEncoder$$anon$4();
  this.Llaika_api_config_ConfigEncoder$__f_path = new $c_Llaika_api_config_ConfigEncoder$$anon$6();
  this.Llaika_api_config_ConfigEncoder$__f_configValue = new $c_Llaika_api_config_ConfigEncoder$$anon$10();
}
$c_Llaika_api_config_ConfigEncoder$.prototype = new $h_O();
$c_Llaika_api_config_ConfigEncoder$.prototype.constructor = $c_Llaika_api_config_ConfigEncoder$;
/** @constructor */
function $h_Llaika_api_config_ConfigEncoder$() {
}
$h_Llaika_api_config_ConfigEncoder$.prototype = $c_Llaika_api_config_ConfigEncoder$.prototype;
var $d_Llaika_api_config_ConfigEncoder$ = new $TypeData().initClass($c_Llaika_api_config_ConfigEncoder$, "laika.api.config.ConfigEncoder$", ({
  Llaika_api_config_ConfigEncoder$: 1
}));
var $n_Llaika_api_config_ConfigEncoder$;
function $m_Llaika_api_config_ConfigEncoder$() {
  if ((!$n_Llaika_api_config_ConfigEncoder$)) {
    $n_Llaika_api_config_ConfigEncoder$ = new $c_Llaika_api_config_ConfigEncoder$();
  }
  return $n_Llaika_api_config_ConfigEncoder$;
}
/** @constructor */
function $c_Llaika_api_config_ConfigEncoder$ObjectBuilder(delegate) {
  this.Llaika_api_config_ConfigEncoder$ObjectBuilder__f_delegate = null;
  this.Llaika_api_config_ConfigEncoder$ObjectBuilder__f_delegate = delegate;
}
$c_Llaika_api_config_ConfigEncoder$ObjectBuilder.prototype = new $h_O();
$c_Llaika_api_config_ConfigEncoder$ObjectBuilder.prototype.constructor = $c_Llaika_api_config_ConfigEncoder$ObjectBuilder;
/** @constructor */
function $h_Llaika_api_config_ConfigEncoder$ObjectBuilder() {
}
$h_Llaika_api_config_ConfigEncoder$ObjectBuilder.prototype = $c_Llaika_api_config_ConfigEncoder$ObjectBuilder.prototype;
$c_Llaika_api_config_ConfigEncoder$ObjectBuilder.prototype.withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder = (function(key, value, encoder) {
  return this.withValue__Llaika_api_config_Key__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder($m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key(key), value, encoder);
});
$c_Llaika_api_config_ConfigEncoder$ObjectBuilder.prototype.withValue__Llaika_api_config_Key__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder = (function(key, value, encoder) {
  return new $c_Llaika_api_config_ConfigEncoder$ObjectBuilder($n(this.Llaika_api_config_ConfigEncoder$ObjectBuilder__f_delegate).withValue__Llaika_api_config_Key__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigBuilder(key, value, encoder));
});
$c_Llaika_api_config_ConfigEncoder$ObjectBuilder.prototype.withValue__T__s_Option__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder = (function(key, value, encoder) {
  var this$1 = $n(value);
  if (this$1.isEmpty__Z()) {
    return this;
  } else {
    var arg1 = this$1.get__O();
    return this.withValue__Llaika_api_config_Key__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder($m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key(key), arg1, encoder);
  }
});
$c_Llaika_api_config_ConfigEncoder$ObjectBuilder.prototype.build__Llaika_api_config_ConfigValue$ObjectValue = (function() {
  return $n(this.Llaika_api_config_ConfigEncoder$ObjectBuilder__f_delegate).asObjectValue__Llaika_api_config_ConfigValue$ObjectValue();
});
var $d_Llaika_api_config_ConfigEncoder$ObjectBuilder = new $TypeData().initClass($c_Llaika_api_config_ConfigEncoder$ObjectBuilder, "laika.api.config.ConfigEncoder$ObjectBuilder", ({
  Llaika_api_config_ConfigEncoder$ObjectBuilder: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigEncoder$ObjectBuilder$() {
  this.Llaika_api_config_ConfigEncoder$ObjectBuilder$__f_empty = null;
  $n_Llaika_api_config_ConfigEncoder$ObjectBuilder$ = this;
  this.Llaika_api_config_ConfigEncoder$ObjectBuilder$__f_empty = new $c_Llaika_api_config_ConfigEncoder$ObjectBuilder($m_Llaika_api_config_ConfigBuilder$().Llaika_api_config_ConfigBuilder$__f_empty);
}
$c_Llaika_api_config_ConfigEncoder$ObjectBuilder$.prototype = new $h_O();
$c_Llaika_api_config_ConfigEncoder$ObjectBuilder$.prototype.constructor = $c_Llaika_api_config_ConfigEncoder$ObjectBuilder$;
/** @constructor */
function $h_Llaika_api_config_ConfigEncoder$ObjectBuilder$() {
}
$h_Llaika_api_config_ConfigEncoder$ObjectBuilder$.prototype = $c_Llaika_api_config_ConfigEncoder$ObjectBuilder$.prototype;
var $d_Llaika_api_config_ConfigEncoder$ObjectBuilder$ = new $TypeData().initClass($c_Llaika_api_config_ConfigEncoder$ObjectBuilder$, "laika.api.config.ConfigEncoder$ObjectBuilder$", ({
  Llaika_api_config_ConfigEncoder$ObjectBuilder$: 1
}));
var $n_Llaika_api_config_ConfigEncoder$ObjectBuilder$;
function $m_Llaika_api_config_ConfigEncoder$ObjectBuilder$() {
  if ((!$n_Llaika_api_config_ConfigEncoder$ObjectBuilder$)) {
    $n_Llaika_api_config_ConfigEncoder$ObjectBuilder$ = new $c_Llaika_api_config_ConfigEncoder$ObjectBuilder$();
  }
  return $n_Llaika_api_config_ConfigEncoder$ObjectBuilder$;
}
function $is_Llaika_api_config_ConfigError(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_api_config_ConfigError)));
}
function $as_Llaika_api_config_ConfigError(obj) {
  return (($is_Llaika_api_config_ConfigError(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.ConfigError"));
}
function $isArrayOf_Llaika_api_config_ConfigError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_ConfigError)));
}
function $asArrayOf_Llaika_api_config_ConfigError(obj, depth) {
  return (($isArrayOf_Llaika_api_config_ConfigError(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.ConfigError;", depth));
}
function $is_Llaika_api_config_ConfigParser(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_api_config_ConfigParser)));
}
function $as_Llaika_api_config_ConfigParser(obj) {
  return (($is_Llaika_api_config_ConfigParser(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.ConfigParser"));
}
function $isArrayOf_Llaika_api_config_ConfigParser(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_ConfigParser)));
}
function $asArrayOf_Llaika_api_config_ConfigParser(obj, depth) {
  return (($isArrayOf_Llaika_api_config_ConfigParser(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.ConfigParser;", depth));
}
/** @constructor */
function $c_Llaika_api_config_ConfigParser$() {
  this.Llaika_api_config_ConfigParser$__f_includesNotSupported = null;
  $n_Llaika_api_config_ConfigParser$ = this;
  var this$4 = $m_sci_Map$EmptyMap$();
  var value = new $c_Llaika_api_config_ConfigError$ResourceLoadingFailed("Loading of includes is not supported in pure mode, use parsers or transformers in laika-io for this purpose.");
  var d = new $c_s_util_Left(value);
  this.Llaika_api_config_ConfigParser$__f_includesNotSupported = $f_sci_Map__withDefaultValue__O__sci_Map(this$4, d);
}
$c_Llaika_api_config_ConfigParser$.prototype = new $h_O();
$c_Llaika_api_config_ConfigParser$.prototype.constructor = $c_Llaika_api_config_ConfigParser$;
/** @constructor */
function $h_Llaika_api_config_ConfigParser$() {
}
$h_Llaika_api_config_ConfigParser$.prototype = $c_Llaika_api_config_ConfigParser$.prototype;
var $d_Llaika_api_config_ConfigParser$ = new $TypeData().initClass($c_Llaika_api_config_ConfigParser$, "laika.api.config.ConfigParser$", ({
  Llaika_api_config_ConfigParser$: 1
}));
var $n_Llaika_api_config_ConfigParser$;
function $m_Llaika_api_config_ConfigParser$() {
  if ((!$n_Llaika_api_config_ConfigParser$)) {
    $n_Llaika_api_config_ConfigParser$ = new $c_Llaika_api_config_ConfigParser$();
  }
  return $n_Llaika_api_config_ConfigParser$;
}
/** @constructor */
function $c_Llaika_api_config_DefaultKey$() {
}
$c_Llaika_api_config_DefaultKey$.prototype = new $h_O();
$c_Llaika_api_config_DefaultKey$.prototype.constructor = $c_Llaika_api_config_DefaultKey$;
/** @constructor */
function $h_Llaika_api_config_DefaultKey$() {
}
$h_Llaika_api_config_DefaultKey$.prototype = $c_Llaika_api_config_DefaultKey$.prototype;
var $d_Llaika_api_config_DefaultKey$ = new $TypeData().initClass($c_Llaika_api_config_DefaultKey$, "laika.api.config.DefaultKey$", ({
  Llaika_api_config_DefaultKey$: 1
}));
var $n_Llaika_api_config_DefaultKey$;
function $m_Llaika_api_config_DefaultKey$() {
  if ((!$n_Llaika_api_config_DefaultKey$)) {
    $n_Llaika_api_config_DefaultKey$ = new $c_Llaika_api_config_DefaultKey$();
  }
  return $n_Llaika_api_config_DefaultKey$;
}
function $is_Llaika_api_errors_TransformationError(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_api_errors_TransformationError)));
}
function $as_Llaika_api_errors_TransformationError(obj) {
  return (($is_Llaika_api_errors_TransformationError(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.errors.TransformationError"));
}
function $isArrayOf_Llaika_api_errors_TransformationError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_errors_TransformationError)));
}
function $asArrayOf_Llaika_api_errors_TransformationError(obj, depth) {
  return (($isArrayOf_Llaika_api_errors_TransformationError(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.errors.TransformationError;", depth));
}
function $ct_Llaika_api_format_Formatter__($thiz) {
  $thiz.Llaika_api_format_Formatter__f_newLine = $n($n($thiz.context__Llaika_api_format_Formatter$Context()).Llaika_api_format_Formatter$Context__f_indentation).Llaika_api_format_Formatter$Indentation__f_newLine;
  return $thiz;
}
function $p_Llaika_api_format_Formatter__renderCurrentElement__T($thiz) {
  return $as_T($n($n($thiz.context__Llaika_api_format_Formatter$Context()).Llaika_api_format_Formatter$Context__f_renderChild).apply__O__O__O($thiz.self__Llaika_api_format_Formatter(), $n($thiz.context__Llaika_api_format_Formatter$Context()).Llaika_api_format_Formatter$Context__f_currentElement));
}
function $p_Llaika_api_format_Formatter__nextLevel__Llaika_api_format_Formatter($thiz) {
  if ((!$thiz.Llaika_api_format_Formatter__f_nextLevelbitmap$1)) {
    var x = $n($thiz.context__Llaika_api_format_Formatter$Context()).Llaika_api_format_Formatter$Context__f_indentation;
    var x$2 = $m_Llaika_api_format_Formatter$Indentation$().Llaika_api_format_Formatter$Indentation$__f_none;
    $thiz.Llaika_api_format_Formatter__f_nextLevel$lzy1 = (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) ? $thiz.self__Llaika_api_format_Formatter() : $thiz.withIndentation__Llaika_api_format_Formatter$Indentation__Llaika_api_format_Formatter($n($n($thiz.context__Llaika_api_format_Formatter$Context()).Llaika_api_format_Formatter$Context__f_indentation).nextLevel__Llaika_api_format_Formatter$Indentation()));
    $thiz.Llaika_api_format_Formatter__f_nextLevelbitmap$1 = true;
  }
  return $thiz.Llaika_api_format_Formatter__f_nextLevel$lzy1;
}
/** @constructor */
function $c_Llaika_api_format_Formatter() {
  this.Llaika_api_format_Formatter__f_nextLevel$lzy1 = null;
  this.Llaika_api_format_Formatter__f_nextLevelbitmap$1 = false;
  this.Llaika_api_format_Formatter__f_newLine = null;
}
$c_Llaika_api_format_Formatter.prototype = new $h_O();
$c_Llaika_api_format_Formatter.prototype.constructor = $c_Llaika_api_format_Formatter;
/** @constructor */
function $h_Llaika_api_format_Formatter() {
}
$h_Llaika_api_format_Formatter.prototype = $c_Llaika_api_format_Formatter.prototype;
$c_Llaika_api_format_Formatter.prototype.forMessage__Llaika_ast_RuntimeMessage__T__T = (function(message, whenEnabled) {
  return ($n($n(this.context__Llaika_api_format_Formatter$Context()).Llaika_api_format_Formatter$Context__f_messageFilter).apply__Llaika_ast_RuntimeMessage__Z(message) ? whenEnabled : "");
});
$c_Llaika_api_format_Formatter.prototype.children__sci_Seq__T = (function(elements) {
  var this$2 = $n($as_sc_IterableOnceOps($n(elements).map__F1__O(new $c_sjsr_AnonFunction1(((element) => {
    var element$1 = $as_Llaika_ast_Element(element);
    return this.child__Llaika_ast_Element__T(element$1);
  })))));
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$2, "", "", "");
});
$c_Llaika_api_format_Formatter.prototype.child__Llaika_ast_Element__T = (function(element) {
  return $p_Llaika_api_format_Formatter__renderCurrentElement__T($n(this.withChild__Llaika_ast_Element__Llaika_api_format_Formatter(element)));
});
$c_Llaika_api_format_Formatter.prototype.childPerLine__sci_Seq__T = (function(elements) {
  var this$2 = $n($as_sc_IterableOnceOps($n(elements).map__F1__O(new $c_sjsr_AnonFunction1(((element) => {
    var element$1 = $as_Llaika_ast_Element(element);
    return this.child__Llaika_ast_Element__T(element$1);
  })))));
  var sep = this.Llaika_api_format_Formatter__f_newLine;
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$2, "", sep, "");
});
$c_Llaika_api_format_Formatter.prototype.indentedChildren__sci_Seq__T = (function(elements) {
  if ($n(elements).isEmpty__Z()) {
    return "";
  } else {
    var arg1 = $p_Llaika_api_format_Formatter__nextLevel__Llaika_api_format_Formatter(this);
    return (("" + $n(arg1).Llaika_api_format_Formatter__f_newLine) + $n(arg1).childPerLine__sci_Seq__T(elements));
  }
});
function $as_Llaika_api_format_Formatter(obj) {
  return (((obj instanceof $c_Llaika_api_format_Formatter) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.format.Formatter"));
}
function $isArrayOf_Llaika_api_format_Formatter(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_format_Formatter)));
}
function $asArrayOf_Llaika_api_format_Formatter(obj, depth) {
  return (($isArrayOf_Llaika_api_format_Formatter(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.format.Formatter;", depth));
}
/** @constructor */
function $c_Llaika_api_format_Formatter$() {
}
$c_Llaika_api_format_Formatter$.prototype = new $h_O();
$c_Llaika_api_format_Formatter$.prototype.constructor = $c_Llaika_api_format_Formatter$;
/** @constructor */
function $h_Llaika_api_format_Formatter$() {
}
$h_Llaika_api_format_Formatter$.prototype = $c_Llaika_api_format_Formatter$.prototype;
$c_Llaika_api_format_Formatter$.prototype.defaultFactory__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((ctx) => {
    var ctx$1 = $as_Llaika_api_format_Formatter$Context(ctx);
    return new $c_Llaika_api_format_Formatter$$anon$1(ctx$1);
  }));
});
var $d_Llaika_api_format_Formatter$ = new $TypeData().initClass($c_Llaika_api_format_Formatter$, "laika.api.format.Formatter$", ({
  Llaika_api_format_Formatter$: 1
}));
var $n_Llaika_api_format_Formatter$;
function $m_Llaika_api_format_Formatter$() {
  if ((!$n_Llaika_api_format_Formatter$)) {
    $n_Llaika_api_format_Formatter$ = new $c_Llaika_api_format_Formatter$();
  }
  return $n_Llaika_api_format_Formatter$;
}
/** @constructor */
function $c_Llaika_api_format_Formatter$Context(renderChild, currentElement, parents, styles, path, pathTranslator, indentation, messageFilter) {
  this.Llaika_api_format_Formatter$Context__f_renderChild = null;
  this.Llaika_api_format_Formatter$Context__f_currentElement = null;
  this.Llaika_api_format_Formatter$Context__f_parents = null;
  this.Llaika_api_format_Formatter$Context__f_styles = null;
  this.Llaika_api_format_Formatter$Context__f_path = null;
  this.Llaika_api_format_Formatter$Context__f_pathTranslator = null;
  this.Llaika_api_format_Formatter$Context__f_indentation = null;
  this.Llaika_api_format_Formatter$Context__f_messageFilter = null;
  this.Llaika_api_format_Formatter$Context__f_renderChild = renderChild;
  this.Llaika_api_format_Formatter$Context__f_currentElement = currentElement;
  this.Llaika_api_format_Formatter$Context__f_parents = parents;
  this.Llaika_api_format_Formatter$Context__f_styles = styles;
  this.Llaika_api_format_Formatter$Context__f_path = path;
  this.Llaika_api_format_Formatter$Context__f_pathTranslator = pathTranslator;
  this.Llaika_api_format_Formatter$Context__f_indentation = indentation;
  this.Llaika_api_format_Formatter$Context__f_messageFilter = messageFilter;
}
$c_Llaika_api_format_Formatter$Context.prototype = new $h_O();
$c_Llaika_api_format_Formatter$Context.prototype.constructor = $c_Llaika_api_format_Formatter$Context;
/** @constructor */
function $h_Llaika_api_format_Formatter$Context() {
}
$h_Llaika_api_format_Formatter$Context.prototype = $c_Llaika_api_format_Formatter$Context.prototype;
$c_Llaika_api_format_Formatter$Context.prototype.forChildElement__Llaika_ast_Element__Llaika_api_format_Formatter$Context = (function(child) {
  var $x_1 = this.Llaika_api_format_Formatter$Context__f_renderChild;
  var this$1 = $n(this.Llaika_api_format_Formatter$Context__f_parents);
  var elem = this.Llaika_api_format_Formatter$Context__f_currentElement;
  return new $c_Llaika_api_format_Formatter$Context($x_1, child, new $c_sci_$colon$colon(elem, this$1), this.Llaika_api_format_Formatter$Context__f_styles, this.Llaika_api_format_Formatter$Context__f_path, this.Llaika_api_format_Formatter$Context__f_pathTranslator, this.Llaika_api_format_Formatter$Context__f_indentation, this.Llaika_api_format_Formatter$Context__f_messageFilter);
});
function $as_Llaika_api_format_Formatter$Context(obj) {
  return (((obj instanceof $c_Llaika_api_format_Formatter$Context) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.format.Formatter$Context"));
}
function $isArrayOf_Llaika_api_format_Formatter$Context(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_format_Formatter$Context)));
}
function $asArrayOf_Llaika_api_format_Formatter$Context(obj, depth) {
  return (($isArrayOf_Llaika_api_format_Formatter$Context(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.format.Formatter$Context;", depth));
}
var $d_Llaika_api_format_Formatter$Context = new $TypeData().initClass($c_Llaika_api_format_Formatter$Context, "laika.api.format.Formatter$Context", ({
  Llaika_api_format_Formatter$Context: 1
}));
function $f_Llaika_api_format_MarkupFormat__createBlockListParser__Llaika_parse_Parser__Llaika_parse_Parser($thiz, parser) {
  var this$1 = $m_Llaika_parse_combinator_Parsers$();
  var p = $m_Llaika_parse_text_TextParsers$().Llaika_parse_text_TextParsers$__f_blankLines;
  var this$2 = $n($n(parser).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$1, p)));
  return new $c_Llaika_parse_combinator_Repeat(this$2, 0, 2147483647, $m_s_None$());
}
/** @constructor */
function $c_Llaika_api_format_TagFormatter$() {
}
$c_Llaika_api_format_TagFormatter$.prototype = new $h_O();
$c_Llaika_api_format_TagFormatter$.prototype.constructor = $c_Llaika_api_format_TagFormatter$;
/** @constructor */
function $h_Llaika_api_format_TagFormatter$() {
}
$h_Llaika_api_format_TagFormatter$.prototype = $c_Llaika_api_format_TagFormatter$.prototype;
$c_Llaika_api_format_TagFormatter$.prototype.escape__T__T__T = (function(str, newLine) {
  var i = 0;
  var this$1 = $n(str);
  var end = this$1.length;
  var result = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  while ((i < end)) {
    var this$2 = $n(str);
    var index = i;
    var x11 = $charAt(this$2, index);
    switch (x11) {
      case 60: {
        result.append__T__scm_StringBuilder("&lt;");
        break;
      }
      case 62: {
        result.append__T__scm_StringBuilder("&gt;");
        break;
      }
      case 34: {
        result.append__T__scm_StringBuilder("&quot;");
        break;
      }
      case 39: {
        result.append__T__scm_StringBuilder("&#39;");
        break;
      }
      case 38: {
        result.append__T__scm_StringBuilder("&amp;");
        break;
      }
      case 160: {
        result.append__T__scm_StringBuilder("&nbsp;");
        break;
      }
      case 10: {
        result.append__T__scm_StringBuilder(newLine);
        break;
      }
      default: {
        result.append__C__scm_StringBuilder(x11);
      }
    }
    i = ((1 + i) | 0);
  }
  return $n(result.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
var $d_Llaika_api_format_TagFormatter$ = new $TypeData().initClass($c_Llaika_api_format_TagFormatter$, "laika.api.format.TagFormatter$", ({
  Llaika_api_format_TagFormatter$: 1
}));
var $n_Llaika_api_format_TagFormatter$;
function $m_Llaika_api_format_TagFormatter$() {
  if ((!$n_Llaika_api_format_TagFormatter$)) {
    $n_Llaika_api_format_TagFormatter$ = new $c_Llaika_api_format_TagFormatter$();
  }
  return $n_Llaika_api_format_TagFormatter$;
}
/** @constructor */
function $c_Llaika_ast_$div$() {
}
$c_Llaika_ast_$div$.prototype = new $h_O();
$c_Llaika_ast_$div$.prototype.constructor = $c_Llaika_ast_$div$;
/** @constructor */
function $h_Llaika_ast_$div$() {
}
$h_Llaika_ast_$div$.prototype = $c_Llaika_ast_$div$.prototype;
$c_Llaika_ast_$div$.prototype.unapply__Llaika_ast_RelativePath__s_Option = (function(p) {
  if ((p instanceof $c_Llaika_ast_RelativePath$Segments)) {
    var _1 = $n(p).parent__Llaika_ast_RelativePath();
    var _2 = $n(p).name__T();
    var value = new $c_T2(_1, _2);
    return new $c_s_Some(value);
  } else {
    return $m_s_None$();
  }
});
var $d_Llaika_ast_$div$ = new $TypeData().initClass($c_Llaika_ast_$div$, "laika.ast.$div$", ({
  Llaika_ast_$div$: 1
}));
var $n_Llaika_ast_$div$;
function $m_Llaika_ast_$div$() {
  if ((!$n_Llaika_ast_$div$)) {
    $n_Llaika_ast_$div$ = new $c_Llaika_ast_$div$();
  }
  return $n_Llaika_ast_$div$;
}
function $is_Llaika_ast_Block(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_Block)));
}
function $as_Llaika_ast_Block(obj) {
  return (($is_Llaika_ast_Block(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Block"));
}
function $isArrayOf_Llaika_ast_Block(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Block)));
}
function $asArrayOf_Llaika_ast_Block(obj, depth) {
  return (($isArrayOf_Llaika_ast_Block(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Block;", depth));
}
var $d_Llaika_ast_Block = new $TypeData().initClass(1, "laika.ast.Block", ({
  Llaika_ast_Block: 1
}));
/** @constructor */
function $c_Llaika_ast_CellType() {
}
$c_Llaika_ast_CellType.prototype = new $h_O();
$c_Llaika_ast_CellType.prototype.constructor = $c_Llaika_ast_CellType;
/** @constructor */
function $h_Llaika_ast_CellType() {
}
$h_Llaika_ast_CellType.prototype = $c_Llaika_ast_CellType.prototype;
function $is_Llaika_ast_Container(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_Container)));
}
function $as_Llaika_ast_Container(obj) {
  return (($is_Llaika_ast_Container(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Container"));
}
function $isArrayOf_Llaika_ast_Container(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Container)));
}
function $asArrayOf_Llaika_ast_Container(obj, depth) {
  return (($isArrayOf_Llaika_ast_Container(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Container;", depth));
}
function $p_Llaika_ast_Document$__contextFor$2__Llaika_ast_Path__Llaika_ast_TreeNodeContext($thiz, path) {
  matchResult24: {
    var parent;
    var x105 = $n(path).parent__Llaika_ast_Path();
    var x = $m_Llaika_ast_Path$Root$();
    if ((x === x105)) {
      var parent = $m_s_None$();
      break matchResult24;
    }
    var value = $p_Llaika_ast_Document$__contextFor$2__Llaika_ast_Path__Llaika_ast_TreeNodeContext($thiz, x105);
    var parent = new $c_s_Some(value);
  }
  var value$1 = $n(path).name__T();
  var localPath$4 = new $c_s_Some(value$1);
  var localConfig$4 = $m_Llaika_api_config_Config$().Llaika_api_config_Config$__f_empty;
  var index$4 = $m_Llaika_ast_TreeNodeIndex$Unassigned$();
  return new $c_Llaika_ast_TreeNodeContext(localPath$4, localConfig$4, index$4, parent);
}
/** @constructor */
function $c_Llaika_ast_Document$() {
}
$c_Llaika_ast_Document$.prototype = new $h_O();
$c_Llaika_ast_Document$.prototype.constructor = $c_Llaika_ast_Document$;
/** @constructor */
function $h_Llaika_ast_Document$() {
}
$h_Llaika_ast_Document$.prototype = $c_Llaika_ast_Document$.prototype;
$c_Llaika_ast_Document$.prototype.apply__Llaika_ast_Path__Llaika_ast_RootElement__Llaika_ast_Document = (function(path, content) {
  return new $c_Llaika_ast_Document($p_Llaika_ast_Document$__contextFor$2__Llaika_ast_Path__Llaika_ast_TreeNodeContext(this, path), content, $m_sci_Map$EmptyMap$());
});
var $d_Llaika_ast_Document$ = new $TypeData().initClass($c_Llaika_ast_Document$, "laika.ast.Document$", ({
  Llaika_ast_Document$: 1
}));
var $n_Llaika_ast_Document$;
function $m_Llaika_ast_Document$() {
  if ((!$n_Llaika_ast_Document$)) {
    $n_Llaika_ast_Document$ = new $c_Llaika_ast_Document$();
  }
  return $n_Llaika_ast_Document$;
}
/** @constructor */
function $c_Llaika_ast_DocumentCursor$() {
}
$c_Llaika_ast_DocumentCursor$.prototype = new $h_O();
$c_Llaika_ast_DocumentCursor$.prototype.constructor = $c_Llaika_ast_DocumentCursor$;
/** @constructor */
function $h_Llaika_ast_DocumentCursor$() {
}
$h_Llaika_ast_DocumentCursor$.prototype = $c_Llaika_ast_DocumentCursor$.prototype;
$c_Llaika_ast_DocumentCursor$.prototype.apply__Llaika_ast_Document__s_Option__s_util_Either = (function(document, outputContext) {
  var this$1 = $n(document);
  $m_Llaika_api_config_ConfigBuilder$();
  var fallback = $n(this$1.Llaika_ast_Document__f_context).Llaika_ast_TreeNodeContext__f_localConfig;
  var builder = new $c_Llaika_api_config_ConfigBuilder($m_sci_Nil$(), $n(fallback).origin__Llaika_api_config_Origin(), fallback);
  var orphanDoc = this$1.withConfig__Llaika_api_config_Config__Llaika_ast_Document($n(builder.withValue__Llaika_api_config_Key__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigBuilder($m_Llaika_config_LaikaKeys$().Llaika_config_LaikaKeys$__f_orphan, true, $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_boolean)).build__Llaika_api_config_Config());
  var $x_1 = $m_Llaika_ast_TreeCursor$();
  var this$3 = $n($n($m_Llaika_ast_DocumentTree$().Llaika_ast_DocumentTree$__f_builder).addDocument__Llaika_ast_Document__Llaika_ast_DocumentTreeBuilder(orphanDoc));
  var this$4 = $n($n($x_1).apply__Llaika_ast_DocumentTree__s_Option__s_util_Either(this$3.build__Llaika_api_config_Config__Llaika_ast_DocumentTree($m_Llaika_api_config_Config$().Llaika_api_config_Config$__f_empty), outputContext));
  if ((this$4 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$4);
    var b = $n(x2).s_util_Right__f_value;
    var _$14 = $as_Llaika_ast_TreeCursor(b);
    return new $c_s_util_Right(this.apply__Llaika_ast_Document__Llaika_ast_TreeCursor__Llaika_ast_DocumentCursor(orphanDoc, _$14));
  } else {
    return this$4;
  }
});
$c_Llaika_ast_DocumentCursor$.prototype.apply__Llaika_ast_Document__Llaika_ast_TreeCursor__Llaika_ast_DocumentCursor = (function(document, parent) {
  return new $c_Llaika_ast_DocumentCursor(document, parent, $m_Llaika_internal_rewrite_ReferenceResolver$().forDocument__Llaika_ast_Document__Llaika_ast_TreeCursor__Llaika_internal_rewrite_ReferenceResolver(document, parent), $m_s_None$());
});
var $d_Llaika_ast_DocumentCursor$ = new $TypeData().initClass($c_Llaika_ast_DocumentCursor$, "laika.ast.DocumentCursor$", ({
  Llaika_ast_DocumentCursor$: 1
}));
var $n_Llaika_ast_DocumentCursor$;
function $m_Llaika_ast_DocumentCursor$() {
  if ((!$n_Llaika_ast_DocumentCursor$)) {
    $n_Llaika_ast_DocumentCursor$ = new $c_Llaika_ast_DocumentCursor$();
  }
  return $n_Llaika_ast_DocumentCursor$;
}
/** @constructor */
function $c_Llaika_ast_DocumentTree$() {
  this.Llaika_ast_DocumentTree$__f_builder = null;
  $n_Llaika_ast_DocumentTree$ = this;
  this.Llaika_ast_DocumentTree$__f_builder = new $c_Llaika_ast_DocumentTreeBuilder($m_sci_Nil$());
  var localPath = $m_s_None$();
  $m_Llaika_api_config_Config$();
  $m_Llaika_ast_DocumentTree$();
  $m_Llaika_ast_DocumentTree$();
}
$c_Llaika_ast_DocumentTree$.prototype = new $h_O();
$c_Llaika_ast_DocumentTree$.prototype.constructor = $c_Llaika_ast_DocumentTree$;
/** @constructor */
function $h_Llaika_ast_DocumentTree$() {
}
$h_Llaika_ast_DocumentTree$.prototype = $c_Llaika_ast_DocumentTree$.prototype;
var $d_Llaika_ast_DocumentTree$ = new $TypeData().initClass($c_Llaika_ast_DocumentTree$, "laika.ast.DocumentTree$", ({
  Llaika_ast_DocumentTree$: 1
}));
var $n_Llaika_ast_DocumentTree$;
function $m_Llaika_ast_DocumentTree$() {
  if ((!$n_Llaika_ast_DocumentTree$)) {
    $n_Llaika_ast_DocumentTree$ = new $c_Llaika_ast_DocumentTree$();
  }
  return $n_Llaika_ast_DocumentTree$;
}
function $p_Llaika_ast_DocumentTreeBuilder__extract__sci_Seq__T__T2($thiz, content, docName) {
  var extracted = $n(content).collectFirst__s_PartialFunction__s_Option(new $c_Llaika_ast_DocumentTreeBuilder$$anon$1(docName));
  var this$1 = $n(extracted);
  if ((!this$1.isEmpty__Z())) {
    var filteredContent = $as_sci_Seq($n(content).filterNot__F1__O(new $c_sjsr_AnonFunction1(((_$1) => {
      var _$1$1 = $as_Llaika_ast_TreeContent(_$1);
      return ($n($n(_$1$1).path__Llaika_ast_Path()).basename__T() === docName);
    }))));
  } else {
    var filteredContent = content;
  }
  return new $c_T2(extracted, filteredContent);
}
function $p_Llaika_ast_DocumentTreeBuilder__buildNode__Llaika_ast_Path__sci_Seq__Llaika_ast_DocumentTreeBuilder$TreePart($thiz, path, content) {
  var treeContent = $as_sci_Seq($n(content).collect__s_PartialFunction__O(new $c_Llaika_ast_DocumentTreeBuilder$$anon$2()));
  var templates = $as_sci_Seq($n(content).collect__s_PartialFunction__O(new $c_Llaika_ast_DocumentTreeBuilder$$anon$3()));
  var hoconConfig = $as_sci_Seq($n(content).collect__s_PartialFunction__O(new $c_Llaika_ast_DocumentTreeBuilder$$anon$4()));
  var treeConfig = $as_sci_Seq($n(content).collect__s_PartialFunction__O(new $c_Llaika_ast_DocumentTreeBuilder$$anon$5()));
  return new $c_Llaika_ast_DocumentTreeBuilder$TreePart(path, treeContent, templates, hoconConfig, treeConfig);
}
function $p_Llaika_ast_DocumentTreeBuilder__localPath__Llaika_ast_Path__s_Option($thiz, path) {
  var x = $m_Llaika_ast_Path$Root$();
  if ((x === path)) {
    return $m_s_None$();
  } else {
    var value = $n(path).name__T();
    return new $c_s_Some(value);
  }
}
function $p_Llaika_ast_DocumentTreeBuilder__applyContext__Llaika_ast_Document__Llaika_ast_TreeNodeContext__Llaika_ast_Document($thiz, doc, parentContext) {
  var $x_1 = $n(doc).config__Llaika_api_config_Config();
  $m_Llaika_api_config_Origin$();
  var scope = $m_Llaika_api_config_Origin$DocumentScope$();
  var path = $n(doc).path__Llaika_ast_Path();
  $m_Llaika_api_config_Origin$();
  var sourcePath = $m_s_None$();
  return $n($n(doc).withConfig__Llaika_api_config_Config__Llaika_ast_Document($n($x_1).withOrigin__Llaika_api_config_Origin__Llaika_api_config_Config(new $c_Llaika_api_config_Origin(scope, path, sourcePath)))).withParent__Llaika_ast_TreeNodeContext__Llaika_ast_Document(parentContext);
}
function $p_Llaika_ast_DocumentTreeBuilder__buildTree__Llaika_ast_DocumentTreeBuilder$TreePart__Llaika_api_config_Config__T__s_Option__Llaika_ast_DocumentTree($thiz, result, baseConfig, defaultTitleName, parentContext) {
  var treeConfig = $n(result).mergeConfigs__Llaika_api_config_Config();
  var localPath$2 = $p_Llaika_ast_DocumentTreeBuilder__localPath__Llaika_ast_Path__s_Option($thiz, $n(result).Llaika_ast_DocumentTreeBuilder$TreePart__f_path);
  var localConfig$2 = ($n(parentContext).isEmpty__Z() ? $n(treeConfig).withFallback__Llaika_api_config_Config__Llaika_api_config_Config(baseConfig) : treeConfig);
  var index$2 = $m_Llaika_ast_TreeNodeIndex$Unassigned$();
  var context = new $c_Llaika_ast_TreeNodeContext(localPath$2, localConfig$2, index$2, parentContext);
  var this$3 = $n($m_Llaika_internal_nav_TitleDocumentConfig$().inputName__Llaika_api_config_Config__s_util_Either(treeConfig));
  if ((this$3 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$3);
    var b = $n(x2).s_util_Right__f_value;
    var $x_1 = b;
  } else {
    var $x_1 = defaultTitleName;
  }
  var titleName = $as_T($x_1);
  var allContent = $as_sci_Seq($n($n(result).Llaika_ast_DocumentTreeBuilder$TreePart__f_content).flatMap__F1__O(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Llaika_ast_DocumentTreeBuilder$TreeContentPart(x$1);
    if ((x$1$1 instanceof $c_Llaika_ast_DocumentTreeBuilder$TreePart)) {
      var tree = $as_Llaika_ast_DocumentTreeBuilder$TreePart(x$1$1);
      var value = $p_Llaika_ast_DocumentTreeBuilder__buildTree__Llaika_ast_DocumentTreeBuilder$TreePart__Llaika_api_config_Config__T__s_Option__Llaika_ast_DocumentTree($thiz, tree, $n(treeConfig).withFallback__Llaika_api_config_Config__Llaika_api_config_Config(baseConfig), titleName, new $c_s_Some(context));
      return new $c_s_Some(value);
    }
    if ((x$1$1 instanceof $c_Llaika_ast_DocumentTreeBuilder$DocumentPart)) {
      var doc = $as_Llaika_ast_DocumentTreeBuilder$DocumentPart(x$1$1);
      var value$1 = $p_Llaika_ast_DocumentTreeBuilder__applyContext__Llaika_ast_Document__Llaika_ast_TreeNodeContext__Llaika_ast_Document($thiz, $n(doc).Llaika_ast_DocumentTreeBuilder$DocumentPart__f_doc, context);
      return new $c_s_Some(value$1);
    }
    if (false) {
      return $m_s_None$();
    }
    throw new $c_s_MatchError(x$1$1);
  }))));
  matchResult17: {
    var \u03b42$___1;
    var \u03b42$___2;
    var x47 = $p_Llaika_ast_DocumentTreeBuilder__extract__sci_Seq__T__T2($thiz, allContent, titleName);
    if ((x47 !== null)) {
      var title = $as_s_Option($n(x47)._1__O());
      var content = $as_sci_Seq($n(x47)._2__O());
      var \u03b42$___1 = title;
      var \u03b42$___2 = content;
      break matchResult17;
    }
    throw new $c_s_MatchError(x47);
  }
  var title$2 = $as_s_Option(\u03b42$___1);
  var content$2 = $as_sci_Seq(\u03b42$___2);
  return new $c_Llaika_ast_DocumentTree(context, content$2, title$2, $n(result).Llaika_ast_DocumentTreeBuilder$TreePart__f_templates);
}
/** @constructor */
function $c_Llaika_ast_DocumentTreeBuilder(parts) {
  this.Llaika_ast_DocumentTreeBuilder__f_parts = null;
  this.Llaika_ast_DocumentTreeBuilder__f_distinctParts$lzy1 = null;
  this.Llaika_ast_DocumentTreeBuilder__f_distinctPartsbitmap$1 = false;
  this.Llaika_ast_DocumentTreeBuilder__f_parts = parts;
}
$c_Llaika_ast_DocumentTreeBuilder.prototype = new $h_O();
$c_Llaika_ast_DocumentTreeBuilder.prototype.constructor = $c_Llaika_ast_DocumentTreeBuilder;
/** @constructor */
function $h_Llaika_ast_DocumentTreeBuilder() {
}
$h_Llaika_ast_DocumentTreeBuilder.prototype = $c_Llaika_ast_DocumentTreeBuilder.prototype;
$c_Llaika_ast_DocumentTreeBuilder.prototype.distinctParts__sci_List = (function() {
  if ((!this.Llaika_ast_DocumentTreeBuilder__f_distinctPartsbitmap$1)) {
    var paths = $as_scm_Set($m_scm_Set$().apply__sci_Seq__O($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Path.getArrayOf().constr)([]))));
    var this$1 = $n(this.Llaika_ast_DocumentTreeBuilder__f_parts);
    var f = ((p) => {
      var p$1 = $as_Llaika_ast_DocumentTreeBuilder$BuilderPart(p);
      return $n(paths).add__O__Z($n(p$1).path__Llaika_ast_Path());
    });
    var l = this$1;
    block: {
      var result;
      while (true) {
        if ($n(l).isEmpty__Z()) {
          var result = $m_sci_Nil$();
          break;
        } else {
          var h = $n(l).head__O();
          var t = $as_sci_List($n(l).tail__O());
          if (($uZ(f(h)) === false)) {
            l = t;
            continue;
          }
          var start = l;
          var remaining = t;
          while (true) {
            if ($n(remaining).isEmpty__Z()) {
              var result = start;
              break block;
            } else {
              var x = $n(remaining).head__O();
              if (($uZ(f(x)) !== false)) {
                remaining = $as_sci_List($n(remaining).tail__O());
                continue;
              }
              var firstMiss = remaining;
              var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
              var toProcess = $as_sci_List($n(start).tail__O());
              var currentLast = newHead;
              while ((toProcess !== firstMiss)) {
                var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
                $n(currentLast).sci_$colon$colon__f_next = newElem;
                currentLast = newElem;
                toProcess = $as_sci_List($n(toProcess).tail__O());
              }
              var next = $as_sci_List($n(firstMiss).tail__O());
              var nextToCopy = next;
              while ((!$n(next).isEmpty__Z())) {
                var head = $n(next).head__O();
                if (($uZ(f(head)) !== false)) {
                  next = $as_sci_List($n(next).tail__O());
                } else {
                  while ((nextToCopy !== next)) {
                    var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                    $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                    currentLast = newElem$2;
                    nextToCopy = $as_sci_List($n(nextToCopy).tail__O());
                  }
                  nextToCopy = $as_sci_List($n(next).tail__O());
                  next = $as_sci_List($n(next).tail__O());
                }
              }
              if ((!$n(nextToCopy).isEmpty__Z())) {
                $n(currentLast).sci_$colon$colon__f_next = nextToCopy;
              }
              var result = newHead;
              break block;
            }
          }
        }
      }
    }
    this.Llaika_ast_DocumentTreeBuilder__f_distinctParts$lzy1 = $n(result).reverse__sci_List();
    this.Llaika_ast_DocumentTreeBuilder__f_distinctPartsbitmap$1 = true;
  }
  return this.Llaika_ast_DocumentTreeBuilder__f_distinctParts$lzy1;
});
$c_Llaika_ast_DocumentTreeBuilder.prototype.addDocument__Llaika_ast_Document__Llaika_ast_DocumentTreeBuilder = (function(doc) {
  var elem$1 = new $c_Llaika_ast_DocumentTreeBuilder$DocumentPart(doc);
  var this$2 = $n(this.Llaika_ast_DocumentTreeBuilder__f_parts);
  return new $c_Llaika_ast_DocumentTreeBuilder(this$2.prepended__O__sci_List(elem$1));
});
$c_Llaika_ast_DocumentTreeBuilder.prototype.build__Llaika_api_config_Config__Llaika_ast_DocumentTree = (function(baseConfig) {
  var this$2 = $m_Llaika_ast_TreeBuilder$();
  var content$2 = this.distinctParts__sci_List();
  var f = ((path, content) => {
    var path$1 = $as_Llaika_ast_Path(path);
    var content$1 = $as_sci_Seq(content);
    return $p_Llaika_ast_DocumentTreeBuilder__buildNode__Llaika_ast_Path__sci_Seq__Llaika_ast_DocumentTreeBuilder$TreePart(this, path$1, content$1);
  });
  if ($n(content$2).isEmpty__Z()) {
    var arg1 = $m_Llaika_ast_Path$Root$();
    var arg2 = $m_sci_Nil$();
    var $x_1 = $as_Llaika_ast_Navigatable(f(arg1, arg2));
  } else {
    var this$3 = $n(content$2);
    var f$1 = ((_$3) => {
      var _$3$1 = $as_Llaika_ast_Navigatable(_$3);
      return $n($n($n(_$3$1).path__Llaika_ast_Path()).parent__Llaika_ast_Path()).depth__I();
    });
    if ((this$3 === $m_sci_Nil$())) {
      var $x_2 = $m_sci_Nil$();
    } else {
      var arg1$1 = this$3.head__O();
      var h = new $c_sci_$colon$colon(f$1(arg1$1), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(this$3.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var arg1$2 = $n(rest).head__O();
        var nx = new $c_sci_$colon$colon(f$1(arg1$2), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O());
      }
      var $x_2 = h;
    }
    var this$4 = $n($x_2);
    var ord = $m_s_math_Ordering$Int$();
    var maxPathLength = $uI($f_sc_IterableOnceOps__max__s_math_Ordering__O(this$4, ord));
    var contentMap = $p_Llaika_ast_TreeBuilder$__toMap$1__sc_Iterable__sci_Map(this$2, content$2);
    var $x_3;
    var contentMap$tailLocal1 = contentMap;
    var depth$tailLocal1 = maxPathLength;
    while (true) {
      var this$5 = $n(content$2);
      var depth$tailLocal1$2$1 = depth$tailLocal1;
      var f$2 = ((depth$tailLocal1$2) => ((_$1) => {
        var _$1$1 = $as_Llaika_ast_Navigatable(_$1);
        return ($n($n($n(_$1$1).path__Llaika_ast_Path()).parent__Llaika_ast_Path()).depth__I() >= depth$tailLocal1$2);
      }))(depth$tailLocal1$2$1);
      var l = this$5;
      block: {
        var result;
        while (true) {
          if ($n(l).isEmpty__Z()) {
            var result = $m_sci_Nil$();
            break;
          } else {
            var h$1 = $n(l).head__O();
            var t$1 = $as_sci_List($n(l).tail__O());
            if (($uZ(f$2(h$1)) === false)) {
              l = t$1;
              continue;
            }
            var start = l;
            var remaining = t$1;
            while (true) {
              if ($n(remaining).isEmpty__Z()) {
                var result = start;
                break block;
              } else {
                var x = $n(remaining).head__O();
                if (($uZ(f$2(x)) !== false)) {
                  remaining = $as_sci_List($n(remaining).tail__O());
                  continue;
                }
                var firstMiss = remaining;
                var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
                var toProcess = $as_sci_List($n(start).tail__O());
                var currentLast = newHead;
                while ((toProcess !== firstMiss)) {
                  var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
                  $n(currentLast).sci_$colon$colon__f_next = newElem;
                  currentLast = newElem;
                  toProcess = $as_sci_List($n(toProcess).tail__O());
                }
                var next = $as_sci_List($n(firstMiss).tail__O());
                var nextToCopy = next;
                while ((!$n(next).isEmpty__Z())) {
                  var head = $n(next).head__O();
                  if (($uZ(f$2(head)) !== false)) {
                    next = $as_sci_List($n(next).tail__O());
                  } else {
                    while ((nextToCopy !== next)) {
                      var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                      $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                      currentLast = newElem$2;
                      nextToCopy = $as_sci_List($n(nextToCopy).tail__O());
                    }
                    nextToCopy = $as_sci_List($n(next).tail__O());
                    next = $as_sci_List($n(next).tail__O());
                  }
                }
                if ((!$n(nextToCopy).isEmpty__Z())) {
                  $n(currentLast).sci_$colon$colon__f_next = nextToCopy;
                }
                var result = newHead;
                break block;
              }
            }
          }
        }
      }
      var this$6 = $n(result);
      var depth$tailLocal1$3$1 = depth$tailLocal1;
      var f$3 = ((this$2, depth$tailLocal1$3) => ((p) => {
        var p$1 = $as_Llaika_ast_Navigatable(p);
        return $p_Llaika_ast_TreeBuilder$__parent$1__Llaika_ast_Path__I__Llaika_ast_Path(this$2, $n(p$1).path__Llaika_ast_Path(), (((-1) + (($n($n(p$1).path__Llaika_ast_Path()).depth__I() - depth$tailLocal1$3) | 0)) | 0));
      }))(this$2, depth$tailLocal1$3$1);
      if ((this$6 === $m_sci_Nil$())) {
        var $x_4 = $m_sci_Nil$();
      } else {
        var arg1$3 = this$6.head__O();
        var h$2 = new $c_sci_$colon$colon(f$3(arg1$3), $m_sci_Nil$());
        var t$2 = h$2;
        var rest$1 = $as_sci_List(this$6.tail__O());
        while ((rest$1 !== $m_sci_Nil$())) {
          var arg1$4 = $n(rest$1).head__O();
          var nx$1 = new $c_sci_$colon$colon(f$3(arg1$4), $m_sci_Nil$());
          $n(t$2).sci_$colon$colon__f_next = nx$1;
          t$2 = nx$1;
          rest$1 = $as_sci_List($n(rest$1).tail__O());
        }
        var $x_4 = h$2;
      }
      var this$7 = $n($x_4);
      var this$8 = $n($as_sc_IterableOps($f_sc_SeqOps__distinct__O(this$7)));
      var m = $as_scm_Map($m_scm_Map$().empty__O());
      var it = this$8.iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        var elem = $n(it).next__O();
        var _$2 = $as_Llaika_ast_Path(elem);
        var key = $n(_$2).parent__Llaika_ast_Path();
        var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0(((this$8) => (() => this$8.newSpecificBuilder__scm_Builder()))(this$8))));
        var this$9 = $n(bldr);
        this$9.addOne__O__scm_Growable(elem);
      }
      var this$10 = $m_sci_HashMap$();
      var result$1 = this$10.sci_HashMap$__f_EmptyMap;
      var mapIt = $n(m).iterator__sc_Iterator();
      while ($n(mapIt).hasNext__Z()) {
        var x1 = $as_T2($n(mapIt).next__O());
        if ((x1 === null)) {
          throw new $c_s_MatchError(x1);
        }
        var k = $n(x1)._1__O();
        var v = $as_scm_Builder($n(x1)._2__O());
        result$1 = $n(result$1).updated__O__O__sci_HashMap(k, $n(v).result__O());
      }
      var this$11 = $n(result$1);
      var contentMap$tailLocal1$2 = contentMap$tailLocal1;
      var b = $m_sci_Iterable$().newBuilder__scm_Builder();
      var it$1 = this$11.iterator__sc_Iterator();
      while ($n(it$1).hasNext__Z()) {
        var this$12 = $n(b);
        var arg1$5 = $n(it$1).next__O();
        var x$1 = $as_T2(arg1$5);
        matchResult1: {
          var elem$1;
          if ((x$1 !== null)) {
            var parent = $as_Llaika_ast_Path($n(x$1)._1__O());
            var contentPaths = $as_sci_Seq($n(x$1)._2__O());
            var arg2$1 = $n(contentPaths).map__F1__O(contentMap$tailLocal1$2);
            var elem$1 = $as_Llaika_ast_Navigatable(f(parent, arg2$1));
            break matchResult1;
          }
          throw new $c_s_MatchError(x$1);
        }
        this$12.addOne__O__scm_Growable(elem$1);
      }
      var newNodes = $as_sci_Iterable($n(b).result__O());
      if ((depth$tailLocal1 !== 0)) {
        var depth$tailLocal1$tmp1 = (((-1) + depth$tailLocal1) | 0);
        var this$13 = $n(contentMap$tailLocal1);
        var xs = $p_Llaika_ast_TreeBuilder$__toMap$1__sc_Iterable__sci_Map(this$2, newNodes);
        var contentMap$tailLocal1$tmp1 = $as_sci_Map(this$13.concat__sc_IterableOnce__sc_IterableOps(xs));
        depth$tailLocal1 = depth$tailLocal1$tmp1;
        contentMap$tailLocal1 = contentMap$tailLocal1$tmp1;
        continue;
      }
      var $x_3 = $n(newNodes).toSeq__sci_Seq();
      break;
    }
    var $x_1 = $as_Llaika_ast_Navigatable($n($x_3).head__O());
  }
  var tree = $as_Llaika_ast_DocumentTreeBuilder$TreePart($x_1);
  return $p_Llaika_ast_DocumentTreeBuilder__buildTree__Llaika_ast_DocumentTreeBuilder$TreePart__Llaika_api_config_Config__T__s_Option__Llaika_ast_DocumentTree(this, tree, baseConfig, "README", $m_s_None$());
});
var $d_Llaika_ast_DocumentTreeBuilder = new $TypeData().initClass($c_Llaika_ast_DocumentTreeBuilder, "laika.ast.DocumentTreeBuilder", ({
  Llaika_ast_DocumentTreeBuilder: 1
}));
/** @constructor */
function $c_Llaika_ast_DocumentTreeRoot(tree, coverDocument, styles, staticDocuments, includes) {
  this.Llaika_ast_DocumentTreeRoot__f_tree = null;
  this.Llaika_ast_DocumentTreeRoot__f_coverDocument = null;
  this.Llaika_ast_DocumentTreeRoot__f_staticDocuments = null;
  this.Llaika_ast_DocumentTreeRoot__f_config = null;
  this.Llaika_ast_DocumentTreeRoot__f_title = null;
  this.Llaika_ast_DocumentTreeRoot__f_allDocuments$lzy2 = null;
  this.Llaika_ast_DocumentTreeRoot__f_allDocumentsbitmap$2 = false;
  this.Llaika_ast_DocumentTreeRoot__f_tree = tree;
  this.Llaika_ast_DocumentTreeRoot__f_coverDocument = coverDocument;
  this.Llaika_ast_DocumentTreeRoot__f_staticDocuments = staticDocuments;
  this.Llaika_ast_DocumentTreeRoot__f_config = $n(tree).config__Llaika_api_config_Config();
  this.Llaika_ast_DocumentTreeRoot__f_title = $n(tree).title__s_Option();
  $n(tree);
}
$c_Llaika_ast_DocumentTreeRoot.prototype = new $h_O();
$c_Llaika_ast_DocumentTreeRoot.prototype.constructor = $c_Llaika_ast_DocumentTreeRoot;
/** @constructor */
function $h_Llaika_ast_DocumentTreeRoot() {
}
$h_Llaika_ast_DocumentTreeRoot.prototype = $c_Llaika_ast_DocumentTreeRoot.prototype;
$c_Llaika_ast_DocumentTreeRoot.prototype.allDocuments__sci_Seq = (function() {
  if ((!this.Llaika_ast_DocumentTreeRoot__f_allDocumentsbitmap$2)) {
    var this$1 = $n($n($m_s_Option$().option2Iterable__s_Option__sc_Iterable(this.Llaika_ast_DocumentTreeRoot__f_coverDocument)).toSeq__sci_Seq());
    var suffix = $n(this.Llaika_ast_DocumentTreeRoot__f_tree).allDocuments__sci_Seq();
    this.Llaika_ast_DocumentTreeRoot__f_allDocuments$lzy2 = $as_sci_Seq(this$1.appendedAll__sc_IterableOnce__O(suffix));
    this.Llaika_ast_DocumentTreeRoot__f_allDocumentsbitmap$2 = true;
  }
  return this.Llaika_ast_DocumentTreeRoot__f_allDocuments$lzy2;
});
$c_Llaika_ast_DocumentTreeRoot.prototype.selectTreeConfig__Llaika_ast_Path__Llaika_api_config_Config = (function(path) {
  var path$tailLocal1 = path;
  while (true) {
    var $x_1 = $n(this.Llaika_ast_DocumentTreeRoot__f_tree);
    var this$1 = $n(path$tailLocal1);
    var x181 = $n($x_1).selectSubtree__Llaika_ast_RelativePath__s_Option(this$1.relativeTo__Llaika_ast_Path__Llaika_ast_RelativePath($m_Llaika_ast_Path$Root$()));
    if ((x181 instanceof $c_s_Some)) {
      var tree = $as_Llaika_ast_DocumentTree($n($as_s_Some(x181)).s_Some__f_value);
      return $n(tree).config__Llaika_api_config_Config();
    }
    var x = $m_s_None$();
    if ((x === x181)) {
      var x$3 = path$tailLocal1;
      var x$4 = $m_Llaika_ast_Path$Root$();
      if (((x$3 !== null) && $n(x$3).equals__O__Z(x$4))) {
        return this.Llaika_ast_DocumentTreeRoot__f_config;
      }
      path$tailLocal1 = $n(path$tailLocal1).parent__Llaika_ast_Path();
      continue;
    }
    throw new $c_s_MatchError(x181);
  }
});
var $d_Llaika_ast_DocumentTreeRoot = new $TypeData().initClass($c_Llaika_ast_DocumentTreeRoot, "laika.ast.DocumentTreeRoot", ({
  Llaika_ast_DocumentTreeRoot: 1
}));
/** @constructor */
function $c_Llaika_ast_DocumentTreeRoot$() {
}
$c_Llaika_ast_DocumentTreeRoot$.prototype = new $h_O();
$c_Llaika_ast_DocumentTreeRoot$.prototype.constructor = $c_Llaika_ast_DocumentTreeRoot$;
/** @constructor */
function $h_Llaika_ast_DocumentTreeRoot$() {
}
$h_Llaika_ast_DocumentTreeRoot$.prototype = $c_Llaika_ast_DocumentTreeRoot$.prototype;
$c_Llaika_ast_DocumentTreeRoot$.prototype.apply__Llaika_ast_DocumentTree__Llaika_ast_DocumentTreeRoot = (function(tree) {
  var $x_1 = $m_s_None$();
  var this$2 = $m_sci_Map$EmptyMap$();
  var d = $m_Llaika_ast_styles_StyleDeclarationSet$().Llaika_ast_styles_StyleDeclarationSet$__f_empty;
  return new $c_Llaika_ast_DocumentTreeRoot(tree, $x_1, $f_sci_Map__withDefaultValue__O__sci_Map(this$2, d), $m_sci_Nil$(), $m_sci_Map$EmptyMap$());
});
var $d_Llaika_ast_DocumentTreeRoot$ = new $TypeData().initClass($c_Llaika_ast_DocumentTreeRoot$, "laika.ast.DocumentTreeRoot$", ({
  Llaika_ast_DocumentTreeRoot$: 1
}));
var $n_Llaika_ast_DocumentTreeRoot$;
function $m_Llaika_ast_DocumentTreeRoot$() {
  if ((!$n_Llaika_ast_DocumentTreeRoot$)) {
    $n_Llaika_ast_DocumentTreeRoot$ = new $c_Llaika_ast_DocumentTreeRoot$();
  }
  return $n_Llaika_ast_DocumentTreeRoot$;
}
function $f_Llaika_ast_ElementTraversal__select__F1__sci_List($thiz, p) {
  var buffer = new $c_scm_ListBuffer();
  var f = new $c_sjsr_AnonFunction1(((e) => {
    var e$1 = $as_Llaika_ast_Element(e);
    if ($uZ($n(p).apply__O__O(e$1))) {
      buffer.addOne__O__scm_ListBuffer(e$1);
    }
  }));
  $ps_Llaika_ast_ElementTraversal__foreachInElement$1__Llaika_ast_Element__F1__V($as_Llaika_ast_Element($thiz), f);
  return buffer.toList__sci_List();
}
function $f_Llaika_ast_ElementTraversal__collect__s_PartialFunction__sci_List($thiz, pf) {
  var buffer = new $c_scm_ListBuffer();
  var f = new $c_sjsr_AnonFunction1(((e) => {
    var e$1 = $as_Llaika_ast_Element(e);
    if ($n(pf).isDefinedAt__O__Z(e$1)) {
      var elem = $n(pf).apply__O__O(e$1);
      buffer.addOne__O__scm_ListBuffer(elem);
    }
  }));
  $ps_Llaika_ast_ElementTraversal__foreachInElement$1__Llaika_ast_Element__F1__V($as_Llaika_ast_Element($thiz), f);
  return buffer.toList__sci_List();
}
function $ps_Llaika_ast_ElementTraversal__foreachInElement$1__Llaika_ast_Element__F1__V(element, f) {
  var this$1 = $n(element);
  var this$2 = new $c_s_Product$$anon$1(this$1);
  $ps_Llaika_ast_ElementTraversal__foreachInIterable$1__sc_Iterable__F1__V($m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$2), f);
  $n(f).apply__O__O(element);
}
function $ps_Llaika_ast_ElementTraversal__foreachInIterable$1__sc_Iterable__F1__V(t, f) {
  $n(t).foreach__F1__V(new $c_sjsr_AnonFunction1(((x$1) => {
    if ((x$1 instanceof $c_Llaika_ast_Element)) {
      var e = $as_Llaika_ast_Element(x$1);
      $ps_Llaika_ast_ElementTraversal__foreachInElement$1__Llaika_ast_Element__F1__V(e, f);
    } else if ($is_sc_Iterable(x$1)) {
      var t$1 = $as_sc_Iterable(x$1);
      $ps_Llaika_ast_ElementTraversal__foreachInIterable$1__sc_Iterable__F1__V(t$1, f);
    }
  })));
}
/** @constructor */
function $c_Llaika_ast_EnumType() {
}
$c_Llaika_ast_EnumType.prototype = new $h_O();
$c_Llaika_ast_EnumType.prototype.constructor = $c_Llaika_ast_EnumType;
/** @constructor */
function $h_Llaika_ast_EnumType() {
}
$h_Llaika_ast_EnumType.prototype = $c_Llaika_ast_EnumType.prototype;
function $is_Llaika_ast_Fallback(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_Fallback)));
}
function $as_Llaika_ast_Fallback(obj) {
  return (($is_Llaika_ast_Fallback(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Fallback"));
}
function $isArrayOf_Llaika_ast_Fallback(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Fallback)));
}
function $asArrayOf_Llaika_ast_Fallback(obj, depth) {
  return (($isArrayOf_Llaika_ast_Fallback(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Fallback;", depth));
}
function $p_Llaika_ast_FormattedElementString$__renderer__Llaika_api_Renderer($thiz) {
  if ((!$thiz.Llaika_ast_FormattedElementString$__f_rendererbitmap$1)) {
    var format = $m_Llaika_format_AST$();
    var this$2 = new $c_Llaika_api_builder_RendererBuilder(format, $m_Llaika_api_builder_OperationConfig$().Llaika_api_builder_OperationConfig$__f_default, false);
    var this$3 = new $c_Llaika_api_builder_RendererBuilder$$anon$1(this$2);
    $thiz.Llaika_ast_FormattedElementString$__f_renderer$lzy1 = new $c_Llaika_api_Renderer$$anon$1(this$3);
    $thiz.Llaika_ast_FormattedElementString$__f_rendererbitmap$1 = true;
  }
  return $thiz.Llaika_ast_FormattedElementString$__f_renderer$lzy1;
}
/** @constructor */
function $c_Llaika_ast_FormattedElementString$() {
  this.Llaika_ast_FormattedElementString$__f_renderer$lzy1 = null;
  this.Llaika_ast_FormattedElementString$__f_rendererbitmap$1 = false;
}
$c_Llaika_ast_FormattedElementString$.prototype = new $h_O();
$c_Llaika_ast_FormattedElementString$.prototype.constructor = $c_Llaika_ast_FormattedElementString$;
/** @constructor */
function $h_Llaika_ast_FormattedElementString$() {
}
$h_Llaika_ast_FormattedElementString$.prototype = $c_Llaika_ast_FormattedElementString$.prototype;
$c_Llaika_ast_FormattedElementString$.prototype.render__Llaika_ast_Element__T = (function(elem) {
  return (("\n" + $n($p_Llaika_ast_FormattedElementString$__renderer__Llaika_api_Renderer(this)).render__Llaika_ast_Element__s_util_Either(elem)) + "\n");
});
var $d_Llaika_ast_FormattedElementString$ = new $TypeData().initClass($c_Llaika_ast_FormattedElementString$, "laika.ast.FormattedElementString$", ({
  Llaika_ast_FormattedElementString$: 1
}));
var $n_Llaika_ast_FormattedElementString$;
function $m_Llaika_ast_FormattedElementString$() {
  if ((!$n_Llaika_ast_FormattedElementString$)) {
    $n_Llaika_ast_FormattedElementString$ = new $c_Llaika_ast_FormattedElementString$();
  }
  return $n_Llaika_ast_FormattedElementString$;
}
function $f_Llaika_ast_GenericPath__withSuffix__T__Llaika_ast_GenericPath($thiz, suffix) {
  var suffix$1 = new $c_s_Some(suffix);
  var basename$1 = $thiz.copyWith$default$1__T();
  var fragment$1 = $thiz.copyWith$default$3__s_Option();
  return $thiz.copyWith__T__s_Option__s_Option__Llaika_ast_GenericPath(basename$1, suffix$1, fragment$1);
}
function $f_Llaika_ast_GenericPath__withFragment__T__Llaika_ast_GenericPath($thiz, fragment) {
  var fragment$2 = new $c_s_Some(fragment);
  var basename$2 = $thiz.copyWith$default$1__T();
  var suffix$2 = $thiz.copyWith$default$2__s_Option();
  return $thiz.copyWith__T__s_Option__s_Option__Llaika_ast_GenericPath(basename$2, suffix$2, fragment$2);
}
function $f_Llaika_ast_GenericPath__withoutSuffix__Llaika_ast_GenericPath($thiz) {
  var suffix$3 = $m_s_None$();
  var basename$3 = $thiz.copyWith$default$1__T();
  var fragment$3 = $thiz.copyWith$default$3__s_Option();
  return $thiz.copyWith__T__s_Option__s_Option__Llaika_ast_GenericPath(basename$3, suffix$3, fragment$3);
}
function $f_Llaika_ast_GenericPath__withoutFragment__Llaika_ast_GenericPath($thiz) {
  var fragment$4 = $m_s_None$();
  var basename$4 = $thiz.copyWith$default$1__T();
  var suffix$4 = $thiz.copyWith$default$2__s_Option();
  return $thiz.copyWith__T__s_Option__s_Option__Llaika_ast_GenericPath(basename$4, suffix$4, fragment$4);
}
function $f_Llaika_ast_GenericPath__$div__T__Llaika_ast_GenericPath($thiz, name) {
  return $thiz.$div__Llaika_ast_RelativePath__Llaika_ast_GenericPath($m_Llaika_ast_RelativePath$().parse__T__Llaika_ast_RelativePath(name));
}
function $is_Llaika_ast_Hidden(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_Hidden)));
}
function $as_Llaika_ast_Hidden(obj) {
  return (($is_Llaika_ast_Hidden(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Hidden"));
}
function $isArrayOf_Llaika_ast_Hidden(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Hidden)));
}
function $asArrayOf_Llaika_ast_Hidden(obj, depth) {
  return (($isArrayOf_Llaika_ast_Hidden(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Hidden;", depth));
}
/** @constructor */
function $c_Llaika_ast_Id$() {
}
$c_Llaika_ast_Id$.prototype = new $h_O();
$c_Llaika_ast_Id$.prototype.constructor = $c_Llaika_ast_Id$;
/** @constructor */
function $h_Llaika_ast_Id$() {
}
$h_Llaika_ast_Id$.prototype = $c_Llaika_ast_Id$.prototype;
$c_Llaika_ast_Id$.prototype.apply__T__Llaika_ast_Options = (function(value) {
  return $m_Llaika_ast_Options$().apply__s_Option__sci_Set__Llaika_ast_Options(new $c_s_Some(value), $m_Llaika_ast_Options$().apply$default$2__sci_Set());
});
var $d_Llaika_ast_Id$ = new $TypeData().initClass($c_Llaika_ast_Id$, "laika.ast.Id$", ({
  Llaika_ast_Id$: 1
}));
var $n_Llaika_ast_Id$;
function $m_Llaika_ast_Id$() {
  if ((!$n_Llaika_ast_Id$)) {
    $n_Llaika_ast_Id$ = new $c_Llaika_ast_Id$();
  }
  return $n_Llaika_ast_Id$;
}
function $is_Llaika_ast_ListItem(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_ListItem)));
}
function $as_Llaika_ast_ListItem(obj) {
  return (($is_Llaika_ast_ListItem(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.ListItem"));
}
function $isArrayOf_Llaika_ast_ListItem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_ListItem)));
}
function $asArrayOf_Llaika_ast_ListItem(obj, depth) {
  return (($isArrayOf_Llaika_ast_ListItem(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.ListItem;", depth));
}
function $is_Llaika_ast_Navigatable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_Navigatable)));
}
function $as_Llaika_ast_Navigatable(obj) {
  return (($is_Llaika_ast_Navigatable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Navigatable"));
}
function $isArrayOf_Llaika_ast_Navigatable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Navigatable)));
}
function $asArrayOf_Llaika_ast_Navigatable(obj, depth) {
  return (($isArrayOf_Llaika_ast_Navigatable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Navigatable;", depth));
}
function $ct_Llaika_ast_NavigationBuilderContext__($thiz) {
  $thiz.Llaika_ast_NavigationBuilderContext__f_isComplete = ($thiz.Llaika_ast_NavigationBuilderContext$Impl__f_currentLevel >= $thiz.Llaika_ast_NavigationBuilderContext$Impl__f_maxLevels);
  return $thiz;
}
function $p_Llaika_ast_NavigationBuilderContext__createNavigationItem__Llaika_ast_SpanSequence__s_Option__sci_Seq__Llaika_config_TargetFormats__Llaika_ast_NavigationItem($thiz, title, target, children, targetFormats) {
  var $x_1 = $n($m_Llaika_ast_Style$().level__I__Llaika_ast_Options($thiz.Llaika_ast_NavigationBuilderContext$Impl__f_currentLevel));
  var values = $thiz.Llaika_ast_NavigationBuilderContext$Impl__f_itemStyles;
  var styles = $n($x_1).$plus__Llaika_ast_Options__Llaika_ast_Options($m_Llaika_ast_Options$().apply__s_Option__sci_Set__Llaika_ast_Options(($m_Llaika_ast_Options$(), $m_s_None$()), values));
  var this$3 = $n(target);
  if (this$3.isEmpty__Z()) {
    var link = $m_s_None$();
  } else {
    var arg1 = this$3.get__O();
    var x$1 = $as_T2(arg1);
    matchResult1: {
      var $x_2;
      if ((x$1 !== null)) {
        var path = $as_Llaika_ast_Path($n(x$1)._1__O());
        var formats = $as_Llaika_config_TargetFormats($n(x$1)._2__O());
        var target$1 = $n($m_Llaika_ast_InternalTarget$().apply__Llaika_ast_VirtualPath__Llaika_ast_InternalTarget(path)).relativeTo__Llaika_ast_Path__Llaika_ast_InternalTarget$Resolved($thiz.Llaika_ast_NavigationBuilderContext$Impl__f_refPath);
        var x$2 = $thiz.Llaika_ast_NavigationBuilderContext$Impl__f_refPath;
        var selfLink = ((path === null) ? (x$2 === null) : $n(path).equals__O__Z(x$2));
        var $x_2 = new $c_Llaika_ast_NavigationLink(target$1, selfLink, formats);
        break matchResult1;
      }
      throw new $c_s_MatchError(x$1);
    }
    var link = new $c_s_Some($x_2);
  }
  return new $c_Llaika_ast_NavigationItem(title, children, link, targetFormats, styles);
}
/** @constructor */
function $c_Llaika_ast_NavigationBuilderContext() {
  this.Llaika_ast_NavigationBuilderContext__f_isComplete = false;
}
$c_Llaika_ast_NavigationBuilderContext.prototype = new $h_O();
$c_Llaika_ast_NavigationBuilderContext.prototype.constructor = $c_Llaika_ast_NavigationBuilderContext;
/** @constructor */
function $h_Llaika_ast_NavigationBuilderContext() {
}
$h_Llaika_ast_NavigationBuilderContext.prototype = $c_Llaika_ast_NavigationBuilderContext.prototype;
$c_Llaika_ast_NavigationBuilderContext.prototype.newNavigationItem__Llaika_ast_SpanSequence__s_Option__sci_Seq__Llaika_config_TargetFormats__Llaika_ast_NavigationItem = (function(title, target, children, targetFormats) {
  var this$1 = $n(target);
  if (this$1.isEmpty__Z()) {
    var $x_1 = $m_s_None$();
  } else {
    var arg1 = this$1.get__O();
    var doc = $as_Llaika_ast_DocumentNavigation(arg1);
    var _1 = $n(doc).path__Llaika_ast_Path();
    var this$2 = $n(doc);
    var _2 = $f_Llaika_ast_TreeContent__targetFormats__Llaika_config_TargetFormats(this$2);
    var $x_1 = new $c_s_Some(new $c_T2(_1, _2));
  }
  return $p_Llaika_ast_NavigationBuilderContext__createNavigationItem__Llaika_ast_SpanSequence__s_Option__sci_Seq__Llaika_config_TargetFormats__Llaika_ast_NavigationItem(this, title, $x_1, children, targetFormats);
});
$c_Llaika_ast_NavigationBuilderContext.prototype.newNavigationItem__Llaika_ast_SpanSequence__Llaika_ast_Path__sci_Seq__Llaika_config_TargetFormats__Llaika_ast_NavigationItem = (function(title, target, children, targetFormats) {
  var _2 = $m_Llaika_config_TargetFormats$All$();
  var value = new $c_T2(target, _2);
  return $p_Llaika_ast_NavigationBuilderContext__createNavigationItem__Llaika_ast_SpanSequence__s_Option__sci_Seq__Llaika_config_TargetFormats__Llaika_ast_NavigationItem(this, title, new $c_s_Some(value), children, targetFormats);
});
/** @constructor */
function $c_Llaika_ast_Options() {
}
$c_Llaika_ast_Options.prototype = new $h_O();
$c_Llaika_ast_Options.prototype.constructor = $c_Llaika_ast_Options;
/** @constructor */
function $h_Llaika_ast_Options() {
}
$h_Llaika_ast_Options.prototype = $c_Llaika_ast_Options.prototype;
function $as_Llaika_ast_Options(obj) {
  return (((obj instanceof $c_Llaika_ast_Options) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Options"));
}
function $isArrayOf_Llaika_ast_Options(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Options)));
}
function $asArrayOf_Llaika_ast_Options(obj, depth) {
  return (($isArrayOf_Llaika_ast_Options(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Options;", depth));
}
var $d_Llaika_ast_Options = new $TypeData().initClass(0, "laika.ast.Options", ({
  Llaika_ast_Options: 1
}));
/** @constructor */
function $c_Llaika_ast_OutputContext() {
}
$c_Llaika_ast_OutputContext.prototype = new $h_O();
$c_Llaika_ast_OutputContext.prototype.constructor = $c_Llaika_ast_OutputContext;
/** @constructor */
function $h_Llaika_ast_OutputContext() {
}
$h_Llaika_ast_OutputContext.prototype = $c_Llaika_ast_OutputContext.prototype;
function $as_Llaika_ast_OutputContext(obj) {
  return (((obj instanceof $c_Llaika_ast_OutputContext) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.OutputContext"));
}
function $isArrayOf_Llaika_ast_OutputContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_OutputContext)));
}
function $asArrayOf_Llaika_ast_OutputContext(obj, depth) {
  return (($isArrayOf_Llaika_ast_OutputContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.OutputContext;", depth));
}
/** @constructor */
function $c_Llaika_ast_ParsedTarget$() {
}
$c_Llaika_ast_ParsedTarget$.prototype = new $h_O();
$c_Llaika_ast_ParsedTarget$.prototype.constructor = $c_Llaika_ast_ParsedTarget$;
/** @constructor */
function $h_Llaika_ast_ParsedTarget$() {
}
$h_Llaika_ast_ParsedTarget$.prototype = $c_Llaika_ast_ParsedTarget$.prototype;
$c_Llaika_ast_ParsedTarget$.prototype.forLink__sci_Seq__T__Llaika_parse_SourceFragment__s_Option__Llaika_ast_Span = (function(linkText, url, source, title) {
  matchResult61: {
    var $x_1;
    var x91 = $m_Llaika_ast_Target$().parse__T__Llaika_ast_Target(url);
    if ((x91 instanceof $c_Llaika_ast_ExternalTarget)) {
      var et = $as_Llaika_ast_ExternalTarget(x91);
      var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      var $x_1 = new $c_Llaika_ast_SpanLink(linkText, et, title, options);
      break matchResult61;
    }
    if ($is_Llaika_ast_InternalTarget(x91)) {
      var it = $as_Llaika_ast_InternalTarget(x91);
      var this$3 = $n(it);
      var path = $f_Llaika_ast_InternalTarget__underlying__Llaika_ast_VirtualPath(this$3);
      var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      var $x_1 = new $c_Llaika_ast_LinkPathReference(linkText, path, source, title, options$1);
      break matchResult61;
    }
    throw new $c_s_MatchError(x91);
  }
  return $as_Llaika_ast_Span($x_1);
});
$c_Llaika_ast_ParsedTarget$.prototype.forImage__T__Llaika_parse_SourceFragment__s_Option__s_Option__s_Option__s_Option__Llaika_ast_Span = (function(url, source, width, height, alt, title) {
  var x94 = $m_Llaika_ast_Target$().parse__T__Llaika_ast_Target(url);
  if ((x94 instanceof $c_Llaika_ast_ExternalTarget)) {
    var et = $as_Llaika_ast_ExternalTarget(x94);
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    return new $c_Llaika_ast_Image(et, width, height, alt, title, options);
  }
  if ($is_Llaika_ast_InternalTarget(x94)) {
    var it = $as_Llaika_ast_InternalTarget(x94);
    var this$3 = $n(it);
    var path = $f_Llaika_ast_InternalTarget__underlying__Llaika_ast_VirtualPath(this$3);
    var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    return new $c_Llaika_ast_ImagePathReference(path, source, width, height, alt, title, options$1);
  }
  throw new $c_s_MatchError(x94);
});
var $d_Llaika_ast_ParsedTarget$ = new $TypeData().initClass($c_Llaika_ast_ParsedTarget$, "laika.ast.ParsedTarget$", ({
  Llaika_ast_ParsedTarget$: 1
}));
var $n_Llaika_ast_ParsedTarget$;
function $m_Llaika_ast_ParsedTarget$() {
  if ((!$n_Llaika_ast_ParsedTarget$)) {
    $n_Llaika_ast_ParsedTarget$ = new $c_Llaika_ast_ParsedTarget$();
  }
  return $n_Llaika_ast_ParsedTarget$;
}
function $is_Llaika_ast_RewritableContainer(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_RewritableContainer)));
}
function $as_Llaika_ast_RewritableContainer(obj) {
  return (($is_Llaika_ast_RewritableContainer(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.RewritableContainer"));
}
function $isArrayOf_Llaika_ast_RewritableContainer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_RewritableContainer)));
}
function $asArrayOf_Llaika_ast_RewritableContainer(obj, depth) {
  return (($isArrayOf_Llaika_ast_RewritableContainer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.RewritableContainer;", depth));
}
function $is_Llaika_ast_RewriteAction(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_RewriteAction)));
}
function $as_Llaika_ast_RewriteAction(obj) {
  return (($is_Llaika_ast_RewriteAction(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.RewriteAction"));
}
function $isArrayOf_Llaika_ast_RewriteAction(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_RewriteAction)));
}
function $asArrayOf_Llaika_ast_RewriteAction(obj, depth) {
  return (($isArrayOf_Llaika_ast_RewriteAction(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.RewriteAction;", depth));
}
function $is_Llaika_ast_RewritePhase(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_RewritePhase)));
}
function $as_Llaika_ast_RewritePhase(obj) {
  return (($is_Llaika_ast_RewritePhase(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.RewritePhase"));
}
function $isArrayOf_Llaika_ast_RewritePhase(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_RewritePhase)));
}
function $asArrayOf_Llaika_ast_RewritePhase(obj, depth) {
  return (($isArrayOf_Llaika_ast_RewritePhase(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.RewritePhase;", depth));
}
function $p_Llaika_ast_RewriteRules__chainedSpanRules__F1($thiz) {
  if ((!$thiz.Llaika_ast_RewriteRules__f_chainedSpanRulesbitmap$1)) {
    $thiz.Llaika_ast_RewriteRules__f_chainedSpanRules$lzy1 = new $c_Llaika_ast_RewriteRules$ChainedRewriteRules($thiz.Llaika_ast_RewriteRules__f_spanRules);
    $thiz.Llaika_ast_RewriteRules__f_chainedSpanRulesbitmap$1 = true;
  }
  return $thiz.Llaika_ast_RewriteRules__f_chainedSpanRules$lzy1;
}
function $p_Llaika_ast_RewriteRules__chainedBlockRules__F1($thiz) {
  if ((!$thiz.Llaika_ast_RewriteRules__f_chainedBlockRulesbitmap$1)) {
    $thiz.Llaika_ast_RewriteRules__f_chainedBlockRules$lzy1 = new $c_Llaika_ast_RewriteRules$ChainedRewriteRules($thiz.Llaika_ast_RewriteRules__f_blockRules);
    $thiz.Llaika_ast_RewriteRules__f_chainedBlockRulesbitmap$1 = true;
  }
  return $thiz.Llaika_ast_RewriteRules__f_chainedBlockRules$lzy1;
}
function $p_Llaika_ast_RewriteRules__chainedTemplateRules__F1($thiz) {
  if ((!$thiz.Llaika_ast_RewriteRules__f_chainedTemplateRulesbitmap$1)) {
    $thiz.Llaika_ast_RewriteRules__f_chainedTemplateRules$lzy1 = new $c_Llaika_ast_RewriteRules$ChainedRewriteRules($thiz.Llaika_ast_RewriteRules__f_templateRules);
    $thiz.Llaika_ast_RewriteRules__f_chainedTemplateRulesbitmap$1 = true;
  }
  return $thiz.Llaika_ast_RewriteRules__f_chainedTemplateRules$lzy1;
}
function $p_Llaika_ast_RewriteRules__rewrite__F1__sci_Seq__sci_Seq($thiz, childRules, children) {
  return $as_sci_Seq($n(children).flatMap__F1__O(new $c_sjsr_AnonFunction1(((x$1) => {
    if ($is_Llaika_ast_RewritableContainer(x$1)) {
      var rw = $as_Llaika_ast_RewritableContainer(x$1);
      var rewritten = $n(rw).rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer($thiz);
      var action = $as_Llaika_ast_RewriteAction($n(childRules).apply__O__O(rewritten));
      return $ps_Llaika_ast_RewriteRules__newChild$1__O__Llaika_ast_RewriteAction__s_Option(rewritten, action);
    } else {
      return $ps_Llaika_ast_RewriteRules__newChild$1__O__Llaika_ast_RewriteAction__s_Option(x$1, $as_Llaika_ast_RewriteAction($n(childRules).apply__O__O(x$1)));
    }
  }))));
}
function $ps_Llaika_ast_RewriteRules__newChild$1__O__Llaika_ast_RewriteAction__s_Option(oldChild, action) {
  var x = $m_Llaika_ast_RewriteAction$Retain$();
  if ((x === action)) {
    return new $c_s_Some(oldChild);
  }
  var x$3 = $m_Llaika_ast_RewriteAction$Remove$();
  if ((x$3 === action)) {
    return $m_s_None$();
  }
  if ((action instanceof $c_Llaika_ast_RewriteAction$Replace)) {
    var x$1 = $as_Llaika_ast_RewriteAction$Replace(action);
    var this$3 = $n(x$1);
    var x9 = this$3.Llaika_ast_RewriteAction$Replace__f_newValue;
    return new $c_s_Some(x9);
  }
  throw new $c_s_MatchError(action);
}
/** @constructor */
function $c_Llaika_ast_RewriteRules(spanRules, blockRules, templateRules) {
  this.Llaika_ast_RewriteRules__f_spanRules = null;
  this.Llaika_ast_RewriteRules__f_blockRules = null;
  this.Llaika_ast_RewriteRules__f_templateRules = null;
  this.Llaika_ast_RewriteRules__f_chainedSpanRules$lzy1 = null;
  this.Llaika_ast_RewriteRules__f_chainedSpanRulesbitmap$1 = false;
  this.Llaika_ast_RewriteRules__f_chainedBlockRules$lzy1 = null;
  this.Llaika_ast_RewriteRules__f_chainedBlockRulesbitmap$1 = false;
  this.Llaika_ast_RewriteRules__f_chainedTemplateRules$lzy1 = null;
  this.Llaika_ast_RewriteRules__f_chainedTemplateRulesbitmap$1 = false;
  this.Llaika_ast_RewriteRules__f_spanRules = spanRules;
  this.Llaika_ast_RewriteRules__f_blockRules = blockRules;
  this.Llaika_ast_RewriteRules__f_templateRules = templateRules;
}
$c_Llaika_ast_RewriteRules.prototype = new $h_O();
$c_Llaika_ast_RewriteRules.prototype.constructor = $c_Llaika_ast_RewriteRules;
/** @constructor */
function $h_Llaika_ast_RewriteRules() {
}
$h_Llaika_ast_RewriteRules.prototype = $c_Llaika_ast_RewriteRules.prototype;
$c_Llaika_ast_RewriteRules.prototype.$plus$plus__Llaika_ast_RewriteRules__Llaika_ast_RewriteRules = (function(other) {
  var this$1 = $n(this.Llaika_ast_RewriteRules__f_spanRules);
  var suffix = $n(other).Llaika_ast_RewriteRules__f_spanRules;
  var $x_2 = $as_sci_Seq(this$1.appendedAll__sc_IterableOnce__O(suffix));
  var this$2 = $n(this.Llaika_ast_RewriteRules__f_blockRules);
  var suffix$1 = $n(other).Llaika_ast_RewriteRules__f_blockRules;
  var $x_1 = $as_sci_Seq(this$2.appendedAll__sc_IterableOnce__O(suffix$1));
  var this$3 = $n(this.Llaika_ast_RewriteRules__f_templateRules);
  var suffix$2 = $n(other).Llaika_ast_RewriteRules__f_templateRules;
  return new $c_Llaika_ast_RewriteRules($x_2, $x_1, $as_sci_Seq(this$3.appendedAll__sc_IterableOnce__O(suffix$2)));
});
$c_Llaika_ast_RewriteRules.prototype.rewriteElement__Llaika_ast_Element__Llaika_ast_Element = (function(element) {
  if ($is_Llaika_ast_Block(element)) {
    var b = $as_Llaika_ast_Block(element);
    return $as_Llaika_ast_Element(this.rewriteBlock__Llaika_ast_Block__Llaika_ast_Block(b));
  } else if ($is_Llaika_ast_TemplateSpan(element)) {
    var t = $as_Llaika_ast_TemplateSpan(element);
    return $as_Llaika_ast_Element(this.rewriteTemplateSpan__Llaika_ast_TemplateSpan__Llaika_ast_TemplateSpan(t));
  } else if ($is_Llaika_ast_Span(element)) {
    var s = $as_Llaika_ast_Span(element);
    return $as_Llaika_ast_Element(this.rewriteSpan__Llaika_ast_Span__Llaika_ast_Span(s));
  } else if ($is_Llaika_ast_RewritableContainer(element)) {
    var r = $as_Llaika_ast_RewritableContainer(element);
    return $as_Llaika_ast_Element($n(r).rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer(this));
  } else {
    return element;
  }
});
$c_Llaika_ast_RewriteRules.prototype.rewriteSpan__Llaika_ast_Span__Llaika_ast_Span = (function(span) {
  var spans = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Span.getArrayOf().constr)([span]))));
  var this$1 = $n($n($p_Llaika_ast_RewriteRules__rewrite__F1__sci_Seq__sci_Seq(this, $p_Llaika_ast_RewriteRules__chainedSpanRules__F1(this), spans)).headOption__s_Option());
  if (this$1.isEmpty__Z()) {
    var spans$1 = $m_sci_Nil$();
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var $x_1 = new $c_Llaika_ast_SpanSequence(spans$1, options);
  } else {
    var $x_1 = this$1.get__O();
  }
  return $as_Llaika_ast_Span($x_1);
});
$c_Llaika_ast_RewriteRules.prototype.rewriteBlock__Llaika_ast_Block__Llaika_ast_Block = (function(block) {
  var blocks = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Block.getArrayOf().constr)([block]))));
  var this$1 = $n($n($p_Llaika_ast_RewriteRules__rewrite__F1__sci_Seq__sci_Seq(this, $p_Llaika_ast_RewriteRules__chainedBlockRules__F1(this), blocks)).headOption__s_Option());
  if (this$1.isEmpty__Z()) {
    var blocks$1 = $m_sci_Nil$();
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var $x_1 = new $c_Llaika_ast_BlockSequence(blocks$1, options);
  } else {
    var $x_1 = this$1.get__O();
  }
  return $as_Llaika_ast_Block($x_1);
});
$c_Llaika_ast_RewriteRules.prototype.rewriteTemplateSpan__Llaika_ast_TemplateSpan__Llaika_ast_TemplateSpan = (function(span) {
  var spans = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_TemplateSpan.getArrayOf().constr)([span]))));
  var this$1 = $n($n($p_Llaika_ast_RewriteRules__rewrite__F1__sci_Seq__sci_Seq(this, $p_Llaika_ast_RewriteRules__chainedTemplateRules__F1(this), spans)).headOption__s_Option());
  if (this$1.isEmpty__Z()) {
    var spans$1 = $m_sci_Nil$();
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var $x_1 = new $c_Llaika_ast_TemplateSpanSequence(spans$1, options);
  } else {
    var $x_1 = this$1.get__O();
  }
  return $as_Llaika_ast_TemplateSpan($x_1);
});
$c_Llaika_ast_RewriteRules.prototype.asBuilder__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((_$1) => {
    $as_Llaika_ast_DocumentCursor(_$1);
    return new $c_s_util_Right(this);
  }));
});
function $as_Llaika_ast_RewriteRules(obj) {
  return (((obj instanceof $c_Llaika_ast_RewriteRules) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.RewriteRules"));
}
function $isArrayOf_Llaika_ast_RewriteRules(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_RewriteRules)));
}
function $asArrayOf_Llaika_ast_RewriteRules(obj, depth) {
  return (($isArrayOf_Llaika_ast_RewriteRules(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.RewriteRules;", depth));
}
var $d_Llaika_ast_RewriteRules = new $TypeData().initClass($c_Llaika_ast_RewriteRules, "laika.ast.RewriteRules", ({
  Llaika_ast_RewriteRules: 1
}));
/** @constructor */
function $c_Llaika_ast_RewriteRules$() {
}
$c_Llaika_ast_RewriteRules$.prototype = new $h_O();
$c_Llaika_ast_RewriteRules$.prototype.constructor = $c_Llaika_ast_RewriteRules$;
/** @constructor */
function $h_Llaika_ast_RewriteRules$() {
}
$h_Llaika_ast_RewriteRules$.prototype = $c_Llaika_ast_RewriteRules$.prototype;
$c_Llaika_ast_RewriteRules$.prototype.forSpans__s_PartialFunction__Llaika_ast_RewriteRules = (function(rule) {
  return new $c_Llaika_ast_RewriteRules($as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_s_PartialFunction.getArrayOf().constr)([rule])))), $m_sci_Nil$(), $m_sci_Nil$());
});
$c_Llaika_ast_RewriteRules$.prototype.forBlocks__s_PartialFunction__Llaika_ast_RewriteRules = (function(rule) {
  var blockRules$1 = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_s_PartialFunction.getArrayOf().constr)([rule]))));
  var spanRules$1 = $m_sci_Nil$();
  var templateRules$1 = $m_sci_Nil$();
  return new $c_Llaika_ast_RewriteRules(spanRules$1, blockRules$1, templateRules$1);
});
$c_Llaika_ast_RewriteRules$.prototype.forTemplates__s_PartialFunction__Llaika_ast_RewriteRules = (function(rule) {
  var templateRules$2 = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_s_PartialFunction.getArrayOf().constr)([rule]))));
  var spanRules$2 = $m_sci_Nil$();
  var blockRules$2 = $m_sci_Nil$();
  return new $c_Llaika_ast_RewriteRules(spanRules$2, blockRules$2, templateRules$2);
});
$c_Llaika_ast_RewriteRules$.prototype.chainFactories__sci_Seq__F1 = (function(rules) {
  return new $c_sjsr_AnonFunction1(((cursor) => {
    var cursor$1 = $as_Llaika_ast_DocumentCursor(cursor);
    var this$3 = $n($n(rules).toList__sci_List());
    var f = ((_$3) => {
      var _$3$1 = $as_F1(_$3);
      var eab = $as_s_util_Either($n(_$3$1).apply__O__O(cursor$1));
      return $m_Lcats_syntax_EitherOps$().toEitherNec$extension__s_util_Either__s_util_Either(eab);
    });
    if ((this$3 === $m_sci_Nil$())) {
      var tma = $m_sci_Nil$();
    } else {
      var arg1 = this$3.head__O();
      var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(this$3.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var arg1$1 = $n(rest).head__O();
        var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O());
      }
      var tma = h;
    }
    $m_Lcats_UnorderedFoldable$();
    $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
    $m_Lcats_UnorderedFoldable$();
    var T = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
    $m_Lcats_data_NonEmptyChainImpl$();
    var ev = $m_Lcats_data_Chain$().Lcats_data_ChainInstances__f_theMonoid;
    $m_Lcats_instances_package$either$();
    var P = new $c_Lcats_instances_EitherInstances$$anon$5(ev);
    var this$12 = $n($as_s_util_Either($m_Lcats_Parallel$().parSequence__O__Lcats_Traverse__Lcats_Parallel__O(tma, T, P)));
    if ((this$12 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$12);
      var b = $n(x2).s_util_Right__f_value;
      var _$4 = $as_sci_List(b);
      var this$13 = $n(_$4);
      var f$1 = ((_$5, _$6) => {
        var _$5$1 = $as_Llaika_ast_RewriteRules(_$5);
        var _$6$1 = $as_Llaika_ast_RewriteRules(_$6);
        return $n(_$5$1).$plus$plus__Llaika_ast_RewriteRules__Llaika_ast_RewriteRules(_$6$1);
      });
      var x1 = this$13.knownSize__I();
      switch (x1) {
        case (-1): {
          var it = this$13.iterator__sc_Iterator();
          if ($n(it).hasNext__Z()) {
            var acc = $n(it).next__O();
            while ($n(it).hasNext__Z()) {
              var arg1$2 = acc;
              var arg2 = $n(it).next__O();
              acc = f$1(arg1$2, arg2);
            }
            var $x_1 = new $c_s_Some(acc);
          } else {
            var $x_1 = $m_s_None$();
          }
          break;
        }
        case 0: {
          var $x_1 = $m_s_None$();
          break;
        }
        default: {
          matchEnd4: {
            var $x_2;
            if ($is_sc_IndexedSeq(this$13)) {
              var x2$1 = $as_sc_IndexedSeq(this$13);
              if (($n(x2$1).length__I() > 0)) {
                var z = $n(x2$1).apply__I__O(0);
                var at = 1;
                var end = $n(x2$1).length__I();
                var acc$1 = z;
                while (true) {
                  if ((at === end)) {
                    var $x_2 = acc$1;
                    break matchEnd4;
                  } else {
                    var temp$at = ((1 + at) | 0);
                    var arg1$3 = acc$1;
                    var arg2$1 = $n(x2$1).apply__I__O(at);
                    var temp$acc = f$1(arg1$3, arg2$1);
                    at = temp$at;
                    acc$1 = temp$acc;
                  }
                }
              }
            }
            if ((this$13.knownSize__I() === 0)) {
              throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
            }
            var it$1 = this$13.iterator__sc_Iterator();
            if ($n(it$1).hasNext__Z()) {
              var acc$2 = $n(it$1).next__O();
              while ($n(it$1).hasNext__Z()) {
                var arg1$4 = acc$2;
                var arg2$2 = $n(it$1).next__O();
                acc$2 = f$1(arg1$4, arg2$2);
              }
              var $x_2 = acc$2;
            } else {
              throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
            }
          }
          var $x_1 = new $c_s_Some($x_2);
        }
      }
      var this$14 = $n($x_1);
      var eab$1 = new $c_s_util_Right($as_Llaika_ast_RewriteRules((this$14.isEmpty__Z() ? new $c_Llaika_ast_RewriteRules($m_sci_Nil$(), $m_sci_Nil$(), $m_sci_Nil$()) : this$14.get__O())));
    } else {
      var eab$1 = this$12;
    }
    if ((eab$1 instanceof $c_s_util_Left)) {
      var a = $n($as_s_util_Left(eab$1)).s_util_Left__f_value;
      var value = new $c_Llaika_api_config_ConfigError$MultipleErrors(a);
      return new $c_s_util_Left(value);
    }
    if ((eab$1 instanceof $c_s_util_Right)) {
      var r = $as_s_util_Right(eab$1);
      $m_Lcats_syntax_EitherUtil$();
      return r;
    }
    throw new $c_s_MatchError(eab$1);
  }));
});
$c_Llaika_ast_RewriteRules$.prototype.defaultsFor__Llaika_ast_DocumentTreeRoot__Llaika_ast_RewritePhase__F1__sci_Seq = (function(root, phase, slugBuilder) {
  var x = $m_Llaika_ast_RewritePhase$Build$();
  if ((x === phase)) {
    return $m_sci_Nil$();
  }
  var x$3 = $m_Llaika_ast_RewritePhase$Resolve$();
  if ((x$3 === phase)) {
    return $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_F1.getArrayOf().constr)([new $c_Llaika_internal_link_LinkResolver(root, slugBuilder), $m_Llaika_internal_nav_SectionBuilder$()]))));
  }
  if ((phase instanceof $c_Llaika_ast_RewritePhase$Render)) {
    var x$1 = $as_Llaika_ast_RewritePhase$Render(phase);
    var this$2 = $n(x$1);
    return $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_F1.getArrayOf().constr)([$m_Llaika_config_Selections$FormatFilter$(), $m_Llaika_ast_NavigationList$FormatFilter$(), $m_Llaika_internal_rewrite_TemplateFormatter$(), $m_Llaika_internal_rewrite_UnresolvedNodeDetector$()]))));
  }
  throw new $c_s_MatchError(phase);
});
var $d_Llaika_ast_RewriteRules$ = new $TypeData().initClass($c_Llaika_ast_RewriteRules$, "laika.ast.RewriteRules$", ({
  Llaika_ast_RewriteRules$: 1
}));
var $n_Llaika_ast_RewriteRules$;
function $m_Llaika_ast_RewriteRules$() {
  if ((!$n_Llaika_ast_RewriteRules$)) {
    $n_Llaika_ast_RewriteRules$ = new $c_Llaika_ast_RewriteRules$();
  }
  return $n_Llaika_ast_RewriteRules$;
}
/** @constructor */
function $c_Llaika_ast_RootCursor(target, renderContext) {
  this.Llaika_ast_RootCursor__f_target = null;
  this.Llaika_ast_RootCursor__f_targetLookup$lzy1 = null;
  this.Llaika_ast_RootCursor__f_targetLookupbitmap$1 = false;
  this.Llaika_ast_RootCursor__f_outputContext = null;
  this.Llaika_ast_RootCursor__f_config = null;
  this.Llaika_ast_RootCursor__f_target = target;
  var this$1 = $n(renderContext);
  if (this$1.isEmpty__Z()) {
    var $x_1 = $m_s_None$();
  } else {
    var arg1 = this$1.get__O();
    var _$1 = $as_T2(arg1);
    var $x_1 = new $c_s_Some($as_Llaika_ast_OutputContext($n(_$1)._1__O()));
  }
  this.Llaika_ast_RootCursor__f_outputContext = $x_1;
  this.Llaika_ast_RootCursor__f_config = $n(target).Llaika_ast_DocumentTreeRoot__f_config;
  $m_Llaika_ast_TreeCursor$().apply__Llaika_ast_RootCursor__Llaika_ast_TreeCursor(this);
}
$c_Llaika_ast_RootCursor.prototype = new $h_O();
$c_Llaika_ast_RootCursor.prototype.constructor = $c_Llaika_ast_RootCursor;
/** @constructor */
function $h_Llaika_ast_RootCursor() {
}
$h_Llaika_ast_RootCursor.prototype = $c_Llaika_ast_RootCursor.prototype;
$c_Llaika_ast_RootCursor.prototype.targetLookup__Llaika_internal_link_TargetLookup = (function() {
  if ((!this.Llaika_ast_RootCursor__f_targetLookupbitmap$1)) {
    this.Llaika_ast_RootCursor__f_targetLookup$lzy1 = new $c_Llaika_internal_link_TargetLookup(this);
    this.Llaika_ast_RootCursor__f_targetLookupbitmap$1 = true;
  }
  return this.Llaika_ast_RootCursor__f_targetLookup$lzy1;
});
function $as_Llaika_ast_RootCursor(obj) {
  return (((obj instanceof $c_Llaika_ast_RootCursor) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.RootCursor"));
}
function $isArrayOf_Llaika_ast_RootCursor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_RootCursor)));
}
function $asArrayOf_Llaika_ast_RootCursor(obj, depth) {
  return (($isArrayOf_Llaika_ast_RootCursor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.RootCursor;", depth));
}
var $d_Llaika_ast_RootCursor = new $TypeData().initClass($c_Llaika_ast_RootCursor, "laika.ast.RootCursor", ({
  Llaika_ast_RootCursor: 1
}));
function $p_Llaika_ast_RootCursor$__validate$1__Llaika_ast_Document__s_Option($thiz, doc) {
  var $x_3 = $m_sr_ScalaRunTime$();
  var this$1 = $n($n(doc).config__Llaika_api_config_Config());
  var key = $m_Llaika_config_LaikaKeys$().Llaika_config_LaikaKeys$__f_versioned;
  var decoder = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_boolean;
  var eab = $f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$1, key, decoder);
  var $x_2 = $m_Lcats_syntax_EitherOps$().toEitherNec$extension__s_util_Either__s_util_Either(eab);
  var this$3 = $n($n(doc).config__Llaika_api_config_Config());
  var key$1 = $m_Llaika_config_LaikaKeys$().Llaika_config_LaikaKeys$__f_title;
  var decoder$1 = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
  var eab$1 = $f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$3, key$1, decoder$1);
  var $x_1 = $m_Lcats_syntax_EitherOps$().toEitherNec$extension__s_util_Either__s_util_Either(eab$1);
  var this$5 = $n($n(doc).config__Llaika_api_config_Config());
  var decoder$2 = $m_Llaika_config_TargetFormats$().Llaika_config_TargetFormats$__f_decoder;
  var defaultKey = $m_Llaika_config_TargetFormats$().Llaika_config_TargetFormats$__f_defaultKey;
  var key$2 = $n(defaultKey).Llaika_api_config_DefaultKey$$anon$1__f_value;
  var eab$2 = $f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$5, key$2, decoder$2);
  var elems = $n($x_3).wrapRefArray__AO__sci_ArraySeq(new ($d_s_util_Either.getArrayOf().constr)([$x_2, $x_1, $m_Lcats_syntax_EitherOps$().toEitherNec$extension__s_util_Either__s_util_Either(eab$2)]));
  var tma = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  $m_Lcats_UnorderedFoldable$();
  $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
  $m_Lcats_UnorderedFoldable$();
  var T = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
  $m_Lcats_data_NonEmptyChainImpl$();
  var ev = $m_Lcats_data_Chain$().Lcats_data_ChainInstances__f_theMonoid;
  $m_Lcats_instances_package$either$();
  var P = new $c_Lcats_instances_EitherInstances$$anon$5(ev);
  var this$16 = $n($as_s_util_Either($m_Lcats_Parallel$().parSequence__O__Lcats_Traverse__Lcats_Parallel__O(tma, T, P)));
  var this$17 = $n(new $c_s_util_Either$LeftProjection(this$16).toOption__s_Option());
  if (this$17.isEmpty__Z()) {
    return $m_s_None$();
  } else {
    var arg1 = this$17.get__O();
    var path = $n(doc).path__Llaika_ast_Path();
    return new $c_s_Some(new $c_Llaika_api_config_ConfigError$DocumentErrors(path, arg1));
  }
}
function $p_Llaika_ast_RootCursor$__validateRoot$1__Llaika_ast_DocumentTreeRoot__sci_Seq($thiz, target$1) {
  var $x_3 = $m_sr_ScalaRunTime$();
  var this$1 = $n($n(target$1).Llaika_ast_DocumentTreeRoot__f_config);
  var key = $m_Llaika_config_LaikaKeys$().Llaika_config_LaikaKeys$__f_siteBaseURL;
  var decoder = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
  var eab = $f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$1, key, decoder);
  var $x_2 = $m_Lcats_syntax_EitherOps$().toEitherNec$extension__s_util_Either__s_util_Either(eab);
  var this$3 = $n($n(target$1).Llaika_ast_DocumentTreeRoot__f_config);
  var decoder$1 = $m_Llaika_config_LinkConfig$().Llaika_config_LinkConfig$__f_decoder;
  var defaultKey = $m_Llaika_config_LinkConfig$().Llaika_config_LinkConfig$__f_key;
  var key$1 = $n(defaultKey).Llaika_api_config_DefaultKey$$anon$1__f_value;
  var eab$1 = $f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$3, key$1, decoder$1);
  var $x_1 = $m_Lcats_syntax_EitherOps$().toEitherNec$extension__s_util_Either__s_util_Either(eab$1);
  var this$5 = $n($n(target$1).Llaika_ast_DocumentTreeRoot__f_config);
  var decoder$2 = $m_Llaika_config_LinkValidation$().Llaika_config_LinkValidation$__f_decoder;
  var defaultKey$1 = $m_Llaika_config_LinkValidation$().Llaika_config_LinkValidation$__f_key;
  var key$2 = $n(defaultKey$1).Llaika_api_config_DefaultKey$$anon$1__f_value;
  var eab$2 = $f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$5, key$2, decoder$2);
  var elems = $n($x_3).wrapRefArray__AO__sci_ArraySeq(new ($d_s_util_Either.getArrayOf().constr)([$x_2, $x_1, $m_Lcats_syntax_EitherOps$().toEitherNec$extension__s_util_Either__s_util_Either(eab$2)]));
  var tma = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  $m_Lcats_UnorderedFoldable$();
  $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
  $m_Lcats_UnorderedFoldable$();
  var T = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
  $m_Lcats_data_NonEmptyChainImpl$();
  var ev = $m_Lcats_data_Chain$().Lcats_data_ChainInstances__f_theMonoid;
  $m_Lcats_instances_package$either$();
  var P = new $c_Lcats_instances_EitherInstances$$anon$5(ev);
  var this$16 = $n($as_s_util_Either($m_Lcats_Parallel$().parSequence__O__Lcats_Traverse__Lcats_Parallel__O(tma, T, P)));
  if ((this$16 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$16);
    var b = $n(x2).s_util_Right__f_value;
    $as_sci_List(b);
    var $x_4 = $m_sci_Nil$();
  } else {
    if ((!(this$16 instanceof $c_s_util_Left))) {
      throw new $c_s_MatchError(this$16);
    }
    var x3 = $as_s_util_Left(this$16);
    var a = $n(x3).s_util_Left__f_value;
    var $x_6 = $m_sci_Seq$();
    var $x_5 = $m_sr_ScalaRunTime$();
    var path = $m_Llaika_ast_Path$Root$();
    var $x_4 = $as_sci_Seq($n($x_6).apply__sci_Seq__sc_SeqOps($n($x_5).wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_config_ConfigError$DocumentErrors.getArrayOf().constr)([new $c_Llaika_api_config_ConfigError$DocumentErrors(path, a)]))));
  }
  return $as_sci_Seq($x_4);
}
function $p_Llaika_ast_RootCursor$__translatorConfig$1__Llaika_ast_DocumentTreeRoot__s_util_Either($thiz, target$2) {
  var eab = $m_Llaika_api_bundle_TranslatorConfig$().readFrom__Llaika_api_config_Config__s_util_Either($n(target$2).Llaika_ast_DocumentTreeRoot__f_config);
  if ((eab instanceof $c_s_util_Left)) {
    var a = $n($as_s_util_Left(eab)).s_util_Left__f_value;
    var err = $as_Llaika_api_config_ConfigError(a);
    var $x_1 = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptyChain);
    var path = $m_Llaika_ast_Path$Root$();
    var failures = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptyChain).one__O__O(err);
    var failures$1 = $n($x_1).one__O__O(new $c_Llaika_api_config_ConfigError$DocumentErrors(path, failures));
    var value = new $c_Llaika_api_config_ConfigError$TreeErrors(failures$1);
    return new $c_s_util_Left(value);
  }
  if ((eab instanceof $c_s_util_Right)) {
    var r = $as_s_util_Right(eab);
    $m_Lcats_syntax_EitherUtil$();
    return r;
  }
  throw new $c_s_MatchError(eab);
}
/** @constructor */
function $c_Llaika_ast_RootCursor$() {
}
$c_Llaika_ast_RootCursor$.prototype = new $h_O();
$c_Llaika_ast_RootCursor$.prototype.constructor = $c_Llaika_ast_RootCursor$;
/** @constructor */
function $h_Llaika_ast_RootCursor$() {
}
$h_Llaika_ast_RootCursor$.prototype = $c_Llaika_ast_RootCursor$.prototype;
$c_Llaika_ast_RootCursor$.prototype.apply__Llaika_ast_DocumentTreeRoot__s_Option__s_util_Either = (function(target, outputContext) {
  var $x_1 = $m_Lcats_data_package$().Lcats_data_package$__f_NonEmptyChain;
  var this$2 = $n($as_sc_IterableOps($n($n(target).allDocuments__sci_Seq()).flatMap__F1__O(new $c_sjsr_AnonFunction1(((doc) => {
    var doc$1 = $as_Llaika_ast_Document(doc);
    return $p_Llaika_ast_RootCursor$__validate$1__Llaika_ast_Document__s_Option(this, doc$1);
  })))));
  var suffix = $p_Llaika_ast_RootCursor$__validateRoot$1__Llaika_ast_DocumentTreeRoot__sci_Seq(this, target);
  var this$3 = $n($n($x_1).fromSeq__sci_Seq__s_Option($as_sci_Seq(this$2.concat__sc_IterableOnce__O(suffix))));
  if (this$3.isEmpty__Z()) {
    var $x_2 = $m_s_None$();
  } else {
    var arg1 = this$3.get__O();
    var $x_2 = new $c_s_Some(new $c_Llaika_api_config_ConfigError$TreeErrors(arg1));
  }
  var this$5 = $n($x_2);
  var validations = (this$5.isEmpty__Z() ? new $c_s_util_Right((void 0)) : new $c_s_util_Left(this$5.get__O()));
  var this$6 = $n(validations);
  if ((this$6 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$6);
    var b = $n(x2).s_util_Right__f_value;
    $as_jl_Void(b);
    $m_Lcats_UnorderedFoldable$();
    var tc = $as_Lcats_Traverse($m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption);
    var this$14 = new $c_Lcats_Traverse$ToTraverseOps$$anon$3(outputContext, tc);
    var f = new $c_sjsr_AnonFunction1(((ctx) => {
      var ctx$1 = $as_Llaika_ast_OutputContext(ctx);
      var this$10 = $n($p_Llaika_ast_RootCursor$__translatorConfig$1__Llaika_ast_DocumentTreeRoot__s_util_Either(this, target));
      if ((this$10 instanceof $c_s_util_Right)) {
        var x2$1 = $as_s_util_Right(this$10);
        var b$1 = $n(x2$1).s_util_Right__f_value;
        var cfg = $as_Llaika_api_bundle_TranslatorConfig(b$1);
        return new $c_s_util_Right(new $c_T2(ctx$1, cfg));
      } else {
        return this$10;
      }
    }));
    $m_Lcats_instances_package$either$();
    var ev$1 = new $c_Lcats_instances_EitherInstances$$anon$2();
    var this$15 = $n($as_s_util_Either($n(this$14.Lcats_Traverse$ToTraverseOps$$anon$3__f_typeClassInstance).traverse__O__F1__Lcats_Applicative__O(this$14.Lcats_Traverse$ToTraverseOps$$anon$3__f_self, f, ev$1)));
    if ((this$15 instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(this$15);
      var b$2 = $n(x2$2).s_util_Right__f_value;
      var renderContext = $as_s_Option(b$2);
      return new $c_s_util_Right(new $c_Llaika_ast_RootCursor(target, renderContext));
    } else {
      return this$15;
    }
  } else {
    return this$6;
  }
});
var $d_Llaika_ast_RootCursor$ = new $TypeData().initClass($c_Llaika_ast_RootCursor$, "laika.ast.RootCursor$", ({
  Llaika_ast_RootCursor$: 1
}));
var $n_Llaika_ast_RootCursor$;
function $m_Llaika_ast_RootCursor$() {
  if ((!$n_Llaika_ast_RootCursor$)) {
    $n_Llaika_ast_RootCursor$ = new $c_Llaika_ast_RootCursor$();
  }
  return $n_Llaika_ast_RootCursor$;
}
function $is_Llaika_ast_Span(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_Span)));
}
function $as_Llaika_ast_Span(obj) {
  return (($is_Llaika_ast_Span(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Span"));
}
function $isArrayOf_Llaika_ast_Span(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Span)));
}
function $asArrayOf_Llaika_ast_Span(obj, depth) {
  return (($isArrayOf_Llaika_ast_Span(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Span;", depth));
}
var $d_Llaika_ast_Span = new $TypeData().initClass(1, "laika.ast.Span", ({
  Llaika_ast_Span: 1
}));
function $f_Llaika_ast_SpanContainerCompanion__apply__T__sci_Seq__O($thiz, text, texts) {
  var this$1 = $n(texts);
  return $thiz.createSpanContainer__sci_Seq__O($as_sci_Seq($n($as_sc_IterableOps(this$1.prepended__O__O(text))).map__F1__O(new $c_sjsr_AnonFunction1(((_$1) => {
    var _$1$1 = $as_T(_$1);
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    return new $c_Llaika_ast_Text(_$1$1, options);
  })))));
}
function $f_Llaika_ast_SpanContainerCompanion__apply__Llaika_ast_Span__sci_Seq__O($thiz, span, spans) {
  var this$1 = $n($n(spans).toList__sci_List());
  return $thiz.createSpanContainer__sci_Seq__O(this$1.prepended__O__sci_List(span));
}
/** @constructor */
function $c_Llaika_ast_Style$() {
  this.Llaika_ast_Style$__f_title = null;
  this.Llaika_ast_Style$__f_section = null;
  this.Llaika_ast_Style$__f_sectionNumber = null;
  this.Llaika_ast_Style$__f_navList = null;
  this.Llaika_ast_Style$__f_navHeader = null;
  this.Llaika_ast_Style$__f_navNode = null;
  this.Llaika_ast_Style$__f_navLeaf = null;
  this.Llaika_ast_Style$__f_active = null;
  this.Llaika_ast_Style$__f_breadcrumb = null;
  this.Llaika_ast_Style$__f_alignCenter = null;
  this.Llaika_ast_Style$__f_alignLeft = null;
  this.Llaika_ast_Style$__f_alignRight = null;
  this.Llaika_ast_Style$__f_citation = null;
  this.Llaika_ast_Style$__f_footnote = null;
  this.Llaika_ast_Style$__f_label = null;
  this.Llaika_ast_Style$__f_attribution = null;
  this.Llaika_ast_Style$__f_caption = null;
  this.Llaika_ast_Style$__f_legend = null;
  this.Llaika_ast_Style$__f_figure = null;
  this.Llaika_ast_Style$__f_runtimeMessage = null;
  this.Llaika_ast_Style$__f_noHighlight = null;
  $n_Llaika_ast_Style$ = this;
  this.Llaika_ast_Style$__f_title = $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["title"])));
  this.Llaika_ast_Style$__f_section = $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["section"])));
  this.Llaika_ast_Style$__f_sectionNumber = $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["section-number"])));
  $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["nav"])));
  this.Llaika_ast_Style$__f_navList = $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["nav-list"])));
  this.Llaika_ast_Style$__f_navHeader = $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["nav-header"])));
  this.Llaika_ast_Style$__f_navNode = $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["nav-node"])));
  this.Llaika_ast_Style$__f_navLeaf = $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["nav-leaf"])));
  this.Llaika_ast_Style$__f_active = $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["active"])));
  this.Llaika_ast_Style$__f_breadcrumb = $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["breadcrumb"])));
  $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["bookmark"])));
  this.Llaika_ast_Style$__f_alignCenter = $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["align-center"])));
  this.Llaika_ast_Style$__f_alignLeft = $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["align-left"])));
  this.Llaika_ast_Style$__f_alignRight = $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["align-right"])));
  $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["keep-together"])));
  this.Llaika_ast_Style$__f_citation = $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["citation"])));
  this.Llaika_ast_Style$__f_footnote = $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["footnote"])));
  $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["footnote-label"])));
  this.Llaika_ast_Style$__f_label = $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["label"])));
  this.Llaika_ast_Style$__f_attribution = $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["attribution"])));
  this.Llaika_ast_Style$__f_caption = $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["caption"])));
  this.Llaika_ast_Style$__f_legend = $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["legend"])));
  this.Llaika_ast_Style$__f_figure = $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["figure"])));
  this.Llaika_ast_Style$__f_runtimeMessage = $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["runtime-message"])));
  this.Llaika_ast_Style$__f_noHighlight = $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["nohighlight"])));
}
$c_Llaika_ast_Style$.prototype = new $h_O();
$c_Llaika_ast_Style$.prototype.constructor = $c_Llaika_ast_Style$;
/** @constructor */
function $h_Llaika_ast_Style$() {
}
$h_Llaika_ast_Style$.prototype = $c_Llaika_ast_Style$.prototype;
$c_Llaika_ast_Style$.prototype.level__I__Llaika_ast_Options = (function(lev) {
  return $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([("level" + lev)])));
});
var $d_Llaika_ast_Style$ = new $TypeData().initClass($c_Llaika_ast_Style$, "laika.ast.Style$", ({
  Llaika_ast_Style$: 1
}));
var $n_Llaika_ast_Style$;
function $m_Llaika_ast_Style$() {
  if ((!$n_Llaika_ast_Style$)) {
    $n_Llaika_ast_Style$ = new $c_Llaika_ast_Style$();
  }
  return $n_Llaika_ast_Style$;
}
/** @constructor */
function $c_Llaika_ast_Styles$() {
}
$c_Llaika_ast_Styles$.prototype = new $h_O();
$c_Llaika_ast_Styles$.prototype.constructor = $c_Llaika_ast_Styles$;
/** @constructor */
function $h_Llaika_ast_Styles$() {
}
$h_Llaika_ast_Styles$.prototype = $c_Llaika_ast_Styles$.prototype;
$c_Llaika_ast_Styles$.prototype.apply__sci_Seq__Llaika_ast_Options = (function(values) {
  var this$1 = $n(values);
  var styles$1 = $m_sci_Set$().from__sc_IterableOnce__sci_Set(this$1);
  $m_Llaika_ast_Options$();
  var id$1 = $m_s_None$();
  return $m_Llaika_ast_Options$().apply__s_Option__sci_Set__Llaika_ast_Options(id$1, styles$1);
});
var $d_Llaika_ast_Styles$ = new $TypeData().initClass($c_Llaika_ast_Styles$, "laika.ast.Styles$", ({
  Llaika_ast_Styles$: 1
}));
var $n_Llaika_ast_Styles$;
function $m_Llaika_ast_Styles$() {
  if ((!$n_Llaika_ast_Styles$)) {
    $n_Llaika_ast_Styles$ = new $c_Llaika_ast_Styles$();
  }
  return $n_Llaika_ast_Styles$;
}
function $is_Llaika_ast_TableElement(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_TableElement)));
}
function $as_Llaika_ast_TableElement(obj) {
  return (($is_Llaika_ast_TableElement(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.TableElement"));
}
function $isArrayOf_Llaika_ast_TableElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_TableElement)));
}
function $asArrayOf_Llaika_ast_TableElement(obj, depth) {
  return (($isArrayOf_Llaika_ast_TableElement(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.TableElement;", depth));
}
function $is_Llaika_ast_Target(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_Target)));
}
function $as_Llaika_ast_Target(obj) {
  return (($is_Llaika_ast_Target(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Target"));
}
function $isArrayOf_Llaika_ast_Target(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Target)));
}
function $asArrayOf_Llaika_ast_Target(obj, depth) {
  return (($isArrayOf_Llaika_ast_Target(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Target;", depth));
}
function $is_Llaika_ast_TargetValidation(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_TargetValidation)));
}
function $as_Llaika_ast_TargetValidation(obj) {
  return (($is_Llaika_ast_TargetValidation(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.TargetValidation"));
}
function $isArrayOf_Llaika_ast_TargetValidation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_TargetValidation)));
}
function $asArrayOf_Llaika_ast_TargetValidation(obj, depth) {
  return (($isArrayOf_Llaika_ast_TargetValidation(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.TargetValidation;", depth));
}
function $f_Llaika_ast_TemplateSpanContainerCompanion__apply__Llaika_ast_TemplateSpan__sci_Seq__O($thiz, span, spans) {
  var this$1 = $n($n(spans).toList__sci_List());
  return $thiz.createSpanContainer__sci_Seq__O(this$1.prepended__O__sci_List(span));
}
function $p_Llaika_ast_TreeBuilder$__toMap$1__sc_Iterable__sci_Map($thiz, items) {
  var $x_1 = $n($as_sc_IterableOnceOps($n(items).map__F1__O(new $c_sjsr_AnonFunction1(((c) => {
    var c$1 = $as_Llaika_ast_Navigatable(c);
    var _1 = $n(c$1).path__Llaika_ast_Path();
    return new $c_T2(_1, c$1);
  })))));
  var this$3 = $m_s_$less$colon$less$();
  return $n($x_1).toMap__s_$less$colon$less__sci_Map(this$3.s_$less$colon$less$__f_singleton);
}
function $p_Llaika_ast_TreeBuilder$__parent$1__Llaika_ast_Path__I__Llaika_ast_Path($thiz, p, levels) {
  var levels$tailLocal1 = levels;
  var p$tailLocal1 = p;
  while (true) {
    if ((levels$tailLocal1 <= 0)) {
      return p$tailLocal1;
    } else {
      var p$tailLocal1$tmp1 = $n(p$tailLocal1).parent__Llaika_ast_Path();
      var levels$tailLocal1$tmp1 = (((-1) + levels$tailLocal1) | 0);
      p$tailLocal1 = p$tailLocal1$tmp1;
      levels$tailLocal1 = levels$tailLocal1$tmp1;
    }
  }
}
/** @constructor */
function $c_Llaika_ast_TreeBuilder$() {
}
$c_Llaika_ast_TreeBuilder$.prototype = new $h_O();
$c_Llaika_ast_TreeBuilder$.prototype.constructor = $c_Llaika_ast_TreeBuilder$;
/** @constructor */
function $h_Llaika_ast_TreeBuilder$() {
}
$h_Llaika_ast_TreeBuilder$.prototype = $c_Llaika_ast_TreeBuilder$.prototype;
var $d_Llaika_ast_TreeBuilder$ = new $TypeData().initClass($c_Llaika_ast_TreeBuilder$, "laika.ast.TreeBuilder$", ({
  Llaika_ast_TreeBuilder$: 1
}));
var $n_Llaika_ast_TreeBuilder$;
function $m_Llaika_ast_TreeBuilder$() {
  if ((!$n_Llaika_ast_TreeBuilder$)) {
    $n_Llaika_ast_TreeBuilder$ = new $c_Llaika_ast_TreeBuilder$();
  }
  return $n_Llaika_ast_TreeBuilder$;
}
/** @constructor */
function $c_Llaika_ast_TreeCursor$() {
}
$c_Llaika_ast_TreeCursor$.prototype = new $h_O();
$c_Llaika_ast_TreeCursor$.prototype.constructor = $c_Llaika_ast_TreeCursor$;
/** @constructor */
function $h_Llaika_ast_TreeCursor$() {
}
$h_Llaika_ast_TreeCursor$.prototype = $c_Llaika_ast_TreeCursor$.prototype;
$c_Llaika_ast_TreeCursor$.prototype.apply__Llaika_ast_RootCursor__Llaika_ast_TreeCursor = (function(root) {
  return new $c_Llaika_ast_TreeCursor($n($n(root).Llaika_ast_RootCursor__f_target).Llaika_ast_DocumentTreeRoot__f_tree, $m_s_None$(), root);
});
$c_Llaika_ast_TreeCursor$.prototype.apply__Llaika_ast_DocumentTree__s_Option__s_util_Either = (function(root, outputContext) {
  var this$1 = $n($m_Llaika_ast_RootCursor$().apply__Llaika_ast_DocumentTreeRoot__s_Option__s_util_Either($m_Llaika_ast_DocumentTreeRoot$().apply__Llaika_ast_DocumentTree__Llaika_ast_DocumentTreeRoot(root), outputContext));
  if ((this$1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$1);
    var b = $n(x2).s_util_Right__f_value;
    var root$1 = $as_Llaika_ast_RootCursor(b);
    return new $c_s_util_Right(this.apply__Llaika_ast_RootCursor__Llaika_ast_TreeCursor(root$1));
  } else {
    return this$1;
  }
});
var $d_Llaika_ast_TreeCursor$ = new $TypeData().initClass($c_Llaika_ast_TreeCursor$, "laika.ast.TreeCursor$", ({
  Llaika_ast_TreeCursor$: 1
}));
var $n_Llaika_ast_TreeCursor$;
function $m_Llaika_ast_TreeCursor$() {
  if ((!$n_Llaika_ast_TreeCursor$)) {
    $n_Llaika_ast_TreeCursor$ = new $c_Llaika_ast_TreeCursor$();
  }
  return $n_Llaika_ast_TreeCursor$;
}
/** @constructor */
function $c_Llaika_ast_TreePosition$() {
  this.Llaika_ast_TreePosition$__f_root = null;
  $n_Llaika_ast_TreePosition$ = this;
  this.Llaika_ast_TreePosition$__f_root = new $c_Llaika_ast_TreePosition($m_sci_Nil$());
}
$c_Llaika_ast_TreePosition$.prototype = new $h_O();
$c_Llaika_ast_TreePosition$.prototype.constructor = $c_Llaika_ast_TreePosition$;
/** @constructor */
function $h_Llaika_ast_TreePosition$() {
}
$h_Llaika_ast_TreePosition$.prototype = $c_Llaika_ast_TreePosition$.prototype;
var $d_Llaika_ast_TreePosition$ = new $TypeData().initClass($c_Llaika_ast_TreePosition$, "laika.ast.TreePosition$", ({
  Llaika_ast_TreePosition$: 1
}));
var $n_Llaika_ast_TreePosition$;
function $m_Llaika_ast_TreePosition$() {
  if ((!$n_Llaika_ast_TreePosition$)) {
    $n_Llaika_ast_TreePosition$ = new $c_Llaika_ast_TreePosition$();
  }
  return $n_Llaika_ast_TreePosition$;
}
function $is_Llaika_ast_Unresolved(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_Unresolved)));
}
function $as_Llaika_ast_Unresolved(obj) {
  return (($is_Llaika_ast_Unresolved(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Unresolved"));
}
function $isArrayOf_Llaika_ast_Unresolved(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Unresolved)));
}
function $asArrayOf_Llaika_ast_Unresolved(obj, depth) {
  return (($isArrayOf_Llaika_ast_Unresolved(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Unresolved;", depth));
}
/** @constructor */
function $c_Llaika_config_ApiLinks() {
}
$c_Llaika_config_ApiLinks.prototype = new $h_O();
$c_Llaika_config_ApiLinks.prototype.constructor = $c_Llaika_config_ApiLinks;
/** @constructor */
function $h_Llaika_config_ApiLinks() {
}
$h_Llaika_config_ApiLinks.prototype = $c_Llaika_config_ApiLinks.prototype;
function $as_Llaika_config_ApiLinks(obj) {
  return (((obj instanceof $c_Llaika_config_ApiLinks) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.ApiLinks"));
}
function $isArrayOf_Llaika_config_ApiLinks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_ApiLinks)));
}
function $asArrayOf_Llaika_config_ApiLinks(obj, depth) {
  return (($isArrayOf_Llaika_config_ApiLinks(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.ApiLinks;", depth));
}
/** @constructor */
function $c_Llaika_config_AutonumberConfig() {
}
$c_Llaika_config_AutonumberConfig.prototype = new $h_O();
$c_Llaika_config_AutonumberConfig.prototype.constructor = $c_Llaika_config_AutonumberConfig;
/** @constructor */
function $h_Llaika_config_AutonumberConfig() {
}
$h_Llaika_config_AutonumberConfig.prototype = $c_Llaika_config_AutonumberConfig.prototype;
function $as_Llaika_config_AutonumberConfig(obj) {
  return (((obj instanceof $c_Llaika_config_AutonumberConfig) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.AutonumberConfig"));
}
function $isArrayOf_Llaika_config_AutonumberConfig(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_AutonumberConfig)));
}
function $asArrayOf_Llaika_config_AutonumberConfig(obj, depth) {
  return (($isArrayOf_Llaika_config_AutonumberConfig(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.AutonumberConfig;", depth));
}
/** @constructor */
function $c_Llaika_config_ChoiceConfig() {
}
$c_Llaika_config_ChoiceConfig.prototype = new $h_O();
$c_Llaika_config_ChoiceConfig.prototype.constructor = $c_Llaika_config_ChoiceConfig;
/** @constructor */
function $h_Llaika_config_ChoiceConfig() {
}
$h_Llaika_config_ChoiceConfig.prototype = $c_Llaika_config_ChoiceConfig.prototype;
function $as_Llaika_config_ChoiceConfig(obj) {
  return (((obj instanceof $c_Llaika_config_ChoiceConfig) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.ChoiceConfig"));
}
function $isArrayOf_Llaika_config_ChoiceConfig(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_ChoiceConfig)));
}
function $asArrayOf_Llaika_config_ChoiceConfig(obj, depth) {
  return (($isArrayOf_Llaika_config_ChoiceConfig(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.ChoiceConfig;", depth));
}
/** @constructor */
function $c_Llaika_config_LaikaKeys$() {
  this.Llaika_config_LaikaKeys$__f_root = null;
  this.Llaika_config_LaikaKeys$__f_title = null;
  this.Llaika_config_LaikaKeys$__f_metadata = null;
  this.Llaika_config_LaikaKeys$__f_links = null;
  this.Llaika_config_LaikaKeys$__f_icons = null;
  this.Llaika_config_LaikaKeys$__f_selections = null;
  this.Llaika_config_LaikaKeys$__f_autonumbering = null;
  this.Llaika_config_LaikaKeys$__f_excludeFromNavigation = null;
  this.Llaika_config_LaikaKeys$__f_targetFormats = null;
  this.Llaika_config_LaikaKeys$__f_firstHeaderAsTitle = null;
  this.Llaika_config_LaikaKeys$__f_siteBaseURL = null;
  this.Llaika_config_LaikaKeys$__f_versioned = null;
  this.Llaika_config_LaikaKeys$__f_versions = null;
  this.Llaika_config_LaikaKeys$__f_orphan = null;
  $n_Llaika_config_LaikaKeys$ = this;
  this.Llaika_config_LaikaKeys$__f_root = $m_Llaika_api_config_Key$().apply__T__sci_Seq__Llaika_api_config_Key("laika", $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([])));
  this.Llaika_config_LaikaKeys$__f_title = $n(this.Llaika_config_LaikaKeys$__f_root).child__T__Llaika_api_config_Key("title");
  $n(this.Llaika_config_LaikaKeys$__f_root).child__T__Llaika_api_config_Key("template");
  this.Llaika_config_LaikaKeys$__f_metadata = $n(this.Llaika_config_LaikaKeys$__f_root).child__T__Llaika_api_config_Key("metadata");
  this.Llaika_config_LaikaKeys$__f_links = $n(this.Llaika_config_LaikaKeys$__f_root).child__T__Llaika_api_config_Key("links");
  this.Llaika_config_LaikaKeys$__f_icons = $n(this.Llaika_config_LaikaKeys$__f_root).child__T__Llaika_api_config_Key("icons");
  this.Llaika_config_LaikaKeys$__f_selections = $n(this.Llaika_config_LaikaKeys$__f_root).child__T__Llaika_api_config_Key("selections");
  this.Llaika_config_LaikaKeys$__f_autonumbering = $n(this.Llaika_config_LaikaKeys$__f_root).child__T__Llaika_api_config_Key("autonumbering");
  $n(this.Llaika_config_LaikaKeys$__f_root).child__T__Llaika_api_config_Key("navigationOrder");
  this.Llaika_config_LaikaKeys$__f_excludeFromNavigation = $n(this.Llaika_config_LaikaKeys$__f_root).child__T__Llaika_api_config_Key("excludeFromNavigation");
  this.Llaika_config_LaikaKeys$__f_targetFormats = $n(this.Llaika_config_LaikaKeys$__f_root).child__T__Llaika_api_config_Key("targetFormats");
  this.Llaika_config_LaikaKeys$__f_firstHeaderAsTitle = $n(this.Llaika_config_LaikaKeys$__f_root).child__T__Llaika_api_config_Key("firstHeaderAsTitle");
  $n(this.Llaika_config_LaikaKeys$__f_root).child__T__Llaika_api_config_Key("artifactBaseName");
  this.Llaika_config_LaikaKeys$__f_siteBaseURL = $n(this.Llaika_config_LaikaKeys$__f_root).child__T__Llaika_api_config_Key("siteBaseURL");
  $n(this.Llaika_config_LaikaKeys$__f_root).child__T__Llaika_api_config_Key("coverImage");
  $n(this.Llaika_config_LaikaKeys$__f_root).child__T__Llaika_api_config_Key("coverImages");
  this.Llaika_config_LaikaKeys$__f_versioned = $n(this.Llaika_config_LaikaKeys$__f_root).child__T__Llaika_api_config_Key("versioned");
  this.Llaika_config_LaikaKeys$__f_versions = $n(this.Llaika_config_LaikaKeys$__f_root).child__T__Llaika_api_config_Key("versions");
  this.Llaika_config_LaikaKeys$__f_orphan = $n(this.Llaika_config_LaikaKeys$__f_root).child__T__Llaika_api_config_Key("orphan");
}
$c_Llaika_config_LaikaKeys$.prototype = new $h_O();
$c_Llaika_config_LaikaKeys$.prototype.constructor = $c_Llaika_config_LaikaKeys$;
/** @constructor */
function $h_Llaika_config_LaikaKeys$() {
}
$h_Llaika_config_LaikaKeys$.prototype = $c_Llaika_config_LaikaKeys$.prototype;
var $d_Llaika_config_LaikaKeys$ = new $TypeData().initClass($c_Llaika_config_LaikaKeys$, "laika.config.LaikaKeys$", ({
  Llaika_config_LaikaKeys$: 1
}));
var $n_Llaika_config_LaikaKeys$;
function $m_Llaika_config_LaikaKeys$() {
  if ((!$n_Llaika_config_LaikaKeys$)) {
    $n_Llaika_config_LaikaKeys$ = new $c_Llaika_config_LaikaKeys$();
  }
  return $n_Llaika_config_LaikaKeys$;
}
/** @constructor */
function $c_Llaika_config_LaikaKeys$titleDocuments$() {
  this.Llaika_config_LaikaKeys$titleDocuments$__f_inputName = null;
  this.Llaika_config_LaikaKeys$titleDocuments$__f_outputName = null;
  $n_Llaika_config_LaikaKeys$titleDocuments$ = this;
  this.Llaika_config_LaikaKeys$titleDocuments$__f_inputName = $n($m_Llaika_config_LaikaKeys$().Llaika_config_LaikaKeys$__f_root).child__Llaika_api_config_Key__Llaika_api_config_Key($m_Llaika_api_config_Key$().apply__T__sci_Seq__Llaika_api_config_Key("titleDocuments", $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["inputName"]))));
  this.Llaika_config_LaikaKeys$titleDocuments$__f_outputName = $n($m_Llaika_config_LaikaKeys$().Llaika_config_LaikaKeys$__f_root).child__Llaika_api_config_Key__Llaika_api_config_Key($m_Llaika_api_config_Key$().apply__T__sci_Seq__Llaika_api_config_Key("titleDocuments", $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["outputName"]))));
}
$c_Llaika_config_LaikaKeys$titleDocuments$.prototype = new $h_O();
$c_Llaika_config_LaikaKeys$titleDocuments$.prototype.constructor = $c_Llaika_config_LaikaKeys$titleDocuments$;
/** @constructor */
function $h_Llaika_config_LaikaKeys$titleDocuments$() {
}
$h_Llaika_config_LaikaKeys$titleDocuments$.prototype = $c_Llaika_config_LaikaKeys$titleDocuments$.prototype;
var $d_Llaika_config_LaikaKeys$titleDocuments$ = new $TypeData().initClass($c_Llaika_config_LaikaKeys$titleDocuments$, "laika.config.LaikaKeys$titleDocuments$", ({
  Llaika_config_LaikaKeys$titleDocuments$: 1
}));
var $n_Llaika_config_LaikaKeys$titleDocuments$;
function $m_Llaika_config_LaikaKeys$titleDocuments$() {
  if ((!$n_Llaika_config_LaikaKeys$titleDocuments$)) {
    $n_Llaika_config_LaikaKeys$titleDocuments$ = new $c_Llaika_config_LaikaKeys$titleDocuments$();
  }
  return $n_Llaika_config_LaikaKeys$titleDocuments$;
}
/** @constructor */
function $c_Llaika_config_LinkConfig() {
}
$c_Llaika_config_LinkConfig.prototype = new $h_O();
$c_Llaika_config_LinkConfig.prototype.constructor = $c_Llaika_config_LinkConfig;
/** @constructor */
function $h_Llaika_config_LinkConfig() {
}
$h_Llaika_config_LinkConfig.prototype = $c_Llaika_config_LinkConfig.prototype;
function $as_Llaika_config_LinkConfig(obj) {
  return (((obj instanceof $c_Llaika_config_LinkConfig) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.LinkConfig"));
}
function $isArrayOf_Llaika_config_LinkConfig(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_LinkConfig)));
}
function $asArrayOf_Llaika_config_LinkConfig(obj, depth) {
  return (($isArrayOf_Llaika_config_LinkConfig(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.LinkConfig;", depth));
}
function $is_Llaika_config_LinkValidation(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_config_LinkValidation)));
}
function $as_Llaika_config_LinkValidation(obj) {
  return (($is_Llaika_config_LinkValidation(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.LinkValidation"));
}
function $isArrayOf_Llaika_config_LinkValidation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_LinkValidation)));
}
function $asArrayOf_Llaika_config_LinkValidation(obj, depth) {
  return (($isArrayOf_Llaika_config_LinkValidation(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.LinkValidation;", depth));
}
/** @constructor */
function $c_Llaika_config_MessageFilter$() {
  this.Llaika_config_MessageFilter$__f_Info = null;
  this.Llaika_config_MessageFilter$__f_Error = null;
  $n_Llaika_config_MessageFilter$ = this;
  var level = $m_Llaika_ast_MessageLevel$Debug$();
  new $c_Llaika_config_MessageFilter$$anon$1(level, this);
  var level$1 = $m_Llaika_ast_MessageLevel$Info$();
  this.Llaika_config_MessageFilter$__f_Info = new $c_Llaika_config_MessageFilter$$anon$1(level$1, this);
  var level$2 = $m_Llaika_ast_MessageLevel$Warning$();
  new $c_Llaika_config_MessageFilter$$anon$1(level$2, this);
  var level$3 = $m_Llaika_ast_MessageLevel$Error$();
  this.Llaika_config_MessageFilter$__f_Error = new $c_Llaika_config_MessageFilter$$anon$1(level$3, this);
  var level$4 = $m_Llaika_ast_MessageLevel$Fatal$();
  new $c_Llaika_config_MessageFilter$$anon$1(level$4, this);
}
$c_Llaika_config_MessageFilter$.prototype = new $h_O();
$c_Llaika_config_MessageFilter$.prototype.constructor = $c_Llaika_config_MessageFilter$;
/** @constructor */
function $h_Llaika_config_MessageFilter$() {
}
$h_Llaika_config_MessageFilter$.prototype = $c_Llaika_config_MessageFilter$.prototype;
var $d_Llaika_config_MessageFilter$ = new $TypeData().initClass($c_Llaika_config_MessageFilter$, "laika.config.MessageFilter$", ({
  Llaika_config_MessageFilter$: 1
}));
var $n_Llaika_config_MessageFilter$;
function $m_Llaika_config_MessageFilter$() {
  if ((!$n_Llaika_config_MessageFilter$)) {
    $n_Llaika_config_MessageFilter$ = new $c_Llaika_config_MessageFilter$();
  }
  return $n_Llaika_config_MessageFilter$;
}
/** @constructor */
function $c_Llaika_config_MessageFilters() {
}
$c_Llaika_config_MessageFilters.prototype = new $h_O();
$c_Llaika_config_MessageFilters.prototype.constructor = $c_Llaika_config_MessageFilters;
/** @constructor */
function $h_Llaika_config_MessageFilters() {
}
$h_Llaika_config_MessageFilters.prototype = $c_Llaika_config_MessageFilters.prototype;
function $is_Llaika_config_Scope(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_config_Scope)));
}
function $as_Llaika_config_Scope(obj) {
  return (($is_Llaika_config_Scope(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.Scope"));
}
function $isArrayOf_Llaika_config_Scope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_Scope)));
}
function $asArrayOf_Llaika_config_Scope(obj, depth) {
  return (($isArrayOf_Llaika_config_Scope(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.Scope;", depth));
}
/** @constructor */
function $c_Llaika_config_SelectionConfig() {
}
$c_Llaika_config_SelectionConfig.prototype = new $h_O();
$c_Llaika_config_SelectionConfig.prototype.constructor = $c_Llaika_config_SelectionConfig;
/** @constructor */
function $h_Llaika_config_SelectionConfig() {
}
$h_Llaika_config_SelectionConfig.prototype = $c_Llaika_config_SelectionConfig.prototype;
$c_Llaika_config_SelectionConfig.prototype.getLabel__T__s_Option = (function(name) {
  $m_Lcats_data_NonEmptyChainImpl$();
  var value = this.Llaika_config_SelectionConfig$Impl__f_choices;
  var this$2 = $n($m_Lcats_data_NonEmptyChainOps$().find$extension__O__F1__s_Option(value, new $c_sjsr_AnonFunction1(((_$19) => {
    var _$19$1 = $as_Llaika_config_ChoiceConfig(_$19);
    return ($n(_$19$1).Llaika_config_ChoiceConfig$Impl__f_name === name);
  }))));
  if (this$2.isEmpty__Z()) {
    return $m_s_None$();
  } else {
    var arg1 = this$2.get__O();
    var _$20 = $as_Llaika_config_ChoiceConfig(arg1);
    return new $c_s_Some($n(_$20).Llaika_config_ChoiceConfig$Impl__f_label);
  }
});
function $as_Llaika_config_SelectionConfig(obj) {
  return (((obj instanceof $c_Llaika_config_SelectionConfig) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.SelectionConfig"));
}
function $isArrayOf_Llaika_config_SelectionConfig(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_SelectionConfig)));
}
function $asArrayOf_Llaika_config_SelectionConfig(obj, depth) {
  return (($isArrayOf_Llaika_config_SelectionConfig(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.SelectionConfig;", depth));
}
/** @constructor */
function $c_Llaika_config_Selections() {
}
$c_Llaika_config_Selections.prototype = new $h_O();
$c_Llaika_config_Selections.prototype.constructor = $c_Llaika_config_Selections;
/** @constructor */
function $h_Llaika_config_Selections() {
}
$h_Llaika_config_Selections.prototype = $c_Llaika_config_Selections.prototype;
$c_Llaika_config_Selections.prototype.getSelection__T__s_Option = (function(name) {
  return $n(this.Llaika_config_Selections$Impl__f_all).find__F1__s_Option(new $c_sjsr_AnonFunction1(((_$1) => {
    var _$1$1 = $as_Llaika_config_SelectionConfig(_$1);
    return ($n(_$1$1).Llaika_config_SelectionConfig$Impl__f_name === name);
  })));
});
function $as_Llaika_config_Selections(obj) {
  return (((obj instanceof $c_Llaika_config_Selections) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.Selections"));
}
function $isArrayOf_Llaika_config_Selections(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_Selections)));
}
function $asArrayOf_Llaika_config_Selections(obj, depth) {
  return (($isArrayOf_Llaika_config_Selections(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.Selections;", depth));
}
/** @constructor */
function $c_Llaika_config_SourceLinks() {
}
$c_Llaika_config_SourceLinks.prototype = new $h_O();
$c_Llaika_config_SourceLinks.prototype.constructor = $c_Llaika_config_SourceLinks;
/** @constructor */
function $h_Llaika_config_SourceLinks() {
}
$h_Llaika_config_SourceLinks.prototype = $c_Llaika_config_SourceLinks.prototype;
function $as_Llaika_config_SourceLinks(obj) {
  return (((obj instanceof $c_Llaika_config_SourceLinks) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.SourceLinks"));
}
function $isArrayOf_Llaika_config_SourceLinks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_SourceLinks)));
}
function $asArrayOf_Llaika_config_SourceLinks(obj, depth) {
  return (($isArrayOf_Llaika_config_SourceLinks(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.SourceLinks;", depth));
}
/** @constructor */
function $c_Llaika_config_TargetDefinition() {
}
$c_Llaika_config_TargetDefinition.prototype = new $h_O();
$c_Llaika_config_TargetDefinition.prototype.constructor = $c_Llaika_config_TargetDefinition;
/** @constructor */
function $h_Llaika_config_TargetDefinition() {
}
$h_Llaika_config_TargetDefinition.prototype = $c_Llaika_config_TargetDefinition.prototype;
function $as_Llaika_config_TargetDefinition(obj) {
  return (((obj instanceof $c_Llaika_config_TargetDefinition) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.TargetDefinition"));
}
function $isArrayOf_Llaika_config_TargetDefinition(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_TargetDefinition)));
}
function $asArrayOf_Llaika_config_TargetDefinition(obj, depth) {
  return (($isArrayOf_Llaika_config_TargetDefinition(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.TargetDefinition;", depth));
}
function $is_Llaika_config_TargetFormats(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_config_TargetFormats)));
}
function $as_Llaika_config_TargetFormats(obj) {
  return (($is_Llaika_config_TargetFormats(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.TargetFormats"));
}
function $isArrayOf_Llaika_config_TargetFormats(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_TargetFormats)));
}
function $asArrayOf_Llaika_config_TargetFormats(obj, depth) {
  return (($isArrayOf_Llaika_config_TargetFormats(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.TargetFormats;", depth));
}
/** @constructor */
function $c_Llaika_config_Version() {
}
$c_Llaika_config_Version.prototype = new $h_O();
$c_Llaika_config_Version.prototype.constructor = $c_Llaika_config_Version;
/** @constructor */
function $h_Llaika_config_Version() {
}
$h_Llaika_config_Version.prototype = $c_Llaika_config_Version.prototype;
function $as_Llaika_config_Version(obj) {
  return (((obj instanceof $c_Llaika_config_Version) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.Version"));
}
function $isArrayOf_Llaika_config_Version(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_Version)));
}
function $asArrayOf_Llaika_config_Version(obj, depth) {
  return (($isArrayOf_Llaika_config_Version(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.Version;", depth));
}
/** @constructor */
function $c_Llaika_config_VersionScannerConfig() {
}
$c_Llaika_config_VersionScannerConfig.prototype = new $h_O();
$c_Llaika_config_VersionScannerConfig.prototype.constructor = $c_Llaika_config_VersionScannerConfig;
/** @constructor */
function $h_Llaika_config_VersionScannerConfig() {
}
$h_Llaika_config_VersionScannerConfig.prototype = $c_Llaika_config_VersionScannerConfig.prototype;
function $as_Llaika_config_VersionScannerConfig(obj) {
  return (((obj instanceof $c_Llaika_config_VersionScannerConfig) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.VersionScannerConfig"));
}
function $isArrayOf_Llaika_config_VersionScannerConfig(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_VersionScannerConfig)));
}
function $asArrayOf_Llaika_config_VersionScannerConfig(obj, depth) {
  return (($isArrayOf_Llaika_config_VersionScannerConfig(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.VersionScannerConfig;", depth));
}
/** @constructor */
function $c_Llaika_config_Versions() {
  this.Llaika_config_Versions__f_allVersions$lzy1 = null;
  this.Llaika_config_Versions__f_allVersionsbitmap$1 = false;
}
$c_Llaika_config_Versions.prototype = new $h_O();
$c_Llaika_config_Versions.prototype.constructor = $c_Llaika_config_Versions;
/** @constructor */
function $h_Llaika_config_Versions() {
}
$h_Llaika_config_Versions.prototype = $c_Llaika_config_Versions.prototype;
$c_Llaika_config_Versions.prototype.allVersions__sci_Seq = (function() {
  if ((!this.Llaika_config_Versions__f_allVersionsbitmap$1)) {
    var prefix$1 = this.Llaika_config_Versions$Impl__f_newerVersions;
    var elem$1 = this.Llaika_config_Versions$Impl__f_currentVersion;
    var this$1 = $n(this.Llaika_config_Versions$Impl__f_olderVersions);
    var this$2 = $n($as_sc_SeqOps(this$1.prepended__O__O(elem$1)));
    this.Llaika_config_Versions__f_allVersions$lzy1 = $as_sci_Seq(this$2.prependedAll__sc_IterableOnce__O(prefix$1));
    this.Llaika_config_Versions__f_allVersionsbitmap$1 = true;
  }
  return this.Llaika_config_Versions__f_allVersions$lzy1;
});
function $as_Llaika_config_Versions(obj) {
  return (((obj instanceof $c_Llaika_config_Versions) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.Versions"));
}
function $isArrayOf_Llaika_config_Versions(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_Versions)));
}
function $asArrayOf_Llaika_config_Versions(obj, depth) {
  return (($isArrayOf_Llaika_config_Versions(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.Versions;", depth));
}
/** @constructor */
function $c_Llaika_internal_collection_Stack() {
  this.Llaika_internal_collection_Stack__f_underlying = null;
  this.Llaika_internal_collection_Stack__f_underlying = $m_sci_Nil$();
}
$c_Llaika_internal_collection_Stack.prototype = new $h_O();
$c_Llaika_internal_collection_Stack.prototype.constructor = $c_Llaika_internal_collection_Stack;
/** @constructor */
function $h_Llaika_internal_collection_Stack() {
}
$h_Llaika_internal_collection_Stack.prototype = $c_Llaika_internal_collection_Stack.prototype;
$c_Llaika_internal_collection_Stack.prototype.nonEmpty__Z = (function() {
  var this$1 = $n(this.Llaika_internal_collection_Stack__f_underlying);
  return (!this$1.isEmpty__Z());
});
$c_Llaika_internal_collection_Stack.prototype.top__O = (function() {
  return $n(this.Llaika_internal_collection_Stack__f_underlying).head__O();
});
$c_Llaika_internal_collection_Stack.prototype.pop__O = (function() {
  var elem = $n(this.Llaika_internal_collection_Stack__f_underlying).head__O();
  this.Llaika_internal_collection_Stack__f_underlying = $as_sci_List($n(this.Llaika_internal_collection_Stack__f_underlying).tail__O());
  return elem;
});
$c_Llaika_internal_collection_Stack.prototype.push__O__V = (function(elem) {
  var this$1 = $n(this.Llaika_internal_collection_Stack__f_underlying);
  this.Llaika_internal_collection_Stack__f_underlying = this$1.prepended__O__sci_List(elem);
});
var $d_Llaika_internal_collection_Stack = new $TypeData().initClass($c_Llaika_internal_collection_Stack, "laika.internal.collection.Stack", ({
  Llaika_internal_collection_Stack: 1
}));
/** @constructor */
function $c_Llaika_internal_collection_TransitionalCollectionOps$TransitionalMapOps$() {
}
$c_Llaika_internal_collection_TransitionalCollectionOps$TransitionalMapOps$.prototype = new $h_O();
$c_Llaika_internal_collection_TransitionalCollectionOps$TransitionalMapOps$.prototype.constructor = $c_Llaika_internal_collection_TransitionalCollectionOps$TransitionalMapOps$;
/** @constructor */
function $h_Llaika_internal_collection_TransitionalCollectionOps$TransitionalMapOps$() {
}
$h_Llaika_internal_collection_TransitionalCollectionOps$TransitionalMapOps$.prototype = $c_Llaika_internal_collection_TransitionalCollectionOps$TransitionalMapOps$.prototype;
$c_Llaika_internal_collection_TransitionalCollectionOps$TransitionalMapOps$.prototype.mapValuesStrict$extension__sci_Map__F1__sci_Map = (function(this$, f) {
  return $as_sci_Map($n(this$).map__F1__sc_IterableOps(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var k = $n(x$1$1)._1__O();
      var v = $n(x$1$1)._2__O();
      var _2 = $n(f).apply__O__O(v);
      return new $c_T2(k, _2);
    }
    throw new $c_s_MatchError(x$1$1);
  }))));
});
var $d_Llaika_internal_collection_TransitionalCollectionOps$TransitionalMapOps$ = new $TypeData().initClass($c_Llaika_internal_collection_TransitionalCollectionOps$TransitionalMapOps$, "laika.internal.collection.TransitionalCollectionOps$TransitionalMapOps$", ({
  Llaika_internal_collection_TransitionalCollectionOps$TransitionalMapOps$: 1
}));
var $n_Llaika_internal_collection_TransitionalCollectionOps$TransitionalMapOps$;
function $m_Llaika_internal_collection_TransitionalCollectionOps$TransitionalMapOps$() {
  if ((!$n_Llaika_internal_collection_TransitionalCollectionOps$TransitionalMapOps$)) {
    $n_Llaika_internal_collection_TransitionalCollectionOps$TransitionalMapOps$ = new $c_Llaika_internal_collection_TransitionalCollectionOps$TransitionalMapOps$();
  }
  return $n_Llaika_internal_collection_TransitionalCollectionOps$TransitionalMapOps$;
}
/** @constructor */
function $c_Llaika_internal_directive_BreadcrumbDirectives$() {
  this.Llaika_internal_directive_BreadcrumbDirectives$__f_forTemplates$lzy1 = null;
  this.Llaika_internal_directive_BreadcrumbDirectives$__f_forTemplatesbitmap$1 = false;
  this.Llaika_internal_directive_BreadcrumbDirectives$__f_forBlocks$lzy1 = null;
  this.Llaika_internal_directive_BreadcrumbDirectives$__f_forBlocksbitmap$1 = false;
}
$c_Llaika_internal_directive_BreadcrumbDirectives$.prototype = new $h_O();
$c_Llaika_internal_directive_BreadcrumbDirectives$.prototype.constructor = $c_Llaika_internal_directive_BreadcrumbDirectives$;
/** @constructor */
function $h_Llaika_internal_directive_BreadcrumbDirectives$() {
}
$h_Llaika_internal_directive_BreadcrumbDirectives$.prototype = $c_Llaika_internal_directive_BreadcrumbDirectives$.prototype;
$c_Llaika_internal_directive_BreadcrumbDirectives$.prototype.forTemplates__Llaika_api_bundle_DirectiveBuilderContext$Directive = (function() {
  if ((!this.Llaika_internal_directive_BreadcrumbDirectives$__f_forTemplatesbitmap$1)) {
    var this$11 = $m_Llaika_api_bundle_TemplateDirectives$();
    var this$1 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12(this$1);
    var this$2 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _2 = $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__source__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$2);
    var t2 = new $c_T2(_1, _2);
    var part = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(new $c_Lcats_syntax_Tuple2SemigroupalOps(t2).mapN__F2__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction2(((x$1, x$2) => {
      var x$1$1 = $as_Llaika_ast_DocumentCursor(x$1);
      var x$2$1 = $as_Llaika_parse_SourceFragment(x$2);
      var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      var element = $as_Llaika_ast_Element(new $c_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder(x$2$1, options).resolve__Llaika_ast_DocumentCursor__Llaika_ast_Block(x$1$1));
      var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      return new $c_Llaika_ast_TemplateElement(element, 0, options$1);
    })), $n($m_Llaika_api_bundle_TemplateDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances, $as_Lcats_Semigroupal($n($m_Llaika_api_bundle_TemplateDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances)));
    this.Llaika_internal_directive_BreadcrumbDirectives$__f_forTemplates$lzy1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$Directive(this$11, "breadcrumb", part);
    this.Llaika_internal_directive_BreadcrumbDirectives$__f_forTemplatesbitmap$1 = true;
  }
  return this.Llaika_internal_directive_BreadcrumbDirectives$__f_forTemplates$lzy1;
});
$c_Llaika_internal_directive_BreadcrumbDirectives$.prototype.forBlocks__Llaika_api_bundle_DirectiveBuilderContext$Directive = (function() {
  if ((!this.Llaika_internal_directive_BreadcrumbDirectives$__f_forBlocksbitmap$1)) {
    var this$9 = $m_Llaika_api_bundle_BlockDirectives$();
    var this$1 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12(this$1);
    var this$2 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _2 = $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__source__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$2);
    var t2 = new $c_T2(_1, _2);
    var part = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(new $c_Lcats_syntax_Tuple2SemigroupalOps(t2).mapN__F2__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction2(((x$1, x$2) => {
      var x$1$1 = $as_Llaika_ast_DocumentCursor(x$1);
      var x$2$1 = $as_Llaika_parse_SourceFragment(x$2);
      var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      return new $c_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder(x$2$1, options).resolve__Llaika_ast_DocumentCursor__Llaika_ast_Block(x$1$1);
    })), $n($m_Llaika_api_bundle_BlockDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances, $as_Lcats_Semigroupal($n($m_Llaika_api_bundle_BlockDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances)));
    this.Llaika_internal_directive_BreadcrumbDirectives$__f_forBlocks$lzy1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$Directive(this$9, "breadcrumb", part);
    this.Llaika_internal_directive_BreadcrumbDirectives$__f_forBlocksbitmap$1 = true;
  }
  return this.Llaika_internal_directive_BreadcrumbDirectives$__f_forBlocks$lzy1;
});
var $d_Llaika_internal_directive_BreadcrumbDirectives$ = new $TypeData().initClass($c_Llaika_internal_directive_BreadcrumbDirectives$, "laika.internal.directive.BreadcrumbDirectives$", ({
  Llaika_internal_directive_BreadcrumbDirectives$: 1
}));
var $n_Llaika_internal_directive_BreadcrumbDirectives$;
function $m_Llaika_internal_directive_BreadcrumbDirectives$() {
  if ((!$n_Llaika_internal_directive_BreadcrumbDirectives$)) {
    $n_Llaika_internal_directive_BreadcrumbDirectives$ = new $c_Llaika_internal_directive_BreadcrumbDirectives$();
  }
  return $n_Llaika_internal_directive_BreadcrumbDirectives$;
}
function $p_Llaika_internal_directive_ControlFlowDirectives$__Empty$lzyINIT1$1__sr_LazyRef__Llaika_internal_directive_ControlFlowDirectives$Empty$3$($thiz, Empty$lzy1$1) {
  if ((Empty$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Llaika_internal_directive_ControlFlowDirectives$Empty$3$(($n(Empty$lzy1$1).sr_LazyRef__f__initialized ? $n(Empty$lzy1$1).sr_LazyRef__f__value : $n(Empty$lzy1$1).initialize__O__O(new $c_Llaika_internal_directive_ControlFlowDirectives$Empty$3$())));
}
function $p_Llaika_internal_directive_ControlFlowDirectives$__Empty$2__sr_LazyRef__Llaika_internal_directive_ControlFlowDirectives$Empty$3$($thiz, Empty$lzy1$2) {
  return $as_Llaika_internal_directive_ControlFlowDirectives$Empty$3$(($n(Empty$lzy1$2).sr_LazyRef__f__initialized ? $n(Empty$lzy1$2).sr_LazyRef__f__value : $p_Llaika_internal_directive_ControlFlowDirectives$__Empty$lzyINIT1$1__sr_LazyRef__Llaika_internal_directive_ControlFlowDirectives$Empty$3$($thiz, Empty$lzy1$2)));
}
function $p_Llaika_internal_directive_ControlFlowDirectives$__contentScope$1__Llaika_api_bundle_DirectiveBuilderContext$Multipart__Llaika_parse_SourceFragment__Llaika_api_config_ConfigValue__Llaika_ast_TemplateSpan($thiz, multipart$1, source$1, value) {
  var content = $n(multipart$1).Llaika_api_bundle_DirectiveBuilderContext$Multipart__f_mainBody;
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  var content$1 = new $c_Llaika_ast_TemplateSpanSequence(content, options);
  var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  return new $c_Llaika_ast_TemplateScope(content$1, value, source$1, options$1);
}
function $p_Llaika_internal_directive_ControlFlowDirectives$__fallback$1__Llaika_api_bundle_DirectiveBuilderContext$Multipart__Llaika_ast_TemplateSpanSequence($thiz, multipart$2) {
  var this$1 = $n($n($n(multipart$2).Llaika_api_bundle_DirectiveBuilderContext$Multipart__f_children).headOption__s_Option());
  if (this$1.isEmpty__Z()) {
    var $x_1 = $m_s_None$();
  } else {
    var arg1 = this$1.get__O();
    var e = $as_Llaika_internal_directive_ControlFlowDirectives$Empty$1(arg1);
    var content = $n(e).Llaika_internal_directive_ControlFlowDirectives$Empty$1__f_spans;
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var $x_1 = new $c_s_Some(new $c_Llaika_ast_TemplateSpanSequence(content, options));
  }
  var this$4 = $n($x_1);
  if (this$4.isEmpty__Z()) {
    var spans = $m_sci_Nil$();
    var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var $x_2 = new $c_Llaika_ast_TemplateSpanSequence(spans, options$1);
  } else {
    var $x_2 = this$4.get__O();
  }
  return $as_Llaika_ast_TemplateSpanSequence($x_2);
}
function $p_Llaika_internal_directive_ControlFlowDirectives$__ElseIf$lzyINIT1$1__sr_LazyRef__Llaika_internal_directive_ControlFlowDirectives$ElseIf$3$($thiz, ElseIf$lzy1$1) {
  if ((ElseIf$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Llaika_internal_directive_ControlFlowDirectives$ElseIf$3$(($n(ElseIf$lzy1$1).sr_LazyRef__f__initialized ? $n(ElseIf$lzy1$1).sr_LazyRef__f__value : $n(ElseIf$lzy1$1).initialize__O__O(new $c_Llaika_internal_directive_ControlFlowDirectives$ElseIf$3$())));
}
function $p_Llaika_internal_directive_ControlFlowDirectives$__ElseIf$2__sr_LazyRef__Llaika_internal_directive_ControlFlowDirectives$ElseIf$3$($thiz, ElseIf$lzy1$2) {
  return $as_Llaika_internal_directive_ControlFlowDirectives$ElseIf$3$(($n(ElseIf$lzy1$2).sr_LazyRef__f__initialized ? $n(ElseIf$lzy1$2).sr_LazyRef__f__value : $p_Llaika_internal_directive_ControlFlowDirectives$__ElseIf$lzyINIT1$1__sr_LazyRef__Llaika_internal_directive_ControlFlowDirectives$ElseIf$3$($thiz, ElseIf$lzy1$2)));
}
function $p_Llaika_internal_directive_ControlFlowDirectives$__Else$lzyINIT1$1__sr_LazyRef__Llaika_internal_directive_ControlFlowDirectives$Else$3$($thiz, Else$lzy1$1) {
  if ((Else$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Llaika_internal_directive_ControlFlowDirectives$Else$3$(($n(Else$lzy1$1).sr_LazyRef__f__initialized ? $n(Else$lzy1$1).sr_LazyRef__f__value : $n(Else$lzy1$1).initialize__O__O(new $c_Llaika_internal_directive_ControlFlowDirectives$Else$3$())));
}
function $p_Llaika_internal_directive_ControlFlowDirectives$__Else$2__sr_LazyRef__Llaika_internal_directive_ControlFlowDirectives$Else$3$($thiz, Else$lzy1$2) {
  return $as_Llaika_internal_directive_ControlFlowDirectives$Else$3$(($n(Else$lzy1$2).sr_LazyRef__f__initialized ? $n(Else$lzy1$2).sr_LazyRef__f__value : $p_Llaika_internal_directive_ControlFlowDirectives$__Else$lzyINIT1$1__sr_LazyRef__Llaika_internal_directive_ControlFlowDirectives$Else$3$($thiz, Else$lzy1$2)));
}
function $p_Llaika_internal_directive_ControlFlowDirectives$__fallback$2__Llaika_api_bundle_DirectiveBuilderContext$Multipart__Llaika_ast_TemplateSpanSequence($thiz, multipart$3) {
  var this$1 = $n($n($n(multipart$3).Llaika_api_bundle_DirectiveBuilderContext$Multipart__f_children).collectFirst__s_PartialFunction__s_Option(new $c_Llaika_internal_directive_ControlFlowDirectives$$anon$1()));
  if (this$1.isEmpty__Z()) {
    var $x_1 = $m_s_None$();
  } else {
    var arg1 = this$1.get__O();
    var e = $as_Llaika_internal_directive_ControlFlowDirectives$Else$1(arg1);
    var content = $n(e).Llaika_internal_directive_ControlFlowDirectives$Else$1__f_body;
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var $x_1 = new $c_s_Some(new $c_Llaika_ast_TemplateSpanSequence(content, options));
  }
  var this$4 = $n($x_1);
  if (this$4.isEmpty__Z()) {
    var spans = $m_sci_Nil$();
    var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var $x_2 = new $c_Llaika_ast_TemplateSpanSequence(spans, options$1);
  } else {
    var $x_2 = this$4.get__O();
  }
  return $as_Llaika_ast_TemplateSpanSequence($x_2);
}
function $p_Llaika_internal_directive_ControlFlowDirectives$__process$1__Llaika_ast_DocumentCursor__sci_Set__Llaika_api_bundle_DirectiveBuilderContext$Multipart__sci_Seq__Llaika_ast_TemplateSpan($thiz, cursor$1, trueStrings$1, multipart$4, parts) {
  var parts$tailLocal1 = parts;
  while (true) {
    if ($n(parts$tailLocal1).isEmpty__Z()) {
      return $p_Llaika_internal_directive_ControlFlowDirectives$__fallback$2__Llaika_api_bundle_DirectiveBuilderContext$Multipart__Llaika_ast_TemplateSpanSequence($thiz, multipart$4);
    } else {
      var x45 = $n(cursor$1).resolveReference__Llaika_api_config_Key__s_util_Either($m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key($n($as_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1($n(parts$tailLocal1).head__O())).Llaika_internal_directive_ControlFlowDirectives$ElseIf$1__f_ref));
      if ((x45 instanceof $c_s_util_Right)) {
        var x59 = $as_s_Option($n($as_s_util_Right(x45)).s_util_Right__f_value);
        if ((x59 instanceof $c_s_Some)) {
          var x61 = $as_Llaika_api_config_ConfigValue($n($as_s_Some(x59)).s_Some__f_value);
          if ((x61 instanceof $c_Llaika_api_config_ConfigValue$BooleanValue)) {
            var x$1 = $as_Llaika_api_config_ConfigValue$BooleanValue(x61);
            var this$2 = $n(x$1);
            var x64 = this$2.Llaika_api_config_ConfigValue$BooleanValue__f_value;
            if ((x64 === true)) {
              var content = $n($as_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1($n(parts$tailLocal1).head__O())).Llaika_internal_directive_ControlFlowDirectives$ElseIf$1__f_body;
              var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
              return new $c_Llaika_ast_TemplateSpanSequence(content, options);
            }
          }
          if ((x61 instanceof $c_Llaika_api_config_ConfigValue$StringValue)) {
            var x$1$1 = $as_Llaika_api_config_ConfigValue$StringValue(x61);
            var this$6 = $n(x$1$1);
            var x57 = this$6.Llaika_api_config_ConfigValue$StringValue__f_value;
            var this$7 = $n(trueStrings$1);
            if (this$7.contains__O__Z(x57)) {
              var content$1 = $n($as_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1($n(parts$tailLocal1).head__O())).Llaika_internal_directive_ControlFlowDirectives$ElseIf$1__f_body;
              var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
              return new $c_Llaika_ast_TemplateSpanSequence(content$1, options$1);
            }
          }
          if ((x61 instanceof $c_Llaika_api_config_ConfigValue$ArrayValue)) {
            var a = $as_Llaika_api_config_ConfigValue$ArrayValue(x61);
            var this$10 = $n(a);
            if ((!$n(this$10.Llaika_api_config_ConfigValue$ArrayValue__f_values).isEmpty__Z())) {
              var content$2 = $n($as_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1($n(parts$tailLocal1).head__O())).Llaika_internal_directive_ControlFlowDirectives$ElseIf$1__f_body;
              var options$2 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
              return new $c_Llaika_ast_TemplateSpanSequence(content$2, options$2);
            }
          }
        }
      }
      parts$tailLocal1 = $as_sci_Seq($n(parts$tailLocal1).tail__O());
    }
  }
}
/** @constructor */
function $c_Llaika_internal_directive_ControlFlowDirectives$() {
  this.Llaika_internal_directive_ControlFlowDirectives$__f_templateFor$lzy1 = null;
  this.Llaika_internal_directive_ControlFlowDirectives$__f_templateForbitmap$1 = false;
  this.Llaika_internal_directive_ControlFlowDirectives$__f_templateIf$lzy1 = null;
  this.Llaika_internal_directive_ControlFlowDirectives$__f_templateIfbitmap$1 = false;
}
$c_Llaika_internal_directive_ControlFlowDirectives$.prototype = new $h_O();
$c_Llaika_internal_directive_ControlFlowDirectives$.prototype.constructor = $c_Llaika_internal_directive_ControlFlowDirectives$;
/** @constructor */
function $h_Llaika_internal_directive_ControlFlowDirectives$() {
}
$h_Llaika_internal_directive_ControlFlowDirectives$.prototype = $c_Llaika_internal_directive_ControlFlowDirectives$.prototype;
$c_Llaika_internal_directive_ControlFlowDirectives$.prototype.templateFor__Llaika_api_bundle_DirectiveBuilderContext$Directive = (function() {
  if ((!this.Llaika_internal_directive_ControlFlowDirectives$__f_templateForbitmap$1)) {
    var this$22 = $m_Llaika_api_bundle_TemplateDirectives$();
    var Empty$lzy1 = new $c_sr_LazyRef();
    var this$3 = $m_sci_Set$();
    var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_config_ConfigValue.getArrayOf().constr)([new $c_Llaika_api_config_ConfigValue$StringValue(""), new $c_Llaika_api_config_ConfigValue$BooleanValue(false), $m_Llaika_api_config_ConfigValue$NullValue$()]));
    var emptyValues = this$3.from__sc_IterableOnce__sci_Set(elems);
    var this$9 = $m_Llaika_api_bundle_TemplateDirectives$();
    var this$5 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var this$8 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__parsedBody__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$5));
    var Empty$lzy1$2$1 = Empty$lzy1;
    var f = new $c_sjsr_AnonFunction1(((Empty$lzy1$2) => ((spans) => {
      var spans$1 = $as_sci_Seq(spans);
      $n($p_Llaika_internal_directive_ControlFlowDirectives$__Empty$2__sr_LazyRef__Llaika_internal_directive_ControlFlowDirectives$Empty$3$(this, Empty$lzy1$2));
      return new $c_Llaika_internal_directive_ControlFlowDirectives$Empty$1($m_Llaika_internal_directive_ControlFlowDirectives$(), spans$1);
    }))(Empty$lzy1$2$1));
    var part = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$2(f, this$8);
    var emptySeparator = new $c_Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective(this$9, "empty", part, 0, 1);
    var this$10 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _1 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$10, 0)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string);
    var this$11 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var separators = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective.getArrayOf().constr)([emptySeparator]))));
    var _2 = new $c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart(this$11, separators);
    var this$12 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _3 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12(this$12);
    var this$13 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _4 = $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__source__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$13);
    var t4 = new $c_T4(_1, _2, _3, _4);
    var part$1 = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(new $c_Lcats_syntax_Tuple4SemigroupalOps(t4).mapN__F4__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction4(((ref, multipart, cursor, source) => {
      var ref$1 = $as_T(ref);
      var multipart$1 = $as_Llaika_api_bundle_DirectiveBuilderContext$Multipart(multipart);
      var cursor$1 = $as_Llaika_ast_DocumentCursor(cursor);
      var source$1 = $as_Llaika_parse_SourceFragment(source);
      var x5 = $n(cursor$1).resolveReference__Llaika_api_config_Key__s_util_Either($m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key(ref$1));
      if ((x5 instanceof $c_s_util_Right)) {
        var x29 = $as_s_Option($n($as_s_util_Right(x5)).s_util_Right__f_value);
        if ((x29 instanceof $c_s_Some)) {
          var x31 = $as_Llaika_api_config_ConfigValue($n($as_s_Some(x29)).s_Some__f_value);
          if ((x31 instanceof $c_Llaika_api_config_ConfigValue$ObjectValue)) {
            var o = $as_Llaika_api_config_ConfigValue$ObjectValue(x31);
            return $p_Llaika_internal_directive_ControlFlowDirectives$__contentScope$1__Llaika_api_bundle_DirectiveBuilderContext$Multipart__Llaika_parse_SourceFragment__Llaika_api_config_ConfigValue__Llaika_ast_TemplateSpan(this, multipart$1, source$1, o);
          }
          if ((x31 instanceof $c_Llaika_api_config_ConfigValue$ArrayValue)) {
            var x27 = $as_Llaika_api_config_ConfigValue$ArrayValue(x31);
            var this$16 = $n(x27);
            if ($n(this$16.Llaika_api_config_ConfigValue$ArrayValue__f_values).isEmpty__Z()) {
              return $p_Llaika_internal_directive_ControlFlowDirectives$__fallback$1__Llaika_api_bundle_DirectiveBuilderContext$Multipart__Llaika_ast_TemplateSpanSequence(this, multipart$1);
            }
            var content = $as_sci_Seq($n($n(x27).Llaika_api_config_ConfigValue$ArrayValue__f_values).map__F1__O(new $c_sjsr_AnonFunction1(((value) => {
              var value$1 = $as_Llaika_api_config_ConfigValue(value);
              return $p_Llaika_internal_directive_ControlFlowDirectives$__contentScope$1__Llaika_api_bundle_DirectiveBuilderContext$Multipart__Llaika_parse_SourceFragment__Llaika_api_config_ConfigValue__Llaika_ast_TemplateSpan(this, multipart$1, source$1, value$1);
            }))));
            var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
            return new $c_Llaika_ast_TemplateSpanSequence(content, options);
          }
          var this$19 = $n(emptyValues);
          if (this$19.contains__O__Z(x31)) {
            return $p_Llaika_internal_directive_ControlFlowDirectives$__fallback$1__Llaika_api_bundle_DirectiveBuilderContext$Multipart__Llaika_ast_TemplateSpanSequence(this, multipart$1);
          }
          return $p_Llaika_internal_directive_ControlFlowDirectives$__contentScope$1__Llaika_api_bundle_DirectiveBuilderContext$Multipart__Llaika_parse_SourceFragment__Llaika_api_config_ConfigValue__Llaika_ast_TemplateSpan(this, multipart$1, source$1, x31);
        }
        var x = $m_s_None$();
        if ((x === x29)) {
          return $p_Llaika_internal_directive_ControlFlowDirectives$__fallback$1__Llaika_api_bundle_DirectiveBuilderContext$Multipart__Llaika_ast_TemplateSpanSequence(this, multipart$1);
        }
      }
      if ((x5 instanceof $c_s_util_Left)) {
        var error = $as_Llaika_api_config_ConfigError($n($as_s_util_Left(x5)).s_util_Left__f_value);
        var element = $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan(((("Error retrieving reference '" + ref$1) + "': ") + $n(error).message__T()), source$1);
        var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
        return new $c_Llaika_ast_TemplateElement(element, 0, options$1);
      }
      throw new $c_s_MatchError(x5);
    })), $n($m_Llaika_api_bundle_TemplateDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances, $as_Lcats_Semigroupal($n($m_Llaika_api_bundle_TemplateDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances)));
    this.Llaika_internal_directive_ControlFlowDirectives$__f_templateFor$lzy1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$Directive(this$22, "for", part$1);
    this.Llaika_internal_directive_ControlFlowDirectives$__f_templateForbitmap$1 = true;
  }
  return this.Llaika_internal_directive_ControlFlowDirectives$__f_templateFor$lzy1;
});
$c_Llaika_internal_directive_ControlFlowDirectives$.prototype.templateIf__Llaika_api_bundle_DirectiveBuilderContext$Directive = (function() {
  if ((!this.Llaika_internal_directive_ControlFlowDirectives$__f_templateIfbitmap$1)) {
    var this$24 = $m_Llaika_api_bundle_TemplateDirectives$();
    var ElseIf$lzy1 = new $c_sr_LazyRef();
    var Else$lzy1 = new $c_sr_LazyRef();
    var this$1 = $m_sci_Set$();
    var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["true", "yes", "on", "enabled"]));
    var trueStrings = this$1.from__sc_IterableOnce__sci_Set(elems);
    var this$10 = $m_Llaika_api_bundle_TemplateDirectives$();
    var this$4 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _1 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$4, 0)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string);
    var this$5 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _2 = $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__parsedBody__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$5);
    var t2 = new $c_T2(_1, _2);
    var $x_1 = new $c_Lcats_syntax_Tuple2SemigroupalOps(t2);
    var ElseIf$lzy1$2$1 = ElseIf$lzy1;
    var part = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart($x_1.mapN__F2__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction2(((ElseIf$lzy1$2) => ((ref, body) => {
      var ref$1 = $as_T(ref);
      var body$1 = $as_sci_Seq(body);
      $n($p_Llaika_internal_directive_ControlFlowDirectives$__ElseIf$2__sr_LazyRef__Llaika_internal_directive_ControlFlowDirectives$ElseIf$3$(this, ElseIf$lzy1$2));
      return new $c_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1($m_Llaika_internal_directive_ControlFlowDirectives$(), ref$1, body$1);
    }))(ElseIf$lzy1$2$1)), $n($m_Llaika_api_bundle_TemplateDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances, $as_Lcats_Semigroupal($n($m_Llaika_api_bundle_TemplateDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances)));
    var elseIfSep = new $c_Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective(this$10, "elseIf", part, 0, 2147483647);
    var this$15 = $m_Llaika_api_bundle_TemplateDirectives$();
    var this$12 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var this$14 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__parsedBody__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$12));
    var Else$lzy1$2$1 = Else$lzy1;
    var f = new $c_sjsr_AnonFunction1(((Else$lzy1$2) => ((body$2) => {
      var body$3 = $as_sci_Seq(body$2);
      $n($p_Llaika_internal_directive_ControlFlowDirectives$__Else$2__sr_LazyRef__Llaika_internal_directive_ControlFlowDirectives$Else$3$(this, Else$lzy1$2));
      return new $c_Llaika_internal_directive_ControlFlowDirectives$Else$1($m_Llaika_internal_directive_ControlFlowDirectives$(), body$3);
    }))(Else$lzy1$2$1));
    var part$1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$2(f, this$14);
    var elseSep = new $c_Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective(this$15, "else", part$1, 0, 1);
    var this$16 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var separators = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective.getArrayOf().constr)([elseIfSep, elseSep]))));
    var multipartBody = new $c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart(this$16, separators);
    var this$17 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _1$1 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$17, 0)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string);
    var this$18 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _3 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12(this$18);
    var t3 = new $c_T3(_1$1, multipartBody, _3);
    var $x_2 = new $c_Lcats_syntax_Tuple3SemigroupalOps(t3);
    var ElseIf$lzy1$3$1 = ElseIf$lzy1;
    var part$2 = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart($x_2.mapN__F3__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction3(((ElseIf$lzy1$3) => ((path, multipart, cursor) => {
      var path$1 = $as_T(path);
      var multipart$1 = $as_Llaika_api_bundle_DirectiveBuilderContext$Multipart(multipart);
      var cursor$1 = $as_Llaika_ast_DocumentCursor(cursor);
      $n($p_Llaika_internal_directive_ControlFlowDirectives$__ElseIf$2__sr_LazyRef__Llaika_internal_directive_ControlFlowDirectives$ElseIf$3$(this, ElseIf$lzy1$3));
      var body$4 = $n(multipart$1).Llaika_api_bundle_DirectiveBuilderContext$Multipart__f_mainBody;
      var elem$1 = new $c_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1($m_Llaika_internal_directive_ControlFlowDirectives$(), path$1, body$4);
      var this$23 = $n($n(multipart$1).collect__s_reflect_ClassTag__sci_Seq(new $c_s_reflect_ClassTag$GenericClassTag($d_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1.getClassOf())));
      var alternatives = $as_sci_Seq(this$23.prepended__O__O(elem$1));
      return $p_Llaika_internal_directive_ControlFlowDirectives$__process$1__Llaika_ast_DocumentCursor__sci_Set__Llaika_api_bundle_DirectiveBuilderContext$Multipart__sci_Seq__Llaika_ast_TemplateSpan(this, cursor$1, trueStrings, multipart$1, alternatives);
    }))(ElseIf$lzy1$3$1)), $n($m_Llaika_api_bundle_TemplateDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances, $as_Lcats_Semigroupal($n($m_Llaika_api_bundle_TemplateDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances)));
    this.Llaika_internal_directive_ControlFlowDirectives$__f_templateIf$lzy1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$Directive(this$24, "if", part$2);
    this.Llaika_internal_directive_ControlFlowDirectives$__f_templateIfbitmap$1 = true;
  }
  return this.Llaika_internal_directive_ControlFlowDirectives$__f_templateIf$lzy1;
});
var $d_Llaika_internal_directive_ControlFlowDirectives$ = new $TypeData().initClass($c_Llaika_internal_directive_ControlFlowDirectives$, "laika.internal.directive.ControlFlowDirectives$", ({
  Llaika_internal_directive_ControlFlowDirectives$: 1
}));
var $n_Llaika_internal_directive_ControlFlowDirectives$;
function $m_Llaika_internal_directive_ControlFlowDirectives$() {
  if ((!$n_Llaika_internal_directive_ControlFlowDirectives$)) {
    $n_Llaika_internal_directive_ControlFlowDirectives$ = new $c_Llaika_internal_directive_ControlFlowDirectives$();
  }
  return $n_Llaika_internal_directive_ControlFlowDirectives$;
}
/** @constructor */
function $c_Llaika_internal_directive_ImageDirectives$() {
  this.Llaika_internal_directive_ImageDirectives$__f_forBlocks = null;
  this.Llaika_internal_directive_ImageDirectives$__f_forSpans = null;
  $n_Llaika_internal_directive_ImageDirectives$ = this;
  var this$27 = $m_Llaika_api_bundle_BlockDirectives$();
  var this$1 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
  var _1 = $n($n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$1, 0)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string));
  var this$2 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
  var this$3 = $n($n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__T__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$2, "intrinsicWidth")).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_double));
  var _2 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$7(this$3);
  var this$4 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
  var this$5 = $n($n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__T__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$4, "intrinsicHeight")).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_double));
  var _3 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$7(this$5);
  var this$6 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
  var this$7 = $n($n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__T__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$6, "style")).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string));
  var _4 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$7(this$7);
  var this$8 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
  var this$9 = $n($n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__T__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$8, "alt")).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string));
  var _5 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$7(this$9);
  var this$10 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
  var this$11 = $n($n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__T__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$10, "title")).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string));
  var _6 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$7(this$11);
  var this$12 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
  var _7 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12(this$12);
  var t7 = new $c_T7(_1, _2, _3, _4, _5, _6, _7);
  var part = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(new $c_Lcats_syntax_Tuple7SemigroupalOps(t7).mapN__F7__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction7(((src, width, height, style, alt, title, cursor) => {
    var src$1 = $as_T(src);
    var width$1 = $as_s_Option(width);
    var height$1 = $as_s_Option(height);
    var style$1 = $as_s_Option(style);
    var alt$1 = $as_s_Option(alt);
    var title$1 = $as_s_Option(title);
    var cursor$1 = $as_Llaika_ast_DocumentCursor(cursor);
    var target = $n($m_Llaika_ast_InternalTarget$().apply__Llaika_ast_VirtualPath__Llaika_ast_InternalTarget($m_Llaika_ast_VirtualPath$().parse__T__Llaika_ast_VirtualPath(src$1))).relativeTo__Llaika_ast_Path__Llaika_ast_InternalTarget$Resolved($n(cursor$1).Llaika_ast_DocumentCursor__f_path);
    var this$16 = $n(width$1);
    if (this$16.isEmpty__Z()) {
      var width$2 = $m_s_None$();
    } else {
      var arg1 = this$16.get__O();
      var _$1 = $uD(arg1);
      var this$17 = $m_Llaika_ast_LengthUnit$px$();
      var width$2 = new $c_s_Some(new $c_Llaika_ast_Length(_$1, this$17));
    }
    var this$19 = $n(height$1);
    if (this$19.isEmpty__Z()) {
      var height$2 = $m_s_None$();
    } else {
      var arg1$1 = this$19.get__O();
      var _$2 = $uD(arg1$1);
      var this$20 = $m_Llaika_ast_LengthUnit$px$();
      var height$2 = new $c_s_Some(new $c_Llaika_ast_Length(_$2, this$20));
    }
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var img = new $c_Llaika_ast_Image(target, width$2, height$2, alt$1, title$1, options);
    var $x_2 = $m_Llaika_ast_Styles$();
    var $x_1 = $m_sr_ScalaRunTime$();
    var this$24 = $n(style$1);
    var options$1 = $n($x_2).apply__sci_Seq__Llaika_ast_Options($n($x_1).wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([$as_T((this$24.isEmpty__Z() ? "default-image-block" : this$24.get__O()))])));
    var $x_4 = $m_sci_Seq$();
    var $x_3 = $m_sr_ScalaRunTime$();
    var this$25 = $m_Llaika_ast_SpanSequence$();
    var spans = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Span.getArrayOf().constr)([]));
    var content = $as_sci_Seq($n($x_4).apply__sci_Seq__sc_SeqOps($n($x_3).wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_SpanSequence.getArrayOf().constr)([$as_Llaika_ast_SpanSequence($f_Llaika_ast_SpanContainerCompanion__apply__Llaika_ast_Span__sci_Seq__O(this$25, img, spans))]))));
    return new $c_Llaika_ast_BlockSequence(content, options$1);
  })), $n($m_Llaika_api_bundle_BlockDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances, $as_Lcats_Semigroupal($n($m_Llaika_api_bundle_BlockDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances)));
  this.Llaika_internal_directive_ImageDirectives$__f_forBlocks = new $c_Llaika_api_bundle_DirectiveBuilderContext$Directive(this$27, "image", part);
  var this$50 = $m_Llaika_api_bundle_SpanDirectives$();
  var this$28 = $n($m_Llaika_api_bundle_SpanDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
  var _1$1 = $n($n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$28, 0)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string));
  var this$29 = $n($m_Llaika_api_bundle_SpanDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
  var this$30 = $n($n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__T__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$29, "intrinsicWidth")).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_double));
  var _2$1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$7(this$30);
  var this$31 = $n($m_Llaika_api_bundle_SpanDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
  var this$32 = $n($n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__T__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$31, "intrinsicHeight")).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_double));
  var _3$1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$7(this$32);
  var this$33 = $n($m_Llaika_api_bundle_SpanDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
  var this$34 = $n($n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__T__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$33, "style")).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string));
  var _4$1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$7(this$34);
  var this$35 = $n($m_Llaika_api_bundle_SpanDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
  var this$36 = $n($n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__T__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$35, "alt")).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string));
  var _5$1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$7(this$36);
  var this$37 = $n($m_Llaika_api_bundle_SpanDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
  var this$38 = $n($n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__T__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$37, "title")).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string));
  var _6$1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$7(this$38);
  var this$39 = $n($m_Llaika_api_bundle_SpanDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
  var _7$1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12(this$39);
  var t7$1 = new $c_T7(_1$1, _2$1, _3$1, _4$1, _5$1, _6$1, _7$1);
  var part$1 = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(new $c_Lcats_syntax_Tuple7SemigroupalOps(t7$1).mapN__F7__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction7(((src$2, width$2$1, height$2$1, style$2, alt$2, title$2, cursor$2) => {
    var src$3 = $as_T(src$2);
    var width$3 = $as_s_Option(width$2$1);
    var height$3 = $as_s_Option(height$2$1);
    var style$3 = $as_s_Option(style$2);
    var alt$3 = $as_s_Option(alt$2);
    var title$3 = $as_s_Option(title$2);
    var cursor$3 = $as_Llaika_ast_DocumentCursor(cursor$2);
    var $x_6 = $m_Llaika_ast_Styles$();
    var $x_5 = $m_sr_ScalaRunTime$();
    var this$42 = $n(style$3);
    var options$2 = $n($x_6).apply__sci_Seq__Llaika_ast_Options($n($x_5).wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([$as_T((this$42.isEmpty__Z() ? "default-image-span" : this$42.get__O()))])));
    var target$1 = $n($m_Llaika_ast_InternalTarget$().apply__Llaika_ast_VirtualPath__Llaika_ast_InternalTarget($m_Llaika_ast_VirtualPath$().parse__T__Llaika_ast_VirtualPath(src$3))).relativeTo__Llaika_ast_Path__Llaika_ast_InternalTarget$Resolved($n(cursor$3).Llaika_ast_DocumentCursor__f_path);
    var this$43 = $n(width$3);
    if (this$43.isEmpty__Z()) {
      var width$4 = $m_s_None$();
    } else {
      var arg1$2 = this$43.get__O();
      var _$3 = $uD(arg1$2);
      var this$44 = $m_Llaika_ast_LengthUnit$px$();
      var width$4 = new $c_s_Some(new $c_Llaika_ast_Length(_$3, this$44));
    }
    var this$46 = $n(height$3);
    if (this$46.isEmpty__Z()) {
      var height$4 = $m_s_None$();
    } else {
      var arg1$3 = this$46.get__O();
      var _$4 = $uD(arg1$3);
      var this$47 = $m_Llaika_ast_LengthUnit$px$();
      var height$4 = new $c_s_Some(new $c_Llaika_ast_Length(_$4, this$47));
    }
    return new $c_Llaika_ast_Image(target$1, width$4, height$4, alt$3, title$3, options$2);
  })), $n($m_Llaika_api_bundle_SpanDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances, $as_Lcats_Semigroupal($n($m_Llaika_api_bundle_SpanDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances)));
  this.Llaika_internal_directive_ImageDirectives$__f_forSpans = new $c_Llaika_api_bundle_DirectiveBuilderContext$Directive(this$50, "image", part$1);
}
$c_Llaika_internal_directive_ImageDirectives$.prototype = new $h_O();
$c_Llaika_internal_directive_ImageDirectives$.prototype.constructor = $c_Llaika_internal_directive_ImageDirectives$;
/** @constructor */
function $h_Llaika_internal_directive_ImageDirectives$() {
}
$h_Llaika_internal_directive_ImageDirectives$.prototype = $c_Llaika_internal_directive_ImageDirectives$.prototype;
var $d_Llaika_internal_directive_ImageDirectives$ = new $TypeData().initClass($c_Llaika_internal_directive_ImageDirectives$, "laika.internal.directive.ImageDirectives$", ({
  Llaika_internal_directive_ImageDirectives$: 1
}));
var $n_Llaika_internal_directive_ImageDirectives$;
function $m_Llaika_internal_directive_ImageDirectives$() {
  if ((!$n_Llaika_internal_directive_ImageDirectives$)) {
    $n_Llaika_internal_directive_ImageDirectives$ = new $c_Llaika_internal_directive_ImageDirectives$();
  }
  return $n_Llaika_internal_directive_ImageDirectives$;
}
function $p_Llaika_internal_directive_IncludeDirectives$__config__Llaika_api_config_Config__s_Option__Llaika_ast_Path__Llaika_api_config_ConfigValue$ObjectValue($thiz, attributes, body, path) {
  if ((attributes instanceof $c_Llaika_api_config_ObjectConfig)) {
    var oc = $as_Llaika_api_config_ObjectConfig(attributes);
    var attributeValues = $n($n(oc).Llaika_api_config_ObjectConfig__f_root).Llaika_api_config_ConfigValue$ObjectValue__f_values;
  } else {
    var attributeValues = $m_sci_Nil$();
  }
  var this$1 = $n(body);
  if (this$1.isEmpty__Z()) {
    var bodyValue = $m_s_None$();
  } else {
    var arg1 = this$1.get__O();
    var b = $as_Llaika_ast_Element(arg1);
    var value = new $c_Llaika_api_config_ConfigValue$ASTValue(b);
    $m_Llaika_api_config_Origin$();
    var scope = $m_Llaika_api_config_Origin$DirectiveScope$();
    $m_Llaika_api_config_Origin$();
    var sourcePath = $m_s_None$();
    var origin = new $c_Llaika_api_config_Origin(scope, path, sourcePath);
    var bodyValue = new $c_s_Some(new $c_Llaika_api_config_Field("embeddedBody", value, origin));
  }
  var this$6 = $n(attributeValues);
  var suffix = $n($m_s_Option$().option2Iterable__s_Option__sc_Iterable(bodyValue)).toSeq__sci_Seq();
  var values = $as_sci_Seq(this$6.appendedAll__sc_IterableOnce__O(suffix));
  return new $c_Llaika_api_config_ConfigValue$ObjectValue(values);
}
function $p_Llaika_internal_directive_IncludeDirectives$__resolvePath__Llaika_ast_Path__T__Llaika_api_config_Config__s_util_Either($thiz, literalPath, pathConfigKey, config) {
  var this$1 = $n(config);
  if ($f_Llaika_api_config_Config__hasKey__T__Z(this$1, pathConfigKey)) {
    var this$2 = $n(config);
    var decoder = $m_Llaika_api_config_ConfigDecoder$().path__Llaika_api_config_ConfigDecoder();
    var eab = $f_Llaika_api_config_Config__get__T__Llaika_api_config_ConfigDecoder__s_util_Either(this$2, pathConfigKey, decoder);
    if ((eab instanceof $c_s_util_Left)) {
      var a = $n($as_s_util_Left(eab)).s_util_Left__f_value;
      var _$1 = $as_Llaika_api_config_ConfigError(a);
      var value = $n(_$1).message__T();
      return new $c_s_util_Left(value);
    }
    if ((eab instanceof $c_s_util_Right)) {
      var r = $as_s_util_Right(eab);
      $m_Lcats_syntax_EitherUtil$();
      return r;
    }
    throw new $c_s_MatchError(eab);
  } else {
    return new $c_s_util_Right(literalPath);
  }
}
function $p_Llaika_internal_directive_IncludeDirectives$__resolveTemplateReference__Llaika_ast_Path__Llaika_api_config_Config__Llaika_ast_DocumentCursor__Llaika_parse_SourceFragment__s_Option__s_util_Either($thiz, path, attributes, cursor, source, body) {
  var $x_1 = $n($n($n(cursor).root__Llaika_ast_RootCursor()).Llaika_ast_RootCursor__f_target).Llaika_ast_DocumentTreeRoot__f_tree;
  var this$1 = $n(path);
  var this$2 = $n($n($x_1).selectTemplate__Llaika_ast_RelativePath__s_Option(this$1.relativeTo__Llaika_ast_Path__Llaika_ast_RelativePath($m_Llaika_ast_Path$Root$())));
  if (this$2.isEmpty__Z()) {
    var $x_2 = $m_s_None$();
  } else {
    var arg1 = this$2.get__O();
    var doc = $as_Llaika_ast_TemplateDocument(arg1);
    var this$3 = $n(body);
    if (this$3.isEmpty__Z()) {
      var $x_3 = $m_s_None$();
    } else {
      var arg1$1 = this$3.get__O();
      var _$2 = $as_sci_Seq(arg1$1);
      var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      var $x_3 = new $c_s_Some(new $c_Llaika_ast_TemplateSpanSequence(_$2, options));
    }
    var this$6 = $n($n(cursor).Llaika_ast_DocumentCursor__f_templatePath);
    var context = $p_Llaika_internal_directive_IncludeDirectives$__config__Llaika_api_config_Config__s_Option__Llaika_ast_Path__Llaika_api_config_ConfigValue$ObjectValue($thiz, attributes, $x_3, $as_Llaika_ast_Path((this$6.isEmpty__Z() ? $n(cursor).Llaika_ast_DocumentCursor__f_path : this$6.get__O())));
    var content = $n($n(doc).content__Llaika_ast_TemplateRoot()).Llaika_ast_TemplateRoot__f_content;
    var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var content$1 = new $c_Llaika_ast_TemplateSpanSequence(content, options$1);
    var options$2 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var $x_2 = new $c_s_Some(new $c_Llaika_ast_TemplateScope(content$1, context, source, options$2));
  }
  var this$11 = $n($x_2);
  return (this$11.isEmpty__Z() ? new $c_s_util_Left((("Unresolved reference to template '" + $n(path).toString__T()) + "'")) : new $c_s_util_Right(this$11.get__O()));
}
function $p_Llaika_internal_directive_IncludeDirectives$__resolveDocumentReference__Llaika_ast_Path__Llaika_api_config_Config__Llaika_ast_DocumentCursor__Llaika_parse_SourceFragment__s_Option__s_util_Either($thiz, path, attributes, cursor, source, body) {
  var $x_1 = $n($n($n(cursor).root__Llaika_ast_RootCursor()).Llaika_ast_RootCursor__f_target).Llaika_ast_DocumentTreeRoot__f_tree;
  var this$1 = $n(path);
  var this$2 = $n($n($x_1).selectDocument__Llaika_ast_RelativePath__s_Option(this$1.relativeTo__Llaika_ast_Path__Llaika_ast_RelativePath($m_Llaika_ast_Path$Root$())));
  if (this$2.isEmpty__Z()) {
    var $x_2 = $m_s_None$();
  } else {
    var arg1 = this$2.get__O();
    var doc = $as_Llaika_ast_Document(arg1);
    var this$3 = $n(body);
    if (this$3.isEmpty__Z()) {
      var $x_3 = $m_s_None$();
    } else {
      var arg1$1 = this$3.get__O();
      var _$3 = $as_sci_Seq(arg1$1);
      var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      var $x_3 = new $c_s_Some(new $c_Llaika_ast_BlockSequence(_$3, options));
    }
    var context = $p_Llaika_internal_directive_IncludeDirectives$__config__Llaika_api_config_Config__s_Option__Llaika_ast_Path__Llaika_api_config_ConfigValue$ObjectValue($thiz, attributes, $x_3, $n(cursor).Llaika_ast_DocumentCursor__f_path);
    var content = $n($n(doc).Llaika_ast_Document__f_content).Llaika_ast_RootElement__f_content;
    var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var content$1 = new $c_Llaika_ast_BlockSequence(content, options$1);
    var options$2 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var $x_2 = new $c_s_Some(new $c_Llaika_ast_BlockScope(content$1, context, source, options$2));
  }
  var this$10 = $n($x_2);
  return (this$10.isEmpty__Z() ? new $c_s_util_Left((("Unresolved reference to template '" + $n(path).toString__T()) + "'")) : new $c_s_util_Right(this$10.get__O()));
}
/** @constructor */
function $c_Llaika_internal_directive_IncludeDirectives$() {
  this.Llaika_internal_directive_IncludeDirectives$__f_templateInclude$lzy1 = null;
  this.Llaika_internal_directive_IncludeDirectives$__f_templateIncludebitmap$1 = false;
  this.Llaika_internal_directive_IncludeDirectives$__f_templateEmbed$lzy1 = null;
  this.Llaika_internal_directive_IncludeDirectives$__f_templateEmbedbitmap$1 = false;
  this.Llaika_internal_directive_IncludeDirectives$__f_blockInclude$lzy1 = null;
  this.Llaika_internal_directive_IncludeDirectives$__f_blockIncludebitmap$1 = false;
  this.Llaika_internal_directive_IncludeDirectives$__f_blockEmbed$lzy1 = null;
  this.Llaika_internal_directive_IncludeDirectives$__f_blockEmbedbitmap$1 = false;
}
$c_Llaika_internal_directive_IncludeDirectives$.prototype = new $h_O();
$c_Llaika_internal_directive_IncludeDirectives$.prototype.constructor = $c_Llaika_internal_directive_IncludeDirectives$;
/** @constructor */
function $h_Llaika_internal_directive_IncludeDirectives$() {
}
$h_Llaika_internal_directive_IncludeDirectives$.prototype = $c_Llaika_internal_directive_IncludeDirectives$.prototype;
$c_Llaika_internal_directive_IncludeDirectives$.prototype.templateInclude__Llaika_api_bundle_DirectiveBuilderContext$Directive = (function() {
  if ((!this.Llaika_internal_directive_IncludeDirectives$__f_templateIncludebitmap$1)) {
    var this$11 = $m_Llaika_api_bundle_TemplateDirectives$();
    var this$1 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _1 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$1, 0)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().path__Llaika_api_config_ConfigDecoder());
    var this$2 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _2 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$2, 0)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string);
    var this$3 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _3 = $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__allAttributes__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$3);
    var this$4 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _4 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12(this$4);
    var this$5 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _5 = $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__source__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$5);
    var t5 = new $c_T5(_1, _2, _3, _4, _5);
    var part = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(new $c_Lcats_syntax_Tuple5SemigroupalOps(t5).mapN__F5__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction5(((x$1, x$2, x$3, x$4, x$5) => {
      var x$1$1 = $as_Llaika_ast_Path(x$1);
      var x$2$1 = $as_T(x$2);
      var x$3$1 = $as_Llaika_api_config_Config(x$3);
      var x$4$1 = $as_Llaika_ast_DocumentCursor(x$4);
      var x$5$1 = $as_Llaika_parse_SourceFragment(x$5);
      var this$10 = $n($p_Llaika_internal_directive_IncludeDirectives$__resolvePath__Llaika_ast_Path__T__Llaika_api_config_Config__s_util_Either(this, x$1$1, x$2$1, $n(x$4$1).Llaika_ast_DocumentCursor__f_config));
      if ((this$10 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(this$10);
        var b = $n(x2).s_util_Right__f_value;
        var _$4 = $as_Llaika_ast_Path(b);
        return $p_Llaika_internal_directive_IncludeDirectives$__resolveTemplateReference__Llaika_ast_Path__Llaika_api_config_Config__Llaika_ast_DocumentCursor__Llaika_parse_SourceFragment__s_Option__s_util_Either(this, _$4, x$3$1, x$4$1, x$5$1, $m_s_None$());
      } else {
        return this$10;
      }
    })), $n($m_Llaika_api_bundle_TemplateDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances, $as_Lcats_Semigroupal($n($m_Llaika_api_bundle_TemplateDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances)));
    this.Llaika_internal_directive_IncludeDirectives$__f_templateInclude$lzy1 = $f_Llaika_api_bundle_DirectiveBuilderContext__eval__T__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$Directive(this$11, "include", part);
    this.Llaika_internal_directive_IncludeDirectives$__f_templateIncludebitmap$1 = true;
  }
  return this.Llaika_internal_directive_IncludeDirectives$__f_templateInclude$lzy1;
});
$c_Llaika_internal_directive_IncludeDirectives$.prototype.templateEmbed__Llaika_api_bundle_DirectiveBuilderContext$Directive = (function() {
  if ((!this.Llaika_internal_directive_IncludeDirectives$__f_templateEmbedbitmap$1)) {
    var this$13 = $m_Llaika_api_bundle_TemplateDirectives$();
    var this$1 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _1 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$1, 0)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().path__Llaika_api_config_ConfigDecoder());
    var this$2 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _2 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$2, 0)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string);
    var this$3 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _3 = $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__allAttributes__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$3);
    var this$4 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _4 = $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__parsedBody__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$4);
    var this$5 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _5 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12(this$5);
    var this$6 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _6 = $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__source__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$6);
    var t6 = new $c_T6(_1, _2, _3, _4, _5, _6);
    var part = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(new $c_Lcats_syntax_Tuple6SemigroupalOps(t6).mapN__F6__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction6(((x$1, x$2, x$3, x$4, x$5, x$6) => {
      var x$1$1 = $as_Llaika_ast_Path(x$1);
      var x$2$1 = $as_T(x$2);
      var x$3$1 = $as_Llaika_api_config_Config(x$3);
      var x$4$1 = $as_sci_Seq(x$4);
      var x$5$1 = $as_Llaika_ast_DocumentCursor(x$5);
      var x$6$1 = $as_Llaika_parse_SourceFragment(x$6);
      var this$11 = $n($p_Llaika_internal_directive_IncludeDirectives$__resolvePath__Llaika_ast_Path__T__Llaika_api_config_Config__s_util_Either(this, x$1$1, x$2$1, $n(x$5$1).Llaika_ast_DocumentCursor__f_config));
      if ((this$11 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(this$11);
        var b = $n(x2).s_util_Right__f_value;
        var _$5 = $as_Llaika_ast_Path(b);
        return $p_Llaika_internal_directive_IncludeDirectives$__resolveTemplateReference__Llaika_ast_Path__Llaika_api_config_Config__Llaika_ast_DocumentCursor__Llaika_parse_SourceFragment__s_Option__s_util_Either(this, _$5, x$3$1, x$5$1, x$6$1, new $c_s_Some(x$4$1));
      } else {
        return this$11;
      }
    })), $n($m_Llaika_api_bundle_TemplateDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances, $as_Lcats_Semigroupal($n($m_Llaika_api_bundle_TemplateDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances)));
    this.Llaika_internal_directive_IncludeDirectives$__f_templateEmbed$lzy1 = $f_Llaika_api_bundle_DirectiveBuilderContext__eval__T__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$Directive(this$13, "embed", part);
    this.Llaika_internal_directive_IncludeDirectives$__f_templateEmbedbitmap$1 = true;
  }
  return this.Llaika_internal_directive_IncludeDirectives$__f_templateEmbed$lzy1;
});
$c_Llaika_internal_directive_IncludeDirectives$.prototype.blockInclude__Llaika_api_bundle_DirectiveBuilderContext$Directive = (function() {
  if ((!this.Llaika_internal_directive_IncludeDirectives$__f_blockIncludebitmap$1)) {
    var this$11 = $m_Llaika_api_bundle_BlockDirectives$();
    var this$1 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _1 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$1, 0)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().path__Llaika_api_config_ConfigDecoder());
    var this$2 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _2 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$2, 0)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string);
    var this$3 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _3 = $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__allAttributes__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$3);
    var this$4 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _4 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12(this$4);
    var this$5 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _5 = $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__source__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$5);
    var t5 = new $c_T5(_1, _2, _3, _4, _5);
    var part = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(new $c_Lcats_syntax_Tuple5SemigroupalOps(t5).mapN__F5__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction5(((x$1, x$2, x$3, x$4, x$5) => {
      var x$1$1 = $as_Llaika_ast_Path(x$1);
      var x$2$1 = $as_T(x$2);
      var x$3$1 = $as_Llaika_api_config_Config(x$3);
      var x$4$1 = $as_Llaika_ast_DocumentCursor(x$4);
      var x$5$1 = $as_Llaika_parse_SourceFragment(x$5);
      var this$10 = $n($p_Llaika_internal_directive_IncludeDirectives$__resolvePath__Llaika_ast_Path__T__Llaika_api_config_Config__s_util_Either(this, x$1$1, x$2$1, $n(x$4$1).Llaika_ast_DocumentCursor__f_config));
      if ((this$10 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(this$10);
        var b = $n(x2).s_util_Right__f_value;
        var _$6 = $as_Llaika_ast_Path(b);
        return $p_Llaika_internal_directive_IncludeDirectives$__resolveDocumentReference__Llaika_ast_Path__Llaika_api_config_Config__Llaika_ast_DocumentCursor__Llaika_parse_SourceFragment__s_Option__s_util_Either(this, _$6, x$3$1, x$4$1, x$5$1, $m_s_None$());
      } else {
        return this$10;
      }
    })), $n($m_Llaika_api_bundle_BlockDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances, $as_Lcats_Semigroupal($n($m_Llaika_api_bundle_BlockDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances)));
    this.Llaika_internal_directive_IncludeDirectives$__f_blockInclude$lzy1 = $f_Llaika_api_bundle_DirectiveBuilderContext__eval__T__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$Directive(this$11, "include", part);
    this.Llaika_internal_directive_IncludeDirectives$__f_blockIncludebitmap$1 = true;
  }
  return this.Llaika_internal_directive_IncludeDirectives$__f_blockInclude$lzy1;
});
$c_Llaika_internal_directive_IncludeDirectives$.prototype.blockEmbed__Llaika_api_bundle_DirectiveBuilderContext$Directive = (function() {
  if ((!this.Llaika_internal_directive_IncludeDirectives$__f_blockEmbedbitmap$1)) {
    var this$13 = $m_Llaika_api_bundle_BlockDirectives$();
    var this$1 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _1 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$1, 0)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().path__Llaika_api_config_ConfigDecoder());
    var this$2 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _2 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$2, 0)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string);
    var this$3 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _3 = $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__allAttributes__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$3);
    var this$4 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _4 = $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__parsedBody__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$4);
    var this$5 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _5 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12(this$5);
    var this$6 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _6 = $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__source__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$6);
    var t6 = new $c_T6(_1, _2, _3, _4, _5, _6);
    var part = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(new $c_Lcats_syntax_Tuple6SemigroupalOps(t6).mapN__F6__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction6(((x$1, x$2, x$3, x$4, x$5, x$6) => {
      var x$1$1 = $as_Llaika_ast_Path(x$1);
      var x$2$1 = $as_T(x$2);
      var x$3$1 = $as_Llaika_api_config_Config(x$3);
      var x$4$1 = $as_sci_Seq(x$4);
      var x$5$1 = $as_Llaika_ast_DocumentCursor(x$5);
      var x$6$1 = $as_Llaika_parse_SourceFragment(x$6);
      var this$11 = $n($p_Llaika_internal_directive_IncludeDirectives$__resolvePath__Llaika_ast_Path__T__Llaika_api_config_Config__s_util_Either(this, x$1$1, x$2$1, $n(x$5$1).Llaika_ast_DocumentCursor__f_config));
      if ((this$11 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(this$11);
        var b = $n(x2).s_util_Right__f_value;
        var _$7 = $as_Llaika_ast_Path(b);
        return $p_Llaika_internal_directive_IncludeDirectives$__resolveDocumentReference__Llaika_ast_Path__Llaika_api_config_Config__Llaika_ast_DocumentCursor__Llaika_parse_SourceFragment__s_Option__s_util_Either(this, _$7, x$3$1, x$5$1, x$6$1, new $c_s_Some(x$4$1));
      } else {
        return this$11;
      }
    })), $n($m_Llaika_api_bundle_BlockDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances, $as_Lcats_Semigroupal($n($m_Llaika_api_bundle_BlockDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances)));
    this.Llaika_internal_directive_IncludeDirectives$__f_blockEmbed$lzy1 = $f_Llaika_api_bundle_DirectiveBuilderContext__eval__T__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$Directive(this$13, "embed", part);
    this.Llaika_internal_directive_IncludeDirectives$__f_blockEmbedbitmap$1 = true;
  }
  return this.Llaika_internal_directive_IncludeDirectives$__f_blockEmbed$lzy1;
});
var $d_Llaika_internal_directive_IncludeDirectives$ = new $TypeData().initClass($c_Llaika_internal_directive_IncludeDirectives$, "laika.internal.directive.IncludeDirectives$", ({
  Llaika_internal_directive_IncludeDirectives$: 1
}));
var $n_Llaika_internal_directive_IncludeDirectives$;
function $m_Llaika_internal_directive_IncludeDirectives$() {
  if ((!$n_Llaika_internal_directive_IncludeDirectives$)) {
    $n_Llaika_internal_directive_IncludeDirectives$ = new $c_Llaika_internal_directive_IncludeDirectives$();
  }
  return $n_Llaika_internal_directive_IncludeDirectives$;
}
/** @constructor */
function $c_Llaika_internal_directive_NavigationTreeDirectives$() {
  this.Llaika_internal_directive_NavigationTreeDirectives$__f_forTemplates$lzy1 = null;
  this.Llaika_internal_directive_NavigationTreeDirectives$__f_forTemplatesbitmap$1 = false;
  this.Llaika_internal_directive_NavigationTreeDirectives$__f_forBlocks$lzy1 = null;
  this.Llaika_internal_directive_NavigationTreeDirectives$__f_forBlocksbitmap$1 = false;
}
$c_Llaika_internal_directive_NavigationTreeDirectives$.prototype = new $h_O();
$c_Llaika_internal_directive_NavigationTreeDirectives$.prototype.constructor = $c_Llaika_internal_directive_NavigationTreeDirectives$;
/** @constructor */
function $h_Llaika_internal_directive_NavigationTreeDirectives$() {
}
$h_Llaika_internal_directive_NavigationTreeDirectives$.prototype = $c_Llaika_internal_directive_NavigationTreeDirectives$.prototype;
$c_Llaika_internal_directive_NavigationTreeDirectives$.prototype.forTemplates__Llaika_api_bundle_DirectiveBuilderContext$Directive = (function() {
  if ((!this.Llaika_internal_directive_NavigationTreeDirectives$__f_forTemplatesbitmap$1)) {
    var this$14 = $m_Llaika_api_bundle_TemplateDirectives$();
    var this$1 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _1 = $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__allAttributes__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$1);
    var this$2 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _2 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12(this$2);
    var t2 = new $c_T2(_1, _2);
    var part = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(new $c_Lcats_syntax_Tuple2SemigroupalOps(t2).mapN__F2__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction2(((config, cursor) => {
      var config$1 = $as_Llaika_api_config_Config(config);
      var cursor$1 = $as_Llaika_ast_DocumentCursor(cursor);
      var eab = $n(config$1).get__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either($m_Llaika_api_config_Key$().Llaika_api_config_Key$__f_root, $m_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig$().Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig$__f_decoder);
      matchResult23: {
        var $x_1;
        if ((eab instanceof $c_s_util_Left)) {
          var a = $n($as_s_util_Left(eab)).s_util_Left__f_value;
          var _$5 = $as_Llaika_api_config_ConfigError(a);
          var value = $n(_$5).message__T();
          var $x_1 = new $c_s_util_Left(value);
          break matchResult23;
        }
        if ((eab instanceof $c_s_util_Right)) {
          var r = $as_s_util_Right(eab);
          $m_Lcats_syntax_EitherUtil$();
          var $x_1 = r;
          break matchResult23;
        }
        throw new $c_s_MatchError(eab);
      }
      var this$10 = $n($x_1);
      if ((this$10 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(this$10);
        var b = $n(x2).s_util_Right__f_value;
        var _$6 = $as_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig(b);
        var this$11 = $n($n(_$6).eval__Llaika_ast_DocumentCursor__s_util_Either(cursor$1));
        if ((this$11 instanceof $c_s_util_Right)) {
          var x2$1 = $as_s_util_Right(this$11);
          var b$1 = $n(x2$1).s_util_Right__f_value;
          var _$7 = $as_Llaika_ast_NavigationList(b$1);
          var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
          return new $c_s_util_Right(new $c_Llaika_ast_TemplateElement(_$7, 0, options));
        } else {
          return this$11;
        }
      } else {
        return this$10;
      }
    })), $n($m_Llaika_api_bundle_TemplateDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances, $as_Lcats_Semigroupal($n($m_Llaika_api_bundle_TemplateDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances)));
    this.Llaika_internal_directive_NavigationTreeDirectives$__f_forTemplates$lzy1 = $f_Llaika_api_bundle_DirectiveBuilderContext__eval__T__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$Directive(this$14, "navigationTree", part);
    this.Llaika_internal_directive_NavigationTreeDirectives$__f_forTemplatesbitmap$1 = true;
  }
  return this.Llaika_internal_directive_NavigationTreeDirectives$__f_forTemplates$lzy1;
});
$c_Llaika_internal_directive_NavigationTreeDirectives$.prototype.forBlocks__Llaika_api_bundle_DirectiveBuilderContext$Directive = (function() {
  if ((!this.Llaika_internal_directive_NavigationTreeDirectives$__f_forBlocksbitmap$1)) {
    var this$11 = $m_Llaika_api_bundle_BlockDirectives$();
    var this$1 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _1 = $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__allAttributes__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$1);
    var this$2 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _2 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12(this$2);
    var t2 = new $c_T2(_1, _2);
    var part = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(new $c_Lcats_syntax_Tuple2SemigroupalOps(t2).mapN__F2__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction2(((config, cursor) => {
      var config$1 = $as_Llaika_api_config_Config(config);
      var cursor$1 = $as_Llaika_ast_DocumentCursor(cursor);
      var eab = $n(config$1).get__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either($m_Llaika_api_config_Key$().Llaika_api_config_Key$__f_root, $m_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig$().Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig$__f_decoder);
      matchResult23: {
        var $x_1;
        if ((eab instanceof $c_s_util_Left)) {
          var a = $n($as_s_util_Left(eab)).s_util_Left__f_value;
          var _$8 = $as_Llaika_api_config_ConfigError(a);
          var value = $n(_$8).message__T();
          var $x_1 = new $c_s_util_Left(value);
          break matchResult23;
        }
        if ((eab instanceof $c_s_util_Right)) {
          var r = $as_s_util_Right(eab);
          $m_Lcats_syntax_EitherUtil$();
          var $x_1 = r;
          break matchResult23;
        }
        throw new $c_s_MatchError(eab);
      }
      var this$10 = $n($x_1);
      if ((this$10 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(this$10);
        var b = $n(x2).s_util_Right__f_value;
        var _$9 = $as_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig(b);
        return $n(_$9).eval__Llaika_ast_DocumentCursor__s_util_Either(cursor$1);
      } else {
        return this$10;
      }
    })), $n($m_Llaika_api_bundle_BlockDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances, $as_Lcats_Semigroupal($n($m_Llaika_api_bundle_BlockDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances)));
    this.Llaika_internal_directive_NavigationTreeDirectives$__f_forBlocks$lzy1 = $f_Llaika_api_bundle_DirectiveBuilderContext__eval__T__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$Directive(this$11, "navigationTree", part);
    this.Llaika_internal_directive_NavigationTreeDirectives$__f_forBlocksbitmap$1 = true;
  }
  return this.Llaika_internal_directive_NavigationTreeDirectives$__f_forBlocks$lzy1;
});
var $d_Llaika_internal_directive_NavigationTreeDirectives$ = new $TypeData().initClass($c_Llaika_internal_directive_NavigationTreeDirectives$, "laika.internal.directive.NavigationTreeDirectives$", ({
  Llaika_internal_directive_NavigationTreeDirectives$: 1
}));
var $n_Llaika_internal_directive_NavigationTreeDirectives$;
function $m_Llaika_internal_directive_NavigationTreeDirectives$() {
  if ((!$n_Llaika_internal_directive_NavigationTreeDirectives$)) {
    $n_Llaika_internal_directive_NavigationTreeDirectives$ = new $c_Llaika_internal_directive_NavigationTreeDirectives$();
  }
  return $n_Llaika_internal_directive_NavigationTreeDirectives$;
}
function $is_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig)));
}
function $as_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig(obj) {
  return (($is_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.directive.NavigationTreeDirectives$NavigationNodeConfig"));
}
function $isArrayOf_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig)));
}
function $asArrayOf_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig(obj, depth) {
  return (($isArrayOf_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.directive.NavigationTreeDirectives$NavigationNodeConfig;", depth));
}
/** @constructor */
function $c_Llaika_internal_directive_SelectDirective$() {
  this.Llaika_internal_directive_SelectDirective$__f_forBlocks = null;
  $n_Llaika_internal_directive_SelectDirective$ = this;
  var this$54 = $m_Llaika_api_bundle_BlockDirectives$();
  var this$9 = $m_Llaika_api_bundle_BlockDirectives$();
  var this$2 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
  var _1 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$2, 0)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string);
  var this$3 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
  var _2 = $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__parsedBody__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$3);
  var t2 = new $c_T2(_1, _2);
  var part = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(new $c_Lcats_syntax_Tuple2SemigroupalOps(t2).mapN__F2__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction2(((name, body) => {
    var name$1 = $as_T(name);
    var body$1 = $as_sci_Seq(body);
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    return new $c_Llaika_ast_Choice(name$1, name$1, body$1, options);
  })), $n($m_Llaika_api_bundle_BlockDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances, $as_Lcats_Semigroupal($n($m_Llaika_api_bundle_BlockDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances)));
  var separator = new $c_Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective(this$9, "choice", part, 2, 2147483647);
  var this$10 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
  var _1$1 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$10, 0)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string);
  var this$11 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
  var separators = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective.getArrayOf().constr)([separator]))));
  var _2$1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart(this$11, separators);
  var this$12 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
  var _3 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12(this$12);
  var t3 = new $c_T3(_1$1, _2$1, _3);
  var part$1 = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(new $c_Lcats_syntax_Tuple3SemigroupalOps(t3).mapN__F3__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction3(((name$2, multiPart, cursor) => {
    var name$3 = $as_T(name$2);
    var multiPart$1 = $as_Llaika_api_bundle_DirectiveBuilderContext$Multipart(multiPart);
    var cursor$1 = $as_Llaika_ast_DocumentCursor(cursor);
    var this$15 = $n($n(cursor$1).Llaika_ast_DocumentCursor__f_config);
    var decoder = $m_Llaika_config_Selections$().Llaika_config_Selections$__f_decoder;
    var defaultKey = $m_Llaika_config_Selections$().Llaika_config_Selections$__f_key;
    var eab = this$15.get__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either($n(defaultKey).Llaika_api_config_DefaultKey$$anon$1__f_value, decoder);
    matchResult23: {
      var $x_1;
      if ((eab instanceof $c_s_util_Left)) {
        var a = $n($as_s_util_Left(eab)).s_util_Left__f_value;
        var e = $as_Llaika_api_config_ConfigError(a);
        var value = ("Error reading config for selections: " + $n(e).message__T());
        var $x_1 = new $c_s_util_Left(value);
        break matchResult23;
      }
      if ((eab instanceof $c_s_util_Right)) {
        var r = $as_s_util_Right(eab);
        $m_Lcats_syntax_EitherUtil$();
        var $x_1 = r;
        break matchResult23;
      }
      throw new $c_s_MatchError(eab);
    }
    var this$20 = $n($x_1);
    if ((this$20 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$20);
      var b = $n(x2).s_util_Right__f_value;
      var config = $as_Llaika_config_Selections(b);
      var this$21 = $n($n(config).getSelection__T__s_Option(name$3));
      var this$22 = $n((this$21.isEmpty__Z() ? new $c_s_util_Left((("Not found: selection '" + name$3) + "'")) : new $c_s_util_Right(this$21.get__O())));
      if ((this$22 instanceof $c_s_util_Right)) {
        var x2$1 = $as_s_util_Right(this$22);
        var b$1 = $n(x2$1).s_util_Right__f_value;
        var selection = $as_Llaika_config_SelectionConfig(b$1);
        var target = $n($n(multiPart$1).Llaika_api_bundle_DirectiveBuilderContext$Multipart__f_children).toList__sci_List();
        $m_Lcats_UnorderedFoldable$();
        var tc = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
        var this$38 = new $c_Lcats_Traverse$ToTraverseOps$$anon$3(target, tc);
        var f = new $c_sjsr_AnonFunction1(((choice) => {
          var choice$1 = $as_Llaika_ast_Choice(choice);
          var this$25 = $n($n(selection).getLabel__T__s_Option($n(choice$1).Llaika_ast_Choice__f_name));
          if (this$25.isEmpty__Z()) {
            var oa = $m_s_None$();
          } else {
            var arg1 = this$25.get__O();
            var label = $as_T(arg1);
            var this$26 = $n($n(multiPart$1).Llaika_api_bundle_DirectiveBuilderContext$Multipart__f_mainBody);
            var suffix = $n(choice$1).Llaika_ast_Choice__f_content;
            var content$1 = $as_sci_Seq(this$26.appendedAll__sc_IterableOnce__O(suffix));
            var this$27 = $n(choice$1);
            var name$1$1 = this$27.Llaika_ast_Choice__f_name;
            var this$28 = $n(choice$1);
            var options$1 = this$28.Llaika_ast_Choice__f_options;
            $n(choice$1);
            var oa = new $c_s_Some(new $c_Llaika_ast_Choice(name$1$1, label, content$1, options$1));
          }
          var this$32 = $n(oa);
          if (this$32.isEmpty__Z()) {
            var this$33 = $m_Lcats_data_Validated$();
            var a$1 = (((("No label defined for choice '" + $n(choice$1).Llaika_ast_Choice__f_name) + "' in selection '") + name$3) + "'");
            var $x_2 = $f_Lcats_data_ValidatedFunctionsBinCompat0__invalidNec__O__Lcats_data_Validated(this$33, a$1);
          } else {
            var arg1$1 = this$32.get__O();
            var $x_2 = new $c_Lcats_data_Validated$Valid(arg1$1);
          }
          return $as_Lcats_data_Validated($x_2);
        }));
        $m_Lcats_data_Validated$();
        $m_Lcats_data_NonEmptyChainImpl$();
        var ev = $m_Lcats_data_Chain$().Lcats_data_ChainInstances__f_theMonoid;
        var ev$1 = new $c_Lcats_data_ValidatedInstances$$anon$7(ev);
        var this$39 = $n($as_Lcats_data_Validated($n(this$38.Lcats_Traverse$ToTraverseOps$$anon$3__f_typeClassInstance).traverse__O__F1__Lcats_Applicative__O(this$38.Lcats_Traverse$ToTraverseOps$$anon$3__f_self, f, ev$1)));
        matchResult24: {
          var $x_3;
          if ((this$39 instanceof $c_Lcats_data_Validated$Invalid)) {
            var x$1 = $as_Lcats_data_Validated$Invalid(this$39);
            var this$41 = $n(x$1);
            var i = $as_Lcats_data_Validated$Invalid(this$39);
            var $x_3 = i;
            break matchResult24;
          }
          if ((this$39 instanceof $c_Lcats_data_Validated$Valid)) {
            var x$1$1 = $as_Lcats_data_Validated$Valid(this$39);
            var this$43 = $n(x$1$1);
            var x228 = this$43.Lcats_data_Validated$Valid__f_a;
            var _$1 = $as_sci_List(x228);
            var options$2 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
            var a$2 = new $c_Llaika_ast_Selection(name$3, _$1, options$2);
            var $x_3 = new $c_Lcats_data_Validated$Valid(a$2);
            break matchResult24;
          }
          throw new $c_s_MatchError(this$39);
        }
        var eab$1 = $n($x_3).toEither__s_util_Either();
        if ((eab$1 instanceof $c_s_util_Left)) {
          var a$3 = $n($as_s_util_Left(eab$1)).s_util_Left__f_value;
          var A = $m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString;
          var F = $as_Lcats_Foldable($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
          var value$1 = $m_Lcats_syntax_FoldableOps$().mkString_$extension__O__T__T__T__Lcats_Show__Lcats_Foldable__T(a$3, "", ", ", "", A, F);
          return new $c_s_util_Left(value$1);
        }
        if ((eab$1 instanceof $c_s_util_Right)) {
          var r$1 = $as_s_util_Right(eab$1);
          $m_Lcats_syntax_EitherUtil$();
          return r$1;
        }
        throw new $c_s_MatchError(eab$1);
      } else {
        return this$22;
      }
    } else {
      return this$20;
    }
  })), $n($m_Llaika_api_bundle_BlockDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances, $as_Lcats_Semigroupal($n($m_Llaika_api_bundle_BlockDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances)));
  this.Llaika_internal_directive_SelectDirective$__f_forBlocks = $f_Llaika_api_bundle_DirectiveBuilderContext__eval__T__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$Directive(this$54, "select", part$1);
}
$c_Llaika_internal_directive_SelectDirective$.prototype = new $h_O();
$c_Llaika_internal_directive_SelectDirective$.prototype.constructor = $c_Llaika_internal_directive_SelectDirective$;
/** @constructor */
function $h_Llaika_internal_directive_SelectDirective$() {
}
$h_Llaika_internal_directive_SelectDirective$.prototype = $c_Llaika_internal_directive_SelectDirective$.prototype;
var $d_Llaika_internal_directive_SelectDirective$ = new $TypeData().initClass($c_Llaika_internal_directive_SelectDirective$, "laika.internal.directive.SelectDirective$", ({
  Llaika_internal_directive_SelectDirective$: 1
}));
var $n_Llaika_internal_directive_SelectDirective$;
function $m_Llaika_internal_directive_SelectDirective$() {
  if ((!$n_Llaika_internal_directive_SelectDirective$)) {
    $n_Llaika_internal_directive_SelectDirective$ = new $c_Llaika_internal_directive_SelectDirective$();
  }
  return $n_Llaika_internal_directive_SelectDirective$;
}
function $p_Llaika_internal_directive_StandardLinkDirectives$__linkConfig__Llaika_ast_DocumentCursor__s_util_Either($thiz, cursor) {
  var this$1 = $n($n(cursor).Llaika_ast_DocumentCursor__f_config);
  var decoder = $m_Llaika_config_LinkConfig$().Llaika_config_LinkConfig$__f_decoder;
  var defaultKey = $m_Llaika_config_LinkConfig$().Llaika_config_LinkConfig$__f_key;
  var key = $n(defaultKey).Llaika_api_config_DefaultKey$$anon$1__f_value;
  var this$2 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$1, key, decoder));
  if ((this$2 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$2);
    var b = $n(x2).s_util_Right__f_value;
    var _$1 = $as_s_Option(b);
    var this$3 = $n(_$1);
    var eab = new $c_s_util_Right($as_Llaika_config_LinkConfig((this$3.isEmpty__Z() ? $m_Llaika_config_LinkConfig$().Llaika_config_LinkConfig$__f_empty : this$3.get__O())));
  } else {
    var eab = this$2;
  }
  if ((eab instanceof $c_s_util_Left)) {
    var a = $n($as_s_util_Left(eab)).s_util_Left__f_value;
    var _$2 = $as_Llaika_api_config_ConfigError(a);
    var value = $n(_$2).message__T();
    return new $c_s_util_Left(value);
  }
  if ((eab instanceof $c_s_util_Right)) {
    var r = $as_s_util_Right(eab);
    $m_Lcats_syntax_EitherUtil$();
    return r;
  }
  throw new $c_s_MatchError(eab);
}
function $p_Llaika_internal_directive_StandardLinkDirectives$__splitAtLast$1__T__C__T2($thiz, in$1, char) {
  var xs = $m_sc_StringOps$().split$extension__T__C__AT(in$1, char);
  var x1 = $m_sc_ArrayOps$().toIndexedSeq$extension__O__sci_IndexedSeq(xs);
  if ((x1 !== null)) {
    var this$6 = $n(x1);
    var x = this$6.length__I();
    if ((((x === 1) ? 0 : ((x < 1) ? (-1) : 1)) === 0)) {
      var x7 = $as_T($n(x1).apply__I__O(0));
      var _2 = $m_s_None$();
      return new $c_T2(x7, _2);
    }
    var x2 = $m_sc_package$$colon$plus$().unapply__sc_SeqOps__s_Option(x1);
    if ((!$n(x2).isEmpty__Z())) {
      var x3 = $as_T2($n(x2).get__O());
      var init = $as_sci_Seq($n(x3)._1__O());
      var last = $as_T($n(x3)._2__O());
      var this$11 = $n(init);
      var sep = ("" + $cToS(char));
      var _1 = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$11, "", sep, "");
      var _2$1 = new $c_s_Some(last);
      return new $c_T2(_1, _2$1);
    }
  }
  var _2$2 = $m_s_None$();
  return new $c_T2("", _2$2);
}
/** @constructor */
function $c_Llaika_internal_directive_StandardLinkDirectives$() {
  this.Llaika_internal_directive_StandardLinkDirectives$__f_api$lzy1 = null;
  this.Llaika_internal_directive_StandardLinkDirectives$__f_apibitmap$1 = false;
  this.Llaika_internal_directive_StandardLinkDirectives$__f_source$lzy1 = null;
  this.Llaika_internal_directive_StandardLinkDirectives$__f_sourcebitmap$1 = false;
}
$c_Llaika_internal_directive_StandardLinkDirectives$.prototype = new $h_O();
$c_Llaika_internal_directive_StandardLinkDirectives$.prototype.constructor = $c_Llaika_internal_directive_StandardLinkDirectives$;
/** @constructor */
function $h_Llaika_internal_directive_StandardLinkDirectives$() {
}
$h_Llaika_internal_directive_StandardLinkDirectives$.prototype = $c_Llaika_internal_directive_StandardLinkDirectives$.prototype;
$c_Llaika_internal_directive_StandardLinkDirectives$.prototype.api__Llaika_api_bundle_LinkDirectives$Directive = (function() {
  if ((!this.Llaika_internal_directive_StandardLinkDirectives$__f_apibitmap$1)) {
    var this$28 = $m_Llaika_api_bundle_LinkDirectives$();
    var f$2 = new $c_sjsr_AnonFunction2(((linkId, cursor) => {
      var linkId$1 = $as_T(linkId);
      var cursor$1 = $as_Llaika_ast_DocumentCursor(cursor);
      var this$2 = $n($p_Llaika_internal_directive_StandardLinkDirectives$__linkConfig__Llaika_ast_DocumentCursor__s_util_Either(this, cursor$1));
      if ((this$2 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(this$2);
        var b = $n(x2).s_util_Right__f_value;
        var linkConfig = $as_Llaika_config_LinkConfig(b);
        var this$5 = $n($n($n(linkConfig).Llaika_config_LinkConfig$Impl__f_apiLinks).toList__sci_List());
        var f = ((l) => {
          var l$1 = $as_Llaika_config_ApiLinks(l);
          var this$3 = $n(linkId$1);
          var prefix = $n(l$1).Llaika_config_ApiLinks$Impl__f_packagePrefix;
          if ((this$3.length >= 0)) {
            var this$4 = $n(prefix);
            var $x_1 = this$3.substring(0, this$4.length);
            return ($as_T($x_1) === prefix);
          } else {
            return false;
          }
        });
        var l$2 = this$5;
        block: {
          var result;
          while (true) {
            if ($n(l$2).isEmpty__Z()) {
              var result = $m_sci_Nil$();
              break;
            } else {
              var h = $n(l$2).head__O();
              var t = $as_sci_List($n(l$2).tail__O());
              if (($uZ(f(h)) === false)) {
                l$2 = t;
                continue;
              }
              var start = l$2;
              var remaining = t;
              while (true) {
                if ($n(remaining).isEmpty__Z()) {
                  var result = start;
                  break block;
                } else {
                  var x = $n(remaining).head__O();
                  if (($uZ(f(x)) !== false)) {
                    remaining = $as_sci_List($n(remaining).tail__O());
                    continue;
                  }
                  var firstMiss = remaining;
                  var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
                  var toProcess = $as_sci_List($n(start).tail__O());
                  var currentLast = newHead;
                  while ((toProcess !== firstMiss)) {
                    var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
                    $n(currentLast).sci_$colon$colon__f_next = newElem;
                    currentLast = newElem;
                    toProcess = $as_sci_List($n(toProcess).tail__O());
                  }
                  var next = $as_sci_List($n(firstMiss).tail__O());
                  var nextToCopy = next;
                  while ((!$n(next).isEmpty__Z())) {
                    var head = $n(next).head__O();
                    if (($uZ(f(head)) !== false)) {
                      next = $as_sci_List($n(next).tail__O());
                    } else {
                      while ((nextToCopy !== next)) {
                        var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                        $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                        currentLast = newElem$2;
                        nextToCopy = $as_sci_List($n(nextToCopy).tail__O());
                      }
                      nextToCopy = $as_sci_List($n(next).tail__O());
                      next = $as_sci_List($n(next).tail__O());
                    }
                  }
                  if ((!$n(nextToCopy).isEmpty__Z())) {
                    $n(currentLast).sci_$colon$colon__f_next = nextToCopy;
                  }
                  var result = newHead;
                  break block;
                }
              }
            }
          }
        }
        $m_Lcats_UnorderedFoldable$();
        var tc = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
        var this$10 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(result, tc);
        var f$1 = new $c_sjsr_AnonFunction1(((_$3) => {
          var _$3$1 = $as_Llaika_config_ApiLinks(_$3);
          var this$8 = $n($n(_$3$1).Llaika_config_ApiLinks$Impl__f_packagePrefix);
          return this$8.length;
        }));
        var ev$1 = $as_Lcats_kernel_Order($as_Lcats_kernel_Hash($m_Lcats_kernel_instances_int_package$().Lcats_kernel_instances_int_package$__f_catsKernelStdOrderForInt));
        var this$11 = $n(this$10.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance);
        var fa = this$10.Lcats_Foldable$ToFoldableOps$$anon$6__f_self;
        var matching = $f_Lcats_Foldable__maximumByOption__O__F1__Lcats_kernel_Order__s_Option(this$11, fa, f$1, ev$1);
        var this$12 = $n(matching);
        var this$13 = $n((this$12.isEmpty__Z() ? $n($n(linkConfig).Llaika_config_LinkConfig$Impl__f_apiLinks).find__F1__s_Option(new $c_sjsr_AnonFunction1(((_$4) => {
          var _$4$1 = $as_Llaika_config_ApiLinks(_$4);
          return ($n(_$4$1).Llaika_config_ApiLinks$Impl__f_packagePrefix === "*");
        }))) : this$12));
        if (this$13.isEmpty__Z()) {
          var value = (("No base URI defined for '" + linkId$1) + "' and no default URI available.");
          var $x_2 = new $c_s_util_Left(value);
        } else {
          var arg1 = this$13.get__O();
          var link = $as_Llaika_config_ApiLinks(arg1);
          matchResult2: {
            var \u03b41$___1;
            var \u03b41$___2;
            var x8 = $p_Llaika_internal_directive_StandardLinkDirectives$__splitAtLast$1__T__C__T2(this, linkId$1, 35);
            if ((x8 !== null)) {
              var fqName = $as_T($n(x8)._1__O());
              var method = $as_s_Option($n(x8)._2__O());
              var \u03b41$___1 = fqName;
              var \u03b41$___2 = method;
              break matchResult2;
            }
            throw new $c_s_MatchError(x8);
          }
          var fqName$2 = $as_T(\u03b41$___1);
          var method$2 = $as_s_Option(\u03b41$___2);
          matchResult3: {
            var \u03b42$___1;
            var \u03b42$___2;
            var x11 = $p_Llaika_internal_directive_StandardLinkDirectives$__splitAtLast$1__T__C__T2(this, fqName$2, 46);
            if ((x11 !== null)) {
              var packageName = $as_T($n(x11)._1__O());
              var className = $as_s_Option($n(x11)._2__O());
              var \u03b42$___1 = packageName;
              var \u03b42$___2 = className;
              break matchResult3;
            }
            throw new $c_s_MatchError(x11);
          }
          var packageName$2 = $as_T(\u03b42$___1);
          var className$2 = $as_s_Option(\u03b42$___2);
          var isPackage = $n(className$2).contains__O__Z("package");
          if (isPackage) {
            var typeText = packageName$2;
          } else {
            var $x_3 = $m_sc_StringOps$();
            var this$17 = $n(className$2);
            var x$1 = $as_T((this$17.isEmpty__Z() ? fqName$2 : this$17.get__O()));
            var typeText = $n($x_3).stripSuffix$extension__T__T__T(x$1, "$");
          }
          var this$19 = $n(method$2);
          if (this$19.isEmpty__Z()) {
            var $x_4 = "";
          } else {
            var arg1$1 = this$19.get__O();
            var m = $as_T(arg1$1);
            var xs = $m_sc_StringOps$().split$extension__T__C__AT(m, 40);
            var $x_4 = ("." + $as_T($m_sc_ArrayOps$().head$extension__O__O(xs)));
          }
          var linkText = (typeText + $x_4);
          if (isPackage) {
            var this$22 = $n(packageName$2);
            var typePath = (($as_T(this$22.split(".").join("/")) + "/") + $n(link).Llaika_config_ApiLinks$Impl__f_packageSummary);
          } else {
            var this$23 = $n(fqName$2);
            var typePath = ($as_T(this$23.split(".").join("/")) + ".html");
          }
          var $x_6 = $n(link).Llaika_config_ApiLinks$Impl__f_baseUri;
          var this$24 = $n(method$2);
          if (this$24.isEmpty__Z()) {
            var $x_5 = "";
          } else {
            var arg1$2 = this$24.get__O();
            var _$5 = $as_T(arg1$2);
            var $x_5 = ("#" + _$5);
          }
          var uri = (($x_6 + typePath) + $x_5);
          var this$27 = $n(cursor$1);
          var this$25 = $m_Llaika_ast_SpanLink$();
          var target = $m_Llaika_ast_Target$().parse__T__Llaika_ast_Target(uri);
          var this$26 = new $c_Llaika_ast_SpanLink$$anon$1(target, this$25);
          var texts = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([]));
          var link$1 = $as_Llaika_ast_Link($f_Llaika_ast_SpanContainerCompanion__apply__T__sci_Seq__O(this$26, linkText, texts));
          var $x_2 = $n($p_Llaika_ast_DocumentCursor__validator__Llaika_internal_link_LinkValidator(this$27)).validate__Llaika_ast_Link__s_util_Either(link$1);
        }
        return $as_s_util_Either($x_2);
      } else {
        return this$2;
      }
    }));
    this.Llaika_internal_directive_StandardLinkDirectives$__f_api$lzy1 = new $c_Llaika_api_bundle_LinkDirectives$$anon$14("api", f$2, this$28);
    this.Llaika_internal_directive_StandardLinkDirectives$__f_apibitmap$1 = true;
  }
  return this.Llaika_internal_directive_StandardLinkDirectives$__f_api$lzy1;
});
$c_Llaika_internal_directive_StandardLinkDirectives$.prototype.source__Llaika_api_bundle_LinkDirectives$Directive = (function() {
  if ((!this.Llaika_internal_directive_StandardLinkDirectives$__f_sourcebitmap$1)) {
    var this$22 = $m_Llaika_api_bundle_LinkDirectives$();
    var f$2 = new $c_sjsr_AnonFunction2(((linkId, cursor) => {
      var linkId$1 = $as_T(linkId);
      var cursor$1 = $as_Llaika_ast_DocumentCursor(cursor);
      var this$2 = $n($p_Llaika_internal_directive_StandardLinkDirectives$__linkConfig__Llaika_ast_DocumentCursor__s_util_Either(this, cursor$1));
      if ((this$2 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(this$2);
        var b = $n(x2).s_util_Right__f_value;
        var _$6 = $as_Llaika_config_LinkConfig(b);
        var $x_1 = new $c_s_util_Right($n(_$6).Llaika_config_LinkConfig$Impl__f_sourceLinks);
      } else {
        var $x_1 = this$2;
      }
      var this$3 = $n($x_1);
      if ((this$3 instanceof $c_s_util_Right)) {
        var x2$1 = $as_s_util_Right(this$3);
        var b$1 = $n(x2$1).s_util_Right__f_value;
        var sourceLinks = $as_sci_Seq(b$1);
        var this$6 = $n($n(sourceLinks).toList__sci_List());
        var f = ((l) => {
          var l$1 = $as_Llaika_config_SourceLinks(l);
          var this$4 = $n(linkId$1);
          var prefix = $n(l$1).Llaika_config_SourceLinks$Impl__f_packagePrefix;
          if ((this$4.length >= 0)) {
            var this$5 = $n(prefix);
            var $x_2 = this$4.substring(0, this$5.length);
            return ($as_T($x_2) === prefix);
          } else {
            return false;
          }
        });
        var l$2 = this$6;
        block: {
          var result;
          while (true) {
            if ($n(l$2).isEmpty__Z()) {
              var result = $m_sci_Nil$();
              break;
            } else {
              var h = $n(l$2).head__O();
              var t = $as_sci_List($n(l$2).tail__O());
              if (($uZ(f(h)) === false)) {
                l$2 = t;
                continue;
              }
              var start = l$2;
              var remaining = t;
              while (true) {
                if ($n(remaining).isEmpty__Z()) {
                  var result = start;
                  break block;
                } else {
                  var x = $n(remaining).head__O();
                  if (($uZ(f(x)) !== false)) {
                    remaining = $as_sci_List($n(remaining).tail__O());
                    continue;
                  }
                  var firstMiss = remaining;
                  var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
                  var toProcess = $as_sci_List($n(start).tail__O());
                  var currentLast = newHead;
                  while ((toProcess !== firstMiss)) {
                    var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
                    $n(currentLast).sci_$colon$colon__f_next = newElem;
                    currentLast = newElem;
                    toProcess = $as_sci_List($n(toProcess).tail__O());
                  }
                  var next = $as_sci_List($n(firstMiss).tail__O());
                  var nextToCopy = next;
                  while ((!$n(next).isEmpty__Z())) {
                    var head = $n(next).head__O();
                    if (($uZ(f(head)) !== false)) {
                      next = $as_sci_List($n(next).tail__O());
                    } else {
                      while ((nextToCopy !== next)) {
                        var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                        $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                        currentLast = newElem$2;
                        nextToCopy = $as_sci_List($n(nextToCopy).tail__O());
                      }
                      nextToCopy = $as_sci_List($n(next).tail__O());
                      next = $as_sci_List($n(next).tail__O());
                    }
                  }
                  if ((!$n(nextToCopy).isEmpty__Z())) {
                    $n(currentLast).sci_$colon$colon__f_next = nextToCopy;
                  }
                  var result = newHead;
                  break block;
                }
              }
            }
          }
        }
        $m_Lcats_UnorderedFoldable$();
        var tc = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
        var this$11 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(result, tc);
        var f$1 = new $c_sjsr_AnonFunction1(((_$7) => {
          var _$7$1 = $as_Llaika_config_SourceLinks(_$7);
          var this$9 = $n($n(_$7$1).Llaika_config_SourceLinks$Impl__f_packagePrefix);
          return this$9.length;
        }));
        var ev$1 = $as_Lcats_kernel_Order($as_Lcats_kernel_Hash($m_Lcats_kernel_instances_int_package$().Lcats_kernel_instances_int_package$__f_catsKernelStdOrderForInt));
        var this$12 = $n(this$11.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance);
        var fa = this$11.Lcats_Foldable$ToFoldableOps$$anon$6__f_self;
        var this$13 = $n($f_Lcats_Foldable__maximumByOption__O__F1__Lcats_kernel_Order__s_Option(this$12, fa, f$1, ev$1));
        var this$14 = $n((this$13.isEmpty__Z() ? $n(sourceLinks).find__F1__s_Option(new $c_sjsr_AnonFunction1(((_$8) => {
          var _$8$1 = $as_Llaika_config_SourceLinks(_$8);
          return ($n(_$8$1).Llaika_config_SourceLinks$Impl__f_packagePrefix === "*");
        }))) : this$13));
        if (this$14.isEmpty__Z()) {
          var value = (("No base URI defined for '" + linkId$1) + "' and no default URI available.");
          var $x_3 = new $c_s_util_Left(value);
        } else {
          var arg1 = this$14.get__O();
          var link = $as_Llaika_config_SourceLinks(arg1);
          var this$16 = $n(linkId$1);
          var typePath = (($as_T(this$16.split(".").join("/")) + ".") + $n(link).Llaika_config_SourceLinks$Impl__f_suffix);
          var uri = ($n(link).Llaika_config_SourceLinks$Impl__f_baseUri + typePath);
          var xs = $m_sc_StringOps$().split$extension__T__C__AT(linkId$1, 46);
          var text = $as_T($m_sc_ArrayOps$().last$extension__O__O(xs));
          var this$21 = $n(cursor$1);
          var this$19 = $m_Llaika_ast_SpanLink$();
          var target = $m_Llaika_ast_Target$().parse__T__Llaika_ast_Target(uri);
          var this$20 = new $c_Llaika_ast_SpanLink$$anon$1(target, this$19);
          var texts = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([]));
          var link$1 = $as_Llaika_ast_Link($f_Llaika_ast_SpanContainerCompanion__apply__T__sci_Seq__O(this$20, text, texts));
          var $x_3 = $n($p_Llaika_ast_DocumentCursor__validator__Llaika_internal_link_LinkValidator(this$21)).validate__Llaika_ast_Link__s_util_Either(link$1);
        }
        return $as_s_util_Either($x_3);
      } else {
        return this$3;
      }
    }));
    this.Llaika_internal_directive_StandardLinkDirectives$__f_source$lzy1 = new $c_Llaika_api_bundle_LinkDirectives$$anon$14("source", f$2, this$22);
    this.Llaika_internal_directive_StandardLinkDirectives$__f_sourcebitmap$1 = true;
  }
  return this.Llaika_internal_directive_StandardLinkDirectives$__f_source$lzy1;
});
var $d_Llaika_internal_directive_StandardLinkDirectives$ = new $TypeData().initClass($c_Llaika_internal_directive_StandardLinkDirectives$, "laika.internal.directive.StandardLinkDirectives$", ({
  Llaika_internal_directive_StandardLinkDirectives$: 1
}));
var $n_Llaika_internal_directive_StandardLinkDirectives$;
function $m_Llaika_internal_directive_StandardLinkDirectives$() {
  if ((!$n_Llaika_internal_directive_StandardLinkDirectives$)) {
    $n_Llaika_internal_directive_StandardLinkDirectives$ = new $c_Llaika_internal_directive_StandardLinkDirectives$();
  }
  return $n_Llaika_internal_directive_StandardLinkDirectives$;
}
function $s_Llaika_internal_link_DocumentTargets__laika$internal$link$DocumentTargets$$_$_$internalResolver$1__Llaika_ast_Document__Llaika_internal_link_TargetIdSelector__F1(document$1, selector) {
  var $x_1 = $m_Llaika_internal_link_ReferenceResolver$();
  var this$1 = $n($n(document$1).path__Llaika_ast_Path());
  var fragment = $n(selector).Llaika_internal_link_TargetIdSelector__f_id;
  return $n($x_1).internalLink__Llaika_ast_Path__F1($as_Llaika_ast_Path($f_Llaika_ast_GenericPath__withFragment__T__Llaika_ast_GenericPath(this$1, fragment)));
}
function $ps_Llaika_internal_link_DocumentTargets__resolve$1__sci_Map__Llaika_internal_link_LinkAliasResolver__sci_Set__Llaika_internal_link_TargetResolver(groupedTargets$1, alias, visited) {
  var visited$tailLocal1 = visited;
  while (true) {
    if ($n(visited$tailLocal1).contains__O__Z($n(alias).Llaika_internal_link_LinkAliasResolver__f_targetSelector)) {
      return $n(alias).circularReference__Llaika_internal_link_LinkAliasResolver();
    } else {
      var x176 = $n(groupedTargets$1).get__O__s_Option($n(alias).Llaika_internal_link_LinkAliasResolver__f_targetSelector);
      if ((x176 instanceof $c_s_Some)) {
        var x180 = $as_Llaika_internal_link_TargetResolver($n($as_s_Some(x176)).s_Some__f_value);
        if ((x180 instanceof $c_Llaika_internal_link_LinkAliasResolver)) {
          var alias2 = $as_Llaika_internal_link_LinkAliasResolver(x180);
          var this$1 = $n(visited$tailLocal1);
          var elem = $n(alias2).Llaika_internal_link_LinkAliasResolver__f_sourceSelector;
          visited$tailLocal1 = $as_sci_Set(this$1.incl__O__sci_SetOps(elem));
          continue;
        }
        var this$2 = $n(alias);
        var referenceResolver = new $c_sjsr_AnonFunction1(((x180) => ((linkSource) => {
          var linkSource$1 = $as_Llaika_internal_link_LinkSource(linkSource);
          return $n(x180).resolveReference__Llaika_internal_link_LinkSource__s_Option(linkSource$1);
        }))(x180));
        var sourceSelector = this$2.Llaika_internal_link_LinkAliasResolver__f_sourceSelector;
        var targetSelector = this$2.Llaika_internal_link_LinkAliasResolver__f_targetSelector;
        var formats = this$2.Llaika_internal_link_LinkAliasResolver__f_formats;
        return new $c_Llaika_internal_link_LinkAliasResolver(sourceSelector, targetSelector, referenceResolver, formats);
      }
      var x = $m_s_None$();
      if ((x === x176)) {
        return alias;
      }
      throw new $c_s_MatchError(x176);
    }
  }
}
/** @constructor */
function $c_Llaika_internal_link_DocumentTargets(document, slugBuilder) {
  this.Llaika_internal_link_DocumentTargets__f_laika$internal$link$DocumentTargets$$slugBuilder = null;
  this.Llaika_internal_link_DocumentTargets__f_laika$internal$link$DocumentTargets$$targetFormats = null;
  this.Llaika_internal_link_DocumentTargets__f_targets = null;
  this.Llaika_internal_link_DocumentTargets__f_laika$internal$link$DocumentTargets$$slugBuilder = slugBuilder;
  var this$1 = $n(document);
  this.Llaika_internal_link_DocumentTargets__f_laika$internal$link$DocumentTargets$$targetFormats = $f_Llaika_ast_TreeContent__targetFormats__Llaika_config_TargetFormats(this$1);
  var levels = new $c_Llaika_internal_link_DocumentTargets$DecoratedHeaderLevels();
  var symbols = new $c_Llaika_internal_link_DocumentTargets$SymbolGenerator();
  var symbolNumbers = new $c_sc_Iterator$$anon$24(1, 1);
  var numbers = new $c_sc_Iterator$$anon$24(1, 1);
  var this$4 = $n($n(document).Llaika_ast_Document__f_content);
  var pf = new $c_Llaika_internal_link_DocumentTargets$$anon$1(symbolNumbers, symbols, numbers, levels, document, this);
  var directTargets = $f_Llaika_ast_ElementTraversal__collect__s_PartialFunction__sci_List(this$4, pf);
  var this$5 = $n(directTargets);
  var m = $as_scm_Map($m_scm_Map$().empty__O());
  var it = this$5.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    var _$1 = $as_Llaika_internal_link_TargetResolver(elem);
    var key = $n(_$1).Llaika_internal_link_TargetResolver__f_selector;
    var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0((() => new $c_scm_ListBuffer()))));
    var this$7 = $n(bldr);
    this$7.addOne__O__scm_Growable(elem);
  }
  var this$8 = $m_sci_HashMap$();
  var result = this$8.sci_HashMap$__f_EmptyMap;
  var mapIt = $n(m).iterator__sc_Iterator();
  while ($n(mapIt).hasNext__Z()) {
    var x1 = $as_T2($n(mapIt).next__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = $n(x1)._1__O();
    var v = $as_scm_Builder($n(x1)._2__O());
    result = $n(result).updated__O__O__sci_HashMap(k, $n(v).result__O());
  }
  var this$9 = $n(result);
  $m_sci_HashMap$();
  var b = new $c_sci_HashMapBuilder();
  var it$1 = this$9.iterator__sc_Iterator();
  while ($n(it$1).hasNext__Z()) {
    var arg1 = $n(it$1).next__O();
    var x$1 = $as_T2(arg1);
    matchResult18: {
      var elem$1___1;
      var elem$1___2;
      if ((x$1 !== null)) {
        var x170 = $as_Llaika_internal_link_Selector($n(x$1)._1__O());
        var x171 = $as_sci_List($n(x$1)._2__O());
        if ($is_Llaika_internal_link_UniqueSelector(x170)) {
          var x175 = $as_Llaika_internal_link_UniqueSelector(x170);
          if ((x171 instanceof $c_sci_$colon$colon)) {
            var x172 = $as_sci_$colon$colon(x171);
            var x174 = $n(x172).sci_$colon$colon__f_next;
            var target = $as_Llaika_internal_link_TargetResolver($n(x172).sci_$colon$colon__f_head);
            var x = $m_sci_Nil$();
            if (x.equals__O__Z(x174)) {
              var elem$1___1 = x175;
              var elem$1___2 = target;
              break matchResult18;
            }
          }
          var this$12 = $m_Llaika_internal_link_TargetResolver$();
          var path = $n(document).path__Llaika_ast_Path();
          var _2 = new $c_Llaika_internal_link_TargetResolver$$anon$6(x175, x171, true, path, this$12);
          var elem$1___1 = x175;
          var elem$1___2 = _2;
          break matchResult18;
        }
        var _2$1 = new $c_Llaika_internal_link_TargetSequenceResolver(x171, x170);
        var elem$1___1 = x170;
        var elem$1___2 = _2$1;
        break matchResult18;
      }
      throw new $c_s_MatchError(x$1);
    }
    $p_sci_HashMapBuilder__ensureUnaliased__V(b);
    var x$2 = elem$1___1;
    var h = $m_sr_Statics$().anyHash__O__I(x$2);
    var im = $m_sc_Hashing$().improve__I__I(h);
    b.update__sci_MapNode__O__O__I__I__I__V(b.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, elem$1___1, elem$1___2, h, im, 0);
  }
  var groupedTargets = b.result__sci_HashMap();
  var this$16 = $n($n(document).config__Llaika_api_config_Config());
  var decoder = $m_Llaika_config_LinkConfig$().Llaika_config_LinkConfig$__f_decoder;
  var defaultKey = $m_Llaika_config_LinkConfig$().Llaika_config_LinkConfig$__f_key;
  var this$17 = $n(this$16.get__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either($n(defaultKey).Llaika_api_config_DefaultKey$$anon$1__f_value, decoder));
  if ((this$17 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$17);
    var b$1 = $n(x2).s_util_Right__f_value;
    var $x_1 = b$1;
  } else {
    var $x_1 = $m_Llaika_config_LinkConfig$().Llaika_config_LinkConfig$__f_empty;
  }
  var linkConfig = $as_Llaika_config_LinkConfig($x_1);
  var targetsFromConfig = $as_sci_Seq($n($n(linkConfig).Llaika_config_LinkConfig$Impl__f_targets).map__F1__O(new $c_sjsr_AnonFunction1(((defn) => {
    var defn$1 = $as_Llaika_config_TargetDefinition(defn);
    var this$19 = $n($n(defn$1).Llaika_config_TargetDefinition$Impl__f_id);
    var id = $as_T(this$19.toLowerCase());
    return this.laika$internal$link$DocumentTargets$$linkDefinitionResolver__Llaika_internal_link_Selector__Llaika_ast_Target__s_Option__Llaika_internal_link_TargetResolver(new $c_Llaika_internal_link_LinkDefinitionSelector(id), $n(defn$1).Llaika_config_TargetDefinition$Impl__f_target, $m_s_None$());
  }))));
  var this$21 = $n(groupedTargets);
  var resolvedTargets = $as_sci_Seq($n($m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$21)).map__F1__O(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1$1 = $as_T2(x$1$2);
    if ((x$1$1 !== null)) {
      var x186 = $as_Llaika_internal_link_TargetResolver($n(x$1$1)._2__O());
      if ((x186 instanceof $c_Llaika_internal_link_LinkAliasResolver)) {
        var alias = $as_Llaika_internal_link_LinkAliasResolver(x186);
        var this$22 = $m_sci_Set$();
        var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_internal_link_TargetIdSelector.getArrayOf().constr)([]));
        return $ps_Llaika_internal_link_DocumentTargets__resolve$1__sci_Map__Llaika_internal_link_LinkAliasResolver__sci_Set__Llaika_internal_link_TargetResolver(groupedTargets, alias, this$22.from__sc_IterableOnce__sci_Set(elems));
      }
      return x186;
    }
    throw new $c_s_MatchError(x$1$1);
  }))));
  var pathTargets = $as_sci_Seq($n(resolvedTargets).flatMap__F1__O(new $c_sjsr_AnonFunction1(((target$1) => {
    var target$2 = $as_Llaika_internal_link_TargetResolver(target$1);
    var x188 = $n(target$2).Llaika_internal_link_TargetResolver__f_selector;
    if ((x188 instanceof $c_Llaika_internal_link_TargetIdSelector)) {
      var x$1$3 = $as_Llaika_internal_link_TargetIdSelector(x188);
      var this$24 = $n(x$1$3);
      var x191 = this$24.Llaika_internal_link_TargetIdSelector__f_id;
      var this$27 = $m_Llaika_internal_link_TargetResolver$();
      var this$25 = $n($n(document).path__Llaika_ast_Path());
      var path$1 = $as_Llaika_ast_Path($f_Llaika_ast_GenericPath__withFragment__T__Llaika_ast_GenericPath(this$25, x191));
      var selector = new $c_Llaika_internal_link_PathSelector(path$1);
      var value = new $c_Llaika_internal_link_TargetResolver$$anon$8(selector, target$2, this$27);
      return new $c_s_Some(value);
    }
    return $m_s_None$();
  }))));
  var this$30 = $m_Llaika_internal_link_TargetResolver$();
  var path$2 = $n(document).path__Llaika_ast_Path();
  var selector$1 = new $c_Llaika_internal_link_PathSelector(path$2);
  var referenceResolver = $m_Llaika_internal_link_ReferenceResolver$().internalLink__Llaika_ast_Path__F1($n(document).path__Llaika_ast_Path());
  var targetResolver = $m_Llaika_internal_link_TargetReplacer$().Llaika_internal_link_TargetReplacer$__f_removeTarget;
  var targetFormats = this.Llaika_internal_link_DocumentTargets__f_laika$internal$link$DocumentTargets$$targetFormats;
  var documentTarget = new $c_Llaika_internal_link_TargetResolver$$anon$2(selector$1, targetFormats, 0, referenceResolver, targetResolver, this$30);
  var this$31 = $n(resolvedTargets);
  var this$32 = $n($as_sc_IterableOps(this$31.appendedAll__sc_IterableOnce__O(pathTargets)));
  var this$33 = $n($as_sc_SeqOps(this$32.concat__sc_IterableOnce__O(targetsFromConfig)));
  this.Llaika_internal_link_DocumentTargets__f_targets = $as_sci_Seq(this$33.appended__O__O(documentTarget));
}
$c_Llaika_internal_link_DocumentTargets.prototype = new $h_O();
$c_Llaika_internal_link_DocumentTargets.prototype.constructor = $c_Llaika_internal_link_DocumentTargets;
/** @constructor */
function $h_Llaika_internal_link_DocumentTargets() {
}
$h_Llaika_internal_link_DocumentTargets.prototype = $c_Llaika_internal_link_DocumentTargets.prototype;
$c_Llaika_internal_link_DocumentTargets.prototype.laika$internal$link$DocumentTargets$$linkDefinitionResolver__Llaika_internal_link_Selector__Llaika_ast_Target__s_Option__Llaika_internal_link_TargetResolver = (function(selector, target, title) {
  var f = new $c_Llaika_internal_link_DocumentTargets$$anon$7(target, title);
  var resolver = new $c_s_PartialFunction$Lifted(f);
  var this$3 = $m_Llaika_internal_link_TargetResolver$();
  var targetResolver = $m_Llaika_internal_link_TargetReplacer$().Llaika_internal_link_TargetReplacer$__f_removeTarget;
  var targetFormats = $m_Llaika_config_TargetFormats$All$();
  return new $c_Llaika_internal_link_TargetResolver$$anon$2(selector, targetFormats, 0, resolver, targetResolver, this$3);
});
var $d_Llaika_internal_link_DocumentTargets = new $TypeData().initClass($c_Llaika_internal_link_DocumentTargets, "laika.internal.link.DocumentTargets", ({
  Llaika_internal_link_DocumentTargets: 1
}));
/** @constructor */
function $c_Llaika_internal_link_DocumentTargets$DecoratedHeaderLevels() {
  this.Llaika_internal_link_DocumentTargets$DecoratedHeaderLevels__f_levelMap = null;
  this.Llaika_internal_link_DocumentTargets$DecoratedHeaderLevels__f_levelIt = null;
  this.Llaika_internal_link_DocumentTargets$DecoratedHeaderLevels__f_levelMap = $as_scm_Map($m_scm_Map$().empty__O());
  this.Llaika_internal_link_DocumentTargets$DecoratedHeaderLevels__f_levelIt = new $c_sc_Iterator$$anon$24(1, 1);
}
$c_Llaika_internal_link_DocumentTargets$DecoratedHeaderLevels.prototype = new $h_O();
$c_Llaika_internal_link_DocumentTargets$DecoratedHeaderLevels.prototype.constructor = $c_Llaika_internal_link_DocumentTargets$DecoratedHeaderLevels;
/** @constructor */
function $h_Llaika_internal_link_DocumentTargets$DecoratedHeaderLevels() {
}
$h_Llaika_internal_link_DocumentTargets$DecoratedHeaderLevels.prototype = $c_Llaika_internal_link_DocumentTargets$DecoratedHeaderLevels.prototype;
$c_Llaika_internal_link_DocumentTargets$DecoratedHeaderLevels.prototype.levelFor__Llaika_ast_HeaderDecoration__I = (function(deco) {
  return $uI($n(this.Llaika_internal_link_DocumentTargets$DecoratedHeaderLevels__f_levelMap).getOrElseUpdate__O__F0__O(deco, new $c_sjsr_AnonFunction0((() => $uI($n(this.Llaika_internal_link_DocumentTargets$DecoratedHeaderLevels__f_levelIt).next__O())))));
});
var $d_Llaika_internal_link_DocumentTargets$DecoratedHeaderLevels = new $TypeData().initClass($c_Llaika_internal_link_DocumentTargets$DecoratedHeaderLevels, "laika.internal.link.DocumentTargets$DecoratedHeaderLevels", ({
  Llaika_internal_link_DocumentTargets$DecoratedHeaderLevels: 1
}));
/** @constructor */
function $c_Llaika_internal_link_DocumentTargets$SymbolGenerator() {
  this.Llaika_internal_link_DocumentTargets$SymbolGenerator__f_symbols = null;
  this.Llaika_internal_link_DocumentTargets$SymbolGenerator__f_stream = null;
  var elems = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([42, 8224, 8225, 167, 182, 35, 9824, 9829, 9830, 9827])));
  this.Llaika_internal_link_DocumentTargets$SymbolGenerator__f_symbols = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var _1 = this.Llaika_internal_link_DocumentTargets$SymbolGenerator__f_symbols;
  var start = new $c_T2(_1, 1);
  var f = new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var sym = $as_sci_List($n(x$1$1)._1__O());
      var num = $uI($n(x$1$1)._2__O());
      if ($n(sym).isEmpty__Z()) {
        var _1$1 = this.Llaika_internal_link_DocumentTargets$SymbolGenerator__f_symbols;
        var _2 = ((1 + num) | 0);
        return new $c_T2(_1$1, _2);
      } else {
        var _1$2 = $n(sym).tail__O();
        return new $c_T2(_1$2, num);
      }
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  this.Llaika_internal_link_DocumentTargets$SymbolGenerator__f_stream = new $c_sc_Iterator$$anon$26(start, f);
}
$c_Llaika_internal_link_DocumentTargets$SymbolGenerator.prototype = new $h_O();
$c_Llaika_internal_link_DocumentTargets$SymbolGenerator.prototype.constructor = $c_Llaika_internal_link_DocumentTargets$SymbolGenerator;
/** @constructor */
function $h_Llaika_internal_link_DocumentTargets$SymbolGenerator() {
}
$h_Llaika_internal_link_DocumentTargets$SymbolGenerator.prototype = $c_Llaika_internal_link_DocumentTargets$SymbolGenerator.prototype;
$c_Llaika_internal_link_DocumentTargets$SymbolGenerator.prototype.next__T = (function() {
  matchResult2: {
    var \u03b41$___1;
    var \u03b41$___2;
    var x4 = $as_T2($n(this.Llaika_internal_link_DocumentTargets$SymbolGenerator__f_stream).next__O());
    if ((x4 !== null)) {
      var sym = $as_sci_List($n(x4)._1__O());
      var num = $uI($n(x4)._2__O());
      var \u03b41$___1 = sym;
      var \u03b41$___2 = num;
      break matchResult2;
    }
    throw new $c_s_MatchError(x4);
  }
  var sym$2 = $as_sci_List(\u03b41$___1);
  var num$2 = $uI(\u03b41$___2);
  var $x_1 = $m_sc_StringOps$();
  var x = $dp_toString__T($n($n(sym$2).head__O()));
  return $n($x_1).$times$extension__T__I__T(x, num$2);
});
var $d_Llaika_internal_link_DocumentTargets$SymbolGenerator = new $TypeData().initClass($c_Llaika_internal_link_DocumentTargets$SymbolGenerator, "laika.internal.link.DocumentTargets$SymbolGenerator", ({
  Llaika_internal_link_DocumentTargets$SymbolGenerator: 1
}));
function $p_Llaika_internal_link_LinkValidator__isExcluded__Llaika_ast_Path__sci_Seq__Z($thiz, path, explicitExclusions) {
  return ($n($thiz.Llaika_internal_link_LinkValidator__f_versionRoots).exists__F1__Z(new $c_sjsr_AnonFunction1(((other) => {
    var other$1 = $as_Llaika_ast_Path(other);
    return $n(path).isSubPath__Llaika_ast_Path__Z(other$1);
  }))) || $n(explicitExclusions).exists__F1__Z(new $c_sjsr_AnonFunction1(((other$2) => {
    var other$3 = $as_Llaika_ast_Path(other$2);
    return $n(path).isSubPath__Llaika_ast_Path__Z(other$3);
  }))));
}
function $p_Llaika_internal_link_LinkValidator__attemptRecovery$1__Llaika_ast_InternalTarget$Resolved__T__Llaika_config_TargetFormats__Llaika_ast_TargetValidation($thiz, resolvedTarget$2, message, targetFormats) {
  matchResult1: {
    var $x_1;
    var _1 = $n(targetFormats).contains__T__Z("html");
    var _2 = $thiz.Llaika_internal_link_LinkValidator__f_siteBaseURL;
    if (((_1 === true) && (_2 instanceof $c_s_Some))) {
      $n(resolvedTarget$2);
      var this$2 = $n(resolvedTarget$2);
      var absolutePath = this$2.Llaika_ast_InternalTarget$Resolved__f_absolutePath;
      var this$3 = $n(resolvedTarget$2);
      var relativePath = this$3.Llaika_ast_InternalTarget$Resolved__f_relativePath;
      var recoveredTarget = new $c_Llaika_ast_InternalTarget$Resolved(absolutePath, relativePath, targetFormats);
      var $x_1 = new $c_Llaika_ast_TargetValidation$RecoveredTarget(message, recoveredTarget);
      break matchResult1;
    }
    var message$1 = (message + " unless html is one of the formats and siteBaseUrl is defined");
    var $x_1 = new $c_Llaika_ast_TargetValidation$InvalidTarget(message$1);
  }
  return $as_Llaika_ast_TargetValidation($x_1);
}
function $ps_Llaika_internal_link_LinkValidator__invalidRefMsg$1__Llaika_ast_InternalTarget$Resolved__T(resolvedTarget$3) {
  return (("cannot reference document '" + $n($n(resolvedTarget$3).Llaika_ast_InternalTarget$Resolved__f_relativePath).toString__T()) + "'");
}
function $p_Llaika_internal_link_LinkValidator__validateFormats$1__Llaika_ast_InternalTarget$Resolved__Llaika_config_TargetFormats__Llaika_ast_TargetValidation($thiz, resolvedTarget$5, targetFormats) {
  var x = $m_Llaika_config_TargetFormats$All$();
  if ((x === targetFormats)) {
    return $m_Llaika_ast_TargetValidation$ValidTarget$();
  }
  var x$3 = $m_Llaika_config_TargetFormats$None$();
  if ((x$3 === targetFormats)) {
    var message = ($ps_Llaika_internal_link_LinkValidator__invalidRefMsg$1__Llaika_ast_InternalTarget$Resolved__T(resolvedTarget$5) + " as it is excluded from rendering");
    return new $c_Llaika_ast_TargetValidation$InvalidTarget(message);
  }
  if ((targetFormats instanceof $c_Llaika_config_TargetFormats$Selected)) {
    var x$1 = $as_Llaika_config_TargetFormats$Selected(targetFormats);
    var this$3 = $n(x$1);
    var x27 = this$3.Llaika_config_TargetFormats$Selected__f_formats;
    var this$4 = $n($n($thiz.Llaika_internal_link_LinkValidator__f_cursor).Llaika_ast_DocumentCursor__f_target);
    var _1 = $f_Llaika_ast_TreeContent__targetFormats__Llaika_config_TargetFormats(this$4);
    var _2 = $thiz.Llaika_internal_link_LinkValidator__f_outputFormat;
    var x6 = new $c_T2(_1, _2);
    var x22 = $as_Llaika_config_TargetFormats(x6.T2__f__1);
    var x23 = $as_s_Option(x6.T2__f__2);
    var x$5 = $m_Llaika_config_TargetFormats$None$();
    if ((x$5 === x22)) {
      return $m_Llaika_ast_TargetValidation$ValidTarget$();
    }
    if ((x23 instanceof $c_s_Some)) {
      var x21 = $as_T($n($as_s_Some(x23)).s_Some__f_value);
      var this$7 = new $c_Lcats_data_NonEmptySetOps(x27);
      var s = this$7.Lcats_data_NonEmptySetOps__f_value;
      var this$9 = $n($as_sci_SortedSet(s));
      if (this$9.contains__O__Z(x21)) {
        return $m_Llaika_ast_TargetValidation$ValidTarget$();
      }
      return $p_Llaika_internal_link_LinkValidator__attemptRecovery$1__Llaika_ast_InternalTarget$Resolved__T__Llaika_config_TargetFormats__Llaika_ast_TargetValidation($thiz, resolvedTarget$5, (((("document for output format " + x21) + " ") + $ps_Llaika_internal_link_LinkValidator__invalidRefMsg$1__Llaika_ast_InternalTarget$Resolved__T(resolvedTarget$5)) + " that does not support this format"), targetFormats);
    }
    var x$7 = $m_Llaika_config_TargetFormats$All$();
    if ((x$7 === x22)) {
      return $p_Llaika_internal_link_LinkValidator__attemptRecovery$1__Llaika_ast_InternalTarget$Resolved__T__Llaika_config_TargetFormats__Llaika_ast_TargetValidation($thiz, resolvedTarget$5, (("document for all output formats " + $ps_Llaika_internal_link_LinkValidator__invalidRefMsg$1__Llaika_ast_InternalTarget$Resolved__T(resolvedTarget$5)) + " with restricted output formats"), targetFormats);
    }
    if ((x22 instanceof $c_Llaika_config_TargetFormats$Selected)) {
      var x$1$1 = $as_Llaika_config_TargetFormats$Selected(x22);
      var this$11 = $n(x$1$1);
      var x11 = this$11.Llaika_config_TargetFormats$Selected__f_formats;
      var missingFormats = new $c_Lcats_data_NonEmptySetOps(x11).filterNot__F1__sci_SortedSet(new $c_sjsr_AnonFunction1(((format) => {
        var format$1 = $as_T(format);
        return $n(targetFormats).contains__T__Z(format$1);
      })));
      if ($n(missingFormats).isEmpty__Z()) {
        return $m_Llaika_ast_TargetValidation$ValidTarget$();
      } else {
        var $x_1 = $ps_Llaika_internal_link_LinkValidator__invalidRefMsg$1__Llaika_ast_InternalTarget$Resolved__T(resolvedTarget$5);
        var this$13 = $n(missingFormats);
        return $p_Llaika_internal_link_LinkValidator__attemptRecovery$1__Llaika_ast_InternalTarget$Resolved__T__Llaika_config_TargetFormats__Llaika_ast_TargetValidation($thiz, resolvedTarget$5, ((($x_1 + " that does not support some of the formats of this document (") + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$13, "", ", ", "")) + ")"), targetFormats);
      }
    }
    throw new $c_s_MatchError(x6);
  }
  throw new $c_s_MatchError(targetFormats);
}
function $p_Llaika_internal_link_LinkValidator__validateTarget$1__Llaika_ast_InternalTarget$Resolved__sci_Seq__Llaika_ast_TargetValidation($thiz, resolvedTarget$4, explicitExclusions) {
  var x28 = $as_s_Option($n($thiz.Llaika_internal_link_LinkValidator__f_findTargetFormats).apply__O__O($n(resolvedTarget$4).Llaika_ast_InternalTarget$Resolved__f_absolutePath));
  var x = $m_s_None$();
  if ((x === x28)) {
    if ($p_Llaika_internal_link_LinkValidator__isExcluded__Llaika_ast_Path__sci_Seq__Z($thiz, $n(resolvedTarget$4).Llaika_ast_InternalTarget$Resolved__f_absolutePath, explicitExclusions)) {
      var this$1 = $n($n($thiz.Llaika_internal_link_LinkValidator__f_cursor).root__Llaika_ast_RootCursor());
      var path = $n($n(resolvedTarget$4).Llaika_ast_InternalTarget$Resolved__f_absolutePath).parent__Llaika_ast_Path();
      var this$2 = $n($n(this$1.Llaika_ast_RootCursor__f_target).selectTreeConfig__Llaika_ast_Path__Llaika_api_config_Config(path));
      var decoder = $m_Llaika_config_TargetFormats$().Llaika_config_TargetFormats$__f_decoder;
      var defaultKey = $m_Llaika_config_TargetFormats$().Llaika_config_TargetFormats$__f_defaultKey;
      var this$3 = $n(this$2.get__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either($n(defaultKey).Llaika_api_config_DefaultKey$$anon$1__f_value, decoder));
      if ((this$3 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(this$3);
        var b = $n(x2).s_util_Right__f_value;
        var $x_1 = b;
      } else {
        var $x_1 = $m_Llaika_config_TargetFormats$All$();
      }
      var formats = $as_Llaika_config_TargetFormats($x_1);
      return $p_Llaika_internal_link_LinkValidator__validateFormats$1__Llaika_ast_InternalTarget$Resolved__Llaika_config_TargetFormats__Llaika_ast_TargetValidation($thiz, resolvedTarget$4, formats);
    }
    var message = ("unresolved internal reference: " + $n($n(resolvedTarget$4).Llaika_ast_InternalTarget$Resolved__f_relativePath).toString__T());
    return new $c_Llaika_ast_TargetValidation$InvalidTarget(message);
  }
  if ((x28 instanceof $c_s_Some)) {
    var targetFormats = $as_Llaika_config_TargetFormats($n($as_s_Some(x28)).s_Some__f_value);
    return $p_Llaika_internal_link_LinkValidator__validateFormats$1__Llaika_ast_InternalTarget$Resolved__Llaika_config_TargetFormats__Llaika_ast_TargetValidation($thiz, resolvedTarget$4, targetFormats);
  }
  throw new $c_s_MatchError(x28);
}
function $p_Llaika_internal_link_LinkValidator__validateTarget$2__Llaika_ast_Link__Llaika_ast_Target__s_util_Either($thiz, link$1, target) {
  if ($is_Llaika_ast_InternalTarget(target)) {
    var it = $as_Llaika_ast_InternalTarget(target);
    var x37 = $thiz.validate__Llaika_ast_InternalTarget__Llaika_ast_TargetValidation(it);
    var x = $m_Llaika_ast_TargetValidation$ValidTarget$();
    if ((x === x37)) {
      return new $c_s_util_Right(link$1);
    }
    if ((x37 instanceof $c_Llaika_ast_TargetValidation$InvalidTarget)) {
      var x$1 = $as_Llaika_ast_TargetValidation$InvalidTarget(x37);
      var this$3 = $n(x$1);
      var x44 = this$3.Llaika_ast_TargetValidation$InvalidTarget__f_message;
      return new $c_s_util_Left(x44);
    }
    if ((x37 instanceof $c_Llaika_ast_TargetValidation$RecoveredTarget)) {
      var x$1$1 = $as_Llaika_ast_TargetValidation$RecoveredTarget(x37);
      var this$6 = $n(x$1$1);
      var x40 = this$6.Llaika_ast_TargetValidation$RecoveredTarget__f_message;
      var this$7 = $n(x$1$1);
      var x41 = this$7.Llaika_ast_TargetValidation$RecoveredTarget__f_recoveredTarget;
      if ($is_Llaika_ast_GlobalLink(link$1)) {
        var gl = $as_Llaika_ast_GlobalLink(link$1);
        if ($n(gl).supportsExternalTargets__Z()) {
          var value = $n(gl).withTarget__Llaika_ast_Target__Llaika_ast_GlobalLink(x41);
          return new $c_s_util_Right(value);
        }
      }
      return new $c_s_util_Left(x40);
    }
    throw new $c_s_MatchError(x37);
  } else {
    return new $c_s_util_Right(link$1);
  }
}
/** @constructor */
function $c_Llaika_internal_link_LinkValidator(cursor, findTargetFormats) {
  this.Llaika_internal_link_LinkValidator__f_cursor = null;
  this.Llaika_internal_link_LinkValidator__f_findTargetFormats = null;
  this.Llaika_internal_link_LinkValidator__f_outputFormat = null;
  this.Llaika_internal_link_LinkValidator__f_siteBaseURL = null;
  this.Llaika_internal_link_LinkValidator__f_versionRoots = null;
  this.Llaika_internal_link_LinkValidator__f_validationConfig = null;
  this.Llaika_internal_link_LinkValidator__f_cursor = cursor;
  this.Llaika_internal_link_LinkValidator__f_findTargetFormats = findTargetFormats;
  var this$1 = $n($n($n(cursor).root__Llaika_ast_RootCursor()).Llaika_ast_RootCursor__f_outputContext);
  if (this$1.isEmpty__Z()) {
    var $x_1 = $m_s_None$();
  } else {
    var arg1 = this$1.get__O();
    var _$1 = $as_Llaika_ast_OutputContext(arg1);
    var $x_1 = new $c_s_Some($n(_$1).Llaika_ast_OutputContext$Impl__f_formatSelector);
  }
  this.Llaika_internal_link_LinkValidator__f_outputFormat = $x_1;
  var this$2 = $n($n(cursor).Llaika_ast_DocumentCursor__f_config);
  var key = $m_Llaika_config_LaikaKeys$().Llaika_config_LaikaKeys$__f_siteBaseURL;
  var decoder = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
  var $x_2 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$2, key, decoder)).toOption__s_Option();
  var this$3 = $m_s_$less$colon$less$();
  this.Llaika_internal_link_LinkValidator__f_siteBaseURL = $n($x_2).flatten__s_$less$colon$less__s_Option(this$3.s_$less$colon$less$__f_singleton);
  var this$4 = $n($n(cursor).Llaika_ast_DocumentCursor__f_config);
  var decoder$1 = $m_Llaika_config_Versions$().Llaika_config_Versions$__f_decoder;
  var defaultKey = $m_Llaika_config_Versions$().Llaika_config_Versions$__f_key;
  var key$1 = $n(defaultKey).Llaika_api_config_DefaultKey$$anon$1__f_value;
  var $x_3 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$4, key$1, decoder$1)).toOption__s_Option();
  var this$5 = $m_s_$less$colon$less$();
  var this$6 = $n($n($x_3).flatten__s_$less$colon$less__s_Option(this$5.s_$less$colon$less$__f_singleton));
  if (this$6.isEmpty__Z()) {
    var $x_4 = $m_s_None$();
  } else {
    var arg1$1 = this$6.get__O();
    var vs = $as_Llaika_config_Versions(arg1$1);
    var $x_4 = new $c_s_Some($as_sci_Seq($n($n(vs).allVersions__sci_Seq()).map__F1__O(new $c_sjsr_AnonFunction1(((v) => {
      var v$1 = $as_Llaika_config_Version(v);
      var this$7 = $m_Llaika_ast_Path$Root$();
      var name = $n(v$1).Llaika_config_Version$Impl__f_pathSegment;
      var this$8 = $n($f_Llaika_ast_GenericPath__$div__T__Llaika_ast_GenericPath(this$7, name));
      return $n($as_Llaika_ast_Path($f_Llaika_ast_GenericPath__$div__T__Llaika_ast_GenericPath(this$8, "doc"))).parent__Llaika_ast_Path();
    })))));
  }
  var this$9 = $n($x_4);
  var this$10 = $n($as_sc_IterableOnceOps((this$9.isEmpty__Z() ? $m_sci_Nil$() : this$9.get__O())));
  this.Llaika_internal_link_LinkValidator__f_versionRoots = $m_sci_Set$().from__sc_IterableOnce__sci_Set($as_sc_IterableOnce(this$10));
  var this$11 = $n($n(cursor).Llaika_ast_DocumentCursor__f_config);
  var decoder$2 = $m_Llaika_config_LinkValidation$().Llaika_config_LinkValidation$__f_decoder;
  var defaultKey$1 = $m_Llaika_config_LinkValidation$().Llaika_config_LinkValidation$__f_key;
  var this$12 = $n(this$11.get__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either($n(defaultKey$1).Llaika_api_config_DefaultKey$$anon$1__f_value, decoder$2));
  if ((this$12 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$12);
    var b = $n(x2).s_util_Right__f_value;
    var $x_5 = b;
  } else {
    var $x_5 = $m_Llaika_config_LinkValidation$Local$();
  }
  this.Llaika_internal_link_LinkValidator__f_validationConfig = $as_Llaika_config_LinkValidation($x_5);
}
$c_Llaika_internal_link_LinkValidator.prototype = new $h_O();
$c_Llaika_internal_link_LinkValidator.prototype.constructor = $c_Llaika_internal_link_LinkValidator;
/** @constructor */
function $h_Llaika_internal_link_LinkValidator() {
}
$h_Llaika_internal_link_LinkValidator.prototype = $c_Llaika_internal_link_LinkValidator.prototype;
$c_Llaika_internal_link_LinkValidator.prototype.validate__Llaika_ast_InternalTarget__Llaika_ast_TargetValidation = (function(target) {
  var resolvedTarget = $n(target).relativeTo__Llaika_ast_Path__Llaika_ast_InternalTarget$Resolved($n(this.Llaika_internal_link_LinkValidator__f_cursor).Llaika_ast_DocumentCursor__f_path);
  var x31 = this.Llaika_internal_link_LinkValidator__f_validationConfig;
  var x = $m_Llaika_config_LinkValidation$Off$();
  if ((x === x31)) {
    return $m_Llaika_ast_TargetValidation$ValidTarget$();
  }
  var x$3 = $m_Llaika_config_LinkValidation$Local$();
  if ((x$3 === x31)) {
    if ((!($n(resolvedTarget).Llaika_ast_InternalTarget$Resolved__f_relativePath instanceof $c_Llaika_ast_RelativePath$CurrentDocument))) {
      return $m_Llaika_ast_TargetValidation$ValidTarget$();
    }
    return $p_Llaika_internal_link_LinkValidator__validateTarget$1__Llaika_ast_InternalTarget$Resolved__sci_Seq__Llaika_ast_TargetValidation(this, resolvedTarget, $m_sci_Nil$());
  }
  if ((x31 instanceof $c_Llaika_config_LinkValidation$Global)) {
    var x$1 = $as_Llaika_config_LinkValidation$Global(x31);
    var this$2 = $n(x$1);
    var x34 = this$2.Llaika_config_LinkValidation$Global__f_excluded;
    return $p_Llaika_internal_link_LinkValidator__validateTarget$1__Llaika_ast_InternalTarget$Resolved__sci_Seq__Llaika_ast_TargetValidation(this, resolvedTarget, x34);
  }
  throw new $c_s_MatchError(x31);
});
$c_Llaika_internal_link_LinkValidator.prototype.validate__Llaika_ast_Link__s_util_Either = (function(link) {
  if ($is_Llaika_ast_GlobalLink(link)) {
    var gl = $as_Llaika_ast_GlobalLink(link);
    return $p_Llaika_internal_link_LinkValidator__validateTarget$2__Llaika_ast_Link__Llaika_ast_Target__s_util_Either(this, link, $n(gl).target__Llaika_ast_Target());
  }
  if ($is_Llaika_ast_LocalLink(link)) {
    var ll = $as_Llaika_ast_LocalLink(link);
    return $p_Llaika_internal_link_LinkValidator__validateTarget$2__Llaika_ast_Link__Llaika_ast_Target__s_util_Either(this, link, $m_Llaika_ast_InternalTarget$().apply__Llaika_ast_VirtualPath__Llaika_ast_InternalTarget($m_Llaika_ast_RelativePath$CurrentDocument$().apply__T__Llaika_ast_RelativePath$CurrentDocument($n(ll).refId__T())));
  }
  throw new $c_s_MatchError(link);
});
$c_Llaika_internal_link_LinkValidator.prototype.validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span = (function(link, source) {
  var eab = this.validate__Llaika_ast_Link__s_util_Either(link);
  matchResult9: {
    var $x_1;
    if ((eab instanceof $c_s_util_Left)) {
      var a = $n($as_s_util_Left(eab)).s_util_Left__f_value;
      var _$2 = $as_T(a);
      var $x_1 = $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan(_$2, source);
      break matchResult9;
    }
    if ((eab instanceof $c_s_util_Right)) {
      var b = $n($as_s_util_Right(eab)).s_util_Right__f_value;
      var $x_1 = b;
      break matchResult9;
    }
    throw new $c_s_MatchError(eab);
  }
  return $as_Llaika_ast_Span($x_1);
});
var $d_Llaika_internal_link_LinkValidator = new $TypeData().initClass($c_Llaika_internal_link_LinkValidator, "laika.internal.link.LinkValidator", ({
  Llaika_internal_link_LinkValidator: 1
}));
/** @constructor */
function $c_Llaika_internal_link_ReferenceResolver$() {
}
$c_Llaika_internal_link_ReferenceResolver$.prototype = new $h_O();
$c_Llaika_internal_link_ReferenceResolver$.prototype.constructor = $c_Llaika_internal_link_ReferenceResolver$;
/** @constructor */
function $h_Llaika_internal_link_ReferenceResolver$() {
}
$h_Llaika_internal_link_ReferenceResolver$.prototype = $c_Llaika_internal_link_ReferenceResolver$.prototype;
$c_Llaika_internal_link_ReferenceResolver$.prototype.internalLink__Llaika_ast_Path__F1 = (function(target) {
  var f = new $c_Llaika_internal_link_ReferenceResolver$$anon$1(target, this);
  return new $c_s_PartialFunction$Lifted(f);
});
$c_Llaika_internal_link_ReferenceResolver$.prototype.resolveTarget__Llaika_ast_VirtualPath__Llaika_ast_Path__Llaika_ast_Target = (function(target, refPath) {
  matchResult6: {
    var $x_1;
    if ($is_Llaika_ast_RelativePath(target)) {
      var rp = $as_Llaika_ast_RelativePath(target);
      if (($n(rp).parentLevels__I() >= $n(refPath).depth__I())) {
        var url = $n(target).toString__T();
        var $x_1 = new $c_Llaika_ast_ExternalTarget(url);
        break matchResult6;
      }
    }
    var $x_1 = $n($m_Llaika_ast_InternalTarget$().apply__Llaika_ast_VirtualPath__Llaika_ast_InternalTarget(target)).relativeTo__Llaika_ast_Path__Llaika_ast_InternalTarget$Resolved(refPath);
  }
  return $as_Llaika_ast_Target($x_1);
});
$c_Llaika_internal_link_ReferenceResolver$.prototype.resolveTarget__Llaika_ast_Target__Llaika_ast_Path__Llaika_ast_Target = (function(target, refPath) {
  if ((target instanceof $c_Llaika_ast_InternalTarget$Relative)) {
    var it = $as_Llaika_ast_InternalTarget$Relative(target);
    return this.resolveTarget__Llaika_ast_VirtualPath__Llaika_ast_Path__Llaika_ast_Target($n(it).Llaika_ast_InternalTarget$Relative__f_path, refPath);
  } else if ($is_Llaika_ast_InternalTarget(target)) {
    var it$2 = $as_Llaika_ast_InternalTarget(target);
    return $n(it$2).relativeTo__Llaika_ast_Path__Llaika_ast_InternalTarget$Resolved(refPath);
  } else {
    return target;
  }
});
var $d_Llaika_internal_link_ReferenceResolver$ = new $TypeData().initClass($c_Llaika_internal_link_ReferenceResolver$, "laika.internal.link.ReferenceResolver$", ({
  Llaika_internal_link_ReferenceResolver$: 1
}));
var $n_Llaika_internal_link_ReferenceResolver$;
function $m_Llaika_internal_link_ReferenceResolver$() {
  if ((!$n_Llaika_internal_link_ReferenceResolver$)) {
    $n_Llaika_internal_link_ReferenceResolver$ = new $c_Llaika_internal_link_ReferenceResolver$();
  }
  return $n_Llaika_internal_link_ReferenceResolver$;
}
function $is_Llaika_internal_link_Selector(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_internal_link_Selector)));
}
function $as_Llaika_internal_link_Selector(obj) {
  return (($is_Llaika_internal_link_Selector(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.link.Selector"));
}
function $isArrayOf_Llaika_internal_link_Selector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_link_Selector)));
}
function $asArrayOf_Llaika_internal_link_Selector(obj, depth) {
  return (($isArrayOf_Llaika_internal_link_Selector(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.link.Selector;", depth));
}
function $p_Llaika_internal_link_TargetLookup$DocumentLookup__ids__sci_Set($thiz) {
  if ((!$thiz.Llaika_internal_link_TargetLookup$DocumentLookup__f_idsbitmap$1)) {
    var this$1 = $n($thiz.Llaika_internal_link_TargetLookup$DocumentLookup__f_content);
    var pf = new $c_Llaika_internal_link_TargetLookup$$anon$1();
    var this$4 = $n($f_Llaika_ast_ElementTraversal__collect__s_PartialFunction__sci_List(this$1, pf));
    var this$3 = $m_s_$less$colon$less$();
    var toIterableOnce = this$3.s_$less$colon$less$__f_singleton;
    var this$5 = $n($as_sc_IterableOnceOps($f_sc_StrictOptimizedIterableOps__flatten__F1__O(this$4, toIterableOnce)));
    $thiz.Llaika_internal_link_TargetLookup$DocumentLookup__f_ids$lzy1 = $m_sci_Set$().from__sc_IterableOnce__sci_Set($as_sc_IterableOnce(this$5));
    $thiz.Llaika_internal_link_TargetLookup$DocumentLookup__f_idsbitmap$1 = true;
    $thiz.Llaika_internal_link_TargetLookup$DocumentLookup__f_content = null;
  }
  return $thiz.Llaika_internal_link_TargetLookup$DocumentLookup__f_ids$lzy1;
}
/** @constructor */
function $c_Llaika_internal_link_TargetLookup$DocumentLookup(content, config) {
  this.Llaika_internal_link_TargetLookup$DocumentLookup__f_content = null;
  this.Llaika_internal_link_TargetLookup$DocumentLookup__f_config = null;
  this.Llaika_internal_link_TargetLookup$DocumentLookup__f_ids$lzy1 = null;
  this.Llaika_internal_link_TargetLookup$DocumentLookup__f_idsbitmap$1 = false;
  this.Llaika_internal_link_TargetLookup$DocumentLookup__f_formats$lzy1 = null;
  this.Llaika_internal_link_TargetLookup$DocumentLookup__f_formatsbitmap$1 = false;
  this.Llaika_internal_link_TargetLookup$DocumentLookup__f_content = content;
  this.Llaika_internal_link_TargetLookup$DocumentLookup__f_config = config;
}
$c_Llaika_internal_link_TargetLookup$DocumentLookup.prototype = new $h_O();
$c_Llaika_internal_link_TargetLookup$DocumentLookup.prototype.constructor = $c_Llaika_internal_link_TargetLookup$DocumentLookup;
/** @constructor */
function $h_Llaika_internal_link_TargetLookup$DocumentLookup() {
}
$h_Llaika_internal_link_TargetLookup$DocumentLookup.prototype = $c_Llaika_internal_link_TargetLookup$DocumentLookup.prototype;
$c_Llaika_internal_link_TargetLookup$DocumentLookup.prototype.formats__Llaika_config_TargetFormats = (function() {
  if ((!this.Llaika_internal_link_TargetLookup$DocumentLookup__f_formatsbitmap$1)) {
    var this$1 = $n(this.Llaika_internal_link_TargetLookup$DocumentLookup__f_config);
    var decoder = $m_Llaika_config_TargetFormats$().Llaika_config_TargetFormats$__f_decoder;
    var defaultKey = $m_Llaika_config_TargetFormats$().Llaika_config_TargetFormats$__f_defaultKey;
    var this$2 = $n(this$1.get__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either($n(defaultKey).Llaika_api_config_DefaultKey$$anon$1__f_value, decoder));
    if ((this$2 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$2);
      var b = $n(x2).s_util_Right__f_value;
      var $x_1 = b;
    } else {
      var $x_1 = $m_Llaika_config_TargetFormats$All$();
    }
    this.Llaika_internal_link_TargetLookup$DocumentLookup__f_formats$lzy1 = $as_Llaika_config_TargetFormats($x_1);
    this.Llaika_internal_link_TargetLookup$DocumentLookup__f_formatsbitmap$1 = true;
    this.Llaika_internal_link_TargetLookup$DocumentLookup__f_config = null;
  }
  return this.Llaika_internal_link_TargetLookup$DocumentLookup__f_formats$lzy1;
});
$c_Llaika_internal_link_TargetLookup$DocumentLookup.prototype.hasTarget__Llaika_ast_Path__Z = (function(path) {
  var x52 = $n(path).fragment__s_Option();
  var x = $m_s_None$();
  if ((x === x52)) {
    return true;
  }
  if ((x52 instanceof $c_s_Some)) {
    var fragment = $as_T($n($as_s_Some(x52)).s_Some__f_value);
    return $n($p_Llaika_internal_link_TargetLookup$DocumentLookup__ids__sci_Set(this)).contains__O__Z(fragment);
  }
  throw new $c_s_MatchError(x52);
});
function $as_Llaika_internal_link_TargetLookup$DocumentLookup(obj) {
  return (((obj instanceof $c_Llaika_internal_link_TargetLookup$DocumentLookup) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.link.TargetLookup$DocumentLookup"));
}
function $isArrayOf_Llaika_internal_link_TargetLookup$DocumentLookup(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_link_TargetLookup$DocumentLookup)));
}
function $asArrayOf_Llaika_internal_link_TargetLookup$DocumentLookup(obj, depth) {
  return (($isArrayOf_Llaika_internal_link_TargetLookup$DocumentLookup(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.link.TargetLookup$DocumentLookup;", depth));
}
var $d_Llaika_internal_link_TargetLookup$DocumentLookup = new $TypeData().initClass($c_Llaika_internal_link_TargetLookup$DocumentLookup, "laika.internal.link.TargetLookup$DocumentLookup", ({
  Llaika_internal_link_TargetLookup$DocumentLookup: 1
}));
/** @constructor */
function $c_Llaika_internal_link_TargetReplacer$() {
  this.Llaika_internal_link_TargetReplacer$__f_removeTarget = null;
  $n_Llaika_internal_link_TargetReplacer$ = this;
  var x$1 = $m_s_None$();
  this.Llaika_internal_link_TargetReplacer$__f_removeTarget = new $c_sjsr_AnonFunction1(((y) => {
    $as_Llaika_ast_Block(y);
    return x$1;
  }));
}
$c_Llaika_internal_link_TargetReplacer$.prototype = new $h_O();
$c_Llaika_internal_link_TargetReplacer$.prototype.constructor = $c_Llaika_internal_link_TargetReplacer$;
/** @constructor */
function $h_Llaika_internal_link_TargetReplacer$() {
}
$h_Llaika_internal_link_TargetReplacer$.prototype = $c_Llaika_internal_link_TargetReplacer$.prototype;
$c_Llaika_internal_link_TargetReplacer$.prototype.addId__T__F1 = (function(id) {
  return new $c_sjsr_AnonFunction1(((block) => {
    var block$1 = $as_Llaika_ast_Block(block);
    var value = $n($as_Llaika_ast_Element(block$1)).withId__T__Llaika_ast_Element(id);
    return new $c_s_Some(value);
  }));
});
var $d_Llaika_internal_link_TargetReplacer$ = new $TypeData().initClass($c_Llaika_internal_link_TargetReplacer$, "laika.internal.link.TargetReplacer$", ({
  Llaika_internal_link_TargetReplacer$: 1
}));
var $n_Llaika_internal_link_TargetReplacer$;
function $m_Llaika_internal_link_TargetReplacer$() {
  if ((!$n_Llaika_internal_link_TargetReplacer$)) {
    $n_Llaika_internal_link_TargetReplacer$ = new $c_Llaika_internal_link_TargetReplacer$();
  }
  return $n_Llaika_internal_link_TargetReplacer$;
}
function $ct_Llaika_internal_link_TargetResolver__Llaika_internal_link_Selector__Llaika_config_TargetFormats__I__($thiz, selector, targetFormats, precedence) {
  $thiz.Llaika_internal_link_TargetResolver__f_selector = selector;
  $thiz.Llaika_internal_link_TargetResolver__f_targetFormats = targetFormats;
  $thiz.Llaika_internal_link_TargetResolver__f_precedence = precedence;
  return $thiz;
}
/** @constructor */
function $c_Llaika_internal_link_TargetResolver() {
  this.Llaika_internal_link_TargetResolver__f_selector = null;
  this.Llaika_internal_link_TargetResolver__f_targetFormats = null;
  this.Llaika_internal_link_TargetResolver__f_precedence = 0;
}
$c_Llaika_internal_link_TargetResolver.prototype = new $h_O();
$c_Llaika_internal_link_TargetResolver.prototype.constructor = $c_Llaika_internal_link_TargetResolver;
/** @constructor */
function $h_Llaika_internal_link_TargetResolver() {
}
$h_Llaika_internal_link_TargetResolver.prototype = $c_Llaika_internal_link_TargetResolver.prototype;
function $as_Llaika_internal_link_TargetResolver(obj) {
  return (((obj instanceof $c_Llaika_internal_link_TargetResolver) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.link.TargetResolver"));
}
function $isArrayOf_Llaika_internal_link_TargetResolver(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_link_TargetResolver)));
}
function $asArrayOf_Llaika_internal_link_TargetResolver(obj, depth) {
  return (($isArrayOf_Llaika_internal_link_TargetResolver(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.link.TargetResolver;", depth));
}
/** @constructor */
function $c_Llaika_internal_link_TargetResolver$() {
}
$c_Llaika_internal_link_TargetResolver$.prototype = new $h_O();
$c_Llaika_internal_link_TargetResolver$.prototype.constructor = $c_Llaika_internal_link_TargetResolver$;
/** @constructor */
function $h_Llaika_internal_link_TargetResolver$() {
}
$h_Llaika_internal_link_TargetResolver$.prototype = $c_Llaika_internal_link_TargetResolver$.prototype;
var $d_Llaika_internal_link_TargetResolver$ = new $TypeData().initClass($c_Llaika_internal_link_TargetResolver$, "laika.internal.link.TargetResolver$", ({
  Llaika_internal_link_TargetResolver$: 1
}));
var $n_Llaika_internal_link_TargetResolver$;
function $m_Llaika_internal_link_TargetResolver$() {
  if ((!$n_Llaika_internal_link_TargetResolver$)) {
    $n_Llaika_internal_link_TargetResolver$ = new $c_Llaika_internal_link_TargetResolver$();
  }
  return $n_Llaika_internal_link_TargetResolver$;
}
function $ps_Llaika_internal_link_TreeTargets__allPaths$1__Llaika_ast_Path__sci_Seq(path) {
  var x$2 = $m_Llaika_ast_Path$Root$();
  if (((path !== null) && $n(path).equals__O__Z(x$2))) {
    return $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Path$Root$.getArrayOf().constr)([$m_Llaika_ast_Path$Root$()]))));
  } else {
    var this$1 = $n($ps_Llaika_internal_link_TreeTargets__allPaths$1__Llaika_ast_Path__sci_Seq($n(path).parent__Llaika_ast_Path()));
    return $as_sci_Seq(this$1.appended__O__O(path));
  }
}
function $ps_Llaika_internal_link_TreeTargets__mapToKeys$1__sci_Seq__sci_Seq__sci_Seq(paths, targets) {
  return $as_sci_Seq($n(paths).flatMap__F1__O(new $c_sjsr_AnonFunction1(((path) => {
    var path$1 = $as_Llaika_ast_Path(path);
    return $as_sc_IterableOnce($n(targets).map__F1__O(new $c_sjsr_AnonFunction1(((target) => {
      var target$1 = $as_Llaika_internal_link_TargetResolver(target);
      var _2 = $n(target$1).Llaika_internal_link_TargetResolver__f_selector;
      var _1 = new $c_T2(path$1, _2);
      return new $c_T2(_1, target$1);
    }))));
  }))));
}
function $ps_Llaika_internal_link_TreeTargets__staticTarget$1__Llaika_ast_StaticDocument__Llaika_internal_link_TargetResolver(doc) {
  var this$2 = $m_Llaika_internal_link_TargetResolver$();
  var path = $n(doc).path__Llaika_ast_Path();
  var selector = new $c_Llaika_internal_link_PathSelector(path);
  var referenceResolver = $m_Llaika_internal_link_ReferenceResolver$().internalLink__Llaika_ast_Path__F1($n(doc).path__Llaika_ast_Path());
  var targetResolver = $m_Llaika_internal_link_TargetReplacer$().Llaika_internal_link_TargetReplacer$__f_removeTarget;
  var targetFormats = $n(doc).formats__Llaika_config_TargetFormats();
  return new $c_Llaika_internal_link_TargetResolver$$anon$2(selector, targetFormats, 0, referenceResolver, targetResolver, this$2);
}
/** @constructor */
function $c_Llaika_internal_link_TreeTargets(root, slugBuilder) {
  this.Llaika_internal_link_TreeTargets__f_targetMap = null;
  var targets$1 = $as_sci_Seq($n($n(root).allDocuments__sci_Seq()).flatMap__F1__O(new $c_sjsr_AnonFunction1(((doc) => {
    var doc$1 = $as_Llaika_ast_Document(doc);
    var targets = new $c_Llaika_internal_link_DocumentTargets(doc$1, slugBuilder).Llaika_internal_link_DocumentTargets__f_targets;
    var x = $n(doc$1).path__Llaika_ast_Path();
    var x$2 = $m_Llaika_ast_Path$Root$();
    if (((x !== null) && $n(x).equals__O__Z(x$2))) {
      var global = $m_sci_Nil$();
    } else {
      var global = $ps_Llaika_internal_link_TreeTargets__mapToKeys$1__sci_Seq__sci_Seq__sci_Seq($ps_Llaika_internal_link_TreeTargets__allPaths$1__Llaika_ast_Path__sci_Seq($n($n(doc$1).path__Llaika_ast_Path()).parent__Llaika_ast_Path()), $as_sci_Seq($n(targets).filter__F1__O(new $c_sjsr_AnonFunction1(((_$1) => {
        var _$1$1 = $as_Llaika_internal_link_TargetResolver(_$1);
        return $n($n(_$1$1).Llaika_internal_link_TargetResolver__f_selector).global__Z();
      })))));
    }
    var local = $ps_Llaika_internal_link_TreeTargets__mapToKeys$1__sci_Seq__sci_Seq__sci_Seq($as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Path.getArrayOf().constr)([$n(doc$1).path__Llaika_ast_Path()])))), targets);
    var this$1 = $n(global);
    return $as_sc_IterableOnce(this$1.appendedAll__sc_IterableOnce__O(local));
  }))));
  var static$1 = $as_sci_Seq($n($n(root).Llaika_ast_DocumentTreeRoot__f_staticDocuments).map__F1__O(new $c_sjsr_AnonFunction1(((doc$2) => {
    var doc$3 = $as_Llaika_ast_StaticDocument(doc$2);
    var _1 = $m_Llaika_ast_Path$Root$();
    var path = $n(doc$3).path__Llaika_ast_Path();
    var _2 = new $c_Llaika_internal_link_PathSelector(path);
    var _1$1 = new $c_T2(_1, _2);
    var _2$1 = $ps_Llaika_internal_link_TreeTargets__staticTarget$1__Llaika_ast_StaticDocument__Llaika_internal_link_TargetResolver(doc$3);
    return new $c_T2(_1$1, _2$1);
  }))));
  var this$5 = $n(targets$1);
  var this$6 = $n($as_sc_IterableOps(this$5.appendedAll__sc_IterableOnce__O(static$1)));
  var m = $as_scm_Map($m_scm_Map$().empty__O());
  var it = this$6.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    var _$2 = $as_T2(elem);
    var key = $as_T2($n(_$2)._1__O());
    var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0(((this$6) => (() => this$6.newSpecificBuilder__scm_Builder()))(this$6))));
    var this$7 = $n(bldr);
    this$7.addOne__O__scm_Growable(elem);
  }
  var this$8 = $m_sci_HashMap$();
  var result = this$8.sci_HashMap$__f_EmptyMap;
  var mapIt = $n(m).iterator__sc_Iterator();
  while ($n(mapIt).hasNext__Z()) {
    var x1 = $as_T2($n(mapIt).next__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = $n(x1)._1__O();
    var v = $as_scm_Builder($n(x1)._2__O());
    result = $n(result).updated__O__O__sci_HashMap(k, $n(v).result__O());
  }
  var this$9 = $n(result);
  var pf = new $c_Llaika_internal_link_TreeTargets$$anon$1();
  this.Llaika_internal_link_TreeTargets__f_targetMap = $as_sci_Map($f_sc_StrictOptimizedMapOps__collect__s_PartialFunction__sc_IterableOps(this$9, pf));
}
$c_Llaika_internal_link_TreeTargets.prototype = new $h_O();
$c_Llaika_internal_link_TreeTargets.prototype.constructor = $c_Llaika_internal_link_TreeTargets;
/** @constructor */
function $h_Llaika_internal_link_TreeTargets() {
}
$h_Llaika_internal_link_TreeTargets.prototype = $c_Llaika_internal_link_TreeTargets.prototype;
$c_Llaika_internal_link_TreeTargets.prototype.select__Llaika_ast_Path__Llaika_internal_link_Selector__s_Option = (function(scope, selector) {
  return $n(this.Llaika_internal_link_TreeTargets__f_targetMap).get__O__s_Option(new $c_T2(scope, selector));
});
var $d_Llaika_internal_link_TreeTargets = new $TypeData().initClass($c_Llaika_internal_link_TreeTargets, "laika.internal.link.TreeTargets", ({
  Llaika_internal_link_TreeTargets: 1
}));
function $p_Llaika_internal_markdown_BlockParsers$__decoratedBlock__Llaika_parse_Parser__Llaika_parse_Parser__Llaika_parse_Parser__Llaika_parse_Parser($thiz, firstLinePrefix, linePrefix, nextBlockPrefix) {
  var this$1 = $m_Llaika_parse_builders$();
  var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([13])));
  var skipLine = $n($n($f_Llaika_parse_text_TextParsers__anyNot__C__sci_Seq__Llaika_parse_text_Characters(this$1, 10, chars)).void__Llaika_parse_text_Characters()).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser($m_Llaika_parse_builders$().Llaika_parse_builders$__f_eol);
  var this$3 = $m_Llaika_parse_builders$();
  var $x_1 = $n(skipLine);
  var this$2 = $m_Llaika_parse_builders$();
  var p = $thiz.Llaika_internal_markdown_BlockParsers$__f_setextDecoration;
  var p$1 = $n($x_1).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($f_Llaika_parse_combinator_Parsers__not__Llaika_parse_Parser__Llaika_parse_Parser(this$2, p));
  var noHeader = $f_Llaika_parse_combinator_Parsers__lookAhead__Llaika_parse_Parser__Llaika_parse_Parser(this$3, p$1);
  return $thiz.mdBlock__Llaika_parse_Parser__Llaika_parse_Parser__Llaika_parse_Parser__Llaika_parse_Parser($n(noHeader).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(firstLinePrefix), linePrefix, nextBlockPrefix);
}
function $p_Llaika_internal_markdown_BlockParsers$__headerOrParagraph__Llaika_parse_markup_RecursiveParsers__Llaika_api_bundle_BlockPosition__Llaika_parse_Parser($thiz, recParsers, pos) {
  var interruptions = $n(recParsers).paragraphInterruptions__Llaika_api_bundle_BlockPosition__Llaika_parse_Parser(pos);
  var this$1 = $m_Llaika_parse_builders$();
  var p = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_blankLine;
  var $x_1 = $n($f_Llaika_parse_combinator_Parsers__not__Llaika_parse_Parser__Llaika_parse_Parser(this$1, p));
  var p$1 = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_restOfLine;
  var line = $n($x_1).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($m_Llaika_parse_syntax$StringParserOps$().line$extension__Llaika_parse_Parser__Llaika_parse_Parser(p$1));
  var this$6 = $n($n(interruptions).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((res) => {
    var res$1 = $as_Llaika_ast_Block(res);
    var _1 = $m_sci_Nil$();
    var _2 = new $c_s_Some(res$1);
    return new $c_T2(_1, _2);
  }))));
  var p$2 = new $c_sjsr_AnonFunction0((() => $n(line).repUntil__Llaika_parse_Parser__Llaika_parse_Parser(interruptions)));
  var lineAndCond = this$6.orElse__F0__Llaika_parse_Parser(p$2);
  var this$9 = $n($n($thiz.Llaika_internal_markdown_BlockParsers$__f_setextDecoration).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$3) => {
    var _$3$1 = $as_T(_$3);
    return new $c_s_util_Left(_$3$1);
  }))));
  var p$3 = new $c_sjsr_AnonFunction0((() => $n(lineAndCond).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$4) => {
    var _$4$1 = $as_T2(_$4);
    return new $c_s_util_Right(_$4$1);
  })))));
  var decorationOrLines = this$9.orElse__F0__Llaika_parse_Parser(p$3);
  var p$4 = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_textLine;
  return $n($n($m_Llaika_parse_syntax$StringParserOps$().line$extension__Llaika_parse_Parser__Llaika_parse_Parser(p$4)).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(decorationOrLines)).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Llaika_parse_builders$$tilde(x$1);
    matchResult1: {
      var $x_2;
      if ((x$1$1 !== null)) {
        var x17 = $as_Llaika_parse_LineSource($n(x$1$1).Llaika_parse_builders$$tilde__f__1);
        var x18 = $as_s_util_Either($n(x$1$1).Llaika_parse_builders$$tilde__f__2);
        if ((x18 instanceof $c_s_util_Right)) {
          var x20 = $as_T2($n($as_s_util_Right(x18)).s_util_Right__f_value);
          if ((x20 !== null)) {
            var x21 = $as_sci_Seq($n(x20)._1__O());
            var x22 = $as_s_Option($n(x20)._2__O());
            var x = $m_s_None$();
            if ((x === x22)) {
              var $x_2 = $p_Llaika_internal_markdown_BlockParsers$__paragraph$1__Llaika_parse_markup_RecursiveParsers__Llaika_parse_LineSource__sci_Seq__Llaika_ast_Paragraph($thiz, recParsers, x17, x21);
              break matchResult1;
            }
            if ((x22 instanceof $c_s_Some)) {
              var list = $as_Llaika_ast_Block($n($as_s_Some(x22)).s_Some__f_value);
              var this$12 = $m_Llaika_ast_BlockSequence$();
              var block = $p_Llaika_internal_markdown_BlockParsers$__paragraph$1__Llaika_parse_markup_RecursiveParsers__Llaika_parse_LineSource__sci_Seq__Llaika_ast_Paragraph($thiz, recParsers, x17, x21);
              var blocks = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Block.getArrayOf().constr)([list]));
              var $x_2 = $as_Llaika_ast_RewritableContainer($f_Llaika_ast_BlockContainerCompanion__apply__Llaika_ast_Block__sci_Seq__O(this$12, block, blocks));
              break matchResult1;
            }
          }
        }
        if ((x18 instanceof $c_s_util_Left)) {
          var decoration = $as_T($n($as_s_util_Left(x18)).s_util_Left__f_value);
          var level = $p_Llaika_internal_markdown_BlockParsers$__decoratedHeaderLevel$1__T__I($thiz, decoration);
          var this$13 = $n(recParsers);
          var content = new $c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$RecursiveSpanParserDelegate(this$13, $as_Llaika_parse_Parser(this$13.defaultSpanParser__Llaika_parse_markup_InlineParser())).parseAndRecover__Llaika_parse_SourceFragment__sci_Seq(x17);
          var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
          var $x_2 = new $c_Llaika_ast_Header(level, content, options);
          break matchResult1;
        }
      }
      throw new $c_s_MatchError(x$1$1);
    }
    return $as_Llaika_ast_Block($x_2);
  })));
}
function $p_Llaika_internal_markdown_BlockParsers$__enclosedBy$1__C__C__Llaika_parse_text_PrefixedParser($thiz, start, end) {
  var $x_2 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var str = ("" + $cToS(start));
  var this$6 = $m_Llaika_parse_builders$();
  var $x_1 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var str$1 = ("" + $cToS(end));
  var this$5 = $m_Llaika_parse_builders$();
  var p = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_wsEol;
  var delimiter = $n($x_1).$less$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(str$1, $f_Llaika_parse_combinator_Parsers__lookAhead__Llaika_parse_Parser__Llaika_parse_Parser(this$5, p));
  return $n($x_2).$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(str, $n($f_Llaika_parse_text_TextParsers__delimitedBy__Llaika_parse_text_PrefixedParser__Llaika_parse_text_DelimitedText(this$6, delimiter)).failOn__sci_Seq__Llaika_parse_text_DelimitedText($m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([13, 10])))));
}
function $p_Llaika_internal_markdown_BlockParsers$__stripDecoration$1__T__T($thiz, text) {
  var $x_2 = $m_sc_StringOps$();
  var $x_1 = $m_sc_StringOps$();
  var x = $f_T__trim__T($n(text));
  var x$1 = $n($x_1).reverse$extension__T__T(x);
  _return: {
    var this$5 = $n(x$1);
    var len = this$5.length;
    var i = 0;
    while ((i < len)) {
      var this$6 = $n(x$1);
      var index = i;
      var arg1 = $charAt(this$6, index);
      if ((arg1 !== 35)) {
        var x1 = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var x1 = (-1);
  }
  if ((x1 === (-1))) {
    var x$2 = "";
  } else {
    var this$7 = $n(x$1);
    if (((x1 < 0) || (x1 > this$7.length))) {
      $charAt(this$7, x1);
    }
    var x$2 = $as_T(this$7.substring(x1));
  }
  return $f_T__trim__T($n($n($x_2).reverse$extension__T__T(x$2)));
}
function $p_Llaika_internal_markdown_BlockParsers$__decoratedHeaderLevel$1__T__I($thiz, decoration) {
  return (($m_sc_StringOps$().head$extension__T__C(decoration) === 61) ? 1 : 2);
}
function $p_Llaika_internal_markdown_BlockParsers$__processLineBreaks$1__Llaika_parse_LineSource__Llaika_parse_LineSource($thiz, line) {
  if ($f_T__endsWith__T__Z($n($n(line).Llaika_parse_LineSource__f_input), "  ")) {
    var $x_1 = $m_sc_StringOps$();
    var x = $n(line).Llaika_parse_LineSource__f_input;
    var x$1 = $n($x_1).dropRight$extension__T__I__T(x, 2);
    var input = (x$1 + "\\\r");
    var parent = $n(line).parent__Llaika_parse_SourceCursor();
    return new $c_Llaika_parse_LineSource(input, parent, 0, $n(parent).nestLevel__I());
  } else {
    return line;
  }
}
function $p_Llaika_internal_markdown_BlockParsers$__paragraph$1__Llaika_parse_markup_RecursiveParsers__Llaika_parse_LineSource__sci_Seq__Llaika_ast_Paragraph($thiz, recParsers$1, firstLine, restLines) {
  var this$1 = $n(recParsers$1);
  var content = new $c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$RecursiveSpanParserDelegate(this$1, $as_Llaika_parse_Parser(this$1.defaultSpanParser__Llaika_parse_markup_InlineParser())).parseAndRecover__Llaika_parse_SourceFragment__sci_Seq($m_Llaika_parse_BlockSource$().apply__Llaika_parse_LineSource__sci_Seq__Llaika_parse_BlockSource($p_Llaika_internal_markdown_BlockParsers$__processLineBreaks$1__Llaika_parse_LineSource__Llaika_parse_LineSource($thiz, firstLine), $as_sci_Seq($n(restLines).map__F1__O(new $c_sjsr_AnonFunction1(((line) => {
    var line$1 = $as_Llaika_parse_LineSource(line);
    return $p_Llaika_internal_markdown_BlockParsers$__processLineBreaks$1__Llaika_parse_LineSource__Llaika_parse_LineSource($thiz, line$1);
  }))))));
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  return new $c_Llaika_ast_Paragraph(content, options);
}
/** @constructor */
function $c_Llaika_internal_markdown_BlockParsers$() {
  this.Llaika_internal_markdown_BlockParsers$__f_tabOrSpace = null;
  this.Llaika_internal_markdown_BlockParsers$__f_insignificantSpaces = null;
  this.Llaika_internal_markdown_BlockParsers$__f_setextDecoration = null;
  this.Llaika_internal_markdown_BlockParsers$__f_rootHeaderOrParagraph$lzy1 = null;
  this.Llaika_internal_markdown_BlockParsers$__f_rootHeaderOrParagraphbitmap$1 = false;
  this.Llaika_internal_markdown_BlockParsers$__f_nestedHeaderOrParagraph$lzy1 = null;
  this.Llaika_internal_markdown_BlockParsers$__f_nestedHeaderOrParagraphbitmap$1 = false;
  this.Llaika_internal_markdown_BlockParsers$__f_linkTarget = null;
  this.Llaika_internal_markdown_BlockParsers$__f_atxHeader = null;
  this.Llaika_internal_markdown_BlockParsers$__f_rules = null;
  this.Llaika_internal_markdown_BlockParsers$__f_literalBlocks = null;
  this.Llaika_internal_markdown_BlockParsers$__f_quotedBlock = null;
  this.Llaika_internal_markdown_BlockParsers$__f_fallbackParagraph = null;
  $n_Llaika_internal_markdown_BlockParsers$ = this;
  var this$1 = $m_Llaika_parse_builders$();
  var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([9])));
  this.Llaika_internal_markdown_BlockParsers$__f_tabOrSpace = $n($as_Llaika_parse_Parser($f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser(this$1, 32, chars))).void__Llaika_parse_Parser();
  var this$2 = $m_Llaika_parse_builders$();
  var chars$1 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
  this.Llaika_internal_markdown_BlockParsers$__f_insignificantSpaces = $n($n($f_Llaika_parse_text_TextParsers__anyOf__C__sci_Seq__Llaika_parse_text_Characters(this$2, 32, chars$1)).max__I__Llaika_parse_text_Characters(3)).void__Llaika_parse_text_Characters();
  var this$3 = $m_Llaika_parse_builders$();
  var chars$2 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
  var this$6 = $n($f_Llaika_parse_text_TextParsers__someOf__C__sci_Seq__Llaika_parse_text_PrefixCharacters(this$3, 61, chars$2));
  var p = new $c_sjsr_AnonFunction0((() => {
    var this$5 = $m_Llaika_parse_builders$();
    var chars$3 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
    return $f_Llaika_parse_text_TextParsers__someOf__C__sci_Seq__Llaika_parse_text_PrefixCharacters(this$5, 45, chars$3);
  }));
  var this$7 = $n($f_Llaika_parse_text_PrefixedParser__$bar__F0__Llaika_parse_text_PrefixedParser(this$6, p));
  var p$1 = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_wsEol;
  this.Llaika_internal_markdown_BlockParsers$__f_setextDecoration = $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$less$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$7, p$1));
  var factory = new $c_sjsr_AnonFunction1(((escapedParsers) => {
    var escapedParsers$1 = $as_Llaika_parse_markup_EscapedTextParsers(escapedParsers);
    var $x_1 = $m_Llaika_parse_syntax$LiteralStringOps$();
    var this$9 = $n(escapedParsers$1);
    var chars$4 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
    var this$11 = $n($n($x_1).$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("[", $n($f_Llaika_internal_parse_markup_DefaultEscapedTextParsers__escapedUntil__C__sci_Seq__Llaika_parse_Parser(this$9, 93, chars$4)).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$5) => {
      var _$5$1 = $as_T(_$5);
      var this$10 = $n(_$5$1);
      return $as_T(this$10.toLowerCase());
    })))));
    var this$12 = $n($f_Llaika_parse_text_PrefixedParser__$less$tilde__T__Llaika_parse_text_PrefixedParser(this$11, ":"));
    var p$2 = $n($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters()).void__Llaika_parse_text_Characters();
    var id = $f_Llaika_parse_text_PrefixedParser__$less$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$12, p$2);
    var $x_2 = $m_Llaika_parse_syntax$LiteralStringOps$();
    var this$14 = $n(escapedParsers$1);
    var chars$5 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
    var this$17 = $n($as_Llaika_parse_Parser($n($x_2).$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("<", $f_Llaika_internal_parse_markup_DefaultEscapedTextParsers__escapedUntil__C__sci_Seq__Llaika_parse_Parser(this$14, 62, chars$5))));
    var p$4 = new $c_sjsr_AnonFunction0((() => {
      var this$16 = $n(escapedParsers$1);
      var this$15 = $m_Llaika_parse_builders$();
      var chars$6 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([10])));
      var p$3 = $n($n($f_Llaika_parse_text_TextParsers__delimitedBy__C__sci_Seq__Llaika_parse_text_DelimitedText(this$15, 32, chars$6)).acceptEOF__Llaika_parse_text_DelimitedText()).keepDelimiter__Llaika_parse_text_DelimitedText();
      return $f_Llaika_internal_parse_markup_DefaultEscapedTextParsers__escapedText__Llaika_parse_text_DelimitedText__Llaika_parse_Parser(this$16, p$3);
    }));
    var url = this$17.orElse__F0__Llaika_parse_Parser(p$4);
    var $x_4 = $n($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters()).void__Llaika_parse_text_Characters();
    var this$18 = $m_Llaika_parse_builders$();
    var p$5 = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_eol;
    var $x_3 = $n($n($n($x_4).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$18, p$5))).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($n($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters()).void__Llaika_parse_text_Characters()));
    var this$19 = $n($p_Llaika_internal_markdown_BlockParsers$__enclosedBy$1__C__C__Llaika_parse_text_PrefixedParser(this, 34, 34));
    var p$6 = new $c_sjsr_AnonFunction0((() => $p_Llaika_internal_markdown_BlockParsers$__enclosedBy$1__C__C__Llaika_parse_text_PrefixedParser(this, 39, 39)));
    var this$20 = $n($f_Llaika_parse_text_PrefixedParser__$bar__F0__Llaika_parse_text_PrefixedParser(this$19, p$6));
    var p$7 = new $c_sjsr_AnonFunction0((() => $p_Llaika_internal_markdown_BlockParsers$__enclosedBy$1__C__C__Llaika_parse_text_PrefixedParser(this, 40, 41)));
    var title = $n($x_3).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$bar__F0__Llaika_parse_text_PrefixedParser(this$20, p$7)));
    var this$21 = $n(id);
    var this$23 = $n($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$21, url));
    var this$22 = $m_Llaika_parse_builders$();
    var p$8 = $f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$22, title);
    var this$24 = $n($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$23, p$8));
    var p$9 = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_wsEol;
    var p$10 = $f_Llaika_parse_text_PrefixedParser__$less$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$24, p$9);
    return $as_Llaika_parse_Parser($m_Llaika_parse_syntax$PrefixedMap3Ops$().mapN$extension__Llaika_parse_text_PrefixedParser__F3__Llaika_parse_text_PrefixedParser(p$10, new $c_sjsr_AnonFunction3(((id$2, url$2, title$2) => {
      var id$1 = $as_T(id$2);
      var url$1 = $as_T(url$2);
      var title$1 = $as_s_Option(title$2);
      return $m_Llaika_ast_LinkDefinition$().create__T__T__s_Option__Llaika_ast_Block(id$1, url$1, title$1);
    }))));
  }));
  this.Llaika_internal_markdown_BlockParsers$__f_linkTarget = new $c_Llaika_api_bundle_BlockParserBuilder(factory, false, $m_Llaika_api_bundle_BlockPosition$Any$(), $m_Llaika_api_bundle_Precedence$High$(), $m_s_None$()).rootOnly__Llaika_api_bundle_BlockParserBuilder();
  var factory$1 = new $c_sjsr_AnonFunction1(((recParsers) => {
    var recParsers$1 = $as_Llaika_parse_markup_RecursiveParsers(recParsers);
    var this$30 = $m_Llaika_parse_builders$();
    var chars$7 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
    var level = $n($n($f_Llaika_parse_text_TextParsers__someOf__C__sci_Seq__Llaika_parse_text_PrefixCharacters(this$30, 35, chars$7)).max__I__Llaika_parse_text_PrefixCharacters(6)).count__Llaika_parse_text_PrefixCharacters();
    var this$32 = $n(recParsers$1);
    var p$11 = $n($m_Llaika_parse_builders$().Llaika_parse_builders$__f_restOfLine).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((text) => {
      var text$1 = $as_T(text);
      return $p_Llaika_internal_markdown_BlockParsers$__stripDecoration$1__T__T(this, text$1);
    })));
    var parser = $m_Llaika_parse_syntax$StringParserOps$().line$extension__Llaika_parse_Parser__Llaika_parse_Parser(p$11);
    var text$2 = $f_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers__recursiveSpans__Llaika_parse_Parser__Llaika_parse_markup_InlineParser(this$32, parser);
    var this$34 = $n(level);
    var this$33 = $m_Llaika_parse_builders$();
    var p$12 = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_blankLine;
    var p$13 = $n($n($f_Llaika_parse_combinator_Parsers__not__Llaika_parse_Parser__Llaika_parse_Parser(this$33, p$12)).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters())).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($as_Llaika_parse_Parser(text$2));
    var p$14 = $f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$34, p$13);
    return $as_Llaika_parse_Parser($m_Llaika_parse_syntax$PrefixedMap2Ops$().mapN$extension__Llaika_parse_text_PrefixedParser__F2__Llaika_parse_text_PrefixedParser(p$14, new $c_sjsr_AnonFunction2(((_$7, _$8) => {
      var _$7$1 = $uI(_$7);
      var _$8$1 = $as_sci_List(_$8);
      var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      return new $c_Llaika_ast_Header(_$7$1, _$8$1, options);
    }))));
  }));
  this.Llaika_internal_markdown_BlockParsers$__f_atxHeader = new $c_Llaika_api_bundle_BlockParserBuilder(factory$1, true, $m_Llaika_api_bundle_BlockPosition$Any$(), $m_Llaika_api_bundle_Precedence$High$(), $m_s_None$());
  var $x_5 = $m_Llaika_api_bundle_BlockParserBuilder$();
  var this$42 = $m_Llaika_parse_builders$();
  var chars$8 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([45, 95])));
  var decoChar = $f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser(this$42, 42, chars$8);
  var this$46 = $n(decoChar);
  var this$43 = $m_Llaika_parse_builders$();
  var chars$9 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
  var this$44 = $n($n($n($f_Llaika_parse_text_TextParsers__anyOf__C__sci_Seq__Llaika_parse_text_Characters(this$43, 32, chars$9)).void__Llaika_parse_text_Characters()).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($as_Llaika_parse_Parser(decoChar)));
  var p$15 = new $c_Llaika_parse_combinator_Repeat(this$44, 0, 2147483647, $m_s_None$()).min__I__Llaika_parse_combinator_Repeat(2);
  var this$49 = $n($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$46, p$15));
  var v = new $c_sjsr_AnonFunction0((() => {
    var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    return new $c_Llaika_ast_Rule(options$1);
  }));
  var pattern = $f_Llaika_parse_text_PrefixedParser__as__F0__Llaika_parse_text_PrefixedParser(this$49, v);
  var this$50 = $n(pattern);
  var p$16 = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_wsEol;
  this.Llaika_internal_markdown_BlockParsers$__f_rules = $n($x_5).standalone__Llaika_parse_Parser__Llaika_api_bundle_BlockParserBuilder($as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$less$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$50, p$16)));
  var $x_6 = $m_Llaika_api_bundle_BlockParserBuilder$();
  var wsPreProcessor = $m_Llaika_parse_text_WhitespacePreprocessor$().Llaika_parse_text_WhitespacePreprocessor$__f_forString;
  var this$53 = $m_Llaika_parse_text_PrefixedParser$();
  var chars$10 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([9])));
  var p$17 = $n($p_Llaika_internal_markdown_BlockParsers$__decoratedBlock__Llaika_parse_Parser__Llaika_parse_Parser__Llaika_parse_Parser__Llaika_parse_Parser(this, this.Llaika_internal_markdown_BlockParsers$__f_tabOrSpace, this.Llaika_internal_markdown_BlockParsers$__f_tabOrSpace, this.Llaika_internal_markdown_BlockParsers$__f_tabOrSpace)).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((lines) => {
    var lines$1 = $as_Llaika_parse_BlockSource(lines);
    var content = $as_T($n(wsPreProcessor).apply__O__O($n(lines$1).input__T()));
    var options$2 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    return new $c_Llaika_ast_LiteralBlock(content, options$2);
  })));
  this.Llaika_internal_markdown_BlockParsers$__f_literalBlocks = $n($x_6).standalone__Llaika_parse_Parser__Llaika_api_bundle_BlockParserBuilder(new $c_Llaika_parse_text_PrefixedParser$$anon$2(32, chars$10, p$17, this$53));
  var factory$2 = new $c_sjsr_AnonFunction1(((recParsers$2) => {
    var recParsers$3 = $as_Llaika_parse_markup_RecursiveParsers(recParsers$2);
    var this$61 = $m_Llaika_parse_text_PrefixedParser$();
    var chars$11 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
    var decoratedLine = $m_Llaika_parse_syntax$LiteralStringOps$().$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(">", $n($n($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters()).max__I__Llaika_parse_text_Characters(1)).void__Llaika_parse_text_Characters());
    var this$58 = $n(recParsers$3);
    var $x_7 = $as_Llaika_parse_Parser(decoratedLine);
    var this$56 = $n($as_Llaika_parse_Parser(decoratedLine));
    var p$19 = new $c_sjsr_AnonFunction0((() => {
      var this$55 = $m_Llaika_parse_builders$();
      var p$18 = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_blankLine;
      return $f_Llaika_parse_combinator_Parsers__not__Llaika_parse_Parser__Llaika_parse_Parser(this$55, p$18);
    }));
    var p$20 = $p_Llaika_internal_markdown_BlockParsers$__decoratedBlock__Llaika_parse_Parser__Llaika_parse_Parser__Llaika_parse_Parser__Llaika_parse_Parser(this, $x_7, this$56.orElse__F0__Llaika_parse_Parser(p$19), ($m_Llaika_parse_builders$(), new $c_Llaika_parse_text_Literal(">")));
    var p$21 = $n($f_Llaika_internal_parse_markup_DefaultRecursiveParsers__recursiveBlocks__Llaika_parse_Parser__Llaika_parse_Parser(this$58, p$20)).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$9) => {
      var _$9$1 = $as_sci_Seq(_$9);
      var attribution = $m_sci_Nil$();
      var options$3 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      return new $c_Llaika_ast_QuotedBlock(_$9$1, attribution, options$3);
    })));
    return new $c_Llaika_parse_text_PrefixedParser$$anon$2(62, chars$11, p$21, this$61);
  }));
  this.Llaika_internal_markdown_BlockParsers$__f_quotedBlock = new $c_Llaika_api_bundle_BlockParserBuilder(factory$2, true, $m_Llaika_api_bundle_BlockPosition$Any$(), $m_Llaika_api_bundle_Precedence$High$(), $m_s_None$());
  var factory$3 = new $c_sjsr_AnonFunction1(((spanParsers) => {
    var spanParsers$1 = $as_Llaika_parse_markup_RecursiveSpanParsers(spanParsers);
    var this$66 = $n($m_Llaika_parse_builders$().Llaika_parse_builders$__f_textLine);
    var p$22 = $n(new $c_Llaika_parse_combinator_Repeat(this$66, 0, 2147483647, $m_s_None$()).min__I__Llaika_parse_combinator_Repeat(1)).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$10) => {
      var _$10$1 = $as_sci_List(_$10);
      var this$68 = $n(_$10$1);
      return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$68, "", "", "");
    })));
    var block = $m_Llaika_parse_syntax$StringParserOps$().line$extension__Llaika_parse_Parser__Llaika_parse_Parser(p$22);
    var this$70 = $n(spanParsers$1);
    return $n($as_Llaika_parse_Parser($f_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers__recursiveSpans__Llaika_parse_Parser__Llaika_parse_markup_InlineParser(this$70, block))).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$11) => {
      var _$11$1 = $as_sci_List(_$11);
      var options$4 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      return new $c_Llaika_ast_Paragraph(_$11$1, options$4);
    })));
  }));
  this.Llaika_internal_markdown_BlockParsers$__f_fallbackParagraph = $n(new $c_Llaika_api_bundle_BlockParserBuilder(factory$3, false, $m_Llaika_api_bundle_BlockPosition$Any$(), $m_Llaika_api_bundle_Precedence$High$(), $m_s_None$()).nestedOnly__Llaika_api_bundle_BlockParserBuilder()).withLowPrecedence__Llaika_api_bundle_BlockParserBuilder();
}
$c_Llaika_internal_markdown_BlockParsers$.prototype = new $h_O();
$c_Llaika_internal_markdown_BlockParsers$.prototype.constructor = $c_Llaika_internal_markdown_BlockParsers$;
/** @constructor */
function $h_Llaika_internal_markdown_BlockParsers$() {
}
$h_Llaika_internal_markdown_BlockParsers$.prototype = $c_Llaika_internal_markdown_BlockParsers$.prototype;
$c_Llaika_internal_markdown_BlockParsers$.prototype.mdBlock__Llaika_parse_Parser__Llaika_parse_Parser__Llaika_parse_Parser__Llaika_parse_Parser = (function(firstLinePrefix, linePrefix, nextBlockPrefix) {
  $m_Llaika_parse_builders$();
  var nextBlockPrefix$1 = new $c_sjsr_AnonFunction0((() => nextBlockPrefix));
  var line$lzy1 = new $c_sr_LazyRef();
  var nextBlock$lzy1 = new $c_sr_LazyRef();
  var $x_1 = $n(firstLinePrefix);
  var p = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_restOfLine;
  var firstLine = $n($x_1).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($m_Llaika_parse_syntax$StringParserOps$().line$extension__Llaika_parse_Parser__Llaika_parse_Parser(p));
  var line$lzy1$2 = line$lzy1;
  if ($n(line$lzy1$2).sr_LazyRef__f__initialized) {
    var $x_2 = $n(line$lzy1$2).sr_LazyRef__f__value;
  } else {
    if ((line$lzy1$2 === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
    }
    if ($n(line$lzy1$2).sr_LazyRef__f__initialized) {
      var $x_3 = $n(line$lzy1$2).sr_LazyRef__f__value;
    } else {
      var $x_5 = $n(line$lzy1$2);
      var $x_4 = $n(this.Llaika_internal_markdown_BlockParsers$__f_insignificantSpaces).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(linePrefix);
      var p$1 = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_restOfLine;
      var $x_3 = $n($x_5).initialize__O__O($n($x_4).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($m_Llaika_parse_syntax$StringParserOps$().line$extension__Llaika_parse_Parser__Llaika_parse_Parser(p$1)));
    }
    var $x_2 = $as_Llaika_parse_Parser($x_3);
  }
  var this$5 = $n($as_Llaika_parse_Parser($x_2));
  var nextBlock$lzy1$2$1 = nextBlock$lzy1;
  var p$2 = new $c_sjsr_AnonFunction0(((nextBlock$lzy1$2) => (() => $ps_Llaika_parse_markup_BlockParsers__nextBlock$1__sr_LazyRef__F0__Llaika_parse_Parser(nextBlock$lzy1$2, nextBlockPrefix$1)))(nextBlock$lzy1$2$1));
  var this$6 = $n(this$5.orElse__F0__Llaika_parse_Parser(p$2));
  return $n($n(firstLine).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(new $c_Llaika_parse_combinator_Repeat(this$6, 0, 2147483647, $m_s_None$()))).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Llaika_parse_builders$$tilde(x$1);
    if ((x$1$1 !== null)) {
      var first = $as_Llaika_parse_LineSource($n(x$1$1).Llaika_parse_builders$$tilde__f__1);
      var rest = $as_sci_List($n(x$1$1).Llaika_parse_builders$$tilde__f__2);
      return $m_Llaika_parse_BlockSource$().apply__Llaika_parse_LineSource__sci_Seq__Llaika_parse_BlockSource(first, rest);
    }
    throw new $c_s_MatchError(x$1$1);
  })));
});
$c_Llaika_internal_markdown_BlockParsers$.prototype.rootHeaderOrParagraph__Llaika_api_bundle_BlockParserBuilder = (function() {
  if ((!this.Llaika_internal_markdown_BlockParsers$__f_rootHeaderOrParagraphbitmap$1)) {
    var factory = new $c_sjsr_AnonFunction1(((_$1) => {
      var _$1$1 = $as_Llaika_parse_markup_RecursiveParsers(_$1);
      return $p_Llaika_internal_markdown_BlockParsers$__headerOrParagraph__Llaika_parse_markup_RecursiveParsers__Llaika_api_bundle_BlockPosition__Llaika_parse_Parser(this, _$1$1, $m_Llaika_api_bundle_BlockPosition$RootOnly$());
    }));
    this.Llaika_internal_markdown_BlockParsers$__f_rootHeaderOrParagraph$lzy1 = new $c_Llaika_api_bundle_BlockParserBuilder(factory, true, $m_Llaika_api_bundle_BlockPosition$Any$(), $m_Llaika_api_bundle_Precedence$High$(), $m_s_None$()).rootOnly__Llaika_api_bundle_BlockParserBuilder();
    this.Llaika_internal_markdown_BlockParsers$__f_rootHeaderOrParagraphbitmap$1 = true;
  }
  return this.Llaika_internal_markdown_BlockParsers$__f_rootHeaderOrParagraph$lzy1;
});
$c_Llaika_internal_markdown_BlockParsers$.prototype.nestedHeaderOrParagraph__Llaika_api_bundle_BlockParserBuilder = (function() {
  if ((!this.Llaika_internal_markdown_BlockParsers$__f_nestedHeaderOrParagraphbitmap$1)) {
    var factory = new $c_sjsr_AnonFunction1(((_$2) => {
      var _$2$1 = $as_Llaika_parse_markup_RecursiveParsers(_$2);
      return $p_Llaika_internal_markdown_BlockParsers$__headerOrParagraph__Llaika_parse_markup_RecursiveParsers__Llaika_api_bundle_BlockPosition__Llaika_parse_Parser(this, _$2$1, $m_Llaika_api_bundle_BlockPosition$NestedOnly$());
    }));
    this.Llaika_internal_markdown_BlockParsers$__f_nestedHeaderOrParagraph$lzy1 = new $c_Llaika_api_bundle_BlockParserBuilder(factory, true, $m_Llaika_api_bundle_BlockPosition$Any$(), $m_Llaika_api_bundle_Precedence$High$(), $m_s_None$()).nestedOnly__Llaika_api_bundle_BlockParserBuilder();
    this.Llaika_internal_markdown_BlockParsers$__f_nestedHeaderOrParagraphbitmap$1 = true;
  }
  return this.Llaika_internal_markdown_BlockParsers$__f_nestedHeaderOrParagraph$lzy1;
});
var $d_Llaika_internal_markdown_BlockParsers$ = new $TypeData().initClass($c_Llaika_internal_markdown_BlockParsers$, "laika.internal.markdown.BlockParsers$", ({
  Llaika_internal_markdown_BlockParsers$: 1
}));
var $n_Llaika_internal_markdown_BlockParsers$;
function $m_Llaika_internal_markdown_BlockParsers$() {
  if ((!$n_Llaika_internal_markdown_BlockParsers$)) {
    $n_Llaika_internal_markdown_BlockParsers$ = new $c_Llaika_internal_markdown_BlockParsers$();
  }
  return $n_Llaika_internal_markdown_BlockParsers$;
}
function $p_Llaika_internal_markdown_HTMLParsers$__asTextContainers__sci_List__sci_List($thiz, spans) {
  return $n(spans).collect__s_PartialFunction__sci_List(new $c_Llaika_internal_markdown_HTMLParsers$$anon$2($thiz));
}
function $p_Llaika_internal_markdown_HTMLParsers$__htmlQuotedAttributeValue__T__Llaika_parse_Parser($thiz, c) {
  var $x_1 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var this$4 = $m_Llaika_parse_markup_InlineParsers$();
  var parser = new $c_sjsr_AnonFunction0((() => {
    var this$3 = $m_Llaika_parse_builders$();
    return $f_Llaika_parse_text_TextParsers__delimitedBy__T__Llaika_parse_text_DelimitedText(this$3, c);
  }));
  return $as_Llaika_parse_Parser($n($x_1).$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(c, $n($as_Llaika_parse_Parser($n($f_Llaika_parse_markup_InlineParsers__spans__F0__Llaika_parse_markup_InlineParser(this$4, parser)).embed__F0__Llaika_parse_markup_InlineParser(new $c_sjsr_AnonFunction0((() => $thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlCharReference))))).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((spans) => {
    var spans$1 = $as_sci_List(spans);
    var _1 = $p_Llaika_internal_markdown_HTMLParsers$__asTextContainers__sci_List__sci_List($thiz, spans$1);
    var value = $m_sc_StringOps$().head$extension__T__C(c);
    var _2 = new $c_s_Some($bC(value));
    return new $c_T2(_1, _2);
  })))));
}
function $p_Llaika_internal_markdown_HTMLParsers$__htmlEndTag__T__Llaika_parse_text_DelimitedText($thiz, tagName) {
  var this$6 = $m_Llaika_parse_builders$();
  var this$2 = $n($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$extension__T__T__Llaika_parse_text_PrefixedParser("</", tagName));
  var p = $thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlWS;
  var this$3 = $n($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$2, p));
  var this$5 = $n($f_Llaika_parse_text_PrefixedParser__$tilde__T__Llaika_parse_text_PrefixedParser(this$3, ">"));
  var v = new $c_sjsr_AnonFunction0((() => ""));
  var delimiter = $f_Llaika_parse_text_PrefixedParser__as__F0__Llaika_parse_text_PrefixedParser(this$5, v);
  return $f_Llaika_parse_text_TextParsers__delimitedBy__Llaika_parse_text_PrefixedParser__Llaika_parse_text_DelimitedText(this$6, delimiter);
}
function $p_Llaika_internal_markdown_HTMLParsers$__htmlElement__Llaika_parse_Parser($thiz) {
  if ((!$thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlElementbitmap$1)) {
    $thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlElement$lzy1 = $n($thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlStartTag).$greater$greater__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((tag) => {
      var tag$1 = $as_Llaika_ast_html_HTMLStartTag(tag);
      var this$2 = $m_Llaika_parse_markup_InlineParsers$();
      var parser = new $c_sjsr_AnonFunction0((() => $p_Llaika_internal_markdown_HTMLParsers$__htmlEndTag__T__Llaika_parse_text_DelimitedText($thiz, $n(tag$1).Llaika_ast_html_HTMLStartTag__f_name)));
      return $n($as_Llaika_parse_Parser($n($f_Llaika_parse_markup_InlineParsers__spans__F0__Llaika_parse_markup_InlineParser(this$2, parser)).embedAll__F0__Llaika_parse_markup_InlineParser(new $c_sjsr_AnonFunction0((() => $p_Llaika_internal_markdown_HTMLParsers$__htmlBlockParsers__sci_Seq($thiz)))))).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((spans) => {
        var spans$1 = $as_sci_List(spans);
        var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
        return new $c_Llaika_ast_html_HTMLElement(tag$1, spans$1, options);
      })));
    })));
    $thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlElementbitmap$1 = true;
  }
  return $thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlElement$lzy1;
}
function $p_Llaika_internal_markdown_HTMLParsers$__htmlElementWithNestedMarkdown__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_Parser($thiz, recParsers) {
  return $n($thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlStartTag).$greater$greater__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((tag) => {
    var tag$1 = $as_Llaika_ast_html_HTMLStartTag(tag);
    var this$2 = $n(recParsers);
    var p = $p_Llaika_internal_markdown_HTMLParsers$__htmlEndTag__T__Llaika_parse_text_DelimitedText($thiz, $n(tag$1).Llaika_ast_html_HTMLStartTag__f_name);
    return $n($as_Llaika_parse_Parser($f_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers__recursiveSpans__Llaika_parse_text_DelimitedText__Llaika_parse_markup_InlineParser(this$2, p))).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((spans) => {
      var spans$1 = $as_sci_List(spans);
      var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      return new $c_Llaika_ast_html_HTMLElement(tag$1, spans$1, options);
    })));
  })));
}
function $p_Llaika_internal_markdown_HTMLParsers$__htmlSpanInsideBlock__Llaika_parse_text_PrefixedParser($thiz) {
  if ((!$thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlSpanInsideBlockbitmap$1)) {
    var $x_1 = $m_Llaika_parse_syntax$LiteralStringOps$();
    var this$3 = $n($thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlComment);
    var p = new $c_sjsr_AnonFunction0((() => $thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlScriptElement));
    var this$4 = $n(this$3.orElse__F0__Llaika_parse_Parser(p));
    var p$1 = new $c_sjsr_AnonFunction0((() => $thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlEmptyElement));
    var this$5 = $n(this$4.orElse__F0__Llaika_parse_Parser(p$1));
    var p$2 = new $c_sjsr_AnonFunction0((() => $p_Llaika_internal_markdown_HTMLParsers$__htmlElement__Llaika_parse_Parser($thiz)));
    var this$6 = $n(this$5.orElse__F0__Llaika_parse_Parser(p$2));
    var p$3 = new $c_sjsr_AnonFunction0((() => $thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlEndTag));
    var this$7 = $n(this$6.orElse__F0__Llaika_parse_Parser(p$3));
    var p$4 = new $c_sjsr_AnonFunction0((() => $thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlStartTag));
    $thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlSpanInsideBlock$lzy1 = $n($x_1).$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("<", this$7.orElse__F0__Llaika_parse_Parser(p$4));
    $thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlSpanInsideBlockbitmap$1 = true;
  }
  return $thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlSpanInsideBlock$lzy1;
}
function $p_Llaika_internal_markdown_HTMLParsers$__htmlBlockParsers__sci_Seq($thiz) {
  if ((!$thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlBlockParsersbitmap$1)) {
    $thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlBlockParsers$lzy1 = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_parse_text_PrefixedParser.getArrayOf().constr)([$p_Llaika_internal_markdown_HTMLParsers$__htmlSpanInsideBlock__Llaika_parse_text_PrefixedParser($thiz), $thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlCharReference]))));
    $thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlBlockParsersbitmap$1 = true;
  }
  return $thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlBlockParsers$lzy1;
}
function $p_Llaika_internal_markdown_HTMLParsers$__htmlBlock__Llaika_parse_Parser($thiz) {
  if ((!$thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlBlockbitmap$1)) {
    $thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlBlock$lzy1 = $n($thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlBlockStart).$greater$greater__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((tag) => {
      var tag$1 = $as_Llaika_ast_html_HTMLStartTag(tag);
      var this$2 = $m_Llaika_parse_markup_InlineParsers$();
      var parser = new $c_sjsr_AnonFunction0((() => $p_Llaika_internal_markdown_HTMLParsers$__htmlEndTag__T__Llaika_parse_text_DelimitedText($thiz, $n(tag$1).Llaika_ast_html_HTMLStartTag__f_name)));
      return $n($n($as_Llaika_parse_Parser($n($f_Llaika_parse_markup_InlineParsers__spans__F0__Llaika_parse_markup_InlineParser(this$2, parser)).embedAll__F0__Llaika_parse_markup_InlineParser(new $c_sjsr_AnonFunction0((() => $p_Llaika_internal_markdown_HTMLParsers$__htmlBlockParsers__sci_Seq($thiz)))))).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser($m_Llaika_parse_builders$().Llaika_parse_builders$__f_wsEol)).$up$up__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((spans) => {
        var spans$1 = $as_sci_List(spans);
        var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
        var root = new $c_Llaika_ast_html_HTMLElement(tag$1, spans$1, options);
        var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
        return new $c_Llaika_ast_html_HTMLBlock(root, options$1);
      })));
    })));
    $thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlBlockbitmap$1 = true;
    $thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlBlockStart = null;
  }
  return $thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlBlock$lzy1;
}
function $p_Llaika_internal_markdown_HTMLParsers$__htmlBlockElement__Llaika_parse_Parser($thiz) {
  if ((!$thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlBlockElementbitmap$1)) {
    var $x_1 = $m_Llaika_parse_syntax$LiteralStringOps$();
    var this$3 = $n($thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlComment);
    var p = new $c_sjsr_AnonFunction0((() => $thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlEmptyElement));
    var this$4 = $n(this$3.orElse__F0__Llaika_parse_Parser(p));
    var p$1 = new $c_sjsr_AnonFunction0((() => $thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlStartTag));
    var this$5 = $n($n($x_1).$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("<", this$4.orElse__F0__Llaika_parse_Parser(p$1)));
    var p$2 = $n($m_Llaika_parse_builders$().Llaika_parse_builders$__f_wsEol).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($m_Llaika_parse_builders$().Llaika_parse_builders$__f_blankLine);
    $thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlBlockElement$lzy1 = $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$less$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$5, p$2));
    $thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlBlockElementbitmap$1 = true;
  }
  return $thiz.Llaika_internal_markdown_HTMLParsers$__f_htmlBlockElement$lzy1;
}
/** @constructor */
function $c_Llaika_internal_markdown_HTMLParsers$() {
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlAttrEndChars = null;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlWS = null;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlDecReference = null;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlNamedReference = null;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlCharReference = null;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlUnquotedAttributeValue = null;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlEndTag = null;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlComment = null;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlScriptElement = null;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlEmptyElement = null;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlStartTag = null;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlElement$lzy1 = null;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlElementbitmap$1 = false;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlSpan = null;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlCharRef = null;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlSpanInsideBlock$lzy1 = null;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlSpanInsideBlockbitmap$1 = false;
  this.Llaika_internal_markdown_HTMLParsers$__f_laika$internal$markdown$HTMLParsers$$$htmlBlockElements = null;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlBlockStart = null;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlBlockParsers$lzy1 = null;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlBlockParsersbitmap$1 = false;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlBlock$lzy1 = null;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlBlockbitmap$1 = false;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlBlockElement$lzy1 = null;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlBlockElementbitmap$1 = false;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlBlockFragment$lzy1 = null;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlBlockFragmentbitmap$1 = false;
  $n_Llaika_internal_markdown_HTMLParsers$ = this;
  var htmlWSChars = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet).of__O__sci_Seq__Lcats_kernel_Order__O($bC(32), $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([9, 12, 10, 13]))), $m_Lcats_kernel_instances_char_package$().Lcats_kernel_instances_char_package$__f_catsKernelStdOrderForChar);
  var value = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet).of__O__sci_Seq__Lcats_kernel_Order__O($bC(34), $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([39, 60, 61, 47, 62]))), $m_Lcats_kernel_instances_char_package$().Lcats_kernel_instances_char_package$__f_catsKernelStdOrderForChar);
  var this$4 = new $c_Lcats_data_NonEmptySetOps(value);
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlAttrEndChars = this$4.union__O__O(htmlWSChars);
  var this$5 = $m_Llaika_parse_builders$();
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlWS = $f_Llaika_parse_text_TextParsers__anyOf__O__Llaika_parse_text_Characters(this$5, htmlWSChars);
  var this$6 = $m_Llaika_parse_builders$();
  var chars = $m_Llaika_parse_text_CharGroup$().Llaika_parse_text_CharGroup$__f_hexDigit;
  var hexNumber = $f_Llaika_parse_text_TextParsers__someOf__O__Llaika_parse_text_PrefixCharacters(this$6, chars);
  var this$7 = $m_Llaika_parse_builders$();
  var chars$1 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
  var this$10 = $n($f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser(this$7, 120, chars$1));
  var p = new $c_sjsr_AnonFunction0((() => {
    var this$9 = $m_Llaika_parse_builders$();
    var chars$2 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
    return $f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser(this$9, 88, chars$2);
  }));
  var this$11 = $n($f_Llaika_parse_text_PrefixedParser__$bar__F0__Llaika_parse_text_PrefixedParser(this$10, p));
  var this$12 = $n($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$11, hexNumber));
  var this$13 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = this$12.startChars__O();
  var p$1 = $c_Llaika_parse_Parser.prototype.source__Llaika_parse_Parser.call(this$12);
  var htmlHexReference = new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p$1, this$13);
  var this$14 = $m_Llaika_parse_builders$();
  var chars$3 = $m_Llaika_parse_text_CharGroup$().Llaika_parse_text_CharGroup$__f_digit;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlDecReference = $f_Llaika_parse_text_TextParsers__someOf__O__Llaika_parse_text_PrefixCharacters(this$14, chars$3);
  var this$15 = $m_Llaika_parse_builders$();
  var chars$4 = $m_Llaika_parse_text_CharGroup$().Llaika_parse_text_CharGroup$__f_alphaNum;
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlNamedReference = $f_Llaika_parse_text_TextParsers__someOf__O__Llaika_parse_text_PrefixCharacters(this$15, chars$4);
  var $x_1 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var p$2 = new $c_sjsr_AnonFunction0((() => this.Llaika_internal_markdown_HTMLParsers$__f_htmlDecReference));
  var this$17 = $n($n($x_1).$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("#", htmlHexReference.orElse__F0__Llaika_parse_Parser(p$2)));
  var this$18 = $m_Llaika_parse_text_PrefixedParser$();
  var sc$1 = this$17.startChars__O();
  var p$3 = $c_Llaika_parse_Parser.prototype.source__Llaika_parse_Parser.call(this$17);
  var htmlNumericReference = new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc$1, p$3, this$18);
  var $x_2 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var p$4 = new $c_sjsr_AnonFunction0((() => this.Llaika_internal_markdown_HTMLParsers$__f_htmlNamedReference));
  var this$20 = $n($n($x_2).$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("&", htmlNumericReference.orElse__F0__Llaika_parse_Parser(p$4)));
  var this$21 = $n($f_Llaika_parse_text_PrefixedParser__$less$tilde__T__Llaika_parse_text_PrefixedParser(this$20, ";"));
  var this$22 = $m_Llaika_parse_text_PrefixedParser$();
  var sc$2 = this$21.startChars__O();
  var p$5 = $c_Llaika_parse_Parser.prototype.source__Llaika_parse_Parser.call(this$21);
  var this$25 = new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc$2, p$5, this$22);
  var f = new $c_sjsr_AnonFunction1(((_$1) => {
    var _$1$1 = $as_T(_$1);
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    return new $c_Llaika_ast_html_HTMLCharacterReference(_$1$1, options);
  }));
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlCharReference = $f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser(this$25, f);
  var this$26 = $m_Llaika_parse_builders$();
  var chars$5 = this.Llaika_internal_markdown_HTMLParsers$__f_htmlAttrEndChars;
  var htmlAttributeName = $f_Llaika_parse_text_TextParsers__someNot__O__Llaika_parse_text_Characters(this$26, chars$5);
  var this$28 = $m_Llaika_parse_markup_InlineParsers$();
  var parser = new $c_sjsr_AnonFunction0((() => {
    var this$27 = $m_Llaika_parse_builders$();
    var chars$6 = this.Llaika_internal_markdown_HTMLParsers$__f_htmlAttrEndChars;
    return $n($f_Llaika_parse_text_TextParsers__delimitedBy__O__Llaika_parse_text_DelimitedText(this$27, chars$6)).keepDelimiter__Llaika_parse_text_DelimitedText();
  }));
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlUnquotedAttributeValue = $n($as_Llaika_parse_Parser($n($f_Llaika_parse_markup_InlineParsers__spans__F0__Llaika_parse_markup_InlineParser(this$28, parser)).embed__F0__Llaika_parse_markup_InlineParser(new $c_sjsr_AnonFunction0((() => this.Llaika_internal_markdown_HTMLParsers$__f_htmlCharReference))))).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((spans) => {
    var spans$1 = $as_sci_List(spans);
    var _1 = $p_Llaika_internal_markdown_HTMLParsers$__asTextContainers__sci_List__sci_List(this, spans$1);
    var _2 = $m_s_None$();
    return new $c_T2(_1, _2);
  })));
  var this$30 = $n($p_Llaika_internal_markdown_HTMLParsers$__htmlQuotedAttributeValue__T__Llaika_parse_Parser(this, "\""));
  var p$6 = new $c_sjsr_AnonFunction0((() => $p_Llaika_internal_markdown_HTMLParsers$__htmlQuotedAttributeValue__T__Llaika_parse_Parser(this, "'")));
  var this$31 = $n(this$30.orElse__F0__Llaika_parse_Parser(p$6));
  var p$7 = new $c_sjsr_AnonFunction0((() => this.Llaika_internal_markdown_HTMLParsers$__f_htmlUnquotedAttributeValue));
  var htmlAttributeValue = this$31.orElse__F0__Llaika_parse_Parser(p$7);
  var $x_3 = $n(htmlAttributeName).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser(this.Llaika_internal_markdown_HTMLParsers$__f_htmlWS);
  var this$34 = $m_Llaika_parse_builders$();
  var this$33 = $n($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("=", htmlAttributeValue));
  var p$8 = this.Llaika_internal_markdown_HTMLParsers$__f_htmlWS;
  var p$9 = $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$less$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$33, p$8));
  var htmlAttribute = $n($n($x_3).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$34, p$9))).$up$up__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Llaika_parse_builders$$tilde(x$1);
    if ((x$1$1 !== null)) {
      var x10 = $as_T($n(x$1$1).Llaika_parse_builders$$tilde__f__1);
      var x11 = $as_s_Option($n(x$1$1).Llaika_parse_builders$$tilde__f__2);
      if ((x11 instanceof $c_s_Some)) {
        var x13 = $as_T2($n($as_s_Some(x11)).s_Some__f_value);
        if ((x13 !== null)) {
          var value$1 = $as_sci_List($n(x13)._1__O());
          var quotedWith = $as_s_Option($n(x13)._2__O());
          return new $c_Llaika_ast_html_HTMLAttribute(x10, value$1, quotedWith);
        }
      }
      var x = $m_s_None$();
      if ((x === x11)) {
        var value$2 = $m_sci_Nil$();
        var quotedWith$1 = $m_s_None$();
        return new $c_Llaika_ast_html_HTMLAttribute(x10, value$2, quotedWith$1);
      }
    }
    throw new $c_s_MatchError(x$1$1);
  })));
  var this$38 = $m_Llaika_parse_builders$();
  var chars$7 = $m_Llaika_parse_text_CharGroup$().Llaika_parse_text_CharGroup$__f_alpha;
  var this$42 = $n($f_Llaika_parse_text_TextParsers__someOf__O__Llaika_parse_text_PrefixCharacters(this$38, chars$7));
  var this$41 = $m_Llaika_parse_builders$();
  var value$3 = new $c_Lcats_data_NonEmptySetOps(htmlWSChars).add__O__O($bC(47));
  var chars$8 = new $c_Lcats_data_NonEmptySetOps(value$3).add__O__O($bC(62));
  var p$10 = $f_Llaika_parse_text_TextParsers__anyNot__O__Llaika_parse_text_Characters(this$41, chars$8);
  var this$43 = $n($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$42, p$10));
  var this$44 = $m_Llaika_parse_text_PrefixedParser$();
  var sc$3 = this$43.startChars__O();
  var p$11 = $c_Llaika_parse_Parser.prototype.source__Llaika_parse_Parser.call(this$43);
  var htmlTagName = new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc$3, p$11, this$44);
  var $x_4 = this.Llaika_internal_markdown_HTMLParsers$__f_htmlWS;
  var this$45 = $n(htmlAttribute);
  var p$12 = $n($n($x_4).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser(new $c_Llaika_parse_combinator_Repeat(this$45, 0, 2147483647, $m_s_None$()))).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser(this.Llaika_internal_markdown_HTMLParsers$__f_htmlWS);
  var htmlTagContent = $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(htmlTagName, p$12));
  var this$48 = $n($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("/", htmlTagName));
  var p$13 = this.Llaika_internal_markdown_HTMLParsers$__f_htmlWS;
  var this$49 = $n($f_Llaika_parse_text_PrefixedParser__$less$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$48, p$13));
  var this$52 = $n($f_Llaika_parse_text_PrefixedParser__$less$tilde__T__Llaika_parse_text_PrefixedParser(this$49, ">"));
  var f$1 = new $c_sjsr_AnonFunction1(((_$2) => {
    var _$2$1 = $as_T(_$2);
    var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    return new $c_Llaika_ast_html_HTMLEndTag(_$2$1, options$1);
  }));
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlEndTag = $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$up$up__F1__Llaika_parse_text_PrefixedParser(this$52, f$1));
  var $x_5 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var this$54 = $m_Llaika_parse_builders$();
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlComment = $as_Llaika_parse_Parser($n($x_5).$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("!--", $n($f_Llaika_parse_text_TextParsers__delimitedBy__T__Llaika_parse_text_DelimitedText(this$54, "-->")).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$3) => {
    var _$3$1 = $as_T(_$3);
    var options$2 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    return new $c_Llaika_ast_html_HTMLComment(_$3$1, options$2);
  })))));
  var $x_7 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var $x_6 = this.Llaika_internal_markdown_HTMLParsers$__f_htmlWS;
  var this$58 = $n(htmlAttribute);
  var this$60 = $n($n($x_7).$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("script", $n($n($x_6).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser(new $c_Llaika_parse_combinator_Repeat(this$58, 0, 2147483647, $m_s_None$()))).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser(this.Llaika_internal_markdown_HTMLParsers$__f_htmlWS)));
  var this$62 = $n($f_Llaika_parse_text_PrefixedParser__$less$tilde__T__Llaika_parse_text_PrefixedParser(this$60, ">"));
  var this$61 = $m_Llaika_parse_builders$();
  var p$14 = $f_Llaika_parse_text_TextParsers__delimitedBy__T__Llaika_parse_text_DelimitedText(this$61, "</script>");
  var p$15 = $f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$62, p$14);
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlScriptElement = $as_Llaika_parse_Parser($m_Llaika_parse_syntax$PrefixedMap2Ops$().mapN$extension__Llaika_parse_text_PrefixedParser__F2__Llaika_parse_text_PrefixedParser(p$15, new $c_sjsr_AnonFunction2(((_$4, _$5) => {
    var _$4$1 = $as_sci_List(_$4);
    var _$5$1 = $as_T(_$5);
    var options$3 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    return new $c_Llaika_ast_html_HTMLScriptElement(_$4$1, _$5$1, options$3);
  }))));
  var p$16 = $n(htmlTagContent).$less$tilde__T__Llaika_parse_Parser("/>");
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlEmptyElement = $m_Llaika_parse_syntax$Map2Ops$().mapN$extension__Llaika_parse_Parser__F2__Llaika_parse_Parser(p$16, new $c_sjsr_AnonFunction2(((_$6, _$7) => {
    var _$6$1 = $as_T(_$6);
    var _$7$1 = $as_sci_List(_$7);
    var options$4 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    return new $c_Llaika_ast_html_HTMLEmptyElement(_$6$1, _$7$1, options$4);
  })));
  var p$17 = $n(htmlTagContent).$less$tilde__T__Llaika_parse_Parser(">");
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlStartTag = $m_Llaika_parse_syntax$Map2Ops$().mapN$extension__Llaika_parse_Parser__F2__Llaika_parse_Parser(p$17, new $c_sjsr_AnonFunction2(((_$8, _$9) => {
    var _$8$1 = $as_T(_$8);
    var _$9$1 = $as_sci_List(_$9);
    var options$5 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    return new $c_Llaika_ast_html_HTMLStartTag(_$8$1, _$9$1, options$5);
  })));
  var factory = new $c_sjsr_AnonFunction1(((recParsers) => {
    var recParsers$1 = $as_Llaika_parse_markup_RecursiveSpanParsers(recParsers);
    var $x_8 = $m_Llaika_parse_syntax$LiteralStringOps$();
    var this$73 = $n(this.Llaika_internal_markdown_HTMLParsers$__f_htmlComment);
    var p$18 = new $c_sjsr_AnonFunction0((() => this.Llaika_internal_markdown_HTMLParsers$__f_htmlEmptyElement));
    var this$74 = $n(this$73.orElse__F0__Llaika_parse_Parser(p$18));
    var p$19 = new $c_sjsr_AnonFunction0((() => $p_Llaika_internal_markdown_HTMLParsers$__htmlElementWithNestedMarkdown__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_Parser(this, recParsers$1)));
    var this$75 = $n(this$74.orElse__F0__Llaika_parse_Parser(p$19));
    var p$20 = new $c_sjsr_AnonFunction0((() => this.Llaika_internal_markdown_HTMLParsers$__f_htmlEndTag));
    var this$76 = $n(this$75.orElse__F0__Llaika_parse_Parser(p$20));
    var p$21 = new $c_sjsr_AnonFunction0((() => this.Llaika_internal_markdown_HTMLParsers$__f_htmlStartTag));
    return $n($x_8).$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("<", this$76.orElse__F0__Llaika_parse_Parser(p$21));
  }));
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlSpan = new $c_Llaika_api_bundle_SpanParserBuilder(factory, true, $m_Llaika_api_bundle_Precedence$High$());
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlCharRef = $m_Llaika_api_bundle_SpanParserBuilder$().standalone__Llaika_parse_text_PrefixedParser__Llaika_api_bundle_SpanParserBuilder(this.Llaika_internal_markdown_HTMLParsers$__f_htmlCharReference);
  var this$78 = $m_sci_Set$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["body", "style", "blockquote", "center", "dir", "dl", "dd", "dt", "fieldset", "form", "p", "pre", "h1", "h2", "h3", "h4", "h5", "h6", "ol", "ul", "li", "div", "hr", "isindex", "menu", "frameset", "noframes", "table", "thead", "tbody", "tfoot", "th", "tr", "td", "article", "aside", "section", "address", "details", "header", "footer", "hgroup", "figure", "figcaption", "menu", "nav", "summary"]));
  this.Llaika_internal_markdown_HTMLParsers$__f_laika$internal$markdown$HTMLParsers$$$htmlBlockElements = this$78.from__sc_IterableOnce__sci_Set(elems);
  var \u03b41$ = $m_Llaika_parse_syntax$LiteralStringOps$().$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("<", this.Llaika_internal_markdown_HTMLParsers$__f_htmlStartTag);
  var this$81 = $n(\u03b41$);
  var f$2 = new $c_Llaika_internal_markdown_HTMLParsers$$anon$1();
  var this$80 = $n(\u03b41$);
  var error = $f_Llaika_parse_text_PrefixedParser__collect$default$2__F1(this$80);
  this.Llaika_internal_markdown_HTMLParsers$__f_htmlBlockStart = $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__collect__s_PartialFunction__F1__Llaika_parse_text_PrefixedParser(this$81, f$2, error));
}
$c_Llaika_internal_markdown_HTMLParsers$.prototype = new $h_O();
$c_Llaika_internal_markdown_HTMLParsers$.prototype.constructor = $c_Llaika_internal_markdown_HTMLParsers$;
/** @constructor */
function $h_Llaika_internal_markdown_HTMLParsers$() {
}
$h_Llaika_internal_markdown_HTMLParsers$.prototype = $c_Llaika_internal_markdown_HTMLParsers$.prototype;
$c_Llaika_internal_markdown_HTMLParsers$.prototype.htmlBlockFragment__Llaika_api_bundle_BlockParserBuilder = (function() {
  if ((!this.Llaika_internal_markdown_HTMLParsers$__f_htmlBlockFragmentbitmap$1)) {
    var $x_1 = $m_Llaika_api_bundle_BlockParserBuilder$();
    var this$2 = $n($p_Llaika_internal_markdown_HTMLParsers$__htmlBlock__Llaika_parse_Parser(this));
    var p = new $c_sjsr_AnonFunction0((() => $p_Llaika_internal_markdown_HTMLParsers$__htmlBlockElement__Llaika_parse_Parser(this)));
    this.Llaika_internal_markdown_HTMLParsers$__f_htmlBlockFragment$lzy1 = $n($n($x_1).standalone__Llaika_parse_Parser__Llaika_api_bundle_BlockParserBuilder(this$2.orElse__F0__Llaika_parse_Parser(p))).rootOnly__Llaika_api_bundle_BlockParserBuilder();
    this.Llaika_internal_markdown_HTMLParsers$__f_htmlBlockFragmentbitmap$1 = true;
  }
  return this.Llaika_internal_markdown_HTMLParsers$__f_htmlBlockFragment$lzy1;
});
var $d_Llaika_internal_markdown_HTMLParsers$ = new $TypeData().initClass($c_Llaika_internal_markdown_HTMLParsers$, "laika.internal.markdown.HTMLParsers$", ({
  Llaika_internal_markdown_HTMLParsers$: 1
}));
var $n_Llaika_internal_markdown_HTMLParsers$;
function $m_Llaika_internal_markdown_HTMLParsers$() {
  if ((!$n_Llaika_internal_markdown_HTMLParsers$)) {
    $n_Llaika_internal_markdown_HTMLParsers$ = new $c_Llaika_internal_markdown_HTMLParsers$();
  }
  return $n_Llaika_internal_markdown_HTMLParsers$;
}
function $p_Llaika_internal_markdown_InlineParsers$__enclosedBySingleChar__C__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_text_PrefixedParser($thiz, c, recParsers) {
  var this$1 = $m_Llaika_parse_builders$();
  var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
  var start = $n($f_Llaika_parse_text_TextParsers__delimiter__C__sci_Seq__Llaika_parse_text_DelimiterParser(this$1, c, chars)).nextNot__C__sci_Seq__Llaika_parse_text_DelimiterParser(32, $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([10, c]))));
  var this$2 = $m_Llaika_parse_builders$();
  var chars$1 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
  var end = $n($f_Llaika_parse_text_TextParsers__delimiter__C__sci_Seq__Llaika_parse_text_DelimiterParser(this$2, c, chars$1)).prevNot__C__sci_Seq__Llaika_parse_text_DelimiterParser(32, $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([]))));
  return $thiz.span__Llaika_parse_text_PrefixedParser__Llaika_parse_text_PrefixedParser__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_text_PrefixedParser(start, end, recParsers);
}
function $p_Llaika_internal_markdown_InlineParsers$__resource__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_Parser($thiz, recParsers) {
  var this$3 = $m_Llaika_parse_markup_InlineParsers$();
  var parser = new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_Llaika_parse_builders$();
    return $f_Llaika_parse_text_TextParsers__delimitedBy__T__Llaika_parse_text_DelimitedText(this$2, "]");
  }));
  var linkText = $n($n($f_Llaika_parse_markup_InlineParsers__text__F0__Llaika_parse_markup_InlineParser(this$3, parser)).embed__F0__Llaika_parse_markup_InlineParser(new $c_sjsr_AnonFunction0((() => {
    var this$4 = $n($n(recParsers).escapeSequence__Llaika_parse_text_PrefixedParser());
    var f = new $c_sjsr_AnonFunction1(((_$8) => {
      var _$8$1 = $as_T(_$8);
      return ("\\" + _$8$1);
    }));
    return $f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser(this$4, f);
  })))).embed__F0__Llaika_parse_markup_InlineParser(new $c_sjsr_AnonFunction0((() => {
    var $x_1 = $m_Llaika_parse_syntax$LiteralStringOps$();
    var this$6 = $m_Llaika_parse_builders$();
    return $n($x_1).$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("[", $n($f_Llaika_parse_text_TextParsers__delimitedBy__T__Llaika_parse_text_DelimitedText(this$6, "]")).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$9) => {
      var _$9$1 = $as_T(_$9);
      return (("[" + _$9$1) + "]");
    }))));
  })));
  var titleEnd = $n($n($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters()).void__Llaika_parse_text_Characters()).$tilde__T__Llaika_parse_Parser(")");
  var $x_2 = $n($n($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters()).void__Llaika_parse_text_Characters());
  var this$7 = $n($p_Llaika_internal_markdown_InlineParsers$__enclosedIn$1__Llaika_parse_Parser__T__Llaika_parse_Parser($thiz, titleEnd, "\""));
  var p = new $c_sjsr_AnonFunction0((() => $p_Llaika_internal_markdown_InlineParsers$__enclosedIn$1__Llaika_parse_Parser__T__Llaika_parse_Parser($thiz, titleEnd, "'")));
  var title = $n($x_2).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser(this$7.orElse__F0__Llaika_parse_Parser(p));
  var $x_3 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var this$9 = $m_Llaika_parse_builders$();
  var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
  var this$10 = $n($n($x_3).$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("(", $f_Llaika_parse_text_TextParsers__delimitedBy__C__sci_Seq__Llaika_parse_text_DelimitedText(this$9, 41, chars)));
  var this$11 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = this$10.startChars__O();
  var p$1 = $c_Llaika_parse_Parser.prototype.source__Llaika_parse_Parser.call(this$10);
  var nestedParens = new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p$1, this$11);
  var $x_4 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var this$14 = $m_Llaika_parse_markup_InlineParsers$();
  var parser$1 = new $c_sjsr_AnonFunction0((() => {
    var this$13 = $m_Llaika_parse_builders$();
    var chars$1 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
    return $f_Llaika_parse_text_TextParsers__delimitedBy__C__sci_Seq__Llaika_parse_text_DelimitedText(this$13, 62, chars$1);
  }));
  var this$17 = $n($as_Llaika_parse_Parser($n($x_4).$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("<", $as_Llaika_parse_Parser($n($f_Llaika_parse_markup_InlineParsers__text__F0__Llaika_parse_markup_InlineParser(this$14, parser$1)).embed__F0__Llaika_parse_markup_InlineParser(new $c_sjsr_AnonFunction0((() => $n(recParsers).escapeSequence__Llaika_parse_text_PrefixedParser())))))));
  var p$2 = new $c_sjsr_AnonFunction0((() => {
    var this$16 = $m_Llaika_parse_markup_InlineParsers$();
    var parser$2 = new $c_sjsr_AnonFunction0((() => {
      var this$15 = $m_Llaika_parse_builders$();
      var chars$2 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([32, 9])));
      return $n($f_Llaika_parse_text_TextParsers__delimitedBy__C__sci_Seq__Llaika_parse_text_DelimitedText(this$15, 41, chars$2)).keepDelimiter__Llaika_parse_text_DelimitedText();
    }));
    return $as_Llaika_parse_Parser($n($f_Llaika_parse_markup_InlineParsers__text__F0__Llaika_parse_markup_InlineParser(this$16, parser$2)).embedAll__F0__Llaika_parse_markup_InlineParser(new $c_sjsr_AnonFunction0((() => $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_parse_text_PrefixedParser.getArrayOf().constr)([$n(recParsers).escapeSequence__Llaika_parse_text_PrefixedParser(), nestedParens]))))))));
  }));
  var url = this$17.orElse__F0__Llaika_parse_Parser(p$2);
  var this$20 = $n($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("(", url));
  var this$19 = $m_Llaika_parse_builders$();
  var p$3 = $f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$19, title);
  var this$21 = $n($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$20, p$3));
  var p$4 = $n($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters()).$tilde__T__Llaika_parse_Parser(")");
  var p$5 = $f_Llaika_parse_text_PrefixedParser__$less$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$21, p$4);
  var this$24 = $n($m_Llaika_parse_syntax$PrefixedMap2Ops$().mapN$extension__Llaika_parse_text_PrefixedParser__F2__Llaika_parse_text_PrefixedParser(p$5, new $c_sjsr_AnonFunction2(((url$2, title$2) => {
    var url$1 = $as_T(url$2);
    var title$1 = $as_s_Option(title$2);
    return new $c_Llaika_internal_markdown_InlineParsers$TargetUrl(url$1, title$1);
  }))));
  var this$25 = $m_Llaika_parse_text_PrefixedParser$();
  var sc$1 = this$24.startChars__O();
  var p$6 = $c_Llaika_parse_Parser.prototype.withCursor__Llaika_parse_Parser.call(this$24);
  var this$27 = new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc$1, p$6, this$25);
  var f$1 = new $c_sjsr_AnonFunction1(((t) => {
    var t$1 = $as_T2(t);
    var _1 = $n(t$1)._1__O();
    var _2 = $n($as_Llaika_parse_SourceCursor($n(t$1)._2__O())).input__T();
    return new $c_T2(_1, _2);
  }));
  var urlWithTitle = $f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser(this$27, f$1);
  var $x_6 = $m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters();
  var this$28 = $m_Llaika_parse_builders$();
  var p$7 = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_eol;
  var $x_5 = $n($n($x_6).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$28, p$7))).$tilde__T__Llaika_parse_Parser("[");
  var this$29 = $n(recParsers);
  var chars$3 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
  var refId = $n($n($n($x_5).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($n($f_Llaika_internal_parse_markup_DefaultEscapedTextParsers__escapedUntil__C__sci_Seq__Llaika_parse_Parser(this$29, 93, chars$3)).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((id) => {
    var id$1 = $as_T(id);
    return new $c_Llaika_internal_markdown_InlineParsers$TargetId(id$1);
  }))))).withCursor__Llaika_parse_Parser()).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((t$2) => {
    var t$3 = $as_T2(t$2);
    var _1$1 = $n(t$3)._1__O();
    var _2$1 = $n($as_Llaika_parse_SourceCursor($n(t$3)._2__O())).input__T();
    return new $c_T2(_1$1, _2$1);
  })));
  var $x_7 = $m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters();
  var this$32 = $m_Llaika_parse_builders$();
  var p$8 = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_eol;
  var refEmpty = $n($n($n($n($x_7).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$32, p$8))).$tilde__T__Llaika_parse_Parser("[]")).source__Llaika_parse_Parser()).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$10) => {
    var _$10$1 = $as_T(_$10);
    var _1$2 = $m_Llaika_internal_markdown_InlineParsers$ImplicitTarget$();
    return new $c_T2(_1$2, _$10$1);
  })));
  var this$35 = $m_Llaika_parse_builders$();
  var _1$3 = $m_Llaika_internal_markdown_InlineParsers$ImplicitTarget$();
  var v = new $c_T2(_1$3, "");
  var noRef = $f_Llaika_parse_combinator_Parsers__success__O__Llaika_parse_Parser(this$35, v);
  var p$9 = $as_Llaika_parse_Parser(linkText);
  var $x_8 = $m_Llaika_parse_syntax$StringParserOps$().line$extension__Llaika_parse_Parser__Llaika_parse_Parser(p$9);
  var this$37 = $n($as_Llaika_parse_Parser(urlWithTitle));
  var p$10 = new $c_sjsr_AnonFunction0((() => refEmpty));
  var this$38 = $n(this$37.orElse__F0__Llaika_parse_Parser(p$10));
  var p$11 = new $c_sjsr_AnonFunction0((() => refId));
  var this$39 = $n(this$38.orElse__F0__Llaika_parse_Parser(p$11));
  var p$12 = new $c_sjsr_AnonFunction0((() => noRef));
  return $n($n($x_8).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(this$39.orElse__F0__Llaika_parse_Parser(p$12))).$up$up__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Llaika_parse_builders$$tilde(x$1);
    if ((x$1$1 !== null)) {
      var x40 = $as_T2($n(x$1$1).Llaika_parse_builders$$tilde__f__2);
      var text = $as_Llaika_parse_LineSource($n(x$1$1).Llaika_parse_builders$$tilde__f__1);
      if ((x40 !== null)) {
        var target = $as_Llaika_internal_markdown_InlineParsers$ResourceTarget($n(x40)._1__O());
        var source = $as_T($n(x40)._2__O());
        var suffix = ("]" + source);
        return new $c_Llaika_internal_markdown_InlineParsers$Resource(text, target, suffix);
      }
    }
    throw new $c_s_MatchError(x$1$1);
  })));
}
function $p_Llaika_internal_markdown_InlineParsers$__isAcceptedScheme$1__T__Z($thiz, s) {
  return ((((s === "http") || (s === "https")) || (s === "ftp")) || (s === "mailto"));
}
function $p_Llaika_internal_markdown_InlineParsers$__unwrap$1__Llaika_ast_LinkIdReference__T__Llaika_ast_Span($thiz, ref, suffix) {
  var this$2 = $n(ref);
  var p = new $c_sjsr_AnonFunction1(((_$4) => {
    var _$4$1 = $as_Llaika_ast_Element(_$4);
    return (_$4$1 instanceof $c_Llaika_ast_LinkIdReference);
  }));
  var this$3 = $n($as_sc_IterableOnceOps($n($f_Llaika_ast_ElementTraversal__select__F1__sci_List(this$2, p)).tail__O()));
  if ((!this$3.isEmpty__Z())) {
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var elem$2 = new $c_Llaika_ast_Text("[", options);
    var prefix$1 = $n($n(ref).Llaika_ast_LinkIdReference__f_content).toList__sci_List();
    var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var elem$1 = new $c_Llaika_ast_Text(suffix, options$1);
    var this$8 = $m_sci_Nil$();
    var this$9 = $n(new $c_sci_$colon$colon(elem$1, this$8).$colon$colon$colon__sci_List__sci_List(prefix$1));
    var content = new $c_sci_$colon$colon(elem$2, this$9);
    var options$2 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var $x_1 = new $c_Llaika_ast_SpanSequence(content, options$2);
  } else {
    var $x_1 = ref;
  }
  return $as_Llaika_ast_Span($x_1);
}
function $p_Llaika_internal_markdown_InlineParsers$__linkReference$1__Llaika_parse_markup_RecursiveSpanParsers__Llaika_internal_markdown_InlineParsers$Resource__T__Llaika_parse_SourceFragment__Llaika_ast_Span($thiz, recParsers$4, res, id, src) {
  var this$1 = $n(recParsers$4);
  var content = new $c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$RecursiveSpanParserDelegate(this$1, $as_Llaika_parse_Parser(this$1.defaultSpanParser__Llaika_parse_markup_InlineParser())).parseAndRecover__Llaika_parse_SourceFragment__sci_Seq($n(res).Llaika_internal_markdown_InlineParsers$Resource__f_text);
  var this$2 = $n(id);
  var ref = $f_T__replaceAll__T__T__T($n($as_T(this$2.toLowerCase())), "[\n ]+", " ");
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  var ref$1 = new $c_Llaika_ast_LinkIdReference(content, ref, src, options);
  return (($n($n(res).Llaika_internal_markdown_InlineParsers$Resource__f_text).Llaika_parse_LineSource__f_input === id) ? $p_Llaika_internal_markdown_InlineParsers$__unwrap$1__Llaika_ast_LinkIdReference__T__Llaika_ast_Span($thiz, ref$1, $n(res).Llaika_internal_markdown_InlineParsers$Resource__f_suffix) : ref$1);
}
function $p_Llaika_internal_markdown_InlineParsers$__enclosedIn$1__Llaika_parse_Parser__T__Llaika_parse_Parser($thiz, titleEnd$1, delim) {
  var $x_2 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var this$4 = $m_Llaika_parse_builders$();
  var $x_1 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var this$3 = $m_Llaika_parse_builders$();
  var delimiter = $n($x_1).$less$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(delim, $f_Llaika_parse_combinator_Parsers__lookAhead__Llaika_parse_Parser__Llaika_parse_Parser(this$3, titleEnd$1));
  return $as_Llaika_parse_Parser($n($x_2).$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(delim, $f_Llaika_parse_text_TextParsers__delimitedBy__Llaika_parse_text_PrefixedParser__Llaika_parse_text_DelimitedText(this$4, delimiter)));
}
/** @constructor */
function $c_Llaika_internal_markdown_InlineParsers$() {
  this.Llaika_internal_markdown_InlineParsers$__f_escapedChar = null;
  this.Llaika_internal_markdown_InlineParsers$__f_lineBreak = null;
  this.Llaika_internal_markdown_InlineParsers$__f_enclosedByAsterisk = null;
  this.Llaika_internal_markdown_InlineParsers$__f_enclosedByUnderscore = null;
  this.Llaika_internal_markdown_InlineParsers$__f_literalSpan = null;
  this.Llaika_internal_markdown_InlineParsers$__f_link$lzy1 = null;
  this.Llaika_internal_markdown_InlineParsers$__f_linkbitmap$1 = false;
  this.Llaika_internal_markdown_InlineParsers$__f_image = null;
  this.Llaika_internal_markdown_InlineParsers$__f_simpleLink = null;
  $n_Llaika_internal_markdown_InlineParsers$ = this;
  var this$1 = $m_Llaika_parse_builders$();
  var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([96, 42, 95, 123, 125, 91, 93, 40, 41, 35, 43, 45, 46, 33, 62, 124])));
  this.Llaika_internal_markdown_InlineParsers$__f_escapedChar = $as_Llaika_parse_Parser($f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser(this$1, 92, chars));
  var $x_1 = $m_Llaika_api_bundle_SpanParserBuilder$();
  $m_Llaika_parse_builders$();
  var this$6 = new $c_Llaika_parse_text_Literal("\\\r");
  var v = new $c_sjsr_AnonFunction0((() => {
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    return new $c_Llaika_ast_LineBreak(options);
  }));
  this.Llaika_internal_markdown_InlineParsers$__f_lineBreak = $n($x_1).standalone__Llaika_parse_text_PrefixedParser__Llaika_api_bundle_SpanParserBuilder($f_Llaika_parse_text_PrefixedParser__as__F0__Llaika_parse_text_PrefixedParser(this$6, v));
  var factory = new $c_sjsr_AnonFunction1(((recParsers) => {
    var recParsers$1 = $as_Llaika_parse_markup_RecursiveSpanParsers(recParsers);
    var this$7 = $n(this.strong__C__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_text_PrefixedParser(42, recParsers$1));
    var p = new $c_sjsr_AnonFunction0((() => this.em__C__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_text_PrefixedParser(42, recParsers$1)));
    return $f_Llaika_parse_text_PrefixedParser__$bar__F0__Llaika_parse_text_PrefixedParser(this$7, p);
  }));
  this.Llaika_internal_markdown_InlineParsers$__f_enclosedByAsterisk = new $c_Llaika_api_bundle_SpanParserBuilder(factory, true, $m_Llaika_api_bundle_Precedence$High$());
  var factory$1 = new $c_sjsr_AnonFunction1(((recParsers$2) => {
    var recParsers$3 = $as_Llaika_parse_markup_RecursiveSpanParsers(recParsers$2);
    var this$9 = $n(this.strong__C__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_text_PrefixedParser(95, recParsers$3));
    var p$1 = new $c_sjsr_AnonFunction0((() => this.em__C__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_text_PrefixedParser(95, recParsers$3)));
    return $f_Llaika_parse_text_PrefixedParser__$bar__F0__Llaika_parse_text_PrefixedParser(this$9, p$1);
  }));
  this.Llaika_internal_markdown_InlineParsers$__f_enclosedByUnderscore = new $c_Llaika_api_bundle_SpanParserBuilder(factory$1, true, $m_Llaika_api_bundle_Precedence$High$());
  var $x_2 = $m_Llaika_api_bundle_SpanParserBuilder$();
  var this$11 = $m_Llaika_parse_builders$();
  var chars$1 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
  var this$17 = $n($n($f_Llaika_parse_text_TextParsers__someOf__C__sci_Seq__Llaika_parse_text_PrefixCharacters(this$11, 96, chars$1)).count__Llaika_parse_text_PrefixCharacters());
  var fq = new $c_sjsr_AnonFunction1(((cnt) => {
    var cnt$1 = $uI(cnt);
    var this$13 = $m_Llaika_parse_builders$();
    var str = $m_sc_StringOps$().$times$extension__T__I__T("`", cnt$1);
    var p$2 = $f_Llaika_parse_text_TextParsers__delimitedBy__T__Llaika_parse_text_DelimitedText(this$13, str);
    return $n($m_Llaika_parse_syntax$StringParserOps$().trim$extension__Llaika_parse_Parser__Llaika_parse_Parser(p$2)).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$3) => {
      var _$3$1 = $as_T(_$3);
      var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      return new $c_Llaika_ast_Literal(_$3$1, options$1);
    })));
  }));
  this.Llaika_internal_markdown_InlineParsers$__f_literalSpan = $n($x_2).standalone__Llaika_parse_text_PrefixedParser__Llaika_api_bundle_SpanParserBuilder($f_Llaika_parse_text_PrefixedParser__$greater$greater__F1__Llaika_parse_text_PrefixedParser(this$17, fq));
  var factory$2 = new $c_sjsr_AnonFunction1(((recParsers$3$1) => {
    var recParsers$4 = $as_Llaika_parse_markup_RecursiveSpanParsers(recParsers$3$1);
    var this$19 = $n($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("![", $p_Llaika_internal_markdown_InlineParsers$__resource__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_Parser(this, recParsers$4)));
    var this$20 = $m_Llaika_parse_text_PrefixedParser$();
    var sc = this$19.startChars__O();
    var p$3 = $c_Llaika_parse_Parser.prototype.withCursor__Llaika_parse_Parser.call(this$19);
    var this$41 = new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p$3, this$20);
    var f = new $c_sjsr_AnonFunction1(((x$1) => {
      var x$1$1 = $as_T2(x$1);
      if ((x$1$1 !== null)) {
        var res = $as_Llaika_internal_markdown_InlineParsers$Resource($n(x$1$1)._1__O());
        var source = $as_Llaika_parse_SourceFragment($n(x$1$1)._2__O());
        var x12 = $n(res).Llaika_internal_markdown_InlineParsers$Resource__f_target;
        if ((x12 instanceof $c_Llaika_internal_markdown_InlineParsers$TargetUrl)) {
          var x$1$2 = $as_Llaika_internal_markdown_InlineParsers$TargetUrl(x12);
          var this$22 = $n(x$1$2);
          var x18 = this$22.Llaika_internal_markdown_InlineParsers$TargetUrl__f_url;
          var this$23 = $n(x$1$2);
          var x19 = this$23.Llaika_internal_markdown_InlineParsers$TargetUrl__f_title;
          var text = $n(res).Llaika_internal_markdown_InlineParsers$Resource__f_text;
          var this$24 = $n(recParsers$4);
          var p$4 = $m_Llaika_parse_text_DelimitedText$().Undelimited__Llaika_parse_text_DelimitedText();
          var this$25 = $n($n($n($f_Llaika_internal_parse_markup_DefaultEscapedTextParsers__escapedText__Llaika_parse_text_DelimitedText__Llaika_parse_Parser(this$24, p$4)).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(text)).toEither__s_util_Either());
          if ((this$25 instanceof $c_s_util_Right)) {
            var x2 = $as_s_util_Right(this$25);
            var b = $n(x2).s_util_Right__f_value;
            var text$1 = $as_T(b);
            var alt$1 = new $c_s_Some(text$1);
            var width$1 = $m_s_None$();
            var height$1 = $m_s_None$();
            var $x_3 = $m_Llaika_ast_ParsedTarget$().forImage__T__Llaika_parse_SourceFragment__s_Option__s_Option__s_Option__s_Option__Llaika_ast_Span(x18, source, width$1, height$1, alt$1, x19);
          } else {
            if ((!(this$25 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(this$25);
            }
            var x3 = $as_s_util_Left(this$25);
            var a = $n(x3).s_util_Left__f_value;
            var _$5 = $as_T(a);
            var $x_3 = $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan(_$5, source);
          }
          return $as_Llaika_ast_Span($x_3);
        }
        if ((x12 instanceof $c_Llaika_internal_markdown_InlineParsers$TargetId)) {
          var x$1$3 = $as_Llaika_internal_markdown_InlineParsers$TargetId(x12);
          var this$30 = $n(x$1$3);
          var x15 = this$30.Llaika_internal_markdown_InlineParsers$TargetId__f_id;
          var text$2 = $n(res).Llaika_internal_markdown_InlineParsers$Resource__f_text;
          var this$31 = $n(recParsers$4);
          var p$5 = $m_Llaika_parse_text_DelimitedText$().Undelimited__Llaika_parse_text_DelimitedText();
          var this$32 = $n($n($n($f_Llaika_internal_parse_markup_DefaultEscapedTextParsers__escapedText__Llaika_parse_text_DelimitedText__Llaika_parse_Parser(this$31, p$5)).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(text$2)).toEither__s_util_Either());
          if ((this$32 instanceof $c_s_util_Right)) {
            var x2$1 = $as_s_util_Right(this$32);
            var b$1 = $n(x2$1).s_util_Right__f_value;
            var _$6 = $as_T(b$1);
            var this$33 = $n(x15);
            var id = $f_T__replaceAll__T__T__T($n($as_T(this$33.toLowerCase())), "[\n ]+", " ");
            var options$2 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
            var $x_4 = new $c_Llaika_ast_ImageIdReference(_$6, id, source, options$2);
          } else {
            if ((!(this$32 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(this$32);
            }
            var x3$1 = $as_s_util_Left(this$32);
            var a$1 = $n(x3$1).s_util_Left__f_value;
            var _$5$1 = $as_T(a$1);
            var $x_4 = $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan(_$5$1, source);
          }
          return $as_Llaika_ast_Span($x_4);
        }
        var x = $m_Llaika_internal_markdown_InlineParsers$ImplicitTarget$();
        if ((x === x12)) {
          var text$3 = $n(res).Llaika_internal_markdown_InlineParsers$Resource__f_text;
          var this$36 = $n(recParsers$4);
          var p$6 = $m_Llaika_parse_text_DelimitedText$().Undelimited__Llaika_parse_text_DelimitedText();
          var this$37 = $n($n($n($f_Llaika_internal_parse_markup_DefaultEscapedTextParsers__escapedText__Llaika_parse_text_DelimitedText__Llaika_parse_Parser(this$36, p$6)).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(text$3)).toEither__s_util_Either());
          if ((this$37 instanceof $c_s_util_Right)) {
            var x2$2 = $as_s_util_Right(this$37);
            var b$2 = $n(x2$2).s_util_Right__f_value;
            var _$7 = $as_T(b$2);
            var id$1 = $n($n(res).Llaika_internal_markdown_InlineParsers$Resource__f_text).Llaika_parse_LineSource__f_input;
            var this$38 = $n(id$1);
            var id$2 = $f_T__replaceAll__T__T__T($n($as_T(this$38.toLowerCase())), "[\n ]+", " ");
            var options$3 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
            var $x_5 = new $c_Llaika_ast_ImageIdReference(_$7, id$2, source, options$3);
          } else {
            if ((!(this$37 instanceof $c_s_util_Left))) {
              throw new $c_s_MatchError(this$37);
            }
            var x3$2 = $as_s_util_Left(this$37);
            var a$2 = $n(x3$2).s_util_Left__f_value;
            var _$5$2 = $as_T(a$2);
            var $x_5 = $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan(_$5$2, source);
          }
          return $as_Llaika_ast_Span($x_5);
        }
        throw new $c_s_MatchError(x12);
      }
      throw new $c_s_MatchError(x$1$1);
    }));
    return $f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser(this$41, f);
  }));
  this.Llaika_internal_markdown_InlineParsers$__f_image = new $c_Llaika_api_bundle_SpanParserBuilder(factory$2, true, $m_Llaika_api_bundle_Precedence$High$());
  var $x_7 = $m_Llaika_api_bundle_SpanParserBuilder$();
  var $x_6 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var this$44 = $m_Llaika_parse_builders$();
  var chars$2 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([13, 10, 9, 62])));
  var this$45 = $n($n($x_6).$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("<", $f_Llaika_parse_text_TextParsers__anyNot__C__sci_Seq__Llaika_parse_text_Characters(this$44, 32, chars$2)));
  var \u03b41$ = $f_Llaika_parse_text_PrefixedParser__$less$tilde__T__Llaika_parse_text_PrefixedParser(this$45, ">");
  var this$47 = $n(\u03b41$);
  var f$1 = new $c_Llaika_internal_markdown_InlineParsers$$anon$1();
  var this$46 = $n(\u03b41$);
  var error = $f_Llaika_parse_text_PrefixedParser__collect$default$2__F1(this$46);
  this.Llaika_internal_markdown_InlineParsers$__f_simpleLink = $n($x_7).standalone__Llaika_parse_text_PrefixedParser__Llaika_api_bundle_SpanParserBuilder($f_Llaika_parse_text_PrefixedParser__collect__s_PartialFunction__F1__Llaika_parse_text_PrefixedParser(this$47, f$1, error));
}
$c_Llaika_internal_markdown_InlineParsers$.prototype = new $h_O();
$c_Llaika_internal_markdown_InlineParsers$.prototype.constructor = $c_Llaika_internal_markdown_InlineParsers$;
/** @constructor */
function $h_Llaika_internal_markdown_InlineParsers$() {
}
$h_Llaika_internal_markdown_InlineParsers$.prototype = $c_Llaika_internal_markdown_InlineParsers$.prototype;
$c_Llaika_internal_markdown_InlineParsers$.prototype.strong__C__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_text_PrefixedParser = (function(char, recParsers) {
  var this$4 = $n(this.enclosedByDoubleChar__C__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_text_PrefixedParser(char, recParsers));
  var f = new $c_sjsr_AnonFunction1(((_$1) => {
    var _$1$1 = $as_sci_List(_$1);
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    return new $c_Llaika_ast_Strong(_$1$1, options);
  }));
  return $f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser(this$4, f);
});
$c_Llaika_internal_markdown_InlineParsers$.prototype.em__C__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_text_PrefixedParser = (function(char, recParsers) {
  var this$4 = $n($p_Llaika_internal_markdown_InlineParsers$__enclosedBySingleChar__C__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_text_PrefixedParser(this, char, recParsers));
  var f = new $c_sjsr_AnonFunction1(((_$2) => {
    var _$2$1 = $as_sci_List(_$2);
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    return new $c_Llaika_ast_Emphasized(_$2$1, options);
  }));
  return $f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser(this$4, f);
});
$c_Llaika_internal_markdown_InlineParsers$.prototype.span__Llaika_parse_text_PrefixedParser__Llaika_parse_text_PrefixedParser__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_text_PrefixedParser = (function(start, end, recParsers) {
  var this$3 = $n(start);
  var this$2 = $n(recParsers);
  var this$1 = $m_Llaika_parse_builders$();
  var p = $f_Llaika_parse_text_TextParsers__delimitedBy__Llaika_parse_text_PrefixedParser__Llaika_parse_text_DelimitedText(this$1, end);
  var p$1 = $as_Llaika_parse_Parser($f_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers__recursiveSpans__Llaika_parse_text_DelimitedText__Llaika_parse_markup_InlineParser(this$2, p));
  return $f_Llaika_parse_text_PrefixedParser__$tilde$greater__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$3, p$1);
});
$c_Llaika_internal_markdown_InlineParsers$.prototype.enclosedByDoubleChar__C__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_text_PrefixedParser = (function(c, recParsers) {
  var this$1 = $m_Llaika_parse_builders$();
  var delim = ($cToS(c) + $cToS(c));
  var start = $n($f_Llaika_parse_text_TextParsers__delimiter__T__Llaika_parse_text_DelimiterParser(this$1, delim)).nextNot__C__sci_Seq__Llaika_parse_text_DelimiterParser(32, $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([10]))));
  var this$2 = $m_Llaika_parse_builders$();
  var delim$1 = ($cToS(c) + $cToS(c));
  var end = $n($f_Llaika_parse_text_TextParsers__delimiter__T__Llaika_parse_text_DelimiterParser(this$2, delim$1)).prevNot__C__sci_Seq__Llaika_parse_text_DelimiterParser(32, $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([]))));
  return this.span__Llaika_parse_text_PrefixedParser__Llaika_parse_text_PrefixedParser__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_text_PrefixedParser(start, end, recParsers);
});
$c_Llaika_internal_markdown_InlineParsers$.prototype.link__Llaika_api_bundle_SpanParserBuilder = (function() {
  if ((!this.Llaika_internal_markdown_InlineParsers$__f_linkbitmap$1)) {
    var factory = new $c_sjsr_AnonFunction1(((recParsers) => {
      var recParsers$1 = $as_Llaika_parse_markup_RecursiveSpanParsers(recParsers);
      var this$3 = $n($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("[", $p_Llaika_internal_markdown_InlineParsers$__resource__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_Parser(this, recParsers$1)));
      var this$4 = $m_Llaika_parse_text_PrefixedParser$();
      var sc = this$3.startChars__O();
      var p = $c_Llaika_parse_Parser.prototype.withCursor__Llaika_parse_Parser.call(this$3);
      var this$11 = new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p, this$4);
      var f = new $c_sjsr_AnonFunction1(((x$1) => {
        var x$1$1 = $as_T2(x$1);
        if ((x$1$1 !== null)) {
          var res = $as_Llaika_internal_markdown_InlineParsers$Resource($n(x$1$1)._1__O());
          var source = $as_Llaika_parse_SourceFragment($n(x$1$1)._2__O());
          var x1 = $n(res).Llaika_internal_markdown_InlineParsers$Resource__f_target;
          if ((x1 instanceof $c_Llaika_internal_markdown_InlineParsers$TargetUrl)) {
            var x$1$2 = $as_Llaika_internal_markdown_InlineParsers$TargetUrl(x1);
            var this$6 = $n(x$1$2);
            var x7 = this$6.Llaika_internal_markdown_InlineParsers$TargetUrl__f_url;
            var this$7 = $n(x$1$2);
            var x8 = this$7.Llaika_internal_markdown_InlineParsers$TargetUrl__f_title;
            var $x_1 = $m_Llaika_ast_ParsedTarget$();
            var this$8 = $n(recParsers$1);
            return $n($x_1).forLink__sci_Seq__T__Llaika_parse_SourceFragment__s_Option__Llaika_ast_Span(new $c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$RecursiveSpanParserDelegate(this$8, $as_Llaika_parse_Parser(this$8.defaultSpanParser__Llaika_parse_markup_InlineParser())).parseAndRecover__Llaika_parse_SourceFragment__sci_Seq($n(res).Llaika_internal_markdown_InlineParsers$Resource__f_text), x7, source, x8);
          }
          if ((x1 instanceof $c_Llaika_internal_markdown_InlineParsers$TargetId)) {
            var x$1$3 = $as_Llaika_internal_markdown_InlineParsers$TargetId(x1);
            var this$10 = $n(x$1$3);
            var x4 = this$10.Llaika_internal_markdown_InlineParsers$TargetId__f_id;
            return $p_Llaika_internal_markdown_InlineParsers$__linkReference$1__Llaika_parse_markup_RecursiveSpanParsers__Llaika_internal_markdown_InlineParsers$Resource__T__Llaika_parse_SourceFragment__Llaika_ast_Span(this, recParsers$1, res, x4, source);
          }
          var x = $m_Llaika_internal_markdown_InlineParsers$ImplicitTarget$();
          if ((x === x1)) {
            return $p_Llaika_internal_markdown_InlineParsers$__linkReference$1__Llaika_parse_markup_RecursiveSpanParsers__Llaika_internal_markdown_InlineParsers$Resource__T__Llaika_parse_SourceFragment__Llaika_ast_Span(this, recParsers$1, res, $n($n(res).Llaika_internal_markdown_InlineParsers$Resource__f_text).Llaika_parse_LineSource__f_input, source);
          }
          throw new $c_s_MatchError(x1);
        }
        throw new $c_s_MatchError(x$1$1);
      }));
      return $f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser(this$11, f);
    }));
    this.Llaika_internal_markdown_InlineParsers$__f_link$lzy1 = new $c_Llaika_api_bundle_SpanParserBuilder(factory, true, $m_Llaika_api_bundle_Precedence$High$());
    this.Llaika_internal_markdown_InlineParsers$__f_linkbitmap$1 = true;
  }
  return this.Llaika_internal_markdown_InlineParsers$__f_link$lzy1;
});
$c_Llaika_internal_markdown_InlineParsers$.prototype.laika$internal$markdown$InlineParsers$$$_$isURI$1__T__Z = (function(s) {
  try {
    var uri = new $c_Ljava_net_URI(s);
    var r1 = (uri.Ljava_net_URI__f_java$net$URI$$_isAbsolute && $p_Llaika_internal_markdown_InlineParsers$__isAcceptedScheme$1__T__Z(this, uri.Ljava_net_URI__f__scheme));
    var $x_1 = new $c_s_util_Success(r1);
  } catch (e) {
    var $x_1;
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      var $x_1 = new $c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2));
    }
  }
  var this$2 = $n($n($x_1).toOption__s_Option());
  return $uZ((this$2.isEmpty__Z() ? false : this$2.get__O()));
});
$c_Llaika_internal_markdown_InlineParsers$.prototype.laika$internal$markdown$InlineParsers$$$_$isEmail$1__T__Z = (function(s) {
  var this$1 = $n(s);
  if (($uI(this$1.indexOf("@")) !== (-1))) {
    return this.laika$internal$markdown$InlineParsers$$$_$isURI$1__T__Z(("mailto:" + s));
  } else {
    return false;
  }
});
$c_Llaika_internal_markdown_InlineParsers$.prototype.laika$internal$markdown$InlineParsers$$$_$toLink$1__T__Llaika_ast_SpanLink = (function(url) {
  var this$1 = $n($m_Llaika_ast_SpanLink$().external__T__Llaika_ast_SpanLink$Companion(url));
  var texts = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([]));
  return $as_Llaika_ast_SpanLink($f_Llaika_ast_SpanContainerCompanion__apply__T__sci_Seq__O(this$1, url, texts));
});
var $d_Llaika_internal_markdown_InlineParsers$ = new $TypeData().initClass($c_Llaika_internal_markdown_InlineParsers$, "laika.internal.markdown.InlineParsers$", ({
  Llaika_internal_markdown_InlineParsers$: 1
}));
var $n_Llaika_internal_markdown_InlineParsers$;
function $m_Llaika_internal_markdown_InlineParsers$() {
  if ((!$n_Llaika_internal_markdown_InlineParsers$)) {
    $n_Llaika_internal_markdown_InlineParsers$ = new $c_Llaika_internal_markdown_InlineParsers$();
  }
  return $n_Llaika_internal_markdown_InlineParsers$;
}
function $is_Llaika_internal_markdown_InlineParsers$ResourceTarget(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_internal_markdown_InlineParsers$ResourceTarget)));
}
function $as_Llaika_internal_markdown_InlineParsers$ResourceTarget(obj) {
  return (($is_Llaika_internal_markdown_InlineParsers$ResourceTarget(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.markdown.InlineParsers$ResourceTarget"));
}
function $isArrayOf_Llaika_internal_markdown_InlineParsers$ResourceTarget(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_markdown_InlineParsers$ResourceTarget)));
}
function $asArrayOf_Llaika_internal_markdown_InlineParsers$ResourceTarget(obj, depth) {
  return (($isArrayOf_Llaika_internal_markdown_InlineParsers$ResourceTarget(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.markdown.InlineParsers$ResourceTarget;", depth));
}
function $p_Llaika_internal_markdown_ListParsers$__list__Llaika_parse_Parser__Llaika_parse_Parser__F1__F2__Llaika_parse_markup_RecursiveParsers__Llaika_parse_Parser($thiz, itemStartChar, itemStartRest, newList, newItem, recParsers) {
  var rule = $n($n($m_Llaika_internal_markdown_BlockParsers$().Llaika_internal_markdown_BlockParsers$__f_rules).createParser__Llaika_parse_markup_RecursiveParsers__Llaika_api_bundle_BlockParserDefinition(recParsers)).Llaika_api_bundle_BlockParserDefinition__f_parser;
  var itemStart = $n(itemStartChar).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(itemStartRest);
  var this$6 = $n(recParsers);
  var $x_3 = $m_Llaika_internal_markdown_BlockParsers$();
  var this$1 = $m_Llaika_parse_builders$();
  var $x_2 = $n($f_Llaika_parse_combinator_Parsers__not__Llaika_parse_Parser__Llaika_parse_Parser(this$1, rule)).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser(itemStart);
  var this$4 = $m_Llaika_parse_builders$();
  var this$3 = $n($m_Llaika_parse_builders$().Llaika_parse_builders$__f_blankLine);
  var p = new $c_sjsr_AnonFunction0((() => itemStart));
  var p$1 = this$3.orElse__F0__Llaika_parse_Parser(p);
  var $x_1 = $f_Llaika_parse_combinator_Parsers__not__Llaika_parse_Parser__Llaika_parse_Parser(this$4, p$1);
  var this$5 = $m_Llaika_parse_combinator_Parsers$();
  var p$2 = $m_Llaika_internal_markdown_BlockParsers$().Llaika_internal_markdown_BlockParsers$__f_tabOrSpace;
  var p$3 = $n($x_3).mdBlock__Llaika_parse_Parser__Llaika_parse_Parser__Llaika_parse_Parser__Llaika_parse_Parser($x_2, $n($x_1).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$5, p$2)), $m_Llaika_internal_markdown_BlockParsers$().Llaika_internal_markdown_BlockParsers$__f_tabOrSpace);
  var listItem = $f_Llaika_internal_parse_markup_DefaultRecursiveParsers__recursiveBlocks__Llaika_parse_Parser__Llaika_parse_Parser(this$6, p$3);
  var this$7 = $m_Llaika_parse_combinator_Parsers$();
  var p$4 = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_blankLines;
  var this$9 = $n($n($n($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$7, p$4)).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$3) => {
    var _$3$1 = $as_s_Option(_$3);
    var this$8 = $n(_$3$1);
    return (!this$8.isEmpty__Z());
  })))).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(listItem));
  return $n($n(listItem).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(new $c_Llaika_parse_combinator_Repeat(this$9, 0, 2147483647, $m_s_None$()))).$up$up__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Llaika_parse_builders$$tilde(x$1);
    if ((x$1$1 !== null)) {
      var firstItem = $as_sci_Seq($n(x$1$1).Llaika_parse_builders$$tilde__f__1);
      var items = $as_sci_List($n(x$1$1).Llaika_parse_builders$$tilde__f__2);
      return $as_Llaika_ast_Block($n(newList).apply__O__O($p_Llaika_internal_markdown_ListParsers$__flattenItems$1__F2__sci_Seq__sci_List__sci_List($thiz, newItem, firstItem, items)));
    }
    throw new $c_s_MatchError(x$1$1);
  })));
}
function $p_Llaika_internal_markdown_ListParsers$__rewriteItemContent$1__Z__F2__sci_Seq__I__Llaika_ast_ListItem($thiz, hasBlankLines$1, newItem$1, blocks, pos) {
  matchResult1: {
    var rewritten;
    if ((blocks instanceof $c_sci_$colon$colon)) {
      var x16 = $as_sci_$colon$colon(blocks);
      var x17 = $as_Llaika_ast_Block($n(x16).sci_$colon$colon__f_head);
      var x18 = $n(x16).sci_$colon$colon__f_next;
      if ((x17 instanceof $c_Llaika_ast_Paragraph)) {
        var x$1 = $as_Llaika_ast_Paragraph(x17);
        var this$2 = $n(x$1);
        var x21 = this$2.Llaika_ast_Paragraph__f_content;
        var this$3 = $n(x$1);
        var x22 = this$3.Llaika_ast_Paragraph__f_options;
        var x = $m_sci_Nil$();
        if ((x.equals__O__Z(x18) && hasBlankLines$1)) {
          var elem$1 = new $c_Llaika_ast_ForcedParagraph(x21, x22);
          var this$5 = $m_sci_Nil$();
          var rewritten = new $c_sci_$colon$colon(elem$1, this$5);
          break matchResult1;
        }
      }
      if ((x17 instanceof $c_Llaika_ast_BlockSequence)) {
        var x$1$1 = $as_Llaika_ast_BlockSequence(x17);
        var this$7 = $n(x$1$1);
        var x7 = this$7.Llaika_ast_BlockSequence__f_content;
        var this$8 = $n(x$1$1);
        if ((x7 instanceof $c_sci_$colon$colon)) {
          var x9 = $as_sci_$colon$colon(x7);
          var x10 = $as_Llaika_ast_Block($n(x9).sci_$colon$colon__f_head);
          var x11 = $n(x9).sci_$colon$colon__f_next;
          if ((x10 instanceof $c_Llaika_ast_Paragraph)) {
            var x12 = $as_Llaika_ast_Paragraph(x10);
            var this$10 = $n(x12);
            var x14 = this$10.Llaika_ast_Paragraph__f_content;
            var this$11 = $n(x12);
            var x15 = this$11.Llaika_ast_Paragraph__f_options;
            if ((!hasBlankLines$1)) {
              var elem$2 = new $c_Llaika_ast_SpanSequence(x14, x15);
              var this$13 = $n($n(x18).$colon$colon$colon__sci_List__sci_List(x11));
              var rewritten = new $c_sci_$colon$colon(elem$2, this$13);
              break matchResult1;
            } else {
              var this$14 = $n($n(x18).$colon$colon$colon__sci_List__sci_List(x11));
              var rewritten = new $c_sci_$colon$colon(x12, this$14);
              break matchResult1;
            }
          }
        }
      }
    }
    var rewritten = blocks;
  }
  return $as_Llaika_ast_ListItem($n(newItem$1).apply__O__O__O(pos, rewritten));
}
function $p_Llaika_internal_markdown_ListParsers$__flattenItems$1__F2__sci_Seq__sci_List__sci_List($thiz, newItem$2, firstItem, items) {
  var this$1 = $n(items);
  _return: {
    var these = this$1;
    while ((!$n(these).isEmpty__Z())) {
      var arg1 = $n(these).head__O();
      var _$1 = $as_Llaika_parse_builders$$tilde(arg1);
      if ($uZ($n(_$1).Llaika_parse_builders$$tilde__f__1)) {
        var hasBlankLines = true;
        break _return;
      }
      these = $as_sci_List($n(these).tail__O());
    }
    var hasBlankLines = false;
  }
  var this$3 = $n(items);
  var f = ((_$2) => {
    var _$2$1 = $as_Llaika_parse_builders$$tilde(_$2);
    return $as_sci_Seq($n(_$2$1).Llaika_parse_builders$$tilde__f__2);
  });
  if ((this$3 === $m_sci_Nil$())) {
    var $x_1 = $m_sci_Nil$();
  } else {
    var arg1$1 = this$3.head__O();
    var h = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$3.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$2 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O());
    }
    var $x_1 = h;
  }
  var this$4 = $n($x_1);
  var blockItems = this$4.prepended__O__sci_List(firstItem);
  var pos = new $c_sc_Iterator$$anon$24(1, 1);
  var this$6 = $n(blockItems);
  var f$1 = ((item) => {
    var item$1 = $as_sci_Seq(item);
    return $p_Llaika_internal_markdown_ListParsers$__rewriteItemContent$1__Z__F2__sci_Seq__I__Llaika_ast_ListItem($thiz, hasBlankLines, newItem$2, item$1, pos.next__I());
  });
  if ((this$6 === $m_sci_Nil$())) {
    return $m_sci_Nil$();
  } else {
    var arg1$3 = this$6.head__O();
    var h$1 = new $c_sci_$colon$colon(f$1(arg1$3), $m_sci_Nil$());
    var t$1 = h$1;
    var rest$1 = $as_sci_List(this$6.tail__O());
    while ((rest$1 !== $m_sci_Nil$())) {
      var arg1$4 = $n(rest$1).head__O();
      var nx$1 = new $c_sci_$colon$colon(f$1(arg1$4), $m_sci_Nil$());
      $n(t$1).sci_$colon$colon__f_next = nx$1;
      t$1 = nx$1;
      rest$1 = $as_sci_List($n(rest$1).tail__O());
    }
    return h$1;
  }
}
/** @constructor */
function $c_Llaika_internal_markdown_ListParsers$() {
  this.Llaika_internal_markdown_ListParsers$__f_bulletChar = null;
  this.Llaika_internal_markdown_ListParsers$__f_enumChar = null;
  this.Llaika_internal_markdown_ListParsers$__f_wsAfterItemStart = null;
  this.Llaika_internal_markdown_ListParsers$__f_enumStartRest = null;
  this.Llaika_internal_markdown_ListParsers$__f_bulletLists = null;
  this.Llaika_internal_markdown_ListParsers$__f_enumLists = null;
  $n_Llaika_internal_markdown_ListParsers$ = this;
  var this$1 = $m_Llaika_parse_builders$();
  var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([45, 43])));
  this.Llaika_internal_markdown_ListParsers$__f_bulletChar = $as_Llaika_parse_Parser($f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser(this$1, 42, chars));
  var this$2 = $m_Llaika_parse_builders$();
  var chars$1 = $m_Llaika_parse_text_CharGroup$().Llaika_parse_text_CharGroup$__f_digit;
  this.Llaika_internal_markdown_ListParsers$__f_enumChar = $as_Llaika_parse_Parser($f_Llaika_parse_text_TextParsers__oneOf__O__Llaika_parse_text_PrefixedParser(this$2, chars$1));
  var this$3 = $m_Llaika_parse_builders$();
  var chars$2 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([9])));
  this.Llaika_internal_markdown_ListParsers$__f_wsAfterItemStart = $n($f_Llaika_parse_text_TextParsers__someOf__C__sci_Seq__Llaika_parse_text_PrefixCharacters(this$3, 32, chars$2)).void__Llaika_parse_text_PrefixCharacters();
  var this$4 = $m_Llaika_parse_builders$();
  var chars$3 = $m_Llaika_parse_text_CharGroup$().Llaika_parse_text_CharGroup$__f_digit;
  this.Llaika_internal_markdown_ListParsers$__f_enumStartRest = $n($n($n($f_Llaika_parse_text_TextParsers__anyOf__O__Llaika_parse_text_Characters(this$4, chars$3)).$tilde__T__Llaika_parse_Parser(".")).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(this.Llaika_internal_markdown_ListParsers$__f_wsAfterItemStart)).as__F0__Llaika_parse_Parser(new $c_sjsr_AnonFunction0((() => "")));
  var factory = new $c_sjsr_AnonFunction1(((recParsers) => {
    var recParsers$1 = $as_Llaika_parse_markup_RecursiveParsers(recParsers);
    var this$12 = $m_Llaika_parse_text_PrefixedParser$();
    var chars$4 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([42, 45])));
    var this$6 = $m_Llaika_parse_builders$();
    var p = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_oneChar;
    var p$1 = $n($f_Llaika_parse_combinator_Parsers__lookAhead__Llaika_parse_Parser__Llaika_parse_Parser(this$6, p)).$greater$greater__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((char) => {
      var char$1 = $as_T(char);
      var bullet = new $c_Llaika_ast_BulletFormat$StringBullet(char$1);
      return $p_Llaika_internal_markdown_ListParsers$__list__Llaika_parse_Parser__Llaika_parse_Parser__F1__F2__Llaika_parse_markup_RecursiveParsers__Llaika_parse_Parser(this, this.Llaika_internal_markdown_ListParsers$__f_bulletChar, this.Llaika_internal_markdown_ListParsers$__f_wsAfterItemStart, new $c_sjsr_AnonFunction1(((_$4) => {
        var _$4$1 = $as_sci_List(_$4);
        var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
        return new $c_Llaika_ast_BulletList(_$4$1, bullet, options);
      })), new $c_sjsr_AnonFunction2(((_$5, blocks) => {
        $uI(_$5);
        var blocks$1 = $as_sci_Seq(blocks);
        var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
        return new $c_Llaika_ast_BulletListItem(blocks$1, bullet, options$1);
      })), recParsers$1);
    })));
    return new $c_Llaika_parse_text_PrefixedParser$$anon$2(43, chars$4, p$1, this$12);
  }));
  this.Llaika_internal_markdown_ListParsers$__f_bulletLists = new $c_Llaika_api_bundle_BlockParserBuilder(factory, true, $m_Llaika_api_bundle_BlockPosition$Any$(), $m_Llaika_api_bundle_Precedence$High$(), $m_s_None$()).withLowPrecedence__Llaika_api_bundle_BlockParserBuilder();
  var factory$1 = new $c_sjsr_AnonFunction1(((recParsers$2) => {
    var recParsers$3 = $as_Llaika_parse_markup_RecursiveParsers(recParsers$2);
    var this$25 = $m_Llaika_parse_text_PrefixedParser$();
    var sc = $m_Llaika_parse_text_CharGroup$().Llaika_parse_text_CharGroup$__f_digit;
    var p$2 = $p_Llaika_internal_markdown_ListParsers$__list__Llaika_parse_Parser__Llaika_parse_Parser__F1__F2__Llaika_parse_markup_RecursiveParsers__Llaika_parse_Parser(this, this.Llaika_internal_markdown_ListParsers$__f_enumChar, this.Llaika_internal_markdown_ListParsers$__f_enumStartRest, new $c_sjsr_AnonFunction1(((_$6) => {
      var _$6$1 = $as_sci_List(_$6);
      var enumType = $m_Llaika_ast_EnumType$Arabic$();
      var format = new $c_Llaika_ast_EnumFormat(enumType, "", ".");
      var options$2 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      return new $c_Llaika_ast_EnumList(_$6$1, format, 1, options$2);
    })), new $c_sjsr_AnonFunction2(((pos, blocks$2) => {
      var pos$1 = $uI(pos);
      var blocks$3 = $as_sci_Seq(blocks$2);
      var enumType$1 = $m_Llaika_ast_EnumType$Arabic$();
      var format$1 = new $c_Llaika_ast_EnumFormat(enumType$1, "", ".");
      var options$3 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      return new $c_Llaika_ast_EnumListItem(blocks$3, format$1, pos$1, options$3);
    })), recParsers$3);
    return new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p$2, this$25);
  }));
  this.Llaika_internal_markdown_ListParsers$__f_enumLists = new $c_Llaika_api_bundle_BlockParserBuilder(factory$1, true, $m_Llaika_api_bundle_BlockPosition$Any$(), $m_Llaika_api_bundle_Precedence$High$(), $m_s_None$());
}
$c_Llaika_internal_markdown_ListParsers$.prototype = new $h_O();
$c_Llaika_internal_markdown_ListParsers$.prototype.constructor = $c_Llaika_internal_markdown_ListParsers$;
/** @constructor */
function $h_Llaika_internal_markdown_ListParsers$() {
}
$h_Llaika_internal_markdown_ListParsers$.prototype = $c_Llaika_internal_markdown_ListParsers$.prototype;
var $d_Llaika_internal_markdown_ListParsers$ = new $TypeData().initClass($c_Llaika_internal_markdown_ListParsers$, "laika.internal.markdown.ListParsers$", ({
  Llaika_internal_markdown_ListParsers$: 1
}));
var $n_Llaika_internal_markdown_ListParsers$;
function $m_Llaika_internal_markdown_ListParsers$() {
  if ((!$n_Llaika_internal_markdown_ListParsers$)) {
    $n_Llaika_internal_markdown_ListParsers$ = new $c_Llaika_internal_markdown_ListParsers$();
  }
  return $n_Llaika_internal_markdown_ListParsers$;
}
function $p_Llaika_internal_markdown_bundle_HTMLRenderer$__prepareAttributeValue__sci_List__T($thiz, spans) {
  var this$1 = $n(spans);
  var acc = "";
  var these = this$1;
  while ((!$n(these).isEmpty__Z())) {
    var arg1 = acc;
    var arg2 = $n(these).head__O();
    var x$1 = $as_T(arg1);
    var x$2 = $as_Llaika_ast_TextContainer(arg2);
    if ((x$2 instanceof $c_Llaika_ast_html_HTMLCharacterReference)) {
      var span = $as_Llaika_ast_html_HTMLCharacterReference(x$2);
      acc = (("" + x$1) + $n(span).Llaika_ast_html_HTMLCharacterReference__f_content);
    } else {
      var this$3 = $n(x$2);
      var this$4 = $n(this$3.content__T());
      var this$5 = $n($as_T(this$4.split("&").join("&amp;")));
      var this$6 = $n($as_T(this$5.split("\"").join("&quot;")));
      acc = (("" + x$1) + $as_T(this$6.split("'").join("$#39;")));
    }
    these = $as_sc_LinearSeq($n(these).tail__O());
  }
  return $as_T(acc);
}
/** @constructor */
function $c_Llaika_internal_markdown_bundle_HTMLRenderer$() {
  this.Llaika_internal_markdown_bundle_HTMLRenderer$__f_custom = null;
  $n_Llaika_internal_markdown_bundle_HTMLRenderer$ = this;
  this.Llaika_internal_markdown_bundle_HTMLRenderer$__f_custom = new $c_Llaika_internal_markdown_bundle_HTMLRenderer$$anon$1();
}
$c_Llaika_internal_markdown_bundle_HTMLRenderer$.prototype = new $h_O();
$c_Llaika_internal_markdown_bundle_HTMLRenderer$.prototype.constructor = $c_Llaika_internal_markdown_bundle_HTMLRenderer$;
/** @constructor */
function $h_Llaika_internal_markdown_bundle_HTMLRenderer$() {
}
$h_Llaika_internal_markdown_bundle_HTMLRenderer$.prototype = $c_Llaika_internal_markdown_bundle_HTMLRenderer$.prototype;
$c_Llaika_internal_markdown_bundle_HTMLRenderer$.prototype.laika$internal$markdown$bundle$HTMLRenderer$$$tagStart__T__sci_List__T = (function(tagName, attributes) {
  var this$6 = $n(attributes);
  var f = ((at) => {
    var at$1 = $as_Llaika_ast_html_HTMLAttribute(at);
    var name = (" " + $n(at$1).Llaika_ast_html_HTMLAttribute__f_name);
    matchResult2: {
      var value$3;
      if ((at$1 !== null)) {
        var this$3 = $n(at$1);
        var this$4 = $n(at$1);
        var x18 = this$4.Llaika_ast_html_HTMLAttribute__f_value;
        var this$5 = $n(at$1);
        var x19 = this$5.Llaika_ast_html_HTMLAttribute__f_quotedWith;
        if ((x19 instanceof $c_s_Some)) {
          var char = $uC($n($as_s_Some(x19)).s_Some__f_value);
          var value$3 = ((("=" + $cToS(char)) + $p_Llaika_internal_markdown_bundle_HTMLRenderer$__prepareAttributeValue__sci_List__T(this, x18)) + $cToS(char));
          break matchResult2;
        }
        var x = $m_sci_Nil$();
        if (x.equals__O__Z(x18)) {
          var x$3 = $m_s_None$();
          var $x_1 = (x$3 === x19);
        } else {
          var $x_1 = false;
        }
        if ($x_1) {
          var value$3 = "";
          break matchResult2;
        }
        var x$5 = $m_s_None$();
        if ((x$5 === x19)) {
          var value$3 = ("=" + $p_Llaika_internal_markdown_bundle_HTMLRenderer$__prepareAttributeValue__sci_List__T(this, x18));
          break matchResult2;
        }
      }
      throw new $c_s_MatchError(at$1);
    }
    return (name + value$3);
  });
  if ((this$6 === $m_sci_Nil$())) {
    var $x_2 = $m_sci_Nil$();
  } else {
    var arg1 = this$6.head__O();
    var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$6.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O());
    }
    var $x_2 = h;
  }
  var this$7 = $n($x_2);
  var renderedAttrs = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$7, "", "", "");
  return (("<" + tagName) + renderedAttrs);
});
var $d_Llaika_internal_markdown_bundle_HTMLRenderer$ = new $TypeData().initClass($c_Llaika_internal_markdown_bundle_HTMLRenderer$, "laika.internal.markdown.bundle.HTMLRenderer$", ({
  Llaika_internal_markdown_bundle_HTMLRenderer$: 1
}));
var $n_Llaika_internal_markdown_bundle_HTMLRenderer$;
function $m_Llaika_internal_markdown_bundle_HTMLRenderer$() {
  if ((!$n_Llaika_internal_markdown_bundle_HTMLRenderer$)) {
    $n_Llaika_internal_markdown_bundle_HTMLRenderer$ = new $c_Llaika_internal_markdown_bundle_HTMLRenderer$();
  }
  return $n_Llaika_internal_markdown_bundle_HTMLRenderer$;
}
/** @constructor */
function $c_Llaika_internal_markdown_github_AutoLinks$() {
  this.Llaika_internal_markdown_github_AutoLinks$__f_startChars = null;
  this.Llaika_internal_markdown_github_AutoLinks$__f_parsers = null;
  $n_Llaika_internal_markdown_github_AutoLinks$ = this;
  this.Llaika_internal_markdown_github_AutoLinks$__f_startChars = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet).of__O__sci_Seq__Lcats_kernel_Order__O($bC(42), $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([95, 126, 40, 32, 10]))), $m_Lcats_kernel_instances_char_package$().Lcats_kernel_instances_char_package$__f_catsKernelStdOrderForChar);
  var endChars = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet).of__O__sci_Seq__Lcats_kernel_Order__O($bC(42), $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([95, 126, 41, 63, 33, 46, 44, 58, 32, 10]))), $m_Lcats_kernel_instances_char_package$().Lcats_kernel_instances_char_package$__f_catsKernelStdOrderForChar);
  var this$6 = $m_Llaika_parse_builders$();
  var this$5 = $n($m_Llaika_parse_builders$().Llaika_parse_builders$__f_eof);
  var p = new $c_sjsr_AnonFunction0((() => {
    var this$4 = $m_Llaika_parse_builders$();
    var chars = this.Llaika_internal_markdown_github_AutoLinks$__f_startChars;
    return $as_Llaika_parse_Parser($f_Llaika_parse_text_TextParsers__oneOf__O__Llaika_parse_text_PrefixedParser(this$4, chars));
  }));
  var p$1 = this$5.orElse__F0__Llaika_parse_Parser(p);
  var reverseMarkupStart = $f_Llaika_parse_combinator_Parsers__lookAhead__Llaika_parse_Parser__Llaika_parse_Parser(this$6, p$1);
  var this$7 = $m_Llaika_parse_builders$();
  var afterMarkupEnd = $as_Llaika_parse_Parser($f_Llaika_parse_text_TextParsers__oneOf__O__Llaika_parse_text_PrefixedParser(this$7, endChars));
  var value = this.Llaika_internal_markdown_github_AutoLinks$__f_startChars;
  var this$9 = new $c_Lcats_data_NonEmptySetOps(value);
  var s = this$9.Lcats_data_NonEmptySetOps__f_value;
  var $x_1 = $as_sci_SortedSet(s);
  var this$12 = new $c_Lcats_data_NonEmptySetOps(endChars);
  var s$1 = this$12.Lcats_data_NonEmptySetOps__f_value;
  this.Llaika_internal_markdown_github_AutoLinks$__f_parsers = new $c_Llaika_internal_parse_uri_AutoLinkParsers(reverseMarkupStart, afterMarkupEnd, $x_1, $as_sci_SortedSet(s$1));
}
$c_Llaika_internal_markdown_github_AutoLinks$.prototype = new $h_O();
$c_Llaika_internal_markdown_github_AutoLinks$.prototype.constructor = $c_Llaika_internal_markdown_github_AutoLinks$;
/** @constructor */
function $h_Llaika_internal_markdown_github_AutoLinks$() {
}
$h_Llaika_internal_markdown_github_AutoLinks$.prototype = $c_Llaika_internal_markdown_github_AutoLinks$.prototype;
var $d_Llaika_internal_markdown_github_AutoLinks$ = new $TypeData().initClass($c_Llaika_internal_markdown_github_AutoLinks$, "laika.internal.markdown.github.AutoLinks$", ({
  Llaika_internal_markdown_github_AutoLinks$: 1
}));
var $n_Llaika_internal_markdown_github_AutoLinks$;
function $m_Llaika_internal_markdown_github_AutoLinks$() {
  if ((!$n_Llaika_internal_markdown_github_AutoLinks$)) {
    $n_Llaika_internal_markdown_github_AutoLinks$ = new $c_Llaika_internal_markdown_github_AutoLinks$();
  }
  return $n_Llaika_internal_markdown_github_AutoLinks$;
}
function $p_Llaika_internal_markdown_github_FencedCodeBlocks$__reverse__I__F0__Llaika_parse_Parser($thiz, offset, p) {
  var this$12 = $m_Llaika_parse_Parser$();
  var f = new $c_sjsr_AnonFunction1(((in$1) => {
    var in$2 = $as_Llaika_parse_SourceCursor(in$1);
    matchResult1: {
      var $x_1;
      var x1 = $n($as_Llaika_parse_Parser($n(p).apply__O())).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed($n($n(in$2).reverse__Llaika_parse_SourceCursor()).consume__I__Llaika_parse_SourceCursor(offset));
      if ((x1 instanceof $c_Llaika_parse_Success)) {
        var x$1 = $as_Llaika_parse_Success(x1);
        var this$3 = $n(x$1);
        var x9 = $as_T(this$3.Llaika_parse_Success__f_result);
        var this$4 = $n(x$1);
        var result = $m_sc_StringOps$().reverse$extension__T__T(x9);
        var $x_1 = new $c_Llaika_parse_Success(result, in$2);
        break matchResult1;
      }
      if ((x1 instanceof $c_Llaika_parse_Failure)) {
        var x$1$1 = $as_Llaika_parse_Failure(x1);
        var this$8 = $n(x$1$1);
        var x4 = this$8.Llaika_parse_Failure__f_msgProvider;
        var this$9 = $n(x$1$1);
        var this$10 = $n(x$1$1);
        var maxOffset = $n(in$2).offset__I();
        var $x_1 = new $c_Llaika_parse_Failure(x4, in$2, maxOffset);
        break matchResult1;
      }
      throw new $c_s_MatchError(x1);
    }
    return $as_Llaika_parse_Parsed($x_1);
  }));
  return new $c_Llaika_parse_Parser$$anon$2(f, this$12);
}
function $p_Llaika_internal_markdown_github_FencedCodeBlocks$__codeBlock__C__Llaika_api_bundle_BlockParserBuilder($thiz, fenceChar) {
  var factory = new $c_sjsr_AnonFunction1(((recParsers) => {
    var recParsers$1 = $as_Llaika_parse_markup_RecursiveParsers(recParsers);
    var infoString = $n($m_Llaika_parse_builders$().Llaika_parse_builders$__f_restOfLine).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$1) => {
      var _$1$1 = $as_T(_$1);
      var this$3 = new $c_s_Some(_$1$1);
      if (this$3.isEmpty__Z()) {
        var $x_1 = true;
      } else {
        var arg1 = this$3.s_Some__f_value;
        var _$2 = $as_T(arg1);
        var this$6 = $n(_$2);
        var $x_1 = (!(this$6 === ""));
      }
      var this$7 = $n(($x_1 ? this$3 : $m_s_None$()));
      if (this$7.isEmpty__Z()) {
        return $m_s_None$();
      } else {
        var arg1$1 = this$7.get__O();
        var _$3 = $as_T(arg1$1);
        var this$8 = $n($f_T__trim__T($n(_$3)));
        var xs = $f_T__split__T__I__AT(this$8, " ", 0);
        return $m_sc_ArrayOps$().headOption$extension__O__s_Option(xs);
      }
    })));
    var this$10 = $m_Llaika_parse_builders$();
    var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
    var this$13 = $n($n($n($f_Llaika_parse_text_TextParsers__someOf__C__sci_Seq__Llaika_parse_text_PrefixCharacters(this$10, fenceChar, chars)).min__I__Llaika_parse_text_PrefixCharacters(3)).count__Llaika_parse_text_PrefixCharacters());
    var fq = new $c_sjsr_AnonFunction1(((fence) => {
      var fence$1 = $uI(fence);
      var p = $n($p_Llaika_internal_markdown_github_FencedCodeBlocks$__indent$1__I__Llaika_parse_Parser($thiz, fence$1)).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(infoString);
      return $m_Llaika_parse_syntax$Map2Ops$().mapN$extension__Llaika_parse_Parser__F2__Llaika_parse_Parser(p, new $c_sjsr_AnonFunction2(((_$5, _$6) => {
        var _$5$1 = $uI(_$5);
        var _$6$1 = $as_s_Option(_$6);
        return new $c_T3(fence$1, _$5$1, _$6$1);
      })));
    }));
    var openingFence = $f_Llaika_parse_text_PrefixedParser__$greater$greater__F1__Llaika_parse_text_PrefixedParser(this$13, fq);
    var this$42 = $n(openingFence);
    var fq$1 = new $c_sjsr_AnonFunction1(((x$1) => {
      var x$1$1 = $as_T3(x$1);
      if ((x$1$1 !== null)) {
        var fenceLength = $uI($n(x$1$1).T3__f__1);
        var indent = $uI($n(x$1$1).T3__f__2);
        var info = $as_s_Option($n(x$1$1).T3__f__3);
        var this$14 = $m_Llaika_parse_builders$();
        var chars$1 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
        var $x_2 = $n($f_Llaika_parse_text_TextParsers__anyOf__C__sci_Seq__Llaika_parse_text_Characters(this$14, 32, chars$1)).max__I__Llaika_parse_text_Characters(3);
        var this$15 = $m_Llaika_parse_builders$();
        var chars$2 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
        var closingFence = $n($n($x_2).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($n($f_Llaika_parse_text_TextParsers__anyOf__C__sci_Seq__Llaika_parse_text_Characters(this$15, fenceChar, chars$2)).min__I__Llaika_parse_text_Characters(fenceLength))).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($m_Llaika_parse_builders$().Llaika_parse_builders$__f_wsEol);
        var this$17 = $m_Llaika_parse_builders$();
        var this$16 = $n(closingFence);
        var p$1 = new $c_sjsr_AnonFunction0((() => $m_Llaika_parse_builders$().Llaika_parse_builders$__f_eof));
        var p$2 = this$16.orElse__F0__Llaika_parse_Parser(p$1);
        var $x_4 = $n($f_Llaika_parse_combinator_Parsers__not__Llaika_parse_Parser__Llaika_parse_Parser(this$17, p$2));
        var this$18 = $m_Llaika_parse_builders$();
        var chars$3 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
        var $x_3 = $n($x_4).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($n($f_Llaika_parse_text_TextParsers__anyOf__C__sci_Seq__Llaika_parse_text_Characters(this$18, 32, chars$3)).max__I__Llaika_parse_text_Characters(indent));
        var p$3 = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_restOfLine;
        var this$20 = $n($n($x_3).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($m_Llaika_parse_syntax$StringParserOps$().line$extension__Llaika_parse_Parser__Llaika_parse_Parser(p$3)));
        var lines = new $c_Llaika_parse_combinator_Repeat(this$20, 0, 2147483647, $m_s_None$());
        var this$22 = $m_Llaika_parse_builders$();
        return $n(lines.$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$22, closingFence))).evalMap__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((lines$2) => {
          var lines$1 = $as_sci_List(lines$2);
          var this$23 = $n(lines$1);
          var this$24 = $n($f_sc_IterableOps__lastOption__s_Option(this$23));
          if ((!this$24.isEmpty__Z())) {
            var arg1$2 = this$24.get__O();
            var _$7 = $as_Llaika_parse_LineSource(arg1$2);
            var this$25 = $n($f_T__trim__T($n($n(_$7).Llaika_parse_LineSource__f_input)));
            var $x_5 = (this$25 === "");
          } else {
            var $x_5 = false;
          }
          if ($x_5) {
            var this$26 = $n(lines$1);
            var trimmedLines = $as_sci_List($f_sc_StrictOptimizedIterableOps__dropRight__I__O(this$26, 1));
          } else {
            var trimmedLines = lines$1;
          }
          var this$27 = $n($n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptyChain).fromSeq__sci_Seq__s_Option(trimmedLines));
          if (this$27.isEmpty__Z()) {
            var codeSource = $m_s_None$();
          } else {
            var arg1$3 = this$27.get__O();
            var codeSource = new $c_s_Some($m_Llaika_parse_BlockSource$().apply__O__Llaika_parse_BlockSource(arg1$3));
          }
          if ((info instanceof $c_s_Some)) {
            var lang = $as_T($n($as_s_Some(info)).s_Some__f_value);
            if ((codeSource instanceof $c_s_Some)) {
              var src = $as_Llaika_parse_BlockSource($n($as_s_Some(codeSource)).s_Some__f_value);
              var this$29 = $n($n(recParsers$1).getSyntaxHighlighter__T__s_Option(lang));
              if (this$29.isEmpty__Z()) {
                var $x_8 = $m_sci_Seq$();
                var $x_7 = $m_sr_ScalaRunTime$();
                var content = $n(src).input__T();
                var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
                var value = $n($x_8).apply__sci_Seq__sc_SeqOps($n($x_7).wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Text.getArrayOf().constr)([new $c_Llaika_ast_Text(content, options)])));
                var $x_6 = new $c_s_util_Right(value);
              } else {
                var arg1$4 = this$29.get__O();
                var highlighter = $as_Llaika_parse_markup_RecursiveSpanParser(arg1$4);
                var $x_6 = $n($n(highlighter).parse__Llaika_parse_SourceFragment__Llaika_parse_Parsed(src)).toEither__s_util_Either();
              }
              var this$33 = $n($as_s_util_Either($x_6));
              if ((this$33 instanceof $c_s_util_Right)) {
                var x2 = $as_s_util_Right(this$33);
                var b = $n(x2).s_util_Right__f_value;
                var _$9 = $as_sci_Seq(b);
                var codeOptions = $m_sci_Nil$();
                var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
                return new $c_s_util_Right(new $c_Llaika_ast_CodeBlock(lang, _$9, codeOptions, options$1));
              } else {
                return this$33;
              }
            }
          }
          var this$37 = $n(trimmedLines);
          var f = ((_$10) => {
            var _$10$1 = $as_Llaika_parse_LineSource(_$10);
            return $n(_$10$1).Llaika_parse_LineSource__f_input;
          });
          if ((this$37 === $m_sci_Nil$())) {
            var $x_9 = $m_sci_Nil$();
          } else {
            var arg1$5 = this$37.head__O();
            var h = new $c_sci_$colon$colon(f(arg1$5), $m_sci_Nil$());
            var t = h;
            var rest = $as_sci_List(this$37.tail__O());
            while ((rest !== $m_sci_Nil$())) {
              var arg1$6 = $n(rest).head__O();
              var nx = new $c_sci_$colon$colon(f(arg1$6), $m_sci_Nil$());
              $n(t).sci_$colon$colon__f_next = nx;
              t = nx;
              rest = $as_sci_List($n(rest).tail__O());
            }
            var $x_9 = h;
          }
          var this$38 = $n($x_9);
          var content$1 = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$38, "", "\n", "");
          var options$2 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
          var value$1 = new $c_Llaika_ast_LiteralBlock(content$1, options$2);
          return new $c_s_util_Right(value$1);
        })));
      }
      throw new $c_s_MatchError(x$1$1);
    }));
    return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$greater$greater__F1__Llaika_parse_text_PrefixedParser(this$42, fq$1));
  }));
  var $x_10 = new $c_Llaika_api_bundle_BlockParserBuilder(factory, true, $m_Llaika_api_bundle_BlockPosition$Any$(), $m_Llaika_api_bundle_Precedence$High$(), $m_s_None$());
  var this$47 = $m_Llaika_parse_builders$();
  var chars$4 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
  return $x_10.interruptsParagraphWith__Llaika_parse_text_PrefixedParser__Llaika_api_bundle_BlockParserBuilder($f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser(this$47, fenceChar, chars$4));
}
function $p_Llaika_internal_markdown_github_FencedCodeBlocks$__indent$1__I__Llaika_parse_Parser($thiz, offset) {
  return $n($p_Llaika_internal_markdown_github_FencedCodeBlocks$__reverse__I__F0__Llaika_parse_Parser($thiz, offset, new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_Llaika_parse_builders$();
    var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
    return $f_Llaika_parse_text_TextParsers__anyOf__C__sci_Seq__Llaika_parse_text_Characters(this$2, 32, chars);
  })))).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$4) => {
    var _$4$1 = $as_T(_$4);
    var this$3 = $n(_$4$1);
    return this$3.length;
  })));
}
/** @constructor */
function $c_Llaika_internal_markdown_github_FencedCodeBlocks$() {
  this.Llaika_internal_markdown_github_FencedCodeBlocks$__f_parsers = null;
  $n_Llaika_internal_markdown_github_FencedCodeBlocks$ = this;
  this.Llaika_internal_markdown_github_FencedCodeBlocks$__f_parsers = $as_sci_Seq($n($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([126, 96]))))).map__F1__O(new $c_sjsr_AnonFunction1(((fenceChar) => {
    var fenceChar$1 = $uC(fenceChar);
    return $p_Llaika_internal_markdown_github_FencedCodeBlocks$__codeBlock__C__Llaika_api_bundle_BlockParserBuilder(this, fenceChar$1);
  }))));
}
$c_Llaika_internal_markdown_github_FencedCodeBlocks$.prototype = new $h_O();
$c_Llaika_internal_markdown_github_FencedCodeBlocks$.prototype.constructor = $c_Llaika_internal_markdown_github_FencedCodeBlocks$;
/** @constructor */
function $h_Llaika_internal_markdown_github_FencedCodeBlocks$() {
}
$h_Llaika_internal_markdown_github_FencedCodeBlocks$.prototype = $c_Llaika_internal_markdown_github_FencedCodeBlocks$.prototype;
var $d_Llaika_internal_markdown_github_FencedCodeBlocks$ = new $TypeData().initClass($c_Llaika_internal_markdown_github_FencedCodeBlocks$, "laika.internal.markdown.github.FencedCodeBlocks$", ({
  Llaika_internal_markdown_github_FencedCodeBlocks$: 1
}));
var $n_Llaika_internal_markdown_github_FencedCodeBlocks$;
function $m_Llaika_internal_markdown_github_FencedCodeBlocks$() {
  if ((!$n_Llaika_internal_markdown_github_FencedCodeBlocks$)) {
    $n_Llaika_internal_markdown_github_FencedCodeBlocks$ = new $c_Llaika_internal_markdown_github_FencedCodeBlocks$();
  }
  return $n_Llaika_internal_markdown_github_FencedCodeBlocks$;
}
/** @constructor */
function $c_Llaika_internal_markdown_github_Strikethrough$() {
  this.Llaika_internal_markdown_github_Strikethrough$__f_parser = null;
  $n_Llaika_internal_markdown_github_Strikethrough$ = this;
  var factory = new $c_sjsr_AnonFunction1(((recParsers) => {
    var recParsers$1 = $as_Llaika_parse_markup_RecursiveSpanParsers(recParsers);
    var this$4 = $n($m_Llaika_internal_markdown_InlineParsers$().enclosedByDoubleChar__C__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_text_PrefixedParser(126, recParsers$1));
    var f = new $c_sjsr_AnonFunction1(((_$1) => {
      var _$1$1 = $as_sci_List(_$1);
      var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      return new $c_Llaika_ast_Deleted(_$1$1, options);
    }));
    return $f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser(this$4, f);
  }));
  this.Llaika_internal_markdown_github_Strikethrough$__f_parser = new $c_Llaika_api_bundle_SpanParserBuilder(factory, true, $m_Llaika_api_bundle_Precedence$High$());
}
$c_Llaika_internal_markdown_github_Strikethrough$.prototype = new $h_O();
$c_Llaika_internal_markdown_github_Strikethrough$.prototype.constructor = $c_Llaika_internal_markdown_github_Strikethrough$;
/** @constructor */
function $h_Llaika_internal_markdown_github_Strikethrough$() {
}
$h_Llaika_internal_markdown_github_Strikethrough$.prototype = $c_Llaika_internal_markdown_github_Strikethrough$.prototype;
var $d_Llaika_internal_markdown_github_Strikethrough$ = new $TypeData().initClass($c_Llaika_internal_markdown_github_Strikethrough$, "laika.internal.markdown.github.Strikethrough$", ({
  Llaika_internal_markdown_github_Strikethrough$: 1
}));
var $n_Llaika_internal_markdown_github_Strikethrough$;
function $m_Llaika_internal_markdown_github_Strikethrough$() {
  if ((!$n_Llaika_internal_markdown_github_Strikethrough$)) {
    $n_Llaika_internal_markdown_github_Strikethrough$ = new $c_Llaika_internal_markdown_github_Strikethrough$();
  }
  return $n_Llaika_internal_markdown_github_Strikethrough$;
}
function $p_Llaika_internal_markdown_github_Tables$__cell$1__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_Parser__Llaika_ast_CellType__Llaika_parse_Parser($thiz, spanParsers$1, textParser, cellType) {
  var this$1 = $n(spanParsers$1);
  return $n($as_Llaika_parse_Parser($f_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers__recursiveSpans__Llaika_parse_Parser__Llaika_parse_markup_InlineParser(this$1, textParser))).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((spans) => {
    var spans$1 = $as_sci_List(spans);
    var $x_2 = $m_sci_Seq$();
    var $x_1 = $m_sr_ScalaRunTime$();
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var content = $as_sci_Seq($n($x_2).apply__sci_Seq__sc_SeqOps($n($x_1).wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Paragraph.getArrayOf().constr)([new $c_Llaika_ast_Paragraph(spans$1, options)]))));
    var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    return new $c_Llaika_ast_Cell(cellType, content, 1, 1, options$1);
  })));
}
function $p_Llaika_internal_markdown_github_Tables$__rowRest$1__Llaika_parse_markup_RecursiveSpanParsers__Llaika_ast_CellType__Llaika_parse_Parser($thiz, spanParsers$2, cellType) {
  var this$1 = $n(spanParsers$2);
  var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([10])));
  var p = $f_Llaika_internal_parse_markup_DefaultEscapedTextParsers__escapedUntil__C__sci_Seq__Llaika_parse_Parser(this$1, 124, chars);
  var cellText = $n($m_Llaika_parse_syntax$StringParserOps$().line$extension__Llaika_parse_Parser__Llaika_parse_Parser(p)).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$1) => {
    var _$1$1 = $as_Llaika_parse_LineSource(_$1);
    return $n(_$1$1).trim__Llaika_parse_LineSource();
  })));
  var p$1 = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_textLine;
  var finalCellText = $n($m_Llaika_parse_syntax$StringParserOps$().line$extension__Llaika_parse_Parser__Llaika_parse_Parser(p$1)).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$2) => {
    var _$2$1 = $as_Llaika_parse_LineSource(_$2);
    return $n(_$2$1).trim__Llaika_parse_LineSource();
  })));
  var $x_1 = $p_Llaika_internal_markdown_github_Tables$__cell$1__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_Parser__Llaika_ast_CellType__Llaika_parse_Parser($thiz, spanParsers$2, cellText, cellType);
  var this$5 = $m_Llaika_parse_builders$();
  var chars$1 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
  var this$6 = $n($n($x_1).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser($f_Llaika_parse_text_TextParsers__prevIn__C__sci_Seq__Llaika_parse_Parser(this$5, 124, chars$1)));
  var delimitedCells = new $c_Llaika_parse_combinator_Repeat(this$6, 0, 2147483647, $m_s_None$());
  var this$9 = $n($n($p_Llaika_internal_markdown_github_Tables$__cell$1__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_Parser__Llaika_ast_CellType__Llaika_parse_Parser($thiz, spanParsers$2, finalCellText, cellType)).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$3) => {
    var _$3$1 = $as_Llaika_ast_Cell(_$3);
    return new $c_s_Some(_$3$1);
  }))));
  var p$2 = new $c_sjsr_AnonFunction0((() => $n($m_Llaika_parse_builders$().Llaika_parse_builders$__f_restOfLine).as__F0__Llaika_parse_Parser(new $c_sjsr_AnonFunction0((() => $m_s_None$())))));
  var optFinalCell = this$9.orElse__F0__Llaika_parse_Parser(p$2);
  var \u03b41$ = delimitedCells.$tilde__Llaika_parse_Parser__Llaika_parse_Parser(optFinalCell);
  return $n(\u03b41$).collect__s_PartialFunction__F1__Llaika_parse_Parser(new $c_Llaika_internal_markdown_github_Tables$$anon$1(), $n(\u03b41$).collect$default$2__F1());
}
function $p_Llaika_internal_markdown_github_Tables$__Header$lzyINIT1$1__sr_LazyRef__Llaika_internal_markdown_github_Tables$Header$3$($thiz, Header$lzy1$1) {
  if ((Header$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Llaika_internal_markdown_github_Tables$Header$3$(($n(Header$lzy1$1).sr_LazyRef__f__initialized ? $n(Header$lzy1$1).sr_LazyRef__f__value : $n(Header$lzy1$1).initialize__O__O(new $c_Llaika_internal_markdown_github_Tables$Header$3$())));
}
function $p_Llaika_internal_markdown_github_Tables$__applyColumnOptions$1__sci_Seq__sci_Seq__sci_Seq($thiz, rows, columnOptions) {
  var this$1 = $n(columnOptions);
  var count = this$1.length__I();
  return $as_sci_Seq($n(rows).map__F1__O(new $c_sjsr_AnonFunction1(((row) => {
    var row$1 = $as_Llaika_ast_Row(row);
    $n(row$1);
    var $x_1 = $as_sc_SeqOps($n($n(row$1).Llaika_ast_Row__f_content).take__I__O(count));
    var this$3 = $m_Llaika_ast_CellType$BodyCell$();
    var blocks = $m_sci_Nil$();
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var content$1 = $as_sci_Seq($n($as_sc_IterableOps($n($as_sc_IterableOps($n($x_1).padTo__I__O__O(count, new $c_Llaika_ast_Cell(this$3, blocks, 1, 1, options)))).zip__sc_IterableOnce__O(columnOptions))).map__F1__O(new $c_sjsr_AnonFunction1(((x$1) => {
      var x$1$1 = $as_T2(x$1);
      if ((x$1$1 !== null)) {
        var cell = $as_Llaika_ast_Cell($n(x$1$1)._1__O());
        var opt = $as_Llaika_ast_Options($n(x$1$1)._2__O());
        var this$6 = $n(cell);
        var cellType = this$6.Llaika_ast_Cell__f_cellType;
        var content = this$6.Llaika_ast_Cell__f_content;
        var colspan = this$6.Llaika_ast_Cell__f_colspan;
        var rowspan = this$6.Llaika_ast_Cell__f_rowspan;
        return new $c_Llaika_ast_Cell(cellType, content, colspan, rowspan, opt);
      }
      throw new $c_s_MatchError(x$1$1);
    }))));
    var this$7 = $n(row$1);
    var options$1 = this$7.Llaika_ast_Row__f_options;
    return new $c_Llaika_ast_Row(content$1, options$1);
  }))));
}
/** @constructor */
function $c_Llaika_internal_markdown_github_Tables$() {
  this.Llaika_internal_markdown_github_Tables$__f_parser = null;
  $n_Llaika_internal_markdown_github_Tables$ = this;
  var factory = new $c_sjsr_AnonFunction1(((spanParsers) => {
    var spanParsers$1 = $as_Llaika_parse_markup_RecursiveSpanParsers(spanParsers);
    var Header$lzy1 = new $c_sr_LazyRef();
    var firstRow = $m_Llaika_parse_syntax$LiteralStringOps$().$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("|", $p_Llaika_internal_markdown_github_Tables$__rowRest$1__Llaika_parse_markup_RecursiveSpanParsers__Llaika_ast_CellType__Llaika_parse_Parser(this, spanParsers$1, $m_Llaika_ast_CellType$HeadCell$()));
    var $x_2 = $m_Llaika_internal_markdown_BlockParsers$().Llaika_internal_markdown_BlockParsers$__f_insignificantSpaces;
    var this$4 = $m_Llaika_parse_builders$();
    var this$3 = $m_Llaika_parse_builders$();
    var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([43, 45, 62, 95, 35, 91, 32, 9])));
    var p = $as_Llaika_parse_Parser($f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser(this$3, 42, chars));
    var $x_1 = $n($n($x_2).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($f_Llaika_parse_combinator_Parsers__not__Llaika_parse_Parser__Llaika_parse_Parser(this$4, p)));
    var this$5 = $m_Llaika_parse_builders$();
    var rowStart = $n($x_1).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($f_Llaika_parse_combinator_Parsers__opt__T__Llaika_parse_Parser(this$5, "|"));
    var bodyRow = $n(rowStart).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($p_Llaika_internal_markdown_github_Tables$__rowRest$1__Llaika_parse_markup_RecursiveSpanParsers__Llaika_ast_CellType__Llaika_parse_Parser(this, spanParsers$1, $m_Llaika_ast_CellType$BodyCell$()));
    var $x_4 = $m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters();
    var this$6 = $m_Llaika_parse_builders$();
    var $x_3 = $n($n($x_4).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($f_Llaika_parse_combinator_Parsers__opt__T__Llaika_parse_Parser(this$6, ":")));
    var this$7 = $m_Llaika_parse_builders$();
    var chars$1 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
    var this$9 = $n($n($f_Llaika_parse_text_TextParsers__someOf__C__sci_Seq__Llaika_parse_text_PrefixCharacters(this$7, 45, chars$1)).void__Llaika_parse_text_PrefixCharacters());
    var this$8 = $m_Llaika_parse_builders$();
    var p$1 = $f_Llaika_parse_combinator_Parsers__opt__T__Llaika_parse_Parser(this$8, ":");
    var this$10 = $n($f_Llaika_parse_text_PrefixedParser__$tilde$greater__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$9, p$1));
    var p$2 = $m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters();
    var separator = $n($x_3).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$less$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$10, p$2)));
    var this$11 = $n($n(separator).$less$tilde__T__Llaika_parse_Parser("|"));
    var delimitedSeparators = new $c_Llaika_parse_combinator_Repeat(this$11, 0, 2147483647, $m_s_None$());
    var this$13 = $m_Llaika_parse_builders$();
    var optFinalSep = $f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$13, separator);
    var this$14 = $m_Llaika_parse_builders$();
    var sepRow = $n($n($n($n($f_Llaika_parse_combinator_Parsers__opt__T__Llaika_parse_Parser(this$14, "|")).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser(delimitedSeparators)).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(optFinalSep)).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser($m_Llaika_parse_builders$().Llaika_parse_builders$__f_wsEol)).$up$up__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((x$1) => {
      var x$1$1 = $as_Llaika_parse_builders$$tilde(x$1);
      if ((x$1$1 !== null)) {
        var seps = $as_sci_List($n(x$1$1).Llaika_parse_builders$$tilde__f__1);
        var finalSep = $as_s_Option($n(x$1$1).Llaika_parse_builders$$tilde__f__2);
        var this$16 = $n(seps);
        var suffix = $n($m_s_Option$().option2Iterable__s_Option__sc_Iterable(finalSep)).toSeq__sci_Seq();
        var this$18 = $n(this$16.appendedAll__sc_IterableOnce__sci_List(suffix));
        var f = ((x$1$2) => {
          var x$1$3 = $as_Llaika_parse_builders$$tilde(x$1$2);
          if ((x$1$3 !== null)) {
            var x21 = $as_s_Option($n(x$1$3).Llaika_parse_builders$$tilde__f__1);
            var x22 = $as_s_Option($n(x$1$3).Llaika_parse_builders$$tilde__f__2);
            if ((x21 instanceof $c_s_Some)) {
              if ((x22 instanceof $c_s_Some)) {
                return $m_Llaika_ast_Style$().Llaika_ast_Style$__f_alignCenter;
              }
              var x = $m_s_None$();
              if ((x === x22)) {
                return $m_Llaika_ast_Style$().Llaika_ast_Style$__f_alignLeft;
              }
            }
            var x$3 = $m_s_None$();
            if (((x$3 === x21) && (x22 instanceof $c_s_Some))) {
              return $m_Llaika_ast_Style$().Llaika_ast_Style$__f_alignRight;
            }
          }
          return $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
        });
        if ((this$18 === $m_sci_Nil$())) {
          return $m_sci_Nil$();
        } else {
          var arg1 = this$18.head__O();
          var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
          var t = h;
          var rest = $as_sci_List(this$18.tail__O());
          while ((rest !== $m_sci_Nil$())) {
            var arg1$1 = $n(rest).head__O();
            var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
            $n(t).sci_$colon$colon__f_next = nx;
            t = nx;
            rest = $as_sci_List($n(rest).tail__O());
          }
          return h;
        }
      }
      throw new $c_s_MatchError(x$1$1);
    })));
    var this$19 = $n(firstRow);
    var \u03b42$ = $f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$19, sepRow);
    var this$21 = $n(\u03b42$);
    var f$1 = new $c_Llaika_internal_markdown_github_Tables$$anon$2(Header$lzy1);
    var this$20 = $n(\u03b42$);
    var error = $f_Llaika_parse_text_PrefixedParser__collect$default$2__F1(this$20);
    var header = $f_Llaika_parse_text_PrefixedParser__collect__s_PartialFunction__F1__Llaika_parse_text_PrefixedParser(this$21, f$1, error);
    var this$24 = $n(header);
    var this$22 = $n(bodyRow);
    var p$3 = new $c_Llaika_parse_combinator_Repeat(this$22, 0, 2147483647, $m_s_None$());
    var this$39 = $n($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$24, p$3));
    var f$2 = new $c_sjsr_AnonFunction1(((x$1$2$1) => {
      var x$1$4 = $as_Llaika_parse_builders$$tilde(x$1$2$1);
      if ((x$1$4 !== null)) {
        var headerRow = $as_Llaika_internal_markdown_github_Tables$Header$1($n(x$1$4).Llaika_parse_builders$$tilde__f__1);
        var bodyRows = $as_sci_List($n(x$1$4).Llaika_parse_builders$$tilde__f__2);
        var content = $p_Llaika_internal_markdown_github_Tables$__applyColumnOptions$1__sci_Seq__sci_Seq__sci_Seq(this, $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Row.getArrayOf().constr)([$n(headerRow).Llaika_internal_markdown_github_Tables$Header$1__f_row])))), $n(headerRow).Llaika_internal_markdown_github_Tables$Header$1__f_columnOptions);
        var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
        var head = new $c_Llaika_ast_TableHead(content, options);
        var content$1 = $p_Llaika_internal_markdown_github_Tables$__applyColumnOptions$1__sci_Seq__sci_Seq__sci_Seq(this, bodyRows, $n(headerRow).Llaika_internal_markdown_github_Tables$Header$1__f_columnOptions);
        var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
        var body = new $c_Llaika_ast_TableBody(content$1, options$1);
        var content$2 = $m_sci_Nil$();
        var options$2 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
        var caption = new $c_Llaika_ast_Caption(content$2, options$2);
        var content$3 = $m_sci_Nil$();
        var options$3 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
        var columns = new $c_Llaika_ast_Columns(content$3, options$3);
        var options$4 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
        return new $c_Llaika_ast_Table(head, body, caption, columns, options$4);
      }
      throw new $c_s_MatchError(x$1$4);
    }));
    return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$up$up__F1__Llaika_parse_text_PrefixedParser(this$39, f$2));
  }));
  this.Llaika_internal_markdown_github_Tables$__f_parser = new $c_Llaika_api_bundle_BlockParserBuilder(factory, false, $m_Llaika_api_bundle_BlockPosition$Any$(), $m_Llaika_api_bundle_Precedence$High$(), $m_s_None$());
}
$c_Llaika_internal_markdown_github_Tables$.prototype = new $h_O();
$c_Llaika_internal_markdown_github_Tables$.prototype.constructor = $c_Llaika_internal_markdown_github_Tables$;
/** @constructor */
function $h_Llaika_internal_markdown_github_Tables$() {
}
$h_Llaika_internal_markdown_github_Tables$.prototype = $c_Llaika_internal_markdown_github_Tables$.prototype;
$c_Llaika_internal_markdown_github_Tables$.prototype.laika$internal$markdown$github$Tables$$$_$Header$2__sr_LazyRef__Llaika_internal_markdown_github_Tables$Header$3$ = (function(Header$lzy1$2) {
  return $as_Llaika_internal_markdown_github_Tables$Header$3$(($n(Header$lzy1$2).sr_LazyRef__f__initialized ? $n(Header$lzy1$2).sr_LazyRef__f__value : $p_Llaika_internal_markdown_github_Tables$__Header$lzyINIT1$1__sr_LazyRef__Llaika_internal_markdown_github_Tables$Header$3$(this, Header$lzy1$2)));
});
var $d_Llaika_internal_markdown_github_Tables$ = new $TypeData().initClass($c_Llaika_internal_markdown_github_Tables$, "laika.internal.markdown.github.Tables$", ({
  Llaika_internal_markdown_github_Tables$: 1
}));
var $n_Llaika_internal_markdown_github_Tables$;
function $m_Llaika_internal_markdown_github_Tables$() {
  if ((!$n_Llaika_internal_markdown_github_Tables$)) {
    $n_Llaika_internal_markdown_github_Tables$ = new $c_Llaika_internal_markdown_github_Tables$();
  }
  return $n_Llaika_internal_markdown_github_Tables$;
}
function $p_Llaika_internal_nav_SectionBuilder$DefaultRule__closeSections$1__Llaika_internal_collection_Stack__I__I($thiz, stack$1, toLevel) {
  var nextPos = 1;
  while (($n(stack$1).nonEmpty__Z() && $n($as_Llaika_internal_nav_SectionBuilder$DefaultRule$Builder($n(stack$1).top__O())).$greater$eq__I__Z(toLevel))) {
    var section = $as_Llaika_internal_nav_SectionBuilder$DefaultRule$Builder($n(stack$1).pop__O());
    var this$1 = $n($n(section).Llaika_internal_nav_SectionBuilder$DefaultRule$Builder__f_position);
    nextPos = ((1 + $uI($n(this$1.Llaika_ast_TreePosition__f_positions).last__O())) | 0);
    $n($as_Llaika_internal_nav_SectionBuilder$DefaultRule$Builder($n(stack$1).top__O())).$plus$eq__Llaika_ast_Block__V($n(section).toSection__Llaika_ast_Section());
  }
  return nextPos;
}
/** @constructor */
function $c_Llaika_internal_nav_SectionBuilder$DefaultRule(autonumberConfig, extractTitle, position) {
  this.Llaika_internal_nav_SectionBuilder$DefaultRule__f_laika$internal$nav$SectionBuilder$DefaultRule$$autonumberConfig = null;
  this.Llaika_internal_nav_SectionBuilder$DefaultRule__f_extractTitle = false;
  this.Llaika_internal_nav_SectionBuilder$DefaultRule__f_position = null;
  this.Llaika_internal_nav_SectionBuilder$DefaultRule__f_rewrite = null;
  this.Llaika_internal_nav_SectionBuilder$DefaultRule__f_laika$internal$nav$SectionBuilder$DefaultRule$$autonumberConfig = autonumberConfig;
  this.Llaika_internal_nav_SectionBuilder$DefaultRule__f_extractTitle = extractTitle;
  this.Llaika_internal_nav_SectionBuilder$DefaultRule__f_position = position;
  this.Llaika_internal_nav_SectionBuilder$DefaultRule__f_rewrite = $m_Llaika_ast_RewriteRules$().forBlocks__s_PartialFunction__Llaika_ast_RewriteRules(new $c_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$1(this));
}
$c_Llaika_internal_nav_SectionBuilder$DefaultRule.prototype = new $h_O();
$c_Llaika_internal_nav_SectionBuilder$DefaultRule.prototype.constructor = $c_Llaika_internal_nav_SectionBuilder$DefaultRule;
/** @constructor */
function $h_Llaika_internal_nav_SectionBuilder$DefaultRule() {
}
$h_Llaika_internal_nav_SectionBuilder$DefaultRule.prototype = $c_Llaika_internal_nav_SectionBuilder$DefaultRule.prototype;
$c_Llaika_internal_nav_SectionBuilder$DefaultRule.prototype.addNumber__sci_Seq__Llaika_ast_TreePosition__sci_Seq = (function(spans, position) {
  var this$1 = $n(position);
  var position$1 = this$1.Llaika_ast_TreePosition__f_positions;
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  var elem$1 = new $c_Llaika_ast_SectionNumber(position$1, options);
  var this$4 = $n(spans);
  return $as_sci_Seq(this$4.prepended__O__O(elem$1));
});
$c_Llaika_internal_nav_SectionBuilder$DefaultRule.prototype.buildSections__Llaika_ast_RootElement__Llaika_ast_RootElement = (function(document) {
  var docPosition = ($n(this.Llaika_internal_nav_SectionBuilder$DefaultRule__f_laika$internal$nav$SectionBuilder$DefaultRule$$autonumberConfig).Llaika_config_AutonumberConfig$Impl__f_documents ? this.Llaika_internal_nav_SectionBuilder$DefaultRule__f_position : $m_Llaika_ast_TreePosition$().Llaika_ast_TreePosition$__f_root);
  if ((!this.Llaika_internal_nav_SectionBuilder$DefaultRule__f_extractTitle)) {
    var _1 = $m_sci_Nil$();
    var _2 = $n(document).Llaika_ast_RootElement__f_content;
    var x8___1 = _1;
    var x8___2 = _2;
  } else {
    var title = $n($n(document).Llaika_ast_RootElement__f_content).collectFirst__s_PartialFunction__s_Option(new $c_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$2(docPosition, this));
    var this$2 = $n(title);
    if (this$2.isEmpty__Z()) {
      var _1$1 = $n(document).Llaika_ast_RootElement__f_content;
      var _2$1 = $m_sci_Seq$().empty__sc_SeqOps();
      var x8___1 = _1$1;
      var x8___2 = _2$1;
    } else {
      var arg1 = this$2.get__O();
      var titleBlock = $as_Llaika_ast_Title(arg1);
      matchResult3: {
        var \u03b42$___1;
        var \u03b42$___2;
        var $x_1 = $n($n(document).Llaika_ast_RootElement__f_content);
        var this$5 = $n($n(document).Llaika_ast_RootElement__f_content);
        var p = new $c_sjsr_AnonFunction1(((_$1) => {
          var _$1$1 = $as_Llaika_ast_Block(_$1);
          return (_$1$1 instanceof $c_Llaika_ast_Header);
        }));
        var x5 = $n($x_1).splitAt__I__T2(this$5.indexWhere__F1__I__I(p, 0));
        if ((x5 !== null)) {
          var preface = $as_sci_Seq($n(x5)._1__O());
          var rest = $as_sci_Seq($n(x5)._2__O());
          var \u03b42$___1 = preface;
          var \u03b42$___2 = rest;
          break matchResult3;
        }
        throw new $c_s_MatchError(x5);
      }
      var preface$2 = $as_sci_Seq(\u03b42$___1);
      var rest$2 = $as_sci_Seq(\u03b42$___2);
      var this$7 = $n(preface$2);
      var _1$2 = this$7.appended__O__O(titleBlock);
      var _2$2 = $n(rest$2).tail__O();
      var x8___1 = _1$2;
      var x8___2 = _2$2;
    }
  }
  var titleSection = $as_sci_Seq(x8___1);
  var rest$1 = $as_sci_Seq(x8___2);
  var \u03b41$___1 = titleSection;
  var \u03b41$___2 = rest$1;
  var titleSection$2 = $as_sci_Seq(\u03b41$___1);
  var rest$2$1 = $as_sci_Seq(\u03b41$___2);
  var stack = new $c_Llaika_internal_collection_Stack();
  var content = $m_sci_Nil$();
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  stack.push__O__V(new $c_Llaika_internal_nav_SectionBuilder$DefaultRule$Builder(this, new $c_Llaika_ast_Header(0, content, options), docPosition));
  $n(rest$2$1).foreach__F1__V(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Llaika_ast_Block(x$1);
    if ((x$1$1 instanceof $c_Llaika_ast_Header)) {
      var x12 = $as_Llaika_ast_Header(x$1$1);
      var this$13 = $n(x12);
      var x14 = this$13.Llaika_ast_Header__f_level;
      var this$14 = $n(x12);
      var this$15 = $n(x12);
      var nextPos = $p_Llaika_internal_nav_SectionBuilder$DefaultRule__closeSections$1__Llaika_internal_collection_Stack__I__I(this, stack, x14);
      stack.push__O__V(new $c_Llaika_internal_nav_SectionBuilder$DefaultRule$Builder(this, x12, $n($n($as_Llaika_internal_nav_SectionBuilder$DefaultRule$Builder(stack.top__O())).Llaika_internal_nav_SectionBuilder$DefaultRule$Builder__f_position).forChild__I__Llaika_ast_TreePosition(nextPos)));
    } else {
      $n($as_Llaika_internal_nav_SectionBuilder$DefaultRule$Builder(stack.top__O())).$plus$eq__Llaika_ast_Block__V(x$1$1);
    }
  })));
  $p_Llaika_internal_nav_SectionBuilder$DefaultRule__closeSections$1__Llaika_internal_collection_Stack__I__I(this, stack, 1);
  var sectionStructure = $n($n($as_Llaika_internal_nav_SectionBuilder$DefaultRule$Builder(stack.pop__O())).toSection__Llaika_ast_Section()).Llaika_ast_Section__f_content;
  var this$16 = $n(titleSection$2);
  var content$1 = $as_sci_Seq(this$16.appendedAll__sc_IterableOnce__O(sectionStructure));
  var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  return new $c_Llaika_ast_RootElement(content$1, options$1);
});
var $d_Llaika_internal_nav_SectionBuilder$DefaultRule = new $TypeData().initClass($c_Llaika_internal_nav_SectionBuilder$DefaultRule, "laika.internal.nav.SectionBuilder$DefaultRule", ({
  Llaika_internal_nav_SectionBuilder$DefaultRule: 1
}));
/** @constructor */
function $c_Llaika_internal_nav_SectionBuilder$DefaultRule$Builder(outer, header, position) {
  this.Llaika_internal_nav_SectionBuilder$DefaultRule$Builder__f_header = null;
  this.Llaika_internal_nav_SectionBuilder$DefaultRule$Builder__f_position = null;
  this.Llaika_internal_nav_SectionBuilder$DefaultRule$Builder__f_titleWithNumber = null;
  this.Llaika_internal_nav_SectionBuilder$DefaultRule$Builder__f_styledHeader = null;
  this.Llaika_internal_nav_SectionBuilder$DefaultRule$Builder__f_buffer = null;
  this.Llaika_internal_nav_SectionBuilder$DefaultRule$Builder__f_header = header;
  this.Llaika_internal_nav_SectionBuilder$DefaultRule$Builder__f_position = position;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ($n($n(outer).Llaika_internal_nav_SectionBuilder$DefaultRule__f_laika$internal$nav$SectionBuilder$DefaultRule$$autonumberConfig).Llaika_config_AutonumberConfig$Impl__f_sections) {
    var this$1 = $n(position);
    var this$2 = $n(this$1.Llaika_ast_TreePosition__f_positions);
    var $x_1 = (this$2.length__I() <= $n($n(outer).Llaika_internal_nav_SectionBuilder$DefaultRule__f_laika$internal$nav$SectionBuilder$DefaultRule$$autonumberConfig).Llaika_config_AutonumberConfig$Impl__f_maxDepth);
  } else {
    var $x_1 = false;
  }
  this.Llaika_internal_nav_SectionBuilder$DefaultRule$Builder__f_titleWithNumber = ($x_1 ? $n(outer).addNumber__sci_Seq__Llaika_ast_TreePosition__sci_Seq($n(header).Llaika_ast_Header__f_content, position) : $n(header).Llaika_ast_Header__f_content);
  var options$1 = $n($n(header).Llaika_ast_Header__f_options).$plus__Llaika_ast_Options__Llaika_ast_Options($m_Llaika_ast_Style$().Llaika_ast_Style$__f_section);
  var this$3 = $n(header);
  var level$1 = this$3.Llaika_ast_Header__f_level;
  $n(header);
  var content = this.Llaika_internal_nav_SectionBuilder$DefaultRule$Builder__f_titleWithNumber;
  this.Llaika_internal_nav_SectionBuilder$DefaultRule$Builder__f_styledHeader = new $c_Llaika_ast_Header(level$1, content, options$1);
  this.Llaika_internal_nav_SectionBuilder$DefaultRule$Builder__f_buffer = new $c_scm_ListBuffer();
}
$c_Llaika_internal_nav_SectionBuilder$DefaultRule$Builder.prototype = new $h_O();
$c_Llaika_internal_nav_SectionBuilder$DefaultRule$Builder.prototype.constructor = $c_Llaika_internal_nav_SectionBuilder$DefaultRule$Builder;
/** @constructor */
function $h_Llaika_internal_nav_SectionBuilder$DefaultRule$Builder() {
}
$h_Llaika_internal_nav_SectionBuilder$DefaultRule$Builder.prototype = $c_Llaika_internal_nav_SectionBuilder$DefaultRule$Builder.prototype;
$c_Llaika_internal_nav_SectionBuilder$DefaultRule$Builder.prototype.$plus$eq__Llaika_ast_Block__V = (function(block) {
  var this$1 = $n(this.Llaika_internal_nav_SectionBuilder$DefaultRule$Builder__f_buffer);
  this$1.addOne__O__scm_ListBuffer(block);
});
$c_Llaika_internal_nav_SectionBuilder$DefaultRule$Builder.prototype.$greater$eq__I__Z = (function(level) {
  return ($n(this.Llaika_internal_nav_SectionBuilder$DefaultRule$Builder__f_header).Llaika_ast_Header__f_level >= level);
});
$c_Llaika_internal_nav_SectionBuilder$DefaultRule$Builder.prototype.toSection__Llaika_ast_Section = (function() {
  var header = this.Llaika_internal_nav_SectionBuilder$DefaultRule$Builder__f_styledHeader;
  var content = $n(this.Llaika_internal_nav_SectionBuilder$DefaultRule$Builder__f_buffer).toList__sci_List();
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  return new $c_Llaika_ast_Section(header, content, options);
});
function $as_Llaika_internal_nav_SectionBuilder$DefaultRule$Builder(obj) {
  return (((obj instanceof $c_Llaika_internal_nav_SectionBuilder$DefaultRule$Builder) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.nav.SectionBuilder$DefaultRule$Builder"));
}
function $isArrayOf_Llaika_internal_nav_SectionBuilder$DefaultRule$Builder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_nav_SectionBuilder$DefaultRule$Builder)));
}
function $asArrayOf_Llaika_internal_nav_SectionBuilder$DefaultRule$Builder(obj, depth) {
  return (($isArrayOf_Llaika_internal_nav_SectionBuilder$DefaultRule$Builder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.nav.SectionBuilder$DefaultRule$Builder;", depth));
}
var $d_Llaika_internal_nav_SectionBuilder$DefaultRule$Builder = new $TypeData().initClass($c_Llaika_internal_nav_SectionBuilder$DefaultRule$Builder, "laika.internal.nav.SectionBuilder$DefaultRule$Builder", ({
  Llaika_internal_nav_SectionBuilder$DefaultRule$Builder: 1
}));
/** @constructor */
function $c_Llaika_internal_nav_TitleDocumentConfig$() {
  this.Llaika_internal_nav_TitleDocumentConfig$__f_defaultInputName = null;
  this.Llaika_internal_nav_TitleDocumentConfig$__f_defaultOutputName = null;
  this.Llaika_internal_nav_TitleDocumentConfig$__f_defaultInputName = "README";
  this.Llaika_internal_nav_TitleDocumentConfig$__f_defaultOutputName = "index";
}
$c_Llaika_internal_nav_TitleDocumentConfig$.prototype = new $h_O();
$c_Llaika_internal_nav_TitleDocumentConfig$.prototype.constructor = $c_Llaika_internal_nav_TitleDocumentConfig$;
/** @constructor */
function $h_Llaika_internal_nav_TitleDocumentConfig$() {
}
$h_Llaika_internal_nav_TitleDocumentConfig$.prototype = $c_Llaika_internal_nav_TitleDocumentConfig$.prototype;
$c_Llaika_internal_nav_TitleDocumentConfig$.prototype.inputName__Llaika_api_config_Config__s_util_Either = (function(config) {
  var this$1 = $n(config);
  var key = $m_Llaika_config_LaikaKeys$titleDocuments$().Llaika_config_LaikaKeys$titleDocuments$__f_inputName;
  var decoder = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
  var this$2 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$1, key, decoder));
  if ((this$2 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$2);
    var b = $n(x2).s_util_Right__f_value;
    var _$1 = $as_s_Option(b);
    var this$3 = $n(_$1);
    return new $c_s_util_Right((this$3.isEmpty__Z() ? "README" : this$3.get__O()));
  } else {
    return this$2;
  }
});
$c_Llaika_internal_nav_TitleDocumentConfig$.prototype.outputName__Llaika_api_config_Config__s_util_Either = (function(config) {
  var this$1 = $n(config);
  var key = $m_Llaika_config_LaikaKeys$titleDocuments$().Llaika_config_LaikaKeys$titleDocuments$__f_outputName;
  var decoder = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
  var this$2 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$1, key, decoder));
  if ((this$2 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$2);
    var b = $n(x2).s_util_Right__f_value;
    var _$1 = $as_s_Option(b);
    var this$3 = $n(_$1);
    return new $c_s_util_Right((this$3.isEmpty__Z() ? "index" : this$3.get__O()));
  } else {
    return this$2;
  }
});
var $d_Llaika_internal_nav_TitleDocumentConfig$ = new $TypeData().initClass($c_Llaika_internal_nav_TitleDocumentConfig$, "laika.internal.nav.TitleDocumentConfig$", ({
  Llaika_internal_nav_TitleDocumentConfig$: 1
}));
var $n_Llaika_internal_nav_TitleDocumentConfig$;
function $m_Llaika_internal_nav_TitleDocumentConfig$() {
  if ((!$n_Llaika_internal_nav_TitleDocumentConfig$)) {
    $n_Llaika_internal_nav_TitleDocumentConfig$ = new $c_Llaika_internal_nav_TitleDocumentConfig$();
  }
  return $n_Llaika_internal_nav_TitleDocumentConfig$;
}
/** @constructor */
function $c_Llaika_internal_parse_css_CSSParsers$() {
  this.Llaika_internal_parse_css_CSSParsers$__f_wsOrNl = null;
  this.Llaika_internal_parse_css_CSSParsers$__f_styleRefName = null;
  this.Llaika_internal_parse_css_CSSParsers$__f_combinator = null;
  this.Llaika_internal_parse_css_CSSParsers$__f_typeSelector = null;
  this.Llaika_internal_parse_css_CSSParsers$__f_predicate = null;
  this.Llaika_internal_parse_css_CSSParsers$__f_simpleSelectorSequence = null;
  this.Llaika_internal_parse_css_CSSParsers$__f_selector = null;
  this.Llaika_internal_parse_css_CSSParsers$__f_selectorGroup = null;
  this.Llaika_internal_parse_css_CSSParsers$__f_styleValue = null;
  this.Llaika_internal_parse_css_CSSParsers$__f_style = null;
  this.Llaika_internal_parse_css_CSSParsers$__f_comment = null;
  this.Llaika_internal_parse_css_CSSParsers$__f_styleDeclarations = null;
  this.Llaika_internal_parse_css_CSSParsers$__f_styleDeclarationSet$lzy1 = null;
  this.Llaika_internal_parse_css_CSSParsers$__f_styleDeclarationSetbitmap$1 = false;
  $n_Llaika_internal_parse_css_CSSParsers$ = this;
  var this$1 = $m_Llaika_parse_builders$();
  var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([9, 10, 13])));
  this.Llaika_internal_parse_css_CSSParsers$__f_wsOrNl = $f_Llaika_parse_text_TextParsers__anyOf__C__sci_Seq__Llaika_parse_text_Characters(this$1, 32, chars);
  var this$4 = $m_Llaika_parse_builders$();
  var p = new $c_sjsr_AnonFunction1(((c) => {
    var c$1 = $uC(c);
    var this$3 = $m_jl_Character$();
    return this$3.isLetter__I__Z(c$1);
  }));
  var alpha = $f_Llaika_parse_text_TextParsers__someWhile__F1__Llaika_parse_text_Characters(this$4, p);
  var this$7 = $m_Llaika_parse_builders$();
  var p$1 = new $c_sjsr_AnonFunction1(((c$2) => {
    var c$3 = $uC(c$2);
    var this$5 = $m_jl_Character$();
    if (this$5.isDigit__I__Z(c$3)) {
      return true;
    } else {
      var this$6 = $m_jl_Character$();
      return this$6.isLetter__I__Z(c$3);
    }
  }));
  var alphaNum = $f_Llaika_parse_text_TextParsers__someWhile__F1__Llaika_parse_text_Characters(this$7, p$1);
  var this$8 = $m_Llaika_parse_builders$();
  var chars$1 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([95])));
  var symbol = $n($f_Llaika_parse_text_TextParsers__anyOf__C__sci_Seq__Llaika_parse_text_Characters(this$8, 45, chars$1)).max__I__Llaika_parse_text_Characters(1);
  var $x_1 = $n(alpha);
  var this$9 = $n($n(symbol).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(alphaNum));
  var name = $n($x_1).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(new $c_Llaika_parse_combinator_Repeat(this$9, 0, 2147483647, $m_s_None$()));
  var this$12 = $n($as_Llaika_parse_Parser($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("fox:", name)));
  var p$2 = new $c_sjsr_AnonFunction0((() => name));
  this.Llaika_internal_parse_css_CSSParsers$__f_styleRefName = $n(this$12.orElse__F0__Llaika_parse_Parser(p$2)).source__Llaika_parse_Parser();
  var this$14 = $n($n($n($n($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters()).$tilde__T__Llaika_parse_Parser(">")).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters())).as__F0__Llaika_parse_Parser(new $c_sjsr_AnonFunction0((() => $m_Llaika_internal_parse_css_CSSParsers$Child$()))));
  var p$3 = new $c_sjsr_AnonFunction0((() => {
    var this$13 = $n($n($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters()).min__I__Llaika_parse_text_Characters(1));
    var v = new $c_sjsr_AnonFunction0((() => $m_Llaika_internal_parse_css_CSSParsers$Descendant$()));
    return new $c_Llaika_parse_Parser$$anon$1(v, this$13);
  }));
  this.Llaika_internal_parse_css_CSSParsers$__f_combinator = this$14.orElse__F0__Llaika_parse_Parser(p$3);
  var this$19 = $n($n(this.Llaika_internal_parse_css_CSSParsers$__f_styleRefName).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((name$3) => {
    var name$1 = $as_T(name$3);
    var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_styles_StylePredicate$ElementType.getArrayOf().constr)([new $c_Llaika_ast_styles_StylePredicate$ElementType(name$1)]));
    return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  }))));
  var p$4 = new $c_sjsr_AnonFunction0((() => {
    $m_Llaika_parse_builders$();
    var this$18 = new $c_Llaika_parse_text_Literal("*");
    var v$1 = new $c_sjsr_AnonFunction0((() => $m_sci_Nil$()));
    return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__as__F0__Llaika_parse_text_PrefixedParser(this$18, v$1));
  }));
  this.Llaika_internal_parse_css_CSSParsers$__f_typeSelector = this$19.orElse__F0__Llaika_parse_Parser(p$4);
  var id$2 = $as_Llaika_parse_Parser($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("#", $n(this.Llaika_internal_parse_css_CSSParsers$__f_styleRefName).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((id) => {
    var id$1 = $as_T(id);
    return new $c_Llaika_ast_styles_StylePredicate$Id(id$1);
  })))));
  var styleName = $as_Llaika_parse_Parser($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(".", $n(this.Llaika_internal_parse_css_CSSParsers$__f_styleRefName).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((name$4) => {
    var name$2 = $as_T(name$4);
    return new $c_Llaika_ast_styles_StylePredicate$StyleName(name$2);
  })))));
  var this$24 = $n(id$2);
  var p$5 = new $c_sjsr_AnonFunction0((() => styleName));
  this.Llaika_internal_parse_css_CSSParsers$__f_predicate = this$24.orElse__F0__Llaika_parse_Parser(p$5);
  var $x_2 = $n(this.Llaika_internal_parse_css_CSSParsers$__f_typeSelector);
  var this$25 = $n(this.Llaika_internal_parse_css_CSSParsers$__f_predicate);
  var p$6 = $n($x_2).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(new $c_Llaika_parse_combinator_Repeat(this$25, 0, 2147483647, $m_s_None$()));
  var this$30 = $n($m_Llaika_parse_syntax$Seq2ParsersOps$().concat$extension__Llaika_parse_Parser__Llaika_parse_Parser(p$6));
  var p$7 = new $c_sjsr_AnonFunction0((() => {
    var this$28 = $n(this.Llaika_internal_parse_css_CSSParsers$__f_predicate);
    return new $c_Llaika_parse_combinator_Repeat(this$28, 0, 2147483647, $m_s_None$()).min__I__Llaika_parse_combinator_Repeat(1);
  }));
  this.Llaika_internal_parse_css_CSSParsers$__f_simpleSelectorSequence = $n(this$30.orElse__F0__Llaika_parse_Parser(p$7)).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((preds) => {
    var preds$1 = $as_sci_Seq(preds);
    var this$31 = $n(preds$1);
    var predicates = $m_sci_Set$().from__sc_IterableOnce__sci_Set(this$31);
    var parent = $m_s_None$();
    return new $c_Llaika_ast_styles_StyleSelector(predicates, parent, 0);
  })));
  var $x_3 = this.Llaika_internal_parse_css_CSSParsers$__f_simpleSelectorSequence;
  var this$34 = $n($n(this.Llaika_internal_parse_css_CSSParsers$__f_combinator).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(this.Llaika_internal_parse_css_CSSParsers$__f_simpleSelectorSequence));
  this.Llaika_internal_parse_css_CSSParsers$__f_selector = $n($n($x_3).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(new $c_Llaika_parse_combinator_Repeat(this$34, 0, 2147483647, $m_s_None$()))).$up$up__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Llaika_parse_builders$$tilde(x$1);
    if ((x$1$1 !== null)) {
      var sel = $as_Llaika_ast_styles_StyleSelector($n(x$1$1).Llaika_parse_builders$$tilde__f__1);
      var sels = $as_sci_List($n(x$1$1).Llaika_parse_builders$$tilde__f__2);
      var this$37 = $n(sels);
      var acc = sel;
      var these = this$37;
      while ((!$n(these).isEmpty__Z())) {
        var arg1 = acc;
        var arg2 = $n(these).head__O();
        var x$1$2 = $as_Llaika_ast_styles_StyleSelector(arg1);
        var x$2 = $as_Llaika_parse_builders$$tilde(arg2);
        matchResult8: {
          var x9 = new $c_T2(x$1$2, x$2);
          var x15 = $as_Llaika_ast_styles_StyleSelector(x9.T2__f__1);
          var x16 = $as_Llaika_parse_builders$$tilde(x9.T2__f__2);
          if ((x16 !== null)) {
            var x18 = $as_Llaika_internal_parse_css_CSSParsers$Combinator($n(x16).Llaika_parse_builders$$tilde__f__1);
            var x19 = $as_Llaika_ast_styles_StyleSelector($n(x16).Llaika_parse_builders$$tilde__f__2);
            var x = $m_Llaika_internal_parse_css_CSSParsers$Child$();
            if ((x === x18)) {
              var value = new $c_Llaika_ast_styles_ParentSelector(x15, true);
              var parent$1 = new $c_s_Some(value);
              var this$42 = $n(x19);
              var predicates$1 = this$42.Llaika_ast_styles_StyleSelector__f_predicates;
              var this$43 = $n(x19);
              var order$1 = this$43.Llaika_ast_styles_StyleSelector__f_order;
              $n(x19);
              acc = new $c_Llaika_ast_styles_StyleSelector(predicates$1, parent$1, order$1);
              break matchResult8;
            }
            var x$4 = $m_Llaika_internal_parse_css_CSSParsers$Descendant$();
            if ((x$4 === x18)) {
              var value$1 = new $c_Llaika_ast_styles_ParentSelector(x15, false);
              var parent$2$2 = new $c_s_Some(value$1);
              var this$47 = $n(x19);
              var predicates$2 = this$47.Llaika_ast_styles_StyleSelector__f_predicates;
              var this$48 = $n(x19);
              var order$2 = this$48.Llaika_ast_styles_StyleSelector__f_order;
              $n(x19);
              acc = new $c_Llaika_ast_styles_StyleSelector(predicates$2, parent$2$2, order$2);
              break matchResult8;
            }
          }
          throw new $c_s_MatchError(x9);
        }
        these = $as_sc_LinearSeq($n(these).tail__O());
      }
      return $as_Llaika_ast_styles_StyleSelector(acc);
    }
    throw new $c_s_MatchError(x$1$1);
  })));
  this.Llaika_internal_parse_css_CSSParsers$__f_selectorGroup = $n($n(this.Llaika_internal_parse_css_CSSParsers$__f_selector).rep__Llaika_parse_Parser__Llaika_parse_combinator_Repeat($n($n($n($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters()).$tilde__T__Llaika_parse_Parser(",")).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters())).void__Llaika_parse_Parser())).min__I__Llaika_parse_combinator_Repeat(1);
  var $x_4 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var this$51 = $m_Llaika_parse_builders$();
  var this$52 = $n($n($x_4).$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("/*", $f_Llaika_parse_text_TextParsers__delimitedBy__T__Llaika_parse_text_DelimitedText(this$51, "*/")));
  var p$8 = this.Llaika_internal_parse_css_CSSParsers$__f_wsOrNl;
  var this$53 = $n($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$52, p$8));
  var v$2 = new $c_sjsr_AnonFunction0((() => ""));
  var comment = $f_Llaika_parse_text_PrefixedParser__as__F0__Llaika_parse_text_PrefixedParser(this$53, v$2);
  var this$55 = $m_Llaika_parse_markup_InlineParsers$();
  var parser = new $c_sjsr_AnonFunction0((() => {
    var this$54 = $m_Llaika_parse_builders$();
    var chars$2 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
    return $f_Llaika_parse_text_TextParsers__delimitedBy__C__sci_Seq__Llaika_parse_text_DelimitedText(this$54, 59, chars$2);
  }));
  this.Llaika_internal_parse_css_CSSParsers$__f_styleValue = $as_Llaika_parse_Parser($n($f_Llaika_parse_markup_InlineParsers__text__F0__Llaika_parse_markup_InlineParser(this$55, parser)).embed__F0__Llaika_parse_markup_InlineParser(new $c_sjsr_AnonFunction0((() => comment))));
  var p$9 = $n($n(this.Llaika_internal_parse_css_CSSParsers$__f_styleRefName).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser($n($n($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters()).$tilde__T__Llaika_parse_Parser(":")).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters()))).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($n(this.Llaika_internal_parse_css_CSSParsers$__f_styleValue).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser(this.Llaika_internal_parse_css_CSSParsers$__f_wsOrNl));
  this.Llaika_internal_parse_css_CSSParsers$__f_style = $m_Llaika_parse_syntax$Map2Ops$().mapN$extension__Llaika_parse_Parser__F2__Llaika_parse_Parser(p$9, new $c_sjsr_AnonFunction2(((name$5, value$2) => {
    var name$6 = $as_T(name$5);
    var value$3 = $as_T(value$2);
    return new $c_Llaika_internal_parse_css_CSSParsers$Style(name$6, value$3);
  })));
  var $x_5 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var this$59 = $m_Llaika_parse_builders$();
  var this$60 = $n($n($x_5).$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("/*", $f_Llaika_parse_text_TextParsers__delimitedBy__T__Llaika_parse_text_DelimitedText(this$59, "*/")));
  var p$10 = this.Llaika_internal_parse_css_CSSParsers$__f_wsOrNl;
  this.Llaika_internal_parse_css_CSSParsers$__f_comment = $n($as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$60, p$10))).void__Llaika_parse_Parser();
  var this$61 = $n(this.Llaika_internal_parse_css_CSSParsers$__f_comment);
  var p$11 = new $c_sjsr_AnonFunction0((() => this.Llaika_internal_parse_css_CSSParsers$__f_style));
  var styleBody = this$61.orElse__F0__Llaika_parse_Parser(p$11);
  var $x_6 = $n(this.Llaika_internal_parse_css_CSSParsers$__f_selectorGroup).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser($n($n(this.Llaika_internal_parse_css_CSSParsers$__f_wsOrNl).$tilde__T__Llaika_parse_Parser("{")).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(this.Llaika_internal_parse_css_CSSParsers$__f_wsOrNl));
  var this$62 = $n(styleBody);
  var p$12 = $n($n($x_6).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(new $c_Llaika_parse_combinator_Repeat(this$62, 0, 2147483647, $m_s_None$()))).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser($n(this.Llaika_internal_parse_css_CSSParsers$__f_wsOrNl).$tilde__T__Llaika_parse_Parser("}"));
  this.Llaika_internal_parse_css_CSSParsers$__f_styleDeclarations = $m_Llaika_parse_syntax$Map2Ops$().mapN$extension__Llaika_parse_Parser__F2__Llaika_parse_Parser(p$12, new $c_sjsr_AnonFunction2(((selectors, stylesAndComments) => {
    var selectors$1 = $as_sci_Seq(selectors);
    var stylesAndComments$1 = $as_sci_List(stylesAndComments);
    var this$66 = $n($n(stylesAndComments$1).collect__s_PartialFunction__sci_List(new $c_Llaika_internal_parse_css_CSSParsers$$anon$1()));
    var this$65 = $m_s_$less$colon$less$();
    var styles = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$66);
    return $as_sci_Seq($n(selectors$1).map__F1__O(new $c_sjsr_AnonFunction1(((_$1) => {
      var _$1$1 = $as_Llaika_ast_styles_StyleSelector(_$1);
      return new $c_Llaika_ast_styles_StyleDeclaration(_$1$1, styles);
    }))));
  })));
}
$c_Llaika_internal_parse_css_CSSParsers$.prototype = new $h_O();
$c_Llaika_internal_parse_css_CSSParsers$.prototype.constructor = $c_Llaika_internal_parse_css_CSSParsers$;
/** @constructor */
function $h_Llaika_internal_parse_css_CSSParsers$() {
}
$h_Llaika_internal_parse_css_CSSParsers$.prototype = $c_Llaika_internal_parse_css_CSSParsers$.prototype;
$c_Llaika_internal_parse_css_CSSParsers$.prototype.styleDeclarationSet__Llaika_parse_Parser = (function() {
  if ((!this.Llaika_internal_parse_css_CSSParsers$__f_styleDeclarationSetbitmap$1)) {
    var $x_4 = $n(this.Llaika_internal_parse_css_CSSParsers$__f_wsOrNl);
    var this$1 = $n(this.Llaika_internal_parse_css_CSSParsers$__f_comment);
    var $x_3 = $n($x_4).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(new $c_Llaika_parse_combinator_Repeat(this$1, 0, 2147483647, $m_s_None$()));
    var $x_2 = this.Llaika_internal_parse_css_CSSParsers$__f_styleDeclarations;
    var $x_1 = this.Llaika_internal_parse_css_CSSParsers$__f_wsOrNl;
    var this$3 = $n(this.Llaika_internal_parse_css_CSSParsers$__f_comment);
    var this$5 = $n($n($x_2).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser($n($x_1).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(new $c_Llaika_parse_combinator_Repeat(this$3, 0, 2147483647, $m_s_None$()))));
    this.Llaika_internal_parse_css_CSSParsers$__f_styleDeclarationSet$lzy1 = $n($n($x_3).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser(new $c_Llaika_parse_combinator_Repeat(this$5, 0, 2147483647, $m_s_None$()))).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$2) => {
      var _$2$1 = $as_sci_List(_$2);
      var this$10 = $n(_$2$1);
      var this$9 = $m_s_$less$colon$less$();
      var toIterableOnce = this$9.s_$less$colon$less$__f_singleton;
      var this$11 = $n($as_sc_StrictOptimizedIterableOps($f_sc_StrictOptimizedIterableOps__flatten__F1__O(this$10, toIterableOnce)));
      var this$12 = $n($as_sci_List($f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this$11)));
      var f = ((x$1) => {
        var x$1$1 = $as_T2(x$1);
        if ((x$1$1 !== null)) {
          var decl = $as_Llaika_ast_styles_StyleDeclaration($n(x$1$1)._1__O());
          var pos = $uI($n(x$1$1)._2__O());
          return $n(decl).increaseOrderBy__I__Llaika_ast_styles_StyleDeclaration(pos);
        }
        throw new $c_s_MatchError(x$1$1);
      });
      if ((this$12 === $m_sci_Nil$())) {
        var $x_5 = $m_sci_Nil$();
      } else {
        var arg1 = this$12.head__O();
        var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
        var t = h;
        var rest = $as_sci_List(this$12.tail__O());
        while ((rest !== $m_sci_Nil$())) {
          var arg1$1 = $n(rest).head__O();
          var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
          $n(t).sci_$colon$colon__f_next = nx;
          t = nx;
          rest = $as_sci_List($n(rest).tail__O());
        }
        var $x_5 = h;
      }
      var this$13 = $n($x_5);
      return $m_sci_Set$().from__sc_IterableOnce__sci_Set(this$13);
    })));
    this.Llaika_internal_parse_css_CSSParsers$__f_styleDeclarationSetbitmap$1 = true;
  }
  return this.Llaika_internal_parse_css_CSSParsers$__f_styleDeclarationSet$lzy1;
});
var $d_Llaika_internal_parse_css_CSSParsers$ = new $TypeData().initClass($c_Llaika_internal_parse_css_CSSParsers$, "laika.internal.parse.css.CSSParsers$", ({
  Llaika_internal_parse_css_CSSParsers$: 1
}));
var $n_Llaika_internal_parse_css_CSSParsers$;
function $m_Llaika_internal_parse_css_CSSParsers$() {
  if ((!$n_Llaika_internal_parse_css_CSSParsers$)) {
    $n_Llaika_internal_parse_css_CSSParsers$ = new $c_Llaika_internal_parse_css_CSSParsers$();
  }
  return $n_Llaika_internal_parse_css_CSSParsers$;
}
/** @constructor */
function $c_Llaika_internal_parse_css_CSSParsers$Combinator() {
}
$c_Llaika_internal_parse_css_CSSParsers$Combinator.prototype = new $h_O();
$c_Llaika_internal_parse_css_CSSParsers$Combinator.prototype.constructor = $c_Llaika_internal_parse_css_CSSParsers$Combinator;
/** @constructor */
function $h_Llaika_internal_parse_css_CSSParsers$Combinator() {
}
$h_Llaika_internal_parse_css_CSSParsers$Combinator.prototype = $c_Llaika_internal_parse_css_CSSParsers$Combinator.prototype;
function $as_Llaika_internal_parse_css_CSSParsers$Combinator(obj) {
  return (((obj instanceof $c_Llaika_internal_parse_css_CSSParsers$Combinator) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.css.CSSParsers$Combinator"));
}
function $isArrayOf_Llaika_internal_parse_css_CSSParsers$Combinator(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_css_CSSParsers$Combinator)));
}
function $asArrayOf_Llaika_internal_parse_css_CSSParsers$Combinator(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_css_CSSParsers$Combinator(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.css.CSSParsers$Combinator;", depth));
}
/** @constructor */
function $c_Llaika_internal_parse_directive_BlockDirectiveParsers$() {
}
$c_Llaika_internal_parse_directive_BlockDirectiveParsers$.prototype = new $h_O();
$c_Llaika_internal_parse_directive_BlockDirectiveParsers$.prototype.constructor = $c_Llaika_internal_parse_directive_BlockDirectiveParsers$;
/** @constructor */
function $h_Llaika_internal_parse_directive_BlockDirectiveParsers$() {
}
$h_Llaika_internal_parse_directive_BlockDirectiveParsers$.prototype = $c_Llaika_internal_parse_directive_BlockDirectiveParsers$.prototype;
$c_Llaika_internal_parse_directive_BlockDirectiveParsers$.prototype.blockDirective__sci_Map__Llaika_api_bundle_BlockParserBuilder = (function(directives) {
  var factory = new $c_sjsr_AnonFunction1(((recParsers) => {
    var recParsers$1 = $as_Llaika_parse_markup_RecursiveParsers(recParsers);
    return $as_Llaika_parse_Parser(this.blockDirectiveParser__sci_Map__Llaika_parse_markup_RecursiveParsers__Llaika_parse_text_PrefixedParser(directives, recParsers$1));
  }));
  return new $c_Llaika_api_bundle_BlockParserBuilder(factory, true, $m_Llaika_api_bundle_BlockPosition$Any$(), $m_Llaika_api_bundle_Precedence$High$(), $m_s_None$());
});
$c_Llaika_internal_parse_directive_BlockDirectiveParsers$.prototype.blockDirectiveParser__sci_Map__Llaika_parse_markup_RecursiveParsers__Llaika_parse_text_PrefixedParser = (function(directives, recParsers) {
  var this$1 = $n(directives);
  var this$3 = new $c_sc_MapOps$$anon$1(this$1);
  var f = new $c_sjsr_AnonFunction1(((_$7) => {
    var _$7$1 = $as_Llaika_api_bundle_DirectiveBuilderContext$Directive(_$7);
    return $n(_$7$1).separators__sci_Set();
  }));
  var this$4 = $n($as_sc_IterableOnceOps($f_sc_IterableOps__flatMap__F1__O(this$3, f)));
  var separators = $m_sci_Set$().from__sc_IterableOnce__sci_Set($as_sc_IterableOnce(this$4));
  var noBody = $n($m_Llaika_parse_builders$().Llaika_parse_builders$__f_wsEol).as__F0__Llaika_parse_Parser(new $c_sjsr_AnonFunction0((() => $m_s_None$())));
  var body = new $c_sjsr_AnonFunction1(((spec) => {
    var spec$1 = $as_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec(spec);
    var this$5 = $n($n(directives).get__O__s_Option($n(spec$1).Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec__f_name));
    if ((!this$5.isEmpty__Z())) {
      var arg1 = this$5.get__O();
      var _$8 = $as_Llaika_api_bundle_DirectiveBuilderContext$Directive(arg1);
      var $x_1 = $n(_$8).hasBody__Z();
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var $x_2 = $m_Llaika_parse_syntax$LiteralStringOps$();
      var str = $n(spec$1).Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec__f_fence;
      var closingFenceP = $n($x_2).$less$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(str, $m_Llaika_parse_builders$().Llaika_parse_builders$__f_wsEol);
      var $x_4 = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_wsEol;
      var this$8 = $m_Llaika_parse_builders$();
      var this$7 = $n($as_Llaika_parse_Parser(closingFenceP));
      var p = new $c_sjsr_AnonFunction0((() => $m_Llaika_parse_builders$().Llaika_parse_builders$__f_eof));
      var p$1 = this$7.orElse__F0__Llaika_parse_Parser(p);
      var $x_3 = $f_Llaika_parse_combinator_Parsers__not__Llaika_parse_Parser__Llaika_parse_Parser(this$8, p$1);
      var p$2 = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_restOfLine;
      var this$10 = $n($n($x_3).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($m_Llaika_parse_syntax$StringParserOps$().line$extension__Llaika_parse_Parser__Llaika_parse_Parser(p$2)));
      var this$21 = $n($n($n($n($x_4).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser(new $c_Llaika_parse_combinator_Repeat(this$10, 0, 2147483647, $m_s_None$()))).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser($as_Llaika_parse_Parser(closingFenceP))).$up$up__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((lines) => {
        var lines$1 = $as_sci_List(lines);
        var this$12 = $n(lines$1);
        var s = this$12;
        while (true) {
          var this$13 = $n(s);
          if ((!this$13.isEmpty__Z())) {
            var arg1$1 = $n(s).head__O();
            var _$9 = $as_Llaika_parse_LineSource(arg1$1);
            var this$14 = $n($f_T__trim__T($n($n(_$9).Llaika_parse_LineSource__f_input)));
            var $x_5 = (this$14 === "");
          } else {
            var $x_5 = false;
          }
          if ($x_5) {
            s = $as_sc_LinearSeq($n(s).tail__O());
          } else {
            break;
          }
        }
        var this$15 = $n($n($as_sci_List(s)).reverse__sci_List());
        var s$1 = this$15;
        while (true) {
          var this$16 = $n(s$1);
          if ((!this$16.isEmpty__Z())) {
            var arg1$2 = $n(s$1).head__O();
            var _$10 = $as_Llaika_parse_LineSource(arg1$2);
            var this$17 = $n($f_T__trim__T($n($n(_$10).Llaika_parse_LineSource__f_input)));
            var $x_6 = (this$17 === "");
          } else {
            var $x_6 = false;
          }
          if ($x_6) {
            s$1 = $as_sc_LinearSeq($n(s$1).tail__O());
          } else {
            break;
          }
        }
        var trimmedLines = $n($as_sci_List(s$1)).reverse__sci_List();
        var this$18 = $n($n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptyChain).fromSeq__sci_Seq__s_Option(trimmedLines));
        if (this$18.isEmpty__Z()) {
          var $x_7 = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptyChain);
          var parent = $m_Llaika_parse_SourceCursor$().apply__T__Llaika_parse_SourceCursor("");
          var lineChain = $n($x_7).one__O__O(new $c_Llaika_parse_LineSource("", parent, 0, $n(parent).nestLevel__I()));
        } else {
          var lineChain = this$18.get__O();
        }
        var value = $m_Llaika_parse_BlockSource$().apply__O__Llaika_parse_BlockSource(lineChain);
        return new $c_s_Some(value);
      }))));
      var p$3 = new $c_sjsr_AnonFunction0((() => noBody));
      return this$21.orElse__F0__Llaika_parse_Parser(p$3);
    } else {
      return noBody;
    }
  }));
  var this$34 = $m_Llaika_parse_text_PrefixedParser$();
  var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
  var p$4 = $n($n($m_Llaika_internal_parse_directive_DirectiveParsers$().directiveParser__F1__Z__Llaika_parse_Parser(body, true)).withCursor__Llaika_parse_Parser()).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    matchResult17: {
      var $x_8;
      if ((x$1$1 !== null)) {
        var res = $as_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective($n(x$1$1)._1__O());
        var source = $as_Llaika_parse_SourceFragment($n(x$1$1)._2__O());
        var $x_9 = $m_sc_StringOps$();
        var x = $n(source).input__T();
        if ($n($n($x_9).lastOption$extension__T__s_Option(x)).contains__O__Z($bC(10))) {
          var $x_10 = $m_sc_StringOps$();
          var x$2 = $n(source).input__T();
          var input = $n($x_10).dropRight$extension__T__I__T(x$2, 1);
          var trimmedSource = new $c_Llaika_parse_LineSource(input, source, 0, $n(source).nestLevel__I());
        } else {
          var trimmedSource = source;
        }
        if ($n(separators).contains__O__Z($n(res).Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_name)) {
          var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
          var $x_8 = new $c_Llaika_api_bundle_BlockDirectives$SeparatorInstance(res, trimmedSource, options);
          break matchResult17;
        } else {
          var directive = $n(directives).get__O__s_Option($n(res).Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_name);
          var rewriteRules = new $c_Llaika_ast_RewriteRules($m_sci_Nil$(), $m_sci_Nil$(), $m_sci_Nil$());
          var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
          var $x_8 = new $c_Llaika_api_bundle_BlockDirectives$DirectiveInstance(directive, res, recParsers, trimmedSource, rewriteRules, options$1);
          break matchResult17;
        }
      }
      throw new $c_s_MatchError(x$1$1);
    }
    return $as_Llaika_api_bundle_DirectiveBuilderContext$DirectiveProcessor($x_8);
  })));
  return new $c_Llaika_parse_text_PrefixedParser$$anon$2(64, chars, p$4, this$34);
});
var $d_Llaika_internal_parse_directive_BlockDirectiveParsers$ = new $TypeData().initClass($c_Llaika_internal_parse_directive_BlockDirectiveParsers$, "laika.internal.parse.directive.BlockDirectiveParsers$", ({
  Llaika_internal_parse_directive_BlockDirectiveParsers$: 1
}));
var $n_Llaika_internal_parse_directive_BlockDirectiveParsers$;
function $m_Llaika_internal_parse_directive_BlockDirectiveParsers$() {
  if ((!$n_Llaika_internal_parse_directive_BlockDirectiveParsers$)) {
    $n_Llaika_internal_parse_directive_BlockDirectiveParsers$ = new $c_Llaika_internal_parse_directive_BlockDirectiveParsers$();
  }
  return $n_Llaika_internal_parse_directive_BlockDirectiveParsers$;
}
/** @constructor */
function $c_Llaika_internal_parse_directive_DirectiveParsers$() {
  this.Llaika_internal_parse_directive_DirectiveParsers$__f_nameDecl$lzy1 = null;
  this.Llaika_internal_parse_directive_DirectiveParsers$__f_nameDeclbitmap$1 = false;
  $n_Llaika_internal_parse_directive_DirectiveParsers$ = this;
  var $x_1 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var this$2 = $m_Llaika_parse_builders$();
  var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
  var this$3 = $n($n($x_1).$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("{", $f_Llaika_parse_text_TextParsers__delimitedBy__C__sci_Seq__Llaika_parse_text_DelimitedText(this$2, 125, chars)));
  var this$4 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = this$3.startChars__O();
  var p = $c_Llaika_parse_Parser.prototype.source__Llaika_parse_Parser.call(this$3);
  var this$8 = new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p, this$4);
  var f = new $c_sjsr_AnonFunction1(((_$1) => {
    var _$1$1 = $as_T(_$1);
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    return new $c_Llaika_ast_Text(_$1$1, options);
  }));
  $f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser(this$8, f);
}
$c_Llaika_internal_parse_directive_DirectiveParsers$.prototype = new $h_O();
$c_Llaika_internal_parse_directive_DirectiveParsers$.prototype.constructor = $c_Llaika_internal_parse_directive_DirectiveParsers$;
/** @constructor */
function $h_Llaika_internal_parse_directive_DirectiveParsers$() {
}
$h_Llaika_internal_parse_directive_DirectiveParsers$.prototype = $c_Llaika_internal_parse_directive_DirectiveParsers$.prototype;
$c_Llaika_internal_parse_directive_DirectiveParsers$.prototype.hoconReference__F3__F1__Llaika_parse_text_PrefixedParser = (function(f, e) {
  var $x_1 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var this$2 = $m_Llaika_parse_builders$();
  var this$4 = $n($n($x_1).$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("${", $f_Llaika_parse_combinator_Parsers__opt__T__Llaika_parse_Parser(this$2, "?")));
  var p = $m_Llaika_internal_parse_hocon_HoconParsers$().concatenatedKey__O__Llaika_parse_Parser($n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet).one__O__Lcats_kernel_Order__O($bC(125), $m_Lcats_kernel_instances_char_package$().Lcats_kernel_instances_char_package$__f_catsKernelStdOrderForChar));
  var this$5 = $n($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$4, p));
  var this$6 = $n($f_Llaika_parse_text_PrefixedParser__$less$tilde__T__Llaika_parse_text_PrefixedParser(this$5, "}"));
  var this$7 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = this$6.startChars__O();
  var p$1 = $c_Llaika_parse_Parser.prototype.withCursor__Llaika_parse_Parser.call(this$6);
  var this$11 = new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p$1, this$7);
  var f$1 = new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var x6 = $as_Llaika_parse_builders$$tilde($n(x$1$1)._1__O());
      if ((x6 !== null)) {
        var optional = $as_s_Option($n(x6).Llaika_parse_builders$$tilde__f__1);
        var key = $as_s_util_Either($n(x6).Llaika_parse_builders$$tilde__f__2);
        var source = $as_Llaika_parse_SourceFragment($n(x$1$1)._2__O());
        var this$10 = $n(key);
        if ((this$10 instanceof $c_s_util_Right)) {
          var x2 = $as_s_util_Right(this$10);
          var b = $n(x2).s_util_Right__f_value;
          var key$1 = $as_Llaika_api_config_Key(b);
          return $n(f).apply__O__O__O__O(key$1, $n(optional).isEmpty__Z(), source);
        } else if ((this$10 instanceof $c_s_util_Left)) {
          var x3 = $as_s_util_Left(this$10);
          var a = $n(x3).s_util_Left__f_value;
          var invalid = $as_Llaika_internal_parse_hocon_InvalidStringValue(a);
          return $n(e).apply__O__O($m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan(((("Invalid HOCON reference: '" + $n(source).input__T()) + "': ") + $n($n(invalid).Llaika_internal_parse_hocon_InvalidStringValue__f_failure).toString__T()), source));
        } else {
          throw new $c_s_MatchError(this$10);
        }
      }
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return $f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser(this$11, f$1);
});
$c_Llaika_internal_parse_directive_DirectiveParsers$.prototype.nameDecl__Llaika_parse_Parser = (function() {
  if ((!this.Llaika_internal_parse_directive_DirectiveParsers$__f_nameDeclbitmap$1)) {
    var this$1 = $m_Llaika_parse_builders$();
    var chars = $m_Llaika_parse_text_CharGroup$().Llaika_parse_text_CharGroup$__f_alpha;
    var this$5 = $n($f_Llaika_parse_text_TextParsers__oneOf__O__Llaika_parse_text_PrefixedParser(this$1, chars));
    var this$4 = $m_Llaika_parse_builders$();
    var value = $m_Llaika_parse_text_CharGroup$().Llaika_parse_text_CharGroup$__f_alphaNum;
    var value$1 = new $c_Lcats_data_NonEmptySetOps(value).add__O__O($bC(45));
    var chars$1 = new $c_Lcats_data_NonEmptySetOps(value$1).add__O__O($bC(95));
    var p = $f_Llaika_parse_text_TextParsers__anyOf__O__Llaika_parse_text_Characters(this$4, chars$1);
    var this$6 = $n($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$5, p));
    var this$7 = $m_Llaika_parse_text_PrefixedParser$();
    var sc = this$6.startChars__O();
    var p$1 = $c_Llaika_parse_Parser.prototype.source__Llaika_parse_Parser.call(this$6);
    this.Llaika_internal_parse_directive_DirectiveParsers$__f_nameDecl$lzy1 = new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p$1, this$7);
    this.Llaika_internal_parse_directive_DirectiveParsers$__f_nameDeclbitmap$1 = true;
  }
  return this.Llaika_internal_parse_directive_DirectiveParsers$__f_nameDecl$lzy1;
});
$c_Llaika_internal_parse_directive_DirectiveParsers$.prototype.declarationParser__Z__Llaika_parse_Parser = (function(supportsCustomFence) {
  var this$1 = $m_Llaika_parse_builders$();
  var defaultFence = $f_Llaika_parse_combinator_Parsers__success__O__Llaika_parse_Parser(this$1, "@:@");
  if (supportsCustomFence) {
    var $x_1 = $m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters();
    var this$2 = $m_Llaika_parse_builders$();
    var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([10, 9])));
    var this$4 = $n($n($x_1).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($n($f_Llaika_parse_text_TextParsers__anyNot__C__sci_Seq__Llaika_parse_text_Characters(this$2, 32, chars)).take__I__Llaika_parse_text_Characters(3)));
    var p = new $c_sjsr_AnonFunction0((() => defaultFence));
    var fence = this$4.orElse__F0__Llaika_parse_Parser(p);
  } else {
    var fence = defaultFence;
  }
  var $x_2 = $n($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters()).$tilde__T__Llaika_parse_Parser("\"");
  var this$6 = $m_Llaika_parse_builders$();
  var parser = new $c_sjsr_AnonFunction0((() => {
    var this$5 = $m_Llaika_parse_builders$();
    var chars$1 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
    return $f_Llaika_parse_text_TextParsers__delimitedBy__C__sci_Seq__Llaika_parse_text_DelimitedText(this$5, 34, chars$1);
  }));
  var quotedAttribute = $n($n($x_2).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($as_Llaika_parse_Parser($n($f_Llaika_parse_markup_InlineParsers__text__F0__Llaika_parse_markup_InlineParser(this$6, parser)).embed__F0__Llaika_parse_markup_InlineParser(new $c_sjsr_AnonFunction0((() => $m_Llaika_parse_syntax$LiteralStringOps$().$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("\\", $m_Llaika_parse_builders$().Llaika_parse_builders$__f_oneChar))))))).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters());
  var this$9 = $m_Llaika_parse_builders$();
  var parser$1 = new $c_sjsr_AnonFunction0((() => {
    var this$8 = $m_Llaika_parse_builders$();
    var chars$2 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([41])));
    return $n($f_Llaika_parse_text_TextParsers__delimitedBy__C__sci_Seq__Llaika_parse_text_DelimitedText(this$8, 44, chars$2)).keepDelimiter__Llaika_parse_text_DelimitedText();
  }));
  var unquotedAttribute = $n($as_Llaika_parse_Parser($n($f_Llaika_parse_markup_InlineParsers__text__F0__Llaika_parse_markup_InlineParser(this$9, parser$1)).embed__F0__Llaika_parse_markup_InlineParser(new $c_sjsr_AnonFunction0((() => $m_Llaika_parse_syntax$LiteralStringOps$().$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("\\", $m_Llaika_parse_builders$().Llaika_parse_builders$__f_oneChar)))))).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters());
  var this$15 = $m_Llaika_parse_builders$();
  var $x_3 = $n($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters()).$tilde$greater__T__Llaika_parse_Parser("(");
  var this$11 = $n(quotedAttribute);
  var p$1 = new $c_sjsr_AnonFunction0((() => unquotedAttribute));
  var p$2 = $n($n($x_3).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($n($n(this$11.orElse__F0__Llaika_parse_Parser(p$1)).rep__T__Llaika_parse_combinator_Repeat(",")).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((values) => {
    var values$1 = $as_sci_List(values);
    var $x_4 = $m_Llaika_internal_parse_hocon_BuilderField$();
    var this$13 = $n(values$1);
    var f = ((sv) => {
      var sv$1 = $as_T(sv);
      var value = $f_T__trim__T($n(sv$1));
      return new $c_Llaika_internal_parse_hocon_ValidStringValue(value);
    });
    if ((this$13 === $m_sci_Nil$())) {
      var values$2 = $m_sci_Nil$();
    } else {
      var arg1 = this$13.head__O();
      var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(this$13.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var arg1$1 = $n(rest).head__O();
        var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O());
      }
      var values$2 = h;
    }
    return $n($x_4).apply__T__Llaika_internal_parse_hocon_ConfigBuilderValue__Llaika_internal_parse_hocon_BuilderField("__$$:positional:$$__", new $c_Llaika_internal_parse_hocon_ArrayBuilderValue(values$2));
  }))))).$less$tilde__T__Llaika_parse_Parser(")");
  var positionalAttributes = $f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$15, p$2);
  $m_Llaika_parse_builders$();
  var this$18 = new $c_Llaika_parse_text_Literal("}");
  var v = new $c_sjsr_AnonFunction0((() => $m_s_None$()));
  var this$21 = $n($as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__as__F0__Llaika_parse_text_PrefixedParser(this$18, v)));
  var p$3 = new $c_sjsr_AnonFunction0((() => {
    var this$19 = $m_Llaika_parse_builders$();
    return $n($n($f_Llaika_parse_combinator_Parsers__success__O__Llaika_parse_Parser(this$19, (void 0))).withCursor__Llaika_parse_Parser()).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((x$1) => {
      var x$1$1 = $as_T2(x$1);
      if ((x$1$1 !== null)) {
        var ctx = $as_Llaika_parse_SourceFragment($n(x$1$1)._2__O());
        return new $c_s_Some(ctx);
      }
      throw new $c_s_MatchError(x$1$1);
    })));
  }));
  var closingAttributes = this$21.orElse__F0__Llaika_parse_Parser(p$3);
  var this$25 = $m_Llaika_parse_builders$();
  var $x_5 = $n($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters());
  var this$24 = $m_Llaika_internal_parse_hocon_HoconParsers$();
  var parser$2 = new $c_sjsr_AnonFunction0((() => {
    var this$23 = $n($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("{", $m_Llaika_internal_parse_hocon_HoconParsers$().objectMembers__Llaika_parse_Parser()));
    return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$23, closingAttributes));
  }));
  var p$4 = $n($x_5).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser(new $c_Llaika_internal_parse_hocon_HoconParsers$$anon$1(parser$2, this$24));
  var hoconAttributes = $f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$25, p$4);
  var attributeSection = $n($n(positionalAttributes).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(hoconAttributes)).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1$3 = $as_Llaika_parse_builders$$tilde(x$1$2);
    if ((x$1$3 !== null)) {
      var x30 = $as_s_Option($n(x$1$3).Llaika_parse_builders$$tilde__f__1);
      var x31 = $as_s_Option($n(x$1$3).Llaika_parse_builders$$tilde__f__2);
      if ((x31 instanceof $c_s_Some)) {
        var x33 = $as_Llaika_parse_builders$$tilde($n($as_s_Some(x31)).s_Some__f_value);
        if ((x33 !== null)) {
          var obj = $as_Llaika_internal_parse_hocon_ObjectBuilderValue($n(x33).Llaika_parse_builders$$tilde__f__1);
          var optCtx = $as_s_Option($n(x33).Llaika_parse_builders$$tilde__f__2);
          var positional = $n($m_s_Option$().option2Iterable__s_Option__sc_Iterable(x30)).toSeq__sci_Seq();
          $n(obj);
          var this$28 = $n(positional);
          var suffix = $n(obj).Llaika_internal_parse_hocon_ObjectBuilderValue__f_values;
          var values$3 = $as_sci_Seq(this$28.appendedAll__sc_IterableOnce__O(suffix));
          var attrs = new $c_Llaika_internal_parse_hocon_ObjectBuilderValue(values$3);
          if ((optCtx instanceof $c_s_Some)) {
            var ctx$1 = $as_Llaika_parse_SourceCursor($n($as_s_Some(optCtx)).s_Some__f_value);
            if ($n($m_Llaika_internal_parse_hocon_ConfigResolver$().extractErrors__Llaika_internal_parse_hocon_ObjectBuilderValue__T__sci_Seq(obj, "")).isEmpty__Z()) {
              var this$30 = $m_Llaika_parse_Message$();
              var msgProvider = new $c_Llaika_parse_Message$$anon$2("Missing closing brace for attribute section", this$30);
              var maxOffset = $n(ctx$1).offset__I();
              var fail = new $c_Llaika_parse_Failure(msgProvider, ctx$1, maxOffset);
              var $x_8 = $m_sci_Seq$();
              var $x_7 = $m_sr_ScalaRunTime$();
              var $x_6 = $m_Llaika_internal_parse_hocon_BuilderField$();
              var value$1 = $m_Llaika_internal_parse_hocon_SelfReference$();
              var values$4 = $as_sci_Seq($n($x_8).apply__sci_Seq__sc_SeqOps($n($x_7).wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_internal_parse_hocon_BuilderField.getArrayOf().constr)([$n($x_6).apply__T__Llaika_internal_parse_hocon_ConfigBuilderValue__Llaika_internal_parse_hocon_BuilderField("failure", new $c_Llaika_internal_parse_hocon_InvalidBuilderValue(value$1, fail))]))));
              return new $c_Llaika_internal_parse_hocon_ObjectBuilderValue(values$4);
            }
          }
          return attrs;
        }
      }
      var x = $m_s_None$();
      if ((x === x31)) {
        var values$5 = $n($m_s_Option$().option2Iterable__s_Option__sc_Iterable(x30)).toSeq__sci_Seq();
        return new $c_Llaika_internal_parse_hocon_ObjectBuilderValue(values$5);
      }
    }
    throw new $c_s_MatchError(x$1$3);
  })));
  var this$36 = $n($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("@:", this.nameDecl__Llaika_parse_Parser()));
  var this$37 = $n($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$36, attributeSection));
  var this$41 = $n($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$37, fence));
  var f$1 = new $c_sjsr_AnonFunction1(((x$1$2$1) => {
    var x$1$4 = $as_Llaika_parse_builders$$tilde(x$1$2$1);
    if ((x$1$4 !== null)) {
      var x39 = $as_Llaika_parse_builders$$tilde($n(x$1$4).Llaika_parse_builders$$tilde__f__1);
      if ((x39 !== null)) {
        var name = $as_T($n(x39).Llaika_parse_builders$$tilde__f__1);
        var attrs$1 = $as_Llaika_internal_parse_hocon_ObjectBuilderValue($n(x39).Llaika_parse_builders$$tilde__f__2);
        var fencePattern = $as_T($n(x$1$4).Llaika_parse_builders$$tilde__f__2);
        return new $c_T3(name, attrs$1, fencePattern);
      }
    }
    throw new $c_s_MatchError(x$1$4);
  }));
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser(this$41, f$1));
});
$c_Llaika_internal_parse_directive_DirectiveParsers$.prototype.directiveParser__F1__Z__Llaika_parse_Parser = (function(bodyContent, supportsCustomFence) {
  return $n(this.declarationParser__Z__Llaika_parse_Parser(supportsCustomFence)).$greater$greater__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T3(x$1);
    if ((x$1$1 !== null)) {
      var name = $as_T($n(x$1$1).T3__f__1);
      var attrs = $as_Llaika_internal_parse_hocon_ObjectBuilderValue($n(x$1$1).T3__f__2);
      var fence = $as_T($n(x$1$1).T3__f__3);
      return $n($as_Llaika_parse_Parser($n(bodyContent).apply__O__O(new $c_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec(name, fence)))).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((content) => {
        var content$1 = $as_s_Option(content);
        return new $c_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective(name, attrs, content$1);
      })));
    }
    throw new $c_s_MatchError(x$1$1);
  })));
});
var $d_Llaika_internal_parse_directive_DirectiveParsers$ = new $TypeData().initClass($c_Llaika_internal_parse_directive_DirectiveParsers$, "laika.internal.parse.directive.DirectiveParsers$", ({
  Llaika_internal_parse_directive_DirectiveParsers$: 1
}));
var $n_Llaika_internal_parse_directive_DirectiveParsers$;
function $m_Llaika_internal_parse_directive_DirectiveParsers$() {
  if ((!$n_Llaika_internal_parse_directive_DirectiveParsers$)) {
    $n_Llaika_internal_parse_directive_DirectiveParsers$ = new $c_Llaika_internal_parse_directive_DirectiveParsers$();
  }
  return $n_Llaika_internal_parse_directive_DirectiveParsers$;
}
/** @constructor */
function $c_Llaika_internal_parse_directive_SpanDirectiveParsers$() {
  this.Llaika_internal_parse_directive_SpanDirectiveParsers$__f_contextRef = null;
  $n_Llaika_internal_parse_directive_SpanDirectiveParsers$ = this;
  this.Llaika_internal_parse_directive_SpanDirectiveParsers$__f_contextRef = $m_Llaika_api_bundle_SpanParserBuilder$().standalone__Llaika_parse_text_PrefixedParser__Llaika_api_bundle_SpanParserBuilder($m_Llaika_internal_parse_directive_DirectiveParsers$().hoconReference__F3__F1__Llaika_parse_text_PrefixedParser(new $c_sjsr_AnonFunction3(((_$2, _$3, _$4) => {
    var _$2$1 = $as_Llaika_api_config_Key(_$2);
    var _$3$1 = $uZ(_$3);
    var _$4$1 = $as_Llaika_parse_SourceFragment(_$4);
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    return new $c_Llaika_ast_MarkupContextReference(_$2$1, _$3$1, _$4$1, options);
  })), new $c_sjsr_AnonFunction1(((x) => {
    var x$1 = $as_Llaika_ast_InvalidSpan(x);
    return x$1;
  }))));
}
$c_Llaika_internal_parse_directive_SpanDirectiveParsers$.prototype = new $h_O();
$c_Llaika_internal_parse_directive_SpanDirectiveParsers$.prototype.constructor = $c_Llaika_internal_parse_directive_SpanDirectiveParsers$;
/** @constructor */
function $h_Llaika_internal_parse_directive_SpanDirectiveParsers$() {
}
$h_Llaika_internal_parse_directive_SpanDirectiveParsers$.prototype = $c_Llaika_internal_parse_directive_SpanDirectiveParsers$.prototype;
$c_Llaika_internal_parse_directive_SpanDirectiveParsers$.prototype.spanDirective__sci_Map__Llaika_api_bundle_SpanParserBuilder = (function(directives) {
  var factory = new $c_sjsr_AnonFunction1(((rec) => {
    var rec$1 = $as_Llaika_parse_markup_RecursiveSpanParsers(rec);
    return this.spanDirectiveParser__sci_Map__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_text_PrefixedParser(directives, rec$1);
  }));
  return new $c_Llaika_api_bundle_SpanParserBuilder(factory, true, $m_Llaika_api_bundle_Precedence$High$());
});
$c_Llaika_internal_parse_directive_SpanDirectiveParsers$.prototype.spanDirectiveParser__sci_Map__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_text_PrefixedParser = (function(directives, recParsers) {
  var this$1 = $n(directives);
  var this$3 = new $c_sc_MapOps$$anon$1(this$1);
  var f = new $c_sjsr_AnonFunction1(((_$5) => {
    var _$5$1 = $as_Llaika_api_bundle_DirectiveBuilderContext$Directive(_$5);
    return $n(_$5$1).separators__sci_Set();
  }));
  var this$4 = $n($as_sc_IterableOnceOps($f_sc_IterableOps__flatMap__F1__O(this$3, f)));
  var separators = $m_sci_Set$().from__sc_IterableOnce__sci_Set($as_sc_IterableOnce(this$4));
  var body = new $c_sjsr_AnonFunction1(((spec) => {
    var spec$1 = $as_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec(spec);
    var this$5 = $n($n(directives).get__O__s_Option($n(spec$1).Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec__f_name));
    if ((!this$5.isEmpty__Z())) {
      var arg1 = this$5.get__O();
      var _$6 = $as_Llaika_api_bundle_DirectiveBuilderContext$Directive(arg1);
      var $x_1 = $n(_$6).hasBody__Z();
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var this$7 = $n(recParsers);
      var this$6 = $m_Llaika_parse_builders$();
      var str = $n(spec$1).Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec__f_fence;
      var p = $f_Llaika_parse_text_TextParsers__delimitedBy__T__Llaika_parse_text_DelimitedText(this$6, str);
      var p$1 = $n($as_Llaika_parse_Parser($f_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers__recursiveSpans__Llaika_parse_text_DelimitedText__Llaika_parse_markup_InlineParser(this$7, p))).source__Llaika_parse_Parser();
      var this$14 = $n($n($m_Llaika_parse_syntax$StringParserOps$().line$extension__Llaika_parse_Parser__Llaika_parse_Parser(p$1)).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((src) => {
        var src$1 = $as_Llaika_parse_LineSource(src);
        var $x_2 = $m_sc_StringOps$();
        var x = $n(src$1).Llaika_parse_LineSource__f_input;
        var this$10 = $n($n(spec$1).Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec__f_fence);
        var input = $n($x_2).dropRight$extension__T__I__T(x, this$10.length);
        var parent = $n(src$1).parent__Llaika_parse_SourceCursor();
        var value = new $c_Llaika_parse_LineSource(input, parent, 0, $n(parent).nestLevel__I());
        return new $c_s_Some(value);
      }))));
      var p$2 = new $c_sjsr_AnonFunction0((() => {
        var this$13 = $m_Llaika_parse_builders$();
        var v = $m_s_None$();
        return $f_Llaika_parse_combinator_Parsers__success__O__Llaika_parse_Parser(this$13, v);
      }));
      return this$14.orElse__F0__Llaika_parse_Parser(p$2);
    } else {
      var this$15 = $m_Llaika_parse_builders$();
      var v$1 = $m_s_None$();
      return $f_Llaika_parse_combinator_Parsers__success__O__Llaika_parse_Parser(this$15, v$1);
    }
  }));
  var this$25 = $m_Llaika_parse_text_PrefixedParser$();
  var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
  var p$3 = $n($n($m_Llaika_internal_parse_directive_DirectiveParsers$().directiveParser__F1__Z__Llaika_parse_Parser(body, ($m_Llaika_internal_parse_directive_DirectiveParsers$(), false))).withCursor__Llaika_parse_Parser()).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    matchResult16: {
      var $x_3;
      if ((x$1$1 !== null)) {
        var res = $as_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective($n(x$1$1)._1__O());
        var source = $as_Llaika_parse_SourceFragment($n(x$1$1)._2__O());
        if ($n(separators).contains__O__Z($n(res).Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_name)) {
          var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
          var $x_3 = new $c_Llaika_api_bundle_SpanDirectives$SeparatorInstance(res, source, options);
          break matchResult16;
        } else {
          var directive = $n(directives).get__O__s_Option($n(res).Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_name);
          var rewriteRules = new $c_Llaika_ast_RewriteRules($m_sci_Nil$(), $m_sci_Nil$(), $m_sci_Nil$());
          var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
          var $x_3 = new $c_Llaika_api_bundle_SpanDirectives$DirectiveInstance(directive, res, recParsers, source, rewriteRules, options$1);
          break matchResult16;
        }
      }
      throw new $c_s_MatchError(x$1$1);
    }
    return $as_Llaika_api_bundle_DirectiveBuilderContext$DirectiveProcessor($x_3);
  })));
  return new $c_Llaika_parse_text_PrefixedParser$$anon$2(64, chars, p$3, this$25);
});
var $d_Llaika_internal_parse_directive_SpanDirectiveParsers$ = new $TypeData().initClass($c_Llaika_internal_parse_directive_SpanDirectiveParsers$, "laika.internal.parse.directive.SpanDirectiveParsers$", ({
  Llaika_internal_parse_directive_SpanDirectiveParsers$: 1
}));
var $n_Llaika_internal_parse_directive_SpanDirectiveParsers$;
function $m_Llaika_internal_parse_directive_SpanDirectiveParsers$() {
  if ((!$n_Llaika_internal_parse_directive_SpanDirectiveParsers$)) {
    $n_Llaika_internal_parse_directive_SpanDirectiveParsers$ = new $c_Llaika_internal_parse_directive_SpanDirectiveParsers$();
  }
  return $n_Llaika_internal_parse_directive_SpanDirectiveParsers$;
}
function $p_Llaika_internal_parse_hocon_ConfigResolver$__deepMerge$1__Llaika_api_config_Origin__Llaika_api_config_ConfigValue$ObjectValue__Llaika_api_config_ConfigValue$ObjectValue__Llaika_api_config_ConfigValue$ObjectValue($thiz, origin$1, o1, o2) {
  var this$1 = $n($n(o1).Llaika_api_config_ConfigValue$ObjectValue__f_values);
  var suffix = $n(o2).Llaika_api_config_ConfigValue$ObjectValue__f_values;
  var this$2 = $n($as_sc_IterableOps(this$1.appendedAll__sc_IterableOnce__O(suffix)));
  var m = $as_scm_Map($m_scm_Map$().empty__O());
  var it = this$2.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    var _$1 = $as_Llaika_api_config_Field(elem);
    var key = $n(_$1).Llaika_api_config_Field__f_key;
    var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0(((this$2) => (() => this$2.newSpecificBuilder__scm_Builder()))(this$2))));
    var this$3 = $n(bldr);
    this$3.addOne__O__scm_Growable(elem);
  }
  var this$4 = $m_sci_HashMap$();
  var result = this$4.sci_HashMap$__f_EmptyMap;
  var mapIt = $n(m).iterator__sc_Iterator();
  while ($n(mapIt).hasNext__Z()) {
    var x1 = $as_T2($n(mapIt).next__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = $n(x1)._1__O();
    var v = $as_scm_Builder($n(x1)._2__O());
    result = $n(result).updated__O__O__sci_HashMap(k, $n(v).result__O());
  }
  var map = result;
  var this$7 = $n(map);
  $m_sci_HashMap$();
  var b = new $c_sci_HashMapBuilder();
  var it$1 = this$7.iterator__sc_Iterator();
  while ($n(it$1).hasNext__Z()) {
    var arg1 = $n(it$1).next__O();
    var x$1 = $as_T2(arg1);
    matchResult2: {
      var elem$1___1;
      var elem$1___2;
      if ((x$1 !== null)) {
        var k$1 = $n(x$1)._1__O();
        var v$1 = $n(x$1)._2__O();
        var _$2 = $as_sci_Seq(v$1);
        var _2 = $as_sci_Seq($n(_$2).map__F1__O(new $c_sjsr_AnonFunction1(((_$3) => {
          var _$3$1 = $as_Llaika_api_config_Field(_$3);
          return $n(_$3$1).Llaika_api_config_Field__f_value;
        }))));
        var elem$1___1 = k$1;
        var elem$1___2 = _2;
        break matchResult2;
      }
      throw new $c_s_MatchError(x$1);
    }
    $p_sci_HashMapBuilder__ensureUnaliased__V(b);
    var x = elem$1___1;
    var h = $m_sr_Statics$().anyHash__O__I(x);
    var im = $m_sc_Hashing$().improve__I__I(h);
    b.update__sci_MapNode__O__O__I__I__I__V(b.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, elem$1___1, elem$1___2, h, im, 0);
  }
  var this$11 = $n(b.result__sci_HashMap());
  var resolvedFields = $as_sci_Seq($n($m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$11)).map__F1__O(new $c_sjsr_AnonFunction1(((x$1$1) => {
    var x$1$2 = $as_T2(x$1$1);
    if ((x$1$2 !== null)) {
      var name = $as_T($n(x$1$2)._1__O());
      var values = $as_sci_Seq($n(x$1$2)._2__O());
      var this$12 = $n(values);
      var op = new $c_sjsr_AnonFunction2(((v1, v2) => {
        var v1$1 = $as_Llaika_api_config_ConfigValue(v1);
        var v2$1 = $as_Llaika_api_config_ConfigValue(v2);
        return $p_Llaika_internal_parse_hocon_ConfigResolver$__merge$1__Llaika_api_config_Origin__Llaika_api_config_ConfigValue__Llaika_api_config_ConfigValue__Llaika_api_config_ConfigValue($thiz, origin$1, v1$1, v2$1);
      }));
      var value = $as_Llaika_api_config_ConfigValue(this$12.reduceLeft__F2__O(op));
      return new $c_Llaika_api_config_Field(name, value, origin$1);
    }
    throw new $c_s_MatchError(x$1$2);
  }))));
  var this$14 = $n(resolvedFields);
  var f = new $c_sjsr_AnonFunction1(((_$4) => {
    var _$4$1 = $as_Llaika_api_config_Field(_$4);
    return $n(_$4$1).Llaika_api_config_Field__f_key;
  }));
  var ord = $m_s_math_Ordering$String$();
  var values$1 = $as_sci_Seq($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$14, f, ord));
  return new $c_Llaika_api_config_ConfigValue$ObjectValue(values$1);
}
function $p_Llaika_internal_parse_hocon_ConfigResolver$__resolveValue$1__scm_Map__scm_Map__Llaika_api_config_Origin__sci_Map__scm_Map__Llaika_internal_parse_hocon_ObjectBuilderValue__scm_Set__Llaika_api_config_Config__Llaika_api_config_Key__Llaika_internal_parse_hocon_ConfigBuilderValue__s_Option($thiz, invalidPaths$6, startedObjects$4, origin$7, includes$4, resolvedFields$5, rootExpanded$4, activeFields$4, fallback$4, key, value) {
  if ((value instanceof $c_Llaika_internal_parse_hocon_ObjectBuilderValue)) {
    var o = $as_Llaika_internal_parse_hocon_ObjectBuilderValue(value);
    var value$1 = $p_Llaika_internal_parse_hocon_ConfigResolver$__resolveObject$1__scm_Map__Llaika_api_config_Origin__sci_Map__scm_Map__scm_Set__scm_Map__Llaika_internal_parse_hocon_ObjectBuilderValue__Llaika_api_config_Config__Llaika_internal_parse_hocon_ObjectBuilderValue__Llaika_api_config_Key__Llaika_api_config_ConfigValue$ObjectValue($thiz, startedObjects$4, origin$7, includes$4, invalidPaths$6, activeFields$4, resolvedFields$5, rootExpanded$4, fallback$4, o, key);
    return new $c_s_Some(value$1);
  }
  if ((value instanceof $c_Llaika_internal_parse_hocon_ArrayBuilderValue)) {
    var a = $as_Llaika_internal_parse_hocon_ArrayBuilderValue(value);
    var values = $as_sci_Seq($n($n(a).Llaika_internal_parse_hocon_ArrayBuilderValue__f_values).flatMap__F1__O(new $c_sjsr_AnonFunction1(((value$2) => {
      var value$3 = $as_Llaika_internal_parse_hocon_ConfigBuilderValue(value$2);
      return $p_Llaika_internal_parse_hocon_ConfigResolver$__resolveValue$1__scm_Map__scm_Map__Llaika_api_config_Origin__sci_Map__scm_Map__Llaika_internal_parse_hocon_ObjectBuilderValue__scm_Set__Llaika_api_config_Config__Llaika_api_config_Key__Llaika_internal_parse_hocon_ConfigBuilderValue__s_Option($thiz, invalidPaths$6, startedObjects$4, origin$7, includes$4, resolvedFields$5, rootExpanded$4, activeFields$4, fallback$4, key, value$3);
    }))));
    var value$4 = new $c_Llaika_api_config_ConfigValue$ArrayValue(values);
    return new $c_s_Some(value$4);
  }
  if ((value instanceof $c_Llaika_internal_parse_hocon_ResolvedBuilderValue)) {
    var r = $as_Llaika_internal_parse_hocon_ResolvedBuilderValue(value);
    var value$5 = $n(r).Llaika_internal_parse_hocon_ResolvedBuilderValue__f_value;
    return new $c_s_Some(value$5);
  }
  if ((value instanceof $c_Llaika_internal_parse_hocon_ValidStringValue)) {
    var s = $as_Llaika_internal_parse_hocon_ValidStringValue(value);
    var value$6 = $n(s).Llaika_internal_parse_hocon_ValidStringValue__f_value;
    var value$7 = new $c_Llaika_api_config_ConfigValue$StringValue(value$6);
    return new $c_s_Some(value$7);
  }
  if ((value instanceof $c_Llaika_internal_parse_hocon_ConcatValue)) {
    var c = $as_Llaika_internal_parse_hocon_ConcatValue(value);
    var this$8 = $n($as_sc_IterableOnceOps($n($n(c).Llaika_internal_parse_hocon_ConcatValue__f_allParts).flatMap__F1__O(new $c_sjsr_AnonFunction1(((part) => {
      var part$1 = $as_Llaika_internal_parse_hocon_ConcatPart(part);
      return $p_Llaika_internal_parse_hocon_ConfigResolver$__resolveConcatPart$1__scm_Map__scm_Map__Llaika_api_config_Origin__sci_Map__scm_Map__Llaika_internal_parse_hocon_ObjectBuilderValue__scm_Set__Llaika_api_config_Config__Llaika_api_config_Key__Llaika_internal_parse_hocon_ConcatPart__s_Option($thiz, invalidPaths$6, startedObjects$4, origin$7, includes$4, resolvedFields$5, rootExpanded$4, activeFields$4, fallback$4, key, part$1);
    })))));
    var op = new $c_sjsr_AnonFunction2(((v1, v2) => {
      var v1$1 = $as_Llaika_api_config_ConfigValue(v1);
      var v2$1 = $as_Llaika_api_config_ConfigValue(v2);
      return $p_Llaika_internal_parse_hocon_ConfigResolver$__concat$1__scm_Map__Llaika_api_config_Origin__Llaika_api_config_Key__Llaika_api_config_ConfigValue__Llaika_api_config_ConfigValue__Llaika_api_config_ConfigValue($thiz, invalidPaths$6, origin$7, key, v1$1, v2$1);
    }));
    return $f_sc_IterableOnceOps__reduceLeftOption__F2__s_Option(this$8, op);
  }
  if ((value instanceof $c_Llaika_internal_parse_hocon_MergedValue)) {
    var m = $as_Llaika_internal_parse_hocon_MergedValue(value);
    var values$1 = $as_sci_Seq($n($n(m).Llaika_internal_parse_hocon_MergedValue__f_values).reverse__O());
    return $p_Llaika_internal_parse_hocon_ConfigResolver$__loop$1__Llaika_api_config_Key__scm_Map__scm_Map__Llaika_api_config_Origin__sci_Map__scm_Map__Llaika_internal_parse_hocon_ObjectBuilderValue__scm_Set__Llaika_api_config_Config__sci_Seq__s_Option($thiz, key, invalidPaths$6, startedObjects$4, origin$7, includes$4, resolvedFields$5, rootExpanded$4, activeFields$4, fallback$4, values$1);
  }
  var x = $m_Llaika_internal_parse_hocon_SelfReference$();
  if ((x === value)) {
    return $m_s_None$();
  }
  if ((value instanceof $c_Llaika_internal_parse_hocon_InvalidStringValue)) {
    return $m_s_None$();
  }
  if ((value instanceof $c_Llaika_internal_parse_hocon_SubstitutionValue)) {
    var x$1 = $as_Llaika_internal_parse_hocon_SubstitutionValue(value);
    var this$10 = $n(x$1);
    var x11 = this$10.Llaika_internal_parse_hocon_SubstitutionValue__f_ref;
    var this$11 = $n(x$1);
    var x12 = this$11.Llaika_internal_parse_hocon_SubstitutionValue__f_optional;
    if (((x12 === true) && ((x11 === null) ? (key === null) : $n(x11).equals__O__Z(key)))) {
      return $m_s_None$();
    }
    var this$12 = $n($n(resolvedFields$5).get__O__s_Option(x11));
    var this$13 = $n((this$12.isEmpty__Z() ? $p_Llaika_internal_parse_hocon_ConfigResolver$__lookahead$1__Llaika_internal_parse_hocon_ObjectBuilderValue__scm_Map__scm_Set__scm_Map__Llaika_api_config_Config__scm_Map__Llaika_api_config_Origin__sci_Map__Llaika_api_config_Key__s_Option($thiz, rootExpanded$4, startedObjects$4, activeFields$4, invalidPaths$6, fallback$4, resolvedFields$5, origin$7, includes$4, x11) : this$12));
    if (this$13.isEmpty__Z()) {
      if ((!x12)) {
        var this$15 = $n(invalidPaths$6);
        var _2 = (("Missing required reference: '" + x11) + "'");
        var elem = new $c_T2(key, _2);
        this$15.addOne__O__scm_Growable(elem);
      }
      return $m_s_None$();
    } else {
      return this$13;
    }
  }
  return $m_s_None$();
}
function $p_Llaika_internal_parse_hocon_ConfigResolver$__loop$1__Llaika_api_config_Key__scm_Map__scm_Map__Llaika_api_config_Origin__sci_Map__scm_Map__Llaika_internal_parse_hocon_ObjectBuilderValue__scm_Set__Llaika_api_config_Config__sci_Seq__s_Option($thiz, key$5, invalidPaths$7, startedObjects$5, origin$8, includes$5, resolvedFields$6, rootExpanded$5, activeFields$5, fallback$5, values) {
  var values$tailLocal1 = values;
  while (true) {
    var _1 = $p_Llaika_internal_parse_hocon_ConfigResolver$__resolveValue$1__scm_Map__scm_Map__Llaika_api_config_Origin__sci_Map__scm_Map__Llaika_internal_parse_hocon_ObjectBuilderValue__scm_Set__Llaika_api_config_Config__Llaika_api_config_Key__Llaika_internal_parse_hocon_ConfigBuilderValue__s_Option($thiz, invalidPaths$7, startedObjects$5, origin$8, includes$5, resolvedFields$6, rootExpanded$5, activeFields$5, fallback$5, key$5, $as_Llaika_internal_parse_hocon_ConfigBuilderValue($n(values$tailLocal1).head__O()));
    var _2 = $n(values$tailLocal1).tail__O();
    var x24 = new $c_T2(_1, _2);
    var x38 = $as_s_Option(x24.T2__f__1);
    var x39 = $as_sci_Seq(x24.T2__f__2);
    if ((x38 instanceof $c_s_Some)) {
      var x41 = $as_Llaika_api_config_ConfigValue($n($as_s_Some(x38)).s_Some__f_value);
      if ((x41 instanceof $c_Llaika_api_config_ConfigValue$ObjectValue)) {
        var x42 = $as_Llaika_api_config_ConfigValue$ObjectValue(x41);
        var x = $m_sci_Nil$();
        if (x.equals__O__Z(x39)) {
          return new $c_s_Some(x42);
        }
        var x20 = $p_Llaika_internal_parse_hocon_ConfigResolver$__loop$1__Llaika_api_config_Key__scm_Map__scm_Map__Llaika_api_config_Origin__sci_Map__scm_Map__Llaika_internal_parse_hocon_ObjectBuilderValue__scm_Set__Llaika_api_config_Config__sci_Seq__s_Option($thiz, key$5, invalidPaths$7, startedObjects$5, origin$8, includes$5, resolvedFields$6, rootExpanded$5, activeFields$5, fallback$5, x39);
        if ((x20 instanceof $c_s_Some)) {
          var x22 = $as_Llaika_api_config_ConfigValue($n($as_s_Some(x20)).s_Some__f_value);
          if ((x22 instanceof $c_Llaika_api_config_ConfigValue$ObjectValue)) {
            var o2 = $as_Llaika_api_config_ConfigValue$ObjectValue(x22);
            var value = $p_Llaika_internal_parse_hocon_ConfigResolver$__merge$1__Llaika_api_config_Origin__Llaika_api_config_ConfigValue__Llaika_api_config_ConfigValue__Llaika_api_config_ConfigValue($thiz, origin$8, o2, x42);
            return new $c_s_Some(value);
          }
        }
        return new $c_s_Some(x42);
      }
      return new $c_s_Some(x41);
    }
    var x$3 = $m_s_None$();
    if ((x$3 === x38)) {
      var x$5 = $m_sci_Nil$();
      if (x$5.equals__O__Z(x39)) {
        return $m_s_None$();
      }
      values$tailLocal1 = x39;
      continue;
    }
    throw new $c_s_MatchError(x24);
  }
}
function $p_Llaika_internal_parse_hocon_ConfigResolver$__resolvedParent$1__Llaika_internal_parse_hocon_ObjectBuilderValue__scm_Map__Llaika_api_config_Key__s_Option($thiz, rootExpanded$7, startedObjects$7, current) {
  if ($n($n(current).Llaika_api_config_Key__f_segments).isEmpty__Z()) {
    var value = new $c_T2(rootExpanded$7, current);
    return new $c_s_Some(value);
  } else {
    var this$3 = $n(startedObjects$7);
    var matching = $as_sci_Seq($n($m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$3)).filter__F1__O(new $c_sjsr_AnonFunction1(((o) => {
      var o$1 = $as_T2(o);
      return $n(current).isChild__Llaika_api_config_Key__Z($as_Llaika_api_config_Key($n(o$1)._1__O()));
    }))));
    var this$5 = $n(matching);
    var f = new $c_sjsr_AnonFunction1(((_$5) => {
      var _$5$1 = $as_T2(_$5);
      return $n($n($as_Llaika_api_config_Key($n(_$5$1)._1__O())).Llaika_api_config_Key__f_segments).length__I();
    }));
    var ord = $m_s_math_Ordering$Int$();
    var sorted = $as_sci_Seq($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$5, f, ord));
    var this$6 = $n(sorted);
    var this$7 = $n($f_sc_IterableOps__lastOption__s_Option(this$6));
    if (this$7.isEmpty__Z()) {
      var $x_1 = $p_Llaika_internal_parse_hocon_ConfigResolver$__resolvedParent$1__Llaika_internal_parse_hocon_ObjectBuilderValue__scm_Map__Llaika_api_config_Key__s_Option($thiz, rootExpanded$7, startedObjects$7, $n(current).parent__Llaika_api_config_Key());
    } else {
      var arg1 = this$7.get__O();
      var x$1 = $as_T2(arg1);
      matchResult5: {
        var $x_1;
        if ((x$1 !== null)) {
          var commonPath = $as_Llaika_api_config_Key($n(x$1)._1__O());
          var obv = $as_Llaika_internal_parse_hocon_ObjectBuilderValue($n(x$1)._2__O());
          $m_Llaika_api_config_Key$();
          var $x_2 = $n(current).Llaika_api_config_Key__f_segments;
          var this$8 = $n($n(commonPath).Llaika_api_config_Key__f_segments);
          var segments = $as_sci_Seq($n($x_2).take__I__O(((1 + this$8.length__I()) | 0)));
          var _2 = new $c_Llaika_api_config_Key(segments);
          var value$1 = new $c_T2(obv, _2);
          var $x_1 = new $c_s_Some(value$1);
          break matchResult5;
        }
        throw new $c_s_MatchError(x$1);
      }
    }
    return $as_s_Option($x_1);
  }
}
function $p_Llaika_internal_parse_hocon_ConfigResolver$__lookahead$1__Llaika_internal_parse_hocon_ObjectBuilderValue__scm_Map__scm_Set__scm_Map__Llaika_api_config_Config__scm_Map__Llaika_api_config_Origin__sci_Map__Llaika_api_config_Key__s_Option($thiz, rootExpanded$6, startedObjects$6, activeFields$6, invalidPaths$8, fallback$6, resolvedFields$7, origin$9, includes$6, key) {
  if ($n(activeFields$6).contains__O__Z(key)) {
    var this$2 = $n(invalidPaths$8);
    var _2 = (("Circular Reference involving path '" + key) + "'");
    var elem = new $c_T2(key, _2);
    this$2.addOne__O__scm_Growable(elem);
    var value = $m_Llaika_api_config_ConfigValue$NullValue$();
    return new $c_s_Some(value);
  } else {
    var this$4 = $n($p_Llaika_internal_parse_hocon_ConfigResolver$__resolvedParent$1__Llaika_internal_parse_hocon_ObjectBuilderValue__scm_Map__Llaika_api_config_Key__s_Option($thiz, rootExpanded$6, startedObjects$6, key));
    if (this$4.isEmpty__Z()) {
      return $m_s_None$();
    } else {
      var arg1 = this$4.get__O();
      var x$1 = $as_T2(arg1);
      if ((x$1 !== null)) {
        var obj = $as_Llaika_internal_parse_hocon_ObjectBuilderValue($n(x$1)._1__O());
        var fieldPath = $as_Llaika_api_config_Key($n(x$1)._2__O());
        var this$6 = $n($n($n(obj).Llaika_internal_parse_hocon_ObjectBuilderValue__f_values).find__F1__s_Option(new $c_sjsr_AnonFunction1(((_$6) => {
          var _$6$1 = $as_Llaika_internal_parse_hocon_BuilderField(_$6);
          var x = $n(_$6$1).validKey__Llaika_api_config_Key();
          return ((x === null) ? (fieldPath === null) : $n(x).equals__O__Z(fieldPath));
        }))));
        if (this$6.isEmpty__Z()) {
          var $x_1 = $m_s_None$();
        } else {
          var arg1$1 = this$6.get__O();
          var _$7 = $as_Llaika_internal_parse_hocon_BuilderField(arg1$1);
          var $x_1 = new $c_s_Some($n(_$7).Llaika_internal_parse_hocon_BuilderField__f_value);
        }
        var this$7 = $n($x_1);
        if ((!this$7.isEmpty__Z())) {
          var arg1$2 = this$7.get__O();
          var _$8 = $as_Llaika_internal_parse_hocon_ConfigBuilderValue(arg1$2);
          $p_Llaika_internal_parse_hocon_ConfigResolver$__resolveField$1__scm_Set__scm_Map__scm_Map__scm_Map__Llaika_api_config_Origin__sci_Map__Llaika_internal_parse_hocon_ObjectBuilderValue__Llaika_api_config_Config__Llaika_api_config_Key__Llaika_internal_parse_hocon_ConfigBuilderValue__s_Option($thiz, activeFields$6, resolvedFields$7, invalidPaths$8, startedObjects$6, origin$9, includes$6, rootExpanded$6, fallback$6, fieldPath, _$8);
        }
        var this$8 = $n($n(resolvedFields$7).get__O__s_Option(key));
        return (this$8.isEmpty__Z() ? $n($n(fallback$6).get__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(key, $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_configValue)).toOption__s_Option() : this$8);
      }
      throw new $c_s_MatchError(x$1);
    }
  }
}
function $p_Llaika_internal_parse_hocon_ConfigResolver$__resolveConcatPart$1__scm_Map__scm_Map__Llaika_api_config_Origin__sci_Map__scm_Map__Llaika_internal_parse_hocon_ObjectBuilderValue__scm_Set__Llaika_api_config_Config__Llaika_api_config_Key__Llaika_internal_parse_hocon_ConcatPart__s_Option($thiz, invalidPaths$18, startedObjects$17, origin$20, includes$15, resolvedFields$17, rootExpanded$17, activeFields$15, fallback$16, key, part) {
  var x56 = $n(part).Llaika_internal_parse_hocon_ConcatPart__f_value;
  var x = $m_Llaika_internal_parse_hocon_SelfReference$();
  if ((x === x56)) {
    return $m_s_None$();
  }
  var x49 = $p_Llaika_internal_parse_hocon_ConfigResolver$__resolveValue$1__scm_Map__scm_Map__Llaika_api_config_Origin__sci_Map__scm_Map__Llaika_internal_parse_hocon_ObjectBuilderValue__scm_Set__Llaika_api_config_Config__Llaika_api_config_Key__Llaika_internal_parse_hocon_ConfigBuilderValue__s_Option($thiz, invalidPaths$18, startedObjects$17, origin$20, includes$15, resolvedFields$17, rootExpanded$17, activeFields$15, fallback$16, key, x56);
  if ((x49 instanceof $c_s_Some)) {
    var x54 = $as_Llaika_api_config_ConfigValue($n($as_s_Some(x49)).s_Some__f_value);
    if ($is_Llaika_api_config_ConfigValue$SimpleValue(x54)) {
      var simpleValue = $as_Llaika_api_config_ConfigValue$SimpleValue(x54);
      var value = (("" + $n(part).Llaika_internal_parse_hocon_ConcatPart__f_whitespace) + $n(simpleValue).render__T());
      var value$1 = new $c_Llaika_api_config_ConfigValue$StringValue(value);
      return new $c_s_Some(value$1);
    }
    if ((x54 instanceof $c_Llaika_api_config_ConfigValue$ASTValue)) {
      return $m_s_None$();
    }
  }
  return x49;
}
function $p_Llaika_internal_parse_hocon_ConfigResolver$__concat$1__scm_Map__Llaika_api_config_Origin__Llaika_api_config_Key__Llaika_api_config_ConfigValue__Llaika_api_config_ConfigValue__Llaika_api_config_ConfigValue($thiz, invalidPaths$11, origin$12, key, v1, v2) {
  if ((v1 instanceof $c_Llaika_api_config_ConfigValue$ObjectValue)) {
    var o1 = $as_Llaika_api_config_ConfigValue$ObjectValue(v1);
    if ((v2 instanceof $c_Llaika_api_config_ConfigValue$ObjectValue)) {
      var o2 = $as_Llaika_api_config_ConfigValue$ObjectValue(v2);
      return $p_Llaika_internal_parse_hocon_ConfigResolver$__deepMerge$1__Llaika_api_config_Origin__Llaika_api_config_ConfigValue$ObjectValue__Llaika_api_config_ConfigValue$ObjectValue__Llaika_api_config_ConfigValue$ObjectValue($thiz, origin$12, o1, o2);
    }
  }
  if ((v1 instanceof $c_Llaika_api_config_ConfigValue$ArrayValue)) {
    var a1 = $as_Llaika_api_config_ConfigValue$ArrayValue(v1);
    if ((v2 instanceof $c_Llaika_api_config_ConfigValue$ArrayValue)) {
      var a2 = $as_Llaika_api_config_ConfigValue$ArrayValue(v2);
      var this$2 = $n($n(a1).Llaika_api_config_ConfigValue$ArrayValue__f_values);
      var suffix = $n(a2).Llaika_api_config_ConfigValue$ArrayValue__f_values;
      var values = $as_sci_Seq(this$2.appendedAll__sc_IterableOnce__O(suffix));
      return new $c_Llaika_api_config_ConfigValue$ArrayValue(values);
    }
  }
  if ((v1 instanceof $c_Llaika_api_config_ConfigValue$StringValue)) {
    var s1 = $as_Llaika_api_config_ConfigValue$StringValue(v1);
    if ((v2 instanceof $c_Llaika_api_config_ConfigValue$StringValue)) {
      var s2 = $as_Llaika_api_config_ConfigValue$StringValue(v2);
      var x = $n(s1).Llaika_api_config_ConfigValue$StringValue__f_value;
      var xs = $n(s2).Llaika_api_config_ConfigValue$StringValue__f_value;
      var value = (("" + x) + xs);
      return new $c_Llaika_api_config_ConfigValue$StringValue(value);
    }
  }
  var x$1 = $m_Llaika_api_config_ConfigValue$NullValue$();
  if (((x$1 === v1) && (v2 instanceof $c_Llaika_api_config_ConfigValue$ArrayValue))) {
    var a2$2 = $as_Llaika_api_config_ConfigValue$ArrayValue(v2);
    return a2$2;
  }
  var this$9 = $n(invalidPaths$11);
  var elem = new $c_T2(key, "Invalid concatenation of values. It must contain either only objects, only arrays or only simple values");
  this$9.addOne__O__scm_Growable(elem);
  return $m_Llaika_api_config_ConfigValue$NullValue$();
}
function $p_Llaika_internal_parse_hocon_ConfigResolver$__merge$1__Llaika_api_config_Origin__Llaika_api_config_ConfigValue__Llaika_api_config_ConfigValue__Llaika_api_config_ConfigValue($thiz, origin$21, v1, v2) {
  if ((v1 instanceof $c_Llaika_api_config_ConfigValue$ObjectValue)) {
    var o1 = $as_Llaika_api_config_ConfigValue$ObjectValue(v1);
    if ((v2 instanceof $c_Llaika_api_config_ConfigValue$ObjectValue)) {
      var o2 = $as_Llaika_api_config_ConfigValue$ObjectValue(v2);
      return $p_Llaika_internal_parse_hocon_ConfigResolver$__deepMerge$1__Llaika_api_config_Origin__Llaika_api_config_ConfigValue$ObjectValue__Llaika_api_config_ConfigValue$ObjectValue__Llaika_api_config_ConfigValue$ObjectValue($thiz, origin$21, o1, o2);
    }
  }
  return v2;
}
function $p_Llaika_internal_parse_hocon_ConfigResolver$__resolveField$1__scm_Set__scm_Map__scm_Map__scm_Map__Llaika_api_config_Origin__sci_Map__Llaika_internal_parse_hocon_ObjectBuilderValue__Llaika_api_config_Config__Llaika_api_config_Key__Llaika_internal_parse_hocon_ConfigBuilderValue__s_Option($thiz, activeFields$9, resolvedFields$10, invalidPaths$12, startedObjects$11, origin$13, includes$9, rootExpanded$11, fallback$10, key, value) {
  var this$1 = $n($n(resolvedFields$10).get__O__s_Option(key));
  if (this$1.isEmpty__Z()) {
    var this$2 = $n(activeFields$9);
    this$2.addOne__O__scm_Growable(key);
    var res = $p_Llaika_internal_parse_hocon_ConfigResolver$__resolveValue$1__scm_Map__scm_Map__Llaika_api_config_Origin__sci_Map__scm_Map__Llaika_internal_parse_hocon_ObjectBuilderValue__scm_Set__Llaika_api_config_Config__Llaika_api_config_Key__Llaika_internal_parse_hocon_ConfigBuilderValue__s_Option($thiz, invalidPaths$12, startedObjects$11, origin$13, includes$9, resolvedFields$10, rootExpanded$11, activeFields$9, fallback$10, key, value);
    var this$3 = $n(activeFields$9);
    this$3.subtractOne__O__scm_Shrinkable(key);
    var this$4 = $n(res);
    if ((!this$4.isEmpty__Z())) {
      var arg1 = this$4.get__O();
      var resolved = $as_Llaika_api_config_ConfigValue(arg1);
      var this$6 = $n(resolvedFields$10);
      var elem = new $c_T2(key, resolved);
      $as_scm_Map(this$6.addOne__O__scm_Growable(elem));
    }
    return res;
  } else {
    return this$1;
  }
}
function $p_Llaika_internal_parse_hocon_ConfigResolver$__resolve$1__Llaika_api_config_Origin__scm_Set__scm_Map__scm_Map__scm_Map__sci_Map__Llaika_internal_parse_hocon_ObjectBuilderValue__Llaika_api_config_Config__Llaika_internal_parse_hocon_BuilderField__s_Option($thiz, origin$17, activeFields$12, resolvedFields$14, invalidPaths$15, startedObjects$14, includes$12, rootExpanded$14, fallback$13, field) {
  var this$1 = $n($p_Llaika_internal_parse_hocon_ConfigResolver$__resolveField$1__scm_Set__scm_Map__scm_Map__scm_Map__Llaika_api_config_Origin__sci_Map__Llaika_internal_parse_hocon_ObjectBuilderValue__Llaika_api_config_Config__Llaika_api_config_Key__Llaika_internal_parse_hocon_ConfigBuilderValue__s_Option($thiz, activeFields$12, resolvedFields$14, invalidPaths$15, startedObjects$14, origin$17, includes$12, rootExpanded$14, fallback$13, $n(field).validKey__Llaika_api_config_Key(), $n(field).Llaika_internal_parse_hocon_BuilderField__f_value));
  if (this$1.isEmpty__Z()) {
    return $m_s_None$();
  } else {
    var arg1 = this$1.get__O();
    var _$9 = $as_Llaika_api_config_ConfigValue(arg1);
    var key = $n($n($n(field).validKey__Llaika_api_config_Key()).local__Llaika_api_config_Key()).toString__T();
    return new $c_s_Some(new $c_Llaika_api_config_Field(key, _$9, origin$17));
  }
}
function $p_Llaika_internal_parse_hocon_ConfigResolver$__resolveObject$1__scm_Map__Llaika_api_config_Origin__sci_Map__scm_Map__scm_Set__scm_Map__Llaika_internal_parse_hocon_ObjectBuilderValue__Llaika_api_config_Config__Llaika_internal_parse_hocon_ObjectBuilderValue__Llaika_api_config_Key__Llaika_api_config_ConfigValue$ObjectValue($thiz, startedObjects$13, origin$15, includes$11, invalidPaths$14, activeFields$11, resolvedFields$13, rootExpanded$13, fallback$12, obj, key) {
  var this$2 = $n(startedObjects$13);
  var elem = new $c_T2(key, obj);
  this$2.addOne__O__scm_Growable(elem);
  var resolvedFields = $as_sci_Seq($n($n(obj).Llaika_internal_parse_hocon_ObjectBuilderValue__f_values).flatMap__F1__O(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Llaika_internal_parse_hocon_BuilderField(x$1);
    matchResult12: {
      var $x_1;
      if ((x$1$1 !== null)) {
        var this$5 = $n(x$1$1);
        var this$6 = $n(x$1$1);
        var x92 = this$6.Llaika_internal_parse_hocon_BuilderField__f_value;
        if ((x92 instanceof $c_Llaika_internal_parse_hocon_IncludeBuilderValue)) {
          var x$1$2 = $as_Llaika_internal_parse_hocon_IncludeBuilderValue(x92);
          var this$8 = $n(x$1$2);
          var x95 = this$8.Llaika_internal_parse_hocon_IncludeBuilderValue__f_resource;
          var x80 = $n(includes$11).get__O__s_Option(x95);
          var x = $m_s_None$();
          if ((x === x80)) {
            if ($n(x95).isRequired__Z()) {
              var this$10 = $n(invalidPaths$14);
              var _2 = (("Missing required include '" + $n($n(x95).resourceId__Llaika_internal_parse_hocon_StringBuilderValue()).value__T()) + "'");
              var elem$1 = new $c_T2(key, _2);
              this$10.addOne__O__scm_Growable(elem$1);
            }
            var $x_1 = $m_sci_Nil$();
            break matchResult12;
          }
          if ((x80 instanceof $c_s_Some)) {
            var x86 = $as_s_util_Either($n($as_s_Some(x80)).s_Some__f_value);
            if ((x86 instanceof $c_s_util_Left)) {
              var error = $as_Llaika_api_config_ConfigError($n($as_s_util_Left(x86)).s_util_Left__f_value);
              var this$12 = $n(invalidPaths$14);
              var _2$1 = ((("Error including '" + $n($n(x95).resourceId__Llaika_internal_parse_hocon_StringBuilderValue()).value__T()) + "': ") + $n(error).message__T());
              var elem$2 = new $c_T2(key, _2$1);
              this$12.addOne__O__scm_Growable(elem$2);
              var $x_1 = $m_sci_Nil$();
              break matchResult12;
            }
            if ((x86 instanceof $c_s_util_Right)) {
              var included = $as_Llaika_internal_parse_hocon_ObjectBuilderValue($n($as_s_util_Right(x86)).s_util_Right__f_value);
              var $x_1 = $n($p_Llaika_internal_parse_hocon_ConfigResolver$__resolveObject$1__scm_Map__Llaika_api_config_Origin__sci_Map__scm_Map__scm_Set__scm_Map__Llaika_internal_parse_hocon_ObjectBuilderValue__Llaika_api_config_Config__Llaika_internal_parse_hocon_ObjectBuilderValue__Llaika_api_config_Key__Llaika_api_config_ConfigValue$ObjectValue($thiz, startedObjects$13, origin$15, includes$11, invalidPaths$14, activeFields$11, resolvedFields$13, rootExpanded$13, fallback$12, included, key)).Llaika_api_config_ConfigValue$ObjectValue__f_values;
              break matchResult12;
            }
          }
          throw new $c_s_MatchError(x80);
        }
      }
      var $x_1 = $p_Llaika_internal_parse_hocon_ConfigResolver$__resolve$1__Llaika_api_config_Origin__scm_Set__scm_Map__scm_Map__scm_Map__sci_Map__Llaika_internal_parse_hocon_ObjectBuilderValue__Llaika_api_config_Config__Llaika_internal_parse_hocon_BuilderField__s_Option($thiz, origin$15, activeFields$11, resolvedFields$13, invalidPaths$14, startedObjects$13, includes$11, rootExpanded$13, fallback$12, x$1$1);
    }
    return $as_sc_IterableOnce($x_1);
  }))));
  var this$13 = $n(resolvedFields);
  var f = new $c_sjsr_AnonFunction1(((_$10) => {
    var _$10$1 = $as_Llaika_api_config_Field(_$10);
    return $n(_$10$1).Llaika_api_config_Field__f_key;
  }));
  var ord = $m_s_math_Ordering$String$();
  var values = $as_sci_Seq($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$13, f, ord));
  return new $c_Llaika_api_config_ConfigValue$ObjectValue(values);
}
function $p_Llaika_internal_parse_hocon_ConfigResolver$__resolve$2__Llaika_internal_parse_hocon_ConfigBuilderValue__Llaika_api_config_Key__Llaika_internal_parse_hocon_ConfigBuilderValue__Llaika_internal_parse_hocon_ConfigBuilderValue($thiz, parent$1, key$11, value) {
  var x = $m_Llaika_internal_parse_hocon_SelfReference$();
  if ((x === value)) {
    return parent$1;
  }
  if ((value instanceof $c_Llaika_internal_parse_hocon_SubstitutionValue)) {
    var x$1 = $as_Llaika_internal_parse_hocon_SubstitutionValue(value);
    var this$2 = $n(x$1);
    var x105 = this$2.Llaika_internal_parse_hocon_SubstitutionValue__f_ref;
    var this$3 = $n(x$1);
    if (((x105 === null) ? (key$11 === null) : $n(x105).equals__O__Z(key$11))) {
      return parent$1;
    }
  }
  return value;
}
function $p_Llaika_internal_parse_hocon_ConfigResolver$__resolveSelfReference$1__Llaika_api_config_Key__Llaika_internal_parse_hocon_ConcatValue__Llaika_internal_parse_hocon_ConfigBuilderValue__Llaika_internal_parse_hocon_ConfigBuilderValue($thiz, key, value, parent) {
  var first = $p_Llaika_internal_parse_hocon_ConfigResolver$__resolve$2__Llaika_internal_parse_hocon_ConfigBuilderValue__Llaika_api_config_Key__Llaika_internal_parse_hocon_ConfigBuilderValue__Llaika_internal_parse_hocon_ConfigBuilderValue($thiz, parent, key, $n(value).Llaika_internal_parse_hocon_ConcatValue__f_first);
  var rest = $as_sci_Seq($n($n(value).Llaika_internal_parse_hocon_ConcatValue__f_rest).map__F1__O(new $c_sjsr_AnonFunction1(((p) => {
    var p$1 = $as_Llaika_internal_parse_hocon_ConcatPart(p);
    var value$1 = $p_Llaika_internal_parse_hocon_ConfigResolver$__resolve$2__Llaika_internal_parse_hocon_ConfigBuilderValue__Llaika_api_config_Key__Llaika_internal_parse_hocon_ConfigBuilderValue__Llaika_internal_parse_hocon_ConfigBuilderValue($thiz, parent, key, $n(p$1).Llaika_internal_parse_hocon_ConcatPart__f_value);
    var this$2 = $n(p$1);
    var whitespace$1 = this$2.Llaika_internal_parse_hocon_ConcatPart__f_whitespace;
    $n(p$1);
    return new $c_Llaika_internal_parse_hocon_ConcatPart(whitespace$1, value$1);
  }))));
  var resolved = new $c_Llaika_internal_parse_hocon_ConcatValue(first, rest);
  if (resolved.equals__O__Z(value)) {
    var values = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_internal_parse_hocon_ConfigBuilderValue.getArrayOf().constr)([parent, value]))));
    return new $c_Llaika_internal_parse_hocon_MergedValue(values);
  } else {
    return resolved;
  }
}
function $p_Llaika_internal_parse_hocon_ConfigResolver$__mergeValues$1__Llaika_api_config_Key__Llaika_internal_parse_hocon_ConfigBuilderValue__Llaika_internal_parse_hocon_ConfigBuilderValue__Llaika_internal_parse_hocon_ConfigBuilderValue($thiz, key, cbv1, cbv2) {
  if ((cbv1 instanceof $c_Llaika_internal_parse_hocon_ObjectBuilderValue)) {
    var o1 = $as_Llaika_internal_parse_hocon_ObjectBuilderValue(cbv1);
    if ((cbv2 instanceof $c_Llaika_internal_parse_hocon_ObjectBuilderValue)) {
      var o2 = $as_Llaika_internal_parse_hocon_ObjectBuilderValue(cbv2);
      var this$2 = $n($n(o1).Llaika_internal_parse_hocon_ObjectBuilderValue__f_values);
      var suffix = $n(o2).Llaika_internal_parse_hocon_ObjectBuilderValue__f_values;
      var values = $as_sci_Seq(this$2.appendedAll__sc_IterableOnce__O(suffix));
      return $thiz.mergeObjects__Llaika_internal_parse_hocon_ObjectBuilderValue__Llaika_internal_parse_hocon_ObjectBuilderValue(new $c_Llaika_internal_parse_hocon_ObjectBuilderValue(values));
    }
  }
  var x = $m_Llaika_internal_parse_hocon_SelfReference$();
  if ((x === cbv2)) {
    return cbv1;
  }
  if ((cbv2 instanceof $c_Llaika_internal_parse_hocon_SubstitutionValue)) {
    var x$1 = $as_Llaika_internal_parse_hocon_SubstitutionValue(cbv2);
    var this$5 = $n(x$1);
    var x131 = this$5.Llaika_internal_parse_hocon_SubstitutionValue__f_ref;
    var this$6 = $n(x$1);
    if (((x131 === null) ? (key === null) : $n(x131).equals__O__Z(key))) {
      return cbv1;
    }
  }
  if ((cbv2 instanceof $c_Llaika_internal_parse_hocon_ResolvedBuilderValue)) {
    var r2 = $as_Llaika_internal_parse_hocon_ResolvedBuilderValue(cbv2);
    return r2;
  }
  if ((cbv2 instanceof $c_Llaika_internal_parse_hocon_ArrayBuilderValue)) {
    var a2 = $as_Llaika_internal_parse_hocon_ArrayBuilderValue(cbv2);
    return a2;
  }
  if ((cbv2 instanceof $c_Llaika_internal_parse_hocon_ObjectBuilderValue)) {
    var o2$2 = $as_Llaika_internal_parse_hocon_ObjectBuilderValue(cbv2);
    return o2$2;
  }
  if ((cbv2 instanceof $c_Llaika_internal_parse_hocon_ConcatValue)) {
    var c2 = $as_Llaika_internal_parse_hocon_ConcatValue(cbv2);
    return $p_Llaika_internal_parse_hocon_ConfigResolver$__resolveSelfReference$1__Llaika_api_config_Key__Llaika_internal_parse_hocon_ConcatValue__Llaika_internal_parse_hocon_ConfigBuilderValue__Llaika_internal_parse_hocon_ConfigBuilderValue($thiz, key, c2, cbv1);
  }
  if ((cbv1 instanceof $c_Llaika_internal_parse_hocon_MergedValue)) {
    var x$1$1 = $as_Llaika_internal_parse_hocon_MergedValue(cbv1);
    var this$8 = $n(x$1$1);
    var x114 = this$8.Llaika_internal_parse_hocon_MergedValue__f_values;
    var this$9 = $n(x114);
    var values$1 = $as_sci_Seq(this$9.appended__O__O(cbv2));
    return new $c_Llaika_internal_parse_hocon_MergedValue(values$1);
  }
  var values$2 = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_internal_parse_hocon_ConfigBuilderValue.getArrayOf().constr)([cbv1, cbv2]))));
  return new $c_Llaika_internal_parse_hocon_MergedValue(values$2);
}
function $p_Llaika_internal_parse_hocon_ConfigResolver$__expandValue$1__Llaika_internal_parse_hocon_ConfigBuilderValue__Llaika_api_config_Key__Llaika_internal_parse_hocon_ConfigBuilderValue($thiz, value, child) {
  if ((value instanceof $c_Llaika_internal_parse_hocon_ObjectBuilderValue)) {
    var o = $as_Llaika_internal_parse_hocon_ObjectBuilderValue(value);
    return $thiz.expandPaths__Llaika_internal_parse_hocon_ObjectBuilderValue__Llaika_api_config_Key__Llaika_internal_parse_hocon_ObjectBuilderValue(o, child);
  } else if ((value instanceof $c_Llaika_internal_parse_hocon_ArrayBuilderValue)) {
    var a = $as_Llaika_internal_parse_hocon_ArrayBuilderValue(value);
    var expandedElements = $as_sci_Seq($n($as_sc_IterableOps($n($n(a).Llaika_internal_parse_hocon_ArrayBuilderValue__f_values).zipWithIndex__O())).map__F1__O(new $c_sjsr_AnonFunction1(((x$1) => {
      var x$1$1 = $as_T2(x$1);
      if ((x$1$1 !== null)) {
        var element = $as_Llaika_internal_parse_hocon_ConfigBuilderValue($n(x$1$1)._1__O());
        var index = $uI($n(x$1$1)._2__O());
        return $p_Llaika_internal_parse_hocon_ConfigResolver$__expandValue$1__Llaika_internal_parse_hocon_ConfigBuilderValue__Llaika_api_config_Key__Llaika_internal_parse_hocon_ConfigBuilderValue($thiz, element, $n(child).child__T__Llaika_api_config_Key(("" + index)));
      }
      throw new $c_s_MatchError(x$1$1);
    }))));
    return new $c_Llaika_internal_parse_hocon_ArrayBuilderValue(expandedElements);
  } else if ((value instanceof $c_Llaika_internal_parse_hocon_ConcatValue)) {
    var c = $as_Llaika_internal_parse_hocon_ConcatValue(value);
    $n(c);
    var first = $p_Llaika_internal_parse_hocon_ConfigResolver$__expandValue$1__Llaika_internal_parse_hocon_ConfigBuilderValue__Llaika_api_config_Key__Llaika_internal_parse_hocon_ConfigBuilderValue($thiz, $n(c).Llaika_internal_parse_hocon_ConcatValue__f_first, child);
    var rest = $as_sci_Seq($n($n(c).Llaika_internal_parse_hocon_ConcatValue__f_rest).map__F1__O(new $c_sjsr_AnonFunction1(((part) => {
      var part$1 = $as_Llaika_internal_parse_hocon_ConcatPart(part);
      var value$2 = $p_Llaika_internal_parse_hocon_ConfigResolver$__expandValue$1__Llaika_internal_parse_hocon_ConfigBuilderValue__Llaika_api_config_Key__Llaika_internal_parse_hocon_ConfigBuilderValue($thiz, $n(part$1).Llaika_internal_parse_hocon_ConcatPart__f_value, child);
      var this$4 = $n(part$1);
      var whitespace$2 = this$4.Llaika_internal_parse_hocon_ConcatPart__f_whitespace;
      $n(part$1);
      return new $c_Llaika_internal_parse_hocon_ConcatPart(whitespace$2, value$2);
    }))));
    return new $c_Llaika_internal_parse_hocon_ConcatValue(first, rest);
  } else {
    return value;
  }
}
function $p_Llaika_internal_parse_hocon_ConfigResolver$__wrap$1__T__T__Llaika_parse_Failure__sci_Seq($thiz, parentPath$2, field$2, failure) {
  var this$1 = $n(parentPath$2);
  if ((this$1 === "")) {
    var fieldName = field$2;
  } else {
    var fieldName = ((parentPath$2 + ".") + field$2);
  }
  return $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_config_ConfigError$InvalidField.getArrayOf().constr)([new $c_Llaika_api_config_ConfigError$InvalidField(fieldName, failure)]))));
}
function $p_Llaika_internal_parse_hocon_ConfigResolver$__extract$1__T__T__Llaika_internal_parse_hocon_ConfigBuilderValue__sci_Seq($thiz, parentPath$1, field, value) {
  if ((value instanceof $c_Llaika_internal_parse_hocon_InvalidStringValue)) {
    var x$1 = $as_Llaika_internal_parse_hocon_InvalidStringValue(value);
    var this$2 = $n(x$1);
    var this$3 = $n(x$1);
    var x193 = this$3.Llaika_internal_parse_hocon_InvalidStringValue__f_failure;
    return $p_Llaika_internal_parse_hocon_ConfigResolver$__wrap$1__T__T__Llaika_parse_Failure__sci_Seq($thiz, parentPath$1, field, x193);
  }
  if ((value instanceof $c_Llaika_internal_parse_hocon_InvalidBuilderValue)) {
    var x$1$1 = $as_Llaika_internal_parse_hocon_InvalidBuilderValue(value);
    var this$5 = $n(x$1$1);
    var x185 = this$5.Llaika_internal_parse_hocon_InvalidBuilderValue__f_value;
    var this$6 = $n(x$1$1);
    var x186 = this$6.Llaika_internal_parse_hocon_InvalidBuilderValue__f_failure;
    if ((x185 instanceof $c_Llaika_internal_parse_hocon_ArrayBuilderValue)) {
      var x$1$2 = $as_Llaika_internal_parse_hocon_ArrayBuilderValue(x185);
      var this$8 = $n(x$1$2);
      var x189 = this$8.Llaika_internal_parse_hocon_ArrayBuilderValue__f_values;
      var nested = $as_sci_Seq($n($as_sc_IterableOps($n(x189).zipWithIndex__O())).flatMap__F1__O(new $c_sjsr_AnonFunction1(((x$1$3) => {
        var x$1$4 = $as_T2(x$1$3);
        if ((x$1$4 !== null)) {
          var arrValue = $as_Llaika_internal_parse_hocon_ConfigBuilderValue($n(x$1$4)._1__O());
          var index = $uI($n(x$1$4)._2__O());
          return $p_Llaika_internal_parse_hocon_ConfigResolver$__extract$1__T__T__Llaika_internal_parse_hocon_ConfigBuilderValue__sci_Seq($thiz, parentPath$1, ((field + ".") + index), arrValue);
        }
        throw new $c_s_MatchError(x$1$4);
      }))));
      return ($n(nested).isEmpty__Z() ? $p_Llaika_internal_parse_hocon_ConfigResolver$__wrap$1__T__T__Llaika_parse_Failure__sci_Seq($thiz, parentPath$1, field, x186) : nested);
    }
    if ((x185 instanceof $c_Llaika_internal_parse_hocon_ObjectBuilderValue)) {
      var obv = $as_Llaika_internal_parse_hocon_ObjectBuilderValue(x185);
      var nested$2 = $thiz.extractErrors__Llaika_internal_parse_hocon_ObjectBuilderValue__T__sci_Seq(obv, "");
      return ($n(nested$2).isEmpty__Z() ? $p_Llaika_internal_parse_hocon_ConfigResolver$__wrap$1__T__T__Llaika_parse_Failure__sci_Seq($thiz, parentPath$1, field, x186) : nested$2);
    }
    return $p_Llaika_internal_parse_hocon_ConfigResolver$__wrap$1__T__T__Llaika_parse_Failure__sci_Seq($thiz, parentPath$1, field, x186);
  }
  if ((value instanceof $c_Llaika_internal_parse_hocon_IncludeBuilderValue)) {
    var incl = $as_Llaika_internal_parse_hocon_IncludeBuilderValue(value);
    var x161 = $n($n(incl).Llaika_internal_parse_hocon_IncludeBuilderValue__f_resource).resourceId__Llaika_internal_parse_hocon_StringBuilderValue();
    if ((x161 instanceof $c_Llaika_internal_parse_hocon_InvalidStringValue)) {
      var x$1$5 = $as_Llaika_internal_parse_hocon_InvalidStringValue(x161);
      var this$11 = $n(x$1$5);
      var this$12 = $n(x$1$5);
      var x165 = this$12.Llaika_internal_parse_hocon_InvalidStringValue__f_failure;
      return $p_Llaika_internal_parse_hocon_ConfigResolver$__wrap$1__T__T__Llaika_parse_Failure__sci_Seq($thiz, parentPath$1, field, x165);
    }
    return $m_sci_Nil$();
  }
  if ((value instanceof $c_Llaika_internal_parse_hocon_ObjectBuilderValue)) {
    var child = $as_Llaika_internal_parse_hocon_ObjectBuilderValue(value);
    var this$13 = $n(parentPath$1);
    if ((this$13 === "")) {
      var fieldName = field;
    } else {
      var fieldName = ((parentPath$1 + ".") + field);
    }
    return $thiz.extractErrors__Llaika_internal_parse_hocon_ObjectBuilderValue__T__sci_Seq(child, fieldName);
  }
  if ((value instanceof $c_Llaika_internal_parse_hocon_ArrayBuilderValue)) {
    var child$2 = $as_Llaika_internal_parse_hocon_ArrayBuilderValue(value);
    return $as_sci_Seq($n($as_sc_IterableOps($n($n(child$2).Llaika_internal_parse_hocon_ArrayBuilderValue__f_values).zipWithIndex__O())).flatMap__F1__O(new $c_sjsr_AnonFunction1(((x$1$2$1) => {
      var x$1$6 = $as_T2(x$1$2$1);
      if ((x$1$6 !== null)) {
        var arrValue$1 = $as_Llaika_internal_parse_hocon_ConfigBuilderValue($n(x$1$6)._1__O());
        var index$1 = $uI($n(x$1$6)._2__O());
        return $p_Llaika_internal_parse_hocon_ConfigResolver$__extract$1__T__T__Llaika_internal_parse_hocon_ConfigBuilderValue__sci_Seq($thiz, parentPath$1, ((field + ".") + index$1), arrValue$1);
      }
      throw new $c_s_MatchError(x$1$6);
    }))));
  }
  if ((value instanceof $c_Llaika_internal_parse_hocon_ConcatValue)) {
    var concat = $as_Llaika_internal_parse_hocon_ConcatValue(value);
    var this$14 = $n($as_sc_SeqOps($n($n(concat).Llaika_internal_parse_hocon_ConcatValue__f_rest).map__F1__O(new $c_sjsr_AnonFunction1(((_$14) => {
      var _$14$1 = $as_Llaika_internal_parse_hocon_ConcatPart(_$14);
      return $n(_$14$1).Llaika_internal_parse_hocon_ConcatPart__f_value;
    })))));
    var elem = $n(concat).Llaika_internal_parse_hocon_ConcatValue__f_first;
    return $as_sci_Seq($n($as_sc_IterableOps(this$14.prepended__O__O(elem))).flatMap__F1__O(new $c_sjsr_AnonFunction1(((_$15) => {
      var _$15$1 = $as_Llaika_internal_parse_hocon_ConfigBuilderValue(_$15);
      return $p_Llaika_internal_parse_hocon_ConfigResolver$__extract$1__T__T__Llaika_internal_parse_hocon_ConfigBuilderValue__sci_Seq($thiz, parentPath$1, field, _$15$1);
    }))));
  }
  return $m_sci_Nil$();
}
/** @constructor */
function $c_Llaika_internal_parse_hocon_ConfigResolver$() {
}
$c_Llaika_internal_parse_hocon_ConfigResolver$.prototype = new $h_O();
$c_Llaika_internal_parse_hocon_ConfigResolver$.prototype.constructor = $c_Llaika_internal_parse_hocon_ConfigResolver$;
/** @constructor */
function $h_Llaika_internal_parse_hocon_ConfigResolver$() {
}
$h_Llaika_internal_parse_hocon_ConfigResolver$.prototype = $c_Llaika_internal_parse_hocon_ConfigResolver$.prototype;
$c_Llaika_internal_parse_hocon_ConfigResolver$.prototype.resolve__Llaika_internal_parse_hocon_ObjectBuilderValue__Llaika_api_config_Origin__Llaika_api_config_Config__sci_Map__s_util_Either = (function(root, origin, fallback, includes) {
  var errors = this.extractErrors__Llaika_internal_parse_hocon_ObjectBuilderValue__T__sci_Seq(root, "");
  var x99 = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptyChain).fromSeq__sci_Seq__s_Option(errors);
  if ((x99 instanceof $c_s_Some)) {
    var errs = $n($as_s_Some(x99)).s_Some__f_value;
    var value = new $c_Llaika_api_config_ConfigError$InvalidFields(errs);
    return new $c_s_util_Left(value);
  }
  var x = $m_s_None$();
  if ((x === x99)) {
    var rootExpanded = this.mergeObjects__Llaika_internal_parse_hocon_ObjectBuilderValue__Llaika_internal_parse_hocon_ObjectBuilderValue(this.expandPaths__Llaika_internal_parse_hocon_ObjectBuilderValue__Llaika_api_config_Key__Llaika_internal_parse_hocon_ObjectBuilderValue(root, $m_Llaika_api_config_Key$().Llaika_api_config_Key$__f_root));
    var activeFields = $as_scm_Set($m_scm_Set$().empty__O());
    var resolvedFields = $as_scm_Map($m_scm_Map$().empty__O());
    var startedObjects = $as_scm_Map($m_scm_Map$().empty__O());
    var invalidPaths = $as_scm_Map($m_scm_Map$().empty__O());
    var res = $p_Llaika_internal_parse_hocon_ConfigResolver$__resolveObject$1__scm_Map__Llaika_api_config_Origin__sci_Map__scm_Map__scm_Set__scm_Map__Llaika_internal_parse_hocon_ObjectBuilderValue__Llaika_api_config_Config__Llaika_internal_parse_hocon_ObjectBuilderValue__Llaika_api_config_Key__Llaika_api_config_ConfigValue$ObjectValue(this, startedObjects, origin, includes, invalidPaths, activeFields, resolvedFields, rootExpanded, fallback, rootExpanded, $m_Llaika_api_config_Key$().Llaika_api_config_Key$__f_root);
    var this$3 = $n(invalidPaths);
    if ((!this$3.isEmpty__Z())) {
      var this$5 = $n($as_sc_IterableOnceOps($n(invalidPaths).map__F1__O(new $c_sjsr_AnonFunction1(((x$1) => {
        var x$1$1 = $as_T2(x$1);
        if ((x$1$1 !== null)) {
          var key = $as_Llaika_api_config_Key($n(x$1$1)._1__O());
          var msg = $as_T($n(x$1$1)._2__O());
          return ((("'" + key) + "': ") + msg);
        }
        throw new $c_s_MatchError(x$1$1);
      })))));
      var message = ("One or more errors resolving configuration: " + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$5, "", ", ", ""));
      var value$1 = new $c_Llaika_api_config_ConfigError$ResolverFailed(message);
      return new $c_s_util_Left(value$1);
    } else {
      return new $c_s_util_Right(res);
    }
  }
  throw new $c_s_MatchError(x99);
});
$c_Llaika_internal_parse_hocon_ConfigResolver$.prototype.mergeObjects__Llaika_internal_parse_hocon_ObjectBuilderValue__Llaika_internal_parse_hocon_ObjectBuilderValue = (function(obj) {
  var this$1 = $n($n(obj).Llaika_internal_parse_hocon_ObjectBuilderValue__f_values);
  var m = $as_scm_Map($m_scm_Map$().empty__O());
  var it = this$1.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    var _$11 = $as_Llaika_internal_parse_hocon_BuilderField(elem);
    var this$2 = $n($n(_$11).Llaika_internal_parse_hocon_BuilderField__f_key);
    if ((this$2 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$2);
      var b = $n(x2).s_util_Right__f_value;
      var $x_1 = b;
    } else {
      var $x_1 = $m_Llaika_api_config_Key$().Llaika_api_config_Key$__f_root;
    }
    var key = $as_Llaika_api_config_Key($x_1);
    var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0(((this$1) => (() => this$1.newSpecificBuilder__scm_Builder()))(this$1))));
    var this$3 = $n(bldr);
    this$3.addOne__O__scm_Growable(elem);
  }
  var this$4 = $m_sci_HashMap$();
  var result = this$4.sci_HashMap$__f_EmptyMap;
  var mapIt = $n(m).iterator__sc_Iterator();
  while ($n(mapIt).hasNext__Z()) {
    var x1 = $as_T2($n(mapIt).next__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = $n(x1)._1__O();
    var v = $as_scm_Builder($n(x1)._2__O());
    result = $n(result).updated__O__O__sci_HashMap(k, $n(v).result__O());
  }
  var map = result;
  var this$7 = $n(map);
  $m_sci_HashMap$();
  var b$1 = new $c_sci_HashMapBuilder();
  var it$1 = this$7.iterator__sc_Iterator();
  while ($n(it$1).hasNext__Z()) {
    var arg1 = $n(it$1).next__O();
    var x$1 = $as_T2(arg1);
    matchResult2: {
      var elem$1___1;
      var elem$1___2;
      if ((x$1 !== null)) {
        var k$1 = $n(x$1)._1__O();
        var v$1 = $n(x$1)._2__O();
        var _$12 = $as_sci_Seq(v$1);
        var _2 = $as_sci_Seq($n(_$12).map__F1__O(new $c_sjsr_AnonFunction1(((_$13) => {
          var _$13$1 = $as_Llaika_internal_parse_hocon_BuilderField(_$13);
          return $n(_$13$1).Llaika_internal_parse_hocon_BuilderField__f_value;
        }))));
        var elem$1___1 = k$1;
        var elem$1___2 = _2;
        break matchResult2;
      }
      throw new $c_s_MatchError(x$1);
    }
    $p_sci_HashMapBuilder__ensureUnaliased__V(b$1);
    var x = elem$1___1;
    var h = $m_sr_Statics$().anyHash__O__I(x);
    var im = $m_sc_Hashing$().improve__I__I(h);
    b$1.update__sci_MapNode__O__O__I__I__I__V(b$1.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, elem$1___1, elem$1___2, h, im, 0);
  }
  var this$11 = $n(b$1.result__sci_HashMap());
  var mergedFields = $as_sci_Seq($n($m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$11)).map__F1__O(new $c_sjsr_AnonFunction1(((x$1$1) => {
    var x$1$2 = $as_T2(x$1$1);
    if ((x$1$2 !== null)) {
      var key$1 = $as_Llaika_api_config_Key($n(x$1$2)._1__O());
      var values = $as_sci_Seq($n(x$1$2)._2__O());
      matchResult17: {
        var merged;
        var this$12 = $n(values);
        var op = new $c_sjsr_AnonFunction2(((cbv1, cbv2) => {
          var cbv1$1 = $as_Llaika_internal_parse_hocon_ConfigBuilderValue(cbv1);
          var cbv2$1 = $as_Llaika_internal_parse_hocon_ConfigBuilderValue(cbv2);
          return $p_Llaika_internal_parse_hocon_ConfigResolver$__mergeValues$1__Llaika_api_config_Key__Llaika_internal_parse_hocon_ConfigBuilderValue__Llaika_internal_parse_hocon_ConfigBuilderValue__Llaika_internal_parse_hocon_ConfigBuilderValue(this, key$1, cbv1$1, cbv2$1);
        }));
        var x139 = $as_Llaika_internal_parse_hocon_ConfigBuilderValue(this$12.reduceLeft__F2__O(op));
        if ((x139 instanceof $c_Llaika_internal_parse_hocon_ObjectBuilderValue)) {
          var obv = $as_Llaika_internal_parse_hocon_ObjectBuilderValue(x139);
          var merged = this.mergeObjects__Llaika_internal_parse_hocon_ObjectBuilderValue__Llaika_internal_parse_hocon_ObjectBuilderValue(obv);
          break matchResult17;
        }
        var merged = x139;
      }
      return $m_Llaika_internal_parse_hocon_BuilderField$().apply__Llaika_api_config_Key__Llaika_internal_parse_hocon_ConfigBuilderValue__Llaika_internal_parse_hocon_BuilderField(key$1, merged);
    }
    throw new $c_s_MatchError(x$1$2);
  }))));
  return new $c_Llaika_internal_parse_hocon_ObjectBuilderValue(mergedFields);
});
$c_Llaika_internal_parse_hocon_ConfigResolver$.prototype.expandPaths__Llaika_internal_parse_hocon_ObjectBuilderValue__Llaika_api_config_Key__Llaika_internal_parse_hocon_ObjectBuilderValue = (function(obj, key) {
  var expandedFields = $as_sci_Seq($n($n(obj).Llaika_internal_parse_hocon_ObjectBuilderValue__f_values).map__F1__O(new $c_sjsr_AnonFunction1(((field) => {
    var field$1 = $as_Llaika_internal_parse_hocon_BuilderField(field);
    var x151 = $n($n($n(field$1).validKey__Llaika_api_config_Key()).Llaika_api_config_Key__f_segments).toList__sci_List();
    if ((x151 instanceof $c_sci_$colon$colon)) {
      var x155 = $as_sci_$colon$colon(x151);
      var x156 = $as_T($n(x155).sci_$colon$colon__f_head);
      var x157 = $n(x155).sci_$colon$colon__f_next;
      var x = $m_sci_Nil$();
      if (x.equals__O__Z(x157)) {
        $n(field$1);
        var value = $n(key).child__T__Llaika_api_config_Key(x156);
        var key$1 = new $c_s_util_Right(value);
        var value$1 = $p_Llaika_internal_parse_hocon_ConfigResolver$__expandValue$1__Llaika_internal_parse_hocon_ConfigBuilderValue__Llaika_api_config_Key__Llaika_internal_parse_hocon_ConfigBuilderValue(this, $n(field$1).Llaika_internal_parse_hocon_BuilderField__f_value, $n(key).child__T__Llaika_api_config_Key(x156));
        return new $c_Llaika_internal_parse_hocon_BuilderField(key$1, value$1);
      }
      $n(field$1);
      var value$2 = $n(key).child__T__Llaika_api_config_Key(x156);
      var key$3 = new $c_s_util_Right(value$2);
      var $x_2 = $m_sci_Seq$();
      var $x_1 = $m_sr_ScalaRunTime$();
      $m_Llaika_api_config_Key$();
      var value$3 = new $c_Llaika_api_config_Key(x157);
      var key$2 = new $c_s_util_Right(value$3);
      var value$4 = $n(field$1).Llaika_internal_parse_hocon_BuilderField__f_value;
      var values = $as_sci_Seq($n($x_2).apply__sci_Seq__sc_SeqOps($n($x_1).wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_internal_parse_hocon_BuilderField.getArrayOf().constr)([new $c_Llaika_internal_parse_hocon_BuilderField(key$2, value$4)]))));
      var value$5 = this.expandPaths__Llaika_internal_parse_hocon_ObjectBuilderValue__Llaika_api_config_Key__Llaika_internal_parse_hocon_ObjectBuilderValue(new $c_Llaika_internal_parse_hocon_ObjectBuilderValue(values), $n(key).child__T__Llaika_api_config_Key(x156));
      return new $c_Llaika_internal_parse_hocon_BuilderField(key$3, value$5);
    }
    var x$3 = $m_sci_Nil$();
    if (x$3.equals__O__Z(x151)) {
      $n(field$1);
      var value$6 = $m_Llaika_api_config_Key$().Llaika_api_config_Key$__f_root;
      var key$4 = new $c_s_util_Right(value$6);
      var value$7 = $p_Llaika_internal_parse_hocon_ConfigResolver$__expandValue$1__Llaika_internal_parse_hocon_ConfigBuilderValue__Llaika_api_config_Key__Llaika_internal_parse_hocon_ConfigBuilderValue(this, $n(field$1).Llaika_internal_parse_hocon_BuilderField__f_value, $m_Llaika_api_config_Key$().Llaika_api_config_Key$__f_root);
      return new $c_Llaika_internal_parse_hocon_BuilderField(key$4, value$7);
    }
    throw new $c_s_MatchError(x151);
  }))));
  $n(obj);
  return new $c_Llaika_internal_parse_hocon_ObjectBuilderValue(expandedFields);
});
$c_Llaika_internal_parse_hocon_ConfigResolver$.prototype.extractErrors__Llaika_internal_parse_hocon_ObjectBuilderValue__T__sci_Seq = (function(obj, parentPath) {
  return $as_sci_Seq($n($n(obj).Llaika_internal_parse_hocon_ObjectBuilderValue__f_values).flatMap__F1__O(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Llaika_internal_parse_hocon_BuilderField(x$1);
    if ((x$1$1 !== null)) {
      var this$3 = $n(x$1$1);
      var x207 = this$3.Llaika_internal_parse_hocon_BuilderField__f_key;
      var this$4 = $n(x$1$1);
      var x208 = this$4.Llaika_internal_parse_hocon_BuilderField__f_value;
      if ((x207 instanceof $c_s_util_Left)) {
        var x211 = $as_Llaika_internal_parse_hocon_InvalidStringValue($n($as_s_util_Left(x207)).s_util_Left__f_value);
        if ((x211 !== null)) {
          var this$6 = $n(x211);
          var this$7 = $n(x211);
          var x214 = this$7.Llaika_internal_parse_hocon_InvalidStringValue__f_failure;
          if ((x208 instanceof $c_Llaika_internal_parse_hocon_InvalidBuilderValue)) {
            var inv = $as_Llaika_internal_parse_hocon_InvalidBuilderValue(x208);
            var this$8 = $n($n(x214).message__T());
            if (($uI(this$8.indexOf("unquoted string")) !== (-1))) {
              var $x_2 = $m_sci_Seq$();
              var $x_1 = $m_sr_ScalaRunTime$();
              $n(x214);
              var msgProvider = $n($n(inv).Llaika_internal_parse_hocon_InvalidBuilderValue__f_failure).Llaika_parse_Failure__f_msgProvider;
              var this$9 = $n(x214);
              var next = this$9.Llaika_parse_Failure__f_next;
              var this$10 = $n(x214);
              var maxOffset = this$10.Llaika_parse_Failure__f_maxOffset;
              var failure = new $c_Llaika_parse_Failure(msgProvider, next, maxOffset);
              return $as_sci_Seq($n($x_2).apply__sci_Seq__sc_SeqOps($n($x_1).wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_config_ConfigError$InvalidField.getArrayOf().constr)([new $c_Llaika_api_config_ConfigError$InvalidField("<invalid>", failure)]))));
            }
          }
          return $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_config_ConfigError$InvalidField.getArrayOf().constr)([new $c_Llaika_api_config_ConfigError$InvalidField("<invalid>", x214)]))));
        }
      }
      var this$14 = $n(x207);
      if ((this$14 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(this$14);
        var b = $n(x2).s_util_Right__f_value;
        var _$16 = $as_Llaika_api_config_Key(b);
        var $x_3 = new $c_s_util_Right($n(_$16).toString__T());
      } else {
        var $x_3 = this$14;
      }
      var this$15 = $n($x_3);
      if ((this$15 instanceof $c_s_util_Right)) {
        var x2$1 = $as_s_util_Right(this$15);
        var b$1 = $n(x2$1).s_util_Right__f_value;
        var $x_4 = b$1;
      } else {
        var $x_4 = "<invalid>";
      }
      return $p_Llaika_internal_parse_hocon_ConfigResolver$__extract$1__T__T__Llaika_internal_parse_hocon_ConfigBuilderValue__sci_Seq(this, parentPath, $as_T($x_4), x208);
    }
    throw new $c_s_MatchError(x$1$1);
  }))));
});
var $d_Llaika_internal_parse_hocon_ConfigResolver$ = new $TypeData().initClass($c_Llaika_internal_parse_hocon_ConfigResolver$, "laika.internal.parse.hocon.ConfigResolver$", ({
  Llaika_internal_parse_hocon_ConfigResolver$: 1
}));
var $n_Llaika_internal_parse_hocon_ConfigResolver$;
function $m_Llaika_internal_parse_hocon_ConfigResolver$() {
  if ((!$n_Llaika_internal_parse_hocon_ConfigResolver$)) {
    $n_Llaika_internal_parse_hocon_ConfigResolver$ = new $c_Llaika_internal_parse_hocon_ConfigResolver$();
  }
  return $n_Llaika_internal_parse_hocon_ConfigResolver$;
}
function $p_Llaika_internal_parse_hocon_HoconParsers$__failWith__Llaika_parse_Parser__F0__F1__Llaika_parse_Parser($thiz, fallbackParser, msg, captureError) {
  return $n($n(fallbackParser).withCursor__Llaika_parse_Parser()).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var cnt = $uI($n(x$1$1)._1__O());
      var source = $as_Llaika_parse_SourceFragment($n(x$1$1)._2__O());
      var $x_1 = $n(captureError);
      var this$2 = $m_Llaika_parse_Message$();
      var msg$1 = $as_T($n(msg).apply__O());
      var msgProvider = new $c_Llaika_parse_Message$$anon$2(msg$1, this$2);
      var next = $n(source).consume__I__Llaika_parse_SourceCursor(cnt);
      var maxOffset = $n(next).offset__I();
      return $n($x_1).apply__O__O(new $c_Llaika_parse_Failure(msgProvider, next, maxOffset));
    }
    throw new $c_s_MatchError(x$1$1);
  })));
}
function $p_Llaika_internal_parse_hocon_HoconParsers$__handleError$1__Llaika_internal_parse_hocon_ConfigBuilderValue__Llaika_parse_Failure__Llaika_internal_parse_hocon_ConfigBuilderValue($thiz, value, failure) {
  if ((value instanceof $c_Llaika_internal_parse_hocon_InvalidStringValue)) {
    var inv = $as_Llaika_internal_parse_hocon_InvalidStringValue(value);
    return inv;
  } else {
    return new $c_Llaika_internal_parse_hocon_InvalidBuilderValue(value, failure);
  }
}
function $p_Llaika_internal_parse_hocon_HoconParsers$__resource$1__T__F1__Llaika_parse_Parser($thiz, kind, f) {
  var this$1 = $m_Llaika_parse_builders$();
  var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
  var this$3 = $n($f_Llaika_parse_text_TextParsers__anyNot__C__sci_Seq__Llaika_parse_text_Characters(this$1, 10, chars));
  var v = new $c_sjsr_AnonFunction0((() => 0));
  var noOpeningQuote = $p_Llaika_internal_parse_hocon_HoconParsers$__failWith__Llaika_parse_Parser__F0__F1__Llaika_parse_Parser($thiz, new $c_Llaika_parse_Parser$$anon$1(v, this$3), new $c_sjsr_AnonFunction0((() => "Expected quoted string")), new $c_sjsr_AnonFunction1(((_$15) => {
    var _$15$1 = $as_Llaika_parse_Failure(_$15);
    return new $c_Llaika_internal_parse_hocon_InvalidStringValue("", _$15$1);
  })));
  var this$5 = $n($thiz.Llaika_internal_parse_hocon_HoconParsers$__f_quotedString);
  var p = new $c_sjsr_AnonFunction0((() => noOpeningQuote));
  var parser = this$5.orElse__F0__Llaika_parse_Parser(p);
  var resourceId = new $c_Llaika_internal_parse_hocon_HoconParsers$ClosingParserOps(parser).closeWith__C__F2__Llaika_parse_Parser(41, new $c_sjsr_AnonFunction2(((x$1, x$2) => {
    var x$1$1 = $as_Llaika_internal_parse_hocon_StringBuilderValue(x$1);
    var x$2$1 = $as_Llaika_parse_Failure(x$2);
    if ((x$1$1 instanceof $c_Llaika_internal_parse_hocon_InvalidStringValue)) {
      var inv = $as_Llaika_internal_parse_hocon_InvalidStringValue(x$1$1);
      return inv;
    } else {
      var value = $n(x$1$1).value__T();
      return new $c_Llaika_internal_parse_hocon_InvalidStringValue(value, x$2$1);
    }
  })));
  var $x_1 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var str = (kind + "(");
  var this$9 = $n($n($x_1).$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(str, resourceId));
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser(this$9, f));
}
function $p_Llaika_internal_parse_hocon_HoconParsers$__parts$lzyINIT1$1__sr_LazyRef__O__Llaika_parse_combinator_Repeat($thiz, parts$lzy1$1, delimiter$2) {
  if ((parts$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ($n(parts$lzy1$1).sr_LazyRef__f__initialized) {
    var $x_1 = $n(parts$lzy1$1).sr_LazyRef__f__value;
  } else {
    var $x_3 = $n(parts$lzy1$1);
    var $x_2 = $n($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters());
    var this$1 = $m_Llaika_parse_builders$();
    var p = $thiz.Llaika_internal_parse_hocon_HoconParsers$__f_comment;
    var p$1 = $n($x_2).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($n($f_Llaika_parse_combinator_Parsers__not__Llaika_parse_Parser__Llaika_parse_Parser(this$1, p)).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($thiz.anyValue__O__Llaika_parse_Parser(delimiter$2)));
    var this$5 = $n($m_Llaika_parse_syntax$Map2Ops$().mapN$extension__Llaika_parse_Parser__F2__Llaika_parse_Parser(p$1, new $c_sjsr_AnonFunction2(((whitespace, value) => {
      var whitespace$1 = $as_T(whitespace);
      var value$1 = $as_Llaika_internal_parse_hocon_ConfigBuilderValue(value);
      return new $c_Llaika_internal_parse_hocon_ConcatPart(whitespace$1, value$1);
    }))));
    var $x_1 = $n($x_3).initialize__O__O(new $c_Llaika_parse_combinator_Repeat(this$5, 0, 2147483647, $m_s_None$()));
  }
  return $as_Llaika_parse_combinator_Repeat($x_1);
}
function $p_Llaika_internal_parse_hocon_HoconParsers$__parts$2__sr_LazyRef__O__Llaika_parse_combinator_Repeat($thiz, parts$lzy1$2, delimiter$3) {
  return $as_Llaika_parse_combinator_Repeat(($n(parts$lzy1$2).sr_LazyRef__f__initialized ? $n(parts$lzy1$2).sr_LazyRef__f__value : $p_Llaika_internal_parse_hocon_HoconParsers$__parts$lzyINIT1$1__sr_LazyRef__O__Llaika_parse_combinator_Repeat($thiz, parts$lzy1$2, delimiter$3)));
}
function $p_Llaika_internal_parse_hocon_HoconParsers$__value$lzyINIT1$1__sr_LazyRef__Llaika_parse_Parser($thiz, value$lzy1$1) {
  if ((value$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Llaika_parse_Parser(($n(value$lzy1$1).sr_LazyRef__f__initialized ? $n(value$lzy1$1).sr_LazyRef__f__value : $n(value$lzy1$1).initialize__O__O($n($n($thiz.Llaika_internal_parse_hocon_HoconParsers$__f_wsOrNl).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($thiz.concatenatedValue__O__Llaika_parse_Parser($n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet).of__O__sci_Seq__Lcats_kernel_Order__O($bC(93), $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([44, 10, 35]))), $m_Lcats_kernel_instances_char_package$().Lcats_kernel_instances_char_package$__f_catsKernelStdOrderForChar)))).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters()))));
}
function $p_Llaika_internal_parse_hocon_HoconParsers$__value$1__sr_LazyRef__Llaika_parse_Parser($thiz, value$lzy1$2) {
  return $as_Llaika_parse_Parser(($n(value$lzy1$2).sr_LazyRef__f__initialized ? $n(value$lzy1$2).sr_LazyRef__f__value : $p_Llaika_internal_parse_hocon_HoconParsers$__value$lzyINIT1$1__sr_LazyRef__Llaika_parse_Parser($thiz, value$lzy1$2)));
}
function $p_Llaika_internal_parse_hocon_HoconParsers$__values$lzyINIT1$1__sr_LazyRef__sr_LazyRef__Llaika_parse_Parser($thiz, values$lzy1$1, value$lzy1$3) {
  if ((values$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Llaika_parse_Parser(($n(values$lzy1$1).sr_LazyRef__f__initialized ? $n(values$lzy1$1).sr_LazyRef__f__value : $n(values$lzy1$1).initialize__O__O($n($n($thiz.Llaika_internal_parse_hocon_HoconParsers$__f_wsOrComment).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($n($p_Llaika_internal_parse_hocon_HoconParsers$__value$1__sr_LazyRef__Llaika_parse_Parser($thiz, value$lzy1$3)).rep__Llaika_parse_Parser__Llaika_parse_combinator_Repeat($thiz.Llaika_internal_parse_hocon_HoconParsers$__f_separator))).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser($thiz.Llaika_internal_parse_hocon_HoconParsers$__f_wsOrComment))));
}
function $p_Llaika_internal_parse_hocon_HoconParsers$__values$1__sr_LazyRef__sr_LazyRef__Llaika_parse_Parser($thiz, values$lzy1$2, value$lzy1$4) {
  return $as_Llaika_parse_Parser(($n(values$lzy1$2).sr_LazyRef__f__initialized ? $n(values$lzy1$2).sr_LazyRef__f__value : $p_Llaika_internal_parse_hocon_HoconParsers$__values$lzyINIT1$1__sr_LazyRef__sr_LazyRef__Llaika_parse_Parser($thiz, values$lzy1$2, value$lzy1$4)));
}
function $p_Llaika_internal_parse_hocon_HoconParsers$__key$lzyINIT1$1__sr_LazyRef__O__Llaika_parse_Parser($thiz, key$lzy1$1, keySeparators$1) {
  if ((key$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Llaika_parse_Parser(($n(key$lzy1$1).sr_LazyRef__f__initialized ? $n(key$lzy1$1).sr_LazyRef__f__value : $n(key$lzy1$1).initialize__O__O($n($n($thiz.Llaika_internal_parse_hocon_HoconParsers$__f_wsOrNl).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($thiz.concatenatedKey__O__Llaika_parse_Parser(keySeparators$1))).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters()))));
}
function $p_Llaika_internal_parse_hocon_HoconParsers$__key$1__sr_LazyRef__O__Llaika_parse_Parser($thiz, key$lzy1$2, keySeparators$2) {
  return $as_Llaika_parse_Parser(($n(key$lzy1$2).sr_LazyRef__f__initialized ? $n(key$lzy1$2).sr_LazyRef__f__value : $p_Llaika_internal_parse_hocon_HoconParsers$__key$lzyINIT1$1__sr_LazyRef__O__Llaika_parse_Parser($thiz, key$lzy1$2, keySeparators$2)));
}
function $p_Llaika_internal_parse_hocon_HoconParsers$__value$lzyINIT2$1__sr_LazyRef__Llaika_parse_Parser($thiz, value$lzy2$1) {
  if ((value$lzy2$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Llaika_parse_Parser(($n(value$lzy2$1).sr_LazyRef__f__initialized ? $n(value$lzy2$1).sr_LazyRef__f__value : $n(value$lzy2$1).initialize__O__O($n($n($thiz.Llaika_internal_parse_hocon_HoconParsers$__f_wsOrNl).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($thiz.concatenatedValue__O__Llaika_parse_Parser($n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet).of__O__sci_Seq__Lcats_kernel_Order__O($bC(125), $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([44, 10, 35]))), $m_Lcats_kernel_instances_char_package$().Lcats_kernel_instances_char_package$__f_catsKernelStdOrderForChar)))).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters()))));
}
function $p_Llaika_internal_parse_hocon_HoconParsers$__value$2__sr_LazyRef__Llaika_parse_Parser($thiz, value$lzy2$2) {
  return $as_Llaika_parse_Parser(($n(value$lzy2$2).sr_LazyRef__f__initialized ? $n(value$lzy2$2).sr_LazyRef__f__value : $p_Llaika_internal_parse_hocon_HoconParsers$__value$lzyINIT2$1__sr_LazyRef__Llaika_parse_Parser($thiz, value$lzy2$2)));
}
function $p_Llaika_internal_parse_hocon_HoconParsers$__withSeparator$lzyINIT1$1__sr_LazyRef__sr_LazyRef__Llaika_parse_text_PrefixedParser($thiz, withSeparator$lzy1$1, value$lzy2$3) {
  if ((withSeparator$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ($n(withSeparator$lzy1$1).sr_LazyRef__f__initialized) {
    var $x_1 = $n(withSeparator$lzy1$1).sr_LazyRef__f__value;
  } else {
    var $x_4 = $n(withSeparator$lzy1$1);
    var this$1 = $m_Llaika_parse_builders$();
    var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([61])));
    var this$3 = $n($f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser(this$1, 58, chars));
    var this$2 = $m_s_$less$colon$less$();
    var ev = this$2.s_$less$colon$less$__f_singleton;
    var this$4 = $n($f_Llaika_parse_text_PrefixedParser__$bar__T__s_$less$colon$less__Llaika_parse_text_PrefixedParser(this$3, "+=", ev));
    var p = $p_Llaika_internal_parse_hocon_HoconParsers$__value$2__sr_LazyRef__Llaika_parse_Parser($thiz, value$lzy2$3);
    var this$10 = $n($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$4, p));
    var f = new $c_sjsr_AnonFunction1(((x$1) => {
      var x$1$1 = $as_Llaika_parse_builders$$tilde(x$1);
      if ((x$1$1 !== null)) {
        var x89 = $as_Llaika_internal_parse_hocon_ConfigBuilderValue($n(x$1$1).Llaika_parse_builders$$tilde__f__2);
        if (($n(x$1$1).Llaika_parse_builders$$tilde__f__1 === "+=")) {
          var first = $m_Llaika_internal_parse_hocon_SelfReference$();
          var $x_3 = $m_sci_Seq$();
          var $x_2 = $m_sr_ScalaRunTime$();
          var values = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_internal_parse_hocon_ConfigBuilderValue.getArrayOf().constr)([x89]))));
          var value = new $c_Llaika_internal_parse_hocon_ArrayBuilderValue(values);
          var rest = $as_sci_Seq($n($x_3).apply__sci_Seq__sc_SeqOps($n($x_2).wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_internal_parse_hocon_ConcatPart.getArrayOf().constr)([new $c_Llaika_internal_parse_hocon_ConcatPart("", value)]))));
          return new $c_Llaika_internal_parse_hocon_ConcatValue(first, rest);
        }
        return x89;
      }
      throw new $c_s_MatchError(x$1$1);
    }));
    var $x_1 = $n($x_4).initialize__O__O($f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser(this$10, f));
  }
  return $as_Llaika_parse_text_PrefixedParser($x_1);
}
function $p_Llaika_internal_parse_hocon_HoconParsers$__withSeparator$1__sr_LazyRef__sr_LazyRef__Llaika_parse_text_PrefixedParser($thiz, withSeparator$lzy1$2, value$lzy2$4) {
  return $as_Llaika_parse_text_PrefixedParser(($n(withSeparator$lzy1$2).sr_LazyRef__f__initialized ? $n(withSeparator$lzy1$2).sr_LazyRef__f__value : $p_Llaika_internal_parse_hocon_HoconParsers$__withSeparator$lzyINIT1$1__sr_LazyRef__sr_LazyRef__Llaika_parse_text_PrefixedParser($thiz, withSeparator$lzy1$2, value$lzy2$4)));
}
function $p_Llaika_internal_parse_hocon_HoconParsers$__withoutSeparator$lzyINIT1$1__sr_LazyRef__Llaika_parse_Parser($thiz, withoutSeparator$lzy1$1) {
  if ((withoutSeparator$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Llaika_parse_Parser(($n(withoutSeparator$lzy1$1).sr_LazyRef__f__initialized ? $n(withoutSeparator$lzy1$1).sr_LazyRef__f__value : $n(withoutSeparator$lzy1$1).initialize__O__O($n($n($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters()).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($thiz.objectValue__Llaika_parse_Parser())).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters()))));
}
function $p_Llaika_internal_parse_hocon_HoconParsers$__withoutSeparator$1__sr_LazyRef__Llaika_parse_Parser($thiz, withoutSeparator$lzy1$2) {
  return $as_Llaika_parse_Parser(($n(withoutSeparator$lzy1$2).sr_LazyRef__f__initialized ? $n(withoutSeparator$lzy1$2).sr_LazyRef__f__value : $p_Llaika_internal_parse_hocon_HoconParsers$__withoutSeparator$lzyINIT1$1__sr_LazyRef__Llaika_parse_Parser($thiz, withoutSeparator$lzy1$2)));
}
function $p_Llaika_internal_parse_hocon_HoconParsers$__member$lzyINIT1$1__sr_LazyRef__Llaika_parse_Parser__Llaika_parse_Parser__Llaika_parse_Parser($thiz, member$lzy1$1, includeField$1, valueField$1) {
  if ((member$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ($n(member$lzy1$1).sr_LazyRef__f__initialized) {
    var $x_1 = $n(member$lzy1$1).sr_LazyRef__f__value;
  } else {
    var $x_2 = $n(member$lzy1$1);
    var this$2 = $n(includeField$1);
    var p = new $c_sjsr_AnonFunction0((() => valueField$1));
    var $x_1 = $n($x_2).initialize__O__O(this$2.orElse__F0__Llaika_parse_Parser(p));
  }
  return $as_Llaika_parse_Parser($x_1);
}
function $p_Llaika_internal_parse_hocon_HoconParsers$__member$1__sr_LazyRef__Llaika_parse_Parser__Llaika_parse_Parser__Llaika_parse_Parser($thiz, member$lzy1$2, includeField$2, valueField$3) {
  return $as_Llaika_parse_Parser(($n(member$lzy1$2).sr_LazyRef__f__initialized ? $n(member$lzy1$2).sr_LazyRef__f__value : $p_Llaika_internal_parse_hocon_HoconParsers$__member$lzyINIT1$1__sr_LazyRef__Llaika_parse_Parser__Llaika_parse_Parser__Llaika_parse_Parser($thiz, member$lzy1$2, includeField$2, valueField$3)));
}
function $p_Llaika_internal_parse_hocon_HoconParsers$__members$lzyINIT1$1__sr_LazyRef__sr_LazyRef__Llaika_parse_Parser__Llaika_parse_Parser__Llaika_parse_combinator_Repeat($thiz, members$lzy1$1, member$lzy1$3, includeField$3, valueField$4) {
  if ((members$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Llaika_parse_combinator_Repeat(($n(members$lzy1$1).sr_LazyRef__f__initialized ? $n(members$lzy1$1).sr_LazyRef__f__value : $n(members$lzy1$1).initialize__O__O($n($p_Llaika_internal_parse_hocon_HoconParsers$__member$1__sr_LazyRef__Llaika_parse_Parser__Llaika_parse_Parser__Llaika_parse_Parser($thiz, member$lzy1$3, includeField$3, valueField$4)).rep__Llaika_parse_Parser__Llaika_parse_combinator_Repeat($thiz.Llaika_internal_parse_hocon_HoconParsers$__f_separator))));
}
function $p_Llaika_internal_parse_hocon_HoconParsers$__members$1__sr_LazyRef__sr_LazyRef__Llaika_parse_Parser__Llaika_parse_Parser__Llaika_parse_combinator_Repeat($thiz, members$lzy1$2, member$lzy1$4, includeField$4, valueField$5) {
  return $as_Llaika_parse_combinator_Repeat(($n(members$lzy1$2).sr_LazyRef__f__initialized ? $n(members$lzy1$2).sr_LazyRef__f__value : $p_Llaika_internal_parse_hocon_HoconParsers$__members$lzyINIT1$1__sr_LazyRef__sr_LazyRef__Llaika_parse_Parser__Llaika_parse_Parser__Llaika_parse_combinator_Repeat($thiz, members$lzy1$2, member$lzy1$4, includeField$4, valueField$5)));
}
/** @constructor */
function $c_Llaika_internal_parse_hocon_HoconParsers$() {
  this.Llaika_internal_parse_hocon_HoconParsers$__f_wsOrNl = null;
  this.Llaika_internal_parse_hocon_HoconParsers$__f_nullValue = null;
  this.Llaika_internal_parse_hocon_HoconParsers$__f_trueValue = null;
  this.Llaika_internal_parse_hocon_HoconParsers$__f_falseValue = null;
  this.Llaika_internal_parse_hocon_HoconParsers$__f_numberValue = null;
  this.Llaika_internal_parse_hocon_HoconParsers$__f_quotedString = null;
  this.Llaika_internal_parse_hocon_HoconParsers$__f_multilineString = null;
  this.Llaika_internal_parse_hocon_HoconParsers$__f_substitutionValue = null;
  this.Llaika_internal_parse_hocon_HoconParsers$__f_include = null;
  this.Llaika_internal_parse_hocon_HoconParsers$__f_comment = null;
  this.Llaika_internal_parse_hocon_HoconParsers$__f_wsOrComment = null;
  this.Llaika_internal_parse_hocon_HoconParsers$__f_separator = null;
  this.Llaika_internal_parse_hocon_HoconParsers$__f_trailingComma = null;
  this.Llaika_internal_parse_hocon_HoconParsers$__f_arrayValue$lzy1 = null;
  this.Llaika_internal_parse_hocon_HoconParsers$__f_arrayValuebitmap$1 = false;
  this.Llaika_internal_parse_hocon_HoconParsers$__f_objectMembers$lzy1 = null;
  this.Llaika_internal_parse_hocon_HoconParsers$__f_objectMembersbitmap$1 = false;
  this.Llaika_internal_parse_hocon_HoconParsers$__f_objectValue$lzy1 = null;
  this.Llaika_internal_parse_hocon_HoconParsers$__f_objectValuebitmap$1 = false;
  this.Llaika_internal_parse_hocon_HoconParsers$__f_rootObject$lzy1 = null;
  this.Llaika_internal_parse_hocon_HoconParsers$__f_rootObjectbitmap$1 = false;
  $n_Llaika_internal_parse_hocon_HoconParsers$ = this;
  var this$1 = $m_Llaika_parse_builders$();
  var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([9, 10])));
  this.Llaika_internal_parse_hocon_HoconParsers$__f_wsOrNl = $f_Llaika_parse_text_TextParsers__anyOf__C__sci_Seq__Llaika_parse_text_Characters(this$1, 32, chars);
  $m_Llaika_parse_builders$();
  var this$5 = new $c_Llaika_parse_text_Literal("null");
  var v = new $c_sjsr_AnonFunction0((() => {
    var value = $m_Llaika_api_config_ConfigValue$NullValue$();
    return new $c_Llaika_internal_parse_hocon_ResolvedBuilderValue(value);
  }));
  this.Llaika_internal_parse_hocon_HoconParsers$__f_nullValue = $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__as__F0__Llaika_parse_text_PrefixedParser(this$5, v));
  $m_Llaika_parse_builders$();
  var this$9 = new $c_Llaika_parse_text_Literal("true");
  var v$1 = new $c_sjsr_AnonFunction0((() => {
    var value$1 = new $c_Llaika_api_config_ConfigValue$BooleanValue(true);
    return new $c_Llaika_internal_parse_hocon_ResolvedBuilderValue(value$1);
  }));
  this.Llaika_internal_parse_hocon_HoconParsers$__f_trueValue = $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__as__F0__Llaika_parse_text_PrefixedParser(this$9, v$1));
  $m_Llaika_parse_builders$();
  var this$13 = new $c_Llaika_parse_text_Literal("false");
  var v$2 = new $c_sjsr_AnonFunction0((() => {
    var value$2 = new $c_Llaika_api_config_ConfigValue$BooleanValue(false);
    return new $c_Llaika_internal_parse_hocon_ResolvedBuilderValue(value$2);
  }));
  this.Llaika_internal_parse_hocon_HoconParsers$__f_falseValue = $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__as__F0__Llaika_parse_text_PrefixedParser(this$13, v$2));
  var this$14 = $m_Llaika_parse_builders$();
  var chars$1 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
  var zero = $f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser(this$14, 48, chars$1);
  var this$15 = $m_Llaika_parse_builders$();
  var chars$2 = $m_Llaika_parse_text_CharGroup$().Llaika_parse_text_CharGroup$__f_digit;
  var digits = $f_Llaika_parse_text_TextParsers__anyOf__O__Llaika_parse_text_Characters(this$15, chars$2);
  var this$17 = $m_Llaika_parse_builders$();
  var this$16 = $m_Llaika_parse_builders$();
  var chars$3 = $f_Llaika_parse_text_TextParsers__range__C__C__O(this$16, 49, 57);
  var oneToNine = $f_Llaika_parse_text_TextParsers__oneOf__O__Llaika_parse_text_PrefixedParser(this$17, chars$3);
  var this$18 = $n(oneToNine);
  var this$19 = $n($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$18, digits));
  var this$20 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = this$19.startChars__O();
  var p = $c_Llaika_parse_Parser.prototype.source__Llaika_parse_Parser.call(this$19);
  var nonZero = new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p, this$20);
  var this$22 = $m_Llaika_parse_builders$();
  var this$21 = $m_Llaika_parse_builders$();
  var chars$4 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
  var p$1 = $as_Llaika_parse_Parser($f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser(this$21, 45, chars$4));
  var negativeSign = $n($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$22, p$1)).source__Llaika_parse_Parser();
  var this$26 = $m_Llaika_parse_builders$();
  var this$23 = $m_Llaika_parse_builders$();
  var chars$5 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
  var this$25 = $n($f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser(this$23, 45, chars$5));
  var p$2 = new $c_sjsr_AnonFunction0((() => {
    var this$24 = $m_Llaika_parse_builders$();
    var chars$6 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
    return $f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser(this$24, 43, chars$6);
  }));
  var p$3 = $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$bar__F0__Llaika_parse_text_PrefixedParser(this$25, p$2));
  var sign = $n($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$26, p$3)).source__Llaika_parse_Parser();
  var this$27 = $n(zero);
  var p$4 = new $c_sjsr_AnonFunction0((() => nonZero));
  var integer = $n($n(negativeSign).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$bar__F0__Llaika_parse_text_PrefixedParser(this$27, p$4)))).source__Llaika_parse_Parser();
  var this$32 = $m_Llaika_parse_builders$();
  var this$28 = $m_Llaika_parse_builders$();
  var chars$7 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
  var this$29 = $n($f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser(this$28, 46, chars$7));
  var this$30 = $n($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$29, digits));
  var this$31 = $m_Llaika_parse_text_PrefixedParser$();
  var sc$1 = this$30.startChars__O();
  var p$5 = $c_Llaika_parse_Parser.prototype.source__Llaika_parse_Parser.call(this$30);
  var p$6 = new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc$1, p$5, this$31);
  var fraction = $n($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$32, p$6)).source__Llaika_parse_Parser();
  var this$38 = $m_Llaika_parse_builders$();
  var this$33 = $m_Llaika_parse_builders$();
  var chars$8 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([101])));
  var this$34 = $n($f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser(this$33, 69, chars$8));
  var this$35 = $n($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$34, sign));
  var this$36 = $n($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$35, digits));
  var this$37 = $m_Llaika_parse_text_PrefixedParser$();
  var sc$2 = this$36.startChars__O();
  var p$7 = $c_Llaika_parse_Parser.prototype.source__Llaika_parse_Parser.call(this$36);
  var p$8 = new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc$2, p$7, this$37);
  var exponent = $n($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$38, p$8)).source__Llaika_parse_Parser();
  this.Llaika_internal_parse_hocon_HoconParsers$__f_numberValue = $n($n(integer).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($n($n(fraction).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(exponent)).source__Llaika_parse_Parser())).evalMap__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Llaika_parse_builders$$tilde(x$1);
    if ((x$1$1 !== null)) {
      var x39 = $as_T($n(x$1$1).Llaika_parse_builders$$tilde__f__1);
      var x40 = $as_T($n(x$1$1).Llaika_parse_builders$$tilde__f__2);
      if ((x40 === "")) {
        var this$43 = $n($n($m_s_util_Try$().apply__F0__s_util_Try(new $c_sjsr_AnonFunction0((() => {
          var this$42 = $m_jl_Long$();
          return this$42.parseLong__T__I__J(x39, 10);
        })))).toEither__s_util_Either());
        return $n(new $c_s_util_Either$LeftProjection(this$43).map__F1__s_util_Either(new $c_sjsr_AnonFunction1(((_$1) => {
          var _$1$1 = $as_jl_Throwable(_$1);
          return $n(_$1$1).getMessage__T();
        })))).map__F1__s_util_Either(new $c_sjsr_AnonFunction1(((v$3) => {
          var t = $uJ(v$3);
          var v$4 = new $c_RTLong(t.RTLong__f_lo, t.RTLong__f_hi);
          var value$3 = new $c_Llaika_api_config_ConfigValue$LongValue(v$4);
          return new $c_Llaika_internal_parse_hocon_ResolvedBuilderValue(value$3);
        })));
      }
      var this$48 = $n($n($m_s_util_Try$().apply__F0__s_util_Try(new $c_sjsr_AnonFunction0((() => {
        var x = (("" + x39) + x40);
        return $m_jl_Double$().parseDouble__T__D(x);
      })))).toEither__s_util_Either());
      return $n(new $c_s_util_Either$LeftProjection(this$48).map__F1__s_util_Either(new $c_sjsr_AnonFunction1(((_$2) => {
        var _$2$1 = $as_jl_Throwable(_$2);
        return $n(_$2$1).getMessage__T();
      })))).map__F1__s_util_Either(new $c_sjsr_AnonFunction1(((v$2$1) => {
        var v$5 = $uD(v$2$1);
        var value$4 = new $c_Llaika_api_config_ConfigValue$DoubleValue(v$5);
        return new $c_Llaika_internal_parse_hocon_ResolvedBuilderValue(value$4);
      })));
    }
    throw new $c_s_MatchError(x$1$1);
  })));
  var this$51 = $m_Llaika_parse_builders$();
  var chars$9 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([92, 10])));
  var chars$10 = $n($f_Llaika_parse_text_TextParsers__someNot__C__sci_Seq__Llaika_parse_text_Characters(this$51, 34, chars$9)).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$3) => {
    var _$3$1 = $as_T(_$3);
    return new $c_s_util_Right(_$3$1);
  })));
  var this$53 = $m_Llaika_parse_builders$();
  var chars$11 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([102, 110, 114, 116])));
  var this$54 = $n($f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser(this$53, 98, chars$11));
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1$3 = $as_T(x$1$2);
    switch (x$1$3) {
      case "b": {
        return "\b";
        break;
      }
      case "f": {
        return "\f";
        break;
      }
      case "n": {
        return "\n";
        break;
      }
      case "r": {
        return "\r";
        break;
      }
      case "t": {
        return "\t";
        break;
      }
      default: {
        throw new $c_s_MatchError(x$1$3);
      }
    }
  }));
  var specialChar = $f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser(this$54, f);
  var this$55 = $m_Llaika_parse_builders$();
  var chars$12 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([92, 47])));
  var literalChar = $f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser(this$55, 34, chars$12);
  var $x_1 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var this$59 = $n($n($m_Llaika_parse_code_common_NumberLiteral$digits$().Llaika_parse_code_common_NumberLiteral$digits$__f_hex).take__I__Llaika_parse_text_PrefixCharacters(4));
  var f$1 = new $c_sjsr_AnonFunction1(((_$4) => {
    var _$4$1 = $as_T(_$4);
    var this$57 = (65535 & $m_jl_Integer$().parseInt__T__I__I(_$4$1, 16));
    return ("" + $cToS(this$57));
  }));
  var unicode = $n($x_1).$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("u", $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser(this$59, f$1)));
  var $x_2 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var this$61 = $n(literalChar);
  var p$9 = new $c_sjsr_AnonFunction0((() => specialChar));
  var this$62 = $n($f_Llaika_parse_text_PrefixedParser__$bar__F0__Llaika_parse_text_PrefixedParser(this$61, p$9));
  var p$10 = new $c_sjsr_AnonFunction0((() => unicode));
  var this$64 = $n($f_Llaika_parse_text_PrefixedParser__$bar__F0__Llaika_parse_text_PrefixedParser(this$62, p$10));
  var f$2 = new $c_sjsr_AnonFunction1(((_$5) => {
    var _$5$1 = $as_T(_$5);
    return new $c_s_util_Right(_$5$1);
  }));
  var this$66 = $n($as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser(this$64, f$2)));
  var p$11 = new $c_sjsr_AnonFunction0((() => $n($n($m_Llaika_parse_builders$().Llaika_parse_builders$__f_oneChar).withCursor__Llaika_parse_Parser()).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$6) => {
    var _$6$1 = $as_T2(_$6);
    return new $c_s_util_Left(_$6$1);
  })))));
  var escape = $n($x_2).$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("\\", this$66.orElse__F0__Llaika_parse_Parser(p$11));
  var this$67 = $n(chars$10);
  var p$12 = new $c_sjsr_AnonFunction0((() => $as_Llaika_parse_Parser(escape)));
  var this$68 = $n(this$67.orElse__F0__Llaika_parse_Parser(p$12));
  var value$7 = new $c_Llaika_parse_combinator_Repeat(this$68, 0, 2147483647, $m_s_None$()).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((parts) => {
    var parts$1 = $as_sci_List(parts);
    $m_Lcats_UnorderedFoldable$();
    var tc = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
    var this$75 = new $c_Lcats_Traverse$ToTraverseOps$$anon$3(parts$1, tc);
    var this$72 = $m_s_$less$colon$less$();
    $m_Lcats_instances_package$either$();
    var ev$2 = new $c_Lcats_instances_EitherInstances$$anon$2();
    var this$76 = $n(this$75.Lcats_Traverse$ToTraverseOps$$anon$3__f_typeClassInstance);
    var fga = this$75.Lcats_Traverse$ToTraverseOps$$anon$3__f_self;
    return $as_Llaika_internal_parse_hocon_StringBuilderValue($n($as_s_util_Either($f_Lcats_Traverse__sequence__O__Lcats_Applicative__O(this$76, fga, ev$2))).fold__F1__F1__O(new $c_sjsr_AnonFunction1(((error) => {
      var error$1 = $as_T2(error);
      var this$78 = $n($n(parts$1).map__F1__sci_List(new $c_sjsr_AnonFunction1(((_$7) => {
        var _$7$1 = $as_s_util_Either(_$7);
        return $as_T($n(_$7$1).fold__F1__F1__O(new $c_sjsr_AnonFunction1(((_$8) => {
          var _$8$1 = $as_T2(_$8);
          return $as_T($n(_$8$1)._1__O());
        })), new $c_sjsr_AnonFunction1(((x$2) => {
          var x$3 = $as_T(x$2);
          return x$3;
        }))));
      }))));
      var value$5 = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$78, "", "", "");
      var this$79 = $m_Llaika_parse_Message$();
      var msg = ("Invalid escape sequence: \\" + $n(error$1)._1__O());
      var msgProvider = new $c_Llaika_parse_Message$$anon$2(msg, this$79);
      var next = $as_Llaika_parse_SourceCursor($n(error$1)._2__O());
      var maxOffset = $n(next).offset__I();
      var failure = new $c_Llaika_parse_Failure(msgProvider, next, maxOffset);
      return new $c_Llaika_internal_parse_hocon_InvalidStringValue(value$5, failure);
    })), new $c_sjsr_AnonFunction1(((parts$3) => {
      var parts$2 = $as_sci_List(parts$3);
      var this$82 = $n(parts$2);
      var value$6 = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$82, "", "", "");
      return new $c_Llaika_internal_parse_hocon_ValidStringValue(value$6);
    }))));
  })));
  var parser = $as_Llaika_parse_Parser($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("\"", value$7));
  this.Llaika_internal_parse_hocon_HoconParsers$__f_quotedString = new $c_Llaika_internal_parse_hocon_HoconParsers$ClosingParserOps(parser).closeWith__C__F2__Llaika_parse_Parser(34, new $c_sjsr_AnonFunction2(((v$6, f$3) => {
    var v$7 = $as_Llaika_internal_parse_hocon_StringBuilderValue(v$6);
    var f$4 = $as_Llaika_parse_Failure(f$3);
    var value$8 = $n(v$7).value__T();
    return new $c_Llaika_internal_parse_hocon_InvalidStringValue(value$8, f$4);
  })));
  var fallback = $p_Llaika_internal_parse_hocon_HoconParsers$__failWith__Llaika_parse_Parser__F0__F1__Llaika_parse_Parser(this, $n($m_Llaika_parse_builders$().Llaika_parse_builders$__f_anyChars).count__Llaika_parse_text_Characters(), new $c_sjsr_AnonFunction0((() => "Expected closing triple quote")), new $c_sjsr_AnonFunction1(((_$9) => {
    var _$9$1 = $as_Llaika_parse_Failure(_$9);
    var value$9 = $m_Llaika_internal_parse_hocon_SelfReference$();
    return new $c_Llaika_internal_parse_hocon_InvalidBuilderValue(value$9, _$9$1);
  })));
  var this$87 = $m_Llaika_parse_builders$();
  var $x_3 = $f_Llaika_parse_text_TextParsers__delimitedBy__T__Llaika_parse_text_DelimitedText(this$87, "\"\"\"");
  var this$88 = $m_Llaika_parse_builders$();
  var chars$13 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
  var content = $n($n($x_3).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($f_Llaika_parse_text_TextParsers__anyOf__C__sci_Seq__Llaika_parse_text_Characters(this$88, 34, chars$13))).$up$up__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((x$1$3$1) => {
    var x$1$4 = $as_Llaika_parse_builders$$tilde(x$1$3$1);
    if ((x$1$4 !== null)) {
      var text = $as_T($n(x$1$4).Llaika_parse_builders$$tilde__f__1);
      var extraQuotes = $as_T($n(x$1$4).Llaika_parse_builders$$tilde__f__2);
      var value$10 = (("" + text) + extraQuotes);
      return new $c_Llaika_internal_parse_hocon_ValidStringValue(value$10);
    }
    throw new $c_s_MatchError(x$1$4);
  })));
  var $x_4 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var this$92 = $n(content);
  var p$13 = new $c_sjsr_AnonFunction0((() => fallback));
  this.Llaika_internal_parse_hocon_HoconParsers$__f_multilineString = $as_Llaika_parse_Parser($n($x_4).$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("\"\"\"", this$92.orElse__F0__Llaika_parse_Parser(p$13)));
  var $x_5 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var this$94 = $m_Llaika_parse_builders$();
  var this$96 = $n($n($x_5).$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("${", $f_Llaika_parse_combinator_Parsers__opt__T__Llaika_parse_Parser(this$94, "?")));
  var p$14 = this.concatenatedKey__O__Llaika_parse_Parser($n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet).one__O__Lcats_kernel_Order__O($bC(125), $m_Lcats_kernel_instances_char_package$().Lcats_kernel_instances_char_package$__f_catsKernelStdOrderForChar));
  var this$100 = $n($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$96, p$14));
  var f$5 = new $c_sjsr_AnonFunction1(((x$1$4$1) => {
    var x$1$5 = $as_Llaika_parse_builders$$tilde(x$1$4$1);
    if ((x$1$5 !== null)) {
      var x70 = $as_s_util_Either($n(x$1$5).Llaika_parse_builders$$tilde__f__2);
      var opt = $as_s_Option($n(x$1$5).Llaika_parse_builders$$tilde__f__1);
      if ((x70 instanceof $c_s_util_Right)) {
        var key = $as_Llaika_api_config_Key($n($as_s_util_Right(x70)).s_util_Right__f_value);
        var this$98 = $n(opt);
        var optional = (!this$98.isEmpty__Z());
        return new $c_Llaika_internal_parse_hocon_SubstitutionValue(key, optional);
      }
      if ((x70 instanceof $c_s_util_Left)) {
        var invalid = $as_Llaika_internal_parse_hocon_InvalidStringValue($n($as_s_util_Left(x70)).s_util_Left__f_value);
        return invalid;
      }
    }
    throw new $c_s_MatchError(x$1$5);
  }));
  var mainParser = $f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser(this$100, f$5);
  var parser$1 = $as_Llaika_parse_Parser(mainParser);
  this.Llaika_internal_parse_hocon_HoconParsers$__f_substitutionValue = new $c_Llaika_internal_parse_hocon_HoconParsers$ClosingParserOps(parser$1).closeWith__C__F2__Llaika_parse_Parser(125, new $c_sjsr_AnonFunction2(((value$2$1, failure$1) => {
    var value$11 = $as_Llaika_internal_parse_hocon_ConfigBuilderValue(value$2$1);
    var failure$2 = $as_Llaika_parse_Failure(failure$1);
    return $p_Llaika_internal_parse_hocon_HoconParsers$__handleError$1__Llaika_internal_parse_hocon_ConfigBuilderValue__Llaika_parse_Failure__Llaika_internal_parse_hocon_ConfigBuilderValue(this, value$11, failure$2);
  })));
  var this$103 = $n($n(this.Llaika_internal_parse_hocon_HoconParsers$__f_quotedString).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$16) => {
    var _$16$1 = $as_Llaika_internal_parse_hocon_StringBuilderValue(_$16);
    return new $c_Llaika_internal_parse_hocon_IncludeAny(_$16$1, false);
  }))));
  var p$15 = new $c_sjsr_AnonFunction0((() => $p_Llaika_internal_parse_hocon_HoconParsers$__resource$1__T__F1__Llaika_parse_Parser(this, "file", new $c_sjsr_AnonFunction1(((_$17) => {
    var _$17$1 = $as_Llaika_internal_parse_hocon_StringBuilderValue(_$17);
    return new $c_Llaika_internal_parse_hocon_IncludeFile(_$17$1, false);
  })))));
  var this$105 = $n(this$103.orElse__F0__Llaika_parse_Parser(p$15));
  var p$16 = new $c_sjsr_AnonFunction0((() => $p_Llaika_internal_parse_hocon_HoconParsers$__resource$1__T__F1__Llaika_parse_Parser(this, "classpath", new $c_sjsr_AnonFunction1(((_$18) => {
    var _$18$1 = $as_Llaika_internal_parse_hocon_StringBuilderValue(_$18);
    return new $c_Llaika_internal_parse_hocon_IncludeClassPath(_$18$1, false);
  })))));
  var this$107 = $n(this$105.orElse__F0__Llaika_parse_Parser(p$16));
  var p$17 = new $c_sjsr_AnonFunction0((() => $p_Llaika_internal_parse_hocon_HoconParsers$__resource$1__T__F1__Llaika_parse_Parser(this, "url", new $c_sjsr_AnonFunction1(((_$19) => {
    var _$19$1 = $as_Llaika_internal_parse_hocon_StringBuilderValue(_$19);
    return new $c_Llaika_internal_parse_hocon_IncludeUrl(_$19$1, false);
  })))));
  var this$112 = $n(this$107.orElse__F0__Llaika_parse_Parser(p$17));
  var p$18 = new $c_sjsr_AnonFunction0((() => {
    var this$108 = $m_Llaika_parse_builders$();
    var chars$14 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
    var this$109 = $n($f_Llaika_parse_text_TextParsers__anyNot__C__sci_Seq__Llaika_parse_text_Characters(this$108, 10, chars$14));
    var v$8 = new $c_sjsr_AnonFunction0((() => 0));
    return $p_Llaika_internal_parse_hocon_HoconParsers$__failWith__Llaika_parse_Parser__F0__F1__Llaika_parse_Parser(this, new $c_Llaika_parse_Parser$$anon$1(v$8, this$109), new $c_sjsr_AnonFunction0((() => "Expected quoted string")), new $c_sjsr_AnonFunction1(((f$6) => {
      var f$7 = $as_Llaika_parse_Failure(f$6);
      var resourceId = new $c_Llaika_internal_parse_hocon_InvalidStringValue("", f$7);
      return new $c_Llaika_internal_parse_hocon_IncludeAny(resourceId, false);
    })));
  }));
  var includeResource = this$112.orElse__F0__Llaika_parse_Parser(p$18);
  var $x_6 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var parser$2 = $n(includeResource).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$20) => {
    var _$20$1 = $as_Llaika_internal_parse_hocon_IncludeResource(_$20);
    var this$114 = $n(_$20$1);
    return $f_Llaika_internal_parse_hocon_IncludeResource__asRequired__Llaika_internal_parse_hocon_IncludeResource(this$114);
  })));
  var required = $n($x_6).$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("required(", new $c_Llaika_internal_parse_hocon_HoconParsers$ClosingParserOps(parser$2).closeWith__C__F2__Llaika_parse_Parser(41, new $c_sjsr_AnonFunction2(((v$2$2, f$2$1) => {
    var v$9 = $as_Llaika_internal_parse_hocon_IncludeResource(v$2$2);
    var f$8 = $as_Llaika_parse_Failure(f$2$1);
    var x81 = $n(v$9).resourceId__Llaika_internal_parse_hocon_StringBuilderValue();
    if ((x81 instanceof $c_Llaika_internal_parse_hocon_InvalidStringValue)) {
      var inv = $as_Llaika_internal_parse_hocon_InvalidStringValue(x81);
      return new $c_Llaika_internal_parse_hocon_IncludeAny(inv, false);
    }
    var value$12 = $n(x81).value__T();
    var resourceId$1 = new $c_Llaika_internal_parse_hocon_InvalidStringValue(value$12, f$8);
    return new $c_Llaika_internal_parse_hocon_IncludeAny(resourceId$1, false);
  }))));
  var $x_7 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var this$119 = $n($as_Llaika_parse_Parser(required));
  var p$19 = new $c_sjsr_AnonFunction0((() => includeResource));
  var this$121 = $n($n($x_7).$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("include ", $n(this$119.orElse__F0__Llaika_parse_Parser(p$19)).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((resource) => {
    var resource$1 = $as_Llaika_internal_parse_hocon_IncludeResource(resource);
    return new $c_Llaika_internal_parse_hocon_IncludeBuilderValue(resource$1);
  })))));
  var p$20 = $m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters();
  this.Llaika_internal_parse_hocon_HoconParsers$__f_include = $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$less$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$121, p$20));
  var this$123 = $n($m_Llaika_parse_syntax$LiteralStringOps$().$bar$extension__T__T__Llaika_parse_text_PrefixedParser("//", "#"));
  var p$21 = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_restOfLine;
  this.Llaika_internal_parse_hocon_HoconParsers$__f_comment = $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$tilde$greater__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$123, p$21));
  var $x_8 = this.Llaika_internal_parse_hocon_HoconParsers$__f_wsOrNl;
  var this$124 = $n(this.Llaika_internal_parse_hocon_HoconParsers$__f_comment);
  var p$22 = new $c_sjsr_AnonFunction0((() => $n(this.Llaika_internal_parse_hocon_HoconParsers$__f_wsOrNl).min__I__Llaika_parse_text_Characters(1)));
  var this$125 = $n(this$124.orElse__F0__Llaika_parse_Parser(p$22));
  this.Llaika_internal_parse_hocon_HoconParsers$__f_wsOrComment = $n($x_8).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(new $c_Llaika_parse_combinator_Repeat(this$125, 0, 2147483647, $m_s_None$()));
  var this$127 = $m_Llaika_parse_builders$();
  var chars$15 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
  var this$128 = $n($as_Llaika_parse_Parser($f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser(this$127, 44, chars$15)));
  var p$23 = new $c_sjsr_AnonFunction0((() => $m_Llaika_parse_builders$().Llaika_parse_builders$__f_eol));
  var this$129 = $n(this$128.orElse__F0__Llaika_parse_Parser(p$23));
  var p$24 = new $c_sjsr_AnonFunction0((() => this.Llaika_internal_parse_hocon_HoconParsers$__f_comment));
  this.Llaika_internal_parse_hocon_HoconParsers$__f_separator = $n($n(this$129.orElse__F0__Llaika_parse_Parser(p$24)).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(this.Llaika_internal_parse_hocon_HoconParsers$__f_wsOrComment)).void__Llaika_parse_Parser();
  var this$131 = $m_Llaika_parse_builders$();
  var p$25 = $as_Llaika_parse_Parser($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(",", this.Llaika_internal_parse_hocon_HoconParsers$__f_wsOrComment));
  this.Llaika_internal_parse_hocon_HoconParsers$__f_trailingComma = $f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$131, p$25);
}
$c_Llaika_internal_parse_hocon_HoconParsers$.prototype = new $h_O();
$c_Llaika_internal_parse_hocon_HoconParsers$.prototype.constructor = $c_Llaika_internal_parse_hocon_HoconParsers$;
/** @constructor */
function $h_Llaika_internal_parse_hocon_HoconParsers$() {
}
$h_Llaika_internal_parse_hocon_HoconParsers$.prototype = $c_Llaika_internal_parse_hocon_HoconParsers$.prototype;
$c_Llaika_internal_parse_hocon_HoconParsers$.prototype.unquotedString__O__Llaika_parse_Parser = (function(delimiters) {
  var this$1 = $m_Llaika_parse_builders$();
  var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([34, 123, 125, 91, 93, 58, 61, 44, 43, 35, 96, 94, 63, 33, 64, 42, 38, 92, 32, 9, 10])));
  var unquotedChar = $f_Llaika_parse_text_TextParsers__anyNot__C__sci_Seq__Llaika_parse_text_Characters(this$1, 36, chars);
  var mainParser = $n($n(unquotedChar).min__I__Llaika_parse_text_Characters(1)).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((value) => {
    var value$1 = $as_T(value);
    return new $c_Llaika_internal_parse_hocon_ValidStringValue(value$1);
  })));
  var this$9 = $m_Llaika_parse_builders$();
  var $x_1 = $n($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters());
  var this$6 = $m_Llaika_parse_builders$();
  var value$2 = new $c_Lcats_data_NonEmptySetOps(delimiters).add__O__O($bC(34));
  var chars$1 = new $c_Lcats_data_NonEmptySetOps(value$2).add__O__O($bC(36));
  var this$7 = $n($as_Llaika_parse_Parser($f_Llaika_parse_text_TextParsers__oneOf__O__Llaika_parse_text_PrefixedParser(this$6, chars$1)));
  var p = new $c_sjsr_AnonFunction0((() => $n(unquotedChar).take__I__Llaika_parse_text_Characters(1)));
  var this$8 = $n(this$7.orElse__F0__Llaika_parse_Parser(p));
  var p$1 = new $c_sjsr_AnonFunction0((() => $m_Llaika_parse_builders$().Llaika_parse_builders$__f_eof));
  var p$2 = $n($x_1).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(this$8.orElse__F0__Llaika_parse_Parser(p$1));
  var closingParser = $f_Llaika_parse_combinator_Parsers__lookAhead__Llaika_parse_Parser__Llaika_parse_Parser(this$9, p$2);
  var tc = $m_Lcats_data_NonEmptySetImpl$().Lcats_data_NonEmptySetInstances__f_catsDataInstancesForNonEmptySet;
  var this$11 = new $c_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4(delimiters, tc);
  var this$12 = $n(this$11.Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4__f_typeClassInstance).size__O__J(this$11.Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4__f_self);
  if (((this$12.RTLong__f_lo === 1) && (this$12.RTLong__f_hi === 0))) {
    var delimMsg = " is";
  } else {
    var delimMsg = "s are one of";
  }
  var this$14 = new $c_Lcats_data_NonEmptySetOps(delimiters);
  var s = this$14.Lcats_data_NonEmptySetOps__f_value;
  var this$16 = $n($n($as_sci_SortedSet(s)).map__F1__s_math_Ordering__sc_SortedSet(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $uC(x$1);
    return ((x$1$1 === 10) ? "'\\n'" : ((x$1$1 === 43) ? "'+='" : (("'" + $cToS(x$1$1)) + "'")));
  })), $m_s_math_Ordering$String$()));
  var renderedDelimiters = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$16, "", ", ", "");
  var msg = ((("Illegal character in unquoted string, expected delimiter" + delimMsg) + " ") + renderedDelimiters);
  var $x_3 = new $c_Llaika_internal_parse_hocon_HoconParsers$ClosingParserOps(mainParser);
  var $x_2 = $n($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters()).count__Llaika_parse_text_Characters();
  var this$18 = $m_Llaika_parse_builders$();
  var chars$2 = new $c_Lcats_data_NonEmptySetOps(delimiters).add__O__O($bC(10));
  return $n($x_3).closeWith__Llaika_parse_Parser__Llaika_parse_Parser__F0__F2__Llaika_parse_Parser(closingParser, $n($x_2).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser($f_Llaika_parse_text_TextParsers__anyNot__O__Llaika_parse_text_Characters(this$18, chars$2)), new $c_sjsr_AnonFunction0((() => msg)), new $c_sjsr_AnonFunction2(((v, f) => {
    var v$1 = $as_Llaika_internal_parse_hocon_ValidStringValue(v);
    var f$1 = $as_Llaika_parse_Failure(f);
    var value$3 = $n(v$1).Llaika_internal_parse_hocon_ValidStringValue__f_value;
    return new $c_Llaika_internal_parse_hocon_InvalidStringValue(value$3, f$1);
  })));
});
$c_Llaika_internal_parse_hocon_HoconParsers$.prototype.stringBuilderValue__O__Llaika_parse_Parser = (function(delimiter) {
  var this$2 = $n(this.Llaika_internal_parse_hocon_HoconParsers$__f_multilineString);
  var p = new $c_sjsr_AnonFunction0((() => this.Llaika_internal_parse_hocon_HoconParsers$__f_quotedString));
  var this$3 = $n(this$2.orElse__F0__Llaika_parse_Parser(p));
  var p$1 = new $c_sjsr_AnonFunction0((() => this.unquotedString__O__Llaika_parse_Parser(delimiter)));
  return this$3.orElse__F0__Llaika_parse_Parser(p$1);
});
$c_Llaika_internal_parse_hocon_HoconParsers$.prototype.concatenatedValue__O__Llaika_parse_Parser = (function(delimiter) {
  var parts$lzy1 = new $c_sr_LazyRef();
  var parts$lzy1$2$1 = parts$lzy1;
  var parser = new $c_sjsr_AnonFunction0(((parts$lzy1$2) => (() => $n($n(this.anyValue__O__Llaika_parse_Parser(delimiter)).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($p_Llaika_internal_parse_hocon_HoconParsers$__parts$2__sr_LazyRef__O__Llaika_parse_combinator_Repeat(this, parts$lzy1$2, delimiter))).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Llaika_parse_builders$$tilde(x$1);
    if ((x$1$1 !== null)) {
      var x52 = $as_Llaika_internal_parse_hocon_ConfigBuilderValue($n(x$1$1).Llaika_parse_builders$$tilde__f__1);
      var x53 = $as_sci_List($n(x$1$1).Llaika_parse_builders$$tilde__f__2);
      var x = $m_sci_Nil$();
      if (x.equals__O__Z(x53)) {
        return x52;
      }
      return new $c_Llaika_internal_parse_hocon_ConcatValue(x52, x53);
    }
    throw new $c_s_MatchError(x$1$1);
  })))))(parts$lzy1$2$1));
  return new $c_Llaika_internal_parse_hocon_HoconParsers$$anon$1(parser, this);
});
$c_Llaika_internal_parse_hocon_HoconParsers$.prototype.concatenatedKey__O__Llaika_parse_Parser = (function(delimiter) {
  var this$3 = $n($n(this.Llaika_internal_parse_hocon_HoconParsers$__f_quotedString).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((key) => {
    var key$1 = $as_Llaika_internal_parse_hocon_StringBuilderValue(key);
    return $m_Llaika_internal_parse_hocon_HoconParsers$PathFragments$().quoted__Llaika_internal_parse_hocon_StringBuilderValue__Llaika_internal_parse_hocon_HoconParsers$PathFragments(key$1);
  }))));
  var p = new $c_sjsr_AnonFunction0((() => $n(this.unquotedString__O__Llaika_parse_Parser(delimiter)).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((key$2) => {
    var key$3 = $as_Llaika_internal_parse_hocon_StringBuilderValue(key$2);
    return $m_Llaika_internal_parse_hocon_HoconParsers$PathFragments$().unquoted__Llaika_internal_parse_hocon_StringBuilderValue__Llaika_internal_parse_hocon_HoconParsers$PathFragments(key$3);
  })))));
  var string = this$3.orElse__F0__Llaika_parse_Parser(p);
  var p$1 = $n($n($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters()).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((ws) => {
    var ws$1 = $as_T(ws);
    return $m_Llaika_internal_parse_hocon_HoconParsers$PathFragments$().whitespace__T__Llaika_internal_parse_hocon_HoconParsers$PathFragments(ws$1);
  })))).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(string);
  var parts = $m_Llaika_parse_syntax$Map2Ops$().mapN$extension__Llaika_parse_Parser__F2__Llaika_parse_Parser(p$1, new $c_sjsr_AnonFunction2(((_$10, _$11) => {
    var _$10$1 = $as_Llaika_internal_parse_hocon_HoconParsers$PathFragments(_$10);
    var _$11$1 = $as_Llaika_internal_parse_hocon_HoconParsers$PathFragments(_$11);
    return $n(_$10$1).join__Llaika_internal_parse_hocon_HoconParsers$PathFragments__Llaika_internal_parse_hocon_HoconParsers$PathFragments(_$11$1);
  })));
  var $x_1 = $n(string);
  var this$5 = $n(parts);
  var p$2 = $n($x_1).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(new $c_Llaika_parse_combinator_Repeat(this$5, 0, 2147483647, $m_s_None$()));
  return $n($m_Llaika_parse_syntax$PrependParserOps$().concat$extension__Llaika_parse_Parser__Llaika_parse_Parser(p$2)).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((allParts) => {
    var allParts$1 = $as_sci_Seq(allParts);
    var this$8 = $n(allParts$1);
    var op = new $c_sjsr_AnonFunction2(((_$12, _$13) => {
      var _$12$1 = $as_Llaika_internal_parse_hocon_HoconParsers$PathFragments(_$12);
      var _$13$1 = $as_Llaika_internal_parse_hocon_HoconParsers$PathFragments(_$13);
      return $n(_$12$1).join__Llaika_internal_parse_hocon_HoconParsers$PathFragments__Llaika_internal_parse_hocon_HoconParsers$PathFragments(_$13$1);
    }));
    var fragments = $n($as_Llaika_internal_parse_hocon_HoconParsers$PathFragments(this$8.reduceLeft__F2__O(op))).Llaika_internal_parse_hocon_HoconParsers$PathFragments__f_fragments;
    var keyStrings = $as_sci_Seq($n(fragments).map__F1__O(new $c_sjsr_AnonFunction1(((_$14) => {
      var _$14$1 = $as_Llaika_internal_parse_hocon_StringBuilderValue(_$14);
      return $n(_$14$1).value__T();
    }))));
    var x58 = $n($n(fragments).toList__sci_List()).collect__s_PartialFunction__sci_List(new $c_Llaika_internal_parse_hocon_HoconParsers$$anon$2());
    if ((x58 instanceof $c_sci_$colon$colon)) {
      $n($as_sci_$colon$colon(x58));
      var error = $as_Llaika_internal_parse_hocon_InvalidStringValue($n($as_sci_$colon$colon(x58)).sci_$colon$colon__f_head);
      var this$9 = $n(keyStrings);
      var value = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$9, "", ".", "");
      $n($n(error).Llaika_internal_parse_hocon_InvalidStringValue__f_failure);
      var msgProvider = new $c_Llaika_internal_parse_hocon_HoconParsers$$anon$3(error);
      var this$10 = $n($n(error).Llaika_internal_parse_hocon_InvalidStringValue__f_failure);
      var next = this$10.Llaika_parse_Failure__f_next;
      var this$11 = $n($n(error).Llaika_internal_parse_hocon_InvalidStringValue__f_failure);
      var maxOffset = this$11.Llaika_parse_Failure__f_maxOffset;
      var failure = new $c_Llaika_parse_Failure(msgProvider, next, maxOffset);
      var value$1 = new $c_Llaika_internal_parse_hocon_InvalidStringValue(value, failure);
      return new $c_s_util_Left(value$1);
    }
    $m_Llaika_api_config_Key$();
    var segments = $n(keyStrings).toList__sci_List();
    var value$2 = new $c_Llaika_api_config_Key(segments);
    return new $c_s_util_Right(value$2);
  })));
});
$c_Llaika_internal_parse_hocon_HoconParsers$.prototype.arrayValue__Llaika_parse_Parser = (function() {
  if ((!this.Llaika_internal_parse_hocon_HoconParsers$__f_arrayValuebitmap$1)) {
    var value$lzy1 = new $c_sr_LazyRef();
    var values$lzy1 = new $c_sr_LazyRef();
    var values$lzy1$2$1 = values$lzy1;
    var value$lzy1$2$1 = value$lzy1;
    var parser = new $c_sjsr_AnonFunction0(((values$lzy1$2, value$lzy1$2) => (() => {
      var this$3 = $n($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("[", $p_Llaika_internal_parse_hocon_HoconParsers$__values$1__sr_LazyRef__sr_LazyRef__Llaika_parse_Parser(this, values$lzy1$2, value$lzy1$2)));
      var p = this.Llaika_internal_parse_hocon_HoconParsers$__f_trailingComma;
      var this$5 = $n($f_Llaika_parse_text_PrefixedParser__$less$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$3, p));
      var f = new $c_sjsr_AnonFunction1(((values) => {
        var values$1 = $as_sci_Seq(values);
        return new $c_Llaika_internal_parse_hocon_ArrayBuilderValue(values$1);
      }));
      return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser(this$5, f));
    }))(values$lzy1$2$1, value$lzy1$2$1));
    var mainParser = new $c_Llaika_internal_parse_hocon_HoconParsers$$anon$1(parser, this);
    this.Llaika_internal_parse_hocon_HoconParsers$__f_arrayValue$lzy1 = new $c_Llaika_internal_parse_hocon_HoconParsers$ClosingParserOps(mainParser).closeWith__C__F2__Llaika_parse_Parser(93, new $c_sjsr_AnonFunction2(((value, failure) => {
      var value$1 = $as_Llaika_internal_parse_hocon_ConfigBuilderValue(value);
      var failure$1 = $as_Llaika_parse_Failure(failure);
      return new $c_Llaika_internal_parse_hocon_InvalidBuilderValue(value$1, failure$1);
    })));
    this.Llaika_internal_parse_hocon_HoconParsers$__f_arrayValuebitmap$1 = true;
  }
  return this.Llaika_internal_parse_hocon_HoconParsers$__f_arrayValue$lzy1;
});
$c_Llaika_internal_parse_hocon_HoconParsers$.prototype.objectMembers__Llaika_parse_Parser = (function() {
  if ((!this.Llaika_internal_parse_hocon_HoconParsers$__f_objectMembersbitmap$1)) {
    var key$lzy1 = new $c_sr_LazyRef();
    var value$lzy2 = new $c_sr_LazyRef();
    var withSeparator$lzy1 = new $c_sr_LazyRef();
    var withoutSeparator$lzy1 = new $c_sr_LazyRef();
    var member$lzy1 = new $c_sr_LazyRef();
    var members$lzy1 = new $c_sr_LazyRef();
    var keySeparators = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet).of__O__sci_Seq__Lcats_kernel_Order__O($bC(58), $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([61, 123, 43]))), $m_Lcats_kernel_instances_char_package$().Lcats_kernel_instances_char_package$__f_catsKernelStdOrderForChar);
    var $x_1 = $n($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters()).count__Llaika_parse_text_Characters();
    var this$2 = $m_Llaika_parse_builders$();
    var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
    var fallback = $p_Llaika_internal_parse_hocon_HoconParsers$__failWith__Llaika_parse_Parser__F0__F1__Llaika_parse_Parser(this, $n($x_1).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser($f_Llaika_parse_text_TextParsers__anyNot__C__sci_Seq__Llaika_parse_text_Characters(this$2, 10, chars)), new $c_sjsr_AnonFunction0((() => "Expected separator after key ('=', '+=', ':' or '{')")), new $c_sjsr_AnonFunction1(((_$21) => {
      var _$21$1 = $as_Llaika_parse_Failure(_$21);
      var value = $m_Llaika_internal_parse_hocon_SelfReference$();
      return new $c_Llaika_internal_parse_hocon_InvalidBuilderValue(value, _$21$1);
    })));
    var includeField = $n(this.Llaika_internal_parse_hocon_HoconParsers$__f_include).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$22) => {
      var _$22$1 = $as_Llaika_internal_parse_hocon_ConfigBuilderValue(_$22);
      var value$1 = $m_Llaika_api_config_Key$().Llaika_api_config_Key$__f_root;
      var key = new $c_s_util_Right(value$1);
      return new $c_Llaika_internal_parse_hocon_BuilderField(key, _$22$1);
    })));
    var $x_2 = $p_Llaika_internal_parse_hocon_HoconParsers$__key$1__sr_LazyRef__O__Llaika_parse_Parser(this, key$lzy1, keySeparators);
    var this$7 = $n($as_Llaika_parse_Parser($p_Llaika_internal_parse_hocon_HoconParsers$__withSeparator$1__sr_LazyRef__sr_LazyRef__Llaika_parse_text_PrefixedParser(this, withSeparator$lzy1, value$lzy2)));
    var withoutSeparator$lzy1$2$1 = withoutSeparator$lzy1;
    var p = new $c_sjsr_AnonFunction0(((withoutSeparator$lzy1$2) => (() => $p_Llaika_internal_parse_hocon_HoconParsers$__withoutSeparator$1__sr_LazyRef__Llaika_parse_Parser(this, withoutSeparator$lzy1$2)))(withoutSeparator$lzy1$2$1));
    var this$8 = $n(this$7.orElse__F0__Llaika_parse_Parser(p));
    var p$1 = new $c_sjsr_AnonFunction0((() => fallback));
    var valueField = $n($n($x_2).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(this$8.orElse__F0__Llaika_parse_Parser(p$1))).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((x$1) => {
      var x$1$1 = $as_Llaika_parse_builders$$tilde(x$1);
      if ((x$1$1 !== null)) {
        var k = $as_s_util_Either($n(x$1$1).Llaika_parse_builders$$tilde__f__1);
        var v = $as_Llaika_internal_parse_hocon_ConfigBuilderValue($n(x$1$1).Llaika_parse_builders$$tilde__f__2);
        return new $c_Llaika_internal_parse_hocon_BuilderField(k, v);
      }
      throw new $c_s_MatchError(x$1$1);
    })));
    this.Llaika_internal_parse_hocon_HoconParsers$__f_objectMembers$lzy1 = $n($n($n($n(this.Llaika_internal_parse_hocon_HoconParsers$__f_wsOrComment).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($p_Llaika_internal_parse_hocon_HoconParsers$__members$1__sr_LazyRef__sr_LazyRef__Llaika_parse_Parser__Llaika_parse_Parser__Llaika_parse_combinator_Repeat(this, members$lzy1, member$lzy1, includeField, valueField))).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser(this.Llaika_internal_parse_hocon_HoconParsers$__f_wsOrComment)).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser(this.Llaika_internal_parse_hocon_HoconParsers$__f_trailingComma)).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((values) => {
      var values$1 = $as_sci_Seq(values);
      return new $c_Llaika_internal_parse_hocon_ObjectBuilderValue(values$1);
    })));
    this.Llaika_internal_parse_hocon_HoconParsers$__f_objectMembersbitmap$1 = true;
  }
  return this.Llaika_internal_parse_hocon_HoconParsers$__f_objectMembers$lzy1;
});
$c_Llaika_internal_parse_hocon_HoconParsers$.prototype.objectValue__Llaika_parse_Parser = (function() {
  if ((!this.Llaika_internal_parse_hocon_HoconParsers$__f_objectValuebitmap$1)) {
    var parser = new $c_sjsr_AnonFunction0((() => $as_Llaika_parse_Parser($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("{", this.objectMembers__Llaika_parse_Parser()))));
    var mainParser = new $c_Llaika_internal_parse_hocon_HoconParsers$$anon$1(parser, this);
    this.Llaika_internal_parse_hocon_HoconParsers$__f_objectValue$lzy1 = new $c_Llaika_internal_parse_hocon_HoconParsers$ClosingParserOps(mainParser).closeWith__C__F2__Llaika_parse_Parser(125, new $c_sjsr_AnonFunction2(((value, failure) => {
      var value$1 = $as_Llaika_internal_parse_hocon_ConfigBuilderValue(value);
      var failure$1 = $as_Llaika_parse_Failure(failure);
      return new $c_Llaika_internal_parse_hocon_InvalidBuilderValue(value$1, failure$1);
    })));
    this.Llaika_internal_parse_hocon_HoconParsers$__f_objectValuebitmap$1 = true;
  }
  return this.Llaika_internal_parse_hocon_HoconParsers$__f_objectValue$lzy1;
});
$c_Llaika_internal_parse_hocon_HoconParsers$.prototype.rootObject__Llaika_parse_Parser = (function() {
  if ((!this.Llaika_internal_parse_hocon_HoconParsers$__f_rootObjectbitmap$1)) {
    var recoveredRoot = $n(this.objectValue__Llaika_parse_Parser()).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((x$1) => {
      var x$1$1 = $as_Llaika_internal_parse_hocon_ConfigBuilderValue(x$1);
      if ((x$1$1 instanceof $c_Llaika_internal_parse_hocon_ObjectBuilderValue)) {
        var obj = $as_Llaika_internal_parse_hocon_ObjectBuilderValue(x$1$1);
        return obj;
      } else {
        var values = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_internal_parse_hocon_BuilderField.getArrayOf().constr)([$m_Llaika_internal_parse_hocon_BuilderField$().apply__T__Llaika_internal_parse_hocon_ConfigBuilderValue__Llaika_internal_parse_hocon_BuilderField("invalid", x$1$1)]))));
        return new $c_Llaika_internal_parse_hocon_ObjectBuilderValue(values);
      }
    })));
    var withBraces = $n($n(this.Llaika_internal_parse_hocon_HoconParsers$__f_wsOrComment).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser(recoveredRoot)).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser(this.Llaika_internal_parse_hocon_HoconParsers$__f_wsOrComment);
    var withoutBraces = $n($n(this.Llaika_internal_parse_hocon_HoconParsers$__f_wsOrComment).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser(this.objectMembers__Llaika_parse_Parser())).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser(this.Llaika_internal_parse_hocon_HoconParsers$__f_wsOrComment);
    var this$3 = $n(withBraces);
    var p = new $c_sjsr_AnonFunction0((() => withoutBraces));
    this.Llaika_internal_parse_hocon_HoconParsers$__f_rootObject$lzy1 = $n(this$3.orElse__F0__Llaika_parse_Parser(p)).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser($m_Llaika_parse_builders$().Llaika_parse_builders$__f_eof);
    this.Llaika_internal_parse_hocon_HoconParsers$__f_rootObjectbitmap$1 = true;
  }
  return this.Llaika_internal_parse_hocon_HoconParsers$__f_rootObject$lzy1;
});
$c_Llaika_internal_parse_hocon_HoconParsers$.prototype.anyValue__O__Llaika_parse_Parser = (function(delimiter) {
  var this$2 = $n(this.objectValue__Llaika_parse_Parser());
  var p = new $c_sjsr_AnonFunction0((() => this.arrayValue__Llaika_parse_Parser()));
  var this$3 = $n(this$2.orElse__F0__Llaika_parse_Parser(p));
  var p$1 = new $c_sjsr_AnonFunction0((() => this.Llaika_internal_parse_hocon_HoconParsers$__f_numberValue));
  var this$4 = $n(this$3.orElse__F0__Llaika_parse_Parser(p$1));
  var p$2 = new $c_sjsr_AnonFunction0((() => this.Llaika_internal_parse_hocon_HoconParsers$__f_trueValue));
  var this$5 = $n(this$4.orElse__F0__Llaika_parse_Parser(p$2));
  var p$3 = new $c_sjsr_AnonFunction0((() => this.Llaika_internal_parse_hocon_HoconParsers$__f_falseValue));
  var this$6 = $n(this$5.orElse__F0__Llaika_parse_Parser(p$3));
  var p$4 = new $c_sjsr_AnonFunction0((() => this.Llaika_internal_parse_hocon_HoconParsers$__f_nullValue));
  var this$7 = $n(this$6.orElse__F0__Llaika_parse_Parser(p$4));
  var p$5 = new $c_sjsr_AnonFunction0((() => this.Llaika_internal_parse_hocon_HoconParsers$__f_substitutionValue));
  var this$8 = $n(this$7.orElse__F0__Llaika_parse_Parser(p$5));
  var p$6 = new $c_sjsr_AnonFunction0((() => this.stringBuilderValue__O__Llaika_parse_Parser(delimiter)));
  return this$8.orElse__F0__Llaika_parse_Parser(p$6);
});
var $d_Llaika_internal_parse_hocon_HoconParsers$ = new $TypeData().initClass($c_Llaika_internal_parse_hocon_HoconParsers$, "laika.internal.parse.hocon.HoconParsers$", ({
  Llaika_internal_parse_hocon_HoconParsers$: 1
}));
var $n_Llaika_internal_parse_hocon_HoconParsers$;
function $m_Llaika_internal_parse_hocon_HoconParsers$() {
  if ((!$n_Llaika_internal_parse_hocon_HoconParsers$)) {
    $n_Llaika_internal_parse_hocon_HoconParsers$ = new $c_Llaika_internal_parse_hocon_HoconParsers$();
  }
  return $n_Llaika_internal_parse_hocon_HoconParsers$;
}
/** @constructor */
function $c_Llaika_internal_parse_hocon_HoconParsers$ClosingParserOps(parser) {
  this.Llaika_internal_parse_hocon_HoconParsers$ClosingParserOps__f_parser = null;
  this.Llaika_internal_parse_hocon_HoconParsers$ClosingParserOps__f_parser = parser;
}
$c_Llaika_internal_parse_hocon_HoconParsers$ClosingParserOps.prototype = new $h_O();
$c_Llaika_internal_parse_hocon_HoconParsers$ClosingParserOps.prototype.constructor = $c_Llaika_internal_parse_hocon_HoconParsers$ClosingParserOps;
/** @constructor */
function $h_Llaika_internal_parse_hocon_HoconParsers$ClosingParserOps() {
}
$h_Llaika_internal_parse_hocon_HoconParsers$ClosingParserOps.prototype = $c_Llaika_internal_parse_hocon_HoconParsers$ClosingParserOps.prototype;
$c_Llaika_internal_parse_hocon_HoconParsers$ClosingParserOps.prototype.closeWith__C__F2__Llaika_parse_Parser = (function(char, captureError) {
  var this$1 = $m_Llaika_parse_builders$();
  var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
  var $x_1 = $as_Llaika_parse_Parser($f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser(this$1, char, chars));
  var this$2 = $m_Llaika_parse_builders$();
  var chars$1 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
  var this$4 = $n($f_Llaika_parse_text_TextParsers__anyNot__C__sci_Seq__Llaika_parse_text_Characters(this$2, 10, chars$1));
  var v = new $c_sjsr_AnonFunction0((() => 0));
  return this.closeWith__Llaika_parse_Parser__Llaika_parse_Parser__F0__F2__Llaika_parse_Parser($x_1, new $c_Llaika_parse_Parser$$anon$1(v, this$4), new $c_sjsr_AnonFunction0((() => (("Expected closing '" + $cToS(char)) + "'"))), captureError);
});
$c_Llaika_internal_parse_hocon_HoconParsers$ClosingParserOps.prototype.closeWith__Llaika_parse_Parser__Llaika_parse_Parser__F0__F2__Llaika_parse_Parser = (function(closingParser, fallbackParser, msg, captureError) {
  var $x_1 = this.Llaika_internal_parse_hocon_HoconParsers$ClosingParserOps__f_parser;
  var this$3 = $n($n(closingParser).as__F0__Llaika_parse_Parser(new $c_sjsr_AnonFunction0((() => new $c_T2(0, (void 0))))));
  var p = new $c_sjsr_AnonFunction0((() => $n(fallbackParser).withCursor__Llaika_parse_Parser()));
  return $n($n($x_1).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(this$3.orElse__F0__Llaika_parse_Parser(p))).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Llaika_parse_builders$$tilde(x$1);
    if ((x$1$1 !== null)) {
      var x6 = $n(x$1$1).Llaika_parse_builders$$tilde__f__1;
      var x7 = $as_T2($n(x$1$1).Llaika_parse_builders$$tilde__f__2);
      if ((x7 !== null)) {
        var x8 = $uI($n(x7)._1__O());
        var x9 = $n(x7)._2__O();
        if ($is_Llaika_parse_SourceCursor(x9)) {
          var source = $as_Llaika_parse_SourceCursor(x9);
          var $x_2 = $n(captureError);
          var this$5 = $m_Llaika_parse_Message$();
          var msg$1 = $as_T($n(msg).apply__O());
          var msgProvider = new $c_Llaika_parse_Message$$anon$2(msg$1, this$5);
          var next = $n(source).consume__I__Llaika_parse_SourceCursor(x8);
          var maxOffset = $n(next).offset__I();
          return $n($x_2).apply__O__O__O(x6, new $c_Llaika_parse_Failure(msgProvider, next, maxOffset));
        }
      }
      return x6;
    }
    throw new $c_s_MatchError(x$1$1);
  })));
});
var $d_Llaika_internal_parse_hocon_HoconParsers$ClosingParserOps = new $TypeData().initClass($c_Llaika_internal_parse_hocon_HoconParsers$ClosingParserOps, "laika.internal.parse.hocon.HoconParsers$ClosingParserOps", ({
  Llaika_internal_parse_hocon_HoconParsers$ClosingParserOps: 1
}));
function $f_Llaika_internal_parse_hocon_IncludeResource__asRequired__Llaika_internal_parse_hocon_IncludeResource($thiz) {
  matchResult36: {
    var $x_1;
    if (($thiz instanceof $c_Llaika_internal_parse_hocon_IncludeUrl)) {
      var i = $as_Llaika_internal_parse_hocon_IncludeUrl($thiz);
      $n(i);
      var this$1 = $n(i);
      var resourceId = this$1.Llaika_internal_parse_hocon_IncludeUrl__f_resourceId;
      var $x_1 = new $c_Llaika_internal_parse_hocon_IncludeUrl(resourceId, true);
      break matchResult36;
    }
    if (($thiz instanceof $c_Llaika_internal_parse_hocon_IncludeFile)) {
      var i$2 = $as_Llaika_internal_parse_hocon_IncludeFile($thiz);
      $n(i$2);
      var this$3 = $n(i$2);
      var resourceId$1 = this$3.Llaika_internal_parse_hocon_IncludeFile__f_resourceId;
      var $x_1 = new $c_Llaika_internal_parse_hocon_IncludeFile(resourceId$1, true);
      break matchResult36;
    }
    if (($thiz instanceof $c_Llaika_internal_parse_hocon_IncludeClassPath)) {
      var i$3 = $as_Llaika_internal_parse_hocon_IncludeClassPath($thiz);
      $n(i$3);
      var this$5 = $n(i$3);
      var resourceId$2 = this$5.Llaika_internal_parse_hocon_IncludeClassPath__f_resourceId;
      var $x_1 = new $c_Llaika_internal_parse_hocon_IncludeClassPath(resourceId$2, true);
      break matchResult36;
    }
    if (($thiz instanceof $c_Llaika_internal_parse_hocon_IncludeAny)) {
      var i$4 = $as_Llaika_internal_parse_hocon_IncludeAny($thiz);
      $n(i$4);
      var this$7 = $n(i$4);
      var resourceId$3 = this$7.Llaika_internal_parse_hocon_IncludeAny__f_resourceId;
      var $x_1 = new $c_Llaika_internal_parse_hocon_IncludeAny(resourceId$3, true);
      break matchResult36;
    }
    throw new $c_s_MatchError($thiz);
  }
  return $as_Llaika_internal_parse_hocon_IncludeResource($x_1);
}
function $is_Llaika_internal_parse_hocon_IncludeResource(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_internal_parse_hocon_IncludeResource)));
}
function $as_Llaika_internal_parse_hocon_IncludeResource(obj) {
  return (($is_Llaika_internal_parse_hocon_IncludeResource(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.hocon.IncludeResource"));
}
function $isArrayOf_Llaika_internal_parse_hocon_IncludeResource(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_hocon_IncludeResource)));
}
function $asArrayOf_Llaika_internal_parse_hocon_IncludeResource(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_hocon_IncludeResource(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.hocon.IncludeResource;", depth));
}
/** @constructor */
function $c_Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser(outer) {
  this.Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser__f_recursive$lzy1 = null;
  this.Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser__f_recursivebitmap$1 = false;
  this.Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser__f_nonRecursive$lzy1 = null;
  this.Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser__f_nonRecursivebitmap$1 = false;
  this.Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser__f_$outer = outer;
}
$c_Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser.prototype = new $h_O();
$c_Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser.prototype.constructor = $c_Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser;
/** @constructor */
function $h_Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser() {
}
$h_Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser.prototype = $c_Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser.prototype;
$c_Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser.prototype.recursive__Llaika_parse_Parser = (function() {
  if ((!this.Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser__f_recursivebitmap$1)) {
    var this$3 = $m_Llaika_parse_builders$();
    var this$1 = $m_Llaika_parse_builders$();
    var p = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_blankLines;
    var $x_1 = $n($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$1, p));
    var this$2 = $n(this.Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser__f_$outer);
    var p$1 = $n($x_1).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($n($n(this$2.Llaika_internal_parse_markup_RootParser__f_markupParser).createBlockListParser__Llaika_parse_Parser__Llaika_parse_Parser($n(this.Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser__f_$outer).nestedBlock__Llaika_parse_Parser())).map__F1__Llaika_parse_Parser($n($n(this$2.Llaika_internal_parse_markup_RootParser__f_markupExtensions).Llaika_api_bundle_MarkupExtensions__f_parserHooks).Llaika_api_bundle_ParserHooks__f_postProcessBlocks));
    this.Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser__f_recursive$lzy1 = $f_Llaika_parse_combinator_Parsers__consumeAll__Llaika_parse_Parser__Llaika_parse_Parser(this$3, p$1);
    this.Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser__f_recursivebitmap$1 = true;
  }
  return this.Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser__f_recursive$lzy1;
});
$c_Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser.prototype.nonRecursive__Llaika_parse_Parser = (function() {
  if ((!this.Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser__f_nonRecursivebitmap$1)) {
    var this$3 = $m_Llaika_parse_builders$();
    var this$1 = $m_Llaika_parse_builders$();
    var p = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_blankLines;
    var $x_1 = $n($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$1, p));
    var this$2 = $n(this.Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser__f_$outer);
    var p$1 = $n($x_1).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($n($n(this$2.Llaika_internal_parse_markup_RootParser__f_markupParser).createBlockListParser__Llaika_parse_Parser__Llaika_parse_Parser($n(this.Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser__f_$outer).fallbackBlock__Llaika_parse_Parser())).map__F1__Llaika_parse_Parser($n($n(this$2.Llaika_internal_parse_markup_RootParser__f_markupExtensions).Llaika_api_bundle_MarkupExtensions__f_parserHooks).Llaika_api_bundle_ParserHooks__f_postProcessBlocks));
    this.Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser__f_nonRecursive$lzy1 = $f_Llaika_parse_combinator_Parsers__consumeAll__Llaika_parse_Parser__Llaika_parse_Parser(this$3, p$1);
    this.Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser__f_nonRecursivebitmap$1 = true;
  }
  return this.Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser__f_nonRecursive$lzy1;
});
$c_Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser.prototype.parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed = (function(source) {
  var p = (($n(source).nestLevel__I() < $n(this.Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser__f_$outer).Llaika_internal_parse_markup_RootParser__f_laika$internal$parse$markup$DefaultRecursiveParsers$$maxNestLevel) ? this.recursive__Llaika_parse_Parser() : this.nonRecursive__Llaika_parse_Parser());
  return $n(p).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed($n(source).nextNestLevel__Llaika_parse_SourceCursor());
});
var $d_Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser = new $TypeData().initClass($c_Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser, "laika.internal.parse.markup.DefaultRecursiveParsers$InternalRecursiveBlockParser", ({
  Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser: 1
}));
function $p_Llaika_internal_parse_markup_DocumentParser$__create__Llaika_parse_Parser__Llaika_parse_Parser__F3__F1($thiz, rootParser, configParser, docFactory) {
  return $thiz.forParser__F1__F1(new $c_sjsr_AnonFunction1(((path) => {
    var path$1 = $as_Llaika_ast_Path(path);
    var this$4 = $n(configParser);
    var p = new $c_sjsr_AnonFunction0((() => {
      var this$3 = $m_Llaika_parse_combinator_Parsers$();
      var this$2 = $m_Llaika_api_config_ConfigParser$();
      var v = new $c_Llaika_api_config_ConfigParser$$anon$2(this$2);
      return $f_Llaika_parse_combinator_Parsers__success__O__Llaika_parse_Parser(this$3, v);
    }));
    var configHeader = this$4.orElse__F0__Llaika_parse_Parser(p);
    var p$1 = $n(configHeader).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(rootParser);
    return $m_Llaika_parse_syntax$Map2Ops$().mapN$extension__Llaika_parse_Parser__F2__Llaika_parse_Parser(p$1, new $c_sjsr_AnonFunction2(((_$1, _$2) => {
      var _$1$1 = $as_Llaika_api_config_ConfigParser(_$1);
      var _$2$1 = $as_Llaika_ast_ElementContainer(_$2);
      return $n(docFactory).apply__O__O__O__O(path$1, _$1$1, _$2$1);
    })));
  })));
}
/** @constructor */
function $c_Llaika_internal_parse_markup_DocumentParser$() {
}
$c_Llaika_internal_parse_markup_DocumentParser$.prototype = new $h_O();
$c_Llaika_internal_parse_markup_DocumentParser$.prototype.constructor = $c_Llaika_internal_parse_markup_DocumentParser$;
/** @constructor */
function $h_Llaika_internal_parse_markup_DocumentParser$() {
}
$h_Llaika_internal_parse_markup_DocumentParser$.prototype = $c_Llaika_internal_parse_markup_DocumentParser$.prototype;
$c_Llaika_internal_parse_markup_DocumentParser$.prototype.forMarkup__Llaika_api_format_MarkupFormat__Llaika_api_bundle_MarkupExtensions__Llaika_api_bundle_ConfigProvider__F1 = (function(markupParser, markupExtensions, configProvider) {
  var rootParser = new $c_Llaika_internal_parse_markup_RootParser(markupParser, markupExtensions).rootElement__Llaika_parse_Parser();
  var preProcess = new $c_sjsr_AnonFunction1(((input) => {
    var input$1 = $as_Llaika_internal_parse_markup_DocumentParser$DocumentInput(input);
    var raw = $n($n(input$1).Llaika_internal_parse_markup_DocumentParser$DocumentInput__f_source).input__T();
    var preprocessed = $as_T($n($n($n(markupExtensions).Llaika_api_bundle_MarkupExtensions__f_parserHooks).Llaika_api_bundle_ParserHooks__f_preProcessInput).apply__O__O(raw));
    var source$1 = $m_Llaika_parse_SourceCursor$().apply__T__Llaika_ast_Path__Llaika_parse_SourceCursor(preprocessed, $n(input$1).Llaika_internal_parse_markup_DocumentParser$DocumentInput__f_path);
    var this$2 = $n(input$1);
    var path$1 = this$2.Llaika_internal_parse_markup_DocumentParser$DocumentInput__f_path;
    $n(input$1);
    return new $c_Llaika_internal_parse_markup_DocumentParser$DocumentInput(path$1, source$1);
  }));
  var g = this.forMarkup__Llaika_parse_Parser__Llaika_api_bundle_ConfigProvider__F1(rootParser, configProvider);
  return $n($f_F1__andThen__F1__F1(preProcess, g)).andThen__F1__F1(new $c_sjsr_AnonFunction1(((_$3) => {
    var _$3$1 = $as_s_util_Either(_$3);
    return $n(_$3$1).map__F1__s_util_Either($n($n(markupExtensions).Llaika_api_bundle_MarkupExtensions__f_parserHooks).Llaika_api_bundle_ParserHooks__f_postProcessDocument);
  })));
});
$c_Llaika_internal_parse_markup_DocumentParser$.prototype.forMarkup__Llaika_parse_Parser__Llaika_api_bundle_ConfigProvider__F1 = (function(rootParser, configProvider) {
  return $p_Llaika_internal_parse_markup_DocumentParser$__create__Llaika_parse_Parser__Llaika_parse_Parser__F3__F1(this, rootParser, $n(configProvider).markupConfigHeader__Llaika_parse_Parser(), new $c_sjsr_AnonFunction3(((path, config, root) => {
    var path$1 = $as_Llaika_ast_Path(path);
    var config$1 = $as_Llaika_api_config_ConfigParser(config);
    var root$1 = $as_Llaika_ast_RootElement(root);
    var doc = $n($m_Llaika_ast_Document$().apply__Llaika_ast_Path__Llaika_ast_RootElement__Llaika_ast_Document(path$1, root$1)).withFragments__sci_Map__Llaika_ast_Document($m_Llaika_ast_DocumentFragment$().collect__Llaika_ast_RootElement__sci_Map(root$1));
    return new $c_Llaika_ast_UnresolvedDocument(doc, config$1);
  })));
});
$c_Llaika_internal_parse_markup_DocumentParser$.prototype.forParser__F1__F1 = (function(p) {
  return new $c_sjsr_AnonFunction1(((in$1) => {
    var in$2 = $as_Llaika_internal_parse_markup_DocumentParser$DocumentInput(in$1);
    var this$2 = $m_Llaika_parse_combinator_Parsers$();
    var p$1 = $as_Llaika_parse_Parser($n(p).apply__O__O($n(in$2).Llaika_internal_parse_markup_DocumentParser$DocumentInput__f_path));
    var x5 = $n($f_Llaika_parse_combinator_Parsers__consumeAll__Llaika_parse_Parser__Llaika_parse_Parser(this$2, p$1)).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed($n(in$2).Llaika_internal_parse_markup_DocumentParser$DocumentInput__f_source);
    if ((x5 instanceof $c_Llaika_parse_Success)) {
      var x$1 = $as_Llaika_parse_Success(x5);
      var this$4 = $n(x$1);
      var x9 = this$4.Llaika_parse_Success__f_result;
      var this$5 = $n(x$1);
      return new $c_s_util_Right(x9);
    }
    if ((x5 instanceof $c_Llaika_parse_Failure)) {
      var f = $as_Llaika_parse_Failure(x5);
      var value = new $c_Llaika_api_errors_InvalidInput(f);
      return new $c_s_util_Left(value);
    }
    throw new $c_s_MatchError(x5);
  }));
});
var $d_Llaika_internal_parse_markup_DocumentParser$ = new $TypeData().initClass($c_Llaika_internal_parse_markup_DocumentParser$, "laika.internal.parse.markup.DocumentParser$", ({
  Llaika_internal_parse_markup_DocumentParser$: 1
}));
var $n_Llaika_internal_parse_markup_DocumentParser$;
function $m_Llaika_internal_parse_markup_DocumentParser$() {
  if ((!$n_Llaika_internal_parse_markup_DocumentParser$)) {
    $n_Llaika_internal_parse_markup_DocumentParser$ = new $c_Llaika_internal_parse_markup_DocumentParser$();
  }
  return $n_Llaika_internal_parse_markup_DocumentParser$;
}
function $is_Llaika_internal_parse_markup_InlineResult(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_internal_parse_markup_InlineResult)));
}
function $as_Llaika_internal_parse_markup_InlineResult(obj) {
  return (($is_Llaika_internal_parse_markup_InlineResult(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.markup.InlineResult"));
}
function $isArrayOf_Llaika_internal_parse_markup_InlineResult(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_markup_InlineResult)));
}
function $asArrayOf_Llaika_internal_parse_markup_InlineResult(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_markup_InlineResult(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.markup.InlineResult;", depth));
}
function $p_Llaika_internal_parse_uri_AutoLinkParsers__reverse__I__F0__Llaika_parse_Parser($thiz, offset, p) {
  var this$11 = $m_Llaika_parse_Parser$();
  var f = new $c_sjsr_AnonFunction1(((in$1) => {
    var in$2 = $as_Llaika_parse_SourceCursor(in$1);
    matchResult1: {
      var $x_1;
      var x1 = $n($as_Llaika_parse_Parser($n(p).apply__O())).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed($n($n(in$2).reverse__Llaika_parse_SourceCursor()).consume__I__Llaika_parse_SourceCursor(offset));
      if ((x1 instanceof $c_Llaika_parse_Success)) {
        var x$1 = $as_Llaika_parse_Success(x1);
        var this$2 = $n(x$1);
        var x9 = $as_T(this$2.Llaika_parse_Success__f_result);
        var this$3 = $n(x$1);
        var result = $m_sc_StringOps$().reverse$extension__T__T(x9);
        var $x_1 = new $c_Llaika_parse_Success(result, in$2);
        break matchResult1;
      }
      if ((x1 instanceof $c_Llaika_parse_Failure)) {
        var x$1$1 = $as_Llaika_parse_Failure(x1);
        var this$7 = $n(x$1$1);
        var x4 = this$7.Llaika_parse_Failure__f_msgProvider;
        var this$8 = $n(x$1$1);
        var this$9 = $n(x$1$1);
        var maxOffset = $n(in$2).offset__I();
        var $x_1 = new $c_Llaika_parse_Failure(x4, in$2, maxOffset);
        break matchResult1;
      }
      throw new $c_s_MatchError(x1);
    }
    return $as_Llaika_parse_Parsed($x_1);
  }));
  return new $c_Llaika_parse_Parser$$anon$2(f, this$11);
}
function $p_Llaika_internal_parse_uri_AutoLinkParsers__trim__Llaika_parse_Parser__Llaika_parse_Parser($thiz, p) {
  return $n(p).$greater$greater__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((res) => {
    var res$1 = $as_T3(res);
    var this$15 = $m_Llaika_parse_Parser$();
    var f = new $c_sjsr_AnonFunction1(((in$1) => {
      var in$2 = $as_Llaika_parse_SourceCursor(in$1);
      if ((res$1 !== null)) {
        var start = $as_T($n(res$1).T3__f__1);
        var sep = $as_T($n(res$1).T3__f__2);
        var end = $as_T($n(res$1).T3__f__3);
        var startTrimmed = $m_sc_StringOps$().dropWhile$extension__T__F1__T(start, $thiz.Llaika_internal_parse_uri_AutoLinkParsers__f_stripStartChars);
        var $x_2 = $m_sc_StringOps$();
        var $x_1 = $m_sc_StringOps$();
        var x = $m_sc_StringOps$().reverse$extension__T__T(end);
        var x$1 = $n($x_1).dropWhile$extension__T__F1__T(x, $thiz.Llaika_internal_parse_uri_AutoLinkParsers__f_stripEndChars);
        var endTrimmed = $n($x_2).reverse$extension__T__T(x$1);
        var uri = ((("" + startTrimmed) + sep) + endTrimmed);
        var uriWithScheme = (((sep === "@") && (!((uri.length >= 0) && ($as_T(uri.substring(0, 7)) === "mailto:")))) ? ("mailto:" + uri) : uri);
        var $x_3 = $n(in$2);
        var this$6 = $n(endTrimmed);
        var this$7 = $n(end);
        var nextIn = $n($x_3).consume__I__Llaika_parse_SourceCursor(((this$6.length - this$7.length) | 0));
        var this$8 = $n(startTrimmed);
        var length = this$8.length;
        var this$9 = $n($m_Llaika_ast_SpanLink$().external__T__Llaika_ast_SpanLink$Companion(uriWithScheme));
        var texts = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([]));
        var target = $as_Llaika_ast_Span($f_Llaika_ast_SpanContainerCompanion__apply__T__sci_Seq__O(this$9, uri, texts));
        var content = (("" + sep) + endTrimmed);
        var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
        var fallback = new $c_Llaika_ast_Text(content, options);
        var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
        var result = new $c_Llaika_ast_Reverse(length, target, fallback, options$1);
        return new $c_Llaika_parse_Success(result, nextIn);
      }
      throw new $c_s_MatchError(res$1);
    }));
    return new $c_Llaika_parse_Parser$$anon$2(f, this$15);
  })));
}
function $p_Llaika_internal_parse_uri_AutoLinkParsers__uri__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser__T__Llaika_parse_text_PrefixedParser($thiz, reverseParser, forwardParser, separator) {
  var this$8 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = $n(forwardParser).startChars__O();
  var rev = $p_Llaika_internal_parse_uri_AutoLinkParsers__reverse__I__F0__Llaika_parse_Parser($thiz, 0, new $c_sjsr_AnonFunction0((() => $n(reverseParser).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser($thiz.Llaika_internal_parse_uri_AutoLinkParsers__f_reverseMarkupStart))));
  var this$5 = $n(forwardParser);
  var this$4 = $m_Llaika_parse_builders$();
  var this$3 = $n($m_Llaika_parse_builders$().Llaika_parse_builders$__f_eol);
  var p = new $c_sjsr_AnonFunction0((() => $thiz.Llaika_internal_parse_uri_AutoLinkParsers__f_afterEndMarkup));
  var p$1 = this$3.orElse__F0__Llaika_parse_Parser(p);
  var p$2 = $f_Llaika_parse_combinator_Parsers__lookAhead__Llaika_parse_Parser__Llaika_parse_Parser(this$4, p$1);
  var fwd = $f_Llaika_parse_text_PrefixedParser__$less$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$5, p$2);
  var p$3 = $n(rev).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($as_Llaika_parse_Parser(fwd));
  var parser = $m_Llaika_parse_syntax$Map2Ops$().mapN$extension__Llaika_parse_Parser__F2__Llaika_parse_Parser(p$3, new $c_sjsr_AnonFunction2(((_$1, _$2) => {
    var _$1$1 = $as_T(_$1);
    var _$2$1 = $as_T(_$2);
    return new $c_T3(_$1$1, separator, _$2$1);
  })));
  var p$4 = $p_Llaika_internal_parse_uri_AutoLinkParsers__trim__Llaika_parse_Parser__Llaika_parse_Parser($thiz, parser);
  return new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p$4, this$8);
}
/** @constructor */
function $c_Llaika_internal_parse_uri_AutoLinkParsers(reverseMarkupStart, afterEndMarkup, stripStartChars, stripEndChars) {
  this.Llaika_internal_parse_uri_AutoLinkParsers__f_reverseMarkupStart = null;
  this.Llaika_internal_parse_uri_AutoLinkParsers__f_afterEndMarkup = null;
  this.Llaika_internal_parse_uri_AutoLinkParsers__f_stripStartChars = null;
  this.Llaika_internal_parse_uri_AutoLinkParsers__f_stripEndChars = null;
  this.Llaika_internal_parse_uri_AutoLinkParsers__f_http$lzy1 = null;
  this.Llaika_internal_parse_uri_AutoLinkParsers__f_httpbitmap$1 = false;
  this.Llaika_internal_parse_uri_AutoLinkParsers__f_www$lzy1 = null;
  this.Llaika_internal_parse_uri_AutoLinkParsers__f_wwwbitmap$1 = false;
  this.Llaika_internal_parse_uri_AutoLinkParsers__f_email$lzy1 = null;
  this.Llaika_internal_parse_uri_AutoLinkParsers__f_emailbitmap$1 = false;
  this.Llaika_internal_parse_uri_AutoLinkParsers__f_reverseMarkupStart = reverseMarkupStart;
  this.Llaika_internal_parse_uri_AutoLinkParsers__f_afterEndMarkup = afterEndMarkup;
  this.Llaika_internal_parse_uri_AutoLinkParsers__f_stripStartChars = stripStartChars;
  this.Llaika_internal_parse_uri_AutoLinkParsers__f_stripEndChars = stripEndChars;
}
$c_Llaika_internal_parse_uri_AutoLinkParsers.prototype = new $h_O();
$c_Llaika_internal_parse_uri_AutoLinkParsers.prototype.constructor = $c_Llaika_internal_parse_uri_AutoLinkParsers;
/** @constructor */
function $h_Llaika_internal_parse_uri_AutoLinkParsers() {
}
$h_Llaika_internal_parse_uri_AutoLinkParsers.prototype = $c_Llaika_internal_parse_uri_AutoLinkParsers.prototype;
$c_Llaika_internal_parse_uri_AutoLinkParsers.prototype.http__Llaika_api_bundle_SpanParserBuilder = (function() {
  if ((!this.Llaika_internal_parse_uri_AutoLinkParsers__f_httpbitmap$1)) {
    this.Llaika_internal_parse_uri_AutoLinkParsers__f_http$lzy1 = $n($m_Llaika_api_bundle_SpanParserBuilder$().standalone__Llaika_parse_text_PrefixedParser__Llaika_api_bundle_SpanParserBuilder($p_Llaika_internal_parse_uri_AutoLinkParsers__uri__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser__T__Llaika_parse_text_PrefixedParser(this, $as_Llaika_parse_Parser($m_Llaika_parse_syntax$LiteralStringOps$().$bar$extension__T__T__Llaika_parse_text_PrefixedParser("ptth", "sptth")), $m_Llaika_parse_syntax$LiteralStringOps$().$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(":", $m_Llaika_internal_parse_uri_URIParsers$().Llaika_internal_parse_uri_URIParsers$__f_httpUriNoScheme), ":"))).withLowPrecedence__Llaika_api_bundle_SpanParserBuilder();
    this.Llaika_internal_parse_uri_AutoLinkParsers__f_httpbitmap$1 = true;
  }
  return this.Llaika_internal_parse_uri_AutoLinkParsers__f_http$lzy1;
});
$c_Llaika_internal_parse_uri_AutoLinkParsers.prototype.www__Llaika_api_bundle_SpanParserBuilder = (function() {
  if ((!this.Llaika_internal_parse_uri_AutoLinkParsers__f_wwwbitmap$1)) {
    var $x_5 = $m_Llaika_api_bundle_SpanParserBuilder$();
    $m_Llaika_parse_builders$();
    var $x_4 = new $c_Llaika_parse_text_Literal("www");
    var $x_3 = $m_Llaika_parse_syntax$LiteralStringOps$();
    var $x_2 = $n($n($m_Llaika_internal_parse_uri_URIParsers$().Llaika_internal_parse_uri_URIParsers$__f_regName).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($m_Llaika_internal_parse_uri_URIParsers$().Llaika_internal_parse_uri_URIParsers$__f_path));
    var this$4 = $m_Llaika_parse_builders$();
    var p = $as_Llaika_parse_Parser($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("?", $m_Llaika_internal_parse_uri_URIParsers$().Llaika_internal_parse_uri_URIParsers$__f_query));
    var $x_1 = $n($x_2).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$4, p));
    var this$6 = $m_Llaika_parse_builders$();
    var p$1 = $as_Llaika_parse_Parser($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("#", $m_Llaika_internal_parse_uri_URIParsers$().Llaika_internal_parse_uri_URIParsers$__f_fragment));
    this.Llaika_internal_parse_uri_AutoLinkParsers__f_www$lzy1 = $n($n($x_5).standalone__Llaika_parse_text_PrefixedParser__Llaika_api_bundle_SpanParserBuilder($p_Llaika_internal_parse_uri_AutoLinkParsers__uri__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser__T__Llaika_parse_text_PrefixedParser(this, $x_4, $n($x_3).$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(".", $n($n($x_1).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$6, p$1))).source__Llaika_parse_Parser()), "."))).withLowPrecedence__Llaika_api_bundle_SpanParserBuilder();
    this.Llaika_internal_parse_uri_AutoLinkParsers__f_wwwbitmap$1 = true;
  }
  return this.Llaika_internal_parse_uri_AutoLinkParsers__f_www$lzy1;
});
$c_Llaika_internal_parse_uri_AutoLinkParsers.prototype.email__Llaika_api_bundle_SpanParserBuilder = (function() {
  if ((!this.Llaika_internal_parse_uri_AutoLinkParsers__f_emailbitmap$1)) {
    var $x_1 = $m_Llaika_api_bundle_SpanParserBuilder$();
    var this$6 = $m_Llaika_parse_text_PrefixedParser$();
    var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
    var rev = $p_Llaika_internal_parse_uri_AutoLinkParsers__reverse__I__F0__Llaika_parse_Parser(this, 0, new $c_sjsr_AnonFunction0((() => $n($m_Llaika_internal_parse_uri_URIParsers$().Llaika_internal_parse_uri_URIParsers$__f_localPart).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser(this.Llaika_internal_parse_uri_AutoLinkParsers__f_reverseMarkupStart))));
    var this$5 = $n($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("@", $m_Llaika_internal_parse_uri_URIParsers$().Llaika_internal_parse_uri_URIParsers$__f_domain));
    var this$4 = $m_Llaika_parse_builders$();
    var this$3 = $n($m_Llaika_parse_builders$().Llaika_parse_builders$__f_eol);
    var p = new $c_sjsr_AnonFunction0((() => this.Llaika_internal_parse_uri_AutoLinkParsers__f_afterEndMarkup));
    var p$1 = this$3.orElse__F0__Llaika_parse_Parser(p);
    var p$2 = $f_Llaika_parse_combinator_Parsers__lookAhead__Llaika_parse_Parser__Llaika_parse_Parser(this$4, p$1);
    var fwd = $f_Llaika_parse_text_PrefixedParser__$less$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$5, p$2);
    var \u03b41$ = $n(rev).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($as_Llaika_parse_Parser(fwd));
    var parser = $n(\u03b41$).collect__s_PartialFunction__F1__Llaika_parse_Parser(new $c_Llaika_internal_parse_uri_AutoLinkParsers$$anon$1(), $n(\u03b41$).collect$default$2__F1());
    var p$3 = $p_Llaika_internal_parse_uri_AutoLinkParsers__trim__Llaika_parse_Parser__Llaika_parse_Parser(this, parser);
    this.Llaika_internal_parse_uri_AutoLinkParsers__f_email$lzy1 = $n($n($x_1).standalone__Llaika_parse_text_PrefixedParser__Llaika_api_bundle_SpanParserBuilder(new $c_Llaika_parse_text_PrefixedParser$$anon$2(64, chars, p$3, this$6))).withLowPrecedence__Llaika_api_bundle_SpanParserBuilder();
    this.Llaika_internal_parse_uri_AutoLinkParsers__f_emailbitmap$1 = true;
  }
  return this.Llaika_internal_parse_uri_AutoLinkParsers__f_email$lzy1;
});
var $d_Llaika_internal_parse_uri_AutoLinkParsers = new $TypeData().initClass($c_Llaika_internal_parse_uri_AutoLinkParsers, "laika.internal.parse.uri.AutoLinkParsers", ({
  Llaika_internal_parse_uri_AutoLinkParsers: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_uri_URIParsers$() {
  this.Llaika_internal_parse_uri_URIParsers$__f_alpha = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_digit = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_hexdig = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_subDelims = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_unreserved = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_pctEncoded = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_ipvFuture = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_ipv4address = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_ipv6address = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_ipLiteral = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_regName = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_host = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_port = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_userInfo = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_authority = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_pChar = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_path = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_query = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_fragment = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_hierPart = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_httpUriNoScheme = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_dotAtomText = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_localPart = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_domain = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_addrSpec = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_to = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_hfields = null;
  this.Llaika_internal_parse_uri_URIParsers$__f_emailAddress = null;
  $n_Llaika_internal_parse_uri_URIParsers$ = this;
  var this$1 = $m_Llaika_parse_builders$();
  var chars = $m_Llaika_parse_text_CharGroup$().Llaika_parse_text_CharGroup$__f_alpha;
  this.Llaika_internal_parse_uri_URIParsers$__f_alpha = $f_Llaika_parse_text_TextParsers__anyOf__O__Llaika_parse_text_Characters(this$1, chars);
  var this$2 = $m_Llaika_parse_builders$();
  var chars$1 = $m_Llaika_parse_text_CharGroup$().Llaika_parse_text_CharGroup$__f_digit;
  this.Llaika_internal_parse_uri_URIParsers$__f_digit = $f_Llaika_parse_text_TextParsers__anyOf__O__Llaika_parse_text_Characters(this$2, chars$1);
  var this$7 = $m_Llaika_parse_builders$();
  var this$3 = $m_Llaika_parse_builders$();
  var value = $f_Llaika_parse_text_TextParsers__range__C__C__O(this$3, 48, 57);
  var this$6 = new $c_Lcats_data_NonEmptySetOps(value);
  var this$5 = $m_Llaika_parse_builders$();
  var as = $f_Llaika_parse_text_TextParsers__range__C__C__O(this$5, 65, 70);
  var chars$2 = this$6.union__O__O(as);
  this.Llaika_internal_parse_uri_URIParsers$__f_hexdig = $f_Llaika_parse_text_TextParsers__anyOf__O__Llaika_parse_text_Characters(this$7, chars$2);
  var this$8 = $m_Llaika_parse_builders$();
  var chars$3 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([36, 38, 39, 40, 41, 42, 43, 44, 59, 61])));
  this.Llaika_internal_parse_uri_URIParsers$__f_subDelims = $as_Llaika_parse_Parser($f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser(this$8, 33, chars$3));
  var this$10 = $n($n(this.Llaika_internal_parse_uri_URIParsers$__f_alpha).take__I__Llaika_parse_text_Characters(1));
  var p = new $c_sjsr_AnonFunction0((() => $n(this.Llaika_internal_parse_uri_URIParsers$__f_digit).take__I__Llaika_parse_text_Characters(1)));
  var this$12 = $n(this$10.orElse__F0__Llaika_parse_Parser(p));
  var p$1 = new $c_sjsr_AnonFunction0((() => {
    var this$11 = $m_Llaika_parse_builders$();
    var chars$4 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([46, 95, 126])));
    return $as_Llaika_parse_Parser($f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser(this$11, 45, chars$4));
  }));
  this.Llaika_internal_parse_uri_URIParsers$__f_unreserved = this$12.orElse__F0__Llaika_parse_Parser(p$1);
  var this$14 = $n($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("%", $n(this.Llaika_internal_parse_uri_URIParsers$__f_hexdig).take__I__Llaika_parse_text_Characters(2)));
  var this$15 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = this$14.startChars__O();
  var p$2 = $c_Llaika_parse_Parser.prototype.source__Llaika_parse_Parser.call(this$14);
  this.Llaika_internal_parse_uri_URIParsers$__f_pctEncoded = new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p$2, this$15);
  var this$17 = $n($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("v", $n(this.Llaika_internal_parse_uri_URIParsers$__f_hexdig).min__I__Llaika_parse_text_Characters(1)));
  var this$22 = $n($f_Llaika_parse_text_PrefixedParser__$tilde__T__Llaika_parse_text_PrefixedParser(this$17, "."));
  var this$18 = $n(this.Llaika_internal_parse_uri_URIParsers$__f_unreserved);
  var p$3 = new $c_sjsr_AnonFunction0((() => this.Llaika_internal_parse_uri_URIParsers$__f_subDelims));
  var $x_1 = this$18.orElse__F0__Llaika_parse_Parser(p$3);
  var this$19 = $m_s_$less$colon$less$();
  var this$20 = $n($n($x_1).$bar__T__s_$less$colon$less__Llaika_parse_Parser(":", this$19.s_$less$colon$less$__f_singleton));
  var p$4 = new $c_Llaika_parse_combinator_Repeat(this$20, 0, 2147483647, $m_s_None$()).min__I__Llaika_parse_combinator_Repeat(1);
  var this$23 = $n($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$22, p$4));
  var this$24 = $m_Llaika_parse_text_PrefixedParser$();
  var sc$1 = this$23.startChars__O();
  var p$5 = $c_Llaika_parse_Parser.prototype.source__Llaika_parse_Parser.call(this$23);
  this.Llaika_internal_parse_uri_URIParsers$__f_ipvFuture = new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc$1, p$5, this$24);
  var decOctet = $n($n($n(this.Llaika_internal_parse_uri_URIParsers$__f_digit).min__I__Llaika_parse_text_Characters(1)).max__I__Llaika_parse_text_Characters(3)).evalMap__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((res) => {
    var res$1 = $as_T(res);
    var this$27 = $m_jl_Integer$();
    var num = this$27.parseInt__T__I__I(res$1, 10);
    return (((num >= 0) && (num < 256)) ? new $c_s_util_Right(num) : new $c_s_util_Left("Number must be between 1 and 255"));
  })));
  this.Llaika_internal_parse_uri_URIParsers$__f_ipv4address = $n($n($n(decOctet).rep__T__Llaika_parse_combinator_Repeat(".")).take__I__Llaika_parse_combinator_Repeat(4)).source__Llaika_parse_Parser();
  var h16 = $n($n(this.Llaika_internal_parse_uri_URIParsers$__f_hexdig).min__I__Llaika_parse_text_Characters(1)).max__I__Llaika_parse_text_Characters(4);
  var h16Col = $n(h16).$tilde__T__Llaika_parse_Parser(":");
  var this$30 = $n($n($n(h16).$tilde__T__Llaika_parse_Parser(":")).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(h16));
  var p$6 = new $c_sjsr_AnonFunction0((() => this.Llaika_internal_parse_uri_URIParsers$__f_ipv4address));
  var ls32 = this$30.orElse__F0__Llaika_parse_Parser(p$6);
  var this$31 = $n(h16Col);
  var this$37 = $n($n(new $c_Llaika_parse_combinator_Repeat(this$31, 0, 2147483647, $m_s_None$()).take__I__Llaika_parse_combinator_Repeat(6)).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(ls32));
  var p$7 = new $c_sjsr_AnonFunction0((() => {
    var $x_2 = $m_Llaika_parse_syntax$LiteralStringOps$();
    var this$34 = $n(h16Col);
    var this$36 = $n($n($x_2).$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("::", new $c_Llaika_parse_combinator_Repeat(this$34, 0, 2147483647, $m_s_None$()).take__I__Llaika_parse_combinator_Repeat(5)));
    return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$36, ls32));
  }));
  var this$41 = $n(this$37.orElse__F0__Llaika_parse_Parser(p$7));
  var p$8 = new $c_sjsr_AnonFunction0((() => {
    var this$38 = $m_Llaika_parse_builders$();
    var $x_3 = $n($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$38, h16)).$tilde__T__Llaika_parse_Parser("::");
    var this$39 = $n(h16Col);
    return $n($n($x_3).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(new $c_Llaika_parse_combinator_Repeat(this$39, 0, 2147483647, $m_s_None$()).take__I__Llaika_parse_combinator_Repeat(4))).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(ls32);
  }));
  var this$47 = $n(this$41.orElse__F0__Llaika_parse_Parser(p$8));
  var p$10 = new $c_sjsr_AnonFunction0((() => {
    var this$44 = $m_Llaika_parse_builders$();
    var this$42 = $n(h16Col);
    var p$9 = $n(new $c_Llaika_parse_combinator_Repeat(this$42, 0, 2147483647, $m_s_None$()).max__I__Llaika_parse_combinator_Repeat(1)).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(h16);
    var $x_4 = $n($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$44, p$9)).$tilde__T__Llaika_parse_Parser("::");
    var this$45 = $n(h16Col);
    return $n($n($x_4).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(new $c_Llaika_parse_combinator_Repeat(this$45, 0, 2147483647, $m_s_None$()).max__I__Llaika_parse_combinator_Repeat(3))).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(ls32);
  }));
  var this$53 = $n(this$47.orElse__F0__Llaika_parse_Parser(p$10));
  var p$12 = new $c_sjsr_AnonFunction0((() => {
    var this$50 = $m_Llaika_parse_builders$();
    var this$48 = $n(h16Col);
    var p$11 = $n(new $c_Llaika_parse_combinator_Repeat(this$48, 0, 2147483647, $m_s_None$()).max__I__Llaika_parse_combinator_Repeat(2)).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(h16);
    var $x_5 = $n($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$50, p$11)).$tilde__T__Llaika_parse_Parser("::");
    var this$51 = $n(h16Col);
    return $n($n($x_5).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(new $c_Llaika_parse_combinator_Repeat(this$51, 0, 2147483647, $m_s_None$()).max__I__Llaika_parse_combinator_Repeat(2))).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(ls32);
  }));
  var this$57 = $n(this$53.orElse__F0__Llaika_parse_Parser(p$12));
  var p$14 = new $c_sjsr_AnonFunction0((() => {
    var this$56 = $m_Llaika_parse_builders$();
    var this$54 = $n(h16Col);
    var p$13 = $n(new $c_Llaika_parse_combinator_Repeat(this$54, 0, 2147483647, $m_s_None$()).max__I__Llaika_parse_combinator_Repeat(3)).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(h16);
    return $n($n($n($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$56, p$13)).$tilde__T__Llaika_parse_Parser("::")).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(h16Col)).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(ls32);
  }));
  var this$61 = $n(this$57.orElse__F0__Llaika_parse_Parser(p$14));
  var p$16 = new $c_sjsr_AnonFunction0((() => {
    var this$60 = $m_Llaika_parse_builders$();
    var this$58 = $n(h16Col);
    var p$15 = $n(new $c_Llaika_parse_combinator_Repeat(this$58, 0, 2147483647, $m_s_None$()).max__I__Llaika_parse_combinator_Repeat(4)).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(h16);
    return $n($n($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$60, p$15)).$tilde__T__Llaika_parse_Parser("::")).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(ls32);
  }));
  var this$65 = $n(this$61.orElse__F0__Llaika_parse_Parser(p$16));
  var p$18 = new $c_sjsr_AnonFunction0((() => {
    var this$64 = $m_Llaika_parse_builders$();
    var this$62 = $n(h16Col);
    var p$17 = $n(new $c_Llaika_parse_combinator_Repeat(this$62, 0, 2147483647, $m_s_None$()).max__I__Llaika_parse_combinator_Repeat(5)).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(h16);
    return $n($n($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$64, p$17)).$tilde__T__Llaika_parse_Parser("::")).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(h16);
  }));
  var this$69 = $n(this$65.orElse__F0__Llaika_parse_Parser(p$18));
  var p$20 = new $c_sjsr_AnonFunction0((() => {
    var this$68 = $m_Llaika_parse_builders$();
    var this$66 = $n(h16Col);
    var p$19 = $n(new $c_Llaika_parse_combinator_Repeat(this$66, 0, 2147483647, $m_s_None$()).max__I__Llaika_parse_combinator_Repeat(6)).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(h16);
    return $n($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$68, p$19)).$tilde__T__Llaika_parse_Parser("::");
  }));
  this.Llaika_internal_parse_uri_URIParsers$__f_ipv6address = $n(this$69.orElse__F0__Llaika_parse_Parser(p$20)).source__Llaika_parse_Parser();
  var $x_6 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var this$71 = $n(this.Llaika_internal_parse_uri_URIParsers$__f_ipv6address);
  var p$21 = new $c_sjsr_AnonFunction0((() => this.Llaika_internal_parse_uri_URIParsers$__f_ipvFuture));
  var this$72 = $n($n($x_6).$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("[", this$71.orElse__F0__Llaika_parse_Parser(p$21)));
  var this$73 = $n($f_Llaika_parse_text_PrefixedParser__$tilde__T__Llaika_parse_text_PrefixedParser(this$72, "]"));
  var this$74 = $m_Llaika_parse_text_PrefixedParser$();
  var sc$2 = this$73.startChars__O();
  var p$22 = $c_Llaika_parse_Parser.prototype.source__Llaika_parse_Parser.call(this$73);
  this.Llaika_internal_parse_uri_URIParsers$__f_ipLiteral = new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc$2, p$22, this$74);
  var this$75 = $n(this.Llaika_internal_parse_uri_URIParsers$__f_unreserved);
  var p$23 = new $c_sjsr_AnonFunction0((() => this.Llaika_internal_parse_uri_URIParsers$__f_pctEncoded));
  var this$76 = $n(this$75.orElse__F0__Llaika_parse_Parser(p$23));
  var p$24 = new $c_sjsr_AnonFunction0((() => this.Llaika_internal_parse_uri_URIParsers$__f_subDelims));
  var this$77 = $n(this$76.orElse__F0__Llaika_parse_Parser(p$24));
  this.Llaika_internal_parse_uri_URIParsers$__f_regName = new $c_Llaika_parse_combinator_Repeat(this$77, 0, 2147483647, $m_s_None$()).source__Llaika_parse_Parser();
  var this$79 = $n(this.Llaika_internal_parse_uri_URIParsers$__f_ipLiteral);
  var p$25 = new $c_sjsr_AnonFunction0((() => this.Llaika_internal_parse_uri_URIParsers$__f_ipv4address));
  var this$80 = $n(this$79.orElse__F0__Llaika_parse_Parser(p$25));
  var p$26 = new $c_sjsr_AnonFunction0((() => this.Llaika_internal_parse_uri_URIParsers$__f_regName));
  this.Llaika_internal_parse_uri_URIParsers$__f_host = this$80.orElse__F0__Llaika_parse_Parser(p$26);
  this.Llaika_internal_parse_uri_URIParsers$__f_port = $n(this.Llaika_internal_parse_uri_URIParsers$__f_digit).min__I__Llaika_parse_text_Characters(1);
  var this$81 = $n(this.Llaika_internal_parse_uri_URIParsers$__f_unreserved);
  var p$27 = new $c_sjsr_AnonFunction0((() => $n(this.Llaika_internal_parse_uri_URIParsers$__f_pctEncoded).source__Llaika_parse_Parser()));
  var this$82 = $n(this$81.orElse__F0__Llaika_parse_Parser(p$27));
  var p$28 = new $c_sjsr_AnonFunction0((() => this.Llaika_internal_parse_uri_URIParsers$__f_subDelims));
  var $x_7 = this$82.orElse__F0__Llaika_parse_Parser(p$28);
  var this$83 = $m_s_$less$colon$less$();
  var this$84 = $n($n($x_7).$bar__T__s_$less$colon$less__Llaika_parse_Parser(":", this$83.s_$less$colon$less$__f_singleton));
  this.Llaika_internal_parse_uri_URIParsers$__f_userInfo = new $c_Llaika_parse_combinator_Repeat(this$84, 0, 2147483647, $m_s_None$()).source__Llaika_parse_Parser();
  var this$86 = $m_Llaika_parse_builders$();
  var p$29 = $n(this.Llaika_internal_parse_uri_URIParsers$__f_userInfo).$tilde__T__Llaika_parse_Parser("@");
  var $x_8 = $n($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$86, p$29)).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(this.Llaika_internal_parse_uri_URIParsers$__f_host);
  var this$88 = $m_Llaika_parse_builders$();
  var p$30 = $as_Llaika_parse_Parser($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(":", this.Llaika_internal_parse_uri_URIParsers$__f_port));
  this.Llaika_internal_parse_uri_URIParsers$__f_authority = $n($n($x_8).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$88, p$30))).source__Llaika_parse_Parser();
  var this$89 = $n(this.Llaika_internal_parse_uri_URIParsers$__f_unreserved);
  var p$31 = new $c_sjsr_AnonFunction0((() => this.Llaika_internal_parse_uri_URIParsers$__f_pctEncoded));
  var this$90 = $n(this$89.orElse__F0__Llaika_parse_Parser(p$31));
  var p$32 = new $c_sjsr_AnonFunction0((() => this.Llaika_internal_parse_uri_URIParsers$__f_subDelims));
  var this$92 = $n(this$90.orElse__F0__Llaika_parse_Parser(p$32));
  var p$33 = new $c_sjsr_AnonFunction0((() => {
    var this$91 = $m_Llaika_parse_builders$();
    var chars$5 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([64])));
    return $as_Llaika_parse_Parser($f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser(this$91, 58, chars$5));
  }));
  this.Llaika_internal_parse_uri_URIParsers$__f_pChar = this$92.orElse__F0__Llaika_parse_Parser(p$33);
  var $x_9 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var this$94 = $n(this.Llaika_internal_parse_uri_URIParsers$__f_pChar);
  var segment = $n($x_9).$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("/", new $c_Llaika_parse_combinator_Repeat(this$94, 0, 2147483647, $m_s_None$()));
  var this$96 = $n($as_Llaika_parse_Parser(segment));
  this.Llaika_internal_parse_uri_URIParsers$__f_path = new $c_Llaika_parse_combinator_Repeat(this$96, 0, 2147483647, $m_s_None$()).source__Llaika_parse_Parser();
  var this$99 = $n(this.Llaika_internal_parse_uri_URIParsers$__f_pChar);
  var p$34 = new $c_sjsr_AnonFunction0((() => {
    var this$98 = $m_Llaika_parse_builders$();
    var chars$6 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([63])));
    return $as_Llaika_parse_Parser($f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser(this$98, 47, chars$6));
  }));
  var this$100 = $n(this$99.orElse__F0__Llaika_parse_Parser(p$34));
  this.Llaika_internal_parse_uri_URIParsers$__f_query = new $c_Llaika_parse_combinator_Repeat(this$100, 0, 2147483647, $m_s_None$()).source__Llaika_parse_Parser();
  this.Llaika_internal_parse_uri_URIParsers$__f_fragment = this.Llaika_internal_parse_uri_URIParsers$__f_query;
  var this$103 = $n($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("//", this.Llaika_internal_parse_uri_URIParsers$__f_authority));
  var p$35 = this.Llaika_internal_parse_uri_URIParsers$__f_path;
  var this$104 = $n($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$103, p$35));
  var this$105 = $m_Llaika_parse_text_PrefixedParser$();
  var sc$3 = this$104.startChars__O();
  var p$36 = $c_Llaika_parse_Parser.prototype.source__Llaika_parse_Parser.call(this$104);
  this.Llaika_internal_parse_uri_URIParsers$__f_hierPart = new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc$3, p$36, this$105);
  var $x_11 = $n(this.Llaika_internal_parse_uri_URIParsers$__f_hierPart);
  var this$107 = $m_Llaika_parse_builders$();
  var p$37 = $as_Llaika_parse_Parser($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("?", this.Llaika_internal_parse_uri_URIParsers$__f_query));
  var $x_10 = $n($x_11).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$107, p$37));
  var this$109 = $m_Llaika_parse_builders$();
  var p$38 = $as_Llaika_parse_Parser($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("#", this.Llaika_internal_parse_uri_URIParsers$__f_fragment));
  this.Llaika_internal_parse_uri_URIParsers$__f_httpUriNoScheme = $n($n($x_10).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$109, p$38))).source__Llaika_parse_Parser();
  var this$111 = $n($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("http:", this.Llaika_internal_parse_uri_URIParsers$__f_httpUriNoScheme));
  var this$112 = $m_Llaika_parse_text_PrefixedParser$();
  var sc$4 = this$111.startChars__O();
  var p$39 = $c_Llaika_parse_Parser.prototype.source__Llaika_parse_Parser.call(this$111);
  new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc$4, p$39, this$112);
  var this$114 = $n($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("https:", this.Llaika_internal_parse_uri_URIParsers$__f_httpUriNoScheme));
  var this$115 = $m_Llaika_parse_text_PrefixedParser$();
  var sc$5 = this$114.startChars__O();
  var p$40 = $c_Llaika_parse_Parser.prototype.source__Llaika_parse_Parser.call(this$114);
  new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc$5, p$40, this$115);
  var this$116 = $n($n(this.Llaika_internal_parse_uri_URIParsers$__f_alpha).min__I__Llaika_parse_text_Characters(1));
  var p$41 = new $c_sjsr_AnonFunction0((() => $n(this.Llaika_internal_parse_uri_URIParsers$__f_digit).min__I__Llaika_parse_text_Characters(1)));
  var this$118 = $n(this$116.orElse__F0__Llaika_parse_Parser(p$41));
  var p$42 = new $c_sjsr_AnonFunction0((() => {
    var this$117 = $m_Llaika_parse_builders$();
    var chars$7 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([35, 36, 37, 38, 39, 42, 43, 45, 47, 61, 63, 94, 95, 96, 123, 124, 125, 126])));
    return $f_Llaika_parse_text_TextParsers__someOf__C__sci_Seq__Llaika_parse_text_PrefixCharacters(this$117, 33, chars$7);
  }));
  var atext = this$118.orElse__F0__Llaika_parse_Parser(p$42);
  var this$119 = $n(atext);
  this.Llaika_internal_parse_uri_URIParsers$__f_dotAtomText = $n($n(new $c_Llaika_parse_combinator_Repeat(this$119, 0, 2147483647, $m_s_None$()).rep__T__Llaika_parse_combinator_Repeat(".")).min__I__Llaika_parse_combinator_Repeat(1)).source__Llaika_parse_Parser();
  this.Llaika_internal_parse_uri_URIParsers$__f_localPart = this.Llaika_internal_parse_uri_URIParsers$__f_dotAtomText;
  var this$125 = $m_Llaika_parse_builders$();
  var this$121 = $m_Llaika_parse_builders$();
  var value$1 = $f_Llaika_parse_text_TextParsers__range__C__C__O(this$121, 33, 90);
  var this$124 = new $c_Lcats_data_NonEmptySetOps(value$1);
  var this$123 = $m_Llaika_parse_builders$();
  var as$1 = $f_Llaika_parse_text_TextParsers__range__C__C__O(this$123, 94, 126);
  var chars$8 = this$124.union__O__O(as$1);
  var dtextNoObs = $f_Llaika_parse_text_TextParsers__anyOf__O__Llaika_parse_text_Characters(this$125, chars$8);
  var this$128 = $n(this.Llaika_internal_parse_uri_URIParsers$__f_dotAtomText);
  var p$43 = new $c_sjsr_AnonFunction0((() => {
    var this$127 = $n($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("[", dtextNoObs));
    return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$tilde__T__Llaika_parse_text_PrefixedParser(this$127, "]"));
  }));
  this.Llaika_internal_parse_uri_URIParsers$__f_domain = $n(this$128.orElse__F0__Llaika_parse_Parser(p$43)).source__Llaika_parse_Parser();
  this.Llaika_internal_parse_uri_URIParsers$__f_addrSpec = $n($n($n(this.Llaika_internal_parse_uri_URIParsers$__f_localPart).$tilde__T__Llaika_parse_Parser("@")).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(this.Llaika_internal_parse_uri_URIParsers$__f_domain)).source__Llaika_parse_Parser();
  this.Llaika_internal_parse_uri_URIParsers$__f_to = $n($n($n(this.Llaika_internal_parse_uri_URIParsers$__f_addrSpec).rep__T__Llaika_parse_combinator_Repeat(",")).min__I__Llaika_parse_combinator_Repeat(1)).source__Llaika_parse_Parser();
  var this$129 = $m_Llaika_parse_builders$();
  var chars$9 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([36, 39, 40, 41, 42, 43, 44, 59, 58, 64])));
  var someDelims = $f_Llaika_parse_text_TextParsers__someOf__C__sci_Seq__Llaika_parse_text_PrefixCharacters(this$129, 33, chars$9);
  var this$130 = $n(this.Llaika_internal_parse_uri_URIParsers$__f_unreserved);
  var p$44 = new $c_sjsr_AnonFunction0((() => this.Llaika_internal_parse_uri_URIParsers$__f_pctEncoded));
  var this$131 = $n(this$130.orElse__F0__Llaika_parse_Parser(p$44));
  var p$45 = new $c_sjsr_AnonFunction0((() => someDelims));
  var qChar = this$131.orElse__F0__Llaika_parse_Parser(p$45);
  var this$132 = $n(qChar);
  var hfname = new $c_Llaika_parse_combinator_Repeat(this$132, 0, 2147483647, $m_s_None$());
  var this$134 = $n(qChar);
  var hfvalue = new $c_Llaika_parse_combinator_Repeat(this$134, 0, 2147483647, $m_s_None$());
  var hfield = $n(hfname.$tilde__T__Llaika_parse_Parser("=")).$tilde__Llaika_parse_Parser__Llaika_parse_Parser(hfvalue);
  var this$137 = $n($m_Llaika_parse_syntax$LiteralStringOps$().$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("?", $n($n(hfield).rep__T__Llaika_parse_combinator_Repeat("&")).min__I__Llaika_parse_combinator_Repeat(1)));
  var this$138 = $m_Llaika_parse_text_PrefixedParser$();
  var sc$6 = this$137.startChars__O();
  var p$46 = $c_Llaika_parse_Parser.prototype.source__Llaika_parse_Parser.call(this$137);
  this.Llaika_internal_parse_uri_URIParsers$__f_hfields = new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc$6, p$46, this$138);
  var $x_12 = this.Llaika_internal_parse_uri_URIParsers$__f_to;
  var this$139 = $m_Llaika_parse_builders$();
  var p$47 = this.Llaika_internal_parse_uri_URIParsers$__f_hfields;
  this.Llaika_internal_parse_uri_URIParsers$__f_emailAddress = $n($n($x_12).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$139, p$47))).source__Llaika_parse_Parser();
  var $x_13 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var this$141 = $m_Llaika_parse_builders$();
  var p$48 = this.Llaika_internal_parse_uri_URIParsers$__f_emailAddress;
  var this$142 = $n($n($x_13).$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("mailto:", $f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$141, p$48)));
  var this$143 = $m_Llaika_parse_text_PrefixedParser$();
  var sc$7 = this$142.startChars__O();
  var p$49 = $c_Llaika_parse_Parser.prototype.source__Llaika_parse_Parser.call(this$142);
  new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc$7, p$49, this$143);
}
$c_Llaika_internal_parse_uri_URIParsers$.prototype = new $h_O();
$c_Llaika_internal_parse_uri_URIParsers$.prototype.constructor = $c_Llaika_internal_parse_uri_URIParsers$;
/** @constructor */
function $h_Llaika_internal_parse_uri_URIParsers$() {
}
$h_Llaika_internal_parse_uri_URIParsers$.prototype = $c_Llaika_internal_parse_uri_URIParsers$.prototype;
var $d_Llaika_internal_parse_uri_URIParsers$ = new $TypeData().initClass($c_Llaika_internal_parse_uri_URIParsers$, "laika.internal.parse.uri.URIParsers$", ({
  Llaika_internal_parse_uri_URIParsers$: 1
}));
var $n_Llaika_internal_parse_uri_URIParsers$;
function $m_Llaika_internal_parse_uri_URIParsers$() {
  if ((!$n_Llaika_internal_parse_uri_URIParsers$)) {
    $n_Llaika_internal_parse_uri_URIParsers$ = new $c_Llaika_internal_parse_uri_URIParsers$();
  }
  return $n_Llaika_internal_parse_uri_URIParsers$;
}
/** @constructor */
function $c_Llaika_internal_render_ASTRenderer$NoRef$2$() {
}
$c_Llaika_internal_render_ASTRenderer$NoRef$2$.prototype = new $h_O();
$c_Llaika_internal_render_ASTRenderer$NoRef$2$.prototype.constructor = $c_Llaika_internal_render_ASTRenderer$NoRef$2$;
/** @constructor */
function $h_Llaika_internal_render_ASTRenderer$NoRef$2$() {
}
$h_Llaika_internal_render_ASTRenderer$NoRef$2$.prototype = $c_Llaika_internal_render_ASTRenderer$NoRef$2$.prototype;
function $as_Llaika_internal_render_ASTRenderer$NoRef$2$(obj) {
  return (((obj instanceof $c_Llaika_internal_render_ASTRenderer$NoRef$2$) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.render.ASTRenderer$NoRef$2$"));
}
function $isArrayOf_Llaika_internal_render_ASTRenderer$NoRef$2$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_render_ASTRenderer$NoRef$2$)));
}
function $asArrayOf_Llaika_internal_render_ASTRenderer$NoRef$2$(obj, depth) {
  return (($isArrayOf_Llaika_internal_render_ASTRenderer$NoRef$2$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.render.ASTRenderer$NoRef$2$;", depth));
}
var $d_Llaika_internal_render_ASTRenderer$NoRef$2$ = new $TypeData().initClass($c_Llaika_internal_render_ASTRenderer$NoRef$2$, "laika.internal.render.ASTRenderer$NoRef$2$", ({
  Llaika_internal_render_ASTRenderer$NoRef$2$: 1
}));
/** @constructor */
function $c_Llaika_internal_render_HTMLRenderer$WithFallback$2$() {
}
$c_Llaika_internal_render_HTMLRenderer$WithFallback$2$.prototype = new $h_O();
$c_Llaika_internal_render_HTMLRenderer$WithFallback$2$.prototype.constructor = $c_Llaika_internal_render_HTMLRenderer$WithFallback$2$;
/** @constructor */
function $h_Llaika_internal_render_HTMLRenderer$WithFallback$2$() {
}
$h_Llaika_internal_render_HTMLRenderer$WithFallback$2$.prototype = $c_Llaika_internal_render_HTMLRenderer$WithFallback$2$.prototype;
$c_Llaika_internal_render_HTMLRenderer$WithFallback$2$.prototype.unapply__Llaika_ast_Element__s_Option = (function(value) {
  if ($is_Llaika_ast_Fallback(value)) {
    var f = $as_Llaika_ast_Element($as_Llaika_ast_Fallback(value));
    var value$1 = $n($as_Llaika_ast_Fallback(f)).fallback__Llaika_ast_Element();
    return new $c_s_Some(value$1);
  } else {
    return $m_s_None$();
  }
});
function $as_Llaika_internal_render_HTMLRenderer$WithFallback$2$(obj) {
  return (((obj instanceof $c_Llaika_internal_render_HTMLRenderer$WithFallback$2$) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.render.HTMLRenderer$WithFallback$2$"));
}
function $isArrayOf_Llaika_internal_render_HTMLRenderer$WithFallback$2$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_render_HTMLRenderer$WithFallback$2$)));
}
function $asArrayOf_Llaika_internal_render_HTMLRenderer$WithFallback$2$(obj, depth) {
  return (($isArrayOf_Llaika_internal_render_HTMLRenderer$WithFallback$2$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.render.HTMLRenderer$WithFallback$2$;", depth));
}
var $d_Llaika_internal_render_HTMLRenderer$WithFallback$2$ = new $TypeData().initClass($c_Llaika_internal_render_HTMLRenderer$WithFallback$2$, "laika.internal.render.HTMLRenderer$WithFallback$2$", ({
  Llaika_internal_render_HTMLRenderer$WithFallback$2$: 1
}));
function $p_Llaika_internal_rewrite_RecursiveResolverRules$__rules$lzyINIT1$1__sr_LazyRef__Llaika_ast_RewritePhase__Z__Llaika_ast_DocumentCursor__Llaika_ast_RewriteRules__Llaika_ast_RewriteRules($thiz, rules$lzy1$1, phase$2, removeScopes$1, cursor$2, baseRules$2) {
  if ((rules$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Llaika_ast_RewriteRules(($n(rules$lzy1$1).sr_LazyRef__f__initialized ? $n(rules$lzy1$1).sr_LazyRef__f__value : $n(rules$lzy1$1).initialize__O__O($n($n($n($m_Llaika_ast_RewriteRules$().forBlocks__s_PartialFunction__Llaika_ast_RewriteRules(new $c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$1(phase$2, removeScopes$1, cursor$2, rules$lzy1$1, baseRules$2))).$plus$plus__Llaika_ast_RewriteRules__Llaika_ast_RewriteRules($m_Llaika_ast_RewriteRules$().forSpans__s_PartialFunction__Llaika_ast_RewriteRules(new $c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$2(phase$2, removeScopes$1, cursor$2, rules$lzy1$1, baseRules$2)))).$plus$plus__Llaika_ast_RewriteRules__Llaika_ast_RewriteRules($m_Llaika_ast_RewriteRules$().forTemplates__s_PartialFunction__Llaika_ast_RewriteRules(new $c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$3(phase$2, removeScopes$1, cursor$2, rules$lzy1$1, baseRules$2)))).$plus$plus__Llaika_ast_RewriteRules__Llaika_ast_RewriteRules(baseRules$2))));
}
/** @constructor */
function $c_Llaika_internal_rewrite_RecursiveResolverRules$() {
}
$c_Llaika_internal_rewrite_RecursiveResolverRules$.prototype = new $h_O();
$c_Llaika_internal_rewrite_RecursiveResolverRules$.prototype.constructor = $c_Llaika_internal_rewrite_RecursiveResolverRules$;
/** @constructor */
function $h_Llaika_internal_rewrite_RecursiveResolverRules$() {
}
$h_Llaika_internal_rewrite_RecursiveResolverRules$.prototype = $c_Llaika_internal_rewrite_RecursiveResolverRules$.prototype;
$c_Llaika_internal_rewrite_RecursiveResolverRules$.prototype.laika$internal$rewrite$RecursiveResolverRules$$$asTemplateSpan__Llaika_ast_Span__Llaika_ast_TemplateSpan = (function(span) {
  if ($is_Llaika_ast_TemplateSpan(span)) {
    var t = $as_Llaika_ast_TemplateSpan(span);
    return t;
  } else {
    var element = $as_Llaika_ast_Element(span);
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    return new $c_Llaika_ast_TemplateElement(element, 0, options);
  }
});
$c_Llaika_internal_rewrite_RecursiveResolverRules$.prototype.applyTo__Llaika_ast_DocumentCursor__Llaika_ast_RewriteRules__Llaika_ast_RewritePhase__Llaika_ast_RewriteRules = (function(cursor, baseRules, phase) {
  var rules$lzy1 = new $c_sr_LazyRef();
  var removeScopes = (phase instanceof $c_Llaika_ast_RewritePhase$Render);
  return this.laika$internal$rewrite$RecursiveResolverRules$$$_$rules$1__sr_LazyRef__Llaika_ast_RewritePhase__Z__Llaika_ast_DocumentCursor__Llaika_ast_RewriteRules__Llaika_ast_RewriteRules(rules$lzy1, phase, removeScopes, cursor, baseRules);
});
$c_Llaika_internal_rewrite_RecursiveResolverRules$.prototype.laika$internal$rewrite$RecursiveResolverRules$$$_$rulesForScope$1__Llaika_ast_DocumentCursor__Llaika_ast_RewriteRules__Llaika_ast_RewritePhase__Llaika_ast_ElementScope__Llaika_ast_RewriteRules = (function(cursor$1, baseRules$1, phase$1, scope) {
  return this.applyTo__Llaika_ast_DocumentCursor__Llaika_ast_RewriteRules__Llaika_ast_RewritePhase__Llaika_ast_RewriteRules($n(cursor$1).withReferenceContext__O__Llaika_api_config_ConfigEncoder__Llaika_ast_DocumentCursor($n(scope).context__Llaika_api_config_ConfigValue(), $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_configValue), baseRules$1, phase$1);
});
$c_Llaika_internal_rewrite_RecursiveResolverRules$.prototype.laika$internal$rewrite$RecursiveResolverRules$$$_$rules$1__sr_LazyRef__Llaika_ast_RewritePhase__Z__Llaika_ast_DocumentCursor__Llaika_ast_RewriteRules__Llaika_ast_RewriteRules = (function(rules$lzy1$5, phase$6, removeScopes$5, cursor$6, baseRules$6) {
  return $as_Llaika_ast_RewriteRules(($n(rules$lzy1$5).sr_LazyRef__f__initialized ? $n(rules$lzy1$5).sr_LazyRef__f__value : $p_Llaika_internal_rewrite_RecursiveResolverRules$__rules$lzyINIT1$1__sr_LazyRef__Llaika_ast_RewritePhase__Z__Llaika_ast_DocumentCursor__Llaika_ast_RewriteRules__Llaika_ast_RewriteRules(this, rules$lzy1$5, phase$6, removeScopes$5, cursor$6, baseRules$6)));
});
var $d_Llaika_internal_rewrite_RecursiveResolverRules$ = new $TypeData().initClass($c_Llaika_internal_rewrite_RecursiveResolverRules$, "laika.internal.rewrite.RecursiveResolverRules$", ({
  Llaika_internal_rewrite_RecursiveResolverRules$: 1
}));
var $n_Llaika_internal_rewrite_RecursiveResolverRules$;
function $m_Llaika_internal_rewrite_RecursiveResolverRules$() {
  if ((!$n_Llaika_internal_rewrite_RecursiveResolverRules$)) {
    $n_Llaika_internal_rewrite_RecursiveResolverRules$ = new $c_Llaika_internal_rewrite_RecursiveResolverRules$();
  }
  return $n_Llaika_internal_rewrite_RecursiveResolverRules$;
}
/** @constructor */
function $c_Llaika_internal_rewrite_ReferenceResolver(config) {
  this.Llaika_internal_rewrite_ReferenceResolver__f_config = null;
  this.Llaika_internal_rewrite_ReferenceResolver__f_config = config;
}
$c_Llaika_internal_rewrite_ReferenceResolver.prototype = new $h_O();
$c_Llaika_internal_rewrite_ReferenceResolver.prototype.constructor = $c_Llaika_internal_rewrite_ReferenceResolver;
/** @constructor */
function $h_Llaika_internal_rewrite_ReferenceResolver() {
}
$h_Llaika_internal_rewrite_ReferenceResolver.prototype = $c_Llaika_internal_rewrite_ReferenceResolver.prototype;
var $d_Llaika_internal_rewrite_ReferenceResolver = new $TypeData().initClass($c_Llaika_internal_rewrite_ReferenceResolver, "laika.internal.rewrite.ReferenceResolver", ({
  Llaika_internal_rewrite_ReferenceResolver: 1
}));
function $p_Llaika_internal_rewrite_ReferenceResolver$__collectSiblings$1__Llaika_ast_DocumentTree__sci_Vector($thiz, tree) {
  var this$1 = $n($n($n(tree).Llaika_ast_DocumentTree__f_content).toVector__sci_Vector());
  $m_sci_Vector$();
  var b = new $c_sci_VectorBuilder();
  var it = this$1.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var arg1 = $n(it).next__O();
    var x$1 = $as_Llaika_ast_TreeContent(arg1);
    matchResult2: {
      var elems;
      if ((x$1 instanceof $c_Llaika_ast_Document)) {
        var d = $as_Llaika_ast_Document(x$1);
        var elems = new $c_s_Some(d);
        break matchResult2;
      }
      if ((x$1 instanceof $c_Llaika_ast_DocumentTree)) {
        var t = $as_Llaika_ast_DocumentTree(x$1);
        var elems = $n(t).Llaika_ast_DocumentTree__f_titleDocument;
        break matchResult2;
      }
      throw new $c_s_MatchError(x$1);
    }
    b.addAll__sc_IterableOnce__sci_VectorBuilder(elems);
  }
  return b.result__sci_Vector();
}
function $p_Llaika_internal_rewrite_ReferenceResolver$__addDocConfig$1__Llaika_api_config_Key__s_Option__Llaika_api_config_ConfigBuilder__Llaika_api_config_ConfigBuilder($thiz, key, doc, builder) {
  var this$1 = $n(doc);
  if (this$1.isEmpty__Z()) {
    return builder;
  } else {
    var arg1 = this$1.get__O();
    var doc$1 = $as_Llaika_ast_Document(arg1);
    var value = $n($n(doc$1).path__Llaika_ast_Path()).toString__T();
    var sourcePath = new $c_Llaika_api_config_ConfigValue$StringValue(value);
    var $x_5 = $n(builder);
    var $x_4 = $m_sci_Seq$();
    var $x_3 = $m_sr_ScalaRunTime$();
    var value$1 = $m_Llaika_ast_RawLink$().internal__Llaika_ast_VirtualPath__Llaika_ast_RawLink($n(doc$1).path__Llaika_ast_Path());
    var value$2 = new $c_Llaika_api_config_ConfigValue$ASTValue(value$1);
    var origin = $m_Llaika_api_config_Origin$().Llaika_api_config_Origin$__f_root;
    var $x_2 = new $c_Llaika_api_config_Field("path", value$2, origin);
    var origin$1 = $m_Llaika_api_config_Origin$().Llaika_api_config_Origin$__f_root;
    var $x_1 = new $c_Llaika_api_config_Field("sourcePath", sourcePath, origin$1);
    var this$8 = $n($n(doc$1).title__s_Option());
    var value$3 = $as_Llaika_ast_Element((this$8.isEmpty__Z() ? $thiz.Llaika_internal_rewrite_ReferenceResolver$__f_emptyTitle : this$8.get__O()));
    var value$4 = new $c_Llaika_api_config_ConfigValue$ASTValue(value$3);
    var origin$2 = $m_Llaika_api_config_Origin$().Llaika_api_config_Origin$__f_root;
    var values = $as_sci_Seq($n($x_4).apply__sci_Seq__sc_SeqOps($n($x_3).wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_config_Field.getArrayOf().constr)([$x_2, $x_1, new $c_Llaika_api_config_Field("title", value$4, origin$2)]))));
    return $n($x_5).withValue__Llaika_api_config_Key__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigBuilder(key, new $c_Llaika_api_config_ConfigValue$ObjectValue(values), $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_configValue);
  }
}
/** @constructor */
function $c_Llaika_internal_rewrite_ReferenceResolver$() {
  this.Llaika_internal_rewrite_ReferenceResolver$__f_emptyTitle = null;
  $n_Llaika_internal_rewrite_ReferenceResolver$ = this;
  var spans = $m_sci_Nil$();
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  this.Llaika_internal_rewrite_ReferenceResolver$__f_emptyTitle = new $c_Llaika_ast_SpanSequence(spans, options);
}
$c_Llaika_internal_rewrite_ReferenceResolver$.prototype = new $h_O();
$c_Llaika_internal_rewrite_ReferenceResolver$.prototype.constructor = $c_Llaika_internal_rewrite_ReferenceResolver$;
/** @constructor */
function $h_Llaika_internal_rewrite_ReferenceResolver$() {
}
$h_Llaika_internal_rewrite_ReferenceResolver$.prototype = $c_Llaika_internal_rewrite_ReferenceResolver$.prototype;
$c_Llaika_internal_rewrite_ReferenceResolver$.prototype.forDocument__Llaika_ast_Document__Llaika_ast_TreeCursor__Llaika_internal_rewrite_ReferenceResolver = (function(document, parent) {
  var rootKey = $m_Llaika_api_config_Key$().apply__T__sci_Seq__Llaika_api_config_Key("cursor", $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([])));
  var this$1 = $n($n(document).title__s_Option());
  var title = $as_Llaika_ast_SpanSequence((this$1.isEmpty__Z() ? this.Llaika_internal_rewrite_ReferenceResolver$__f_emptyTitle : this$1.get__O()));
  $m_Llaika_api_config_ConfigBuilder$();
  var fallback = $n(document).config__Llaika_api_config_Config();
  var $x_12 = new $c_Llaika_api_config_ConfigBuilder($m_sci_Nil$(), $n(fallback).origin__Llaika_api_config_Origin(), fallback);
  var $x_11 = $n(rootKey).child__T__Llaika_api_config_Key("currentDocument");
  var $x_10 = $m_sci_Seq$();
  var $x_9 = $m_sr_ScalaRunTime$();
  var value = $n($n(document).path__Llaika_ast_Path()).toString__T();
  var value$1 = new $c_Llaika_api_config_ConfigValue$StringValue(value);
  var origin = $m_Llaika_api_config_Origin$().Llaika_api_config_Origin$__f_root;
  var $x_8 = new $c_Llaika_api_config_Field("sourcePath", value$1, origin);
  var value$2 = $n(document).Llaika_ast_Document__f_content;
  var value$3 = new $c_Llaika_api_config_ConfigValue$ASTValue(value$2);
  var origin$1 = $n($n(document).config__Llaika_api_config_Config()).origin__Llaika_api_config_Origin();
  var $x_7 = new $c_Llaika_api_config_Field("content", value$3, origin$1);
  var value$4 = new $c_Llaika_api_config_ConfigValue$ASTValue(title);
  var origin$2 = $n($n(document).config__Llaika_api_config_Config()).origin__Llaika_api_config_Origin();
  var $x_6 = new $c_Llaika_api_config_Field("title", value$4, origin$2);
  var this$10 = $n(title);
  var value$5 = $f_Llaika_ast_SpanContainer__extractText__T(this$10);
  var value$6 = new $c_Llaika_api_config_ConfigValue$StringValue(value$5);
  var origin$3 = $n($n(document).config__Llaika_api_config_Config()).origin__Llaika_api_config_Origin();
  var $x_5 = new $c_Llaika_api_config_Field("rawTitle", value$6, origin$3);
  var this$13 = $n($n(document).Llaika_ast_Document__f_fragments);
  var values = $as_sci_Seq($n($m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$13)).map__F1__O(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var name = $as_T($n(x$1$1)._1__O());
      var element = $as_Llaika_ast_Element($n(x$1$1)._2__O());
      var value$7 = new $c_Llaika_api_config_ConfigValue$ASTValue(element);
      var origin$4 = $n($n(document).config__Llaika_api_config_Config()).origin__Llaika_api_config_Origin();
      return new $c_Llaika_api_config_Field(name, value$7, origin$4);
    }
    throw new $c_s_MatchError(x$1$1);
  }))));
  var value$8 = new $c_Llaika_api_config_ConfigValue$ObjectValue(values);
  var origin$5 = $n($n(document).config__Llaika_api_config_Config()).origin__Llaika_api_config_Origin();
  var values$1 = $as_sci_Seq($n($x_10).apply__sci_Seq__sc_SeqOps($n($x_9).wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_config_Field.getArrayOf().constr)([$x_8, $x_7, $x_6, $x_5, new $c_Llaika_api_config_Field("fragments", value$8, origin$5)]))));
  var $x_4 = $n($x_12.withValue__Llaika_api_config_Key__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigBuilder($x_11, new $c_Llaika_api_config_ConfigValue$ObjectValue(values$1), $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_configValue));
  var $x_3 = $n(rootKey).child__T__Llaika_api_config_Key("root");
  var $x_2 = $m_sci_Seq$();
  var $x_1 = $m_sr_ScalaRunTime$();
  var this$19 = $n($n($n($n(parent).Llaika_ast_TreeCursor__f_root).Llaika_ast_RootCursor__f_target).Llaika_ast_DocumentTreeRoot__f_title);
  var value$9 = $as_Llaika_ast_Element((this$19.isEmpty__Z() ? this.Llaika_internal_rewrite_ReferenceResolver$__f_emptyTitle : this$19.get__O()));
  var value$10 = new $c_Llaika_api_config_ConfigValue$ASTValue(value$9);
  var origin$6 = $m_Llaika_api_config_Origin$().Llaika_api_config_Origin$__f_root;
  var values$2 = $as_sci_Seq($n($x_2).apply__sci_Seq__sc_SeqOps($n($x_1).wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_config_Field.getArrayOf().constr)([new $c_Llaika_api_config_Field("title", value$10, origin$6)]))));
  var baseBuilder = $n($x_4).withValue__Llaika_api_config_Key__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigBuilder($x_3, new $c_Llaika_api_config_ConfigValue$ObjectValue(values$2), $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_configValue);
  var flattenedSiblings = new $c_Llaika_internal_rewrite_ReferenceResolver$Siblings($n($n($n($n(parent).Llaika_ast_TreeCursor__f_root).Llaika_ast_RootCursor__f_target).allDocuments__sci_Seq()).toVector__sci_Vector(), $n(document).path__Llaika_ast_Path());
  var this$24 = $n($n($n(parent).Llaika_ast_TreeCursor__f_target).Llaika_ast_DocumentTree__f_titleDocument);
  if (this$24.isEmpty__Z()) {
    var $x_13 = $m_s_None$();
  } else {
    var arg1 = this$24.get__O();
    var _$2 = $as_Llaika_ast_Document(arg1);
    var $x_13 = new $c_s_Some($n(_$2).path__Llaika_ast_Path());
  }
  if ($n($x_13).contains__O__Z($n(document).path__Llaika_ast_Path())) {
    var $x_15 = $m_s_Option$();
    var this$25 = $n($n(parent).Llaika_ast_TreeCursor__f_parent);
    if (this$25.isEmpty__Z()) {
      var $x_14 = $m_s_None$();
    } else {
      var arg1$1 = this$25.get__O();
      var _$3 = $as_Llaika_ast_TreeCursor(arg1$1);
      var $x_14 = new $c_s_Some($n(_$3).Llaika_ast_TreeCursor__f_target);
    }
    var this$26 = $n($n($n($x_15).option2Iterable__s_Option__sc_Iterable($x_14)).toVector__sci_Vector());
    $m_sci_Vector$();
    var b = new $c_sci_VectorBuilder();
    var it = this$26.iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var arg1$2 = $n(it).next__O();
      var tree = $as_Llaika_ast_DocumentTree(arg1$2);
      var elems = $p_Llaika_internal_rewrite_ReferenceResolver$__collectSiblings$1__Llaika_ast_DocumentTree__sci_Vector(this, tree);
      b.addAll__sc_IterableOnce__sci_VectorBuilder(elems);
    }
    var hierarchicalSiblings = new $c_Llaika_internal_rewrite_ReferenceResolver$Siblings(b.result__sci_Vector(), $n(document).path__Llaika_ast_Path());
  } else {
    var hierarchicalSiblings = new $c_Llaika_internal_rewrite_ReferenceResolver$Siblings($p_Llaika_internal_rewrite_ReferenceResolver$__collectSiblings$1__Llaika_ast_DocumentTree__sci_Vector(this, $n(parent).Llaika_ast_TreeCursor__f_target), $n(document).path__Llaika_ast_Path());
  }
  var this$28 = new $c_sjsr_AnonFunction1(((_$4) => {
    var _$4$1 = $as_Llaika_api_config_ConfigBuilder(_$4);
    return $p_Llaika_internal_rewrite_ReferenceResolver$__addDocConfig$1__Llaika_api_config_Key__s_Option__Llaika_api_config_ConfigBuilder__Llaika_api_config_ConfigBuilder(this, $n(rootKey).child__T__Llaika_api_config_Key("parentDocument"), $n($n(parent).Llaika_ast_TreeCursor__f_target).Llaika_ast_DocumentTree__f_titleDocument, _$4$1);
  }));
  var key$1 = $n(rootKey).child__T__Llaika_api_config_Key("previousDocument");
  var doc$1 = $n(hierarchicalSiblings).previousDocument__s_Option();
  var g = new $c_sjsr_AnonFunction1(((builder) => {
    var builder$1 = $as_Llaika_api_config_ConfigBuilder(builder);
    return $p_Llaika_internal_rewrite_ReferenceResolver$__addDocConfig$1__Llaika_api_config_Key__s_Option__Llaika_api_config_ConfigBuilder__Llaika_api_config_ConfigBuilder(this, key$1, doc$1, builder$1);
  }));
  var $x_18 = $n($f_F1__andThen__F1__F1(this$28, g));
  var key$2 = $n(rootKey).child__T__Llaika_api_config_Key("nextDocument");
  var doc$2 = $n(hierarchicalSiblings).nextDocument__s_Option();
  var $x_17 = $n($x_18).andThen__F1__F1(new $c_sjsr_AnonFunction1(((builder$2) => {
    var builder$3 = $as_Llaika_api_config_ConfigBuilder(builder$2);
    return $p_Llaika_internal_rewrite_ReferenceResolver$__addDocConfig$1__Llaika_api_config_Key__s_Option__Llaika_api_config_ConfigBuilder__Llaika_api_config_ConfigBuilder(this, key$2, doc$2, builder$3);
  })));
  var key$3 = $n(rootKey).child__Llaika_api_config_Key__Llaika_api_config_Key($m_Llaika_api_config_Key$().apply__T__sci_Seq__Llaika_api_config_Key("flattenedSiblings", $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["previousDocument"]))));
  var doc$3 = flattenedSiblings.previousDocument__s_Option();
  var $x_16 = $n($n($x_17).andThen__F1__F1(new $c_sjsr_AnonFunction1(((builder$3$1) => {
    var builder$4 = $as_Llaika_api_config_ConfigBuilder(builder$3$1);
    return $p_Llaika_internal_rewrite_ReferenceResolver$__addDocConfig$1__Llaika_api_config_Key__s_Option__Llaika_api_config_ConfigBuilder__Llaika_api_config_ConfigBuilder(this, key$3, doc$3, builder$4);
  }))));
  var key$4 = $n(rootKey).child__Llaika_api_config_Key__Llaika_api_config_Key($m_Llaika_api_config_Key$().apply__T__sci_Seq__Llaika_api_config_Key("flattenedSiblings", $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["nextDocument"]))));
  var doc$4 = flattenedSiblings.nextDocument__s_Option();
  var addSiblings = $n($x_16).andThen__F1__F1(new $c_sjsr_AnonFunction1(((builder$4$1) => {
    var builder$5 = $as_Llaika_api_config_ConfigBuilder(builder$4$1);
    return $p_Llaika_internal_rewrite_ReferenceResolver$__addDocConfig$1__Llaika_api_config_Key__s_Option__Llaika_api_config_ConfigBuilder__Llaika_api_config_ConfigBuilder(this, key$4, doc$4, builder$5);
  })));
  return new $c_Llaika_internal_rewrite_ReferenceResolver($n($as_Llaika_api_config_ConfigBuilder($n(addSiblings).apply__O__O(baseBuilder))).build__Llaika_api_config_Config());
});
var $d_Llaika_internal_rewrite_ReferenceResolver$ = new $TypeData().initClass($c_Llaika_internal_rewrite_ReferenceResolver$, "laika.internal.rewrite.ReferenceResolver$", ({
  Llaika_internal_rewrite_ReferenceResolver$: 1
}));
var $n_Llaika_internal_rewrite_ReferenceResolver$;
function $m_Llaika_internal_rewrite_ReferenceResolver$() {
  if ((!$n_Llaika_internal_rewrite_ReferenceResolver$)) {
    $n_Llaika_internal_rewrite_ReferenceResolver$ = new $c_Llaika_internal_rewrite_ReferenceResolver$();
  }
  return $n_Llaika_internal_rewrite_ReferenceResolver$;
}
/** @constructor */
function $c_Llaika_internal_rewrite_ReferenceResolver$CursorKeys$() {
  this.Llaika_internal_rewrite_ReferenceResolver$CursorKeys$__f_documentContent = null;
  $n_Llaika_internal_rewrite_ReferenceResolver$CursorKeys$ = this;
  this.Llaika_internal_rewrite_ReferenceResolver$CursorKeys$__f_documentContent = $m_Llaika_api_config_Key$().apply__T__sci_Seq__Llaika_api_config_Key("cursor", $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["currentDocument", "content"])));
  $m_Llaika_api_config_Key$().apply__T__sci_Seq__Llaika_api_config_Key("cursor", $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["currentDocument", "title"])));
}
$c_Llaika_internal_rewrite_ReferenceResolver$CursorKeys$.prototype = new $h_O();
$c_Llaika_internal_rewrite_ReferenceResolver$CursorKeys$.prototype.constructor = $c_Llaika_internal_rewrite_ReferenceResolver$CursorKeys$;
/** @constructor */
function $h_Llaika_internal_rewrite_ReferenceResolver$CursorKeys$() {
}
$h_Llaika_internal_rewrite_ReferenceResolver$CursorKeys$.prototype = $c_Llaika_internal_rewrite_ReferenceResolver$CursorKeys$.prototype;
var $d_Llaika_internal_rewrite_ReferenceResolver$CursorKeys$ = new $TypeData().initClass($c_Llaika_internal_rewrite_ReferenceResolver$CursorKeys$, "laika.internal.rewrite.ReferenceResolver$CursorKeys$", ({
  Llaika_internal_rewrite_ReferenceResolver$CursorKeys$: 1
}));
var $n_Llaika_internal_rewrite_ReferenceResolver$CursorKeys$;
function $m_Llaika_internal_rewrite_ReferenceResolver$CursorKeys$() {
  if ((!$n_Llaika_internal_rewrite_ReferenceResolver$CursorKeys$)) {
    $n_Llaika_internal_rewrite_ReferenceResolver$CursorKeys$ = new $c_Llaika_internal_rewrite_ReferenceResolver$CursorKeys$();
  }
  return $n_Llaika_internal_rewrite_ReferenceResolver$CursorKeys$;
}
/** @constructor */
function $c_Llaika_internal_rewrite_ReferenceResolver$Siblings(documents, refPath) {
  this.Llaika_internal_rewrite_ReferenceResolver$Siblings__f_documents = null;
  this.Llaika_internal_rewrite_ReferenceResolver$Siblings__f_currentIndex = 0;
  this.Llaika_internal_rewrite_ReferenceResolver$Siblings__f_documents = documents;
  var this$1 = $n(documents);
  var this$2 = $n(this$1.iterator__sc_Iterator());
  _return: {
    var i = 0;
    var dropped = this$2.drop__I__sc_Iterator(0);
    while ($n(dropped).hasNext__Z()) {
      var arg1 = $n(dropped).next__O();
      var _$1 = $as_Llaika_ast_Document(arg1);
      var x = $n(_$1).path__Llaika_ast_Path();
      if (((x === null) ? (refPath === null) : $n(x).equals__O__Z(refPath))) {
        var $x_1 = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var $x_1 = (-1);
  }
  this.Llaika_internal_rewrite_ReferenceResolver$Siblings__f_currentIndex = $x_1;
}
$c_Llaika_internal_rewrite_ReferenceResolver$Siblings.prototype = new $h_O();
$c_Llaika_internal_rewrite_ReferenceResolver$Siblings.prototype.constructor = $c_Llaika_internal_rewrite_ReferenceResolver$Siblings;
/** @constructor */
function $h_Llaika_internal_rewrite_ReferenceResolver$Siblings() {
}
$h_Llaika_internal_rewrite_ReferenceResolver$Siblings.prototype = $c_Llaika_internal_rewrite_ReferenceResolver$Siblings.prototype;
$c_Llaika_internal_rewrite_ReferenceResolver$Siblings.prototype.previousDocument__s_Option = (function() {
  if ((this.Llaika_internal_rewrite_ReferenceResolver$Siblings__f_currentIndex <= 0)) {
    return $m_s_None$();
  } else {
    var value = $n(this.Llaika_internal_rewrite_ReferenceResolver$Siblings__f_documents).apply__I__O((((-1) + this.Llaika_internal_rewrite_ReferenceResolver$Siblings__f_currentIndex) | 0));
    return new $c_s_Some(value);
  }
});
$c_Llaika_internal_rewrite_ReferenceResolver$Siblings.prototype.nextDocument__s_Option = (function() {
  var this$1 = $n(this.Llaika_internal_rewrite_ReferenceResolver$Siblings__f_documents);
  if ($f_sc_SeqOps__isEmpty__Z(this$1)) {
    var $x_1 = true;
  } else {
    var $x_2 = this.Llaika_internal_rewrite_ReferenceResolver$Siblings__f_currentIndex;
    var this$2 = $n(this.Llaika_internal_rewrite_ReferenceResolver$Siblings__f_documents);
    var $x_1 = (((1 + $x_2) | 0) === this$2.length__I());
  }
  if ($x_1) {
    return $m_s_None$();
  } else {
    var value = $n(this.Llaika_internal_rewrite_ReferenceResolver$Siblings__f_documents).apply__I__O(((1 + this.Llaika_internal_rewrite_ReferenceResolver$Siblings__f_currentIndex) | 0));
    return new $c_s_Some(value);
  }
});
var $d_Llaika_internal_rewrite_ReferenceResolver$Siblings = new $TypeData().initClass($c_Llaika_internal_rewrite_ReferenceResolver$Siblings, "laika.internal.rewrite.ReferenceResolver$Siblings", ({
  Llaika_internal_rewrite_ReferenceResolver$Siblings: 1
}));
/** @constructor */
function $c_Llaika_parse_BlockSource$() {
}
$c_Llaika_parse_BlockSource$.prototype = new $h_O();
$c_Llaika_parse_BlockSource$.prototype.constructor = $c_Llaika_parse_BlockSource$;
/** @constructor */
function $h_Llaika_parse_BlockSource$() {
}
$h_Llaika_parse_BlockSource$.prototype = $c_Llaika_parse_BlockSource$.prototype;
$c_Llaika_parse_BlockSource$.prototype.apply__O__Llaika_parse_BlockSource = (function(lines) {
  var tc = $as_Lcats_Functor($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
  var this$5 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(lines, tc);
  var f = new $c_sjsr_AnonFunction1(((line) => {
    var line$1 = $as_Llaika_parse_LineSource(line);
    if ($f_T__endsWith__T__Z($n($n(line$1).Llaika_parse_LineSource__f_input), "\n")) {
      var $x_1 = $m_sc_StringOps$();
      var x = $n(line$1).Llaika_parse_LineSource__f_input;
      var input = $n($x_1).dropRight$extension__T__I__T(x, 1);
      var parent = $n(line$1).parent__Llaika_parse_SourceCursor();
      return new $c_Llaika_parse_LineSource(input, parent, 0, $n(parent).nestLevel__I());
    } else {
      return line$1;
    }
  }));
  var trimmedLines = $n(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  $m_Llaika_parse_InputString$();
  var tc$1 = $as_Lcats_Functor($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
  var this$7 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(trimmedLines, tc$1);
  var f$1 = new $c_sjsr_AnonFunction1(((_$4) => {
    var _$4$1 = $as_Llaika_parse_LineSource(_$4);
    return $n(_$4$1).Llaika_parse_LineSource__f_input;
  }));
  var fa = $n(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
  var A = $m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString;
  var F = $as_Lcats_Foldable($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
  var value = $m_Lcats_syntax_FoldableOps$().mkString_$extension__O__T__T__T__Lcats_Show__Lcats_Foldable__T(fa, "", "\n", "", A, F);
  $m_Llaika_parse_InputString$();
  var path = $m_s_None$();
  $m_Llaika_parse_InputString$();
  var isReverse = false;
  var input$1 = new $c_Llaika_parse_InputString(value, path, isReverse);
  return new $c_Llaika_parse_BlockSource(input$1, trimmedLines, 0, $n(($m_Lcats_data_NonEmptyChainImpl$(), $as_Llaika_parse_LineSource($m_Lcats_data_NonEmptyChainOps$().head$extension__O__O(lines)))).Llaika_parse_LineSource__f_nestLevel);
});
$c_Llaika_parse_BlockSource$.prototype.apply__Llaika_parse_LineSource__sci_Seq__Llaika_parse_BlockSource = (function(firstLine, rest) {
  return this.apply__O__Llaika_parse_BlockSource($n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptyChain).apply__O__sci_Seq__O(firstLine, rest));
});
var $d_Llaika_parse_BlockSource$ = new $TypeData().initClass($c_Llaika_parse_BlockSource$, "laika.parse.BlockSource$", ({
  Llaika_parse_BlockSource$: 1
}));
var $n_Llaika_parse_BlockSource$;
function $m_Llaika_parse_BlockSource$() {
  if ((!$n_Llaika_parse_BlockSource$)) {
    $n_Llaika_parse_BlockSource$ = new $c_Llaika_parse_BlockSource$();
  }
  return $n_Llaika_parse_BlockSource$;
}
/** @constructor */
function $c_Llaika_parse_InputString(value, path, isReverse) {
  this.Llaika_parse_InputString__f_value = null;
  this.Llaika_parse_InputString__f_path = null;
  this.Llaika_parse_InputString__f_isReverse = false;
  this.Llaika_parse_InputString__f_lineStarts$lzy1 = null;
  this.Llaika_parse_InputString__f_lineStartsbitmap$1 = false;
  this.Llaika_parse_InputString__f_reverse$lzy1 = null;
  this.Llaika_parse_InputString__f_reversebitmap$1 = false;
  this.Llaika_parse_InputString__f_value = value;
  this.Llaika_parse_InputString__f_path = path;
  this.Llaika_parse_InputString__f_isReverse = isReverse;
}
$c_Llaika_parse_InputString.prototype = new $h_O();
$c_Llaika_parse_InputString.prototype.constructor = $c_Llaika_parse_InputString;
/** @constructor */
function $h_Llaika_parse_InputString() {
}
$h_Llaika_parse_InputString.prototype = $c_Llaika_parse_InputString.prototype;
$c_Llaika_parse_InputString.prototype.lineStarts__AI = (function() {
  if ((!this.Llaika_parse_InputString__f_lineStartsbitmap$1)) {
    var lineStarts = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    lineStarts.addOne__O__scm_ArrayBuffer(0);
    var pos = 0;
    var this$1 = $n(this.Llaika_parse_InputString__f_value);
    var len = this$1.length;
    while ((pos < len)) {
      var x = this.Llaika_parse_InputString__f_value;
      var i = pos;
      var this$4 = $n(x);
      if (($charAt(this$4, i) === 10)) {
        var elem = ((1 + pos) | 0);
        lineStarts.addOne__O__scm_ArrayBuffer(elem);
      }
      pos = ((1 + pos) | 0);
    }
    lineStarts.addOne__O__scm_ArrayBuffer(len);
    if ((lineStarts.scm_ArrayBuffer__f_size0 >= 0)) {
      var len$1 = lineStarts.scm_ArrayBuffer__f_size0;
      var destination = new $ac_I(len$1);
      lineStarts.copyToArray__O__I__I__I(destination, 0, 2147483647);
      var $x_1 = destination;
    } else {
      var capacity = 0;
      var jsElems = null;
      capacity = 0;
      jsElems = [];
      var it = $n(lineStarts.view__scm_ArrayBufferView()).iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        var elem$1 = $n(it).next__O();
        var unboxedElem = ((elem$1 === null) ? 0 : elem$1);
        jsElems.push(unboxedElem);
      }
      var $x_1 = new $ac_I(new Int32Array(jsElems));
    }
    this.Llaika_parse_InputString__f_lineStarts$lzy1 = $x_1;
    this.Llaika_parse_InputString__f_lineStartsbitmap$1 = true;
  }
  return this.Llaika_parse_InputString__f_lineStarts$lzy1;
});
$c_Llaika_parse_InputString.prototype.reverse__Llaika_parse_InputString = (function() {
  if ((!this.Llaika_parse_InputString__f_reversebitmap$1)) {
    var $x_1 = $m_sc_StringOps$();
    var x = this.Llaika_parse_InputString__f_value;
    this.Llaika_parse_InputString__f_reverse$lzy1 = new $c_Llaika_parse_InputString($n($x_1).reverse$extension__T__T(x), this.Llaika_parse_InputString__f_path, (!this.Llaika_parse_InputString__f_isReverse));
    this.Llaika_parse_InputString__f_reversebitmap$1 = true;
  }
  return this.Llaika_parse_InputString__f_reverse$lzy1;
});
var $d_Llaika_parse_InputString = new $TypeData().initClass($c_Llaika_parse_InputString, "laika.parse.InputString", ({
  Llaika_parse_InputString: 1
}));
/** @constructor */
function $c_Llaika_parse_InputString$() {
  this.Llaika_parse_InputString$__f_empty = null;
  $n_Llaika_parse_InputString$ = this;
  this.Llaika_parse_InputString$__f_empty = new $c_Llaika_parse_InputString("", ($m_Llaika_parse_InputString$(), $m_s_None$()), ($m_Llaika_parse_InputString$(), false));
}
$c_Llaika_parse_InputString$.prototype = new $h_O();
$c_Llaika_parse_InputString$.prototype.constructor = $c_Llaika_parse_InputString$;
/** @constructor */
function $h_Llaika_parse_InputString$() {
}
$h_Llaika_parse_InputString$.prototype = $c_Llaika_parse_InputString$.prototype;
$c_Llaika_parse_InputString$.prototype.apply__T__s_Option__Z__Llaika_parse_InputString = (function(value, path, isReverse) {
  var this$1 = $n(value);
  return new $c_Llaika_parse_InputString($as_T(this$1.split("\r\n").join("\n")), path, isReverse);
});
var $d_Llaika_parse_InputString$ = new $TypeData().initClass($c_Llaika_parse_InputString$, "laika.parse.InputString$", ({
  Llaika_parse_InputString$: 1
}));
var $n_Llaika_parse_InputString$;
function $m_Llaika_parse_InputString$() {
  if ((!$n_Llaika_parse_InputString$)) {
    $n_Llaika_parse_InputString$ = new $c_Llaika_parse_InputString$();
  }
  return $n_Llaika_parse_InputString$;
}
function $is_Llaika_parse_Message(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_parse_Message)));
}
function $as_Llaika_parse_Message(obj) {
  return (($is_Llaika_parse_Message(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.parse.Message"));
}
function $isArrayOf_Llaika_parse_Message(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_parse_Message)));
}
function $asArrayOf_Llaika_parse_Message(obj, depth) {
  return (($isArrayOf_Llaika_parse_Message(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.parse.Message;", depth));
}
/** @constructor */
function $c_Llaika_parse_Message$() {
  this.Llaika_parse_Message$__f_UnexpectedEOF = null;
  this.Llaika_parse_Message$__f_ExpectedFailure = null;
  this.Llaika_parse_Message$__f_ExpectedEOF = null;
  this.Llaika_parse_Message$__f_ExpectedStart = null;
  this.Llaika_parse_Message$__f_ExpectedEOL = null;
  $n_Llaika_parse_Message$ = this;
  this.Llaika_parse_Message$__f_UnexpectedEOF = new $c_Llaika_parse_Message$$anon$2("Unexpected end of input", this);
  this.Llaika_parse_Message$__f_ExpectedFailure = new $c_Llaika_parse_Message$$anon$2("Expected failure, but parser succeeded", this);
  this.Llaika_parse_Message$__f_ExpectedEOF = new $c_Llaika_parse_Message$$anon$2("Expected end of input", this);
  this.Llaika_parse_Message$__f_ExpectedStart = new $c_Llaika_parse_Message$$anon$2("Expected start of input", this);
  this.Llaika_parse_Message$__f_ExpectedEOL = new $c_Llaika_parse_Message$$anon$2("Expected end of line", this);
}
$c_Llaika_parse_Message$.prototype = new $h_O();
$c_Llaika_parse_Message$.prototype.constructor = $c_Llaika_parse_Message$;
/** @constructor */
function $h_Llaika_parse_Message$() {
}
$h_Llaika_parse_Message$.prototype = $c_Llaika_parse_Message$.prototype;
var $d_Llaika_parse_Message$ = new $TypeData().initClass($c_Llaika_parse_Message$, "laika.parse.Message$", ({
  Llaika_parse_Message$: 1
}));
var $n_Llaika_parse_Message$;
function $m_Llaika_parse_Message$() {
  if ((!$n_Llaika_parse_Message$)) {
    $n_Llaika_parse_Message$ = new $c_Llaika_parse_Message$();
  }
  return $n_Llaika_parse_Message$;
}
/** @constructor */
function $c_Llaika_parse_Parsed() {
}
$c_Llaika_parse_Parsed.prototype = new $h_O();
$c_Llaika_parse_Parsed.prototype.constructor = $c_Llaika_parse_Parsed;
/** @constructor */
function $h_Llaika_parse_Parsed() {
}
$h_Llaika_parse_Parsed.prototype = $c_Llaika_parse_Parsed.prototype;
function $as_Llaika_parse_Parsed(obj) {
  return (((obj instanceof $c_Llaika_parse_Parsed) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.parse.Parsed"));
}
function $isArrayOf_Llaika_parse_Parsed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_parse_Parsed)));
}
function $asArrayOf_Llaika_parse_Parsed(obj, depth) {
  return (($isArrayOf_Llaika_parse_Parsed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.parse.Parsed;", depth));
}
function $ps_Llaika_parse_Parser__alt$lzyINIT1$1__sr_LazyRef__F0__Llaika_parse_Parser(alt$lzy1$1, p0$1) {
  if ((alt$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Llaika_parse_Parser(($n(alt$lzy1$1).sr_LazyRef__f__initialized ? $n(alt$lzy1$1).sr_LazyRef__f__value : $n(alt$lzy1$1).initialize__O__O($as_Llaika_parse_Parser($n(p0$1).apply__O()))));
}
function $ps_Llaika_parse_Parser__alt$1__sr_LazyRef__F0__Llaika_parse_Parser(alt$lzy1$2, p0$2) {
  return $as_Llaika_parse_Parser(($n(alt$lzy1$2).sr_LazyRef__f__initialized ? $n(alt$lzy1$2).sr_LazyRef__f__value : $ps_Llaika_parse_Parser__alt$lzyINIT1$1__sr_LazyRef__F0__Llaika_parse_Parser(alt$lzy1$2, p0$2)));
}
function $ps_Llaika_parse_Parser__loop$1__Llaika_parse_Parser__scm_ListBuffer__Llaika_parse_SourceCursor__Llaika_parse_Parsed(combined$1, elems$1, input) {
  var input$tailLocal1 = input;
  while (true) {
    var x37 = $n(combined$1).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(input$tailLocal1);
    if ((x37 instanceof $c_Llaika_parse_Success)) {
      var x$1 = $as_Llaika_parse_Success(x37);
      var this$2 = $n(x$1);
      var x48 = $as_Llaika_parse_builders$$tilde(this$2.Llaika_parse_Success__f_result);
      var this$3 = $n(x$1);
      var x49 = this$3.Llaika_parse_Success__f_next;
      if ((x48 !== null)) {
        var x51 = $n(x48).Llaika_parse_builders$$tilde__f__1;
        var x52 = $as_s_Option($n(x48).Llaika_parse_builders$$tilde__f__2);
        if ((x52 instanceof $c_s_Some)) {
          var endCond = $n($as_s_Some(x52)).s_Some__f_value;
          var this$5 = $n(elems$1);
          this$5.addOne__O__scm_ListBuffer(x51);
          var _1 = $n(elems$1).toList__sci_List();
          var _2 = new $c_s_Some(endCond);
          var result = new $c_T2(_1, _2);
          return new $c_Llaika_parse_Success(result, x49);
        }
        var x = $m_s_None$();
        if ((x === x52)) {
          var this$9 = $n(elems$1);
          this$9.addOne__O__scm_ListBuffer(x51);
          input$tailLocal1 = x49;
          continue;
        }
      }
    }
    if ((x37 instanceof $c_Llaika_parse_Failure)) {
      var _1$1 = $n(elems$1).toList__sci_List();
      var _2$1 = $m_s_None$();
      var result$1 = new $c_T2(_1$1, _2$1);
      var next = input$tailLocal1;
      return new $c_Llaika_parse_Success(result$1, next);
    }
    throw new $c_s_MatchError(x37);
  }
}
/** @constructor */
function $c_Llaika_parse_Parser() {
}
$c_Llaika_parse_Parser.prototype = new $h_O();
$c_Llaika_parse_Parser.prototype.constructor = $c_Llaika_parse_Parser;
/** @constructor */
function $h_Llaika_parse_Parser() {
}
$h_Llaika_parse_Parser.prototype = $c_Llaika_parse_Parser.prototype;
$c_Llaika_parse_Parser.prototype.parse__T__Llaika_parse_Parsed = (function(in$1) {
  return this.parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed($m_Llaika_parse_SourceCursor$().apply__T__Llaika_parse_SourceCursor(in$1));
});
$c_Llaika_parse_Parser.prototype.flatMap__F1__Llaika_parse_Parser = (function(f) {
  var this$5 = $m_Llaika_parse_Parser$();
  var f$1 = new $c_sjsr_AnonFunction1(((in$1) => {
    var in$2 = $as_Llaika_parse_SourceCursor(in$1);
    var x1 = this.parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(in$2);
    if ((x1 instanceof $c_Llaika_parse_Success)) {
      var x$1 = $as_Llaika_parse_Success(x1);
      var this$3 = $n(x$1);
      var x5 = this$3.Llaika_parse_Success__f_result;
      var this$4 = $n(x$1);
      var x6 = this$4.Llaika_parse_Success__f_next;
      return $n($as_Llaika_parse_Parser($n(f).apply__O__O(x5))).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(x6);
    }
    if ((x1 instanceof $c_Llaika_parse_Failure)) {
      var e = $as_Llaika_parse_Failure(x1);
      return e;
    }
    throw new $c_s_MatchError(x1);
  }));
  return new $c_Llaika_parse_Parser$$anon$2(f$1, this$5);
});
$c_Llaika_parse_Parser.prototype.map__F1__Llaika_parse_Parser = (function(f) {
  var this$2 = $m_Llaika_parse_Parser$();
  var f$1 = new $c_sjsr_AnonFunction1(((in$1) => {
    var in$2 = $as_Llaika_parse_SourceCursor(in$1);
    return $n(this.parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(in$2)).map__F1__Llaika_parse_Parsed(f);
  }));
  return new $c_Llaika_parse_Parser$$anon$2(f$1, this$2);
});
$c_Llaika_parse_Parser.prototype.orElse__F0__Llaika_parse_Parser = (function(p0) {
  var alt$lzy1 = new $c_sr_LazyRef();
  var this$2 = $m_Llaika_parse_Parser$();
  var alt$lzy1$2$1 = alt$lzy1;
  var f = new $c_sjsr_AnonFunction1(((alt$lzy1$2) => ((in$1) => {
    var in$2 = $as_Llaika_parse_SourceCursor(in$1);
    return $n(this.parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(in$2)).orElse__F0__Llaika_parse_Parsed(new $c_sjsr_AnonFunction0((() => $n($ps_Llaika_parse_Parser__alt$1__sr_LazyRef__F0__Llaika_parse_Parser(alt$lzy1$2, p0)).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(in$2))));
  }))(alt$lzy1$2$1));
  return new $c_Llaika_parse_Parser$$anon$2(f, this$2);
});
$c_Llaika_parse_Parser.prototype.$tilde__T__Llaika_parse_Parser = (function(value) {
  return this.$tilde__Llaika_parse_Parser__Llaika_parse_Parser(($m_Llaika_parse_text_TextParsers$(), new $c_Llaika_parse_text_Literal(value)));
});
$c_Llaika_parse_Parser.prototype.$tilde__Llaika_parse_Parser__Llaika_parse_Parser = (function(p) {
  var this$5 = $m_Llaika_parse_Parser$();
  var f$1 = new $c_sjsr_AnonFunction1(((ctx) => {
    var ctx$1 = $as_Llaika_parse_SourceCursor(ctx);
    var x7 = this.parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(ctx$1);
    if ((x7 instanceof $c_Llaika_parse_Success)) {
      var x$1 = $as_Llaika_parse_Success(x7);
      var this$3 = $n(x$1);
      var x11 = this$3.Llaika_parse_Success__f_result;
      var this$4 = $n(x$1);
      var x12 = this$4.Llaika_parse_Success__f_next;
      return $n($n(p).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(x12)).map__F1__Llaika_parse_Parsed(new $c_sjsr_AnonFunction1(((bRes) => new $c_Llaika_parse_builders$$tilde(x11, bRes))));
    }
    if ((x7 instanceof $c_Llaika_parse_Failure)) {
      var f = $as_Llaika_parse_Failure(x7);
      return f;
    }
    throw new $c_s_MatchError(x7);
  }));
  return new $c_Llaika_parse_Parser$$anon$2(f$1, this$5);
});
$c_Llaika_parse_Parser.prototype.$tilde$greater__T__Llaika_parse_Parser = (function(value) {
  return this.$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser(($m_Llaika_parse_text_TextParsers$(), new $c_Llaika_parse_text_Literal(value)));
});
$c_Llaika_parse_Parser.prototype.$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser = (function(p) {
  var this$5 = $m_Llaika_parse_Parser$();
  var f$1 = new $c_sjsr_AnonFunction1(((ctx) => {
    var ctx$1 = $as_Llaika_parse_SourceCursor(ctx);
    var x13 = this.parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(ctx$1);
    if ((x13 instanceof $c_Llaika_parse_Success)) {
      var x$1 = $as_Llaika_parse_Success(x13);
      var this$3 = $n(x$1);
      var this$4 = $n(x$1);
      var x18 = this$4.Llaika_parse_Success__f_next;
      return $n(p).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(x18);
    }
    if ((x13 instanceof $c_Llaika_parse_Failure)) {
      var f = $as_Llaika_parse_Failure(x13);
      return f;
    }
    throw new $c_s_MatchError(x13);
  }));
  return new $c_Llaika_parse_Parser$$anon$2(f$1, this$5);
});
$c_Llaika_parse_Parser.prototype.$less$tilde__T__Llaika_parse_Parser = (function(value) {
  return this.$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser(($m_Llaika_parse_text_TextParsers$(), new $c_Llaika_parse_text_Literal(value)));
});
$c_Llaika_parse_Parser.prototype.$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser = (function(p) {
  var this$5 = $m_Llaika_parse_Parser$();
  var f$1 = new $c_sjsr_AnonFunction1(((ctx) => {
    var ctx$1 = $as_Llaika_parse_SourceCursor(ctx);
    var x19 = this.parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(ctx$1);
    if ((x19 instanceof $c_Llaika_parse_Success)) {
      var x$1 = $as_Llaika_parse_Success(x19);
      var this$3 = $n(x$1);
      var x23 = this$3.Llaika_parse_Success__f_result;
      var this$4 = $n(x$1);
      var x24 = this$4.Llaika_parse_Success__f_next;
      return $n($n(p).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(x24)).map__F1__Llaika_parse_Parsed(new $c_sjsr_AnonFunction1(((_$1) => x23)));
    }
    if ((x19 instanceof $c_Llaika_parse_Failure)) {
      var f = $as_Llaika_parse_Failure(x19);
      return f;
    }
    throw new $c_s_MatchError(x19);
  }));
  return new $c_Llaika_parse_Parser$$anon$2(f$1, this$5);
});
$c_Llaika_parse_Parser.prototype.$bar__T__s_$less$colon$less__Llaika_parse_Parser = (function(value, ev) {
  return $n(this.map__F1__Llaika_parse_Parser(ev)).orElse__F0__Llaika_parse_Parser(new $c_sjsr_AnonFunction0((() => {
    $m_Llaika_parse_text_TextParsers$();
    return new $c_Llaika_parse_text_Literal(value);
  })));
});
$c_Llaika_parse_Parser.prototype.$up$up__F1__Llaika_parse_Parser = (function(f) {
  return this.map__F1__Llaika_parse_Parser(f);
});
$c_Llaika_parse_Parser.prototype.as__F0__Llaika_parse_Parser = (function(v) {
  return new $c_Llaika_parse_Parser$$anon$1(v, this);
});
$c_Llaika_parse_Parser.prototype.void__Llaika_parse_Parser = (function() {
  return this.map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$3) => (void 0))));
});
$c_Llaika_parse_Parser.prototype.collect__s_PartialFunction__F1__Llaika_parse_Parser = (function(f, error) {
  $m_Llaika_parse_Message$();
  var msg = new $c_Llaika_parse_Message$MessageFactory(error);
  var this$8 = $m_Llaika_parse_Parser$();
  var f$2 = new $c_sjsr_AnonFunction1(((in$1) => {
    var in$2 = $as_Llaika_parse_SourceCursor(in$1);
    matchResult5: {
      var $x_1;
      var x25 = this.parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(in$2);
      if ((x25 instanceof $c_Llaika_parse_Success)) {
        var x$1 = $as_Llaika_parse_Success(x25);
        var this$4 = $n(x$1);
        var x29 = this$4.Llaika_parse_Success__f_result;
        var this$5 = $n(x$1);
        var x30 = this$5.Llaika_parse_Success__f_next;
        if ($n(f).isDefinedAt__O__Z(x29)) {
          var result = $n(f).apply__O__O(x29);
          var $x_1 = new $c_Llaika_parse_Success(result, x30);
          break matchResult5;
        } else {
          var msgProvider = new $c_Llaika_parse_Message$MessageFactory$$anon$1(x29, msg);
          var maxOffset = $n(x30).offset__I();
          var $x_1 = new $c_Llaika_parse_Failure(msgProvider, in$2, maxOffset);
          break matchResult5;
        }
      }
      if ((x25 instanceof $c_Llaika_parse_Failure)) {
        var f$1 = $as_Llaika_parse_Failure(x25);
        var $x_1 = f$1;
        break matchResult5;
      }
      throw new $c_s_MatchError(x25);
    }
    return $as_Llaika_parse_Parsed($x_1);
  }));
  return new $c_Llaika_parse_Parser$$anon$2(f$2, this$8);
});
$c_Llaika_parse_Parser.prototype.collect$default$2__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((r) => ("Constructor function not defined at " + r)));
});
$c_Llaika_parse_Parser.prototype.evalMap__F1__Llaika_parse_Parser = (function(f) {
  var this$9 = $m_Llaika_parse_Parser$();
  var f$2 = new $c_sjsr_AnonFunction1(((in$1) => {
    var in$2 = $as_Llaika_parse_SourceCursor(in$1);
    var x31 = this.parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(in$2);
    if ((x31 instanceof $c_Llaika_parse_Success)) {
      var x$1 = $as_Llaika_parse_Success(x31);
      var this$3 = $n(x$1);
      var x35 = this$3.Llaika_parse_Success__f_result;
      var this$4 = $n(x$1);
      var x36 = this$4.Llaika_parse_Success__f_next;
      var this$5 = $n($as_s_util_Either($n(f).apply__O__O(x35)));
      if ((this$5 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(this$5);
        var b = $n(x2).s_util_Right__f_value;
        var $x_1 = new $c_Llaika_parse_Success(b, x36);
      } else {
        if ((!(this$5 instanceof $c_s_util_Left))) {
          throw new $c_s_MatchError(this$5);
        }
        var x3 = $as_s_util_Left(this$5);
        var a = $n(x3).s_util_Left__f_value;
        var msg = $as_T(a);
        var this$7 = $m_Llaika_parse_Message$();
        var msgProvider = new $c_Llaika_parse_Message$$anon$2(msg, this$7);
        var maxOffset = $n(x36).offset__I();
        var $x_1 = new $c_Llaika_parse_Failure(msgProvider, in$2, maxOffset);
      }
      return $as_Llaika_parse_Parsed($x_1);
    }
    if ((x31 instanceof $c_Llaika_parse_Failure)) {
      var f$1 = $as_Llaika_parse_Failure(x31);
      return f$1;
    }
    throw new $c_s_MatchError(x31);
  }));
  return new $c_Llaika_parse_Parser$$anon$2(f$2, this$9);
});
$c_Llaika_parse_Parser.prototype.$greater$greater__F1__Llaika_parse_Parser = (function(fq) {
  return this.flatMap__F1__Llaika_parse_Parser(fq);
});
$c_Llaika_parse_Parser.prototype.rep__Llaika_parse_Parser__Llaika_parse_combinator_Repeat = (function(separator) {
  var sep$1 = new $c_s_Some(separator);
  return new $c_Llaika_parse_combinator_Repeat(this, 0, 2147483647, sep$1);
});
$c_Llaika_parse_Parser.prototype.rep__T__Llaika_parse_combinator_Repeat = (function(separator) {
  var value = ($m_Llaika_parse_text_TextParsers$(), new $c_Llaika_parse_text_Literal(separator)).void__Llaika_parse_Parser();
  var sep$2 = new $c_s_Some(value);
  return new $c_Llaika_parse_combinator_Repeat(this, 0, 2147483647, sep$2);
});
$c_Llaika_parse_Parser.prototype.repUntil__Llaika_parse_Parser__Llaika_parse_Parser = (function(endCondition) {
  var this$3 = $m_Llaika_parse_Parser$();
  var f = new $c_sjsr_AnonFunction1(((in$1) => {
    var in$2 = $as_Llaika_parse_SourceCursor(in$1);
    var elems = new $c_scm_ListBuffer();
    var this$2 = $m_Llaika_parse_combinator_Parsers$();
    var combined = this.$tilde__Llaika_parse_Parser__Llaika_parse_Parser($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$2, endCondition));
    return $ps_Llaika_parse_Parser__loop$1__Llaika_parse_Parser__scm_ListBuffer__Llaika_parse_SourceCursor__Llaika_parse_Parsed(combined, elems, in$2);
  }));
  return new $c_Llaika_parse_Parser$$anon$2(f, this$3);
});
$c_Llaika_parse_Parser.prototype.withCursor__Llaika_parse_Parser = (function() {
  var this$8 = $m_Llaika_parse_Parser$();
  var f$1 = new $c_sjsr_AnonFunction1(((in$1) => {
    var in$2 = $as_Llaika_parse_SourceCursor(in$1);
    matchResult11: {
      var $x_1;
      var x69 = this.parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(in$2);
      if ((x69 instanceof $c_Llaika_parse_Failure)) {
        var f = $as_Llaika_parse_Failure(x69);
        var $x_1 = f;
        break matchResult11;
      }
      if ((x69 instanceof $c_Llaika_parse_Success)) {
        var x$1 = $as_Llaika_parse_Success(x69);
        var this$3 = $n(x$1);
        var x72 = this$3.Llaika_parse_Success__f_result;
        var this$4 = $n(x$1);
        var x73 = this$4.Llaika_parse_Success__f_next;
        var consumed = $n(in$2).capture__I__T((($n(x73).offset__I() - $n(in$2).offset__I()) | 0));
        var _2 = new $c_Llaika_parse_LineSource(consumed, in$2, 0, $n(in$2).nestLevel__I());
        var result = new $c_T2(x72, _2);
        var $x_1 = new $c_Llaika_parse_Success(result, x73);
        break matchResult11;
      }
      throw new $c_s_MatchError(x69);
    }
    return $as_Llaika_parse_Parsed($x_1);
  }));
  return new $c_Llaika_parse_Parser$$anon$2(f$1, this$8);
});
$c_Llaika_parse_Parser.prototype.source__Llaika_parse_Parser = (function() {
  return $n(this.withCursor__Llaika_parse_Parser()).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$6) => {
    var _$6$1 = $as_T2(_$6);
    return $n($as_Llaika_parse_SourceCursor($n(_$6$1)._2__O())).input__T();
  })));
});
function $as_Llaika_parse_Parser(obj) {
  return (((obj instanceof $c_Llaika_parse_Parser) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.parse.Parser"));
}
function $isArrayOf_Llaika_parse_Parser(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_parse_Parser)));
}
function $asArrayOf_Llaika_parse_Parser(obj, depth) {
  return (($isArrayOf_Llaika_parse_Parser(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.parse.Parser;", depth));
}
/** @constructor */
function $c_Llaika_parse_Parser$() {
}
$c_Llaika_parse_Parser$.prototype = new $h_O();
$c_Llaika_parse_Parser$.prototype.constructor = $c_Llaika_parse_Parser$;
/** @constructor */
function $h_Llaika_parse_Parser$() {
}
$h_Llaika_parse_Parser$.prototype = $c_Llaika_parse_Parser$.prototype;
var $d_Llaika_parse_Parser$ = new $TypeData().initClass($c_Llaika_parse_Parser$, "laika.parse.Parser$", ({
  Llaika_parse_Parser$: 1
}));
var $n_Llaika_parse_Parser$;
function $m_Llaika_parse_Parser$() {
  if ((!$n_Llaika_parse_Parser$)) {
    $n_Llaika_parse_Parser$ = new $c_Llaika_parse_Parser$();
  }
  return $n_Llaika_parse_Parser$;
}
/** @constructor */
function $c_Llaika_parse_Position(s, offset) {
  this.Llaika_parse_Position__f_s = null;
  this.Llaika_parse_Position__f_offset = 0;
  this.Llaika_parse_Position__f_source = null;
  this.Llaika_parse_Position__f_line$lzy1 = 0;
  this.Llaika_parse_Position__f_linebitmap$1 = false;
  this.Llaika_parse_Position__f_column$lzy1 = 0;
  this.Llaika_parse_Position__f_columnbitmap$1 = false;
  this.Llaika_parse_Position__f_lineContent$lzy1 = null;
  this.Llaika_parse_Position__f_lineContentbitmap$1 = false;
  this.Llaika_parse_Position__f_toString$lzy1 = null;
  this.Llaika_parse_Position__f_toStringbitmap$1 = false;
  this.Llaika_parse_Position__f_s = s;
  this.Llaika_parse_Position__f_offset = offset;
  this.Llaika_parse_Position__f_source = $n(s).Llaika_parse_InputString__f_value;
}
$c_Llaika_parse_Position.prototype = new $h_O();
$c_Llaika_parse_Position.prototype.constructor = $c_Llaika_parse_Position;
/** @constructor */
function $h_Llaika_parse_Position() {
}
$h_Llaika_parse_Position.prototype = $c_Llaika_parse_Position.prototype;
$c_Llaika_parse_Position.prototype.line__I = (function() {
  if ((!this.Llaika_parse_Position__f_linebitmap$1)) {
    var a = $n(this.Llaika_parse_Position__f_s).lineStarts__AI();
    var key = this.Llaika_parse_Position__f_offset;
    var result = $m_ju_Arrays$().binarySearch__AI__I__I(a, key);
    this.Llaika_parse_Position__f_line$lzy1 = ((result === (((-1) + $n($n(this.Llaika_parse_Position__f_s).lineStarts__AI()).u.length) | 0)) ? result : ((result < 0) ? (((-1) + ((result < 0) ? ((-result) | 0) : result)) | 0) : ((1 + result) | 0)));
    this.Llaika_parse_Position__f_linebitmap$1 = true;
  }
  return this.Llaika_parse_Position__f_line$lzy1;
});
$c_Llaika_parse_Position.prototype.column__I = (function() {
  if ((!this.Llaika_parse_Position__f_columnbitmap$1)) {
    this.Llaika_parse_Position__f_column$lzy1 = ((1 + ((this.Llaika_parse_Position__f_offset - $n($n(this.Llaika_parse_Position__f_s).lineStarts__AI()).get((((-1) + this.line__I()) | 0))) | 0)) | 0);
    this.Llaika_parse_Position__f_columnbitmap$1 = true;
  }
  return this.Llaika_parse_Position__f_column$lzy1;
});
$c_Llaika_parse_Position.prototype.lineContent__T = (function() {
  if ((!this.Llaika_parse_Position__f_lineContentbitmap$1)) {
    var startIndex = $n($n(this.Llaika_parse_Position__f_s).lineStarts__AI()).get((((-1) + this.line__I()) | 0));
    var endIndex = $n($n(this.Llaika_parse_Position__f_s).lineStarts__AI()).get(this.line__I());
    var this$1 = $n(this.Llaika_parse_Position__f_source);
    if ((startIndex < 0)) {
      $charAt(this$1, startIndex);
    }
    if ((endIndex > this$1.length)) {
      $charAt(this$1, endIndex);
    }
    if ((endIndex < startIndex)) {
      $charAt(this$1, (-1));
    }
    var result = $as_T(this$1.substring(startIndex, endIndex));
    this.Llaika_parse_Position__f_lineContent$lzy1 = ($f_T__endsWith__T__Z($n(result), "\n") ? $m_sc_StringOps$().dropRight$extension__T__I__T(result, 1) : result);
    this.Llaika_parse_Position__f_lineContentbitmap$1 = true;
  }
  return this.Llaika_parse_Position__f_lineContent$lzy1;
});
$c_Llaika_parse_Position.prototype.lineContentWithCaret__T = (function() {
  return (((this.lineContent__T() + "\n") + $m_sc_StringOps$().$times$extension__T__I__T(" ", (((-1) + this.column__I()) | 0))) + "^");
});
$c_Llaika_parse_Position.prototype.toString__T = (function() {
  if ((!this.Llaika_parse_Position__f_toStringbitmap$1)) {
    this.Llaika_parse_Position__f_toString$lzy1 = ((this.line__I() + ".") + this.column__I());
    this.Llaika_parse_Position__f_toStringbitmap$1 = true;
  }
  return this.Llaika_parse_Position__f_toString$lzy1;
});
var $d_Llaika_parse_Position = new $TypeData().initClass($c_Llaika_parse_Position, "laika.parse.Position", ({
  Llaika_parse_Position: 1
}));
function $f_Llaika_parse_SourceCursor__charAt__I__C($thiz, relativeOffset) {
  var this$1 = $n($thiz.input__T());
  var index = (($thiz.offset__I() + relativeOffset) | 0);
  return $charAt(this$1, index);
}
function $f_Llaika_parse_SourceCursor__canConsume__I__I($thiz, maxChars) {
  if ((maxChars > 0)) {
    var a = $thiz.remaining__I();
    return ((a < maxChars) ? a : maxChars);
  } else {
    var a$1 = ((-$thiz.offset__I()) | 0);
    return ((a$1 > maxChars) ? a$1 : maxChars);
  }
}
function $is_Llaika_parse_SourceCursor(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_parse_SourceCursor)));
}
function $as_Llaika_parse_SourceCursor(obj) {
  return (($is_Llaika_parse_SourceCursor(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.parse.SourceCursor"));
}
function $isArrayOf_Llaika_parse_SourceCursor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_parse_SourceCursor)));
}
function $asArrayOf_Llaika_parse_SourceCursor(obj, depth) {
  return (($isArrayOf_Llaika_parse_SourceCursor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.parse.SourceCursor;", depth));
}
/** @constructor */
function $c_Llaika_parse_SourceCursor$() {
}
$c_Llaika_parse_SourceCursor$.prototype = new $h_O();
$c_Llaika_parse_SourceCursor$.prototype.constructor = $c_Llaika_parse_SourceCursor$;
/** @constructor */
function $h_Llaika_parse_SourceCursor$() {
}
$h_Llaika_parse_SourceCursor$.prototype = $c_Llaika_parse_SourceCursor$.prototype;
$c_Llaika_parse_SourceCursor$.prototype.apply__T__Llaika_parse_SourceCursor = (function(input) {
  return new $c_Llaika_parse_RootSource($m_Llaika_parse_InputString$().apply__T__s_Option__Z__Llaika_parse_InputString(input, ($m_Llaika_parse_InputString$(), $m_s_None$()), ($m_Llaika_parse_InputString$(), false)), 0, 0);
});
$c_Llaika_parse_SourceCursor$.prototype.apply__T__Llaika_ast_Path__Llaika_parse_SourceCursor = (function(input, path) {
  return new $c_Llaika_parse_RootSource($m_Llaika_parse_InputString$().apply__T__s_Option__Z__Llaika_parse_InputString(input, new $c_s_Some(path), ($m_Llaika_parse_InputString$(), false)), 0, 0);
});
var $d_Llaika_parse_SourceCursor$ = new $TypeData().initClass($c_Llaika_parse_SourceCursor$, "laika.parse.SourceCursor$", ({
  Llaika_parse_SourceCursor$: 1
}));
var $n_Llaika_parse_SourceCursor$;
function $m_Llaika_parse_SourceCursor$() {
  if ((!$n_Llaika_parse_SourceCursor$)) {
    $n_Llaika_parse_SourceCursor$ = new $c_Llaika_parse_SourceCursor$();
  }
  return $n_Llaika_parse_SourceCursor$;
}
/** @constructor */
function $c_Llaika_parse_code_common_NumberLiteral$digits$() {
  this.Llaika_parse_code_common_NumberLiteral$digits$__f_hex = null;
  $n_Llaika_parse_code_common_NumberLiteral$digits$ = this;
  var this$1 = $m_Llaika_parse_builders$();
  var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([49])));
  $f_Llaika_parse_text_TextParsers__someOf__C__sci_Seq__Llaika_parse_text_PrefixCharacters(this$1, 48, chars);
  var this$2 = $m_Llaika_parse_builders$();
  var chars$1 = $m_Llaika_parse_text_CharGroup$().Llaika_parse_text_CharGroup$__f_octalDigit;
  $f_Llaika_parse_text_TextParsers__someOf__O__Llaika_parse_text_PrefixCharacters(this$2, chars$1);
  var this$3 = $m_Llaika_parse_builders$();
  var chars$2 = $m_Llaika_parse_text_CharGroup$().Llaika_parse_text_CharGroup$__f_digit;
  $f_Llaika_parse_text_TextParsers__someOf__O__Llaika_parse_text_PrefixCharacters(this$3, chars$2);
  var this$8 = $m_Llaika_parse_builders$();
  var $x_1 = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet);
  var value = $m_Llaika_parse_text_CharGroup$().Llaika_parse_text_CharGroup$__f_digit;
  var this$5 = new $c_Lcats_data_NonEmptySetOps(value);
  var s = this$5.Lcats_data_NonEmptySetOps__f_value;
  var this$7 = $n($as_sci_SortedSet(s));
  var chars$3 = $n($x_1).fromSetUnsafe__sci_SortedSet__O($as_sci_SortedSet(this$7.excl__O__sci_SetOps($bC(48))));
  $f_Llaika_parse_text_TextParsers__someOf__O__Llaika_parse_text_PrefixCharacters(this$8, chars$3);
  var this$9 = $m_Llaika_parse_builders$();
  var chars$4 = $m_Llaika_parse_text_CharGroup$().Llaika_parse_text_CharGroup$__f_hexDigit;
  this.Llaika_parse_code_common_NumberLiteral$digits$__f_hex = $f_Llaika_parse_text_TextParsers__someOf__O__Llaika_parse_text_PrefixCharacters(this$9, chars$4);
}
$c_Llaika_parse_code_common_NumberLiteral$digits$.prototype = new $h_O();
$c_Llaika_parse_code_common_NumberLiteral$digits$.prototype.constructor = $c_Llaika_parse_code_common_NumberLiteral$digits$;
/** @constructor */
function $h_Llaika_parse_code_common_NumberLiteral$digits$() {
}
$h_Llaika_parse_code_common_NumberLiteral$digits$.prototype = $c_Llaika_parse_code_common_NumberLiteral$digits$.prototype;
var $d_Llaika_parse_code_common_NumberLiteral$digits$ = new $TypeData().initClass($c_Llaika_parse_code_common_NumberLiteral$digits$, "laika.parse.code.common.NumberLiteral$digits$", ({
  Llaika_parse_code_common_NumberLiteral$digits$: 1
}));
var $n_Llaika_parse_code_common_NumberLiteral$digits$;
function $m_Llaika_parse_code_common_NumberLiteral$digits$() {
  if ((!$n_Llaika_parse_code_common_NumberLiteral$digits$)) {
    $n_Llaika_parse_code_common_NumberLiteral$digits$ = new $c_Llaika_parse_code_common_NumberLiteral$digits$();
  }
  return $n_Llaika_parse_code_common_NumberLiteral$digits$;
}
function $f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser($thiz, p) {
  var this$7 = $m_Llaika_parse_Parser$();
  var f = new $c_sjsr_AnonFunction1(((in$1) => {
    var in$2 = $as_Llaika_parse_SourceCursor(in$1);
    var x1 = $n(p).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(in$2);
    if ((x1 instanceof $c_Llaika_parse_Success)) {
      var x$1 = $as_Llaika_parse_Success(x1);
      var this$2 = $n(x$1);
      var x4 = this$2.Llaika_parse_Success__f_result;
      var this$3 = $n(x$1);
      var x5 = this$3.Llaika_parse_Success__f_next;
      var result = new $c_s_Some(x4);
      return new $c_Llaika_parse_Success(result, x5);
    }
    var result$1 = $m_s_None$();
    return new $c_Llaika_parse_Success(result$1, in$2);
  }));
  return new $c_Llaika_parse_Parser$$anon$2(f, this$7);
}
function $f_Llaika_parse_combinator_Parsers__opt__T__Llaika_parse_Parser($thiz, value) {
  $m_Llaika_parse_text_TextParsers$();
  var p = new $c_Llaika_parse_text_Literal(value);
  return $f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser($thiz, p);
}
function $f_Llaika_parse_combinator_Parsers__not__Llaika_parse_Parser__Llaika_parse_Parser($thiz, p) {
  var this$6 = $m_Llaika_parse_Parser$();
  var f = new $c_sjsr_AnonFunction1(((in$1) => {
    var in$2 = $as_Llaika_parse_SourceCursor(in$1);
    matchResult2: {
      var $x_1;
      var x6 = $n(p).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(in$2);
      if ((x6 instanceof $c_Llaika_parse_Success)) {
        var x$1 = $as_Llaika_parse_Success(x6);
        var this$2 = $n(x$1);
        var this$3 = $n(x$1);
        var msgProvider = $m_Llaika_parse_Message$().Llaika_parse_Message$__f_ExpectedFailure;
        var maxOffset = $n(in$2).offset__I();
        var $x_1 = new $c_Llaika_parse_Failure(msgProvider, in$2, maxOffset);
        break matchResult2;
      }
      var $x_1 = new $c_Llaika_parse_Success((void 0), in$2);
    }
    return $as_Llaika_parse_Parsed($x_1);
  }));
  return new $c_Llaika_parse_Parser$$anon$2(f, this$6);
}
function $f_Llaika_parse_combinator_Parsers__lookAhead__Llaika_parse_Parser__Llaika_parse_Parser($thiz, p) {
  var this$5 = $m_Llaika_parse_Parser$();
  var f = new $c_sjsr_AnonFunction1(((in$1) => {
    var in$2 = $as_Llaika_parse_SourceCursor(in$1);
    var x11 = $n(p).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(in$2);
    if ((x11 instanceof $c_Llaika_parse_Success)) {
      var x$1 = $as_Llaika_parse_Success(x11);
      var this$2 = $n(x$1);
      var x14 = this$2.Llaika_parse_Success__f_result;
      var this$3 = $n(x$1);
      return new $c_Llaika_parse_Success(x14, in$2);
    }
    return x11;
  }));
  return new $c_Llaika_parse_Parser$$anon$2(f, this$5);
}
function $f_Llaika_parse_combinator_Parsers__success__O__Llaika_parse_Parser($thiz, v) {
  var this$2 = $m_Llaika_parse_Parser$();
  var f = new $c_sjsr_AnonFunction1(((in$1) => {
    var in$2 = $as_Llaika_parse_SourceCursor(in$1);
    return new $c_Llaika_parse_Success(v, in$2);
  }));
  return new $c_Llaika_parse_Parser$$anon$2(f, this$2);
}
function $f_Llaika_parse_combinator_Parsers__failure__T__Llaika_parse_Parser($thiz, msg) {
  var this$3 = $m_Llaika_parse_Parser$();
  var f = new $c_sjsr_AnonFunction1(((in$1) => {
    var in$2 = $as_Llaika_parse_SourceCursor(in$1);
    var this$1 = $m_Llaika_parse_Message$();
    var msgProvider = new $c_Llaika_parse_Message$$anon$2(msg, this$1);
    var maxOffset = $n(in$2).offset__I();
    return new $c_Llaika_parse_Failure(msgProvider, in$2, maxOffset);
  }));
  return new $c_Llaika_parse_Parser$$anon$2(f, this$3);
}
function $f_Llaika_parse_combinator_Parsers__consumeAll__Llaika_parse_Parser__Llaika_parse_Parser($thiz, p) {
  var this$5 = $m_Llaika_parse_Parser$();
  var f = new $c_sjsr_AnonFunction1(((in$1) => {
    var in$2 = $as_Llaika_parse_SourceCursor(in$1);
    var x26 = $n(p).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(in$2);
    if ((x26 instanceof $c_Llaika_parse_Success)) {
      var x27 = $as_Llaika_parse_Success(x26);
      var this$2 = $n(x27);
      var this$3 = $n(x27);
      var x30 = this$3.Llaika_parse_Success__f_next;
      if ($n(x30).atEnd__Z()) {
        var $x_1 = x27;
      } else {
        var msgProvider = $m_Llaika_parse_Message$().Llaika_parse_Message$__f_ExpectedEOF;
        var maxOffset = $n(x30).offset__I();
        var $x_1 = new $c_Llaika_parse_Failure(msgProvider, x30, maxOffset);
      }
      return $as_Llaika_parse_Parsed($x_1);
    }
    return x26;
  }));
  return new $c_Llaika_parse_Parser$$anon$2(f, this$5);
}
function $f_Llaika_parse_combinator_Parsers__lazily__F0__Llaika_parse_Parser($thiz, p) {
  var p0$lzy1 = new $c_sr_LazyRef();
  var this$1 = $m_Llaika_parse_Parser$();
  var p0$lzy1$2$1 = p0$lzy1;
  var f = new $c_sjsr_AnonFunction1(((p0$lzy1$2) => ((in$1) => {
    var in$2 = $as_Llaika_parse_SourceCursor(in$1);
    return $n($ps_Llaika_parse_combinator_Parsers__p0$1__sr_LazyRef__F0__Llaika_parse_Parser(p0$lzy1$2, p)).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(in$2);
  }))(p0$lzy1$2$1));
  return new $c_Llaika_parse_Parser$$anon$2(f, this$1);
}
function $ps_Llaika_parse_combinator_Parsers__p0$lzyINIT1$1__sr_LazyRef__F0__Llaika_parse_Parser(p0$lzy1$1, p$6) {
  if ((p0$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Llaika_parse_Parser(($n(p0$lzy1$1).sr_LazyRef__f__initialized ? $n(p0$lzy1$1).sr_LazyRef__f__value : $n(p0$lzy1$1).initialize__O__O($as_Llaika_parse_Parser($n(p$6).apply__O()))));
}
function $ps_Llaika_parse_combinator_Parsers__p0$1__sr_LazyRef__F0__Llaika_parse_Parser(p0$lzy1$2, p$7) {
  return $as_Llaika_parse_Parser(($n(p0$lzy1$2).sr_LazyRef__f__initialized ? $n(p0$lzy1$2).sr_LazyRef__f__value : $ps_Llaika_parse_combinator_Parsers__p0$lzyINIT1$1__sr_LazyRef__F0__Llaika_parse_Parser(p0$lzy1$2, p$7)));
}
function $f_Llaika_parse_markup_BlockParsers__$init$__V($thiz) {
  var this$1 = $m_Llaika_parse_builders$();
  $f_Llaika_parse_combinator_Parsers__failure__T__Llaika_parse_Parser(this$1, "Blank line ends this block element");
}
function $ps_Llaika_parse_markup_BlockParsers__nextBlock$lzyINIT1$1__sr_LazyRef__F0__Llaika_parse_Parser(nextBlock$lzy1$1, nextBlockPrefix$1) {
  if ((nextBlock$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ($n(nextBlock$lzy1$1).sr_LazyRef__f__initialized) {
    var $x_1 = $n(nextBlock$lzy1$1).sr_LazyRef__f__value;
  } else {
    var $x_3 = $n(nextBlock$lzy1$1);
    var p = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_blankLines;
    var p$1 = $m_Llaika_parse_syntax$SeqStringParserOps$().mkLines$extension__Llaika_parse_Parser__Llaika_parse_Parser(p);
    var $x_2 = $m_Llaika_parse_syntax$StringParserOps$().line$extension__Llaika_parse_Parser__Llaika_parse_Parser(p$1);
    var this$3 = $m_Llaika_parse_builders$();
    var p$2 = $as_Llaika_parse_Parser($n(nextBlockPrefix$1).apply__O());
    var $x_1 = $n($x_3).initialize__O__O($n($x_2).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser($f_Llaika_parse_combinator_Parsers__lookAhead__Llaika_parse_Parser__Llaika_parse_Parser(this$3, p$2)));
  }
  return $as_Llaika_parse_Parser($x_1);
}
function $ps_Llaika_parse_markup_BlockParsers__nextBlock$1__sr_LazyRef__F0__Llaika_parse_Parser(nextBlock$lzy1$2, nextBlockPrefix$2) {
  return $as_Llaika_parse_Parser(($n(nextBlock$lzy1$2).sr_LazyRef__f__initialized ? $n(nextBlock$lzy1$2).sr_LazyRef__f__value : $ps_Llaika_parse_markup_BlockParsers__nextBlock$lzyINIT1$1__sr_LazyRef__F0__Llaika_parse_Parser(nextBlock$lzy1$2, nextBlockPrefix$2)));
}
function $is_Llaika_parse_markup_EscapedTextParsers(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_parse_markup_EscapedTextParsers)));
}
function $as_Llaika_parse_markup_EscapedTextParsers(obj) {
  return (($is_Llaika_parse_markup_EscapedTextParsers(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.parse.markup.EscapedTextParsers"));
}
function $isArrayOf_Llaika_parse_markup_EscapedTextParsers(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_parse_markup_EscapedTextParsers)));
}
function $asArrayOf_Llaika_parse_markup_EscapedTextParsers(obj, depth) {
  return (($isArrayOf_Llaika_parse_markup_EscapedTextParsers(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.parse.markup.EscapedTextParsers;", depth));
}
function $is_Llaika_parse_markup_InlineParser(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_parse_markup_InlineParser)));
}
function $as_Llaika_parse_markup_InlineParser(obj) {
  return (($is_Llaika_parse_markup_InlineParser(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.parse.markup.InlineParser"));
}
function $isArrayOf_Llaika_parse_markup_InlineParser(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_parse_markup_InlineParser)));
}
function $asArrayOf_Llaika_parse_markup_InlineParser(obj, depth) {
  return (($isArrayOf_Llaika_parse_markup_InlineParser(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.parse.markup.InlineParser;", depth));
}
function $f_Llaika_parse_markup_InlineParsers__spans__F0__Llaika_parse_markup_InlineParser($thiz, parser) {
  return new $c_Llaika_parse_markup_InlineParsers$DefaultInlineParser($thiz, new $c_sjsr_AnonFunction0((() => $n($as_Llaika_parse_text_DelimitedText($n(parser).apply__O())).Llaika_parse_text_DelimitedText__f_delimiter)), new $c_sjsr_AnonFunction0((() => $m_sci_Nil$())), new $c_sjsr_AnonFunction0((() => new $c_Llaika_parse_markup_InlineParsers$SpanBuilder())));
}
function $f_Llaika_parse_markup_InlineParsers__text__F0__Llaika_parse_markup_InlineParser($thiz, parser) {
  return new $c_Llaika_parse_markup_InlineParsers$DefaultInlineParser($thiz, new $c_sjsr_AnonFunction0((() => $n($as_Llaika_parse_text_DelimitedText($n(parser).apply__O())).Llaika_parse_text_DelimitedText__f_delimiter)), new $c_sjsr_AnonFunction0((() => $m_sci_Nil$())), new $c_sjsr_AnonFunction0((() => new $c_Llaika_parse_markup_InlineParsers$TextBuilder())));
}
function $is_Llaika_parse_markup_InlineParsers$ResultBuilder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_parse_markup_InlineParsers$ResultBuilder)));
}
function $as_Llaika_parse_markup_InlineParsers$ResultBuilder(obj) {
  return (($is_Llaika_parse_markup_InlineParsers$ResultBuilder(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.parse.markup.InlineParsers$ResultBuilder"));
}
function $isArrayOf_Llaika_parse_markup_InlineParsers$ResultBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_parse_markup_InlineParsers$ResultBuilder)));
}
function $asArrayOf_Llaika_parse_markup_InlineParsers$ResultBuilder(obj, depth) {
  return (($isArrayOf_Llaika_parse_markup_InlineParsers$ResultBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.parse.markup.InlineParsers$ResultBuilder;", depth));
}
function $is_Llaika_parse_markup_RecursiveSpanParser(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_parse_markup_RecursiveSpanParser)));
}
function $as_Llaika_parse_markup_RecursiveSpanParser(obj) {
  return (($is_Llaika_parse_markup_RecursiveSpanParser(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.parse.markup.RecursiveSpanParser"));
}
function $isArrayOf_Llaika_parse_markup_RecursiveSpanParser(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_parse_markup_RecursiveSpanParser)));
}
function $asArrayOf_Llaika_parse_markup_RecursiveSpanParser(obj, depth) {
  return (($isArrayOf_Llaika_parse_markup_RecursiveSpanParser(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.parse.markup.RecursiveSpanParser;", depth));
}
/** @constructor */
function $c_Llaika_parse_syntax$LiteralStringOps$() {
}
$c_Llaika_parse_syntax$LiteralStringOps$.prototype = new $h_O();
$c_Llaika_parse_syntax$LiteralStringOps$.prototype.constructor = $c_Llaika_parse_syntax$LiteralStringOps$;
/** @constructor */
function $h_Llaika_parse_syntax$LiteralStringOps$() {
}
$h_Llaika_parse_syntax$LiteralStringOps$.prototype = $c_Llaika_parse_syntax$LiteralStringOps$.prototype;
$c_Llaika_parse_syntax$LiteralStringOps$.prototype.$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser = (function(this$, p) {
  $m_Llaika_parse_text_TextParsers$();
  var this$2 = new $c_Llaika_parse_text_Literal(this$);
  return $f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$2, p);
});
$c_Llaika_parse_syntax$LiteralStringOps$.prototype.$tilde$extension__T__T__Llaika_parse_text_PrefixedParser = (function(this$, value) {
  $m_Llaika_parse_text_TextParsers$();
  var this$3 = new $c_Llaika_parse_text_Literal(this$);
  $m_Llaika_parse_text_TextParsers$();
  var p = new $c_Llaika_parse_text_Literal(value);
  return $f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$3, p);
});
$c_Llaika_parse_syntax$LiteralStringOps$.prototype.$less$tilde$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser = (function(this$, p) {
  $m_Llaika_parse_text_TextParsers$();
  var this$2 = new $c_Llaika_parse_text_Literal(this$);
  return $f_Llaika_parse_text_PrefixedParser__$less$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$2, p);
});
$c_Llaika_parse_syntax$LiteralStringOps$.prototype.$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser = (function(this$, p) {
  $m_Llaika_parse_text_TextParsers$();
  var this$2 = new $c_Llaika_parse_text_Literal(this$);
  return $f_Llaika_parse_text_PrefixedParser__$tilde$greater__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this$2, p);
});
$c_Llaika_parse_syntax$LiteralStringOps$.prototype.$bar$extension__T__T__Llaika_parse_text_PrefixedParser = (function(this$, value) {
  $m_Llaika_parse_text_TextParsers$();
  var this$4 = new $c_Llaika_parse_text_Literal(this$);
  var p = new $c_sjsr_AnonFunction0((() => {
    $m_Llaika_parse_text_TextParsers$();
    return new $c_Llaika_parse_text_Literal(value);
  }));
  return $f_Llaika_parse_text_PrefixedParser__$bar__F0__Llaika_parse_text_PrefixedParser(this$4, p);
});
var $d_Llaika_parse_syntax$LiteralStringOps$ = new $TypeData().initClass($c_Llaika_parse_syntax$LiteralStringOps$, "laika.parse.syntax$LiteralStringOps$", ({
  Llaika_parse_syntax$LiteralStringOps$: 1
}));
var $n_Llaika_parse_syntax$LiteralStringOps$;
function $m_Llaika_parse_syntax$LiteralStringOps$() {
  if ((!$n_Llaika_parse_syntax$LiteralStringOps$)) {
    $n_Llaika_parse_syntax$LiteralStringOps$ = new $c_Llaika_parse_syntax$LiteralStringOps$();
  }
  return $n_Llaika_parse_syntax$LiteralStringOps$;
}
/** @constructor */
function $c_Llaika_parse_syntax$Map2Ops$() {
}
$c_Llaika_parse_syntax$Map2Ops$.prototype = new $h_O();
$c_Llaika_parse_syntax$Map2Ops$.prototype.constructor = $c_Llaika_parse_syntax$Map2Ops$;
/** @constructor */
function $h_Llaika_parse_syntax$Map2Ops$() {
}
$h_Llaika_parse_syntax$Map2Ops$.prototype = $c_Llaika_parse_syntax$Map2Ops$.prototype;
$c_Llaika_parse_syntax$Map2Ops$.prototype.mapN$extension__Llaika_parse_Parser__F2__Llaika_parse_Parser = (function(this$, f) {
  return $n(this$).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Llaika_parse_builders$$tilde(x$1);
    if ((x$1$1 !== null)) {
      var a = $n(x$1$1).Llaika_parse_builders$$tilde__f__1;
      var b = $n(x$1$1).Llaika_parse_builders$$tilde__f__2;
      return $n(f).apply__O__O__O(a, b);
    }
    throw new $c_s_MatchError(x$1$1);
  })));
});
var $d_Llaika_parse_syntax$Map2Ops$ = new $TypeData().initClass($c_Llaika_parse_syntax$Map2Ops$, "laika.parse.syntax$Map2Ops$", ({
  Llaika_parse_syntax$Map2Ops$: 1
}));
var $n_Llaika_parse_syntax$Map2Ops$;
function $m_Llaika_parse_syntax$Map2Ops$() {
  if ((!$n_Llaika_parse_syntax$Map2Ops$)) {
    $n_Llaika_parse_syntax$Map2Ops$ = new $c_Llaika_parse_syntax$Map2Ops$();
  }
  return $n_Llaika_parse_syntax$Map2Ops$;
}
/** @constructor */
function $c_Llaika_parse_syntax$PrefixedMap2Ops$() {
}
$c_Llaika_parse_syntax$PrefixedMap2Ops$.prototype = new $h_O();
$c_Llaika_parse_syntax$PrefixedMap2Ops$.prototype.constructor = $c_Llaika_parse_syntax$PrefixedMap2Ops$;
/** @constructor */
function $h_Llaika_parse_syntax$PrefixedMap2Ops$() {
}
$h_Llaika_parse_syntax$PrefixedMap2Ops$.prototype = $c_Llaika_parse_syntax$PrefixedMap2Ops$.prototype;
$c_Llaika_parse_syntax$PrefixedMap2Ops$.prototype.mapN$extension__Llaika_parse_text_PrefixedParser__F2__Llaika_parse_text_PrefixedParser = (function(this$, f) {
  var this$3 = $n(this$);
  var f$1 = new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Llaika_parse_builders$$tilde(x$1);
    if ((x$1$1 !== null)) {
      var a = $n(x$1$1).Llaika_parse_builders$$tilde__f__1;
      var b = $n(x$1$1).Llaika_parse_builders$$tilde__f__2;
      return $n(f).apply__O__O__O(a, b);
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return $f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser(this$3, f$1);
});
var $d_Llaika_parse_syntax$PrefixedMap2Ops$ = new $TypeData().initClass($c_Llaika_parse_syntax$PrefixedMap2Ops$, "laika.parse.syntax$PrefixedMap2Ops$", ({
  Llaika_parse_syntax$PrefixedMap2Ops$: 1
}));
var $n_Llaika_parse_syntax$PrefixedMap2Ops$;
function $m_Llaika_parse_syntax$PrefixedMap2Ops$() {
  if ((!$n_Llaika_parse_syntax$PrefixedMap2Ops$)) {
    $n_Llaika_parse_syntax$PrefixedMap2Ops$ = new $c_Llaika_parse_syntax$PrefixedMap2Ops$();
  }
  return $n_Llaika_parse_syntax$PrefixedMap2Ops$;
}
/** @constructor */
function $c_Llaika_parse_syntax$PrefixedMap3Ops$() {
}
$c_Llaika_parse_syntax$PrefixedMap3Ops$.prototype = new $h_O();
$c_Llaika_parse_syntax$PrefixedMap3Ops$.prototype.constructor = $c_Llaika_parse_syntax$PrefixedMap3Ops$;
/** @constructor */
function $h_Llaika_parse_syntax$PrefixedMap3Ops$() {
}
$h_Llaika_parse_syntax$PrefixedMap3Ops$.prototype = $c_Llaika_parse_syntax$PrefixedMap3Ops$.prototype;
$c_Llaika_parse_syntax$PrefixedMap3Ops$.prototype.mapN$extension__Llaika_parse_text_PrefixedParser__F3__Llaika_parse_text_PrefixedParser = (function(this$, f) {
  var this$4 = $n(this$);
  var f$1 = new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Llaika_parse_builders$$tilde(x$1);
    if ((x$1$1 !== null)) {
      var x124 = $as_Llaika_parse_builders$$tilde($n(x$1$1).Llaika_parse_builders$$tilde__f__1);
      if ((x124 !== null)) {
        var a = $n(x124).Llaika_parse_builders$$tilde__f__1;
        var b = $n(x124).Llaika_parse_builders$$tilde__f__2;
        var c = $n(x$1$1).Llaika_parse_builders$$tilde__f__2;
        return $n(f).apply__O__O__O__O(a, b, c);
      }
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return $f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser(this$4, f$1);
});
var $d_Llaika_parse_syntax$PrefixedMap3Ops$ = new $TypeData().initClass($c_Llaika_parse_syntax$PrefixedMap3Ops$, "laika.parse.syntax$PrefixedMap3Ops$", ({
  Llaika_parse_syntax$PrefixedMap3Ops$: 1
}));
var $n_Llaika_parse_syntax$PrefixedMap3Ops$;
function $m_Llaika_parse_syntax$PrefixedMap3Ops$() {
  if ((!$n_Llaika_parse_syntax$PrefixedMap3Ops$)) {
    $n_Llaika_parse_syntax$PrefixedMap3Ops$ = new $c_Llaika_parse_syntax$PrefixedMap3Ops$();
  }
  return $n_Llaika_parse_syntax$PrefixedMap3Ops$;
}
/** @constructor */
function $c_Llaika_parse_syntax$PrependParserOps$() {
}
$c_Llaika_parse_syntax$PrependParserOps$.prototype = new $h_O();
$c_Llaika_parse_syntax$PrependParserOps$.prototype.constructor = $c_Llaika_parse_syntax$PrependParserOps$;
/** @constructor */
function $h_Llaika_parse_syntax$PrependParserOps$() {
}
$h_Llaika_parse_syntax$PrependParserOps$.prototype = $c_Llaika_parse_syntax$PrependParserOps$.prototype;
$c_Llaika_parse_syntax$PrependParserOps$.prototype.concat$extension__Llaika_parse_Parser__Llaika_parse_Parser = (function(this$) {
  return $n(this$).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Llaika_parse_builders$$tilde(x$1);
    if ((x$1$1 !== null)) {
      var x = $n(x$1$1).Llaika_parse_builders$$tilde__f__1;
      var xs = $as_sci_Seq($n(x$1$1).Llaika_parse_builders$$tilde__f__2);
      var this$3 = $n(xs);
      return $as_sci_Seq(this$3.prepended__O__O(x));
    }
    throw new $c_s_MatchError(x$1$1);
  })));
});
var $d_Llaika_parse_syntax$PrependParserOps$ = new $TypeData().initClass($c_Llaika_parse_syntax$PrependParserOps$, "laika.parse.syntax$PrependParserOps$", ({
  Llaika_parse_syntax$PrependParserOps$: 1
}));
var $n_Llaika_parse_syntax$PrependParserOps$;
function $m_Llaika_parse_syntax$PrependParserOps$() {
  if ((!$n_Llaika_parse_syntax$PrependParserOps$)) {
    $n_Llaika_parse_syntax$PrependParserOps$ = new $c_Llaika_parse_syntax$PrependParserOps$();
  }
  return $n_Llaika_parse_syntax$PrependParserOps$;
}
/** @constructor */
function $c_Llaika_parse_syntax$Seq2ParsersOps$() {
}
$c_Llaika_parse_syntax$Seq2ParsersOps$.prototype = new $h_O();
$c_Llaika_parse_syntax$Seq2ParsersOps$.prototype.constructor = $c_Llaika_parse_syntax$Seq2ParsersOps$;
/** @constructor */
function $h_Llaika_parse_syntax$Seq2ParsersOps$() {
}
$h_Llaika_parse_syntax$Seq2ParsersOps$.prototype = $c_Llaika_parse_syntax$Seq2ParsersOps$.prototype;
$c_Llaika_parse_syntax$Seq2ParsersOps$.prototype.concat$extension__Llaika_parse_Parser__Llaika_parse_Parser = (function(this$) {
  return $n(this$).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Llaika_parse_builders$$tilde(x$1);
    if ((x$1$1 !== null)) {
      var x = $as_sci_Seq($n(x$1$1).Llaika_parse_builders$$tilde__f__1);
      var xs = $as_sci_Seq($n(x$1$1).Llaika_parse_builders$$tilde__f__2);
      var this$3 = $n(x);
      return $as_sci_Seq(this$3.appendedAll__sc_IterableOnce__O(xs));
    }
    throw new $c_s_MatchError(x$1$1);
  })));
});
var $d_Llaika_parse_syntax$Seq2ParsersOps$ = new $TypeData().initClass($c_Llaika_parse_syntax$Seq2ParsersOps$, "laika.parse.syntax$Seq2ParsersOps$", ({
  Llaika_parse_syntax$Seq2ParsersOps$: 1
}));
var $n_Llaika_parse_syntax$Seq2ParsersOps$;
function $m_Llaika_parse_syntax$Seq2ParsersOps$() {
  if ((!$n_Llaika_parse_syntax$Seq2ParsersOps$)) {
    $n_Llaika_parse_syntax$Seq2ParsersOps$ = new $c_Llaika_parse_syntax$Seq2ParsersOps$();
  }
  return $n_Llaika_parse_syntax$Seq2ParsersOps$;
}
/** @constructor */
function $c_Llaika_parse_syntax$SeqStringParserOps$() {
}
$c_Llaika_parse_syntax$SeqStringParserOps$.prototype = new $h_O();
$c_Llaika_parse_syntax$SeqStringParserOps$.prototype.constructor = $c_Llaika_parse_syntax$SeqStringParserOps$;
/** @constructor */
function $h_Llaika_parse_syntax$SeqStringParserOps$() {
}
$h_Llaika_parse_syntax$SeqStringParserOps$.prototype = $c_Llaika_parse_syntax$SeqStringParserOps$.prototype;
$c_Llaika_parse_syntax$SeqStringParserOps$.prototype.mkLines$extension__Llaika_parse_Parser__Llaika_parse_Parser = (function(this$) {
  return $n(this$).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$1) => {
    var _$1$1 = $as_sci_Seq(_$1);
    var this$2 = $n(_$1$1);
    return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$2, "", "\n", "");
  })));
});
var $d_Llaika_parse_syntax$SeqStringParserOps$ = new $TypeData().initClass($c_Llaika_parse_syntax$SeqStringParserOps$, "laika.parse.syntax$SeqStringParserOps$", ({
  Llaika_parse_syntax$SeqStringParserOps$: 1
}));
var $n_Llaika_parse_syntax$SeqStringParserOps$;
function $m_Llaika_parse_syntax$SeqStringParserOps$() {
  if ((!$n_Llaika_parse_syntax$SeqStringParserOps$)) {
    $n_Llaika_parse_syntax$SeqStringParserOps$ = new $c_Llaika_parse_syntax$SeqStringParserOps$();
  }
  return $n_Llaika_parse_syntax$SeqStringParserOps$;
}
/** @constructor */
function $c_Llaika_parse_syntax$StringParserOps$() {
}
$c_Llaika_parse_syntax$StringParserOps$.prototype = new $h_O();
$c_Llaika_parse_syntax$StringParserOps$.prototype.constructor = $c_Llaika_parse_syntax$StringParserOps$;
/** @constructor */
function $h_Llaika_parse_syntax$StringParserOps$() {
}
$h_Llaika_parse_syntax$StringParserOps$.prototype = $c_Llaika_parse_syntax$StringParserOps$.prototype;
$c_Llaika_parse_syntax$StringParserOps$.prototype.line$extension__Llaika_parse_Parser__Llaika_parse_Parser = (function(this$) {
  var this$7 = $m_Llaika_parse_Parser$();
  var f$1 = new $c_sjsr_AnonFunction1(((in$1) => {
    var in$2 = $as_Llaika_parse_SourceCursor(in$1);
    matchResult24: {
      var $x_1;
      var x91 = $n(this$).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(in$2);
      if ((x91 instanceof $c_Llaika_parse_Failure)) {
        var f = $as_Llaika_parse_Failure(x91);
        var $x_1 = f;
        break matchResult24;
      }
      if ((x91 instanceof $c_Llaika_parse_Success)) {
        var x$1 = $as_Llaika_parse_Success(x91);
        var this$3 = $n(x$1);
        var x94 = $as_T(this$3.Llaika_parse_Success__f_result);
        var this$4 = $n(x$1);
        var x95 = this$4.Llaika_parse_Success__f_next;
        var result = new $c_Llaika_parse_LineSource(x94, in$2, 0, $n(in$2).nestLevel__I());
        var $x_1 = new $c_Llaika_parse_Success(result, x95);
        break matchResult24;
      }
      throw new $c_s_MatchError(x91);
    }
    return $as_Llaika_parse_Parsed($x_1);
  }));
  return new $c_Llaika_parse_Parser$$anon$2(f$1, this$7);
});
$c_Llaika_parse_syntax$StringParserOps$.prototype.trim$extension__Llaika_parse_Parser__Llaika_parse_Parser = (function(this$) {
  return $n(this$).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$3) => {
    var _$3$1 = $as_T(_$3);
    return $f_T__trim__T($n(_$3$1));
  })));
});
var $d_Llaika_parse_syntax$StringParserOps$ = new $TypeData().initClass($c_Llaika_parse_syntax$StringParserOps$, "laika.parse.syntax$StringParserOps$", ({
  Llaika_parse_syntax$StringParserOps$: 1
}));
var $n_Llaika_parse_syntax$StringParserOps$;
function $m_Llaika_parse_syntax$StringParserOps$() {
  if ((!$n_Llaika_parse_syntax$StringParserOps$)) {
    $n_Llaika_parse_syntax$StringParserOps$ = new $c_Llaika_parse_syntax$StringParserOps$();
  }
  return $n_Llaika_parse_syntax$StringParserOps$;
}
/** @constructor */
function $c_Llaika_parse_text_CharGroup$() {
  this.Llaika_parse_text_CharGroup$__f_digit = null;
  this.Llaika_parse_text_CharGroup$__f_hexDigit = null;
  this.Llaika_parse_text_CharGroup$__f_octalDigit = null;
  this.Llaika_parse_text_CharGroup$__f_lowerAlpha = null;
  this.Llaika_parse_text_CharGroup$__f_upperAlpha = null;
  this.Llaika_parse_text_CharGroup$__f_alpha = null;
  this.Llaika_parse_text_CharGroup$__f_alphaNum = null;
  $n_Llaika_parse_text_CharGroup$ = this;
  var this$2 = new $c_sr_RichChar(48);
  var range = $f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive(this$2, $bC(57));
  var $x_2 = $m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet;
  var $x_1 = $n(range).head__O();
  var this$3 = $n(range);
  this.Llaika_parse_text_CharGroup$__f_digit = $n($x_2).of__O__sci_Seq__Lcats_kernel_Order__O($x_1, this$3.tail__sci_NumericRange(), $m_Lcats_kernel_instances_char_package$().Lcats_kernel_instances_char_package$__f_catsKernelStdOrderForChar);
  var value = this.Llaika_parse_text_CharGroup$__f_digit;
  var this$10 = new $c_Lcats_data_NonEmptySetOps(value);
  var this$7 = new $c_sr_RichChar(97);
  var range$1 = $f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive(this$7, $bC(102));
  var $x_4 = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet);
  var $x_3 = $n(range$1).head__O();
  var this$8 = $n(range$1);
  var as = $n($x_4).of__O__sci_Seq__Lcats_kernel_Order__O($x_3, this$8.tail__sci_NumericRange(), $m_Lcats_kernel_instances_char_package$().Lcats_kernel_instances_char_package$__f_catsKernelStdOrderForChar);
  var value$1 = this$10.union__O__O(as);
  var this$16 = new $c_Lcats_data_NonEmptySetOps(value$1);
  var this$13 = new $c_sr_RichChar(65);
  var range$2 = $f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive(this$13, $bC(70));
  var $x_6 = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet);
  var $x_5 = $n(range$2).head__O();
  var this$14 = $n(range$2);
  var as$1 = $n($x_6).of__O__sci_Seq__Lcats_kernel_Order__O($x_5, this$14.tail__sci_NumericRange(), $m_Lcats_kernel_instances_char_package$().Lcats_kernel_instances_char_package$__f_catsKernelStdOrderForChar);
  this.Llaika_parse_text_CharGroup$__f_hexDigit = this$16.union__O__O(as$1);
  var value$2 = this.Llaika_parse_text_CharGroup$__f_digit;
  var this$22 = new $c_Lcats_data_NonEmptySetOps(value$2);
  var this$19 = new $c_sr_RichChar(48);
  var range$3 = $f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive(this$19, $bC(55));
  var $x_8 = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet);
  var $x_7 = $n(range$3).head__O();
  var this$20 = $n(range$3);
  var as$2 = $n($x_8).of__O__sci_Seq__Lcats_kernel_Order__O($x_7, this$20.tail__sci_NumericRange(), $m_Lcats_kernel_instances_char_package$().Lcats_kernel_instances_char_package$__f_catsKernelStdOrderForChar);
  this.Llaika_parse_text_CharGroup$__f_octalDigit = this$22.union__O__O(as$2);
  var this$24 = new $c_sr_RichChar(97);
  var range$4 = $f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive(this$24, $bC(122));
  var $x_10 = $m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet;
  var $x_9 = $n(range$4).head__O();
  var this$25 = $n(range$4);
  this.Llaika_parse_text_CharGroup$__f_lowerAlpha = $n($x_10).of__O__sci_Seq__Lcats_kernel_Order__O($x_9, this$25.tail__sci_NumericRange(), $m_Lcats_kernel_instances_char_package$().Lcats_kernel_instances_char_package$__f_catsKernelStdOrderForChar);
  var this$28 = new $c_sr_RichChar(65);
  var range$5 = $f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive(this$28, $bC(90));
  var $x_12 = $m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet;
  var $x_11 = $n(range$5).head__O();
  var this$29 = $n(range$5);
  this.Llaika_parse_text_CharGroup$__f_upperAlpha = $n($x_12).of__O__sci_Seq__Lcats_kernel_Order__O($x_11, this$29.tail__sci_NumericRange(), $m_Lcats_kernel_instances_char_package$().Lcats_kernel_instances_char_package$__f_catsKernelStdOrderForChar);
  var value$3 = this.Llaika_parse_text_CharGroup$__f_lowerAlpha;
  var this$32 = new $c_Lcats_data_NonEmptySetOps(value$3);
  var as$3 = this.Llaika_parse_text_CharGroup$__f_upperAlpha;
  this.Llaika_parse_text_CharGroup$__f_alpha = this$32.union__O__O(as$3);
  var value$4 = this.Llaika_parse_text_CharGroup$__f_alpha;
  var this$34 = new $c_Lcats_data_NonEmptySetOps(value$4);
  var as$4 = this.Llaika_parse_text_CharGroup$__f_digit;
  this.Llaika_parse_text_CharGroup$__f_alphaNum = this$34.union__O__O(as$4);
}
$c_Llaika_parse_text_CharGroup$.prototype = new $h_O();
$c_Llaika_parse_text_CharGroup$.prototype.constructor = $c_Llaika_parse_text_CharGroup$;
/** @constructor */
function $h_Llaika_parse_text_CharGroup$() {
}
$h_Llaika_parse_text_CharGroup$.prototype = $c_Llaika_parse_text_CharGroup$.prototype;
var $d_Llaika_parse_text_CharGroup$ = new $TypeData().initClass($c_Llaika_parse_text_CharGroup$, "laika.parse.text.CharGroup$", ({
  Llaika_parse_text_CharGroup$: 1
}));
var $n_Llaika_parse_text_CharGroup$;
function $m_Llaika_parse_text_CharGroup$() {
  if ((!$n_Llaika_parse_text_CharGroup$)) {
    $n_Llaika_parse_text_CharGroup$ = new $c_Llaika_parse_text_CharGroup$();
  }
  return $n_Llaika_parse_text_CharGroup$;
}
/** @constructor */
function $c_Llaika_parse_text_Characters$() {
  this.Llaika_parse_text_Characters$__f_StringResultBuilder = null;
  this.Llaika_parse_text_Characters$__f_CountResultBuilder = null;
  this.Llaika_parse_text_Characters$__f_UnitResultBuilder = null;
  $n_Llaika_parse_text_Characters$ = this;
  this.Llaika_parse_text_Characters$__f_StringResultBuilder = new $c_sjsr_AnonFunction2(((ctx, consumed) => {
    var ctx$1 = $as_Llaika_parse_SourceCursor(ctx);
    var consumed$1 = $uI(consumed);
    return $n(ctx$1).capture__I__T(consumed$1);
  }));
  this.Llaika_parse_text_Characters$__f_CountResultBuilder = new $c_sjsr_AnonFunction2(((_$1, consumed$2) => {
    $as_Llaika_parse_SourceCursor(_$1);
    var consumed$3 = $uI(consumed$2);
    return consumed$3;
  }));
  this.Llaika_parse_text_Characters$__f_UnitResultBuilder = new $c_sjsr_AnonFunction2(((v1, v2) => {
    $as_Llaika_parse_SourceCursor(v1);
    $uI(v2);
  }));
}
$c_Llaika_parse_text_Characters$.prototype = new $h_O();
$c_Llaika_parse_text_Characters$.prototype.constructor = $c_Llaika_parse_text_Characters$;
/** @constructor */
function $h_Llaika_parse_text_Characters$() {
}
$h_Llaika_parse_text_Characters$.prototype = $c_Llaika_parse_text_Characters$.prototype;
$c_Llaika_parse_text_Characters$.prototype.optimizedLookup__sc_Iterable__AB = (function(chars) {
  var this$1 = $n(chars);
  if ((!this$1.isEmpty__Z())) {
    var max = $uC($n(chars).max__s_math_Ordering__O($m_s_math_Ordering$Char$()));
  } else {
    var max = (-1);
  }
  var dimensions = new $ac_I(new Int32Array([((1 + max) | 0)]));
  var lookup = $asArrayOf_B($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_B.getClassOf(), dimensions), 1);
  $n(chars).foreach__F1__V(new $c_sjsr_AnonFunction1(((v1) => {
    var c = $uC(v1);
    $n(lookup).set(c, 1);
  })));
  return lookup;
});
$c_Llaika_parse_text_Characters$.prototype.include__sci_Seq__Llaika_parse_text_Characters = (function(chars) {
  var p;
  var x1 = $n(chars).length__I();
  switch (x1) {
    case 0: {
      var p = new $c_sjsr_AnonFunction1(((_$4) => {
        $uC(_$4);
        return false;
      }));
      break;
    }
    case 1: {
      var c = $uC($n(chars).apply__I__O(0));
      var p = new $c_sjsr_AnonFunction1(((_$5) => {
        var _$5$1 = $uC(_$5);
        return (_$5$1 === c);
      }));
      break;
    }
    case 2: {
      var c1 = $uC($n(chars).apply__I__O(0));
      var c2 = $uC($n(chars).apply__I__O(1));
      var p = new $c_sjsr_AnonFunction1(((c$3) => {
        var c$1 = $uC(c$3);
        return ((c$1 === c1) || (c$1 === c2));
      }));
      break;
    }
    default: {
      var lookup = this.optimizedLookup__sc_Iterable__AB(chars);
      var max = (((-1) + $n(lookup).u.length) | 0);
      var p = new $c_sjsr_AnonFunction1(((c$4) => {
        var c$2 = $uC(c$4);
        return ((c$2 <= max) && ($n(lookup).get(c$2) === 1));
      }));
    }
  }
  return new $c_Llaika_parse_text_Characters(p, this.Llaika_parse_text_Characters$__f_StringResultBuilder, 0, (-1));
});
$c_Llaika_parse_text_Characters$.prototype.exclude__sci_Seq__Llaika_parse_text_Characters = (function(chars) {
  var p;
  var x2 = $n(chars).length__I();
  switch (x2) {
    case 0: {
      var p = new $c_sjsr_AnonFunction1(((_$6) => {
        $uC(_$6);
        return true;
      }));
      break;
    }
    case 1: {
      var c = $uC($n(chars).apply__I__O(0));
      var p = new $c_sjsr_AnonFunction1(((_$7) => {
        var _$7$1 = $uC(_$7);
        return (_$7$1 !== c);
      }));
      break;
    }
    case 2: {
      var c1 = $uC($n(chars).apply__I__O(0));
      var c2 = $uC($n(chars).apply__I__O(1));
      var p = new $c_sjsr_AnonFunction1(((c$3) => {
        var c$1 = $uC(c$3);
        return ((c$1 !== c1) && (c$1 !== c2));
      }));
      break;
    }
    default: {
      var lookup = this.optimizedLookup__sc_Iterable__AB(chars);
      var max = (((-1) + $n(lookup).u.length) | 0);
      var p = new $c_sjsr_AnonFunction1(((c$4) => {
        var c$2 = $uC(c$4);
        return ((c$2 > max) || ($n(lookup).get(c$2) === 0));
      }));
    }
  }
  return new $c_Llaika_parse_text_Characters(p, this.Llaika_parse_text_Characters$__f_StringResultBuilder, 0, (-1));
});
var $d_Llaika_parse_text_Characters$ = new $TypeData().initClass($c_Llaika_parse_text_Characters$, "laika.parse.text.Characters$", ({
  Llaika_parse_text_Characters$: 1
}));
var $n_Llaika_parse_text_Characters$;
function $m_Llaika_parse_text_Characters$() {
  if ((!$n_Llaika_parse_text_Characters$)) {
    $n_Llaika_parse_text_Characters$ = new $c_Llaika_parse_text_Characters$();
  }
  return $n_Llaika_parse_text_Characters$;
}
/** @constructor */
function $c_Llaika_parse_text_DelimitedText$() {
  this.Llaika_parse_text_DelimitedText$__f_Undelimited$lzy1 = null;
  this.Llaika_parse_text_DelimitedText$__f_Undelimitedbitmap$1 = false;
}
$c_Llaika_parse_text_DelimitedText$.prototype = new $h_O();
$c_Llaika_parse_text_DelimitedText$.prototype.constructor = $c_Llaika_parse_text_DelimitedText$;
/** @constructor */
function $h_Llaika_parse_text_DelimitedText$() {
}
$h_Llaika_parse_text_DelimitedText$.prototype = $c_Llaika_parse_text_DelimitedText$.prototype;
$c_Llaika_parse_text_DelimitedText$.prototype.Undelimited__Llaika_parse_text_DelimitedText = (function() {
  if ((!this.Llaika_parse_text_DelimitedText$__f_Undelimitedbitmap$1)) {
    var parser = $m_s_None$();
    var failOn = $m_Llaika_parse_text_TextDelimiter$().$lessinit$greater$default$5__sci_Set();
    this.Llaika_parse_text_DelimitedText$__f_Undelimited$lzy1 = new $c_Llaika_parse_text_DelimitedText(new $c_Llaika_parse_text_TextDelimiter(parser, false, false, false, failOn)).acceptEOF__Llaika_parse_text_DelimitedText();
    this.Llaika_parse_text_DelimitedText$__f_Undelimitedbitmap$1 = true;
  }
  return this.Llaika_parse_text_DelimitedText$__f_Undelimited$lzy1;
});
var $d_Llaika_parse_text_DelimitedText$ = new $TypeData().initClass($c_Llaika_parse_text_DelimitedText$, "laika.parse.text.DelimitedText$", ({
  Llaika_parse_text_DelimitedText$: 1
}));
var $n_Llaika_parse_text_DelimitedText$;
function $m_Llaika_parse_text_DelimitedText$() {
  if ((!$n_Llaika_parse_text_DelimitedText$)) {
    $n_Llaika_parse_text_DelimitedText$ = new $c_Llaika_parse_text_DelimitedText$();
  }
  return $n_Llaika_parse_text_DelimitedText$;
}
function $is_Llaika_parse_text_Delimiter(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_parse_text_Delimiter)));
}
function $as_Llaika_parse_text_Delimiter(obj) {
  return (($is_Llaika_parse_text_Delimiter(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.parse.text.Delimiter"));
}
function $isArrayOf_Llaika_parse_text_Delimiter(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_parse_text_Delimiter)));
}
function $asArrayOf_Llaika_parse_text_Delimiter(obj, depth) {
  return (($isArrayOf_Llaika_parse_text_Delimiter(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.parse.text.Delimiter;", depth));
}
/** @constructor */
function $c_Llaika_parse_text_DelimiterParser$() {
}
$c_Llaika_parse_text_DelimiterParser$.prototype = new $h_O();
$c_Llaika_parse_text_DelimiterParser$.prototype.constructor = $c_Llaika_parse_text_DelimiterParser$;
/** @constructor */
function $h_Llaika_parse_text_DelimiterParser$() {
}
$h_Llaika_parse_text_DelimiterParser$.prototype = $c_Llaika_parse_text_DelimiterParser$.prototype;
$c_Llaika_parse_text_DelimiterParser$.prototype.$lessinit$greater$default$2__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((_$1) => {
    $uC(_$1);
    return false;
  }));
});
$c_Llaika_parse_text_DelimiterParser$.prototype.$lessinit$greater$default$3__F1 = (function() {
  return new $c_sjsr_AnonFunction1(((_$2) => {
    $uC(_$2);
    return false;
  }));
});
$c_Llaika_parse_text_DelimiterParser$.prototype.$lessinit$greater$default$4__F2 = (function() {
  return new $c_sjsr_AnonFunction2(((_$3, _$4) => {
    $uC(_$3);
    $uC(_$4);
    return false;
  }));
});
var $d_Llaika_parse_text_DelimiterParser$ = new $TypeData().initClass($c_Llaika_parse_text_DelimiterParser$, "laika.parse.text.DelimiterParser$", ({
  Llaika_parse_text_DelimiterParser$: 1
}));
var $n_Llaika_parse_text_DelimiterParser$;
function $m_Llaika_parse_text_DelimiterParser$() {
  if ((!$n_Llaika_parse_text_DelimiterParser$)) {
    $n_Llaika_parse_text_DelimiterParser$ = new $c_Llaika_parse_text_DelimiterParser$();
  }
  return $n_Llaika_parse_text_DelimiterParser$;
}
function $is_Llaika_parse_text_DelimiterResult(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_parse_text_DelimiterResult)));
}
function $as_Llaika_parse_text_DelimiterResult(obj) {
  return (($is_Llaika_parse_text_DelimiterResult(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.parse.text.DelimiterResult"));
}
function $isArrayOf_Llaika_parse_text_DelimiterResult(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_parse_text_DelimiterResult)));
}
function $asArrayOf_Llaika_parse_text_DelimiterResult(obj, depth) {
  return (($isArrayOf_Llaika_parse_text_DelimiterResult(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.parse.text.DelimiterResult;", depth));
}
function $f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser($thiz, p) {
  var this$1 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = $thiz.startChars__O();
  var p$1 = $c_Llaika_parse_Parser.prototype.$tilde__Llaika_parse_Parser__Llaika_parse_Parser.call($thiz, p);
  return new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p$1, this$1);
}
function $f_Llaika_parse_text_PrefixedParser__$tilde$greater__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser($thiz, p) {
  var this$1 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = $thiz.startChars__O();
  var p$1 = $c_Llaika_parse_Parser.prototype.$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser.call($thiz, p);
  return new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p$1, this$1);
}
function $f_Llaika_parse_text_PrefixedParser__$less$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser($thiz, p) {
  var this$1 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = $thiz.startChars__O();
  var p$1 = $c_Llaika_parse_Parser.prototype.$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser.call($thiz, p);
  return new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p$1, this$1);
}
function $f_Llaika_parse_text_PrefixedParser__$tilde__T__Llaika_parse_text_PrefixedParser($thiz, value) {
  $m_Llaika_parse_text_TextParsers$();
  var p = new $c_Llaika_parse_text_Literal(value);
  return $f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser($thiz, p);
}
function $f_Llaika_parse_text_PrefixedParser__$less$tilde__T__Llaika_parse_text_PrefixedParser($thiz, value) {
  $m_Llaika_parse_text_TextParsers$();
  var p = new $c_Llaika_parse_text_Literal(value);
  return $f_Llaika_parse_text_PrefixedParser__$less$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser($thiz, p);
}
function $f_Llaika_parse_text_PrefixedParser__flatMap__F1__Llaika_parse_text_PrefixedParser($thiz, f) {
  var this$1 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = $thiz.startChars__O();
  var p = $c_Llaika_parse_Parser.prototype.flatMap__F1__Llaika_parse_Parser.call($thiz, f);
  return new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p, this$1);
}
function $f_Llaika_parse_text_PrefixedParser__$greater$greater__F1__Llaika_parse_text_PrefixedParser($thiz, fq) {
  var this$1 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = $thiz.startChars__O();
  var p = $c_Llaika_parse_Parser.prototype.flatMap__F1__Llaika_parse_Parser.call($thiz, fq);
  return new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p, this$1);
}
function $f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser($thiz, f) {
  var this$1 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = $thiz.startChars__O();
  var p = $c_Llaika_parse_Parser.prototype.map__F1__Llaika_parse_Parser.call($thiz, f);
  return new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p, this$1);
}
function $f_Llaika_parse_text_PrefixedParser__$up$up__F1__Llaika_parse_text_PrefixedParser($thiz, f) {
  var this$1 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = $thiz.startChars__O();
  var p = $c_Llaika_parse_Parser.prototype.map__F1__Llaika_parse_Parser.call($thiz, f);
  return new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p, this$1);
}
function $f_Llaika_parse_text_PrefixedParser__as__F0__Llaika_parse_text_PrefixedParser($thiz, v) {
  var this$1 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = $thiz.startChars__O();
  var p = new $c_Llaika_parse_Parser$$anon$1(v, $thiz);
  return new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p, this$1);
}
function $f_Llaika_parse_text_PrefixedParser__evalMap__F1__Llaika_parse_text_PrefixedParser($thiz, f) {
  var this$1 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = $thiz.startChars__O();
  var p = $c_Llaika_parse_Parser.prototype.evalMap__F1__Llaika_parse_Parser.call($thiz, f);
  return new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p, this$1);
}
function $f_Llaika_parse_text_PrefixedParser__collect__s_PartialFunction__F1__Llaika_parse_text_PrefixedParser($thiz, f, error) {
  var this$1 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = $thiz.startChars__O();
  var p = $c_Llaika_parse_Parser.prototype.collect__s_PartialFunction__F1__Llaika_parse_Parser.call($thiz, f, error);
  return new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p, this$1);
}
function $f_Llaika_parse_text_PrefixedParser__collect$default$2__F1($thiz) {
  return new $c_sjsr_AnonFunction1(((r) => ("Constructor function not defined at " + r)));
}
function $f_Llaika_parse_text_PrefixedParser__orElse__F0__Llaika_parse_text_PrefixedParser($thiz, p) {
  var this$3 = $m_Llaika_parse_text_PrefixedParser$();
  var value = $thiz.startChars__O();
  var this$2 = new $c_Lcats_data_NonEmptySetOps(value);
  var as = $n($as_Llaika_parse_text_PrefixedParser($n(p).apply__O())).startChars__O();
  var sc = this$2.union__O__O(as);
  var p$1 = $c_Llaika_parse_Parser.prototype.orElse__F0__Llaika_parse_Parser.call($thiz, p);
  return new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p$1, this$3);
}
function $f_Llaika_parse_text_PrefixedParser__$bar__F0__Llaika_parse_text_PrefixedParser($thiz, p) {
  var this$3 = $m_Llaika_parse_text_PrefixedParser$();
  var value = $thiz.startChars__O();
  var this$2 = new $c_Lcats_data_NonEmptySetOps(value);
  var as = $n($as_Llaika_parse_text_PrefixedParser($n(p).apply__O())).startChars__O();
  var sc = this$2.union__O__O(as);
  var p$1 = $c_Llaika_parse_Parser.prototype.orElse__F0__Llaika_parse_Parser.call($thiz, p);
  return new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p$1, this$3);
}
function $f_Llaika_parse_text_PrefixedParser__$bar__T__s_$less$colon$less__Llaika_parse_text_PrefixedParser($thiz, value, ev) {
  var this$2 = $n($f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser($thiz, ev));
  var p = new $c_sjsr_AnonFunction0((() => {
    $m_Llaika_parse_text_TextParsers$();
    return new $c_Llaika_parse_text_Literal(value);
  }));
  return $f_Llaika_parse_text_PrefixedParser__orElse__F0__Llaika_parse_text_PrefixedParser(this$2, p);
}
function $is_Llaika_parse_text_PrefixedParser(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_parse_text_PrefixedParser)));
}
function $as_Llaika_parse_text_PrefixedParser(obj) {
  return (($is_Llaika_parse_text_PrefixedParser(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.parse.text.PrefixedParser"));
}
function $isArrayOf_Llaika_parse_text_PrefixedParser(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_parse_text_PrefixedParser)));
}
function $asArrayOf_Llaika_parse_text_PrefixedParser(obj, depth) {
  return (($isArrayOf_Llaika_parse_text_PrefixedParser(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.parse.text.PrefixedParser;", depth));
}
var $d_Llaika_parse_text_PrefixedParser = new $TypeData().initClass(1, "laika.parse.text.PrefixedParser", ({
  Llaika_parse_text_PrefixedParser: 1
}));
/** @constructor */
function $c_Llaika_parse_text_PrefixedParser$() {
}
$c_Llaika_parse_text_PrefixedParser$.prototype = new $h_O();
$c_Llaika_parse_text_PrefixedParser$.prototype.constructor = $c_Llaika_parse_text_PrefixedParser$;
/** @constructor */
function $h_Llaika_parse_text_PrefixedParser$() {
}
$h_Llaika_parse_text_PrefixedParser$.prototype = $c_Llaika_parse_text_PrefixedParser$.prototype;
$c_Llaika_parse_text_PrefixedParser$.prototype.mapAndMerge__sci_Seq__sci_Map = (function(parsers) {
  var this$6 = $n($as_sc_IterableOps($n(parsers).flatMap__F1__O(new $c_sjsr_AnonFunction1(((parserDef) => {
    var parserDef$1 = $as_Llaika_parse_text_PrefixedParser(parserDef);
    var target = $n(parserDef$1).startChars__O();
    var tc = $m_Lcats_data_NonEmptySetImpl$().Lcats_data_NonEmptySetInstances__f_catsDataInstancesForNonEmptySet;
    var this$3 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(target, tc);
    var this$5 = $n($n(this$3.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).toList__O__sci_List(this$3.Lcats_Foldable$ToFoldableOps$$anon$6__f_self));
    var f = ((c) => {
      var c$1 = $uC(c);
      return new $c_T2($bC(c$1), parserDef$1);
    });
    if ((this$5 === $m_sci_Nil$())) {
      return $m_sci_Nil$();
    } else {
      var arg1 = this$5.head__O();
      var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(this$5.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var arg1$1 = $n(rest).head__O();
        var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O());
      }
      return h;
    }
  })))));
  var m = $as_scm_Map($m_scm_Map$().empty__O());
  var it = this$6.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    var _$1 = $as_T2(elem);
    var key = $uC($n(_$1)._1__O());
    var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O($bC(key), new $c_sjsr_AnonFunction0(((this$6) => (() => this$6.newSpecificBuilder__scm_Builder()))(this$6))));
    var this$7 = $n(bldr);
    this$7.addOne__O__scm_Growable(elem);
  }
  var this$8 = $m_sci_HashMap$();
  var result = this$8.sci_HashMap$__f_EmptyMap;
  var mapIt = $n(m).iterator__sc_Iterator();
  while ($n(mapIt).hasNext__Z()) {
    var x1 = $as_T2($n(mapIt).next__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = $n(x1)._1__O();
    var v = $as_scm_Builder($n(x1)._2__O());
    result = $n(result).updated__O__O__sci_HashMap(k, $n(v).result__O());
  }
  var this$9 = $n(result);
  $m_sci_HashMap$();
  var b = new $c_sci_HashMapBuilder();
  var it$1 = this$9.iterator__sc_Iterator();
  while ($n(it$1).hasNext__Z()) {
    var arg1$2 = $n(it$1).next__O();
    var x$1 = $as_T2(arg1$2);
    matchResult1: {
      var elem$1___1;
      var elem$1___2;
      if ((x$1 !== null)) {
        var char = $uC($n(x$1)._1__O());
        var definitions = $as_sci_Seq($n(x$1)._2__O());
        var _2 = $n($as_sc_IterableOnceOps($n(definitions).map__F1__O(new $c_sjsr_AnonFunction1(((_$2) => {
          var _$2$1 = $as_T2(_$2);
          return $as_Llaika_parse_text_PrefixedParser($n(_$2$1)._2__O());
        }))))).reduceLeft__F2__O(new $c_sjsr_AnonFunction2(((_$3, _$4) => {
          var _$3$1 = $as_Llaika_parse_text_PrefixedParser(_$3);
          var _$4$1 = $as_Llaika_parse_text_PrefixedParser(_$4);
          var this$12 = $n(_$3$1);
          var p = new $c_sjsr_AnonFunction0((() => _$4$1));
          return $f_Llaika_parse_text_PrefixedParser__$bar__F0__Llaika_parse_text_PrefixedParser(this$12, p);
        })));
        var elem$1___1 = $bC(char);
        var elem$1___2 = _2;
        break matchResult1;
      }
      throw new $c_s_MatchError(x$1);
    }
    $p_sci_HashMapBuilder__ensureUnaliased__V(b);
    var x = elem$1___1;
    var h$1 = $m_sr_Statics$().anyHash__O__I(x);
    var im = $m_sc_Hashing$().improve__I__I(h$1);
    b.update__sci_MapNode__O__O__I__I__I__V(b.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, elem$1___1, elem$1___2, h$1, im, 0);
  }
  return b.result__sci_HashMap();
});
var $d_Llaika_parse_text_PrefixedParser$ = new $TypeData().initClass($c_Llaika_parse_text_PrefixedParser$, "laika.parse.text.PrefixedParser$", ({
  Llaika_parse_text_PrefixedParser$: 1
}));
var $n_Llaika_parse_text_PrefixedParser$;
function $m_Llaika_parse_text_PrefixedParser$() {
  if ((!$n_Llaika_parse_text_PrefixedParser$)) {
    $n_Llaika_parse_text_PrefixedParser$ = new $c_Llaika_parse_text_PrefixedParser$();
  }
  return $n_Llaika_parse_text_PrefixedParser$;
}
/** @constructor */
function $c_Llaika_parse_text_WhitespacePreprocessor$() {
  this.Llaika_parse_text_WhitespacePreprocessor$__f_forString = null;
  $n_Llaika_parse_text_WhitespacePreprocessor$ = this;
  this.Llaika_parse_text_WhitespacePreprocessor$__f_forString = new $c_Llaika_parse_text_WhitespacePreprocessor();
}
$c_Llaika_parse_text_WhitespacePreprocessor$.prototype = new $h_O();
$c_Llaika_parse_text_WhitespacePreprocessor$.prototype.constructor = $c_Llaika_parse_text_WhitespacePreprocessor$;
/** @constructor */
function $h_Llaika_parse_text_WhitespacePreprocessor$() {
}
$h_Llaika_parse_text_WhitespacePreprocessor$.prototype = $c_Llaika_parse_text_WhitespacePreprocessor$.prototype;
var $d_Llaika_parse_text_WhitespacePreprocessor$ = new $TypeData().initClass($c_Llaika_parse_text_WhitespacePreprocessor$, "laika.parse.text.WhitespacePreprocessor$", ({
  Llaika_parse_text_WhitespacePreprocessor$: 1
}));
var $n_Llaika_parse_text_WhitespacePreprocessor$;
function $m_Llaika_parse_text_WhitespacePreprocessor$() {
  if ((!$n_Llaika_parse_text_WhitespacePreprocessor$)) {
    $n_Llaika_parse_text_WhitespacePreprocessor$ = new $c_Llaika_parse_text_WhitespacePreprocessor$();
  }
  return $n_Llaika_parse_text_WhitespacePreprocessor$;
}
/** @constructor */
function $c_RTLong(lo, hi) {
  this.RTLong__f_lo = 0;
  this.RTLong__f_hi = 0;
  this.RTLong__f_lo = lo;
  this.RTLong__f_hi = hi;
}
$c_RTLong.prototype = new $h_O();
$c_RTLong.prototype.constructor = $c_RTLong;
/** @constructor */
function $h_RTLong() {
}
$h_RTLong.prototype = $c_RTLong.prototype;
$c_RTLong.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_RTLong)) {
    var x2 = $as_RTLong(that);
    return ((this.RTLong__f_lo === $n(x2).RTLong__f_lo) && (this.RTLong__f_hi === $n(x2).RTLong__f_hi));
  } else {
    return false;
  }
});
$c_RTLong.prototype.hashCode__I = (function() {
  return (this.RTLong__f_lo ^ this.RTLong__f_hi);
});
$c_RTLong.prototype.toString__T = (function() {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this.RTLong__f_lo, this.RTLong__f_hi);
});
$c_RTLong.prototype.toInt__I = (function() {
  return this.RTLong__f_lo;
});
$c_RTLong.prototype.toFloat__F = (function() {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toFloat__I__I__F(this.RTLong__f_lo, this.RTLong__f_hi);
});
$c_RTLong.prototype.toDouble__D = (function() {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this.RTLong__f_lo, this.RTLong__f_hi);
});
$c_RTLong.prototype.byteValue__B = (function() {
  return ((this.RTLong__f_lo << 24) >> 24);
});
$c_RTLong.prototype.shortValue__S = (function() {
  return ((this.RTLong__f_lo << 16) >> 16);
});
$c_RTLong.prototype.intValue__I = (function() {
  return this.RTLong__f_lo;
});
$c_RTLong.prototype.longValue__J = (function() {
  return $uJ(this);
});
$c_RTLong.prototype.floatValue__F = (function() {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toFloat__I__I__F(this.RTLong__f_lo, this.RTLong__f_hi);
});
$c_RTLong.prototype.doubleValue__D = (function() {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this.RTLong__f_lo, this.RTLong__f_hi);
});
$c_RTLong.prototype.compareTo__O__I = (function(that) {
  var b = $as_RTLong(that);
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(this.RTLong__f_lo, this.RTLong__f_hi, $n(b).RTLong__f_lo, $n(b).RTLong__f_hi);
});
$c_RTLong.prototype.compareTo__jl_Long__I = (function(that) {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(this.RTLong__f_lo, this.RTLong__f_hi, $n(that).RTLong__f_lo, $n(that).RTLong__f_hi);
});
$c_RTLong.prototype.equals__RTLong__Z = (function(b) {
  return ((this.RTLong__f_lo === $n(b).RTLong__f_lo) && (this.RTLong__f_hi === $n(b).RTLong__f_hi));
});
$c_RTLong.prototype.notEquals__RTLong__Z = (function(b) {
  return (!((this.RTLong__f_lo === $n(b).RTLong__f_lo) && (this.RTLong__f_hi === $n(b).RTLong__f_hi)));
});
$c_RTLong.prototype.$less__RTLong__Z = (function(b) {
  var ahi = this.RTLong__f_hi;
  var bhi = $n(b).RTLong__f_hi;
  return ((ahi === bhi) ? (((-2147483648) ^ this.RTLong__f_lo) < ((-2147483648) ^ $n(b).RTLong__f_lo)) : (ahi < bhi));
});
$c_RTLong.prototype.$less$eq__RTLong__Z = (function(b) {
  var ahi = this.RTLong__f_hi;
  var bhi = $n(b).RTLong__f_hi;
  return ((ahi === bhi) ? (((-2147483648) ^ this.RTLong__f_lo) <= ((-2147483648) ^ $n(b).RTLong__f_lo)) : (ahi < bhi));
});
$c_RTLong.prototype.$greater__RTLong__Z = (function(b) {
  var ahi = this.RTLong__f_hi;
  var bhi = $n(b).RTLong__f_hi;
  return ((ahi === bhi) ? (((-2147483648) ^ this.RTLong__f_lo) > ((-2147483648) ^ $n(b).RTLong__f_lo)) : (ahi > bhi));
});
$c_RTLong.prototype.$greater$eq__RTLong__Z = (function(b) {
  var ahi = this.RTLong__f_hi;
  var bhi = $n(b).RTLong__f_hi;
  return ((ahi === bhi) ? (((-2147483648) ^ this.RTLong__f_lo) >= ((-2147483648) ^ $n(b).RTLong__f_lo)) : (ahi > bhi));
});
$c_RTLong.prototype.unary_$tilde__RTLong = (function() {
  return new $c_RTLong((~this.RTLong__f_lo), (~this.RTLong__f_hi));
});
$c_RTLong.prototype.$bar__RTLong__RTLong = (function(b) {
  return new $c_RTLong((this.RTLong__f_lo | $n(b).RTLong__f_lo), (this.RTLong__f_hi | $n(b).RTLong__f_hi));
});
$c_RTLong.prototype.$amp__RTLong__RTLong = (function(b) {
  return new $c_RTLong((this.RTLong__f_lo & $n(b).RTLong__f_lo), (this.RTLong__f_hi & $n(b).RTLong__f_hi));
});
$c_RTLong.prototype.$up__RTLong__RTLong = (function(b) {
  return new $c_RTLong((this.RTLong__f_lo ^ $n(b).RTLong__f_lo), (this.RTLong__f_hi ^ $n(b).RTLong__f_hi));
});
$c_RTLong.prototype.$less$less__I__RTLong = (function(n) {
  var lo = this.RTLong__f_lo;
  return new $c_RTLong((((32 & n) === 0) ? (lo << n) : 0), (((32 & n) === 0) ? (((((lo >>> 1) | 0) >>> ((31 - n) | 0)) | 0) | (this.RTLong__f_hi << n)) : (lo << n)));
});
$c_RTLong.prototype.$greater$greater$greater__I__RTLong = (function(n) {
  var hi = this.RTLong__f_hi;
  return new $c_RTLong((((32 & n) === 0) ? (((this.RTLong__f_lo >>> n) | 0) | ((hi << 1) << ((31 - n) | 0))) : ((hi >>> n) | 0)), (((32 & n) === 0) ? ((hi >>> n) | 0) : 0));
});
$c_RTLong.prototype.$greater$greater__I__RTLong = (function(n) {
  var hi = this.RTLong__f_hi;
  return new $c_RTLong((((32 & n) === 0) ? (((this.RTLong__f_lo >>> n) | 0) | ((hi << 1) << ((31 - n) | 0))) : (hi >> n)), (((32 & n) === 0) ? (hi >> n) : (hi >> 31)));
});
$c_RTLong.prototype.unary_$minus__RTLong = (function() {
  var lo = this.RTLong__f_lo;
  var hi = this.RTLong__f_hi;
  return new $c_RTLong(((-lo) | 0), ((lo !== 0) ? (~hi) : ((-hi) | 0)));
});
$c_RTLong.prototype.$plus__RTLong__RTLong = (function(b) {
  var alo = this.RTLong__f_lo;
  var ahi = this.RTLong__f_hi;
  var bhi = $n(b).RTLong__f_hi;
  var lo = ((alo + $n(b).RTLong__f_lo) | 0);
  return new $c_RTLong(lo, ((((-2147483648) ^ lo) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + bhi) | 0)) | 0) : ((ahi + bhi) | 0)));
});
$c_RTLong.prototype.$minus__RTLong__RTLong = (function(b) {
  var alo = this.RTLong__f_lo;
  var ahi = this.RTLong__f_hi;
  var bhi = $n(b).RTLong__f_hi;
  var lo = ((alo - $n(b).RTLong__f_lo) | 0);
  return new $c_RTLong(lo, ((((-2147483648) ^ lo) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - bhi) | 0)) | 0) : ((ahi - bhi) | 0)));
});
$c_RTLong.prototype.$times__RTLong__RTLong = (function(b) {
  var alo = this.RTLong__f_lo;
  var blo = $n(b).RTLong__f_lo;
  var a0 = (65535 & alo);
  var a1 = ((alo >>> 16) | 0);
  var b0 = (65535 & blo);
  var b1 = ((blo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi = ((((((((Math.imul(alo, $n(b).RTLong__f_hi) + Math.imul(this.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return new $c_RTLong(lo, hi);
});
$c_RTLong.prototype.$div__RTLong__RTLong = (function(b) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(this.RTLong__f_lo, this.RTLong__f_hi, $n(b).RTLong__f_lo, $n(b).RTLong__f_hi);
  return new $c_RTLong(lo, this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn);
});
$c_RTLong.prototype.$percent__RTLong__RTLong = (function(b) {
  var this$1 = $m_RTLong$();
  var lo = this$1.remainderImpl__I__I__I__I__I(this.RTLong__f_lo, this.RTLong__f_hi, $n(b).RTLong__f_lo, $n(b).RTLong__f_hi);
  return new $c_RTLong(lo, this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn);
});
function $as_RTLong(obj) {
  return (((obj instanceof $c_RTLong) || (obj === null)) ? obj : $throwClassCastException(obj, "org.scalajs.linker.runtime.RuntimeLong"));
}
function $isArrayOf_RTLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.RTLong)));
}
function $asArrayOf_RTLong(obj, depth) {
  return (($isArrayOf_RTLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lorg.scalajs.linker.runtime.RuntimeLong;", depth));
}
var $d_RTLong = new $TypeData().initClass($c_RTLong, "org.scalajs.linker.runtime.RuntimeLong", ({
  RTLong: 1
}));
function $p_RTLong$__toUnsignedString__I__I__T($thiz, lo, hi) {
  if ((((-2097152) & hi) === 0)) {
    var this$1 = ((4.294967296E9 * hi) + $uD((lo >>> 0.0)));
    return ("" + this$1);
  } else {
    return $as_T($p_RTLong$__unsignedDivModHelper__I__I__I__I__I__O($thiz, lo, hi, 1000000000, 0, 2));
  }
}
function $p_RTLong$__unsigned_$div__I__I__I__I__I($thiz, alo, ahi, blo, bhi) {
  if ((((-2097152) & ahi) === 0)) {
    if ((((-2097152) & bhi) === 0)) {
      var aDouble = ((4.294967296E9 * ahi) + $uD((alo >>> 0.0)));
      var bDouble = ((4.294967296E9 * bhi) + $uD((blo >>> 0.0)));
      var rDouble = (aDouble / bDouble);
      var x = (rDouble / 4.294967296E9);
      $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = $uI((x | 0.0));
      return $uI((rDouble | 0.0));
    } else {
      $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      return 0;
    }
  } else if (((bhi === 0) && ((blo & (((-1) + blo) | 0)) === 0))) {
    var pow = ((31 - $uI(Math.clz32(blo))) | 0);
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ((ahi >>> pow) | 0);
    return (((alo >>> pow) | 0) | ((ahi << 1) << ((31 - pow) | 0)));
  } else if (((blo === 0) && ((bhi & (((-1) + bhi) | 0)) === 0))) {
    var pow$2 = ((31 - $uI(Math.clz32(bhi))) | 0);
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
    return ((ahi >>> pow$2) | 0);
  } else {
    return $uI($p_RTLong$__unsignedDivModHelper__I__I__I__I__I__O($thiz, alo, ahi, blo, bhi, 0));
  }
}
function $p_RTLong$__unsigned_$percent__I__I__I__I__I($thiz, alo, ahi, blo, bhi) {
  if ((((-2097152) & ahi) === 0)) {
    if ((((-2097152) & bhi) === 0)) {
      var aDouble = ((4.294967296E9 * ahi) + $uD((alo >>> 0.0)));
      var bDouble = ((4.294967296E9 * bhi) + $uD((blo >>> 0.0)));
      var rDouble = (aDouble % bDouble);
      var x = (rDouble / 4.294967296E9);
      $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = $uI((x | 0.0));
      return $uI((rDouble | 0.0));
    } else {
      $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ahi;
      return alo;
    }
  } else if (((bhi === 0) && ((blo & (((-1) + blo) | 0)) === 0))) {
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
    return (alo & (((-1) + blo) | 0));
  } else if (((blo === 0) && ((bhi & (((-1) + bhi) | 0)) === 0))) {
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (ahi & (((-1) + bhi) | 0));
    return alo;
  } else {
    return $uI($p_RTLong$__unsignedDivModHelper__I__I__I__I__I__O($thiz, alo, ahi, blo, bhi, 1));
  }
}
function $p_RTLong$__unsignedDivModHelper__I__I__I__I__I__O($thiz, alo, ahi, blo, bhi, ask) {
  var shift = ((((bhi !== 0) ? $uI(Math.clz32(bhi)) : ((32 + $uI(Math.clz32(blo))) | 0)) - ((ahi !== 0) ? $uI(Math.clz32(ahi)) : ((32 + $uI(Math.clz32(alo))) | 0))) | 0);
  var n = shift;
  var lo = (((32 & n) === 0) ? (blo << n) : 0);
  var hi = (((32 & n) === 0) ? (((((blo >>> 1) | 0) >>> ((31 - n) | 0)) | 0) | (bhi << n)) : (blo << n));
  var bShiftLo = lo;
  var bShiftHi = hi;
  var remLo = alo;
  var remHi = ahi;
  var quotLo = 0;
  var quotHi = 0;
  while (((shift >= 0) && (((-2097152) & remHi) !== 0))) {
    var alo$1 = remLo;
    var ahi$1 = remHi;
    var blo$1 = bShiftLo;
    var bhi$1 = bShiftHi;
    if (((ahi$1 === bhi$1) ? (((-2147483648) ^ alo$1) >= ((-2147483648) ^ blo$1)) : (((-2147483648) ^ ahi$1) >= ((-2147483648) ^ bhi$1)))) {
      var lo$1 = remLo;
      var hi$1 = remHi;
      var lo$2 = bShiftLo;
      var hi$2 = bShiftHi;
      var lo$3 = ((lo$1 - lo$2) | 0);
      var hi$3 = ((((-2147483648) ^ lo$3) > ((-2147483648) ^ lo$1)) ? (((-1) + ((hi$1 - hi$2) | 0)) | 0) : ((hi$1 - hi$2) | 0));
      remLo = lo$3;
      remHi = hi$3;
      if ((shift < 32)) {
        quotLo = (quotLo | (1 << shift));
      } else {
        quotHi = (quotHi | (1 << shift));
      }
    }
    shift = (((-1) + shift) | 0);
    var lo$4 = bShiftLo;
    var hi$4 = bShiftHi;
    var lo$5 = (((lo$4 >>> 1) | 0) | (hi$4 << 31));
    var hi$5 = ((hi$4 >>> 1) | 0);
    bShiftLo = lo$5;
    bShiftHi = hi$5;
  }
  var alo$2 = remLo;
  var ahi$2 = remHi;
  if (((ahi$2 === bhi) ? (((-2147483648) ^ alo$2) >= ((-2147483648) ^ blo)) : (((-2147483648) ^ ahi$2) >= ((-2147483648) ^ bhi)))) {
    var lo$6 = remLo;
    var hi$6 = remHi;
    var remDouble = ((4.294967296E9 * hi$6) + $uD((lo$6 >>> 0.0)));
    var bDouble = ((4.294967296E9 * bhi) + $uD((blo >>> 0.0)));
    if ((ask !== 1)) {
      var x = (remDouble / bDouble);
      var lo$7 = $uI((x | 0.0));
      var x$1 = (x / 4.294967296E9);
      var hi$7 = $uI((x$1 | 0.0));
      var lo$8 = quotLo;
      var hi$8 = quotHi;
      var lo$9 = ((lo$8 + lo$7) | 0);
      var hi$9 = ((((-2147483648) ^ lo$9) < ((-2147483648) ^ lo$8)) ? ((1 + ((hi$8 + hi$7) | 0)) | 0) : ((hi$8 + hi$7) | 0));
      quotLo = lo$9;
      quotHi = hi$9;
    }
    if ((ask !== 0)) {
      var rem_mod_bDouble = (remDouble % bDouble);
      remLo = $uI((rem_mod_bDouble | 0.0));
      var x$2 = (rem_mod_bDouble / 4.294967296E9);
      remHi = $uI((x$2 | 0.0));
    }
  }
  if ((ask === 0)) {
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = quotHi;
    return quotLo;
  } else if ((ask === 1)) {
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = remHi;
    return remLo;
  } else {
    var lo$10 = quotLo;
    var hi$10 = quotHi;
    var quot = ((4.294967296E9 * hi$10) + $uD((lo$10 >>> 0.0)));
    var this$7 = remLo;
    var remStr = ("" + this$7);
    var start = remStr.length;
    return ((("" + quot) + $as_T("000000000".substring(start))) + remStr);
  }
}
/** @constructor */
function $c_RTLong$() {
  this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
}
$c_RTLong$.prototype = new $h_O();
$c_RTLong$.prototype.constructor = $c_RTLong$;
/** @constructor */
function $h_RTLong$() {
}
$h_RTLong$.prototype = $c_RTLong$.prototype;
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T = (function(lo, hi) {
  return ((hi === (lo >> 31)) ? ("" + lo) : ((hi < 0) ? ("-" + $p_RTLong$__toUnsignedString__I__I__T(this, ((-lo) | 0), ((lo !== 0) ? (~hi) : ((-hi) | 0)))) : $p_RTLong$__toUnsignedString__I__I__T(this, lo, hi)));
});
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D = (function(lo, hi) {
  if ((hi < 0)) {
    var x = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    var $x_1 = $uD((x >>> 0.0));
    var x$1 = ((-lo) | 0);
    return (-((4.294967296E9 * $x_1) + $uD((x$1 >>> 0.0))));
  } else {
    return ((4.294967296E9 * hi) + $uD((lo >>> 0.0)));
  }
});
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$toFloat__I__I__F = (function(lo, hi) {
  if ((hi < 0)) {
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    var abs__lo = lo$1;
    var abs__hi = hi$1;
  } else {
    var abs__lo = lo;
    var abs__hi = hi;
  }
  var hi$2 = abs__hi;
  if (((((-2097152) & hi$2) === 0) || ((65535 & abs__lo) === 0))) {
    var compressedAbsLo = abs__lo;
  } else {
    var compressedAbsLo = (32768 | ((-65536) & abs__lo));
  }
  var x = abs__hi;
  var absRes = ((4.294967296E9 * $uD((x >>> 0.0))) + $uD((compressedAbsLo >>> 0.0)));
  return Math.fround(((hi < 0) ? (-absRes) : absRes));
});
$c_RTLong$.prototype.fromInt__I__RTLong = (function(value) {
  return new $c_RTLong(value, (value >> 31));
});
$c_RTLong$.prototype.fromDouble__D__RTLong = (function(value) {
  var lo = this.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  return new $c_RTLong(lo, this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn);
});
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I = (function(value) {
  if ((value < (-9.223372036854776E18))) {
    this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (-2147483648);
    return 0;
  } else if ((value >= 9.223372036854776E18)) {
    this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 2147483647;
    return (-1);
  } else {
    var rawLo = $uI((value | 0.0));
    var x = (value / 4.294967296E9);
    var rawHi = $uI((x | 0.0));
    this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (((value < 0.0) && (rawLo !== 0)) ? (((-1) + rawHi) | 0) : rawHi);
    return rawLo;
  }
});
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I = (function(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo === blo) ? 0 : ((((-2147483648) ^ alo) < ((-2147483648) ^ blo)) ? (-1) : 1)) : ((ahi < bhi) ? (-1) : 1));
});
$c_RTLong$.prototype.divideImpl__I__I__I__I__I = (function(alo, ahi, blo, bhi) {
  if (((blo | bhi) === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero");
  }
  if ((ahi === (alo >> 31))) {
    if ((bhi === (blo >> 31))) {
      if (((alo === (-2147483648)) && (blo === (-1)))) {
        this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
        return (-2147483648);
      } else {
        var lo = $intDiv(alo, blo);
        this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (lo >> 31);
        return lo;
      }
    } else if (((alo === (-2147483648)) && ((blo === (-2147483648)) && (bhi === 0)))) {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (-1);
      return (-1);
    } else {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      return 0;
    }
  } else {
    if ((ahi < 0)) {
      var lo$1 = ((-alo) | 0);
      var hi = ((alo !== 0) ? (~ahi) : ((-ahi) | 0));
      var aAbs__lo = lo$1;
      var aAbs__hi = hi;
    } else {
      var aAbs__lo = alo;
      var aAbs__hi = ahi;
    }
    if ((bhi < 0)) {
      var lo$2 = ((-blo) | 0);
      var hi$1 = ((blo !== 0) ? (~bhi) : ((-bhi) | 0));
      var bAbs__lo = lo$2;
      var bAbs__hi = hi$1;
    } else {
      var bAbs__lo = blo;
      var bAbs__hi = bhi;
    }
    var absRLo = $p_RTLong$__unsigned_$div__I__I__I__I__I(this, aAbs__lo, aAbs__hi, bAbs__lo, bAbs__hi);
    if (((ahi ^ bhi) >= 0)) {
      return absRLo;
    } else {
      var hi$2 = this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ((absRLo !== 0) ? (~hi$2) : ((-hi$2) | 0));
      return ((-absRLo) | 0);
    }
  }
});
$c_RTLong$.prototype.divideUnsignedImpl__I__I__I__I__I = (function(alo, ahi, blo, bhi) {
  if (((blo | bhi) === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero");
  }
  if ((ahi === 0)) {
    if ((bhi === 0)) {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      if ((blo === 0)) {
        return $intDiv(0, 0);
      } else {
        var n = ($uD((alo >>> 0.0)) / $uD((blo >>> 0.0)));
        return $uI((n | 0.0));
      }
    } else {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      return 0;
    }
  } else {
    return $p_RTLong$__unsigned_$div__I__I__I__I__I(this, alo, ahi, blo, bhi);
  }
});
$c_RTLong$.prototype.remainderImpl__I__I__I__I__I = (function(alo, ahi, blo, bhi) {
  if (((blo | bhi) === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero");
  }
  if ((ahi === (alo >> 31))) {
    if ((bhi === (blo >> 31))) {
      if ((blo !== (-1))) {
        var lo = $intMod(alo, blo);
        this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (lo >> 31);
        return lo;
      } else {
        this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
        return 0;
      }
    } else if (((alo === (-2147483648)) && ((blo === (-2147483648)) && (bhi === 0)))) {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      return 0;
    } else {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ahi;
      return alo;
    }
  } else {
    if ((ahi < 0)) {
      var lo$1 = ((-alo) | 0);
      var hi = ((alo !== 0) ? (~ahi) : ((-ahi) | 0));
      var aAbs__lo = lo$1;
      var aAbs__hi = hi;
    } else {
      var aAbs__lo = alo;
      var aAbs__hi = ahi;
    }
    if ((bhi < 0)) {
      var lo$2 = ((-blo) | 0);
      var hi$1 = ((blo !== 0) ? (~bhi) : ((-bhi) | 0));
      var bAbs__lo = lo$2;
      var bAbs__hi = hi$1;
    } else {
      var bAbs__lo = blo;
      var bAbs__hi = bhi;
    }
    var absRLo = $p_RTLong$__unsigned_$percent__I__I__I__I__I(this, aAbs__lo, aAbs__hi, bAbs__lo, bAbs__hi);
    if ((ahi < 0)) {
      var hi$2 = this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ((absRLo !== 0) ? (~hi$2) : ((-hi$2) | 0));
      return ((-absRLo) | 0);
    } else {
      return absRLo;
    }
  }
});
var $d_RTLong$ = new $TypeData().initClass($c_RTLong$, "org.scalajs.linker.runtime.RuntimeLong$", ({
  RTLong$: 1
}));
var $n_RTLong$;
function $m_RTLong$() {
  if ((!$n_RTLong$)) {
    $n_RTLong$ = new $c_RTLong$();
  }
  return $n_RTLong$;
}
/** @constructor */
function $c_s_Array$EmptyArrays$() {
  this.s_Array$EmptyArrays$__f_emptyIntArray = null;
  this.s_Array$EmptyArrays$__f_emptyObjectArray = null;
  $n_s_Array$EmptyArrays$ = this;
  this.s_Array$EmptyArrays$__f_emptyIntArray = new $ac_I(0);
  this.s_Array$EmptyArrays$__f_emptyObjectArray = new $ac_O(0);
}
$c_s_Array$EmptyArrays$.prototype = new $h_O();
$c_s_Array$EmptyArrays$.prototype.constructor = $c_s_Array$EmptyArrays$;
/** @constructor */
function $h_s_Array$EmptyArrays$() {
}
$h_s_Array$EmptyArrays$.prototype = $c_s_Array$EmptyArrays$.prototype;
var $d_s_Array$EmptyArrays$ = new $TypeData().initClass($c_s_Array$EmptyArrays$, "scala.Array$EmptyArrays$", ({
  s_Array$EmptyArrays$: 1
}));
var $n_s_Array$EmptyArrays$;
function $m_s_Array$EmptyArrays$() {
  if ((!$n_s_Array$EmptyArrays$)) {
    $n_s_Array$EmptyArrays$ = new $c_s_Array$EmptyArrays$();
  }
  return $n_s_Array$EmptyArrays$;
}
function $is_F0(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F0)));
}
function $as_F0(obj) {
  return (($is_F0(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function0"));
}
function $isArrayOf_F0(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F0)));
}
function $asArrayOf_F0(obj, depth) {
  return (($isArrayOf_F0(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function0;", depth));
}
function $f_F1__compose__F1__F1($thiz, g) {
  return new $c_sjsr_AnonFunction1(((x$2) => $thiz.apply__O__O($n(g).apply__O__O(x$2))));
}
function $f_F1__andThen__F1__F1($thiz, g) {
  return new $c_sjsr_AnonFunction1(((x$2) => $n(g).apply__O__O($thiz.apply__O__O(x$2))));
}
function $is_F1(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F1)));
}
function $as_F1(obj) {
  return (($is_F1(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function1"));
}
function $isArrayOf_F1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F1)));
}
function $asArrayOf_F1(obj, depth) {
  return (($isArrayOf_F1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function1;", depth));
}
var $d_F1 = new $TypeData().initClass(1, "scala.Function1", ({
  F1: 1
}));
function $f_F2__tupled__F1($thiz) {
  return new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var x1$2 = $n(x0$1)._1__O();
      var x2 = $n(x0$1)._2__O();
      return $thiz.apply__O__O__O(x1$2, x2);
    } else {
      throw new $c_s_MatchError(x0$1);
    }
  }));
}
function $is_F2(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F2)));
}
function $as_F2(obj) {
  return (($is_F2(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function2"));
}
function $isArrayOf_F2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F2)));
}
function $asArrayOf_F2(obj, depth) {
  return (($isArrayOf_F2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function2;", depth));
}
/** @constructor */
function $c_s_LowPriorityImplicits2() {
}
$c_s_LowPriorityImplicits2.prototype = new $h_O();
$c_s_LowPriorityImplicits2.prototype.constructor = $c_s_LowPriorityImplicits2;
/** @constructor */
function $h_s_LowPriorityImplicits2() {
}
$h_s_LowPriorityImplicits2.prototype = $c_s_LowPriorityImplicits2.prototype;
/** @constructor */
function $c_s_PartialFunction$() {
  this.s_PartialFunction$__f_fallback_fn = null;
  this.s_PartialFunction$__f_scala$PartialFunction$$constFalse = null;
  this.s_PartialFunction$__f_empty_pf = null;
  $n_s_PartialFunction$ = this;
  this.s_PartialFunction$__f_fallback_fn = new $c_sjsr_AnonFunction1(((x$2$2) => $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn));
  this.s_PartialFunction$__f_scala$PartialFunction$$constFalse = new $c_sjsr_AnonFunction1(((x$3$2) => false));
  this.s_PartialFunction$__f_empty_pf = new $c_s_PartialFunction$$anon$1();
}
$c_s_PartialFunction$.prototype = new $h_O();
$c_s_PartialFunction$.prototype.constructor = $c_s_PartialFunction$;
/** @constructor */
function $h_s_PartialFunction$() {
}
$h_s_PartialFunction$.prototype = $c_s_PartialFunction$.prototype;
$c_s_PartialFunction$.prototype.scala$PartialFunction$$fallbackOccurred__O__Z = (function(x) {
  return (this.s_PartialFunction$__f_fallback_fn === x);
});
var $d_s_PartialFunction$ = new $TypeData().initClass($c_s_PartialFunction$, "scala.PartialFunction$", ({
  s_PartialFunction$: 1
}));
var $n_s_PartialFunction$;
function $m_s_PartialFunction$() {
  if ((!$n_s_PartialFunction$)) {
    $n_s_PartialFunction$ = new $c_s_PartialFunction$();
  }
  return $n_s_PartialFunction$;
}
function $f_s_Proxy__toString__T($thiz) {
  return ("" + $thiz.self__O());
}
function $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O($thiz, len$1, \u03b4this$2, ord$1) {
  if ((len$1 < 300)) {
    var a = $m_sr_ScalaRunTime$().array_clone__O__O(\u03b4this$2);
    var this$1 = $m_s_util_Sorting$();
    this$1.stableSort__O__I__I__s_math_Ordering__V(a, 0, $m_jl_reflect_Array$().getLength__O__I(a), ord$1);
    return a;
  } else {
    var this$3 = $m_s_Array$();
    var this$4 = $n(\u03b4this$2);
    if ($d_O.getClassOf().isAssignableFrom__jl_Class__Z($n($objectGetClass(this$4)).getComponentType__jl_Class())) {
      if ($d_O.getClassOf().isPrimitive__Z()) {
        var $x_1 = this$3.copyOf__O__I__O(\u03b4this$2, len$1);
      } else {
        var original = $asArrayOf_O(\u03b4this$2, 1);
        var $x_1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original, len$1, $d_O.getArrayOf().getClassOf());
      }
    } else {
      var dest = new $ac_O(len$1);
      $m_s_Array$().copy__O__I__O__I__I__V(\u03b4this$2, 0, dest, 0, $m_jl_reflect_Array$().getLength__O__I(\u03b4this$2));
      var $x_1 = dest;
    }
    var a$2 = $asArrayOf_O($x_1, 1);
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(a$2, ord$1);
    var $x_3 = $m_s_Array$();
    var $x_2 = $m_s_reflect_ClassTag$();
    var this$8 = $n(\u03b4this$2);
    return $n($x_3).copyAs__O__I__s_reflect_ClassTag__O(a$2, len$1, $n($x_2).apply__jl_Class__s_reflect_ClassTag($n($objectGetClass(this$8)).getComponentType__jl_Class()));
  }
}
/** @constructor */
function $c_sc_ArrayOps$() {
  this.sc_ArrayOps$__f_fallback = null;
  $n_sc_ArrayOps$ = this;
  this.sc_ArrayOps$__f_fallback = new $c_sjsr_AnonFunction1(((x$1$2) => $m_sc_ArrayOps$().sc_ArrayOps$__f_fallback));
}
$c_sc_ArrayOps$.prototype = new $h_O();
$c_sc_ArrayOps$.prototype.constructor = $c_sc_ArrayOps$;
/** @constructor */
function $h_sc_ArrayOps$() {
}
$h_sc_ArrayOps$.prototype = $c_sc_ArrayOps$.prototype;
$c_sc_ArrayOps$.prototype.head$extension__O__O = (function(this$) {
  if (($m_jl_reflect_Array$().getLength__O__I(this$) !== 0)) {
    return $m_sr_ScalaRunTime$().array_apply__O__I__O(this$, 0);
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty array");
  }
});
$c_sc_ArrayOps$.prototype.last$extension__O__O = (function(this$) {
  if (($m_jl_reflect_Array$().getLength__O__I(this$) !== 0)) {
    return $m_sr_ScalaRunTime$().array_apply__O__I__O(this$, (((-1) + $m_jl_reflect_Array$().getLength__O__I(this$)) | 0));
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last of empty array");
  }
});
$c_sc_ArrayOps$.prototype.headOption$extension__O__s_Option = (function(this$) {
  return (($m_jl_reflect_Array$().getLength__O__I(this$) === 0) ? $m_s_None$() : new $c_s_Some($m_sc_ArrayOps$().head$extension__O__O(this$)));
});
$c_sc_ArrayOps$.prototype.slice$extension__O__I__I__O = (function(this$, from, until) {
  var lo = ((from > 0) ? from : 0);
  var b = $m_jl_reflect_Array$().getLength__O__I(this$);
  var hi = ((until < b) ? until : b);
  if ((hi > lo)) {
    if ((this$ instanceof $ac_O)) {
      var x2 = $asArrayOf_O(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AO__I__I__AO(x2, lo, hi);
    } else if ((this$ instanceof $ac_I)) {
      var x3 = $asArrayOf_I(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AI__I__I__AI(x3, lo, hi);
    } else if ((this$ instanceof $ac_D)) {
      var x4 = $asArrayOf_D(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AD__I__I__AD(x4, lo, hi);
    } else if ((this$ instanceof $ac_J)) {
      var x5 = $asArrayOf_J(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AJ__I__I__AJ(x5, lo, hi);
    } else if ((this$ instanceof $ac_F)) {
      var x6 = $asArrayOf_F(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AF__I__I__AF(x6, lo, hi);
    } else if ((this$ instanceof $ac_C)) {
      var x7 = $asArrayOf_C(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AC__I__I__AC(x7, lo, hi);
    } else if ((this$ instanceof $ac_B)) {
      var x8 = $asArrayOf_B(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AB__I__I__AB(x8, lo, hi);
    } else if ((this$ instanceof $ac_S)) {
      var x9 = $asArrayOf_S(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AS__I__I__AS(x9, lo, hi);
    } else if ((this$ instanceof $ac_Z)) {
      var x10 = $asArrayOf_Z(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AZ__I__I__AZ(x10, lo, hi);
    } else {
      throw new $c_s_MatchError(this$);
    }
  } else {
    var $x_1 = $m_s_reflect_ClassTag$();
    var this$5 = $n(this$);
    return $n($n($x_1).apply__jl_Class__s_reflect_ClassTag($n($objectGetClass(this$5)).getComponentType__jl_Class())).newArray__I__O(0);
  }
});
$c_sc_ArrayOps$.prototype.tail$extension__O__O = (function(this$) {
  if (($m_jl_reflect_Array$().getLength__O__I(this$) === 0)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty array");
  } else {
    return $m_sc_ArrayOps$().slice$extension__O__I__I__O(this$, 1, $m_jl_reflect_Array$().getLength__O__I(this$));
  }
});
$c_sc_ArrayOps$.prototype.drop$extension__O__I__O = (function(this$, n) {
  return $m_sc_ArrayOps$().slice$extension__O__I__I__O(this$, n, $m_jl_reflect_Array$().getLength__O__I(this$));
});
$c_sc_ArrayOps$.prototype.dropRight$extension__O__I__O = (function(this$, n) {
  var n$1 = (($m_jl_reflect_Array$().getLength__O__I(this$) - ((n > 0) ? n : 0)) | 0);
  return $m_sc_ArrayOps$().slice$extension__O__I__I__O(this$, 0, n$1);
});
$c_sc_ArrayOps$.prototype.sorted$extension__O__s_math_Ordering__O = (function(this$, ord) {
  var len = $m_jl_reflect_Array$().getLength__O__I(this$);
  if ((len <= 1)) {
    return $m_sr_ScalaRunTime$().array_clone__O__O(this$);
  } else if ((this$ instanceof $ac_O)) {
    var x2 = $asArrayOf_O(this$, 1);
    var a = $m_ju_Arrays$().copyOf__AO__I__AO(x2, len);
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(a, ord);
    return a;
  } else if ((this$ instanceof $ac_I)) {
    var x3 = $asArrayOf_I(this$, 1);
    if ((ord === $m_s_math_Ordering$Int$())) {
      var a$2 = $m_ju_Arrays$().copyOf__AI__I__AI(x3, len);
      $m_ju_Arrays$().sort__AI__V(a$2);
      return a$2;
    } else {
      return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord);
    }
  } else if ((this$ instanceof $ac_J)) {
    var x4 = $asArrayOf_J(this$, 1);
    if ((ord === $m_s_math_Ordering$Long$())) {
      var a$3 = $m_ju_Arrays$().copyOf__AJ__I__AJ(x4, len);
      $m_ju_Arrays$().sort__AJ__V(a$3);
      return a$3;
    } else {
      return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord);
    }
  } else if ((this$ instanceof $ac_C)) {
    var x5 = $asArrayOf_C(this$, 1);
    if ((ord === $m_s_math_Ordering$Char$())) {
      var a$4 = $m_ju_Arrays$().copyOf__AC__I__AC(x5, len);
      $m_ju_Arrays$().sort__AC__V(a$4);
      return a$4;
    } else {
      return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord);
    }
  } else if ((this$ instanceof $ac_B)) {
    var x6 = $asArrayOf_B(this$, 1);
    if ((ord === $m_s_math_Ordering$Byte$())) {
      var a$5 = $m_ju_Arrays$().copyOf__AB__I__AB(x6, len);
      $m_ju_Arrays$().sort__AB__V(a$5);
      return a$5;
    } else {
      return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord);
    }
  } else if ((this$ instanceof $ac_S)) {
    var x7 = $asArrayOf_S(this$, 1);
    if ((ord === $m_s_math_Ordering$Short$())) {
      var a$6 = $m_ju_Arrays$().copyOf__AS__I__AS(x7, len);
      $m_ju_Arrays$().sort__AS__V(a$6);
      return a$6;
    } else {
      return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord);
    }
  } else if ((this$ instanceof $ac_Z)) {
    var x8 = $asArrayOf_Z(this$, 1);
    if ((ord === $m_s_math_Ordering$Boolean$())) {
      var a$7 = $m_ju_Arrays$().copyOf__AZ__I__AZ(x8, len);
      var this$2 = $m_s_util_Sorting$();
      var evidence$3 = $m_s_math_Ordering$Boolean$();
      this$2.stableSort__O__I__I__s_math_Ordering__V(a$7, 0, $n(a$7).u.length, evidence$3);
      return a$7;
    } else {
      return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord);
    }
  } else {
    return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord);
  }
});
$c_sc_ArrayOps$.prototype.zipWithIndex$extension__O__AT2 = (function(this$) {
  var b = new ($d_T2.getArrayOf().constr)($m_jl_reflect_Array$().getLength__O__I(this$));
  var i = 0;
  while ((i < $m_jl_reflect_Array$().getLength__O__I(this$))) {
    $n(b).set(i, new $c_T2($m_sr_ScalaRunTime$().array_apply__O__I__O(this$, i), i));
    i = ((1 + i) | 0);
  }
  return b;
});
$c_sc_ArrayOps$.prototype.toIndexedSeq$extension__O__sci_IndexedSeq = (function(this$) {
  return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq($m_s_Array$().copyOf__O__I__O(this$, $m_jl_reflect_Array$().getLength__O__I(this$)));
});
var $d_sc_ArrayOps$ = new $TypeData().initClass($c_sc_ArrayOps$, "scala.collection.ArrayOps$", ({
  sc_ArrayOps$: 1
}));
var $n_sc_ArrayOps$;
function $m_sc_ArrayOps$() {
  if ((!$n_sc_ArrayOps$)) {
    $n_sc_ArrayOps$ = new $c_sc_ArrayOps$();
  }
  return $n_sc_ArrayOps$;
}
/** @constructor */
function $c_sc_BitSetOps$() {
}
$c_sc_BitSetOps$.prototype = new $h_O();
$c_sc_BitSetOps$.prototype.constructor = $c_sc_BitSetOps$;
/** @constructor */
function $h_sc_BitSetOps$() {
}
$h_sc_BitSetOps$.prototype = $c_sc_BitSetOps$.prototype;
$c_sc_BitSetOps$.prototype.updateArray__AJ__I__J__AJ = (function(elems, idx, w) {
  var len = $n(elems).u.length;
  while (true) {
    if ((len > 0)) {
      var this$1 = $n(elems).get((((-1) + len) | 0));
      if (((this$1.RTLong__f_lo === 0) && (this$1.RTLong__f_hi === 0))) {
        var $x_1 = true;
      } else {
        var $x_1 = (((w.RTLong__f_lo === 0) && (w.RTLong__f_hi === 0)) && (idx === (((-1) + len) | 0)));
      }
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      len = (((-1) + len) | 0);
    } else {
      break;
    }
  }
  var newlen = len;
  if (((idx >= newlen) && (!((w.RTLong__f_lo === 0) && (w.RTLong__f_hi === 0))))) {
    newlen = ((1 + idx) | 0);
  }
  var newelems = new $ac_J(newlen);
  $m_s_Array$().copy__O__I__O__I__I__V(elems, 0, newelems, 0, len);
  if ((idx < newlen)) {
    $n(newelems).set(idx, w);
  } else {
    $m_s_Predef$().assert__Z__V(((w.RTLong__f_lo === 0) && (w.RTLong__f_hi === 0)));
  }
  return newelems;
});
$c_sc_BitSetOps$.prototype.computeWordForFilter__F1__Z__J__I__J = (function(pred, isFlipped, oldWord, wordIndex) {
  if (((oldWord.RTLong__f_lo === 0) && (oldWord.RTLong__f_hi === 0))) {
    return $L0;
  } else {
    var lo = oldWord.RTLong__f_lo;
    var hi = oldWord.RTLong__f_hi;
    var w__lo = lo;
    var w__hi = hi;
    var l__lo = w__lo;
    var l__hi = w__hi;
    var lo$1 = l__lo;
    if ((lo$1 !== 0)) {
      if ((lo$1 === 0)) {
        var trailingZeroes = 32;
      } else {
        var i = (lo$1 & ((-lo$1) | 0));
        var trailingZeroes = ((31 - $uI(Math.clz32(i))) | 0);
      }
    } else {
      var hi$1 = l__hi;
      if ((hi$1 === 0)) {
        var $x_1 = 32;
      } else {
        var i$1 = (hi$1 & ((-hi$1) | 0));
        var $x_1 = ((31 - $uI(Math.clz32(i$1))) | 0);
      }
      var trailingZeroes = ((32 + $x_1) | 0);
    }
    var lo$2 = (((32 & trailingZeroes) === 0) ? (1 << trailingZeroes) : 0);
    var hi$2 = (((32 & trailingZeroes) === 0) ? 0 : (1 << trailingZeroes));
    var jmask__lo = lo$2;
    var jmask__hi = hi$2;
    var j = (((wordIndex << 6) + trailingZeroes) | 0);
    var l$1__lo = w__lo;
    var l$1__hi = w__hi;
    var hi$3 = l$1__hi;
    if ((hi$3 !== 0)) {
      var $x_2 = $uI(Math.clz32(hi$3));
    } else {
      var i$2 = l$1__lo;
      var $x_2 = ((32 + $uI(Math.clz32(i$2))) | 0);
    }
    var maxJ = (((((1 + wordIndex) | 0) << 6) - $x_2) | 0);
    while ((j !== maxJ)) {
      var this$7__lo = w__lo;
      var this$7__hi = w__hi;
      var b__lo = jmask__lo;
      var b__hi = jmask__hi;
      var lo$3 = (this$7__lo & b__lo);
      var hi$4 = (this$7__hi & b__hi);
      if ((!((lo$3 === 0) && (hi$4 === 0)))) {
        if (($n(pred).apply$mcZI$sp__I__Z(j) === isFlipped)) {
          var this$8__lo = w__lo;
          var this$8__hi = w__hi;
          var b$1__lo = jmask__lo;
          var b$1__hi = jmask__hi;
          var lo$4 = (~b$1__lo);
          var hi$5 = (~b$1__hi);
          var lo$5 = (this$8__lo & lo$4);
          var hi$6 = (this$8__hi & hi$5);
          var $x_3__lo = lo$5;
          var $x_3__hi = hi$6;
          w__lo = $x_3__lo;
          w__hi = $x_3__hi;
        }
      }
      var this$9__lo = jmask__lo;
      var this$9__hi = jmask__hi;
      var lo$6 = this$9__lo;
      var lo$7 = (lo$6 << 1);
      var hi$7 = (((lo$6 >>> 31) | 0) | (this$9__hi << 1));
      var $x_4__lo = lo$7;
      var $x_4__hi = hi$7;
      jmask__lo = $x_4__lo;
      jmask__hi = $x_4__hi;
      j = ((1 + j) | 0);
    }
    return new $c_RTLong(w__lo, w__hi);
  }
});
var $d_sc_BitSetOps$ = new $TypeData().initClass($c_sc_BitSetOps$, "scala.collection.BitSetOps$", ({
  sc_BitSetOps$: 1
}));
var $n_sc_BitSetOps$;
function $m_sc_BitSetOps$() {
  if ((!$n_sc_BitSetOps$)) {
    $n_sc_BitSetOps$ = new $c_sc_BitSetOps$();
  }
  return $n_sc_BitSetOps$;
}
/** @constructor */
function $c_sc_Hashing$() {
}
$c_sc_Hashing$.prototype = new $h_O();
$c_sc_Hashing$.prototype.constructor = $c_sc_Hashing$;
/** @constructor */
function $h_sc_Hashing$() {
}
$h_sc_Hashing$.prototype = $c_sc_Hashing$.prototype;
$c_sc_Hashing$.prototype.improve__I__I = (function(hcode) {
  var h = ((hcode + (~(hcode << 9))) | 0);
  h = (h ^ ((h >>> 14) | 0));
  h = ((h + (h << 4)) | 0);
  return (h ^ ((h >>> 10) | 0));
});
var $d_sc_Hashing$ = new $TypeData().initClass($c_sc_Hashing$, "scala.collection.Hashing$", ({
  sc_Hashing$: 1
}));
var $n_sc_Hashing$;
function $m_sc_Hashing$() {
  if ((!$n_sc_Hashing$)) {
    $n_sc_Hashing$ = new $c_sc_Hashing$();
  }
  return $n_sc_Hashing$;
}
function $is_sc_IterableOnce(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IterableOnce)));
}
function $as_sc_IterableOnce(obj) {
  return (($is_sc_IterableOnce(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IterableOnce"));
}
function $isArrayOf_sc_IterableOnce(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IterableOnce)));
}
function $asArrayOf_sc_IterableOnce(obj, depth) {
  return (($isArrayOf_sc_IterableOnce(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IterableOnce;", depth));
}
/** @constructor */
function $c_sc_IterableOnceExtensionMethods$() {
}
$c_sc_IterableOnceExtensionMethods$.prototype = new $h_O();
$c_sc_IterableOnceExtensionMethods$.prototype.constructor = $c_sc_IterableOnceExtensionMethods$;
/** @constructor */
function $h_sc_IterableOnceExtensionMethods$() {
}
$h_sc_IterableOnceExtensionMethods$.prototype = $c_sc_IterableOnceExtensionMethods$.prototype;
$c_sc_IterableOnceExtensionMethods$.prototype.isEmpty$extension__sc_IterableOnce__Z = (function(this$) {
  if ($is_sc_Iterable(this$)) {
    var x2 = $as_sc_Iterable(this$);
    return $n(x2).isEmpty__Z();
  } else {
    var this$1 = $n($n(this$).iterator__sc_Iterator());
    return (!this$1.hasNext__Z());
  }
});
var $d_sc_IterableOnceExtensionMethods$ = new $TypeData().initClass($c_sc_IterableOnceExtensionMethods$, "scala.collection.IterableOnceExtensionMethods$", ({
  sc_IterableOnceExtensionMethods$: 1
}));
var $n_sc_IterableOnceExtensionMethods$;
function $m_sc_IterableOnceExtensionMethods$() {
  if ((!$n_sc_IterableOnceExtensionMethods$)) {
    $n_sc_IterableOnceExtensionMethods$ = new $c_sc_IterableOnceExtensionMethods$();
  }
  return $n_sc_IterableOnceExtensionMethods$;
}
function $f_sc_IterableOnceOps__foreach__F1__V($thiz, f) {
  var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    $n(f).apply__O__O($n(it).next__O());
  }
}
function $f_sc_IterableOnceOps__forall__F1__Z($thiz, p) {
  var res = true;
  var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
  while ((res && $n(it).hasNext__Z())) {
    res = $uZ($n(p).apply__O__O($n(it).next__O()));
  }
  return res;
}
function $f_sc_IterableOnceOps__exists__F1__Z($thiz, p) {
  var res = false;
  var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
  while (((!res) && $n(it).hasNext__Z())) {
    res = $uZ($n(p).apply__O__O($n(it).next__O()));
  }
  return res;
}
function $f_sc_IterableOnceOps__find__F1__s_Option($thiz, p) {
  var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var a = $n(it).next__O();
    if ($uZ($n(p).apply__O__O(a))) {
      return new $c_s_Some(a);
    }
  }
  return $m_s_None$();
}
function $f_sc_IterableOnceOps__foldLeft__O__F2__O($thiz, z, op) {
  if ($is_sc_IndexedSeq($thiz)) {
    var x2 = $as_sc_IndexedSeq($thiz);
    return $p_sc_IterableOnceOps__loop$1__I__I__O__F2__sc_IndexedSeq__O($thiz, 0, $n(x2).length__I(), z, op, x2);
  } else {
    var result = z;
    var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      result = $n(op).apply__O__O__O(result, $n(it).next__O());
    }
    return result;
  }
}
function $f_sc_IterableOnceOps__reduceLeft__F2__O($thiz, op) {
  if ($is_sc_IndexedSeq($thiz)) {
    var x2 = $as_sc_IndexedSeq($thiz);
    if (($n(x2).length__I() > 0)) {
      var z = $n(x2).apply__I__O(0);
      return $p_sc_IterableOnceOps__loop$1__I__I__O__F2__sc_IndexedSeq__O($thiz, 1, $n(x2).length__I(), z, op, x2);
    }
  }
  if (($n($as_sc_IterableOnce($thiz)).knownSize__I() === 0)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
  }
  var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
  if ($n(it).hasNext__Z()) {
    var acc = $n(it).next__O();
    while ($n(it).hasNext__Z()) {
      acc = $n(op).apply__O__O__O(acc, $n(it).next__O());
    }
    return acc;
  } else {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
  }
}
function $f_sc_IterableOnceOps__reduceLeftOption__F2__s_Option($thiz, op) {
  var x1 = $n($as_sc_IterableOnce($thiz)).knownSize__I();
  switch (x1) {
    case (-1): {
      return $p_sc_IterableOnceOps__reduceLeftOptionIterator__F2__s_Option($thiz, op);
      break;
    }
    case 0: {
      return $m_s_None$();
      break;
    }
    default: {
      return new $c_s_Some($thiz.reduceLeft__F2__O(op));
    }
  }
}
function $p_sc_IterableOnceOps__reduceLeftOptionIterator__F2__s_Option($thiz, op) {
  return $p_sc_IterableOnceOps__reduceOptionIterator__sc_Iterator__F2__s_Option($thiz, $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator(), op);
}
function $p_sc_IterableOnceOps__reduceOptionIterator__sc_Iterator__F2__s_Option($thiz, it, op) {
  if ($n(it).hasNext__Z()) {
    var acc = $n(it).next__O();
    while ($n(it).hasNext__Z()) {
      acc = $n(op).apply__O__O__O(acc, $n(it).next__O());
    }
    return new $c_s_Some(acc);
  } else {
    return $m_s_None$();
  }
}
function $f_sc_IterableOnceOps__isEmpty__Z($thiz) {
  var x1 = $n($as_sc_IterableOnce($thiz)).knownSize__I();
  switch (x1) {
    case (-1): {
      return (!$n($n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator()).hasNext__Z());
      break;
    }
    case 0: {
      return true;
      break;
    }
    default: {
      return false;
    }
  }
}
function $f_sc_IterableOnceOps__size__I($thiz) {
  if (($n($as_sc_IterableOnce($thiz)).knownSize__I() >= 0)) {
    return $n($as_sc_IterableOnce($thiz)).knownSize__I();
  } else {
    var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
    var len = 0;
    while ($n(it).hasNext__Z()) {
      len = ((1 + len) | 0);
      $n(it).next__O();
    }
    return len;
  }
}
function $f_sc_IterableOnceOps__copyToArray__O__I__I__I($thiz, xs, start, len) {
  var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
  var i = start;
  var y = (($m_jl_reflect_Array$().getLength__O__I(xs) - start) | 0);
  var end = ((start + ((len < y) ? len : y)) | 0);
  while (((i < end) && $n(it).hasNext__Z())) {
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(xs, i, $n(it).next__O());
    i = ((1 + i) | 0);
  }
  return ((i - start) | 0);
}
function $f_sc_IterableOnceOps__max__s_math_Ordering__O($thiz, ord) {
  var x1 = $n($as_sc_IterableOnce($thiz)).knownSize__I();
  switch (x1) {
    case (-1): {
      var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
      if ($n(it).hasNext__Z()) {
        var acc = $n(it).next__O();
        while ($n(it).hasNext__Z()) {
          var arg1 = acc;
          var arg2 = $n(it).next__O();
          acc = $n(ord).max__O__O__O(arg1, arg2);
        }
        return acc;
      } else {
        throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.max");
      }
      break;
    }
    case 0: {
      throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.max");
      break;
    }
    default: {
      return $thiz.reduceLeft__F2__O(new $c_sjsr_AnonFunction2(((x$3$2, y$3$2) => $n(ord).max__O__O__O(x$3$2, y$3$2))));
    }
  }
}
function $f_sc_IterableOnceOps__maxBy__F1__s_math_Ordering__O($thiz, f, ord) {
  var x1 = $n($as_sc_IterableOnce($thiz)).knownSize__I();
  if ((x1 === 0)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.maxBy");
  } else {
    return $n($as_sc_IterableOnceOps$Maximized($thiz.foldLeft__O__F2__O(new $c_sc_IterableOnceOps$Maximized($thiz, "maxBy", f, new $c_sjsr_AnonFunction2(((x$2, y$2) => $n(ord).gt__O__O__Z(x$2, y$2)))), new $c_sjsr_AnonFunction2(((m$2, a$2) => {
      var m = $as_sc_IterableOnceOps$Maximized(m$2);
      return $n(m).apply__sc_IterableOnceOps$Maximized__O__sc_IterableOnceOps$Maximized(m, a$2);
    }))))).result__O();
  }
}
function $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option($thiz, pf) {
  var sentinel = new $c_sc_IterableOnceOps$$anon$1($thiz);
  var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var x = $n(pf).applyOrElse__O__F1__O($n(it).next__O(), sentinel);
    if ((x !== sentinel)) {
      return new $c_s_Some(x);
    }
  }
  return $m_s_None$();
}
function $f_sc_IterableOnceOps__mkString__T__T__T__T($thiz, start, sep, end) {
  if (($n($as_sc_IterableOnce($thiz)).knownSize__I() === 0)) {
    return (("" + start) + end);
  } else {
    var this$1 = $n($thiz.addString__scm_StringBuilder__T__T__T__scm_StringBuilder($ct_scm_StringBuilder__(new $c_scm_StringBuilder()), start, sep, end));
    return $n(this$1.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content;
  }
}
function $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder($thiz, b, start, sep, end) {
  var jsb = $n(b).scm_StringBuilder__f_underlying;
  var this$1 = $n(start);
  if ((this$1.length !== 0)) {
    var this$2 = $n(jsb);
    this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start);
  }
  var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
  if ($n(it).hasNext__Z()) {
    var this$3 = $n(jsb);
    var obj = $n(it).next__O();
    this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj);
    while ($n(it).hasNext__Z()) {
      var this$4 = $n(jsb);
      this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
      var this$5 = $n(jsb);
      var obj$1 = $n(it).next__O();
      this$5.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$5.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$1);
    }
  }
  var this$6 = $n(end);
  if ((this$6.length !== 0)) {
    var this$7 = $n(jsb);
    this$7.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$7.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end);
  }
  return b;
}
function $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O($thiz, evidence$2) {
  if (($n($as_sc_IterableOnce($thiz)).knownSize__I() >= 0)) {
    var destination = $n(evidence$2).newArray__I__O($n($as_sc_IterableOnce($thiz)).knownSize__I());
    $thiz.copyToArray__O__I__I__I(destination, 0, 2147483647);
    return destination;
  } else {
    var capacity = 0;
    var jsElems = null;
    var elementClass = $n(evidence$2).runtimeClass__jl_Class();
    capacity = 0;
    var isCharArrayBuilder = (elementClass === $d_C.getClassOf());
    jsElems = [];
    var xs = $as_sc_IterableOnce($thiz);
    var it = $n(xs).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var elem = $n(it).next__O();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $n(elementClass).jl_Class__f_data.zero : elem));
      jsElems.push(unboxedElem);
    }
    var elemRuntimeClass = ((elementClass === $d_V.getClassOf()) ? $d_jl_Void.getClassOf() : (((elementClass === $d_sr_Null$.getClassOf()) || (elementClass === $d_sr_Nothing$.getClassOf())) ? $d_O.getClassOf() : elementClass));
    return $n(elemRuntimeClass).jl_Class__f_data.getArrayOf().wrapArray(jsElems);
  }
}
function $f_sc_IterableOnceOps__reversed__sc_Iterable($thiz) {
  var xs = $m_sci_Nil$();
  var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var rassoc$1 = $n(it).next__O();
    var this$1 = $n(xs);
    xs = new $c_sci_$colon$colon(rassoc$1, this$1);
  }
  return xs;
}
function $p_sc_IterableOnceOps__loop$1__I__I__O__F2__sc_IndexedSeq__O($thiz, at, end, acc, op$1, seq$1) {
  while (true) {
    if ((at === end)) {
      return acc;
    } else {
      var temp$at = ((1 + at) | 0);
      var temp$acc = $n(op$1).apply__O__O__O(acc, $n(seq$1).apply__I__O(at));
      at = temp$at;
      acc = temp$acc;
    }
  }
}
function $is_sc_IterableOnceOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IterableOnceOps)));
}
function $as_sc_IterableOnceOps(obj) {
  return (($is_sc_IterableOnceOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IterableOnceOps"));
}
function $isArrayOf_sc_IterableOnceOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IterableOnceOps)));
}
function $asArrayOf_sc_IterableOnceOps(obj, depth) {
  return (($isArrayOf_sc_IterableOnceOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IterableOnceOps;", depth));
}
/** @constructor */
function $c_sc_Iterator$ConcatIteratorCell(head, tail) {
  this.sc_Iterator$ConcatIteratorCell__f_head = null;
  this.sc_Iterator$ConcatIteratorCell__f_tail = null;
  this.sc_Iterator$ConcatIteratorCell__f_head = head;
  this.sc_Iterator$ConcatIteratorCell__f_tail = tail;
}
$c_sc_Iterator$ConcatIteratorCell.prototype = new $h_O();
$c_sc_Iterator$ConcatIteratorCell.prototype.constructor = $c_sc_Iterator$ConcatIteratorCell;
/** @constructor */
function $h_sc_Iterator$ConcatIteratorCell() {
}
$h_sc_Iterator$ConcatIteratorCell.prototype = $c_sc_Iterator$ConcatIteratorCell.prototype;
$c_sc_Iterator$ConcatIteratorCell.prototype.headIterator__sc_Iterator = (function() {
  return $n($as_sc_IterableOnce($n(this.sc_Iterator$ConcatIteratorCell__f_head).apply__O())).iterator__sc_Iterator();
});
var $d_sc_Iterator$ConcatIteratorCell = new $TypeData().initClass($c_sc_Iterator$ConcatIteratorCell, "scala.collection.Iterator$ConcatIteratorCell", ({
  sc_Iterator$ConcatIteratorCell: 1
}));
function $p_sc_LinearSeqIterator$LazyCell__v$lzycompute__sc_LinearSeqOps($thiz) {
  if ((!$thiz.sc_LinearSeqIterator$LazyCell__f_bitmap$0)) {
    $thiz.sc_LinearSeqIterator$LazyCell__f_v = $as_sc_LinearSeqOps($n($thiz.sc_LinearSeqIterator$LazyCell__f_st).apply__O());
    $thiz.sc_LinearSeqIterator$LazyCell__f_bitmap$0 = true;
  }
  $thiz.sc_LinearSeqIterator$LazyCell__f_st = null;
  return $thiz.sc_LinearSeqIterator$LazyCell__f_v;
}
/** @constructor */
function $c_sc_LinearSeqIterator$LazyCell(outer, st) {
  this.sc_LinearSeqIterator$LazyCell__f_v = null;
  this.sc_LinearSeqIterator$LazyCell__f_st = null;
  this.sc_LinearSeqIterator$LazyCell__f_bitmap$0 = false;
  this.sc_LinearSeqIterator$LazyCell__f_st = st;
}
$c_sc_LinearSeqIterator$LazyCell.prototype = new $h_O();
$c_sc_LinearSeqIterator$LazyCell.prototype.constructor = $c_sc_LinearSeqIterator$LazyCell;
/** @constructor */
function $h_sc_LinearSeqIterator$LazyCell() {
}
$h_sc_LinearSeqIterator$LazyCell.prototype = $c_sc_LinearSeqIterator$LazyCell.prototype;
$c_sc_LinearSeqIterator$LazyCell.prototype.v__sc_LinearSeqOps = (function() {
  return ((!this.sc_LinearSeqIterator$LazyCell__f_bitmap$0) ? $p_sc_LinearSeqIterator$LazyCell__v$lzycompute__sc_LinearSeqOps(this) : this.sc_LinearSeqIterator$LazyCell__f_v);
});
var $d_sc_LinearSeqIterator$LazyCell = new $TypeData().initClass($c_sc_LinearSeqIterator$LazyCell, "scala.collection.LinearSeqIterator$LazyCell", ({
  sc_LinearSeqIterator$LazyCell: 1
}));
/** @constructor */
function $c_sc_StringOps$() {
  this.sc_StringOps$__f_fallback = null;
  $n_sc_StringOps$ = this;
  this.sc_StringOps$__f_fallback = new $c_sjsr_AnonFunction1(((x$1$2) => $m_sc_StringOps$().sc_StringOps$__f_fallback));
}
$c_sc_StringOps$.prototype = new $h_O();
$c_sc_StringOps$.prototype.constructor = $c_sc_StringOps$;
/** @constructor */
function $h_sc_StringOps$() {
}
$h_sc_StringOps$.prototype = $c_sc_StringOps$.prototype;
$c_sc_StringOps$.prototype.slice$extension__T__I__I__T = (function(this$, from, until) {
  var start = ((from > 0) ? from : 0);
  var this$6 = $n(this$);
  var that = this$6.length;
  var end = ((until < that) ? until : that);
  if ((start >= end)) {
    return "";
  } else {
    var this$10 = $n(this$);
    if ((start < 0)) {
      $charAt(this$10, start);
    }
    if ((end > this$10.length)) {
      $charAt(this$10, end);
    }
    if ((end < start)) {
      $charAt(this$10, (-1));
    }
    return $as_T(this$10.substring(start, end));
  }
});
$c_sc_StringOps$.prototype.$times$extension__T__I__T = (function(this$, n) {
  if ((n <= 0)) {
    return "";
  } else {
    var this$1 = $n(this$);
    var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), Math.imul(this$1.length, n));
    var i = 0;
    while ((i < n)) {
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + this$);
      i = ((1 + i) | 0);
    }
    return sb.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  }
});
$c_sc_StringOps$.prototype.stripPrefix$extension__T__T__T = (function(this$, prefix) {
  var this$1 = $n(this$);
  if ((this$1.length >= 0)) {
    var this$2 = $n(prefix);
    var $x_2 = this$1.substring(0, this$2.length);
    var $x_1 = ($as_T($x_2) === prefix);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var this$4 = $n(this$);
    var this$3 = $n(prefix);
    var beginIndex = this$3.length;
    if (((beginIndex < 0) || (beginIndex > this$4.length))) {
      $charAt(this$4, beginIndex);
    }
    return $as_T(this$4.substring(beginIndex));
  } else {
    return this$;
  }
});
$c_sc_StringOps$.prototype.stripSuffix$extension__T__T__T = (function(this$, suffix) {
  if ($f_T__endsWith__T__Z($n(this$), suffix)) {
    var this$3 = $n(this$);
    var this$1 = $n(this$);
    var this$2 = $n(suffix);
    var endIndex = ((this$1.length - this$2.length) | 0);
    if ((endIndex > this$3.length)) {
      $charAt(this$3, endIndex);
    }
    if ((endIndex < 0)) {
      $charAt(this$3, (-1));
    }
    return $as_T(this$3.substring(0, endIndex));
  } else {
    return this$;
  }
});
$c_sc_StringOps$.prototype.stripMargin$extension__T__C__T = (function(this$, marginChar) {
  var this$1 = $n(this$);
  var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), this$1.length);
  var this$4 = new $c_sc_StringOps$$anon$1(this$, false);
  while ((this$4.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < this$4.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)) {
    var arg1 = this$4.next__T();
    var this$5 = $n(arg1);
    var len = this$5.length;
    var index = 0;
    while (true) {
      if ((index < len)) {
        var this$6 = $n(arg1);
        var index$1 = index;
        var $x_1 = ($charAt(this$6, index$1) <= 32);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        index = ((1 + index) | 0);
      } else {
        break;
      }
    }
    if ((index < len)) {
      var this$7 = $n(arg1);
      var index$2 = index;
      var $x_2 = ($charAt(this$7, index$2) === marginChar);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var this$8 = $n(arg1);
      var beginIndex = ((1 + index) | 0);
      if (((beginIndex < 0) || (beginIndex > this$8.length))) {
        $charAt(this$8, beginIndex);
      }
      var stripped = $as_T(this$8.substring(beginIndex));
    } else {
      var stripped = arg1;
    }
    sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + stripped);
  }
  return sb.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_sc_StringOps$.prototype.escape$extension__T__C__T = (function(this$, ch) {
  return (((((ch >= 97) && (ch <= 122)) || ((ch >= 65) && (ch <= 90))) || ((ch >= 48) && (ch <= 57))) ? ("" + $cToS(ch)) : ("\\" + $cToS(ch)));
});
$c_sc_StringOps$.prototype.split$extension__T__C__AT = (function(this$, separator) {
  var this$1 = $n(this$);
  var regex = $m_sc_StringOps$().escape$extension__T__C__T(this$, separator);
  return $f_T__split__T__I__AT(this$1, regex, 0);
});
$c_sc_StringOps$.prototype.toBooleanImpl$extension__T__T__Z = (function(this$, s) {
  if ((s === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "For input string: \"null\"");
  } else {
    var this$1 = $n(s);
    _return: {
      var len = this$1.length;
      if ((len === 4)) {
        var i = 0;
        while ((i !== len)) {
          var index = i;
          var c = $charAt(this$1, index);
          var $x_2 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c));
          var index$1 = i;
          var c$1 = $charAt("true", index$1);
          if (($x_2 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$1)))) {
            var $x_1 = false;
            break _return;
          }
          i = ((1 + i) | 0);
        }
        var $x_1 = true;
      } else {
        var $x_1 = false;
      }
    }
    if ($x_1) {
      return true;
    } else {
      var this$2 = $n(s);
      _return$1: {
        var len$1 = this$2.length;
        if ((len$1 === 5)) {
          var i$1 = 0;
          while ((i$1 !== len$1)) {
            var index$2 = i$1;
            var c$2 = $charAt(this$2, index$2);
            var $x_4 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$2));
            var index$3 = i$1;
            var c$3 = $charAt("false", index$3);
            if (($x_4 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$3)))) {
              var $x_3 = false;
              break _return$1;
            }
            i$1 = ((1 + i$1) | 0);
          }
          var $x_3 = true;
        } else {
          var $x_3 = false;
        }
      }
      if ($x_3) {
        return false;
      } else {
        throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("For input string: \"" + s) + "\""));
      }
    }
  }
});
$c_sc_StringOps$.prototype.unwrapArg$extension__T__O__O = (function(this$, arg) {
  if ((arg instanceof $c_s_math_ScalaNumber)) {
    var x2 = $as_s_math_ScalaNumber(arg);
    return $n(x2).underlying__O();
  } else {
    return arg;
  }
});
$c_sc_StringOps$.prototype.format$extension__T__sci_Seq__T = (function(this$, args) {
  var args$1 = $asArrayOf_O($n($as_sc_IterableOnceOps($n(args).map__F1__O(new $c_sjsr_AnonFunction1(((arg$2) => $m_sc_StringOps$().unwrapArg$extension__T__O__O(this$, arg$2)))))).toArray__s_reflect_ClassTag__O($m_s_reflect_ManifestFactory$ObjectManifest$()), 1);
  return $m_jl_String$().format__T__AO__T(this$, args$1);
});
$c_sc_StringOps$.prototype.head$extension__T__C = (function(this$) {
  var this$1 = $n(this$);
  if ((this$1 === "")) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty String");
  } else {
    var this$2 = $n(this$);
    return $charAt(this$2, 0);
  }
});
$c_sc_StringOps$.prototype.headOption$extension__T__s_Option = (function(this$) {
  var this$1 = $n(this$);
  if ((this$1 === "")) {
    return $m_s_None$();
  } else {
    var this$2 = $n(this$);
    return new $c_s_Some($bC($charAt(this$2, 0)));
  }
});
$c_sc_StringOps$.prototype.lastOption$extension__T__s_Option = (function(this$) {
  var this$1 = $n(this$);
  if ((this$1 === "")) {
    return $m_s_None$();
  } else {
    var this$3 = $n(this$);
    var this$2 = $n(this$);
    var index = (((-1) + this$2.length) | 0);
    return new $c_s_Some($bC($charAt(this$3, index)));
  }
});
$c_sc_StringOps$.prototype.reverse$extension__T__T = (function(this$) {
  return $n($ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), this$).reverse__jl_StringBuilder()).jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_sc_StringOps$.prototype.take$extension__T__I__T = (function(this$, n) {
  var $x_1 = $m_sc_StringOps$();
  var this$1 = $n(this$);
  var y = this$1.length;
  return $n($x_1).slice$extension__T__I__I__T(this$, 0, ((n < y) ? n : y));
});
$c_sc_StringOps$.prototype.drop$extension__T__I__T = (function(this$, n) {
  var $x_1 = $m_sc_StringOps$();
  var this$1 = $n(this$);
  var y = this$1.length;
  var this$4 = $n(this$);
  return $n($x_1).slice$extension__T__I__I__T(this$, ((n < y) ? n : y), this$4.length);
});
$c_sc_StringOps$.prototype.dropRight$extension__T__I__T = (function(this$, n) {
  var $x_1 = $m_sc_StringOps$();
  var this$1 = $n(this$);
  return $n($x_1).take$extension__T__I__T(this$, ((this$1.length - ((n > 0) ? n : 0)) | 0));
});
$c_sc_StringOps$.prototype.dropWhile$extension__T__F1__T = (function(this$, p) {
  _return: {
    var this$2 = $n(this$);
    var len = this$2.length;
    var i = 0;
    while ((i < len)) {
      var this$3 = $n(this$);
      var index = i;
      var arg1 = $charAt(this$3, index);
      if ((!$uZ($n(p).apply__O__O($bC(arg1))))) {
        var x1 = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var x1 = (-1);
  }
  if ((x1 === (-1))) {
    return "";
  } else {
    var this$4 = $n(this$);
    if (((x1 < 0) || (x1 > this$4.length))) {
      $charAt(this$4, x1);
    }
    return $as_T(this$4.substring(x1));
  }
});
var $d_sc_StringOps$ = new $TypeData().initClass($c_sc_StringOps$, "scala.collection.StringOps$", ({
  sc_StringOps$: 1
}));
var $n_sc_StringOps$;
function $m_sc_StringOps$() {
  if ((!$n_sc_StringOps$)) {
    $n_sc_StringOps$ = new $c_sc_StringOps$();
  }
  return $n_sc_StringOps$;
}
function $p_sc_StringParsers$__step$2__I__J__Z__I__T__s_Option($thiz, i, agg, isPositive, len$3, from$3) {
  while (true) {
    if ((i === len$3)) {
      if (isPositive) {
        var this$1 = agg;
        var $x_1 = ((this$1.RTLong__f_lo === 0) && (this$1.RTLong__f_hi === (-2147483648)));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        return $m_s_None$();
      } else if (isPositive) {
        var this$2 = agg;
        var lo = this$2.RTLong__f_lo;
        var hi = this$2.RTLong__f_hi;
        var lo$1 = ((-lo) | 0);
        var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
        return new $c_s_Some(new $c_RTLong(lo$1, hi$1));
      } else {
        return new $c_s_Some(agg);
      }
    } else {
      var this$5 = agg;
      var ahi = this$5.RTLong__f_hi;
      if (((ahi === (-214748365)) ? (((-2147483648) ^ this$5.RTLong__f_lo) < (-1288490188)) : (ahi < (-214748365)))) {
        return $m_s_None$();
      } else {
        var this$6 = $n(from$3);
        var index = i;
        var ch = $charAt(this$6, index);
        var this$7 = $m_jl_Character$();
        var codePoint = ch;
        var digit = this$7.digitWithValidRadix__I__I__I(codePoint, 10);
        if ((digit === (-1))) {
          var $x_2 = true;
        } else {
          var this$8 = agg;
          if (((this$8.RTLong__f_lo === 858993460) && (this$8.RTLong__f_hi === (-214748365)))) {
            var $x_2 = (digit === 9);
          } else {
            var $x_2 = false;
          }
        }
        if ($x_2) {
          return $m_s_None$();
        } else {
          var temp$i = ((1 + i) | 0);
          var b = agg;
          var blo = b.RTLong__f_lo;
          var b0 = (65535 & blo);
          var b1 = ((blo >>> 16) | 0);
          var a0b0 = Math.imul(10, b0);
          var a0b1 = Math.imul(10, b1);
          var lo$2 = ((a0b0 + (a0b1 << 16)) | 0);
          var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
          var hi$2 = ((Math.imul(10, b.RTLong__f_hi) + ((c1part >>> 16) | 0)) | 0);
          var hi$3 = (digit >> 31);
          var lo$3 = ((lo$2 - digit) | 0);
          var hi$4 = ((((-2147483648) ^ lo$3) > ((-2147483648) ^ lo$2)) ? (((-1) + ((hi$2 - hi$3) | 0)) | 0) : ((hi$2 - hi$3) | 0));
          i = temp$i;
          agg = new $c_RTLong(lo$3, hi$4);
        }
      }
    }
  }
}
/** @constructor */
function $c_sc_StringParsers$() {
}
$c_sc_StringParsers$.prototype = new $h_O();
$c_sc_StringParsers$.prototype.constructor = $c_sc_StringParsers$;
/** @constructor */
function $h_sc_StringParsers$() {
}
$h_sc_StringParsers$.prototype = $c_sc_StringParsers$.prototype;
$c_sc_StringParsers$.prototype.parseLong__T__s_Option = (function(from) {
  var this$1 = $n(from);
  var len = this$1.length;
  if ((len === 0)) {
    return $m_s_None$();
  } else {
    var this$2 = $n(from);
    var first = $charAt(this$2, 0);
    var this$3 = $m_jl_Character$();
    var codePoint = first;
    var value = this$3.digitWithValidRadix__I__I__I(codePoint, 10);
    var hi = (value >> 31);
    if ((len === 1)) {
      return ((hi > (-1)) ? new $c_s_Some(new $c_RTLong(value, hi)) : $m_s_None$());
    } else if ((hi > (-1))) {
      var lo = ((-value) | 0);
      var hi$1 = ((value !== 0) ? (~hi) : ((-hi) | 0));
      return $p_sc_StringParsers$__step$2__I__J__Z__I__T__s_Option(this, 1, new $c_RTLong(lo, hi$1), true, len, from);
    } else {
      return ((first === 43) ? $p_sc_StringParsers$__step$2__I__J__Z__I__T__s_Option(this, 1, $L0, true, len, from) : ((first === 45) ? $p_sc_StringParsers$__step$2__I__J__Z__I__T__s_Option(this, 1, $L0, false, len, from) : $m_s_None$()));
    }
  }
});
var $d_sc_StringParsers$ = new $TypeData().initClass($c_sc_StringParsers$, "scala.collection.StringParsers$", ({
  sc_StringParsers$: 1
}));
var $n_sc_StringParsers$;
function $m_sc_StringParsers$() {
  if ((!$n_sc_StringParsers$)) {
    $n_sc_StringParsers$ = new $c_sc_StringParsers$();
  }
  return $n_sc_StringParsers$;
}
function $f_scg_BitOperations$Int__zero__I__I__Z($thiz, i, mask) {
  return ((i & mask) === 0);
}
function $f_scg_BitOperations$Int__mask__I__I__I($thiz, i, mask) {
  var i$1 = (((-1) + mask) | 0);
  return (i & ($f_scg_BitOperations$Int__complement__I__I($thiz, i$1) ^ mask));
}
function $f_scg_BitOperations$Int__hasMatch__I__I__I__Z($thiz, key, prefix, m) {
  return ($f_scg_BitOperations$Int__mask__I__I__I($thiz, key, m) === prefix);
}
function $f_scg_BitOperations$Int__complement__I__I($thiz, i) {
  return (~i);
}
function $p_sci_IndexedSeqDefaults$__liftedTree1$1__I($thiz) {
  try {
    var x = $m_jl_System$SystemProperties$().getProperty__T__T__T("scala.collection.immutable.IndexedSeq.defaultApplyPreferredMaxLength", "64");
    var this$4 = $m_jl_Integer$();
    return this$4.parseInt__T__I__I(x, 10);
  } catch (e) {
    if (false) {
      return 64;
    } else {
      throw e;
    }
  }
}
/** @constructor */
function $c_sci_IndexedSeqDefaults$() {
  this.sci_IndexedSeqDefaults$__f_defaultApplyPreferredMaxLength = 0;
  $n_sci_IndexedSeqDefaults$ = this;
  this.sci_IndexedSeqDefaults$__f_defaultApplyPreferredMaxLength = $p_sci_IndexedSeqDefaults$__liftedTree1$1__I(this);
}
$c_sci_IndexedSeqDefaults$.prototype = new $h_O();
$c_sci_IndexedSeqDefaults$.prototype.constructor = $c_sci_IndexedSeqDefaults$;
/** @constructor */
function $h_sci_IndexedSeqDefaults$() {
}
$h_sci_IndexedSeqDefaults$.prototype = $c_sci_IndexedSeqDefaults$.prototype;
var $d_sci_IndexedSeqDefaults$ = new $TypeData().initClass($c_sci_IndexedSeqDefaults$, "scala.collection.immutable.IndexedSeqDefaults$", ({
  sci_IndexedSeqDefaults$: 1
}));
var $n_sci_IndexedSeqDefaults$;
function $m_sci_IndexedSeqDefaults$() {
  if ((!$n_sci_IndexedSeqDefaults$)) {
    $n_sci_IndexedSeqDefaults$ = new $c_sci_IndexedSeqDefaults$();
  }
  return $n_sci_IndexedSeqDefaults$;
}
/** @constructor */
function $c_sci_LazyList$Deferrer$() {
}
$c_sci_LazyList$Deferrer$.prototype = new $h_O();
$c_sci_LazyList$Deferrer$.prototype.constructor = $c_sci_LazyList$Deferrer$;
/** @constructor */
function $h_sci_LazyList$Deferrer$() {
}
$h_sci_LazyList$Deferrer$.prototype = $c_sci_LazyList$Deferrer$.prototype;
$c_sci_LazyList$Deferrer$.prototype.$hash$colon$colon$extension__F0__F0__sci_LazyList = (function(this$, elem) {
  $m_sci_LazyList$();
  var state$1 = new $c_sjsr_AnonFunction0((() => {
    $m_sci_LazyList$();
    var hd = $n(elem).apply__O();
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((() => $n($as_sci_LazyList($n(this$).apply__O())).scala$collection$immutable$LazyList$$state__sci_LazyList$State()));
    var tl = new $c_sci_LazyList(state);
    return new $c_sci_LazyList$State$Cons(hd, tl);
  }));
  return new $c_sci_LazyList(state$1);
});
var $d_sci_LazyList$Deferrer$ = new $TypeData().initClass($c_sci_LazyList$Deferrer$, "scala.collection.immutable.LazyList$Deferrer$", ({
  sci_LazyList$Deferrer$: 1
}));
var $n_sci_LazyList$Deferrer$;
function $m_sci_LazyList$Deferrer$() {
  if ((!$n_sci_LazyList$Deferrer$)) {
    $n_sci_LazyList$Deferrer$ = new $c_sci_LazyList$Deferrer$();
  }
  return $n_sci_LazyList$Deferrer$;
}
/** @constructor */
function $c_sci_LazyList$LazyBuilder$DeferredState() {
  this.sci_LazyList$LazyBuilder$DeferredState__f__state = null;
}
$c_sci_LazyList$LazyBuilder$DeferredState.prototype = new $h_O();
$c_sci_LazyList$LazyBuilder$DeferredState.prototype.constructor = $c_sci_LazyList$LazyBuilder$DeferredState;
/** @constructor */
function $h_sci_LazyList$LazyBuilder$DeferredState() {
}
$h_sci_LazyList$LazyBuilder$DeferredState.prototype = $c_sci_LazyList$LazyBuilder$DeferredState.prototype;
$c_sci_LazyList$LazyBuilder$DeferredState.prototype.eval__sci_LazyList$State = (function() {
  var state = this.sci_LazyList$LazyBuilder$DeferredState__f__state;
  if ((state === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "uninitialized");
  }
  return $as_sci_LazyList$State($n(state).apply__O());
});
$c_sci_LazyList$LazyBuilder$DeferredState.prototype.init__F0__V = (function(state) {
  if ((this.sci_LazyList$LazyBuilder$DeferredState__f__state !== null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "already initialized");
  }
  this.sci_LazyList$LazyBuilder$DeferredState__f__state = state;
});
var $d_sci_LazyList$LazyBuilder$DeferredState = new $TypeData().initClass($c_sci_LazyList$LazyBuilder$DeferredState, "scala.collection.immutable.LazyList$LazyBuilder$DeferredState", ({
  sci_LazyList$LazyBuilder$DeferredState: 1
}));
/** @constructor */
function $c_sci_LazyList$cons$() {
}
$c_sci_LazyList$cons$.prototype = new $h_O();
$c_sci_LazyList$cons$.prototype.constructor = $c_sci_LazyList$cons$;
/** @constructor */
function $h_sci_LazyList$cons$() {
}
$h_sci_LazyList$cons$.prototype = $c_sci_LazyList$cons$.prototype;
$c_sci_LazyList$cons$.prototype.apply__F0__F0__sci_LazyList = (function(hd, tl) {
  $m_sci_LazyList$();
  var state$1 = new $c_sjsr_AnonFunction0((() => {
    $m_sci_LazyList$();
    var hd$1 = $n(hd).apply__O();
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((() => $n($as_sci_LazyList($n(tl).apply__O())).scala$collection$immutable$LazyList$$state__sci_LazyList$State()));
    var tl$1 = new $c_sci_LazyList(state);
    return new $c_sci_LazyList$State$Cons(hd$1, tl$1);
  }));
  return new $c_sci_LazyList(state$1);
});
var $d_sci_LazyList$cons$ = new $TypeData().initClass($c_sci_LazyList$cons$, "scala.collection.immutable.LazyList$cons$", ({
  sci_LazyList$cons$: 1
}));
var $n_sci_LazyList$cons$;
function $m_sci_LazyList$cons$() {
  if ((!$n_sci_LazyList$cons$)) {
    $n_sci_LazyList$cons$ = new $c_sci_LazyList$cons$();
  }
  return $n_sci_LazyList$cons$;
}
/** @constructor */
function $c_sci_MapNode$() {
  this.sci_MapNode$__f_EmptyMapNode = null;
  $n_sci_MapNode$ = this;
  this.sci_MapNode$__f_EmptyMapNode = new $c_sci_BitmapIndexedMapNode(0, 0, new $ac_O(0), new $ac_I(0), 0, 0);
}
$c_sci_MapNode$.prototype = new $h_O();
$c_sci_MapNode$.prototype.constructor = $c_sci_MapNode$;
/** @constructor */
function $h_sci_MapNode$() {
}
$h_sci_MapNode$.prototype = $c_sci_MapNode$.prototype;
var $d_sci_MapNode$ = new $TypeData().initClass($c_sci_MapNode$, "scala.collection.immutable.MapNode$", ({
  sci_MapNode$: 1
}));
var $n_sci_MapNode$;
function $m_sci_MapNode$() {
  if ((!$n_sci_MapNode$)) {
    $n_sci_MapNode$ = new $c_sci_MapNode$();
  }
  return $n_sci_MapNode$;
}
function $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException($thiz, as, ix) {
  return $ct_jl_ArrayIndexOutOfBoundsException__T__(new $c_jl_ArrayIndexOutOfBoundsException(), ((ix + " is out of bounds (min 0, max ") + (((-1) + $m_jl_reflect_Array$().getLength__O__I(as)) | 0)));
}
/** @constructor */
function $c_sci_Node() {
}
$c_sci_Node.prototype = new $h_O();
$c_sci_Node.prototype.constructor = $c_sci_Node;
/** @constructor */
function $h_sci_Node() {
}
$h_sci_Node.prototype = $c_sci_Node.prototype;
$c_sci_Node.prototype.removeElement__AI__I__AI = (function(as, ix) {
  if ((ix < 0)) {
    throw $n($p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix));
  }
  if ((ix > (((-1) + $n(as).u.length) | 0))) {
    throw $n($p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix));
  }
  var result = new $ac_I((((-1) + $n(as).u.length) | 0));
  $systemArraycopy($n(as), 0, result, 0, ix);
  var srcPos = ((1 + ix) | 0);
  var length = (((-1) + (($n(as).u.length - ix) | 0)) | 0);
  $systemArraycopy($n(as), srcPos, result, ix, length);
  return result;
});
$c_sci_Node.prototype.insertElement__AI__I__I__AI = (function(as, ix, elem) {
  if ((ix < 0)) {
    throw $n($p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix));
  }
  if ((ix > $n(as).u.length)) {
    throw $n($p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix));
  }
  var result = new $ac_I(((1 + $n(as).u.length) | 0));
  $systemArraycopy($n(as), 0, result, 0, ix);
  $n(result).set(ix, elem);
  var destPos = ((1 + ix) | 0);
  var length = (($n(as).u.length - ix) | 0);
  $systemArraycopy($n(as), ix, result, destPos, length);
  return result;
});
var $d_sci_Node = new $TypeData().initClass(0, "scala.collection.immutable.Node", ({
  sci_Node: 1
}));
/** @constructor */
function $c_sci_Node$() {
  this.sci_Node$__f_MaxDepth = 0;
  $n_sci_Node$ = this;
  this.sci_Node$__f_MaxDepth = $doubleToInt($uD(Math.ceil(6.4)));
}
$c_sci_Node$.prototype = new $h_O();
$c_sci_Node$.prototype.constructor = $c_sci_Node$;
/** @constructor */
function $h_sci_Node$() {
}
$h_sci_Node$.prototype = $c_sci_Node$.prototype;
$c_sci_Node$.prototype.maskFrom__I__I__I = (function(hash, shift) {
  return (31 & ((hash >>> shift) | 0));
});
$c_sci_Node$.prototype.bitposFrom__I__I = (function(mask) {
  return (1 << mask);
});
$c_sci_Node$.prototype.indexFrom__I__I__I = (function(bitmap, bitpos) {
  var i = (bitmap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_Node$.prototype.indexFrom__I__I__I__I = (function(bitmap, mask, bitpos) {
  return ((bitmap === (-1)) ? mask : this.indexFrom__I__I__I(bitmap, bitpos));
});
var $d_sci_Node$ = new $TypeData().initClass($c_sci_Node$, "scala.collection.immutable.Node$", ({
  sci_Node$: 1
}));
var $n_sci_Node$;
function $m_sci_Node$() {
  if ((!$n_sci_Node$)) {
    $n_sci_Node$ = new $c_sci_Node$();
  }
  return $n_sci_Node$;
}
function $p_sci_RedBlackTree$___foreachKey__sci_RedBlackTree$Tree__F1__V($thiz, tree, f) {
  while (true) {
    var this$1 = $n(tree);
    if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left !== null)) {
      var this$2 = $n(tree);
      $p_sci_RedBlackTree$___foreachKey__sci_RedBlackTree$Tree__F1__V($thiz, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, f);
    }
    var $x_1 = $n(f);
    var this$3 = $n(tree);
    $n($x_1).apply__O__O(this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
    var this$4 = $n(tree);
    if ((this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right !== null)) {
      var this$5 = $n(tree);
      tree = this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      continue;
    }
    return (void 0);
  }
}
function $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, t) {
  return ((t === null) ? null : $n(t).black__sci_RedBlackTree$Tree());
}
function $p_sci_RedBlackTree$__maybeBlacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, t) {
  if ($thiz.isBlack__sci_RedBlackTree$Tree__Z(t)) {
    return t;
  } else {
    var this$1 = $n(t);
    var tree = this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    if ((tree !== null)) {
      var this$2 = $n(tree);
      var $x_2 = (this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var $x_1 = true;
    } else {
      var this$3 = $n(t);
      var tree$1 = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      if ((tree$1 !== null)) {
        var this$4 = $n(tree$1);
        var $x_1 = (this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
      } else {
        var $x_1 = false;
      }
    }
    if ($x_1) {
      return $n(t).black__sci_RedBlackTree$Tree();
    } else {
      return t;
    }
  }
}
function $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, isBlack, key, value, left, right) {
  if ((left === null)) {
    var $x_2 = 0;
  } else {
    var this$1 = $n(left);
    var $x_2 = (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count);
  }
  if ((right === null)) {
    var $x_1 = 0;
  } else {
    var this$2 = $n(right);
    var $x_1 = (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count);
  }
  var sizeAndColour = (((1 + (($x_2 + $x_1) | 0)) | 0) | (isBlack ? (-2147483648) : 0));
  return new $c_sci_RedBlackTree$Tree(key, value, left, right, sizeAndColour);
}
function $p_sci_RedBlackTree$__balanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, newLeft) {
  var this$1 = $n(tree);
  if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left === newLeft)) {
    return tree;
  } else {
    var this$2 = $n(newLeft);
    if ((this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
      var this$3 = $n(newLeft);
      var newLeft_left = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var this$4 = $n(newLeft);
      var newLeft_right = this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      if ((newLeft_left !== null)) {
        var this$5 = $n(newLeft_left);
        var $x_1 = (this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var resultLeft = $n(newLeft_left).black__sci_RedBlackTree$Tree();
        var resultRight = $n(tree).blackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft_right);
        return $n(newLeft).withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft, resultRight);
      } else {
        if ((newLeft_right !== null)) {
          var this$6 = $n(newLeft_right);
          var $x_2 = (this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
        } else {
          var $x_2 = false;
        }
        if ($x_2) {
          var this$7 = $n(newLeft_right);
          var newLeft_right_right = this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
          var $x_3 = $n(newLeft);
          var this$8 = $n(newLeft_right);
          var resultLeft$2 = $n($x_3).blackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
          var resultRight$2 = $n(tree).blackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft_right_right);
          return $n(newLeft_right).withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft$2, resultRight$2);
        } else {
          return $n(tree).withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft);
        }
      }
    } else {
      return $n(tree).withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft);
    }
  }
}
function $p_sci_RedBlackTree$__balanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, newRight) {
  var this$1 = $n(tree);
  if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right === newRight)) {
    return tree;
  } else {
    var this$2 = $n(newRight);
    if ((this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
      var this$3 = $n(newRight);
      var newRight_left = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      if ((newRight_left !== null)) {
        var this$4 = $n(newRight_left);
        var $x_1 = (this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var $x_2 = $n(tree);
        var this$5 = $n(newRight_left);
        var resultLeft = $n($x_2).blackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        var $x_3 = $n(newRight);
        var this$6 = $n(newRight_left);
        var resultRight = $n($x_3).blackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
        return $n(newRight_left).withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft, resultRight);
      } else {
        var this$7 = $n(newRight);
        var newRight_right = this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
        if ((newRight_right !== null)) {
          var this$8 = $n(newRight_right);
          var $x_4 = (this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
        } else {
          var $x_4 = false;
        }
        if ($x_4) {
          var resultLeft$2 = $n(tree).blackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight_left);
          var resultRight$2 = $n(newRight_right).black__sci_RedBlackTree$Tree();
          return $n(newRight).withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft$2, resultRight$2);
        } else {
          return $n(tree).withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight);
        }
      }
    } else {
      return $n(tree).withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight);
    }
  }
}
function $p_sci_RedBlackTree$__upd__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree($thiz, tree, k, v, overwrite, ordering) {
  if ((tree === null)) {
    return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(k, v, null, null);
  } else {
    var this$1 = $n(tree);
    if (Object.is(k, this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)) {
      return (overwrite ? $n(tree).withV__O__sci_RedBlackTree$Tree(v) : tree);
    } else {
      var $x_1 = $n(ordering);
      var this$2 = $n(tree);
      var cmp = $n($x_1).compare__O__O__I(k, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
      if ((cmp < 0)) {
        var this$3 = $n(tree);
        return $p_sci_RedBlackTree$__balanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, $p_sci_RedBlackTree$__upd__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree($thiz, this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, k, v, overwrite, ordering));
      } else if ((cmp > 0)) {
        var this$4 = $n(tree);
        return $p_sci_RedBlackTree$__balanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, $p_sci_RedBlackTree$__upd__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree($thiz, this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k, v, overwrite, ordering));
      } else {
        if (overwrite) {
          var this$5 = $n(tree);
          var $x_2 = (!Object.is(v, this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value));
        } else {
          var $x_2 = false;
        }
        if ($x_2) {
          return $n(tree).withV__O__sci_RedBlackTree$Tree(v);
        } else {
          return tree;
        }
      }
    }
  }
}
function $p_sci_RedBlackTree$__updNth__sci_RedBlackTree$Tree__I__O__O__sci_RedBlackTree$Tree($thiz, tree, idx, k, v) {
  if ((tree === null)) {
    return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(k, v, null, null);
  } else {
    var this$1 = $n(tree);
    var rank = ((1 + $thiz.count__sci_RedBlackTree$Tree__I(this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left)) | 0);
    if ((idx < rank)) {
      var this$2 = $n(tree);
      return $p_sci_RedBlackTree$__balanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, $p_sci_RedBlackTree$__updNth__sci_RedBlackTree$Tree__I__O__O__sci_RedBlackTree$Tree($thiz, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, idx, k, v));
    } else if ((idx > rank)) {
      var this$3 = $n(tree);
      return $p_sci_RedBlackTree$__balanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, $p_sci_RedBlackTree$__updNth__sci_RedBlackTree$Tree__I__O__O__sci_RedBlackTree$Tree($thiz, this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ((idx - rank) | 0), k, v));
    } else {
      return tree;
    }
  }
}
function $p_sci_RedBlackTree$__doDrop__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree($thiz, tree, n) {
  while (true) {
    if (((tree === null) || (n <= 0))) {
      return tree;
    } else {
      var $x_1 = n;
      var this$1 = $n(tree);
      if (($x_1 >= (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) {
        return null;
      } else {
        var this$2 = $n(tree);
        var l = $thiz.count__sci_RedBlackTree$Tree__I(this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        if ((n > l)) {
          var this$3 = $n(tree);
          var temp$tree = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
          var temp$n = (((-1) + ((n - l) | 0)) | 0);
          tree = temp$tree;
          n = temp$n;
        } else if ((n === l)) {
          var this$4 = $n(tree);
          var $x_3 = this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
          var this$5 = $n(tree);
          var $x_2 = this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
          var this$6 = $n(tree);
          return $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(null, $x_3, $x_2, this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
        } else {
          var this$7 = $n(tree);
          var $x_6 = $p_sci_RedBlackTree$__doDrop__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree($thiz, this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, n);
          var this$8 = $n(tree);
          var $x_5 = this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
          var this$9 = $n(tree);
          var $x_4 = this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
          var this$10 = $n(tree);
          return $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($x_6, $x_5, $x_4, this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
        }
      }
    }
  }
}
function $p_sci_RedBlackTree$__doTake__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree($thiz, tree, n) {
  while (true) {
    if (((tree === null) || (n <= 0))) {
      return null;
    } else {
      var this$1 = $n(tree);
      if ((n >= (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) {
        return tree;
      } else {
        var this$2 = $n(tree);
        var l = $thiz.count__sci_RedBlackTree$Tree__I(this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        if ((n <= l)) {
          var this$3 = $n(tree);
          tree = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
        } else if ((n === ((1 + l) | 0))) {
          var this$4 = $n(tree);
          var $x_2 = this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
          var this$5 = $n(tree);
          var $x_1 = this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
          var this$6 = $n(tree);
          return $p_sci_RedBlackTree$__maybeBlacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, $p_sci_RedBlackTree$__updNth__sci_RedBlackTree$Tree__I__O__O__sci_RedBlackTree$Tree($thiz, $x_2, n, $x_1, this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value));
        } else {
          var this$7 = $n(tree);
          var $x_5 = this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
          var this$8 = $n(tree);
          var $x_4 = this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
          var this$9 = $n(tree);
          var $x_3 = this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
          var this$10 = $n(tree);
          return $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($x_5, $x_4, $x_3, $p_sci_RedBlackTree$__doTake__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree($thiz, this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, (((-1) + ((n - l) | 0)) | 0)));
        }
      }
    }
  }
}
function $p_sci_RedBlackTree$__del__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree($thiz, tree, k, ordering) {
  if ((tree === null)) {
    return null;
  } else {
    var $x_1 = $n(ordering);
    var this$1 = $n(tree);
    var cmp = $n($x_1).compare__O__O__I(k, this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
    if ((cmp < 0)) {
      var this$2 = $n(tree);
      var newLeft = $p_sci_RedBlackTree$__del__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree($thiz, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, k, ordering);
      var this$3 = $n(tree);
      if ((newLeft === this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left)) {
        return tree;
      } else {
        var this$4 = $n(tree);
        var tree$1 = this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
        if ((tree$1 !== null)) {
          var this$5 = $n(tree$1);
          var $x_2 = (this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0);
        } else {
          var $x_2 = false;
        }
        if ($x_2) {
          var this$6 = $n(tree);
          return $p_sci_RedBlackTree$__balLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, newLeft, this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
        } else {
          return $n(tree).redWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft);
        }
      }
    } else if ((cmp > 0)) {
      var this$7 = $n(tree);
      var newRight = $p_sci_RedBlackTree$__del__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree($thiz, this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k, ordering);
      var this$8 = $n(tree);
      if ((newRight === this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)) {
        return tree;
      } else {
        var this$9 = $n(tree);
        var tree$2 = this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
        if ((tree$2 !== null)) {
          var this$10 = $n(tree$2);
          var $x_3 = (this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0);
        } else {
          var $x_3 = false;
        }
        if ($x_3) {
          var this$11 = $n(tree);
          return $p_sci_RedBlackTree$__balRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, this$11.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight);
        } else {
          return $n(tree).redWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight);
        }
      }
    } else {
      var this$12 = $n(tree);
      var $x_4 = this$12.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var this$13 = $n(tree);
      return $p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, $x_4, this$13.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
    }
  }
}
function $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, tl, tr) {
  if ((tl !== null)) {
    var this$1 = $n(tl);
    var $x_1 = (this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    if ((tr !== null)) {
      var this$2 = $n(tr);
      var $x_2 = (this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      return $n(tree).redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($n(tl).black__sci_RedBlackTree$Tree(), $n(tr).black__sci_RedBlackTree$Tree());
    } else {
      var this$3 = $n(tl);
      var tree$1 = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      if ((tree$1 !== null)) {
        var this$4 = $n(tree$1);
        var $x_3 = (this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
      } else {
        var $x_3 = false;
      }
      if ($x_3) {
        var $x_5 = $n(tl);
        var this$5 = $n(tl);
        var $x_4 = $n(this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left).black__sci_RedBlackTree$Tree();
        var this$6 = $n(tl);
        return $n($x_5).withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($x_4, $n(tree).blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr));
      } else {
        var this$7 = $n(tl);
        var tree$2 = this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
        if ((tree$2 !== null)) {
          var this$8 = $n(tree$2);
          var $x_6 = (this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
        } else {
          var $x_6 = false;
        }
        if ($x_6) {
          var this$9 = $n(tl);
          var $x_9 = $n(this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
          var $x_8 = $n(tl);
          var this$10 = $n(tl);
          var this$11 = $n(this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
          var $x_7 = $n($x_8).blackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$11.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
          var this$12 = $n(tl);
          var this$13 = $n(this$12.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
          return $n($x_9).withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($x_7, $n(tree).blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$13.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr));
        } else {
          return $n(tree).blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, tr);
        }
      }
    }
  } else {
    if ((tr !== null)) {
      var this$14 = $n(tr);
      var $x_10 = (this$14.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var this$15 = $n(tr);
      var tree$3 = this$15.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      if ((tree$3 !== null)) {
        var this$16 = $n(tree$3);
        var $x_11 = (this$16.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
      } else {
        var $x_11 = false;
      }
      if ($x_11) {
        var $x_14 = $n(tr);
        var $x_13 = $n(tree);
        var this$17 = $n(tr);
        var $x_12 = $n($x_13).blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, this$17.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        var this$18 = $n(tr);
        return $n($x_14).withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($x_12, $n(this$18.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right).black__sci_RedBlackTree$Tree());
      } else {
        var this$19 = $n(tr);
        var tree$4 = this$19.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
        if ((tree$4 !== null)) {
          var this$20 = $n(tree$4);
          var $x_15 = (this$20.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
        } else {
          var $x_15 = false;
        }
        if ($x_15) {
          var this$21 = $n(tr);
          var $x_19 = $n(this$21.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
          var $x_18 = $n(tree);
          var this$22 = $n(tr);
          var this$23 = $n(this$22.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
          var $x_17 = $n($x_18).blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, this$23.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
          var this$24 = $n(tr);
          var this$25 = $n(this$24.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
          var $x_16 = this$25.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
          var this$26 = $n(tr);
          return $n($x_19).withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($x_17, $n(tr).blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($x_16, this$26.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right));
        } else {
          return $n(tree).blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, tr);
        }
      }
    } else {
      return $n(tree).blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, tr);
    }
  }
}
function $p_sci_RedBlackTree$__balLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, tl, tr) {
  if ((tl !== null)) {
    var this$1 = $n(tl);
    var $x_1 = (this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return $n(tree).redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($n(tl).black__sci_RedBlackTree$Tree(), tr);
  } else {
    if ((tr !== null)) {
      var this$2 = $n(tr);
      var $x_2 = (this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      return $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, tl, $n(tr).red__sci_RedBlackTree$Tree());
    } else {
      if ((tr !== null)) {
        var this$3 = $n(tr);
        var $x_4 = (this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
      } else {
        var $x_4 = false;
      }
      if ($x_4) {
        var this$4 = $n(tr);
        var tree$1 = this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
        if ((tree$1 !== null)) {
          var this$5 = $n(tree$1);
          var $x_3 = (this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0);
        } else {
          var $x_3 = false;
        }
      } else {
        var $x_3 = false;
      }
      if ($x_3) {
        var this$6 = $n(tr);
        var $x_8 = $n(this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        var $x_7 = $n(tree);
        var this$7 = $n(tr);
        var this$8 = $n(this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        var $x_6 = $n($x_7).blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        var this$9 = $n(tr);
        var this$10 = $n(this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        var $x_5 = this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
        var this$11 = $n(tr);
        return $n($x_8).redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($x_6, $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tr, $x_5, $n(this$11.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right).red__sci_RedBlackTree$Tree()));
      } else {
        $m_s_sys_package$().error__T__E("Defect: invariance violation");
      }
    }
  }
}
function $p_sci_RedBlackTree$__balRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, tl, tr) {
  if ((tr !== null)) {
    var this$1 = $n(tr);
    var $x_1 = (this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return $n(tree).redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, $n(tr).black__sci_RedBlackTree$Tree());
  } else {
    if ((tl !== null)) {
      var this$2 = $n(tl);
      var $x_2 = (this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      return $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, $n(tl).red__sci_RedBlackTree$Tree(), tr);
    } else {
      if ((tl !== null)) {
        var this$3 = $n(tl);
        var $x_4 = (this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
      } else {
        var $x_4 = false;
      }
      if ($x_4) {
        var this$4 = $n(tl);
        var tree$1 = this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
        if ((tree$1 !== null)) {
          var this$5 = $n(tree$1);
          var $x_3 = (this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0);
        } else {
          var $x_3 = false;
        }
      } else {
        var $x_3 = false;
      }
      if ($x_3) {
        var this$6 = $n(tl);
        var $x_7 = $n(this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
        var this$7 = $n(tl);
        var $x_6 = $n(this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left).red__sci_RedBlackTree$Tree();
        var this$8 = $n(tl);
        var this$9 = $n(this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
        var $x_5 = $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl, $x_6, this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        var this$10 = $n(tl);
        var this$11 = $n(this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
        return $n($x_7).redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($x_5, $n(tree).blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$11.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr));
      } else {
        $m_s_sys_package$().error__T__E("Defect: invariance violation");
      }
    }
  }
}
function $p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl, tr) {
  if ((tl === null)) {
    return tr;
  } else if ((tr === null)) {
    return tl;
  } else {
    var this$1 = $n(tl);
    if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
      var this$2 = $n(tr);
      if ((this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
        var this$3 = $n(tl);
        var $x_1 = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
        var this$4 = $n(tr);
        var bc = $p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, $x_1, this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        if ((bc !== null)) {
          var this$5 = $n(bc);
          var $x_2 = (this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
        } else {
          var $x_2 = false;
        }
        if ($x_2) {
          var $x_5 = $n(bc);
          var $x_4 = $n(tl);
          var this$6 = $n(bc);
          var $x_3 = $n($x_4).withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
          var this$7 = $n(bc);
          return $n($x_5).withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($x_3, $n(tr).withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right));
        } else {
          return $n(tl).withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($n(tr).withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(bc));
        }
      } else {
        var $x_6 = $n(tl);
        var this$8 = $n(tl);
        return $n($x_6).withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr));
      }
    } else {
      var this$9 = $n(tr);
      if ((this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)) {
        var this$10 = $n(tl);
        var $x_7 = this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
        var this$11 = $n(tr);
        var bc$2 = $p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, $x_7, this$11.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        if ((bc$2 !== null)) {
          var this$12 = $n(bc$2);
          var $x_8 = (this$12.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
        } else {
          var $x_8 = false;
        }
        if ($x_8) {
          var $x_11 = $n(bc$2);
          var $x_10 = $n(tl);
          var this$13 = $n(bc$2);
          var $x_9 = $n($x_10).withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$13.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
          var this$14 = $n(bc$2);
          return $n($x_11).withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($x_9, $n(tr).withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$14.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right));
        } else {
          var this$15 = $n(tl);
          return $p_sci_RedBlackTree$__balLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl, this$15.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, $n(tr).withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(bc$2));
        }
      } else {
        var $x_12 = $n(tr);
        var this$16 = $n(tr);
        return $n($x_12).withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl, this$16.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left));
      }
    }
  }
}
function $p_sci_RedBlackTree$__joinRight__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree($thiz, tl, k, v, tr, bhtl, rtr) {
  if ((tl === null)) {
    var rtl = 0;
  } else {
    var this$1 = $n(tl);
    if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)) {
      var rtl = ((((-1) + bhtl) | 0) << 1);
    } else {
      var rtl = (((-1) + (bhtl << 1)) | 0);
    }
  }
  if ((rtl === (((rtr / 2) | 0) << 1))) {
    return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(k, v, tl, tr);
  } else {
    if ((tl !== null)) {
      var this$2 = $n(tl);
      var tlBlack = (this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0);
    } else {
      var tlBlack = false;
    }
    var bhtlr = (tlBlack ? (((-1) + bhtl) | 0) : bhtl);
    var this$3 = $n(tl);
    var ttr = $p_sci_RedBlackTree$__joinRight__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree($thiz, this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k, v, tr, bhtlr, rtr);
    if (tlBlack) {
      if ((ttr !== null)) {
        var this$4 = $n(ttr);
        var $x_2 = (this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
      } else {
        var $x_2 = false;
      }
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var this$5 = $n(ttr);
      var tree = this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      if ((tree !== null)) {
        var this$6 = $n(tree);
        var $x_1 = (this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
      } else {
        var $x_1 = false;
      }
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var this$7 = $n(ttr);
      var $x_8 = this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
      var this$8 = $n(ttr);
      var $x_7 = this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
      var this$9 = $n(tl);
      var $x_6 = this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
      var this$10 = $n(tl);
      var $x_5 = this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
      var this$11 = $n(tl);
      var $x_4 = this$11.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var this$12 = $n(ttr);
      var $x_3 = $thiz.BlackTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($x_6, $x_5, $x_4, this$12.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      var this$13 = $n(ttr);
      return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($x_8, $x_7, $x_3, $n(this$13.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right).black__sci_RedBlackTree$Tree());
    } else {
      var this$14 = $n(tl);
      var $x_10 = this$14.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
      var this$15 = $n(tl);
      var $x_9 = this$15.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
      var this$16 = $n(tl);
      return $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tlBlack, $x_10, $x_9, this$16.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, ttr);
    }
  }
}
function $p_sci_RedBlackTree$__joinLeft__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree($thiz, tl, k, v, tr, rtl, bhtr) {
  if ((tr === null)) {
    var rtr = 0;
  } else {
    var this$1 = $n(tr);
    if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)) {
      var rtr = ((((-1) + bhtr) | 0) << 1);
    } else {
      var rtr = (((-1) + (bhtr << 1)) | 0);
    }
  }
  if ((rtr === (((rtl / 2) | 0) << 1))) {
    return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(k, v, tl, tr);
  } else {
    if ((tr !== null)) {
      var this$2 = $n(tr);
      var trBlack = (this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0);
    } else {
      var trBlack = false;
    }
    var bhtrl = (trBlack ? (((-1) + bhtr) | 0) : bhtr);
    var this$3 = $n(tr);
    var ttl = $p_sci_RedBlackTree$__joinLeft__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree($thiz, tl, k, v, this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, rtl, bhtrl);
    if (trBlack) {
      if ((ttl !== null)) {
        var this$4 = $n(ttl);
        var $x_2 = (this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
      } else {
        var $x_2 = false;
      }
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var this$5 = $n(ttl);
      var tree = this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      if ((tree !== null)) {
        var this$6 = $n(tree);
        var $x_1 = (this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
      } else {
        var $x_1 = false;
      }
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var this$7 = $n(ttl);
      var $x_8 = this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
      var this$8 = $n(ttl);
      var $x_7 = this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
      var this$9 = $n(ttl);
      var $x_6 = $n(this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left).black__sci_RedBlackTree$Tree();
      var this$10 = $n(tr);
      var $x_5 = this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
      var this$11 = $n(tr);
      var $x_4 = this$11.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
      var this$12 = $n(ttl);
      var $x_3 = this$12.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var this$13 = $n(tr);
      return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($x_8, $x_7, $x_6, $thiz.BlackTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($x_5, $x_4, $x_3, this$13.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right));
    } else {
      var this$14 = $n(tr);
      var $x_10 = this$14.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
      var this$15 = $n(tr);
      var $x_9 = this$15.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
      var this$16 = $n(tr);
      return $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, trBlack, $x_10, $x_9, ttl, this$16.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
    }
  }
}
function $p_sci_RedBlackTree$__split__sci_RedBlackTree$Tree__O__s_math_Ordering__T4($thiz, t, k2, ordering) {
  if ((t === null)) {
    return new $c_T4(null, null, null, k2);
  } else {
    var $x_1 = $n(ordering);
    var this$1 = $n(t);
    var cmp = $n($x_1).compare__O__O__I(k2, this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
    if ((cmp === 0)) {
      var this$2 = $n(t);
      var $x_3 = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var this$3 = $n(t);
      var $x_2 = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var this$4 = $n(t);
      return new $c_T4($x_3, t, $x_2, this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
    } else if ((cmp < 0)) {
      var this$5 = $n(t);
      var x1 = $p_sci_RedBlackTree$__split__sci_RedBlackTree$Tree__O__s_math_Ordering__T4($thiz, this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, k2, ordering);
      if ((x1 === null)) {
        throw new $c_s_MatchError(x1);
      }
      var ll = $as_sci_RedBlackTree$Tree($n(x1).T4__f__1);
      var b = $as_sci_RedBlackTree$Tree($n(x1).T4__f__2);
      var lr = $as_sci_RedBlackTree$Tree($n(x1).T4__f__3);
      var k1 = $n(x1).T4__f__4;
      var this$6 = $n(t);
      var $x_5 = this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
      var this$7 = $n(t);
      var $x_4 = this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
      var this$8 = $n(t);
      return new $c_T4(ll, b, $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(lr, $x_5, $x_4, this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right), k1);
    } else {
      var this$9 = $n(t);
      var x1$2 = $p_sci_RedBlackTree$__split__sci_RedBlackTree$Tree__O__s_math_Ordering__T4($thiz, this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k2, ordering);
      if ((x1$2 === null)) {
        throw new $c_s_MatchError(x1$2);
      }
      var rl = $as_sci_RedBlackTree$Tree($n(x1$2).T4__f__1);
      var b$3 = $as_sci_RedBlackTree$Tree($n(x1$2).T4__f__2);
      var rr = $as_sci_RedBlackTree$Tree($n(x1$2).T4__f__3);
      var k1$3 = $n(x1$2).T4__f__4;
      var this$10 = $n(t);
      var $x_7 = this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var this$11 = $n(t);
      var $x_6 = this$11.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
      var this$12 = $n(t);
      return new $c_T4($thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($x_7, $x_6, this$12.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, rl), b$3, rr, k1$3);
    }
  }
}
function $p_sci_RedBlackTree$__splitLast__sci_RedBlackTree$Tree__T3($thiz, t) {
  var this$1 = $n(t);
  if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right === null)) {
    var this$2 = $n(t);
    var $x_2 = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    var this$3 = $n(t);
    var $x_1 = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
    var this$4 = $n(t);
    return new $c_T3($x_2, $x_1, this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value);
  } else {
    var this$5 = $n(t);
    var x1 = $p_sci_RedBlackTree$__splitLast__sci_RedBlackTree$Tree__T3($thiz, this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var tt = $as_sci_RedBlackTree$Tree($n(x1).T3__f__1);
    var kk = $n(x1).T3__f__2;
    var vv = $n(x1).T3__f__3;
    var this$6 = $n(t);
    var $x_4 = this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    var this$7 = $n(t);
    var $x_3 = this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
    var this$8 = $n(t);
    return new $c_T3($thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($x_4, $x_3, this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, tt), kk, vv);
  }
}
function $p_sci_RedBlackTree$___union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree($thiz, t1, t2, ordering) {
  if (((t1 === null) || (t1 === t2))) {
    return t2;
  } else if ((t2 === null)) {
    return t1;
  } else {
    var this$1 = $n(t2);
    var x1 = $p_sci_RedBlackTree$__split__sci_RedBlackTree$Tree__O__s_math_Ordering__T4($thiz, t1, this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, ordering);
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var l1 = $as_sci_RedBlackTree$Tree($n(x1).T4__f__1);
    var r1 = $as_sci_RedBlackTree$Tree($n(x1).T4__f__3);
    var k1 = $n(x1).T4__f__4;
    var this$2 = $n(t2);
    var tl = $p_sci_RedBlackTree$___union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree($thiz, l1, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, ordering);
    var this$3 = $n(t2);
    var tr = $p_sci_RedBlackTree$___union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree($thiz, r1, this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ordering);
    var this$4 = $n(t2);
    return $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, k1, this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, tr);
  }
}
function $p_sci_RedBlackTree$___tail$1__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree) {
  if ((tree === null)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty tree");
  } else {
    var this$1 = $n(tree);
    var tl = this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    if ((tl === null)) {
      var this$2 = $n(tree);
      return this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    } else {
      var this$3 = $n(tl);
      if ((this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)) {
        var $x_1 = $p_sci_RedBlackTree$___tail$1__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl);
        var this$4 = $n(tree);
        return $p_sci_RedBlackTree$__balLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, $x_1, this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
      } else {
        var $x_2 = $n(tree);
        var this$5 = $n(tree);
        return $n($x_2).redWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($p_sci_RedBlackTree$___tail$1__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left));
      }
    }
  }
}
function $p_sci_RedBlackTree$__f$1__I__I__I__sc_Iterator__sci_RedBlackTree$Tree($thiz, level, size, maxUsedDepth$1, xs$1) {
  switch (size) {
    case 0: {
      return null;
      break;
    }
    case 1: {
      return $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, ((level !== maxUsedDepth$1) || (level === 1)), $n(xs$1).next__O(), null, null, null);
      break;
    }
    default: {
      var leftSize = (((((-1) + size) | 0) / 2) | 0);
      var left = $p_sci_RedBlackTree$__f$1__I__I__I__sc_Iterator__sci_RedBlackTree$Tree($thiz, ((1 + level) | 0), leftSize, maxUsedDepth$1, xs$1);
      var x = $n(xs$1).next__O();
      var right = $p_sci_RedBlackTree$__f$1__I__I__I__sc_Iterator__sci_RedBlackTree$Tree($thiz, ((1 + level) | 0), (((((-1) + size) | 0) - leftSize) | 0), maxUsedDepth$1, xs$1);
      return $thiz.BlackTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(x, null, left, right);
    }
  }
}
function $p_sci_RedBlackTree$__fk$1__sci_RedBlackTree$Tree__F2__sci_RedBlackTree$Tree($thiz, t, f$3) {
  var this$1 = $n(t);
  var k = this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
  var this$2 = $n(t);
  var v = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
  var this$3 = $n(t);
  var l = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
  var this$4 = $n(t);
  var r = this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
  var l2 = ((l === null) ? null : $p_sci_RedBlackTree$__fk$1__sci_RedBlackTree$Tree__F2__sci_RedBlackTree$Tree($thiz, l, f$3));
  var keep = $uZ($n(f$3).apply__O__O__O(k, v));
  var r2 = ((r === null) ? null : $p_sci_RedBlackTree$__fk$1__sci_RedBlackTree$Tree__F2__sci_RedBlackTree$Tree($thiz, r, f$3));
  return ((!keep) ? $thiz.scala$collection$immutable$RedBlackTree$$join2__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(l2, r2) : (((l2 === l) && (r2 === r)) ? t : $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(l2, k, v, r2)));
}
function $p_sci_RedBlackTree$__partitioner$lzycompute$1__sr_LazyRef__F2__sci_RedBlackTree$partitioner$1$($thiz, partitioner$module$1, p$1) {
  $n(partitioner$module$1);
  return ($n(partitioner$module$1).sr_LazyRef__f__initialized ? $as_sci_RedBlackTree$partitioner$1$($n(partitioner$module$1).sr_LazyRef__f__value) : $as_sci_RedBlackTree$partitioner$1$($n(partitioner$module$1).initialize__O__O(new $c_sci_RedBlackTree$partitioner$1$(p$1))));
}
function $p_sci_RedBlackTree$__partitioner$2__sr_LazyRef__F2__sci_RedBlackTree$partitioner$1$($thiz, partitioner$module$1, p$1) {
  return ($n(partitioner$module$1).sr_LazyRef__f__initialized ? $as_sci_RedBlackTree$partitioner$1$($n(partitioner$module$1).sr_LazyRef__f__value) : $p_sci_RedBlackTree$__partitioner$lzycompute$1__sr_LazyRef__F2__sci_RedBlackTree$partitioner$1$($thiz, partitioner$module$1, p$1));
}
function $p_sci_RedBlackTree$__h$1__sci_RedBlackTree$Tree__I__I($thiz, t, i) {
  while (true) {
    if ((t === null)) {
      return ((1 + i) | 0);
    } else {
      var this$1 = $n(t);
      var temp$t = this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var this$2 = $n(t);
      if ((this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)) {
        var temp$i = ((1 + i) | 0);
      } else {
        var temp$i = i;
      }
      t = temp$t;
      i = temp$i;
    }
  }
}
/** @constructor */
function $c_sci_RedBlackTree$() {
  this.sci_RedBlackTree$__f_null2 = null;
  $n_sci_RedBlackTree$ = this;
  this.sci_RedBlackTree$__f_null2 = new $c_T2(null, null);
}
$c_sci_RedBlackTree$.prototype = new $h_O();
$c_sci_RedBlackTree$.prototype.constructor = $c_sci_RedBlackTree$;
/** @constructor */
function $h_sci_RedBlackTree$() {
}
$h_sci_RedBlackTree$.prototype = $c_sci_RedBlackTree$.prototype;
$c_sci_RedBlackTree$.prototype.contains__sci_RedBlackTree$Tree__O__s_math_Ordering__Z = (function(tree, x, evidence$1) {
  return (this.lookup__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree(tree, x, evidence$1) !== null);
});
$c_sci_RedBlackTree$.prototype.lookup__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree = (function(tree, x, ordering) {
  while (true) {
    if ((tree === null)) {
      return null;
    } else {
      var $x_1 = $n(ordering);
      var this$1 = $n(tree);
      var cmp = $n($x_1).compare__O__O__I(x, this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
      if ((cmp < 0)) {
        var this$2 = $n(tree);
        tree = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      } else if ((cmp > 0)) {
        var this$3 = $n(tree);
        tree = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      } else {
        return tree;
      }
    }
  }
});
$c_sci_RedBlackTree$.prototype.count__sci_RedBlackTree$Tree__I = (function(tree) {
  if ((tree === null)) {
    return 0;
  } else {
    var this$1 = $n(tree);
    return (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count);
  }
});
$c_sci_RedBlackTree$.prototype.update__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree = (function(tree, k, v, overwrite, evidence$3) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$__upd__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree(this, tree, k, v, overwrite, evidence$3));
});
$c_sci_RedBlackTree$.prototype.delete__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree = (function(tree, k, evidence$4) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$__del__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree(this, tree, k, evidence$4));
});
$c_sci_RedBlackTree$.prototype.drop__sci_RedBlackTree$Tree__I__s_math_Ordering__sci_RedBlackTree$Tree = (function(tree, n, evidence$10) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$__doDrop__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree(this, tree, n));
});
$c_sci_RedBlackTree$.prototype.take__sci_RedBlackTree$Tree__I__s_math_Ordering__sci_RedBlackTree$Tree = (function(tree, n, evidence$11) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$__doTake__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree(this, tree, n));
});
$c_sci_RedBlackTree$.prototype.smallest__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree) {
  if ((tree === null)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty tree");
  }
  var result = tree;
  while (true) {
    var this$1 = $n(result);
    if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left !== null)) {
      var this$2 = $n(result);
      result = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    } else {
      break;
    }
  }
  return result;
});
$c_sci_RedBlackTree$.prototype.greatest__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree) {
  if ((tree === null)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty tree");
  }
  var result = tree;
  while (true) {
    var this$1 = $n(result);
    if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right !== null)) {
      var this$2 = $n(result);
      result = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    } else {
      break;
    }
  }
  return result;
});
$c_sci_RedBlackTree$.prototype.tail__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$___tail$1__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, tree));
});
$c_sci_RedBlackTree$.prototype.keysEqual__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__Z = (function(a, b, evidence$13) {
  if ((a === b)) {
    return true;
  } else if ((a !== null)) {
    if ((b !== null)) {
      var this$1 = $n(a);
      var $x_1 = this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count;
      var this$2 = $n(b);
      if (((2147483647 & $x_1) === (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) {
        return new $c_sci_RedBlackTree$EqualsIterator(a, evidence$13).sameKeys__sci_RedBlackTree$EqualsIterator__Z(new $c_sci_RedBlackTree$EqualsIterator(b, evidence$13));
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_sci_RedBlackTree$.prototype.foreachKey__sci_RedBlackTree$Tree__F1__V = (function(tree, f) {
  if ((tree !== null)) {
    $p_sci_RedBlackTree$___foreachKey__sci_RedBlackTree$Tree__F1__V(this, tree, f);
  }
});
$c_sci_RedBlackTree$.prototype.isBlack__sci_RedBlackTree$Tree__Z = (function(tree) {
  if ((tree === null)) {
    return true;
  } else {
    var this$1 = $n(tree);
    return (this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0);
  }
});
$c_sci_RedBlackTree$.prototype.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(key, value, left, right) {
  if ((left === null)) {
    var $x_2 = 0;
  } else {
    var this$1 = $n(left);
    var $x_2 = (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count);
  }
  if ((right === null)) {
    var $x_1 = 0;
  } else {
    var this$2 = $n(right);
    var $x_1 = (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count);
  }
  var size = ((1 + (($x_2 + $x_1) | 0)) | 0);
  return new $c_sci_RedBlackTree$Tree(key, value, left, right, size);
});
$c_sci_RedBlackTree$.prototype.BlackTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(key, value, left, right) {
  if ((left === null)) {
    var $x_2 = 0;
  } else {
    var this$1 = $n(left);
    var $x_2 = (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count);
  }
  if ((right === null)) {
    var $x_1 = 0;
  } else {
    var this$2 = $n(right);
    var $x_1 = (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count);
  }
  var size = ((1 + (($x_2 + $x_1) | 0)) | 0);
  return new $c_sci_RedBlackTree$Tree(key, value, left, right, ((-2147483648) | size));
});
$c_sci_RedBlackTree$.prototype.fromOrderedKeys__sc_Iterator__I__sci_RedBlackTree$Tree = (function(xs, size) {
  var maxUsedDepth = ((32 - $uI(Math.clz32(size))) | 0);
  return $p_sci_RedBlackTree$__f$1__I__I__I__sc_Iterator__sci_RedBlackTree$Tree(this, 1, size, maxUsedDepth, xs);
});
$c_sci_RedBlackTree$.prototype.filterEntries__sci_RedBlackTree$Tree__F2__sci_RedBlackTree$Tree = (function(t, f) {
  return ((t === null) ? null : $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$__fk$1__sci_RedBlackTree$Tree__F2__sci_RedBlackTree$Tree(this, t, f)));
});
$c_sci_RedBlackTree$.prototype.partitionEntries__sci_RedBlackTree$Tree__F2__T2 = (function(t, p) {
  if ((t === null)) {
    return new $c_T2(null, null);
  } else if ((t === null)) {
    return this.sci_RedBlackTree$__f_null2;
  } else {
    var partitioner$module = new $c_sr_LazyRef();
    $n($p_sci_RedBlackTree$__partitioner$2__sr_LazyRef__F2__sci_RedBlackTree$partitioner$1$(this, partitioner$module, p)).fk__sci_RedBlackTree$Tree__V(t);
    return new $c_T2($p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $n($p_sci_RedBlackTree$__partitioner$2__sr_LazyRef__F2__sci_RedBlackTree$partitioner$1$(this, partitioner$module, p)).sci_RedBlackTree$partitioner$1$__f_tmpk), $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $n($p_sci_RedBlackTree$__partitioner$2__sr_LazyRef__F2__sci_RedBlackTree$partitioner$1$(this, partitioner$module, p)).sci_RedBlackTree$partitioner$1$__f_tmpd));
  }
});
$c_sci_RedBlackTree$.prototype.union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree = (function(t1, t2, ordering) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$___union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this, t1, t2, ordering));
});
$c_sci_RedBlackTree$.prototype.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tl, k, v, tr) {
  var bhtl = $p_sci_RedBlackTree$__h$1__sci_RedBlackTree$Tree__I__I(this, tl, 0);
  var bhtr = $p_sci_RedBlackTree$__h$1__sci_RedBlackTree$Tree__I__I(this, tr, 0);
  if ((bhtl > bhtr)) {
    if ((tr === null)) {
      var $x_1 = 0;
    } else {
      var this$1 = $n(tr);
      if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)) {
        var $x_1 = ((((-1) + bhtr) | 0) << 1);
      } else {
        var $x_1 = (((-1) + (bhtr << 1)) | 0);
      }
    }
    var tt = $p_sci_RedBlackTree$__joinRight__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree(this, tl, k, v, tr, bhtl, $x_1);
    if ((tt !== null)) {
      var this$2 = $n(tt);
      var $x_3 = (this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var this$3 = $n(tt);
      var tree = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      if ((tree !== null)) {
        var this$4 = $n(tree);
        var $x_2 = (this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
      } else {
        var $x_2 = false;
      }
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      return $n(tt).black__sci_RedBlackTree$Tree();
    } else {
      return tt;
    }
  } else if ((bhtr > bhtl)) {
    if ((tl === null)) {
      var $x_4 = 0;
    } else {
      var this$5 = $n(tl);
      if ((this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)) {
        var $x_4 = ((((-1) + bhtl) | 0) << 1);
      } else {
        var $x_4 = (((-1) + (bhtl << 1)) | 0);
      }
    }
    var tt$2 = $p_sci_RedBlackTree$__joinLeft__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree(this, tl, k, v, tr, $x_4, bhtr);
    if ((tt$2 !== null)) {
      var this$6 = $n(tt$2);
      var $x_6 = (this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var this$7 = $n(tt$2);
      var tree$1 = this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      if ((tree$1 !== null)) {
        var this$8 = $n(tree$1);
        var $x_5 = (this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
      } else {
        var $x_5 = false;
      }
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      return $n(tt$2).black__sci_RedBlackTree$Tree();
    } else {
      return tt$2;
    }
  } else {
    if ((tl !== null)) {
      var this$9 = $n(tl);
      var $x_8 = (this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var $x_7 = true;
    } else if ((tr !== null)) {
      var this$10 = $n(tr);
      var $x_7 = (this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
    } else {
      var $x_7 = false;
    }
    return $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $x_7, k, v, tl, tr);
  }
});
$c_sci_RedBlackTree$.prototype.scala$collection$immutable$RedBlackTree$$join2__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tl, tr) {
  if ((tl === null)) {
    return tr;
  } else if ((tr === null)) {
    return tl;
  } else {
    var x1 = $p_sci_RedBlackTree$__splitLast__sci_RedBlackTree$Tree__T3(this, tl);
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var ttl = $as_sci_RedBlackTree$Tree($n(x1).T3__f__1);
    var k = $n(x1).T3__f__2;
    var v = $n(x1).T3__f__3;
    return this.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(ttl, k, v, tr);
  }
});
var $d_sci_RedBlackTree$ = new $TypeData().initClass($c_sci_RedBlackTree$, "scala.collection.immutable.RedBlackTree$", ({
  sci_RedBlackTree$: 1
}));
var $n_sci_RedBlackTree$;
function $m_sci_RedBlackTree$() {
  if ((!$n_sci_RedBlackTree$)) {
    $n_sci_RedBlackTree$ = new $c_sci_RedBlackTree$();
  }
  return $n_sci_RedBlackTree$;
}
function $ct_sci_RedBlackTree$Helper__s_math_Ordering__($thiz, ordering) {
  $thiz.sci_RedBlackTree$Helper__f_ordering = ordering;
  return $thiz;
}
/** @constructor */
function $c_sci_RedBlackTree$Helper() {
  this.sci_RedBlackTree$Helper__f_ordering = null;
}
$c_sci_RedBlackTree$Helper.prototype = new $h_O();
$c_sci_RedBlackTree$Helper.prototype.constructor = $c_sci_RedBlackTree$Helper;
/** @constructor */
function $h_sci_RedBlackTree$Helper() {
}
$h_sci_RedBlackTree$Helper.prototype = $c_sci_RedBlackTree$Helper.prototype;
$c_sci_RedBlackTree$Helper.prototype.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree) {
  if ((tree === null)) {
    return tree;
  } else {
    var this$1 = $n(tree);
    if (((2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
      var res = $n($n(tree).mutableBlack__sci_RedBlackTree$Tree()).makeImmutable__sci_RedBlackTree$Tree();
      return res;
    } else {
      return $n(tree).black__sci_RedBlackTree$Tree();
    }
  }
});
$c_sci_RedBlackTree$Helper.prototype.mutableBalanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree, newLeft) {
  var this$1 = $n(newLeft);
  if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
    var this$2 = $n(newLeft);
    var newLeft_left = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    var this$3 = $n(newLeft);
    var newLeft_right = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    if ((newLeft_left !== null)) {
      var this$5 = $n(newLeft_left);
      var $x_1 = (this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var resultLeft = $n(newLeft_left).mutableBlack__sci_RedBlackTree$Tree();
      var resultRight = $n(tree).mutableBlackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft_right);
      return $n(newLeft).mutableWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft, resultRight);
    } else {
      if ((newLeft_right !== null)) {
        var this$7 = $n(newLeft_right);
        var $x_2 = (this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        var this$8 = $n(newLeft_right);
        var newLeft_right_right = this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
        var $x_3 = $n(newLeft);
        var this$9 = $n(newLeft_right);
        var resultLeft$2 = $n($x_3).mutableBlackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        var resultRight$2 = $n(tree).mutableBlackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft_right_right);
        return $n(newLeft_right).mutableWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft$2, resultRight$2);
      } else {
        return $n(tree).mutableWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft);
      }
    }
  } else {
    return $n(tree).mutableWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft);
  }
});
$c_sci_RedBlackTree$Helper.prototype.mutableBalanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree, newRight) {
  var this$1 = $n(newRight);
  if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
    var this$2 = $n(newRight);
    var newRight_left = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    if ((newRight_left !== null)) {
      var this$4 = $n(newRight_left);
      var $x_1 = (this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var $x_2 = $n(tree);
      var this$5 = $n(newRight_left);
      var resultLeft = $n($x_2).mutableBlackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      var $x_3 = $n(newRight);
      var this$6 = $n(newRight_left);
      var resultRight = $n($x_3).mutableBlackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
      return $n(newRight_left).mutableWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft, resultRight);
    } else {
      var this$7 = $n(newRight);
      var newRight_right = this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      if ((newRight_right !== null)) {
        var this$9 = $n(newRight_right);
        var $x_4 = (this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0);
      } else {
        var $x_4 = false;
      }
      if ($x_4) {
        var resultLeft$2 = $n(tree).mutableBlackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight_left);
        var resultRight$2 = $n(newRight_right).mutableBlack__sci_RedBlackTree$Tree();
        return $n(newRight).mutableWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft$2, resultRight$2);
      } else {
        return $n(tree).mutableWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight);
      }
    }
  } else {
    return $n(tree).mutableWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight);
  }
});
function $p_sci_RedBlackTree$Tree__makeImmutableImpl$1__V($thiz) {
  if (((2147483647 & $thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    var size = 1;
    if (($thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left !== null)) {
      $n($thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left).makeImmutable__sci_RedBlackTree$Tree();
      var $x_1 = size;
      var this$1 = $n($thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      size = (($x_1 + (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) | 0);
    }
    if (($thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right !== null)) {
      $n($thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right).makeImmutable__sci_RedBlackTree$Tree();
      var $x_2 = size;
      var this$2 = $n($thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
      size = (($x_2 + (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) | 0);
    }
    $thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = ($thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count | size);
  }
}
/** @constructor */
function $c_sci_RedBlackTree$Tree(_key, _value, _left, _right, _count) {
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key = null;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value = null;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left = null;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right = null;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = 0;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key = _key;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value = _value;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left = _left;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right = _right;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = _count;
}
$c_sci_RedBlackTree$Tree.prototype = new $h_O();
$c_sci_RedBlackTree$Tree.prototype.constructor = $c_sci_RedBlackTree$Tree;
/** @constructor */
function $h_sci_RedBlackTree$Tree() {
}
$h_sci_RedBlackTree$Tree.prototype = $c_sci_RedBlackTree$Tree.prototype;
$c_sci_RedBlackTree$Tree.prototype.toString__T = (function() {
  return (((((((((((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0) ? "RedTree" : "BlackTree") + "(") + this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key) + ", ") + this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value) + ", ") + this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) + ", ") + this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right) + ")");
});
$c_sci_RedBlackTree$Tree.prototype.makeImmutable__sci_RedBlackTree$Tree = (function() {
  $p_sci_RedBlackTree$Tree__makeImmutableImpl$1__V(this);
  return this;
});
$c_sci_RedBlackTree$Tree.prototype.mutableBlack__sci_RedBlackTree$Tree = (function() {
  if ((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)) {
    return this;
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = (-2147483648);
    return this;
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, (-2147483648));
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft) {
  if ((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left === newLeft)) {
    return this;
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left = newLeft;
    return this;
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count));
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newRight) {
  if ((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right === newRight)) {
    return this;
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right = newRight;
    return this;
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight, ((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count));
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft, newRight) {
  if (((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left === newLeft) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right === newRight))) {
    return this;
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left = newLeft;
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right = newRight;
    return this;
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, newRight, ((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count));
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableBlackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft) {
  if (((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left === newLeft) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return this;
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = (-2147483648);
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left = newLeft;
    return this;
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, (-2147483648));
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableBlackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newRight) {
  if (((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right === newRight) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return this;
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = (-2147483648);
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right = newRight;
    return this;
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight, (-2147483648));
  }
});
$c_sci_RedBlackTree$Tree.prototype.black__sci_RedBlackTree$Tree = (function() {
  return ((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0) ? this : new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ((-2147483648) ^ this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)));
});
$c_sci_RedBlackTree$Tree.prototype.red__sci_RedBlackTree$Tree = (function() {
  return ((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0) ? this : new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ((-2147483648) ^ this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)));
});
$c_sci_RedBlackTree$Tree.prototype.withV__O__sci_RedBlackTree$Tree = (function(newValue) {
  return (Object.is(newValue, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value) ? this : new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, newValue, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count));
});
$c_sci_RedBlackTree$Tree.prototype.withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft) {
  if ((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left)) {
    return this;
  } else {
    if ((newLeft === null)) {
      var $x_2 = 0;
    } else {
      var this$1 = $n(newLeft);
      var $x_2 = (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count);
    }
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    if ((tree === null)) {
      var $x_1 = 0;
    } else {
      var this$2 = $n(tree);
      var $x_1 = (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count);
    }
    var size = ((1 + (($x_2 + $x_1) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, (((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) | size));
  }
});
$c_sci_RedBlackTree$Tree.prototype.withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newRight) {
  if ((newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)) {
    return this;
  } else {
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    if ((tree === null)) {
      var $x_2 = 0;
    } else {
      var this$1 = $n(tree);
      var $x_2 = (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count);
    }
    if ((newRight === null)) {
      var $x_1 = 0;
    } else {
      var this$2 = $n(newRight);
      var $x_1 = (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count);
    }
    var size = ((1 + (($x_2 + $x_1) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight, (((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) | size));
  }
});
$c_sci_RedBlackTree$Tree.prototype.blackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft) {
  if (((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return this;
  } else {
    if ((newLeft === null)) {
      var $x_2 = 0;
    } else {
      var this$1 = $n(newLeft);
      var $x_2 = (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count);
    }
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    if ((tree === null)) {
      var $x_1 = 0;
    } else {
      var this$2 = $n(tree);
      var $x_1 = (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count);
    }
    var size = ((1 + (($x_2 + $x_1) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ((-2147483648) | size));
  }
});
$c_sci_RedBlackTree$Tree.prototype.redWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft) {
  if (((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    return this;
  } else {
    if ((newLeft === null)) {
      var $x_2 = 0;
    } else {
      var this$1 = $n(newLeft);
      var $x_2 = (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count);
    }
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    if ((tree === null)) {
      var $x_1 = 0;
    } else {
      var this$2 = $n(tree);
      var $x_1 = (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count);
    }
    var size = ((1 + (($x_2 + $x_1) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, size);
  }
});
$c_sci_RedBlackTree$Tree.prototype.blackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newRight) {
  if (((newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return this;
  } else {
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    if ((tree === null)) {
      var $x_2 = 0;
    } else {
      var this$1 = $n(tree);
      var $x_2 = (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count);
    }
    if ((newRight === null)) {
      var $x_1 = 0;
    } else {
      var this$2 = $n(newRight);
      var $x_1 = (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count);
    }
    var size = ((1 + (($x_2 + $x_1) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight, ((-2147483648) | size));
  }
});
$c_sci_RedBlackTree$Tree.prototype.redWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newRight) {
  if (((newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    return this;
  } else {
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    if ((tree === null)) {
      var $x_2 = 0;
    } else {
      var this$1 = $n(tree);
      var $x_2 = (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count);
    }
    if ((newRight === null)) {
      var $x_1 = 0;
    } else {
      var this$2 = $n(newRight);
      var $x_1 = (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count);
    }
    var size = ((1 + (($x_2 + $x_1) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight, size);
  }
});
$c_sci_RedBlackTree$Tree.prototype.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft, newRight) {
  if (((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) && (newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right))) {
    return this;
  } else {
    if ((newLeft === null)) {
      var $x_2 = 0;
    } else {
      var this$1 = $n(newLeft);
      var $x_2 = (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count);
    }
    if ((newRight === null)) {
      var $x_1 = 0;
    } else {
      var this$2 = $n(newRight);
      var $x_1 = (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count);
    }
    var size = ((1 + (($x_2 + $x_1) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, newRight, (((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) | size));
  }
});
$c_sci_RedBlackTree$Tree.prototype.redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft, newRight) {
  if ((((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) && (newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    return this;
  } else {
    if ((newLeft === null)) {
      var $x_2 = 0;
    } else {
      var this$1 = $n(newLeft);
      var $x_2 = (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count);
    }
    if ((newRight === null)) {
      var $x_1 = 0;
    } else {
      var this$2 = $n(newRight);
      var $x_1 = (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count);
    }
    var size = ((1 + (($x_2 + $x_1) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, newRight, size);
  }
});
$c_sci_RedBlackTree$Tree.prototype.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft, newRight) {
  if ((((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) && (newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return this;
  } else {
    if ((newLeft === null)) {
      var $x_2 = 0;
    } else {
      var this$1 = $n(newLeft);
      var $x_2 = (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count);
    }
    if ((newRight === null)) {
      var $x_1 = 0;
    } else {
      var this$2 = $n(newRight);
      var $x_1 = (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count);
    }
    var size = ((1 + (($x_2 + $x_1) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, newRight, ((-2147483648) | size));
  }
});
function $as_sci_RedBlackTree$Tree(obj) {
  return (((obj instanceof $c_sci_RedBlackTree$Tree) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.RedBlackTree$Tree"));
}
function $isArrayOf_sci_RedBlackTree$Tree(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_RedBlackTree$Tree)));
}
function $asArrayOf_sci_RedBlackTree$Tree(obj, depth) {
  return (($isArrayOf_sci_RedBlackTree$Tree(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.RedBlackTree$Tree;", depth));
}
var $d_sci_RedBlackTree$Tree = new $TypeData().initClass($c_sci_RedBlackTree$Tree, "scala.collection.immutable.RedBlackTree$Tree", ({
  sci_RedBlackTree$Tree: 1
}));
/** @constructor */
function $c_sci_RedBlackTree$partitioner$1$(p$1) {
  this.sci_RedBlackTree$partitioner$1$__f_tmpk = null;
  this.sci_RedBlackTree$partitioner$1$__f_tmpd = null;
  this.sci_RedBlackTree$partitioner$1$__f_p$1 = null;
  this.sci_RedBlackTree$partitioner$1$__f_p$1 = p$1;
  this.sci_RedBlackTree$partitioner$1$__f_tmpk = null;
  this.sci_RedBlackTree$partitioner$1$__f_tmpd = null;
}
$c_sci_RedBlackTree$partitioner$1$.prototype = new $h_O();
$c_sci_RedBlackTree$partitioner$1$.prototype.constructor = $c_sci_RedBlackTree$partitioner$1$;
/** @constructor */
function $h_sci_RedBlackTree$partitioner$1$() {
}
$h_sci_RedBlackTree$partitioner$1$.prototype = $c_sci_RedBlackTree$partitioner$1$.prototype;
$c_sci_RedBlackTree$partitioner$1$.prototype.fk__sci_RedBlackTree$Tree__V = (function(t) {
  var this$1 = $n(t);
  var k = this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
  var this$2 = $n(t);
  var v = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
  var this$3 = $n(t);
  var l = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
  var this$4 = $n(t);
  var r = this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
  var l2k = null;
  var l2d = null;
  var r2k = null;
  var r2d = null;
  if ((l !== null)) {
    this.fk__sci_RedBlackTree$Tree__V(l);
    l2k = this.sci_RedBlackTree$partitioner$1$__f_tmpk;
    l2d = this.sci_RedBlackTree$partitioner$1$__f_tmpd;
  }
  var keep = $uZ($n(this.sci_RedBlackTree$partitioner$1$__f_p$1).apply__O__O__O(k, v));
  if ((r !== null)) {
    this.fk__sci_RedBlackTree$Tree__V(r);
    r2k = this.sci_RedBlackTree$partitioner$1$__f_tmpk;
    r2d = this.sci_RedBlackTree$partitioner$1$__f_tmpd;
  }
  var jk = ((!keep) ? $m_sci_RedBlackTree$().scala$collection$immutable$RedBlackTree$$join2__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(l2k, r2k) : (((l2k === l) && (r2k === r)) ? t : $m_sci_RedBlackTree$().scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(l2k, k, v, r2k)));
  var jd = (keep ? $m_sci_RedBlackTree$().scala$collection$immutable$RedBlackTree$$join2__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(l2d, r2d) : (((l2d === l) && (r2d === r)) ? t : $m_sci_RedBlackTree$().scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(l2d, k, v, r2d)));
  this.sci_RedBlackTree$partitioner$1$__f_tmpk = jk;
  this.sci_RedBlackTree$partitioner$1$__f_tmpd = jd;
});
function $as_sci_RedBlackTree$partitioner$1$(obj) {
  return (((obj instanceof $c_sci_RedBlackTree$partitioner$1$) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.RedBlackTree$partitioner$1$"));
}
function $isArrayOf_sci_RedBlackTree$partitioner$1$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_RedBlackTree$partitioner$1$)));
}
function $asArrayOf_sci_RedBlackTree$partitioner$1$(obj, depth) {
  return (($isArrayOf_sci_RedBlackTree$partitioner$1$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.RedBlackTree$partitioner$1$;", depth));
}
var $d_sci_RedBlackTree$partitioner$1$ = new $TypeData().initClass($c_sci_RedBlackTree$partitioner$1$, "scala.collection.immutable.RedBlackTree$partitioner$1$", ({
  sci_RedBlackTree$partitioner$1$: 1
}));
/** @constructor */
function $c_sci_SetNode$() {
  this.sci_SetNode$__f_EmptySetNode = null;
  $n_sci_SetNode$ = this;
  this.sci_SetNode$__f_EmptySetNode = new $c_sci_BitmapIndexedSetNode(0, 0, new $ac_O(0), new $ac_I(0), 0, 0);
}
$c_sci_SetNode$.prototype = new $h_O();
$c_sci_SetNode$.prototype.constructor = $c_sci_SetNode$;
/** @constructor */
function $h_sci_SetNode$() {
}
$h_sci_SetNode$.prototype = $c_sci_SetNode$.prototype;
var $d_sci_SetNode$ = new $TypeData().initClass($c_sci_SetNode$, "scala.collection.immutable.SetNode$", ({
  sci_SetNode$: 1
}));
var $n_sci_SetNode$;
function $m_sci_SetNode$() {
  if ((!$n_sci_SetNode$)) {
    $n_sci_SetNode$ = new $c_sci_SetNode$();
  }
  return $n_sci_SetNode$;
}
/** @constructor */
function $c_sci_TreeSeqMap$Ordering() {
}
$c_sci_TreeSeqMap$Ordering.prototype = new $h_O();
$c_sci_TreeSeqMap$Ordering.prototype.constructor = $c_sci_TreeSeqMap$Ordering;
/** @constructor */
function $h_sci_TreeSeqMap$Ordering() {
}
$h_sci_TreeSeqMap$Ordering.prototype = $c_sci_TreeSeqMap$Ordering.prototype;
$c_sci_TreeSeqMap$Ordering.prototype.toString__T = (function() {
  return this.format__T();
});
$c_sci_TreeSeqMap$Ordering.prototype.format__T = (function() {
  var sb = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  this.format__scm_StringBuilder__T__T__V(sb, "", "");
  return $n(sb.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_sci_TreeSeqMap$Ordering.prototype.head__O = (function() {
  var _$this = this;
  while (true) {
    var x1 = _$this;
    var x = $m_sci_TreeSeqMap$Ordering$Zero$();
    if (x.equals__O__Z(x1)) {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty map");
    } else if ((x1 instanceof $c_sci_TreeSeqMap$Ordering$Tip)) {
      var x3 = $as_sci_TreeSeqMap$Ordering$Tip(x1);
      var v = $n(x3).sci_TreeSeqMap$Ordering$Tip__f_value;
      return v;
    } else if ((x1 instanceof $c_sci_TreeSeqMap$Ordering$Bin)) {
      var x4 = $as_sci_TreeSeqMap$Ordering$Bin(x1);
      var l = $n(x4).sci_TreeSeqMap$Ordering$Bin__f_left;
      _$this = l;
    } else {
      throw new $c_s_MatchError(x1);
    }
  }
});
$c_sci_TreeSeqMap$Ordering.prototype.headOption__s_Option = (function() {
  var _$this = this;
  while (true) {
    var x1 = _$this;
    var x = $m_sci_TreeSeqMap$Ordering$Zero$();
    if (x.equals__O__Z(x1)) {
      return $m_s_None$();
    } else if ((x1 instanceof $c_sci_TreeSeqMap$Ordering$Tip)) {
      var x3 = $as_sci_TreeSeqMap$Ordering$Tip(x1);
      var v = $n(x3).sci_TreeSeqMap$Ordering$Tip__f_value;
      return new $c_s_Some(v);
    } else if ((x1 instanceof $c_sci_TreeSeqMap$Ordering$Bin)) {
      var x5 = $as_sci_TreeSeqMap$Ordering$Bin(x1);
      var l = $n(x5).sci_TreeSeqMap$Ordering$Bin__f_left;
      _$this = l;
    } else {
      throw new $c_s_MatchError(x1);
    }
  }
});
$c_sci_TreeSeqMap$Ordering.prototype.last__O = (function() {
  var _$this = this;
  while (true) {
    var x1 = _$this;
    var x = $m_sci_TreeSeqMap$Ordering$Zero$();
    if (x.equals__O__Z(x1)) {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last of empty map");
    } else if ((x1 instanceof $c_sci_TreeSeqMap$Ordering$Tip)) {
      var x3 = $as_sci_TreeSeqMap$Ordering$Tip(x1);
      var v = $n(x3).sci_TreeSeqMap$Ordering$Tip__f_value;
      return v;
    } else if ((x1 instanceof $c_sci_TreeSeqMap$Ordering$Bin)) {
      var x5 = $as_sci_TreeSeqMap$Ordering$Bin(x1);
      var r = $n(x5).sci_TreeSeqMap$Ordering$Bin__f_right;
      _$this = r;
    } else {
      throw new $c_s_MatchError(x1);
    }
  }
});
$c_sci_TreeSeqMap$Ordering.prototype.ordinal__I = (function() {
  var _$this = this;
  while (true) {
    var x1 = _$this;
    var x = $m_sci_TreeSeqMap$Ordering$Zero$();
    if (x.equals__O__Z(x1)) {
      return 0;
    } else if ((x1 instanceof $c_sci_TreeSeqMap$Ordering$Tip)) {
      var x3 = $as_sci_TreeSeqMap$Ordering$Tip(x1);
      var o = $n(x3).sci_TreeSeqMap$Ordering$Tip__f_ord;
      return o;
    } else if ((x1 instanceof $c_sci_TreeSeqMap$Ordering$Bin)) {
      var x5 = $as_sci_TreeSeqMap$Ordering$Bin(x1);
      var r = $n(x5).sci_TreeSeqMap$Ordering$Bin__f_right;
      _$this = r;
    } else {
      throw new $c_s_MatchError(x1);
    }
  }
});
$c_sci_TreeSeqMap$Ordering.prototype.headTail__T2 = (function() {
  var x = $m_sci_TreeSeqMap$Ordering$Zero$();
  if (x.equals__O__Z(this)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "init of empty map");
  } else if ((this instanceof $c_sci_TreeSeqMap$Ordering$Tip)) {
    var x3 = $as_sci_TreeSeqMap$Ordering$Tip(this);
    var v = $n(x3).sci_TreeSeqMap$Ordering$Tip__f_value;
    return new $c_T2(v, $m_sci_TreeSeqMap$Ordering$Zero$());
  } else if ((this instanceof $c_sci_TreeSeqMap$Ordering$Bin)) {
    var x5 = $as_sci_TreeSeqMap$Ordering$Bin(this);
    var p = $n(x5).sci_TreeSeqMap$Ordering$Bin__f_prefix;
    var m = $n(x5).sci_TreeSeqMap$Ordering$Bin__f_mask;
    var l = $n(x5).sci_TreeSeqMap$Ordering$Bin__f_left;
    var r = $n(x5).sci_TreeSeqMap$Ordering$Bin__f_right;
    var x1$2 = $n(l).headTail__T2();
    if ((x1$2 === null)) {
      throw new $c_s_MatchError(x1$2);
    }
    var head = $n(x1$2)._1__O();
    var tail = $as_sci_TreeSeqMap$Ordering($n(x1$2)._2__O());
    return new $c_T2(head, $m_sci_TreeSeqMap$Ordering$().scala$collection$immutable$TreeSeqMap$Ordering$$bin__I__I__sci_TreeSeqMap$Ordering__sci_TreeSeqMap$Ordering__sci_TreeSeqMap$Ordering(p, m, tail, r));
  } else {
    throw new $c_s_MatchError(this);
  }
});
$c_sci_TreeSeqMap$Ordering.prototype.iterator__sci_TreeSeqMap$Ordering$Iterator = (function() {
  var x = $m_sci_TreeSeqMap$Ordering$Zero$();
  if (x.equals__O__Z(this)) {
    var this$1 = $m_sci_TreeSeqMap$Ordering$Iterator$();
    return this$1.sci_TreeSeqMap$Ordering$Iterator$__f_Empty;
  } else {
    return new $c_sci_TreeSeqMap$Ordering$Iterator(this);
  }
});
$c_sci_TreeSeqMap$Ordering.prototype.include__I__O__sci_TreeSeqMap$Ordering = (function(ordinal, value) {
  var x = $m_sci_TreeSeqMap$Ordering$Zero$();
  if (x.equals__O__Z(this)) {
    return new $c_sci_TreeSeqMap$Ordering$Tip(ordinal, value);
  } else if ((this instanceof $c_sci_TreeSeqMap$Ordering$Tip)) {
    var x3 = $as_sci_TreeSeqMap$Ordering$Tip(this);
    var o = $n(x3).sci_TreeSeqMap$Ordering$Tip__f_ord;
    return ((ordinal === o) ? new $c_sci_TreeSeqMap$Ordering$Tip(ordinal, value) : $m_sci_TreeSeqMap$Ordering$().scala$collection$immutable$TreeSeqMap$Ordering$$join__I__sci_TreeSeqMap$Ordering__I__sci_TreeSeqMap$Ordering__sci_TreeSeqMap$Ordering(ordinal, new $c_sci_TreeSeqMap$Ordering$Tip(ordinal, value), o, this));
  } else if ((this instanceof $c_sci_TreeSeqMap$Ordering$Bin)) {
    var x5 = $as_sci_TreeSeqMap$Ordering$Bin(this);
    var p = $n(x5).sci_TreeSeqMap$Ordering$Bin__f_prefix;
    var m = $n(x5).sci_TreeSeqMap$Ordering$Bin__f_mask;
    var l = $n(x5).sci_TreeSeqMap$Ordering$Bin__f_left;
    var r = $n(x5).sci_TreeSeqMap$Ordering$Bin__f_right;
    var this$1 = $m_scg_BitOperations$Int$();
    if ((!$f_scg_BitOperations$Int__hasMatch__I__I__I__Z(this$1, ordinal, p, m))) {
      return $m_sci_TreeSeqMap$Ordering$().scala$collection$immutable$TreeSeqMap$Ordering$$join__I__sci_TreeSeqMap$Ordering__I__sci_TreeSeqMap$Ordering__sci_TreeSeqMap$Ordering(ordinal, new $c_sci_TreeSeqMap$Ordering$Tip(ordinal, value), p, this);
    } else {
      var this$2 = $m_scg_BitOperations$Int$();
      if ($f_scg_BitOperations$Int__zero__I__I__Z(this$2, ordinal, m)) {
        return new $c_sci_TreeSeqMap$Ordering$Bin(p, m, $n(l).include__I__O__sci_TreeSeqMap$Ordering(ordinal, value), r);
      } else {
        return new $c_sci_TreeSeqMap$Ordering$Bin(p, m, l, $n(r).include__I__O__sci_TreeSeqMap$Ordering(ordinal, value));
      }
    }
  } else {
    throw new $c_s_MatchError(this);
  }
});
$c_sci_TreeSeqMap$Ordering.prototype.append__I__O__sci_TreeSeqMap$Ordering = (function(ordinal, value) {
  var x = $m_sci_TreeSeqMap$Ordering$Zero$();
  if (x.equals__O__Z(this)) {
    return new $c_sci_TreeSeqMap$Ordering$Tip(ordinal, value);
  } else if ((this instanceof $c_sci_TreeSeqMap$Ordering$Tip)) {
    var x3 = $as_sci_TreeSeqMap$Ordering$Tip(this);
    var o = $n(x3).sci_TreeSeqMap$Ordering$Tip__f_ord;
    return ((ordinal === o) ? new $c_sci_TreeSeqMap$Ordering$Tip(ordinal, value) : $m_sci_TreeSeqMap$Ordering$().scala$collection$immutable$TreeSeqMap$Ordering$$join__I__sci_TreeSeqMap$Ordering__I__sci_TreeSeqMap$Ordering__sci_TreeSeqMap$Ordering(ordinal, new $c_sci_TreeSeqMap$Ordering$Tip(ordinal, value), o, this));
  } else if ((this instanceof $c_sci_TreeSeqMap$Ordering$Bin)) {
    var x5 = $as_sci_TreeSeqMap$Ordering$Bin(this);
    var p = $n(x5).sci_TreeSeqMap$Ordering$Bin__f_prefix;
    var m = $n(x5).sci_TreeSeqMap$Ordering$Bin__f_mask;
    var l = $n(x5).sci_TreeSeqMap$Ordering$Bin__f_left;
    var r = $n(x5).sci_TreeSeqMap$Ordering$Bin__f_right;
    var this$1 = $m_scg_BitOperations$Int$();
    if ((!$f_scg_BitOperations$Int__hasMatch__I__I__I__Z(this$1, ordinal, p, m))) {
      return $m_sci_TreeSeqMap$Ordering$().scala$collection$immutable$TreeSeqMap$Ordering$$join__I__sci_TreeSeqMap$Ordering__I__sci_TreeSeqMap$Ordering__sci_TreeSeqMap$Ordering(ordinal, new $c_sci_TreeSeqMap$Ordering$Tip(ordinal, value), p, this);
    } else {
      var this$2 = $m_scg_BitOperations$Int$();
      if ($f_scg_BitOperations$Int__zero__I__I__Z(this$2, ordinal, m)) {
        throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((("Append called with ordinal out of range: " + ordinal) + " is not greater than current max ordinal ") + this.ordinal__I()));
      } else {
        return new $c_sci_TreeSeqMap$Ordering$Bin(p, m, l, $n(r).append__I__O__sci_TreeSeqMap$Ordering(ordinal, value));
      }
    }
  } else {
    throw new $c_s_MatchError(this);
  }
});
$c_sci_TreeSeqMap$Ordering.prototype.appendInPlace1__sci_TreeSeqMap$Ordering$Bin__I__O__sci_TreeSeqMap$Ordering = (function(parent, ordinal, value) {
  var rc12 = false;
  var x3 = null;
  var x = $m_sci_TreeSeqMap$Ordering$Zero$();
  if (x.equals__O__Z(this)) {
    return new $c_sci_TreeSeqMap$Ordering$Tip(ordinal, value);
  }
  if ((this instanceof $c_sci_TreeSeqMap$Ordering$Tip)) {
    rc12 = true;
    x3 = $as_sci_TreeSeqMap$Ordering$Tip(this);
    var o = $n(x3).sci_TreeSeqMap$Ordering$Tip__f_ord;
    if ((o >= ordinal)) {
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((("Append called with ordinal out of range: " + o) + " is not greater than current max ordinal ") + this.ordinal__I()));
    }
  }
  if (rc12) {
    var o$2 = $n(x3).sci_TreeSeqMap$Ordering$Tip__f_ord;
    if ((parent === null)) {
      return $m_sci_TreeSeqMap$Ordering$().scala$collection$immutable$TreeSeqMap$Ordering$$join__I__sci_TreeSeqMap$Ordering__I__sci_TreeSeqMap$Ordering__sci_TreeSeqMap$Ordering(ordinal, new $c_sci_TreeSeqMap$Ordering$Tip(ordinal, value), o$2, this);
    }
  }
  if (rc12) {
    var o$3 = $n(x3).sci_TreeSeqMap$Ordering$Tip__f_ord;
    $n(parent).sci_TreeSeqMap$Ordering$Bin__f_right = $m_sci_TreeSeqMap$Ordering$().scala$collection$immutable$TreeSeqMap$Ordering$$join__I__sci_TreeSeqMap$Ordering__I__sci_TreeSeqMap$Ordering__sci_TreeSeqMap$Ordering(ordinal, new $c_sci_TreeSeqMap$Ordering$Tip(ordinal, value), o$3, this);
    return parent;
  }
  if ((this instanceof $c_sci_TreeSeqMap$Ordering$Bin)) {
    var x9 = $as_sci_TreeSeqMap$Ordering$Bin(this);
    var p = $n(x9).sci_TreeSeqMap$Ordering$Bin__f_prefix;
    var m = $n(x9).sci_TreeSeqMap$Ordering$Bin__f_mask;
    var r = $n(x9).sci_TreeSeqMap$Ordering$Bin__f_right;
    var this$1 = $m_scg_BitOperations$Int$();
    if ((!$f_scg_BitOperations$Int__hasMatch__I__I__I__Z(this$1, ordinal, p, m))) {
      var b2 = $m_sci_TreeSeqMap$Ordering$().scala$collection$immutable$TreeSeqMap$Ordering$$join__I__sci_TreeSeqMap$Ordering__I__sci_TreeSeqMap$Ordering__sci_TreeSeqMap$Ordering(ordinal, new $c_sci_TreeSeqMap$Ordering$Tip(ordinal, value), p, this);
      if ((parent !== null)) {
        $n(parent).sci_TreeSeqMap$Ordering$Bin__f_right = b2;
        return parent;
      } else {
        return b2;
      }
    } else {
      var this$2 = $m_scg_BitOperations$Int$();
      if ($f_scg_BitOperations$Int__zero__I__I__Z(this$2, ordinal, m)) {
        throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((("Append called with ordinal out of range: " + ordinal) + " is not greater than current max ordinal ") + this.ordinal__I()));
      } else {
        $n(r).appendInPlace1__sci_TreeSeqMap$Ordering$Bin__I__O__sci_TreeSeqMap$Ordering(x9, ordinal, value);
        return this;
      }
    }
  }
  throw new $c_s_MatchError(this);
});
$c_sci_TreeSeqMap$Ordering.prototype.exclude__I__sci_TreeSeqMap$Ordering = (function(ordinal) {
  var x = $m_sci_TreeSeqMap$Ordering$Zero$();
  if (x.equals__O__Z(this)) {
    return $m_sci_TreeSeqMap$Ordering$Zero$();
  } else if ((this instanceof $c_sci_TreeSeqMap$Ordering$Tip)) {
    var x3 = $as_sci_TreeSeqMap$Ordering$Tip(this);
    var o = $n(x3).sci_TreeSeqMap$Ordering$Tip__f_ord;
    return ((ordinal === o) ? $m_sci_TreeSeqMap$Ordering$Zero$() : this);
  } else if ((this instanceof $c_sci_TreeSeqMap$Ordering$Bin)) {
    var x5 = $as_sci_TreeSeqMap$Ordering$Bin(this);
    var p = $n(x5).sci_TreeSeqMap$Ordering$Bin__f_prefix;
    var m = $n(x5).sci_TreeSeqMap$Ordering$Bin__f_mask;
    var l = $n(x5).sci_TreeSeqMap$Ordering$Bin__f_left;
    var r = $n(x5).sci_TreeSeqMap$Ordering$Bin__f_right;
    var this$1 = $m_scg_BitOperations$Int$();
    if ((!$f_scg_BitOperations$Int__hasMatch__I__I__I__Z(this$1, ordinal, p, m))) {
      return this;
    } else {
      var this$2 = $m_scg_BitOperations$Int$();
      if ($f_scg_BitOperations$Int__zero__I__I__Z(this$2, ordinal, m)) {
        return $m_sci_TreeSeqMap$Ordering$().scala$collection$immutable$TreeSeqMap$Ordering$$bin__I__I__sci_TreeSeqMap$Ordering__sci_TreeSeqMap$Ordering__sci_TreeSeqMap$Ordering(p, m, $n(l).exclude__I__sci_TreeSeqMap$Ordering(ordinal), r);
      } else {
        return $m_sci_TreeSeqMap$Ordering$().scala$collection$immutable$TreeSeqMap$Ordering$$bin__I__I__sci_TreeSeqMap$Ordering__sci_TreeSeqMap$Ordering__sci_TreeSeqMap$Ordering(p, m, l, $n(r).exclude__I__sci_TreeSeqMap$Ordering(ordinal));
      }
    }
  } else {
    throw new $c_s_MatchError(this);
  }
});
function $as_sci_TreeSeqMap$Ordering(obj) {
  return (((obj instanceof $c_sci_TreeSeqMap$Ordering) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.TreeSeqMap$Ordering"));
}
function $isArrayOf_sci_TreeSeqMap$Ordering(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_TreeSeqMap$Ordering)));
}
function $asArrayOf_sci_TreeSeqMap$Ordering(obj, depth) {
  return (($isArrayOf_sci_TreeSeqMap$Ordering(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.TreeSeqMap$Ordering;", depth));
}
function $p_sci_TreeSeqMap$Ordering$__branchMask__I__I__I($thiz, i, j) {
  var j$1 = (i ^ j);
  return (((-2147483648) >> $uI(Math.clz32(j$1))) & j$1);
}
/** @constructor */
function $c_sci_TreeSeqMap$Ordering$() {
}
$c_sci_TreeSeqMap$Ordering$.prototype = new $h_O();
$c_sci_TreeSeqMap$Ordering$.prototype.constructor = $c_sci_TreeSeqMap$Ordering$;
/** @constructor */
function $h_sci_TreeSeqMap$Ordering$() {
}
$h_sci_TreeSeqMap$Ordering$.prototype = $c_sci_TreeSeqMap$Ordering$.prototype;
$c_sci_TreeSeqMap$Ordering$.prototype.scala$collection$immutable$TreeSeqMap$Ordering$$join__I__sci_TreeSeqMap$Ordering__I__sci_TreeSeqMap$Ordering__sci_TreeSeqMap$Ordering = (function(p1, t1, p2, t2) {
  var m = $p_sci_TreeSeqMap$Ordering$__branchMask__I__I__I(this, p1, p2);
  var this$1 = $m_scg_BitOperations$Int$();
  var p = $f_scg_BitOperations$Int__mask__I__I__I(this$1, p1, m);
  var this$2 = $m_scg_BitOperations$Int$();
  if ($f_scg_BitOperations$Int__zero__I__I__Z(this$2, p1, m)) {
    return new $c_sci_TreeSeqMap$Ordering$Bin(p, m, t1, t2);
  } else {
    return new $c_sci_TreeSeqMap$Ordering$Bin(p, m, t2, t1);
  }
});
$c_sci_TreeSeqMap$Ordering$.prototype.scala$collection$immutable$TreeSeqMap$Ordering$$bin__I__I__sci_TreeSeqMap$Ordering__sci_TreeSeqMap$Ordering__sci_TreeSeqMap$Ordering = (function(prefix, mask, left, right) {
  var x = $m_sci_TreeSeqMap$Ordering$Zero$();
  if (x.equals__O__Z(right)) {
    return left;
  } else {
    var x$3 = $m_sci_TreeSeqMap$Ordering$Zero$();
    if (x$3.equals__O__Z(left)) {
      return right;
    } else {
      return new $c_sci_TreeSeqMap$Ordering$Bin(prefix, mask, left, right);
    }
  }
});
var $d_sci_TreeSeqMap$Ordering$ = new $TypeData().initClass($c_sci_TreeSeqMap$Ordering$, "scala.collection.immutable.TreeSeqMap$Ordering$", ({
  sci_TreeSeqMap$Ordering$: 1
}));
var $n_sci_TreeSeqMap$Ordering$;
function $m_sci_TreeSeqMap$Ordering$() {
  if ((!$n_sci_TreeSeqMap$Ordering$)) {
    $n_sci_TreeSeqMap$Ordering$ = new $c_sci_TreeSeqMap$Ordering$();
  }
  return $n_sci_TreeSeqMap$Ordering$;
}
function $p_sci_TreeSeqMap$Ordering$Iterator__pop__sci_TreeSeqMap$Ordering($thiz) {
  $thiz.sci_TreeSeqMap$Ordering$Iterator__f_index = (((-1) + $thiz.sci_TreeSeqMap$Ordering$Iterator__f_index) | 0);
  return $as_sci_TreeSeqMap$Ordering($n($thiz.sci_TreeSeqMap$Ordering$Iterator__f_buffer).get($thiz.sci_TreeSeqMap$Ordering$Iterator__f_index));
}
function $p_sci_TreeSeqMap$Ordering$Iterator__push__sci_TreeSeqMap$Ordering__V($thiz, x) {
  $n($thiz.sci_TreeSeqMap$Ordering$Iterator__f_buffer).set($thiz.sci_TreeSeqMap$Ordering$Iterator__f_index, x);
  $thiz.sci_TreeSeqMap$Ordering$Iterator__f_index = ((1 + $thiz.sci_TreeSeqMap$Ordering$Iterator__f_index) | 0);
}
/** @constructor */
function $c_sci_TreeSeqMap$Ordering$Iterator(it) {
  this.sci_TreeSeqMap$Ordering$Iterator__f_index = 0;
  this.sci_TreeSeqMap$Ordering$Iterator__f_buffer = null;
  this.sci_TreeSeqMap$Ordering$Iterator__f_index = 0;
  this.sci_TreeSeqMap$Ordering$Iterator__f_buffer = new $ac_O(33);
  var x$2 = $m_sci_TreeSeqMap$Ordering$Zero$();
  if ((!((it !== null) && $n(it).equals__O__Z(x$2)))) {
    $p_sci_TreeSeqMap$Ordering$Iterator__push__sci_TreeSeqMap$Ordering__V(this, it);
  }
}
$c_sci_TreeSeqMap$Ordering$Iterator.prototype = new $h_O();
$c_sci_TreeSeqMap$Ordering$Iterator.prototype.constructor = $c_sci_TreeSeqMap$Ordering$Iterator;
/** @constructor */
function $h_sci_TreeSeqMap$Ordering$Iterator() {
}
$h_sci_TreeSeqMap$Ordering$Iterator.prototype = $c_sci_TreeSeqMap$Ordering$Iterator.prototype;
$c_sci_TreeSeqMap$Ordering$Iterator.prototype.hasNext__Z = (function() {
  return (this.sci_TreeSeqMap$Ordering$Iterator__f_index !== 0);
});
$c_sci_TreeSeqMap$Ordering$Iterator.prototype.next__O = (function() {
  while (true) {
    var rc15 = false;
    var x2 = null;
    var x1 = $p_sci_TreeSeqMap$Ordering$Iterator__pop__sci_TreeSeqMap$Ordering(this);
    if ((x1 instanceof $c_sci_TreeSeqMap$Ordering$Bin)) {
      rc15 = true;
      x2 = $as_sci_TreeSeqMap$Ordering$Bin(x1);
      var p5 = $n(x2).sci_TreeSeqMap$Ordering$Bin__f_left;
      var right = $n(x2).sci_TreeSeqMap$Ordering$Bin__f_right;
      if ((p5 instanceof $c_sci_TreeSeqMap$Ordering$Tip)) {
        var x6 = $as_sci_TreeSeqMap$Ordering$Tip(p5);
        var v = $n(x6).sci_TreeSeqMap$Ordering$Tip__f_value;
        $p_sci_TreeSeqMap$Ordering$Iterator__push__sci_TreeSeqMap$Ordering__V(this, right);
        return v;
      }
    }
    if (rc15) {
      var left = $n(x2).sci_TreeSeqMap$Ordering$Bin__f_left;
      var right$2 = $n(x2).sci_TreeSeqMap$Ordering$Bin__f_right;
      $p_sci_TreeSeqMap$Ordering$Iterator__push__sci_TreeSeqMap$Ordering__V(this, right$2);
      $p_sci_TreeSeqMap$Ordering$Iterator__push__sci_TreeSeqMap$Ordering__V(this, left);
      continue;
    }
    if ((x1 instanceof $c_sci_TreeSeqMap$Ordering$Tip)) {
      var x11 = $as_sci_TreeSeqMap$Ordering$Tip(x1);
      var v$2 = $n(x11).sci_TreeSeqMap$Ordering$Tip__f_value;
      return v$2;
    }
    var x = $m_sci_TreeSeqMap$Ordering$Zero$();
    if (x.equals__O__Z(x1)) {
      throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "empty subtree not allowed");
    }
    throw new $c_s_MatchError(x1);
  }
});
var $d_sci_TreeSeqMap$Ordering$Iterator = new $TypeData().initClass($c_sci_TreeSeqMap$Ordering$Iterator, "scala.collection.immutable.TreeSeqMap$Ordering$Iterator", ({
  sci_TreeSeqMap$Ordering$Iterator: 1
}));
/** @constructor */
function $c_sci_TreeSeqMap$Ordering$Iterator$() {
  this.sci_TreeSeqMap$Ordering$Iterator$__f_Empty = null;
  $n_sci_TreeSeqMap$Ordering$Iterator$ = this;
  this.sci_TreeSeqMap$Ordering$Iterator$__f_Empty = new $c_sci_TreeSeqMap$Ordering$Iterator($m_sci_TreeSeqMap$Ordering$Zero$());
}
$c_sci_TreeSeqMap$Ordering$Iterator$.prototype = new $h_O();
$c_sci_TreeSeqMap$Ordering$Iterator$.prototype.constructor = $c_sci_TreeSeqMap$Ordering$Iterator$;
/** @constructor */
function $h_sci_TreeSeqMap$Ordering$Iterator$() {
}
$h_sci_TreeSeqMap$Ordering$Iterator$.prototype = $c_sci_TreeSeqMap$Ordering$Iterator$.prototype;
var $d_sci_TreeSeqMap$Ordering$Iterator$ = new $TypeData().initClass($c_sci_TreeSeqMap$Ordering$Iterator$, "scala.collection.immutable.TreeSeqMap$Ordering$Iterator$", ({
  sci_TreeSeqMap$Ordering$Iterator$: 1
}));
var $n_sci_TreeSeqMap$Ordering$Iterator$;
function $m_sci_TreeSeqMap$Ordering$Iterator$() {
  if ((!$n_sci_TreeSeqMap$Ordering$Iterator$)) {
    $n_sci_TreeSeqMap$Ordering$Iterator$ = new $c_sci_TreeSeqMap$Ordering$Iterator$();
  }
  return $n_sci_TreeSeqMap$Ordering$Iterator$;
}
function $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V($thiz, n, a, lo, hi) {
  while (true) {
    if ((n === 1)) {
      var a$1 = a;
      var start = lo;
      var end = hi;
      $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, 1, (((start === 0) && (end === $n(a$1).u.length)) ? a$1 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$1, start, end)));
    } else {
      var bitsN = Math.imul(5, (((-1) + n) | 0));
      var widthN = (1 << bitsN);
      var loN = ((lo >>> bitsN) | 0);
      var hiN = ((hi >>> bitsN) | 0);
      var loRest = (lo & (((-1) + widthN) | 0));
      var hiRest = (hi & (((-1) + widthN) | 0));
      if ((loRest === 0)) {
        if ((hiRest === 0)) {
          var $x_1 = n;
          var a$2 = a;
          $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $x_1, (((loN === 0) && (hiN === $n(a$2).u.length)) ? a$2 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$2, loN, hiN)));
        } else {
          if ((hiN > loN)) {
            var $x_2 = n;
            var a$3 = a;
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $x_2, (((loN === 0) && (hiN === $n(a$3).u.length)) ? a$3 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$3, loN, hiN)));
          }
          var temp$n = (((-1) + n) | 0);
          var temp$a = $asArrayOf_O($n(a).get(hiN), 1);
          n = temp$n;
          a = temp$a;
          lo = 0;
          hi = hiRest;
          continue;
        }
      } else if ((hiN === loN)) {
        var temp$n$2 = (((-1) + n) | 0);
        var temp$a$2 = $asArrayOf_O($n(a).get(loN), 1);
        n = temp$n$2;
        a = temp$a$2;
        lo = loRest;
        hi = hiRest;
        continue;
      } else {
        $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V($thiz, (((-1) + n) | 0), $asArrayOf_O($n(a).get(loN), 1), loRest, widthN);
        if ((hiRest === 0)) {
          if ((hiN > ((1 + loN) | 0))) {
            var $x_3 = n;
            var a$4 = a;
            var start$1 = ((1 + loN) | 0);
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $x_3, (((start$1 === 0) && (hiN === $n(a$4).u.length)) ? a$4 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$4, start$1, hiN)));
          }
        } else {
          if ((hiN > ((1 + loN) | 0))) {
            var $x_4 = n;
            var a$5 = a;
            var start$2 = ((1 + loN) | 0);
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $x_4, (((start$2 === 0) && (hiN === $n(a$5).u.length)) ? a$5 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$5, start$2, hiN)));
          }
          var temp$n$3 = (((-1) + n) | 0);
          var temp$a$3 = $asArrayOf_O($n(a).get(hiN), 1);
          n = temp$n$3;
          a = temp$a$3;
          lo = 0;
          hi = hiRest;
          continue;
        }
      }
    }
    return (void 0);
  }
}
function $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, n, a) {
  if ((n <= $thiz.sci_VectorSliceBuilder__f_maxDim)) {
    var idx = ((11 - n) | 0);
  } else {
    $thiz.sci_VectorSliceBuilder__f_maxDim = n;
    var idx = (((-1) + n) | 0);
  }
  $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).set(idx, a);
}
function $p_sci_VectorSliceBuilder__balancePrefix__I__V($thiz, n) {
  if (($n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get((((-1) + n) | 0)) === null)) {
    if ((n === $thiz.sci_VectorSliceBuilder__f_maxDim)) {
      $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).set((((-1) + n) | 0), $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(((11 - n) | 0)));
      $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).set(((11 - n) | 0), null);
    } else {
      $p_sci_VectorSliceBuilder__balancePrefix__I__V($thiz, ((1 + n) | 0));
      var $x_1 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
      var n$1 = ((1 + n) | 0);
      var preN1 = $asArrayOf_O($n($x_1).get((((-1) + n$1) | 0)), 2);
      $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).set((((-1) + n) | 0), $n(preN1).get(0));
      if (($n(preN1).u.length === 1)) {
        var $x_2 = $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices);
        var n$2 = ((1 + n) | 0);
        $x_2.set((((-1) + n$2) | 0), null);
        if (($thiz.sci_VectorSliceBuilder__f_maxDim === ((1 + n) | 0))) {
          var $x_4 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
          var n$3 = ((1 + n) | 0);
          var $x_3 = ($n($x_4).get(((11 - n$3) | 0)) === null);
        } else {
          var $x_3 = false;
        }
        if ($x_3) {
          $thiz.sci_VectorSliceBuilder__f_maxDim = n;
        }
      } else {
        var $x_5 = $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices);
        var n$4 = ((1 + n) | 0);
        var to = $n(preN1).u.length;
        $x_5.set((((-1) + n$4) | 0), $m_ju_Arrays$().copyOfRange__AO__I__I__AO(preN1, 1, to));
      }
    }
  }
}
function $p_sci_VectorSliceBuilder__balanceSuffix__I__V($thiz, n) {
  if (($n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(((11 - n) | 0)) === null)) {
    if ((n === $thiz.sci_VectorSliceBuilder__f_maxDim)) {
      $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).set(((11 - n) | 0), $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get((((-1) + n) | 0)));
      $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).set((((-1) + n) | 0), null);
    } else {
      $p_sci_VectorSliceBuilder__balanceSuffix__I__V($thiz, ((1 + n) | 0));
      var $x_1 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
      var n$1 = ((1 + n) | 0);
      var sufN1 = $asArrayOf_O($n($x_1).get(((11 - n$1) | 0)), 2);
      $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).set(((11 - n) | 0), $n(sufN1).get((((-1) + $n(sufN1).u.length) | 0)));
      if (($n(sufN1).u.length === 1)) {
        var $x_2 = $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices);
        var n$2 = ((1 + n) | 0);
        $x_2.set(((11 - n$2) | 0), null);
        if (($thiz.sci_VectorSliceBuilder__f_maxDim === ((1 + n) | 0))) {
          var $x_4 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
          var n$3 = ((1 + n) | 0);
          var $x_3 = ($n($x_4).get((((-1) + n$3) | 0)) === null);
        } else {
          var $x_3 = false;
        }
        if ($x_3) {
          $thiz.sci_VectorSliceBuilder__f_maxDim = n;
        }
      } else {
        var $x_5 = $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices);
        var n$4 = ((1 + n) | 0);
        var to = (((-1) + $n(sufN1).u.length) | 0);
        $x_5.set(((11 - n$4) | 0), $m_ju_Arrays$().copyOfRange__AO__I__I__AO(sufN1, 0, to));
      }
    }
  }
}
/** @constructor */
function $c_sci_VectorSliceBuilder(lo, hi) {
  this.sci_VectorSliceBuilder__f_lo = 0;
  this.sci_VectorSliceBuilder__f_hi = 0;
  this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices = null;
  this.sci_VectorSliceBuilder__f_len = 0;
  this.sci_VectorSliceBuilder__f_pos = 0;
  this.sci_VectorSliceBuilder__f_maxDim = 0;
  this.sci_VectorSliceBuilder__f_lo = lo;
  this.sci_VectorSliceBuilder__f_hi = hi;
  this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices = new ($d_O.getArrayOf().getArrayOf().constr)(11);
  this.sci_VectorSliceBuilder__f_len = 0;
  this.sci_VectorSliceBuilder__f_pos = 0;
  this.sci_VectorSliceBuilder__f_maxDim = 0;
}
$c_sci_VectorSliceBuilder.prototype = new $h_O();
$c_sci_VectorSliceBuilder.prototype.constructor = $c_sci_VectorSliceBuilder;
/** @constructor */
function $h_sci_VectorSliceBuilder() {
}
$h_sci_VectorSliceBuilder.prototype = $c_sci_VectorSliceBuilder.prototype;
$c_sci_VectorSliceBuilder.prototype.consider__I__AO__V = (function(n, a) {
  var count = Math.imul($n(a).u.length, (1 << Math.imul(5, (((-1) + n) | 0))));
  var a$1 = ((this.sci_VectorSliceBuilder__f_lo - this.sci_VectorSliceBuilder__f_pos) | 0);
  var lo0 = ((a$1 > 0) ? a$1 : 0);
  var a$2 = ((this.sci_VectorSliceBuilder__f_hi - this.sci_VectorSliceBuilder__f_pos) | 0);
  var hi0 = ((a$2 < count) ? a$2 : count);
  if ((hi0 > lo0)) {
    $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V(this, n, a, lo0, hi0);
    this.sci_VectorSliceBuilder__f_len = ((this.sci_VectorSliceBuilder__f_len + ((hi0 - lo0) | 0)) | 0);
  }
  this.sci_VectorSliceBuilder__f_pos = ((this.sci_VectorSliceBuilder__f_pos + count) | 0);
});
$c_sci_VectorSliceBuilder.prototype.result__sci_Vector = (function() {
  if ((this.sci_VectorSliceBuilder__f_len <= 32)) {
    if ((this.sci_VectorSliceBuilder__f_len === 0)) {
      return $m_sci_Vector0$();
    } else {
      var prefix1 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(0);
      var suffix1 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(10);
      if ((prefix1 !== null)) {
        if ((suffix1 !== null)) {
          var newLength = (($n(prefix1).u.length + $n(suffix1).u.length) | 0);
          var dest = $m_ju_Arrays$().copyOf__AO__I__AO(prefix1, newLength);
          var destPos = $n(prefix1).u.length;
          var length = $n(suffix1).u.length;
          $systemArraycopyRefs($n(suffix1), 0, $n(dest), destPos, length);
          var a = dest;
        } else {
          var a = prefix1;
        }
      } else if ((suffix1 !== null)) {
        var a = suffix1;
      } else {
        var prefix2 = $asArrayOf_O($n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(1), 2);
        if ((prefix2 !== null)) {
          var a = $n(prefix2).get(0);
        } else {
          var suffix2 = $asArrayOf_O($n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(9), 2);
          var a = $n(suffix2).get(0);
        }
      }
      return new $c_sci_Vector1(a);
    }
  } else {
    $p_sci_VectorSliceBuilder__balancePrefix__I__V(this, 1);
    $p_sci_VectorSliceBuilder__balanceSuffix__I__V(this, 1);
    var resultDim = this.sci_VectorSliceBuilder__f_maxDim;
    if ((resultDim < 6)) {
      var $x_1 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices);
      var n = this.sci_VectorSliceBuilder__f_maxDim;
      var pre = $n($x_1).get((((-1) + n) | 0));
      var $x_2 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices);
      var n$1 = this.sci_VectorSliceBuilder__f_maxDim;
      var suf = $n($x_2).get(((11 - n$1) | 0));
      if (((pre !== null) && (suf !== null))) {
        if (((($n(pre).u.length + $n(suf).u.length) | 0) <= 30)) {
          var $x_3 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices);
          var n$2 = this.sci_VectorSliceBuilder__f_maxDim;
          var newLength$1 = (($n(pre).u.length + $n(suf).u.length) | 0);
          var dest$1 = $m_ju_Arrays$().copyOf__AO__I__AO(pre, newLength$1);
          var destPos$1 = $n(pre).u.length;
          var length$1 = $n(suf).u.length;
          $systemArraycopyRefs($n(suf), 0, $n(dest$1), destPos$1, length$1);
          $x_3.set((((-1) + n$2) | 0), dest$1);
          var $x_4 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices);
          var n$3 = this.sci_VectorSliceBuilder__f_maxDim;
          $x_4.set(((11 - n$3) | 0), null);
        } else {
          resultDim = ((1 + resultDim) | 0);
        }
      } else {
        var one = ((pre !== null) ? pre : suf);
        if (($n(one).u.length > 30)) {
          resultDim = ((1 + resultDim) | 0);
        }
      }
    }
    var prefix1$2 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(0);
    var suffix1$2 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(10);
    var len1 = $n(prefix1$2).u.length;
    var x1 = resultDim;
    switch (x1) {
      case 2: {
        var a$1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(1);
        if ((p !== null)) {
          var $x_5 = p;
        } else {
          var s = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(9);
          var $x_5 = ((s !== null) ? s : a$1);
        }
        var data2 = $asArrayOf_O($x_5, 2);
        var res = new $c_sci_Vector2(prefix1$2, len1, data2, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break;
      }
      case 3: {
        var a$2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$1 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(1);
        var prefix2$2 = $asArrayOf_O(((p$1 !== null) ? p$1 : a$2), 2);
        var a$3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$2 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(2);
        if ((p$2 !== null)) {
          var $x_6 = p$2;
        } else {
          var s$1 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(8);
          var $x_6 = ((s$1 !== null) ? s$1 : a$3);
        }
        var data3 = $asArrayOf_O($x_6, 3);
        var a$4 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$2 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(9);
        var suffix2$2 = $asArrayOf_O(((s$2 !== null) ? s$2 : a$4), 2);
        var len12 = ((len1 + ($n(prefix2$2).u.length << 5)) | 0);
        var res = new $c_sci_Vector3(prefix1$2, len1, prefix2$2, len12, data3, suffix2$2, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break;
      }
      case 4: {
        var a$5 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$3 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(1);
        var prefix2$3 = $asArrayOf_O(((p$3 !== null) ? p$3 : a$5), 2);
        var a$6 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$4 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(2);
        var prefix3 = $asArrayOf_O(((p$4 !== null) ? p$4 : a$6), 3);
        var a$7 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var p$5 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(3);
        if ((p$5 !== null)) {
          var $x_7 = p$5;
        } else {
          var s$3 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(7);
          var $x_7 = ((s$3 !== null) ? s$3 : a$7);
        }
        var data4 = $asArrayOf_O($x_7, 4);
        var a$8 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var s$4 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(8);
        var suffix3 = $asArrayOf_O(((s$4 !== null) ? s$4 : a$8), 3);
        var a$9 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$5 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(9);
        var suffix2$3 = $asArrayOf_O(((s$5 !== null) ? s$5 : a$9), 2);
        var len12$2 = ((len1 + ($n(prefix2$3).u.length << 5)) | 0);
        var len123 = ((len12$2 + ($n(prefix3).u.length << 10)) | 0);
        var res = new $c_sci_Vector4(prefix1$2, len1, prefix2$3, len12$2, prefix3, len123, data4, suffix3, suffix2$3, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break;
      }
      case 5: {
        var a$10 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$6 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(1);
        var prefix2$4 = $asArrayOf_O(((p$6 !== null) ? p$6 : a$10), 2);
        var a$11 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$7 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(2);
        var prefix3$2 = $asArrayOf_O(((p$7 !== null) ? p$7 : a$11), 3);
        var a$12 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var p$8 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(3);
        var prefix4 = $asArrayOf_O(((p$8 !== null) ? p$8 : a$12), 4);
        var a$13 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
        var p$9 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(4);
        if ((p$9 !== null)) {
          var $x_8 = p$9;
        } else {
          var s$6 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(6);
          var $x_8 = ((s$6 !== null) ? s$6 : a$13);
        }
        var data5 = $asArrayOf_O($x_8, 5);
        var a$14 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var s$7 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(7);
        var suffix4 = $asArrayOf_O(((s$7 !== null) ? s$7 : a$14), 4);
        var a$15 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var s$8 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(8);
        var suffix3$2 = $asArrayOf_O(((s$8 !== null) ? s$8 : a$15), 3);
        var a$16 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$9 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(9);
        var suffix2$4 = $asArrayOf_O(((s$9 !== null) ? s$9 : a$16), 2);
        var len12$3 = ((len1 + ($n(prefix2$4).u.length << 5)) | 0);
        var len123$2 = ((len12$3 + ($n(prefix3$2).u.length << 10)) | 0);
        var len1234 = ((len123$2 + ($n(prefix4).u.length << 15)) | 0);
        var res = new $c_sci_Vector5(prefix1$2, len1, prefix2$4, len12$3, prefix3$2, len123$2, prefix4, len1234, data5, suffix4, suffix3$2, suffix2$4, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break;
      }
      case 6: {
        var a$17 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$10 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(1);
        var prefix2$5 = $asArrayOf_O(((p$10 !== null) ? p$10 : a$17), 2);
        var a$18 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$11 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(2);
        var prefix3$3 = $asArrayOf_O(((p$11 !== null) ? p$11 : a$18), 3);
        var a$19 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var p$12 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(3);
        var prefix4$2 = $asArrayOf_O(((p$12 !== null) ? p$12 : a$19), 4);
        var a$20 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
        var p$13 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(4);
        var prefix5 = $asArrayOf_O(((p$13 !== null) ? p$13 : a$20), 5);
        var a$21 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty6;
        var p$14 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(5);
        if ((p$14 !== null)) {
          var $x_9 = p$14;
        } else {
          var s$10 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(5);
          var $x_9 = ((s$10 !== null) ? s$10 : a$21);
        }
        var data6 = $asArrayOf_O($x_9, 6);
        var a$22 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
        var s$11 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(6);
        var suffix5 = $asArrayOf_O(((s$11 !== null) ? s$11 : a$22), 5);
        var a$23 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var s$12 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(7);
        var suffix4$2 = $asArrayOf_O(((s$12 !== null) ? s$12 : a$23), 4);
        var a$24 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var s$13 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(8);
        var suffix3$3 = $asArrayOf_O(((s$13 !== null) ? s$13 : a$24), 3);
        var a$25 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$14 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(9);
        var suffix2$5 = $asArrayOf_O(((s$14 !== null) ? s$14 : a$25), 2);
        var len12$4 = ((len1 + ($n(prefix2$5).u.length << 5)) | 0);
        var len123$3 = ((len12$4 + ($n(prefix3$3).u.length << 10)) | 0);
        var len1234$2 = ((len123$3 + ($n(prefix4$2).u.length << 15)) | 0);
        var len12345 = ((len1234$2 + ($n(prefix5).u.length << 20)) | 0);
        var res = new $c_sci_Vector6(prefix1$2, len1, prefix2$5, len12$4, prefix3$3, len123$3, prefix4$2, len1234$2, prefix5, len12345, data6, suffix5, suffix4$2, suffix3$3, suffix2$5, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break;
      }
      default: {
        var res;
        throw new $c_s_MatchError(x1);
      }
    }
    return res;
  }
});
$c_sci_VectorSliceBuilder.prototype.toString__T = (function() {
  return (((((((((("VectorSliceBuilder(lo=" + this.sci_VectorSliceBuilder__f_lo) + ", hi=") + this.sci_VectorSliceBuilder__f_hi) + ", len=") + this.sci_VectorSliceBuilder__f_len) + ", pos=") + this.sci_VectorSliceBuilder__f_pos) + ", maxDim=") + this.sci_VectorSliceBuilder__f_maxDim) + ")");
});
var $d_sci_VectorSliceBuilder = new $TypeData().initClass($c_sci_VectorSliceBuilder, "scala.collection.immutable.VectorSliceBuilder", ({
  sci_VectorSliceBuilder: 1
}));
/** @constructor */
function $c_sci_VectorStatics$() {
  this.sci_VectorStatics$__f_empty1 = null;
  this.sci_VectorStatics$__f_empty2 = null;
  this.sci_VectorStatics$__f_empty3 = null;
  this.sci_VectorStatics$__f_empty4 = null;
  this.sci_VectorStatics$__f_empty5 = null;
  this.sci_VectorStatics$__f_empty6 = null;
  $n_sci_VectorStatics$ = this;
  this.sci_VectorStatics$__f_empty1 = new $ac_O(0);
  this.sci_VectorStatics$__f_empty2 = new ($d_O.getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty6 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(0);
}
$c_sci_VectorStatics$.prototype = new $h_O();
$c_sci_VectorStatics$.prototype.constructor = $c_sci_VectorStatics$;
/** @constructor */
function $h_sci_VectorStatics$() {
}
$h_sci_VectorStatics$.prototype = $c_sci_VectorStatics$.prototype;
$c_sci_VectorStatics$.prototype.copyAppend1__AO__O__AO = (function(a, elem) {
  var alen = $n(a).u.length;
  var ac = new $ac_O(((1 + alen) | 0));
  $systemArraycopyRefs($n(a), 0, ac, 0, alen);
  $n(ac).set(alen, elem);
  return ac;
});
$c_sci_VectorStatics$.prototype.copyAppend__AO__O__AO = (function(a, elem) {
  var newLength = ((1 + $n(a).u.length) | 0);
  var ac = $m_ju_Arrays$().copyOf__AO__I__AO(a, newLength);
  $n(ac).set((((-1) + $n(ac).u.length) | 0), elem);
  return ac;
});
$c_sci_VectorStatics$.prototype.copyPrepend1__O__AO__AO = (function(elem, a) {
  var ac = new $ac_O(((1 + $n(a).u.length) | 0));
  var length = $n(a).u.length;
  $systemArraycopyRefs($n(a), 0, ac, 1, length);
  $n(ac).set(0, elem);
  return ac;
});
$c_sci_VectorStatics$.prototype.copyPrepend__O__AO__AO = (function(elem, a) {
  var this$1 = $n(a);
  var componentType = $objectGetClass(this$1).getComponentType__jl_Class();
  var length = ((1 + $n(a).u.length) | 0);
  var ac = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__I__O(componentType, length), 1);
  var length$1 = $n(a).u.length;
  $systemArraycopyRefs($n(a), 0, $n(ac), 1, length$1);
  $n(ac).set(0, elem);
  return ac;
});
$c_sci_VectorStatics$.prototype.foreachRec__I__AO__F1__V = (function(level, a, f) {
  var i = 0;
  var len = $n(a).u.length;
  if ((level === 0)) {
    while ((i < len)) {
      $n(f).apply__O__O($n(a).get(i));
      i = ((1 + i) | 0);
    }
  } else {
    var l = (((-1) + level) | 0);
    while ((i < len)) {
      this.foreachRec__I__AO__F1__V(l, $asArrayOf_O($n(a).get(i), 1), f);
      i = ((1 + i) | 0);
    }
  }
});
$c_sci_VectorStatics$.prototype.mapElems1__AO__F1__AO = (function(a, f) {
  var i = 0;
  while ((i < $n(a).u.length)) {
    var v1 = $n(a).get(i);
    var v2 = $n(f).apply__O__O(v1);
    if ((!Object.is(v1, v2))) {
      return this.mapElems1Rest__AO__F1__I__O__AO(a, f, i, v2);
    }
    i = ((1 + i) | 0);
  }
  return a;
});
$c_sci_VectorStatics$.prototype.mapElems1Rest__AO__F1__I__O__AO = (function(a, f, at, v2) {
  var ac = new $ac_O($n(a).u.length);
  if ((at > 0)) {
    $systemArraycopyRefs($n(a), 0, ac, 0, at);
  }
  $n(ac).set(at, v2);
  var i = ((1 + at) | 0);
  while ((i < $n(a).u.length)) {
    $n(ac).set(i, $n(f).apply__O__O($n(a).get(i)));
    i = ((1 + i) | 0);
  }
  return ac;
});
$c_sci_VectorStatics$.prototype.mapElems__I__AO__F1__AO = (function(n, a, f) {
  if ((n === 1)) {
    return this.mapElems1__AO__F1__AO(a, f);
  } else {
    var i = 0;
    while ((i < $n(a).u.length)) {
      var v1 = $n(a).get(i);
      var v2 = this.mapElems__I__AO__F1__AO((((-1) + n) | 0), $asArrayOf_O(v1, 1), f);
      if ((v1 !== v2)) {
        return this.mapElemsRest__I__AO__F1__I__O__AO(n, a, f, i, v2);
      }
      i = ((1 + i) | 0);
    }
    return a;
  }
});
$c_sci_VectorStatics$.prototype.mapElemsRest__I__AO__F1__I__O__AO = (function(n, a, f, at, v2) {
  var this$1 = $n(a);
  var componentType = $objectGetClass(this$1).getComponentType__jl_Class();
  var length = $n(a).u.length;
  var ac = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__I__O(componentType, length), 1);
  if ((at > 0)) {
    $systemArraycopyRefs($n(a), 0, $n(ac), 0, at);
  }
  $n(ac).set(at, v2);
  var i = ((1 + at) | 0);
  while ((i < $n(a).u.length)) {
    $n(ac).set(i, this.mapElems__I__AO__F1__AO((((-1) + n) | 0), $asArrayOf_O($n(a).get(i), 1), f));
    i = ((1 + i) | 0);
  }
  return ac;
});
$c_sci_VectorStatics$.prototype.prepend1IfSpace__AO__sc_IterableOnce__AO = (function(prefix1, xs) {
  if ($is_sci_Iterable(xs)) {
    var x2 = $as_sci_Iterable(xs);
    if (($n(x2).sizeCompare__I__I(((32 - $n(prefix1).u.length) | 0)) <= 0)) {
      var x1$2 = $n(x2).size__I();
      switch (x1$2) {
        case 0: {
          return null;
          break;
        }
        case 1: {
          return this.copyPrepend__O__AO__AO($n(x2).head__O(), prefix1);
          break;
        }
        default: {
          var prefix1b = new $ac_O((($n(prefix1).u.length + x1$2) | 0));
          var length = $n(prefix1).u.length;
          $systemArraycopyRefs($n(prefix1), 0, prefix1b, x1$2, length);
          var this$1 = $n(x2);
          this$1.copyToArray__O__I__I__I(prefix1b, 0, 2147483647);
          return prefix1b;
        }
      }
    } else {
      return null;
    }
  } else {
    var s = $n(xs).knownSize__I();
    if (((s > 0) && (s <= ((32 - $n(prefix1).u.length) | 0)))) {
      var prefix1b$2 = new $ac_O((($n(prefix1).u.length + s) | 0));
      var length$1 = $n(prefix1).u.length;
      $systemArraycopyRefs($n(prefix1), 0, prefix1b$2, s, length$1);
      var this$2 = $n($n(xs).iterator__sc_Iterator());
      this$2.copyToArray__O__I__I__I(prefix1b$2, 0, 2147483647);
      return prefix1b$2;
    } else {
      return null;
    }
  }
});
$c_sci_VectorStatics$.prototype.append1IfSpace__AO__sc_IterableOnce__AO = (function(suffix1, xs) {
  if ($is_sci_Iterable(xs)) {
    var x2 = $as_sci_Iterable(xs);
    if (($n(x2).sizeCompare__I__I(((32 - $n(suffix1).u.length) | 0)) <= 0)) {
      var x1$2 = $n(x2).size__I();
      switch (x1$2) {
        case 0: {
          return null;
          break;
        }
        case 1: {
          return this.copyAppend__AO__O__AO(suffix1, $n(x2).head__O());
          break;
        }
        default: {
          var newLength = (($n(suffix1).u.length + x1$2) | 0);
          var suffix1b = $m_ju_Arrays$().copyOf__AO__I__AO(suffix1, newLength);
          var this$1 = $n(x2);
          var start = $n(suffix1).u.length;
          this$1.copyToArray__O__I__I__I(suffix1b, start, 2147483647);
          return suffix1b;
        }
      }
    } else {
      return null;
    }
  } else {
    var s = $n(xs).knownSize__I();
    if (((s > 0) && (s <= ((32 - $n(suffix1).u.length) | 0)))) {
      var newLength$1 = (($n(suffix1).u.length + s) | 0);
      var suffix1b$2 = $m_ju_Arrays$().copyOf__AO__I__AO(suffix1, newLength$1);
      var this$2 = $n($n(xs).iterator__sc_Iterator());
      var start$1 = $n(suffix1).u.length;
      this$2.copyToArray__O__I__I__I(suffix1b$2, start$1, 2147483647);
      return suffix1b$2;
    } else {
      return null;
    }
  }
});
var $d_sci_VectorStatics$ = new $TypeData().initClass($c_sci_VectorStatics$, "scala.collection.immutable.VectorStatics$", ({
  sci_VectorStatics$: 1
}));
var $n_sci_VectorStatics$;
function $m_sci_VectorStatics$() {
  if ((!$n_sci_VectorStatics$)) {
    $n_sci_VectorStatics$ = new $c_sci_VectorStatics$();
  }
  return $n_sci_VectorStatics$;
}
/** @constructor */
function $c_scm_HashMap$Node(_key, _hash, _value, _next) {
  this.scm_HashMap$Node__f__key = null;
  this.scm_HashMap$Node__f__hash = 0;
  this.scm_HashMap$Node__f__value = null;
  this.scm_HashMap$Node__f__next = null;
  this.scm_HashMap$Node__f__key = _key;
  this.scm_HashMap$Node__f__hash = _hash;
  this.scm_HashMap$Node__f__value = _value;
  this.scm_HashMap$Node__f__next = _next;
}
$c_scm_HashMap$Node.prototype = new $h_O();
$c_scm_HashMap$Node.prototype.constructor = $c_scm_HashMap$Node;
/** @constructor */
function $h_scm_HashMap$Node() {
}
$h_scm_HashMap$Node.prototype = $c_scm_HashMap$Node.prototype;
$c_scm_HashMap$Node.prototype.findNode__O__I__scm_HashMap$Node = (function(k, h) {
  var _$this = this;
  while (true) {
    if (((h === $n(_$this).scm_HashMap$Node__f__hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(k, $n(_$this).scm_HashMap$Node__f__key))) {
      return _$this;
    } else if ((($n(_$this).scm_HashMap$Node__f__next === null) || ($n(_$this).scm_HashMap$Node__f__hash > h))) {
      return null;
    } else {
      _$this = $n(_$this).scm_HashMap$Node__f__next;
    }
  }
});
$c_scm_HashMap$Node.prototype.foreach__F1__V = (function(f) {
  var _$this = this;
  while (true) {
    $n(f).apply__O__O(new $c_T2($n(_$this).scm_HashMap$Node__f__key, $n(_$this).scm_HashMap$Node__f__value));
    if (($n(_$this).scm_HashMap$Node__f__next !== null)) {
      _$this = $n(_$this).scm_HashMap$Node__f__next;
      continue;
    }
    break;
  }
});
$c_scm_HashMap$Node.prototype.foreachEntry__F2__V = (function(f) {
  var _$this = this;
  while (true) {
    $n(f).apply__O__O__O($n(_$this).scm_HashMap$Node__f__key, $n(_$this).scm_HashMap$Node__f__value);
    if (($n(_$this).scm_HashMap$Node__f__next !== null)) {
      _$this = $n(_$this).scm_HashMap$Node__f__next;
      continue;
    }
    break;
  }
});
$c_scm_HashMap$Node.prototype.toString__T = (function() {
  return ((((((("Node(" + this.scm_HashMap$Node__f__key) + ", ") + this.scm_HashMap$Node__f__value) + ", ") + this.scm_HashMap$Node__f__hash) + ") -> ") + this.scm_HashMap$Node__f__next);
});
function $as_scm_HashMap$Node(obj) {
  return (((obj instanceof $c_scm_HashMap$Node) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.HashMap$Node"));
}
function $isArrayOf_scm_HashMap$Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_HashMap$Node)));
}
function $asArrayOf_scm_HashMap$Node(obj, depth) {
  return (($isArrayOf_scm_HashMap$Node(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.HashMap$Node;", depth));
}
var $d_scm_HashMap$Node = new $TypeData().initClass($c_scm_HashMap$Node, "scala.collection.mutable.HashMap$Node", ({
  scm_HashMap$Node: 1
}));
/** @constructor */
function $c_scm_HashSet$Node(_key, _hash, _next) {
  this.scm_HashSet$Node__f__key = null;
  this.scm_HashSet$Node__f__hash = 0;
  this.scm_HashSet$Node__f__next = null;
  this.scm_HashSet$Node__f__key = _key;
  this.scm_HashSet$Node__f__hash = _hash;
  this.scm_HashSet$Node__f__next = _next;
}
$c_scm_HashSet$Node.prototype = new $h_O();
$c_scm_HashSet$Node.prototype.constructor = $c_scm_HashSet$Node;
/** @constructor */
function $h_scm_HashSet$Node() {
}
$h_scm_HashSet$Node.prototype = $c_scm_HashSet$Node.prototype;
$c_scm_HashSet$Node.prototype.findNode__O__I__scm_HashSet$Node = (function(k, h) {
  var _$this = this;
  while (true) {
    if (((h === $n(_$this).scm_HashSet$Node__f__hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(k, $n(_$this).scm_HashSet$Node__f__key))) {
      return _$this;
    } else if ((($n(_$this).scm_HashSet$Node__f__next === null) || ($n(_$this).scm_HashSet$Node__f__hash > h))) {
      return null;
    } else {
      _$this = $n(_$this).scm_HashSet$Node__f__next;
    }
  }
});
$c_scm_HashSet$Node.prototype.foreach__F1__V = (function(f) {
  var _$this = this;
  while (true) {
    $n(f).apply__O__O($n(_$this).scm_HashSet$Node__f__key);
    if (($n(_$this).scm_HashSet$Node__f__next !== null)) {
      _$this = $n(_$this).scm_HashSet$Node__f__next;
      continue;
    }
    break;
  }
});
$c_scm_HashSet$Node.prototype.toString__T = (function() {
  return ((((("Node(" + this.scm_HashSet$Node__f__key) + ", ") + this.scm_HashSet$Node__f__hash) + ") -> ") + this.scm_HashSet$Node__f__next);
});
function $as_scm_HashSet$Node(obj) {
  return (((obj instanceof $c_scm_HashSet$Node) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.HashSet$Node"));
}
function $isArrayOf_scm_HashSet$Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_HashSet$Node)));
}
function $asArrayOf_scm_HashSet$Node(obj, depth) {
  return (($isArrayOf_scm_HashSet$Node(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.HashSet$Node;", depth));
}
var $d_scm_HashSet$Node = new $TypeData().initClass($c_scm_HashSet$Node, "scala.collection.mutable.HashSet$Node", ({
  scm_HashSet$Node: 1
}));
function $as_scm_LinkedHashMap$LinkedEntry(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.LinkedHashMap$LinkedEntry"));
}
function $isArrayOf_scm_LinkedHashMap$LinkedEntry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_LinkedHashMap$LinkedEntry)));
}
function $asArrayOf_scm_LinkedHashMap$LinkedEntry(obj, depth) {
  return (($isArrayOf_scm_LinkedHashMap$LinkedEntry(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.LinkedHashMap$LinkedEntry;", depth));
}
function $as_scm_LinkedHashSet$Entry(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.LinkedHashSet$Entry"));
}
function $isArrayOf_scm_LinkedHashSet$Entry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_LinkedHashSet$Entry)));
}
function $asArrayOf_scm_LinkedHashSet$Entry(obj, depth) {
  return (($isArrayOf_scm_LinkedHashSet$Entry(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.LinkedHashSet$Entry;", depth));
}
/** @constructor */
function $c_scm_MutationTracker$() {
}
$c_scm_MutationTracker$.prototype = new $h_O();
$c_scm_MutationTracker$.prototype.constructor = $c_scm_MutationTracker$;
/** @constructor */
function $h_scm_MutationTracker$() {
}
$h_scm_MutationTracker$.prototype = $c_scm_MutationTracker$.prototype;
$c_scm_MutationTracker$.prototype.checkMutations__I__I__T__V = (function(expectedCount, actualCount, message) {
  if ((actualCount !== expectedCount)) {
    throw new $c_ju_ConcurrentModificationException(message);
  }
});
var $d_scm_MutationTracker$ = new $TypeData().initClass($c_scm_MutationTracker$, "scala.collection.mutable.MutationTracker$", ({
  scm_MutationTracker$: 1
}));
var $n_scm_MutationTracker$;
function $m_scm_MutationTracker$() {
  if ((!$n_scm_MutationTracker$)) {
    $n_scm_MutationTracker$ = new $c_scm_MutationTracker$();
  }
  return $n_scm_MutationTracker$;
}
function $p_scm_RedBlackTree$__getNode__scm_RedBlackTree$Node__O__s_math_Ordering__scm_RedBlackTree$Node($thiz, node, key, ord) {
  while (true) {
    if ((node === null)) {
      return null;
    } else {
      var cmp = $n(ord).compare__O__O__I(key, $n(node).scm_RedBlackTree$Node__f_key);
      if ((cmp < 0)) {
        node = $n(node).scm_RedBlackTree$Node__f_left;
      } else if ((cmp > 0)) {
        node = $n(node).scm_RedBlackTree$Node__f_right;
      } else {
        return node;
      }
    }
  }
}
function $p_scm_RedBlackTree$__maxNode__scm_RedBlackTree$Node__scm_RedBlackTree$Node($thiz, node) {
  return ((node === null) ? null : $thiz.maxNodeNonNull__scm_RedBlackTree$Node__scm_RedBlackTree$Node(node));
}
function $p_scm_RedBlackTree$__fixAfterInsert__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, node) {
  var z = node;
  while ($thiz.isRed__scm_RedBlackTree$Node__Z($n(z).scm_RedBlackTree$Node__f_parent)) {
    if (($n(z).scm_RedBlackTree$Node__f_parent === $n($n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_left)) {
      var y = $n($n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_right;
      if ($thiz.isRed__scm_RedBlackTree$Node__Z(y)) {
        $n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_red = false;
        $n(y).scm_RedBlackTree$Node__f_red = false;
        $n($n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_red = true;
        z = $n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_parent;
      } else {
        if ((z === $n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_right)) {
          z = $n(z).scm_RedBlackTree$Node__f_parent;
          $p_scm_RedBlackTree$__rotateLeft__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, z);
        }
        $n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_red = false;
        $n($n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_red = true;
        $p_scm_RedBlackTree$__rotateRight__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, $n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_parent);
      }
    } else {
      var y$2 = $n($n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_left;
      if ($thiz.isRed__scm_RedBlackTree$Node__Z(y$2)) {
        $n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_red = false;
        $n(y$2).scm_RedBlackTree$Node__f_red = false;
        $n($n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_red = true;
        z = $n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_parent;
      } else {
        if ((z === $n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_left)) {
          z = $n(z).scm_RedBlackTree$Node__f_parent;
          $p_scm_RedBlackTree$__rotateRight__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, z);
        }
        $n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_red = false;
        $n($n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_red = true;
        $p_scm_RedBlackTree$__rotateLeft__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, $n($n(z).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_parent);
      }
    }
  }
  $n($n(tree).scm_RedBlackTree$Tree__f_root).scm_RedBlackTree$Node__f_red = false;
}
function $p_scm_RedBlackTree$__fixAfterDelete__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V($thiz, tree, node, parent) {
  var x = node;
  var xParent = parent;
  while (((x !== $n(tree).scm_RedBlackTree$Tree__f_root) && $thiz.isBlack__scm_RedBlackTree$Node__Z(x))) {
    if ((x === $n(xParent).scm_RedBlackTree$Node__f_left)) {
      var w = $n(xParent).scm_RedBlackTree$Node__f_right;
      if ($n(w).scm_RedBlackTree$Node__f_red) {
        $n(w).scm_RedBlackTree$Node__f_red = false;
        $n(xParent).scm_RedBlackTree$Node__f_red = true;
        $p_scm_RedBlackTree$__rotateLeft__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, xParent);
        w = $n(xParent).scm_RedBlackTree$Node__f_right;
      }
      if (($thiz.isBlack__scm_RedBlackTree$Node__Z($n(w).scm_RedBlackTree$Node__f_left) && $thiz.isBlack__scm_RedBlackTree$Node__Z($n(w).scm_RedBlackTree$Node__f_right))) {
        $n(w).scm_RedBlackTree$Node__f_red = true;
        x = xParent;
      } else {
        if ($thiz.isBlack__scm_RedBlackTree$Node__Z($n(w).scm_RedBlackTree$Node__f_right)) {
          $n($n(w).scm_RedBlackTree$Node__f_left).scm_RedBlackTree$Node__f_red = false;
          $n(w).scm_RedBlackTree$Node__f_red = true;
          $p_scm_RedBlackTree$__rotateRight__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, w);
          w = $n(xParent).scm_RedBlackTree$Node__f_right;
        }
        $n(w).scm_RedBlackTree$Node__f_red = $n(xParent).scm_RedBlackTree$Node__f_red;
        $n(xParent).scm_RedBlackTree$Node__f_red = false;
        $n($n(w).scm_RedBlackTree$Node__f_right).scm_RedBlackTree$Node__f_red = false;
        $p_scm_RedBlackTree$__rotateLeft__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, xParent);
        x = $n(tree).scm_RedBlackTree$Tree__f_root;
      }
    } else {
      var w$2 = $n(xParent).scm_RedBlackTree$Node__f_left;
      if ($n(w$2).scm_RedBlackTree$Node__f_red) {
        $n(w$2).scm_RedBlackTree$Node__f_red = false;
        $n(xParent).scm_RedBlackTree$Node__f_red = true;
        $p_scm_RedBlackTree$__rotateRight__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, xParent);
        w$2 = $n(xParent).scm_RedBlackTree$Node__f_left;
      }
      if (($thiz.isBlack__scm_RedBlackTree$Node__Z($n(w$2).scm_RedBlackTree$Node__f_right) && $thiz.isBlack__scm_RedBlackTree$Node__Z($n(w$2).scm_RedBlackTree$Node__f_left))) {
        $n(w$2).scm_RedBlackTree$Node__f_red = true;
        x = xParent;
      } else {
        if ($thiz.isBlack__scm_RedBlackTree$Node__Z($n(w$2).scm_RedBlackTree$Node__f_left)) {
          $n($n(w$2).scm_RedBlackTree$Node__f_right).scm_RedBlackTree$Node__f_red = false;
          $n(w$2).scm_RedBlackTree$Node__f_red = true;
          $p_scm_RedBlackTree$__rotateLeft__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, w$2);
          w$2 = $n(xParent).scm_RedBlackTree$Node__f_left;
        }
        $n(w$2).scm_RedBlackTree$Node__f_red = $n(xParent).scm_RedBlackTree$Node__f_red;
        $n(xParent).scm_RedBlackTree$Node__f_red = false;
        $n($n(w$2).scm_RedBlackTree$Node__f_left).scm_RedBlackTree$Node__f_red = false;
        $p_scm_RedBlackTree$__rotateRight__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, xParent);
        x = $n(tree).scm_RedBlackTree$Tree__f_root;
      }
    }
    xParent = $n(x).scm_RedBlackTree$Node__f_parent;
  }
  if ((x !== null)) {
    $n(x).scm_RedBlackTree$Node__f_red = false;
  }
}
function $p_scm_RedBlackTree$__rotateLeft__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, x) {
  if ((x !== null)) {
    var y = $n(x).scm_RedBlackTree$Node__f_right;
    $n(x).scm_RedBlackTree$Node__f_right = $n(y).scm_RedBlackTree$Node__f_left;
    if (($n(y).scm_RedBlackTree$Node__f_left !== null)) {
      $n($n(y).scm_RedBlackTree$Node__f_left).scm_RedBlackTree$Node__f_parent = x;
    }
    $n(y).scm_RedBlackTree$Node__f_parent = $n(x).scm_RedBlackTree$Node__f_parent;
    if (($n(x).scm_RedBlackTree$Node__f_parent === null)) {
      $n(tree).scm_RedBlackTree$Tree__f_root = y;
    } else if ((x === $n($n(x).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_left)) {
      $n($n(x).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_left = y;
    } else {
      $n($n(x).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_right = y;
    }
    $n(y).scm_RedBlackTree$Node__f_left = x;
    $n(x).scm_RedBlackTree$Node__f_parent = y;
  }
}
function $p_scm_RedBlackTree$__rotateRight__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, x) {
  if ((x !== null)) {
    var y = $n(x).scm_RedBlackTree$Node__f_left;
    $n(x).scm_RedBlackTree$Node__f_left = $n(y).scm_RedBlackTree$Node__f_right;
    if (($n(y).scm_RedBlackTree$Node__f_right !== null)) {
      $n($n(y).scm_RedBlackTree$Node__f_right).scm_RedBlackTree$Node__f_parent = x;
    }
    $n(y).scm_RedBlackTree$Node__f_parent = $n(x).scm_RedBlackTree$Node__f_parent;
    if (($n(x).scm_RedBlackTree$Node__f_parent === null)) {
      $n(tree).scm_RedBlackTree$Tree__f_root = y;
    } else if ((x === $n($n(x).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_right)) {
      $n($n(x).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_right = y;
    } else {
      $n($n(x).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_left = y;
    }
    $n(y).scm_RedBlackTree$Node__f_right = x;
    $n(x).scm_RedBlackTree$Node__f_parent = y;
  }
}
function $p_scm_RedBlackTree$__transplant__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V($thiz, tree, to, from) {
  if (($n(to).scm_RedBlackTree$Node__f_parent === null)) {
    $n(tree).scm_RedBlackTree$Tree__f_root = from;
  } else if ((to === $n($n(to).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_left)) {
    $n($n(to).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_left = from;
  } else {
    $n($n(to).scm_RedBlackTree$Node__f_parent).scm_RedBlackTree$Node__f_right = from;
  }
  if ((from !== null)) {
    $n(from).scm_RedBlackTree$Node__f_parent = $n(to).scm_RedBlackTree$Node__f_parent;
  }
}
function $p_scm_RedBlackTree$__g$1__scm_RedBlackTree$Node__F1__V($thiz, node, f$1) {
  while (true) {
    var l = $n(node).scm_RedBlackTree$Node__f_left;
    if ((l !== null)) {
      $p_scm_RedBlackTree$__g$1__scm_RedBlackTree$Node__F1__V($thiz, l, f$1);
    }
    $n(f$1).apply__O__O($n(node).scm_RedBlackTree$Node__f_key);
    var r = $n(node).scm_RedBlackTree$Node__f_right;
    if ((r !== null)) {
      node = r;
      continue;
    }
    return (void 0);
  }
}
function $p_scm_RedBlackTree$__f$3__I__I__sc_Iterator__I__scm_RedBlackTree$Node($thiz, level, size, xs$1, maxUsedDepth$1) {
  switch (size) {
    case 0: {
      return null;
      break;
    }
    case 1: {
      return new $c_scm_RedBlackTree$Node($n(xs$1).next__O(), null, ((level === maxUsedDepth$1) && (level !== 1)), null, null, null);
      break;
    }
    default: {
      var leftSize = (((((-1) + size) | 0) / 2) | 0);
      var left = $p_scm_RedBlackTree$__f$3__I__I__sc_Iterator__I__scm_RedBlackTree$Node($thiz, ((1 + level) | 0), leftSize, xs$1, maxUsedDepth$1);
      var x = $n(xs$1).next__O();
      var right = $p_scm_RedBlackTree$__f$3__I__I__sc_Iterator__I__scm_RedBlackTree$Node($thiz, ((1 + level) | 0), (((((-1) + size) | 0) - leftSize) | 0), xs$1, maxUsedDepth$1);
      var n = new $c_scm_RedBlackTree$Node(x, null, false, left, right, null);
      if ((left !== null)) {
        $n(left).scm_RedBlackTree$Node__f_parent = n;
      }
      $n(right).scm_RedBlackTree$Node__f_parent = n;
      return n;
    }
  }
}
/** @constructor */
function $c_scm_RedBlackTree$() {
}
$c_scm_RedBlackTree$.prototype = new $h_O();
$c_scm_RedBlackTree$.prototype.constructor = $c_scm_RedBlackTree$;
/** @constructor */
function $h_scm_RedBlackTree$() {
}
$h_scm_RedBlackTree$.prototype = $c_scm_RedBlackTree$.prototype;
$c_scm_RedBlackTree$.prototype.isRed__scm_RedBlackTree$Node__Z = (function(node) {
  return ((node !== null) && $n(node).scm_RedBlackTree$Node__f_red);
});
$c_scm_RedBlackTree$.prototype.isBlack__scm_RedBlackTree$Node__Z = (function(node) {
  return ((node === null) || (!$n(node).scm_RedBlackTree$Node__f_red));
});
$c_scm_RedBlackTree$.prototype.isEmpty__scm_RedBlackTree$Tree__Z = (function(tree) {
  return ($n(tree).scm_RedBlackTree$Tree__f_root === null);
});
$c_scm_RedBlackTree$.prototype.contains__scm_RedBlackTree$Tree__O__s_math_Ordering__Z = (function(tree, key, evidence$2) {
  return ($p_scm_RedBlackTree$__getNode__scm_RedBlackTree$Node__O__s_math_Ordering__scm_RedBlackTree$Node(this, $n(tree).scm_RedBlackTree$Tree__f_root, key, evidence$2) !== null);
});
$c_scm_RedBlackTree$.prototype.minKey__scm_RedBlackTree$Tree__s_Option = (function(tree) {
  var x1 = this.scala$collection$mutable$RedBlackTree$$minNode__scm_RedBlackTree$Node__scm_RedBlackTree$Node($n(tree).scm_RedBlackTree$Tree__f_root);
  return ((x1 === null) ? $m_s_None$() : new $c_s_Some($n(x1).scm_RedBlackTree$Node__f_key));
});
$c_scm_RedBlackTree$.prototype.scala$collection$mutable$RedBlackTree$$minNode__scm_RedBlackTree$Node__scm_RedBlackTree$Node = (function(node) {
  return ((node === null) ? null : this.minNodeNonNull__scm_RedBlackTree$Node__scm_RedBlackTree$Node(node));
});
$c_scm_RedBlackTree$.prototype.minNodeNonNull__scm_RedBlackTree$Node__scm_RedBlackTree$Node = (function(node) {
  while (true) {
    if (($n(node).scm_RedBlackTree$Node__f_left === null)) {
      return node;
    } else {
      node = $n(node).scm_RedBlackTree$Node__f_left;
    }
  }
});
$c_scm_RedBlackTree$.prototype.maxKey__scm_RedBlackTree$Tree__s_Option = (function(tree) {
  var x1 = $p_scm_RedBlackTree$__maxNode__scm_RedBlackTree$Node__scm_RedBlackTree$Node(this, $n(tree).scm_RedBlackTree$Tree__f_root);
  return ((x1 === null) ? $m_s_None$() : new $c_s_Some($n(x1).scm_RedBlackTree$Node__f_key));
});
$c_scm_RedBlackTree$.prototype.maxNodeNonNull__scm_RedBlackTree$Node__scm_RedBlackTree$Node = (function(node) {
  while (true) {
    if (($n(node).scm_RedBlackTree$Node__f_right === null)) {
      return node;
    } else {
      node = $n(node).scm_RedBlackTree$Node__f_right;
    }
  }
});
$c_scm_RedBlackTree$.prototype.scala$collection$mutable$RedBlackTree$$minNodeAfter__scm_RedBlackTree$Node__O__s_math_Ordering__scm_RedBlackTree$Node = (function(node, key, ord) {
  if ((node === null)) {
    return null;
  } else {
    var y = null;
    var x = node;
    var cmp = 1;
    while (((x !== null) && (cmp !== 0))) {
      y = x;
      cmp = $n(ord).compare__O__O__I(key, $n(x).scm_RedBlackTree$Node__f_key);
      x = ((cmp < 0) ? $n(x).scm_RedBlackTree$Node__f_left : $n(x).scm_RedBlackTree$Node__f_right);
    }
    return ((cmp <= 0) ? y : this.scala$collection$mutable$RedBlackTree$$successor__scm_RedBlackTree$Node__scm_RedBlackTree$Node(y));
  }
});
$c_scm_RedBlackTree$.prototype.insert__scm_RedBlackTree$Tree__O__O__s_math_Ordering__V = (function(tree, key, value, ord) {
  var y = null;
  var x = $n(tree).scm_RedBlackTree$Tree__f_root;
  var cmp = 1;
  while (((x !== null) && (cmp !== 0))) {
    y = x;
    cmp = $n(ord).compare__O__O__I(key, $n(x).scm_RedBlackTree$Node__f_key);
    x = ((cmp < 0) ? $n(x).scm_RedBlackTree$Node__f_left : $n(x).scm_RedBlackTree$Node__f_right);
  }
  if ((cmp === 0)) {
    $n(y).scm_RedBlackTree$Node__f_value = value;
  } else {
    var parent = y;
    var z = new $c_scm_RedBlackTree$Node(key, value, true, null, null, parent);
    if ((y === null)) {
      $n(tree).scm_RedBlackTree$Tree__f_root = z;
    } else if ((cmp < 0)) {
      $n(y).scm_RedBlackTree$Node__f_left = z;
    } else {
      $n(y).scm_RedBlackTree$Node__f_right = z;
    }
    $p_scm_RedBlackTree$__fixAfterInsert__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V(this, tree, z);
    $n(tree).scm_RedBlackTree$Tree__f_size = ((1 + $n(tree).scm_RedBlackTree$Tree__f_size) | 0);
  }
});
$c_scm_RedBlackTree$.prototype.delete__scm_RedBlackTree$Tree__O__s_math_Ordering__V = (function(tree, key, ord) {
  var z = $p_scm_RedBlackTree$__getNode__scm_RedBlackTree$Node__O__s_math_Ordering__scm_RedBlackTree$Node(this, $n(tree).scm_RedBlackTree$Tree__f_root, key, ord);
  if ((z !== null)) {
    var y = z;
    var yIsRed = $n(y).scm_RedBlackTree$Node__f_red;
    var x = null;
    var xParent = null;
    if (($n(z).scm_RedBlackTree$Node__f_left === null)) {
      x = $n(z).scm_RedBlackTree$Node__f_right;
      $p_scm_RedBlackTree$__transplant__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V(this, tree, z, $n(z).scm_RedBlackTree$Node__f_right);
      xParent = $n(z).scm_RedBlackTree$Node__f_parent;
    } else if (($n(z).scm_RedBlackTree$Node__f_right === null)) {
      x = $n(z).scm_RedBlackTree$Node__f_left;
      $p_scm_RedBlackTree$__transplant__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V(this, tree, z, $n(z).scm_RedBlackTree$Node__f_left);
      xParent = $n(z).scm_RedBlackTree$Node__f_parent;
    } else {
      y = this.minNodeNonNull__scm_RedBlackTree$Node__scm_RedBlackTree$Node($n(z).scm_RedBlackTree$Node__f_right);
      yIsRed = $n(y).scm_RedBlackTree$Node__f_red;
      x = $n(y).scm_RedBlackTree$Node__f_right;
      if (($n(y).scm_RedBlackTree$Node__f_parent === z)) {
        xParent = y;
      } else {
        xParent = $n(y).scm_RedBlackTree$Node__f_parent;
        $p_scm_RedBlackTree$__transplant__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V(this, tree, y, $n(y).scm_RedBlackTree$Node__f_right);
        $n(y).scm_RedBlackTree$Node__f_right = $n(z).scm_RedBlackTree$Node__f_right;
        $n($n(y).scm_RedBlackTree$Node__f_right).scm_RedBlackTree$Node__f_parent = y;
      }
      $p_scm_RedBlackTree$__transplant__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V(this, tree, z, y);
      $n(y).scm_RedBlackTree$Node__f_left = $n(z).scm_RedBlackTree$Node__f_left;
      $n($n(y).scm_RedBlackTree$Node__f_left).scm_RedBlackTree$Node__f_parent = y;
      $n(y).scm_RedBlackTree$Node__f_red = $n(z).scm_RedBlackTree$Node__f_red;
    }
    if ((!yIsRed)) {
      $p_scm_RedBlackTree$__fixAfterDelete__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V(this, tree, x, xParent);
    }
    $n(tree).scm_RedBlackTree$Tree__f_size = (((-1) + $n(tree).scm_RedBlackTree$Tree__f_size) | 0);
  }
});
$c_scm_RedBlackTree$.prototype.scala$collection$mutable$RedBlackTree$$successor__scm_RedBlackTree$Node__scm_RedBlackTree$Node = (function(node) {
  if (($n(node).scm_RedBlackTree$Node__f_right !== null)) {
    return this.minNodeNonNull__scm_RedBlackTree$Node__scm_RedBlackTree$Node($n(node).scm_RedBlackTree$Node__f_right);
  } else {
    var x = node;
    var y = $n(x).scm_RedBlackTree$Node__f_parent;
    while (((y !== null) && (x === $n(y).scm_RedBlackTree$Node__f_right))) {
      x = y;
      y = $n(y).scm_RedBlackTree$Node__f_parent;
    }
    return y;
  }
});
$c_scm_RedBlackTree$.prototype.foreachKey__scm_RedBlackTree$Tree__F1__V = (function(tree, f) {
  var r = $n(tree).scm_RedBlackTree$Tree__f_root;
  if ((r !== null)) {
    $p_scm_RedBlackTree$__g$1__scm_RedBlackTree$Node__F1__V(this, r, f);
  }
});
$c_scm_RedBlackTree$.prototype.fromOrderedKeys__sc_Iterator__I__scm_RedBlackTree$Tree = (function(xs, size) {
  var maxUsedDepth = ((32 - $uI(Math.clz32(size))) | 0);
  return new $c_scm_RedBlackTree$Tree($p_scm_RedBlackTree$__f$3__I__I__sc_Iterator__I__scm_RedBlackTree$Node(this, 1, size, xs, maxUsedDepth), size);
});
$c_scm_RedBlackTree$.prototype.copyTree__scm_RedBlackTree$Node__scm_RedBlackTree$Node = (function(n) {
  if ((n === null)) {
    return null;
  } else {
    var c = new $c_scm_RedBlackTree$Node($n(n).scm_RedBlackTree$Node__f_key, $n(n).scm_RedBlackTree$Node__f_value, $n(n).scm_RedBlackTree$Node__f_red, this.copyTree__scm_RedBlackTree$Node__scm_RedBlackTree$Node($n(n).scm_RedBlackTree$Node__f_left), this.copyTree__scm_RedBlackTree$Node__scm_RedBlackTree$Node($n(n).scm_RedBlackTree$Node__f_right), null);
    if ((c.scm_RedBlackTree$Node__f_left !== null)) {
      $n(c.scm_RedBlackTree$Node__f_left).scm_RedBlackTree$Node__f_parent = c;
    }
    if ((c.scm_RedBlackTree$Node__f_right !== null)) {
      $n(c.scm_RedBlackTree$Node__f_right).scm_RedBlackTree$Node__f_parent = c;
    }
    return c;
  }
});
var $d_scm_RedBlackTree$ = new $TypeData().initClass($c_scm_RedBlackTree$, "scala.collection.mutable.RedBlackTree$", ({
  scm_RedBlackTree$: 1
}));
var $n_scm_RedBlackTree$;
function $m_scm_RedBlackTree$() {
  if ((!$n_scm_RedBlackTree$)) {
    $n_scm_RedBlackTree$ = new $c_scm_RedBlackTree$();
  }
  return $n_scm_RedBlackTree$;
}
/** @constructor */
function $c_scm_RedBlackTree$Node(key, value, red, left, right, parent) {
  this.scm_RedBlackTree$Node__f_key = null;
  this.scm_RedBlackTree$Node__f_value = null;
  this.scm_RedBlackTree$Node__f_red = false;
  this.scm_RedBlackTree$Node__f_left = null;
  this.scm_RedBlackTree$Node__f_right = null;
  this.scm_RedBlackTree$Node__f_parent = null;
  this.scm_RedBlackTree$Node__f_key = key;
  this.scm_RedBlackTree$Node__f_value = value;
  this.scm_RedBlackTree$Node__f_red = red;
  this.scm_RedBlackTree$Node__f_left = left;
  this.scm_RedBlackTree$Node__f_right = right;
  this.scm_RedBlackTree$Node__f_parent = parent;
}
$c_scm_RedBlackTree$Node.prototype = new $h_O();
$c_scm_RedBlackTree$Node.prototype.constructor = $c_scm_RedBlackTree$Node;
/** @constructor */
function $h_scm_RedBlackTree$Node() {
}
$h_scm_RedBlackTree$Node.prototype = $c_scm_RedBlackTree$Node.prototype;
$c_scm_RedBlackTree$Node.prototype.toString__T = (function() {
  return (((((((((("Node(" + this.scm_RedBlackTree$Node__f_key) + ", ") + this.scm_RedBlackTree$Node__f_value) + ", ") + this.scm_RedBlackTree$Node__f_red) + ", ") + this.scm_RedBlackTree$Node__f_left) + ", ") + this.scm_RedBlackTree$Node__f_right) + ")");
});
var $d_scm_RedBlackTree$Node = new $TypeData().initClass($c_scm_RedBlackTree$Node, "scala.collection.mutable.RedBlackTree$Node", ({
  scm_RedBlackTree$Node: 1
}));
/** @constructor */
function $c_scm_RedBlackTree$Tree(root, size) {
  this.scm_RedBlackTree$Tree__f_root = null;
  this.scm_RedBlackTree$Tree__f_size = 0;
  this.scm_RedBlackTree$Tree__f_root = root;
  this.scm_RedBlackTree$Tree__f_size = size;
}
$c_scm_RedBlackTree$Tree.prototype = new $h_O();
$c_scm_RedBlackTree$Tree.prototype.constructor = $c_scm_RedBlackTree$Tree;
/** @constructor */
function $h_scm_RedBlackTree$Tree() {
}
$h_scm_RedBlackTree$Tree.prototype = $c_scm_RedBlackTree$Tree.prototype;
$c_scm_RedBlackTree$Tree.prototype.treeCopy__scm_RedBlackTree$Tree = (function() {
  return new $c_scm_RedBlackTree$Tree($m_scm_RedBlackTree$().copyTree__scm_RedBlackTree$Node__scm_RedBlackTree$Node(this.scm_RedBlackTree$Tree__f_root), this.scm_RedBlackTree$Tree__f_size);
});
var $d_scm_RedBlackTree$Tree = new $TypeData().initClass($c_scm_RedBlackTree$Tree, "scala.collection.mutable.RedBlackTree$Tree", ({
  scm_RedBlackTree$Tree: 1
}));
/** @constructor */
function $c_sc_package$$colon$plus$() {
}
$c_sc_package$$colon$plus$.prototype = new $h_O();
$c_sc_package$$colon$plus$.prototype.constructor = $c_sc_package$$colon$plus$;
/** @constructor */
function $h_sc_package$$colon$plus$() {
}
$h_sc_package$$colon$plus$.prototype = $c_sc_package$$colon$plus$.prototype;
$c_sc_package$$colon$plus$.prototype.unapply__sc_SeqOps__s_Option = (function(t) {
  if ($n(t).isEmpty__Z()) {
    return $m_s_None$();
  } else {
    var self = $n(t).init__O();
    var y = $n(t).last__O();
    return new $c_s_Some(new $c_T2(self, y));
  }
});
var $d_sc_package$$colon$plus$ = new $TypeData().initClass($c_sc_package$$colon$plus$, "scala.collection.package$$colon$plus$", ({
  sc_package$$colon$plus$: 1
}));
var $n_sc_package$$colon$plus$;
function $m_sc_package$$colon$plus$() {
  if ((!$n_sc_package$$colon$plus$)) {
    $n_sc_package$$colon$plus$ = new $c_sc_package$$colon$plus$();
  }
  return $n_sc_package$$colon$plus$;
}
function $p_s_concurrent_BatchingExecutor$AbstractBatch__ensureCapacity__I__Ajl_Runnable($thiz, curSize) {
  var curOther = $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_other;
  var curLen = $n(curOther).u.length;
  if ((curSize <= curLen)) {
    return curOther;
  } else {
    var newLen = ((curLen === 0) ? 4 : (curLen << 1));
    if ((newLen <= curLen)) {
      throw new $c_jl_StackOverflowError(("Space limit of asynchronous stack reached: " + curLen));
    }
    var newOther = new ($d_jl_Runnable.getArrayOf().constr)(newLen);
    $systemArraycopyRefs($n(curOther), 0, newOther, 0, curLen);
    $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_other = newOther;
    return newOther;
  }
}
function $ct_s_concurrent_BatchingExecutor$AbstractBatch__s_concurrent_BatchingExecutor__jl_Runnable__Ajl_Runnable__I__($thiz, outer, first, other, size) {
  $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_first = first;
  $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_other = other;
  $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_size = size;
  $n(outer);
  $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_$outer = outer;
  return $thiz;
}
/** @constructor */
function $c_s_concurrent_BatchingExecutor$AbstractBatch() {
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_first = null;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_other = null;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = 0;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_$outer = null;
}
$c_s_concurrent_BatchingExecutor$AbstractBatch.prototype = new $h_O();
$c_s_concurrent_BatchingExecutor$AbstractBatch.prototype.constructor = $c_s_concurrent_BatchingExecutor$AbstractBatch;
/** @constructor */
function $h_s_concurrent_BatchingExecutor$AbstractBatch() {
}
$h_s_concurrent_BatchingExecutor$AbstractBatch.prototype = $c_s_concurrent_BatchingExecutor$AbstractBatch.prototype;
$c_s_concurrent_BatchingExecutor$AbstractBatch.prototype.push__jl_Runnable__V = (function(r) {
  var sz = this.s_concurrent_BatchingExecutor$AbstractBatch__f_size;
  if ((sz === 0)) {
    this.s_concurrent_BatchingExecutor$AbstractBatch__f_first = r;
  } else {
    $n($p_s_concurrent_BatchingExecutor$AbstractBatch__ensureCapacity__I__Ajl_Runnable(this, sz)).set((((-1) + sz) | 0), r);
  }
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = ((1 + sz) | 0);
});
$c_s_concurrent_BatchingExecutor$AbstractBatch.prototype.runN__I__V = (function(n) {
  while (true) {
    if ((n > 0)) {
      var x1 = this.s_concurrent_BatchingExecutor$AbstractBatch__f_size;
      switch (x1) {
        case 0: {
          break;
        }
        case 1: {
          var next = this.s_concurrent_BatchingExecutor$AbstractBatch__f_first;
          this.s_concurrent_BatchingExecutor$AbstractBatch__f_first = null;
          this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = 0;
          $n(next).run__V();
          n = (((-1) + n) | 0);
          continue;
          break;
        }
        default: {
          var o = this.s_concurrent_BatchingExecutor$AbstractBatch__f_other;
          var next$2 = $n(o).get((((-2) + x1) | 0));
          $n(o).set((((-2) + x1) | 0), null);
          this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = (((-1) + x1) | 0);
          $n(next$2).run__V();
          n = (((-1) + n) | 0);
          continue;
        }
      }
    }
    return (void 0);
  }
});
/** @constructor */
function $c_s_concurrent_BatchingExecutorStatics$() {
  this.s_concurrent_BatchingExecutorStatics$__f_emptyBatchArray = null;
  $n_s_concurrent_BatchingExecutorStatics$ = this;
  this.s_concurrent_BatchingExecutorStatics$__f_emptyBatchArray = new ($d_jl_Runnable.getArrayOf().constr)(0);
}
$c_s_concurrent_BatchingExecutorStatics$.prototype = new $h_O();
$c_s_concurrent_BatchingExecutorStatics$.prototype.constructor = $c_s_concurrent_BatchingExecutorStatics$;
/** @constructor */
function $h_s_concurrent_BatchingExecutorStatics$() {
}
$h_s_concurrent_BatchingExecutorStatics$.prototype = $c_s_concurrent_BatchingExecutorStatics$.prototype;
var $d_s_concurrent_BatchingExecutorStatics$ = new $TypeData().initClass($c_s_concurrent_BatchingExecutorStatics$, "scala.concurrent.BatchingExecutorStatics$", ({
  s_concurrent_BatchingExecutorStatics$: 1
}));
var $n_s_concurrent_BatchingExecutorStatics$;
function $m_s_concurrent_BatchingExecutorStatics$() {
  if ((!$n_s_concurrent_BatchingExecutorStatics$)) {
    $n_s_concurrent_BatchingExecutorStatics$ = new $c_s_concurrent_BatchingExecutorStatics$();
  }
  return $n_s_concurrent_BatchingExecutorStatics$;
}
function $is_s_concurrent_ExecutionContext(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_concurrent_ExecutionContext)));
}
function $as_s_concurrent_ExecutionContext(obj) {
  return (($is_s_concurrent_ExecutionContext(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.ExecutionContext"));
}
function $isArrayOf_s_concurrent_ExecutionContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_ExecutionContext)));
}
function $asArrayOf_s_concurrent_ExecutionContext(obj, depth) {
  return (($isArrayOf_s_concurrent_ExecutionContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.ExecutionContext;", depth));
}
/** @constructor */
function $c_s_concurrent_ExecutionContext$() {
  this.s_concurrent_ExecutionContext$__f_defaultReporter = null;
  $n_s_concurrent_ExecutionContext$ = this;
  this.s_concurrent_ExecutionContext$__f_defaultReporter = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_jl_Throwable(x$1$2);
    var this$2 = $n(x$1);
    this$2.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err);
  }));
}
$c_s_concurrent_ExecutionContext$.prototype = new $h_O();
$c_s_concurrent_ExecutionContext$.prototype.constructor = $c_s_concurrent_ExecutionContext$;
/** @constructor */
function $h_s_concurrent_ExecutionContext$() {
}
$h_s_concurrent_ExecutionContext$.prototype = $c_s_concurrent_ExecutionContext$.prototype;
var $d_s_concurrent_ExecutionContext$ = new $TypeData().initClass($c_s_concurrent_ExecutionContext$, "scala.concurrent.ExecutionContext$", ({
  s_concurrent_ExecutionContext$: 1
}));
var $n_s_concurrent_ExecutionContext$;
function $m_s_concurrent_ExecutionContext$() {
  if ((!$n_s_concurrent_ExecutionContext$)) {
    $n_s_concurrent_ExecutionContext$ = new $c_s_concurrent_ExecutionContext$();
  }
  return $n_s_concurrent_ExecutionContext$;
}
/** @constructor */
function $c_s_concurrent_Future$() {
  this.s_concurrent_Future$__f_collectFailed = null;
  this.s_concurrent_Future$__f_filterFailure = null;
  this.s_concurrent_Future$__f_failedFailure = null;
  this.s_concurrent_Future$__f_recoverWithFailedMarker = null;
  this.s_concurrent_Future$__f_recoverWithFailed = null;
  $n_s_concurrent_Future$ = this;
  var this$22 = $m_sci_Map$();
  var array = [new $c_T2($d_Z.getClassOf(), $d_jl_Boolean.getClassOf()), new $c_T2($d_B.getClassOf(), $d_jl_Byte.getClassOf()), new $c_T2($d_C.getClassOf(), $d_jl_Character.getClassOf()), new $c_T2($d_S.getClassOf(), $d_jl_Short.getClassOf()), new $c_T2($d_I.getClassOf(), $d_jl_Integer.getClassOf()), new $c_T2($d_J.getClassOf(), $d_jl_Long.getClassOf()), new $c_T2($d_F.getClassOf(), $d_jl_Float.getClassOf()), new $c_T2($d_D.getClassOf(), $d_jl_Double.getClassOf()), new $c_T2($d_V.getClassOf(), $d_jl_Void.getClassOf())];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this$22.from__sc_IterableOnce__sci_Map(elems);
  this.s_concurrent_Future$__f_collectFailed = new $c_sjsr_AnonFunction1(((t$2) => {
    throw new $c_s_concurrent_Future$$anon$1(t$2);
  }));
  this.s_concurrent_Future$__f_filterFailure = new $c_s_util_Failure(new $c_s_concurrent_Future$$anon$2());
  this.s_concurrent_Future$__f_failedFailure = new $c_s_util_Failure(new $c_s_concurrent_Future$$anon$3());
  this.fromTry__s_util_Try__s_concurrent_Future(this.s_concurrent_Future$__f_failedFailure);
  this.s_concurrent_Future$__f_recoverWithFailedMarker = this.failed__jl_Throwable__s_concurrent_Future(new $c_s_concurrent_Future$$anon$4());
  this.s_concurrent_Future$__f_recoverWithFailed = new $c_sjsr_AnonFunction1(((t$3$2) => {
    $as_jl_Throwable(t$3$2);
    return $m_s_concurrent_Future$().s_concurrent_Future$__f_recoverWithFailedMarker;
  }));
  this.fromTry__s_util_Try__s_concurrent_Future(new $c_s_util_Success((void 0)));
}
$c_s_concurrent_Future$.prototype = new $h_O();
$c_s_concurrent_Future$.prototype.constructor = $c_s_concurrent_Future$;
/** @constructor */
function $h_s_concurrent_Future$() {
}
$h_s_concurrent_Future$.prototype = $c_s_concurrent_Future$.prototype;
$c_s_concurrent_Future$.prototype.failed__jl_Throwable__s_concurrent_Future = (function(exception) {
  return $n($m_s_concurrent_Promise$().failed__jl_Throwable__s_concurrent_Promise(exception));
});
$c_s_concurrent_Future$.prototype.successful__O__s_concurrent_Future = (function(result) {
  return $n($m_s_concurrent_Promise$().successful__O__s_concurrent_Promise(result));
});
$c_s_concurrent_Future$.prototype.fromTry__s_util_Try__s_concurrent_Future = (function(result) {
  return $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__(new $c_s_concurrent_impl_Promise$DefaultPromise(), result);
});
var $d_s_concurrent_Future$ = new $TypeData().initClass($c_s_concurrent_Future$, "scala.concurrent.Future$", ({
  s_concurrent_Future$: 1
}));
var $n_s_concurrent_Future$;
function $m_s_concurrent_Future$() {
  if ((!$n_s_concurrent_Future$)) {
    $n_s_concurrent_Future$ = new $c_s_concurrent_Future$();
  }
  return $n_s_concurrent_Future$;
}
function $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise($thiz, result) {
  if ($thiz.tryComplete__s_util_Try__Z(result)) {
    return $thiz;
  } else {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Promise already completed.");
  }
}
function $f_s_concurrent_Promise__success__O__s_concurrent_Promise($thiz, value) {
  var result = new $c_s_util_Success(value);
  return $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise($thiz, result);
}
function $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise($thiz, cause) {
  var result = new $c_s_util_Failure(cause);
  return $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise($thiz, result);
}
/** @constructor */
function $c_s_concurrent_Promise$() {
}
$c_s_concurrent_Promise$.prototype = new $h_O();
$c_s_concurrent_Promise$.prototype.constructor = $c_s_concurrent_Promise$;
/** @constructor */
function $h_s_concurrent_Promise$() {
}
$h_s_concurrent_Promise$.prototype = $c_s_concurrent_Promise$.prototype;
$c_s_concurrent_Promise$.prototype.failed__jl_Throwable__s_concurrent_Promise = (function(exception) {
  var result = new $c_s_util_Failure(exception);
  return $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__(new $c_s_concurrent_impl_Promise$DefaultPromise(), result);
});
$c_s_concurrent_Promise$.prototype.successful__O__s_concurrent_Promise = (function(result) {
  var result$1 = new $c_s_util_Success(result);
  return $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__(new $c_s_concurrent_impl_Promise$DefaultPromise(), result$1);
});
var $d_s_concurrent_Promise$ = new $TypeData().initClass($c_s_concurrent_Promise$, "scala.concurrent.Promise$", ({
  s_concurrent_Promise$: 1
}));
var $n_s_concurrent_Promise$;
function $m_s_concurrent_Promise$() {
  if ((!$n_s_concurrent_Promise$)) {
    $n_s_concurrent_Promise$ = new $c_s_concurrent_Promise$();
  }
  return $n_s_concurrent_Promise$;
}
/** @constructor */
function $c_s_concurrent_duration_package$DurationInt$() {
}
$c_s_concurrent_duration_package$DurationInt$.prototype = new $h_O();
$c_s_concurrent_duration_package$DurationInt$.prototype.constructor = $c_s_concurrent_duration_package$DurationInt$;
/** @constructor */
function $h_s_concurrent_duration_package$DurationInt$() {
}
$h_s_concurrent_duration_package$DurationInt$.prototype = $c_s_concurrent_duration_package$DurationInt$.prototype;
$c_s_concurrent_duration_package$DurationInt$.prototype.equals$extension__I__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_s_concurrent_duration_package$DurationInt)) {
    var DurationInt$1 = $n($as_s_concurrent_duration_package$DurationInt(x$1)).s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
    return (this$ === DurationInt$1);
  } else {
    return false;
  }
});
var $d_s_concurrent_duration_package$DurationInt$ = new $TypeData().initClass($c_s_concurrent_duration_package$DurationInt$, "scala.concurrent.duration.package$DurationInt$", ({
  s_concurrent_duration_package$DurationInt$: 1
}));
var $n_s_concurrent_duration_package$DurationInt$;
function $m_s_concurrent_duration_package$DurationInt$() {
  if ((!$n_s_concurrent_duration_package$DurationInt$)) {
    $n_s_concurrent_duration_package$DurationInt$ = new $c_s_concurrent_duration_package$DurationInt$();
  }
  return $n_s_concurrent_duration_package$DurationInt$;
}
/** @constructor */
function $c_s_concurrent_duration_package$DurationLong$() {
}
$c_s_concurrent_duration_package$DurationLong$.prototype = new $h_O();
$c_s_concurrent_duration_package$DurationLong$.prototype.constructor = $c_s_concurrent_duration_package$DurationLong$;
/** @constructor */
function $h_s_concurrent_duration_package$DurationLong$() {
}
$h_s_concurrent_duration_package$DurationLong$.prototype = $c_s_concurrent_duration_package$DurationLong$.prototype;
$c_s_concurrent_duration_package$DurationLong$.prototype.equals$extension__J__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_s_concurrent_duration_package$DurationLong)) {
    var t = $n($as_s_concurrent_duration_package$DurationLong(x$1)).s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return ((this$.RTLong__f_lo === lo) && (this$.RTLong__f_hi === hi));
  } else {
    return false;
  }
});
var $d_s_concurrent_duration_package$DurationLong$ = new $TypeData().initClass($c_s_concurrent_duration_package$DurationLong$, "scala.concurrent.duration.package$DurationLong$", ({
  s_concurrent_duration_package$DurationLong$: 1
}));
var $n_s_concurrent_duration_package$DurationLong$;
function $m_s_concurrent_duration_package$DurationLong$() {
  if ((!$n_s_concurrent_duration_package$DurationLong$)) {
    $n_s_concurrent_duration_package$DurationLong$ = new $c_s_concurrent_duration_package$DurationLong$();
  }
  return $n_s_concurrent_duration_package$DurationLong$;
}
/** @constructor */
function $c_s_concurrent_impl_Promise$() {
  this.s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop = null;
  $n_s_concurrent_impl_Promise$ = this;
  this.s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop = $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 0, null, $m_s_concurrent_ExecutionContext$parasitic$());
}
$c_s_concurrent_impl_Promise$.prototype = new $h_O();
$c_s_concurrent_impl_Promise$.prototype.constructor = $c_s_concurrent_impl_Promise$;
/** @constructor */
function $h_s_concurrent_impl_Promise$() {
}
$h_s_concurrent_impl_Promise$.prototype = $c_s_concurrent_impl_Promise$.prototype;
$c_s_concurrent_impl_Promise$.prototype.scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try = (function(value) {
  if ((value === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((value instanceof $c_s_util_Success)) {
    return value;
  } else {
    var t = $n($as_s_util_Failure(value)).s_util_Failure__f_exception;
    return (((false || false) || (t instanceof $c_jl_Error)) ? (false ? new $c_s_util_Success($n($as_sr_NonLocalReturnControl(t)).value__O()) : new $c_s_util_Failure(new $c_ju_concurrent_ExecutionException("Boxed Exception", t))) : value);
  }
});
var $d_s_concurrent_impl_Promise$ = new $TypeData().initClass($c_s_concurrent_impl_Promise$, "scala.concurrent.impl.Promise$", ({
  s_concurrent_impl_Promise$: 1
}));
var $n_s_concurrent_impl_Promise$;
function $m_s_concurrent_impl_Promise$() {
  if ((!$n_s_concurrent_impl_Promise$)) {
    $n_s_concurrent_impl_Promise$ = new $c_s_concurrent_impl_Promise$();
  }
  return $n_s_concurrent_impl_Promise$;
}
function $is_s_concurrent_impl_Promise$Callbacks(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_concurrent_impl_Promise$Callbacks)));
}
function $as_s_concurrent_impl_Promise$Callbacks(obj) {
  return (($is_s_concurrent_impl_Promise$Callbacks(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.impl.Promise$Callbacks"));
}
function $isArrayOf_s_concurrent_impl_Promise$Callbacks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$Callbacks)));
}
function $asArrayOf_s_concurrent_impl_Promise$Callbacks(obj, depth) {
  return (($isArrayOf_s_concurrent_impl_Promise$Callbacks(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.impl.Promise$Callbacks;", depth));
}
function $ct_s_math_Numeric$NumericOps__s_math_Numeric__O__($thiz, outer, lhs) {
  $thiz.s_math_Numeric$NumericOps__f_lhs = lhs;
  $n(outer);
  $thiz.s_math_Numeric$NumericOps__f_$outer = outer;
  return $thiz;
}
/** @constructor */
function $c_s_math_Numeric$NumericOps() {
  this.s_math_Numeric$NumericOps__f_lhs = null;
  this.s_math_Numeric$NumericOps__f_$outer = null;
}
$c_s_math_Numeric$NumericOps.prototype = new $h_O();
$c_s_math_Numeric$NumericOps.prototype.constructor = $c_s_math_Numeric$NumericOps;
/** @constructor */
function $h_s_math_Numeric$NumericOps() {
}
$h_s_math_Numeric$NumericOps.prototype = $c_s_math_Numeric$NumericOps.prototype;
$c_s_math_Numeric$NumericOps.prototype.$plus__O__O = (function(rhs) {
  return $n(this.s_math_Numeric$NumericOps__f_$outer).plus__O__O__O(this.s_math_Numeric$NumericOps__f_lhs, rhs);
});
$c_s_math_Numeric$NumericOps.prototype.$minus__O__O = (function(rhs) {
  return $n(this.s_math_Numeric$NumericOps__f_$outer).minus__O__O__O(this.s_math_Numeric$NumericOps__f_lhs, rhs);
});
$c_s_math_Numeric$NumericOps.prototype.$times__O__O = (function(rhs) {
  return $n(this.s_math_Numeric$NumericOps__f_$outer).times__O__O__O(this.s_math_Numeric$NumericOps__f_lhs, rhs);
});
$c_s_math_Numeric$NumericOps.prototype.unary_$minus__O = (function() {
  return $n(this.s_math_Numeric$NumericOps__f_$outer).negate__O__O(this.s_math_Numeric$NumericOps__f_lhs);
});
/** @constructor */
function $c_s_math_Ordering$OrderingOps(outer, lhs) {
  this.s_math_Ordering$OrderingOps__f_lhs = null;
  this.s_math_Ordering$OrderingOps__f_$outer = null;
  this.s_math_Ordering$OrderingOps__f_lhs = lhs;
  $n(outer);
  this.s_math_Ordering$OrderingOps__f_$outer = outer;
}
$c_s_math_Ordering$OrderingOps.prototype = new $h_O();
$c_s_math_Ordering$OrderingOps.prototype.constructor = $c_s_math_Ordering$OrderingOps;
/** @constructor */
function $h_s_math_Ordering$OrderingOps() {
}
$h_s_math_Ordering$OrderingOps.prototype = $c_s_math_Ordering$OrderingOps.prototype;
$c_s_math_Ordering$OrderingOps.prototype.$greater__O__Z = (function(rhs) {
  return $n(this.s_math_Ordering$OrderingOps__f_$outer).gt__O__O__Z(this.s_math_Ordering$OrderingOps__f_lhs, rhs);
});
var $d_s_math_Ordering$OrderingOps = new $TypeData().initClass($c_s_math_Ordering$OrderingOps, "scala.math.Ordering$OrderingOps", ({
  s_math_Ordering$OrderingOps: 1
}));
function $f_s_math_ScalaNumericAnyConversions__isValidByte__Z($thiz) {
  return ($thiz.isWhole__Z() && ($thiz.intValue__I() === $thiz.byteValue__B()));
}
function $f_s_math_ScalaNumericAnyConversions__isValidShort__Z($thiz) {
  return ($thiz.isWhole__Z() && ($thiz.intValue__I() === $thiz.shortValue__S()));
}
function $f_s_math_ScalaNumericAnyConversions__isValidInt__Z($thiz) {
  if ($thiz.isWhole__Z()) {
    var this$2 = $thiz.longValue__J();
    var value = $thiz.intValue__I();
    var hi = (value >> 31);
    return ((this$2.RTLong__f_lo === value) && (this$2.RTLong__f_hi === hi));
  } else {
    return false;
  }
}
function $f_s_math_ScalaNumericAnyConversions__isValidChar__Z($thiz) {
  return ($thiz.isWhole__Z() && (($thiz.intValue__I() >= 0) && ($thiz.intValue__I() <= 65535)));
}
function $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveHashcode__I($thiz) {
  var t = $thiz.longValue__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return ((((hi === (-1)) ? (((-2147483648) ^ lo) >= 0) : (hi > (-1))) && ((hi === 0) ? (((-2147483648) ^ lo) <= (-1)) : (hi < 0))) ? lo : $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi)));
}
function $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z($thiz, x) {
  if ((x instanceof $Char)) {
    var x2 = $uC(x);
    return ($thiz.isValidChar__Z() && ($thiz.intValue__I() === x2));
  } else if ($isByte(x)) {
    var x3 = $uB(x);
    return ($thiz.isValidByte__Z() && ($thiz.byteValue__B() === x3));
  } else if ($isShort(x)) {
    var x4 = $uS(x);
    return ($thiz.isValidShort__Z() && ($thiz.shortValue__S() === x4));
  } else if ($isInt(x)) {
    var x5 = $uI(x);
    return ($thiz.isValidInt__Z() && ($thiz.intValue__I() === x5));
  } else if ((x instanceof $c_RTLong)) {
    var t = $uJ(x);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var this$1 = $thiz.longValue__J();
    return ((this$1.RTLong__f_lo === lo) && (this$1.RTLong__f_hi === hi));
  } else if ($isFloat(x)) {
    var x7 = $uF(x);
    return ($thiz.floatValue__F() === x7);
  } else if (((typeof x) === "number")) {
    var x8 = $uD(x);
    return ($thiz.doubleValue__D() === x8);
  } else {
    return false;
  }
}
/** @constructor */
function $c_s_math_package$() {
}
$c_s_math_package$.prototype = new $h_O();
$c_s_math_package$.prototype.constructor = $c_s_math_package$;
/** @constructor */
function $h_s_math_package$() {
}
$h_s_math_package$.prototype = $c_s_math_package$.prototype;
$c_s_math_package$.prototype.signum__J__J = (function(x) {
  var hi = x.RTLong__f_hi;
  var value = ((hi < 0) ? (-1) : (((hi === 0) && (x.RTLong__f_lo === 0)) ? 0 : 1));
  var hi$1 = (value >> 31);
  return new $c_RTLong(value, hi$1);
});
var $d_s_math_package$ = new $TypeData().initClass($c_s_math_package$, "scala.math.package$", ({
  s_math_package$: 1
}));
var $n_s_math_package$;
function $m_s_math_package$() {
  if ((!$n_s_math_package$)) {
    $n_s_math_package$ = new $c_s_math_package$();
  }
  return $n_s_math_package$;
}
function $p_s_package$__BigDecimal$lzycompute__s_math_BigDecimal$($thiz) {
  if (((((1 & $thiz.s_package$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.s_package$__f_BigDecimal = $m_s_math_BigDecimal$();
    $thiz.s_package$__f_bitmap$0 = (((1 | $thiz.s_package$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.s_package$__f_BigDecimal;
}
function $p_s_package$__BigInt$lzycompute__s_math_BigInt$($thiz) {
  if (((((2 & $thiz.s_package$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.s_package$__f_BigInt = $m_s_math_BigInt$();
    $thiz.s_package$__f_bitmap$0 = (((2 | $thiz.s_package$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.s_package$__f_BigInt;
}
/** @constructor */
function $c_s_package$() {
  this.s_package$__f_BigDecimal = null;
  this.s_package$__f_BigInt = null;
  this.s_package$__f_Iterable = null;
  this.s_package$__f_Seq = null;
  this.s_package$__f_Iterator = null;
  this.s_package$__f_List = null;
  this.s_package$__f_Nil = null;
  this.s_package$__f_$colon$plus = null;
  this.s_package$__f_Stream = null;
  this.s_package$__f_LazyList = null;
  this.s_package$__f_Vector = null;
  this.s_package$__f_Ordering = null;
  this.s_package$__f_Either = null;
  this.s_package$__f_Left = null;
  this.s_package$__f_Right = null;
  this.s_package$__f_bitmap$0 = 0;
  $n_s_package$ = this;
  this.s_package$__f_Iterable = $m_sc_Iterable$();
  this.s_package$__f_Seq = $m_sci_Seq$();
  $m_sci_IndexedSeq$();
  this.s_package$__f_Iterator = $m_sc_Iterator$();
  this.s_package$__f_List = $m_sci_List$();
  this.s_package$__f_Nil = $m_sci_Nil$();
  this.s_package$__f_$colon$plus = $m_sc_package$$colon$plus$();
  this.s_package$__f_Stream = $m_sci_Stream$();
  this.s_package$__f_LazyList = $m_sci_LazyList$();
  this.s_package$__f_Vector = $m_sci_Vector$();
  this.s_package$__f_Ordering = $m_s_math_Ordering$();
  this.s_package$__f_Either = $m_s_util_Either$();
  this.s_package$__f_Left = $m_s_util_Left$();
  this.s_package$__f_Right = $m_s_util_Right$();
}
$c_s_package$.prototype = new $h_O();
$c_s_package$.prototype.constructor = $c_s_package$;
/** @constructor */
function $h_s_package$() {
}
$h_s_package$.prototype = $c_s_package$.prototype;
$c_s_package$.prototype.BigDecimal__s_math_BigDecimal$ = (function() {
  return (((((1 & this.s_package$__f_bitmap$0) << 24) >> 24) === 0) ? $p_s_package$__BigDecimal$lzycompute__s_math_BigDecimal$(this) : this.s_package$__f_BigDecimal);
});
$c_s_package$.prototype.BigInt__s_math_BigInt$ = (function() {
  return (((((2 & this.s_package$__f_bitmap$0) << 24) >> 24) === 0) ? $p_s_package$__BigInt$lzycompute__s_math_BigInt$(this) : this.s_package$__f_BigInt);
});
var $d_s_package$ = new $TypeData().initClass($c_s_package$, "scala.package$", ({
  s_package$: 1
}));
var $n_s_package$;
function $m_s_package$() {
  if ((!$n_s_package$)) {
    $n_s_package$ = new $c_s_package$();
  }
  return $n_s_package$;
}
/** @constructor */
function $c_s_package$$hash$colon$colon$() {
}
$c_s_package$$hash$colon$colon$.prototype = new $h_O();
$c_s_package$$hash$colon$colon$.prototype.constructor = $c_s_package$$hash$colon$colon$;
/** @constructor */
function $h_s_package$$hash$colon$colon$() {
}
$h_s_package$$hash$colon$colon$.prototype = $c_s_package$$hash$colon$colon$.prototype;
$c_s_package$$hash$colon$colon$.prototype.unapply__sci_Stream__s_Option = (function(s) {
  var this$1 = $n(s);
  if ((!this$1.isEmpty__Z())) {
    return new $c_s_Some(new $c_T2($n(s).head__O(), $n(s).tail__O()));
  } else {
    return $m_s_None$();
  }
});
var $d_s_package$$hash$colon$colon$ = new $TypeData().initClass($c_s_package$$hash$colon$colon$, "scala.package$$hash$colon$colon$", ({
  s_package$$hash$colon$colon$: 1
}));
var $n_s_package$$hash$colon$colon$;
function $m_s_package$$hash$colon$colon$() {
  if ((!$n_s_package$$hash$colon$colon$)) {
    $n_s_package$$hash$colon$colon$ = new $c_s_package$$hash$colon$colon$();
  }
  return $n_s_package$$hash$colon$colon$;
}
function $p_s_reflect_NameTransformer$__enterOp__C__T__V($thiz, op, code) {
  $n($thiz.s_reflect_NameTransformer$__f_op2code).set(op, code);
  var this$1 = $n(code);
  var this$2 = $n(code);
  var c = (((-97) + ((Math.imul(26, (((-97) + $charAt(this$1, 1)) | 0)) + $charAt(this$2, 2)) | 0)) | 0);
  $n($thiz.s_reflect_NameTransformer$__f_code2op).set(c, new $c_s_reflect_NameTransformer$OpCodes(op, code, $n($thiz.s_reflect_NameTransformer$__f_code2op).get(c)));
}
/** @constructor */
function $c_s_reflect_NameTransformer$() {
  this.s_reflect_NameTransformer$__f_nops = 0;
  this.s_reflect_NameTransformer$__f_ncodes = 0;
  this.s_reflect_NameTransformer$__f_op2code = null;
  this.s_reflect_NameTransformer$__f_code2op = null;
  $n_s_reflect_NameTransformer$ = this;
  this.s_reflect_NameTransformer$__f_nops = 128;
  this.s_reflect_NameTransformer$__f_ncodes = 676;
  this.s_reflect_NameTransformer$__f_op2code = new ($d_T.getArrayOf().constr)(this.s_reflect_NameTransformer$__f_nops);
  this.s_reflect_NameTransformer$__f_code2op = new ($d_s_reflect_NameTransformer$OpCodes.getArrayOf().constr)(this.s_reflect_NameTransformer$__f_ncodes);
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 126, "$tilde");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 61, "$eq");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 60, "$less");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 62, "$greater");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 33, "$bang");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 35, "$hash");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 37, "$percent");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 94, "$up");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 38, "$amp");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 124, "$bar");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 42, "$times");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 47, "$div");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 43, "$plus");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 45, "$minus");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 58, "$colon");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 92, "$bslash");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 63, "$qmark");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 64, "$at");
}
$c_s_reflect_NameTransformer$.prototype = new $h_O();
$c_s_reflect_NameTransformer$.prototype.constructor = $c_s_reflect_NameTransformer$;
/** @constructor */
function $h_s_reflect_NameTransformer$() {
}
$h_s_reflect_NameTransformer$.prototype = $c_s_reflect_NameTransformer$.prototype;
$c_s_reflect_NameTransformer$.prototype.decode__T__T = (function(name0) {
  var name = ($f_T__endsWith__T__Z($n(name0), "<init>") ? ($m_sc_StringOps$().stripSuffix$extension__T__T__T(name0, "<init>") + "this") : name0);
  var buf = null;
  var this$2 = $n(name);
  var len = this$2.length;
  var i = 0;
  while ((i < len)) {
    var ops = null;
    var unicode = false;
    var this$3 = $n(name);
    var index = i;
    var c = $charAt(this$3, index);
    if (((c === 36) && (((2 + i) | 0) < len))) {
      var this$4 = $n(name);
      var index$1 = ((1 + i) | 0);
      var ch1 = $charAt(this$4, index$1);
      if (((ch1 >= 97) && (ch1 <= 122))) {
        var this$5 = $n(name);
        var index$2 = ((2 + i) | 0);
        var ch2 = $charAt(this$5, index$2);
        if (((ch2 >= 97) && (ch2 <= 122))) {
          ops = $n(this.s_reflect_NameTransformer$__f_code2op).get((((-97) + ((Math.imul(26, (((-97) + ch1) | 0)) + ch2) | 0)) | 0));
          while (true) {
            if ((ops !== null)) {
              var this$6 = $n(name);
              var prefix = $n(ops).s_reflect_NameTransformer$OpCodes__f_code;
              var toffset = i;
              if (((toffset <= this$6.length) && (toffset >= 0))) {
                var this$7 = $n(prefix);
                var $x_3 = this$6.substring(toffset, ((toffset + this$7.length) | 0));
                var $x_2 = ($as_T($x_3) === prefix);
              } else {
                var $x_2 = false;
              }
              var $x_1 = (!$x_2);
            } else {
              var $x_1 = false;
            }
            if ($x_1) {
              ops = $n(ops).s_reflect_NameTransformer$OpCodes__f_next;
            } else {
              break;
            }
          }
          if ((ops !== null)) {
            if ((buf === null)) {
              buf = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
              var $x_4 = $n(buf);
              var this$8 = $n(name);
              var endIndex = i;
              if ((endIndex > this$8.length)) {
                $charAt(this$8, endIndex);
              }
              if ((endIndex < 0)) {
                $charAt(this$8, (-1));
              }
              $n($x_4).append__T__scm_StringBuilder($as_T(this$8.substring(0, endIndex)));
            }
            $n(buf).append__C__scm_StringBuilder($n(ops).s_reflect_NameTransformer$OpCodes__f_op);
            var $x_5 = i;
            var this$9 = $n($n(ops).s_reflect_NameTransformer$OpCodes__f_code);
            i = (($x_5 + this$9.length) | 0);
          }
        } else {
          if (((((len - i) | 0) >= 6) && (ch1 === 117))) {
            var this$10 = $m_jl_Character$();
            if (this$10.isDigit__I__Z(ch2)) {
              var $x_6 = true;
            } else {
              var $x_6 = ((ch2 >= 65) && (ch2 <= 70));
            }
          } else {
            var $x_6 = false;
          }
          if ($x_6) {
            var this$11 = $n(name);
            var beginIndex = ((2 + i) | 0);
            var endIndex$1 = ((6 + i) | 0);
            if ((beginIndex < 0)) {
              $charAt(this$11, beginIndex);
            }
            if ((endIndex$1 > this$11.length)) {
              $charAt(this$11, endIndex$1);
            }
            if ((endIndex$1 < beginIndex)) {
              $charAt(this$11, (-1));
            }
            var hex = $as_T(this$11.substring(beginIndex, endIndex$1));
            try {
              var str = (65535 & $m_jl_Integer$().parseInt__T__I__I(hex, 16));
              if ((buf === null)) {
                buf = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
                var $x_7 = $n(buf);
                var this$12 = $n(name);
                var endIndex$2 = i;
                if ((endIndex$2 > this$12.length)) {
                  $charAt(this$12, endIndex$2);
                }
                if ((endIndex$2 < 0)) {
                  $charAt(this$12, (-1));
                }
                $n($x_7).append__T__scm_StringBuilder($as_T(this$12.substring(0, endIndex$2)));
              }
              $n(buf).append__C__scm_StringBuilder(str);
              i = ((6 + i) | 0);
              unicode = true;
            } catch (e) {
              if ((!(e instanceof $c_jl_NumberFormatException))) {
                throw e;
              }
            }
          }
        }
      }
    }
    if (((ops === null) && (!unicode))) {
      if ((buf !== null)) {
        $n(buf).append__C__scm_StringBuilder(c);
      }
      i = ((1 + i) | 0);
    }
  }
  if ((buf === null)) {
    return name;
  } else {
    var this$13 = $n(buf);
    return $n(this$13.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content;
  }
});
var $d_s_reflect_NameTransformer$ = new $TypeData().initClass($c_s_reflect_NameTransformer$, "scala.reflect.NameTransformer$", ({
  s_reflect_NameTransformer$: 1
}));
var $n_s_reflect_NameTransformer$;
function $m_s_reflect_NameTransformer$() {
  if ((!$n_s_reflect_NameTransformer$)) {
    $n_s_reflect_NameTransformer$ = new $c_s_reflect_NameTransformer$();
  }
  return $n_s_reflect_NameTransformer$;
}
/** @constructor */
function $c_s_reflect_NameTransformer$OpCodes(op, code, next) {
  this.s_reflect_NameTransformer$OpCodes__f_op = 0;
  this.s_reflect_NameTransformer$OpCodes__f_code = null;
  this.s_reflect_NameTransformer$OpCodes__f_next = null;
  this.s_reflect_NameTransformer$OpCodes__f_op = op;
  this.s_reflect_NameTransformer$OpCodes__f_code = code;
  this.s_reflect_NameTransformer$OpCodes__f_next = next;
}
$c_s_reflect_NameTransformer$OpCodes.prototype = new $h_O();
$c_s_reflect_NameTransformer$OpCodes.prototype.constructor = $c_s_reflect_NameTransformer$OpCodes;
/** @constructor */
function $h_s_reflect_NameTransformer$OpCodes() {
}
$h_s_reflect_NameTransformer$OpCodes.prototype = $c_s_reflect_NameTransformer$OpCodes.prototype;
var $d_s_reflect_NameTransformer$OpCodes = new $TypeData().initClass($c_s_reflect_NameTransformer$OpCodes, "scala.reflect.NameTransformer$OpCodes", ({
  s_reflect_NameTransformer$OpCodes: 1
}));
/** @constructor */
function $c_sr_BoxesRunTime$() {
}
$c_sr_BoxesRunTime$.prototype = new $h_O();
$c_sr_BoxesRunTime$.prototype.constructor = $c_sr_BoxesRunTime$;
/** @constructor */
function $h_sr_BoxesRunTime$() {
}
$h_sr_BoxesRunTime$.prototype = $c_sr_BoxesRunTime$.prototype;
$c_sr_BoxesRunTime$.prototype.equals__O__O__Z = (function(x, y) {
  if ((x === y)) {
    return true;
  } else if ($is_jl_Number(x)) {
    var x2 = $as_jl_Number(x);
    return this.equalsNumObject__jl_Number__O__Z(x2, y);
  } else if ((x instanceof $Char)) {
    var x3 = $as_jl_Character(x);
    return this.equalsCharObject__jl_Character__O__Z(x3, y);
  } else {
    return ((x === null) ? (y === null) : $dp_equals__O__Z($n(x), y));
  }
});
$c_sr_BoxesRunTime$.prototype.equalsNumObject__jl_Number__O__Z = (function(xn, y) {
  if ($is_jl_Number(y)) {
    var x2 = $as_jl_Number(y);
    return this.equalsNumNum__jl_Number__jl_Number__Z(xn, x2);
  } else if ((y instanceof $Char)) {
    var x3 = $as_jl_Character(y);
    if (((typeof xn) === "number")) {
      var x2$1 = $uD(xn);
      var this$1 = $uC($n(x3));
      return (x2$1 === this$1);
    } else if ((xn instanceof $c_RTLong)) {
      var t = $uJ(xn);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var this$2 = $uC($n(x3));
      var value = this$2;
      var hi$1 = (value >> 31);
      return ((lo === value) && (hi === hi$1));
    } else {
      return ((xn === null) ? (x3 === null) : $dp_equals__O__Z($n(xn), x3));
    }
  } else {
    return ((xn === null) ? (y === null) : $dp_equals__O__Z($n(xn), y));
  }
});
$c_sr_BoxesRunTime$.prototype.equalsNumNum__jl_Number__jl_Number__Z = (function(xn, yn) {
  if (((typeof xn) === "number")) {
    var x2 = $uD(xn);
    if (((typeof yn) === "number")) {
      var x2$2 = $uD(yn);
      return (x2 === x2$2);
    } else if ((yn instanceof $c_RTLong)) {
      var t = $uJ(yn);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      return (x2 === $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo, hi));
    } else if ((yn instanceof $c_s_math_ScalaNumber)) {
      var x4 = $as_s_math_ScalaNumber(yn);
      return $n(x4).equals__O__Z(x2);
    } else {
      return false;
    }
  } else if ((xn instanceof $c_RTLong)) {
    var t$1 = $uJ(xn);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    if ((yn instanceof $c_RTLong)) {
      var t$2 = $uJ(yn);
      var lo$2 = t$2.RTLong__f_lo;
      var hi$2 = t$2.RTLong__f_hi;
      return ((lo$1 === lo$2) && (hi$1 === hi$2));
    } else if (((typeof yn) === "number")) {
      var x3$3 = $uD(yn);
      return ($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo$1, hi$1) === x3$3);
    } else if ((yn instanceof $c_s_math_ScalaNumber)) {
      var x4$2 = $as_s_math_ScalaNumber(yn);
      return $n(x4$2).equals__O__Z(new $c_RTLong(lo$1, hi$1));
    } else {
      return false;
    }
  } else {
    return ((xn === null) ? (yn === null) : $dp_equals__O__Z($n(xn), yn));
  }
});
$c_sr_BoxesRunTime$.prototype.equalsCharObject__jl_Character__O__Z = (function(xc, y) {
  if ((y instanceof $Char)) {
    var x2 = $as_jl_Character(y);
    var this$1 = $uC($n(xc));
    var this$2 = $uC($n(x2));
    return (this$1 === this$2);
  } else if ($is_jl_Number(y)) {
    var x3 = $as_jl_Number(y);
    if (((typeof x3) === "number")) {
      var x2$1 = $uD(x3);
      var this$3 = $uC($n(xc));
      return (x2$1 === this$3);
    } else if ((x3 instanceof $c_RTLong)) {
      var t = $uJ(x3);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var this$4 = $uC($n(xc));
      var value = this$4;
      var hi$1 = (value >> 31);
      return ((lo === value) && (hi === hi$1));
    } else {
      return ((x3 === null) ? (xc === null) : $dp_equals__O__Z($n(x3), xc));
    }
  } else {
    return ((xc === null) && (y === null));
  }
});
var $d_sr_BoxesRunTime$ = new $TypeData().initClass($c_sr_BoxesRunTime$, "scala.runtime.BoxesRunTime$", ({
  sr_BoxesRunTime$: 1
}));
var $n_sr_BoxesRunTime$;
function $m_sr_BoxesRunTime$() {
  if ((!$n_sr_BoxesRunTime$)) {
    $n_sr_BoxesRunTime$ = new $c_sr_BoxesRunTime$();
  }
  return $n_sr_BoxesRunTime$;
}
var $d_sr_Null$ = new $TypeData().initClass(0, "scala.runtime.Null$", ({
  sr_Null$: 1
}));
/** @constructor */
function $c_sr_RichChar$() {
}
$c_sr_RichChar$.prototype = new $h_O();
$c_sr_RichChar$.prototype.constructor = $c_sr_RichChar$;
/** @constructor */
function $h_sr_RichChar$() {
}
$h_sr_RichChar$.prototype = $c_sr_RichChar$.prototype;
$c_sr_RichChar$.prototype.equals$extension__C__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_sr_RichChar)) {
    var RichChar$1 = $n($as_sr_RichChar(x$1)).sr_RichChar__f_self;
    return (this$ === RichChar$1);
  } else {
    return false;
  }
});
var $d_sr_RichChar$ = new $TypeData().initClass($c_sr_RichChar$, "scala.runtime.RichChar$", ({
  sr_RichChar$: 1
}));
var $n_sr_RichChar$;
function $m_sr_RichChar$() {
  if ((!$n_sr_RichChar$)) {
    $n_sr_RichChar$ = new $c_sr_RichChar$();
  }
  return $n_sr_RichChar$;
}
/** @constructor */
function $c_sr_RichDouble$() {
}
$c_sr_RichDouble$.prototype = new $h_O();
$c_sr_RichDouble$.prototype.constructor = $c_sr_RichDouble$;
/** @constructor */
function $h_sr_RichDouble$() {
}
$h_sr_RichDouble$.prototype = $c_sr_RichDouble$.prototype;
$c_sr_RichDouble$.prototype.isValidInt$extension__D__Z = (function(this$) {
  return ($doubleToInt(this$) === this$);
});
var $d_sr_RichDouble$ = new $TypeData().initClass($c_sr_RichDouble$, "scala.runtime.RichDouble$", ({
  sr_RichDouble$: 1
}));
var $n_sr_RichDouble$;
function $m_sr_RichDouble$() {
  if ((!$n_sr_RichDouble$)) {
    $n_sr_RichDouble$ = new $c_sr_RichDouble$();
  }
  return $n_sr_RichDouble$;
}
/** @constructor */
function $c_sr_RichInt$() {
}
$c_sr_RichInt$.prototype = new $h_O();
$c_sr_RichInt$.prototype.constructor = $c_sr_RichInt$;
/** @constructor */
function $h_sr_RichInt$() {
}
$h_sr_RichInt$.prototype = $c_sr_RichInt$.prototype;
$c_sr_RichInt$.prototype.equals$extension__I__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_sr_RichInt)) {
    var RichInt$1 = $n($as_sr_RichInt(x$1)).sr_RichInt__f_self;
    return (this$ === RichInt$1);
  } else {
    return false;
  }
});
var $d_sr_RichInt$ = new $TypeData().initClass($c_sr_RichInt$, "scala.runtime.RichInt$", ({
  sr_RichInt$: 1
}));
var $n_sr_RichInt$;
function $m_sr_RichInt$() {
  if ((!$n_sr_RichInt$)) {
    $n_sr_RichInt$ = new $c_sr_RichInt$();
  }
  return $n_sr_RichInt$;
}
/** @constructor */
function $c_sr_RichLong$() {
}
$c_sr_RichLong$.prototype = new $h_O();
$c_sr_RichLong$.prototype.constructor = $c_sr_RichLong$;
/** @constructor */
function $h_sr_RichLong$() {
}
$h_sr_RichLong$.prototype = $c_sr_RichLong$.prototype;
$c_sr_RichLong$.prototype.isValidByte$extension__J__Z = (function(this$) {
  var value = ((this$.RTLong__f_lo << 24) >> 24);
  var hi = (value >> 31);
  return ((value === this$.RTLong__f_lo) && (hi === this$.RTLong__f_hi));
});
$c_sr_RichLong$.prototype.isValidShort$extension__J__Z = (function(this$) {
  var value = ((this$.RTLong__f_lo << 16) >> 16);
  var hi = (value >> 31);
  return ((value === this$.RTLong__f_lo) && (hi === this$.RTLong__f_hi));
});
$c_sr_RichLong$.prototype.isValidChar$extension__J__Z = (function(this$) {
  var value = (65535 & this$.RTLong__f_lo);
  var hi = (value >> 31);
  return ((value === this$.RTLong__f_lo) && (hi === this$.RTLong__f_hi));
});
$c_sr_RichLong$.prototype.isValidInt$extension__J__Z = (function(this$) {
  var value = this$.RTLong__f_lo;
  var hi = (value >> 31);
  return ((value === this$.RTLong__f_lo) && (hi === this$.RTLong__f_hi));
});
$c_sr_RichLong$.prototype.equals$extension__J__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_sr_RichLong)) {
    var t = $n($as_sr_RichLong(x$1)).sr_RichLong__f_self;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return ((this$.RTLong__f_lo === lo) && (this$.RTLong__f_hi === hi));
  } else {
    return false;
  }
});
var $d_sr_RichLong$ = new $TypeData().initClass($c_sr_RichLong$, "scala.runtime.RichLong$", ({
  sr_RichLong$: 1
}));
var $n_sr_RichLong$;
function $m_sr_RichLong$() {
  if ((!$n_sr_RichLong$)) {
    $n_sr_RichLong$ = new $c_sr_RichLong$();
  }
  return $n_sr_RichLong$;
}
/** @constructor */
function $c_sr_Scala3RunTime$() {
}
$c_sr_Scala3RunTime$.prototype = new $h_O();
$c_sr_Scala3RunTime$.prototype.constructor = $c_sr_Scala3RunTime$;
/** @constructor */
function $h_sr_Scala3RunTime$() {
}
$h_sr_Scala3RunTime$.prototype = $c_sr_Scala3RunTime$.prototype;
$c_sr_Scala3RunTime$.prototype.assertFailed__E = (function() {
  throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "assertion failed");
});
var $d_sr_Scala3RunTime$ = new $TypeData().initClass($c_sr_Scala3RunTime$, "scala.runtime.Scala3RunTime$", ({
  sr_Scala3RunTime$: 1
}));
var $n_sr_Scala3RunTime$;
function $m_sr_Scala3RunTime$() {
  if ((!$n_sr_Scala3RunTime$)) {
    $n_sr_Scala3RunTime$ = new $c_sr_Scala3RunTime$();
  }
  return $n_sr_Scala3RunTime$;
}
/** @constructor */
function $c_sr_ScalaRunTime$() {
}
$c_sr_ScalaRunTime$.prototype = new $h_O();
$c_sr_ScalaRunTime$.prototype.constructor = $c_sr_ScalaRunTime$;
/** @constructor */
function $h_sr_ScalaRunTime$() {
}
$h_sr_ScalaRunTime$.prototype = $c_sr_ScalaRunTime$.prototype;
$c_sr_ScalaRunTime$.prototype.array_apply__O__I__O = (function(xs, idx) {
  if ((xs instanceof $ac_O)) {
    var x2 = $asArrayOf_O(xs, 1);
    return $n(x2).get(idx);
  } else if ((xs instanceof $ac_I)) {
    var x3 = $asArrayOf_I(xs, 1);
    return $n(x3).get(idx);
  } else if ((xs instanceof $ac_D)) {
    var x4 = $asArrayOf_D(xs, 1);
    return $n(x4).get(idx);
  } else if ((xs instanceof $ac_J)) {
    var x5 = $asArrayOf_J(xs, 1);
    return $n(x5).get(idx);
  } else if ((xs instanceof $ac_F)) {
    var x6 = $asArrayOf_F(xs, 1);
    return $n(x6).get(idx);
  } else if ((xs instanceof $ac_C)) {
    var x7 = $asArrayOf_C(xs, 1);
    return $bC($n(x7).get(idx));
  } else if ((xs instanceof $ac_B)) {
    var x8 = $asArrayOf_B(xs, 1);
    return $n(x8).get(idx);
  } else if ((xs instanceof $ac_S)) {
    var x9 = $asArrayOf_S(xs, 1);
    return $n(x9).get(idx);
  } else if ((xs instanceof $ac_Z)) {
    var x10 = $asArrayOf_Z(xs, 1);
    return $n(x10).get(idx);
  } else if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  } else {
    throw new $c_s_MatchError(xs);
  }
});
$c_sr_ScalaRunTime$.prototype.array_update__O__I__O__V = (function(xs, idx, value) {
  if ((xs instanceof $ac_O)) {
    var x2 = $asArrayOf_O(xs, 1);
    $n(x2).set(idx, value);
  } else if ((xs instanceof $ac_I)) {
    var x3 = $asArrayOf_I(xs, 1);
    $n(x3).set(idx, $uI(value));
  } else if ((xs instanceof $ac_D)) {
    var x4 = $asArrayOf_D(xs, 1);
    $n(x4).set(idx, $uD(value));
  } else if ((xs instanceof $ac_J)) {
    var x5 = $asArrayOf_J(xs, 1);
    $n(x5).set(idx, $uJ(value));
  } else if ((xs instanceof $ac_F)) {
    var x6 = $asArrayOf_F(xs, 1);
    $n(x6).set(idx, $uF(value));
  } else if ((xs instanceof $ac_C)) {
    var x7 = $asArrayOf_C(xs, 1);
    $n(x7).set(idx, $uC(value));
  } else if ((xs instanceof $ac_B)) {
    var x8 = $asArrayOf_B(xs, 1);
    $n(x8).set(idx, $uB(value));
  } else if ((xs instanceof $ac_S)) {
    var x9 = $asArrayOf_S(xs, 1);
    $n(x9).set(idx, $uS(value));
  } else if ((xs instanceof $ac_Z)) {
    var x10 = $asArrayOf_Z(xs, 1);
    $n(x10).set(idx, $uZ(value));
  } else if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  } else {
    throw new $c_s_MatchError(xs);
  }
});
$c_sr_ScalaRunTime$.prototype.array_clone__O__O = (function(xs) {
  if ((xs instanceof $ac_O)) {
    var x2 = $asArrayOf_O(xs, 1);
    var this$1 = $n(x2);
    return $n(this$1).clone__O();
  } else if ((xs instanceof $ac_I)) {
    var x3 = $asArrayOf_I(xs, 1);
    var this$2 = $n(x3);
    return $n(this$2).clone__O();
  } else if ((xs instanceof $ac_D)) {
    var x4 = $asArrayOf_D(xs, 1);
    var this$3 = $n(x4);
    return $n(this$3).clone__O();
  } else if ((xs instanceof $ac_J)) {
    var x5 = $asArrayOf_J(xs, 1);
    var this$4 = $n(x5);
    return $n(this$4).clone__O();
  } else if ((xs instanceof $ac_F)) {
    var x6 = $asArrayOf_F(xs, 1);
    var this$5 = $n(x6);
    return $n(this$5).clone__O();
  } else if ((xs instanceof $ac_C)) {
    var x7 = $asArrayOf_C(xs, 1);
    var this$6 = $n(x7);
    return $n(this$6).clone__O();
  } else if ((xs instanceof $ac_B)) {
    var x8 = $asArrayOf_B(xs, 1);
    var this$7 = $n(x8);
    return $n(this$7).clone__O();
  } else if ((xs instanceof $ac_S)) {
    var x9 = $asArrayOf_S(xs, 1);
    var this$8 = $n(x9);
    return $n(this$8).clone__O();
  } else if ((xs instanceof $ac_Z)) {
    var x10 = $asArrayOf_Z(xs, 1);
    var this$9 = $n(x10);
    return $n(this$9).clone__O();
  } else if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  } else {
    throw new $c_s_MatchError(xs);
  }
});
$c_sr_ScalaRunTime$.prototype._toString__s_Product__T = (function(x) {
  var this$1 = $n($n(x).productIterator__sc_Iterator());
  var start = ($n(x).productPrefix__T() + "(");
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, start, ",", ")");
});
$c_sr_ScalaRunTime$.prototype.genericWrapArray__O__sci_ArraySeq = (function(xs) {
  return ((xs === null) ? null : $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(xs));
});
$c_sr_ScalaRunTime$.prototype.wrapRefArray__AO__sci_ArraySeq = (function(xs) {
  if ((xs === null)) {
    return null;
  } else if (($n(xs).u.length === 0)) {
    var this$1 = $m_sci_ArraySeq$();
    return $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef(this$1);
  } else {
    return new $c_sci_ArraySeq$ofRef(xs);
  }
});
$c_sr_ScalaRunTime$.prototype.wrapCharArray__AC__sci_ArraySeq = (function(xs) {
  return ((xs !== null) ? new $c_sci_ArraySeq$ofChar(xs) : null);
});
var $d_sr_ScalaRunTime$ = new $TypeData().initClass($c_sr_ScalaRunTime$, "scala.runtime.ScalaRunTime$", ({
  sr_ScalaRunTime$: 1
}));
var $n_sr_ScalaRunTime$;
function $m_sr_ScalaRunTime$() {
  if ((!$n_sr_ScalaRunTime$)) {
    $n_sr_ScalaRunTime$ = new $c_sr_ScalaRunTime$();
  }
  return $n_sr_ScalaRunTime$;
}
/** @constructor */
function $c_sr_Statics$() {
}
$c_sr_Statics$.prototype = new $h_O();
$c_sr_Statics$.prototype.constructor = $c_sr_Statics$;
/** @constructor */
function $h_sr_Statics$() {
}
$h_sr_Statics$.prototype = $c_sr_Statics$.prototype;
$c_sr_Statics$.prototype.mix__I__I__I = (function(hash, data) {
  var h = this.mixLast__I__I__I(hash, data);
  var i = h;
  h = ((i << 13) | ((i >>> 19) | 0));
  return (((-430675100) + Math.imul(5, h)) | 0);
});
$c_sr_Statics$.prototype.mixLast__I__I__I = (function(hash, data) {
  var k = data;
  k = Math.imul((-862048943), k);
  var i = k;
  k = ((i << 15) | ((i >>> 17) | 0));
  k = Math.imul(461845907, k);
  return (hash ^ k);
});
$c_sr_Statics$.prototype.finalizeHash__I__I__I = (function(hash, length) {
  return this.avalanche__I__I((hash ^ length));
});
$c_sr_Statics$.prototype.avalanche__I__I = (function(h0) {
  var h = h0;
  h = (h ^ ((h >>> 16) | 0));
  h = Math.imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = Math.imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h;
});
$c_sr_Statics$.prototype.longHash__J__I = (function(lv) {
  var lo = lv.RTLong__f_lo;
  var hi = lv.RTLong__f_hi;
  return ((hi === (lo >> 31)) ? lo : (lo ^ hi));
});
$c_sr_Statics$.prototype.doubleHash__D__I = (function(dv) {
  var iv = $doubleToInt(dv);
  if ((iv === dv)) {
    return iv;
  } else {
    var this$1 = $m_RTLong$();
    var lo = this$1.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(dv);
    var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    return (($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo, hi) === dv) ? (lo ^ hi) : $m_jl_FloatingPointBits$().numberHashCode__D__I(dv));
  }
});
$c_sr_Statics$.prototype.anyHash__O__I = (function(x) {
  if ((x === null)) {
    return 0;
  } else if (((typeof x) === "number")) {
    var x3 = $uD(x);
    return this.doubleHash__D__I(x3);
  } else if ((x instanceof $c_RTLong)) {
    var t = $uJ(x);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return this.longHash__J__I(new $c_RTLong(lo, hi));
  } else {
    return $dp_hashCode__I($n(x));
  }
});
$c_sr_Statics$.prototype.ioobe__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_sr_Statics$ = new $TypeData().initClass($c_sr_Statics$, "scala.runtime.Statics$", ({
  sr_Statics$: 1
}));
var $n_sr_Statics$;
function $m_sr_Statics$() {
  if ((!$n_sr_Statics$)) {
    $n_sr_Statics$ = new $c_sr_Statics$();
  }
  return $n_sr_Statics$;
}
/** @constructor */
function $c_sr_Statics$PFMarker$() {
}
$c_sr_Statics$PFMarker$.prototype = new $h_O();
$c_sr_Statics$PFMarker$.prototype.constructor = $c_sr_Statics$PFMarker$;
/** @constructor */
function $h_sr_Statics$PFMarker$() {
}
$h_sr_Statics$PFMarker$.prototype = $c_sr_Statics$PFMarker$.prototype;
var $d_sr_Statics$PFMarker$ = new $TypeData().initClass($c_sr_Statics$PFMarker$, "scala.runtime.Statics$PFMarker$", ({
  sr_Statics$PFMarker$: 1
}));
var $n_sr_Statics$PFMarker$;
function $m_sr_Statics$PFMarker$() {
  if ((!$n_sr_Statics$PFMarker$)) {
    $n_sr_Statics$PFMarker$ = new $c_sr_Statics$PFMarker$();
  }
  return $n_sr_Statics$PFMarker$;
}
/** @constructor */
function $c_sjs_js_ArrayOps$() {
}
$c_sjs_js_ArrayOps$.prototype = new $h_O();
$c_sjs_js_ArrayOps$.prototype.constructor = $c_sjs_js_ArrayOps$;
/** @constructor */
function $h_sjs_js_ArrayOps$() {
}
$h_sjs_js_ArrayOps$.prototype = $c_sjs_js_ArrayOps$.prototype;
$c_sjs_js_ArrayOps$.prototype.headOption$extension__sjs_js_Array__s_Option = (function(this$) {
  return (($uI(this$.length) === 0) ? $m_s_None$() : new $c_s_Some(this$[0]));
});
var $d_sjs_js_ArrayOps$ = new $TypeData().initClass($c_sjs_js_ArrayOps$, "scala.scalajs.js.ArrayOps$", ({
  sjs_js_ArrayOps$: 1
}));
var $n_sjs_js_ArrayOps$;
function $m_sjs_js_ArrayOps$() {
  if ((!$n_sjs_js_ArrayOps$)) {
    $n_sjs_js_ArrayOps$ = new $c_sjs_js_ArrayOps$();
  }
  return $n_sjs_js_ArrayOps$;
}
/** @constructor */
function $c_sjs_js_Thenable$ThenableOps$() {
}
$c_sjs_js_Thenable$ThenableOps$.prototype = new $h_O();
$c_sjs_js_Thenable$ThenableOps$.prototype.constructor = $c_sjs_js_Thenable$ThenableOps$;
/** @constructor */
function $h_sjs_js_Thenable$ThenableOps$() {
}
$h_sjs_js_Thenable$ThenableOps$.prototype = $c_sjs_js_Thenable$ThenableOps$.prototype;
$c_sjs_js_Thenable$ThenableOps$.prototype.toFuture$extension__sjs_js_Thenable__s_concurrent_Future = (function(this$) {
  var p2 = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
  this$.then(((arg1$2) => $m_sjs_js_Thenable$ThenableOps$().scala$scalajs$js$Thenable$ThenableOps$$$anonfun$toFuture$1__O__s_concurrent_Promise__sjs_js_$bar(arg1$2, p2)), $m_sjs_js_defined$().apply__O__sjs_js_$bar(((arg1$2$1) => $m_sjs_js_Thenable$ThenableOps$().scala$scalajs$js$Thenable$ThenableOps$$$anonfun$toFuture$2__O__s_concurrent_Promise__sjs_js_$bar(arg1$2$1, p2))));
  return p2;
});
$c_sjs_js_Thenable$ThenableOps$.prototype.scala$scalajs$js$Thenable$ThenableOps$$$anonfun$toFuture$1__O__s_concurrent_Promise__sjs_js_$bar = (function(v, p2$1) {
  var this$1 = $n(p2$1);
  $f_s_concurrent_Promise__success__O__s_concurrent_Promise(this$1, v);
});
$c_sjs_js_Thenable$ThenableOps$.prototype.scala$scalajs$js$Thenable$ThenableOps$$$anonfun$toFuture$2__O__s_concurrent_Promise__sjs_js_$bar = (function(e, p2$1) {
  var this$1 = $n(p2$1);
  var cause = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
  $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise(this$1, cause);
});
var $d_sjs_js_Thenable$ThenableOps$ = new $TypeData().initClass($c_sjs_js_Thenable$ThenableOps$, "scala.scalajs.js.Thenable$ThenableOps$", ({
  sjs_js_Thenable$ThenableOps$: 1
}));
var $n_sjs_js_Thenable$ThenableOps$;
function $m_sjs_js_Thenable$ThenableOps$() {
  if ((!$n_sjs_js_Thenable$ThenableOps$)) {
    $n_sjs_js_Thenable$ThenableOps$ = new $c_sjs_js_Thenable$ThenableOps$();
  }
  return $n_sjs_js_Thenable$ThenableOps$;
}
/** @constructor */
function $c_sjs_js_WrappedDictionary$Cache$() {
  this.sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty = null;
  $n_sjs_js_WrappedDictionary$Cache$ = this;
  this.sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty = Object.prototype.hasOwnProperty;
}
$c_sjs_js_WrappedDictionary$Cache$.prototype = new $h_O();
$c_sjs_js_WrappedDictionary$Cache$.prototype.constructor = $c_sjs_js_WrappedDictionary$Cache$;
/** @constructor */
function $h_sjs_js_WrappedDictionary$Cache$() {
}
$h_sjs_js_WrappedDictionary$Cache$.prototype = $c_sjs_js_WrappedDictionary$Cache$.prototype;
var $d_sjs_js_WrappedDictionary$Cache$ = new $TypeData().initClass($c_sjs_js_WrappedDictionary$Cache$, "scala.scalajs.js.WrappedDictionary$Cache$", ({
  sjs_js_WrappedDictionary$Cache$: 1
}));
var $n_sjs_js_WrappedDictionary$Cache$;
function $m_sjs_js_WrappedDictionary$Cache$() {
  if ((!$n_sjs_js_WrappedDictionary$Cache$)) {
    $n_sjs_js_WrappedDictionary$Cache$ = new $c_sjs_js_WrappedDictionary$Cache$();
  }
  return $n_sjs_js_WrappedDictionary$Cache$;
}
/** @constructor */
function $c_sjs_js_defined$() {
}
$c_sjs_js_defined$.prototype = new $h_O();
$c_sjs_js_defined$.prototype.constructor = $c_sjs_js_defined$;
/** @constructor */
function $h_sjs_js_defined$() {
}
$h_sjs_js_defined$.prototype = $c_sjs_js_defined$.prototype;
$c_sjs_js_defined$.prototype.apply__O__sjs_js_$bar = (function(a) {
  return a;
});
var $d_sjs_js_defined$ = new $TypeData().initClass($c_sjs_js_defined$, "scala.scalajs.js.defined$", ({
  sjs_js_defined$: 1
}));
var $n_sjs_js_defined$;
function $m_sjs_js_defined$() {
  if ((!$n_sjs_js_defined$)) {
    $n_sjs_js_defined$ = new $c_sjs_js_defined$();
  }
  return $n_sjs_js_defined$;
}
/** @constructor */
function $c_sjs_js_special_package$() {
}
$c_sjs_js_special_package$.prototype = new $h_O();
$c_sjs_js_special_package$.prototype.constructor = $c_sjs_js_special_package$;
/** @constructor */
function $h_sjs_js_special_package$() {
}
$h_sjs_js_special_package$.prototype = $c_sjs_js_special_package$.prototype;
$c_sjs_js_special_package$.prototype.objectLiteral__sci_Seq__sjs_js_Object = (function(properties) {
  var result = ({});
  $n(properties).foreach__F1__V(new $c_sjsr_AnonFunction1(((pair$2) => {
    var pair = $as_T2(pair$2);
    result[$n(pair)._1__O()] = $n(pair)._2__O();
  })));
  return result;
});
var $d_sjs_js_special_package$ = new $TypeData().initClass($c_sjs_js_special_package$, "scala.scalajs.js.special.package$", ({
  sjs_js_special_package$: 1
}));
var $n_sjs_js_special_package$;
function $m_sjs_js_special_package$() {
  if ((!$n_sjs_js_special_package$)) {
    $n_sjs_js_special_package$ = new $c_sjs_js_special_package$();
  }
  return $n_sjs_js_special_package$;
}
/** @constructor */
function $c_sjs_js_timers_package$() {
}
$c_sjs_js_timers_package$.prototype = new $h_O();
$c_sjs_js_timers_package$.prototype.constructor = $c_sjs_js_timers_package$;
/** @constructor */
function $h_sjs_js_timers_package$() {
}
$h_sjs_js_timers_package$.prototype = $c_sjs_js_timers_package$.prototype;
$c_sjs_js_timers_package$.prototype.setTimeout__s_concurrent_duration_FiniteDuration__F0__sjs_js_timers_SetTimeoutHandle = (function(interval, body) {
  var $x_1 = setTimeout;
  var this$3 = $n(interval);
  var this$4 = $n(this$3.s_concurrent_duration_FiniteDuration__f_unit).toMillis__J__J(this$3.s_concurrent_duration_FiniteDuration__f_length);
  return $x_1((() => {
    var this$2 = $n(body);
    this$2.apply__O();
  }), $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$4.RTLong__f_lo, this$4.RTLong__f_hi));
});
$c_sjs_js_timers_package$.prototype.clearTimeout__sjs_js_timers_SetTimeoutHandle__V = (function(handle) {
  clearTimeout(handle);
});
var $d_sjs_js_timers_package$ = new $TypeData().initClass($c_sjs_js_timers_package$, "scala.scalajs.js.timers.package$", ({
  sjs_js_timers_package$: 1
}));
var $n_sjs_js_timers_package$;
function $m_sjs_js_timers_package$() {
  if ((!$n_sjs_js_timers_package$)) {
    $n_sjs_js_timers_package$ = new $c_sjs_js_timers_package$();
  }
  return $n_sjs_js_timers_package$;
}
/** @constructor */
function $c_s_sys_package$() {
}
$c_s_sys_package$.prototype = new $h_O();
$c_s_sys_package$.prototype.constructor = $c_s_sys_package$;
/** @constructor */
function $h_s_sys_package$() {
}
$h_s_sys_package$.prototype = $c_s_sys_package$.prototype;
$c_s_sys_package$.prototype.error__T__E = (function(message) {
  throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), message);
});
var $d_s_sys_package$ = new $TypeData().initClass($c_s_sys_package$, "scala.sys.package$", ({
  s_sys_package$: 1
}));
var $n_s_sys_package$;
function $m_s_sys_package$() {
  if ((!$n_s_sys_package$)) {
    $n_s_sys_package$ = new $c_s_sys_package$();
  }
  return $n_s_sys_package$;
}
/** @constructor */
function $c_s_util_DynamicVariable(init) {
  this.s_util_DynamicVariable__f_v = null;
  this.s_util_DynamicVariable__f_v = init;
}
$c_s_util_DynamicVariable.prototype = new $h_O();
$c_s_util_DynamicVariable.prototype.constructor = $c_s_util_DynamicVariable;
/** @constructor */
function $h_s_util_DynamicVariable() {
}
$h_s_util_DynamicVariable.prototype = $c_s_util_DynamicVariable.prototype;
$c_s_util_DynamicVariable.prototype.toString__T = (function() {
  return (("DynamicVariable(" + this.s_util_DynamicVariable__f_v) + ")");
});
var $d_s_util_DynamicVariable = new $TypeData().initClass($c_s_util_DynamicVariable, "scala.util.DynamicVariable", ({
  s_util_DynamicVariable: 1
}));
/** @constructor */
function $c_s_util_NotGiven() {
}
$c_s_util_NotGiven.prototype = new $h_O();
$c_s_util_NotGiven.prototype.constructor = $c_s_util_NotGiven;
/** @constructor */
function $h_s_util_NotGiven() {
}
$h_s_util_NotGiven.prototype = $c_s_util_NotGiven.prototype;
var $d_s_util_NotGiven = new $TypeData().initClass($c_s_util_NotGiven, "scala.util.NotGiven", ({
  s_util_NotGiven: 1
}));
/** @constructor */
function $c_s_util_Sorting$() {
}
$c_s_util_Sorting$.prototype = new $h_O();
$c_s_util_Sorting$.prototype.constructor = $c_s_util_Sorting$;
/** @constructor */
function $h_s_util_Sorting$() {
}
$h_s_util_Sorting$.prototype = $c_s_util_Sorting$.prototype;
$c_s_util_Sorting$.prototype.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V = (function(a, i0, iN, ord) {
  var n = ((iN - i0) | 0);
  if ((n < 2)) {
    return (void 0);
  }
  if (($n(ord).compare__O__O__I($m_sr_ScalaRunTime$().array_apply__O__I__O(a, i0), $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((1 + i0) | 0))) > 0)) {
    var temp = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i0);
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, i0, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((1 + i0) | 0)));
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, ((1 + i0) | 0), temp);
  }
  var m = 2;
  while ((m < n)) {
    var next = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((i0 + m) | 0));
    if (($n(ord).compare__O__O__I(next, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, (((-1) + ((i0 + m) | 0)) | 0))) < 0)) {
      var iA = i0;
      var iB = (((-1) + ((i0 + m) | 0)) | 0);
      while ((((iB - iA) | 0) > 1)) {
        var ix = ((((iA + iB) | 0) >>> 1) | 0);
        if (($n(ord).compare__O__O__I(next, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ix)) < 0)) {
          iB = ix;
        } else {
          iA = ix;
        }
      }
      var ix$2 = ((iA + (($n(ord).compare__O__O__I(next, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, iA)) < 0) ? 0 : 1)) | 0);
      var i = ((i0 + m) | 0);
      while ((i > ix$2)) {
        $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, i, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, (((-1) + i) | 0)));
        i = (((-1) + i) | 0);
      }
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, ix$2, next);
    }
    m = ((1 + m) | 0);
  }
});
$c_s_util_Sorting$.prototype.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V = (function(a, i0, iN, ord, scratch, evidence$2) {
  if ((((iN - i0) | 0) < 32)) {
    this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, i0, iN, ord);
  } else {
    var iK = ((((i0 + iN) | 0) >>> 1) | 0);
    var sc = ((scratch === null) ? $n(evidence$2).newArray__I__O(((iK - i0) | 0)) : scratch);
    this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, i0, iK, ord, sc, evidence$2);
    this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK, iN, ord, sc, evidence$2);
    this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, i0, iK, iN, ord, sc);
  }
});
$c_s_util_Sorting$.prototype.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V = (function(a, i0, iK, iN, ord, scratch) {
  if (($n(ord).compare__O__O__I($m_sr_ScalaRunTime$().array_apply__O__I__O(a, (((-1) + iK) | 0)), $m_sr_ScalaRunTime$().array_apply__O__I__O(a, iK)) > 0)) {
    var i = i0;
    var jN = ((iK - i0) | 0);
    var j = 0;
    while ((i < iK)) {
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(scratch, j, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i));
      i = ((1 + i) | 0);
      j = ((1 + j) | 0);
    }
    var k = i0;
    j = 0;
    while (((i < iN) && (j < jN))) {
      if (($n(ord).compare__O__O__I($m_sr_ScalaRunTime$().array_apply__O__I__O(a, i), $m_sr_ScalaRunTime$().array_apply__O__I__O(scratch, j)) < 0)) {
        $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, k, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i));
        i = ((1 + i) | 0);
      } else {
        $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, k, $m_sr_ScalaRunTime$().array_apply__O__I__O(scratch, j));
        j = ((1 + j) | 0);
      }
      k = ((1 + k) | 0);
    }
    while ((j < jN)) {
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, k, $m_sr_ScalaRunTime$().array_apply__O__I__O(scratch, j));
      j = ((1 + j) | 0);
      k = ((1 + k) | 0);
    }
  }
});
$c_s_util_Sorting$.prototype.scala$util$Sorting$$booleanSort__AZ__I__I__V = (function(a, from, until) {
  var i = from;
  var n = 0;
  while ((i < until)) {
    if ((!$n(a).get(i))) {
      n = ((1 + n) | 0);
    }
    i = ((1 + i) | 0);
  }
  i = 0;
  while ((i < n)) {
    $n(a).set(((from + i) | 0), false);
    i = ((1 + i) | 0);
  }
  while ((((from + i) | 0) < until)) {
    $n(a).set(((from + i) | 0), true);
    i = ((1 + i) | 0);
  }
});
$c_s_util_Sorting$.prototype.stableSort__O__I__I__s_math_Ordering__V = (function(a, from, until, evidence$4) {
  if ((a instanceof $ac_O)) {
    if ((($m_jl_reflect_Array$().getLength__O__I(a) > 1) && (evidence$4 === null))) {
      throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "Ordering");
    }
    var array = $asArrayOf_O(a, 1);
    $m_ju_Arrays$().sort__AO__I__I__ju_Comparator__V(array, from, until, evidence$4);
  } else if ((a instanceof $ac_I)) {
    var x3 = $asArrayOf_I(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Int$())) {
      $m_ju_Arrays$().sort__AI__I__I__V(x3, from, until);
    } else {
      var evidence$2 = $m_s_reflect_ManifestFactory$IntManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x3, from, until, evidence$4);
      } else {
        var iK = ((((from + until) | 0) >>> 1) | 0);
        var len = ((iK - from) | 0);
        var sc = new $ac_I(len);
        if ((((iK - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x3, from, iK, evidence$4);
        } else {
          var iK$1 = ((((from + iK) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x3, from, iK$1, evidence$4, sc, evidence$2);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x3, iK$1, iK, evidence$4, sc, evidence$2);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x3, from, iK$1, iK, evidence$4, sc);
        }
        if ((((until - iK) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x3, iK, until, evidence$4);
        } else {
          var iK$2 = ((((iK + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x3, iK, iK$2, evidence$4, sc, evidence$2);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x3, iK$2, until, evidence$4, sc, evidence$2);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x3, iK, iK$2, until, evidence$4, sc);
        }
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x3, from, iK, until, evidence$4, sc);
      }
    }
  } else if ((a instanceof $ac_D)) {
    var x4 = $asArrayOf_D(a, 1);
    var evidence$2$1 = $m_s_reflect_ManifestFactory$DoubleManifest$();
    if ((((until - from) | 0) < 32)) {
      this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x4, from, until, evidence$4);
    } else {
      var iK$3 = ((((from + until) | 0) >>> 1) | 0);
      var len$1 = ((iK$3 - from) | 0);
      var sc$1 = new $ac_D(len$1);
      if ((((iK$3 - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x4, from, iK$3, evidence$4);
      } else {
        var iK$4 = ((((from + iK$3) | 0) >>> 1) | 0);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x4, from, iK$4, evidence$4, sc$1, evidence$2$1);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x4, iK$4, iK$3, evidence$4, sc$1, evidence$2$1);
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x4, from, iK$4, iK$3, evidence$4, sc$1);
      }
      if ((((until - iK$3) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x4, iK$3, until, evidence$4);
      } else {
        var iK$5 = ((((iK$3 + until) | 0) >>> 1) | 0);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x4, iK$3, iK$5, evidence$4, sc$1, evidence$2$1);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x4, iK$5, until, evidence$4, sc$1, evidence$2$1);
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x4, iK$3, iK$5, until, evidence$4, sc$1);
      }
      this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x4, from, iK$3, until, evidence$4, sc$1);
    }
  } else if ((a instanceof $ac_J)) {
    var x5 = $asArrayOf_J(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Long$())) {
      $m_ju_Arrays$().sort__AJ__I__I__V(x5, from, until);
    } else {
      var evidence$2$2 = $m_s_reflect_ManifestFactory$LongManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x5, from, until, evidence$4);
      } else {
        var iK$6 = ((((from + until) | 0) >>> 1) | 0);
        var len$2 = ((iK$6 - from) | 0);
        var sc$2 = new $ac_J(len$2);
        if ((((iK$6 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x5, from, iK$6, evidence$4);
        } else {
          var iK$7 = ((((from + iK$6) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x5, from, iK$7, evidence$4, sc$2, evidence$2$2);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x5, iK$7, iK$6, evidence$4, sc$2, evidence$2$2);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x5, from, iK$7, iK$6, evidence$4, sc$2);
        }
        if ((((until - iK$6) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x5, iK$6, until, evidence$4);
        } else {
          var iK$8 = ((((iK$6 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x5, iK$6, iK$8, evidence$4, sc$2, evidence$2$2);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x5, iK$8, until, evidence$4, sc$2, evidence$2$2);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x5, iK$6, iK$8, until, evidence$4, sc$2);
        }
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x5, from, iK$6, until, evidence$4, sc$2);
      }
    }
  } else if ((a instanceof $ac_F)) {
    var x6 = $asArrayOf_F(a, 1);
    var evidence$2$3 = $m_s_reflect_ManifestFactory$FloatManifest$();
    if ((((until - from) | 0) < 32)) {
      this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x6, from, until, evidence$4);
    } else {
      var iK$9 = ((((from + until) | 0) >>> 1) | 0);
      var len$3 = ((iK$9 - from) | 0);
      var sc$3 = new $ac_F(len$3);
      if ((((iK$9 - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x6, from, iK$9, evidence$4);
      } else {
        var iK$10 = ((((from + iK$9) | 0) >>> 1) | 0);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x6, from, iK$10, evidence$4, sc$3, evidence$2$3);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x6, iK$10, iK$9, evidence$4, sc$3, evidence$2$3);
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x6, from, iK$10, iK$9, evidence$4, sc$3);
      }
      if ((((until - iK$9) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x6, iK$9, until, evidence$4);
      } else {
        var iK$11 = ((((iK$9 + until) | 0) >>> 1) | 0);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x6, iK$9, iK$11, evidence$4, sc$3, evidence$2$3);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x6, iK$11, until, evidence$4, sc$3, evidence$2$3);
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x6, iK$9, iK$11, until, evidence$4, sc$3);
      }
      this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x6, from, iK$9, until, evidence$4, sc$3);
    }
  } else if ((a instanceof $ac_C)) {
    var x7 = $asArrayOf_C(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Char$())) {
      $m_ju_Arrays$().sort__AC__I__I__V(x7, from, until);
    } else {
      var evidence$2$4 = $m_s_reflect_ManifestFactory$CharManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x7, from, until, evidence$4);
      } else {
        var iK$12 = ((((from + until) | 0) >>> 1) | 0);
        var len$4 = ((iK$12 - from) | 0);
        var sc$4 = new $ac_C(len$4);
        if ((((iK$12 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x7, from, iK$12, evidence$4);
        } else {
          var iK$13 = ((((from + iK$12) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x7, from, iK$13, evidence$4, sc$4, evidence$2$4);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x7, iK$13, iK$12, evidence$4, sc$4, evidence$2$4);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x7, from, iK$13, iK$12, evidence$4, sc$4);
        }
        if ((((until - iK$12) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x7, iK$12, until, evidence$4);
        } else {
          var iK$14 = ((((iK$12 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x7, iK$12, iK$14, evidence$4, sc$4, evidence$2$4);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x7, iK$14, until, evidence$4, sc$4, evidence$2$4);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x7, iK$12, iK$14, until, evidence$4, sc$4);
        }
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x7, from, iK$12, until, evidence$4, sc$4);
      }
    }
  } else if ((a instanceof $ac_B)) {
    var x8 = $asArrayOf_B(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Byte$())) {
      $m_ju_Arrays$().sort__AB__I__I__V(x8, from, until);
    } else {
      var evidence$2$5 = $m_s_reflect_ManifestFactory$ByteManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x8, from, until, evidence$4);
      } else {
        var iK$15 = ((((from + until) | 0) >>> 1) | 0);
        var len$5 = ((iK$15 - from) | 0);
        var sc$5 = new $ac_B(len$5);
        if ((((iK$15 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x8, from, iK$15, evidence$4);
        } else {
          var iK$16 = ((((from + iK$15) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x8, from, iK$16, evidence$4, sc$5, evidence$2$5);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x8, iK$16, iK$15, evidence$4, sc$5, evidence$2$5);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x8, from, iK$16, iK$15, evidence$4, sc$5);
        }
        if ((((until - iK$15) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x8, iK$15, until, evidence$4);
        } else {
          var iK$17 = ((((iK$15 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x8, iK$15, iK$17, evidence$4, sc$5, evidence$2$5);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x8, iK$17, until, evidence$4, sc$5, evidence$2$5);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x8, iK$15, iK$17, until, evidence$4, sc$5);
        }
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x8, from, iK$15, until, evidence$4, sc$5);
      }
    }
  } else if ((a instanceof $ac_S)) {
    var x9 = $asArrayOf_S(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Short$())) {
      $m_ju_Arrays$().sort__AS__I__I__V(x9, from, until);
    } else {
      var evidence$2$6 = $m_s_reflect_ManifestFactory$ShortManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x9, from, until, evidence$4);
      } else {
        var iK$18 = ((((from + until) | 0) >>> 1) | 0);
        var len$6 = ((iK$18 - from) | 0);
        var sc$6 = new $ac_S(len$6);
        if ((((iK$18 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x9, from, iK$18, evidence$4);
        } else {
          var iK$19 = ((((from + iK$18) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x9, from, iK$19, evidence$4, sc$6, evidence$2$6);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x9, iK$19, iK$18, evidence$4, sc$6, evidence$2$6);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x9, from, iK$19, iK$18, evidence$4, sc$6);
        }
        if ((((until - iK$18) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x9, iK$18, until, evidence$4);
        } else {
          var iK$20 = ((((iK$18 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x9, iK$18, iK$20, evidence$4, sc$6, evidence$2$6);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x9, iK$20, until, evidence$4, sc$6, evidence$2$6);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x9, iK$18, iK$20, until, evidence$4, sc$6);
        }
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x9, from, iK$18, until, evidence$4, sc$6);
      }
    }
  } else if ((a instanceof $ac_Z)) {
    var x10 = $asArrayOf_Z(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Boolean$())) {
      this.scala$util$Sorting$$booleanSort__AZ__I__I__V(x10, from, until);
    } else {
      var evidence$2$7 = $m_s_reflect_ManifestFactory$BooleanManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x10, from, until, evidence$4);
      } else {
        var iK$21 = ((((from + until) | 0) >>> 1) | 0);
        var len$7 = ((iK$21 - from) | 0);
        var sc$7 = new $ac_Z(len$7);
        if ((((iK$21 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x10, from, iK$21, evidence$4);
        } else {
          var iK$22 = ((((from + iK$21) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x10, from, iK$22, evidence$4, sc$7, evidence$2$7);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x10, iK$22, iK$21, evidence$4, sc$7, evidence$2$7);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x10, from, iK$22, iK$21, evidence$4, sc$7);
        }
        if ((((until - iK$21) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x10, iK$21, until, evidence$4);
        } else {
          var iK$23 = ((((iK$21 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x10, iK$21, iK$23, evidence$4, sc$7, evidence$2$7);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x10, iK$23, until, evidence$4, sc$7, evidence$2$7);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x10, iK$21, iK$23, until, evidence$4, sc$7);
        }
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x10, from, iK$21, until, evidence$4, sc$7);
      }
    }
  } else if ((a === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  } else {
    throw new $c_s_MatchError(a);
  }
});
var $d_s_util_Sorting$ = new $TypeData().initClass($c_s_util_Sorting$, "scala.util.Sorting$", ({
  s_util_Sorting$: 1
}));
var $n_s_util_Sorting$;
function $m_s_util_Sorting$() {
  if ((!$n_s_util_Sorting$)) {
    $n_s_util_Sorting$ = new $c_s_util_Sorting$();
  }
  return $n_s_util_Sorting$;
}
function $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable($thiz) {
  var this$1 = $m_s_util_control_NoStackTrace$();
  if (this$1.s_util_control_NoStackTrace$__f__noSuppression) {
    return $c_jl_Throwable.prototype.fillInStackTrace__jl_Throwable.call($thiz);
  } else {
    return $as_jl_Throwable($thiz);
  }
}
/** @constructor */
function $c_s_util_control_NonFatal$() {
}
$c_s_util_control_NonFatal$.prototype = new $h_O();
$c_s_util_control_NonFatal$.prototype.constructor = $c_s_util_control_NonFatal$;
/** @constructor */
function $h_s_util_control_NonFatal$() {
}
$h_s_util_control_NonFatal$.prototype = $c_s_util_control_NonFatal$.prototype;
$c_s_util_control_NonFatal$.prototype.apply__jl_Throwable__Z = (function(t) {
  return (!((t instanceof $c_jl_VirtualMachineError) || (false || (false || (false || false)))));
});
$c_s_util_control_NonFatal$.prototype.unapply__jl_Throwable__s_Option = (function(t) {
  return (this.apply__jl_Throwable__Z(t) ? new $c_s_Some(t) : $m_s_None$());
});
var $d_s_util_control_NonFatal$ = new $TypeData().initClass($c_s_util_control_NonFatal$, "scala.util.control.NonFatal$", ({
  s_util_control_NonFatal$: 1
}));
var $n_s_util_control_NonFatal$;
function $m_s_util_control_NonFatal$() {
  if ((!$n_s_util_control_NonFatal$)) {
    $n_s_util_control_NonFatal$ = new $c_s_util_control_NonFatal$();
  }
  return $n_s_util_control_NonFatal$;
}
/** @constructor */
function $c_s_util_hashing_MurmurHash3() {
}
$c_s_util_hashing_MurmurHash3.prototype = new $h_O();
$c_s_util_hashing_MurmurHash3.prototype.constructor = $c_s_util_hashing_MurmurHash3;
/** @constructor */
function $h_s_util_hashing_MurmurHash3() {
}
$h_s_util_hashing_MurmurHash3.prototype = $c_s_util_hashing_MurmurHash3.prototype;
$c_s_util_hashing_MurmurHash3.prototype.mix__I__I__I = (function(hash, data) {
  var h = this.mixLast__I__I__I(hash, data);
  var i = h;
  h = ((i << 13) | ((i >>> 19) | 0));
  return (((-430675100) + Math.imul(5, h)) | 0);
});
$c_s_util_hashing_MurmurHash3.prototype.mixLast__I__I__I = (function(hash, data) {
  var k = data;
  k = Math.imul((-862048943), k);
  var i = k;
  k = ((i << 15) | ((i >>> 17) | 0));
  k = Math.imul(461845907, k);
  return (hash ^ k);
});
$c_s_util_hashing_MurmurHash3.prototype.finalizeHash__I__I__I = (function(hash, length) {
  return this.scala$util$hashing$MurmurHash3$$avalanche__I__I((hash ^ length));
});
$c_s_util_hashing_MurmurHash3.prototype.scala$util$hashing$MurmurHash3$$avalanche__I__I = (function(hash) {
  var h = hash;
  h = (h ^ ((h >>> 16) | 0));
  h = Math.imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = Math.imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h;
});
$c_s_util_hashing_MurmurHash3.prototype.tuple2Hash__I__I__I__I = (function(x, y, seed) {
  var h = seed;
  h = this.mix__I__I__I(h, $f_T__hashCode__I("Tuple2"));
  h = this.mix__I__I__I(h, x);
  h = this.mix__I__I__I(h, y);
  return this.finalizeHash__I__I__I(h, 2);
});
$c_s_util_hashing_MurmurHash3.prototype.productHash__s_Product__I__Z__I = (function(x, seed, ignorePrefix) {
  var arr = $n(x).productArity__I();
  if ((arr === 0)) {
    return $f_T__hashCode__I($n($n(x).productPrefix__T()));
  } else {
    var h = seed;
    if ((!ignorePrefix)) {
      h = this.mix__I__I__I(h, $f_T__hashCode__I($n($n(x).productPrefix__T())));
    }
    var i = 0;
    while ((i < arr)) {
      var $x_1 = h;
      var x$1 = $n(x).productElement__I__O(i);
      h = this.mix__I__I__I($x_1, $m_sr_Statics$().anyHash__O__I(x$1));
      i = ((1 + i) | 0);
    }
    return this.finalizeHash__I__I__I(h, arr);
  }
});
$c_s_util_hashing_MurmurHash3.prototype.stringHash__T__I__I = (function(str, seed) {
  var h = seed;
  var i = 0;
  while (true) {
    var $x_1 = i;
    var this$1 = $n(str);
    if ((((1 + $x_1) | 0) < this$1.length)) {
      var this$2 = $n(str);
      var index = i;
      var this$3 = $n(str);
      var index$1 = ((1 + i) | 0);
      var data = ((($charAt(this$2, index) << 16) + $charAt(this$3, index$1)) | 0);
      h = this.mix__I__I__I(h, data);
      i = ((2 + i) | 0);
    } else {
      break;
    }
  }
  var $x_2 = i;
  var this$4 = $n(str);
  if (($x_2 < this$4.length)) {
    var $x_3 = h;
    var this$5 = $n(str);
    var index$2 = i;
    h = this.mixLast__I__I__I($x_3, $charAt(this$5, index$2));
  }
  var $x_4 = h;
  var this$6 = $n(str);
  return this.finalizeHash__I__I__I($x_4, this$6.length);
});
$c_s_util_hashing_MurmurHash3.prototype.unorderedHash__sc_IterableOnce__I__I = (function(xs, seed) {
  var a = 0;
  var b = 0;
  var n = 0;
  var c = 1;
  var iterator = $n(xs).iterator__sc_Iterator();
  while ($n(iterator).hasNext__Z()) {
    var x = $n(iterator).next__O();
    var h = $m_sr_Statics$().anyHash__O__I(x);
    a = ((a + h) | 0);
    b = (b ^ h);
    c = Math.imul(c, (1 | h));
    n = ((1 + n) | 0);
  }
  var h$2 = seed;
  h$2 = this.mix__I__I__I(h$2, a);
  h$2 = this.mix__I__I__I(h$2, b);
  h$2 = this.mixLast__I__I__I(h$2, c);
  return this.finalizeHash__I__I__I(h$2, n);
});
$c_s_util_hashing_MurmurHash3.prototype.orderedHash__sc_IterableOnce__I__I = (function(xs, seed) {
  var it = $n(xs).iterator__sc_Iterator();
  var h = seed;
  if ((!$n(it).hasNext__Z())) {
    return this.finalizeHash__I__I__I(h, 0);
  }
  var x0 = $n(it).next__O();
  if ((!$n(it).hasNext__Z())) {
    return this.finalizeHash__I__I__I(this.mix__I__I__I(h, $m_sr_Statics$().anyHash__O__I(x0)), 1);
  }
  var x1 = $n(it).next__O();
  var initial = $m_sr_Statics$().anyHash__O__I(x0);
  h = this.mix__I__I__I(h, initial);
  var h0 = h;
  var prev = $m_sr_Statics$().anyHash__O__I(x1);
  var rangeDiff = ((prev - initial) | 0);
  var i = 2;
  while ($n(it).hasNext__Z()) {
    h = this.mix__I__I__I(h, prev);
    var x = $n(it).next__O();
    var hash = $m_sr_Statics$().anyHash__O__I(x);
    if ((rangeDiff !== ((hash - prev) | 0))) {
      h = this.mix__I__I__I(h, hash);
      i = ((1 + i) | 0);
      while ($n(it).hasNext__Z()) {
        var $x_1 = h;
        var x$1 = $n(it).next__O();
        h = this.mix__I__I__I($x_1, $m_sr_Statics$().anyHash__O__I(x$1));
        i = ((1 + i) | 0);
      }
      return this.finalizeHash__I__I__I(h, i);
    }
    prev = hash;
    i = ((1 + i) | 0);
  }
  return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash__O__I__I = (function(a, seed) {
  var h = seed;
  var l = $m_jl_reflect_Array$().getLength__O__I(a);
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      var $x_1 = h;
      var x = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, 0);
      return this.finalizeHash__I__I__I(this.mix__I__I__I($x_1, $m_sr_Statics$().anyHash__O__I(x)), 1);
      break;
    }
    default: {
      var x$1 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, 0);
      var initial = $m_sr_Statics$().anyHash__O__I(x$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var x$2 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, 1);
      var prev = $m_sr_Statics$().anyHash__O__I(x$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var x$3 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i);
        var hash = $m_sr_Statics$().anyHash__O__I(x$3);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $x_2 = h;
            var x$4 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i);
            h = this.mix__I__I__I($x_2, $m_sr_Statics$().anyHash__O__I(x$4));
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.rangeHash__I__I__I__I__I = (function(start, step, last, seed) {
  return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(this.mix__I__I__I(seed, start), step), last));
});
$c_s_util_hashing_MurmurHash3.prototype.indexedSeqHash__sc_IndexedSeq__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).length__I();
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      var $x_1 = h;
      var x = $n(a).apply__I__O(0);
      return this.finalizeHash__I__I__I(this.mix__I__I__I($x_1, $m_sr_Statics$().anyHash__O__I(x)), 1);
      break;
    }
    default: {
      var x$1 = $n(a).apply__I__O(0);
      var initial = $m_sr_Statics$().anyHash__O__I(x$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var x$2 = $n(a).apply__I__O(1);
      var prev = $m_sr_Statics$().anyHash__O__I(x$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var x$3 = $n(a).apply__I__O(i);
        var hash = $m_sr_Statics$().anyHash__O__I(x$3);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $x_2 = h;
            var x$4 = $n(a).apply__I__O(i);
            h = this.mix__I__I__I($x_2, $m_sr_Statics$().anyHash__O__I(x$4));
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.listHash__sci_List__I__I = (function(xs, seed) {
  var n = 0;
  var h = seed;
  var rangeState = 0;
  var rangeDiff = 0;
  var prev = 0;
  var initial = 0;
  var elems = xs;
  while ((!$n(elems).isEmpty__Z())) {
    var head = $n(elems).head__O();
    var tail = $as_sci_List($n(elems).tail__O());
    var hash = $m_sr_Statics$().anyHash__O__I(head);
    h = this.mix__I__I__I(h, hash);
    var x1 = rangeState;
    switch (x1) {
      case 0: {
        initial = hash;
        rangeState = 1;
        break;
      }
      case 1: {
        rangeDiff = ((hash - prev) | 0);
        rangeState = 2;
        break;
      }
      case 2: {
        if ((rangeDiff !== ((hash - prev) | 0))) {
          rangeState = 3;
        }
        break;
      }
    }
    prev = hash;
    n = ((1 + n) | 0);
    elems = tail;
  }
  return ((rangeState === 2) ? this.rangeHash__I__I__I__I__I(initial, rangeDiff, prev, seed) : this.finalizeHash__I__I__I(h, n));
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mZc$sp__AZ__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, ($n(a).get(0) ? 1231 : 1237)), 1);
      break;
    }
    default: {
      var initial = ($n(a).get(0) ? 1231 : 1237);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = ($n(a).get(1) ? 1231 : 1237);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = ($n(a).get(i) ? 1231 : 1237);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, ($n(a).get(i) ? 1231 : 1237));
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mBc$sp__AB__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, $n(a).get(0)), 1);
      break;
    }
    default: {
      var initial = $n(a).get(0);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = $n(a).get(1);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = $n(a).get(i);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, $n(a).get(i));
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mCc$sp__AC__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, $n(a).get(0)), 1);
      break;
    }
    default: {
      var initial = $n(a).get(0);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = $n(a).get(1);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = $n(a).get(i);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, $n(a).get(i));
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mDc$sp__AD__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      var $x_1 = h;
      var dv = $n(a).get(0);
      return this.finalizeHash__I__I__I(this.mix__I__I__I($x_1, $m_sr_Statics$().doubleHash__D__I(dv)), 1);
      break;
    }
    default: {
      var dv$1 = $n(a).get(0);
      var initial = $m_sr_Statics$().doubleHash__D__I(dv$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var dv$2 = $n(a).get(1);
      var prev = $m_sr_Statics$().doubleHash__D__I(dv$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var dv$3 = $n(a).get(i);
        var hash = $m_sr_Statics$().doubleHash__D__I(dv$3);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $x_2 = h;
            var dv$4 = $n(a).get(i);
            h = this.mix__I__I__I($x_2, $m_sr_Statics$().doubleHash__D__I(dv$4));
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mFc$sp__AF__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      var $x_1 = h;
      var fv = $n(a).get(0);
      var this$1 = $m_sr_Statics$();
      return this.finalizeHash__I__I__I(this.mix__I__I__I($x_1, this$1.doubleHash__D__I(fv)), 1);
      break;
    }
    default: {
      var fv$1 = $n(a).get(0);
      var this$2 = $m_sr_Statics$();
      var initial = this$2.doubleHash__D__I(fv$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var fv$2 = $n(a).get(1);
      var this$3 = $m_sr_Statics$();
      var prev = this$3.doubleHash__D__I(fv$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var fv$3 = $n(a).get(i);
        var this$4 = $m_sr_Statics$();
        var hash = this$4.doubleHash__D__I(fv$3);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $x_2 = h;
            var fv$4 = $n(a).get(i);
            var this$5 = $m_sr_Statics$();
            h = this.mix__I__I__I($x_2, this$5.doubleHash__D__I(fv$4));
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mIc$sp__AI__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, $n(a).get(0)), 1);
      break;
    }
    default: {
      var initial = $n(a).get(0);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = $n(a).get(1);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = $n(a).get(i);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, $n(a).get(i));
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mJc$sp__AJ__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      var $x_1 = h;
      var t = $n(a).get(0);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      return this.finalizeHash__I__I__I(this.mix__I__I__I($x_1, $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi))), 1);
      break;
    }
    default: {
      var t$1 = $n(a).get(0);
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      var initial = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$1, hi$1));
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var t$2 = $n(a).get(1);
      var lo$2 = t$2.RTLong__f_lo;
      var hi$2 = t$2.RTLong__f_hi;
      var prev = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$2, hi$2));
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var t$3 = $n(a).get(i);
        var lo$3 = t$3.RTLong__f_lo;
        var hi$3 = t$3.RTLong__f_hi;
        var hash = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$3, hi$3));
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $x_2 = h;
            var t$4 = $n(a).get(i);
            var lo$4 = t$4.RTLong__f_lo;
            var hi$4 = t$4.RTLong__f_hi;
            h = this.mix__I__I__I($x_2, $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$4, hi$4)));
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mSc$sp__AS__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, $n(a).get(0)), 1);
      break;
    }
    default: {
      var initial = $n(a).get(0);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = $n(a).get(1);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = $n(a).get(i);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, $n(a).get(i));
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mVc$sp__Ajl_Void__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, 0), 1);
      break;
    }
    default: {
      h = this.mix__I__I__I(h, 0);
      var h0 = h;
      var prev = 0;
      var rangeDiff = prev;
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        if ((rangeDiff !== ((-prev) | 0))) {
          h = this.mix__I__I__I(h, 0);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, 0);
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = 0;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
function $is_Lsnabbdom_CreateHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_CreateHook)));
}
function $as_Lsnabbdom_CreateHook(obj) {
  return (($is_Lsnabbdom_CreateHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.CreateHook"));
}
function $isArrayOf_Lsnabbdom_CreateHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_CreateHook)));
}
function $asArrayOf_Lsnabbdom_CreateHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_CreateHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.CreateHook;", depth));
}
function $is_Lsnabbdom_DestroyHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_DestroyHook)));
}
function $as_Lsnabbdom_DestroyHook(obj) {
  return (($is_Lsnabbdom_DestroyHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.DestroyHook"));
}
function $isArrayOf_Lsnabbdom_DestroyHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_DestroyHook)));
}
function $asArrayOf_Lsnabbdom_DestroyHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_DestroyHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.DestroyHook;", depth));
}
function $is_Lsnabbdom_DomApi(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_DomApi)));
}
function $as_Lsnabbdom_DomApi(obj) {
  return (($is_Lsnabbdom_DomApi(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.DomApi"));
}
function $isArrayOf_Lsnabbdom_DomApi(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_DomApi)));
}
function $asArrayOf_Lsnabbdom_DomApi(obj, depth) {
  return (($isArrayOf_Lsnabbdom_DomApi(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.DomApi;", depth));
}
/** @constructor */
function $c_Lsnabbdom_EventHandler(cbs) {
  this.Lsnabbdom_EventHandler__f_cbs = null;
  this.Lsnabbdom_EventHandler__f_cbs = cbs;
}
$c_Lsnabbdom_EventHandler.prototype = new $h_O();
$c_Lsnabbdom_EventHandler.prototype.constructor = $c_Lsnabbdom_EventHandler;
/** @constructor */
function $h_Lsnabbdom_EventHandler() {
}
$h_Lsnabbdom_EventHandler.prototype = $c_Lsnabbdom_EventHandler.prototype;
function $as_Lsnabbdom_EventHandler(obj) {
  return (((obj instanceof $c_Lsnabbdom_EventHandler) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.EventHandler"));
}
function $isArrayOf_Lsnabbdom_EventHandler(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_EventHandler)));
}
function $asArrayOf_Lsnabbdom_EventHandler(obj, depth) {
  return (($isArrayOf_Lsnabbdom_EventHandler(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.EventHandler;", depth));
}
var $d_Lsnabbdom_EventHandler = new $TypeData().initClass($c_Lsnabbdom_EventHandler, "snabbdom.EventHandler", ({
  Lsnabbdom_EventHandler: 1
}));
/** @constructor */
function $c_Lsnabbdom_EventHandler$() {
}
$c_Lsnabbdom_EventHandler$.prototype = new $h_O();
$c_Lsnabbdom_EventHandler$.prototype.constructor = $c_Lsnabbdom_EventHandler$;
/** @constructor */
function $h_Lsnabbdom_EventHandler$() {
}
$h_Lsnabbdom_EventHandler$.prototype = $c_Lsnabbdom_EventHandler$.prototype;
$c_Lsnabbdom_EventHandler$.prototype.apply__sci_Seq__Lsnabbdom_EventHandler = (function(cbs) {
  return new $c_Lsnabbdom_EventHandler($as_sci_Seq($n(cbs).map__F1__O(new $c_sjsr_AnonFunction1(((cb) => {
    var cb$1 = $as_F1(cb);
    return new $c_sjsr_AnonFunction2(((ev, _$1) => {
      $as_Lsnabbdom_VNode(_$1);
      $n(cb$1).apply__O__O(ev);
    }));
  })))));
});
var $d_Lsnabbdom_EventHandler$ = new $TypeData().initClass($c_Lsnabbdom_EventHandler$, "snabbdom.EventHandler$", ({
  Lsnabbdom_EventHandler$: 1
}));
var $n_Lsnabbdom_EventHandler$;
function $m_Lsnabbdom_EventHandler$() {
  if ((!$n_Lsnabbdom_EventHandler$)) {
    $n_Lsnabbdom_EventHandler$ = new $c_Lsnabbdom_EventHandler$();
  }
  return $n_Lsnabbdom_EventHandler$;
}
function $is_Lsnabbdom_InitHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_InitHook)));
}
function $as_Lsnabbdom_InitHook(obj) {
  return (($is_Lsnabbdom_InitHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.InitHook"));
}
function $isArrayOf_Lsnabbdom_InitHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_InitHook)));
}
function $asArrayOf_Lsnabbdom_InitHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_InitHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.InitHook;", depth));
}
function $is_Lsnabbdom_InsertHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_InsertHook)));
}
function $as_Lsnabbdom_InsertHook(obj) {
  return (($is_Lsnabbdom_InsertHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.InsertHook"));
}
function $isArrayOf_Lsnabbdom_InsertHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_InsertHook)));
}
function $asArrayOf_Lsnabbdom_InsertHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_InsertHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.InsertHook;", depth));
}
/** @constructor */
function $c_Lsnabbdom_Listener(vnode) {
  this.Lsnabbdom_Listener__f_vnode = null;
  this.Lsnabbdom_Listener__f_jsFun = null;
  this.Lsnabbdom_Listener__f_vnode = vnode;
  this.Lsnabbdom_Listener__f_jsFun = ((event) => {
    this.handleEvent__Lorg_scalajs_dom_Event__V(event);
  });
}
$c_Lsnabbdom_Listener.prototype = new $h_O();
$c_Lsnabbdom_Listener.prototype.constructor = $c_Lsnabbdom_Listener;
/** @constructor */
function $h_Lsnabbdom_Listener() {
}
$h_Lsnabbdom_Listener.prototype = $c_Lsnabbdom_Listener.prototype;
$c_Lsnabbdom_Listener.prototype.handleEvent__Lorg_scalajs_dom_Event__V = (function(event) {
  var name = $as_T(event.type);
  var this$1 = $n($n($n($n(this.Lsnabbdom_Listener__f_vnode).Lsnabbdom_VNode__f_data).Lsnabbdom_VNodeData__f_on).get__O__s_Option(name));
  if ((!this$1.isEmpty__Z())) {
    var arg1 = this$1.get__O();
    var handler = $as_Lsnabbdom_EventHandler(arg1);
    $n($n(handler).Lsnabbdom_EventHandler__f_cbs).foreach__F1__V(new $c_sjsr_AnonFunction1(((cb) => {
      var cb$1 = $as_F2(cb);
      $n(cb$1).apply__O__O__O(event, this.Lsnabbdom_Listener__f_vnode);
    })));
  }
});
function $as_Lsnabbdom_Listener(obj) {
  return (((obj instanceof $c_Lsnabbdom_Listener) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.Listener"));
}
function $isArrayOf_Lsnabbdom_Listener(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_Listener)));
}
function $asArrayOf_Lsnabbdom_Listener(obj, depth) {
  return (($isArrayOf_Lsnabbdom_Listener(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.Listener;", depth));
}
var $d_Lsnabbdom_Listener = new $TypeData().initClass($c_Lsnabbdom_Listener, "snabbdom.Listener", ({
  Lsnabbdom_Listener: 1
}));
function $is_Lsnabbdom_PostHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_PostHook)));
}
function $as_Lsnabbdom_PostHook(obj) {
  return (($is_Lsnabbdom_PostHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.PostHook"));
}
function $isArrayOf_Lsnabbdom_PostHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_PostHook)));
}
function $asArrayOf_Lsnabbdom_PostHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_PostHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.PostHook;", depth));
}
function $is_Lsnabbdom_PostPatchHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_PostPatchHook)));
}
function $as_Lsnabbdom_PostPatchHook(obj) {
  return (($is_Lsnabbdom_PostPatchHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.PostPatchHook"));
}
function $isArrayOf_Lsnabbdom_PostPatchHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_PostPatchHook)));
}
function $asArrayOf_Lsnabbdom_PostPatchHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_PostPatchHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.PostPatchHook;", depth));
}
function $is_Lsnabbdom_PreHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_PreHook)));
}
function $as_Lsnabbdom_PreHook(obj) {
  return (($is_Lsnabbdom_PreHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.PreHook"));
}
function $isArrayOf_Lsnabbdom_PreHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_PreHook)));
}
function $asArrayOf_Lsnabbdom_PreHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_PreHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.PreHook;", depth));
}
function $is_Lsnabbdom_PrePatchHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_PrePatchHook)));
}
function $as_Lsnabbdom_PrePatchHook(obj) {
  return (($is_Lsnabbdom_PrePatchHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.PrePatchHook"));
}
function $isArrayOf_Lsnabbdom_PrePatchHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_PrePatchHook)));
}
function $asArrayOf_Lsnabbdom_PrePatchHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_PrePatchHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.PrePatchHook;", depth));
}
function $is_Lsnabbdom_RemoveHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_RemoveHook)));
}
function $as_Lsnabbdom_RemoveHook(obj) {
  return (($is_Lsnabbdom_RemoveHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.RemoveHook"));
}
function $isArrayOf_Lsnabbdom_RemoveHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_RemoveHook)));
}
function $asArrayOf_Lsnabbdom_RemoveHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_RemoveHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.RemoveHook;", depth));
}
function $is_Lsnabbdom_UpdateHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_UpdateHook)));
}
function $as_Lsnabbdom_UpdateHook(obj) {
  return (($is_Lsnabbdom_UpdateHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.UpdateHook"));
}
function $isArrayOf_Lsnabbdom_UpdateHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_UpdateHook)));
}
function $asArrayOf_Lsnabbdom_UpdateHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_UpdateHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.UpdateHook;", depth));
}
/** @constructor */
function $c_Lsnabbdom_VNode(sel, data, children, elm, text, key, listener) {
  this.Lsnabbdom_VNode__f_sel = null;
  this.Lsnabbdom_VNode__f_data = null;
  this.Lsnabbdom_VNode__f_children = null;
  this.Lsnabbdom_VNode__f_elm = null;
  this.Lsnabbdom_VNode__f_text = null;
  this.Lsnabbdom_VNode__f_key = null;
  this.Lsnabbdom_VNode__f_listener = null;
  this.Lsnabbdom_VNode__f_sel = sel;
  this.Lsnabbdom_VNode__f_data = data;
  this.Lsnabbdom_VNode__f_children = children;
  this.Lsnabbdom_VNode__f_elm = elm;
  this.Lsnabbdom_VNode__f_text = text;
  this.Lsnabbdom_VNode__f_key = key;
  this.Lsnabbdom_VNode__f_listener = listener;
}
$c_Lsnabbdom_VNode.prototype = new $h_O();
$c_Lsnabbdom_VNode.prototype.constructor = $c_Lsnabbdom_VNode;
/** @constructor */
function $h_Lsnabbdom_VNode() {
}
$h_Lsnabbdom_VNode.prototype = $c_Lsnabbdom_VNode.prototype;
$c_Lsnabbdom_VNode.prototype.toString__T = (function() {
  return ((((((((((("sel=" + this.Lsnabbdom_VNode__f_sel) + ", data=") + this.Lsnabbdom_VNode__f_data) + ", text=") + this.Lsnabbdom_VNode__f_text) + ", key=") + this.Lsnabbdom_VNode__f_key) + ", children=") + this.Lsnabbdom_VNode__f_children) + ", elm=") + this.Lsnabbdom_VNode__f_elm);
});
$c_Lsnabbdom_VNode.prototype.isTextNode__Z = (function() {
  if (($n(this.Lsnabbdom_VNode__f_sel).isEmpty__Z() && $n(this.Lsnabbdom_VNode__f_children).isEmpty__Z())) {
    var this$1 = $n(this.Lsnabbdom_VNode__f_text);
    return (!this$1.isEmpty__Z());
  } else {
    return false;
  }
});
function $as_Lsnabbdom_VNode(obj) {
  return (((obj instanceof $c_Lsnabbdom_VNode) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.VNode"));
}
function $isArrayOf_Lsnabbdom_VNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_VNode)));
}
function $asArrayOf_Lsnabbdom_VNode(obj, depth) {
  return (($isArrayOf_Lsnabbdom_VNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.VNode;", depth));
}
var $d_Lsnabbdom_VNode = new $TypeData().initClass($c_Lsnabbdom_VNode, "snabbdom.VNode", ({
  Lsnabbdom_VNode: 1
}));
/** @constructor */
function $c_Lsnabbdom_VNode$() {
}
$c_Lsnabbdom_VNode$.prototype = new $h_O();
$c_Lsnabbdom_VNode$.prototype.constructor = $c_Lsnabbdom_VNode$;
/** @constructor */
function $h_Lsnabbdom_VNode$() {
}
$h_Lsnabbdom_VNode$.prototype = $c_Lsnabbdom_VNode$.prototype;
$c_Lsnabbdom_VNode$.prototype.empty__Lsnabbdom_VNode = (function() {
  return new $c_Lsnabbdom_VNode($m_s_None$(), $m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty, $m_s_None$(), $m_s_None$(), new $c_s_Some(""), $m_s_None$(), $m_s_None$());
});
$c_Lsnabbdom_VNode$.prototype.create__s_Option__Lsnabbdom_VNodeData__s_Option__s_Option__s_Option__Lsnabbdom_VNode = (function(sel, data, children, text, elm) {
  var this$1 = $n(children);
  if (this$1.isEmpty__Z()) {
    var $x_1 = true;
  } else {
    var arg1 = this$1.get__O();
    var _$1 = $asArrayOf_Lsnabbdom_VNode(arg1, 1);
    var $x_1 = ($n(_$1).u.length !== 0);
  }
  return new $c_Lsnabbdom_VNode(sel, data, ($x_1 ? this$1 : $m_s_None$()), elm, text, $n(data).Lsnabbdom_VNodeData__f_key, $m_s_None$());
});
$c_Lsnabbdom_VNode$.prototype.text__T__Lsnabbdom_VNode = (function(text) {
  return new $c_Lsnabbdom_VNode($m_s_None$(), $m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty, $m_s_None$(), $m_s_None$(), new $c_s_Some(text), $m_s_None$(), $m_s_None$());
});
var $d_Lsnabbdom_VNode$ = new $TypeData().initClass($c_Lsnabbdom_VNode$, "snabbdom.VNode$", ({
  Lsnabbdom_VNode$: 1
}));
var $n_Lsnabbdom_VNode$;
function $m_Lsnabbdom_VNode$() {
  if ((!$n_Lsnabbdom_VNode$)) {
    $n_Lsnabbdom_VNode$ = new $c_Lsnabbdom_VNode$();
  }
  return $n_Lsnabbdom_VNode$;
}
function $p_Lsnabbdom_h$__apply__T__s_Option__s_Option__s_Option__Lsnabbdom_VNode($thiz, sel, data, children, text) {
  var $x_2 = $m_Lsnabbdom_VNode$();
  var $x_1 = new $c_s_Some(sel);
  var this$2 = $n(data);
  var vnode = $n($x_2).create__s_Option__Lsnabbdom_VNodeData__s_Option__s_Option__s_Option__Lsnabbdom_VNode($x_1, $as_Lsnabbdom_VNodeData((this$2.isEmpty__Z() ? $m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty : this$2.get__O())), children, text, $m_s_None$());
  var this$3 = $n(sel);
  if (((this$3.length >= 0) && ($as_T(this$3.substring(0, 3)) === "svg"))) {
    var this$4 = $n(sel);
    if ((this$4.length === 3)) {
      var $x_4 = true;
    } else {
      var this$7 = $n(sel);
      var $x_4 = ($charAt(this$7, 3) === 46);
    }
    if ($x_4) {
      var $x_3 = true;
    } else {
      var this$10 = $n(sel);
      var $x_3 = ($charAt(this$10, 3) === 35);
    }
  } else {
    var $x_3 = false;
  }
  if ($x_3) {
    $thiz.addNS__Lsnabbdom_VNode__V(vnode);
  }
  return vnode;
}
/** @constructor */
function $c_Lsnabbdom_h$() {
}
$c_Lsnabbdom_h$.prototype = new $h_O();
$c_Lsnabbdom_h$.prototype.constructor = $c_Lsnabbdom_h$;
/** @constructor */
function $h_Lsnabbdom_h$() {
}
$h_Lsnabbdom_h$.prototype = $c_Lsnabbdom_h$.prototype;
$c_Lsnabbdom_h$.prototype.apply__T__Lsnabbdom_VNodeData__ALsnabbdom_VNode__Lsnabbdom_VNode = (function(sel, data, children) {
  return $p_Lsnabbdom_h$__apply__T__s_Option__s_Option__s_Option__Lsnabbdom_VNode(this, sel, new $c_s_Some(data), new $c_s_Some(children), $m_s_None$());
});
$c_Lsnabbdom_h$.prototype.addNS__Lsnabbdom_VNode__V = (function(vnode) {
  var $x_1 = $n(vnode);
  var \u03b41$ = $n(vnode).Lsnabbdom_VNode__f_data;
  var ns$1 = new $c_s_Some("http://www.w3.org/2000/svg");
  var this$2 = $n(\u03b41$);
  var props$1 = this$2.Lsnabbdom_VNodeData__f_props;
  var this$3 = $n(\u03b41$);
  var attrs$1 = this$3.Lsnabbdom_VNodeData__f_attrs;
  var this$4 = $n(\u03b41$);
  var classes$1 = this$4.Lsnabbdom_VNodeData__f_classes;
  var this$5 = $n(\u03b41$);
  var style$1 = this$5.Lsnabbdom_VNodeData__f_style;
  var this$6 = $n(\u03b41$);
  var dataset$1 = this$6.Lsnabbdom_VNodeData__f_dataset;
  var this$7 = $n(\u03b41$);
  var on$1 = this$7.Lsnabbdom_VNodeData__f_on;
  var this$8 = $n(\u03b41$);
  var hook$1 = this$8.Lsnabbdom_VNodeData__f_hook;
  var this$9 = $n(\u03b41$);
  var key$1 = this$9.Lsnabbdom_VNodeData__f_key;
  var this$10 = $n(\u03b41$);
  var fn$1 = this$10.Lsnabbdom_VNodeData__f_fn;
  var this$11 = $n(\u03b41$);
  var args$1 = this$11.Lsnabbdom_VNodeData__f_args;
  var this$12 = $n(\u03b41$);
  var is$1 = this$12.Lsnabbdom_VNodeData__f_is;
  $n(\u03b41$);
  $x_1.Lsnabbdom_VNode__f_data = new $c_Lsnabbdom_VNodeData(props$1, attrs$1, classes$1, style$1, dataset$1, on$1, hook$1, key$1, ns$1, fn$1, args$1, is$1);
  var this$14 = $n($n(vnode).Lsnabbdom_VNode__f_sel);
  if (this$14.isEmpty__Z()) {
    var $x_2 = true;
  } else {
    var arg1 = this$14.get__O();
    var _$1 = $as_T(arg1);
    var $x_2 = (_$1 !== "foreignObject");
  }
  if ($x_2) {
    var this$15 = $n($n(vnode).Lsnabbdom_VNode__f_children);
    if ((!this$15.isEmpty__Z())) {
      var arg1$1 = this$15.get__O();
      var _$2 = $asArrayOf_Lsnabbdom_VNode(arg1$1, 1);
      var f = ((vnode$1) => {
        var vnode$2 = $as_Lsnabbdom_VNode(vnode$1);
        this.addNS__Lsnabbdom_VNode__V(vnode$2);
      });
      var len = $n(_$2).u.length;
      var ys = new ($d_jl_Void.getArrayOf().constr)(len);
      if ((len > 0)) {
        var i = 0;
        if ((_$2 !== null)) {
          while ((i < len)) {
            var $x_3 = i;
            var arg1$2 = $n(_$2).get(i);
            ys.set($x_3, f(arg1$2));
            i = ((1 + i) | 0);
          }
        } else if ((_$2 instanceof $ac_I)) {
          var x3 = $asArrayOf_I(_$2, 1);
          while ((i < len)) {
            var $x_4 = i;
            var arg1$3 = $n(x3).get(i);
            ys.set($x_4, f(arg1$3));
            i = ((1 + i) | 0);
          }
        } else if ((_$2 instanceof $ac_D)) {
          var x4 = $asArrayOf_D(_$2, 1);
          while ((i < len)) {
            var $x_5 = i;
            var arg1$4 = $n(x4).get(i);
            ys.set($x_5, f(arg1$4));
            i = ((1 + i) | 0);
          }
        } else if ((_$2 instanceof $ac_J)) {
          var x5 = $asArrayOf_J(_$2, 1);
          while ((i < len)) {
            var $x_6 = i;
            var t = $n(x5).get(i);
            var lo = t.RTLong__f_lo;
            var hi = t.RTLong__f_hi;
            ys.set($x_6, f(new $c_RTLong(lo, hi)));
            i = ((1 + i) | 0);
          }
        } else if ((_$2 instanceof $ac_F)) {
          var x6 = $asArrayOf_F(_$2, 1);
          while ((i < len)) {
            var $x_7 = i;
            var arg1$5 = $n(x6).get(i);
            ys.set($x_7, f(arg1$5));
            i = ((1 + i) | 0);
          }
        } else if ((_$2 instanceof $ac_C)) {
          var x7 = $asArrayOf_C(_$2, 1);
          while ((i < len)) {
            var $x_8 = i;
            var arg1$6 = $n(x7).get(i);
            ys.set($x_8, f($bC(arg1$6)));
            i = ((1 + i) | 0);
          }
        } else if ((_$2 instanceof $ac_B)) {
          var x8 = $asArrayOf_B(_$2, 1);
          while ((i < len)) {
            var $x_9 = i;
            var arg1$7 = $n(x8).get(i);
            ys.set($x_9, f(arg1$7));
            i = ((1 + i) | 0);
          }
        } else if ((_$2 instanceof $ac_S)) {
          var x9 = $asArrayOf_S(_$2, 1);
          while ((i < len)) {
            var $x_10 = i;
            var arg1$8 = $n(x9).get(i);
            ys.set($x_10, f(arg1$8));
            i = ((1 + i) | 0);
          }
        } else if ((_$2 instanceof $ac_Z)) {
          var x10 = $asArrayOf_Z(_$2, 1);
          while ((i < len)) {
            var $x_11 = i;
            var arg1$9 = $n(x10).get(i);
            ys.set($x_11, f(arg1$9));
            i = ((1 + i) | 0);
          }
        } else {
          throw new $c_s_MatchError(_$2);
        }
      }
    }
  }
});
var $d_Lsnabbdom_h$ = new $TypeData().initClass($c_Lsnabbdom_h$, "snabbdom.h$", ({
  Lsnabbdom_h$: 1
}));
var $n_Lsnabbdom_h$;
function $m_Lsnabbdom_h$() {
  if ((!$n_Lsnabbdom_h$)) {
    $n_Lsnabbdom_h$ = new $c_Lsnabbdom_h$();
  }
  return $n_Lsnabbdom_h$;
}
function $p_Lsnabbdom_init$__sameVnode__Lsnabbdom_VNode__Lsnabbdom_VNode__Z($thiz, vnode1, vnode2) {
  var x = $n(vnode1).Lsnabbdom_VNode__f_key;
  var x$2 = $n(vnode2).Lsnabbdom_VNode__f_key;
  if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
    var x$3 = $n($n(vnode1).Lsnabbdom_VNode__f_data).Lsnabbdom_VNodeData__f_is;
    var x$4 = $n($n(vnode2).Lsnabbdom_VNode__f_data).Lsnabbdom_VNodeData__f_is;
    var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var x$5 = $n(vnode1).Lsnabbdom_VNode__f_sel;
    var x$6 = $n(vnode2).Lsnabbdom_VNode__f_sel;
    return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
  } else {
    return false;
  }
}
function $p_Lsnabbdom_init$__createKeyToOldIdx__ALsnabbdom_VNode__I__I__sci_Map($thiz, children, beginIdx, endIdx) {
  var $x_10 = $m_s_Predef$();
  var xs = $m_sc_ArrayOps$().zipWithIndex$extension__O__AT2(children);
  var f = ((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var ch = $as_Lsnabbdom_VNode($n(x$1$1)._1__O());
      var i = $uI($n(x$1$1)._2__O());
      var this$4 = $n($n(ch).Lsnabbdom_VNode__f_key);
      if (this$4.isEmpty__Z()) {
        return $m_s_None$();
      } else {
        var arg1 = this$4.get__O();
        var key = $as_T(arg1);
        return new $c_s_Some(new $c_T2(key, i));
      }
    }
    throw new $c_s_MatchError(x$1$1);
  });
  var len = $n(xs).u.length;
  var ys = new ($d_s_Option.getArrayOf().constr)(len);
  if ((len > 0)) {
    var i$1 = 0;
    if ((xs !== null)) {
      while ((i$1 < len)) {
        var $x_1 = i$1;
        var arg1$1 = $n(xs).get(i$1);
        ys.set($x_1, f(arg1$1));
        i$1 = ((1 + i$1) | 0);
      }
    } else if ((xs instanceof $ac_I)) {
      var x3 = $asArrayOf_I(xs, 1);
      while ((i$1 < len)) {
        var $x_2 = i$1;
        var arg1$2 = $n(x3).get(i$1);
        ys.set($x_2, f(arg1$2));
        i$1 = ((1 + i$1) | 0);
      }
    } else if ((xs instanceof $ac_D)) {
      var x4 = $asArrayOf_D(xs, 1);
      while ((i$1 < len)) {
        var $x_3 = i$1;
        var arg1$3 = $n(x4).get(i$1);
        ys.set($x_3, f(arg1$3));
        i$1 = ((1 + i$1) | 0);
      }
    } else if ((xs instanceof $ac_J)) {
      var x5 = $asArrayOf_J(xs, 1);
      while ((i$1 < len)) {
        var $x_4 = i$1;
        var t = $n(x5).get(i$1);
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        ys.set($x_4, f(new $c_RTLong(lo, hi)));
        i$1 = ((1 + i$1) | 0);
      }
    } else if ((xs instanceof $ac_F)) {
      var x6 = $asArrayOf_F(xs, 1);
      while ((i$1 < len)) {
        var $x_5 = i$1;
        var arg1$4 = $n(x6).get(i$1);
        ys.set($x_5, f(arg1$4));
        i$1 = ((1 + i$1) | 0);
      }
    } else if ((xs instanceof $ac_C)) {
      var x7 = $asArrayOf_C(xs, 1);
      while ((i$1 < len)) {
        var $x_6 = i$1;
        var arg1$5 = $n(x7).get(i$1);
        ys.set($x_6, f($bC(arg1$5)));
        i$1 = ((1 + i$1) | 0);
      }
    } else if ((xs instanceof $ac_B)) {
      var x8 = $asArrayOf_B(xs, 1);
      while ((i$1 < len)) {
        var $x_7 = i$1;
        var arg1$6 = $n(x8).get(i$1);
        ys.set($x_7, f(arg1$6));
        i$1 = ((1 + i$1) | 0);
      }
    } else if ((xs instanceof $ac_S)) {
      var x9 = $asArrayOf_S(xs, 1);
      while ((i$1 < len)) {
        var $x_8 = i$1;
        var arg1$7 = $n(x9).get(i$1);
        ys.set($x_8, f(arg1$7));
        i$1 = ((1 + i$1) | 0);
      }
    } else if ((xs instanceof $ac_Z)) {
      var x10 = $asArrayOf_Z(xs, 1);
      while ((i$1 < len)) {
        var $x_9 = i$1;
        var arg1$8 = $n(x10).get(i$1);
        ys.set($x_9, f(arg1$8));
        i$1 = ((1 + i$1) | 0);
      }
    } else {
      throw new $c_s_MatchError(xs);
    }
  }
  var pf = new $c_Lsnabbdom_init$$anon$2();
  var fallback = $m_sc_ArrayOps$().sc_ArrayOps$__f_fallback;
  var capacity = 0;
  var jsElems = null;
  capacity = 0;
  jsElems = [];
  var i$2 = 0;
  while ((i$2 < ys.u.length)) {
    var x = ys.get(i$2);
    var v = pf.applyOrElse__s_Option__F1__O($as_s_Option(x), fallback);
    if ((v !== fallback)) {
      var unboxedElem = ((v === null) ? null : v);
      jsElems.push(unboxedElem);
    }
    i$2 = ((1 + i$2) | 0);
  }
  var this$15 = $n($n($x_10).wrapRefArray__AO__scm_ArraySeq$ofRef(new ($d_T2.getArrayOf().constr)(jsElems)));
  var this$14 = $m_s_$less$colon$less$();
  return $as_sci_Map($n($m_sci_Map$().from__sc_IterableOnce__sci_Map(this$15)).filter__F1__O(new $c_sjsr_AnonFunction1(((kv) => {
    var kv$1 = $as_T2(kv);
    return (($uI($n(kv$1)._2__O()) >= beginIdx) && ($uI($n(kv$1)._2__O()) <= endIdx));
  }))));
}
function $p_Lsnabbdom_init$__createRmCb$1__Lsnabbdom_DomApi__Lorg_scalajs_dom_Node__I__F0($thiz, api$3, childElm, listeners) {
  var listeners0 = new $c_sr_IntRef(listeners);
  return new $c_sjsr_AnonFunction0((() => {
    var ev$10 = (((-1) + listeners0.sr_IntRef__f_elem) | 0);
    listeners0.sr_IntRef__f_elem = ev$10;
    if ((listeners0.sr_IntRef__f_elem === 0)) {
      var parent = $n(api$3).parentNode__Lorg_scalajs_dom_Node__s_Option(childElm);
      var this$3 = $n(parent);
      if ((!this$3.isEmpty__Z())) {
        var arg1 = this$3.get__O();
        $n(api$3).removeChild__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__V(arg1, childElm);
      }
    }
  }));
}
function $p_Lsnabbdom_init$__createElm$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__scm_ArrayBuffer__Lorg_scalajs_dom_Node($thiz, api$5, cbs$1, vnode, insertedVNodeQueue) {
  var elem = $n(vnode).Lsnabbdom_VNode__f_data;
  var elem$1 = null;
  elem$1 = elem;
  var this$2 = $n($n($as_Lsnabbdom_VNodeData(elem$1)).Lsnabbdom_VNodeData__f_hook);
  if ((!this$2.isEmpty__Z())) {
    var arg1 = this$2.get__O();
    var h = $as_Lsnabbdom_Hooks(arg1);
    var this$3 = $n($n(h).init__s_Option());
    if (this$3.isEmpty__Z()) {
    } else {
      var arg1$1 = this$3.get__O();
      var init0 = $as_Lsnabbdom_InitHook(arg1$1);
      $n(init0).apply__Lsnabbdom_VNode__O(vnode);
      var ev$11 = $n(vnode).Lsnabbdom_VNode__f_data;
      elem$1 = ev$11;
      ev$11 = null;
    }
  }
  var sel = $n(vnode).Lsnabbdom_VNode__f_sel;
  matchResult5: {
    if ((sel instanceof $c_s_Some)) {
      var x17 = $as_T($n($as_s_Some(sel)).s_Some__f_value);
      if ((x17 === "!")) {
        var $x_1 = $n(vnode);
        var this$4 = $n($n(vnode).Lsnabbdom_VNode__f_text);
        var value = (this$4.isEmpty__Z() ? "" : this$4.get__O());
        $x_1.Lsnabbdom_VNode__f_text = new $c_s_Some(value);
        var $x_2 = $n(vnode);
        var value$1 = $n(api$5).createComment__T__Lorg_scalajs_dom_Comment($as_T($n($n(vnode).Lsnabbdom_VNode__f_text).get__O()));
        $x_2.Lsnabbdom_VNode__f_elm = new $c_s_Some(value$1);
        break matchResult5;
      }
      var this$7 = $n(x17);
      var hashIdx = $uI(this$7.indexOf("#"));
      var this$8 = $n(x17);
      var dotIdx = $uI(this$8.indexOf(".", hashIdx));
      if ((hashIdx > 0)) {
        var hash = hashIdx;
      } else {
        var this$9 = $n(x17);
        var hash = this$9.length;
      }
      if ((dotIdx > 0)) {
        var dot = dotIdx;
      } else {
        var this$10 = $n(x17);
        var dot = this$10.length;
      }
      var tag = (((hashIdx !== (-1)) || (dotIdx !== (-1))) ? $m_sc_StringOps$().slice$extension__T__I__I__T(x17, 0, ((hash < dot) ? hash : dot)) : x17);
      var this$14 = $n($n($as_Lsnabbdom_VNodeData(elem$1)).Lsnabbdom_VNodeData__f_ns);
      if ((!this$14.isEmpty__Z())) {
        var elm = $n(api$5).createElementNS__T__T__Lorg_scalajs_dom_Element($as_T($n($n($as_Lsnabbdom_VNodeData(elem$1)).Lsnabbdom_VNodeData__f_ns).get__O()), tag);
      } else {
        var elm = $n(api$5).createElement__T__Lorg_scalajs_dom_HTMLElement(tag);
      }
      $n(vnode).Lsnabbdom_VNode__f_elm = new $c_s_Some(elm);
      if ((hash < dot)) {
        elm.setAttribute("id", $m_sc_StringOps$().slice$extension__T__I__I__T(x17, ((1 + hash) | 0), dot));
      }
      if ((dotIdx > 0)) {
        var $x_3 = $m_sc_StringOps$();
        var this$18 = $n(x17);
        elm.setAttribute("class", $f_T__replaceAll__T__T__T($n($n($x_3).slice$extension__T__I__I__T(x17, ((1 + dot) | 0), this$18.length)), "\\.", " "));
      }
      var this$19 = $n($n(cbs$1).Lsnabbdom_ModuleHooks__f_create);
      var these = this$19;
      while ((!$n(these).isEmpty__Z())) {
        var arg1$2 = $n(these).head__O();
        var _$10 = $as_Lsnabbdom_CreateHook(arg1$2);
        $n(_$10).apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O($thiz.Lsnabbdom_init$__f_emptyNode, vnode);
        these = $as_sci_List($n(these).tail__O());
      }
      matchResult3: {
        var x7 = $n(vnode).Lsnabbdom_VNode__f_children;
        var x = $m_s_None$();
        if ((x === x7)) {
          matchResult2: {
            var x4 = $n(vnode).Lsnabbdom_VNode__f_text;
            var x$3 = $m_s_None$();
            if ((x$3 === x4)) {
              break matchResult2;
            }
            if ((x4 instanceof $c_s_Some)) {
              var text = $as_T($n($as_s_Some(x4)).s_Some__f_value);
              $n(api$5).appendChild__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__V(elm, $n(api$5).createTextNode__T__Lorg_scalajs_dom_Text(text));
              break matchResult2;
            }
            throw new $c_s_MatchError(x4);
          }
          break matchResult3;
        }
        if ((x7 instanceof $c_s_Some)) {
          var children = $asArrayOf_Lsnabbdom_VNode($n($as_s_Some(x7)).s_Some__f_value, 1);
          var f = ((child) => {
            var child$1 = $as_Lsnabbdom_VNode(child);
            $n(api$5).appendChild__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__V(elm, $p_Lsnabbdom_init$__createElm$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__scm_ArrayBuffer__Lorg_scalajs_dom_Node($thiz, api$5, cbs$1, child$1, insertedVNodeQueue));
          });
          var len = $n(children).u.length;
          var i = 0;
          if ((children !== null)) {
            while ((i < len)) {
              var arg1$3 = $n(children).get(i);
              f(arg1$3);
              i = ((1 + i) | 0);
            }
          } else if ((children instanceof $ac_I)) {
            var x3 = $asArrayOf_I(children, 1);
            while ((i < len)) {
              var arg1$4 = $n(x3).get(i);
              f(arg1$4);
              i = ((1 + i) | 0);
            }
          } else if ((children instanceof $ac_D)) {
            var x4$1 = $asArrayOf_D(children, 1);
            while ((i < len)) {
              var arg1$5 = $n(x4$1).get(i);
              f(arg1$5);
              i = ((1 + i) | 0);
            }
          } else if ((children instanceof $ac_J)) {
            var x5 = $asArrayOf_J(children, 1);
            while ((i < len)) {
              var t = $n(x5).get(i);
              var lo = t.RTLong__f_lo;
              var hi = t.RTLong__f_hi;
              f(new $c_RTLong(lo, hi));
              i = ((1 + i) | 0);
            }
          } else if ((children instanceof $ac_F)) {
            var x6 = $asArrayOf_F(children, 1);
            while ((i < len)) {
              var arg1$6 = $n(x6).get(i);
              f(arg1$6);
              i = ((1 + i) | 0);
            }
          } else if ((children instanceof $ac_C)) {
            var x7$1 = $asArrayOf_C(children, 1);
            while ((i < len)) {
              var arg1$7 = $n(x7$1).get(i);
              f($bC(arg1$7));
              i = ((1 + i) | 0);
            }
          } else if ((children instanceof $ac_B)) {
            var x8 = $asArrayOf_B(children, 1);
            while ((i < len)) {
              var arg1$8 = $n(x8).get(i);
              f(arg1$8);
              i = ((1 + i) | 0);
            }
          } else if ((children instanceof $ac_S)) {
            var x9 = $asArrayOf_S(children, 1);
            while ((i < len)) {
              var arg1$9 = $n(x9).get(i);
              f(arg1$9);
              i = ((1 + i) | 0);
            }
          } else if ((children instanceof $ac_Z)) {
            var x10 = $asArrayOf_Z(children, 1);
            while ((i < len)) {
              var arg1$10 = $n(x10).get(i);
              f(arg1$10);
              i = ((1 + i) | 0);
            }
          } else {
            throw new $c_s_MatchError(children);
          }
          break matchResult3;
        }
        throw new $c_s_MatchError(x7);
      }
      var this$22 = $n($n($n(vnode).Lsnabbdom_VNode__f_data).Lsnabbdom_VNodeData__f_hook);
      if (this$22.isEmpty__Z()) {
        $m_s_None$();
        break matchResult5;
      } else {
        var arg1$11 = this$22.get__O();
        var hooks = $as_Lsnabbdom_Hooks(arg1$11);
        var this$23 = $n($n(hooks).create__s_Option());
        if ((!this$23.isEmpty__Z())) {
          var arg1$12 = this$23.get__O();
          var hook = $as_Lsnabbdom_CreateHook(arg1$12);
          $n(hook).apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O($thiz.Lsnabbdom_init$__f_emptyNode, vnode);
        }
        var this$24 = $n($n(hooks).insert__s_Option());
        if ((!this$24.isEmpty__Z())) {
          var arg1$13 = this$24.get__O();
          $as_Lsnabbdom_InsertHook(arg1$13);
          var this$25 = $n(insertedVNodeQueue);
          this$25.addOne__O__scm_ArrayBuffer(vnode);
        }
        new $c_s_Some((void 0));
        break matchResult5;
      }
    }
    var x$5 = $m_s_None$();
    if ((x$5 === sel)) {
      matchResult4: {
        var x10$1 = $n(vnode).Lsnabbdom_VNode__f_children;
        var x$7 = $m_s_None$();
        if ((x$7 === x10$1)) {
          var $x_5 = $n(vnode);
          var $x_4 = $n(api$5);
          var this$26 = $n($n(vnode).Lsnabbdom_VNode__f_text);
          var value$2 = $n($x_4).createTextNode__T__Lorg_scalajs_dom_Text($as_T((this$26.isEmpty__Z() ? "" : this$26.get__O())));
          $x_5.Lsnabbdom_VNode__f_elm = new $c_s_Some(value$2);
          break matchResult4;
        }
        if ((x10$1 instanceof $c_s_Some)) {
          var children$2 = $asArrayOf_Lsnabbdom_VNode($n($as_s_Some(x10$1)).s_Some__f_value, 1);
          var elm$3 = $n(api$5).createDocumentFragment__Lorg_scalajs_dom_DocumentFragment();
          $n(vnode).Lsnabbdom_VNode__f_elm = new $c_s_Some(elm$3);
          var this$29 = $n($n(cbs$1).Lsnabbdom_ModuleHooks__f_create);
          var these$1 = this$29;
          while ((!$n(these$1).isEmpty__Z())) {
            var arg1$14 = $n(these$1).head__O();
            var hook$1 = $as_Lsnabbdom_CreateHook(arg1$14);
            $n(hook$1).apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O($thiz.Lsnabbdom_init$__f_emptyNode, vnode);
            these$1 = $as_sci_List($n(these$1).tail__O());
          }
          var f$1 = ((child$2) => {
            var child$3 = $as_Lsnabbdom_VNode(child$2);
            $n(api$5).appendChild__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__V(elm$3, $p_Lsnabbdom_init$__createElm$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__scm_ArrayBuffer__Lorg_scalajs_dom_Node($thiz, api$5, cbs$1, child$3, insertedVNodeQueue));
          });
          var len$1 = $n(children$2).u.length;
          var i$1 = 0;
          if ((children$2 !== null)) {
            while ((i$1 < len$1)) {
              var arg1$15 = $n(children$2).get(i$1);
              f$1(arg1$15);
              i$1 = ((1 + i$1) | 0);
            }
          } else if ((children$2 instanceof $ac_I)) {
            var x3$1 = $asArrayOf_I(children$2, 1);
            while ((i$1 < len$1)) {
              var arg1$16 = $n(x3$1).get(i$1);
              f$1(arg1$16);
              i$1 = ((1 + i$1) | 0);
            }
          } else if ((children$2 instanceof $ac_D)) {
            var x4$2 = $asArrayOf_D(children$2, 1);
            while ((i$1 < len$1)) {
              var arg1$17 = $n(x4$2).get(i$1);
              f$1(arg1$17);
              i$1 = ((1 + i$1) | 0);
            }
          } else if ((children$2 instanceof $ac_J)) {
            var x5$1 = $asArrayOf_J(children$2, 1);
            while ((i$1 < len$1)) {
              var t$1 = $n(x5$1).get(i$1);
              var lo$1 = t$1.RTLong__f_lo;
              var hi$1 = t$1.RTLong__f_hi;
              f$1(new $c_RTLong(lo$1, hi$1));
              i$1 = ((1 + i$1) | 0);
            }
          } else if ((children$2 instanceof $ac_F)) {
            var x6$1 = $asArrayOf_F(children$2, 1);
            while ((i$1 < len$1)) {
              var arg1$18 = $n(x6$1).get(i$1);
              f$1(arg1$18);
              i$1 = ((1 + i$1) | 0);
            }
          } else if ((children$2 instanceof $ac_C)) {
            var x7$2 = $asArrayOf_C(children$2, 1);
            while ((i$1 < len$1)) {
              var arg1$19 = $n(x7$2).get(i$1);
              f$1($bC(arg1$19));
              i$1 = ((1 + i$1) | 0);
            }
          } else if ((children$2 instanceof $ac_B)) {
            var x8$1 = $asArrayOf_B(children$2, 1);
            while ((i$1 < len$1)) {
              var arg1$20 = $n(x8$1).get(i$1);
              f$1(arg1$20);
              i$1 = ((1 + i$1) | 0);
            }
          } else if ((children$2 instanceof $ac_S)) {
            var x9$1 = $asArrayOf_S(children$2, 1);
            while ((i$1 < len$1)) {
              var arg1$21 = $n(x9$1).get(i$1);
              f$1(arg1$21);
              i$1 = ((1 + i$1) | 0);
            }
          } else if ((children$2 instanceof $ac_Z)) {
            var x10$2 = $asArrayOf_Z(children$2, 1);
            while ((i$1 < len$1)) {
              var arg1$22 = $n(x10$2).get(i$1);
              f$1(arg1$22);
              i$1 = ((1 + i$1) | 0);
            }
          } else {
            throw new $c_s_MatchError(children$2);
          }
          break matchResult4;
        }
        throw new $c_s_MatchError(x10$1);
      }
      break matchResult5;
    }
    throw new $c_s_MatchError(sel);
  }
  return $n($n(vnode).Lsnabbdom_VNode__f_elm).get__O();
}
function $p_Lsnabbdom_init$__addVnodes$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__s_Option__ALsnabbdom_VNode__I__I__scm_ArrayBuffer__V($thiz, api$8, cbs$4, parentElm, before, vnodes, startIdx, endIdx, insertedVNodeQueue) {
  var i = startIdx;
  while ((i <= endIdx)) {
    var ch = $n(vnodes).get(i);
    $n(api$8).insertBefore__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__s_Option__V(parentElm, $p_Lsnabbdom_init$__createElm$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__scm_ArrayBuffer__Lorg_scalajs_dom_Node($thiz, api$8, cbs$4, ch, insertedVNodeQueue), before);
    i = ((1 + i) | 0);
  }
}
function $p_Lsnabbdom_init$__invokeDestroyHook$1__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__V($thiz, cbs$5, vnode) {
  if ((!$n(vnode).isTextNode__Z())) {
    var this$1 = $n($n($n(vnode).Lsnabbdom_VNode__f_data).Lsnabbdom_VNodeData__f_hook);
    if (this$1.isEmpty__Z()) {
      var $x_1 = $m_s_None$();
    } else {
      var arg1 = this$1.get__O();
      var _$12 = $as_Lsnabbdom_Hooks(arg1);
      var $x_1 = $n(_$12).destroy__s_Option();
    }
    var this$2 = $n($x_1);
    if ((!this$2.isEmpty__Z())) {
      var arg1$1 = this$2.get__O();
      var hook = $as_Lsnabbdom_DestroyHook(arg1$1);
      $n(hook);
      $m_Lsnabbdom_modules_EventListeners$().snabbdom$modules$EventListeners$$$updateEventListeners__Lsnabbdom_VNode__s_Option__V(vnode, $m_s_None$());
    }
    var this$4 = $n($n(cbs$5).Lsnabbdom_ModuleHooks__f_destroy);
    var these = this$4;
    while ((!$n(these).isEmpty__Z())) {
      var arg1$2 = $n(these).head__O();
      var hook$1 = $as_Lsnabbdom_DestroyHook(arg1$2);
      $n(hook$1);
      $m_Lsnabbdom_modules_EventListeners$().snabbdom$modules$EventListeners$$$updateEventListeners__Lsnabbdom_VNode__s_Option__V(vnode, $m_s_None$());
      these = $as_sci_List($n(these).tail__O());
    }
    var this$6 = $n($n(vnode).Lsnabbdom_VNode__f_children);
    if ((!this$6.isEmpty__Z())) {
      var arg1$3 = this$6.get__O();
      var _$13 = $asArrayOf_Lsnabbdom_VNode(arg1$3, 1);
      var f = ((child) => {
        var child$1 = $as_Lsnabbdom_VNode(child);
        $p_Lsnabbdom_init$__invokeDestroyHook$1__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__V($thiz, cbs$5, child$1);
      });
      var len = $n(_$13).u.length;
      var i = 0;
      if ((_$13 !== null)) {
        while ((i < len)) {
          var arg1$4 = $n(_$13).get(i);
          f(arg1$4);
          i = ((1 + i) | 0);
        }
      } else if ((_$13 instanceof $ac_I)) {
        var x3 = $asArrayOf_I(_$13, 1);
        while ((i < len)) {
          var arg1$5 = $n(x3).get(i);
          f(arg1$5);
          i = ((1 + i) | 0);
        }
      } else if ((_$13 instanceof $ac_D)) {
        var x4 = $asArrayOf_D(_$13, 1);
        while ((i < len)) {
          var arg1$6 = $n(x4).get(i);
          f(arg1$6);
          i = ((1 + i) | 0);
        }
      } else if ((_$13 instanceof $ac_J)) {
        var x5 = $asArrayOf_J(_$13, 1);
        while ((i < len)) {
          var t = $n(x5).get(i);
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          f(new $c_RTLong(lo, hi));
          i = ((1 + i) | 0);
        }
      } else if ((_$13 instanceof $ac_F)) {
        var x6 = $asArrayOf_F(_$13, 1);
        while ((i < len)) {
          var arg1$7 = $n(x6).get(i);
          f(arg1$7);
          i = ((1 + i) | 0);
        }
      } else if ((_$13 instanceof $ac_C)) {
        var x7 = $asArrayOf_C(_$13, 1);
        while ((i < len)) {
          var arg1$8 = $n(x7).get(i);
          f($bC(arg1$8));
          i = ((1 + i) | 0);
        }
      } else if ((_$13 instanceof $ac_B)) {
        var x8 = $asArrayOf_B(_$13, 1);
        while ((i < len)) {
          var arg1$9 = $n(x8).get(i);
          f(arg1$9);
          i = ((1 + i) | 0);
        }
      } else if ((_$13 instanceof $ac_S)) {
        var x9 = $asArrayOf_S(_$13, 1);
        while ((i < len)) {
          var arg1$10 = $n(x9).get(i);
          f(arg1$10);
          i = ((1 + i) | 0);
        }
      } else if ((_$13 instanceof $ac_Z)) {
        var x10 = $asArrayOf_Z(_$13, 1);
        while ((i < len)) {
          var arg1$11 = $n(x10).get(i);
          f(arg1$11);
          i = ((1 + i) | 0);
        }
      } else {
        throw new $c_s_MatchError(_$13);
      }
    }
  }
}
function $p_Lsnabbdom_init$__removeVnodes$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__ALsnabbdom_VNode__I__I__V($thiz, api$9, cbs$6, parentElm, vnodes, startIdx, endIdx) {
  var i = startIdx;
  while ((i <= endIdx)) {
    var ch = $n(vnodes).get(i);
    matchResult6: {
      var x18 = $n(ch).Lsnabbdom_VNode__f_sel;
      if ((x18 instanceof $c_s_Some)) {
        $p_Lsnabbdom_init$__invokeDestroyHook$1__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__V($thiz, cbs$6, ch);
        var listeners = ((1 + $n($n(cbs$6).Lsnabbdom_ModuleHooks__f_remove).length__I()) | 0);
        var rm = $p_Lsnabbdom_init$__createRmCb$1__Lsnabbdom_DomApi__Lorg_scalajs_dom_Node__I__F0($thiz, api$9, $n($n(ch).Lsnabbdom_VNode__f_elm).get__O(), listeners);
        var this$1 = $n($n(cbs$6).Lsnabbdom_ModuleHooks__f_remove);
        var these = this$1;
        while ((!$n(these).isEmpty__Z())) {
          var arg1 = $n(these).head__O();
          var hook = $as_Lsnabbdom_RemoveHook(arg1);
          $n(hook).apply__Lsnabbdom_VNode__F0__O(ch, rm);
          these = $as_sci_List($n(these).tail__O());
        }
        var this$2 = $n($n($n(ch).Lsnabbdom_VNode__f_data).Lsnabbdom_VNodeData__f_hook);
        if (this$2.isEmpty__Z()) {
          var $x_1 = $m_s_None$();
        } else {
          var arg1$1 = this$2.get__O();
          var _$14 = $as_Lsnabbdom_Hooks(arg1$1);
          var $x_1 = $n(_$14).remove__s_Option();
        }
        var this$3 = $n($x_1);
        if (this$3.isEmpty__Z()) {
          $n(rm).apply__O();
        } else {
          var arg1$2 = this$3.get__O();
          var hook$1 = $as_Lsnabbdom_RemoveHook(arg1$2);
          $n(hook$1).apply__Lsnabbdom_VNode__F0__O(ch, rm);
        }
        break matchResult6;
      }
      var x = $m_s_None$();
      if ((x === x18)) {
        $n(api$9).removeChild__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__V(parentElm, $n($n(ch).Lsnabbdom_VNode__f_elm).get__O());
        break matchResult6;
      }
      throw new $c_s_MatchError(x18);
    }
    i = ((1 + i) | 0);
  }
}
function $p_Lsnabbdom_init$__updateChildren$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__ALsnabbdom_VNode__ALsnabbdom_VNode__scm_ArrayBuffer__V($thiz, api$10, cbs$7, parentElm, oldCh, newCh, insertedVnodeQueue) {
  if (($n(oldCh).u.length === 0)) {
    $m_sr_Scala3RunTime$().assertFailed__E();
  }
  if (($n(newCh).u.length === 0)) {
    $m_sr_Scala3RunTime$().assertFailed__E();
  }
  var oldStartIdx = 0;
  var newStartIdx = 0;
  var oldEndIdx = (((-1) + $n(oldCh).u.length) | 0);
  var oldStartVnode = $n(oldCh).get(0);
  var oldEndVnode = $n(oldCh).get(oldEndIdx);
  var newEndIdx = (((-1) + $n(newCh).u.length) | 0);
  var newStartVnode = $n(newCh).get(0);
  var newEndVnode = $n(newCh).get(newEndIdx);
  var elem = null;
  elem = null;
  while (((oldStartIdx <= oldEndIdx) && (newStartIdx <= newEndIdx))) {
    if ((oldStartVnode === null)) {
      oldStartIdx = ((1 + oldStartIdx) | 0);
      if ((oldStartIdx <= oldEndIdx)) {
        oldStartVnode = $n(oldCh).get(oldStartIdx);
      }
    } else if ((oldEndVnode === null)) {
      oldEndIdx = (((-1) + oldEndIdx) | 0);
      if ((oldStartIdx <= oldEndIdx)) {
        oldEndVnode = $n(oldCh).get(oldEndIdx);
      }
    } else if ($p_Lsnabbdom_init$__sameVnode__Lsnabbdom_VNode__Lsnabbdom_VNode__Z($thiz, oldStartVnode, newStartVnode)) {
      $p_Lsnabbdom_init$__patchVnode$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__Lsnabbdom_VNode__scm_ArrayBuffer__V($thiz, api$10, cbs$7, oldStartVnode, newStartVnode, insertedVnodeQueue);
      oldStartIdx = ((1 + oldStartIdx) | 0);
      if ((oldStartIdx <= oldEndIdx)) {
        oldStartVnode = $n(oldCh).get(oldStartIdx);
      }
      newStartIdx = ((1 + newStartIdx) | 0);
      if ((newStartIdx <= newEndIdx)) {
        newStartVnode = $n(newCh).get(newStartIdx);
      }
    } else if ($p_Lsnabbdom_init$__sameVnode__Lsnabbdom_VNode__Lsnabbdom_VNode__Z($thiz, oldEndVnode, newEndVnode)) {
      $p_Lsnabbdom_init$__patchVnode$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__Lsnabbdom_VNode__scm_ArrayBuffer__V($thiz, api$10, cbs$7, oldEndVnode, newEndVnode, insertedVnodeQueue);
      oldEndIdx = (((-1) + oldEndIdx) | 0);
      if ((oldStartIdx <= oldEndIdx)) {
        oldEndVnode = $n(oldCh).get(oldEndIdx);
      }
      newEndIdx = (((-1) + newEndIdx) | 0);
      if ((newStartIdx <= newEndIdx)) {
        newEndVnode = $n(newCh).get(newEndIdx);
      }
    } else if ($p_Lsnabbdom_init$__sameVnode__Lsnabbdom_VNode__Lsnabbdom_VNode__Z($thiz, oldStartVnode, newEndVnode)) {
      $p_Lsnabbdom_init$__patchVnode$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__Lsnabbdom_VNode__scm_ArrayBuffer__V($thiz, api$10, cbs$7, oldStartVnode, newEndVnode, insertedVnodeQueue);
      $n(api$10).insertBefore__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__s_Option__V(parentElm, $n($n(oldStartVnode).Lsnabbdom_VNode__f_elm).get__O(), $n(api$10).nextSibling__Lorg_scalajs_dom_Node__s_Option($n($n(oldEndVnode).Lsnabbdom_VNode__f_elm).get__O()));
      oldStartIdx = ((1 + oldStartIdx) | 0);
      if ((oldStartIdx <= oldEndIdx)) {
        oldStartVnode = $n(oldCh).get(oldStartIdx);
      }
      newEndIdx = (((-1) + newEndIdx) | 0);
      if ((newStartIdx <= newEndIdx)) {
        newEndVnode = $n(newCh).get(newEndIdx);
      }
    } else if ($p_Lsnabbdom_init$__sameVnode__Lsnabbdom_VNode__Lsnabbdom_VNode__Z($thiz, oldEndVnode, newStartVnode)) {
      $p_Lsnabbdom_init$__patchVnode$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__Lsnabbdom_VNode__scm_ArrayBuffer__V($thiz, api$10, cbs$7, oldEndVnode, newStartVnode, insertedVnodeQueue);
      $n(api$10).insertBefore__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__s_Option__V(parentElm, $n($n(oldEndVnode).Lsnabbdom_VNode__f_elm).get__O(), $n(oldStartVnode).Lsnabbdom_VNode__f_elm);
      oldEndIdx = (((-1) + oldEndIdx) | 0);
      if ((oldStartIdx <= oldEndIdx)) {
        oldEndVnode = $n(oldCh).get(oldEndIdx);
      }
      newStartIdx = ((1 + newStartIdx) | 0);
      if ((newStartIdx <= newEndIdx)) {
        newStartVnode = $n(newCh).get(newStartIdx);
      }
    } else {
      if (($as_sci_Map(elem) === null)) {
        var ev$12 = $p_Lsnabbdom_init$__createKeyToOldIdx__ALsnabbdom_VNode__I__I__sci_Map($thiz, oldCh, oldStartIdx, oldEndIdx);
        elem = ev$12;
        ev$12 = null;
      }
      var this$6 = $n($n(newStartVnode).Lsnabbdom_VNode__f_key);
      if (this$6.isEmpty__Z()) {
        var idxInOld = $m_s_None$();
      } else {
        var arg1 = this$6.get__O();
        var key = $as_T(arg1);
        var idxInOld = $n($as_sci_Map(elem)).get__O__s_Option(key);
      }
      matchResult7: {
        var x = $m_s_None$();
        if ((x === idxInOld)) {
          $n(api$10).insertBefore__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__s_Option__V(parentElm, $p_Lsnabbdom_init$__createElm$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__scm_ArrayBuffer__Lorg_scalajs_dom_Node($thiz, api$10, cbs$7, newStartVnode, insertedVnodeQueue), $n(oldStartVnode).Lsnabbdom_VNode__f_elm);
          break matchResult7;
        }
        if ((idxInOld instanceof $c_s_Some)) {
          var idxInOld$2 = $uI($n($as_s_Some(idxInOld)).s_Some__f_value);
          var elmToMove = $n(oldCh).get(idxInOld$2);
          var x$3 = $n(elmToMove).Lsnabbdom_VNode__f_sel;
          var x$4 = $n(newStartVnode).Lsnabbdom_VNode__f_sel;
          if ((!((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4)))) {
            $n(api$10).insertBefore__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__s_Option__V(parentElm, $p_Lsnabbdom_init$__createElm$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__scm_ArrayBuffer__Lorg_scalajs_dom_Node($thiz, api$10, cbs$7, newStartVnode, insertedVnodeQueue), $n(oldStartVnode).Lsnabbdom_VNode__f_elm);
          } else {
            $p_Lsnabbdom_init$__patchVnode$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__Lsnabbdom_VNode__scm_ArrayBuffer__V($thiz, api$10, cbs$7, elmToMove, newStartVnode, insertedVnodeQueue);
            $n(oldCh).set(idxInOld$2, null);
            $n(api$10).insertBefore__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__s_Option__V(parentElm, $n($n(elmToMove).Lsnabbdom_VNode__f_elm).get__O(), $n(oldStartVnode).Lsnabbdom_VNode__f_elm);
          }
          break matchResult7;
        }
        throw new $c_s_MatchError(idxInOld);
      }
      newStartIdx = ((1 + newStartIdx) | 0);
      if ((newStartIdx <= newEndIdx)) {
        newStartVnode = $n(newCh).get(newStartIdx);
      }
    }
  }
  if ((newStartIdx <= newEndIdx)) {
    var before = (($n(newCh).u.length > ((1 + newEndIdx) | 0)) ? $n($n(newCh).get(((1 + newEndIdx) | 0))).Lsnabbdom_VNode__f_elm : $m_s_None$());
    $p_Lsnabbdom_init$__addVnodes$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__s_Option__ALsnabbdom_VNode__I__I__scm_ArrayBuffer__V($thiz, api$10, cbs$7, parentElm, before, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
  }
  if ((oldStartIdx <= oldEndIdx)) {
    $p_Lsnabbdom_init$__removeVnodes$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__ALsnabbdom_VNode__I__I__V($thiz, api$10, cbs$7, parentElm, oldCh, oldStartIdx, oldEndIdx);
  }
}
function $p_Lsnabbdom_init$__patchVnode$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__Lsnabbdom_VNode__scm_ArrayBuffer__V($thiz, api$11, cbs$8, oldVnode, vnode, insertedVNodeQueue) {
  var hook = $n($n(vnode).Lsnabbdom_VNode__f_data).Lsnabbdom_VNodeData__f_hook;
  var this$1 = $n(hook);
  if (this$1.isEmpty__Z()) {
    var $x_1 = $m_s_None$();
  } else {
    var arg1 = this$1.get__O();
    var _$15 = $as_Lsnabbdom_Hooks(arg1);
    var $x_1 = $n(_$15).prepatch__s_Option();
  }
  var this$2 = $n($x_1);
  if ((!this$2.isEmpty__Z())) {
    var arg1$1 = this$2.get__O();
    var hook$1 = $as_Lsnabbdom_PrePatchHook(arg1$1);
    $n(hook$1).apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O(oldVnode, vnode);
  }
  var elm = $n($n(oldVnode).Lsnabbdom_VNode__f_elm).get__O();
  $n(vnode).Lsnabbdom_VNode__f_elm = new $c_s_Some(elm);
  var oldCh = $n(oldVnode).Lsnabbdom_VNode__f_children;
  var ch = $n(vnode).Lsnabbdom_VNode__f_children;
  if ((oldVnode === null)) {
    var $x_2 = (vnode === null);
  } else {
    var this$4 = $n(oldVnode);
    var $x_2 = (this$4 === vnode);
  }
  if ((!$x_2)) {
    var this$5 = $n($n(cbs$8).Lsnabbdom_ModuleHooks__f_update);
    var these = this$5;
    while ((!$n(these).isEmpty__Z())) {
      var arg1$2 = $n(these).head__O();
      var hook$2 = $as_Lsnabbdom_UpdateHook(arg1$2);
      $n(hook$2).apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O(oldVnode, vnode);
      these = $as_sci_List($n(these).tail__O());
    }
    var this$6 = $n($n($n(vnode).Lsnabbdom_VNode__f_data).Lsnabbdom_VNodeData__f_hook);
    if (this$6.isEmpty__Z()) {
      var $x_3 = $m_s_None$();
    } else {
      var arg1$3 = this$6.get__O();
      var _$16 = $as_Lsnabbdom_Hooks(arg1$3);
      var $x_3 = $n(_$16).update__s_Option();
    }
    var this$7 = $n($x_3);
    if ((!this$7.isEmpty__Z())) {
      var arg1$4 = this$7.get__O();
      var hook$3 = $as_Lsnabbdom_UpdateHook(arg1$4);
      $n(hook$3).apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O(oldVnode, vnode);
    }
    matchResult9: {
      var x41 = $n(vnode).Lsnabbdom_VNode__f_text;
      var x$3 = $m_s_None$();
      if ((x$3 === x41)) {
        matchResult8: {
          var x24 = new $c_T2(oldCh, ch);
          var x35 = $as_s_Option(x24.T2__f__1);
          var x36 = $as_s_Option(x24.T2__f__2);
          if ((x35 instanceof $c_s_Some)) {
            var oldCh$2 = $asArrayOf_Lsnabbdom_VNode($n($as_s_Some(x35)).s_Some__f_value, 1);
            if ((x36 instanceof $c_s_Some)) {
              var ch$2 = $asArrayOf_Lsnabbdom_VNode($n($as_s_Some(x36)).s_Some__f_value, 1);
              if ((oldCh$2 === null)) {
                var $x_4 = (ch$2 === null);
              } else {
                var this$9 = $n(oldCh$2);
                var $x_4 = (this$9 === ch$2);
              }
              if ((!$x_4)) {
                $p_Lsnabbdom_init$__updateChildren$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__ALsnabbdom_VNode__ALsnabbdom_VNode__scm_ArrayBuffer__V($thiz, api$11, cbs$8, elm, oldCh$2, ch$2, insertedVNodeQueue);
              }
              break matchResult8;
            }
          }
          var x$7 = $m_s_None$();
          if (((x$7 === x35) && (x36 instanceof $c_s_Some))) {
            var ch$3 = $asArrayOf_Lsnabbdom_VNode($n($as_s_Some(x36)).s_Some__f_value, 1);
            var this$10 = $n($n(oldVnode).Lsnabbdom_VNode__f_text);
            if ((!this$10.isEmpty__Z())) {
              var arg1$5 = this$10.get__O();
              $as_T(arg1$5);
              $n(api$11).setTextContent__Lorg_scalajs_dom_Node__s_Option__V(elm, new $c_s_Some(""));
            }
            $p_Lsnabbdom_init$__addVnodes$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__s_Option__ALsnabbdom_VNode__I__I__scm_ArrayBuffer__V($thiz, api$11, cbs$8, elm, $m_s_None$(), ch$3, 0, (((-1) + $n(ch$3).u.length) | 0), insertedVNodeQueue);
            break matchResult8;
          }
          if ((x35 instanceof $c_s_Some)) {
            var oldCh$3 = $asArrayOf_Lsnabbdom_VNode($n($as_s_Some(x35)).s_Some__f_value, 1);
            var x$9 = $m_s_None$();
            if ((x$9 === x36)) {
              $p_Lsnabbdom_init$__removeVnodes$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__ALsnabbdom_VNode__I__I__V($thiz, api$11, cbs$8, elm, oldCh$3, 0, (((-1) + $n(oldCh$3).u.length) | 0));
              break matchResult8;
            }
          }
          var x$11 = $m_s_None$();
          if ((x$11 === x35)) {
            var x$13 = $m_s_None$();
            var $x_5 = (x$13 === x36);
          } else {
            var $x_5 = false;
          }
          if ($x_5) {
            var this$12 = $n($n(oldVnode).Lsnabbdom_VNode__f_text);
            if ((!this$12.isEmpty__Z())) {
              var arg1$6 = this$12.get__O();
              $as_T(arg1$6);
              $n(api$11).setTextContent__Lorg_scalajs_dom_Node__s_Option__V(elm, new $c_s_Some(""));
            }
            break matchResult8;
          }
          throw new $c_s_MatchError(x24);
        }
        break matchResult9;
      }
      if ((x41 instanceof $c_s_Some)) {
        var text = $as_T($n($as_s_Some(x41)).s_Some__f_value);
        var this$14 = $n($n(oldVnode).Lsnabbdom_VNode__f_text);
        if (this$14.isEmpty__Z()) {
          var $x_6 = true;
        } else {
          var arg1$7 = this$14.get__O();
          var _$19 = $as_T(arg1$7);
          var $x_6 = (_$19 !== text);
        }
        if ($x_6) {
          var this$15 = $n(oldCh);
          if ((!this$15.isEmpty__Z())) {
            var arg1$8 = this$15.get__O();
            var oldChildren = $asArrayOf_Lsnabbdom_VNode(arg1$8, 1);
            $p_Lsnabbdom_init$__removeVnodes$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__ALsnabbdom_VNode__I__I__V($thiz, api$11, cbs$8, elm, oldChildren, 0, (((-1) + $n(oldChildren).u.length) | 0));
          }
          $n(api$11).setTextContent__Lorg_scalajs_dom_Node__s_Option__V(elm, new $c_s_Some(text));
          break matchResult9;
        }
        break matchResult9;
      }
      throw new $c_s_MatchError(x41);
    }
    var this$17 = $n(hook);
    if (this$17.isEmpty__Z()) {
      var $x_7 = $m_s_None$();
    } else {
      var arg1$9 = this$17.get__O();
      var _$20 = $as_Lsnabbdom_Hooks(arg1$9);
      var $x_7 = $n(_$20).postpatch__s_Option();
    }
    var this$18 = $n($x_7);
    if ((!this$18.isEmpty__Z())) {
      var arg1$10 = this$18.get__O();
      var hook$4 = $as_Lsnabbdom_PostPatchHook(arg1$10);
      $n(hook$4).apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O(oldVnode, vnode);
    }
  }
}
/** @constructor */
function $c_Lsnabbdom_init$() {
  this.Lsnabbdom_init$__f_emptyNode = null;
  $n_Lsnabbdom_init$ = this;
  this.Lsnabbdom_init$__f_emptyNode = $m_Lsnabbdom_VNode$().create__s_Option__Lsnabbdom_VNodeData__s_Option__s_Option__s_Option__Lsnabbdom_VNode(new $c_s_Some(""), $m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty, $m_s_None$(), $m_s_None$(), $m_s_None$());
}
$c_Lsnabbdom_init$.prototype = new $h_O();
$c_Lsnabbdom_init$.prototype.constructor = $c_Lsnabbdom_init$;
/** @constructor */
function $h_Lsnabbdom_init$() {
}
$h_Lsnabbdom_init$.prototype = $c_Lsnabbdom_init$.prototype;
$c_Lsnabbdom_init$.prototype.apply__sci_Seq__s_Option__Lsnabbdom_Patch = (function(modules, domApi) {
  var this$1 = $n(domApi);
  var api = $as_Lsnabbdom_DomApi((this$1.isEmpty__Z() ? new $c_Lsnabbdom_DomApi$$anon$1() : this$1.get__O()));
  var create = $m_sci_Nil$();
  var update = $m_sci_Nil$();
  var remove = $m_sci_Nil$();
  var destroy = $m_sci_Nil$();
  var pre = $m_sci_Nil$();
  var post = $m_sci_Nil$();
  var cbs = $as_Lsnabbdom_ModuleHooks($n(modules).foldLeft__O__F2__O(new $c_Lsnabbdom_ModuleHooks(create, update, remove, destroy, pre, post), new $c_sjsr_AnonFunction2(((x$1, x$2) => {
    var x$1$1 = $as_Lsnabbdom_ModuleHooks(x$1);
    var x$2$1 = $as_Lsnabbdom_Module(x$2);
    $n(x$1$1);
    var this$6 = $n($n(x$2$1).Lsnabbdom_Module__f_create);
    if (this$6.isEmpty__Z()) {
      var $x_1 = $n(x$1$1).Lsnabbdom_ModuleHooks__f_create;
    } else {
      var arg1 = this$6.get__O();
      var _$1 = $as_Lsnabbdom_CreateHook(arg1);
      var this$7 = $n($n(x$1$1).Lsnabbdom_ModuleHooks__f_create);
      var $x_1 = new $c_sci_$colon$colon(_$1, this$7);
    }
    var create$1 = $as_sci_List($x_1);
    var this$8 = $n($n(x$2$1).Lsnabbdom_Module__f_update);
    if (this$8.isEmpty__Z()) {
      var $x_2 = $n(x$1$1).Lsnabbdom_ModuleHooks__f_update;
    } else {
      var arg1$1 = this$8.get__O();
      var _$2 = $as_Lsnabbdom_UpdateHook(arg1$1);
      var this$9 = $n($n(x$1$1).Lsnabbdom_ModuleHooks__f_update);
      var $x_2 = new $c_sci_$colon$colon(_$2, this$9);
    }
    var update$1 = $as_sci_List($x_2);
    var this$10 = $n($n(x$2$1).Lsnabbdom_Module__f_remove);
    if (this$10.isEmpty__Z()) {
      var $x_3 = $n(x$1$1).Lsnabbdom_ModuleHooks__f_remove;
    } else {
      var arg1$2 = this$10.get__O();
      var _$3 = $as_Lsnabbdom_RemoveHook(arg1$2);
      var this$11 = $n($n(x$1$1).Lsnabbdom_ModuleHooks__f_remove);
      var $x_3 = new $c_sci_$colon$colon(_$3, this$11);
    }
    var remove$1 = $as_sci_List($x_3);
    var this$12 = $n($n(x$2$1).Lsnabbdom_Module__f_destroy);
    if (this$12.isEmpty__Z()) {
      var $x_4 = $n(x$1$1).Lsnabbdom_ModuleHooks__f_destroy;
    } else {
      var arg1$3 = this$12.get__O();
      var _$4 = $as_Lsnabbdom_DestroyHook(arg1$3);
      var this$13 = $n($n(x$1$1).Lsnabbdom_ModuleHooks__f_destroy);
      var $x_4 = new $c_sci_$colon$colon(_$4, this$13);
    }
    var destroy$1 = $as_sci_List($x_4);
    var this$14 = $n($n(x$2$1).Lsnabbdom_Module__f_pre);
    if (this$14.isEmpty__Z()) {
      var $x_5 = $n(x$1$1).Lsnabbdom_ModuleHooks__f_pre;
    } else {
      var arg1$4 = this$14.get__O();
      var _$5 = $as_Lsnabbdom_PreHook(arg1$4);
      var this$15 = $n($n(x$1$1).Lsnabbdom_ModuleHooks__f_pre);
      var $x_5 = new $c_sci_$colon$colon(_$5, this$15);
    }
    var pre$1 = $as_sci_List($x_5);
    var this$16 = $n($n(x$2$1).Lsnabbdom_Module__f_post);
    if (this$16.isEmpty__Z()) {
      var $x_6 = $n(x$1$1).Lsnabbdom_ModuleHooks__f_post;
    } else {
      var arg1$5 = this$16.get__O();
      var _$6 = $as_Lsnabbdom_PostHook(arg1$5);
      var this$17 = $n($n(x$1$1).Lsnabbdom_ModuleHooks__f_post);
      var $x_6 = new $c_sci_$colon$colon(_$6, this$17);
    }
    var post$1 = $as_sci_List($x_6);
    return new $c_Lsnabbdom_ModuleHooks(create$1, update$1, remove$1, destroy$1, pre$1, post$1);
  }))));
  return new $c_Lsnabbdom_init$$anon$1(api, cbs);
});
$c_Lsnabbdom_init$.prototype.snabbdom$init$$$_$emptyNodeAt$1__Lsnabbdom_DomApi__Lorg_scalajs_dom_Element__Lsnabbdom_VNode = (function(api$1, elm) {
  var this$1 = $n($m_s_Option$().apply__O__s_Option($as_T(elm.id)));
  if (this$1.isEmpty__Z()) {
    var $x_1 = true;
  } else {
    var arg1 = this$1.get__O();
    var _$7 = $as_T(arg1);
    var this$4 = $n(_$7);
    var $x_1 = (!(this$4 === ""));
  }
  var this$5 = $n(($x_1 ? this$1 : $m_s_None$()));
  if (this$5.isEmpty__Z()) {
    var id = "";
  } else {
    var arg1$1 = this$5.get__O();
    var _$8 = $as_T(arg1$1);
    var id = ("#" + _$8);
  }
  var classes = $m_s_Option$().apply__O__s_Option($as_T(elm.getAttribute("class")));
  var this$6 = $n(classes);
  if (this$6.isEmpty__Z()) {
    var $x_2 = $m_s_None$();
  } else {
    var arg1$2 = this$6.get__O();
    var _$9 = $as_T(arg1$2);
    var $x_3 = $m_s_Predef$();
    var this$7 = $n(_$9);
    var this$8 = $n($n($x_3).wrapRefArray__AO__scm_ArraySeq$ofRef($f_T__split__T__I__AT(this$7, " ", 0)));
    var $x_2 = new $c_s_Some(("." + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$8, "", ".", "")));
  }
  var this$9 = $n($x_2);
  var c = $as_T((this$9.isEmpty__Z() ? "" : this$9.get__O()));
  var $x_4 = $m_Lsnabbdom_VNode$();
  var this$10 = $n($n(api$1).tagName__Lorg_scalajs_dom_Element__T(elm));
  var value = (($as_T(this$10.toLowerCase()) + id) + c);
  return $n($x_4).create__s_Option__Lsnabbdom_VNodeData__s_Option__s_Option__s_Option__Lsnabbdom_VNode(new $c_s_Some(value), $m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty, $m_s_None$(), $m_s_None$(), new $c_s_Some(elm));
});
$c_Lsnabbdom_init$.prototype.snabbdom$init$$$_$patch$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__Lsnabbdom_VNode__Lsnabbdom_VNode = (function(api$15, cbs$10, oldVnode, vnode) {
  $m_scm_ArrayBuffer$();
  var insertedVNodeQueue = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  var this$2 = $n($n(cbs$10).Lsnabbdom_ModuleHooks__f_pre);
  var these = this$2;
  while ((!$n(these).isEmpty__Z())) {
    var arg1 = $n(these).head__O();
    var hook = $as_Lsnabbdom_PreHook(arg1);
    $n(hook).apply__O();
    these = $as_sci_List($n(these).tail__O());
  }
  if ($p_Lsnabbdom_init$__sameVnode__Lsnabbdom_VNode__Lsnabbdom_VNode__Z(this, oldVnode, vnode)) {
    $p_Lsnabbdom_init$__patchVnode$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__Lsnabbdom_VNode__scm_ArrayBuffer__V(this, api$15, cbs$10, oldVnode, vnode, insertedVNodeQueue);
  } else {
    var elm = $n($n(oldVnode).Lsnabbdom_VNode__f_elm).get__O();
    var parent = $n(api$15).parentNode__Lorg_scalajs_dom_Node__s_Option(elm);
    $p_Lsnabbdom_init$__createElm$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__scm_ArrayBuffer__Lorg_scalajs_dom_Node(this, api$15, cbs$10, vnode, insertedVNodeQueue);
    matchResult10: {
      if ((parent instanceof $c_s_Some)) {
        var parent$2 = $n($as_s_Some(parent)).s_Some__f_value;
        $n(api$15).insertBefore__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__s_Option__V(parent$2, $n($n(vnode).Lsnabbdom_VNode__f_elm).get__O(), $n(api$15).nextSibling__Lorg_scalajs_dom_Node__s_Option(elm));
        $p_Lsnabbdom_init$__removeVnodes$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__ALsnabbdom_VNode__I__I__V(this, api$15, cbs$10, parent$2, new ($d_Lsnabbdom_VNode.getArrayOf().constr)([oldVnode]), 0, 0);
        break matchResult10;
      }
      var x = $m_s_None$();
      if ((x === parent)) {
        break matchResult10;
      }
      throw new $c_s_MatchError(parent);
    }
  }
  var it = $n(insertedVNodeQueue.view__scm_ArrayBufferView()).iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var arg1$1 = $n(it).next__O();
    var vnode$1 = $as_Lsnabbdom_VNode(arg1$1);
    var this$3 = $n($n($n(vnode$1).Lsnabbdom_VNode__f_data).Lsnabbdom_VNodeData__f_hook);
    if (this$3.isEmpty__Z()) {
      var $x_1 = $m_s_None$();
    } else {
      var arg1$2 = this$3.get__O();
      var _$21 = $as_Lsnabbdom_Hooks(arg1$2);
      var $x_1 = $n(_$21).insert__s_Option();
    }
    var this$4 = $n($x_1);
    if ((!this$4.isEmpty__Z())) {
      var arg1$3 = this$4.get__O();
      var hook$1 = $as_Lsnabbdom_InsertHook(arg1$3);
      $n(hook$1).apply__Lsnabbdom_VNode__O(vnode$1);
    }
  }
  var this$5 = $n($n(cbs$10).Lsnabbdom_ModuleHooks__f_post);
  var these$1 = this$5;
  while ((!$n(these$1).isEmpty__Z())) {
    var arg1$4 = $n(these$1).head__O();
    var hook$2 = $as_Lsnabbdom_PostHook(arg1$4);
    $n(hook$2).apply__O();
    these$1 = $as_sci_List($n(these$1).tail__O());
  }
  return vnode;
});
var $d_Lsnabbdom_init$ = new $TypeData().initClass($c_Lsnabbdom_init$, "snabbdom.init$", ({
  Lsnabbdom_init$: 1
}));
var $n_Lsnabbdom_init$;
function $m_Lsnabbdom_init$() {
  if ((!$n_Lsnabbdom_init$)) {
    $n_Lsnabbdom_init$ = new $c_Lsnabbdom_init$();
  }
  return $n_Lsnabbdom_init$;
}
function $p_Lsnabbdom_modules_Attributes$__update$2__Lorg_scalajs_dom_Element__sci_Map__sci_Map__V($thiz, elm$2, oldAttrs, attrs) {
  $n(attrs).foreach__F1__V(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    matchResult1: {
      if ((x$1$1 !== null)) {
        var key = $as_T($n(x$1$1)._1__O());
        var cur = $n(x$1$1)._2__O();
        var old = $n(oldAttrs).get__O__s_Option(key);
        var this$2 = $n(old);
        if (this$2.isEmpty__Z()) {
          var $x_1 = true;
        } else {
          var arg1 = this$2.get__O();
          var $x_1 = (!$m_sr_BoxesRunTime$().equals__O__O__Z(arg1, cur));
        }
        if ($x_1) {
          if ($m_sr_BoxesRunTime$().equals__O__O__Z(cur, true)) {
            elm$2.setAttribute(key, "");
          } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(cur, false)) {
            elm$2.removeAttribute(key);
          } else {
            var this$3 = $n(key);
            if (($charAt(this$3, 0) !== 120)) {
              elm$2.setAttribute(key, $dp_toString__T($n(cur)));
            } else {
              var this$4 = $n(key);
              if ((this$4.length > 3)) {
                var this$5 = $n(key);
                var $x_2 = ($charAt(this$5, 3) === 58);
              } else {
                var $x_2 = false;
              }
              if ($x_2) {
                elm$2.setAttributeNS($thiz.Lsnabbdom_modules_Attributes$__f_xmlNS, key, $dp_toString__T($n(cur)));
              } else {
                var this$6 = $n(key);
                if ((this$6.length > 5)) {
                  var this$7 = $n(key);
                  var $x_3 = ($charAt(this$7, 5) === 58);
                } else {
                  var $x_3 = false;
                }
                if ($x_3) {
                  elm$2.setAttributeNS($thiz.Lsnabbdom_modules_Attributes$__f_xlinkNS, key, $dp_toString__T($n(cur)));
                } else {
                  elm$2.setAttribute(key, $dp_toString__T($n(cur)));
                }
              }
            }
          }
        }
        break matchResult1;
      }
      throw new $c_s_MatchError(x$1$1);
    }
  })));
  $n(oldAttrs).foreach__F1__V(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1$3 = $as_T2(x$1$2);
    matchResult2: {
      if ((x$1$3 !== null)) {
        var key$1 = $as_T($n(x$1$3)._1__O());
        if ((!$n(attrs).contains__O__Z(key$1))) {
          elm$2.removeAttribute(key$1);
        }
        break matchResult2;
      }
      throw new $c_s_MatchError(x$1$3);
    }
  })));
}
/** @constructor */
function $c_Lsnabbdom_modules_Attributes$() {
  this.Lsnabbdom_modules_Attributes$__f_module = null;
  this.Lsnabbdom_modules_Attributes$__f_xlinkNS = null;
  this.Lsnabbdom_modules_Attributes$__f_xmlNS = null;
  $n_Lsnabbdom_modules_Attributes$ = this;
  var pre = $m_s_None$();
  var create = $m_s_None$();
  var update = $m_s_None$();
  var destroy = $m_s_None$();
  var remove = $m_s_None$();
  var post = $m_s_None$();
  var \u03b41$ = new $c_Lsnabbdom_Module(pre, create, update, destroy, remove, post);
  var value = new $c_Lsnabbdom_modules_Attributes$$anon$1();
  var create$1 = new $c_s_Some(value);
  var value$1 = new $c_Lsnabbdom_modules_Attributes$$anon$2();
  var update$1 = new $c_s_Some(value$1);
  var pre$1 = \u03b41$.Lsnabbdom_Module__f_pre;
  var destroy$1 = \u03b41$.Lsnabbdom_Module__f_destroy;
  var remove$1 = \u03b41$.Lsnabbdom_Module__f_remove;
  var post$1 = \u03b41$.Lsnabbdom_Module__f_post;
  this.Lsnabbdom_modules_Attributes$__f_module = new $c_Lsnabbdom_Module(pre$1, create$1, update$1, destroy$1, remove$1, post$1);
  this.Lsnabbdom_modules_Attributes$__f_xlinkNS = "http://www.w3.org/1999/xlink";
  this.Lsnabbdom_modules_Attributes$__f_xmlNS = "http://www.w3.org/XML/1998/namespace";
}
$c_Lsnabbdom_modules_Attributes$.prototype = new $h_O();
$c_Lsnabbdom_modules_Attributes$.prototype.constructor = $c_Lsnabbdom_modules_Attributes$;
/** @constructor */
function $h_Lsnabbdom_modules_Attributes$() {
}
$h_Lsnabbdom_modules_Attributes$.prototype = $c_Lsnabbdom_modules_Attributes$.prototype;
$c_Lsnabbdom_modules_Attributes$.prototype.snabbdom$modules$Attributes$$$updateAttrs__Lsnabbdom_VNode__Lsnabbdom_VNode__V = (function(oldVnode, vnode) {
  var elm = $n($n(vnode).Lsnabbdom_VNode__f_elm).get__O();
  var oldAttrs = $n($n(oldVnode).Lsnabbdom_VNode__f_data).Lsnabbdom_VNodeData__f_attrs;
  var attrs = $n($n(vnode).Lsnabbdom_VNode__f_data).Lsnabbdom_VNodeData__f_attrs;
  if ((!((oldAttrs === null) ? (attrs === null) : $n(oldAttrs).equals__O__Z(attrs)))) {
    $p_Lsnabbdom_modules_Attributes$__update$2__Lorg_scalajs_dom_Element__sci_Map__sci_Map__V(this, elm, oldAttrs, attrs);
  }
});
var $d_Lsnabbdom_modules_Attributes$ = new $TypeData().initClass($c_Lsnabbdom_modules_Attributes$, "snabbdom.modules.Attributes$", ({
  Lsnabbdom_modules_Attributes$: 1
}));
var $n_Lsnabbdom_modules_Attributes$;
function $m_Lsnabbdom_modules_Attributes$() {
  if ((!$n_Lsnabbdom_modules_Attributes$)) {
    $n_Lsnabbdom_modules_Attributes$ = new $c_Lsnabbdom_modules_Attributes$();
  }
  return $n_Lsnabbdom_modules_Attributes$;
}
function $p_Lsnabbdom_modules_Classes$__update$2__Lorg_scalajs_dom_Element__sci_Map__sci_Map__V($thiz, elm$2, oldClass, klass) {
  $n(oldClass).foreach__F1__V(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    matchResult1: {
      if ((x$1$1 !== null)) {
        var name = $as_T($n(x$1$1)._1__O());
        var flag = $uZ($n(x$1$1)._2__O());
        if ((flag && (!$n(klass).contains__O__Z(name)))) {
          elm$2.classList.remove(name);
        }
        break matchResult1;
      }
      throw new $c_s_MatchError(x$1$1);
    }
  })));
  $n(klass).foreach__F1__V(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1$3 = $as_T2(x$1$2);
    matchResult2: {
      if ((x$1$3 !== null)) {
        var name$1 = $as_T($n(x$1$3)._1__O());
        var cur = $uZ($n(x$1$3)._2__O());
        var this$3 = $n($n(oldClass).get__O__s_Option(name$1));
        if (this$3.isEmpty__Z()) {
          var $x_1 = true;
        } else {
          var arg1 = this$3.get__O();
          var _$1 = $uZ(arg1);
          var $x_1 = (_$1 !== cur);
        }
        if ($x_1) {
          if (cur) {
            elm$2.classList.add(name$1);
          } else {
            elm$2.classList.remove(name$1);
          }
        }
        break matchResult2;
      }
      throw new $c_s_MatchError(x$1$3);
    }
  })));
}
/** @constructor */
function $c_Lsnabbdom_modules_Classes$() {
  this.Lsnabbdom_modules_Classes$__f_module = null;
  $n_Lsnabbdom_modules_Classes$ = this;
  var pre = $m_s_None$();
  var create = $m_s_None$();
  var update = $m_s_None$();
  var destroy = $m_s_None$();
  var remove = $m_s_None$();
  var post = $m_s_None$();
  var \u03b41$ = new $c_Lsnabbdom_Module(pre, create, update, destroy, remove, post);
  var value = new $c_Lsnabbdom_modules_Classes$$anon$1();
  var create$1 = new $c_s_Some(value);
  var value$1 = new $c_Lsnabbdom_modules_Classes$$anon$2();
  var update$1 = new $c_s_Some(value$1);
  var pre$1 = \u03b41$.Lsnabbdom_Module__f_pre;
  var destroy$1 = \u03b41$.Lsnabbdom_Module__f_destroy;
  var remove$1 = \u03b41$.Lsnabbdom_Module__f_remove;
  var post$1 = \u03b41$.Lsnabbdom_Module__f_post;
  this.Lsnabbdom_modules_Classes$__f_module = new $c_Lsnabbdom_Module(pre$1, create$1, update$1, destroy$1, remove$1, post$1);
}
$c_Lsnabbdom_modules_Classes$.prototype = new $h_O();
$c_Lsnabbdom_modules_Classes$.prototype.constructor = $c_Lsnabbdom_modules_Classes$;
/** @constructor */
function $h_Lsnabbdom_modules_Classes$() {
}
$h_Lsnabbdom_modules_Classes$.prototype = $c_Lsnabbdom_modules_Classes$.prototype;
$c_Lsnabbdom_modules_Classes$.prototype.snabbdom$modules$Classes$$$updateClasses__Lsnabbdom_VNode__Lsnabbdom_VNode__V = (function(oldVnode, vnode) {
  var elm = $n($n(vnode).Lsnabbdom_VNode__f_elm).get__O();
  var oldClasses = $n($n(oldVnode).Lsnabbdom_VNode__f_data).Lsnabbdom_VNodeData__f_classes;
  var classes = $n($n(vnode).Lsnabbdom_VNode__f_data).Lsnabbdom_VNodeData__f_classes;
  if ((!((oldClasses === null) ? (classes === null) : $n(oldClasses).equals__O__Z(classes)))) {
    $p_Lsnabbdom_modules_Classes$__update$2__Lorg_scalajs_dom_Element__sci_Map__sci_Map__V(this, elm, oldClasses, classes);
  }
});
var $d_Lsnabbdom_modules_Classes$ = new $TypeData().initClass($c_Lsnabbdom_modules_Classes$, "snabbdom.modules.Classes$", ({
  Lsnabbdom_modules_Classes$: 1
}));
var $n_Lsnabbdom_modules_Classes$;
function $m_Lsnabbdom_modules_Classes$() {
  if ((!$n_Lsnabbdom_modules_Classes$)) {
    $n_Lsnabbdom_modules_Classes$ = new $c_Lsnabbdom_modules_Classes$();
  }
  return $n_Lsnabbdom_modules_Classes$;
}
function $p_Lsnabbdom_modules_Dataset$__update$2__Lorg_scalajs_dom_HTMLElement__sjs_js_Dictionary__sci_Map__sci_Map__V($thiz, elm$2, d$2, oldDataset, dataset) {
  $n(oldDataset).foreach__F1__V(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var key = $as_T($n(x$1$1)._1__O());
      var x1 = $n(dataset).get__O__s_Option(key);
      var x = $m_s_None$();
      if ((x === x1)) {
        if ((d$2 !== (void 0))) {
          var this$4 = new $c_sjs_js_WrappedDictionary(d$2);
          return this$4.subtractOne__T__sjs_js_WrappedDictionary(key);
        } else {
          var this$5 = $n($f_T__replaceAll__T__T__T($n(key), $thiz.Lsnabbdom_modules_Dataset$__f_CAPS_REGEX, "-$&"));
          elm$2.removeAttribute(("data-" + $as_T(this$5.toLowerCase())));
          return (void 0);
        }
      }
      if ((x1 instanceof $c_s_Some)) {
        return (void 0);
      }
      throw new $c_s_MatchError(x1);
    }
    throw new $c_s_MatchError(x$1$1);
  })));
  $n(dataset).foreach__F1__V(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1$3 = $as_T2(x$1$2);
    matchResult3: {
      if ((x$1$3 !== null)) {
        var key$1 = $as_T($n(x$1$3)._1__O());
        var value = $as_T($n(x$1$3)._2__O());
        var this$6 = $n($n(oldDataset).get__O__s_Option(key$1));
        if (this$6.isEmpty__Z()) {
          var $x_1 = true;
        } else {
          var arg1 = this$6.get__O();
          var _$1 = $as_T(arg1);
          var $x_1 = (_$1 !== value);
        }
        if ($x_1) {
          if ((d$2 !== (void 0))) {
            d$2[key$1] = value;
          } else {
            var this$12 = $n($f_T__replaceAll__T__T__T($n(key$1), $thiz.Lsnabbdom_modules_Dataset$__f_CAPS_REGEX, "-$&"));
            elm$2.setAttribute(("data-" + $as_T(this$12.toLowerCase())), value);
          }
        }
        break matchResult3;
      }
      throw new $c_s_MatchError(x$1$3);
    }
  })));
}
/** @constructor */
function $c_Lsnabbdom_modules_Dataset$() {
  this.Lsnabbdom_modules_Dataset$__f_module = null;
  this.Lsnabbdom_modules_Dataset$__f_CAPS_REGEX = null;
  $n_Lsnabbdom_modules_Dataset$ = this;
  var pre = $m_s_None$();
  var create = $m_s_None$();
  var update = $m_s_None$();
  var destroy = $m_s_None$();
  var remove = $m_s_None$();
  var post = $m_s_None$();
  var \u03b41$ = new $c_Lsnabbdom_Module(pre, create, update, destroy, remove, post);
  var value = new $c_Lsnabbdom_modules_Dataset$$anon$1();
  var create$1 = new $c_s_Some(value);
  var value$1 = new $c_Lsnabbdom_modules_Dataset$$anon$2();
  var update$1 = new $c_s_Some(value$1);
  var pre$1 = \u03b41$.Lsnabbdom_Module__f_pre;
  var destroy$1 = \u03b41$.Lsnabbdom_Module__f_destroy;
  var remove$1 = \u03b41$.Lsnabbdom_Module__f_remove;
  var post$1 = \u03b41$.Lsnabbdom_Module__f_post;
  this.Lsnabbdom_modules_Dataset$__f_module = new $c_Lsnabbdom_Module(pre$1, create$1, update$1, destroy$1, remove$1, post$1);
  this.Lsnabbdom_modules_Dataset$__f_CAPS_REGEX = "[A-Z]";
}
$c_Lsnabbdom_modules_Dataset$.prototype = new $h_O();
$c_Lsnabbdom_modules_Dataset$.prototype.constructor = $c_Lsnabbdom_modules_Dataset$;
/** @constructor */
function $h_Lsnabbdom_modules_Dataset$() {
}
$h_Lsnabbdom_modules_Dataset$.prototype = $c_Lsnabbdom_modules_Dataset$.prototype;
$c_Lsnabbdom_modules_Dataset$.prototype.snabbdom$modules$Dataset$$$updateDataset__Lsnabbdom_VNode__Lsnabbdom_VNode__V = (function(oldVnode, vnode) {
  var elm = $n($n(vnode).Lsnabbdom_VNode__f_elm).get__O();
  var oldDataset = $n($n(oldVnode).Lsnabbdom_VNode__f_data).Lsnabbdom_VNodeData__f_dataset;
  var dataset = $n($n(vnode).Lsnabbdom_VNode__f_data).Lsnabbdom_VNodeData__f_dataset;
  var d = elm.dataset;
  if ((!((oldDataset === null) ? (dataset === null) : $n(oldDataset).equals__O__Z(dataset)))) {
    $p_Lsnabbdom_modules_Dataset$__update$2__Lorg_scalajs_dom_HTMLElement__sjs_js_Dictionary__sci_Map__sci_Map__V(this, elm, d, oldDataset, dataset);
  }
});
var $d_Lsnabbdom_modules_Dataset$ = new $TypeData().initClass($c_Lsnabbdom_modules_Dataset$, "snabbdom.modules.Dataset$", ({
  Lsnabbdom_modules_Dataset$: 1
}));
var $n_Lsnabbdom_modules_Dataset$;
function $m_Lsnabbdom_modules_Dataset$() {
  if ((!$n_Lsnabbdom_modules_Dataset$)) {
    $n_Lsnabbdom_modules_Dataset$ = new $c_Lsnabbdom_modules_Dataset$();
  }
  return $n_Lsnabbdom_modules_Dataset$;
}
/** @constructor */
function $c_Lsnabbdom_modules_EventListeners$() {
  this.Lsnabbdom_modules_EventListeners$__f_module = null;
  $n_Lsnabbdom_modules_EventListeners$ = this;
  var pre = $m_s_None$();
  var create = $m_s_None$();
  var update = $m_s_None$();
  var destroy = $m_s_None$();
  var remove = $m_s_None$();
  var post = $m_s_None$();
  var \u03b41$ = new $c_Lsnabbdom_Module(pre, create, update, destroy, remove, post);
  var value = new $c_Lsnabbdom_modules_EventListeners$$anon$1();
  var create$1 = new $c_s_Some(value);
  var value$1 = new $c_Lsnabbdom_modules_EventListeners$$anon$2();
  var update$1 = new $c_s_Some(value$1);
  var value$2 = new $c_Lsnabbdom_modules_EventListeners$$anon$3();
  var destroy$1 = new $c_s_Some(value$2);
  var pre$1 = \u03b41$.Lsnabbdom_Module__f_pre;
  var remove$1 = \u03b41$.Lsnabbdom_Module__f_remove;
  var post$1 = \u03b41$.Lsnabbdom_Module__f_post;
  this.Lsnabbdom_modules_EventListeners$__f_module = new $c_Lsnabbdom_Module(pre$1, create$1, update$1, destroy$1, remove$1, post$1);
}
$c_Lsnabbdom_modules_EventListeners$.prototype = new $h_O();
$c_Lsnabbdom_modules_EventListeners$.prototype.constructor = $c_Lsnabbdom_modules_EventListeners$;
/** @constructor */
function $h_Lsnabbdom_modules_EventListeners$() {
}
$h_Lsnabbdom_modules_EventListeners$.prototype = $c_Lsnabbdom_modules_EventListeners$.prototype;
$c_Lsnabbdom_modules_EventListeners$.prototype.snabbdom$modules$EventListeners$$$updateEventListeners__Lsnabbdom_VNode__s_Option__V = (function(oldVnode, vnode) {
  var oldOn = $n($n(oldVnode).Lsnabbdom_VNode__f_data).Lsnabbdom_VNodeData__f_on;
  var oldListener = $n(oldVnode).Lsnabbdom_VNode__f_listener;
  var this$1 = $n($n(oldVnode).Lsnabbdom_VNode__f_elm);
  if (this$1.isEmpty__Z()) {
    var oldElm = $m_s_None$();
  } else {
    var arg1 = this$1.get__O();
    var oldElm = new $c_s_Some(arg1);
  }
  var this$2 = $n(vnode);
  if (this$2.isEmpty__Z()) {
    var $x_1 = $m_s_None$();
  } else {
    var arg1$1 = this$2.get__O();
    var _$2 = $as_Lsnabbdom_VNode(arg1$1);
    var $x_1 = new $c_s_Some($n($n(_$2).Lsnabbdom_VNode__f_data).Lsnabbdom_VNodeData__f_on);
  }
  var this$3 = $n($x_1);
  var on = $as_sci_Map((this$3.isEmpty__Z() ? $m_sci_Map$EmptyMap$() : this$3.get__O()));
  var this$5 = $n(vnode);
  if (this$5.isEmpty__Z()) {
    var $x_2 = $m_s_None$();
  } else {
    var arg1$2 = this$5.get__O();
    var _$3 = $as_Lsnabbdom_VNode(arg1$2);
    var $x_2 = $n(_$3).Lsnabbdom_VNode__f_elm;
  }
  var this$6 = $n($x_2);
  if (this$6.isEmpty__Z()) {
    var elm = $m_s_None$();
  } else {
    var arg1$3 = this$6.get__O();
    var elm = new $c_s_Some(arg1$3);
  }
  if ((!((oldOn === null) ? (on === null) : $n(oldOn).equals__O__Z(on)))) {
    var this$7 = $n(oldOn);
    if ((!this$7.isEmpty__Z())) {
      var this$8 = $n(oldListener);
      var $x_3 = (!this$8.isEmpty__Z());
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var ol = $as_Lsnabbdom_Listener($n(oldListener).get__O());
      if ($n(on).isEmpty__Z()) {
        $n(oldOn).foreach__F1__V(new $c_sjsr_AnonFunction1(((x$1) => {
          var x$1$1 = $as_T2(x$1);
          matchResult1: {
            if ((x$1$1 !== null)) {
              var name = $as_T($n(x$1$1)._1__O());
              var this$9 = $n(oldElm);
              if ((!this$9.isEmpty__Z())) {
                var arg1$4 = this$9.get__O();
                arg1$4.removeEventListener(name, $n(ol).Lsnabbdom_Listener__f_jsFun, false);
              }
              break matchResult1;
            }
            throw new $c_s_MatchError(x$1$1);
          }
        })));
      } else {
        $n(oldOn).foreach__F1__V(new $c_sjsr_AnonFunction1(((x$1$2) => {
          var x$1$3 = $as_T2(x$1$2);
          matchResult2: {
            if ((x$1$3 !== null)) {
              var name$1 = $as_T($n(x$1$3)._1__O());
              if ($n($n(on).get__O__s_Option(name$1)).isEmpty__Z()) {
                var this$10 = $n(oldElm);
                if ((!this$10.isEmpty__Z())) {
                  var arg1$5 = this$10.get__O();
                  arg1$5.removeEventListener(name$1, $n(ol).Lsnabbdom_Listener__f_jsFun, false);
                }
              }
              break matchResult2;
            }
            throw new $c_s_MatchError(x$1$3);
          }
        })));
      }
    }
    var this$11 = $n(on);
    if ((!this$11.isEmpty__Z())) {
      var this$12 = $n(oldListener);
      if (this$12.isEmpty__Z()) {
        var vnode$1 = $as_Lsnabbdom_VNode($n(vnode).get__O());
        var $x_4 = new $c_Lsnabbdom_Listener(vnode$1);
      } else {
        var $x_4 = this$12.get__O();
      }
      var listener = $as_Lsnabbdom_Listener($x_4);
      $n(listener).Lsnabbdom_Listener__f_vnode = $as_Lsnabbdom_VNode($n(vnode).get__O());
      var this$13 = $n(vnode);
      if ((!this$13.isEmpty__Z())) {
        var arg1$6 = this$13.get__O();
        var _$6 = $as_Lsnabbdom_VNode(arg1$6);
        $n(_$6).Lsnabbdom_VNode__f_listener = new $c_s_Some(listener);
      }
      if ($n(oldOn).isEmpty__Z()) {
        $n(on).foreach__F1__V(new $c_sjsr_AnonFunction1(((x$1$3$1) => {
          var x$1$4 = $as_T2(x$1$3$1);
          matchResult3: {
            if ((x$1$4 !== null)) {
              var name$2 = $as_T($n(x$1$4)._1__O());
              var this$15 = $n(elm);
              if ((!this$15.isEmpty__Z())) {
                var arg1$7 = this$15.get__O();
                arg1$7.addEventListener(name$2, $n(listener).Lsnabbdom_Listener__f_jsFun, false);
              }
              break matchResult3;
            }
            throw new $c_s_MatchError(x$1$4);
          }
        })));
      } else {
        $n(on).foreach__F1__V(new $c_sjsr_AnonFunction1(((x$1$4$1) => {
          var x$1$5 = $as_T2(x$1$4$1);
          matchResult4: {
            if ((x$1$5 !== null)) {
              var name$3 = $as_T($n(x$1$5)._1__O());
              if ((!$n(oldOn).contains__O__Z(name$3))) {
                var this$16 = $n(elm);
                if ((!this$16.isEmpty__Z())) {
                  var arg1$8 = this$16.get__O();
                  arg1$8.addEventListener(name$3, $n(listener).Lsnabbdom_Listener__f_jsFun, false);
                }
              }
              break matchResult4;
            }
            throw new $c_s_MatchError(x$1$5);
          }
        })));
      }
    }
  }
});
var $d_Lsnabbdom_modules_EventListeners$ = new $TypeData().initClass($c_Lsnabbdom_modules_EventListeners$, "snabbdom.modules.EventListeners$", ({
  Lsnabbdom_modules_EventListeners$: 1
}));
var $n_Lsnabbdom_modules_EventListeners$;
function $m_Lsnabbdom_modules_EventListeners$() {
  if ((!$n_Lsnabbdom_modules_EventListeners$)) {
    $n_Lsnabbdom_modules_EventListeners$ = new $c_Lsnabbdom_modules_EventListeners$();
  }
  return $n_Lsnabbdom_modules_EventListeners$;
}
function $p_Lsnabbdom_modules_Props$__update$2__Lorg_scalajs_dom_Node__sci_Map__sci_Map__V($thiz, elm$2, oldProps, props) {
  $n(props).foreach__F1__V(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    matchResult1: {
      if ((x$1$1 !== null)) {
        var key = $as_T($n(x$1$1)._1__O());
        var cur = $n(x$1$1)._2__O();
        var this$2 = $n($n(oldProps).get__O__s_Option(key));
        if (this$2.isEmpty__Z()) {
          var $x_2 = true;
        } else {
          var arg1 = this$2.get__O();
          var $x_2 = (!$m_sr_BoxesRunTime$().equals__O__O__Z(arg1, cur));
        }
        if ($x_2) {
          if ((key !== "value")) {
            var $x_1 = true;
          } else {
            var this$5 = $n(($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(elm$2, key)) ? new $c_s_Some(elm$2[key]) : $m_s_None$()));
            if (this$5.isEmpty__Z()) {
              var $x_1 = true;
            } else {
              var arg1$1 = this$5.get__O();
              var $x_1 = (!$m_sr_BoxesRunTime$().equals__O__O__Z(arg1$1, cur));
            }
          }
        } else {
          var $x_1 = false;
        }
        if ($x_1) {
          elm$2[key] = cur;
        }
        break matchResult1;
      }
      throw new $c_s_MatchError(x$1$1);
    }
  })));
}
/** @constructor */
function $c_Lsnabbdom_modules_Props$() {
  this.Lsnabbdom_modules_Props$__f_module = null;
  $n_Lsnabbdom_modules_Props$ = this;
  var pre = $m_s_None$();
  var create = $m_s_None$();
  var update = $m_s_None$();
  var destroy = $m_s_None$();
  var remove = $m_s_None$();
  var post = $m_s_None$();
  var \u03b41$ = new $c_Lsnabbdom_Module(pre, create, update, destroy, remove, post);
  var value = new $c_Lsnabbdom_modules_Props$$anon$1();
  var create$1 = new $c_s_Some(value);
  var value$1 = new $c_Lsnabbdom_modules_Props$$anon$2();
  var update$1 = new $c_s_Some(value$1);
  var pre$1 = \u03b41$.Lsnabbdom_Module__f_pre;
  var destroy$1 = \u03b41$.Lsnabbdom_Module__f_destroy;
  var remove$1 = \u03b41$.Lsnabbdom_Module__f_remove;
  var post$1 = \u03b41$.Lsnabbdom_Module__f_post;
  this.Lsnabbdom_modules_Props$__f_module = new $c_Lsnabbdom_Module(pre$1, create$1, update$1, destroy$1, remove$1, post$1);
}
$c_Lsnabbdom_modules_Props$.prototype = new $h_O();
$c_Lsnabbdom_modules_Props$.prototype.constructor = $c_Lsnabbdom_modules_Props$;
/** @constructor */
function $h_Lsnabbdom_modules_Props$() {
}
$h_Lsnabbdom_modules_Props$.prototype = $c_Lsnabbdom_modules_Props$.prototype;
$c_Lsnabbdom_modules_Props$.prototype.snabbdom$modules$Props$$$updateProps__Lsnabbdom_VNode__Lsnabbdom_VNode__V = (function(oldVnode, vnode) {
  var elm = $n($n(vnode).Lsnabbdom_VNode__f_elm).get__O();
  var oldProps = $n($n(oldVnode).Lsnabbdom_VNode__f_data).Lsnabbdom_VNodeData__f_props;
  var props = $n($n(vnode).Lsnabbdom_VNode__f_data).Lsnabbdom_VNodeData__f_props;
  if ((!((oldProps === null) ? (props === null) : $n(oldProps).equals__O__Z(props)))) {
    $p_Lsnabbdom_modules_Props$__update$2__Lorg_scalajs_dom_Node__sci_Map__sci_Map__V(this, elm, oldProps, props);
  }
});
var $d_Lsnabbdom_modules_Props$ = new $TypeData().initClass($c_Lsnabbdom_modules_Props$, "snabbdom.modules.Props$", ({
  Lsnabbdom_modules_Props$: 1
}));
var $n_Lsnabbdom_modules_Props$;
function $m_Lsnabbdom_modules_Props$() {
  if ((!$n_Lsnabbdom_modules_Props$)) {
    $n_Lsnabbdom_modules_Props$ = new $c_Lsnabbdom_modules_Props$();
  }
  return $n_Lsnabbdom_modules_Props$;
}
function $p_Lsnabbdom_modules_Styles$__update$2__Lorg_scalajs_dom_Node__sci_Map__sci_Map__V($thiz, elm$2, oldStyle, style) {
  $n(oldStyle).foreach__F1__V(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var name = $as_T($n(x$1$1)._1__O());
      var x1 = $n(style).get__O__s_Option(name);
      if ((x1 instanceof $c_s_Some)) {
        return (void 0);
      }
      var x = $m_s_None$();
      if ((x === x1)) {
        var this$4 = $n(name);
        if (($charAt(this$4, 0) === 45)) {
          var this$7 = $n(name);
          var $x_1 = ($charAt(this$7, 1) === 45);
        } else {
          var $x_1 = false;
        }
        if ($x_1) {
          return $as_T(elm$2.style.removeProperty(name));
        } else {
          var dict = elm$2.style;
          dict[name] = "";
          return (void 0);
        }
      }
      throw new $c_s_MatchError(x1);
    }
    throw new $c_s_MatchError(x$1$1);
  })));
  $n(style).foreach__F1__V(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1$3 = $as_T2(x$1$2);
    matchResult3: {
      if ((x$1$3 !== null)) {
        var name$1 = $as_T($n(x$1$3)._1__O());
        var cur = $as_T($n(x$1$3)._2__O());
        var this$9 = $n($n(oldStyle).get__O__s_Option(name$1));
        if (this$9.isEmpty__Z()) {
          var $x_2 = true;
        } else {
          var arg1 = this$9.get__O();
          var _$1 = $as_T(arg1);
          var $x_2 = (_$1 !== cur);
        }
        if ($x_2) {
          var this$12 = $n(name$1);
          if (($charAt(this$12, 0) === 45)) {
            var this$15 = $n(name$1);
            var $x_3 = ($charAt(this$15, 1) === 45);
          } else {
            var $x_3 = false;
          }
          if ($x_3) {
            var \u03b42$ = elm$2.style;
            \u03b42$.setProperty(name$1, cur);
          } else {
            var dict$1 = elm$2.style;
            dict$1[name$1] = cur;
          }
        }
        break matchResult3;
      }
      throw new $c_s_MatchError(x$1$3);
    }
  })));
}
/** @constructor */
function $c_Lsnabbdom_modules_Styles$() {
  this.Lsnabbdom_modules_Styles$__f_module = null;
  $n_Lsnabbdom_modules_Styles$ = this;
  var pre = $m_s_None$();
  var create = $m_s_None$();
  var update = $m_s_None$();
  var destroy = $m_s_None$();
  var remove = $m_s_None$();
  var post = $m_s_None$();
  var \u03b41$ = new $c_Lsnabbdom_Module(pre, create, update, destroy, remove, post);
  var value = new $c_Lsnabbdom_modules_Styles$$anon$1();
  var create$1 = new $c_s_Some(value);
  var value$1 = new $c_Lsnabbdom_modules_Styles$$anon$2();
  var update$1 = new $c_s_Some(value$1);
  var pre$1 = \u03b41$.Lsnabbdom_Module__f_pre;
  var destroy$1 = \u03b41$.Lsnabbdom_Module__f_destroy;
  var remove$1 = \u03b41$.Lsnabbdom_Module__f_remove;
  var post$1 = \u03b41$.Lsnabbdom_Module__f_post;
  this.Lsnabbdom_modules_Styles$__f_module = new $c_Lsnabbdom_Module(pre$1, create$1, update$1, destroy$1, remove$1, post$1);
}
$c_Lsnabbdom_modules_Styles$.prototype = new $h_O();
$c_Lsnabbdom_modules_Styles$.prototype.constructor = $c_Lsnabbdom_modules_Styles$;
/** @constructor */
function $h_Lsnabbdom_modules_Styles$() {
}
$h_Lsnabbdom_modules_Styles$.prototype = $c_Lsnabbdom_modules_Styles$.prototype;
$c_Lsnabbdom_modules_Styles$.prototype.snabbdom$modules$Styles$$$updateStyle__Lsnabbdom_VNode__Lsnabbdom_VNode__V = (function(oldVnode, vnode) {
  var elm = $n($n(vnode).Lsnabbdom_VNode__f_elm).get__O();
  var oldStyle = $n($n(oldVnode).Lsnabbdom_VNode__f_data).Lsnabbdom_VNodeData__f_style;
  var style = $n($n(vnode).Lsnabbdom_VNode__f_data).Lsnabbdom_VNodeData__f_style;
  if ((!((oldStyle === null) ? (style === null) : $n(oldStyle).equals__O__Z(style)))) {
    $p_Lsnabbdom_modules_Styles$__update$2__Lorg_scalajs_dom_Node__sci_Map__sci_Map__V(this, elm, oldStyle, style);
  }
});
var $d_Lsnabbdom_modules_Styles$ = new $TypeData().initClass($c_Lsnabbdom_modules_Styles$, "snabbdom.modules.Styles$", ({
  Lsnabbdom_modules_Styles$: 1
}));
var $n_Lsnabbdom_modules_Styles$;
function $m_Lsnabbdom_modules_Styles$() {
  if ((!$n_Lsnabbdom_modules_Styles$)) {
    $n_Lsnabbdom_modules_Styles$ = new $c_Lsnabbdom_modules_Styles$();
  }
  return $n_Lsnabbdom_modules_Styles$;
}
/** @constructor */
function $c_Lsnabbdom_toVNode$() {
}
$c_Lsnabbdom_toVNode$.prototype = new $h_O();
$c_Lsnabbdom_toVNode$.prototype.constructor = $c_Lsnabbdom_toVNode$;
/** @constructor */
function $h_Lsnabbdom_toVNode$() {
}
$h_Lsnabbdom_toVNode$.prototype = $c_Lsnabbdom_toVNode$.prototype;
$c_Lsnabbdom_toVNode$.prototype.apply__Lorg_scalajs_dom_Node__s_Option__Lsnabbdom_VNode = (function(node, domApi) {
  var this$1 = $n(domApi);
  var api = $as_Lsnabbdom_DomApi((this$1.isEmpty__Z() ? new $c_Lsnabbdom_DomApi$$anon$1() : this$1.get__O()));
  if ($n(api).isElement__Lorg_scalajs_dom_Node__Z(node)) {
    var this$3 = $n($m_s_Option$().apply__O__s_Option($as_T(node.id)));
    if (this$3.isEmpty__Z()) {
      var $x_1 = true;
    } else {
      var arg1 = this$3.get__O();
      var _$1 = $as_T(arg1);
      var this$6 = $n(_$1);
      var $x_1 = (!(this$6 === ""));
    }
    var this$7 = $n(($x_1 ? this$3 : $m_s_None$()));
    if (this$7.isEmpty__Z()) {
      var id = "";
    } else {
      var arg1$1 = this$7.get__O();
      var _$2 = $as_T(arg1$1);
      var id = ("#" + _$2);
    }
    var this$8 = $n($m_s_Option$().apply__O__s_Option($as_T(node.getAttribute("class"))));
    var cn = $as_T((this$8.isEmpty__Z() ? "" : this$8.get__O()));
    if ((cn !== "")) {
      var $x_2 = $m_s_Predef$();
      var this$9 = $n(cn);
      var this$10 = $n($n($x_2).wrapRefArray__AO__scm_ArraySeq$ofRef($f_T__split__T__I__AT(this$9, " ", 0)));
      var c = ("." + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$10, "", ".", ""));
    } else {
      var c = "";
    }
    var this$11 = $n($n(api).tagName__Lorg_scalajs_dom_Element__T(node));
    var sel = (($as_T(this$11.toLowerCase()) + id) + c);
    var attrs = $as_scm_Map($m_scm_Map$().empty__O());
    var datasets = $as_scm_Map($m_scm_Map$().empty__O());
    var children = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    var elmAttrs = node.attributes;
    var elmChildren = node.childNodes;
    var this$13 = new $c_Lorg_scalajs_dom_NamedNodeMapMap(elmAttrs);
    var it = new $c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1(this$13);
    while (it.hasNext__Z()) {
      var arg1$2 = it.next__T2();
      matchResult1: {
        if ((arg1$2 !== null)) {
          var attr = $n(arg1$2)._2__O();
          var name = $as_T(attr.nodeName);
          var this$14 = $n(name);
          if (((this$14.length >= 0) && ($as_T(this$14.substring(0, 5)) === "data-"))) {
            var this$19 = $n(datasets);
            var self = $m_sc_StringOps$().drop$extension__T__I__T(name, 5);
            var this$17 = $n($m_s_Option$().apply__O__s_Option($as_T(attr.nodeValue)));
            var y = (this$17.isEmpty__Z() ? "" : this$17.get__O());
            var elem = new $c_T2(self, y);
            this$19.addOne__O__scm_Growable(elem);
            break matchResult1;
          } else if (((name !== "id") && (name !== "class"))) {
            var this$23 = $n(attrs);
            var this$21 = $n($m_s_Option$().apply__O__s_Option($as_T(attr.nodeValue)));
            var y$1 = (this$21.isEmpty__Z() ? "" : this$21.get__O());
            var elem$1 = new $c_T2(name, y$1);
            this$23.addOne__O__scm_Growable(elem$1);
            break matchResult1;
          } else {
            break matchResult1;
          }
        }
        throw new $c_s_MatchError(arg1$2);
      }
    }
    var this$25 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(elmChildren);
    var it$1 = this$25.iterator__sc_Iterator();
    while ($n(it$1).hasNext__Z()) {
      var arg1$3 = $n(it$1).next__O();
      var elem$2 = $m_Lsnabbdom_toVNode$().apply__Lorg_scalajs_dom_Node__s_Option__Lsnabbdom_VNode(arg1$3, domApi);
      children.addOne__O__scm_ArrayBuffer(elem$2);
    }
    var this$26 = $n(attrs);
    if ((!this$26.isEmpty__Z())) {
      var this$28 = $n(attrs);
      var this$27 = $m_s_$less$colon$less$();
      var attrs$1 = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$28);
    } else {
      var attrs$1 = $m_sci_Map$EmptyMap$();
    }
    var this$30 = $n(datasets);
    if ((!this$30.isEmpty__Z())) {
      var this$32 = $n(datasets);
      var this$31 = $m_s_$less$colon$less$();
      var dataset$1 = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$32);
    } else {
      var dataset$1 = $m_sci_Map$EmptyMap$();
    }
    $m_Lsnabbdom_VNodeData$();
    var props$1 = $m_sci_Map$EmptyMap$();
    $m_Lsnabbdom_VNodeData$();
    var classes$1 = $m_sci_Map$EmptyMap$();
    $m_Lsnabbdom_VNodeData$();
    var style$1 = $m_sci_Map$EmptyMap$();
    $m_Lsnabbdom_VNodeData$();
    var on$1 = $m_sci_Map$EmptyMap$();
    $m_Lsnabbdom_VNodeData$();
    var hook$1 = $m_s_None$();
    $m_Lsnabbdom_VNodeData$();
    var key$1 = $m_s_None$();
    $m_Lsnabbdom_VNodeData$();
    var ns$1 = $m_s_None$();
    $m_Lsnabbdom_VNodeData$();
    var fn$1 = $m_s_None$();
    $m_Lsnabbdom_VNodeData$();
    var args$1 = $m_s_None$();
    $m_Lsnabbdom_VNodeData$();
    var is$1 = $m_s_None$();
    $m_Lsnabbdom_VNodeData$();
    var data = new $c_Lsnabbdom_VNodeData(props$1, attrs$1, classes$1, style$1, dataset$1, on$1, hook$1, key$1, ns$1, fn$1, args$1, is$1);
    var $x_4 = $m_Lsnabbdom_VNode$();
    var $x_3 = new $c_s_Some(sel);
    if ((children.scm_ArrayBuffer__f_size0 >= 0)) {
      var len = children.scm_ArrayBuffer__f_size0;
      var destination = new ($d_Lsnabbdom_VNode.getArrayOf().constr)(len);
      children.copyToArray__O__I__I__I(destination, 0, 2147483647);
      var value = destination;
    } else {
      var capacity = 0;
      var jsElems = null;
      capacity = 0;
      jsElems = [];
      var it$2 = $n(children.view__scm_ArrayBufferView()).iterator__sc_Iterator();
      while ($n(it$2).hasNext__Z()) {
        var elem$3 = $n(it$2).next__O();
        var unboxedElem = ((elem$3 === null) ? null : elem$3);
        jsElems.push(unboxedElem);
      }
      var value = new ($d_Lsnabbdom_VNode.getArrayOf().constr)(jsElems);
    }
    var vnode = $n($x_4).create__s_Option__Lsnabbdom_VNodeData__s_Option__s_Option__s_Option__Lsnabbdom_VNode($x_3, data, new $c_s_Some(value), $m_s_None$(), new $c_s_Some(node));
    if ((((sel.length >= 0) && ($as_T(sel.substring(0, 3)) === "svg")) && (((sel.length === 3) || ($charAt(sel, 3) === 46)) || ($charAt(sel, 3) === 35)))) {
      $m_Lsnabbdom_h$().addNS__Lsnabbdom_VNode__V(vnode);
    }
    return vnode;
  } else if ($n(api).isText__Lorg_scalajs_dom_Node__Z(node)) {
    var this$59 = $n($n(api).getTextContent__Lorg_scalajs_dom_Node__s_Option(node));
    var text = $as_T((this$59.isEmpty__Z() ? "" : this$59.get__O()));
    return $m_Lsnabbdom_VNode$().create__s_Option__Lsnabbdom_VNodeData__s_Option__s_Option__s_Option__Lsnabbdom_VNode($m_s_None$(), $m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty, $m_s_None$(), new $c_s_Some(text), new $c_s_Some(node));
  } else if ($n(api).isComment__Lorg_scalajs_dom_Node__Z(node)) {
    var this$62 = $n($n(api).getTextContent__Lorg_scalajs_dom_Node__s_Option(node));
    var text$2 = $as_T((this$62.isEmpty__Z() ? "" : this$62.get__O()));
    return $m_Lsnabbdom_VNode$().create__s_Option__Lsnabbdom_VNodeData__s_Option__s_Option__s_Option__Lsnabbdom_VNode(new $c_s_Some("!"), $m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty, $m_s_None$(), new $c_s_Some(text$2), new $c_s_Some(node));
  } else {
    return $m_Lsnabbdom_VNode$().create__s_Option__Lsnabbdom_VNodeData__s_Option__s_Option__s_Option__Lsnabbdom_VNode(new $c_s_Some(""), $m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty, $m_s_None$(), $m_s_None$(), new $c_s_Some(node));
  }
});
var $d_Lsnabbdom_toVNode$ = new $TypeData().initClass($c_Lsnabbdom_toVNode$, "snabbdom.toVNode$", ({
  Lsnabbdom_toVNode$: 1
}));
var $n_Lsnabbdom_toVNode$;
function $m_Lsnabbdom_toVNode$() {
  if ((!$n_Lsnabbdom_toVNode$)) {
    $n_Lsnabbdom_toVNode$ = new $c_Lsnabbdom_toVNode$();
  }
  return $n_Lsnabbdom_toVNode$;
}
function $is_Ltyrian_Attr(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_Attr)));
}
function $as_Ltyrian_Attr(obj) {
  return (($is_Ltyrian_Attr(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Attr"));
}
function $isArrayOf_Ltyrian_Attr(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Attr)));
}
function $asArrayOf_Ltyrian_Attr(obj, depth) {
  return (($isArrayOf_Ltyrian_Attr(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Attr;", depth));
}
var $d_Ltyrian_Attr = new $TypeData().initClass(1, "tyrian.Attr", ({
  Ltyrian_Attr: 1
}));
function $is_Ltyrian_Cmd(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_Cmd)));
}
function $as_Ltyrian_Cmd(obj) {
  return (($is_Ltyrian_Cmd(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Cmd"));
}
function $isArrayOf_Ltyrian_Cmd(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Cmd)));
}
function $asArrayOf_Ltyrian_Cmd(obj, depth) {
  return (($isArrayOf_Ltyrian_Cmd(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Cmd;", depth));
}
/** @constructor */
function $c_Ltyrian_Cmd$() {
}
$c_Ltyrian_Cmd$.prototype = new $h_O();
$c_Ltyrian_Cmd$.prototype.constructor = $c_Ltyrian_Cmd$;
/** @constructor */
function $h_Ltyrian_Cmd$() {
}
$h_Ltyrian_Cmd$.prototype = $c_Ltyrian_Cmd$.prototype;
$c_Ltyrian_Cmd$.prototype.merge__Ltyrian_Cmd__Ltyrian_Cmd__Ltyrian_Cmd = (function(a, b) {
  var x = $m_Ltyrian_Cmd$None$();
  if ((x === a)) {
    var x$3 = $m_Ltyrian_Cmd$None$();
    if ((x$3 === b)) {
      return $m_Ltyrian_Cmd$None$();
    }
    return b;
  }
  var x$5 = $m_Ltyrian_Cmd$None$();
  if ((x$5 === b)) {
    return a;
  }
  return new $c_Ltyrian_Cmd$Combine(a, b);
});
var $d_Ltyrian_Cmd$ = new $TypeData().initClass($c_Ltyrian_Cmd$, "tyrian.Cmd$", ({
  Ltyrian_Cmd$: 1
}));
var $n_Ltyrian_Cmd$;
function $m_Ltyrian_Cmd$() {
  if ((!$n_Ltyrian_Cmd$)) {
    $n_Ltyrian_Cmd$ = new $c_Ltyrian_Cmd$();
  }
  return $n_Ltyrian_Cmd$;
}
/** @constructor */
function $c_Ltyrian_Cmd$Run$() {
}
$c_Ltyrian_Cmd$Run$.prototype = new $h_O();
$c_Ltyrian_Cmd$Run$.prototype.constructor = $c_Ltyrian_Cmd$Run$;
/** @constructor */
function $h_Ltyrian_Cmd$Run$() {
}
$h_Ltyrian_Cmd$Run$.prototype = $c_Ltyrian_Cmd$Run$.prototype;
$c_Ltyrian_Cmd$Run$.prototype.apply__O__Lcats_Applicative__Ltyrian_Cmd$Run = (function(task, evidence$1) {
  var toMsg = new $c_sjsr_AnonFunction1(((x) => x));
  return new $c_Ltyrian_Cmd$Run(task, toMsg, evidence$1);
});
var $d_Ltyrian_Cmd$Run$ = new $TypeData().initClass($c_Ltyrian_Cmd$Run$, "tyrian.Cmd$Run$", ({
  Ltyrian_Cmd$Run$: 1
}));
var $n_Ltyrian_Cmd$Run$;
function $m_Ltyrian_Cmd$Run$() {
  if ((!$n_Ltyrian_Cmd$Run$)) {
    $n_Ltyrian_Cmd$Run$ = new $c_Ltyrian_Cmd$Run$();
  }
  return $n_Ltyrian_Cmd$Run$;
}
function $is_Ltyrian_Elem(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_Elem)));
}
function $as_Ltyrian_Elem(obj) {
  return (($is_Ltyrian_Elem(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Elem"));
}
function $isArrayOf_Ltyrian_Elem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Elem)));
}
function $asArrayOf_Ltyrian_Elem(obj, depth) {
  return (($isArrayOf_Ltyrian_Elem(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Elem;", depth));
}
var $d_Ltyrian_Elem = new $TypeData().initClass(1, "tyrian.Elem", ({
  Ltyrian_Elem: 1
}));
/** @constructor */
function $c_Ltyrian_HTMLRendering$package$() {
  this.Ltyrian_HTMLRendering$package$__f_spacer = null;
  $n_Ltyrian_HTMLRendering$package$ = this;
  this.Ltyrian_HTMLRendering$package$__f_spacer = new $c_sjsr_AnonFunction1(((str) => {
    var str$1 = $as_T(str);
    var this$2 = $n(str$1);
    if ((this$2 === "")) {
      return str$1;
    } else {
      return (" " + str$1);
    }
  }));
}
$c_Ltyrian_HTMLRendering$package$.prototype = new $h_O();
$c_Ltyrian_HTMLRendering$package$.prototype.constructor = $c_Ltyrian_HTMLRendering$package$;
/** @constructor */
function $h_Ltyrian_HTMLRendering$package$() {
}
$h_Ltyrian_HTMLRendering$package$.prototype = $c_Ltyrian_HTMLRendering$package$.prototype;
$c_Ltyrian_HTMLRendering$package$.prototype.render__Ltyrian_Elem__T = (function(elem) {
  if ((elem === $m_Ltyrian_Empty$())) {
    return "";
  }
  if ((elem instanceof $c_Ltyrian_Text)) {
    var t = $as_Ltyrian_Text(elem);
    return $n(t).Ltyrian_Text__f_value;
  }
  if ($is_Ltyrian_Html(elem)) {
    var h = $as_Ltyrian_Html(elem);
    return $m_Ltyrian_HTMLRendering$package$().render__Ltyrian_Html__T(h);
  }
  throw new $c_s_MatchError(elem);
});
$c_Ltyrian_HTMLRendering$package$.prototype.render__Ltyrian_Html__T = (function(html) {
  if ((html instanceof $c_Ltyrian_RawTag)) {
    var tag = $as_Ltyrian_RawTag(html);
    var $x_2 = $m_Ltyrian_HTMLRendering$package$().Ltyrian_HTMLRendering$package$__f_spacer;
    var this$1 = $n($n(tag).Ltyrian_RawTag__f_attributes);
    var f = ((_$1) => {
      var _$1$1 = $as_Ltyrian_Attr(_$1);
      return $m_Ltyrian_HTMLRendering$package$().render__Ltyrian_Attr__T(_$1$1);
    });
    if ((this$1 === $m_sci_Nil$())) {
      var $x_1 = $m_sci_Nil$();
    } else {
      var arg1 = this$1.head__O();
      var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(this$1.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var arg1$1 = $n(rest).head__O();
        var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O());
      }
      var $x_1 = h;
    }
    var this$3 = $n($x_1);
    var f$1 = ((_$2) => {
      var _$2$1 = $as_T(_$2);
      var this$2 = $n(_$2$1);
      return (this$2 === "");
    });
    var l = this$3;
    block: {
      var result;
      while (true) {
        if ($n(l).isEmpty__Z()) {
          var result = $m_sci_Nil$();
          break;
        } else {
          var h$1 = $n(l).head__O();
          var t$1 = $as_sci_List($n(l).tail__O());
          if (($uZ(f$1(h$1)) === true)) {
            l = t$1;
            continue;
          }
          var start = l;
          var remaining = t$1;
          while (true) {
            if ($n(remaining).isEmpty__Z()) {
              var result = start;
              break block;
            } else {
              var x = $n(remaining).head__O();
              if (($uZ(f$1(x)) !== true)) {
                remaining = $as_sci_List($n(remaining).tail__O());
                continue;
              }
              var firstMiss = remaining;
              var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
              var toProcess = $as_sci_List($n(start).tail__O());
              var currentLast = newHead;
              while ((toProcess !== firstMiss)) {
                var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
                $n(currentLast).sci_$colon$colon__f_next = newElem;
                currentLast = newElem;
                toProcess = $as_sci_List($n(toProcess).tail__O());
              }
              var next = $as_sci_List($n(firstMiss).tail__O());
              var nextToCopy = next;
              while ((!$n(next).isEmpty__Z())) {
                var head = $n(next).head__O();
                if (($uZ(f$1(head)) !== true)) {
                  next = $as_sci_List($n(next).tail__O());
                } else {
                  while ((nextToCopy !== next)) {
                    var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                    $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                    currentLast = newElem$2;
                    nextToCopy = $as_sci_List($n(nextToCopy).tail__O());
                  }
                  nextToCopy = $as_sci_List($n(next).tail__O());
                  next = $as_sci_List($n(next).tail__O());
                }
              }
              if ((!$n(nextToCopy).isEmpty__Z())) {
                $n(currentLast).sci_$colon$colon__f_next = nextToCopy;
              }
              var result = newHead;
              break block;
            }
          }
        }
      }
    }
    var this$4 = $n(result);
    var attributes = $as_T($n($x_2).apply__O__O($f_sc_IterableOnceOps__mkString__T__T__T__T(this$4, "", " ", "")));
    return ((((((("<" + $n(tag).Ltyrian_RawTag__f_name) + attributes) + ">") + $n(tag).Ltyrian_RawTag__f_innerHTML) + "</") + $n(tag).Ltyrian_RawTag__f_name) + ">");
  }
  if ((html instanceof $c_Ltyrian_Tag)) {
    var tag$2 = $as_Ltyrian_Tag(html);
    var $x_4 = $m_Ltyrian_HTMLRendering$package$().Ltyrian_HTMLRendering$package$__f_spacer;
    var this$5 = $n($n(tag$2).Ltyrian_Tag__f_attributes);
    var f$2 = ((_$3) => {
      var _$3$1 = $as_Ltyrian_Attr(_$3);
      return $m_Ltyrian_HTMLRendering$package$().render__Ltyrian_Attr__T(_$3$1);
    });
    if ((this$5 === $m_sci_Nil$())) {
      var $x_3 = $m_sci_Nil$();
    } else {
      var arg1$2 = this$5.head__O();
      var h$2 = new $c_sci_$colon$colon(f$2(arg1$2), $m_sci_Nil$());
      var t$2 = h$2;
      var rest$1 = $as_sci_List(this$5.tail__O());
      while ((rest$1 !== $m_sci_Nil$())) {
        var arg1$3 = $n(rest$1).head__O();
        var nx$1 = new $c_sci_$colon$colon(f$2(arg1$3), $m_sci_Nil$());
        $n(t$2).sci_$colon$colon__f_next = nx$1;
        t$2 = nx$1;
        rest$1 = $as_sci_List($n(rest$1).tail__O());
      }
      var $x_3 = h$2;
    }
    var this$7 = $n($x_3);
    var f$3 = ((_$4) => {
      var _$4$1 = $as_T(_$4);
      var this$6 = $n(_$4$1);
      return (this$6 === "");
    });
    var l$1 = this$7;
    block$2: {
      var result$1;
      while (true) {
        if ($n(l$1).isEmpty__Z()) {
          var result$1 = $m_sci_Nil$();
          break;
        } else {
          var h$3 = $n(l$1).head__O();
          var t$3 = $as_sci_List($n(l$1).tail__O());
          if (($uZ(f$3(h$3)) === true)) {
            l$1 = t$3;
            continue;
          }
          var start$1 = l$1;
          var remaining$1 = t$3;
          while (true) {
            if ($n(remaining$1).isEmpty__Z()) {
              var result$1 = start$1;
              break block$2;
            } else {
              var x$1 = $n(remaining$1).head__O();
              if (($uZ(f$3(x$1)) !== true)) {
                remaining$1 = $as_sci_List($n(remaining$1).tail__O());
                continue;
              }
              var firstMiss$1 = remaining$1;
              var newHead$1 = new $c_sci_$colon$colon($n(start$1).head__O(), $m_sci_Nil$());
              var toProcess$1 = $as_sci_List($n(start$1).tail__O());
              var currentLast$1 = newHead$1;
              while ((toProcess$1 !== firstMiss$1)) {
                var newElem$1 = new $c_sci_$colon$colon($n(toProcess$1).head__O(), $m_sci_Nil$());
                $n(currentLast$1).sci_$colon$colon__f_next = newElem$1;
                currentLast$1 = newElem$1;
                toProcess$1 = $as_sci_List($n(toProcess$1).tail__O());
              }
              var next$1 = $as_sci_List($n(firstMiss$1).tail__O());
              var nextToCopy$1 = next$1;
              while ((!$n(next$1).isEmpty__Z())) {
                var head$1 = $n(next$1).head__O();
                if (($uZ(f$3(head$1)) !== true)) {
                  next$1 = $as_sci_List($n(next$1).tail__O());
                } else {
                  while ((nextToCopy$1 !== next$1)) {
                    var newElem$2$1 = new $c_sci_$colon$colon($n(nextToCopy$1).head__O(), $m_sci_Nil$());
                    $n(currentLast$1).sci_$colon$colon__f_next = newElem$2$1;
                    currentLast$1 = newElem$2$1;
                    nextToCopy$1 = $as_sci_List($n(nextToCopy$1).tail__O());
                  }
                  nextToCopy$1 = $as_sci_List($n(next$1).tail__O());
                  next$1 = $as_sci_List($n(next$1).tail__O());
                }
              }
              if ((!$n(nextToCopy$1).isEmpty__Z())) {
                $n(currentLast$1).sci_$colon$colon__f_next = nextToCopy$1;
              }
              var result$1 = newHead$1;
              break block$2;
            }
          }
        }
      }
    }
    var this$8 = $n(result$1);
    var attributes$2 = $as_T($n($x_4).apply__O__O($f_sc_IterableOnceOps__mkString__T__T__T__T(this$8, "", " ", "")));
    var this$9 = $n($n(tag$2).Ltyrian_Tag__f_children);
    var f$4 = ((x$1$1) => {
      var x$1$2 = $as_Ltyrian_Elem(x$1$1);
      if ((x$1$2 === $m_Ltyrian_Empty$())) {
        return "";
      }
      if ((x$1$2 instanceof $c_Ltyrian_Text)) {
        var t$4 = $as_Ltyrian_Text(x$1$2);
        return $n(t$4).Ltyrian_Text__f_value;
      }
      if ($is_Ltyrian_Html(x$1$2)) {
        var h$4 = $as_Ltyrian_Html(x$1$2);
        return $m_Ltyrian_HTMLRendering$package$().render__Ltyrian_Html__T(h$4);
      }
      throw new $c_s_MatchError(x$1$2);
    });
    if ((this$9 === $m_sci_Nil$())) {
      var $x_5 = $m_sci_Nil$();
    } else {
      var arg1$4 = this$9.head__O();
      var h$5 = new $c_sci_$colon$colon(f$4(arg1$4), $m_sci_Nil$());
      var t$5 = h$5;
      var rest$2 = $as_sci_List(this$9.tail__O());
      while ((rest$2 !== $m_sci_Nil$())) {
        var arg1$5 = $n(rest$2).head__O();
        var nx$2 = new $c_sci_$colon$colon(f$4(arg1$5), $m_sci_Nil$());
        $n(t$5).sci_$colon$colon__f_next = nx$2;
        t$5 = nx$2;
        rest$2 = $as_sci_List($n(rest$2).tail__O());
      }
      var $x_5 = h$5;
    }
    var this$10 = $n($x_5);
    var children = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$10, "", "", "");
    return ((((((("<" + $n(tag$2).Ltyrian_Tag__f_name) + attributes$2) + ">") + children) + "</") + $n(tag$2).Ltyrian_Tag__f_name) + ">");
  }
  throw new $c_s_MatchError(html);
});
$c_Ltyrian_HTMLRendering$package$.prototype.render__Ltyrian_Attr__T = (function(a) {
  if (false) {
    return "";
  }
  if ((a instanceof $c_Ltyrian_Attribute)) {
    var a$2 = $as_Ltyrian_Attribute(a);
    return $m_Ltyrian_HTMLRendering$package$().render__Ltyrian_Attribute__T(a$2);
  }
  if ($is_Ltyrian_Property(a)) {
    var p = $as_Ltyrian_Property(a);
    return $m_Ltyrian_HTMLRendering$package$().render__Ltyrian_Property__T(p);
  }
  if (false) {
    var a$3 = $as_Ltyrian_NamedAttribute(a);
    return $n(a$3).name__T();
  }
  if ((a === $m_Ltyrian_EmptyAttribute$())) {
    return "";
  }
  throw new $c_s_MatchError(a);
});
$c_Ltyrian_HTMLRendering$package$.prototype.render__Ltyrian_Attribute__T = (function(a) {
  return ((($n(a).Ltyrian_Attribute__f_name + "=\"") + $n(a).Ltyrian_Attribute__f_value) + "\"");
});
$c_Ltyrian_HTMLRendering$package$.prototype.render__Ltyrian_Property__T = (function(p) {
  matchResult5: {
    var asStr;
    var x18 = $n(p).valueOf__O();
    if (((typeof x18) === "boolean")) {
      var x = $uZ(x18);
      var asStr = ("" + x);
      break matchResult5;
    }
    if (((typeof x18) === "string")) {
      var x$2 = $as_T(x18);
      var asStr = x$2;
      break matchResult5;
    }
    throw new $c_s_MatchError(x18);
  }
  return ((($n(p).name__T() + "=\"") + asStr) + "\"");
});
var $d_Ltyrian_HTMLRendering$package$ = new $TypeData().initClass($c_Ltyrian_HTMLRendering$package$, "tyrian.HTMLRendering$package$", ({
  Ltyrian_HTMLRendering$package$: 1
}));
var $n_Ltyrian_HTMLRendering$package$;
function $m_Ltyrian_HTMLRendering$package$() {
  if ((!$n_Ltyrian_HTMLRendering$package$)) {
    $n_Ltyrian_HTMLRendering$package$ = new $c_Ltyrian_HTMLRendering$package$();
  }
  return $n_Ltyrian_HTMLRendering$package$;
}
function $f_Ltyrian_HtmlAttributes__$init$__V($thiz) {
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "accept");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "accesskey");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "action");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "alt");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "autocomplete");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "charset");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "cite");
  $thiz.Ltyrian_Html$__f_$u0060class$u0060$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "class");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "class");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "class");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "class");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "class");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "cols");
  new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "cols");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "colspan");
  new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "colspan");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "colspan");
  new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "colspan");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "content");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "contenteditable");
  new $c_Ltyrian_HtmlAttributes$AttributeNameBoolean($thiz, "contenteditable");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "contenteditable");
  new $c_Ltyrian_HtmlAttributes$AttributeNameBoolean($thiz, "contenteditable");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "coords");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "data");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "datetime");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "datetime");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "dir");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "dirname");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "draggable");
  new $c_Ltyrian_HtmlAttributes$AttributeNameBoolean($thiz, "draggable");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "enctype");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "enctype");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "for");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "for");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "for");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "for");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "form");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "formaction");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "formaction");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "headers");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "height");
  new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "height");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "high");
  new $c_Ltyrian_HtmlAttributes$AttributeNameDouble($thiz, "high");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "href");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "hreflang");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "hreflang");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "http");
  $thiz.Ltyrian_Html$__f_id$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "id");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "kind");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "label");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "lang");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "list");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "low");
  new $c_Ltyrian_HtmlAttributes$AttributeNameDouble($thiz, "low");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "max");
  new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "max");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "maxlength");
  new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "maxlength");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "maxlength");
  new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "maxlength");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "media");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "method");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "min");
  new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "min");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "multiple");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "muted");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "name");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "optimum");
  new $c_Ltyrian_HtmlAttributes$AttributeNameDouble($thiz, "optimum");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "pattern");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "placeholder");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "poster");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "preload");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "rel");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "role");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "rows");
  new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "rows");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "rowspan");
  new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "rowspan");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "rowspan");
  new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "rowspan");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "scope");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "shape");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "size");
  new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "size");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "sizes");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "span");
  new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "span");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "spellcheck");
  new $c_Ltyrian_HtmlAttributes$AttributeNameBoolean($thiz, "spellcheck");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "spellcheck");
  new $c_Ltyrian_HtmlAttributes$AttributeNameBoolean($thiz, "spellcheck");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "src");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "srcdoc");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "srcdoc");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "srclang");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "srclang");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "srcset");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "srcset");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "start");
  new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "start");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "step");
  new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "step");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "style");
  new $c_Ltyrian_HtmlAttributes$AttributeNameStyle($thiz, "style");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "tabindex");
  new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "tabindex");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "tabindex");
  new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "tabindex");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "target");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "title");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "translate");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "type");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "type");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "type");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "type");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "usemap");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "usemap");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "width");
  new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "width");
  new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "wrap");
  new $c_Ltyrian_HtmlAttributes$PropertyNameBoolean($thiz, "checked");
  new $c_Ltyrian_HtmlAttributes$PropertyNameBoolean($thiz, "indeterminate");
  new $c_Ltyrian_HtmlAttributes$PropertyNameBoolean($thiz, "selected");
  new $c_Ltyrian_HtmlAttributes$PropertyNameString($thiz, "value");
}
/** @constructor */
function $c_Ltyrian_HtmlAttributes$AttributeNameBoolean(outer, name) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Ltyrian_HtmlAttributes$AttributeNameBoolean.prototype = new $h_O();
$c_Ltyrian_HtmlAttributes$AttributeNameBoolean.prototype.constructor = $c_Ltyrian_HtmlAttributes$AttributeNameBoolean;
/** @constructor */
function $h_Ltyrian_HtmlAttributes$AttributeNameBoolean() {
}
$h_Ltyrian_HtmlAttributes$AttributeNameBoolean.prototype = $c_Ltyrian_HtmlAttributes$AttributeNameBoolean.prototype;
var $d_Ltyrian_HtmlAttributes$AttributeNameBoolean = new $TypeData().initClass($c_Ltyrian_HtmlAttributes$AttributeNameBoolean, "tyrian.HtmlAttributes$AttributeNameBoolean", ({
  Ltyrian_HtmlAttributes$AttributeNameBoolean: 1
}));
/** @constructor */
function $c_Ltyrian_HtmlAttributes$AttributeNameDouble(outer, name) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Ltyrian_HtmlAttributes$AttributeNameDouble.prototype = new $h_O();
$c_Ltyrian_HtmlAttributes$AttributeNameDouble.prototype.constructor = $c_Ltyrian_HtmlAttributes$AttributeNameDouble;
/** @constructor */
function $h_Ltyrian_HtmlAttributes$AttributeNameDouble() {
}
$h_Ltyrian_HtmlAttributes$AttributeNameDouble.prototype = $c_Ltyrian_HtmlAttributes$AttributeNameDouble.prototype;
var $d_Ltyrian_HtmlAttributes$AttributeNameDouble = new $TypeData().initClass($c_Ltyrian_HtmlAttributes$AttributeNameDouble, "tyrian.HtmlAttributes$AttributeNameDouble", ({
  Ltyrian_HtmlAttributes$AttributeNameDouble: 1
}));
/** @constructor */
function $c_Ltyrian_HtmlAttributes$AttributeNameInt(outer, name) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Ltyrian_HtmlAttributes$AttributeNameInt.prototype = new $h_O();
$c_Ltyrian_HtmlAttributes$AttributeNameInt.prototype.constructor = $c_Ltyrian_HtmlAttributes$AttributeNameInt;
/** @constructor */
function $h_Ltyrian_HtmlAttributes$AttributeNameInt() {
}
$h_Ltyrian_HtmlAttributes$AttributeNameInt.prototype = $c_Ltyrian_HtmlAttributes$AttributeNameInt.prototype;
var $d_Ltyrian_HtmlAttributes$AttributeNameInt = new $TypeData().initClass($c_Ltyrian_HtmlAttributes$AttributeNameInt, "tyrian.HtmlAttributes$AttributeNameInt", ({
  Ltyrian_HtmlAttributes$AttributeNameInt: 1
}));
/** @constructor */
function $c_Ltyrian_HtmlAttributes$AttributeNameString(outer, name) {
  this.Ltyrian_HtmlAttributes$AttributeNameString__f_name = null;
  this.Ltyrian_HtmlAttributes$AttributeNameString__f_name = name;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Ltyrian_HtmlAttributes$AttributeNameString.prototype = new $h_O();
$c_Ltyrian_HtmlAttributes$AttributeNameString.prototype.constructor = $c_Ltyrian_HtmlAttributes$AttributeNameString;
/** @constructor */
function $h_Ltyrian_HtmlAttributes$AttributeNameString() {
}
$h_Ltyrian_HtmlAttributes$AttributeNameString.prototype = $c_Ltyrian_HtmlAttributes$AttributeNameString.prototype;
$c_Ltyrian_HtmlAttributes$AttributeNameString.prototype.$colon$eq__T__Ltyrian_Attribute = (function(value) {
  $m_Ltyrian_Attribute$();
  var this$1 = $n(this.Ltyrian_HtmlAttributes$AttributeNameString__f_name);
  return new $c_Ltyrian_Attribute(this$1, value);
});
var $d_Ltyrian_HtmlAttributes$AttributeNameString = new $TypeData().initClass($c_Ltyrian_HtmlAttributes$AttributeNameString, "tyrian.HtmlAttributes$AttributeNameString", ({
  Ltyrian_HtmlAttributes$AttributeNameString: 1
}));
/** @constructor */
function $c_Ltyrian_HtmlAttributes$AttributeNameStyle(outer, name) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Ltyrian_HtmlAttributes$AttributeNameStyle.prototype = new $h_O();
$c_Ltyrian_HtmlAttributes$AttributeNameStyle.prototype.constructor = $c_Ltyrian_HtmlAttributes$AttributeNameStyle;
/** @constructor */
function $h_Ltyrian_HtmlAttributes$AttributeNameStyle() {
}
$h_Ltyrian_HtmlAttributes$AttributeNameStyle.prototype = $c_Ltyrian_HtmlAttributes$AttributeNameStyle.prototype;
var $d_Ltyrian_HtmlAttributes$AttributeNameStyle = new $TypeData().initClass($c_Ltyrian_HtmlAttributes$AttributeNameStyle, "tyrian.HtmlAttributes$AttributeNameStyle", ({
  Ltyrian_HtmlAttributes$AttributeNameStyle: 1
}));
/** @constructor */
function $c_Ltyrian_HtmlAttributes$PropertyNameBoolean(outer, name) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Ltyrian_HtmlAttributes$PropertyNameBoolean.prototype = new $h_O();
$c_Ltyrian_HtmlAttributes$PropertyNameBoolean.prototype.constructor = $c_Ltyrian_HtmlAttributes$PropertyNameBoolean;
/** @constructor */
function $h_Ltyrian_HtmlAttributes$PropertyNameBoolean() {
}
$h_Ltyrian_HtmlAttributes$PropertyNameBoolean.prototype = $c_Ltyrian_HtmlAttributes$PropertyNameBoolean.prototype;
var $d_Ltyrian_HtmlAttributes$PropertyNameBoolean = new $TypeData().initClass($c_Ltyrian_HtmlAttributes$PropertyNameBoolean, "tyrian.HtmlAttributes$PropertyNameBoolean", ({
  Ltyrian_HtmlAttributes$PropertyNameBoolean: 1
}));
/** @constructor */
function $c_Ltyrian_HtmlAttributes$PropertyNameString(outer, name) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Ltyrian_HtmlAttributes$PropertyNameString.prototype = new $h_O();
$c_Ltyrian_HtmlAttributes$PropertyNameString.prototype.constructor = $c_Ltyrian_HtmlAttributes$PropertyNameString;
/** @constructor */
function $h_Ltyrian_HtmlAttributes$PropertyNameString() {
}
$h_Ltyrian_HtmlAttributes$PropertyNameString.prototype = $c_Ltyrian_HtmlAttributes$PropertyNameString.prototype;
var $d_Ltyrian_HtmlAttributes$PropertyNameString = new $TypeData().initClass($c_Ltyrian_HtmlAttributes$PropertyNameString, "tyrian.HtmlAttributes$PropertyNameString", ({
  Ltyrian_HtmlAttributes$PropertyNameString: 1
}));
function $f_Ltyrian_HtmlTags__button$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html($thiz, attributes, plainText) {
  var attributes$1 = $n(attributes).toList__sci_List();
  var children = new $c_sci_$colon$colon(($m_Ltyrian_Html$(), new $c_Ltyrian_Text(plainText)), $m_sci_Nil$());
  var key = $m_s_None$();
  return new $c_Ltyrian_Tag("button", attributes$1, children, key);
}
function $f_Ltyrian_HtmlTags__div$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html($thiz, attributes, plainText) {
  var attributes$1 = $n(attributes).toList__sci_List();
  var children = new $c_sci_$colon$colon(($m_Ltyrian_Html$(), new $c_Ltyrian_Text(plainText)), $m_sci_Nil$());
  var key = $m_s_None$();
  return new $c_Ltyrian_Tag("div", attributes$1, children, key);
}
function $f_Ltyrian_HtmlTags__h1$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html($thiz, plainText) {
  var attributes = $m_sci_Nil$();
  var children = new $c_sci_$colon$colon(($m_Ltyrian_Html$(), new $c_Ltyrian_Text(plainText)), $m_sci_Nil$());
  var key = $m_s_None$();
  return new $c_Ltyrian_Tag("h1", attributes, children, key);
}
function $is_Ltyrian_Location(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_Location)));
}
function $as_Ltyrian_Location(obj) {
  return (($is_Ltyrian_Location(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Location"));
}
function $isArrayOf_Ltyrian_Location(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Location)));
}
function $asArrayOf_Ltyrian_Location(obj, depth) {
  return (($isArrayOf_Ltyrian_Location(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Location;", depth));
}
function $f_Ltyrian_LocationPlatform__fromJsLocation__Lorg_scalajs_dom_Location__Ltyrian_Location$Internal($thiz, location) {
  var locationDetails = $m_Ltyrian_LocationDetails$().fromUrl__T__Ltyrian_LocationDetails($as_T(location.href));
  return new $c_Ltyrian_Location$Internal(locationDetails);
}
/** @constructor */
function $c_Ltyrian_Routing$() {
}
$c_Ltyrian_Routing$.prototype = new $h_O();
$c_Ltyrian_Routing$.prototype.constructor = $c_Ltyrian_Routing$;
/** @constructor */
function $h_Ltyrian_Routing$() {
}
$h_Ltyrian_Routing$.prototype = $c_Ltyrian_Routing$.prototype;
$c_Ltyrian_Routing$.prototype.none__O__F1 = (function(ignore) {
  return new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Ltyrian_Location(x$1);
    if ((x$1$1 instanceof $c_Ltyrian_Location$Internal)) {
      var x$1$2 = $as_Ltyrian_Location$Internal(x$1$1);
      var this$2 = $n(x$1$2);
      $as_Ltyrian_Location$Internal(x$1$1);
      return ignore;
    }
    if ((x$1$1 instanceof $c_Ltyrian_Location$External)) {
      var x$1$3 = $as_Ltyrian_Location$External(x$1$1);
      var this$4 = $n(x$1$3);
      $as_Ltyrian_Location$External(x$1$1);
      return ignore;
    }
    throw new $c_s_MatchError(x$1$1);
  }));
});
var $d_Ltyrian_Routing$ = new $TypeData().initClass($c_Ltyrian_Routing$, "tyrian.Routing$", ({
  Ltyrian_Routing$: 1
}));
var $n_Ltyrian_Routing$;
function $m_Ltyrian_Routing$() {
  if ((!$n_Ltyrian_Routing$)) {
    $n_Ltyrian_Routing$ = new $c_Ltyrian_Routing$();
  }
  return $n_Ltyrian_Routing$;
}
function $is_Ltyrian_Sub(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_Sub)));
}
function $as_Ltyrian_Sub(obj) {
  return (($is_Ltyrian_Sub(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Sub"));
}
function $isArrayOf_Ltyrian_Sub(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Sub)));
}
function $asArrayOf_Ltyrian_Sub(obj, depth) {
  return (($isArrayOf_Ltyrian_Sub(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Sub;", depth));
}
var $d_Ltyrian_Sub = new $TypeData().initClass(1, "tyrian.Sub", ({
  Ltyrian_Sub: 1
}));
function $f_Ltyrian_TyrianApp__launch__T__V($thiz, containerId) {
  var this$1 = $m_sci_Map$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([]));
  $p_Ltyrian_TyrianApp__runReadyOrError__T__sci_Map__V($thiz, containerId, this$1.from__sc_IterableOnce__sci_Map(elems));
}
function $f_Ltyrian_TyrianApp__launch__Lorg_scalajs_dom_Element__V($thiz, node) {
  var this$1 = $m_sci_Map$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([]));
  var flags = this$1.from__sc_IterableOnce__sci_Map(elems);
  $f_Ltyrian_TyrianApp__ready__Lorg_scalajs_dom_Element__sci_Map__V($thiz, node, flags);
}
function $f_Ltyrian_TyrianApp__launch__T__sjs_js_Dictionary__V($thiz, containerId, flags) {
  var this$3 = new $c_sjs_js_WrappedDictionary(flags);
  var this$2 = $m_s_$less$colon$less$();
  $p_Ltyrian_TyrianApp__runReadyOrError__T__sci_Map__V($thiz, containerId, $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$3));
}
function $f_Ltyrian_TyrianApp__launch__Lorg_scalajs_dom_Element__sjs_js_Dictionary__V($thiz, node, flags) {
  var this$3 = new $c_sjs_js_WrappedDictionary(flags);
  var this$2 = $m_s_$less$colon$less$();
  var flags$1 = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$3);
  $f_Ltyrian_TyrianApp__ready__Lorg_scalajs_dom_Element__sci_Map__V($thiz, node, flags$1);
}
function $p_Ltyrian_TyrianApp__routeCurrentLocation__F1__Lcats_effect_kernel_Async__Ltyrian_Cmd($thiz, router, evidence$1) {
  var task = $n(evidence$1).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
    var this$2 = $m_Ltyrian_Location$();
    var location = window.location;
    return $f_Ltyrian_LocationPlatform__fromJsLocation__Lorg_scalajs_dom_Location__Ltyrian_Location$Internal(this$2, location);
  })));
  return new $c_Ltyrian_Cmd$Run(task, router, evidence$1);
}
function $p_Ltyrian_TyrianApp___init__sci_Map__T2($thiz, flags) {
  matchResult1: {
    var \u03b41$___1;
    var \u03b41$___2;
    var x1 = $thiz.init__sci_Map__T2(flags);
    if ((x1 !== null)) {
      var m = $n(x1)._1__O();
      var cmd = $as_Ltyrian_Cmd($n(x1)._2__O());
      var \u03b41$___1 = m;
      var \u03b41$___2 = cmd;
      break matchResult1;
    }
    throw new $c_s_MatchError(x1);
  }
  var m$2 = \u03b41$___1;
  var cmd$2 = $as_Ltyrian_Cmd(\u03b41$___2);
  var this$2 = $n(cmd$2);
  var other = $p_Ltyrian_TyrianApp__routeCurrentLocation__F1__Lcats_effect_kernel_Async__Ltyrian_Cmd($thiz, $thiz.router__F1(), $thiz.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_tyrian$TyrianApp$$evidence$1);
  var _2 = $m_Ltyrian_Cmd$().merge__Ltyrian_Cmd__Ltyrian_Cmd__Ltyrian_Cmd(this$2, other);
  return new $c_T2(m$2, _2);
}
function $p_Ltyrian_TyrianApp___update__O__F1($thiz, model) {
  return new $c_sjsr_AnonFunction1(((msg) => $as_T2($n($thiz.update__Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__F1($as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model(model))).apply__O__O(msg))));
}
function $p_Ltyrian_TyrianApp__onUrlChange__F1__Lcats_effect_kernel_Async__Ltyrian_Sub($thiz, router, evidence$1) {
  var subs = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Sub.getArrayOf().constr)([$m_Ltyrian_Sub$().fromEvent__T__Lorg_scalajs_dom_EventTarget__F1__Lcats_effect_kernel_Sync__Ltyrian_Sub("DOMContentLoaded", window, new $c_sjsr_AnonFunction1(((_$4) => $ps_Ltyrian_TyrianApp__makeMsg$1__F1__s_Option(router))), evidence$1), $m_Ltyrian_Sub$().fromEvent__T__Lorg_scalajs_dom_EventTarget__F1__Lcats_effect_kernel_Sync__Ltyrian_Sub("popstate", window, new $c_sjsr_AnonFunction1(((_$5) => $ps_Ltyrian_TyrianApp__makeMsg$1__F1__s_Option(router))), evidence$1)]));
  var this$2 = $n(subs);
  var subs$1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$2);
  return new $c_Ltyrian_Sub$Batch(subs$1);
}
function $p_Ltyrian_TyrianApp___subscriptions__O__Ltyrian_Sub($thiz, model) {
  var this$1 = $n($p_Ltyrian_TyrianApp__onUrlChange__F1__Lcats_effect_kernel_Async__Ltyrian_Sub($thiz, $thiz.router__F1(), $thiz.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_tyrian$TyrianApp$$evidence$1));
  var other = $thiz.subscriptions__Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__Ltyrian_Sub($as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model(model));
  return $m_Ltyrian_Sub$().merge__Ltyrian_Sub__Ltyrian_Sub__Ltyrian_Sub(this$1, other);
}
function $f_Ltyrian_TyrianApp__ready__Lorg_scalajs_dom_Element__sci_Map__V($thiz, node, flags) {
  var $x_1 = $n($thiz.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_run);
  var router = $thiz.router__F1();
  var init = $p_Ltyrian_TyrianApp___init__sci_Map__T2($thiz, flags);
  var update = new $c_sjsr_AnonFunction1(((model) => $p_Ltyrian_TyrianApp___update__O__F1($thiz, model)));
  var view = new $c_sjsr_AnonFunction1(((model$2) => $thiz.view__Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__Ltyrian_Html($as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model(model$2))));
  var subscriptions = new $c_sjsr_AnonFunction1(((model$3) => $p_Ltyrian_TyrianApp___subscriptions__O__Ltyrian_Sub($thiz, model$3)));
  var evidence$1 = $thiz.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_tyrian$TyrianApp$$evidence$1;
  $n($x_1).apply__O__O($m_Ltyrian_runtime_TyrianRuntime$().apply__F1__Lorg_scalajs_dom_Element__O__Ltyrian_Cmd__F1__F1__F1__Lcats_effect_kernel_Async__O(router, node, $n(init)._1__O(), $as_Ltyrian_Cmd($n(init)._2__O()), update, view, subscriptions, evidence$1));
}
function $p_Ltyrian_TyrianApp__runReadyOrError__T__sci_Map__V($thiz, containerId, flags) {
  var x4 = $m_s_Option$().apply__O__s_Option(document.getElementById(containerId));
  if ((x4 instanceof $c_s_Some)) {
    var e = $n($as_s_Some(x4)).s_Some__f_value;
    $f_Ltyrian_TyrianApp__ready__Lorg_scalajs_dom_Element__sci_Map__V($thiz, e, flags);
    return (void 0);
  }
  var x = $m_s_None$();
  if ((x === x4)) {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), (("Missing Element! Could not find an element with id '" + containerId) + "' on the page."));
  }
  throw new $c_s_MatchError(x4);
}
function $ps_Ltyrian_TyrianApp__makeMsg$1__F1__s_Option(router$1) {
  var $x_1 = $m_s_Option$();
  var this$1 = $m_Ltyrian_Location$();
  var location = window.location;
  return $n($x_1).apply__O__s_Option($n(router$1).apply__O__O($f_Ltyrian_LocationPlatform__fromJsLocation__Lorg_scalajs_dom_Location__Ltyrian_Location$Internal(this$1, location)));
}
function $is_Ltyrian_TyrianApp(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_TyrianApp)));
}
function $as_Ltyrian_TyrianApp(obj) {
  return (($is_Ltyrian_TyrianApp(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.TyrianApp"));
}
function $isArrayOf_Ltyrian_TyrianApp(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_TyrianApp)));
}
function $asArrayOf_Ltyrian_TyrianApp(obj, depth) {
  return (($isArrayOf_Ltyrian_TyrianApp(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.TyrianApp;", depth));
}
function $p_Ltyrian_TyrianApp$__appElementFlags__Lorg_scalajs_dom_HTMLElement__sci_Map($thiz, tyrianAppElement) {
  var dict = tyrianAppElement.dataset;
  var pf = new $c_Ltyrian_TyrianApp$$anon$1($thiz);
  var b = new $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder();
  var it = new $c_sjs_js_WrappedDictionary$DictionaryIterator(dict);
  while (it.hasNext__Z()) {
    var arg1 = it.next__T2();
    if (pf.isDefinedAt__T2__Z(arg1)) {
      var default$1 = $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf;
      var elems = new $c_sc_View$Single(pf.applyOrElse__T2__F1__O(arg1, default$1));
    } else {
      var elems = $m_sc_View$Empty$();
    }
    $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(b, elems);
  }
  var this$3 = $n(b.result__sjs_js_WrappedDictionary());
  var this$2 = $m_s_$less$colon$less$();
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$3);
}
/** @constructor */
function $c_Ltyrian_TyrianApp$() {
}
$c_Ltyrian_TyrianApp$.prototype = new $h_O();
$c_Ltyrian_TyrianApp$.prototype.constructor = $c_Ltyrian_TyrianApp$;
/** @constructor */
function $h_Ltyrian_TyrianApp$() {
}
$h_Ltyrian_TyrianApp$.prototype = $c_Ltyrian_TyrianApp$.prototype;
$c_Ltyrian_TyrianApp$.prototype.onLoad__sci_Map__Lcats_effect_kernel_Async__V = (function(appDirectory, evidence$1) {
  var documentReady = new Promise(((resolve, _reject) => {
    document.addEventListener("DOMContentLoaded", ((_$7) => resolve((void 0))));
    return (($as_T(document.readyState) !== "loading") ? (resolve((void 0)), (void 0)) : (void 0));
  }));
  documentReady.then(((_$8) => {
    $m_Ltyrian_TyrianApp$().launch__sci_Map__Lcats_effect_kernel_Async__V(appDirectory, evidence$1);
  }));
});
$c_Ltyrian_TyrianApp$.prototype.onLoad__sci_Seq__Lcats_effect_kernel_Async__V = (function(appDirectory, evidence$1) {
  var this$2 = $n(appDirectory);
  var this$1 = $m_s_$less$colon$less$();
  this.onLoad__sci_Map__Lcats_effect_kernel_Async__V($m_sci_Map$().from__sc_IterableOnce__sci_Map(this$2), evidence$1);
});
$c_Ltyrian_TyrianApp$.prototype.launch__sci_Map__Lcats_effect_kernel_Async__V = (function(appDirectory, evidence$1) {
  var domList = document.querySelectorAll("[data-tyrian-app]");
  var this$2 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(domList);
  var it = this$2.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var arg1 = $n(it).next__O();
    var dict = arg1.dataset;
    var tyrianAppName = ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, "tyrianApp")) ? new $c_s_Some(dict.tyrianApp) : $m_s_None$());
    matchResult3: {
      var this$5 = $n(tyrianAppName);
      if (this$5.isEmpty__Z()) {
        var x7 = $m_s_None$();
      } else {
        var arg1$1 = this$5.get__O();
        var key = $as_T(arg1$1);
        var x7 = $n(appDirectory).get__O__s_Option(key);
      }
      if ((x7 instanceof $c_s_Some)) {
        var appSupplier = $as_Ltyrian_TyrianApp($n($as_s_Some(x7)).s_Some__f_value);
        var this$6 = $n(appSupplier);
        var flags = $p_Ltyrian_TyrianApp$__appElementFlags__Lorg_scalajs_dom_HTMLElement__sci_Map($m_Ltyrian_TyrianApp$(), arg1);
        $f_Ltyrian_TyrianApp__ready__Lorg_scalajs_dom_Element__sci_Map__V(this$6, arg1, flags);
        break matchResult3;
      }
      var this$7 = $n(tyrianAppName);
      var x = ("Could not find an app entry for " + (this$7.isEmpty__Z() ? "" : this$7.get__O()));
      var this$9 = $m_s_Console$();
      $n(this$9.out__Ljava_io_PrintStream()).println__O__V(x);
    }
  }
});
var $d_Ltyrian_TyrianApp$ = new $TypeData().initClass($c_Ltyrian_TyrianApp$, "tyrian.TyrianApp$", ({
  Ltyrian_TyrianApp$: 1
}));
var $n_Ltyrian_TyrianApp$;
function $m_Ltyrian_TyrianApp$() {
  if ((!$n_Ltyrian_TyrianApp$)) {
    $n_Ltyrian_TyrianApp$ = new $c_Ltyrian_TyrianApp$();
  }
  return $n_Ltyrian_TyrianApp$;
}
function $p_Ltyrian_runtime_CmdHelper$__rec$1__scm_ListBuffer__Lcats_Applicative__sci_List__sci_List($thiz, acc$1, evidence$1$1, remaining) {
  var remaining$tailLocal1 = remaining;
  while (true) {
    var x12 = remaining$tailLocal1;
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x12)) {
      return $n(acc$1).toList__sci_List();
    }
    if ((x12 instanceof $c_sci_$colon$colon)) {
      var x13 = $as_sci_$colon$colon(x12);
      var x15 = $n(x13).sci_$colon$colon__f_next;
      var cmd = $as_Ltyrian_Cmd($n(x13).sci_$colon$colon__f_head);
      var x$3 = $m_Ltyrian_Cmd$None$();
      if ((x$3 === cmd)) {
        remaining$tailLocal1 = x15;
        continue;
      }
      if (false) {
        var c = $as_Ltyrian_Cmd$Emit(cmd);
        var this$2 = $n(acc$1);
        var elem = $n(evidence$1$1).map__O__F1__O($n(c).toTask__Lcats_Applicative__O(evidence$1$1), new $c_sjsr_AnonFunction1(((x$5) => $m_s_Option$().apply__O__s_Option(x$5))));
        this$2.addOne__O__scm_ListBuffer(elem);
        remaining$tailLocal1 = x15;
        continue;
      }
      if (false) {
        var c$2 = $as_Ltyrian_Cmd$SideEffect(cmd);
        var this$5 = $n(acc$1);
        var elem$1 = $n(evidence$1$1).map__O__F1__O($n(c$2).toTask__O(), new $c_sjsr_AnonFunction1(((_$2) => {
          $as_jl_Void(_$2);
          return $m_s_None$();
        })));
        this$5.addOne__O__scm_ListBuffer(elem$1);
        remaining$tailLocal1 = x15;
        continue;
      }
      if ((cmd instanceof $c_Ltyrian_Cmd$Run)) {
        var c$3 = $as_Ltyrian_Cmd$Run(cmd);
        var this$7 = $n(acc$1);
        var elem$2 = $n(evidence$1$1).map__O__F1__O($n(c$3).toTask__O(), new $c_sjsr_AnonFunction1(((x$6) => $m_s_Option$().apply__O__s_Option(x$6))));
        this$7.addOne__O__scm_ListBuffer(elem$2);
        remaining$tailLocal1 = x15;
        continue;
      }
      if ((cmd instanceof $c_Ltyrian_Cmd$Combine)) {
        var x$1 = $as_Ltyrian_Cmd$Combine(cmd);
        var this$9 = $n(x$1);
        var x7 = this$9.Ltyrian_Cmd$Combine__f_cmd1;
        var this$10 = $n(x$1);
        var x8 = this$10.Ltyrian_Cmd$Combine__f_cmd2;
        var this$11 = $n(x15);
        var this$12 = new $c_sci_$colon$colon(x8, this$11);
        remaining$tailLocal1 = new $c_sci_$colon$colon(x7, this$12);
        continue;
      }
      if (false) {
        var x$1$1 = $as_Ltyrian_Cmd$Batch(cmd);
        var x4 = $n(x$1$1)._1__sci_List();
        var this$14 = $n(x4);
        remaining$tailLocal1 = this$14.appendedAll__sc_IterableOnce__sci_List(x15);
        continue;
      }
      throw new $c_s_MatchError(cmd);
    }
    throw new $c_s_MatchError(x12);
  }
}
/** @constructor */
function $c_Ltyrian_runtime_CmdHelper$() {
}
$c_Ltyrian_runtime_CmdHelper$.prototype = new $h_O();
$c_Ltyrian_runtime_CmdHelper$.prototype.constructor = $c_Ltyrian_runtime_CmdHelper$;
/** @constructor */
function $h_Ltyrian_runtime_CmdHelper$() {
}
$h_Ltyrian_runtime_CmdHelper$.prototype = $c_Ltyrian_runtime_CmdHelper$.prototype;
$c_Ltyrian_runtime_CmdHelper$.prototype.cmdToTaskList__Ltyrian_Cmd__Lcats_Applicative__sci_List = (function(cmd, evidence$1) {
  var acc = new $c_scm_ListBuffer();
  return $p_Ltyrian_runtime_CmdHelper$__rec$1__scm_ListBuffer__Lcats_Applicative__sci_List__sci_List(this, acc, evidence$1, new $c_sci_$colon$colon(cmd, $m_sci_Nil$()));
});
var $d_Ltyrian_runtime_CmdHelper$ = new $TypeData().initClass($c_Ltyrian_runtime_CmdHelper$, "tyrian.runtime.CmdHelper$", ({
  Ltyrian_runtime_CmdHelper$: 1
}));
var $n_Ltyrian_runtime_CmdHelper$;
function $m_Ltyrian_runtime_CmdHelper$() {
  if ((!$n_Ltyrian_runtime_CmdHelper$)) {
    $n_Ltyrian_runtime_CmdHelper$ = new $c_Ltyrian_runtime_CmdHelper$();
  }
  return $n_Ltyrian_runtime_CmdHelper$;
}
function $p_Ltyrian_runtime_Rendering$__buildNodeData__sci_List__F1__s_Option__Lsnabbdom_VNodeData($thiz, attrs, onMsg, key) {
  var as = $n(attrs).collect__s_PartialFunction__sci_List(new $c_Ltyrian_runtime_Rendering$$anon$1());
  var props = $n(attrs).collect__s_PartialFunction__sci_List(new $c_Ltyrian_runtime_Rendering$$anon$2());
  var events = $n(attrs).collect__s_PartialFunction__sci_List(new $c_Ltyrian_runtime_Rendering$$anon$3(onMsg));
  var this$2 = $n(props);
  var this$1 = $m_s_$less$colon$less$();
  var props$1 = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$2);
  var this$4 = $n(as);
  var this$3 = $m_s_$less$colon$less$();
  var attrs$1 = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$4);
  var this$6 = $n(events);
  var this$5 = $m_s_$less$colon$less$();
  var on$1 = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$6);
  var this$7 = $n($m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty);
  var classes$1 = this$7.Lsnabbdom_VNodeData__f_classes;
  var this$8 = $n($m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty);
  var style$1 = this$8.Lsnabbdom_VNodeData__f_style;
  var this$9 = $n($m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty);
  var dataset$1 = this$9.Lsnabbdom_VNodeData__f_dataset;
  var this$10 = $n($m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty);
  var hook$1 = this$10.Lsnabbdom_VNodeData__f_hook;
  var this$11 = $n($m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty);
  var ns$1 = this$11.Lsnabbdom_VNodeData__f_ns;
  var this$12 = $n($m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty);
  var fn$1 = this$12.Lsnabbdom_VNodeData__f_fn;
  var this$13 = $n($m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty);
  var args$1 = this$13.Lsnabbdom_VNodeData__f_args;
  var this$14 = $n($m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty);
  var is$1 = this$14.Lsnabbdom_VNodeData__f_is;
  $n($m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty);
  return new $c_Lsnabbdom_VNodeData(props$1, attrs$1, classes$1, style$1, dataset$1, on$1, hook$1, key, ns$1, fn$1, args$1, is$1);
}
function $p_Ltyrian_runtime_Rendering$__interceptHref__sci_List__Z($thiz, attrs) {
  var this$1 = $n(attrs);
  _return: {
    var these = this$1;
    while ((!$n(these).isEmpty__Z())) {
      var arg1 = $n(these).head__O();
      var x$1 = $as_Ltyrian_Attr(arg1);
      matchResult7: {
        var $x_1;
        if ((x$1 instanceof $c_Ltyrian_Attribute)) {
          $m_Ltyrian_Attribute$();
          var x$1$1 = $as_Ltyrian_Attribute(x$1);
          var this$3 = $n(x$1$1);
          var x54 = this$3.Ltyrian_Attribute__f_name;
          var this$4 = $n(x$1$1);
          if ((x54 === "href")) {
            var $x_1 = true;
            break matchResult7;
          }
        }
        var $x_1 = false;
      }
      if ($x_1) {
        var href = true;
        break _return;
      }
      these = $as_sci_List($n(these).tail__O());
    }
    var href = false;
  }
  var this$5 = $n(attrs);
  _return$1: {
    var these$1 = this$5;
    while ((!$n(these$1).isEmpty__Z())) {
      var arg1$1 = $n(these$1).head__O();
      var x$1$2 = $as_Ltyrian_Attr(arg1$1);
      matchResult8: {
        var $x_2;
        if (false) {
          var x$1$3 = $as_Ltyrian_Event(x$1$2);
          var x59 = $n(x$1$3)._1__T();
          $n(x$1$3)._2__F1();
          $n(x$1$3)._3__Z();
          $n(x$1$3)._4__Z();
          $n(x$1$3)._5__Z();
          if ((x59 === "click")) {
            var $x_2 = true;
            break matchResult8;
          }
        }
        var $x_2 = false;
      }
      if ($x_2) {
        var onClick = true;
        break _return$1;
      }
      these$1 = $as_sci_List($n(these$1).tail__O());
    }
    var onClick = false;
  }
  return (href && (!onClick));
}
function $p_Ltyrian_runtime_Rendering$__onClickPreventDefault__sci_List__F1__F1__T2($thiz, attrs, onMsg, router) {
  var newLocation = $n($n(attrs).collect__s_PartialFunction__sci_List(new $c_Ltyrian_runtime_Rendering$$anon$4())).headOption__s_Option();
  var callback = new $c_sjsr_AnonFunction1(((e) => {
    e.preventDefault();
    matchResult11: {
      var x = $m_s_None$();
      if ((x === newLocation)) {
        break matchResult11;
      }
      if ((newLocation instanceof $c_s_Some)) {
        var loc = $as_T($n($as_s_Some(newLocation)).s_Some__f_value);
        var this$1 = $m_Ltyrian_Location$();
        var location = window.location;
        var jsLoc = $f_Ltyrian_LocationPlatform__fromJsLocation__Lorg_scalajs_dom_Location__Ltyrian_Location$Internal(this$1, location);
        var locationToRoute = $m_Ltyrian_Location$().fromUrl__T__Ltyrian_Location$Internal__Ltyrian_Location(loc, jsLoc);
        if ($n(locationToRoute).isInternal__Z()) {
          window.history.pushState(({}), "", loc);
        }
        $n(onMsg).apply__O__O($n(router).apply__O__O(locationToRoute));
        break matchResult11;
      }
      throw new $c_s_MatchError(newLocation);
    }
  }));
  var y = $m_Lsnabbdom_EventHandler$().apply__sci_Seq__Lsnabbdom_EventHandler($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_F1.getArrayOf().constr)([callback])));
  return new $c_T2("click", y);
}
function $p_Ltyrian_runtime_Rendering$__patch__Lsnabbdom_Patch($thiz) {
  if ((!$thiz.Ltyrian_runtime_Rendering$__f_patchbitmap$1)) {
    $thiz.Ltyrian_runtime_Rendering$__f_patch$lzy1 = $m_Lsnabbdom_init$().apply__sci_Seq__s_Option__Lsnabbdom_Patch(new $c_sci_$colon$colon($m_Lsnabbdom_modules_Attributes$().Lsnabbdom_modules_Attributes$__f_module, new $c_sci_$colon$colon($m_Lsnabbdom_modules_Classes$().Lsnabbdom_modules_Classes$__f_module, new $c_sci_$colon$colon($m_Lsnabbdom_modules_Props$().Lsnabbdom_modules_Props$__f_module, new $c_sci_$colon$colon($m_Lsnabbdom_modules_Styles$().Lsnabbdom_modules_Styles$__f_module, new $c_sci_$colon$colon($m_Lsnabbdom_modules_EventListeners$().Lsnabbdom_modules_EventListeners$__f_module, new $c_sci_$colon$colon($m_Lsnabbdom_modules_Dataset$().Lsnabbdom_modules_Dataset$__f_module, $m_sci_Nil$())))))), ($m_Lsnabbdom_init$(), $m_s_None$()));
    $thiz.Ltyrian_runtime_Rendering$__f_patchbitmap$1 = true;
  }
  return $thiz.Ltyrian_runtime_Rendering$__f_patch$lzy1;
}
/** @constructor */
function $c_Ltyrian_runtime_Rendering$() {
  this.Ltyrian_runtime_Rendering$__f_patch$lzy1 = null;
  this.Ltyrian_runtime_Rendering$__f_patchbitmap$1 = false;
}
$c_Ltyrian_runtime_Rendering$.prototype = new $h_O();
$c_Ltyrian_runtime_Rendering$.prototype.constructor = $c_Ltyrian_runtime_Rendering$;
/** @constructor */
function $h_Ltyrian_runtime_Rendering$() {
}
$h_Ltyrian_runtime_Rendering$.prototype = $c_Ltyrian_runtime_Rendering$.prototype;
$c_Ltyrian_runtime_Rendering$.prototype.toVNode__Ltyrian_Html__F1__F1__Lsnabbdom_VNode = (function(html, onMsg, router) {
  if ((html instanceof $c_Ltyrian_RawTag)) {
    var x$1 = $as_Ltyrian_RawTag(html);
    var this$2 = $n(x$1);
    var x100 = this$2.Ltyrian_RawTag__f_name;
    var this$3 = $n(x$1);
    var x101 = this$3.Ltyrian_RawTag__f_attributes;
    var this$4 = $n(x$1);
    var x102 = this$4.Ltyrian_RawTag__f_innerHTML;
    var this$5 = $n(x$1);
    var x103 = this$5.Ltyrian_RawTag__f_key;
    var data = $p_Ltyrian_runtime_Rendering$__buildNodeData__sci_List__F1__s_Option__Lsnabbdom_VNodeData(this, x101, onMsg, x103);
    var elm = document.createElement(x100);
    elm.innerHTML = x102;
    var vNode = $m_Lsnabbdom_toVNode$().apply__Lorg_scalajs_dom_Node__s_Option__Lsnabbdom_VNode(elm, $m_s_None$());
    $n(vNode).Lsnabbdom_VNode__f_data = data;
    return vNode;
  }
  if ((html instanceof $c_Ltyrian_Tag)) {
    var x$1$1 = $as_Ltyrian_Tag(html);
    var this$8 = $n(x$1$1);
    var x94 = this$8.Ltyrian_Tag__f_name;
    var this$9 = $n(x$1$1);
    var x95 = this$9.Ltyrian_Tag__f_attributes;
    var this$10 = $n(x$1$1);
    var x96 = this$10.Ltyrian_Tag__f_children;
    var this$11 = $n(x$1$1);
    var x97 = this$11.Ltyrian_Tag__f_key;
    if ((x94 === "a")) {
      if ($p_Ltyrian_runtime_Rendering$__interceptHref__sci_List__Z(this, x95)) {
        var data$2 = $p_Ltyrian_runtime_Rendering$__buildNodeData__sci_List__F1__s_Option__Lsnabbdom_VNodeData(this, x95, onMsg, x97);
        var this$13 = $n(x96);
        if ((this$13.knownSize__I() >= 0)) {
          var len = this$13.knownSize__I();
          var destination = new ($d_Ltyrian_Elem.getArrayOf().constr)(len);
          $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$13, destination, 0, 2147483647);
          var xs = destination;
        } else {
          var capacity = 0;
          var jsElems = null;
          capacity = 0;
          jsElems = [];
          var it = this$13.iterator__sc_Iterator();
          while ($n(it).hasNext__Z()) {
            var elem = $n(it).next__O();
            var unboxedElem = ((elem === null) ? null : elem);
            jsElems.push(unboxedElem);
          }
          var xs = new ($d_Ltyrian_Elem.getArrayOf().constr)(jsElems);
        }
        var f = ((x$1$2) => {
          var x$1$3 = $as_Ltyrian_Elem(x$1$2);
          if ((x$1$3 === $m_Ltyrian_Empty$())) {
            return $m_Lsnabbdom_VNode$().empty__Lsnabbdom_VNode();
          }
          if ((x$1$3 instanceof $c_Ltyrian_Text)) {
            var t = $as_Ltyrian_Text(x$1$3);
            return $m_Lsnabbdom_VNode$().text__T__Lsnabbdom_VNode($n(t).Ltyrian_Text__f_value);
          }
          if ($is_Ltyrian_Html(x$1$3)) {
            var subHtml = $as_Ltyrian_Html(x$1$3);
            return $m_Ltyrian_runtime_Rendering$().toVNode__Ltyrian_Html__F1__F1__Lsnabbdom_VNode(subHtml, onMsg, router);
          }
          throw new $c_s_MatchError(x$1$3);
        });
        var len$1 = $n(xs).u.length;
        var ys = new ($d_Lsnabbdom_VNode.getArrayOf().constr)(len$1);
        if ((len$1 > 0)) {
          var i = 0;
          if ((xs !== null)) {
            while ((i < len$1)) {
              var $x_1 = i;
              var arg1 = $n(xs).get(i);
              ys.set($x_1, f(arg1));
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_I)) {
            var x3 = $asArrayOf_I(xs, 1);
            while ((i < len$1)) {
              var $x_2 = i;
              var arg1$1 = $n(x3).get(i);
              ys.set($x_2, f(arg1$1));
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_D)) {
            var x4 = $asArrayOf_D(xs, 1);
            while ((i < len$1)) {
              var $x_3 = i;
              var arg1$2 = $n(x4).get(i);
              ys.set($x_3, f(arg1$2));
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_J)) {
            var x5 = $asArrayOf_J(xs, 1);
            while ((i < len$1)) {
              var $x_4 = i;
              var t$1 = $n(x5).get(i);
              var lo = t$1.RTLong__f_lo;
              var hi = t$1.RTLong__f_hi;
              ys.set($x_4, f(new $c_RTLong(lo, hi)));
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_F)) {
            var x6 = $asArrayOf_F(xs, 1);
            while ((i < len$1)) {
              var $x_5 = i;
              var arg1$3 = $n(x6).get(i);
              ys.set($x_5, f(arg1$3));
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_C)) {
            var x7 = $asArrayOf_C(xs, 1);
            while ((i < len$1)) {
              var $x_6 = i;
              var arg1$4 = $n(x7).get(i);
              ys.set($x_6, f($bC(arg1$4)));
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_B)) {
            var x8 = $asArrayOf_B(xs, 1);
            while ((i < len$1)) {
              var $x_7 = i;
              var arg1$5 = $n(x8).get(i);
              ys.set($x_7, f(arg1$5));
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_S)) {
            var x9 = $asArrayOf_S(xs, 1);
            while ((i < len$1)) {
              var $x_8 = i;
              var arg1$6 = $n(x9).get(i);
              ys.set($x_8, f(arg1$6));
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_Z)) {
            var x10 = $asArrayOf_Z(xs, 1);
            while ((i < len$1)) {
              var $x_9 = i;
              var arg1$7 = $n(x10).get(i);
              ys.set($x_9, f(arg1$7));
              i = ((1 + i) | 0);
            }
          } else {
            throw new $c_s_MatchError(xs);
          }
        }
        var $x_10 = $m_Lsnabbdom_h$();
        var this$19 = $n($n(data$2).Lsnabbdom_VNodeData__f_on);
        var kv = $p_Ltyrian_runtime_Rendering$__onClickPreventDefault__sci_List__F1__F1__T2(this, x95, onMsg, router);
        var on$2 = $as_sci_Map(this$19.updated__O__O__sci_MapOps($n(kv)._1__O(), $n(kv)._2__O()));
        var this$20 = $n(data$2);
        var props$2 = this$20.Lsnabbdom_VNodeData__f_props;
        var this$21 = $n(data$2);
        var attrs$2$2 = this$21.Lsnabbdom_VNodeData__f_attrs;
        var this$22 = $n(data$2);
        var classes$2 = this$22.Lsnabbdom_VNodeData__f_classes;
        var this$23 = $n(data$2);
        var style$2 = this$23.Lsnabbdom_VNodeData__f_style;
        var this$24 = $n(data$2);
        var dataset$2 = this$24.Lsnabbdom_VNodeData__f_dataset;
        var this$25 = $n(data$2);
        var hook$2 = this$25.Lsnabbdom_VNodeData__f_hook;
        var this$26 = $n(data$2);
        var key$1 = this$26.Lsnabbdom_VNodeData__f_key;
        var this$27 = $n(data$2);
        var ns$2 = this$27.Lsnabbdom_VNodeData__f_ns;
        var this$28 = $n(data$2);
        var fn$2 = this$28.Lsnabbdom_VNodeData__f_fn;
        var this$29 = $n(data$2);
        var args$2 = this$29.Lsnabbdom_VNodeData__f_args;
        var this$30 = $n(data$2);
        var is$2 = this$30.Lsnabbdom_VNodeData__f_is;
        $n(data$2);
        return $n($x_10).apply__T__Lsnabbdom_VNodeData__ALsnabbdom_VNode__Lsnabbdom_VNode("a", new $c_Lsnabbdom_VNodeData(props$2, attrs$2$2, classes$2, style$2, dataset$2, on$2, hook$2, key$1, ns$2, fn$2, args$2, is$2), ys);
      }
    }
    var data$3 = $p_Ltyrian_runtime_Rendering$__buildNodeData__sci_List__F1__s_Option__Lsnabbdom_VNodeData(this, x95, onMsg, x97);
    var this$33 = $n(x96);
    if ((this$33.knownSize__I() >= 0)) {
      var len$2 = this$33.knownSize__I();
      var destination$1 = new ($d_Ltyrian_Elem.getArrayOf().constr)(len$2);
      $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$33, destination$1, 0, 2147483647);
      var xs$1 = destination$1;
    } else {
      var capacity$1 = 0;
      var jsElems$1 = null;
      capacity$1 = 0;
      jsElems$1 = [];
      var it$1 = this$33.iterator__sc_Iterator();
      while ($n(it$1).hasNext__Z()) {
        var elem$1 = $n(it$1).next__O();
        var unboxedElem$1 = ((elem$1 === null) ? null : elem$1);
        jsElems$1.push(unboxedElem$1);
      }
      var xs$1 = new ($d_Ltyrian_Elem.getArrayOf().constr)(jsElems$1);
    }
    var f$1 = ((x$1$2$1) => {
      var x$1$4 = $as_Ltyrian_Elem(x$1$2$1);
      if ((x$1$4 === $m_Ltyrian_Empty$())) {
        return $m_Lsnabbdom_VNode$().empty__Lsnabbdom_VNode();
      }
      if ((x$1$4 instanceof $c_Ltyrian_Text)) {
        var t$2 = $as_Ltyrian_Text(x$1$4);
        return $m_Lsnabbdom_VNode$().text__T__Lsnabbdom_VNode($n(t$2).Ltyrian_Text__f_value);
      }
      if ($is_Ltyrian_Html(x$1$4)) {
        var subHtml$1 = $as_Ltyrian_Html(x$1$4);
        return $m_Ltyrian_runtime_Rendering$().toVNode__Ltyrian_Html__F1__F1__Lsnabbdom_VNode(subHtml$1, onMsg, router);
      }
      throw new $c_s_MatchError(x$1$4);
    });
    var len$3 = $n(xs$1).u.length;
    var ys$1 = new ($d_Lsnabbdom_VNode.getArrayOf().constr)(len$3);
    if ((len$3 > 0)) {
      var i$1 = 0;
      if ((xs$1 !== null)) {
        while ((i$1 < len$3)) {
          var $x_11 = i$1;
          var arg1$8 = $n(xs$1).get(i$1);
          ys$1.set($x_11, f$1(arg1$8));
          i$1 = ((1 + i$1) | 0);
        }
      } else if ((xs$1 instanceof $ac_I)) {
        var x3$1 = $asArrayOf_I(xs$1, 1);
        while ((i$1 < len$3)) {
          var $x_12 = i$1;
          var arg1$9 = $n(x3$1).get(i$1);
          ys$1.set($x_12, f$1(arg1$9));
          i$1 = ((1 + i$1) | 0);
        }
      } else if ((xs$1 instanceof $ac_D)) {
        var x4$1 = $asArrayOf_D(xs$1, 1);
        while ((i$1 < len$3)) {
          var $x_13 = i$1;
          var arg1$10 = $n(x4$1).get(i$1);
          ys$1.set($x_13, f$1(arg1$10));
          i$1 = ((1 + i$1) | 0);
        }
      } else if ((xs$1 instanceof $ac_J)) {
        var x5$1 = $asArrayOf_J(xs$1, 1);
        while ((i$1 < len$3)) {
          var $x_14 = i$1;
          var t$3 = $n(x5$1).get(i$1);
          var lo$1 = t$3.RTLong__f_lo;
          var hi$1 = t$3.RTLong__f_hi;
          ys$1.set($x_14, f$1(new $c_RTLong(lo$1, hi$1)));
          i$1 = ((1 + i$1) | 0);
        }
      } else if ((xs$1 instanceof $ac_F)) {
        var x6$1 = $asArrayOf_F(xs$1, 1);
        while ((i$1 < len$3)) {
          var $x_15 = i$1;
          var arg1$11 = $n(x6$1).get(i$1);
          ys$1.set($x_15, f$1(arg1$11));
          i$1 = ((1 + i$1) | 0);
        }
      } else if ((xs$1 instanceof $ac_C)) {
        var x7$1 = $asArrayOf_C(xs$1, 1);
        while ((i$1 < len$3)) {
          var $x_16 = i$1;
          var arg1$12 = $n(x7$1).get(i$1);
          ys$1.set($x_16, f$1($bC(arg1$12)));
          i$1 = ((1 + i$1) | 0);
        }
      } else if ((xs$1 instanceof $ac_B)) {
        var x8$1 = $asArrayOf_B(xs$1, 1);
        while ((i$1 < len$3)) {
          var $x_17 = i$1;
          var arg1$13 = $n(x8$1).get(i$1);
          ys$1.set($x_17, f$1(arg1$13));
          i$1 = ((1 + i$1) | 0);
        }
      } else if ((xs$1 instanceof $ac_S)) {
        var x9$1 = $asArrayOf_S(xs$1, 1);
        while ((i$1 < len$3)) {
          var $x_18 = i$1;
          var arg1$14 = $n(x9$1).get(i$1);
          ys$1.set($x_18, f$1(arg1$14));
          i$1 = ((1 + i$1) | 0);
        }
      } else if ((xs$1 instanceof $ac_Z)) {
        var x10$1 = $asArrayOf_Z(xs$1, 1);
        while ((i$1 < len$3)) {
          var $x_19 = i$1;
          var arg1$15 = $n(x10$1).get(i$1);
          ys$1.set($x_19, f$1(arg1$15));
          i$1 = ((1 + i$1) | 0);
        }
      } else {
        throw new $c_s_MatchError(xs$1);
      }
    }
    return $m_Lsnabbdom_h$().apply__T__Lsnabbdom_VNodeData__ALsnabbdom_VNode__Lsnabbdom_VNode(x94, data$3, ys$1);
  }
  throw new $c_s_MatchError(html);
});
$c_Ltyrian_runtime_Rendering$.prototype.render__O__O__F1__F1__F1__Lsnabbdom_VNode = (function(oldNode, model, view, onMsg, router) {
  if ($uZ((oldNode instanceof Element))) {
    return $n($p_Ltyrian_runtime_Rendering$__patch__Lsnabbdom_Patch(this)).apply__Lorg_scalajs_dom_Element__Lsnabbdom_VNode__Lsnabbdom_VNode(oldNode, $m_Ltyrian_runtime_Rendering$().toVNode__Ltyrian_Html__F1__F1__Lsnabbdom_VNode($as_Ltyrian_Html($n(view).apply__O__O(model)), onMsg, router));
  }
  if ((oldNode instanceof $c_Lsnabbdom_VNode)) {
    var vn = $as_Lsnabbdom_VNode(oldNode);
    return $n($p_Ltyrian_runtime_Rendering$__patch__Lsnabbdom_Patch(this)).apply__Lsnabbdom_VNode__Lsnabbdom_VNode__Lsnabbdom_VNode(vn, $m_Ltyrian_runtime_Rendering$().toVNode__Ltyrian_Html__F1__F1__Lsnabbdom_VNode($as_Ltyrian_Html($n(view).apply__O__O(model)), onMsg, router));
  }
  throw new $c_s_MatchError(oldNode);
});
var $d_Ltyrian_runtime_Rendering$ = new $TypeData().initClass($c_Ltyrian_runtime_Rendering$, "tyrian.runtime.Rendering$", ({
  Ltyrian_runtime_Rendering$: 1
}));
var $n_Ltyrian_runtime_Rendering$;
function $m_Ltyrian_runtime_Rendering$() {
  if ((!$n_Ltyrian_runtime_Rendering$)) {
    $n_Ltyrian_runtime_Rendering$ = new $c_Ltyrian_runtime_Rendering$();
  }
  return $n_Ltyrian_runtime_Rendering$;
}
function $p_Ltyrian_runtime_SubHelper$__rec$1__sci_List__sci_List__sci_List($thiz, remaining, acc) {
  var acc$tailLocal1 = acc;
  var remaining$tailLocal1 = remaining;
  while (true) {
    var x1 = remaining$tailLocal1;
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x1)) {
      return acc$tailLocal1;
    }
    if ((x1 instanceof $c_sci_$colon$colon)) {
      var x19 = $as_sci_$colon$colon(x1);
      var x20 = $as_Ltyrian_Sub($n(x19).sci_$colon$colon__f_head);
      var x21 = $n(x19).sci_$colon$colon__f_next;
      var x$3 = $m_Ltyrian_Sub$None$();
      if ((x$3 === x20)) {
        remaining$tailLocal1 = x21;
        continue;
      }
      if ((x20 instanceof $c_Ltyrian_Sub$Combine)) {
        var x$1 = $as_Ltyrian_Sub$Combine(x20);
        var this$2 = $n(x$1);
        var x17 = this$2.Ltyrian_Sub$Combine__f_sub1;
        var this$3 = $n(x$1);
        var x18 = this$3.Ltyrian_Sub$Combine__f_sub2;
        var this$4 = $n(x21);
        var this$5 = new $c_sci_$colon$colon(x18, this$4);
        remaining$tailLocal1 = new $c_sci_$colon$colon(x17, this$5);
        continue;
      }
      if ((x20 instanceof $c_Ltyrian_Sub$Batch)) {
        var x$1$1 = $as_Ltyrian_Sub$Batch(x20);
        var this$7 = $n(x$1$1);
        var x11 = this$7.Ltyrian_Sub$Batch__f_subs;
        var this$8 = $n(x11);
        remaining$tailLocal1 = this$8.appendedAll__sc_IterableOnce__sci_List(x21);
        continue;
      }
      if ((x20 instanceof $c_Ltyrian_Sub$Observe)) {
        var s = $as_Ltyrian_Sub$Observe(x20);
        var this$9 = $n(acc$tailLocal1);
        var acc$tailLocal1$tmp1 = new $c_sci_$colon$colon(s, this$9);
        remaining$tailLocal1 = x21;
        acc$tailLocal1 = acc$tailLocal1$tmp1;
        continue;
      }
    }
    throw new $c_s_MatchError(x1);
  }
}
/** @constructor */
function $c_Ltyrian_runtime_SubHelper$() {
}
$c_Ltyrian_runtime_SubHelper$.prototype = new $h_O();
$c_Ltyrian_runtime_SubHelper$.prototype.constructor = $c_Ltyrian_runtime_SubHelper$;
/** @constructor */
function $h_Ltyrian_runtime_SubHelper$() {
}
$h_Ltyrian_runtime_SubHelper$.prototype = $c_Ltyrian_runtime_SubHelper$.prototype;
$c_Ltyrian_runtime_SubHelper$.prototype.flatten__Ltyrian_Sub__sci_List = (function(sub) {
  return $p_Ltyrian_runtime_SubHelper$__rec$1__sci_List__sci_List__sci_List(this, new $c_sci_$colon$colon(sub, $m_sci_Nil$()), $m_sci_Nil$());
});
$c_Ltyrian_runtime_SubHelper$.prototype.aliveAndDead__sci_List__sci_List__Lcats_effect_kernel_GenConcurrent__T2 = (function(subs, current, evidence$1) {
  matchResult3: {
    var \u03b41$___1;
    var \u03b41$___2;
    var this$1 = $n(current);
    if (this$1.isEmpty__Z()) {
      var x25 = $m_sci_List$().sci_List$__f_scala$collection$immutable$List$$TupleOfNil;
    } else {
      var l = new $c_scm_ListBuffer();
      var r = new $c_scm_ListBuffer();
      var this$4 = $n(this$1.iterator__sc_Iterator());
      while (this$4.hasNext__Z()) {
        var arg1 = this$4.next__O();
        var x$1 = $as_T2(arg1);
        matchResult2: {
          var $x_1;
          if ((x$1 !== null)) {
            var id = $as_T($n(x$1)._1__O());
            var this$5 = $n(subs);
            var these = this$5;
            while ((!$n(these).isEmpty__Z())) {
              var arg1$1 = $n(these).head__O();
              var _$3 = $as_Ltyrian_Sub$Observe(arg1$1);
              if (($n(_$3).Ltyrian_Sub$Observe__f_id === id)) {
                var $x_1 = true;
                break matchResult2;
              }
              these = $as_sci_List($n(these).tail__O());
            }
            var $x_1 = false;
            break matchResult2;
          }
          throw new $c_s_MatchError(x$1);
        }
        var this$6 = $n(($x_1 ? l : r));
        this$6.addOne__O__scm_ListBuffer(arg1);
      }
      var x1 = new $c_T2(l.toList__sci_List(), r.toList__sci_List());
      matchEnd7$1: {
        var x25;
        var p2 = $as_sci_List(x1.T2__f__1);
        var x = $m_sci_Nil$();
        if (x.equals__O__Z(p2)) {
          var x25 = new $c_T2($m_sci_Nil$(), this$1);
          break matchEnd7$1;
        }
        var p4 = $as_sci_List(x1.T2__f__2);
        var x$3 = $m_sci_Nil$();
        if (x$3.equals__O__Z(p4)) {
          var x25 = new $c_T2(this$1, $m_sci_Nil$());
          break matchEnd7$1;
        }
        var x25 = x1;
      }
    }
    if ((x25 !== null)) {
      var a = $as_sci_List($n(x25)._1__O());
      var d = $as_sci_List($n(x25)._2__O());
      var \u03b41$___1 = a;
      var \u03b41$___2 = d;
      break matchResult3;
    }
    throw new $c_s_MatchError(x25);
  }
  var a$2 = $as_sci_List(\u03b41$___1);
  var d$2 = $as_sci_List(\u03b41$___2);
  var this$8 = $n(d$2);
  var f = ((_$4) => {
    var _$4$1 = $as_T2(_$4);
    return $n(_$4$1)._2__O();
  });
  if ((this$8 === $m_sci_Nil$())) {
    var _2 = $m_sci_Nil$();
  } else {
    var arg1$2 = this$8.head__O();
    var h = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$8.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$3 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$3), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O());
    }
    var _2 = h;
  }
  return new $c_T2(a$2, _2);
});
$c_Ltyrian_runtime_SubHelper$.prototype.findNewSubs__sci_List__sci_List__sci_List__Lcats_effect_kernel_GenConcurrent__sci_List = (function(subs, alive, inProgress, evidence$1) {
  var this$2 = $n(subs);
  var f = ((s) => {
    var s$1 = $as_Ltyrian_Sub$Observe(s);
    var this$1 = $n(alive);
    _return: {
      var these = this$1;
      while ((!$n(these).isEmpty__Z())) {
        var arg1 = $n(these).head__O();
        var _$6 = $as_T(arg1);
        if ((!(_$6 !== $n(s$1).Ltyrian_Sub$Observe__f_id))) {
          var $x_1 = false;
          break _return;
        }
        these = $as_sci_List($n(these).tail__O());
      }
      var $x_1 = true;
    }
    if ($x_1) {
      return (!$n(inProgress).contains__O__Z($n(s$1).Ltyrian_Sub$Observe__f_id));
    } else {
      return false;
    }
  });
  var l = this$2;
  block: {
    var result;
    while (true) {
      if ($n(l).isEmpty__Z()) {
        var result = $m_sci_Nil$();
        break;
      } else {
        var h = $n(l).head__O();
        var t = $as_sci_List($n(l).tail__O());
        if (($uZ(f(h)) === false)) {
          l = t;
          continue;
        }
        var start = l;
        var remaining = t;
        while (true) {
          if ($n(remaining).isEmpty__Z()) {
            var result = start;
            break block;
          } else {
            var x = $n(remaining).head__O();
            if (($uZ(f(x)) !== false)) {
              remaining = $as_sci_List($n(remaining).tail__O());
              continue;
            }
            var firstMiss = remaining;
            var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
            var toProcess = $as_sci_List($n(start).tail__O());
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
              $n(currentLast).sci_$colon$colon__f_next = newElem;
              currentLast = newElem;
              toProcess = $as_sci_List($n(toProcess).tail__O());
            }
            var next = $as_sci_List($n(firstMiss).tail__O());
            var nextToCopy = next;
            while ((!$n(next).isEmpty__Z())) {
              var head = $n(next).head__O();
              if (($uZ(f(head)) !== false)) {
                next = $as_sci_List($n(next).tail__O());
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                  $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = $as_sci_List($n(nextToCopy).tail__O());
                }
                nextToCopy = $as_sci_List($n(next).tail__O());
                next = $as_sci_List($n(next).tail__O());
              }
            }
            if ((!$n(nextToCopy).isEmpty__Z())) {
              $n(currentLast).sci_$colon$colon__f_next = nextToCopy;
            }
            var result = newHead;
            break block;
          }
        }
      }
    }
  }
  return result;
});
$c_Ltyrian_runtime_SubHelper$.prototype.runObserve__Ltyrian_Sub$Observe__F1__Lcats_effect_kernel_GenConcurrent__O = (function(sub, callback, F) {
  var this$6 = $m_Lcats_effect_syntax_package$all$();
  var wrapped = $n($m_Lcats_effect_kernel_Resource$().makeFull__F1__F1__Lcats_Functor__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var $x_3 = $n(poll$1);
    var target = $n(sub).Ltyrian_Sub$Observe__f_observable;
    var this$3 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F);
    var f = new $c_sjsr_AnonFunction1(((run) => {
      var run$1 = $as_F1(run);
      return $n(run$1).apply__O__O(new $c_sjsr_AnonFunction1(((result) => {
        var result$1 = $as_s_util_Either(result);
        var $x_2 = $n(callback);
        var this$2 = $n(result$1);
        if ((this$2 instanceof $c_s_util_Right)) {
          var x2 = $as_s_util_Right(this$2);
          var b = $n(x2).s_util_Right__f_value;
          var $x_1 = new $c_s_util_Right($as_s_Option($n($n(sub).Ltyrian_Sub$Observe__f_toMsg).apply__O__O(b)));
        } else {
          var $x_1 = this$2;
        }
        $n($x_2).apply__O__O($x_1);
      })));
    }));
    return $n($x_3).apply__O__O($n(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f));
  })), new $c_sjsr_AnonFunction1(((_$9) => {
    var _$9$1 = $as_s_Option(_$9);
    var this$4 = $n(_$9$1);
    if (this$4.isEmpty__Z()) {
      var this$5 = $n(F);
      return this$5.pure__O__O((void 0));
    } else {
      return this$4.get__O();
    }
  })), F)).useForever__Lcats_effect_kernel_GenSpawn__O(F);
  var ev$1 = $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O(this$6, wrapped, F);
  var target$1 = $n(F).start__O__O(ev$1);
  var this$9 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, F);
  var f$1 = new $c_sjsr_AnonFunction1(((_$10) => {
    var _$10$1 = $as_Lcats_effect_kernel_Fiber(_$10);
    return $n(_$10$1).cancel__O();
  }));
  var target$2 = $n(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
  var this$11 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, F);
  var b$1 = $n(sub).Ltyrian_Sub$Observe__f_id;
  var this$12 = $n(this$11.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance);
  var fa = this$11.Lcats_Functor$ToFunctorOps$$anon$5__f_self;
  return $f_Lcats_Functor__tupleLeft__O__O__O(this$12, fa, b$1);
});
var $d_Ltyrian_runtime_SubHelper$ = new $TypeData().initClass($c_Ltyrian_runtime_SubHelper$, "tyrian.runtime.SubHelper$", ({
  Ltyrian_runtime_SubHelper$: 1
}));
var $n_Ltyrian_runtime_SubHelper$;
function $m_Ltyrian_runtime_SubHelper$() {
  if ((!$n_Ltyrian_runtime_SubHelper$)) {
    $n_Ltyrian_runtime_SubHelper$ = new $c_Ltyrian_runtime_SubHelper$();
  }
  return $n_Ltyrian_runtime_SubHelper$;
}
/** @constructor */
function $c_Ltyrian_runtime_TyrianRuntime$() {
}
$c_Ltyrian_runtime_TyrianRuntime$.prototype = new $h_O();
$c_Ltyrian_runtime_TyrianRuntime$.prototype.constructor = $c_Ltyrian_runtime_TyrianRuntime$;
/** @constructor */
function $h_Ltyrian_runtime_TyrianRuntime$() {
}
$h_Ltyrian_runtime_TyrianRuntime$.prototype = $c_Ltyrian_runtime_TyrianRuntime$.prototype;
$c_Ltyrian_runtime_TyrianRuntime$.prototype.apply__F1__Lorg_scalajs_dom_Element__O__Ltyrian_Cmd__F1__F1__F1__Lcats_effect_kernel_Async__O = (function(router, node, initModel, initCmd, update, view, subscriptions, F) {
  var this$1 = $m_Lcats_effect_std_Dispatcher$();
  return $n($p_Lcats_effect_std_Dispatcher$__impl__Z__Z__Z__Lcats_effect_kernel_Async__Lcats_effect_kernel_Resource(this$1, false, false, false, F)).use__F1__Lcats_effect_kernel_MonadCancel__O(new $c_sjsr_AnonFunction1(((dispatcher) => {
    var dispatcher$1 = $as_Lcats_effect_std_Dispatcher(dispatcher);
    var loop = new $c_sjsr_AnonFunction4(((model, currentSubs, msgQueue, renderer) => {
      var model$1 = $as_Lcats_effect_kernel_Ref(model);
      var currentSubs$1 = $as_Lcats_effect_std_AtomicCell(currentSubs);
      var msgQueue$1 = $as_Lcats_effect_std_Queue(msgQueue);
      var renderer$1 = $as_Lcats_effect_kernel_Ref(renderer);
      return $m_Ltyrian_runtime_TyrianRuntime$().mainLoop__Lcats_effect_std_Dispatcher__F1__Ltyrian_Cmd__F1__F1__F1__Lcats_effect_kernel_Ref__Lcats_effect_std_AtomicCell__Lcats_effect_std_Queue__Lcats_effect_kernel_Ref__Lcats_effect_kernel_Async__Lcats_effect_kernel_Clock__O(dispatcher$1, router, initCmd, update, view, subscriptions, model$1, currentSubs$1, msgQueue$1, renderer$1, F, F);
    }));
    var model$2 = $n(F).ref__O__O(initModel);
    var currentSubs$2 = $m_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$().of$extension__Z__O__Lcats_effect_kernel_GenConcurrent__O(true, $m_sci_Nil$(), F);
    var msgQueue$2 = $m_Lcats_effect_std_Queue$().unbounded__Lcats_effect_kernel_GenConcurrent__O(F);
    var renderer$2 = $m_Ltyrian_runtime_Renderer$().init__Lsnabbdom_VNode__Lcats_effect_kernel_Async__O($m_Lsnabbdom_toVNode$().apply__Lorg_scalajs_dom_Node__s_Option__Lsnabbdom_VNode(node, $m_s_None$()), F);
    var t4 = new $c_T4(model$2, currentSubs$2, msgQueue$2, renderer$2);
    return new $c_Lcats_syntax_Tuple4SemigroupalOps(t4).flatMapN__F4__Lcats_FlatMap__O(loop, F);
  })), F);
});
$c_Ltyrian_runtime_TyrianRuntime$.prototype.mainLoop__Lcats_effect_std_Dispatcher__F1__Ltyrian_Cmd__F1__F1__F1__Lcats_effect_kernel_Ref__Lcats_effect_std_AtomicCell__Lcats_effect_std_Queue__Lcats_effect_kernel_Ref__Lcats_effect_kernel_Async__Lcats_effect_kernel_Clock__O = (function(dispatcher, router, initCmd, update, view, subscriptions, model, currentSubs, msgQueue, renderer, F, clock) {
  var runCmd = new $c_sjsr_AnonFunction1(((cmd) => {
    var cmd$1 = $as_Ltyrian_Cmd(cmd);
    return $m_Ltyrian_runtime_TyrianRuntime$().runCommands__Lcats_effect_std_Queue__Ltyrian_Cmd__Lcats_effect_kernel_Async__O(msgQueue, cmd$1, F);
  }));
  var runSub = new $c_sjsr_AnonFunction1(((sub) => {
    var sub$1 = $as_Ltyrian_Sub(sub);
    return $m_Ltyrian_runtime_TyrianRuntime$().runSubscriptions__Lcats_effect_std_AtomicCell__Lcats_effect_std_Queue__Lcats_effect_std_Dispatcher__Ltyrian_Sub__Lcats_effect_kernel_Async__O(currentSubs, msgQueue, dispatcher, sub$1, F);
  }));
  var onMsg = this.postMsg__Lcats_effect_std_Dispatcher__Lcats_effect_std_Queue__F1(dispatcher, msgQueue);
  var target = $n(msgQueue).take__O();
  var this$14 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F);
  var f$3 = new $c_sjsr_AnonFunction1(((msg) => {
    var target$1 = $n(model).modify__F1__O(new $c_sjsr_AnonFunction1(((oldModel) => {
      matchResult1: {
        var \u03b41$___1;
        var \u03b41$___2;
        var x1 = $as_T2($n($as_F1($n(update).apply__O__O(oldModel))).apply__O__O(msg));
        if ((x1 !== null)) {
          var newModel = $n(x1)._1__O();
          var cmd$2 = $as_Ltyrian_Cmd($n(x1)._2__O());
          var \u03b41$___1 = newModel;
          var \u03b41$___2 = cmd$2;
          break matchResult1;
        }
        throw new $c_s_MatchError(x1);
      }
      var newModel$2 = \u03b41$___1;
      var cmd$2$1 = $as_Ltyrian_Cmd(\u03b41$___2);
      var sub$2 = $as_Ltyrian_Sub($n(subscriptions).apply__O__O(newModel$2));
      var _2 = new $c_T2(cmd$2$1, sub$2);
      return new $c_T2(newModel$2, _2);
    })));
    var this$13 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, F);
    var f$2 = new $c_sjsr_AnonFunction1(((cmdsAndSubs) => {
      var cmdsAndSubs$1 = $as_T2(cmdsAndSubs);
      var fa = runCmd.apply__O__O($n(cmdsAndSubs$1)._1__O());
      var fb = runSub.apply__O__O($n(cmdsAndSubs$1)._2__O());
      var this$8 = $n(F);
      var target$2 = this$8.productR__O__O__O(fa, fb);
      var this$12 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, F);
      var f$1 = new $c_sjsr_AnonFunction1(((x$1) => {
        $as_jl_Void(x$1);
        var target$3 = $m_Ltyrian_runtime_Renderer$().redraw__Lcats_effect_std_Dispatcher__Lcats_effect_kernel_Ref__Lcats_effect_kernel_Ref__F1__F1__F1__Lcats_effect_kernel_Async__Lcats_effect_kernel_Clock__O(dispatcher, renderer, model, view, onMsg, router, F, F);
        var this$11 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, F);
        var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
          $as_jl_Void(x$1$2);
        }));
        return $n(this$11.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$11.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
      }));
      return $n(this$12.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$12.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
    }));
    return $n(this$13.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$13.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
  }));
  var fa$1 = $n(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
  var this$17 = $n(F);
  var msgLoop = $f_Lcats_FlatMap__foreverM__O__O(this$17, fa$1);
  var this$18 = $m_Lcats_effect_syntax_package$all$();
  var ev$4 = $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O(this$18, msgLoop, F);
  var this$20 = $n(F);
  var $x_1 = $n($f_Lcats_effect_kernel_GenSpawn__background__O__Lcats_effect_kernel_Resource(this$20, ev$4));
  var fa$2 = runCmd.apply__O__O(initCmd);
  var fb$1 = $n(F).never__O();
  var this$23 = $n(F);
  return $n($x_1).surround__O__Lcats_effect_kernel_MonadCancel__O(this$23.productR__O__O__O(fa$2, fb$1), F);
});
$c_Ltyrian_runtime_TyrianRuntime$.prototype.runCommands__Lcats_effect_std_Queue__Ltyrian_Cmd__Lcats_effect_kernel_Async__O = (function(msgQueue, cmd, F) {
  var target = $m_Ltyrian_runtime_CmdHelper$().cmdToTaskList__Ltyrian_Cmd__Lcats_Applicative__sci_List(cmd, F);
  $m_Lcats_UnorderedFoldable$();
  var tc = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
  var this$15 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(target, tc);
  var f$3 = new $c_sjsr_AnonFunction1(((task) => {
    var this$10 = $m_Lcats_effect_syntax_package$all$();
    var f = new $c_sjsr_AnonFunction1(((_$4) => {
      $as_jl_Throwable(_$4);
      return $m_s_None$();
    }));
    var target$1 = $n(F).handleError__O__F1__O(task, f);
    var this$9 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, F);
    var f$2 = new $c_sjsr_AnonFunction1(((_$5) => {
      var _$5$1 = $as_s_Option(_$5);
      $m_Lcats_UnorderedFoldable$();
      var tc$1 = $as_Lcats_Traverse($m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption);
      var this$8 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(_$5$1, tc$1);
      var f$1 = new $c_sjsr_AnonFunction1(((_$6) => $n(msgQueue).offer__O__O(_$6)));
      return $n(this$8.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).traverse___O__F1__Lcats_Applicative__O(this$8.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, f$1, F);
    }));
    var wrapped = $n(this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
    var ev$7 = $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O(this$10, wrapped, F);
    var target$2 = $n(F).start__O__O(ev$7);
    var this$13 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, F);
    return $n(this$13.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$13.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
  }));
  var B = $m_Lcats_kernel_instances_unit_package$().Lcats_kernel_instances_unit_package$__f_catsKernelStdAlgebraForUnit;
  var this$16 = $n(this$15.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance);
  var fa = this$15.Lcats_Foldable$ToFoldableOps$$anon$6__f_self;
  return $f_Lcats_Foldable__foldMapM__O__F1__Lcats_Monad__Lcats_kernel_Monoid__O(this$16, fa, f$3, F, B);
});
$c_Ltyrian_runtime_TyrianRuntime$.prototype.runSubscriptions__Lcats_effect_std_AtomicCell__Lcats_effect_std_Queue__Lcats_effect_std_Dispatcher__Ltyrian_Sub__Lcats_effect_kernel_Async__O = (function(currentSubs, msgQueue, dispatcher, sub, F) {
  return $n(currentSubs).evalUpdate__F1__O(new $c_sjsr_AnonFunction1(((oldSubs) => {
    var oldSubs$1 = $as_sci_List(oldSubs);
    var allSubs = $m_Ltyrian_runtime_SubHelper$().flatten__Ltyrian_Sub__sci_List(sub);
    matchResult4: {
      var \u03b42$___1;
      var \u03b42$___2;
      var x6 = $m_Ltyrian_runtime_SubHelper$().aliveAndDead__sci_List__sci_List__Lcats_effect_kernel_GenConcurrent__T2(allSubs, oldSubs$1, F);
      if ((x6 !== null)) {
        var stillAlive = $as_sci_List($n(x6)._1__O());
        var discarded = $as_sci_List($n(x6)._2__O());
        var \u03b42$___1 = stillAlive;
        var \u03b42$___2 = discarded;
        break matchResult4;
      }
      throw new $c_s_MatchError(x6);
    }
    var stillAlive$2 = $as_sci_List(\u03b42$___1);
    var discarded$2 = $as_sci_List(\u03b42$___2);
    var $x_2 = $m_Ltyrian_runtime_SubHelper$();
    var this$2 = $n(stillAlive$2);
    var f = ((_$8) => {
      var _$8$1 = $as_T2(_$8);
      return $as_T($n(_$8$1)._1__O());
    });
    if ((this$2 === $m_sci_Nil$())) {
      var $x_1 = $m_sci_Nil$();
    } else {
      var arg1 = this$2.head__O();
      var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(this$2.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var arg1$1 = $n(rest).head__O();
        var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O());
      }
      var $x_1 = h;
    }
    var target = $n($x_2).findNewSubs__sci_List__sci_List__sci_List__Lcats_effect_kernel_GenConcurrent__sci_List(allSubs, $x_1, $m_sci_Nil$(), F);
    $m_Lcats_UnorderedFoldable$();
    var tc = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
    var this$14 = new $c_Lcats_Traverse$ToTraverseOps$$anon$3(target, tc);
    var f$2 = new $c_sjsr_AnonFunction1(((_$9) => {
      var _$9$1 = $as_Ltyrian_Sub$Observe(_$9);
      return $m_Ltyrian_runtime_SubHelper$().runObserve__Ltyrian_Sub$Observe__F1__Lcats_effect_kernel_GenConcurrent__O(_$9$1, new $c_sjsr_AnonFunction1(((result) => {
        var result$1 = $as_s_util_Either(result);
        var this$13 = $n(dispatcher);
        var $x_3 = $n($n(result$1).toOption__s_Option());
        var this$5 = $m_s_$less$colon$less$();
        var target$1 = $n($x_3).flatten__s_$less$colon$less__s_Option(this$5.s_$less$colon$less$__f_singleton);
        $m_Lcats_UnorderedFoldable$();
        var tc$1 = $as_Lcats_Traverse($m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption);
        var this$11 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(target$1, tc$1);
        var f$1 = new $c_sjsr_AnonFunction1(((_$10) => {
          var target$2 = $n(msgQueue).offer__O__O(_$10);
          var this$9 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, F);
          return $n(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
        }));
        var B = $m_Lcats_kernel_instances_unit_package$().Lcats_kernel_instances_unit_package$__f_catsKernelStdAlgebraForUnit;
        var this$12 = $n(this$11.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance);
        var fa = this$11.Lcats_Foldable$ToFoldableOps$$anon$6__f_self;
        var fa$1 = $f_Lcats_Foldable__foldMapM__O__F1__Lcats_Monad__Lcats_kernel_Monoid__O(this$12, fa, f$1, F, B);
        $f_Lcats_effect_std_Dispatcher__unsafeRunAndForget__O__V(this$13, fa$1);
      })), F);
    }));
    var newSubs = $n(this$14.Lcats_Traverse$ToTraverseOps$$anon$3__f_typeClassInstance).traverse__O__F1__Lcats_Applicative__O(this$14.Lcats_Traverse$ToTraverseOps$$anon$3__f_self, f$2, F);
    $m_Lcats_UnorderedFoldable$();
    var tc$2 = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
    var this$22 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(discarded$2, tc$2);
    var f$3 = new $c_sjsr_AnonFunction1(((_$11) => {
      var this$17 = $m_Lcats_effect_syntax_package$all$();
      var ev$8 = $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O(this$17, _$11, F);
      var target$3 = $n(F).start__O__O(ev$8);
      var this$20 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, F);
      return $n(this$20.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$20.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
    }));
    var B$1 = $m_Lcats_kernel_instances_unit_package$().Lcats_kernel_instances_unit_package$__f_catsKernelStdAlgebraForUnit;
    var this$23 = $n(this$22.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance);
    var fa$2 = this$22.Lcats_Foldable$ToFoldableOps$$anon$6__f_self;
    var fa$3 = $f_Lcats_Foldable__foldMapM__O__F1__Lcats_Monad__Lcats_kernel_Monoid__O(this$23, fa$2, f$3, F, B$1);
    var this$27 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(newSubs, F);
    var f$4 = new $c_sjsr_AnonFunction1(((_$12) => {
      var _$12$1 = $as_sci_List(_$12);
      var this$26 = $n(_$12$1);
      return this$26.appendedAll__sc_IterableOnce__sci_List(stillAlive$2);
    }));
    var fb = $n(this$27.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$27.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$4);
    var this$29 = $n(F);
    return this$29.productR__O__O__O(fa$3, fb);
  })));
});
$c_Ltyrian_runtime_TyrianRuntime$.prototype.postMsg__Lcats_effect_std_Dispatcher__Lcats_effect_std_Queue__F1 = (function(dispatcher, msgQueue) {
  return new $c_sjsr_AnonFunction1(((msg) => {
    var this$1 = $n(dispatcher);
    var fa = $n(msgQueue).offer__O__O(msg);
    $f_Lcats_effect_std_Dispatcher__unsafeRunAndForget__O__V(this$1, fa);
  }));
});
var $d_Ltyrian_runtime_TyrianRuntime$ = new $TypeData().initClass($c_Ltyrian_runtime_TyrianRuntime$, "tyrian.runtime.TyrianRuntime$", ({
  Ltyrian_runtime_TyrianRuntime$: 1
}));
var $n_Ltyrian_runtime_TyrianRuntime$;
function $m_Ltyrian_runtime_TyrianRuntime$() {
  if ((!$n_Ltyrian_runtime_TyrianRuntime$)) {
    $n_Ltyrian_runtime_TyrianRuntime$ = new $c_Ltyrian_runtime_TyrianRuntime$();
  }
  return $n_Ltyrian_runtime_TyrianRuntime$;
}
function $f_Lcats_Bifoldable__bifoldMap__O__F1__F1__Lcats_kernel_Monoid__O($thiz, fab, f, g, C) {
  return $thiz.bifoldLeft__O__O__F2__F2__O(fab, $n(C).empty__O(), new $c_sjsr_AnonFunction2(((c, a) => $n(C).combine__O__O__O(c, $n(f).apply__O__O(a)))), new $c_sjsr_AnonFunction2(((c$2, b) => $n(C).combine__O__O__O(c$2, $n(g).apply__O__O(b)))));
}
/** @constructor */
function $c_Lcats_Bifunctor$() {
}
$c_Lcats_Bifunctor$.prototype = new $h_O();
$c_Lcats_Bifunctor$.prototype.constructor = $c_Lcats_Bifunctor$;
/** @constructor */
function $h_Lcats_Bifunctor$() {
}
$h_Lcats_Bifunctor$.prototype = $c_Lcats_Bifunctor$.prototype;
var $d_Lcats_Bifunctor$ = new $TypeData().initClass($c_Lcats_Bifunctor$, "cats.Bifunctor$", ({
  Lcats_Bifunctor$: 1,
  Lcats_instances_NTupleBifunctorInstances: 1
}));
var $n_Lcats_Bifunctor$;
function $m_Lcats_Bifunctor$() {
  if ((!$n_Lcats_Bifunctor$)) {
    $n_Lcats_Bifunctor$ = new $c_Lcats_Bifunctor$();
  }
  return $n_Lcats_Bifunctor$;
}
/** @constructor */
function $c_Lcats_Eval() {
}
$c_Lcats_Eval.prototype = new $h_O();
$c_Lcats_Eval.prototype.constructor = $c_Lcats_Eval;
/** @constructor */
function $h_Lcats_Eval() {
}
$h_Lcats_Eval.prototype = $c_Lcats_Eval.prototype;
$c_Lcats_Eval.prototype.map__F1__Lcats_Eval = (function(f) {
  return this.flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((a) => {
    var value = $n(f).apply__O__O(a);
    return new $c_Lcats_Now(value);
  })));
});
$c_Lcats_Eval.prototype.flatMap__F1__Lcats_Eval = (function(f) {
  if ((this instanceof $c_Lcats_Eval$FlatMap)) {
    var c = $as_Lcats_Eval$FlatMap(this);
    return new $c_Lcats_Eval$$anon$1(c, f);
  } else if ((this instanceof $c_Lcats_Eval$Defer)) {
    var c$2 = $as_Lcats_Eval$Defer(this);
    return new $c_Lcats_Eval$$anon$3(c$2, f);
  } else {
    return new $c_Lcats_Eval$$anon$4(f, this);
  }
});
function $as_Lcats_Eval(obj) {
  return (((obj instanceof $c_Lcats_Eval) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval"));
}
function $isArrayOf_Lcats_Eval(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval)));
}
function $asArrayOf_Lcats_Eval(obj, depth) {
  return (($isArrayOf_Lcats_Eval(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval;", depth));
}
/** @constructor */
function $c_Lcats_EvalInstances0() {
}
$c_Lcats_EvalInstances0.prototype = new $h_Lcats_EvalInstances1();
$c_Lcats_EvalInstances0.prototype.constructor = $c_Lcats_EvalInstances0;
/** @constructor */
function $h_Lcats_EvalInstances0() {
}
$h_Lcats_EvalInstances0.prototype = $c_Lcats_EvalInstances0.prototype;
/** @constructor */
function $c_Lcats_Foldable$Source$$anon$3() {
}
$c_Lcats_Foldable$Source$$anon$3.prototype = new $h_Lcats_Foldable$Source();
$c_Lcats_Foldable$Source$$anon$3.prototype.constructor = $c_Lcats_Foldable$Source$$anon$3;
/** @constructor */
function $h_Lcats_Foldable$Source$$anon$3() {
}
$h_Lcats_Foldable$Source$$anon$3.prototype = $c_Lcats_Foldable$Source$$anon$3.prototype;
$c_Lcats_Foldable$Source$$anon$3.prototype.uncons__s_Option = (function() {
  return $m_s_None$();
});
var $d_Lcats_Foldable$Source$$anon$3 = new $TypeData().initClass($c_Lcats_Foldable$Source$$anon$3, "cats.Foldable$Source$$anon$3", ({
  Lcats_Foldable$Source$$anon$3: 1,
  Lcats_Foldable$Source: 1
}));
/** @constructor */
function $c_Lcats_Foldable$Source$$anon$4(a$5, src$10, outer) {
  this.Lcats_Foldable$Source$$anon$4__f_a$2 = null;
  this.Lcats_Foldable$Source$$anon$4__f_src$6 = null;
  this.Lcats_Foldable$Source$$anon$4__f_a$2 = a$5;
  this.Lcats_Foldable$Source$$anon$4__f_src$6 = src$10;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_Foldable$Source$$anon$4.prototype = new $h_Lcats_Foldable$Source();
$c_Lcats_Foldable$Source$$anon$4.prototype.constructor = $c_Lcats_Foldable$Source$$anon$4;
/** @constructor */
function $h_Lcats_Foldable$Source$$anon$4() {
}
$h_Lcats_Foldable$Source$$anon$4.prototype = $c_Lcats_Foldable$Source$$anon$4.prototype;
$c_Lcats_Foldable$Source$$anon$4.prototype.uncons__s_Option = (function() {
  var _1 = this.Lcats_Foldable$Source$$anon$4__f_a$2;
  var _2 = this.Lcats_Foldable$Source$$anon$4__f_src$6;
  var value = new $c_T2(_1, _2);
  return new $c_s_Some(value);
});
var $d_Lcats_Foldable$Source$$anon$4 = new $TypeData().initClass($c_Lcats_Foldable$Source$$anon$4, "cats.Foldable$Source$$anon$4", ({
  Lcats_Foldable$Source$$anon$4: 1,
  Lcats_Foldable$Source: 1
}));
/** @constructor */
function $c_Lcats_ParallelArityFunctions2() {
}
$c_Lcats_ParallelArityFunctions2.prototype = new $h_O();
$c_Lcats_ParallelArityFunctions2.prototype.constructor = $c_Lcats_ParallelArityFunctions2;
/** @constructor */
function $h_Lcats_ParallelArityFunctions2() {
}
$h_Lcats_ParallelArityFunctions2.prototype = $c_Lcats_ParallelArityFunctions2.prototype;
function $is_Lcats_Semigroupal(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_Semigroupal)));
}
function $as_Lcats_Semigroupal(obj) {
  return (($is_Lcats_Semigroupal(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Semigroupal"));
}
function $isArrayOf_Lcats_Semigroupal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Semigroupal)));
}
function $asArrayOf_Lcats_Semigroupal(obj, depth) {
  return (($isArrayOf_Lcats_Semigroupal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Semigroupal;", depth));
}
/** @constructor */
function $c_Lcats_Show$ToShowOps$$anon$3(target$1, tc$1) {
  this.Lcats_Show$ToShowOps$$anon$3__f_self = null;
  this.Lcats_Show$ToShowOps$$anon$3__f_typeClassInstance = null;
  this.Lcats_Show$ToShowOps$$anon$3__f_self = target$1;
  this.Lcats_Show$ToShowOps$$anon$3__f_typeClassInstance = tc$1;
}
$c_Lcats_Show$ToShowOps$$anon$3.prototype = new $h_O();
$c_Lcats_Show$ToShowOps$$anon$3.prototype.constructor = $c_Lcats_Show$ToShowOps$$anon$3;
/** @constructor */
function $h_Lcats_Show$ToShowOps$$anon$3() {
}
$h_Lcats_Show$ToShowOps$$anon$3.prototype = $c_Lcats_Show$ToShowOps$$anon$3.prototype;
var $d_Lcats_Show$ToShowOps$$anon$3 = new $TypeData().initClass($c_Lcats_Show$ToShowOps$$anon$3, "cats.Show$ToShowOps$$anon$3", ({
  Lcats_Show$ToShowOps$$anon$3: 1,
  Lcats_Show$Ops: 1
}));
function $f_Lcats_UnorderedFoldable__size__O__J($thiz, fa) {
  return $uJ($thiz.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O(fa, new $c_sjsr_AnonFunction1(((_$2) => new $c_RTLong(1, 0))), $m_Lcats_kernel_instances_long_package$().Lcats_kernel_instances_long_package$__f_catsKernelStdGroupForLong));
}
function $is_Lcats_UnorderedFoldable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_UnorderedFoldable)));
}
function $as_Lcats_UnorderedFoldable(obj) {
  return (($is_Lcats_UnorderedFoldable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.UnorderedFoldable"));
}
function $isArrayOf_Lcats_UnorderedFoldable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_UnorderedFoldable)));
}
function $asArrayOf_Lcats_UnorderedFoldable(obj, depth) {
  return (($isArrayOf_Lcats_UnorderedFoldable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.UnorderedFoldable;", depth));
}
function $is_Lcats_arrow_FunctionK(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_arrow_FunctionK)));
}
function $as_Lcats_arrow_FunctionK(obj) {
  return (($is_Lcats_arrow_FunctionK(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.arrow.FunctionK"));
}
function $isArrayOf_Lcats_arrow_FunctionK(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_arrow_FunctionK)));
}
function $asArrayOf_Lcats_arrow_FunctionK(obj, depth) {
  return (($isArrayOf_Lcats_arrow_FunctionK(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.arrow.FunctionK;", depth));
}
/** @constructor */
function $c_Lcats_arrow_FunctionKMacroMethods() {
}
$c_Lcats_arrow_FunctionKMacroMethods.prototype = new $h_O();
$c_Lcats_arrow_FunctionKMacroMethods.prototype.constructor = $c_Lcats_arrow_FunctionKMacroMethods;
/** @constructor */
function $h_Lcats_arrow_FunctionKMacroMethods() {
}
$h_Lcats_arrow_FunctionKMacroMethods.prototype = $c_Lcats_arrow_FunctionKMacroMethods.prototype;
function $ct_Lcats_data_AndThenInstances0__($thiz) {
  new $c_Lcats_data_AndThenInstances0$$anon$1();
  return $thiz;
}
/** @constructor */
function $c_Lcats_data_AndThenInstances0() {
}
$c_Lcats_data_AndThenInstances0.prototype = new $h_Lcats_data_AndThenInstances1();
$c_Lcats_data_AndThenInstances0.prototype.constructor = $c_Lcats_data_AndThenInstances0;
/** @constructor */
function $h_Lcats_data_AndThenInstances0() {
}
$h_Lcats_data_AndThenInstances0.prototype = $c_Lcats_data_AndThenInstances0.prototype;
function $ps_Lcats_data_Chain__loop$1__Lcats_data_Chain$NonEmpty__sci_List__Lcats_data_Chain__Lcats_data_Chain(h, tail, acc) {
  var acc$tailLocal1 = acc;
  var tail$tailLocal1 = tail;
  var h$tailLocal1 = h;
  while (true) {
    var x67 = h$tailLocal1;
    if ((x67 instanceof $c_Lcats_data_Chain$Append)) {
      var x$1 = $as_Lcats_data_Chain$Append(x67);
      var this$2 = $n(x$1);
      var x76 = this$2.Lcats_data_Chain$Append__f_leftNE;
      var this$3 = $n(x$1);
      var x77 = this$3.Lcats_data_Chain$Append__f_rightNE;
      var this$4 = $n(tail$tailLocal1);
      var tail$tailLocal1$tmp1 = new $c_sci_$colon$colon(x77, this$4);
      h$tailLocal1 = x76;
      tail$tailLocal1 = tail$tailLocal1$tmp1;
      continue;
    }
    if ((x67 instanceof $c_Lcats_data_Chain$Singleton)) {
      var x$1$1 = $as_Lcats_data_Chain$Singleton(x67);
      var this$6 = $n(x$1$1);
      var sing = $as_Lcats_data_Chain$Singleton(x67);
      var this$7 = $n(sing);
      var c = acc$tailLocal1;
      var nextAcc = $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this$7, c);
      var x59 = tail$tailLocal1;
      if ((x59 instanceof $c_sci_$colon$colon)) {
        var x60 = $as_sci_$colon$colon(x59);
        var x62 = $n(x60).sci_$colon$colon__f_next;
        var h1 = $as_Lcats_data_Chain$NonEmpty($n(x60).sci_$colon$colon__f_head);
        h$tailLocal1 = h1;
        tail$tailLocal1 = x62;
        acc$tailLocal1 = nextAcc;
        continue;
      }
      return nextAcc;
    }
    if ((x67 instanceof $c_Lcats_data_Chain$Wrap)) {
      var x$1$2 = $as_Lcats_data_Chain$Wrap(x67);
      var this$9 = $n(x$1$2);
      var x70 = this$9.Lcats_data_Chain$Wrap__f_seq;
      var seq = $as_sci_Seq($n(x70).reverse__O());
      var this$11 = new $c_Lcats_data_Chain$Wrap(seq);
      var c$1 = acc$tailLocal1;
      var nextAcc$2 = $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this$11, c$1);
      var x63 = tail$tailLocal1;
      if ((x63 instanceof $c_sci_$colon$colon)) {
        var x64 = $as_sci_$colon$colon(x63);
        var x66 = $n(x64).sci_$colon$colon__f_next;
        var h1$2 = $as_Lcats_data_Chain$NonEmpty($n(x64).sci_$colon$colon__f_head);
        h$tailLocal1 = h1$2;
        tail$tailLocal1 = x66;
        acc$tailLocal1 = nextAcc$2;
        continue;
      }
      return nextAcc$2;
    }
    throw new $c_s_MatchError(x67);
  }
}
function $ps_Lcats_data_Chain__loop$2__Lcats_data_Chain$NonEmpty__sci_List__J__J(head, tail, acc) {
  var lo = acc.RTLong__f_lo;
  var hi = acc.RTLong__f_hi;
  var acc$tailLocal3__lo = lo;
  var acc$tailLocal3__hi = hi;
  var tail$tailLocal2 = tail;
  var head$tailLocal1 = head;
  while (true) {
    var x128 = head$tailLocal1;
    if ((x128 instanceof $c_Lcats_data_Chain$Append)) {
      var x$1 = $as_Lcats_data_Chain$Append(x128);
      var this$2 = $n(x$1);
      var x137 = this$2.Lcats_data_Chain$Append__f_leftNE;
      var this$3 = $n(x$1);
      var x138 = this$3.Lcats_data_Chain$Append__f_rightNE;
      var this$4 = $n(tail$tailLocal2);
      var tail$tailLocal2$tmp1 = new $c_sci_$colon$colon(x138, this$4);
      head$tailLocal1 = x137;
      tail$tailLocal2 = tail$tailLocal2$tmp1;
      continue;
    }
    if ((x128 instanceof $c_Lcats_data_Chain$Singleton)) {
      var x$1$1 = $as_Lcats_data_Chain$Singleton(x128);
      var this$6 = $n(x$1$1);
      var b__lo = acc$tailLocal3__lo;
      var b__hi = acc$tailLocal3__hi;
      var bhi = b__hi;
      var lo$1 = ((1 + b__lo) | 0);
      var hi$1 = ((lo$1 === 0) ? ((1 + bhi) | 0) : bhi);
      var x120 = tail$tailLocal2;
      if ((x120 instanceof $c_sci_$colon$colon)) {
        var x121 = $as_sci_$colon$colon(x120);
        var x123 = $n(x121).sci_$colon$colon__f_next;
        var h1 = $as_Lcats_data_Chain$NonEmpty($n(x121).sci_$colon$colon__f_head);
        head$tailLocal1 = h1;
        tail$tailLocal2 = x123;
        var $x_1__lo = lo$1;
        var $x_1__hi = hi$1;
        acc$tailLocal3__lo = $x_1__lo;
        acc$tailLocal3__hi = $x_1__hi;
        continue;
      }
      return new $c_RTLong(lo$1, hi$1);
    }
    if ((x128 instanceof $c_Lcats_data_Chain$Wrap)) {
      var x$1$2 = $as_Lcats_data_Chain$Wrap(x128);
      var this$9 = $n(x$1$2);
      var x131 = this$9.Lcats_data_Chain$Wrap__f_seq;
      var this$11__lo = acc$tailLocal3__lo;
      var this$11__hi = acc$tailLocal3__hi;
      var value = $n(x131).length__I();
      var hi$2 = (value >> 31);
      var alo = this$11__lo;
      var ahi = this$11__hi;
      var lo$2 = ((alo + value) | 0);
      var hi$3 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + hi$2) | 0)) | 0) : ((ahi + hi$2) | 0));
      var x124 = tail$tailLocal2;
      if ((x124 instanceof $c_sci_$colon$colon)) {
        var x125 = $as_sci_$colon$colon(x124);
        var x127 = $n(x125).sci_$colon$colon__f_next;
        var h1$2 = $as_Lcats_data_Chain$NonEmpty($n(x125).sci_$colon$colon__f_head);
        head$tailLocal1 = h1$2;
        tail$tailLocal2 = x127;
        var $x_2__lo = lo$2;
        var $x_2__hi = hi$3;
        acc$tailLocal3__lo = $x_2__lo;
        acc$tailLocal3__hi = $x_2__hi;
        continue;
      }
      return new $c_RTLong(lo$2, hi$3);
    }
    throw new $c_s_MatchError(x128);
  }
}
/** @constructor */
function $c_Lcats_data_Chain() {
}
$c_Lcats_data_Chain.prototype = new $h_O();
$c_Lcats_data_Chain.prototype.constructor = $c_Lcats_data_Chain;
/** @constructor */
function $h_Lcats_data_Chain() {
}
$h_Lcats_data_Chain.prototype = $c_Lcats_data_Chain.prototype;
$c_Lcats_data_Chain.prototype.uncons__s_Option = (function() {
  if ((this instanceof $c_Lcats_data_Chain$NonEmpty)) {
    var non = $as_Lcats_data_Chain$NonEmpty(this);
    var c = non;
    var rights = null;
    var result = null;
    while ((result === null)) {
      var x3 = c;
      if ((x3 instanceof $c_Lcats_data_Chain$Singleton)) {
        var x$1 = $as_Lcats_data_Chain$Singleton(x3);
        var this$2 = $n(x$1);
        var x13 = this$2.Lcats_data_Chain$Singleton__f_a;
        var next = ((rights === null) ? $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil : rights);
        result = new $c_T2(x13, next);
        continue;
      }
      if ((x3 instanceof $c_Lcats_data_Chain$Append)) {
        var x$1$1 = $as_Lcats_data_Chain$Append(x3);
        var this$5 = $n(x$1$1);
        var x9 = this$5.Lcats_data_Chain$Append__f_leftNE;
        var this$6 = $n(x$1$1);
        var x10 = this$6.Lcats_data_Chain$Append__f_rightNE;
        if ((rights === null)) {
          rights = x10;
        } else {
          var rightNE = rights;
          rights = new $c_Lcats_data_Chain$Append(x10, rightNE);
        }
        c = x9;
        continue;
      }
      if ((x3 instanceof $c_Lcats_data_Chain$Wrap)) {
        var x$1$2 = $as_Lcats_data_Chain$Wrap(x3);
        var this$9 = $n(x$1$2);
        var x6 = this$9.Lcats_data_Chain$Wrap__f_seq;
        var this$10 = $m_Lcats_data_Chain$();
        var s = $as_sci_Seq($n(x6).tail__O());
        var tail = $f_Lcats_data_ChainCompanionCompat__fromSeq__sci_Seq__Lcats_data_Chain(this$10, s);
        if ((rights === null)) {
          var next$2 = tail;
        } else if ((tail instanceof $c_Lcats_data_Chain$NonEmpty)) {
          var non$2 = $as_Lcats_data_Chain$NonEmpty(tail);
          var rightNE$1 = rights;
          var next$2 = new $c_Lcats_data_Chain$Append(non$2, rightNE$1);
        } else {
          var next$2 = rights;
        }
        var _1 = $n(x6).head__O();
        result = new $c_T2(_1, next$2);
        continue;
      }
      throw new $c_s_MatchError(x3);
    }
    var value = result;
    return new $c_s_Some(value);
  } else {
    return $m_s_None$();
  }
});
$c_Lcats_data_Chain.prototype.initLast__s_Option = (function() {
  if ((this instanceof $c_Lcats_data_Chain$NonEmpty)) {
    var non = $as_Lcats_data_Chain$NonEmpty(this);
    var c = non;
    var lefts = null;
    var result = null;
    while ((result === null)) {
      var x18 = c;
      if ((x18 instanceof $c_Lcats_data_Chain$Singleton)) {
        var x$1 = $as_Lcats_data_Chain$Singleton(x18);
        var this$2 = $n(x$1);
        var x28 = this$2.Lcats_data_Chain$Singleton__f_a;
        var pre = ((lefts === null) ? $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil : lefts);
        result = new $c_T2(pre, x28);
        continue;
      }
      if ((x18 instanceof $c_Lcats_data_Chain$Append)) {
        var x$1$1 = $as_Lcats_data_Chain$Append(x18);
        var this$5 = $n(x$1$1);
        var x24 = this$5.Lcats_data_Chain$Append__f_leftNE;
        var this$6 = $n(x$1$1);
        var x25 = this$6.Lcats_data_Chain$Append__f_rightNE;
        if ((lefts === null)) {
          lefts = x24;
        } else {
          var leftNE = lefts;
          lefts = new $c_Lcats_data_Chain$Append(leftNE, x24);
        }
        c = x25;
        continue;
      }
      if ((x18 instanceof $c_Lcats_data_Chain$Wrap)) {
        var x$1$2 = $as_Lcats_data_Chain$Wrap(x18);
        var this$9 = $n(x$1$2);
        var x21 = this$9.Lcats_data_Chain$Wrap__f_seq;
        var this$10 = $m_Lcats_data_Chain$();
        var s = $as_sci_Seq($n(x21).init__O());
        var init = $f_Lcats_data_ChainCompanionCompat__fromSeq__sci_Seq__Lcats_data_Chain(this$10, s);
        if ((lefts === null)) {
          var pre$2 = init;
        } else if ((init instanceof $c_Lcats_data_Chain$NonEmpty)) {
          var non$2 = $as_Lcats_data_Chain$NonEmpty(init);
          var leftNE$1 = lefts;
          var pre$2 = new $c_Lcats_data_Chain$Append(leftNE$1, non$2);
        } else {
          var pre$2 = lefts;
        }
        var _2 = $n(x21).last__O();
        result = new $c_T2(pre$2, _2);
        continue;
      }
      throw new $c_s_MatchError(x18);
    }
    var value = result;
    return new $c_s_Some(value);
  } else {
    return $m_s_None$();
  }
});
$c_Lcats_data_Chain.prototype.isEmpty__Z = (function() {
  return (!(this instanceof $c_Lcats_data_Chain$NonEmpty));
});
$c_Lcats_data_Chain.prototype.prepend__O__Lcats_data_Chain = (function(a) {
  return $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(($m_Lcats_data_Chain$(), new $c_Lcats_data_Chain$Singleton(a)), this);
});
$c_Lcats_data_Chain.prototype.append__O__Lcats_data_Chain = (function(a) {
  return $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this, ($m_Lcats_data_Chain$(), new $c_Lcats_data_Chain$Singleton(a)));
});
$c_Lcats_data_Chain.prototype.map__F1__Lcats_data_Chain = (function(f) {
  if ((this instanceof $c_Lcats_data_Chain$Wrap)) {
    var x$1 = $as_Lcats_data_Chain$Wrap(this);
    var this$2 = $n(x$1);
    var x34 = this$2.Lcats_data_Chain$Wrap__f_seq;
    var seq = $as_sci_Seq($n(x34).map__F1__O(f));
    return new $c_Lcats_data_Chain$Wrap(seq);
  } else {
    var this$6 = $m_Lcats_data_Chain$();
    var this$4 = $n(this.iterator__sc_Iterator());
    var this$5 = new $c_sc_Iterator$$anon$9(this$4, f);
    var s = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$5);
    return $f_Lcats_data_ChainCompanionCompat__fromSeq__sci_Seq__Lcats_data_Chain(this$6, s);
  }
});
$c_Lcats_data_Chain.prototype.flatMap__F1__Lcats_data_Chain = (function(f) {
  var this$1 = $m_Lcats_data_Chain$();
  var result = this$1.Lcats_data_Chain$__f_nil;
  var iter = this.iterator__sc_Iterator();
  while ($n(iter).hasNext__Z()) {
    var this$2 = $n(result);
    var c = $as_Lcats_data_Chain($n(f).apply__O__O($n(iter).next__O()));
    result = $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this$2, c);
  }
  return result;
});
$c_Lcats_data_Chain.prototype.foldLeft__O__F2__O = (function(z, f) {
  var result = z;
  var iter = this.iterator__sc_Iterator();
  while ($n(iter).hasNext__Z()) {
    result = $n(f).apply__O__O__O(result, $n(iter).next__O());
  }
  return result;
});
$c_Lcats_data_Chain.prototype.collect__s_PartialFunction__Lcats_data_Chain = (function(pf) {
  var z = $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil;
  var result = z;
  var iter = this.iterator__sc_Iterator();
  while ($n(iter).hasNext__Z()) {
    var arg1 = result;
    var arg2 = $n(iter).next__O();
    var acc = $as_Lcats_data_Chain(arg1);
    var x = $n(pf).applyOrElse__O__F1__O(arg2, $m_Lcats_data_Chain$().Lcats_data_Chain$__f_cats$data$Chain$$$sentinel);
    if ((x !== $m_Lcats_data_Chain$().Lcats_data_Chain$__f_cats$data$Chain$$$sentinel)) {
      var this$1 = $n(acc);
      result = this$1.append__O__Lcats_data_Chain(x);
    } else {
      result = acc;
    }
  }
  return $as_Lcats_data_Chain(result);
});
$c_Lcats_data_Chain.prototype.find__F1__s_Option = (function(f) {
  var elem = $m_s_None$();
  var result = new $c_sr_ObjectRef(elem);
  var f$1 = ((a) => {
    var b = $uZ($n(f).apply__O__O(a));
    if (b) {
      var ev$7 = $m_s_Option$().apply__O__s_Option(a);
      result.sr_ObjectRef__f_elem = ev$7;
      ev$7 = null;
    }
    return b;
  });
  _return: {
    if ((this instanceof $c_Lcats_data_Chain$NonEmpty)) {
      var non = $as_Lcats_data_Chain$NonEmpty(this);
      var c = non;
      var rights = $m_sci_Nil$();
      while ((c !== null)) {
        var x91 = c;
        if ((x91 instanceof $c_Lcats_data_Chain$Singleton)) {
          var x$1 = $as_Lcats_data_Chain$Singleton(x91);
          var this$4 = $n(x$1);
          var x101 = this$4.Lcats_data_Chain$Singleton__f_a;
          var b$1 = $uZ(f$1(x101));
          if (b$1) {
            break;
          }
          if ($n(rights).isEmpty__Z()) {
            c = null;
          } else {
            var head = $as_Lcats_data_Chain$NonEmpty($n(rights).head__O());
            rights = $as_sci_List($n(rights).tail__O());
            c = head;
          }
          continue;
        }
        if ((x91 instanceof $c_Lcats_data_Chain$Append)) {
          var x$1$1 = $as_Lcats_data_Chain$Append(x91);
          var this$6 = $n(x$1$1);
          var x97 = this$6.Lcats_data_Chain$Append__f_leftNE;
          var this$7 = $n(x$1$1);
          var x98 = this$7.Lcats_data_Chain$Append__f_rightNE;
          var this$8 = $n(rights);
          rights = new $c_sci_$colon$colon(x98, this$8);
          c = x97;
          continue;
        }
        if ((x91 instanceof $c_Lcats_data_Chain$Wrap)) {
          var x$1$2 = $as_Lcats_data_Chain$Wrap(x91);
          var this$10 = $n(x$1$2);
          var x94 = this$10.Lcats_data_Chain$Wrap__f_seq;
          var iterator = $n(x94).iterator__sc_Iterator();
          while ($n(iterator).hasNext__Z()) {
            var arg1 = $n(iterator).next__O();
            var b$2 = $uZ(f$1(arg1));
            if (b$2) {
              break _return;
            }
          }
          if ($n(rights).isEmpty__Z()) {
            c = null;
          } else {
            var head$2 = $as_Lcats_data_Chain$NonEmpty($n(rights).head__O());
            rights = $as_sci_List($n(rights).tail__O());
            c = head$2;
          }
          continue;
        }
        throw new $c_s_MatchError(x91);
      }
    }
  }
  return $as_s_Option(result.sr_ObjectRef__f_elem);
});
$c_Lcats_data_Chain.prototype.reverse__Lcats_data_Chain = (function() {
  if ((this instanceof $c_Lcats_data_Chain$Append)) {
    var x$1 = $as_Lcats_data_Chain$Append(this);
    var this$2 = $n(x$1);
    var x84 = this$2.Lcats_data_Chain$Append__f_leftNE;
    var this$3 = $n(x$1);
    var x85 = this$3.Lcats_data_Chain$Append__f_rightNE;
    var this$4 = $m_sci_Nil$();
    return $ps_Lcats_data_Chain__loop$1__Lcats_data_Chain$NonEmpty__sci_List__Lcats_data_Chain__Lcats_data_Chain(x84, new $c_sci_$colon$colon(x85, this$4), $m_Lcats_data_Chain$Empty$());
  } else if ((this instanceof $c_Lcats_data_Chain$Wrap)) {
    var x$1$1 = $as_Lcats_data_Chain$Wrap(this);
    var this$6 = $n(x$1$1);
    var x81 = this$6.Lcats_data_Chain$Wrap__f_seq;
    var seq = $as_sci_Seq($n(x81).reverse__O());
    return new $c_Lcats_data_Chain$Wrap(seq);
  } else {
    return this;
  }
});
$c_Lcats_data_Chain.prototype.iterator__sc_Iterator = (function() {
  if ((this instanceof $c_Lcats_data_Chain$Wrap)) {
    var x$1 = $as_Lcats_data_Chain$Wrap(this);
    var this$2 = $n(x$1);
    var x111 = this$2.Lcats_data_Chain$Wrap__f_seq;
    return $n(x111).iterator__sc_Iterator();
  } else if ((this instanceof $c_Lcats_data_Chain$Singleton)) {
    var x$1$1 = $as_Lcats_data_Chain$Singleton(this);
    var this$4 = $n(x$1$1);
    var x108 = this$4.Lcats_data_Chain$Singleton__f_a;
    return new $c_sc_Iterator$$anon$20(x108);
  } else if ((this instanceof $c_Lcats_data_Chain$Append)) {
    var app = $as_Lcats_data_Chain$Append(this);
    return new $c_Lcats_data_Chain$ChainIterator(app);
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  }
});
$c_Lcats_data_Chain.prototype.length__J = (function() {
  if ((this instanceof $c_Lcats_data_Chain$NonEmpty)) {
    var ne = $as_Lcats_data_Chain$NonEmpty(this);
    return $ps_Lcats_data_Chain__loop$2__Lcats_data_Chain$NonEmpty__sci_List__J__J(ne, $m_sci_Nil$(), $L0);
  } else {
    return $L0;
  }
});
$c_Lcats_data_Chain.prototype.toList__sci_List = (function() {
  if ((this instanceof $c_Lcats_data_Chain$Wrap)) {
    var x$1 = $as_Lcats_data_Chain$Wrap(this);
    var this$2 = $n(x$1);
    var x169 = this$2.Lcats_data_Chain$Wrap__f_seq;
    return $n(x169).toList__sci_List();
  } else if ((this instanceof $c_Lcats_data_Chain$Singleton)) {
    var x$1$1 = $as_Lcats_data_Chain$Singleton(this);
    var this$4 = $n(x$1$1);
    var x166 = this$4.Lcats_data_Chain$Singleton__f_a;
    var this$5 = $m_sci_Nil$();
    return new $c_sci_$colon$colon(x166, this$5);
  } else if ((this instanceof $c_Lcats_data_Chain$Append)) {
    var app = $as_Lcats_data_Chain$Append(this);
    var this$6 = new $c_Lcats_data_Chain$ChainIterator(app);
    return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$6);
  } else {
    return $m_sci_Nil$();
  }
});
$c_Lcats_data_Chain.prototype.toVector__sci_Vector = (function() {
  if ((this instanceof $c_Lcats_data_Chain$Wrap)) {
    var x$1 = $as_Lcats_data_Chain$Wrap(this);
    var this$2 = $n(x$1);
    var x177 = this$2.Lcats_data_Chain$Wrap__f_seq;
    return $n(x177).toVector__sci_Vector();
  } else if ((this instanceof $c_Lcats_data_Chain$Singleton)) {
    var x$1$1 = $as_Lcats_data_Chain$Singleton(this);
    var this$4 = $n(x$1$1);
    var x174 = this$4.Lcats_data_Chain$Singleton__f_a;
    $m_sci_Vector$();
    var this$6 = $m_sci_Vector0$();
    return this$6.appended__O__sci_Vector(x174);
  } else if ((this instanceof $c_Lcats_data_Chain$Append)) {
    var app = $as_Lcats_data_Chain$Append(this);
    var this$7 = new $c_Lcats_data_Chain$ChainIterator(app);
    return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$7);
  } else {
    $m_sci_Vector$();
    return $m_sci_Vector0$();
  }
});
$c_Lcats_data_Chain.prototype.$eq$eq$eq__Lcats_data_Chain__Lcats_kernel_Eq__Z = (function(that, A) {
  if ((this === that)) {
    return true;
  } else {
    var iterX = this.iterator__sc_Iterator();
    var iterY = $n(that).iterator__sc_Iterator();
    while (($n(iterX).hasNext__Z() && $n(iterY).hasNext__Z())) {
      if ((!$n(A).eqv__O__O__Z($n(iterX).next__O(), $n(iterY).next__O()))) {
        return false;
      }
    }
    return ($n(iterX).hasNext__Z() === $n(iterY).hasNext__Z());
  }
});
$c_Lcats_data_Chain.prototype.show__Lcats_Show__T = (function(AA) {
  var builder = $ct_scm_StringBuilder__T__(new $c_scm_StringBuilder(), "Chain(");
  var first = new $c_sr_BooleanRef(true);
  var f = ((a) => {
    if (first.sr_BooleanRef__f_elem) {
      var s = $n(AA).show__O__T(a);
      builder.addAll__T__scm_StringBuilder(s);
      var ev$14 = false;
      first.sr_BooleanRef__f_elem = ev$14;
    } else {
      var s$1 = (", " + $n(AA).show__O__T(a));
      builder.addAll__T__scm_StringBuilder(s$1);
    }
    return false;
  });
  _return: {
    if ((this instanceof $c_Lcats_data_Chain$NonEmpty)) {
      var non = $as_Lcats_data_Chain$NonEmpty(this);
      var c = non;
      var rights = $m_sci_Nil$();
      while ((c !== null)) {
        var x91 = c;
        if ((x91 instanceof $c_Lcats_data_Chain$Singleton)) {
          var x$1 = $as_Lcats_data_Chain$Singleton(x91);
          var this$3 = $n(x$1);
          var x101 = this$3.Lcats_data_Chain$Singleton__f_a;
          var b = $uZ(f(x101));
          if (b) {
            break;
          }
          if ($n(rights).isEmpty__Z()) {
            c = null;
          } else {
            var head = $as_Lcats_data_Chain$NonEmpty($n(rights).head__O());
            rights = $as_sci_List($n(rights).tail__O());
            c = head;
          }
          continue;
        }
        if ((x91 instanceof $c_Lcats_data_Chain$Append)) {
          var x$1$1 = $as_Lcats_data_Chain$Append(x91);
          var this$5 = $n(x$1$1);
          var x97 = this$5.Lcats_data_Chain$Append__f_leftNE;
          var this$6 = $n(x$1$1);
          var x98 = this$6.Lcats_data_Chain$Append__f_rightNE;
          var this$7 = $n(rights);
          rights = new $c_sci_$colon$colon(x98, this$7);
          c = x97;
          continue;
        }
        if ((x91 instanceof $c_Lcats_data_Chain$Wrap)) {
          var x$1$2 = $as_Lcats_data_Chain$Wrap(x91);
          var this$9 = $n(x$1$2);
          var x94 = this$9.Lcats_data_Chain$Wrap__f_seq;
          var iterator = $n(x94).iterator__sc_Iterator();
          while ($n(iterator).hasNext__Z()) {
            var arg1 = $n(iterator).next__O();
            var b$2 = $uZ(f(arg1));
            if (b$2) {
              break _return;
            }
          }
          if ($n(rights).isEmpty__Z()) {
            c = null;
          } else {
            var head$2 = $as_Lcats_data_Chain$NonEmpty($n(rights).head__O());
            rights = $as_sci_List($n(rights).tail__O());
            c = head$2;
          }
          continue;
        }
        throw new $c_s_MatchError(x91);
      }
    }
  }
  builder.addOne__C__scm_StringBuilder(41);
  return $n(builder.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_Lcats_data_Chain.prototype.toString__T = (function() {
  var this$1 = $m_Lcats_Show$();
  return this.show__Lcats_Show__T(new $c_Lcats_Show$$anon$5(this$1));
});
$c_Lcats_data_Chain.prototype.equals__O__Z = (function(o) {
  if ((o instanceof $c_Lcats_data_Chain)) {
    var thatChain = $as_Lcats_data_Chain(o);
    var this$1 = $n($m_Lcats_package$().Lcats_package$__f_Eq);
    return this.$eq$eq$eq__Lcats_data_Chain__Lcats_kernel_Eq__Z(thatChain, new $c_Lcats_kernel_Eq$$anon$6(this$1));
  } else {
    return false;
  }
});
$c_Lcats_data_Chain.prototype.hashCode__I = (function() {
  var this$1 = $n($m_Lcats_package$().Lcats_package$__f_Hash);
  var hashA = new $c_Lcats_kernel_Hash$$anon$3(this$1);
  return $m_Lcats_kernel_instances_StaticMethods$().orderedHash__sc_IterableOnce__Lcats_kernel_Hash__I(this.iterator__sc_Iterator(), hashA);
});
function $as_Lcats_data_Chain(obj) {
  return (((obj instanceof $c_Lcats_data_Chain) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Chain"));
}
function $isArrayOf_Lcats_data_Chain(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Chain)));
}
function $asArrayOf_Lcats_data_Chain(obj, depth) {
  return (($isArrayOf_Lcats_data_Chain(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Chain;", depth));
}
/** @constructor */
function $c_Lcats_data_ChainInstances2() {
}
$c_Lcats_data_ChainInstances2.prototype = new $h_Lcats_data_ChainInstances3();
$c_Lcats_data_ChainInstances2.prototype.constructor = $c_Lcats_data_ChainInstances2;
/** @constructor */
function $h_Lcats_data_ChainInstances2() {
}
$h_Lcats_data_ChainInstances2.prototype = $c_Lcats_data_ChainInstances2.prototype;
/** @constructor */
function $c_Lcats_data_KleisliInstances8() {
}
$c_Lcats_data_KleisliInstances8.prototype = new $h_Lcats_data_KleisliInstances9();
$c_Lcats_data_KleisliInstances8.prototype.constructor = $c_Lcats_data_KleisliInstances8;
/** @constructor */
function $h_Lcats_data_KleisliInstances8() {
}
$h_Lcats_data_KleisliInstances8.prototype = $c_Lcats_data_KleisliInstances8.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyChainInstances2() {
}
$c_Lcats_data_NonEmptyChainInstances2.prototype = new $h_Lcats_data_NonEmptyChainInstances3();
$c_Lcats_data_NonEmptyChainInstances2.prototype.constructor = $c_Lcats_data_NonEmptyChainInstances2;
/** @constructor */
function $h_Lcats_data_NonEmptyChainInstances2() {
}
$h_Lcats_data_NonEmptyChainInstances2.prototype = $c_Lcats_data_NonEmptyChainInstances2.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyListInstances0() {
}
$c_Lcats_data_NonEmptyListInstances0.prototype = new $h_Lcats_data_NonEmptyListInstances1();
$c_Lcats_data_NonEmptyListInstances0.prototype.constructor = $c_Lcats_data_NonEmptyListInstances0;
/** @constructor */
function $h_Lcats_data_NonEmptyListInstances0() {
}
$h_Lcats_data_NonEmptyListInstances0.prototype = $c_Lcats_data_NonEmptyListInstances0.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptySetInstances0() {
}
$c_Lcats_data_NonEmptySetInstances0.prototype = new $h_Lcats_data_NonEmptySetInstances1();
$c_Lcats_data_NonEmptySetInstances0.prototype.constructor = $c_Lcats_data_NonEmptySetInstances0;
/** @constructor */
function $h_Lcats_data_NonEmptySetInstances0() {
}
$h_Lcats_data_NonEmptySetInstances0.prototype = $c_Lcats_data_NonEmptySetInstances0.prototype;
/** @constructor */
function $c_Lcats_data_ValidatedInstances1() {
}
$c_Lcats_data_ValidatedInstances1.prototype = new $h_Lcats_data_ValidatedInstances2();
$c_Lcats_data_ValidatedInstances1.prototype.constructor = $c_Lcats_data_ValidatedInstances1;
/** @constructor */
function $h_Lcats_data_ValidatedInstances1() {
}
$h_Lcats_data_ValidatedInstances1.prototype = $c_Lcats_data_ValidatedInstances1.prototype;
/** @constructor */
function $c_Lcats_data_package$() {
  this.Lcats_data_package$__f_NonEmptySet = null;
  this.Lcats_data_package$__f_NonEmptyChain = null;
  $n_Lcats_data_package$ = this;
  this.Lcats_data_package$__f_NonEmptySet = $m_Lcats_data_NonEmptySetImpl$();
  this.Lcats_data_package$__f_NonEmptyChain = $m_Lcats_data_NonEmptyChainImpl$();
  $m_Lcats_data_Kleisli$();
}
$c_Lcats_data_package$.prototype = new $h_Lcats_data_ScalaVersionSpecificPackage();
$c_Lcats_data_package$.prototype.constructor = $c_Lcats_data_package$;
/** @constructor */
function $h_Lcats_data_package$() {
}
$h_Lcats_data_package$.prototype = $c_Lcats_data_package$.prototype;
var $d_Lcats_data_package$ = new $TypeData().initClass($c_Lcats_data_package$, "cats.data.package$", ({
  Lcats_data_package$: 1,
  Lcats_data_ScalaVersionSpecificPackage: 1
}));
var $n_Lcats_data_package$;
function $m_Lcats_data_package$() {
  if ((!$n_Lcats_data_package$)) {
    $n_Lcats_data_package$ = new $c_Lcats_data_package$();
  }
  return $n_Lcats_data_package$;
}
function $p_Lcats_effect_CpuStarvationCheck$__mkWarning__s_concurrent_duration_Duration__s_concurrent_duration_FiniteDuration__T($thiz, threshold, when) {
  var x = (((("|" + $thiz.format__s_concurrent_duration_FiniteDuration__T(when)) + " [WARNING] Your app's responsiveness to a new asynchronous\n        | event (such as a new connection, an upstream response, or a timer) was in excess\n        | of ") + threshold) + ". Your CPU is probably starving. Consider increasing the\n        | granularity of your delays or adding more cedes. This may also be a sign that you\n        | are unintentionally running blocking I/O operations (such as File or InetAddress)\n        | without the blocking combinator.");
  return $f_T__replaceAll__T__T__T($n($m_sc_StringOps$().stripMargin$extension__T__C__T(x, 124)), "\n", "");
}
function $p_Lcats_effect_CpuStarvationCheck$__go$1__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_metrics_CpuStarvationMetrics__F1__s_concurrent_duration_Duration__s_concurrent_duration_FiniteDuration__Lcats_effect_IO($thiz, runtimeConfig$1, metrics$1, onCpuStarvationWarn$1, threshold$1, initial) {
  var this$1 = $m_Lcats_effect_IO$();
  var finiteDelay = $n(runtimeConfig$1).Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInterval;
  return $n(this$1.sleep__s_concurrent_duration_Duration__Lcats_effect_IO(finiteDelay)).$greater$greater__F0__Lcats_effect_IO(new $c_sjsr_AnonFunction0((() => ($m_Lcats_effect_IO$(), $m_Lcats_effect_IO$Monotonic$()).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((now) => {
    var now$1 = $as_s_concurrent_duration_FiniteDuration(now);
    var delta = $n(now$1).$minus__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration(initial);
    return $n($n(($n(metrics$1), $n(delta).$minus__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration($n(runtimeConfig$1).Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInterval), $m_Lcats_effect_IO$().Lcats_effect_IO$__f__unit)).$greater$greater__F0__Lcats_effect_IO(new $c_sjsr_AnonFunction0((() => ($m_Lcats_effect_IO$(), $m_Lcats_effect_IO$RealTime$()).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((fd) => {
      var fd$1 = $as_s_concurrent_duration_FiniteDuration(fd);
      var this$7 = $n(delta);
      var cond = $f_s_math_Ordered__$greater$eq__O__Z(this$7, threshold$1);
      var F = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO;
      var this$9 = $n(F);
      if (cond) {
        var clockDrift = $n(delta).$minus__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration($n(runtimeConfig$1).Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInterval);
        var starvationThreshold = $n(runtimeConfig$1).Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckThreshold;
        var starvationInterval = $n(runtimeConfig$1).Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInterval;
        var this$12 = $n($as_Lcats_effect_IO($n(onCpuStarvationWarn$1).apply__O__O(new $c_Lcats_effect_metrics_CpuStarvationWarningMetrics(fd$1, clockDrift, starvationThreshold, starvationInterval))));
        $n(metrics$1);
        var that = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__unit;
        var $x_1 = this$9.void__O__O(this$12.productR__Lcats_effect_IO__Lcats_effect_IO(that));
      } else {
        var $x_1 = this$9.pure__O__O((void 0));
      }
      return $as_Lcats_effect_IO($x_1);
    }))))))).$greater$greater__F0__Lcats_effect_IO(new $c_sjsr_AnonFunction0((() => $p_Lcats_effect_CpuStarvationCheck$__go$1__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_metrics_CpuStarvationMetrics__F1__s_concurrent_duration_Duration__s_concurrent_duration_FiniteDuration__Lcats_effect_IO($thiz, runtimeConfig$1, metrics$1, onCpuStarvationWarn$1, threshold$1, now$1))));
  }))))));
}
/** @constructor */
function $c_Lcats_effect_CpuStarvationCheck$() {
}
$c_Lcats_effect_CpuStarvationCheck$.prototype = new $h_Lcats_effect_CpuStarvationCheckPlatform();
$c_Lcats_effect_CpuStarvationCheck$.prototype.constructor = $c_Lcats_effect_CpuStarvationCheck$;
/** @constructor */
function $h_Lcats_effect_CpuStarvationCheck$() {
}
$h_Lcats_effect_CpuStarvationCheck$.prototype = $c_Lcats_effect_CpuStarvationCheck$.prototype;
$c_Lcats_effect_CpuStarvationCheck$.prototype.run__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_metrics_CpuStarvationMetrics__F1__Lcats_effect_IO = (function(runtimeConfig, metrics, onCpuStarvationWarn) {
  var threshold = $n($n(runtimeConfig).Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInterval).$times__D__s_concurrent_duration_Duration((1.0 + $n(runtimeConfig).Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckThreshold));
  return $n(($m_Lcats_effect_IO$(), $m_Lcats_effect_IO$Monotonic$()).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((_$1) => {
    var _$1$1 = $as_s_concurrent_duration_FiniteDuration(_$1);
    return $p_Lcats_effect_CpuStarvationCheck$__go$1__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_metrics_CpuStarvationMetrics__F1__s_concurrent_duration_Duration__s_concurrent_duration_FiniteDuration__Lcats_effect_IO(this, runtimeConfig, metrics, onCpuStarvationWarn, threshold, _$1$1);
  })))).delayBy__s_concurrent_duration_Duration__Lcats_effect_IO($n(runtimeConfig).Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInitialDelay);
});
$c_Lcats_effect_CpuStarvationCheck$.prototype.logWarning__Lcats_effect_metrics_CpuStarvationWarningMetrics__Lcats_effect_IO = (function(cpuStarvationWarningMetrics) {
  return $as_Lcats_effect_IO($n($m_Lcats_effect_std_Console$().make__Lcats_effect_kernel_Async__Lcats_effect_std_Console($m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO)).errorln__O__Lcats_Show__O($p_Lcats_effect_CpuStarvationCheck$__mkWarning__s_concurrent_duration_Duration__s_concurrent_duration_FiniteDuration__T(this, $n($n(cpuStarvationWarningMetrics).Lcats_effect_metrics_CpuStarvationWarningMetrics__f_starvationInterval).$times__D__s_concurrent_duration_Duration($n(cpuStarvationWarningMetrics).Lcats_effect_metrics_CpuStarvationWarningMetrics__f_starvationThreshold), $n(cpuStarvationWarningMetrics).Lcats_effect_metrics_CpuStarvationWarningMetrics__f_occurrenceTime), $m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString));
});
var $d_Lcats_effect_CpuStarvationCheck$ = new $TypeData().initClass($c_Lcats_effect_CpuStarvationCheck$, "cats.effect.CpuStarvationCheck$", ({
  Lcats_effect_CpuStarvationCheck$: 1,
  Lcats_effect_CpuStarvationCheckPlatform: 1
}));
var $n_Lcats_effect_CpuStarvationCheck$;
function $m_Lcats_effect_CpuStarvationCheck$() {
  if ((!$n_Lcats_effect_CpuStarvationCheck$)) {
    $n_Lcats_effect_CpuStarvationCheck$ = new $c_Lcats_effect_CpuStarvationCheck$();
  }
  return $n_Lcats_effect_CpuStarvationCheck$;
}
/** @constructor */
function $c_Lcats_effect_IO() {
}
$c_Lcats_effect_IO.prototype = new $h_Lcats_effect_IOPlatform();
$c_Lcats_effect_IO.prototype.constructor = $c_Lcats_effect_IO;
/** @constructor */
function $h_Lcats_effect_IO() {
}
$h_Lcats_effect_IO.prototype = $c_Lcats_effect_IO.prototype;
$c_Lcats_effect_IO.prototype.$greater$greater__F0__Lcats_effect_IO = (function(that) {
  return this.flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((_$1) => $as_Lcats_effect_IO($n(that).apply__O()))));
});
$c_Lcats_effect_IO.prototype.as__O__Lcats_effect_IO = (function(b) {
  return this.map__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((_$2) => b)));
});
$c_Lcats_effect_IO.prototype.forceR__Lcats_effect_IO__Lcats_effect_IO = (function(that) {
  return $n(this.handleError__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((_$9) => {
    $as_jl_Throwable(_$9);
  })))).productR__Lcats_effect_IO__Lcats_effect_IO(that);
});
$c_Lcats_effect_IO.prototype.flatMap__F1__Lcats_effect_IO = (function(f) {
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(f);
  return new $c_Lcats_effect_IO$FlatMap(this, f, event);
});
$c_Lcats_effect_IO.prototype.flatTap__F1__Lcats_effect_IO = (function(f) {
  return this.flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((a) => $n($as_Lcats_effect_IO($n(f).apply__O__O(a))).as__O__Lcats_effect_IO(a))));
});
$c_Lcats_effect_IO.prototype.guarantee__Lcats_effect_IO__Lcats_effect_IO = (function(finalizer) {
  return $m_Lcats_effect_IO$().uncancelable__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var handled = $n(finalizer).handleErrorWith__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((t) => {
      var t$1 = $as_jl_Throwable(t);
      return ($m_Lcats_effect_IO$(), $m_Lcats_effect_IO$ReadEC$()).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((ec) => {
        var ec$1 = $as_s_concurrent_ExecutionContext(ec);
        var this$3 = $m_Lcats_effect_IO$();
        var thunk = new $c_sjsr_AnonFunction0((() => {
          $n(ec$1).reportFailure__jl_Throwable__V(t$1);
        }));
        return this$3.delay__F0__Lcats_effect_IO(thunk);
      })));
    })));
    var this$4 = $n($as_Lcats_effect_IO($n(poll$1).apply__O__O(this)));
    return $n(new $c_Lcats_effect_IO$OnCancel(this$4, finalizer).onError__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((_$10) => {
      $as_jl_Throwable(_$10);
      return handled;
    })))).flatTap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((_$11) => finalizer)));
  })));
});
$c_Lcats_effect_IO.prototype.guaranteeCase__F1__Lcats_effect_IO = (function(finalizer) {
  return $m_Lcats_effect_IO$().uncancelable__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var this$4 = $n($as_Lcats_effect_IO($n(poll$1).apply__O__O(this)));
    var fin = $as_Lcats_effect_IO($n(finalizer).apply__O__O(new $c_Lcats_effect_kernel_Outcome$Canceled()));
    var finalized = new $c_Lcats_effect_IO$OnCancel(this$4, fin);
    var handled = finalized.onError__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((e) => {
      var e$1 = $as_jl_Throwable(e);
      return $n($as_Lcats_effect_IO($n(finalizer).apply__O__O(new $c_Lcats_effect_kernel_Outcome$Errored(e$1)))).handleErrorWith__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((t) => {
        var t$1 = $as_jl_Throwable(t);
        return ($m_Lcats_effect_IO$(), $m_Lcats_effect_IO$ReadEC$()).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((ec) => {
          var ec$1 = $as_s_concurrent_ExecutionContext(ec);
          var this$9 = $m_Lcats_effect_IO$();
          var thunk = new $c_sjsr_AnonFunction0((() => {
            $n(ec$1).reportFailure__jl_Throwable__V(t$1);
          }));
          return this$9.delay__F0__Lcats_effect_IO(thunk);
        })));
      })));
    })));
    return $n(handled).flatTap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((a) => {
      $m_Lcats_effect_IO$();
      var fa = new $c_Lcats_effect_IO$Pure(a);
      return $as_Lcats_effect_IO($n(finalizer).apply__O__O(new $c_Lcats_effect_kernel_Outcome$Succeeded(fa)));
    })));
  })));
});
$c_Lcats_effect_IO.prototype.handleError__F1__Lcats_effect_IO = (function(f) {
  return this.handleErrorWith__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((t) => {
    var t$1 = $as_jl_Throwable(t);
    $m_Lcats_effect_IO$();
    var value = $n(f).apply__O__O(t$1);
    return new $c_Lcats_effect_IO$Pure(value);
  })));
});
$c_Lcats_effect_IO.prototype.handleErrorWith__F1__Lcats_effect_IO = (function(f) {
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(f);
  return new $c_Lcats_effect_IO$HandleErrorWith(this, f, event);
});
$c_Lcats_effect_IO.prototype.map__F1__Lcats_effect_IO = (function(f) {
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(f);
  return new $c_Lcats_effect_IO$Map(this, f, event);
});
$c_Lcats_effect_IO.prototype.onError__F1__Lcats_effect_IO = (function(f) {
  return this.handleErrorWith__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((t) => {
    var t$1 = $as_jl_Throwable(t);
    var $x_1 = $as_Lcats_effect_IO($n(f).apply__O__O(t$1));
    var this$1 = $m_s_$less$colon$less$();
    var this$4 = $n($n($x_1).voidError__s_$less$colon$less__Lcats_effect_IO(this$1.s_$less$colon$less$__f_singleton));
    $m_Lcats_effect_IO$();
    var that = new $c_Lcats_effect_IO$Error(t$1);
    return this$4.productR__Lcats_effect_IO__Lcats_effect_IO(that);
  })));
});
$c_Lcats_effect_IO.prototype.redeemWith__F1__F1__Lcats_effect_IO = (function(recover, bind) {
  return new $c_Lcats_effect_IO$Attempt(this).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((_$15) => {
    var _$15$1 = $as_s_util_Either(_$15);
    return $as_Lcats_effect_IO($n(_$15$1).fold__F1__F1__O(recover, bind));
  })));
});
$c_Lcats_effect_IO.prototype.delayBy__s_concurrent_duration_Duration__Lcats_effect_IO = (function(duration) {
  var this$1 = $n($m_Lcats_effect_IO$().sleep__s_concurrent_duration_Duration__Lcats_effect_IO(duration));
  return this$1.productR__Lcats_effect_IO__Lcats_effect_IO(this);
});
$c_Lcats_effect_IO.prototype.productL__Lcats_effect_IO__Lcats_effect_IO = (function(that) {
  return this.flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((a) => $n(that).as__O__Lcats_effect_IO(a))));
});
$c_Lcats_effect_IO.prototype.productR__Lcats_effect_IO__Lcats_effect_IO = (function(that) {
  return this.flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((_$18) => that)));
});
$c_Lcats_effect_IO.prototype.background__Lcats_effect_kernel_Resource = (function() {
  var F = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO;
  var this$2 = $n(F);
  return $f_Lcats_effect_kernel_GenSpawn__background__O__Lcats_effect_kernel_Resource(this$2, this);
});
$c_Lcats_effect_IO.prototype.void__Lcats_effect_IO = (function() {
  return this.map__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((_$20) => (void 0))));
});
$c_Lcats_effect_IO.prototype.voidError__s_$less$colon$less__Lcats_effect_IO = (function(ev) {
  return this.handleError__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((_$21) => {
    $as_jl_Throwable(_$21);
  })));
});
$c_Lcats_effect_IO.prototype.toString__T = (function() {
  return "IO(...)";
});
$c_Lcats_effect_IO.prototype.unsafeRunAndForget__Lcats_effect_unsafe_IORuntime__V = (function(runtime) {
  this.unsafeRunFiber__F0__F1__F1__Z__Lcats_effect_unsafe_IORuntime__Lcats_effect_IOFiber(new $c_sjsr_AnonFunction0((() => (void 0))), new $c_sjsr_AnonFunction1(((t) => {
    var t$1 = $as_jl_Throwable(t);
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(t$1)) {
      if ($n($n(runtime).Lcats_effect_unsafe_IORuntime__f_config).Lcats_effect_unsafe_IORuntimeConfig__f_reportUnhandledFiberErrors) {
        $n($n(runtime).Lcats_effect_unsafe_IORuntime__f_compute).reportFailure__jl_Throwable__V(t$1);
      }
    } else {
      var this$1 = $n(t$1);
      this$1.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err);
    }
  })), new $c_sjsr_AnonFunction1(((_$23) => (void 0))), true, runtime);
});
$c_Lcats_effect_IO.prototype.unsafeRunAndForgetWithoutCallback__Lcats_effect_unsafe_IORuntime__V = (function(runtime) {
  this.unsafeRunFiber__F0__F1__F1__Z__Lcats_effect_unsafe_IORuntime__Lcats_effect_IOFiber(new $c_sjsr_AnonFunction0((() => (void 0))), new $c_sjsr_AnonFunction1(((_$24) => {
    $as_jl_Throwable(_$24);
  })), new $c_sjsr_AnonFunction1(((_$25) => (void 0))), false, runtime);
});
$c_Lcats_effect_IO.prototype.unsafeRunFiber__F0__F1__F1__Z__Lcats_effect_unsafe_IORuntime__Lcats_effect_IOFiber = (function(canceled, failure, success, registerCallback, runtime) {
  var fiber = new $c_Lcats_effect_IOFiber($m_sci_Map$EmptyMap$(), new $c_sjsr_AnonFunction1(((oc) => {
    var oc$1 = $as_Lcats_effect_kernel_Outcome(oc);
    var this$2 = $n(oc$1);
    matchResult1: {
      if (((this$2 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(this$2), true))) {
        $n($n(runtime).Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs).remove__F1__V(failure);
        $n(canceled).apply__O();
        break matchResult1;
      }
      if ((this$2 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
        var x$1 = $as_Lcats_effect_kernel_Outcome$Errored(this$2);
        var this$4 = $n(x$1);
        var x7 = this$4.Lcats_effect_kernel_Outcome$Errored__f_e;
        var t = $as_jl_Throwable(x7);
        $n($n(runtime).Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs).remove__F1__V(failure);
        $n(failure).apply__O__O(t);
        break matchResult1;
      }
      if ((this$2 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
        var x$1$1 = $as_Lcats_effect_kernel_Outcome$Succeeded(this$2);
        var this$6 = $n(x$1$1);
        var x4 = this$6.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
        var ioa = $as_Lcats_effect_IO(x4);
        $n($n(runtime).Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs).remove__F1__V(failure);
        $n(success).apply__O__O($n($as_Lcats_effect_IO$Pure(ioa)).Lcats_effect_IO$Pure__f_value);
        break matchResult1;
      }
      throw new $c_s_MatchError(this$2);
    }
  })), this, $n(runtime).Lcats_effect_unsafe_IORuntime__f_compute, runtime);
  if (registerCallback) {
    $n($n(runtime).Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs).put__F1__V(failure);
  }
  $n($n(runtime).Lcats_effect_unsafe_IORuntime__f_compute).execute__jl_Runnable__V(fiber);
  return fiber;
});
function $as_Lcats_effect_IO(obj) {
  return (((obj instanceof $c_Lcats_effect_IO) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO"));
}
function $isArrayOf_Lcats_effect_IO(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO)));
}
function $asArrayOf_Lcats_effect_IO(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO;", depth));
}
/** @constructor */
function $c_Lcats_effect_IOFiber$$anon$2(cb$12, outer) {
  this.Lcats_effect_IOFiber$$anon$2__f_cb$11 = null;
  this.Lcats_effect_IOFiber$$anon$2__f_cb$11 = cb$12;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_effect_IOFiber$$anon$2.prototype = new $h_O();
$c_Lcats_effect_IOFiber$$anon$2.prototype.constructor = $c_Lcats_effect_IOFiber$$anon$2;
/** @constructor */
function $h_Lcats_effect_IOFiber$$anon$2() {
}
$h_Lcats_effect_IOFiber$$anon$2.prototype = $c_Lcats_effect_IOFiber$$anon$2.prototype;
$c_Lcats_effect_IOFiber$$anon$2.prototype.run__V = (function() {
  var cb$7 = this.Lcats_effect_IOFiber$$anon$2__f_cb$11;
  $n(cb$7).apply__O__O($m_Lcats_effect_IOFiber$().Lcats_effect_IOFiber$__f_RightUnit);
});
var $d_Lcats_effect_IOFiber$$anon$2 = new $TypeData().initClass($c_Lcats_effect_IOFiber$$anon$2, "cats.effect.IOFiber$$anon$2", ({
  Lcats_effect_IOFiber$$anon$2: 1,
  jl_Runnable: 1
}));
/** @constructor */
function $c_Lcats_effect_ResourceApp$Forever$$anon$2(outer) {
  this.Lcats_effect_ResourceApp$Forever$$anon$2__f_cats$effect$IOApp$$_runtime = null;
  this.Lcats_effect_ResourceApp$Forever$$anon$2__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_ResourceApp$Forever$$anon$2__f_$outer = outer;
  this.Lcats_effect_ResourceApp$Forever$$anon$2__f_cats$effect$IOApp$$_runtime = null;
}
$c_Lcats_effect_ResourceApp$Forever$$anon$2.prototype = new $h_O();
$c_Lcats_effect_ResourceApp$Forever$$anon$2.prototype.constructor = $c_Lcats_effect_ResourceApp$Forever$$anon$2;
/** @constructor */
function $h_Lcats_effect_ResourceApp$Forever$$anon$2() {
}
$h_Lcats_effect_ResourceApp$Forever$$anon$2.prototype = $c_Lcats_effect_ResourceApp$Forever$$anon$2.prototype;
$c_Lcats_effect_ResourceApp$Forever$$anon$2.prototype.run__sci_List__Lcats_effect_IO = (function(args) {
  return $as_Lcats_effect_IO($n($n(this.Lcats_effect_ResourceApp$Forever$$anon$2__f_$outer).run__sci_List__Lcats_effect_kernel_Resource(args)).useForever__Lcats_effect_kernel_GenSpawn__O($m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO));
});
var $d_Lcats_effect_ResourceApp$Forever$$anon$2 = new $TypeData().initClass($c_Lcats_effect_ResourceApp$Forever$$anon$2, "cats.effect.ResourceApp$Forever$$anon$2", ({
  Lcats_effect_ResourceApp$Forever$$anon$2: 1,
  Lcats_effect_IOApp: 1
}));
function $ps_Lcats_effect_SyncIO__runLoop$1__sr_ObjectRef__sjs_js_Array__Lcats_effect_SyncIO__O(conts$1, objectState$1, cur0) {
  var cur0$tailLocal1 = cur0;
  while (true) {
    var x34 = $n(cur0$tailLocal1).tag__B();
    switch (x34) {
      case 0: {
        var cur = $as_Lcats_effect_SyncIO$Pure(cur0$tailLocal1);
        cur0$tailLocal1 = $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO(conts$1, objectState$1, $n(cur).Lcats_effect_SyncIO$Pure__f_value, 0);
        break;
      }
      case 1: {
        var cur$2 = $as_Lcats_effect_SyncIO$Suspend(cur0$tailLocal1);
        var error = null;
        try {
          var r = $n($n(cur$2).Lcats_effect_SyncIO$Suspend__f_thunk).apply__O();
        } catch (e) {
          var e$1 = e;
          var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
          matchResult2: {
            if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
              error = e$2;
              break matchResult2;
            }
            throw e$2;
          }
          var r = (void 0);
        }
        var next = ((error === null) ? $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO(conts$1, objectState$1, r, 0) : $ps_Lcats_effect_SyncIO__failed$1__sr_ObjectRef__sjs_js_Array__jl_Throwable__I__Lcats_effect_SyncIO(conts$1, objectState$1, error, 0));
        cur0$tailLocal1 = next;
        break;
      }
      case 2: {
        var cur$3 = $as_Lcats_effect_SyncIO$Error(cur0$tailLocal1);
        cur0$tailLocal1 = $ps_Lcats_effect_SyncIO__failed$1__sr_ObjectRef__sjs_js_Array__jl_Throwable__I__Lcats_effect_SyncIO(conts$1, objectState$1, $n(cur$3).Lcats_effect_SyncIO$Error__f_t, 0);
        break;
      }
      case 3: {
        var cur$4 = $as_Lcats_effect_SyncIO$Map(cur0$tailLocal1);
        var a = $n(cur$4).f__F1();
        objectState$1.push(a);
        var stack = $n(conts$1).sr_ObjectRef__f_elem;
        var c = $uI(stack[0]);
        var use = ((((1 + (((1 + c) | 0) >> 3)) | 0) < $uI(stack.length)) ? stack : (stack.push(0), stack));
        var s = ((1 + (c >> 3)) | 0);
        var shift = ((7 & c) << 2);
        use[s] = ($uI(use[s]) & (~((-1) << shift)));
        use[0] = ((1 + $uI(use[0])) | 0);
        var ev$5 = use;
        $n(conts$1).sr_ObjectRef__f_elem = ev$5;
        ev$5 = null;
        cur0$tailLocal1 = $n(cur$4).ioe__Lcats_effect_SyncIO();
        break;
      }
      case 4: {
        var cur$5 = $as_Lcats_effect_SyncIO$FlatMap(cur0$tailLocal1);
        var a$1 = $n(cur$5).Lcats_effect_SyncIO$FlatMap__f_f;
        objectState$1.push(a$1);
        var stack$1 = $n(conts$1).sr_ObjectRef__f_elem;
        var c$1 = $uI(stack$1[0]);
        var use$1 = ((((1 + (((1 + c$1) | 0) >> 3)) | 0) < $uI(stack$1.length)) ? stack$1 : (stack$1.push(0), stack$1));
        var s$1 = ((1 + (c$1 >> 3)) | 0);
        var shift$1 = ((7 & c$1) << 2);
        use$1[s$1] = (($uI(use$1[s$1]) & (~((-1) << shift$1))) | (1 << shift$1));
        use$1[0] = ((1 + $uI(use$1[0])) | 0);
        var ev$6 = use$1;
        $n(conts$1).sr_ObjectRef__f_elem = ev$6;
        ev$6 = null;
        cur0$tailLocal1 = $n(cur$5).Lcats_effect_SyncIO$FlatMap__f_ioe;
        break;
      }
      case 5: {
        var cur$6 = $as_Lcats_effect_SyncIO$HandleErrorWith(cur0$tailLocal1);
        var a$2 = $n(cur$6).Lcats_effect_SyncIO$HandleErrorWith__f_f;
        objectState$1.push(a$2);
        var stack$2 = $n(conts$1).sr_ObjectRef__f_elem;
        var c$2 = $uI(stack$2[0]);
        var use$2 = ((((1 + (((1 + c$2) | 0) >> 3)) | 0) < $uI(stack$2.length)) ? stack$2 : (stack$2.push(0), stack$2));
        var s$2 = ((1 + (c$2 >> 3)) | 0);
        var shift$2 = ((7 & c$2) << 2);
        use$2[s$2] = (($uI(use$2[s$2]) & (~((-1) << shift$2))) | (2 << shift$2));
        use$2[0] = ((1 + $uI(use$2[0])) | 0);
        var ev$7 = use$2;
        $n(conts$1).sr_ObjectRef__f_elem = ev$7;
        ev$7 = null;
        cur0$tailLocal1 = $n(cur$6).Lcats_effect_SyncIO$HandleErrorWith__f_ioa;
        break;
      }
      case 6: {
        var cur$7 = $as_Lcats_effect_SyncIO$Success(cur0$tailLocal1);
        return $n(cur$7).Lcats_effect_SyncIO$Success__f_value;
        break;
      }
      case 7: {
        var cur$8 = $as_Lcats_effect_SyncIO$Failure(cur0$tailLocal1);
        var x = $n(cur$8).Lcats_effect_SyncIO$Failure__f_t;
        throw ((x === null) ? $n(null) : x);
        break;
      }
      case 8: {
        var cur$9 = $as_Lcats_effect_SyncIO$Attempt(cur0$tailLocal1);
        var stack$3 = $n(conts$1).sr_ObjectRef__f_elem;
        var c$3 = $uI(stack$3[0]);
        var use$3 = ((((1 + (((1 + c$3) | 0) >> 3)) | 0) < $uI(stack$3.length)) ? stack$3 : (stack$3.push(0), stack$3));
        var s$3 = ((1 + (c$3 >> 3)) | 0);
        var shift$3 = ((7 & c$3) << 2);
        use$3[s$3] = (($uI(use$3[s$3]) & (~((-1) << shift$3))) | (4 << shift$3));
        use$3[0] = ((1 + $uI(use$3[0])) | 0);
        var ev$8 = use$3;
        $n(conts$1).sr_ObjectRef__f_elem = ev$8;
        ev$8 = null;
        cur0$tailLocal1 = $n(cur$9).Lcats_effect_SyncIO$Attempt__f_ioa;
        break;
      }
      case 9: {
        var this$10 = $m_RTLong$();
        var value = $uD(new Date().getTime());
        var lo = this$10.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
        var hi = this$10.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var this$12 = new $c_s_concurrent_duration_package$DurationLong(new $c_RTLong(lo, hi));
        var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
        var t = this$12.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
        var lo$1 = t.RTLong__f_lo;
        var hi$1 = t.RTLong__f_hi;
        $m_s_concurrent_duration_Duration$();
        cur0$tailLocal1 = $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO(conts$1, objectState$1, new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$1, hi$1), unit), 0);
        break;
      }
      case 10: {
        var this$16 = $m_RTLong$();
        var value$1 = (1000000.0 * $uD((0, $m_jl_System$NanoTime$().jl_System$NanoTime$__f_getHighPrecisionTime)()));
        var lo$2 = this$16.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$1);
        var hi$2 = this$16.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var this$18 = new $c_s_concurrent_duration_package$DurationLong(new $c_RTLong(lo$2, hi$2));
        var unit$1 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
        var t$1 = this$18.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
        var lo$3 = t$1.RTLong__f_lo;
        var hi$3 = t$1.RTLong__f_hi;
        $m_s_concurrent_duration_Duration$();
        cur0$tailLocal1 = $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO(conts$1, objectState$1, new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$3, hi$3), unit$1), 0);
        break;
      }
      default: {
        throw new $c_s_MatchError(x34);
      }
    }
  }
}
function $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO(conts$2, objectState$2, result, depth) {
  var depth$tailLocal1 = depth;
  var result$tailLocal1 = result;
  while (true) {
    var stack = $n(conts$2).sr_ObjectRef__f_elem;
    var c = (((-1) + $uI(stack[0])) | 0);
    if ((c < 0)) {
      throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
    }
    var op = (((15 & (($uI(stack[((1 + (c >> 3)) | 0)]) >>> ((7 & c) << 2)) | 0)) << 24) >> 24);
    stack[0] = (((-1) + $uI(stack[0])) | 0);
    switch (op) {
      case 0: {
        return $ps_Lcats_effect_SyncIO__mapK$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO(conts$2, objectState$2, result$tailLocal1, depth$tailLocal1);
        break;
      }
      case 1: {
        return $ps_Lcats_effect_SyncIO__flatMapK$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO(conts$2, objectState$2, result$tailLocal1, depth$tailLocal1);
        break;
      }
      case 2: {
        objectState$2.pop();
        break;
      }
      case 3: {
        var value = result$tailLocal1;
        return new $c_Lcats_effect_SyncIO$Success(value);
        break;
      }
      case 4: {
        var value$1 = result$tailLocal1;
        var result$tailLocal1$tmp1 = new $c_s_util_Right(value$1);
        var depth$tailLocal1$tmp1 = ((1 + depth$tailLocal1) | 0);
        result$tailLocal1 = result$tailLocal1$tmp1;
        depth$tailLocal1 = depth$tailLocal1$tmp1;
        break;
      }
      default: {
        throw new $c_s_MatchError(op);
      }
    }
  }
}
function $ps_Lcats_effect_SyncIO__failed$1__sr_ObjectRef__sjs_js_Array__jl_Throwable__I__Lcats_effect_SyncIO(conts$3, objectState$3, error, depth) {
  while (true) {
    var stack = $n(conts$3).sr_ObjectRef__f_elem;
    var c = (((-1) + $uI(stack[0])) | 0);
    if ((c < 0)) {
      throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
    }
    var op = (((15 & (($uI(stack[((1 + (c >> 3)) | 0)]) >>> ((7 & c) << 2)) | 0)) << 24) >> 24);
    stack[0] = (((-1) + $uI(stack[0])) | 0);
    switch (op) {
      case 0:
      case 1: {
        objectState$3.pop();
        break;
      }
      case 2: {
        return $ps_Lcats_effect_SyncIO__handleErrorWithK$1__sr_ObjectRef__sjs_js_Array__jl_Throwable__I__Lcats_effect_SyncIO(conts$3, objectState$3, error, depth);
        break;
      }
      case 3: {
        return new $c_Lcats_effect_SyncIO$Failure(error);
        break;
      }
      case 4: {
        return $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO(conts$3, objectState$3, new $c_s_util_Left(error), ((1 + depth) | 0));
        break;
      }
      default: {
        throw new $c_s_MatchError(op);
      }
    }
  }
}
function $ps_Lcats_effect_SyncIO__mapK$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO(conts$4, objectState$4, result, depth) {
  var f = $as_F1(objectState$4.pop());
  var error = null;
  try {
    var transformed = $n(f).apply__O__O(result);
  } catch (e) {
    var e$1 = e;
    var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
    matchResult6: {
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        error = e$2;
        break matchResult6;
      }
      throw e$2;
    }
    var transformed = (void 0);
  }
  if ((depth > 512)) {
    if ((error === null)) {
      var $x_1 = new $c_Lcats_effect_SyncIO$Pure(transformed);
    } else {
      var t = error;
      var $x_1 = new $c_Lcats_effect_SyncIO$Error(t);
    }
    return $as_Lcats_effect_SyncIO($x_1);
  } else {
    return ((error === null) ? $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO(conts$4, objectState$4, transformed, ((1 + depth) | 0)) : $ps_Lcats_effect_SyncIO__failed$1__sr_ObjectRef__sjs_js_Array__jl_Throwable__I__Lcats_effect_SyncIO(conts$4, objectState$4, error, ((1 + depth) | 0)));
  }
}
function $ps_Lcats_effect_SyncIO__flatMapK$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO(conts$5, objectState$5, result, depth) {
  var f = $as_F1(objectState$5.pop());
  try {
    return $as_Lcats_effect_SyncIO($n(f).apply__O__O(result));
  } catch (e) {
    var e$1 = e;
    var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      return $ps_Lcats_effect_SyncIO__failed$1__sr_ObjectRef__sjs_js_Array__jl_Throwable__I__Lcats_effect_SyncIO(conts$5, objectState$5, e$2, ((1 + depth) | 0));
    }
    throw e$2;
  }
}
function $ps_Lcats_effect_SyncIO__handleErrorWithK$1__sr_ObjectRef__sjs_js_Array__jl_Throwable__I__Lcats_effect_SyncIO(conts$6, objectState$6, t, depth) {
  var f = $as_F1(objectState$6.pop());
  try {
    return $as_Lcats_effect_SyncIO($n(f).apply__O__O(t));
  } catch (e) {
    var e$1 = e;
    var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      return $ps_Lcats_effect_SyncIO__failed$1__sr_ObjectRef__sjs_js_Array__jl_Throwable__I__Lcats_effect_SyncIO(conts$6, objectState$6, e$2, ((1 + depth) | 0));
    }
    throw e$2;
  }
}
/** @constructor */
function $c_Lcats_effect_SyncIO() {
}
$c_Lcats_effect_SyncIO.prototype = new $h_O();
$c_Lcats_effect_SyncIO.prototype.constructor = $c_Lcats_effect_SyncIO;
/** @constructor */
function $h_Lcats_effect_SyncIO() {
}
$h_Lcats_effect_SyncIO.prototype = $c_Lcats_effect_SyncIO.prototype;
$c_Lcats_effect_SyncIO.prototype.productR__Lcats_effect_SyncIO__Lcats_effect_SyncIO = (function(that) {
  var f = new $c_sjsr_AnonFunction1(((_$4) => that));
  return new $c_Lcats_effect_SyncIO$FlatMap(this, f);
});
$c_Lcats_effect_SyncIO.prototype.toString__T = (function() {
  return "SyncIO(...)";
});
$c_Lcats_effect_SyncIO.prototype.unsafeRunSync__O = (function() {
  var elem = [0];
  var conts = new $c_sr_ObjectRef(elem);
  var objectState = [];
  var stack = conts.sr_ObjectRef__f_elem;
  var c = $uI(stack[0]);
  var use = ((((1 + (((1 + c) | 0) >> 3)) | 0) < $uI(stack.length)) ? stack : (stack.push(0), stack));
  var s = ((1 + (c >> 3)) | 0);
  var shift = ((7 & c) << 2);
  use[s] = (($uI(use[s]) & (~((-1) << shift))) | (3 << shift));
  use[0] = ((1 + $uI(use[0])) | 0);
  var ev$4 = use;
  conts.sr_ObjectRef__f_elem = ev$4;
  ev$4 = null;
  return $ps_Lcats_effect_SyncIO__runLoop$1__sr_ObjectRef__sjs_js_Array__Lcats_effect_SyncIO__O(conts, objectState, this);
});
function $as_Lcats_effect_SyncIO(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO"));
}
function $isArrayOf_Lcats_effect_SyncIO(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO)));
}
function $asArrayOf_Lcats_effect_SyncIO(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO;", depth));
}
/** @constructor */
function $c_Lcats_effect_instances_package$spawn$() {
}
$c_Lcats_effect_instances_package$spawn$.prototype = new $h_O();
$c_Lcats_effect_instances_package$spawn$.prototype.constructor = $c_Lcats_effect_instances_package$spawn$;
/** @constructor */
function $h_Lcats_effect_instances_package$spawn$() {
}
$h_Lcats_effect_instances_package$spawn$.prototype = $c_Lcats_effect_instances_package$spawn$.prototype;
var $d_Lcats_effect_instances_package$spawn$ = new $TypeData().initClass($c_Lcats_effect_instances_package$spawn$, "cats.effect.instances.package$spawn$", ({
  Lcats_effect_instances_package$spawn$: 1,
  Lcats_effect_kernel_instances_GenSpawnInstances: 1
}));
var $n_Lcats_effect_instances_package$spawn$;
function $m_Lcats_effect_instances_package$spawn$() {
  if ((!$n_Lcats_effect_instances_package$spawn$)) {
    $n_Lcats_effect_instances_package$spawn$ = new $c_Lcats_effect_instances_package$spawn$();
  }
  return $n_Lcats_effect_instances_package$spawn$;
}
function $is_Lcats_effect_kernel_Fiber(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_kernel_Fiber)));
}
function $as_Lcats_effect_kernel_Fiber(obj) {
  return (($is_Lcats_effect_kernel_Fiber(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Fiber"));
}
function $isArrayOf_Lcats_effect_kernel_Fiber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Fiber)));
}
function $asArrayOf_Lcats_effect_kernel_Fiber(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Fiber(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Fiber;", depth));
}
/** @constructor */
function $c_Lcats_effect_kernel_Par$ParallelFImpl() {
}
$c_Lcats_effect_kernel_Par$ParallelFImpl.prototype = new $h_O();
$c_Lcats_effect_kernel_Par$ParallelFImpl.prototype.constructor = $c_Lcats_effect_kernel_Par$ParallelFImpl;
/** @constructor */
function $h_Lcats_effect_kernel_Par$ParallelFImpl() {
}
$h_Lcats_effect_kernel_Par$ParallelFImpl.prototype = $c_Lcats_effect_kernel_Par$ParallelFImpl.prototype;
/** @constructor */
function $c_Lcats_effect_kernel_Ref$MakeInstances$$anon$1(F$7) {
  this.Lcats_effect_kernel_Ref$MakeInstances$$anon$1__f_F$5 = null;
  this.Lcats_effect_kernel_Ref$MakeInstances$$anon$1__f_F$5 = F$7;
}
$c_Lcats_effect_kernel_Ref$MakeInstances$$anon$1.prototype = new $h_O();
$c_Lcats_effect_kernel_Ref$MakeInstances$$anon$1.prototype.constructor = $c_Lcats_effect_kernel_Ref$MakeInstances$$anon$1;
/** @constructor */
function $h_Lcats_effect_kernel_Ref$MakeInstances$$anon$1() {
}
$h_Lcats_effect_kernel_Ref$MakeInstances$$anon$1.prototype = $c_Lcats_effect_kernel_Ref$MakeInstances$$anon$1.prototype;
$c_Lcats_effect_kernel_Ref$MakeInstances$$anon$1.prototype.refOf__O__O = (function(a) {
  return $n(this.Lcats_effect_kernel_Ref$MakeInstances$$anon$1__f_F$5).ref__O__O(a);
});
var $d_Lcats_effect_kernel_Ref$MakeInstances$$anon$1 = new $TypeData().initClass($c_Lcats_effect_kernel_Ref$MakeInstances$$anon$1, "cats.effect.kernel.Ref$MakeInstances$$anon$1", ({
  Lcats_effect_kernel_Ref$MakeInstances$$anon$1: 1,
  Lcats_effect_kernel_Ref$Make: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2(F$8) {
  this.Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2__f_F$6 = null;
  this.Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2__f_F$6 = F$8;
}
$c_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2.prototype = new $h_O();
$c_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2.prototype.constructor = $c_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2;
/** @constructor */
function $h_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2() {
}
$h_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2.prototype = $c_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2.prototype;
$c_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2.prototype.refOf__O__O = (function(a) {
  return $n(this.Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2__f_F$6).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
    var F = this.Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2__f_F$6;
    return new $c_Lcats_effect_kernel_SyncRef(a, F);
  })));
});
var $d_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2 = new $TypeData().initClass($c_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2, "cats.effect.kernel.Ref$MakeLowPriorityInstances$$anon$2", ({
  Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2: 1,
  Lcats_effect_kernel_Ref$Make: 1
}));
function $ps_Lcats_effect_kernel_Resource__Nil$lzyINIT1$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$(Nil$lzy1$1) {
  if ((Nil$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Lcats_effect_kernel_Resource$Nil$2$(($n(Nil$lzy1$1).sr_LazyRef__f__initialized ? $n(Nil$lzy1$1).sr_LazyRef__f__value : $n(Nil$lzy1$1).initialize__O__O(new $c_Lcats_effect_kernel_Resource$Nil$2$())));
}
function $ps_Lcats_effect_kernel_Resource__Nil$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$(Nil$lzy1$2) {
  return $as_Lcats_effect_kernel_Resource$Nil$2$(($n(Nil$lzy1$2).sr_LazyRef__f__initialized ? $n(Nil$lzy1$2).sr_LazyRef__f__value : $ps_Lcats_effect_kernel_Resource__Nil$lzyINIT1$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$(Nil$lzy1$2)));
}
function $p_Lcats_effect_kernel_Resource__Frame$lzyINIT1$1__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$3$($thiz, Frame$lzy1$1) {
  if ((Frame$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Lcats_effect_kernel_Resource$Frame$3$(($n(Frame$lzy1$1).sr_LazyRef__f__initialized ? $n(Frame$lzy1$1).sr_LazyRef__f__value : $n(Frame$lzy1$1).initialize__O__O(new $c_Lcats_effect_kernel_Resource$Frame$3$($thiz))));
}
function $p_Lcats_effect_kernel_Resource__Frame$2__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$3$($thiz, Frame$lzy1$2) {
  return $as_Lcats_effect_kernel_Resource$Frame$3$(($n(Frame$lzy1$2).sr_LazyRef__f__initialized ? $n(Frame$lzy1$2).sr_LazyRef__f__value : $p_Lcats_effect_kernel_Resource__Frame$lzyINIT1$1__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$3$($thiz, Frame$lzy1$2)));
}
function $p_Lcats_effect_kernel_Resource__loop$1__F1__F2__Lcats_effect_kernel_MonadCancel__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$1__O($thiz, onOutput$1, onRelease$1, F$1, Nil$lzy1$3, Frame$lzy1$3, current, stack) {
  var stack$tailLocal1 = stack;
  var current$tailLocal1 = current;
  while (true) {
    var x25 = current$tailLocal1;
    if ((x25 instanceof $c_Lcats_effect_kernel_Resource$Allocate)) {
      var x$1 = $as_Lcats_effect_kernel_Resource$Allocate(x25);
      var this$2 = $n(x$1);
      var x38 = this$2.Lcats_effect_kernel_Resource$Allocate__f_resource;
      var $x_1 = $n(F$1);
      var stack$tailLocal1$2$1 = stack$tailLocal1;
      return $n($x_1).bracketFull__F1__F1__F2__O(x38, new $c_sjsr_AnonFunction1(((onOutput$1, onRelease$1, F$1, Nil$lzy1$3, Frame$lzy1$3, stack$tailLocal1$2) => ((x$1$1) => {
        var x$1$2 = $as_T2(x$1$1);
        if ((x$1$2 !== null)) {
          var a = $n(x$1$2)._1__O();
          var x = $ps_Lcats_effect_kernel_Resource__Nil$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$(Nil$lzy1$3);
          if ((x === null)) {
            var $x_2 = (stack$tailLocal1$2 === null);
          } else {
            var this$4 = $n(x);
            var $x_2 = (this$4 === stack$tailLocal1$2);
          }
          if ($x_2) {
            return $n(onOutput$1).apply__O__O(a);
          }
          if ((stack$tailLocal1$2 instanceof $c_Lcats_effect_kernel_Resource$Frame$1)) {
            $n($p_Lcats_effect_kernel_Resource__Frame$2__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$3$($thiz, Frame$lzy1$3));
            var x$1$3 = $as_Lcats_effect_kernel_Resource$Frame$1(stack$tailLocal1$2);
            var this$6 = $n(x$1$3);
            var x10 = this$6.Lcats_effect_kernel_Resource$Frame$1__f_head;
            var this$7 = $n(x$1$3);
            var x11 = this$7.Lcats_effect_kernel_Resource$Frame$1__f_tail;
            var current$1 = $as_Lcats_effect_kernel_Resource($n(x10).apply__O__O(a));
            return $p_Lcats_effect_kernel_Resource__loop$1__F1__F2__Lcats_effect_kernel_MonadCancel__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$1__O($thiz, onOutput$1, onRelease$1, F$1, Nil$lzy1$3, Frame$lzy1$3, current$1, x11);
          }
          throw new $c_s_MatchError(stack$tailLocal1$2);
        }
        throw new $c_s_MatchError(x$1$2);
      }))(onOutput$1, onRelease$1, F$1, Nil$lzy1$3, Frame$lzy1$3, stack$tailLocal1$2$1)), new $c_sjsr_AnonFunction2(((onRelease$1) => ((x$1$2$1, x$2) => {
        var x$1$4 = $as_T2(x$1$2$1);
        var x$2$1 = $as_Lcats_effect_kernel_Outcome(x$2);
        var x15 = new $c_T2(x$1$4, x$2$1);
        var x16 = $as_T2(x15.T2__f__1);
        if ((x16 !== null)) {
          var release = $as_F1($n(x16)._2__O());
          var outcome = $as_Lcats_effect_kernel_Outcome(x15.T2__f__2);
          return $n(onRelease$1).apply__O__O__O(release, $m_Lcats_effect_kernel_Resource$ExitCase$().fromOutcome__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Resource$ExitCase(outcome));
        }
        throw new $c_s_MatchError(x15);
      }))(onRelease$1)));
    }
    if ((x25 instanceof $c_Lcats_effect_kernel_Resource$Bind)) {
      var x$1$5 = $as_Lcats_effect_kernel_Resource$Bind(x25);
      var this$10 = $n(x$1$5);
      var x34 = this$10.Lcats_effect_kernel_Resource$Bind__f_source;
      var this$11 = $n(x$1$5);
      var x35 = this$11.Lcats_effect_kernel_Resource$Bind__f_fs;
      var stack$tailLocal1$tmp1 = $n($p_Lcats_effect_kernel_Resource__Frame$2__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$3$($thiz, Frame$lzy1$3)).apply__F1__Lcats_effect_kernel_Resource$Stack$1__Lcats_effect_kernel_Resource$Frame$1(x35, stack$tailLocal1);
      current$tailLocal1 = x34;
      stack$tailLocal1 = stack$tailLocal1$tmp1;
      continue;
    }
    if ((x25 instanceof $c_Lcats_effect_kernel_Resource$Pure)) {
      var x$1$6 = $as_Lcats_effect_kernel_Resource$Pure(x25);
      var this$13 = $n(x$1$6);
      var x31 = this$13.Lcats_effect_kernel_Resource$Pure__f_a;
      var x20 = stack$tailLocal1;
      var x$3 = $ps_Lcats_effect_kernel_Resource__Nil$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$(Nil$lzy1$3);
      if ((x$3 === null)) {
        var $x_3 = (x20 === null);
      } else {
        var this$14 = $n(x$3);
        var $x_3 = (this$14 === x20);
      }
      if ($x_3) {
        return $n(onOutput$1).apply__O__O(x31);
      }
      if ((x20 instanceof $c_Lcats_effect_kernel_Resource$Frame$1)) {
        $n($p_Lcats_effect_kernel_Resource__Frame$2__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$3$($thiz, Frame$lzy1$3));
        var x$1$7 = $as_Lcats_effect_kernel_Resource$Frame$1(x20);
        var this$16 = $n(x$1$7);
        var x23 = this$16.Lcats_effect_kernel_Resource$Frame$1__f_head;
        var this$17 = $n(x$1$7);
        var x24 = this$17.Lcats_effect_kernel_Resource$Frame$1__f_tail;
        var current$tailLocal1$tmp2 = $as_Lcats_effect_kernel_Resource($n(x23).apply__O__O(x31));
        current$tailLocal1 = current$tailLocal1$tmp2;
        stack$tailLocal1 = x24;
        continue;
      }
      throw new $c_s_MatchError(x20);
    }
    if ((x25 instanceof $c_Lcats_effect_kernel_Resource$Eval)) {
      var x$1$8 = $as_Lcats_effect_kernel_Resource$Eval(x25);
      var this$19 = $n(x$1$8);
      var x28 = this$19.Lcats_effect_kernel_Resource$Eval__f_fa;
      var this$23 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(x28, F$1);
      var stack$tailLocal1$3$1 = stack$tailLocal1;
      var f = new $c_sjsr_AnonFunction1(((onOutput$1, onRelease$1, F$1, Nil$lzy1$3, Frame$lzy1$3, stack$tailLocal1$3) => ((a$1) => {
        var current$2 = new $c_Lcats_effect_kernel_Resource$Pure(a$1);
        return $p_Lcats_effect_kernel_Resource__loop$1__F1__F2__Lcats_effect_kernel_MonadCancel__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$1__O($thiz, onOutput$1, onRelease$1, F$1, Nil$lzy1$3, Frame$lzy1$3, current$2, stack$tailLocal1$3);
      }))(onOutput$1, onRelease$1, F$1, Nil$lzy1$3, Frame$lzy1$3, stack$tailLocal1$3$1));
      return $n(this$23.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$23.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
    }
    throw new $c_s_MatchError(x25);
  }
}
function $ps_Lcats_effect_kernel_Resource__allocate$1__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource__F1__O(F$7, r, storeFinalizer) {
  return $n(r).fold__F1__F2__Lcats_effect_kernel_MonadCancel__O(new $c_sjsr_AnonFunction1(((_$8) => $n(F$7).pure__O__O(_$8))), new $c_sjsr_AnonFunction2(((release, _$9) => {
    var release$1 = $as_F1(release);
    $as_Lcats_effect_kernel_Resource$ExitCase(_$9);
    return $n(storeFinalizer).apply__O__O(new $c_sjsr_AnonFunction1(((fin) => {
      var fin$1 = $as_F1(fin);
      return new $c_sjsr_AnonFunction1(((ec) => {
        var ec$1 = $as_Lcats_effect_kernel_Resource$ExitCase(ec);
        var this$3 = $n(F$7);
        var fa = this$3.pure__O__O((void 0));
        return $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa, new $c_sjsr_AnonFunction0((() => {
          var wrapped = $n(fin$1).apply__O__O(ec$1);
          var fin$2 = $n(release$1).apply__O__O(ec$1);
          return $n(F$7).guarantee__O__O__O(wrapped, fin$2);
        })), F$7);
      }));
    })));
  })), F$7);
}
function $ps_Lcats_effect_kernel_Resource__Nil$lzyINIT2$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$4$(Nil$lzy2$1) {
  if ((Nil$lzy2$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Lcats_effect_kernel_Resource$Nil$4$(($n(Nil$lzy2$1).sr_LazyRef__f__initialized ? $n(Nil$lzy2$1).sr_LazyRef__f__value : $n(Nil$lzy2$1).initialize__O__O(new $c_Lcats_effect_kernel_Resource$Nil$4$())));
}
function $ps_Lcats_effect_kernel_Resource__Nil$3__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$4$(Nil$lzy2$2) {
  return $as_Lcats_effect_kernel_Resource$Nil$4$(($n(Nil$lzy2$2).sr_LazyRef__f__initialized ? $n(Nil$lzy2$2).sr_LazyRef__f__value : $ps_Lcats_effect_kernel_Resource__Nil$lzyINIT2$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$4$(Nil$lzy2$2)));
}
function $p_Lcats_effect_kernel_Resource__Frame$lzyINIT2$1__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$6$($thiz, Frame$lzy2$1) {
  if ((Frame$lzy2$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Lcats_effect_kernel_Resource$Frame$6$(($n(Frame$lzy2$1).sr_LazyRef__f__initialized ? $n(Frame$lzy2$1).sr_LazyRef__f__value : $n(Frame$lzy2$1).initialize__O__O(new $c_Lcats_effect_kernel_Resource$Frame$6$($thiz))));
}
function $p_Lcats_effect_kernel_Resource__Frame$5__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$6$($thiz, Frame$lzy2$2) {
  return $as_Lcats_effect_kernel_Resource$Frame$6$(($n(Frame$lzy2$2).sr_LazyRef__f__initialized ? $n(Frame$lzy2$2).sr_LazyRef__f__value : $p_Lcats_effect_kernel_Resource__Frame$lzyINIT2$1__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$6$($thiz, Frame$lzy2$2)));
}
function $p_Lcats_effect_kernel_Resource__loop$2__Lcats_effect_kernel_MonadCancel__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$2__F1__O($thiz, F$37, Nil$lzy2$3, Frame$lzy2$3, current, stack, release) {
  var stack$tailLocal2 = stack;
  var current$tailLocal2 = current;
  while (true) {
    var x133 = current$tailLocal2;
    if ((x133 instanceof $c_Lcats_effect_kernel_Resource$Allocate)) {
      var x$1 = $as_Lcats_effect_kernel_Resource$Allocate(x133);
      var this$2 = $n(x$1);
      var x146 = this$2.Lcats_effect_kernel_Resource$Allocate__f_resource;
      var $x_1 = $n(F$37);
      var stack$tailLocal2$2$1 = stack$tailLocal2;
      return $n($x_1).uncancelable__F1__O(new $c_sjsr_AnonFunction1(((F$37, release, x146, Nil$lzy2$3, Frame$lzy2$3, stack$tailLocal2$2) => ((poll) => {
        var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
        var target = $n(x146).apply__O__O(poll$1);
        var this$18 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F$37);
        var f = new $c_sjsr_AnonFunction1(((x$1$1) => {
          var x$1$2 = $as_T2(x$1$1);
          if ((x$1$2 !== null)) {
            var b = $n(x$1$2)._1__O();
            var rel = $as_F1($n(x$1$2)._2__O());
            var rel2 = new $c_sjsr_AnonFunction1(((ec) => {
              var ec$1 = $as_Lcats_effect_kernel_Resource$ExitCase(ec);
              var wrapped = $n(rel).apply__O__O(ec$1);
              var fa = $n(F$37).unit__O();
              var fin = $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa, new $c_sjsr_AnonFunction0((() => $n(release).apply__O__O(ec$1))), F$37);
              return $n(F$37).guarantee__O__O__O(wrapped, fin);
            }));
            var x = $ps_Lcats_effect_kernel_Resource__Nil$3__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$4$(Nil$lzy2$3);
            if ((x === null)) {
              var $x_2 = (stack$tailLocal2$2 === null);
            } else {
              var this$8 = $n(x);
              var $x_2 = (this$8 === stack$tailLocal2$2);
            }
            if ($x_2) {
              return $n(F$37).pure__O__O(new $c_T2(b, rel2));
            }
            if ((stack$tailLocal2$2 instanceof $c_Lcats_effect_kernel_Resource$Frame$4)) {
              $n($p_Lcats_effect_kernel_Resource__Frame$5__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$6$($thiz, Frame$lzy2$3));
              var x$1$3 = $as_Lcats_effect_kernel_Resource$Frame$4(stack$tailLocal2$2);
              var this$11 = $n(x$1$3);
              var x123 = this$11.Lcats_effect_kernel_Resource$Frame$4__f_head;
              var this$12 = $n(x$1$3);
              var x124 = this$12.Lcats_effect_kernel_Resource$Frame$4__f_tail;
              var $x_3 = $n(poll$1);
              var current$1 = $as_Lcats_effect_kernel_Resource($n(x123).apply__O__O(b));
              var wrapped$1 = $n($x_3).apply__O__O($p_Lcats_effect_kernel_Resource__loop$2__Lcats_effect_kernel_MonadCancel__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$2__F1__O($thiz, F$37, Nil$lzy2$3, Frame$lzy2$3, current$1, x124, rel2));
              var fin$1 = $n(rel).apply__O__O($m_Lcats_effect_kernel_Resource$ExitCase$Canceled$());
              var fa$1 = $n(F$37).onCancel__O__O__O(wrapped$1, fin$1);
              var pf = new $c_Lcats_effect_kernel_Resource$$anon$2(F$37, rel);
              var this$17 = $n(F$37);
              return $f_Lcats_ApplicativeError__onError__O__s_PartialFunction__O(this$17, fa$1, pf);
            }
            throw new $c_s_MatchError(stack$tailLocal2$2);
          }
          throw new $c_s_MatchError(x$1$2);
        }));
        return $n(this$18.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$18.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
      }))(F$37, release, x146, Nil$lzy2$3, Frame$lzy2$3, stack$tailLocal2$2$1)));
    }
    if ((x133 instanceof $c_Lcats_effect_kernel_Resource$Bind)) {
      var x$1$4 = $as_Lcats_effect_kernel_Resource$Bind(x133);
      var this$20 = $n(x$1$4);
      var x142 = this$20.Lcats_effect_kernel_Resource$Bind__f_source;
      var this$21 = $n(x$1$4);
      var x143 = this$21.Lcats_effect_kernel_Resource$Bind__f_fs;
      var stack$tailLocal2$tmp1 = $n($p_Lcats_effect_kernel_Resource__Frame$5__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$6$($thiz, Frame$lzy2$3)).apply__F1__Lcats_effect_kernel_Resource$Stack$2__Lcats_effect_kernel_Resource$Frame$4(x143, stack$tailLocal2);
      current$tailLocal2 = x142;
      stack$tailLocal2 = stack$tailLocal2$tmp1;
      continue;
    }
    if ((x133 instanceof $c_Lcats_effect_kernel_Resource$Pure)) {
      var x$1$5 = $as_Lcats_effect_kernel_Resource$Pure(x133);
      var this$23 = $n(x$1$5);
      var x139 = this$23.Lcats_effect_kernel_Resource$Pure__f_a;
      var x128 = stack$tailLocal2;
      var x$2 = $ps_Lcats_effect_kernel_Resource__Nil$3__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$4$(Nil$lzy2$3);
      if ((x$2 === null)) {
        var $x_4 = (x128 === null);
      } else {
        var this$24 = $n(x$2);
        var $x_4 = (this$24 === x128);
      }
      if ($x_4) {
        var a = new $c_T2(x139, release);
        return $n(F$37).pure__O__O(a);
      }
      if ((x128 instanceof $c_Lcats_effect_kernel_Resource$Frame$4)) {
        $n($p_Lcats_effect_kernel_Resource__Frame$5__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$6$($thiz, Frame$lzy2$3));
        var x$1$6 = $as_Lcats_effect_kernel_Resource$Frame$4(x128);
        var this$29 = $n(x$1$6);
        var x131 = this$29.Lcats_effect_kernel_Resource$Frame$4__f_head;
        var this$30 = $n(x$1$6);
        var x132 = this$30.Lcats_effect_kernel_Resource$Frame$4__f_tail;
        var current$tailLocal2$tmp2 = $as_Lcats_effect_kernel_Resource($n(x131).apply__O__O(x139));
        current$tailLocal2 = current$tailLocal2$tmp2;
        stack$tailLocal2 = x132;
        continue;
      }
      throw new $c_s_MatchError(x128);
    }
    if ((x133 instanceof $c_Lcats_effect_kernel_Resource$Eval)) {
      var x$1$7 = $as_Lcats_effect_kernel_Resource$Eval(x133);
      var this$32 = $n(x$1$7);
      var x136 = this$32.Lcats_effect_kernel_Resource$Eval__f_fa;
      var this$36 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(x136, F$37);
      var stack$tailLocal2$3$1 = stack$tailLocal2;
      var f$1 = new $c_sjsr_AnonFunction1(((F$37, release, Nil$lzy2$3, Frame$lzy2$3, stack$tailLocal2$3) => ((a$1) => {
        var current$2 = new $c_Lcats_effect_kernel_Resource$Pure(a$1);
        return $p_Lcats_effect_kernel_Resource__loop$2__Lcats_effect_kernel_MonadCancel__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$2__F1__O($thiz, F$37, Nil$lzy2$3, Frame$lzy2$3, current$2, stack$tailLocal2$3, release);
      }))(F$37, release, Nil$lzy2$3, Frame$lzy2$3, stack$tailLocal2$3$1));
      return $n(this$36.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$36.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
    }
    throw new $c_s_MatchError(x133);
  }
}
function $p_Lcats_effect_kernel_Resource__State$lzyINIT1$1__Lcats_effect_kernel_GenConcurrent__sr_LazyRef__Lcats_effect_kernel_Resource$State$3$($thiz, F$52, State$lzy1$1) {
  if ((State$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Lcats_effect_kernel_Resource$State$3$(($n(State$lzy1$1).sr_LazyRef__f__initialized ? $n(State$lzy1$1).sr_LazyRef__f__value : $n(State$lzy1$1).initialize__O__O(new $c_Lcats_effect_kernel_Resource$State$3$(F$52, $thiz))));
}
function $p_Lcats_effect_kernel_Resource__State$2__Lcats_effect_kernel_GenConcurrent__sr_LazyRef__Lcats_effect_kernel_Resource$State$3$($thiz, F$53, State$lzy1$2) {
  return $as_Lcats_effect_kernel_Resource$State$3$(($n(State$lzy1$2).sr_LazyRef__f__initialized ? $n(State$lzy1$2).sr_LazyRef__f__value : $p_Lcats_effect_kernel_Resource__State$lzyINIT1$1__Lcats_effect_kernel_GenConcurrent__sr_LazyRef__Lcats_effect_kernel_Resource$State$3$($thiz, F$53, State$lzy1$2)));
}
/** @constructor */
function $c_Lcats_effect_kernel_Resource() {
}
$c_Lcats_effect_kernel_Resource.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource.prototype.constructor = $c_Lcats_effect_kernel_Resource;
/** @constructor */
function $h_Lcats_effect_kernel_Resource() {
}
$h_Lcats_effect_kernel_Resource.prototype = $c_Lcats_effect_kernel_Resource.prototype;
$c_Lcats_effect_kernel_Resource.prototype.fold__F1__F2__Lcats_effect_kernel_MonadCancel__O = (function(onOutput, onRelease, F) {
  var Nil$lzy1 = new $c_sr_LazyRef();
  var Frame$lzy1 = new $c_sr_LazyRef();
  return $p_Lcats_effect_kernel_Resource__loop$1__F1__F2__Lcats_effect_kernel_MonadCancel__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$1__O(this, onOutput, onRelease, F, Nil$lzy1, Frame$lzy1, this, $ps_Lcats_effect_kernel_Resource__Nil$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$(Nil$lzy1));
});
$c_Lcats_effect_kernel_Resource.prototype.use__F1__Lcats_effect_kernel_MonadCancel__O = (function(f, F) {
  return this.fold__F1__F2__Lcats_effect_kernel_MonadCancel__O(f, new $c_sjsr_AnonFunction2(((_$2, _$3) => {
    var _$2$1 = $as_F1(_$2);
    var _$3$1 = $as_Lcats_effect_kernel_Resource$ExitCase(_$3);
    return $n(_$2$1).apply__O__O(_$3$1);
  })), F);
});
$c_Lcats_effect_kernel_Resource.prototype.useForever__Lcats_effect_kernel_GenSpawn__O = (function(F) {
  return this.use__F1__Lcats_effect_kernel_MonadCancel__O(new $c_sjsr_AnonFunction1(((_$4) => $n(F).never__O())), F);
});
$c_Lcats_effect_kernel_Resource.prototype.use___Lcats_effect_kernel_MonadCancel__O = (function(F) {
  return this.use__F1__Lcats_effect_kernel_MonadCancel__O(new $c_sjsr_AnonFunction1(((_$5) => $n(F).unit__O())), F);
});
$c_Lcats_effect_kernel_Resource.prototype.both__Lcats_effect_kernel_Resource__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource = (function(that, F) {
  var noop = new $c_sjsr_AnonFunction1(((_$10) => {
    $as_Lcats_effect_kernel_Resource$ExitCase(_$10);
    var this$1 = $n(F);
    return this$1.pure__O__O((void 0));
  }));
  var bothFinalizers = $n(F).ref__O__O(new $c_T2(noop, noop));
  return $n($m_Lcats_effect_kernel_Resource$().makeCase__O__F2__Lcats_Functor__Lcats_effect_kernel_Resource(bothFinalizers, new $c_sjsr_AnonFunction2(((finalizers, ec) => {
    var finalizers$1 = $as_Lcats_effect_kernel_Ref(finalizers);
    var ec$1 = $as_Lcats_effect_kernel_Resource$ExitCase(ec);
    var target = $n(finalizers$1).get__O();
    var this$4 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F);
    var f = new $c_sjsr_AnonFunction1(((x$1) => {
      var x$1$1 = $as_T2(x$1);
      if ((x$1$1 !== null)) {
        var thisFin = $as_F1($n(x$1$1)._1__O());
        var thatFin = $as_F1($n(x$1$1)._2__O());
        return $n(F).void__O__O($n(F).both__O__O__O($n(thisFin).apply__O__O(ec$1), $n(thatFin).apply__O__O(ec$1)));
      }
      throw new $c_s_MatchError(x$1$1);
    }));
    return $n(this$4.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$4.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  })), F)).evalMap__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1(((store) => {
    var store$1 = $as_Lcats_effect_kernel_Ref(store);
    var thisStore = new $c_sjsr_AnonFunction1(((f$1) => {
      var f$2 = $as_F1(f$1);
      return $n(store$1).update__F1__O(new $c_sjsr_AnonFunction1(((_$11) => {
        var _$11$1 = $as_T2(_$11);
        var this$6 = $m_Lcats_Bifunctor$();
        var tc = $f_Lcats_instances_NTupleBifunctorInstances__catsStdBifunctorForTuple2__Lcats_Bifunctor(this$6);
        var this$9 = new $c_Lcats_Bifunctor$ToBifunctorOps$$anon$5(_$11$1, tc);
        var g = new $c_sjsr_AnonFunction1(((x) => {
          var x$2 = $as_F1(x);
          return x$2;
        }));
        return $as_T2($n(this$9.Lcats_Bifunctor$ToBifunctorOps$$anon$5__f_typeClassInstance).bimap__O__F1__F1__O(this$9.Lcats_Bifunctor$ToBifunctorOps$$anon$5__f_self, f$2, g));
      })));
    }));
    var thatStore = new $c_sjsr_AnonFunction1(((f$2$1) => {
      var f$3 = $as_F1(f$2$1);
      return $n(store$1).update__F1__O(new $c_sjsr_AnonFunction1(((_$12) => {
        var _$12$1 = $as_T2(_$12);
        var this$10 = $m_Lcats_Bifunctor$();
        var tc$1 = $f_Lcats_instances_NTupleBifunctorInstances__catsStdBifunctorForTuple2__Lcats_Bifunctor(this$10);
        var this$13 = new $c_Lcats_Bifunctor$ToBifunctorOps$$anon$5(_$12$1, tc$1);
        var f$4 = new $c_sjsr_AnonFunction1(((x$3) => {
          var x$4 = $as_F1(x$3);
          return x$4;
        }));
        return $as_T2($n(this$13.Lcats_Bifunctor$ToBifunctorOps$$anon$5__f_typeClassInstance).bimap__O__F1__F1__O(this$13.Lcats_Bifunctor$ToBifunctorOps$$anon$5__f_self, f$4, f$3));
      })));
    }));
    return $n(F).both__O__O__O($ps_Lcats_effect_kernel_Resource__allocate$1__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource__F1__O(F, this, thisStore), $ps_Lcats_effect_kernel_Resource__allocate$1__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource__F1__O(F, that, thatStore));
  })));
});
$c_Lcats_effect_kernel_Resource.prototype.map__F1__Lcats_effect_kernel_Resource = (function(f) {
  var f$1 = new $c_sjsr_AnonFunction1(((a) => {
    var a$1 = $n(f).apply__O__O(a);
    return new $c_Lcats_effect_kernel_Resource$Pure(a$1);
  }));
  return new $c_Lcats_effect_kernel_Resource$Bind(this, f$1);
});
$c_Lcats_effect_kernel_Resource.prototype.allocatedCase__Lcats_effect_kernel_MonadCancel__O = (function(F) {
  var Nil$lzy2 = new $c_sr_LazyRef();
  var Frame$lzy2 = new $c_sr_LazyRef();
  return $p_Lcats_effect_kernel_Resource__loop$2__Lcats_effect_kernel_MonadCancel__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$2__F1__O(this, F, Nil$lzy2, Frame$lzy2, this, $ps_Lcats_effect_kernel_Resource__Nil$3__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$4$(Nil$lzy2), new $c_sjsr_AnonFunction1(((_$27) => {
    $as_Lcats_effect_kernel_Resource$ExitCase(_$27);
    return $n(F).unit__O();
  })));
});
$c_Lcats_effect_kernel_Resource.prototype.allocated__Lcats_effect_kernel_MonadCancel__O = (function(F) {
  return $n(F).uncancelable__F1__O(new $c_sjsr_AnonFunction1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var target = $n(poll$1).apply__O__O(this.allocatedCase__Lcats_effect_kernel_MonadCancel__O(F));
    var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, F);
    var f = new $c_sjsr_AnonFunction1(((x$1) => {
      var x$1$1 = $as_T2(x$1);
      if ((x$1$1 !== null)) {
        var b = $n(x$1$1)._1__O();
        var fin = $as_F1($n(x$1$1)._2__O());
        var _2 = $n(fin).apply__O__O($m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$());
        return new $c_T2(b, _2);
      }
      throw new $c_s_MatchError(x$1$1);
    }));
    return $n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  })));
});
$c_Lcats_effect_kernel_Resource.prototype.evalMap__F1__Lcats_effect_kernel_Resource = (function(f) {
  var f$1 = new $c_sjsr_AnonFunction1(((a) => {
    var fa = $n(f).apply__O__O(a);
    return new $c_Lcats_effect_kernel_Resource$Eval(fa);
  }));
  return new $c_Lcats_effect_kernel_Resource$Bind(this, f$1);
});
$c_Lcats_effect_kernel_Resource.prototype.surround__O__Lcats_effect_kernel_MonadCancel__O = (function(gb, F) {
  return this.use__F1__Lcats_effect_kernel_MonadCancel__O(new $c_sjsr_AnonFunction1(((_$29) => gb)), F);
});
$c_Lcats_effect_kernel_Resource.prototype.forceR__Lcats_effect_kernel_Resource__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource = (function(that, F) {
  var resource = new $c_sjsr_AnonFunction1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var $x_1 = $n(poll$1);
    var wrapped = this.use___Lcats_effect_kernel_MonadCancel__O(F);
    var fb = $n(that).allocatedCase__Lcats_effect_kernel_MonadCancel__O(F);
    return $n($x_1).apply__O__O($n(F).forceR__O__O__O(wrapped, fb));
  }));
  return new $c_Lcats_effect_kernel_Resource$Allocate(resource);
});
$c_Lcats_effect_kernel_Resource.prototype.onCancel__Lcats_effect_kernel_Resource__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource = (function(fin, F) {
  var resource = new $c_sjsr_AnonFunction1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var wrapped = $n(poll$1).apply__O__O(this.allocatedCase__Lcats_effect_kernel_MonadCancel__O(F));
    var fin$1 = $n(fin).use___Lcats_effect_kernel_MonadCancel__O(F);
    return $n(F).onCancel__O__O__O(wrapped, fin$1);
  }));
  return new $c_Lcats_effect_kernel_Resource$Allocate(resource);
});
$c_Lcats_effect_kernel_Resource.prototype.guaranteeCase__F1__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource = (function(fin, F) {
  var resource = new $c_sjsr_AnonFunction1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var this$2 = $m_Lcats_effect_kernel_implicits$();
    var wrapped = $n(poll$1).apply__O__O(this.allocatedCase__Lcats_effect_kernel_MonadCancel__O(F));
    var ev$25 = $f_Lcats_effect_kernel_syntax_MonadCancelSyntax__monadCancelOps__O__Lcats_effect_kernel_MonadCancel__O(this$2, wrapped, F);
    var fin$1 = new $c_sjsr_AnonFunction1(((x$1) => {
      var x$1$1 = $as_Lcats_effect_kernel_Outcome(x$1);
      if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
        var x$1$2 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$1);
        var this$4 = $n(x$1$2);
        var x157 = this$4.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
        var this$6 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(x157, F);
        var f = new $c_sjsr_AnonFunction1(((_$31) => {
          var _$31$1 = $as_T2(_$31);
          return $n(_$31$1)._1__O();
        }));
        var fa = $n(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
        var fa$1 = new $c_Lcats_effect_kernel_Resource$Eval(fa);
        var fa$2 = $n($as_Lcats_effect_kernel_Resource($n(fin).apply__O__O(new $c_Lcats_effect_kernel_Outcome$Succeeded(fa$1)))).use___Lcats_effect_kernel_MonadCancel__O(F);
        var f$3 = new $c_sjsr_AnonFunction1(((e) => {
          var e$1 = $as_jl_Throwable(e);
          var this$13 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(x157, F);
          var f$1 = new $c_sjsr_AnonFunction1(((_$32) => {
            var _$32$1 = $as_T2(_$32);
            return $n($as_F1($n(_$32$1)._2__O())).apply__O__O(new $c_Lcats_effect_kernel_Resource$ExitCase$Errored(e$1));
          }));
          var fa$3 = $n(this$13.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$13.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
          var f$2 = new $c_sjsr_AnonFunction1(((_$33) => {
            $as_jl_Throwable(_$33);
          }));
          var fa$4 = $n(F).handleError__O__F1__O(fa$3, f$2);
          return $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa$4, new $c_sjsr_AnonFunction0((() => $n(F).raiseError__O__O(e$1))), F);
        }));
        return $n(F).handleErrorWith__O__F1__O(fa$2, f$3);
      }
      if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
        var x$1$3 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$1);
        var this$19 = $n(x$1$3);
        var x154 = $as_jl_Throwable(this$19.Lcats_effect_kernel_Outcome$Errored__f_e);
        var fa$5 = $n($as_Lcats_effect_kernel_Resource($n(fin).apply__O__O(new $c_Lcats_effect_kernel_Outcome$Errored(x154)))).use___Lcats_effect_kernel_MonadCancel__O(F);
        var f$4 = new $c_sjsr_AnonFunction1(((_$34) => {
          $as_jl_Throwable(_$34);
        }));
        return $n(F).handleError__O__F1__O(fa$5, f$4);
      }
      if (((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$1), true))) {
        return $n($as_Lcats_effect_kernel_Resource($n(fin).apply__O__O(new $c_Lcats_effect_kernel_Outcome$Canceled()))).use___Lcats_effect_kernel_MonadCancel__O(F);
      }
      throw new $c_s_MatchError(x$1$1);
    }));
    return $n(F).guaranteeCase__O__F1__O(ev$25, fin$1);
  }));
  return new $c_Lcats_effect_kernel_Resource$Allocate(resource);
});
$c_Lcats_effect_kernel_Resource.prototype.start__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource = (function(F) {
  var State$lzy1 = new $c_sr_LazyRef();
  var $x_7 = $m_Lcats_effect_kernel_Resource$();
  var target = $n(F).ref__O__O($n($p_Lcats_effect_kernel_Resource__State$2__Lcats_effect_kernel_GenConcurrent__sr_LazyRef__Lcats_effect_kernel_Resource$State$3$(this, F, State$lzy1)).apply__O__Z__Z__Lcats_effect_kernel_Resource$State$1($n($p_Lcats_effect_kernel_Resource__State$2__Lcats_effect_kernel_GenConcurrent__sr_LazyRef__Lcats_effect_kernel_Resource$State$3$(this, F, State$lzy1)).$lessinit$greater$default$1__O(), ($n($p_Lcats_effect_kernel_Resource__State$2__Lcats_effect_kernel_GenConcurrent__sr_LazyRef__Lcats_effect_kernel_Resource$State$3$(this, F, State$lzy1)), false), ($n($p_Lcats_effect_kernel_Resource__State$2__Lcats_effect_kernel_GenConcurrent__sr_LazyRef__Lcats_effect_kernel_Resource$State$3$(this, F, State$lzy1)), false)));
  var this$30 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F);
  var f$3 = new $c_sjsr_AnonFunction1(((state) => {
    var state$1 = $as_Lcats_effect_kernel_Ref(state);
    var finalized = $n(F).uncancelable__F1__O(new $c_sjsr_AnonFunction1(((poll) => {
      var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
      var wrapped = $n(poll$1).apply__O__O(this.allocated__Lcats_effect_kernel_MonadCancel__O(F));
      var fin = $n(state$1).update__F1__O(new $c_sjsr_AnonFunction1(((s) => {
        var s$1 = $as_Lcats_effect_kernel_Resource$State$1(s);
        if ($n(s$1).Lcats_effect_kernel_Resource$State$1__f_finalizeOnComplete) {
          var $x_2 = $n(s$1);
          var this$4 = $n(s$1);
          var $x_1 = this$4.Lcats_effect_kernel_Resource$State$1__f_fin;
          var this$5 = $n(s$1);
          return $n($x_2).copy__O__Z__Z__Lcats_effect_kernel_Resource$State$1($x_1, this$5.Lcats_effect_kernel_Resource$State$1__f_finalizeOnComplete, true);
        } else {
          return s$1;
        }
      })));
      var target$1 = $n(F).guarantee__O__O__O(wrapped, fin);
      var this$20 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, F);
      var f$1 = new $c_sjsr_AnonFunction1(((x$1) => {
        var x$1$1 = $as_T2(x$1);
        if ((x$1$1 !== null)) {
          var a = $n(x$1$1)._1__O();
          var rel = $n(x$1$1)._2__O();
          var action = $n(state$1).modify__F1__O(new $c_sjsr_AnonFunction1(((s$2) => {
            var s$3 = $as_Lcats_effect_kernel_Resource$State$1(s$2);
            if ($n(s$3).Lcats_effect_kernel_Resource$State$1__f_confirmedFinalizeOnComplete) {
              var f = new $c_sjsr_AnonFunction1(((_$36) => {
                $as_jl_Throwable(_$36);
              }));
              var _2 = $n(F).handleError__O__F1__O(rel, f);
              return new $c_T2(s$3, _2);
            } else {
              var $x_4 = $n(s$3);
              var this$11 = $n(s$3);
              var $x_3 = this$11.Lcats_effect_kernel_Resource$State$1__f_finalizeOnComplete;
              var this$12 = $n(s$3);
              var _1 = $n($x_4).copy__O__Z__Z__Lcats_effect_kernel_Resource$State$1(rel, $x_3, this$12.Lcats_effect_kernel_Resource$State$1__f_confirmedFinalizeOnComplete);
              var this$13 = $n(F);
              var _2$1 = this$13.pure__O__O((void 0));
              return new $c_T2(_1, _2$1);
            }
          })));
          var this$17 = $n(F);
          var target$2 = $f_Lcats_FlatMap__flatten__O__O(this$17, action);
          var this$19 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, F);
          return $n(this$19.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$19.Lcats_Functor$ToFunctorOps$$anon$5__f_self, a);
        }
        throw new $c_s_MatchError(x$1$1);
      }));
      return $n(this$20.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$20.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
    })));
    var target$3 = $n(F).start__O__O(finalized);
    var this$29 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, F);
    var f$2 = new $c_sjsr_AnonFunction1(((outer) => {
      var outer$1 = $as_Lcats_effect_kernel_Fiber(outer);
      var fiber = new $c_Lcats_effect_kernel_Resource$$anon$4(F, state$1, outer$1);
      var ffa = $n(state$1).modify__F1__O(new $c_sjsr_AnonFunction1(((s$4) => {
        var s$5 = $as_Lcats_effect_kernel_Resource$State$1(s$4);
        var $x_6 = $n(s$5);
        var this$22 = $n(s$5);
        var $x_5 = this$22.Lcats_effect_kernel_Resource$State$1__f_fin;
        var this$23 = $n(s$5);
        var _1$1 = $n($x_6).copy__O__Z__Z__Lcats_effect_kernel_Resource$State$1($x_5, true, this$23.Lcats_effect_kernel_Resource$State$1__f_confirmedFinalizeOnComplete);
        var _2$2 = $n(s$5).Lcats_effect_kernel_Resource$State$1__f_fin;
        return new $c_T2(_1$1, _2$2);
      })));
      var this$27 = $n(F);
      var finalizeOuter = $f_Lcats_FlatMap__flatten__O__O(this$27, ffa);
      return new $c_T2(fiber, finalizeOuter);
    }));
    return $n(this$29.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$29.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$2);
  }));
  return $n($x_7).apply__O__Lcats_Functor__Lcats_effect_kernel_Resource($n(this$30.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$30.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3), F);
});
$c_Lcats_effect_kernel_Resource.prototype.attempt__Lcats_ApplicativeError__Lcats_effect_kernel_Resource = (function(F) {
  if ((this instanceof $c_Lcats_effect_kernel_Resource$Allocate)) {
    var x$1 = $as_Lcats_effect_kernel_Resource$Allocate(this);
    var this$2 = $n(x$1);
    var x201 = this$2.Lcats_effect_kernel_Resource$Allocate__f_resource;
    var resource = new $c_sjsr_AnonFunction1(((poll) => {
      var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
      var fa = $n(x201).apply__O__O(poll$1);
      var target = $n(F).attempt__O__O(fa);
      var this$10 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, F);
      var f = new $c_sjsr_AnonFunction1(((x$1$1) => {
        var x$1$2 = $as_s_util_Either(x$1$1);
        if ((x$1$2 instanceof $c_s_util_Left)) {
          var error = $n($as_s_util_Left(x$1$2)).s_util_Left__f_value;
          var _1 = new $c_s_util_Left(error);
          var _2 = new $c_sjsr_AnonFunction1(((_$44) => {
            $as_Lcats_effect_kernel_Resource$ExitCase(_$44);
            return $n(F).unit__O();
          }));
          return new $c_T2(_1, _2);
        }
        if ((x$1$2 instanceof $c_s_util_Right)) {
          var x178 = $as_T2($n($as_s_util_Right(x$1$2)).s_util_Right__f_value);
          if ((x178 !== null)) {
            var a = $n(x178)._1__O();
            var release = $as_F1($n(x178)._2__O());
            var _1$1 = new $c_s_util_Right(a);
            return new $c_T2(_1$1, release);
          }
        }
        throw new $c_s_MatchError(x$1$2);
      }));
      return $n(this$10.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$10.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
    }));
    return new $c_Lcats_effect_kernel_Resource$Allocate(resource);
  }
  if ((this instanceof $c_Lcats_effect_kernel_Resource$Bind)) {
    var x$1$3 = $as_Lcats_effect_kernel_Resource$Bind(this);
    var this$14 = $n(x$1$3);
    var x197 = this$14.Lcats_effect_kernel_Resource$Bind__f_source;
    var this$15 = $n(x$1$3);
    var x198 = this$15.Lcats_effect_kernel_Resource$Bind__f_fs;
    var this$18 = new $c_Lcats_effect_kernel_Resource$Pure((void 0));
    var f$1 = new $c_sjsr_AnonFunction1(((_$45) => {
      $as_jl_Void(_$45);
      return $n(x197).attempt__Lcats_ApplicativeError__Lcats_effect_kernel_Resource(F);
    }));
    var this$25 = new $c_Lcats_effect_kernel_Resource$Bind(this$18, f$1);
    var f$2 = new $c_sjsr_AnonFunction1(((x$1$4) => {
      var x$1$5 = $as_s_util_Either(x$1$4);
      if ((x$1$5 instanceof $c_s_util_Left)) {
        var error$1 = $n($as_s_util_Left(x$1$5)).s_util_Left__f_value;
        var a$1 = new $c_s_util_Left(error$1);
        return new $c_Lcats_effect_kernel_Resource$Pure(a$1);
      }
      if ((x$1$5 instanceof $c_s_util_Right)) {
        var s = $n($as_s_util_Right(x$1$5)).s_util_Right__f_value;
        return $n($as_Lcats_effect_kernel_Resource($n(x198).apply__O__O(s))).attempt__Lcats_ApplicativeError__Lcats_effect_kernel_Resource(F);
      }
      throw new $c_s_MatchError(x$1$5);
    }));
    return new $c_Lcats_effect_kernel_Resource$Bind(this$25, f$2);
  }
  if ((this instanceof $c_Lcats_effect_kernel_Resource$Pure)) {
    var x$1$6 = $as_Lcats_effect_kernel_Resource$Pure(this);
    var this$28 = $n(x$1$6);
    var p = $as_Lcats_effect_kernel_Resource$Pure(this);
    var a$2 = $n(p).Lcats_effect_kernel_Resource$Pure__f_a;
    var a$3 = new $c_s_util_Right(a$2);
    return new $c_Lcats_effect_kernel_Resource$Pure(a$3);
  }
  if ((this instanceof $c_Lcats_effect_kernel_Resource$Eval)) {
    var x$1$7 = $as_Lcats_effect_kernel_Resource$Eval(this);
    var this$35 = $n(x$1$7);
    var e = $as_Lcats_effect_kernel_Resource$Eval(this);
    var fa$1 = $n(e).Lcats_effect_kernel_Resource$Eval__f_fa;
    var fa$2 = $n(F).attempt__O__O(fa$1);
    return new $c_Lcats_effect_kernel_Resource$Eval(fa$2);
  }
  throw new $c_s_MatchError(this);
});
$c_Lcats_effect_kernel_Resource.prototype.handleErrorWith__F1__Lcats_ApplicativeError__Lcats_effect_kernel_Resource = (function(f, F) {
  var this$3 = $n(this.attempt__Lcats_ApplicativeError__Lcats_effect_kernel_Resource(F));
  var f$1 = new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_s_util_Either(x$1);
    if ((x$1$1 instanceof $c_s_util_Right)) {
      var a = $n($as_s_util_Right(x$1$1)).s_util_Right__f_value;
      return new $c_Lcats_effect_kernel_Resource$Pure(a);
    }
    if ((x$1$1 instanceof $c_s_util_Left)) {
      var e = $n($as_s_util_Left(x$1$1)).s_util_Left__f_value;
      return $as_Lcats_effect_kernel_Resource($n(f).apply__O__O(e));
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return new $c_Lcats_effect_kernel_Resource$Bind(this$3, f$1);
});
function $as_Lcats_effect_kernel_Resource(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource"));
}
function $isArrayOf_Lcats_effect_kernel_Resource(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource)));
}
function $asArrayOf_Lcats_effect_kernel_Resource(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource;", depth));
}
/** @constructor */
function $c_Lcats_effect_kernel_ResourceFOInstances0() {
}
$c_Lcats_effect_kernel_ResourceFOInstances0.prototype = new $h_Lcats_effect_kernel_ResourceFOInstances1();
$c_Lcats_effect_kernel_ResourceFOInstances0.prototype.constructor = $c_Lcats_effect_kernel_ResourceFOInstances0;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceFOInstances0() {
}
$h_Lcats_effect_kernel_ResourceFOInstances0.prototype = $c_Lcats_effect_kernel_ResourceFOInstances0.prototype;
/** @constructor */
function $c_Lcats_effect_kernel_Unique$Token() {
}
$c_Lcats_effect_kernel_Unique$Token.prototype = new $h_O();
$c_Lcats_effect_kernel_Unique$Token.prototype.constructor = $c_Lcats_effect_kernel_Unique$Token;
/** @constructor */
function $h_Lcats_effect_kernel_Unique$Token() {
}
$h_Lcats_effect_kernel_Unique$Token.prototype = $c_Lcats_effect_kernel_Unique$Token.prototype;
function $as_Lcats_effect_kernel_Unique$Token(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Unique$Token) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Unique$Token"));
}
function $isArrayOf_Lcats_effect_kernel_Unique$Token(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Unique$Token)));
}
function $asArrayOf_Lcats_effect_kernel_Unique$Token(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Unique$Token(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Unique$Token;", depth));
}
var $d_Lcats_effect_kernel_Unique$Token = new $TypeData().initClass($c_Lcats_effect_kernel_Unique$Token, "cats.effect.kernel.Unique$Token", ({
  Lcats_effect_kernel_Unique$Token: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_metrics_JsCpuStarvationMetrics() {
}
$c_Lcats_effect_metrics_JsCpuStarvationMetrics.prototype = new $h_O();
$c_Lcats_effect_metrics_JsCpuStarvationMetrics.prototype.constructor = $c_Lcats_effect_metrics_JsCpuStarvationMetrics;
/** @constructor */
function $h_Lcats_effect_metrics_JsCpuStarvationMetrics() {
}
$h_Lcats_effect_metrics_JsCpuStarvationMetrics.prototype = $c_Lcats_effect_metrics_JsCpuStarvationMetrics.prototype;
var $d_Lcats_effect_metrics_JsCpuStarvationMetrics = new $TypeData().initClass($c_Lcats_effect_metrics_JsCpuStarvationMetrics, "cats.effect.metrics.JsCpuStarvationMetrics", ({
  Lcats_effect_metrics_JsCpuStarvationMetrics: 1,
  Lcats_effect_metrics_CpuStarvationMetrics: 1
}));
/** @constructor */
function $c_Lcats_effect_std_AtomicCell$AsyncImpl(init, mutex, F) {
  this.Lcats_effect_std_AtomicCell$AsyncImpl__f_mutex = null;
  this.Lcats_effect_std_AtomicCell$AsyncImpl__f_F = null;
  this.Lcats_effect_std_AtomicCell$AsyncImpl__f_cell = null;
  this.Lcats_effect_std_AtomicCell$AsyncImpl__f_mutex = mutex;
  this.Lcats_effect_std_AtomicCell$AsyncImpl__f_F = F;
  this.Lcats_effect_std_AtomicCell$AsyncImpl__f_cell = init;
}
$c_Lcats_effect_std_AtomicCell$AsyncImpl.prototype = new $h_Lcats_effect_std_AtomicCell();
$c_Lcats_effect_std_AtomicCell$AsyncImpl.prototype.constructor = $c_Lcats_effect_std_AtomicCell$AsyncImpl;
/** @constructor */
function $h_Lcats_effect_std_AtomicCell$AsyncImpl() {
}
$h_Lcats_effect_std_AtomicCell$AsyncImpl.prototype = $c_Lcats_effect_std_AtomicCell$AsyncImpl.prototype;
$c_Lcats_effect_std_AtomicCell$AsyncImpl.prototype.evalModify__F1__O = (function(f) {
  var $x_1 = $n($n(this.Lcats_effect_std_AtomicCell$AsyncImpl__f_mutex).Lcats_effect_std_Mutex$ConcurrentImpl__f_lock);
  var target = $n(this.Lcats_effect_std_AtomicCell$AsyncImpl__f_F).delay__F0__O(new $c_sjsr_AnonFunction0((() => this.Lcats_effect_std_AtomicCell$AsyncImpl__f_cell)));
  var tc = this.Lcats_effect_std_AtomicCell$AsyncImpl__f_F;
  var this$3 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var target$1 = $n(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  var tc$1 = this.Lcats_effect_std_AtomicCell$AsyncImpl__f_F;
  var this$5 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
  var f$1 = new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var a = $n(x$1$1)._1__O();
      var b = $n(x$1$1)._2__O();
      return $n(this.Lcats_effect_std_AtomicCell$AsyncImpl__f_F).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
        this.Lcats_effect_std_AtomicCell$AsyncImpl__f_cell = a;
        return b;
      })));
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return $n($x_1).surround__O__Lcats_effect_kernel_MonadCancel__O($n(this$5.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$5.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1), this.Lcats_effect_std_AtomicCell$AsyncImpl__f_F);
});
$c_Lcats_effect_std_AtomicCell$AsyncImpl.prototype.evalUpdate__F1__O = (function(f) {
  return this.evalModify__F1__O(new $c_sjsr_AnonFunction1(((a) => {
    var target = $n(f).apply__O__O(a);
    var tc = this.Lcats_effect_std_AtomicCell$AsyncImpl__f_F;
    var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
    var f$1 = new $c_sjsr_AnonFunction1(((aa) => new $c_T2(aa, (void 0))));
    return $n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
  })));
});
var $d_Lcats_effect_std_AtomicCell$AsyncImpl = new $TypeData().initClass($c_Lcats_effect_std_AtomicCell$AsyncImpl, "cats.effect.std.AtomicCell$AsyncImpl", ({
  Lcats_effect_std_AtomicCell$AsyncImpl: 1,
  Lcats_effect_std_AtomicCell: 1
}));
/** @constructor */
function $c_Lcats_effect_std_AtomicCell$ConcurrentImpl(ref, mutex, F) {
  this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_ref = null;
  this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_mutex = null;
  this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_F = null;
  this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_ref = ref;
  this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_mutex = mutex;
  this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_F = F;
}
$c_Lcats_effect_std_AtomicCell$ConcurrentImpl.prototype = new $h_Lcats_effect_std_AtomicCell();
$c_Lcats_effect_std_AtomicCell$ConcurrentImpl.prototype.constructor = $c_Lcats_effect_std_AtomicCell$ConcurrentImpl;
/** @constructor */
function $h_Lcats_effect_std_AtomicCell$ConcurrentImpl() {
}
$h_Lcats_effect_std_AtomicCell$ConcurrentImpl.prototype = $c_Lcats_effect_std_AtomicCell$ConcurrentImpl.prototype;
$c_Lcats_effect_std_AtomicCell$ConcurrentImpl.prototype.evalModify__F1__O = (function(f) {
  var $x_1 = $n($n(this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_mutex).Lcats_effect_std_Mutex$ConcurrentImpl__f_lock);
  var target = $n(this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_ref).get__O();
  var tc = this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_F;
  var this$2 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var target$1 = $n(this$2.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$2.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  var tc$1 = this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_F;
  var this$7 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
  var f$1 = new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var a = $n(x$1$1)._1__O();
      var b = $n(x$1$1)._2__O();
      var target$2 = $n(this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_ref).set__O__O(a);
      var tc$2 = this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_F;
      var this$6 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, tc$2);
      return $n(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b);
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return $n($x_1).surround__O__Lcats_effect_kernel_MonadCancel__O($n(this$7.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$7.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1), this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_F);
});
$c_Lcats_effect_std_AtomicCell$ConcurrentImpl.prototype.evalUpdate__F1__O = (function(f) {
  return this.evalModify__F1__O(new $c_sjsr_AnonFunction1(((a) => {
    var target = $n(f).apply__O__O(a);
    var tc = this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_F;
    var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
    var f$1 = new $c_sjsr_AnonFunction1(((aa) => new $c_T2(aa, (void 0))));
    return $n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
  })));
});
var $d_Lcats_effect_std_AtomicCell$ConcurrentImpl = new $TypeData().initClass($c_Lcats_effect_std_AtomicCell$ConcurrentImpl, "cats.effect.std.AtomicCell$ConcurrentImpl", ({
  Lcats_effect_std_AtomicCell$ConcurrentImpl: 1,
  Lcats_effect_std_AtomicCell: 1
}));
function $is_Lcats_effect_std_Console(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_std_Console)));
}
function $as_Lcats_effect_std_Console(obj) {
  return (($is_Lcats_effect_std_Console(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Console"));
}
function $isArrayOf_Lcats_effect_std_Console(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Console)));
}
function $asArrayOf_Lcats_effect_std_Console(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Console(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Console;", depth));
}
/** @constructor */
function $c_Lcats_effect_std_Console$() {
}
$c_Lcats_effect_std_Console$.prototype = new $h_Lcats_effect_std_ConsoleCompanionCrossPlatform();
$c_Lcats_effect_std_Console$.prototype.constructor = $c_Lcats_effect_std_Console$;
/** @constructor */
function $h_Lcats_effect_std_Console$() {
}
$h_Lcats_effect_std_Console$.prototype = $c_Lcats_effect_std_Console$.prototype;
$c_Lcats_effect_std_Console$.prototype.make__Lcats_effect_kernel_Async__Lcats_effect_std_Console = (function(F) {
  try {
    var r1 = process.stdout;
    var $x_1 = new $c_s_util_Success(r1);
  } catch (e) {
    var $x_1;
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      var $x_1 = new $c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2));
    }
  }
  var this$2 = $n($n($x_1).toOption__s_Option());
  if (this$2.isEmpty__Z()) {
    var $x_2 = $m_s_None$();
  } else {
    var arg1 = this$2.get__O();
    var $x_2 = $m_s_Option$().apply__O__s_Option(arg1);
  }
  var this$3 = $n($x_2);
  if (this$3.isEmpty__Z()) {
    var $x_3 = true;
  } else {
    var arg1$1 = this$3.get__O();
    var $x_3 = (!(arg1$1 === (void 0)));
  }
  if ($x_3) {
    var stdout = this$3;
  } else {
    var stdout = $m_s_None$();
  }
  try {
    var r1$1 = process.stderr;
    var $x_4 = new $c_s_util_Success(r1$1);
  } catch (e$1) {
    var $x_4;
    var e$2$1 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$1)) {
      var $x_4 = new $c_s_util_Failure(e$2$1);
    } else {
      throw ((e$2$1 instanceof $c_sjs_js_JavaScriptException) ? e$2$1.sjs_js_JavaScriptException__f_exception : $n(e$2$1));
    }
  }
  var this$6 = $n($n($x_4).toOption__s_Option());
  if (this$6.isEmpty__Z()) {
    var $x_5 = $m_s_None$();
  } else {
    var arg1$2 = this$6.get__O();
    var $x_5 = $m_s_Option$().apply__O__s_Option(arg1$2);
  }
  var this$7 = $n($x_5);
  if (this$7.isEmpty__Z()) {
    var $x_6 = true;
  } else {
    var arg1$3 = this$7.get__O();
    var $x_6 = (!(arg1$3 === (void 0)));
  }
  if ($x_6) {
    var stderr = this$7;
  } else {
    var stderr = $m_s_None$();
  }
  var F$1 = $as_Lcats_Alternative($m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption);
  var this$11 = new $c_Lcats_syntax_ApplySyntax$$anon$1(stdout, F$1);
  var f = new $c_sjsr_AnonFunction2(((_$8, _$9) => new $c_Lcats_effect_std_Console$NodeJSConsole(_$8, _$9, F)));
  var this$12 = $n($as_s_Option($n(this$11.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance).map2__O__O__F2__O(this$11.Lcats_syntax_ApplySyntax$$anon$1__f_self, stderr, f)));
  return $as_Lcats_effect_std_Console((this$12.isEmpty__Z() ? new $c_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole(this, F) : this$12.get__O()));
});
var $d_Lcats_effect_std_Console$ = new $TypeData().initClass($c_Lcats_effect_std_Console$, "cats.effect.std.Console$", ({
  Lcats_effect_std_Console$: 1,
  Lcats_effect_std_ConsoleCompanionCrossPlatform: 1
}));
var $n_Lcats_effect_std_Console$;
function $m_Lcats_effect_std_Console$() {
  if ((!$n_Lcats_effect_std_Console$)) {
    $n_Lcats_effect_std_Console$ = new $c_Lcats_effect_std_Console$();
  }
  return $n_Lcats_effect_std_Console$;
}
function $f_Lcats_effect_std_Dispatcher__unsafeToFuture__O__s_concurrent_Future($thiz, fa) {
  return $as_s_concurrent_Future($n($thiz.unsafeToFutureCancelable__O__T2(fa))._1__O());
}
function $f_Lcats_effect_std_Dispatcher__unsafeRunAndForget__O__V($thiz, fa) {
  $n($f_Lcats_effect_std_Dispatcher__unsafeToFuture__O__s_concurrent_Future($thiz, fa)).onComplete__F1__s_concurrent_ExecutionContext__V(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_s_util_Try(x$1);
    if ((x$1$1 instanceof $c_s_util_Failure)) {
      var ex = $n($as_s_util_Failure(x$1$1)).s_util_Failure__f_exception;
      $thiz.reportFailure__jl_Throwable__V(ex);
    }
  })), $m_Lcats_effect_std_Dispatcher$().Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$parasiticEC);
}
function $is_Lcats_effect_std_Dispatcher(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_std_Dispatcher)));
}
function $as_Lcats_effect_std_Dispatcher(obj) {
  return (($is_Lcats_effect_std_Dispatcher(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher;", depth));
}
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$$anon$1() {
}
$c_Lcats_effect_std_Dispatcher$$anon$1.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$$anon$1.prototype.constructor = $c_Lcats_effect_std_Dispatcher$$anon$1;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$$anon$1() {
}
$h_Lcats_effect_std_Dispatcher$$anon$1.prototype = $c_Lcats_effect_std_Dispatcher$$anon$1.prototype;
$c_Lcats_effect_std_Dispatcher$$anon$1.prototype.execute__jl_Runnable__V = (function(runnable) {
  $n(runnable).run__V();
});
$c_Lcats_effect_std_Dispatcher$$anon$1.prototype.reportFailure__jl_Throwable__V = (function(t) {
  var this$1 = $n(t);
  this$1.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err);
});
var $d_Lcats_effect_std_Dispatcher$$anon$1 = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$$anon$1, "cats.effect.std.Dispatcher$$anon$1", ({
  Lcats_effect_std_Dispatcher$$anon$1: 1,
  s_concurrent_ExecutionContext: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Executor$$anon$3(evidence$10$2) {
  this.Lcats_effect_std_Dispatcher$Executor$$anon$3__f_evidence$10$1 = null;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$3__f_evidence$10$1 = evidence$10$2;
}
$c_Lcats_effect_std_Dispatcher$Executor$$anon$3.prototype = new $h_Lcats_effect_std_Dispatcher$Executor();
$c_Lcats_effect_std_Dispatcher$Executor$$anon$3.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Executor$$anon$3;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Executor$$anon$3() {
}
$h_Lcats_effect_std_Dispatcher$Executor$$anon$3.prototype = $c_Lcats_effect_std_Dispatcher$Executor$$anon$3.prototype;
$c_Lcats_effect_std_Dispatcher$Executor$$anon$3.prototype.apply__O__F1__O = (function(task, registerCancel) {
  var F = this.Lcats_effect_std_Dispatcher$Executor$$anon$3__f_evidence$10$1;
  var target = $n(F).deferred__O();
  var tc = this.Lcats_effect_std_Dispatcher$Executor$$anon$3__f_evidence$10$1;
  var this$11 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f = new $c_sjsr_AnonFunction1(((d$1) => {
    var d$2 = $as_Lcats_effect_kernel_Deferred(d$1);
    var fa = $n(registerCancel).apply__O__O($n(d$2).get__O());
    var F$1 = this.Lcats_effect_std_Dispatcher$Executor$$anon$3__f_evidence$10$1;
    var this$5 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa, F$1);
    var this$6 = $n(this$5.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
    var fa$1 = this$5.Lcats_syntax_ApplySyntax$$anon$1__f_self;
    var wrapped = this$6.productR__O__O__O(fa$1, task);
    var target$1 = $n(d$2).complete__O__O((void 0));
    var tc$1 = this.Lcats_effect_std_Dispatcher$Executor$$anon$3__f_evidence$10$1;
    var this$9 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, tc$1);
    var fin = $n(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
    var F$2 = this.Lcats_effect_std_Dispatcher$Executor$$anon$3__f_evidence$10$1;
    return $n(F$2).guarantee__O__O__O(wrapped, fin);
  }));
  return $n(this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
});
var $d_Lcats_effect_std_Dispatcher$Executor$$anon$3 = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Executor$$anon$3, "cats.effect.std.Dispatcher$Executor$$anon$3", ({
  Lcats_effect_std_Dispatcher$Executor$$anon$3: 1,
  Lcats_effect_std_Dispatcher$Executor: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Executor$$anon$4(evidence$11$16, tasks$7, shutoff$4, spawnExecutor$4, fiberR$2, TaskState$lzy1$13) {
  this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14 = null;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_tasks$6 = null;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_shutoff$3 = null;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_spawnExecutor$3 = null;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_fiberR$1 = null;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_TaskState$lzy1$11 = null;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14 = evidence$11$16;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_tasks$6 = tasks$7;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_shutoff$3 = shutoff$4;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_spawnExecutor$3 = spawnExecutor$4;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_fiberR$1 = fiberR$2;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_TaskState$lzy1$11 = TaskState$lzy1$13;
}
$c_Lcats_effect_std_Dispatcher$Executor$$anon$4.prototype = new $h_Lcats_effect_std_Dispatcher$Executor();
$c_Lcats_effect_std_Dispatcher$Executor$$anon$4.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Executor$$anon$4;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Executor$$anon$4() {
}
$h_Lcats_effect_std_Dispatcher$Executor$$anon$4.prototype = $c_Lcats_effect_std_Dispatcher$Executor$$anon$4.prototype;
$c_Lcats_effect_std_Dispatcher$Executor$$anon$4.prototype.apply__O__F1__O = (function(task, registerCancel) {
  var F = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14;
  var target = $n(F).ref__O__O($n($n($m_Lcats_effect_std_Dispatcher$Executor$().cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_TaskState$lzy1$11)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Ready$lzy1).apply__O__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready(task));
  var tc = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14;
  var this$58 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f$16 = new $c_sjsr_AnonFunction1(((taskR) => {
    var taskR$1 = $as_Lcats_effect_kernel_Ref(taskR);
    var F$1 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14;
    var target$1 = $n(F$1).deferred__O();
    var tc$1 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14;
    var this$51 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
    var f$14 = new $c_sjsr_AnonFunction1(((cancelLatch) => {
      var cancelLatch$1 = $as_Lcats_effect_kernel_Deferred(cancelLatch);
      return $n(taskR$1).flatModify__F1__Lcats_effect_kernel_MonadCancel__O(new $c_sjsr_AnonFunction1(((x$1) => {
        var x$1$1 = $as_Lcats_effect_std_Dispatcher$Executor$TaskState$1(x$1);
        matchAlts5: {
          matchAlts6: {
            if (((x$1$1 instanceof $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready) && ($n($as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready(x$1$1)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready__f_$outer === $m_Lcats_effect_std_Dispatcher$Executor$().cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_TaskState$lzy1$11)))) {
              $n($n($m_Lcats_effect_std_Dispatcher$Executor$().cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_TaskState$lzy1$11)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Ready$lzy1);
              var x$1$2 = $as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready(x$1$1);
              var this$7 = $n(x$1$2);
              break matchAlts6;
            }
            var x = $n($m_Lcats_effect_std_Dispatcher$Executor$().cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_TaskState$lzy1$11)).Dead__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$();
            if ((x === null)) {
              var $x_1 = (x$1$1 === null);
            } else {
              var this$8 = $n(x);
              var $x_1 = (this$8 === x$1$1);
            }
            if ($x_1) {
              break matchAlts6;
            }
            break matchAlts5;
          }
          var _1 = $n($m_Lcats_effect_std_Dispatcher$Executor$().cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_TaskState$lzy1$11)).Dead__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$();
          var instance = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14;
          var this$10 = $n(instance);
          var _2 = this$10.pure__O__O((void 0));
          return new $c_T2(_1, _2);
        }
        if (((x$1$1 instanceof $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling) && ($n($as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(x$1$1)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_$outer === $m_Lcats_effect_std_Dispatcher$Executor$().cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_TaskState$lzy1$11)))) {
          $n($n($m_Lcats_effect_std_Dispatcher$Executor$().cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_TaskState$lzy1$11)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Canceling$lzy1);
          var x$1$3 = $as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(x$1$1);
          var this$13 = $n(x$1$3);
          var x99 = this$13.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_latch;
          var _1$1 = $n($n($m_Lcats_effect_std_Dispatcher$Executor$().cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_TaskState$lzy1$11)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Canceling$lzy1).apply__Lcats_effect_kernel_Deferred__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(x99);
          var _2$1 = $n(x99).get__O();
          return new $c_T2(_1$1, _2$1);
        }
        var x$3 = $n($m_Lcats_effect_std_Dispatcher$Executor$().cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_TaskState$lzy1$11)).Executing__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$();
        if ((x$3 === null)) {
          var $x_2 = (x$1$1 === null);
        } else {
          var this$15 = $n(x$3);
          var $x_2 = (this$15 === x$1$1);
        }
        if ($x_2) {
          var F$2 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14;
          var target$2 = $n(F$2).deferred__O();
          var tc$2 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14;
          var this$49 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, tc$2);
          var f$13 = new $c_sjsr_AnonFunction1(((latch) => {
            var latch$1 = $as_Lcats_effect_kernel_Deferred(latch);
            var target$3 = $n(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_shutoff$3).set__O__O(new $c_s_Some(latch$1));
            var tc$3 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14;
            var this$48 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$3, tc$3);
            var f$12 = new $c_sjsr_AnonFunction1(((x$1$4) => {
              $as_jl_Void(x$1$4);
              var this$20 = $n(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_tasks$6);
              var maxN = $m_s_None$();
              var F$3 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14;
              var target$4 = $f_Lcats_effect_std_QueueSource__tryTakeN__s_Option__Lcats_Monad__O(this$20, maxN, F$3);
              var tc$4 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14;
              var this$47 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$4, tc$4);
              var f$11 = new $c_sjsr_AnonFunction1(((scratch) => {
                var scratch$1 = $as_sci_List(scratch);
                var target$5 = $n(cancelLatch$1).tryGet__O();
                var tc$5 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14;
                var this$42 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$5, tc$5);
                var f$8 = new $c_sjsr_AnonFunction1(((x$1$6) => {
                  var x$1$7 = $as_s_Option(x$1$6);
                  if ((x$1$7 instanceof $c_s_Some)) {
                    var instance$1 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14;
                    var this$24 = $n(instance$1);
                    return this$24.pure__O__O((void 0));
                  }
                  var x$2 = $m_s_None$();
                  if ((x$2 === x$1$7)) {
                    var target$6 = $n(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_fiberR$1).get__O();
                    var tc$6 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14;
                    var this$26 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$6, tc$6);
                    var f = new $c_sjsr_AnonFunction1(((_$26) => {
                      var _$26$1 = $as_Lcats_effect_kernel_Fiber(_$26);
                      return $n(_$26$1).cancel__O();
                    }));
                    var target$7 = $n(this$26.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$26.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
                    var tc$7 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14;
                    var this$41 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$7, tc$7);
                    var f$7 = new $c_sjsr_AnonFunction1(((x$1$2$1) => {
                      $as_jl_Void(x$1$2$1);
                      $m_Lcats_UnorderedFoldable$();
                      var tc$8 = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
                      var this$30 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(scratch$1, tc$8);
                      var f$1 = new $c_sjsr_AnonFunction1(((_$27) => {
                        var _$27$1 = $as_Lcats_effect_kernel_Ref(_$27);
                        return $n(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_tasks$6).offer__O__O(_$27$1);
                      }));
                      var G = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14;
                      var target$8 = $n(this$30.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).traverse___O__F1__Lcats_Applicative__O(this$30.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, f$1, G);
                      var tc$9 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14;
                      var this$40 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$8, tc$9);
                      var f$6 = new $c_sjsr_AnonFunction1(((x$1$2$2) => {
                        $as_jl_Void(x$1$2$2);
                        var target$9 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_spawnExecutor$3;
                        var tc$10 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14;
                        var this$33 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$9, tc$10);
                        var f$2 = new $c_sjsr_AnonFunction1(((_$28) => {
                          var _$28$1 = $as_Lcats_effect_kernel_Fiber(_$28);
                          return $n(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_fiberR$1).set__O__O(_$28$1);
                        }));
                        var target$10 = $n(this$33.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$33.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
                        var tc$11 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14;
                        var this$39 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$10, tc$11);
                        var f$5 = new $c_sjsr_AnonFunction1(((x$1$2$3) => {
                          $as_jl_Void(x$1$2$3);
                          var target$11 = $n(latch$1).complete__O__O((void 0));
                          var tc$12 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14;
                          var this$38 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$11, tc$12);
                          var f$4 = new $c_sjsr_AnonFunction1(((x$1$2$4) => {
                            $uZ(x$1$2$4);
                            var target$12 = $n(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_shutoff$3).set__O__O($m_s_None$());
                            var tc$13 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14;
                            var this$37 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$12, tc$13);
                            var f$3 = new $c_sjsr_AnonFunction1(((x$1$2$5) => {
                              $as_jl_Void(x$1$2$5);
                            }));
                            return $n(this$37.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$37.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$3);
                          }));
                          return $n(this$38.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$38.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$4);
                        }));
                        return $n(this$39.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$39.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$5);
                      }));
                      return $n(this$40.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$40.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$6);
                    }));
                    return $n(this$41.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$41.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$7);
                  }
                  throw new $c_s_MatchError(x$1$7);
                }));
                var target$13 = $n(this$42.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$42.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$8);
                var tc$14 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14;
                var this$46 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$13, tc$14);
                var f$10 = new $c_sjsr_AnonFunction1(((x$1$2$6) => {
                  $as_jl_Void(x$1$2$6);
                  var target$14 = $n(cancelLatch$1).complete__O__O((void 0));
                  var tc$15 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14;
                  var this$45 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$14, tc$15);
                  var f$9 = new $c_sjsr_AnonFunction1(((v1) => {
                    $uZ(v1);
                  }));
                  return $n(this$45.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$45.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$9);
                }));
                return $n(this$46.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$46.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$10);
              }));
              return $n(this$47.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$47.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$11);
            }));
            return $n(this$48.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$48.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$12);
          }));
          var eff = $n(this$49.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$49.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$13);
          var _1$2 = $n($n($m_Lcats_effect_std_Dispatcher$Executor$().cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_TaskState$lzy1$11)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Canceling$lzy1).apply__Lcats_effect_kernel_Deferred__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(cancelLatch$1);
          return new $c_T2(_1$2, eff);
        }
        throw new $c_s_MatchError(x$1$1);
      })), this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14);
    }));
    var cancelF = $n(this$51.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$51.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$14);
    var target$15 = $n(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_shutoff$3).get__O();
    var tc$16 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14;
    var this$55 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$15, tc$16);
    var f$15 = new $c_sjsr_AnonFunction1(((x$1$15) => {
      var x$1$16 = $as_s_Option(x$1$15);
      if ((x$1$16 instanceof $c_s_Some)) {
        var latch$2 = $as_Lcats_effect_kernel_Deferred($n($as_s_Some(x$1$16)).s_Some__f_value);
        return $n(latch$2).get__O();
      }
      var x$4 = $m_s_None$();
      if ((x$4 === x$1$16)) {
        var instance$2 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14;
        var this$54 = $n(instance$2);
        return this$54.pure__O__O((void 0));
      }
      throw new $c_s_MatchError(x$1$16);
    }));
    var optBlock = $n(this$55.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$55.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$15);
    var fa = $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(optBlock, new $c_sjsr_AnonFunction0((() => $n(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_tasks$6).offer__O__O(taskR$1))), this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14);
    return $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa, new $c_sjsr_AnonFunction0((() => $n(registerCancel).apply__O__O(cancelF))), this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$11$14);
  }));
  return $n(this$58.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$58.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$16);
});
var $d_Lcats_effect_std_Dispatcher$Executor$$anon$4 = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Executor$$anon$4, "cats.effect.std.Dispatcher$Executor$$anon$4", ({
  Lcats_effect_std_Dispatcher$Executor$$anon$4: 1,
  Lcats_effect_std_Dispatcher$Executor: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Executor$$anon$5(evidence$12$3, supervisor$12) {
  this.Lcats_effect_std_Dispatcher$Executor$$anon$5__f_evidence$12$1 = null;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$5__f_supervisor$10 = null;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$5__f_evidence$12$1 = evidence$12$3;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$5__f_supervisor$10 = supervisor$12;
}
$c_Lcats_effect_std_Dispatcher$Executor$$anon$5.prototype = new $h_Lcats_effect_std_Dispatcher$Executor();
$c_Lcats_effect_std_Dispatcher$Executor$$anon$5.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Executor$$anon$5;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Executor$$anon$5() {
}
$h_Lcats_effect_std_Dispatcher$Executor$$anon$5.prototype = $c_Lcats_effect_std_Dispatcher$Executor$$anon$5.prototype;
$c_Lcats_effect_std_Dispatcher$Executor$$anon$5.prototype.apply__O__F1__O = (function(task, registerCancel) {
  var target = $n(this.Lcats_effect_std_Dispatcher$Executor$$anon$5__f_supervisor$10).supervise__O__O(task);
  var tc = this.Lcats_effect_std_Dispatcher$Executor$$anon$5__f_evidence$12$1;
  var this$2 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f = new $c_sjsr_AnonFunction1(((fiber) => {
    var fiber$1 = $as_Lcats_effect_kernel_Fiber(fiber);
    return $n(registerCancel).apply__O__O($n(fiber$1).cancel__O());
  }));
  return $n(this$2.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$2.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
});
var $d_Lcats_effect_std_Dispatcher$Executor$$anon$5 = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Executor$$anon$5, "cats.effect.std.Dispatcher$Executor$$anon$5", ({
  Lcats_effect_std_Dispatcher$Executor$$anon$5: 1,
  Lcats_effect_std_Dispatcher$Executor: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Registration$Primary(action, stateR) {
  this.Lcats_effect_std_Dispatcher$Registration$Primary__f_action = null;
  this.Lcats_effect_std_Dispatcher$Registration$Primary__f_stateR = null;
  this.Lcats_effect_std_Dispatcher$Registration$Primary__f_action = action;
  this.Lcats_effect_std_Dispatcher$Registration$Primary__f_stateR = stateR;
}
$c_Lcats_effect_std_Dispatcher$Registration$Primary.prototype = new $h_Lcats_effect_std_Dispatcher$Registration();
$c_Lcats_effect_std_Dispatcher$Registration$Primary.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Registration$Primary;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Registration$Primary() {
}
$h_Lcats_effect_std_Dispatcher$Registration$Primary.prototype = $c_Lcats_effect_std_Dispatcher$Registration$Primary.prototype;
function $as_Lcats_effect_std_Dispatcher$Registration$Primary(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$Registration$Primary) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$Registration$Primary"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$Registration$Primary(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$Registration$Primary)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$Registration$Primary(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$Registration$Primary(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$Registration$Primary;", depth));
}
var $d_Lcats_effect_std_Dispatcher$Registration$Primary = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Registration$Primary, "cats.effect.std.Dispatcher$Registration$Primary", ({
  Lcats_effect_std_Dispatcher$Registration$Primary: 1,
  Lcats_effect_std_Dispatcher$Registration: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Env$() {
}
$c_Lcats_effect_std_Env$.prototype = new $h_Lcats_effect_std_EnvCompanionPlatform();
$c_Lcats_effect_std_Env$.prototype.constructor = $c_Lcats_effect_std_Env$;
/** @constructor */
function $h_Lcats_effect_std_Env$() {
}
$h_Lcats_effect_std_Env$.prototype = $c_Lcats_effect_std_Env$.prototype;
var $d_Lcats_effect_std_Env$ = new $TypeData().initClass($c_Lcats_effect_std_Env$, "cats.effect.std.Env$", ({
  Lcats_effect_std_Env$: 1,
  Lcats_effect_std_EnvCompanionPlatform: 1
}));
var $n_Lcats_effect_std_Env$;
function $m_Lcats_effect_std_Env$() {
  if ((!$n_Lcats_effect_std_Env$)) {
    $n_Lcats_effect_std_Env$ = new $c_Lcats_effect_std_Env$();
  }
  return $n_Lcats_effect_std_Env$;
}
function $p_Lcats_effect_std_EnvCompanionPlatform$SyncEnv__processEnv__sjs_js_Dictionary($thiz) {
  try {
    var r1 = process.env;
    var $x_1 = new $c_s_util_Success(r1);
  } catch (e) {
    var $x_1;
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      var $x_1 = new $c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2));
    }
  }
  return $n($x_1).getOrElse__F0__O(new $c_sjsr_AnonFunction0((() => (({})))));
}
/** @constructor */
function $c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv(outer, F) {
  this.Lcats_effect_std_EnvCompanionPlatform$SyncEnv__f_F = null;
  this.Lcats_effect_std_EnvCompanionPlatform$SyncEnv__f_F = F;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv.prototype = new $h_O();
$c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv.prototype.constructor = $c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv;
/** @constructor */
function $h_Lcats_effect_std_EnvCompanionPlatform$SyncEnv() {
}
$h_Lcats_effect_std_EnvCompanionPlatform$SyncEnv.prototype = $c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv.prototype;
$c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv.prototype.get__T__O = (function(name) {
  var value = $n(this.Lcats_effect_std_EnvCompanionPlatform$SyncEnv__f_F).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
    var dict = $p_Lcats_effect_std_EnvCompanionPlatform$SyncEnv__processEnv__sjs_js_Dictionary(this);
    return ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, name)) ? new $c_s_Some(dict[name]) : $m_s_None$());
  })));
  return $n(new $c_Lcats_data_OptionT(value).collect__s_PartialFunction__Lcats_Functor__Lcats_data_OptionT(new $c_Lcats_effect_std_EnvCompanionPlatform$$anon$1(), this.Lcats_effect_std_EnvCompanionPlatform$SyncEnv__f_F)).Lcats_data_OptionT__f_value;
});
var $d_Lcats_effect_std_EnvCompanionPlatform$SyncEnv = new $TypeData().initClass($c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv, "cats.effect.std.EnvCompanionPlatform$SyncEnv", ({
  Lcats_effect_std_EnvCompanionPlatform$SyncEnv: 1,
  Lcats_effect_std_Env: 1
}));
function $p_Lcats_effect_std_Mutex$ConcurrentImpl__awakeCell__Lcats_effect_kernel_Deferred__O__O($thiz, ourCell, nextCell) {
  var target = $n($thiz.Lcats_effect_std_Mutex$ConcurrentImpl__f_state).access__O();
  var tc = $thiz.Lcats_effect_std_Mutex$ConcurrentImpl__f_F;
  var this$3 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f = new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var lastCell = $n(x$1$1)._1__O();
      var setter = $as_F1($n(x$1$1)._2__O());
      return ((lastCell === ourCell) ? $n(setter).apply__O__O(nextCell) : $n($thiz.Lcats_effect_std_Mutex$ConcurrentImpl__f_F).pure__O__O(false));
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  var target$1 = $n(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  var tc$1 = $thiz.Lcats_effect_std_Mutex$ConcurrentImpl__f_F;
  var this$8 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
  var f$1 = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1$3 = $uZ(x$1$2);
    if ((x$1$3 === false)) {
      var target$2 = $n(ourCell).complete__O__O(nextCell);
      var tc$2 = $thiz.Lcats_effect_std_Mutex$ConcurrentImpl__f_F;
      var this$6 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, tc$2);
      return $n(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
    }
    if ((x$1$3 === true)) {
      var this$7 = $n($thiz.Lcats_effect_std_Mutex$ConcurrentImpl__f_F);
      return this$7.pure__O__O((void 0));
    }
    throw new $c_s_MatchError(x$1$3);
  }));
  return $n(this$8.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$8.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
}
function $p_Lcats_effect_std_Mutex$ConcurrentImpl__acquire__Lcats_effect_kernel_Poll__O($thiz, poll) {
  var F = $thiz.Lcats_effect_std_Mutex$ConcurrentImpl__f_F;
  var target = $n(F).deferred__O();
  var tc = $thiz.Lcats_effect_std_Mutex$ConcurrentImpl__f_F;
  var this$7 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f$1 = new $c_sjsr_AnonFunction1(((ourCell) => {
    var ourCell$1 = $as_Lcats_effect_kernel_Deferred(ourCell);
    var target$1 = $n($thiz.Lcats_effect_std_Mutex$ConcurrentImpl__f_state).getAndSet__O__O(ourCell$1);
    var tc$1 = $thiz.Lcats_effect_std_Mutex$ConcurrentImpl__f_F;
    var this$6 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
    var f = new $c_sjsr_AnonFunction1(((lastCell) => $p_Lcats_effect_std_Mutex$ConcurrentImpl__loop$1__Lcats_effect_kernel_Poll__Lcats_effect_kernel_Deferred__O__O($thiz, poll, ourCell$1, lastCell)));
    return $n(this$6.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$6.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  }));
  return $n(this$7.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$7.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
}
function $p_Lcats_effect_std_Mutex$ConcurrentImpl__loop$1__Lcats_effect_kernel_Poll__Lcats_effect_kernel_Deferred__O__O($thiz, poll$2, ourCell$4, nextCell) {
  if ((nextCell === null)) {
    return $n($thiz.Lcats_effect_std_Mutex$ConcurrentImpl__f_F).pure__O__O(ourCell$4);
  } else {
    var target = $n($thiz.Lcats_effect_std_Mutex$ConcurrentImpl__f_F).onCancel__O__O__O($n(poll$2).apply__O__O($n($as_Lcats_effect_kernel_Deferred(nextCell)).get__O()), $p_Lcats_effect_std_Mutex$ConcurrentImpl__awakeCell__Lcats_effect_kernel_Deferred__O__O($thiz, ourCell$4, nextCell));
    var tc = $thiz.Lcats_effect_std_Mutex$ConcurrentImpl__f_F;
    var this$3 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
    var f = new $c_sjsr_AnonFunction1(((nextCell$2) => $p_Lcats_effect_std_Mutex$ConcurrentImpl__loop$1__Lcats_effect_kernel_Poll__Lcats_effect_kernel_Deferred__O__O($thiz, poll$2, ourCell$4, nextCell$2)));
    return $n(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  }
}
/** @constructor */
function $c_Lcats_effect_std_Mutex$ConcurrentImpl(state, F) {
  this.Lcats_effect_std_Mutex$ConcurrentImpl__f_state = null;
  this.Lcats_effect_std_Mutex$ConcurrentImpl__f_F = null;
  this.Lcats_effect_std_Mutex$ConcurrentImpl__f_lock = null;
  this.Lcats_effect_std_Mutex$ConcurrentImpl__f_state = state;
  this.Lcats_effect_std_Mutex$ConcurrentImpl__f_F = F;
  var target = $m_Lcats_effect_kernel_Resource$().makeFull__F1__F1__Lcats_Functor__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    return $p_Lcats_effect_std_Mutex$ConcurrentImpl__acquire__Lcats_effect_kernel_Poll__O(this, poll$1);
  })), new $c_sjsr_AnonFunction1(((ourCell) => {
    var ourCell$1 = $as_Lcats_effect_kernel_Deferred(ourCell);
    return $p_Lcats_effect_std_Mutex$ConcurrentImpl__awakeCell__Lcats_effect_kernel_Deferred__O__O(this, ourCell$1, null);
  })), F);
  var tc = new $c_Lcats_effect_kernel_ResourceHOInstances2$$anon$13(F);
  var this$5 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
  this.Lcats_effect_std_Mutex$ConcurrentImpl__f_lock = $as_Lcats_effect_kernel_Resource($n(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_self));
}
$c_Lcats_effect_std_Mutex$ConcurrentImpl.prototype = new $h_Lcats_effect_std_Mutex();
$c_Lcats_effect_std_Mutex$ConcurrentImpl.prototype.constructor = $c_Lcats_effect_std_Mutex$ConcurrentImpl;
/** @constructor */
function $h_Lcats_effect_std_Mutex$ConcurrentImpl() {
}
$h_Lcats_effect_std_Mutex$ConcurrentImpl.prototype = $c_Lcats_effect_std_Mutex$ConcurrentImpl.prototype;
var $d_Lcats_effect_std_Mutex$ConcurrentImpl = new $TypeData().initClass($c_Lcats_effect_std_Mutex$ConcurrentImpl, "cats.effect.std.Mutex$ConcurrentImpl", ({
  Lcats_effect_std_Mutex$ConcurrentImpl: 1,
  Lcats_effect_std_Mutex: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Random$() {
}
$c_Lcats_effect_std_Random$.prototype = new $h_O();
$c_Lcats_effect_std_Random$.prototype.constructor = $c_Lcats_effect_std_Random$;
/** @constructor */
function $h_Lcats_effect_std_Random$() {
}
$h_Lcats_effect_std_Random$.prototype = $c_Lcats_effect_std_Random$.prototype;
$c_Lcats_effect_std_Random$.prototype.scalaUtilRandom__Lcats_effect_kernel_Sync__O = (function(evidence$1) {
  return $n(evidence$1).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
    var sRandom = $ct_s_util_Random__(new $c_s_util_Random());
    return new $c_Lcats_effect_std_Random$$anon$2(evidence$1, sRandom);
  })));
});
var $d_Lcats_effect_std_Random$ = new $TypeData().initClass($c_Lcats_effect_std_Random$, "cats.effect.std.Random$", ({
  Lcats_effect_std_Random$: 1,
  Lcats_effect_std_RandomCompanionPlatform: 1
}));
var $n_Lcats_effect_std_Random$;
function $m_Lcats_effect_std_Random$() {
  if ((!$n_Lcats_effect_std_Random$)) {
    $n_Lcats_effect_std_Random$ = new $c_Lcats_effect_std_Random$();
  }
  return $n_Lcats_effect_std_Random$;
}
function $ct_Lcats_effect_std_Random$RandomCommon__Lcats_effect_kernel_Sync__($thiz, evidence$24) {
  $thiz.Lcats_effect_std_Random$RandomCommon__f_evidence$24 = evidence$24;
  return $thiz;
}
function $p_Lcats_effect_std_Random$RandomCommon__loop$2__I__I__O($thiz, minInclusive$6, maxExclusive$5) {
  var target = $thiz.nextInt__O();
  var tc = $thiz.Lcats_effect_std_Random$RandomCommon__f_evidence$24;
  var this$5 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f = new $c_sjsr_AnonFunction1(((n) => {
    var n$1 = $uI(n);
    if (((n$1 >= minInclusive$6) && (n$1 < maxExclusive$5))) {
      var F = $thiz.Lcats_effect_std_Random$RandomCommon__f_evidence$24;
      return $n(F).pure__O__O(n$1);
    } else {
      return $p_Lcats_effect_std_Random$RandomCommon__loop$2__I__I__O($thiz, minInclusive$6, maxExclusive$5);
    }
  }));
  return $n(this$5.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$5.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
}
/** @constructor */
function $c_Lcats_effect_std_Random$RandomCommon() {
  this.Lcats_effect_std_Random$RandomCommon__f_evidence$24 = null;
}
$c_Lcats_effect_std_Random$RandomCommon.prototype = new $h_O();
$c_Lcats_effect_std_Random$RandomCommon.prototype.constructor = $c_Lcats_effect_std_Random$RandomCommon;
/** @constructor */
function $h_Lcats_effect_std_Random$RandomCommon() {
}
$h_Lcats_effect_std_Random$RandomCommon.prototype = $c_Lcats_effect_std_Random$RandomCommon.prototype;
$c_Lcats_effect_std_Random$RandomCommon.prototype.betweenInt__I__I__O = (function(minInclusive, maxExclusive) {
  var condition = (minInclusive < maxExclusive);
  if (condition) {
    var F = this.Lcats_effect_std_Random$RandomCommon__f_evidence$24;
    var fa = $n(F).pure__O__O((void 0));
  } else {
    var e = $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Invalid bounds");
    var F$1 = this.Lcats_effect_std_Random$RandomCommon__f_evidence$24;
    var fa = $n(F$1).raiseError__O__O(e);
  }
  var F$2 = this.Lcats_effect_std_Random$RandomCommon__f_evidence$24;
  var this$10 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa, F$2);
  var difference = ((maxExclusive - minInclusive) | 0);
  if ((difference >= 0)) {
    var target = this.nextIntBounded__I__O(difference);
    var tc = this.Lcats_effect_std_Random$RandomCommon__f_evidence$24;
    var this$7 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
    var f = new $c_sjsr_AnonFunction1(((_$28) => {
      var _$28$1 = $uI(_$28);
      return ((_$28$1 + minInclusive) | 0);
    }));
    var target$1 = $n(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  } else {
    var target$1 = $p_Lcats_effect_std_Random$RandomCommon__loop$2__I__I__O(this, minInclusive, maxExclusive);
  }
  var tc$1 = this.Lcats_effect_std_Random$RandomCommon__f_evidence$24;
  var this$9 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, tc$1);
  var f$1 = new $c_sjsr_AnonFunction1(((out) => {
    var out$1 = $uI(out);
    return out$1;
  }));
  var fb = $n(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
  var this$11 = $n(this$10.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
  var fa$1 = this$10.Lcats_syntax_ApplySyntax$$anon$1__f_self;
  return this$11.productR__O__O__O(fa$1, fb);
});
function $p_Lcats_effect_std_Supervisor$$anon$1__action$1__F1__O__O__Lcats_effect_kernel_Deferred__Lcats_effect_kernel_Ref__Lcats_effect_kernel_Ref__Lcats_effect_kernel_Deferred__O($thiz, restart$5, fa$5, fin$5, resultR$4, canceledR$3, currentR$1, current) {
  return $n($thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4).uncancelable__F1__O(new $c_sjsr_AnonFunction1(((_$8) => {
    $as_Lcats_effect_kernel_Poll(_$8);
    var $x_1 = $n($thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4);
    var this$2 = $m_Lcats_effect_kernel_implicits$();
    var F = $thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
    var ev$2 = $f_Lcats_effect_kernel_syntax_MonadCancelSyntax__monadCancelOps__O__Lcats_effect_kernel_MonadCancel__O(this$2, fa$5, F);
    var fin$1 = new $c_sjsr_AnonFunction1(((oc) => {
      var oc$1 = $as_Lcats_effect_kernel_Outcome(oc);
      var target = $n($thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4).deferred__O();
      var tc = $thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
      var this$18 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
      var f$2 = new $c_sjsr_AnonFunction1(((newCurrent) => {
        var newCurrent$1 = $as_Lcats_effect_kernel_Deferred(newCurrent);
        var fa = $n(currentR$1).set__O__O(newCurrent$1);
        var F$1 = $thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
        var this$16 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa, F$1);
        var target$1 = $n(canceledR$3).get__O();
        var tc$1 = $thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
        var this$15 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
        var f$1 = new $c_sjsr_AnonFunction1(((canceled) => {
          var canceled$1 = $uZ(canceled);
          var target$2 = $n($thiz.Lcats_effect_std_Supervisor$$anon$1__f_doneR$3).get__O();
          var tc$2 = $thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
          var this$14 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, tc$2);
          var f = new $c_sjsr_AnonFunction1(((done) => {
            var done$1 = $uZ(done);
            if ((((!canceled$1) && (!done$1)) && $uZ($n(restart$5).apply__O__O(oc$1)))) {
              return $p_Lcats_effect_std_Supervisor$$anon$1__action$1__F1__O__O__Lcats_effect_kernel_Deferred__Lcats_effect_kernel_Ref__Lcats_effect_kernel_Ref__Lcats_effect_kernel_Deferred__O($thiz, restart$5, fa$5, fin$5, resultR$4, canceledR$3, currentR$1, newCurrent$1);
            } else {
              var fa$1 = $n(newCurrent$1).complete__O__O(null);
              var F$2 = $thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
              var this$12 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$1, F$2);
              var target$3 = $n(resultR$4).complete__O__O(oc$1);
              var tc$3 = $thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
              var this$10 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, tc$3);
              var fin = $n(this$10.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$10.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
              var F$3 = $thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
              var fb = $n(F$3).guarantee__O__O__O(fin$5, fin);
              var this$13 = $n(this$12.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
              var fa$2 = this$12.Lcats_syntax_ApplySyntax$$anon$1__f_self;
              return this$13.productR__O__O__O(fa$2, fb);
            }
          }));
          return $n(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
        }));
        var fb$1 = $n(this$15.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$15.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
        var this$17 = $n(this$16.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
        var fa$3 = this$16.Lcats_syntax_ApplySyntax$$anon$1__f_self;
        return this$17.productR__O__O__O(fa$3, fb$1);
      }));
      return $n(this$18.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$18.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
    }));
    var F$4 = $thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
    var started = $n($x_1).start__O__O($n(F$4).guaranteeCase__O__F1__O(ev$2, fin$1));
    var tc$4 = $thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
    var this$23 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(started, tc$4);
    var f$5 = new $c_sjsr_AnonFunction1(((f$3) => {
      var f$4 = $as_Lcats_effect_kernel_Fiber(f$3);
      var target$4 = $n(current).complete__O__O(f$4);
      var tc$5 = $thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
      var this$22 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$4, tc$5);
      return $n(this$22.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$22.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
    }));
    return $n(this$23.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$23.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$5);
  })));
}
/** @constructor */
function $c_Lcats_effect_std_Supervisor$$anon$1(checkRestart$4, F$22, doneR$7, state$5) {
  this.Lcats_effect_std_Supervisor$$anon$1__f_checkRestart$3 = null;
  this.Lcats_effect_std_Supervisor$$anon$1__f_F$4 = null;
  this.Lcats_effect_std_Supervisor$$anon$1__f_doneR$3 = null;
  this.Lcats_effect_std_Supervisor$$anon$1__f_state$1 = null;
  this.Lcats_effect_std_Supervisor$$anon$1__f_checkRestart$3 = checkRestart$4;
  this.Lcats_effect_std_Supervisor$$anon$1__f_F$4 = F$22;
  this.Lcats_effect_std_Supervisor$$anon$1__f_doneR$3 = doneR$7;
  this.Lcats_effect_std_Supervisor$$anon$1__f_state$1 = state$5;
}
$c_Lcats_effect_std_Supervisor$$anon$1.prototype = new $h_O();
$c_Lcats_effect_std_Supervisor$$anon$1.prototype.constructor = $c_Lcats_effect_std_Supervisor$$anon$1;
/** @constructor */
function $h_Lcats_effect_std_Supervisor$$anon$1() {
}
$h_Lcats_effect_std_Supervisor$$anon$1.prototype = $c_Lcats_effect_std_Supervisor$$anon$1.prototype;
$c_Lcats_effect_std_Supervisor$$anon$1.prototype.supervise__O__O = (function(fa) {
  return $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4).uncancelable__F1__O(new $c_sjsr_AnonFunction1(((_$7) => {
    $as_Lcats_effect_kernel_Poll(_$7);
    matchResult6$1: {
      var monitor;
      var x12 = this.Lcats_effect_std_Supervisor$$anon$1__f_checkRestart$3;
      if ((x12 instanceof $c_s_Some)) {
        var restart = $as_F1($n($as_s_Some(x12)).s_Some__f_value);
        var monitor = new $c_sjsr_AnonFunction2(((fa$1, fin) => {
          var target = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4).deferred__O();
          var tc = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
          var this$11 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
          var f$3 = new $c_sjsr_AnonFunction1(((resultR) => {
            var resultR$1 = $as_Lcats_effect_kernel_Deferred(resultR);
            var target$1 = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4).ref__O__O(false);
            var tc$1 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
            var this$10 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
            var f$2 = new $c_sjsr_AnonFunction1(((canceledR) => {
              var canceledR$1 = $as_Lcats_effect_kernel_Ref(canceledR);
              var target$2 = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4).deferred__O();
              var tc$2 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
              var this$9 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, tc$2);
              var f$1 = new $c_sjsr_AnonFunction1(((firstCurrent) => {
                var firstCurrent$1 = $as_Lcats_effect_kernel_Deferred(firstCurrent);
                var target$3 = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4).ref__O__O(firstCurrent$1);
                var tc$3 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
                var this$8 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$3, tc$3);
                var f = new $c_sjsr_AnonFunction1(((currentR) => {
                  var currentR$1 = $as_Lcats_effect_kernel_Ref(currentR);
                  var target$4 = $p_Lcats_effect_std_Supervisor$$anon$1__action$1__F1__O__O__Lcats_effect_kernel_Deferred__Lcats_effect_kernel_Ref__Lcats_effect_kernel_Ref__Lcats_effect_kernel_Deferred__O(this, restart, fa$1, fin, resultR$1, canceledR$1, currentR$1, firstCurrent$1);
                  var tc$4 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
                  var this$7 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$4, tc$4);
                  var b = new $c_Lcats_effect_std_Supervisor$$anon$2(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4, fin, resultR$1, canceledR$1, currentR$1, this);
                  return $n(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b);
                }));
                return $n(this$8.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$8.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
              }));
              return $n(this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
            }));
            return $n(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
          }));
          return $n(this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
        }));
        break matchResult6$1;
      }
      var x = $m_s_None$();
      if ((x === x12)) {
        var monitor = new $c_sjsr_AnonFunction2(((fa$2, fin$2) => {
          var $x_1 = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4);
          var F = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
          return $n($x_1).start__O__O($n(F).guarantee__O__O__O(fa$2, fin$2));
        }));
        break matchResult6$1;
      }
      throw new $c_s_MatchError(x12);
    }
    var target$5 = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4).ref__O__O(false);
    var tc$5 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
    var this$46 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$5, tc$5);
    var f$12 = new $c_sjsr_AnonFunction1(((done) => {
      var done$1 = $as_Lcats_effect_kernel_Ref(done);
      var target$6 = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4).deferred__O();
      var tc$6 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
      var this$45 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$6, tc$6);
      var f$11 = new $c_sjsr_AnonFunction1(((insertResult) => {
        var insertResult$1 = $as_Lcats_effect_kernel_Deferred(insertResult);
        var target$7 = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4).unique__O();
        var tc$7 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
        var this$18 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$7, tc$7);
        var f$4 = new $c_sjsr_AnonFunction1(((token) => {
          var token$1 = $as_Lcats_effect_kernel_Unique$Token(token);
          var cleanup = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_state$1).remove__Lcats_effect_kernel_Unique$Token__O(token$1);
          return new $c_T2(token$1, cleanup);
        }));
        var target$8 = $n(this$18.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$18.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$4);
        var tc$8 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
        var this$44 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$8, tc$8);
        var f$10 = new $c_sjsr_AnonFunction1(((x$1) => {
          var x$1$1 = $as_T2(x$1);
          if ((x$1$1 !== null)) {
            var token$2 = $as_Lcats_effect_kernel_Unique$Token($n(x$1$1)._1__O());
            var cleanup$1 = $n(x$1$1)._2__O();
            var $x_3 = $n(monitor);
            var fa$3 = $n(insertResult$1).get__O();
            var ifTrue = new $c_sjsr_AnonFunction0((() => fa));
            var ifFalse = new $c_sjsr_AnonFunction0((() => {
              var fa$4 = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4).canceled__O();
              var F$1 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
              var this$22 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$4, F$1);
              var fb = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4).raiseError__O__O($ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "supervised fiber couldn't cancel (this is a bug in Supervisor)"));
              var this$23 = $n(this$22.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
              var fa$5 = this$22.Lcats_syntax_ApplySyntax$$anon$1__f_self;
              return this$23.productR__O__O__O(fa$5, fb);
            }));
            var F$2 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
            var this$25 = $n(F$2);
            var $x_2 = $f_Lcats_FlatMap__ifM__O__F0__F0__O(this$25, fa$3, ifTrue, ifFalse);
            var fa$6 = $n(done$1).set__O__O(true);
            var F$3 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
            var this$27 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$6, F$3);
            var this$28 = $n(this$27.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
            var fa$7 = this$27.Lcats_syntax_ApplySyntax$$anon$1__f_self;
            var target$9 = $n($x_3).apply__O__O__O($x_2, this$28.productR__O__O__O(fa$7, cleanup$1));
            var tc$9 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
            var this$43 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$9, tc$9);
            var f$9 = new $c_sjsr_AnonFunction1(((fiber) => {
              var fiber$1 = $as_Lcats_effect_kernel_Fiber(fiber);
              var target$10 = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_state$1).add__Lcats_effect_kernel_Unique$Token__Lcats_effect_kernel_Fiber__O(token$2, fiber$1);
              var tc$10 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
              var this$42 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$10, tc$10);
              var f$8 = new $c_sjsr_AnonFunction1(((insertOk) => {
                var insertOk$1 = $uZ(insertOk);
                var target$11 = $n(insertResult$1).complete__O__O(insertOk$1);
                var tc$11 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
                var this$41 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$11, tc$11);
                var f$7 = new $c_sjsr_AnonFunction1(((x$1$2) => {
                  $uZ(x$1$2);
                  var fa$8 = $n(done$1).get__O();
                  var ifTrue$1 = new $c_sjsr_AnonFunction0((() => cleanup$1));
                  var ifFalse$1 = new $c_sjsr_AnonFunction0((() => {
                    var this$33 = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4);
                    return this$33.pure__O__O((void 0));
                  }));
                  var F$4 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
                  var this$35 = $n(F$4);
                  var target$12 = $f_Lcats_FlatMap__ifM__O__F0__F0__O(this$35, fa$8, ifTrue$1, ifFalse$1);
                  var tc$12 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
                  var this$40 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$12, tc$12);
                  var f$6 = new $c_sjsr_AnonFunction1(((x$1$2$1) => {
                    $as_jl_Void(x$1$2$1);
                    if ((!insertOk$1)) {
                      var target$13 = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4).raiseError__O__O($ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "supervisor already shutdown"));
                    } else {
                      var this$37 = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4);
                      var target$13 = this$37.pure__O__O((void 0));
                    }
                    var tc$13 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
                    var this$39 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$13, tc$13);
                    var f$5 = new $c_sjsr_AnonFunction1(((x$1$2$2) => {
                      $as_jl_Void(x$1$2$2);
                      return fiber$1;
                    }));
                    return $n(this$39.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$39.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$5);
                  }));
                  return $n(this$40.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$40.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$6);
                }));
                return $n(this$41.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$41.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$7);
              }));
              return $n(this$42.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$42.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$8);
            }));
            return $n(this$43.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$43.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$9);
          }
          throw new $c_s_MatchError(x$1$1);
        }));
        return $n(this$44.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$44.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$10);
      }));
      return $n(this$45.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$45.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$11);
    }));
    return $n(this$46.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$46.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$12);
  })));
});
var $d_Lcats_effect_std_Supervisor$$anon$1 = new $TypeData().initClass($c_Lcats_effect_std_Supervisor$$anon$1, "cats.effect.std.Supervisor$$anon$1", ({
  Lcats_effect_std_Supervisor$$anon$1: 1,
  Lcats_effect_std_Supervisor: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Supervisor$$anon$3(F$10, stateRef$1) {
  this.Lcats_effect_std_Supervisor$$anon$3__f_stateRef$2 = null;
  this.Lcats_effect_std_Supervisor$$anon$3__f_joinAll = null;
  this.Lcats_effect_std_Supervisor$$anon$3__f_cancelAll = null;
  this.Lcats_effect_std_Supervisor$$anon$3__f_stateRef$2 = stateRef$1;
  var target = $n(stateRef$1).getAndSet__O__O(null);
  var this$5 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, F$10);
  var f = new $c_sjsr_AnonFunction1(((_$12) => {
    var _$12$1 = $as_sci_Map(_$12);
    var this$2 = $n(_$12$1);
    var this$3 = new $c_sc_MapOps$$anon$1(this$2);
    return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$3);
  }));
  var allFibers = $n(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  var this$12 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(allFibers, F$10);
  var f$2 = new $c_sjsr_AnonFunction1(((_$13) => {
    var _$13$1 = $as_sci_List(_$13);
    $m_Lcats_UnorderedFoldable$();
    var tc = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
    var this$11 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(_$13$1, tc);
    var f$1 = new $c_sjsr_AnonFunction1(((_$14) => {
      var _$14$1 = $as_Lcats_effect_kernel_Fiber(_$14);
      var target$1 = $n(_$14$1).join__O();
      var this$10 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, F$10);
      return $n(this$10.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$10.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
    }));
    return $n(this$11.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).traverse___O__F1__Lcats_Applicative__O(this$11.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, f$1, F$10);
  }));
  this.Lcats_effect_std_Supervisor$$anon$3__f_joinAll = $n(this$12.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$12.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
  var this$21 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(allFibers, F$10);
  var f$4 = new $c_sjsr_AnonFunction1(((_$15) => {
    var _$15$1 = $as_sci_List(_$15);
    var f$3 = new $c_sjsr_AnonFunction1(((_$16) => {
      var _$16$1 = $as_Lcats_effect_kernel_Fiber(_$16);
      return $n(_$16$1).cancel__O();
    }));
    var this$15 = $m_Lcats_effect_kernel_implicits$();
    var P = new $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1(F$10, this$15);
    var F = new $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4(F$10);
    $m_Lcats_UnorderedFoldable$();
    var Tutraverse = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
    var target$2 = $m_Lcats_Parallel$().parUnorderedTraverse__O__F1__Lcats_UnorderedTraverse__Lcats_CommutativeApplicative__Lcats_Parallel__O(_$15$1, f$3, Tutraverse, F, P);
    var this$20 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, F$10);
    return $n(this$20.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$20.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
  }));
  this.Lcats_effect_std_Supervisor$$anon$3__f_cancelAll = $n(this$21.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$21.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$4);
}
$c_Lcats_effect_std_Supervisor$$anon$3.prototype = new $h_Lcats_effect_std_Supervisor$State();
$c_Lcats_effect_std_Supervisor$$anon$3.prototype.constructor = $c_Lcats_effect_std_Supervisor$$anon$3;
/** @constructor */
function $h_Lcats_effect_std_Supervisor$$anon$3() {
}
$h_Lcats_effect_std_Supervisor$$anon$3.prototype = $c_Lcats_effect_std_Supervisor$$anon$3.prototype;
$c_Lcats_effect_std_Supervisor$$anon$3.prototype.remove__Lcats_effect_kernel_Unique$Token__O = (function(token) {
  return $n(this.Lcats_effect_std_Supervisor$$anon$3__f_stateRef$2).update__F1__O(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_sci_Map(x$1);
    if ((x$1$1 === null)) {
      return null;
    } else {
      var this$1 = $n(x$1$1);
      return $as_sci_Map(this$1.removed__O__sci_MapOps(token));
    }
  })));
});
$c_Lcats_effect_std_Supervisor$$anon$3.prototype.add__Lcats_effect_kernel_Unique$Token__Lcats_effect_kernel_Fiber__O = (function(token, fiber) {
  return $n(this.Lcats_effect_std_Supervisor$$anon$3__f_stateRef$2).modify__F1__O(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_sci_Map(x$1);
    if ((x$1$1 === null)) {
      return new $c_T2(null, false);
    } else {
      var _1 = $n(x$1$1).updated__O__O__sci_MapOps(token, fiber);
      return new $c_T2(_1, true);
    }
  })));
});
$c_Lcats_effect_std_Supervisor$$anon$3.prototype.joinAll__O = (function() {
  return this.Lcats_effect_std_Supervisor$$anon$3__f_joinAll;
});
$c_Lcats_effect_std_Supervisor$$anon$3.prototype.cancelAll__O = (function() {
  return this.Lcats_effect_std_Supervisor$$anon$3__f_cancelAll;
});
var $d_Lcats_effect_std_Supervisor$$anon$3 = new $TypeData().initClass($c_Lcats_effect_std_Supervisor$$anon$3, "cats.effect.std.Supervisor$$anon$3", ({
  Lcats_effect_std_Supervisor$$anon$3: 1,
  Lcats_effect_std_Supervisor$State: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Supervisor$$anon$4(F$17, doneR$5, state$2) {
  this.Lcats_effect_std_Supervisor$$anon$4__f_F$21 = null;
  this.Lcats_effect_std_Supervisor$$anon$4__f_doneR$6 = null;
  this.Lcats_effect_std_Supervisor$$anon$4__f_state$4 = null;
  this.Lcats_effect_std_Supervisor$$anon$4__f_joinAll = null;
  this.Lcats_effect_std_Supervisor$$anon$4__f_cancelAll = null;
  this.Lcats_effect_std_Supervisor$$anon$4__f_F$21 = F$17;
  this.Lcats_effect_std_Supervisor$$anon$4__f_doneR$6 = doneR$5;
  this.Lcats_effect_std_Supervisor$$anon$4__f_state$4 = state$2;
  var allFibers = $n(F$17).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
    var fibers = new $c_scm_ListBuffer();
    $n(state$2).size__I();
    var values = $n($n(state$2).values__ju_Collection()).iterator__ju_Iterator();
    while ($n(values).hasNext__Z()) {
      var elem = $n(values).next__O();
      fibers.addOne__O__scm_ListBuffer(elem);
    }
    return fibers.toList__sci_List();
  })));
  var this$8 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(allFibers, F$17);
  var f$1 = new $c_sjsr_AnonFunction1(((_$20) => {
    var _$20$1 = $as_sci_List(_$20);
    $m_Lcats_UnorderedFoldable$();
    var tc = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
    var this$7 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(_$20$1, tc);
    var f = new $c_sjsr_AnonFunction1(((_$21) => {
      var _$21$1 = $as_Lcats_effect_kernel_Fiber(_$21);
      var target = $n(_$21$1).join__O();
      var this$6 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, F$17);
      return $n(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
    }));
    return $n(this$7.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).traverse___O__F1__Lcats_Applicative__O(this$7.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, f, F$17);
  }));
  this.Lcats_effect_std_Supervisor$$anon$4__f_joinAll = $n(this$8.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$8.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
  var this$17 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(allFibers, F$17);
  var f$3 = new $c_sjsr_AnonFunction1(((_$22) => {
    var _$22$1 = $as_sci_List(_$22);
    var f$2 = new $c_sjsr_AnonFunction1(((_$23) => {
      var _$23$1 = $as_Lcats_effect_kernel_Fiber(_$23);
      return $n(_$23$1).cancel__O();
    }));
    var this$11 = $m_Lcats_effect_kernel_implicits$();
    var P = new $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1(F$17, this$11);
    var F = new $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4(F$17);
    $m_Lcats_UnorderedFoldable$();
    var Tutraverse = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
    var target$1 = $m_Lcats_Parallel$().parUnorderedTraverse__O__F1__Lcats_UnorderedTraverse__Lcats_CommutativeApplicative__Lcats_Parallel__O(_$22$1, f$2, Tutraverse, F, P);
    var this$16 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, F$17);
    return $n(this$16.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$16.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
  }));
  this.Lcats_effect_std_Supervisor$$anon$4__f_cancelAll = $n(this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
}
$c_Lcats_effect_std_Supervisor$$anon$4.prototype = new $h_Lcats_effect_std_Supervisor$State();
$c_Lcats_effect_std_Supervisor$$anon$4.prototype.constructor = $c_Lcats_effect_std_Supervisor$$anon$4;
/** @constructor */
function $h_Lcats_effect_std_Supervisor$$anon$4() {
}
$h_Lcats_effect_std_Supervisor$$anon$4.prototype = $c_Lcats_effect_std_Supervisor$$anon$4.prototype;
$c_Lcats_effect_std_Supervisor$$anon$4.prototype.remove__Lcats_effect_kernel_Unique$Token__O = (function(token) {
  var target = $n(this.Lcats_effect_std_Supervisor$$anon$4__f_F$21).delay__F0__O(new $c_sjsr_AnonFunction0((() => $as_Lcats_effect_kernel_Fiber($n(this.Lcats_effect_std_Supervisor$$anon$4__f_state$4).remove__O__O(token)))));
  var tc = this.Lcats_effect_std_Supervisor$$anon$4__f_F$21;
  var this$3 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
  return $n(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
});
$c_Lcats_effect_std_Supervisor$$anon$4.prototype.add__Lcats_effect_kernel_Unique$Token__Lcats_effect_kernel_Fiber__O = (function(token, fiber) {
  var fa = $n(this.Lcats_effect_std_Supervisor$$anon$4__f_F$21).delay__F0__O(new $c_sjsr_AnonFunction0((() => $as_Lcats_effect_kernel_Fiber($n(this.Lcats_effect_std_Supervisor$$anon$4__f_state$4).put__O__O__O(token, fiber)))));
  var F = this.Lcats_effect_std_Supervisor$$anon$4__f_F$21;
  var this$5 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa, F);
  var target = $n(this.Lcats_effect_std_Supervisor$$anon$4__f_doneR$6).get__O();
  var tc = this.Lcats_effect_std_Supervisor$$anon$4__f_F$21;
  var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
  var f = new $c_sjsr_AnonFunction1(((_$19) => {
    var _$19$1 = $uZ(_$19);
    return (!_$19$1);
  }));
  var fb = $n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  var this$6 = $n(this$5.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
  var fa$1 = this$5.Lcats_syntax_ApplySyntax$$anon$1__f_self;
  return this$6.productR__O__O__O(fa$1, fb);
});
$c_Lcats_effect_std_Supervisor$$anon$4.prototype.joinAll__O = (function() {
  return this.Lcats_effect_std_Supervisor$$anon$4__f_joinAll;
});
$c_Lcats_effect_std_Supervisor$$anon$4.prototype.cancelAll__O = (function() {
  return this.Lcats_effect_std_Supervisor$$anon$4__f_cancelAll;
});
var $d_Lcats_effect_std_Supervisor$$anon$4 = new $TypeData().initClass($c_Lcats_effect_std_Supervisor$$anon$4, "cats.effect.std.Supervisor$$anon$4", ({
  Lcats_effect_std_Supervisor$$anon$4: 1,
  Lcats_effect_std_Supervisor$State: 1
}));
function $p_Lcats_effect_tracing_Tracing$__applyRunLoopFilter$1__jl_StackTraceElement__Z($thiz, ste) {
  var name = $n(ste).jl_StackTraceElement__f_declaringClass;
  var i = 0;
  var len = $n($thiz.Lcats_effect_tracing_Tracing$__f_runLoopFilter).u.length;
  while ((i < len)) {
    var this$1 = $n(name);
    var prefix = $n($thiz.Lcats_effect_tracing_Tracing$__f_runLoopFilter).get(i);
    if ((this$1.length >= 0)) {
      var this$2 = $n(prefix);
      var $x_2 = this$1.substring(0, this$2.length);
      var $x_1 = ($as_T($x_2) === prefix);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return true;
    }
    i = ((1 + i) | 0);
  }
  return false;
}
function $p_Lcats_effect_tracing_Tracing$__dropRunLoopFrames$1__Ajl_StackTraceElement__Ajl_StackTraceElement($thiz, frames) {
  $m_scm_ArrayBuffer$();
  var buffer = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  var i = 0;
  var len = $n(frames).u.length;
  while ((i < len)) {
    var frame = $n(frames).get(i);
    if ((!$p_Lcats_effect_tracing_Tracing$__applyRunLoopFilter$1__jl_StackTraceElement__Z($thiz, frame))) {
      buffer.addOne__O__scm_ArrayBuffer(frame);
    } else if ((buffer.scm_ArrayBuffer__f_size0 >= 0)) {
      var len$1 = buffer.scm_ArrayBuffer__f_size0;
      var destination = new ($d_jl_StackTraceElement.getArrayOf().constr)(len$1);
      buffer.copyToArray__O__I__I__I(destination, 0, 2147483647);
      return destination;
    } else {
      var capacity = 0;
      var jsElems = null;
      capacity = 0;
      jsElems = [];
      var it = $n(buffer.view__scm_ArrayBufferView()).iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        var elem = $n(it).next__O();
        var unboxedElem = ((elem === null) ? null : elem);
        jsElems.push(unboxedElem);
      }
      return new ($d_jl_StackTraceElement.getArrayOf().constr)(jsElems);
    }
    i = ((1 + i) | 0);
  }
  if ((buffer.scm_ArrayBuffer__f_size0 >= 0)) {
    var len$2 = buffer.scm_ArrayBuffer__f_size0;
    var destination$1 = new ($d_jl_StackTraceElement.getArrayOf().constr)(len$2);
    buffer.copyToArray__O__I__I__I(destination$1, 0, 2147483647);
    return destination$1;
  } else {
    var capacity$1 = 0;
    var jsElems$1 = null;
    capacity$1 = 0;
    jsElems$1 = [];
    var it$1 = $n(buffer.view__scm_ArrayBufferView()).iterator__sc_Iterator();
    while ($n(it$1).hasNext__Z()) {
      var elem$1 = $n(it$1).next__O();
      var unboxedElem$1 = ((elem$1 === null) ? null : elem$1);
      jsElems$1.push(unboxedElem$1);
    }
    return new ($d_jl_StackTraceElement.getArrayOf().constr)(jsElems$1);
  }
}
/** @constructor */
function $c_Lcats_effect_tracing_Tracing$() {
  this.Lcats_effect_tracing_TracingPlatform__f_cache = null;
  this.Lcats_effect_tracing_TracingPlatform__f_function0Property = null;
  this.Lcats_effect_tracing_TracingPlatform__f_function1Property = null;
  this.Lcats_effect_tracing_TracingPlatform__f_calculateTracingEvent = null;
  this.Lcats_effect_tracing_TracingPlatform__f_stackTraceFileNameFilter = null;
  this.Lcats_effect_tracing_TracingPlatform__f_stackTraceMethodNameFilter = null;
  this.Lcats_effect_tracing_Tracing$__f_runLoopFilter = null;
  this.Lcats_effect_tracing_Tracing$__f_stackTraceClassNameFilter = null;
  $ct_Lcats_effect_tracing_TracingPlatform__(this);
  $n_Lcats_effect_tracing_Tracing$ = this;
  this.Lcats_effect_tracing_Tracing$__f_runLoopFilter = new ($d_T.getArrayOf().constr)(["cats.effect.", "scala.runtime.", "scala.scalajs.runtime.", "scala.scalanative.runtime."]);
  this.Lcats_effect_tracing_Tracing$__f_stackTraceClassNameFilter = new ($d_T.getArrayOf().constr)(["cats.", "sbt.", "java.", "jdk.", "sun.", "scala.", "org.scalajs."]);
}
$c_Lcats_effect_tracing_Tracing$.prototype = new $h_Lcats_effect_tracing_TracingPlatform();
$c_Lcats_effect_tracing_Tracing$.prototype.constructor = $c_Lcats_effect_tracing_Tracing$;
/** @constructor */
function $h_Lcats_effect_tracing_Tracing$() {
}
$h_Lcats_effect_tracing_Tracing$.prototype = $c_Lcats_effect_tracing_Tracing$.prototype;
$c_Lcats_effect_tracing_Tracing$.prototype.combineOpAndCallSite__jl_StackTraceElement__jl_StackTraceElement__jl_StackTraceElement = (function(methodSite, callSite) {
  var methodSiteMethodName = $n(methodSite).jl_StackTraceElement__f_methodName;
  var op = this.decodeMethodName__T__T(methodSiteMethodName);
  return $ct_jl_StackTraceElement__T__T__T__I__(new $c_jl_StackTraceElement(), ((op + " @ ") + $n(callSite).jl_StackTraceElement__f_declaringClass), $n(callSite).jl_StackTraceElement__f_methodName, $n(callSite).jl_StackTraceElement__f_fileName, $n(callSite).jl_StackTraceElement__f_lineNumber);
});
$c_Lcats_effect_tracing_Tracing$.prototype.isInternalClass__T__Z = (function(className) {
  var i = 0;
  var len = $n(this.Lcats_effect_tracing_Tracing$__f_stackTraceClassNameFilter).u.length;
  while ((i < len)) {
    var this$1 = $n(className);
    var prefix = $n(this.Lcats_effect_tracing_Tracing$__f_stackTraceClassNameFilter).get(i);
    if ((this$1.length >= 0)) {
      var this$2 = $n(prefix);
      var $x_2 = this$1.substring(0, this$2.length);
      var $x_1 = ($as_T($x_2) === prefix);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return true;
    }
    i = ((1 + i) | 0);
  }
  return false;
});
$c_Lcats_effect_tracing_Tracing$.prototype.cats$effect$tracing$Tracing$$$getOpAndCallSite__Ajl_StackTraceElement__jl_StackTraceElement = (function(stackTrace) {
  var len = $n(stackTrace).u.length;
  var idx = 1;
  while ((idx < len)) {
    var methodSite = $n(stackTrace).get((((-1) + idx) | 0));
    var callSite = $n(stackTrace).get(idx);
    var callSiteClassName = $n(callSite).jl_StackTraceElement__f_declaringClass;
    var callSiteMethodName = $n(callSite).jl_StackTraceElement__f_methodName;
    var callSiteFileName = $n(callSite).jl_StackTraceElement__f_fileName;
    if (((callSiteClassName === "cats.effect.IOFiber") && (callSiteMethodName === "run"))) {
      return null;
    }
    if ((!this.applyStackTraceFilter__T__T__T__Z(callSiteClassName, callSiteMethodName, callSiteFileName))) {
      return this.combineOpAndCallSite__jl_StackTraceElement__jl_StackTraceElement__jl_StackTraceElement(methodSite, callSite);
    }
    idx = ((1 + idx) | 0);
  }
  return null;
});
$c_Lcats_effect_tracing_Tracing$.prototype.augmentThrowable__Z__jl_Throwable__Lcats_effect_tracing_RingBuffer__V = (function(enhancedExceptions, t, events) {
  if (($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing && enhancedExceptions)) {
    var stackTrace = $n(t).getStackTrace__Ajl_StackTraceElement();
    if (($n(stackTrace).u.length !== 0)) {
      var augmented = ($f_T__indexOf__I__I($n($n($as_jl_StackTraceElement($m_sc_ArrayOps$().last$extension__O__O(stackTrace))).jl_StackTraceElement__f_declaringClass), 64) !== (-1));
      if ((!augmented)) {
        var prefix = $p_Lcats_effect_tracing_Tracing$__dropRunLoopFrames$1__Ajl_StackTraceElement__Ajl_StackTraceElement(this, stackTrace);
        var this$5 = $n(this.getFrames__Lcats_effect_tracing_RingBuffer__sci_List(events));
        if ((this$5.knownSize__I() >= 0)) {
          var len = this$5.knownSize__I();
          var destination = new ($d_jl_StackTraceElement.getArrayOf().constr)(len);
          $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$5, destination, 0, 2147483647);
          var suffix = destination;
        } else {
          var capacity = 0;
          var jsElems = null;
          capacity = 0;
          jsElems = [];
          var it = this$5.iterator__sc_Iterator();
          while ($n(it).hasNext__Z()) {
            var elem = $n(it).next__O();
            var unboxedElem = ((elem === null) ? null : elem);
            jsElems.push(unboxedElem);
          }
          var suffix = new ($d_jl_StackTraceElement.getArrayOf().constr)(jsElems);
        }
        var $x_1 = $n(t);
        var this$12 = $m_s_Array$();
        var newLength = (($n(prefix).u.length + $n(suffix).u.length) | 0);
        var this$13 = $n(prefix);
        if ($d_jl_StackTraceElement.getClassOf().isAssignableFrom__jl_Class__Z($objectGetClass(this$13).getComponentType__jl_Class())) {
          var dest$1 = ($d_jl_StackTraceElement.getClassOf().isPrimitive__Z() ? this$12.copyOf__O__I__O(prefix, newLength) : $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(prefix, newLength, $d_jl_StackTraceElement.getArrayOf().getClassOf()));
        } else {
          var dest = new ($d_jl_StackTraceElement.getArrayOf().constr)(newLength);
          $m_s_Array$().copy__O__I__O__I__I__V(prefix, 0, dest, 0, $n(prefix).u.length);
          var dest$1 = dest;
        }
        $m_s_Array$().copy__O__I__O__I__I__V(suffix, 0, dest$1, $n(prefix).u.length, $n(suffix).u.length);
        $n($x_1).setStackTrace__Ajl_StackTraceElement__V($asArrayOf_jl_StackTraceElement(dest$1, 1));
      }
    }
  }
});
$c_Lcats_effect_tracing_Tracing$.prototype.getFrames__Lcats_effect_tracing_RingBuffer__sci_List = (function(events) {
  var this$2 = $n($n($n(events).toList__sci_List()).collect__s_PartialFunction__sci_List(new $c_Lcats_effect_tracing_Tracing$$anon$1()));
  var f = ((_$1) => {
    var _$1$1 = $as_jl_StackTraceElement(_$1);
    return (_$1$1 !== null);
  });
  var l = this$2;
  block: {
    var result;
    while (true) {
      if ($n(l).isEmpty__Z()) {
        var result = $m_sci_Nil$();
        break;
      } else {
        var h = $n(l).head__O();
        var t = $as_sci_List($n(l).tail__O());
        if (($uZ(f(h)) === false)) {
          l = t;
          continue;
        }
        var start = l;
        var remaining = t;
        while (true) {
          if ($n(remaining).isEmpty__Z()) {
            var result = start;
            break block;
          } else {
            var x = $n(remaining).head__O();
            if (($uZ(f(x)) !== false)) {
              remaining = $as_sci_List($n(remaining).tail__O());
              continue;
            }
            var firstMiss = remaining;
            var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
            var toProcess = $as_sci_List($n(start).tail__O());
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
              $n(currentLast).sci_$colon$colon__f_next = newElem;
              currentLast = newElem;
              toProcess = $as_sci_List($n(toProcess).tail__O());
            }
            var next = $as_sci_List($n(firstMiss).tail__O());
            var nextToCopy = next;
            while ((!$n(next).isEmpty__Z())) {
              var head = $n(next).head__O();
              if (($uZ(f(head)) !== false)) {
                next = $as_sci_List($n(next).tail__O());
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                  $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = $as_sci_List($n(nextToCopy).tail__O());
                }
                nextToCopy = $as_sci_List($n(next).tail__O());
                next = $as_sci_List($n(next).tail__O());
              }
            }
            if ((!$n(nextToCopy).isEmpty__Z())) {
              $n(currentLast).sci_$colon$colon__f_next = nextToCopy;
            }
            var result = newHead;
            break block;
          }
        }
      }
    }
  }
  return result;
});
$c_Lcats_effect_tracing_Tracing$.prototype.prettyPrint__Lcats_effect_Trace__T = (function(trace) {
  var frames = $n(trace).Lcats_effect_Trace__f_frames;
  var this$1 = $n(frames);
  var this$3 = $n($as_sci_List($f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this$1)));
  var f = ((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var frame = $as_jl_StackTraceElement($n(x$1$1)._1__O());
      var index = $uI($n(x$1$1)._2__O());
      var junc = ((index === (((-1) + $n(frames).length__I()) | 0)) ? "\u2570" : "\u251c");
      return (((" " + junc) + " ") + frame);
    }
    throw new $c_s_MatchError(x$1$1);
  });
  if ((this$3 === $m_sci_Nil$())) {
    var $x_1 = $m_sci_Nil$();
  } else {
    var arg1 = this$3.head__O();
    var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$3.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O());
    }
    var $x_1 = h;
  }
  var this$4 = $n($x_1);
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$4, "", "\n", "");
});
function $as_Lcats_effect_tracing_Tracing$(obj) {
  return (((obj instanceof $c_Lcats_effect_tracing_Tracing$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.tracing.Tracing$"));
}
function $isArrayOf_Lcats_effect_tracing_Tracing$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_tracing_Tracing$)));
}
function $asArrayOf_Lcats_effect_tracing_Tracing$(obj, depth) {
  return (($isArrayOf_Lcats_effect_tracing_Tracing$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.tracing.Tracing$;", depth));
}
var $d_Lcats_effect_tracing_Tracing$ = new $TypeData().initClass($c_Lcats_effect_tracing_Tracing$, "cats.effect.tracing.Tracing$", ({
  Lcats_effect_tracing_Tracing$: 1,
  Lcats_effect_tracing_TracingPlatform: 1
}));
var $n_Lcats_effect_tracing_Tracing$;
function $m_Lcats_effect_tracing_Tracing$() {
  if ((!$n_Lcats_effect_tracing_Tracing$)) {
    $n_Lcats_effect_tracing_Tracing$ = new $c_Lcats_effect_tracing_Tracing$();
  }
  return $n_Lcats_effect_tracing_Tracing$;
}
function $is_Lcats_effect_tracing_TracingEvent(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_tracing_TracingEvent)));
}
function $as_Lcats_effect_tracing_TracingEvent(obj) {
  return (($is_Lcats_effect_tracing_TracingEvent(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.tracing.TracingEvent"));
}
function $isArrayOf_Lcats_effect_tracing_TracingEvent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_tracing_TracingEvent)));
}
function $asArrayOf_Lcats_effect_tracing_TracingEvent(obj, depth) {
  return (($isArrayOf_Lcats_effect_tracing_TracingEvent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.tracing.TracingEvent;", depth));
}
var $d_Lcats_effect_tracing_TracingEvent = new $TypeData().initClass(1, "cats.effect.tracing.TracingEvent", ({
  Lcats_effect_tracing_TracingEvent: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1(outer) {
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1__f_$outer = outer;
}
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1.prototype = new $h_O();
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1.prototype.constructor = $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1;
/** @constructor */
function $h_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1() {
}
$h_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1.prototype = $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1.prototype;
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1.prototype.run__V = (function() {
  var i = 0;
  while (((i < $n(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1__f_$outer).Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$batchSize) && (!$n($n(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1__f_$outer).Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$fibers).Lcats_effect_unsafe_JSArrayQueue__f_empty))) {
    var this$1 = $n($n(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1__f_$outer).Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$fibers);
    var a = this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer[this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex];
    this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer[this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex] = null;
    this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex = ((1 + this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex) | 0);
    if ((this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex === this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex)) {
      this$1.Lcats_effect_unsafe_JSArrayQueue__f_empty = true;
    }
    if ((this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex >= $uI(this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer.length))) {
      this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex = 0;
    }
    var fiber = $as_Lcats_effect_IOFiber(a);
    try {
      $n(fiber).run__V();
    } catch (e) {
      var e$1 = e;
      var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        $n(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1__f_$outer).reportFailure__jl_Throwable__V(e$2);
      } else {
        $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__N(e$2);
      }
    }
    i = ((1 + i) | 0);
  }
  if ((!$n($n(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1__f_$outer).Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$fibers).Lcats_effect_unsafe_JSArrayQueue__f_empty)) {
    $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$().execute__jl_Runnable__V(this);
  } else {
    $n(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1__f_$outer).Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$needsReschedule = true;
  }
});
var $d_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1 = new $TypeData().initClass($c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1, "cats.effect.unsafe.BatchingMacrotaskExecutor$$anon$1", ({
  Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1: 1,
  jl_Runnable: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2(r$3, outer) {
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2__f_r$2 = null;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2__f_$outer = null;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2__f_r$2 = r$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2__f_$outer = outer;
}
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2.prototype = new $h_O();
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2.prototype.constructor = $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2;
/** @constructor */
function $h_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2() {
}
$h_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2.prototype = $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2.prototype;
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2.prototype.run__V = (function() {
  var this$1 = $n(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2__f_$outer);
  var r$1 = this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2__f_r$2;
  var this$2 = $n(this$1.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_fiberBag);
  this$2.subtractOne__O__scm_Shrinkable(r$1);
  $n(r$1).run__V();
});
var $d_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2 = new $TypeData().initClass($c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2, "cats.effect.unsafe.BatchingMacrotaskExecutor$$anon$2", ({
  Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2: 1,
  jl_Runnable: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_FiberMonitor() {
  this.Lcats_effect_unsafe_FiberMonitorShared__f_newline = null;
  this.Lcats_effect_unsafe_FiberMonitorShared__f_doubleNewline = null;
}
$c_Lcats_effect_unsafe_FiberMonitor.prototype = new $h_Lcats_effect_unsafe_FiberMonitorShared();
$c_Lcats_effect_unsafe_FiberMonitor.prototype.constructor = $c_Lcats_effect_unsafe_FiberMonitor;
/** @constructor */
function $h_Lcats_effect_unsafe_FiberMonitor() {
}
$h_Lcats_effect_unsafe_FiberMonitor.prototype = $c_Lcats_effect_unsafe_FiberMonitor.prototype;
/** @constructor */
function $c_Lcats_effect_unsafe_IORuntime$() {
  this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global = null;
  this.Lcats_effect_unsafe_IORuntime$__f_allRuntimes = null;
  this.Lcats_effect_unsafe_IORuntime$__f_globalFatalFailureHandled = null;
  $ct_Lcats_effect_unsafe_IORuntimeCompanionPlatform__(this);
  $n_Lcats_effect_unsafe_IORuntime$ = this;
  this.Lcats_effect_unsafe_IORuntime$__f_allRuntimes = new $c_Lcats_effect_unsafe_ThreadSafeHashtable(4);
  this.Lcats_effect_unsafe_IORuntime$__f_globalFatalFailureHandled = $ct_ju_concurrent_atomic_AtomicBoolean__Z__(new $c_ju_concurrent_atomic_AtomicBoolean(), false);
}
$c_Lcats_effect_unsafe_IORuntime$.prototype = new $h_Lcats_effect_unsafe_IORuntimeCompanionPlatform();
$c_Lcats_effect_unsafe_IORuntime$.prototype.constructor = $c_Lcats_effect_unsafe_IORuntime$;
/** @constructor */
function $h_Lcats_effect_unsafe_IORuntime$() {
}
$h_Lcats_effect_unsafe_IORuntime$.prototype = $c_Lcats_effect_unsafe_IORuntime$.prototype;
$c_Lcats_effect_unsafe_IORuntime$.prototype.apply__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__F0__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_IORuntime = (function(compute, blocking, scheduler, shutdown, config) {
  var fiberMonitor = $m_Lcats_effect_unsafe_FiberMonitor$().apply__s_concurrent_ExecutionContext__Lcats_effect_unsafe_FiberMonitor(compute);
  var unregister = this.registerFiberMonitorMBean__Lcats_effect_unsafe_FiberMonitor__F0(fiberMonitor);
  var unregisterAndShutdown = new $c_sjsr_AnonFunction0((() => {
    $n(unregister).apply__O();
    $n(shutdown).apply__O();
  }));
  var runtime = new $c_Lcats_effect_unsafe_IORuntime(compute, blocking, scheduler, fiberMonitor, unregisterAndShutdown, config);
  $n(this.Lcats_effect_unsafe_IORuntime$__f_allRuntimes).put__O__I__V(runtime, $systemIdentityHashCode(runtime));
  return runtime;
});
var $d_Lcats_effect_unsafe_IORuntime$ = new $TypeData().initClass($c_Lcats_effect_unsafe_IORuntime$, "cats.effect.unsafe.IORuntime$", ({
  Lcats_effect_unsafe_IORuntime$: 1,
  Lcats_effect_unsafe_IORuntimeCompanionPlatform: 1
}));
var $n_Lcats_effect_unsafe_IORuntime$;
function $m_Lcats_effect_unsafe_IORuntime$() {
  if ((!$n_Lcats_effect_unsafe_IORuntime$)) {
    $n_Lcats_effect_unsafe_IORuntime$ = new $c_Lcats_effect_unsafe_IORuntime$();
  }
  return $n_Lcats_effect_unsafe_IORuntime$;
}
/** @constructor */
function $c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1.prototype = new $h_O();
$c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1.prototype.constructor = $c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1;
/** @constructor */
function $h_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1() {
}
$h_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1.prototype = $c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1.prototype;
$c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1.prototype.deregister__V = (function() {
});
var $d_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1 = new $TypeData().initClass($c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1, "cats.effect.unsafe.NoOpFiberMonitor$$anon$1", ({
  Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1: 1,
  Lcats_effect_unsafe_WeakBag$Handle: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_Scheduler$() {
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$maxTimeout = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$mkCancelRunnable = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$nowMicrosImpl = null;
  $ct_Lcats_effect_unsafe_SchedulerCompanionPlatform__(this);
}
$c_Lcats_effect_unsafe_Scheduler$.prototype = new $h_Lcats_effect_unsafe_SchedulerCompanionPlatform();
$c_Lcats_effect_unsafe_Scheduler$.prototype.constructor = $c_Lcats_effect_unsafe_Scheduler$;
/** @constructor */
function $h_Lcats_effect_unsafe_Scheduler$() {
}
$h_Lcats_effect_unsafe_Scheduler$.prototype = $c_Lcats_effect_unsafe_Scheduler$.prototype;
var $d_Lcats_effect_unsafe_Scheduler$ = new $TypeData().initClass($c_Lcats_effect_unsafe_Scheduler$, "cats.effect.unsafe.Scheduler$", ({
  Lcats_effect_unsafe_Scheduler$: 1,
  Lcats_effect_unsafe_SchedulerCompanionPlatform: 1
}));
var $n_Lcats_effect_unsafe_Scheduler$;
function $m_Lcats_effect_unsafe_Scheduler$() {
  if ((!$n_Lcats_effect_unsafe_Scheduler$)) {
    $n_Lcats_effect_unsafe_Scheduler$ = new $c_Lcats_effect_unsafe_Scheduler$();
  }
  return $n_Lcats_effect_unsafe_Scheduler$;
}
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1(handle$3, outer) {
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1__f_handle$2 = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1__f_handle$2 = handle$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1.prototype = new $h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1() {
}
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1.prototype.run__V = (function() {
  var handle$1 = this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1__f_handle$2;
  $m_sjs_js_timers_package$().clearTimeout__sjs_js_timers_SetTimeoutHandle__V(handle$1);
});
var $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1 = new $TypeData().initClass($c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1, "cats.effect.unsafe.SchedulerCompanionPlatform$$anon$1", ({
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1: 1,
  jl_Runnable: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2.prototype = new $h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2() {
}
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2.prototype.run__V = (function() {
});
var $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2 = new $TypeData().initClass($c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2, "cats.effect.unsafe.SchedulerCompanionPlatform$$anon$2", ({
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2: 1,
  jl_Runnable: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3(outer) {
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3__f_$outer = outer;
}
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3.prototype = new $h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3() {
}
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3.prototype.sleep__s_concurrent_duration_FiniteDuration__jl_Runnable__jl_Runnable = (function(delay, task) {
  var this$1 = $n(delay);
  var that = $n(this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3__f_$outer).Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$maxTimeout;
  if ($f_s_math_Ordered__$less$eq__O__Z(this$1, that)) {
    var handle = $m_sjs_js_timers_package$().setTimeout__s_concurrent_duration_FiniteDuration__F0__sjs_js_timers_SetTimeoutHandle(delay, new $c_sjsr_AnonFunction0((() => {
      $n(task).run__V();
    })));
    return $as_jl_Runnable((0, $n(this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3__f_$outer).Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$mkCancelRunnable)(handle));
  } else {
    var elem = new $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4(this);
    var cancel = new $c_sr_ObjectRef(elem);
    var ev$6 = this.sleep__s_concurrent_duration_FiniteDuration__jl_Runnable__jl_Runnable($n(this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3__f_$outer).Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$maxTimeout, new $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5(delay, task, cancel, this));
    cancel.sr_ObjectRef__f_elem = ev$6;
    ev$6 = null;
    return new $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6(cancel, this);
  }
});
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3.prototype.nowMicros__J = (function() {
  return $uJ((0, $n(this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3__f_$outer).Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$nowMicrosImpl)());
});
var $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3 = new $TypeData().initClass($c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3, "cats.effect.unsafe.SchedulerCompanionPlatform$$anon$3", ({
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3: 1,
  Lcats_effect_unsafe_Scheduler: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4.prototype = new $h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4() {
}
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4.prototype.run__V = (function() {
});
var $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4 = new $TypeData().initClass($c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4, "cats.effect.unsafe.SchedulerCompanionPlatform$$anon$4", ({
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4: 1,
  jl_Runnable: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5(delay$3, task$5, cancel$5, outer) {
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_delay$2 = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_task$4 = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_cancel$3 = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_$outer = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_delay$2 = delay$3;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_task$4 = task$5;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_cancel$3 = cancel$5;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_$outer = outer;
}
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5.prototype = new $h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5() {
}
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5.prototype.run__V = (function() {
  var this$1 = $n(this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_$outer);
  var delay$1 = this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_delay$2;
  var task$2 = this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_task$4;
  var cancel$1 = this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_cancel$3;
  var ev$5 = this$1.sleep__s_concurrent_duration_FiniteDuration__jl_Runnable__jl_Runnable($n(delay$1).$minus__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration($n(this$1.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3__f_$outer).Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$maxTimeout), task$2);
  $n(cancel$1).sr_ObjectRef__f_elem = ev$5;
  ev$5 = null;
});
var $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5 = new $TypeData().initClass($c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5, "cats.effect.unsafe.SchedulerCompanionPlatform$$anon$5", ({
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5: 1,
  jl_Runnable: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6(cancel$6, outer) {
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6__f_cancel$4 = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6__f_cancel$4 = cancel$6;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6.prototype = new $h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6() {
}
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6.prototype.run__V = (function() {
  var cancel$2 = this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6__f_cancel$4;
  $n($as_jl_Runnable($n(cancel$2).sr_ObjectRef__f_elem)).run__V();
});
var $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6 = new $TypeData().initClass($c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6, "cats.effect.unsafe.SchedulerCompanionPlatform$$anon$6", ({
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6: 1,
  jl_Runnable: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_WeakBag$$anon$1(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_effect_unsafe_WeakBag$$anon$1.prototype = new $h_O();
$c_Lcats_effect_unsafe_WeakBag$$anon$1.prototype.constructor = $c_Lcats_effect_unsafe_WeakBag$$anon$1;
/** @constructor */
function $h_Lcats_effect_unsafe_WeakBag$$anon$1() {
}
$h_Lcats_effect_unsafe_WeakBag$$anon$1.prototype = $c_Lcats_effect_unsafe_WeakBag$$anon$1.prototype;
$c_Lcats_effect_unsafe_WeakBag$$anon$1.prototype.deregister__V = (function() {
});
var $d_Lcats_effect_unsafe_WeakBag$$anon$1 = new $TypeData().initClass($c_Lcats_effect_unsafe_WeakBag$$anon$1, "cats.effect.unsafe.WeakBag$$anon$1", ({
  Lcats_effect_unsafe_WeakBag$$anon$1: 1,
  Lcats_effect_unsafe_WeakBag$Handle: 1
}));
function $as_Lcats_effect_unsafe_WorkStealingThreadPool(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.WorkStealingThreadPool"));
}
function $isArrayOf_Lcats_effect_unsafe_WorkStealingThreadPool(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_WorkStealingThreadPool)));
}
function $asArrayOf_Lcats_effect_unsafe_WorkStealingThreadPool(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_WorkStealingThreadPool(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.WorkStealingThreadPool;", depth));
}
/** @constructor */
function $c_Lcats_effect_unsafe_ref_WeakReference() {
  this.Lcats_effect_unsafe_ref_Reference__f_queue = null;
  this.Lcats_effect_unsafe_ref_Reference__f_weakRef = null;
  this.Lcats_effect_unsafe_ref_Reference__f_enqueued = false;
}
$c_Lcats_effect_unsafe_ref_WeakReference.prototype = new $h_Lcats_effect_unsafe_ref_Reference();
$c_Lcats_effect_unsafe_ref_WeakReference.prototype.constructor = $c_Lcats_effect_unsafe_ref_WeakReference;
/** @constructor */
function $h_Lcats_effect_unsafe_ref_WeakReference() {
}
$h_Lcats_effect_unsafe_ref_WeakReference.prototype = $c_Lcats_effect_unsafe_ref_WeakReference.prototype;
/** @constructor */
function $c_Lcats_evidence_As() {
}
$c_Lcats_evidence_As.prototype = new $h_O();
$c_Lcats_evidence_As.prototype.constructor = $c_Lcats_evidence_As;
/** @constructor */
function $h_Lcats_evidence_As() {
}
$h_Lcats_evidence_As.prototype = $c_Lcats_evidence_As.prototype;
function $f_Lcats_instances_Function1Instances__$init$__V($thiz) {
  $thiz.cats$instances$Function1Instances$_setter_$catsStdInstancesForFunction1_$eq__Lcats_arrow_ArrowChoice__V(new $c_Lcats_instances_Function1Instances$$anon$6());
  $thiz.cats$instances$Function1Instances$_setter_$catsStdMonoidKForFunction1_$eq__Lcats_MonoidK__V(new $c_Lcats_instances_Function1Instances$$anon$7($thiz));
}
/** @constructor */
function $c_Lcats_instances_package$equiv$() {
  this.Lcats_instances_package$equiv$__f_catsContravariantMonoidalForEquiv = null;
  $n_Lcats_instances_package$equiv$ = this;
  this.Lcats_instances_package$equiv$__f_catsContravariantMonoidalForEquiv = new $c_Lcats_instances_EquivInstances$$anon$1();
}
$c_Lcats_instances_package$equiv$.prototype = new $h_O();
$c_Lcats_instances_package$equiv$.prototype.constructor = $c_Lcats_instances_package$equiv$;
/** @constructor */
function $h_Lcats_instances_package$equiv$() {
}
$h_Lcats_instances_package$equiv$.prototype = $c_Lcats_instances_package$equiv$.prototype;
var $d_Lcats_instances_package$equiv$ = new $TypeData().initClass($c_Lcats_instances_package$equiv$, "cats.instances.package$equiv$", ({
  Lcats_instances_package$equiv$: 1,
  Lcats_instances_EquivInstances: 1
}));
var $n_Lcats_instances_package$equiv$;
function $m_Lcats_instances_package$equiv$() {
  if ((!$n_Lcats_instances_package$equiv$)) {
    $n_Lcats_instances_package$equiv$ = new $c_Lcats_instances_package$equiv$();
  }
  return $n_Lcats_instances_package$equiv$;
}
/** @constructor */
function $c_Lcats_instances_package$ordering$() {
  this.Lcats_instances_package$ordering$__f_catsContravariantMonoidalForOrdering = null;
  $n_Lcats_instances_package$ordering$ = this;
  this.Lcats_instances_package$ordering$__f_catsContravariantMonoidalForOrdering = new $c_Lcats_instances_OrderingInstances$$anon$1();
}
$c_Lcats_instances_package$ordering$.prototype = new $h_O();
$c_Lcats_instances_package$ordering$.prototype.constructor = $c_Lcats_instances_package$ordering$;
/** @constructor */
function $h_Lcats_instances_package$ordering$() {
}
$h_Lcats_instances_package$ordering$.prototype = $c_Lcats_instances_package$ordering$.prototype;
var $d_Lcats_instances_package$ordering$ = new $TypeData().initClass($c_Lcats_instances_package$ordering$, "cats.instances.package$ordering$", ({
  Lcats_instances_package$ordering$: 1,
  Lcats_instances_OrderingInstances: 1
}));
var $n_Lcats_instances_package$ordering$;
function $m_Lcats_instances_package$ordering$() {
  if ((!$n_Lcats_instances_package$ordering$)) {
    $n_Lcats_instances_package$ordering$ = new $c_Lcats_instances_package$ordering$();
  }
  return $n_Lcats_instances_package$ordering$;
}
/** @constructor */
function $c_Lcats_instances_package$partialOrdering$() {
  this.Lcats_instances_package$partialOrdering$__f_catsContravariantMonoidalForPartialOrdering = null;
  $n_Lcats_instances_package$partialOrdering$ = this;
  this.Lcats_instances_package$partialOrdering$__f_catsContravariantMonoidalForPartialOrdering = new $c_Lcats_instances_PartialOrderingInstances$$anon$1();
}
$c_Lcats_instances_package$partialOrdering$.prototype = new $h_O();
$c_Lcats_instances_package$partialOrdering$.prototype.constructor = $c_Lcats_instances_package$partialOrdering$;
/** @constructor */
function $h_Lcats_instances_package$partialOrdering$() {
}
$h_Lcats_instances_package$partialOrdering$.prototype = $c_Lcats_instances_package$partialOrdering$.prototype;
var $d_Lcats_instances_package$partialOrdering$ = new $TypeData().initClass($c_Lcats_instances_package$partialOrdering$, "cats.instances.package$partialOrdering$", ({
  Lcats_instances_package$partialOrdering$: 1,
  Lcats_instances_PartialOrderingInstances: 1
}));
var $n_Lcats_instances_package$partialOrdering$;
function $m_Lcats_instances_package$partialOrdering$() {
  if ((!$n_Lcats_instances_package$partialOrdering$)) {
    $n_Lcats_instances_package$partialOrdering$ = new $c_Lcats_instances_package$partialOrdering$();
  }
  return $n_Lcats_instances_package$partialOrdering$;
}
function $is_Lcats_kernel_Eq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_Eq)));
}
function $as_Lcats_kernel_Eq(obj) {
  return (($is_Lcats_kernel_Eq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.Eq"));
}
function $isArrayOf_Lcats_kernel_Eq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_Eq)));
}
function $asArrayOf_Lcats_kernel_Eq(obj, depth) {
  return (($isArrayOf_Lcats_kernel_Eq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.Eq;", depth));
}
/** @constructor */
function $c_Lcats_kernel_HashFunctions() {
}
$c_Lcats_kernel_HashFunctions.prototype = new $h_Lcats_kernel_EqFunctions();
$c_Lcats_kernel_HashFunctions.prototype.constructor = $c_Lcats_kernel_HashFunctions;
/** @constructor */
function $h_Lcats_kernel_HashFunctions() {
}
$h_Lcats_kernel_HashFunctions.prototype = $c_Lcats_kernel_HashFunctions.prototype;
/** @constructor */
function $c_Lcats_kernel_PartialOrderFunctions() {
}
$c_Lcats_kernel_PartialOrderFunctions.prototype = new $h_Lcats_kernel_EqFunctions();
$c_Lcats_kernel_PartialOrderFunctions.prototype.constructor = $c_Lcats_kernel_PartialOrderFunctions;
/** @constructor */
function $h_Lcats_kernel_PartialOrderFunctions() {
}
$h_Lcats_kernel_PartialOrderFunctions.prototype = $c_Lcats_kernel_PartialOrderFunctions.prototype;
function $f_Lcats_kernel_Semigroup__combineAllOption__sc_IterableOnce__s_Option($thiz, as) {
  var f = ((x, y) => $thiz.combine__O__O__O(x, y));
  var this$4 = $n($n(as).iterator__sc_Iterator());
  var x1 = this$4.knownSize__I();
  switch (x1) {
    case (-1): {
      if (this$4.hasNext__Z()) {
        var acc = this$4.next__O();
        while (this$4.hasNext__Z()) {
          var arg1 = acc;
          var arg2 = this$4.next__O();
          acc = f(arg1, arg2);
        }
        return new $c_s_Some(acc);
      } else {
        return $m_s_None$();
      }
      break;
    }
    case 0: {
      return $m_s_None$();
      break;
    }
    default: {
      matchEnd4: {
        var $x_1;
        if ($is_sc_IndexedSeq(this$4)) {
          var x2 = $as_sc_IndexedSeq(this$4);
          if (($n(x2).length__I() > 0)) {
            var z = $n(x2).apply__I__O(0);
            var at = 1;
            var end = $n(x2).length__I();
            var acc$1 = z;
            while (true) {
              if ((at === end)) {
                var $x_1 = acc$1;
                break matchEnd4;
              } else {
                var temp$at = ((1 + at) | 0);
                var arg1$1 = acc$1;
                var arg2$1 = $n(x2).apply__I__O(at);
                var temp$acc = f(arg1$1, arg2$1);
                at = temp$at;
                acc$1 = temp$acc;
              }
            }
          }
        }
        if ((this$4.knownSize__I() === 0)) {
          throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
        }
        if (this$4.hasNext__Z()) {
          var acc$2 = this$4.next__O();
          while (this$4.hasNext__Z()) {
            var arg1$2 = acc$2;
            var arg2$2 = this$4.next__O();
            acc$2 = f(arg1$2, arg2$2);
          }
          var $x_1 = acc$2;
        } else {
          throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
        }
      }
      return new $c_s_Some($x_1);
    }
  }
}
function $is_Lcats_kernel_Semigroup(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_Semigroup)));
}
function $as_Lcats_kernel_Semigroup(obj) {
  return (($is_Lcats_kernel_Semigroup(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.Semigroup"));
}
function $isArrayOf_Lcats_kernel_Semigroup(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_Semigroup)));
}
function $asArrayOf_Lcats_kernel_Semigroup(obj, depth) {
  return (($isArrayOf_Lcats_kernel_Semigroup(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.Semigroup;", depth));
}
/** @constructor */
function $c_Lcats_kernel_instances_StaticMethods$() {
}
$c_Lcats_kernel_instances_StaticMethods$.prototype = new $h_Lcats_kernel_compat_HashCompat();
$c_Lcats_kernel_instances_StaticMethods$.prototype.constructor = $c_Lcats_kernel_instances_StaticMethods$;
/** @constructor */
function $h_Lcats_kernel_instances_StaticMethods$() {
}
$h_Lcats_kernel_instances_StaticMethods$.prototype = $c_Lcats_kernel_instances_StaticMethods$.prototype;
$c_Lcats_kernel_instances_StaticMethods$.prototype.combineAllIterable__scm_Builder__sc_IterableOnce__O = (function(b, xs) {
  var this$1 = $n($n(xs).iterator__sc_Iterator());
  while (this$1.hasNext__Z()) {
    var arg1 = this$1.next__O();
    var _$1 = $as_sc_Iterable(arg1);
    var this$2 = $n(b);
    $as_scm_Builder(this$2.addAll__sc_IterableOnce__scm_Growable(_$1));
  }
  return $n(b).result__O();
});
var $d_Lcats_kernel_instances_StaticMethods$ = new $TypeData().initClass($c_Lcats_kernel_instances_StaticMethods$, "cats.kernel.instances.StaticMethods$", ({
  Lcats_kernel_instances_StaticMethods$: 1,
  Lcats_kernel_compat_HashCompat: 1
}));
var $n_Lcats_kernel_instances_StaticMethods$;
function $m_Lcats_kernel_instances_StaticMethods$() {
  if ((!$n_Lcats_kernel_instances_StaticMethods$)) {
    $n_Lcats_kernel_instances_StaticMethods$ = new $c_Lcats_kernel_instances_StaticMethods$();
  }
  return $n_Lcats_kernel_instances_StaticMethods$;
}
/** @constructor */
function $c_Lcats_kernel_instances_char_package$() {
  this.Lcats_kernel_instances_char_package$__f_catsKernelStdOrderForChar = null;
  $n_Lcats_kernel_instances_char_package$ = this;
  this.Lcats_kernel_instances_char_package$__f_catsKernelStdOrderForChar = new $c_Lcats_kernel_instances_CharOrder();
}
$c_Lcats_kernel_instances_char_package$.prototype = new $h_O();
$c_Lcats_kernel_instances_char_package$.prototype.constructor = $c_Lcats_kernel_instances_char_package$;
/** @constructor */
function $h_Lcats_kernel_instances_char_package$() {
}
$h_Lcats_kernel_instances_char_package$.prototype = $c_Lcats_kernel_instances_char_package$.prototype;
var $d_Lcats_kernel_instances_char_package$ = new $TypeData().initClass($c_Lcats_kernel_instances_char_package$, "cats.kernel.instances.char.package$", ({
  Lcats_kernel_instances_char_package$: 1,
  Lcats_kernel_instances_CharInstances: 1
}));
var $n_Lcats_kernel_instances_char_package$;
function $m_Lcats_kernel_instances_char_package$() {
  if ((!$n_Lcats_kernel_instances_char_package$)) {
    $n_Lcats_kernel_instances_char_package$ = new $c_Lcats_kernel_instances_char_package$();
  }
  return $n_Lcats_kernel_instances_char_package$;
}
/** @constructor */
function $c_Lcats_kernel_instances_int_package$() {
  this.Lcats_kernel_instances_int_package$__f_catsKernelStdOrderForInt = null;
  $n_Lcats_kernel_instances_int_package$ = this;
  $f_Lcats_kernel_instances_IntInstances__$init$__V(this);
}
$c_Lcats_kernel_instances_int_package$.prototype = new $h_O();
$c_Lcats_kernel_instances_int_package$.prototype.constructor = $c_Lcats_kernel_instances_int_package$;
/** @constructor */
function $h_Lcats_kernel_instances_int_package$() {
}
$h_Lcats_kernel_instances_int_package$.prototype = $c_Lcats_kernel_instances_int_package$.prototype;
$c_Lcats_kernel_instances_int_package$.prototype.cats$kernel$instances$IntInstances$_setter_$catsKernelStdOrderForInt_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
  this.Lcats_kernel_instances_int_package$__f_catsKernelStdOrderForInt = x$0;
});
$c_Lcats_kernel_instances_int_package$.prototype.cats$kernel$instances$IntInstances$_setter_$catsKernelStdGroupForInt_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
var $d_Lcats_kernel_instances_int_package$ = new $TypeData().initClass($c_Lcats_kernel_instances_int_package$, "cats.kernel.instances.int.package$", ({
  Lcats_kernel_instances_int_package$: 1,
  Lcats_kernel_instances_IntInstances: 1
}));
var $n_Lcats_kernel_instances_int_package$;
function $m_Lcats_kernel_instances_int_package$() {
  if ((!$n_Lcats_kernel_instances_int_package$)) {
    $n_Lcats_kernel_instances_int_package$ = new $c_Lcats_kernel_instances_int_package$();
  }
  return $n_Lcats_kernel_instances_int_package$;
}
/** @constructor */
function $c_Lcats_kernel_instances_long_package$() {
  this.Lcats_kernel_instances_long_package$__f_catsKernelStdGroupForLong = null;
  $n_Lcats_kernel_instances_long_package$ = this;
  $f_Lcats_kernel_instances_LongInstances__$init$__V(this);
}
$c_Lcats_kernel_instances_long_package$.prototype = new $h_O();
$c_Lcats_kernel_instances_long_package$.prototype.constructor = $c_Lcats_kernel_instances_long_package$;
/** @constructor */
function $h_Lcats_kernel_instances_long_package$() {
}
$h_Lcats_kernel_instances_long_package$.prototype = $c_Lcats_kernel_instances_long_package$.prototype;
$c_Lcats_kernel_instances_long_package$.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdOrderForLong_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_kernel_instances_long_package$.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdGroupForLong_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
  this.Lcats_kernel_instances_long_package$__f_catsKernelStdGroupForLong = x$0;
});
var $d_Lcats_kernel_instances_long_package$ = new $TypeData().initClass($c_Lcats_kernel_instances_long_package$, "cats.kernel.instances.long.package$", ({
  Lcats_kernel_instances_long_package$: 1,
  Lcats_kernel_instances_LongInstances: 1
}));
var $n_Lcats_kernel_instances_long_package$;
function $m_Lcats_kernel_instances_long_package$() {
  if ((!$n_Lcats_kernel_instances_long_package$)) {
    $n_Lcats_kernel_instances_long_package$ = new $c_Lcats_kernel_instances_long_package$();
  }
  return $n_Lcats_kernel_instances_long_package$;
}
/** @constructor */
function $c_Lcats_kernel_instances_string_package$() {
  this.Lcats_kernel_instances_string_package$__f_catsKernelStdOrderForString = null;
  $n_Lcats_kernel_instances_string_package$ = this;
  $f_Lcats_kernel_instances_StringInstances__$init$__V(this);
}
$c_Lcats_kernel_instances_string_package$.prototype = new $h_O();
$c_Lcats_kernel_instances_string_package$.prototype.constructor = $c_Lcats_kernel_instances_string_package$;
/** @constructor */
function $h_Lcats_kernel_instances_string_package$() {
}
$h_Lcats_kernel_instances_string_package$.prototype = $c_Lcats_kernel_instances_string_package$.prototype;
$c_Lcats_kernel_instances_string_package$.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdOrderForString_$eq__Lcats_kernel_Hash__V = (function(x$0) {
  this.Lcats_kernel_instances_string_package$__f_catsKernelStdOrderForString = x$0;
});
$c_Lcats_kernel_instances_string_package$.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdMonoidForString_$eq__Lcats_kernel_Monoid__V = (function(x$0) {
});
var $d_Lcats_kernel_instances_string_package$ = new $TypeData().initClass($c_Lcats_kernel_instances_string_package$, "cats.kernel.instances.string.package$", ({
  Lcats_kernel_instances_string_package$: 1,
  Lcats_kernel_instances_StringInstances: 1
}));
var $n_Lcats_kernel_instances_string_package$;
function $m_Lcats_kernel_instances_string_package$() {
  if ((!$n_Lcats_kernel_instances_string_package$)) {
    $n_Lcats_kernel_instances_string_package$ = new $c_Lcats_kernel_instances_string_package$();
  }
  return $n_Lcats_kernel_instances_string_package$;
}
/** @constructor */
function $c_Lcats_kernel_instances_unit_package$() {
  this.Lcats_kernel_instances_unit_package$__f_catsKernelStdAlgebraForUnit = null;
  $n_Lcats_kernel_instances_unit_package$ = this;
  $f_Lcats_kernel_instances_UnitInstances__$init$__V(this);
}
$c_Lcats_kernel_instances_unit_package$.prototype = new $h_O();
$c_Lcats_kernel_instances_unit_package$.prototype.constructor = $c_Lcats_kernel_instances_unit_package$;
/** @constructor */
function $h_Lcats_kernel_instances_unit_package$() {
}
$h_Lcats_kernel_instances_unit_package$.prototype = $c_Lcats_kernel_instances_unit_package$.prototype;
$c_Lcats_kernel_instances_unit_package$.prototype.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdOrderForUnit_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_kernel_instances_unit_package$.prototype.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdAlgebraForUnit_$eq__Lcats_kernel_BoundedSemilattice__V = (function(x$0) {
  this.Lcats_kernel_instances_unit_package$__f_catsKernelStdAlgebraForUnit = x$0;
});
var $d_Lcats_kernel_instances_unit_package$ = new $TypeData().initClass($c_Lcats_kernel_instances_unit_package$, "cats.kernel.instances.unit.package$", ({
  Lcats_kernel_instances_unit_package$: 1,
  Lcats_kernel_instances_UnitInstances: 1
}));
var $n_Lcats_kernel_instances_unit_package$;
function $m_Lcats_kernel_instances_unit_package$() {
  if ((!$n_Lcats_kernel_instances_unit_package$)) {
    $n_Lcats_kernel_instances_unit_package$ = new $c_Lcats_kernel_instances_unit_package$();
  }
  return $n_Lcats_kernel_instances_unit_package$;
}
/** @constructor */
function $c_Lcats_syntax_SeparateOps(fgab) {
  this.Lcats_syntax_SeparateOps__f_fgab = null;
  this.Lcats_syntax_SeparateOps__f_fgab = fgab;
}
$c_Lcats_syntax_SeparateOps.prototype = new $h_O();
$c_Lcats_syntax_SeparateOps.prototype.constructor = $c_Lcats_syntax_SeparateOps;
/** @constructor */
function $h_Lcats_syntax_SeparateOps() {
}
$h_Lcats_syntax_SeparateOps.prototype = $c_Lcats_syntax_SeparateOps.prototype;
$c_Lcats_syntax_SeparateOps.prototype.hashCode__I = (function() {
  var this$ = this.Lcats_syntax_SeparateOps__f_fgab;
  return $dp_hashCode__I($n(this$));
});
$c_Lcats_syntax_SeparateOps.prototype.equals__O__Z = (function(x$0) {
  return $m_Lcats_syntax_SeparateOps$().equals$extension__O__O__Z(this.Lcats_syntax_SeparateOps__f_fgab, x$0);
});
function $as_Lcats_syntax_SeparateOps(obj) {
  return (((obj instanceof $c_Lcats_syntax_SeparateOps) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.syntax.SeparateOps"));
}
function $isArrayOf_Lcats_syntax_SeparateOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_syntax_SeparateOps)));
}
function $asArrayOf_Lcats_syntax_SeparateOps(obj, depth) {
  return (($isArrayOf_Lcats_syntax_SeparateOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.syntax.SeparateOps;", depth));
}
var $d_Lcats_syntax_SeparateOps = new $TypeData().initClass($c_Lcats_syntax_SeparateOps, "cats.syntax.SeparateOps", ({
  Lcats_syntax_SeparateOps: 1,
  Lcats_syntax_SeparateOpsBinCompat0: 1
}));
/** @constructor */
function $c_Lcats_syntax_Tuple2SemigroupalOps(t2) {
  this.Lcats_syntax_Tuple2SemigroupalOps__f_t2 = null;
  this.Lcats_syntax_Tuple2SemigroupalOps__f_t2 = t2;
}
$c_Lcats_syntax_Tuple2SemigroupalOps.prototype = new $h_O();
$c_Lcats_syntax_Tuple2SemigroupalOps.prototype.constructor = $c_Lcats_syntax_Tuple2SemigroupalOps;
/** @constructor */
function $h_Lcats_syntax_Tuple2SemigroupalOps() {
}
$h_Lcats_syntax_Tuple2SemigroupalOps.prototype = $c_Lcats_syntax_Tuple2SemigroupalOps.prototype;
$c_Lcats_syntax_Tuple2SemigroupalOps.prototype.mapN__F2__Lcats_Functor__Lcats_Semigroupal__O = (function(f, functor, semigroupal) {
  var this$1 = $m_Lcats_Semigroupal$();
  var f0 = $n(this.Lcats_syntax_Tuple2SemigroupalOps__f_t2)._1__O();
  var f1 = $n(this.Lcats_syntax_Tuple2SemigroupalOps__f_t2)._2__O();
  return $f_Lcats_SemigroupalArityFunctions__map2__O__O__F2__Lcats_Semigroupal__Lcats_Functor__O(this$1, f0, f1, f, semigroupal, functor);
});
$c_Lcats_syntax_Tuple2SemigroupalOps.prototype.flatMapN__F2__Lcats_FlatMap__O = (function(f, flatMap) {
  var this$1 = $n(flatMap);
  var f0 = $n(this.Lcats_syntax_Tuple2SemigroupalOps__f_t2)._1__O();
  var f1 = $n(this.Lcats_syntax_Tuple2SemigroupalOps__f_t2)._2__O();
  return $f_Lcats_FlatMapArityFunctions__flatMap2__O__O__F2__O(this$1, f0, f1, f);
});
$c_Lcats_syntax_Tuple2SemigroupalOps.prototype.tupled__Lcats_Invariant__Lcats_Semigroupal__O = (function(invariant, semigroupal) {
  var this$1 = $m_Lcats_Semigroupal$();
  var f0 = $n(this.Lcats_syntax_Tuple2SemigroupalOps__f_t2)._1__O();
  var f1 = $n(this.Lcats_syntax_Tuple2SemigroupalOps__f_t2)._2__O();
  return $f_Lcats_SemigroupalArityFunctions__tuple2__O__O__Lcats_Semigroupal__Lcats_Invariant__O(this$1, f0, f1, semigroupal, invariant);
});
var $d_Lcats_syntax_Tuple2SemigroupalOps = new $TypeData().initClass($c_Lcats_syntax_Tuple2SemigroupalOps, "cats.syntax.Tuple2SemigroupalOps", ({
  Lcats_syntax_Tuple2SemigroupalOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_syntax_Tuple3SemigroupalOps(t3) {
  this.Lcats_syntax_Tuple3SemigroupalOps__f_t3 = null;
  this.Lcats_syntax_Tuple3SemigroupalOps__f_t3 = t3;
}
$c_Lcats_syntax_Tuple3SemigroupalOps.prototype = new $h_O();
$c_Lcats_syntax_Tuple3SemigroupalOps.prototype.constructor = $c_Lcats_syntax_Tuple3SemigroupalOps;
/** @constructor */
function $h_Lcats_syntax_Tuple3SemigroupalOps() {
}
$h_Lcats_syntax_Tuple3SemigroupalOps.prototype = $c_Lcats_syntax_Tuple3SemigroupalOps.prototype;
$c_Lcats_syntax_Tuple3SemigroupalOps.prototype.mapN__F3__Lcats_Functor__Lcats_Semigroupal__O = (function(f, functor, semigroupal) {
  var this$1 = $m_Lcats_Semigroupal$();
  var f0 = $n(this.Lcats_syntax_Tuple3SemigroupalOps__f_t3).T3__f__1;
  var f1 = $n(this.Lcats_syntax_Tuple3SemigroupalOps__f_t3).T3__f__2;
  var f2 = $n(this.Lcats_syntax_Tuple3SemigroupalOps__f_t3).T3__f__3;
  return $f_Lcats_SemigroupalArityFunctions__map3__O__O__O__F3__Lcats_Semigroupal__Lcats_Functor__O(this$1, f0, f1, f2, f, semigroupal, functor);
});
var $d_Lcats_syntax_Tuple3SemigroupalOps = new $TypeData().initClass($c_Lcats_syntax_Tuple3SemigroupalOps, "cats.syntax.Tuple3SemigroupalOps", ({
  Lcats_syntax_Tuple3SemigroupalOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_syntax_Tuple4SemigroupalOps(t4) {
  this.Lcats_syntax_Tuple4SemigroupalOps__f_t4 = null;
  this.Lcats_syntax_Tuple4SemigroupalOps__f_t4 = t4;
}
$c_Lcats_syntax_Tuple4SemigroupalOps.prototype = new $h_O();
$c_Lcats_syntax_Tuple4SemigroupalOps.prototype.constructor = $c_Lcats_syntax_Tuple4SemigroupalOps;
/** @constructor */
function $h_Lcats_syntax_Tuple4SemigroupalOps() {
}
$h_Lcats_syntax_Tuple4SemigroupalOps.prototype = $c_Lcats_syntax_Tuple4SemigroupalOps.prototype;
$c_Lcats_syntax_Tuple4SemigroupalOps.prototype.mapN__F4__Lcats_Functor__Lcats_Semigroupal__O = (function(f, functor, semigroupal) {
  var this$1 = $m_Lcats_Semigroupal$();
  var f0 = $n(this.Lcats_syntax_Tuple4SemigroupalOps__f_t4).T4__f__1;
  var f1 = $n(this.Lcats_syntax_Tuple4SemigroupalOps__f_t4).T4__f__2;
  var f2 = $n(this.Lcats_syntax_Tuple4SemigroupalOps__f_t4).T4__f__3;
  var f3 = $n(this.Lcats_syntax_Tuple4SemigroupalOps__f_t4).T4__f__4;
  return $f_Lcats_SemigroupalArityFunctions__map4__O__O__O__O__F4__Lcats_Semigroupal__Lcats_Functor__O(this$1, f0, f1, f2, f3, f, semigroupal, functor);
});
$c_Lcats_syntax_Tuple4SemigroupalOps.prototype.flatMapN__F4__Lcats_FlatMap__O = (function(f, flatMap) {
  var this$1 = $n(flatMap);
  var f0 = $n(this.Lcats_syntax_Tuple4SemigroupalOps__f_t4).T4__f__1;
  var f1 = $n(this.Lcats_syntax_Tuple4SemigroupalOps__f_t4).T4__f__2;
  var f2 = $n(this.Lcats_syntax_Tuple4SemigroupalOps__f_t4).T4__f__3;
  var f3 = $n(this.Lcats_syntax_Tuple4SemigroupalOps__f_t4).T4__f__4;
  return $f_Lcats_FlatMapArityFunctions__flatMap4__O__O__O__O__F4__O(this$1, f0, f1, f2, f3, f);
});
var $d_Lcats_syntax_Tuple4SemigroupalOps = new $TypeData().initClass($c_Lcats_syntax_Tuple4SemigroupalOps, "cats.syntax.Tuple4SemigroupalOps", ({
  Lcats_syntax_Tuple4SemigroupalOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_syntax_Tuple5SemigroupalOps(t5) {
  this.Lcats_syntax_Tuple5SemigroupalOps__f_t5 = null;
  this.Lcats_syntax_Tuple5SemigroupalOps__f_t5 = t5;
}
$c_Lcats_syntax_Tuple5SemigroupalOps.prototype = new $h_O();
$c_Lcats_syntax_Tuple5SemigroupalOps.prototype.constructor = $c_Lcats_syntax_Tuple5SemigroupalOps;
/** @constructor */
function $h_Lcats_syntax_Tuple5SemigroupalOps() {
}
$h_Lcats_syntax_Tuple5SemigroupalOps.prototype = $c_Lcats_syntax_Tuple5SemigroupalOps.prototype;
$c_Lcats_syntax_Tuple5SemigroupalOps.prototype.mapN__F5__Lcats_Functor__Lcats_Semigroupal__O = (function(f, functor, semigroupal) {
  var this$1 = $m_Lcats_Semigroupal$();
  var f0 = $n(this.Lcats_syntax_Tuple5SemigroupalOps__f_t5).T5__f__1;
  var f1 = $n(this.Lcats_syntax_Tuple5SemigroupalOps__f_t5).T5__f__2;
  var f2 = $n(this.Lcats_syntax_Tuple5SemigroupalOps__f_t5).T5__f__3;
  var f3 = $n(this.Lcats_syntax_Tuple5SemigroupalOps__f_t5).T5__f__4;
  var f4 = $n(this.Lcats_syntax_Tuple5SemigroupalOps__f_t5).T5__f__5;
  return $f_Lcats_SemigroupalArityFunctions__map5__O__O__O__O__O__F5__Lcats_Semigroupal__Lcats_Functor__O(this$1, f0, f1, f2, f3, f4, f, semigroupal, functor);
});
var $d_Lcats_syntax_Tuple5SemigroupalOps = new $TypeData().initClass($c_Lcats_syntax_Tuple5SemigroupalOps, "cats.syntax.Tuple5SemigroupalOps", ({
  Lcats_syntax_Tuple5SemigroupalOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_syntax_Tuple6SemigroupalOps(t6) {
  this.Lcats_syntax_Tuple6SemigroupalOps__f_t6 = null;
  this.Lcats_syntax_Tuple6SemigroupalOps__f_t6 = t6;
}
$c_Lcats_syntax_Tuple6SemigroupalOps.prototype = new $h_O();
$c_Lcats_syntax_Tuple6SemigroupalOps.prototype.constructor = $c_Lcats_syntax_Tuple6SemigroupalOps;
/** @constructor */
function $h_Lcats_syntax_Tuple6SemigroupalOps() {
}
$h_Lcats_syntax_Tuple6SemigroupalOps.prototype = $c_Lcats_syntax_Tuple6SemigroupalOps.prototype;
$c_Lcats_syntax_Tuple6SemigroupalOps.prototype.mapN__F6__Lcats_Functor__Lcats_Semigroupal__O = (function(f, functor, semigroupal) {
  var this$1 = $m_Lcats_Semigroupal$();
  var f0 = $n(this.Lcats_syntax_Tuple6SemigroupalOps__f_t6).T6__f__1;
  var f1 = $n(this.Lcats_syntax_Tuple6SemigroupalOps__f_t6).T6__f__2;
  var f2 = $n(this.Lcats_syntax_Tuple6SemigroupalOps__f_t6).T6__f__3;
  var f3 = $n(this.Lcats_syntax_Tuple6SemigroupalOps__f_t6).T6__f__4;
  var f4 = $n(this.Lcats_syntax_Tuple6SemigroupalOps__f_t6).T6__f__5;
  var f5 = $n(this.Lcats_syntax_Tuple6SemigroupalOps__f_t6).T6__f__6;
  return $f_Lcats_SemigroupalArityFunctions__map6__O__O__O__O__O__O__F6__Lcats_Semigroupal__Lcats_Functor__O(this$1, f0, f1, f2, f3, f4, f5, f, semigroupal, functor);
});
var $d_Lcats_syntax_Tuple6SemigroupalOps = new $TypeData().initClass($c_Lcats_syntax_Tuple6SemigroupalOps, "cats.syntax.Tuple6SemigroupalOps", ({
  Lcats_syntax_Tuple6SemigroupalOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_syntax_Tuple7SemigroupalOps(t7) {
  this.Lcats_syntax_Tuple7SemigroupalOps__f_t7 = null;
  this.Lcats_syntax_Tuple7SemigroupalOps__f_t7 = t7;
}
$c_Lcats_syntax_Tuple7SemigroupalOps.prototype = new $h_O();
$c_Lcats_syntax_Tuple7SemigroupalOps.prototype.constructor = $c_Lcats_syntax_Tuple7SemigroupalOps;
/** @constructor */
function $h_Lcats_syntax_Tuple7SemigroupalOps() {
}
$h_Lcats_syntax_Tuple7SemigroupalOps.prototype = $c_Lcats_syntax_Tuple7SemigroupalOps.prototype;
$c_Lcats_syntax_Tuple7SemigroupalOps.prototype.mapN__F7__Lcats_Functor__Lcats_Semigroupal__O = (function(f, functor, semigroupal) {
  var this$1 = $m_Lcats_Semigroupal$();
  var f0 = $n(this.Lcats_syntax_Tuple7SemigroupalOps__f_t7).T7__f__1;
  var f1 = $n(this.Lcats_syntax_Tuple7SemigroupalOps__f_t7).T7__f__2;
  var f2 = $n(this.Lcats_syntax_Tuple7SemigroupalOps__f_t7).T7__f__3;
  var f3 = $n(this.Lcats_syntax_Tuple7SemigroupalOps__f_t7).T7__f__4;
  var f4 = $n(this.Lcats_syntax_Tuple7SemigroupalOps__f_t7).T7__f__5;
  var f5 = $n(this.Lcats_syntax_Tuple7SemigroupalOps__f_t7).T7__f__6;
  var f6 = $n(this.Lcats_syntax_Tuple7SemigroupalOps__f_t7).T7__f__7;
  return $f_Lcats_SemigroupalArityFunctions__map7__O__O__O__O__O__O__O__F7__Lcats_Semigroupal__Lcats_Functor__O(this$1, f0, f1, f2, f3, f4, f5, f6, f, semigroupal, functor);
});
var $d_Lcats_syntax_Tuple7SemigroupalOps = new $TypeData().initClass($c_Lcats_syntax_Tuple7SemigroupalOps, "cats.syntax.Tuple7SemigroupalOps", ({
  Lcats_syntax_Tuple7SemigroupalOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1(outer) {
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_tyrian$TyrianApp$$evidence$1 = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_run = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer = outer;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_tyrian$TyrianApp$$evidence$1 = $n(outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_dev$sungkm$enchantedrealm$EnchantedRealm$$evidence$1;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_run = new $c_sjsr_AnonFunction1(((_$2) => {
    var this$1 = $n($n(outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_dispatcher);
    $f_Lcats_effect_std_Dispatcher__unsafeRunAndForget__O__V(this$1, _$2);
  }));
}
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1.prototype = new $h_O();
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1.prototype.constructor = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1;
/** @constructor */
function $h_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1() {
}
$h_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1.prototype = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1.prototype;
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1.prototype.router__F1 = (function() {
  return $m_Ltyrian_Routing$().none__O__F1($n($n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_Msg$lzy1).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_NoOp);
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1.prototype.update__Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__F1 = (function(model) {
  return new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg(x$1);
    var x = $n($n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_Msg$lzy1).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_NoOp;
    if (((x === null) ? (x$1$1 === null) : $n(x).equals__O__Z(x$1$1))) {
      var _2 = $m_Ltyrian_Cmd$None$();
      return new $c_T2(model, _2);
    }
    if (((x$1$1 instanceof $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage) && ($n($as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage(x$1$1)).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage__f_$outer === $n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_Msg$lzy1))) {
      $n($n($n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_Msg$lzy1).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_SystemMessage$lzy1);
      var x$1$2 = $as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage(x$1$1);
      var this$4 = $n(x$1$2);
      var x38 = this$4.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage__f_msg;
      var systemMessage$1 = new $c_s_Some(x38);
      var this$6 = $n(model);
      var text$1 = this$6.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_text;
      var this$7 = $n(model);
      var userChoices$1 = this$7.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_userChoices;
      var this$8 = $n(model);
      var engine$1 = this$8.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_engine;
      var this$9 = $n(model);
      var engineResponseStream$1 = this$9.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_engineResponseStream;
      var _1 = $n(model).copy__T__s_Option__sci_List__s_Option__s_Option__Ldev_sungkm_enchantedrealm_EnchantedRealm$Model(text$1, systemMessage$1, userChoices$1, engine$1, engineResponseStream$1);
      var _2$1 = $m_Ltyrian_Cmd$None$();
      return new $c_T2(_1, _2$1);
    }
    if (((x$1$1 instanceof $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit) && ($n($as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit(x$1$1)).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit__f_$outer === $n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_Msg$lzy1))) {
      $n($n($n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_Msg$lzy1).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_FinishInit$lzy1);
      var x$1$3 = $as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit(x$1$1);
      var this$12 = $n(x$1$3);
      var x35 = this$12.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit__f_engine;
      var x$2 = ("Engine initialized: " + x35.modelId);
      var this$14 = $m_s_Console$();
      $n(this$14.out__Ljava_io_PrintStream()).println__O__V(x$2);
      var systemMessage$2 = new $c_s_Some("Engine initialized");
      var engine$2 = new $c_s_Some(x35);
      var this$17 = $n(model);
      var text$2 = this$17.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_text;
      var this$18 = $n(model);
      var userChoices$2 = this$18.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_userChoices;
      var this$19 = $n(model);
      var engineResponseStream$2 = this$19.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_engineResponseStream;
      var model1 = $n(model).copy__T__s_Option__sci_List__s_Option__s_Option__Ldev_sungkm_enchantedrealm_EnchantedRealm$Model(text$2, systemMessage$2, userChoices$2, engine$2, engineResponseStream$2);
      var $x_1 = $m_Ltyrian_Cmd$Run$();
      var target = $m_Ldev_sungkm_enchantedrealm_Prompt$().sendInitialPrompt__Ltypings_mlcAiWebLlm_libServiceWorkerMod$ServiceWorkerMLCEngine__Lcats_effect_kernel_Async__Lcats_effect_std_Random__O(x35, $n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_dev$sungkm$enchantedrealm$EnchantedRealm$$evidence$1, $n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_dev$sungkm$enchantedrealm$EnchantedRealm$$evidence$2);
      var tc = $n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_dev$sungkm$enchantedrealm$EnchantedRealm$$evidence$1;
      var this$21 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
      var f = new $c_sjsr_AnonFunction1(((_$3) => {
        var _$3$1 = $as_Lfs2_Stream(_$3);
        return $n($n($n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_Msg$lzy1).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_SubscribeEngineResponse$lzy1).apply__Lfs2_Stream__Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse(_$3$1);
      }));
      var cmd = $n($x_1).apply__O__Lcats_Applicative__Ltyrian_Cmd$Run($n(this$21.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$21.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f), $n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_dev$sungkm$enchantedrealm$EnchantedRealm$$evidence$1);
      return new $c_T2(model1, cmd);
    }
    if (((x$1$1 instanceof $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse) && ($n($as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse(x$1$1)).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse__f_$outer === $n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_Msg$lzy1))) {
      $n($n($n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_Msg$lzy1).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_SubscribeEngineResponse$lzy1);
      var x$1$4 = $as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse(x$1$1);
      var this$24 = $n(x$1$4);
      var x32 = this$24.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse__f_stream;
      var engineResponseStream$3 = new $c_s_Some(x32);
      var this$26 = $n(model);
      var text$3 = this$26.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_text;
      var this$27 = $n(model);
      var systemMessage$3 = this$27.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_systemMessage;
      var this$28 = $n(model);
      var userChoices$3 = this$28.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_userChoices;
      var this$29 = $n(model);
      var engine$3 = this$29.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_engine;
      var _1$1 = $n(model).copy__T__s_Option__sci_List__s_Option__s_Option__Ldev_sungkm_enchantedrealm_EnchantedRealm$Model(text$3, systemMessage$3, userChoices$3, engine$3, engineResponseStream$3);
      var _2$2 = $m_Ltyrian_Cmd$None$();
      return new $c_T2(_1$1, _2$2);
    }
    if (((x$1$1 instanceof $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse) && ($n($as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse(x$1$1)).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse__f_$outer === $n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_Msg$lzy1))) {
      $n($n($n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_Msg$lzy1).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_EngineResponse$lzy1);
      var x$1$5 = $as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse(x$1$1);
      var this$32 = $n(x$1$5);
      var x29 = this$32.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse__f_response;
      var $x_6 = $n(model);
      var $x_5 = $n(model).Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_text;
      var this$33 = $n(model);
      var $x_4 = this$33.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_systemMessage;
      var this$34 = $n(model);
      var $x_3 = this$34.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_userChoices;
      var this$35 = $n(model);
      var $x_2 = this$35.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_engine;
      var this$36 = $n(model);
      var _1$2 = $n($x_6).copy__T__s_Option__sci_List__s_Option__s_Option__Ldev_sungkm_enchantedrealm_EnchantedRealm$Model((("" + $x_5) + x29), $x_4, $x_3, $x_2, this$36.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_engineResponseStream);
      var _2$3 = $m_Ltyrian_Cmd$None$();
      return new $c_T2(_1$2, _2$3);
    }
    var x$3 = $n($n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_Msg$lzy1).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_FinishEngineResponse;
    if (((x$3 === null) ? (x$1$1 === null) : $n(x$3).equals__O__Z(x$1$1))) {
      var this$39 = $m_s_Console$();
      $n(this$39.out__Ljava_io_PrintStream()).println__O__V("Engine response finished");
      var this$41 = $m_s_Console$();
      $n(this$41.out__Ljava_io_PrintStream()).println__O__V("--------------------------------");
      var x$4 = $n(model).Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_text;
      var this$43 = $m_s_Console$();
      $n(this$43.out__Ljava_io_PrintStream()).println__O__V(x$4);
      var this$45 = $m_s_Console$();
      $n(this$45.out__Ljava_io_PrintStream()).println__O__V("--------------------------------");
      var _2$4 = $m_Ltyrian_Cmd$None$();
      return new $c_T2(model, _2$4);
    }
    throw new $c_s_MatchError(x$1$1);
  }));
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1.prototype.view__Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__Ltyrian_Html = (function(model) {
  var this$1 = $n($n($m_Llaika_api_Transformer$().from__Llaika_api_format_MarkupFormat__Llaika_api_Transformer$Builder($m_Llaika_format_Markdown$())).to__Llaika_api_format_RenderFormat__Llaika_api_builder_TransformerBuilder($m_Llaika_format_HTML$()));
  var bundles = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_bundle_ExtensionBundle.getArrayOf().constr)([$m_Llaika_format_Markdown$GitHubFlavor$()]));
  var this$2 = $n($n($as_Llaika_api_builder_TransformerBuilder($f_Llaika_api_builder_CommonBuilderOps__using__sci_Seq__O(this$1, bundles))).build__Llaika_api_Transformer());
  var input = $n(model).Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_text;
  var either = this$2.transform__T__Llaika_ast_Path__s_util_Either(input, $m_Llaika_ast_Path$Root$());
  matchResult21: {
    var textHtml;
    if ((either instanceof $c_s_util_Left)) {
      var err = $as_Llaika_api_errors_TransformationError($n($as_s_util_Left(either)).s_util_Left__f_value);
      var x = ("Error transforming markdown to html: " + err);
      var this$4 = $m_s_Console$();
      $n(this$4.out__Ljava_io_PrintStream()).println__O__V(x);
      var textHtml = $n(model).Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_text;
      break matchResult21;
    }
    if ((either instanceof $c_s_util_Right)) {
      var value = $as_T($n($as_s_util_Right(either)).s_util_Right__f_value);
      var textHtml = value;
      break matchResult21;
    }
    throw new $c_s_MatchError(either);
  }
  $m_Ltyrian_Html$();
  var attributes$8 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$n($m_Ltyrian_Html$().Ltyrian_Html$__f_$u0060class$u0060$minusString).$colon$eq__T__Ltyrian_Attribute("container")]));
  var $x_6 = $m_sr_ScalaRunTime$();
  var this$5 = $m_Ltyrian_Html$();
  var $x_5 = $f_Ltyrian_HtmlTags__h1$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$5, "Enchanted Realm");
  var this$6 = $m_Ltyrian_Html$();
  var attributes = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([]));
  var $x_4 = $f_Ltyrian_HtmlTags__div$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html(this$6, attributes, "Welcome to the Enchanted Realm! Your journey begins here...");
  $m_Ltyrian_Html$();
  var attributes$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$n($m_Ltyrian_Html$().Ltyrian_Html$__f_id$minusString).$colon$eq__T__Ltyrian_Attribute("text-area")]));
  var children = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([]));
  var this$8 = $n(attributes$1);
  var attributes$2 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$8);
  var this$10 = $n(children);
  var children$1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$10);
  var key = $m_s_None$();
  var this$14 = new $c_Ltyrian_Tag("div", attributes$2, children$1, key);
  var name = this$14.Ltyrian_Tag__f_name;
  var attributes$3 = this$14.Ltyrian_Tag__f_attributes;
  var key$1 = $m_s_None$();
  var $x_3 = new $c_Ltyrian_RawTag(name, attributes$3, textHtml, key$1);
  var this$17 = $n($n(model).Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_systemMessage);
  if (this$17.isEmpty__Z()) {
    var $x_2 = $m_s_None$();
  } else {
    var arg1 = this$17.get__O();
    var msg = $as_T(arg1);
    var this$18 = $m_Ltyrian_Html$();
    var attributes$4 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$n($m_Ltyrian_Html$().Ltyrian_Html$__f_id$minusString).$colon$eq__T__Ltyrian_Attribute("system-message")]));
    var $x_2 = new $c_s_Some($f_Ltyrian_HtmlTags__div$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html(this$18, attributes$4, msg));
  }
  var this$19 = $n($x_2);
  var $x_1 = $as_Ltyrian_Elem((this$19.isEmpty__Z() ? $m_Ltyrian_Empty$() : this$19.get__O()));
  $m_Ltyrian_Html$();
  var attributes$6 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$n($m_Ltyrian_Html$().Ltyrian_Html$__f_id$minusString).$colon$eq__T__Ltyrian_Attribute("choices")]));
  var this$21 = $n($n(model).Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_userChoices);
  var f = ((choice) => {
    var choice$1 = $as_T(choice);
    var this$20 = $m_Ltyrian_Html$();
    var attributes$5 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$n($m_Ltyrian_Html$().Ltyrian_Html$__f_$u0060class$u0060$minusString).$colon$eq__T__Ltyrian_Attribute("button")]));
    return $f_Ltyrian_HtmlTags__button$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html(this$20, attributes$5, choice$1);
  });
  if ((this$21 === $m_sci_Nil$())) {
    var children$2 = $m_sci_Nil$();
  } else {
    var arg1$1 = this$21.head__O();
    var h = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$21.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$2 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O());
    }
    var children$2 = h;
  }
  var this$23 = $n(attributes$6);
  var attributes$7 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$23);
  var key$2 = $m_s_None$();
  var children$3 = $n($x_6).wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$x_5, $x_4, $x_3, $x_1, new $c_Ltyrian_Tag("div", attributes$7, children$2, key$2)]));
  var this$28 = $n(attributes$8);
  var attributes$9 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$28);
  var this$30 = $n(children$3);
  var children$4 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$30);
  var key$3 = $m_s_None$();
  return new $c_Ltyrian_Tag("div", attributes$9, children$4, key$3);
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1.prototype.init__sci_Map__T2 = (function(flags) {
  var $x_1 = $m_Ltyrian_Cmd$Run$();
  var target = $m_Ldev_sungkm_enchantedrealm_Engine$().engine__F1__Lcats_effect_kernel_Async__O(new $c_sjsr_AnonFunction1(((report) => {
    var this$2 = $n($n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_dispatcher);
    var fa = $n($n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_queue).offer__O__O($as_T(report.text));
    $f_Lcats_effect_std_Dispatcher__unsafeRunAndForget__O__V(this$2, fa);
  })), $n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_dev$sungkm$enchantedrealm$EnchantedRealm$$evidence$1);
  var tc = $n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_dev$sungkm$enchantedrealm$EnchantedRealm$$evidence$1;
  var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
  var f = new $c_sjsr_AnonFunction1(((engine) => $n($n($n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_Msg$lzy1).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_FinishInit$lzy1).apply__Ltypings_mlcAiWebLlm_libServiceWorkerMod$ServiceWorkerMLCEngine__Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit(engine)));
  var launchEngineCmd = $n($x_1).apply__O__Lcats_Applicative__Ltyrian_Cmd$Run($n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f), $n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_dev$sungkm$enchantedrealm$EnchantedRealm$$evidence$1);
  var _1 = $n($n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Model__Ldev_sungkm_enchantedrealm_EnchantedRealm$Model$()).init__Ldev_sungkm_enchantedrealm_EnchantedRealm$Model();
  return new $c_T2(_1, launchEngineCmd);
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1.prototype.subscriptions__Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__Ltyrian_Sub = (function(model) {
  var engineInitReportStream = $n($m_Lfs2_Stream$().repeatEval__O__Lfs2_Stream($n($n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_queue).take__O())).map__F1__Lfs2_Stream(new $c_sjsr_AnonFunction1(((_$4) => {
    var _$4$1 = $as_T(_$4);
    return $n($n($n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_Msg$lzy1).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_SystemMessage$lzy1).apply__T__Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage(_$4$1);
  })));
  var x44 = $n(model).Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_engineResponseStream;
  var x = $m_s_None$();
  if ((x === x44)) {
    var $x_1 = $m_Ltyrian_Sub$();
    var F = $n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_dev$sungkm$enchantedrealm$EnchantedRealm$$evidence$1;
    var this$3 = $n(F);
    return $n($x_1).make__T__Lfs2_Stream__O__Lcats_effect_kernel_Async__Ltyrian_Sub("engine-init-report", engineInitReportStream, this$3.pure__O__O((void 0)), $n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_dev$sungkm$enchantedrealm$EnchantedRealm$$evidence$1);
  }
  if ((x44 instanceof $c_s_Some)) {
    var stream = $as_Lfs2_Stream($n($as_s_Some(x44)).s_Some__f_value);
    var $x_7 = $m_sr_ScalaRunTime$();
    var $x_6 = $m_Ltyrian_Sub$();
    var F$1 = $n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_dev$sungkm$enchantedrealm$EnchantedRealm$$evidence$1;
    var this$5 = $n(F$1);
    var $x_5 = $n($x_6).make__T__Lfs2_Stream__O__Lcats_effect_kernel_Async__Ltyrian_Sub("engine-init-report", engineInitReportStream, this$5.pure__O__O((void 0)), $n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_dev$sungkm$enchantedrealm$EnchantedRealm$$evidence$1);
    var $x_4 = $m_Ltyrian_Sub$();
    var $x_2 = $n(stream).map__F1__Lfs2_Stream(new $c_sjsr_AnonFunction1(((_$5) => {
      var _$5$1 = $as_s_Option(_$5);
      var this$6 = $n(_$5$1);
      if (this$6.isEmpty__Z()) {
        var $x_3 = $n($n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_Msg$lzy1).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_FinishEngineResponse;
      } else {
        var arg1 = this$6.get__O();
        var _$6 = $as_T(arg1);
        var $x_3 = $n($n($n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_Msg$lzy1).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_EngineResponse$lzy1).apply__T__Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse(_$6);
      }
      return $as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg($x_3);
    })));
    var F$2 = $n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_dev$sungkm$enchantedrealm$EnchantedRealm$$evidence$1;
    var this$8 = $n(F$2);
    var subs = $n($x_7).wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Sub.getArrayOf().constr)([$x_5, $n($x_4).make__T__Lfs2_Stream__O__Lcats_effect_kernel_Async__Ltyrian_Sub("engine-response", $x_2, this$8.pure__O__O((void 0)), $n(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1__f_$outer).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_dev$sungkm$enchantedrealm$EnchantedRealm$$evidence$1)]));
    var this$10 = $n(subs);
    var subs$1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$10);
    return new $c_Ltyrian_Sub$Batch(subs$1);
  }
  throw new $c_s_MatchError(x44);
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1.prototype.launch = (function(arg, ...rest) {
  switch ($uI(rest.length)) {
    case 0: {
      if (((typeof arg) === "string")) {
        var prep0$2 = $as_T(arg);
        $f_Ltyrian_TyrianApp__launch__T__V(this, prep0$2);
        return (void 0);
      } else {
        $f_Ltyrian_TyrianApp__launch__Lorg_scalajs_dom_Element__V(this, arg);
        return (void 0);
      }
      break;
    }
    case 1: {
      if (((typeof arg) === "string")) {
        var prep0$4 = $as_T(arg);
        var prep1$2 = rest[0];
        $f_Ltyrian_TyrianApp__launch__T__sjs_js_Dictionary__V(this, prep0$4, prep1$2);
        return (void 0);
      } else {
        var prep1 = rest[0];
        $f_Ltyrian_TyrianApp__launch__Lorg_scalajs_dom_Element__sjs_js_Dictionary__V(this, arg, prep1);
        return (void 0);
      }
      break;
    }
    default: {
      throw new TypeError("No matching overload");
    }
  }
});
var $d_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1 = new $TypeData().initClass($c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1, "dev.sungkm.enchantedrealm.EnchantedRealm$$anon$1", ({
  Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1: 1,
  Ltyrian_TyrianApp: 1
}));
/** @constructor */
function $c_Ldev_sungkm_enchantedrealm_Main$() {
}
$c_Ldev_sungkm_enchantedrealm_Main$.prototype = new $h_O();
$c_Ldev_sungkm_enchantedrealm_Main$.prototype.constructor = $c_Ldev_sungkm_enchantedrealm_Main$;
/** @constructor */
function $h_Ldev_sungkm_enchantedrealm_Main$() {
}
$h_Ldev_sungkm_enchantedrealm_Main$.prototype = $c_Ldev_sungkm_enchantedrealm_Main$.prototype;
$c_Ldev_sungkm_enchantedrealm_Main$.prototype.run__sci_List__Lcats_effect_kernel_Resource = (function(args) {
  var this$1 = $m_Lcats_effect_std_Dispatcher$();
  var evidence$2 = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO;
  var this$7 = $n($p_Lcats_effect_std_Dispatcher$__impl__Z__Z__Z__Lcats_effect_kernel_Async__Lcats_effect_kernel_Resource(this$1, true, false, true, evidence$2));
  var f = new $c_sjsr_AnonFunction1(((dispatcher) => {
    var dispatcher$1 = $as_Lcats_effect_std_Dispatcher(dispatcher);
    var fa = $n($as_Lcats_effect_IO($m_Lcats_effect_std_Queue$().unbounded__Lcats_effect_kernel_GenConcurrent__O($m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO))).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((queue) => {
      var queue$1 = $as_Lcats_effect_std_Queue(queue);
      return $n($as_Lcats_effect_IO($m_Lcats_effect_std_Random$().scalaUtilRandom__Lcats_effect_kernel_Sync__O($m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO))).map__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((x$1) => {
        var x$1$1 = $as_Lcats_effect_std_Random(x$1);
        if ((x$1$1 !== null)) {
          var evidence$1 = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO;
          return new $c_Ldev_sungkm_enchantedrealm_EnchantedRealm(dispatcher$1, queue$1, evidence$1, x$1$1).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_app;
        }
        throw new $c_s_MatchError(x$1$1);
      })));
    })));
    return new $c_Lcats_effect_kernel_Resource$Eval(fa).map__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1(((app) => {
      var app$1 = $as_Ltyrian_TyrianApp(app);
      $m_Ltyrian_TyrianApp$().onLoad__sci_Seq__Lcats_effect_kernel_Async__V($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([new $c_T2("EnchantedRealmApp", app$1)])), $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO);
    })));
  }));
  return new $c_Lcats_effect_kernel_Resource$Bind(this$7, f);
});
var $d_Ldev_sungkm_enchantedrealm_Main$ = new $TypeData().initClass($c_Ldev_sungkm_enchantedrealm_Main$, "dev.sungkm.enchantedrealm.Main$", ({
  Ldev_sungkm_enchantedrealm_Main$: 1,
  Lcats_effect_ResourceApp$Forever: 1
}));
var $n_Ldev_sungkm_enchantedrealm_Main$;
function $m_Ldev_sungkm_enchantedrealm_Main$() {
  if ((!$n_Ldev_sungkm_enchantedrealm_Main$)) {
    $n_Ldev_sungkm_enchantedrealm_Main$ = new $c_Ldev_sungkm_enchantedrealm_Main$();
  }
  return $n_Ldev_sungkm_enchantedrealm_Main$;
}
/** @constructor */
function $c_Lfs2_Compiler$$anon$5() {
  $m_Lcats_package$();
}
$c_Lfs2_Compiler$$anon$5.prototype = new $h_O();
$c_Lfs2_Compiler$$anon$5.prototype.constructor = $c_Lfs2_Compiler$$anon$5;
/** @constructor */
function $h_Lfs2_Compiler$$anon$5() {
}
$h_Lfs2_Compiler$$anon$5.prototype = $c_Lfs2_Compiler$$anon$5.prototype;
$c_Lfs2_Compiler$$anon$5.prototype.apply__Lfs2_Pull__O__F2__O = (function(stream, init, foldChunk) {
  $m_Lfs2_Compiler$();
  var this$1 = $m_Lfs2_Compiler$Target$();
  var F = $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__syncForSyncIO;
  var F$1 = $f_Lfs2_Compiler$TargetLowPriority__forSync__Lcats_effect_kernel_Sync__Lfs2_Compiler$Target(this$1, F);
  return $n($as_Lcats_effect_SyncIO(new $c_Lfs2_CompilerLowPriority1$$anon$2(F$1).apply__Lfs2_Pull__O__F2__O(stream, init, foldChunk))).unsafeRunSync__O();
});
var $d_Lfs2_Compiler$$anon$5 = new $TypeData().initClass($c_Lfs2_Compiler$$anon$5, "fs2.Compiler$$anon$5", ({
  Lfs2_Compiler$$anon$5: 1,
  Lfs2_Compiler: 1
}));
/** @constructor */
function $c_Lfs2_Compiler$Target$() {
}
$c_Lfs2_Compiler$Target$.prototype = new $h_O();
$c_Lfs2_Compiler$Target$.prototype.constructor = $c_Lfs2_Compiler$Target$;
/** @constructor */
function $h_Lfs2_Compiler$Target$() {
}
$h_Lfs2_Compiler$Target$.prototype = $c_Lfs2_Compiler$Target$.prototype;
var $d_Lfs2_Compiler$Target$ = new $TypeData().initClass($c_Lfs2_Compiler$Target$, "fs2.Compiler$Target$", ({
  Lfs2_Compiler$Target$: 1,
  Lfs2_Compiler$TargetLowPriority: 1
}));
var $n_Lfs2_Compiler$Target$;
function $m_Lfs2_Compiler$Target$() {
  if ((!$n_Lfs2_Compiler$Target$)) {
    $n_Lfs2_Compiler$Target$ = new $c_Lfs2_Compiler$Target$();
  }
  return $n_Lfs2_Compiler$Target$;
}
/** @constructor */
function $c_Lfs2_CompilerLowPriority$$anon$4() {
  $m_Lcats_instances_package$either$();
}
$c_Lfs2_CompilerLowPriority$$anon$4.prototype = new $h_O();
$c_Lfs2_CompilerLowPriority$$anon$4.prototype.constructor = $c_Lfs2_CompilerLowPriority$$anon$4;
/** @constructor */
function $h_Lfs2_CompilerLowPriority$$anon$4() {
}
$h_Lfs2_CompilerLowPriority$$anon$4.prototype = $c_Lfs2_CompilerLowPriority$$anon$4.prototype;
$c_Lfs2_CompilerLowPriority$$anon$4.prototype.apply__Lfs2_Pull__O__F2__s_util_Either = (function(stream, init, foldChunk) {
  $m_Lfs2_Compiler$();
  var this$1 = $m_Lfs2_Compiler$Target$();
  var F = $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__syncForSyncIO;
  var F$1 = $f_Lfs2_Compiler$TargetLowPriority__forSync__Lcats_effect_kernel_Sync__Lfs2_Compiler$Target(this$1, F);
  var this$3 = $n($as_Lcats_effect_SyncIO(new $c_Lfs2_CompilerLowPriority1$$anon$2(F$1).apply__Lfs2_Pull__O__F2__O(stream, init, foldChunk)));
  return $as_s_util_Either(new $c_Lcats_effect_SyncIO$Attempt(this$3).unsafeRunSync__O());
});
$c_Lfs2_CompilerLowPriority$$anon$4.prototype.apply__Lfs2_Pull__O__F2__O = (function(stream, init, fold) {
  return this.apply__Lfs2_Pull__O__F2__s_util_Either(stream, init, fold);
});
var $d_Lfs2_CompilerLowPriority$$anon$4 = new $TypeData().initClass($c_Lfs2_CompilerLowPriority$$anon$4, "fs2.CompilerLowPriority$$anon$4", ({
  Lfs2_CompilerLowPriority$$anon$4: 1,
  Lfs2_Compiler: 1
}));
/** @constructor */
function $c_Lfs2_CompilerLowPriority0$$anon$3() {
  $m_Lcats_package$();
}
$c_Lfs2_CompilerLowPriority0$$anon$3.prototype = new $h_O();
$c_Lfs2_CompilerLowPriority0$$anon$3.prototype.constructor = $c_Lfs2_CompilerLowPriority0$$anon$3;
/** @constructor */
function $h_Lfs2_CompilerLowPriority0$$anon$3() {
}
$h_Lfs2_CompilerLowPriority0$$anon$3.prototype = $c_Lfs2_CompilerLowPriority0$$anon$3.prototype;
$c_Lfs2_CompilerLowPriority0$$anon$3.prototype.apply__Lfs2_Pull__O__F2__O = (function(stream, init, foldChunk) {
  $m_Lfs2_Compiler$();
  var this$1 = $m_Lfs2_Compiler$Target$();
  var F = $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__syncForSyncIO;
  var F$1 = $f_Lfs2_Compiler$TargetLowPriority__forSync__Lcats_effect_kernel_Sync__Lfs2_Compiler$Target(this$1, F);
  return $n($as_Lcats_effect_SyncIO(new $c_Lfs2_CompilerLowPriority1$$anon$2(F$1).apply__Lfs2_Pull__O__F2__O(($m_Lfs2_Pull$(), $m_Lfs2_Pull$IdOps$().covaryId$extension__Lfs2_Pull__Lcats_Applicative__Lfs2_Pull(stream, $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__syncForSyncIO)), init, foldChunk))).unsafeRunSync__O();
});
var $d_Lfs2_CompilerLowPriority0$$anon$3 = new $TypeData().initClass($c_Lfs2_CompilerLowPriority0$$anon$3, "fs2.CompilerLowPriority0$$anon$3", ({
  Lfs2_CompilerLowPriority0$$anon$3: 1,
  Lfs2_Compiler: 1
}));
/** @constructor */
function $c_Lfs2_CompilerLowPriority1$$anon$2(F$1) {
  this.Lfs2_CompilerLowPriority1$$anon$2__f_F$2 = null;
  this.Lfs2_CompilerLowPriority1$$anon$2__f_F$2 = F$1;
}
$c_Lfs2_CompilerLowPriority1$$anon$2.prototype = new $h_O();
$c_Lfs2_CompilerLowPriority1$$anon$2.prototype.constructor = $c_Lfs2_CompilerLowPriority1$$anon$2;
/** @constructor */
function $h_Lfs2_CompilerLowPriority1$$anon$2() {
}
$h_Lfs2_CompilerLowPriority1$$anon$2.prototype = $c_Lfs2_CompilerLowPriority1$$anon$2.prototype;
$c_Lfs2_CompilerLowPriority1$$anon$2.prototype.apply__Lfs2_Pull__O__F2__O = (function(stream, init, foldChunk) {
  var this$1 = $n(this.Lfs2_CompilerLowPriority1$$anon$2__f_F$2);
  return $f_Lfs2_Compiler$Target__compile__Lfs2_Pull__O__F2__O(this$1, stream, init, foldChunk);
});
var $d_Lfs2_CompilerLowPriority1$$anon$2 = new $TypeData().initClass($c_Lfs2_CompilerLowPriority1$$anon$2, "fs2.CompilerLowPriority1$$anon$2", ({
  Lfs2_CompilerLowPriority1$$anon$2: 1,
  Lfs2_Compiler: 1
}));
function $p_Lfs2_Pull$__TheBuildR$lzyINIT1$1__Lcats_MonadError__sr_LazyRef__Lfs2_Pull$TheBuildR$2$($thiz, F$7, TheBuildR$lzy1$1) {
  if ((TheBuildR$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Lfs2_Pull$TheBuildR$2$(($n(TheBuildR$lzy1$1).sr_LazyRef__f__initialized ? $n(TheBuildR$lzy1$1).sr_LazyRef__f__value : $n(TheBuildR$lzy1$1).initialize__O__O(new $c_Lfs2_Pull$TheBuildR$2$(F$7))));
}
function $p_Lfs2_Pull$__TheBuildR$1__Lcats_MonadError__sr_LazyRef__Lfs2_Pull$TheBuildR$2$($thiz, F$8, TheBuildR$lzy1$2) {
  return $as_Lfs2_Pull$TheBuildR$2$(($n(TheBuildR$lzy1$2).sr_LazyRef__f__initialized ? $n(TheBuildR$lzy1$2).sr_LazyRef__f__value : $p_Lfs2_Pull$__TheBuildR$lzyINIT1$1__Lcats_MonadError__sr_LazyRef__Lfs2_Pull$TheBuildR$2$($thiz, F$8, TheBuildR$lzy1$2)));
}
function $s_Lfs2_Pull$__fs2$Pull$ViewRunner$1$$_$outLoop$1__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__Lfs2_Pull$Run$1__O(head$2, scope$7, acc, pred) {
  var pred$tailLocal1 = pred;
  var acc$tailLocal1 = acc;
  while (true) {
    var x187 = pred$tailLocal1;
    if ((x187 instanceof $c_Lfs2_Pull$ViewRunner$1)) {
      var vrun = $as_Lfs2_Pull$ViewRunner$1(x187);
      var acc$tailLocal1$tmp1 = $m_Lfs2_Pull$().fs2$Pull$$$bindView__Lfs2_Pull__F1__Lfs2_Pull(acc$tailLocal1, $n(vrun).Lfs2_Pull$ViewRunner$1__f_view);
      var pred$tailLocal1$tmp1 = $n(vrun).Lfs2_Pull$ViewRunner$1__f_prevRunner;
      acc$tailLocal1 = acc$tailLocal1$tmp1;
      pred$tailLocal1 = pred$tailLocal1$tmp1;
      continue;
    }
    return $n(pred$tailLocal1).out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O(head$2, scope$7, acc$tailLocal1);
  }
}
function $p_Lfs2_Pull$__goEval$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull$Eval__F1__O($thiz, extendLastTopLevelScope$12, F$21, contP$14, scope$14, extendedTopLevelScope$11, TheBuildR$lzy1$14, translation$tailLocal1$11, runner$tailLocal1$11, eval$1, view) {
  var target = $n(scope$14).interruptibleEval__O__O($n(translation$tailLocal1$11).apply__O__O($n(eval$1).Lfs2_Pull$Eval__f_value));
  var this$11 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F$21);
  var f = new $c_sjsr_AnonFunction1(((eitherOutcome) => {
    var eitherOutcome$1 = $as_s_util_Either(eitherOutcome);
    matchResult81: {
      var $x_1;
      if ((eitherOutcome$1 instanceof $c_s_util_Right)) {
        var r = $n($as_s_util_Right(eitherOutcome$1)).s_util_Right__f_value;
        var $x_1 = new $c_Lfs2_Pull$Succeeded(r);
        break matchResult81;
      }
      if ((eitherOutcome$1 instanceof $c_s_util_Left)) {
        var x222 = $as_Lcats_effect_kernel_Outcome($n($as_s_util_Left(eitherOutcome$1)).s_util_Left__f_value);
        if ((x222 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
          var x$1 = $as_Lcats_effect_kernel_Outcome$Errored(x222);
          var this$5 = $n(x$1);
          var x225 = $as_jl_Throwable(this$5.Lcats_effect_kernel_Outcome$Errored__f_e);
          var $x_1 = new $c_Lfs2_Pull$Fail(x225);
          break matchResult81;
        }
        if (((x222 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x222), true))) {
          var context = $n(scope$14).Lfs2_internal_Scope__f_id;
          var deferredError = $m_s_None$();
          var $x_1 = new $c_Lfs2_Pull$Interrupted(context, deferredError);
          break matchResult81;
        }
        if ((x222 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
          var x$1$1 = $as_Lcats_effect_kernel_Outcome$Succeeded(x222);
          var this$9 = $n(x$1$1);
          var x217 = $as_Lcats_effect_kernel_Unique$Token(this$9.Lcats_effect_kernel_Outcome$Succeeded__f_fa);
          var deferredError$1 = $m_s_None$();
          var $x_1 = new $c_Lfs2_Pull$Interrupted(x217, deferredError$1);
          break matchResult81;
        }
      }
      throw new $c_s_MatchError(eitherOutcome$1);
    }
    var result = $as_Lfs2_Pull$Terminal($x_1);
    return $thiz.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope$12, F$21, contP$14, TheBuildR$lzy1$14, scope$14, extendedTopLevelScope$11, translation$tailLocal1$11, runner$tailLocal1$11, $as_Lfs2_Pull($n(view).apply__O__O(result)));
  }));
  return $n(this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
}
function $p_Lfs2_Pull$__goAcquire$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull$Acquire__F1__O($thiz, extendLastTopLevelScope$14, F$23, contP$16, scope$16, extendedTopLevelScope$13, TheBuildR$lzy1$16, translation$tailLocal1$13, runner$tailLocal1$13, acquire, view) {
  var onScope = $n(scope$16).acquireResource__F1__F2__O(new $c_sjsr_AnonFunction1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    return ($n(acquire).cancelable__Z() ? $n(poll$1).apply__O__O($n(translation$tailLocal1$13).apply__O__O($n(acquire).resource__O())) : $n(translation$tailLocal1$13).apply__O__O($n(acquire).resource__O()));
  })), new $c_sjsr_AnonFunction2(((resource, exit) => {
    var exit$1 = $as_Lcats_effect_kernel_Resource$ExitCase(exit);
    return $n(translation$tailLocal1$13).apply__O__O($n($n(acquire).release__F2()).apply__O__O__O(resource, exit$1));
  })));
  var this$12 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(onScope, F$23);
  var f = new $c_sjsr_AnonFunction1(((outcome) => {
    var outcome$1 = $as_Lcats_effect_kernel_Outcome(outcome);
    matchResult82: {
      var $x_1;
      if ((outcome$1 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
        var x$1 = $as_Lcats_effect_kernel_Outcome$Succeeded(outcome$1);
        var this$5 = $n(x$1);
        var x240 = $as_s_util_Either(this$5.Lcats_effect_kernel_Outcome$Succeeded__f_fa);
        if ((x240 instanceof $c_s_util_Right)) {
          var r = $n($as_s_util_Right(x240)).s_util_Right__f_value;
          var $x_1 = new $c_Lfs2_Pull$Succeeded(r);
          break matchResult82;
        }
        if ((x240 instanceof $c_s_util_Left)) {
          var scopeId = $as_Lcats_effect_kernel_Unique$Token($n($as_s_util_Left(x240)).s_util_Left__f_value);
          var deferredError = $m_s_None$();
          var $x_1 = new $c_Lfs2_Pull$Interrupted(scopeId, deferredError);
          break matchResult82;
        }
      }
      if (((outcome$1 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(outcome$1), true))) {
        var context = $n(scope$16).Lfs2_internal_Scope__f_id;
        var deferredError$1 = $m_s_None$();
        var $x_1 = new $c_Lfs2_Pull$Interrupted(context, deferredError$1);
        break matchResult82;
      }
      if ((outcome$1 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
        var x$1$1 = $as_Lcats_effect_kernel_Outcome$Errored(outcome$1);
        var this$10 = $n(x$1$1);
        var x231 = $as_jl_Throwable(this$10.Lcats_effect_kernel_Outcome$Errored__f_e);
        var $x_1 = new $c_Lfs2_Pull$Fail(x231);
        break matchResult82;
      }
      throw new $c_s_MatchError(outcome$1);
    }
    var result = $as_Lfs2_Pull$Terminal($x_1);
    return $thiz.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope$14, F$23, contP$16, TheBuildR$lzy1$16, scope$16, extendedTopLevelScope$13, translation$tailLocal1$13, runner$tailLocal1$13, $as_Lfs2_Pull($n(view).apply__O__O(result)));
  }));
  var cont = $n(this$12.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$12.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  return $thiz.fs2$Pull$$$_$interruptGuard$1__Z__Lcats_MonadError__sr_ObjectRef__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_internal_Scope__F1__F0__O(extendLastTopLevelScope$14, F$23, contP$16, extendedTopLevelScope$13, TheBuildR$lzy1$16, translation$tailLocal1$13, runner$tailLocal1$13, scope$16, view, new $c_sjsr_AnonFunction0((() => cont)));
}
function $p_Lfs2_Pull$__goInterruptWhen$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__O__F1__O($thiz, extendLastTopLevelScope$16, F$25, contP$18, scope$18, extendedTopLevelScope$15, TheBuildR$lzy1$18, translation$tailLocal1$17, runner$tailLocal1$15, haltOnSignal, view) {
  var onScope = $n(scope$18).acquireResource__F1__F2__O(new $c_sjsr_AnonFunction1(((_$68) => {
    $as_Lcats_effect_kernel_Poll(_$68);
    return $n(scope$18).interruptWhen__O__O(haltOnSignal);
  })), new $c_sjsr_AnonFunction2(((f, _$69) => {
    var f$1 = $as_Lcats_effect_kernel_Fiber(f);
    $as_Lcats_effect_kernel_Resource$ExitCase(_$69);
    return $n(f$1).cancel__O();
  })));
  var this$11 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(onScope, F$25);
  var f$2 = new $c_sjsr_AnonFunction1(((outcome) => {
    var outcome$1 = $as_Lcats_effect_kernel_Outcome(outcome);
    matchResult83: {
      var result;
      if ((outcome$1 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
        var x$1 = $as_Lcats_effect_kernel_Outcome$Succeeded(outcome$1);
        var this$5 = $n(x$1);
        var x255 = $as_s_util_Either(this$5.Lcats_effect_kernel_Outcome$Succeeded__f_fa);
        if ((x255 instanceof $c_s_util_Right)) {
          var result = $thiz.Lfs2_Pull$__f_fs2$Pull$$$unit;
          break matchResult83;
        }
        if ((x255 instanceof $c_s_util_Left)) {
          var scopeId = $as_Lcats_effect_kernel_Unique$Token($n($as_s_util_Left(x255)).s_util_Left__f_value);
          var deferredError = $m_s_None$();
          var result = new $c_Lfs2_Pull$Interrupted(scopeId, deferredError);
          break matchResult83;
        }
      }
      if (((outcome$1 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(outcome$1), true))) {
        var context = $n(scope$18).Lfs2_internal_Scope__f_id;
        var deferredError$1 = $m_s_None$();
        var result = new $c_Lfs2_Pull$Interrupted(context, deferredError$1);
        break matchResult83;
      }
      if ((outcome$1 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
        var x$1$1 = $as_Lcats_effect_kernel_Outcome$Errored(outcome$1);
        var this$9 = $n(x$1$1);
        var x246 = $as_jl_Throwable(this$9.Lcats_effect_kernel_Outcome$Errored__f_e);
        var result = new $c_Lfs2_Pull$Fail(x246);
        break matchResult83;
      }
      throw new $c_s_MatchError(outcome$1);
    }
    return $thiz.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope$16, F$25, contP$18, TheBuildR$lzy1$18, scope$18, extendedTopLevelScope$15, translation$tailLocal1$17, runner$tailLocal1$15, $as_Lfs2_Pull($n(view).apply__O__O(result)));
  }));
  var cont = $n(this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
  return $thiz.fs2$Pull$$$_$interruptGuard$1__Z__Lcats_MonadError__sr_ObjectRef__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_internal_Scope__F1__F0__O(extendLastTopLevelScope$16, F$25, contP$18, extendedTopLevelScope$15, TheBuildR$lzy1$18, translation$tailLocal1$17, runner$tailLocal1$15, scope$18, view, new $c_sjsr_AnonFunction0((() => cont)));
}
function $p_Lfs2_Pull$__goInScope$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__Z__F1__O($thiz, extendLastTopLevelScope$18, F$27, contP$20, scope$21, extendedTopLevelScope$17, TheBuildR$lzy1$20, translation$tailLocal1$19, runner$tailLocal1$17, stream, useInterruption, view) {
  var this$1 = $n(scope$21);
  if ($n(this$1.Lfs2_internal_Scope__f_parent).isEmpty__Z()) {
    var this$2 = $n(extendedTopLevelScope$17);
    var $x_1 = (!this$2.isEmpty__Z());
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    $m_Lcats_UnorderedFoldable$();
    var tc = $as_Lcats_Traverse($m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption);
    var this$7 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(extendedTopLevelScope$17, tc);
    var f = new $c_sjsr_AnonFunction1(((_$70) => {
      var _$70$1 = $as_Lfs2_internal_Scope(_$70);
      var fea = $n(_$70$1).close__Lcats_effect_kernel_Resource$ExitCase__O($m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$());
      return $m_Lcats_syntax_MonadErrorRethrowOps$().rethrow$extension__O__Lcats_MonadError__O(fea, F$27);
    }));
    var target = $n(this$7.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).traverse___O__F1__Lcats_Applicative__O(this$7.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, f, F$27);
    var this$9 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, F$27);
    var b = $m_s_None$();
    var maybeCloseExtendedScope = $n(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b);
  } else {
    var maybeCloseExtendedScope = $n(F$27).pure__O__O(extendedTopLevelScope$17);
  }
  var this$14 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(maybeCloseExtendedScope, F$27);
  var f$2 = new $c_sjsr_AnonFunction1(((newExtendedScope) => {
    var newExtendedScope$1 = $as_s_Option(newExtendedScope);
    var fea$1 = $n(scope$21).open__Z__O(useInterruption);
    var target$1 = $m_Lcats_syntax_MonadErrorRethrowOps$().rethrow$extension__O__Lcats_MonadError__O(fea$1, F$27);
    var this$13 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, F$27);
    var f$1 = new $c_sjsr_AnonFunction1(((childScope) => {
      var childScope$1 = $as_Lfs2_internal_Scope(childScope);
      var bb = new $c_Lfs2_Pull$$anon$8(stream, childScope$1);
      return $thiz.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope$18, F$27, contP$20, TheBuildR$lzy1$20, childScope$1, newExtendedScope$1, translation$tailLocal1$19, new $c_Lfs2_Pull$ViewRunner$1(extendLastTopLevelScope$18, F$27, contP$20, scope$21, extendedTopLevelScope$17, TheBuildR$lzy1$20, translation$tailLocal1$19, runner$tailLocal1$17, view), bb);
    }));
    return $n(this$13.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$13.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
  }));
  var tail = $n(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
  return $thiz.fs2$Pull$$$_$interruptGuard$1__Z__Lcats_MonadError__sr_ObjectRef__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_internal_Scope__F1__F0__O(extendLastTopLevelScope$18, F$27, contP$20, extendedTopLevelScope$17, TheBuildR$lzy1$20, translation$tailLocal1$19, runner$tailLocal1$17, scope$21, view, new $c_sjsr_AnonFunction0((() => tail)));
}
function $p_Lfs2_Pull$__addError$1__jl_Throwable__Lfs2_Pull$Terminal__Lfs2_Pull$Terminal($thiz, err, res) {
  if ((res instanceof $c_Lfs2_Pull$Succeeded)) {
    var x$1 = $as_Lfs2_Pull$Succeeded(res);
    var this$2 = $n(x$1);
    $as_jl_Void(this$2.Lfs2_Pull$Succeeded__f_r);
    return new $c_Lfs2_Pull$Fail(err);
  }
  if ((res instanceof $c_Lfs2_Pull$Fail)) {
    var x$1$1 = $as_Lfs2_Pull$Fail(res);
    var this$5 = $n(x$1$1);
    var x276 = this$5.Lfs2_Pull$Fail__f_error;
    var error = $m_Lfs2_CompositeFailure$().apply__jl_Throwable__jl_Throwable__sci_List__Lfs2_CompositeFailure(err, x276, $m_sci_Nil$());
    return new $c_Lfs2_Pull$Fail(error);
  }
  if ((res instanceof $c_Lfs2_Pull$Interrupted)) {
    var x$1$2 = $as_Lfs2_Pull$Interrupted(res);
    var this$8 = $n(x$1$2);
    var this$9 = $n(x$1$2);
    $m_s_sys_package$().error__T__E("Impossible, cannot interrupt here");
  }
  throw new $c_s_MatchError(res);
}
function $p_Lfs2_Pull$__viewCont$1__Lfs2_Pull$CloseScope__F1__Lfs2_Pull$Terminal__Lfs2_Pull($thiz, close$1, view$9, res) {
  var x280 = $n(close$1).exitCase__Lcats_effect_kernel_Resource$ExitCase();
  if ((x280 instanceof $c_Lcats_effect_kernel_Resource$ExitCase$Errored)) {
    var x$1 = $as_Lcats_effect_kernel_Resource$ExitCase$Errored(x280);
    var this$2 = $n(x$1);
    var x283 = this$2.Lcats_effect_kernel_Resource$ExitCase$Errored__f_e;
    return $as_Lfs2_Pull($n(view$9).apply__O__O($p_Lfs2_Pull$__addError$1__jl_Throwable__Lfs2_Pull$Terminal__Lfs2_Pull$Terminal($thiz, x283, res)));
  }
  return $as_Lfs2_Pull($n(view$9).apply__O__O(res));
}
function $p_Lfs2_Pull$__err1$1__s_util_Either__s_Option__s_Option($thiz, r$1, err$1) {
  var $x_1 = $m_Lfs2_CompositeFailure$();
  var this$1 = $n($n($n($n(r$1).swap__s_util_Either()).toOption__s_Option()).toList__sci_List());
  var suffix = $n(err$1).toList__sci_List();
  return $n($x_1).fromList__sci_List__s_Option(this$1.appendedAll__sc_IterableOnce__sci_List(suffix));
}
function $p_Lfs2_Pull$__closeTerminal$1__Lfs2_Pull$CloseScope__s_util_Either__Lfs2_internal_Scope__Lfs2_Pull$Terminal($thiz, close$2, r, ancestor) {
  var x287 = $n(close$2).interruption__s_Option();
  var x = $m_s_None$();
  if ((x === x287)) {
    var this$1 = $n(r);
    if ((this$1 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$1);
      var b = $n(x2).s_util_Right__f_value;
      var _$72 = $as_jl_Void(b);
      var $x_1 = new $c_Lfs2_Pull$Succeeded(_$72);
    } else {
      if ((!(this$1 instanceof $c_s_util_Left))) {
        throw new $c_s_MatchError(this$1);
      }
      var x3 = $as_s_util_Left(this$1);
      var a = $n(x3).s_util_Left__f_value;
      var _$71 = $as_jl_Throwable(a);
      var $x_1 = new $c_Lfs2_Pull$Fail(_$71);
    }
    return $as_Lfs2_Pull$Terminal($x_1);
  }
  if ((x287 instanceof $c_s_Some)) {
    var x289 = $as_Lfs2_Pull$Interrupted($n($as_s_Some(x287)).s_Some__f_value);
    if ((x289 !== null)) {
      var this$5 = $n(x289);
      var x291 = this$5.Lfs2_Pull$Interrupted__f_context;
      var this$6 = $n(x289);
      var x292 = this$6.Lfs2_Pull$Interrupted__f_deferredError;
      if ($n(ancestor).descendsFrom__Lcats_effect_kernel_Unique$Token__Z(x291)) {
        var deferredError = $p_Lfs2_Pull$__err1$1__s_util_Either__s_Option__s_Option($thiz, r, x292);
        return new $c_Lfs2_Pull$Interrupted(x291, deferredError);
      } else {
        var x284 = $p_Lfs2_Pull$__err1$1__s_util_Either__s_Option__s_Option($thiz, r, x292);
        var x$3 = $m_s_None$();
        if ((x$3 === x284)) {
          return $thiz.Lfs2_Pull$__f_fs2$Pull$$$unit;
        }
        if ((x284 instanceof $c_s_Some)) {
          var err$2 = $as_jl_Throwable($n($as_s_Some(x284)).s_Some__f_value);
          return new $c_Lfs2_Pull$Fail(err$2);
        }
        throw new $c_s_MatchError(x284);
      }
    }
  }
  throw new $c_s_MatchError(x287);
}
function $p_Lfs2_Pull$__goCloseScope$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull$CloseScope__F1__O($thiz, extendLastTopLevelScope$21, F$31, contP$23, scope$24, extendedTopLevelScope$20, TheBuildR$lzy1$23, translation$tailLocal1$22, runner$tailLocal1$20, close, view) {
  var target = $n(scope$24).findInLineage__Lcats_effect_kernel_Unique$Token__O($n(close).scopeId__Lcats_effect_kernel_Unique$Token());
  var this$20 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F$31);
  var f$4 = new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_s_Option(x$1);
    if ((x$1$1 instanceof $c_s_Some)) {
      var x299 = $as_Lfs2_internal_Scope($n($as_s_Some(x$1$1)).s_Some__f_value);
      var this$3 = $n(x299);
      if ($n(this$3.Lfs2_internal_Scope__f_parent).isEmpty__Z()) {
        return $thiz.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope$21, F$31, contP$23, TheBuildR$lzy1$23, scope$24, extendedTopLevelScope$20, translation$tailLocal1$22, runner$tailLocal1$20, $p_Lfs2_Pull$__viewCont$1__Lfs2_Pull$CloseScope__F1__Lfs2_Pull$Terminal__Lfs2_Pull($thiz, close, view, $thiz.Lfs2_Pull$__f_fs2$Pull$$$unit));
      }
      if (extendLastTopLevelScope$21) {
        var this$4 = $n(x299);
        var $x_1 = ($ps_Lfs2_internal_Scope__go$1__Lfs2_internal_Scope__I__I(this$4, 0) === 1);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        $m_Lcats_UnorderedFoldable$();
        var tc = $as_Lcats_Traverse($m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption);
        var this$8 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(extendedTopLevelScope$20, tc);
        var f = new $c_sjsr_AnonFunction1(((_$73) => {
          var _$73$1 = $as_Lfs2_internal_Scope(_$73);
          var fea = $n(_$73$1).close__Lcats_effect_kernel_Resource$ExitCase__O($m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$());
          return $m_Lcats_syntax_MonadErrorRethrowOps$().rethrow$extension__O__Lcats_MonadError__O(fea, F$31);
        }));
        var fa = $n(this$8.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).traverse___O__F1__Lcats_Applicative__O(this$8.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, f, F$31);
        var target$1 = $n(x299).openAncestor__O();
        var this$12 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, F$31);
        var f$1 = new $c_sjsr_AnonFunction1(((ancestor) => {
          var ancestor$1 = $as_Lfs2_internal_Scope(ancestor);
          return $thiz.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope$21, F$31, contP$23, TheBuildR$lzy1$23, ancestor$1, new $c_s_Some(x299), translation$tailLocal1$22, runner$tailLocal1$20, $p_Lfs2_Pull$__viewCont$1__Lfs2_Pull$CloseScope__F1__Lfs2_Pull$Terminal__Lfs2_Pull($thiz, close, view, $thiz.Lfs2_Pull$__f_fs2$Pull$$$unit));
        }));
        var fb = $n(this$12.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$12.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
        var this$14 = $n(F$31);
        return this$14.productR__O__O__O(fa, fb);
      }
      var target$2 = $n(x299).close__Lcats_effect_kernel_Resource$ExitCase__O($n(close).exitCase__Lcats_effect_kernel_Resource$ExitCase());
      var this$18 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, F$31);
      var f$3 = new $c_sjsr_AnonFunction1(((r) => {
        var r$1 = $as_s_util_Either(r);
        var target$3 = $n(x299).openAncestor__O();
        var this$17 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$3, F$31);
        var f$2 = new $c_sjsr_AnonFunction1(((ancestor$2) => {
          var ancestor$3 = $as_Lfs2_internal_Scope(ancestor$2);
          var res = $p_Lfs2_Pull$__closeTerminal$1__Lfs2_Pull$CloseScope__s_util_Either__Lfs2_internal_Scope__Lfs2_Pull$Terminal($thiz, close, r$1, ancestor$3);
          return $thiz.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope$21, F$31, contP$23, TheBuildR$lzy1$23, ancestor$3, extendedTopLevelScope$20, translation$tailLocal1$22, runner$tailLocal1$20, $p_Lfs2_Pull$__viewCont$1__Lfs2_Pull$CloseScope__F1__Lfs2_Pull$Terminal__Lfs2_Pull($thiz, close, view, res));
        }));
        return $n(this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
      }));
      return $n(this$18.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$18.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
    }
    var x = $m_s_None$();
    if ((x === x$1$1)) {
      var this$19 = $n($n(close).interruption__s_Option());
      var result = $as_Lfs2_Pull$Terminal((this$19.isEmpty__Z() ? $thiz.Lfs2_Pull$__f_fs2$Pull$$$unit : this$19.get__O()));
      return $thiz.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope$21, F$31, contP$23, TheBuildR$lzy1$23, scope$24, extendedTopLevelScope$20, translation$tailLocal1$22, runner$tailLocal1$20, $p_Lfs2_Pull$__viewCont$1__Lfs2_Pull$CloseScope__F1__Lfs2_Pull$Terminal__Lfs2_Pull($thiz, close, view, result));
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return $n(this$20.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$20.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$4);
}
/** @constructor */
function $c_Lfs2_Pull$() {
  this.Lfs2_Pull$__f_fs2$Pull$$$unit = null;
  this.Lfs2_Pull$__f_outUnit = null;
  this.Lfs2_Pull$__f_done = null;
  $n_Lfs2_Pull$ = this;
  this.Lfs2_Pull$__f_fs2$Pull$$$unit = new $c_Lfs2_Pull$Succeeded((void 0));
  var values = $m_Lfs2_Chunk$().Lfs2_Chunk$__f_unit;
  this.Lfs2_Pull$__f_outUnit = new $c_Lfs2_Pull$Output(values);
  this.Lfs2_Pull$__f_done = this.Lfs2_Pull$__f_fs2$Pull$$$unit;
}
$c_Lfs2_Pull$.prototype = new $h_O();
$c_Lfs2_Pull$.prototype.constructor = $c_Lfs2_Pull$;
/** @constructor */
function $h_Lfs2_Pull$() {
}
$h_Lfs2_Pull$.prototype = $c_Lfs2_Pull$.prototype;
$c_Lfs2_Pull$.prototype.output1__O__Lfs2_Pull = (function(o) {
  $m_Lfs2_Chunk$();
  var values = new $c_Lfs2_Chunk$Singleton(o);
  return new $c_Lfs2_Pull$Output(values);
});
$c_Lfs2_Pull$.prototype.output__Lfs2_Chunk__Lfs2_Pull = (function(os) {
  return ($n(os).isEmpty__Z() ? $m_Lfs2_Pull$().Lfs2_Pull$__f_done : new $c_Lfs2_Pull$Output(os));
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$bindView__Lfs2_Pull__F1__Lfs2_Pull = (function(fmoc, view) {
  var x = $m_Lfs2_Pull$IdContP$();
  if ((x === view)) {
    return fmoc;
  } else if ((view instanceof $c_Lfs2_Pull$Bind)) {
    var bv = $as_Lfs2_Pull$Bind(view);
    if ((fmoc instanceof $c_Lfs2_Pull$Terminal)) {
      var r = $as_Lfs2_Pull$Terminal(fmoc);
      try {
        var this$1 = $n(bv);
        return this$1.cont__Lfs2_Pull$Terminal__Lfs2_Pull(r);
      } catch (e) {
        var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
        var x95 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!$n(x95).isEmpty__Z())) {
          var x96 = $as_jl_Throwable($n(x95).get__O());
          return new $c_Lfs2_Pull$Fail(x96);
        }
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2));
      }
    } else {
      return new $c_Lfs2_Pull$DelegateBind(fmoc, $n(bv).delegate__Lfs2_Pull$Bind());
    }
  } else {
    return new $c_Lfs2_Pull$$anon$7(fmoc, view, this);
  }
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$bindBindAux__Lfs2_Pull__Lfs2_Pull$Bind__Lfs2_Pull = (function(py, del) {
  var del$tailLocal1 = del;
  var py$tailLocal1 = py;
  while (true) {
    var x108 = py$tailLocal1;
    if ((x108 instanceof $c_Lfs2_Pull$Terminal)) {
      var ty = $as_Lfs2_Pull$Terminal(x108);
      var x106 = del$tailLocal1;
      if ((x106 instanceof $c_Lfs2_Pull$BindBind)) {
        var cici = $as_Lfs2_Pull$BindBind(x106);
        var py$tailLocal1$tmp1 = $n($n(cici).Lfs2_Pull$BindBind__f_bb).cont__Lfs2_Pull$Terminal__Lfs2_Pull(ty);
        var del$tailLocal1$tmp1 = $n(cici).Lfs2_Pull$BindBind__f_del;
        py$tailLocal1 = py$tailLocal1$tmp1;
        del$tailLocal1 = del$tailLocal1$tmp1;
        continue;
      }
      return $n(del$tailLocal1).cont__Lfs2_Pull$Terminal__Lfs2_Pull(ty);
    }
    return new $c_Lfs2_Pull$DelegateBind(x108, del$tailLocal1);
  }
});
$c_Lfs2_Pull$.prototype.compile__Lfs2_Pull__Lfs2_internal_Scope__Z__O__F2__Lcats_MonadError__O = (function(stream, initScope, extendLastTopLevelScope, init, foldChunk, F) {
  var TheBuildR$lzy1 = new $c_sr_LazyRef();
  var contP = new $c_sr_ObjectRef(null);
  var this$2 = $m_Lcats_arrow_FunctionK$();
  var initFk = new $c_Lcats_arrow_FunctionK$$anon$4(this$2);
  return this.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope, F, contP, TheBuildR$lzy1, initScope, $m_s_None$(), initFk, new $c_Lfs2_Pull$OuterRun$1(extendLastTopLevelScope, foldChunk, F, contP, initFk, TheBuildR$lzy1, this, init), stream);
});
$c_Lfs2_Pull$.prototype.translate__Lfs2_Pull__Lcats_arrow_FunctionK__Lfs2_Pull = (function(stream, fK) {
  var fK$tailLocal1 = fK;
  var stream$tailLocal2 = stream;
  while (true) {
    var x331 = stream$tailLocal2;
    if ((x331 instanceof $c_Lfs2_Pull$Translate)) {
      var t = $as_Lfs2_Pull$Translate(x331);
      var stream$tailLocal2$tmp1 = $n(t).Lfs2_Pull$Translate__f_stream;
      var this$1 = $n($n(t).Lfs2_Pull$Translate__f_fk);
      var f = fK$tailLocal1;
      var this$2 = $n(f);
      var fK$tailLocal1$tmp1 = new $c_Lcats_arrow_FunctionK$$anon$1(this$1, this$2);
      stream$tailLocal2 = stream$tailLocal2$tmp1;
      fK$tailLocal1 = fK$tailLocal1$tmp1;
      continue;
    }
    if ((x331 instanceof $c_Lfs2_Pull$Output)) {
      var o = $as_Lfs2_Pull$Output(x331);
      return o;
    }
    if ((x331 instanceof $c_Lfs2_Pull$Terminal)) {
      var r = $as_Lfs2_Pull$Terminal(x331);
      return r;
    }
    var stream$1 = stream$tailLocal2;
    var fk = fK$tailLocal1;
    return new $c_Lfs2_Pull$Translate(stream$1, fk);
  }
});
$c_Lfs2_Pull$.prototype.mapOutput__Lfs2_Stream__F1__Lfs2_Pull = (function(s, f) {
  var s$1 = this.mapOutputNoScope__Lfs2_Stream__F1__Lfs2_Pull(s, f);
  return new $c_Lfs2_Pull$InScope(s$1, true);
});
$c_Lfs2_Pull$.prototype.mapOutputNoScope__Lfs2_Stream__F1__Lfs2_Pull = (function(s, f) {
  var ev$16 = ($m_Lfs2_Stream$(), new $c_Lfs2_Stream$ToPull(s)).Lfs2_Stream$ToPull__f_self;
  var self = $n(ev$16).Lfs2_Stream__f_underlying;
  return $m_Lfs2_Pull$StreamPullOps$().unconsFlatMap$extension__Lfs2_Pull__F1__Lfs2_Pull(self, new $c_sjsr_AnonFunction1(((hd) => {
    var hd$1 = $as_Lfs2_Chunk(hd);
    return $m_Lfs2_Pull$().output__Lfs2_Chunk__Lfs2_Pull($n(hd$1).map__F1__Lfs2_Chunk(f));
  })));
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$transformWith__Lfs2_Pull__F1__Lfs2_Pull = (function(p, f) {
  if ((p instanceof $c_Lfs2_Pull$Terminal)) {
    var r = $as_Lfs2_Pull$Terminal(p);
    try {
      return $as_Lfs2_Pull($n(f).apply__O__O(r));
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      var x336 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!$n(x336).isEmpty__Z())) {
        var x337 = $as_jl_Throwable($n(x336).get__O());
        return new $c_Lfs2_Pull$Fail(x337);
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2));
    }
  } else {
    return new $c_Lfs2_Pull$$anon$9(p, f, this);
  }
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$_$viewL$1__sr_ObjectRef__Lfs2_Pull__Lfs2_Pull$ViewL = (function(contP$2, free) {
  var free$tailLocal1 = free;
  while (true) {
    var x166 = free$tailLocal1;
    if ((x166 instanceof $c_Lfs2_Pull$Action)) {
      var e = $as_Lfs2_Pull$Action(x166);
      var ev$19 = $m_Lfs2_Pull$IdContP$();
      $n(contP$2).sr_ObjectRef__f_elem = ev$19;
      ev$19 = null;
      return e;
    }
    if ((x166 instanceof $c_Lfs2_Pull$Bind)) {
      var b = $as_Lfs2_Pull$Bind(x166);
      var x162 = $n(b).Lfs2_Pull$Bind__f_step;
      if ((x162 instanceof $c_Lfs2_Pull$Bind)) {
        var c = $as_Lfs2_Pull$Bind(x162);
        free$tailLocal1 = new $c_Lfs2_Pull$BindBind($n(c).Lfs2_Pull$Bind__f_step, $n(c).delegate__Lfs2_Pull$Bind(), $n(b).delegate__Lfs2_Pull$Bind());
        continue;
      }
      if ((x162 instanceof $c_Lfs2_Pull$Action)) {
        var e$2 = $as_Lfs2_Pull$Action(x162);
        var ev$20 = $n(b).delegate__Lfs2_Pull$Bind();
        $n(contP$2).sr_ObjectRef__f_elem = ev$20;
        ev$20 = null;
        return e$2;
      }
      if ((x162 instanceof $c_Lfs2_Pull$Terminal)) {
        var r = $as_Lfs2_Pull$Terminal(x162);
        free$tailLocal1 = $n(b).cont__Lfs2_Pull$Terminal__Lfs2_Pull(r);
        continue;
      }
      throw new $c_s_MatchError(x162);
    }
    if ((x166 instanceof $c_Lfs2_Pull$Terminal)) {
      var r$2 = $as_Lfs2_Pull$Terminal(x166);
      return r$2;
    }
    throw new $c_s_MatchError(x166);
  }
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$_$interruptBoundary$1__sr_ObjectRef__Lfs2_Pull__Lfs2_Pull$Interrupted__Lfs2_Pull = (function(contP$38, stream, interruption) {
  var x170 = this.fs2$Pull$$$_$viewL$1__sr_ObjectRef__Lfs2_Pull__Lfs2_Pull$ViewL(contP$38, stream);
  if ((x170 instanceof $c_Lfs2_Pull$CloseScope)) {
    var cs = $as_Lfs2_Pull$CloseScope(x170);
    var scopeId = $n(cs).scopeId__Lcats_effect_kernel_Unique$Token();
    var cl = new $c_Lfs2_Pull$CanceledScope(scopeId, interruption);
    return this.fs2$Pull$$$transformWith__Lfs2_Pull__F1__Lfs2_Pull(cl, $as_Lfs2_Pull$ContP($n(contP$38).sr_ObjectRef__f_elem));
  }
  if ((x170 instanceof $c_Lfs2_Pull$Action)) {
    var this$2 = $n($as_Lfs2_Pull$ContP($n(contP$38).sr_ObjectRef__f_elem));
    return this$2.cont__Lfs2_Pull$Terminal__Lfs2_Pull(interruption);
  }
  if ((x170 instanceof $c_Lfs2_Pull$Interrupted)) {
    var interrupted = $as_Lfs2_Pull$Interrupted(x170);
    return interrupted;
  }
  if ((x170 instanceof $c_Lfs2_Pull$Succeeded)) {
    return interruption;
  }
  if ((x170 instanceof $c_Lfs2_Pull$Fail)) {
    var failed = $as_Lfs2_Pull$Fail(x170);
    var this$3 = $n($n($n(interruption).Lfs2_Pull$Interrupted__f_deferredError).toList__sci_List());
    var elem = $n(failed).Lfs2_Pull$Fail__f_error;
    var errs = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$3, elem));
    var this$4 = $n($m_Lfs2_CompositeFailure$().fromList__sci_List__s_Option(errs));
    var error = $as_jl_Throwable((this$4.isEmpty__Z() ? $n(failed).Lfs2_Pull$Fail__f_error : this$4.get__O()));
    return new $c_Lfs2_Pull$Fail(error);
  }
  throw new $c_s_MatchError(x170);
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$_$interruptGuard$1__Z__Lcats_MonadError__sr_ObjectRef__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_internal_Scope__F1__F0__O = (function(extendLastTopLevelScope$2, F$11, contP$4, extendedTopLevelScope$1, TheBuildR$lzy1$4, translation$tailLocal1$1, runner$tailLocal1$1, scope, view, next) {
  var target = $n(scope).isInterrupted__O();
  var this$10 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F$11);
  var f = new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_s_Option(x$1);
    var x = $m_s_None$();
    if ((x === x$1$1)) {
      return $n(next).apply__O();
    }
    if ((x$1$1 instanceof $c_s_Some)) {
      var outcome = $as_Lcats_effect_kernel_Outcome($n($as_s_Some(x$1$1)).s_Some__f_value);
      matchResult74: {
        var $x_1;
        if ((outcome instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
          var x$1$2 = $as_Lcats_effect_kernel_Outcome$Errored(outcome);
          var this$4 = $n(x$1$2);
          var x183 = $as_jl_Throwable(this$4.Lcats_effect_kernel_Outcome$Errored__f_e);
          var $x_1 = new $c_Lfs2_Pull$Fail(x183);
          break matchResult74;
        }
        if (((outcome instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(outcome), true))) {
          var context = $n(scope).Lfs2_internal_Scope__f_id;
          var deferredError = $m_s_None$();
          var $x_1 = new $c_Lfs2_Pull$Interrupted(context, deferredError);
          break matchResult74;
        }
        if ((outcome instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
          var x$1$3 = $as_Lcats_effect_kernel_Outcome$Succeeded(outcome);
          var this$8 = $n(x$1$3);
          var x179 = $as_Lcats_effect_kernel_Unique$Token(this$8.Lcats_effect_kernel_Outcome$Succeeded__f_fa);
          var deferredError$1 = $m_s_None$();
          var $x_1 = new $c_Lfs2_Pull$Interrupted(x179, deferredError$1);
          break matchResult74;
        }
        throw new $c_s_MatchError(outcome);
      }
      var result = $as_Lfs2_Pull$Terminal($x_1);
      return this.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope$2, F$11, contP$4, TheBuildR$lzy1$4, scope, extendedTopLevelScope$1, translation$tailLocal1$1, runner$tailLocal1$1, $as_Lfs2_Pull($n(view).apply__O__O(result)));
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return $n(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$_$goErr$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__jl_Throwable__F1__O = (function(extendLastTopLevelScope$4, F$13, contP$6, scope$4, extendedTopLevelScope$3, TheBuildR$lzy1$6, translation$tailLocal1$3, runner$tailLocal1$3, err, view) {
  return this.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope$4, F$13, contP$6, TheBuildR$lzy1$6, scope$4, extendedTopLevelScope$3, translation$tailLocal1$3, runner$tailLocal1$3, $as_Lfs2_Pull($n(view).apply__O__O(new $c_Lfs2_Pull$Fail(err))));
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$_$endScope$1__Lcats_effect_kernel_Unique$Token__Lfs2_Pull$Terminal__Lfs2_Pull = (function(scopeId, result) {
  matchResult84: {
    var $x_1;
    if ((result instanceof $c_Lfs2_Pull$Succeeded)) {
      var x$1 = $as_Lfs2_Pull$Succeeded(result);
      var this$2 = $n(x$1);
      $as_jl_Void(this$2.Lfs2_Pull$Succeeded__f_r);
      var $x_1 = new $c_Lfs2_Pull$SucceedScope(scopeId);
      break matchResult84;
    }
    if ((result instanceof $c_Lfs2_Pull$Interrupted)) {
      var x$1$1 = $as_Lfs2_Pull$Interrupted(result);
      var this$5 = $n(x$1$1);
      var this$6 = $n(x$1$1);
      var inter = $as_Lfs2_Pull$Interrupted(result);
      var $x_1 = new $c_Lfs2_Pull$CanceledScope(scopeId, inter);
      break matchResult84;
    }
    if ((result instanceof $c_Lfs2_Pull$Fail)) {
      var x$1$2 = $as_Lfs2_Pull$Fail(result);
      var this$9 = $n(x$1$2);
      var x261 = this$9.Lfs2_Pull$Fail__f_error;
      var $x_1 = new $c_Lfs2_Pull$FailedScope(scopeId, x261);
      break matchResult84;
    }
    throw new $c_s_MatchError(result);
  }
  return $as_Lfs2_Pull($x_1);
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O = (function(extendLastTopLevelScope$1, F$10, contP$3, TheBuildR$lzy1$3, scope, extendedTopLevelScope, translation, runner, stream) {
  var stream$tailLocal1 = stream;
  var runner$tailLocal1 = runner;
  var translation$tailLocal1 = translation;
  while (true) {
    var x300 = this.fs2$Pull$$$_$viewL$1__sr_ObjectRef__Lfs2_Pull__Lfs2_Pull$ViewL(contP$3, stream$tailLocal1);
    if ((x300 instanceof $c_Lfs2_Pull$Translate)) {
      var tst = $as_Lfs2_Pull$Translate(x300);
      var translateRunner = new $c_Lfs2_Pull$TranslateRunner$1(extendLastTopLevelScope$1, F$10, contP$3, scope, extendedTopLevelScope, TheBuildR$lzy1$3, translation$tailLocal1, runner$tailLocal1, $n(tst).Lfs2_Pull$Translate__f_fk, $as_Lfs2_Pull$ContP($n(contP$3).sr_ObjectRef__f_elem));
      var this$1 = $n(translation$tailLocal1);
      var f = $n(tst).Lfs2_Pull$Translate__f_fk;
      var composed = new $c_Lcats_arrow_FunctionK$$anon$1(f, this$1);
      var stream$tailLocal1$tmp1 = $n(tst).Lfs2_Pull$Translate__f_stream;
      translation$tailLocal1 = composed;
      runner$tailLocal1 = translateRunner;
      stream$tailLocal1 = stream$tailLocal1$tmp1;
      continue;
    }
    if ((x300 instanceof $c_Lfs2_Pull$Output)) {
      var output = $as_Lfs2_Pull$Output(x300);
      var view = $as_Lfs2_Pull$ContP($n(contP$3).sr_ObjectRef__f_elem);
      var $x_2 = translation$tailLocal1;
      var $x_1 = runner$tailLocal1;
      var runner$tailLocal1$2$1 = runner$tailLocal1;
      return this.fs2$Pull$$$_$interruptGuard$1__Z__Lcats_MonadError__sr_ObjectRef__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_internal_Scope__F1__F0__O(extendLastTopLevelScope$1, F$10, contP$3, extendedTopLevelScope, TheBuildR$lzy1$3, $x_2, $x_1, scope, view, new $c_sjsr_AnonFunction0(((scope, output, view, runner$tailLocal1$2) => (() => {
        var $x_4 = $n(runner$tailLocal1$2);
        var $x_3 = $n(output).Lfs2_Pull$Output__f_values;
        var this$3 = $n(view);
        var v1 = this.Lfs2_Pull$__f_fs2$Pull$$$unit;
        return $n($x_4).out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O($x_3, scope, this$3.cont__Lfs2_Pull$Terminal__Lfs2_Pull(v1));
      }))(scope, output, view, runner$tailLocal1$2$1)));
    }
    if ((x300 instanceof $c_Lfs2_Pull$FlatMapOutput)) {
      var fmout = $as_Lfs2_Pull$FlatMapOutput(x300);
      var fmrunr = new $c_Lfs2_Pull$FlatMapR$1(extendLastTopLevelScope$1, F$10, contP$3, scope, extendedTopLevelScope, TheBuildR$lzy1$3, translation$tailLocal1, runner$tailLocal1, $as_Lfs2_Pull$ContP($n(contP$3).sr_ObjectRef__f_elem), $n(fmout).Lfs2_Pull$FlatMapOutput__f_fun);
      var fa = $n(F$10).unit__O();
      var $x_5 = $m_Lcats_syntax_FlatMapOps$();
      var translation$tailLocal1$2$1 = translation$tailLocal1;
      return $n($x_5).$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa, new $c_sjsr_AnonFunction0(((extendLastTopLevelScope$1, F$10, contP$3, scope, extendedTopLevelScope, fmout, fmrunr, TheBuildR$lzy1$3, translation$tailLocal1$2) => (() => this.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope$1, F$10, contP$3, TheBuildR$lzy1$3, scope, extendedTopLevelScope, translation$tailLocal1$2, fmrunr, $n(fmout).Lfs2_Pull$FlatMapOutput__f_stream)))(extendLastTopLevelScope$1, F$10, contP$3, scope, extendedTopLevelScope, fmout, fmrunr, TheBuildR$lzy1$3, translation$tailLocal1$2$1)), F$10);
    }
    if ((x300 instanceof $c_Lfs2_Pull$Uncons)) {
      var u = $as_Lfs2_Pull$Uncons(x300);
      var v = $as_Lfs2_Pull$ContP($n(contP$3).sr_ObjectRef__f_elem);
      var runr = $p_Lfs2_Pull$__TheBuildR$1__Lcats_MonadError__sr_LazyRef__Lfs2_Pull$TheBuildR$2$(this, F$10, TheBuildR$lzy1$3);
      var fa$1 = $n(F$10).unit__O();
      var $x_6 = $m_Lcats_syntax_FlatMapOps$();
      var translation$tailLocal1$3$1 = translation$tailLocal1;
      var runner$tailLocal1$3$1 = runner$tailLocal1;
      return $n($x_6).$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa$1, new $c_sjsr_AnonFunction0(((extendLastTopLevelScope$1, F$10, contP$3, scope, extendedTopLevelScope, u, v, runr, TheBuildR$lzy1$3, translation$tailLocal1$3, runner$tailLocal1$3) => (() => {
        var fa$2 = this.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope$1, F$10, contP$3, TheBuildR$lzy1$3, scope, extendedTopLevelScope, translation$tailLocal1$3, runr, $n(u).Lfs2_Pull$Uncons__f_stream);
        var target = $n(F$10).attempt__O__O(fa$2);
        var this$10 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F$10);
        var f$1 = new $c_sjsr_AnonFunction1(((_$74) => {
          var _$74$1 = $as_s_util_Either(_$74);
          var this$9 = $n(_$74$1);
          if ((this$9 instanceof $c_s_util_Right)) {
            var x2 = $as_s_util_Right(this$9);
            var b = $n(x2).s_util_Right__f_value;
            var _$76 = $as_F1(b);
            return $n(_$76).apply__O__O(new $c_Lfs2_Pull$UnconsRunR$1(extendLastTopLevelScope$1, F$10, contP$3, scope, extendedTopLevelScope, TheBuildR$lzy1$3, translation$tailLocal1$3, runner$tailLocal1$3, this, v));
          } else if ((this$9 instanceof $c_s_util_Left)) {
            var x3 = $as_s_util_Left(this$9);
            var a = $n(x3).s_util_Left__f_value;
            var _$75 = $as_jl_Throwable(a);
            return this.fs2$Pull$$$_$goErr$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__jl_Throwable__F1__O(extendLastTopLevelScope$1, F$10, contP$3, scope, extendedTopLevelScope, TheBuildR$lzy1$3, translation$tailLocal1$3, runner$tailLocal1$3, _$75, v);
          } else {
            throw new $c_s_MatchError(this$9);
          }
        }));
        return $n(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
      }))(extendLastTopLevelScope$1, F$10, contP$3, scope, extendedTopLevelScope, u, v, runr, TheBuildR$lzy1$3, translation$tailLocal1$3$1, runner$tailLocal1$3$1)), F$10);
    }
    if (false) {
      var s = $as_Lfs2_Pull$StepLeg(x300);
      var v$3 = $as_Lfs2_Pull$ContP($n(contP$3).sr_ObjectRef__f_elem);
      var runr$3 = $p_Lfs2_Pull$__TheBuildR$1__Lcats_MonadError__sr_LazyRef__Lfs2_Pull$TheBuildR$2$(this, F$10, TheBuildR$lzy1$3);
      var target$1 = $n(scope).shiftScope__Lcats_effect_kernel_Unique$Token__F0__O($n(s).scope__Lcats_effect_kernel_Unique$Token(), new $c_sjsr_AnonFunction0(((s) => (() => $n(s).toString__T()))(s)));
      var this$14 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, F$10);
      var translation$tailLocal1$4$1 = translation$tailLocal1;
      var f$2 = new $c_sjsr_AnonFunction1(((extendLastTopLevelScope$1, F$10, contP$3, extendedTopLevelScope, s, runr$3, TheBuildR$lzy1$3, translation$tailLocal1$4) => ((_$77) => {
        var _$77$1 = $as_Lfs2_internal_Scope(_$77);
        var fa$3 = this.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope$1, F$10, contP$3, TheBuildR$lzy1$3, _$77$1, extendedTopLevelScope, translation$tailLocal1$4, runr$3, $n(s).stream__Lfs2_Pull());
        return $n(F$10).attempt__O__O(fa$3);
      }))(extendLastTopLevelScope$1, F$10, contP$3, extendedTopLevelScope, s, runr$3, TheBuildR$lzy1$3, translation$tailLocal1$4$1));
      var target$2 = $n(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
      var this$17 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, F$10);
      var translation$tailLocal1$5$1 = translation$tailLocal1;
      var runner$tailLocal1$4$1 = runner$tailLocal1;
      var f$3 = new $c_sjsr_AnonFunction1(((extendLastTopLevelScope$1, F$10, contP$3, scope, extendedTopLevelScope, v$3, TheBuildR$lzy1$3, translation$tailLocal1$5, runner$tailLocal1$4) => ((_$78) => {
        var _$78$1 = $as_s_util_Either(_$78);
        var this$16 = $n(_$78$1);
        if ((this$16 instanceof $c_s_util_Right)) {
          var x2$1 = $as_s_util_Right(this$16);
          var b$1 = $n(x2$1).s_util_Right__f_value;
          var _$80 = $as_F1(b$1);
          return $n(_$80).apply__O__O(new $c_Lfs2_Pull$StepLegRunR$1(extendLastTopLevelScope$1, F$10, contP$3, scope, extendedTopLevelScope, TheBuildR$lzy1$3, translation$tailLocal1$5, runner$tailLocal1$4, this, v$3));
        } else if ((this$16 instanceof $c_s_util_Left)) {
          var x3$1 = $as_s_util_Left(this$16);
          var a$1 = $n(x3$1).s_util_Left__f_value;
          var _$79 = $as_jl_Throwable(a$1);
          return this.fs2$Pull$$$_$goErr$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__jl_Throwable__F1__O(extendLastTopLevelScope$1, F$10, contP$3, scope, extendedTopLevelScope, TheBuildR$lzy1$3, translation$tailLocal1$5, runner$tailLocal1$4, _$79, v$3);
        } else {
          throw new $c_s_MatchError(this$16);
        }
      }))(extendLastTopLevelScope$1, F$10, contP$3, scope, extendedTopLevelScope, v$3, TheBuildR$lzy1$3, translation$tailLocal1$5$1, runner$tailLocal1$4$1));
      return $n(this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
    }
    if (false) {
      var this$19 = $n($as_Lfs2_Pull$ContP($n(contP$3).sr_ObjectRef__f_elem));
      var v1$1 = new $c_Lfs2_Pull$Succeeded(scope);
      stream$tailLocal1 = this$19.cont__Lfs2_Pull$Terminal__Lfs2_Pull(v1$1);
      continue;
    }
    if ((x300 instanceof $c_Lfs2_Pull$Eval)) {
      var eval$1 = $as_Lfs2_Pull$Eval(x300);
      return $p_Lfs2_Pull$__goEval$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull$Eval__F1__O(this, extendLastTopLevelScope$1, F$10, contP$3, scope, extendedTopLevelScope, TheBuildR$lzy1$3, translation$tailLocal1, runner$tailLocal1, eval$1, $as_Lfs2_Pull$ContP($n(contP$3).sr_ObjectRef__f_elem));
    }
    if (false) {
      var acquire = $as_Lfs2_Pull$Acquire(x300);
      return $p_Lfs2_Pull$__goAcquire$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull$Acquire__F1__O(this, extendLastTopLevelScope$1, F$10, contP$3, scope, extendedTopLevelScope, TheBuildR$lzy1$3, translation$tailLocal1, runner$tailLocal1, acquire, $as_Lfs2_Pull$ContP($n(contP$3).sr_ObjectRef__f_elem));
    }
    if ((x300 instanceof $c_Lfs2_Pull$InScope)) {
      var inScope = $as_Lfs2_Pull$InScope(x300);
      return $p_Lfs2_Pull$__goInScope$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__Z__F1__O(this, extendLastTopLevelScope$1, F$10, contP$3, scope, extendedTopLevelScope, TheBuildR$lzy1$3, translation$tailLocal1, runner$tailLocal1, $n(inScope).Lfs2_Pull$InScope__f_stream, $n(inScope).Lfs2_Pull$InScope__f_useInterruption, $as_Lfs2_Pull$ContP($n(contP$3).sr_ObjectRef__f_elem));
    }
    if (false) {
      var int = $as_Lfs2_Pull$InterruptWhen(x300);
      return $p_Lfs2_Pull$__goInterruptWhen$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__O__F1__O(this, extendLastTopLevelScope$1, F$10, contP$3, scope, extendedTopLevelScope, TheBuildR$lzy1$3, translation$tailLocal1, runner$tailLocal1, $n(translation$tailLocal1).apply__O__O($n(int).haltOnSignal__O()), $as_Lfs2_Pull$ContP($n(contP$3).sr_ObjectRef__f_elem));
    }
    if ((x300 instanceof $c_Lfs2_Pull$CloseScope)) {
      var close = $as_Lfs2_Pull$CloseScope(x300);
      return $p_Lfs2_Pull$__goCloseScope$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull$CloseScope__F1__O(this, extendLastTopLevelScope$1, F$10, contP$3, scope, extendedTopLevelScope, TheBuildR$lzy1$3, translation$tailLocal1, runner$tailLocal1, close, $as_Lfs2_Pull$ContP($n(contP$3).sr_ObjectRef__f_elem));
    }
    if ((x300 instanceof $c_Lfs2_Pull$Succeeded)) {
      return $n(runner$tailLocal1).done__Lfs2_internal_Scope__O(scope);
    }
    if ((x300 instanceof $c_Lfs2_Pull$Fail)) {
      var failed = $as_Lfs2_Pull$Fail(x300);
      return $n(runner$tailLocal1).fail__jl_Throwable__O($n(failed).Lfs2_Pull$Fail__f_error);
    }
    if ((x300 instanceof $c_Lfs2_Pull$Interrupted)) {
      var int$2 = $as_Lfs2_Pull$Interrupted(x300);
      return $n(runner$tailLocal1).interrupted__Lfs2_Pull$Interrupted__O(int$2);
    }
    throw new $c_s_MatchError(x300);
  }
});
var $d_Lfs2_Pull$ = new $TypeData().initClass($c_Lfs2_Pull$, "fs2.Pull$", ({
  Lfs2_Pull$: 1,
  Lfs2_PullLowPriority: 1
}));
var $n_Lfs2_Pull$;
function $m_Lfs2_Pull$() {
  if ((!$n_Lfs2_Pull$)) {
    $n_Lfs2_Pull$ = new $c_Lfs2_Pull$();
  }
  return $n_Lfs2_Pull$;
}
function $is_Lfs2_Pull$ContP(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lfs2_Pull$ContP)));
}
function $as_Lfs2_Pull$ContP(obj) {
  return (($is_Lfs2_Pull$ContP(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$ContP"));
}
function $isArrayOf_Lfs2_Pull$ContP(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$ContP)));
}
function $asArrayOf_Lfs2_Pull$ContP(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$ContP(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$ContP;", depth));
}
function $p_Lfs2_Pull$FlatMapR$1__unconsed__Lfs2_Chunk__Lfs2_Pull__Lfs2_Pull($thiz, chunk, tail) {
  if ((($n(chunk).size__I() === 1) && (tail instanceof $c_Lfs2_Pull$Succeeded))) {
    try {
      return $as_Lfs2_Pull($n($thiz.Lfs2_Pull$FlatMapR$1__f_fun).apply__O__O($n(chunk).apply__I__O(0)));
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      var x190 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!$n(x190).isEmpty__Z())) {
        var x191 = $as_jl_Throwable($n(x190).get__O());
        return new $c_Lfs2_Pull$Fail(x191);
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2));
    }
  } else {
    return $p_Lfs2_Pull$FlatMapR$1__go$2__Lfs2_Chunk__Lfs2_Pull__I__Lfs2_Pull($thiz, chunk, tail, 0);
  }
}
function $p_Lfs2_Pull$FlatMapR$1__loop$1__Lfs2_Chunk__sr_IntRef__Lfs2_Pull($thiz, chunk$2, j$1) {
  while (true) {
    var x193 = $as_Lfs2_Pull($n($thiz.Lfs2_Pull$FlatMapR$1__f_fun).apply__O__O($n(chunk$2).apply__I__O($n(j$1).sr_IntRef__f_elem)));
    if ((x193 instanceof $c_Lfs2_Pull$Succeeded)) {
      var x$1 = $as_Lfs2_Pull$Succeeded(x193);
      var this$2 = $n(x$1);
      $as_jl_Void(this$2.Lfs2_Pull$Succeeded__f_r);
      if (($n(j$1).sr_IntRef__f_elem < (((-1) + $n(chunk$2).size__I()) | 0))) {
        var ev$21 = ((1 + $n(j$1).sr_IntRef__f_elem) | 0);
        $n(j$1).sr_IntRef__f_elem = ev$21;
        continue;
      }
    }
    return x193;
  }
}
function $p_Lfs2_Pull$FlatMapR$1__go$2__Lfs2_Chunk__Lfs2_Pull__I__Lfs2_Pull($thiz, chunk$1, tail$4, idx) {
  if ((idx === $n(chunk$1).size__I())) {
    $m_Lfs2_Pull$();
    return $m_Lfs2_Pull$StreamPullOps$().flatMapOutput$extension__Lfs2_Pull__F1__Lfs2_Pull(tail$4, $thiz.Lfs2_Pull$FlatMapR$1__f_fun);
  } else {
    try {
      var j = new $c_sr_IntRef(idx);
      var next = $p_Lfs2_Pull$FlatMapR$1__loop$1__Lfs2_Chunk__sr_IntRef__Lfs2_Pull($thiz, chunk$1, j);
      return $m_Lfs2_Pull$().fs2$Pull$$$transformWith__Lfs2_Pull__F1__Lfs2_Pull(next, new $c_sjsr_AnonFunction1(((x$1) => {
        var x$1$1 = $as_Lfs2_Pull$Terminal(x$1);
        if ((x$1$1 instanceof $c_Lfs2_Pull$Succeeded)) {
          var x$1$2 = $as_Lfs2_Pull$Succeeded(x$1$1);
          var this$5 = $n(x$1$2);
          $as_jl_Void(this$5.Lfs2_Pull$Succeeded__f_r);
          return $p_Lfs2_Pull$FlatMapR$1__go$2__Lfs2_Chunk__Lfs2_Pull__I__Lfs2_Pull($thiz, chunk$1, tail$4, ((1 + j.sr_IntRef__f_elem) | 0));
        }
        if ((x$1$1 instanceof $c_Lfs2_Pull$Fail)) {
          var x$1$3 = $as_Lfs2_Pull$Fail(x$1$1);
          var this$7 = $n(x$1$3);
          var x204 = this$7.Lfs2_Pull$Fail__f_error;
          return new $c_Lfs2_Pull$Fail(x204);
        }
        if ((x$1$1 instanceof $c_Lfs2_Pull$Interrupted)) {
          var x$1$4 = $as_Lfs2_Pull$Interrupted(x$1$1);
          var this$10 = $n(x$1$4);
          var this$11 = $n(x$1$4);
          var interruption = $as_Lfs2_Pull$Interrupted(x$1$1);
          $m_Lfs2_Pull$();
          var self = $m_Lfs2_Pull$().fs2$Pull$$$_$interruptBoundary$1__sr_ObjectRef__Lfs2_Pull__Lfs2_Pull$Interrupted__Lfs2_Pull($thiz.Lfs2_Pull$FlatMapR$1__f_contP$13, tail$4, interruption);
          return $m_Lfs2_Pull$StreamPullOps$().flatMapOutput$extension__Lfs2_Pull__F1__Lfs2_Pull(self, $thiz.Lfs2_Pull$FlatMapR$1__f_fun);
        }
        throw new $c_s_MatchError(x$1$1);
      })));
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      var x209 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!$n(x209).isEmpty__Z())) {
        var x210 = $as_jl_Throwable($n(x209).get__O());
        return new $c_Lfs2_Pull$Fail(x210);
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2));
    }
  }
}
/** @constructor */
function $c_Lfs2_Pull$FlatMapR$1(extendLastTopLevelScope$40, F$53, contP$43, scope$39, extendedTopLevelScope$37, TheBuildR$lzy1$43, translation$tailLocal1$40, runner$tailLocal1$37, view, fun) {
  this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11 = false;
  this.Lfs2_Pull$FlatMapR$1__f_F$20 = null;
  this.Lfs2_Pull$FlatMapR$1__f_contP$13 = null;
  this.Lfs2_Pull$FlatMapR$1__f_scope$13 = null;
  this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10 = null;
  this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13 = null;
  this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10 = null;
  this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10 = null;
  this.Lfs2_Pull$FlatMapR$1__f_view = null;
  this.Lfs2_Pull$FlatMapR$1__f_fun = null;
  this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11 = extendLastTopLevelScope$40;
  this.Lfs2_Pull$FlatMapR$1__f_F$20 = F$53;
  this.Lfs2_Pull$FlatMapR$1__f_contP$13 = contP$43;
  this.Lfs2_Pull$FlatMapR$1__f_scope$13 = scope$39;
  this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10 = extendedTopLevelScope$37;
  this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13 = TheBuildR$lzy1$43;
  this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10 = translation$tailLocal1$40;
  this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10 = runner$tailLocal1$37;
  this.Lfs2_Pull$FlatMapR$1__f_view = view;
  this.Lfs2_Pull$FlatMapR$1__f_fun = fun;
}
$c_Lfs2_Pull$FlatMapR$1.prototype = new $h_O();
$c_Lfs2_Pull$FlatMapR$1.prototype.constructor = $c_Lfs2_Pull$FlatMapR$1;
/** @constructor */
function $h_Lfs2_Pull$FlatMapR$1() {
}
$h_Lfs2_Pull$FlatMapR$1.prototype = $c_Lfs2_Pull$FlatMapR$1.prototype;
$c_Lfs2_Pull$FlatMapR$1.prototype.done__Lfs2_internal_Scope__O = (function(scope) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$interruptGuard$1__Z__Lcats_MonadError__sr_ObjectRef__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_internal_Scope__F1__F0__O(this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11, this.Lfs2_Pull$FlatMapR$1__f_F$20, this.Lfs2_Pull$FlatMapR$1__f_contP$13, this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10, this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13, this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10, this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10, scope, this.Lfs2_Pull$FlatMapR$1__f_view, new $c_sjsr_AnonFunction0((() => $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11, this.Lfs2_Pull$FlatMapR$1__f_F$20, this.Lfs2_Pull$FlatMapR$1__f_contP$13, this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13, scope, this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10, this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10, this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10, $as_Lfs2_Pull($n(this.Lfs2_Pull$FlatMapR$1__f_view).apply__O__O($m_Lfs2_Pull$().Lfs2_Pull$__f_fs2$Pull$$$unit))))));
});
$c_Lfs2_Pull$FlatMapR$1.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, outScope, tail) {
  var next = $m_Lfs2_Pull$().fs2$Pull$$$bindView__Lfs2_Pull__F1__Lfs2_Pull($p_Lfs2_Pull$FlatMapR$1__unconsed__Lfs2_Chunk__Lfs2_Pull__Lfs2_Pull(this, head, tail), this.Lfs2_Pull$FlatMapR$1__f_view);
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11, this.Lfs2_Pull$FlatMapR$1__f_F$20, this.Lfs2_Pull$FlatMapR$1__f_contP$13, this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13, outScope, this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10, this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10, this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10, next);
});
$c_Lfs2_Pull$FlatMapR$1.prototype.interrupted__Lfs2_Pull$Interrupted__O = (function(inter) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11, this.Lfs2_Pull$FlatMapR$1__f_F$20, this.Lfs2_Pull$FlatMapR$1__f_contP$13, this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13, this.Lfs2_Pull$FlatMapR$1__f_scope$13, this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10, this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10, this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10, $as_Lfs2_Pull($n(this.Lfs2_Pull$FlatMapR$1__f_view).apply__O__O(inter)));
});
$c_Lfs2_Pull$FlatMapR$1.prototype.fail__jl_Throwable__O = (function(e) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$goErr$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__jl_Throwable__F1__O(this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11, this.Lfs2_Pull$FlatMapR$1__f_F$20, this.Lfs2_Pull$FlatMapR$1__f_contP$13, this.Lfs2_Pull$FlatMapR$1__f_scope$13, this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10, this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13, this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10, this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10, e, this.Lfs2_Pull$FlatMapR$1__f_view);
});
var $d_Lfs2_Pull$FlatMapR$1 = new $TypeData().initClass($c_Lfs2_Pull$FlatMapR$1, "fs2.Pull$FlatMapR$1", ({
  Lfs2_Pull$FlatMapR$1: 1,
  Lfs2_Pull$Run$1: 1
}));
/** @constructor */
function $c_Lfs2_Pull$OuterRun$1(extendLastTopLevelScope$41, foldChunk$2, F$54, contP$44, initFk$2, TheBuildR$lzy1$44, outer, initB) {
  this.Lfs2_Pull$OuterRun$1__f_extendLastTopLevelScope$35 = false;
  this.Lfs2_Pull$OuterRun$1__f_foldChunk$1 = null;
  this.Lfs2_Pull$OuterRun$1__f_F$46 = null;
  this.Lfs2_Pull$OuterRun$1__f_contP$37 = null;
  this.Lfs2_Pull$OuterRun$1__f_initFk$1 = null;
  this.Lfs2_Pull$OuterRun$1__f_TheBuildR$lzy1$37 = null;
  this.Lfs2_Pull$OuterRun$1__f_accB = null;
  this.Lfs2_Pull$OuterRun$1__f_extendLastTopLevelScope$35 = extendLastTopLevelScope$41;
  this.Lfs2_Pull$OuterRun$1__f_foldChunk$1 = foldChunk$2;
  this.Lfs2_Pull$OuterRun$1__f_F$46 = F$54;
  this.Lfs2_Pull$OuterRun$1__f_contP$37 = contP$44;
  this.Lfs2_Pull$OuterRun$1__f_initFk$1 = initFk$2;
  this.Lfs2_Pull$OuterRun$1__f_TheBuildR$lzy1$37 = TheBuildR$lzy1$44;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lfs2_Pull$OuterRun$1__f_accB = initB;
}
$c_Lfs2_Pull$OuterRun$1.prototype = new $h_O();
$c_Lfs2_Pull$OuterRun$1.prototype.constructor = $c_Lfs2_Pull$OuterRun$1;
/** @constructor */
function $h_Lfs2_Pull$OuterRun$1() {
}
$h_Lfs2_Pull$OuterRun$1.prototype = $c_Lfs2_Pull$OuterRun$1.prototype;
$c_Lfs2_Pull$OuterRun$1.prototype.done__Lfs2_internal_Scope__O = (function(scope) {
  return $n(this.Lfs2_Pull$OuterRun$1__f_F$46).pure__O__O(this.Lfs2_Pull$OuterRun$1__f_accB);
});
$c_Lfs2_Pull$OuterRun$1.prototype.fail__jl_Throwable__O = (function(e) {
  return $n(this.Lfs2_Pull$OuterRun$1__f_F$46).raiseError__O__O(e);
});
$c_Lfs2_Pull$OuterRun$1.prototype.interrupted__Lfs2_Pull$Interrupted__O = (function(inter) {
  var this$1 = $n($n(inter).Lfs2_Pull$Interrupted__f_deferredError);
  if (this$1.isEmpty__Z()) {
    return $n(this.Lfs2_Pull$OuterRun$1__f_F$46).pure__O__O(this.Lfs2_Pull$OuterRun$1__f_accB);
  } else {
    var arg1 = this$1.get__O();
    var e = $as_jl_Throwable(arg1);
    return $n(this.Lfs2_Pull$OuterRun$1__f_F$46).raiseError__O__O(e);
  }
});
$c_Lfs2_Pull$OuterRun$1.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, scope, tail) {
  try {
    this.Lfs2_Pull$OuterRun$1__f_accB = $n(this.Lfs2_Pull$OuterRun$1__f_foldChunk$1).apply__O__O__O(this.Lfs2_Pull$OuterRun$1__f_accB, head);
    return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$OuterRun$1__f_extendLastTopLevelScope$35, this.Lfs2_Pull$OuterRun$1__f_F$46, this.Lfs2_Pull$OuterRun$1__f_contP$37, this.Lfs2_Pull$OuterRun$1__f_TheBuildR$lzy1$37, scope, $m_s_None$(), this.Lfs2_Pull$OuterRun$1__f_initFk$1, this, tail);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    var x328 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
    if ((!$n(x328).isEmpty__Z())) {
      var x329 = $as_jl_Throwable($n(x328).get__O());
      var x315 = $m_Lfs2_Pull$().fs2$Pull$$$_$viewL$1__sr_ObjectRef__Lfs2_Pull__Lfs2_Pull$ViewL(this.Lfs2_Pull$OuterRun$1__f_contP$37, tail);
      if ((x315 instanceof $c_Lfs2_Pull$Action)) {
        var $x_7 = $m_Lfs2_Pull$();
        var $x_6 = this.Lfs2_Pull$OuterRun$1__f_extendLastTopLevelScope$35;
        var $x_5 = this.Lfs2_Pull$OuterRun$1__f_F$46;
        var $x_4 = this.Lfs2_Pull$OuterRun$1__f_contP$37;
        var $x_3 = this.Lfs2_Pull$OuterRun$1__f_TheBuildR$lzy1$37;
        var $x_2 = $m_s_None$();
        var $x_1 = this.Lfs2_Pull$OuterRun$1__f_initFk$1;
        $m_Lfs2_Pull$();
        var contP$1 = this.Lfs2_Pull$OuterRun$1__f_contP$37;
        var this$3 = $n($as_Lfs2_Pull$ContP($n(contP$1).sr_ObjectRef__f_elem));
        var v1 = new $c_Lfs2_Pull$Fail(x329);
        return $n($x_7).fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O($x_6, $x_5, $x_4, $x_3, scope, $x_2, $x_1, this, this$3.cont__Lfs2_Pull$Terminal__Lfs2_Pull(v1));
      }
      if ((x315 instanceof $c_Lfs2_Pull$Succeeded)) {
        var x$1 = $as_Lfs2_Pull$Succeeded(x315);
        var this$5 = $n(x$1);
        return $n(this.Lfs2_Pull$OuterRun$1__f_F$46).raiseError__O__O(x329);
      }
      if ((x315 instanceof $c_Lfs2_Pull$Fail)) {
        var x$1$1 = $as_Lfs2_Pull$Fail(x315);
        var this$7 = $n(x$1$1);
        var x322 = this$7.Lfs2_Pull$Fail__f_error;
        return $n(this.Lfs2_Pull$OuterRun$1__f_F$46).raiseError__O__O($m_Lfs2_CompositeFailure$().apply__jl_Throwable__jl_Throwable__sci_List__Lfs2_CompositeFailure(x322, x329, $m_sci_Nil$()));
      }
      if ((x315 instanceof $c_Lfs2_Pull$Interrupted)) {
        var x$1$2 = $as_Lfs2_Pull$Interrupted(x315);
        var this$11 = $n(x$1$2);
        var this$12 = $n(x$1$2);
        var x319 = this$12.Lfs2_Pull$Interrupted__f_deferredError;
        var $x_9 = $n(this.Lfs2_Pull$OuterRun$1__f_F$46);
        var this$13 = $n(x319);
        if (this$13.isEmpty__Z()) {
          var $x_8 = x329;
        } else {
          var arg1 = this$13.get__O();
          var t = $as_jl_Throwable(arg1);
          var $x_8 = $m_Lfs2_CompositeFailure$().apply__jl_Throwable__jl_Throwable__sci_List__Lfs2_CompositeFailure(x329, t, $m_sci_Nil$());
        }
        return $n($x_9).raiseError__O__O($x_8);
      }
      throw new $c_s_MatchError(x315);
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2));
  }
});
var $d_Lfs2_Pull$OuterRun$1 = new $TypeData().initClass($c_Lfs2_Pull$OuterRun$1, "fs2.Pull$OuterRun$1", ({
  Lfs2_Pull$OuterRun$1: 1,
  Lfs2_Pull$Run$1: 1
}));
function $ct_Lfs2_Pull$StepRunR$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__F1__($thiz, extendLastTopLevelScope$37, F$50, contP$40, scope$36, extendedTopLevelScope$34, TheBuildR$lzy1$40, translation$tailLocal1$37, runner$tailLocal1$34, view) {
  $thiz.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8 = extendLastTopLevelScope$37;
  $thiz.Lfs2_Pull$StepRunR$1__f_F$17 = F$50;
  $thiz.Lfs2_Pull$StepRunR$1__f_contP$10 = contP$40;
  $thiz.Lfs2_Pull$StepRunR$1__f_scope$10 = scope$36;
  $thiz.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7 = extendedTopLevelScope$34;
  $thiz.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10 = TheBuildR$lzy1$40;
  $thiz.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7 = translation$tailLocal1$37;
  $thiz.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7 = runner$tailLocal1$34;
  $thiz.Lfs2_Pull$StepRunR$1__f_view = view;
  return $thiz;
}
/** @constructor */
function $c_Lfs2_Pull$StepRunR$1() {
  this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8 = false;
  this.Lfs2_Pull$StepRunR$1__f_F$17 = null;
  this.Lfs2_Pull$StepRunR$1__f_contP$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_scope$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_view = null;
}
$c_Lfs2_Pull$StepRunR$1.prototype = new $h_O();
$c_Lfs2_Pull$StepRunR$1.prototype.constructor = $c_Lfs2_Pull$StepRunR$1;
/** @constructor */
function $h_Lfs2_Pull$StepRunR$1() {
}
$h_Lfs2_Pull$StepRunR$1.prototype = $c_Lfs2_Pull$StepRunR$1.prototype;
$c_Lfs2_Pull$StepRunR$1.prototype.done__Lfs2_internal_Scope__O = (function(scope) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$interruptGuard$1__Z__Lcats_MonadError__sr_ObjectRef__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_internal_Scope__F1__F0__O(this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8, this.Lfs2_Pull$StepRunR$1__f_F$17, this.Lfs2_Pull$StepRunR$1__f_contP$10, this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7, this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10, this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7, this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7, scope, this.Lfs2_Pull$StepRunR$1__f_view, new $c_sjsr_AnonFunction0((() => {
    var $x_9 = $m_Lfs2_Pull$();
    var $x_8 = this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8;
    var $x_7 = this.Lfs2_Pull$StepRunR$1__f_F$17;
    var $x_6 = this.Lfs2_Pull$StepRunR$1__f_contP$10;
    var $x_5 = this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10;
    var $x_4 = this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7;
    var $x_3 = this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7;
    var $x_2 = this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7;
    var $x_1 = this.Lfs2_Pull$StepRunR$1__f_view;
    var r = $m_s_None$();
    return $n($x_9).fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O($x_8, $x_7, $x_6, $x_5, scope, $x_4, $x_3, $x_2, $as_Lfs2_Pull($n($x_1).apply__O__O(new $c_Lfs2_Pull$Succeeded(r))));
  })));
});
$c_Lfs2_Pull$StepRunR$1.prototype.interrupted__Lfs2_Pull$Interrupted__O = (function(inter) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8, this.Lfs2_Pull$StepRunR$1__f_F$17, this.Lfs2_Pull$StepRunR$1__f_contP$10, this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10, this.Lfs2_Pull$StepRunR$1__f_scope$10, this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7, this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7, this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7, $as_Lfs2_Pull($n(this.Lfs2_Pull$StepRunR$1__f_view).apply__O__O(inter)));
});
$c_Lfs2_Pull$StepRunR$1.prototype.fail__jl_Throwable__O = (function(e) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$goErr$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__jl_Throwable__F1__O(this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8, this.Lfs2_Pull$StepRunR$1__f_F$17, this.Lfs2_Pull$StepRunR$1__f_contP$10, this.Lfs2_Pull$StepRunR$1__f_scope$10, this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7, this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10, this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7, this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7, e, this.Lfs2_Pull$StepRunR$1__f_view);
});
/** @constructor */
function $c_Lfs2_Pull$TheBuildR$2$(F$47) {
  this.Lfs2_Pull$TheBuildR$2$__f_F$9 = null;
  this.Lfs2_Pull$TheBuildR$2$__f_F$9 = F$47;
}
$c_Lfs2_Pull$TheBuildR$2$.prototype = new $h_O();
$c_Lfs2_Pull$TheBuildR$2$.prototype.constructor = $c_Lfs2_Pull$TheBuildR$2$;
/** @constructor */
function $h_Lfs2_Pull$TheBuildR$2$() {
}
$h_Lfs2_Pull$TheBuildR$2$.prototype = $c_Lfs2_Pull$TheBuildR$2$.prototype;
$c_Lfs2_Pull$TheBuildR$2$.prototype.fail__jl_Throwable__O = (function(e) {
  return $n(this.Lfs2_Pull$TheBuildR$2$__f_F$9).raiseError__O__O(e);
});
$c_Lfs2_Pull$TheBuildR$2$.prototype.done__Lfs2_internal_Scope__O = (function(scope) {
  return $n(this.Lfs2_Pull$TheBuildR$2$__f_F$9).pure__O__O(new $c_sjsr_AnonFunction1(((_$62) => {
    var _$62$1 = $as_Lfs2_Pull$Run$1(_$62);
    return $n(_$62$1).done__Lfs2_internal_Scope__O(scope);
  })));
});
$c_Lfs2_Pull$TheBuildR$2$.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, scope, tail) {
  return $n(this.Lfs2_Pull$TheBuildR$2$__f_F$9).pure__O__O(new $c_sjsr_AnonFunction1(((_$63) => {
    var _$63$1 = $as_Lfs2_Pull$Run$1(_$63);
    return $n(_$63$1).out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O(head, scope, tail);
  })));
});
$c_Lfs2_Pull$TheBuildR$2$.prototype.interrupted__Lfs2_Pull$Interrupted__O = (function(i) {
  return $n(this.Lfs2_Pull$TheBuildR$2$__f_F$9).pure__O__O(new $c_sjsr_AnonFunction1(((_$64) => {
    var _$64$1 = $as_Lfs2_Pull$Run$1(_$64);
    return $n(_$64$1).interrupted__Lfs2_Pull$Interrupted__O(i);
  })));
});
function $as_Lfs2_Pull$TheBuildR$2$(obj) {
  return (((obj instanceof $c_Lfs2_Pull$TheBuildR$2$) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$TheBuildR$2$"));
}
function $isArrayOf_Lfs2_Pull$TheBuildR$2$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$TheBuildR$2$)));
}
function $asArrayOf_Lfs2_Pull$TheBuildR$2$(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$TheBuildR$2$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$TheBuildR$2$;", depth));
}
var $d_Lfs2_Pull$TheBuildR$2$ = new $TypeData().initClass($c_Lfs2_Pull$TheBuildR$2$, "fs2.Pull$TheBuildR$2$", ({
  Lfs2_Pull$TheBuildR$2$: 1,
  Lfs2_Pull$Run$1: 1
}));
/** @constructor */
function $c_Lfs2_Pull$TranslateRunner$1(extendLastTopLevelScope$36, F$49, contP$39, scope$35, extendedTopLevelScope$33, TheBuildR$lzy1$39, translation$tailLocal1$36, runner$tailLocal1$33, fk, view) {
  this.Lfs2_Pull$TranslateRunner$1__f_extendLastTopLevelScope$7 = false;
  this.Lfs2_Pull$TranslateRunner$1__f_F$16 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_contP$9 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_scope$8 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_extendedTopLevelScope$6 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_TheBuildR$lzy1$9 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_translation$tailLocal1$6 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_runner$tailLocal1$6 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_fk = null;
  this.Lfs2_Pull$TranslateRunner$1__f_view = null;
  this.Lfs2_Pull$TranslateRunner$1__f_extendLastTopLevelScope$7 = extendLastTopLevelScope$36;
  this.Lfs2_Pull$TranslateRunner$1__f_F$16 = F$49;
  this.Lfs2_Pull$TranslateRunner$1__f_contP$9 = contP$39;
  this.Lfs2_Pull$TranslateRunner$1__f_scope$8 = scope$35;
  this.Lfs2_Pull$TranslateRunner$1__f_extendedTopLevelScope$6 = extendedTopLevelScope$33;
  this.Lfs2_Pull$TranslateRunner$1__f_TheBuildR$lzy1$9 = TheBuildR$lzy1$39;
  this.Lfs2_Pull$TranslateRunner$1__f_translation$tailLocal1$6 = translation$tailLocal1$36;
  this.Lfs2_Pull$TranslateRunner$1__f_runner$tailLocal1$6 = runner$tailLocal1$33;
  this.Lfs2_Pull$TranslateRunner$1__f_fk = fk;
  this.Lfs2_Pull$TranslateRunner$1__f_view = view;
}
$c_Lfs2_Pull$TranslateRunner$1.prototype = new $h_O();
$c_Lfs2_Pull$TranslateRunner$1.prototype.constructor = $c_Lfs2_Pull$TranslateRunner$1;
/** @constructor */
function $h_Lfs2_Pull$TranslateRunner$1() {
}
$h_Lfs2_Pull$TranslateRunner$1.prototype = $c_Lfs2_Pull$TranslateRunner$1.prototype;
$c_Lfs2_Pull$TranslateRunner$1.prototype.done__Lfs2_internal_Scope__O = (function(doneScope) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$TranslateRunner$1__f_extendLastTopLevelScope$7, this.Lfs2_Pull$TranslateRunner$1__f_F$16, this.Lfs2_Pull$TranslateRunner$1__f_contP$9, this.Lfs2_Pull$TranslateRunner$1__f_TheBuildR$lzy1$9, doneScope, this.Lfs2_Pull$TranslateRunner$1__f_extendedTopLevelScope$6, this.Lfs2_Pull$TranslateRunner$1__f_translation$tailLocal1$6, this.Lfs2_Pull$TranslateRunner$1__f_runner$tailLocal1$6, $as_Lfs2_Pull($n(this.Lfs2_Pull$TranslateRunner$1__f_view).apply__O__O($m_Lfs2_Pull$().Lfs2_Pull$__f_fs2$Pull$$$unit)));
});
$c_Lfs2_Pull$TranslateRunner$1.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, scope, tail) {
  var $x_1 = $m_Lfs2_Pull$();
  var fk = this.Lfs2_Pull$TranslateRunner$1__f_fk;
  var next = $n($x_1).fs2$Pull$$$bindView__Lfs2_Pull__F1__Lfs2_Pull(new $c_Lfs2_Pull$Translate(tail, fk), this.Lfs2_Pull$TranslateRunner$1__f_view);
  return $n(this.Lfs2_Pull$TranslateRunner$1__f_runner$tailLocal1$6).out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O(head, scope, next);
});
$c_Lfs2_Pull$TranslateRunner$1.prototype.interrupted__Lfs2_Pull$Interrupted__O = (function(inter) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$TranslateRunner$1__f_extendLastTopLevelScope$7, this.Lfs2_Pull$TranslateRunner$1__f_F$16, this.Lfs2_Pull$TranslateRunner$1__f_contP$9, this.Lfs2_Pull$TranslateRunner$1__f_TheBuildR$lzy1$9, this.Lfs2_Pull$TranslateRunner$1__f_scope$8, this.Lfs2_Pull$TranslateRunner$1__f_extendedTopLevelScope$6, this.Lfs2_Pull$TranslateRunner$1__f_translation$tailLocal1$6, this.Lfs2_Pull$TranslateRunner$1__f_runner$tailLocal1$6, $as_Lfs2_Pull($n(this.Lfs2_Pull$TranslateRunner$1__f_view).apply__O__O(inter)));
});
$c_Lfs2_Pull$TranslateRunner$1.prototype.fail__jl_Throwable__O = (function(e) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$goErr$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__jl_Throwable__F1__O(this.Lfs2_Pull$TranslateRunner$1__f_extendLastTopLevelScope$7, this.Lfs2_Pull$TranslateRunner$1__f_F$16, this.Lfs2_Pull$TranslateRunner$1__f_contP$9, this.Lfs2_Pull$TranslateRunner$1__f_scope$8, this.Lfs2_Pull$TranslateRunner$1__f_extendedTopLevelScope$6, this.Lfs2_Pull$TranslateRunner$1__f_TheBuildR$lzy1$9, this.Lfs2_Pull$TranslateRunner$1__f_translation$tailLocal1$6, this.Lfs2_Pull$TranslateRunner$1__f_runner$tailLocal1$6, e, this.Lfs2_Pull$TranslateRunner$1__f_view);
});
var $d_Lfs2_Pull$TranslateRunner$1 = new $TypeData().initClass($c_Lfs2_Pull$TranslateRunner$1, "fs2.Pull$TranslateRunner$1", ({
  Lfs2_Pull$TranslateRunner$1: 1,
  Lfs2_Pull$Run$1: 1
}));
/** @constructor */
function $c_Lfs2_Pull$ViewRunner$1(extendLastTopLevelScope$5, F$14, contP$7, scope$5, extendedTopLevelScope$4, TheBuildR$lzy1$7, translation$tailLocal1$4, runner$tailLocal1$4, view) {
  this.Lfs2_Pull$ViewRunner$1__f_extendLastTopLevelScope$6 = false;
  this.Lfs2_Pull$ViewRunner$1__f_F$15 = null;
  this.Lfs2_Pull$ViewRunner$1__f_contP$8 = null;
  this.Lfs2_Pull$ViewRunner$1__f_scope$6 = null;
  this.Lfs2_Pull$ViewRunner$1__f_extendedTopLevelScope$5 = null;
  this.Lfs2_Pull$ViewRunner$1__f_TheBuildR$lzy1$8 = null;
  this.Lfs2_Pull$ViewRunner$1__f_translation$tailLocal1$5 = null;
  this.Lfs2_Pull$ViewRunner$1__f_runner$tailLocal1$5 = null;
  this.Lfs2_Pull$ViewRunner$1__f_view = null;
  this.Lfs2_Pull$ViewRunner$1__f_prevRunner = null;
  this.Lfs2_Pull$ViewRunner$1__f_extendLastTopLevelScope$6 = extendLastTopLevelScope$5;
  this.Lfs2_Pull$ViewRunner$1__f_F$15 = F$14;
  this.Lfs2_Pull$ViewRunner$1__f_contP$8 = contP$7;
  this.Lfs2_Pull$ViewRunner$1__f_scope$6 = scope$5;
  this.Lfs2_Pull$ViewRunner$1__f_extendedTopLevelScope$5 = extendedTopLevelScope$4;
  this.Lfs2_Pull$ViewRunner$1__f_TheBuildR$lzy1$8 = TheBuildR$lzy1$7;
  this.Lfs2_Pull$ViewRunner$1__f_translation$tailLocal1$5 = translation$tailLocal1$4;
  this.Lfs2_Pull$ViewRunner$1__f_runner$tailLocal1$5 = runner$tailLocal1$4;
  this.Lfs2_Pull$ViewRunner$1__f_view = view;
  this.Lfs2_Pull$ViewRunner$1__f_prevRunner = runner$tailLocal1$4;
}
$c_Lfs2_Pull$ViewRunner$1.prototype = new $h_O();
$c_Lfs2_Pull$ViewRunner$1.prototype.constructor = $c_Lfs2_Pull$ViewRunner$1;
/** @constructor */
function $h_Lfs2_Pull$ViewRunner$1() {
}
$h_Lfs2_Pull$ViewRunner$1.prototype = $c_Lfs2_Pull$ViewRunner$1.prototype;
$c_Lfs2_Pull$ViewRunner$1.prototype.done__Lfs2_internal_Scope__O = (function(doneScope) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$ViewRunner$1__f_extendLastTopLevelScope$6, this.Lfs2_Pull$ViewRunner$1__f_F$15, this.Lfs2_Pull$ViewRunner$1__f_contP$8, this.Lfs2_Pull$ViewRunner$1__f_TheBuildR$lzy1$8, doneScope, this.Lfs2_Pull$ViewRunner$1__f_extendedTopLevelScope$5, this.Lfs2_Pull$ViewRunner$1__f_translation$tailLocal1$5, this.Lfs2_Pull$ViewRunner$1__f_prevRunner, $as_Lfs2_Pull($n(this.Lfs2_Pull$ViewRunner$1__f_view).apply__O__O($m_Lfs2_Pull$().Lfs2_Pull$__f_fs2$Pull$$$unit)));
});
$c_Lfs2_Pull$ViewRunner$1.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, scope, tail) {
  return $s_Lfs2_Pull$__fs2$Pull$ViewRunner$1$$_$outLoop$1__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__Lfs2_Pull$Run$1__O(head, scope, tail, this);
});
$c_Lfs2_Pull$ViewRunner$1.prototype.interrupted__Lfs2_Pull$Interrupted__O = (function(inter) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$ViewRunner$1__f_extendLastTopLevelScope$6, this.Lfs2_Pull$ViewRunner$1__f_F$15, this.Lfs2_Pull$ViewRunner$1__f_contP$8, this.Lfs2_Pull$ViewRunner$1__f_TheBuildR$lzy1$8, this.Lfs2_Pull$ViewRunner$1__f_scope$6, this.Lfs2_Pull$ViewRunner$1__f_extendedTopLevelScope$5, this.Lfs2_Pull$ViewRunner$1__f_translation$tailLocal1$5, this.Lfs2_Pull$ViewRunner$1__f_prevRunner, $as_Lfs2_Pull($n(this.Lfs2_Pull$ViewRunner$1__f_view).apply__O__O(inter)));
});
$c_Lfs2_Pull$ViewRunner$1.prototype.fail__jl_Throwable__O = (function(e) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$goErr$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__jl_Throwable__F1__O(this.Lfs2_Pull$ViewRunner$1__f_extendLastTopLevelScope$6, this.Lfs2_Pull$ViewRunner$1__f_F$15, this.Lfs2_Pull$ViewRunner$1__f_contP$8, this.Lfs2_Pull$ViewRunner$1__f_scope$6, this.Lfs2_Pull$ViewRunner$1__f_extendedTopLevelScope$5, this.Lfs2_Pull$ViewRunner$1__f_TheBuildR$lzy1$8, this.Lfs2_Pull$ViewRunner$1__f_translation$tailLocal1$5, this.Lfs2_Pull$ViewRunner$1__f_runner$tailLocal1$5, e, this.Lfs2_Pull$ViewRunner$1__f_view);
});
function $as_Lfs2_Pull$ViewRunner$1(obj) {
  return (((obj instanceof $c_Lfs2_Pull$ViewRunner$1) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$ViewRunner$1"));
}
function $isArrayOf_Lfs2_Pull$ViewRunner$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$ViewRunner$1)));
}
function $asArrayOf_Lfs2_Pull$ViewRunner$1(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$ViewRunner$1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$ViewRunner$1;", depth));
}
var $d_Lfs2_Pull$ViewRunner$1 = new $TypeData().initClass($c_Lfs2_Pull$ViewRunner$1, "fs2.Pull$ViewRunner$1", ({
  Lfs2_Pull$ViewRunner$1: 1,
  Lfs2_Pull$Run$1: 1
}));
function $p_Lfs2_Stream$__go$19__F1__O__Lfs2_Stream($thiz, f$100, s) {
  return $n($thiz.eval__O__Lfs2_Stream($n(f$100).apply__O__O(s))).flatMap__F1__s_util_NotGiven__Lfs2_Stream(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_s_Option(x$1);
    if ((x$1$1 instanceof $c_s_Some)) {
      var x486 = $as_T2($n($as_s_Some(x$1$1)).s_Some__f_value);
      if ((x486 !== null)) {
        var o = $n(x486)._1__O();
        var s$1 = $n(x486)._2__O();
        return $n($thiz.emit__O__Lfs2_Stream(o)).$plus$plus__F0__Lfs2_Stream(new $c_sjsr_AnonFunction0((() => $p_Lfs2_Stream$__go$19__F1__O__Lfs2_Stream($thiz, f$100, s$1))));
      }
    }
    var x = $m_s_None$();
    if ((x === x$1$1)) {
      return $thiz.Lfs2_Stream$__f_empty;
    }
    throw new $c_s_MatchError(x$1$1);
  })), $m_s_util_NotGiven$().s_util_NotGiven$__f_cachedValue);
}
/** @constructor */
function $c_Lfs2_Stream$() {
  this.Lfs2_Stream$__f_empty = null;
  $n_Lfs2_Stream$ = this;
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
  var self$1 = $m_Lfs2_Pull$().Lfs2_Pull$__f_done;
  this.Lfs2_Stream$__f_empty = new $c_Lfs2_Stream(self$1);
}
$c_Lfs2_Stream$.prototype = new $h_O();
$c_Lfs2_Stream$.prototype.constructor = $c_Lfs2_Stream$;
/** @constructor */
function $h_Lfs2_Stream$() {
}
$h_Lfs2_Stream$.prototype = $c_Lfs2_Stream$.prototype;
$c_Lfs2_Stream$.prototype.emit__O__Lfs2_Stream = (function(o) {
  $m_Lfs2_Pull$();
  var self = $m_Lfs2_Pull$().output1__O__Lfs2_Pull(o);
  return new $c_Lfs2_Stream(self);
});
$c_Lfs2_Stream$.prototype.eval__O__Lfs2_Stream = (function(fo) {
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
  var this$4 = new $c_Lfs2_Pull$Eval(fo);
  var f = new $c_sjsr_AnonFunction1(((o) => $m_Lfs2_Pull$().output1__O__Lfs2_Pull(o)));
  var self = new $c_Lfs2_Pull$$anon$1(f, this$4);
  return new $c_Lfs2_Stream(self);
});
$c_Lfs2_Stream$.prototype.repeatEval__O__Lfs2_Stream = (function(fo) {
  return $n(this.eval__O__Lfs2_Stream(fo)).repeat__Lfs2_Stream();
});
$c_Lfs2_Stream$.prototype.suspend__F0__Lfs2_Stream = (function(s) {
  $m_Lfs2_Pull$();
  var this$2 = $m_Lfs2_Pull$();
  var p = new $c_sjsr_AnonFunction0((() => $n($as_Lfs2_Stream($n(s).apply__O())).Lfs2_Stream__f_underlying));
  var self = new $c_Lfs2_Pull$$anon$5(p, this$2);
  return new $c_Lfs2_Stream(self);
});
$c_Lfs2_Stream$.prototype.unfoldEval__O__F1__Lfs2_Stream = (function(s, f) {
  return this.suspend__F0__Lfs2_Stream(new $c_sjsr_AnonFunction0((() => $p_Lfs2_Stream$__go$19__F1__O__Lfs2_Stream(this, f, s))));
});
var $d_Lfs2_Stream$ = new $TypeData().initClass($c_Lfs2_Stream$, "fs2.Stream$", ({
  Lfs2_Stream$: 1,
  Lfs2_StreamLowPriority: 1
}));
var $n_Lfs2_Stream$;
function $m_Lfs2_Stream$() {
  if ((!$n_Lfs2_Stream$)) {
    $n_Lfs2_Stream$ = new $c_Lfs2_Stream$();
  }
  return $n_Lfs2_Stream$;
}
/** @constructor */
function $c_Lfs2_internal_ScopedResource$$anon$1(F$2, state$1, token$1) {
  this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4 = null;
  this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$state$3 = null;
  this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$pru = null;
  this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4 = F$2;
  this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$state$3 = state$1;
  $m_Lcats_implicits$();
  var a = new $c_s_util_Right((void 0));
  var this$4 = $n(F$2);
  this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$pru = $n(this$4.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a);
}
$c_Lfs2_internal_ScopedResource$$anon$1.prototype = new $h_Lfs2_internal_ScopedResource();
$c_Lfs2_internal_ScopedResource$$anon$1.prototype.constructor = $c_Lfs2_internal_ScopedResource$$anon$1;
/** @constructor */
function $h_Lfs2_internal_ScopedResource$$anon$1() {
}
$h_Lfs2_internal_ScopedResource$$anon$1.prototype = $c_Lfs2_internal_ScopedResource$$anon$1.prototype;
$c_Lfs2_internal_ScopedResource$$anon$1.prototype.release__Lcats_effect_kernel_Resource$ExitCase__O = (function(ec) {
  $m_Lcats_implicits$();
  var target = $n(this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$state$3).modify__F1__O(new $c_sjsr_AnonFunction1(((s) => {
    var s$1 = $as_Lfs2_internal_ScopedResource$State(s);
    if (($n(s$1).Lfs2_internal_ScopedResource$State__f_leases !== 0)) {
      $n(s$1);
      var this$1 = $n(s$1);
      var finalizer = this$1.Lfs2_internal_ScopedResource$State__f_finalizer;
      var this$2 = $n(s$1);
      var leases = this$2.Lfs2_internal_ScopedResource$State__f_leases;
      var _1 = new $c_Lfs2_internal_ScopedResource$State(false, finalizer, leases);
      var _2 = $m_s_None$();
      return new $c_T2(_1, _2);
    } else {
      $n(s$1);
      var finalizer$1 = $m_s_None$();
      var this$5 = $n(s$1);
      var leases$1 = this$5.Lfs2_internal_ScopedResource$State__f_leases;
      var _1$1 = new $c_Lfs2_internal_ScopedResource$State(false, finalizer$1, leases$1);
      var _2$1 = $n(s$1).Lfs2_internal_ScopedResource$State__f_finalizer;
      return new $c_T2(_1$1, _2$1);
    }
  })));
  var tc = this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4;
  var this$12 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f = new $c_sjsr_AnonFunction1(((finalizer$2) => {
    var finalizer$3 = $as_s_Option(finalizer$2);
    var this$10 = $n(finalizer$3);
    if (this$10.isEmpty__Z()) {
      var $x_1 = $m_s_None$();
    } else {
      var arg1 = this$10.get__O();
      var _$4 = $as_F1(arg1);
      var $x_1 = new $c_s_Some($n(_$4).apply__O__O(ec));
    }
    var this$11 = $n($x_1);
    return (this$11.isEmpty__Z() ? this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$pru : this$11.get__O());
  }));
  return $n(this$12.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$12.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
});
$c_Lfs2_internal_ScopedResource$$anon$1.prototype.acquired__F1__O = (function(finalizer) {
  return $n(this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$state$3).flatModify__F1__Lcats_effect_kernel_MonadCancel__O(new $c_sjsr_AnonFunction1(((s) => {
    var s$1 = $as_Lfs2_internal_ScopedResource$State(s);
    var this$2 = $n(s$1);
    if (((!this$2.Lfs2_internal_ScopedResource$State__f_open) && (this$2.Lfs2_internal_ScopedResource$State__f_leases === 0))) {
      $m_Lcats_implicits$();
      $m_Lcats_implicits$();
      var target = $n(finalizer).apply__O__O($m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$());
      var tc = this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4;
      var this$5 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
      var fa = $n(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_self, false);
      var F$1 = this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4;
      var this$8 = $n(F$1);
      var y = $f_Lcats_ApplicativeError__attempt__O__O(this$8, fa);
      return new $c_T2(s$1, y);
    } else {
      var attemptFinalizer = new $c_sjsr_AnonFunction1(((ec) => {
        var ec$1 = $as_Lcats_effect_kernel_Resource$ExitCase(ec);
        $m_Lcats_implicits$();
        var fa$1 = $n(finalizer).apply__O__O(ec$1);
        var F$3 = this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4;
        var this$12 = $n(F$3);
        return $f_Lcats_ApplicativeError__attempt__O__O(this$12, fa$1);
      }));
      var finalizer$1 = new $c_s_Some(attemptFinalizer);
      var this$14 = $n(s$1);
      var open$1 = this$14.Lfs2_internal_ScopedResource$State__f_open;
      var this$15 = $n(s$1);
      var leases$1 = this$15.Lfs2_internal_ScopedResource$State__f_leases;
      $n(s$1);
      var self = new $c_Lfs2_internal_ScopedResource$State(open$1, finalizer$1, leases$1);
      $m_Lcats_implicits$();
      var a = new $c_s_util_Right(true);
      var F$4 = this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4;
      var this$21 = $n(F$4);
      var y$1 = $n(this$21.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a);
      return new $c_T2(self, y$1);
    }
  })), this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4);
});
var $d_Lfs2_internal_ScopedResource$$anon$1 = new $TypeData().initClass($c_Lfs2_internal_ScopedResource$$anon$1, "fs2.internal.ScopedResource$$anon$1", ({
  Lfs2_internal_ScopedResource$$anon$1: 1,
  Lfs2_internal_ScopedResource: 1
}));
function $p_jl_Character$__getTypeGE256__I__I($thiz, codePoint) {
  return $n($p_jl_Character$__charTypes__AI($thiz)).get($p_jl_Character$__findIndexOfRange__AI__I__Z__I($thiz, $p_jl_Character$__charTypeIndices__AI($thiz), codePoint, false));
}
function $p_jl_Character$__java$lang$Character$$charTypesFirst256$lzycompute__AI($thiz) {
  if (((((1 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Character$__f_java$lang$Character$$charTypesFirst256 = new $ac_I(new Int32Array([15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 12, 24, 24, 24, 26, 24, 24, 24, 21, 22, 24, 25, 24, 20, 24, 24, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 24, 24, 25, 25, 25, 24, 24, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 21, 24, 22, 27, 23, 27, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 21, 25, 22, 25, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 12, 24, 26, 26, 26, 26, 28, 24, 27, 28, 5, 29, 25, 16, 28, 27, 28, 25, 11, 11, 27, 2, 24, 24, 27, 11, 5, 30, 11, 11, 11, 24, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 25, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 25, 2, 2, 2, 2, 2, 2, 2, 2]));
    $thiz.jl_Character$__f_bitmap$0 = (((1 | $thiz.jl_Character$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.jl_Character$__f_java$lang$Character$$charTypesFirst256;
}
function $p_jl_Character$__charTypeIndices$lzycompute__AI($thiz) {
  if (((((2 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0)) {
    var deltas = new $ac_I(new Int32Array([257, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 3, 2, 1, 1, 1, 2, 1, 3, 2, 4, 1, 2, 1, 3, 3, 2, 1, 2, 1, 1, 1, 1, 1, 2, 1, 1, 2, 1, 1, 2, 1, 3, 1, 1, 1, 2, 2, 1, 1, 3, 4, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 7, 2, 1, 2, 2, 1, 1, 4, 1, 1, 1, 1, 1, 1, 1, 1, 69, 1, 27, 18, 4, 12, 14, 5, 7, 1, 1, 1, 17, 112, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 3, 1, 5, 2, 1, 1, 3, 1, 1, 1, 2, 1, 17, 1, 9, 35, 1, 2, 3, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 1, 1, 1, 1, 1, 2, 2, 51, 48, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 9, 38, 2, 1, 6, 1, 39, 1, 1, 1, 4, 1, 1, 45, 1, 1, 1, 2, 1, 2, 1, 1, 8, 27, 5, 3, 2, 11, 5, 1, 3, 2, 1, 2, 2, 11, 1, 2, 2, 32, 1, 10, 21, 10, 4, 2, 1, 99, 1, 1, 7, 1, 1, 6, 2, 2, 1, 4, 2, 10, 3, 2, 1, 14, 1, 1, 1, 1, 30, 27, 2, 89, 11, 1, 14, 10, 33, 9, 2, 1, 3, 1, 5, 22, 4, 1, 9, 1, 3, 1, 5, 2, 15, 1, 25, 3, 2, 1, 65, 1, 1, 11, 55, 27, 1, 3, 1, 54, 1, 1, 1, 1, 3, 8, 4, 1, 2, 1, 7, 10, 2, 2, 10, 1, 1, 6, 1, 7, 1, 1, 2, 1, 8, 2, 2, 2, 22, 1, 7, 1, 1, 3, 4, 2, 1, 1, 3, 4, 2, 2, 2, 2, 1, 1, 8, 1, 4, 2, 1, 3, 2, 2, 10, 2, 2, 6, 1, 1, 5, 2, 1, 1, 6, 4, 2, 2, 22, 1, 7, 1, 2, 1, 2, 1, 2, 2, 1, 1, 3, 2, 4, 2, 2, 3, 3, 1, 7, 4, 1, 1, 7, 10, 2, 3, 1, 11, 2, 1, 1, 9, 1, 3, 1, 22, 1, 7, 1, 2, 1, 5, 2, 1, 1, 3, 5, 1, 2, 1, 1, 2, 1, 2, 1, 15, 2, 2, 2, 10, 1, 1, 15, 1, 2, 1, 8, 2, 2, 2, 22, 1, 7, 1, 2, 1, 5, 2, 1, 1, 1, 1, 1, 4, 2, 2, 2, 2, 1, 8, 1, 1, 4, 2, 1, 3, 2, 2, 10, 1, 1, 6, 10, 1, 1, 1, 6, 3, 3, 1, 4, 3, 2, 1, 1, 1, 2, 3, 2, 3, 3, 3, 12, 4, 2, 1, 2, 3, 3, 1, 3, 1, 2, 1, 6, 1, 14, 10, 3, 6, 1, 1, 6, 3, 1, 8, 1, 3, 1, 23, 1, 10, 1, 5, 3, 1, 3, 4, 1, 3, 1, 4, 7, 2, 1, 2, 6, 2, 2, 2, 10, 8, 7, 1, 2, 2, 1, 8, 1, 3, 1, 23, 1, 10, 1, 5, 2, 1, 1, 1, 1, 5, 1, 1, 2, 1, 2, 2, 7, 2, 7, 1, 1, 2, 2, 2, 10, 1, 2, 15, 2, 1, 8, 1, 3, 1, 41, 2, 1, 3, 4, 1, 3, 1, 3, 1, 1, 8, 1, 8, 2, 2, 2, 10, 6, 3, 1, 6, 2, 2, 1, 18, 3, 24, 1, 9, 1, 1, 2, 7, 3, 1, 4, 3, 3, 1, 1, 1, 8, 18, 2, 1, 12, 48, 1, 2, 7, 4, 1, 6, 1, 8, 1, 10, 2, 37, 2, 1, 1, 2, 2, 1, 1, 2, 1, 6, 4, 1, 7, 1, 3, 1, 1, 1, 1, 2, 2, 1, 4, 1, 2, 6, 1, 2, 1, 2, 5, 1, 1, 1, 6, 2, 10, 2, 4, 32, 1, 3, 15, 1, 1, 3, 2, 6, 10, 10, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 8, 1, 36, 4, 14, 1, 5, 1, 2, 5, 11, 1, 36, 1, 8, 1, 6, 1, 2, 5, 4, 2, 37, 43, 2, 4, 1, 6, 1, 2, 2, 2, 1, 10, 6, 6, 2, 2, 4, 3, 1, 3, 2, 7, 3, 4, 13, 1, 2, 2, 6, 1, 1, 1, 10, 3, 1, 2, 38, 1, 1, 5, 1, 2, 43, 1, 1, 332, 1, 4, 2, 7, 1, 1, 1, 4, 2, 41, 1, 4, 2, 33, 1, 4, 2, 7, 1, 1, 1, 4, 2, 15, 1, 57, 1, 4, 2, 67, 2, 3, 9, 20, 3, 16, 10, 6, 85, 11, 1, 620, 2, 17, 1, 26, 1, 1, 3, 75, 3, 3, 15, 13, 1, 4, 3, 11, 18, 3, 2, 9, 18, 2, 12, 13, 1, 3, 1, 2, 12, 52, 2, 1, 7, 8, 1, 2, 11, 3, 1, 3, 1, 1, 1, 2, 10, 6, 10, 6, 6, 1, 4, 3, 1, 1, 10, 6, 35, 1, 52, 8, 41, 1, 1, 5, 70, 10, 29, 3, 3, 4, 2, 3, 4, 2, 1, 6, 3, 4, 1, 3, 2, 10, 30, 2, 5, 11, 44, 4, 17, 7, 2, 6, 10, 1, 3, 34, 23, 2, 3, 2, 2, 53, 1, 1, 1, 7, 1, 1, 1, 1, 2, 8, 6, 10, 2, 1, 10, 6, 10, 6, 7, 1, 6, 82, 4, 1, 47, 1, 1, 5, 1, 1, 5, 1, 2, 7, 4, 10, 7, 10, 9, 9, 3, 2, 1, 30, 1, 4, 2, 2, 1, 1, 2, 2, 10, 44, 1, 1, 2, 3, 1, 1, 3, 2, 8, 4, 36, 8, 8, 2, 2, 3, 5, 10, 3, 3, 10, 30, 6, 2, 64, 8, 8, 3, 1, 13, 1, 7, 4, 1, 4, 2, 1, 2, 9, 44, 63, 13, 1, 34, 37, 39, 21, 4, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 9, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 9, 8, 6, 2, 6, 2, 8, 8, 8, 8, 6, 2, 6, 2, 8, 1, 1, 1, 1, 1, 1, 1, 1, 8, 8, 14, 2, 8, 8, 8, 8, 8, 8, 5, 1, 2, 4, 1, 1, 1, 3, 3, 1, 2, 4, 1, 3, 4, 2, 2, 4, 1, 3, 8, 5, 3, 2, 3, 1, 2, 4, 1, 2, 1, 11, 5, 6, 2, 1, 1, 1, 2, 1, 1, 1, 8, 1, 1, 5, 1, 9, 1, 1, 4, 2, 3, 1, 1, 1, 11, 1, 1, 1, 10, 1, 5, 5, 6, 1, 1, 2, 6, 3, 1, 1, 1, 10, 3, 1, 1, 1, 13, 3, 32, 16, 13, 4, 1, 3, 12, 15, 2, 1, 4, 1, 2, 1, 3, 2, 3, 1, 1, 1, 2, 1, 5, 6, 1, 1, 1, 1, 1, 1, 4, 1, 1, 4, 1, 4, 1, 2, 2, 2, 5, 1, 4, 1, 1, 2, 1, 1, 16, 35, 1, 1, 4, 1, 6, 5, 5, 2, 4, 1, 2, 1, 2, 1, 7, 1, 31, 2, 2, 1, 1, 1, 31, 268, 8, 4, 20, 2, 7, 1, 1, 81, 1, 30, 25, 40, 6, 18, 12, 39, 25, 11, 21, 60, 78, 22, 183, 1, 9, 1, 54, 8, 111, 1, 144, 1, 103, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 30, 44, 5, 1, 1, 31, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 16, 256, 131, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 63, 1, 1, 1, 1, 32, 1, 1, 258, 48, 21, 2, 6, 3, 10, 166, 47, 1, 47, 1, 1, 1, 3, 2, 1, 1, 1, 1, 1, 1, 4, 1, 1, 2, 1, 6, 2, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 6, 1, 1, 1, 1, 3, 1, 1, 5, 4, 1, 2, 38, 1, 1, 5, 1, 2, 56, 7, 1, 1, 14, 1, 23, 9, 7, 1, 7, 1, 7, 1, 7, 1, 7, 1, 7, 1, 7, 1, 7, 1, 32, 2, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 9, 1, 2, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 1, 10, 2, 68, 26, 1, 89, 12, 214, 26, 12, 4, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 9, 4, 2, 1, 5, 2, 3, 1, 1, 1, 2, 1, 86, 2, 2, 2, 2, 1, 1, 90, 1, 3, 1, 5, 41, 3, 94, 1, 2, 4, 10, 27, 5, 36, 12, 16, 31, 1, 10, 30, 8, 1, 15, 32, 10, 39, 15, 320, 6582, 10, 64, 20941, 51, 21, 1, 1143, 3, 55, 9, 40, 6, 2, 268, 1, 3, 16, 10, 2, 20, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 1, 10, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 7, 1, 70, 10, 2, 6, 8, 23, 9, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 8, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 12, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 77, 2, 1, 7, 1, 3, 1, 4, 1, 23, 2, 2, 1, 4, 4, 6, 2, 1, 1, 6, 52, 4, 8, 2, 50, 16, 1, 9, 2, 10, 6, 18, 6, 3, 1, 4, 10, 28, 8, 2, 23, 11, 2, 11, 1, 29, 3, 3, 1, 47, 1, 2, 4, 2, 1, 4, 13, 1, 1, 10, 4, 2, 32, 41, 6, 2, 2, 2, 2, 9, 3, 1, 8, 1, 1, 2, 10, 2, 4, 16, 1, 6, 3, 1, 1, 4, 48, 1, 1, 3, 2, 2, 5, 2, 1, 1, 1, 24, 2, 1, 2, 11, 1, 2, 2, 2, 1, 2, 1, 1, 10, 6, 2, 6, 2, 6, 9, 7, 1, 7, 145, 35, 2, 1, 2, 1, 2, 1, 1, 1, 2, 10, 6, 11172, 12, 23, 4, 49, 4, 2048, 6400, 366, 2, 106, 38, 7, 12, 5, 5, 1, 1, 10, 1, 13, 1, 5, 1, 1, 1, 2, 1, 2, 1, 108, 16, 17, 363, 1, 1, 16, 64, 2, 54, 40, 12, 1, 1, 2, 16, 7, 1, 1, 1, 6, 7, 9, 1, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 4, 3, 3, 1, 4, 1, 1, 1, 1, 1, 1, 1, 3, 1, 1, 3, 1, 1, 1, 2, 4, 5, 1, 135, 2, 1, 1, 3, 1, 3, 1, 1, 1, 1, 1, 1, 2, 10, 2, 3, 2, 26, 1, 1, 1, 1, 1, 1, 26, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 10, 1, 45, 2, 31, 3, 6, 2, 6, 2, 6, 2, 3, 3, 2, 1, 1, 1, 2, 1, 1, 4, 2, 10, 3, 2, 2, 12, 1, 26, 1, 19, 1, 2, 1, 15, 2, 14, 34, 123, 5, 3, 4, 45, 3, 9, 53, 4, 17, 1, 5, 12, 52, 45, 1, 130, 29, 3, 49, 47, 31, 1, 4, 12, 17, 1, 8, 1, 53, 30, 1, 1, 36, 4, 8, 1, 5, 42, 40, 40, 78, 2, 10, 854, 6, 2, 1, 1, 44, 1, 2, 3, 1, 2, 23, 1, 1, 8, 160, 22, 6, 3, 1, 26, 5, 1, 64, 56, 6, 2, 64, 1, 3, 1, 2, 5, 4, 4, 1, 3, 1, 27, 4, 3, 4, 1, 8, 8, 9, 7, 29, 2, 1, 128, 54, 3, 7, 22, 2, 8, 19, 5, 8, 128, 73, 535, 31, 385, 1, 1, 1, 53, 15, 7, 4, 20, 10, 16, 2, 1, 45, 3, 4, 2, 2, 2, 1, 4, 14, 25, 7, 10, 6, 3, 36, 5, 1, 8, 1, 10, 4, 60, 2, 1, 48, 3, 9, 2, 4, 4, 7, 10, 1190, 43, 1, 1, 1, 2, 6, 1, 1, 8, 10, 2358, 879, 145, 99, 13, 4, 2956, 1071, 13265, 569, 1223, 69, 11, 1, 46, 16, 4, 13, 16480, 2, 8190, 246, 10, 39, 2, 60, 2, 3, 3, 6, 8, 8, 2, 7, 30, 4, 48, 34, 66, 3, 1, 186, 87, 9, 18, 142, 26, 26, 26, 7, 1, 18, 26, 26, 1, 1, 2, 2, 1, 2, 2, 2, 4, 1, 8, 4, 1, 1, 1, 7, 1, 11, 26, 26, 2, 1, 4, 2, 8, 1, 7, 1, 26, 2, 1, 4, 1, 5, 1, 1, 3, 7, 1, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 28, 2, 25, 1, 25, 1, 6, 25, 1, 25, 1, 6, 25, 1, 25, 1, 6, 25, 1, 25, 1, 6, 25, 1, 25, 1, 6, 1, 1, 2, 50, 5632, 4, 1, 27, 1, 2, 1, 1, 2, 1, 1, 10, 1, 4, 1, 1, 1, 1, 6, 1, 4, 1, 1, 1, 1, 1, 1, 3, 1, 2, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 2, 4, 1, 7, 1, 4, 1, 4, 1, 1, 1, 10, 1, 17, 5, 3, 1, 5, 1, 17, 52, 2, 270, 44, 4, 100, 12, 15, 2, 14, 2, 15, 1, 15, 32, 11, 5, 31, 1, 60, 4, 43, 75, 29, 13, 43, 5, 9, 7, 2, 174, 33, 15, 6, 1, 70, 3, 20, 12, 37, 1, 5, 21, 17, 15, 63, 1, 1, 1, 182, 1, 4, 3, 62, 2, 4, 12, 24, 147, 70, 4, 11, 48, 70, 58, 116, 2188, 42711, 41, 4149, 11, 222, 16354, 542, 722403, 1, 30, 96, 128, 240, 65040, 65534, 2, 65534]));
    $thiz.jl_Character$__f_charTypeIndices = $p_jl_Character$__uncompressDeltas__AI__AI($thiz, deltas);
    $thiz.jl_Character$__f_bitmap$0 = (((2 | $thiz.jl_Character$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.jl_Character$__f_charTypeIndices;
}
function $p_jl_Character$__charTypeIndices__AI($thiz) {
  return (((((2 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Character$__charTypeIndices$lzycompute__AI($thiz) : $thiz.jl_Character$__f_charTypeIndices);
}
function $p_jl_Character$__charTypes$lzycompute__AI($thiz) {
  if (((((4 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Character$__f_charTypes = new $ac_I(new Int32Array([1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 5, 1, 2, 5, 1, 3, 2, 1, 3, 2, 1, 3, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 3, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 5, 2, 4, 27, 4, 27, 4, 27, 4, 27, 4, 27, 6, 1, 2, 1, 2, 4, 27, 1, 2, 0, 4, 2, 24, 0, 27, 1, 24, 1, 0, 1, 0, 1, 2, 1, 0, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 25, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 28, 6, 7, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 0, 1, 0, 4, 24, 0, 2, 0, 24, 20, 0, 26, 0, 6, 20, 6, 24, 6, 24, 6, 24, 6, 0, 5, 0, 5, 24, 0, 16, 0, 25, 24, 26, 24, 28, 6, 24, 0, 24, 5, 4, 5, 6, 9, 24, 5, 6, 5, 24, 5, 6, 16, 28, 6, 4, 6, 28, 6, 5, 9, 5, 28, 5, 24, 0, 16, 5, 6, 5, 6, 0, 5, 6, 5, 0, 9, 5, 6, 4, 28, 24, 4, 0, 5, 6, 4, 6, 4, 6, 4, 6, 0, 24, 0, 5, 6, 0, 24, 0, 5, 0, 5, 0, 6, 0, 6, 8, 5, 6, 8, 6, 5, 8, 6, 8, 6, 8, 5, 6, 5, 6, 24, 9, 24, 4, 5, 0, 5, 0, 6, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 5, 8, 6, 0, 8, 0, 8, 6, 5, 0, 8, 0, 5, 0, 5, 6, 0, 9, 5, 26, 11, 28, 26, 0, 6, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 0, 8, 6, 0, 6, 0, 6, 0, 6, 0, 5, 0, 5, 0, 9, 6, 5, 6, 0, 6, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 5, 8, 6, 0, 6, 8, 0, 8, 6, 0, 5, 0, 5, 6, 0, 9, 24, 26, 0, 6, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 5, 8, 6, 8, 6, 0, 8, 0, 8, 6, 0, 6, 8, 0, 5, 0, 5, 6, 0, 9, 28, 5, 11, 0, 6, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 8, 6, 8, 0, 8, 0, 8, 6, 0, 5, 0, 8, 0, 9, 11, 28, 26, 28, 0, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 6, 8, 0, 6, 0, 6, 0, 6, 0, 5, 0, 5, 6, 0, 9, 0, 11, 28, 0, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 5, 8, 6, 8, 0, 6, 8, 0, 8, 6, 0, 8, 0, 5, 0, 5, 6, 0, 9, 0, 5, 0, 8, 0, 5, 0, 5, 0, 5, 0, 5, 8, 6, 0, 8, 0, 8, 6, 5, 0, 8, 0, 5, 6, 0, 9, 11, 0, 28, 5, 0, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 0, 8, 6, 0, 6, 0, 8, 0, 8, 24, 0, 5, 6, 5, 6, 0, 26, 5, 4, 6, 24, 9, 24, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 6, 5, 6, 0, 6, 5, 0, 5, 0, 4, 0, 6, 0, 9, 0, 5, 0, 5, 28, 24, 28, 24, 28, 6, 28, 9, 11, 28, 6, 28, 6, 28, 6, 21, 22, 21, 22, 8, 5, 0, 5, 0, 6, 8, 6, 24, 6, 5, 6, 0, 6, 0, 28, 6, 28, 0, 28, 24, 28, 24, 0, 5, 8, 6, 8, 6, 8, 6, 8, 6, 5, 9, 24, 5, 8, 6, 5, 6, 5, 8, 5, 8, 5, 6, 5, 6, 8, 6, 8, 6, 5, 8, 9, 8, 6, 28, 1, 0, 1, 0, 1, 0, 5, 24, 4, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 24, 11, 0, 5, 28, 0, 5, 0, 20, 5, 24, 5, 12, 5, 21, 22, 0, 5, 24, 10, 0, 5, 0, 5, 6, 0, 5, 6, 24, 0, 5, 6, 0, 5, 0, 5, 0, 6, 0, 5, 6, 8, 6, 8, 6, 8, 6, 24, 4, 24, 26, 5, 6, 0, 9, 0, 11, 0, 24, 20, 24, 6, 12, 0, 9, 0, 5, 4, 5, 0, 5, 6, 5, 0, 5, 0, 5, 0, 6, 8, 6, 8, 0, 8, 6, 8, 6, 0, 28, 0, 24, 9, 5, 0, 5, 0, 5, 0, 8, 5, 8, 0, 9, 11, 0, 28, 5, 6, 8, 0, 24, 5, 8, 6, 8, 6, 0, 6, 8, 6, 8, 6, 8, 6, 0, 6, 9, 0, 9, 0, 24, 4, 24, 0, 6, 8, 5, 6, 8, 6, 8, 6, 8, 6, 8, 5, 0, 9, 24, 28, 6, 28, 0, 6, 8, 5, 8, 6, 8, 6, 8, 6, 8, 5, 9, 5, 6, 8, 6, 8, 6, 8, 6, 8, 0, 24, 5, 8, 6, 8, 6, 0, 24, 9, 0, 5, 9, 5, 4, 24, 0, 24, 0, 6, 24, 6, 8, 6, 5, 6, 5, 8, 6, 5, 0, 2, 4, 2, 4, 2, 4, 6, 0, 6, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 0, 1, 0, 2, 1, 2, 1, 2, 0, 1, 0, 2, 0, 1, 0, 1, 0, 1, 0, 1, 2, 1, 2, 0, 2, 3, 2, 3, 2, 3, 2, 0, 2, 1, 3, 27, 2, 27, 2, 0, 2, 1, 3, 27, 2, 0, 2, 1, 0, 27, 2, 1, 27, 0, 2, 0, 2, 1, 3, 27, 0, 12, 16, 20, 24, 29, 30, 21, 29, 30, 21, 29, 24, 13, 14, 16, 12, 24, 29, 30, 24, 23, 24, 25, 21, 22, 24, 25, 24, 23, 24, 12, 16, 0, 16, 11, 4, 0, 11, 25, 21, 22, 4, 11, 25, 21, 22, 0, 4, 0, 26, 0, 6, 7, 6, 7, 6, 0, 28, 1, 28, 1, 28, 2, 1, 2, 1, 2, 28, 1, 28, 25, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 2, 1, 2, 5, 2, 28, 2, 1, 25, 1, 2, 28, 25, 28, 2, 28, 11, 10, 1, 2, 10, 11, 0, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 21, 22, 28, 25, 28, 25, 28, 25, 28, 0, 28, 0, 28, 0, 11, 28, 11, 28, 25, 28, 25, 28, 25, 28, 25, 28, 0, 28, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 11, 28, 25, 21, 22, 25, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 25, 28, 25, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 25, 21, 22, 21, 22, 25, 21, 22, 25, 28, 25, 28, 25, 0, 28, 0, 1, 0, 2, 0, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 4, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 28, 1, 2, 1, 2, 6, 1, 2, 0, 24, 11, 24, 2, 0, 2, 0, 2, 0, 5, 0, 4, 24, 0, 6, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 24, 29, 30, 29, 30, 24, 29, 30, 24, 29, 30, 24, 20, 24, 20, 24, 29, 30, 24, 29, 30, 21, 22, 21, 22, 21, 22, 21, 22, 24, 4, 24, 20, 0, 28, 0, 28, 0, 28, 0, 28, 0, 12, 24, 28, 4, 5, 10, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 28, 21, 22, 21, 22, 21, 22, 21, 22, 20, 21, 22, 28, 10, 6, 8, 20, 4, 28, 10, 4, 5, 24, 28, 0, 5, 0, 6, 27, 4, 5, 20, 5, 24, 4, 5, 0, 5, 0, 5, 0, 28, 11, 28, 5, 0, 28, 0, 5, 28, 0, 11, 28, 11, 28, 11, 28, 11, 28, 11, 28, 5, 0, 28, 5, 0, 5, 4, 5, 0, 28, 0, 5, 4, 24, 5, 4, 24, 5, 9, 5, 0, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 5, 6, 7, 24, 6, 24, 4, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 0, 6, 5, 10, 6, 24, 0, 27, 4, 27, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 4, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 4, 27, 1, 2, 1, 2, 0, 1, 2, 1, 2, 0, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 0, 4, 2, 5, 6, 5, 6, 5, 6, 5, 8, 6, 8, 28, 0, 11, 28, 26, 28, 0, 5, 24, 0, 8, 5, 8, 6, 0, 24, 9, 0, 6, 5, 24, 5, 0, 9, 5, 6, 24, 5, 6, 8, 0, 24, 5, 0, 6, 8, 5, 6, 8, 6, 8, 6, 8, 24, 0, 4, 9, 0, 24, 0, 5, 6, 8, 6, 8, 6, 0, 5, 6, 5, 6, 8, 0, 9, 0, 24, 5, 4, 5, 28, 5, 8, 0, 5, 6, 5, 6, 5, 6, 5, 6, 5, 6, 5, 0, 5, 4, 24, 5, 8, 6, 8, 24, 5, 4, 8, 6, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 8, 6, 8, 6, 8, 24, 8, 6, 0, 9, 0, 5, 0, 5, 0, 5, 0, 19, 18, 5, 0, 5, 0, 2, 0, 2, 0, 5, 6, 5, 25, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 27, 0, 5, 21, 22, 0, 5, 0, 5, 0, 5, 26, 28, 0, 6, 24, 21, 22, 24, 0, 6, 0, 24, 20, 23, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 24, 21, 22, 24, 23, 24, 0, 24, 20, 21, 22, 21, 22, 21, 22, 24, 25, 20, 25, 0, 24, 26, 24, 0, 5, 0, 5, 0, 16, 0, 24, 26, 24, 21, 22, 24, 25, 24, 20, 24, 9, 24, 25, 24, 1, 21, 24, 22, 27, 23, 27, 2, 21, 25, 22, 25, 21, 22, 24, 21, 22, 24, 5, 4, 5, 4, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 26, 25, 27, 28, 26, 0, 28, 25, 28, 0, 16, 28, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 24, 0, 11, 0, 28, 10, 11, 28, 11, 0, 28, 0, 28, 6, 0, 5, 0, 5, 0, 5, 0, 11, 0, 5, 10, 5, 10, 0, 5, 0, 24, 5, 0, 5, 24, 10, 0, 1, 2, 5, 0, 9, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 24, 11, 0, 5, 11, 0, 24, 5, 0, 24, 0, 5, 0, 5, 0, 5, 6, 0, 6, 0, 6, 5, 0, 5, 0, 5, 0, 6, 0, 6, 11, 0, 24, 0, 5, 11, 24, 0, 5, 0, 24, 5, 0, 11, 5, 0, 11, 0, 5, 0, 11, 0, 8, 6, 8, 5, 6, 24, 0, 11, 9, 0, 6, 8, 5, 8, 6, 8, 6, 24, 16, 24, 0, 5, 0, 9, 0, 6, 5, 6, 8, 6, 0, 9, 24, 0, 6, 8, 5, 8, 6, 8, 5, 24, 0, 9, 0, 5, 6, 8, 6, 8, 6, 8, 6, 0, 9, 0, 5, 0, 10, 0, 24, 0, 5, 0, 5, 0, 5, 0, 5, 8, 0, 6, 4, 0, 5, 0, 28, 0, 28, 0, 28, 8, 6, 28, 8, 16, 6, 28, 6, 28, 6, 28, 0, 28, 6, 28, 0, 28, 0, 11, 0, 1, 2, 1, 2, 0, 2, 1, 2, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 2, 0, 2, 0, 2, 0, 2, 1, 2, 1, 0, 1, 0, 1, 0, 1, 0, 2, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 0, 1, 25, 2, 25, 2, 1, 25, 2, 25, 2, 1, 25, 2, 25, 2, 1, 25, 2, 25, 2, 1, 25, 2, 25, 2, 1, 2, 0, 9, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 25, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 11, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 5, 0, 5, 0, 5, 0, 5, 0, 16, 0, 16, 0, 6, 0, 18, 0, 18, 0]));
    $thiz.jl_Character$__f_bitmap$0 = (((4 | $thiz.jl_Character$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.jl_Character$__f_charTypes;
}
function $p_jl_Character$__charTypes__AI($thiz) {
  return (((((4 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Character$__charTypes$lzycompute__AI($thiz) : $thiz.jl_Character$__f_charTypes);
}
function $p_jl_Character$__uncompressDeltas__AI__AI($thiz, deltas) {
  var acc = $n(deltas).get(0);
  var i = 1;
  var len = $n(deltas).u.length;
  while ((i !== len)) {
    acc = ((acc + $n(deltas).get(i)) | 0);
    $n(deltas).set(i, acc);
    i = ((1 + i) | 0);
  }
  return deltas;
}
function $p_jl_Character$__findIndexOfRange__AI__I__Z__I($thiz, startOfRangesArray, value, hasEmptyRanges) {
  var i = $m_ju_Arrays$().binarySearch__AI__I__I(startOfRangesArray, value);
  if ((i >= 0)) {
    if (hasEmptyRanges) {
      var j = ((1 + i) | 0);
      while (((j < $n(startOfRangesArray).u.length) && ($n(startOfRangesArray).get(j) === value))) {
        j = ((1 + j) | 0);
      }
      return j;
    } else {
      return ((1 + i) | 0);
    }
  } else {
    return (((-1) - i) | 0);
  }
}
function $p_jl_Character$__nonASCIIZeroDigitCodePoints$lzycompute__AI($thiz) {
  if (((((32 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Character$__f_nonASCIIZeroDigitCodePoints = new $ac_I(new Int32Array([1632, 1776, 1984, 2406, 2534, 2662, 2790, 2918, 3046, 3174, 3302, 3430, 3664, 3792, 3872, 4160, 4240, 6112, 6160, 6470, 6608, 6784, 6800, 6992, 7088, 7232, 7248, 42528, 43216, 43264, 43472, 43600, 44016, 65296, 66720, 69734, 69872, 69942, 70096, 71360, 120782, 120792, 120802, 120812, 120822]));
    $thiz.jl_Character$__f_bitmap$0 = (((32 | $thiz.jl_Character$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.jl_Character$__f_nonASCIIZeroDigitCodePoints;
}
function $p_jl_Character$__nonASCIIZeroDigitCodePoints__AI($thiz) {
  return (((((32 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Character$__nonASCIIZeroDigitCodePoints$lzycompute__AI($thiz) : $thiz.jl_Character$__f_nonASCIIZeroDigitCodePoints);
}
function $p_jl_Character$__isSeparator$1__I__Z($thiz, tpe) {
  return (((tpe === 12) || (tpe === 13)) || (tpe === 14));
}
/** @constructor */
function $c_jl_Character$() {
  this.jl_Character$__f_java$lang$Character$$charTypesFirst256 = null;
  this.jl_Character$__f_charTypeIndices = null;
  this.jl_Character$__f_charTypes = null;
  this.jl_Character$__f_nonASCIIZeroDigitCodePoints = null;
  this.jl_Character$__f_bitmap$0 = 0;
}
$c_jl_Character$.prototype = new $h_O();
$c_jl_Character$.prototype.constructor = $c_jl_Character$;
/** @constructor */
function $h_jl_Character$() {
}
$h_jl_Character$.prototype = $c_jl_Character$.prototype;
$c_jl_Character$.prototype.toString__I__T = (function(codePoint) {
  if (((codePoint >= 0) && (codePoint < 65536))) {
    return $as_T(String.fromCharCode(codePoint));
  } else if (((codePoint >= 0) && (codePoint <= 1114111))) {
    return $as_T(String.fromCharCode((65535 & (55296 | (((-64) + (codePoint >> 10)) | 0))), (65535 & (56320 | (1023 & codePoint)))));
  } else {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
});
$c_jl_Character$.prototype.getType__I__I = (function(codePoint) {
  return ((codePoint < 0) ? 0 : ((codePoint < 256) ? $n(this.java$lang$Character$$charTypesFirst256__AI()).get(codePoint) : $p_jl_Character$__getTypeGE256__I__I(this, codePoint)));
});
$c_jl_Character$.prototype.digitWithValidRadix__I__I__I = (function(codePoint, radix) {
  if ((codePoint < 256)) {
    var value = (((codePoint >= 48) && (codePoint <= 57)) ? (((-48) + codePoint) | 0) : (((codePoint >= 65) && (codePoint <= 90)) ? (((-55) + codePoint) | 0) : (((codePoint >= 97) && (codePoint <= 122)) ? (((-87) + codePoint) | 0) : (-1))));
  } else if (((codePoint >= 65313) && (codePoint <= 65338))) {
    var value = (((-65303) + codePoint) | 0);
  } else if (((codePoint >= 65345) && (codePoint <= 65370))) {
    var value = (((-65335) + codePoint) | 0);
  } else {
    var p = $m_ju_Arrays$().binarySearch__AI__I__I($p_jl_Character$__nonASCIIZeroDigitCodePoints__AI(this), codePoint);
    var zeroCodePointIndex = ((p < 0) ? (((-2) - p) | 0) : p);
    if ((zeroCodePointIndex < 0)) {
      var value = (-1);
    } else {
      var v = ((codePoint - $n($p_jl_Character$__nonASCIIZeroDigitCodePoints__AI(this)).get(zeroCodePointIndex)) | 0);
      var value = ((v > 9) ? (-1) : v);
    }
  }
  return ((value < radix) ? value : (-1));
});
$c_jl_Character$.prototype.isZeroDigit__C__Z = (function(ch) {
  return ((ch < 256) ? (ch === 48) : ($m_ju_Arrays$().binarySearch__AI__I__I($p_jl_Character$__nonASCIIZeroDigitCodePoints__AI(this), ch) >= 0));
});
$c_jl_Character$.prototype.forDigit__I__I__C = (function(digit, radix) {
  if (((((radix < 2) || (radix > 36)) || (digit < 0)) || (digit >= radix))) {
    return 0;
  } else {
    var overBaseTen = (((-10) + digit) | 0);
    var result = ((overBaseTen < 0) ? ((48 + digit) | 0) : ((97 + overBaseTen) | 0));
    return (65535 & result);
  }
});
$c_jl_Character$.prototype.isWhitespace__I__Z = (function(codePoint) {
  return ((codePoint < 256) ? (((((((codePoint === 9) || (codePoint === 10)) || (codePoint === 11)) || (codePoint === 12)) || (codePoint === 13)) || ((codePoint >= 28) && (codePoint <= 31))) || ((codePoint !== 160) && $p_jl_Character$__isSeparator$1__I__Z(this, $n(this.java$lang$Character$$charTypesFirst256__AI()).get(codePoint)))) : (((codePoint !== 8199) && (codePoint !== 8239)) && $p_jl_Character$__isSeparator$1__I__Z(this, $p_jl_Character$__getTypeGE256__I__I(this, codePoint))));
});
$c_jl_Character$.prototype.isDigit__I__Z = (function(cp) {
  if ((cp < 256)) {
    return ((cp >= 48) && (cp <= 57));
  } else {
    var tpe = $p_jl_Character$__getTypeGE256__I__I(this, cp);
    return (tpe === 9);
  }
});
$c_jl_Character$.prototype.isLetter__I__Z = (function(cp) {
  var tpe = this.getType__I__I(cp);
  return (((((tpe === 1) || (tpe === 2)) || (tpe === 3)) || (tpe === 4)) || (tpe === 5));
});
$c_jl_Character$.prototype.toUpperCase__C__C = (function(ch) {
  return (65535 & this.toUpperCase__I__I(ch));
});
$c_jl_Character$.prototype.toUpperCase__I__I = (function(codePoint) {
  switch (codePoint) {
    case 8115:
    case 8131:
    case 8179: {
      return ((9 + codePoint) | 0);
      break;
    }
    default: {
      if (((codePoint >= 8064) && (codePoint <= 8111))) {
        return (8 | codePoint);
      } else {
        var this$1 = $n(this.toString__I__T(codePoint));
        var upperChars = $as_T(this$1.toUpperCase());
        var this$2 = $n(upperChars);
        var x1$2 = this$2.length;
        switch (x1$2) {
          case 1: {
            var this$3 = $n(upperChars);
            return $charAt(this$3, 0);
            break;
          }
          case 2: {
            var this$4 = $n(upperChars);
            var high = $charAt(this$4, 0);
            var this$5 = $n(upperChars);
            var low = $charAt(this$5, 1);
            return ((((-67044352) & ((high << 16) | low)) === (-671032320)) ? ((((64 + (1023 & high)) | 0) << 10) | (1023 & low)) : codePoint);
            break;
          }
          default: {
            return codePoint;
          }
        }
      }
    }
  }
});
$c_jl_Character$.prototype.toLowerCase__C__C = (function(ch) {
  return (65535 & this.toLowerCase__I__I(ch));
});
$c_jl_Character$.prototype.toLowerCase__I__I = (function(codePoint) {
  if ((codePoint === 304)) {
    return 105;
  } else {
    var this$1 = $n(this.toString__I__T(codePoint));
    var lowerChars = $as_T(this$1.toLowerCase());
    var this$2 = $n(lowerChars);
    var x1$2 = this$2.length;
    switch (x1$2) {
      case 1: {
        var this$3 = $n(lowerChars);
        return $charAt(this$3, 0);
        break;
      }
      case 2: {
        var this$4 = $n(lowerChars);
        var high = $charAt(this$4, 0);
        var this$5 = $n(lowerChars);
        var low = $charAt(this$5, 1);
        return ((((-67044352) & ((high << 16) | low)) === (-671032320)) ? ((((64 + (1023 & high)) | 0) << 10) | (1023 & low)) : codePoint);
        break;
      }
      default: {
        return codePoint;
      }
    }
  }
});
$c_jl_Character$.prototype.java$lang$Character$$charTypesFirst256__AI = (function() {
  return (((((1 & this.jl_Character$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Character$__java$lang$Character$$charTypesFirst256$lzycompute__AI(this) : this.jl_Character$__f_java$lang$Character$$charTypesFirst256);
});
var $d_jl_Character$ = new $TypeData().initClass($c_jl_Character$, "java.lang.Character$", ({
  jl_Character$: 1,
  Ljava_io_Serializable: 1
}));
var $n_jl_Character$;
function $m_jl_Character$() {
  if ((!$n_jl_Character$)) {
    $n_jl_Character$ = new $c_jl_Character$();
  }
  return $n_jl_Character$;
}
function $p_jl_Double$__doubleStrPat$lzycompute__O($thiz) {
  if (((((1 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Double$__f_doubleStrPat = new RegExp("^[\\x00-\\x20]*([+-]?(?:NaN|Infinity|(?:\\d+\\.?\\d*|\\.\\d+)(?:[eE][+-]?\\d+)?)[fFdD]?)[\\x00-\\x20]*$");
    $thiz.jl_Double$__f_bitmap$0 = (((1 | $thiz.jl_Double$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.jl_Double$__f_doubleStrPat;
}
function $p_jl_Double$__doubleStrPat__O($thiz) {
  return (((((1 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Double$__doubleStrPat$lzycompute__O($thiz) : $thiz.jl_Double$__f_doubleStrPat);
}
function $p_jl_Double$__doubleStrHexPat$lzycompute__O($thiz) {
  if (((((2 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Double$__f_doubleStrHexPat = new RegExp("^[\\x00-\\x20]*([+-]?)0[xX]([0-9A-Fa-f]*)\\.?([0-9A-Fa-f]*)[pP]([+-]?\\d+)[fFdD]?[\\x00-\\x20]*$");
    $thiz.jl_Double$__f_bitmap$0 = (((2 | $thiz.jl_Double$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.jl_Double$__f_doubleStrHexPat;
}
function $p_jl_Double$__doubleStrHexPat__O($thiz) {
  return (((((2 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Double$__doubleStrHexPat$lzycompute__O($thiz) : $thiz.jl_Double$__f_doubleStrHexPat);
}
function $p_jl_Double$__parseDoubleSlowPath__T__D($thiz, s) {
  var groups = $p_jl_Double$__doubleStrHexPat__O($thiz).exec(s);
  if ((groups === null)) {
    $p_jl_Double$__fail$1__T__E($thiz, s);
  }
  var x = groups[1];
  var signStr = $as_T(x);
  var x$1 = groups[2];
  var integralPartStr = $as_T(x$1);
  var x$2 = groups[3];
  var fractionalPartStr = $as_T(x$2);
  var x$3 = groups[4];
  var binaryExpStr = $as_T(x$3);
  if (((integralPartStr === "") && (fractionalPartStr === ""))) {
    $p_jl_Double$__fail$1__T__E($thiz, s);
  }
  var absResult = $thiz.parseHexDoubleImpl__T__T__T__I__D(integralPartStr, fractionalPartStr, binaryExpStr, 15);
  return ((signStr === "-") ? (-absResult) : absResult);
}
function $p_jl_Double$__fail$1__T__E($thiz, s$1) {
  throw new $c_jl_NumberFormatException((("For input string: \"" + s$1) + "\""));
}
/** @constructor */
function $c_jl_Double$() {
  this.jl_Double$__f_doubleStrPat = null;
  this.jl_Double$__f_doubleStrHexPat = null;
  this.jl_Double$__f_bitmap$0 = 0;
}
$c_jl_Double$.prototype = new $h_O();
$c_jl_Double$.prototype.constructor = $c_jl_Double$;
/** @constructor */
function $h_jl_Double$() {
}
$h_jl_Double$.prototype = $c_jl_Double$.prototype;
$c_jl_Double$.prototype.parseDouble__T__D = (function(s) {
  var groups = $p_jl_Double$__doubleStrPat__O(this).exec(s);
  if ((groups !== null)) {
    var $x_2 = parseFloat;
    var x = groups[1];
    var $x_1 = $x_2($as_T(x));
    return $uD($x_1);
  } else {
    return $p_jl_Double$__parseDoubleSlowPath__T__D(this, s);
  }
});
$c_jl_Double$.prototype.parseHexDoubleImpl__T__T__T__I__D = (function(integralPartStr, fractionalPartStr, binaryExpStr, maxPrecisionChars) {
  var mantissaStr0 = (("" + integralPartStr) + fractionalPartStr);
  var this$1 = $n(fractionalPartStr);
  var correction1 = ((-(this$1.length << 2)) | 0);
  var i = 0;
  while (true) {
    if ((i !== mantissaStr0.length)) {
      var index = i;
      var $x_1 = ($charAt(mantissaStr0, index) === 48);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      i = ((1 + i) | 0);
    } else {
      break;
    }
  }
  var beginIndex = i;
  if (((beginIndex < 0) || (beginIndex > mantissaStr0.length))) {
    $charAt(mantissaStr0, beginIndex);
  }
  var mantissaStr = $as_T(mantissaStr0.substring(beginIndex));
  if ((mantissaStr === "")) {
    return 0.0;
  }
  var this$2 = $n(mantissaStr);
  var mantissaStrLen = this$2.length;
  var needsCorrection2 = (mantissaStrLen > maxPrecisionChars);
  if (needsCorrection2) {
    var hasNonZeroChar = false;
    var j = maxPrecisionChars;
    while (((!hasNonZeroChar) && (j !== mantissaStrLen))) {
      var this$3 = $n(mantissaStr);
      var index$1 = j;
      if (($charAt(this$3, index$1) !== 48)) {
        hasNonZeroChar = true;
      }
      j = ((1 + j) | 0);
    }
    var compressedTail = (hasNonZeroChar ? "1" : "0");
    var this$4 = $n(mantissaStr);
    if ((maxPrecisionChars > this$4.length)) {
      $charAt(this$4, maxPrecisionChars);
    }
    if ((maxPrecisionChars < 0)) {
      $charAt(this$4, (-1));
    }
    var truncatedMantissaStr = ($as_T(this$4.substring(0, maxPrecisionChars)) + compressedTail);
  } else {
    var truncatedMantissaStr = mantissaStr;
  }
  if (needsCorrection2) {
    var this$5 = $n(mantissaStr);
    var correction2 = (((this$5.length - ((1 + maxPrecisionChars) | 0)) | 0) << 2);
  } else {
    var correction2 = 0;
  }
  var fullCorrection = ((correction1 + correction2) | 0);
  var mantissa = $uD(parseInt(truncatedMantissaStr, 16));
  var binaryExpDouble = $uD(parseInt(binaryExpStr, 10));
  var binaryExp = $doubleToInt(binaryExpDouble);
  var binExpAndCorrection = ((binaryExp + fullCorrection) | 0);
  var binExpAndCorrection_div_3 = ((binExpAndCorrection / 3) | 0);
  var b = binExpAndCorrection_div_3;
  var correctingPow = $uD(Math.pow(2.0, b));
  var b$1 = ((binExpAndCorrection - (binExpAndCorrection_div_3 << 1)) | 0);
  var correctingPow3 = $uD(Math.pow(2.0, b$1));
  return (((mantissa * correctingPow) * correctingPow) * correctingPow3);
});
$c_jl_Double$.prototype.compare__D__D__I = (function(a, b) {
  if ((a !== a)) {
    return ((b !== b) ? 0 : 1);
  } else if ((b !== b)) {
    return (-1);
  } else if ((a === b)) {
    if ((a === 0.0)) {
      var ainf = (1.0 / a);
      return ((ainf === (1.0 / b)) ? 0 : ((ainf < 0.0) ? (-1) : 1));
    } else {
      return 0;
    }
  } else {
    return ((a < b) ? (-1) : 1);
  }
});
var $d_jl_Double$ = new $TypeData().initClass($c_jl_Double$, "java.lang.Double$", ({
  jl_Double$: 1,
  Ljava_io_Serializable: 1
}));
var $n_jl_Double$;
function $m_jl_Double$() {
  if ((!$n_jl_Double$)) {
    $n_jl_Double$ = new $c_jl_Double$();
  }
  return $n_jl_Double$;
}
function $p_jl_Float$__parseFloatRegExp$lzycompute__O($thiz) {
  if ((!$thiz.jl_Float$__f_bitmap$0)) {
    $thiz.jl_Float$__f_parseFloatRegExp = new RegExp("^[\\x00-\\x20]*([+-]?)(?:(NaN)|(Infinity)|(?:((?:(\\d+)(?:\\.(\\d*))?|\\.(\\d+))(?:[eE]([+-]?\\d+))?)|(0[xX](?:([0-9A-Fa-f]+)(?:\\.([0-9A-Fa-f]*))?|\\.([0-9A-Fa-f]+))[pP]([+-]?\\d+)))[fFdD]?)[\\x00-\\x20]*$");
    $thiz.jl_Float$__f_bitmap$0 = true;
  }
  return $thiz.jl_Float$__f_parseFloatRegExp;
}
function $p_jl_Float$__parseFloatRegExp__O($thiz) {
  return ((!$thiz.jl_Float$__f_bitmap$0) ? $p_jl_Float$__parseFloatRegExp$lzycompute__O($thiz) : $thiz.jl_Float$__f_parseFloatRegExp);
}
function $p_jl_Float$__parseFloatDecimal__T__T__T__T__F($thiz, fullNumberStr, integralPartStr, fractionalPartStr, exponentStr) {
  var z0 = $uD(parseFloat(fullNumberStr));
  var z = Math.fround(z0);
  var zDouble = z;
  if ((zDouble === z0)) {
    return z;
  } else if ((zDouble === Infinity)) {
    return ((z0 === 3.4028235677973366E38) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, 3.4028234663852886E38, z, 3.4028235677973366E38) : z);
  } else if ((zDouble < z0)) {
    var zUp = $m_jl_Math$().nextUp__F__F(z);
    var mid$2 = ((zDouble + zUp) / 2.0);
    return ((z0 === mid$2) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, z, zUp, mid$2) : z);
  } else {
    var zDown = $m_jl_Math$().nextDown__F__F(z);
    var mid$3 = ((zDouble + zDown) / 2.0);
    return ((z0 === mid$3) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, zDown, z, mid$3) : z);
  }
}
function $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, zDown, zUp, mid) {
  var f = $ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), (("" + integralPartStr) + fractionalPartStr));
  var this$1 = $m_jl_Integer$();
  var $x_1 = this$1.parseInt__T__I__I(exponentStr, 10);
  var this$2 = $n(fractionalPartStr);
  var e = (($x_1 - this$2.length) | 0);
  var t = $m_jl_FloatingPointBits$().doubleToLongBits__D__J(mid);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var lo$1 = (hi >> 20);
  if ((lo$1 === 0)) {
    throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), ("parseFloatCorrection was given a subnormal mid: " + mid));
  }
  var hi$2 = (1048575 & hi);
  var $x_2 = $m_Ljava_math_BigInteger$();
  var hi$3 = (1048576 | hi$2);
  var m = $n($x_2).valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi$3));
  var k = (((-1075) + lo$1) | 0);
  if ((e >= 0)) {
    if ((k >= 0)) {
      var x = f.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN).pow__I__Ljava_math_BigInteger(e));
      var y = $n(m).shiftLeft__I__Ljava_math_BigInteger(k);
      var cmp = $n(x).compareTo__Ljava_math_BigInteger__I(y);
    } else {
      var v = f.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN).pow__I__Ljava_math_BigInteger(e));
      var e$1 = ((-k) | 0);
      var x$1 = $n(v).shiftLeft__I__Ljava_math_BigInteger(e$1);
      var cmp = $n(x$1).compareTo__Ljava_math_BigInteger__I(m);
    }
  } else if ((k >= 0)) {
    var e$2 = ((-e) | 0);
    var v$1 = $n(m).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN).pow__I__Ljava_math_BigInteger(e$2));
    var y$1 = $n(v$1).shiftLeft__I__Ljava_math_BigInteger(k);
    var cmp = f.compareTo__Ljava_math_BigInteger__I(y$1);
  } else {
    var e$3 = ((-k) | 0);
    var x$2 = f.shiftLeft__I__Ljava_math_BigInteger(e$3);
    var e$4 = ((-e) | 0);
    var y$2 = $n(m).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN).pow__I__Ljava_math_BigInteger(e$4));
    var cmp = $n(x$2).compareTo__Ljava_math_BigInteger__I(y$2);
  }
  return ((cmp < 0) ? zDown : ((cmp > 0) ? zUp : (((1 & $m_jl_FloatingPointBits$().floatToIntBits__F__I(zDown)) === 0) ? zDown : zUp)));
}
function $p_jl_Float$__parseFloatHexadecimal__T__T__T__F($thiz, integralPartStr, fractionalPartStr, binaryExpStr) {
  var doubleValue = $m_jl_Double$().parseHexDoubleImpl__T__T__T__I__D(integralPartStr, fractionalPartStr, binaryExpStr, 7);
  return Math.fround(doubleValue);
}
/** @constructor */
function $c_jl_Float$() {
  this.jl_Float$__f_parseFloatRegExp = null;
  this.jl_Float$__f_bitmap$0 = false;
}
$c_jl_Float$.prototype = new $h_O();
$c_jl_Float$.prototype.constructor = $c_jl_Float$;
/** @constructor */
function $h_jl_Float$() {
}
$h_jl_Float$.prototype = $c_jl_Float$.prototype;
$c_jl_Float$.prototype.parseFloat__T__F = (function(s) {
  var groups = $p_jl_Float$__parseFloatRegExp__O(this).exec(s);
  if ((groups === null)) {
    throw new $c_jl_NumberFormatException((("For input string: \"" + s) + "\""));
  }
  var x = groups[2];
  if ((x !== (void 0))) {
    var absResult = (NaN);
  } else {
    var x$1 = groups[3];
    if ((x$1 !== (void 0))) {
      var absResult = Infinity;
    } else {
      var x$2 = groups[4];
      if ((x$2 !== (void 0))) {
        var x$3 = groups[4];
        var fullNumberStr = $as_T(x$3);
        var x$4 = groups[5];
        var integralPartStr = $as_T(((x$4 !== (void 0)) ? x$4 : ""));
        var x$5 = groups[6];
        var $x_1 = $as_T(((x$5 !== (void 0)) ? x$5 : ""));
        var x$6 = groups[7];
        var fractionalPartStr = (("" + $x_1) + ((x$6 !== (void 0)) ? x$6 : ""));
        var x$7 = groups[8];
        var exponentStr = $as_T(((x$7 !== (void 0)) ? x$7 : "0"));
        var absResult = $p_jl_Float$__parseFloatDecimal__T__T__T__T__F(this, fullNumberStr, integralPartStr, fractionalPartStr, exponentStr);
      } else {
        var x$8 = groups[10];
        var integralPartStr$2 = $as_T(((x$8 !== (void 0)) ? x$8 : ""));
        var x$9 = groups[11];
        var $x_2 = $as_T(((x$9 !== (void 0)) ? x$9 : ""));
        var x$10 = groups[12];
        var fractionalPartStr$2 = (("" + $x_2) + ((x$10 !== (void 0)) ? x$10 : ""));
        var x$11 = groups[13];
        var binaryExpStr = $as_T(x$11);
        var absResult = $p_jl_Float$__parseFloatHexadecimal__T__T__T__F(this, integralPartStr$2, fractionalPartStr$2, binaryExpStr);
      }
    }
  }
  var x$12 = groups[1];
  var signStr = $as_T(x$12);
  return ((signStr === "-") ? Math.fround((-absResult)) : absResult);
});
var $d_jl_Float$ = new $TypeData().initClass($c_jl_Float$, "java.lang.Float$", ({
  jl_Float$: 1,
  Ljava_io_Serializable: 1
}));
var $n_jl_Float$;
function $m_jl_Float$() {
  if ((!$n_jl_Float$)) {
    $n_jl_Float$ = new $c_jl_Float$();
  }
  return $n_jl_Float$;
}
function $p_jl_Integer$__fail$1__T__E($thiz, s$1) {
  throw new $c_jl_NumberFormatException((("For input string: \"" + s$1) + "\""));
}
/** @constructor */
function $c_jl_Integer$() {
}
$c_jl_Integer$.prototype = new $h_O();
$c_jl_Integer$.prototype.constructor = $c_jl_Integer$;
/** @constructor */
function $h_jl_Integer$() {
}
$h_jl_Integer$.prototype = $c_jl_Integer$.prototype;
$c_jl_Integer$.prototype.parseInt__T__I__I = (function(s, radix) {
  if ((s === null)) {
    var len = 0;
  } else {
    var this$1 = $n(s);
    var len = this$1.length;
  }
  if ((((len === 0) || (radix < 2)) || (radix > 36))) {
    $p_jl_Integer$__fail$1__T__E(this, s);
  }
  var this$2 = $n(s);
  var firstChar = $charAt(this$2, 0);
  var negative = (firstChar === 45);
  var maxAbsValue = (negative ? 2.147483648E9 : 2.147483647E9);
  var i = ((negative || (firstChar === 43)) ? 1 : 0);
  var $x_1 = i;
  var this$3 = $n(s);
  if (($x_1 >= this$3.length)) {
    $p_jl_Integer$__fail$1__T__E(this, s);
  }
  var result = 0.0;
  while ((i !== len)) {
    var $x_2 = $m_jl_Character$();
    var this$4 = $n(s);
    var index = i;
    var digit = $n($x_2).digitWithValidRadix__I__I__I($charAt(this$4, index), radix);
    result = ((result * radix) + digit);
    if (((digit === (-1)) || (result > maxAbsValue))) {
      $p_jl_Integer$__fail$1__T__E(this, s);
    }
    i = ((1 + i) | 0);
  }
  if (negative) {
    var n = (-result);
    return $uI((n | 0.0));
  } else {
    var n$1 = result;
    return $uI((n$1 | 0.0));
  }
});
$c_jl_Integer$.prototype.bitCount__I__I = (function(i) {
  var t1 = ((i - (1431655765 & (i >> 1))) | 0);
  var t2 = (((858993459 & t1) + (858993459 & (t1 >> 2))) | 0);
  return (Math.imul(16843009, (252645135 & ((t2 + (t2 >> 4)) | 0))) >> 24);
});
var $d_jl_Integer$ = new $TypeData().initClass($c_jl_Integer$, "java.lang.Integer$", ({
  jl_Integer$: 1,
  Ljava_io_Serializable: 1
}));
var $n_jl_Integer$;
function $m_jl_Integer$() {
  if ((!$n_jl_Integer$)) {
    $n_jl_Integer$ = new $c_jl_Integer$();
  }
  return $n_jl_Integer$;
}
function $p_jl_Long$__StringRadixInfos$lzycompute__O($thiz) {
  if ((!$thiz.jl_Long$__f_bitmap$0)) {
    var r = [];
    var radix = 0;
    while ((radix < 2)) {
      r.push(null);
      radix = ((1 + radix) | 0);
    }
    while ((radix <= 36)) {
      var barrier = $intDiv(2147483647, radix);
      var radixPowLength = radix;
      var chunkLength = 1;
      var paddingZeros = "0";
      while ((radixPowLength <= barrier)) {
        radixPowLength = Math.imul(radixPowLength, radix);
        chunkLength = ((1 + chunkLength) | 0);
        paddingZeros = (paddingZeros + "0");
      }
      var value = radixPowLength;
      var hi = (value >> 31);
      var this$2 = $m_RTLong$();
      var lo = this$2.divideUnsignedImpl__I__I__I__I__I((-1), (-1), value, hi);
      var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      r.push(new $c_jl_Long$StringRadixInfo(chunkLength, new $c_RTLong(value, hi), paddingZeros, new $c_RTLong(lo, hi$1)));
      radix = ((1 + radix) | 0);
    }
    $thiz.jl_Long$__f_StringRadixInfos = r;
    $thiz.jl_Long$__f_bitmap$0 = true;
  }
  return $thiz.jl_Long$__f_StringRadixInfos;
}
function $p_jl_Long$__StringRadixInfos__O($thiz) {
  return ((!$thiz.jl_Long$__f_bitmap$0) ? $p_jl_Long$__StringRadixInfos$lzycompute__O($thiz) : $thiz.jl_Long$__f_StringRadixInfos);
}
function $p_jl_Long$__toUnsignedStringInternalLarge__J__I__T($thiz, i, radix) {
  var radixInfo = $as_jl_Long$StringRadixInfo($p_jl_Long$__StringRadixInfos__O($thiz)[radix]);
  var t = $n(radixInfo).jl_Long$StringRadixInfo__f_radixPowLength;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var paddingZeros = $n(radixInfo).jl_Long$StringRadixInfo__f_paddingZeros;
  var hi$1 = ((-2147483648) ^ hi);
  var res = "";
  var lo$1 = i.RTLong__f_lo;
  var hi$2 = i.RTLong__f_hi;
  var value__lo = lo$1;
  var value__hi = hi$2;
  while (true) {
    var b__lo = value__lo;
    var b__hi = value__hi;
    var lo$2 = b__lo;
    var hi$3 = ((-2147483648) ^ b__hi);
    if (((hi$3 === hi$1) ? (((-2147483648) ^ lo$2) >= ((-2147483648) ^ lo)) : (hi$3 > hi$1))) {
      var this$1__lo = value__lo;
      var this$1__hi = value__hi;
      var this$2 = $m_RTLong$();
      var lo$3 = this$2.divideUnsignedImpl__I__I__I__I__I(this$1__lo, this$1__hi, lo, hi);
      var hi$4 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var this$3__lo = value__lo;
      var this$3__hi = value__hi;
      var a0 = (65535 & lo$3);
      var a1 = ((lo$3 >>> 16) | 0);
      var b0 = (65535 & lo);
      var b1 = ((lo >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$4 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$5 = ((((((((Math.imul(lo$3, hi) + Math.imul(hi$4, lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var alo = this$3__lo;
      var ahi = this$3__hi;
      var lo$5 = ((alo - lo$4) | 0);
      var remStr = $as_T(lo$5.toString(radix));
      var this$5 = $n(remStr);
      var $x_1 = paddingZeros.substring(this$5.length);
      res = ((("" + $as_T($x_1)) + remStr) + res);
      var $x_2__lo = lo$3;
      var $x_2__hi = hi$4;
      value__lo = $x_2__lo;
      value__hi = $x_2__hi;
    } else {
      break;
    }
  }
  var this$6__lo = value__lo;
  var this$6__hi = value__hi;
  var $x_3 = this$6__lo.toString(radix);
  return (("" + $as_T($x_3)) + res);
}
function $p_jl_Long$__parseLongError__T__E($thiz, s) {
  throw new $c_jl_NumberFormatException((("For input string: \"" + s) + "\""));
}
function $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I($thiz, chunkStart, chunkEnd, s$1, radix$1) {
  var result = 0;
  var i = chunkStart;
  while ((i !== chunkEnd)) {
    var $x_1 = $m_jl_Character$();
    var this$1 = $n(s$1);
    var index = i;
    var digit = $n($x_1).digitWithValidRadix__I__I__I($charAt(this$1, index), radix$1);
    if ((digit === (-1))) {
      $p_jl_Long$__parseLongError__T__E($thiz, s$1);
    }
    result = ((Math.imul(result, radix$1) + digit) | 0);
    i = ((1 + i) | 0);
  }
  return result;
}
/** @constructor */
function $c_jl_Long$() {
  this.jl_Long$__f_StringRadixInfos = null;
  this.jl_Long$__f_bitmap$0 = false;
}
$c_jl_Long$.prototype = new $h_O();
$c_jl_Long$.prototype.constructor = $c_jl_Long$;
/** @constructor */
function $h_jl_Long$() {
}
$h_jl_Long$.prototype = $c_jl_Long$.prototype;
$c_jl_Long$.prototype.java$lang$Long$$toStringImpl__J__I__T = (function(i, radix) {
  var lo = i.RTLong__f_lo;
  var hi = i.RTLong__f_hi;
  if (((lo >> 31) === hi)) {
    return $as_T(lo.toString(radix));
  } else if ((hi < 0)) {
    var lo$1 = i.RTLong__f_lo;
    var hi$1 = i.RTLong__f_hi;
    var lo$2 = ((-lo$1) | 0);
    var hi$2 = ((lo$1 !== 0) ? (~hi$1) : ((-hi$1) | 0));
    return ("-" + $p_jl_Long$__toUnsignedStringInternalLarge__J__I__T(this, new $c_RTLong(lo$2, hi$2), radix));
  } else {
    return $p_jl_Long$__toUnsignedStringInternalLarge__J__I__T(this, i, radix);
  }
});
$c_jl_Long$.prototype.parseLong__T__I__J = (function(s, radix) {
  if ((s === "")) {
    $p_jl_Long$__parseLongError__T__E(this, s);
  }
  var start = 0;
  var neg = false;
  var this$1 = $n(s);
  var x1 = $charAt(this$1, 0);
  switch (x1) {
    case 43: {
      start = 1;
      break;
    }
    case 45: {
      start = 1;
      neg = true;
      break;
    }
  }
  var t = this.parseUnsignedLongInternal__T__I__I__J(s, radix, start);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  if (neg) {
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    if (((hi$1 === 0) ? (lo$1 !== 0) : (hi$1 > 0))) {
      $p_jl_Long$__parseLongError__T__E(this, s);
    }
    return new $c_RTLong(lo$1, hi$1);
  } else {
    if ((hi < 0)) {
      $p_jl_Long$__parseLongError__T__E(this, s);
    }
    return new $c_RTLong(lo, hi);
  }
});
$c_jl_Long$.prototype.parseUnsignedLongInternal__T__I__I__J = (function(s, radix, start) {
  var this$1 = $n(s);
  var length = this$1.length;
  if ((((start >= length) || (radix < 2)) || (radix > 36))) {
    $p_jl_Long$__parseLongError__T__E(this, s);
  } else {
    var radixInfo = $as_jl_Long$StringRadixInfo($p_jl_Long$__StringRadixInfos__O(this)[radix]);
    var chunkLen = $n(radixInfo).jl_Long$StringRadixInfo__f_chunkLength;
    var firstChunkStart = start;
    while (true) {
      if ((firstChunkStart < length)) {
        var $x_2 = $m_jl_Character$();
        var this$2 = $n(s);
        var index = firstChunkStart;
        var $x_1 = $n($x_2).isZeroDigit__C__Z($charAt(this$2, index));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        firstChunkStart = ((1 + firstChunkStart) | 0);
      } else {
        break;
      }
    }
    if ((((length - firstChunkStart) | 0) > Math.imul(3, chunkLen))) {
      $p_jl_Long$__parseLongError__T__E(this, s);
    }
    var firstChunkLength = ((1 + $intMod((((-1) + ((length - firstChunkStart) | 0)) | 0), chunkLen)) | 0);
    var firstChunkEnd = ((firstChunkStart + firstChunkLength) | 0);
    var chunkStart = firstChunkStart;
    var x = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, chunkStart, firstChunkEnd, s, radix);
    if ((firstChunkEnd === length)) {
      return new $c_RTLong(x, 0);
    } else {
      var t = $n(radixInfo).jl_Long$StringRadixInfo__f_radixPowLength;
      var lo = t.RTLong__f_lo;
      var hi$1 = t.RTLong__f_hi;
      var secondChunkEnd = ((firstChunkEnd + chunkLen) | 0);
      var a0 = (65535 & x);
      var a1 = ((x >>> 16) | 0);
      var b0 = (65535 & lo);
      var b1 = ((lo >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((((((Math.imul(x, hi$1) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var x$1 = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, firstChunkEnd, secondChunkEnd, s, radix);
      var lo$2 = ((lo$1 + x$1) | 0);
      var hi$4 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + hi$2) | 0) : hi$2);
      if ((secondChunkEnd === length)) {
        return new $c_RTLong(lo$2, hi$4);
      } else {
        var t$1 = $n(radixInfo).jl_Long$StringRadixInfo__f_overflowBarrier;
        var lo$3 = t$1.RTLong__f_lo;
        var hi$5 = t$1.RTLong__f_hi;
        var x$2 = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, secondChunkEnd, length, s, radix);
        if (((hi$4 === hi$5) ? (((-2147483648) ^ lo$2) > ((-2147483648) ^ lo$3)) : (hi$4 > hi$5))) {
          $p_jl_Long$__parseLongError__T__E(this, s);
        }
        var a0$1 = (65535 & lo$2);
        var a1$1 = ((lo$2 >>> 16) | 0);
        var b0$1 = (65535 & lo);
        var b1$1 = ((lo >>> 16) | 0);
        var a0b0$1 = Math.imul(a0$1, b0$1);
        var a1b0$1 = Math.imul(a1$1, b0$1);
        var a0b1$1 = Math.imul(a0$1, b1$1);
        var lo$4 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
        var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
        var hi$7 = ((((((((Math.imul(lo$2, hi$1) + Math.imul(hi$4, lo)) | 0) + Math.imul(a1$1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
        var lo$5 = ((lo$4 + x$2) | 0);
        var hi$8 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$4)) ? ((1 + hi$7) | 0) : hi$7);
        var hi$9 = ((-2147483648) ^ hi$8);
        if (((hi$9 === (-2147483648)) && (((-2147483648) ^ lo$5) < ((-2147483648) ^ x$2)))) {
          $p_jl_Long$__parseLongError__T__E(this, s);
        }
        return new $c_RTLong(lo$5, hi$8);
      }
    }
  }
});
$c_jl_Long$.prototype.java$lang$Long$$toHexString__I__I__T = (function(lo, hi) {
  if ((hi !== 0)) {
    var $x_1 = $as_T($uD((hi >>> 0.0)).toString(16));
    var s = $as_T($uD((lo >>> 0.0)).toString(16));
    var this$3 = $n(s);
    var beginIndex = this$3.length;
    if (((beginIndex < 0) || (beginIndex > 8))) {
      $charAt("00000000", beginIndex);
    }
    return ($x_1 + (("" + $as_T("00000000".substring(beginIndex))) + s));
  } else {
    return $as_T($uD((lo >>> 0.0)).toString(16));
  }
});
$c_jl_Long$.prototype.java$lang$Long$$toOctalString__I__I__T = (function(lo, hi) {
  var lp = (1073741823 & lo);
  var mp = (1073741823 & ((((lo >>> 30) | 0) + (hi << 2)) | 0));
  var hp = ((hi >>> 28) | 0);
  if ((hp !== 0)) {
    var $x_2 = $as_T($uD((hp >>> 0.0)).toString(8));
    var s = $as_T($uD((mp >>> 0.0)).toString(8));
    var this$3 = $n(s);
    var beginIndex = this$3.length;
    if (((beginIndex < 0) || (beginIndex > 10))) {
      $charAt("0000000000", beginIndex);
    }
    var $x_1 = $as_T("0000000000".substring(beginIndex));
    var s$1 = $as_T($uD((lp >>> 0.0)).toString(8));
    var this$5 = $n(s$1);
    var beginIndex$1 = this$5.length;
    if (((beginIndex$1 < 0) || (beginIndex$1 > 10))) {
      $charAt("0000000000", beginIndex$1);
    }
    return (($x_2 + (("" + $x_1) + s)) + (("" + $as_T("0000000000".substring(beginIndex$1))) + s$1));
  } else if ((mp !== 0)) {
    var $x_3 = $as_T($uD((mp >>> 0.0)).toString(8));
    var s$2 = $as_T($uD((lp >>> 0.0)).toString(8));
    var this$8 = $n(s$2);
    var beginIndex$2 = this$8.length;
    if (((beginIndex$2 < 0) || (beginIndex$2 > 10))) {
      $charAt("0000000000", beginIndex$2);
    }
    return ($x_3 + (("" + $as_T("0000000000".substring(beginIndex$2))) + s$2));
  } else {
    return $as_T($uD((lp >>> 0.0)).toString(8));
  }
});
var $d_jl_Long$ = new $TypeData().initClass($c_jl_Long$, "java.lang.Long$", ({
  jl_Long$: 1,
  Ljava_io_Serializable: 1
}));
var $n_jl_Long$;
function $m_jl_Long$() {
  if ((!$n_jl_Long$)) {
    $n_jl_Long$ = new $c_jl_Long$();
  }
  return $n_jl_Long$;
}
/** @constructor */
function $c_jl_Number() {
}
$c_jl_Number.prototype = new $h_O();
$c_jl_Number.prototype.constructor = $c_jl_Number;
/** @constructor */
function $h_jl_Number() {
}
$h_jl_Number.prototype = $c_jl_Number.prototype;
function $is_jl_Number(obj) {
  return (((obj instanceof $c_jl_Number) || ((typeof obj) === "number")) || (obj instanceof $c_RTLong));
}
function $as_jl_Number(obj) {
  return (($is_jl_Number(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Number"));
}
function $isArrayOf_jl_Number(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Number)));
}
function $asArrayOf_jl_Number(obj, depth) {
  return (($isArrayOf_jl_Number(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Number;", depth));
}
function $ct_jl_StackTraceElement__T__T__T__I__I__($thiz, declaringClass, methodName, fileName, lineNumber, columnNumber) {
  $thiz.jl_StackTraceElement__f_declaringClass = declaringClass;
  $thiz.jl_StackTraceElement__f_methodName = methodName;
  $thiz.jl_StackTraceElement__f_fileName = fileName;
  $thiz.jl_StackTraceElement__f_lineNumber = lineNumber;
  $thiz.jl_StackTraceElement__f_columnNumber = columnNumber;
  return $thiz;
}
function $ct_jl_StackTraceElement__T__T__T__I__($thiz, declaringClass, methodName, fileName, lineNumber) {
  $ct_jl_StackTraceElement__T__T__T__I__I__($thiz, declaringClass, methodName, fileName, lineNumber, (-1));
  return $thiz;
}
/** @constructor */
function $c_jl_StackTraceElement() {
  this.jl_StackTraceElement__f_declaringClass = null;
  this.jl_StackTraceElement__f_methodName = null;
  this.jl_StackTraceElement__f_fileName = null;
  this.jl_StackTraceElement__f_lineNumber = 0;
  this.jl_StackTraceElement__f_columnNumber = 0;
}
$c_jl_StackTraceElement.prototype = new $h_O();
$c_jl_StackTraceElement.prototype.constructor = $c_jl_StackTraceElement;
/** @constructor */
function $h_jl_StackTraceElement() {
}
$h_jl_StackTraceElement.prototype = $c_jl_StackTraceElement.prototype;
$c_jl_StackTraceElement.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_jl_StackTraceElement)) {
    var x2 = $as_jl_StackTraceElement(that);
    return (((((this.jl_StackTraceElement__f_fileName === $n(x2).jl_StackTraceElement__f_fileName) && (this.jl_StackTraceElement__f_lineNumber === $n(x2).jl_StackTraceElement__f_lineNumber)) && (this.jl_StackTraceElement__f_columnNumber === $n(x2).jl_StackTraceElement__f_columnNumber)) && (this.jl_StackTraceElement__f_declaringClass === $n(x2).jl_StackTraceElement__f_declaringClass)) && (this.jl_StackTraceElement__f_methodName === $n(x2).jl_StackTraceElement__f_methodName));
  } else {
    return false;
  }
});
$c_jl_StackTraceElement.prototype.toString__T = (function() {
  var result = "";
  if ((this.jl_StackTraceElement__f_declaringClass !== "<jscode>")) {
    result = ((("" + result) + this.jl_StackTraceElement__f_declaringClass) + ".");
  }
  result = (("" + result) + this.jl_StackTraceElement__f_methodName);
  if ((this.jl_StackTraceElement__f_fileName === null)) {
    result = (result + "(Unknown Source)");
  } else {
    result = ((result + "(") + this.jl_StackTraceElement__f_fileName);
    if ((this.jl_StackTraceElement__f_lineNumber >= 0)) {
      result = ((result + ":") + this.jl_StackTraceElement__f_lineNumber);
      if ((this.jl_StackTraceElement__f_columnNumber >= 0)) {
        result = ((result + ":") + this.jl_StackTraceElement__f_columnNumber);
      }
    }
    result = (result + ")");
  }
  return result;
});
$c_jl_StackTraceElement.prototype.hashCode__I = (function() {
  return (((($f_T__hashCode__I($n(this.jl_StackTraceElement__f_declaringClass)) ^ $f_T__hashCode__I($n(this.jl_StackTraceElement__f_methodName))) ^ $f_T__hashCode__I($n(this.jl_StackTraceElement__f_fileName))) ^ this.jl_StackTraceElement__f_lineNumber) ^ this.jl_StackTraceElement__f_columnNumber);
});
function $as_jl_StackTraceElement(obj) {
  return (((obj instanceof $c_jl_StackTraceElement) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.StackTraceElement"));
}
function $isArrayOf_jl_StackTraceElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_StackTraceElement)));
}
function $asArrayOf_jl_StackTraceElement(obj, depth) {
  return (($isArrayOf_jl_StackTraceElement(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.StackTraceElement;", depth));
}
var $d_jl_StackTraceElement = new $TypeData().initClass($c_jl_StackTraceElement, "java.lang.StackTraceElement", ({
  jl_StackTraceElement: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_jl_String$() {
}
$c_jl_String$.prototype = new $h_O();
$c_jl_String$.prototype.constructor = $c_jl_String$;
/** @constructor */
function $h_jl_String$() {
}
$h_jl_String$.prototype = $c_jl_String$.prototype;
$c_jl_String$.prototype.new__AC__I__I__T = (function(value, offset, count) {
  var end = ((offset + count) | 0);
  if ((((offset < 0) || (end < offset)) || (end > $n(value).u.length))) {
    throw $ct_jl_StringIndexOutOfBoundsException__(new $c_jl_StringIndexOutOfBoundsException());
  }
  var result = "";
  var i = offset;
  while ((i !== end)) {
    var $x_1 = result;
    var this$1 = $n(value).get(i);
    result = ($x_1 + ("" + $cToS(this$1)));
    i = ((1 + i) | 0);
  }
  return result;
});
$c_jl_String$.prototype.new__AB__I__I__Ljava_nio_charset_Charset__T = (function(bytes, offset, length, charset) {
  var this$2 = $n(charset);
  var bb = $m_Ljava_nio_HeapByteBuffer$().wrap__AB__I__I__I__I__Z__Ljava_nio_ByteBuffer(bytes, 0, $n(bytes).u.length, offset, length, false);
  return $n($n($p_Ljava_nio_charset_Charset__cachedDecoder__Ljava_nio_charset_CharsetDecoder(this$2)).decode__Ljava_nio_ByteBuffer__Ljava_nio_CharBuffer(bb)).toString__T();
});
$c_jl_String$.prototype.format__T__AO__T = (function(format, args) {
  return $n($ct_ju_Formatter__(new $c_ju_Formatter()).format__T__AO__ju_Formatter(format, args)).toString__T();
});
var $d_jl_String$ = new $TypeData().initClass($c_jl_String$, "java.lang.String$", ({
  jl_String$: 1,
  Ljava_io_Serializable: 1
}));
var $n_jl_String$;
function $m_jl_String$() {
  if ((!$n_jl_String$)) {
    $n_jl_String$ = new $c_jl_String$();
  }
  return $n_jl_String$;
}
/** @constructor */
function $c_jl_Thread(dummy) {
  this.jl_Thread__f_java$lang$Thread$$interruptedState = false;
  this.jl_Thread__f_java$lang$Thread$$interruptedState = false;
}
$c_jl_Thread.prototype = new $h_O();
$c_jl_Thread.prototype.constructor = $c_jl_Thread;
/** @constructor */
function $h_jl_Thread() {
}
$h_jl_Thread.prototype = $c_jl_Thread.prototype;
$c_jl_Thread.prototype.run__V = (function() {
});
var $d_jl_Thread = new $TypeData().initClass($c_jl_Thread, "java.lang.Thread", ({
  jl_Thread: 1,
  jl_Runnable: 1
}));
function $p_jl_Throwable__printStackTraceImpl__O__V($thiz, sprintln) {
  $thiz.getStackTrace__Ajl_StackTraceElement();
  sprintln($thiz.toString__T());
  if (($n($thiz.jl_Throwable__f_stackTrace).u.length !== 0)) {
    var i = 0;
    while ((i < $n($thiz.jl_Throwable__f_stackTrace).u.length)) {
      sprintln(("  at " + $n($thiz.jl_Throwable__f_stackTrace).get(i)));
      i = ((1 + i) | 0);
    }
  } else {
    sprintln("  <no stack trace available>");
  }
  var wCause = $thiz;
  while (true) {
    var $x_3 = wCause;
    var this$1 = $n(wCause);
    if (($x_3 !== this$1.jl_Throwable__f_e)) {
      var this$2 = $n(wCause);
      var $x_2 = (this$2.jl_Throwable__f_e !== null);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var parentTrace = $n(wCause).getStackTrace__Ajl_StackTraceElement();
      var this$3 = $n(wCause);
      wCause = this$3.jl_Throwable__f_e;
      var thisTrace = $n(wCause).getStackTrace__Ajl_StackTraceElement();
      var thisLength = $n(thisTrace).u.length;
      var parentLength = $n(parentTrace).u.length;
      sprintln(("Caused by: " + wCause));
      if ((thisLength !== 0)) {
        var sameFrameCount = 0;
        while (true) {
          if (((sameFrameCount < thisLength) && (sameFrameCount < parentLength))) {
            var x = $n(thisTrace).get((((-1) + ((thisLength - sameFrameCount) | 0)) | 0));
            var x$2 = $n(parentTrace).get((((-1) + ((parentLength - sameFrameCount) | 0)) | 0));
            var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
          } else {
            var $x_1 = false;
          }
          if ($x_1) {
            sameFrameCount = ((1 + sameFrameCount) | 0);
          } else {
            break;
          }
        }
        if ((sameFrameCount > 0)) {
          sameFrameCount = (((-1) + sameFrameCount) | 0);
        }
        var lengthToPrint = ((thisLength - sameFrameCount) | 0);
        var i$2 = 0;
        while ((i$2 < lengthToPrint)) {
          sprintln(("  at " + $n(thisTrace).get(i$2)));
          i$2 = ((1 + i$2) | 0);
        }
        if ((sameFrameCount > 0)) {
          sprintln((("  ... " + sameFrameCount) + " more"));
        }
      } else {
        sprintln("  <no stack trace available>");
      }
    } else {
      break;
    }
  }
}
function $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, e, enableSuppression, writableStackTrace) {
  $thiz.jl_Throwable__f_s = s;
  $thiz.jl_Throwable__f_e = e;
  $thiz.jl_Throwable__f_writableStackTrace = writableStackTrace;
  if (writableStackTrace) {
    $thiz.fillInStackTrace__jl_Throwable();
  }
  return $thiz;
}
class $c_jl_Throwable extends Error {
  constructor() {
    super();
    this.jl_Throwable__f_s = null;
    this.jl_Throwable__f_e = null;
    this.jl_Throwable__f_writableStackTrace = false;
    this.jl_Throwable__f_jsErrorForStackTrace = null;
    this.jl_Throwable__f_stackTrace = null;
  }
  getMessage__T() {
    return this.jl_Throwable__f_s;
  }
  fillInStackTrace__jl_Throwable() {
    var $x_1 = this;
    var reference = (($x_1 instanceof $c_sjs_js_JavaScriptException) ? $x_1.sjs_js_JavaScriptException__f_exception : $n($x_1));
    var identifyingString = Object.prototype.toString.call(reference);
    this.jl_Throwable__f_jsErrorForStackTrace = ((identifyingString === "[object Error]") ? reference : ((Error.captureStackTrace === (void 0)) ? new Error() : (Error.captureStackTrace(this), this)));
    return this;
  }
  getStackTrace__Ajl_StackTraceElement() {
    if ((this.jl_Throwable__f_stackTrace === null)) {
      if (this.jl_Throwable__f_writableStackTrace) {
        this.jl_Throwable__f_stackTrace = $m_jl_StackTrace$().extract__O__Ajl_StackTraceElement(this.jl_Throwable__f_jsErrorForStackTrace);
      } else {
        this.jl_Throwable__f_stackTrace = new ($d_jl_StackTraceElement.getArrayOf().constr)(0);
      }
    }
    return this.jl_Throwable__f_stackTrace;
  }
  setStackTrace__Ajl_StackTraceElement__V(stackTrace) {
    if (this.jl_Throwable__f_writableStackTrace) {
      var i = 0;
      while ((i < $n(stackTrace).u.length)) {
        if (($n(stackTrace).get(i) === null)) {
          throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
        }
        i = ((1 + i) | 0);
      }
      var this$1 = $n(stackTrace);
      this.jl_Throwable__f_stackTrace = $n(this$1).clone__O();
    }
  }
  printStackTrace__Ljava_io_PrintStream__V(s) {
    $p_jl_Throwable__printStackTraceImpl__O__V(this, ((x$1$2) => {
      var x$1 = $as_T(x$1$2);
      $n(s).println__T__V(x$1);
    }));
  }
  toString__T() {
    var className = $objectClassName(this);
    var message = this.getMessage__T();
    return ((message === null) ? className : ((className + ": ") + message));
  }
  hashCode__I() {
    return $c_O.prototype.hashCode__I.call(this);
  }
  equals__O__Z(that) {
    return $c_O.prototype.equals__O__Z.call(this, that);
  }
  get "message"() {
    var m = this.getMessage__T();
    return ((m === null) ? "" : m);
  }
  get "name"() {
    return $objectClassName(this);
  }
  "toString"() {
    return this.toString__T();
  }
}
function $as_jl_Throwable(obj) {
  return (((obj instanceof $c_jl_Throwable) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Throwable"));
}
function $isArrayOf_jl_Throwable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Throwable)));
}
function $asArrayOf_jl_Throwable(obj, depth) {
  return (($isArrayOf_jl_Throwable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Throwable;", depth));
}
function $p_Ljava_math_BigDecimal$__powLen$1__I__I($thiz, diffScale$1) {
  return $n($thiz.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength).get(diffScale$1);
}
function $p_Ljava_math_BigDecimal$__augPlusPowLength$1__Ljava_math_BigDecimal__I__I($thiz, augend$1, diffScale$1) {
  return (($n(augend$1).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + $p_Ljava_math_BigDecimal$__powLen$1__I__I($thiz, diffScale$1)) | 0);
}
function $p_Ljava_math_BigDecimal$__maxLen$1__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__I($thiz, thisValue$1, augend$1, diffScale$1) {
  var a = $n(thisValue$1).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
  var b = $p_Ljava_math_BigDecimal$__augPlusPowLength$1__Ljava_math_BigDecimal__I__I($thiz, augend$1, diffScale$1);
  return ((1 + ((a > b) ? a : b)) | 0);
}
/** @constructor */
function $c_Ljava_math_BigDecimal$() {
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows = null;
  this.Ljava_math_BigDecimal$__f_LongTenPows = null;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength = null;
  this.Ljava_math_BigDecimal$__f_BigIntScaledByZero = null;
  this.Ljava_math_BigDecimal$__f_ZeroScaledBy = null;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros = null;
  $n_Ljava_math_BigDecimal$ = this;
  $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, 0);
  $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 1, 0);
  $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 10, 0);
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows = this.newArrayOfPows__I__I__AJ(28, 5);
  var len = $n(this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows).u.length;
  var result = new $ac_I(len);
  var i = 0;
  while ((i < len)) {
    var i$2 = i;
    $n(result).set(i$2, $m_Ljava_math_BigDecimal$().bitLength__J__I($n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows).get(i$2)));
    i = ((1 + i) | 0);
  }
  this.Ljava_math_BigDecimal$__f_LongTenPows = this.newArrayOfPows__I__I__AJ(19, 10);
  var len$2 = $n(this.Ljava_math_BigDecimal$__f_LongTenPows).u.length;
  var result$2 = new $ac_I(len$2);
  var i$1 = 0;
  while ((i$1 < len$2)) {
    var i$3$2 = i$1;
    $n(result$2).set(i$3$2, $m_Ljava_math_BigDecimal$().bitLength__J__I($n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows).get(i$3$2)));
    i$1 = ((1 + i$1) | 0);
  }
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength = result$2;
  var result$3 = new ($d_Ljava_math_BigDecimal.getArrayOf().constr)(11);
  var i$3 = 0;
  while ((i$3 < 11)) {
    var i$4$2 = i$3;
    $n(result$3).set(i$4$2, $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), i$4$2, 0));
    i$3 = ((1 + i$3) | 0);
  }
  this.Ljava_math_BigDecimal$__f_BigIntScaledByZero = result$3;
  var result$4 = new ($d_Ljava_math_BigDecimal.getArrayOf().constr)(11);
  var i$4 = 0;
  while ((i$4 < 11)) {
    var i$5$2 = i$4;
    $n(result$4).set(i$5$2, $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, i$5$2));
    i$4 = ((1 + i$4) | 0);
  }
  this.Ljava_math_BigDecimal$__f_ZeroScaledBy = result$4;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros = "0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000";
}
$c_Ljava_math_BigDecimal$.prototype = new $h_O();
$c_Ljava_math_BigDecimal$.prototype.constructor = $c_Ljava_math_BigDecimal$;
/** @constructor */
function $h_Ljava_math_BigDecimal$() {
}
$h_Ljava_math_BigDecimal$.prototype = $c_Ljava_math_BigDecimal$.prototype;
$c_Ljava_math_BigDecimal$.prototype.valueOf__J__I__Ljava_math_BigDecimal = (function(unscaledVal, scale) {
  return ((scale === 0) ? this.valueOf__J__Ljava_math_BigDecimal(unscaledVal) : (((((unscaledVal.RTLong__f_lo === 0) && (unscaledVal.RTLong__f_hi === 0)) && (scale >= 0)) && (scale < $n(this.Ljava_math_BigDecimal$__f_ZeroScaledBy).u.length)) ? $n(this.Ljava_math_BigDecimal$__f_ZeroScaledBy).get(scale) : $ct_Ljava_math_BigDecimal__J__I__(new $c_Ljava_math_BigDecimal(), unscaledVal, scale)));
});
$c_Ljava_math_BigDecimal$.prototype.valueOf__J__Ljava_math_BigDecimal = (function(unscaledVal) {
  var ahi = unscaledVal.RTLong__f_hi;
  if ((ahi >= 0)) {
    var ahi$1 = unscaledVal.RTLong__f_hi;
    var $x_1 = ((ahi$1 === 0) ? (((-2147483648) ^ unscaledVal.RTLong__f_lo) < (-2147483637)) : (ahi$1 < 0));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return $n(this.Ljava_math_BigDecimal$__f_BigIntScaledByZero).get(unscaledVal.RTLong__f_lo);
  } else {
    return $ct_Ljava_math_BigDecimal__J__I__(new $c_Ljava_math_BigDecimal(), unscaledVal, 0);
  }
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$addAndMult10__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__Ljava_math_BigDecimal = (function(thisValue, augend, diffScale) {
  if (((diffScale < $n(this.Ljava_math_BigDecimal$__f_LongTenPows).u.length) && ($p_Ljava_math_BigDecimal$__maxLen$1__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__I(this, thisValue, augend, diffScale) < 64))) {
    var this$1 = $n(augend).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var b = $n(this.Ljava_math_BigDecimal$__f_LongTenPows).get(diffScale);
    var alo = this$1.RTLong__f_lo;
    var blo = b.RTLong__f_lo;
    var a0 = (65535 & alo);
    var a1 = ((alo >>> 16) | 0);
    var b0 = (65535 & blo);
    var b1 = ((blo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(this$1.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var this$2 = $n(thisValue).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var alo$1 = this$2.RTLong__f_lo;
    var ahi = this$2.RTLong__f_hi;
    var lo$1 = ((alo$1 + lo) | 0);
    var hi$1 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ alo$1)) ? ((1 + ((ahi + hi) | 0)) | 0) : ((ahi + hi) | 0));
    return this.valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo$1, hi$1), $n(thisValue).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
  } else {
    var $x_2 = $m_Ljava_math_Multiplication$();
    var $x_1 = $n(augend).java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var hi$2 = (diffScale >> 31);
    var bi = $n($x_2).multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger($x_1, new $c_RTLong(diffScale, hi$2));
    var this$5 = $n($n(thisValue).java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
    var $x_3 = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$5, bi);
    var this$6 = $n(thisValue);
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $x_3, this$6.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
  }
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$longCompareTo__J__J__I = (function(value1, value2) {
  var ahi = value1.RTLong__f_hi;
  var bhi = value2.RTLong__f_hi;
  if (((ahi === bhi) ? (((-2147483648) ^ value1.RTLong__f_lo) > ((-2147483648) ^ value2.RTLong__f_lo)) : (ahi > bhi))) {
    return 1;
  } else {
    var ahi$1 = value1.RTLong__f_hi;
    var bhi$1 = value2.RTLong__f_hi;
    if (((ahi$1 === bhi$1) ? (((-2147483648) ^ value1.RTLong__f_lo) < ((-2147483648) ^ value2.RTLong__f_lo)) : (ahi$1 < bhi$1))) {
      return (-1);
    } else {
      return 0;
    }
  }
});
$c_Ljava_math_BigDecimal$.prototype.newArrayOfPows__I__I__AJ = (function(len, pow) {
  var result = new $ac_J(len);
  $n(result).set(0, new $c_RTLong(1, 0));
  var i = 1;
  while ((i < len)) {
    var i$2 = i;
    var $x_1 = $n(result);
    var this$4 = $n(result).get((((-1) + i$2) | 0));
    var hi = (pow >> 31);
    var alo = this$4.RTLong__f_lo;
    var a0 = (65535 & alo);
    var a1 = ((alo >>> 16) | 0);
    var b0 = (65535 & pow);
    var b1 = ((pow >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((((((((Math.imul(alo, hi) + Math.imul(this$4.RTLong__f_hi, pow)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    $x_1.set(i$2, new $c_RTLong(lo, hi$1));
    i = ((1 + i) | 0);
  }
  return result;
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I = (function(parityBit, fraction, roundingMode) {
  var absFraction = ((fraction < 0) ? ((-fraction) | 0) : fraction);
  var sigFraction = ((fraction === 0) ? 0 : ((fraction < 0) ? (-1) : 1));
  var x = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_UP;
  if ((x === null)) {
    var $x_1 = (roundingMode === null);
  } else {
    var this$3 = $n(x);
    var $x_1 = (this$3 === roundingMode);
  }
  if ($x_1) {
    return sigFraction;
  } else {
    var x$3 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_DOWN;
    if ((x$3 === null)) {
      var $x_2 = (roundingMode === null);
    } else {
      var this$4 = $n(x$3);
      var $x_2 = (this$4 === roundingMode);
    }
    if ($x_2) {
      return 0;
    } else {
      var x$5 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_CEILING;
      if ((x$5 === null)) {
        var $x_3 = (roundingMode === null);
      } else {
        var this$5 = $n(x$5);
        var $x_3 = (this$5 === roundingMode);
      }
      if ($x_3) {
        return ((sigFraction > 0) ? sigFraction : 0);
      } else {
        var x$7 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_FLOOR;
        if ((x$7 === null)) {
          var $x_4 = (roundingMode === null);
        } else {
          var this$7 = $n(x$7);
          var $x_4 = (this$7 === roundingMode);
        }
        if ($x_4) {
          return ((sigFraction < 0) ? sigFraction : 0);
        } else {
          var x$9 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_UP;
          if ((x$9 === null)) {
            var $x_5 = (roundingMode === null);
          } else {
            var this$9 = $n(x$9);
            var $x_5 = (this$9 === roundingMode);
          }
          if ($x_5) {
            return ((absFraction >= 5) ? sigFraction : 0);
          } else {
            var x$11 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_DOWN;
            if ((x$11 === null)) {
              var $x_6 = (roundingMode === null);
            } else {
              var this$10 = $n(x$11);
              var $x_6 = (this$10 === roundingMode);
            }
            if ($x_6) {
              return ((absFraction > 5) ? sigFraction : 0);
            } else {
              var x$13 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN;
              if ((x$13 === null)) {
                var $x_7 = (roundingMode === null);
              } else {
                var this$11 = $n(x$13);
                var $x_7 = (this$11 === roundingMode);
              }
              if ($x_7) {
                return ((((absFraction + parityBit) | 0) > 5) ? sigFraction : 0);
              } else {
                var x$15 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_UNNECESSARY;
                if ((x$15 === null)) {
                  var $x_8 = (roundingMode === null);
                } else {
                  var this$12 = $n(x$15);
                  var $x_8 = (this$12 === roundingMode);
                }
                if ($x_8) {
                  if ((fraction === 0)) {
                    return 0;
                  } else {
                    throw new $c_jl_ArithmeticException("Rounding necessary");
                  }
                } else {
                  throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), roundingMode);
                }
              }
            }
          }
        }
      }
    }
  }
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$safeLongToInt__J__I = (function(longValue) {
  var ahi = longValue.RTLong__f_hi;
  if (((ahi === (-1)) ? (((-2147483648) ^ longValue.RTLong__f_lo) < 0) : (ahi < (-1)))) {
    var $x_1 = true;
  } else {
    var ahi$1 = longValue.RTLong__f_hi;
    var $x_1 = ((ahi$1 === 0) ? (((-2147483648) ^ longValue.RTLong__f_lo) > (-1)) : (ahi$1 > 0));
  }
  if ($x_1) {
    throw new $c_jl_ArithmeticException(("Out of int range: " + longValue));
  }
  return longValue.RTLong__f_lo;
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$zeroScaledBy__J__Ljava_math_BigDecimal = (function(longScale) {
  var value = longScale.RTLong__f_lo;
  var hi = (value >> 31);
  if (((longScale.RTLong__f_lo === value) && (longScale.RTLong__f_hi === hi))) {
    return this.valueOf__J__I__Ljava_math_BigDecimal($L0, longScale.RTLong__f_lo);
  } else {
    var ahi = longScale.RTLong__f_hi;
    if ((ahi >= 0)) {
      return $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, 2147483647);
    } else {
      return $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, (-2147483648));
    }
  }
});
$c_Ljava_math_BigDecimal$.prototype.bitLength__J__I = (function(sValue) {
  var ahi = sValue.RTLong__f_hi;
  if ((ahi < 0)) {
    var lo = (~sValue.RTLong__f_lo);
    var hi = (~sValue.RTLong__f_hi);
    var x__lo = lo;
    var x__hi = hi;
    var t = new $c_RTLong(x__lo, x__hi);
  } else {
    var t = sValue;
  }
  var lo$1 = t.RTLong__f_lo;
  var hi$1 = t.RTLong__f_hi;
  return ((64 - ((hi$1 !== 0) ? $uI(Math.clz32(hi$1)) : ((32 + $uI(Math.clz32(lo$1))) | 0))) | 0);
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$bitLength__I__I = (function(sValue) {
  var smallValue = ((sValue < 0) ? (~sValue) : sValue);
  return ((32 - $uI(Math.clz32(smallValue))) | 0);
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$charNotEqualTo__C__AC__Z = (function(c, cs) {
  return (!this.java$math$BigDecimal$$charEqualTo__C__AC__Z(c, cs));
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$charEqualTo__C__AC__Z = (function(c, cs) {
  var len = $n(cs).u.length;
  var i = 0;
  while ((i !== len)) {
    if (($n(cs).get(i) === c)) {
      return true;
    }
    i = ((1 + i) | 0);
  }
  return false;
});
var $d_Ljava_math_BigDecimal$ = new $TypeData().initClass($c_Ljava_math_BigDecimal$, "java.math.BigDecimal$", ({
  Ljava_math_BigDecimal$: 1,
  Ljava_io_Serializable: 1
}));
var $n_Ljava_math_BigDecimal$;
function $m_Ljava_math_BigDecimal$() {
  if ((!$n_Ljava_math_BigDecimal$)) {
    $n_Ljava_math_BigDecimal$ = new $c_Ljava_math_BigDecimal$();
  }
  return $n_Ljava_math_BigDecimal$;
}
/** @constructor */
function $c_Ljava_math_BigInteger$() {
  this.Ljava_math_BigInteger$__f_ONE = null;
  this.Ljava_math_BigInteger$__f_TEN = null;
  this.Ljava_math_BigInteger$__f_ZERO = null;
  this.Ljava_math_BigInteger$__f_MINUS_ONE = null;
  this.Ljava_math_BigInteger$__f_SMALL_VALUES = null;
  this.Ljava_math_BigInteger$__f_TWO_POWS = null;
  $n_Ljava_math_BigInteger$ = this;
  this.Ljava_math_BigInteger$__f_ONE = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 1);
  this.Ljava_math_BigInteger$__f_TEN = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 10);
  this.Ljava_math_BigInteger$__f_ZERO = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 0, 0);
  this.Ljava_math_BigInteger$__f_MINUS_ONE = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), (-1), 1);
  this.Ljava_math_BigInteger$__f_SMALL_VALUES = new ($d_Ljava_math_BigInteger.getArrayOf().constr)([this.Ljava_math_BigInteger$__f_ZERO, this.Ljava_math_BigInteger$__f_ONE, $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 2), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 3), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 4), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 5), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 6), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 7), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 8), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 9), this.Ljava_math_BigInteger$__f_TEN]);
  var result = new ($d_Ljava_math_BigInteger.getArrayOf().constr)(32);
  var i = 0;
  while ((i < 32)) {
    var i$2 = i;
    var $x_2 = $n(result);
    var $x_1 = $m_Ljava_math_BigInteger$();
    var lo = (((32 & i$2) === 0) ? (1 << i$2) : 0);
    var hi = (((32 & i$2) === 0) ? 0 : (1 << i$2));
    $x_2.set(i$2, $n($x_1).valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi)));
    i = ((1 + i) | 0);
  }
  this.Ljava_math_BigInteger$__f_TWO_POWS = result;
}
$c_Ljava_math_BigInteger$.prototype = new $h_O();
$c_Ljava_math_BigInteger$.prototype.constructor = $c_Ljava_math_BigInteger$;
/** @constructor */
function $h_Ljava_math_BigInteger$() {
}
$h_Ljava_math_BigInteger$.prototype = $c_Ljava_math_BigInteger$.prototype;
$c_Ljava_math_BigInteger$.prototype.valueOf__J__Ljava_math_BigInteger = (function(lVal) {
  var ahi = lVal.RTLong__f_hi;
  if ((ahi < 0)) {
    if ((!((lVal.RTLong__f_lo === (-1)) && (lVal.RTLong__f_hi === (-1))))) {
      var lo = lVal.RTLong__f_lo;
      var hi = lVal.RTLong__f_hi;
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
      return $ct_Ljava_math_BigInteger__I__J__(new $c_Ljava_math_BigInteger(), (-1), new $c_RTLong(lo$1, hi$1));
    } else {
      return this.Ljava_math_BigInteger$__f_MINUS_ONE;
    }
  } else {
    var ahi$1 = lVal.RTLong__f_hi;
    if (((ahi$1 === 0) ? (((-2147483648) ^ lVal.RTLong__f_lo) <= (-2147483638)) : (ahi$1 < 0))) {
      return $n(this.Ljava_math_BigInteger$__f_SMALL_VALUES).get(lVal.RTLong__f_lo);
    } else {
      return $ct_Ljava_math_BigInteger__I__J__(new $c_Ljava_math_BigInteger(), 1, lVal);
    }
  }
});
$c_Ljava_math_BigInteger$.prototype.getPowerOfTwo__I__Ljava_math_BigInteger = (function(exp) {
  if ((exp < $n(this.Ljava_math_BigInteger$__f_TWO_POWS).u.length)) {
    return $n(this.Ljava_math_BigInteger$__f_TWO_POWS).get(exp);
  } else {
    var intCount = (exp >> 5);
    var bitN = (31 & exp);
    var resDigits = new $ac_I(((1 + intCount) | 0));
    $n(resDigits).set(intCount, (1 << bitN));
    return $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), 1, ((1 + intCount) | 0), resDigits);
  }
});
$c_Ljava_math_BigInteger$.prototype.checkRangeBasedOnIntArrayLength__I__V = (function(byteLength) {
  if (((byteLength < 0) || (byteLength >= 67108864))) {
    throw new $c_jl_ArithmeticException("BigInteger would overflow supported range");
  }
});
var $d_Ljava_math_BigInteger$ = new $TypeData().initClass($c_Ljava_math_BigInteger$, "java.math.BigInteger$", ({
  Ljava_math_BigInteger$: 1,
  Ljava_io_Serializable: 1
}));
var $n_Ljava_math_BigInteger$;
function $m_Ljava_math_BigInteger$() {
  if ((!$n_Ljava_math_BigInteger$)) {
    $n_Ljava_math_BigInteger$ = new $c_Ljava_math_BigInteger$();
  }
  return $n_Ljava_math_BigInteger$;
}
/** @constructor */
function $c_Ljava_math_RoundingMode$() {
  this.Ljava_math_RoundingMode$__f_UP = null;
  this.Ljava_math_RoundingMode$__f_DOWN = null;
  this.Ljava_math_RoundingMode$__f_CEILING = null;
  this.Ljava_math_RoundingMode$__f_FLOOR = null;
  this.Ljava_math_RoundingMode$__f_HALF_UP = null;
  this.Ljava_math_RoundingMode$__f_HALF_DOWN = null;
  this.Ljava_math_RoundingMode$__f_HALF_EVEN = null;
  this.Ljava_math_RoundingMode$__f_UNNECESSARY = null;
  $n_Ljava_math_RoundingMode$ = this;
  this.Ljava_math_RoundingMode$__f_UP = new $c_Ljava_math_RoundingMode("UP", 0);
  this.Ljava_math_RoundingMode$__f_DOWN = new $c_Ljava_math_RoundingMode("DOWN", 1);
  this.Ljava_math_RoundingMode$__f_CEILING = new $c_Ljava_math_RoundingMode("CEILING", 2);
  this.Ljava_math_RoundingMode$__f_FLOOR = new $c_Ljava_math_RoundingMode("FLOOR", 3);
  this.Ljava_math_RoundingMode$__f_HALF_UP = new $c_Ljava_math_RoundingMode("HALF_UP", 4);
  this.Ljava_math_RoundingMode$__f_HALF_DOWN = new $c_Ljava_math_RoundingMode("HALF_DOWN", 5);
  this.Ljava_math_RoundingMode$__f_HALF_EVEN = new $c_Ljava_math_RoundingMode("HALF_EVEN", 6);
  this.Ljava_math_RoundingMode$__f_UNNECESSARY = new $c_Ljava_math_RoundingMode("UNNECESSARY", 7);
}
$c_Ljava_math_RoundingMode$.prototype = new $h_O();
$c_Ljava_math_RoundingMode$.prototype.constructor = $c_Ljava_math_RoundingMode$;
/** @constructor */
function $h_Ljava_math_RoundingMode$() {
}
$h_Ljava_math_RoundingMode$.prototype = $c_Ljava_math_RoundingMode$.prototype;
var $d_Ljava_math_RoundingMode$ = new $TypeData().initClass($c_Ljava_math_RoundingMode$, "java.math.RoundingMode$", ({
  Ljava_math_RoundingMode$: 1,
  Ljava_io_Serializable: 1
}));
var $n_Ljava_math_RoundingMode$;
function $m_Ljava_math_RoundingMode$() {
  if ((!$n_Ljava_math_RoundingMode$)) {
    $n_Ljava_math_RoundingMode$ = new $c_Ljava_math_RoundingMode$();
  }
  return $n_Ljava_math_RoundingMode$;
}
function $p_Ljava_net_URI$__loop$1__I__T__T__I($thiz, i, x$1, y$1) {
  while (true) {
    var $x_2 = i;
    var this$1 = $n(x$1);
    if (($x_2 >= this$1.length)) {
      var $x_1 = true;
    } else {
      var $x_3 = i;
      var this$2 = $n(y$1);
      var $x_1 = ($x_3 >= this$2.length);
    }
    if ($x_1) {
      var this$3 = $n(x$1);
      var this$4 = $n(y$1);
      return ((this$3.length - this$4.length) | 0);
    } else {
      var this$5 = $n(x$1);
      var index = i;
      var this$6 = $n(y$1);
      var index$1 = i;
      var diff = (($charAt(this$5, index) - $charAt(this$6, index$1)) | 0);
      if ((diff !== 0)) {
        return diff;
      } else {
        var this$7 = $n(x$1);
        var index$2 = i;
        if (($charAt(this$7, index$2) === 37)) {
          var $x_5 = i;
          var this$8 = $n(x$1);
          if ((((2 + $x_5) | 0) >= this$8.length)) {
            var $x_4 = true;
          } else {
            var $x_6 = i;
            var this$9 = $n(y$1);
            var $x_4 = (((2 + $x_6) | 0) >= this$9.length);
          }
          if ($x_4) {
            throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "Invalid escape in URI");
          }
          var this$10 = $n(x$1);
          var beginIndex = ((1 + i) | 0);
          var endIndex = ((3 + i) | 0);
          if ((beginIndex < 0)) {
            $charAt(this$10, beginIndex);
          }
          if ((endIndex > this$10.length)) {
            $charAt(this$10, endIndex);
          }
          if ((endIndex < beginIndex)) {
            $charAt(this$10, (-1));
          }
          var $x_7 = $n($as_T(this$10.substring(beginIndex, endIndex)));
          var this$11 = $n(y$1);
          var beginIndex$1 = ((1 + i) | 0);
          var endIndex$1 = ((3 + i) | 0);
          if ((beginIndex$1 < 0)) {
            $charAt(this$11, beginIndex$1);
          }
          if ((endIndex$1 > this$11.length)) {
            $charAt(this$11, endIndex$1);
          }
          if ((endIndex$1 < beginIndex$1)) {
            $charAt(this$11, (-1));
          }
          var cmp = $f_T__compareToIgnoreCase__T__I($n($x_7), $as_T(this$11.substring(beginIndex$1, endIndex$1)));
          if ((cmp !== 0)) {
            return cmp;
          } else {
            i = ((3 + i) | 0);
          }
        } else {
          i = ((1 + i) | 0);
        }
      }
    }
  }
}
/** @constructor */
function $c_Ljava_net_URI$() {
  this.Ljava_net_URI$__f_ipv4address = null;
  this.Ljava_net_URI$__f_ipv6address = null;
  this.Ljava_net_URI$__f_java$net$URI$$uriRe = null;
  $n_Ljava_net_URI$ = this;
  this.Ljava_net_URI$__f_ipv4address = "(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)";
  var ipv4 = this.Ljava_net_URI$__f_ipv4address;
  this.Ljava_net_URI$__f_ipv6address = (((((((((((((("(?:(?:[0-9a-f]{1,4}:){7}[0-9a-f]{1,4}|(?:[0-9a-f]{1,4}:){1,7}:|(?:[0-9a-f]{1,4}:){1,6}(?::[0-9a-f]{1,4})|(?:[0-9a-f]{1,4}:){1,5}(?::[0-9a-f]{1,4}){1,2}|(?:[0-9a-f]{1,4}:){1,4}(?::[0-9a-f]{1,4}){1,3}|(?:[0-9a-f]{1,4}:){1,3}(?::[0-9a-f]{1,4}){1,4}|(?:[0-9a-f]{1,4}:){1,2}(?::[0-9a-f]{1,4}){1,5}|(?:[0-9a-f]{1,4}:)(?::[0-9a-f]{1,4}){1,6}|:(?:(?::[0-9a-f]{1,4}){1,7}|:)|(?:[0-9a-f]{1,4}:){6}" + ipv4) + "|(?:[0-9a-f]{1,4}:){1,5}:") + ipv4) + "|(?:[0-9a-f]{1,4}:){1,4}(?::[0-9a-f]{1,4}):") + ipv4) + "|(?:[0-9a-f]{1,4}:){1,3}(?::[0-9a-f]{1,4}){1,2}:") + ipv4) + "|(?:[0-9a-f]{1,4}:){1,2}(?::[0-9a-f]{1,4}){1,3}:") + ipv4) + "|(?:[0-9a-f]{1,4}:)(?::[0-9a-f]{1,4}){1,4}:") + ipv4) + "|::(?:[0-9a-f]{1,4}:){1,5}") + ipv4) + ")(?:%[0-9a-z]+)?");
  new RegExp((("^" + this.Ljava_net_URI$__f_ipv6address) + "$"), "i");
  var ipv6reference = (("\\[(?:" + this.Ljava_net_URI$__f_ipv6address) + ")\\]");
  var host = (((("((?:(?:[a-z0-9]|[a-z0-9][a-z0-9-]*[a-z0-9])\\.)*(?:[a-z]|[a-z][a-z0-9-]*[a-z0-9])\\.?|" + this.Ljava_net_URI$__f_ipv4address) + "|") + ipv6reference) + ")");
  var hostport = (host + "(?::([0-9]*))?");
  var server = (("(?:(?:((?:[a-z0-9-_.!~*'();:&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)@)?" + hostport) + ")?");
  var authority = (server + "|(?:[a-z0-9-_.!~*'()$,;:@&=+]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])+");
  var net_path = (("//(" + authority) + ")(/(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*(?:/(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*)*)?");
  var hier_part = (("(?:" + net_path) + "|(/(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*(?:/(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*)*))(?:\\?((?:[;/?:@&=+$,\\[\\]a-z0-9-_.!~*'()]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*))?");
  var absoluteURI = (("([a-z][a-z0-9+-.]*):(?:(" + hier_part) + ")|((?:[a-z0-9-_.!~*'();?:@&=+$,]|%[a-f0-9]{2})(?:[;/?:@&=+$,\\[\\]a-z0-9-_.!~*'()]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*))");
  var relativeURI = (("((?:" + net_path) + "|(/(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*(?:/(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*)*)|((?:[a-z0-9-_.!~*'();@&=+$,]|%[a-f0-9]{2})*(?:/(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*(?:/(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*)*)?))(?:\\?((?:[;/?:@&=+$,\\[\\]a-z0-9-_.!~*'()]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*))?)");
  var uriRef = (((("^(?:" + absoluteURI) + "|") + relativeURI) + ")(?:#((?:[;/?:@&=+$,\\[\\]a-z0-9-_.!~*'()]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*))?$");
  this.Ljava_net_URI$__f_java$net$URI$$uriRe = new RegExp(uriRef, "i");
  new RegExp("[\u0000- \"#/<>?@\\[-\\^`{-}\u007f-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029]|%(?![0-9a-f]{2})", "ig");
  new RegExp("[\u0000- \"#<>?\\[-\\^`{-}\u007f-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029]|%(?![0-9a-f]{2})", "ig");
  new RegExp("[\u0000- \"#/<>?\\^`{-}\u007f-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029]|%(?![0-9a-f]{2})", "ig");
  new RegExp("[\u0000- \"#<>@\\^`{-}\u007f-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029]|%(?![0-9a-f]{2})", "ig");
  new RegExp("[^\u0000-\u007f]+", "g");
}
$c_Ljava_net_URI$.prototype = new $h_O();
$c_Ljava_net_URI$.prototype.constructor = $c_Ljava_net_URI$;
/** @constructor */
function $h_Ljava_net_URI$() {
}
$h_Ljava_net_URI$.prototype = $c_Ljava_net_URI$.prototype;
$c_Ljava_net_URI$.prototype.java$net$URI$$caseInsensitiveCompare__T__T__I = (function(x, y) {
  return ((x === null) ? ((y === null) ? 0 : (-1)) : ((y === null) ? 1 : $f_T__compareToIgnoreCase__T__I($n(x), y)));
});
$c_Ljava_net_URI$.prototype.java$net$URI$$escapeAwareCompare__T__T__I = (function(x, y) {
  return ((x === null) ? ((y === null) ? 0 : (-1)) : ((y === null) ? 1 : $p_Ljava_net_URI$__loop$1__I__T__T__I(this, 0, x, y)));
});
$c_Ljava_net_URI$.prototype.java$net$URI$$normalizeEscapes__T__T = (function(str) {
  if ((str === null)) {
    return null;
  } else {
    var i = 0;
    var res = "";
    while (true) {
      var $x_4 = i;
      var this$1 = $n(str);
      if (($x_4 < this$1.length)) {
        var this$2 = $n(str);
        var index = i;
        if (($charAt(this$2, index) === 37)) {
          var $x_1 = i;
          var this$3 = $n(str);
          if ((((2 + $x_1) | 0) >= this$3.length)) {
            throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "Invalid escape in URI");
          }
          var $x_2 = res;
          var this$4 = $n(str);
          var beginIndex = i;
          var endIndex = ((3 + i) | 0);
          if ((beginIndex < 0)) {
            $charAt(this$4, beginIndex);
          }
          if ((endIndex > this$4.length)) {
            $charAt(this$4, endIndex);
          }
          if ((endIndex < beginIndex)) {
            $charAt(this$4, (-1));
          }
          var this$5 = $n($as_T(this$4.substring(beginIndex, endIndex)));
          res = (("" + $x_2) + $as_T(this$5.toUpperCase()));
          i = ((3 + i) | 0);
        } else {
          var $x_3 = res;
          var this$6 = $n(str);
          var beginIndex$1 = i;
          var endIndex$1 = ((1 + i) | 0);
          if ((beginIndex$1 < 0)) {
            $charAt(this$6, beginIndex$1);
          }
          if ((endIndex$1 > this$6.length)) {
            $charAt(this$6, endIndex$1);
          }
          if ((endIndex$1 < beginIndex$1)) {
            $charAt(this$6, (-1));
          }
          res = (("" + $x_3) + $as_T(this$6.substring(beginIndex$1, endIndex$1)));
          i = ((1 + i) | 0);
        }
      } else {
        break;
      }
    }
    return res;
  }
});
var $d_Ljava_net_URI$ = new $TypeData().initClass($c_Ljava_net_URI$, "java.net.URI$", ({
  Ljava_net_URI$: 1,
  Ljava_io_Serializable: 1
}));
var $n_Ljava_net_URI$;
function $m_Ljava_net_URI$() {
  if ((!$n_Ljava_net_URI$)) {
    $n_Ljava_net_URI$ = new $c_Ljava_net_URI$();
  }
  return $n_Ljava_net_URI$;
}
function $p_Ljava_nio_charset_Charset__cachedDecoder$lzycompute__Ljava_nio_charset_CharsetDecoder($thiz) {
  if (((((2 & $thiz.Ljava_nio_charset_Charset__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_nio_charset_Charset__f_cachedDecoder = $n(new $c_Ljava_nio_charset_UTF\uff3f8$Decoder().onMalformedInput__Ljava_nio_charset_CodingErrorAction__Ljava_nio_charset_CharsetDecoder($m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPLACE)).onUnmappableCharacter__Ljava_nio_charset_CodingErrorAction__Ljava_nio_charset_CharsetDecoder($m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPLACE);
    $thiz.Ljava_nio_charset_Charset__f_bitmap$0 = (((2 | $thiz.Ljava_nio_charset_Charset__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.Ljava_nio_charset_Charset__f_cachedDecoder;
}
function $p_Ljava_nio_charset_Charset__cachedDecoder__Ljava_nio_charset_CharsetDecoder($thiz) {
  return (((((2 & $thiz.Ljava_nio_charset_Charset__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_nio_charset_Charset__cachedDecoder$lzycompute__Ljava_nio_charset_CharsetDecoder($thiz) : $thiz.Ljava_nio_charset_Charset__f_cachedDecoder);
}
function $ct_Ljava_nio_charset_Charset__T__AT__($thiz, canonicalName, _aliases) {
  $thiz.Ljava_nio_charset_Charset__f_canonicalName = canonicalName;
  return $thiz;
}
/** @constructor */
function $c_Ljava_nio_charset_Charset() {
  this.Ljava_nio_charset_Charset__f_cachedDecoder = null;
  this.Ljava_nio_charset_Charset__f_canonicalName = null;
  this.Ljava_nio_charset_Charset__f_bitmap$0 = 0;
}
$c_Ljava_nio_charset_Charset.prototype = new $h_O();
$c_Ljava_nio_charset_Charset.prototype.constructor = $c_Ljava_nio_charset_Charset;
/** @constructor */
function $h_Ljava_nio_charset_Charset() {
}
$h_Ljava_nio_charset_Charset.prototype = $c_Ljava_nio_charset_Charset.prototype;
$c_Ljava_nio_charset_Charset.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Ljava_nio_charset_Charset)) {
    var x2 = $as_Ljava_nio_charset_Charset(that);
    return (this.Ljava_nio_charset_Charset__f_canonicalName === $n(x2).Ljava_nio_charset_Charset__f_canonicalName);
  } else {
    return false;
  }
});
$c_Ljava_nio_charset_Charset.prototype.toString__T = (function() {
  return this.Ljava_nio_charset_Charset__f_canonicalName;
});
$c_Ljava_nio_charset_Charset.prototype.hashCode__I = (function() {
  return $f_T__hashCode__I($n(this.Ljava_nio_charset_Charset__f_canonicalName));
});
$c_Ljava_nio_charset_Charset.prototype.compareTo__O__I = (function(o) {
  var that = $as_Ljava_nio_charset_Charset(o);
  return $f_T__compareToIgnoreCase__T__I($n(this.Ljava_nio_charset_Charset__f_canonicalName), $n(that).Ljava_nio_charset_Charset__f_canonicalName);
});
function $as_Ljava_nio_charset_Charset(obj) {
  return (((obj instanceof $c_Ljava_nio_charset_Charset) || (obj === null)) ? obj : $throwClassCastException(obj, "java.nio.charset.Charset"));
}
function $isArrayOf_Ljava_nio_charset_Charset(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_nio_charset_Charset)));
}
function $asArrayOf_Ljava_nio_charset_Charset(obj, depth) {
  return (($isArrayOf_Ljava_nio_charset_Charset(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.nio.charset.Charset;", depth));
}
function $p_Ljava_nio_charset_UTF\uff3f8$Decoder__decodeLoopArray__Ljava_nio_ByteBuffer__Ljava_nio_CharBuffer__Ljava_nio_charset_CoderResult($thiz, in$1, out) {
  var this$1 = $n(in$1);
  var a = this$1.Ljava_nio_ByteBuffer__f__array;
  if ((a === null)) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (this$1.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var this$4 = $n(in$1);
  var o = this$4.Ljava_nio_ByteBuffer__f__arrayOffset;
  if ((o === (-1))) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (this$4.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var this$7 = $n(in$1);
  var inStart = ((this$7.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + o) | 0);
  var this$8 = $n(in$1);
  var inEnd = ((this$8.Ljava_nio_Buffer__f__limit + o) | 0);
  var this$9 = $n(out);
  var a$1 = this$9.Ljava_nio_CharBuffer__f__array;
  if ((a$1 === null)) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (this$9.isReadOnly__Z()) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var this$12 = $n(out);
  var o$1 = this$12.Ljava_nio_CharBuffer__f__arrayOffset;
  if ((o$1 === (-1))) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (this$12.isReadOnly__Z()) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var this$15 = $n(out);
  var outStart = ((this$15.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + o$1) | 0);
  var this$16 = $n(out);
  var outEnd = ((this$16.Ljava_nio_Buffer__f__limit + o$1) | 0);
  var inPos = inStart;
  var outPos = outStart;
  while (true) {
    if ((inPos === inEnd)) {
      var result = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
      var inPos$1 = inPos;
      var outPos$1 = outPos;
      var this$17 = $n(in$1);
      var newPosition = ((inPos$1 - o) | 0);
      $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$17, newPosition);
      var this$18 = $n(out);
      var newPosition$1 = ((outPos$1 - o$1) | 0);
      $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$18, newPosition$1);
      return result;
    } else {
      var leading = $n(a).get(inPos);
      if ((leading >= 0)) {
        if ((outPos === outEnd)) {
          var result$1 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
          var inPos$1$1 = inPos;
          var outPos$1$1 = outPos;
          var this$19 = $n(in$1);
          var newPosition$2 = ((inPos$1$1 - o) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$19, newPosition$2);
          var this$20 = $n(out);
          var newPosition$3 = ((outPos$1$1 - o$1) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$20, newPosition$3);
          return result$1;
        } else {
          $n(a$1).set(outPos, (65535 & leading));
          var temp$inPos = ((1 + inPos) | 0);
          var temp$outPos = ((1 + outPos) | 0);
          inPos = temp$inPos;
          outPos = temp$outPos;
        }
      } else {
        var length = $n($m_Ljava_nio_charset_UTF\uff3f8$().Ljava_nio_charset_UTF\uff3f8$__f_java$nio$charset$UTF_8$$lengthByLeading).get((127 & leading));
        if ((length === (-1))) {
          var this$21 = $m_Ljava_nio_charset_CoderResult$();
          var result$2 = this$21.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
          var inPos$1$2 = inPos;
          var outPos$1$2 = outPos;
          var this$22 = $n(in$1);
          var newPosition$4 = ((inPos$1$2 - o) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$22, newPosition$4);
          var this$23 = $n(out);
          var newPosition$5 = ((outPos$1$2 - o$1) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$23, newPosition$5);
          return result$2;
        } else {
          if ((((1 + inPos) | 0) >= inEnd)) {
            var failure = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
            var decoded__failure = failure;
            var decoded__high = 0;
            var decoded__low = 0;
          } else {
            var b2 = $n(a).get(((1 + inPos) | 0));
            var b = b2;
            if (((192 & b) !== 128)) {
              var this$25 = $m_Ljava_nio_charset_CoderResult$();
              var failure$1 = this$25.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
              var decoded__failure = failure$1;
              var decoded__high = 0;
              var decoded__low = 0;
            } else if ((length === 2)) {
              var b2$1 = b2;
              var codePoint = (((31 & leading) << 6) | (63 & b2$1));
              if ((codePoint < 128)) {
                var this$27 = $m_Ljava_nio_charset_CoderResult$();
                var failure$2 = this$27.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
                var decoded__failure = failure$2;
                var decoded__high = 0;
                var decoded__low = 0;
              } else {
                var single = (65535 & codePoint);
                var decoded__failure = null;
                var decoded__high = single;
                var decoded__low = 0;
              }
            } else if ((((2 + inPos) | 0) >= inEnd)) {
              var failure$3 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
              var decoded__failure = failure$3;
              var decoded__high = 0;
              var decoded__low = 0;
            } else {
              var b3 = $n(a).get(((2 + inPos) | 0));
              var b$1 = b3;
              if (((192 & b$1) !== 128)) {
                var this$31 = $m_Ljava_nio_charset_CoderResult$();
                var failure$4 = this$31.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed2;
                var decoded__failure = failure$4;
                var decoded__high = 0;
                var decoded__low = 0;
              } else if ((length === 3)) {
                var b2$2 = b2;
                var b3$1 = b3;
                var codePoint$1 = ((((15 & leading) << 12) | ((63 & b2$2) << 6)) | (63 & b3$1));
                if ((codePoint$1 < 2048)) {
                  var this$33 = $m_Ljava_nio_charset_CoderResult$();
                  var failure$5 = this$33.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
                  var decoded__failure = failure$5;
                  var decoded__high = 0;
                  var decoded__low = 0;
                } else if (((codePoint$1 >= 55296) && (codePoint$1 <= 57343))) {
                  var this$35 = $m_Ljava_nio_charset_CoderResult$();
                  var failure$6 = this$35.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed3;
                  var decoded__failure = failure$6;
                  var decoded__high = 0;
                  var decoded__low = 0;
                } else {
                  var single$1 = (65535 & codePoint$1);
                  var decoded__failure = null;
                  var decoded__high = single$1;
                  var decoded__low = 0;
                }
              } else if ((((3 + inPos) | 0) >= inEnd)) {
                var failure$7 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
                var decoded__failure = failure$7;
                var decoded__high = 0;
                var decoded__low = 0;
              } else {
                var b4 = $n(a).get(((3 + inPos) | 0));
                var b$2 = b4;
                if (((192 & b$2) !== 128)) {
                  var this$39 = $m_Ljava_nio_charset_CoderResult$();
                  var failure$8 = this$39.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed3;
                  var decoded__failure = failure$8;
                  var decoded__high = 0;
                  var decoded__low = 0;
                } else {
                  var b2$3 = b2;
                  var b3$2 = b3;
                  var b4$1 = b4;
                  var codePoint$2 = (((((7 & leading) << 18) | ((63 & b2$3) << 12)) | ((63 & b3$2) << 6)) | (63 & b4$1));
                  if (((codePoint$2 < 65536) || (codePoint$2 > 1114111))) {
                    var this$41 = $m_Ljava_nio_charset_CoderResult$();
                    var failure$9 = this$41.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
                    var decoded__failure = failure$9;
                    var decoded__high = 0;
                    var decoded__low = 0;
                  } else {
                    var offsetCodePoint = (((-65536) + codePoint$2) | 0);
                    var high = (65535 & (55296 | (offsetCodePoint >> 10)));
                    var low = (65535 & (56320 | (1023 & offsetCodePoint)));
                    var decoded__failure = null;
                    var decoded__high = high;
                    var decoded__low = low;
                  }
                }
              }
            }
          }
          if ((decoded__failure !== null)) {
            var result$3 = decoded__failure;
            var inPos$1$3 = inPos;
            var outPos$1$3 = outPos;
            var this$44 = $n(in$1);
            var newPosition$6 = ((inPos$1$3 - o) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$44, newPosition$6);
            var this$45 = $n(out);
            var newPosition$7 = ((outPos$1$3 - o$1) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$45, newPosition$7);
            return result$3;
          } else if ((decoded__low === 0)) {
            if ((outPos === outEnd)) {
              var result$4 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
              var inPos$1$4 = inPos;
              var outPos$1$4 = outPos;
              var this$46 = $n(in$1);
              var newPosition$8 = ((inPos$1$4 - o) | 0);
              $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$46, newPosition$8);
              var this$47 = $n(out);
              var newPosition$9 = ((outPos$1$4 - o$1) | 0);
              $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$47, newPosition$9);
              return result$4;
            } else {
              $n(a$1).set(outPos, decoded__high);
              var temp$inPos$2 = ((inPos + length) | 0);
              var temp$outPos$2 = ((1 + outPos) | 0);
              inPos = temp$inPos$2;
              outPos = temp$outPos$2;
            }
          } else if ((((2 + outPos) | 0) > outEnd)) {
            var result$5 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
            var inPos$1$5 = inPos;
            var outPos$1$5 = outPos;
            var this$48 = $n(in$1);
            var newPosition$10 = ((inPos$1$5 - o) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$48, newPosition$10);
            var this$49 = $n(out);
            var newPosition$11 = ((outPos$1$5 - o$1) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$49, newPosition$11);
            return result$5;
          } else {
            $n(a$1).set(outPos, decoded__high);
            $n(a$1).set(((1 + outPos) | 0), decoded__low);
            var temp$inPos$3 = ((inPos + length) | 0);
            var temp$outPos$3 = ((2 + outPos) | 0);
            inPos = temp$inPos$3;
            outPos = temp$outPos$3;
          }
        }
      }
    }
  }
}
/** @constructor */
function $c_Ljava_nio_charset_UTF\uff3f8$Decoder() {
  this.Ljava_nio_charset_CharsetDecoder__f__averageCharsPerByte = 0.0;
  this.Ljava_nio_charset_CharsetDecoder__f__replacement = null;
  this.Ljava_nio_charset_CharsetDecoder__f__malformedInputAction = null;
  this.Ljava_nio_charset_CharsetDecoder__f__unmappableCharacterAction = null;
  this.Ljava_nio_charset_CharsetDecoder__f_status = 0;
  $ct_Ljava_nio_charset_CharsetDecoder__Ljava_nio_charset_Charset__F__F__(this, $m_Ljava_nio_charset_UTF\uff3f8$(), 1.0, 1.0);
}
$c_Ljava_nio_charset_UTF\uff3f8$Decoder.prototype = new $h_Ljava_nio_charset_CharsetDecoder();
$c_Ljava_nio_charset_UTF\uff3f8$Decoder.prototype.constructor = $c_Ljava_nio_charset_UTF\uff3f8$Decoder;
/** @constructor */
function $h_Ljava_nio_charset_UTF\uff3f8$Decoder() {
}
$h_Ljava_nio_charset_UTF\uff3f8$Decoder.prototype = $c_Ljava_nio_charset_UTF\uff3f8$Decoder.prototype;
$c_Ljava_nio_charset_UTF\uff3f8$Decoder.prototype.decodeLoop__Ljava_nio_ByteBuffer__Ljava_nio_CharBuffer__Ljava_nio_charset_CoderResult = (function(in$1, out) {
  var this$1 = $n(in$1);
  if (((this$1.Ljava_nio_ByteBuffer__f__array !== null) && (!this$1.Ljava_nio_HeapByteBuffer__f__readOnly))) {
    var this$4 = $n(out);
    var $x_1 = ((this$4.Ljava_nio_CharBuffer__f__array !== null) && (!this$4.isReadOnly__Z()));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return $p_Ljava_nio_charset_UTF\uff3f8$Decoder__decodeLoopArray__Ljava_nio_ByteBuffer__Ljava_nio_CharBuffer__Ljava_nio_charset_CoderResult(this, in$1, out);
  } else {
    while (true) {
      var this$7 = $n(in$1);
      var startPosition = this$7.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
      var this$8 = $n(in$1);
      if ((!(this$8.Ljava_nio_Buffer__f_java$nio$Buffer$$_position !== this$8.Ljava_nio_Buffer__f__limit))) {
        return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
      } else {
        var leading = $n(in$1).get__B();
        if ((leading >= 0)) {
          var this$9 = $n(out);
          if ((!(this$9.Ljava_nio_Buffer__f_java$nio$Buffer$$_position !== this$9.Ljava_nio_Buffer__f__limit))) {
            var result = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
            var this$10 = $n(in$1);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$10, startPosition);
            return result;
          } else {
            $n(out).put__C__Ljava_nio_CharBuffer((65535 & leading));
          }
        } else {
          var length = $n($m_Ljava_nio_charset_UTF\uff3f8$().Ljava_nio_charset_UTF\uff3f8$__f_java$nio$charset$UTF_8$$lengthByLeading).get((127 & leading));
          if ((length === (-1))) {
            var this$11 = $m_Ljava_nio_charset_CoderResult$();
            var result$1 = this$11.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
            var this$12 = $n(in$1);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$12, startPosition);
            return result$1;
          } else {
            var this$13 = $n(in$1);
            if ((this$13.Ljava_nio_Buffer__f_java$nio$Buffer$$_position !== this$13.Ljava_nio_Buffer__f__limit)) {
              var b2 = $n(in$1).get__B();
              var b = b2;
              if (((192 & b) !== 128)) {
                var this$14 = $m_Ljava_nio_charset_CoderResult$();
                var failure = this$14.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
                var decoded__failure = failure;
                var decoded__high = 0;
                var decoded__low = 0;
              } else if ((length === 2)) {
                var b2$1 = b2;
                var codePoint = (((31 & leading) << 6) | (63 & b2$1));
                if ((codePoint < 128)) {
                  var this$16 = $m_Ljava_nio_charset_CoderResult$();
                  var failure$1 = this$16.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
                  var decoded__failure = failure$1;
                  var decoded__high = 0;
                  var decoded__low = 0;
                } else {
                  var single = (65535 & codePoint);
                  var decoded__failure = null;
                  var decoded__high = single;
                  var decoded__low = 0;
                }
              } else {
                var this$19 = $n(in$1);
                if ((this$19.Ljava_nio_Buffer__f_java$nio$Buffer$$_position !== this$19.Ljava_nio_Buffer__f__limit)) {
                  var b3 = $n(in$1).get__B();
                  var b$1 = b3;
                  if (((192 & b$1) !== 128)) {
                    var this$20 = $m_Ljava_nio_charset_CoderResult$();
                    var failure$2 = this$20.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed2;
                    var decoded__failure = failure$2;
                    var decoded__high = 0;
                    var decoded__low = 0;
                  } else if ((length === 3)) {
                    var b2$2 = b2;
                    var b3$1 = b3;
                    var codePoint$1 = ((((15 & leading) << 12) | ((63 & b2$2) << 6)) | (63 & b3$1));
                    if ((codePoint$1 < 2048)) {
                      var this$22 = $m_Ljava_nio_charset_CoderResult$();
                      var failure$3 = this$22.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
                      var decoded__failure = failure$3;
                      var decoded__high = 0;
                      var decoded__low = 0;
                    } else if (((codePoint$1 >= 55296) && (codePoint$1 <= 57343))) {
                      var this$24 = $m_Ljava_nio_charset_CoderResult$();
                      var failure$4 = this$24.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed3;
                      var decoded__failure = failure$4;
                      var decoded__high = 0;
                      var decoded__low = 0;
                    } else {
                      var single$1 = (65535 & codePoint$1);
                      var decoded__failure = null;
                      var decoded__high = single$1;
                      var decoded__low = 0;
                    }
                  } else {
                    var this$27 = $n(in$1);
                    if ((this$27.Ljava_nio_Buffer__f_java$nio$Buffer$$_position !== this$27.Ljava_nio_Buffer__f__limit)) {
                      var b4 = $n(in$1).get__B();
                      var b$2 = b4;
                      if (((192 & b$2) !== 128)) {
                        var this$28 = $m_Ljava_nio_charset_CoderResult$();
                        var failure$5 = this$28.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed3;
                        var decoded__failure = failure$5;
                        var decoded__high = 0;
                        var decoded__low = 0;
                      } else {
                        var b2$3 = b2;
                        var b3$2 = b3;
                        var b4$1 = b4;
                        var codePoint$2 = (((((7 & leading) << 18) | ((63 & b2$3) << 12)) | ((63 & b3$2) << 6)) | (63 & b4$1));
                        if (((codePoint$2 < 65536) || (codePoint$2 > 1114111))) {
                          var this$30 = $m_Ljava_nio_charset_CoderResult$();
                          var failure$6 = this$30.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
                          var decoded__failure = failure$6;
                          var decoded__high = 0;
                          var decoded__low = 0;
                        } else {
                          var offsetCodePoint = (((-65536) + codePoint$2) | 0);
                          var high = (65535 & (55296 | (offsetCodePoint >> 10)));
                          var low = (65535 & (56320 | (1023 & offsetCodePoint)));
                          var decoded__failure = null;
                          var decoded__high = high;
                          var decoded__low = low;
                        }
                      }
                    } else {
                      var failure$7 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
                      var decoded__failure = failure$7;
                      var decoded__high = 0;
                      var decoded__low = 0;
                    }
                  }
                } else {
                  var failure$8 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
                  var decoded__failure = failure$8;
                  var decoded__high = 0;
                  var decoded__low = 0;
                }
              }
            } else {
              var failure$9 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
              var decoded__failure = failure$9;
              var decoded__high = 0;
              var decoded__low = 0;
            }
            if ((decoded__failure !== null)) {
              var result$2 = decoded__failure;
              var this$36 = $n(in$1);
              $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$36, startPosition);
              return result$2;
            } else if ((decoded__low === 0)) {
              var this$37 = $n(out);
              if ((!(this$37.Ljava_nio_Buffer__f_java$nio$Buffer$$_position !== this$37.Ljava_nio_Buffer__f__limit))) {
                var result$3 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
                var this$38 = $n(in$1);
                $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$38, startPosition);
                return result$3;
              } else {
                $n(out).put__C__Ljava_nio_CharBuffer(decoded__high);
              }
            } else {
              var this$39 = $n(out);
              if ((((this$39.Ljava_nio_Buffer__f__limit - this$39.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) < 2)) {
                var result$4 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
                var this$40 = $n(in$1);
                $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$40, startPosition);
                return result$4;
              } else {
                $n(out).put__C__Ljava_nio_CharBuffer(decoded__high);
                $n(out).put__C__Ljava_nio_CharBuffer(decoded__low);
              }
            }
          }
        }
      }
    }
  }
});
var $d_Ljava_nio_charset_UTF\uff3f8$Decoder = new $TypeData().initClass($c_Ljava_nio_charset_UTF\uff3f8$Decoder, "java.nio.charset.UTF_8$Decoder", ({
  Ljava_nio_charset_UTF\uff3f8$Decoder: 1,
  Ljava_nio_charset_CharsetDecoder: 1
}));
function $p_Ljava_nio_charset_UTF\uff3f8$Encoder__encodeLoopArray__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer__Ljava_nio_charset_CoderResult($thiz, in$1, out) {
  var this$1 = $n(in$1);
  var a = this$1.Ljava_nio_CharBuffer__f__array;
  if ((a === null)) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (this$1.isReadOnly__Z()) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var this$4 = $n(in$1);
  var o = this$4.Ljava_nio_CharBuffer__f__arrayOffset;
  if ((o === (-1))) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (this$4.isReadOnly__Z()) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var this$7 = $n(in$1);
  var inStart = ((this$7.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + o) | 0);
  var this$8 = $n(in$1);
  var inEnd = ((this$8.Ljava_nio_Buffer__f__limit + o) | 0);
  var this$9 = $n(out);
  var a$1 = this$9.Ljava_nio_ByteBuffer__f__array;
  if ((a$1 === null)) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (this$9.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var this$12 = $n(out);
  var o$1 = this$12.Ljava_nio_ByteBuffer__f__arrayOffset;
  if ((o$1 === (-1))) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (this$12.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var this$15 = $n(out);
  var outStart = ((this$15.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + o$1) | 0);
  var this$16 = $n(out);
  var outEnd = ((this$16.Ljava_nio_Buffer__f__limit + o$1) | 0);
  var inPos = inStart;
  var outPos = outStart;
  while (true) {
    if ((inPos === inEnd)) {
      var result = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
      var inPos$2 = inPos;
      var outPos$2 = outPos;
      var this$17 = $n(in$1);
      var newPosition = ((inPos$2 - o) | 0);
      $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$17, newPosition);
      var this$18 = $n(out);
      var newPosition$1 = ((outPos$2 - o$1) | 0);
      $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$18, newPosition$1);
      return result;
    } else {
      var c1 = $n(a).get(inPos);
      if ((c1 < 128)) {
        if ((outPos === outEnd)) {
          var result$1 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
          var inPos$2$1 = inPos;
          var outPos$2$1 = outPos;
          var this$19 = $n(in$1);
          var newPosition$2 = ((inPos$2$1 - o) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$19, newPosition$2);
          var this$20 = $n(out);
          var newPosition$3 = ((outPos$2$1 - o$1) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$20, newPosition$3);
          return result$1;
        } else {
          $n(a$1).set(outPos, ((c1 << 24) >> 24));
          var temp$inPos = ((1 + inPos) | 0);
          var temp$outPos = ((1 + outPos) | 0);
          inPos = temp$inPos;
          outPos = temp$outPos;
        }
      } else if ((c1 < 2048)) {
        if ((((2 + outPos) | 0) > outEnd)) {
          var result$2 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
          var inPos$2$2 = inPos;
          var outPos$2$2 = outPos;
          var this$21 = $n(in$1);
          var newPosition$4 = ((inPos$2$2 - o) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$21, newPosition$4);
          var this$22 = $n(out);
          var newPosition$5 = ((outPos$2$2 - o$1) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$22, newPosition$5);
          return result$2;
        } else {
          $n(a$1).set(outPos, (((192 | (c1 >> 6)) << 24) >> 24));
          $n(a$1).set(((1 + outPos) | 0), (((128 | (63 & c1)) << 24) >> 24));
          var temp$inPos$2 = ((1 + inPos) | 0);
          var temp$outPos$2 = ((2 + outPos) | 0);
          inPos = temp$inPos$2;
          outPos = temp$outPos$2;
        }
      } else if ((!($m_Ljava_nio_charset_UTF\uff3f8$(), ((63488 & c1) === 55296)))) {
        if ((((3 + outPos) | 0) > outEnd)) {
          var result$3 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
          var inPos$2$3 = inPos;
          var outPos$2$3 = outPos;
          var this$24 = $n(in$1);
          var newPosition$6 = ((inPos$2$3 - o) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$24, newPosition$6);
          var this$25 = $n(out);
          var newPosition$7 = ((outPos$2$3 - o$1) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$25, newPosition$7);
          return result$3;
        } else {
          $n(a$1).set(outPos, (((224 | (c1 >> 12)) << 24) >> 24));
          $n(a$1).set(((1 + outPos) | 0), (((128 | (63 & (c1 >> 6))) << 24) >> 24));
          $n(a$1).set(((2 + outPos) | 0), (((128 | (63 & c1)) << 24) >> 24));
          var temp$inPos$3 = ((1 + inPos) | 0);
          var temp$outPos$3 = ((3 + outPos) | 0);
          inPos = temp$inPos$3;
          outPos = temp$outPos$3;
        }
      } else if (((64512 & c1) === 55296)) {
        if ((((1 + inPos) | 0) === inEnd)) {
          var result$4 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
          var inPos$2$4 = inPos;
          var outPos$2$4 = outPos;
          var this$27 = $n(in$1);
          var newPosition$8 = ((inPos$2$4 - o) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$27, newPosition$8);
          var this$28 = $n(out);
          var newPosition$9 = ((outPos$2$4 - o$1) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$28, newPosition$9);
          return result$4;
        } else {
          var c2 = $n(a).get(((1 + inPos) | 0));
          if (((64512 & c2) !== 56320)) {
            var this$30 = $m_Ljava_nio_charset_CoderResult$();
            var result$5 = this$30.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
            var inPos$2$5 = inPos;
            var outPos$2$5 = outPos;
            var this$31 = $n(in$1);
            var newPosition$10 = ((inPos$2$5 - o) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$31, newPosition$10);
            var this$32 = $n(out);
            var newPosition$11 = ((outPos$2$5 - o$1) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$32, newPosition$11);
            return result$5;
          } else if ((((4 + outPos) | 0) > outEnd)) {
            var result$6 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
            var inPos$2$6 = inPos;
            var outPos$2$6 = outPos;
            var this$33 = $n(in$1);
            var newPosition$12 = ((inPos$2$6 - o) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$33, newPosition$12);
            var this$34 = $n(out);
            var newPosition$13 = ((outPos$2$6 - o$1) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$34, newPosition$13);
            return result$6;
          } else {
            var cp = ((((64 + (1023 & c1)) | 0) << 10) | (1023 & c2));
            $n(a$1).set(outPos, (((240 | (cp >> 18)) << 24) >> 24));
            $n(a$1).set(((1 + outPos) | 0), (((128 | (63 & (cp >> 12))) << 24) >> 24));
            $n(a$1).set(((2 + outPos) | 0), (((128 | (63 & (cp >> 6))) << 24) >> 24));
            $n(a$1).set(((3 + outPos) | 0), (((128 | (63 & cp)) << 24) >> 24));
            var temp$inPos$4 = ((2 + inPos) | 0);
            var temp$outPos$4 = ((4 + outPos) | 0);
            inPos = temp$inPos$4;
            outPos = temp$outPos$4;
          }
        }
      } else {
        var this$36 = $m_Ljava_nio_charset_CoderResult$();
        var result$7 = this$36.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
        var inPos$2$7 = inPos;
        var outPos$2$7 = outPos;
        var this$37 = $n(in$1);
        var newPosition$14 = ((inPos$2$7 - o) | 0);
        $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$37, newPosition$14);
        var this$38 = $n(out);
        var newPosition$15 = ((outPos$2$7 - o$1) | 0);
        $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$38, newPosition$15);
        return result$7;
      }
    }
  }
}
/** @constructor */
function $c_Ljava_nio_charset_UTF\uff3f8$Encoder() {
  this.Ljava_nio_charset_CharsetEncoder__f__averageBytesPerChar = 0.0;
  this.Ljava_nio_charset_CharsetEncoder__f__replacement = null;
  this.Ljava_nio_charset_CharsetEncoder__f__malformedInputAction = null;
  this.Ljava_nio_charset_CharsetEncoder__f__unmappableCharacterAction = null;
  this.Ljava_nio_charset_CharsetEncoder__f_status = 0;
  $ct_Ljava_nio_charset_CharsetEncoder__Ljava_nio_charset_Charset__F__F__(this, $m_Ljava_nio_charset_UTF\uff3f8$(), 1.100000023841858, 3.0);
}
$c_Ljava_nio_charset_UTF\uff3f8$Encoder.prototype = new $h_Ljava_nio_charset_CharsetEncoder();
$c_Ljava_nio_charset_UTF\uff3f8$Encoder.prototype.constructor = $c_Ljava_nio_charset_UTF\uff3f8$Encoder;
/** @constructor */
function $h_Ljava_nio_charset_UTF\uff3f8$Encoder() {
}
$h_Ljava_nio_charset_UTF\uff3f8$Encoder.prototype = $c_Ljava_nio_charset_UTF\uff3f8$Encoder.prototype;
$c_Ljava_nio_charset_UTF\uff3f8$Encoder.prototype.encodeLoop__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer__Ljava_nio_charset_CoderResult = (function(in$1, out) {
  var this$1 = $n(in$1);
  if (((this$1.Ljava_nio_CharBuffer__f__array !== null) && (!this$1.isReadOnly__Z()))) {
    var this$4 = $n(out);
    var $x_1 = ((this$4.Ljava_nio_ByteBuffer__f__array !== null) && (!this$4.Ljava_nio_HeapByteBuffer__f__readOnly));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return $p_Ljava_nio_charset_UTF\uff3f8$Encoder__encodeLoopArray__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer__Ljava_nio_charset_CoderResult(this, in$1, out);
  } else {
    while (true) {
      var this$7 = $n(in$1);
      if ((!(this$7.Ljava_nio_Buffer__f_java$nio$Buffer$$_position !== this$7.Ljava_nio_Buffer__f__limit))) {
        return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
      } else {
        var c1 = $n(in$1).get__C();
        if ((c1 < 128)) {
          var this$8 = $n(out);
          if ((!(this$8.Ljava_nio_Buffer__f_java$nio$Buffer$$_position !== this$8.Ljava_nio_Buffer__f__limit))) {
            var result = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
            var this$10 = $n(in$1);
            var this$9 = $n(in$1);
            var newPosition = (((-1) + this$9.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$10, newPosition);
            return result;
          } else {
            $n(out).put__B__Ljava_nio_ByteBuffer(((c1 << 24) >> 24));
          }
        } else if ((c1 < 2048)) {
          var this$11 = $n(out);
          if ((((this$11.Ljava_nio_Buffer__f__limit - this$11.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) < 2)) {
            var result$1 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
            var this$13 = $n(in$1);
            var this$12 = $n(in$1);
            var newPosition$1 = (((-1) + this$12.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$13, newPosition$1);
            return result$1;
          } else {
            $n(out).put__B__Ljava_nio_ByteBuffer((((192 | (c1 >> 6)) << 24) >> 24));
            $n(out).put__B__Ljava_nio_ByteBuffer((((128 | (63 & c1)) << 24) >> 24));
          }
        } else if ((!($m_Ljava_nio_charset_UTF\uff3f8$(), ((63488 & c1) === 55296)))) {
          var this$15 = $n(out);
          if ((((this$15.Ljava_nio_Buffer__f__limit - this$15.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) < 3)) {
            var result$2 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
            var this$17 = $n(in$1);
            var this$16 = $n(in$1);
            var newPosition$2 = (((-1) + this$16.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$17, newPosition$2);
            return result$2;
          } else {
            $n(out).put__B__Ljava_nio_ByteBuffer((((224 | (c1 >> 12)) << 24) >> 24));
            $n(out).put__B__Ljava_nio_ByteBuffer((((128 | (63 & (c1 >> 6))) << 24) >> 24));
            $n(out).put__B__Ljava_nio_ByteBuffer((((128 | (63 & c1)) << 24) >> 24));
          }
        } else if (((64512 & c1) === 55296)) {
          var this$19 = $n(in$1);
          if ((!(this$19.Ljava_nio_Buffer__f_java$nio$Buffer$$_position !== this$19.Ljava_nio_Buffer__f__limit))) {
            var result$3 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
            var this$21 = $n(in$1);
            var this$20 = $n(in$1);
            var newPosition$3 = (((-1) + this$20.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$21, newPosition$3);
            return result$3;
          } else {
            var c2 = $n(in$1).get__C();
            if (((64512 & c2) !== 56320)) {
              var this$23 = $m_Ljava_nio_charset_CoderResult$();
              var result$4 = this$23.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
              var this$25 = $n(in$1);
              var this$24 = $n(in$1);
              var newPosition$4 = (((-2) + this$24.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
              $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$25, newPosition$4);
              return result$4;
            } else {
              var this$26 = $n(out);
              if ((((this$26.Ljava_nio_Buffer__f__limit - this$26.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) < 4)) {
                var result$5 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
                var this$28 = $n(in$1);
                var this$27 = $n(in$1);
                var newPosition$5 = (((-2) + this$27.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
                $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$28, newPosition$5);
                return result$5;
              } else {
                var cp = ((((64 + (1023 & c1)) | 0) << 10) | (1023 & c2));
                $n(out).put__B__Ljava_nio_ByteBuffer((((240 | (cp >> 18)) << 24) >> 24));
                $n(out).put__B__Ljava_nio_ByteBuffer((((128 | (63 & (cp >> 12))) << 24) >> 24));
                $n(out).put__B__Ljava_nio_ByteBuffer((((128 | (63 & (cp >> 6))) << 24) >> 24));
                $n(out).put__B__Ljava_nio_ByteBuffer((((128 | (63 & cp)) << 24) >> 24));
              }
            }
          }
        } else {
          var this$30 = $m_Ljava_nio_charset_CoderResult$();
          var result$6 = this$30.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
          var this$32 = $n(in$1);
          var this$31 = $n(in$1);
          var newPosition$6 = (((-1) + this$31.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$32, newPosition$6);
          return result$6;
        }
      }
    }
  }
});
var $d_Ljava_nio_charset_UTF\uff3f8$Encoder = new $TypeData().initClass($c_Ljava_nio_charset_UTF\uff3f8$Encoder, "java.nio.charset.UTF_8$Encoder", ({
  Ljava_nio_charset_UTF\uff3f8$Encoder: 1,
  Ljava_nio_charset_CharsetEncoder: 1
}));
/** @constructor */
function $c_ju_AbstractMap() {
}
$c_ju_AbstractMap.prototype = new $h_O();
$c_ju_AbstractMap.prototype.constructor = $c_ju_AbstractMap;
/** @constructor */
function $h_ju_AbstractMap() {
}
$h_ju_AbstractMap.prototype = $c_ju_AbstractMap.prototype;
$c_ju_AbstractMap.prototype.equals__O__Z = (function(o) {
  if ((o === this)) {
    return true;
  } else if ($is_ju_Map(o)) {
    var x2 = $as_ju_Map(o);
    if ((this.size__I() === $n(x2).size__I())) {
      var _\uff3fself = this.entrySet__ju_Set();
      var _\uff3fself$1 = $n(_\uff3fself).iterator__ju_Iterator();
      _return: {
        while ($n(_\uff3fself$1).hasNext__Z()) {
          var x$2 = $n(_\uff3fself$1).next__O();
          var item = $as_ju_Map$Entry(x$2);
          var $x_2 = $n(x2);
          var this$8 = $n(item);
          var a = $n($x_2).get__O__O(this$8.ju_HashMap$Node__f_key);
          var this$9 = $n(item);
          var b = this$9.ju_HashMap$Node__f_value;
          if ((!((a === null) ? (b === null) : $dp_equals__O__Z($n(a), b)))) {
            var $x_1 = true;
            break _return;
          }
        }
        var $x_1 = false;
      }
      return (!$x_1);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_ju_AbstractMap.prototype.hashCode__I = (function() {
  var _\uff3fself = this.entrySet__ju_Set();
  var _\uff3fself$1 = $n(_\uff3fself).iterator__ju_Iterator();
  var result = 0;
  while ($n(_\uff3fself$1).hasNext__Z()) {
    var prev$2 = result;
    var item$2 = $n(_\uff3fself$1).next__O();
    var prev = $uI(prev$2);
    var item = $as_ju_Map$Entry(item$2);
    result = (($n(item).hashCode__I() + prev) | 0);
  }
  return $uI(result);
});
$c_ju_AbstractMap.prototype.toString__T = (function() {
  var result = "{";
  var first = true;
  var iter = $n(this.entrySet__ju_Set()).iterator__ju_Iterator();
  while ($n(iter).hasNext__Z()) {
    var entry = $as_ju_Map$Entry($n(iter).next__O());
    if (first) {
      first = false;
    } else {
      result = (result + ", ");
    }
    var $x_2 = result;
    var this$1 = $n(entry);
    var $x_1 = this$1.ju_HashMap$Node__f_key;
    var this$2 = $n(entry);
    result = (((("" + $x_2) + $x_1) + "=") + this$2.ju_HashMap$Node__f_value);
  }
  return (result + "}");
});
/** @constructor */
function $c_ju_Arrays$NaturalComparator$() {
}
$c_ju_Arrays$NaturalComparator$.prototype = new $h_O();
$c_ju_Arrays$NaturalComparator$.prototype.constructor = $c_ju_Arrays$NaturalComparator$;
/** @constructor */
function $h_ju_Arrays$NaturalComparator$() {
}
$h_ju_Arrays$NaturalComparator$.prototype = $c_ju_Arrays$NaturalComparator$.prototype;
$c_ju_Arrays$NaturalComparator$.prototype.compare__O__O__I = (function(o1, o2) {
  return $dp_compareTo__O__I($n($as_jl_Comparable(o1)), o2);
});
var $d_ju_Arrays$NaturalComparator$ = new $TypeData().initClass($c_ju_Arrays$NaturalComparator$, "java.util.Arrays$NaturalComparator$", ({
  ju_Arrays$NaturalComparator$: 1,
  ju_Comparator: 1
}));
var $n_ju_Arrays$NaturalComparator$;
function $m_ju_Arrays$NaturalComparator$() {
  if ((!$n_ju_Arrays$NaturalComparator$)) {
    $n_ju_Arrays$NaturalComparator$ = new $c_ju_Arrays$NaturalComparator$();
  }
  return $n_ju_Arrays$NaturalComparator$;
}
function $is_ju_Collection(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Collection)));
}
function $as_ju_Collection(obj) {
  return (($is_ju_Collection(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Collection"));
}
function $isArrayOf_ju_Collection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Collection)));
}
function $asArrayOf_ju_Collection(obj, depth) {
  return (($isArrayOf_ju_Collection(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Collection;", depth));
}
/** @constructor */
function $c_ju_Formatter$RootLocaleInfo$() {
}
$c_ju_Formatter$RootLocaleInfo$.prototype = new $h_ju_Formatter$LocaleInfo();
$c_ju_Formatter$RootLocaleInfo$.prototype.constructor = $c_ju_Formatter$RootLocaleInfo$;
/** @constructor */
function $h_ju_Formatter$RootLocaleInfo$() {
}
$h_ju_Formatter$RootLocaleInfo$.prototype = $c_ju_Formatter$RootLocaleInfo$.prototype;
var $d_ju_Formatter$RootLocaleInfo$ = new $TypeData().initClass($c_ju_Formatter$RootLocaleInfo$, "java.util.Formatter$RootLocaleInfo$", ({
  ju_Formatter$RootLocaleInfo$: 1,
  ju_Formatter$LocaleInfo: 1
}));
var $n_ju_Formatter$RootLocaleInfo$;
function $m_ju_Formatter$RootLocaleInfo$() {
  if ((!$n_ju_Formatter$RootLocaleInfo$)) {
    $n_ju_Formatter$RootLocaleInfo$ = new $c_ju_Formatter$RootLocaleInfo$();
  }
  return $n_ju_Formatter$RootLocaleInfo$;
}
function $ct_ju_HashMap$AbstractHashMapIterator__ju_HashMap__($thiz, outer) {
  $n(outer);
  $thiz.ju_HashMap$AbstractHashMapIterator__f_$outer = outer;
  $thiz.ju_HashMap$AbstractHashMapIterator__f_len = $n($n(outer).ju_HashMap__f_java$util$HashMap$$table).u.length;
  return $thiz;
}
/** @constructor */
function $c_ju_HashMap$AbstractHashMapIterator() {
  this.ju_HashMap$AbstractHashMapIterator__f_len = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextIdx = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_$outer = null;
}
$c_ju_HashMap$AbstractHashMapIterator.prototype = new $h_O();
$c_ju_HashMap$AbstractHashMapIterator.prototype.constructor = $c_ju_HashMap$AbstractHashMapIterator;
/** @constructor */
function $h_ju_HashMap$AbstractHashMapIterator() {
}
$h_ju_HashMap$AbstractHashMapIterator.prototype = $c_ju_HashMap$AbstractHashMapIterator.prototype;
$c_ju_HashMap$AbstractHashMapIterator.prototype.hasNext__Z = (function() {
  if ((this.ju_HashMap$AbstractHashMapIterator__f_nextNode !== null)) {
    return true;
  } else {
    while ((this.ju_HashMap$AbstractHashMapIterator__f_nextIdx < this.ju_HashMap$AbstractHashMapIterator__f_len)) {
      var node = $n($n(this.ju_HashMap$AbstractHashMapIterator__f_$outer).ju_HashMap__f_java$util$HashMap$$table).get(this.ju_HashMap$AbstractHashMapIterator__f_nextIdx);
      this.ju_HashMap$AbstractHashMapIterator__f_nextIdx = ((1 + this.ju_HashMap$AbstractHashMapIterator__f_nextIdx) | 0);
      if ((node !== null)) {
        this.ju_HashMap$AbstractHashMapIterator__f_nextNode = node;
        return true;
      }
    }
    return false;
  }
});
$c_ju_HashMap$AbstractHashMapIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator");
  }
  var node = this.ju_HashMap$AbstractHashMapIterator__f_nextNode;
  this.ju_HashMap$AbstractHashMapIterator__f_nextNode = $n(node).ju_HashMap$Node__f_next;
  return node;
});
function $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__($thiz, key, hash, value, previous, next) {
  $thiz.ju_HashMap$Node__f_key = key;
  $thiz.ju_HashMap$Node__f_hash = hash;
  $thiz.ju_HashMap$Node__f_value = value;
  $thiz.ju_HashMap$Node__f_previous = previous;
  $thiz.ju_HashMap$Node__f_next = next;
  return $thiz;
}
/** @constructor */
function $c_ju_HashMap$Node() {
  this.ju_HashMap$Node__f_key = null;
  this.ju_HashMap$Node__f_hash = 0;
  this.ju_HashMap$Node__f_value = null;
  this.ju_HashMap$Node__f_previous = null;
  this.ju_HashMap$Node__f_next = null;
}
$c_ju_HashMap$Node.prototype = new $h_O();
$c_ju_HashMap$Node.prototype.constructor = $c_ju_HashMap$Node;
/** @constructor */
function $h_ju_HashMap$Node() {
}
$h_ju_HashMap$Node.prototype = $c_ju_HashMap$Node.prototype;
$c_ju_HashMap$Node.prototype.equals__O__Z = (function(that) {
  if ($is_ju_Map$Entry(that)) {
    var x2 = $as_ju_Map$Entry(that);
    var a = this.ju_HashMap$Node__f_key;
    var this$1 = $n(x2);
    var b = this$1.ju_HashMap$Node__f_key;
    if (((a === null) ? (b === null) : $dp_equals__O__Z($n(a), b))) {
      var a$1 = this.ju_HashMap$Node__f_value;
      var this$3 = $n(x2);
      var b$1 = this$3.ju_HashMap$Node__f_value;
      return ((a$1 === null) ? (b$1 === null) : $dp_equals__O__Z($n(a$1), b$1));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_ju_HashMap$Node.prototype.hashCode__I = (function() {
  var improvedHash = this.ju_HashMap$Node__f_hash;
  var o = this.ju_HashMap$Node__f_value;
  return ((improvedHash ^ ((improvedHash >>> 16) | 0)) ^ ((o === null) ? 0 : $dp_hashCode__I($n(o))));
});
$c_ju_HashMap$Node.prototype.toString__T = (function() {
  return ((this.ju_HashMap$Node__f_key + "=") + this.ju_HashMap$Node__f_value);
});
function $as_ju_HashMap$Node(obj) {
  return (((obj instanceof $c_ju_HashMap$Node) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.HashMap$Node"));
}
function $isArrayOf_ju_HashMap$Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_HashMap$Node)));
}
function $asArrayOf_ju_HashMap$Node(obj, depth) {
  return (($isArrayOf_ju_HashMap$Node(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.HashMap$Node;", depth));
}
var $d_ju_HashMap$Node = new $TypeData().initClass(0, "java.util.HashMap$Node", ({
  ju_HashMap$Node: 1,
  ju_Map$Entry: 1
}));
function $p_ju_Random__loop$1__I__I($thiz, n$1) {
  while (true) {
    var bits = $thiz.next__I__I(31);
    var value = $intMod(bits, n$1);
    if ((((((bits - value) | 0) + (((-1) + n$1) | 0)) | 0) < 0)) {
    } else {
      return value;
    }
  }
}
function $ct_ju_Random__J__($thiz, seed_in) {
  $thiz.setSeed__J__V(seed_in);
  return $thiz;
}
function $ct_ju_Random__($thiz) {
  $ct_ju_Random__J__($thiz, $m_ju_Random$().java$util$Random$$randomSeed__J());
  return $thiz;
}
/** @constructor */
function $c_ju_Random() {
  this.ju_Random__f_seedHi = 0;
  this.ju_Random__f_seedLo = 0;
}
$c_ju_Random.prototype = new $h_O();
$c_ju_Random.prototype.constructor = $c_ju_Random;
/** @constructor */
function $h_ju_Random() {
}
$h_ju_Random.prototype = $c_ju_Random.prototype;
$c_ju_Random.prototype.setSeed__J__V = (function(seed_in) {
  var lo = ((-554899859) ^ seed_in.RTLong__f_lo);
  var hi = (5 ^ seed_in.RTLong__f_hi);
  var hi$1 = (65535 & hi);
  var lo$1 = (((lo >>> 24) | 0) | (hi$1 << 8));
  this.ju_Random__f_seedHi = lo$1;
  this.ju_Random__f_seedLo = (16777215 & lo);
});
$c_ju_Random.prototype.next__I__I = (function(bits) {
  var oldSeedHi = this.ju_Random__f_seedHi;
  var oldSeedLo = this.ju_Random__f_seedLo;
  var loProd = ((1.5525485E7 * oldSeedLo) + 11.0);
  var hiProd = ((1502.0 * oldSeedLo) + (1.5525485E7 * oldSeedHi));
  var x = (loProd / 1.6777216E7);
  var newSeedHi = (16777215 & (($uI((x | 0)) + (16777215 & $uI((hiProd | 0)))) | 0));
  var newSeedLo = (16777215 & $uI((loProd | 0)));
  this.ju_Random__f_seedHi = newSeedHi;
  this.ju_Random__f_seedLo = newSeedLo;
  var result32 = ((newSeedHi << 8) | (newSeedLo >> 16));
  return ((result32 >>> ((32 - bits) | 0)) | 0);
});
$c_ju_Random.prototype.nextInt__I__I = (function(n) {
  if ((n <= 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "n must be positive");
  } else {
    return (((n & ((-n) | 0)) === n) ? (this.next__I__I(31) >> $uI(Math.clz32(n))) : $p_ju_Random__loop$1__I__I(this, n));
  }
});
var $d_ju_Random = new $TypeData().initClass($c_ju_Random, "java.util.Random", ({
  ju_Random: 1,
  Ljava_io_Serializable: 1
}));
function $p_ju_Random$__randomInt__I($thiz) {
  var a = (4.294967296E9 * $uD(Math.random()));
  return $doubleToInt(($uD(Math.floor(a)) - 2.147483648E9));
}
/** @constructor */
function $c_ju_Random$() {
}
$c_ju_Random$.prototype = new $h_O();
$c_ju_Random$.prototype.constructor = $c_ju_Random$;
/** @constructor */
function $h_ju_Random$() {
}
$h_ju_Random$.prototype = $c_ju_Random$.prototype;
$c_ju_Random$.prototype.java$util$Random$$randomSeed__J = (function() {
  var value = $p_ju_Random$__randomInt__I(this);
  var value$1 = $p_ju_Random$__randomInt__I(this);
  return new $c_RTLong(value$1, value);
});
var $d_ju_Random$ = new $TypeData().initClass($c_ju_Random$, "java.util.Random$", ({
  ju_Random$: 1,
  Ljava_io_Serializable: 1
}));
var $n_ju_Random$;
function $m_ju_Random$() {
  if ((!$n_ju_Random$)) {
    $n_ju_Random$ = new $c_ju_Random$();
  }
  return $n_ju_Random$;
}
function $ct_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__ju_concurrent_ConcurrentHashMap$InnerHashMap__($thiz, outer) {
  $n(outer);
  var this$1 = $n($n(outer).java$util$concurrent$ConcurrentHashMap$InnerHashMap$$makeSnapshot__ju_ArrayList());
  $thiz.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter = this$1.listIterator__I__ju_ListIterator(0);
  return $thiz;
}
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator() {
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter = null;
}
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype = new $h_O();
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator() {
}
$h_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype;
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype.hasNext__Z = (function() {
  return $n(this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter).hasNext__Z();
});
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype.next__O = (function() {
  var node = $as_ju_HashMap$Node($n(this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter).next__O());
  return this.extract__ju_HashMap$Node__O(node);
});
/** @constructor */
function $c_ju_concurrent_ThreadLocalRandom$() {
  this.ju_concurrent_ThreadLocalRandom$__f__current = null;
  $n_ju_concurrent_ThreadLocalRandom$ = this;
  this.ju_concurrent_ThreadLocalRandom$__f__current = new $c_ju_concurrent_ThreadLocalRandom();
}
$c_ju_concurrent_ThreadLocalRandom$.prototype = new $h_O();
$c_ju_concurrent_ThreadLocalRandom$.prototype.constructor = $c_ju_concurrent_ThreadLocalRandom$;
/** @constructor */
function $h_ju_concurrent_ThreadLocalRandom$() {
}
$h_ju_concurrent_ThreadLocalRandom$.prototype = $c_ju_concurrent_ThreadLocalRandom$.prototype;
var $d_ju_concurrent_ThreadLocalRandom$ = new $TypeData().initClass($c_ju_concurrent_ThreadLocalRandom$, "java.util.concurrent.ThreadLocalRandom$", ({
  ju_concurrent_ThreadLocalRandom$: 1,
  Ljava_io_Serializable: 1
}));
var $n_ju_concurrent_ThreadLocalRandom$;
function $m_ju_concurrent_ThreadLocalRandom$() {
  if ((!$n_ju_concurrent_ThreadLocalRandom$)) {
    $n_ju_concurrent_ThreadLocalRandom$ = new $c_ju_concurrent_ThreadLocalRandom$();
  }
  return $n_ju_concurrent_ThreadLocalRandom$;
}
/** @constructor */
function $c_ju_concurrent_TimeUnit$() {
  this.ju_concurrent_TimeUnit$__f_NANOSECONDS = null;
  this.ju_concurrent_TimeUnit$__f_MICROSECONDS = null;
  this.ju_concurrent_TimeUnit$__f_MILLISECONDS = null;
  this.ju_concurrent_TimeUnit$__f_SECONDS = null;
  this.ju_concurrent_TimeUnit$__f_MINUTES = null;
  this.ju_concurrent_TimeUnit$__f_HOURS = null;
  this.ju_concurrent_TimeUnit$__f_DAYS = null;
  $n_ju_concurrent_TimeUnit$ = this;
  this.ju_concurrent_TimeUnit$__f_NANOSECONDS = new $c_ju_concurrent_TimeUnit$$anon$1();
  this.ju_concurrent_TimeUnit$__f_MICROSECONDS = new $c_ju_concurrent_TimeUnit$$anon$2();
  this.ju_concurrent_TimeUnit$__f_MILLISECONDS = new $c_ju_concurrent_TimeUnit$$anon$3();
  this.ju_concurrent_TimeUnit$__f_SECONDS = new $c_ju_concurrent_TimeUnit$$anon$4();
  this.ju_concurrent_TimeUnit$__f_MINUTES = new $c_ju_concurrent_TimeUnit$$anon$5();
  this.ju_concurrent_TimeUnit$__f_HOURS = new $c_ju_concurrent_TimeUnit$$anon$6();
  this.ju_concurrent_TimeUnit$__f_DAYS = new $c_ju_concurrent_TimeUnit$$anon$7();
}
$c_ju_concurrent_TimeUnit$.prototype = new $h_O();
$c_ju_concurrent_TimeUnit$.prototype.constructor = $c_ju_concurrent_TimeUnit$;
/** @constructor */
function $h_ju_concurrent_TimeUnit$() {
}
$h_ju_concurrent_TimeUnit$.prototype = $c_ju_concurrent_TimeUnit$.prototype;
$c_ju_concurrent_TimeUnit$.prototype.java$util$concurrent$TimeUnit$$x__J__J__J__J = (function(a, b, max) {
  var ahi = a.RTLong__f_hi;
  var bhi = max.RTLong__f_hi;
  if (((ahi === bhi) ? (((-2147483648) ^ a.RTLong__f_lo) > ((-2147483648) ^ max.RTLong__f_lo)) : (ahi > bhi))) {
    return new $c_RTLong((-1), 2147483647);
  } else {
    var lo = max.RTLong__f_lo;
    var hi = max.RTLong__f_hi;
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    var ahi$1 = a.RTLong__f_hi;
    if (((ahi$1 === hi$1) ? (((-2147483648) ^ a.RTLong__f_lo) < ((-2147483648) ^ lo$1)) : (ahi$1 < hi$1))) {
      return new $c_RTLong(1, (-2147483648));
    } else {
      var alo = a.RTLong__f_lo;
      var blo = b.RTLong__f_lo;
      var a0 = (65535 & alo);
      var a1 = ((alo >>> 16) | 0);
      var b0 = (65535 & blo);
      var b1 = ((blo >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$2 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(a.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      return new $c_RTLong(lo$2, hi$2);
    }
  }
});
var $d_ju_concurrent_TimeUnit$ = new $TypeData().initClass($c_ju_concurrent_TimeUnit$, "java.util.concurrent.TimeUnit$", ({
  ju_concurrent_TimeUnit$: 1,
  Ljava_io_Serializable: 1
}));
var $n_ju_concurrent_TimeUnit$;
function $m_ju_concurrent_TimeUnit$() {
  if ((!$n_ju_concurrent_TimeUnit$)) {
    $n_ju_concurrent_TimeUnit$ = new $c_ju_concurrent_TimeUnit$();
  }
  return $n_ju_concurrent_TimeUnit$;
}
function $ct_ju_concurrent_atomic_AtomicBoolean__Z__($thiz, value) {
  $thiz.ju_concurrent_atomic_AtomicBoolean__f_value = value;
  return $thiz;
}
/** @constructor */
function $c_ju_concurrent_atomic_AtomicBoolean() {
  this.ju_concurrent_atomic_AtomicBoolean__f_value = false;
}
$c_ju_concurrent_atomic_AtomicBoolean.prototype = new $h_O();
$c_ju_concurrent_atomic_AtomicBoolean.prototype.constructor = $c_ju_concurrent_atomic_AtomicBoolean;
/** @constructor */
function $h_ju_concurrent_atomic_AtomicBoolean() {
}
$h_ju_concurrent_atomic_AtomicBoolean.prototype = $c_ju_concurrent_atomic_AtomicBoolean.prototype;
$c_ju_concurrent_atomic_AtomicBoolean.prototype.compareAndSet__Z__Z__Z = (function(expect, update) {
  if ((expect === this.ju_concurrent_atomic_AtomicBoolean__f_value)) {
    this.ju_concurrent_atomic_AtomicBoolean__f_value = update;
    return true;
  } else {
    return false;
  }
});
$c_ju_concurrent_atomic_AtomicBoolean.prototype.getAndSet__Z__Z = (function(newValue) {
  var old = this.ju_concurrent_atomic_AtomicBoolean__f_value;
  this.ju_concurrent_atomic_AtomicBoolean__f_value = newValue;
  return old;
});
$c_ju_concurrent_atomic_AtomicBoolean.prototype.toString__T = (function() {
  var this$1 = this.ju_concurrent_atomic_AtomicBoolean__f_value;
  return ("" + this$1);
});
function $as_ju_concurrent_atomic_AtomicBoolean(obj) {
  return (((obj instanceof $c_ju_concurrent_atomic_AtomicBoolean) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.concurrent.atomic.AtomicBoolean"));
}
function $isArrayOf_ju_concurrent_atomic_AtomicBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_concurrent_atomic_AtomicBoolean)));
}
function $asArrayOf_ju_concurrent_atomic_AtomicBoolean(obj, depth) {
  return (($isArrayOf_ju_concurrent_atomic_AtomicBoolean(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.concurrent.atomic.AtomicBoolean;", depth));
}
var $d_ju_concurrent_atomic_AtomicBoolean = new $TypeData().initClass($c_ju_concurrent_atomic_AtomicBoolean, "java.util.concurrent.atomic.AtomicBoolean", ({
  ju_concurrent_atomic_AtomicBoolean: 1,
  Ljava_io_Serializable: 1
}));
function $ct_ju_concurrent_atomic_AtomicReference__O__($thiz, value) {
  $thiz.ju_concurrent_atomic_AtomicReference__f_value = value;
  return $thiz;
}
function $ct_ju_concurrent_atomic_AtomicReference__($thiz) {
  $ct_ju_concurrent_atomic_AtomicReference__O__($thiz, null);
  return $thiz;
}
/** @constructor */
function $c_ju_concurrent_atomic_AtomicReference() {
  this.ju_concurrent_atomic_AtomicReference__f_value = null;
}
$c_ju_concurrent_atomic_AtomicReference.prototype = new $h_O();
$c_ju_concurrent_atomic_AtomicReference.prototype.constructor = $c_ju_concurrent_atomic_AtomicReference;
/** @constructor */
function $h_ju_concurrent_atomic_AtomicReference() {
}
$h_ju_concurrent_atomic_AtomicReference.prototype = $c_ju_concurrent_atomic_AtomicReference.prototype;
$c_ju_concurrent_atomic_AtomicReference.prototype.compareAndSet__O__O__Z = (function(expect, update) {
  if (Object.is(expect, this.ju_concurrent_atomic_AtomicReference__f_value)) {
    this.ju_concurrent_atomic_AtomicReference__f_value = update;
    return true;
  } else {
    return false;
  }
});
$c_ju_concurrent_atomic_AtomicReference.prototype.getAndSet__O__O = (function(newValue) {
  var old = this.ju_concurrent_atomic_AtomicReference__f_value;
  this.ju_concurrent_atomic_AtomicReference__f_value = newValue;
  return old;
});
$c_ju_concurrent_atomic_AtomicReference.prototype.toString__T = (function() {
  var obj = this.ju_concurrent_atomic_AtomicReference__f_value;
  return ("" + obj);
});
var $d_ju_concurrent_atomic_AtomicReference = new $TypeData().initClass($c_ju_concurrent_atomic_AtomicReference, "java.util.concurrent.atomic.AtomicReference", ({
  ju_concurrent_atomic_AtomicReference: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$() {
}
$c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype = new $h_O();
$c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype.constructor = $c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$() {
}
$h_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype = $c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype;
$c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype.set__O__I__O__V = (function(a, i, v) {
  var a$1 = $asArrayOf_O(a, 1);
  $n(a$1).set(i, v);
});
$c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype.get__O__I__O = (function(a, i) {
  var a$1 = $asArrayOf_O(a, 1);
  return $n(a$1).get(i);
});
var $d_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$ = new $TypeData().initClass($c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$, "java.util.internal.GenericArrayOps$ReusableAnyRefArrayOps$", ({
  ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$: 1,
  ju_internal_GenericArrayOps$ArrayOps: 1
}));
var $n_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$;
function $m_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$)) {
    $n_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$ = new $c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$;
}
function $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher($thiz) {
  $thiz.ju_regex_Matcher__f_position = 0;
  $thiz.ju_regex_Matcher__f_lastMatch = null;
  $thiz.ju_regex_Matcher__f_appendPos = 0;
  return $thiz;
}
function $p_ju_regex_Matcher__ensureLastMatch__O($thiz) {
  if (($thiz.ju_regex_Matcher__f_lastMatch === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "No match available");
  }
  return $thiz.ju_regex_Matcher__f_lastMatch;
}
/** @constructor */
function $c_ju_regex_Matcher(pattern0, input0) {
  this.ju_regex_Matcher__f_pattern0 = null;
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0 = null;
  this.ju_regex_Matcher__f_regionStart0 = 0;
  this.ju_regex_Matcher__f_inputstr = null;
  this.ju_regex_Matcher__f_position = 0;
  this.ju_regex_Matcher__f_lastMatch = null;
  this.ju_regex_Matcher__f_appendPos = 0;
  this.ju_regex_Matcher__f_pattern0 = pattern0;
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0 = input0;
  this.ju_regex_Matcher__f_regionStart0 = 0;
  $n(this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0);
  this.ju_regex_Matcher__f_inputstr = this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0;
  this.ju_regex_Matcher__f_position = 0;
  this.ju_regex_Matcher__f_lastMatch = null;
  this.ju_regex_Matcher__f_appendPos = 0;
}
$c_ju_regex_Matcher.prototype = new $h_O();
$c_ju_regex_Matcher.prototype.constructor = $c_ju_regex_Matcher;
/** @constructor */
function $h_ju_regex_Matcher() {
}
$h_ju_regex_Matcher.prototype = $c_ju_regex_Matcher.prototype;
$c_ju_regex_Matcher.prototype.matches__Z = (function() {
  $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher(this);
  this.ju_regex_Matcher__f_lastMatch = $n(this.ju_regex_Matcher__f_pattern0).execMatches__T__O(this.ju_regex_Matcher__f_inputstr);
  return (this.ju_regex_Matcher__f_lastMatch !== null);
});
$c_ju_regex_Matcher.prototype.find__Z = (function() {
  var this$1 = $n(this.ju_regex_Matcher__f_pattern0);
  var input = this.ju_regex_Matcher__f_inputstr;
  var start = this.ju_regex_Matcher__f_position;
  var mtch = this$1.java$util$regex$Pattern$$execFindInternal__T__I__O(input, start);
  var end = $uI(this$1.ju_regex_Pattern__f_java$util$regex$Pattern$$jsRegExpForFind.lastIndex);
  if ((mtch !== null)) {
    var $x_1 = ((end === $uI(mtch.index)) ? ((1 + end) | 0) : end);
  } else {
    var this$2 = $n(this.ju_regex_Matcher__f_inputstr);
    var $x_1 = ((1 + this$2.length) | 0);
  }
  this.ju_regex_Matcher__f_position = $x_1;
  this.ju_regex_Matcher__f_lastMatch = mtch;
  return (mtch !== null);
});
$c_ju_regex_Matcher.prototype.appendReplacement__jl_StringBuffer__T__ju_regex_Matcher = (function(sb, replacement) {
  var $x_1 = $n(sb);
  var this$1 = $n(this.ju_regex_Matcher__f_inputstr);
  var beginIndex = this.ju_regex_Matcher__f_appendPos;
  var endIndex = this.start__I();
  if ((beginIndex < 0)) {
    $charAt(this$1, beginIndex);
  }
  if ((endIndex > this$1.length)) {
    $charAt(this$1, endIndex);
  }
  if ((endIndex < beginIndex)) {
    $charAt(this$1, (-1));
  }
  $n($x_1).append__T__jl_StringBuffer($as_T(this$1.substring(beginIndex, endIndex)));
  var this$2 = $n(replacement);
  var len = this$2.length;
  var i = 0;
  while ((i < len)) {
    var this$3 = $n(replacement);
    var index = i;
    var x1 = $charAt(this$3, index);
    switch (x1) {
      case 36: {
        i = ((1 + i) | 0);
        var j = i;
        while (true) {
          if ((i < len)) {
            var this$4 = $n(replacement);
            var index$1 = i;
            var c = $charAt(this$4, index$1);
            var $x_2 = ((c >= 48) && (c <= 57));
          } else {
            var $x_2 = false;
          }
          if ($x_2) {
            i = ((1 + i) | 0);
          } else {
            break;
          }
        }
        var this$6 = $m_jl_Integer$();
        var this$5 = $n(replacement);
        var endIndex$1 = i;
        if ((j < 0)) {
          $charAt(this$5, j);
        }
        if ((endIndex$1 > this$5.length)) {
          $charAt(this$5, endIndex$1);
        }
        if ((endIndex$1 < j)) {
          $charAt(this$5, (-1));
        }
        var s = $as_T(this$5.substring(j, endIndex$1));
        var group = this$6.parseInt__T__I__I(s, 10);
        var replaced = this.group__I__T(group);
        if ((replaced !== null)) {
          $n(sb).append__T__jl_StringBuffer(replaced);
        }
        break;
      }
      case 92: {
        i = ((1 + i) | 0);
        if ((i < len)) {
          var $x_3 = $n(sb);
          var this$7 = $n(replacement);
          var index$2 = i;
          $n($x_3).append__C__jl_StringBuffer($charAt(this$7, index$2));
        }
        i = ((1 + i) | 0);
        break;
      }
      default: {
        $n(sb).append__C__jl_StringBuffer(x1);
        i = ((1 + i) | 0);
      }
    }
  }
  this.ju_regex_Matcher__f_appendPos = this.end__I();
  return this;
});
$c_ju_regex_Matcher.prototype.appendTail__jl_StringBuffer__jl_StringBuffer = (function(sb) {
  var $x_1 = $n(sb);
  var this$1 = $n(this.ju_regex_Matcher__f_inputstr);
  var beginIndex = this.ju_regex_Matcher__f_appendPos;
  if (((beginIndex < 0) || (beginIndex > this$1.length))) {
    $charAt(this$1, beginIndex);
  }
  $n($x_1).append__T__jl_StringBuffer($as_T(this$1.substring(beginIndex)));
  var this$2 = $n(this.ju_regex_Matcher__f_inputstr);
  this.ju_regex_Matcher__f_appendPos = this$2.length;
  return sb;
});
$c_ju_regex_Matcher.prototype.replaceFirst__T__T = (function(replacement) {
  this.reset__ju_regex_Matcher();
  if (this.find__Z()) {
    var sb = $ct_jl_StringBuffer__(new $c_jl_StringBuffer());
    this.appendReplacement__jl_StringBuffer__T__ju_regex_Matcher(sb, replacement);
    this.appendTail__jl_StringBuffer__jl_StringBuffer(sb);
    return sb.toString__T();
  } else {
    return this.ju_regex_Matcher__f_inputstr;
  }
});
$c_ju_regex_Matcher.prototype.replaceAll__T__T = (function(replacement) {
  this.reset__ju_regex_Matcher();
  var sb = $ct_jl_StringBuffer__(new $c_jl_StringBuffer());
  while (this.find__Z()) {
    this.appendReplacement__jl_StringBuffer__T__ju_regex_Matcher(sb, replacement);
  }
  this.appendTail__jl_StringBuffer__jl_StringBuffer(sb);
  return sb.toString__T();
});
$c_ju_regex_Matcher.prototype.reset__ju_regex_Matcher = (function() {
  this.ju_regex_Matcher__f_regionStart0 = 0;
  $n(this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0);
  this.ju_regex_Matcher__f_inputstr = this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0;
  return $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher(this);
});
$c_ju_regex_Matcher.prototype.start__I = (function() {
  return (($uI($p_ju_regex_Matcher__ensureLastMatch__O(this).index) + this.ju_regex_Matcher__f_regionStart0) | 0);
});
$c_ju_regex_Matcher.prototype.end__I = (function() {
  var $x_1 = this.start__I();
  var this$1 = $n(this.group__T());
  return (($x_1 + this$1.length) | 0);
});
$c_ju_regex_Matcher.prototype.group__T = (function() {
  var x = $p_ju_regex_Matcher__ensureLastMatch__O(this)[0];
  return $as_T(x);
});
$c_ju_regex_Matcher.prototype.group__I__T = (function(group) {
  var x = $p_ju_regex_Matcher__ensureLastMatch__O(this)[$n(this.ju_regex_Matcher__f_pattern0).numberedGroup__I__I(group)];
  return $as_T(((x !== (void 0)) ? x : null));
});
var $d_ju_regex_Matcher = new $TypeData().initClass($c_ju_regex_Matcher, "java.util.regex.Matcher", ({
  ju_regex_Matcher: 1,
  ju_regex_MatchResult: 1
}));
/** @constructor */
function $c_ju_regex_Pattern(_pattern, _flags, jsPattern, jsFlags, sticky, groupCount, groupNumberMap, namedGroups) {
  this.ju_regex_Pattern__f__pattern = null;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsFlags = null;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$sticky = false;
  this.ju_regex_Pattern__f_groupCount = 0;
  this.ju_regex_Pattern__f_groupNumberMap = null;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsRegExpForFind = null;
  this.ju_regex_Pattern__f_jsRegExpForMatches = null;
  this.ju_regex_Pattern__f__pattern = _pattern;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsFlags = jsFlags;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$sticky = sticky;
  this.ju_regex_Pattern__f_groupCount = groupCount;
  this.ju_regex_Pattern__f_groupNumberMap = groupNumberMap;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsRegExpForFind = new RegExp(jsPattern, (this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsFlags + (this.ju_regex_Pattern__f_java$util$regex$Pattern$$sticky ? "gy" : "g")));
  this.ju_regex_Pattern__f_jsRegExpForMatches = new RegExp((("^(?:" + jsPattern) + ")$"), jsFlags);
}
$c_ju_regex_Pattern.prototype = new $h_O();
$c_ju_regex_Pattern.prototype.constructor = $c_ju_regex_Pattern;
/** @constructor */
function $h_ju_regex_Pattern() {
}
$h_ju_regex_Pattern.prototype = $c_ju_regex_Pattern.prototype;
$c_ju_regex_Pattern.prototype.execMatches__T__O = (function(input) {
  return this.ju_regex_Pattern__f_jsRegExpForMatches.exec(input);
});
$c_ju_regex_Pattern.prototype.java$util$regex$Pattern$$execFindInternal__T__I__O = (function(input, start) {
  var regexp = this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsRegExpForFind;
  regexp.lastIndex = start;
  return regexp.exec(input);
});
$c_ju_regex_Pattern.prototype.numberedGroup__I__I = (function(group) {
  if (((group < 0) || (group > this.ju_regex_Pattern__f_groupCount))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + group));
  }
  return $uI(this.ju_regex_Pattern__f_groupNumberMap[group]);
});
$c_ju_regex_Pattern.prototype.toString__T = (function() {
  return this.ju_regex_Pattern__f__pattern;
});
$c_ju_regex_Pattern.prototype.java$util$regex$Pattern$$split__T__I__AT = (function(inputStr, limit) {
  if ((inputStr === "")) {
    return new ($d_T.getArrayOf().constr)([""]);
  } else {
    var lim = ((limit > 0) ? limit : 2147483647);
    var this$1 = $n(inputStr);
    var matcher = new $c_ju_regex_Matcher(this, this$1);
    var result = [];
    var prevEnd = 0;
    while ((($uI(result.length) < (((-1) + lim) | 0)) && matcher.find__Z())) {
      if ((matcher.end__I() !== 0)) {
        var this$2 = $n(inputStr);
        var beginIndex = prevEnd;
        var endIndex = matcher.start__I();
        if ((beginIndex < 0)) {
          $charAt(this$2, beginIndex);
        }
        if ((endIndex > this$2.length)) {
          $charAt(this$2, endIndex);
        }
        if ((endIndex < beginIndex)) {
          $charAt(this$2, (-1));
        }
        var $x_1 = result.push($as_T(this$2.substring(beginIndex, endIndex)));
        $uI($x_1);
      }
      prevEnd = matcher.end__I();
    }
    var this$3 = $n(inputStr);
    var beginIndex$1 = prevEnd;
    if (((beginIndex$1 < 0) || (beginIndex$1 > this$3.length))) {
      $charAt(this$3, beginIndex$1);
    }
    result.push($as_T(this$3.substring(beginIndex$1)));
    var actualLength = $uI(result.length);
    if ((limit === 0)) {
      while (true) {
        if ((actualLength !== 0)) {
          var x = result[(((-1) + actualLength) | 0)];
          var $x_2 = ((x !== null) && $dp_equals__O__Z($n(x), ""));
        } else {
          var $x_2 = false;
        }
        if ($x_2) {
          actualLength = (((-1) + actualLength) | 0);
        } else {
          break;
        }
      }
    }
    var r = new ($d_T.getArrayOf().constr)(actualLength);
    var end = actualLength;
    var i = 0;
    while ((i < end)) {
      var i$2 = i;
      $n(r).set(i$2, $as_T(result[i$2]));
      i = ((1 + i) | 0);
    }
    return r;
  }
});
var $d_ju_regex_Pattern = new $TypeData().initClass($c_ju_regex_Pattern, "java.util.regex.Pattern", ({
  ju_regex_Pattern: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_Renderer$$anon$1(outer) {
  this.Llaika_api_Renderer__f_config = null;
  this.Llaika_api_Renderer__f_skipRewrite = false;
  this.Llaika_api_Renderer__f_renderFunction$lzy1 = null;
  this.Llaika_api_Renderer__f_renderFunctionbitmap$1 = false;
  this.Llaika_api_Renderer__f_defaultPathTranslator = null;
  this.Llaika_api_Renderer$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_Renderer$$anon$1__f_$outer = outer;
  $ct_Llaika_api_Renderer__Llaika_api_builder_OperationConfig__Z__(this, $n(outer).Llaika_api_Renderer__f_config, true);
}
$c_Llaika_api_Renderer$$anon$1.prototype = new $h_Llaika_api_Renderer();
$c_Llaika_api_Renderer$$anon$1.prototype.constructor = $c_Llaika_api_Renderer$$anon$1;
/** @constructor */
function $h_Llaika_api_Renderer$$anon$1() {
}
$h_Llaika_api_Renderer$$anon$1.prototype = $c_Llaika_api_Renderer$$anon$1.prototype;
$c_Llaika_api_Renderer$$anon$1.prototype.format__Llaika_api_format_RenderFormat = (function() {
  return $n(this.Llaika_api_Renderer$$anon$1__f_$outer).format__Llaika_api_format_RenderFormat();
});
var $d_Llaika_api_Renderer$$anon$1 = new $TypeData().initClass($c_Llaika_api_Renderer$$anon$1, "laika.api.Renderer$$anon$1", ({
  Llaika_api_Renderer$$anon$1: 1,
  Llaika_api_Renderer: 1
}));
/** @constructor */
function $c_Llaika_api_builder_OperationConfig$$anon$2(parser$1) {
  this.Llaika_api_builder_OperationConfig$$anon$2__f_origin = null;
  $n(parser$1);
  this.Llaika_api_builder_OperationConfig$$anon$2__f_origin = $m_Llaika_api_bundle_BundleOrigin$Parser$();
  var this$2 = $m_Llaika_api_bundle_DocumentTypeMatcher$();
  var fileSuffixes = $n(parser$1).Llaika_format_Markdown$__f_fileSuffixes;
  new $c_Llaika_api_bundle_DocumentTypeMatcher$$anon$2(fileSuffixes, this$2);
}
$c_Llaika_api_builder_OperationConfig$$anon$2.prototype = new $h_O();
$c_Llaika_api_builder_OperationConfig$$anon$2.prototype.constructor = $c_Llaika_api_builder_OperationConfig$$anon$2;
/** @constructor */
function $h_Llaika_api_builder_OperationConfig$$anon$2() {
}
$h_Llaika_api_builder_OperationConfig$$anon$2.prototype = $c_Llaika_api_builder_OperationConfig$$anon$2.prototype;
$c_Llaika_api_builder_OperationConfig$$anon$2.prototype.baseConfig__Llaika_api_config_Config = (function() {
  return $m_Llaika_api_config_Config$().Llaika_api_config_Config$__f_empty;
});
$c_Llaika_api_builder_OperationConfig$$anon$2.prototype.slugBuilder__s_Option = (function() {
  return $m_s_None$();
});
$c_Llaika_api_builder_OperationConfig$$anon$2.prototype.parsers__Llaika_api_bundle_ParserBundle = (function() {
  return new $c_Llaika_api_bundle_ParserBundle($m_sci_Nil$(), $m_sci_Nil$(), $m_sci_Nil$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
});
$c_Llaika_api_builder_OperationConfig$$anon$2.prototype.rewriteRules__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf;
});
$c_Llaika_api_builder_OperationConfig$$anon$2.prototype.renderOverrides__sci_Seq = (function() {
  return $as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps());
});
$c_Llaika_api_builder_OperationConfig$$anon$2.prototype.processExtension__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf;
});
$c_Llaika_api_builder_OperationConfig$$anon$2.prototype.forStrictMode__s_Option = (function() {
  return new $c_s_Some(this);
});
$c_Llaika_api_builder_OperationConfig$$anon$2.prototype.rawContentDisabled__s_Option = (function() {
  return new $c_s_Some(this);
});
$c_Llaika_api_builder_OperationConfig$$anon$2.prototype.origin__Llaika_api_bundle_BundleOrigin = (function() {
  return this.Llaika_api_builder_OperationConfig$$anon$2__f_origin;
});
var $d_Llaika_api_builder_OperationConfig$$anon$2 = new $TypeData().initClass($c_Llaika_api_builder_OperationConfig$$anon$2, "laika.api.builder.OperationConfig$$anon$2", ({
  Llaika_api_builder_OperationConfig$$anon$2: 1,
  Llaika_api_bundle_ExtensionBundle: 1
}));
/** @constructor */
function $c_Llaika_api_builder_RendererBuilder$$anon$1(outer) {
  this.Llaika_api_Renderer__f_config = null;
  this.Llaika_api_Renderer__f_skipRewrite = false;
  this.Llaika_api_Renderer__f_renderFunction$lzy1 = null;
  this.Llaika_api_Renderer__f_renderFunctionbitmap$1 = false;
  this.Llaika_api_Renderer__f_defaultPathTranslator = null;
  this.Llaika_api_builder_RendererBuilder$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_builder_RendererBuilder$$anon$1__f_$outer = outer;
  $ct_Llaika_api_Renderer__Llaika_api_builder_OperationConfig__Z__(this, $n(outer).Llaika_api_builder_RendererBuilder__f_config, $n(outer).Llaika_api_builder_RendererBuilder__f_laika$api$builder$RendererBuilder$$skipRewritePhase);
}
$c_Llaika_api_builder_RendererBuilder$$anon$1.prototype = new $h_Llaika_api_Renderer();
$c_Llaika_api_builder_RendererBuilder$$anon$1.prototype.constructor = $c_Llaika_api_builder_RendererBuilder$$anon$1;
/** @constructor */
function $h_Llaika_api_builder_RendererBuilder$$anon$1() {
}
$h_Llaika_api_builder_RendererBuilder$$anon$1.prototype = $c_Llaika_api_builder_RendererBuilder$$anon$1.prototype;
$c_Llaika_api_builder_RendererBuilder$$anon$1.prototype.format__Llaika_api_format_RenderFormat = (function() {
  return $n(this.Llaika_api_builder_RendererBuilder$$anon$1__f_$outer).Llaika_api_builder_RendererBuilder__f_renderFormat;
});
var $d_Llaika_api_builder_RendererBuilder$$anon$1 = new $TypeData().initClass($c_Llaika_api_builder_RendererBuilder$$anon$1, "laika.api.builder.RendererBuilder$$anon$1", ({
  Llaika_api_builder_RendererBuilder$$anon$1: 1,
  Llaika_api_Renderer: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_BlockDirectives$() {
  this.Llaika_api_bundle_BlockDirectives$__f_Multipart$lzy2 = null;
  this.Llaika_api_bundle_BlockDirectives$__f_Multipartbitmap$2 = false;
  this.Llaika_api_bundle_BlockDirectives$__f_BodyContent$lzy2 = null;
  this.Llaika_api_bundle_BlockDirectives$__f_BodyContentbitmap$2 = false;
  this.Llaika_api_bundle_BlockDirectives$__f_DirectiveContent$lzy2 = null;
  this.Llaika_api_bundle_BlockDirectives$__f_DirectiveContentbitmap$2 = false;
  this.Llaika_api_bundle_BlockDirectives$__f_DirectivePart$lzy2 = null;
  this.Llaika_api_bundle_BlockDirectives$__f_DirectivePartbitmap$2 = false;
  this.Llaika_api_bundle_BlockDirectives$__f_dsl$lzy2 = null;
  this.Llaika_api_bundle_BlockDirectives$__f_dslbitmap$2 = false;
}
$c_Llaika_api_bundle_BlockDirectives$.prototype = new $h_O();
$c_Llaika_api_bundle_BlockDirectives$.prototype.constructor = $c_Llaika_api_bundle_BlockDirectives$;
/** @constructor */
function $h_Llaika_api_bundle_BlockDirectives$() {
}
$h_Llaika_api_bundle_BlockDirectives$.prototype = $c_Llaika_api_bundle_BlockDirectives$.prototype;
$c_Llaika_api_bundle_BlockDirectives$.prototype.Multipart__Llaika_api_bundle_DirectiveBuilderContext$Multipart$ = (function() {
  if ((!this.Llaika_api_bundle_BlockDirectives$__f_Multipartbitmap$2)) {
    this.Llaika_api_bundle_BlockDirectives$__f_Multipart$lzy2 = new $c_Llaika_api_bundle_DirectiveBuilderContext$Multipart$(this);
    this.Llaika_api_bundle_BlockDirectives$__f_Multipartbitmap$2 = true;
  }
  return this.Llaika_api_bundle_BlockDirectives$__f_Multipart$lzy2;
});
$c_Llaika_api_bundle_BlockDirectives$.prototype.BodyContent__Llaika_api_bundle_DirectiveBuilderContext$BodyContent$ = (function() {
  if ((!this.Llaika_api_bundle_BlockDirectives$__f_BodyContentbitmap$2)) {
    this.Llaika_api_bundle_BlockDirectives$__f_BodyContent$lzy2 = new $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$(this);
    this.Llaika_api_bundle_BlockDirectives$__f_BodyContentbitmap$2 = true;
  }
  return this.Llaika_api_bundle_BlockDirectives$__f_BodyContent$lzy2;
});
$c_Llaika_api_bundle_BlockDirectives$.prototype.DirectiveContent__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent$ = (function() {
  if ((!this.Llaika_api_bundle_BlockDirectives$__f_DirectiveContentbitmap$2)) {
    this.Llaika_api_bundle_BlockDirectives$__f_DirectiveContent$lzy2 = new $c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent$(this);
    this.Llaika_api_bundle_BlockDirectives$__f_DirectiveContentbitmap$2 = true;
  }
  return this.Llaika_api_bundle_BlockDirectives$__f_DirectiveContent$lzy2;
});
$c_Llaika_api_bundle_BlockDirectives$.prototype.DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$ = (function() {
  if ((!this.Llaika_api_bundle_BlockDirectives$__f_DirectivePartbitmap$2)) {
    this.Llaika_api_bundle_BlockDirectives$__f_DirectivePart$lzy2 = new $c_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$(this);
    this.Llaika_api_bundle_BlockDirectives$__f_DirectivePartbitmap$2 = true;
  }
  return this.Llaika_api_bundle_BlockDirectives$__f_DirectivePart$lzy2;
});
$c_Llaika_api_bundle_BlockDirectives$.prototype.dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$ = (function() {
  if ((!this.Llaika_api_bundle_BlockDirectives$__f_dslbitmap$2)) {
    this.Llaika_api_bundle_BlockDirectives$__f_dsl$lzy2 = new $c_Llaika_api_bundle_DirectiveBuilderContext$dsl$(this);
    this.Llaika_api_bundle_BlockDirectives$__f_dslbitmap$2 = true;
  }
  return this.Llaika_api_bundle_BlockDirectives$__f_dsl$lzy2;
});
$c_Llaika_api_bundle_BlockDirectives$.prototype.parse__Llaika_parse_markup_RecursiveParsers__Llaika_parse_SourceFragment__s_util_Either = (function(parser, src) {
  var this$1 = $n(parser);
  var this$2 = $n($n(new $c_Llaika_internal_parse_markup_DefaultRecursiveParsers$$anon$1(this$1).parse__Llaika_parse_SourceFragment__Llaika_parse_Parsed(src)).toEither__s_util_Either());
  var this$3 = new $c_s_util_Either$LeftProjection(this$2);
  var x1 = this$3.s_util_Either$LeftProjection__f_e;
  if ((x1 instanceof $c_s_util_Left)) {
    var x2 = $as_s_util_Left(x1);
    var a = $n(x2).s_util_Left__f_value;
    var _$19 = $as_T(a);
    return new $c_s_util_Left($as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([_$19])))));
  } else {
    return this$3.s_util_Either$LeftProjection__f_e;
  }
});
$c_Llaika_api_bundle_BlockDirectives$.prototype.parse__O__Llaika_parse_SourceFragment__s_util_Either = (function(parser, src) {
  return this.parse__Llaika_parse_markup_RecursiveParsers__Llaika_parse_SourceFragment__s_util_Either($as_Llaika_parse_markup_RecursiveParsers(parser), src);
});
var $d_Llaika_api_bundle_BlockDirectives$ = new $TypeData().initClass($c_Llaika_api_bundle_BlockDirectives$, "laika.api.bundle.BlockDirectives$", ({
  Llaika_api_bundle_BlockDirectives$: 1,
  Llaika_api_bundle_DirectiveBuilderContext: 1
}));
var $n_Llaika_api_bundle_BlockDirectives$;
function $m_Llaika_api_bundle_BlockDirectives$() {
  if ((!$n_Llaika_api_bundle_BlockDirectives$)) {
    $n_Llaika_api_bundle_BlockDirectives$ = new $c_Llaika_api_bundle_BlockDirectives$();
  }
  return $n_Llaika_api_bundle_BlockDirectives$;
}
/** @constructor */
function $c_Llaika_api_bundle_BlockParserBuilder(parserFactory, recursive, position, precedence, paragraphLineCheck) {
  this.Llaika_api_bundle_BlockParserBuilder__f_parserFactory = null;
  this.Llaika_api_bundle_BlockParserBuilder__f_recursive = false;
  this.Llaika_api_bundle_BlockParserBuilder__f_position = null;
  this.Llaika_api_bundle_BlockParserBuilder__f_precedence = null;
  this.Llaika_api_bundle_BlockParserBuilder__f_paragraphLineCheck = null;
  this.Llaika_api_bundle_BlockParserBuilder__f_parserFactory = parserFactory;
  this.Llaika_api_bundle_BlockParserBuilder__f_recursive = recursive;
  this.Llaika_api_bundle_BlockParserBuilder__f_position = position;
  this.Llaika_api_bundle_BlockParserBuilder__f_precedence = precedence;
  this.Llaika_api_bundle_BlockParserBuilder__f_paragraphLineCheck = paragraphLineCheck;
}
$c_Llaika_api_bundle_BlockParserBuilder.prototype = new $h_O();
$c_Llaika_api_bundle_BlockParserBuilder.prototype.constructor = $c_Llaika_api_bundle_BlockParserBuilder;
/** @constructor */
function $h_Llaika_api_bundle_BlockParserBuilder() {
}
$h_Llaika_api_bundle_BlockParserBuilder.prototype = $c_Llaika_api_bundle_BlockParserBuilder.prototype;
$c_Llaika_api_bundle_BlockParserBuilder.prototype.createParser__Llaika_parse_markup_RecursiveParsers__Llaika_api_bundle_BlockParserDefinition = (function(recursiveParsers) {
  var p = $as_Llaika_parse_Parser($n(this.Llaika_api_bundle_BlockParserBuilder__f_parserFactory).apply__O__O(recursiveParsers));
  if ($is_Llaika_parse_text_PrefixedParser(p)) {
    var pp = $as_Llaika_parse_Parser($as_Llaika_parse_text_PrefixedParser(p));
    var value = $n($as_Llaika_parse_text_PrefixedParser(pp)).startChars__O();
    var this$2 = new $c_Lcats_data_NonEmptySetOps(value);
    var s = this$2.Lcats_data_NonEmptySetOps__f_value;
    var startChars = $as_sci_SortedSet(s);
  } else {
    var startChars = $m_sci_Set$EmptySet$();
  }
  return new $c_Llaika_api_bundle_BlockParserDefinition(startChars, p, this.Llaika_api_bundle_BlockParserBuilder__f_recursive, this.Llaika_api_bundle_BlockParserBuilder__f_position, this.Llaika_api_bundle_BlockParserBuilder__f_precedence, this.Llaika_api_bundle_BlockParserBuilder__f_paragraphLineCheck);
});
$c_Llaika_api_bundle_BlockParserBuilder.prototype.withLowPrecedence__Llaika_api_bundle_BlockParserBuilder = (function() {
  return new $c_Llaika_api_bundle_BlockParserBuilder(this.Llaika_api_bundle_BlockParserBuilder__f_parserFactory, this.Llaika_api_bundle_BlockParserBuilder__f_recursive, this.Llaika_api_bundle_BlockParserBuilder__f_position, $m_Llaika_api_bundle_Precedence$Low$(), this.Llaika_api_bundle_BlockParserBuilder__f_paragraphLineCheck);
});
$c_Llaika_api_bundle_BlockParserBuilder.prototype.rootOnly__Llaika_api_bundle_BlockParserBuilder = (function() {
  return new $c_Llaika_api_bundle_BlockParserBuilder(this.Llaika_api_bundle_BlockParserBuilder__f_parserFactory, this.Llaika_api_bundle_BlockParserBuilder__f_recursive, $m_Llaika_api_bundle_BlockPosition$RootOnly$(), this.Llaika_api_bundle_BlockParserBuilder__f_precedence, this.Llaika_api_bundle_BlockParserBuilder__f_paragraphLineCheck);
});
$c_Llaika_api_bundle_BlockParserBuilder.prototype.nestedOnly__Llaika_api_bundle_BlockParserBuilder = (function() {
  return new $c_Llaika_api_bundle_BlockParserBuilder(this.Llaika_api_bundle_BlockParserBuilder__f_parserFactory, this.Llaika_api_bundle_BlockParserBuilder__f_recursive, $m_Llaika_api_bundle_BlockPosition$NestedOnly$(), this.Llaika_api_bundle_BlockParserBuilder__f_precedence, this.Llaika_api_bundle_BlockParserBuilder__f_paragraphLineCheck);
});
$c_Llaika_api_bundle_BlockParserBuilder.prototype.interruptsParagraphWith__Llaika_parse_text_PrefixedParser__Llaika_api_bundle_BlockParserBuilder = (function(lineCheck) {
  return new $c_Llaika_api_bundle_BlockParserBuilder(this.Llaika_api_bundle_BlockParserBuilder__f_parserFactory, this.Llaika_api_bundle_BlockParserBuilder__f_recursive, this.Llaika_api_bundle_BlockParserBuilder__f_position, this.Llaika_api_bundle_BlockParserBuilder__f_precedence, new $c_s_Some(lineCheck));
});
$c_Llaika_api_bundle_BlockParserBuilder.prototype.createParser__Llaika_parse_markup_RecursiveParsers__Llaika_api_bundle_ParserDefinition = (function(recursiveParsers) {
  return this.createParser__Llaika_parse_markup_RecursiveParsers__Llaika_api_bundle_BlockParserDefinition(recursiveParsers);
});
var $d_Llaika_api_bundle_BlockParserBuilder = new $TypeData().initClass($c_Llaika_api_bundle_BlockParserBuilder, "laika.api.bundle.BlockParserBuilder", ({
  Llaika_api_bundle_BlockParserBuilder: 1,
  Llaika_api_bundle_ParserBuilder: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_BlockParserDefinition(startChars, parser, isRecursive, position, precedence, paragraphLineCheck) {
  this.Llaika_api_bundle_BlockParserDefinition__f_startChars = null;
  this.Llaika_api_bundle_BlockParserDefinition__f_parser = null;
  this.Llaika_api_bundle_BlockParserDefinition__f_isRecursive = false;
  this.Llaika_api_bundle_BlockParserDefinition__f_position = null;
  this.Llaika_api_bundle_BlockParserDefinition__f_precedence = null;
  this.Llaika_api_bundle_BlockParserDefinition__f_paragraphLineCheck = null;
  this.Llaika_api_bundle_BlockParserDefinition__f_startChars = startChars;
  this.Llaika_api_bundle_BlockParserDefinition__f_parser = parser;
  this.Llaika_api_bundle_BlockParserDefinition__f_isRecursive = isRecursive;
  this.Llaika_api_bundle_BlockParserDefinition__f_position = position;
  this.Llaika_api_bundle_BlockParserDefinition__f_precedence = precedence;
  this.Llaika_api_bundle_BlockParserDefinition__f_paragraphLineCheck = paragraphLineCheck;
}
$c_Llaika_api_bundle_BlockParserDefinition.prototype = new $h_O();
$c_Llaika_api_bundle_BlockParserDefinition.prototype.constructor = $c_Llaika_api_bundle_BlockParserDefinition;
/** @constructor */
function $h_Llaika_api_bundle_BlockParserDefinition() {
}
$h_Llaika_api_bundle_BlockParserDefinition.prototype = $c_Llaika_api_bundle_BlockParserDefinition.prototype;
$c_Llaika_api_bundle_BlockParserDefinition.prototype.precedence__Llaika_api_bundle_Precedence = (function() {
  return this.Llaika_api_bundle_BlockParserDefinition__f_precedence;
});
function $as_Llaika_api_bundle_BlockParserDefinition(obj) {
  return (((obj instanceof $c_Llaika_api_bundle_BlockParserDefinition) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.BlockParserDefinition"));
}
function $isArrayOf_Llaika_api_bundle_BlockParserDefinition(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_BlockParserDefinition)));
}
function $asArrayOf_Llaika_api_bundle_BlockParserDefinition(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_BlockParserDefinition(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.BlockParserDefinition;", depth));
}
var $d_Llaika_api_bundle_BlockParserDefinition = new $TypeData().initClass($c_Llaika_api_bundle_BlockParserDefinition, "laika.api.bundle.BlockParserDefinition", ({
  Llaika_api_bundle_BlockParserDefinition: 1,
  Llaika_api_bundle_ParserDefinition: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_ConfigProvider$$anon$1(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_api_bundle_ConfigProvider$$anon$1.prototype = new $h_O();
$c_Llaika_api_bundle_ConfigProvider$$anon$1.prototype.constructor = $c_Llaika_api_bundle_ConfigProvider$$anon$1;
/** @constructor */
function $h_Llaika_api_bundle_ConfigProvider$$anon$1() {
}
$h_Llaika_api_bundle_ConfigProvider$$anon$1.prototype = $c_Llaika_api_bundle_ConfigProvider$$anon$1.prototype;
$c_Llaika_api_bundle_ConfigProvider$$anon$1.prototype.markupConfigHeader__Llaika_parse_Parser = (function() {
  return $n($m_Llaika_api_bundle_ConfigProvider$().Llaika_api_bundle_ConfigProvider$__f_empty).markupConfigHeader__Llaika_parse_Parser();
});
var $d_Llaika_api_bundle_ConfigProvider$$anon$1 = new $TypeData().initClass($c_Llaika_api_bundle_ConfigProvider$$anon$1, "laika.api.bundle.ConfigProvider$$anon$1", ({
  Llaika_api_bundle_ConfigProvider$$anon$1: 1,
  Llaika_api_bundle_ConfigProvider: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_ConfigProvider$$anon$2() {
}
$c_Llaika_api_bundle_ConfigProvider$$anon$2.prototype = new $h_O();
$c_Llaika_api_bundle_ConfigProvider$$anon$2.prototype.constructor = $c_Llaika_api_bundle_ConfigProvider$$anon$2;
/** @constructor */
function $h_Llaika_api_bundle_ConfigProvider$$anon$2() {
}
$h_Llaika_api_bundle_ConfigProvider$$anon$2.prototype = $c_Llaika_api_bundle_ConfigProvider$$anon$2.prototype;
$c_Llaika_api_bundle_ConfigProvider$$anon$2.prototype.markupConfigHeader__Llaika_parse_Parser = (function() {
  var this$2 = $m_Llaika_parse_combinator_Parsers$();
  var this$1 = $m_Llaika_api_config_ConfigParser$();
  var v = new $c_Llaika_api_config_ConfigParser$$anon$2(this$1);
  return $f_Llaika_parse_combinator_Parsers__success__O__Llaika_parse_Parser(this$2, v);
});
var $d_Llaika_api_bundle_ConfigProvider$$anon$2 = new $TypeData().initClass($c_Llaika_api_bundle_ConfigProvider$$anon$2, "laika.api.bundle.ConfigProvider$$anon$2", ({
  Llaika_api_bundle_ConfigProvider$$anon$2: 1,
  Llaika_api_bundle_ConfigProvider: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$11(f$8, outer) {
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__f_$outer = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$$anon$11__f_f$3 = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$$anon$11__f_f$3 = f$8;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__Llaika_api_bundle_DirectiveBuilderContext__(this, $n(outer).Llaika_api_bundle_DirectiveBuilderContext$dsl$__f_$outer);
}
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$11.prototype = new $h_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart();
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$11.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$11;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$$anon$11() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$$anon$11.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$11.prototype;
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$11.prototype.apply__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__s_util_Either = (function(p) {
  return $as_s_util_Either($n(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$11__f_f$3).apply__O__O(p));
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$11.prototype.hasBody__Z = (function() {
  return false;
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$11.prototype.needsCursor__Z = (function() {
  return false;
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$11.prototype.separators__sci_Set = (function() {
  return $m_sci_Set$EmptySet$();
});
var $d_Llaika_api_bundle_DirectiveBuilderContext$$anon$11 = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$$anon$11, "laika.api.bundle.DirectiveBuilderContext$$anon$11", ({
  Llaika_api_bundle_DirectiveBuilderContext$$anon$11: 1,
  Llaika_api_bundle_DirectiveBuilderContext$DirectivePart: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12(outer) {
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__Llaika_api_bundle_DirectiveBuilderContext__(this, $n(outer).Llaika_api_bundle_DirectiveBuilderContext$dsl$__f_$outer);
}
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12.prototype = new $h_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart();
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$$anon$12() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$$anon$12.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12.prototype;
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12.prototype.apply__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__s_util_Either = (function(p) {
  var value = $n(p).Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__f_cursor;
  return new $c_s_util_Right(value);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12.prototype.hasBody__Z = (function() {
  return false;
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12.prototype.needsCursor__Z = (function() {
  return true;
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12.prototype.separators__sci_Set = (function() {
  return $m_sci_Set$EmptySet$();
});
var $d_Llaika_api_bundle_DirectiveBuilderContext$$anon$12 = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12, "laika.api.bundle.DirectiveBuilderContext$$anon$12", ({
  Llaika_api_bundle_DirectiveBuilderContext$$anon$12: 1,
  Llaika_api_bundle_DirectiveBuilderContext$DirectivePart: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$2(f$6, outer) {
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__f_$outer = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$$anon$2__f_f$1 = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$$anon$2__f_$outer = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$$anon$2__f_f$1 = f$6;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_bundle_DirectiveBuilderContext$$anon$2__f_$outer = outer;
  $ct_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__Llaika_api_bundle_DirectiveBuilderContext__(this, $n(outer).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__f_$outer);
}
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$2.prototype = new $h_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart();
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$2.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$2;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$$anon$2() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$$anon$2.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$2.prototype;
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$2.prototype.apply__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__s_util_Either = (function(p) {
  return $n($n(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$2__f_$outer).apply__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__s_util_Either(p)).map__F1__s_util_Either(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$2__f_f$1);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$2.prototype.hasBody__Z = (function() {
  return $n(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$2__f_$outer).hasBody__Z();
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$2.prototype.needsCursor__Z = (function() {
  return $n(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$2__f_$outer).needsCursor__Z();
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$2.prototype.separators__sci_Set = (function() {
  return $n(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$2__f_$outer).separators__sci_Set();
});
var $d_Llaika_api_bundle_DirectiveBuilderContext$$anon$2 = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$$anon$2, "laika.api.bundle.DirectiveBuilderContext$$anon$2", ({
  Llaika_api_bundle_DirectiveBuilderContext$$anon$2: 1,
  Llaika_api_bundle_DirectiveBuilderContext$DirectivePart: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$3(f$7, outer) {
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__f_$outer = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$$anon$3__f_f$2 = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$$anon$3__f_$outer = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$$anon$3__f_f$2 = f$7;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_bundle_DirectiveBuilderContext$$anon$3__f_$outer = outer;
  $ct_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__Llaika_api_bundle_DirectiveBuilderContext__(this, $n(outer).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__f_$outer);
}
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$3.prototype = new $h_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart();
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$3.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$3;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$$anon$3() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$$anon$3.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$3.prototype;
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$3.prototype.apply__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__s_util_Either = (function(p) {
  var this$1 = $n($n(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$3__f_$outer).apply__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__s_util_Either(p));
  if ((this$1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$1);
    var b = $n(x2).s_util_Right__f_value;
    var this$2 = $n($as_s_util_Either($n(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$3__f_f$2).apply__O__O(b)));
    var this$3 = new $c_s_util_Either$LeftProjection(this$2);
    var x1 = this$3.s_util_Either$LeftProjection__f_e;
    if ((x1 instanceof $c_s_util_Left)) {
      var x2$1 = $as_s_util_Left(x1);
      var a = $n(x2$1).s_util_Left__f_value;
      var _$3 = $as_T(a);
      return new $c_s_util_Left($as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([_$3])))));
    } else {
      return this$3.s_util_Either$LeftProjection__f_e;
    }
  } else {
    return this$1;
  }
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$3.prototype.hasBody__Z = (function() {
  return $n(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$3__f_$outer).hasBody__Z();
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$3.prototype.needsCursor__Z = (function() {
  return $n(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$3__f_$outer).needsCursor__Z();
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$3.prototype.separators__sci_Set = (function() {
  return $n(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$3__f_$outer).separators__sci_Set();
});
var $d_Llaika_api_bundle_DirectiveBuilderContext$$anon$3 = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$$anon$3, "laika.api.bundle.DirectiveBuilderContext$$anon$3", ({
  Llaika_api_bundle_DirectiveBuilderContext$$anon$3: 1,
  Llaika_api_bundle_DirectiveBuilderContext$DirectivePart: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$5(fa$2, fb$2, outer) {
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__f_$outer = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$$anon$5__f_fa$1 = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$$anon$5__f_fb$1 = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$$anon$5__f_fa$1 = fa$2;
  this.Llaika_api_bundle_DirectiveBuilderContext$$anon$5__f_fb$1 = fb$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__Llaika_api_bundle_DirectiveBuilderContext__(this, $n($n(outer).Llaika_api_bundle_DirectiveBuilderContext$$anon$4__f_$outer).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_$outer);
}
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$5.prototype = new $h_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart();
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$5.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$5;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$$anon$5() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$$anon$5.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$5.prototype;
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$5.prototype.apply__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__s_util_Either = (function(p) {
  var _1 = $n(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$5__f_fa$1).apply__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__s_util_Either(p);
  var _2 = $n(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$5__f_fb$1).apply__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__s_util_Either(p);
  var x44 = new $c_T2(_1, _2);
  var x59 = $as_s_util_Either(x44.T2__f__1);
  var x60 = $as_s_util_Either(x44.T2__f__2);
  if ((x59 instanceof $c_s_util_Right)) {
    var a = $n($as_s_util_Right(x59)).s_util_Right__f_value;
    if ((x60 instanceof $c_s_util_Right)) {
      var b = $n($as_s_util_Right(x60)).s_util_Right__f_value;
      var value = new $c_T2(a, b);
      return new $c_s_util_Right(value);
    }
  }
  if ((x59 instanceof $c_s_util_Left)) {
    var x58 = $as_sci_Seq($n($as_s_util_Left(x59)).s_util_Left__f_value);
    if ((x60 instanceof $c_s_util_Left)) {
      var b$2 = $as_sci_Seq($n($as_s_util_Left(x60)).s_util_Left__f_value);
      var this$4 = $n(x58);
      var value$1 = this$4.appendedAll__sc_IterableOnce__O(b$2);
      return new $c_s_util_Left(value$1);
    }
    return new $c_s_util_Left(x58);
  }
  if ((x60 instanceof $c_s_util_Left)) {
    var msg$2 = $as_sci_Seq($n($as_s_util_Left(x60)).s_util_Left__f_value);
    return new $c_s_util_Left(msg$2);
  }
  throw new $c_s_MatchError(x44);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$5.prototype.hasBody__Z = (function() {
  return ($n(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$5__f_fa$1).hasBody__Z() || $n(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$5__f_fb$1).hasBody__Z());
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$5.prototype.needsCursor__Z = (function() {
  return ($n(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$5__f_fa$1).needsCursor__Z() || $n(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$5__f_fb$1).needsCursor__Z());
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$5.prototype.separators__sci_Set = (function() {
  var this$1 = $n($n(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$5__f_fa$1).separators__sci_Set());
  var that = $n(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$5__f_fb$1).separators__sci_Set();
  return $as_sci_Set(this$1.concat__sc_IterableOnce__sc_SetOps(that));
});
var $d_Llaika_api_bundle_DirectiveBuilderContext$$anon$5 = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$$anon$5, "laika.api.bundle.DirectiveBuilderContext$$anon$5", ({
  Llaika_api_bundle_DirectiveBuilderContext$$anon$5: 1,
  Llaika_api_bundle_DirectiveBuilderContext$DirectivePart: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$6(accessor$2, outer) {
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__f_$outer = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$$anon$6__f_accessor$1 = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$$anon$6__f_accessor$1 = accessor$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__Llaika_api_bundle_DirectiveBuilderContext__(this, $n(outer).Llaika_api_bundle_DirectiveBuilderContext$dsl$__f_$outer);
}
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$6.prototype = new $h_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart();
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$6.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$6;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$$anon$6() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$$anon$6.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$6.prototype;
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$6.prototype.apply__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__s_util_Either = (function(context) {
  var this$1 = $n($as_s_Option($n(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$6__f_accessor$1).apply__O__O(context)));
  if (this$1.isEmpty__Z()) {
    var value = $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["required body is missing"])));
    var $x_1 = new $c_s_util_Left(value);
  } else {
    var $x_1 = this$1.get__O();
  }
  return $as_s_util_Either($x_1);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$6.prototype.hasBody__Z = (function() {
  return true;
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$6.prototype.needsCursor__Z = (function() {
  return false;
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$6.prototype.separators__sci_Set = (function() {
  return $m_sci_Set$EmptySet$();
});
var $d_Llaika_api_bundle_DirectiveBuilderContext$$anon$6 = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$$anon$6, "laika.api.bundle.DirectiveBuilderContext$$anon$6", ({
  Llaika_api_bundle_DirectiveBuilderContext$$anon$6: 1,
  Llaika_api_bundle_DirectiveBuilderContext$DirectivePart: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$7(outer) {
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__f_$outer = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$$anon$7__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_bundle_DirectiveBuilderContext$$anon$7__f_$outer = outer;
  $ct_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__Llaika_api_bundle_DirectiveBuilderContext__(this, $n($n(outer).Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart__f_$outer).Llaika_api_bundle_DirectiveBuilderContext$dsl$__f_$outer);
}
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$7.prototype = new $h_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart();
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$7.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$7;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$$anon$7() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$$anon$7.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$7.prototype;
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$7.prototype.apply__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__s_util_Either = (function(context) {
  return $n(context).attribute__Llaika_api_bundle_AttributeKey__Llaika_api_config_ConfigDecoder__Z__s_util_Either($n(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$7__f_$outer).Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart__f_laika$api$bundle$DirectiveBuilderContext$Combinators$AttributePart$$key, $n(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$7__f_$outer).Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart__f_laika$api$bundle$DirectiveBuilderContext$Combinators$AttributePart$$decoder, $n(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$7__f_$outer).Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart__f_laika$api$bundle$DirectiveBuilderContext$Combinators$AttributePart$$isInherited);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$7.prototype.hasBody__Z = (function() {
  return false;
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$7.prototype.needsCursor__Z = (function() {
  return false;
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$7.prototype.separators__sci_Set = (function() {
  return $m_sci_Set$EmptySet$();
});
var $d_Llaika_api_bundle_DirectiveBuilderContext$$anon$7 = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$$anon$7, "laika.api.bundle.DirectiveBuilderContext$$anon$7", ({
  Llaika_api_bundle_DirectiveBuilderContext$$anon$7: 1,
  Llaika_api_bundle_DirectiveBuilderContext$DirectivePart: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(outer, key, decoder, isInherited, requiredMsg) {
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__f_$outer = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart__f_laika$api$bundle$DirectiveBuilderContext$Combinators$AttributePart$$key = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart__f_laika$api$bundle$DirectiveBuilderContext$Combinators$AttributePart$$decoder = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart__f_laika$api$bundle$DirectiveBuilderContext$Combinators$AttributePart$$isInherited = false;
  this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart__f_requiredMsg = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart__f_$outer = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart__f_laika$api$bundle$DirectiveBuilderContext$Combinators$AttributePart$$key = key;
  this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart__f_laika$api$bundle$DirectiveBuilderContext$Combinators$AttributePart$$decoder = decoder;
  this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart__f_laika$api$bundle$DirectiveBuilderContext$Combinators$AttributePart$$isInherited = isInherited;
  this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart__f_requiredMsg = requiredMsg;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart__f_$outer = outer;
  $ct_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__Llaika_api_bundle_DirectiveBuilderContext__(this, $n(outer).Llaika_api_bundle_DirectiveBuilderContext$dsl$__f_$outer);
}
$c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart.prototype = new $h_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart();
$c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart.prototype;
$c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart.prototype.apply__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__s_util_Either = (function(context) {
  var this$1 = $n($n(context).attribute__Llaika_api_bundle_AttributeKey__Llaika_api_config_ConfigDecoder__Z__s_util_Either(this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart__f_laika$api$bundle$DirectiveBuilderContext$Combinators$AttributePart$$key, this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart__f_laika$api$bundle$DirectiveBuilderContext$Combinators$AttributePart$$decoder, this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart__f_laika$api$bundle$DirectiveBuilderContext$Combinators$AttributePart$$isInherited));
  if ((this$1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$1);
    var b = $n(x2).s_util_Right__f_value;
    var _$8 = $as_s_Option(b);
    var this$2 = $n(_$8);
    return (this$2.isEmpty__Z() ? new $c_s_util_Left($as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([$as_T($n(this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart__f_requiredMsg).apply__O())]))))) : new $c_s_util_Right(this$2.get__O()));
  } else {
    return this$1;
  }
});
$c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart.prototype.as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart = (function(decoder) {
  return new $c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart__f_$outer, this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart__f_laika$api$bundle$DirectiveBuilderContext$Combinators$AttributePart$$key, decoder, this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart__f_laika$api$bundle$DirectiveBuilderContext$Combinators$AttributePart$$isInherited, this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart__f_requiredMsg);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart.prototype.hasBody__Z = (function() {
  return false;
});
$c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart.prototype.needsCursor__Z = (function() {
  return false;
});
$c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart.prototype.separators__sci_Set = (function() {
  return $m_sci_Set$EmptySet$();
});
var $d_Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart, "laika.api.bundle.DirectiveBuilderContext$Combinators$AttributePart", ({
  Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart: 1,
  Llaika_api_bundle_DirectiveBuilderContext$DirectivePart: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes(outer, decoder) {
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__f_$outer = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes__f_decoder = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes__f_$outer = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes__f_decoder = decoder;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes__f_$outer = outer;
  $ct_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__Llaika_api_bundle_DirectiveBuilderContext__(this, $n(outer).Llaika_api_bundle_DirectiveBuilderContext$dsl$__f_$outer);
}
$c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes.prototype = new $h_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart();
$c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes.prototype;
$c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes.prototype.apply__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__s_util_Either = (function(context) {
  var $x_1 = $m_Llaika_api_bundle_AttributeKey$Positional$();
  var this$1 = $m_Llaika_api_config_ConfigDecoder$();
  var elementDecoder = this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes__f_decoder;
  var this$2 = $n($n(context).attribute__Llaika_api_bundle_AttributeKey__Llaika_api_config_ConfigDecoder__Z__s_util_Either($x_1, new $c_Llaika_api_config_ConfigDecoder$$anon$10(elementDecoder, this$1), false));
  if ((this$2 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$2);
    var b = $n(x2).s_util_Right__f_value;
    var _$7 = $as_s_Option(b);
    var this$3 = $n(_$7);
    return new $c_s_util_Right($as_sci_Seq((this$3.isEmpty__Z() ? $m_sci_Nil$() : this$3.get__O())));
  } else {
    return this$2;
  }
});
$c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes.prototype.as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes = (function(decoder) {
  return new $c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes(this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes__f_$outer, decoder);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes.prototype.hasBody__Z = (function() {
  return false;
});
$c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes.prototype.needsCursor__Z = (function() {
  return false;
});
$c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes.prototype.separators__sci_Set = (function() {
  return $m_sci_Set$EmptySet$();
});
var $d_Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes, "laika.api.bundle.DirectiveBuilderContext$Combinators$PositionalAttributes", ({
  Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes: 1,
  Llaika_api_bundle_DirectiveBuilderContext$DirectivePart: 1
}));
function $p_Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart__processSeparators$1__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__sci_Seq__sci_Seq__sci_Seq($thiz, context$7, remaining, acc) {
  var this$1 = $n($n(remaining).headOption__s_Option());
  var pf = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$8($thiz);
  if ((!this$1.isEmpty__Z())) {
    var this$2 = new $c_s_PartialFunction$Lifted(pf);
    var v1 = this$1.get__O();
    var $x_1 = this$2.apply__O__s_Option(v1);
  } else {
    var $x_1 = $m_s_None$();
  }
  var this$3 = $n($x_1);
  if (this$3.isEmpty__Z()) {
    return acc;
  } else {
    var arg1 = this$3.get__O();
    var instance = $as_Llaika_ast_Element(arg1);
    var name = $n($n($as_Llaika_api_bundle_DirectiveBuilderContext$DirectiveProcessor(instance)).parsedResult__Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective()).Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_name;
    matchResult32: {
      var \u03b43$___1;
      var \u03b43$___2;
      var x90 = $s_Llaika_api_bundle_DirectiveBuilderContext__laika$api$bundle$DirectiveBuilderContext$Combinators$SeparatedBodyPart$$_$splitNextBodyPart$1__sci_Seq__T2($as_sci_Seq($n(remaining).tail__O()));
      if ((x90 !== null)) {
        var body = $as_sci_Seq($n(x90)._1__O());
        var newRemaining = $as_sci_Seq($n(x90)._2__O());
        var \u03b43$___1 = body;
        var \u03b43$___2 = newRemaining;
        break matchResult32;
      }
      throw new $c_s_MatchError(x90);
    }
    var body$2 = $as_sci_Seq(\u03b43$___1);
    var newRemaining$2 = $as_sci_Seq(\u03b43$___2);
    var this$5 = $n($as_Llaika_api_bundle_DirectiveBuilderContext$SeparatorInstanceBase(instance));
    var directive = $n($thiz.Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart__f_directives).find__F1__s_Option(new $c_sjsr_AnonFunction1(((_$11) => {
      var _$11$1 = $as_Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective(_$11);
      return ($n(_$11$1).Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective__f_name === name);
    })));
    var this$6 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$SeparatorInstanceBase__resolve__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__sci_Seq__s_Option__s_util_Either(this$5, context$7, body$2, directive));
    if ((this$6 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$6);
      var b = $n(x2).s_util_Right__f_value;
      var nextSeparator = new $c_s_util_Right(new $c_T2(name, b));
    } else {
      var nextSeparator = this$6;
    }
    var this$11 = $n(acc);
    var this$8 = $n(nextSeparator);
    var this$9 = new $c_s_util_Either$LeftProjection(this$8);
    var x1 = this$9.s_util_Either$LeftProjection__f_e;
    if ((x1 instanceof $c_s_util_Left)) {
      var x2$1 = $as_s_util_Left(x1);
      var a = $n(x2$1).s_util_Left__f_value;
      var errs = $as_sci_Seq(a);
      var $x_3 = $m_sci_Seq$();
      var $x_2 = $m_sr_ScalaRunTime$();
      var this$10 = $n(errs);
      var elem = new $c_s_util_Left($as_sci_Seq($n($x_3).apply__sci_Seq__sc_SeqOps($n($x_2).wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([((("One or more errors processing separator directive '" + name) + "': ") + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$10, "", ", ", ""))])))));
    } else {
      var elem = this$9.s_util_Either$LeftProjection__f_e;
    }
    return $p_Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart__processSeparators$1__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__sci_Seq__sci_Seq__sci_Seq($thiz, context$7, newRemaining$2, $as_sci_Seq(this$11.appended__O__O(elem)));
  }
}
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart(outer, directives) {
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__f_$outer = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart__f_directives = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart__f_$outer = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart__f_directives = directives;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart__f_$outer = outer;
  $ct_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__Llaika_api_bundle_DirectiveBuilderContext__(this, $n(outer).Llaika_api_bundle_DirectiveBuilderContext$dsl$__f_$outer);
}
$c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart.prototype = new $h_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart();
$c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart.prototype;
$c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart.prototype.apply__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__s_util_Either = (function(context) {
  var this$1 = $n(this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart__f_$outer);
  var this$2 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__laika$api$bundle$DirectiveBuilderContext$Combinators$$getParsedBody__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__s_Option(this$1, context));
  if (this$2.isEmpty__Z()) {
    var value = $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["required body is missing"])));
    var $x_1 = new $c_s_util_Left(value);
  } else {
    var $x_1 = this$2.get__O();
  }
  var this$4 = $n($as_s_util_Either($x_1));
  if ((this$4 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$4);
    var b = $n(x2).s_util_Right__f_value;
    var elements = $as_sci_Seq(b);
    return this.toMultipart__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__sci_Seq__s_util_Either(context, elements);
  } else {
    return this$4;
  }
});
$c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart.prototype.hasBody__Z = (function() {
  return true;
});
$c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart.prototype.needsCursor__Z = (function() {
  return false;
});
$c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart.prototype.separators__sci_Set = (function() {
  var this$1 = $n($as_sc_IterableOnceOps($n(this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart__f_directives).map__F1__O(new $c_sjsr_AnonFunction1(((_$9) => {
    var _$9$1 = $as_Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective(_$9);
    return $n(_$9$1).Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective__f_name;
  })))));
  return $m_sci_Set$().from__sc_IterableOnce__sci_Set($as_sc_IterableOnce(this$1));
});
$c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart.prototype.toMultipart__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__sci_Seq__s_util_Either = (function(context, elements) {
  matchResult33: {
    var \u03b41$___1;
    var \u03b41$___2;
    var x93 = $s_Llaika_api_bundle_DirectiveBuilderContext__laika$api$bundle$DirectiveBuilderContext$Combinators$SeparatedBodyPart$$_$splitNextBodyPart$1__sci_Seq__T2(elements);
    if ((x93 !== null)) {
      var mainBody = $as_sci_Seq($n(x93)._1__O());
      var remaining = $as_sci_Seq($n(x93)._2__O());
      var \u03b41$___1 = mainBody;
      var \u03b41$___2 = remaining;
      break matchResult33;
    }
    throw new $c_s_MatchError(x93);
  }
  var mainBody$2 = $as_sci_Seq(\u03b41$___1);
  var remaining$2 = $as_sci_Seq(\u03b41$___2);
  var separators = $p_Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart__processSeparators$1__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__sci_Seq__sci_Seq__sci_Seq(this, context, remaining$2, $m_sci_Nil$());
  var _1 = $n(separators).collect__s_PartialFunction__O(new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$9());
  var _2 = $n(separators).collect__s_PartialFunction__O(new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$10());
  var errors = $as_sci_Seq(_1);
  var valid = $as_sci_Seq(_2);
  var this$3 = $n(valid);
  var m = $as_scm_Map($m_scm_Map$().empty__O());
  var it = this$3.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    var _$13 = $as_T2(elem);
    var key = $as_T($n(_$13)._1__O());
    var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0(((this$3) => (() => this$3.newSpecificBuilder__scm_Builder()))(this$3))));
    var this$4 = $n(bldr);
    this$4.addOne__O__scm_Growable(elem);
  }
  var this$5 = $m_sci_HashMap$();
  var result = this$5.sci_HashMap$__f_EmptyMap;
  var mapIt = $n(m).iterator__sc_Iterator();
  while ($n(mapIt).hasNext__Z()) {
    var x1 = $as_T2($n(mapIt).next__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = $n(x1)._1__O();
    var v = $as_scm_Builder($n(x1)._2__O());
    result = $n(result).updated__O__O__sci_HashMap(k, $n(v).result__O());
  }
  var map = result;
  var this$8 = $n(map);
  $m_sci_HashMap$();
  var b = new $c_sci_HashMapBuilder();
  var it$1 = this$8.iterator__sc_Iterator();
  while ($n(it$1).hasNext__Z()) {
    var arg1 = $n(it$1).next__O();
    var x$1 = $as_T2(arg1);
    matchResult2: {
      var elem$1___1;
      var elem$1___2;
      if ((x$1 !== null)) {
        var k$1 = $n(x$1)._1__O();
        var v$1 = $n(x$1)._2__O();
        var _$14 = $as_sci_Seq(v$1);
        var _2$1 = $n(_$14).length__I();
        var elem$1___1 = k$1;
        var elem$1___2 = _2$1;
        break matchResult2;
      }
      throw new $c_s_MatchError(x$1);
    }
    $p_sci_HashMapBuilder__ensureUnaliased__V(b);
    var x = elem$1___1;
    var h = $m_sr_Statics$().anyHash__O__I(x);
    var im = $m_sc_Hashing$().improve__I__I(h);
    b.update__sci_MapNode__O__O__I__I__I__V(b.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, elem$1___1, elem$1___2, h, im, 0);
  }
  var this$11 = $n(b.result__sci_HashMap());
  var nameCounts = $f_sci_Map__withDefaultValue__O__sci_Map(this$11, 0);
  var cntErrors = $as_sci_Seq($n(this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart__f_directives).flatMap__F1__O(new $c_sjsr_AnonFunction1(((dir) => {
    var dir$1 = $as_Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective(dir);
    var cnt = $uI($n(nameCounts).apply__O__O($n(dir$1).Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective__f_name));
    var this$12 = $n(((cnt > $n(dir$1).Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective__f_max) ? $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([((((("too many occurrences of separator directive '" + $n(dir$1).Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective__f_name) + "': expected max: ") + $n(dir$1).Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective__f_max) + ", actual: ") + cnt)])))) : $m_sci_Nil$()));
    var suffix = ((cnt < $n(dir$1).Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective__f_min) ? $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([((((("too few occurrences of separator directive '" + $n(dir$1).Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective__f_name) + "': expected min: ") + $n(dir$1).Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective__f_min) + ", actual: ") + cnt)]))) : $m_sci_Nil$());
    return $as_sc_IterableOnce(this$12.appendedAll__sc_IterableOnce__O(suffix));
  }))));
  if (($n(errors).isEmpty__Z() && $n(cntErrors).isEmpty__Z())) {
    var value = $n($n($n(this.Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart__f_$outer).Llaika_api_bundle_DirectiveBuilderContext$dsl$__f_$outer).Multipart__Llaika_api_bundle_DirectiveBuilderContext$Multipart$()).apply__sci_Seq__sci_Seq__Llaika_api_bundle_DirectiveBuilderContext$Multipart(mainBody$2, $as_sci_Seq($n(valid).map__F1__O(new $c_sjsr_AnonFunction1(((_$15) => {
      var _$15$1 = $as_T2(_$15);
      return $n(_$15$1)._2__O();
    })))));
    return new $c_s_util_Right(value);
  } else {
    var $x_2 = $m_sci_Seq$();
    var $x_1 = $m_sr_ScalaRunTime$();
    var this$15 = $m_s_$less$colon$less$();
    var this$16 = $n($as_sc_IterableOps($n(errors).flatten__F1__O(this$15.s_$less$colon$less$__f_singleton)));
    var this$17 = $n($as_sc_IterableOnceOps(this$16.concat__sc_IterableOnce__O(cntErrors)));
    var value$1 = $n($x_2).apply__sci_Seq__sc_SeqOps($n($x_1).wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([$f_sc_IterableOnceOps__mkString__T__T__T__T(this$17, "", ", ", "")])));
    return new $c_s_util_Left(value$1);
  }
});
var $d_Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart, "laika.api.bundle.DirectiveBuilderContext$Combinators$SeparatedBodyPart", ({
  Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart: 1,
  Llaika_api_bundle_DirectiveBuilderContext$DirectivePart: 1
}));
function $f_Llaika_api_bundle_DirectiveBuilderContext$DirectiveInstanceBase__resolve__Llaika_ast_DocumentCursor__Llaika_ast_Element($thiz, cursor) {
  var this$1 = $n($thiz.directive__s_Option());
  if (this$1.isEmpty__Z()) {
    var factory = $m_s_None$();
  } else {
    var arg1 = this$1.get__O();
    var dir = $as_Llaika_api_bundle_DirectiveBuilderContext$Directive(arg1);
    var factory = new $c_s_Some(new $c_sjsr_AnonFunction1(((content) => {
      var content$1 = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent(content);
      return $n(dir).apply__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__s_util_Either(new $c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext($thiz.laika$api$bundle$DirectiveBuilderContext$DirectiveInstanceBase$$$outer__Llaika_api_bundle_DirectiveBuilderContext(), content$1, $thiz.parser__O(), cursor, $thiz.source__Llaika_parse_SourceFragment()));
    })));
  }
  var this$3 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$DirectiveProcessor__process__Llaika_ast_DocumentCursor__s_Option__s_util_Either($thiz, cursor, factory));
  if ((this$3 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$3);
    var b = $n(x2).s_util_Right__f_value;
    var x = $as_Llaika_ast_Element(b);
    var $x_1 = x;
  } else {
    if ((!(this$3 instanceof $c_s_util_Left))) {
      throw new $c_s_MatchError(this$3);
    }
    var x3 = $as_s_util_Left(this$3);
    var a = $n(x3).s_util_Left__f_value;
    var messages = $as_sci_Seq(a);
    var $x_2 = $n($thiz.parsedResult__Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective()).Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_name;
    var this$5 = $n(messages);
    var $x_1 = $thiz.createInvalidElement__T__Llaika_ast_Element(((("One or more errors processing directive '" + $x_2) + "': ") + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$5, "", ", ", "")));
  }
  return $n($x_1).mergeOptions__Llaika_ast_Options__Llaika_ast_Element($thiz.options__Llaika_ast_Options());
}
function $f_Llaika_api_bundle_DirectiveBuilderContext$DirectiveInstanceBase__runsIn__Llaika_ast_RewritePhase__Z($thiz, phase) {
  var this$1 = $n($thiz.directive__s_Option());
  if (this$1.isEmpty__Z()) {
    return true;
  } else {
    var arg1 = this$1.get__O();
    var _$5 = $as_Llaika_api_bundle_DirectiveBuilderContext$Directive(arg1);
    return $n(_$5).runsIn__Llaika_ast_RewritePhase__Z(phase);
  }
}
function $f_Llaika_api_bundle_DirectiveBuilderContext$SeparatorInstanceBase__resolve__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__sci_Seq__s_Option__s_util_Either($thiz, context, body, directive) {
  var this$1 = $n(directive);
  if (this$1.isEmpty__Z()) {
    var factory = $m_s_None$();
  } else {
    var arg1 = this$1.get__O();
    var dir = $as_Llaika_api_bundle_DirectiveBuilderContext$SeparatorDirective(arg1);
    var factory = new $c_s_Some(new $c_sjsr_AnonFunction1(((content) => {
      var content$1 = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent(content);
      var $x_1 = $n(dir);
      var value = $n($n($n($thiz.laika$api$bundle$DirectiveBuilderContext$SeparatorInstanceBase$$$outer__Llaika_api_bundle_DirectiveBuilderContext()).BodyContent__Llaika_api_bundle_DirectiveBuilderContext$BodyContent$()).Llaika_api_bundle_DirectiveBuilderContext$BodyContent$__f_Parsed$lzy1).apply__sci_Seq__Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed(body);
      var body$1 = new $c_s_Some(value);
      var this$4 = $n(content$1);
      var attributes$1 = this$4.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent__f_attributes;
      return $n($x_1).apply__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__s_util_Either($n(context).withContent__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext($n(content$1).copy__Llaika_api_config_Config__s_Option__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent(attributes$1, body$1)));
    })));
  }
  var cursor = $n(context).Llaika_api_bundle_DirectiveBuilderContext$DirectiveContext__f_cursor;
  return $f_Llaika_api_bundle_DirectiveBuilderContext$DirectiveProcessor__process__Llaika_ast_DocumentCursor__s_Option__s_util_Either($thiz, cursor, factory);
}
function $is_Llaika_api_bundle_DirectiveBuilderContext$SeparatorInstanceBase(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_api_bundle_DirectiveBuilderContext$SeparatorInstanceBase)));
}
function $as_Llaika_api_bundle_DirectiveBuilderContext$SeparatorInstanceBase(obj) {
  return (($is_Llaika_api_bundle_DirectiveBuilderContext$SeparatorInstanceBase(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.DirectiveBuilderContext$SeparatorInstanceBase"));
}
function $isArrayOf_Llaika_api_bundle_DirectiveBuilderContext$SeparatorInstanceBase(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_DirectiveBuilderContext$SeparatorInstanceBase)));
}
function $asArrayOf_Llaika_api_bundle_DirectiveBuilderContext$SeparatorInstanceBase(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_DirectiveBuilderContext$SeparatorInstanceBase(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.DirectiveBuilderContext$SeparatorInstanceBase;", depth));
}
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$dsl$(outer) {
  this.Llaika_api_bundle_DirectiveBuilderContext$dsl$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_bundle_DirectiveBuilderContext$dsl$__f_$outer = outer;
}
$c_Llaika_api_bundle_DirectiveBuilderContext$dsl$.prototype = new $h_O();
$c_Llaika_api_bundle_DirectiveBuilderContext$dsl$.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$dsl$;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$dsl$() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$dsl$.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$dsl$.prototype;
var $d_Llaika_api_bundle_DirectiveBuilderContext$dsl$ = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$dsl$, "laika.api.bundle.DirectiveBuilderContext$dsl$", ({
  Llaika_api_bundle_DirectiveBuilderContext$dsl$: 1,
  Llaika_api_bundle_DirectiveBuilderContext$Combinators: 1
}));
function $f_Llaika_api_bundle_DirectiveRegistry__forStrictMode__s_Option($thiz) {
  var value = new $c_Llaika_api_bundle_DirectiveRegistry$$anon$1($thiz);
  return new $c_s_Some(value);
}
function $p_Llaika_api_bundle_ExtensionBundle$$anon$1__merged__s_Option__s_Option__s_Option($thiz, thisBundle, baseBundle) {
  var $x_1 = $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_s_Option.getArrayOf().constr)([thisBundle, baseBundle])));
  var this$2 = $m_s_$less$colon$less$();
  var this$4 = $n($as_sc_IterableOnceOps($n($x_1).flatten__F1__O(this$2.s_$less$colon$less$__f_singleton)));
  var op = new $c_sjsr_AnonFunction2(((a, b) => {
    var a$1 = $as_Llaika_api_bundle_ExtensionBundle(a);
    var b$1 = $as_Llaika_api_bundle_ExtensionBundle(b);
    var this$3 = $n(a$1);
    return new $c_Llaika_api_bundle_ExtensionBundle$$anon$1(b$1, this$3);
  }));
  return $f_sc_IterableOnceOps__reduceLeftOption__F2__s_Option(this$4, op);
}
/** @constructor */
function $c_Llaika_api_bundle_ExtensionBundle$$anon$1(base$2, outer) {
  this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_laika$api$bundle$ExtensionBundle$$anon$1$$base$1 = null;
  this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_origin$lzy1 = null;
  this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_originbitmap$1 = false;
  this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_baseConfig$lzy1 = null;
  this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_baseConfigbitmap$1 = false;
  this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_slugBuilder$lzy1 = null;
  this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_slugBuilderbitmap$1 = false;
  this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_parsers$lzy1 = null;
  this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_parsersbitmap$1 = false;
  this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_rewriteRules$lzy1 = null;
  this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_rewriteRulesbitmap$1 = false;
  this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_renderOverrides$lzy1 = null;
  this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_renderOverridesbitmap$1 = false;
  this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_$outer = null;
  this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_laika$api$bundle$ExtensionBundle$$anon$1$$base$1 = base$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_$outer = outer;
}
$c_Llaika_api_bundle_ExtensionBundle$$anon$1.prototype = new $h_O();
$c_Llaika_api_bundle_ExtensionBundle$$anon$1.prototype.constructor = $c_Llaika_api_bundle_ExtensionBundle$$anon$1;
/** @constructor */
function $h_Llaika_api_bundle_ExtensionBundle$$anon$1() {
}
$h_Llaika_api_bundle_ExtensionBundle$$anon$1.prototype = $c_Llaika_api_bundle_ExtensionBundle$$anon$1.prototype;
$c_Llaika_api_bundle_ExtensionBundle$$anon$1.prototype.origin__Llaika_api_bundle_BundleOrigin = (function() {
  if ((!this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_originbitmap$1)) {
    var x = $n(this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_$outer).origin__Llaika_api_bundle_BundleOrigin();
    var x$2 = $n(this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_laika$api$bundle$ExtensionBundle$$anon$1$$base$1).origin__Llaika_api_bundle_BundleOrigin();
    if ((x === null)) {
      var $x_1 = (x$2 === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === x$2);
    }
    this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_origin$lzy1 = ($x_1 ? $n(this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_$outer).origin__Llaika_api_bundle_BundleOrigin() : $m_Llaika_api_bundle_BundleOrigin$Mixed$());
    this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_originbitmap$1 = true;
  }
  return this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_origin$lzy1;
});
$c_Llaika_api_bundle_ExtensionBundle$$anon$1.prototype.baseConfig__Llaika_api_config_Config = (function() {
  if ((!this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_baseConfigbitmap$1)) {
    this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_baseConfig$lzy1 = $n($n(this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_$outer).baseConfig__Llaika_api_config_Config()).withFallback__Llaika_api_config_Config__Llaika_api_config_Config($n(this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_laika$api$bundle$ExtensionBundle$$anon$1$$base$1).baseConfig__Llaika_api_config_Config());
    this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_baseConfigbitmap$1 = true;
  }
  return this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_baseConfig$lzy1;
});
$c_Llaika_api_bundle_ExtensionBundle$$anon$1.prototype.slugBuilder__s_Option = (function() {
  if ((!this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_slugBuilderbitmap$1)) {
    var this$1 = $n($n(this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_$outer).slugBuilder__s_Option());
    this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_slugBuilder$lzy1 = (this$1.isEmpty__Z() ? $n(this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_laika$api$bundle$ExtensionBundle$$anon$1$$base$1).slugBuilder__s_Option() : this$1);
    this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_slugBuilderbitmap$1 = true;
  }
  return this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_slugBuilder$lzy1;
});
$c_Llaika_api_bundle_ExtensionBundle$$anon$1.prototype.parsers__Llaika_api_bundle_ParserBundle = (function() {
  if ((!this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_parsersbitmap$1)) {
    this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_parsers$lzy1 = $n($n(this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_$outer).parsers__Llaika_api_bundle_ParserBundle()).withBase__Llaika_api_bundle_ParserBundle__Llaika_api_bundle_ParserBundle($n(this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_laika$api$bundle$ExtensionBundle$$anon$1$$base$1).parsers__Llaika_api_bundle_ParserBundle());
    this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_parsersbitmap$1 = true;
  }
  return this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_parsers$lzy1;
});
$c_Llaika_api_bundle_ExtensionBundle$$anon$1.prototype.rewriteRules__s_PartialFunction = (function() {
  if ((!this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_rewriteRulesbitmap$1)) {
    this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_rewriteRules$lzy1 = new $c_Llaika_api_bundle_ExtensionBundle$$anon$1$$anon$2(this);
    this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_rewriteRulesbitmap$1 = true;
  }
  return this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_rewriteRules$lzy1;
});
$c_Llaika_api_bundle_ExtensionBundle$$anon$1.prototype.renderOverrides__sci_Seq = (function() {
  if ((!this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_renderOverridesbitmap$1)) {
    var this$1 = $n($n(this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_$outer).renderOverrides__sci_Seq());
    var suffix = $n(this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_laika$api$bundle$ExtensionBundle$$anon$1$$base$1).renderOverrides__sci_Seq();
    this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_renderOverrides$lzy1 = $as_sci_Seq(this$1.appendedAll__sc_IterableOnce__O(suffix));
    this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_renderOverridesbitmap$1 = true;
  }
  return this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_renderOverrides$lzy1;
});
$c_Llaika_api_bundle_ExtensionBundle$$anon$1.prototype.processExtension__s_PartialFunction = (function() {
  return $n($n(this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_$outer).processExtension__s_PartialFunction()).orElse__s_PartialFunction__s_PartialFunction($n(this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_laika$api$bundle$ExtensionBundle$$anon$1$$base$1).processExtension__s_PartialFunction());
});
$c_Llaika_api_bundle_ExtensionBundle$$anon$1.prototype.forStrictMode__s_Option = (function() {
  return $p_Llaika_api_bundle_ExtensionBundle$$anon$1__merged__s_Option__s_Option__s_Option(this, $n(this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_$outer).forStrictMode__s_Option(), $n(this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_laika$api$bundle$ExtensionBundle$$anon$1$$base$1).forStrictMode__s_Option());
});
$c_Llaika_api_bundle_ExtensionBundle$$anon$1.prototype.rawContentDisabled__s_Option = (function() {
  return $p_Llaika_api_bundle_ExtensionBundle$$anon$1__merged__s_Option__s_Option__s_Option(this, $n(this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_$outer).rawContentDisabled__s_Option(), $n(this.Llaika_api_bundle_ExtensionBundle$$anon$1__f_laika$api$bundle$ExtensionBundle$$anon$1$$base$1).rawContentDisabled__s_Option());
});
var $d_Llaika_api_bundle_ExtensionBundle$$anon$1 = new $TypeData().initClass($c_Llaika_api_bundle_ExtensionBundle$$anon$1, "laika.api.bundle.ExtensionBundle$$anon$1", ({
  Llaika_api_bundle_ExtensionBundle$$anon$1: 1,
  Llaika_api_bundle_ExtensionBundle: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_ExtensionBundle$$anon$4() {
  this.Llaika_api_bundle_ExtensionBundle$$anon$4__f_origin = null;
  this.Llaika_api_bundle_ExtensionBundle$$anon$4__f_origin = $m_Llaika_api_bundle_BundleOrigin$Library$();
}
$c_Llaika_api_bundle_ExtensionBundle$$anon$4.prototype = new $h_O();
$c_Llaika_api_bundle_ExtensionBundle$$anon$4.prototype.constructor = $c_Llaika_api_bundle_ExtensionBundle$$anon$4;
/** @constructor */
function $h_Llaika_api_bundle_ExtensionBundle$$anon$4() {
}
$h_Llaika_api_bundle_ExtensionBundle$$anon$4.prototype = $c_Llaika_api_bundle_ExtensionBundle$$anon$4.prototype;
$c_Llaika_api_bundle_ExtensionBundle$$anon$4.prototype.baseConfig__Llaika_api_config_Config = (function() {
  return $m_Llaika_api_config_Config$().Llaika_api_config_Config$__f_empty;
});
$c_Llaika_api_bundle_ExtensionBundle$$anon$4.prototype.slugBuilder__s_Option = (function() {
  return $m_s_None$();
});
$c_Llaika_api_bundle_ExtensionBundle$$anon$4.prototype.parsers__Llaika_api_bundle_ParserBundle = (function() {
  return new $c_Llaika_api_bundle_ParserBundle($m_sci_Nil$(), $m_sci_Nil$(), $m_sci_Nil$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
});
$c_Llaika_api_bundle_ExtensionBundle$$anon$4.prototype.rewriteRules__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf;
});
$c_Llaika_api_bundle_ExtensionBundle$$anon$4.prototype.renderOverrides__sci_Seq = (function() {
  return $as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps());
});
$c_Llaika_api_bundle_ExtensionBundle$$anon$4.prototype.processExtension__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf;
});
$c_Llaika_api_bundle_ExtensionBundle$$anon$4.prototype.forStrictMode__s_Option = (function() {
  return new $c_s_Some(this);
});
$c_Llaika_api_bundle_ExtensionBundle$$anon$4.prototype.rawContentDisabled__s_Option = (function() {
  return new $c_s_Some(this);
});
$c_Llaika_api_bundle_ExtensionBundle$$anon$4.prototype.origin__Llaika_api_bundle_BundleOrigin = (function() {
  return this.Llaika_api_bundle_ExtensionBundle$$anon$4__f_origin;
});
var $d_Llaika_api_bundle_ExtensionBundle$$anon$4 = new $TypeData().initClass($c_Llaika_api_bundle_ExtensionBundle$$anon$4, "laika.api.bundle.ExtensionBundle$$anon$4", ({
  Llaika_api_bundle_ExtensionBundle$$anon$4: 1,
  Llaika_api_bundle_ExtensionBundle: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_ExtensionBundle$LaikaDefaults$() {
  this.Llaika_api_bundle_ExtensionBundle$LaikaDefaults$__f_origin = null;
  this.Llaika_api_bundle_ExtensionBundle$LaikaDefaults$__f_slugBuilder = null;
  this.Llaika_api_bundle_ExtensionBundle$LaikaDefaults$__f_baseConfig = null;
  this.Llaika_api_bundle_ExtensionBundle$LaikaDefaults$__f_parsers = null;
  $n_Llaika_api_bundle_ExtensionBundle$LaikaDefaults$ = this;
  this.Llaika_api_bundle_ExtensionBundle$LaikaDefaults$__f_origin = $m_Llaika_api_bundle_BundleOrigin$Library$();
  var value = new $c_sjsr_AnonFunction1(((text) => {
    var text$1 = $as_T(text);
    return $m_Llaika_api_bundle_SlugBuilder$().default__T__T(text$1);
  }));
  this.Llaika_api_bundle_ExtensionBundle$LaikaDefaults$__f_slugBuilder = new $c_s_Some(value);
  this.Llaika_api_bundle_ExtensionBundle$LaikaDefaults$__f_baseConfig = $m_Llaika_api_config_Config$().Llaika_api_config_Config$__f_empty;
  var value$1 = $m_Llaika_internal_parse_css_CSSParsers$().styleDeclarationSet__Llaika_parse_Parser();
  var styleSheetParser$1 = new $c_s_Some(value$1);
  var blockParsers$1 = $m_sci_Nil$();
  var spanParsers$1 = $m_sci_Nil$();
  var syntaxHighlighters$1 = $m_sci_Nil$();
  var markupParserHooks$1 = $m_s_None$();
  var configProvider$1 = $m_s_None$();
  var templateParser$1 = $m_s_None$();
  this.Llaika_api_bundle_ExtensionBundle$LaikaDefaults$__f_parsers = new $c_Llaika_api_bundle_ParserBundle(blockParsers$1, spanParsers$1, syntaxHighlighters$1, markupParserHooks$1, configProvider$1, templateParser$1, styleSheetParser$1);
}
$c_Llaika_api_bundle_ExtensionBundle$LaikaDefaults$.prototype = new $h_O();
$c_Llaika_api_bundle_ExtensionBundle$LaikaDefaults$.prototype.constructor = $c_Llaika_api_bundle_ExtensionBundle$LaikaDefaults$;
/** @constructor */
function $h_Llaika_api_bundle_ExtensionBundle$LaikaDefaults$() {
}
$h_Llaika_api_bundle_ExtensionBundle$LaikaDefaults$.prototype = $c_Llaika_api_bundle_ExtensionBundle$LaikaDefaults$.prototype;
$c_Llaika_api_bundle_ExtensionBundle$LaikaDefaults$.prototype.rewriteRules__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf;
});
$c_Llaika_api_bundle_ExtensionBundle$LaikaDefaults$.prototype.renderOverrides__sci_Seq = (function() {
  return $as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps());
});
$c_Llaika_api_bundle_ExtensionBundle$LaikaDefaults$.prototype.processExtension__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf;
});
$c_Llaika_api_bundle_ExtensionBundle$LaikaDefaults$.prototype.forStrictMode__s_Option = (function() {
  return new $c_s_Some(this);
});
$c_Llaika_api_bundle_ExtensionBundle$LaikaDefaults$.prototype.rawContentDisabled__s_Option = (function() {
  return new $c_s_Some(this);
});
$c_Llaika_api_bundle_ExtensionBundle$LaikaDefaults$.prototype.origin__Llaika_api_bundle_BundleOrigin = (function() {
  return this.Llaika_api_bundle_ExtensionBundle$LaikaDefaults$__f_origin;
});
$c_Llaika_api_bundle_ExtensionBundle$LaikaDefaults$.prototype.slugBuilder__s_Option = (function() {
  return this.Llaika_api_bundle_ExtensionBundle$LaikaDefaults$__f_slugBuilder;
});
$c_Llaika_api_bundle_ExtensionBundle$LaikaDefaults$.prototype.baseConfig__Llaika_api_config_Config = (function() {
  return this.Llaika_api_bundle_ExtensionBundle$LaikaDefaults$__f_baseConfig;
});
$c_Llaika_api_bundle_ExtensionBundle$LaikaDefaults$.prototype.parsers__Llaika_api_bundle_ParserBundle = (function() {
  return this.Llaika_api_bundle_ExtensionBundle$LaikaDefaults$__f_parsers;
});
var $d_Llaika_api_bundle_ExtensionBundle$LaikaDefaults$ = new $TypeData().initClass($c_Llaika_api_bundle_ExtensionBundle$LaikaDefaults$, "laika.api.bundle.ExtensionBundle$LaikaDefaults$", ({
  Llaika_api_bundle_ExtensionBundle$LaikaDefaults$: 1,
  Llaika_api_bundle_ExtensionBundle: 1
}));
var $n_Llaika_api_bundle_ExtensionBundle$LaikaDefaults$;
function $m_Llaika_api_bundle_ExtensionBundle$LaikaDefaults$() {
  if ((!$n_Llaika_api_bundle_ExtensionBundle$LaikaDefaults$)) {
    $n_Llaika_api_bundle_ExtensionBundle$LaikaDefaults$ = new $c_Llaika_api_bundle_ExtensionBundle$LaikaDefaults$();
  }
  return $n_Llaika_api_bundle_ExtensionBundle$LaikaDefaults$;
}
/** @constructor */
function $c_Llaika_api_bundle_LinkDirectives$$anon$14(directiveName$2, f$9, outer) {
  this.Llaika_api_bundle_LinkDirectives$$anon$14__f_directiveName$1 = null;
  this.Llaika_api_bundle_LinkDirectives$$anon$14__f_f$5 = null;
  this.Llaika_api_bundle_LinkDirectives$$anon$14__f_directiveName$1 = directiveName$2;
  this.Llaika_api_bundle_LinkDirectives$$anon$14__f_f$5 = f$9;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_api_bundle_LinkDirectives$$anon$14.prototype = new $h_O();
$c_Llaika_api_bundle_LinkDirectives$$anon$14.prototype.constructor = $c_Llaika_api_bundle_LinkDirectives$$anon$14;
/** @constructor */
function $h_Llaika_api_bundle_LinkDirectives$$anon$14() {
}
$h_Llaika_api_bundle_LinkDirectives$$anon$14.prototype = $c_Llaika_api_bundle_LinkDirectives$$anon$14.prototype;
$c_Llaika_api_bundle_LinkDirectives$$anon$14.prototype.apply__T__Llaika_ast_DocumentCursor__s_util_Either = (function(linkId, cursor) {
  var this$1 = $n($as_s_util_Either($n(this.Llaika_api_bundle_LinkDirectives$$anon$14__f_f$5).apply__O__O__O(linkId, cursor)));
  if ((this$1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$1);
    var b = $n(x2).s_util_Right__f_value;
    var _$24 = $as_Llaika_ast_SpanLink(b);
    return new $c_s_util_Right($as_Llaika_ast_SpanLink($n(_$24).withStyles__T__sci_Seq__Llaika_ast_Element(this.Llaika_api_bundle_LinkDirectives$$anon$14__f_directiveName$1, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([])))));
  } else {
    return this$1;
  }
});
var $d_Llaika_api_bundle_LinkDirectives$$anon$14 = new $TypeData().initClass($c_Llaika_api_bundle_LinkDirectives$$anon$14, "laika.api.bundle.LinkDirectives$$anon$14", ({
  Llaika_api_bundle_LinkDirectives$$anon$14: 1,
  Llaika_api_bundle_LinkDirectives$Directive: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_PathTranslator$$anon$1() {
}
$c_Llaika_api_bundle_PathTranslator$$anon$1.prototype = new $h_O();
$c_Llaika_api_bundle_PathTranslator$$anon$1.prototype.constructor = $c_Llaika_api_bundle_PathTranslator$$anon$1;
/** @constructor */
function $h_Llaika_api_bundle_PathTranslator$$anon$1() {
}
$h_Llaika_api_bundle_PathTranslator$$anon$1.prototype = $c_Llaika_api_bundle_PathTranslator$$anon$1.prototype;
var $d_Llaika_api_bundle_PathTranslator$$anon$1 = new $TypeData().initClass($c_Llaika_api_bundle_PathTranslator$$anon$1, "laika.api.bundle.PathTranslator$$anon$1", ({
  Llaika_api_bundle_PathTranslator$$anon$1: 1,
  Llaika_api_bundle_PathTranslator: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_Precedence$High$() {
}
$c_Llaika_api_bundle_Precedence$High$.prototype = new $h_O();
$c_Llaika_api_bundle_Precedence$High$.prototype.constructor = $c_Llaika_api_bundle_Precedence$High$;
/** @constructor */
function $h_Llaika_api_bundle_Precedence$High$() {
}
$h_Llaika_api_bundle_Precedence$High$.prototype = $c_Llaika_api_bundle_Precedence$High$.prototype;
var $d_Llaika_api_bundle_Precedence$High$ = new $TypeData().initClass($c_Llaika_api_bundle_Precedence$High$, "laika.api.bundle.Precedence$High$", ({
  Llaika_api_bundle_Precedence$High$: 1,
  Llaika_api_bundle_Precedence: 1
}));
var $n_Llaika_api_bundle_Precedence$High$;
function $m_Llaika_api_bundle_Precedence$High$() {
  if ((!$n_Llaika_api_bundle_Precedence$High$)) {
    $n_Llaika_api_bundle_Precedence$High$ = new $c_Llaika_api_bundle_Precedence$High$();
  }
  return $n_Llaika_api_bundle_Precedence$High$;
}
/** @constructor */
function $c_Llaika_api_bundle_Precedence$Low$() {
}
$c_Llaika_api_bundle_Precedence$Low$.prototype = new $h_O();
$c_Llaika_api_bundle_Precedence$Low$.prototype.constructor = $c_Llaika_api_bundle_Precedence$Low$;
/** @constructor */
function $h_Llaika_api_bundle_Precedence$Low$() {
}
$h_Llaika_api_bundle_Precedence$Low$.prototype = $c_Llaika_api_bundle_Precedence$Low$.prototype;
var $d_Llaika_api_bundle_Precedence$Low$ = new $TypeData().initClass($c_Llaika_api_bundle_Precedence$Low$, "laika.api.bundle.Precedence$Low$", ({
  Llaika_api_bundle_Precedence$Low$: 1,
  Llaika_api_bundle_Precedence: 1
}));
var $n_Llaika_api_bundle_Precedence$Low$;
function $m_Llaika_api_bundle_Precedence$Low$() {
  if ((!$n_Llaika_api_bundle_Precedence$Low$)) {
    $n_Llaika_api_bundle_Precedence$Low$ = new $c_Llaika_api_bundle_Precedence$Low$();
  }
  return $n_Llaika_api_bundle_Precedence$Low$;
}
/** @constructor */
function $c_Llaika_api_bundle_SpanDirectives$() {
  this.Llaika_api_bundle_SpanDirectives$__f_Multipart$lzy1 = null;
  this.Llaika_api_bundle_SpanDirectives$__f_Multipartbitmap$1 = false;
  this.Llaika_api_bundle_SpanDirectives$__f_BodyContent$lzy1 = null;
  this.Llaika_api_bundle_SpanDirectives$__f_BodyContentbitmap$1 = false;
  this.Llaika_api_bundle_SpanDirectives$__f_DirectiveContent$lzy1 = null;
  this.Llaika_api_bundle_SpanDirectives$__f_DirectiveContentbitmap$1 = false;
  this.Llaika_api_bundle_SpanDirectives$__f_DirectivePart$lzy1 = null;
  this.Llaika_api_bundle_SpanDirectives$__f_DirectivePartbitmap$1 = false;
  this.Llaika_api_bundle_SpanDirectives$__f_dsl$lzy1 = null;
  this.Llaika_api_bundle_SpanDirectives$__f_dslbitmap$1 = false;
}
$c_Llaika_api_bundle_SpanDirectives$.prototype = new $h_O();
$c_Llaika_api_bundle_SpanDirectives$.prototype.constructor = $c_Llaika_api_bundle_SpanDirectives$;
/** @constructor */
function $h_Llaika_api_bundle_SpanDirectives$() {
}
$h_Llaika_api_bundle_SpanDirectives$.prototype = $c_Llaika_api_bundle_SpanDirectives$.prototype;
$c_Llaika_api_bundle_SpanDirectives$.prototype.Multipart__Llaika_api_bundle_DirectiveBuilderContext$Multipart$ = (function() {
  if ((!this.Llaika_api_bundle_SpanDirectives$__f_Multipartbitmap$1)) {
    this.Llaika_api_bundle_SpanDirectives$__f_Multipart$lzy1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$Multipart$(this);
    this.Llaika_api_bundle_SpanDirectives$__f_Multipartbitmap$1 = true;
  }
  return this.Llaika_api_bundle_SpanDirectives$__f_Multipart$lzy1;
});
$c_Llaika_api_bundle_SpanDirectives$.prototype.BodyContent__Llaika_api_bundle_DirectiveBuilderContext$BodyContent$ = (function() {
  if ((!this.Llaika_api_bundle_SpanDirectives$__f_BodyContentbitmap$1)) {
    this.Llaika_api_bundle_SpanDirectives$__f_BodyContent$lzy1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$(this);
    this.Llaika_api_bundle_SpanDirectives$__f_BodyContentbitmap$1 = true;
  }
  return this.Llaika_api_bundle_SpanDirectives$__f_BodyContent$lzy1;
});
$c_Llaika_api_bundle_SpanDirectives$.prototype.DirectiveContent__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent$ = (function() {
  if ((!this.Llaika_api_bundle_SpanDirectives$__f_DirectiveContentbitmap$1)) {
    this.Llaika_api_bundle_SpanDirectives$__f_DirectiveContent$lzy1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent$(this);
    this.Llaika_api_bundle_SpanDirectives$__f_DirectiveContentbitmap$1 = true;
  }
  return this.Llaika_api_bundle_SpanDirectives$__f_DirectiveContent$lzy1;
});
$c_Llaika_api_bundle_SpanDirectives$.prototype.DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$ = (function() {
  if ((!this.Llaika_api_bundle_SpanDirectives$__f_DirectivePartbitmap$1)) {
    this.Llaika_api_bundle_SpanDirectives$__f_DirectivePart$lzy1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$(this);
    this.Llaika_api_bundle_SpanDirectives$__f_DirectivePartbitmap$1 = true;
  }
  return this.Llaika_api_bundle_SpanDirectives$__f_DirectivePart$lzy1;
});
$c_Llaika_api_bundle_SpanDirectives$.prototype.dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$ = (function() {
  if ((!this.Llaika_api_bundle_SpanDirectives$__f_dslbitmap$1)) {
    this.Llaika_api_bundle_SpanDirectives$__f_dsl$lzy1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$dsl$(this);
    this.Llaika_api_bundle_SpanDirectives$__f_dslbitmap$1 = true;
  }
  return this.Llaika_api_bundle_SpanDirectives$__f_dsl$lzy1;
});
$c_Llaika_api_bundle_SpanDirectives$.prototype.parse__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_SourceFragment__s_util_Either = (function(parser, src) {
  var this$1 = $n(parser);
  var this$2 = $n($n(new $c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$RecursiveSpanParserDelegate(this$1, $as_Llaika_parse_Parser(this$1.defaultSpanParser__Llaika_parse_markup_InlineParser())).parse__Llaika_parse_SourceFragment__Llaika_parse_Parsed(src)).toEither__s_util_Either());
  var this$3 = new $c_s_util_Either$LeftProjection(this$2);
  var x1 = this$3.s_util_Either$LeftProjection__f_e;
  if ((x1 instanceof $c_s_util_Left)) {
    var x2 = $as_s_util_Left(x1);
    var a = $n(x2).s_util_Left__f_value;
    var _$17 = $as_T(a);
    return new $c_s_util_Left($as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([_$17])))));
  } else {
    return this$3.s_util_Either$LeftProjection__f_e;
  }
});
$c_Llaika_api_bundle_SpanDirectives$.prototype.parse__O__Llaika_parse_SourceFragment__s_util_Either = (function(parser, src) {
  return this.parse__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_SourceFragment__s_util_Either($as_Llaika_parse_markup_RecursiveSpanParsers(parser), src);
});
var $d_Llaika_api_bundle_SpanDirectives$ = new $TypeData().initClass($c_Llaika_api_bundle_SpanDirectives$, "laika.api.bundle.SpanDirectives$", ({
  Llaika_api_bundle_SpanDirectives$: 1,
  Llaika_api_bundle_DirectiveBuilderContext: 1
}));
var $n_Llaika_api_bundle_SpanDirectives$;
function $m_Llaika_api_bundle_SpanDirectives$() {
  if ((!$n_Llaika_api_bundle_SpanDirectives$)) {
    $n_Llaika_api_bundle_SpanDirectives$ = new $c_Llaika_api_bundle_SpanDirectives$();
  }
  return $n_Llaika_api_bundle_SpanDirectives$;
}
/** @constructor */
function $c_Llaika_api_bundle_SpanParserBuilder(parserFactory, recursive, precedence) {
  this.Llaika_api_bundle_SpanParserBuilder__f_parserFactory = null;
  this.Llaika_api_bundle_SpanParserBuilder__f_recursive = false;
  this.Llaika_api_bundle_SpanParserBuilder__f_precedence = null;
  this.Llaika_api_bundle_SpanParserBuilder__f_parserFactory = parserFactory;
  this.Llaika_api_bundle_SpanParserBuilder__f_recursive = recursive;
  this.Llaika_api_bundle_SpanParserBuilder__f_precedence = precedence;
}
$c_Llaika_api_bundle_SpanParserBuilder.prototype = new $h_O();
$c_Llaika_api_bundle_SpanParserBuilder.prototype.constructor = $c_Llaika_api_bundle_SpanParserBuilder;
/** @constructor */
function $h_Llaika_api_bundle_SpanParserBuilder() {
}
$h_Llaika_api_bundle_SpanParserBuilder.prototype = $c_Llaika_api_bundle_SpanParserBuilder.prototype;
$c_Llaika_api_bundle_SpanParserBuilder.prototype.createParser__Llaika_parse_markup_RecursiveParsers__Llaika_api_bundle_SpanParserDefinition = (function(recursiveParsers) {
  var p = $as_Llaika_parse_text_PrefixedParser($n(this.Llaika_api_bundle_SpanParserBuilder__f_parserFactory).apply__O__O(recursiveParsers));
  return new $c_Llaika_api_bundle_SpanParserDefinition($n(p).startChars__O(), $n(p).underlying__Llaika_parse_Parser(), this.Llaika_api_bundle_SpanParserBuilder__f_recursive, this.Llaika_api_bundle_SpanParserBuilder__f_precedence);
});
$c_Llaika_api_bundle_SpanParserBuilder.prototype.withLowPrecedence__Llaika_api_bundle_SpanParserBuilder = (function() {
  return new $c_Llaika_api_bundle_SpanParserBuilder(this.Llaika_api_bundle_SpanParserBuilder__f_parserFactory, this.Llaika_api_bundle_SpanParserBuilder__f_recursive, $m_Llaika_api_bundle_Precedence$Low$());
});
$c_Llaika_api_bundle_SpanParserBuilder.prototype.createParser__Llaika_parse_markup_RecursiveParsers__Llaika_api_bundle_ParserDefinition = (function(recursiveParsers) {
  return this.createParser__Llaika_parse_markup_RecursiveParsers__Llaika_api_bundle_SpanParserDefinition(recursiveParsers);
});
var $d_Llaika_api_bundle_SpanParserBuilder = new $TypeData().initClass($c_Llaika_api_bundle_SpanParserBuilder, "laika.api.bundle.SpanParserBuilder", ({
  Llaika_api_bundle_SpanParserBuilder: 1,
  Llaika_api_bundle_ParserBuilder: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_SpanParserDefinition(startChars, parser, isRecursive, precedence) {
  this.Llaika_api_bundle_SpanParserDefinition__f_startChars = null;
  this.Llaika_api_bundle_SpanParserDefinition__f_parser = null;
  this.Llaika_api_bundle_SpanParserDefinition__f_precedence = null;
  this.Llaika_api_bundle_SpanParserDefinition__f_startChars = startChars;
  this.Llaika_api_bundle_SpanParserDefinition__f_parser = parser;
  this.Llaika_api_bundle_SpanParserDefinition__f_precedence = precedence;
}
$c_Llaika_api_bundle_SpanParserDefinition.prototype = new $h_O();
$c_Llaika_api_bundle_SpanParserDefinition.prototype.constructor = $c_Llaika_api_bundle_SpanParserDefinition;
/** @constructor */
function $h_Llaika_api_bundle_SpanParserDefinition() {
}
$h_Llaika_api_bundle_SpanParserDefinition.prototype = $c_Llaika_api_bundle_SpanParserDefinition.prototype;
$c_Llaika_api_bundle_SpanParserDefinition.prototype.precedence__Llaika_api_bundle_Precedence = (function() {
  return this.Llaika_api_bundle_SpanParserDefinition__f_precedence;
});
function $as_Llaika_api_bundle_SpanParserDefinition(obj) {
  return (((obj instanceof $c_Llaika_api_bundle_SpanParserDefinition) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.SpanParserDefinition"));
}
function $isArrayOf_Llaika_api_bundle_SpanParserDefinition(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_SpanParserDefinition)));
}
function $asArrayOf_Llaika_api_bundle_SpanParserDefinition(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_SpanParserDefinition(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.SpanParserDefinition;", depth));
}
var $d_Llaika_api_bundle_SpanParserDefinition = new $TypeData().initClass($c_Llaika_api_bundle_SpanParserDefinition, "laika.api.bundle.SpanParserDefinition", ({
  Llaika_api_bundle_SpanParserDefinition: 1,
  Llaika_api_bundle_ParserDefinition: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_TemplateDirectives$() {
  this.Llaika_api_bundle_TemplateDirectives$__f_Multipart$lzy3 = null;
  this.Llaika_api_bundle_TemplateDirectives$__f_Multipartbitmap$3 = false;
  this.Llaika_api_bundle_TemplateDirectives$__f_BodyContent$lzy3 = null;
  this.Llaika_api_bundle_TemplateDirectives$__f_BodyContentbitmap$3 = false;
  this.Llaika_api_bundle_TemplateDirectives$__f_DirectiveContent$lzy3 = null;
  this.Llaika_api_bundle_TemplateDirectives$__f_DirectiveContentbitmap$3 = false;
  this.Llaika_api_bundle_TemplateDirectives$__f_DirectivePart$lzy3 = null;
  this.Llaika_api_bundle_TemplateDirectives$__f_DirectivePartbitmap$3 = false;
  this.Llaika_api_bundle_TemplateDirectives$__f_dsl$lzy3 = null;
  this.Llaika_api_bundle_TemplateDirectives$__f_dslbitmap$3 = false;
}
$c_Llaika_api_bundle_TemplateDirectives$.prototype = new $h_O();
$c_Llaika_api_bundle_TemplateDirectives$.prototype.constructor = $c_Llaika_api_bundle_TemplateDirectives$;
/** @constructor */
function $h_Llaika_api_bundle_TemplateDirectives$() {
}
$h_Llaika_api_bundle_TemplateDirectives$.prototype = $c_Llaika_api_bundle_TemplateDirectives$.prototype;
$c_Llaika_api_bundle_TemplateDirectives$.prototype.Multipart__Llaika_api_bundle_DirectiveBuilderContext$Multipart$ = (function() {
  if ((!this.Llaika_api_bundle_TemplateDirectives$__f_Multipartbitmap$3)) {
    this.Llaika_api_bundle_TemplateDirectives$__f_Multipart$lzy3 = new $c_Llaika_api_bundle_DirectiveBuilderContext$Multipart$(this);
    this.Llaika_api_bundle_TemplateDirectives$__f_Multipartbitmap$3 = true;
  }
  return this.Llaika_api_bundle_TemplateDirectives$__f_Multipart$lzy3;
});
$c_Llaika_api_bundle_TemplateDirectives$.prototype.BodyContent__Llaika_api_bundle_DirectiveBuilderContext$BodyContent$ = (function() {
  if ((!this.Llaika_api_bundle_TemplateDirectives$__f_BodyContentbitmap$3)) {
    this.Llaika_api_bundle_TemplateDirectives$__f_BodyContent$lzy3 = new $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$(this);
    this.Llaika_api_bundle_TemplateDirectives$__f_BodyContentbitmap$3 = true;
  }
  return this.Llaika_api_bundle_TemplateDirectives$__f_BodyContent$lzy3;
});
$c_Llaika_api_bundle_TemplateDirectives$.prototype.DirectiveContent__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent$ = (function() {
  if ((!this.Llaika_api_bundle_TemplateDirectives$__f_DirectiveContentbitmap$3)) {
    this.Llaika_api_bundle_TemplateDirectives$__f_DirectiveContent$lzy3 = new $c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent$(this);
    this.Llaika_api_bundle_TemplateDirectives$__f_DirectiveContentbitmap$3 = true;
  }
  return this.Llaika_api_bundle_TemplateDirectives$__f_DirectiveContent$lzy3;
});
$c_Llaika_api_bundle_TemplateDirectives$.prototype.DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$ = (function() {
  if ((!this.Llaika_api_bundle_TemplateDirectives$__f_DirectivePartbitmap$3)) {
    this.Llaika_api_bundle_TemplateDirectives$__f_DirectivePart$lzy3 = new $c_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$(this);
    this.Llaika_api_bundle_TemplateDirectives$__f_DirectivePartbitmap$3 = true;
  }
  return this.Llaika_api_bundle_TemplateDirectives$__f_DirectivePart$lzy3;
});
$c_Llaika_api_bundle_TemplateDirectives$.prototype.dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$ = (function() {
  if ((!this.Llaika_api_bundle_TemplateDirectives$__f_dslbitmap$3)) {
    this.Llaika_api_bundle_TemplateDirectives$__f_dsl$lzy3 = new $c_Llaika_api_bundle_DirectiveBuilderContext$dsl$(this);
    this.Llaika_api_bundle_TemplateDirectives$__f_dslbitmap$3 = true;
  }
  return this.Llaika_api_bundle_TemplateDirectives$__f_dsl$lzy3;
});
$c_Llaika_api_bundle_TemplateDirectives$.prototype.parse__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_SourceFragment__s_util_Either = (function(parser, src) {
  var this$1 = $n(parser);
  var this$3 = $n($n($n(new $c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$RecursiveSpanParserDelegate(this$1, $as_Llaika_parse_Parser(this$1.defaultSpanParser__Llaika_parse_markup_InlineParser())).parse__Llaika_parse_SourceFragment__Llaika_parse_Parsed(src)).map__F1__Llaika_parse_Parsed(new $c_sjsr_AnonFunction1(((_$21) => {
    var _$21$1 = $as_sci_Seq(_$21);
    return $as_sci_Seq($n(_$21$1).collect__s_PartialFunction__O(new $c_Llaika_api_bundle_TemplateDirectives$$anon$13()));
  })))).toEither__s_util_Either());
  var this$4 = new $c_s_util_Either$LeftProjection(this$3);
  var x1 = this$4.s_util_Either$LeftProjection__f_e;
  if ((x1 instanceof $c_s_util_Left)) {
    var x2 = $as_s_util_Left(x1);
    var a = $n(x2).s_util_Left__f_value;
    var _$22 = $as_T(a);
    return new $c_s_util_Left($as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([_$22])))));
  } else {
    return this$4.s_util_Either$LeftProjection__f_e;
  }
});
$c_Llaika_api_bundle_TemplateDirectives$.prototype.parse__O__Llaika_parse_SourceFragment__s_util_Either = (function(parser, src) {
  return this.parse__Llaika_parse_markup_RecursiveSpanParsers__Llaika_parse_SourceFragment__s_util_Either($as_Llaika_parse_markup_RecursiveSpanParsers(parser), src);
});
var $d_Llaika_api_bundle_TemplateDirectives$ = new $TypeData().initClass($c_Llaika_api_bundle_TemplateDirectives$, "laika.api.bundle.TemplateDirectives$", ({
  Llaika_api_bundle_TemplateDirectives$: 1,
  Llaika_api_bundle_DirectiveBuilderContext: 1
}));
var $n_Llaika_api_bundle_TemplateDirectives$;
function $m_Llaika_api_bundle_TemplateDirectives$() {
  if ((!$n_Llaika_api_bundle_TemplateDirectives$)) {
    $n_Llaika_api_bundle_TemplateDirectives$ = new $c_Llaika_api_bundle_TemplateDirectives$();
  }
  return $n_Llaika_api_bundle_TemplateDirectives$;
}
/** @constructor */
function $c_Llaika_api_config_ConfigDecoder$$anon$1(f$3, outer) {
  this.Llaika_api_config_ConfigDecoder$$anon$1__f_f$1 = null;
  this.Llaika_api_config_ConfigDecoder$$anon$1__f_$outer = null;
  this.Llaika_api_config_ConfigDecoder$$anon$1__f_f$1 = f$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_config_ConfigDecoder$$anon$1__f_$outer = outer;
}
$c_Llaika_api_config_ConfigDecoder$$anon$1.prototype = new $h_O();
$c_Llaika_api_config_ConfigDecoder$$anon$1.prototype.constructor = $c_Llaika_api_config_ConfigDecoder$$anon$1;
/** @constructor */
function $h_Llaika_api_config_ConfigDecoder$$anon$1() {
}
$h_Llaika_api_config_ConfigDecoder$$anon$1.prototype = $c_Llaika_api_config_ConfigDecoder$$anon$1.prototype;
$c_Llaika_api_config_ConfigDecoder$$anon$1.prototype.apply__Llaika_api_config_Traced__s_util_Either = (function(value) {
  return $n($n(this.Llaika_api_config_ConfigDecoder$$anon$1__f_$outer).apply__Llaika_api_config_Traced__s_util_Either(value)).flatMap__F1__s_util_Either(this.Llaika_api_config_ConfigDecoder$$anon$1__f_f$1);
});
var $d_Llaika_api_config_ConfigDecoder$$anon$1 = new $TypeData().initClass($c_Llaika_api_config_ConfigDecoder$$anon$1, "laika.api.config.ConfigDecoder$$anon$1", ({
  Llaika_api_config_ConfigDecoder$$anon$1: 1,
  Llaika_api_config_ConfigDecoder: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigDecoder$$anon$10(elementDecoder$2, outer) {
  this.Llaika_api_config_ConfigDecoder$$anon$10__f_elementDecoder$1 = null;
  this.Llaika_api_config_ConfigDecoder$$anon$10__f_elementDecoder$1 = elementDecoder$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_api_config_ConfigDecoder$$anon$10.prototype = new $h_O();
$c_Llaika_api_config_ConfigDecoder$$anon$10.prototype.constructor = $c_Llaika_api_config_ConfigDecoder$$anon$10;
/** @constructor */
function $h_Llaika_api_config_ConfigDecoder$$anon$10() {
}
$h_Llaika_api_config_ConfigDecoder$$anon$10.prototype = $c_Llaika_api_config_ConfigDecoder$$anon$10.prototype;
$c_Llaika_api_config_ConfigDecoder$$anon$10.prototype.apply__Llaika_api_config_Traced__s_util_Either = (function(value) {
  var x46 = $as_Llaika_api_config_ConfigValue($n(value).Llaika_api_config_Traced__f_value);
  if ((x46 instanceof $c_Llaika_api_config_ConfigValue$ArrayValue)) {
    var x$1 = $as_Llaika_api_config_ConfigValue$ArrayValue(x46);
    var this$2 = $n(x$1);
    var x49 = this$2.Llaika_api_config_ConfigValue$ArrayValue__f_values;
    matchResult8: {
      var \u03b41$___1;
      var \u03b41$___2;
      var this$5 = $n($n(x49).toList__sci_List());
      var f = ((v) => {
        var v$1 = $as_Llaika_api_config_ConfigValue(v);
        var $x_1 = $n(this.Llaika_api_config_ConfigDecoder$$anon$10__f_elementDecoder$1);
        var origin = $n(value).Llaika_api_config_Traced__f_origin;
        return $n($x_1).apply__Llaika_api_config_Traced__s_util_Either(new $c_Llaika_api_config_Traced(v$1, origin));
      });
      if ((this$5 === $m_sci_Nil$())) {
        var fgab = $m_sci_Nil$();
      } else {
        var arg1 = this$5.head__O();
        var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
        var t = h;
        var rest = $as_sci_List(this$5.tail__O());
        while ((rest !== $m_sci_Nil$())) {
          var arg1$1 = $n(rest).head__O();
          var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
          $n(t).sci_$colon$colon__f_next = nx;
          t = nx;
          rest = $as_sci_List($n(rest).tail__O());
        }
        var fgab = h;
      }
      var this$10 = new $c_Lcats_syntax_SeparateOps(fgab);
      var F = $as_Lcats_FlatMap($as_Lcats_Alternative($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList));
      var A = $as_Lcats_Alternative($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
      var G = $m_Lcats_instances_package$either$().Lcats_instances_package$either$__f_catsStdBitraverseForEither;
      var x43 = $f_Lcats_syntax_SeparateOpsBinCompat0__separate__Lcats_FlatMap__Lcats_Alternative__Lcats_Bifoldable__T2(this$10, F, A, G);
      if ((x43 !== null)) {
        var errors = $as_sci_List($n(x43)._1__O());
        var results = $as_sci_List($n(x43)._2__O());
        var \u03b41$___1 = errors;
        var \u03b41$___2 = results;
        break matchResult8;
      }
      throw new $c_s_MatchError(x43);
    }
    var errors$2 = $as_sci_List(\u03b41$___1);
    var results$2 = $as_sci_List(\u03b41$___2);
    var this$12 = $n(errors$2);
    if ((!this$12.isEmpty__Z())) {
      var this$13 = $n(errors$2);
      var f$1 = ((_$3) => {
        var _$3$1 = $as_Llaika_api_config_ConfigError(_$3);
        return $n(_$3$1).message__T();
      });
      if ((this$13 === $m_sci_Nil$())) {
        var $x_2 = $m_sci_Nil$();
      } else {
        var arg1$2 = this$13.head__O();
        var h$1 = new $c_sci_$colon$colon(f$1(arg1$2), $m_sci_Nil$());
        var t$1 = h$1;
        var rest$1 = $as_sci_List(this$13.tail__O());
        while ((rest$1 !== $m_sci_Nil$())) {
          var arg1$3 = $n(rest$1).head__O();
          var nx$1 = new $c_sci_$colon$colon(f$1(arg1$3), $m_sci_Nil$());
          $n(t$1).sci_$colon$colon__f_next = nx$1;
          t$1 = nx$1;
          rest$1 = $as_sci_List($n(rest$1).tail__O());
        }
        var $x_2 = h$1;
      }
      var this$14 = $n($x_2);
      var error = ("One or more errors decoding array elements: " + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$14, "", ", ", ""));
      var key = $m_s_None$();
      var value$1 = new $c_Llaika_api_config_ConfigError$DecodingFailed(error, key);
      return new $c_s_util_Left(value$1);
    } else {
      return new $c_s_util_Right(results$2);
    }
  }
  var value$2 = new $c_Llaika_api_config_ConfigError$InvalidType("Array", x46);
  return new $c_s_util_Left(value$2);
});
var $d_Llaika_api_config_ConfigDecoder$$anon$10 = new $TypeData().initClass($c_Llaika_api_config_ConfigDecoder$$anon$10, "laika.api.config.ConfigDecoder$$anon$10", ({
  Llaika_api_config_ConfigDecoder$$anon$10: 1,
  Llaika_api_config_ConfigDecoder: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigDecoder$$anon$11(valueDecoder$6, outer) {
  this.Llaika_api_config_ConfigDecoder$$anon$11__f_valueDecoder$5 = null;
  this.Llaika_api_config_ConfigDecoder$$anon$11__f_valueDecoder$5 = valueDecoder$6;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_api_config_ConfigDecoder$$anon$11.prototype = new $h_O();
$c_Llaika_api_config_ConfigDecoder$$anon$11.prototype.constructor = $c_Llaika_api_config_ConfigDecoder$$anon$11;
/** @constructor */
function $h_Llaika_api_config_ConfigDecoder$$anon$11() {
}
$h_Llaika_api_config_ConfigDecoder$$anon$11.prototype = $c_Llaika_api_config_ConfigDecoder$$anon$11.prototype;
$c_Llaika_api_config_ConfigDecoder$$anon$11.prototype.apply__Llaika_api_config_Traced__s_util_Either = (function(x$1) {
  var valueDecoder$2 = this.Llaika_api_config_ConfigDecoder$$anon$11__f_valueDecoder$5;
  if ((x$1 !== null)) {
    var this$3 = $n(x$1);
    var x59 = $as_Llaika_api_config_ConfigValue(this$3.Llaika_api_config_Traced__f_value);
    var this$4 = $n(x$1);
    var x60 = this$4.Llaika_api_config_Traced__f_origin;
    if ((x59 instanceof $c_Llaika_api_config_ConfigValue$ObjectValue)) {
      var ov = $as_Llaika_api_config_ConfigValue$ObjectValue(x59);
      matchResult10: {
        var \u03b42$___1;
        var \u03b42$___2;
        var this$8 = $n($n($n(ov).Llaika_api_config_ConfigValue$ObjectValue__f_values).toList__sci_List());
        var f = ((field) => {
          var field$1 = $as_Llaika_api_config_Field(field);
          var value = $n(field$1).Llaika_api_config_Field__f_value;
          var this$6 = $n($n(valueDecoder$2).apply__Llaika_api_config_Traced__s_util_Either(new $c_Llaika_api_config_Traced(value, x60)));
          if ((this$6 instanceof $c_s_util_Right)) {
            var x2 = $as_s_util_Right(this$6);
            var b = $n(x2).s_util_Right__f_value;
            var _1 = $n(field$1).Llaika_api_config_Field__f_key;
            return new $c_s_util_Right(new $c_T2(_1, b));
          } else {
            return this$6;
          }
        });
        if ((this$8 === $m_sci_Nil$())) {
          var fgab = $m_sci_Nil$();
        } else {
          var arg1 = this$8.head__O();
          var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
          var t = h;
          var rest = $as_sci_List(this$8.tail__O());
          while ((rest !== $m_sci_Nil$())) {
            var arg1$1 = $n(rest).head__O();
            var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
            $n(t).sci_$colon$colon__f_next = nx;
            t = nx;
            rest = $as_sci_List($n(rest).tail__O());
          }
          var fgab = h;
        }
        var this$13 = new $c_Lcats_syntax_SeparateOps(fgab);
        var F = $as_Lcats_FlatMap($as_Lcats_Alternative($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList));
        var A = $as_Lcats_Alternative($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
        var G = $m_Lcats_instances_package$either$().Lcats_instances_package$either$__f_catsStdBitraverseForEither;
        var x50 = $f_Lcats_syntax_SeparateOpsBinCompat0__separate__Lcats_FlatMap__Lcats_Alternative__Lcats_Bifoldable__T2(this$13, F, A, G);
        if ((x50 !== null)) {
          var errors = $as_sci_List($n(x50)._1__O());
          var results = $as_sci_List($n(x50)._2__O());
          var \u03b42$___1 = errors;
          var \u03b42$___2 = results;
          break matchResult10;
        }
        throw new $c_s_MatchError(x50);
      }
      var errors$2 = $as_sci_List(\u03b42$___1);
      var results$2 = $as_sci_List(\u03b42$___2);
      var this$15 = $n(errors$2);
      if ((!this$15.isEmpty__Z())) {
        var this$16 = $n(errors$2);
        var error = ("One or more errors decoding map values: " + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$16, "", ", ", ""));
        var key = $m_s_None$();
        var value$1 = new $c_Llaika_api_config_ConfigError$DecodingFailed(error, key);
        return new $c_s_util_Left(value$1);
      } else {
        var this$21 = $n(results$2);
        var this$20 = $m_s_$less$colon$less$();
        var value$2 = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$21);
        return new $c_s_util_Right(value$2);
      }
    }
    if ((x59 !== null)) {
      var value$3 = new $c_Llaika_api_config_ConfigError$InvalidType("Object", x59);
      return new $c_s_util_Left(value$3);
    }
  }
  throw new $c_s_MatchError(x$1);
});
var $d_Llaika_api_config_ConfigDecoder$$anon$11 = new $TypeData().initClass($c_Llaika_api_config_ConfigDecoder$$anon$11, "laika.api.config.ConfigDecoder$$anon$11", ({
  Llaika_api_config_ConfigDecoder$$anon$11: 1,
  Llaika_api_config_ConfigDecoder: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigDecoder$$anon$2(f$4, outer) {
  this.Llaika_api_config_ConfigDecoder$$anon$2__f_f$2 = null;
  this.Llaika_api_config_ConfigDecoder$$anon$2__f_$outer = null;
  this.Llaika_api_config_ConfigDecoder$$anon$2__f_f$2 = f$4;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_config_ConfigDecoder$$anon$2__f_$outer = outer;
}
$c_Llaika_api_config_ConfigDecoder$$anon$2.prototype = new $h_O();
$c_Llaika_api_config_ConfigDecoder$$anon$2.prototype.constructor = $c_Llaika_api_config_ConfigDecoder$$anon$2;
/** @constructor */
function $h_Llaika_api_config_ConfigDecoder$$anon$2() {
}
$h_Llaika_api_config_ConfigDecoder$$anon$2.prototype = $c_Llaika_api_config_ConfigDecoder$$anon$2.prototype;
$c_Llaika_api_config_ConfigDecoder$$anon$2.prototype.apply__Llaika_api_config_Traced__s_util_Either = (function(value) {
  return $n($n(this.Llaika_api_config_ConfigDecoder$$anon$2__f_$outer).apply__Llaika_api_config_Traced__s_util_Either(value)).map__F1__s_util_Either(this.Llaika_api_config_ConfigDecoder$$anon$2__f_f$2);
});
var $d_Llaika_api_config_ConfigDecoder$$anon$2 = new $TypeData().initClass($c_Llaika_api_config_ConfigDecoder$$anon$2, "laika.api.config.ConfigDecoder$$anon$2", ({
  Llaika_api_config_ConfigDecoder$$anon$2: 1,
  Llaika_api_config_ConfigDecoder: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigDecoder$$anon$3() {
}
$c_Llaika_api_config_ConfigDecoder$$anon$3.prototype = new $h_O();
$c_Llaika_api_config_ConfigDecoder$$anon$3.prototype.constructor = $c_Llaika_api_config_ConfigDecoder$$anon$3;
/** @constructor */
function $h_Llaika_api_config_ConfigDecoder$$anon$3() {
}
$h_Llaika_api_config_ConfigDecoder$$anon$3.prototype = $c_Llaika_api_config_ConfigDecoder$$anon$3.prototype;
$c_Llaika_api_config_ConfigDecoder$$anon$3.prototype.apply__Llaika_api_config_Traced__s_util_Either = (function(value) {
  var x1 = $as_Llaika_api_config_ConfigValue($n(value).Llaika_api_config_Traced__f_value);
  if ((x1 instanceof $c_Llaika_api_config_ConfigValue$BooleanValue)) {
    var x$1 = $as_Llaika_api_config_ConfigValue$BooleanValue(x1);
    var this$2 = $n(x$1);
    var x4 = this$2.Llaika_api_config_ConfigValue$BooleanValue__f_value;
    return new $c_s_util_Right(x4);
  }
  var value$1 = new $c_Llaika_api_config_ConfigError$InvalidType("Boolean", x1);
  return new $c_s_util_Left(value$1);
});
var $d_Llaika_api_config_ConfigDecoder$$anon$3 = new $TypeData().initClass($c_Llaika_api_config_ConfigDecoder$$anon$3, "laika.api.config.ConfigDecoder$$anon$3", ({
  Llaika_api_config_ConfigDecoder$$anon$3: 1,
  Llaika_api_config_ConfigDecoder: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigDecoder$$anon$4() {
}
$c_Llaika_api_config_ConfigDecoder$$anon$4.prototype = new $h_O();
$c_Llaika_api_config_ConfigDecoder$$anon$4.prototype.constructor = $c_Llaika_api_config_ConfigDecoder$$anon$4;
/** @constructor */
function $h_Llaika_api_config_ConfigDecoder$$anon$4() {
}
$h_Llaika_api_config_ConfigDecoder$$anon$4.prototype = $c_Llaika_api_config_ConfigDecoder$$anon$4.prototype;
$c_Llaika_api_config_ConfigDecoder$$anon$4.prototype.apply__Llaika_api_config_Traced__s_util_Either = (function(value) {
  var x5 = $as_Llaika_api_config_ConfigValue($n(value).Llaika_api_config_Traced__f_value);
  if ($is_Llaika_api_config_ConfigValue$SimpleValue(x5)) {
    var s = $as_Llaika_api_config_ConfigValue$SimpleValue(x5);
    var value$1 = $n(s).render__T();
    return new $c_s_util_Right(value$1);
  }
  var value$2 = new $c_Llaika_api_config_ConfigError$InvalidType("String", x5);
  return new $c_s_util_Left(value$2);
});
var $d_Llaika_api_config_ConfigDecoder$$anon$4 = new $TypeData().initClass($c_Llaika_api_config_ConfigDecoder$$anon$4, "laika.api.config.ConfigDecoder$$anon$4", ({
  Llaika_api_config_ConfigDecoder$$anon$4: 1,
  Llaika_api_config_ConfigDecoder: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigDecoder$$anon$5() {
}
$c_Llaika_api_config_ConfigDecoder$$anon$5.prototype = new $h_O();
$c_Llaika_api_config_ConfigDecoder$$anon$5.prototype.constructor = $c_Llaika_api_config_ConfigDecoder$$anon$5;
/** @constructor */
function $h_Llaika_api_config_ConfigDecoder$$anon$5() {
}
$h_Llaika_api_config_ConfigDecoder$$anon$5.prototype = $c_Llaika_api_config_ConfigDecoder$$anon$5.prototype;
$c_Llaika_api_config_ConfigDecoder$$anon$5.prototype.apply__Llaika_api_config_Traced__s_util_Either = (function(value) {
  var x7 = $as_Llaika_api_config_ConfigValue($n(value).Llaika_api_config_Traced__f_value);
  if ((x7 instanceof $c_Llaika_api_config_ConfigValue$LongValue)) {
    var x$1 = $as_Llaika_api_config_ConfigValue$LongValue(x7);
    var this$2 = $n(x$1);
    var t = this$2.Llaika_api_config_ConfigValue$LongValue__f_value;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var test = $m_sr_RichLong$().isValidInt$extension__J__Z(new $c_RTLong(lo, hi));
    if (test) {
      return new $c_s_util_Right(lo);
    } else {
      var error = ("not a valid integer: " + new $c_RTLong(lo, hi));
      var key = $m_s_None$();
      return new $c_s_util_Left(new $c_Llaika_api_config_ConfigError$DecodingFailed(error, key));
    }
  }
  if ((x7 instanceof $c_Llaika_api_config_ConfigValue$DoubleValue)) {
    var x$1$1 = $as_Llaika_api_config_ConfigValue$DoubleValue(x7);
    var this$8 = $n(x$1$1);
    var x13 = this$8.Llaika_api_config_ConfigValue$DoubleValue__f_value;
    var test$1 = $m_sr_RichDouble$().isValidInt$extension__D__Z(x13);
    if (test$1) {
      return new $c_s_util_Right($doubleToInt(x13));
    } else {
      var error$1 = ("not a valid integer: " + x13);
      var key$1 = $m_s_None$();
      return new $c_s_util_Left(new $c_Llaika_api_config_ConfigError$DecodingFailed(error$1, key$1));
    }
  }
  if ((x7 instanceof $c_Llaika_api_config_ConfigValue$StringValue)) {
    var x$1$2 = $as_Llaika_api_config_ConfigValue$StringValue(x7);
    var this$14 = $n(x$1$2);
    var x10 = this$14.Llaika_api_config_ConfigValue$StringValue__f_value;
    try {
      var this$18 = $m_jl_Integer$();
      var r1 = this$18.parseInt__T__I__I(x10, 10);
      var $x_1 = new $c_s_util_Success(r1);
    } catch (e) {
      var $x_1;
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        var $x_1 = new $c_s_util_Failure(e$2);
      } else {
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2));
      }
    }
    var this$19 = $n($n($x_1).toEither__s_util_Either());
    var this$20 = new $c_s_util_Either$LeftProjection(this$19);
    var x1 = this$20.s_util_Either$LeftProjection__f_e;
    if ((x1 instanceof $c_s_util_Left)) {
      var x2 = $as_s_util_Left(x1);
      var a = $n(x2).s_util_Left__f_value;
      $as_jl_Throwable(a);
      var error$2 = ("not an integer: " + x10);
      var key$2 = $m_s_None$();
      return new $c_s_util_Left(new $c_Llaika_api_config_ConfigError$DecodingFailed(error$2, key$2));
    } else {
      return this$20.s_util_Either$LeftProjection__f_e;
    }
  }
  var value$1 = new $c_Llaika_api_config_ConfigError$InvalidType("Number", x7);
  return new $c_s_util_Left(value$1);
});
var $d_Llaika_api_config_ConfigDecoder$$anon$5 = new $TypeData().initClass($c_Llaika_api_config_ConfigDecoder$$anon$5, "laika.api.config.ConfigDecoder$$anon$5", ({
  Llaika_api_config_ConfigDecoder$$anon$5: 1,
  Llaika_api_config_ConfigDecoder: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigDecoder$$anon$6() {
}
$c_Llaika_api_config_ConfigDecoder$$anon$6.prototype = new $h_O();
$c_Llaika_api_config_ConfigDecoder$$anon$6.prototype.constructor = $c_Llaika_api_config_ConfigDecoder$$anon$6;
/** @constructor */
function $h_Llaika_api_config_ConfigDecoder$$anon$6() {
}
$h_Llaika_api_config_ConfigDecoder$$anon$6.prototype = $c_Llaika_api_config_ConfigDecoder$$anon$6.prototype;
$c_Llaika_api_config_ConfigDecoder$$anon$6.prototype.apply__Llaika_api_config_Traced__s_util_Either = (function(value) {
  var x17 = $as_Llaika_api_config_ConfigValue($n(value).Llaika_api_config_Traced__f_value);
  if ((x17 instanceof $c_Llaika_api_config_ConfigValue$LongValue)) {
    var x$1 = $as_Llaika_api_config_ConfigValue$LongValue(x17);
    var this$2 = $n(x$1);
    var t = this$2.Llaika_api_config_ConfigValue$LongValue__f_value;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var value$1 = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo, hi);
    return new $c_s_util_Right(value$1);
  }
  if ((x17 instanceof $c_Llaika_api_config_ConfigValue$DoubleValue)) {
    var x$1$1 = $as_Llaika_api_config_ConfigValue$DoubleValue(x17);
    var this$5 = $n(x$1$1);
    var x23 = this$5.Llaika_api_config_ConfigValue$DoubleValue__f_value;
    return new $c_s_util_Right(x23);
  }
  if ((x17 instanceof $c_Llaika_api_config_ConfigValue$StringValue)) {
    var x$1$2 = $as_Llaika_api_config_ConfigValue$StringValue(x17);
    var this$8 = $n(x$1$2);
    var x20 = this$8.Llaika_api_config_ConfigValue$StringValue__f_value;
    try {
      var r1 = $m_jl_Double$().parseDouble__T__D(x20);
      var $x_1 = new $c_s_util_Success(r1);
    } catch (e) {
      var $x_1;
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        var $x_1 = new $c_s_util_Failure(e$2);
      } else {
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2));
      }
    }
    var this$12 = $n($n($x_1).toEither__s_util_Either());
    var this$13 = new $c_s_util_Either$LeftProjection(this$12);
    var x1 = this$13.s_util_Either$LeftProjection__f_e;
    if ((x1 instanceof $c_s_util_Left)) {
      var x2 = $as_s_util_Left(x1);
      var a = $n(x2).s_util_Left__f_value;
      $as_jl_Throwable(a);
      var error = ("not a double: " + x20);
      var key = $m_s_None$();
      return new $c_s_util_Left(new $c_Llaika_api_config_ConfigError$DecodingFailed(error, key));
    } else {
      return this$13.s_util_Either$LeftProjection__f_e;
    }
  }
  var value$2 = new $c_Llaika_api_config_ConfigError$InvalidType("Number", x17);
  return new $c_s_util_Left(value$2);
});
var $d_Llaika_api_config_ConfigDecoder$$anon$6 = new $TypeData().initClass($c_Llaika_api_config_ConfigDecoder$$anon$6, "laika.api.config.ConfigDecoder$$anon$6", ({
  Llaika_api_config_ConfigDecoder$$anon$6: 1,
  Llaika_api_config_ConfigDecoder: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigDecoder$$anon$7() {
}
$c_Llaika_api_config_ConfigDecoder$$anon$7.prototype = new $h_O();
$c_Llaika_api_config_ConfigDecoder$$anon$7.prototype.constructor = $c_Llaika_api_config_ConfigDecoder$$anon$7;
/** @constructor */
function $h_Llaika_api_config_ConfigDecoder$$anon$7() {
}
$h_Llaika_api_config_ConfigDecoder$$anon$7.prototype = $c_Llaika_api_config_ConfigDecoder$$anon$7.prototype;
$c_Llaika_api_config_ConfigDecoder$$anon$7.prototype.apply__Llaika_api_config_Traced__s_util_Either = (function(x$1) {
  if ((x$1 !== null)) {
    var this$3 = $n(x$1);
    var x33 = $as_Llaika_api_config_ConfigValue(this$3.Llaika_api_config_Traced__f_value);
    var this$4 = $n(x$1);
    if ((x33 instanceof $c_Llaika_api_config_ConfigValue$ObjectValue)) {
      var ov = $as_Llaika_api_config_ConfigValue$ObjectValue(x33);
      var value = $n(ov).toConfig__Llaika_api_config_Config();
      return new $c_s_util_Right(value);
    }
    if ((x33 !== null)) {
      var value$1 = new $c_Llaika_api_config_ConfigError$InvalidType("Object", x33);
      return new $c_s_util_Left(value$1);
    }
  }
  throw new $c_s_MatchError(x$1);
});
var $d_Llaika_api_config_ConfigDecoder$$anon$7 = new $TypeData().initClass($c_Llaika_api_config_ConfigDecoder$$anon$7, "laika.api.config.ConfigDecoder$$anon$7", ({
  Llaika_api_config_ConfigDecoder$$anon$7: 1,
  Llaika_api_config_ConfigDecoder: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigDecoder$$anon$8() {
}
$c_Llaika_api_config_ConfigDecoder$$anon$8.prototype = new $h_O();
$c_Llaika_api_config_ConfigDecoder$$anon$8.prototype.constructor = $c_Llaika_api_config_ConfigDecoder$$anon$8;
/** @constructor */
function $h_Llaika_api_config_ConfigDecoder$$anon$8() {
}
$h_Llaika_api_config_ConfigDecoder$$anon$8.prototype = $c_Llaika_api_config_ConfigDecoder$$anon$8.prototype;
$c_Llaika_api_config_ConfigDecoder$$anon$8.prototype.apply__Llaika_api_config_Traced__s_util_Either = (function(value) {
  var value$1 = $n(value).Llaika_api_config_Traced__f_value;
  return new $c_s_util_Right(value$1);
});
var $d_Llaika_api_config_ConfigDecoder$$anon$8 = new $TypeData().initClass($c_Llaika_api_config_ConfigDecoder$$anon$8, "laika.api.config.ConfigDecoder$$anon$8", ({
  Llaika_api_config_ConfigDecoder$$anon$8: 1,
  Llaika_api_config_ConfigDecoder: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigDecoder$$anon$9(valueDecoder$4, outer) {
  this.Llaika_api_config_ConfigDecoder$$anon$9__f_valueDecoder$1 = null;
  this.Llaika_api_config_ConfigDecoder$$anon$9__f_valueDecoder$1 = valueDecoder$4;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_api_config_ConfigDecoder$$anon$9.prototype = new $h_O();
$c_Llaika_api_config_ConfigDecoder$$anon$9.prototype.constructor = $c_Llaika_api_config_ConfigDecoder$$anon$9;
/** @constructor */
function $h_Llaika_api_config_ConfigDecoder$$anon$9() {
}
$h_Llaika_api_config_ConfigDecoder$$anon$9.prototype = $c_Llaika_api_config_ConfigDecoder$$anon$9.prototype;
$c_Llaika_api_config_ConfigDecoder$$anon$9.prototype.apply__Llaika_api_config_Traced__s_util_Either = (function(value) {
  var this$1 = $n($n(this.Llaika_api_config_ConfigDecoder$$anon$9__f_valueDecoder$1).apply__Llaika_api_config_Traced__s_util_Either(value));
  if ((this$1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$1);
    var b = $n(x2).s_util_Right__f_value;
    $n(value);
    var this$2 = $n(value);
    var origin = this$2.Llaika_api_config_Traced__f_origin;
    return new $c_s_util_Right(new $c_Llaika_api_config_Traced(b, origin));
  } else {
    return this$1;
  }
});
var $d_Llaika_api_config_ConfigDecoder$$anon$9 = new $TypeData().initClass($c_Llaika_api_config_ConfigDecoder$$anon$9, "laika.api.config.ConfigDecoder$$anon$9", ({
  Llaika_api_config_ConfigDecoder$$anon$9: 1,
  Llaika_api_config_ConfigDecoder: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigEncoder$$anon$1(f$3, outer) {
  this.Llaika_api_config_ConfigEncoder$$anon$1__f_f$1 = null;
  this.Llaika_api_config_ConfigEncoder$$anon$1__f_$outer = null;
  this.Llaika_api_config_ConfigEncoder$$anon$1__f_f$1 = f$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_config_ConfigEncoder$$anon$1__f_$outer = outer;
}
$c_Llaika_api_config_ConfigEncoder$$anon$1.prototype = new $h_O();
$c_Llaika_api_config_ConfigEncoder$$anon$1.prototype.constructor = $c_Llaika_api_config_ConfigEncoder$$anon$1;
/** @constructor */
function $h_Llaika_api_config_ConfigEncoder$$anon$1() {
}
$h_Llaika_api_config_ConfigEncoder$$anon$1.prototype = $c_Llaika_api_config_ConfigEncoder$$anon$1.prototype;
$c_Llaika_api_config_ConfigEncoder$$anon$1.prototype.apply__O__Llaika_api_config_ConfigValue = (function(value) {
  return $n(this.Llaika_api_config_ConfigEncoder$$anon$1__f_$outer).apply__O__Llaika_api_config_ConfigValue($n(this.Llaika_api_config_ConfigEncoder$$anon$1__f_f$1).apply__O__O(value));
});
var $d_Llaika_api_config_ConfigEncoder$$anon$1 = new $TypeData().initClass($c_Llaika_api_config_ConfigEncoder$$anon$1, "laika.api.config.ConfigEncoder$$anon$1", ({
  Llaika_api_config_ConfigEncoder$$anon$1: 1,
  Llaika_api_config_ConfigEncoder: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigEncoder$$anon$10() {
}
$c_Llaika_api_config_ConfigEncoder$$anon$10.prototype = new $h_O();
$c_Llaika_api_config_ConfigEncoder$$anon$10.prototype.constructor = $c_Llaika_api_config_ConfigEncoder$$anon$10;
/** @constructor */
function $h_Llaika_api_config_ConfigEncoder$$anon$10() {
}
$h_Llaika_api_config_ConfigEncoder$$anon$10.prototype = $c_Llaika_api_config_ConfigEncoder$$anon$10.prototype;
$c_Llaika_api_config_ConfigEncoder$$anon$10.prototype.apply__O__Llaika_api_config_ConfigValue = (function(value) {
  var value$1 = $as_Llaika_api_config_ConfigValue(value);
  return value$1;
});
var $d_Llaika_api_config_ConfigEncoder$$anon$10 = new $TypeData().initClass($c_Llaika_api_config_ConfigEncoder$$anon$10, "laika.api.config.ConfigEncoder$$anon$10", ({
  Llaika_api_config_ConfigEncoder$$anon$10: 1,
  Llaika_api_config_ConfigEncoder: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigEncoder$$anon$11(elementEncoder$4, outer) {
  this.Llaika_api_config_ConfigEncoder$$anon$11__f_elementEncoder$1 = null;
  this.Llaika_api_config_ConfigEncoder$$anon$11__f_elementEncoder$1 = elementEncoder$4;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_api_config_ConfigEncoder$$anon$11.prototype = new $h_O();
$c_Llaika_api_config_ConfigEncoder$$anon$11.prototype.constructor = $c_Llaika_api_config_ConfigEncoder$$anon$11;
/** @constructor */
function $h_Llaika_api_config_ConfigEncoder$$anon$11() {
}
$h_Llaika_api_config_ConfigEncoder$$anon$11.prototype = $c_Llaika_api_config_ConfigEncoder$$anon$11.prototype;
$c_Llaika_api_config_ConfigEncoder$$anon$11.prototype.apply__sci_Seq__Llaika_api_config_ConfigValue = (function(value) {
  var values = $as_sci_Seq($n(value).map__F1__O(new $c_sjsr_AnonFunction1(((value$2) => $n(this.Llaika_api_config_ConfigEncoder$$anon$11__f_elementEncoder$1).apply__O__Llaika_api_config_ConfigValue(value$2)))));
  return new $c_Llaika_api_config_ConfigValue$ArrayValue(values);
});
$c_Llaika_api_config_ConfigEncoder$$anon$11.prototype.apply__O__Llaika_api_config_ConfigValue = (function(value) {
  return this.apply__sci_Seq__Llaika_api_config_ConfigValue($as_sci_Seq(value));
});
var $d_Llaika_api_config_ConfigEncoder$$anon$11 = new $TypeData().initClass($c_Llaika_api_config_ConfigEncoder$$anon$11, "laika.api.config.ConfigEncoder$$anon$11", ({
  Llaika_api_config_ConfigEncoder$$anon$11: 1,
  Llaika_api_config_ConfigEncoder: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigEncoder$$anon$12(elementEncoder$5, outer) {
  this.Llaika_api_config_ConfigEncoder$$anon$12__f_elementEncoder$2 = null;
  this.Llaika_api_config_ConfigEncoder$$anon$12__f_elementEncoder$2 = elementEncoder$5;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_api_config_ConfigEncoder$$anon$12.prototype = new $h_O();
$c_Llaika_api_config_ConfigEncoder$$anon$12.prototype.constructor = $c_Llaika_api_config_ConfigEncoder$$anon$12;
/** @constructor */
function $h_Llaika_api_config_ConfigEncoder$$anon$12() {
}
$h_Llaika_api_config_ConfigEncoder$$anon$12.prototype = $c_Llaika_api_config_ConfigEncoder$$anon$12.prototype;
$c_Llaika_api_config_ConfigEncoder$$anon$12.prototype.apply__O__Llaika_api_config_ConfigValue = (function(value) {
  $m_Lcats_data_NonEmptyChainImpl$();
  $m_Lcats_data_NonEmptyChainImpl$();
  var value$1 = $m_Lcats_data_NonEmptyChainOps$().map$extension__O__F1__O(value, new $c_sjsr_AnonFunction1(((value$2) => $n(this.Llaika_api_config_ConfigEncoder$$anon$12__f_elementEncoder$2).apply__O__Llaika_api_config_ConfigValue(value$2))));
  $m_Lcats_data_NonEmptyChainImpl$();
  var values = $n($as_Lcats_data_Chain(value$1)).toList__sci_List();
  return new $c_Llaika_api_config_ConfigValue$ArrayValue(values);
});
var $d_Llaika_api_config_ConfigEncoder$$anon$12 = new $TypeData().initClass($c_Llaika_api_config_ConfigEncoder$$anon$12, "laika.api.config.ConfigEncoder$$anon$12", ({
  Llaika_api_config_ConfigEncoder$$anon$12: 1,
  Llaika_api_config_ConfigEncoder: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigEncoder$$anon$13(elementEncoder$6, outer) {
  this.Llaika_api_config_ConfigEncoder$$anon$13__f_elementEncoder$3 = null;
  this.Llaika_api_config_ConfigEncoder$$anon$13__f_elementEncoder$3 = elementEncoder$6;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_api_config_ConfigEncoder$$anon$13.prototype = new $h_O();
$c_Llaika_api_config_ConfigEncoder$$anon$13.prototype.constructor = $c_Llaika_api_config_ConfigEncoder$$anon$13;
/** @constructor */
function $h_Llaika_api_config_ConfigEncoder$$anon$13() {
}
$h_Llaika_api_config_ConfigEncoder$$anon$13.prototype = $c_Llaika_api_config_ConfigEncoder$$anon$13.prototype;
$c_Llaika_api_config_ConfigEncoder$$anon$13.prototype.apply__sci_Map__Llaika_api_config_ConfigValue = (function(value) {
  var this$1 = $n(value);
  var values = $as_sci_Seq($n($m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$1)).map__F1__O(new $c_sjsr_AnonFunction1(((entry) => {
    var entry$1 = $as_T2(entry);
    var key = $as_T($n(entry$1)._1__O());
    var value$1 = $n(this.Llaika_api_config_ConfigEncoder$$anon$13__f_elementEncoder$3).apply__O__Llaika_api_config_ConfigValue($n(entry$1)._2__O());
    var origin = $m_Llaika_api_config_Origin$().Llaika_api_config_Origin$__f_root;
    return new $c_Llaika_api_config_Field(key, value$1, origin);
  }))));
  return new $c_Llaika_api_config_ConfigValue$ObjectValue(values);
});
$c_Llaika_api_config_ConfigEncoder$$anon$13.prototype.apply__O__Llaika_api_config_ConfigValue = (function(value) {
  return this.apply__sci_Map__Llaika_api_config_ConfigValue($as_sci_Map(value));
});
var $d_Llaika_api_config_ConfigEncoder$$anon$13 = new $TypeData().initClass($c_Llaika_api_config_ConfigEncoder$$anon$13, "laika.api.config.ConfigEncoder$$anon$13", ({
  Llaika_api_config_ConfigEncoder$$anon$13: 1,
  Llaika_api_config_ConfigEncoder: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigEncoder$$anon$14(f$4, outer) {
  this.Llaika_api_config_ConfigEncoder$$anon$14__f_f$2 = null;
  this.Llaika_api_config_ConfigEncoder$$anon$14__f_f$2 = f$4;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_api_config_ConfigEncoder$$anon$14.prototype = new $h_O();
$c_Llaika_api_config_ConfigEncoder$$anon$14.prototype.constructor = $c_Llaika_api_config_ConfigEncoder$$anon$14;
/** @constructor */
function $h_Llaika_api_config_ConfigEncoder$$anon$14() {
}
$h_Llaika_api_config_ConfigEncoder$$anon$14.prototype = $c_Llaika_api_config_ConfigEncoder$$anon$14.prototype;
$c_Llaika_api_config_ConfigEncoder$$anon$14.prototype.apply__O__Llaika_api_config_ConfigValue = (function(value) {
  return $as_Llaika_api_config_ConfigValue($n(this.Llaika_api_config_ConfigEncoder$$anon$14__f_f$2).apply__O__O(value));
});
var $d_Llaika_api_config_ConfigEncoder$$anon$14 = new $TypeData().initClass($c_Llaika_api_config_ConfigEncoder$$anon$14, "laika.api.config.ConfigEncoder$$anon$14", ({
  Llaika_api_config_ConfigEncoder$$anon$14: 1,
  Llaika_api_config_ConfigEncoder: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigEncoder$$anon$2() {
}
$c_Llaika_api_config_ConfigEncoder$$anon$2.prototype = new $h_O();
$c_Llaika_api_config_ConfigEncoder$$anon$2.prototype.constructor = $c_Llaika_api_config_ConfigEncoder$$anon$2;
/** @constructor */
function $h_Llaika_api_config_ConfigEncoder$$anon$2() {
}
$h_Llaika_api_config_ConfigEncoder$$anon$2.prototype = $c_Llaika_api_config_ConfigEncoder$$anon$2.prototype;
$c_Llaika_api_config_ConfigEncoder$$anon$2.prototype.apply__O__Llaika_api_config_ConfigValue = (function(value) {
  var value$1 = $uZ(value);
  return new $c_Llaika_api_config_ConfigValue$BooleanValue(value$1);
});
var $d_Llaika_api_config_ConfigEncoder$$anon$2 = new $TypeData().initClass($c_Llaika_api_config_ConfigEncoder$$anon$2, "laika.api.config.ConfigEncoder$$anon$2", ({
  Llaika_api_config_ConfigEncoder$$anon$2: 1,
  Llaika_api_config_ConfigEncoder: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigEncoder$$anon$3() {
}
$c_Llaika_api_config_ConfigEncoder$$anon$3.prototype = new $h_O();
$c_Llaika_api_config_ConfigEncoder$$anon$3.prototype.constructor = $c_Llaika_api_config_ConfigEncoder$$anon$3;
/** @constructor */
function $h_Llaika_api_config_ConfigEncoder$$anon$3() {
}
$h_Llaika_api_config_ConfigEncoder$$anon$3.prototype = $c_Llaika_api_config_ConfigEncoder$$anon$3.prototype;
$c_Llaika_api_config_ConfigEncoder$$anon$3.prototype.apply__O__Llaika_api_config_ConfigValue = (function(value) {
  var value$1 = $as_T(value);
  return new $c_Llaika_api_config_ConfigValue$StringValue(value$1);
});
var $d_Llaika_api_config_ConfigEncoder$$anon$3 = new $TypeData().initClass($c_Llaika_api_config_ConfigEncoder$$anon$3, "laika.api.config.ConfigEncoder$$anon$3", ({
  Llaika_api_config_ConfigEncoder$$anon$3: 1,
  Llaika_api_config_ConfigEncoder: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigEncoder$$anon$4() {
}
$c_Llaika_api_config_ConfigEncoder$$anon$4.prototype = new $h_O();
$c_Llaika_api_config_ConfigEncoder$$anon$4.prototype.constructor = $c_Llaika_api_config_ConfigEncoder$$anon$4;
/** @constructor */
function $h_Llaika_api_config_ConfigEncoder$$anon$4() {
}
$h_Llaika_api_config_ConfigEncoder$$anon$4.prototype = $c_Llaika_api_config_ConfigEncoder$$anon$4.prototype;
$c_Llaika_api_config_ConfigEncoder$$anon$4.prototype.apply__O__Llaika_api_config_ConfigValue = (function(value) {
  var value$1 = $uI(value);
  var hi = (value$1 >> 31);
  return new $c_Llaika_api_config_ConfigValue$LongValue(new $c_RTLong(value$1, hi));
});
var $d_Llaika_api_config_ConfigEncoder$$anon$4 = new $TypeData().initClass($c_Llaika_api_config_ConfigEncoder$$anon$4, "laika.api.config.ConfigEncoder$$anon$4", ({
  Llaika_api_config_ConfigEncoder$$anon$4: 1,
  Llaika_api_config_ConfigEncoder: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigEncoder$$anon$6() {
}
$c_Llaika_api_config_ConfigEncoder$$anon$6.prototype = new $h_O();
$c_Llaika_api_config_ConfigEncoder$$anon$6.prototype.constructor = $c_Llaika_api_config_ConfigEncoder$$anon$6;
/** @constructor */
function $h_Llaika_api_config_ConfigEncoder$$anon$6() {
}
$h_Llaika_api_config_ConfigEncoder$$anon$6.prototype = $c_Llaika_api_config_ConfigEncoder$$anon$6.prototype;
$c_Llaika_api_config_ConfigEncoder$$anon$6.prototype.apply__O__Llaika_api_config_ConfigValue = (function(value) {
  var value$1 = $as_Llaika_ast_Path(value);
  var value$2 = $n(value$1).toString__T();
  return new $c_Llaika_api_config_ConfigValue$StringValue(value$2);
});
var $d_Llaika_api_config_ConfigEncoder$$anon$6 = new $TypeData().initClass($c_Llaika_api_config_ConfigEncoder$$anon$6, "laika.api.config.ConfigEncoder$$anon$6", ({
  Llaika_api_config_ConfigEncoder$$anon$6: 1,
  Llaika_api_config_ConfigEncoder: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigParser$$anon$1(input$2, outer) {
  this.Llaika_api_config_ConfigParser$$anon$1__f_input$1 = null;
  this.Llaika_api_config_ConfigParser$$anon$1__f_unresolved$lzy1 = null;
  this.Llaika_api_config_ConfigParser$$anon$1__f_unresolvedbitmap$1 = false;
  this.Llaika_api_config_ConfigParser$$anon$1__f_input$1 = input$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_api_config_ConfigParser$$anon$1.prototype = new $h_O();
$c_Llaika_api_config_ConfigParser$$anon$1.prototype.constructor = $c_Llaika_api_config_ConfigParser$$anon$1;
/** @constructor */
function $h_Llaika_api_config_ConfigParser$$anon$1() {
}
$h_Llaika_api_config_ConfigParser$$anon$1.prototype = $c_Llaika_api_config_ConfigParser$$anon$1.prototype;
$c_Llaika_api_config_ConfigParser$$anon$1.prototype.unresolved__s_util_Either = (function() {
  if ((!this.Llaika_api_config_ConfigParser$$anon$1__f_unresolvedbitmap$1)) {
    matchResult1: {
      var $x_1;
      var x1 = $n($m_Llaika_internal_parse_hocon_HoconParsers$().rootObject__Llaika_parse_Parser()).parse__T__Llaika_parse_Parsed(this.Llaika_api_config_ConfigParser$$anon$1__f_input$1);
      if ((x1 instanceof $c_Llaika_parse_Success)) {
        var x$1 = $as_Llaika_parse_Success(x1);
        var this$2 = $n(x$1);
        var x5 = $as_Llaika_internal_parse_hocon_ObjectBuilderValue(this$2.Llaika_parse_Success__f_result);
        var this$3 = $n(x$1);
        var $x_1 = new $c_s_util_Right(x5);
        break matchResult1;
      }
      if ((x1 instanceof $c_Llaika_parse_Failure)) {
        var f = $as_Llaika_parse_Failure(x1);
        var value = new $c_Llaika_api_config_ConfigError$ParsingFailed(f);
        var $x_1 = new $c_s_util_Left(value);
        break matchResult1;
      }
      throw new $c_s_MatchError(x1);
    }
    this.Llaika_api_config_ConfigParser$$anon$1__f_unresolved$lzy1 = $x_1;
    this.Llaika_api_config_ConfigParser$$anon$1__f_unresolvedbitmap$1 = true;
  }
  return this.Llaika_api_config_ConfigParser$$anon$1__f_unresolved$lzy1;
});
$c_Llaika_api_config_ConfigParser$$anon$1.prototype.resolve__Llaika_api_config_Origin__Llaika_api_config_Config__sci_Map__s_util_Either = (function(origin, fallback, includes) {
  var this$1 = $n(this.unresolved__s_util_Either());
  if ((this$1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$1);
    var b = $n(x2).s_util_Right__f_value;
    var _$2 = $as_Llaika_internal_parse_hocon_ObjectBuilderValue(b);
    var this$2 = $n($m_Llaika_internal_parse_hocon_ConfigResolver$().resolve__Llaika_internal_parse_hocon_ObjectBuilderValue__Llaika_api_config_Origin__Llaika_api_config_Config__sci_Map__s_util_Either(_$2, origin, fallback, includes));
    if ((this$2 instanceof $c_s_util_Right)) {
      var x2$1 = $as_s_util_Right(this$2);
      var b$1 = $n(x2$1).s_util_Right__f_value;
      var _$3 = $as_Llaika_api_config_ConfigValue$ObjectValue(b$1);
      return new $c_s_util_Right(new $c_Llaika_api_config_ObjectConfig(_$3, origin, fallback));
    } else {
      return this$2;
    }
  } else {
    return this$1;
  }
});
var $d_Llaika_api_config_ConfigParser$$anon$1 = new $TypeData().initClass($c_Llaika_api_config_ConfigParser$$anon$1, "laika.api.config.ConfigParser$$anon$1", ({
  Llaika_api_config_ConfigParser$$anon$1: 1,
  Llaika_api_config_ConfigParser: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigParser$$anon$2(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_api_config_ConfigParser$$anon$2.prototype = new $h_O();
$c_Llaika_api_config_ConfigParser$$anon$2.prototype.constructor = $c_Llaika_api_config_ConfigParser$$anon$2;
/** @constructor */
function $h_Llaika_api_config_ConfigParser$$anon$2() {
}
$h_Llaika_api_config_ConfigParser$$anon$2.prototype = $c_Llaika_api_config_ConfigParser$$anon$2.prototype;
$c_Llaika_api_config_ConfigParser$$anon$2.prototype.resolve__Llaika_api_config_Origin__Llaika_api_config_Config__sci_Map__s_util_Either = (function(origin, fallback, includes) {
  var value = ($m_Llaika_api_config_ConfigBuilder$(), new $c_Llaika_api_config_ConfigBuilder($m_sci_Nil$(), origin, fallback)).build__Llaika_api_config_Config();
  return new $c_s_util_Right(value);
});
var $d_Llaika_api_config_ConfigParser$$anon$2 = new $TypeData().initClass($c_Llaika_api_config_ConfigParser$$anon$2, "laika.api.config.ConfigParser$$anon$2", ({
  Llaika_api_config_ConfigParser$$anon$2: 1,
  Llaika_api_config_ConfigParser: 1
}));
/** @constructor */
function $c_Llaika_api_config_DefaultKey$$anon$1(key$1, outer) {
  this.Llaika_api_config_DefaultKey$$anon$1__f_value = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_config_DefaultKey$$anon$1__f_value = key$1;
}
$c_Llaika_api_config_DefaultKey$$anon$1.prototype = new $h_O();
$c_Llaika_api_config_DefaultKey$$anon$1.prototype.constructor = $c_Llaika_api_config_DefaultKey$$anon$1;
/** @constructor */
function $h_Llaika_api_config_DefaultKey$$anon$1() {
}
$h_Llaika_api_config_DefaultKey$$anon$1.prototype = $c_Llaika_api_config_DefaultKey$$anon$1.prototype;
var $d_Llaika_api_config_DefaultKey$$anon$1 = new $TypeData().initClass($c_Llaika_api_config_DefaultKey$$anon$1, "laika.api.config.DefaultKey$$anon$1", ({
  Llaika_api_config_DefaultKey$$anon$1: 1,
  Llaika_api_config_DefaultKey: 1
}));
/** @constructor */
function $c_Llaika_api_config_EmptyConfig$() {
  this.Llaika_api_config_EmptyConfig$__f_origin = null;
  $n_Llaika_api_config_EmptyConfig$ = this;
  this.Llaika_api_config_EmptyConfig$__f_origin = $m_Llaika_api_config_Origin$().Llaika_api_config_Origin$__f_root;
}
$c_Llaika_api_config_EmptyConfig$.prototype = new $h_O();
$c_Llaika_api_config_EmptyConfig$.prototype.constructor = $c_Llaika_api_config_EmptyConfig$;
/** @constructor */
function $h_Llaika_api_config_EmptyConfig$() {
}
$h_Llaika_api_config_EmptyConfig$.prototype = $c_Llaika_api_config_EmptyConfig$.prototype;
$c_Llaika_api_config_EmptyConfig$.prototype.origin__Llaika_api_config_Origin = (function() {
  return this.Llaika_api_config_EmptyConfig$__f_origin;
});
$c_Llaika_api_config_EmptyConfig$.prototype.hasKey__Llaika_api_config_Key__Z = (function(key) {
  return false;
});
$c_Llaika_api_config_EmptyConfig$.prototype.get__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either = (function(key, decoder) {
  var value = new $c_Llaika_api_config_ConfigError$NotFound(key);
  return new $c_s_util_Left(value);
});
$c_Llaika_api_config_EmptyConfig$.prototype.withFallback__Llaika_api_config_Config__Llaika_api_config_Config = (function(other) {
  return other;
});
$c_Llaika_api_config_EmptyConfig$.prototype.withOrigin__Llaika_api_config_Origin__Llaika_api_config_Config = (function(newOrigin) {
  return this;
});
var $d_Llaika_api_config_EmptyConfig$ = new $TypeData().initClass($c_Llaika_api_config_EmptyConfig$, "laika.api.config.EmptyConfig$", ({
  Llaika_api_config_EmptyConfig$: 1,
  Llaika_api_config_Config: 1
}));
var $n_Llaika_api_config_EmptyConfig$;
function $m_Llaika_api_config_EmptyConfig$() {
  if ((!$n_Llaika_api_config_EmptyConfig$)) {
    $n_Llaika_api_config_EmptyConfig$ = new $c_Llaika_api_config_EmptyConfig$();
  }
  return $n_Llaika_api_config_EmptyConfig$;
}
function $p_Llaika_api_config_ObjectConfig__lookup__sci_Seq__Llaika_api_config_ConfigValue$ArrayValue__Llaika_api_config_Origin__s_Option($thiz, keySegments, target, targetOrigin) {
  try {
    var x = $as_T($n(keySegments).head__O());
    var this$4 = $m_jl_Integer$();
    var r1 = this$4.parseInt__T__I__I(x, 10);
    var $x_1 = new $c_s_util_Success(r1);
  } catch (e) {
    var $x_1;
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      var $x_1 = new $c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2));
    }
  }
  var this$5 = $n($n($x_1).toOption__s_Option());
  if (this$5.isEmpty__Z()) {
    return $m_s_None$();
  } else {
    var arg1 = this$5.get__O();
    var posKey = $uI(arg1);
    var _1 = $n($as_sc_IterableOps($n($n(target).Llaika_api_config_ConfigValue$ArrayValue__f_values).drop__I__O(posKey))).headOption__s_Option();
    var _2 = $n(keySegments).tail__O();
    var x8 = $as_sci_Seq(_2);
    var x$1 = $m_sci_Nil$();
    if (x$1.equals__O__Z(x8)) {
      var this$7 = $n(_1);
      if (this$7.isEmpty__Z()) {
        return $m_s_None$();
      } else {
        var arg1$1 = this$7.get__O();
        var _$2 = $as_Llaika_api_config_ConfigValue(arg1$1);
        return new $c_s_Some(new $c_Llaika_api_config_Field("", _$2, targetOrigin));
      }
    }
    if ((_1 instanceof $c_s_Some)) {
      var x5 = $as_Llaika_api_config_ConfigValue($n($as_s_Some(_1)).s_Some__f_value);
      if ((x5 instanceof $c_Llaika_api_config_ConfigValue$ObjectValue)) {
        var ov = $as_Llaika_api_config_ConfigValue$ObjectValue(x5);
        return $p_Llaika_api_config_ObjectConfig__lookup__sci_Seq__Llaika_api_config_ConfigValue$ObjectValue__s_Option($thiz, x8, ov);
      }
    }
    return $m_s_None$();
  }
}
function $p_Llaika_api_config_ObjectConfig__lookup__sci_Seq__Llaika_api_config_ConfigValue$ObjectValue__s_Option($thiz, keySegments, target) {
  var target$tailLocal1 = target;
  var keySegments$tailLocal1 = keySegments;
  while (true) {
    var $x_1 = $n($n(target$tailLocal1).Llaika_api_config_ConfigValue$ObjectValue__f_values);
    var keySegments$tailLocal1$2$1 = keySegments$tailLocal1;
    var _1 = $n($x_1).find__F1__s_Option(new $c_sjsr_AnonFunction1(((keySegments$tailLocal1$2) => ((_$3) => {
      var _$3$1 = $as_Llaika_api_config_Field(_$3);
      return ($n(_$3$1).Llaika_api_config_Field__f_key === $n(keySegments$tailLocal1$2).head__O());
    }))(keySegments$tailLocal1$2$1)));
    var _2 = $n(keySegments$tailLocal1).tail__O();
    var x29 = $as_sci_Seq(_2);
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x29)) {
      return _1;
    }
    if ((_1 instanceof $c_s_Some)) {
      var x22 = $as_Llaika_api_config_Field($n($as_s_Some(_1)).s_Some__f_value);
      if ((x22 !== null)) {
        var this$3 = $n(x22);
        var this$4 = $n(x22);
        var x25 = this$4.Llaika_api_config_Field__f_value;
        var this$5 = $n(x22);
        var x26 = this$5.Llaika_api_config_Field__f_origin;
        if ((x25 instanceof $c_Llaika_api_config_ConfigValue$ArrayValue)) {
          var av = $as_Llaika_api_config_ConfigValue$ArrayValue(x25);
          return $p_Llaika_api_config_ObjectConfig__lookup__sci_Seq__Llaika_api_config_ConfigValue$ArrayValue__Llaika_api_config_Origin__s_Option($thiz, x29, av, x26);
        }
        if ((x25 instanceof $c_Llaika_api_config_ConfigValue$ObjectValue)) {
          var ov = $as_Llaika_api_config_ConfigValue$ObjectValue(x25);
          keySegments$tailLocal1 = x29;
          target$tailLocal1 = ov;
          continue;
        }
      }
    }
    return $m_s_None$();
  }
}
function $p_Llaika_api_config_ObjectConfig__lookup__Llaika_api_config_Key__s_Option($thiz, key) {
  if ($n($n(key).Llaika_api_config_Key__f_segments).isEmpty__Z()) {
    var value = $thiz.Llaika_api_config_ObjectConfig__f_root;
    var origin = $thiz.Llaika_api_config_ObjectConfig__f_origin;
    var value$1 = new $c_Llaika_api_config_Field("", value, origin);
    return new $c_s_Some(value$1);
  } else {
    return $p_Llaika_api_config_ObjectConfig__lookup__sci_Seq__Llaika_api_config_ConfigValue$ObjectValue__s_Option($thiz, $n(key).Llaika_api_config_Key__f_segments, $thiz.Llaika_api_config_ObjectConfig__f_root);
  }
}
/** @constructor */
function $c_Llaika_api_config_ObjectConfig(root, origin, fallback) {
  this.Llaika_api_config_ObjectConfig__f_root = null;
  this.Llaika_api_config_ObjectConfig__f_origin = null;
  this.Llaika_api_config_ObjectConfig__f_fallback = null;
  this.Llaika_api_config_ObjectConfig__f_root = root;
  this.Llaika_api_config_ObjectConfig__f_origin = origin;
  this.Llaika_api_config_ObjectConfig__f_fallback = fallback;
}
$c_Llaika_api_config_ObjectConfig.prototype = new $h_O();
$c_Llaika_api_config_ObjectConfig.prototype.constructor = $c_Llaika_api_config_ObjectConfig;
/** @constructor */
function $h_Llaika_api_config_ObjectConfig() {
}
$h_Llaika_api_config_ObjectConfig.prototype = $c_Llaika_api_config_ObjectConfig.prototype;
$c_Llaika_api_config_ObjectConfig.prototype.origin__Llaika_api_config_Origin = (function() {
  return this.Llaika_api_config_ObjectConfig__f_origin;
});
$c_Llaika_api_config_ObjectConfig.prototype.hasKey__Llaika_api_config_Key__Z = (function(key) {
  var this$1 = $n($p_Llaika_api_config_ObjectConfig__lookup__Llaika_api_config_Key__s_Option(this, key));
  if ((!this$1.isEmpty__Z())) {
    return true;
  } else {
    return $n(this.Llaika_api_config_ObjectConfig__f_fallback).hasKey__Llaika_api_config_Key__Z(key);
  }
});
$c_Llaika_api_config_ObjectConfig.prototype.get__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either = (function(key, decoder) {
  var this$1 = $n($p_Llaika_api_config_ObjectConfig__lookup__Llaika_api_config_Key__s_Option(this, key));
  if (this$1.isEmpty__Z()) {
    return $n(this.Llaika_api_config_ObjectConfig__f_fallback).get__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(key, decoder);
  } else {
    var arg1 = this$1.get__O();
    var field = $as_Llaika_api_config_Field(arg1);
    matchResult4: {
      var res;
      if ((field !== null)) {
        var this$3 = $n(field);
        var this$4 = $n(field);
        var x37 = this$4.Llaika_api_config_Field__f_value;
        var this$5 = $n(field);
        if ((x37 instanceof $c_Llaika_api_config_ConfigValue$ObjectValue)) {
          var ov = $as_Llaika_api_config_ConfigValue$ObjectValue(x37);
          var x30 = $n($n(this.Llaika_api_config_ObjectConfig__f_fallback).get__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(key, $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_configValue)).toOption__s_Option();
          if ((x30 instanceof $c_s_Some)) {
            var x32 = $as_Llaika_api_config_ConfigValue($n($as_s_Some(x30)).s_Some__f_value);
            if ((x32 instanceof $c_Llaika_api_config_ConfigValue$ObjectValue)) {
              var parentOv = $as_Llaika_api_config_ConfigValue$ObjectValue(x32);
              var res = $n(ov).merge__Llaika_api_config_ConfigValue$ObjectValue__Llaika_api_config_ConfigValue$ObjectValue(parentOv);
              break matchResult4;
            }
          }
          var res = ov;
          break matchResult4;
        }
      }
      var res = $n(field).Llaika_api_config_Field__f_value;
    }
    var origin = $n(field).Llaika_api_config_Field__f_origin;
    var this$7 = $n($n(decoder).apply__Llaika_api_config_Traced__s_util_Either(new $c_Llaika_api_config_Traced(res, origin)));
    var this$8 = new $c_s_util_Either$LeftProjection(this$7);
    var x1 = this$8.s_util_Either$LeftProjection__f_e;
    if ((x1 instanceof $c_s_util_Left)) {
      var x2 = $as_s_util_Left(x1);
      var a = $n(x2).s_util_Left__f_value;
      var x$1 = $as_Llaika_api_config_ConfigError(a);
      if ((x$1 instanceof $c_Llaika_api_config_ConfigError$DecodingFailed)) {
        var x41 = $as_Llaika_api_config_ConfigError$DecodingFailed(x$1);
        var this$10 = $n(x41);
        var this$11 = $n(x41);
        var x44 = this$11.Llaika_api_config_ConfigError$DecodingFailed__f_key;
        var $x_3 = $n(x41);
        var this$12 = $n(x44);
        if (this$12.isEmpty__Z()) {
          var $x_2 = key;
        } else {
          var arg1$1 = this$12.get__O();
          var childKey = $as_Llaika_api_config_Key(arg1$1);
          var $x_2 = $n(key).child__Llaika_api_config_Key__Llaika_api_config_Key(childKey);
        }
        var $x_1 = $n($x_3).withKey__Llaika_api_config_Key__Llaika_api_config_ConfigError$DecodingFailed($x_2);
      } else {
        var $x_1 = x$1;
      }
      return new $c_s_util_Left($x_1);
    } else {
      return this$8.s_util_Either$LeftProjection__f_e;
    }
  }
});
$c_Llaika_api_config_ObjectConfig.prototype.withFallback__Llaika_api_config_Config__Llaika_api_config_Config = (function(other) {
  var x = $m_Llaika_api_config_EmptyConfig$();
  if ((x === other)) {
    return this;
  } else {
    return new $c_Llaika_api_config_ObjectConfig(this.Llaika_api_config_ObjectConfig__f_root, this.Llaika_api_config_ObjectConfig__f_origin, $n(this.Llaika_api_config_ObjectConfig__f_fallback).withFallback__Llaika_api_config_Config__Llaika_api_config_Config(other));
  }
});
$c_Llaika_api_config_ObjectConfig.prototype.withOrigin__Llaika_api_config_Origin__Llaika_api_config_Config = (function(newOrigin) {
  return new $c_Llaika_api_config_ObjectConfig(this.Llaika_api_config_ObjectConfig__f_root, newOrigin, this.Llaika_api_config_ObjectConfig__f_fallback);
});
$c_Llaika_api_config_ObjectConfig.prototype.hashCode__I = (function() {
  var _1 = this.Llaika_api_config_ObjectConfig__f_root;
  var _2 = this.Llaika_api_config_ObjectConfig__f_origin;
  var _3 = this.Llaika_api_config_ObjectConfig__f_fallback;
  var this$3 = $m_s_util_hashing_MurmurHash3$();
  var h = (-889275714);
  h = this$3.mix__I__I__I(h, $f_T__hashCode__I("Tuple3"));
  var i = 0;
  while ((i < 3)) {
    var $x_1 = h;
    var n = i;
    switch (n) {
      case 0: {
        var x = _1;
        break;
      }
      case 1: {
        var x = _2;
        break;
      }
      case 2: {
        var x = _3;
        break;
      }
      default: {
        var x;
        throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 2)"));
      }
    }
    h = this$3.mix__I__I__I($x_1, $m_sr_Statics$().anyHash__O__I(x));
    i = ((1 + i) | 0);
  }
  return this$3.finalizeHash__I__I__I(h, 3);
});
$c_Llaika_api_config_ObjectConfig.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Llaika_api_config_ObjectConfig)) {
    var c = $as_Llaika_api_config_ObjectConfig(obj);
    var _1 = $n(c).Llaika_api_config_ObjectConfig__f_root;
    var _2 = $n(c).Llaika_api_config_ObjectConfig__f_origin;
    var _3 = $n(c).Llaika_api_config_ObjectConfig__f_fallback;
    var $x_1 = new $c_T3(_1, _2, _3);
    var _1$1 = this.Llaika_api_config_ObjectConfig__f_root;
    var _2$1 = this.Llaika_api_config_ObjectConfig__f_origin;
    var _3$1 = this.Llaika_api_config_ObjectConfig__f_fallback;
    return $x_1.equals__O__Z(new $c_T3(_1$1, _2$1, _3$1));
  } else {
    return false;
  }
});
function $as_Llaika_api_config_ObjectConfig(obj) {
  return (((obj instanceof $c_Llaika_api_config_ObjectConfig) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.ObjectConfig"));
}
function $isArrayOf_Llaika_api_config_ObjectConfig(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_ObjectConfig)));
}
function $asArrayOf_Llaika_api_config_ObjectConfig(obj, depth) {
  return (($isArrayOf_Llaika_api_config_ObjectConfig(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.ObjectConfig;", depth));
}
var $d_Llaika_api_config_ObjectConfig = new $TypeData().initClass($c_Llaika_api_config_ObjectConfig, "laika.api.config.ObjectConfig", ({
  Llaika_api_config_ObjectConfig: 1,
  Llaika_api_config_Config: 1
}));
function $is_Llaika_api_errors_ParserError(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_api_errors_ParserError)));
}
function $as_Llaika_api_errors_ParserError(obj) {
  return (($is_Llaika_api_errors_ParserError(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.errors.ParserError"));
}
function $isArrayOf_Llaika_api_errors_ParserError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_errors_ParserError)));
}
function $asArrayOf_Llaika_api_errors_ParserError(obj, depth) {
  return (($isArrayOf_Llaika_api_errors_ParserError(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.errors.ParserError;", depth));
}
/** @constructor */
function $c_Llaika_api_format_Formatter$$anon$1(ctx$2) {
  this.Llaika_api_format_Formatter__f_nextLevel$lzy1 = null;
  this.Llaika_api_format_Formatter__f_nextLevelbitmap$1 = false;
  this.Llaika_api_format_Formatter__f_newLine = null;
  this.Llaika_api_format_Formatter$$anon$1__f_ctx$1 = null;
  this.Llaika_api_format_Formatter$$anon$1__f_ctx$1 = ctx$2;
  $ct_Llaika_api_format_Formatter__(this);
}
$c_Llaika_api_format_Formatter$$anon$1.prototype = new $h_Llaika_api_format_Formatter();
$c_Llaika_api_format_Formatter$$anon$1.prototype.constructor = $c_Llaika_api_format_Formatter$$anon$1;
/** @constructor */
function $h_Llaika_api_format_Formatter$$anon$1() {
}
$h_Llaika_api_format_Formatter$$anon$1.prototype = $c_Llaika_api_format_Formatter$$anon$1.prototype;
$c_Llaika_api_format_Formatter$$anon$1.prototype.self__Llaika_api_format_Formatter = (function() {
  return this;
});
$c_Llaika_api_format_Formatter$$anon$1.prototype.context__Llaika_api_format_Formatter$Context = (function() {
  return this.Llaika_api_format_Formatter$$anon$1__f_ctx$1;
});
$c_Llaika_api_format_Formatter$$anon$1.prototype.withChild__Llaika_ast_Element__Llaika_api_format_Formatter = (function(element) {
  return $as_Llaika_api_format_Formatter($n($m_Llaika_api_format_Formatter$().defaultFactory__F1()).apply__O__O($n(this.Llaika_api_format_Formatter$$anon$1__f_ctx$1).forChildElement__Llaika_ast_Element__Llaika_api_format_Formatter$Context(element)));
});
$c_Llaika_api_format_Formatter$$anon$1.prototype.withIndentation__Llaika_api_format_Formatter$Indentation__Llaika_api_format_Formatter = (function(newIndentation) {
  var $x_1 = $m_Llaika_api_format_Formatter$().defaultFactory__F1();
  var this$1 = $n(this.Llaika_api_format_Formatter$$anon$1__f_ctx$1);
  return $as_Llaika_api_format_Formatter($n($x_1).apply__O__O(new $c_Llaika_api_format_Formatter$Context(this$1.Llaika_api_format_Formatter$Context__f_renderChild, this$1.Llaika_api_format_Formatter$Context__f_currentElement, this$1.Llaika_api_format_Formatter$Context__f_parents, this$1.Llaika_api_format_Formatter$Context__f_styles, this$1.Llaika_api_format_Formatter$Context__f_path, this$1.Llaika_api_format_Formatter$Context__f_pathTranslator, newIndentation, this$1.Llaika_api_format_Formatter$Context__f_messageFilter)));
});
var $d_Llaika_api_format_Formatter$$anon$1 = new $TypeData().initClass($c_Llaika_api_format_Formatter$$anon$1, "laika.api.format.Formatter$$anon$1", ({
  Llaika_api_format_Formatter$$anon$1: 1,
  Llaika_api_format_Formatter: 1
}));
function $p_Llaika_api_format_TagFormatter__attribute__T__T__T($thiz, name, value) {
  return ((((" " + name) + "=\"") + value) + "\"");
}
/** @constructor */
function $c_Llaika_api_format_TagFormatter() {
  this.Llaika_api_format_Formatter__f_nextLevel$lzy1 = null;
  this.Llaika_api_format_Formatter__f_nextLevelbitmap$1 = false;
  this.Llaika_api_format_Formatter__f_newLine = null;
}
$c_Llaika_api_format_TagFormatter.prototype = new $h_Llaika_api_format_Formatter();
$c_Llaika_api_format_TagFormatter.prototype.constructor = $c_Llaika_api_format_TagFormatter;
/** @constructor */
function $h_Llaika_api_format_TagFormatter() {
}
$h_Llaika_api_format_TagFormatter.prototype = $c_Llaika_api_format_TagFormatter.prototype;
$c_Llaika_api_format_TagFormatter.prototype.comment__T__T = (function(content) {
  return (("<!-- " + content) + " -->");
});
$c_Llaika_api_format_TagFormatter.prototype.element__T__Llaika_ast_ElementContainer__sci_Seq__T = (function(tagName, container, attrs) {
  var $x_1 = this.attributes__T__Llaika_ast_Element__sci_Seq__T(tagName, $as_Llaika_ast_Element(container), attrs);
  var this$1 = $n(container);
  return ((((((("<" + tagName) + $x_1) + ">") + this.children__sci_Seq__T(this$1.content__sci_Seq())) + "</") + tagName) + ">");
});
$c_Llaika_api_format_TagFormatter.prototype.indentedElement__T__Llaika_ast_ElementContainer__sci_Seq__T = (function(tagName, container, attrs) {
  var $x_1 = this.attributes__T__Llaika_ast_Element__sci_Seq__T(tagName, $as_Llaika_ast_Element(container), attrs);
  var this$1 = $n(container);
  return (((((((("<" + tagName) + $x_1) + ">") + this.indentedChildren__sci_Seq__T(this$1.content__sci_Seq())) + this.Llaika_api_format_Formatter__f_newLine) + "</") + tagName) + ">");
});
$c_Llaika_api_format_TagFormatter.prototype.rawElement__T__Llaika_ast_Element__T__sci_Seq__T = (function(tagName, styleHint, content, attrs) {
  return ((((((("<" + tagName) + this.attributes__T__Llaika_ast_Element__sci_Seq__T(tagName, styleHint, attrs)) + ">") + content) + "</") + tagName) + ">");
});
$c_Llaika_api_format_TagFormatter.prototype.textElement__T__Llaika_ast_TextContainer__sci_Seq__T = (function(tagName, container, attrs) {
  var $x_1 = this.attributes__T__Llaika_ast_Element__sci_Seq__T(tagName, $as_Llaika_ast_Element(container), attrs);
  var this$1 = $n(container);
  var str = this$1.content__T();
  return ((((((("<" + tagName) + $x_1) + ">") + $m_Llaika_api_format_TagFormatter$().escape__T__T__T(str, this.Llaika_api_format_Formatter__f_newLine)) + "</") + tagName) + ">");
});
$c_Llaika_api_format_TagFormatter.prototype.attributes__sci_Seq__T = (function(attrs) {
  var this$2 = $n($as_sc_IterableOnceOps($n(attrs).map__F1__O(new $c_sjsr_AnonFunction1(((t) => {
    var t$1 = $as_T2(t);
    return $p_Llaika_api_format_TagFormatter__attribute__T__T__T(this, $as_T($n(t$1)._1__O()), $as_T($n(t$1)._2__O()));
  })))));
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$2, "", "", "");
});
$c_Llaika_api_format_TagFormatter.prototype.self__Llaika_api_format_Formatter = (function() {
  return this;
});
function $as_Llaika_api_format_TagFormatter(obj) {
  return (((obj instanceof $c_Llaika_api_format_TagFormatter) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.format.TagFormatter"));
}
function $isArrayOf_Llaika_api_format_TagFormatter(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_format_TagFormatter)));
}
function $asArrayOf_Llaika_api_format_TagFormatter(obj, depth) {
  return (($isArrayOf_Llaika_api_format_TagFormatter(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.format.TagFormatter;", depth));
}
function $f_Llaika_ast_BlockContainerCompanion__createSpanContainer__sci_Seq__O($thiz, spans) {
  return $thiz.createBlockContainer__sci_Seq__O($as_sci_Seq($n(spans).map__F1__O(new $c_sjsr_AnonFunction1(((_$2) => {
    var _$2$1 = $as_Llaika_ast_Span(_$2);
    var this$1 = $m_Llaika_ast_Paragraph$();
    var spans$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Span.getArrayOf().constr)([]));
    return $as_Llaika_ast_Paragraph($f_Llaika_ast_SpanContainerCompanion__apply__Llaika_ast_Span__sci_Seq__O(this$1, _$2$1, spans$1));
  })))));
}
function $f_Llaika_ast_BlockContainerCompanion__apply__Llaika_ast_Block__sci_Seq__O($thiz, block, blocks) {
  var this$1 = $n($n(blocks).toList__sci_List());
  return $thiz.createBlockContainer__sci_Seq__O(this$1.prepended__O__sci_List(block));
}
function $p_Llaika_ast_DocumentCursor__validator__Llaika_internal_link_LinkValidator($thiz) {
  if ((!$thiz.Llaika_ast_DocumentCursor__f_validatorbitmap$1)) {
    $thiz.Llaika_ast_DocumentCursor__f_validator$lzy1 = new $c_Llaika_internal_link_LinkValidator($thiz, $n($thiz.root__Llaika_ast_RootCursor()).targetLookup__Llaika_internal_link_TargetLookup());
    $thiz.Llaika_ast_DocumentCursor__f_validatorbitmap$1 = true;
  }
  return $thiz.Llaika_ast_DocumentCursor__f_validator$lzy1;
}
/** @constructor */
function $c_Llaika_ast_DocumentCursor(target, parent, resolver, templatePath) {
  this.Llaika_ast_DocumentCursor__f_target = null;
  this.Llaika_ast_DocumentCursor__f_parent = null;
  this.Llaika_ast_DocumentCursor__f_resolver = null;
  this.Llaika_ast_DocumentCursor__f_templatePath = null;
  this.Llaika_ast_DocumentCursor__f_path = null;
  this.Llaika_ast_DocumentCursor__f_position = null;
  this.Llaika_ast_DocumentCursor__f_root$lzy1 = null;
  this.Llaika_ast_DocumentCursor__f_rootbitmap$1 = false;
  this.Llaika_ast_DocumentCursor__f_config = null;
  this.Llaika_ast_DocumentCursor__f_validator$lzy1 = null;
  this.Llaika_ast_DocumentCursor__f_validatorbitmap$1 = false;
  this.Llaika_ast_DocumentCursor__f_target = target;
  this.Llaika_ast_DocumentCursor__f_parent = parent;
  this.Llaika_ast_DocumentCursor__f_resolver = resolver;
  this.Llaika_ast_DocumentCursor__f_templatePath = templatePath;
  this.Llaika_ast_DocumentCursor__f_path = $n(target).path__Llaika_ast_Path();
  this.Llaika_ast_DocumentCursor__f_position = $n(target).position__Llaika_ast_TreePosition();
  this.Llaika_ast_DocumentCursor__f_config = $n(resolver).Llaika_internal_rewrite_ReferenceResolver__f_config;
}
$c_Llaika_ast_DocumentCursor.prototype = new $h_O();
$c_Llaika_ast_DocumentCursor.prototype.constructor = $c_Llaika_ast_DocumentCursor;
/** @constructor */
function $h_Llaika_ast_DocumentCursor() {
}
$h_Llaika_ast_DocumentCursor.prototype = $c_Llaika_ast_DocumentCursor.prototype;
$c_Llaika_ast_DocumentCursor.prototype.root__Llaika_ast_RootCursor = (function() {
  if ((!this.Llaika_ast_DocumentCursor__f_rootbitmap$1)) {
    this.Llaika_ast_DocumentCursor__f_root$lzy1 = $n(this.Llaika_ast_DocumentCursor__f_parent).Llaika_ast_TreeCursor__f_root;
    this.Llaika_ast_DocumentCursor__f_rootbitmap$1 = true;
  }
  return this.Llaika_ast_DocumentCursor__f_root$lzy1;
});
$c_Llaika_ast_DocumentCursor.prototype.rewriteTarget__Llaika_ast_RewriteRules__Llaika_ast_Document = (function(rules) {
  matchResult6: {
    var rewrittenRoot;
    var x18 = $n(rules).rewriteBlock__Llaika_ast_Block__Llaika_ast_Block($n(this.Llaika_ast_DocumentCursor__f_target).Llaika_ast_Document__f_content);
    if ((x18 instanceof $c_Llaika_ast_RootElement)) {
      var r = $as_Llaika_ast_RootElement(x18);
      var rewrittenRoot = r;
      break matchResult6;
    }
    var this$1 = $n($n(this.Llaika_ast_DocumentCursor__f_target).Llaika_ast_Document__f_content);
    var newContent = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Block.getArrayOf().constr)([x18]))));
    var options = this$1.Llaika_ast_RootElement__f_options;
    var rewrittenRoot = new $c_Llaika_ast_RootElement(newContent, options);
  }
  var map = $n(this.Llaika_ast_DocumentCursor__f_target).Llaika_ast_Document__f_fragments;
  var rewrittenFragments = $m_Llaika_internal_collection_TransitionalCollectionOps$TransitionalMapOps$().mapValuesStrict$extension__sci_Map__F1__sci_Map(map, new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Llaika_ast_Element(x$1);
    if (($is_Llaika_ast_RewritableContainer(x$1$1) && $is_Llaika_ast_Block(x$1$1))) {
      var r$1 = $as_Llaika_ast_Block(x$1$1);
      return $as_Llaika_ast_Element($as_Llaika_ast_Block($n($as_Llaika_ast_RewritableContainer(r$1)).rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer(rules)));
    } else {
      return x$1$1;
    }
  })));
  var newFragments = $m_Llaika_ast_DocumentFragment$().collect__Llaika_ast_RootElement__sci_Map(rewrittenRoot);
  var $x_2 = $n(this.Llaika_ast_DocumentCursor__f_target);
  var this$3 = $n(rewrittenRoot);
  var newContent$1 = $as_sci_Seq($n($n(rewrittenRoot).Llaika_ast_RootElement__f_content).filterNot__F1__O(new $c_sjsr_AnonFunction1(((_$10) => {
    var _$10$1 = $as_Llaika_ast_Block(_$10);
    return (_$10$1 instanceof $c_Llaika_ast_DocumentFragment);
  }))));
  var options$1 = this$3.Llaika_ast_RootElement__f_options;
  var $x_1 = new $c_Llaika_ast_RootElement(newContent$1, options$1);
  var this$4 = $n(rewrittenFragments);
  return $n($x_2).withContent__Llaika_ast_RootElement__sci_Map__Llaika_ast_Document($x_1, $as_sci_Map(this$4.concat__sc_IterableOnce__sc_IterableOps(newFragments)));
});
$c_Llaika_ast_DocumentCursor.prototype.resolveReference__Llaika_api_config_Key__s_util_Either = (function(key) {
  var this$1 = $n(this.Llaika_ast_DocumentCursor__f_resolver);
  var this$2 = $n(this$1.Llaika_internal_rewrite_ReferenceResolver__f_config);
  var decoder = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_configValue;
  return $f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$2, key, decoder);
});
$c_Llaika_ast_DocumentCursor.prototype.withReferenceContext__O__Llaika_api_config_ConfigEncoder__Llaika_ast_DocumentCursor = (function(refValue, evidence$1) {
  var $x_2 = this.Llaika_ast_DocumentCursor__f_target;
  var $x_1 = this.Llaika_ast_DocumentCursor__f_parent;
  var this$1 = $n(this.Llaika_ast_DocumentCursor__f_config);
  return new $c_Llaika_ast_DocumentCursor($x_2, $x_1, new $c_Llaika_internal_rewrite_ReferenceResolver($n($f_Llaika_api_config_Config__withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigBuilder(this$1, "_", refValue, evidence$1)).build__Llaika_api_config_Config()), this.Llaika_ast_DocumentCursor__f_templatePath);
});
function $as_Llaika_ast_DocumentCursor(obj) {
  return (((obj instanceof $c_Llaika_ast_DocumentCursor) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.DocumentCursor"));
}
function $isArrayOf_Llaika_ast_DocumentCursor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_DocumentCursor)));
}
function $asArrayOf_Llaika_ast_DocumentCursor(obj, depth) {
  return (($isArrayOf_Llaika_ast_DocumentCursor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.DocumentCursor;", depth));
}
var $d_Llaika_ast_DocumentCursor = new $TypeData().initClass($c_Llaika_ast_DocumentCursor, "laika.ast.DocumentCursor", ({
  Llaika_ast_DocumentCursor: 1,
  Llaika_ast_Cursor: 1
}));
function $f_Llaika_ast_DocumentNavigation__asNavigationItem__Llaika_ast_NavigationBuilderContext__Llaika_ast_NavigationItem($thiz, context) {
  var children = (($n(context).Llaika_ast_NavigationBuilderContext__f_isComplete || $n(context).Llaika_ast_NavigationBuilderContext$Impl__f_excludeSections) ? $m_sci_Nil$() : $as_sci_Seq($n($thiz.sections__sci_Seq()).map__F1__O(new $c_sjsr_AnonFunction1(((_$1) => {
    var _$1$1 = $as_Llaika_ast_SectionInfo(_$1);
    return $n(_$1$1).asNavigationItem__Llaika_ast_Path__Llaika_ast_NavigationBuilderContext__Llaika_ast_NavigationItem($thiz.path__Llaika_ast_Path(), $n(context).nextLevel__Llaika_ast_NavigationBuilderContext());
  })))));
  var $x_2 = $n(context);
  var this$2 = $n($thiz.title__s_Option());
  if (this$2.isEmpty__Z()) {
    var this$3 = $m_Llaika_ast_SpanSequence$();
    var text = $n($thiz.path__Llaika_ast_Path()).name__T();
    var texts = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([]));
    var $x_1 = $as_Llaika_ast_SpanSequence($f_Llaika_ast_SpanContainerCompanion__apply__T__sci_Seq__O(this$3, text, texts));
  } else {
    var $x_1 = this$2.get__O();
  }
  return $n($x_2).newNavigationItem__Llaika_ast_SpanSequence__Llaika_ast_Path__sci_Seq__Llaika_config_TargetFormats__Llaika_ast_NavigationItem($as_Llaika_ast_SpanSequence($x_1), $thiz.path__Llaika_ast_Path(), children, $f_Llaika_ast_TreeContent__targetFormats__Llaika_config_TargetFormats($thiz));
}
function $is_Llaika_ast_DocumentNavigation(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_DocumentNavigation)));
}
function $as_Llaika_ast_DocumentNavigation(obj) {
  return (($is_Llaika_ast_DocumentNavigation(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.DocumentNavigation"));
}
function $isArrayOf_Llaika_ast_DocumentNavigation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_DocumentNavigation)));
}
function $asArrayOf_Llaika_ast_DocumentNavigation(obj, depth) {
  return (($isArrayOf_Llaika_ast_DocumentNavigation(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.DocumentNavigation;", depth));
}
function $is_Llaika_ast_DocumentTreeBuilder$BuilderPart(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_DocumentTreeBuilder$BuilderPart)));
}
function $as_Llaika_ast_DocumentTreeBuilder$BuilderPart(obj) {
  return (($is_Llaika_ast_DocumentTreeBuilder$BuilderPart(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.DocumentTreeBuilder$BuilderPart"));
}
function $isArrayOf_Llaika_ast_DocumentTreeBuilder$BuilderPart(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_DocumentTreeBuilder$BuilderPart)));
}
function $asArrayOf_Llaika_ast_DocumentTreeBuilder$BuilderPart(obj, depth) {
  return (($isArrayOf_Llaika_ast_DocumentTreeBuilder$BuilderPart(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.DocumentTreeBuilder$BuilderPart;", depth));
}
function $is_Llaika_ast_Icon(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_Icon)));
}
function $as_Llaika_ast_Icon(obj) {
  return (($is_Llaika_ast_Icon(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Icon"));
}
function $isArrayOf_Llaika_ast_Icon(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Icon)));
}
function $asArrayOf_Llaika_ast_Icon(obj, depth) {
  return (($isArrayOf_Llaika_ast_Icon(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Icon;", depth));
}
function $f_Llaika_ast_InternalTarget__underlying__Llaika_ast_VirtualPath($thiz) {
  if (($thiz instanceof $c_Llaika_ast_InternalTarget$Resolved)) {
    var t = $as_Llaika_ast_InternalTarget$Resolved($thiz);
    return $n(t).Llaika_ast_InternalTarget$Resolved__f_absolutePath;
  }
  if (($thiz instanceof $c_Llaika_ast_InternalTarget$Absolute)) {
    var t$2 = $as_Llaika_ast_InternalTarget$Absolute($thiz);
    return $n(t$2).Llaika_ast_InternalTarget$Absolute__f_path;
  }
  if (($thiz instanceof $c_Llaika_ast_InternalTarget$Relative)) {
    var t$3 = $as_Llaika_ast_InternalTarget$Relative($thiz);
    return $n(t$3).Llaika_ast_InternalTarget$Relative__f_path;
  }
  throw new $c_s_MatchError($thiz);
}
function $is_Llaika_ast_InternalTarget(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_InternalTarget)));
}
function $as_Llaika_ast_InternalTarget(obj) {
  return (($is_Llaika_ast_InternalTarget(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.InternalTarget"));
}
function $isArrayOf_Llaika_ast_InternalTarget(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_InternalTarget)));
}
function $asArrayOf_Llaika_ast_InternalTarget(obj, depth) {
  return (($isArrayOf_Llaika_ast_InternalTarget(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.InternalTarget;", depth));
}
function $is_Llaika_ast_Invalid(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_Invalid)));
}
function $as_Llaika_ast_Invalid(obj) {
  return (($is_Llaika_ast_Invalid(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Invalid"));
}
function $isArrayOf_Llaika_ast_Invalid(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Invalid)));
}
function $asArrayOf_Llaika_ast_Invalid(obj, depth) {
  return (($isArrayOf_Llaika_ast_Invalid(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Invalid;", depth));
}
function $ct_Llaika_ast_LengthUnit__T__($thiz, displayValue) {
  $thiz.Llaika_ast_LengthUnit__f_displayValue = displayValue;
  return $thiz;
}
/** @constructor */
function $c_Llaika_ast_LengthUnit() {
  this.Llaika_ast_LengthUnit__f_displayValue = null;
}
$c_Llaika_ast_LengthUnit.prototype = new $h_O();
$c_Llaika_ast_LengthUnit.prototype.constructor = $c_Llaika_ast_LengthUnit;
/** @constructor */
function $h_Llaika_ast_LengthUnit() {
}
$h_Llaika_ast_LengthUnit.prototype = $c_Llaika_ast_LengthUnit.prototype;
$c_Llaika_ast_LengthUnit.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_Llaika_ast_LengthUnit.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_Llaika_ast_LengthUnit.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Llaika_ast_LengthUnit.prototype.apply__O__O = (function(v1) {
  var amount = $uD(v1);
  return new $c_Llaika_ast_Length(amount, this);
});
$c_Llaika_ast_LengthUnit.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  var amount = $uD(v1);
  return $uZ(new $c_Llaika_ast_Length(amount, this));
});
function $is_Llaika_ast_Link(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_Link)));
}
function $as_Llaika_ast_Link(obj) {
  return (($is_Llaika_ast_Link(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Link"));
}
function $isArrayOf_Llaika_ast_Link(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Link)));
}
function $asArrayOf_Llaika_ast_Link(obj, depth) {
  return (($isArrayOf_Llaika_ast_Link(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Link;", depth));
}
/** @constructor */
function $c_Llaika_ast_NavigationList$FormatFilter$() {
}
$c_Llaika_ast_NavigationList$FormatFilter$.prototype = new $h_O();
$c_Llaika_ast_NavigationList$FormatFilter$.prototype.constructor = $c_Llaika_ast_NavigationList$FormatFilter$;
/** @constructor */
function $h_Llaika_ast_NavigationList$FormatFilter$() {
}
$h_Llaika_ast_NavigationList$FormatFilter$.prototype = $c_Llaika_ast_NavigationList$FormatFilter$.prototype;
$c_Llaika_ast_NavigationList$FormatFilter$.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_Llaika_ast_NavigationList$FormatFilter$.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_Llaika_ast_NavigationList$FormatFilter$.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Llaika_ast_NavigationList$FormatFilter$.prototype.apply__Llaika_ast_DocumentCursor__s_util_Either = (function(cursor) {
  var value = $m_Llaika_ast_RewriteRules$().forBlocks__s_PartialFunction__Llaika_ast_RewriteRules(new $c_Llaika_ast_NavigationList$FormatFilter$$anon$3(cursor, this));
  return new $c_s_util_Right(value);
});
$c_Llaika_ast_NavigationList$FormatFilter$.prototype.apply__O__O = (function(v1) {
  return this.apply__Llaika_ast_DocumentCursor__s_util_Either($as_Llaika_ast_DocumentCursor(v1));
});
$c_Llaika_ast_NavigationList$FormatFilter$.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__Llaika_ast_DocumentCursor__s_util_Either($as_Llaika_ast_DocumentCursor(v1)));
});
var $d_Llaika_ast_NavigationList$FormatFilter$ = new $TypeData().initClass($c_Llaika_ast_NavigationList$FormatFilter$, "laika.ast.NavigationList$FormatFilter$", ({
  Llaika_ast_NavigationList$FormatFilter$: 1,
  F1: 1
}));
var $n_Llaika_ast_NavigationList$FormatFilter$;
function $m_Llaika_ast_NavigationList$FormatFilter$() {
  if ((!$n_Llaika_ast_NavigationList$FormatFilter$)) {
    $n_Llaika_ast_NavigationList$FormatFilter$ = new $c_Llaika_ast_NavigationList$FormatFilter$();
  }
  return $n_Llaika_ast_NavigationList$FormatFilter$;
}
function $p_Llaika_ast_RewriteRules$ChainedRewriteRules__applyNextRule$1__O__Llaika_ast_RewriteAction__sci_Seq__Llaika_ast_RewriteAction($thiz, element$1, currentAction, remainingRules) {
  var remainingRules$tailLocal1 = remainingRules;
  var currentAction$tailLocal1 = currentAction;
  while (true) {
    var x = currentAction$tailLocal1;
    var x$2 = $m_Llaika_ast_RewriteAction$Remove$();
    if ((((x !== null) && $n(x).equals__O__Z(x$2)) || $n(remainingRules$tailLocal1).isEmpty__Z())) {
      return currentAction$tailLocal1;
    } else {
      matchResult6: {
        var input;
        var x20 = currentAction$tailLocal1;
        if ((x20 instanceof $c_Llaika_ast_RewriteAction$Replace)) {
          var x$1 = $as_Llaika_ast_RewriteAction$Replace(x20);
          var this$2 = $n(x$1);
          var x23 = this$2.Llaika_ast_RewriteAction$Replace__f_newValue;
          var input = x23;
          break matchResult6;
        }
        var input = element$1;
      }
      matchResult7: {
        var nextAction;
        var $x_1 = $as_s_PartialFunction($n(remainingRules$tailLocal1).head__O());
        var currentAction$tailLocal1$2$1 = currentAction$tailLocal1;
        var x24 = $as_Llaika_ast_RewriteAction($n($x_1).applyOrElse__O__F1__O(input, new $c_sjsr_AnonFunction1(((currentAction$tailLocal1$2) => ((_$2) => currentAction$tailLocal1$2))(currentAction$tailLocal1$2$1))));
        var x$3 = $m_Llaika_ast_RewriteAction$Retain$();
        if ((x$3 === x24)) {
          var nextAction = currentAction$tailLocal1;
          break matchResult7;
        }
        var nextAction = x24;
      }
      var remainingRules$tailLocal1$tmp1 = $as_sci_Seq($n(remainingRules$tailLocal1).tail__O());
      currentAction$tailLocal1 = nextAction;
      remainingRules$tailLocal1 = remainingRules$tailLocal1$tmp1;
    }
  }
}
/** @constructor */
function $c_Llaika_ast_RewriteRules$ChainedRewriteRules(rules) {
  this.Llaika_ast_RewriteRules$ChainedRewriteRules__f_rules = null;
  this.Llaika_ast_RewriteRules$ChainedRewriteRules__f_rules = rules;
}
$c_Llaika_ast_RewriteRules$ChainedRewriteRules.prototype = new $h_O();
$c_Llaika_ast_RewriteRules$ChainedRewriteRules.prototype.constructor = $c_Llaika_ast_RewriteRules$ChainedRewriteRules;
/** @constructor */
function $h_Llaika_ast_RewriteRules$ChainedRewriteRules() {
}
$h_Llaika_ast_RewriteRules$ChainedRewriteRules.prototype = $c_Llaika_ast_RewriteRules$ChainedRewriteRules.prototype;
$c_Llaika_ast_RewriteRules$ChainedRewriteRules.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_Llaika_ast_RewriteRules$ChainedRewriteRules.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_Llaika_ast_RewriteRules$ChainedRewriteRules.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Llaika_ast_RewriteRules$ChainedRewriteRules.prototype.apply__O__Llaika_ast_RewriteAction = (function(element) {
  return $p_Llaika_ast_RewriteRules$ChainedRewriteRules__applyNextRule$1__O__Llaika_ast_RewriteAction__sci_Seq__Llaika_ast_RewriteAction(this, element, $m_Llaika_ast_RewriteAction$Retain$(), this.Llaika_ast_RewriteRules$ChainedRewriteRules__f_rules);
});
$c_Llaika_ast_RewriteRules$ChainedRewriteRules.prototype.apply__O__O = (function(v1) {
  return this.apply__O__Llaika_ast_RewriteAction(v1);
});
$c_Llaika_ast_RewriteRules$ChainedRewriteRules.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__O__Llaika_ast_RewriteAction(v1));
});
var $d_Llaika_ast_RewriteRules$ChainedRewriteRules = new $TypeData().initClass($c_Llaika_ast_RewriteRules$ChainedRewriteRules, "laika.ast.RewriteRules$ChainedRewriteRules", ({
  Llaika_ast_RewriteRules$ChainedRewriteRules: 1,
  F1: 1
}));
function $as_Llaika_ast_TemplateDocument(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.TemplateDocument"));
}
function $isArrayOf_Llaika_ast_TemplateDocument(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_TemplateDocument)));
}
function $asArrayOf_Llaika_ast_TemplateDocument(obj, depth) {
  return (($isArrayOf_Llaika_ast_TemplateDocument(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.TemplateDocument;", depth));
}
function $is_Llaika_ast_TemplateSpan(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_TemplateSpan)));
}
function $as_Llaika_ast_TemplateSpan(obj) {
  return (($is_Llaika_ast_TemplateSpan(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.TemplateSpan"));
}
function $isArrayOf_Llaika_ast_TemplateSpan(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_TemplateSpan)));
}
function $asArrayOf_Llaika_ast_TemplateSpan(obj, depth) {
  return (($isArrayOf_Llaika_ast_TemplateSpan(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.TemplateSpan;", depth));
}
var $d_Llaika_ast_TemplateSpan = new $TypeData().initClass(1, "laika.ast.TemplateSpan", ({
  Llaika_ast_TemplateSpan: 1,
  Llaika_ast_Span: 1
}));
function $is_Llaika_ast_TextContainer(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_TextContainer)));
}
function $as_Llaika_ast_TextContainer(obj) {
  return (($is_Llaika_ast_TextContainer(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.TextContainer"));
}
function $isArrayOf_Llaika_ast_TextContainer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_TextContainer)));
}
function $asArrayOf_Llaika_ast_TextContainer(obj, depth) {
  return (($isArrayOf_Llaika_ast_TextContainer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.TextContainer;", depth));
}
function $f_Llaika_ast_TreeContent__titleFromConfig__s_Option($thiz) {
  var $x_2 = $thiz.config__Llaika_api_config_Config();
  var $x_1 = $m_Llaika_config_LaikaKeys$().Llaika_config_LaikaKeys$__f_title;
  var this$1 = $m_Llaika_api_config_ConfigDecoder$();
  var valueDecoder = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
  var this$2 = $n($n($n($x_2).get__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either($x_1, new $c_Llaika_api_config_ConfigDecoder$$anon$9(valueDecoder, this$1))).toOption__s_Option());
  if (this$2.isEmpty__Z()) {
    return $m_s_None$();
  } else {
    var arg1 = this$2.get__O();
    var tracedTitle = $as_Llaika_api_config_Traced(arg1);
    var x = $n($n(tracedTitle).Llaika_api_config_Traced__f_origin).Llaika_api_config_Origin__f_scope;
    var x$2 = $thiz.configScope__Llaika_api_config_Origin$Scope();
    if ((x === null)) {
      var $x_3 = (x$2 === null);
    } else {
      var this$3 = $n(x);
      var $x_3 = (this$3 === x$2);
    }
    if ($x_3) {
      var $x_5 = $m_sci_Seq$();
      var $x_4 = $m_sr_ScalaRunTime$();
      var content = $as_T($n(tracedTitle).Llaika_api_config_Traced__f_value);
      var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      var title = $as_sci_Seq($n($x_5).apply__sci_Seq__sc_SeqOps($n($x_4).wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Text.getArrayOf().constr)([new $c_Llaika_ast_Text(content, options)]))));
      var this$6 = $n($thiz.config__Llaika_api_config_Config());
      var decoder = $m_Llaika_config_AutonumberConfig$().Llaika_config_AutonumberConfig$__f_decoder;
      var defaultKey = $m_Llaika_config_AutonumberConfig$().Llaika_config_AutonumberConfig$__f_defaultKey;
      var this$7 = $n(this$6.get__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either($n(defaultKey).Llaika_api_config_DefaultKey$$anon$1__f_value, decoder));
      if ((this$7 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(this$7);
        var b = $n(x2).s_util_Right__f_value;
        var $x_6 = b;
      } else {
        $m_Llaika_config_AutonumberConfig$();
        var $x_6 = new $c_Llaika_config_AutonumberConfig$Impl(false, false, 0);
      }
      var autonumberConfig = $as_Llaika_config_AutonumberConfig($x_6);
      if ($n(autonumberConfig).Llaika_config_AutonumberConfig$Impl__f_documents) {
        var this$10 = $n($thiz.position__Llaika_ast_TreePosition());
        var this$11 = $n(this$10.Llaika_ast_TreePosition__f_positions);
        var autonumberEnabled = (this$11.length__I() < $n(autonumberConfig).Llaika_config_AutonumberConfig$Impl__f_maxDepth);
      } else {
        var autonumberEnabled = false;
      }
      if (autonumberEnabled) {
        var this$12 = $n($thiz.position__Llaika_ast_TreePosition());
        var position = this$12.Llaika_ast_TreePosition__f_positions;
        var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
        var elem$1 = new $c_Llaika_ast_SectionNumber(position, options$1);
        var this$15 = $n(title);
        var content$1 = $as_sci_Seq(this$15.prepended__O__O(elem$1));
        var options$2 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
        var value = new $c_Llaika_ast_SpanSequence(content$1, options$2);
        return new $c_s_Some(value);
      } else {
        var options$3 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
        var value$1 = new $c_Llaika_ast_SpanSequence(title, options$3);
        return new $c_s_Some(value$1);
      }
    } else {
      return $m_s_None$();
    }
  }
}
function $f_Llaika_ast_TreeContent__targetFormats__Llaika_config_TargetFormats($thiz) {
  var this$1 = $n($thiz.config__Llaika_api_config_Config());
  var decoder = $m_Llaika_config_TargetFormats$().Llaika_config_TargetFormats$__f_decoder;
  var defaultKey = $m_Llaika_config_TargetFormats$().Llaika_config_TargetFormats$__f_defaultKey;
  var this$2 = $n(this$1.get__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either($n(defaultKey).Llaika_api_config_DefaultKey$$anon$1__f_value, decoder));
  if ((this$2 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$2);
    var b = $n(x2).s_util_Right__f_value;
    var $x_1 = b;
  } else {
    var $x_1 = $m_Llaika_config_TargetFormats$All$();
  }
  return $as_Llaika_config_TargetFormats($x_1);
}
function $is_Llaika_ast_TreeContent(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_TreeContent)));
}
function $as_Llaika_ast_TreeContent(obj) {
  return (($is_Llaika_ast_TreeContent(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.TreeContent"));
}
function $isArrayOf_Llaika_ast_TreeContent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_TreeContent)));
}
function $asArrayOf_Llaika_ast_TreeContent(obj, depth) {
  return (($isArrayOf_Llaika_ast_TreeContent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.TreeContent;", depth));
}
/** @constructor */
function $c_Llaika_ast_TreeCursor(target, parent, root) {
  this.Llaika_ast_TreeCursor__f_target = null;
  this.Llaika_ast_TreeCursor__f_parent = null;
  this.Llaika_ast_TreeCursor__f_root = null;
  this.Llaika_ast_TreeCursor__f_path = null;
  this.Llaika_ast_TreeCursor__f_titleDocument$lzy1 = null;
  this.Llaika_ast_TreeCursor__f_titleDocumentbitmap$1 = false;
  this.Llaika_ast_TreeCursor__f_target = target;
  this.Llaika_ast_TreeCursor__f_parent = parent;
  this.Llaika_ast_TreeCursor__f_root = root;
  this.Llaika_ast_TreeCursor__f_path = $n(target).path__Llaika_ast_Path();
  $n(target).position__Llaika_ast_TreePosition();
  $n(target).config__Llaika_api_config_Config();
}
$c_Llaika_ast_TreeCursor.prototype = new $h_O();
$c_Llaika_ast_TreeCursor.prototype.constructor = $c_Llaika_ast_TreeCursor;
/** @constructor */
function $h_Llaika_ast_TreeCursor() {
}
$h_Llaika_ast_TreeCursor.prototype = $c_Llaika_ast_TreeCursor.prototype;
$c_Llaika_ast_TreeCursor.prototype.titleDocument__s_Option = (function() {
  if ((!this.Llaika_ast_TreeCursor__f_titleDocumentbitmap$1)) {
    var this$1 = $n($n(this.Llaika_ast_TreeCursor__f_target).Llaika_ast_DocumentTree__f_titleDocument);
    if (this$1.isEmpty__Z()) {
      var $x_1 = $m_s_None$();
    } else {
      var arg1 = this$1.get__O();
      var title = $as_Llaika_ast_Document(arg1);
      var $x_2 = $m_Llaika_ast_DocumentCursor$();
      var this$2 = $n(title);
      var config$1 = $n(title).config__Llaika_api_config_Config();
      $m_Llaika_api_config_ConfigBuilder$();
      var fallback = $n(this$2.Llaika_ast_Document__f_context).Llaika_ast_TreeNodeContext__f_localConfig;
      var builder = new $c_Llaika_api_config_ConfigBuilder($m_sci_Nil$(), $n(fallback).origin__Llaika_api_config_Origin(), fallback);
      var $x_1 = new $c_s_Some($n($x_2).apply__Llaika_ast_Document__Llaika_ast_TreeCursor__Llaika_ast_DocumentCursor($n(this$2.withConfig__Llaika_api_config_Config__Llaika_ast_Document($n($m_Llaika_config_AutonumberConfig$().withoutSectionNumbering__Llaika_api_config_Config__Llaika_api_config_ConfigBuilder__Llaika_api_config_ConfigBuilder(config$1, builder)).build__Llaika_api_config_Config())).withPosition__Llaika_ast_TreeNodeIndex__Llaika_ast_Document($m_Llaika_ast_TreeNodeIndex$Inherit$()), this));
    }
    this.Llaika_ast_TreeCursor__f_titleDocument$lzy1 = $x_1;
    this.Llaika_ast_TreeCursor__f_titleDocumentbitmap$1 = true;
  }
  return this.Llaika_ast_TreeCursor__f_titleDocument$lzy1;
});
function $as_Llaika_ast_TreeCursor(obj) {
  return (((obj instanceof $c_Llaika_ast_TreeCursor) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.TreeCursor"));
}
function $isArrayOf_Llaika_ast_TreeCursor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_TreeCursor)));
}
function $asArrayOf_Llaika_ast_TreeCursor(obj, depth) {
  return (($isArrayOf_Llaika_ast_TreeCursor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.TreeCursor;", depth));
}
var $d_Llaika_ast_TreeCursor = new $TypeData().initClass($c_Llaika_ast_TreeCursor, "laika.ast.TreeCursor", ({
  Llaika_ast_TreeCursor: 1,
  Llaika_ast_Cursor: 1
}));
/** @constructor */
function $c_Llaika_config_MessageFilter$$anon$1(level$2, outer) {
  this.Llaika_config_MessageFilter$$anon$1__f_level$1 = null;
  this.Llaika_config_MessageFilter$$anon$1__f_level$1 = level$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_config_MessageFilter$$anon$1.prototype = new $h_O();
$c_Llaika_config_MessageFilter$$anon$1.prototype.constructor = $c_Llaika_config_MessageFilter$$anon$1;
/** @constructor */
function $h_Llaika_config_MessageFilter$$anon$1() {
}
$h_Llaika_config_MessageFilter$$anon$1.prototype = $c_Llaika_config_MessageFilter$$anon$1.prototype;
$c_Llaika_config_MessageFilter$$anon$1.prototype.apply__Llaika_ast_RuntimeMessage__Z = (function(message) {
  var this$1 = $n($n(message).Llaika_ast_RuntimeMessage__f_level);
  var that = this.Llaika_config_MessageFilter$$anon$1__f_level$1;
  return $f_s_math_Ordered__$greater$eq__O__Z(this$1, that);
});
var $d_Llaika_config_MessageFilter$$anon$1 = new $TypeData().initClass($c_Llaika_config_MessageFilter$$anon$1, "laika.config.MessageFilter$$anon$1", ({
  Llaika_config_MessageFilter$$anon$1: 1,
  Llaika_config_MessageFilter: 1
}));
function $p_Llaika_config_PlatformDateTimeImpl$__jsLocaleParam__s_Option__sjs_js_Any($thiz, locale) {
  var this$1 = $n(locale);
  if (this$1.isEmpty__Z()) {
    var $x_1 = $m_s_None$();
  } else {
    var arg1 = this$1.get__O();
    var s = $as_T(arg1);
    var $x_1 = new $c_s_Some(s);
  }
  var this$3 = $n($x_1);
  return (this$3.isEmpty__Z() ? [] : this$3.get__O());
}
function $p_Llaika_config_PlatformDateTimeImpl$__formatterConstants__sci_Set($thiz) {
  if ((!$thiz.Llaika_config_PlatformDateTimeImpl$__f_formatterConstantsbitmap$1)) {
    var this$1 = $m_sci_Set$();
    var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["full", "long", "medium", "short"]));
    $thiz.Llaika_config_PlatformDateTimeImpl$__f_formatterConstants$lzy1 = this$1.from__sc_IterableOnce__sci_Set(elems);
    $thiz.Llaika_config_PlatformDateTimeImpl$__f_formatterConstantsbitmap$1 = true;
  }
  return $thiz.Llaika_config_PlatformDateTimeImpl$__f_formatterConstants$lzy1;
}
/** @constructor */
function $c_Llaika_config_PlatformDateTimeImpl$() {
  this.Llaika_config_PlatformDateTimeImpl$__f_formatterConstants$lzy1 = null;
  this.Llaika_config_PlatformDateTimeImpl$__f_formatterConstantsbitmap$1 = false;
}
$c_Llaika_config_PlatformDateTimeImpl$.prototype = new $h_O();
$c_Llaika_config_PlatformDateTimeImpl$.prototype.constructor = $c_Llaika_config_PlatformDateTimeImpl$;
/** @constructor */
function $h_Llaika_config_PlatformDateTimeImpl$() {
}
$h_Llaika_config_PlatformDateTimeImpl$.prototype = $c_Llaika_config_PlatformDateTimeImpl$.prototype;
$c_Llaika_config_PlatformDateTimeImpl$.prototype.parse__T__s_util_Either = (function(dateString) {
  var result = new Date(dateString);
  var x = $uD(result.getTime());
  if ((x !== x)) {
    var value = ("Invalid date format: " + dateString);
    return new $c_s_util_Left(value);
  } else {
    return new $c_s_util_Right(result);
  }
});
$c_Llaika_config_PlatformDateTimeImpl$.prototype.format__sjs_js_Date__T__s_Option__s_util_Either = (function(date, pattern, locale) {
  var this$1 = $n(pattern);
  if (($uI(this$1.indexOf(":")) !== (-1))) {
    try {
      var r1 = $as_T(date.toLocaleString($p_Llaika_config_PlatformDateTimeImpl$__jsLocaleParam__s_Option__sjs_js_Any(this, locale)));
      var attempt = new $c_s_util_Success(r1);
    } catch (e) {
      var attempt;
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        var attempt = new $c_s_util_Failure(e$2);
      } else {
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2));
      }
    }
  } else {
    try {
      var r1$1 = $as_T(date.toLocaleDateString($p_Llaika_config_PlatformDateTimeImpl$__jsLocaleParam__s_Option__sjs_js_Any(this, locale)));
      var attempt = new $c_s_util_Success(r1$1);
    } catch (e$1) {
      var attempt;
      var e$2$1 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$1)) {
        var attempt = new $c_s_util_Failure(e$2$1);
      } else {
        throw ((e$2$1 instanceof $c_sjs_js_JavaScriptException) ? e$2$1.sjs_js_JavaScriptException__f_exception : $n(e$2$1));
      }
    }
  }
  var this$4 = $n($n(attempt).toEither__s_util_Either());
  var this$5 = new $c_s_util_Either$LeftProjection(this$4);
  var x1 = this$5.s_util_Either$LeftProjection__f_e;
  if ((x1 instanceof $c_s_util_Left)) {
    var x2 = $as_s_util_Left(x1);
    var a = $n(x2).s_util_Left__f_value;
    var _$1 = $as_jl_Throwable(a);
    return new $c_s_util_Left($n(_$1).getMessage__T());
  } else {
    return this$5.s_util_Either$LeftProjection__f_e;
  }
});
$c_Llaika_config_PlatformDateTimeImpl$.prototype.formatConstant__sjs_js_Date__T__s_Option__s_Option = (function(date, constant, locale) {
  var $x_1 = $p_Llaika_config_PlatformDateTimeImpl$__formatterConstants__sci_Set(this);
  var this$1 = $n(constant);
  if ($n($x_1).contains__O__Z($as_T(this$1.toLowerCase()))) {
    var $x_3 = $m_sr_ScalaRunTime$();
    var this$3 = $n(constant);
    var s = $as_T(this$3.toLowerCase());
    var $x_2 = new $c_T2("dateStyle", s);
    var this$7 = $n(constant);
    var s$1 = $as_T(this$7.toLowerCase());
    var fields = $n($x_3).wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$x_2, new $c_T2("timeStyle", s$1)]));
    var opts = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
    try {
      var r1 = $as_T(date.toLocaleString($p_Llaika_config_PlatformDateTimeImpl$__jsLocaleParam__s_Option__sjs_js_Any(this, locale), opts));
      var $x_4 = new $c_s_util_Success(r1);
    } catch (e) {
      var $x_4;
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        var $x_4 = new $c_s_util_Failure(e$2);
      } else {
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2));
      }
    }
    var eab = $n($x_4).toEither__s_util_Either();
    matchResult23: {
      var a$1;
      if ((eab instanceof $c_s_util_Left)) {
        var a = $n($as_s_util_Left(eab)).s_util_Left__f_value;
        var _$2 = $as_jl_Throwable(a);
        var value = $n(_$2).getMessage__T();
        var a$1 = new $c_s_util_Left(value);
        break matchResult23;
      }
      if ((eab instanceof $c_s_util_Right)) {
        var r = $as_s_util_Right(eab);
        $m_Lcats_syntax_EitherUtil$();
        var a$1 = r;
        break matchResult23;
      }
      throw new $c_s_MatchError(eab);
    }
    return new $c_s_Some(a$1);
  } else {
    return $m_s_None$();
  }
});
var $d_Llaika_config_PlatformDateTimeImpl$ = new $TypeData().initClass($c_Llaika_config_PlatformDateTimeImpl$, "laika.config.PlatformDateTimeImpl$", ({
  Llaika_config_PlatformDateTimeImpl$: 1,
  Llaika_config_PlatformDateTime: 1
}));
var $n_Llaika_config_PlatformDateTimeImpl$;
function $m_Llaika_config_PlatformDateTimeImpl$() {
  if ((!$n_Llaika_config_PlatformDateTimeImpl$)) {
    $n_Llaika_config_PlatformDateTimeImpl$ = new $c_Llaika_config_PlatformDateTimeImpl$();
  }
  return $n_Llaika_config_PlatformDateTimeImpl$;
}
function $p_Llaika_config_Selections$FormatFilter$__extractMap$1__Llaika_config_Selections__sci_Map($thiz, selectionConfig) {
  var $x_1 = $n($as_sc_IterableOnceOps($n($n(selectionConfig).Llaika_config_Selections$Impl__f_all).flatMap__F1__O(new $c_sjsr_AnonFunction1(((selection) => {
    var selection$1 = $as_Llaika_config_SelectionConfig(selection);
    $m_Lcats_data_NonEmptyChainImpl$();
    var value = $n(selection$1).Llaika_config_SelectionConfig$Impl__f_choices;
    var this$3 = $n($m_Lcats_data_NonEmptyChainOps$().find$extension__O__F1__s_Option(value, new $c_sjsr_AnonFunction1(((_$16) => {
      var _$16$1 = $as_Llaika_config_ChoiceConfig(_$16);
      return $n(_$16$1).Llaika_config_ChoiceConfig$Impl__f_selected;
    }))));
    if (this$3.isEmpty__Z()) {
      return $m_s_None$();
    } else {
      var arg1 = this$3.get__O();
      var c = $as_Llaika_config_ChoiceConfig(arg1);
      var _1 = $n(selection$1).Llaika_config_SelectionConfig$Impl__f_name;
      var _2 = $n(c).Llaika_config_ChoiceConfig$Impl__f_name;
      return new $c_s_Some(new $c_T2(_1, _2));
    }
  })))));
  var this$5 = $m_s_$less$colon$less$();
  return $n($x_1).toMap__s_$less$colon$less__sci_Map(this$5.s_$less$colon$less$__f_singleton);
}
/** @constructor */
function $c_Llaika_config_Selections$FormatFilter$() {
}
$c_Llaika_config_Selections$FormatFilter$.prototype = new $h_O();
$c_Llaika_config_Selections$FormatFilter$.prototype.constructor = $c_Llaika_config_Selections$FormatFilter$;
/** @constructor */
function $h_Llaika_config_Selections$FormatFilter$() {
}
$h_Llaika_config_Selections$FormatFilter$.prototype = $c_Llaika_config_Selections$FormatFilter$.prototype;
$c_Llaika_config_Selections$FormatFilter$.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_Llaika_config_Selections$FormatFilter$.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_Llaika_config_Selections$FormatFilter$.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Llaika_config_Selections$FormatFilter$.prototype.apply__Llaika_ast_DocumentCursor__s_util_Either = (function(cursor) {
  var targetConfig = ($n($n($n(cursor).root__Llaika_ast_RootCursor()).Llaika_ast_RootCursor__f_config).hasKey__Llaika_api_config_Key__Z($m_Llaika_config_LaikaKeys$().Llaika_config_LaikaKeys$__f_selections) ? $n($n(cursor).root__Llaika_ast_RootCursor()).Llaika_ast_RootCursor__f_config : $n(cursor).Llaika_ast_DocumentCursor__f_config);
  var this$1 = $n(targetConfig);
  var decoder = $m_Llaika_config_Selections$().Llaika_config_Selections$__f_decoder;
  var defaultKey = $m_Llaika_config_Selections$().Llaika_config_Selections$__f_key;
  var key = $n(defaultKey).Llaika_api_config_DefaultKey$$anon$1__f_value;
  var this$2 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$1, key, decoder));
  if ((this$2 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$2);
    var b = $n(x2).s_util_Right__f_value;
    var _$17 = $as_s_Option(b);
    var this$3 = $n(_$17);
    var $x_1 = new $c_s_util_Right($as_Llaika_config_Selections((this$3.isEmpty__Z() ? $m_Llaika_config_Selections$().Llaika_config_Selections$__f_empty : this$3.get__O())));
  } else {
    var $x_1 = this$2;
  }
  var this$4 = $n($x_1);
  if ((this$4 instanceof $c_s_util_Right)) {
    var x2$1 = $as_s_util_Right(this$4);
    var b$1 = $n(x2$1).s_util_Right__f_value;
    var selectionConfig = $as_Llaika_config_Selections(b$1);
    var selections = new $c_s_util_Right($p_Llaika_config_Selections$FormatFilter$__extractMap$1__Llaika_config_Selections__sci_Map(this, selectionConfig));
  } else {
    var selections = this$4;
  }
  var this$5 = $n(selections);
  if ((this$5 instanceof $c_s_util_Right)) {
    var x2$2 = $as_s_util_Right(this$5);
    var b$2 = $n(x2$2).s_util_Right__f_value;
    var selections$1 = $as_sci_Map(b$2);
    return new $c_s_util_Right(($n(selections$1).isEmpty__Z() ? new $c_Llaika_ast_RewriteRules($m_sci_Nil$(), $m_sci_Nil$(), $m_sci_Nil$()) : $m_Llaika_ast_RewriteRules$().forBlocks__s_PartialFunction__Llaika_ast_RewriteRules(new $c_Llaika_config_Selections$FormatFilter$$anon$1(selections$1))));
  } else {
    return this$5;
  }
});
$c_Llaika_config_Selections$FormatFilter$.prototype.apply__O__O = (function(v1) {
  return this.apply__Llaika_ast_DocumentCursor__s_util_Either($as_Llaika_ast_DocumentCursor(v1));
});
$c_Llaika_config_Selections$FormatFilter$.prototype.laika$config$Selections$FormatFilter$$$_$select$1__Llaika_ast_Selection__T__Llaika_ast_Block = (function(selection, selectedChoice) {
  var this$2 = $n($n($n(selection).Llaika_ast_Selection__f_choices).find__F1__s_Option(new $c_sjsr_AnonFunction1(((_$18) => {
    var _$18$1 = $as_Llaika_ast_Choice(_$18);
    return ($n(_$18$1).Llaika_ast_Choice__f_name === selectedChoice);
  }))));
  if (this$2.isEmpty__Z()) {
    var $x_1 = selection;
  } else {
    var arg1 = this$2.get__O();
    var choice = $as_Llaika_ast_Choice(arg1);
    var content = $n(choice).Llaika_ast_Choice__f_content;
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var $x_1 = new $c_Llaika_ast_BlockSequence(content, options);
  }
  return $as_Llaika_ast_Block($x_1);
});
$c_Llaika_config_Selections$FormatFilter$.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__Llaika_ast_DocumentCursor__s_util_Either($as_Llaika_ast_DocumentCursor(v1)));
});
var $d_Llaika_config_Selections$FormatFilter$ = new $TypeData().initClass($c_Llaika_config_Selections$FormatFilter$, "laika.config.Selections$FormatFilter$", ({
  Llaika_config_Selections$FormatFilter$: 1,
  F1: 1
}));
var $n_Llaika_config_Selections$FormatFilter$;
function $m_Llaika_config_Selections$FormatFilter$() {
  if ((!$n_Llaika_config_Selections$FormatFilter$)) {
    $n_Llaika_config_Selections$FormatFilter$ = new $c_Llaika_config_Selections$FormatFilter$();
  }
  return $n_Llaika_config_Selections$FormatFilter$;
}
/** @constructor */
function $c_Llaika_format_Markdown$GitHubFlavor$() {
  this.Llaika_format_Markdown$GitHubFlavor$__f_origin = null;
  $n_Llaika_format_Markdown$GitHubFlavor$ = this;
  this.Llaika_format_Markdown$GitHubFlavor$__f_origin = $m_Llaika_api_bundle_BundleOrigin$Parser$();
}
$c_Llaika_format_Markdown$GitHubFlavor$.prototype = new $h_O();
$c_Llaika_format_Markdown$GitHubFlavor$.prototype.constructor = $c_Llaika_format_Markdown$GitHubFlavor$;
/** @constructor */
function $h_Llaika_format_Markdown$GitHubFlavor$() {
}
$h_Llaika_format_Markdown$GitHubFlavor$.prototype = $c_Llaika_format_Markdown$GitHubFlavor$.prototype;
$c_Llaika_format_Markdown$GitHubFlavor$.prototype.baseConfig__Llaika_api_config_Config = (function() {
  return $m_Llaika_api_config_Config$().Llaika_api_config_Config$__f_empty;
});
$c_Llaika_format_Markdown$GitHubFlavor$.prototype.slugBuilder__s_Option = (function() {
  return $m_s_None$();
});
$c_Llaika_format_Markdown$GitHubFlavor$.prototype.rewriteRules__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf;
});
$c_Llaika_format_Markdown$GitHubFlavor$.prototype.renderOverrides__sci_Seq = (function() {
  return $as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps());
});
$c_Llaika_format_Markdown$GitHubFlavor$.prototype.processExtension__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf;
});
$c_Llaika_format_Markdown$GitHubFlavor$.prototype.rawContentDisabled__s_Option = (function() {
  return new $c_s_Some(this);
});
$c_Llaika_format_Markdown$GitHubFlavor$.prototype.origin__Llaika_api_bundle_BundleOrigin = (function() {
  return $m_Llaika_api_bundle_BundleOrigin$Parser$();
});
$c_Llaika_format_Markdown$GitHubFlavor$.prototype.parsers__Llaika_api_bundle_ParserBundle = (function() {
  var this$1 = $n($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_bundle_BlockParserBuilder.getArrayOf().constr)([$m_Llaika_internal_markdown_github_Tables$().Llaika_internal_markdown_github_Tables$__f_parser]))));
  var suffix = $m_Llaika_internal_markdown_github_FencedCodeBlocks$().Llaika_internal_markdown_github_FencedCodeBlocks$__f_parsers;
  return new $c_Llaika_api_bundle_ParserBundle($as_sci_Seq(this$1.appendedAll__sc_IterableOnce__O(suffix)), $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_bundle_SpanParserBuilder.getArrayOf().constr)([$m_Llaika_internal_markdown_github_Strikethrough$().Llaika_internal_markdown_github_Strikethrough$__f_parser, $n($m_Llaika_internal_markdown_github_AutoLinks$().Llaika_internal_markdown_github_AutoLinks$__f_parsers).www__Llaika_api_bundle_SpanParserBuilder(), $n($m_Llaika_internal_markdown_github_AutoLinks$().Llaika_internal_markdown_github_AutoLinks$__f_parsers).http__Llaika_api_bundle_SpanParserBuilder(), $n($m_Llaika_internal_markdown_github_AutoLinks$().Llaika_internal_markdown_github_AutoLinks$__f_parsers).email__Llaika_api_bundle_SpanParserBuilder()])))), $m_sci_Nil$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
});
$c_Llaika_format_Markdown$GitHubFlavor$.prototype.forStrictMode__s_Option = (function() {
  return $m_s_None$();
});
var $d_Llaika_format_Markdown$GitHubFlavor$ = new $TypeData().initClass($c_Llaika_format_Markdown$GitHubFlavor$, "laika.format.Markdown$GitHubFlavor$", ({
  Llaika_format_Markdown$GitHubFlavor$: 1,
  Llaika_api_bundle_ExtensionBundle: 1
}));
var $n_Llaika_format_Markdown$GitHubFlavor$;
function $m_Llaika_format_Markdown$GitHubFlavor$() {
  if ((!$n_Llaika_format_Markdown$GitHubFlavor$)) {
    $n_Llaika_format_Markdown$GitHubFlavor$ = new $c_Llaika_format_Markdown$GitHubFlavor$();
  }
  return $n_Llaika_format_Markdown$GitHubFlavor$;
}
/** @constructor */
function $c_Llaika_format_Markdown$blockParsers$() {
  this.Llaika_format_Markdown$blockParsers$__f_atxHeader = null;
  this.Llaika_format_Markdown$blockParsers$__f_rootHeaderOrParagraph$lzy1 = null;
  this.Llaika_format_Markdown$blockParsers$__f_rootHeaderOrParagraphbitmap$1 = false;
  this.Llaika_format_Markdown$blockParsers$__f_nestedHeaderOrParagraph$lzy1 = null;
  this.Llaika_format_Markdown$blockParsers$__f_nestedHeaderOrParagraphbitmap$1 = false;
  this.Llaika_format_Markdown$blockParsers$__f_bulletList = null;
  this.Llaika_format_Markdown$blockParsers$__f_enumList = null;
  this.Llaika_format_Markdown$blockParsers$__f_quotedBlock = null;
  this.Llaika_format_Markdown$blockParsers$__f_literalBlock = null;
  this.Llaika_format_Markdown$blockParsers$__f_linkTarget = null;
  this.Llaika_format_Markdown$blockParsers$__f_rule = null;
  this.Llaika_format_Markdown$blockParsers$__f_all = null;
  $n_Llaika_format_Markdown$blockParsers$ = this;
  this.Llaika_format_Markdown$blockParsers$__f_atxHeader = $m_Llaika_internal_markdown_BlockParsers$().Llaika_internal_markdown_BlockParsers$__f_atxHeader;
  this.Llaika_format_Markdown$blockParsers$__f_bulletList = $m_Llaika_internal_markdown_ListParsers$().Llaika_internal_markdown_ListParsers$__f_bulletLists;
  this.Llaika_format_Markdown$blockParsers$__f_enumList = $m_Llaika_internal_markdown_ListParsers$().Llaika_internal_markdown_ListParsers$__f_enumLists;
  this.Llaika_format_Markdown$blockParsers$__f_quotedBlock = $m_Llaika_internal_markdown_BlockParsers$().Llaika_internal_markdown_BlockParsers$__f_quotedBlock;
  this.Llaika_format_Markdown$blockParsers$__f_literalBlock = $m_Llaika_internal_markdown_BlockParsers$().Llaika_internal_markdown_BlockParsers$__f_literalBlocks;
  this.Llaika_format_Markdown$blockParsers$__f_linkTarget = $m_Llaika_internal_markdown_BlockParsers$().Llaika_internal_markdown_BlockParsers$__f_linkTarget;
  this.Llaika_format_Markdown$blockParsers$__f_rule = $m_Llaika_internal_markdown_BlockParsers$().Llaika_internal_markdown_BlockParsers$__f_rules;
  var $x_15 = $m_sci_Seq$();
  var $x_14 = $m_sr_ScalaRunTime$();
  var $x_13 = $n(this.Llaika_format_Markdown$blockParsers$__f_atxHeader);
  var this$1 = $m_Llaika_parse_text_TextParsers$();
  var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
  var $x_12 = $n($x_13).interruptsParagraphWith__Llaika_parse_text_PrefixedParser__Llaika_api_bundle_BlockParserBuilder($f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser(this$1, 35, chars));
  var $x_11 = this.Llaika_format_Markdown$blockParsers$__f_linkTarget;
  var $x_10 = this.Llaika_format_Markdown$blockParsers$__f_quotedBlock;
  var $x_9 = this.rootHeaderOrParagraph__Llaika_api_bundle_BlockParserBuilder();
  var $x_8 = this.nestedHeaderOrParagraph__Llaika_api_bundle_BlockParserBuilder();
  var $x_7 = $m_Llaika_internal_markdown_BlockParsers$().Llaika_internal_markdown_BlockParsers$__f_fallbackParagraph;
  var $x_6 = this.Llaika_format_Markdown$blockParsers$__f_literalBlock;
  var $x_5 = this.Llaika_format_Markdown$blockParsers$__f_rule;
  var $x_4 = $n(this.Llaika_format_Markdown$blockParsers$__f_enumList).rootOnly__Llaika_api_bundle_BlockParserBuilder();
  var $x_3 = $n($n(this.Llaika_format_Markdown$blockParsers$__f_enumList).nestedOnly__Llaika_api_bundle_BlockParserBuilder());
  var this$2 = $m_Llaika_parse_text_TextParsers$();
  var chars$1 = $m_Llaika_parse_text_CharGroup$().Llaika_parse_text_CharGroup$__f_digit;
  var $x_2 = $n($x_3).interruptsParagraphWith__Llaika_parse_text_PrefixedParser__Llaika_api_bundle_BlockParserBuilder($f_Llaika_parse_text_TextParsers__oneOf__O__Llaika_parse_text_PrefixedParser(this$2, chars$1));
  var $x_1 = this.Llaika_format_Markdown$blockParsers$__f_bulletList;
  var this$3 = $m_Llaika_parse_text_TextParsers$();
  var chars$2 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([42, 45])));
  this.Llaika_format_Markdown$blockParsers$__f_all = $as_sci_Seq($n($x_15).apply__sci_Seq__sc_SeqOps($n($x_14).wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_bundle_BlockParserBuilder.getArrayOf().constr)([$x_12, $x_11, $x_10, $x_9, $x_8, $x_7, $x_6, $x_5, $x_4, $x_2, $n($x_1).interruptsParagraphWith__Llaika_parse_text_PrefixedParser__Llaika_api_bundle_BlockParserBuilder($f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser(this$3, 43, chars$2))]))));
}
$c_Llaika_format_Markdown$blockParsers$.prototype = new $h_O();
$c_Llaika_format_Markdown$blockParsers$.prototype.constructor = $c_Llaika_format_Markdown$blockParsers$;
/** @constructor */
function $h_Llaika_format_Markdown$blockParsers$() {
}
$h_Llaika_format_Markdown$blockParsers$.prototype = $c_Llaika_format_Markdown$blockParsers$.prototype;
$c_Llaika_format_Markdown$blockParsers$.prototype.rootHeaderOrParagraph__Llaika_api_bundle_BlockParserBuilder = (function() {
  if ((!this.Llaika_format_Markdown$blockParsers$__f_rootHeaderOrParagraphbitmap$1)) {
    this.Llaika_format_Markdown$blockParsers$__f_rootHeaderOrParagraph$lzy1 = $m_Llaika_internal_markdown_BlockParsers$().rootHeaderOrParagraph__Llaika_api_bundle_BlockParserBuilder();
    this.Llaika_format_Markdown$blockParsers$__f_rootHeaderOrParagraphbitmap$1 = true;
  }
  return this.Llaika_format_Markdown$blockParsers$__f_rootHeaderOrParagraph$lzy1;
});
$c_Llaika_format_Markdown$blockParsers$.prototype.nestedHeaderOrParagraph__Llaika_api_bundle_BlockParserBuilder = (function() {
  if ((!this.Llaika_format_Markdown$blockParsers$__f_nestedHeaderOrParagraphbitmap$1)) {
    this.Llaika_format_Markdown$blockParsers$__f_nestedHeaderOrParagraph$lzy1 = $m_Llaika_internal_markdown_BlockParsers$().nestedHeaderOrParagraph__Llaika_api_bundle_BlockParserBuilder();
    this.Llaika_format_Markdown$blockParsers$__f_nestedHeaderOrParagraphbitmap$1 = true;
  }
  return this.Llaika_format_Markdown$blockParsers$__f_nestedHeaderOrParagraph$lzy1;
});
var $d_Llaika_format_Markdown$blockParsers$ = new $TypeData().initClass($c_Llaika_format_Markdown$blockParsers$, "laika.format.Markdown$blockParsers$", ({
  Llaika_format_Markdown$blockParsers$: 1,
  Llaika_api_format_MarkupFormat$MarkupParsers: 1
}));
var $n_Llaika_format_Markdown$blockParsers$;
function $m_Llaika_format_Markdown$blockParsers$() {
  if ((!$n_Llaika_format_Markdown$blockParsers$)) {
    $n_Llaika_format_Markdown$blockParsers$ = new $c_Llaika_format_Markdown$blockParsers$();
  }
  return $n_Llaika_format_Markdown$blockParsers$;
}
/** @constructor */
function $c_Llaika_format_Markdown$spanParsers$() {
  this.Llaika_format_Markdown$spanParsers$__f_enclosedByAsterisk = null;
  this.Llaika_format_Markdown$spanParsers$__f_enclosedByUnderscore = null;
  this.Llaika_format_Markdown$spanParsers$__f_link$lzy1 = null;
  this.Llaika_format_Markdown$spanParsers$__f_linkbitmap$1 = false;
  this.Llaika_format_Markdown$spanParsers$__f_simpleLink = null;
  this.Llaika_format_Markdown$spanParsers$__f_literalSpan = null;
  this.Llaika_format_Markdown$spanParsers$__f_image = null;
  this.Llaika_format_Markdown$spanParsers$__f_lineBreak = null;
  this.Llaika_format_Markdown$spanParsers$__f_all = null;
  $n_Llaika_format_Markdown$spanParsers$ = this;
  this.Llaika_format_Markdown$spanParsers$__f_enclosedByAsterisk = $m_Llaika_internal_markdown_InlineParsers$().Llaika_internal_markdown_InlineParsers$__f_enclosedByAsterisk;
  this.Llaika_format_Markdown$spanParsers$__f_enclosedByUnderscore = $m_Llaika_internal_markdown_InlineParsers$().Llaika_internal_markdown_InlineParsers$__f_enclosedByUnderscore;
  this.Llaika_format_Markdown$spanParsers$__f_simpleLink = $m_Llaika_internal_markdown_InlineParsers$().Llaika_internal_markdown_InlineParsers$__f_simpleLink;
  this.Llaika_format_Markdown$spanParsers$__f_literalSpan = $m_Llaika_internal_markdown_InlineParsers$().Llaika_internal_markdown_InlineParsers$__f_literalSpan;
  this.Llaika_format_Markdown$spanParsers$__f_image = $m_Llaika_internal_markdown_InlineParsers$().Llaika_internal_markdown_InlineParsers$__f_image;
  this.Llaika_format_Markdown$spanParsers$__f_lineBreak = $m_Llaika_internal_markdown_InlineParsers$().Llaika_internal_markdown_InlineParsers$__f_lineBreak;
  this.Llaika_format_Markdown$spanParsers$__f_all = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_bundle_SpanParserBuilder.getArrayOf().constr)([this.Llaika_format_Markdown$spanParsers$__f_enclosedByAsterisk, this.Llaika_format_Markdown$spanParsers$__f_enclosedByUnderscore, this.Llaika_format_Markdown$spanParsers$__f_literalSpan, this.Llaika_format_Markdown$spanParsers$__f_image, this.link__Llaika_api_bundle_SpanParserBuilder(), this.Llaika_format_Markdown$spanParsers$__f_simpleLink, this.Llaika_format_Markdown$spanParsers$__f_lineBreak]))));
}
$c_Llaika_format_Markdown$spanParsers$.prototype = new $h_O();
$c_Llaika_format_Markdown$spanParsers$.prototype.constructor = $c_Llaika_format_Markdown$spanParsers$;
/** @constructor */
function $h_Llaika_format_Markdown$spanParsers$() {
}
$h_Llaika_format_Markdown$spanParsers$.prototype = $c_Llaika_format_Markdown$spanParsers$.prototype;
$c_Llaika_format_Markdown$spanParsers$.prototype.link__Llaika_api_bundle_SpanParserBuilder = (function() {
  if ((!this.Llaika_format_Markdown$spanParsers$__f_linkbitmap$1)) {
    this.Llaika_format_Markdown$spanParsers$__f_link$lzy1 = $m_Llaika_internal_markdown_InlineParsers$().link__Llaika_api_bundle_SpanParserBuilder();
    this.Llaika_format_Markdown$spanParsers$__f_linkbitmap$1 = true;
  }
  return this.Llaika_format_Markdown$spanParsers$__f_link$lzy1;
});
var $d_Llaika_format_Markdown$spanParsers$ = new $TypeData().initClass($c_Llaika_format_Markdown$spanParsers$, "laika.format.Markdown$spanParsers$", ({
  Llaika_format_Markdown$spanParsers$: 1,
  Llaika_api_format_MarkupFormat$MarkupParsers: 1
}));
var $n_Llaika_format_Markdown$spanParsers$;
function $m_Llaika_format_Markdown$spanParsers$() {
  if ((!$n_Llaika_format_Markdown$spanParsers$)) {
    $n_Llaika_format_Markdown$spanParsers$ = new $c_Llaika_format_Markdown$spanParsers$();
  }
  return $n_Llaika_format_Markdown$spanParsers$;
}
function $ct_Llaika_internal_directive_DirectiveSupport__sci_Seq__sci_Seq__sci_Seq__sci_Seq__Z__($thiz, blockDirectives, spanDirectives, templateDirectives, linkDirectives, strictMode) {
  $thiz.Llaika_internal_directive_DirectiveSupport__f_blockDirectives = blockDirectives;
  $thiz.Llaika_internal_directive_DirectiveSupport__f_spanDirectives = spanDirectives;
  $thiz.Llaika_internal_directive_DirectiveSupport__f_templateDirectives = templateDirectives;
  $thiz.Llaika_internal_directive_DirectiveSupport__f_linkDirectives = linkDirectives;
  $thiz.Llaika_internal_directive_DirectiveSupport__f_laika$internal$directive$DirectiveSupport$$strictMode = strictMode;
  new $c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver$($thiz);
  $thiz.Llaika_internal_directive_DirectiveSupport__f_LinkDirectiveResolver2$lzy1 = new $c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2$($thiz);
  $thiz.Llaika_internal_directive_DirectiveSupport__f_origin = $m_Llaika_api_bundle_BundleOrigin$Library$();
  $thiz.Llaika_internal_directive_DirectiveSupport__f_configProvider = new $c_Llaika_internal_directive_DirectiveSupport$$anon$1($thiz);
  var $x_1 = $as_sc_IterableOnceOps($n(linkDirectives).map__F1__O(new $c_sjsr_AnonFunction1(((d) => {
    var d$1 = $as_Llaika_api_bundle_LinkDirectives$Directive(d);
    var _1 = $n(d$1).Llaika_api_bundle_LinkDirectives$$anon$14__f_directiveName$1;
    return new $c_T2(_1, d$1);
  }))));
  var this$2 = $m_s_$less$colon$less$();
  $thiz.Llaika_internal_directive_DirectiveSupport__f_laika$internal$directive$DirectiveSupport$$linkDirectiveMap = $n($x_1).toMap__s_$less$colon$less__sci_Map(this$2.s_$less$colon$less$__f_singleton);
  var $x_3 = $n($m_Llaika_internal_parse_directive_DirectiveParsers$().nameDecl__Llaika_parse_Parser()).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser($m_Llaika_parse_builders$().ws__Llaika_parse_text_Characters());
  var $x_2 = $m_Llaika_parse_syntax$LiteralStringOps$();
  var this$5 = $m_Llaika_parse_builders$();
  var parser = new $c_sjsr_AnonFunction0((() => {
    var this$4 = $m_Llaika_parse_builders$();
    var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
    return $f_Llaika_parse_text_TextParsers__delimitedBy__C__sci_Seq__Llaika_parse_text_DelimitedText(this$4, 41, chars);
  }));
  $thiz.Llaika_internal_directive_DirectiveSupport__f_laika$internal$directive$DirectiveSupport$$linkParser = $n($x_3).$tilde__Llaika_parse_Parser__Llaika_parse_Parser($as_Llaika_parse_Parser($n($x_2).$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("(", $as_Llaika_parse_Parser($n($f_Llaika_parse_markup_InlineParsers__text__F0__Llaika_parse_markup_InlineParser(this$5, parser)).embed__F0__Llaika_parse_markup_InlineParser(new $c_sjsr_AnonFunction0((() => $m_Llaika_parse_syntax$LiteralStringOps$().$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("\\", $m_Llaika_parse_text_TextParsers$().Llaika_parse_text_TextParsers$__f_oneChar))))))));
  return $thiz;
}
/** @constructor */
function $c_Llaika_internal_directive_DirectiveSupport() {
  this.Llaika_internal_directive_DirectiveSupport__f_blockDirectives = null;
  this.Llaika_internal_directive_DirectiveSupport__f_spanDirectives = null;
  this.Llaika_internal_directive_DirectiveSupport__f_templateDirectives = null;
  this.Llaika_internal_directive_DirectiveSupport__f_linkDirectives = null;
  this.Llaika_internal_directive_DirectiveSupport__f_laika$internal$directive$DirectiveSupport$$strictMode = false;
  this.Llaika_internal_directive_DirectiveSupport__f_origin = null;
  this.Llaika_internal_directive_DirectiveSupport__f_configProvider = null;
  this.Llaika_internal_directive_DirectiveSupport__f_parsers$lzy1 = null;
  this.Llaika_internal_directive_DirectiveSupport__f_parsersbitmap$1 = false;
  this.Llaika_internal_directive_DirectiveSupport__f_laika$internal$directive$DirectiveSupport$$linkDirectiveMap = null;
  this.Llaika_internal_directive_DirectiveSupport__f_laika$internal$directive$DirectiveSupport$$linkParser = null;
  this.Llaika_internal_directive_DirectiveSupport__f_LinkDirectiveResolver2$lzy1 = null;
  this.Llaika_internal_directive_DirectiveSupport__f_rewriteRules$lzy1 = null;
  this.Llaika_internal_directive_DirectiveSupport__f_rewriteRulesbitmap$1 = false;
}
$c_Llaika_internal_directive_DirectiveSupport.prototype = new $h_O();
$c_Llaika_internal_directive_DirectiveSupport.prototype.constructor = $c_Llaika_internal_directive_DirectiveSupport;
/** @constructor */
function $h_Llaika_internal_directive_DirectiveSupport() {
}
$h_Llaika_internal_directive_DirectiveSupport.prototype = $c_Llaika_internal_directive_DirectiveSupport.prototype;
$c_Llaika_internal_directive_DirectiveSupport.prototype.baseConfig__Llaika_api_config_Config = (function() {
  return $m_Llaika_api_config_Config$().Llaika_api_config_Config$__f_empty;
});
$c_Llaika_internal_directive_DirectiveSupport.prototype.slugBuilder__s_Option = (function() {
  return $m_s_None$();
});
$c_Llaika_internal_directive_DirectiveSupport.prototype.renderOverrides__sci_Seq = (function() {
  return $as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps());
});
$c_Llaika_internal_directive_DirectiveSupport.prototype.processExtension__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf;
});
$c_Llaika_internal_directive_DirectiveSupport.prototype.rawContentDisabled__s_Option = (function() {
  return new $c_s_Some(this);
});
$c_Llaika_internal_directive_DirectiveSupport.prototype.origin__Llaika_api_bundle_BundleOrigin = (function() {
  return this.Llaika_internal_directive_DirectiveSupport__f_origin;
});
$c_Llaika_internal_directive_DirectiveSupport.prototype.parsers__Llaika_api_bundle_ParserBundle = (function() {
  if ((!this.Llaika_internal_directive_DirectiveSupport__f_parsersbitmap$1)) {
    if (this.Llaika_internal_directive_DirectiveSupport__f_laika$internal$directive$DirectiveSupport$$strictMode) {
      var blockParsers$1 = $m_sci_Nil$();
    } else {
      var $x_3 = $m_sci_Seq$();
      var $x_2 = $m_sr_ScalaRunTime$();
      var $x_1 = $m_Llaika_internal_parse_directive_BlockDirectiveParsers$();
      var this$1 = $m_Llaika_api_bundle_BlockDirectives$();
      var directives = this.Llaika_internal_directive_DirectiveSupport__f_blockDirectives;
      var blockParsers$1 = $as_sci_Seq($n($x_3).apply__sci_Seq__sc_SeqOps($n($x_2).wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_bundle_BlockParserBuilder.getArrayOf().constr)([$n($x_1).blockDirective__sci_Map__Llaika_api_bundle_BlockParserBuilder($f_Llaika_api_bundle_DirectiveBuilderContext__toMap__sc_Iterable__sci_Map(this$1, directives))]))));
    }
    if (this.Llaika_internal_directive_DirectiveSupport__f_laika$internal$directive$DirectiveSupport$$strictMode) {
      var spanParsers$1 = $m_sci_Nil$();
    } else {
      var $x_6 = $m_sci_Seq$();
      var $x_5 = $m_sr_ScalaRunTime$();
      var $x_4 = $m_Llaika_internal_parse_directive_SpanDirectiveParsers$();
      var this$4 = $m_Llaika_api_bundle_SpanDirectives$();
      var this$3 = $n(this.Llaika_internal_directive_DirectiveSupport__f_spanDirectives);
      var suffix = $as_sc_IterableOnce($n(this.Llaika_internal_directive_DirectiveSupport__f_linkDirectives).map__F1__O(new $c_sjsr_AnonFunction1(((_$1) => {
        var _$1$1 = $as_Llaika_api_bundle_LinkDirectives$Directive(_$1);
        var this$2 = $n(_$1$1);
        return $f_Llaika_api_bundle_LinkDirectives$Directive__asSpanDirective__Llaika_api_bundle_DirectiveBuilderContext$Directive(this$2);
      }))));
      var directives$1 = $as_sc_Iterable(this$3.appendedAll__sc_IterableOnce__O(suffix));
      var spanParsers$1 = $as_sci_Seq($n($x_6).apply__sci_Seq__sc_SeqOps($n($x_5).wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_bundle_SpanParserBuilder.getArrayOf().constr)([$n($x_4).spanDirective__sci_Map__Llaika_api_bundle_SpanParserBuilder($f_Llaika_api_bundle_DirectiveBuilderContext__toMap__sc_Iterable__sci_Map(this$4, directives$1)), $m_Llaika_internal_parse_directive_SpanDirectiveParsers$().Llaika_internal_parse_directive_SpanDirectiveParsers$__f_contextRef]))));
    }
    var value = this.Llaika_internal_directive_DirectiveSupport__f_configProvider;
    var configProvider$1 = new $c_s_Some(value);
    var this$6 = $m_Llaika_api_bundle_TemplateDirectives$();
    var directives$2 = this.Llaika_internal_directive_DirectiveSupport__f_templateDirectives;
    var value$1 = new $c_Llaika_internal_parse_directive_TemplateParsers($f_Llaika_api_bundle_DirectiveBuilderContext__toMap__sc_Iterable__sci_Map(this$6, directives$2)).templateRoot__Llaika_parse_Parser();
    var templateParser$1 = new $c_s_Some(value$1);
    var syntaxHighlighters$1 = $m_sci_Nil$();
    var markupParserHooks$1 = $m_s_None$();
    var styleSheetParser$1 = $m_s_None$();
    this.Llaika_internal_directive_DirectiveSupport__f_parsers$lzy1 = new $c_Llaika_api_bundle_ParserBundle(blockParsers$1, spanParsers$1, syntaxHighlighters$1, markupParserHooks$1, configProvider$1, templateParser$1, styleSheetParser$1);
    this.Llaika_internal_directive_DirectiveSupport__f_parsersbitmap$1 = true;
  }
  return this.Llaika_internal_directive_DirectiveSupport__f_parsers$lzy1;
});
$c_Llaika_internal_directive_DirectiveSupport.prototype.rewriteRules__s_PartialFunction = (function() {
  if ((!this.Llaika_internal_directive_DirectiveSupport__f_rewriteRulesbitmap$1)) {
    this.Llaika_internal_directive_DirectiveSupport__f_rewriteRules$lzy1 = new $c_Llaika_internal_directive_DirectiveSupport$$anon$2(this);
    this.Llaika_internal_directive_DirectiveSupport__f_rewriteRulesbitmap$1 = true;
  }
  return this.Llaika_internal_directive_DirectiveSupport__f_rewriteRules$lzy1;
});
$c_Llaika_internal_directive_DirectiveSupport.prototype.withDirectives__sci_Seq__sci_Seq__sci_Seq__sci_Seq__Llaika_internal_directive_DirectiveSupport = (function(newBlockDirectives, newSpanDirectives, newTemplateDirectives, newLinkDirectives) {
  var this$1 = $n(this.Llaika_internal_directive_DirectiveSupport__f_blockDirectives);
  var $x_3 = $as_sci_Seq(this$1.appendedAll__sc_IterableOnce__O(newBlockDirectives));
  var this$2 = $n(this.Llaika_internal_directive_DirectiveSupport__f_spanDirectives);
  var $x_2 = $as_sci_Seq(this$2.appendedAll__sc_IterableOnce__O(newSpanDirectives));
  var this$3 = $n(this.Llaika_internal_directive_DirectiveSupport__f_templateDirectives);
  var $x_1 = $as_sci_Seq(this$3.appendedAll__sc_IterableOnce__O(newTemplateDirectives));
  var this$4 = $n(this.Llaika_internal_directive_DirectiveSupport__f_linkDirectives);
  return $ct_Llaika_internal_directive_DirectiveSupport__sci_Seq__sci_Seq__sci_Seq__sci_Seq__Z__(new $c_Llaika_internal_directive_DirectiveSupport(), $x_3, $x_2, $x_1, $as_sci_Seq(this$4.appendedAll__sc_IterableOnce__O(newLinkDirectives)), this.Llaika_internal_directive_DirectiveSupport__f_laika$internal$directive$DirectiveSupport$$strictMode);
});
$c_Llaika_internal_directive_DirectiveSupport.prototype.forStrictMode__s_Option = (function() {
  var value = $ct_Llaika_internal_directive_DirectiveSupport__sci_Seq__sci_Seq__sci_Seq__sci_Seq__Z__(new $c_Llaika_internal_directive_DirectiveSupport(), $m_sci_Nil$(), $m_sci_Nil$(), this.Llaika_internal_directive_DirectiveSupport__f_templateDirectives, $m_sci_Nil$(), true);
  return new $c_s_Some(value);
});
function $as_Llaika_internal_directive_DirectiveSupport(obj) {
  return (((obj instanceof $c_Llaika_internal_directive_DirectiveSupport) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.directive.DirectiveSupport"));
}
function $isArrayOf_Llaika_internal_directive_DirectiveSupport(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_directive_DirectiveSupport)));
}
function $asArrayOf_Llaika_internal_directive_DirectiveSupport(obj, depth) {
  return (($isArrayOf_Llaika_internal_directive_DirectiveSupport(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.directive.DirectiveSupport;", depth));
}
var $d_Llaika_internal_directive_DirectiveSupport = new $TypeData().initClass($c_Llaika_internal_directive_DirectiveSupport, "laika.internal.directive.DirectiveSupport", ({
  Llaika_internal_directive_DirectiveSupport: 1,
  Llaika_api_bundle_ExtensionBundle: 1
}));
/** @constructor */
function $c_Llaika_internal_directive_DirectiveSupport$$anon$1(outer) {
  this.Llaika_internal_directive_DirectiveSupport$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_internal_directive_DirectiveSupport$$anon$1__f_$outer = outer;
}
$c_Llaika_internal_directive_DirectiveSupport$$anon$1.prototype = new $h_O();
$c_Llaika_internal_directive_DirectiveSupport$$anon$1.prototype.constructor = $c_Llaika_internal_directive_DirectiveSupport$$anon$1;
/** @constructor */
function $h_Llaika_internal_directive_DirectiveSupport$$anon$1() {
}
$h_Llaika_internal_directive_DirectiveSupport$$anon$1.prototype = $c_Llaika_internal_directive_DirectiveSupport$$anon$1.prototype;
$c_Llaika_internal_directive_DirectiveSupport$$anon$1.prototype.markupConfigHeader__Llaika_parse_Parser = (function() {
  if ($n(this.Llaika_internal_directive_DirectiveSupport$$anon$1__f_$outer).Llaika_internal_directive_DirectiveSupport__f_laika$internal$directive$DirectiveSupport$$strictMode) {
    var this$2 = $m_Llaika_parse_combinator_Parsers$();
    var this$1 = $m_Llaika_api_config_ConfigParser$();
    var v = new $c_Llaika_api_config_ConfigParser$$anon$2(this$1);
    return $f_Llaika_parse_combinator_Parsers__success__O__Llaika_parse_Parser(this$2, v);
  } else {
    var this$3 = $m_Llaika_api_bundle_ConfigHeaderParser$();
    return this$3.betweenLines__T__T__Llaika_parse_Parser("{%", "%}");
  }
});
var $d_Llaika_internal_directive_DirectiveSupport$$anon$1 = new $TypeData().initClass($c_Llaika_internal_directive_DirectiveSupport$$anon$1, "laika.internal.directive.DirectiveSupport$$anon$1", ({
  Llaika_internal_directive_DirectiveSupport$$anon$1: 1,
  Llaika_api_bundle_ConfigProvider: 1
}));
function $p_Llaika_internal_link_LinkResolver__replace$1__Llaika_ast_DocumentCursor__Llaika_ast_Element__Llaika_internal_link_Selector__s_Option($thiz, cursor$1, element, selector) {
  var this$1 = $n($n($thiz.Llaika_internal_link_LinkResolver__f_targets).select__Llaika_ast_Path__Llaika_internal_link_Selector__s_Option($n(cursor$1).Llaika_ast_DocumentCursor__f_path, selector));
  if (this$1.isEmpty__Z()) {
    return $m_s_None$();
  } else {
    var arg1 = this$1.get__O();
    var _$2 = $as_Llaika_internal_link_TargetResolver(arg1);
    return $n(_$2).replaceTarget__Llaika_ast_Element__s_Option(element);
  }
}
function $ps_Llaika_internal_link_LinkResolver__describeUnknownTarget$1__Llaika_ast_Element__T(target) {
  var this$1 = $n($n($n(target).options__Llaika_ast_Options()).Llaika_ast_Options$Impl__f_id);
  if (this$1.isEmpty__Z()) {
    var id$2 = "<no id>";
  } else {
    var arg1 = this$1.get__O();
    var id = $as_T(arg1);
    var id$2 = ("id " + id);
  }
  var tpe = $n(target).productPrefix__T();
  return (((("link target of type " + tpe) + " with ") + id$2) + " can only be inserted in RewritePhase.Build");
}
function $p_Llaika_internal_link_LinkResolver__selectFromParent$1__Llaika_ast_TreeCursor__Llaika_internal_link_UniqueSelector__s_Option($thiz, treeCursor, selector) {
  var treeCursor$tailLocal1 = treeCursor;
  while (true) {
    var target = $n($thiz.Llaika_internal_link_LinkResolver__f_targets).select__Llaika_ast_Path__Llaika_internal_link_Selector__s_Option($n(treeCursor$tailLocal1).Llaika_ast_TreeCursor__f_path, selector);
    var x20 = $n(treeCursor$tailLocal1).Llaika_ast_TreeCursor__f_parent;
    if ((x20 instanceof $c_s_Some)) {
      var parent = $as_Llaika_ast_TreeCursor($n($as_s_Some(x20)).s_Some__f_value);
      if ($n(target).isEmpty__Z()) {
        treeCursor$tailLocal1 = parent;
        continue;
      }
    }
    return target;
  }
}
function $p_Llaika_internal_link_LinkResolver__selectRecursive$1__Llaika_ast_DocumentCursor__Llaika_internal_link_UniqueSelector__s_Option($thiz, cursor$6, selector) {
  var this$1 = $n($n($thiz.Llaika_internal_link_LinkResolver__f_targets).select__Llaika_ast_Path__Llaika_internal_link_Selector__s_Option($n(cursor$6).Llaika_ast_DocumentCursor__f_path, selector));
  return (this$1.isEmpty__Z() ? $p_Llaika_internal_link_LinkResolver__selectFromParent$1__Llaika_ast_TreeCursor__Llaika_internal_link_UniqueSelector__s_Option($thiz, $n(cursor$6).Llaika_ast_DocumentCursor__f_parent, selector) : this$1);
}
/** @constructor */
function $c_Llaika_internal_link_LinkResolver(root, slugBuilder) {
  this.Llaika_internal_link_LinkResolver__f_laika$internal$link$LinkResolver$$slugBuilder = null;
  this.Llaika_internal_link_LinkResolver__f_targets = null;
  this.Llaika_internal_link_LinkResolver__f_laika$internal$link$LinkResolver$$slugBuilder = slugBuilder;
  this.Llaika_internal_link_LinkResolver__f_targets = new $c_Llaika_internal_link_TreeTargets(root, slugBuilder);
}
$c_Llaika_internal_link_LinkResolver.prototype = new $h_O();
$c_Llaika_internal_link_LinkResolver.prototype.constructor = $c_Llaika_internal_link_LinkResolver;
/** @constructor */
function $h_Llaika_internal_link_LinkResolver() {
}
$h_Llaika_internal_link_LinkResolver.prototype = $c_Llaika_internal_link_LinkResolver.prototype;
$c_Llaika_internal_link_LinkResolver.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_Llaika_internal_link_LinkResolver.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_Llaika_internal_link_LinkResolver.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Llaika_internal_link_LinkResolver.prototype.apply__Llaika_ast_DocumentCursor__s_util_Either = (function(cursor) {
  var validator = new $c_Llaika_internal_link_LinkValidator(cursor, new $c_sjsr_AnonFunction1(((path) => {
    var path$1 = $as_Llaika_ast_Path(path);
    var this$3 = $n($n(this.Llaika_internal_link_LinkResolver__f_targets).select__Llaika_ast_Path__Llaika_internal_link_Selector__s_Option($m_Llaika_ast_Path$Root$(), new $c_Llaika_internal_link_PathSelector(path$1)));
    if (this$3.isEmpty__Z()) {
      return $m_s_None$();
    } else {
      var arg1 = this$3.get__O();
      var _$1 = $as_Llaika_internal_link_TargetResolver(arg1);
      return new $c_s_Some($n(_$1).Llaika_internal_link_TargetResolver__f_targetFormats);
    }
  })));
  var value = $n($m_Llaika_ast_RewriteRules$().forBlocks__s_PartialFunction__Llaika_ast_RewriteRules(new $c_Llaika_internal_link_LinkResolver$$anon$1(cursor, this))).$plus$plus__Llaika_ast_RewriteRules__Llaika_ast_RewriteRules($m_Llaika_ast_RewriteRules$().forSpans__s_PartialFunction__Llaika_ast_RewriteRules(new $c_Llaika_internal_link_LinkResolver$$anon$2(cursor, validator, this)));
  return new $c_s_util_Right(value);
});
$c_Llaika_internal_link_LinkResolver.prototype.apply__O__O = (function(v1) {
  return this.apply__Llaika_ast_DocumentCursor__s_util_Either($as_Llaika_ast_DocumentCursor(v1));
});
$c_Llaika_internal_link_LinkResolver.prototype.laika$internal$link$LinkResolver$$_$replaceBlock$1__Llaika_ast_DocumentCursor__Llaika_ast_Block__Llaika_internal_link_Selector__Llaika_ast_RewriteAction = (function(cursor$10, block, selector) {
  var x1 = $p_Llaika_internal_link_LinkResolver__replace$1__Llaika_ast_DocumentCursor__Llaika_ast_Element__Llaika_internal_link_Selector__s_Option(this, cursor$10, $as_Llaika_ast_Element(block), selector);
  if ((x1 instanceof $c_s_Some)) {
    var x3 = $as_Llaika_ast_Element($n($as_s_Some(x1)).s_Some__f_value);
    if ($is_Llaika_ast_Block(x3)) {
      var b = $as_Llaika_ast_Block(x3);
      return new $c_Llaika_ast_RewriteAction$Replace(b);
    }
  }
  var \u03b41$ = $m_Llaika_ast_InvalidBlock$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidBlock($ps_Llaika_internal_link_LinkResolver__describeUnknownTarget$1__Llaika_ast_Element__T($as_Llaika_ast_Element(block)), $m_Llaika_parse_SourceCursor$Generated$());
  var fallback$1 = $as_Llaika_ast_Block($n($as_Llaika_ast_Element(block)).withoutId__Llaika_ast_Element());
  var this$2 = $n(\u03b41$);
  var message$1 = this$2.Llaika_ast_InvalidBlock__f_message;
  var this$3 = $n(\u03b41$);
  var source$1 = this$3.Llaika_ast_InvalidBlock__f_source;
  var this$4 = $n(\u03b41$);
  var options$1 = this$4.Llaika_ast_InvalidBlock__f_options;
  $n(\u03b41$);
  var newValue = new $c_Llaika_ast_InvalidBlock(message$1, source$1, fallback$1, options$1);
  return new $c_Llaika_ast_RewriteAction$Replace(newValue);
});
$c_Llaika_internal_link_LinkResolver.prototype.laika$internal$link$LinkResolver$$_$replaceSpan$1__Llaika_ast_DocumentCursor__Llaika_ast_Span__Llaika_internal_link_Selector__Llaika_ast_RewriteAction = (function(cursor$11, span, selector) {
  var x5 = $p_Llaika_internal_link_LinkResolver__replace$1__Llaika_ast_DocumentCursor__Llaika_ast_Element__Llaika_internal_link_Selector__s_Option(this, cursor$11, $as_Llaika_ast_Element(span), selector);
  if ((x5 instanceof $c_s_Some)) {
    var x7 = $as_Llaika_ast_Element($n($as_s_Some(x5)).s_Some__f_value);
    if ($is_Llaika_ast_Span(x7)) {
      var b = $as_Llaika_ast_Span(x7);
      return new $c_Llaika_ast_RewriteAction$Replace(b);
    }
  }
  var \u03b42$ = $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan($ps_Llaika_internal_link_LinkResolver__describeUnknownTarget$1__Llaika_ast_Element__T($as_Llaika_ast_Element(span)), $m_Llaika_parse_SourceCursor$Generated$());
  var fallback$2 = $as_Llaika_ast_Span($n($as_Llaika_ast_Element(span)).withoutId__Llaika_ast_Element());
  var this$2 = $n(\u03b42$);
  var message$2 = this$2.Llaika_ast_InvalidSpan__f_message;
  var this$3 = $n(\u03b42$);
  var source$2 = this$3.Llaika_ast_InvalidSpan__f_source;
  var this$4 = $n(\u03b42$);
  var options$2 = this$4.Llaika_ast_InvalidSpan__f_options;
  $n(\u03b42$);
  var newValue = new $c_Llaika_ast_InvalidSpan(message$2, source$2, fallback$2, options$2);
  return new $c_Llaika_ast_RewriteAction$Replace(newValue);
});
$c_Llaika_internal_link_LinkResolver.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__Llaika_ast_DocumentCursor__s_util_Either($as_Llaika_ast_DocumentCursor(v1)));
});
var $d_Llaika_internal_link_LinkResolver = new $TypeData().initClass($c_Llaika_internal_link_LinkResolver, "laika.internal.link.LinkResolver", ({
  Llaika_internal_link_LinkResolver: 1,
  F1: 1
}));
function $f_Llaika_internal_link_SequenceSelector__$init$__V($thiz) {
  $thiz.laika$internal$link$SequenceSelector$_setter_$global_$eq__Z__V(false);
  $thiz.laika$internal$link$SequenceSelector$_setter_$unique_$eq__Z__V(false);
}
function $p_Llaika_internal_link_TargetLookup__docLookup__sci_Map($thiz) {
  if ((!$thiz.Llaika_internal_link_TargetLookup__f_docLookupbitmap$1)) {
    var $x_1 = $as_sc_IterableOnceOps($n($n($n($thiz.Llaika_internal_link_TargetLookup__f_cursor).Llaika_ast_RootCursor__f_target).allDocuments__sci_Seq()).map__F1__O(new $c_sjsr_AnonFunction1(((doc) => {
      var doc$1 = $as_Llaika_ast_Document(doc);
      var this$1 = $n($n(doc$1).path__Llaika_ast_Path());
      var _1 = $f_Llaika_ast_GenericPath__withoutFragment__Llaika_ast_GenericPath(this$1);
      var _2 = new $c_Llaika_internal_link_TargetLookup$DocumentLookup($n(doc$1).Llaika_ast_Document__f_content, $n(doc$1).config__Llaika_api_config_Config());
      return new $c_T2(_1, _2);
    }))));
    var this$3 = $m_s_$less$colon$less$();
    $thiz.Llaika_internal_link_TargetLookup__f_docLookup$lzy1 = $n($x_1).toMap__s_$less$colon$less__sci_Map(this$3.s_$less$colon$less$__f_singleton);
    $thiz.Llaika_internal_link_TargetLookup__f_docLookupbitmap$1 = true;
  }
  return $thiz.Llaika_internal_link_TargetLookup__f_docLookup$lzy1;
}
function $p_Llaika_internal_link_TargetLookup__staticLookup__sci_Map($thiz) {
  if ((!$thiz.Llaika_internal_link_TargetLookup__f_staticLookupbitmap$1)) {
    var $x_1 = $as_sc_IterableOnceOps($n($n($n($thiz.Llaika_internal_link_TargetLookup__f_cursor).Llaika_ast_RootCursor__f_target).Llaika_ast_DocumentTreeRoot__f_staticDocuments).map__F1__O(new $c_sjsr_AnonFunction1(((doc) => {
      var doc$1 = $as_Llaika_ast_StaticDocument(doc);
      var _1 = $n(doc$1).path__Llaika_ast_Path();
      var _2 = $n(doc$1).formats__Llaika_config_TargetFormats();
      return new $c_T2(_1, _2);
    }))));
    var this$2 = $m_s_$less$colon$less$();
    $thiz.Llaika_internal_link_TargetLookup__f_staticLookup$lzy1 = $n($x_1).toMap__s_$less$colon$less__sci_Map(this$2.s_$less$colon$less$__f_singleton);
    $thiz.Llaika_internal_link_TargetLookup__f_staticLookupbitmap$1 = true;
  }
  return $thiz.Llaika_internal_link_TargetLookup__f_staticLookup$lzy1;
}
/** @constructor */
function $c_Llaika_internal_link_TargetLookup(cursor) {
  this.Llaika_internal_link_TargetLookup__f_cursor = null;
  this.Llaika_internal_link_TargetLookup__f_docLookup$lzy1 = null;
  this.Llaika_internal_link_TargetLookup__f_docLookupbitmap$1 = false;
  this.Llaika_internal_link_TargetLookup__f_staticLookup$lzy1 = null;
  this.Llaika_internal_link_TargetLookup__f_staticLookupbitmap$1 = false;
  this.Llaika_internal_link_TargetLookup__f_cursor = cursor;
}
$c_Llaika_internal_link_TargetLookup.prototype = new $h_O();
$c_Llaika_internal_link_TargetLookup.prototype.constructor = $c_Llaika_internal_link_TargetLookup;
/** @constructor */
function $h_Llaika_internal_link_TargetLookup() {
}
$h_Llaika_internal_link_TargetLookup.prototype = $c_Llaika_internal_link_TargetLookup.prototype;
$c_Llaika_internal_link_TargetLookup.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_Llaika_internal_link_TargetLookup.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_Llaika_internal_link_TargetLookup.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Llaika_internal_link_TargetLookup.prototype.apply__Llaika_ast_Path__s_Option = (function(path) {
  var $x_1 = $p_Llaika_internal_link_TargetLookup__docLookup__sci_Map(this);
  var this$1 = $n(path);
  var this$2 = $n($n($x_1).get__O__s_Option($f_Llaika_ast_GenericPath__withoutFragment__Llaika_ast_GenericPath(this$1)));
  if (this$2.isEmpty__Z()) {
    var $x_2 = $m_s_None$();
  } else {
    var arg1 = this$2.get__O();
    var lookup = $as_Llaika_internal_link_TargetLookup$DocumentLookup(arg1);
    if ($n(lookup).hasTarget__Llaika_ast_Path__Z(path)) {
      var value = $n(lookup).formats__Llaika_config_TargetFormats();
      var $x_2 = new $c_s_Some(value);
    } else {
      var $x_2 = $m_s_None$();
    }
  }
  var this$4 = $n($x_2);
  return (this$4.isEmpty__Z() ? $n($p_Llaika_internal_link_TargetLookup__staticLookup__sci_Map(this)).get__O__s_Option(path) : this$4);
});
$c_Llaika_internal_link_TargetLookup.prototype.apply__O__O = (function(v1) {
  return this.apply__Llaika_ast_Path__s_Option($as_Llaika_ast_Path(v1));
});
$c_Llaika_internal_link_TargetLookup.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__Llaika_ast_Path__s_Option($as_Llaika_ast_Path(v1)));
});
var $d_Llaika_internal_link_TargetLookup = new $TypeData().initClass($c_Llaika_internal_link_TargetLookup, "laika.internal.link.TargetLookup", ({
  Llaika_internal_link_TargetLookup: 1,
  F1: 1
}));
/** @constructor */
function $c_Llaika_internal_link_TargetResolver$$anon$2(selector$1, targetFormats$1, precedence$1, referenceResolver$2, targetResolver$1, outer) {
  this.Llaika_internal_link_TargetResolver__f_selector = null;
  this.Llaika_internal_link_TargetResolver__f_targetFormats = null;
  this.Llaika_internal_link_TargetResolver__f_precedence = 0;
  this.Llaika_internal_link_TargetResolver$$anon$2__f_referenceResolver$3 = null;
  this.Llaika_internal_link_TargetResolver$$anon$2__f_targetResolver$2 = null;
  this.Llaika_internal_link_TargetResolver$$anon$2__f_referenceResolver$3 = referenceResolver$2;
  this.Llaika_internal_link_TargetResolver$$anon$2__f_targetResolver$2 = targetResolver$1;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Llaika_internal_link_TargetResolver__Llaika_internal_link_Selector__Llaika_config_TargetFormats__I__(this, selector$1, targetFormats$1, precedence$1);
}
$c_Llaika_internal_link_TargetResolver$$anon$2.prototype = new $h_Llaika_internal_link_TargetResolver();
$c_Llaika_internal_link_TargetResolver$$anon$2.prototype.constructor = $c_Llaika_internal_link_TargetResolver$$anon$2;
/** @constructor */
function $h_Llaika_internal_link_TargetResolver$$anon$2() {
}
$h_Llaika_internal_link_TargetResolver$$anon$2.prototype = $c_Llaika_internal_link_TargetResolver$$anon$2.prototype;
$c_Llaika_internal_link_TargetResolver$$anon$2.prototype.resolveReference__Llaika_internal_link_LinkSource__s_Option = (function(linkSource) {
  return $as_s_Option($n(this.Llaika_internal_link_TargetResolver$$anon$2__f_referenceResolver$3).apply__O__O(linkSource));
});
$c_Llaika_internal_link_TargetResolver$$anon$2.prototype.replaceTarget__Llaika_ast_Element__s_Option = (function(rewrittenOriginal) {
  if ($is_Llaika_ast_Block(rewrittenOriginal)) {
    var b = $as_Llaika_ast_Block(rewrittenOriginal);
    return $as_s_Option($n(this.Llaika_internal_link_TargetResolver$$anon$2__f_targetResolver$2).apply__O__O(b));
  } else {
    return $m_s_None$();
  }
});
var $d_Llaika_internal_link_TargetResolver$$anon$2 = new $TypeData().initClass($c_Llaika_internal_link_TargetResolver$$anon$2, "laika.internal.link.TargetResolver$$anon$2", ({
  Llaika_internal_link_TargetResolver$$anon$2: 1,
  Llaika_internal_link_TargetResolver: 1
}));
/** @constructor */
function $c_Llaika_internal_link_TargetResolver$$anon$3(idSelector$1, targetFormats$2, referenceResolver$4, outer) {
  this.Llaika_internal_link_TargetResolver__f_selector = null;
  this.Llaika_internal_link_TargetResolver__f_targetFormats = null;
  this.Llaika_internal_link_TargetResolver__f_precedence = 0;
  this.Llaika_internal_link_TargetResolver$$anon$3__f_referenceResolver$5 = null;
  this.Llaika_internal_link_TargetResolver$$anon$3__f_idSelector$2 = null;
  this.Llaika_internal_link_TargetResolver$$anon$3__f_referenceResolver$5 = referenceResolver$4;
  this.Llaika_internal_link_TargetResolver$$anon$3__f_idSelector$2 = idSelector$1;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Llaika_internal_link_TargetResolver__Llaika_internal_link_Selector__Llaika_config_TargetFormats__I__(this, idSelector$1, targetFormats$2, 0);
}
$c_Llaika_internal_link_TargetResolver$$anon$3.prototype = new $h_Llaika_internal_link_TargetResolver();
$c_Llaika_internal_link_TargetResolver$$anon$3.prototype.constructor = $c_Llaika_internal_link_TargetResolver$$anon$3;
/** @constructor */
function $h_Llaika_internal_link_TargetResolver$$anon$3() {
}
$h_Llaika_internal_link_TargetResolver$$anon$3.prototype = $c_Llaika_internal_link_TargetResolver$$anon$3.prototype;
$c_Llaika_internal_link_TargetResolver$$anon$3.prototype.resolveReference__Llaika_internal_link_LinkSource__s_Option = (function(linkSource) {
  return $as_s_Option($n(this.Llaika_internal_link_TargetResolver$$anon$3__f_referenceResolver$5).apply__O__O(linkSource));
});
$c_Llaika_internal_link_TargetResolver$$anon$3.prototype.replaceTarget__Llaika_ast_Element__s_Option = (function(rewrittenOriginal) {
  if ($is_Llaika_ast_Span(rewrittenOriginal)) {
    var s = $as_Llaika_ast_Span(rewrittenOriginal);
    var value = $n($as_Llaika_ast_Element(s)).withId__T__Llaika_ast_Element($n(this.Llaika_internal_link_TargetResolver$$anon$3__f_idSelector$2).Llaika_internal_link_TargetIdSelector__f_id);
    return new $c_s_Some(value);
  } else {
    return $m_s_None$();
  }
});
var $d_Llaika_internal_link_TargetResolver$$anon$3 = new $TypeData().initClass($c_Llaika_internal_link_TargetResolver$$anon$3, "laika.internal.link.TargetResolver$$anon$3", ({
  Llaika_internal_link_TargetResolver$$anon$3: 1,
  Llaika_internal_link_TargetResolver: 1
}));
/** @constructor */
function $c_Llaika_internal_link_TargetResolver$$anon$4(selector$2, msg$1, outer) {
  this.Llaika_internal_link_TargetResolver__f_selector = null;
  this.Llaika_internal_link_TargetResolver__f_targetFormats = null;
  this.Llaika_internal_link_TargetResolver__f_precedence = 0;
  this.Llaika_internal_link_TargetResolver$$anon$4__f_sysMsg = null;
  this.Llaika_internal_link_TargetResolver$$anon$4__f_resolver = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Llaika_internal_link_TargetResolver__Llaika_internal_link_Selector__Llaika_config_TargetFormats__I__(this, selector$2, $m_Llaika_config_TargetFormats$All$(), 0);
  var level = $m_Llaika_ast_MessageLevel$Error$();
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  this.Llaika_internal_link_TargetResolver$$anon$4__f_sysMsg = new $c_Llaika_ast_RuntimeMessage(level, msg$1, options);
  var f = new $c_Llaika_internal_link_TargetResolver$$anon$5(msg$1, this);
  this.Llaika_internal_link_TargetResolver$$anon$4__f_resolver = new $c_s_PartialFunction$Lifted(f);
}
$c_Llaika_internal_link_TargetResolver$$anon$4.prototype = new $h_Llaika_internal_link_TargetResolver();
$c_Llaika_internal_link_TargetResolver$$anon$4.prototype.constructor = $c_Llaika_internal_link_TargetResolver$$anon$4;
/** @constructor */
function $h_Llaika_internal_link_TargetResolver$$anon$4() {
}
$h_Llaika_internal_link_TargetResolver$$anon$4.prototype = $c_Llaika_internal_link_TargetResolver$$anon$4.prototype;
$c_Llaika_internal_link_TargetResolver$$anon$4.prototype.resolveReference__Llaika_internal_link_LinkSource__s_Option = (function(linkSource) {
  return $as_s_Option($n(this.Llaika_internal_link_TargetResolver$$anon$4__f_resolver).apply__O__O(linkSource));
});
$c_Llaika_internal_link_TargetResolver$$anon$4.prototype.replaceTarget__Llaika_ast_Element__s_Option = (function(rewrittenOriginal) {
  if ($is_Llaika_ast_Block(rewrittenOriginal)) {
    var b = $as_Llaika_ast_Block(rewrittenOriginal);
    var message = this.Llaika_internal_link_TargetResolver$$anon$4__f_sysMsg;
    var source = $m_Llaika_parse_SourceCursor$Generated$();
    var fallback = $as_Llaika_ast_Block($n($as_Llaika_ast_Element(b)).withoutId__Llaika_ast_Element());
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var value = new $c_Llaika_ast_InvalidBlock(message, source, fallback, options);
    return new $c_s_Some(value);
  } else if ($is_Llaika_ast_Span(rewrittenOriginal)) {
    var s = $as_Llaika_ast_Span(rewrittenOriginal);
    var message$1 = this.Llaika_internal_link_TargetResolver$$anon$4__f_sysMsg;
    var source$1 = $m_Llaika_parse_SourceCursor$Generated$();
    var fallback$1 = $as_Llaika_ast_Span($n($as_Llaika_ast_Element(s)).withoutId__Llaika_ast_Element());
    var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var value$1 = new $c_Llaika_ast_InvalidSpan(message$1, source$1, fallback$1, options$1);
    return new $c_s_Some(value$1);
  } else {
    return $m_s_None$();
  }
});
var $d_Llaika_internal_link_TargetResolver$$anon$4 = new $TypeData().initClass($c_Llaika_internal_link_TargetResolver$$anon$4, "laika.internal.link.TargetResolver$$anon$4", ({
  Llaika_internal_link_TargetResolver$$anon$4: 1,
  Llaika_internal_link_TargetResolver: 1
}));
/** @constructor */
function $c_Llaika_internal_link_TargetResolver$$anon$6(uniqueSelector$1, targets$1, isDocScope$1, path$1, outer) {
  this.Llaika_internal_link_TargetResolver__f_selector = null;
  this.Llaika_internal_link_TargetResolver__f_targetFormats = null;
  this.Llaika_internal_link_TargetResolver__f_precedence = 0;
  this.Llaika_internal_link_TargetResolver$$anon$6__f_sorted = null;
  this.Llaika_internal_link_TargetResolver$$anon$6__f_resolver = null;
  this.Llaika_internal_link_TargetResolver$$anon$6__f_indexed = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Llaika_internal_link_TargetResolver__Llaika_internal_link_Selector__Llaika_config_TargetFormats__I__(this, uniqueSelector$1, $m_Llaika_config_TargetFormats$All$(), 0);
  var this$2 = $n(targets$1);
  var f = new $c_sjsr_AnonFunction1(((_$1) => {
    var _$1$1 = $as_Llaika_internal_link_TargetResolver(_$1);
    return $n(_$1$1).Llaika_internal_link_TargetResolver__f_precedence;
  }));
  var ord = $m_s_math_Ordering$Int$();
  this.Llaika_internal_link_TargetResolver$$anon$6__f_sorted = $as_sci_Seq($n($as_sc_SeqOps($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$2, f, ord))).reverse__O());
  matchResult15$1: {
    var $x_1;
    var x65 = $as_sci_Seq($n(this.Llaika_internal_link_TargetResolver$$anon$6__f_sorted).takeWhile__F1__O(new $c_sjsr_AnonFunction1(((_$2) => {
      var _$2$1 = $as_Llaika_internal_link_TargetResolver(_$2);
      return ($n(_$2$1).Llaika_internal_link_TargetResolver__f_precedence === $n($as_Llaika_internal_link_TargetResolver($n(this.Llaika_internal_link_TargetResolver$$anon$6__f_sorted).head__O())).Llaika_internal_link_TargetResolver__f_precedence);
    }))));
    if ((x65 !== null)) {
      if (($n(x65).lengthCompare__I__I(1) === 0)) {
        var x67 = $as_Llaika_internal_link_TargetResolver($n(x65).apply__I__O(0));
        if ((!isDocScope$1)) {
          var $x_1 = new $c_sjsr_AnonFunction1(((linkSource) => {
            var linkSource$1 = $as_Llaika_internal_link_LinkSource(linkSource);
            return $n(x67).resolveReference__Llaika_internal_link_LinkSource__s_Option(linkSource$1);
          }));
          break matchResult15$1;
        }
      }
    }
    var f$1 = new $c_Llaika_internal_link_TargetResolver$$anon$7(uniqueSelector$1, path$1, this);
    var $x_1 = new $c_s_PartialFunction$Lifted(f$1);
  }
  this.Llaika_internal_link_TargetResolver$$anon$6__f_resolver = $x_1;
  this.Llaika_internal_link_TargetResolver$$anon$6__f_indexed = $n($as_sc_IterableOnce($n(targets$1).zipWithIndex__O())).iterator__sc_Iterator();
}
$c_Llaika_internal_link_TargetResolver$$anon$6.prototype = new $h_Llaika_internal_link_TargetResolver();
$c_Llaika_internal_link_TargetResolver$$anon$6.prototype.constructor = $c_Llaika_internal_link_TargetResolver$$anon$6;
/** @constructor */
function $h_Llaika_internal_link_TargetResolver$$anon$6() {
}
$h_Llaika_internal_link_TargetResolver$$anon$6.prototype = $c_Llaika_internal_link_TargetResolver$$anon$6.prototype;
$c_Llaika_internal_link_TargetResolver$$anon$6.prototype.resolveReference__Llaika_internal_link_LinkSource__s_Option = (function(linkSource) {
  return $as_s_Option($n(this.Llaika_internal_link_TargetResolver$$anon$6__f_resolver).apply__O__O(linkSource));
});
$c_Llaika_internal_link_TargetResolver$$anon$6.prototype.nextOption__s_Option = (function() {
  if ($n(this.Llaika_internal_link_TargetResolver$$anon$6__f_indexed).hasNext__Z()) {
    var value = $n(this.Llaika_internal_link_TargetResolver$$anon$6__f_indexed).next__O();
    return new $c_s_Some(value);
  } else {
    return $m_s_None$();
  }
});
$c_Llaika_internal_link_TargetResolver$$anon$6.prototype.replaceTarget__Llaika_ast_Element__s_Option = (function(rewrittenOriginal) {
  var this$1 = $n(this.nextOption__s_Option());
  if (this$1.isEmpty__Z()) {
    return $m_s_None$();
  } else {
    var arg1 = this$1.get__O();
    var x$1 = $as_T2(arg1);
    if ((x$1 !== null)) {
      var target = $as_Llaika_internal_link_TargetResolver($n(x$1)._1__O());
      var index = $uI($n(x$1)._2__O());
      var this$2 = $n($n(target).replaceTarget__Llaika_ast_Element__s_Option(rewrittenOriginal));
      if (this$2.isEmpty__Z()) {
        return $m_s_None$();
      } else {
        var arg1$1 = this$2.get__O();
        var targetBase = $as_Llaika_ast_Element(arg1$1);
        matchResult16: {
          var $x_1;
          var x68 = $n($n(targetBase).options__Llaika_ast_Options()).Llaika_ast_Options$Impl__f_id;
          if ((x68 instanceof $c_s_Some)) {
            var id = $as_T($n($as_s_Some(x68)).s_Some__f_value);
            var $x_1 = $n(targetBase).withId__T__Llaika_ast_Element(((id + "-") + ((1 + index) | 0)));
            break matchResult16;
          }
          var x = $m_s_None$();
          if ((x === x68)) {
            var $x_1 = targetBase;
            break matchResult16;
          }
          throw new $c_s_MatchError(x68);
        }
        return new $c_s_Some($x_1);
      }
    }
    throw new $c_s_MatchError(x$1);
  }
});
var $d_Llaika_internal_link_TargetResolver$$anon$6 = new $TypeData().initClass($c_Llaika_internal_link_TargetResolver$$anon$6, "laika.internal.link.TargetResolver$$anon$6", ({
  Llaika_internal_link_TargetResolver$$anon$6: 1,
  Llaika_internal_link_TargetResolver: 1
}));
/** @constructor */
function $c_Llaika_internal_link_TargetResolver$$anon$8(selector$3, delegate$1, outer) {
  this.Llaika_internal_link_TargetResolver__f_selector = null;
  this.Llaika_internal_link_TargetResolver__f_targetFormats = null;
  this.Llaika_internal_link_TargetResolver__f_precedence = 0;
  this.Llaika_internal_link_TargetResolver$$anon$8__f_delegate$2 = null;
  this.Llaika_internal_link_TargetResolver$$anon$8__f_delegate$2 = delegate$1;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Llaika_internal_link_TargetResolver__Llaika_internal_link_Selector__Llaika_config_TargetFormats__I__(this, selector$3, $n(delegate$1).Llaika_internal_link_TargetResolver__f_targetFormats, 0);
}
$c_Llaika_internal_link_TargetResolver$$anon$8.prototype = new $h_Llaika_internal_link_TargetResolver();
$c_Llaika_internal_link_TargetResolver$$anon$8.prototype.constructor = $c_Llaika_internal_link_TargetResolver$$anon$8;
/** @constructor */
function $h_Llaika_internal_link_TargetResolver$$anon$8() {
}
$h_Llaika_internal_link_TargetResolver$$anon$8.prototype = $c_Llaika_internal_link_TargetResolver$$anon$8.prototype;
$c_Llaika_internal_link_TargetResolver$$anon$8.prototype.resolveReference__Llaika_internal_link_LinkSource__s_Option = (function(linkSource) {
  return $n(this.Llaika_internal_link_TargetResolver$$anon$8__f_delegate$2).resolveReference__Llaika_internal_link_LinkSource__s_Option(linkSource);
});
$c_Llaika_internal_link_TargetResolver$$anon$8.prototype.replaceTarget__Llaika_ast_Element__s_Option = (function(rewrittenOriginal) {
  return $n(this.Llaika_internal_link_TargetResolver$$anon$8__f_delegate$2).replaceTarget__Llaika_ast_Element__s_Option(rewrittenOriginal);
});
var $d_Llaika_internal_link_TargetResolver$$anon$8 = new $TypeData().initClass($c_Llaika_internal_link_TargetResolver$$anon$8, "laika.internal.link.TargetResolver$$anon$8", ({
  Llaika_internal_link_TargetResolver$$anon$8: 1,
  Llaika_internal_link_TargetResolver: 1
}));
function $f_Llaika_internal_link_UniqueSelector__$init$__V($thiz) {
  $thiz.laika$internal$link$UniqueSelector$_setter_$global_$eq__Z__V(true);
  $thiz.laika$internal$link$UniqueSelector$_setter_$unique_$eq__Z__V(true);
}
function $is_Llaika_internal_link_UniqueSelector(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_internal_link_UniqueSelector)));
}
function $as_Llaika_internal_link_UniqueSelector(obj) {
  return (($is_Llaika_internal_link_UniqueSelector(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.link.UniqueSelector"));
}
function $isArrayOf_Llaika_internal_link_UniqueSelector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_link_UniqueSelector)));
}
function $asArrayOf_Llaika_internal_link_UniqueSelector(obj, depth) {
  return (($isArrayOf_Llaika_internal_link_UniqueSelector(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.link.UniqueSelector;", depth));
}
/** @constructor */
function $c_Llaika_internal_markdown_bundle_VerbatimHTML$() {
  this.Llaika_internal_markdown_bundle_VerbatimHTML$__f_origin = null;
  this.Llaika_internal_markdown_bundle_VerbatimHTML$__f_renderOverrides = null;
  $n_Llaika_internal_markdown_bundle_VerbatimHTML$ = this;
  this.Llaika_internal_markdown_bundle_VerbatimHTML$__f_origin = $m_Llaika_api_bundle_BundleOrigin$Parser$();
  this.Llaika_internal_markdown_bundle_VerbatimHTML$__f_renderOverrides = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_format_RenderFormat$Overrides.getArrayOf().constr)([$n($m_Llaika_format_HTML$().Overrides__Llaika_api_format_RenderFormat$Overrides$()).apply__s_PartialFunction__Llaika_api_format_RenderFormat$Overrides($m_Llaika_internal_markdown_bundle_HTMLRenderer$().Llaika_internal_markdown_bundle_HTMLRenderer$__f_custom)]))));
}
$c_Llaika_internal_markdown_bundle_VerbatimHTML$.prototype = new $h_O();
$c_Llaika_internal_markdown_bundle_VerbatimHTML$.prototype.constructor = $c_Llaika_internal_markdown_bundle_VerbatimHTML$;
/** @constructor */
function $h_Llaika_internal_markdown_bundle_VerbatimHTML$() {
}
$h_Llaika_internal_markdown_bundle_VerbatimHTML$.prototype = $c_Llaika_internal_markdown_bundle_VerbatimHTML$.prototype;
$c_Llaika_internal_markdown_bundle_VerbatimHTML$.prototype.baseConfig__Llaika_api_config_Config = (function() {
  return $m_Llaika_api_config_Config$().Llaika_api_config_Config$__f_empty;
});
$c_Llaika_internal_markdown_bundle_VerbatimHTML$.prototype.slugBuilder__s_Option = (function() {
  return $m_s_None$();
});
$c_Llaika_internal_markdown_bundle_VerbatimHTML$.prototype.rewriteRules__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf;
});
$c_Llaika_internal_markdown_bundle_VerbatimHTML$.prototype.processExtension__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf;
});
$c_Llaika_internal_markdown_bundle_VerbatimHTML$.prototype.forStrictMode__s_Option = (function() {
  return new $c_s_Some(this);
});
$c_Llaika_internal_markdown_bundle_VerbatimHTML$.prototype.origin__Llaika_api_bundle_BundleOrigin = (function() {
  return this.Llaika_internal_markdown_bundle_VerbatimHTML$__f_origin;
});
$c_Llaika_internal_markdown_bundle_VerbatimHTML$.prototype.rawContentDisabled__s_Option = (function() {
  return $m_s_None$();
});
$c_Llaika_internal_markdown_bundle_VerbatimHTML$.prototype.parsers__Llaika_api_bundle_ParserBundle = (function() {
  return new $c_Llaika_api_bundle_ParserBundle($as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_bundle_BlockParserBuilder.getArrayOf().constr)([$m_Llaika_internal_markdown_HTMLParsers$().htmlBlockFragment__Llaika_api_bundle_BlockParserBuilder()])))), $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_bundle_SpanParserBuilder.getArrayOf().constr)([$m_Llaika_internal_markdown_HTMLParsers$().Llaika_internal_markdown_HTMLParsers$__f_htmlSpan, $m_Llaika_internal_markdown_HTMLParsers$().Llaika_internal_markdown_HTMLParsers$__f_htmlCharRef])))), $m_sci_Nil$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
});
$c_Llaika_internal_markdown_bundle_VerbatimHTML$.prototype.renderOverrides__sci_Seq = (function() {
  return this.Llaika_internal_markdown_bundle_VerbatimHTML$__f_renderOverrides;
});
var $d_Llaika_internal_markdown_bundle_VerbatimHTML$ = new $TypeData().initClass($c_Llaika_internal_markdown_bundle_VerbatimHTML$, "laika.internal.markdown.bundle.VerbatimHTML$", ({
  Llaika_internal_markdown_bundle_VerbatimHTML$: 1,
  Llaika_api_bundle_ExtensionBundle: 1
}));
var $n_Llaika_internal_markdown_bundle_VerbatimHTML$;
function $m_Llaika_internal_markdown_bundle_VerbatimHTML$() {
  if ((!$n_Llaika_internal_markdown_bundle_VerbatimHTML$)) {
    $n_Llaika_internal_markdown_bundle_VerbatimHTML$ = new $c_Llaika_internal_markdown_bundle_VerbatimHTML$();
  }
  return $n_Llaika_internal_markdown_bundle_VerbatimHTML$;
}
/** @constructor */
function $c_Llaika_internal_nav_SectionBuilder$() {
}
$c_Llaika_internal_nav_SectionBuilder$.prototype = new $h_O();
$c_Llaika_internal_nav_SectionBuilder$.prototype.constructor = $c_Llaika_internal_nav_SectionBuilder$;
/** @constructor */
function $h_Llaika_internal_nav_SectionBuilder$() {
}
$h_Llaika_internal_nav_SectionBuilder$.prototype = $c_Llaika_internal_nav_SectionBuilder$.prototype;
$c_Llaika_internal_nav_SectionBuilder$.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_Llaika_internal_nav_SectionBuilder$.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_Llaika_internal_nav_SectionBuilder$.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Llaika_internal_nav_SectionBuilder$.prototype.apply__Llaika_ast_DocumentCursor__s_util_Either = (function(cursor) {
  var this$1 = $n($n(cursor).Llaika_ast_DocumentCursor__f_config);
  var decoder = $m_Llaika_config_AutonumberConfig$().Llaika_config_AutonumberConfig$__f_decoder;
  var defaultKey = $m_Llaika_config_AutonumberConfig$().Llaika_config_AutonumberConfig$__f_defaultKey;
  var key = $n(defaultKey).Llaika_api_config_DefaultKey$$anon$1__f_value;
  var this$2 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$1, key, decoder));
  if ((this$2 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$2);
    var b = $n(x2).s_util_Right__f_value;
    var _$2 = $as_s_Option(b);
    var this$3 = $n(_$2);
    var $x_1 = new $c_s_util_Right($as_Llaika_config_AutonumberConfig((this$3.isEmpty__Z() ? ($m_Llaika_config_AutonumberConfig$(), new $c_Llaika_config_AutonumberConfig$Impl(false, false, 0)) : this$3.get__O())));
  } else {
    var $x_1 = this$2;
  }
  var this$6 = $n($x_1);
  if ((this$6 instanceof $c_s_util_Right)) {
    var x2$1 = $as_s_util_Right(this$6);
    var b$1 = $n(x2$1).s_util_Right__f_value;
    var autonumbering = $as_Llaika_config_AutonumberConfig(b$1);
    var this$7 = $n($n(cursor).Llaika_ast_DocumentCursor__f_config);
    var key$1 = $m_Llaika_config_LaikaKeys$().Llaika_config_LaikaKeys$__f_firstHeaderAsTitle;
    var decoder$1 = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_boolean;
    var this$8 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$7, key$1, decoder$1));
    if ((this$8 instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(this$8);
      var b$2 = $n(x2$2).s_util_Right__f_value;
      var _$1 = $as_s_Option(b$2);
      var this$9 = $n(_$1);
      if (this$9.isEmpty__Z()) {
        var this$10 = $n($n($n(cursor).Llaika_ast_DocumentCursor__f_config).get__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either($m_Llaika_config_LaikaKeys$().Llaika_config_LaikaKeys$__f_orphan, $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_boolean));
        if ((this$10 instanceof $c_s_util_Right)) {
          var x2$3 = $as_s_util_Right(this$10);
          var b$3 = $n(x2$3).s_util_Right__f_value;
          var $x_4 = b$3;
        } else {
          var $x_4 = false;
        }
        var $x_3 = (!$uZ($x_4));
      } else {
        var $x_3 = this$9.get__O();
      }
      var $x_2 = new $c_s_util_Right($x_3);
    } else {
      var $x_2 = this$8;
    }
    var this$11 = $n($x_2);
    if ((this$11 instanceof $c_s_util_Right)) {
      var x2$4 = $as_s_util_Right(this$11);
      var b$4 = $n(x2$4).s_util_Right__f_value;
      var firstHeaderAsTitle = $uZ(b$4);
      return new $c_s_util_Right(new $c_Llaika_internal_nav_SectionBuilder$DefaultRule(autonumbering, firstHeaderAsTitle, $n(cursor).Llaika_ast_DocumentCursor__f_position).Llaika_internal_nav_SectionBuilder$DefaultRule__f_rewrite);
    } else {
      return this$11;
    }
  } else {
    return this$6;
  }
});
$c_Llaika_internal_nav_SectionBuilder$.prototype.apply__O__O = (function(v1) {
  return this.apply__Llaika_ast_DocumentCursor__s_util_Either($as_Llaika_ast_DocumentCursor(v1));
});
$c_Llaika_internal_nav_SectionBuilder$.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__Llaika_ast_DocumentCursor__s_util_Either($as_Llaika_ast_DocumentCursor(v1)));
});
var $d_Llaika_internal_nav_SectionBuilder$ = new $TypeData().initClass($c_Llaika_internal_nav_SectionBuilder$, "laika.internal.nav.SectionBuilder$", ({
  Llaika_internal_nav_SectionBuilder$: 1,
  F1: 1
}));
var $n_Llaika_internal_nav_SectionBuilder$;
function $m_Llaika_internal_nav_SectionBuilder$() {
  if ((!$n_Llaika_internal_nav_SectionBuilder$)) {
    $n_Llaika_internal_nav_SectionBuilder$ = new $c_Llaika_internal_nav_SectionBuilder$();
  }
  return $n_Llaika_internal_nav_SectionBuilder$;
}
/** @constructor */
function $c_Llaika_internal_parse_hocon_HoconParsers$$anon$1(parser$2, outer) {
  this.Llaika_internal_parse_hocon_HoconParsers$$anon$1__f_parser$1 = null;
  this.Llaika_internal_parse_hocon_HoconParsers$$anon$1__f_p$lzy1 = null;
  this.Llaika_internal_parse_hocon_HoconParsers$$anon$1__f_pbitmap$1 = false;
  this.Llaika_internal_parse_hocon_HoconParsers$$anon$1__f_parser$1 = parser$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_internal_parse_hocon_HoconParsers$$anon$1.prototype = new $h_Llaika_parse_Parser();
$c_Llaika_internal_parse_hocon_HoconParsers$$anon$1.prototype.constructor = $c_Llaika_internal_parse_hocon_HoconParsers$$anon$1;
/** @constructor */
function $h_Llaika_internal_parse_hocon_HoconParsers$$anon$1() {
}
$h_Llaika_internal_parse_hocon_HoconParsers$$anon$1.prototype = $c_Llaika_internal_parse_hocon_HoconParsers$$anon$1.prototype;
$c_Llaika_internal_parse_hocon_HoconParsers$$anon$1.prototype.p__Llaika_parse_Parser = (function() {
  if ((!this.Llaika_internal_parse_hocon_HoconParsers$$anon$1__f_pbitmap$1)) {
    this.Llaika_internal_parse_hocon_HoconParsers$$anon$1__f_p$lzy1 = $as_Llaika_parse_Parser($n(this.Llaika_internal_parse_hocon_HoconParsers$$anon$1__f_parser$1).apply__O());
    this.Llaika_internal_parse_hocon_HoconParsers$$anon$1__f_pbitmap$1 = true;
  }
  return this.Llaika_internal_parse_hocon_HoconParsers$$anon$1__f_p$lzy1;
});
$c_Llaika_internal_parse_hocon_HoconParsers$$anon$1.prototype.parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed = (function(in$1) {
  return $n(this.p__Llaika_parse_Parser()).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(in$1);
});
var $d_Llaika_internal_parse_hocon_HoconParsers$$anon$1 = new $TypeData().initClass($c_Llaika_internal_parse_hocon_HoconParsers$$anon$1, "laika.internal.parse.hocon.HoconParsers$$anon$1", ({
  Llaika_internal_parse_hocon_HoconParsers$$anon$1: 1,
  Llaika_parse_Parser: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_hocon_HoconParsers$$anon$3(error$3) {
  this.Llaika_internal_parse_hocon_HoconParsers$$anon$3__f_error$2 = null;
  this.Llaika_internal_parse_hocon_HoconParsers$$anon$3__f_error$2 = error$3;
}
$c_Llaika_internal_parse_hocon_HoconParsers$$anon$3.prototype = new $h_O();
$c_Llaika_internal_parse_hocon_HoconParsers$$anon$3.prototype.constructor = $c_Llaika_internal_parse_hocon_HoconParsers$$anon$3;
/** @constructor */
function $h_Llaika_internal_parse_hocon_HoconParsers$$anon$3() {
}
$h_Llaika_internal_parse_hocon_HoconParsers$$anon$3.prototype = $c_Llaika_internal_parse_hocon_HoconParsers$$anon$3.prototype;
$c_Llaika_internal_parse_hocon_HoconParsers$$anon$3.prototype.message__Llaika_parse_SourceCursor__T = (function(res) {
  $m_Llaika_internal_parse_hocon_HoconParsers$();
  var error$1 = this.Llaika_internal_parse_hocon_HoconParsers$$anon$3__f_error$2;
  return ("Invalid key: " + $n($n($n(error$1).Llaika_internal_parse_hocon_InvalidStringValue__f_failure).Llaika_parse_Failure__f_msgProvider).message__Llaika_parse_SourceCursor__T(res));
});
var $d_Llaika_internal_parse_hocon_HoconParsers$$anon$3 = new $TypeData().initClass($c_Llaika_internal_parse_hocon_HoconParsers$$anon$3, "laika.internal.parse.hocon.HoconParsers$$anon$3", ({
  Llaika_internal_parse_hocon_HoconParsers$$anon$3: 1,
  Llaika_parse_Message: 1
}));
function $f_Llaika_internal_parse_markup_DefaultEscapedTextParsers__escapeSequence__Llaika_parse_text_PrefixedParser($thiz) {
  return $m_Llaika_parse_syntax$LiteralStringOps$().$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("\\", $thiz.escapedChar__Llaika_parse_Parser());
}
function $f_Llaika_internal_parse_markup_DefaultEscapedTextParsers__escapedText__Llaika_parse_text_DelimitedText__Llaika_parse_Parser($thiz, p) {
  var this$1 = $m_Llaika_parse_markup_InlineParsers$();
  var parser = new $c_sjsr_AnonFunction0((() => p));
  return $as_Llaika_parse_Parser($n($f_Llaika_parse_markup_InlineParsers__text__F0__Llaika_parse_markup_InlineParser(this$1, parser)).embed__F0__Llaika_parse_markup_InlineParser(new $c_sjsr_AnonFunction0((() => $thiz.escapeSequence__Llaika_parse_text_PrefixedParser()))));
}
function $f_Llaika_internal_parse_markup_DefaultEscapedTextParsers__escapedUntil__C__sci_Seq__Llaika_parse_Parser($thiz, char, chars) {
  var this$1 = $m_Llaika_parse_text_TextParsers$();
  var p = $n($f_Llaika_parse_text_TextParsers__delimitedBy__C__sci_Seq__Llaika_parse_text_DelimitedText(this$1, char, chars)).nonEmpty__Llaika_parse_text_DelimitedText();
  return $f_Llaika_internal_parse_markup_DefaultEscapedTextParsers__escapedText__Llaika_parse_text_DelimitedText__Llaika_parse_Parser($thiz, p);
}
/** @constructor */
function $c_Llaika_internal_parse_markup_DefaultRecursiveParsers$$anon$1(outer) {
  this.Llaika_internal_parse_markup_DefaultRecursiveParsers$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_internal_parse_markup_DefaultRecursiveParsers$$anon$1__f_$outer = outer;
}
$c_Llaika_internal_parse_markup_DefaultRecursiveParsers$$anon$1.prototype = new $h_O();
$c_Llaika_internal_parse_markup_DefaultRecursiveParsers$$anon$1.prototype.constructor = $c_Llaika_internal_parse_markup_DefaultRecursiveParsers$$anon$1;
/** @constructor */
function $h_Llaika_internal_parse_markup_DefaultRecursiveParsers$$anon$1() {
}
$h_Llaika_internal_parse_markup_DefaultRecursiveParsers$$anon$1.prototype = $c_Llaika_internal_parse_markup_DefaultRecursiveParsers$$anon$1.prototype;
$c_Llaika_internal_parse_markup_DefaultRecursiveParsers$$anon$1.prototype.parse__Llaika_parse_SourceFragment__Llaika_parse_Parsed = (function(in$1) {
  return $n($n(this.Llaika_internal_parse_markup_DefaultRecursiveParsers$$anon$1__f_$outer).Llaika_internal_parse_markup_RootParser__f_laika$internal$parse$markup$DefaultRecursiveParsers$$recursiveBlockParser).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(in$1);
});
var $d_Llaika_internal_parse_markup_DefaultRecursiveParsers$$anon$1 = new $TypeData().initClass($c_Llaika_internal_parse_markup_DefaultRecursiveParsers$$anon$1, "laika.internal.parse.markup.DefaultRecursiveParsers$$anon$1", ({
  Llaika_internal_parse_markup_DefaultRecursiveParsers$$anon$1: 1,
  Llaika_parse_markup_RecursiveBlockParser: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$RecursiveSpanParserDelegate(outer, delegate) {
  this.Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$RecursiveSpanParserDelegate__f_parser = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  var this$1 = $m_Llaika_parse_combinator_Parsers$();
  this.Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$RecursiveSpanParserDelegate__f_parser = $f_Llaika_parse_combinator_Parsers__consumeAll__Llaika_parse_Parser__Llaika_parse_Parser(this$1, delegate);
}
$c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$RecursiveSpanParserDelegate.prototype = new $h_O();
$c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$RecursiveSpanParserDelegate.prototype.constructor = $c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$RecursiveSpanParserDelegate;
/** @constructor */
function $h_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$RecursiveSpanParserDelegate() {
}
$h_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$RecursiveSpanParserDelegate.prototype = $c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$RecursiveSpanParserDelegate.prototype;
$c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$RecursiveSpanParserDelegate.prototype.parse__Llaika_parse_SourceFragment__Llaika_parse_Parsed = (function(in$1) {
  return $n(this.Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$RecursiveSpanParserDelegate__f_parser).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(in$1);
});
$c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$RecursiveSpanParserDelegate.prototype.parseAndRecover__Llaika_parse_SourceFragment__sci_Seq = (function(in$1) {
  var x13 = $n(this.Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$RecursiveSpanParserDelegate__f_parser).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(in$1);
  if ((x13 instanceof $c_Llaika_parse_Success)) {
    var x$1 = $as_Llaika_parse_Success(x13);
    var this$2 = $n(x$1);
    var x17 = $as_sci_Seq(this$2.Llaika_parse_Success__f_result);
    var this$3 = $n(x$1);
    return x17;
  }
  if ((x13 instanceof $c_Llaika_parse_Failure)) {
    var f = $as_Llaika_parse_Failure(x13);
    var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_InvalidSpan.getArrayOf().constr)([$m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan($n(f).message__T(), in$1)]));
    return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  }
  throw new $c_s_MatchError(x13);
});
var $d_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$RecursiveSpanParserDelegate = new $TypeData().initClass($c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$RecursiveSpanParserDelegate, "laika.internal.parse.markup.DefaultRecursiveSpanParsers$RecursiveSpanParserDelegate", ({
  Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$RecursiveSpanParserDelegate: 1,
  Llaika_parse_markup_RecursiveSpanParser: 1
}));
function $ps_Llaika_internal_parse_markup_InlineDelimiter__nestedDelimiter$1__Llaika_parse_SourceCursor__I__C__Llaika_parse_text_DelimiterResult(source$1, charsConsumed$1, startChar$1) {
  var capturedText = $n(source$1).capture__I__T(charsConsumed$1);
  var result = new $c_Llaika_internal_parse_markup_NestedDelimiter(startChar$1, capturedText);
  var next = $n(source$1).consume__I__Llaika_parse_SourceCursor(charsConsumed$1);
  var result$1 = new $c_Llaika_parse_Success(result, next);
  return new $c_Llaika_parse_text_DelimiterResult$Complete(result$1);
}
/** @constructor */
function $c_Llaika_internal_parse_markup_InlineDelimiter(nestedDelimiters, endDelimiters) {
  this.Llaika_internal_parse_markup_InlineDelimiter__f_nestedDelimiters = null;
  this.Llaika_internal_parse_markup_InlineDelimiter__f_endDelimiters = null;
  this.Llaika_internal_parse_markup_InlineDelimiter__f_startChars = null;
  this.Llaika_internal_parse_markup_InlineDelimiter__f_nestedDelimiters = nestedDelimiters;
  this.Llaika_internal_parse_markup_InlineDelimiter__f_endDelimiters = endDelimiters;
  var this$1 = $n(nestedDelimiters);
  var that = $n(endDelimiters).startChars__sci_Set();
  this.Llaika_internal_parse_markup_InlineDelimiter__f_startChars = $as_sci_Set(this$1.concat__sc_IterableOnce__sc_SetOps(that));
}
$c_Llaika_internal_parse_markup_InlineDelimiter.prototype = new $h_O();
$c_Llaika_internal_parse_markup_InlineDelimiter.prototype.constructor = $c_Llaika_internal_parse_markup_InlineDelimiter;
/** @constructor */
function $h_Llaika_internal_parse_markup_InlineDelimiter() {
}
$h_Llaika_internal_parse_markup_InlineDelimiter.prototype = $c_Llaika_internal_parse_markup_InlineDelimiter.prototype;
$c_Llaika_internal_parse_markup_InlineDelimiter.prototype.startChars__sci_Set = (function() {
  return this.Llaika_internal_parse_markup_InlineDelimiter__f_startChars;
});
$c_Llaika_internal_parse_markup_InlineDelimiter.prototype.atStartChar__C__I__Llaika_parse_SourceCursor__Llaika_parse_text_DelimiterResult = (function(startChar, charsConsumed, source) {
  if ($n($n(this.Llaika_internal_parse_markup_InlineDelimiter__f_endDelimiters).startChars__sci_Set()).contains__O__Z($bC(startChar))) {
    var x1 = $n(this.Llaika_internal_parse_markup_InlineDelimiter__f_endDelimiters).atStartChar__C__I__Llaika_parse_SourceCursor__Llaika_parse_text_DelimiterResult(startChar, charsConsumed, source);
    if ((x1 instanceof $c_Llaika_parse_text_DelimiterResult$Complete)) {
      var x$1 = $as_Llaika_parse_text_DelimiterResult$Complete(x1);
      var this$2 = $n(x$1);
      var x4 = this$2.Llaika_parse_text_DelimiterResult$Complete__f_result;
      if ((x4 !== null)) {
        var result = $n(x4).map__F1__Llaika_parse_Parsed(new $c_sjsr_AnonFunction1(((capturedText) => {
          var capturedText$1 = $as_T(capturedText);
          return new $c_Llaika_internal_parse_markup_EndDelimiter(capturedText$1);
        })));
        return new $c_Llaika_parse_text_DelimiterResult$Complete(result);
      }
    }
    var x = $m_Llaika_parse_text_DelimiterResult$Continue$();
    if ((x === x1)) {
      return ($n(this.Llaika_internal_parse_markup_InlineDelimiter__f_nestedDelimiters).contains__O__Z($bC(startChar)) ? $ps_Llaika_internal_parse_markup_InlineDelimiter__nestedDelimiter$1__Llaika_parse_SourceCursor__I__C__Llaika_parse_text_DelimiterResult(source, charsConsumed, startChar) : $m_Llaika_parse_text_DelimiterResult$Continue$());
    }
    throw new $c_s_MatchError(x1);
  } else {
    return $ps_Llaika_internal_parse_markup_InlineDelimiter__nestedDelimiter$1__Llaika_parse_SourceCursor__I__C__Llaika_parse_text_DelimiterResult(source, charsConsumed, startChar);
  }
});
$c_Llaika_internal_parse_markup_InlineDelimiter.prototype.atEOF__I__Llaika_parse_SourceCursor__Llaika_parse_Parsed = (function(charsConsumed, source) {
  return $n($n(this.Llaika_internal_parse_markup_InlineDelimiter__f_endDelimiters).atEOF__I__Llaika_parse_SourceCursor__Llaika_parse_Parsed(charsConsumed, source)).map__F1__Llaika_parse_Parsed(new $c_sjsr_AnonFunction1(((capturedText) => {
    var capturedText$1 = $as_T(capturedText);
    return new $c_Llaika_internal_parse_markup_EndDelimiter(capturedText$1);
  })));
});
var $d_Llaika_internal_parse_markup_InlineDelimiter = new $TypeData().initClass($c_Llaika_internal_parse_markup_InlineDelimiter, "laika.internal.parse.markup.InlineDelimiter", ({
  Llaika_internal_parse_markup_InlineDelimiter: 1,
  Llaika_parse_text_Delimiter: 1
}));
function $p_Llaika_internal_render_ASTRenderer$__NoRef$lzyINIT1$1__sr_LazyRef__Llaika_internal_render_ASTRenderer$NoRef$2$($thiz, NoRef$lzy1$1) {
  if ((NoRef$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Llaika_internal_render_ASTRenderer$NoRef$2$(($n(NoRef$lzy1$1).sr_LazyRef__f__initialized ? $n(NoRef$lzy1$1).sr_LazyRef__f__value : $n(NoRef$lzy1$1).initialize__O__O(new $c_Llaika_internal_render_ASTRenderer$NoRef$2$())));
}
function $p_Llaika_internal_render_ASTRenderer$__NoRef$1__sr_LazyRef__Llaika_internal_render_ASTRenderer$NoRef$2$($thiz, NoRef$lzy1$2) {
  return $as_Llaika_internal_render_ASTRenderer$NoRef$2$(($n(NoRef$lzy1$2).sr_LazyRef__f__initialized ? $n(NoRef$lzy1$2).sr_LazyRef__f__value : $p_Llaika_internal_render_ASTRenderer$__NoRef$lzyINIT1$1__sr_LazyRef__Llaika_internal_render_ASTRenderer$NoRef$2$($thiz, NoRef$lzy1$2)));
}
function $p_Llaika_internal_render_ASTRenderer$__options$1__Llaika_ast_Options__T($thiz, opt) {
  var $x_3 = $m_sr_ScalaRunTime$();
  var this$1 = $n($n(opt).Llaika_ast_Options$Impl__f_id);
  if (this$1.isEmpty__Z()) {
    var $x_2 = $m_s_None$();
  } else {
    var arg1 = this$1.get__O();
    var _$1 = $as_T(arg1);
    var $x_2 = new $c_s_Some((("Id(" + _$1) + ")"));
  }
  if ($n($n(opt).Llaika_ast_Options$Impl__f_styles).isEmpty__Z()) {
    var $x_1 = $m_s_None$();
  } else {
    var this$2 = $n($n(opt).Llaika_ast_Options$Impl__f_styles);
    var value = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$2, "Styles(", ",", ")");
    var $x_1 = new $c_s_Some(value);
  }
  var elems = $n($x_3).wrapRefArray__AO__sci_ArraySeq(new ($d_s_Option.getArrayOf().constr)([$x_2, $x_1]));
  var this$6 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems));
  var f = ((_$2) => {
    var _$2$1 = $as_s_Option(_$2);
    var this$5 = $n(_$2$1);
    return (!this$5.isEmpty__Z());
  });
  var l = this$6;
  block: {
    var result;
    while (true) {
      if ($n(l).isEmpty__Z()) {
        var result = $m_sci_Nil$();
        break;
      } else {
        var h = $n(l).head__O();
        var t = $as_sci_List($n(l).tail__O());
        if (($uZ(f(h)) === false)) {
          l = t;
          continue;
        }
        var start = l;
        var remaining = t;
        while (true) {
          if ($n(remaining).isEmpty__Z()) {
            var result = start;
            break block;
          } else {
            var x = $n(remaining).head__O();
            if (($uZ(f(x)) !== false)) {
              remaining = $as_sci_List($n(remaining).tail__O());
              continue;
            }
            var firstMiss = remaining;
            var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
            var toProcess = $as_sci_List($n(start).tail__O());
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
              $n(currentLast).sci_$colon$colon__f_next = newElem;
              currentLast = newElem;
              toProcess = $as_sci_List($n(toProcess).tail__O());
            }
            var next = $as_sci_List($n(firstMiss).tail__O());
            var nextToCopy = next;
            while ((!$n(next).isEmpty__Z())) {
              var head = $n(next).head__O();
              if (($uZ(f(head)) !== false)) {
                next = $as_sci_List($n(next).tail__O());
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                  $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = $as_sci_List($n(nextToCopy).tail__O());
                }
                nextToCopy = $as_sci_List($n(next).tail__O());
                next = $as_sci_List($n(next).tail__O());
              }
            }
            if ((!$n(nextToCopy).isEmpty__Z())) {
              $n(currentLast).sci_$colon$colon__f_next = nextToCopy;
            }
            var result = newHead;
            break block;
          }
        }
      }
    }
  }
  var this$7 = $n(result);
  var f$1 = ((_$3) => {
    var _$3$1 = $as_s_Option(_$3);
    return $as_T($n(_$3$1).get__O());
  });
  if ((this$7 === $m_sci_Nil$())) {
    var $x_4 = $m_sci_Nil$();
  } else {
    var arg1$1 = this$7.head__O();
    var h$1 = new $c_sci_$colon$colon(f$1(arg1$1), $m_sci_Nil$());
    var t$1 = h$1;
    var rest = $as_sci_List(this$7.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$2 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f$1(arg1$2), $m_sci_Nil$());
      $n(t$1).sci_$colon$colon__f_next = nx;
      t$1 = nx;
      rest = $as_sci_List($n(rest).tail__O());
    }
    var $x_4 = h$1;
  }
  var this$8 = $n($x_4);
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$8, "", " + ", "");
}
function $p_Llaika_internal_render_ASTRenderer$__prep$1__O__O($thiz, value) {
  if ((value instanceof $c_Llaika_ast_Options)) {
    var opt = $as_Llaika_ast_Options(value);
    return $p_Llaika_internal_render_ASTRenderer$__options$1__Llaika_ast_Options__T($thiz, opt);
  } else if ((value instanceof $c_Llaika_ast_InternalTarget$Resolved)) {
    var t = $as_Llaika_ast_InternalTarget$Resolved(value);
    return (((("InternalTarget(" + $n(t).Llaika_ast_InternalTarget$Resolved__f_relativePath) + ",") + $n(t).Llaika_ast_InternalTarget$Resolved__f_internalFormats) + ")");
  } else {
    return value;
  }
}
function $p_Llaika_internal_render_ASTRenderer$__attributes$1__sc_Iterator__O__T($thiz, attr, exclude) {
  var this$2 = $n(attr);
  var p = new $c_sjsr_AnonFunction1(((_$4) => (!Object.is(_$4, exclude))));
  var this$3 = new $c_sc_Iterator$$anon$6(this$2, p, false);
  var p$1 = new $c_sjsr_AnonFunction1(((_$5) => {
    var x$2 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    return (!((_$5 === null) ? (x$2 === null) : $dp_equals__O__Z($n(_$5), x$2)));
  }));
  var this$4 = new $c_sc_Iterator$$anon$6(this$3, p$1, false);
  var f = new $c_sjsr_AnonFunction1(((value) => $p_Llaika_internal_render_ASTRenderer$__prep$1__O__O($thiz, value)));
  var this$5 = new $c_sc_Iterator$$anon$9(this$4, f);
  var res = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$5, "(", ",", ")");
  return ((res === "()") ? "" : res);
}
function $p_Llaika_internal_render_ASTRenderer$__elementContainerDesc$1__Llaika_api_format_Formatter__Llaika_ast_ElementContainer__T__T($thiz, fmt$1, con, elementType) {
  matchResult5: {
    var \u03b41$___1;
    var \u03b41$___2;
    var this$2 = $n($n($as_s_Product(con)).productIterator__sc_Iterator());
    var p = new $c_sjsr_AnonFunction1(((_$6) => (_$6 instanceof $c_Llaika_ast_Element)));
    var x8 = $f_sc_Iterator__partition__F1__T2(this$2, p);
    if ((x8 !== null)) {
      var elements = $as_sc_Iterator($n(x8)._1__O());
      var rest = $as_sc_Iterator($n(x8)._2__O());
      var \u03b41$___1 = elements;
      var \u03b41$___2 = rest;
      break matchResult5;
    }
    throw new $c_s_MatchError(x8);
  }
  var elements$2 = $as_sc_Iterator(\u03b41$___1);
  var rest$2 = $as_sc_Iterator(\u03b41$___2);
  var $x_1 = $n($as_s_Product(con)).productPrefix__T();
  var this$4 = $n(con);
  var prefix = (("" + $x_1) + $p_Llaika_internal_render_ASTRenderer$__attributes$1__sc_Iterator__O__T($thiz, rest$2, this$4.content__sci_Seq()));
  var this$5 = $n(con);
  var this$6 = $n(this$5.content__sci_Seq()).length__I();
  var contentDesc = (((" - " + elementType) + ": ") + ("" + this$6));
  var this$8 = $n(elements$2);
  if (this$8.hasNext__Z()) {
    var this$9 = $n(elements$2);
    var this$15 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$9));
    var $x_2 = $m_sr_ScalaRunTime$();
    var this$11 = $n(con);
    var content = this$11.content__sci_Seq();
    var desc = ("Content" + contentDesc);
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var elems = $n($x_2).wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_internal_render_ASTRenderer$Content.getArrayOf().constr)([new $c_Llaika_internal_render_ASTRenderer$Content(content, desc, options)]));
    var suffix = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
    return (prefix + $n(fmt$1).indentedChildren__sci_Seq__T(this$15.appendedAll__sc_IterableOnce__sci_List(suffix)));
  } else {
    var this$16 = $n(con);
    return ((prefix + contentDesc) + $n(fmt$1).indentedChildren__sci_Seq__T(this$16.content__sci_Seq()));
  }
}
function $p_Llaika_internal_render_ASTRenderer$__textContainerDesc$1__Llaika_ast_TextContainer__T($thiz, con) {
  if (false) {
    var x$1 = $as_Llaika_ast_CodeSpan(con);
    $n(x$1)._1__T();
    var x15 = $n(x$1)._2__sci_Set();
    $n(x$1)._3__Llaika_ast_Options();
    if ($n(x15).isEmpty__Z()) {
      var props = "";
    } else {
      var this$2 = $n(x15);
      var this$4 = $n($as_sc_IterableOnceOps($n($as_sc_SeqOps($n($m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$2)).map__F1__O(new $c_sjsr_AnonFunction1(((_$7) => {
        var _$7$1 = $as_Llaika_parse_code_CodeCategory(_$7);
        return $n(_$7$1).name__T();
      }))))).sorted__s_math_Ordering__O($m_s_math_Ordering$String$())));
      var props = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$4, "(", ", ", ")");
    }
    var start = (("CodeSpan" + props) + " - '");
  } else {
    var $x_2 = $n($as_s_Product(con)).productPrefix__T();
    var $x_1 = $n($as_s_Product(con)).productIterator__sc_Iterator();
    var this$5 = $n(con);
    var start = ((("" + $x_2) + $p_Llaika_internal_render_ASTRenderer$__attributes$1__sc_Iterator__O__T($thiz, $x_1, this$5.content__T())) + " - '");
  }
  var this$6 = $n(con);
  var this$7 = $n(this$6.content__T());
  var text = $as_T(this$7.split("\n").join("|"));
  var this$8 = $n(text);
  var len = this$8.length;
  if ((len <= 50)) {
    return ((start + text) + "'");
  } else {
    var this$9 = $n(text);
    if ((this$9.length < 25)) {
      $charAt(this$9, 25);
    }
    var $x_3 = $as_T(this$9.substring(0, 25));
    var this$10 = $n(text);
    var beginIndex = (((-25) + len) | 0);
    if (((beginIndex < 0) || (beginIndex > this$10.length))) {
      $charAt(this$10, beginIndex);
    }
    return ((((start + $x_3) + " [...] ") + $as_T(this$10.substring(beginIndex))) + "'");
  }
}
function $p_Llaika_internal_render_ASTRenderer$__renderElement$1__Llaika_api_format_Formatter__sr_LazyRef__Llaika_ast_Element__T($thiz, fmt$2, NoRef$lzy1$3, e) {
  matchResult7: {
    var \u03b42$___1;
    var \u03b42$___2;
    var this$1 = $n(e);
    var this$3 = new $c_s_Product$$anon$1(this$1);
    var p = new $c_sjsr_AnonFunction1(((_$8) => (_$8 instanceof $c_Llaika_ast_Element)));
    var x17 = $f_sc_Iterator__partition__F1__T2(this$3, p);
    if ((x17 !== null)) {
      var elements = $as_sc_Iterator($n(x17)._1__O());
      var rest = $as_sc_Iterator($n(x17)._2__O());
      var \u03b42$___1 = elements;
      var \u03b42$___2 = rest;
      break matchResult7;
    }
    throw new $c_s_MatchError(x17);
  }
  var elements$2 = $as_sc_Iterator(\u03b42$___1);
  var rest$2 = $as_sc_Iterator(\u03b42$___2);
  var $x_2 = $n(e).productPrefix__T();
  var $x_1 = $p_Llaika_internal_render_ASTRenderer$__attributes$1__sc_Iterator__O__T($thiz, rest$2, $p_Llaika_internal_render_ASTRenderer$__NoRef$1__sr_LazyRef__Llaika_internal_render_ASTRenderer$NoRef$2$($thiz, NoRef$lzy1$3));
  var this$5 = $n(elements$2);
  return ((("" + $x_2) + $x_1) + $n(fmt$2).indentedChildren__sci_Seq__T($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$5)));
}
function $p_Llaika_internal_render_ASTRenderer$__lists$1__Llaika_api_format_Formatter__T__sci_Seq__T($thiz, fmt$3, desc, lists) {
  return (("" + desc) + $n(fmt$3).indentedChildren__sci_Seq__T($as_sci_Seq($n(lists).map__F1__O(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var elems = $as_sci_Seq($n(x$1$1)._1__O());
      var d = $as_T($n(x$1$1)._2__O());
      var desc$1 = (("" + d) + $n(elems).length__I());
      var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      return new $c_Llaika_internal_render_ASTRenderer$Content(elems, desc$1, options);
    }
    throw new $c_s_MatchError(x$1$1);
  }))))));
}
/** @constructor */
function $c_Llaika_internal_render_ASTRenderer$() {
  this.Llaika_internal_render_ASTRenderer$__f_maxTextWidth = 0;
  this.Llaika_internal_render_ASTRenderer$__f_maxTextWidth = 50;
}
$c_Llaika_internal_render_ASTRenderer$.prototype = new $h_O();
$c_Llaika_internal_render_ASTRenderer$.prototype.constructor = $c_Llaika_internal_render_ASTRenderer$;
/** @constructor */
function $h_Llaika_internal_render_ASTRenderer$() {
}
$h_Llaika_internal_render_ASTRenderer$.prototype = $c_Llaika_internal_render_ASTRenderer$.prototype;
$c_Llaika_internal_render_ASTRenderer$.prototype.toString__T = (function() {
  return "<function2>";
});
$c_Llaika_internal_render_ASTRenderer$.prototype.apply__Llaika_api_format_Formatter__Llaika_ast_Element__T = (function(fmt, element) {
  var NoRef$lzy1 = new $c_sr_LazyRef();
  if ((element instanceof $c_Llaika_ast_QuotedBlock)) {
    var x$1 = $as_Llaika_ast_QuotedBlock(element);
    var this$2 = $n(x$1);
    var x45 = this$2.Llaika_ast_QuotedBlock__f_content;
    var this$3 = $n(x$1);
    var x46 = this$3.Llaika_ast_QuotedBlock__f_attribution;
    var this$4 = $n(x$1);
    return $p_Llaika_internal_render_ASTRenderer$__lists$1__Llaika_api_format_Formatter__T__sci_Seq__T(this, fmt, "QuotedBlock", $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([new $c_T2(x45, "Content - Blocks: "), new $c_T2(x46, "Attribution - Spans: ")])));
  } else if (false) {
    var x$1$1 = $as_Llaika_ast_DefinitionListItem(element);
    var x40 = $n(x$1$1)._1__sci_Seq();
    var x41 = $n(x$1$1)._2__sci_Seq();
    $n(x$1$1)._3__Llaika_ast_Options();
    return $p_Llaika_internal_render_ASTRenderer$__lists$1__Llaika_api_format_Formatter__T__sci_Seq__T(this, fmt, "Item", $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([new $c_T2(x40, "Term - Spans: "), new $c_T2(x41, "Definition - Blocks: ")])));
  } else if ((element instanceof $c_Llaika_ast_SectionNumber)) {
    var x$1$2 = $as_Llaika_ast_SectionNumber(element);
    var this$11 = $n(x$1$2);
    var x36 = this$11.Llaika_ast_SectionNumber__f_position;
    var this$12 = $n(x$1$2);
    var x37 = this$12.Llaika_ast_SectionNumber__f_options;
    var $x_3 = $m_sci_Seq$();
    var $x_2 = $m_sr_ScalaRunTime$();
    var this$13 = $n(x36);
    var $x_1 = $n($n($x_3).apply__sci_Seq__sc_SeqOps($n($x_2).wrapRefArray__AO__sci_ArraySeq(new $ac_O([$f_sc_IterableOnceOps__mkString__T__T__T__T(this$13, "", ".", ""), x37])))).iterator__sc_Iterator();
    var NoRef$lzy1$4 = NoRef$lzy1;
    return ("SectionNumber" + $p_Llaika_internal_render_ASTRenderer$__attributes$1__sc_Iterator__O__T(this, $x_1, $p_Llaika_internal_render_ASTRenderer$__NoRef$1__sr_LazyRef__Llaika_internal_render_ASTRenderer$NoRef$2$(this, NoRef$lzy1$4)));
  } else if ($is_Llaika_ast_BlockContainer(element)) {
    var bc = $as_Llaika_ast_BlockContainer(element);
    return $p_Llaika_internal_render_ASTRenderer$__elementContainerDesc$1__Llaika_api_format_Formatter__Llaika_ast_ElementContainer__T__T(this, fmt, bc, "Blocks");
  } else if ($is_Llaika_ast_SpanContainer(element)) {
    var sc = $as_Llaika_ast_SpanContainer(element);
    return $p_Llaika_internal_render_ASTRenderer$__elementContainerDesc$1__Llaika_api_format_Formatter__Llaika_ast_ElementContainer__T__T(this, fmt, sc, "Spans");
  } else if ($is_Llaika_ast_TemplateSpanContainer(element)) {
    var tsc = $as_Llaika_ast_TemplateSpanContainer(element);
    return $p_Llaika_internal_render_ASTRenderer$__elementContainerDesc$1__Llaika_api_format_Formatter__Llaika_ast_ElementContainer__T__T(this, fmt, tsc, "TemplateSpans");
  } else if ($is_Llaika_ast_TextContainer(element)) {
    var tc = $as_Llaika_ast_TextContainer(element);
    return $p_Llaika_internal_render_ASTRenderer$__textContainerDesc$1__Llaika_ast_TextContainer__T(this, tc);
  } else if ((element instanceof $c_Llaika_internal_render_ASTRenderer$Content)) {
    var x$1$3 = $as_Llaika_internal_render_ASTRenderer$Content(element);
    var this$15 = $n(x$1$3);
    var x27 = this$15.Llaika_internal_render_ASTRenderer$Content__f_content;
    var this$16 = $n(x$1$3);
    var x28 = this$16.Llaika_internal_render_ASTRenderer$Content__f_desc;
    var this$17 = $n(x$1$3);
    return (("" + x28) + $n(fmt).indentedChildren__sci_Seq__T(x27));
  } else if ($is_Llaika_ast_ElementContainer(element)) {
    var ec = $as_Llaika_ast_ElementContainer(element);
    return $p_Llaika_internal_render_ASTRenderer$__elementContainerDesc$1__Llaika_api_format_Formatter__Llaika_ast_ElementContainer__T__T(this, fmt, ec, "Elements");
  } else {
    return $p_Llaika_internal_render_ASTRenderer$__renderElement$1__Llaika_api_format_Formatter__sr_LazyRef__Llaika_ast_Element__T(this, fmt, NoRef$lzy1, element);
  }
});
$c_Llaika_internal_render_ASTRenderer$.prototype.apply__O__O__O = (function(v1, v2) {
  return this.apply__Llaika_api_format_Formatter__Llaika_ast_Element__T($as_Llaika_api_format_Formatter(v1), $as_Llaika_ast_Element(v2));
});
var $d_Llaika_internal_render_ASTRenderer$ = new $TypeData().initClass($c_Llaika_internal_render_ASTRenderer$, "laika.internal.render.ASTRenderer$", ({
  Llaika_internal_render_ASTRenderer$: 1,
  F2: 1
}));
var $n_Llaika_internal_render_ASTRenderer$;
function $m_Llaika_internal_render_ASTRenderer$() {
  if ((!$n_Llaika_internal_render_ASTRenderer$)) {
    $n_Llaika_internal_render_ASTRenderer$ = new $c_Llaika_internal_render_ASTRenderer$();
  }
  return $n_Llaika_internal_render_ASTRenderer$;
}
function $ct_Llaika_internal_render_HTMLRenderer__T__($thiz, format) {
  $thiz.Llaika_internal_render_HTMLRenderer__f_format = format;
  $thiz.Llaika_internal_render_HTMLRenderer__f_ElementSequence$lzy1 = new $c_Llaika_internal_render_HTMLRenderer$ElementSequence$($thiz);
  return $thiz;
}
function $ps_Llaika_internal_render_HTMLRenderer__noneIfDefault$1__O__O__s_Option(actual, default$1) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(actual, default$1)) {
    return $m_s_None$();
  } else {
    var value = $dp_toString__T($n(actual));
    return new $c_s_Some(value);
  }
}
function $ps_Llaika_internal_render_HTMLRenderer__renderBlocks$1__Llaika_api_format_TagFormatter__T__Llaika_ast_BlockContainer__sci_Seq__T(fmt$1, tagName, container, attrs) {
  var this$1 = $n(container);
  var x5 = this$1.content__sci_Seq();
  if ((x5 !== null)) {
    if (($n(x5).lengthCompare__I__I(1) === 0)) {
      var x13 = $as_Llaika_ast_Block($n(x5).apply__I__O(0));
      if ((x13 instanceof $c_Llaika_ast_SpanSequence)) {
        var ss = $as_Llaika_ast_SpanSequence(x13);
        var $x_1 = $n(fmt$1);
        var this$5 = $n(ss);
        var options = $n($as_Llaika_ast_Element(container)).options__Llaika_ast_Options();
        var content = this$5.Llaika_ast_SpanSequence__f_content;
        return $n($x_1).element__T__Llaika_ast_ElementContainer__sci_Seq__T(tagName, new $c_Llaika_ast_SpanSequence(content, options), attrs);
      }
      if ((x13 instanceof $c_Llaika_ast_Paragraph)) {
        var x$1 = $as_Llaika_ast_Paragraph(x13);
        var this$7 = $n(x$1);
        var x10 = this$7.Llaika_ast_Paragraph__f_content;
        var this$8 = $n(x$1);
        var x11 = this$8.Llaika_ast_Paragraph__f_options;
        return $n(fmt$1).element__T__Llaika_ast_ElementContainer__sci_Seq__T(tagName, new $c_Llaika_ast_SpanSequence(x10, x11), attrs);
      }
    }
  }
  return $n(fmt$1).indentedElement__T__Llaika_ast_ElementContainer__sci_Seq__T(tagName, container, attrs);
}
function $p_Llaika_internal_render_HTMLRenderer__renderTable$1__Llaika_api_format_TagFormatter__Llaika_ast_Table__T($thiz, fmt$2, table) {
  var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_Llaika_ast_ElementContainer.getArrayOf().constr)([$n(table).Llaika_ast_Table__f_caption, $n(table).Llaika_ast_Table__f_columns, $n(table).Llaika_ast_Table__f_head, $n(table).Llaika_ast_Table__f_body]));
  var this$3 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems));
  var f = ((_$1) => {
    var _$1$1 = $as_Llaika_ast_ElementContainer(_$1);
    var this$2 = $n(_$1$1);
    return $n(this$2.content__sci_Seq()).isEmpty__Z();
  });
  var l = this$3;
  block: {
    var result;
    while (true) {
      if ($n(l).isEmpty__Z()) {
        var result = $m_sci_Nil$();
        break;
      } else {
        var h = $n(l).head__O();
        var t = $as_sci_List($n(l).tail__O());
        if (($uZ(f(h)) === true)) {
          l = t;
          continue;
        }
        var start = l;
        var remaining = t;
        while (true) {
          if ($n(remaining).isEmpty__Z()) {
            var result = start;
            break block;
          } else {
            var x = $n(remaining).head__O();
            if (($uZ(f(x)) !== true)) {
              remaining = $as_sci_List($n(remaining).tail__O());
              continue;
            }
            var firstMiss = remaining;
            var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
            var toProcess = $as_sci_List($n(start).tail__O());
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
              $n(currentLast).sci_$colon$colon__f_next = newElem;
              currentLast = newElem;
              toProcess = $as_sci_List($n(toProcess).tail__O());
            }
            var next = $as_sci_List($n(firstMiss).tail__O());
            var nextToCopy = next;
            while ((!$n(next).isEmpty__Z())) {
              var head = $n(next).head__O();
              if (($uZ(f(head)) !== true)) {
                next = $as_sci_List($n(next).tail__O());
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                  $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = $as_sci_List($n(nextToCopy).tail__O());
                }
                nextToCopy = $as_sci_List($n(next).tail__O());
                next = $as_sci_List($n(next).tail__O());
              }
            }
            if ((!$n(nextToCopy).isEmpty__Z())) {
              $n(currentLast).sci_$colon$colon__f_next = nextToCopy;
            }
            var result = newHead;
            break block;
          }
        }
      }
    }
  }
  var $x_1 = $n(fmt$2);
  var this$5 = $n($n($thiz.Llaika_internal_render_HTMLRenderer__f_ElementSequence$lzy1).apply__sci_Seq__Llaika_ast_Options__Llaika_internal_render_HTMLRenderer$ElementSequence(result, ($n($thiz.Llaika_internal_render_HTMLRenderer__f_ElementSequence$lzy1), $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty)));
  var options = $n(table).Llaika_ast_Table__f_options;
  return $n($x_1).indentedElement__T__Llaika_ast_ElementContainer__sci_Seq__T("table", this$5.copy__sci_Seq__Llaika_ast_Options__Llaika_internal_render_HTMLRenderer$ElementSequence(this$5.Llaika_internal_render_HTMLRenderer$ElementSequence__f_content, options), $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
}
function $ps_Llaika_internal_render_HTMLRenderer__transformItems$1__Llaika_ast_BulletFormat$StringBullet__sci_Seq__sci_Seq(bullet$1, items) {
  return $as_sci_Seq($n(items).flatMap__F1__O(new $c_sjsr_AnonFunction1(((item) => {
    var item$1 = $as_Llaika_ast_NavigationItem(item);
    var this$1 = $n($n(item$1).Llaika_ast_NavigationItem__f_link);
    if ((!this$1.isEmpty__Z())) {
      var arg1 = this$1.get__O();
      var _$2 = $as_Llaika_ast_NavigationLink(arg1);
      var $x_1 = $n(_$2).Llaika_ast_NavigationLink__f_selfLink;
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var linkStyles = $m_Llaika_ast_Style$().Llaika_ast_Style$__f_active;
    } else {
      var linkStyles = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    }
    if ($n($n(item$1).Llaika_ast_NavigationItem__f_link).isEmpty__Z()) {
      var typeStyles = $m_Llaika_ast_Style$().Llaika_ast_Style$__f_navHeader;
    } else {
      var this$2 = $n($n(item$1).Llaika_ast_NavigationItem__f_content);
      if ((!this$2.isEmpty__Z())) {
        var typeStyles = $m_Llaika_ast_Style$().Llaika_ast_Style$__f_navNode;
      } else {
        var typeStyles = $m_Llaika_ast_Style$().Llaika_ast_Style$__f_navLeaf;
      }
    }
    var this$3 = $n($n(item$1).Llaika_ast_NavigationItem__f_link);
    if (this$3.isEmpty__Z()) {
      var content$1 = $n(item$1).Llaika_ast_NavigationItem__f_title;
    } else {
      var arg1$1 = this$3.get__O();
      var link = $as_Llaika_ast_NavigationLink(arg1$1);
      var this$7 = $m_Llaika_ast_SpanSequence$();
      var content = $n($n(item$1).Llaika_ast_NavigationItem__f_title).Llaika_ast_SpanSequence__f_content;
      var target = $n(link).Llaika_ast_NavigationLink__f_target;
      var title = $m_s_None$();
      var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      var span = new $c_Llaika_ast_SpanLink(content, target, title, options);
      var spans = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Span.getArrayOf().constr)([]));
      var content$1 = $as_Llaika_ast_SpanSequence($f_Llaika_ast_SpanContainerCompanion__apply__Llaika_ast_Span__sci_Seq__O(this$7, span, spans));
    }
    var content$2 = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_SpanSequence.getArrayOf().constr)([content$1]))));
    var options$1 = $n($n($n(item$1).Llaika_ast_NavigationItem__f_options).$plus__Llaika_ast_Options__Llaika_ast_Options(linkStyles)).$plus__Llaika_ast_Options__Llaika_ast_Options(typeStyles);
    var target$1 = new $c_Llaika_ast_BulletListItem(content$2, bullet$1, options$1);
    var children = ($n($n(item$1).Llaika_ast_NavigationItem__f_content).isEmpty__Z() ? $m_sci_Nil$() : $ps_Llaika_internal_render_HTMLRenderer__transformItems$1__Llaika_ast_BulletFormat$StringBullet__sci_Seq__sci_Seq(bullet$1, $n(item$1).Llaika_ast_NavigationItem__f_content));
    var this$9 = $n(children);
    return $as_sc_IterableOnce(this$9.prepended__O__O(target$1));
  }))));
}
function $ps_Llaika_internal_render_HTMLRenderer__navigationToBulletList$1__Llaika_ast_NavigationList__Llaika_ast_BulletList(navList) {
  var bullet = new $c_Llaika_ast_BulletFormat$StringBullet("*");
  var content = $ps_Llaika_internal_render_HTMLRenderer__transformItems$1__Llaika_ast_BulletFormat$StringBullet__sci_Seq__sci_Seq(bullet, $n(navList).Llaika_ast_NavigationList__f_content);
  var options = $n($n(navList).Llaika_ast_NavigationList__f_options).$plus__Llaika_ast_Options__Llaika_ast_Options($m_Llaika_ast_Style$().Llaika_ast_Style$__f_navList);
  return new $c_Llaika_ast_BulletList(content, bullet, options);
}
function $ps_Llaika_internal_render_HTMLRenderer__WithFallback$lzyINIT1$1__sr_LazyRef__Llaika_internal_render_HTMLRenderer$WithFallback$2$(WithFallback$lzy1$1) {
  if ((WithFallback$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Llaika_internal_render_HTMLRenderer$WithFallback$2$(($n(WithFallback$lzy1$1).sr_LazyRef__f__initialized ? $n(WithFallback$lzy1$1).sr_LazyRef__f__value : $n(WithFallback$lzy1$1).initialize__O__O(new $c_Llaika_internal_render_HTMLRenderer$WithFallback$2$())));
}
function $ps_Llaika_internal_render_HTMLRenderer__WithFallback$1__sr_LazyRef__Llaika_internal_render_HTMLRenderer$WithFallback$2$(WithFallback$lzy1$2) {
  return $as_Llaika_internal_render_HTMLRenderer$WithFallback$2$(($n(WithFallback$lzy1$2).sr_LazyRef__f__initialized ? $n(WithFallback$lzy1$2).sr_LazyRef__f__value : $ps_Llaika_internal_render_HTMLRenderer__WithFallback$lzyINIT1$1__sr_LazyRef__Llaika_internal_render_HTMLRenderer$WithFallback$2$(WithFallback$lzy1$2)));
}
function $ps_Llaika_internal_render_HTMLRenderer__toTable$1__T__sci_Seq__Llaika_ast_Options__Llaika_ast_Table(label, content, options) {
  var this$2 = $m_Llaika_ast_CellType$BodyCell$();
  var this$1 = $m_Llaika_ast_SpanSequence$();
  var text = (("[" + label) + "]");
  var texts = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([]));
  var block = $as_Llaika_ast_Block($f_Llaika_ast_SpanContainerCompanion__apply__T__sci_Seq__O(this$1, text, texts));
  var blocks = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Block.getArrayOf().constr)([]));
  var left = $as_Llaika_ast_Cell($f_Llaika_ast_BlockContainerCompanion__apply__Llaika_ast_Block__sci_Seq__O(this$2, block, blocks));
  var this$3 = $m_Llaika_ast_CellType$BodyCell$();
  var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  var right = new $c_Llaika_ast_Cell(this$3, content, 1, 1, options$1);
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Cell.getArrayOf().constr)([left, right]));
  var content$1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var options$2 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  var row = new $c_Llaika_ast_Row(content$1, options$2);
  var content$2 = $m_sci_Nil$();
  var options$3 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  var head = new $c_Llaika_ast_TableHead(content$2, options$3);
  var elems$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Row.getArrayOf().constr)([row]));
  var content$3 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1);
  var options$4 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  var body = new $c_Llaika_ast_TableBody(content$3, options$4);
  var content$4 = $m_sci_Nil$();
  var options$5 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  var caption = new $c_Llaika_ast_Caption(content$4, options$5);
  var columns = $m_Llaika_ast_Columns$().options__sci_Seq__Llaika_ast_Columns($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Options.getArrayOf().constr)([$m_Llaika_ast_Style$().Llaika_ast_Style$__f_label, $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty])));
  return new $c_Llaika_ast_Table(head, body, caption, columns, options);
}
function $ps_Llaika_internal_render_HTMLRenderer__quotedBlockContent$1__Llaika_ast_QuotedBlock__Llaika_ast_BlockContainer(qb) {
  if ($n($n(qb).Llaika_ast_QuotedBlock__f_attribution).isEmpty__Z()) {
    return qb;
  } else {
    var this$2 = $n($n(qb).Llaika_ast_QuotedBlock__f_content);
    var content = $n(qb).Llaika_ast_QuotedBlock__f_attribution;
    var options = $m_Llaika_ast_Style$().Llaika_ast_Style$__f_attribution;
    var elem = new $c_Llaika_ast_Paragraph(content, options);
    var content$1 = $as_sci_Seq(this$2.appended__O__O(elem));
    var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var this$5 = new $c_Llaika_ast_BlockSequence(content$1, options$1);
    var options$2 = $n(qb).Llaika_ast_QuotedBlock__f_options;
    var content$2 = this$5.Llaika_ast_BlockSequence__f_content;
    return new $c_Llaika_ast_BlockSequence(content$2, options$2);
  }
}
function $ps_Llaika_internal_render_HTMLRenderer__figureContent$1__Llaika_ast_Span__sci_Seq__sci_Seq__sci_List(img, caption, legend) {
  var $x_3 = $m_sr_ScalaRunTime$();
  var this$1 = $m_Llaika_ast_SpanSequence$();
  var spans = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Span.getArrayOf().constr)([]));
  var $x_2 = $as_Llaika_ast_Block($f_Llaika_ast_SpanContainerCompanion__apply__Llaika_ast_Span__sci_Seq__O(this$1, img, spans));
  var options = $m_Llaika_ast_Style$().Llaika_ast_Style$__f_caption;
  var $x_1 = new $c_Llaika_ast_Paragraph(caption, options);
  var options$1 = $m_Llaika_ast_Style$().Llaika_ast_Style$__f_legend;
  var elems = $n($x_3).genericWrapArray__O__sci_ArraySeq(new ($d_Llaika_ast_Block.getArrayOf().constr)([$x_2, $x_1, new $c_Llaika_ast_BlockSequence(legend, options$1)]));
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
}
function $p_Llaika_internal_render_HTMLRenderer__renderBlockContainer$1__Llaika_api_format_TagFormatter__sr_LazyRef__Llaika_ast_BlockContainer__T($thiz, fmt$3, WithFallback$lzy1$3, con) {
  if ((con instanceof $c_Llaika_ast_RootElement)) {
    var x$1 = $as_Llaika_ast_RootElement(con);
    var this$2 = $n(x$1);
    var x62 = this$2.Llaika_ast_RootElement__f_content;
    var this$3 = $n(x$1);
    return $n(fmt$3).childPerLine__sci_Seq__T(x62);
  }
  if ((con instanceof $c_Llaika_ast_EmbeddedRoot)) {
    var x$1$1 = $as_Llaika_ast_EmbeddedRoot(con);
    var this$5 = $n(x$1$1);
    var x57 = this$5.Llaika_ast_EmbeddedRoot__f_content;
    var this$6 = $n(x$1$1);
    var x58 = this$6.Llaika_ast_EmbeddedRoot__f_indent;
    var this$7 = $n(x$1$1);
    var this$8 = $n(fmt$3);
    var x = $n(this$8.Llaika_internal_render_HTMLFormatter__f_context).Llaika_api_format_Formatter$Context__f_indentation;
    var x$2 = $m_Llaika_api_format_Formatter$Indentation$().Llaika_api_format_Formatter$Indentation$__f_none;
    if ((((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) || ($n($n(this$8.Llaika_internal_render_HTMLFormatter__f_context).Llaika_api_format_Formatter$Context__f_indentation).Llaika_api_format_Formatter$Indentation__f_currentLevel >= x58))) {
      var newIndentation$1 = this$8;
    } else {
      var \u03b41$ = $n(this$8.Llaika_internal_render_HTMLFormatter__f_context).Llaika_api_format_Formatter$Context__f_indentation;
      $n(\u03b41$);
      var this$9 = $n(\u03b41$);
      var numSpaces = this$9.Llaika_api_format_Formatter$Indentation__f_numSpaces;
      var this$10 = $n(\u03b41$);
      var dotted = this$10.Llaika_api_format_Formatter$Indentation__f_dotted;
      var newIndentation = new $c_Llaika_api_format_Formatter$Indentation(x58, numSpaces, dotted);
      var newIndentation$1 = this$8.withIndentation__Llaika_api_format_Formatter$Indentation__Llaika_api_format_TagFormatter(newIndentation);
    }
    return $n(newIndentation$1).childPerLine__sci_Seq__T(x57);
  }
  if ((con instanceof $c_Llaika_ast_Section)) {
    var x$1$2 = $as_Llaika_ast_Section(con);
    var this$13 = $n(x$1$2);
    var x52 = this$13.Llaika_ast_Section__f_header;
    var this$14 = $n(x$1$2);
    var x53 = this$14.Llaika_ast_Section__f_content;
    var this$15 = $n(x$1$2);
    var $x_1 = $n(fmt$3);
    var this$16 = $n(x53);
    return $n($x_1).childPerLine__sci_Seq__T($as_sci_Seq(this$16.prepended__O__O(x52)));
  }
  if (false) {
    var x$1$3 = $as_Llaika_ast_TitledBlock(con);
    var x47 = $n(x$1$3)._1__sci_Seq();
    var x48 = $n(x$1$3)._2__sci_Seq();
    var x49 = $n(x$1$3)._3__Llaika_ast_Options();
    var $x_2 = $n(fmt$3);
    var options = $m_Llaika_ast_Style$().Llaika_ast_Style$__f_title;
    var elem$1 = new $c_Llaika_ast_Paragraph(x47, options);
    var this$19 = $n(x48);
    var content = $as_sci_Seq(this$19.prepended__O__O(elem$1));
    var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var this$22 = new $c_Llaika_ast_BlockSequence(content, options$1);
    var content$1 = this$22.Llaika_ast_BlockSequence__f_content;
    return $n($x_2).indentedElement__T__Llaika_ast_ElementContainer__sci_Seq__T("div", new $c_Llaika_ast_BlockSequence(content$1, x49), $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if ((con instanceof $c_Llaika_ast_QuotedBlock)) {
    var qb = $as_Llaika_ast_QuotedBlock(con);
    return $ps_Llaika_internal_render_HTMLRenderer__renderBlocks$1__Llaika_api_format_TagFormatter__T__Llaika_ast_BlockContainer__sci_Seq__T(fmt$3, "blockquote", $ps_Llaika_internal_render_HTMLRenderer__quotedBlockContent$1__Llaika_ast_QuotedBlock__Llaika_ast_BlockContainer(qb), $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if ((con instanceof $c_Llaika_ast_BulletListItem)) {
    var bli = $as_Llaika_ast_BulletListItem(con);
    return $ps_Llaika_internal_render_HTMLRenderer__renderBlocks$1__Llaika_api_format_TagFormatter__T__Llaika_ast_BlockContainer__sci_Seq__T(fmt$3, "li", bli, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if ((con instanceof $c_Llaika_ast_EnumListItem)) {
    var eli = $as_Llaika_ast_EnumListItem(con);
    return $ps_Llaika_internal_render_HTMLRenderer__renderBlocks$1__Llaika_api_format_TagFormatter__T__Llaika_ast_BlockContainer__sci_Seq__T(fmt$3, "li", eli, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if (false) {
    var dli = $as_Llaika_ast_DefinitionListItem(con);
    var content$2 = $n(dli).term__sci_Seq();
    var options$2 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    return ((("" + $n(fmt$3).element__T__Llaika_ast_ElementContainer__sci_Seq__T("dt", new $c_Llaika_ast_SpanSequence(content$2, options$2), $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])))) + $n(fmt$3).Llaika_api_format_Formatter__f_newLine) + $ps_Llaika_internal_render_HTMLRenderer__renderBlocks$1__Llaika_api_format_TagFormatter__T__Llaika_ast_BlockContainer__sci_Seq__T(fmt$3, "dd", $as_Llaika_ast_BlockContainer($n(dli).clearOptions__Llaika_ast_Element()), $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([]))));
  }
  if (false) {
    var x$1$4 = $as_Llaika_ast_Figure(con);
    var x37 = $n(x$1$4)._1__Llaika_ast_Span();
    var x38 = $n(x$1$4)._2__sci_Seq();
    var x39 = $n(x$1$4)._3__sci_Seq();
    var x40 = $n(x$1$4)._4__Llaika_ast_Options();
    var content$3 = $ps_Llaika_internal_render_HTMLRenderer__figureContent$1__Llaika_ast_Span__sci_Seq__sci_Seq__sci_List(x37, x38, x39);
    var options$3 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var this$28 = new $c_Llaika_ast_BlockSequence(content$3, options$3);
    var options$4 = $n(x40).$plus__Llaika_ast_Options__Llaika_ast_Options($m_Llaika_ast_Style$().Llaika_ast_Style$__f_figure);
    var content$4 = this$28.Llaika_ast_BlockSequence__f_content;
    var content$6 = new $c_Llaika_ast_BlockSequence(content$4, options$4);
    return $n(fmt$3).indentedElement__T__Llaika_ast_ElementContainer__sci_Seq__T("div", content$6, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if ((con instanceof $c_Llaika_ast_Footnote)) {
    var x$1$5 = $as_Llaika_ast_Footnote(con);
    var this$30 = $n(x$1$5);
    var x32 = this$30.Llaika_ast_Footnote__f_label;
    var this$31 = $n(x$1$5);
    var x33 = this$31.Llaika_ast_Footnote__f_content;
    var this$32 = $n(x$1$5);
    var x34 = this$32.Llaika_ast_Footnote__f_options;
    return $p_Llaika_internal_render_HTMLRenderer__renderTable$1__Llaika_api_format_TagFormatter__Llaika_ast_Table__T($thiz, fmt$3, $ps_Llaika_internal_render_HTMLRenderer__toTable$1__T__sci_Seq__Llaika_ast_Options__Llaika_ast_Table(x32, x33, $n(x34).$plus__Llaika_ast_Options__Llaika_ast_Options($m_Llaika_ast_Style$().Llaika_ast_Style$__f_footnote)));
  }
  if ((con instanceof $c_Llaika_ast_Citation)) {
    var x$1$6 = $as_Llaika_ast_Citation(con);
    var this$34 = $n(x$1$6);
    var x27 = this$34.Llaika_ast_Citation__f_label;
    var this$35 = $n(x$1$6);
    var x28 = this$35.Llaika_ast_Citation__f_content;
    var this$36 = $n(x$1$6);
    var x29 = this$36.Llaika_ast_Citation__f_options;
    return $p_Llaika_internal_render_HTMLRenderer__renderTable$1__Llaika_api_format_TagFormatter__Llaika_ast_Table__T($thiz, fmt$3, $ps_Llaika_internal_render_HTMLRenderer__toTable$1__T__sci_Seq__Llaika_ast_Options__Llaika_ast_Table(x27, x28, $n(x29).$plus__Llaika_ast_Options__Llaika_ast_Options($m_Llaika_ast_Style$().Llaika_ast_Style$__f_citation)));
  }
  if ((con !== null)) {
    var x22 = $n($ps_Llaika_internal_render_HTMLRenderer__WithFallback$1__sr_LazyRef__Llaika_internal_render_HTMLRenderer$WithFallback$2$(WithFallback$lzy1$3)).unapply__Llaika_ast_Element__s_Option($as_Llaika_ast_Element(con));
    if ((!$n(x22).isEmpty__Z())) {
      var x23 = $as_Llaika_ast_Element($n(x22).get__O());
      return $n(fmt$3).child__Llaika_ast_Element__T(x23);
    }
  }
  if ((con instanceof $c_Llaika_ast_BlockSequence)) {
    var x$1$7 = $as_Llaika_ast_BlockSequence(con);
    var this$38 = $n(x$1$7);
    var x20 = this$38.Llaika_ast_BlockSequence__f_content;
    var this$39 = $n(x$1$7);
    var x21 = this$39.Llaika_ast_BlockSequence__f_options;
    var x$3 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    if (((x$3 === null) ? (x21 === null) : $n(x$3).equals__O__Z(x21))) {
      return $n(fmt$3).childPerLine__sci_Seq__T(x20);
    }
  }
  return $n(fmt$3).indentedElement__T__Llaika_ast_ElementContainer__sci_Seq__T("div", con, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
}
function $ps_Llaika_internal_render_HTMLRenderer__renderTarget$1__Llaika_api_format_TagFormatter__Llaika_ast_Target__T(fmt$4, target) {
  var this$1 = $n(fmt$4);
  var this$2 = $n($n(this$1.Llaika_internal_render_HTMLFormatter__f_context).Llaika_api_format_Formatter$Context__f_pathTranslator);
  var x64 = $f_Llaika_api_bundle_PathTranslator__translate__Llaika_ast_Target__Llaika_ast_Target(this$2, target);
  if ((x64 instanceof $c_Llaika_ast_ExternalTarget)) {
    var ext = $as_Llaika_ast_ExternalTarget(x64);
    return $n(ext).Llaika_ast_ExternalTarget__f_url;
  }
  if ($is_Llaika_ast_InternalTarget(x64)) {
    var int = $as_Llaika_ast_InternalTarget(x64);
    var this$3 = $n(fmt$4);
    var relPath = $n($n(int).relativeTo__Llaika_ast_Path__Llaika_ast_InternalTarget$Resolved($n(this$3.Llaika_internal_render_HTMLFormatter__f_context).Llaika_api_format_Formatter$Context__f_path)).Llaika_ast_InternalTarget$Resolved__f_relativePath;
    var this$4 = $n(relPath);
    if ($f_T__endsWith__T__Z($n($n($f_Llaika_ast_GenericPath__withoutFragment__Llaika_ast_GenericPath(this$4)).toString__T()), "/index.html")) {
      var this$5 = $n(relPath);
      var suffix = this$5.copyWith$default$2__s_Option();
      var fragment = this$5.copyWith$default$3__s_Option();
      var this$6 = $n(this$5.copyWith__T__s_Option__s_Option__Llaika_ast_RelativePath("", suffix, fragment));
      return $n($f_Llaika_ast_GenericPath__withoutSuffix__Llaika_ast_GenericPath(this$6)).toString__T();
    } else {
      return $n(relPath).toString__T();
    }
  }
  throw new $c_s_MatchError(x64);
}
function $ps_Llaika_internal_render_HTMLRenderer__codeStyles$1__T__Z__Llaika_ast_Options(language, hasHighlighting) {
  return (hasHighlighting ? $m_Llaika_ast_Style$().Llaika_ast_Style$__f_noHighlight : $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([language]))));
}
function $ps_Llaika_internal_render_HTMLRenderer__linkAttributes$1__Llaika_api_format_TagFormatter__Llaika_ast_Target__s_Option__sci_Seq(fmt$6, target, title) {
  $n(fmt$6);
  var $x_2 = $m_sr_ScalaRunTime$();
  var value = $ps_Llaika_internal_render_HTMLRenderer__renderTarget$1__Llaika_api_format_TagFormatter__Llaika_ast_Target__T(fmt$6, target);
  var y = new $c_s_Some(value);
  var $x_1 = new $c_T2("href", y);
  var this$5 = $n(title);
  if (this$5.isEmpty__Z()) {
    var y$1 = $m_s_None$();
  } else {
    var arg1 = this$5.get__O();
    var str = $as_T(arg1);
    var this$6 = $n(fmt$6);
    var y$1 = new $c_s_Some($m_Llaika_api_format_TagFormatter$().escape__T__T__T(str, this$6.Llaika_api_format_Formatter__f_newLine));
  }
  var attrs = $n($x_2).wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$x_1, new $c_T2("title", y$1)]));
  var this$9 = $n(attrs);
  var pf = new $c_Llaika_api_format_TagFormatter$$anon$1();
  return $as_sci_Seq($f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this$9, pf));
}
function $ps_Llaika_internal_render_HTMLRenderer__renderCode$1__Llaika_api_format_TagFormatter__Llaika_ast_SpanContainer__T(fmt$8, spans) {
  var this$1 = $n(fmt$8);
  var newIndentation = $m_Llaika_api_format_Formatter$Indentation$().Llaika_api_format_Formatter$Indentation$__f_none;
  var arg1 = this$1.withIndentation__Llaika_api_format_Formatter$Indentation__Llaika_api_format_TagFormatter(newIndentation);
  return $n(arg1).element__T__Llaika_ast_ElementContainer__sci_Seq__T("code", spans, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
}
function $ps_Llaika_internal_render_HTMLRenderer__renderSpanContainer$1__Llaika_api_format_TagFormatter__sr_LazyRef__Llaika_ast_SpanContainer__T(fmt$5, WithFallback$lzy1$4, con) {
  if ((con instanceof $c_Llaika_ast_Paragraph)) {
    var p = $as_Llaika_ast_Paragraph(con);
    return $n(fmt$5).element__T__Llaika_ast_ElementContainer__sci_Seq__T("p", p, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if ((con instanceof $c_Llaika_ast_Title)) {
    var t = $as_Llaika_ast_Title(con);
    return $n(fmt$5).element__T__Llaika_ast_ElementContainer__sci_Seq__T("h1", t, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if ((con instanceof $c_Llaika_ast_Emphasized)) {
    var e = $as_Llaika_ast_Emphasized(con);
    return $n(fmt$5).element__T__Llaika_ast_ElementContainer__sci_Seq__T("em", e, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if ((con instanceof $c_Llaika_ast_Strong)) {
    var s = $as_Llaika_ast_Strong(con);
    return $n(fmt$5).element__T__Llaika_ast_ElementContainer__sci_Seq__T("strong", s, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if ((con instanceof $c_Llaika_ast_Deleted)) {
    var d = $as_Llaika_ast_Deleted(con);
    return $n(fmt$5).element__T__Llaika_ast_ElementContainer__sci_Seq__T("del", d, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if (false) {
    var i = $as_Llaika_ast_Inserted(con);
    return $n(fmt$5).element__T__Llaika_ast_ElementContainer__sci_Seq__T("ins", i, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if ((con instanceof $c_Llaika_ast_SpanLink)) {
    var sl = $as_Llaika_ast_SpanLink(con);
    return $n(fmt$5).element__T__Llaika_ast_ElementContainer__sci_Seq__T("a", sl, $ps_Llaika_internal_render_HTMLRenderer__linkAttributes$1__Llaika_api_format_TagFormatter__Llaika_ast_Target__s_Option__sci_Seq(fmt$5, $n(sl).Llaika_ast_SpanLink__f_target, $n(sl).Llaika_ast_SpanLink__f_title));
  }
  if ((con instanceof $c_Llaika_ast_Header)) {
    var h = $as_Llaika_ast_Header(con);
    var $x_1 = $n(fmt$5).Llaika_api_format_Formatter__f_newLine;
    var this$1 = $n(h).Llaika_ast_Header__f_level;
    return (("" + $x_1) + $n(fmt$5).element__T__Llaika_ast_ElementContainer__sci_Seq__T(("h" + ("" + this$1)), h, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([]))));
  }
  if (false) {
    var lb = $as_Llaika_ast_ParsedLiteralBlock(con);
    return $n(fmt$5).rawElement__T__Llaika_ast_Element__T__sci_Seq__T("pre", lb, $ps_Llaika_internal_render_HTMLRenderer__renderCode$1__Llaika_api_format_TagFormatter__Llaika_ast_SpanContainer__T(fmt$5, $as_Llaika_ast_SpanContainer($n(lb).clearOptions__Llaika_ast_Element())), $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if ((con instanceof $c_Llaika_ast_CodeBlock)) {
    var cb = $as_Llaika_ast_CodeBlock(con);
    var opt = $ps_Llaika_internal_render_HTMLRenderer__codeStyles$1__T__Z__Llaika_ast_Options($n(cb).Llaika_ast_CodeBlock__f_language, $n(cb).hasSyntaxHighlighting__Z());
    var $x_2 = $n(fmt$5);
    var this$3 = $n(cb);
    var language = this$3.Llaika_ast_CodeBlock__f_language;
    var content = this$3.Llaika_ast_CodeBlock__f_content;
    var codeOptions = this$3.Llaika_ast_CodeBlock__f_codeOptions;
    return $n($x_2).rawElement__T__Llaika_ast_Element__T__sci_Seq__T("pre", cb, $ps_Llaika_internal_render_HTMLRenderer__renderCode$1__Llaika_api_format_TagFormatter__Llaika_ast_SpanContainer__T(fmt$5, new $c_Llaika_ast_CodeBlock(language, content, codeOptions, opt)), $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if (false) {
    var ic = $as_Llaika_ast_InlineCode(con);
    var opt$2 = $ps_Llaika_internal_render_HTMLRenderer__codeStyles$1__T__Z__Llaika_ast_Options($n(ic).language__T(), false);
    return $ps_Llaika_internal_render_HTMLRenderer__renderCode$1__Llaika_api_format_TagFormatter__Llaika_ast_SpanContainer__T(fmt$5, $as_Llaika_ast_SpanContainer($n(ic).mergeOptions__Llaika_ast_Options__Llaika_ast_Element(opt$2)));
  }
  if ((con !== null)) {
    var x76 = $n($ps_Llaika_internal_render_HTMLRenderer__WithFallback$1__sr_LazyRef__Llaika_internal_render_HTMLRenderer$WithFallback$2$(WithFallback$lzy1$4)).unapply__Llaika_ast_Element__s_Option($as_Llaika_ast_Element(con));
    if ((!$n(x76).isEmpty__Z())) {
      var x77 = $as_Llaika_ast_Element($n(x76).get__O());
      return $n(fmt$5).child__Llaika_ast_Element__T(x77);
    }
  }
  if ((con instanceof $c_Llaika_ast_SpanSequence)) {
    var x$1 = $as_Llaika_ast_SpanSequence(con);
    var this$5 = $n(x$1);
    var x74 = this$5.Llaika_ast_SpanSequence__f_content;
    var this$6 = $n(x$1);
    var x75 = this$6.Llaika_ast_SpanSequence__f_options;
    var x = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    if (((x === null) ? (x75 === null) : $n(x).equals__O__Z(x75))) {
      return $n(fmt$5).children__sci_Seq__T(x74);
    }
  }
  if (false) {
    var x$1$1 = $as_Llaika_ast_CodeSpanSequence(con);
    var this$8 = $n(x$1$1);
    var x70 = this$8.Llaika_ast_CodeSpanSequence__f_content;
    var this$9 = $n(x$1$1);
    var x71 = this$9.Llaika_ast_CodeSpanSequence__f_options;
    var x$3 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    if (((x$3 === null) ? (x71 === null) : $n(x$3).equals__O__Z(x71))) {
      return $n(fmt$5).children__sci_Seq__T(x70);
    }
  }
  return $n(fmt$5).element__T__Llaika_ast_ElementContainer__sci_Seq__T("span", con, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
}
function $ps_Llaika_internal_render_HTMLRenderer__renderTemplateSpanContainer$1__Llaika_api_format_TagFormatter__Llaika_ast_TemplateSpanContainer__T(fmt$9, con) {
  if ((con instanceof $c_Llaika_ast_TemplateRoot)) {
    $m_Llaika_ast_TemplateRoot$();
    var x$1 = $as_Llaika_ast_TemplateRoot(con);
    var this$2 = $n(x$1);
    var x97 = this$2.Llaika_ast_TemplateRoot__f_content;
    var this$3 = $n(x$1);
    var x98 = this$3.Llaika_ast_TemplateRoot__f_options;
    var x = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    if (((x === null) ? (x98 === null) : $n(x).equals__O__Z(x98))) {
      return $n(fmt$9).children__sci_Seq__T(x97);
    }
  }
  if ((con instanceof $c_Llaika_ast_TemplateSpanSequence)) {
    var x$1$1 = $as_Llaika_ast_TemplateSpanSequence(con);
    var this$5 = $n(x$1$1);
    var x93 = this$5.Llaika_ast_TemplateSpanSequence__f_content;
    var this$6 = $n(x$1$1);
    var x94 = this$6.Llaika_ast_TemplateSpanSequence__f_options;
    var x$3 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    if (((x$3 === null) ? (x94 === null) : $n(x$3).equals__O__Z(x94))) {
      return $n(fmt$9).children__sci_Seq__T(x93);
    }
  }
  return $n(fmt$9).element__T__Llaika_ast_ElementContainer__sci_Seq__T("span", con, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
}
function $ps_Llaika_internal_render_HTMLRenderer__renderListContainer$1__Llaika_api_format_TagFormatter__sr_LazyRef__Llaika_ast_ListContainer__T(fmt$10, WithFallback$lzy1$5, con) {
  if ((con instanceof $c_Llaika_ast_EnumList)) {
    var x106 = $as_Llaika_ast_EnumList(con);
    var this$2 = $n(x106);
    var this$3 = $n(x106);
    var x109 = this$3.Llaika_ast_EnumList__f_format;
    var this$4 = $n(x106);
    var x110 = this$4.Llaika_ast_EnumList__f_start;
    var this$5 = $n(x106);
    var $x_3 = $n(fmt$10);
    $n(fmt$10);
    var $x_2 = $m_sr_ScalaRunTime$();
    var this$7 = $n($n($n(x109).Llaika_ast_EnumFormat__f_enumType).toString__T());
    var value = $as_T(this$7.toLowerCase());
    var y = new $c_s_Some(value);
    var $x_1 = new $c_T2("class", y);
    var y$1 = $ps_Llaika_internal_render_HTMLRenderer__noneIfDefault$1__O__O__s_Option(x110, 1);
    var attrs = $n($x_2).wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$x_1, new $c_T2("start", y$1)]));
    var this$13 = $n(attrs);
    var pf = new $c_Llaika_api_format_TagFormatter$$anon$1();
    return $n($x_3).indentedElement__T__Llaika_ast_ElementContainer__sci_Seq__T("ol", x106, $as_sci_Seq($f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this$13, pf)));
  }
  if ((con instanceof $c_Llaika_ast_BulletList)) {
    var bl = $as_Llaika_ast_BulletList(con);
    return $n(fmt$10).indentedElement__T__Llaika_ast_ElementContainer__sci_Seq__T("ul", bl, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if (false) {
    var dl = $as_Llaika_ast_DefinitionList(con);
    return $n(fmt$10).indentedElement__T__Llaika_ast_ElementContainer__sci_Seq__T("dl", dl, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if ((con instanceof $c_Llaika_ast_NavigationList)) {
    var nl = $as_Llaika_ast_NavigationList(con);
    return $n(fmt$10).child__Llaika_ast_Element__T($ps_Llaika_internal_render_HTMLRenderer__navigationToBulletList$1__Llaika_ast_NavigationList__Llaika_ast_BulletList(nl));
  }
  if ((con !== null)) {
    var x100 = $n($ps_Llaika_internal_render_HTMLRenderer__WithFallback$1__sr_LazyRef__Llaika_internal_render_HTMLRenderer$WithFallback$2$(WithFallback$lzy1$5)).unapply__Llaika_ast_Element__s_Option($as_Llaika_ast_Element(con));
    if ((!$n(x100).isEmpty__Z())) {
      var x101 = $as_Llaika_ast_Element($n(x100).get__O());
      return $n(fmt$10).child__Llaika_ast_Element__T(x101);
    }
  }
  return $n(fmt$10).indentedElement__T__Llaika_ast_ElementContainer__sci_Seq__T("div", con, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
}
function $p_Llaika_internal_render_HTMLRenderer__renderTextContainer$1__Llaika_api_format_TagFormatter__sr_LazyRef__Llaika_ast_TextContainer__T($thiz, fmt$11, WithFallback$lzy1$6, con) {
  if ((con instanceof $c_Llaika_ast_Text)) {
    var t = $as_Llaika_ast_Text(con);
    if ($n($n(t).Llaika_ast_Text__f_options).isEmpty__Z()) {
      var this$1 = $n(fmt$11);
      var str = $n(t).Llaika_ast_Text__f_content;
      return $m_Llaika_api_format_TagFormatter$().escape__T__T__T(str, this$1.Llaika_api_format_Formatter__f_newLine);
    } else {
      return $n(fmt$11).textElement__T__Llaika_ast_TextContainer__sci_Seq__T("span", t, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
    }
  }
  if ((con instanceof $c_Llaika_ast_TemplateString)) {
    var ts = $as_Llaika_ast_TemplateString(con);
    return ($n($n(ts).Llaika_ast_TemplateString__f_options).isEmpty__Z() ? $n(ts).Llaika_ast_TemplateString__f_content : $n(fmt$11).rawElement__T__Llaika_ast_Element__T__sci_Seq__T("span", ts, $n(ts).Llaika_ast_TemplateString__f_content, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([]))));
  }
  if (false) {
    var x130 = $as_Llaika_ast_RawContent(con);
    var x132 = $n(x130)._1__O();
    var x133 = $n(x130)._2__T();
    var x134 = $n(x130)._3__Llaika_ast_Options();
    var this$4 = new $c_Lcats_data_NonEmptySetOps(x132);
    var a = $thiz.Llaika_internal_render_HTMLRenderer__f_format;
    var s = this$4.Lcats_data_NonEmptySetOps__f_value;
    var this$6 = $n($as_sci_SortedSet(s));
    if (this$6.contains__O__Z(a)) {
      return ($n(x134).isEmpty__Z() ? x133 : $n(fmt$11).rawElement__T__Llaika_ast_Element__T__sci_Seq__T("span", x130, x133, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([]))));
    } else {
      return "";
    }
  }
  if (false) {
    var cs = $as_Llaika_ast_CodeSpan(con);
    return $n(fmt$11).textElement__T__Llaika_ast_TextContainer__sci_Seq__T("span", $as_Llaika_ast_TextContainer($n(cs).mergeOptions__Llaika_ast_Options__Llaika_ast_Element($m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($n($as_sc_IterableOnceOps($n($n(cs).categories__sci_Set()).map__F1__O(new $c_sjsr_AnonFunction1(((_$5) => {
      var _$5$1 = $as_Llaika_parse_code_CodeCategory(_$5);
      return $n(_$5$1).name__T();
    }))))).toSeq__sci_Seq()))), $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if ((con instanceof $c_Llaika_ast_Literal)) {
    var l = $as_Llaika_ast_Literal(con);
    var this$7 = $n(fmt$11);
    var newIndentation = $m_Llaika_api_format_Formatter$Indentation$().Llaika_api_format_Formatter$Indentation$__f_none;
    var arg1 = this$7.withIndentation__Llaika_api_format_Formatter$Indentation__Llaika_api_format_TagFormatter(newIndentation);
    return $n(arg1).textElement__T__Llaika_ast_TextContainer__sci_Seq__T("code", l, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if ((con instanceof $c_Llaika_ast_LiteralBlock)) {
    var x$1 = $as_Llaika_ast_LiteralBlock(con);
    var this$9 = $n(x$1);
    var x126 = this$9.Llaika_ast_LiteralBlock__f_content;
    var this$10 = $n(x$1);
    var x127 = this$10.Llaika_ast_LiteralBlock__f_options;
    var $x_1 = $n(fmt$11);
    var this$13 = $m_Llaika_ast_SpanSequence$();
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var span = new $c_Llaika_ast_Literal(x126, options);
    var spans = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Span.getArrayOf().constr)([]));
    var this$14 = $n($as_Llaika_ast_SpanSequence($f_Llaika_ast_SpanContainerCompanion__apply__Llaika_ast_Span__sci_Seq__O(this$13, span, spans)));
    var content = this$14.Llaika_ast_SpanSequence__f_content;
    return $n($x_1).element__T__Llaika_ast_ElementContainer__sci_Seq__T("pre", new $c_Llaika_ast_SpanSequence(content, x127), $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if (false) {
    var x$1$1 = $as_Llaika_ast_Comment(con);
    var x122 = $n(x$1$1)._1__T();
    $n(x$1$1)._2__Llaika_ast_Options();
    return $n(fmt$11).comment__T__T(x122);
  }
  if ((con instanceof $c_Llaika_ast_SectionNumber)) {
    var x116 = $as_Llaika_ast_SectionNumber(con);
    var this$17 = $n(x116);
    var this$18 = $n(x116);
    var x119 = this$18.Llaika_ast_SectionNumber__f_options;
    var $x_2 = $n(fmt$11);
    var content$1 = $n(x116).Llaika_ast_SectionNumber__f_content;
    var options$1 = $n(x119).$plus__Llaika_ast_Options__Llaika_ast_Options($m_Llaika_ast_Style$().Llaika_ast_Style$__f_sectionNumber);
    return $n($x_2).child__Llaika_ast_Element__T(new $c_Llaika_ast_Text(content$1, options$1));
  }
  if ((con !== null)) {
    var x113 = $n($ps_Llaika_internal_render_HTMLRenderer__WithFallback$1__sr_LazyRef__Llaika_internal_render_HTMLRenderer$WithFallback$2$(WithFallback$lzy1$6)).unapply__Llaika_ast_Element__s_Option($as_Llaika_ast_Element(con));
    if ((!$n(x113).isEmpty__Z())) {
      var x114 = $as_Llaika_ast_Element($n(x113).get__O());
      return $n(fmt$11).child__Llaika_ast_Element__T(x114);
    }
  }
  return $n(fmt$11).textElement__T__Llaika_ast_TextContainer__sci_Seq__T("span", con, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
}
function $ps_Llaika_internal_render_HTMLRenderer__renderChoices$1__Llaika_api_format_TagFormatter__sci_Seq__Llaika_ast_Options__T(fmt$12, choices, options) {
  var content$1 = $as_sci_Seq($n(choices).flatMap__F1__O(new $c_sjsr_AnonFunction1(((choice) => {
    var choice$1 = $as_Llaika_ast_Choice(choice);
    var this$4 = $m_Llaika_ast_Paragraph$();
    var this$3 = $m_Llaika_ast_Strong$();
    var content = $n(choice$1).Llaika_ast_Choice__f_label;
    var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var span = new $c_Llaika_ast_Text(content, options$1);
    var spans = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Span.getArrayOf().constr)([]));
    var span$1 = $as_Llaika_ast_Span($f_Llaika_ast_SpanContainerCompanion__apply__Llaika_ast_Span__sci_Seq__O(this$3, span, spans));
    var spans$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Span.getArrayOf().constr)([]));
    var elem$2 = $as_Llaika_ast_Paragraph($f_Llaika_ast_SpanContainerCompanion__apply__Llaika_ast_Span__sci_Seq__O(this$4, span$1, spans$1));
    var this$5 = $n($n(choice$1).Llaika_ast_Choice__f_content);
    return $as_sc_IterableOnce(this$5.prepended__O__O(elem$2));
  }))));
  return $n(fmt$12).child__Llaika_ast_Element__T(new $c_Llaika_ast_BlockSequence(content$1, options));
}
function $p_Llaika_internal_render_HTMLRenderer__renderSimpleBlock$1__Llaika_api_format_TagFormatter__sr_LazyRef__Llaika_ast_Block__T($thiz, fmt$13, WithFallback$lzy1$7, block) {
  if ((block instanceof $c_Llaika_ast_Rule)) {
    var r = $as_Llaika_ast_Rule(block);
    return $n(fmt$13).emptyElement__T__Llaika_ast_Element__sci_Seq__T("hr", r, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if (false) {
    var x$1 = $as_Llaika_ast_InternalLinkTarget(block);
    var x153 = $n(x$1)._1__Llaika_ast_Options();
    var $x_1 = $n(fmt$13);
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var this$4 = new $c_Llaika_ast_Text("", options);
    var content = this$4.Llaika_ast_Text__f_content;
    return $n($x_1).textElement__T__Llaika_ast_TextContainer__sci_Seq__T("a", new $c_Llaika_ast_Text(content, x153), $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if ((block instanceof $c_Llaika_ast_Selection)) {
    var x$1$1 = $as_Llaika_ast_Selection(block);
    var this$6 = $n(x$1$1);
    var this$7 = $n(x$1$1);
    var x149 = this$7.Llaika_ast_Selection__f_choices;
    var this$8 = $n(x$1$1);
    var x150 = this$8.Llaika_ast_Selection__f_options;
    return $ps_Llaika_internal_render_HTMLRenderer__renderChoices$1__Llaika_api_format_TagFormatter__sci_Seq__Llaika_ast_Options__T(fmt$13, x149, x150);
  }
  if ((block instanceof $c_Llaika_ast_TargetFormat)) {
    var x$1$2 = $as_Llaika_ast_TargetFormat(block);
    var this$10 = $n(x$1$2);
    var x143 = this$10.Llaika_ast_TargetFormat__f_formats;
    var this$11 = $n(x$1$2);
    var x144 = this$11.Llaika_ast_TargetFormat__f_element;
    var this$12 = $n(x$1$2);
    var this$14 = new $c_Lcats_data_NonEmptySetOps(x143);
    var a = $thiz.Llaika_internal_render_HTMLRenderer__f_format;
    var s = this$14.Lcats_data_NonEmptySetOps__f_value;
    var this$16 = $n($as_sci_SortedSet(s));
    if (this$16.contains__O__Z(a)) {
      return $n(fmt$13).child__Llaika_ast_Element__T(x144);
    }
  }
  if ((block !== null)) {
    var x138 = $n($ps_Llaika_internal_render_HTMLRenderer__WithFallback$1__sr_LazyRef__Llaika_internal_render_HTMLRenderer$WithFallback$2$(WithFallback$lzy1$7)).unapply__Llaika_ast_Element__s_Option($as_Llaika_ast_Element(block));
    if ((!$n(x138).isEmpty__Z())) {
      var x139 = $as_Llaika_ast_Element($n(x138).get__O());
      return $n(fmt$13).child__Llaika_ast_Element__T(x139);
    }
  }
  return "";
}
function $ps_Llaika_internal_render_HTMLRenderer__renderIcon$1__Llaika_api_format_TagFormatter__Llaika_ast_Icon__T(fmt$14, icon) {
  matchResult13: {
    var \u03b41$___1;
    var \u03b41$___2;
    var \u03b41$___3;
    if (false) {
      var icon$2 = $as_Llaika_ast_IconGlyph(icon);
      var _2 = $n(icon$2).options__Llaika_ast_Options();
      var _3 = $n(icon$2).codePointAsEntity__T();
      var \u03b41$___1 = "i";
      var \u03b41$___2 = _2;
      var \u03b41$___3 = _3;
      break matchResult13;
    }
    if (false) {
      var icon$3 = $as_Llaika_ast_IconStyle(icon);
      var _2$1 = $n($m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([$n(icon$3).styleName__T()])))).$plus__Llaika_ast_Options__Llaika_ast_Options($n(icon$3).options__Llaika_ast_Options());
      var \u03b41$___1 = "i";
      var \u03b41$___2 = _2$1;
      var \u03b41$___3 = "";
      break matchResult13;
    }
    if (false) {
      var icon$4 = $as_Llaika_ast_InlineSVGIcon(icon);
      var _2$2 = $n(icon$4).options__Llaika_ast_Options();
      var _3$1 = $n(icon$4).content__T();
      var \u03b41$___1 = "span";
      var \u03b41$___2 = _2$2;
      var \u03b41$___3 = _3$1;
      break matchResult13;
    }
    if (false) {
      var icon$5 = $as_Llaika_ast_SVGSymbolIcon(icon);
      var _2$3 = $n(icon$5).options__Llaika_ast_Options();
      var _3$2 = (("<svg class=\"svg-icon\"><use class=\"svg-shape\" href=\"" + $ps_Llaika_internal_render_HTMLRenderer__renderTarget$1__Llaika_api_format_TagFormatter__Llaika_ast_Target__T(fmt$14, $n(icon$5).target__Llaika_ast_Target())) + "\"/></svg>");
      var \u03b41$___1 = "span";
      var \u03b41$___2 = _2$3;
      var \u03b41$___3 = _3$2;
      break matchResult13;
    }
    throw new $c_s_MatchError(icon);
  }
  var tagName = $as_T(\u03b41$___1);
  var options = $as_Llaika_ast_Options(\u03b41$___2);
  var content = $as_T(\u03b41$___3);
  var $x_3 = $n(fmt$14);
  var $x_2 = $n($as_Llaika_ast_Element(icon)).withOptions__Llaika_ast_Options__Llaika_ast_Element(options);
  $n(fmt$14);
  var $x_1 = $m_sr_ScalaRunTime$();
  var y = $n(icon).title__s_Option();
  var attrs = $n($x_1).wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([new $c_T2("title", y)]));
  var this$8 = $n(attrs);
  var pf = new $c_Llaika_api_format_TagFormatter$$anon$1();
  return $n($x_3).rawElement__T__Llaika_ast_Element__T__sci_Seq__T(tagName, $x_2, content, $as_sci_Seq($f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this$8, pf)));
}
function $ps_Llaika_internal_render_HTMLRenderer__sizeAttr$1__s_Option__T__T2(size, styleName) {
  var this$1 = $n(size);
  if (this$1.isEmpty__Z()) {
    var $x_1 = $m_s_None$();
  } else {
    var arg1 = this$1.get__O();
    var x$1 = $as_Llaika_ast_Length(arg1);
    matchResult14$1: {
      var $x_2;
      if ((x$1 !== null)) {
        var this$3 = $n(x$1);
        var x163 = this$3.Llaika_ast_Length__f_amount;
        var this$4 = $n(x$1);
        var x164 = this$4.Llaika_ast_Length__f_unit;
        var x = $m_Llaika_ast_LengthUnit$px$();
        if ((x === x164)) {
          var this$5 = $doubleToInt(x163);
          var value = ("" + this$5);
          var _1 = new $c_s_Some(value);
          var _2 = $m_s_None$();
          var $x_2 = new $c_T2(_1, _2);
          break matchResult14$1;
        }
      }
      if ((x$1 !== null)) {
        var _1$1 = $m_s_None$();
        var value$1 = ((styleName + ":") + $n(x$1).displayValue__T());
        var _2$1 = new $c_s_Some(value$1);
        var $x_2 = new $c_T2(_1$1, _2$1);
        break matchResult14$1;
      }
      throw new $c_s_MatchError(x$1);
    }
    var $x_1 = new $c_s_Some($x_2);
  }
  var this$11 = $n($x_1);
  if (this$11.isEmpty__Z()) {
    var _1$2 = $m_s_None$();
    var _2$2 = $m_s_None$();
    var $x_3 = new $c_T2(_1$2, _2$2);
  } else {
    var $x_3 = this$11.get__O();
  }
  return $as_T2($x_3);
}
function $ps_Llaika_internal_render_HTMLRenderer__renderSimpleSpan$1__Llaika_api_format_TagFormatter__sr_LazyRef__Llaika_ast_Span__T(fmt$15, WithFallback$lzy1$8, span) {
  if ((span instanceof $c_Llaika_ast_CitationLink)) {
    var x$1 = $as_Llaika_ast_CitationLink(span);
    var this$2 = $n(x$1);
    var x201 = this$2.Llaika_ast_CitationLink__f_refId;
    var this$3 = $n(x$1);
    var x202 = this$3.Llaika_ast_CitationLink__f_label;
    var this$4 = $n(x$1);
    var x203 = this$4.Llaika_ast_CitationLink__f_options;
    var content = (("[" + x202) + "]");
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var this$7 = new $c_Llaika_ast_Text(content, options);
    var options$1 = $n(x203).$plus__Llaika_ast_Options__Llaika_ast_Options($m_Llaika_ast_Style$().Llaika_ast_Style$__f_citation);
    var content$1 = this$7.Llaika_ast_Text__f_content;
    var text = new $c_Llaika_ast_Text(content$1, options$1);
    var $x_2 = $n(fmt$15);
    var $x_1 = $m_sr_ScalaRunTime$();
    var y = ("#" + x201);
    return $n($x_2).textElement__T__Llaika_ast_TextContainer__sci_Seq__T("a", text, $n($x_1).wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([new $c_T2("href", y)])));
  }
  if ((span instanceof $c_Llaika_ast_FootnoteLink)) {
    var x$1$1 = $as_Llaika_ast_FootnoteLink(span);
    var this$11 = $n(x$1$1);
    var x196 = this$11.Llaika_ast_FootnoteLink__f_refId;
    var this$12 = $n(x$1$1);
    var x197 = this$12.Llaika_ast_FootnoteLink__f_label;
    var this$13 = $n(x$1$1);
    var x198 = this$13.Llaika_ast_FootnoteLink__f_options;
    var content$2 = (("[" + x197) + "]");
    var options$2 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var this$16 = new $c_Llaika_ast_Text(content$2, options$2);
    var options$3 = $n(x198).$plus__Llaika_ast_Options__Llaika_ast_Options($m_Llaika_ast_Style$().Llaika_ast_Style$__f_footnote);
    var content$3 = this$16.Llaika_ast_Text__f_content;
    var text$2 = new $c_Llaika_ast_Text(content$3, options$3);
    var $x_4 = $n(fmt$15);
    var $x_3 = $m_sr_ScalaRunTime$();
    var y$1 = ("#" + x196);
    return $n($x_4).textElement__T__Llaika_ast_TextContainer__sci_Seq__T("a", text$2, $n($x_3).wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([new $c_T2("href", y$1)])));
  }
  if ((span instanceof $c_Llaika_ast_RawLink)) {
    var x$1$2 = $as_Llaika_ast_RawLink(span);
    var this$20 = $n(x$1$2);
    var x192 = this$20.Llaika_ast_RawLink__f_target;
    var this$21 = $n(x$1$2);
    return $ps_Llaika_internal_render_HTMLRenderer__renderTarget$1__Llaika_api_format_TagFormatter__Llaika_ast_Target__T(fmt$15, x192);
  }
  if ((span instanceof $c_Llaika_ast_Image)) {
    var x182 = $as_Llaika_ast_Image(span);
    var this$23 = $n(x182);
    var x184 = this$23.Llaika_ast_Image__f_target;
    var this$24 = $n(x182);
    var x185 = this$24.Llaika_ast_Image__f_width;
    var this$25 = $n(x182);
    var x186 = this$25.Llaika_ast_Image__f_height;
    var this$26 = $n(x182);
    var x187 = this$26.Llaika_ast_Image__f_alt;
    var this$27 = $n(x182);
    var x188 = this$27.Llaika_ast_Image__f_title;
    var this$28 = $n(x182);
    matchResult15: {
      var \u03b42$___1;
      var \u03b42$___2;
      var x165 = $ps_Llaika_internal_render_HTMLRenderer__sizeAttr$1__s_Option__T__T2(x185, "width");
      if ((x165 !== null)) {
        var widthAttr = $as_s_Option($n(x165)._1__O());
        var wStyle = $as_s_Option($n(x165)._2__O());
        var \u03b42$___1 = widthAttr;
        var \u03b42$___2 = wStyle;
        break matchResult15;
      }
      throw new $c_s_MatchError(x165);
    }
    var widthAttr$2 = $as_s_Option(\u03b42$___1);
    var wStyle$2 = $as_s_Option(\u03b42$___2);
    matchResult16: {
      var \u03b43$___1;
      var \u03b43$___2;
      var x168 = $ps_Llaika_internal_render_HTMLRenderer__sizeAttr$1__s_Option__T__T2(x186, "height");
      if ((x168 !== null)) {
        var heightAttr = $as_s_Option($n(x168)._1__O());
        var hStyle = $as_s_Option($n(x168)._2__O());
        var \u03b43$___1 = heightAttr;
        var \u03b43$___2 = hStyle;
        break matchResult16;
      }
      throw new $c_s_MatchError(x168);
    }
    var heightAttr$2 = $as_s_Option(\u03b43$___1);
    var hStyle$2 = $as_s_Option(\u03b43$___2);
    var this$31 = $n($m_s_Option$().option2Iterable__s_Option__sc_Iterable(wStyle$2));
    var this$32 = $n($as_sc_IterableOnceOps(this$31.concat__sc_IterableOnce__O(hStyle$2)));
    var op = new $c_sjsr_AnonFunction2(((a, b) => {
      var a$1 = $as_T(a);
      var b$1 = $as_T(b);
      return ((a$1 + ";") + b$1);
    }));
    var styleAttr = $f_sc_IterableOnceOps__reduceLeftOption__F2__s_Option(this$32, op);
    $n(fmt$15);
    var $x_5 = $m_sr_ScalaRunTime$();
    var value = $ps_Llaika_internal_render_HTMLRenderer__renderTarget$1__Llaika_api_format_TagFormatter__Llaika_ast_Target__T(fmt$15, x184);
    var y$2 = new $c_s_Some(value);
    var attrs = $n($x_5).wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([new $c_T2("src", y$2), new $c_T2("alt", x187), new $c_T2("title", x188), new $c_T2("width", widthAttr$2), new $c_T2("height", heightAttr$2), new $c_T2("style", styleAttr)]));
    var this$47 = $n(attrs);
    var pf = new $c_Llaika_api_format_TagFormatter$$anon$1();
    var allAttr = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this$47, pf));
    return $n(fmt$15).emptyElement__T__Llaika_ast_Element__sci_Seq__T("img", x182, allAttr);
  }
  if ($is_Llaika_ast_Icon(span)) {
    var icon = $as_Llaika_ast_Icon(span);
    return $ps_Llaika_internal_render_HTMLRenderer__renderIcon$1__Llaika_api_format_TagFormatter__Llaika_ast_Icon__T(fmt$15, icon);
  }
  if ((span instanceof $c_Llaika_ast_LineBreak)) {
    var lb = $as_Llaika_ast_LineBreak(span);
    return $n(fmt$15).emptyElement__T__Llaika_ast_Element__sci_Seq__T("br", lb, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if ((span instanceof $c_Llaika_ast_TemplateElement)) {
    var x$1$3 = $as_Llaika_ast_TemplateElement(span);
    var this$49 = $n(x$1$3);
    var x177 = this$49.Llaika_ast_TemplateElement__f_element;
    var this$50 = $n(x$1$3);
    var x178 = this$50.Llaika_ast_TemplateElement__f_indent;
    var this$51 = $n(x$1$3);
    var this$52 = $n(fmt$15);
    var x = $n(this$52.Llaika_internal_render_HTMLFormatter__f_context).Llaika_api_format_Formatter$Context__f_indentation;
    var x$2 = $m_Llaika_api_format_Formatter$Indentation$().Llaika_api_format_Formatter$Indentation$__f_none;
    if ((((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) || ($n($n(this$52.Llaika_internal_render_HTMLFormatter__f_context).Llaika_api_format_Formatter$Context__f_indentation).Llaika_api_format_Formatter$Indentation__f_currentLevel >= x178))) {
      var newIndentation$1 = this$52;
    } else {
      var \u03b41$ = $n(this$52.Llaika_internal_render_HTMLFormatter__f_context).Llaika_api_format_Formatter$Context__f_indentation;
      $n(\u03b41$);
      var this$53 = $n(\u03b41$);
      var numSpaces = this$53.Llaika_api_format_Formatter$Indentation__f_numSpaces;
      var this$54 = $n(\u03b41$);
      var dotted = this$54.Llaika_api_format_Formatter$Indentation__f_dotted;
      var newIndentation = new $c_Llaika_api_format_Formatter$Indentation(x178, numSpaces, dotted);
      var newIndentation$1 = this$52.withIndentation__Llaika_api_format_Formatter$Indentation__Llaika_api_format_TagFormatter(newIndentation);
    }
    return $n(newIndentation$1).child__Llaika_ast_Element__T(x177);
  }
  if ((span !== null)) {
    var x172 = $n($ps_Llaika_internal_render_HTMLRenderer__WithFallback$1__sr_LazyRef__Llaika_internal_render_HTMLRenderer$WithFallback$2$(WithFallback$lzy1$8)).unapply__Llaika_ast_Element__s_Option($as_Llaika_ast_Element(span));
    if ((!$n(x172).isEmpty__Z())) {
      var x173 = $as_Llaika_ast_Element($n(x172).get__O());
      return $n(fmt$15).child__Llaika_ast_Element__T(x173);
    }
  }
  return "";
}
function $ps_Llaika_internal_render_HTMLRenderer__renderTableElement$1__Llaika_api_format_TagFormatter__Llaika_ast_TableElement__T(fmt$16, elem) {
  if ((elem instanceof $c_Llaika_ast_TableHead)) {
    var th = $as_Llaika_ast_TableHead(elem);
    return $n(fmt$16).indentedElement__T__Llaika_ast_ElementContainer__sci_Seq__T("thead", th, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if ((elem instanceof $c_Llaika_ast_TableBody)) {
    var tb = $as_Llaika_ast_TableBody(elem);
    return $n(fmt$16).indentedElement__T__Llaika_ast_ElementContainer__sci_Seq__T("tbody", tb, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if ((elem instanceof $c_Llaika_ast_Columns)) {
    var c = $as_Llaika_ast_Columns(elem);
    return $n(fmt$16).indentedElement__T__Llaika_ast_ElementContainer__sci_Seq__T("colgroup", c, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if ((elem instanceof $c_Llaika_ast_Row)) {
    var r = $as_Llaika_ast_Row(elem);
    return $n(fmt$16).indentedElement__T__Llaika_ast_ElementContainer__sci_Seq__T("tr", r, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if ((elem instanceof $c_Llaika_ast_Caption)) {
    var c$2 = $as_Llaika_ast_Caption(elem);
    return $n(fmt$16).element__T__Llaika_ast_ElementContainer__sci_Seq__T("caption", c$2, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if ((elem instanceof $c_Llaika_ast_Column)) {
    var x$1 = $as_Llaika_ast_Column(elem);
    var this$2 = $n(x$1);
    var x209 = this$2.Llaika_ast_Column__f_options;
    var $x_1 = $n(fmt$16);
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var this$5 = new $c_Llaika_ast_Text("", options);
    var content = this$5.Llaika_ast_Text__f_content;
    return $n($x_1).textElement__T__Llaika_ast_TextContainer__sci_Seq__T("col", new $c_Llaika_ast_Text(content, x209), $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([])));
  }
  if ((elem instanceof $c_Llaika_ast_Cell)) {
    var c$3 = $as_Llaika_ast_Cell(elem);
    matchResult18: {
      var tagName;
      var x204 = $n(c$3).Llaika_ast_Cell__f_cellType;
      var x = $m_Llaika_ast_CellType$HeadCell$();
      if ((x === x204)) {
        var tagName = "th";
        break matchResult18;
      }
      var x$3 = $m_Llaika_ast_CellType$BodyCell$();
      if ((x$3 === x204)) {
        var tagName = "td";
        break matchResult18;
      }
      throw new $c_s_MatchError(x204);
    }
    $n(fmt$16);
    var $x_3 = $m_sr_ScalaRunTime$();
    var y = $ps_Llaika_internal_render_HTMLRenderer__noneIfDefault$1__O__O__s_Option($n(c$3).Llaika_ast_Cell__f_colspan, 1);
    var $x_2 = new $c_T2("colspan", y);
    var y$1 = $ps_Llaika_internal_render_HTMLRenderer__noneIfDefault$1__O__O__s_Option($n(c$3).Llaika_ast_Cell__f_rowspan, 1);
    var attrs = $n($x_3).wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$x_2, new $c_T2("rowspan", y$1)]));
    var this$11 = $n(attrs);
    var pf = new $c_Llaika_api_format_TagFormatter$$anon$1();
    var attributes = $as_sci_Seq($f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this$11, pf));
    return $ps_Llaika_internal_render_HTMLRenderer__renderBlocks$1__Llaika_api_format_TagFormatter__T__Llaika_ast_BlockContainer__sci_Seq__T(fmt$16, tagName, c$3, attributes);
  }
  throw new $c_s_MatchError(elem);
}
function $ps_Llaika_internal_render_HTMLRenderer__renderUnresolvedReference$1__Llaika_api_format_TagFormatter__Llaika_ast_Reference__T(fmt$17, ref) {
  return $n(fmt$17).child__Llaika_ast_Element__T($m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan(("unresolved reference: " + ref), $n(ref).source__Llaika_parse_SourceFragment()));
}
function $ps_Llaika_internal_render_HTMLRenderer__renderInvalidElement$1__Llaika_api_format_TagFormatter__Llaika_ast_Invalid__T(fmt$18, elem) {
  if ((elem instanceof $c_Llaika_ast_InvalidBlock)) {
    var x$1 = $as_Llaika_ast_InvalidBlock(elem);
    var this$2 = $n(x$1);
    var x218 = this$2.Llaika_ast_InvalidBlock__f_message;
    var this$3 = $n(x$1);
    var this$4 = $n(x$1);
    var x220 = this$4.Llaika_ast_InvalidBlock__f_fallback;
    var this$5 = $n(x$1);
    var x221 = this$5.Llaika_ast_InvalidBlock__f_options;
    var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_RuntimeMessage.getArrayOf().constr)([x218]));
    var content = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
    return (("" + $n(fmt$18).forMessage__Llaika_ast_RuntimeMessage__T__T(x218, $n(fmt$18).child__Llaika_ast_Element__T(new $c_Llaika_ast_Paragraph(content, x221)))) + $n(fmt$18).child__Llaika_ast_Element__T($as_Llaika_ast_Element(x220)));
  } else {
    return (("" + $n(fmt$18).forMessage__Llaika_ast_RuntimeMessage__T__T($n(elem).message__Llaika_ast_RuntimeMessage(), ($n(fmt$18).child__Llaika_ast_Element__T($n(elem).message__Llaika_ast_RuntimeMessage()) + " "))) + $n(fmt$18).child__Llaika_ast_Element__T($n(elem).fallback__Llaika_ast_Element()));
  }
}
function $ps_Llaika_internal_render_HTMLRenderer__renderRuntimeMessage$1__Llaika_api_format_TagFormatter__Llaika_ast_RuntimeMessage__T(fmt$19, message) {
  var $x_3 = $n($m_Llaika_ast_Style$().Llaika_ast_Style$__f_runtimeMessage);
  var $x_2 = $m_Llaika_ast_Styles$();
  var $x_1 = $m_sr_ScalaRunTime$();
  var this$1 = $n($n($n(message).Llaika_ast_RuntimeMessage__f_level).Llaika_ast_MessageLevel__f_toString);
  var styles = $n($x_3).$plus__Llaika_ast_Options__Llaika_ast_Options($n($x_2).apply__sci_Seq__Llaika_ast_Options($n($x_1).wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([$as_T(this$1.toLowerCase())]))));
  return $n(fmt$19).forMessage__Llaika_ast_RuntimeMessage__T__T(message, $n(fmt$19).textElement__T__Llaika_ast_TextContainer__sci_Seq__T("span", $as_Llaika_ast_TextContainer($n(message).mergeOptions__Llaika_ast_Options__Llaika_ast_Element(styles)), $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([]))));
}
/** @constructor */
function $c_Llaika_internal_render_HTMLRenderer() {
  this.Llaika_internal_render_HTMLRenderer__f_format = null;
  this.Llaika_internal_render_HTMLRenderer__f_ElementSequence$lzy1 = null;
}
$c_Llaika_internal_render_HTMLRenderer.prototype = new $h_O();
$c_Llaika_internal_render_HTMLRenderer.prototype.constructor = $c_Llaika_internal_render_HTMLRenderer;
/** @constructor */
function $h_Llaika_internal_render_HTMLRenderer() {
}
$h_Llaika_internal_render_HTMLRenderer.prototype = $c_Llaika_internal_render_HTMLRenderer.prototype;
$c_Llaika_internal_render_HTMLRenderer.prototype.toString__T = (function() {
  return "<function2>";
});
$c_Llaika_internal_render_HTMLRenderer.prototype.apply__Llaika_api_format_TagFormatter__Llaika_ast_Element__T = (function(fmt, element) {
  var WithFallback$lzy1 = new $c_sr_LazyRef();
  if ((element instanceof $c_Llaika_ast_RuntimeMessage)) {
    var e = $as_Llaika_ast_RuntimeMessage(element);
    return $ps_Llaika_internal_render_HTMLRenderer__renderRuntimeMessage$1__Llaika_api_format_TagFormatter__Llaika_ast_RuntimeMessage__T(fmt, e);
  } else if ((element instanceof $c_Llaika_ast_Table)) {
    var e$2 = $as_Llaika_ast_Table(element);
    return $p_Llaika_internal_render_HTMLRenderer__renderTable$1__Llaika_api_format_TagFormatter__Llaika_ast_Table__T(this, fmt, e$2);
  } else if ($is_Llaika_ast_TableElement(element)) {
    var e$3 = $as_Llaika_ast_TableElement(element);
    return $ps_Llaika_internal_render_HTMLRenderer__renderTableElement$1__Llaika_api_format_TagFormatter__Llaika_ast_TableElement__T(fmt, e$3);
  } else if ($is_Llaika_ast_Reference(element)) {
    var e$4 = $as_Llaika_ast_Reference(element);
    return $ps_Llaika_internal_render_HTMLRenderer__renderUnresolvedReference$1__Llaika_api_format_TagFormatter__Llaika_ast_Reference__T(fmt, e$4);
  } else if ($is_Llaika_ast_Invalid(element)) {
    var e$5 = $as_Llaika_ast_Invalid(element);
    return $ps_Llaika_internal_render_HTMLRenderer__renderInvalidElement$1__Llaika_api_format_TagFormatter__Llaika_ast_Invalid__T(fmt, e$5);
  } else if ($is_Llaika_ast_BlockContainer(element)) {
    var e$6 = $as_Llaika_ast_BlockContainer(element);
    return $p_Llaika_internal_render_HTMLRenderer__renderBlockContainer$1__Llaika_api_format_TagFormatter__sr_LazyRef__Llaika_ast_BlockContainer__T(this, fmt, WithFallback$lzy1, e$6);
  } else if ($is_Llaika_ast_SpanContainer(element)) {
    var e$7 = $as_Llaika_ast_SpanContainer(element);
    return $ps_Llaika_internal_render_HTMLRenderer__renderSpanContainer$1__Llaika_api_format_TagFormatter__sr_LazyRef__Llaika_ast_SpanContainer__T(fmt, WithFallback$lzy1, e$7);
  } else if ($is_Llaika_ast_ListContainer(element)) {
    var e$8 = $as_Llaika_ast_ListContainer(element);
    return $ps_Llaika_internal_render_HTMLRenderer__renderListContainer$1__Llaika_api_format_TagFormatter__sr_LazyRef__Llaika_ast_ListContainer__T(fmt, WithFallback$lzy1, e$8);
  } else if ($is_Llaika_ast_TextContainer(element)) {
    var e$9 = $as_Llaika_ast_TextContainer(element);
    return $p_Llaika_internal_render_HTMLRenderer__renderTextContainer$1__Llaika_api_format_TagFormatter__sr_LazyRef__Llaika_ast_TextContainer__T(this, fmt, WithFallback$lzy1, e$9);
  } else if ($is_Llaika_ast_TemplateSpanContainer(element)) {
    var e$10 = $as_Llaika_ast_TemplateSpanContainer(element);
    return $ps_Llaika_internal_render_HTMLRenderer__renderTemplateSpanContainer$1__Llaika_api_format_TagFormatter__Llaika_ast_TemplateSpanContainer__T(fmt, e$10);
  } else if ($is_Llaika_ast_Block(element)) {
    var e$11 = $as_Llaika_ast_Block(element);
    return $p_Llaika_internal_render_HTMLRenderer__renderSimpleBlock$1__Llaika_api_format_TagFormatter__sr_LazyRef__Llaika_ast_Block__T(this, fmt, WithFallback$lzy1, e$11);
  } else if ($is_Llaika_ast_Span(element)) {
    var e$12 = $as_Llaika_ast_Span(element);
    return $ps_Llaika_internal_render_HTMLRenderer__renderSimpleSpan$1__Llaika_api_format_TagFormatter__sr_LazyRef__Llaika_ast_Span__T(fmt, WithFallback$lzy1, e$12);
  } else {
    return "";
  }
});
$c_Llaika_internal_render_HTMLRenderer.prototype.apply__O__O__O = (function(v1, v2) {
  return this.apply__Llaika_api_format_TagFormatter__Llaika_ast_Element__T($as_Llaika_api_format_TagFormatter(v1), $as_Llaika_ast_Element(v2));
});
function $p_Llaika_internal_rewrite_TemplateFormatter$__indentFor$1__T__I($thiz, text) {
  var x22 = $f_T__lastIndexOf__I__I($n(text), 10);
  if ((x22 === (-1))) {
    return 0;
  }
  var this$2 = $n($f_T__trim__T($n($m_sc_StringOps$().drop$extension__T__I__T(text, x22))));
  if ((this$2 === "")) {
    var this$3 = $n(text);
    return (((-1) + ((this$3.length - x22) | 0)) | 0);
  } else {
    return 0;
  }
}
/** @constructor */
function $c_Llaika_internal_rewrite_TemplateFormatter$() {
}
$c_Llaika_internal_rewrite_TemplateFormatter$.prototype = new $h_O();
$c_Llaika_internal_rewrite_TemplateFormatter$.prototype.constructor = $c_Llaika_internal_rewrite_TemplateFormatter$;
/** @constructor */
function $h_Llaika_internal_rewrite_TemplateFormatter$() {
}
$h_Llaika_internal_rewrite_TemplateFormatter$.prototype = $c_Llaika_internal_rewrite_TemplateFormatter$.prototype;
$c_Llaika_internal_rewrite_TemplateFormatter$.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_Llaika_internal_rewrite_TemplateFormatter$.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_Llaika_internal_rewrite_TemplateFormatter$.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Llaika_internal_rewrite_TemplateFormatter$.prototype.laika$internal$rewrite$TemplateFormatter$$$joinTextSpans__sci_Seq__sci_Seq = (function(spans) {
  if ($n(spans).isEmpty__Z()) {
    return spans;
  } else {
    var this$1 = $n(spans);
    var this$18 = $n(this$1.sliding__I__I__sc_Iterator(2, 1));
    var z = $n(spans).take__I__O(1);
    var f = ((x$1, x$2) => {
      var x$1$1 = $as_sci_Seq(x$1);
      var x$2$1 = $as_sci_Seq(x$2);
      if ((x$2$1 !== null)) {
        if (($n(x$2$1).lengthCompare__I__I(2) === 0)) {
          var x12 = $as_Llaika_ast_Span($n(x$2$1).apply__I__O(0));
          var x13 = $as_Llaika_ast_Span($n(x$2$1).apply__I__O(1));
          if ((x12 instanceof $c_Llaika_ast_Text)) {
            var x$1$2 = $as_Llaika_ast_Text(x12);
            var this$9 = $n(x$1$2);
            var this$10 = $n(x$1$2);
            var x21 = this$10.Llaika_ast_Text__f_options;
            var x = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
            if ((((x === null) ? (x21 === null) : $n(x).equals__O__Z(x21)) && (x13 instanceof $c_Llaika_ast_Text))) {
              var x$1$3 = $as_Llaika_ast_Text(x13);
              var this$12 = $n(x$1$3);
              var x16 = this$12.Llaika_ast_Text__f_content;
              var this$13 = $n(x$1$3);
              var x17 = this$13.Llaika_ast_Text__f_options;
              var x$4 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
              if (((x$4 === null) ? (x17 === null) : $n(x$4).equals__O__Z(x17))) {
                var this$16 = $n($as_sc_SeqOps($n(x$1$1).dropRight__I__O(1)));
                var content = (("" + $n($as_Llaika_ast_Text($n(x$1$1).last__O())).Llaika_ast_Text__f_content) + x16);
                var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
                var elem = new $c_Llaika_ast_Text(content, options);
                return $as_sci_Seq(this$16.appended__O__O(elem));
              }
            }
          }
          var this$17 = $n(x$1$1);
          return $as_sci_Seq(this$17.appended__O__O(x13));
        }
      }
      return x$1$1;
    });
    if ($is_sc_IndexedSeq(this$18)) {
      var x2 = $as_sc_IndexedSeq(this$18);
      var at = 0;
      var end = $n(x2).length__I();
      var acc = z;
      var $x_1;
      while (true) {
        if ((at !== end)) {
          var temp$at = ((1 + at) | 0);
          var arg1 = acc;
          var arg2 = $n(x2).apply__I__O(at);
          var temp$acc = f(arg1, arg2);
          at = temp$at;
          acc = temp$acc;
          continue;
        }
        var $x_1 = acc;
        break;
      }
    } else {
      var result = z;
      while (this$18.hasNext__Z()) {
        var arg1$1 = result;
        var arg2$1 = this$18.next__O();
        result = f(arg1$1, arg2$1);
      }
      var $x_1 = result;
    }
    return $as_sci_Seq($x_1);
  }
});
$c_Llaika_internal_rewrite_TemplateFormatter$.prototype.laika$internal$rewrite$TemplateFormatter$$$format__sci_Seq__sci_Seq = (function(spans) {
  if ($n(spans).isEmpty__Z()) {
    return spans;
  } else {
    var this$1 = $n(spans);
    var this$28 = $n(this$1.sliding__I__I__sc_Iterator(2, 1));
    var this$2 = new $c_scm_ListBuffer();
    var elem = $n(spans).head__O();
    var z = this$2.addOne__O__scm_ListBuffer(elem);
    var f = ((x$1, x$2) => {
      var x$1$1 = $as_scm_ListBuffer(x$1);
      var x$2$1 = $as_sci_Seq(x$2);
      if ((x$2$1 !== null)) {
        if (($n(x$2$1).lengthCompare__I__I(2) === 0)) {
          var x48 = $as_Llaika_ast_TemplateSpan($n(x$2$1).apply__I__O(0));
          var x49 = $as_Llaika_ast_TemplateSpan($n(x$2$1).apply__I__O(1));
          if ((x48 instanceof $c_Llaika_ast_TemplateString)) {
            var x$1$2 = $as_Llaika_ast_TemplateString(x48);
            var this$10 = $n(x$1$2);
            var x57 = this$10.Llaika_ast_TemplateString__f_content;
            var this$11 = $n(x$1$2);
            var x58 = this$11.Llaika_ast_TemplateString__f_options;
            var x = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
            if ((((x === null) ? (x58 === null) : $n(x).equals__O__Z(x58)) && (x49 instanceof $c_Llaika_ast_TemplateElement))) {
              var x$1$3 = $as_Llaika_ast_TemplateElement(x49);
              var this$13 = $n(x$1$3);
              var x52 = this$13.Llaika_ast_TemplateElement__f_element;
              var this$14 = $n(x$1$3);
              var x53 = this$14.Llaika_ast_TemplateElement__f_indent;
              var this$15 = $n(x$1$3);
              var x54 = this$15.Llaika_ast_TemplateElement__f_options;
              if ((x53 === 0)) {
                var this$17 = $n(x$1$1);
                var indent = $p_Llaika_internal_rewrite_TemplateFormatter$__indentFor$1__T__I(this, x57);
                var elem$1 = new $c_Llaika_ast_TemplateElement(x52, indent, x54);
                return this$17.addOne__O__scm_ListBuffer(elem$1);
              }
            }
          }
          if ((x48 instanceof $c_Llaika_ast_TemplateString)) {
            var x$1$4 = $as_Llaika_ast_TemplateString(x48);
            var this$19 = $n(x$1$4);
            var x43 = this$19.Llaika_ast_TemplateString__f_content;
            var this$20 = $n(x$1$4);
            var x44 = this$20.Llaika_ast_TemplateString__f_options;
            var x$4 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
            if ((((x$4 === null) ? (x44 === null) : $n(x$4).equals__O__Z(x44)) && (x49 instanceof $c_Llaika_ast_EmbeddedRoot))) {
              var x$1$5 = $as_Llaika_ast_EmbeddedRoot(x49);
              var this$22 = $n(x$1$5);
              var x38 = this$22.Llaika_ast_EmbeddedRoot__f_content;
              var this$23 = $n(x$1$5);
              var x39 = this$23.Llaika_ast_EmbeddedRoot__f_indent;
              var this$24 = $n(x$1$5);
              var x40 = this$24.Llaika_ast_EmbeddedRoot__f_options;
              if ((x39 === 0)) {
                var this$26 = $n(x$1$1);
                var indent$1 = $p_Llaika_internal_rewrite_TemplateFormatter$__indentFor$1__T__I(this, x43);
                var elem$2 = new $c_Llaika_ast_EmbeddedRoot(x38, indent$1, x40);
                return this$26.addOne__O__scm_ListBuffer(elem$2);
              }
            }
          }
          var this$27 = $n(x$1$1);
          return this$27.addOne__O__scm_ListBuffer(x49);
        }
      }
      return x$1$1;
    });
    if ($is_sc_IndexedSeq(this$28)) {
      var x2 = $as_sc_IndexedSeq(this$28);
      var at = 0;
      var end = $n(x2).length__I();
      var acc = z;
      var $x_1;
      while (true) {
        if ((at !== end)) {
          var temp$at = ((1 + at) | 0);
          var arg1 = acc;
          var arg2 = $n(x2).apply__I__O(at);
          var temp$acc = f(arg1, arg2);
          at = temp$at;
          acc = temp$acc;
          continue;
        }
        var $x_1 = acc;
        break;
      }
    } else {
      var result = z;
      while (this$28.hasNext__Z()) {
        var arg1$1 = result;
        var arg2$1 = this$28.next__O();
        result = f(arg1$1, arg2$1);
      }
      var $x_1 = result;
    }
    return $n($as_scm_ListBuffer($x_1)).toList__sci_List();
  }
});
$c_Llaika_internal_rewrite_TemplateFormatter$.prototype.apply__Llaika_ast_DocumentCursor__s_util_Either = (function(cursor) {
  var rules = $n($n($m_Llaika_ast_RewriteRules$().forBlocks__s_PartialFunction__Llaika_ast_RewriteRules(new $c_Llaika_internal_rewrite_TemplateFormatter$$anon$1())).$plus$plus__Llaika_ast_RewriteRules__Llaika_ast_RewriteRules($m_Llaika_ast_RewriteRules$().forSpans__s_PartialFunction__Llaika_ast_RewriteRules(new $c_Llaika_internal_rewrite_TemplateFormatter$$anon$2()))).$plus$plus__Llaika_ast_RewriteRules__Llaika_ast_RewriteRules($m_Llaika_ast_RewriteRules$().forTemplates__s_PartialFunction__Llaika_ast_RewriteRules(new $c_Llaika_internal_rewrite_TemplateFormatter$$anon$3()));
  return new $c_s_util_Right(rules);
});
$c_Llaika_internal_rewrite_TemplateFormatter$.prototype.apply__O__O = (function(v1) {
  return this.apply__Llaika_ast_DocumentCursor__s_util_Either($as_Llaika_ast_DocumentCursor(v1));
});
$c_Llaika_internal_rewrite_TemplateFormatter$.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__Llaika_ast_DocumentCursor__s_util_Either($as_Llaika_ast_DocumentCursor(v1)));
});
var $d_Llaika_internal_rewrite_TemplateFormatter$ = new $TypeData().initClass($c_Llaika_internal_rewrite_TemplateFormatter$, "laika.internal.rewrite.TemplateFormatter$", ({
  Llaika_internal_rewrite_TemplateFormatter$: 1,
  F1: 1
}));
var $n_Llaika_internal_rewrite_TemplateFormatter$;
function $m_Llaika_internal_rewrite_TemplateFormatter$() {
  if ((!$n_Llaika_internal_rewrite_TemplateFormatter$)) {
    $n_Llaika_internal_rewrite_TemplateFormatter$ = new $c_Llaika_internal_rewrite_TemplateFormatter$();
  }
  return $n_Llaika_internal_rewrite_TemplateFormatter$;
}
/** @constructor */
function $c_Llaika_internal_rewrite_UnresolvedNodeDetector$() {
}
$c_Llaika_internal_rewrite_UnresolvedNodeDetector$.prototype = new $h_O();
$c_Llaika_internal_rewrite_UnresolvedNodeDetector$.prototype.constructor = $c_Llaika_internal_rewrite_UnresolvedNodeDetector$;
/** @constructor */
function $h_Llaika_internal_rewrite_UnresolvedNodeDetector$() {
}
$h_Llaika_internal_rewrite_UnresolvedNodeDetector$.prototype = $c_Llaika_internal_rewrite_UnresolvedNodeDetector$.prototype;
$c_Llaika_internal_rewrite_UnresolvedNodeDetector$.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_Llaika_internal_rewrite_UnresolvedNodeDetector$.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_Llaika_internal_rewrite_UnresolvedNodeDetector$.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Llaika_internal_rewrite_UnresolvedNodeDetector$.prototype.apply__Llaika_ast_DocumentCursor__s_util_Either = (function(cursor) {
  var value = $n($n($m_Llaika_ast_RewriteRules$().forBlocks__s_PartialFunction__Llaika_ast_RewriteRules(new $c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$1(this))).$plus$plus__Llaika_ast_RewriteRules__Llaika_ast_RewriteRules($m_Llaika_ast_RewriteRules$().forSpans__s_PartialFunction__Llaika_ast_RewriteRules(new $c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$2(this)))).$plus$plus__Llaika_ast_RewriteRules__Llaika_ast_RewriteRules($m_Llaika_ast_RewriteRules$().forTemplates__s_PartialFunction__Llaika_ast_RewriteRules(new $c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$3(this)));
  return new $c_s_util_Right(value);
});
$c_Llaika_internal_rewrite_UnresolvedNodeDetector$.prototype.apply__O__O = (function(v1) {
  return this.apply__Llaika_ast_DocumentCursor__s_util_Either($as_Llaika_ast_DocumentCursor(v1));
});
$c_Llaika_internal_rewrite_UnresolvedNodeDetector$.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__Llaika_ast_DocumentCursor__s_util_Either($as_Llaika_ast_DocumentCursor(v1)));
});
var $d_Llaika_internal_rewrite_UnresolvedNodeDetector$ = new $TypeData().initClass($c_Llaika_internal_rewrite_UnresolvedNodeDetector$, "laika.internal.rewrite.UnresolvedNodeDetector$", ({
  Llaika_internal_rewrite_UnresolvedNodeDetector$: 1,
  F1: 1
}));
var $n_Llaika_internal_rewrite_UnresolvedNodeDetector$;
function $m_Llaika_internal_rewrite_UnresolvedNodeDetector$() {
  if ((!$n_Llaika_internal_rewrite_UnresolvedNodeDetector$)) {
    $n_Llaika_internal_rewrite_UnresolvedNodeDetector$ = new $c_Llaika_internal_rewrite_UnresolvedNodeDetector$();
  }
  return $n_Llaika_internal_rewrite_UnresolvedNodeDetector$;
}
/** @constructor */
function $c_Llaika_parse_Message$$anon$2(msg$2, outer) {
  this.Llaika_parse_Message$$anon$2__f_msg$1 = null;
  this.Llaika_parse_Message$$anon$2__f_msg$1 = msg$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_parse_Message$$anon$2.prototype = new $h_O();
$c_Llaika_parse_Message$$anon$2.prototype.constructor = $c_Llaika_parse_Message$$anon$2;
/** @constructor */
function $h_Llaika_parse_Message$$anon$2() {
}
$h_Llaika_parse_Message$$anon$2.prototype = $c_Llaika_parse_Message$$anon$2.prototype;
$c_Llaika_parse_Message$$anon$2.prototype.message__Llaika_parse_SourceCursor__T = (function(source) {
  return this.Llaika_parse_Message$$anon$2__f_msg$1;
});
var $d_Llaika_parse_Message$$anon$2 = new $TypeData().initClass($c_Llaika_parse_Message$$anon$2, "laika.parse.Message$$anon$2", ({
  Llaika_parse_Message$$anon$2: 1,
  Llaika_parse_Message: 1
}));
/** @constructor */
function $c_Llaika_parse_Message$$anon$3(f$2, outer) {
  this.Llaika_parse_Message$$anon$3__f_f$1 = null;
  this.Llaika_parse_Message$$anon$3__f_f$1 = f$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_parse_Message$$anon$3.prototype = new $h_O();
$c_Llaika_parse_Message$$anon$3.prototype.constructor = $c_Llaika_parse_Message$$anon$3;
/** @constructor */
function $h_Llaika_parse_Message$$anon$3() {
}
$h_Llaika_parse_Message$$anon$3.prototype = $c_Llaika_parse_Message$$anon$3.prototype;
$c_Llaika_parse_Message$$anon$3.prototype.message__Llaika_parse_SourceCursor__T = (function(source) {
  return $as_T($n(this.Llaika_parse_Message$$anon$3__f_f$1).apply__O__O(source));
});
var $d_Llaika_parse_Message$$anon$3 = new $TypeData().initClass($c_Llaika_parse_Message$$anon$3, "laika.parse.Message$$anon$3", ({
  Llaika_parse_Message$$anon$3: 1,
  Llaika_parse_Message: 1
}));
/** @constructor */
function $c_Llaika_parse_Message$MessageFactory(f) {
  this.Llaika_parse_Message$MessageFactory__f_laika$parse$Message$MessageFactory$$f = null;
  this.Llaika_parse_Message$MessageFactory__f_laika$parse$Message$MessageFactory$$f = f;
}
$c_Llaika_parse_Message$MessageFactory.prototype = new $h_O();
$c_Llaika_parse_Message$MessageFactory.prototype.constructor = $c_Llaika_parse_Message$MessageFactory;
/** @constructor */
function $h_Llaika_parse_Message$MessageFactory() {
}
$h_Llaika_parse_Message$MessageFactory.prototype = $c_Llaika_parse_Message$MessageFactory.prototype;
$c_Llaika_parse_Message$MessageFactory.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_Llaika_parse_Message$MessageFactory.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_Llaika_parse_Message$MessageFactory.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Llaika_parse_Message$MessageFactory.prototype.apply__O__O = (function(v1) {
  return new $c_Llaika_parse_Message$MessageFactory$$anon$1(v1, this);
});
$c_Llaika_parse_Message$MessageFactory.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(new $c_Llaika_parse_Message$MessageFactory$$anon$1(v1, this));
});
var $d_Llaika_parse_Message$MessageFactory = new $TypeData().initClass($c_Llaika_parse_Message$MessageFactory, "laika.parse.Message$MessageFactory", ({
  Llaika_parse_Message$MessageFactory: 1,
  F1: 1
}));
/** @constructor */
function $c_Llaika_parse_Message$MessageFactory$$anon$1(value$2, outer) {
  this.Llaika_parse_Message$MessageFactory$$anon$1__f_value$1 = null;
  this.Llaika_parse_Message$MessageFactory$$anon$1__f_$outer = null;
  this.Llaika_parse_Message$MessageFactory$$anon$1__f_value$1 = value$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_parse_Message$MessageFactory$$anon$1__f_$outer = outer;
}
$c_Llaika_parse_Message$MessageFactory$$anon$1.prototype = new $h_O();
$c_Llaika_parse_Message$MessageFactory$$anon$1.prototype.constructor = $c_Llaika_parse_Message$MessageFactory$$anon$1;
/** @constructor */
function $h_Llaika_parse_Message$MessageFactory$$anon$1() {
}
$h_Llaika_parse_Message$MessageFactory$$anon$1.prototype = $c_Llaika_parse_Message$MessageFactory$$anon$1.prototype;
$c_Llaika_parse_Message$MessageFactory$$anon$1.prototype.message__Llaika_parse_SourceCursor__T = (function(source) {
  return $as_T($n($n(this.Llaika_parse_Message$MessageFactory$$anon$1__f_$outer).Llaika_parse_Message$MessageFactory__f_laika$parse$Message$MessageFactory$$f).apply__O__O(this.Llaika_parse_Message$MessageFactory$$anon$1__f_value$1));
});
var $d_Llaika_parse_Message$MessageFactory$$anon$1 = new $TypeData().initClass($c_Llaika_parse_Message$MessageFactory$$anon$1, "laika.parse.Message$MessageFactory$$anon$1", ({
  Llaika_parse_Message$MessageFactory$$anon$1: 1,
  Llaika_parse_Message: 1
}));
/** @constructor */
function $c_Llaika_parse_Parser$$anon$1(v$2, outer) {
  this.Llaika_parse_Parser$$anon$1__f_v$1 = null;
  this.Llaika_parse_Parser$$anon$1__f_v0$lzy1 = null;
  this.Llaika_parse_Parser$$anon$1__f_v0bitmap$1 = false;
  this.Llaika_parse_Parser$$anon$1__f_$outer = null;
  this.Llaika_parse_Parser$$anon$1__f_v$1 = v$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_parse_Parser$$anon$1__f_$outer = outer;
}
$c_Llaika_parse_Parser$$anon$1.prototype = new $h_Llaika_parse_Parser();
$c_Llaika_parse_Parser$$anon$1.prototype.constructor = $c_Llaika_parse_Parser$$anon$1;
/** @constructor */
function $h_Llaika_parse_Parser$$anon$1() {
}
$h_Llaika_parse_Parser$$anon$1.prototype = $c_Llaika_parse_Parser$$anon$1.prototype;
$c_Llaika_parse_Parser$$anon$1.prototype.v0__O = (function() {
  if ((!this.Llaika_parse_Parser$$anon$1__f_v0bitmap$1)) {
    this.Llaika_parse_Parser$$anon$1__f_v0$lzy1 = $n(this.Llaika_parse_Parser$$anon$1__f_v$1).apply__O();
    this.Llaika_parse_Parser$$anon$1__f_v0bitmap$1 = true;
  }
  return this.Llaika_parse_Parser$$anon$1__f_v0$lzy1;
});
$c_Llaika_parse_Parser$$anon$1.prototype.parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed = (function(in$1) {
  return $n($n(this.Llaika_parse_Parser$$anon$1__f_$outer).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(in$1)).map__F1__Llaika_parse_Parsed(new $c_sjsr_AnonFunction1(((_$2) => this.v0__O())));
});
var $d_Llaika_parse_Parser$$anon$1 = new $TypeData().initClass($c_Llaika_parse_Parser$$anon$1, "laika.parse.Parser$$anon$1", ({
  Llaika_parse_Parser$$anon$1: 1,
  Llaika_parse_Parser: 1
}));
/** @constructor */
function $c_Llaika_parse_Parser$$anon$2(f$8, outer) {
  this.Llaika_parse_Parser$$anon$2__f_f$7 = null;
  this.Llaika_parse_Parser$$anon$2__f_f$7 = f$8;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_parse_Parser$$anon$2.prototype = new $h_Llaika_parse_Parser();
$c_Llaika_parse_Parser$$anon$2.prototype.constructor = $c_Llaika_parse_Parser$$anon$2;
/** @constructor */
function $h_Llaika_parse_Parser$$anon$2() {
}
$h_Llaika_parse_Parser$$anon$2.prototype = $c_Llaika_parse_Parser$$anon$2.prototype;
$c_Llaika_parse_Parser$$anon$2.prototype.parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed = (function(source) {
  return $as_Llaika_parse_Parsed($n(this.Llaika_parse_Parser$$anon$2__f_f$7).apply__O__O(source));
});
var $d_Llaika_parse_Parser$$anon$2 = new $TypeData().initClass($c_Llaika_parse_Parser$$anon$2, "laika.parse.Parser$$anon$2", ({
  Llaika_parse_Parser$$anon$2: 1,
  Llaika_parse_Parser: 1
}));
/** @constructor */
function $c_Llaika_parse_RootSource(inputRef, offset, nestLevel) {
  this.Llaika_parse_RootSource__f_inputRef = null;
  this.Llaika_parse_RootSource__f_offset = 0;
  this.Llaika_parse_RootSource__f_nestLevel = 0;
  this.Llaika_parse_RootSource__f_input = null;
  this.Llaika_parse_RootSource__f_root = null;
  this.Llaika_parse_RootSource__f_position$lzy1 = null;
  this.Llaika_parse_RootSource__f_positionbitmap$1 = false;
  this.Llaika_parse_RootSource__f_path = null;
  this.Llaika_parse_RootSource__f_inputRef = inputRef;
  this.Llaika_parse_RootSource__f_offset = offset;
  this.Llaika_parse_RootSource__f_nestLevel = nestLevel;
  this.Llaika_parse_RootSource__f_input = $n(inputRef).Llaika_parse_InputString__f_value;
  this.Llaika_parse_RootSource__f_root = this;
  this.Llaika_parse_RootSource__f_path = $n(inputRef).Llaika_parse_InputString__f_path;
}
$c_Llaika_parse_RootSource.prototype = new $h_O();
$c_Llaika_parse_RootSource.prototype.constructor = $c_Llaika_parse_RootSource;
/** @constructor */
function $h_Llaika_parse_RootSource() {
}
$h_Llaika_parse_RootSource.prototype = $c_Llaika_parse_RootSource.prototype;
$c_Llaika_parse_RootSource.prototype.offset__I = (function() {
  return this.Llaika_parse_RootSource__f_offset;
});
$c_Llaika_parse_RootSource.prototype.nestLevel__I = (function() {
  return this.Llaika_parse_RootSource__f_nestLevel;
});
$c_Llaika_parse_RootSource.prototype.input__T = (function() {
  return this.Llaika_parse_RootSource__f_input;
});
$c_Llaika_parse_RootSource.prototype.atEnd__Z = (function() {
  var $x_1 = this.Llaika_parse_RootSource__f_offset;
  var this$1 = $n(this.Llaika_parse_RootSource__f_input);
  return ($x_1 >= this$1.length);
});
$c_Llaika_parse_RootSource.prototype.remaining__I = (function() {
  var this$1 = $n(this.Llaika_parse_RootSource__f_input);
  return ((this$1.length - this.Llaika_parse_RootSource__f_offset) | 0);
});
$c_Llaika_parse_RootSource.prototype.capture__I__T = (function(numChars) {
  var requirement = (numChars >= 0);
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: numChars cannot be negative");
  }
  var this$2 = $n(this.Llaika_parse_RootSource__f_input);
  var a = this$2.length;
  var b = ((this.Llaika_parse_RootSource__f_offset + numChars) | 0);
  var endIndex = ((a < b) ? a : b);
  var this$4 = $n(this.Llaika_parse_RootSource__f_input);
  var beginIndex = this.Llaika_parse_RootSource__f_offset;
  if ((beginIndex < 0)) {
    $charAt(this$4, beginIndex);
  }
  if ((endIndex > this$4.length)) {
    $charAt(this$4, endIndex);
  }
  if ((endIndex < beginIndex)) {
    $charAt(this$4, (-1));
  }
  return $as_T(this$4.substring(beginIndex, endIndex));
});
$c_Llaika_parse_RootSource.prototype.consume__I__Llaika_parse_RootSource = (function(numChars) {
  var toConsume = $f_Llaika_parse_SourceCursor__canConsume__I__I(this, numChars);
  return ((toConsume !== 0) ? new $c_Llaika_parse_RootSource(this.Llaika_parse_RootSource__f_inputRef, ((this.Llaika_parse_RootSource__f_offset + numChars) | 0), this.Llaika_parse_RootSource__f_nestLevel) : this);
});
$c_Llaika_parse_RootSource.prototype.root__Llaika_parse_SourceCursor = (function() {
  return this.Llaika_parse_RootSource__f_root;
});
$c_Llaika_parse_RootSource.prototype.position__Llaika_parse_Position = (function() {
  if ((!this.Llaika_parse_RootSource__f_positionbitmap$1)) {
    this.Llaika_parse_RootSource__f_position$lzy1 = ($n(this.Llaika_parse_RootSource__f_inputRef).Llaika_parse_InputString__f_isReverse ? $n(this.reverse__Llaika_parse_RootSource()).position__Llaika_parse_Position() : new $c_Llaika_parse_Position(this.Llaika_parse_RootSource__f_inputRef, this.Llaika_parse_RootSource__f_offset));
    this.Llaika_parse_RootSource__f_positionbitmap$1 = true;
  }
  return this.Llaika_parse_RootSource__f_position$lzy1;
});
$c_Llaika_parse_RootSource.prototype.path__s_Option = (function() {
  return this.Llaika_parse_RootSource__f_path;
});
$c_Llaika_parse_RootSource.prototype.nextNestLevel__Llaika_parse_RootSource = (function() {
  return new $c_Llaika_parse_RootSource(this.Llaika_parse_RootSource__f_inputRef, this.Llaika_parse_RootSource__f_offset, ((1 + this.Llaika_parse_RootSource__f_nestLevel) | 0));
});
$c_Llaika_parse_RootSource.prototype.reverse__Llaika_parse_RootSource = (function() {
  return new $c_Llaika_parse_RootSource($n(this.Llaika_parse_RootSource__f_inputRef).reverse__Llaika_parse_InputString(), this.remaining__I(), this.Llaika_parse_RootSource__f_nestLevel);
});
$c_Llaika_parse_RootSource.prototype.hashCode__I = (function() {
  var _1 = this.Llaika_parse_RootSource__f_input;
  var _2 = this.Llaika_parse_RootSource__f_offset;
  var _3 = this.Llaika_parse_RootSource__f_nestLevel;
  var this$3 = $m_s_util_hashing_MurmurHash3$();
  var h = (-889275714);
  h = this$3.mix__I__I__I(h, $f_T__hashCode__I("Tuple3"));
  var i = 0;
  while ((i < 3)) {
    var $x_1 = h;
    var n = i;
    switch (n) {
      case 0: {
        var x = _1;
        break;
      }
      case 1: {
        var x = _2;
        break;
      }
      case 2: {
        var x = _3;
        break;
      }
      default: {
        var x;
        throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 2)"));
      }
    }
    h = this$3.mix__I__I__I($x_1, $m_sr_Statics$().anyHash__O__I(x));
    i = ((1 + i) | 0);
  }
  return this$3.finalizeHash__I__I__I(h, 3);
});
$c_Llaika_parse_RootSource.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Llaika_parse_RootSource)) {
    var rs = $as_Llaika_parse_RootSource(obj);
    return ((($n(rs).Llaika_parse_RootSource__f_input === this.Llaika_parse_RootSource__f_input) && ($n(rs).Llaika_parse_RootSource__f_offset === this.Llaika_parse_RootSource__f_offset)) && ($n(rs).Llaika_parse_RootSource__f_nestLevel === this.Llaika_parse_RootSource__f_nestLevel));
  } else {
    return false;
  }
});
$c_Llaika_parse_RootSource.prototype.toString__T = (function() {
  var $x_1 = this.Llaika_parse_RootSource__f_offset;
  var this$1 = $n(this.Llaika_parse_RootSource__f_input);
  return (((("RootSource(offset " + $x_1) + " - length ") + this$1.length) + ")");
});
$c_Llaika_parse_RootSource.prototype.consume__I__Llaika_parse_SourceCursor = (function(numChars) {
  return this.consume__I__Llaika_parse_RootSource(numChars);
});
$c_Llaika_parse_RootSource.prototype.nextNestLevel__Llaika_parse_SourceCursor = (function() {
  return this.nextNestLevel__Llaika_parse_RootSource();
});
$c_Llaika_parse_RootSource.prototype.reverse__Llaika_parse_SourceCursor = (function() {
  return this.reverse__Llaika_parse_RootSource();
});
function $as_Llaika_parse_RootSource(obj) {
  return (((obj instanceof $c_Llaika_parse_RootSource) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.parse.RootSource"));
}
function $isArrayOf_Llaika_parse_RootSource(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_parse_RootSource)));
}
function $asArrayOf_Llaika_parse_RootSource(obj, depth) {
  return (($isArrayOf_Llaika_parse_RootSource(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.parse.RootSource;", depth));
}
var $d_Llaika_parse_RootSource = new $TypeData().initClass($c_Llaika_parse_RootSource, "laika.parse.RootSource", ({
  Llaika_parse_RootSource: 1,
  Llaika_parse_SourceCursor: 1
}));
function $is_Llaika_parse_SourceFragment(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_parse_SourceFragment)));
}
function $as_Llaika_parse_SourceFragment(obj) {
  return (($is_Llaika_parse_SourceFragment(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.parse.SourceFragment"));
}
function $isArrayOf_Llaika_parse_SourceFragment(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_parse_SourceFragment)));
}
function $asArrayOf_Llaika_parse_SourceFragment(obj, depth) {
  return (($isArrayOf_Llaika_parse_SourceFragment(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.parse.SourceFragment;", depth));
}
/** @constructor */
function $c_Llaika_parse_combinator_Parsers$() {
}
$c_Llaika_parse_combinator_Parsers$.prototype = new $h_O();
$c_Llaika_parse_combinator_Parsers$.prototype.constructor = $c_Llaika_parse_combinator_Parsers$;
/** @constructor */
function $h_Llaika_parse_combinator_Parsers$() {
}
$h_Llaika_parse_combinator_Parsers$.prototype = $c_Llaika_parse_combinator_Parsers$.prototype;
var $d_Llaika_parse_combinator_Parsers$ = new $TypeData().initClass($c_Llaika_parse_combinator_Parsers$, "laika.parse.combinator.Parsers$", ({
  Llaika_parse_combinator_Parsers$: 1,
  Llaika_parse_combinator_Parsers: 1
}));
var $n_Llaika_parse_combinator_Parsers$;
function $m_Llaika_parse_combinator_Parsers$() {
  if ((!$n_Llaika_parse_combinator_Parsers$)) {
    $n_Llaika_parse_combinator_Parsers$ = new $c_Llaika_parse_combinator_Parsers$();
  }
  return $n_Llaika_parse_combinator_Parsers$;
}
function $p_Llaika_parse_combinator_Repeat__rec$1__scm_ListBuffer__Llaika_parse_SourceCursor__Llaika_parse_Parser__Llaika_parse_Parsed($thiz, elems$1, source, p) {
  var p$tailLocal1 = p;
  var source$tailLocal1 = source;
  while (true) {
    if (($n(elems$1).scm_ListBuffer__f_len === $thiz.Llaika_parse_combinator_Repeat__f_max)) {
      var result = $n(elems$1).toList__sci_List();
      var next = source$tailLocal1;
      return new $c_Llaika_parse_Success(result, next);
    } else {
      var x1 = $n(p$tailLocal1).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(source$tailLocal1);
      if ((x1 instanceof $c_Llaika_parse_Success)) {
        var x$1 = $as_Llaika_parse_Success(x1);
        var this$3 = $n(x$1);
        var x6 = this$3.Llaika_parse_Success__f_result;
        var this$4 = $n(x$1);
        var x7 = this$4.Llaika_parse_Success__f_next;
        var this$5 = $n(elems$1);
        this$5.addOne__O__scm_ListBuffer(x6);
        var p$tailLocal1$tmp1 = $thiz.Llaika_parse_combinator_Repeat__f_repParser;
        source$tailLocal1 = x7;
        p$tailLocal1 = p$tailLocal1$tmp1;
        continue;
      }
      if ((x1 instanceof $c_Llaika_parse_Failure)) {
        if (($n(elems$1).scm_ListBuffer__f_len >= $thiz.Llaika_parse_combinator_Repeat__f_min)) {
          var result$1 = $n(elems$1).toList__sci_List();
          var next$1 = source$tailLocal1;
          return new $c_Llaika_parse_Success(result$1, next$1);
        }
        var f = $as_Llaika_parse_Failure(x1);
        return f;
      }
      throw new $c_s_MatchError(x1);
    }
  }
}
/** @constructor */
function $c_Llaika_parse_combinator_Repeat(parser, min, max, sep) {
  this.Llaika_parse_combinator_Repeat__f_parser = null;
  this.Llaika_parse_combinator_Repeat__f_min = 0;
  this.Llaika_parse_combinator_Repeat__f_max = 0;
  this.Llaika_parse_combinator_Repeat__f_sep = null;
  this.Llaika_parse_combinator_Repeat__f_repParser = null;
  this.Llaika_parse_combinator_Repeat__f_parser = parser;
  this.Llaika_parse_combinator_Repeat__f_min = min;
  this.Llaika_parse_combinator_Repeat__f_max = max;
  this.Llaika_parse_combinator_Repeat__f_sep = sep;
  var this$1 = $n(sep);
  if (this$1.isEmpty__Z()) {
    var $x_1 = parser;
  } else {
    var arg1 = this$1.get__O();
    var _$1 = $as_Llaika_parse_Parser(arg1);
    var $x_1 = $n(_$1).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser(parser);
  }
  this.Llaika_parse_combinator_Repeat__f_repParser = $x_1;
}
$c_Llaika_parse_combinator_Repeat.prototype = new $h_Llaika_parse_Parser();
$c_Llaika_parse_combinator_Repeat.prototype.constructor = $c_Llaika_parse_combinator_Repeat;
/** @constructor */
function $h_Llaika_parse_combinator_Repeat() {
}
$h_Llaika_parse_combinator_Repeat.prototype = $c_Llaika_parse_combinator_Repeat.prototype;
$c_Llaika_parse_combinator_Repeat.prototype.min__I__Llaika_parse_combinator_Repeat = (function(num) {
  return new $c_Llaika_parse_combinator_Repeat(this.Llaika_parse_combinator_Repeat__f_parser, num, this.Llaika_parse_combinator_Repeat__f_max, this.Llaika_parse_combinator_Repeat__f_sep);
});
$c_Llaika_parse_combinator_Repeat.prototype.max__I__Llaika_parse_combinator_Repeat = (function(num) {
  return new $c_Llaika_parse_combinator_Repeat(this.Llaika_parse_combinator_Repeat__f_parser, this.Llaika_parse_combinator_Repeat__f_min, num, this.Llaika_parse_combinator_Repeat__f_sep);
});
$c_Llaika_parse_combinator_Repeat.prototype.take__I__Llaika_parse_combinator_Repeat = (function(num) {
  return new $c_Llaika_parse_combinator_Repeat(this.Llaika_parse_combinator_Repeat__f_parser, num, num, this.Llaika_parse_combinator_Repeat__f_sep);
});
$c_Llaika_parse_combinator_Repeat.prototype.parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed = (function(source) {
  var elems = new $c_scm_ListBuffer();
  return $p_Llaika_parse_combinator_Repeat__rec$1__scm_ListBuffer__Llaika_parse_SourceCursor__Llaika_parse_Parser__Llaika_parse_Parsed(this, elems, source, this.Llaika_parse_combinator_Repeat__f_parser);
});
function $as_Llaika_parse_combinator_Repeat(obj) {
  return (((obj instanceof $c_Llaika_parse_combinator_Repeat) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.parse.combinator.Repeat"));
}
function $isArrayOf_Llaika_parse_combinator_Repeat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_parse_combinator_Repeat)));
}
function $asArrayOf_Llaika_parse_combinator_Repeat(obj, depth) {
  return (($isArrayOf_Llaika_parse_combinator_Repeat(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.parse.combinator.Repeat;", depth));
}
var $d_Llaika_parse_combinator_Repeat = new $TypeData().initClass($c_Llaika_parse_combinator_Repeat, "laika.parse.combinator.Repeat", ({
  Llaika_parse_combinator_Repeat: 1,
  Llaika_parse_Parser: 1
}));
/** @constructor */
function $c_Llaika_parse_markup_InlineParsers$() {
}
$c_Llaika_parse_markup_InlineParsers$.prototype = new $h_O();
$c_Llaika_parse_markup_InlineParsers$.prototype.constructor = $c_Llaika_parse_markup_InlineParsers$;
/** @constructor */
function $h_Llaika_parse_markup_InlineParsers$() {
}
$h_Llaika_parse_markup_InlineParsers$.prototype = $c_Llaika_parse_markup_InlineParsers$.prototype;
var $d_Llaika_parse_markup_InlineParsers$ = new $TypeData().initClass($c_Llaika_parse_markup_InlineParsers$, "laika.parse.markup.InlineParsers$", ({
  Llaika_parse_markup_InlineParsers$: 1,
  Llaika_parse_markup_InlineParsers: 1
}));
var $n_Llaika_parse_markup_InlineParsers$;
function $m_Llaika_parse_markup_InlineParsers$() {
  if ((!$n_Llaika_parse_markup_InlineParsers$)) {
    $n_Llaika_parse_markup_InlineParsers$ = new $c_Llaika_parse_markup_InlineParsers$();
  }
  return $n_Llaika_parse_markup_InlineParsers$;
}
/** @constructor */
function $c_Llaika_parse_markup_InlineParsers$SpanBuilder() {
  this.Llaika_parse_markup_InlineParsers$SpanBuilder__f_buffer = null;
  this.Llaika_parse_markup_InlineParsers$SpanBuilder__f_last = null;
  this.Llaika_parse_markup_InlineParsers$SpanBuilder__f_buffer = new $c_scm_ListBuffer();
  this.Llaika_parse_markup_InlineParsers$SpanBuilder__f_last = $m_s_None$();
}
$c_Llaika_parse_markup_InlineParsers$SpanBuilder.prototype = new $h_O();
$c_Llaika_parse_markup_InlineParsers$SpanBuilder.prototype.constructor = $c_Llaika_parse_markup_InlineParsers$SpanBuilder;
/** @constructor */
function $h_Llaika_parse_markup_InlineParsers$SpanBuilder() {
}
$h_Llaika_parse_markup_InlineParsers$SpanBuilder.prototype = $c_Llaika_parse_markup_InlineParsers$SpanBuilder.prototype;
$c_Llaika_parse_markup_InlineParsers$SpanBuilder.prototype.$plus$eq__Llaika_ast_Span__V = (function(item) {
  var _1 = this.Llaika_parse_markup_InlineParsers$SpanBuilder__f_last;
  var x1 = new $c_T2(_1, item);
  var x40 = $as_s_Option(x1.T2__f__1);
  var x41 = $as_Llaika_ast_Span(x1.T2__f__2);
  if ((x40 instanceof $c_s_Some)) {
    var x47 = $as_Llaika_ast_Span($n($as_s_Some(x40)).s_Some__f_value);
    if ((x47 instanceof $c_Llaika_ast_Text)) {
      var x$1 = $as_Llaika_ast_Text(x47);
      var this$3 = $n(x$1);
      var x50 = this$3.Llaika_ast_Text__f_content;
      var this$4 = $n(x$1);
      var x51 = this$4.Llaika_ast_Text__f_options;
      var x = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      if ((((x === null) ? (x51 === null) : $n(x).equals__O__Z(x51)) && (x41 instanceof $c_Llaika_ast_Text))) {
        var x$1$1 = $as_Llaika_ast_Text(x41);
        var this$6 = $n(x$1$1);
        var x44 = this$6.Llaika_ast_Text__f_content;
        var this$7 = $n(x$1$1);
        var x45 = this$7.Llaika_ast_Text__f_options;
        var x$3 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
        if (((x$3 === null) ? (x45 === null) : $n(x$3).equals__O__Z(x45))) {
          var content = (("" + x50) + x44);
          var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
          var value = new $c_Llaika_ast_Text(content, options);
          this.Llaika_parse_markup_InlineParsers$SpanBuilder__f_last = new $c_s_Some(value);
          return (void 0);
        }
      }
      if ((x41 instanceof $c_Llaika_ast_Reverse)) {
        var x$1$2 = $as_Llaika_ast_Reverse(x41);
        var this$15 = $n(x$1$2);
        var x30 = this$15.Llaika_ast_Reverse__f_length;
        var this$16 = $n(x$1$2);
        var x31 = this$16.Llaika_ast_Reverse__f_target;
        var this$17 = $n(x$1$2);
        var this$18 = $n(x$1$2);
        var this$19 = $n(x50);
        if ((this$19.length >= x30)) {
          var this$23 = $n(this.Llaika_parse_markup_InlineParsers$SpanBuilder__f_buffer);
          var content$1 = $m_sc_StringOps$().dropRight$extension__T__I__T(x50, x30);
          var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
          var elem = new $c_Llaika_ast_Text(content$1, options$1);
          this$23.addOne__O__scm_ListBuffer(elem);
          this.Llaika_parse_markup_InlineParsers$SpanBuilder__f_last = new $c_s_Some(x31);
          return (void 0);
        }
      }
    }
    if ((x41 instanceof $c_Llaika_ast_Reverse)) {
      var x$1$3 = $as_Llaika_ast_Reverse(x41);
      var this$26 = $n(x$1$3);
      var this$27 = $n(x$1$3);
      var this$28 = $n(x$1$3);
      var x22 = this$28.Llaika_ast_Reverse__f_fallback;
      var this$29 = $n(x$1$3);
      var this$30 = $n(this.Llaika_parse_markup_InlineParsers$SpanBuilder__f_buffer);
      this$30.addOne__O__scm_ListBuffer(x47);
      this.Llaika_parse_markup_InlineParsers$SpanBuilder__f_last = new $c_s_Some(x22);
      return (void 0);
    }
    var this$32 = $n(this.Llaika_parse_markup_InlineParsers$SpanBuilder__f_buffer);
    this$32.addOne__O__scm_ListBuffer(x47);
    this.Llaika_parse_markup_InlineParsers$SpanBuilder__f_last = new $c_s_Some(x41);
    return (void 0);
  }
  var x$5 = $m_s_None$();
  if ((x$5 === x40)) {
    if ((x41 instanceof $c_Llaika_ast_Reverse)) {
      var x$1$4 = $as_Llaika_ast_Reverse(x41);
      var this$35 = $n(x$1$4);
      var this$36 = $n(x$1$4);
      var this$37 = $n(x$1$4);
      var x10 = this$37.Llaika_ast_Reverse__f_fallback;
      var this$38 = $n(x$1$4);
      this.Llaika_parse_markup_InlineParsers$SpanBuilder__f_last = new $c_s_Some(x10);
      return (void 0);
    }
    this.Llaika_parse_markup_InlineParsers$SpanBuilder__f_last = new $c_s_Some(x41);
    return (void 0);
  }
  throw new $c_s_MatchError(x1);
});
$c_Llaika_parse_markup_InlineParsers$SpanBuilder.prototype.result__sci_List = (function() {
  var x52 = this.Llaika_parse_markup_InlineParsers$SpanBuilder__f_last;
  if ((x52 instanceof $c_s_Some)) {
    var span = $as_Llaika_ast_Span($n($as_s_Some(x52)).s_Some__f_value);
    var this$1 = $n(this.Llaika_parse_markup_InlineParsers$SpanBuilder__f_buffer);
    this$1.addOne__O__scm_ListBuffer(span);
    return $n(this.Llaika_parse_markup_InlineParsers$SpanBuilder__f_buffer).toList__sci_List();
  }
  var x = $m_s_None$();
  if ((x === x52)) {
    return $m_sci_Nil$();
  }
  throw new $c_s_MatchError(x52);
});
$c_Llaika_parse_markup_InlineParsers$SpanBuilder.prototype.fromString__T__O = (function(str) {
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  return new $c_Llaika_ast_Text(str, options);
});
$c_Llaika_parse_markup_InlineParsers$SpanBuilder.prototype.$plus$eq__O__V = (function(item) {
  this.$plus$eq__Llaika_ast_Span__V($as_Llaika_ast_Span(item));
});
$c_Llaika_parse_markup_InlineParsers$SpanBuilder.prototype.result__O = (function() {
  return this.result__sci_List();
});
var $d_Llaika_parse_markup_InlineParsers$SpanBuilder = new $TypeData().initClass($c_Llaika_parse_markup_InlineParsers$SpanBuilder, "laika.parse.markup.InlineParsers$SpanBuilder", ({
  Llaika_parse_markup_InlineParsers$SpanBuilder: 1,
  Llaika_parse_markup_InlineParsers$ResultBuilder: 1
}));
/** @constructor */
function $c_Llaika_parse_markup_InlineParsers$TextBuilder() {
  this.Llaika_parse_markup_InlineParsers$TextBuilder__f_builder = null;
  this.Llaika_parse_markup_InlineParsers$TextBuilder__f_builder = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
}
$c_Llaika_parse_markup_InlineParsers$TextBuilder.prototype = new $h_O();
$c_Llaika_parse_markup_InlineParsers$TextBuilder.prototype.constructor = $c_Llaika_parse_markup_InlineParsers$TextBuilder;
/** @constructor */
function $h_Llaika_parse_markup_InlineParsers$TextBuilder() {
}
$h_Llaika_parse_markup_InlineParsers$TextBuilder.prototype = $c_Llaika_parse_markup_InlineParsers$TextBuilder.prototype;
$c_Llaika_parse_markup_InlineParsers$TextBuilder.prototype.$plus$eq__T__V = (function(item) {
  var this$1 = $n(this.Llaika_parse_markup_InlineParsers$TextBuilder__f_builder);
  this$1.addAll__T__scm_StringBuilder(item);
});
$c_Llaika_parse_markup_InlineParsers$TextBuilder.prototype.result__T = (function() {
  var this$1 = $n(this.Llaika_parse_markup_InlineParsers$TextBuilder__f_builder);
  return $n(this$1.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_Llaika_parse_markup_InlineParsers$TextBuilder.prototype.fromString__T__O = (function(str) {
  return str;
});
$c_Llaika_parse_markup_InlineParsers$TextBuilder.prototype.$plus$eq__O__V = (function(item) {
  this.$plus$eq__T__V($as_T(item));
});
$c_Llaika_parse_markup_InlineParsers$TextBuilder.prototype.result__O = (function() {
  return this.result__T();
});
var $d_Llaika_parse_markup_InlineParsers$TextBuilder = new $TypeData().initClass($c_Llaika_parse_markup_InlineParsers$TextBuilder, "laika.parse.markup.InlineParsers$TextBuilder", ({
  Llaika_parse_markup_InlineParsers$TextBuilder: 1,
  Llaika_parse_markup_InlineParsers$ResultBuilder: 1
}));
function $is_Llaika_parse_markup_RecursiveSpanParsers(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_parse_markup_RecursiveSpanParsers)));
}
function $as_Llaika_parse_markup_RecursiveSpanParsers(obj) {
  return (($is_Llaika_parse_markup_RecursiveSpanParsers(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.parse.markup.RecursiveSpanParsers"));
}
function $isArrayOf_Llaika_parse_markup_RecursiveSpanParsers(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_parse_markup_RecursiveSpanParsers)));
}
function $asArrayOf_Llaika_parse_markup_RecursiveSpanParsers(obj, depth) {
  return (($isArrayOf_Llaika_parse_markup_RecursiveSpanParsers(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.parse.markup.RecursiveSpanParsers;", depth));
}
function $p_Llaika_parse_text_Characters__result$1__Llaika_parse_SourceCursor__I__Llaika_parse_Parsed($thiz, source$1, offset) {
  var consumed = ((offset - $n(source$1).offset__I()) | 0);
  if ((consumed >= $thiz.Llaika_parse_text_Characters__f_minChar)) {
    var result = $n($thiz.Llaika_parse_text_Characters__f_resultBuilder).apply__O__O__O(source$1, consumed);
    var next = $n(source$1).consume__I__Llaika_parse_SourceCursor(consumed);
    var $x_1 = new $c_Llaika_parse_Success(result, next);
  } else {
    var msgProvider = $as_Llaika_parse_Message($n($thiz.Llaika_parse_text_Characters__f_msgProvider).apply__O__O(consumed));
    var $x_1 = new $c_Llaika_parse_Failure(msgProvider, source$1, offset);
  }
  return $as_Llaika_parse_Parsed($x_1);
}
function $p_Llaika_parse_text_Characters__parse$1__I__T__Llaika_parse_SourceCursor__I__Llaika_parse_Parsed($thiz, maxOffset$1, sourceString$1, source$2, offset) {
  var offset$tailLocal1 = offset;
  while (true) {
    if ((offset$tailLocal1 === maxOffset$1)) {
      var $x_1 = true;
    } else {
      var $x_2 = $thiz.Llaika_parse_text_Characters__f_predicate;
      var this$1 = $n(sourceString$1);
      var index = offset$tailLocal1;
      var $x_1 = (!$uZ($n($x_2).apply__O__O($bC($charAt(this$1, index)))));
    }
    if ($x_1) {
      return $p_Llaika_parse_text_Characters__result$1__Llaika_parse_SourceCursor__I__Llaika_parse_Parsed($thiz, source$2, offset$tailLocal1);
    } else {
      offset$tailLocal1 = ((1 + offset$tailLocal1) | 0);
    }
  }
}
/** @constructor */
function $c_Llaika_parse_text_Characters(predicate, resultBuilder, minChar, maxChar) {
  this.Llaika_parse_text_Characters__f_predicate = null;
  this.Llaika_parse_text_Characters__f_resultBuilder = null;
  this.Llaika_parse_text_Characters__f_minChar = 0;
  this.Llaika_parse_text_Characters__f_maxChar = 0;
  this.Llaika_parse_text_Characters__f_msgProvider = null;
  this.Llaika_parse_text_Characters__f_predicate = predicate;
  this.Llaika_parse_text_Characters__f_resultBuilder = resultBuilder;
  this.Llaika_parse_text_Characters__f_minChar = minChar;
  this.Llaika_parse_text_Characters__f_maxChar = maxChar;
  $m_Llaika_parse_Message$();
  var f = new $c_sjsr_AnonFunction1(((actual) => {
    var actual$1 = $uI(actual);
    return ((("expected at least " + minChar) + " characters, got only ") + actual$1);
  }));
  this.Llaika_parse_text_Characters__f_msgProvider = new $c_Llaika_parse_Message$MessageFactory(f);
}
$c_Llaika_parse_text_Characters.prototype = new $h_Llaika_parse_Parser();
$c_Llaika_parse_text_Characters.prototype.constructor = $c_Llaika_parse_text_Characters;
/** @constructor */
function $h_Llaika_parse_text_Characters() {
}
$h_Llaika_parse_text_Characters.prototype = $c_Llaika_parse_text_Characters.prototype;
$c_Llaika_parse_text_Characters.prototype.min__I__Llaika_parse_text_Characters = (function(count) {
  return new $c_Llaika_parse_text_Characters(this.Llaika_parse_text_Characters__f_predicate, this.Llaika_parse_text_Characters__f_resultBuilder, count, this.Llaika_parse_text_Characters__f_maxChar);
});
$c_Llaika_parse_text_Characters.prototype.max__I__Llaika_parse_text_Characters = (function(count) {
  return new $c_Llaika_parse_text_Characters(this.Llaika_parse_text_Characters__f_predicate, this.Llaika_parse_text_Characters__f_resultBuilder, this.Llaika_parse_text_Characters__f_minChar, count);
});
$c_Llaika_parse_text_Characters.prototype.take__I__Llaika_parse_text_Characters = (function(count) {
  return new $c_Llaika_parse_text_Characters(this.Llaika_parse_text_Characters__f_predicate, this.Llaika_parse_text_Characters__f_resultBuilder, count, count);
});
$c_Llaika_parse_text_Characters.prototype.count__Llaika_parse_text_Characters = (function() {
  return new $c_Llaika_parse_text_Characters(this.Llaika_parse_text_Characters__f_predicate, $m_Llaika_parse_text_Characters$().Llaika_parse_text_Characters$__f_CountResultBuilder, this.Llaika_parse_text_Characters__f_minChar, this.Llaika_parse_text_Characters__f_maxChar);
});
$c_Llaika_parse_text_Characters.prototype.void__Llaika_parse_text_Characters = (function() {
  return new $c_Llaika_parse_text_Characters(this.Llaika_parse_text_Characters__f_predicate, $m_Llaika_parse_text_Characters$().Llaika_parse_text_Characters$__f_UnitResultBuilder, this.Llaika_parse_text_Characters__f_minChar, this.Llaika_parse_text_Characters__f_maxChar);
});
$c_Llaika_parse_text_Characters.prototype.parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed = (function(source) {
  var sourceString = $n(source).input__T();
  if (((this.Llaika_parse_text_Characters__f_maxChar < 0) || ((($n(source).offset__I() + this.Llaika_parse_text_Characters__f_maxChar) | 0) < 0))) {
    var this$1 = $n(sourceString);
    var maxOffset = this$1.length;
  } else {
    var a = (($n(source).offset__I() + this.Llaika_parse_text_Characters__f_maxChar) | 0);
    var this$2 = $n(sourceString);
    var b = this$2.length;
    var maxOffset = ((a < b) ? a : b);
  }
  return $p_Llaika_parse_text_Characters__parse$1__I__T__Llaika_parse_SourceCursor__I__Llaika_parse_Parsed(this, maxOffset, sourceString, source, $n(source).offset__I());
});
$c_Llaika_parse_text_Characters.prototype.void__Llaika_parse_Parser = (function() {
  return this.void__Llaika_parse_text_Characters();
});
var $d_Llaika_parse_text_Characters = new $TypeData().initClass($c_Llaika_parse_text_Characters, "laika.parse.text.Characters", ({
  Llaika_parse_text_Characters: 1,
  Llaika_parse_Parser: 1
}));
function $p_Llaika_parse_text_DelimitedParser__optimizedDelimiters__AB($thiz) {
  if ((!$thiz.Llaika_parse_text_DelimitedParser__f_optimizedDelimitersbitmap$1)) {
    $thiz.Llaika_parse_text_DelimitedParser__f_optimizedDelimiters$lzy1 = $m_Llaika_parse_text_Characters$().optimizedLookup__sc_Iterable__AB($n($thiz.Llaika_parse_text_DelimitedParser__f_delimiter).startChars__sci_Set());
    $thiz.Llaika_parse_text_DelimitedParser__f_optimizedDelimitersbitmap$1 = true;
  }
  return $thiz.Llaika_parse_text_DelimitedParser__f_optimizedDelimiters$lzy1;
}
function $ps_Llaika_parse_text_DelimitedParser__charsConsumed$4__I__Llaika_parse_SourceCursor__I(offset$tailLocal1$1, source$1) {
  return ((offset$tailLocal1$1 - $n(source$1).offset__I()) | 0);
}
function $p_Llaika_parse_text_DelimitedParser__parse$1__Llaika_parse_SourceCursor__I__T__AB__I__Llaika_parse_Parsed($thiz, source$2, end$1, sourceString$1, lookup$1, offset) {
  var offset$tailLocal1 = offset;
  while (true) {
    if ((offset$tailLocal1 === end$1)) {
      return $n($thiz.Llaika_parse_text_DelimitedParser__f_delimiter).atEOF__I__Llaika_parse_SourceCursor__Llaika_parse_Parsed($ps_Llaika_parse_text_DelimitedParser__charsConsumed$4__I__Llaika_parse_SourceCursor__I(offset$tailLocal1, source$2), source$2);
    } else {
      var this$1 = $n(sourceString$1);
      var index = offset$tailLocal1;
      var char = $charAt(this$1, index);
      if (((char <= $thiz.Llaika_parse_text_DelimitedParser__f_maxChar) && ($n(lookup$1).get(char) === 1))) {
        var x1 = $n($thiz.Llaika_parse_text_DelimitedParser__f_delimiter).atStartChar__C__I__Llaika_parse_SourceCursor__Llaika_parse_text_DelimiterResult(char, $ps_Llaika_parse_text_DelimitedParser__charsConsumed$4__I__Llaika_parse_SourceCursor__I(offset$tailLocal1, source$2), source$2);
        if ((x1 instanceof $c_Llaika_parse_text_DelimiterResult$Complete)) {
          var x$1 = $as_Llaika_parse_text_DelimiterResult$Complete(x1);
          var this$3 = $n(x$1);
          var x4 = this$3.Llaika_parse_text_DelimiterResult$Complete__f_result;
          return x4;
        }
        var x = $m_Llaika_parse_text_DelimiterResult$Continue$();
        if ((x === x1)) {
          offset$tailLocal1 = ((1 + offset$tailLocal1) | 0);
          continue;
        }
        throw new $c_s_MatchError(x1);
      } else {
        offset$tailLocal1 = ((1 + offset$tailLocal1) | 0);
      }
    }
  }
}
/** @constructor */
function $c_Llaika_parse_text_DelimitedParser(delimiter) {
  this.Llaika_parse_text_DelimitedParser__f_delimiter = null;
  this.Llaika_parse_text_DelimitedParser__f_maxChar = 0;
  this.Llaika_parse_text_DelimitedParser__f_optimizedDelimiters$lzy1 = null;
  this.Llaika_parse_text_DelimitedParser__f_optimizedDelimitersbitmap$1 = false;
  this.Llaika_parse_text_DelimitedParser__f_delimiter = delimiter;
  var this$1 = $n($n(delimiter).startChars__sci_Set());
  this.Llaika_parse_text_DelimitedParser__f_maxChar = ((!this$1.isEmpty__Z()) ? $uC($n($n(delimiter).startChars__sci_Set()).max__s_math_Ordering__O($m_s_math_Ordering$Char$())) : 0);
}
$c_Llaika_parse_text_DelimitedParser.prototype = new $h_Llaika_parse_Parser();
$c_Llaika_parse_text_DelimitedParser.prototype.constructor = $c_Llaika_parse_text_DelimitedParser;
/** @constructor */
function $h_Llaika_parse_text_DelimitedParser() {
}
$h_Llaika_parse_text_DelimitedParser.prototype = $c_Llaika_parse_text_DelimitedParser.prototype;
$c_Llaika_parse_text_DelimitedParser.prototype.parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed = (function(source) {
  var sourceString = $n(source).input__T();
  var this$1 = $n(sourceString);
  var end = this$1.length;
  var lookup = $p_Llaika_parse_text_DelimitedParser__optimizedDelimiters__AB(this);
  return $p_Llaika_parse_text_DelimitedParser__parse$1__Llaika_parse_SourceCursor__I__T__AB__I__Llaika_parse_Parsed(this, source, end, sourceString, lookup, $n(source).offset__I());
});
var $d_Llaika_parse_text_DelimitedParser = new $TypeData().initClass($c_Llaika_parse_text_DelimitedParser, "laika.parse.text.DelimitedParser", ({
  Llaika_parse_text_DelimitedParser: 1,
  Llaika_parse_Parser: 1
}));
function $p_Llaika_parse_text_DelimitedText__parser__Llaika_parse_text_DelimitedParser($thiz) {
  if ((!$thiz.Llaika_parse_text_DelimitedText__f_parserbitmap$1)) {
    $thiz.Llaika_parse_text_DelimitedText__f_parser$lzy1 = new $c_Llaika_parse_text_DelimitedParser($thiz.Llaika_parse_text_DelimitedText__f_delimiter);
    $thiz.Llaika_parse_text_DelimitedText__f_parserbitmap$1 = true;
  }
  return $thiz.Llaika_parse_text_DelimitedText__f_parser$lzy1;
}
/** @constructor */
function $c_Llaika_parse_text_DelimitedText(delimiter) {
  this.Llaika_parse_text_DelimitedText__f_delimiter = null;
  this.Llaika_parse_text_DelimitedText__f_parser$lzy1 = null;
  this.Llaika_parse_text_DelimitedText__f_parserbitmap$1 = false;
  this.Llaika_parse_text_DelimitedText__f_delimiter = delimiter;
}
$c_Llaika_parse_text_DelimitedText.prototype = new $h_Llaika_parse_Parser();
$c_Llaika_parse_text_DelimitedText.prototype.constructor = $c_Llaika_parse_text_DelimitedText;
/** @constructor */
function $h_Llaika_parse_text_DelimitedText() {
}
$h_Llaika_parse_text_DelimitedText.prototype = $c_Llaika_parse_text_DelimitedText.prototype;
$c_Llaika_parse_text_DelimitedText.prototype.acceptEOF__Llaika_parse_text_DelimitedText = (function() {
  $n(this.Llaika_parse_text_DelimitedText__f_delimiter);
  var this$1 = $n(this.Llaika_parse_text_DelimitedText__f_delimiter);
  var parser = this$1.Llaika_parse_text_TextDelimiter__f_parser;
  var this$2 = $n(this.Llaika_parse_text_DelimitedText__f_delimiter);
  var nonEmpty = this$2.Llaika_parse_text_TextDelimiter__f_nonEmpty;
  var this$3 = $n(this.Llaika_parse_text_DelimitedText__f_delimiter);
  var keepDelimiter = this$3.Llaika_parse_text_TextDelimiter__f_keepDelimiter;
  var this$4 = $n(this.Llaika_parse_text_DelimitedText__f_delimiter);
  var failOn = this$4.Llaika_parse_text_TextDelimiter__f_failOn;
  return new $c_Llaika_parse_text_DelimitedText(new $c_Llaika_parse_text_TextDelimiter(parser, true, nonEmpty, keepDelimiter, failOn));
});
$c_Llaika_parse_text_DelimitedText.prototype.nonEmpty__Llaika_parse_text_DelimitedText = (function() {
  $n(this.Llaika_parse_text_DelimitedText__f_delimiter);
  var this$1 = $n(this.Llaika_parse_text_DelimitedText__f_delimiter);
  var parser = this$1.Llaika_parse_text_TextDelimiter__f_parser;
  var this$2 = $n(this.Llaika_parse_text_DelimitedText__f_delimiter);
  var acceptEOF = this$2.Llaika_parse_text_TextDelimiter__f_acceptEOF;
  var this$3 = $n(this.Llaika_parse_text_DelimitedText__f_delimiter);
  var keepDelimiter = this$3.Llaika_parse_text_TextDelimiter__f_keepDelimiter;
  var this$4 = $n(this.Llaika_parse_text_DelimitedText__f_delimiter);
  var failOn = this$4.Llaika_parse_text_TextDelimiter__f_failOn;
  return new $c_Llaika_parse_text_DelimitedText(new $c_Llaika_parse_text_TextDelimiter(parser, acceptEOF, true, keepDelimiter, failOn));
});
$c_Llaika_parse_text_DelimitedText.prototype.keepDelimiter__Llaika_parse_text_DelimitedText = (function() {
  $n(this.Llaika_parse_text_DelimitedText__f_delimiter);
  var this$1 = $n(this.Llaika_parse_text_DelimitedText__f_delimiter);
  var parser = this$1.Llaika_parse_text_TextDelimiter__f_parser;
  var this$2 = $n(this.Llaika_parse_text_DelimitedText__f_delimiter);
  var acceptEOF = this$2.Llaika_parse_text_TextDelimiter__f_acceptEOF;
  var this$3 = $n(this.Llaika_parse_text_DelimitedText__f_delimiter);
  var nonEmpty = this$3.Llaika_parse_text_TextDelimiter__f_nonEmpty;
  var this$4 = $n(this.Llaika_parse_text_DelimitedText__f_delimiter);
  var failOn = this$4.Llaika_parse_text_TextDelimiter__f_failOn;
  return new $c_Llaika_parse_text_DelimitedText(new $c_Llaika_parse_text_TextDelimiter(parser, acceptEOF, nonEmpty, true, failOn));
});
$c_Llaika_parse_text_DelimitedText.prototype.failOn__sci_Seq__Llaika_parse_text_DelimitedText = (function(chars) {
  var this$1 = $n(chars);
  var failOn$1 = $m_sci_Set$().from__sc_IterableOnce__sci_Set(this$1);
  var this$2 = $n(this.Llaika_parse_text_DelimitedText__f_delimiter);
  var parser$1 = this$2.Llaika_parse_text_TextDelimiter__f_parser;
  var this$3 = $n(this.Llaika_parse_text_DelimitedText__f_delimiter);
  var acceptEOF$1 = this$3.Llaika_parse_text_TextDelimiter__f_acceptEOF;
  var this$4 = $n(this.Llaika_parse_text_DelimitedText__f_delimiter);
  var nonEmpty$1 = this$4.Llaika_parse_text_TextDelimiter__f_nonEmpty;
  var this$5 = $n(this.Llaika_parse_text_DelimitedText__f_delimiter);
  var keepDelimiter$1 = this$5.Llaika_parse_text_TextDelimiter__f_keepDelimiter;
  $n(this.Llaika_parse_text_DelimitedText__f_delimiter);
  return new $c_Llaika_parse_text_DelimitedText(new $c_Llaika_parse_text_TextDelimiter(parser$1, acceptEOF$1, nonEmpty$1, keepDelimiter$1, failOn$1));
});
$c_Llaika_parse_text_DelimitedText.prototype.parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed = (function(source) {
  return $n($p_Llaika_parse_text_DelimitedText__parser__Llaika_parse_text_DelimitedParser(this)).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(source);
});
function $as_Llaika_parse_text_DelimitedText(obj) {
  return (((obj instanceof $c_Llaika_parse_text_DelimitedText) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.parse.text.DelimitedText"));
}
function $isArrayOf_Llaika_parse_text_DelimitedText(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_parse_text_DelimitedText)));
}
function $asArrayOf_Llaika_parse_text_DelimitedText(obj, depth) {
  return (($isArrayOf_Llaika_parse_text_DelimitedText(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.parse.text.DelimitedText;", depth));
}
var $d_Llaika_parse_text_DelimitedText = new $TypeData().initClass($c_Llaika_parse_text_DelimitedText, "laika.parse.text.DelimitedText", ({
  Llaika_parse_text_DelimitedText: 1,
  Llaika_parse_Parser: 1
}));
function $f_Llaika_parse_text_TextParsers__$init$__V($thiz) {
  var this$8 = $m_Llaika_parse_Parser$();
  var f = new $c_sjsr_AnonFunction1(((in$1) => {
    var in$2 = $as_Llaika_parse_SourceCursor(in$1);
    if ($n(in$2).atEnd__Z()) {
      return new $c_Llaika_parse_Success((void 0), in$2);
    } else {
      var this$2 = $n(in$2);
      if (($f_Llaika_parse_SourceCursor__charAt__I__C(this$2, 0) === 10)) {
        var next = $n(in$2).consume__I__Llaika_parse_SourceCursor(1);
        return new $c_Llaika_parse_Success((void 0), next);
      } else {
        var this$4 = $n(in$2);
        if ((($f_Llaika_parse_SourceCursor__charAt__I__C(this$4, 0) === 13) && ($n(in$2).remaining__I() > 1))) {
          var this$5 = $n(in$2);
          var $x_2 = ($f_Llaika_parse_SourceCursor__charAt__I__C(this$5, 1) === 10);
        } else {
          var $x_2 = false;
        }
        if ($x_2) {
          var next$1 = $n(in$2).consume__I__Llaika_parse_SourceCursor(2);
          var $x_1 = new $c_Llaika_parse_Success((void 0), next$1);
        } else {
          var msgProvider = $m_Llaika_parse_Message$().Llaika_parse_Message$__f_ExpectedEOL;
          var maxOffset = $n(in$2).offset__I();
          var $x_1 = new $c_Llaika_parse_Failure(msgProvider, in$2, maxOffset);
        }
        return $as_Llaika_parse_Parsed($x_1);
      }
    }
  }));
  $thiz.laika$parse$text$TextParsers$_setter_$eol_$eq__Llaika_parse_Parser__V(new $c_Llaika_parse_Parser$$anon$2(f, this$8));
  $thiz.laika$parse$text$TextParsers$_setter_$wsEol_$eq__Llaika_parse_Parser__V($n($n($thiz.ws__Llaika_parse_text_Characters()).void__Llaika_parse_text_Characters()).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($thiz.eol__Llaika_parse_Parser()));
  var this$11 = $m_Llaika_parse_Parser$();
  var f$1 = new $c_sjsr_AnonFunction1(((in$2$1) => {
    var in$3 = $as_Llaika_parse_SourceCursor(in$2$1);
    if ($n(in$3).atEnd__Z()) {
      var $x_3 = new $c_Llaika_parse_Success("", in$3);
    } else {
      var msgProvider$1 = $m_Llaika_parse_Message$().Llaika_parse_Message$__f_ExpectedEOF;
      var maxOffset$1 = $n(in$3).offset__I();
      var $x_3 = new $c_Llaika_parse_Failure(msgProvider$1, in$3, maxOffset$1);
    }
    return $as_Llaika_parse_Parsed($x_3);
  }));
  $thiz.laika$parse$text$TextParsers$_setter_$eof_$eq__Llaika_parse_Parser__V(new $c_Llaika_parse_Parser$$anon$2(f$1, this$11));
  var this$14 = $m_Llaika_parse_Parser$();
  var f$2 = new $c_sjsr_AnonFunction1(((in$3$1) => {
    var in$4 = $as_Llaika_parse_SourceCursor(in$3$1);
    if (($n(in$4).offset__I() === 0)) {
      var $x_4 = new $c_Llaika_parse_Success((void 0), in$4);
    } else {
      var msgProvider$2 = $m_Llaika_parse_Message$().Llaika_parse_Message$__f_ExpectedStart;
      var maxOffset$2 = $n(in$4).offset__I();
      var $x_4 = new $c_Llaika_parse_Failure(msgProvider$2, in$4, maxOffset$2);
    }
    return $as_Llaika_parse_Parsed($x_4);
  }));
  $thiz.laika$parse$text$TextParsers$_setter_$atStart_$eq__Llaika_parse_Parser__V(new $c_Llaika_parse_Parser$$anon$2(f$2, this$14));
  $thiz.laika$parse$text$TextParsers$_setter_$blankLine_$eq__Llaika_parse_Parser__V($n($thiz.wsEol__Llaika_parse_Parser()).as__F0__Llaika_parse_Parser(new $c_sjsr_AnonFunction0((() => ""))));
  var p = $thiz.eof__Llaika_parse_Parser();
  var this$15 = $n($n($f_Llaika_parse_combinator_Parsers__not__Llaika_parse_Parser__Llaika_parse_Parser($thiz, p)).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($thiz.blankLine__Llaika_parse_Parser()));
  $thiz.laika$parse$text$TextParsers$_setter_$blankLines_$eq__Llaika_parse_Parser__V(new $c_Llaika_parse_combinator_Repeat(this$15, 0, 2147483647, $m_s_None$()).min__I__Llaika_parse_combinator_Repeat(1));
  var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([13])));
  $thiz.laika$parse$text$TextParsers$_setter_$restOfLine_$eq__Llaika_parse_Parser__V($n($f_Llaika_parse_text_TextParsers__anyNot__C__sci_Seq__Llaika_parse_text_Characters($thiz, 10, chars)).$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser($thiz.eol__Llaika_parse_Parser()));
  var p$1 = $thiz.blankLine__Llaika_parse_Parser();
  $thiz.laika$parse$text$TextParsers$_setter_$textLine_$eq__Llaika_parse_Parser__V($n($f_Llaika_parse_combinator_Parsers__not__Llaika_parse_Parser__Llaika_parse_Parser($thiz, p$1)).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($thiz.restOfLine__Llaika_parse_Parser()));
  var this$17 = $m_Llaika_parse_text_Characters$();
  var predicate = new $c_sjsr_AnonFunction1(((_$5) => {
    $uC(_$5);
    return true;
  }));
  $thiz.laika$parse$text$TextParsers$_setter_$anyChars_$eq__Llaika_parse_text_Characters__V(new $c_Llaika_parse_text_Characters(predicate, this$17.Llaika_parse_text_Characters$__f_StringResultBuilder, 0, (-1)));
  $thiz.laika$parse$text$TextParsers$_setter_$oneChar_$eq__Llaika_parse_Parser__V($n($thiz.anyChars__Llaika_parse_text_Characters()).take__I__Llaika_parse_text_Characters(1));
}
function $f_Llaika_parse_text_TextParsers__range__C__C__O($thiz, fromChar, toChar) {
  if ((fromChar > toChar)) {
    var this$2 = new $c_sr_RichChar(toChar);
    var range = $f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive(this$2, $bC(fromChar));
  } else {
    var this$4 = new $c_sr_RichChar(fromChar);
    var range = $f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive(this$4, $bC(toChar));
  }
  return $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet).of__O__sci_Seq__Lcats_kernel_Order__O($n(range).head__O(), $n(range).tail__sci_NumericRange(), $m_Lcats_kernel_instances_char_package$().Lcats_kernel_instances_char_package$__f_catsKernelStdOrderForChar);
}
function $f_Llaika_parse_text_TextParsers__ws__Llaika_parse_text_Characters($thiz) {
  var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([9])));
  return $f_Llaika_parse_text_TextParsers__anyOf__C__sci_Seq__Llaika_parse_text_Characters($thiz, 32, chars);
}
function $f_Llaika_parse_text_TextParsers__prevIn__C__sci_Seq__Llaika_parse_Parser($thiz, char, chars) {
  var chars$1 = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet).of__O__sci_Seq__Lcats_kernel_Order__O($bC(char), chars, $m_Lcats_kernel_instances_char_package$().Lcats_kernel_instances_char_package$__f_catsKernelStdOrderForChar);
  return $f_Llaika_parse_text_TextParsers__prevIn__O__Llaika_parse_Parser($thiz, chars$1);
}
function $f_Llaika_parse_text_TextParsers__prevIn__O__Llaika_parse_Parser($thiz, chars) {
  var predicate = new $c_sjsr_AnonFunction1(((_$3) => {
    var _$3$1 = $uC(_$3);
    var this$2 = new $c_Lcats_data_NonEmptySetOps(chars);
    var s = this$2.Lcats_data_NonEmptySetOps__f_value;
    var this$4 = $n($as_sci_SortedSet(s));
    return this$4.contains__O__Z($bC(_$3$1));
  }));
  return $f_Llaika_parse_text_TextParsers__prevIs__F1__Llaika_parse_Parser($thiz, predicate);
}
function $f_Llaika_parse_text_TextParsers__prevIs__F1__Llaika_parse_Parser($thiz, predicate) {
  $m_Llaika_parse_Message$();
  var f = new $c_sjsr_AnonFunction1(((found) => {
    var found$1 = $uC(found);
    return (("previous character '" + $cToS(found$1)) + "' does not satisfy the specified predicate");
  }));
  var errMsg = new $c_Llaika_parse_Message$MessageFactory(f);
  var this$8 = $m_Llaika_parse_Parser$();
  var f$1 = new $c_sjsr_AnonFunction1(((in$1) => {
    var in$2 = $as_Llaika_parse_SourceCursor(in$1);
    if (($n(in$2).offset__I() === 0)) {
      var this$2 = $m_Llaika_parse_Message$();
      var msgProvider = new $c_Llaika_parse_Message$$anon$2("unable to check predicate on start of input", this$2);
      var maxOffset = $n(in$2).offset__I();
      return new $c_Llaika_parse_Failure(msgProvider, in$2, maxOffset);
    } else {
      var this$4 = $n(in$2);
      if ($uZ($n(predicate).apply__O__O($bC($f_Llaika_parse_SourceCursor__charAt__I__C(this$4, (-1)))))) {
        var $x_1 = new $c_Llaika_parse_Success((void 0), in$2);
      } else {
        var this$6 = $n(in$2);
        var v1 = $f_Llaika_parse_SourceCursor__charAt__I__C(this$6, (-1));
        var msgProvider$1 = new $c_Llaika_parse_Message$MessageFactory$$anon$1($bC(v1), errMsg);
        var maxOffset$1 = $n(in$2).offset__I();
        var $x_1 = new $c_Llaika_parse_Failure(msgProvider$1, in$2, maxOffset$1);
      }
      return $as_Llaika_parse_Parsed($x_1);
    }
  }));
  return new $c_Llaika_parse_Parser$$anon$2(f$1, this$8);
}
function $f_Llaika_parse_text_TextParsers__anyOf__C__sci_Seq__Llaika_parse_text_Characters($thiz, char, chars) {
  var $x_1 = $m_Llaika_parse_text_Characters$();
  var this$1 = $n(chars);
  return $n($x_1).include__sci_Seq__Llaika_parse_text_Characters($as_sci_Seq(this$1.prepended__O__O($bC(char))));
}
function $f_Llaika_parse_text_TextParsers__anyOf__O__Llaika_parse_text_Characters($thiz, chars) {
  var $x_1 = $m_Llaika_parse_text_Characters$();
  var this$2 = new $c_Lcats_data_NonEmptySetOps(chars);
  var s = this$2.Lcats_data_NonEmptySetOps__f_value;
  var this$4 = $n($as_sci_SortedSet(s));
  return $n($x_1).include__sci_Seq__Llaika_parse_text_Characters($m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$4));
}
function $f_Llaika_parse_text_TextParsers__anyNot__C__sci_Seq__Llaika_parse_text_Characters($thiz, char, chars) {
  var $x_1 = $m_Llaika_parse_text_Characters$();
  var this$1 = $n(chars);
  return $n($x_1).exclude__sci_Seq__Llaika_parse_text_Characters($as_sci_Seq(this$1.prepended__O__O($bC(char))));
}
function $f_Llaika_parse_text_TextParsers__anyNot__O__Llaika_parse_text_Characters($thiz, chars) {
  var $x_1 = $m_Llaika_parse_text_Characters$();
  var this$2 = new $c_Lcats_data_NonEmptySetOps(chars);
  var s = this$2.Lcats_data_NonEmptySetOps__f_value;
  var this$4 = $n($as_sci_SortedSet(s));
  return $n($x_1).exclude__sci_Seq__Llaika_parse_text_Characters($m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$4));
}
function $f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser($thiz, char, chars) {
  var startChars = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet).of__O__sci_Seq__Lcats_kernel_Order__O($bC(char), chars, $m_Lcats_kernel_instances_char_package$().Lcats_kernel_instances_char_package$__f_catsKernelStdOrderForChar);
  return new $c_Llaika_parse_text_PrefixCharacters($n($f_Llaika_parse_text_TextParsers__anyOf__O__Llaika_parse_text_Characters($thiz, startChars)).take__I__Llaika_parse_text_Characters(1), startChars);
}
function $f_Llaika_parse_text_TextParsers__oneOf__O__Llaika_parse_text_PrefixedParser($thiz, chars) {
  return new $c_Llaika_parse_text_PrefixCharacters($n($f_Llaika_parse_text_TextParsers__anyOf__O__Llaika_parse_text_Characters($thiz, chars)).take__I__Llaika_parse_text_Characters(1), chars);
}
function $f_Llaika_parse_text_TextParsers__someOf__C__sci_Seq__Llaika_parse_text_PrefixCharacters($thiz, char, chars) {
  var startChars = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet).of__O__sci_Seq__Lcats_kernel_Order__O($bC(char), chars, $m_Lcats_kernel_instances_char_package$().Lcats_kernel_instances_char_package$__f_catsKernelStdOrderForChar);
  return new $c_Llaika_parse_text_PrefixCharacters($n($f_Llaika_parse_text_TextParsers__anyOf__O__Llaika_parse_text_Characters($thiz, startChars)).min__I__Llaika_parse_text_Characters(1), startChars);
}
function $f_Llaika_parse_text_TextParsers__someOf__O__Llaika_parse_text_PrefixCharacters($thiz, chars) {
  return new $c_Llaika_parse_text_PrefixCharacters($n($f_Llaika_parse_text_TextParsers__anyOf__O__Llaika_parse_text_Characters($thiz, chars)).min__I__Llaika_parse_text_Characters(1), chars);
}
function $f_Llaika_parse_text_TextParsers__someNot__C__sci_Seq__Llaika_parse_text_Characters($thiz, char, chars) {
  var $x_1 = $m_Llaika_parse_text_Characters$();
  var this$1 = $n(chars);
  return $n($n($x_1).exclude__sci_Seq__Llaika_parse_text_Characters($as_sci_Seq(this$1.prepended__O__O($bC(char))))).min__I__Llaika_parse_text_Characters(1);
}
function $f_Llaika_parse_text_TextParsers__someNot__O__Llaika_parse_text_Characters($thiz, chars) {
  var $x_1 = $m_Llaika_parse_text_Characters$();
  var this$2 = new $c_Lcats_data_NonEmptySetOps(chars);
  var s = this$2.Lcats_data_NonEmptySetOps__f_value;
  var this$4 = $n($as_sci_SortedSet(s));
  return $n($n($x_1).exclude__sci_Seq__Llaika_parse_text_Characters($m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$4))).min__I__Llaika_parse_text_Characters(1);
}
function $f_Llaika_parse_text_TextParsers__someWhile__F1__Llaika_parse_text_Characters($thiz, p) {
  var this$1 = $m_Llaika_parse_text_Characters$();
  return new $c_Llaika_parse_text_Characters(p, this$1.Llaika_parse_text_Characters$__f_StringResultBuilder, 0, (-1)).min__I__Llaika_parse_text_Characters(1);
}
function $f_Llaika_parse_text_TextParsers__delimitedBy__C__sci_Seq__Llaika_parse_text_DelimitedText($thiz, char, chars) {
  return new $c_Llaika_parse_text_DelimitedText($m_Llaika_parse_text_TextDelimiter$().apply__Llaika_parse_text_PrefixedParser__Llaika_parse_text_TextDelimiter($f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser($thiz, char, chars)));
}
function $f_Llaika_parse_text_TextParsers__delimitedBy__O__Llaika_parse_text_DelimitedText($thiz, chars) {
  return new $c_Llaika_parse_text_DelimitedText($m_Llaika_parse_text_TextDelimiter$().apply__Llaika_parse_text_PrefixedParser__Llaika_parse_text_TextDelimiter($f_Llaika_parse_text_TextParsers__oneOf__O__Llaika_parse_text_PrefixedParser($thiz, chars)));
}
function $f_Llaika_parse_text_TextParsers__delimitedBy__T__Llaika_parse_text_DelimitedText($thiz, str) {
  var this$1 = $n(str);
  if ((this$1 === "")) {
    return $m_Llaika_parse_text_DelimitedText$().Undelimited__Llaika_parse_text_DelimitedText();
  } else {
    var delimiter = new $c_Llaika_parse_text_Literal(str);
    return $f_Llaika_parse_text_TextParsers__delimitedBy__Llaika_parse_text_PrefixedParser__Llaika_parse_text_DelimitedText($thiz, delimiter);
  }
}
function $f_Llaika_parse_text_TextParsers__delimitedBy__Llaika_parse_text_PrefixedParser__Llaika_parse_text_DelimitedText($thiz, delimiter) {
  return new $c_Llaika_parse_text_DelimitedText($m_Llaika_parse_text_TextDelimiter$().apply__Llaika_parse_text_PrefixedParser__Llaika_parse_text_TextDelimiter(delimiter));
}
function $f_Llaika_parse_text_TextParsers__delimiter__C__sci_Seq__Llaika_parse_text_DelimiterParser($thiz, char, chars) {
  return new $c_Llaika_parse_text_DelimiterParser($f_Llaika_parse_text_TextParsers__oneOf__C__sci_Seq__Llaika_parse_text_PrefixedParser($thiz, char, chars), $m_Llaika_parse_text_DelimiterParser$().$lessinit$greater$default$2__F1(), $m_Llaika_parse_text_DelimiterParser$().$lessinit$greater$default$3__F1(), $m_Llaika_parse_text_DelimiterParser$().$lessinit$greater$default$4__F2());
}
function $f_Llaika_parse_text_TextParsers__delimiter__T__Llaika_parse_text_DelimiterParser($thiz, delim) {
  return new $c_Llaika_parse_text_DelimiterParser(new $c_Llaika_parse_text_Literal(delim), $m_Llaika_parse_text_DelimiterParser$().$lessinit$greater$default$2__F1(), $m_Llaika_parse_text_DelimiterParser$().$lessinit$greater$default$3__F1(), $m_Llaika_parse_text_DelimiterParser$().$lessinit$greater$default$4__F2());
}
/** @constructor */
function $c_Llaika_parse_text_WhitespacePreprocessor() {
  this.Llaika_parse_text_WhitespacePreprocessor__f_tabStops = 0;
  this.Llaika_parse_text_WhitespacePreprocessor__f_tabStops = 4;
}
$c_Llaika_parse_text_WhitespacePreprocessor.prototype = new $h_O();
$c_Llaika_parse_text_WhitespacePreprocessor.prototype.constructor = $c_Llaika_parse_text_WhitespacePreprocessor;
/** @constructor */
function $h_Llaika_parse_text_WhitespacePreprocessor() {
}
$h_Llaika_parse_text_WhitespacePreprocessor.prototype = $c_Llaika_parse_text_WhitespacePreprocessor.prototype;
$c_Llaika_parse_text_WhitespacePreprocessor.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_Llaika_parse_text_WhitespacePreprocessor.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_Llaika_parse_text_WhitespacePreprocessor.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Llaika_parse_text_WhitespacePreprocessor.prototype.apply__T__T = (function(input) {
  var this$1 = $n(input);
  var end = this$1.length;
  var buf = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var elem = 0;
  elem = 0;
  var col = 0;
  var elem$1 = 0;
  elem$1 = 0;
  while ((elem < end)) {
    var this$4 = $n(input);
    var index = elem;
    var x1 = $charAt(this$4, index);
    switch (x1) {
      case 12:
      case 11: {
        var this$5 = $n(input);
        var beginIndex = elem$1;
        var endIndex = elem;
        if ((beginIndex < 0)) {
          $charAt(this$5, beginIndex);
        }
        if ((endIndex > this$5.length)) {
          $charAt(this$5, endIndex);
        }
        if ((endIndex < beginIndex)) {
          $charAt(this$5, (-1));
        }
        var s = $as_T(this$5.substring(beginIndex, endIndex));
        var this$6 = $n(buf.addAll__T__scm_StringBuilder(s));
        this$6.addAll__T__scm_StringBuilder(" ");
        var ev$1 = ((1 + elem) | 0);
        elem$1 = ev$1;
        col = ((1 + col) | 0);
        break;
      }
      case 13: {
        var this$7 = $n(input);
        var beginIndex$1 = elem$1;
        var endIndex$1 = elem;
        if ((beginIndex$1 < 0)) {
          $charAt(this$7, beginIndex$1);
        }
        if ((endIndex$1 > this$7.length)) {
          $charAt(this$7, endIndex$1);
        }
        if ((endIndex$1 < beginIndex$1)) {
          $charAt(this$7, (-1));
        }
        var s$1 = $as_T(this$7.substring(beginIndex$1, endIndex$1));
        var this$8 = $n(buf.addAll__T__scm_StringBuilder(s$1));
        this$8.addAll__T__scm_StringBuilder("");
        var ev$1$1 = ((1 + elem) | 0);
        elem$1 = ev$1$1;
        break;
      }
      case 10: {
        col = 0;
        break;
      }
      case 9: {
        var spaces = ((this.Llaika_parse_text_WhitespacePreprocessor__f_tabStops - $intMod(col, this.Llaika_parse_text_WhitespacePreprocessor__f_tabStops)) | 0);
        var add = $m_sc_StringOps$().$times$extension__T__I__T(" ", spaces);
        var this$10 = $n(input);
        var beginIndex$2 = elem$1;
        var endIndex$2 = elem;
        if ((beginIndex$2 < 0)) {
          $charAt(this$10, beginIndex$2);
        }
        if ((endIndex$2 > this$10.length)) {
          $charAt(this$10, endIndex$2);
        }
        if ((endIndex$2 < beginIndex$2)) {
          $charAt(this$10, (-1));
        }
        var s$2 = $as_T(this$10.substring(beginIndex$2, endIndex$2));
        var this$11 = $n(buf.addAll__T__scm_StringBuilder(s$2));
        this$11.addAll__T__scm_StringBuilder(add);
        var ev$1$2 = ((1 + elem) | 0);
        elem$1 = ev$1$2;
        col = ((col + spaces) | 0);
        break;
      }
      default: {
        col = ((1 + col) | 0);
      }
    }
    var ev$2 = ((1 + elem) | 0);
    elem = ev$2;
  }
  var this$12 = $n(input);
  var beginIndex$3 = elem$1;
  if (((beginIndex$3 < 0) || (beginIndex$3 > this$12.length))) {
    $charAt(this$12, beginIndex$3);
  }
  var s$3 = $as_T(this$12.substring(beginIndex$3));
  buf.addAll__T__scm_StringBuilder(s$3);
  return $n(buf.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_Llaika_parse_text_WhitespacePreprocessor.prototype.apply__O__O = (function(v1) {
  return this.apply__T__T($as_T(v1));
});
$c_Llaika_parse_text_WhitespacePreprocessor.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__T__T($as_T(v1)));
});
var $d_Llaika_parse_text_WhitespacePreprocessor = new $TypeData().initClass($c_Llaika_parse_text_WhitespacePreprocessor, "laika.parse.text.WhitespacePreprocessor", ({
  Llaika_parse_text_WhitespacePreprocessor: 1,
  F1: 1
}));
/** @constructor */
function $c_s_$less$colon$less$() {
  this.s_$less$colon$less$__f_singleton = null;
  $n_s_$less$colon$less$ = this;
  this.s_$less$colon$less$__f_singleton = new $c_s_$less$colon$less$$anon$1();
}
$c_s_$less$colon$less$.prototype = new $h_O();
$c_s_$less$colon$less$.prototype.constructor = $c_s_$less$colon$less$;
/** @constructor */
function $h_s_$less$colon$less$() {
}
$h_s_$less$colon$less$.prototype = $c_s_$less$colon$less$.prototype;
var $d_s_$less$colon$less$ = new $TypeData().initClass($c_s_$less$colon$less$, "scala.$less$colon$less$", ({
  s_$less$colon$less$: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_$less$colon$less$;
function $m_s_$less$colon$less$() {
  if ((!$n_s_$less$colon$less$)) {
    $n_s_$less$colon$less$ = new $c_s_$less$colon$less$();
  }
  return $n_s_$less$colon$less$;
}
function $p_s_Array$__slowcopy__O__I__O__I__I__V($thiz, src, srcPos, dest, destPos, length) {
  var i = srcPos;
  var j = destPos;
  var srcUntil = ((srcPos + length) | 0);
  while ((i < srcUntil)) {
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest, j, $m_sr_ScalaRunTime$().array_apply__O__I__O(src, i));
    i = ((1 + i) | 0);
    j = ((1 + j) | 0);
  }
}
function $p_s_Array$__newUnitArray__I__Ajl_Void($thiz, len) {
  var result = new ($d_jl_Void.getArrayOf().constr)(len);
  $m_ju_Arrays$().fill__AO__O__V(result, (void 0));
  return result;
}
/** @constructor */
function $c_s_Array$() {
}
$c_s_Array$.prototype = new $h_O();
$c_s_Array$.prototype.constructor = $c_s_Array$;
/** @constructor */
function $h_s_Array$() {
}
$h_s_Array$.prototype = $c_s_Array$.prototype;
$c_s_Array$.prototype.from__sc_IterableOnce__s_reflect_ClassTag__O = (function(it, evidence$3) {
  var n = $n(it).knownSize__I();
  if ((n > (-1))) {
    var elements = $n(evidence$3).newArray__I__O(n);
    var iterator = $n(it).iterator__sc_Iterator();
    var i = 0;
    while ((i < n)) {
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(elements, i, $n(iterator).next__O());
      i = ((1 + i) | 0);
    }
    return elements;
  } else {
    var capacity = 0;
    var jsElems = null;
    var elementClass = $n(evidence$3).runtimeClass__jl_Class();
    capacity = 0;
    var isCharArrayBuilder = (elementClass === $d_C.getClassOf());
    jsElems = [];
    var iterator$2 = $n(it).iterator__sc_Iterator();
    while ($n(iterator$2).hasNext__Z()) {
      var elem = $n(iterator$2).next__O();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $n(elementClass).jl_Class__f_data.zero : elem));
      jsElems.push(unboxedElem);
    }
    var elemRuntimeClass = ((elementClass === $d_V.getClassOf()) ? $d_jl_Void.getClassOf() : (((elementClass === $d_sr_Null$.getClassOf()) || (elementClass === $d_sr_Nothing$.getClassOf())) ? $d_O.getClassOf() : elementClass));
    return $n(elemRuntimeClass).jl_Class__f_data.getArrayOf().wrapArray(jsElems);
  }
});
$c_s_Array$.prototype.copy__O__I__O__I__I__V = (function(src, srcPos, dest, destPos, length) {
  var this$1 = $n(src);
  var srcClass = $objectGetClass(this$1);
  if ($n(srcClass).isArray__Z()) {
    var this$2 = $n(dest);
    var $x_1 = $n($objectGetClass(this$2)).isAssignableFrom__jl_Class__Z(srcClass);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    $systemArraycopyFull($n(src), srcPos, $n(dest), destPos, length);
  } else {
    $p_s_Array$__slowcopy__O__I__O__I__I__V(this, src, srcPos, dest, destPos, length);
  }
});
$c_s_Array$.prototype.copyOf__O__I__O = (function(original, newLength) {
  if ($isArrayOf_jl_Void(original, 1)) {
    return $p_s_Array$__newUnitArray__I__Ajl_Void(this, newLength);
  } else if ((original instanceof $ac_O)) {
    var x3 = $asArrayOf_O(original, 1);
    return $m_ju_Arrays$().copyOf__AO__I__AO(x3, newLength);
  } else if ((original instanceof $ac_I)) {
    var x4 = $asArrayOf_I(original, 1);
    return $m_ju_Arrays$().copyOf__AI__I__AI(x4, newLength);
  } else if ((original instanceof $ac_D)) {
    var x5 = $asArrayOf_D(original, 1);
    return $m_ju_Arrays$().copyOf__AD__I__AD(x5, newLength);
  } else if ((original instanceof $ac_J)) {
    var x6 = $asArrayOf_J(original, 1);
    return $m_ju_Arrays$().copyOf__AJ__I__AJ(x6, newLength);
  } else if ((original instanceof $ac_F)) {
    var x7 = $asArrayOf_F(original, 1);
    return $m_ju_Arrays$().copyOf__AF__I__AF(x7, newLength);
  } else if ((original instanceof $ac_C)) {
    var x8 = $asArrayOf_C(original, 1);
    return $m_ju_Arrays$().copyOf__AC__I__AC(x8, newLength);
  } else if ((original instanceof $ac_B)) {
    var x9 = $asArrayOf_B(original, 1);
    return $m_ju_Arrays$().copyOf__AB__I__AB(x9, newLength);
  } else if ((original instanceof $ac_S)) {
    var x10 = $asArrayOf_S(original, 1);
    return $m_ju_Arrays$().copyOf__AS__I__AS(x10, newLength);
  } else if ((original instanceof $ac_Z)) {
    var x11 = $asArrayOf_Z(original, 1);
    return $m_ju_Arrays$().copyOf__AZ__I__AZ(x11, newLength);
  } else {
    throw new $c_s_MatchError(original);
  }
});
$c_s_Array$.prototype.copyAs__O__I__s_reflect_ClassTag__O = (function(original, newLength, ct) {
  var runtimeClass = $n(ct).runtimeClass__jl_Class();
  if ((runtimeClass !== null)) {
    var this$1 = $n(runtimeClass);
    var $x_1 = (this$1 === $d_V.getClassOf());
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return $p_s_Array$__newUnitArray__I__Ajl_Void(this, newLength);
  } else {
    var this$2 = $n(original);
    if ($n(runtimeClass).isAssignableFrom__jl_Class__Z($n($objectGetClass(this$2)).getComponentType__jl_Class())) {
      if ($n(runtimeClass).isPrimitive__Z()) {
        return this.copyOf__O__I__O(original, newLength);
      } else {
        var this$3 = $n($m_jl_reflect_Array$().newInstance__jl_Class__I__O(runtimeClass, 0));
        var destArrayClass = $objectGetClass(this$3);
        var original$1 = $asArrayOf_O(original, 1);
        return $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original$1, newLength, destArrayClass);
      }
    } else {
      var dest = $n(ct).newArray__I__O(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(original, 0, dest, 0, $m_jl_reflect_Array$().getLength__O__I(original));
      return dest;
    }
  }
});
$c_s_Array$.prototype.equals__AO__AO__Z = (function(xs, ys) {
  if ((xs === ys)) {
    return true;
  }
  if (($n(xs).u.length !== $n(ys).u.length)) {
    return false;
  }
  var len = $n(xs).u.length;
  var i = 0;
  while ((i < len)) {
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z($n(xs).get(i), $n(ys).get(i)))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
var $d_s_Array$ = new $TypeData().initClass($c_s_Array$, "scala.Array$", ({
  s_Array$: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_Array$;
function $m_s_Array$() {
  if ((!$n_s_Array$)) {
    $n_s_Array$ = new $c_s_Array$();
  }
  return $n_s_Array$;
}
/** @constructor */
function $c_s_Console$() {
  this.s_Console$__f_outVar = null;
  $n_s_Console$ = this;
  this.s_Console$__f_outVar = new $c_s_util_DynamicVariable($m_jl_System$Streams$().jl_System$Streams$__f_out);
}
$c_s_Console$.prototype = new $h_O();
$c_s_Console$.prototype.constructor = $c_s_Console$;
/** @constructor */
function $h_s_Console$() {
}
$h_s_Console$.prototype = $c_s_Console$.prototype;
$c_s_Console$.prototype.out__Ljava_io_PrintStream = (function() {
  return $as_Ljava_io_PrintStream($n(this.s_Console$__f_outVar).s_util_DynamicVariable__f_v);
});
var $d_s_Console$ = new $TypeData().initClass($c_s_Console$, "scala.Console$", ({
  s_Console$: 1,
  s_io_AnsiColor: 1
}));
var $n_s_Console$;
function $m_s_Console$() {
  if ((!$n_s_Console$)) {
    $n_s_Console$ = new $c_s_Console$();
  }
  return $n_s_Console$;
}
/** @constructor */
function $c_s_LowPriorityImplicits() {
}
$c_s_LowPriorityImplicits.prototype = new $h_s_LowPriorityImplicits2();
$c_s_LowPriorityImplicits.prototype.constructor = $c_s_LowPriorityImplicits;
/** @constructor */
function $h_s_LowPriorityImplicits() {
}
$h_s_LowPriorityImplicits.prototype = $c_s_LowPriorityImplicits.prototype;
$c_s_LowPriorityImplicits.prototype.wrapRefArray__AO__scm_ArraySeq$ofRef = (function(xs) {
  if ((xs === null)) {
    return null;
  } else if (($n(xs).u.length === 0)) {
    var this$1 = $m_scm_ArraySeq$();
    return this$1.scm_ArraySeq$__f_EmptyArraySeq;
  } else {
    return new $c_scm_ArraySeq$ofRef(xs);
  }
});
$c_s_LowPriorityImplicits.prototype.wrapString__T__sci_WrappedString = (function(s) {
  return ((s !== null) ? new $c_sci_WrappedString(s) : null);
});
/** @constructor */
function $c_s_Option$() {
}
$c_s_Option$.prototype = new $h_O();
$c_s_Option$.prototype.constructor = $c_s_Option$;
/** @constructor */
function $h_s_Option$() {
}
$h_s_Option$.prototype = $c_s_Option$.prototype;
$c_s_Option$.prototype.option2Iterable__s_Option__sc_Iterable = (function(xo) {
  if ($n(xo).isEmpty__Z()) {
    return $as_sc_Iterable($m_sc_Iterable$().empty__O());
  } else {
    var a = $n(xo).get__O();
    return new $c_sc_Iterable$$anon$1(a);
  }
});
$c_s_Option$.prototype.apply__O__s_Option = (function(x) {
  return ((x === null) ? $m_s_None$() : new $c_s_Some(x));
});
var $d_s_Option$ = new $TypeData().initClass($c_s_Option$, "scala.Option$", ({
  s_Option$: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_Option$;
function $m_s_Option$() {
  if ((!$n_s_Option$)) {
    $n_s_Option$ = new $c_s_Option$();
  }
  return $n_s_Option$;
}
function $f_s_PartialFunction__andThen__F1__s_PartialFunction($thiz, k) {
  if ($is_s_PartialFunction(k)) {
    var x2 = $as_s_PartialFunction(k);
    return new $c_s_PartialFunction$Combined($thiz, x2);
  } else {
    return new $c_s_PartialFunction$AndThen($thiz, k);
  }
}
function $f_s_PartialFunction__applyOrElse__O__F1__O($thiz, x, default$1) {
  return ($thiz.isDefinedAt__O__Z(x) ? $thiz.apply__O__O(x) : $n(default$1).apply__O__O(x));
}
function $f_s_PartialFunction__runWith__F1__F1($thiz, action) {
  return new $c_sjsr_AnonFunction1(((x$2) => {
    var z = $thiz.applyOrElse__O__F1__O(x$2, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
    return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(z)) && ($n(action).apply__O__O(z), true));
  }));
}
function $is_s_PartialFunction(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_PartialFunction)));
}
function $as_s_PartialFunction(obj) {
  return (($is_s_PartialFunction(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.PartialFunction"));
}
function $isArrayOf_s_PartialFunction(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_PartialFunction)));
}
function $asArrayOf_s_PartialFunction(obj, depth) {
  return (($isArrayOf_s_PartialFunction(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.PartialFunction;", depth));
}
var $d_s_PartialFunction = new $TypeData().initClass(1, "scala.PartialFunction", ({
  s_PartialFunction: 1,
  F1: 1
}));
function $is_s_Product(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_Product)));
}
function $as_s_Product(obj) {
  return (($is_s_Product(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Product"));
}
function $isArrayOf_s_Product(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_Product)));
}
function $asArrayOf_s_Product(obj, depth) {
  return (($isArrayOf_s_Product(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Product;", depth));
}
/** @constructor */
function $c_scg_BitOperations$Int$() {
}
$c_scg_BitOperations$Int$.prototype = new $h_O();
$c_scg_BitOperations$Int$.prototype.constructor = $c_scg_BitOperations$Int$;
/** @constructor */
function $h_scg_BitOperations$Int$() {
}
$h_scg_BitOperations$Int$.prototype = $c_scg_BitOperations$Int$.prototype;
var $d_scg_BitOperations$Int$ = new $TypeData().initClass($c_scg_BitOperations$Int$, "scala.collection.generic.BitOperations$Int$", ({
  scg_BitOperations$Int$: 1,
  scg_BitOperations$Int: 1
}));
var $n_scg_BitOperations$Int$;
function $m_scg_BitOperations$Int$() {
  if ((!$n_scg_BitOperations$Int$)) {
    $n_scg_BitOperations$Int$ = new $c_scg_BitOperations$Int$();
  }
  return $n_scg_BitOperations$Int$;
}
function $is_sci_LazyList$State(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_LazyList$State)));
}
function $as_sci_LazyList$State(obj) {
  return (($is_sci_LazyList$State(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.LazyList$State"));
}
function $isArrayOf_sci_LazyList$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_LazyList$State)));
}
function $asArrayOf_sci_LazyList$State(obj, depth) {
  return (($isArrayOf_sci_LazyList$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.LazyList$State;", depth));
}
/** @constructor */
function $c_sci_List$$anon$1() {
}
$c_sci_List$$anon$1.prototype = new $h_O();
$c_sci_List$$anon$1.prototype.constructor = $c_sci_List$$anon$1;
/** @constructor */
function $h_sci_List$$anon$1() {
}
$h_sci_List$$anon$1.prototype = $c_sci_List$$anon$1.prototype;
$c_sci_List$$anon$1.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this);
});
$c_sci_List$$anon$1.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sci_List$$anon$1.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_sci_List$$anon$1.prototype.toString__T = (function() {
  return "<function1>";
});
$c_sci_List$$anon$1.prototype.apply__O__O = (function(x) {
  return this;
});
var $d_sci_List$$anon$1 = new $TypeData().initClass($c_sci_List$$anon$1, "scala.collection.immutable.List$$anon$1", ({
  sci_List$$anon$1: 1,
  F1: 1
}));
/** @constructor */
function $c_sci_MapNode() {
}
$c_sci_MapNode.prototype = new $h_sci_Node();
$c_sci_MapNode.prototype.constructor = $c_sci_MapNode;
/** @constructor */
function $h_sci_MapNode() {
}
$h_sci_MapNode.prototype = $c_sci_MapNode.prototype;
function $as_sci_MapNode(obj) {
  return (((obj instanceof $c_sci_MapNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.MapNode"));
}
function $isArrayOf_sci_MapNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_MapNode)));
}
function $asArrayOf_sci_MapNode(obj, depth) {
  return (($isArrayOf_sci_MapNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.MapNode;", depth));
}
function $p_sci_NumericRange$__bigDecimalCheckUnderflow__O__O__O__s_math_Integral__V($thiz, start, end, step, num) {
  if ((!$m_sr_BoxesRunTime$().equals__O__O__Z($n(num).minus__O__O__O($n(num).plus__O__O__O(start, step), start), step))) {
    $p_sci_NumericRange$__FAIL$1__O__O__V($thiz, start, step);
  }
  if ((!$m_sr_BoxesRunTime$().equals__O__O__Z($n(num).minus__O__O__O(end, $n(num).minus__O__O__O(end, step)), step))) {
    $p_sci_NumericRange$__FAIL$1__O__O__V($thiz, end, step);
  }
}
function $p_sci_NumericRange$__FAIL$1__O__O__V($thiz, boundary, step) {
  if ((boundary instanceof $c_s_math_BigDecimal)) {
    var x2 = $as_s_math_BigDecimal(boundary);
    var this$1 = $n($n(x2).s_math_BigDecimal__f_mc);
    var msg = ("Precision " + this$1.Ljava_math_MathContext__f_precision);
  } else {
    var msg = "Precision";
  }
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((((msg + " inadequate to represent steps of size ") + step) + " near ") + boundary));
}
function $p_sci_NumericRange$__check$1__O__s_math_Integral__O__O($thiz, t, num$1, limit$1) {
  var this$1 = $n(num$1);
  if ($f_s_math_Ordering__gt__O__O__Z(this$1, t, limit$1)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "More than Int.MaxValue elements.");
  } else {
    return t;
  }
}
/** @constructor */
function $c_sci_NumericRange$() {
  this.sci_NumericRange$__f_defaultOrdering = null;
  $n_sci_NumericRange$ = this;
  var this$14 = $m_sci_Map$();
  var self = $m_s_math_Numeric$IntIsIntegral$();
  var y = $m_s_math_Ordering$Int$();
  var $x_4 = new $c_T2(self, y);
  var self$1 = $m_s_math_Numeric$ShortIsIntegral$();
  var y$1 = $m_s_math_Ordering$Short$();
  var $x_3 = new $c_T2(self$1, y$1);
  var self$2 = $m_s_math_Numeric$ByteIsIntegral$();
  var y$2 = $m_s_math_Ordering$Byte$();
  var $x_2 = new $c_T2(self$2, y$2);
  var self$3 = $m_s_math_Numeric$CharIsIntegral$();
  var y$3 = $m_s_math_Ordering$Char$();
  var $x_1 = new $c_T2(self$3, y$3);
  var self$4 = $m_s_math_Numeric$LongIsIntegral$();
  var y$4 = $m_s_math_Ordering$Long$();
  var array = [$x_4, $x_3, $x_2, $x_1, new $c_T2(self$4, y$4)];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.sci_NumericRange$__f_defaultOrdering = this$14.from__sc_IterableOnce__sci_Map(elems);
}
$c_sci_NumericRange$.prototype = new $h_O();
$c_sci_NumericRange$.prototype.constructor = $c_sci_NumericRange$;
/** @constructor */
function $h_sci_NumericRange$() {
}
$h_sci_NumericRange$.prototype = $c_sci_NumericRange$.prototype;
$c_sci_NumericRange$.prototype.count__O__O__O__Z__s_math_Integral__I = (function(start, end, step, isInclusive, num) {
  var this$1 = $n(num);
  var zero = this$1.fromInt__I__O(0);
  var this$2 = $n(num);
  var upward = $f_s_math_Ordering__lt__O__O__Z(this$2, start, end);
  var this$3 = $n(num);
  var posStep = $f_s_math_Ordering__gt__O__O__Z(this$3, step, zero);
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(step, zero)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "step cannot be 0.");
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(start, end)) {
    return (isInclusive ? 1 : 0);
  } else if ((upward !== posStep)) {
    return 0;
  } else {
    var startint = $n(num).toInt__O__I(start);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(start, $n(num).fromInt__I__O(startint))) {
      var endint = $n(num).toInt__O__I(end);
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(end, $n(num).fromInt__I__O(endint))) {
        var stepint = $n(num).toInt__O__I(step);
        if ($m_sr_BoxesRunTime$().equals__O__O__Z(step, $n(num).fromInt__I__O(stepint))) {
          if (isInclusive) {
            var isEmpty = (((startint > endint) && (stepint > 0)) || ((startint < endint) && (stepint < 0)));
            if ((stepint === 0)) {
              throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "step cannot be 0.");
            }
            if (isEmpty) {
              var scala$collection$immutable$Range$$numRangeElements = 0;
            } else {
              var hi = (endint >> 31);
              var hi$1 = (startint >> 31);
              var lo = ((endint - startint) | 0);
              var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ endint)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
              var hi$3 = (stepint >> 31);
              var this$9 = $m_RTLong$();
              var lo$1 = this$9.divideImpl__I__I__I__I__I(lo, hi$2, stepint, hi$3);
              var hi$4 = this$9.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
              var lo$2 = ((1 + lo$1) | 0);
              var hi$5 = ((lo$2 === 0) ? ((1 + hi$4) | 0) : hi$4);
              var scala$collection$immutable$Range$$numRangeElements = (((hi$5 === 0) ? (((-2147483648) ^ lo$2) > (-1)) : (hi$5 > 0)) ? (-1) : lo$2);
            }
            switch (stepint) {
              case 1: {
                break;
              }
              case (-1): {
                break;
              }
              default: {
                var hi$6 = (endint >> 31);
                var hi$7 = (startint >> 31);
                var lo$3 = ((endint - startint) | 0);
                var hi$8 = ((((-2147483648) ^ lo$3) > ((-2147483648) ^ endint)) ? (((-1) + ((hi$6 - hi$7) | 0)) | 0) : ((hi$6 - hi$7) | 0));
                var hi$9 = (stepint >> 31);
                var this$15 = $m_RTLong$();
                var lo$4 = this$15.remainderImpl__I__I__I__I__I(lo$3, hi$8, stepint, hi$9);
              }
            }
            return ((scala$collection$immutable$Range$$numRangeElements < 0) ? $m_sci_Range$().scala$collection$immutable$Range$$fail__I__I__I__Z__E(startint, endint, stepint, true) : scala$collection$immutable$Range$$numRangeElements);
          } else {
            var isEmpty$1 = ((((startint > endint) && (stepint > 0)) || ((startint < endint) && (stepint < 0))) || (startint === endint));
            if ((stepint === 0)) {
              throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "step cannot be 0.");
            }
            if (isEmpty$1) {
              var scala$collection$immutable$Range$$numRangeElements$1 = 0;
            } else {
              var hi$11 = (endint >> 31);
              var hi$12 = (startint >> 31);
              var lo$5 = ((endint - startint) | 0);
              var hi$13 = ((((-2147483648) ^ lo$5) > ((-2147483648) ^ endint)) ? (((-1) + ((hi$11 - hi$12) | 0)) | 0) : ((hi$11 - hi$12) | 0));
              var hi$14 = (stepint >> 31);
              var this$21 = $m_RTLong$();
              var lo$6 = this$21.divideImpl__I__I__I__I__I(lo$5, hi$13, stepint, hi$14);
              var hi$15 = this$21.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
              var hi$16 = (endint >> 31);
              var hi$17 = (startint >> 31);
              var lo$7 = ((endint - startint) | 0);
              var hi$18 = ((((-2147483648) ^ lo$7) > ((-2147483648) ^ endint)) ? (((-1) + ((hi$16 - hi$17) | 0)) | 0) : ((hi$16 - hi$17) | 0));
              var hi$19 = (stepint >> 31);
              var this$26 = $m_RTLong$();
              var lo$8 = this$26.remainderImpl__I__I__I__I__I(lo$7, hi$18, stepint, hi$19);
              var hi$20 = this$26.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
              if ((!((lo$8 === 0) && (hi$20 === 0)))) {
                var value = 1;
              } else {
                var value = 0;
              }
              var hi$21 = (value >> 31);
              var lo$9 = ((lo$6 + value) | 0);
              var hi$22 = ((((-2147483648) ^ lo$9) < ((-2147483648) ^ lo$6)) ? ((1 + ((hi$15 + hi$21) | 0)) | 0) : ((hi$15 + hi$21) | 0));
              var scala$collection$immutable$Range$$numRangeElements$1 = (((hi$22 === 0) ? (((-2147483648) ^ lo$9) > (-1)) : (hi$22 > 0)) ? (-1) : lo$9);
            }
            switch (stepint) {
              case 1: {
                break;
              }
              case (-1): {
                break;
              }
              default: {
                var hi$23 = (endint >> 31);
                var hi$24 = (startint >> 31);
                var lo$10 = ((endint - startint) | 0);
                var hi$25 = ((((-2147483648) ^ lo$10) > ((-2147483648) ^ endint)) ? (((-1) + ((hi$23 - hi$24) | 0)) | 0) : ((hi$23 - hi$24) | 0));
                var hi$26 = (stepint >> 31);
                var this$33 = $m_RTLong$();
                var lo$11 = this$33.remainderImpl__I__I__I__I__I(lo$10, hi$25, stepint, hi$26);
              }
            }
            return ((scala$collection$immutable$Range$$numRangeElements$1 < 0) ? $m_sci_Range$().scala$collection$immutable$Range$$fail__I__I__I__Z__E(startint, endint, stepint, false) : scala$collection$immutable$Range$$numRangeElements$1);
          }
        }
      }
    }
    if ($is_s_math_Numeric$BigDecimalAsIfIntegral(num)) {
      $p_sci_NumericRange$__bigDecimalCheckUnderflow__O__O__O__s_math_Integral__V(this, start, end, step, num);
    }
    var this$34 = $n(num);
    var one = this$34.fromInt__I__O(1);
    var limit = $n(num).fromInt__I__O(2147483647);
    var startside = $n(num).sign__O__O(start);
    var endside = $n(num).sign__O__O(end);
    var $x_5 = $n(num);
    var this$35 = $n(num);
    var x = $n(num).times__O__O__O(startside, endside);
    if ($f_s_math_Ordering__gteq__O__O__Z(this$35, x, zero)) {
      var diff = $n(num).minus__O__O__O(end, start);
      var quotient = $p_sci_NumericRange$__check$1__O__s_math_Integral__O__O(this, $n(num).quot__O__O__O(diff, step), num, limit);
      var remainder = $n(num).minus__O__O__O(diff, $n(num).times__O__O__O(quotient, step));
      var $x_1 = (((!isInclusive) && $m_sr_BoxesRunTime$().equals__O__O__Z(zero, remainder)) ? quotient : $p_sci_NumericRange$__check$1__O__s_math_Integral__O__O(this, $n(num).plus__O__O__O(quotient, one), num, limit));
    } else {
      var negone = $n(num).fromInt__I__O((-1));
      var startlim = (posStep ? negone : one);
      if (posStep) {
        var this$36 = $n(num);
        var $x_3 = $f_s_math_Ordering__lt__O__O__Z(this$36, startlim, start);
      } else {
        var $x_3 = false;
      }
      if ($x_3) {
        var $x_2 = true;
      } else if ((!posStep)) {
        var this$37 = $n(num);
        var $x_2 = $f_s_math_Ordering__gt__O__O__Z(this$37, startlim, start);
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        var startdiff = start;
      } else {
        var startdiff = $n(num).minus__O__O__O(startlim, start);
      }
      var startq = $p_sci_NumericRange$__check$1__O__s_math_Integral__O__O(this, $n(num).quot__O__O__O(startdiff, step), num, limit);
      var waypointA = ($m_sr_BoxesRunTime$().equals__O__O__Z(startq, zero) ? start : $n(num).plus__O__O__O(start, $n(num).times__O__O__O(startq, step)));
      var waypointB = $n(num).plus__O__O__O(waypointA, step);
      var this$38 = $n(num);
      if (($f_s_math_Ordering__lt__O__O__Z(this$38, waypointB, end) !== upward)) {
        var $x_4 = ((isInclusive && $m_sr_BoxesRunTime$().equals__O__O__Z(waypointB, end)) ? $n(num).plus__O__O__O(startq, $n(num).fromInt__I__O(2)) : $n(num).plus__O__O__O(startq, one));
      } else {
        var enddiff = $n(num).minus__O__O__O(end, waypointB);
        var endq = $p_sci_NumericRange$__check$1__O__s_math_Integral__O__O(this, $n(num).quot__O__O__O(enddiff, step), num, limit);
        var last = ($m_sr_BoxesRunTime$().equals__O__O__Z(endq, zero) ? waypointB : $n(num).plus__O__O__O(waypointB, $n(num).times__O__O__O(endq, step)));
        var $x_4 = $n(num).plus__O__O__O(startq, $n(num).plus__O__O__O(endq, (((!isInclusive) && $m_sr_BoxesRunTime$().equals__O__O__Z(last, end)) ? one : $n(num).fromInt__I__O(2))));
      }
      var $x_1 = $p_sci_NumericRange$__check$1__O__s_math_Integral__O__O(this, $x_4, num, limit);
    }
    return $n($x_5).toInt__O__I($x_1);
  }
});
var $d_sci_NumericRange$ = new $TypeData().initClass($c_sci_NumericRange$, "scala.collection.immutable.NumericRange$", ({
  sci_NumericRange$: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_NumericRange$;
function $m_sci_NumericRange$() {
  if ((!$n_sci_NumericRange$)) {
    $n_sci_NumericRange$ = new $c_sci_NumericRange$();
  }
  return $n_sci_NumericRange$;
}
function $p_sci_Range$__description__I__I__I__Z__T($thiz, start, end, step, isInclusive) {
  return ((((start + (isInclusive ? " to " : " until ")) + end) + " by ") + step);
}
/** @constructor */
function $c_sci_Range$() {
}
$c_sci_Range$.prototype = new $h_O();
$c_sci_Range$.prototype.constructor = $c_sci_Range$;
/** @constructor */
function $h_sci_Range$() {
}
$h_sci_Range$.prototype = $c_sci_Range$.prototype;
$c_sci_Range$.prototype.scala$collection$immutable$Range$$fail__I__I__I__Z__E = (function(start, end, step, isInclusive) {
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ($p_sci_Range$__description__I__I__I__Z__T(this, start, end, step, isInclusive) + ": seqs cannot contain more than Int.MaxValue elements."));
});
var $d_sci_Range$ = new $TypeData().initClass($c_sci_Range$, "scala.collection.immutable.Range$", ({
  sci_Range$: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_Range$;
function $m_sci_Range$() {
  if ((!$n_sci_Range$)) {
    $n_sci_Range$ = new $c_sci_Range$();
  }
  return $n_sci_Range$;
}
/** @constructor */
function $c_sci_RedBlackTree$SetHelper() {
  this.sci_RedBlackTree$Helper__f_ordering = null;
}
$c_sci_RedBlackTree$SetHelper.prototype = new $h_sci_RedBlackTree$Helper();
$c_sci_RedBlackTree$SetHelper.prototype.constructor = $c_sci_RedBlackTree$SetHelper;
/** @constructor */
function $h_sci_RedBlackTree$SetHelper() {
}
$h_sci_RedBlackTree$SetHelper.prototype = $c_sci_RedBlackTree$SetHelper.prototype;
$c_sci_RedBlackTree$SetHelper.prototype.mutableUpd__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree = (function(tree, k) {
  if ((tree === null)) {
    return new $c_sci_RedBlackTree$Tree(k, (void 0), null, null, 0);
  } else {
    var this$2 = $n(tree);
    if (Object.is(k, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)) {
      return tree;
    } else {
      var $x_1 = $n(this.sci_RedBlackTree$Helper__f_ordering);
      var this$3 = $n(tree);
      var cmp = $n($x_1).compare__O__O__I(k, this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
      if ((cmp < 0)) {
        var this$4 = $n(tree);
        return this.mutableBalanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree, this.mutableUpd__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree(this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, k));
      } else if ((cmp > 0)) {
        var this$5 = $n(tree);
        return this.mutableBalanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree, this.mutableUpd__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree(this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k));
      } else {
        return tree;
      }
    }
  }
});
/** @constructor */
function $c_sci_SetNode() {
}
$c_sci_SetNode.prototype = new $h_sci_Node();
$c_sci_SetNode.prototype.constructor = $c_sci_SetNode;
/** @constructor */
function $h_sci_SetNode() {
}
$h_sci_SetNode.prototype = $c_sci_SetNode.prototype;
function $as_sci_SetNode(obj) {
  return (((obj instanceof $c_sci_SetNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SetNode"));
}
function $isArrayOf_sci_SetNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SetNode)));
}
function $asArrayOf_sci_SetNode(obj, depth) {
  return (($isArrayOf_sci_SetNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SetNode;", depth));
}
function $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable($thiz, elems) {
  if ((elems === $thiz)) {
    $thiz.addAll__sc_IterableOnce__scm_Growable($m_scm_Buffer$().from__sc_IterableOnce__sc_SeqOps(elems));
  } else {
    var it = $n(elems).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      $thiz.addOne__O__scm_Growable($n(it).next__O());
    }
  }
  return $thiz;
}
function $is_scm_Growable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Growable)));
}
function $as_scm_Growable(obj) {
  return (($is_scm_Growable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Growable"));
}
function $isArrayOf_scm_Growable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Growable)));
}
function $asArrayOf_scm_Growable(obj, depth) {
  return (($isArrayOf_scm_Growable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Growable;", depth));
}
function $f_s_concurrent_BatchingExecutor__submitSyncBatched__jl_Runnable__V($thiz, runnable) {
  if ((runnable === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "runnable is null");
  }
  var tl = $thiz.s_concurrent_ExecutionContext$parasitic$__f_scala$concurrent$BatchingExecutor$$_tasksLocal;
  var b = $n(tl).get__O();
  if ((b instanceof $c_s_concurrent_BatchingExecutor$SyncBatch)) {
    $n($as_s_concurrent_BatchingExecutor$SyncBatch(b)).push__jl_Runnable__V(runnable);
  } else {
    if ((b !== null)) {
      var this$2 = $n($as_jl_Integer(b));
      var i = this$2;
    } else {
      var i = 0;
    }
    if ((i < 16)) {
      var $x_1 = $n(tl);
      var i$1 = ((1 + i) | 0);
      $n($x_1).set__O__V(i$1);
      try {
        $n(runnable).run__V();
      } catch (e) {
        var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
        if (false) {
          var x2 = $as_jl_InterruptedException(e$2);
          $n($m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter).apply__O__O(x2);
        } else if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
          $n($m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter).apply__O__O(e$2);
        } else {
          throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2));
        }
      } finally {
        $n(tl).set__O__V(b);
      }
    } else {
      var batch = new $c_s_concurrent_BatchingExecutor$SyncBatch($thiz, runnable);
      $n(tl).set__O__V(batch);
      batch.run__V();
      $n(tl).set__O__V(b);
    }
  }
}
function $is_s_concurrent_Future(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_concurrent_Future)));
}
function $as_s_concurrent_Future(obj) {
  return (($is_s_concurrent_Future(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.Future"));
}
function $isArrayOf_s_concurrent_Future(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_Future)));
}
function $asArrayOf_s_concurrent_Future(obj, depth) {
  return (($isArrayOf_s_concurrent_Future(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.Future;", depth));
}
function $p_s_concurrent_duration_Duration$__words__T__sci_List($thiz, s) {
  var $x_1 = $m_s_Predef$();
  var this$1 = $n($f_T__trim__T($n(s)));
  var this$2 = $n($n($x_1).wrapRefArray__AO__scm_ArraySeq$ofRef($f_T__split__T__I__AT(this$1, "\\s+", 0)));
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$2);
}
function $p_s_concurrent_duration_Duration$__expandLabels__T__sci_List($thiz, labels) {
  var x1 = $p_s_concurrent_duration_Duration$__words__T__sci_List($thiz, labels);
  if ((!(x1 instanceof $c_sci_$colon$colon))) {
    throw new $c_s_MatchError(x1);
  }
  var x2 = $as_sci_$colon$colon(x1);
  var hd = $as_T($n(x2).sci_$colon$colon__f_head);
  var rest = $n(x2).sci_$colon$colon__f_next;
  var this$1 = $n(rest);
  var rest$1 = this$1;
  var h = null;
  var t = null;
  while ((rest$1 !== $m_sci_Nil$())) {
    var arg1 = $n(rest$1).head__O();
    var s = $as_T(arg1);
    var array = [s, (s + "s")];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var it = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var nx = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        $n(t).sci_$colon$colon__f_next = nx;
      }
      t = nx;
    }
    rest$1 = $as_sci_List($n(rest$1).tail__O());
  }
  var this$6 = $n(((h === null) ? $m_sci_Nil$() : h));
  return new $c_sci_$colon$colon(hd, this$6);
}
/** @constructor */
function $c_s_concurrent_duration_Duration$() {
  this.s_concurrent_duration_Duration$__f_timeUnitLabels = null;
  this.s_concurrent_duration_Duration$__f_timeUnitName = null;
  this.s_concurrent_duration_Duration$__f_timeUnit = null;
  this.s_concurrent_duration_Duration$__f_Zero = null;
  this.s_concurrent_duration_Duration$__f_Undefined = null;
  this.s_concurrent_duration_Duration$__f_Inf = null;
  this.s_concurrent_duration_Duration$__f_MinusInf = null;
  $n_s_concurrent_duration_Duration$ = this;
  var self = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS;
  var $x_6 = new $c_T2(self, "d day");
  var self$1 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_HOURS;
  var $x_5 = new $c_T2(self$1, "h hr hour");
  var self$2 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MINUTES;
  var $x_4 = new $c_T2(self$2, "m min minute");
  var self$3 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var $x_3 = new $c_T2(self$3, "s sec second");
  var self$4 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
  var $x_2 = new $c_T2(self$4, "ms milli millisecond");
  var self$5 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
  var $x_1 = new $c_T2(self$5, "\u00b5s micro microsecond");
  var self$6 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
  var array = [$x_6, $x_5, $x_4, $x_3, $x_2, $x_1, new $c_T2(self$6, "ns nano nanosecond")];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.s_concurrent_duration_Duration$__f_timeUnitLabels = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var this$20 = $n(this.s_concurrent_duration_Duration$__f_timeUnitLabels);
  var this$19 = $m_s_$less$colon$less$();
  var this$21 = $n($m_sci_Map$().from__sc_IterableOnce__sci_Map(this$20));
  var this$23 = new $c_sc_MapView$Id(this$21);
  var f = new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_T(s$2);
    return $as_T($n($p_s_concurrent_duration_Duration$__words__T__sci_List($m_s_concurrent_duration_Duration$(), s)).last__O());
  }));
  var this$25 = new $c_sc_MapView$MapValues(this$23, f);
  var this$24 = $m_s_$less$colon$less$();
  this.s_concurrent_duration_Duration$__f_timeUnitName = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$25);
  var this$26 = $n(this.s_concurrent_duration_Duration$__f_timeUnitLabels);
  var rest = this$26;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var arg1 = $n(rest).head__O();
    var x0$1 = $as_T2(arg1);
    if ((x0$1 === null)) {
      throw new $c_s_MatchError(x0$1);
    }
    var unit = $as_ju_concurrent_TimeUnit($n(x0$1)._1__O());
    var names = $as_T($n(x0$1)._2__O());
    var this$30 = $n($p_s_concurrent_duration_Duration$__expandLabels__T__sci_List($m_s_concurrent_duration_Duration$(), names));
    var f$1 = ((unit) => ((x$5$2) => {
      var x$5 = $as_T(x$5$2);
      return new $c_T2(x$5, unit);
    }))(unit);
    if ((this$30 === $m_sci_Nil$())) {
      var $x_7 = $m_sci_Nil$();
    } else {
      var arg1$1 = this$30.head__O();
      var h$1 = new $c_sci_$colon$colon(f$1(arg1$1), $m_sci_Nil$());
      var t$1 = h$1;
      var rest$1 = $as_sci_List(this$30.tail__O());
      while ((rest$1 !== $m_sci_Nil$())) {
        var arg1$2 = $n(rest$1).head__O();
        var nx = new $c_sci_$colon$colon(f$1(arg1$2), $m_sci_Nil$());
        $n(t$1).sci_$colon$colon__f_next = nx;
        t$1 = nx;
        rest$1 = $as_sci_List($n(rest$1).tail__O());
      }
      var $x_7 = h$1;
    }
    var it = $n($x_7).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var nx$1 = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx$1;
      } else {
        $n(t).sci_$colon$colon__f_next = nx$1;
      }
      t = nx$1;
    }
    rest = $as_sci_List($n(rest).tail__O());
  }
  var this$32 = $n(((h === null) ? $m_sci_Nil$() : h));
  var this$31 = $m_s_$less$colon$less$();
  this.s_concurrent_duration_Duration$__f_timeUnit = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$32);
  this.s_concurrent_duration_Duration$__f_Zero = new $c_s_concurrent_duration_FiniteDuration($L0, $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS);
  this.s_concurrent_duration_Duration$__f_Undefined = new $c_s_concurrent_duration_Duration$$anon$1();
  this.s_concurrent_duration_Duration$__f_Inf = new $c_s_concurrent_duration_Duration$$anon$2();
  this.s_concurrent_duration_Duration$__f_MinusInf = new $c_s_concurrent_duration_Duration$$anon$3();
}
$c_s_concurrent_duration_Duration$.prototype = new $h_O();
$c_s_concurrent_duration_Duration$.prototype.constructor = $c_s_concurrent_duration_Duration$;
/** @constructor */
function $h_s_concurrent_duration_Duration$() {
}
$h_s_concurrent_duration_Duration$.prototype = $c_s_concurrent_duration_Duration$.prototype;
$c_s_concurrent_duration_Duration$.prototype.apply__D__ju_concurrent_TimeUnit__s_concurrent_duration_Duration = (function(length, unit) {
  var this$1 = $n(unit).toNanos__J__J(new $c_RTLong(1, 0));
  return this.fromNanos__D__s_concurrent_duration_Duration(($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$1.RTLong__f_lo, this$1.RTLong__f_hi) * length));
});
$c_s_concurrent_duration_Duration$.prototype.apply__T__s_concurrent_duration_Duration = (function(s) {
  var this$4 = $n(s);
  var len = this$4.length;
  var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), len);
  var i = 0;
  while ((i < len)) {
    var this$5 = $n(s);
    var index = i;
    var x = $charAt(this$5, index);
    var this$8 = $m_jl_Character$();
    if ((!this$8.isWhitespace__I__Z(x))) {
      var str = ("" + $cToS(x));
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
    }
    i = ((1 + i) | 0);
  }
  var s1 = ((len === sb.length__I()) ? s : sb.jl_StringBuilder__f_java$lang$StringBuilder$$content);
  switch (s1) {
    case "Inf":
    case "PlusInf":
    case "+Inf":
    case "Duration.Inf": {
      return this.s_concurrent_duration_Duration$__f_Inf;
      break;
    }
    case "MinusInf":
    case "-Inf":
    case "Duration.MinusInf": {
      return this.s_concurrent_duration_Duration$__f_MinusInf;
      break;
    }
    case "Duration.Undefined": {
      return this.s_concurrent_duration_Duration$__f_Undefined;
      break;
    }
    default: {
      var $x_1 = $m_sc_StringOps$();
      var x$1 = $m_sc_StringOps$().reverse$extension__T__T(s1);
      _return: {
        var this$14 = $n(x$1);
        var len$1 = this$14.length;
        var i$1 = 0;
        while ((i$1 < len$1)) {
          var this$15 = $n(x$1);
          var index$1 = i$1;
          var arg1 = $charAt(this$15, index$1);
          var this$18 = $m_jl_Character$();
          if ((!this$18.isLetter__I__Z(arg1))) {
            var x1 = i$1;
            break _return;
          }
          i$1 = ((1 + i$1) | 0);
        }
        var x1 = (-1);
      }
      if ((x1 === (-1))) {
        var x$2 = x$1;
      } else {
        var this$19 = $n(x$1);
        if ((x1 > this$19.length)) {
          $charAt(this$19, x1);
        }
        if ((x1 < 0)) {
          $charAt(this$19, (-1));
        }
        var x$2 = $as_T(this$19.substring(0, x1));
      }
      var unitName = $n($x_1).reverse$extension__T__T(x$2);
      var x1$2 = $n(this.s_concurrent_duration_Duration$__f_timeUnit).get__O__s_Option(unitName);
      if ((x1$2 instanceof $c_s_Some)) {
        var x2 = $as_s_Some(x1$2);
        var unit = $as_ju_concurrent_TimeUnit($n(x2).s_Some__f_value);
        var $x_2 = $m_sc_StringOps$();
        var this$22 = $n(unitName);
        var valueStr = $n($x_2).dropRight$extension__T__I__T(s1, this$22.length);
        var this$23 = $n($m_sc_StringParsers$().parseLong__T__s_Option(valueStr));
        if (this$23.isEmpty__Z()) {
          var $x_3 = $m_s_None$();
        } else {
          var arg1$1 = this$23.get__O();
          var t = $uJ(arg1$1);
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          $m_s_concurrent_duration_Duration$();
          var $x_3 = new $c_s_Some(new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo, hi), unit));
        }
        var this$25 = $n($x_3);
        return $as_s_concurrent_duration_Duration((this$25.isEmpty__Z() ? $m_s_concurrent_duration_Duration$().apply__D__ju_concurrent_TimeUnit__s_concurrent_duration_Duration($m_jl_Double$().parseDouble__T__D(valueStr), unit) : this$25.get__O()));
      } else {
        throw new $c_jl_NumberFormatException(("format error " + s));
      }
    }
  }
});
$c_s_concurrent_duration_Duration$.prototype.fromNanos__D__s_concurrent_duration_Duration = (function(nanos) {
  if (((nanos === Infinity) || (nanos === (-Infinity)))) {
    return ((nanos > 0.0) ? this.s_concurrent_duration_Duration$__f_Inf : this.s_concurrent_duration_Duration$__f_MinusInf);
  } else if ((nanos !== nanos)) {
    return this.s_concurrent_duration_Duration$__f_Undefined;
  } else if (((nanos > 9.223372036854776E18) || (nanos < (-9.223372036854776E18)))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("trying to construct too large duration with " + nanos) + "ns"));
  } else {
    var this$8 = $m_RTLong$();
    var value = $uD(Math.round(nanos));
    var lo = this$8.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
    var hi = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    return this.fromNanos__J__s_concurrent_duration_FiniteDuration(new $c_RTLong(lo, hi));
  }
});
$c_s_concurrent_duration_Duration$.prototype.fromNanos__J__s_concurrent_duration_FiniteDuration = (function(nanos) {
  var this$1 = $m_RTLong$();
  var lo = this$1.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, (-1857093632), 20116);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if (((lo === 0) && (hi === 0))) {
    $m_s_concurrent_duration_Duration$();
    var this$2 = $m_RTLong$();
    var lo$1 = this$2.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, (-1857093632), 20116);
    var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS;
    return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$1, hi$1), unit);
  } else {
    var this$4 = $m_RTLong$();
    var lo$2 = this$4.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 817405952, 838);
    var hi$2 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    if (((lo$2 === 0) && (hi$2 === 0))) {
      $m_s_concurrent_duration_Duration$();
      var this$5 = $m_RTLong$();
      var lo$3 = this$5.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 817405952, 838);
      var hi$3 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var unit$1 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_HOURS;
      return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$3, hi$3), unit$1);
    } else {
      var this$7 = $m_RTLong$();
      var lo$4 = this$7.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, (-129542144), 13);
      var hi$4 = this$7.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      if (((lo$4 === 0) && (hi$4 === 0))) {
        $m_s_concurrent_duration_Duration$();
        var this$8 = $m_RTLong$();
        var lo$5 = this$8.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, (-129542144), 13);
        var hi$5 = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var unit$2 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MINUTES;
        return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$5, hi$5), unit$2);
      } else {
        var this$10 = $m_RTLong$();
        var lo$6 = this$10.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000000000, 0);
        var hi$6 = this$10.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        if (((lo$6 === 0) && (hi$6 === 0))) {
          $m_s_concurrent_duration_Duration$();
          var this$11 = $m_RTLong$();
          var lo$7 = this$11.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000000000, 0);
          var hi$7 = this$11.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var unit$3 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
          return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$7, hi$7), unit$3);
        } else {
          var this$13 = $m_RTLong$();
          var lo$8 = this$13.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000000, 0);
          var hi$8 = this$13.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          if (((lo$8 === 0) && (hi$8 === 0))) {
            $m_s_concurrent_duration_Duration$();
            var this$14 = $m_RTLong$();
            var lo$9 = this$14.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000000, 0);
            var hi$9 = this$14.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
            var unit$4 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
            return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$9, hi$9), unit$4);
          } else {
            var this$16 = $m_RTLong$();
            var lo$10 = this$16.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000, 0);
            var hi$10 = this$16.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
            if (((lo$10 === 0) && (hi$10 === 0))) {
              $m_s_concurrent_duration_Duration$();
              var this$17 = $m_RTLong$();
              var lo$11 = this$17.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000, 0);
              var hi$11 = this$17.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
              var unit$5 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
              return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$11, hi$11), unit$5);
            } else {
              $m_s_concurrent_duration_Duration$();
              var unit$6 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
              return new $c_s_concurrent_duration_FiniteDuration(nanos, unit$6);
            }
          }
        }
      }
    }
  }
});
var $d_s_concurrent_duration_Duration$ = new $TypeData().initClass($c_s_concurrent_duration_Duration$, "scala.concurrent.duration.Duration$", ({
  s_concurrent_duration_Duration$: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_concurrent_duration_Duration$;
function $m_s_concurrent_duration_Duration$() {
  if ((!$n_s_concurrent_duration_Duration$)) {
    $n_s_concurrent_duration_Duration$ = new $c_s_concurrent_duration_Duration$();
  }
  return $n_s_concurrent_duration_Duration$;
}
/** @constructor */
function $c_s_concurrent_duration_package$DurationInt(n) {
  this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n = 0;
  this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n = n;
}
$c_s_concurrent_duration_package$DurationInt.prototype = new $h_O();
$c_s_concurrent_duration_package$DurationInt.prototype.constructor = $c_s_concurrent_duration_package$DurationInt;
/** @constructor */
function $h_s_concurrent_duration_package$DurationInt() {
}
$h_s_concurrent_duration_package$DurationInt.prototype = $c_s_concurrent_duration_package$DurationInt.prototype;
$c_s_concurrent_duration_package$DurationInt.prototype.hashCode__I = (function() {
  var this$ = this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  return this$;
});
$c_s_concurrent_duration_package$DurationInt.prototype.equals__O__Z = (function(x$1) {
  return $m_s_concurrent_duration_package$DurationInt$().equals$extension__I__O__Z(this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n, x$1);
});
function $as_s_concurrent_duration_package$DurationInt(obj) {
  return (((obj instanceof $c_s_concurrent_duration_package$DurationInt) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.package$DurationInt"));
}
function $isArrayOf_s_concurrent_duration_package$DurationInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_package$DurationInt)));
}
function $asArrayOf_s_concurrent_duration_package$DurationInt(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_package$DurationInt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.package$DurationInt;", depth));
}
var $d_s_concurrent_duration_package$DurationInt = new $TypeData().initClass($c_s_concurrent_duration_package$DurationInt, "scala.concurrent.duration.package$DurationInt", ({
  s_concurrent_duration_package$DurationInt: 1,
  s_concurrent_duration_DurationConversions: 1
}));
/** @constructor */
function $c_s_concurrent_duration_package$DurationLong(n) {
  this.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n = $L0;
  this.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n = n;
}
$c_s_concurrent_duration_package$DurationLong.prototype = new $h_O();
$c_s_concurrent_duration_package$DurationLong.prototype.constructor = $c_s_concurrent_duration_package$DurationLong;
/** @constructor */
function $h_s_concurrent_duration_package$DurationLong() {
}
$h_s_concurrent_duration_package$DurationLong.prototype = $c_s_concurrent_duration_package$DurationLong.prototype;
$c_s_concurrent_duration_package$DurationLong.prototype.hashCode__I = (function() {
  var t = this.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return (lo ^ hi);
});
$c_s_concurrent_duration_package$DurationLong.prototype.equals__O__Z = (function(x$1) {
  return $m_s_concurrent_duration_package$DurationLong$().equals$extension__J__O__Z(this.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n, x$1);
});
function $as_s_concurrent_duration_package$DurationLong(obj) {
  return (((obj instanceof $c_s_concurrent_duration_package$DurationLong) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.package$DurationLong"));
}
function $isArrayOf_s_concurrent_duration_package$DurationLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_package$DurationLong)));
}
function $asArrayOf_s_concurrent_duration_package$DurationLong(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_package$DurationLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.package$DurationLong;", depth));
}
var $d_s_concurrent_duration_package$DurationLong = new $TypeData().initClass($c_s_concurrent_duration_package$DurationLong, "scala.concurrent.duration.package$DurationLong", ({
  s_concurrent_duration_package$DurationLong: 1,
  s_concurrent_duration_DurationConversions: 1
}));
/** @constructor */
function $c_s_concurrent_impl_Promise$ManyCallbacks(first, rest) {
  this.s_concurrent_impl_Promise$ManyCallbacks__f_first = null;
  this.s_concurrent_impl_Promise$ManyCallbacks__f_rest = null;
  this.s_concurrent_impl_Promise$ManyCallbacks__f_first = first;
  this.s_concurrent_impl_Promise$ManyCallbacks__f_rest = rest;
}
$c_s_concurrent_impl_Promise$ManyCallbacks.prototype = new $h_O();
$c_s_concurrent_impl_Promise$ManyCallbacks.prototype.constructor = $c_s_concurrent_impl_Promise$ManyCallbacks;
/** @constructor */
function $h_s_concurrent_impl_Promise$ManyCallbacks() {
}
$h_s_concurrent_impl_Promise$ManyCallbacks.prototype = $c_s_concurrent_impl_Promise$ManyCallbacks.prototype;
$c_s_concurrent_impl_Promise$ManyCallbacks.prototype.toString__T = (function() {
  return "ManyCallbacks";
});
function $as_s_concurrent_impl_Promise$ManyCallbacks(obj) {
  return (((obj instanceof $c_s_concurrent_impl_Promise$ManyCallbacks) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.impl.Promise$ManyCallbacks"));
}
function $isArrayOf_s_concurrent_impl_Promise$ManyCallbacks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$ManyCallbacks)));
}
function $asArrayOf_s_concurrent_impl_Promise$ManyCallbacks(obj, depth) {
  return (($isArrayOf_s_concurrent_impl_Promise$ManyCallbacks(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.impl.Promise$ManyCallbacks;", depth));
}
var $d_s_concurrent_impl_Promise$ManyCallbacks = new $TypeData().initClass($c_s_concurrent_impl_Promise$ManyCallbacks, "scala.concurrent.impl.Promise$ManyCallbacks", ({
  s_concurrent_impl_Promise$ManyCallbacks: 1,
  s_concurrent_impl_Promise$Callbacks: 1
}));
function $p_s_math_BigDecimal$__cache$lzycompute__As_math_BigDecimal($thiz) {
  if ((!$thiz.s_math_BigDecimal$__f_bitmap$0)) {
    $thiz.s_math_BigDecimal$__f_cache = new ($d_s_math_BigDecimal.getArrayOf().constr)(((1 + (($thiz.s_math_BigDecimal$__f_maxCached - $thiz.s_math_BigDecimal$__f_minCached) | 0)) | 0));
    $thiz.s_math_BigDecimal$__f_bitmap$0 = true;
  }
  return $thiz.s_math_BigDecimal$__f_cache;
}
function $p_s_math_BigDecimal$__cache__As_math_BigDecimal($thiz) {
  return ((!$thiz.s_math_BigDecimal$__f_bitmap$0) ? $p_s_math_BigDecimal$__cache$lzycompute__As_math_BigDecimal($thiz) : $thiz.s_math_BigDecimal$__f_cache);
}
/** @constructor */
function $c_s_math_BigDecimal$() {
  this.s_math_BigDecimal$__f_cache = null;
  this.s_math_BigDecimal$__f_minCached = 0;
  this.s_math_BigDecimal$__f_maxCached = 0;
  this.s_math_BigDecimal$__f_defaultMathContext = null;
  this.s_math_BigDecimal$__f_bitmap$0 = false;
  $n_s_math_BigDecimal$ = this;
  this.s_math_BigDecimal$__f_minCached = (-512);
  this.s_math_BigDecimal$__f_maxCached = 512;
  this.s_math_BigDecimal$__f_defaultMathContext = $m_Ljava_math_MathContext$().Ljava_math_MathContext$__f_DECIMAL128;
}
$c_s_math_BigDecimal$.prototype = new $h_O();
$c_s_math_BigDecimal$.prototype.constructor = $c_s_math_BigDecimal$;
/** @constructor */
function $h_s_math_BigDecimal$() {
}
$h_s_math_BigDecimal$.prototype = $c_s_math_BigDecimal$.prototype;
$c_s_math_BigDecimal$.prototype.decimal__D__Ljava_math_MathContext__s_math_BigDecimal = (function(d, mc) {
  return new $c_s_math_BigDecimal($ct_Ljava_math_BigDecimal__T__Ljava_math_MathContext__(new $c_Ljava_math_BigDecimal(), ("" + d), mc), mc);
});
$c_s_math_BigDecimal$.prototype.apply__I__Ljava_math_MathContext__s_math_BigDecimal = (function(i, mc) {
  var x$2 = this.s_math_BigDecimal$__f_defaultMathContext;
  if (((((mc === null) ? (x$2 === null) : $n(mc).equals__O__Z(x$2)) && (this.s_math_BigDecimal$__f_minCached <= i)) && (i <= this.s_math_BigDecimal$__f_maxCached))) {
    var offset = ((i - this.s_math_BigDecimal$__f_minCached) | 0);
    var n = $n($p_s_math_BigDecimal$__cache__As_math_BigDecimal(this)).get(offset);
    if ((n === null)) {
      var hi = (i >> 31);
      n = new $c_s_math_BigDecimal($m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(new $c_RTLong(i, hi)), mc);
      $n($p_s_math_BigDecimal$__cache__As_math_BigDecimal(this)).set(offset, n);
    }
    return n;
  } else {
    var hi$1 = (i >> 31);
    return this.apply__J__Ljava_math_MathContext__s_math_BigDecimal(new $c_RTLong(i, hi$1), mc);
  }
});
$c_s_math_BigDecimal$.prototype.apply__J__Ljava_math_MathContext__s_math_BigDecimal = (function(l, mc) {
  return new $c_s_math_BigDecimal($ct_Ljava_math_BigDecimal__J__Ljava_math_MathContext__(new $c_Ljava_math_BigDecimal(), l, mc), mc);
});
var $d_s_math_BigDecimal$ = new $TypeData().initClass($c_s_math_BigDecimal$, "scala.math.BigDecimal$", ({
  s_math_BigDecimal$: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_math_BigDecimal$;
function $m_s_math_BigDecimal$() {
  if ((!$n_s_math_BigDecimal$)) {
    $n_s_math_BigDecimal$ = new $c_s_math_BigDecimal$();
  }
  return $n_s_math_BigDecimal$;
}
function $p_s_math_BigInt$__getCached__I__s_math_BigInt($thiz, i) {
  var offset = ((i - $thiz.s_math_BigInt$__f_minCached) | 0);
  var n = $n($thiz.s_math_BigInt$__f_cache).get(offset);
  if ((n === null)) {
    var hi = (i >> 31);
    n = $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), null, new $c_RTLong(i, hi));
    $n($thiz.s_math_BigInt$__f_cache).set(offset, n);
  }
  return n;
}
/** @constructor */
function $c_s_math_BigInt$() {
  this.s_math_BigInt$__f_scala$math$BigInt$$longMinValueBigInteger = null;
  this.s_math_BigInt$__f_longMinValue = null;
  this.s_math_BigInt$__f_minCached = 0;
  this.s_math_BigInt$__f_maxCached = 0;
  this.s_math_BigInt$__f_cache = null;
  this.s_math_BigInt$__f_scala$math$BigInt$$minusOne = null;
  $n_s_math_BigInt$ = this;
  this.s_math_BigInt$__f_scala$math$BigInt$$longMinValueBigInteger = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(0, (-2147483648)));
  this.s_math_BigInt$__f_longMinValue = $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), this.s_math_BigInt$__f_scala$math$BigInt$$longMinValueBigInteger, new $c_RTLong(0, (-2147483648)));
  this.s_math_BigInt$__f_minCached = (-1024);
  this.s_math_BigInt$__f_maxCached = 1024;
  this.s_math_BigInt$__f_cache = new ($d_s_math_BigInt.getArrayOf().constr)(((1 + ((this.s_math_BigInt$__f_maxCached - this.s_math_BigInt$__f_minCached) | 0)) | 0));
  this.s_math_BigInt$__f_scala$math$BigInt$$minusOne = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong((-1), (-1)));
}
$c_s_math_BigInt$.prototype = new $h_O();
$c_s_math_BigInt$.prototype.constructor = $c_s_math_BigInt$;
/** @constructor */
function $h_s_math_BigInt$() {
}
$h_s_math_BigInt$.prototype = $c_s_math_BigInt$.prototype;
$c_s_math_BigInt$.prototype.apply__I__s_math_BigInt = (function(i) {
  if (((this.s_math_BigInt$__f_minCached <= i) && (i <= this.s_math_BigInt$__f_maxCached))) {
    return $p_s_math_BigInt$__getCached__I__s_math_BigInt(this, i);
  } else {
    var hi = (i >> 31);
    return this.apply__J__s_math_BigInt(new $c_RTLong(i, hi));
  }
});
$c_s_math_BigInt$.prototype.apply__J__s_math_BigInt = (function(l) {
  var value = this.s_math_BigInt$__f_minCached;
  var hi = (value >> 31);
  var bhi = l.RTLong__f_hi;
  if (((hi === bhi) ? (((-2147483648) ^ value) <= ((-2147483648) ^ l.RTLong__f_lo)) : (hi < bhi))) {
    var value$1 = this.s_math_BigInt$__f_maxCached;
    var hi$1 = (value$1 >> 31);
    var ahi = l.RTLong__f_hi;
    var $x_1 = ((ahi === hi$1) ? (((-2147483648) ^ l.RTLong__f_lo) <= ((-2147483648) ^ value$1)) : (ahi < hi$1));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return $p_s_math_BigInt$__getCached__I__s_math_BigInt(this, l.RTLong__f_lo);
  } else {
    return (((l.RTLong__f_lo === 0) && (l.RTLong__f_hi === (-2147483648))) ? this.s_math_BigInt$__f_longMinValue : $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), null, l));
  }
});
$c_s_math_BigInt$.prototype.apply__Ljava_math_BigInteger__s_math_BigInt = (function(x) {
  var this$1 = $n(x);
  if (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$1) <= 63)) {
    var t = $n(x).longValue__J();
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var value = this.s_math_BigInt$__f_minCached;
    var hi$1 = (value >> 31);
    if (((hi$1 === hi) ? (((-2147483648) ^ value) <= ((-2147483648) ^ lo)) : (hi$1 < hi))) {
      var value$1 = this.s_math_BigInt$__f_maxCached;
      var hi$2 = (value$1 >> 31);
      var $x_1 = ((hi === hi$2) ? (((-2147483648) ^ lo) <= ((-2147483648) ^ value$1)) : (hi < hi$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return $p_s_math_BigInt$__getCached__I__s_math_BigInt(this, lo);
    } else {
      return $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), x, new $c_RTLong(lo, hi));
    }
  } else {
    return $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), x, new $c_RTLong(0, (-2147483648)));
  }
});
var $d_s_math_BigInt$ = new $TypeData().initClass($c_s_math_BigInt$, "scala.math.BigInt$", ({
  s_math_BigInt$: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_math_BigInt$;
function $m_s_math_BigInt$() {
  if ((!$n_s_math_BigInt$)) {
    $n_s_math_BigInt$ = new $c_s_math_BigInt$();
  }
  return $n_s_math_BigInt$;
}
function $is_s_math_Equiv(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_math_Equiv)));
}
function $as_s_math_Equiv(obj) {
  return (($is_s_math_Equiv(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Equiv"));
}
function $isArrayOf_s_math_Equiv(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Equiv)));
}
function $asArrayOf_s_math_Equiv(obj, depth) {
  return (($isArrayOf_s_math_Equiv(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Equiv;", depth));
}
/** @constructor */
function $c_s_math_Integral$IntegralOps(outer, lhs) {
  this.s_math_Numeric$NumericOps__f_lhs = null;
  this.s_math_Numeric$NumericOps__f_$outer = null;
  this.s_math_Integral$IntegralOps__f_lhs = null;
  this.s_math_Integral$IntegralOps__f_lhs = lhs;
  $ct_s_math_Numeric$NumericOps__s_math_Numeric__O__(this, outer, lhs);
}
$c_s_math_Integral$IntegralOps.prototype = new $h_s_math_Numeric$NumericOps();
$c_s_math_Integral$IntegralOps.prototype.constructor = $c_s_math_Integral$IntegralOps;
/** @constructor */
function $h_s_math_Integral$IntegralOps() {
}
$h_s_math_Integral$IntegralOps.prototype = $c_s_math_Integral$IntegralOps.prototype;
$c_s_math_Integral$IntegralOps.prototype.$div__O__O = (function(rhs) {
  return $n($as_s_math_Integral(this.s_math_Numeric$NumericOps__f_$outer)).quot__O__O__O(this.s_math_Integral$IntegralOps__f_lhs, rhs);
});
var $d_s_math_Integral$IntegralOps = new $TypeData().initClass($c_s_math_Integral$IntegralOps, "scala.math.Integral$IntegralOps", ({
  s_math_Integral$IntegralOps: 1,
  s_math_Numeric$NumericOps: 1
}));
function $f_s_math_Ordered__$less__O__Z($thiz, that) {
  return ($thiz.compare__O__I(that) < 0);
}
function $f_s_math_Ordered__$greater__O__Z($thiz, that) {
  return ($thiz.compare__O__I(that) > 0);
}
function $f_s_math_Ordered__$less$eq__O__Z($thiz, that) {
  return ($thiz.compare__O__I(that) <= 0);
}
function $f_s_math_Ordered__$greater$eq__O__Z($thiz, that) {
  return ($thiz.compare__O__I(that) >= 0);
}
/** @constructor */
function $c_s_reflect_ClassTag$() {
  this.s_reflect_ClassTag$__f_Byte = null;
  this.s_reflect_ClassTag$__f_Short = null;
  this.s_reflect_ClassTag$__f_Char = null;
  this.s_reflect_ClassTag$__f_Int = null;
  this.s_reflect_ClassTag$__f_Long = null;
  this.s_reflect_ClassTag$__f_Float = null;
  this.s_reflect_ClassTag$__f_Double = null;
  this.s_reflect_ClassTag$__f_Boolean = null;
  this.s_reflect_ClassTag$__f_Unit = null;
  this.s_reflect_ClassTag$__f_Any = null;
  this.s_reflect_ClassTag$__f_Object = null;
  this.s_reflect_ClassTag$__f_AnyRef = null;
  this.s_reflect_ClassTag$__f_Nothing = null;
  this.s_reflect_ClassTag$__f_Null = null;
  $n_s_reflect_ClassTag$ = this;
  this.s_reflect_ClassTag$__f_Byte = $m_s_reflect_ManifestFactory$ByteManifest$();
  this.s_reflect_ClassTag$__f_Short = $m_s_reflect_ManifestFactory$ShortManifest$();
  this.s_reflect_ClassTag$__f_Char = $m_s_reflect_ManifestFactory$CharManifest$();
  this.s_reflect_ClassTag$__f_Int = $m_s_reflect_ManifestFactory$IntManifest$();
  this.s_reflect_ClassTag$__f_Long = $m_s_reflect_ManifestFactory$LongManifest$();
  this.s_reflect_ClassTag$__f_Float = $m_s_reflect_ManifestFactory$FloatManifest$();
  this.s_reflect_ClassTag$__f_Double = $m_s_reflect_ManifestFactory$DoubleManifest$();
  this.s_reflect_ClassTag$__f_Boolean = $m_s_reflect_ManifestFactory$BooleanManifest$();
  this.s_reflect_ClassTag$__f_Unit = $m_s_reflect_ManifestFactory$UnitManifest$();
  this.s_reflect_ClassTag$__f_Any = $m_s_reflect_ManifestFactory$AnyManifest$();
  this.s_reflect_ClassTag$__f_Object = $m_s_reflect_ManifestFactory$ObjectManifest$();
  this.s_reflect_ClassTag$__f_AnyRef = $m_s_reflect_ManifestFactory$ObjectManifest$();
  this.s_reflect_ClassTag$__f_Nothing = $m_s_reflect_ManifestFactory$NothingManifest$();
  this.s_reflect_ClassTag$__f_Null = $m_s_reflect_ManifestFactory$NullManifest$();
}
$c_s_reflect_ClassTag$.prototype = new $h_O();
$c_s_reflect_ClassTag$.prototype.constructor = $c_s_reflect_ClassTag$;
/** @constructor */
function $h_s_reflect_ClassTag$() {
}
$h_s_reflect_ClassTag$.prototype = $c_s_reflect_ClassTag$.prototype;
$c_s_reflect_ClassTag$.prototype.apply__jl_Class__s_reflect_ClassTag = (function(runtimeClass1) {
  return ((runtimeClass1 === $d_B.getClassOf()) ? $m_s_reflect_ManifestFactory$ByteManifest$() : ((runtimeClass1 === $d_S.getClassOf()) ? $m_s_reflect_ManifestFactory$ShortManifest$() : ((runtimeClass1 === $d_C.getClassOf()) ? $m_s_reflect_ManifestFactory$CharManifest$() : ((runtimeClass1 === $d_I.getClassOf()) ? $m_s_reflect_ManifestFactory$IntManifest$() : ((runtimeClass1 === $d_J.getClassOf()) ? $m_s_reflect_ManifestFactory$LongManifest$() : ((runtimeClass1 === $d_F.getClassOf()) ? $m_s_reflect_ManifestFactory$FloatManifest$() : ((runtimeClass1 === $d_D.getClassOf()) ? $m_s_reflect_ManifestFactory$DoubleManifest$() : ((runtimeClass1 === $d_Z.getClassOf()) ? $m_s_reflect_ManifestFactory$BooleanManifest$() : ((runtimeClass1 === $d_V.getClassOf()) ? $m_s_reflect_ManifestFactory$UnitManifest$() : ((runtimeClass1 === $d_O.getClassOf()) ? $m_s_reflect_ManifestFactory$ObjectManifest$() : ((runtimeClass1 === $d_sr_Nothing$.getClassOf()) ? $m_s_reflect_ManifestFactory$NothingManifest$() : ((runtimeClass1 === $d_sr_Null$.getClassOf()) ? $m_s_reflect_ManifestFactory$NullManifest$() : new $c_s_reflect_ClassTag$GenericClassTag(runtimeClass1)))))))))))));
});
var $d_s_reflect_ClassTag$ = new $TypeData().initClass($c_s_reflect_ClassTag$, "scala.reflect.ClassTag$", ({
  s_reflect_ClassTag$: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_reflect_ClassTag$;
function $m_s_reflect_ClassTag$() {
  if ((!$n_s_reflect_ClassTag$)) {
    $n_s_reflect_ClassTag$ = new $c_s_reflect_ClassTag$();
  }
  return $n_s_reflect_ClassTag$;
}
/** @constructor */
function $c_sr_AbstractFunction0() {
}
$c_sr_AbstractFunction0.prototype = new $h_O();
$c_sr_AbstractFunction0.prototype.constructor = $c_sr_AbstractFunction0;
/** @constructor */
function $h_sr_AbstractFunction0() {
}
$h_sr_AbstractFunction0.prototype = $c_sr_AbstractFunction0.prototype;
$c_sr_AbstractFunction0.prototype.toString__T = (function() {
  return "<function0>";
});
/** @constructor */
function $c_sr_AbstractFunction1() {
}
$c_sr_AbstractFunction1.prototype = new $h_O();
$c_sr_AbstractFunction1.prototype.constructor = $c_sr_AbstractFunction1;
/** @constructor */
function $h_sr_AbstractFunction1() {
}
$h_sr_AbstractFunction1.prototype = $c_sr_AbstractFunction1.prototype;
$c_sr_AbstractFunction1.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__O__O(v1));
});
$c_sr_AbstractFunction1.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sr_AbstractFunction1.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_sr_AbstractFunction1.prototype.toString__T = (function() {
  return "<function1>";
});
/** @constructor */
function $c_sr_AbstractFunction2() {
}
$c_sr_AbstractFunction2.prototype = new $h_O();
$c_sr_AbstractFunction2.prototype.constructor = $c_sr_AbstractFunction2;
/** @constructor */
function $h_sr_AbstractFunction2() {
}
$h_sr_AbstractFunction2.prototype = $c_sr_AbstractFunction2.prototype;
$c_sr_AbstractFunction2.prototype.toString__T = (function() {
  return "<function2>";
});
/** @constructor */
function $c_sr_AbstractFunction3() {
}
$c_sr_AbstractFunction3.prototype = new $h_O();
$c_sr_AbstractFunction3.prototype.constructor = $c_sr_AbstractFunction3;
/** @constructor */
function $h_sr_AbstractFunction3() {
}
$h_sr_AbstractFunction3.prototype = $c_sr_AbstractFunction3.prototype;
$c_sr_AbstractFunction3.prototype.toString__T = (function() {
  return "<function3>";
});
/** @constructor */
function $c_sr_AbstractFunction4() {
}
$c_sr_AbstractFunction4.prototype = new $h_O();
$c_sr_AbstractFunction4.prototype.constructor = $c_sr_AbstractFunction4;
/** @constructor */
function $h_sr_AbstractFunction4() {
}
$h_sr_AbstractFunction4.prototype = $c_sr_AbstractFunction4.prototype;
$c_sr_AbstractFunction4.prototype.toString__T = (function() {
  return "<function4>";
});
/** @constructor */
function $c_sr_AbstractFunction5() {
}
$c_sr_AbstractFunction5.prototype = new $h_O();
$c_sr_AbstractFunction5.prototype.constructor = $c_sr_AbstractFunction5;
/** @constructor */
function $h_sr_AbstractFunction5() {
}
$h_sr_AbstractFunction5.prototype = $c_sr_AbstractFunction5.prototype;
$c_sr_AbstractFunction5.prototype.toString__T = (function() {
  return "<function5>";
});
/** @constructor */
function $c_sr_AbstractFunction6() {
}
$c_sr_AbstractFunction6.prototype = new $h_O();
$c_sr_AbstractFunction6.prototype.constructor = $c_sr_AbstractFunction6;
/** @constructor */
function $h_sr_AbstractFunction6() {
}
$h_sr_AbstractFunction6.prototype = $c_sr_AbstractFunction6.prototype;
$c_sr_AbstractFunction6.prototype.toString__T = (function() {
  return "<function6>";
});
/** @constructor */
function $c_sr_AbstractFunction7() {
}
$c_sr_AbstractFunction7.prototype = new $h_O();
$c_sr_AbstractFunction7.prototype.constructor = $c_sr_AbstractFunction7;
/** @constructor */
function $h_sr_AbstractFunction7() {
}
$h_sr_AbstractFunction7.prototype = $c_sr_AbstractFunction7.prototype;
$c_sr_AbstractFunction7.prototype.toString__T = (function() {
  return "<function7>";
});
/** @constructor */
function $c_sr_BooleanRef(elem) {
  this.sr_BooleanRef__f_elem = false;
  this.sr_BooleanRef__f_elem = elem;
}
$c_sr_BooleanRef.prototype = new $h_O();
$c_sr_BooleanRef.prototype.constructor = $c_sr_BooleanRef;
/** @constructor */
function $h_sr_BooleanRef() {
}
$h_sr_BooleanRef.prototype = $c_sr_BooleanRef.prototype;
$c_sr_BooleanRef.prototype.toString__T = (function() {
  var b = this.sr_BooleanRef__f_elem;
  return ("" + b);
});
var $d_sr_BooleanRef = new $TypeData().initClass($c_sr_BooleanRef, "scala.runtime.BooleanRef", ({
  sr_BooleanRef: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sr_IntRef(elem) {
  this.sr_IntRef__f_elem = 0;
  this.sr_IntRef__f_elem = elem;
}
$c_sr_IntRef.prototype = new $h_O();
$c_sr_IntRef.prototype.constructor = $c_sr_IntRef;
/** @constructor */
function $h_sr_IntRef() {
}
$h_sr_IntRef.prototype = $c_sr_IntRef.prototype;
$c_sr_IntRef.prototype.toString__T = (function() {
  var i = this.sr_IntRef__f_elem;
  return ("" + i);
});
var $d_sr_IntRef = new $TypeData().initClass($c_sr_IntRef, "scala.runtime.IntRef", ({
  sr_IntRef: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sr_LazyRef() {
  this.sr_LazyRef__f__initialized = false;
  this.sr_LazyRef__f__value = null;
}
$c_sr_LazyRef.prototype = new $h_O();
$c_sr_LazyRef.prototype.constructor = $c_sr_LazyRef;
/** @constructor */
function $h_sr_LazyRef() {
}
$h_sr_LazyRef.prototype = $c_sr_LazyRef.prototype;
$c_sr_LazyRef.prototype.initialize__O__O = (function(value) {
  this.sr_LazyRef__f__value = value;
  this.sr_LazyRef__f__initialized = true;
  return value;
});
$c_sr_LazyRef.prototype.toString__T = (function() {
  return ("LazyRef " + (this.sr_LazyRef__f__initialized ? ("of: " + this.sr_LazyRef__f__value) : "thunk"));
});
var $d_sr_LazyRef = new $TypeData().initClass($c_sr_LazyRef, "scala.runtime.LazyRef", ({
  sr_LazyRef: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sr_ObjectRef(elem) {
  this.sr_ObjectRef__f_elem = null;
  this.sr_ObjectRef__f_elem = elem;
}
$c_sr_ObjectRef.prototype = new $h_O();
$c_sr_ObjectRef.prototype.constructor = $c_sr_ObjectRef;
/** @constructor */
function $h_sr_ObjectRef() {
}
$h_sr_ObjectRef.prototype = $c_sr_ObjectRef.prototype;
$c_sr_ObjectRef.prototype.toString__T = (function() {
  var obj = this.sr_ObjectRef__f_elem;
  return ("" + obj);
});
var $d_sr_ObjectRef = new $TypeData().initClass($c_sr_ObjectRef, "scala.runtime.ObjectRef", ({
  sr_ObjectRef: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_util_Either$() {
}
$c_s_util_Either$.prototype = new $h_O();
$c_s_util_Either$.prototype.constructor = $c_s_util_Either$;
/** @constructor */
function $h_s_util_Either$() {
}
$h_s_util_Either$.prototype = $c_s_util_Either$.prototype;
var $d_s_util_Either$ = new $TypeData().initClass($c_s_util_Either$, "scala.util.Either$", ({
  s_util_Either$: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_util_Either$;
function $m_s_util_Either$() {
  if ((!$n_s_util_Either$)) {
    $n_s_util_Either$ = new $c_s_util_Either$();
  }
  return $n_s_util_Either$;
}
/** @constructor */
function $c_s_util_Left$() {
}
$c_s_util_Left$.prototype = new $h_O();
$c_s_util_Left$.prototype.constructor = $c_s_util_Left$;
/** @constructor */
function $h_s_util_Left$() {
}
$h_s_util_Left$.prototype = $c_s_util_Left$.prototype;
$c_s_util_Left$.prototype.toString__T = (function() {
  return "Left";
});
var $d_s_util_Left$ = new $TypeData().initClass($c_s_util_Left$, "scala.util.Left$", ({
  s_util_Left$: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_util_Left$;
function $m_s_util_Left$() {
  if ((!$n_s_util_Left$)) {
    $n_s_util_Left$ = new $c_s_util_Left$();
  }
  return $n_s_util_Left$;
}
/** @constructor */
function $c_s_util_NotGiven$() {
  this.s_util_NotGiven$__f_cachedValue = null;
  $n_s_util_NotGiven$ = this;
  this.s_util_NotGiven$__f_cachedValue = new $c_s_util_NotGiven();
}
$c_s_util_NotGiven$.prototype = new $h_O();
$c_s_util_NotGiven$.prototype.constructor = $c_s_util_NotGiven$;
/** @constructor */
function $h_s_util_NotGiven$() {
}
$h_s_util_NotGiven$.prototype = $c_s_util_NotGiven$.prototype;
var $d_s_util_NotGiven$ = new $TypeData().initClass($c_s_util_NotGiven$, "scala.util.NotGiven$", ({
  s_util_NotGiven$: 1,
  s_util_LowPriorityNotGiven: 1
}));
var $n_s_util_NotGiven$;
function $m_s_util_NotGiven$() {
  if ((!$n_s_util_NotGiven$)) {
    $n_s_util_NotGiven$ = new $c_s_util_NotGiven$();
  }
  return $n_s_util_NotGiven$;
}
function $ct_s_util_Random__ju_Random__($thiz, self) {
  $thiz.s_util_Random__f_self = self;
  return $thiz;
}
function $ct_s_util_Random__($thiz) {
  $ct_s_util_Random__ju_Random__($thiz, $ct_ju_Random__(new $c_ju_Random()));
  return $thiz;
}
/** @constructor */
function $c_s_util_Random() {
  this.s_util_Random__f_self = null;
}
$c_s_util_Random.prototype = new $h_O();
$c_s_util_Random.prototype.constructor = $c_s_util_Random;
/** @constructor */
function $h_s_util_Random() {
}
$h_s_util_Random.prototype = $c_s_util_Random.prototype;
function $as_s_util_Random(obj) {
  return (((obj instanceof $c_s_util_Random) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Random"));
}
function $isArrayOf_s_util_Random(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Random)));
}
function $asArrayOf_s_util_Random(obj, depth) {
  return (($isArrayOf_s_util_Random(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Random;", depth));
}
var $d_s_util_Random = new $TypeData().initClass($c_s_util_Random, "scala.util.Random", ({
  s_util_Random: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_util_Right$() {
}
$c_s_util_Right$.prototype = new $h_O();
$c_s_util_Right$.prototype.constructor = $c_s_util_Right$;
/** @constructor */
function $h_s_util_Right$() {
}
$h_s_util_Right$.prototype = $c_s_util_Right$.prototype;
$c_s_util_Right$.prototype.toString__T = (function() {
  return "Right";
});
var $d_s_util_Right$ = new $TypeData().initClass($c_s_util_Right$, "scala.util.Right$", ({
  s_util_Right$: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_util_Right$;
function $m_s_util_Right$() {
  if ((!$n_s_util_Right$)) {
    $n_s_util_Right$ = new $c_s_util_Right$();
  }
  return $n_s_util_Right$;
}
/** @constructor */
function $c_s_util_Try$() {
}
$c_s_util_Try$.prototype = new $h_O();
$c_s_util_Try$.prototype.constructor = $c_s_util_Try$;
/** @constructor */
function $h_s_util_Try$() {
}
$h_s_util_Try$.prototype = $c_s_util_Try$.prototype;
$c_s_util_Try$.prototype.apply__F0__s_util_Try = (function(r) {
  try {
    var r1 = $n(r).apply__O();
    return new $c_s_util_Success(r1);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      return new $c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2));
    }
  }
});
var $d_s_util_Try$ = new $TypeData().initClass($c_s_util_Try$, "scala.util.Try$", ({
  s_util_Try$: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_util_Try$;
function $m_s_util_Try$() {
  if ((!$n_s_util_Try$)) {
    $n_s_util_Try$ = new $c_s_util_Try$();
  }
  return $n_s_util_Try$;
}
/** @constructor */
function $c_s_util_control_NoStackTrace$() {
  this.s_util_control_NoStackTrace$__f__noSuppression = false;
  this.s_util_control_NoStackTrace$__f__noSuppression = false;
}
$c_s_util_control_NoStackTrace$.prototype = new $h_O();
$c_s_util_control_NoStackTrace$.prototype.constructor = $c_s_util_control_NoStackTrace$;
/** @constructor */
function $h_s_util_control_NoStackTrace$() {
}
$h_s_util_control_NoStackTrace$.prototype = $c_s_util_control_NoStackTrace$.prototype;
var $d_s_util_control_NoStackTrace$ = new $TypeData().initClass($c_s_util_control_NoStackTrace$, "scala.util.control.NoStackTrace$", ({
  s_util_control_NoStackTrace$: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_util_control_NoStackTrace$;
function $m_s_util_control_NoStackTrace$() {
  if ((!$n_s_util_control_NoStackTrace$)) {
    $n_s_util_control_NoStackTrace$ = new $c_s_util_control_NoStackTrace$();
  }
  return $n_s_util_control_NoStackTrace$;
}
/** @constructor */
function $c_s_util_hashing_MurmurHash3$() {
  this.s_util_hashing_MurmurHash3$__f_seqSeed = 0;
  this.s_util_hashing_MurmurHash3$__f_mapSeed = 0;
  this.s_util_hashing_MurmurHash3$__f_setSeed = 0;
  this.s_util_hashing_MurmurHash3$__f_emptyMapHash = 0;
  $n_s_util_hashing_MurmurHash3$ = this;
  this.s_util_hashing_MurmurHash3$__f_seqSeed = $f_T__hashCode__I("Seq");
  this.s_util_hashing_MurmurHash3$__f_mapSeed = $f_T__hashCode__I("Map");
  this.s_util_hashing_MurmurHash3$__f_setSeed = $f_T__hashCode__I("Set");
  this.s_util_hashing_MurmurHash3$__f_emptyMapHash = this.unorderedHash__sc_IterableOnce__I__I($m_sci_Nil$(), this.s_util_hashing_MurmurHash3$__f_mapSeed);
}
$c_s_util_hashing_MurmurHash3$.prototype = new $h_s_util_hashing_MurmurHash3();
$c_s_util_hashing_MurmurHash3$.prototype.constructor = $c_s_util_hashing_MurmurHash3$;
/** @constructor */
function $h_s_util_hashing_MurmurHash3$() {
}
$h_s_util_hashing_MurmurHash3$.prototype = $c_s_util_hashing_MurmurHash3$.prototype;
$c_s_util_hashing_MurmurHash3$.prototype.tuple2Hash__O__O__I = (function(x, y) {
  return this.tuple2Hash__I__I__I__I($m_sr_Statics$().anyHash__O__I(x), $m_sr_Statics$().anyHash__O__I(y), (-889275714));
});
$c_s_util_hashing_MurmurHash3$.prototype.seqHash__sc_Seq__I = (function(xs) {
  if ($is_sc_IndexedSeq(xs)) {
    var x2 = $as_sc_IndexedSeq(xs);
    return this.indexedSeqHash__sc_IndexedSeq__I__I(x2, this.s_util_hashing_MurmurHash3$__f_seqSeed);
  } else if ((xs instanceof $c_sci_List)) {
    var x3 = $as_sci_List(xs);
    return this.listHash__sci_List__I__I(x3, this.s_util_hashing_MurmurHash3$__f_seqSeed);
  } else {
    return this.orderedHash__sc_IterableOnce__I__I(xs, this.s_util_hashing_MurmurHash3$__f_seqSeed);
  }
});
$c_s_util_hashing_MurmurHash3$.prototype.mapHash__sc_Map__I = (function(xs) {
  if ($n(xs).isEmpty__Z()) {
    return this.s_util_hashing_MurmurHash3$__f_emptyMapHash;
  } else {
    var accum = new $c_s_util_hashing_MurmurHash3$accum$1();
    var h = this.s_util_hashing_MurmurHash3$__f_mapSeed;
    $n(xs).foreachEntry__F2__V(accum);
    h = this.mix__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_a);
    h = this.mix__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_b);
    h = this.mixLast__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_c);
    return this.finalizeHash__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_n);
  }
});
var $d_s_util_hashing_MurmurHash3$ = new $TypeData().initClass($c_s_util_hashing_MurmurHash3$, "scala.util.hashing.MurmurHash3$", ({
  s_util_hashing_MurmurHash3$: 1,
  s_util_hashing_MurmurHash3: 1
}));
var $n_s_util_hashing_MurmurHash3$;
function $m_s_util_hashing_MurmurHash3$() {
  if ((!$n_s_util_hashing_MurmurHash3$)) {
    $n_s_util_hashing_MurmurHash3$ = new $c_s_util_hashing_MurmurHash3$();
  }
  return $n_s_util_hashing_MurmurHash3$;
}
/** @constructor */
function $c_s_util_hashing_MurmurHash3$accum$1() {
  this.s_util_hashing_MurmurHash3$accum$1__f_a = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_b = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_n = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_c = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_a = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_b = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_n = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_c = 1;
}
$c_s_util_hashing_MurmurHash3$accum$1.prototype = new $h_O();
$c_s_util_hashing_MurmurHash3$accum$1.prototype.constructor = $c_s_util_hashing_MurmurHash3$accum$1;
/** @constructor */
function $h_s_util_hashing_MurmurHash3$accum$1() {
}
$h_s_util_hashing_MurmurHash3$accum$1.prototype = $c_s_util_hashing_MurmurHash3$accum$1.prototype;
$c_s_util_hashing_MurmurHash3$accum$1.prototype.toString__T = (function() {
  return "<function2>";
});
$c_s_util_hashing_MurmurHash3$accum$1.prototype.apply__O__O__V = (function(k, v) {
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(k, v);
  this.s_util_hashing_MurmurHash3$accum$1__f_a = ((this.s_util_hashing_MurmurHash3$accum$1__f_a + h) | 0);
  this.s_util_hashing_MurmurHash3$accum$1__f_b = (this.s_util_hashing_MurmurHash3$accum$1__f_b ^ h);
  this.s_util_hashing_MurmurHash3$accum$1__f_c = Math.imul(this.s_util_hashing_MurmurHash3$accum$1__f_c, (1 | h));
  this.s_util_hashing_MurmurHash3$accum$1__f_n = ((1 + this.s_util_hashing_MurmurHash3$accum$1__f_n) | 0);
});
$c_s_util_hashing_MurmurHash3$accum$1.prototype.apply__O__O__O = (function(v1, v2) {
  this.apply__O__O__V(v1, v2);
});
var $d_s_util_hashing_MurmurHash3$accum$1 = new $TypeData().initClass($c_s_util_hashing_MurmurHash3$accum$1, "scala.util.hashing.MurmurHash3$accum$1", ({
  s_util_hashing_MurmurHash3$accum$1: 1,
  F2: 1
}));
function $ct_s_util_matching_Regex__ju_regex_Pattern__sci_Seq__($thiz, pattern, groupNames) {
  $thiz.s_util_matching_Regex__f_pattern = pattern;
  return $thiz;
}
function $ct_s_util_matching_Regex__T__sci_Seq__($thiz, regex, groupNames) {
  $ct_s_util_matching_Regex__ju_regex_Pattern__sci_Seq__($thiz, $m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern(regex, 0), groupNames);
  return $thiz;
}
/** @constructor */
function $c_s_util_matching_Regex() {
  this.s_util_matching_Regex__f_pattern = null;
}
$c_s_util_matching_Regex.prototype = new $h_O();
$c_s_util_matching_Regex.prototype.constructor = $c_s_util_matching_Regex;
/** @constructor */
function $h_s_util_matching_Regex() {
}
$h_s_util_matching_Regex.prototype = $c_s_util_matching_Regex.prototype;
$c_s_util_matching_Regex.prototype.unapplySeq__jl_CharSequence__s_Option = (function(s) {
  var this$1 = $n(this.s_util_matching_Regex__f_pattern);
  var m = new $c_ju_regex_Matcher(this$1, $dp_toString__T($n(s)));
  if (m.matches__Z()) {
    var n = $n(m.ju_regex_Matcher__f_pattern0).ju_regex_Pattern__f_groupCount;
    var b = new $c_scm_ListBuffer();
    var i = 0;
    while ((i < n)) {
      var arg1 = i;
      var elem = m.group__I__T(((1 + arg1) | 0));
      b.addOne__O__scm_ListBuffer(elem);
      i = ((1 + i) | 0);
    }
    return new $c_s_Some(b.toList__sci_List());
  } else {
    return $m_s_None$();
  }
});
$c_s_util_matching_Regex.prototype.toString__T = (function() {
  return $n(this.s_util_matching_Regex__f_pattern).ju_regex_Pattern__f__pattern;
});
var $d_s_util_matching_Regex = new $TypeData().initClass($c_s_util_matching_Regex, "scala.util.matching.Regex", ({
  s_util_matching_Regex: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lsnabbdom_DomApi$$anon$1() {
}
$c_Lsnabbdom_DomApi$$anon$1.prototype = new $h_O();
$c_Lsnabbdom_DomApi$$anon$1.prototype.constructor = $c_Lsnabbdom_DomApi$$anon$1;
/** @constructor */
function $h_Lsnabbdom_DomApi$$anon$1() {
}
$h_Lsnabbdom_DomApi$$anon$1.prototype = $c_Lsnabbdom_DomApi$$anon$1.prototype;
$c_Lsnabbdom_DomApi$$anon$1.prototype.createElement__T__Lorg_scalajs_dom_HTMLElement = (function(tagName) {
  return document.createElement(tagName);
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.createElementNS__T__T__Lorg_scalajs_dom_Element = (function(namespaceURI, qualifiedName) {
  return document.createElementNS(namespaceURI, qualifiedName);
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.createDocumentFragment__Lorg_scalajs_dom_DocumentFragment = (function() {
  return document.createDocumentFragment();
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.createTextNode__T__Lorg_scalajs_dom_Text = (function(text) {
  return document.createTextNode(text);
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.createComment__T__Lorg_scalajs_dom_Comment = (function(text) {
  return document.createComment(text);
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.insertBefore__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__s_Option__V = (function(parentNode, newNode, referenceNode) {
  var this$1 = $n(referenceNode);
  parentNode.insertBefore(newNode, (this$1.isEmpty__Z() ? null : this$1.get__O()));
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.removeChild__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__V = (function(node, child) {
  node.removeChild(child);
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.appendChild__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__V = (function(node, child) {
  node.appendChild(child);
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.parentNode__Lorg_scalajs_dom_Node__s_Option = (function(node) {
  return $m_s_Option$().apply__O__s_Option(node.parentNode);
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.nextSibling__Lorg_scalajs_dom_Node__s_Option = (function(node) {
  return $m_s_Option$().apply__O__s_Option(node.nextSibling);
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.tagName__Lorg_scalajs_dom_Element__T = (function(elm) {
  return $as_T(elm.tagName);
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.setTextContent__Lorg_scalajs_dom_Node__s_Option__V = (function(node, text) {
  var this$1 = $n(text);
  node.textContent = $as_T((this$1.isEmpty__Z() ? null : this$1.get__O()));
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.getTextContent__Lorg_scalajs_dom_Node__s_Option = (function(node) {
  return $m_s_Option$().apply__O__s_Option($as_T(node.textContent));
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.isElement__Lorg_scalajs_dom_Node__Z = (function(node) {
  return ($uI(node.nodeType) === 1);
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.isText__Lorg_scalajs_dom_Node__Z = (function(node) {
  return ($uI(node.nodeType) === 3);
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.isComment__Lorg_scalajs_dom_Node__Z = (function(node) {
  return ($uI(node.nodeType) === 8);
});
var $d_Lsnabbdom_DomApi$$anon$1 = new $TypeData().initClass($c_Lsnabbdom_DomApi$$anon$1, "snabbdom.DomApi$$anon$1", ({
  Lsnabbdom_DomApi$$anon$1: 1,
  Lsnabbdom_DomApi: 1
}));
/** @constructor */
function $c_Lsnabbdom_init$$anon$1(api$24, cbs$19) {
  this.Lsnabbdom_init$$anon$1__f_api$23 = null;
  this.Lsnabbdom_init$$anon$1__f_cbs$18 = null;
  this.Lsnabbdom_init$$anon$1__f_api$23 = api$24;
  this.Lsnabbdom_init$$anon$1__f_cbs$18 = cbs$19;
}
$c_Lsnabbdom_init$$anon$1.prototype = new $h_O();
$c_Lsnabbdom_init$$anon$1.prototype.constructor = $c_Lsnabbdom_init$$anon$1;
/** @constructor */
function $h_Lsnabbdom_init$$anon$1() {
}
$h_Lsnabbdom_init$$anon$1.prototype = $c_Lsnabbdom_init$$anon$1.prototype;
$c_Lsnabbdom_init$$anon$1.prototype.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__Lsnabbdom_VNode = (function(oldVnode, vnode) {
  return $m_Lsnabbdom_init$().snabbdom$init$$$_$patch$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__Lsnabbdom_VNode__Lsnabbdom_VNode(this.Lsnabbdom_init$$anon$1__f_api$23, this.Lsnabbdom_init$$anon$1__f_cbs$18, oldVnode, vnode);
});
$c_Lsnabbdom_init$$anon$1.prototype.apply__Lorg_scalajs_dom_Element__Lsnabbdom_VNode__Lsnabbdom_VNode = (function(elm, vnode) {
  return $m_Lsnabbdom_init$().snabbdom$init$$$_$patch$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__Lsnabbdom_VNode__Lsnabbdom_VNode(this.Lsnabbdom_init$$anon$1__f_api$23, this.Lsnabbdom_init$$anon$1__f_cbs$18, $m_Lsnabbdom_init$().snabbdom$init$$$_$emptyNodeAt$1__Lsnabbdom_DomApi__Lorg_scalajs_dom_Element__Lsnabbdom_VNode(this.Lsnabbdom_init$$anon$1__f_api$23, elm), vnode);
});
var $d_Lsnabbdom_init$$anon$1 = new $TypeData().initClass($c_Lsnabbdom_init$$anon$1, "snabbdom.init$$anon$1", ({
  Lsnabbdom_init$$anon$1: 1,
  Lsnabbdom_Patch: 1
}));
/** @constructor */
function $c_Lsnabbdom_modules_Attributes$$anon$1() {
}
$c_Lsnabbdom_modules_Attributes$$anon$1.prototype = new $h_O();
$c_Lsnabbdom_modules_Attributes$$anon$1.prototype.constructor = $c_Lsnabbdom_modules_Attributes$$anon$1;
/** @constructor */
function $h_Lsnabbdom_modules_Attributes$$anon$1() {
}
$h_Lsnabbdom_modules_Attributes$$anon$1.prototype = $c_Lsnabbdom_modules_Attributes$$anon$1.prototype;
$c_Lsnabbdom_modules_Attributes$$anon$1.prototype.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O = (function(emptyVNode, vNode) {
  $m_Lsnabbdom_modules_Attributes$().snabbdom$modules$Attributes$$$updateAttrs__Lsnabbdom_VNode__Lsnabbdom_VNode__V(emptyVNode, vNode);
});
var $d_Lsnabbdom_modules_Attributes$$anon$1 = new $TypeData().initClass($c_Lsnabbdom_modules_Attributes$$anon$1, "snabbdom.modules.Attributes$$anon$1", ({
  Lsnabbdom_modules_Attributes$$anon$1: 1,
  Lsnabbdom_CreateHook: 1
}));
/** @constructor */
function $c_Lsnabbdom_modules_Attributes$$anon$2() {
}
$c_Lsnabbdom_modules_Attributes$$anon$2.prototype = new $h_O();
$c_Lsnabbdom_modules_Attributes$$anon$2.prototype.constructor = $c_Lsnabbdom_modules_Attributes$$anon$2;
/** @constructor */
function $h_Lsnabbdom_modules_Attributes$$anon$2() {
}
$h_Lsnabbdom_modules_Attributes$$anon$2.prototype = $c_Lsnabbdom_modules_Attributes$$anon$2.prototype;
$c_Lsnabbdom_modules_Attributes$$anon$2.prototype.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O = (function(oldVNode, vNode) {
  $m_Lsnabbdom_modules_Attributes$().snabbdom$modules$Attributes$$$updateAttrs__Lsnabbdom_VNode__Lsnabbdom_VNode__V(oldVNode, vNode);
});
var $d_Lsnabbdom_modules_Attributes$$anon$2 = new $TypeData().initClass($c_Lsnabbdom_modules_Attributes$$anon$2, "snabbdom.modules.Attributes$$anon$2", ({
  Lsnabbdom_modules_Attributes$$anon$2: 1,
  Lsnabbdom_UpdateHook: 1
}));
/** @constructor */
function $c_Lsnabbdom_modules_Classes$$anon$1() {
}
$c_Lsnabbdom_modules_Classes$$anon$1.prototype = new $h_O();
$c_Lsnabbdom_modules_Classes$$anon$1.prototype.constructor = $c_Lsnabbdom_modules_Classes$$anon$1;
/** @constructor */
function $h_Lsnabbdom_modules_Classes$$anon$1() {
}
$h_Lsnabbdom_modules_Classes$$anon$1.prototype = $c_Lsnabbdom_modules_Classes$$anon$1.prototype;
$c_Lsnabbdom_modules_Classes$$anon$1.prototype.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O = (function(emptyVNode, vNode) {
  $m_Lsnabbdom_modules_Classes$().snabbdom$modules$Classes$$$updateClasses__Lsnabbdom_VNode__Lsnabbdom_VNode__V(emptyVNode, vNode);
});
var $d_Lsnabbdom_modules_Classes$$anon$1 = new $TypeData().initClass($c_Lsnabbdom_modules_Classes$$anon$1, "snabbdom.modules.Classes$$anon$1", ({
  Lsnabbdom_modules_Classes$$anon$1: 1,
  Lsnabbdom_CreateHook: 1
}));
/** @constructor */
function $c_Lsnabbdom_modules_Classes$$anon$2() {
}
$c_Lsnabbdom_modules_Classes$$anon$2.prototype = new $h_O();
$c_Lsnabbdom_modules_Classes$$anon$2.prototype.constructor = $c_Lsnabbdom_modules_Classes$$anon$2;
/** @constructor */
function $h_Lsnabbdom_modules_Classes$$anon$2() {
}
$h_Lsnabbdom_modules_Classes$$anon$2.prototype = $c_Lsnabbdom_modules_Classes$$anon$2.prototype;
$c_Lsnabbdom_modules_Classes$$anon$2.prototype.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O = (function(oldVNode, vNode) {
  $m_Lsnabbdom_modules_Classes$().snabbdom$modules$Classes$$$updateClasses__Lsnabbdom_VNode__Lsnabbdom_VNode__V(oldVNode, vNode);
});
var $d_Lsnabbdom_modules_Classes$$anon$2 = new $TypeData().initClass($c_Lsnabbdom_modules_Classes$$anon$2, "snabbdom.modules.Classes$$anon$2", ({
  Lsnabbdom_modules_Classes$$anon$2: 1,
  Lsnabbdom_UpdateHook: 1
}));
/** @constructor */
function $c_Lsnabbdom_modules_Dataset$$anon$1() {
}
$c_Lsnabbdom_modules_Dataset$$anon$1.prototype = new $h_O();
$c_Lsnabbdom_modules_Dataset$$anon$1.prototype.constructor = $c_Lsnabbdom_modules_Dataset$$anon$1;
/** @constructor */
function $h_Lsnabbdom_modules_Dataset$$anon$1() {
}
$h_Lsnabbdom_modules_Dataset$$anon$1.prototype = $c_Lsnabbdom_modules_Dataset$$anon$1.prototype;
$c_Lsnabbdom_modules_Dataset$$anon$1.prototype.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O = (function(emptyVNode, vNode) {
  $m_Lsnabbdom_modules_Dataset$().snabbdom$modules$Dataset$$$updateDataset__Lsnabbdom_VNode__Lsnabbdom_VNode__V(emptyVNode, vNode);
});
var $d_Lsnabbdom_modules_Dataset$$anon$1 = new $TypeData().initClass($c_Lsnabbdom_modules_Dataset$$anon$1, "snabbdom.modules.Dataset$$anon$1", ({
  Lsnabbdom_modules_Dataset$$anon$1: 1,
  Lsnabbdom_CreateHook: 1
}));
/** @constructor */
function $c_Lsnabbdom_modules_Dataset$$anon$2() {
}
$c_Lsnabbdom_modules_Dataset$$anon$2.prototype = new $h_O();
$c_Lsnabbdom_modules_Dataset$$anon$2.prototype.constructor = $c_Lsnabbdom_modules_Dataset$$anon$2;
/** @constructor */
function $h_Lsnabbdom_modules_Dataset$$anon$2() {
}
$h_Lsnabbdom_modules_Dataset$$anon$2.prototype = $c_Lsnabbdom_modules_Dataset$$anon$2.prototype;
$c_Lsnabbdom_modules_Dataset$$anon$2.prototype.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O = (function(oldVNode, vNode) {
  $m_Lsnabbdom_modules_Dataset$().snabbdom$modules$Dataset$$$updateDataset__Lsnabbdom_VNode__Lsnabbdom_VNode__V(oldVNode, vNode);
});
var $d_Lsnabbdom_modules_Dataset$$anon$2 = new $TypeData().initClass($c_Lsnabbdom_modules_Dataset$$anon$2, "snabbdom.modules.Dataset$$anon$2", ({
  Lsnabbdom_modules_Dataset$$anon$2: 1,
  Lsnabbdom_UpdateHook: 1
}));
/** @constructor */
function $c_Lsnabbdom_modules_EventListeners$$anon$1() {
}
$c_Lsnabbdom_modules_EventListeners$$anon$1.prototype = new $h_O();
$c_Lsnabbdom_modules_EventListeners$$anon$1.prototype.constructor = $c_Lsnabbdom_modules_EventListeners$$anon$1;
/** @constructor */
function $h_Lsnabbdom_modules_EventListeners$$anon$1() {
}
$h_Lsnabbdom_modules_EventListeners$$anon$1.prototype = $c_Lsnabbdom_modules_EventListeners$$anon$1.prototype;
$c_Lsnabbdom_modules_EventListeners$$anon$1.prototype.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O = (function(emptyVNode, vNode) {
  $m_Lsnabbdom_modules_EventListeners$().snabbdom$modules$EventListeners$$$updateEventListeners__Lsnabbdom_VNode__s_Option__V(emptyVNode, new $c_s_Some(vNode));
});
var $d_Lsnabbdom_modules_EventListeners$$anon$1 = new $TypeData().initClass($c_Lsnabbdom_modules_EventListeners$$anon$1, "snabbdom.modules.EventListeners$$anon$1", ({
  Lsnabbdom_modules_EventListeners$$anon$1: 1,
  Lsnabbdom_CreateHook: 1
}));
/** @constructor */
function $c_Lsnabbdom_modules_EventListeners$$anon$2() {
}
$c_Lsnabbdom_modules_EventListeners$$anon$2.prototype = new $h_O();
$c_Lsnabbdom_modules_EventListeners$$anon$2.prototype.constructor = $c_Lsnabbdom_modules_EventListeners$$anon$2;
/** @constructor */
function $h_Lsnabbdom_modules_EventListeners$$anon$2() {
}
$h_Lsnabbdom_modules_EventListeners$$anon$2.prototype = $c_Lsnabbdom_modules_EventListeners$$anon$2.prototype;
$c_Lsnabbdom_modules_EventListeners$$anon$2.prototype.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O = (function(oldVNode, vNode) {
  $m_Lsnabbdom_modules_EventListeners$().snabbdom$modules$EventListeners$$$updateEventListeners__Lsnabbdom_VNode__s_Option__V(oldVNode, new $c_s_Some(vNode));
});
var $d_Lsnabbdom_modules_EventListeners$$anon$2 = new $TypeData().initClass($c_Lsnabbdom_modules_EventListeners$$anon$2, "snabbdom.modules.EventListeners$$anon$2", ({
  Lsnabbdom_modules_EventListeners$$anon$2: 1,
  Lsnabbdom_UpdateHook: 1
}));
/** @constructor */
function $c_Lsnabbdom_modules_EventListeners$$anon$3() {
}
$c_Lsnabbdom_modules_EventListeners$$anon$3.prototype = new $h_O();
$c_Lsnabbdom_modules_EventListeners$$anon$3.prototype.constructor = $c_Lsnabbdom_modules_EventListeners$$anon$3;
/** @constructor */
function $h_Lsnabbdom_modules_EventListeners$$anon$3() {
}
$h_Lsnabbdom_modules_EventListeners$$anon$3.prototype = $c_Lsnabbdom_modules_EventListeners$$anon$3.prototype;
var $d_Lsnabbdom_modules_EventListeners$$anon$3 = new $TypeData().initClass($c_Lsnabbdom_modules_EventListeners$$anon$3, "snabbdom.modules.EventListeners$$anon$3", ({
  Lsnabbdom_modules_EventListeners$$anon$3: 1,
  Lsnabbdom_DestroyHook: 1
}));
/** @constructor */
function $c_Lsnabbdom_modules_Props$$anon$1() {
}
$c_Lsnabbdom_modules_Props$$anon$1.prototype = new $h_O();
$c_Lsnabbdom_modules_Props$$anon$1.prototype.constructor = $c_Lsnabbdom_modules_Props$$anon$1;
/** @constructor */
function $h_Lsnabbdom_modules_Props$$anon$1() {
}
$h_Lsnabbdom_modules_Props$$anon$1.prototype = $c_Lsnabbdom_modules_Props$$anon$1.prototype;
$c_Lsnabbdom_modules_Props$$anon$1.prototype.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O = (function(emptyVNode, vNode) {
  $m_Lsnabbdom_modules_Props$().snabbdom$modules$Props$$$updateProps__Lsnabbdom_VNode__Lsnabbdom_VNode__V(emptyVNode, vNode);
});
var $d_Lsnabbdom_modules_Props$$anon$1 = new $TypeData().initClass($c_Lsnabbdom_modules_Props$$anon$1, "snabbdom.modules.Props$$anon$1", ({
  Lsnabbdom_modules_Props$$anon$1: 1,
  Lsnabbdom_CreateHook: 1
}));
/** @constructor */
function $c_Lsnabbdom_modules_Props$$anon$2() {
}
$c_Lsnabbdom_modules_Props$$anon$2.prototype = new $h_O();
$c_Lsnabbdom_modules_Props$$anon$2.prototype.constructor = $c_Lsnabbdom_modules_Props$$anon$2;
/** @constructor */
function $h_Lsnabbdom_modules_Props$$anon$2() {
}
$h_Lsnabbdom_modules_Props$$anon$2.prototype = $c_Lsnabbdom_modules_Props$$anon$2.prototype;
$c_Lsnabbdom_modules_Props$$anon$2.prototype.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O = (function(oldVNode, vNode) {
  $m_Lsnabbdom_modules_Props$().snabbdom$modules$Props$$$updateProps__Lsnabbdom_VNode__Lsnabbdom_VNode__V(oldVNode, vNode);
});
var $d_Lsnabbdom_modules_Props$$anon$2 = new $TypeData().initClass($c_Lsnabbdom_modules_Props$$anon$2, "snabbdom.modules.Props$$anon$2", ({
  Lsnabbdom_modules_Props$$anon$2: 1,
  Lsnabbdom_UpdateHook: 1
}));
/** @constructor */
function $c_Lsnabbdom_modules_Styles$$anon$1() {
}
$c_Lsnabbdom_modules_Styles$$anon$1.prototype = new $h_O();
$c_Lsnabbdom_modules_Styles$$anon$1.prototype.constructor = $c_Lsnabbdom_modules_Styles$$anon$1;
/** @constructor */
function $h_Lsnabbdom_modules_Styles$$anon$1() {
}
$h_Lsnabbdom_modules_Styles$$anon$1.prototype = $c_Lsnabbdom_modules_Styles$$anon$1.prototype;
$c_Lsnabbdom_modules_Styles$$anon$1.prototype.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O = (function(emptyVNode, vNode) {
  $m_Lsnabbdom_modules_Styles$().snabbdom$modules$Styles$$$updateStyle__Lsnabbdom_VNode__Lsnabbdom_VNode__V(emptyVNode, vNode);
});
var $d_Lsnabbdom_modules_Styles$$anon$1 = new $TypeData().initClass($c_Lsnabbdom_modules_Styles$$anon$1, "snabbdom.modules.Styles$$anon$1", ({
  Lsnabbdom_modules_Styles$$anon$1: 1,
  Lsnabbdom_CreateHook: 1
}));
/** @constructor */
function $c_Lsnabbdom_modules_Styles$$anon$2() {
}
$c_Lsnabbdom_modules_Styles$$anon$2.prototype = new $h_O();
$c_Lsnabbdom_modules_Styles$$anon$2.prototype.constructor = $c_Lsnabbdom_modules_Styles$$anon$2;
/** @constructor */
function $h_Lsnabbdom_modules_Styles$$anon$2() {
}
$h_Lsnabbdom_modules_Styles$$anon$2.prototype = $c_Lsnabbdom_modules_Styles$$anon$2.prototype;
$c_Lsnabbdom_modules_Styles$$anon$2.prototype.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O = (function(oldVNode, vNode) {
  $m_Lsnabbdom_modules_Styles$().snabbdom$modules$Styles$$$updateStyle__Lsnabbdom_VNode__Lsnabbdom_VNode__V(oldVNode, vNode);
});
var $d_Lsnabbdom_modules_Styles$$anon$2 = new $TypeData().initClass($c_Lsnabbdom_modules_Styles$$anon$2, "snabbdom.modules.Styles$$anon$2", ({
  Lsnabbdom_modules_Styles$$anon$2: 1,
  Lsnabbdom_UpdateHook: 1
}));
function $is_Ltyrian_Html(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_Html)));
}
function $as_Ltyrian_Html(obj) {
  return (($is_Ltyrian_Html(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Html"));
}
function $isArrayOf_Ltyrian_Html(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Html)));
}
function $asArrayOf_Ltyrian_Html(obj, depth) {
  return (($isArrayOf_Ltyrian_Html(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Html;", depth));
}
function $is_Ltyrian_Property(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_Property)));
}
function $as_Ltyrian_Property(obj) {
  return (($is_Ltyrian_Property(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Property"));
}
function $isArrayOf_Ltyrian_Property(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Property)));
}
function $asArrayOf_Ltyrian_Property(obj, depth) {
  return (($isArrayOf_Ltyrian_Property(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Property;", depth));
}
/** @constructor */
function $c_Lcats_Bifunctor$ToBifunctorOps$$anon$5(target$2, tc$2) {
  this.Lcats_Bifunctor$ToBifunctorOps$$anon$5__f_self = null;
  this.Lcats_Bifunctor$ToBifunctorOps$$anon$5__f_typeClassInstance = null;
  this.Lcats_Bifunctor$ToBifunctorOps$$anon$5__f_self = target$2;
  this.Lcats_Bifunctor$ToBifunctorOps$$anon$5__f_typeClassInstance = tc$2;
}
$c_Lcats_Bifunctor$ToBifunctorOps$$anon$5.prototype = new $h_O();
$c_Lcats_Bifunctor$ToBifunctorOps$$anon$5.prototype.constructor = $c_Lcats_Bifunctor$ToBifunctorOps$$anon$5;
/** @constructor */
function $h_Lcats_Bifunctor$ToBifunctorOps$$anon$5() {
}
$h_Lcats_Bifunctor$ToBifunctorOps$$anon$5.prototype = $c_Lcats_Bifunctor$ToBifunctorOps$$anon$5.prototype;
var $d_Lcats_Bifunctor$ToBifunctorOps$$anon$5 = new $TypeData().initClass($c_Lcats_Bifunctor$ToBifunctorOps$$anon$5, "cats.Bifunctor$ToBifunctorOps$$anon$5", ({
  Lcats_Bifunctor$ToBifunctorOps$$anon$5: 1,
  Ljava_io_Serializable: 1,
  Lcats_Bifunctor$Ops: 1
}));
function $f_Lcats_ComposedInvariant__imap__O__F1__F1__O($thiz, fga, f, g) {
  return $n($thiz.Lcats_Functor$$anon$1__f_F).imap__O__F1__F1__O(fga, new $c_sjsr_AnonFunction1(((ga) => $n($thiz.Lcats_Functor$$anon$1__f_G).imap__O__F1__F1__O(ga, f, g))), new $c_sjsr_AnonFunction1(((gb) => $n($thiz.Lcats_Functor$$anon$1__f_G).imap__O__F1__F1__O(gb, g, f))));
}
function $ct_Lcats_Eval$Defer__F0__($thiz, thunk) {
  $thiz.Lcats_Eval$Defer__f_thunk = thunk;
  return $thiz;
}
/** @constructor */
function $c_Lcats_Eval$Defer() {
  this.Lcats_Eval$Defer__f_thunk = null;
}
$c_Lcats_Eval$Defer.prototype = new $h_Lcats_Eval();
$c_Lcats_Eval$Defer.prototype.constructor = $c_Lcats_Eval$Defer;
/** @constructor */
function $h_Lcats_Eval$Defer() {
}
$h_Lcats_Eval$Defer.prototype = $c_Lcats_Eval$Defer.prototype;
$c_Lcats_Eval$Defer.prototype.memoize__Lcats_Eval = (function() {
  return new $c_Lcats_Eval$Memoize(this);
});
$c_Lcats_Eval$Defer.prototype.value__O = (function() {
  return $m_Lcats_Eval$().cats$Eval$$$evaluate__Lcats_Eval__O(this);
});
function $as_Lcats_Eval$Defer(obj) {
  return (((obj instanceof $c_Lcats_Eval$Defer) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval$Defer"));
}
function $isArrayOf_Lcats_Eval$Defer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$Defer)));
}
function $asArrayOf_Lcats_Eval$Defer(obj, depth) {
  return (($isArrayOf_Lcats_Eval$Defer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval$Defer;", depth));
}
/** @constructor */
function $c_Lcats_Eval$FlatMap() {
}
$c_Lcats_Eval$FlatMap.prototype = new $h_Lcats_Eval();
$c_Lcats_Eval$FlatMap.prototype.constructor = $c_Lcats_Eval$FlatMap;
/** @constructor */
function $h_Lcats_Eval$FlatMap() {
}
$h_Lcats_Eval$FlatMap.prototype = $c_Lcats_Eval$FlatMap.prototype;
$c_Lcats_Eval$FlatMap.prototype.memoize__Lcats_Eval = (function() {
  return new $c_Lcats_Eval$Memoize(this);
});
$c_Lcats_Eval$FlatMap.prototype.value__O = (function() {
  return $m_Lcats_Eval$().cats$Eval$$$evaluate__Lcats_Eval__O(this);
});
function $as_Lcats_Eval$FlatMap(obj) {
  return (((obj instanceof $c_Lcats_Eval$FlatMap) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval$FlatMap"));
}
function $isArrayOf_Lcats_Eval$FlatMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$FlatMap)));
}
function $asArrayOf_Lcats_Eval$FlatMap(obj, depth) {
  return (($isArrayOf_Lcats_Eval$FlatMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval$FlatMap;", depth));
}
/** @constructor */
function $c_Lcats_Eval$Leaf() {
}
$c_Lcats_Eval$Leaf.prototype = new $h_Lcats_Eval();
$c_Lcats_Eval$Leaf.prototype.constructor = $c_Lcats_Eval$Leaf;
/** @constructor */
function $h_Lcats_Eval$Leaf() {
}
$h_Lcats_Eval$Leaf.prototype = $c_Lcats_Eval$Leaf.prototype;
function $as_Lcats_Eval$Leaf(obj) {
  return (((obj instanceof $c_Lcats_Eval$Leaf) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval$Leaf"));
}
function $isArrayOf_Lcats_Eval$Leaf(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$Leaf)));
}
function $asArrayOf_Lcats_Eval$Leaf(obj, depth) {
  return (($isArrayOf_Lcats_Eval$Leaf(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval$Leaf;", depth));
}
function $ct_Lcats_EvalInstances__($thiz) {
  $thiz.Lcats_EvalInstances__f_catsBimonadForEval = new $c_Lcats_EvalInstances$$anon$6();
  new $c_Lcats_EvalInstances$$anon$9($thiz);
  return $thiz;
}
/** @constructor */
function $c_Lcats_EvalInstances() {
  this.Lcats_EvalInstances__f_catsBimonadForEval = null;
}
$c_Lcats_EvalInstances.prototype = new $h_Lcats_EvalInstances0();
$c_Lcats_EvalInstances.prototype.constructor = $c_Lcats_EvalInstances;
/** @constructor */
function $h_Lcats_EvalInstances() {
}
$h_Lcats_EvalInstances.prototype = $c_Lcats_EvalInstances.prototype;
/** @constructor */
function $c_Lcats_EvalInstances$$anon$9(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $n(outer);
}
$c_Lcats_EvalInstances$$anon$9.prototype = new $h_O();
$c_Lcats_EvalInstances$$anon$9.prototype.constructor = $c_Lcats_EvalInstances$$anon$9;
/** @constructor */
function $h_Lcats_EvalInstances$$anon$9() {
}
$h_Lcats_EvalInstances$$anon$9.prototype = $c_Lcats_EvalInstances$$anon$9.prototype;
var $d_Lcats_EvalInstances$$anon$9 = new $TypeData().initClass($c_Lcats_EvalInstances$$anon$9, "cats.EvalInstances$$anon$9", ({
  Lcats_EvalInstances$$anon$9: 1,
  Ljava_io_Serializable: 1,
  Lcats_Representable: 1
}));
/** @constructor */
function $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, tc$2) {
  this.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self = null;
  this.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance = null;
  this.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self = target$2;
  this.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance = tc$2;
}
$c_Lcats_FlatMap$ToFlatMapOps$$anon$2.prototype = new $h_O();
$c_Lcats_FlatMap$ToFlatMapOps$$anon$2.prototype.constructor = $c_Lcats_FlatMap$ToFlatMapOps$$anon$2;
/** @constructor */
function $h_Lcats_FlatMap$ToFlatMapOps$$anon$2() {
}
$h_Lcats_FlatMap$ToFlatMapOps$$anon$2.prototype = $c_Lcats_FlatMap$ToFlatMapOps$$anon$2.prototype;
var $d_Lcats_FlatMap$ToFlatMapOps$$anon$2 = new $TypeData().initClass($c_Lcats_FlatMap$ToFlatMapOps$$anon$2, "cats.FlatMap$ToFlatMapOps$$anon$2", ({
  Lcats_FlatMap$ToFlatMapOps$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_FlatMap$Ops: 1
}));
/** @constructor */
function $c_Lcats_Foldable$ToFoldableOps$$anon$6(target$2, tc$2) {
  this.Lcats_Foldable$ToFoldableOps$$anon$6__f_self = null;
  this.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance = null;
  this.Lcats_Foldable$ToFoldableOps$$anon$6__f_self = target$2;
  this.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance = tc$2;
}
$c_Lcats_Foldable$ToFoldableOps$$anon$6.prototype = new $h_O();
$c_Lcats_Foldable$ToFoldableOps$$anon$6.prototype.constructor = $c_Lcats_Foldable$ToFoldableOps$$anon$6;
/** @constructor */
function $h_Lcats_Foldable$ToFoldableOps$$anon$6() {
}
$h_Lcats_Foldable$ToFoldableOps$$anon$6.prototype = $c_Lcats_Foldable$ToFoldableOps$$anon$6.prototype;
var $d_Lcats_Foldable$ToFoldableOps$$anon$6 = new $TypeData().initClass($c_Lcats_Foldable$ToFoldableOps$$anon$6, "cats.Foldable$ToFoldableOps$$anon$6", ({
  Lcats_Foldable$ToFoldableOps$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_Foldable$Ops: 1
}));
function $f_Lcats_Functor__as__O__O__O($thiz, fa, b) {
  return $thiz.map__O__F1__O(fa, new $c_sjsr_AnonFunction1(((_$3) => b)));
}
function $f_Lcats_Functor__tupleLeft__O__O__O($thiz, fa, b) {
  return $thiz.map__O__F1__O(fa, new $c_sjsr_AnonFunction1(((a) => new $c_T2(b, a))));
}
function $is_Lcats_Functor(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_Functor)));
}
function $as_Lcats_Functor(obj) {
  return (($is_Lcats_Functor(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Functor"));
}
function $isArrayOf_Lcats_Functor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Functor)));
}
function $asArrayOf_Lcats_Functor(obj, depth) {
  return (($isArrayOf_Lcats_Functor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Functor;", depth));
}
/** @constructor */
function $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, tc$2) {
  this.Lcats_Functor$ToFunctorOps$$anon$5__f_self = null;
  this.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance = null;
  this.Lcats_Functor$ToFunctorOps$$anon$5__f_self = target$2;
  this.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance = tc$2;
}
$c_Lcats_Functor$ToFunctorOps$$anon$5.prototype = new $h_O();
$c_Lcats_Functor$ToFunctorOps$$anon$5.prototype.constructor = $c_Lcats_Functor$ToFunctorOps$$anon$5;
/** @constructor */
function $h_Lcats_Functor$ToFunctorOps$$anon$5() {
}
$h_Lcats_Functor$ToFunctorOps$$anon$5.prototype = $c_Lcats_Functor$ToFunctorOps$$anon$5.prototype;
var $d_Lcats_Functor$ToFunctorOps$$anon$5 = new $TypeData().initClass($c_Lcats_Functor$ToFunctorOps$$anon$5, "cats.Functor$ToFunctorOps$$anon$5", ({
  Lcats_Functor$ToFunctorOps$$anon$5: 1,
  Ljava_io_Serializable: 1,
  Lcats_Functor$Ops: 1
}));
/** @constructor */
function $c_Lcats_Parallel$() {
}
$c_Lcats_Parallel$.prototype = new $h_Lcats_ParallelArityFunctions2();
$c_Lcats_Parallel$.prototype.constructor = $c_Lcats_Parallel$;
/** @constructor */
function $h_Lcats_Parallel$() {
}
$h_Lcats_Parallel$.prototype = $c_Lcats_Parallel$.prototype;
$c_Lcats_Parallel$.prototype.parSequence__O__Lcats_Traverse__Lcats_Parallel__O = (function(tma, evidence$1, P) {
  var fta = $n(evidence$1).traverse__O__F1__Lcats_Applicative__O(tma, new $c_sjsr_AnonFunction1(((_$27) => $n($n(P).parallel__Lcats_arrow_FunctionK()).apply__O__O(_$27))), $n(P).applicative__Lcats_Applicative());
  return $n($n(P).sequential__Lcats_arrow_FunctionK()).apply__O__O(fta);
});
$c_Lcats_Parallel$.prototype.parUnorderedTraverse__O__F1__Lcats_UnorderedTraverse__Lcats_CommutativeApplicative__Lcats_Parallel__O = (function(ta, f, evidence$1, evidence$2, P) {
  return $n($n(P).sequential__Lcats_arrow_FunctionK()).apply__O__O($n(evidence$1).unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O(ta, new $c_sjsr_AnonFunction1(((a) => $n($n(P).parallel__Lcats_arrow_FunctionK()).apply__O__O($n(f).apply__O__O(a)))), evidence$2));
});
var $d_Lcats_Parallel$ = new $TypeData().initClass($c_Lcats_Parallel$, "cats.Parallel$", ({
  Lcats_Parallel$: 1,
  Lcats_ParallelArityFunctions2: 1,
  Lcats_ParallelArityFunctions: 1
}));
var $n_Lcats_Parallel$;
function $m_Lcats_Parallel$() {
  if ((!$n_Lcats_Parallel$)) {
    $n_Lcats_Parallel$ = new $c_Lcats_Parallel$();
  }
  return $n_Lcats_Parallel$;
}
/** @constructor */
function $c_Lcats_Semigroupal$() {
  $n_Lcats_Semigroupal$ = this;
  $m_Lcats_instances_package$order$();
  $m_Lcats_instances_package$partialOrder$();
  $m_Lcats_instances_package$ordering$();
  $m_Lcats_instances_package$partialOrdering$();
  $m_Lcats_instances_package$eq$();
  $m_Lcats_instances_package$equiv$();
  $m_Lcats_instances_package$invariant$();
  $m_Lcats_instances_package$invariant$();
  $m_Lcats_instances_package$invariant$();
}
$c_Lcats_Semigroupal$.prototype = new $h_O();
$c_Lcats_Semigroupal$.prototype.constructor = $c_Lcats_Semigroupal$;
/** @constructor */
function $h_Lcats_Semigroupal$() {
}
$h_Lcats_Semigroupal$.prototype = $c_Lcats_Semigroupal$.prototype;
var $d_Lcats_Semigroupal$ = new $TypeData().initClass($c_Lcats_Semigroupal$, "cats.Semigroupal$", ({
  Lcats_Semigroupal$: 1,
  Lcats_ScalaVersionSpecificSemigroupalInstances: 1,
  Lcats_SemigroupalArityFunctions: 1
}));
var $n_Lcats_Semigroupal$;
function $m_Lcats_Semigroupal$() {
  if ((!$n_Lcats_Semigroupal$)) {
    $n_Lcats_Semigroupal$ = new $c_Lcats_Semigroupal$();
  }
  return $n_Lcats_Semigroupal$;
}
/** @constructor */
function $c_Lcats_Traverse$ToTraverseOps$$anon$3(target$2, tc$2) {
  this.Lcats_Traverse$ToTraverseOps$$anon$3__f_self = null;
  this.Lcats_Traverse$ToTraverseOps$$anon$3__f_typeClassInstance = null;
  this.Lcats_Traverse$ToTraverseOps$$anon$3__f_self = target$2;
  this.Lcats_Traverse$ToTraverseOps$$anon$3__f_typeClassInstance = tc$2;
}
$c_Lcats_Traverse$ToTraverseOps$$anon$3.prototype = new $h_O();
$c_Lcats_Traverse$ToTraverseOps$$anon$3.prototype.constructor = $c_Lcats_Traverse$ToTraverseOps$$anon$3;
/** @constructor */
function $h_Lcats_Traverse$ToTraverseOps$$anon$3() {
}
$h_Lcats_Traverse$ToTraverseOps$$anon$3.prototype = $c_Lcats_Traverse$ToTraverseOps$$anon$3.prototype;
var $d_Lcats_Traverse$ToTraverseOps$$anon$3 = new $TypeData().initClass($c_Lcats_Traverse$ToTraverseOps$$anon$3, "cats.Traverse$ToTraverseOps$$anon$3", ({
  Lcats_Traverse$ToTraverseOps$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_Traverse$Ops: 1
}));
/** @constructor */
function $c_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4(target$2, tc$2) {
  this.Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4__f_self = null;
  this.Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4__f_typeClassInstance = null;
  this.Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4__f_self = target$2;
  this.Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4__f_typeClassInstance = tc$2;
}
$c_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4.prototype = new $h_O();
$c_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4.prototype.constructor = $c_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4;
/** @constructor */
function $h_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4() {
}
$h_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4.prototype = $c_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4.prototype;
var $d_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4 = new $TypeData().initClass($c_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4, "cats.UnorderedFoldable$ToUnorderedFoldableOps$$anon$4", ({
  Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lcats_UnorderedFoldable$Ops: 1
}));
/** @constructor */
function $c_Lcats_arrow_FunctionK$() {
}
$c_Lcats_arrow_FunctionK$.prototype = new $h_Lcats_arrow_FunctionKMacroMethods();
$c_Lcats_arrow_FunctionK$.prototype.constructor = $c_Lcats_arrow_FunctionK$;
/** @constructor */
function $h_Lcats_arrow_FunctionK$() {
}
$h_Lcats_arrow_FunctionK$.prototype = $c_Lcats_arrow_FunctionK$.prototype;
var $d_Lcats_arrow_FunctionK$ = new $TypeData().initClass($c_Lcats_arrow_FunctionK$, "cats.arrow.FunctionK$", ({
  Lcats_arrow_FunctionK$: 1,
  Lcats_arrow_FunctionKMacroMethods: 1,
  Lcats_arrow_FunctionKLift: 1
}));
var $n_Lcats_arrow_FunctionK$;
function $m_Lcats_arrow_FunctionK$() {
  if ((!$n_Lcats_arrow_FunctionK$)) {
    $n_Lcats_arrow_FunctionK$ = new $c_Lcats_arrow_FunctionK$();
  }
  return $n_Lcats_arrow_FunctionK$;
}
/** @constructor */
function $c_Lcats_arrow_FunctionK$$anon$1(f$2, outer) {
  this.Lcats_arrow_FunctionK$$anon$1__f_f$1 = null;
  this.Lcats_arrow_FunctionK$$anon$1__f_$outer = null;
  this.Lcats_arrow_FunctionK$$anon$1__f_f$1 = f$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_arrow_FunctionK$$anon$1__f_$outer = outer;
}
$c_Lcats_arrow_FunctionK$$anon$1.prototype = new $h_O();
$c_Lcats_arrow_FunctionK$$anon$1.prototype.constructor = $c_Lcats_arrow_FunctionK$$anon$1;
/** @constructor */
function $h_Lcats_arrow_FunctionK$$anon$1() {
}
$h_Lcats_arrow_FunctionK$$anon$1.prototype = $c_Lcats_arrow_FunctionK$$anon$1.prototype;
$c_Lcats_arrow_FunctionK$$anon$1.prototype.apply__O__O = (function(fa) {
  return $n(this.Lcats_arrow_FunctionK$$anon$1__f_$outer).apply__O__O($n(this.Lcats_arrow_FunctionK$$anon$1__f_f$1).apply__O__O(fa));
});
var $d_Lcats_arrow_FunctionK$$anon$1 = new $TypeData().initClass($c_Lcats_arrow_FunctionK$$anon$1, "cats.arrow.FunctionK$$anon$1", ({
  Lcats_arrow_FunctionK$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
/** @constructor */
function $c_Lcats_arrow_FunctionK$$anon$4(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_arrow_FunctionK$$anon$4.prototype = new $h_O();
$c_Lcats_arrow_FunctionK$$anon$4.prototype.constructor = $c_Lcats_arrow_FunctionK$$anon$4;
/** @constructor */
function $h_Lcats_arrow_FunctionK$$anon$4() {
}
$h_Lcats_arrow_FunctionK$$anon$4.prototype = $c_Lcats_arrow_FunctionK$$anon$4.prototype;
$c_Lcats_arrow_FunctionK$$anon$4.prototype.apply__O__O = (function(fa) {
  return fa;
});
var $d_Lcats_arrow_FunctionK$$anon$4 = new $TypeData().initClass($c_Lcats_arrow_FunctionK$$anon$4, "cats.arrow.FunctionK$$anon$4", ({
  Lcats_arrow_FunctionK$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
/** @constructor */
function $c_Lcats_data_Chain$$anon$2() {
}
$c_Lcats_data_Chain$$anon$2.prototype = new $h_sr_AbstractFunction1();
$c_Lcats_data_Chain$$anon$2.prototype.constructor = $c_Lcats_data_Chain$$anon$2;
/** @constructor */
function $h_Lcats_data_Chain$$anon$2() {
}
$h_Lcats_data_Chain$$anon$2.prototype = $c_Lcats_data_Chain$$anon$2.prototype;
$c_Lcats_data_Chain$$anon$2.prototype.apply__O__O = (function(a) {
  return this;
});
var $d_Lcats_data_Chain$$anon$2 = new $TypeData().initClass($c_Lcats_data_Chain$$anon$2, "cats.data.Chain$$anon$2", ({
  Lcats_data_Chain$$anon$2: 1,
  sr_AbstractFunction1: 1,
  F1: 1
}));
/** @constructor */
function $c_Lcats_data_Chain$NonEmpty() {
}
$c_Lcats_data_Chain$NonEmpty.prototype = new $h_Lcats_data_Chain();
$c_Lcats_data_Chain$NonEmpty.prototype.constructor = $c_Lcats_data_Chain$NonEmpty;
/** @constructor */
function $h_Lcats_data_Chain$NonEmpty() {
}
$h_Lcats_data_Chain$NonEmpty.prototype = $c_Lcats_data_Chain$NonEmpty.prototype;
function $as_Lcats_data_Chain$NonEmpty(obj) {
  return (((obj instanceof $c_Lcats_data_Chain$NonEmpty) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Chain$NonEmpty"));
}
function $isArrayOf_Lcats_data_Chain$NonEmpty(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Chain$NonEmpty)));
}
function $asArrayOf_Lcats_data_Chain$NonEmpty(obj, depth) {
  return (($isArrayOf_Lcats_data_Chain$NonEmpty(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Chain$NonEmpty;", depth));
}
/** @constructor */
function $c_Lcats_data_ChainInstances1() {
}
$c_Lcats_data_ChainInstances1.prototype = new $h_Lcats_data_ChainInstances2();
$c_Lcats_data_ChainInstances1.prototype.constructor = $c_Lcats_data_ChainInstances1;
/** @constructor */
function $h_Lcats_data_ChainInstances1() {
}
$h_Lcats_data_ChainInstances1.prototype = $c_Lcats_data_ChainInstances1.prototype;
/** @constructor */
function $c_Lcats_data_KleisliFunctions$$anon$3() {
}
$c_Lcats_data_KleisliFunctions$$anon$3.prototype = new $h_O();
$c_Lcats_data_KleisliFunctions$$anon$3.prototype.constructor = $c_Lcats_data_KleisliFunctions$$anon$3;
/** @constructor */
function $h_Lcats_data_KleisliFunctions$$anon$3() {
}
$h_Lcats_data_KleisliFunctions$$anon$3.prototype = $c_Lcats_data_KleisliFunctions$$anon$3.prototype;
$c_Lcats_data_KleisliFunctions$$anon$3.prototype.apply__O__O = (function(fa) {
  var this$1 = $m_Lcats_data_Kleisli$();
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$1, fa);
});
var $d_Lcats_data_KleisliFunctions$$anon$3 = new $TypeData().initClass($c_Lcats_data_KleisliFunctions$$anon$3, "cats.data.KleisliFunctions$$anon$3", ({
  Lcats_data_KleisliFunctions$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
/** @constructor */
function $c_Lcats_data_KleisliInstances7() {
}
$c_Lcats_data_KleisliInstances7.prototype = new $h_Lcats_data_KleisliInstances8();
$c_Lcats_data_KleisliInstances7.prototype.constructor = $c_Lcats_data_KleisliInstances7;
/** @constructor */
function $h_Lcats_data_KleisliInstances7() {
}
$h_Lcats_data_KleisliInstances7.prototype = $c_Lcats_data_KleisliInstances7.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyChainInstances1() {
}
$c_Lcats_data_NonEmptyChainInstances1.prototype = new $h_Lcats_data_NonEmptyChainInstances2();
$c_Lcats_data_NonEmptyChainInstances1.prototype.constructor = $c_Lcats_data_NonEmptyChainInstances1;
/** @constructor */
function $h_Lcats_data_NonEmptyChainInstances1() {
}
$h_Lcats_data_NonEmptyChainInstances1.prototype = $c_Lcats_data_NonEmptyChainInstances1.prototype;
function $ct_Lcats_data_NonEmptyListInstances__($thiz) {
  new $c_Lcats_data_NonEmptyListInstances$$anon$2();
  return $thiz;
}
function $s_Lcats_data_NonEmptyListInstances__cats$data$NonEmptyListInstances$$anon$2$$_$go$2__scm_ListBuffer__F1__Lcats_data_NonEmptyList__V(buf$3, f$9, v) {
  var v$tailLocal1 = v;
  while (true) {
    matchResult19: {
      var x64 = $as_s_util_Either($n(v$tailLocal1).Lcats_data_NonEmptyList__f_head);
      if ((x64 instanceof $c_s_util_Right)) {
        var b = $n($as_s_util_Right(x64)).s_util_Right__f_value;
        var this$1 = $n(buf$3);
        this$1.addOne__O__scm_ListBuffer(b);
        matchResult18: {
          var x61 = $m_Lcats_data_NonEmptyList$().fromList__sci_List__s_Option($n(v$tailLocal1).Lcats_data_NonEmptyList__f_tail);
          if ((x61 instanceof $c_s_Some)) {
            var t = $as_Lcats_data_NonEmptyList($n($as_s_Some(x61)).s_Some__f_value);
            v$tailLocal1 = t;
            continue;
          }
          var x = $m_s_None$();
          if ((x === x61)) {
            break matchResult18;
          }
          throw new $c_s_MatchError(x61);
        }
        break matchResult19;
      }
      if ((x64 instanceof $c_s_util_Left)) {
        var a = $n($as_s_util_Left(x64)).s_util_Left__f_value;
        var this$2 = $n($as_Lcats_data_NonEmptyList($n(f$9).apply__O__O(a)));
        var l = $n(v$tailLocal1).Lcats_data_NonEmptyList__f_tail;
        v$tailLocal1 = this$2.concat__sci_List__Lcats_data_NonEmptyList(l);
        continue;
      }
      throw new $c_s_MatchError(x64);
    }
    return (void 0);
  }
}
/** @constructor */
function $c_Lcats_data_NonEmptyListInstances() {
}
$c_Lcats_data_NonEmptyListInstances.prototype = new $h_Lcats_data_NonEmptyListInstances0();
$c_Lcats_data_NonEmptyListInstances.prototype.constructor = $c_Lcats_data_NonEmptyListInstances;
/** @constructor */
function $h_Lcats_data_NonEmptyListInstances() {
}
$h_Lcats_data_NonEmptyListInstances.prototype = $c_Lcats_data_NonEmptyListInstances.prototype;
function $ct_Lcats_data_NonEmptySetInstances__($thiz) {
  $thiz.Lcats_data_NonEmptySetInstances__f_catsDataInstancesForNonEmptySet = new $c_Lcats_data_NonEmptySetInstances$$anon$1();
  return $thiz;
}
/** @constructor */
function $c_Lcats_data_NonEmptySetInstances() {
  this.Lcats_data_NonEmptySetInstances__f_catsDataInstancesForNonEmptySet = null;
}
$c_Lcats_data_NonEmptySetInstances.prototype = new $h_Lcats_data_NonEmptySetInstances0();
$c_Lcats_data_NonEmptySetInstances.prototype.constructor = $c_Lcats_data_NonEmptySetInstances;
/** @constructor */
function $h_Lcats_data_NonEmptySetInstances() {
}
$h_Lcats_data_NonEmptySetInstances.prototype = $c_Lcats_data_NonEmptySetInstances.prototype;
function $ct_Lcats_data_ValidatedInstances__($thiz) {
  return $thiz;
}
/** @constructor */
function $c_Lcats_data_ValidatedInstances() {
}
$c_Lcats_data_ValidatedInstances.prototype = new $h_Lcats_data_ValidatedInstances1();
$c_Lcats_data_ValidatedInstances.prototype.constructor = $c_Lcats_data_ValidatedInstances;
/** @constructor */
function $h_Lcats_data_ValidatedInstances() {
}
$h_Lcats_data_ValidatedInstances.prototype = $c_Lcats_data_ValidatedInstances.prototype;
/** @constructor */
function $c_Lcats_effect_ContState(wasFinalizing) {
  this.ju_concurrent_atomic_AtomicReference__f_value = null;
  this.Lcats_effect_ContState__f_wasFinalizing = false;
  this.Lcats_effect_ContState__f_waiting = null;
  this.Lcats_effect_ContState__f_handle = null;
  this.Lcats_effect_ContState__f_wasFinalizing = wasFinalizing;
  $ct_ju_concurrent_atomic_AtomicReference__O__(this, null);
  this.Lcats_effect_ContState__f_waiting = $m_Lcats_effect_ContState$().Lcats_effect_ContState$__f_cats$effect$ContState$$$waitingSentinel;
}
$c_Lcats_effect_ContState.prototype = new $h_ju_concurrent_atomic_AtomicReference();
$c_Lcats_effect_ContState.prototype.constructor = $c_Lcats_effect_ContState;
/** @constructor */
function $h_Lcats_effect_ContState() {
}
$h_Lcats_effect_ContState.prototype = $c_Lcats_effect_ContState.prototype;
var $d_Lcats_effect_ContState = new $TypeData().initClass($c_Lcats_effect_ContState, "cats.effect.ContState", ({
  Lcats_effect_ContState: 1,
  ju_concurrent_atomic_AtomicReference: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$$anon$3(k$4) {
  this.Lcats_effect_IO$$anon$3__f_k$1 = null;
  this.Lcats_effect_IO$$anon$3__f_k$1 = k$4;
}
$c_Lcats_effect_IO$$anon$3.prototype = new $h_O();
$c_Lcats_effect_IO$$anon$3.prototype.constructor = $c_Lcats_effect_IO$$anon$3;
/** @constructor */
function $h_Lcats_effect_IO$$anon$3() {
}
$h_Lcats_effect_IO$$anon$3.prototype = $c_Lcats_effect_IO$$anon$3.prototype;
$c_Lcats_effect_IO$$anon$3.prototype.apply__Lcats_effect_kernel_MonadCancel__F3 = (function(G) {
  return new $c_sjsr_AnonFunction3(((resume, get, lift) => {
    var resume$1 = $as_F1(resume);
    var lift$1 = $as_Lcats_arrow_FunctionK(lift);
    return $n(G).uncancelable__F1__O(new $c_sjsr_AnonFunction1(((poll) => {
      var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
      var target = $n(lift$1).apply__O__O($n(this.Lcats_effect_IO$$anon$3__f_k$1).apply__O__O(resume$1));
      var this$3 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, G);
      var f = new $c_sjsr_AnonFunction1(((x$1) => {
        var x$1$1 = $as_s_util_Either(x$1);
        if ((x$1$1 instanceof $c_s_util_Right)) {
          var a = $n($as_s_util_Right(x$1$1)).s_util_Right__f_value;
          return $n(G).pure__O__O(a);
        }
        if ((x$1$1 instanceof $c_s_util_Left)) {
          var x27 = $as_s_Option($n($as_s_util_Left(x$1$1)).s_util_Left__f_value);
          if ((x27 instanceof $c_s_Some)) {
            var fin = $as_Lcats_effect_IO($n($as_s_Some(x27)).s_Some__f_value);
            return $n(G).onCancel__O__O__O($n(poll$1).apply__O__O(get), $n(lift$1).apply__O__O(fin));
          }
          var x = $m_s_None$();
          if ((x === x27)) {
            return get;
          }
        }
        throw new $c_s_MatchError(x$1$1);
      }));
      return $n(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
    })));
  }));
});
var $d_Lcats_effect_IO$$anon$3 = new $TypeData().initClass($c_Lcats_effect_IO$$anon$3, "cats.effect.IO$$anon$3", ({
  Lcats_effect_IO$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Cont: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$$anon$4(k$5) {
  this.Lcats_effect_IO$$anon$4__f_k$2 = null;
  this.Lcats_effect_IO$$anon$4__f_k$2 = k$5;
}
$c_Lcats_effect_IO$$anon$4.prototype = new $h_O();
$c_Lcats_effect_IO$$anon$4.prototype.constructor = $c_Lcats_effect_IO$$anon$4;
/** @constructor */
function $h_Lcats_effect_IO$$anon$4() {
}
$h_Lcats_effect_IO$$anon$4.prototype = $c_Lcats_effect_IO$$anon$4.prototype;
$c_Lcats_effect_IO$$anon$4.prototype.apply__Lcats_effect_kernel_MonadCancel__F3 = (function(G) {
  return new $c_sjsr_AnonFunction3(((resume, get, lift) => {
    var resume$1 = $as_F1(resume);
    var lift$1 = $as_Lcats_arrow_FunctionK(lift);
    return $n(G).uncancelable__F1__O(new $c_sjsr_AnonFunction1(((poll) => {
      var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
      var target = $n(lift$1).apply__O__O($n(this.Lcats_effect_IO$$anon$4__f_k$2).apply__O__O(resume$1));
      var this$3 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, G);
      var f = new $c_sjsr_AnonFunction1(((x$1) => {
        var x$1$1 = $as_s_Option(x$1);
        if ((x$1$1 instanceof $c_s_Some)) {
          var fin = $as_Lcats_effect_IO($n($as_s_Some(x$1$1)).s_Some__f_value);
          return $n(G).onCancel__O__O__O($n(poll$1).apply__O__O(get), $n(lift$1).apply__O__O(fin));
        }
        var x = $m_s_None$();
        if ((x === x$1$1)) {
          return get;
        }
        throw new $c_s_MatchError(x$1$1);
      }));
      return $n(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
    })));
  }));
});
var $d_Lcats_effect_IO$$anon$4 = new $TypeData().initClass($c_Lcats_effect_IO$$anon$4, "cats.effect.IO$$anon$4", ({
  Lcats_effect_IO$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Cont: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$$anon$5(k$6) {
  this.Lcats_effect_IO$$anon$5__f_k$3 = null;
  this.Lcats_effect_IO$$anon$5__f_k$3 = k$6;
}
$c_Lcats_effect_IO$$anon$5.prototype = new $h_O();
$c_Lcats_effect_IO$$anon$5.prototype.constructor = $c_Lcats_effect_IO$$anon$5;
/** @constructor */
function $h_Lcats_effect_IO$$anon$5() {
}
$h_Lcats_effect_IO$$anon$5.prototype = $c_Lcats_effect_IO$$anon$5.prototype;
$c_Lcats_effect_IO$$anon$5.prototype.apply__Lcats_effect_kernel_MonadCancel__F3 = (function(G) {
  return new $c_sjsr_AnonFunction3(((resume, get, lift) => {
    var resume$1 = $as_F1(resume);
    var lift$1 = $as_Lcats_arrow_FunctionK(lift);
    return $n(G).uncancelable__F1__O(new $c_sjsr_AnonFunction1(((_$32) => {
      $as_Lcats_effect_kernel_Poll(_$32);
      var target = $n(lift$1).apply__O__O($m_Lcats_effect_IO$().delay__F0__Lcats_effect_IO(new $c_sjsr_AnonFunction0((() => {
        $n(this.Lcats_effect_IO$$anon$5__f_k$3).apply__O__O(resume$1);
      }))));
      var this$3 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, G);
      var f = new $c_sjsr_AnonFunction1(((_$33) => {
        $as_jl_Void(_$33);
        return get;
      }));
      return $n(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
    })));
  }));
});
var $d_Lcats_effect_IO$$anon$5 = new $TypeData().initClass($c_Lcats_effect_IO$$anon$5, "cats.effect.IO$$anon$5", ({
  Lcats_effect_IO$$anon$5: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Cont: 1
}));
/** @constructor */
function $c_Lcats_effect_IOFiberPlatform() {
  this.ju_concurrent_atomic_AtomicBoolean__f_value = false;
}
$c_Lcats_effect_IOFiberPlatform.prototype = new $h_ju_concurrent_atomic_AtomicBoolean();
$c_Lcats_effect_IOFiberPlatform.prototype.constructor = $c_Lcats_effect_IOFiberPlatform;
/** @constructor */
function $h_Lcats_effect_IOFiberPlatform() {
}
$h_Lcats_effect_IOFiberPlatform.prototype = $c_Lcats_effect_IOFiberPlatform.prototype;
$c_Lcats_effect_IOFiberPlatform.prototype.interruptibleImpl__Lcats_effect_IO$Blocking__Lcats_effect_IO = (function(cur) {
  var this$1 = $m_Lcats_effect_IO$();
  var thunk = new $c_sjsr_AnonFunction0((() => $n($n(cur).thunk__F0()).apply__O()));
  return this$1.delay__F0__Lcats_effect_IO(thunk);
});
/** @constructor */
function $c_Lcats_effect_kernel_Async$$anon$1(k$5) {
  this.Lcats_effect_kernel_Async$$anon$1__f_k$1 = null;
  this.Lcats_effect_kernel_Async$$anon$1__f_k$1 = k$5;
}
$c_Lcats_effect_kernel_Async$$anon$1.prototype = new $h_O();
$c_Lcats_effect_kernel_Async$$anon$1.prototype.constructor = $c_Lcats_effect_kernel_Async$$anon$1;
/** @constructor */
function $h_Lcats_effect_kernel_Async$$anon$1() {
}
$h_Lcats_effect_kernel_Async$$anon$1.prototype = $c_Lcats_effect_kernel_Async$$anon$1.prototype;
$c_Lcats_effect_kernel_Async$$anon$1.prototype.apply__Lcats_effect_kernel_MonadCancel__F3 = (function(G) {
  return new $c_sjsr_AnonFunction3(((resume, get, lift) => {
    var resume$1 = $as_F1(resume);
    var lift$1 = $as_Lcats_arrow_FunctionK(lift);
    return $n(G).uncancelable__F1__O(new $c_sjsr_AnonFunction1(((poll) => {
      var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
      $m_Lcats_implicits$();
      var target = $n(lift$1).apply__O__O($n(this.Lcats_effect_kernel_Async$$anon$1__f_k$1).apply__O__O(resume$1));
      var this$3 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, G);
      var f = new $c_sjsr_AnonFunction1(((x$1) => {
        var x$1$1 = $as_s_util_Either(x$1);
        if ((x$1$1 instanceof $c_s_util_Right)) {
          var a = $n($as_s_util_Right(x$1$1)).s_util_Right__f_value;
          return $n(G).pure__O__O(a);
        }
        if ((x$1$1 instanceof $c_s_util_Left)) {
          var x5 = $as_s_Option($n($as_s_util_Left(x$1$1)).s_util_Left__f_value);
          if ((x5 instanceof $c_s_Some)) {
            var fin = $n($as_s_Some(x5)).s_Some__f_value;
            return $n(G).onCancel__O__O__O($n(poll$1).apply__O__O(get), $n(lift$1).apply__O__O(fin));
          }
          var x = $m_s_None$();
          if ((x === x5)) {
            return get;
          }
        }
        throw new $c_s_MatchError(x$1$1);
      }));
      return $n(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
    })));
  }));
});
var $d_Lcats_effect_kernel_Async$$anon$1 = new $TypeData().initClass($c_Lcats_effect_kernel_Async$$anon$1, "cats.effect.kernel.Async$$anon$1", ({
  Lcats_effect_kernel_Async$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Cont: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Async$$anon$18(nat$10) {
  this.Lcats_effect_kernel_Async$$anon$18__f_nat$5 = null;
  this.Lcats_effect_kernel_Async$$anon$18__f_nat$5 = nat$10;
}
$c_Lcats_effect_kernel_Async$$anon$18.prototype = new $h_O();
$c_Lcats_effect_kernel_Async$$anon$18.prototype.constructor = $c_Lcats_effect_kernel_Async$$anon$18;
/** @constructor */
function $h_Lcats_effect_kernel_Async$$anon$18() {
}
$h_Lcats_effect_kernel_Async$$anon$18.prototype = $c_Lcats_effect_kernel_Async$$anon$18.prototype;
$c_Lcats_effect_kernel_Async$$anon$18.prototype.apply__Lcats_data_Kleisli__Lcats_data_Kleisli = (function(fa) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((r) => $n(this.Lcats_effect_kernel_Async$$anon$18__f_nat$5).apply__O__O($n($n(fa).Lcats_data_Kleisli__f_run).apply__O__O(r))));
  return new $c_Lcats_data_Kleisli(run);
});
$c_Lcats_effect_kernel_Async$$anon$18.prototype.apply__O__O = (function(fa) {
  return this.apply__Lcats_data_Kleisli__Lcats_data_Kleisli($as_Lcats_data_Kleisli(fa));
});
var $d_Lcats_effect_kernel_Async$$anon$18 = new $TypeData().initClass($c_Lcats_effect_kernel_Async$$anon$18, "cats.effect.kernel.Async$$anon$18", ({
  Lcats_effect_kernel_Async$$anon$18: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Async$KleisliAsync$$anon$17(body$12, r$2) {
  this.Lcats_effect_kernel_Async$KleisliAsync$$anon$17__f_body$7 = null;
  this.Lcats_effect_kernel_Async$KleisliAsync$$anon$17__f_r$1 = null;
  this.Lcats_effect_kernel_Async$KleisliAsync$$anon$17__f_body$7 = body$12;
  this.Lcats_effect_kernel_Async$KleisliAsync$$anon$17__f_r$1 = r$2;
}
$c_Lcats_effect_kernel_Async$KleisliAsync$$anon$17.prototype = new $h_O();
$c_Lcats_effect_kernel_Async$KleisliAsync$$anon$17.prototype.constructor = $c_Lcats_effect_kernel_Async$KleisliAsync$$anon$17;
/** @constructor */
function $h_Lcats_effect_kernel_Async$KleisliAsync$$anon$17() {
}
$h_Lcats_effect_kernel_Async$KleisliAsync$$anon$17.prototype = $c_Lcats_effect_kernel_Async$KleisliAsync$$anon$17.prototype;
$c_Lcats_effect_kernel_Async$KleisliAsync$$anon$17.prototype.apply__Lcats_effect_kernel_MonadCancel__F3 = (function(G) {
  return new $c_sjsr_AnonFunction3(((cb, ga, nat) => {
    var cb$1 = $as_F1(cb);
    var nat$1 = $as_Lcats_arrow_FunctionK(nat);
    var natT = new $c_Lcats_effect_kernel_Async$$anon$18(nat$1);
    var $x_1 = $n(this.Lcats_effect_kernel_Async$KleisliAsync$$anon$17__f_body$7).apply__Lcats_effect_kernel_MonadCancel__F3($m_Lcats_effect_kernel_MonadCancel$().monadCancelForKleisli__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_MonadCancel(G));
    var this$2 = $m_Lcats_data_Kleisli$();
    return $n($n($as_Lcats_data_Kleisli($n($x_1).apply__O__O__O__O(cb$1, $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$2, ga), natT))).Lcats_data_Kleisli__f_run).apply__O__O(this.Lcats_effect_kernel_Async$KleisliAsync$$anon$17__f_r$1);
  }));
});
var $d_Lcats_effect_kernel_Async$KleisliAsync$$anon$17 = new $TypeData().initClass($c_Lcats_effect_kernel_Async$KleisliAsync$$anon$17, "cats.effect.kernel.Async$KleisliAsync$$anon$17", ({
  Lcats_effect_kernel_Async$KleisliAsync$$anon$17: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Cont: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10(fib$9, outer) {
  this.Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10__f_fib$4 = null;
  this.Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10__f_$outer = null;
  this.Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10__f_fib$4 = fib$9;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10__f_$outer = outer;
}
$c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10.prototype = new $h_O();
$c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10.prototype.constructor = $c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10;
/** @constructor */
function $h_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10() {
}
$h_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10.prototype = $c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10.prototype;
$c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10.prototype.cancel__Lcats_data_Kleisli = (function() {
  var this$1 = $m_Lcats_data_Kleisli$();
  var x = $n(this.Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10__f_fib$4).cancel__O();
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$1, x);
});
$c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10.prototype.join__Lcats_data_Kleisli = (function() {
  var this$5 = $m_Lcats_data_Kleisli$();
  var target = $n(this.Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10__f_fib$4).join__O();
  var tc = $n(this.Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10__f_$outer).F__Lcats_effect_kernel_GenSpawn();
  var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
  var f = new $c_sjsr_AnonFunction1(((oc) => {
    var oc$1 = $as_Lcats_effect_kernel_Outcome(oc);
    var this$3 = $n(this.Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10__f_$outer);
    return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__cats$effect$kernel$GenSpawn$KleisliGenSpawn$$liftOutcome__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Outcome(this$3, oc$1);
  }));
  var x = $n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$5, x);
});
$c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10.prototype.cancel__O = (function() {
  return this.cancel__Lcats_data_Kleisli();
});
$c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10.prototype.join__O = (function() {
  return this.join__Lcats_data_Kleisli();
});
var $d_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10 = new $TypeData().initClass($c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10, "cats.effect.kernel.GenSpawn$KleisliGenSpawn$$anon$10", ({
  Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Fiber: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$9() {
}
$c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$9.prototype = new $h_O();
$c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$9.prototype.constructor = $c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$9;
/** @constructor */
function $h_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$9() {
}
$h_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$9.prototype = $c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$9.prototype;
$c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$9.prototype.apply__O__O = (function(fa) {
  var this$1 = $m_Lcats_data_Kleisli$();
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$1, fa);
});
var $d_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$9 = new $TypeData().initClass($c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$9, "cats.effect.kernel.GenSpawn$KleisliGenSpawn$$anon$9", ({
  Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$9: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Par$$anon$1() {
}
$c_Lcats_effect_kernel_Par$$anon$1.prototype = new $h_Lcats_effect_kernel_Par$ParallelFImpl();
$c_Lcats_effect_kernel_Par$$anon$1.prototype.constructor = $c_Lcats_effect_kernel_Par$$anon$1;
/** @constructor */
function $h_Lcats_effect_kernel_Par$$anon$1() {
}
$h_Lcats_effect_kernel_Par$$anon$1.prototype = $c_Lcats_effect_kernel_Par$$anon$1.prototype;
var $d_Lcats_effect_kernel_Par$$anon$1 = new $TypeData().initClass($c_Lcats_effect_kernel_Par$$anon$1, "cats.effect.kernel.Par$$anon$1", ({
  Lcats_effect_kernel_Par$$anon$1: 1,
  Lcats_effect_kernel_Par$ParallelFImpl: 1,
  Ljava_io_Serializable: 1
}));
function $is_Lcats_effect_kernel_Poll(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_kernel_Poll)));
}
function $as_Lcats_effect_kernel_Poll(obj) {
  return (($is_Lcats_effect_kernel_Poll(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Poll"));
}
function $isArrayOf_Lcats_effect_kernel_Poll(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Poll)));
}
function $asArrayOf_Lcats_effect_kernel_Poll(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Poll(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Poll;", depth));
}
/** @constructor */
function $c_Lcats_effect_kernel_Resource$$anon$4(F$96, state$5, outer$2) {
  this.Lcats_effect_kernel_Resource$$anon$4__f_F$60 = null;
  this.Lcats_effect_kernel_Resource$$anon$4__f_state$4 = null;
  this.Lcats_effect_kernel_Resource$$anon$4__f_outer$1 = null;
  this.Lcats_effect_kernel_Resource$$anon$4__f_F$60 = F$96;
  this.Lcats_effect_kernel_Resource$$anon$4__f_state$4 = state$5;
  this.Lcats_effect_kernel_Resource$$anon$4__f_outer$1 = outer$2;
}
$c_Lcats_effect_kernel_Resource$$anon$4.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$$anon$4.prototype.constructor = $c_Lcats_effect_kernel_Resource$$anon$4;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$$anon$4() {
}
$h_Lcats_effect_kernel_Resource$$anon$4.prototype = $c_Lcats_effect_kernel_Resource$$anon$4.prototype;
$c_Lcats_effect_kernel_Resource$$anon$4.prototype.cancel__Lcats_effect_kernel_Resource = (function() {
  var fa$2 = $n(this.Lcats_effect_kernel_Resource$$anon$4__f_F$60).uncancelable__F1__O(new $c_sjsr_AnonFunction1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var fa = $n(poll$1).apply__O__O($n(this.Lcats_effect_kernel_Resource$$anon$4__f_outer$1).cancel__O());
    var F = this.Lcats_effect_kernel_Resource$$anon$4__f_F$60;
    var this$5 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa, F);
    var fb = $n(this.Lcats_effect_kernel_Resource$$anon$4__f_state$4).update__F1__O(new $c_sjsr_AnonFunction1(((_$38) => {
      var _$38$1 = $as_Lcats_effect_kernel_Resource$State$1(_$38);
      var $x_2 = $n(_$38$1);
      var this$3 = $n(_$38$1);
      var $x_1 = this$3.Lcats_effect_kernel_Resource$State$1__f_fin;
      var this$4 = $n(_$38$1);
      return $n($x_2).copy__O__Z__Z__Lcats_effect_kernel_Resource$State$1($x_1, true, this$4.Lcats_effect_kernel_Resource$State$1__f_confirmedFinalizeOnComplete);
    })));
    var this$6 = $n(this$5.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
    var fa$1 = this$5.Lcats_syntax_ApplySyntax$$anon$1__f_self;
    return this$6.productR__O__O__O(fa$1, fb);
  })));
  return new $c_Lcats_effect_kernel_Resource$Eval(fa$2);
});
$c_Lcats_effect_kernel_Resource$$anon$4.prototype.join__Lcats_effect_kernel_Resource = (function() {
  var target = $n(this.Lcats_effect_kernel_Resource$$anon$4__f_outer$1).join__O();
  var tc = this.Lcats_effect_kernel_Resource$$anon$4__f_F$60;
  var this$23 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f$1 = new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Lcats_effect_kernel_Outcome(x$1);
    if (((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$1), true))) {
      var a = new $c_Lcats_effect_kernel_Outcome$Canceled();
      var F = this.Lcats_effect_kernel_Resource$$anon$4__f_F$60;
      return $n(F).pure__O__O(a);
    }
    if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
      var x$1$2 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$1);
      var this$8 = $n(x$1$2);
      var x171 = $as_jl_Throwable(this$8.Lcats_effect_kernel_Outcome$Errored__f_e);
      var a$1 = new $c_Lcats_effect_kernel_Outcome$Errored(x171);
      var F$1 = this.Lcats_effect_kernel_Resource$$anon$4__f_F$60;
      return $n(F$1).pure__O__O(a$1);
    }
    if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
      var x$1$3 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$1);
      var this$14 = $n(x$1$3);
      var x168 = this$14.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
      var target$1 = $n(this.Lcats_effect_kernel_Resource$$anon$4__f_state$4).get__O();
      var tc$1 = this.Lcats_effect_kernel_Resource$$anon$4__f_F$60;
      var this$22 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, tc$1);
      var f = new $c_sjsr_AnonFunction1(((s) => {
        var s$1 = $as_Lcats_effect_kernel_Resource$State$1(s);
        if ($n(s$1).Lcats_effect_kernel_Resource$State$1__f_confirmedFinalizeOnComplete) {
          return new $c_Lcats_effect_kernel_Outcome$Canceled();
        } else {
          var fa = new $c_Lcats_effect_kernel_Resource$Eval(x168);
          return new $c_Lcats_effect_kernel_Outcome$Succeeded(fa);
        }
      }));
      return $n(this$22.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$22.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  var fa$1 = $n(this$23.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$23.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
  return new $c_Lcats_effect_kernel_Resource$Eval(fa$1);
});
$c_Lcats_effect_kernel_Resource$$anon$4.prototype.cancel__O = (function() {
  return this.cancel__Lcats_effect_kernel_Resource();
});
$c_Lcats_effect_kernel_Resource$$anon$4.prototype.join__O = (function() {
  return this.join__Lcats_effect_kernel_Resource();
});
var $d_Lcats_effect_kernel_Resource$$anon$4 = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$$anon$4, "cats.effect.kernel.Resource$$anon$4", ({
  Lcats_effect_kernel_Resource$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Fiber: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$$anon$5() {
}
$c_Lcats_effect_kernel_Resource$$anon$5.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$$anon$5.prototype.constructor = $c_Lcats_effect_kernel_Resource$$anon$5;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$$anon$5() {
}
$h_Lcats_effect_kernel_Resource$$anon$5.prototype = $c_Lcats_effect_kernel_Resource$$anon$5.prototype;
$c_Lcats_effect_kernel_Resource$$anon$5.prototype.apply__O__O = (function(fa) {
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
});
var $d_Lcats_effect_kernel_Resource$$anon$5 = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$$anon$5, "cats.effect.kernel.Resource$$anon$5", ({
  Lcats_effect_kernel_Resource$$anon$5: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$$anon$7(body$4, F$98) {
  this.Lcats_effect_kernel_Resource$$anon$7__f_body$3 = null;
  this.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$85 = null;
  this.Lcats_effect_kernel_Resource$$anon$7__f_body$3 = body$4;
  this.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$85 = F$98;
}
$c_Lcats_effect_kernel_Resource$$anon$7.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$$anon$7.prototype.constructor = $c_Lcats_effect_kernel_Resource$$anon$7;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$$anon$7() {
}
$h_Lcats_effect_kernel_Resource$$anon$7.prototype = $c_Lcats_effect_kernel_Resource$$anon$7.prototype;
$c_Lcats_effect_kernel_Resource$$anon$7.prototype.apply__Lcats_effect_kernel_MonadCancel__F3 = (function(G) {
  return new $c_sjsr_AnonFunction3(((cb, ga, nt) => {
    var cb$1 = $as_F1(cb);
    var nt$1 = $as_Lcats_arrow_FunctionK(nt);
    var nt2 = new $c_Lcats_effect_kernel_Resource$$anon$7$$anon$8(G, nt$1, this);
    var $x_1 = $n(nt$1);
    var target = $n(this.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$85).ref__O__O(new $c_sjsr_AnonFunction1(((_$94) => {
      $as_Lcats_effect_kernel_Resource$ExitCase(_$94);
      var this$2 = $n(this.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$85);
      return this$2.pure__O__O((void 0));
    })));
    var tc = this.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$85;
    var this$5 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
    var f = new $c_sjsr_AnonFunction1(((_$95) => {
      var _$95$1 = $as_Lcats_effect_kernel_Ref(_$95);
      var this$4 = $n(_$95$1);
      var F = this.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$85;
      return new $c_Lcats_effect_kernel_Ref$TransformedRef(this$4, nt$1, F);
    }));
    var target$1 = $n($x_1).apply__O__O($n(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f));
    var this$14 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, G);
    var f$2 = new $c_sjsr_AnonFunction1(((r) => {
      var r$1 = $as_Lcats_effect_kernel_Ref(r);
      var $x_3 = $n(G);
      var $x_2 = $n(this.Lcats_effect_kernel_Resource$$anon$7__f_body$3).apply__Lcats_effect_kernel_MonadCancel__F3($m_Lcats_effect_kernel_MonadCancel$().monadCancelForKleisli__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_MonadCancel(G));
      var this$7 = $m_Lcats_data_Kleisli$();
      var _1 = $n($n($as_Lcats_data_Kleisli($n($x_2).apply__O__O__O__O(cb$1, $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$7, ga), nt2))).Lcats_data_Kleisli__f_run).apply__O__O(r$1);
      var _2 = $n(r$1).get__O();
      var t2 = new $c_T2(_1, _2);
      return $n($x_3).guaranteeCase__O__F1__O(new $c_Lcats_syntax_Tuple2SemigroupalOps(t2).tupled__Lcats_Invariant__Lcats_Semigroupal__O(G, G), new $c_sjsr_AnonFunction1(((x$1) => {
        var x$1$1 = $as_Lcats_effect_kernel_Outcome(x$1);
        if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
          var x$1$2 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$1);
          var this$11 = $n(x$1$2);
          return $n(G).unit__O();
        } else {
          var target$2 = $n(r$1).get__O();
          var this$13 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, G);
          var f$1 = new $c_sjsr_AnonFunction1(((fin) => {
            var fin$1 = $as_F1(fin);
            return $n(nt$1).apply__O__O($n(fin$1).apply__O__O($m_Lcats_effect_kernel_Resource$ExitCase$().fromOutcome__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Resource$ExitCase(x$1$1)));
          }));
          return $n(this$13.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$13.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
        }
      })));
    }));
    return $n(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
  }));
});
var $d_Lcats_effect_kernel_Resource$$anon$7 = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$$anon$7, "cats.effect.kernel.Resource$$anon$7", ({
  Lcats_effect_kernel_Resource$$anon$7: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Cont: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$$anon$7$$anon$8(G$8, nt$6, outer) {
  this.Lcats_effect_kernel_Resource$$anon$7$$anon$8__f_G$5 = null;
  this.Lcats_effect_kernel_Resource$$anon$7$$anon$8__f_nt$1 = null;
  this.Lcats_effect_kernel_Resource$$anon$7$$anon$8__f_$outer = null;
  this.Lcats_effect_kernel_Resource$$anon$7$$anon$8__f_G$5 = G$8;
  this.Lcats_effect_kernel_Resource$$anon$7$$anon$8__f_nt$1 = nt$6;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_kernel_Resource$$anon$7$$anon$8__f_$outer = outer;
}
$c_Lcats_effect_kernel_Resource$$anon$7$$anon$8.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$$anon$7$$anon$8.prototype.constructor = $c_Lcats_effect_kernel_Resource$$anon$7$$anon$8;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$$anon$7$$anon$8() {
}
$h_Lcats_effect_kernel_Resource$$anon$7$$anon$8.prototype = $c_Lcats_effect_kernel_Resource$$anon$7$$anon$8.prototype;
$c_Lcats_effect_kernel_Resource$$anon$7$$anon$8.prototype.apply__Lcats_effect_kernel_Resource__Lcats_data_Kleisli = (function(rfa) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((r) => {
    var r$1 = $as_Lcats_effect_kernel_Ref(r);
    return $n(this.Lcats_effect_kernel_Resource$$anon$7$$anon$8__f_G$5).uncancelable__F1__O(new $c_sjsr_AnonFunction1(((poll) => {
      var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
      var target = $n(poll$1).apply__O__O($n(this.Lcats_effect_kernel_Resource$$anon$7$$anon$8__f_nt$1).apply__O__O($n(rfa).allocatedCase__Lcats_effect_kernel_MonadCancel__O($n(this.Lcats_effect_kernel_Resource$$anon$7$$anon$8__f_$outer).Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$85)));
      var tc = this.Lcats_effect_kernel_Resource$$anon$7$$anon$8__f_G$5;
      var this$10 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
      var f$2 = new $c_sjsr_AnonFunction1(((x$1) => {
        var x$1$1 = $as_T2(x$1);
        if ((x$1$1 !== null)) {
          var a = $n(x$1$1)._1__O();
          var fin = $as_F1($n(x$1$1)._2__O());
          var $x_1 = $n(r$1);
          var x$2 = this.Lcats_effect_kernel_Resource$$anon$7$$anon$8__f_$outer;
          var target$1 = $n($x_1).update__F1__O(new $c_sjsr_AnonFunction1(((x) => ((f) => {
            var this$3 = $n(x);
            var f$1 = $as_F1(f);
            return new $c_sjsr_AnonFunction1(((ec) => {
              var ec$1 = $as_Lcats_effect_kernel_Resource$ExitCase(ec);
              var wrapped = $n(f$1).apply__O__O(ec$1);
              var this$5 = $n(this$3.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$85);
              var fa = this$5.pure__O__O((void 0));
              var fb = $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa, new $c_sjsr_AnonFunction0((() => $n(fin).apply__O__O(ec$1))), this$3.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$85);
              var F = this$3.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$85;
              return $n(F).forceR__O__O__O(wrapped, fb);
            }));
          }))(x$2)));
          var tc$1 = this.Lcats_effect_kernel_Resource$$anon$7$$anon$8__f_G$5;
          var this$9 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, tc$1);
          return $n(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_self, a);
        }
        throw new $c_s_MatchError(x$1$1);
      }));
      return $n(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
    })));
  }));
  return new $c_Lcats_data_Kleisli(run);
});
$c_Lcats_effect_kernel_Resource$$anon$7$$anon$8.prototype.apply__O__O = (function(fa) {
  return this.apply__Lcats_effect_kernel_Resource__Lcats_data_Kleisli($as_Lcats_effect_kernel_Resource(fa));
});
var $d_Lcats_effect_kernel_Resource$$anon$7$$anon$8 = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$$anon$7$$anon$8, "cats.effect.kernel.Resource$$anon$7$$anon$8", ({
  Lcats_effect_kernel_Resource$$anon$7$$anon$8: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$ExitCase$() {
}
$c_Lcats_effect_kernel_Resource$ExitCase$.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$ExitCase$.prototype.constructor = $c_Lcats_effect_kernel_Resource$ExitCase$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$ExitCase$() {
}
$h_Lcats_effect_kernel_Resource$ExitCase$.prototype = $c_Lcats_effect_kernel_Resource$ExitCase$.prototype;
$c_Lcats_effect_kernel_Resource$ExitCase$.prototype.fromOutcome__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Resource$ExitCase = (function(outcome) {
  if ((outcome instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
    var x$1 = $as_Lcats_effect_kernel_Outcome$Succeeded(outcome);
    var this$2 = $n(x$1);
    return $m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$();
  }
  if ((outcome instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
    var x$1$1 = $as_Lcats_effect_kernel_Outcome$Errored(outcome);
    var this$4 = $n(x$1$1);
    var x245 = $as_jl_Throwable(this$4.Lcats_effect_kernel_Outcome$Errored__f_e);
    return new $c_Lcats_effect_kernel_Resource$ExitCase$Errored(x245);
  }
  if (((outcome instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(outcome), true))) {
    return $m_Lcats_effect_kernel_Resource$ExitCase$Canceled$();
  }
  throw new $c_s_MatchError(outcome);
});
var $d_Lcats_effect_kernel_Resource$ExitCase$ = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$ExitCase$, "cats.effect.kernel.Resource$ExitCase$", ({
  Lcats_effect_kernel_Resource$ExitCase$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Lcats_effect_kernel_Resource$ExitCase$;
function $m_Lcats_effect_kernel_Resource$ExitCase$() {
  if ((!$n_Lcats_effect_kernel_Resource$ExitCase$)) {
    $n_Lcats_effect_kernel_Resource$ExitCase$ = new $c_Lcats_effect_kernel_Resource$ExitCase$();
  }
  return $n_Lcats_effect_kernel_Resource$ExitCase$;
}
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Frame$3$(outer) {
  this.Lcats_effect_kernel_Resource$Frame$3$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_kernel_Resource$Frame$3$__f_$outer = outer;
}
$c_Lcats_effect_kernel_Resource$Frame$3$.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$Frame$3$.prototype.constructor = $c_Lcats_effect_kernel_Resource$Frame$3$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Frame$3$() {
}
$h_Lcats_effect_kernel_Resource$Frame$3$.prototype = $c_Lcats_effect_kernel_Resource$Frame$3$.prototype;
$c_Lcats_effect_kernel_Resource$Frame$3$.prototype.apply__F1__Lcats_effect_kernel_Resource$Stack$1__Lcats_effect_kernel_Resource$Frame$1 = (function(head, tail) {
  return new $c_Lcats_effect_kernel_Resource$Frame$1(this.Lcats_effect_kernel_Resource$Frame$3$__f_$outer, head, tail);
});
$c_Lcats_effect_kernel_Resource$Frame$3$.prototype.toString__T = (function() {
  return "Frame";
});
function $as_Lcats_effect_kernel_Resource$Frame$3$(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Frame$3$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Frame$3$"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$Frame$3$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Frame$3$)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$Frame$3$(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Frame$3$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Frame$3$;", depth));
}
var $d_Lcats_effect_kernel_Resource$Frame$3$ = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$Frame$3$, "cats.effect.kernel.Resource$Frame$3$", ({
  Lcats_effect_kernel_Resource$Frame$3$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Frame$6$(outer) {
  this.Lcats_effect_kernel_Resource$Frame$6$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_kernel_Resource$Frame$6$__f_$outer = outer;
}
$c_Lcats_effect_kernel_Resource$Frame$6$.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$Frame$6$.prototype.constructor = $c_Lcats_effect_kernel_Resource$Frame$6$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Frame$6$() {
}
$h_Lcats_effect_kernel_Resource$Frame$6$.prototype = $c_Lcats_effect_kernel_Resource$Frame$6$.prototype;
$c_Lcats_effect_kernel_Resource$Frame$6$.prototype.apply__F1__Lcats_effect_kernel_Resource$Stack$2__Lcats_effect_kernel_Resource$Frame$4 = (function(head, tail) {
  return new $c_Lcats_effect_kernel_Resource$Frame$4(this.Lcats_effect_kernel_Resource$Frame$6$__f_$outer, head, tail);
});
$c_Lcats_effect_kernel_Resource$Frame$6$.prototype.toString__T = (function() {
  return "Frame";
});
function $as_Lcats_effect_kernel_Resource$Frame$6$(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Frame$6$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Frame$6$"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$Frame$6$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Frame$6$)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$Frame$6$(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Frame$6$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Frame$6$;", depth));
}
var $d_Lcats_effect_kernel_Resource$Frame$6$ = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$Frame$6$, "cats.effect.kernel.Resource$Frame$6$", ({
  Lcats_effect_kernel_Resource$Frame$6$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$State$3$(F$95, outer) {
  this.Lcats_effect_kernel_Resource$State$3$__f_F$54 = null;
  this.Lcats_effect_kernel_Resource$State$3$__f_$outer = null;
  this.Lcats_effect_kernel_Resource$State$3$__f_F$54 = F$95;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_kernel_Resource$State$3$__f_$outer = outer;
}
$c_Lcats_effect_kernel_Resource$State$3$.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$State$3$.prototype.constructor = $c_Lcats_effect_kernel_Resource$State$3$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$State$3$() {
}
$h_Lcats_effect_kernel_Resource$State$3$.prototype = $c_Lcats_effect_kernel_Resource$State$3$.prototype;
$c_Lcats_effect_kernel_Resource$State$3$.prototype.apply__O__Z__Z__Lcats_effect_kernel_Resource$State$1 = (function(fin, finalizeOnComplete, confirmedFinalizeOnComplete) {
  return new $c_Lcats_effect_kernel_Resource$State$1(this.Lcats_effect_kernel_Resource$State$3$__f_$outer, fin, finalizeOnComplete, confirmedFinalizeOnComplete);
});
$c_Lcats_effect_kernel_Resource$State$3$.prototype.toString__T = (function() {
  return "State";
});
$c_Lcats_effect_kernel_Resource$State$3$.prototype.$lessinit$greater$default$1__O = (function() {
  var this$1 = $n(this.Lcats_effect_kernel_Resource$State$3$__f_F$54);
  return this$1.pure__O__O((void 0));
});
function $as_Lcats_effect_kernel_Resource$State$3$(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$State$3$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$State$3$"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$State$3$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$State$3$)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$State$3$(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$State$3$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$State$3$;", depth));
}
var $d_Lcats_effect_kernel_Resource$State$3$ = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$State$3$, "cats.effect.kernel.Resource$State$3$", ({
  Lcats_effect_kernel_Resource$State$3$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2() {
}
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype = new $h_O();
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype.constructor = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2;
/** @constructor */
function $h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2() {
}
$h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype;
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype.apply__O__O = (function(fa) {
  $n($m_Lcats_effect_kernel_Par$().Lcats_effect_kernel_Par$__f_instance);
  return fa;
});
var $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2 = new $TypeData().initClass($c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2, "cats.effect.kernel.instances.GenSpawnInstances$$anon$2", ({
  Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3() {
}
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3.prototype = new $h_O();
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3.prototype.constructor = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3;
/** @constructor */
function $h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3() {
}
$h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3.prototype = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3.prototype;
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3.prototype.apply__O__O = (function(ma) {
  $n($m_Lcats_effect_kernel_Par$().Lcats_effect_kernel_Par$__f_instance);
  return ma;
});
var $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3 = new $TypeData().initClass($c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3, "cats.effect.kernel.instances.GenSpawnInstances$$anon$3", ({
  Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
function $p_Lcats_effect_std_Console$NodeJSConsole__write__sjs_js_Dynamic__T__O($thiz, writable, s) {
  return $n($thiz.Lcats_effect_std_Console$NodeJSConsole__f_F).async___F1__O(new $c_sjsr_AnonFunction1(((cb) => {
    var cb$1 = $as_F1(cb);
    if ($uZ(writable.write(s))) {
      $n(cb$1).apply__O__O(new $c_s_util_Right((void 0)));
    } else {
      writable.once("drain", $m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(new $c_sjsr_AnonFunction0((() => {
        $n(cb$1).apply__O__O(new $c_s_util_Right((void 0)));
      }))));
    }
  })));
}
function $p_Lcats_effect_std_Console$NodeJSConsole__writeln__sjs_js_Dynamic__T__O($thiz, writable, s) {
  return $n($thiz.Lcats_effect_std_Console$NodeJSConsole__f_F).async__F1__O(new $c_sjsr_AnonFunction1(((cb) => {
    var cb$1 = $as_F1(cb);
    return $n($thiz.Lcats_effect_std_Console$NodeJSConsole__f_F).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
      try {
        writable.cork();
        writable.write(s);
        if ($uZ(writable.write("\n"))) {
          $n(cb$1).apply__O__O(new $c_s_util_Right((void 0)));
        } else {
          writable.once("drain", $m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(new $c_sjsr_AnonFunction0((() => {
            $n(cb$1).apply__O__O(new $c_s_util_Right((void 0)));
          }))));
        }
      } finally {
        writable.uncork();
      }
      return $m_s_None$();
    })));
  })));
}
/** @constructor */
function $c_Lcats_effect_std_Console$NodeJSConsole(stdout, stderr, F) {
  this.Lcats_effect_std_Console$NodeJSConsole__f_stderr = null;
  this.Lcats_effect_std_Console$NodeJSConsole__f_F = null;
  this.Lcats_effect_std_Console$NodeJSConsole__f_stderr = stderr;
  this.Lcats_effect_std_Console$NodeJSConsole__f_F = F;
}
$c_Lcats_effect_std_Console$NodeJSConsole.prototype = new $h_O();
$c_Lcats_effect_std_Console$NodeJSConsole.prototype.constructor = $c_Lcats_effect_std_Console$NodeJSConsole;
/** @constructor */
function $h_Lcats_effect_std_Console$NodeJSConsole() {
}
$h_Lcats_effect_std_Console$NodeJSConsole.prototype = $c_Lcats_effect_std_Console$NodeJSConsole.prototype;
$c_Lcats_effect_std_Console$NodeJSConsole.prototype.printStackTrace__jl_Throwable__O = (function(t) {
  return $m_Lcats_effect_std_Console$().printStackTrace__Lcats_effect_std_Console__jl_Throwable__O(this, t);
});
$c_Lcats_effect_std_Console$NodeJSConsole.prototype.error__O__Lcats_Show__O = (function(a, S) {
  return $p_Lcats_effect_std_Console$NodeJSConsole__write__sjs_js_Dynamic__T__O(this, this.Lcats_effect_std_Console$NodeJSConsole__f_stderr, $n(S).show__O__T(a));
});
$c_Lcats_effect_std_Console$NodeJSConsole.prototype.errorln__O__Lcats_Show__O = (function(a, S) {
  return $p_Lcats_effect_std_Console$NodeJSConsole__writeln__sjs_js_Dynamic__T__O(this, this.Lcats_effect_std_Console$NodeJSConsole__f_stderr, $n(S).show__O__T(a));
});
var $d_Lcats_effect_std_Console$NodeJSConsole = new $TypeData().initClass($c_Lcats_effect_std_Console$NodeJSConsole, "cats.effect.std.Console$NodeJSConsole", ({
  Lcats_effect_std_Console$NodeJSConsole: 1,
  Lcats_effect_std_ConsoleCrossPlatform: 1,
  Lcats_effect_std_Console: 1
}));
/** @constructor */
function $c_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole(outer, F) {
  this.Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole__f_F = null;
  this.Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole__f_F = F;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole.prototype = new $h_O();
$c_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole.prototype.constructor = $c_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole;
/** @constructor */
function $h_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole() {
}
$h_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole.prototype = $c_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole.prototype;
$c_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole.prototype.error__O__Lcats_Show__O = (function(a, S) {
  var this$2 = new $c_Lcats_Show$ToShowOps$$anon$3(a, S);
  var text = $n(this$2.Lcats_Show$ToShowOps$$anon$3__f_typeClassInstance).show__O__T(this$2.Lcats_Show$ToShowOps$$anon$3__f_self);
  return $n(this.Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole__f_F).blocking__F0__O(new $c_sjsr_AnonFunction0((() => {
    $n($m_jl_System$Streams$().jl_System$Streams$__f_err).print__T__V(text);
  })));
});
$c_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole.prototype.errorln__O__Lcats_Show__O = (function(a, S) {
  var this$2 = new $c_Lcats_Show$ToShowOps$$anon$3(a, S);
  var text = $n(this$2.Lcats_Show$ToShowOps$$anon$3__f_typeClassInstance).show__O__T(this$2.Lcats_Show$ToShowOps$$anon$3__f_self);
  return $n(this.Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole__f_F).blocking__F0__O(new $c_sjsr_AnonFunction0((() => {
    $n($m_jl_System$Streams$().jl_System$Streams$__f_err).println__T__V(text);
  })));
});
$c_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole.prototype.printStackTrace__jl_Throwable__O = (function(t) {
  return $n(this.Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole__f_F).blocking__F0__O(new $c_sjsr_AnonFunction0((() => {
    var this$1 = $n(t);
    this$1.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err);
  })));
});
var $d_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole = new $TypeData().initClass($c_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole, "cats.effect.std.ConsoleCompanionCrossPlatform$SyncConsole", ({
  Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole: 1,
  Lcats_effect_std_ConsoleCrossPlatform: 1,
  Lcats_effect_std_Console: 1
}));
function $p_Lcats_effect_std_Dispatcher$$anon$2__cancel$1__ju_concurrent_atomic_AtomicReference__Lcats_effect_std_Dispatcher$Registration$Primary__s_concurrent_Future($thiz, stateR$3, reg$1) {
  while (true) {
    var x7 = $as_Lcats_effect_std_Dispatcher$RegState($n(stateR$3).ju_concurrent_atomic_AtomicReference__f_value);
    var x = $m_Lcats_effect_std_Dispatcher$RegState$Unstarted$();
    if ((x === x7)) {
      var latch = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
      $n(reg$1).Lcats_effect_std_Dispatcher$Registration$Primary__f_action = null;
      if ($n(stateR$3).compareAndSet__O__O__Z($m_Lcats_effect_std_Dispatcher$RegState$Unstarted$(), new $c_Lcats_effect_std_Dispatcher$RegState$CancelRequested(latch))) {
        return latch;
      } else {
        continue;
      }
    }
    if ((x7 instanceof $c_Lcats_effect_std_Dispatcher$RegState$Running)) {
      var r = $as_Lcats_effect_std_Dispatcher$RegState$Running(x7);
      var cancel = $n(r).Lcats_effect_std_Dispatcher$RegState$Running__f_cancel;
      var latch$2 = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
      $p_Lcats_effect_std_Dispatcher$$anon$2__inner$1__O__s_concurrent_Promise__Z__F0($thiz, cancel, latch$2, true);
      return latch$2;
    }
    if ((x7 instanceof $c_Lcats_effect_std_Dispatcher$RegState$CancelRequested)) {
      var r$2 = $as_Lcats_effect_std_Dispatcher$RegState$CancelRequested(x7);
      return $n($n(r$2).Lcats_effect_std_Dispatcher$RegState$CancelRequested__f_latch);
    }
    var x$3 = $m_Lcats_effect_std_Dispatcher$RegState$Completed$();
    if ((x$3 === x7)) {
      return $m_s_concurrent_Future$().successful__O__s_concurrent_Future((void 0));
    }
    throw new $c_s_MatchError(x7);
  }
}
function $p_Lcats_effect_std_Dispatcher$$anon$2__inner$1__O__s_concurrent_Promise__Z__F0($thiz, fe, result, finalizer) {
  if ($n($thiz.Lcats_effect_std_Dispatcher$$anon$2__f_doneR$5).ju_concurrent_atomic_AtomicBoolean__f_value) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Dispatcher already closed");
  }
  var stateR = $ct_ju_concurrent_atomic_AtomicReference__O__(new $c_ju_concurrent_atomic_AtomicReference(), $m_Lcats_effect_std_Dispatcher$RegState$Unstarted$());
  var F = $thiz.Lcats_effect_std_Dispatcher$$anon$2__f_evidence$7$8;
  var promisory = $n(F).uncancelable__F1__O(new $c_sjsr_AnonFunction1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var F$1 = $thiz.Lcats_effect_std_Dispatcher$$anon$2__f_evidence$7$8;
    var completeState = $n(F$1).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
      matchResult2: {
        var x4 = $as_Lcats_effect_std_Dispatcher$RegState(stateR.getAndSet__O__O($m_Lcats_effect_std_Dispatcher$RegState$Completed$()));
        if ((x4 instanceof $c_Lcats_effect_std_Dispatcher$RegState$CancelRequested)) {
          var st = $as_Lcats_effect_std_Dispatcher$RegState$CancelRequested(x4);
          var this$4 = $n($n(st).Lcats_effect_std_Dispatcher$RegState$CancelRequested__f_latch);
          $f_s_concurrent_Promise__success__O__s_concurrent_Promise(this$4, (void 0));
          break matchResult2;
        }
        var x = $m_Lcats_effect_std_Dispatcher$RegState$Completed$();
        if ((x === x4)) {
          throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "unexpected Completed state");
        }
      }
    })));
    var $x_1 = $n(poll$1);
    var F$2 = $thiz.Lcats_effect_std_Dispatcher$$anon$2__f_evidence$7$8;
    var fa = $n($x_1).apply__O__O($n(F$2).guarantee__O__O__O(fe, completeState));
    var recover = new $c_sjsr_AnonFunction1(((e) => {
      var e$1 = $as_jl_Throwable(e);
      var F$4 = $thiz.Lcats_effect_std_Dispatcher$$anon$2__f_evidence$7$8;
      return $n(F$4).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
        var this$9 = $n(result);
        return $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise(this$9, e$1);
      })));
    }));
    var bind = new $c_sjsr_AnonFunction1(((a) => {
      var F$5 = $thiz.Lcats_effect_std_Dispatcher$$anon$2__f_evidence$7$8;
      return $n(F$5).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
        var this$11 = $n(result);
        return $f_s_concurrent_Promise__success__O__s_concurrent_Promise(this$11, a);
      })));
    }));
    var F$6 = $thiz.Lcats_effect_std_Dispatcher$$anon$2__f_evidence$7$8;
    return $n(F$6).redeemWith__O__F1__F1__O(fa, recover, bind);
  })));
  if ($thiz.Lcats_effect_std_Dispatcher$$anon$2__f_parallel$6) {
    var $x_2 = $n($thiz.Lcats_effect_std_Dispatcher$$anon$2__f_workers$3);
    var this$13 = $m_ju_concurrent_ThreadLocalRandom$();
    var worker = $n($x_2).get($n(this$13.ju_concurrent_ThreadLocalRandom$__f__current).nextInt__I__I($m_Lcats_effect_std_Dispatcher$().Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$Cpus));
  } else {
    var worker = $n($thiz.Lcats_effect_std_Dispatcher$$anon$2__f_workers$3).get(0);
  }
  if (finalizer) {
    var $x_3 = $n($n(worker).Lcats_effect_std_Dispatcher$Worker__f_queue);
    var tc = $thiz.Lcats_effect_std_Dispatcher$$anon$2__f_evidence$7$8;
    var this$15 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(promisory, tc);
    var action = $n(this$15.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$15.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
    $n($x_3).unsafeOffer__O__V(new $c_Lcats_effect_std_Dispatcher$Registration$Finalizer(action));
    return new $c_sjsr_AnonFunction0((() => $m_s_concurrent_Future$().failed__jl_Throwable__s_concurrent_Future($ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException()))));
  } else {
    var tc$1 = $thiz.Lcats_effect_std_Dispatcher$$anon$2__f_evidence$7$8;
    var this$18 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(promisory, tc$1);
    var reg = new $c_Lcats_effect_std_Dispatcher$Registration$Primary($n(this$18.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$18.Lcats_Functor$ToFunctorOps$$anon$5__f_self), stateR);
    $n($n(worker).Lcats_effect_std_Dispatcher$Worker__f_queue).unsafeOffer__O__V(reg);
    return new $c_sjsr_AnonFunction0((() => $p_Lcats_effect_std_Dispatcher$$anon$2__cancel$1__ju_concurrent_atomic_AtomicReference__Lcats_effect_std_Dispatcher$Registration$Primary__s_concurrent_Future($thiz, stateR, reg)));
  }
}
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$$anon$2(parallel$7, evidence$7$9, doneR$11, workers$5, ec$2) {
  this.Lcats_effect_std_Dispatcher$$anon$2__f_parallel$6 = false;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_evidence$7$8 = null;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_doneR$5 = null;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_workers$3 = null;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_ec$1 = null;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_parallel$6 = parallel$7;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_evidence$7$8 = evidence$7$9;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_doneR$5 = doneR$11;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_workers$3 = workers$5;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_ec$1 = ec$2;
}
$c_Lcats_effect_std_Dispatcher$$anon$2.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$$anon$2.prototype.constructor = $c_Lcats_effect_std_Dispatcher$$anon$2;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$$anon$2() {
}
$h_Lcats_effect_std_Dispatcher$$anon$2.prototype = $c_Lcats_effect_std_Dispatcher$$anon$2.prototype;
$c_Lcats_effect_std_Dispatcher$$anon$2.prototype.unsafeToFutureCancelable__O__T2 = (function(fa) {
  var result = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
  var _2 = $p_Lcats_effect_std_Dispatcher$$anon$2__inner$1__O__s_concurrent_Promise__Z__F0(this, fa, result, false);
  return new $c_T2(result, _2);
});
$c_Lcats_effect_std_Dispatcher$$anon$2.prototype.reportFailure__jl_Throwable__V = (function(t) {
  $n(this.Lcats_effect_std_Dispatcher$$anon$2__f_ec$1).reportFailure__jl_Throwable__V(t);
});
var $d_Lcats_effect_std_Dispatcher$$anon$2 = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$$anon$2, "cats.effect.std.Dispatcher$$anon$2", ({
  Lcats_effect_std_Dispatcher$$anon$2: 1,
  Lcats_effect_std_DispatcherPlatform: 1,
  Lcats_effect_std_Dispatcher: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$(TaskState$lzy1$14) {
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Ready$lzy1 = null;
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Executing$lzy1 = null;
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Executingbitmap$1 = false;
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Canceling$lzy1 = null;
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Dead$lzy1 = null;
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Deadbitmap$1 = false;
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Ready$lzy1 = new $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$(this);
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Canceling$lzy1 = new $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$(this);
}
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$() {
}
$h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$.prototype = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$.prototype;
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$.prototype.Executing__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$ = (function() {
  if ((!this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Executingbitmap$1)) {
    this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Executing$lzy1 = new $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$();
    this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Executingbitmap$1 = true;
  }
  return this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Executing$lzy1;
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$.prototype.Dead__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$ = (function() {
  if ((!this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Deadbitmap$1)) {
    this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Dead$lzy1 = new $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$();
    this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Deadbitmap$1 = true;
  }
  return this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Dead$lzy1;
});
function $as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$Executor$TaskState$3$"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$Executor$TaskState$3$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$Executor$TaskState$3$)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$Executor$TaskState$3$(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$Executor$TaskState$3$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$Executor$TaskState$3$;", depth));
}
var $d_Lcats_effect_std_Dispatcher$Executor$TaskState$3$ = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$, "cats.effect.std.Dispatcher$Executor$TaskState$3$", ({
  Lcats_effect_std_Dispatcher$Executor$TaskState$3$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$(outer) {
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$__f_$outer = outer;
}
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$() {
}
$h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$.prototype = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$.prototype;
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$.prototype.apply__Lcats_effect_kernel_Deferred__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling = (function(latch) {
  return new $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$__f_$outer, latch);
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$.prototype.toString__T = (function() {
  return "Canceling";
});
var $d_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$ = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$, "cats.effect.std.Dispatcher$Executor$TaskState$3$Canceling$", ({
  Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$(outer) {
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$__f_$outer = outer;
}
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$() {
}
$h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$.prototype = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$.prototype;
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$.prototype.apply__O__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready = (function(task) {
  return new $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready(this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$__f_$outer, task);
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$.prototype.toString__T = (function() {
  return "Ready";
});
var $d_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$ = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$, "cats.effect.std.Dispatcher$Executor$TaskState$3$Ready$", ({
  Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue(evidence$9) {
  this.ju_concurrent_atomic_AtomicReference__f_value = null;
  this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue__f_cats$effect$std$Dispatcher$UnsafeAsyncQueue$$evidence$9 = null;
  this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue__f_cats$effect$std$Dispatcher$UnsafeAsyncQueue$$buffer = null;
  this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue__f_cats$effect$std$Dispatcher$UnsafeAsyncQueue$$evidence$9 = evidence$9;
  $ct_ju_concurrent_atomic_AtomicReference__O__(this, null);
  this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue__f_cats$effect$std$Dispatcher$UnsafeAsyncQueue$$buffer = new $c_Lcats_effect_std_UnsafeUnbounded();
}
$c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue.prototype = new $h_ju_concurrent_atomic_AtomicReference();
$c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue.prototype.constructor = $c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue() {
}
$h_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue.prototype = $c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue.prototype;
$c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue.prototype.unsafeOffer__O__V = (function(a) {
  $n(this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue__f_cats$effect$std$Dispatcher$UnsafeAsyncQueue$$buffer).put__O__F0(a);
  var back = $as_F1(this.ju_concurrent_atomic_AtomicReference__f_value);
  if ((back !== null)) {
    $n(back).apply__O__O($m_Lcats_effect_std_Dispatcher$().Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$RightUnit);
  }
});
$c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue.prototype.take__O = (function() {
  var F = this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue__f_cats$effect$std$Dispatcher$UnsafeAsyncQueue$$evidence$9;
  return $n(F).cont__Lcats_effect_kernel_Cont__O(new $c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6(this));
});
var $d_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue, "cats.effect.std.Dispatcher$UnsafeAsyncQueue", ({
  Lcats_effect_std_Dispatcher$UnsafeAsyncQueue: 1,
  ju_concurrent_atomic_AtomicReference: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6(outer) {
  this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6__f_$outer = outer;
}
$c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6.prototype.constructor = $c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6() {
}
$h_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6.prototype = $c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6.prototype;
$c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6.prototype.apply__Lcats_effect_kernel_MonadCancel__F3 = (function(evidence$14) {
  return new $c_sjsr_AnonFunction3(((k, get, lift) => {
    var k$1 = $as_F1(k);
    var lift$1 = $as_Lcats_arrow_FunctionK(lift);
    var $x_1 = $n(lift$1);
    var F = $n(this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6__f_$outer).Lcats_effect_std_Dispatcher$UnsafeAsyncQueue__f_cats$effect$std$Dispatcher$UnsafeAsyncQueue$$evidence$9;
    var takeG = $n($x_1).apply__O__O($n(F).delay__F0__O(new $c_sjsr_AnonFunction0((() => $n($n(this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6__f_$outer).Lcats_effect_std_Dispatcher$UnsafeAsyncQueue__f_cats$effect$std$Dispatcher$UnsafeAsyncQueue$$buffer).take__O()))));
    var $x_2 = $n(lift$1);
    var F$1 = $n(this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6__f_$outer).Lcats_effect_std_Dispatcher$UnsafeAsyncQueue__f_cats$effect$std$Dispatcher$UnsafeAsyncQueue$$evidence$9;
    var setLatchG = $n($x_2).apply__O__O($n(F$1).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
      $n(this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6__f_$outer).ju_concurrent_atomic_AtomicReference__f_value = k$1;
    }))));
    var $x_3 = $n(lift$1);
    var F$2 = $n(this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6__f_$outer).Lcats_effect_std_Dispatcher$UnsafeAsyncQueue__f_cats$effect$std$Dispatcher$UnsafeAsyncQueue$$evidence$9;
    var unsetLatchG = $n($x_3).apply__O__O($n(F$2).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
      var this$5 = $n(this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6__f_$outer);
      this$5.ju_concurrent_atomic_AtomicReference__f_value = null;
    }))));
    var f$1 = new $c_sjsr_AnonFunction1(((_$32) => {
      $as_jl_Throwable(_$32);
      var this$19 = new $c_Lcats_syntax_ApplySyntax$$anon$1(setLatchG, evidence$14);
      var this$9 = new $c_Lcats_syntax_ApplySyntax$$anon$1(takeG, evidence$14);
      var this$10 = $n(this$9.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
      var fa = this$9.Lcats_syntax_ApplySyntax$$anon$1__f_self;
      var fa$1 = this$10.productL__O__O__O(fa, unsetLatchG);
      var f = new $c_sjsr_AnonFunction1(((_$33) => {
        $as_jl_Throwable(_$33);
        var this$13 = new $c_Lcats_syntax_ApplySyntax$$anon$1(get, evidence$14);
        var this$14 = $n(this$13.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
        var fa$2 = this$13.Lcats_syntax_ApplySyntax$$anon$1__f_self;
        var fa$3 = this$14.productR__O__O__O(fa$2, unsetLatchG);
        var this$16 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$3, evidence$14);
        var fb = $n(lift$1).apply__O__O($n(this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6__f_$outer).take__O());
        var this$17 = $n(this$16.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
        var fa$4 = this$16.Lcats_syntax_ApplySyntax$$anon$1__f_self;
        return this$17.productR__O__O__O(fa$4, fb);
      }));
      var fb$1 = $n(evidence$14).handleErrorWith__O__F1__O(fa$1, f);
      var this$20 = $n(this$19.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
      var fa$5 = this$19.Lcats_syntax_ApplySyntax$$anon$1__f_self;
      return this$20.productR__O__O__O(fa$5, fb$1);
    }));
    return $n(evidence$14).handleErrorWith__O__F1__O(takeG, f$1);
  }));
});
var $d_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6 = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6, "cats.effect.std.Dispatcher$UnsafeAsyncQueue$$anon$6", ({
  Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Cont: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Queue() {
}
$c_Lcats_effect_std_Queue.prototype = new $h_O();
$c_Lcats_effect_std_Queue.prototype.constructor = $c_Lcats_effect_std_Queue;
/** @constructor */
function $h_Lcats_effect_std_Queue() {
}
$h_Lcats_effect_std_Queue.prototype = $c_Lcats_effect_std_Queue.prototype;
function $as_Lcats_effect_std_Queue(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Queue) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Queue"));
}
function $isArrayOf_Lcats_effect_std_Queue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Queue)));
}
function $asArrayOf_Lcats_effect_std_Queue(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Queue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Queue;", depth));
}
function $ct_Lcats_effect_std_Random$ScalaRandom__O__Lcats_effect_kernel_Sync__($thiz, f, evidence$25) {
  $thiz.Lcats_effect_std_Random$ScalaRandom__f_f = f;
  $thiz.Lcats_effect_std_Random$ScalaRandom__f_evidence$25 = evidence$25;
  $ct_Lcats_effect_std_Random$RandomCommon__Lcats_effect_kernel_Sync__($thiz, evidence$25);
  return $thiz;
}
/** @constructor */
function $c_Lcats_effect_std_Random$ScalaRandom() {
  this.Lcats_effect_std_Random$RandomCommon__f_evidence$24 = null;
  this.Lcats_effect_std_Random$ScalaRandom__f_f = null;
  this.Lcats_effect_std_Random$ScalaRandom__f_evidence$25 = null;
}
$c_Lcats_effect_std_Random$ScalaRandom.prototype = new $h_Lcats_effect_std_Random$RandomCommon();
$c_Lcats_effect_std_Random$ScalaRandom.prototype.constructor = $c_Lcats_effect_std_Random$ScalaRandom;
/** @constructor */
function $h_Lcats_effect_std_Random$ScalaRandom() {
}
$h_Lcats_effect_std_Random$ScalaRandom.prototype = $c_Lcats_effect_std_Random$ScalaRandom.prototype;
$c_Lcats_effect_std_Random$ScalaRandom.prototype.nextInt__O = (function() {
  var target = this.Lcats_effect_std_Random$ScalaRandom__f_f;
  var tc = this.Lcats_effect_std_Random$ScalaRandom__f_evidence$25;
  var this$8 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f$1 = new $c_sjsr_AnonFunction1(((r) => {
    var r$1 = $as_s_util_Random(r);
    var F = this.Lcats_effect_std_Random$ScalaRandom__f_evidence$25;
    var target$1 = $n(F).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
      var this$4 = $n(r$1);
      var this$5 = $n(this$4.s_util_Random__f_self);
      return this$5.next__I__I(32);
    })));
    var tc$1 = this.Lcats_effect_std_Random$ScalaRandom__f_evidence$25;
    var this$7 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, tc$1);
    var f = new $c_sjsr_AnonFunction1(((out) => {
      var out$1 = $uI(out);
      return out$1;
    }));
    return $n(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  }));
  return $n(this$8.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$8.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
});
$c_Lcats_effect_std_Random$ScalaRandom.prototype.nextIntBounded__I__O = (function(n) {
  var target = this.Lcats_effect_std_Random$ScalaRandom__f_f;
  var tc = this.Lcats_effect_std_Random$ScalaRandom__f_evidence$25;
  var this$6 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f$1 = new $c_sjsr_AnonFunction1(((r) => {
    var r$1 = $as_s_util_Random(r);
    var F = this.Lcats_effect_std_Random$ScalaRandom__f_evidence$25;
    var target$1 = $n(F).delay__F0__O(new $c_sjsr_AnonFunction0((() => $n($n(r$1).s_util_Random__f_self).nextInt__I__I(n))));
    var tc$1 = this.Lcats_effect_std_Random$ScalaRandom__f_evidence$25;
    var this$5 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, tc$1);
    var f = new $c_sjsr_AnonFunction1(((out) => {
      var out$1 = $uI(out);
      return out$1;
    }));
    return $n(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  }));
  return $n(this$6.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$6.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
});
/** @constructor */
function $c_Lcats_effect_std_Supervisor$$anon$2(F$5, fin$11, resultR$10, canceledR$9, currentR$7, outer) {
  this.Lcats_effect_std_Supervisor$$anon$2__f_resultR$15 = null;
  this.Lcats_effect_std_Supervisor$$anon$2__f_delegateF = null;
  this.Lcats_effect_std_Supervisor$$anon$2__f_cancel = null;
  this.Lcats_effect_std_Supervisor$$anon$2__f_$outer = null;
  this.Lcats_effect_std_Supervisor$$anon$2__f_resultR$15 = resultR$10;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_std_Supervisor$$anon$2__f_$outer = outer;
  var target = $n(currentR$7).get__O();
  var this$2 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F$5);
  var f = new $c_sjsr_AnonFunction1(((_$9) => {
    var _$9$1 = $as_Lcats_effect_kernel_Deferred(_$9);
    return $n(_$9$1).get__O();
  }));
  this.Lcats_effect_std_Supervisor$$anon$2__f_delegateF = $n(this$2.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$2.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  this.Lcats_effect_std_Supervisor$$anon$2__f_cancel = $n(F$5).uncancelable__F1__O(new $c_sjsr_AnonFunction1(((_$10) => {
    $as_Lcats_effect_kernel_Poll(_$10);
    var fa = $n(canceledR$9).set__O__O(true);
    var this$5 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa, F$5);
    var fb = this.Lcats_effect_std_Supervisor$$anon$2__f_delegateF;
    var this$6 = $n(this$5.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
    var fa$1 = this$5.Lcats_syntax_ApplySyntax$$anon$1__f_self;
    var target$1 = this$6.productR__O__O__O(fa$1, fb);
    var this$30 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, F$5);
    var f$3 = new $c_sjsr_AnonFunction1(((x$1) => {
      var x$1$1 = $as_Lcats_effect_kernel_Fiber(x$1);
      if ((x$1$1 === null)) {
        var target$2 = $n(resultR$10).get__O();
        var this$9 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, F$5);
        return $n(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
      } else {
        var fa$2 = $n(x$1$1).cancel__O();
        var this$11 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$2, F$5);
        var fb$1 = $n(x$1$1).join__O();
        var this$12 = $n(this$11.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
        var fa$3 = this$11.Lcats_syntax_ApplySyntax$$anon$1__f_self;
        var target$3 = this$12.productR__O__O__O(fa$3, fb$1);
        var this$29 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$3, F$5);
        var f$2 = new $c_sjsr_AnonFunction1(((x$1$2) => {
          var x$1$3 = $as_Lcats_effect_kernel_Outcome(x$1$2);
          if (((x$1$3 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$3), true))) {
            var target$4 = this.Lcats_effect_std_Supervisor$$anon$2__f_delegateF;
            var this$26 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$4, F$5);
            var x$2 = this.Lcats_effect_std_Supervisor$$anon$2__f_$outer;
            var f$1 = new $c_sjsr_AnonFunction1(((x) => ((x$1$2$1) => {
              $n(x);
              var x$1$4 = $as_Lcats_effect_kernel_Fiber(x$1$2$1);
              if ((x$1$4 === null)) {
                var target$5 = $n(resultR$10).get__O();
                var this$17 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$5, F$5);
                return $n(this$17.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$17.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
              } else {
                var target$6 = $n(resultR$10).complete__O__O(new $c_Lcats_effect_kernel_Outcome$Canceled());
                var this$21 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$6, F$5);
                var fin = $n(this$21.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$21.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
                var cleanup = $n(F$5).guarantee__O__O__O(fin$11, fin);
                if ((x$1$4 === x$1$1)) {
                  return cleanup;
                } else {
                  var this$24 = new $c_Lcats_syntax_ApplySyntax$$anon$1(cleanup, F$5);
                  var fb$2 = $n(F$5).raiseError__O__O($ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "unexpected fiber (this is a bug in Supervisor)"));
                  var this$25 = $n(this$24.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
                  var fa$4 = this$24.Lcats_syntax_ApplySyntax$$anon$1__f_self;
                  return this$25.productR__O__O__O(fa$4, fb$2);
                }
              }
            }))(x$2));
            return $n(this$26.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$26.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
          } else {
            var target$7 = $n(resultR$10).get__O();
            var this$28 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$7, F$5);
            return $n(this$28.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$28.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
          }
        }));
        return $n(this$29.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$29.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
      }
    }));
    return $n(this$30.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$30.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
  })));
}
$c_Lcats_effect_std_Supervisor$$anon$2.prototype = new $h_O();
$c_Lcats_effect_std_Supervisor$$anon$2.prototype.constructor = $c_Lcats_effect_std_Supervisor$$anon$2;
/** @constructor */
function $h_Lcats_effect_std_Supervisor$$anon$2() {
}
$h_Lcats_effect_std_Supervisor$$anon$2.prototype = $c_Lcats_effect_std_Supervisor$$anon$2.prototype;
$c_Lcats_effect_std_Supervisor$$anon$2.prototype.cancel__O = (function() {
  return this.Lcats_effect_std_Supervisor$$anon$2__f_cancel;
});
$c_Lcats_effect_std_Supervisor$$anon$2.prototype.join__O = (function() {
  return $n(this.Lcats_effect_std_Supervisor$$anon$2__f_resultR$15).get__O();
});
var $d_Lcats_effect_std_Supervisor$$anon$2 = new $TypeData().initClass($c_Lcats_effect_std_Supervisor$$anon$2, "cats.effect.std.Supervisor$$anon$2", ({
  Lcats_effect_std_Supervisor$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Fiber: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_ES2021FiberMonitor(compute) {
  this.Lcats_effect_unsafe_FiberMonitorShared__f_newline = null;
  this.Lcats_effect_unsafe_FiberMonitorShared__f_doubleNewline = null;
  this.Lcats_effect_unsafe_ES2021FiberMonitor__f_compute = null;
  this.Lcats_effect_unsafe_ES2021FiberMonitor__f_bag = null;
  this.Lcats_effect_unsafe_ES2021FiberMonitor__f_compute = compute;
  $ct_Lcats_effect_unsafe_FiberMonitorShared__(this);
  this.Lcats_effect_unsafe_ES2021FiberMonitor__f_bag = new $c_Lcats_effect_unsafe_WeakBag();
}
$c_Lcats_effect_unsafe_ES2021FiberMonitor.prototype = new $h_Lcats_effect_unsafe_FiberMonitor();
$c_Lcats_effect_unsafe_ES2021FiberMonitor.prototype.constructor = $c_Lcats_effect_unsafe_ES2021FiberMonitor;
/** @constructor */
function $h_Lcats_effect_unsafe_ES2021FiberMonitor() {
}
$h_Lcats_effect_unsafe_ES2021FiberMonitor.prototype = $c_Lcats_effect_unsafe_ES2021FiberMonitor.prototype;
$c_Lcats_effect_unsafe_ES2021FiberMonitor.prototype.monitorSuspended__Lcats_effect_IOFiber__Lcats_effect_unsafe_WeakBag$Handle = (function(fiber) {
  return $n(this.Lcats_effect_unsafe_ES2021FiberMonitor__f_bag).insert__O__Lcats_effect_unsafe_WeakBag$Handle(fiber);
});
$c_Lcats_effect_unsafe_ES2021FiberMonitor.prototype.foreignTraces__sci_Map = (function() {
  var foreign = $as_scm_Map($m_scm_Map$().empty__O());
  var this$1 = $n(this.Lcats_effect_unsafe_ES2021FiberMonitor__f_bag);
  var i = 0;
  var sz = this$1.Lcats_effect_unsafe_WeakBag__f_index;
  while ((i < sz)) {
    var a = $n($n(this$1.Lcats_effect_unsafe_WeakBag__f_table).get(i)).get__O();
    if ((a !== null)) {
      var fiber = $as_Lcats_effect_IOFiber(a);
      if ((!$n(fiber).isDone__Z())) {
        var this$4 = $n(foreign);
        var y = $n(fiber).captureTrace__Lcats_effect_Trace();
        var elem = new $c_T2(fiber, y);
        this$4.addOne__O__scm_Growable(elem);
      }
    }
    i = ((1 + i) | 0);
  }
  var this$6 = $n(foreign);
  var this$5 = $m_s_$less$colon$less$();
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$6);
});
$c_Lcats_effect_unsafe_ES2021FiberMonitor.prototype.liveFiberSnapshot__F1__V = (function(print) {
  var this$1 = $n($m_s_Option$().apply__O__s_Option(this.Lcats_effect_unsafe_ES2021FiberMonitor__f_compute));
  if ((!this$1.isEmpty__Z())) {
    var arg1 = this$1.get__O();
    var compute = $as_Lcats_effect_unsafe_BatchingMacrotaskExecutor(arg1);
    var queued = $n(compute).liveTraces__sci_Map();
    var rawForeign = this.foreignTraces__sci_Map();
    var this$3 = $n(rawForeign);
    var this$2 = $n(queued);
    var keys = this$2.keySet__sc_Set();
    var allForeign = $as_sci_Map(this$3.removedAll__sc_IterableOnce__sci_MapOps(keys));
    matchResult2: {
      var \u03b41$___1;
      var \u03b41$___2;
      var x4 = $n(allForeign).partition__F1__T2(new $c_sjsr_AnonFunction1(((x$1) => {
        var x$1$1 = $as_T2(x$1);
        if ((x$1$1 !== null)) {
          var f = $as_Lcats_effect_IOFiber($n(x$1$1)._1__O());
          return $n(f).ju_concurrent_atomic_AtomicBoolean__f_value;
        }
        throw new $c_s_MatchError(x$1$1);
      })));
      if ((x4 !== null)) {
        var suspended = $as_sci_Map($n(x4)._1__O());
        var foreign = $as_sci_Map($n(x4)._2__O());
        var \u03b41$___1 = suspended;
        var \u03b41$___2 = foreign;
        break matchResult2;
      }
      throw new $c_s_MatchError(x4);
    }
    var suspended$2 = $as_sci_Map(\u03b41$___1);
    var foreign$2 = $as_sci_Map(\u03b41$___2);
    this.printFibers__sci_Map__T__F1__V(queued, "YIELDING", print);
    this.printFibers__sci_Map__T__F1__V(foreign$2, "YIELDING", print);
    this.printFibers__sci_Map__T__F1__V(suspended$2, "WAITING", print);
    var globalStatus = ((("Global: enqueued " + (($n(queued).size__I() + $n(foreign$2).size__I()) | 0)) + ", waiting ") + $n(suspended$2).size__I());
    $n(print).apply__O__O(this.Lcats_effect_unsafe_FiberMonitorShared__f_doubleNewline);
    $n(print).apply__O__O(globalStatus);
    $n(print).apply__O__O(this.Lcats_effect_unsafe_FiberMonitorShared__f_newline);
  }
});
var $d_Lcats_effect_unsafe_ES2021FiberMonitor = new $TypeData().initClass($c_Lcats_effect_unsafe_ES2021FiberMonitor, "cats.effect.unsafe.ES2021FiberMonitor", ({
  Lcats_effect_unsafe_ES2021FiberMonitor: 1,
  Lcats_effect_unsafe_FiberMonitor: 1,
  Lcats_effect_unsafe_FiberMonitorShared: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_NoOpFiberMonitor() {
  this.Lcats_effect_unsafe_FiberMonitorShared__f_newline = null;
  this.Lcats_effect_unsafe_FiberMonitorShared__f_doubleNewline = null;
  $ct_Lcats_effect_unsafe_FiberMonitorShared__(this);
}
$c_Lcats_effect_unsafe_NoOpFiberMonitor.prototype = new $h_Lcats_effect_unsafe_FiberMonitor();
$c_Lcats_effect_unsafe_NoOpFiberMonitor.prototype.constructor = $c_Lcats_effect_unsafe_NoOpFiberMonitor;
/** @constructor */
function $h_Lcats_effect_unsafe_NoOpFiberMonitor() {
}
$h_Lcats_effect_unsafe_NoOpFiberMonitor.prototype = $c_Lcats_effect_unsafe_NoOpFiberMonitor.prototype;
$c_Lcats_effect_unsafe_NoOpFiberMonitor.prototype.monitorSuspended__Lcats_effect_IOFiber__Lcats_effect_unsafe_WeakBag$Handle = (function(fiber) {
  return new $c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1(this);
});
$c_Lcats_effect_unsafe_NoOpFiberMonitor.prototype.liveFiberSnapshot__F1__V = (function(print) {
});
var $d_Lcats_effect_unsafe_NoOpFiberMonitor = new $TypeData().initClass($c_Lcats_effect_unsafe_NoOpFiberMonitor, "cats.effect.unsafe.NoOpFiberMonitor", ({
  Lcats_effect_unsafe_NoOpFiberMonitor: 1,
  Lcats_effect_unsafe_FiberMonitor: 1,
  Lcats_effect_unsafe_FiberMonitorShared: 1
}));
/** @constructor */
function $c_Lcats_evidence_As$() {
  this.Lcats_evidence_As$__f_reflAny = null;
  $ct_Lcats_evidence_AsInstances__(this);
  $n_Lcats_evidence_As$ = this;
  this.Lcats_evidence_As$__f_reflAny = new $c_Lcats_evidence_As$$anon$2();
}
$c_Lcats_evidence_As$.prototype = new $h_Lcats_evidence_AsInstances();
$c_Lcats_evidence_As$.prototype.constructor = $c_Lcats_evidence_As$;
/** @constructor */
function $h_Lcats_evidence_As$() {
}
$h_Lcats_evidence_As$.prototype = $c_Lcats_evidence_As$.prototype;
$c_Lcats_evidence_As$.prototype.witness__Lcats_evidence_As__F1 = (function(lt) {
  $n(lt);
  var fa = new $c_sjsr_AnonFunction1(((x) => x));
  return fa;
});
var $d_Lcats_evidence_As$ = new $TypeData().initClass($c_Lcats_evidence_As$, "cats.evidence.As$", ({
  Lcats_evidence_As$: 1,
  Lcats_evidence_AsInstances: 1,
  Lcats_evidence_AsSupport: 1
}));
var $n_Lcats_evidence_As$;
function $m_Lcats_evidence_As$() {
  if ((!$n_Lcats_evidence_As$)) {
    $n_Lcats_evidence_As$ = new $c_Lcats_evidence_As$();
  }
  return $n_Lcats_evidence_As$;
}
/** @constructor */
function $c_Lcats_evidence_As$$anon$2() {
}
$c_Lcats_evidence_As$$anon$2.prototype = new $h_Lcats_evidence_As();
$c_Lcats_evidence_As$$anon$2.prototype.constructor = $c_Lcats_evidence_As$$anon$2;
/** @constructor */
function $h_Lcats_evidence_As$$anon$2() {
}
$h_Lcats_evidence_As$$anon$2.prototype = $c_Lcats_evidence_As$$anon$2.prototype;
var $d_Lcats_evidence_As$$anon$2 = new $TypeData().initClass($c_Lcats_evidence_As$$anon$2, "cats.evidence.As$$anon$2", ({
  Lcats_evidence_As$$anon$2: 1,
  Lcats_evidence_As: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_instances_EitherInstances$$anon$6() {
}
$c_Lcats_instances_EitherInstances$$anon$6.prototype = new $h_O();
$c_Lcats_instances_EitherInstances$$anon$6.prototype.constructor = $c_Lcats_instances_EitherInstances$$anon$6;
/** @constructor */
function $h_Lcats_instances_EitherInstances$$anon$6() {
}
$h_Lcats_instances_EitherInstances$$anon$6.prototype = $c_Lcats_instances_EitherInstances$$anon$6.prototype;
$c_Lcats_instances_EitherInstances$$anon$6.prototype.apply__O__O = (function(fa) {
  var a = $as_Lcats_data_Validated(fa);
  return $n(a).toEither__s_util_Either();
});
var $d_Lcats_instances_EitherInstances$$anon$6 = new $TypeData().initClass($c_Lcats_instances_EitherInstances$$anon$6, "cats.instances.EitherInstances$$anon$6", ({
  Lcats_instances_EitherInstances$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
/** @constructor */
function $c_Lcats_instances_EitherInstances$$anon$7() {
}
$c_Lcats_instances_EitherInstances$$anon$7.prototype = new $h_O();
$c_Lcats_instances_EitherInstances$$anon$7.prototype.constructor = $c_Lcats_instances_EitherInstances$$anon$7;
/** @constructor */
function $h_Lcats_instances_EitherInstances$$anon$7() {
}
$h_Lcats_instances_EitherInstances$$anon$7.prototype = $c_Lcats_instances_EitherInstances$$anon$7.prototype;
$c_Lcats_instances_EitherInstances$$anon$7.prototype.apply__s_util_Either__Lcats_data_Validated = (function(a) {
  return $m_Lcats_syntax_EitherOps$().toValidated$extension__s_util_Either__Lcats_data_Validated(a);
});
$c_Lcats_instances_EitherInstances$$anon$7.prototype.apply__O__O = (function(fa) {
  return this.apply__s_util_Either__Lcats_data_Validated($as_s_util_Either(fa));
});
var $d_Lcats_instances_EitherInstances$$anon$7 = new $TypeData().initClass($c_Lcats_instances_EitherInstances$$anon$7, "cats.instances.EitherInstances$$anon$7", ({
  Lcats_instances_EitherInstances$$anon$7: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
/** @constructor */
function $c_Lcats_instances_EqInstances$$anon$2(fa$6, fb$3, outer) {
  this.Lcats_instances_EqInstances$$anon$2__f_fa$4 = null;
  this.Lcats_instances_EqInstances$$anon$2__f_fb$2 = null;
  this.Lcats_instances_EqInstances$$anon$2__f_fa$4 = fa$6;
  this.Lcats_instances_EqInstances$$anon$2__f_fb$2 = fb$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_instances_EqInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_EqInstances$$anon$2.prototype.constructor = $c_Lcats_instances_EqInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_EqInstances$$anon$2() {
}
$h_Lcats_instances_EqInstances$$anon$2.prototype = $c_Lcats_instances_EqInstances$$anon$2.prototype;
$c_Lcats_instances_EqInstances$$anon$2.prototype.eqv__T2__T2__Z = (function(left, right) {
  var fa$1 = this.Lcats_instances_EqInstances$$anon$2__f_fa$4;
  var fb$1 = this.Lcats_instances_EqInstances$$anon$2__f_fb$2;
  return ($n(fa$1).eqv__O__O__Z($n(left)._1__O(), $n(right)._1__O()) && $n(fb$1).eqv__O__O__Z($n(left)._2__O(), $n(right)._2__O()));
});
$c_Lcats_instances_EqInstances$$anon$2.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__T2__T2__Z($as_T2(x), $as_T2(y));
});
var $d_Lcats_instances_EqInstances$$anon$2 = new $TypeData().initClass($c_Lcats_instances_EqInstances$$anon$2, "cats.instances.EqInstances$$anon$2", ({
  Lcats_instances_EqInstances$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1
}));
/** @constructor */
function $c_Lcats_instances_EquivInstances$$anon$3(fa$5, f$2) {
}
$c_Lcats_instances_EquivInstances$$anon$3.prototype = new $h_O();
$c_Lcats_instances_EquivInstances$$anon$3.prototype.constructor = $c_Lcats_instances_EquivInstances$$anon$3;
/** @constructor */
function $h_Lcats_instances_EquivInstances$$anon$3() {
}
$h_Lcats_instances_EquivInstances$$anon$3.prototype = $c_Lcats_instances_EquivInstances$$anon$3.prototype;
var $d_Lcats_instances_EquivInstances$$anon$3 = new $TypeData().initClass($c_Lcats_instances_EquivInstances$$anon$3, "cats.instances.EquivInstances$$anon$3", ({
  Lcats_instances_EquivInstances$$anon$3: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1
}));
/** @constructor */
function $c_Lcats_instances_EquivInstances$$anon$4(fa$6, fb$2) {
}
$c_Lcats_instances_EquivInstances$$anon$4.prototype = new $h_O();
$c_Lcats_instances_EquivInstances$$anon$4.prototype.constructor = $c_Lcats_instances_EquivInstances$$anon$4;
/** @constructor */
function $h_Lcats_instances_EquivInstances$$anon$4() {
}
$h_Lcats_instances_EquivInstances$$anon$4.prototype = $c_Lcats_instances_EquivInstances$$anon$4.prototype;
var $d_Lcats_instances_EquivInstances$$anon$4 = new $TypeData().initClass($c_Lcats_instances_EquivInstances$$anon$4, "cats.instances.EquivInstances$$anon$4", ({
  Lcats_instances_EquivInstances$$anon$4: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1
}));
/** @constructor */
function $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1() {
  new $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$(this);
}
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1.prototype = new $h_O();
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1.prototype.constructor = $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1;
/** @constructor */
function $h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1() {
}
$h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1.prototype = $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1.prototype;
var $d_Lcats_instances_FunctionInstancesBinCompat0$$anon$1 = new $TypeData().initClass($c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1, "cats.instances.FunctionInstancesBinCompat0$$anon$1", ({
  Lcats_instances_FunctionInstancesBinCompat0$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Defer: 1
}));
/** @constructor */
function $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype = new $h_O();
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype.constructor = $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$;
/** @constructor */
function $h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$() {
}
$h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype = $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype;
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype.toString__T = (function() {
  return "Deferred";
});
var $d_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$ = new $TypeData().initClass($c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$, "cats.instances.FunctionInstancesBinCompat0$$anon$1$Deferred$", ({
  Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Lcats_instances_InvariantInstances$$anon$10() {
}
$c_Lcats_instances_InvariantInstances$$anon$10.prototype = new $h_O();
$c_Lcats_instances_InvariantInstances$$anon$10.prototype.constructor = $c_Lcats_instances_InvariantInstances$$anon$10;
/** @constructor */
function $h_Lcats_instances_InvariantInstances$$anon$10() {
}
$h_Lcats_instances_InvariantInstances$$anon$10.prototype = $c_Lcats_instances_InvariantInstances$$anon$10.prototype;
$c_Lcats_instances_InvariantInstances$$anon$10.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_s_math_Numeric(fa);
  return new $c_Lcats_instances_InvariantInstances$$anon$11(fa$1, f, g);
});
var $d_Lcats_instances_InvariantInstances$$anon$10 = new $TypeData().initClass($c_Lcats_instances_InvariantInstances$$anon$10, "cats.instances.InvariantInstances$$anon$10", ({
  Lcats_instances_InvariantInstances$$anon$10: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
}));
/** @constructor */
function $c_Lcats_instances_InvariantInstances$$anon$12() {
}
$c_Lcats_instances_InvariantInstances$$anon$12.prototype = new $h_O();
$c_Lcats_instances_InvariantInstances$$anon$12.prototype.constructor = $c_Lcats_instances_InvariantInstances$$anon$12;
/** @constructor */
function $h_Lcats_instances_InvariantInstances$$anon$12() {
}
$h_Lcats_instances_InvariantInstances$$anon$12.prototype = $c_Lcats_instances_InvariantInstances$$anon$12.prototype;
$c_Lcats_instances_InvariantInstances$$anon$12.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_s_math_Integral(fa);
  return new $c_Lcats_instances_InvariantInstances$$anon$13(fa$1, f, g);
});
var $d_Lcats_instances_InvariantInstances$$anon$12 = new $TypeData().initClass($c_Lcats_instances_InvariantInstances$$anon$12, "cats.instances.InvariantInstances$$anon$12", ({
  Lcats_instances_InvariantInstances$$anon$12: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
}));
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$2(fa$18, fb$7, outer) {
  this.Lcats_instances_InvariantMonoidalInstances$$anon$2__f_fa$13 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$2__f_fb$5 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$2__f_fa$13 = fa$18;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$2__f_fb$5 = fb$7;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$2() {
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  return $f_Lcats_kernel_Semigroup__combineAllOption__sc_IterableOnce__s_Option(this, as);
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype.combine__T2__T2__T2 = (function(x, y) {
  var fa$1 = this.Lcats_instances_InvariantMonoidalInstances$$anon$2__f_fa$13;
  var fb$1 = this.Lcats_instances_InvariantMonoidalInstances$$anon$2__f_fb$5;
  var self = $n(fa$1).combine__O__O__O($n(x)._1__O(), $n(y)._1__O());
  var y$1 = $n(fb$1).combine__O__O__O($n(x)._2__O(), $n(y)._2__O());
  return new $c_T2(self, y$1);
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__T2__T2__T2($as_T2(x), $as_T2(y));
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$2 = new $TypeData().initClass($c_Lcats_instances_InvariantMonoidalInstances$$anon$2, "cats.instances.InvariantMonoidalInstances$$anon$2", ({
  Lcats_instances_InvariantMonoidalInstances$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1
}));
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$3(f$12, fa$19, g$12, outer) {
  this.Lcats_instances_InvariantMonoidalInstances$$anon$3__f_f$9 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$3__f_fa$14 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$3__f_g$9 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$3__f_f$9 = f$12;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$3__f_fa$14 = fa$19;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$3__f_g$9 = g$12;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$3;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$3() {
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  return $f_Lcats_kernel_Semigroup__combineAllOption__sc_IterableOnce__s_Option(this, as);
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype.combine__O__O__O = (function(x, y) {
  var f$1 = this.Lcats_instances_InvariantMonoidalInstances$$anon$3__f_f$9;
  var fa$2 = this.Lcats_instances_InvariantMonoidalInstances$$anon$3__f_fa$14;
  var g$1 = this.Lcats_instances_InvariantMonoidalInstances$$anon$3__f_g$9;
  return $n(f$1).apply__O__O($n(fa$2).combine__O__O__O($n(g$1).apply__O__O(x), $n(g$1).apply__O__O(y)));
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$3 = new $TypeData().initClass($c_Lcats_instances_InvariantMonoidalInstances$$anon$3, "cats.instances.InvariantMonoidalInstances$$anon$3", ({
  Lcats_instances_InvariantMonoidalInstances$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1
}));
/** @constructor */
function $c_Lcats_instances_NTupleBifunctorInstances$$anon$1(bim$2) {
  this.Lcats_instances_NTupleBifunctorInstances$$anon$1__f_bim$1 = null;
  this.Lcats_instances_NTupleBifunctorInstances$$anon$1__f_bim$1 = bim$2;
}
$c_Lcats_instances_NTupleBifunctorInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_NTupleBifunctorInstances$$anon$1.prototype.constructor = $c_Lcats_instances_NTupleBifunctorInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_NTupleBifunctorInstances$$anon$1() {
}
$h_Lcats_instances_NTupleBifunctorInstances$$anon$1.prototype = $c_Lcats_instances_NTupleBifunctorInstances$$anon$1.prototype;
$c_Lcats_instances_NTupleBifunctorInstances$$anon$1.prototype.bimap__O__F1__F1__O = (function(fab, f, g) {
  return $n(this.Lcats_instances_NTupleBifunctorInstances$$anon$1__f_bim$1).apply__O__O__O__O(fab, f, g);
});
var $d_Lcats_instances_NTupleBifunctorInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_NTupleBifunctorInstances$$anon$1, "cats.instances.NTupleBifunctorInstances$$anon$1", ({
  Lcats_instances_NTupleBifunctorInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Bifunctor: 1
}));
/** @constructor */
function $c_Lcats_instances_package$string$() {
  this.Lcats_instances_package$string$__f_catsStdShowForString = null;
  $n_Lcats_instances_package$string$ = this;
  $f_Lcats_kernel_instances_StringInstances__$init$__V(this);
  var this$1 = $m_Lcats_Show$();
  this.Lcats_instances_package$string$__f_catsStdShowForString = new $c_Lcats_Show$$anon$5(this$1);
}
$c_Lcats_instances_package$string$.prototype = new $h_O();
$c_Lcats_instances_package$string$.prototype.constructor = $c_Lcats_instances_package$string$;
/** @constructor */
function $h_Lcats_instances_package$string$() {
}
$h_Lcats_instances_package$string$.prototype = $c_Lcats_instances_package$string$.prototype;
$c_Lcats_instances_package$string$.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdOrderForString_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_package$string$.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdMonoidForString_$eq__Lcats_kernel_Monoid__V = (function(x$0) {
});
var $d_Lcats_instances_package$string$ = new $TypeData().initClass($c_Lcats_instances_package$string$, "cats.instances.package$string$", ({
  Lcats_instances_package$string$: 1,
  Lcats_kernel_instances_StringInstances: 1,
  Lcats_instances_StringInstances: 1
}));
var $n_Lcats_instances_package$string$;
function $m_Lcats_instances_package$string$() {
  if ((!$n_Lcats_instances_package$string$)) {
    $n_Lcats_instances_package$string$ = new $c_Lcats_instances_package$string$();
  }
  return $n_Lcats_instances_package$string$;
}
function $is_Lcats_kernel_CommutativeSemigroup(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_CommutativeSemigroup)));
}
function $as_Lcats_kernel_CommutativeSemigroup(obj) {
  return (($is_Lcats_kernel_CommutativeSemigroup(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.CommutativeSemigroup"));
}
function $isArrayOf_Lcats_kernel_CommutativeSemigroup(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_CommutativeSemigroup)));
}
function $asArrayOf_Lcats_kernel_CommutativeSemigroup(obj, depth) {
  return (($isArrayOf_Lcats_kernel_CommutativeSemigroup(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.CommutativeSemigroup;", depth));
}
/** @constructor */
function $c_Lcats_kernel_Comparison$() {
}
$c_Lcats_kernel_Comparison$.prototype = new $h_O();
$c_Lcats_kernel_Comparison$.prototype.constructor = $c_Lcats_kernel_Comparison$;
/** @constructor */
function $h_Lcats_kernel_Comparison$() {
}
$h_Lcats_kernel_Comparison$.prototype = $c_Lcats_kernel_Comparison$.prototype;
var $d_Lcats_kernel_Comparison$ = new $TypeData().initClass($c_Lcats_kernel_Comparison$, "cats.kernel.Comparison$", ({
  Lcats_kernel_Comparison$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Lcats_kernel_Comparison$;
function $m_Lcats_kernel_Comparison$() {
  if ((!$n_Lcats_kernel_Comparison$)) {
    $n_Lcats_kernel_Comparison$ = new $c_Lcats_kernel_Comparison$();
  }
  return $n_Lcats_kernel_Comparison$;
}
/** @constructor */
function $c_Lcats_kernel_Eq$$anon$2(ev$6, f$5, outer) {
  this.Lcats_kernel_Eq$$anon$2__f_ev$4 = null;
  this.Lcats_kernel_Eq$$anon$2__f_f$3 = null;
  this.Lcats_kernel_Eq$$anon$2__f_ev$4 = ev$6;
  this.Lcats_kernel_Eq$$anon$2__f_f$3 = f$5;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_kernel_Eq$$anon$2.prototype = new $h_O();
$c_Lcats_kernel_Eq$$anon$2.prototype.constructor = $c_Lcats_kernel_Eq$$anon$2;
/** @constructor */
function $h_Lcats_kernel_Eq$$anon$2() {
}
$h_Lcats_kernel_Eq$$anon$2.prototype = $c_Lcats_kernel_Eq$$anon$2.prototype;
$c_Lcats_kernel_Eq$$anon$2.prototype.eqv__O__O__Z = (function(x, y) {
  var ev$2 = this.Lcats_kernel_Eq$$anon$2__f_ev$4;
  var f$1 = this.Lcats_kernel_Eq$$anon$2__f_f$3;
  return $n(ev$2).eqv__O__O__Z($n(f$1).apply__O__O(x), $n(f$1).apply__O__O(y));
});
var $d_Lcats_kernel_Eq$$anon$2 = new $TypeData().initClass($c_Lcats_kernel_Eq$$anon$2, "cats.kernel.Eq$$anon$2", ({
  Lcats_kernel_Eq$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1
}));
/** @constructor */
function $c_Lcats_kernel_Eq$$anon$6(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_kernel_Eq$$anon$6.prototype = new $h_O();
$c_Lcats_kernel_Eq$$anon$6.prototype.constructor = $c_Lcats_kernel_Eq$$anon$6;
/** @constructor */
function $h_Lcats_kernel_Eq$$anon$6() {
}
$h_Lcats_kernel_Eq$$anon$6.prototype = $c_Lcats_kernel_Eq$$anon$6.prototype;
$c_Lcats_kernel_Eq$$anon$6.prototype.eqv__O__O__Z = (function(_$5, _$6) {
  return $m_sr_BoxesRunTime$().equals__O__O__Z(_$5, _$6);
});
var $d_Lcats_kernel_Eq$$anon$6 = new $TypeData().initClass($c_Lcats_kernel_Eq$$anon$6, "cats.kernel.Eq$$anon$6", ({
  Lcats_kernel_Eq$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1
}));
function $is_Lcats_kernel_Hash(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_Hash)));
}
function $as_Lcats_kernel_Hash(obj) {
  return (($is_Lcats_kernel_Hash(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.Hash"));
}
function $isArrayOf_Lcats_kernel_Hash(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_Hash)));
}
function $asArrayOf_Lcats_kernel_Hash(obj, depth) {
  return (($isArrayOf_Lcats_kernel_Hash(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.Hash;", depth));
}
/** @constructor */
function $c_Lcats_kernel_Hash$() {
}
$c_Lcats_kernel_Hash$.prototype = new $h_Lcats_kernel_HashFunctions();
$c_Lcats_kernel_Hash$.prototype.constructor = $c_Lcats_kernel_Hash$;
/** @constructor */
function $h_Lcats_kernel_Hash$() {
}
$h_Lcats_kernel_Hash$.prototype = $c_Lcats_kernel_Hash$.prototype;
var $d_Lcats_kernel_Hash$ = new $TypeData().initClass($c_Lcats_kernel_Hash$, "cats.kernel.Hash$", ({
  Lcats_kernel_Hash$: 1,
  Lcats_kernel_HashFunctions: 1,
  Lcats_kernel_EqFunctions: 1
}));
var $n_Lcats_kernel_Hash$;
function $m_Lcats_kernel_Hash$() {
  if ((!$n_Lcats_kernel_Hash$)) {
    $n_Lcats_kernel_Hash$ = new $c_Lcats_kernel_Hash$();
  }
  return $n_Lcats_kernel_Hash$;
}
function $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O($thiz, as) {
  var this$2 = $n($n(as).iterator__sc_Iterator());
  var z = $thiz.empty__O();
  var f = ((x, y) => $thiz.combine__O__O__O(x, y));
  if ($is_sc_IndexedSeq(this$2)) {
    var x2 = $as_sc_IndexedSeq(this$2);
    var at = 0;
    var end = $n(x2).length__I();
    var acc = z;
    while (true) {
      if ((at === end)) {
        return acc;
      } else {
        var temp$at = ((1 + at) | 0);
        var arg1 = acc;
        var arg2 = $n(x2).apply__I__O(at);
        var temp$acc = f(arg1, arg2);
        at = temp$at;
        acc = temp$acc;
      }
    }
  } else {
    var result = z;
    while (this$2.hasNext__Z()) {
      var arg1$1 = result;
      var arg2$1 = this$2.next__O();
      result = f(arg1$1, arg2$1);
    }
    return result;
  }
}
function $f_Lcats_kernel_Monoid__combineAllOption__sc_IterableOnce__s_Option($thiz, as) {
  var this$1 = $n($n(as).iterator__sc_Iterator());
  if ((!this$1.hasNext__Z())) {
    return $m_s_None$();
  } else {
    var value = $thiz.combineAll__sc_IterableOnce__O(as);
    return new $c_s_Some(value);
  }
}
/** @constructor */
function $c_Lcats_kernel_OrderFunctions() {
}
$c_Lcats_kernel_OrderFunctions.prototype = new $h_Lcats_kernel_PartialOrderFunctions();
$c_Lcats_kernel_OrderFunctions.prototype.constructor = $c_Lcats_kernel_OrderFunctions;
/** @constructor */
function $h_Lcats_kernel_OrderFunctions() {
}
$h_Lcats_kernel_OrderFunctions.prototype = $c_Lcats_kernel_OrderFunctions.prototype;
function $f_Lcats_kernel_PartialOrder__eqv__O__O__Z($thiz, x, y) {
  return ($thiz.partialCompare__O__O__D(x, y) === 0.0);
}
function $is_Lcats_kernel_PartialOrder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_PartialOrder)));
}
function $as_Lcats_kernel_PartialOrder(obj) {
  return (($is_Lcats_kernel_PartialOrder(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.PartialOrder"));
}
function $isArrayOf_Lcats_kernel_PartialOrder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_PartialOrder)));
}
function $asArrayOf_Lcats_kernel_PartialOrder(obj, depth) {
  return (($isArrayOf_Lcats_kernel_PartialOrder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.PartialOrder;", depth));
}
/** @constructor */
function $c_Lcats_package$$anon$2() {
  $m_Lcats_package$();
}
$c_Lcats_package$$anon$2.prototype = new $h_O();
$c_Lcats_package$$anon$2.prototype.constructor = $c_Lcats_package$$anon$2;
/** @constructor */
function $h_Lcats_package$$anon$2() {
}
$h_Lcats_package$$anon$2.prototype = $c_Lcats_package$$anon$2.prototype;
var $d_Lcats_package$$anon$2 = new $TypeData().initClass($c_Lcats_package$$anon$2, "cats.package$$anon$2", ({
  Lcats_package$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_Representable: 1
}));
/** @constructor */
function $c_Lcats_package$$anon$3() {
  $m_Lcats_package$();
}
$c_Lcats_package$$anon$3.prototype = new $h_O();
$c_Lcats_package$$anon$3.prototype.constructor = $c_Lcats_package$$anon$3;
/** @constructor */
function $h_Lcats_package$$anon$3() {
}
$h_Lcats_package$$anon$3.prototype = $c_Lcats_package$$anon$3.prototype;
var $d_Lcats_package$$anon$3 = new $TypeData().initClass($c_Lcats_package$$anon$3, "cats.package$$anon$3", ({
  Lcats_package$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_Align: 1
}));
/** @constructor */
function $c_Lcats_syntax_ApplySyntax$$anon$1(fa$1, F$1) {
  this.Lcats_syntax_ApplySyntax$$anon$1__f_self = null;
  this.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance = null;
  this.Lcats_syntax_ApplySyntax$$anon$1__f_self = fa$1;
  this.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance = F$1;
}
$c_Lcats_syntax_ApplySyntax$$anon$1.prototype = new $h_O();
$c_Lcats_syntax_ApplySyntax$$anon$1.prototype.constructor = $c_Lcats_syntax_ApplySyntax$$anon$1;
/** @constructor */
function $h_Lcats_syntax_ApplySyntax$$anon$1() {
}
$h_Lcats_syntax_ApplySyntax$$anon$1.prototype = $c_Lcats_syntax_ApplySyntax$$anon$1.prototype;
var $d_Lcats_syntax_ApplySyntax$$anon$1 = new $TypeData().initClass($c_Lcats_syntax_ApplySyntax$$anon$1, "cats.syntax.ApplySyntax$$anon$1", ({
  Lcats_syntax_ApplySyntax$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Apply$Ops: 1
}));
/** @constructor */
function $c_Lcats_syntax_SemigroupalOps() {
}
$c_Lcats_syntax_SemigroupalOps.prototype = new $h_O();
$c_Lcats_syntax_SemigroupalOps.prototype.constructor = $c_Lcats_syntax_SemigroupalOps;
/** @constructor */
function $h_Lcats_syntax_SemigroupalOps() {
}
$h_Lcats_syntax_SemigroupalOps.prototype = $c_Lcats_syntax_SemigroupalOps.prototype;
/** @constructor */
function $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model$(outer) {
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model$__f_$outer = outer;
}
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model$.prototype = new $h_O();
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model$.prototype.constructor = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model$;
/** @constructor */
function $h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model$() {
}
$h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model$.prototype = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model$.prototype;
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model$.prototype.apply__T__s_Option__sci_List__s_Option__s_Option__Ldev_sungkm_enchantedrealm_EnchantedRealm$Model = (function(text, systemMessage, userChoices, engine, engineResponseStream) {
  return new $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model$__f_$outer, text, systemMessage, userChoices, engine, engineResponseStream);
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model$.prototype.init__Ldev_sungkm_enchantedrealm_EnchantedRealm$Model = (function() {
  return this.apply__T__s_Option__sci_List__s_Option__s_Option__Ldev_sungkm_enchantedrealm_EnchantedRealm$Model("", $m_s_None$(), $m_sci_Nil$(), $m_s_None$(), $m_s_None$());
});
var $d_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model$ = new $TypeData().initClass($c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model$, "dev.sungkm.enchantedrealm.EnchantedRealm$Model$", ({
  Ldev_sungkm_enchantedrealm_EnchantedRealm$Model$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$(outer) {
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_NoOp = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_SystemMessage$lzy1 = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_FinishInit$lzy1 = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_SubscribeEngineResponse$lzy1 = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_EngineResponse$lzy1 = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_FinishEngineResponse = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_$outer = outer;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_SystemMessage$lzy1 = new $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage$(this);
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_FinishInit$lzy1 = new $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit$(this);
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_SubscribeEngineResponse$lzy1 = new $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse$(this);
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_EngineResponse$lzy1 = new $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse$(this);
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_NoOp = new $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$2(this);
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_FinishEngineResponse = new $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$3(this);
}
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$.prototype = new $h_O();
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$.prototype.constructor = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$;
/** @constructor */
function $h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$() {
}
$h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$.prototype = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$.prototype;
var $d_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$ = new $TypeData().initClass($c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$, "dev.sungkm.enchantedrealm.EnchantedRealm$Msg$", ({
  Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
/** @constructor */
function $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse$(outer) {
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse$__f_$outer = outer;
}
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse$.prototype = new $h_O();
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse$.prototype.constructor = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse$;
/** @constructor */
function $h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse$() {
}
$h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse$.prototype = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse$.prototype;
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse$.prototype.apply__T__Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse = (function(response) {
  return new $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse$__f_$outer, response);
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse$.prototype.toString__T = (function() {
  return "EngineResponse";
});
var $d_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse$ = new $TypeData().initClass($c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse$, "dev.sungkm.enchantedrealm.EnchantedRealm$Msg$EngineResponse$", ({
  Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit$(outer) {
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit$__f_$outer = outer;
}
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit$.prototype = new $h_O();
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit$.prototype.constructor = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit$;
/** @constructor */
function $h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit$() {
}
$h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit$.prototype = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit$.prototype;
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit$.prototype.apply__Ltypings_mlcAiWebLlm_libServiceWorkerMod$ServiceWorkerMLCEngine__Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit = (function(engine) {
  return new $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit$__f_$outer, engine);
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit$.prototype.toString__T = (function() {
  return "FinishInit";
});
var $d_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit$ = new $TypeData().initClass($c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit$, "dev.sungkm.enchantedrealm.EnchantedRealm$Msg$FinishInit$", ({
  Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse$(outer) {
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse$__f_$outer = outer;
}
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse$.prototype = new $h_O();
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse$.prototype.constructor = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse$;
/** @constructor */
function $h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse$() {
}
$h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse$.prototype = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse$.prototype;
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse$.prototype.apply__Lfs2_Stream__Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse = (function(stream) {
  return new $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse$__f_$outer, stream);
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse$.prototype.toString__T = (function() {
  return "SubscribeEngineResponse";
});
var $d_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse$ = new $TypeData().initClass($c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse$, "dev.sungkm.enchantedrealm.EnchantedRealm$Msg$SubscribeEngineResponse$", ({
  Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage$(outer) {
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage$__f_$outer = outer;
}
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage$.prototype = new $h_O();
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage$.prototype.constructor = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage$;
/** @constructor */
function $h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage$() {
}
$h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage$.prototype = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage$.prototype;
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage$.prototype.apply__T__Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage = (function(msg) {
  return new $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage$__f_$outer, msg);
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage$.prototype.toString__T = (function() {
  return "SystemMessage";
});
var $d_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage$ = new $TypeData().initClass($c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage$, "dev.sungkm.enchantedrealm.EnchantedRealm$Msg$SystemMessage$", ({
  Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
function $p_Lfs2_CompositeFailure$__flattenExceptions$1__jl_Throwable__Lcats_data_NonEmptyList($thiz, throwable) {
  if ((throwable instanceof $c_Lfs2_CompositeFailure)) {
    var cf = $as_Lfs2_CompositeFailure(throwable);
    var this$1 = $n(cf);
    var this$2 = $n(this$1.Lfs2_CompositeFailure__f_tail);
    var a = this$1.Lfs2_CompositeFailure__f_head;
    return this$2.prepend__O__Lcats_data_NonEmptyList(a);
  } else {
    $m_Lcats_data_NonEmptyList$();
    $m_Lcats_data_NonEmptyList$();
    var tail = $m_sci_Nil$();
    return new $c_Lcats_data_NonEmptyList(throwable, tail);
  }
}
/** @constructor */
function $c_Lfs2_CompositeFailure$() {
}
$c_Lfs2_CompositeFailure$.prototype = new $h_O();
$c_Lfs2_CompositeFailure$.prototype.constructor = $c_Lfs2_CompositeFailure$;
/** @constructor */
function $h_Lfs2_CompositeFailure$() {
}
$h_Lfs2_CompositeFailure$.prototype = $c_Lfs2_CompositeFailure$.prototype;
$c_Lfs2_CompositeFailure$.prototype.apply__jl_Throwable__jl_Throwable__sci_List__Lfs2_CompositeFailure = (function(first, second, rest) {
  return this.apply__jl_Throwable__Lcats_data_NonEmptyList__Lfs2_CompositeFailure(first, ($m_Lcats_data_NonEmptyList$(), new $c_Lcats_data_NonEmptyList(second, rest)));
});
$c_Lfs2_CompositeFailure$.prototype.apply__jl_Throwable__Lcats_data_NonEmptyList__Lfs2_CompositeFailure = (function(first, rest) {
  if ((first instanceof $c_Lfs2_CompositeFailure)) {
    var cf = $as_Lfs2_CompositeFailure(first);
    var this$2 = $n(rest);
    var f = ((throwable) => {
      var throwable$1 = $as_jl_Throwable(throwable);
      return $p_Lfs2_CompositeFailure$__flattenExceptions$1__jl_Throwable__Lcats_data_NonEmptyList(this, throwable$1);
    });
    var arg1 = this$2.Lcats_data_NonEmptyList__f_head;
    var this$7 = $n($as_Lcats_data_NonEmptyList(f(arg1)));
    var this$3 = $n(this$2.Lcats_data_NonEmptyList__f_tail);
    var rest$1 = this$3;
    var h = null;
    var t = null;
    while ((rest$1 !== $m_sci_Nil$())) {
      var arg1$1 = $n(rest$1).head__O();
      var this$4 = $n($as_Lcats_data_NonEmptyList(f(arg1$1)));
      var this$5 = $n(this$4.Lcats_data_NonEmptyList__f_tail);
      var elem = this$4.Lcats_data_NonEmptyList__f_head;
      var this$6 = new $c_sci_$colon$colon(elem, this$5);
      var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$6);
      while (it.hasNext__Z()) {
        var nx = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
        if ((t === null)) {
          h = nx;
        } else {
          $n(t).sci_$colon$colon__f_next = nx;
        }
        t = nx;
      }
      rest$1 = $as_sci_List($n(rest$1).tail__O());
    }
    var l = ((h === null) ? $m_sci_Nil$() : h);
    var this$8 = $n(this$7.concat__sci_List__Lcats_data_NonEmptyList(l));
    var other = $n(cf).Lfs2_CompositeFailure__f_tail;
    var tail = $n(other).concatNel__Lcats_data_NonEmptyList__Lcats_data_NonEmptyList(this$8);
    return new $c_Lfs2_CompositeFailure($n(cf).Lfs2_CompositeFailure__f_head, tail);
  } else {
    var this$9 = $n(rest);
    var f$1 = ((throwable$2) => {
      var throwable$3 = $as_jl_Throwable(throwable$2);
      return $p_Lfs2_CompositeFailure$__flattenExceptions$1__jl_Throwable__Lcats_data_NonEmptyList(this, throwable$3);
    });
    var arg1$2 = this$9.Lcats_data_NonEmptyList__f_head;
    var this$14 = $n($as_Lcats_data_NonEmptyList(f$1(arg1$2)));
    var this$10 = $n(this$9.Lcats_data_NonEmptyList__f_tail);
    var rest$2 = this$10;
    var h$1 = null;
    var t$1 = null;
    while ((rest$2 !== $m_sci_Nil$())) {
      var arg1$3 = $n(rest$2).head__O();
      var this$11 = $n($as_Lcats_data_NonEmptyList(f$1(arg1$3)));
      var this$12 = $n(this$11.Lcats_data_NonEmptyList__f_tail);
      var elem$1 = this$11.Lcats_data_NonEmptyList__f_head;
      var this$13 = new $c_sci_$colon$colon(elem$1, this$12);
      var it$1 = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$13);
      while (it$1.hasNext__Z()) {
        var nx$1 = new $c_sci_$colon$colon(it$1.next__O(), $m_sci_Nil$());
        if ((t$1 === null)) {
          h$1 = nx$1;
        } else {
          $n(t$1).sci_$colon$colon__f_next = nx$1;
        }
        t$1 = nx$1;
      }
      rest$2 = $as_sci_List($n(rest$2).tail__O());
    }
    var l$1 = ((h$1 === null) ? $m_sci_Nil$() : h$1);
    return new $c_Lfs2_CompositeFailure(first, this$14.concat__sci_List__Lcats_data_NonEmptyList(l$1));
  }
});
$c_Lfs2_CompositeFailure$.prototype.fromList__sci_List__s_Option = (function(errors) {
  var x = $m_sci_Nil$();
  if (x.equals__O__Z(errors)) {
    return $m_s_None$();
  }
  if ((errors instanceof $c_sci_$colon$colon)) {
    var x26 = $as_sci_$colon$colon(errors);
    var x27 = $as_jl_Throwable($n(x26).sci_$colon$colon__f_head);
    var x28 = $n(x26).sci_$colon$colon__f_next;
    var x$3 = $m_sci_Nil$();
    if (x$3.equals__O__Z(x28)) {
      return new $c_s_Some(x27);
    }
    if ((x28 instanceof $c_sci_$colon$colon)) {
      var x23 = $as_sci_$colon$colon(x28);
      var x25 = $n(x23).sci_$colon$colon__f_next;
      var second = $as_jl_Throwable($n(x23).sci_$colon$colon__f_head);
      var value = this.apply__jl_Throwable__jl_Throwable__sci_List__Lfs2_CompositeFailure(x27, second, x25);
      return new $c_s_Some(value);
    }
  }
  throw new $c_s_MatchError(errors);
});
$c_Lfs2_CompositeFailure$.prototype.fromResults__s_util_Either__s_util_Either__s_util_Either = (function(first, second) {
  if ((first instanceof $c_s_util_Right)) {
    return second;
  }
  if ((first instanceof $c_s_util_Left)) {
    var err = $as_jl_Throwable($n($as_s_util_Left(first)).s_util_Left__f_value);
    var this$1 = $n(second);
    if ((this$1 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$1);
      var b = $n(x2).s_util_Right__f_value;
      $as_jl_Void(b);
      var value = err;
    } else {
      if ((!(this$1 instanceof $c_s_util_Left))) {
        throw new $c_s_MatchError(this$1);
      }
      var x3 = $as_s_util_Left(this$1);
      var a = $n(x3).s_util_Left__f_value;
      var err1 = $as_jl_Throwable(a);
      var value = this.apply__jl_Throwable__jl_Throwable__sci_List__Lfs2_CompositeFailure(err, err1, $m_sci_Nil$());
    }
    return new $c_s_util_Left(value);
  }
  throw new $c_s_MatchError(first);
});
var $d_Lfs2_CompositeFailure$ = new $TypeData().initClass($c_Lfs2_CompositeFailure$, "fs2.CompositeFailure$", ({
  Lfs2_CompositeFailure$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Lfs2_CompositeFailure$;
function $m_Lfs2_CompositeFailure$() {
  if ((!$n_Lfs2_CompositeFailure$)) {
    $n_Lfs2_CompositeFailure$ = new $c_Lfs2_CompositeFailure$();
  }
  return $n_Lfs2_CompositeFailure$;
}
/** @constructor */
function $c_Lfs2_Pull$Action() {
}
$c_Lfs2_Pull$Action.prototype = new $h_Lfs2_Pull();
$c_Lfs2_Pull$Action.prototype.constructor = $c_Lfs2_Pull$Action;
/** @constructor */
function $h_Lfs2_Pull$Action() {
}
$h_Lfs2_Pull$Action.prototype = $c_Lfs2_Pull$Action.prototype;
function $as_Lfs2_Pull$Action(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Action) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Action"));
}
function $isArrayOf_Lfs2_Pull$Action(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Action)));
}
function $asArrayOf_Lfs2_Pull$Action(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Action(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Action;", depth));
}
/** @constructor */
function $c_Lfs2_Pull$IdContP$() {
}
$c_Lfs2_Pull$IdContP$.prototype = new $h_O();
$c_Lfs2_Pull$IdContP$.prototype.constructor = $c_Lfs2_Pull$IdContP$;
/** @constructor */
function $h_Lfs2_Pull$IdContP$() {
}
$h_Lfs2_Pull$IdContP$.prototype = $c_Lfs2_Pull$IdContP$.prototype;
$c_Lfs2_Pull$IdContP$.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_Lfs2_Pull$IdContP$.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_Lfs2_Pull$IdContP$.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Lfs2_Pull$IdContP$.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(r) {
  return r;
});
$c_Lfs2_Pull$IdContP$.prototype.apply__O__O = (function(v1) {
  var r = $as_Lfs2_Pull$Terminal(v1);
  return r;
});
$c_Lfs2_Pull$IdContP$.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  var r = $as_Lfs2_Pull$Terminal(v1);
  return $uZ(r);
});
var $d_Lfs2_Pull$IdContP$ = new $TypeData().initClass($c_Lfs2_Pull$IdContP$, "fs2.Pull$IdContP$", ({
  Lfs2_Pull$IdContP$: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
var $n_Lfs2_Pull$IdContP$;
function $m_Lfs2_Pull$IdContP$() {
  if ((!$n_Lfs2_Pull$IdContP$)) {
    $n_Lfs2_Pull$IdContP$ = new $c_Lfs2_Pull$IdContP$();
  }
  return $n_Lfs2_Pull$IdContP$;
}
/** @constructor */
function $c_Lfs2_Pull$IdOps$$anon$10(evidence$3$2, outer) {
  this.Lfs2_Pull$IdOps$$anon$10__f_evidence$3$1 = null;
  this.Lfs2_Pull$IdOps$$anon$10__f_evidence$3$1 = evidence$3$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lfs2_Pull$IdOps$$anon$10.prototype = new $h_O();
$c_Lfs2_Pull$IdOps$$anon$10.prototype.constructor = $c_Lfs2_Pull$IdOps$$anon$10;
/** @constructor */
function $h_Lfs2_Pull$IdOps$$anon$10() {
}
$h_Lfs2_Pull$IdOps$$anon$10.prototype = $c_Lfs2_Pull$IdOps$$anon$10.prototype;
$c_Lfs2_Pull$IdOps$$anon$10.prototype.apply__O__O = (function(a) {
  var F = this.Lfs2_Pull$IdOps$$anon$10__f_evidence$3$1;
  return $n(F).pure__O__O(a);
});
var $d_Lfs2_Pull$IdOps$$anon$10 = new $TypeData().initClass($c_Lfs2_Pull$IdOps$$anon$10, "fs2.Pull$IdOps$$anon$10", ({
  Lfs2_Pull$IdOps$$anon$10: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
/** @constructor */
function $c_Lfs2_Pull$StepLegRunR$1(extendLastTopLevelScope$39, F$52, contP$42, scope$38, extendedTopLevelScope$36, TheBuildR$lzy1$42, translation$tailLocal1$39, runner$tailLocal1$36, outer, view) {
  this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8 = false;
  this.Lfs2_Pull$StepRunR$1__f_F$17 = null;
  this.Lfs2_Pull$StepRunR$1__f_contP$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_scope$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_view = null;
  this.Lfs2_Pull$StepLegRunR$1__f_extendLastTopLevelScope$10 = false;
  this.Lfs2_Pull$StepLegRunR$1__f_F$19 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_contP$12 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_scope$11 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_extendedTopLevelScope$9 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_TheBuildR$lzy1$12 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_translation$tailLocal1$9 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_runner$tailLocal1$9 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_view = null;
  this.Lfs2_Pull$StepLegRunR$1__f_extendLastTopLevelScope$10 = extendLastTopLevelScope$39;
  this.Lfs2_Pull$StepLegRunR$1__f_F$19 = F$52;
  this.Lfs2_Pull$StepLegRunR$1__f_contP$12 = contP$42;
  this.Lfs2_Pull$StepLegRunR$1__f_scope$11 = scope$38;
  this.Lfs2_Pull$StepLegRunR$1__f_extendedTopLevelScope$9 = extendedTopLevelScope$36;
  this.Lfs2_Pull$StepLegRunR$1__f_TheBuildR$lzy1$12 = TheBuildR$lzy1$42;
  this.Lfs2_Pull$StepLegRunR$1__f_translation$tailLocal1$9 = translation$tailLocal1$39;
  this.Lfs2_Pull$StepLegRunR$1__f_runner$tailLocal1$9 = runner$tailLocal1$36;
  this.Lfs2_Pull$StepLegRunR$1__f_view = view;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Lfs2_Pull$StepRunR$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__F1__(this, extendLastTopLevelScope$39, F$52, contP$42, scope$38, extendedTopLevelScope$36, TheBuildR$lzy1$42, translation$tailLocal1$39, runner$tailLocal1$36, view);
}
$c_Lfs2_Pull$StepLegRunR$1.prototype = new $h_Lfs2_Pull$StepRunR$1();
$c_Lfs2_Pull$StepLegRunR$1.prototype.constructor = $c_Lfs2_Pull$StepLegRunR$1;
/** @constructor */
function $h_Lfs2_Pull$StepLegRunR$1() {
}
$h_Lfs2_Pull$StepLegRunR$1.prototype = $c_Lfs2_Pull$StepLegRunR$1.prototype;
$c_Lfs2_Pull$StepLegRunR$1.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, outScope, tail) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$interruptGuard$1__Z__Lcats_MonadError__sr_ObjectRef__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_internal_Scope__F1__F0__O(this.Lfs2_Pull$StepLegRunR$1__f_extendLastTopLevelScope$10, this.Lfs2_Pull$StepLegRunR$1__f_F$19, this.Lfs2_Pull$StepLegRunR$1__f_contP$12, this.Lfs2_Pull$StepLegRunR$1__f_extendedTopLevelScope$9, this.Lfs2_Pull$StepLegRunR$1__f_TheBuildR$lzy1$12, this.Lfs2_Pull$StepLegRunR$1__f_translation$tailLocal1$9, this.Lfs2_Pull$StepLegRunR$1__f_runner$tailLocal1$9, this.Lfs2_Pull$StepLegRunR$1__f_scope$11, this.Lfs2_Pull$StepLegRunR$1__f_view, new $c_sjsr_AnonFunction0((() => {
    var value = new $c_Lfs2_Stream$StepLeg(head, $n(outScope).Lfs2_internal_Scope__f_id, tail);
    var r = new $c_s_Some(value);
    var result = new $c_Lfs2_Pull$Succeeded(r);
    return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$StepLegRunR$1__f_extendLastTopLevelScope$10, this.Lfs2_Pull$StepLegRunR$1__f_F$19, this.Lfs2_Pull$StepLegRunR$1__f_contP$12, this.Lfs2_Pull$StepLegRunR$1__f_TheBuildR$lzy1$12, this.Lfs2_Pull$StepLegRunR$1__f_scope$11, this.Lfs2_Pull$StepLegRunR$1__f_extendedTopLevelScope$9, this.Lfs2_Pull$StepLegRunR$1__f_translation$tailLocal1$9, this.Lfs2_Pull$StepLegRunR$1__f_runner$tailLocal1$9, $as_Lfs2_Pull($n(this.Lfs2_Pull$StepLegRunR$1__f_view).apply__O__O(result)));
  })));
});
var $d_Lfs2_Pull$StepLegRunR$1 = new $TypeData().initClass($c_Lfs2_Pull$StepLegRunR$1, "fs2.Pull$StepLegRunR$1", ({
  Lfs2_Pull$StepLegRunR$1: 1,
  Lfs2_Pull$StepRunR$1: 1,
  Lfs2_Pull$Run$1: 1
}));
/** @constructor */
function $c_Lfs2_Pull$Terminal() {
}
$c_Lfs2_Pull$Terminal.prototype = new $h_Lfs2_Pull();
$c_Lfs2_Pull$Terminal.prototype.constructor = $c_Lfs2_Pull$Terminal;
/** @constructor */
function $h_Lfs2_Pull$Terminal() {
}
$h_Lfs2_Pull$Terminal.prototype = $c_Lfs2_Pull$Terminal.prototype;
function $as_Lfs2_Pull$Terminal(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Terminal) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Terminal"));
}
function $isArrayOf_Lfs2_Pull$Terminal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Terminal)));
}
function $asArrayOf_Lfs2_Pull$Terminal(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Terminal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Terminal;", depth));
}
/** @constructor */
function $c_Lfs2_Pull$UnconsRunR$1(extendLastTopLevelScope$38, F$51, contP$41, scope$37, extendedTopLevelScope$35, TheBuildR$lzy1$41, translation$tailLocal1$38, runner$tailLocal1$35, outer, view) {
  this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8 = false;
  this.Lfs2_Pull$StepRunR$1__f_F$17 = null;
  this.Lfs2_Pull$StepRunR$1__f_contP$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_scope$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_view = null;
  this.Lfs2_Pull$UnconsRunR$1__f_extendLastTopLevelScope$9 = false;
  this.Lfs2_Pull$UnconsRunR$1__f_F$18 = null;
  this.Lfs2_Pull$UnconsRunR$1__f_contP$11 = null;
  this.Lfs2_Pull$UnconsRunR$1__f_extendedTopLevelScope$8 = null;
  this.Lfs2_Pull$UnconsRunR$1__f_TheBuildR$lzy1$11 = null;
  this.Lfs2_Pull$UnconsRunR$1__f_translation$tailLocal1$8 = null;
  this.Lfs2_Pull$UnconsRunR$1__f_runner$tailLocal1$8 = null;
  this.Lfs2_Pull$UnconsRunR$1__f_view = null;
  this.Lfs2_Pull$UnconsRunR$1__f_extendLastTopLevelScope$9 = extendLastTopLevelScope$38;
  this.Lfs2_Pull$UnconsRunR$1__f_F$18 = F$51;
  this.Lfs2_Pull$UnconsRunR$1__f_contP$11 = contP$41;
  this.Lfs2_Pull$UnconsRunR$1__f_extendedTopLevelScope$8 = extendedTopLevelScope$35;
  this.Lfs2_Pull$UnconsRunR$1__f_TheBuildR$lzy1$11 = TheBuildR$lzy1$41;
  this.Lfs2_Pull$UnconsRunR$1__f_translation$tailLocal1$8 = translation$tailLocal1$38;
  this.Lfs2_Pull$UnconsRunR$1__f_runner$tailLocal1$8 = runner$tailLocal1$35;
  this.Lfs2_Pull$UnconsRunR$1__f_view = view;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Lfs2_Pull$StepRunR$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__F1__(this, extendLastTopLevelScope$38, F$51, contP$41, scope$37, extendedTopLevelScope$35, TheBuildR$lzy1$41, translation$tailLocal1$38, runner$tailLocal1$35, view);
}
$c_Lfs2_Pull$UnconsRunR$1.prototype = new $h_Lfs2_Pull$StepRunR$1();
$c_Lfs2_Pull$UnconsRunR$1.prototype.constructor = $c_Lfs2_Pull$UnconsRunR$1;
/** @constructor */
function $h_Lfs2_Pull$UnconsRunR$1() {
}
$h_Lfs2_Pull$UnconsRunR$1.prototype = $c_Lfs2_Pull$UnconsRunR$1.prototype;
$c_Lfs2_Pull$UnconsRunR$1.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, outScope, tail) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$interruptGuard$1__Z__Lcats_MonadError__sr_ObjectRef__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_internal_Scope__F1__F0__O(this.Lfs2_Pull$UnconsRunR$1__f_extendLastTopLevelScope$9, this.Lfs2_Pull$UnconsRunR$1__f_F$18, this.Lfs2_Pull$UnconsRunR$1__f_contP$11, this.Lfs2_Pull$UnconsRunR$1__f_extendedTopLevelScope$8, this.Lfs2_Pull$UnconsRunR$1__f_TheBuildR$lzy1$11, this.Lfs2_Pull$UnconsRunR$1__f_translation$tailLocal1$8, this.Lfs2_Pull$UnconsRunR$1__f_runner$tailLocal1$8, outScope, this.Lfs2_Pull$UnconsRunR$1__f_view, new $c_sjsr_AnonFunction0((() => {
    var value = new $c_T2(head, tail);
    var r = new $c_s_Some(value);
    var result = new $c_Lfs2_Pull$Succeeded(r);
    return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$UnconsRunR$1__f_extendLastTopLevelScope$9, this.Lfs2_Pull$UnconsRunR$1__f_F$18, this.Lfs2_Pull$UnconsRunR$1__f_contP$11, this.Lfs2_Pull$UnconsRunR$1__f_TheBuildR$lzy1$11, outScope, this.Lfs2_Pull$UnconsRunR$1__f_extendedTopLevelScope$8, this.Lfs2_Pull$UnconsRunR$1__f_translation$tailLocal1$8, this.Lfs2_Pull$UnconsRunR$1__f_runner$tailLocal1$8, $as_Lfs2_Pull($n(this.Lfs2_Pull$UnconsRunR$1__f_view).apply__O__O(result)));
  })));
});
var $d_Lfs2_Pull$UnconsRunR$1 = new $TypeData().initClass($c_Lfs2_Pull$UnconsRunR$1, "fs2.Pull$UnconsRunR$1", ({
  Lfs2_Pull$UnconsRunR$1: 1,
  Lfs2_Pull$StepRunR$1: 1,
  Lfs2_Pull$Run$1: 1
}));
/** @constructor */
function $c_Lfs2_internal_Scope$$anon$2(outer) {
  this.Lfs2_internal_Scope$$anon$2__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lfs2_internal_Scope$$anon$2__f_$outer = outer;
}
$c_Lfs2_internal_Scope$$anon$2.prototype = new $h_O();
$c_Lfs2_internal_Scope$$anon$2.prototype.constructor = $c_Lfs2_internal_Scope$$anon$2;
/** @constructor */
function $h_Lfs2_internal_Scope$$anon$2() {
}
$h_Lfs2_internal_Scope$$anon$2.prototype = $c_Lfs2_internal_Scope$$anon$2.prototype;
$c_Lfs2_internal_Scope$$anon$2.prototype.cancel__O = (function() {
  var this$1 = $n($n(this.Lfs2_internal_Scope$$anon$2__f_$outer).Lfs2_internal_Scope__f_F);
  return $n(this$1.F__Lcats_effect_kernel_MonadCancel()).pure__O__O((void 0));
});
$c_Lfs2_internal_Scope$$anon$2.prototype.join__O = (function() {
  var this$3 = $n($n(this.Lfs2_internal_Scope$$anon$2__f_$outer).Lfs2_internal_Scope__f_F);
  var this$1 = $n($n(this.Lfs2_internal_Scope$$anon$2__f_$outer).Lfs2_internal_Scope__f_F);
  var fa = $n(this$1.F__Lcats_effect_kernel_MonadCancel()).pure__O__O((void 0));
  var a = new $c_Lcats_effect_kernel_Outcome$Succeeded(fa);
  return $n(this$3.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a);
});
var $d_Lfs2_internal_Scope$$anon$2 = new $TypeData().initClass($c_Lfs2_internal_Scope$$anon$2, "fs2.internal.Scope$$anon$2", ({
  Lfs2_internal_Scope$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Fiber: 1
}));
/** @constructor */
function $c_Lfs2_internal_Scope$State$() {
  this.Lfs2_internal_Scope$State$__f_initial_ = null;
  this.Lfs2_internal_Scope$State$__f_closed_ = null;
  $n_Lfs2_internal_Scope$State$ = this;
  var this$1 = $m_Lcats_data_Chain$();
  var resources = this$1.Lcats_data_Chain$__f_nil;
  var this$2 = $m_Lcats_data_Chain$();
  var children = this$2.Lcats_data_Chain$__f_nil;
  this.Lfs2_internal_Scope$State$__f_initial_ = new $c_Lfs2_internal_Scope$State$Open(resources, children);
  this.Lfs2_internal_Scope$State$__f_closed_ = new $c_Lfs2_internal_Scope$State$Closed();
}
$c_Lfs2_internal_Scope$State$.prototype = new $h_O();
$c_Lfs2_internal_Scope$State$.prototype.constructor = $c_Lfs2_internal_Scope$State$;
/** @constructor */
function $h_Lfs2_internal_Scope$State$() {
}
$h_Lfs2_internal_Scope$State$.prototype = $c_Lfs2_internal_Scope$State$.prototype;
var $d_Lfs2_internal_Scope$State$ = new $TypeData().initClass($c_Lfs2_internal_Scope$State$, "fs2.internal.Scope$State$", ({
  Lfs2_internal_Scope$State$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Lfs2_internal_Scope$State$;
function $m_Lfs2_internal_Scope$State$() {
  if ((!$n_Lfs2_internal_Scope$State$)) {
    $n_Lfs2_internal_Scope$State$ = new $c_Lfs2_internal_Scope$State$();
  }
  return $n_Lfs2_internal_Scope$State$;
}
/** @constructor */
function $c_jl_Class(data0) {
  this.jl_Class__f_data = null;
  this.jl_Class__f_data = data0;
}
$c_jl_Class.prototype = new $h_O();
$c_jl_Class.prototype.constructor = $c_jl_Class;
/** @constructor */
function $h_jl_Class() {
}
$h_jl_Class.prototype = $c_jl_Class.prototype;
$c_jl_Class.prototype.toString__T = (function() {
  return ((this.isInterface__Z() ? "interface " : (this.isPrimitive__Z() ? "" : "class ")) + this.getName__T());
});
$c_jl_Class.prototype.isInstance__O__Z = (function(obj) {
  return $uZ(this.jl_Class__f_data.isInstance(obj));
});
$c_jl_Class.prototype.isAssignableFrom__jl_Class__Z = (function(that) {
  return $uZ(this.jl_Class__f_data.isAssignableFrom($n(that).jl_Class__f_data));
});
$c_jl_Class.prototype.isInterface__Z = (function() {
  return $uZ(this.jl_Class__f_data.isInterface);
});
$c_jl_Class.prototype.isArray__Z = (function() {
  return $uZ(this.jl_Class__f_data.isArrayClass);
});
$c_jl_Class.prototype.isPrimitive__Z = (function() {
  return $uZ(this.jl_Class__f_data.isPrimitive);
});
$c_jl_Class.prototype.getName__T = (function() {
  return $as_T(this.jl_Class__f_data.name);
});
$c_jl_Class.prototype.getComponentType__jl_Class = (function() {
  return $as_jl_Class(this.jl_Class__f_data.getComponentType());
});
$c_jl_Class.prototype.newArrayOfThisClass__O__O = (function(dimensions) {
  return this.jl_Class__f_data.newArrayOfThisClass(dimensions);
});
function $as_jl_Class(obj) {
  return (((obj instanceof $c_jl_Class) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Class"));
}
function $isArrayOf_jl_Class(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Class)));
}
function $asArrayOf_jl_Class(obj, depth) {
  return (($isArrayOf_jl_Class(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Class;", depth));
}
var $d_jl_Class = new $TypeData().initClass($c_jl_Class, "java.lang.Class", ({
  jl_Class: 1,
  Ljava_io_Serializable: 1,
  jl_constant_Constable: 1
}));
function $ct_jl_Enum__T__I__($thiz, _name, _ordinal) {
  $thiz.jl_Enum__f__name = _name;
  $thiz.jl_Enum__f__ordinal = _ordinal;
  return $thiz;
}
/** @constructor */
function $c_jl_Enum() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
}
$c_jl_Enum.prototype = new $h_O();
$c_jl_Enum.prototype.constructor = $c_jl_Enum;
/** @constructor */
function $h_jl_Enum() {
}
$h_jl_Enum.prototype = $c_jl_Enum.prototype;
$c_jl_Enum.prototype.toString__T = (function() {
  return this.jl_Enum__f__name;
});
$c_jl_Enum.prototype.equals__O__Z = (function(that) {
  return (this === that);
});
$c_jl_Enum.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this);
});
$c_jl_Enum.prototype.compareTo__jl_Enum__I = (function(o) {
  var x = this.jl_Enum__f__ordinal;
  var y = $n(o).jl_Enum__f__ordinal;
  return ((x === y) ? 0 : ((x < y) ? (-1) : 1));
});
$c_jl_Enum.prototype.compareTo__O__I = (function(o) {
  return this.compareTo__jl_Enum__I($as_jl_Enum(o));
});
function $as_jl_Enum(obj) {
  return (((obj instanceof $c_jl_Enum) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Enum"));
}
function $isArrayOf_jl_Enum(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Enum)));
}
function $asArrayOf_jl_Enum(obj, depth) {
  return (($isArrayOf_jl_Enum(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Enum;", depth));
}
function $ct_jl_Error__jl_Throwable__($thiz, e) {
  var message = ((e === null) ? null : $n(e).toString__T());
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, message, e, true, true);
  return $thiz;
}
class $c_jl_Error extends $c_jl_Throwable {
}
function $as_jl_Error(obj) {
  return (((obj instanceof $c_jl_Error) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Error"));
}
function $isArrayOf_jl_Error(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Error)));
}
function $asArrayOf_jl_Error(obj, depth) {
  return (($isArrayOf_jl_Error(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Error;", depth));
}
function $ct_jl_Exception__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
class $c_jl_Exception extends $c_jl_Throwable {
}
var $d_jl_Exception = new $TypeData().initClass($c_jl_Exception, "java.lang.Exception", ({
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $p_Ljava_net_URI__comparePathQueryFragement$1__Ljava_net_URI__I($thiz, that$1) {
  var cmpPath = $m_Ljava_net_URI$().java$net$URI$$escapeAwareCompare__T__T__I($thiz.Ljava_net_URI__f__path, $n(that$1).Ljava_net_URI__f__path);
  if ((cmpPath !== 0)) {
    return cmpPath;
  } else {
    var cmpQuery = $m_Ljava_net_URI$().java$net$URI$$escapeAwareCompare__T__T__I($thiz.Ljava_net_URI__f__query, $n(that$1).Ljava_net_URI__f__query);
    return ((cmpQuery !== 0) ? cmpQuery : $m_Ljava_net_URI$().java$net$URI$$escapeAwareCompare__T__T__I($thiz.Ljava_net_URI__f__fragment, $n(that$1).Ljava_net_URI__f__fragment));
  }
}
function $p_Ljava_net_URI__normalizeEscapesHash$1__T__I($thiz, str) {
  return ((str === null) ? 0 : $f_T__hashCode__I($n($m_Ljava_net_URI$().java$net$URI$$normalizeEscapes__T__T(str))));
}
/** @constructor */
function $c_Ljava_net_URI(origStr) {
  this.Ljava_net_URI__f_origStr = null;
  this.Ljava_net_URI__f_java$net$URI$$_fld = null;
  this.Ljava_net_URI__f_java$net$URI$$_isAbsolute = false;
  this.Ljava_net_URI__f__isOpaque = false;
  this.Ljava_net_URI__f__scheme = null;
  this.Ljava_net_URI__f__schemeSpecificPart = null;
  this.Ljava_net_URI__f__authority = null;
  this.Ljava_net_URI__f__userInfo = null;
  this.Ljava_net_URI__f__host = null;
  this.Ljava_net_URI__f__port = 0;
  this.Ljava_net_URI__f__path = null;
  this.Ljava_net_URI__f__query = null;
  this.Ljava_net_URI__f__fragment = null;
  this.Ljava_net_URI__f_origStr = origStr;
  this.Ljava_net_URI__f_java$net$URI$$_fld = $m_Ljava_net_URI$().Ljava_net_URI$__f_java$net$URI$$uriRe.exec(origStr);
  if ((this.Ljava_net_URI__f_java$net$URI$$_fld === null)) {
    throw $ct_Ljava_net_URISyntaxException__T__T__(new $c_Ljava_net_URISyntaxException(), origStr, "Malformed URI");
  }
  var x = this.Ljava_net_URI__f_java$net$URI$$_fld[1];
  this.Ljava_net_URI__f_java$net$URI$$_isAbsolute = (x !== (void 0));
  var x$1 = this.Ljava_net_URI__f_java$net$URI$$_fld[10];
  this.Ljava_net_URI__f__isOpaque = (x$1 !== (void 0));
  var x$2 = this.Ljava_net_URI__f_java$net$URI$$_fld[1];
  this.Ljava_net_URI__f__scheme = $as_T(((x$2 !== (void 0)) ? x$2 : null));
  if ((!this.Ljava_net_URI__f_java$net$URI$$_isAbsolute)) {
    var x$3 = this.Ljava_net_URI__f_java$net$URI$$_fld[11];
    var $x_1 = $as_T(((x$3 !== (void 0)) ? x$3 : null));
  } else if (this.Ljava_net_URI__f__isOpaque) {
    var x$4 = this.Ljava_net_URI__f_java$net$URI$$_fld[10];
    var $x_1 = $as_T(((x$4 !== (void 0)) ? x$4 : null));
  } else {
    var x$5 = this.Ljava_net_URI__f_java$net$URI$$_fld[2];
    var $x_1 = $as_T(((x$5 !== (void 0)) ? x$5 : null));
  }
  this.Ljava_net_URI__f__schemeSpecificPart = $x_1;
  if (this.Ljava_net_URI__f_java$net$URI$$_isAbsolute) {
    var x$6 = this.Ljava_net_URI__f_java$net$URI$$_fld[3];
    var authPart = $as_T(((x$6 !== (void 0)) ? x$6 : null));
  } else {
    var x$7 = this.Ljava_net_URI__f_java$net$URI$$_fld[12];
    var authPart = $as_T(((x$7 !== (void 0)) ? x$7 : null));
  }
  this.Ljava_net_URI__f__authority = ((authPart === "") ? null : authPart);
  if (this.Ljava_net_URI__f_java$net$URI$$_isAbsolute) {
    var x$8 = this.Ljava_net_URI__f_java$net$URI$$_fld[4];
    var $x_2 = $as_T(((x$8 !== (void 0)) ? x$8 : null));
  } else {
    var x$9 = this.Ljava_net_URI__f_java$net$URI$$_fld[13];
    var $x_2 = $as_T(((x$9 !== (void 0)) ? x$9 : null));
  }
  this.Ljava_net_URI__f__userInfo = $x_2;
  if (this.Ljava_net_URI__f_java$net$URI$$_isAbsolute) {
    var x$10 = this.Ljava_net_URI__f_java$net$URI$$_fld[5];
    var $x_3 = $as_T(((x$10 !== (void 0)) ? x$10 : null));
  } else {
    var x$11 = this.Ljava_net_URI__f_java$net$URI$$_fld[14];
    var $x_3 = $as_T(((x$11 !== (void 0)) ? x$11 : null));
  }
  this.Ljava_net_URI__f__host = $x_3;
  if (this.Ljava_net_URI__f_java$net$URI$$_isAbsolute) {
    var x$12 = this.Ljava_net_URI__f_java$net$URI$$_fld[6];
    var portPart = $as_T(((x$12 !== (void 0)) ? x$12 : null));
  } else {
    var x$13 = this.Ljava_net_URI__f_java$net$URI$$_fld[15];
    var portPart = $as_T(((x$13 !== (void 0)) ? x$13 : null));
  }
  if ((portPart === null)) {
    var $x_4 = (-1);
  } else {
    var this$15 = $m_jl_Integer$();
    var $x_4 = this$15.parseInt__T__I__I(portPart, 10);
  }
  this.Ljava_net_URI__f__port = $x_4;
  if (this.Ljava_net_URI__f_java$net$URI$$_isAbsolute) {
    var x$14 = this.Ljava_net_URI__f_java$net$URI$$_fld[3];
    var $x_5 = $as_T(((x$14 !== (void 0)) ? x$14 : null));
  } else {
    var x$15 = this.Ljava_net_URI__f_java$net$URI$$_fld[12];
    var $x_5 = $as_T(((x$15 !== (void 0)) ? x$15 : null));
  }
  var useNetPath = ($x_5 !== null);
  if (useNetPath) {
    if (this.Ljava_net_URI__f_java$net$URI$$_isAbsolute) {
      var x$16 = this.Ljava_net_URI__f_java$net$URI$$_fld[7];
      var netPath = $as_T(((x$16 !== (void 0)) ? x$16 : null));
    } else {
      var x$17 = this.Ljava_net_URI__f_java$net$URI$$_fld[16];
      var netPath = $as_T(((x$17 !== (void 0)) ? x$17 : null));
    }
    var $x_6 = ((netPath === null) ? "" : netPath);
  } else if (this.Ljava_net_URI__f_java$net$URI$$_isAbsolute) {
    var x$18 = this.Ljava_net_URI__f_java$net$URI$$_fld[8];
    var $x_6 = $as_T(((x$18 !== (void 0)) ? x$18 : null));
  } else {
    var x$19 = this.Ljava_net_URI__f_java$net$URI$$_fld[17];
    var relAbsPath = $as_T(((x$19 !== (void 0)) ? x$19 : null));
    if ((relAbsPath !== null)) {
      var $x_6 = relAbsPath;
    } else {
      var x$20 = this.Ljava_net_URI__f_java$net$URI$$_fld[18];
      var $x_6 = $as_T(((x$20 !== (void 0)) ? x$20 : null));
    }
  }
  this.Ljava_net_URI__f__path = $x_6;
  if (this.Ljava_net_URI__f_java$net$URI$$_isAbsolute) {
    var x$21 = this.Ljava_net_URI__f_java$net$URI$$_fld[9];
    var $x_7 = $as_T(((x$21 !== (void 0)) ? x$21 : null));
  } else {
    var x$22 = this.Ljava_net_URI__f_java$net$URI$$_fld[19];
    var $x_7 = $as_T(((x$22 !== (void 0)) ? x$22 : null));
  }
  this.Ljava_net_URI__f__query = $x_7;
  var x$23 = this.Ljava_net_URI__f_java$net$URI$$_fld[20];
  this.Ljava_net_URI__f__fragment = $as_T(((x$23 !== (void 0)) ? x$23 : null));
  this.Ljava_net_URI__f_java$net$URI$$_fld = null;
}
$c_Ljava_net_URI.prototype = new $h_O();
$c_Ljava_net_URI.prototype.constructor = $c_Ljava_net_URI;
/** @constructor */
function $h_Ljava_net_URI() {
}
$h_Ljava_net_URI.prototype = $c_Ljava_net_URI.prototype;
$c_Ljava_net_URI.prototype.compareTo__Ljava_net_URI__I = (function(that) {
  var cmpScheme = $m_Ljava_net_URI$().java$net$URI$$caseInsensitiveCompare__T__T__I(this.Ljava_net_URI__f__scheme, $n(that).Ljava_net_URI__f__scheme);
  if ((cmpScheme !== 0)) {
    return cmpScheme;
  } else {
    var x = this.Ljava_net_URI__f__isOpaque;
    var this$1 = $n(that);
    var y = this$1.Ljava_net_URI__f__isOpaque;
    var cmpIsOpaque = ((x === y) ? 0 : (x ? 1 : (-1)));
    if ((cmpIsOpaque !== 0)) {
      return cmpIsOpaque;
    } else if (this.Ljava_net_URI__f__isOpaque) {
      var cmpSchemeSpecificPart = $m_Ljava_net_URI$().java$net$URI$$escapeAwareCompare__T__T__I(this.Ljava_net_URI__f__schemeSpecificPart, $n(that).Ljava_net_URI__f__schemeSpecificPart);
      return ((cmpSchemeSpecificPart !== 0) ? cmpSchemeSpecificPart : $p_Ljava_net_URI__comparePathQueryFragement$1__Ljava_net_URI__I(this, that));
    } else if (((this.Ljava_net_URI__f__host !== null) && ($n(that).Ljava_net_URI__f__host !== null))) {
      var cmpUserInfo = $m_Ljava_net_URI$().java$net$URI$$escapeAwareCompare__T__T__I(this.Ljava_net_URI__f__userInfo, $n(that).Ljava_net_URI__f__userInfo);
      if ((cmpUserInfo !== 0)) {
        return cmpUserInfo;
      } else {
        var cmpHost = $m_Ljava_net_URI$().java$net$URI$$caseInsensitiveCompare__T__T__I(this.Ljava_net_URI__f__host, $n(that).Ljava_net_URI__f__host);
        if ((cmpHost !== 0)) {
          return cmpHost;
        } else {
          var cmpPort = ((this.Ljava_net_URI__f__port - $n(that).Ljava_net_URI__f__port) | 0);
          return ((cmpPort !== 0) ? cmpPort : $p_Ljava_net_URI__comparePathQueryFragement$1__Ljava_net_URI__I(this, that));
        }
      }
    } else {
      var cmpAuthority = $m_Ljava_net_URI$().java$net$URI$$escapeAwareCompare__T__T__I(this.Ljava_net_URI__f__authority, $n(that).Ljava_net_URI__f__authority);
      return ((cmpAuthority !== 0) ? cmpAuthority : $p_Ljava_net_URI__comparePathQueryFragement$1__Ljava_net_URI__I(this, that));
    }
  }
});
$c_Ljava_net_URI.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Ljava_net_URI)) {
    var x2 = $as_Ljava_net_URI(that);
    return (this.compareTo__Ljava_net_URI__I(x2) === 0);
  } else {
    return false;
  }
});
$c_Ljava_net_URI.prototype.hashCode__I = (function() {
  var acc = 53722356;
  var $x_3 = $m_ju_internal_MurmurHash3$();
  var $x_2 = acc;
  if ((this.Ljava_net_URI__f__scheme === null)) {
    var $x_1 = 0;
  } else {
    var this$1 = $n(this.Ljava_net_URI__f__scheme);
    var $x_1 = $f_T__hashCode__I($n($as_T(this$1.toLowerCase())));
  }
  acc = $n($x_3).mix__I__I__I($x_2, $x_1);
  if (this.Ljava_net_URI__f__isOpaque) {
    acc = $m_ju_internal_MurmurHash3$().mix__I__I__I(acc, $p_Ljava_net_URI__normalizeEscapesHash$1__T__I(this, this.Ljava_net_URI__f__schemeSpecificPart));
  } else if ((this.Ljava_net_URI__f__host !== null)) {
    acc = $m_ju_internal_MurmurHash3$().mix__I__I__I(acc, $p_Ljava_net_URI__normalizeEscapesHash$1__T__I(this, this.Ljava_net_URI__f__userInfo));
    var $x_5 = $m_ju_internal_MurmurHash3$();
    var $x_4 = acc;
    var this$2 = $n(this.Ljava_net_URI__f__host);
    acc = $n($x_5).mix__I__I__I($x_4, $f_T__hashCode__I($n($as_T(this$2.toLowerCase()))));
    var $x_7 = $m_ju_internal_MurmurHash3$();
    var $x_6 = acc;
    var this$3 = this.Ljava_net_URI__f__port;
    acc = $n($x_7).mix__I__I__I($x_6, this$3);
  } else {
    acc = $m_ju_internal_MurmurHash3$().mix__I__I__I(acc, $p_Ljava_net_URI__normalizeEscapesHash$1__T__I(this, this.Ljava_net_URI__f__authority));
  }
  acc = $m_ju_internal_MurmurHash3$().mix__I__I__I(acc, $p_Ljava_net_URI__normalizeEscapesHash$1__T__I(this, this.Ljava_net_URI__f__path));
  acc = $m_ju_internal_MurmurHash3$().mix__I__I__I(acc, $p_Ljava_net_URI__normalizeEscapesHash$1__T__I(this, this.Ljava_net_URI__f__query));
  acc = $m_ju_internal_MurmurHash3$().mixLast__I__I__I(acc, $p_Ljava_net_URI__normalizeEscapesHash$1__T__I(this, this.Ljava_net_URI__f__fragment));
  return $m_ju_internal_MurmurHash3$().finalizeHash__I__I__I(acc, 3);
});
$c_Ljava_net_URI.prototype.toString__T = (function() {
  return this.Ljava_net_URI__f_origStr;
});
$c_Ljava_net_URI.prototype.compareTo__O__I = (function(o) {
  return this.compareTo__Ljava_net_URI__I($as_Ljava_net_URI(o));
});
function $as_Ljava_net_URI(obj) {
  return (((obj instanceof $c_Ljava_net_URI) || (obj === null)) ? obj : $throwClassCastException(obj, "java.net.URI"));
}
function $isArrayOf_Ljava_net_URI(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_net_URI)));
}
function $asArrayOf_Ljava_net_URI(obj, depth) {
  return (($isArrayOf_Ljava_net_URI(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.net.URI;", depth));
}
var $d_Ljava_net_URI = new $TypeData().initClass($c_Ljava_net_URI, "java.net.URI", ({
  Ljava_net_URI: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
}));
function $ct_Ljava_nio_ByteBuffer__I__AB__I__($thiz, _capacity, _array, _arrayOffset) {
  $thiz.Ljava_nio_ByteBuffer__f__array = _array;
  $thiz.Ljava_nio_ByteBuffer__f__arrayOffset = _arrayOffset;
  $ct_Ljava_nio_Buffer__I__($thiz, _capacity);
  return $thiz;
}
/** @constructor */
function $c_Ljava_nio_ByteBuffer() {
  this.Ljava_nio_Buffer__f__capacity = 0;
  this.Ljava_nio_Buffer__f__limit = 0;
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  this.Ljava_nio_Buffer__f__mark = 0;
  this.Ljava_nio_ByteBuffer__f__array = null;
  this.Ljava_nio_ByteBuffer__f__arrayOffset = 0;
}
$c_Ljava_nio_ByteBuffer.prototype = new $h_Ljava_nio_Buffer();
$c_Ljava_nio_ByteBuffer.prototype.constructor = $c_Ljava_nio_ByteBuffer;
/** @constructor */
function $h_Ljava_nio_ByteBuffer() {
}
$h_Ljava_nio_ByteBuffer.prototype = $c_Ljava_nio_ByteBuffer.prototype;
$c_Ljava_nio_ByteBuffer.prototype.put__Ljava_nio_ByteBuffer__Ljava_nio_ByteBuffer = (function(src) {
  if ((src === this)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  if (this.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var this$3 = $n(src);
  var srcLimit = this$3.Ljava_nio_Buffer__f__limit;
  var this$4 = $n(src);
  var srcPos = this$4.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var length = ((srcLimit - srcPos) | 0);
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var newPos = ((p + length) | 0);
  if ((newPos > this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferOverflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPos;
  var selfPos = p;
  var this$5 = $n(src);
  $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$5, srcLimit);
  var this$6 = $n(src);
  var srcArray = this$6.Ljava_nio_ByteBuffer__f__array;
  if ((srcArray !== null)) {
    var startIndex = selfPos;
    var offset = (($n(src).Ljava_nio_ByteBuffer__f__arrayOffset + srcPos) | 0);
    var x2 = this.Ljava_nio_ByteBuffer__f__array;
    var x3 = ((this.Ljava_nio_ByteBuffer__f__arrayOffset + startIndex) | 0);
    $systemArraycopy($n(srcArray), offset, $n(x2), x3, length);
  } else {
    while ((srcPos !== srcLimit)) {
      var index$1 = selfPos;
      var this$9 = $n(src);
      var index = srcPos;
      var a = this$9.Ljava_nio_ByteBuffer__f__array;
      var i = ((this$9.Ljava_nio_ByteBuffer__f__arrayOffset + index) | 0);
      var elem = $n(a).get(i);
      var a$1 = this.Ljava_nio_ByteBuffer__f__array;
      var i$1 = ((this.Ljava_nio_ByteBuffer__f__arrayOffset + index$1) | 0);
      $n(a$1).set(i$1, elem);
      srcPos = ((1 + srcPos) | 0);
      selfPos = ((1 + selfPos) | 0);
    }
  }
  return this;
});
$c_Ljava_nio_ByteBuffer.prototype.hashCode__I = (function() {
  var start = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var end = this.Ljava_nio_Buffer__f__limit;
  var h = (-547316498);
  var i = start;
  while ((i !== end)) {
    var $x_2 = $m_ju_internal_MurmurHash3$();
    var $x_1 = h;
    var index = i;
    var a = this.Ljava_nio_ByteBuffer__f__array;
    var i$1 = ((this.Ljava_nio_ByteBuffer__f__arrayOffset + index) | 0);
    var this$5 = $n(a).get(i$1);
    h = $n($x_2).mix__I__I__I($x_1, this$5);
    i = ((1 + i) | 0);
  }
  return $m_ju_internal_MurmurHash3$().finalizeHash__I__I__I(h, ((end - start) | 0));
});
$c_Ljava_nio_ByteBuffer.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Ljava_nio_ByteBuffer)) {
    var x2 = $as_Ljava_nio_ByteBuffer(that);
    return (this.compareTo__Ljava_nio_ByteBuffer__I(x2) === 0);
  } else {
    return false;
  }
});
$c_Ljava_nio_ByteBuffer.prototype.compareTo__Ljava_nio_ByteBuffer__I = (function(that) {
  if ((this === that)) {
    return 0;
  } else {
    var thisStart = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
    var thisRemaining = ((this.Ljava_nio_Buffer__f__limit - thisStart) | 0);
    var this$3 = $n(that);
    var thatStart = this$3.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
    var this$4 = $n(that);
    var thatRemaining = ((this$4.Ljava_nio_Buffer__f__limit - thatStart) | 0);
    var shortestLength = ((thisRemaining < thatRemaining) ? thisRemaining : thatRemaining);
    var i = 0;
    while ((i !== shortestLength)) {
      var index = ((thisStart + i) | 0);
      var a = this.Ljava_nio_ByteBuffer__f__array;
      var i$1 = ((this.Ljava_nio_ByteBuffer__f__arrayOffset + index) | 0);
      var x$1$2 = $n(a).get(i$1);
      var this$8 = $n(that);
      var index$1 = ((thatStart + i) | 0);
      var a$1 = this$8.Ljava_nio_ByteBuffer__f__array;
      var i$2 = ((this$8.Ljava_nio_ByteBuffer__f__arrayOffset + index$1) | 0);
      var x$2$2 = $n(a$1).get(i$2);
      var cmp = ((x$1$2 - x$2$2) | 0);
      if ((cmp !== 0)) {
        return cmp;
      }
      i = ((1 + i) | 0);
    }
    return ((thisRemaining === thatRemaining) ? 0 : ((thisRemaining < thatRemaining) ? (-1) : 1));
  }
});
$c_Ljava_nio_ByteBuffer.prototype.compareTo__O__I = (function(o) {
  return this.compareTo__Ljava_nio_ByteBuffer__I($as_Ljava_nio_ByteBuffer(o));
});
function $as_Ljava_nio_ByteBuffer(obj) {
  return (((obj instanceof $c_Ljava_nio_ByteBuffer) || (obj === null)) ? obj : $throwClassCastException(obj, "java.nio.ByteBuffer"));
}
function $isArrayOf_Ljava_nio_ByteBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_nio_ByteBuffer)));
}
function $asArrayOf_Ljava_nio_ByteBuffer(obj, depth) {
  return (($isArrayOf_Ljava_nio_ByteBuffer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.nio.ByteBuffer;", depth));
}
/** @constructor */
function $c_Ljava_nio_charset_UTF\uff3f8$() {
  this.Ljava_nio_charset_Charset__f_cachedDecoder = null;
  this.Ljava_nio_charset_Charset__f_canonicalName = null;
  this.Ljava_nio_charset_Charset__f_bitmap$0 = 0;
  this.Ljava_nio_charset_UTF\uff3f8$__f_java$nio$charset$UTF_8$$lengthByLeading = null;
  $ct_Ljava_nio_charset_Charset__T__AT__(this, "UTF-8", new ($d_T.getArrayOf().constr)(["UTF8", "unicode-1-1-utf-8"]));
  $n_Ljava_nio_charset_UTF\uff3f8$ = this;
  this.Ljava_nio_charset_UTF\uff3f8$__f_java$nio$charset$UTF_8$$lengthByLeading = new $ac_I(new Int32Array([(-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1)]));
}
$c_Ljava_nio_charset_UTF\uff3f8$.prototype = new $h_Ljava_nio_charset_Charset();
$c_Ljava_nio_charset_UTF\uff3f8$.prototype.constructor = $c_Ljava_nio_charset_UTF\uff3f8$;
/** @constructor */
function $h_Ljava_nio_charset_UTF\uff3f8$() {
}
$h_Ljava_nio_charset_UTF\uff3f8$.prototype = $c_Ljava_nio_charset_UTF\uff3f8$.prototype;
var $d_Ljava_nio_charset_UTF\uff3f8$ = new $TypeData().initClass($c_Ljava_nio_charset_UTF\uff3f8$, "java.nio.charset.UTF_8$", ({
  Ljava_nio_charset_UTF\uff3f8$: 1,
  Ljava_nio_charset_Charset: 1,
  jl_Comparable: 1
}));
var $n_Ljava_nio_charset_UTF\uff3f8$;
function $m_Ljava_nio_charset_UTF\uff3f8$() {
  if ((!$n_Ljava_nio_charset_UTF\uff3f8$)) {
    $n_Ljava_nio_charset_UTF\uff3f8$ = new $c_Ljava_nio_charset_UTF\uff3f8$();
  }
  return $n_Ljava_nio_charset_UTF\uff3f8$;
}
/** @constructor */
function $c_ju_AbstractCollection() {
}
$c_ju_AbstractCollection.prototype = new $h_O();
$c_ju_AbstractCollection.prototype.constructor = $c_ju_AbstractCollection;
/** @constructor */
function $h_ju_AbstractCollection() {
}
$h_ju_AbstractCollection.prototype = $c_ju_AbstractCollection.prototype;
$c_ju_AbstractCollection.prototype.contains__O__Z = (function(o) {
  var _\uff3fself = this.iterator__ju_Iterator();
  while ($n(_\uff3fself).hasNext__Z()) {
    var x$1$2 = $n(_\uff3fself).next__O();
    if (((o === null) ? (x$1$2 === null) : $dp_equals__O__Z($n(o), x$1$2))) {
      return true;
    }
  }
  return false;
});
$c_ju_AbstractCollection.prototype.containsAll__ju_Collection__Z = (function(c) {
  var _\uff3fself = $n(c).iterator__ju_Iterator();
  _return: {
    while ($n(_\uff3fself).hasNext__Z()) {
      var x$2 = $n(_\uff3fself).next__O();
      if ((!this.contains__O__Z(x$2))) {
        var $x_1 = true;
        break _return;
      }
    }
    var $x_1 = false;
  }
  return (!$x_1);
});
$c_ju_AbstractCollection.prototype.toString__T = (function() {
  var _\uff3fself = this.iterator__ju_Iterator();
  var result = "[";
  var first = true;
  while ($n(_\uff3fself).hasNext__Z()) {
    if (first) {
      first = false;
    } else {
      result = (result + ", ");
    }
    result = (("" + result) + $n(_\uff3fself).next__O());
  }
  return (result + "]");
});
/** @constructor */
function $c_ju_HashMap$NodeIterator(outer) {
  this.ju_HashMap$AbstractHashMapIterator__f_len = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextIdx = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_$outer = null;
  $ct_ju_HashMap$AbstractHashMapIterator__ju_HashMap__(this, outer);
}
$c_ju_HashMap$NodeIterator.prototype = new $h_ju_HashMap$AbstractHashMapIterator();
$c_ju_HashMap$NodeIterator.prototype.constructor = $c_ju_HashMap$NodeIterator;
/** @constructor */
function $h_ju_HashMap$NodeIterator() {
}
$h_ju_HashMap$NodeIterator.prototype = $c_ju_HashMap$NodeIterator.prototype;
var $d_ju_HashMap$NodeIterator = new $TypeData().initClass($c_ju_HashMap$NodeIterator, "java.util.HashMap$NodeIterator", ({
  ju_HashMap$NodeIterator: 1,
  ju_HashMap$AbstractHashMapIterator: 1,
  ju_Iterator: 1
}));
function $is_ju_List(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_List)));
}
function $as_ju_List(obj) {
  return (($is_ju_List(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.List"));
}
function $isArrayOf_ju_List(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_List)));
}
function $asArrayOf_ju_List(obj, depth) {
  return (($isArrayOf_ju_List(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.List;", depth));
}
/** @constructor */
function $c_ju_NullRejectingHashMap$Node(key, hash, value, previous, next) {
  this.ju_HashMap$Node__f_key = null;
  this.ju_HashMap$Node__f_hash = 0;
  this.ju_HashMap$Node__f_value = null;
  this.ju_HashMap$Node__f_previous = null;
  this.ju_HashMap$Node__f_next = null;
  $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__(this, key, hash, value, previous, next);
}
$c_ju_NullRejectingHashMap$Node.prototype = new $h_ju_HashMap$Node();
$c_ju_NullRejectingHashMap$Node.prototype.constructor = $c_ju_NullRejectingHashMap$Node;
/** @constructor */
function $h_ju_NullRejectingHashMap$Node() {
}
$h_ju_NullRejectingHashMap$Node.prototype = $c_ju_NullRejectingHashMap$Node.prototype;
var $d_ju_NullRejectingHashMap$Node = new $TypeData().initClass($c_ju_NullRejectingHashMap$Node, "java.util.NullRejectingHashMap$Node", ({
  ju_NullRejectingHashMap$Node: 1,
  ju_HashMap$Node: 1,
  ju_Map$Entry: 1
}));
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator(outer) {
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter = null;
  $ct_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__ju_concurrent_ConcurrentHashMap$InnerHashMap__(this, outer);
}
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype = new $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator();
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator() {
}
$h_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype;
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype.extract__ju_HashMap$Node__O = (function(node) {
  return node;
});
var $d_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator = new $TypeData().initClass($c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator, "java.util.concurrent.ConcurrentHashMap$InnerHashMap$NodeIterator", ({
  ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator: 1,
  ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator: 1,
  ju_Iterator: 1
}));
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator(outer) {
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter = null;
  $ct_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__ju_concurrent_ConcurrentHashMap$InnerHashMap__(this, outer);
}
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator.prototype = new $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator();
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator() {
}
$h_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator.prototype = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator.prototype;
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator.prototype.extract__ju_HashMap$Node__O = (function(node) {
  return $n(node).ju_HashMap$Node__f_value;
});
var $d_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator = new $TypeData().initClass($c_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator, "java.util.concurrent.ConcurrentHashMap$InnerHashMap$ValueIterator", ({
  ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator: 1,
  ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator: 1,
  ju_Iterator: 1
}));
/** @constructor */
function $c_ju_concurrent_ThreadLocalRandom() {
  this.ju_Random__f_seedHi = 0;
  this.ju_Random__f_seedLo = 0;
  this.ju_concurrent_ThreadLocalRandom__f_initialized = false;
  $ct_ju_Random__J__(this, $m_ju_Random$().java$util$Random$$randomSeed__J());
  this.ju_concurrent_ThreadLocalRandom__f_initialized = true;
}
$c_ju_concurrent_ThreadLocalRandom.prototype = new $h_ju_Random();
$c_ju_concurrent_ThreadLocalRandom.prototype.constructor = $c_ju_concurrent_ThreadLocalRandom;
/** @constructor */
function $h_ju_concurrent_ThreadLocalRandom() {
}
$h_ju_concurrent_ThreadLocalRandom.prototype = $c_ju_concurrent_ThreadLocalRandom.prototype;
$c_ju_concurrent_ThreadLocalRandom.prototype.setSeed__J__V = (function(seed) {
  if (this.ju_concurrent_ThreadLocalRandom__f_initialized) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  $c_ju_Random.prototype.setSeed__J__V.call(this, seed);
});
var $d_ju_concurrent_ThreadLocalRandom = new $TypeData().initClass($c_ju_concurrent_ThreadLocalRandom, "java.util.concurrent.ThreadLocalRandom", ({
  ju_concurrent_ThreadLocalRandom: 1,
  ju_Random: 1,
  Ljava_io_Serializable: 1
}));
function $ct_ju_concurrent_atomic_AtomicInteger__I__($thiz, value) {
  $thiz.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value = value;
  return $thiz;
}
function $ct_ju_concurrent_atomic_AtomicInteger__($thiz) {
  $ct_ju_concurrent_atomic_AtomicInteger__I__($thiz, 0);
  return $thiz;
}
/** @constructor */
function $c_ju_concurrent_atomic_AtomicInteger() {
  this.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value = 0;
}
$c_ju_concurrent_atomic_AtomicInteger.prototype = new $h_jl_Number();
$c_ju_concurrent_atomic_AtomicInteger.prototype.constructor = $c_ju_concurrent_atomic_AtomicInteger;
/** @constructor */
function $h_ju_concurrent_atomic_AtomicInteger() {
}
$h_ju_concurrent_atomic_AtomicInteger.prototype = $c_ju_concurrent_atomic_AtomicInteger.prototype;
$c_ju_concurrent_atomic_AtomicInteger.prototype.toString__T = (function() {
  var this$1 = this.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value;
  return ("" + this$1);
});
var $d_ju_concurrent_atomic_AtomicInteger = new $TypeData().initClass($c_ju_concurrent_atomic_AtomicInteger, "java.util.concurrent.atomic.AtomicInteger", ({
  ju_concurrent_atomic_AtomicInteger: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_builder_RendererBuilder(renderFormat, config, skipRewritePhase) {
  this.Llaika_api_builder_RendererBuilder__f_renderFormat = null;
  this.Llaika_api_builder_RendererBuilder__f_config = null;
  this.Llaika_api_builder_RendererBuilder__f_laika$api$builder$RendererBuilder$$skipRewritePhase = false;
  this.Llaika_api_builder_RendererBuilder__f_renderFormat = renderFormat;
  this.Llaika_api_builder_RendererBuilder__f_config = config;
  this.Llaika_api_builder_RendererBuilder__f_laika$api$builder$RendererBuilder$$skipRewritePhase = skipRewritePhase;
}
$c_Llaika_api_builder_RendererBuilder.prototype = new $h_O();
$c_Llaika_api_builder_RendererBuilder.prototype.constructor = $c_Llaika_api_builder_RendererBuilder;
/** @constructor */
function $h_Llaika_api_builder_RendererBuilder() {
}
$h_Llaika_api_builder_RendererBuilder.prototype = $c_Llaika_api_builder_RendererBuilder.prototype;
$c_Llaika_api_builder_RendererBuilder.prototype.config__Llaika_api_builder_OperationConfig = (function() {
  return this.Llaika_api_builder_RendererBuilder__f_config;
});
$c_Llaika_api_builder_RendererBuilder.prototype.withConfig__Llaika_api_builder_OperationConfig__O = (function(newConfig) {
  return new $c_Llaika_api_builder_RendererBuilder(this.Llaika_api_builder_RendererBuilder__f_renderFormat, newConfig, false);
});
var $d_Llaika_api_builder_RendererBuilder = new $TypeData().initClass($c_Llaika_api_builder_RendererBuilder, "laika.api.builder.RendererBuilder", ({
  Llaika_api_builder_RendererBuilder: 1,
  Llaika_api_builder_CommonBuilderOps: 1,
  Llaika_api_builder_RendererBuilderOps: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$(outer) {
  this.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$__f_Source$lzy1 = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$__f_Parsed$lzy1 = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$__f_Source$lzy1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source$(this);
  this.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$__f_Parsed$lzy1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed$(this);
}
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$.prototype = new $h_O();
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$.prototype;
var $d_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$ = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$, "laika.api.bundle.DirectiveBuilderContext$BodyContent$", ({
  Llaika_api_bundle_DirectiveBuilderContext$BodyContent$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed$(outer) {
  this.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed$__f_$outer = outer;
}
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed$.prototype = new $h_O();
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed$.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed$;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed$() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed$.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed$.prototype;
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed$.prototype.apply__sci_Seq__Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed = (function(value) {
  return new $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed(this.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed$__f_$outer, value);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed$.prototype.toString__T = (function() {
  return "Parsed";
});
var $d_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed$ = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed$, "laika.api.bundle.DirectiveBuilderContext$BodyContent$Parsed$", ({
  Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source$(outer) {
  this.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source$__f_$outer = outer;
}
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source$.prototype = new $h_O();
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source$.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source$;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source$() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source$.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source$.prototype;
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source$.prototype.apply__Llaika_parse_SourceFragment__Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source = (function(value) {
  return new $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source(this.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source$__f_$outer, value);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source$.prototype.toString__T = (function() {
  return "Source";
});
var $d_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source$ = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source$, "laika.api.bundle.DirectiveBuilderContext$BodyContent$Source$", ({
  Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent$(outer) {
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent$__f_$outer = outer;
}
$c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent$.prototype = new $h_O();
$c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent$.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent$;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent$() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent$.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent$.prototype;
$c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent$.prototype.apply__Llaika_api_config_Config__s_Option__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent = (function(attributes, body) {
  return new $c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent(this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent$__f_$outer, attributes, body);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent$.prototype.toString__T = (function() {
  return "DirectiveContent";
});
var $d_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent$ = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent$, "laika.api.bundle.DirectiveBuilderContext$DirectiveContent$", ({
  Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$Multipart$(outer) {
  this.Llaika_api_bundle_DirectiveBuilderContext$Multipart$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_bundle_DirectiveBuilderContext$Multipart$__f_$outer = outer;
}
$c_Llaika_api_bundle_DirectiveBuilderContext$Multipart$.prototype = new $h_O();
$c_Llaika_api_bundle_DirectiveBuilderContext$Multipart$.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$Multipart$;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$Multipart$() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$Multipart$.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$Multipart$.prototype;
$c_Llaika_api_bundle_DirectiveBuilderContext$Multipart$.prototype.apply__sci_Seq__sci_Seq__Llaika_api_bundle_DirectiveBuilderContext$Multipart = (function(mainBody, children) {
  return new $c_Llaika_api_bundle_DirectiveBuilderContext$Multipart(this.Llaika_api_bundle_DirectiveBuilderContext$Multipart$__f_$outer, mainBody, children);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$Multipart$.prototype.toString__T = (function() {
  return "Multipart";
});
var $d_Llaika_api_bundle_DirectiveBuilderContext$Multipart$ = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$Multipart$, "laika.api.bundle.DirectiveBuilderContext$Multipart$", ({
  Llaika_api_bundle_DirectiveBuilderContext$Multipart$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DirectiveRegistry$$anon$1(outer) {
  this.Llaika_api_bundle_DirectiveRegistry$$anon$1__f_spanDirectives = null;
  this.Llaika_api_bundle_DirectiveRegistry$$anon$1__f_blockDirectives = null;
  this.Llaika_api_bundle_DirectiveRegistry$$anon$1__f_linkDirectives = null;
  this.Llaika_api_bundle_DirectiveRegistry$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_bundle_DirectiveRegistry$$anon$1__f_$outer = outer;
  this.Llaika_api_bundle_DirectiveRegistry$$anon$1__f_spanDirectives = $m_sci_Nil$();
  this.Llaika_api_bundle_DirectiveRegistry$$anon$1__f_blockDirectives = $m_sci_Nil$();
  this.Llaika_api_bundle_DirectiveRegistry$$anon$1__f_linkDirectives = $m_sci_Nil$();
}
$c_Llaika_api_bundle_DirectiveRegistry$$anon$1.prototype = new $h_O();
$c_Llaika_api_bundle_DirectiveRegistry$$anon$1.prototype.constructor = $c_Llaika_api_bundle_DirectiveRegistry$$anon$1;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveRegistry$$anon$1() {
}
$h_Llaika_api_bundle_DirectiveRegistry$$anon$1.prototype = $c_Llaika_api_bundle_DirectiveRegistry$$anon$1.prototype;
$c_Llaika_api_bundle_DirectiveRegistry$$anon$1.prototype.origin__Llaika_api_bundle_BundleOrigin = (function() {
  return $m_Llaika_api_bundle_BundleOrigin$User$();
});
$c_Llaika_api_bundle_DirectiveRegistry$$anon$1.prototype.baseConfig__Llaika_api_config_Config = (function() {
  return $m_Llaika_api_config_Config$().Llaika_api_config_Config$__f_empty;
});
$c_Llaika_api_bundle_DirectiveRegistry$$anon$1.prototype.slugBuilder__s_Option = (function() {
  return $m_s_None$();
});
$c_Llaika_api_bundle_DirectiveRegistry$$anon$1.prototype.parsers__Llaika_api_bundle_ParserBundle = (function() {
  return new $c_Llaika_api_bundle_ParserBundle($m_sci_Nil$(), $m_sci_Nil$(), $m_sci_Nil$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
});
$c_Llaika_api_bundle_DirectiveRegistry$$anon$1.prototype.rewriteRules__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf;
});
$c_Llaika_api_bundle_DirectiveRegistry$$anon$1.prototype.renderOverrides__sci_Seq = (function() {
  return $as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps());
});
$c_Llaika_api_bundle_DirectiveRegistry$$anon$1.prototype.rawContentDisabled__s_Option = (function() {
  return new $c_s_Some(this);
});
$c_Llaika_api_bundle_DirectiveRegistry$$anon$1.prototype.forStrictMode__s_Option = (function() {
  return $f_Llaika_api_bundle_DirectiveRegistry__forStrictMode__s_Option(this);
});
$c_Llaika_api_bundle_DirectiveRegistry$$anon$1.prototype.processExtension__s_PartialFunction = (function() {
  return new $c_Llaika_api_bundle_DirectiveRegistry$$anon$2(this);
});
$c_Llaika_api_bundle_DirectiveRegistry$$anon$1.prototype.spanDirectives__sci_Seq = (function() {
  return this.Llaika_api_bundle_DirectiveRegistry$$anon$1__f_spanDirectives;
});
$c_Llaika_api_bundle_DirectiveRegistry$$anon$1.prototype.blockDirectives__sci_Seq = (function() {
  return this.Llaika_api_bundle_DirectiveRegistry$$anon$1__f_blockDirectives;
});
$c_Llaika_api_bundle_DirectiveRegistry$$anon$1.prototype.linkDirectives__sci_Seq = (function() {
  return this.Llaika_api_bundle_DirectiveRegistry$$anon$1__f_linkDirectives;
});
$c_Llaika_api_bundle_DirectiveRegistry$$anon$1.prototype.templateDirectives__sci_Seq = (function() {
  return $n(this.Llaika_api_bundle_DirectiveRegistry$$anon$1__f_$outer).templateDirectives__sci_Seq();
});
var $d_Llaika_api_bundle_DirectiveRegistry$$anon$1 = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveRegistry$$anon$1, "laika.api.bundle.DirectiveRegistry$$anon$1", ({
  Llaika_api_bundle_DirectiveRegistry$$anon$1: 1,
  Llaika_api_bundle_ExtensionBundle: 1,
  Llaika_api_bundle_DirectiveRegistry: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_TranslatorConfig$() {
  $n_Llaika_api_bundle_TranslatorConfig$ = this;
  $m_Llaika_api_bundle_TranslatorConfig$();
}
$c_Llaika_api_bundle_TranslatorConfig$.prototype = new $h_O();
$c_Llaika_api_bundle_TranslatorConfig$.prototype.constructor = $c_Llaika_api_bundle_TranslatorConfig$;
/** @constructor */
function $h_Llaika_api_bundle_TranslatorConfig$() {
}
$h_Llaika_api_bundle_TranslatorConfig$.prototype = $c_Llaika_api_bundle_TranslatorConfig$.prototype;
$c_Llaika_api_bundle_TranslatorConfig$.prototype.readFrom__Llaika_api_config_Config__s_util_Either = (function(config) {
  var this$1 = $n(config);
  var decoder = $m_Llaika_config_Versions$().Llaika_config_Versions$__f_decoder;
  var defaultKey = $m_Llaika_config_Versions$().Llaika_config_Versions$__f_key;
  var key = $n(defaultKey).Llaika_api_config_DefaultKey$$anon$1__f_value;
  var this$2 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$1, key, decoder));
  if ((this$2 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$2);
    var b = $n(x2).s_util_Right__f_value;
    var versions = $as_s_Option(b);
    var this$3 = $n($m_Llaika_internal_nav_TitleDocumentConfig$().inputName__Llaika_api_config_Config__s_util_Either(config));
    if ((this$3 instanceof $c_s_util_Right)) {
      var x2$1 = $as_s_util_Right(this$3);
      var b$1 = $n(x2$1).s_util_Right__f_value;
      var titleDocInputName = $as_T(b$1);
      var this$4 = $n($m_Llaika_internal_nav_TitleDocumentConfig$().outputName__Llaika_api_config_Config__s_util_Either(config));
      if ((this$4 instanceof $c_s_util_Right)) {
        var x2$2 = $as_s_util_Right(this$4);
        var b$2 = $n(x2$2).s_util_Right__f_value;
        var titleDocOutputName = $as_T(b$2);
        var this$5 = $n(config);
        var key$1 = $m_Llaika_config_LaikaKeys$().Llaika_config_LaikaKeys$__f_siteBaseURL;
        var decoder$1 = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
        var this$6 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$5, key$1, decoder$1));
        if ((this$6 instanceof $c_s_util_Right)) {
          var x2$3 = $as_s_util_Right(this$6);
          var b$3 = $n(x2$3).s_util_Right__f_value;
          var siteBaseURL = $as_s_Option(b$3);
          $m_Llaika_api_bundle_TranslatorConfig$();
          return new $c_s_util_Right(new $c_Llaika_api_bundle_TranslatorConfig(versions, titleDocInputName, titleDocOutputName, siteBaseURL));
        } else {
          return this$6;
        }
      } else {
        return this$4;
      }
    } else {
      return this$3;
    }
  } else {
    return this$2;
  }
});
var $d_Llaika_api_bundle_TranslatorConfig$ = new $TypeData().initClass($c_Llaika_api_bundle_TranslatorConfig$, "laika.api.bundle.TranslatorConfig$", ({
  Llaika_api_bundle_TranslatorConfig$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_api_bundle_TranslatorConfig$;
function $m_Llaika_api_bundle_TranslatorConfig$() {
  if ((!$n_Llaika_api_bundle_TranslatorConfig$)) {
    $n_Llaika_api_bundle_TranslatorConfig$ = new $c_Llaika_api_bundle_TranslatorConfig$();
  }
  return $n_Llaika_api_bundle_TranslatorConfig$;
}
/** @constructor */
function $c_Llaika_api_config_Key$() {
  this.Llaika_api_config_Key$__f_root = null;
  $n_Llaika_api_config_Key$ = this;
  $m_Llaika_api_config_Key$();
  var segments = $m_sci_Nil$();
  this.Llaika_api_config_Key$__f_root = new $c_Llaika_api_config_Key(segments);
}
$c_Llaika_api_config_Key$.prototype = new $h_O();
$c_Llaika_api_config_Key$.prototype.constructor = $c_Llaika_api_config_Key$;
/** @constructor */
function $h_Llaika_api_config_Key$() {
}
$h_Llaika_api_config_Key$.prototype = $c_Llaika_api_config_Key$.prototype;
$c_Llaika_api_config_Key$.prototype.apply__T__sci_Seq__Llaika_api_config_Key = (function(segment, segments) {
  $m_Llaika_api_config_Key$();
  var this$1 = $n($n(segments).toList__sci_List());
  var segments$1 = this$1.prepended__O__sci_List(segment);
  return new $c_Llaika_api_config_Key(segments$1);
});
$c_Llaika_api_config_Key$.prototype.parse__T__Llaika_api_config_Key = (function(key) {
  var this$1 = $n(key);
  if ((this$1 === "")) {
    return this.Llaika_api_config_Key$__f_root;
  } else {
    var $x_1 = $m_s_Predef$();
    var this$2 = $n(key);
    var this$3 = $n($n($x_1).wrapRefArray__AO__scm_ArraySeq$ofRef($f_T__split__T__I__AT(this$2, "\\.", 0)));
    var segments = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$3);
    $m_Llaika_api_config_Key$();
    return new $c_Llaika_api_config_Key(segments);
  }
});
var $d_Llaika_api_config_Key$ = new $TypeData().initClass($c_Llaika_api_config_Key$, "laika.api.config.Key$", ({
  Llaika_api_config_Key$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_api_config_Key$;
function $m_Llaika_api_config_Key$() {
  if ((!$n_Llaika_api_config_Key$)) {
    $n_Llaika_api_config_Key$ = new $c_Llaika_api_config_Key$();
  }
  return $n_Llaika_api_config_Key$;
}
/** @constructor */
function $c_Llaika_api_config_Origin$() {
  this.Llaika_api_config_Origin$__f_root = null;
  $n_Llaika_api_config_Origin$ = this;
  $m_Llaika_api_config_Origin$();
  var scope = $m_Llaika_api_config_Origin$GlobalScope$();
  var path = $m_Llaika_ast_Path$Root$();
  $m_Llaika_api_config_Origin$();
  var sourcePath = $m_s_None$();
  this.Llaika_api_config_Origin$__f_root = new $c_Llaika_api_config_Origin(scope, path, sourcePath);
}
$c_Llaika_api_config_Origin$.prototype = new $h_O();
$c_Llaika_api_config_Origin$.prototype.constructor = $c_Llaika_api_config_Origin$;
/** @constructor */
function $h_Llaika_api_config_Origin$() {
}
$h_Llaika_api_config_Origin$.prototype = $c_Llaika_api_config_Origin$.prototype;
var $d_Llaika_api_config_Origin$ = new $TypeData().initClass($c_Llaika_api_config_Origin$, "laika.api.config.Origin$", ({
  Llaika_api_config_Origin$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_api_config_Origin$;
function $m_Llaika_api_config_Origin$() {
  if ((!$n_Llaika_api_config_Origin$)) {
    $n_Llaika_api_config_Origin$ = new $c_Llaika_api_config_Origin$();
  }
  return $n_Llaika_api_config_Origin$;
}
function $p_Llaika_api_errors_InvalidDocument$__formatElement__Llaika_ast_Path__Llaika_ast_Invalid__T($thiz, docPath, element) {
  var this$1 = $n($n(element).source__Llaika_parse_SourceFragment());
  var this$2 = $n($n(this$1.root__Llaika_parse_SourceCursor()).path__s_Option());
  if (this$2.isEmpty__Z()) {
    var pathStr = "";
  } else {
    var arg1 = this$2.get__O();
    var srcPath = $as_Llaika_ast_Path(arg1);
    var pathStr = (((srcPath === null) ? (docPath === null) : $n(srcPath).equals__O__Z(docPath)) ? "" : ($n(srcPath).toString__T() + ":"));
  }
  return $thiz.formatElement__T__Llaika_ast_Invalid__T(pathStr, element);
}
/** @constructor */
function $c_Llaika_api_errors_InvalidDocument$() {
}
$c_Llaika_api_errors_InvalidDocument$.prototype = new $h_O();
$c_Llaika_api_errors_InvalidDocument$.prototype.constructor = $c_Llaika_api_errors_InvalidDocument$;
/** @constructor */
function $h_Llaika_api_errors_InvalidDocument$() {
}
$h_Llaika_api_errors_InvalidDocument$.prototype = $c_Llaika_api_errors_InvalidDocument$.prototype;
$c_Llaika_api_errors_InvalidDocument$.prototype.indent__T__T = (function(lineContent) {
  var lines = $m_sc_StringOps$().split$extension__T__C__AT(lineContent, 10);
  return (($as_T($m_sc_ArrayOps$().head$extension__O__O(lines)) + "\n  ") + $as_T($m_sc_ArrayOps$().last$extension__O__O(lines)));
});
$c_Llaika_api_errors_InvalidDocument$.prototype.format__s_util_Either__Llaika_ast_Path__T = (function(errors, path) {
  var this$1 = $n(errors);
  if ((this$1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$1);
    var b = $n(x2).s_util_Right__f_value;
    var tc = $as_Lcats_Functor($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
    var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(b, tc);
    var f = new $c_sjsr_AnonFunction1(((element) => {
      var element$1 = $as_Llaika_ast_Invalid(element);
      return $p_Llaika_api_errors_InvalidDocument$__formatElement__Llaika_ast_Path__Llaika_ast_Invalid__T($m_Llaika_api_errors_InvalidDocument$(), path, element$1);
    }));
    var target = $n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
    var tc$1 = $as_Lcats_Foldable($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
    var this$6 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(target, tc$1);
    var this$7 = $n($n(this$6.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).toList__O__sci_List(this$6.Lcats_Foldable$ToFoldableOps$$anon$6__f_self));
    return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$7, "", "", "");
  } else {
    if ((!(this$1 instanceof $c_s_util_Left))) {
      throw new $c_s_MatchError(this$1);
    }
    var x3 = $as_s_util_Left(this$1);
    var a = $n(x3).s_util_Left__f_value;
    var tc$2 = $as_Lcats_Functor($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
    var this$10 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(a, tc$2);
    var f$1 = new $c_sjsr_AnonFunction1(((_$2) => {
      var _$2$1 = $as_Llaika_api_config_ConfigError(_$2);
      return $n(_$2$1).message__T();
    }));
    var fa = $n(this$10.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$10.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
    var A = $m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString;
    var F = $as_Lcats_Foldable($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
    return $m_Lcats_syntax_FoldableOps$().mkString_$extension__O__T__T__T__Lcats_Show__Lcats_Foldable__T(fa, "", "\n", "", A, F);
  }
});
$c_Llaika_api_errors_InvalidDocument$.prototype.formatElement__T__Llaika_ast_Invalid__T = (function(pathInfo, element) {
  var x = ((((((("  [" + pathInfo) + $n($n($n(element).source__Llaika_parse_SourceFragment()).position__Llaika_parse_Position()).line__I()) + "]: ") + $n($n(element).message__Llaika_ast_RuntimeMessage()).Llaika_ast_RuntimeMessage__f_content) + "\n       |\n       |  ") + this.indent__T__T($n($n($n(element).source__Llaika_parse_SourceFragment()).position__Llaika_parse_Position()).lineContentWithCaret__T())) + "\n       |\n       |");
  return $m_sc_StringOps$().stripMargin$extension__T__C__T(x, 124);
});
$c_Llaika_api_errors_InvalidDocument$.prototype.from__Llaika_ast_Document__Llaika_config_MessageFilter__s_Option = (function(document, failOn) {
  var invalidElements = $n(document).invalidElements__Llaika_config_MessageFilter__sci_Seq(failOn);
  var this$1 = $n($n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptyChain).fromSeq__sci_Seq__s_Option(invalidElements));
  if (this$1.isEmpty__Z()) {
    return $m_s_None$();
  } else {
    var arg1 = this$1.get__O();
    var errors = new $c_s_util_Right(arg1);
    var path = $n(document).path__Llaika_ast_Path();
    return new $c_s_Some(new $c_Llaika_api_errors_InvalidDocument(errors, path));
  }
});
var $d_Llaika_api_errors_InvalidDocument$ = new $TypeData().initClass($c_Llaika_api_errors_InvalidDocument$, "laika.api.errors.InvalidDocument$", ({
  Llaika_api_errors_InvalidDocument$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_api_errors_InvalidDocument$;
function $m_Llaika_api_errors_InvalidDocument$() {
  if ((!$n_Llaika_api_errors_InvalidDocument$)) {
    $n_Llaika_api_errors_InvalidDocument$ = new $c_Llaika_api_errors_InvalidDocument$();
  }
  return $n_Llaika_api_errors_InvalidDocument$;
}
/** @constructor */
function $c_Llaika_api_format_Formatter$Indentation$() {
  this.Llaika_api_format_Formatter$Indentation$__f_none = null;
  this.Llaika_api_format_Formatter$Indentation$__f_default = null;
  this.Llaika_api_format_Formatter$Indentation$__f_dotted = null;
  $n_Llaika_api_format_Formatter$Indentation$ = this;
  $m_Llaika_api_format_Formatter$Indentation$();
  $m_Llaika_api_format_Formatter$Indentation$();
  var dotted = false;
  this.Llaika_api_format_Formatter$Indentation$__f_none = new $c_Llaika_api_format_Formatter$Indentation(0, 0, dotted);
  $m_Llaika_api_format_Formatter$Indentation$();
  $m_Llaika_api_format_Formatter$Indentation$();
  var dotted$1 = false;
  this.Llaika_api_format_Formatter$Indentation$__f_default = new $c_Llaika_api_format_Formatter$Indentation(0, 2, dotted$1);
  this.Llaika_api_format_Formatter$Indentation$__f_dotted = ($m_Llaika_api_format_Formatter$Indentation$(), new $c_Llaika_api_format_Formatter$Indentation(0, 2, true));
}
$c_Llaika_api_format_Formatter$Indentation$.prototype = new $h_O();
$c_Llaika_api_format_Formatter$Indentation$.prototype.constructor = $c_Llaika_api_format_Formatter$Indentation$;
/** @constructor */
function $h_Llaika_api_format_Formatter$Indentation$() {
}
$h_Llaika_api_format_Formatter$Indentation$.prototype = $c_Llaika_api_format_Formatter$Indentation$.prototype;
var $d_Llaika_api_format_Formatter$Indentation$ = new $TypeData().initClass($c_Llaika_api_format_Formatter$Indentation$, "laika.api.format.Formatter$Indentation$", ({
  Llaika_api_format_Formatter$Indentation$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_api_format_Formatter$Indentation$;
function $m_Llaika_api_format_Formatter$Indentation$() {
  if ((!$n_Llaika_api_format_Formatter$Indentation$)) {
    $n_Llaika_api_format_Formatter$Indentation$ = new $c_Llaika_api_format_Formatter$Indentation$();
  }
  return $n_Llaika_api_format_Formatter$Indentation$;
}
/** @constructor */
function $c_Llaika_api_format_RenderFormat$Overrides$(outer) {
  this.Llaika_api_format_RenderFormat$Overrides$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_format_RenderFormat$Overrides$__f_$outer = outer;
}
$c_Llaika_api_format_RenderFormat$Overrides$.prototype = new $h_O();
$c_Llaika_api_format_RenderFormat$Overrides$.prototype.constructor = $c_Llaika_api_format_RenderFormat$Overrides$;
/** @constructor */
function $h_Llaika_api_format_RenderFormat$Overrides$() {
}
$h_Llaika_api_format_RenderFormat$Overrides$.prototype = $c_Llaika_api_format_RenderFormat$Overrides$.prototype;
$c_Llaika_api_format_RenderFormat$Overrides$.prototype.apply__s_PartialFunction__Llaika_api_format_RenderFormat$Overrides = (function(value) {
  return new $c_Llaika_api_format_RenderFormat$Overrides(this.Llaika_api_format_RenderFormat$Overrides$__f_$outer, value);
});
$c_Llaika_api_format_RenderFormat$Overrides$.prototype.toString__T = (function() {
  return "Overrides";
});
var $d_Llaika_api_format_RenderFormat$Overrides$ = new $TypeData().initClass($c_Llaika_api_format_RenderFormat$Overrides$, "laika.api.format.RenderFormat$Overrides$", ({
  Llaika_api_format_RenderFormat$Overrides$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
function $is_Llaika_ast_BlockResolver(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_BlockResolver)));
}
function $as_Llaika_ast_BlockResolver(obj) {
  return (($is_Llaika_ast_BlockResolver(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.BlockResolver"));
}
function $isArrayOf_Llaika_ast_BlockResolver(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_BlockResolver)));
}
function $asArrayOf_Llaika_ast_BlockResolver(obj, depth) {
  return (($isArrayOf_Llaika_ast_BlockResolver(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.BlockResolver;", depth));
}
/** @constructor */
function $c_Llaika_ast_Columns$() {
}
$c_Llaika_ast_Columns$.prototype = new $h_O();
$c_Llaika_ast_Columns$.prototype.constructor = $c_Llaika_ast_Columns$;
/** @constructor */
function $h_Llaika_ast_Columns$() {
}
$h_Llaika_ast_Columns$.prototype = $c_Llaika_ast_Columns$.prototype;
$c_Llaika_ast_Columns$.prototype.options__sci_Seq__Llaika_ast_Columns = (function(options) {
  var content = $as_sci_Seq($n(options).map__F1__O(new $c_sjsr_AnonFunction1(((options$2) => {
    var options$1 = $as_Llaika_ast_Options(options$2);
    return new $c_Llaika_ast_Column(options$1);
  }))));
  var options$3 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  return new $c_Llaika_ast_Columns(content, options$3);
});
var $d_Llaika_ast_Columns$ = new $TypeData().initClass($c_Llaika_ast_Columns$, "laika.ast.Columns$", ({
  Llaika_ast_Columns$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_ast_Columns$;
function $m_Llaika_ast_Columns$() {
  if ((!$n_Llaika_ast_Columns$)) {
    $n_Llaika_ast_Columns$ = new $c_Llaika_ast_Columns$();
  }
  return $n_Llaika_ast_Columns$;
}
function $ps_Llaika_ast_DocumentTree__collect$1__Llaika_ast_DocumentTree__sci_Seq(tree) {
  var this$1 = $n($n($m_s_Option$().option2Iterable__s_Option__sc_Iterable($n(tree).Llaika_ast_DocumentTree__f_titleDocument)).toSeq__sci_Seq());
  var suffix = $as_sc_IterableOnce($n($n(tree).Llaika_ast_DocumentTree__f_content).flatMap__F1__O(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Llaika_ast_TreeContent(x$1);
    if ((x$1$1 instanceof $c_Llaika_ast_Document)) {
      var doc = $as_Llaika_ast_Document(x$1$1);
      return $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Document.getArrayOf().constr)([doc]))));
    }
    if ((x$1$1 instanceof $c_Llaika_ast_DocumentTree)) {
      var sub = $as_Llaika_ast_DocumentTree(x$1$1);
      return $ps_Llaika_ast_DocumentTree__collect$1__Llaika_ast_DocumentTree__sci_Seq(sub);
    }
    throw new $c_s_MatchError(x$1$1);
  }))));
  return $as_sci_Seq(this$1.appendedAll__sc_IterableOnce__O(suffix));
}
function $ps_Llaika_ast_DocumentTree__hasLinks$1__Llaika_ast_NavigationItem__Z(item) {
  var this$1 = $n($n(item).Llaika_ast_NavigationItem__f_link);
  if ((!this$1.isEmpty__Z())) {
    return true;
  } else {
    return $n($n(item).Llaika_ast_NavigationItem__f_content).exists__F1__Z(new $c_sjsr_AnonFunction1(((item$2) => {
      var item$1 = $as_Llaika_ast_NavigationItem(item$2);
      return $ps_Llaika_ast_DocumentTree__hasLinks$1__Llaika_ast_NavigationItem__Z(item$1);
    })));
  }
}
/** @constructor */
function $c_Llaika_ast_DocumentTree(context, content, titleDocument, templates) {
  this.Llaika_ast_DocumentTree__f_context = null;
  this.Llaika_ast_DocumentTree__f_content = null;
  this.Llaika_ast_DocumentTree__f_titleDocument = null;
  this.Llaika_ast_DocumentTree__f_templates = null;
  this.Llaika_ast_DocumentTree__f_title$lzy1 = null;
  this.Llaika_ast_DocumentTree__f_titlebitmap$1 = false;
  this.Llaika_ast_DocumentTree__f_allDocuments$lzy1 = null;
  this.Llaika_ast_DocumentTree__f_allDocumentsbitmap$1 = false;
  this.Llaika_ast_DocumentTree__f_configScope = null;
  this.Llaika_ast_DocumentTree__f_context = context;
  this.Llaika_ast_DocumentTree__f_content = content;
  this.Llaika_ast_DocumentTree__f_titleDocument = titleDocument;
  this.Llaika_ast_DocumentTree__f_templates = templates;
  this.Llaika_ast_DocumentTree__f_configScope = $m_Llaika_api_config_Origin$TreeScope$();
}
$c_Llaika_ast_DocumentTree.prototype = new $h_O();
$c_Llaika_ast_DocumentTree.prototype.constructor = $c_Llaika_ast_DocumentTree;
/** @constructor */
function $h_Llaika_ast_DocumentTree() {
}
$h_Llaika_ast_DocumentTree.prototype = $c_Llaika_ast_DocumentTree.prototype;
$c_Llaika_ast_DocumentTree.prototype.path__Llaika_ast_Path = (function() {
  return $n(this.Llaika_ast_DocumentTree__f_context).path__Llaika_ast_Path();
});
$c_Llaika_ast_DocumentTree.prototype.config__Llaika_api_config_Config = (function() {
  return $n(this.Llaika_ast_DocumentTree__f_context).config__Llaika_api_config_Config();
});
$c_Llaika_ast_DocumentTree.prototype.position__Llaika_ast_TreePosition = (function() {
  return $n(this.Llaika_ast_DocumentTree__f_context).position__Llaika_ast_TreePosition();
});
$c_Llaika_ast_DocumentTree.prototype.title__s_Option = (function() {
  if ((!this.Llaika_ast_DocumentTree__f_titlebitmap$1)) {
    var this$1 = $n(this.Llaika_ast_DocumentTree__f_titleDocument);
    if (this$1.isEmpty__Z()) {
      var $x_1 = $m_s_None$();
    } else {
      var arg1 = this$1.get__O();
      var _$13 = $as_Llaika_ast_Document(arg1);
      var $x_1 = $n(_$13).title__s_Option();
    }
    var this$2 = $n($x_1);
    this.Llaika_ast_DocumentTree__f_title$lzy1 = (this$2.isEmpty__Z() ? $f_Llaika_ast_TreeContent__titleFromConfig__s_Option(this) : this$2);
    this.Llaika_ast_DocumentTree__f_titlebitmap$1 = true;
  }
  return this.Llaika_ast_DocumentTree__f_title$lzy1;
});
$c_Llaika_ast_DocumentTree.prototype.allDocuments__sci_Seq = (function() {
  if ((!this.Llaika_ast_DocumentTree__f_allDocumentsbitmap$1)) {
    this.Llaika_ast_DocumentTree__f_allDocuments$lzy1 = $ps_Llaika_ast_DocumentTree__collect$1__Llaika_ast_DocumentTree__sci_Seq(this);
    this.Llaika_ast_DocumentTree__f_allDocumentsbitmap$1 = true;
  }
  return this.Llaika_ast_DocumentTree__f_allDocuments$lzy1;
});
$c_Llaika_ast_DocumentTree.prototype.selectDocument__T__s_Option = (function(path) {
  return this.selectDocument__Llaika_ast_RelativePath__s_Option($m_Llaika_ast_RelativePath$().parse__T__Llaika_ast_RelativePath(path));
});
$c_Llaika_ast_DocumentTree.prototype.selectDocument__Llaika_ast_RelativePath__s_Option = (function(path) {
  var this$1 = $n(path);
  var x145 = $as_Llaika_ast_RelativePath($f_Llaika_ast_GenericPath__withoutFragment__Llaika_ast_GenericPath(this$1));
  if ((x145 !== null)) {
    var x150 = $m_Llaika_ast_$div$().unapply__Llaika_ast_RelativePath__s_Option(x145);
    if ((!$n(x150).isEmpty__Z())) {
      var x151 = $as_T2($n(x150).get__O());
      var x152 = $as_Llaika_ast_RelativePath($n(x151)._1__O());
      var x153 = $as_T($n(x151)._2__O());
      var x = $m_Llaika_ast_RelativePath$CurrentTree$();
      if ((x === x152)) {
        var prefix$1 = $n($m_s_Option$().option2Iterable__s_Option__sc_Iterable(this.Llaika_ast_DocumentTree__f_titleDocument)).toSeq__sci_Seq();
        var this$2 = $n(this.Llaika_ast_DocumentTree__f_content);
        return $n($as_sc_IterableOnceOps(this$2.prependedAll__sc_IterableOnce__O(prefix$1))).collectFirst__s_PartialFunction__s_Option(new $c_Llaika_ast_DocumentTree$$anon$6(x153));
      }
      if (($n(path).parentLevels__I() === 0)) {
        var this$3 = $n(this.selectSubtree__Llaika_ast_RelativePath__s_Option(x152));
        if (this$3.isEmpty__Z()) {
          return $m_s_None$();
        } else {
          var arg1 = this$3.get__O();
          var _$14 = $as_Llaika_ast_DocumentTree(arg1);
          return $n(_$14).selectDocument__T__s_Option(x153);
        }
      }
    }
  }
  return $m_s_None$();
});
$c_Llaika_ast_DocumentTree.prototype.selectTemplate__T__s_Option = (function(path) {
  return this.selectTemplate__Llaika_ast_RelativePath__s_Option($m_Llaika_ast_RelativePath$().parse__T__Llaika_ast_RelativePath(path));
});
$c_Llaika_ast_DocumentTree.prototype.selectTemplate__Llaika_ast_RelativePath__s_Option = (function(path) {
  if ((path !== null)) {
    var x162 = $m_Llaika_ast_$div$().unapply__Llaika_ast_RelativePath__s_Option(path);
    if ((!$n(x162).isEmpty__Z())) {
      var x163 = $as_T2($n(x162).get__O());
      var x164 = $as_Llaika_ast_RelativePath($n(x163)._1__O());
      var x165 = $as_T($n(x163)._2__O());
      var x = $m_Llaika_ast_RelativePath$CurrentTree$();
      if ((x === x164)) {
        return $n(this.Llaika_ast_DocumentTree__f_templates).find__F1__s_Option(new $c_sjsr_AnonFunction1(((_$15) => {
          var _$15$1 = $as_Llaika_ast_TemplateDocument(_$15);
          return ($n($n(_$15$1).path__Llaika_ast_Path()).name__T() === x165);
        })));
      }
      if (($n(path).parentLevels__I() === 0)) {
        var this$1 = $n(this.selectSubtree__Llaika_ast_RelativePath__s_Option(x164));
        if (this$1.isEmpty__Z()) {
          return $m_s_None$();
        } else {
          var arg1 = this$1.get__O();
          var _$16 = $as_Llaika_ast_DocumentTree(arg1);
          return $n(_$16).selectTemplate__T__s_Option(x165);
        }
      }
    }
  }
  return $m_s_None$();
});
$c_Llaika_ast_DocumentTree.prototype.selectSubtree__T__s_Option = (function(path) {
  return this.selectSubtree__Llaika_ast_RelativePath__s_Option($m_Llaika_ast_RelativePath$().parse__T__Llaika_ast_RelativePath(path));
});
$c_Llaika_ast_DocumentTree.prototype.selectSubtree__Llaika_ast_RelativePath__s_Option = (function(path) {
  var x = $m_Llaika_ast_RelativePath$CurrentTree$();
  if ((x === path)) {
    return new $c_s_Some(this);
  }
  if ((path !== null)) {
    var x175 = $m_Llaika_ast_$div$().unapply__Llaika_ast_RelativePath__s_Option(path);
    if ((!$n(x175).isEmpty__Z())) {
      var x176 = $as_T2($n(x175).get__O());
      var x177 = $as_Llaika_ast_RelativePath($n(x176)._1__O());
      var x178 = $as_T($n(x176)._2__O());
      var x$3 = $m_Llaika_ast_RelativePath$CurrentTree$();
      if ((x$3 === x177)) {
        return $n(this.Llaika_ast_DocumentTree__f_content).collectFirst__s_PartialFunction__s_Option(new $c_Llaika_ast_DocumentTree$$anon$7(x178));
      }
      if (($n(path).parentLevels__I() === 0)) {
        var this$2 = $n(this.selectSubtree__Llaika_ast_RelativePath__s_Option(x177));
        if (this$2.isEmpty__Z()) {
          return $m_s_None$();
        } else {
          var arg1 = this$2.get__O();
          var _$18 = $as_Llaika_ast_DocumentTree(arg1);
          return $n(_$18).selectSubtree__T__s_Option(x178);
        }
      }
    }
  }
  return $m_s_None$();
});
$c_Llaika_ast_DocumentTree.prototype.asNavigationItem__Llaika_ast_NavigationBuilderContext__Llaika_ast_NavigationItem = (function(context) {
  var navContent = $as_sci_Seq($n($as_sc_IterableOps($n(this.Llaika_ast_DocumentTree__f_content).filterNot__F1__O(new $c_sjsr_AnonFunction1(((_$19) => {
    var _$19$1 = $as_Llaika_ast_TreeContent(_$19);
    var x = $n(_$19$1).path__Llaika_ast_Path();
    var x$2 = $n(context).Llaika_ast_NavigationBuilderContext$Impl__f_refPath;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      return $n(context).Llaika_ast_NavigationBuilderContext$Impl__f_excludeSelf;
    } else {
      return false;
    }
  }))))).filterNot__F1__O(new $c_sjsr_AnonFunction1(((_$20) => {
    var _$20$1 = $as_Llaika_ast_TreeContent(_$20);
    var this$1 = $n($n($n(_$20$1).config__Llaika_api_config_Config()).get__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either($m_Llaika_config_LaikaKeys$().Llaika_config_LaikaKeys$__f_excludeFromNavigation, $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_boolean));
    if ((this$1 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$1);
      var b = $n(x2).s_util_Right__f_value;
      var $x_1 = b;
    } else {
      var $x_1 = false;
    }
    return $uZ($x_1);
  }))));
  var children = ($n(context).Llaika_ast_NavigationBuilderContext__f_isComplete ? $m_sci_Nil$() : $as_sci_Seq($n($as_sc_IterableOps($n(navContent).map__F1__O(new $c_sjsr_AnonFunction1(((_$21) => {
    var _$21$1 = $as_Llaika_ast_TreeContent(_$21);
    return $n(_$21$1).asNavigationItem__Llaika_ast_NavigationBuilderContext__Llaika_ast_NavigationItem($n(context).nextLevel__Llaika_ast_NavigationBuilderContext());
  }))))).filter__F1__O(new $c_sjsr_AnonFunction1(((item) => {
    var item$1 = $as_Llaika_ast_NavigationItem(item);
    return $ps_Llaika_ast_DocumentTree__hasLinks$1__Llaika_ast_NavigationItem__Z(item$1);
  })))));
  var this$2 = $n(this.title__s_Option());
  if (this$2.isEmpty__Z()) {
    var this$3 = $m_Llaika_ast_SpanSequence$();
    var text = $n(this.path__Llaika_ast_Path()).name__T();
    var texts = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([]));
    var $x_2 = $as_Llaika_ast_SpanSequence($f_Llaika_ast_SpanContainerCompanion__apply__T__sci_Seq__O(this$3, text, texts));
  } else {
    var $x_2 = this$2.get__O();
  }
  var navTitle = $as_Llaika_ast_SpanSequence($x_2);
  return $n(context).newNavigationItem__Llaika_ast_SpanSequence__s_Option__sci_Seq__Llaika_config_TargetFormats__Llaika_ast_NavigationItem(navTitle, this.Llaika_ast_DocumentTree__f_titleDocument, children, $f_Llaika_ast_TreeContent__targetFormats__Llaika_config_TargetFormats(this));
});
$c_Llaika_ast_DocumentTree.prototype.configScope__Llaika_api_config_Origin$Scope = (function() {
  return this.Llaika_ast_DocumentTree__f_configScope;
});
function $as_Llaika_ast_DocumentTree(obj) {
  return (((obj instanceof $c_Llaika_ast_DocumentTree) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.DocumentTree"));
}
function $isArrayOf_Llaika_ast_DocumentTree(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_DocumentTree)));
}
function $asArrayOf_Llaika_ast_DocumentTree(obj, depth) {
  return (($isArrayOf_Llaika_ast_DocumentTree(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.DocumentTree;", depth));
}
var $d_Llaika_ast_DocumentTree = new $TypeData().initClass($c_Llaika_ast_DocumentTree, "laika.ast.DocumentTree", ({
  Llaika_ast_DocumentTree: 1,
  Llaika_ast_Navigatable: 1,
  Llaika_ast_TreeContent: 1
}));
function $is_Llaika_ast_DocumentTreeBuilder$TreeContentPart(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_DocumentTreeBuilder$TreeContentPart)));
}
function $as_Llaika_ast_DocumentTreeBuilder$TreeContentPart(obj) {
  return (($is_Llaika_ast_DocumentTreeBuilder$TreeContentPart(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.DocumentTreeBuilder$TreeContentPart"));
}
function $isArrayOf_Llaika_ast_DocumentTreeBuilder$TreeContentPart(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_DocumentTreeBuilder$TreeContentPart)));
}
function $asArrayOf_Llaika_ast_DocumentTreeBuilder$TreeContentPart(obj, depth) {
  return (($isArrayOf_Llaika_ast_DocumentTreeBuilder$TreeContentPart(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.DocumentTreeBuilder$TreeContentPart;", depth));
}
/** @constructor */
function $c_Llaika_ast_DocumentType() {
}
$c_Llaika_ast_DocumentType.prototype = new $h_O();
$c_Llaika_ast_DocumentType.prototype.constructor = $c_Llaika_ast_DocumentType;
/** @constructor */
function $h_Llaika_ast_DocumentType() {
}
$h_Llaika_ast_DocumentType.prototype = $c_Llaika_ast_DocumentType.prototype;
$c_Llaika_ast_DocumentType.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
function $is_Llaika_ast_ElementContainer(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_ElementContainer)));
}
function $as_Llaika_ast_ElementContainer(obj) {
  return (($is_Llaika_ast_ElementContainer(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.ElementContainer"));
}
function $isArrayOf_Llaika_ast_ElementContainer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_ElementContainer)));
}
function $asArrayOf_Llaika_ast_ElementContainer(obj, depth) {
  return (($isArrayOf_Llaika_ast_ElementContainer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.ElementContainer;", depth));
}
var $d_Llaika_ast_ElementContainer = new $TypeData().initClass(1, "laika.ast.ElementContainer", ({
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1
}));
function $is_Llaika_ast_GlobalLink(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_GlobalLink)));
}
function $as_Llaika_ast_GlobalLink(obj) {
  return (($is_Llaika_ast_GlobalLink(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.GlobalLink"));
}
function $isArrayOf_Llaika_ast_GlobalLink(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_GlobalLink)));
}
function $asArrayOf_Llaika_ast_GlobalLink(obj, depth) {
  return (($isArrayOf_Llaika_ast_GlobalLink(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.GlobalLink;", depth));
}
/** @constructor */
function $c_Llaika_ast_InternalTarget$() {
}
$c_Llaika_ast_InternalTarget$.prototype = new $h_O();
$c_Llaika_ast_InternalTarget$.prototype.constructor = $c_Llaika_ast_InternalTarget$;
/** @constructor */
function $h_Llaika_ast_InternalTarget$() {
}
$h_Llaika_ast_InternalTarget$.prototype = $c_Llaika_ast_InternalTarget$.prototype;
$c_Llaika_ast_InternalTarget$.prototype.apply__Llaika_ast_VirtualPath__Llaika_ast_InternalTarget = (function(path) {
  matchResult16: {
    var $x_1;
    if ($is_Llaika_ast_RelativePath(path)) {
      var p = $as_Llaika_ast_RelativePath(path);
      var $x_1 = new $c_Llaika_ast_InternalTarget$Relative(p);
      break matchResult16;
    }
    if ($is_Llaika_ast_Path(path)) {
      var p$2 = $as_Llaika_ast_Path(path);
      var $x_1 = new $c_Llaika_ast_InternalTarget$Absolute(p$2);
      break matchResult16;
    }
    throw new $c_s_MatchError(path);
  }
  return $as_Llaika_ast_InternalTarget($x_1);
});
var $d_Llaika_ast_InternalTarget$ = new $TypeData().initClass($c_Llaika_ast_InternalTarget$, "laika.ast.InternalTarget$", ({
  Llaika_ast_InternalTarget$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Llaika_ast_InternalTarget$;
function $m_Llaika_ast_InternalTarget$() {
  if ((!$n_Llaika_ast_InternalTarget$)) {
    $n_Llaika_ast_InternalTarget$ = new $c_Llaika_ast_InternalTarget$();
  }
  return $n_Llaika_ast_InternalTarget$;
}
/** @constructor */
function $c_Llaika_ast_InvalidBlock$() {
}
$c_Llaika_ast_InvalidBlock$.prototype = new $h_O();
$c_Llaika_ast_InvalidBlock$.prototype.constructor = $c_Llaika_ast_InvalidBlock$;
/** @constructor */
function $h_Llaika_ast_InvalidBlock$() {
}
$h_Llaika_ast_InvalidBlock$.prototype = $c_Llaika_ast_InvalidBlock$.prototype;
$c_Llaika_ast_InvalidBlock$.prototype.apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidBlock = (function(message, source) {
  var level = $m_Llaika_ast_MessageLevel$Error$();
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  return this.apply__Llaika_ast_RuntimeMessage__Llaika_parse_SourceFragment__Llaika_ast_InvalidBlock(new $c_Llaika_ast_RuntimeMessage(level, message, options), source);
});
$c_Llaika_ast_InvalidBlock$.prototype.apply__Llaika_ast_RuntimeMessage__Llaika_parse_SourceFragment__Llaika_ast_InvalidBlock = (function(message, source) {
  var content = $n(source).input__T();
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  var fallback = new $c_Llaika_ast_LiteralBlock(content, options);
  var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  return new $c_Llaika_ast_InvalidBlock(message, source, fallback, options$1);
});
var $d_Llaika_ast_InvalidBlock$ = new $TypeData().initClass($c_Llaika_ast_InvalidBlock$, "laika.ast.InvalidBlock$", ({
  Llaika_ast_InvalidBlock$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_ast_InvalidBlock$;
function $m_Llaika_ast_InvalidBlock$() {
  if ((!$n_Llaika_ast_InvalidBlock$)) {
    $n_Llaika_ast_InvalidBlock$ = new $c_Llaika_ast_InvalidBlock$();
  }
  return $n_Llaika_ast_InvalidBlock$;
}
/** @constructor */
function $c_Llaika_ast_InvalidSpan$() {
}
$c_Llaika_ast_InvalidSpan$.prototype = new $h_O();
$c_Llaika_ast_InvalidSpan$.prototype.constructor = $c_Llaika_ast_InvalidSpan$;
/** @constructor */
function $h_Llaika_ast_InvalidSpan$() {
}
$h_Llaika_ast_InvalidSpan$.prototype = $c_Llaika_ast_InvalidSpan$.prototype;
$c_Llaika_ast_InvalidSpan$.prototype.apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan = (function(message, source) {
  var level = $m_Llaika_ast_MessageLevel$Error$();
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  return this.apply__Llaika_ast_RuntimeMessage__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan(new $c_Llaika_ast_RuntimeMessage(level, message, options), source);
});
$c_Llaika_ast_InvalidSpan$.prototype.apply__Llaika_ast_RuntimeMessage__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan = (function(message, source) {
  var content = $n(source).input__T();
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  var fallback = new $c_Llaika_ast_Literal(content, options);
  var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  return new $c_Llaika_ast_InvalidSpan(message, source, fallback, options$1);
});
var $d_Llaika_ast_InvalidSpan$ = new $TypeData().initClass($c_Llaika_ast_InvalidSpan$, "laika.ast.InvalidSpan$", ({
  Llaika_ast_InvalidSpan$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_ast_InvalidSpan$;
function $m_Llaika_ast_InvalidSpan$() {
  if ((!$n_Llaika_ast_InvalidSpan$)) {
    $n_Llaika_ast_InvalidSpan$ = new $c_Llaika_ast_InvalidSpan$();
  }
  return $n_Llaika_ast_InvalidSpan$;
}
/** @constructor */
function $c_Llaika_ast_LengthUnit$px$() {
  this.Llaika_ast_LengthUnit__f_displayValue = null;
  $ct_Llaika_ast_LengthUnit__T__(this, "px");
}
$c_Llaika_ast_LengthUnit$px$.prototype = new $h_Llaika_ast_LengthUnit();
$c_Llaika_ast_LengthUnit$px$.prototype.constructor = $c_Llaika_ast_LengthUnit$px$;
/** @constructor */
function $h_Llaika_ast_LengthUnit$px$() {
}
$h_Llaika_ast_LengthUnit$px$.prototype = $c_Llaika_ast_LengthUnit$px$.prototype;
var $d_Llaika_ast_LengthUnit$px$ = new $TypeData().initClass($c_Llaika_ast_LengthUnit$px$, "laika.ast.LengthUnit$px$", ({
  Llaika_ast_LengthUnit$px$: 1,
  Llaika_ast_LengthUnit: 1,
  F1: 1
}));
var $n_Llaika_ast_LengthUnit$px$;
function $m_Llaika_ast_LengthUnit$px$() {
  if ((!$n_Llaika_ast_LengthUnit$px$)) {
    $n_Llaika_ast_LengthUnit$px$ = new $c_Llaika_ast_LengthUnit$px$();
  }
  return $n_Llaika_ast_LengthUnit$px$;
}
/** @constructor */
function $c_Llaika_ast_LinkDefinition$() {
}
$c_Llaika_ast_LinkDefinition$.prototype = new $h_O();
$c_Llaika_ast_LinkDefinition$.prototype.constructor = $c_Llaika_ast_LinkDefinition$;
/** @constructor */
function $h_Llaika_ast_LinkDefinition$() {
}
$h_Llaika_ast_LinkDefinition$.prototype = $c_Llaika_ast_LinkDefinition$.prototype;
$c_Llaika_ast_LinkDefinition$.prototype.create__T__T__s_Option__Llaika_ast_Block = (function(id, url, title) {
  var target = $m_Llaika_ast_Target$().parse__T__Llaika_ast_Target(url);
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  return new $c_Llaika_ast_LinkDefinition(id, target, title, options);
});
var $d_Llaika_ast_LinkDefinition$ = new $TypeData().initClass($c_Llaika_ast_LinkDefinition$, "laika.ast.LinkDefinition$", ({
  Llaika_ast_LinkDefinition$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_ast_LinkDefinition$;
function $m_Llaika_ast_LinkDefinition$() {
  if ((!$n_Llaika_ast_LinkDefinition$)) {
    $n_Llaika_ast_LinkDefinition$ = new $c_Llaika_ast_LinkDefinition$();
  }
  return $n_Llaika_ast_LinkDefinition$;
}
function $is_Llaika_ast_LocalLink(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_LocalLink)));
}
function $as_Llaika_ast_LocalLink(obj) {
  return (($is_Llaika_ast_LocalLink(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.LocalLink"));
}
function $isArrayOf_Llaika_ast_LocalLink(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_LocalLink)));
}
function $asArrayOf_Llaika_ast_LocalLink(obj, depth) {
  return (($isArrayOf_Llaika_ast_LocalLink(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.LocalLink;", depth));
}
/** @constructor */
function $c_Llaika_ast_NavigationBuilderContext$() {
}
$c_Llaika_ast_NavigationBuilderContext$.prototype = new $h_O();
$c_Llaika_ast_NavigationBuilderContext$.prototype.constructor = $c_Llaika_ast_NavigationBuilderContext$;
/** @constructor */
function $h_Llaika_ast_NavigationBuilderContext$() {
}
$h_Llaika_ast_NavigationBuilderContext$.prototype = $c_Llaika_ast_NavigationBuilderContext$.prototype;
$c_Llaika_ast_NavigationBuilderContext$.prototype.defaults__Llaika_ast_NavigationBuilderContext = (function() {
  var refPath = $m_Llaika_ast_Path$Root$();
  var this$1 = $m_sci_Set$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([]));
  var itemStyles = this$1.from__sc_IterableOnce__sci_Set(elems);
  return new $c_Llaika_ast_NavigationBuilderContext$Impl(refPath, itemStyles, 2147483647, 1, false, false);
});
var $d_Llaika_ast_NavigationBuilderContext$ = new $TypeData().initClass($c_Llaika_ast_NavigationBuilderContext$, "laika.ast.NavigationBuilderContext$", ({
  Llaika_ast_NavigationBuilderContext$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Llaika_ast_NavigationBuilderContext$;
function $m_Llaika_ast_NavigationBuilderContext$() {
  if ((!$n_Llaika_ast_NavigationBuilderContext$)) {
    $n_Llaika_ast_NavigationBuilderContext$ = new $c_Llaika_ast_NavigationBuilderContext$();
  }
  return $n_Llaika_ast_NavigationBuilderContext$;
}
/** @constructor */
function $c_Llaika_ast_Options$() {
  this.Llaika_ast_Options$__f_empty = null;
  $n_Llaika_ast_Options$ = this;
  var id = $m_s_None$();
  var this$1 = $m_sci_Set$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([]));
  var styles = this$1.from__sc_IterableOnce__sci_Set(elems);
  this.Llaika_ast_Options$__f_empty = new $c_Llaika_ast_Options$Impl(id, styles);
}
$c_Llaika_ast_Options$.prototype = new $h_O();
$c_Llaika_ast_Options$.prototype.constructor = $c_Llaika_ast_Options$;
/** @constructor */
function $h_Llaika_ast_Options$() {
}
$h_Llaika_ast_Options$.prototype = $c_Llaika_ast_Options$.prototype;
$c_Llaika_ast_Options$.prototype.apply__s_Option__sci_Set__Llaika_ast_Options = (function(id, styles) {
  return (($n(id).isEmpty__Z() && $n(styles).isEmpty__Z()) ? this.Llaika_ast_Options$__f_empty : new $c_Llaika_ast_Options$Impl(id, styles));
});
$c_Llaika_ast_Options$.prototype.apply$default$2__sci_Set = (function() {
  var this$1 = $m_sci_Set$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([]));
  return this$1.from__sc_IterableOnce__sci_Set(elems);
});
var $d_Llaika_ast_Options$ = new $TypeData().initClass($c_Llaika_ast_Options$, "laika.ast.Options$", ({
  Llaika_ast_Options$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Llaika_ast_Options$;
function $m_Llaika_ast_Options$() {
  if ((!$n_Llaika_ast_Options$)) {
    $n_Llaika_ast_Options$ = new $c_Llaika_ast_Options$();
  }
  return $n_Llaika_ast_Options$;
}
/** @constructor */
function $c_Llaika_ast_OutputContext$() {
}
$c_Llaika_ast_OutputContext$.prototype = new $h_O();
$c_Llaika_ast_OutputContext$.prototype.constructor = $c_Llaika_ast_OutputContext$;
/** @constructor */
function $h_Llaika_ast_OutputContext$() {
}
$h_Llaika_ast_OutputContext$.prototype = $c_Llaika_ast_OutputContext$.prototype;
$c_Llaika_ast_OutputContext$.prototype.apply__Llaika_api_format_RenderFormat__Llaika_ast_OutputContext = (function(format) {
  var fileSuffix = $n(format).fileSuffix__T();
  var this$1 = $n(format);
  var this$2 = $n(this$1.toString__T());
  var formatSelector = $as_T(this$2.toLowerCase());
  return new $c_Llaika_ast_OutputContext$Impl(fileSuffix, formatSelector);
});
var $d_Llaika_ast_OutputContext$ = new $TypeData().initClass($c_Llaika_ast_OutputContext$, "laika.ast.OutputContext$", ({
  Llaika_ast_OutputContext$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Llaika_ast_OutputContext$;
function $m_Llaika_ast_OutputContext$() {
  if ((!$n_Llaika_ast_OutputContext$)) {
    $n_Llaika_ast_OutputContext$ = new $c_Llaika_ast_OutputContext$();
  }
  return $n_Llaika_ast_OutputContext$;
}
/** @constructor */
function $c_Llaika_ast_Path$() {
}
$c_Llaika_ast_Path$.prototype = new $h_O();
$c_Llaika_ast_Path$.prototype.constructor = $c_Llaika_ast_Path$;
/** @constructor */
function $h_Llaika_ast_Path$() {
}
$h_Llaika_ast_Path$.prototype = $c_Llaika_ast_Path$.prototype;
$c_Llaika_ast_Path$.prototype.parse__T__Llaika_ast_Path = (function(str) {
  if ((str === "/")) {
    return $m_Llaika_ast_Path$Root$();
  } else {
    var $x_2 = $m_s_Predef$();
    var $x_1 = $m_sc_StringOps$();
    var x = $m_sc_StringOps$().stripPrefix$extension__T__T__T(str, "/");
    var this$3 = $n($n($x_1).stripSuffix$extension__T__T__T(x, "/"));
    var this$4 = $n($n($x_2).wrapRefArray__AO__scm_ArraySeq$ofRef($f_T__split__T__I__AT(this$3, "/", 0)));
    var segments = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$4);
    if ($f_T__endsWith__T__Z($n(str), "/")) {
      var _1 = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptyChain).fromSeq__sci_Seq__s_Option(segments);
      var _2 = $m_s_None$();
      var _3 = $m_s_None$();
      var parts = new $c_T3(_1, _2, _3);
    } else {
      var parts = $m_Llaika_ast_VirtualPath$().parseLastSegment__sci_List__T3(segments);
    }
    if ((parts !== null)) {
      var x65 = $as_s_Option($n(parts).T3__f__1);
      if ((x65 instanceof $c_s_Some)) {
        var seg = $n($as_s_Some(x65)).s_Some__f_value;
        var suf = $as_s_Option($n(parts).T3__f__2);
        var frag = $as_s_Option($n(parts).T3__f__3);
        return new $c_Llaika_ast_Path$Segments(seg, suf, frag);
      }
    }
    return $m_Llaika_ast_Path$Root$();
  }
});
var $d_Llaika_ast_Path$ = new $TypeData().initClass($c_Llaika_ast_Path$, "laika.ast.Path$", ({
  Llaika_ast_Path$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Llaika_ast_Path$;
function $m_Llaika_ast_Path$() {
  if ((!$n_Llaika_ast_Path$)) {
    $n_Llaika_ast_Path$ = new $c_Llaika_ast_Path$();
  }
  return $n_Llaika_ast_Path$;
}
/** @constructor */
function $c_Llaika_ast_RawLink$() {
}
$c_Llaika_ast_RawLink$.prototype = new $h_O();
$c_Llaika_ast_RawLink$.prototype.constructor = $c_Llaika_ast_RawLink$;
/** @constructor */
function $h_Llaika_ast_RawLink$() {
}
$h_Llaika_ast_RawLink$.prototype = $c_Llaika_ast_RawLink$.prototype;
$c_Llaika_ast_RawLink$.prototype.internal__Llaika_ast_VirtualPath__Llaika_ast_RawLink = (function(path) {
  var target = $m_Llaika_ast_InternalTarget$().apply__Llaika_ast_VirtualPath__Llaika_ast_InternalTarget(path);
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  return new $c_Llaika_ast_RawLink(target, options);
});
$c_Llaika_ast_RawLink$.prototype.external__T__Llaika_ast_RawLink = (function(url) {
  var target = new $c_Llaika_ast_ExternalTarget(url);
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  return new $c_Llaika_ast_RawLink(target, options);
});
var $d_Llaika_ast_RawLink$ = new $TypeData().initClass($c_Llaika_ast_RawLink$, "laika.ast.RawLink$", ({
  Llaika_ast_RawLink$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_ast_RawLink$;
function $m_Llaika_ast_RawLink$() {
  if ((!$n_Llaika_ast_RawLink$)) {
    $n_Llaika_ast_RawLink$ = new $c_Llaika_ast_RawLink$();
  }
  return $n_Llaika_ast_RawLink$;
}
function $is_Llaika_ast_Reference(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_Reference)));
}
function $as_Llaika_ast_Reference(obj) {
  return (($is_Llaika_ast_Reference(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Reference"));
}
function $isArrayOf_Llaika_ast_Reference(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Reference)));
}
function $asArrayOf_Llaika_ast_Reference(obj, depth) {
  return (($isArrayOf_Llaika_ast_Reference(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Reference;", depth));
}
function $p_Llaika_ast_RelativePath$__countParents$1__I__T__T2($thiz, current, path) {
  var path$tailLocal1 = path;
  var current$tailLocal1 = current;
  while (true) {
    var this$1 = $n(path$tailLocal1);
    if (((this$1.length >= 0) && ($as_T(this$1.substring(0, 2)) === ".."))) {
      var current$tailLocal1$tmp1 = ((1 + current$tailLocal1) | 0);
      var $x_2 = $m_sc_StringOps$();
      var $x_1 = $m_sc_StringOps$();
      var x = path$tailLocal1;
      var x$1 = $n($x_1).drop$extension__T__I__T(x, 2);
      var path$tailLocal1$tmp1 = $n($x_2).stripPrefix$extension__T__T__T(x$1, "/");
      current$tailLocal1 = current$tailLocal1$tmp1;
      path$tailLocal1 = path$tailLocal1$tmp1;
    } else {
      var _1 = current$tailLocal1;
      var _2 = path$tailLocal1;
      return new $c_T2(_1, _2);
    }
  }
}
/** @constructor */
function $c_Llaika_ast_RelativePath$() {
}
$c_Llaika_ast_RelativePath$.prototype = new $h_O();
$c_Llaika_ast_RelativePath$.prototype.constructor = $c_Llaika_ast_RelativePath$;
/** @constructor */
function $h_Llaika_ast_RelativePath$() {
}
$h_Llaika_ast_RelativePath$.prototype = $c_Llaika_ast_RelativePath$.prototype;
$c_Llaika_ast_RelativePath$.prototype.parse__T__Llaika_ast_RelativePath = (function(str) {
  var $x_1 = $m_sc_StringOps$();
  var x = $m_sc_StringOps$().stripPrefix$extension__T__T__T(str, "/");
  var x120 = $n($x_1).stripSuffix$extension__T__T__T(x, "/");
  switch (x120) {
    case "":
    case "#": {
      var fragment = $m_s_None$();
      return new $c_Llaika_ast_RelativePath$CurrentDocument(fragment);
      break;
    }
    case ".": {
      return $m_Llaika_ast_RelativePath$CurrentTree$();
      break;
    }
    default: {
      var this$5 = $n(x120);
      if (((this$5.length >= 0) && ($as_T(this$5.substring(0, 1)) === "#"))) {
        return $m_Llaika_ast_RelativePath$CurrentDocument$().apply__T__Llaika_ast_RelativePath$CurrentDocument($m_sc_StringOps$().drop$extension__T__I__T(x120, 1));
      }
      matchResult33: {
        var \u03b46$___1;
        var \u03b46$___2;
        var x111 = $p_Llaika_ast_RelativePath$__countParents$1__I__T__T2(this, 0, x120);
        if ((x111 !== null)) {
          var levels = $uI($n(x111)._1__O());
          var rest = $as_T($n(x111)._2__O());
          var \u03b46$___1 = levels;
          var \u03b46$___2 = rest;
          break matchResult33;
        }
        throw new $c_s_MatchError(x111);
      }
      var levels$2 = $uI(\u03b46$___1);
      var rest$2 = $as_T(\u03b46$___2);
      var $x_2 = $m_s_Predef$();
      var this$8 = $n(rest$2);
      var this$9 = $n($n($x_2).wrapRefArray__AO__scm_ArraySeq$ofRef($f_T__split__T__I__AT(this$8, "/", 0)));
      var segments = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$9);
      var this$11 = $n(rest$2);
      if ((this$11 === "")) {
        var _1 = $m_s_None$();
        var _2 = $m_s_None$();
        var _3 = $m_s_None$();
        var parts = new $c_T3(_1, _2, _3);
      } else if ($f_T__endsWith__T__Z($n(str), "/")) {
        var _1$1 = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptyChain).fromSeq__sci_Seq__s_Option(segments);
        var _2$1 = $m_s_None$();
        var _3$1 = $m_s_None$();
        var parts = new $c_T3(_1$1, _2$1, _3$1);
      } else {
        var parts = $m_Llaika_ast_VirtualPath$().parseLastSegment__sci_List__T3(segments);
      }
      if ((parts !== null)) {
        var x115 = $as_s_Option($n(parts).T3__f__1);
        if ((x115 instanceof $c_s_Some)) {
          var seg = $n($as_s_Some(x115)).s_Some__f_value;
          var suf = $as_s_Option($n(parts).T3__f__2);
          var frag = $as_s_Option($n(parts).T3__f__3);
          return new $c_Llaika_ast_RelativePath$Segments(seg, suf, frag, levels$2);
        }
      }
      return new $c_Llaika_ast_RelativePath$Parent(levels$2);
    }
  }
});
var $d_Llaika_ast_RelativePath$ = new $TypeData().initClass($c_Llaika_ast_RelativePath$, "laika.ast.RelativePath$", ({
  Llaika_ast_RelativePath$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Llaika_ast_RelativePath$;
function $m_Llaika_ast_RelativePath$() {
  if ((!$n_Llaika_ast_RelativePath$)) {
    $n_Llaika_ast_RelativePath$ = new $c_Llaika_ast_RelativePath$();
  }
  return $n_Llaika_ast_RelativePath$;
}
/** @constructor */
function $c_Llaika_ast_RelativePath$CurrentDocument$() {
}
$c_Llaika_ast_RelativePath$CurrentDocument$.prototype = new $h_O();
$c_Llaika_ast_RelativePath$CurrentDocument$.prototype.constructor = $c_Llaika_ast_RelativePath$CurrentDocument$;
/** @constructor */
function $h_Llaika_ast_RelativePath$CurrentDocument$() {
}
$h_Llaika_ast_RelativePath$CurrentDocument$.prototype = $c_Llaika_ast_RelativePath$CurrentDocument$.prototype;
$c_Llaika_ast_RelativePath$CurrentDocument$.prototype.apply__T__Llaika_ast_RelativePath$CurrentDocument = (function(fragment) {
  var fragment$1 = new $c_s_Some(fragment);
  return new $c_Llaika_ast_RelativePath$CurrentDocument(fragment$1);
});
var $d_Llaika_ast_RelativePath$CurrentDocument$ = new $TypeData().initClass($c_Llaika_ast_RelativePath$CurrentDocument$, "laika.ast.RelativePath$CurrentDocument$", ({
  Llaika_ast_RelativePath$CurrentDocument$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_ast_RelativePath$CurrentDocument$;
function $m_Llaika_ast_RelativePath$CurrentDocument$() {
  if ((!$n_Llaika_ast_RelativePath$CurrentDocument$)) {
    $n_Llaika_ast_RelativePath$CurrentDocument$ = new $c_Llaika_ast_RelativePath$CurrentDocument$();
  }
  return $n_Llaika_ast_RelativePath$CurrentDocument$;
}
/** @constructor */
function $c_Llaika_ast_SpanLink$() {
}
$c_Llaika_ast_SpanLink$.prototype = new $h_O();
$c_Llaika_ast_SpanLink$.prototype.constructor = $c_Llaika_ast_SpanLink$;
/** @constructor */
function $h_Llaika_ast_SpanLink$() {
}
$h_Llaika_ast_SpanLink$.prototype = $c_Llaika_ast_SpanLink$.prototype;
$c_Llaika_ast_SpanLink$.prototype.external__T__Llaika_ast_SpanLink$Companion = (function(url) {
  var target = new $c_Llaika_ast_ExternalTarget(url);
  return new $c_Llaika_ast_SpanLink$$anon$1(target, this);
});
var $d_Llaika_ast_SpanLink$ = new $TypeData().initClass($c_Llaika_ast_SpanLink$, "laika.ast.SpanLink$", ({
  Llaika_ast_SpanLink$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_ast_SpanLink$;
function $m_Llaika_ast_SpanLink$() {
  if ((!$n_Llaika_ast_SpanLink$)) {
    $n_Llaika_ast_SpanLink$ = new $c_Llaika_ast_SpanLink$();
  }
  return $n_Llaika_ast_SpanLink$;
}
/** @constructor */
function $c_Llaika_ast_SpanLink$$anon$1(target$3, outer) {
  this.Llaika_ast_SpanLink$$anon$1__f_target$2 = null;
  this.Llaika_ast_SpanLink$$anon$1__f_target$2 = target$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_ast_SpanLink$$anon$1.prototype = new $h_O();
$c_Llaika_ast_SpanLink$$anon$1.prototype.constructor = $c_Llaika_ast_SpanLink$$anon$1;
/** @constructor */
function $h_Llaika_ast_SpanLink$$anon$1() {
}
$h_Llaika_ast_SpanLink$$anon$1.prototype = $c_Llaika_ast_SpanLink$$anon$1.prototype;
$c_Llaika_ast_SpanLink$$anon$1.prototype.createSpanContainer__sci_Seq__Llaika_ast_SpanLink = (function(spans) {
  var target = this.Llaika_ast_SpanLink$$anon$1__f_target$2;
  var title = $m_s_None$();
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  return new $c_Llaika_ast_SpanLink(spans, target, title, options);
});
$c_Llaika_ast_SpanLink$$anon$1.prototype.createSpanContainer__sci_Seq__O = (function(spans) {
  return this.createSpanContainer__sci_Seq__Llaika_ast_SpanLink(spans);
});
var $d_Llaika_ast_SpanLink$$anon$1 = new $TypeData().initClass($c_Llaika_ast_SpanLink$$anon$1, "laika.ast.SpanLink$$anon$1", ({
  Llaika_ast_SpanLink$$anon$1: 1,
  Llaika_ast_SpanContainerCompanion: 1,
  Llaika_ast_SpanLink$Companion: 1
}));
function $is_Llaika_ast_SpanResolver(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_SpanResolver)));
}
function $as_Llaika_ast_SpanResolver(obj) {
  return (($is_Llaika_ast_SpanResolver(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.SpanResolver"));
}
function $isArrayOf_Llaika_ast_SpanResolver(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_SpanResolver)));
}
function $asArrayOf_Llaika_ast_SpanResolver(obj, depth) {
  return (($isArrayOf_Llaika_ast_SpanResolver(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.SpanResolver;", depth));
}
/** @constructor */
function $c_Llaika_ast_Target$() {
  this.Llaika_ast_Target$__f_pseudoProtocol = null;
  this.Llaika_ast_Target$__f_recognizedProtocols = null;
  $n_Llaika_ast_Target$ = this;
  this.Llaika_ast_Target$__f_pseudoProtocol = "ext:";
  var this$1 = $m_sci_Set$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["http:", "https:", "mailto:", this.Llaika_ast_Target$__f_pseudoProtocol]));
  this.Llaika_ast_Target$__f_recognizedProtocols = this$1.from__sc_IterableOnce__sci_Set(elems);
}
$c_Llaika_ast_Target$.prototype = new $h_O();
$c_Llaika_ast_Target$.prototype.constructor = $c_Llaika_ast_Target$;
/** @constructor */
function $h_Llaika_ast_Target$() {
}
$h_Llaika_ast_Target$.prototype = $c_Llaika_ast_Target$.prototype;
$c_Llaika_ast_Target$.prototype.parse__T__Llaika_ast_Target = (function(url) {
  if ($n(this.Llaika_ast_Target$__f_recognizedProtocols).exists__F1__Z(new $c_sjsr_AnonFunction1(((x$0) => {
    var x$0$1 = $as_T(x$0);
    var this$2 = $n(url);
    if ((this$2.length >= 0)) {
      var this$3 = $n(x$0$1);
      var $x_1 = this$2.substring(0, this$3.length);
      return ($as_T($x_1) === x$0$1);
    } else {
      return false;
    }
  })))) {
    var url$1 = $m_sc_StringOps$().stripPrefix$extension__T__T__T(url, this.Llaika_ast_Target$__f_pseudoProtocol);
    return new $c_Llaika_ast_ExternalTarget(url$1);
  } else {
    return $m_Llaika_ast_InternalTarget$().apply__Llaika_ast_VirtualPath__Llaika_ast_InternalTarget($m_Llaika_ast_VirtualPath$().parse__T__Llaika_ast_VirtualPath(url));
  }
});
var $d_Llaika_ast_Target$ = new $TypeData().initClass($c_Llaika_ast_Target$, "laika.ast.Target$", ({
  Llaika_ast_Target$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Llaika_ast_Target$;
function $m_Llaika_ast_Target$() {
  if ((!$n_Llaika_ast_Target$)) {
    $n_Llaika_ast_Target$ = new $c_Llaika_ast_Target$();
  }
  return $n_Llaika_ast_Target$;
}
function $ps_Llaika_ast_TreePosition__compare$1__sci_Seq__sci_Seq__I(pos1, pos2) {
  var pos2$tailLocal1 = pos2;
  var pos1$tailLocal1 = pos1;
  while (true) {
    var _1 = $n(pos1$tailLocal1).headOption__s_Option();
    var _2 = $n(pos2$tailLocal1).headOption__s_Option();
    if ((_1 instanceof $c_s_Some)) {
      var a = $uI($n($as_s_Some(_1)).s_Some__f_value);
      if ((_2 instanceof $c_s_Some)) {
        var b = $uI($n($as_s_Some(_2)).s_Some__f_value);
        var this$3 = new $c_sr_RichInt(a);
        $m_s_math_Ordering$Int$();
        var x = this$3.sr_RichInt__f_self;
        var x2 = ((x === b) ? 0 : ((x < b) ? (-1) : 1));
        if ((x2 === 0)) {
          var pos1$tailLocal1$tmp1 = $as_sci_Seq($n(pos1$tailLocal1).tail__O());
          var pos2$tailLocal1$tmp1 = $as_sci_Seq($n(pos2$tailLocal1).tail__O());
          pos1$tailLocal1 = pos1$tailLocal1$tmp1;
          pos2$tailLocal1 = pos2$tailLocal1$tmp1;
          continue;
        }
        return x2;
      }
    }
    return 0;
  }
}
/** @constructor */
function $c_Llaika_ast_TreePosition(positions) {
  this.Llaika_ast_TreePosition__f_positions = null;
  this.Llaika_ast_TreePosition__f_positions = positions;
}
$c_Llaika_ast_TreePosition.prototype = new $h_O();
$c_Llaika_ast_TreePosition.prototype.constructor = $c_Llaika_ast_TreePosition;
/** @constructor */
function $h_Llaika_ast_TreePosition() {
}
$h_Llaika_ast_TreePosition.prototype = $c_Llaika_ast_TreePosition.prototype;
$c_Llaika_ast_TreePosition.prototype.compareTo__O__I = (function(that) {
  return this.compare__Llaika_ast_TreePosition__I($as_Llaika_ast_TreePosition(that));
});
$c_Llaika_ast_TreePosition.prototype.toString__T = (function() {
  var x1 = this.Llaika_ast_TreePosition__f_positions;
  var x = $m_sci_Nil$();
  if (x.equals__O__Z(x1)) {
    return "TreePosition.root";
  }
  var this$1 = $n(x1);
  return (("TreePosition(" + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, "", ".", "")) + ")");
});
$c_Llaika_ast_TreePosition.prototype.forChild__I__Llaika_ast_TreePosition = (function(childPos) {
  var this$1 = $n(this.Llaika_ast_TreePosition__f_positions);
  var pos = $as_sci_Seq(this$1.appended__O__O(childPos));
  return new $c_Llaika_ast_TreePosition(pos);
});
$c_Llaika_ast_TreePosition.prototype.compare__Llaika_ast_TreePosition__I = (function(other) {
  var a = $n(this.Llaika_ast_TreePosition__f_positions).length__I();
  var this$1 = $n(other);
  var b = $n(this$1.Llaika_ast_TreePosition__f_positions).length__I();
  var maxLen = ((a > b) ? a : b);
  var $x_1 = $as_sci_Seq($n(this.Llaika_ast_TreePosition__f_positions).padTo__I__O__O(maxLen, 0));
  var this$3 = $n(other);
  return $ps_Llaika_ast_TreePosition__compare$1__sci_Seq__sci_Seq__I($x_1, $as_sci_Seq($n(this$3.Llaika_ast_TreePosition__f_positions).padTo__I__O__O(maxLen, 0)));
});
$c_Llaika_ast_TreePosition.prototype.hashCode__I = (function() {
  return $n(this.Llaika_ast_TreePosition__f_positions).hashCode__I();
});
$c_Llaika_ast_TreePosition.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Llaika_ast_TreePosition)) {
    var tp = $as_Llaika_ast_TreePosition(obj);
    var x = $n(tp).Llaika_ast_TreePosition__f_positions;
    var x$2 = this.Llaika_ast_TreePosition__f_positions;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Llaika_ast_TreePosition.prototype.compare__O__I = (function(that) {
  return this.compare__Llaika_ast_TreePosition__I($as_Llaika_ast_TreePosition(that));
});
function $as_Llaika_ast_TreePosition(obj) {
  return (((obj instanceof $c_Llaika_ast_TreePosition) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.TreePosition"));
}
function $isArrayOf_Llaika_ast_TreePosition(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_TreePosition)));
}
function $asArrayOf_Llaika_ast_TreePosition(obj, depth) {
  return (($isArrayOf_Llaika_ast_TreePosition(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.TreePosition;", depth));
}
var $d_Llaika_ast_TreePosition = new $TypeData().initClass($c_Llaika_ast_TreePosition, "laika.ast.TreePosition", ({
  Llaika_ast_TreePosition: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1
}));
function $p_Llaika_ast_VirtualPath$__splitAtLast$1__T__C__T2($thiz, in$1, char) {
  var xs = $m_sc_StringOps$().split$extension__T__C__AT(in$1, char);
  var x1 = $m_sc_ArrayOps$().toIndexedSeq$extension__O__sci_IndexedSeq(xs);
  if ((x1 !== null)) {
    var this$6 = $n(x1);
    var x = this$6.length__I();
    if ((((x === 0) ? 0 : ((x < 0) ? (-1) : 1)) === 0)) {
      var _2 = $m_s_None$();
      return new $c_T2("", _2);
    }
    var this$10 = $n(x1);
    var x$1 = this$10.length__I();
    if ((((x$1 === 1) ? 0 : ((x$1 < 1) ? (-1) : 1)) === 0)) {
      var x3 = $as_T($n(x1).apply__I__O(0));
      var _2$1 = $m_s_None$();
      return new $c_T2(x3, _2$1);
    }
  }
  var this$15 = $n($as_sc_IterableOnceOps($n(x1).init__O()));
  var sep = ("" + $cToS(char));
  var _1 = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$15, "", sep, "");
  var value = $n(x1).last__O();
  var _2$2 = new $c_s_Some(value);
  return new $c_T2(_1, _2$2);
}
/** @constructor */
function $c_Llaika_ast_VirtualPath$() {
}
$c_Llaika_ast_VirtualPath$.prototype = new $h_O();
$c_Llaika_ast_VirtualPath$.prototype.constructor = $c_Llaika_ast_VirtualPath$;
/** @constructor */
function $h_Llaika_ast_VirtualPath$() {
}
$h_Llaika_ast_VirtualPath$.prototype = $c_Llaika_ast_VirtualPath$.prototype;
$c_Llaika_ast_VirtualPath$.prototype.parse__T__Llaika_ast_VirtualPath = (function(path) {
  var this$1 = $n(path);
  if (((this$1.length >= 0) && ($as_T(this$1.substring(0, 1)) === "/"))) {
    return $m_Llaika_ast_Path$().parse__T__Llaika_ast_Path(path);
  } else {
    return $m_Llaika_ast_RelativePath$().parse__T__Llaika_ast_RelativePath(path);
  }
});
$c_Llaika_ast_VirtualPath$.prototype.parseLastSegment__sci_List__T3 = (function(segments) {
  var this$1 = $n(segments);
  var this$2 = $n($f_sc_IterableOps__lastOption__s_Option(this$1));
  if (this$2.isEmpty__Z()) {
    var _1 = $m_s_None$();
    var _2 = $m_s_None$();
    var _3 = $m_s_None$();
    return new $c_T3(_1, _2, _3);
  } else {
    var arg1 = this$2.get__O();
    var lastSegment = $as_T(arg1);
    matchResult2: {
      var \u03b41$___1;
      var \u03b41$___2;
      var x5 = $p_Llaika_ast_VirtualPath$__splitAtLast$1__T__C__T2(this, lastSegment, 35);
      if ((x5 !== null)) {
        var name = $as_T($n(x5)._1__O());
        var fragment = $as_s_Option($n(x5)._2__O());
        var \u03b41$___1 = name;
        var \u03b41$___2 = fragment;
        break matchResult2;
      }
      throw new $c_s_MatchError(x5);
    }
    var name$2 = $as_T(\u03b41$___1);
    var fragment$2 = $as_s_Option(\u03b41$___2);
    matchResult3: {
      var \u03b42$___1;
      var \u03b42$___2;
      var x8 = $p_Llaika_ast_VirtualPath$__splitAtLast$1__T__C__T2(this, name$2, 46);
      if ((x8 !== null)) {
        var basename = $as_T($n(x8)._1__O());
        var suffix = $as_s_Option($n(x8)._2__O());
        var \u03b42$___1 = basename;
        var \u03b42$___2 = suffix;
        break matchResult3;
      }
      throw new $c_s_MatchError(x8);
    }
    var basename$2 = $as_T(\u03b42$___1);
    var suffix$2 = $as_s_Option(\u03b42$___2);
    var $x_1 = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptyChain);
    var this$6 = $m_Lcats_data_Chain$();
    var s = $as_sci_Seq($n(segments).init__O());
    var value = $n($x_1).fromChainAppend__Lcats_data_Chain__O__O($f_Lcats_data_ChainCompanionCompat__fromSeq__sci_Seq__Lcats_data_Chain(this$6, s), basename$2);
    var _1$1 = new $c_s_Some(value);
    return new $c_T3(_1$1, suffix$2, fragment$2);
  }
});
var $d_Llaika_ast_VirtualPath$ = new $TypeData().initClass($c_Llaika_ast_VirtualPath$, "laika.ast.VirtualPath$", ({
  Llaika_ast_VirtualPath$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Llaika_ast_VirtualPath$;
function $m_Llaika_ast_VirtualPath$() {
  if ((!$n_Llaika_ast_VirtualPath$)) {
    $n_Llaika_ast_VirtualPath$ = new $c_Llaika_ast_VirtualPath$();
  }
  return $n_Llaika_ast_VirtualPath$;
}
/** @constructor */
function $c_Llaika_config_ApiLinks$() {
  this.Llaika_config_ApiLinks$__f_decoder = null;
  this.Llaika_config_ApiLinks$__f_encoder = null;
  $n_Llaika_config_ApiLinks$ = this;
  var this$13 = $n($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_config);
  var f = new $c_sjsr_AnonFunction1(((config) => {
    var config$1 = $as_Llaika_api_config_Config(config);
    var this$2 = $n(config$1);
    var decoder = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
    var this$3 = $n($f_Llaika_api_config_Config__get__T__Llaika_api_config_ConfigDecoder__s_util_Either(this$2, "baseUri", decoder));
    if ((this$3 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$3);
      var b = $n(x2).s_util_Right__f_value;
      var baseUri = $as_T(b);
      var this$4 = $n(config$1);
      var decoder$1 = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
      var key = $m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key("packagePrefix");
      var this$5 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$4, key, decoder$1));
      if ((this$5 instanceof $c_s_util_Right)) {
        var x2$1 = $as_s_util_Right(this$5);
        var b$1 = $n(x2$1).s_util_Right__f_value;
        var _$1 = $as_s_Option(b$1);
        var this$6 = $n(_$1);
        var $x_1 = new $c_s_util_Right((this$6.isEmpty__Z() ? "*" : this$6.get__O()));
      } else {
        var $x_1 = this$5;
      }
      var this$7 = $n($x_1);
      if ((this$7 instanceof $c_s_util_Right)) {
        var x2$2 = $as_s_util_Right(this$7);
        var b$2 = $n(x2$2).s_util_Right__f_value;
        var prefix = $as_T(b$2);
        var this$8 = $n(config$1);
        var decoder$2 = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
        var key$1 = $m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key("packageSummary");
        var this$9 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$8, key$1, decoder$2));
        if ((this$9 instanceof $c_s_util_Right)) {
          var x2$3 = $as_s_util_Right(this$9);
          var b$3 = $n(x2$3).s_util_Right__f_value;
          var _$1$1 = $as_s_Option(b$3);
          var this$10 = $n(_$1$1);
          var $x_2 = new $c_s_util_Right((this$10.isEmpty__Z() ? "index.html" : this$10.get__O()));
        } else {
          var $x_2 = this$9;
        }
        var this$11 = $n($x_2);
        if ((this$11 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(this$11);
          var b$4 = $n(x2$4).s_util_Right__f_value;
          var summary = $as_T(b$4);
          return new $c_s_util_Right(new $c_Llaika_config_ApiLinks$Impl(baseUri, prefix, summary));
        } else {
          return this$11;
        }
      } else {
        return this$7;
      }
    } else {
      return this$3;
    }
  }));
  this.Llaika_config_ApiLinks$__f_decoder = new $c_Llaika_api_config_ConfigDecoder$$anon$1(f, this$13);
  var this$14 = $m_Llaika_api_config_ConfigEncoder$();
  var f$1 = new $c_sjsr_AnonFunction1(((links) => {
    var links$1 = $as_Llaika_config_ApiLinks(links);
    return $n($n($n($n($m_Llaika_api_config_ConfigEncoder$ObjectBuilder$().Llaika_api_config_ConfigEncoder$ObjectBuilder$__f_empty).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("baseUri", $n(links$1).Llaika_config_ApiLinks$Impl__f_baseUri, $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_string)).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("packagePrefix", $n(links$1).Llaika_config_ApiLinks$Impl__f_packagePrefix, $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_string)).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("packageSummary", $n(links$1).Llaika_config_ApiLinks$Impl__f_packageSummary, $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_string)).build__Llaika_api_config_ConfigValue$ObjectValue();
  }));
  this.Llaika_config_ApiLinks$__f_encoder = new $c_Llaika_api_config_ConfigEncoder$$anon$14(f$1, this$14);
}
$c_Llaika_config_ApiLinks$.prototype = new $h_O();
$c_Llaika_config_ApiLinks$.prototype.constructor = $c_Llaika_config_ApiLinks$;
/** @constructor */
function $h_Llaika_config_ApiLinks$() {
}
$h_Llaika_config_ApiLinks$.prototype = $c_Llaika_config_ApiLinks$.prototype;
var $d_Llaika_config_ApiLinks$ = new $TypeData().initClass($c_Llaika_config_ApiLinks$, "laika.config.ApiLinks$", ({
  Llaika_config_ApiLinks$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Llaika_config_ApiLinks$;
function $m_Llaika_config_ApiLinks$() {
  if ((!$n_Llaika_config_ApiLinks$)) {
    $n_Llaika_config_ApiLinks$ = new $c_Llaika_config_ApiLinks$();
  }
  return $n_Llaika_config_ApiLinks$;
}
/** @constructor */
function $c_Llaika_config_AutonumberConfig$() {
  this.Llaika_config_AutonumberConfig$__f_scopeKey = null;
  this.Llaika_config_AutonumberConfig$__f_depthKey = null;
  this.Llaika_config_AutonumberConfig$__f_defaultKey = null;
  this.Llaika_config_AutonumberConfig$__f_decoder = null;
  $n_Llaika_config_AutonumberConfig$ = this;
  this.Llaika_config_AutonumberConfig$__f_scopeKey = $m_Llaika_api_config_Key$().apply__T__sci_Seq__Llaika_api_config_Key("scope", $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([])));
  this.Llaika_config_AutonumberConfig$__f_depthKey = $m_Llaika_api_config_Key$().apply__T__sci_Seq__Llaika_api_config_Key("depth", $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([])));
  var this$1 = $m_Llaika_api_config_DefaultKey$();
  var key = $m_Llaika_config_LaikaKeys$().Llaika_config_LaikaKeys$__f_autonumbering;
  this.Llaika_config_AutonumberConfig$__f_defaultKey = new $c_Llaika_api_config_DefaultKey$$anon$1(key, this$1);
  var this$16 = $n($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_config);
  var f = new $c_sjsr_AnonFunction1(((config) => {
    var config$1 = $as_Llaika_api_config_Config(config);
    var this$3 = $n(config$1);
    var key$1 = this.Llaika_config_AutonumberConfig$__f_scopeKey;
    var decoder = $m_Llaika_config_Scope$().Llaika_config_Scope$__f_decoder;
    var this$4 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$3, key$1, decoder));
    if ((this$4 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$4);
      var b = $n(x2).s_util_Right__f_value;
      var _$1 = $as_s_Option(b);
      var this$5 = $n(_$1);
      var $x_1 = new $c_s_util_Right((this$5.isEmpty__Z() ? $m_Llaika_config_Scope$None$() : this$5.get__O()));
    } else {
      var $x_1 = this$4;
    }
    var this$6 = $n($x_1);
    if ((this$6 instanceof $c_s_util_Right)) {
      var x2$1 = $as_s_util_Right(this$6);
      var b$1 = $n(x2$1).s_util_Right__f_value;
      var scope = $as_Llaika_config_Scope(b$1);
      var this$7 = $n(config$1);
      var key$2 = this.Llaika_config_AutonumberConfig$__f_depthKey;
      var decoder$1 = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_int;
      var this$8 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$7, key$2, decoder$1));
      if ((this$8 instanceof $c_s_util_Right)) {
        var x2$2 = $as_s_util_Right(this$8);
        var b$2 = $n(x2$2).s_util_Right__f_value;
        var _$1$1 = $as_s_Option(b$2);
        var this$9 = $n(_$1$1);
        var $x_2 = new $c_s_util_Right((this$9.isEmpty__Z() ? 2147483647 : this$9.get__O()));
      } else {
        var $x_2 = this$8;
      }
      var this$10 = $n($x_2);
      if ((this$10 instanceof $c_s_util_Right)) {
        var x2$3 = $as_s_util_Right(this$10);
        var b$3 = $n(x2$3).s_util_Right__f_value;
        var depth = $uI(b$3);
        matchResult4: {
          var \u03b41$___1;
          var \u03b41$___2;
          var x = $m_Llaika_config_Scope$Documents$();
          if ((x === scope)) {
            var \u03b41$___1 = true;
            var \u03b41$___2 = false;
            break matchResult4;
          }
          var x$3 = $m_Llaika_config_Scope$Sections$();
          if ((x$3 === scope)) {
            var \u03b41$___1 = false;
            var \u03b41$___2 = true;
            break matchResult4;
          }
          var x$5 = $m_Llaika_config_Scope$All$();
          if ((x$5 === scope)) {
            var \u03b41$___1 = true;
            var \u03b41$___2 = true;
            break matchResult4;
          }
          var x$7 = $m_Llaika_config_Scope$None$();
          if ((x$7 === scope)) {
            var \u03b41$___1 = false;
            var \u03b41$___2 = false;
            break matchResult4;
          }
          throw new $c_s_MatchError(scope);
        }
        var documents = $uZ(\u03b41$___1);
        var sections = $uZ(\u03b41$___2);
        return new $c_s_util_Right(new $c_Llaika_config_AutonumberConfig$Impl(documents, sections, depth));
      } else {
        return this$10;
      }
    } else {
      return this$6;
    }
  }));
  this.Llaika_config_AutonumberConfig$__f_decoder = new $c_Llaika_api_config_ConfigDecoder$$anon$1(f, this$16);
  var this$18 = $m_Llaika_api_config_ConfigEncoder$();
  var f$1 = new $c_sjsr_AnonFunction1(((config$2) => {
    var config$3 = $as_Llaika_config_AutonumberConfig(config$2);
    matchResult5: {
      var scopeString;
      var _1 = $n(config$3).Llaika_config_AutonumberConfig$Impl__f_documents;
      var _2 = $n(config$3).Llaika_config_AutonumberConfig$Impl__f_sections;
      var x6 = new $c_T2(_1, _2);
      var x13 = $uZ(x6.T2__f__1);
      var x14 = $uZ(x6.T2__f__2);
      if (((x13 === true) && (x14 === false))) {
        var scopeString = "documents";
        break matchResult5;
      }
      if (((x13 === false) && (x14 === true))) {
        var scopeString = "sections";
        break matchResult5;
      }
      if (((x13 === true) && (x14 === true))) {
        var scopeString = "all";
        break matchResult5;
      }
      if (((x13 === false) && (x14 === false))) {
        var scopeString = "none";
        break matchResult5;
      }
      throw new $c_s_MatchError(x6);
    }
    return $n($n($n($m_Llaika_api_config_ConfigEncoder$ObjectBuilder$().Llaika_api_config_ConfigEncoder$ObjectBuilder$__f_empty).withValue__Llaika_api_config_Key__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder(this.Llaika_config_AutonumberConfig$__f_scopeKey, scopeString, $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_string)).withValue__Llaika_api_config_Key__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder(this.Llaika_config_AutonumberConfig$__f_depthKey, $n(config$3).Llaika_config_AutonumberConfig$Impl__f_maxDepth, $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_int)).build__Llaika_api_config_ConfigValue$ObjectValue();
  }));
  new $c_Llaika_api_config_ConfigEncoder$$anon$14(f$1, this$18);
}
$c_Llaika_config_AutonumberConfig$.prototype = new $h_O();
$c_Llaika_config_AutonumberConfig$.prototype.constructor = $c_Llaika_config_AutonumberConfig$;
/** @constructor */
function $h_Llaika_config_AutonumberConfig$() {
}
$h_Llaika_config_AutonumberConfig$.prototype = $c_Llaika_config_AutonumberConfig$.prototype;
$c_Llaika_config_AutonumberConfig$.prototype.withoutSectionNumbering__Llaika_api_config_Config__Llaika_api_config_ConfigBuilder__Llaika_api_config_ConfigBuilder = (function(config, builder) {
  var key = $n($m_Llaika_config_LaikaKeys$().Llaika_config_LaikaKeys$__f_autonumbering).child__Llaika_api_config_Key__Llaika_api_config_Key(this.Llaika_config_AutonumberConfig$__f_scopeKey);
  var this$1 = $n($n($n(config).get__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(key, $m_Llaika_config_Scope$().Llaika_config_Scope$__f_decoder)).toOption__s_Option());
  if (this$1.isEmpty__Z()) {
    return builder;
  } else {
    var arg1 = this$1.get__O();
    var x$1 = $as_Llaika_config_Scope(arg1);
    var x = $m_Llaika_config_Scope$Documents$();
    if ((x === x$1)) {
      return builder;
    }
    var x$3 = $m_Llaika_config_Scope$Sections$();
    if ((x$3 === x$1)) {
      return $n(builder).withValue__Llaika_api_config_Key__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigBuilder(key, "none", $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_string);
    }
    var x$5 = $m_Llaika_config_Scope$All$();
    if ((x$5 === x$1)) {
      return $n(builder).withValue__Llaika_api_config_Key__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigBuilder(key, "documents", $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_string);
    }
    var x$7 = $m_Llaika_config_Scope$None$();
    if ((x$7 === x$1)) {
      return builder;
    }
    throw new $c_s_MatchError(x$1);
  }
});
var $d_Llaika_config_AutonumberConfig$ = new $TypeData().initClass($c_Llaika_config_AutonumberConfig$, "laika.config.AutonumberConfig$", ({
  Llaika_config_AutonumberConfig$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Llaika_config_AutonumberConfig$;
function $m_Llaika_config_AutonumberConfig$() {
  if ((!$n_Llaika_config_AutonumberConfig$)) {
    $n_Llaika_config_AutonumberConfig$ = new $c_Llaika_config_AutonumberConfig$();
  }
  return $n_Llaika_config_AutonumberConfig$;
}
/** @constructor */
function $c_Llaika_config_ChoiceConfig$() {
  this.Llaika_config_ChoiceConfig$__f_decoder = null;
  this.Llaika_config_ChoiceConfig$__f_encoder = null;
  $n_Llaika_config_ChoiceConfig$ = this;
  var this$11 = $n($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_config);
  var f = new $c_sjsr_AnonFunction1(((config) => {
    var config$1 = $as_Llaika_api_config_Config(config);
    var this$2 = $n(config$1);
    var decoder = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
    var this$3 = $n($f_Llaika_api_config_Config__get__T__Llaika_api_config_ConfigDecoder__s_util_Either(this$2, "name", decoder));
    if ((this$3 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$3);
      var b = $n(x2).s_util_Right__f_value;
      var name = $as_T(b);
      var this$4 = $n(config$1);
      var decoder$1 = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
      var this$5 = $n($f_Llaika_api_config_Config__get__T__Llaika_api_config_ConfigDecoder__s_util_Either(this$4, "label", decoder$1));
      if ((this$5 instanceof $c_s_util_Right)) {
        var x2$1 = $as_s_util_Right(this$5);
        var b$1 = $n(x2$1).s_util_Right__f_value;
        var label = $as_T(b$1);
        var this$6 = $n(config$1);
        var decoder$2 = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_boolean;
        var key = $m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key("selected");
        var this$7 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$6, key, decoder$2));
        if ((this$7 instanceof $c_s_util_Right)) {
          var x2$2 = $as_s_util_Right(this$7);
          var b$2 = $n(x2$2).s_util_Right__f_value;
          var _$1 = $as_s_Option(b$2);
          var this$8 = $n(_$1);
          var $x_1 = new $c_s_util_Right((this$8.isEmpty__Z() ? false : this$8.get__O()));
        } else {
          var $x_1 = this$7;
        }
        var this$9 = $n($x_1);
        if ((this$9 instanceof $c_s_util_Right)) {
          var x2$3 = $as_s_util_Right(this$9);
          var b$3 = $n(x2$3).s_util_Right__f_value;
          var selected = $uZ(b$3);
          return new $c_s_util_Right(new $c_Llaika_config_ChoiceConfig$Impl(name, label, selected));
        } else {
          return this$9;
        }
      } else {
        return this$5;
      }
    } else {
      return this$3;
    }
  }));
  this.Llaika_config_ChoiceConfig$__f_decoder = new $c_Llaika_api_config_ConfigDecoder$$anon$1(f, this$11);
  var this$12 = $m_Llaika_api_config_ConfigEncoder$();
  var f$1 = new $c_sjsr_AnonFunction1(((config$2) => {
    var config$3 = $as_Llaika_config_ChoiceConfig(config$2);
    return $n($n($n($n($m_Llaika_api_config_ConfigEncoder$ObjectBuilder$().Llaika_api_config_ConfigEncoder$ObjectBuilder$__f_empty).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("name", $n(config$3).Llaika_config_ChoiceConfig$Impl__f_name, $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_string)).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("label", $n(config$3).Llaika_config_ChoiceConfig$Impl__f_label, $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_string)).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("selected", $n(config$3).Llaika_config_ChoiceConfig$Impl__f_selected, $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_boolean)).build__Llaika_api_config_ConfigValue$ObjectValue();
  }));
  this.Llaika_config_ChoiceConfig$__f_encoder = new $c_Llaika_api_config_ConfigEncoder$$anon$14(f$1, this$12);
}
$c_Llaika_config_ChoiceConfig$.prototype = new $h_O();
$c_Llaika_config_ChoiceConfig$.prototype.constructor = $c_Llaika_config_ChoiceConfig$;
/** @constructor */
function $h_Llaika_config_ChoiceConfig$() {
}
$h_Llaika_config_ChoiceConfig$.prototype = $c_Llaika_config_ChoiceConfig$.prototype;
var $d_Llaika_config_ChoiceConfig$ = new $TypeData().initClass($c_Llaika_config_ChoiceConfig$, "laika.config.ChoiceConfig$", ({
  Llaika_config_ChoiceConfig$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Llaika_config_ChoiceConfig$;
function $m_Llaika_config_ChoiceConfig$() {
  if ((!$n_Llaika_config_ChoiceConfig$)) {
    $n_Llaika_config_ChoiceConfig$ = new $c_Llaika_config_ChoiceConfig$();
  }
  return $n_Llaika_config_ChoiceConfig$;
}
/** @constructor */
function $c_Llaika_config_LinkConfig$() {
  this.Llaika_config_LinkConfig$__f_empty = null;
  this.Llaika_config_LinkConfig$__f_key = null;
  this.Llaika_config_LinkConfig$__f_decoder = null;
  $n_Llaika_config_LinkConfig$ = this;
  var targets = $m_sci_Nil$();
  var apiLinks = $m_sci_Nil$();
  var sourceLinks = $m_sci_Nil$();
  this.Llaika_config_LinkConfig$__f_empty = new $c_Llaika_config_LinkConfig$Impl(targets, apiLinks, sourceLinks);
  var this$2 = $m_Llaika_api_config_DefaultKey$();
  var key = $m_Llaika_config_LaikaKeys$().Llaika_config_LaikaKeys$__f_links;
  this.Llaika_config_LinkConfig$__f_key = new $c_Llaika_api_config_DefaultKey$$anon$1(key, this$2);
  var this$23 = $n($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_config);
  var f = new $c_sjsr_AnonFunction1(((config) => {
    var config$1 = $as_Llaika_api_config_Config(config);
    var this$5 = $n(config$1);
    var this$4 = $m_Llaika_api_config_ConfigDecoder$();
    var valueDecoder = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
    var decoder = new $c_Llaika_api_config_ConfigDecoder$$anon$11(valueDecoder, this$4);
    var key$1 = $m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key("targets");
    var this$6 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$5, key$1, decoder));
    if ((this$6 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$6);
      var b = $n(x2).s_util_Right__f_value;
      var _$1 = $as_s_Option(b);
      var this$7 = $n(_$1);
      var $x_1 = new $c_s_util_Right((this$7.isEmpty__Z() ? $m_sci_Map$EmptyMap$() : this$7.get__O()));
    } else {
      var $x_1 = this$6;
    }
    var this$9 = $n($x_1);
    if ((this$9 instanceof $c_s_util_Right)) {
      var x2$1 = $as_s_util_Right(this$9);
      var b$1 = $n(x2$1).s_util_Right__f_value;
      var targets$1 = $as_sci_Map(b$1);
      var this$11 = $n(config$1);
      var this$10 = $m_Llaika_api_config_ConfigDecoder$();
      var elementDecoder = $m_Llaika_config_ApiLinks$().Llaika_config_ApiLinks$__f_decoder;
      var decoder$1 = new $c_Llaika_api_config_ConfigDecoder$$anon$10(elementDecoder, this$10);
      var key$2 = $m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key("api");
      var this$12 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$11, key$2, decoder$1));
      if ((this$12 instanceof $c_s_util_Right)) {
        var x2$2 = $as_s_util_Right(this$12);
        var b$2 = $n(x2$2).s_util_Right__f_value;
        var _$1$1 = $as_s_Option(b$2);
        var this$13 = $n(_$1$1);
        var $x_2 = new $c_s_util_Right((this$13.isEmpty__Z() ? $m_sci_Nil$() : this$13.get__O()));
      } else {
        var $x_2 = this$12;
      }
      var this$14 = $n($x_2);
      if ((this$14 instanceof $c_s_util_Right)) {
        var x2$3 = $as_s_util_Right(this$14);
        var b$3 = $n(x2$3).s_util_Right__f_value;
        var apiLinks$1 = $as_sci_Seq(b$3);
        var this$16 = $n(config$1);
        var this$15 = $m_Llaika_api_config_ConfigDecoder$();
        var elementDecoder$1 = $m_Llaika_config_SourceLinks$().Llaika_config_SourceLinks$__f_decoder;
        var decoder$2 = new $c_Llaika_api_config_ConfigDecoder$$anon$10(elementDecoder$1, this$15);
        var key$3 = $m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key("source");
        var this$17 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$16, key$3, decoder$2));
        if ((this$17 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(this$17);
          var b$4 = $n(x2$4).s_util_Right__f_value;
          var _$1$2 = $as_s_Option(b$4);
          var this$18 = $n(_$1$2);
          var $x_3 = new $c_s_util_Right((this$18.isEmpty__Z() ? $m_sci_Nil$() : this$18.get__O()));
        } else {
          var $x_3 = this$17;
        }
        var this$19 = $n($x_3);
        if ((this$19 instanceof $c_s_util_Right)) {
          var x2$5 = $as_s_util_Right(this$19);
          var b$5 = $n(x2$5).s_util_Right__f_value;
          var sourceLinks$1 = $as_sci_Seq(b$5);
          var mappedTargets = $as_sci_Iterable($n(targets$1).map__F1__O(new $c_sjsr_AnonFunction1(((x$1) => {
            var x$1$1 = $as_T2(x$1);
            if ((x$1$1 !== null)) {
              var id = $as_T($n(x$1$1)._1__O());
              var targetURL = $as_T($n(x$1$1)._2__O());
              var target = $m_Llaika_ast_Target$().parse__T__Llaika_ast_Target(targetURL);
              return new $c_Llaika_config_TargetDefinition$Impl(id, target);
            }
            throw new $c_s_MatchError(x$1$1);
          }))));
          var targets$2 = $n(mappedTargets).toSeq__sci_Seq();
          return new $c_s_util_Right(new $c_Llaika_config_LinkConfig$Impl(targets$2, apiLinks$1, sourceLinks$1));
        } else {
          return this$19;
        }
      } else {
        return this$14;
      }
    } else {
      return this$9;
    }
  }));
  this.Llaika_config_LinkConfig$__f_decoder = new $c_Llaika_api_config_ConfigDecoder$$anon$1(f, this$23);
  var this$29 = $m_Llaika_api_config_ConfigEncoder$();
  var f$1 = new $c_sjsr_AnonFunction1(((config$2) => {
    var config$3 = $as_Llaika_config_LinkConfig(config$2);
    var $x_10 = $m_Llaika_api_config_ConfigEncoder$ObjectBuilder$().Llaika_api_config_ConfigEncoder$ObjectBuilder$__f_empty;
    var $x_9 = $n($as_sc_IterableOnceOps($n($n(config$3).Llaika_config_LinkConfig$Impl__f_targets).map__F1__O(new $c_sjsr_AnonFunction1(((t) => {
      var t$1 = $as_Llaika_config_TargetDefinition(t);
      var _1 = $n(t$1).Llaika_config_TargetDefinition$Impl__f_id;
      var \u03b41$ = $n(t$1).Llaika_config_TargetDefinition$Impl__f_target;
      var _2 = $n(\u03b41$).render__Z__T($n(\u03b41$).render$default$1__Z());
      return new $c_T2(_1, _2);
    })))));
    var this$25 = $m_s_$less$colon$less$();
    var $x_8 = $n($x_9).toMap__s_$less$colon$less__sci_Map(this$25.s_$less$colon$less$__f_singleton);
    var this$26 = $m_Llaika_api_config_ConfigEncoder$();
    var elementEncoder = $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_string;
    var $x_7 = $n($n($x_10).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("targets", $x_8, new $c_Llaika_api_config_ConfigEncoder$$anon$13(elementEncoder, this$26)));
    var $x_6 = $n(config$3).Llaika_config_LinkConfig$Impl__f_apiLinks;
    var this$27 = $m_Llaika_api_config_ConfigEncoder$();
    var elementEncoder$1 = $m_Llaika_config_ApiLinks$().Llaika_config_ApiLinks$__f_encoder;
    var $x_5 = $n($x_7).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("api", $x_6, new $c_Llaika_api_config_ConfigEncoder$$anon$11(elementEncoder$1, this$27));
    var $x_4 = $n(config$3).Llaika_config_LinkConfig$Impl__f_sourceLinks;
    var this$28 = $m_Llaika_api_config_ConfigEncoder$();
    var elementEncoder$2 = $m_Llaika_config_SourceLinks$().Llaika_config_SourceLinks$__f_encoder;
    return $n($n($x_5).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("source", $x_4, new $c_Llaika_api_config_ConfigEncoder$$anon$11(elementEncoder$2, this$28))).build__Llaika_api_config_ConfigValue$ObjectValue();
  }));
  new $c_Llaika_api_config_ConfigEncoder$$anon$14(f$1, this$29);
}
$c_Llaika_config_LinkConfig$.prototype = new $h_O();
$c_Llaika_config_LinkConfig$.prototype.constructor = $c_Llaika_config_LinkConfig$;
/** @constructor */
function $h_Llaika_config_LinkConfig$() {
}
$h_Llaika_config_LinkConfig$.prototype = $c_Llaika_config_LinkConfig$.prototype;
var $d_Llaika_config_LinkConfig$ = new $TypeData().initClass($c_Llaika_config_LinkConfig$, "laika.config.LinkConfig$", ({
  Llaika_config_LinkConfig$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Llaika_config_LinkConfig$;
function $m_Llaika_config_LinkConfig$() {
  if ((!$n_Llaika_config_LinkConfig$)) {
    $n_Llaika_config_LinkConfig$ = new $c_Llaika_config_LinkConfig$();
  }
  return $n_Llaika_config_LinkConfig$;
}
/** @constructor */
function $c_Llaika_config_LinkValidation$() {
  this.Llaika_config_LinkValidation$__f_key = null;
  this.Llaika_config_LinkValidation$__f_decoder = null;
  $n_Llaika_config_LinkValidation$ = this;
  var keyValue = $n($m_Llaika_config_LaikaKeys$().Llaika_config_LaikaKeys$__f_links).child__T__Llaika_api_config_Key("validation");
  var this$1 = $m_Llaika_api_config_DefaultKey$();
  this.Llaika_config_LinkValidation$__f_key = new $c_Llaika_api_config_DefaultKey$$anon$1(keyValue, this$1);
  var this$2 = $m_Llaika_api_config_DefaultKey$();
  new $c_Llaika_api_config_DefaultKey$$anon$1(keyValue, this$2);
  var this$3 = $m_Llaika_api_config_DefaultKey$();
  new $c_Llaika_api_config_DefaultKey$$anon$1(keyValue, this$3);
  var this$4 = $m_Llaika_api_config_DefaultKey$();
  new $c_Llaika_api_config_DefaultKey$$anon$1(keyValue, this$4);
  var this$23 = $n($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_config);
  var f = new $c_sjsr_AnonFunction1(((config) => {
    var config$1 = $as_Llaika_api_config_Config(config);
    var this$6 = $n(config$1);
    var decoder = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
    var this$7 = $n($f_Llaika_api_config_Config__getOpt__T__Llaika_api_config_ConfigDecoder__s_util_Either(this$6, "scope", decoder));
    if ((this$7 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$7);
      var b = $n(x2).s_util_Right__f_value;
      var scope = $as_s_Option(b);
      var this$9 = $n(config$1);
      var this$8 = $m_Llaika_api_config_ConfigDecoder$();
      var elementDecoder = $m_Llaika_api_config_ConfigDecoder$().path__Llaika_api_config_ConfigDecoder();
      var decoder$1 = new $c_Llaika_api_config_ConfigDecoder$$anon$10(elementDecoder, this$8);
      var key = $m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key("excluded");
      var this$10 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$9, key, decoder$1));
      if ((this$10 instanceof $c_s_util_Right)) {
        var x2$1 = $as_s_util_Right(this$10);
        var b$1 = $n(x2$1).s_util_Right__f_value;
        var _$1 = $as_s_Option(b$1);
        var this$11 = $n(_$1);
        var $x_1 = new $c_s_util_Right((this$11.isEmpty__Z() ? $m_sci_Nil$() : this$11.get__O()));
      } else {
        var $x_1 = this$10;
      }
      var this$12 = $n($x_1);
      if ((this$12 instanceof $c_s_util_Right)) {
        var x2$2 = $as_s_util_Right(this$12);
        var b$2 = $n(x2$2).s_util_Right__f_value;
        var excluded = $as_sci_Seq(b$2);
        var result = new $c_s_util_Right(new $c_T2(scope, excluded));
      } else {
        var result = this$12;
      }
    } else {
      var result = this$7;
    }
    var this$14 = $n(result);
    if ((this$14 instanceof $c_s_util_Right)) {
      var x2$3 = $as_s_util_Right(this$14);
      var b$3 = $n(x2$3).s_util_Right__f_value;
      var x$1 = $as_T2(b$3);
      if ((x$1 !== null)) {
        var x33 = $as_s_Option($n(x$1)._1__O());
        if ((x33 instanceof $c_s_Some)) {
          var x36 = $as_T($n($as_s_Some(x33)).s_Some__f_value);
          if ((x36 === "global")) {
            var excluded$1 = $as_sci_Seq($n(x$1)._2__O());
            var value = new $c_Llaika_config_LinkValidation$Global(excluded$1);
            return new $c_s_util_Right(value);
          }
          if ((x36 === "local")) {
            var value$1 = $m_Llaika_config_LinkValidation$Local$();
            return new $c_s_util_Right(value$1);
          }
          if ((x36 === "off")) {
            var value$2 = $m_Llaika_config_LinkValidation$Off$();
            return new $c_s_util_Right(value$2);
          }
        }
        var x = $m_s_None$();
        if ((x === x33)) {
          var value$3 = new $c_Llaika_api_config_ConfigError$ValidationFailed("scope not specified");
          return new $c_s_util_Left(value$3);
        }
        if ((x33 instanceof $c_s_Some)) {
          var unknown = $as_T($n($as_s_Some(x33)).s_Some__f_value);
          var message = ("Unsupported value for scope: " + unknown);
          var value$4 = new $c_Llaika_api_config_ConfigError$ValidationFailed(message);
          return new $c_s_util_Left(value$4);
        }
      }
      throw new $c_s_MatchError(x$1);
    } else {
      return this$14;
    }
  }));
  this.Llaika_config_LinkValidation$__f_decoder = new $c_Llaika_api_config_ConfigDecoder$$anon$1(f, this$23);
  var this$30 = $m_Llaika_api_config_ConfigEncoder$();
  var f$1 = new $c_sjsr_AnonFunction1(((config$2) => {
    var config$3 = $as_Llaika_config_LinkValidation(config$2);
    matchResult14: {
      var \u03b42$___1;
      var \u03b42$___2;
      if ((config$3 instanceof $c_Llaika_config_LinkValidation$Global)) {
        var x$1$1 = $as_Llaika_config_LinkValidation$Global(config$3);
        var this$25 = $n(x$1$1);
        var x40 = this$25.Llaika_config_LinkValidation$Global__f_excluded;
        var \u03b42$___1 = "global";
        var \u03b42$___2 = x40;
        break matchResult14;
      }
      var x$2 = $m_Llaika_config_LinkValidation$Local$();
      if ((x$2 === config$3)) {
        var _2 = $m_sci_Nil$();
        var \u03b42$___1 = "local";
        var \u03b42$___2 = _2;
        break matchResult14;
      }
      var x$3 = $m_Llaika_config_LinkValidation$Off$();
      if ((x$3 === config$3)) {
        var _2$1 = $m_sci_Nil$();
        var \u03b42$___1 = "off";
        var \u03b42$___2 = _2$1;
        break matchResult14;
      }
      throw new $c_s_MatchError(config$3);
    }
    var scope$1 = $as_T(\u03b42$___1);
    var excluded$2 = $as_sci_Seq(\u03b42$___2);
    var $x_2 = $n($m_Llaika_api_config_ConfigEncoder$ObjectBuilder$().Llaika_api_config_ConfigEncoder$ObjectBuilder$__f_empty).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("scope", scope$1, $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_string);
    var this$29 = $m_Llaika_api_config_ConfigEncoder$();
    var elementEncoder = $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_path;
    return $n($n($x_2).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("excluded", excluded$2, new $c_Llaika_api_config_ConfigEncoder$$anon$11(elementEncoder, this$29))).build__Llaika_api_config_ConfigValue$ObjectValue();
  }));
  new $c_Llaika_api_config_ConfigEncoder$$anon$14(f$1, this$30);
}
$c_Llaika_config_LinkValidation$.prototype = new $h_O();
$c_Llaika_config_LinkValidation$.prototype.constructor = $c_Llaika_config_LinkValidation$;
/** @constructor */
function $h_Llaika_config_LinkValidation$() {
}
$h_Llaika_config_LinkValidation$.prototype = $c_Llaika_config_LinkValidation$.prototype;
var $d_Llaika_config_LinkValidation$ = new $TypeData().initClass($c_Llaika_config_LinkValidation$, "laika.config.LinkValidation$", ({
  Llaika_config_LinkValidation$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Llaika_config_LinkValidation$;
function $m_Llaika_config_LinkValidation$() {
  if ((!$n_Llaika_config_LinkValidation$)) {
    $n_Llaika_config_LinkValidation$ = new $c_Llaika_config_LinkValidation$();
  }
  return $n_Llaika_config_LinkValidation$;
}
/** @constructor */
function $c_Llaika_config_MessageFilters$() {
  this.Llaika_config_MessageFilters$__f_defaults = null;
  $n_Llaika_config_MessageFilters$ = this;
  var failOn = $m_Llaika_config_MessageFilter$().Llaika_config_MessageFilter$__f_Error;
  var render = $m_Llaika_config_MessageFilter$None$();
  this.Llaika_config_MessageFilters$__f_defaults = new $c_Llaika_config_MessageFilters$Impl(failOn, render);
  var failOn$1 = $m_Llaika_config_MessageFilter$None$();
  $m_Llaika_config_MessageFilter$();
}
$c_Llaika_config_MessageFilters$.prototype = new $h_O();
$c_Llaika_config_MessageFilters$.prototype.constructor = $c_Llaika_config_MessageFilters$;
/** @constructor */
function $h_Llaika_config_MessageFilters$() {
}
$h_Llaika_config_MessageFilters$.prototype = $c_Llaika_config_MessageFilters$.prototype;
var $d_Llaika_config_MessageFilters$ = new $TypeData().initClass($c_Llaika_config_MessageFilters$, "laika.config.MessageFilters$", ({
  Llaika_config_MessageFilters$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Llaika_config_MessageFilters$;
function $m_Llaika_config_MessageFilters$() {
  if ((!$n_Llaika_config_MessageFilters$)) {
    $n_Llaika_config_MessageFilters$ = new $c_Llaika_config_MessageFilters$();
  }
  return $n_Llaika_config_MessageFilters$;
}
/** @constructor */
function $c_Llaika_config_Scope$() {
  this.Llaika_config_Scope$__f_decoder = null;
  $n_Llaika_config_Scope$ = this;
  var this$8 = $n($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string);
  var f = new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T(x$1);
    switch (x$1$1) {
      case "documents": {
        var value = $m_Llaika_config_Scope$Documents$();
        return new $c_s_util_Right(value);
        break;
      }
      case "sections": {
        var value$1 = $m_Llaika_config_Scope$Sections$();
        return new $c_s_util_Right(value$1);
        break;
      }
      case "all": {
        var value$2 = $m_Llaika_config_Scope$All$();
        return new $c_s_util_Right(value$2);
        break;
      }
      case "none": {
        var value$3 = $m_Llaika_config_Scope$None$();
        return new $c_s_util_Right(value$3);
        break;
      }
      default: {
        var message = ("Invalid value for autonumbering.scope: " + x$1$1);
        var value$4 = new $c_Llaika_api_config_ConfigError$ValidationFailed(message);
        return new $c_s_util_Left(value$4);
      }
    }
  }));
  this.Llaika_config_Scope$__f_decoder = new $c_Llaika_api_config_ConfigDecoder$$anon$1(f, this$8);
}
$c_Llaika_config_Scope$.prototype = new $h_O();
$c_Llaika_config_Scope$.prototype.constructor = $c_Llaika_config_Scope$;
/** @constructor */
function $h_Llaika_config_Scope$() {
}
$h_Llaika_config_Scope$.prototype = $c_Llaika_config_Scope$.prototype;
var $d_Llaika_config_Scope$ = new $TypeData().initClass($c_Llaika_config_Scope$, "laika.config.Scope$", ({
  Llaika_config_Scope$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Llaika_config_Scope$;
function $m_Llaika_config_Scope$() {
  if ((!$n_Llaika_config_Scope$)) {
    $n_Llaika_config_Scope$ = new $c_Llaika_config_Scope$();
  }
  return $n_Llaika_config_Scope$;
}
/** @constructor */
function $c_Llaika_config_SelectionConfig$() {
  this.Llaika_config_SelectionConfig$__f_decoder = null;
  this.Llaika_config_SelectionConfig$__f_encoder = null;
  $n_Llaika_config_SelectionConfig$ = this;
  var this$11 = $n($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_config);
  var f = new $c_sjsr_AnonFunction1(((config) => {
    var config$1 = $as_Llaika_api_config_Config(config);
    var this$2 = $n(config$1);
    var decoder = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
    var this$3 = $n($f_Llaika_api_config_Config__get__T__Llaika_api_config_ConfigDecoder__s_util_Either(this$2, "name", decoder));
    if ((this$3 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$3);
      var b = $n(x2).s_util_Right__f_value;
      var name = $as_T(b);
      var this$4 = $n(config$1);
      var decoder$1 = $m_Llaika_api_config_ConfigDecoder$().nec__Llaika_api_config_ConfigDecoder__Llaika_api_config_ConfigDecoder($m_Llaika_config_ChoiceConfig$().Llaika_config_ChoiceConfig$__f_decoder);
      var this$5 = $n($f_Llaika_api_config_Config__get__T__Llaika_api_config_ConfigDecoder__s_util_Either(this$4, "choices", decoder$1));
      if ((this$5 instanceof $c_s_util_Right)) {
        var x2$1 = $as_s_util_Right(this$5);
        var b$1 = $n(x2$1).s_util_Right__f_value;
        var this$6 = $n(config$1);
        var decoder$2 = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_boolean;
        var key = $m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key("separateEbooks");
        var this$7 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$6, key, decoder$2));
        if ((this$7 instanceof $c_s_util_Right)) {
          var x2$2 = $as_s_util_Right(this$7);
          var b$2 = $n(x2$2).s_util_Right__f_value;
          var _$1 = $as_s_Option(b$2);
          var this$8 = $n(_$1);
          var $x_1 = new $c_s_util_Right((this$8.isEmpty__Z() ? false : this$8.get__O()));
        } else {
          var $x_1 = this$7;
        }
        var this$9 = $n($x_1);
        if ((this$9 instanceof $c_s_util_Right)) {
          var x2$3 = $as_s_util_Right(this$9);
          var b$3 = $n(x2$3).s_util_Right__f_value;
          var separate = $uZ(b$3);
          return new $c_s_util_Right(new $c_Llaika_config_SelectionConfig$Impl(name, b$1, separate));
        } else {
          return this$9;
        }
      } else {
        return this$5;
      }
    } else {
      return this$3;
    }
  }));
  this.Llaika_config_SelectionConfig$__f_decoder = new $c_Llaika_api_config_ConfigDecoder$$anon$1(f, this$11);
  var this$13 = $m_Llaika_api_config_ConfigEncoder$();
  var f$1 = new $c_sjsr_AnonFunction1(((config$2) => {
    var config$3 = $as_Llaika_config_SelectionConfig(config$2);
    var $x_3 = $n($m_Llaika_api_config_ConfigEncoder$ObjectBuilder$().Llaika_api_config_ConfigEncoder$ObjectBuilder$__f_empty).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("name", $n(config$3).Llaika_config_SelectionConfig$Impl__f_name, $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_string);
    var $x_2 = $n(config$3).Llaika_config_SelectionConfig$Impl__f_choices;
    var this$12 = $m_Llaika_api_config_ConfigEncoder$();
    var elementEncoder = $m_Llaika_config_ChoiceConfig$().Llaika_config_ChoiceConfig$__f_encoder;
    return $n($n($n($x_3).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("choices", $x_2, new $c_Llaika_api_config_ConfigEncoder$$anon$12(elementEncoder, this$12))).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("separateEbooks", $n(config$3).Llaika_config_SelectionConfig$Impl__f_separateEbooks, $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_boolean)).build__Llaika_api_config_ConfigValue$ObjectValue();
  }));
  this.Llaika_config_SelectionConfig$__f_encoder = new $c_Llaika_api_config_ConfigEncoder$$anon$14(f$1, this$13);
}
$c_Llaika_config_SelectionConfig$.prototype = new $h_O();
$c_Llaika_config_SelectionConfig$.prototype.constructor = $c_Llaika_config_SelectionConfig$;
/** @constructor */
function $h_Llaika_config_SelectionConfig$() {
}
$h_Llaika_config_SelectionConfig$.prototype = $c_Llaika_config_SelectionConfig$.prototype;
var $d_Llaika_config_SelectionConfig$ = new $TypeData().initClass($c_Llaika_config_SelectionConfig$, "laika.config.SelectionConfig$", ({
  Llaika_config_SelectionConfig$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Llaika_config_SelectionConfig$;
function $m_Llaika_config_SelectionConfig$() {
  if ((!$n_Llaika_config_SelectionConfig$)) {
    $n_Llaika_config_SelectionConfig$ = new $c_Llaika_config_SelectionConfig$();
  }
  return $n_Llaika_config_SelectionConfig$;
}
/** @constructor */
function $c_Llaika_config_Selections$() {
  this.Llaika_config_Selections$__f_key = null;
  this.Llaika_config_Selections$__f_decoder = null;
  this.Llaika_config_Selections$__f_empty = null;
  $n_Llaika_config_Selections$ = this;
  var this$1 = $m_Llaika_api_config_DefaultKey$();
  var key = $m_Llaika_config_LaikaKeys$().Llaika_config_LaikaKeys$__f_selections;
  this.Llaika_config_Selections$__f_key = new $c_Llaika_api_config_DefaultKey$$anon$1(key, this$1);
  var this$2 = $m_Llaika_api_config_ConfigDecoder$();
  var elementDecoder = $m_Llaika_config_SelectionConfig$().Llaika_config_SelectionConfig$__f_decoder;
  var this$5 = new $c_Llaika_api_config_ConfigDecoder$$anon$10(elementDecoder, this$2);
  var f = new $c_sjsr_AnonFunction1(((all) => {
    var all$1 = $as_sci_Seq(all);
    return new $c_Llaika_config_Selections$Impl(all$1);
  }));
  this.Llaika_config_Selections$__f_decoder = new $c_Llaika_api_config_ConfigDecoder$$anon$2(f, this$5);
  var this$6 = $m_Llaika_api_config_ConfigEncoder$();
  var elementEncoder = $m_Llaika_config_SelectionConfig$().Llaika_config_SelectionConfig$__f_encoder;
  var this$7 = new $c_Llaika_api_config_ConfigEncoder$$anon$11(elementEncoder, this$6);
  var f$1 = new $c_sjsr_AnonFunction1(((_$4) => {
    var _$4$1 = $as_Llaika_config_Selections(_$4);
    return $n(_$4$1).Llaika_config_Selections$Impl__f_all;
  }));
  new $c_Llaika_api_config_ConfigEncoder$$anon$1(f$1, this$7);
  var all$2 = $m_sci_Nil$();
  this.Llaika_config_Selections$__f_empty = new $c_Llaika_config_Selections$Impl(all$2);
}
$c_Llaika_config_Selections$.prototype = new $h_O();
$c_Llaika_config_Selections$.prototype.constructor = $c_Llaika_config_Selections$;
/** @constructor */
function $h_Llaika_config_Selections$() {
}
$h_Llaika_config_Selections$.prototype = $c_Llaika_config_Selections$.prototype;
var $d_Llaika_config_Selections$ = new $TypeData().initClass($c_Llaika_config_Selections$, "laika.config.Selections$", ({
  Llaika_config_Selections$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Llaika_config_Selections$;
function $m_Llaika_config_Selections$() {
  if ((!$n_Llaika_config_Selections$)) {
    $n_Llaika_config_Selections$ = new $c_Llaika_config_Selections$();
  }
  return $n_Llaika_config_Selections$;
}
/** @constructor */
function $c_Llaika_config_SourceLinks$() {
  this.Llaika_config_SourceLinks$__f_decoder = null;
  this.Llaika_config_SourceLinks$__f_encoder = null;
  $n_Llaika_config_SourceLinks$ = this;
  var this$11 = $n($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_config);
  var f = new $c_sjsr_AnonFunction1(((config) => {
    var config$1 = $as_Llaika_api_config_Config(config);
    var this$2 = $n(config$1);
    var decoder = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
    var this$3 = $n($f_Llaika_api_config_Config__get__T__Llaika_api_config_ConfigDecoder__s_util_Either(this$2, "baseUri", decoder));
    if ((this$3 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$3);
      var b = $n(x2).s_util_Right__f_value;
      var baseUri = $as_T(b);
      var this$4 = $n(config$1);
      var decoder$1 = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
      var key = $m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key("packagePrefix");
      var this$5 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$4, key, decoder$1));
      if ((this$5 instanceof $c_s_util_Right)) {
        var x2$1 = $as_s_util_Right(this$5);
        var b$1 = $n(x2$1).s_util_Right__f_value;
        var _$1 = $as_s_Option(b$1);
        var this$6 = $n(_$1);
        var $x_1 = new $c_s_util_Right((this$6.isEmpty__Z() ? "*" : this$6.get__O()));
      } else {
        var $x_1 = this$5;
      }
      var this$7 = $n($x_1);
      if ((this$7 instanceof $c_s_util_Right)) {
        var x2$2 = $as_s_util_Right(this$7);
        var b$2 = $n(x2$2).s_util_Right__f_value;
        var prefix = $as_T(b$2);
        var this$8 = $n(config$1);
        var decoder$2 = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
        var this$9 = $n($f_Llaika_api_config_Config__get__T__Llaika_api_config_ConfigDecoder__s_util_Either(this$8, "suffix", decoder$2));
        if ((this$9 instanceof $c_s_util_Right)) {
          var x2$3 = $as_s_util_Right(this$9);
          var b$3 = $n(x2$3).s_util_Right__f_value;
          var suffix = $as_T(b$3);
          return new $c_s_util_Right(new $c_Llaika_config_SourceLinks$Impl(baseUri, suffix, prefix));
        } else {
          return this$9;
        }
      } else {
        return this$7;
      }
    } else {
      return this$3;
    }
  }));
  this.Llaika_config_SourceLinks$__f_decoder = new $c_Llaika_api_config_ConfigDecoder$$anon$1(f, this$11);
  var this$12 = $m_Llaika_api_config_ConfigEncoder$();
  var f$1 = new $c_sjsr_AnonFunction1(((links) => {
    var links$1 = $as_Llaika_config_SourceLinks(links);
    return $n($n($n($n($m_Llaika_api_config_ConfigEncoder$ObjectBuilder$().Llaika_api_config_ConfigEncoder$ObjectBuilder$__f_empty).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("baseUri", $n(links$1).Llaika_config_SourceLinks$Impl__f_baseUri, $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_string)).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("packagePrefix", $n(links$1).Llaika_config_SourceLinks$Impl__f_packagePrefix, $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_string)).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("suffix", $n(links$1).Llaika_config_SourceLinks$Impl__f_suffix, $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_string)).build__Llaika_api_config_ConfigValue$ObjectValue();
  }));
  this.Llaika_config_SourceLinks$__f_encoder = new $c_Llaika_api_config_ConfigEncoder$$anon$14(f$1, this$12);
}
$c_Llaika_config_SourceLinks$.prototype = new $h_O();
$c_Llaika_config_SourceLinks$.prototype.constructor = $c_Llaika_config_SourceLinks$;
/** @constructor */
function $h_Llaika_config_SourceLinks$() {
}
$h_Llaika_config_SourceLinks$.prototype = $c_Llaika_config_SourceLinks$.prototype;
var $d_Llaika_config_SourceLinks$ = new $TypeData().initClass($c_Llaika_config_SourceLinks$, "laika.config.SourceLinks$", ({
  Llaika_config_SourceLinks$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Llaika_config_SourceLinks$;
function $m_Llaika_config_SourceLinks$() {
  if ((!$n_Llaika_config_SourceLinks$)) {
    $n_Llaika_config_SourceLinks$ = new $c_Llaika_config_SourceLinks$();
  }
  return $n_Llaika_config_SourceLinks$;
}
/** @constructor */
function $c_Llaika_config_TargetFormats$() {
  this.Llaika_config_TargetFormats$__f_decoder = null;
  this.Llaika_config_TargetFormats$__f_defaultKey = null;
  $n_Llaika_config_TargetFormats$ = this;
  var this$1 = $m_Llaika_api_config_ConfigDecoder$();
  var elementDecoder = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
  var this$18 = new $c_Llaika_api_config_ConfigDecoder$$anon$10(elementDecoder, this$1);
  var f = new $c_sjsr_AnonFunction1(((formats) => {
    var formats$1 = $as_sci_Seq(formats);
    var $x_1 = $m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet;
    var this$3 = $m_sci_TreeSet$();
    var evidence$7 = $m_s_math_Ordering$String$();
    var this$4 = $n($n($x_1).fromSet__sci_SortedSet__s_Option(this$3.from__sc_IterableOnce__s_math_Ordering__sci_TreeSet(formats$1, evidence$7)));
    if (this$4.isEmpty__Z()) {
      var $x_2 = $m_Llaika_config_TargetFormats$None$();
    } else {
      var arg1 = this$4.get__O();
      var y = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet).one__O__Lcats_kernel_Order__O("*", $as_Lcats_kernel_Order($m_Lcats_kernel_instances_string_package$().Lcats_kernel_instances_string_package$__f_catsKernelStdOrderForString));
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(arg1, y)) {
        var $x_3 = $m_Llaika_config_TargetFormats$All$();
      } else {
        var this$7 = new $c_Lcats_data_NonEmptySetOps(arg1);
        var s = this$7.Lcats_data_NonEmptySetOps__f_value;
        var this$9 = $n($as_sci_SortedSet(s));
        if (this$9.contains__O__Z("pdf")) {
          var pdfExtra = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["fo", "xsl-fo"]))));
        } else {
          var pdfExtra = $m_sci_Nil$();
        }
        var this$11 = new $c_Lcats_data_NonEmptySetOps(arg1);
        var s$1 = this$11.Lcats_data_NonEmptySetOps__f_value;
        var this$13 = $n($as_sci_SortedSet(s$1));
        if (this$13.contains__O__Z("epub")) {
          var epubExtra = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["xhtml"]))));
        } else {
          var epubExtra = $m_sci_Nil$();
        }
        var this$14 = $n(pdfExtra);
        var all = $n($as_sc_IterableOnceOps(this$14.appendedAll__sc_IterableOnce__O(epubExtra))).foldLeft__O__F2__O(arg1, new $c_sjsr_AnonFunction2(((x$1, x$2) => {
          var x$2$1 = $as_T(x$2);
          return new $c_Lcats_data_NonEmptySetOps(x$1).add__O__O(x$2$1);
        })));
        var $x_3 = new $c_Llaika_config_TargetFormats$Selected(all);
      }
      var $x_2 = $as_Llaika_config_TargetFormats($x_3);
    }
    return $as_Llaika_config_TargetFormats($x_2);
  }));
  this.Llaika_config_TargetFormats$__f_decoder = new $c_Llaika_api_config_ConfigDecoder$$anon$2(f, this$18);
  var this$19 = $m_Llaika_api_config_ConfigEncoder$();
  var elementEncoder = $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_string;
  var this$25 = new $c_Llaika_api_config_ConfigEncoder$$anon$11(elementEncoder, this$19);
  var f$1 = new $c_sjsr_AnonFunction1(((x$1$1) => {
    var x$1$2 = $as_Llaika_config_TargetFormats(x$1$1);
    var x = $m_Llaika_config_TargetFormats$All$();
    if ((x === x$1$2)) {
      return $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["*"]))));
    }
    if ((x$1$2 instanceof $c_Llaika_config_TargetFormats$Selected)) {
      var x$1$3 = $as_Llaika_config_TargetFormats$Selected(x$1$2);
      var this$21 = $n(x$1$3);
      var x15 = this$21.Llaika_config_TargetFormats$Selected__f_formats;
      var this$23 = $n(new $c_Lcats_data_NonEmptySetOps(x15).toNonEmptyList__Lcats_data_NonEmptyList());
      var this$24 = $n(this$23.Lcats_data_NonEmptyList__f_tail);
      var elem = this$23.Lcats_data_NonEmptyList__f_head;
      return new $c_sci_$colon$colon(elem, this$24);
    }
    var x$3 = $m_Llaika_config_TargetFormats$None$();
    if ((x$3 === x$1$2)) {
      return $m_sci_Nil$();
    }
    throw new $c_s_MatchError(x$1$2);
  }));
  new $c_Llaika_api_config_ConfigEncoder$$anon$1(f$1, this$25);
  var this$26 = $m_Llaika_api_config_DefaultKey$();
  var key = $m_Llaika_config_LaikaKeys$().Llaika_config_LaikaKeys$__f_targetFormats;
  this.Llaika_config_TargetFormats$__f_defaultKey = new $c_Llaika_api_config_DefaultKey$$anon$1(key, this$26);
}
$c_Llaika_config_TargetFormats$.prototype = new $h_O();
$c_Llaika_config_TargetFormats$.prototype.constructor = $c_Llaika_config_TargetFormats$;
/** @constructor */
function $h_Llaika_config_TargetFormats$() {
}
$h_Llaika_config_TargetFormats$.prototype = $c_Llaika_config_TargetFormats$.prototype;
var $d_Llaika_config_TargetFormats$ = new $TypeData().initClass($c_Llaika_config_TargetFormats$, "laika.config.TargetFormats$", ({
  Llaika_config_TargetFormats$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Llaika_config_TargetFormats$;
function $m_Llaika_config_TargetFormats$() {
  if ((!$n_Llaika_config_TargetFormats$)) {
    $n_Llaika_config_TargetFormats$ = new $c_Llaika_config_TargetFormats$();
  }
  return $n_Llaika_config_TargetFormats$;
}
/** @constructor */
function $c_Llaika_config_TargetFormats$Selected$() {
}
$c_Llaika_config_TargetFormats$Selected$.prototype = new $h_O();
$c_Llaika_config_TargetFormats$Selected$.prototype.constructor = $c_Llaika_config_TargetFormats$Selected$;
/** @constructor */
function $h_Llaika_config_TargetFormats$Selected$() {
}
$h_Llaika_config_TargetFormats$Selected$.prototype = $c_Llaika_config_TargetFormats$Selected$.prototype;
$c_Llaika_config_TargetFormats$Selected$.prototype.apply__T__sci_Seq__Llaika_config_TargetFormats$Selected = (function(format, formats) {
  var formats$1 = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet).of__O__sci_Seq__Lcats_kernel_Order__O(format, formats, $as_Lcats_kernel_Order($m_Lcats_kernel_instances_string_package$().Lcats_kernel_instances_string_package$__f_catsKernelStdOrderForString));
  return new $c_Llaika_config_TargetFormats$Selected(formats$1);
});
var $d_Llaika_config_TargetFormats$Selected$ = new $TypeData().initClass($c_Llaika_config_TargetFormats$Selected$, "laika.config.TargetFormats$Selected$", ({
  Llaika_config_TargetFormats$Selected$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_config_TargetFormats$Selected$;
function $m_Llaika_config_TargetFormats$Selected$() {
  if ((!$n_Llaika_config_TargetFormats$Selected$)) {
    $n_Llaika_config_TargetFormats$Selected$ = new $c_Llaika_config_TargetFormats$Selected$();
  }
  return $n_Llaika_config_TargetFormats$Selected$;
}
/** @constructor */
function $c_Llaika_config_Version$() {
  this.Llaika_config_Version$__f_decoder = null;
  this.Llaika_config_Version$__f_encoder = null;
  $n_Llaika_config_Version$ = this;
  var this$17 = $n($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_config);
  var f = new $c_sjsr_AnonFunction1(((config) => {
    var config$1 = $as_Llaika_api_config_Config(config);
    var this$2 = $n(config$1);
    var decoder = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
    var this$3 = $n($f_Llaika_api_config_Config__get__T__Llaika_api_config_ConfigDecoder__s_util_Either(this$2, "displayValue", decoder));
    if ((this$3 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$3);
      var b = $n(x2).s_util_Right__f_value;
      var displayName = $as_T(b);
      var this$4 = $n(config$1);
      var decoder$1 = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
      var this$5 = $n($f_Llaika_api_config_Config__get__T__Llaika_api_config_ConfigDecoder__s_util_Either(this$4, "pathSegment", decoder$1));
      if ((this$5 instanceof $c_s_util_Right)) {
        var x2$1 = $as_s_util_Right(this$5);
        var b$1 = $n(x2$1).s_util_Right__f_value;
        var pathSegment = $as_T(b$1);
        var this$6 = $n(config$1);
        var decoder$2 = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_boolean;
        var key = $m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key("canonical");
        var this$7 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$6, key, decoder$2));
        if ((this$7 instanceof $c_s_util_Right)) {
          var x2$2 = $as_s_util_Right(this$7);
          var b$2 = $n(x2$2).s_util_Right__f_value;
          var _$1 = $as_s_Option(b$2);
          var this$8 = $n(_$1);
          var $x_1 = new $c_s_util_Right((this$8.isEmpty__Z() ? false : this$8.get__O()));
        } else {
          var $x_1 = this$7;
        }
        var this$9 = $n($x_1);
        if ((this$9 instanceof $c_s_util_Right)) {
          var x2$3 = $as_s_util_Right(this$9);
          var b$3 = $n(x2$3).s_util_Right__f_value;
          var canonical = $uZ(b$3);
          var this$10 = $n(config$1);
          var decoder$3 = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
          var key$1 = $m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key("fallbackLink");
          var this$11 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$10, key$1, decoder$3));
          if ((this$11 instanceof $c_s_util_Right)) {
            var x2$4 = $as_s_util_Right(this$11);
            var b$4 = $n(x2$4).s_util_Right__f_value;
            var _$1$1 = $as_s_Option(b$4);
            var this$12 = $n(_$1$1);
            var $x_2 = new $c_s_util_Right((this$12.isEmpty__Z() ? "index.html" : this$12.get__O()));
          } else {
            var $x_2 = this$11;
          }
          var this$13 = $n($x_2);
          if ((this$13 instanceof $c_s_util_Right)) {
            var x2$5 = $as_s_util_Right(this$13);
            var b$5 = $n(x2$5).s_util_Right__f_value;
            var fallbackLink = $as_T(b$5);
            var this$14 = $n(config$1);
            var decoder$4 = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
            var this$15 = $n($f_Llaika_api_config_Config__getOpt__T__Llaika_api_config_ConfigDecoder__s_util_Either(this$14, "label", decoder$4));
            if ((this$15 instanceof $c_s_util_Right)) {
              var x2$6 = $as_s_util_Right(this$15);
              var b$6 = $n(x2$6).s_util_Right__f_value;
              var label = $as_s_Option(b$6);
              return new $c_s_util_Right(new $c_Llaika_config_Version$Impl(displayName, pathSegment, fallbackLink, label, canonical));
            } else {
              return this$15;
            }
          } else {
            return this$13;
          }
        } else {
          return this$9;
        }
      } else {
        return this$5;
      }
    } else {
      return this$3;
    }
  }));
  this.Llaika_config_Version$__f_decoder = new $c_Llaika_api_config_ConfigDecoder$$anon$1(f, this$17);
  var this$18 = $m_Llaika_api_config_ConfigEncoder$();
  var f$1 = new $c_sjsr_AnonFunction1(((version) => {
    var version$1 = $as_Llaika_config_Version(version);
    return $n($n($n($n($n($n($m_Llaika_api_config_ConfigEncoder$ObjectBuilder$().Llaika_api_config_ConfigEncoder$ObjectBuilder$__f_empty).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("displayValue", $n(version$1).Llaika_config_Version$Impl__f_displayValue, $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_string)).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("pathSegment", $n(version$1).Llaika_config_Version$Impl__f_pathSegment, $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_string)).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("fallbackLink", $n(version$1).Llaika_config_Version$Impl__f_fallbackLink, $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_string)).withValue__T__s_Option__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("label", $n(version$1).Llaika_config_Version$Impl__f_label, $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_string)).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("canonical", $n(version$1).Llaika_config_Version$Impl__f_canonical, $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_boolean)).build__Llaika_api_config_ConfigValue$ObjectValue();
  }));
  this.Llaika_config_Version$__f_encoder = new $c_Llaika_api_config_ConfigEncoder$$anon$14(f$1, this$18);
}
$c_Llaika_config_Version$.prototype = new $h_O();
$c_Llaika_config_Version$.prototype.constructor = $c_Llaika_config_Version$;
/** @constructor */
function $h_Llaika_config_Version$() {
}
$h_Llaika_config_Version$.prototype = $c_Llaika_config_Version$.prototype;
var $d_Llaika_config_Version$ = new $TypeData().initClass($c_Llaika_config_Version$, "laika.config.Version$", ({
  Llaika_config_Version$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Llaika_config_Version$;
function $m_Llaika_config_Version$() {
  if ((!$n_Llaika_config_Version$)) {
    $n_Llaika_config_Version$ = new $c_Llaika_config_Version$();
  }
  return $n_Llaika_config_Version$;
}
/** @constructor */
function $c_Llaika_config_VersionScannerConfig$() {
  this.Llaika_config_VersionScannerConfig$__f_decoder = null;
  this.Llaika_config_VersionScannerConfig$__f_encoder = null;
  $n_Llaika_config_VersionScannerConfig$ = this;
  var this$10 = $n($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_config);
  var f = new $c_sjsr_AnonFunction1(((config) => {
    var config$1 = $as_Llaika_api_config_Config(config);
    var this$2 = $n(config$1);
    var decoder = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
    var this$3 = $n($f_Llaika_api_config_Config__get__T__Llaika_api_config_ConfigDecoder__s_util_Either(this$2, "rootDirectory", decoder));
    if ((this$3 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$3);
      var b = $n(x2).s_util_Right__f_value;
      var rootDirectory = $as_T(b);
      var this$5 = $n(config$1);
      var this$4 = $m_Llaika_api_config_ConfigDecoder$();
      var elementDecoder = $m_Llaika_api_config_ConfigDecoder$().path__Llaika_api_config_ConfigDecoder();
      var decoder$1 = new $c_Llaika_api_config_ConfigDecoder$$anon$10(elementDecoder, this$4);
      var key = $m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key("exclude");
      var this$6 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$5, key, decoder$1));
      if ((this$6 instanceof $c_s_util_Right)) {
        var x2$1 = $as_s_util_Right(this$6);
        var b$1 = $n(x2$1).s_util_Right__f_value;
        var _$1 = $as_s_Option(b$1);
        var this$7 = $n(_$1);
        var $x_1 = new $c_s_util_Right((this$7.isEmpty__Z() ? $m_sci_Nil$() : this$7.get__O()));
      } else {
        var $x_1 = this$6;
      }
      var this$8 = $n($x_1);
      if ((this$8 instanceof $c_s_util_Right)) {
        var x2$2 = $as_s_util_Right(this$8);
        var b$2 = $n(x2$2).s_util_Right__f_value;
        var exclude = $as_sci_Seq(b$2);
        return new $c_s_util_Right(new $c_Llaika_config_VersionScannerConfig$Impl(rootDirectory, exclude));
      } else {
        return this$8;
      }
    } else {
      return this$3;
    }
  }));
  this.Llaika_config_VersionScannerConfig$__f_decoder = new $c_Llaika_api_config_ConfigDecoder$$anon$1(f, this$10);
  var this$12 = $m_Llaika_api_config_ConfigEncoder$();
  var f$1 = new $c_sjsr_AnonFunction1(((config$2) => {
    var config$3 = $as_Llaika_config_VersionScannerConfig(config$2);
    var $x_3 = $n($m_Llaika_api_config_ConfigEncoder$ObjectBuilder$().Llaika_api_config_ConfigEncoder$ObjectBuilder$__f_empty).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("rootDirectory", $n(config$3).Llaika_config_VersionScannerConfig$Impl__f_rootDirectory, $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_string);
    var $x_2 = $n(config$3).Llaika_config_VersionScannerConfig$Impl__f_exclude;
    var this$11 = $m_Llaika_api_config_ConfigEncoder$();
    var elementEncoder = $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_path;
    return $n($n($x_3).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("exclude", $x_2, new $c_Llaika_api_config_ConfigEncoder$$anon$11(elementEncoder, this$11))).build__Llaika_api_config_ConfigValue$ObjectValue();
  }));
  this.Llaika_config_VersionScannerConfig$__f_encoder = new $c_Llaika_api_config_ConfigEncoder$$anon$14(f$1, this$12);
}
$c_Llaika_config_VersionScannerConfig$.prototype = new $h_O();
$c_Llaika_config_VersionScannerConfig$.prototype.constructor = $c_Llaika_config_VersionScannerConfig$;
/** @constructor */
function $h_Llaika_config_VersionScannerConfig$() {
}
$h_Llaika_config_VersionScannerConfig$.prototype = $c_Llaika_config_VersionScannerConfig$.prototype;
var $d_Llaika_config_VersionScannerConfig$ = new $TypeData().initClass($c_Llaika_config_VersionScannerConfig$, "laika.config.VersionScannerConfig$", ({
  Llaika_config_VersionScannerConfig$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Llaika_config_VersionScannerConfig$;
function $m_Llaika_config_VersionScannerConfig$() {
  if ((!$n_Llaika_config_VersionScannerConfig$)) {
    $n_Llaika_config_VersionScannerConfig$ = new $c_Llaika_config_VersionScannerConfig$();
  }
  return $n_Llaika_config_VersionScannerConfig$;
}
/** @constructor */
function $c_Llaika_config_Versions$() {
  this.Llaika_config_Versions$__f_key = null;
  this.Llaika_config_Versions$__f_decoder = null;
  $n_Llaika_config_Versions$ = this;
  var this$1 = $m_Llaika_api_config_DefaultKey$();
  var key = $m_Llaika_config_LaikaKeys$().Llaika_config_LaikaKeys$__f_versions;
  this.Llaika_config_Versions$__f_key = new $c_Llaika_api_config_DefaultKey$$anon$1(key, this$1);
  var this$31 = $n($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_config);
  var f$1 = new $c_sjsr_AnonFunction1(((config) => {
    var config$1 = $as_Llaika_api_config_Config(config);
    var this$3 = $n(config$1);
    var decoder = $m_Llaika_config_Version$().Llaika_config_Version$__f_decoder;
    var this$4 = $n($f_Llaika_api_config_Config__get__T__Llaika_api_config_ConfigDecoder__s_util_Either(this$3, "currentVersion", decoder));
    if ((this$4 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$4);
      var b = $n(x2).s_util_Right__f_value;
      var currentVersion = $as_Llaika_config_Version(b);
      var this$6 = $n(config$1);
      var this$5 = $m_Llaika_api_config_ConfigDecoder$();
      var elementDecoder = $m_Llaika_config_Version$().Llaika_config_Version$__f_decoder;
      var decoder$1 = new $c_Llaika_api_config_ConfigDecoder$$anon$10(elementDecoder, this$5);
      var key$1 = $m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key("olderVersions");
      var this$7 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$6, key$1, decoder$1));
      if ((this$7 instanceof $c_s_util_Right)) {
        var x2$1 = $as_s_util_Right(this$7);
        var b$1 = $n(x2$1).s_util_Right__f_value;
        var _$1 = $as_s_Option(b$1);
        var this$8 = $n(_$1);
        var $x_1 = new $c_s_util_Right((this$8.isEmpty__Z() ? $m_sci_Nil$() : this$8.get__O()));
      } else {
        var $x_1 = this$7;
      }
      var this$9 = $n($x_1);
      if ((this$9 instanceof $c_s_util_Right)) {
        var x2$2 = $as_s_util_Right(this$9);
        var b$2 = $n(x2$2).s_util_Right__f_value;
        var olderVersions = $as_sci_Seq(b$2);
        var this$11 = $n(config$1);
        var this$10 = $m_Llaika_api_config_ConfigDecoder$();
        var elementDecoder$1 = $m_Llaika_config_Version$().Llaika_config_Version$__f_decoder;
        var decoder$2 = new $c_Llaika_api_config_ConfigDecoder$$anon$10(elementDecoder$1, this$10);
        var key$2 = $m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key("newerVersions");
        var this$12 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$11, key$2, decoder$2));
        if ((this$12 instanceof $c_s_util_Right)) {
          var x2$3 = $as_s_util_Right(this$12);
          var b$3 = $n(x2$3).s_util_Right__f_value;
          var _$1$1 = $as_s_Option(b$3);
          var this$13 = $n(_$1$1);
          var $x_2 = new $c_s_util_Right((this$13.isEmpty__Z() ? $m_sci_Nil$() : this$13.get__O()));
        } else {
          var $x_2 = this$12;
        }
        var this$14 = $n($x_2);
        if ((this$14 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(this$14);
          var b$4 = $n(x2$4).s_util_Right__f_value;
          var newerVersions = $as_sci_Seq(b$4);
          var this$15 = $n(config$1);
          var decoder$3 = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_boolean;
          var key$3 = $m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key("renderUnversioned");
          var this$16 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$15, key$3, decoder$3));
          if ((this$16 instanceof $c_s_util_Right)) {
            var x2$5 = $as_s_util_Right(this$16);
            var b$5 = $n(x2$5).s_util_Right__f_value;
            var _$1$2 = $as_s_Option(b$5);
            var this$17 = $n(_$1$2);
            var $x_3 = new $c_s_util_Right((this$17.isEmpty__Z() ? false : this$17.get__O()));
          } else {
            var $x_3 = this$16;
          }
          var this$18 = $n($x_3);
          if ((this$18 instanceof $c_s_util_Right)) {
            var x2$6 = $as_s_util_Right(this$18);
            var b$6 = $n(x2$6).s_util_Right__f_value;
            var renderUnversioned = $uZ(b$6);
            var this$19 = $n(config$1);
            var decoder$4 = $m_Llaika_config_VersionScannerConfig$().Llaika_config_VersionScannerConfig$__f_decoder;
            var this$20 = $n($f_Llaika_api_config_Config__getOpt__T__Llaika_api_config_ConfigDecoder__s_util_Either(this$19, "scannerConfig", decoder$4));
            if ((this$20 instanceof $c_s_util_Right)) {
              var x2$7 = $as_s_util_Right(this$20);
              var b$7 = $n(x2$7).s_util_Right__f_value;
              var versionScanner = $as_s_Option(b$7);
              var eab = new $c_Llaika_config_Versions$Impl(currentVersion, olderVersions, newerVersions, renderUnversioned, versionScanner).validated__s_util_Either();
              matchResult23: {
                var $x_4;
                if ((eab instanceof $c_s_util_Left)) {
                  var a = $n($as_s_util_Left(eab)).s_util_Left__f_value;
                  var tc = $as_Lcats_Functor($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
                  var this$26 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(a, tc);
                  var f = new $c_sjsr_AnonFunction1(((_$5) => {
                    var _$5$1 = $as_T(_$5);
                    return new $c_Llaika_api_config_ConfigError$ValidationFailed(_$5$1);
                  }));
                  var failures = $n(this$26.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$26.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
                  var value = new $c_Llaika_api_config_ConfigError$MultipleErrors(failures);
                  var $x_4 = new $c_s_util_Left(value);
                  break matchResult23;
                }
                if ((eab instanceof $c_s_util_Right)) {
                  var r = $as_s_util_Right(eab);
                  $m_Lcats_syntax_EitherUtil$();
                  var $x_4 = r;
                  break matchResult23;
                }
                throw new $c_s_MatchError(eab);
              }
              var this$30 = $n($x_4);
              if ((this$30 instanceof $c_s_util_Right)) {
                var x2$8 = $as_s_util_Right(this$30);
                var b$8 = $n(x2$8).s_util_Right__f_value;
                var result = $as_Llaika_config_Versions(b$8);
                return new $c_s_util_Right(result);
              } else {
                return this$30;
              }
            } else {
              return this$20;
            }
          } else {
            return this$18;
          }
        } else {
          return this$14;
        }
      } else {
        return this$9;
      }
    } else {
      return this$4;
    }
  }));
  this.Llaika_config_Versions$__f_decoder = new $c_Llaika_api_config_ConfigDecoder$$anon$1(f$1, this$31);
  var this$34 = $m_Llaika_api_config_ConfigEncoder$();
  var f$2 = new $c_sjsr_AnonFunction1(((versions) => {
    var versions$1 = $as_Llaika_config_Versions(versions);
    var $x_8 = $n($n($m_Llaika_api_config_ConfigEncoder$ObjectBuilder$().Llaika_api_config_ConfigEncoder$ObjectBuilder$__f_empty).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("currentVersion", $n(versions$1).Llaika_config_Versions$Impl__f_currentVersion, $m_Llaika_config_Version$().Llaika_config_Version$__f_encoder));
    var $x_7 = $n(versions$1).Llaika_config_Versions$Impl__f_olderVersions;
    var this$32 = $m_Llaika_api_config_ConfigEncoder$();
    var elementEncoder = $m_Llaika_config_Version$().Llaika_config_Version$__f_encoder;
    var $x_6 = $n($x_8).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("olderVersions", $x_7, new $c_Llaika_api_config_ConfigEncoder$$anon$11(elementEncoder, this$32));
    var $x_5 = $n(versions$1).Llaika_config_Versions$Impl__f_newerVersions;
    var this$33 = $m_Llaika_api_config_ConfigEncoder$();
    var elementEncoder$1 = $m_Llaika_config_Version$().Llaika_config_Version$__f_encoder;
    return $n($n($n($n($x_6).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("newerVersions", $x_5, new $c_Llaika_api_config_ConfigEncoder$$anon$11(elementEncoder$1, this$33))).withValue__T__O__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("renderUnversioned", $n(versions$1).Llaika_config_Versions$Impl__f_renderUnversioned, $m_Llaika_api_config_ConfigEncoder$().Llaika_api_config_ConfigEncoder$__f_boolean)).withValue__T__s_Option__Llaika_api_config_ConfigEncoder__Llaika_api_config_ConfigEncoder$ObjectBuilder("scannerConfig", $n(versions$1).Llaika_config_Versions$Impl__f_scannerConfig, $m_Llaika_config_VersionScannerConfig$().Llaika_config_VersionScannerConfig$__f_encoder)).build__Llaika_api_config_ConfigValue$ObjectValue();
  }));
  new $c_Llaika_api_config_ConfigEncoder$$anon$14(f$2, this$34);
}
$c_Llaika_config_Versions$.prototype = new $h_O();
$c_Llaika_config_Versions$.prototype.constructor = $c_Llaika_config_Versions$;
/** @constructor */
function $h_Llaika_config_Versions$() {
}
$h_Llaika_config_Versions$.prototype = $c_Llaika_config_Versions$.prototype;
var $d_Llaika_config_Versions$ = new $TypeData().initClass($c_Llaika_config_Versions$, "laika.config.Versions$", ({
  Llaika_config_Versions$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Llaika_config_Versions$;
function $m_Llaika_config_Versions$() {
  if ((!$n_Llaika_config_Versions$)) {
    $n_Llaika_config_Versions$ = new $c_Llaika_config_Versions$();
  }
  return $n_Llaika_config_Versions$;
}
/** @constructor */
function $c_Llaika_internal_directive_ControlFlowDirectives$Else$3$() {
}
$c_Llaika_internal_directive_ControlFlowDirectives$Else$3$.prototype = new $h_O();
$c_Llaika_internal_directive_ControlFlowDirectives$Else$3$.prototype.constructor = $c_Llaika_internal_directive_ControlFlowDirectives$Else$3$;
/** @constructor */
function $h_Llaika_internal_directive_ControlFlowDirectives$Else$3$() {
}
$h_Llaika_internal_directive_ControlFlowDirectives$Else$3$.prototype = $c_Llaika_internal_directive_ControlFlowDirectives$Else$3$.prototype;
$c_Llaika_internal_directive_ControlFlowDirectives$Else$3$.prototype.toString__T = (function() {
  return "Else";
});
function $as_Llaika_internal_directive_ControlFlowDirectives$Else$3$(obj) {
  return (((obj instanceof $c_Llaika_internal_directive_ControlFlowDirectives$Else$3$) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.directive.ControlFlowDirectives$Else$3$"));
}
function $isArrayOf_Llaika_internal_directive_ControlFlowDirectives$Else$3$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_directive_ControlFlowDirectives$Else$3$)));
}
function $asArrayOf_Llaika_internal_directive_ControlFlowDirectives$Else$3$(obj, depth) {
  return (($isArrayOf_Llaika_internal_directive_ControlFlowDirectives$Else$3$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.directive.ControlFlowDirectives$Else$3$;", depth));
}
var $d_Llaika_internal_directive_ControlFlowDirectives$Else$3$ = new $TypeData().initClass($c_Llaika_internal_directive_ControlFlowDirectives$Else$3$, "laika.internal.directive.ControlFlowDirectives$Else$3$", ({
  Llaika_internal_directive_ControlFlowDirectives$Else$3$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Llaika_internal_directive_ControlFlowDirectives$ElseIf$3$() {
}
$c_Llaika_internal_directive_ControlFlowDirectives$ElseIf$3$.prototype = new $h_O();
$c_Llaika_internal_directive_ControlFlowDirectives$ElseIf$3$.prototype.constructor = $c_Llaika_internal_directive_ControlFlowDirectives$ElseIf$3$;
/** @constructor */
function $h_Llaika_internal_directive_ControlFlowDirectives$ElseIf$3$() {
}
$h_Llaika_internal_directive_ControlFlowDirectives$ElseIf$3$.prototype = $c_Llaika_internal_directive_ControlFlowDirectives$ElseIf$3$.prototype;
$c_Llaika_internal_directive_ControlFlowDirectives$ElseIf$3$.prototype.toString__T = (function() {
  return "ElseIf";
});
function $as_Llaika_internal_directive_ControlFlowDirectives$ElseIf$3$(obj) {
  return (((obj instanceof $c_Llaika_internal_directive_ControlFlowDirectives$ElseIf$3$) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.directive.ControlFlowDirectives$ElseIf$3$"));
}
function $isArrayOf_Llaika_internal_directive_ControlFlowDirectives$ElseIf$3$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_directive_ControlFlowDirectives$ElseIf$3$)));
}
function $asArrayOf_Llaika_internal_directive_ControlFlowDirectives$ElseIf$3$(obj, depth) {
  return (($isArrayOf_Llaika_internal_directive_ControlFlowDirectives$ElseIf$3$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.directive.ControlFlowDirectives$ElseIf$3$;", depth));
}
var $d_Llaika_internal_directive_ControlFlowDirectives$ElseIf$3$ = new $TypeData().initClass($c_Llaika_internal_directive_ControlFlowDirectives$ElseIf$3$, "laika.internal.directive.ControlFlowDirectives$ElseIf$3$", ({
  Llaika_internal_directive_ControlFlowDirectives$ElseIf$3$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Llaika_internal_directive_ControlFlowDirectives$Empty$3$() {
}
$c_Llaika_internal_directive_ControlFlowDirectives$Empty$3$.prototype = new $h_O();
$c_Llaika_internal_directive_ControlFlowDirectives$Empty$3$.prototype.constructor = $c_Llaika_internal_directive_ControlFlowDirectives$Empty$3$;
/** @constructor */
function $h_Llaika_internal_directive_ControlFlowDirectives$Empty$3$() {
}
$h_Llaika_internal_directive_ControlFlowDirectives$Empty$3$.prototype = $c_Llaika_internal_directive_ControlFlowDirectives$Empty$3$.prototype;
$c_Llaika_internal_directive_ControlFlowDirectives$Empty$3$.prototype.toString__T = (function() {
  return "Empty";
});
function $as_Llaika_internal_directive_ControlFlowDirectives$Empty$3$(obj) {
  return (((obj instanceof $c_Llaika_internal_directive_ControlFlowDirectives$Empty$3$) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.directive.ControlFlowDirectives$Empty$3$"));
}
function $isArrayOf_Llaika_internal_directive_ControlFlowDirectives$Empty$3$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_directive_ControlFlowDirectives$Empty$3$)));
}
function $asArrayOf_Llaika_internal_directive_ControlFlowDirectives$Empty$3$(obj, depth) {
  return (($isArrayOf_Llaika_internal_directive_ControlFlowDirectives$Empty$3$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.directive.ControlFlowDirectives$Empty$3$;", depth));
}
var $d_Llaika_internal_directive_ControlFlowDirectives$Empty$3$ = new $TypeData().initClass($c_Llaika_internal_directive_ControlFlowDirectives$Empty$3$, "laika.internal.directive.ControlFlowDirectives$Empty$3$", ({
  Llaika_internal_directive_ControlFlowDirectives$Empty$3$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Llaika_internal_directive_DirectiveSupport$() {
  this.Llaika_internal_directive_DirectiveSupport__f_blockDirectives = null;
  this.Llaika_internal_directive_DirectiveSupport__f_spanDirectives = null;
  this.Llaika_internal_directive_DirectiveSupport__f_templateDirectives = null;
  this.Llaika_internal_directive_DirectiveSupport__f_linkDirectives = null;
  this.Llaika_internal_directive_DirectiveSupport__f_laika$internal$directive$DirectiveSupport$$strictMode = false;
  this.Llaika_internal_directive_DirectiveSupport__f_origin = null;
  this.Llaika_internal_directive_DirectiveSupport__f_configProvider = null;
  this.Llaika_internal_directive_DirectiveSupport__f_parsers$lzy1 = null;
  this.Llaika_internal_directive_DirectiveSupport__f_parsersbitmap$1 = false;
  this.Llaika_internal_directive_DirectiveSupport__f_laika$internal$directive$DirectiveSupport$$linkDirectiveMap = null;
  this.Llaika_internal_directive_DirectiveSupport__f_laika$internal$directive$DirectiveSupport$$linkParser = null;
  this.Llaika_internal_directive_DirectiveSupport__f_LinkDirectiveResolver2$lzy1 = null;
  this.Llaika_internal_directive_DirectiveSupport__f_rewriteRules$lzy1 = null;
  this.Llaika_internal_directive_DirectiveSupport__f_rewriteRulesbitmap$1 = false;
  $ct_Llaika_internal_directive_DirectiveSupport__sci_Seq__sci_Seq__sci_Seq__sci_Seq__Z__(this, $m_sci_Nil$(), $m_sci_Nil$(), $m_sci_Nil$(), $m_sci_Nil$(), false);
}
$c_Llaika_internal_directive_DirectiveSupport$.prototype = new $h_Llaika_internal_directive_DirectiveSupport();
$c_Llaika_internal_directive_DirectiveSupport$.prototype.constructor = $c_Llaika_internal_directive_DirectiveSupport$;
/** @constructor */
function $h_Llaika_internal_directive_DirectiveSupport$() {
}
$h_Llaika_internal_directive_DirectiveSupport$.prototype = $c_Llaika_internal_directive_DirectiveSupport$.prototype;
var $d_Llaika_internal_directive_DirectiveSupport$ = new $TypeData().initClass($c_Llaika_internal_directive_DirectiveSupport$, "laika.internal.directive.DirectiveSupport$", ({
  Llaika_internal_directive_DirectiveSupport$: 1,
  Llaika_internal_directive_DirectiveSupport: 1,
  Llaika_api_bundle_ExtensionBundle: 1
}));
var $n_Llaika_internal_directive_DirectiveSupport$;
function $m_Llaika_internal_directive_DirectiveSupport$() {
  if ((!$n_Llaika_internal_directive_DirectiveSupport$)) {
    $n_Llaika_internal_directive_DirectiveSupport$ = new $c_Llaika_internal_directive_DirectiveSupport$();
  }
  return $n_Llaika_internal_directive_DirectiveSupport$;
}
/** @constructor */
function $c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver$(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver$.prototype = new $h_O();
$c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver$.prototype.constructor = $c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver$;
/** @constructor */
function $h_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver$() {
}
$h_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver$.prototype = $c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver$.prototype;
$c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver$.prototype.toString__T = (function() {
  return "LinkDirectiveResolver";
});
var $d_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver$ = new $TypeData().initClass($c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver$, "laika.internal.directive.DirectiveSupport$LinkDirectiveResolver$", ({
  Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2$(outer) {
  this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2$__f_$outer = outer;
}
$c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2$.prototype = new $h_O();
$c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2$.prototype.constructor = $c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2$;
/** @constructor */
function $h_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2$() {
}
$h_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2$.prototype = $c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2$.prototype;
$c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2$.prototype.apply__Llaika_ast_LinkPathReference__T__T__Llaika_parse_SourceFragment__Llaika_ast_Options__Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2 = (function(ref, directiveName, typeName, source, options) {
  return new $c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2(this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2$__f_$outer, ref, directiveName, typeName, source, options);
});
$c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2$.prototype.toString__T = (function() {
  return "LinkDirectiveResolver2";
});
var $d_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2$ = new $TypeData().initClass($c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2$, "laika.internal.directive.DirectiveSupport$LinkDirectiveResolver2$", ({
  Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig$() {
  this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig$__f_decoder = null;
  $n_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig$ = this;
  var this$31 = $n($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_config);
  var f = new $c_sjsr_AnonFunction1(((config) => {
    var config$1 = $as_Llaika_api_config_Config(config);
    var this$3 = $n(config$1);
    var this$2 = $m_Llaika_api_config_ConfigDecoder$();
    var elementDecoder = $m_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$().decoder__Llaika_api_config_ConfigDecoder();
    var decoder = new $c_Llaika_api_config_ConfigDecoder$$anon$10(elementDecoder, this$2);
    var key = $m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key("entries");
    var this$4 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$3, key, decoder));
    if ((this$4 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$4);
      var b = $n(x2).s_util_Right__f_value;
      var _$1 = $as_s_Option(b);
      var this$5 = $n(_$1);
      var $x_1 = new $c_s_util_Right((this$5.isEmpty__Z() ? $m_sci_Nil$() : this$5.get__O()));
    } else {
      var $x_1 = this$4;
    }
    var this$6 = $n($x_1);
    if ((this$6 instanceof $c_s_util_Right)) {
      var x2$1 = $as_s_util_Right(this$6);
      var b$1 = $n(x2$1).s_util_Right__f_value;
      var entries = $as_sci_Seq(b$1);
      var this$7 = $n(config$1);
      var decoder$1 = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_int;
      var key$1 = $m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key("defaultDepth");
      var this$8 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$7, key$1, decoder$1));
      if ((this$8 instanceof $c_s_util_Right)) {
        var x2$2 = $as_s_util_Right(this$8);
        var b$2 = $n(x2$2).s_util_Right__f_value;
        var _$1$1 = $as_s_Option(b$2);
        var this$9 = $n(_$1$1);
        var $x_2 = new $c_s_util_Right((this$9.isEmpty__Z() ? 2147483647 : this$9.get__O()));
      } else {
        var $x_2 = this$8;
      }
      var this$10 = $n($x_2);
      if ((this$10 instanceof $c_s_util_Right)) {
        var x2$3 = $as_s_util_Right(this$10);
        var b$3 = $n(x2$3).s_util_Right__f_value;
        var defaultDepth = $uI(b$3);
        var this$12 = $n(config$1);
        var this$11 = $m_Llaika_api_config_ConfigDecoder$();
        var elementDecoder$1 = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
        var decoder$2 = new $c_Llaika_api_config_ConfigDecoder$$anon$10(elementDecoder$1, this$11);
        var key$2 = $m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key("itemStyles");
        var this$13 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$12, key$2, decoder$2));
        if ((this$13 instanceof $c_s_util_Right)) {
          var x2$4 = $as_s_util_Right(this$13);
          var b$4 = $n(x2$4).s_util_Right__f_value;
          var _$1$2 = $as_s_Option(b$4);
          var this$14 = $n(_$1$2);
          var $x_3 = new $c_s_util_Right((this$14.isEmpty__Z() ? $m_sci_Nil$() : this$14.get__O()));
        } else {
          var $x_3 = this$13;
        }
        var this$15 = $n($x_3);
        if ((this$15 instanceof $c_s_util_Right)) {
          var x2$5 = $as_s_util_Right(this$15);
          var b$5 = $n(x2$5).s_util_Right__f_value;
          var itemStyles = $as_sci_Seq(b$5);
          var this$16 = $n(config$1);
          var decoder$3 = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_boolean;
          var key$3 = $m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key("excludeRoot");
          var this$17 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$16, key$3, decoder$3));
          if ((this$17 instanceof $c_s_util_Right)) {
            var x2$6 = $as_s_util_Right(this$17);
            var b$6 = $n(x2$6).s_util_Right__f_value;
            var _$1$3 = $as_s_Option(b$6);
            var this$18 = $n(_$1$3);
            var $x_4 = new $c_s_util_Right((this$18.isEmpty__Z() ? false : this$18.get__O()));
          } else {
            var $x_4 = this$17;
          }
          var this$19 = $n($x_4);
          if ((this$19 instanceof $c_s_util_Right)) {
            var x2$7 = $as_s_util_Right(this$19);
            var b$7 = $n(x2$7).s_util_Right__f_value;
            var excludeRoot = $uZ(b$7);
            var this$20 = $n(config$1);
            var decoder$4 = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_boolean;
            var key$4 = $m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key("excludeSections");
            var this$21 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$20, key$4, decoder$4));
            if ((this$21 instanceof $c_s_util_Right)) {
              var x2$8 = $as_s_util_Right(this$21);
              var b$8 = $n(x2$8).s_util_Right__f_value;
              var _$1$4 = $as_s_Option(b$8);
              var this$22 = $n(_$1$4);
              var $x_5 = new $c_s_util_Right((this$22.isEmpty__Z() ? false : this$22.get__O()));
            } else {
              var $x_5 = this$21;
            }
            var this$23 = $n($x_5);
            if ((this$23 instanceof $c_s_util_Right)) {
              var x2$9 = $as_s_util_Right(this$23);
              var b$9 = $n(x2$9).s_util_Right__f_value;
              var excludeSections = $uZ(b$9);
              var this$24 = $n(config$1);
              var decoder$5 = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_boolean;
              var key$5 = $m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key("excludeSelf");
              var this$25 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$24, key$5, decoder$5));
              if ((this$25 instanceof $c_s_util_Right)) {
                var x2$10 = $as_s_util_Right(this$25);
                var b$10 = $n(x2$10).s_util_Right__f_value;
                var _$1$5 = $as_s_Option(b$10);
                var this$26 = $n(_$1$5);
                var $x_6 = new $c_s_util_Right((this$26.isEmpty__Z() ? false : this$26.get__O()));
              } else {
                var $x_6 = this$25;
              }
              var this$27 = $n($x_6);
              if ((this$27 instanceof $c_s_util_Right)) {
                var x2$11 = $as_s_util_Right(this$27);
                var b$11 = $n(x2$11).s_util_Right__f_value;
                var excludeSelf = $uZ(b$11);
                $m_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig$();
                var source = $m_Llaika_parse_SourceCursor$Generated$();
                var this$28 = $n(itemStyles);
                var itemStyles$1 = $m_sci_Set$().from__sc_IterableOnce__sci_Set(this$28);
                $m_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig$();
                var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
                return new $c_s_util_Right(new $c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig(entries, source, defaultDepth, itemStyles$1, excludeRoot, excludeSections, excludeSelf, options));
              } else {
                return this$27;
              }
            } else {
              return this$23;
            }
          } else {
            return this$19;
          }
        } else {
          return this$15;
        }
      } else {
        return this$10;
      }
    } else {
      return this$6;
    }
  }));
  this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig$__f_decoder = new $c_Llaika_api_config_ConfigDecoder$$anon$1(f, this$31);
}
$c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig$.prototype = new $h_O();
$c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig$.prototype.constructor = $c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig$;
/** @constructor */
function $h_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig$() {
}
$h_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig$.prototype = $c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig$.prototype;
var $d_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig$ = new $TypeData().initClass($c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig$, "laika.internal.directive.NavigationTreeDirectives$NavigationBuilderConfig$", ({
  Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig$;
function $m_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig$() {
  if ((!$n_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig$)) {
    $n_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig$ = new $c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig$();
  }
  return $n_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig$;
}
function $p_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$__createManualNode$1__Llaika_api_config_Config__s_Option__s_util_Either($thiz, config$7, externalTarget) {
  var this$1 = $n(config$7);
  var decoder = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
  var this$2 = $n($f_Llaika_api_config_Config__get__T__Llaika_api_config_ConfigDecoder__s_util_Either(this$1, "title", decoder));
  if ((this$2 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$2);
    var b = $n(x2).s_util_Right__f_value;
    var title = $as_T(b);
    var this$4 = $n(config$7);
    var this$3 = $m_Llaika_api_config_ConfigDecoder$();
    var elementDecoder = $thiz.decoder__Llaika_api_config_ConfigDecoder();
    var decoder$1 = new $c_Llaika_api_config_ConfigDecoder$$anon$10(elementDecoder, this$3);
    var key = $m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key("entries");
    var this$5 = $n($f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$4, key, decoder$1));
    if ((this$5 instanceof $c_s_util_Right)) {
      var x2$1 = $as_s_util_Right(this$5);
      var b$1 = $n(x2$1).s_util_Right__f_value;
      var _$1 = $as_s_Option(b$1);
      var this$6 = $n(_$1);
      var $x_1 = new $c_s_util_Right((this$6.isEmpty__Z() ? $m_sci_Nil$() : this$6.get__O()));
    } else {
      var $x_1 = this$5;
    }
    var this$7 = $n($x_1);
    if ((this$7 instanceof $c_s_util_Right)) {
      var x2$2 = $as_s_util_Right(this$7);
      var b$2 = $n(x2$2).s_util_Right__f_value;
      var children = $as_sci_Seq(b$2);
      var this$8 = $m_Llaika_ast_SpanSequence$();
      var texts = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([]));
      var title$1 = $as_Llaika_ast_SpanSequence($f_Llaika_ast_SpanContainerCompanion__apply__T__sci_Seq__O(this$8, title, texts));
      return new $c_s_util_Right(new $c_Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode(title$1, externalTarget, children));
    } else {
      return this$7;
    }
  } else {
    return this$2;
  }
}
function $p_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$__createGeneratedNode$1__Llaika_api_config_Config__Llaika_ast_VirtualPath__s_util_Either($thiz, config$9, internalTarget) {
  var this$1 = $n(config$9);
  var decoder = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
  var this$2 = $n($f_Llaika_api_config_Config__getOpt__T__Llaika_api_config_ConfigDecoder__s_util_Either(this$1, "title", decoder));
  if ((this$2 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$2);
    var b = $n(x2).s_util_Right__f_value;
    var title = $as_s_Option(b);
    var this$3 = $n(config$9);
    var decoder$1 = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_int;
    var this$4 = $n($f_Llaika_api_config_Config__getOpt__T__Llaika_api_config_ConfigDecoder__s_util_Either(this$3, "depth", decoder$1));
    if ((this$4 instanceof $c_s_util_Right)) {
      var x2$1 = $as_s_util_Right(this$4);
      var b$1 = $n(x2$1).s_util_Right__f_value;
      var depth = $as_s_Option(b$1);
      var this$5 = $n(config$9);
      var decoder$2 = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_boolean;
      var this$6 = $n($f_Llaika_api_config_Config__getOpt__T__Llaika_api_config_ConfigDecoder__s_util_Either(this$5, "excludeRoot", decoder$2));
      if ((this$6 instanceof $c_s_util_Right)) {
        var x2$2 = $as_s_util_Right(this$6);
        var b$2 = $n(x2$2).s_util_Right__f_value;
        var excludeRoot = $as_s_Option(b$2);
        var this$7 = $n(config$9);
        var decoder$3 = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_boolean;
        var this$8 = $n($f_Llaika_api_config_Config__getOpt__T__Llaika_api_config_ConfigDecoder__s_util_Either(this$7, "excludeSections", decoder$3));
        if ((this$8 instanceof $c_s_util_Right)) {
          var x2$3 = $as_s_util_Right(this$8);
          var b$3 = $n(x2$3).s_util_Right__f_value;
          var excludeSections = $as_s_Option(b$3);
          var this$9 = $n(title);
          if (this$9.isEmpty__Z()) {
            var titleSpan = $m_s_None$();
          } else {
            var arg1 = this$9.get__O();
            var _$4 = $as_T(arg1);
            var this$10 = $m_Llaika_ast_SpanSequence$();
            var texts = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([]));
            var titleSpan = new $c_s_Some($as_Llaika_ast_SpanSequence($f_Llaika_ast_SpanContainerCompanion__apply__T__sci_Seq__O(this$10, _$4, texts)));
          }
          return new $c_s_util_Right(new $c_Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode(internalTarget, titleSpan, depth, excludeRoot, excludeSections));
        } else {
          return this$8;
        }
      } else {
        return this$6;
      }
    } else {
      return this$4;
    }
  } else {
    return this$2;
  }
}
/** @constructor */
function $c_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$() {
  this.Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$__f_decoder$lzy1 = null;
  this.Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$__f_decoderbitmap$1 = false;
}
$c_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$.prototype = new $h_O();
$c_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$.prototype.constructor = $c_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$;
/** @constructor */
function $h_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$() {
}
$h_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$.prototype = $c_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$.prototype;
$c_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$.prototype.decoder__Llaika_api_config_ConfigDecoder = (function() {
  if ((!this.Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$__f_decoderbitmap$1)) {
    var this$10 = $n($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_config);
    var f = new $c_sjsr_AnonFunction1(((config) => {
      var config$1 = $as_Llaika_api_config_Config(config);
      var this$2 = $n(config$1);
      var decoder = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string;
      var this$3 = $n($f_Llaika_api_config_Config__getOpt__T__Llaika_api_config_ConfigDecoder__s_util_Either(this$2, "target", decoder));
      if ((this$3 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(this$3);
        var b = $n(x2).s_util_Right__f_value;
        var optTarget = $as_s_Option(b);
        var this$4 = $n(optTarget);
        if (this$4.isEmpty__Z()) {
          return $p_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$__createManualNode$1__Llaika_api_config_Config__s_Option__s_util_Either(this, config$1, $m_s_None$());
        } else {
          var arg1 = this$4.get__O();
          var targetStr = $as_T(arg1);
          var this$5 = $n(targetStr);
          if (((this$5.length >= 0) && ($as_T(this$5.substring(0, 5)) === "http:"))) {
            var $x_2 = true;
          } else {
            var this$6 = $n(targetStr);
            var $x_2 = ((this$6.length >= 0) && ($as_T(this$6.substring(0, 6)) === "https:"));
          }
          if ($x_2) {
            var $x_1 = true;
          } else {
            var this$7 = $n(targetStr);
            var $x_1 = ((this$7.length >= 0) && ($as_T(this$7.substring(0, 7)) === "mailto:"));
          }
          if ($x_1) {
            var value = new $c_Llaika_ast_ExternalTarget(targetStr);
            return $p_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$__createManualNode$1__Llaika_api_config_Config__s_Option__s_util_Either(this, config$1, new $c_s_Some(value));
          } else {
            return $p_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$__createGeneratedNode$1__Llaika_api_config_Config__Llaika_ast_VirtualPath__s_util_Either(this, config$1, $m_Llaika_ast_VirtualPath$().parse__T__Llaika_ast_VirtualPath(targetStr));
          }
        }
      } else {
        return this$3;
      }
    }));
    this.Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$__f_decoder$lzy1 = new $c_Llaika_api_config_ConfigDecoder$$anon$1(f, this$10);
    this.Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$__f_decoderbitmap$1 = true;
  }
  return this.Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$__f_decoder$lzy1;
});
var $d_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$ = new $TypeData().initClass($c_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$, "laika.internal.directive.NavigationTreeDirectives$NavigationNodeConfig$", ({
  Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$;
function $m_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$() {
  if ((!$n_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$)) {
    $n_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$ = new $c_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$();
  }
  return $n_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig$;
}
function $p_Llaika_internal_directive_StandardDirectives$__asBlock__sci_Seq__Llaika_ast_Options__Llaika_ast_Block($thiz, blocks, options) {
  if ((blocks instanceof $c_sci_$colon$colon)) {
    var x2 = $as_sci_$colon$colon(blocks);
    var x4 = $n(x2).sci_$colon$colon__f_next;
    var block = $as_Llaika_ast_Block($n(x2).sci_$colon$colon__f_head);
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x4)) {
      return $as_Llaika_ast_Block($n($as_Llaika_ast_Element(block)).mergeOptions__Llaika_ast_Options__Llaika_ast_Element(options));
    }
  }
  return new $c_Llaika_ast_BlockSequence(blocks, options);
}
function $p_Llaika_internal_directive_StandardDirectives$__asSpan__sci_Seq__Llaika_ast_Options__Llaika_ast_Span($thiz, spans, options) {
  if ((spans instanceof $c_sci_$colon$colon)) {
    var x6 = $as_sci_$colon$colon(spans);
    var x8 = $n(x6).sci_$colon$colon__f_next;
    var span = $as_Llaika_ast_Span($n(x6).sci_$colon$colon__f_head);
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x8)) {
      return $as_Llaika_ast_Span($n($as_Llaika_ast_Element(span)).mergeOptions__Llaika_ast_Options__Llaika_ast_Element(options));
    }
  }
  return new $c_Llaika_ast_SpanSequence(spans, options);
}
function $p_Llaika_internal_directive_StandardDirectives$__resolveTarget$1__Llaika_ast_DocumentCursor__Llaika_ast_Target__s_util_Either($thiz, cursor$1, target) {
  if ((target instanceof $c_Llaika_ast_ExternalTarget)) {
    var et = $as_Llaika_ast_ExternalTarget(target);
    var element = $m_Llaika_ast_RawLink$().external__T__Llaika_ast_RawLink($n(et).Llaika_ast_ExternalTarget__f_url);
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var value = new $c_Llaika_ast_TemplateElement(element, 0, options);
    return new $c_s_util_Right(value);
  }
  if ($is_Llaika_ast_InternalTarget(target)) {
    var it = $as_Llaika_ast_InternalTarget(target);
    var this$4 = $n(cursor$1);
    var x9 = $n($p_Llaika_ast_DocumentCursor__validator__Llaika_internal_link_LinkValidator(this$4)).validate__Llaika_ast_InternalTarget__Llaika_ast_TargetValidation(it);
    var x = $m_Llaika_ast_TargetValidation$ValidTarget$();
    if ((x === x9)) {
      var target$1 = $n(it).relativeTo__Llaika_ast_Path__Llaika_ast_InternalTarget$Resolved($n(cursor$1).Llaika_ast_DocumentCursor__f_path);
      var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      var element$1 = new $c_Llaika_ast_RawLink(target$1, options$1);
      var options$2 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      var value$1 = new $c_Llaika_ast_TemplateElement(element$1, 0, options$2);
      return new $c_s_util_Right(value$1);
    }
    if ((x9 instanceof $c_Llaika_ast_TargetValidation$InvalidTarget)) {
      var x$1 = $as_Llaika_ast_TargetValidation$InvalidTarget(x9);
      var this$11 = $n(x$1);
      var x16 = this$11.Llaika_ast_TargetValidation$InvalidTarget__f_message;
      return new $c_s_util_Left(x16);
    }
    if ((x9 instanceof $c_Llaika_ast_TargetValidation$RecoveredTarget)) {
      var x$1$1 = $as_Llaika_ast_TargetValidation$RecoveredTarget(x9);
      var this$14 = $n(x$1$1);
      var x12 = this$14.Llaika_ast_TargetValidation$RecoveredTarget__f_message;
      var this$15 = $n(x$1$1);
      return new $c_s_util_Left(x12);
    }
    throw new $c_s_MatchError(x9);
  }
  throw new $c_s_MatchError(target);
}
/** @constructor */
function $c_Llaika_internal_directive_StandardDirectives$() {
  this.Llaika_internal_directive_StandardDirectives$__f_origin = null;
  this.Llaika_internal_directive_StandardDirectives$__f_callout$lzy1 = null;
  this.Llaika_internal_directive_StandardDirectives$__f_calloutbitmap$1 = false;
  this.Llaika_internal_directive_StandardDirectives$__f_target$lzy1 = null;
  this.Llaika_internal_directive_StandardDirectives$__f_targetbitmap$1 = false;
  this.Llaika_internal_directive_StandardDirectives$__f_date$lzy1 = null;
  this.Llaika_internal_directive_StandardDirectives$__f_datebitmap$1 = false;
  this.Llaika_internal_directive_StandardDirectives$__f_attr$lzy1 = null;
  this.Llaika_internal_directive_StandardDirectives$__f_attrbitmap$1 = false;
  this.Llaika_internal_directive_StandardDirectives$__f_format$lzy1 = null;
  this.Llaika_internal_directive_StandardDirectives$__f_formatbitmap$1 = false;
  this.Llaika_internal_directive_StandardDirectives$__f_blockStyle$lzy1 = null;
  this.Llaika_internal_directive_StandardDirectives$__f_blockStylebitmap$1 = false;
  this.Llaika_internal_directive_StandardDirectives$__f_spanStyle$lzy1 = null;
  this.Llaika_internal_directive_StandardDirectives$__f_spanStylebitmap$1 = false;
  this.Llaika_internal_directive_StandardDirectives$__f_iconSpan$lzy1 = null;
  this.Llaika_internal_directive_StandardDirectives$__f_iconSpanbitmap$1 = false;
  this.Llaika_internal_directive_StandardDirectives$__f_iconTemplate$lzy1 = null;
  this.Llaika_internal_directive_StandardDirectives$__f_iconTemplatebitmap$1 = false;
  this.Llaika_internal_directive_StandardDirectives$__f_blockFragment$lzy1 = null;
  this.Llaika_internal_directive_StandardDirectives$__f_blockFragmentbitmap$1 = false;
  this.Llaika_internal_directive_StandardDirectives$__f_pageBreak$lzy1 = null;
  this.Llaika_internal_directive_StandardDirectives$__f_pageBreakbitmap$1 = false;
  this.Llaika_internal_directive_StandardDirectives$__f_todoSpan = null;
  this.Llaika_internal_directive_StandardDirectives$__f_todoBlock = null;
  this.Llaika_internal_directive_StandardDirectives$__f_blockDirectives$lzy1 = null;
  this.Llaika_internal_directive_StandardDirectives$__f_blockDirectivesbitmap$1 = false;
  this.Llaika_internal_directive_StandardDirectives$__f_spanDirectives$lzy1 = null;
  this.Llaika_internal_directive_StandardDirectives$__f_spanDirectivesbitmap$1 = false;
  this.Llaika_internal_directive_StandardDirectives$__f_templateDirectives$lzy1 = null;
  this.Llaika_internal_directive_StandardDirectives$__f_templateDirectivesbitmap$1 = false;
  this.Llaika_internal_directive_StandardDirectives$__f_linkDirectives$lzy1 = null;
  this.Llaika_internal_directive_StandardDirectives$__f_linkDirectivesbitmap$1 = false;
  $n_Llaika_internal_directive_StandardDirectives$ = this;
  this.Llaika_internal_directive_StandardDirectives$__f_origin = $m_Llaika_api_bundle_BundleOrigin$Library$();
  var this$6 = $m_Llaika_api_bundle_SpanDirectives$();
  var this$1 = $n($m_Llaika_api_bundle_SpanDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
  var this$5 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$1, 0));
  var f = new $c_sjsr_AnonFunction1(((_$8) => {
    $as_Llaika_api_config_ConfigValue(_$8);
    var content = $m_sci_Nil$();
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    return new $c_Llaika_ast_SpanSequence(content, options);
  }));
  var part = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$2(f, this$5);
  this.Llaika_internal_directive_StandardDirectives$__f_todoSpan = new $c_Llaika_api_bundle_DirectiveBuilderContext$Directive(this$6, "todo", part);
  var this$11 = $m_Llaika_api_bundle_BlockDirectives$();
  var this$7 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
  var this$10 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$7, 0));
  var f$1 = new $c_sjsr_AnonFunction1(((_$9) => {
    $as_Llaika_api_config_ConfigValue(_$9);
    var content$1 = $m_sci_Nil$();
    var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    return new $c_Llaika_ast_BlockSequence(content$1, options$1);
  }));
  var part$1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$2(f$1, this$10);
  this.Llaika_internal_directive_StandardDirectives$__f_todoBlock = new $c_Llaika_api_bundle_DirectiveBuilderContext$Directive(this$11, "todo", part$1);
}
$c_Llaika_internal_directive_StandardDirectives$.prototype = new $h_O();
$c_Llaika_internal_directive_StandardDirectives$.prototype.constructor = $c_Llaika_internal_directive_StandardDirectives$;
/** @constructor */
function $h_Llaika_internal_directive_StandardDirectives$() {
}
$h_Llaika_internal_directive_StandardDirectives$.prototype = $c_Llaika_internal_directive_StandardDirectives$.prototype;
$c_Llaika_internal_directive_StandardDirectives$.prototype.baseConfig__Llaika_api_config_Config = (function() {
  return $m_Llaika_api_config_Config$().Llaika_api_config_Config$__f_empty;
});
$c_Llaika_internal_directive_StandardDirectives$.prototype.slugBuilder__s_Option = (function() {
  return $m_s_None$();
});
$c_Llaika_internal_directive_StandardDirectives$.prototype.parsers__Llaika_api_bundle_ParserBundle = (function() {
  return new $c_Llaika_api_bundle_ParserBundle($m_sci_Nil$(), $m_sci_Nil$(), $m_sci_Nil$(), $m_s_None$(), $m_s_None$(), $m_s_None$(), $m_s_None$());
});
$c_Llaika_internal_directive_StandardDirectives$.prototype.rewriteRules__s_PartialFunction = (function() {
  return $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf;
});
$c_Llaika_internal_directive_StandardDirectives$.prototype.renderOverrides__sci_Seq = (function() {
  return $as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps());
});
$c_Llaika_internal_directive_StandardDirectives$.prototype.rawContentDisabled__s_Option = (function() {
  return new $c_s_Some(this);
});
$c_Llaika_internal_directive_StandardDirectives$.prototype.forStrictMode__s_Option = (function() {
  return $f_Llaika_api_bundle_DirectiveRegistry__forStrictMode__s_Option(this);
});
$c_Llaika_internal_directive_StandardDirectives$.prototype.processExtension__s_PartialFunction = (function() {
  return new $c_Llaika_api_bundle_DirectiveRegistry$$anon$2(this);
});
$c_Llaika_internal_directive_StandardDirectives$.prototype.origin__Llaika_api_bundle_BundleOrigin = (function() {
  return this.Llaika_internal_directive_StandardDirectives$__f_origin;
});
$c_Llaika_internal_directive_StandardDirectives$.prototype.callout__Llaika_api_bundle_DirectiveBuilderContext$Directive = (function() {
  if ((!this.Llaika_internal_directive_StandardDirectives$__f_calloutbitmap$1)) {
    var this$7 = $m_Llaika_api_bundle_BlockDirectives$();
    var this$1 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _1 = $n($n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$1, 0)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string));
    var this$2 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _2 = $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__parsedBody__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$2);
    var t2 = new $c_T2(_1, _2);
    var part = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(new $c_Lcats_syntax_Tuple2SemigroupalOps(t2).mapN__F2__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction2(((style, body) => {
      var style$1 = $as_T(style);
      var body$1 = $as_sci_Seq(body);
      var options = $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["callout", style$1])));
      return new $c_Llaika_ast_BlockSequence(body$1, options);
    })), $n($m_Llaika_api_bundle_BlockDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances, $as_Lcats_Semigroupal($n($m_Llaika_api_bundle_BlockDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances)));
    this.Llaika_internal_directive_StandardDirectives$__f_callout$lzy1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$Directive(this$7, "callout", part);
    this.Llaika_internal_directive_StandardDirectives$__f_calloutbitmap$1 = true;
  }
  return this.Llaika_internal_directive_StandardDirectives$__f_callout$lzy1;
});
$c_Llaika_internal_directive_StandardDirectives$.prototype.target__Llaika_api_bundle_DirectiveBuilderContext$Directive = (function() {
  if ((!this.Llaika_internal_directive_StandardDirectives$__f_targetbitmap$1)) {
    var this$14 = $m_Llaika_api_bundle_TemplateDirectives$();
    var this$1 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _1 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$1, 0)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().target__Llaika_api_config_ConfigDecoder());
    var this$2 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _2 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$2, 0)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string);
    var this$3 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _3 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12(this$3);
    var t3 = new $c_T3(_1, _2, _3);
    var part = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(new $c_Lcats_syntax_Tuple3SemigroupalOps(t3).mapN__F3__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction3(((literalTarget, pathKey, cursor) => {
      var literalTarget$1 = $as_Llaika_ast_Target(literalTarget);
      var pathKey$1 = $as_T(pathKey);
      var cursor$1 = $as_Llaika_ast_DocumentCursor(cursor);
      var config = $n(cursor$1).Llaika_ast_DocumentCursor__f_config;
      var this$7 = $n(config);
      if ($f_Llaika_api_config_Config__hasKey__T__Z(this$7, pathKey$1)) {
        var this$8 = $n(config);
        var decoder = $m_Llaika_api_config_ConfigDecoder$().target__Llaika_api_config_ConfigDecoder();
        var eab = $f_Llaika_api_config_Config__get__T__Llaika_api_config_ConfigDecoder__s_util_Either(this$8, pathKey$1, decoder);
        matchResult23: {
          var $x_1;
          if ((eab instanceof $c_s_util_Left)) {
            var a = $n($as_s_util_Left(eab)).s_util_Left__f_value;
            var _$1 = $as_Llaika_api_config_ConfigError(a);
            var value = $n(_$1).message__T();
            var $x_1 = new $c_s_util_Left(value);
            break matchResult23;
          }
          if ((eab instanceof $c_s_util_Right)) {
            var r = $as_s_util_Right(eab);
            $m_Lcats_syntax_EitherUtil$();
            var $x_1 = r;
            break matchResult23;
          }
          throw new $c_s_MatchError(eab);
        }
        var this$13 = $n($x_1);
        if ((this$13 instanceof $c_s_util_Right)) {
          var x2 = $as_s_util_Right(this$13);
          var b = $n(x2).s_util_Right__f_value;
          var target = $as_Llaika_ast_Target(b);
          return $p_Llaika_internal_directive_StandardDirectives$__resolveTarget$1__Llaika_ast_DocumentCursor__Llaika_ast_Target__s_util_Either(this, cursor$1, target);
        } else {
          return this$13;
        }
      } else {
        return $p_Llaika_internal_directive_StandardDirectives$__resolveTarget$1__Llaika_ast_DocumentCursor__Llaika_ast_Target__s_util_Either(this, cursor$1, literalTarget$1);
      }
    })), $n($m_Llaika_api_bundle_TemplateDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances, $as_Lcats_Semigroupal($n($m_Llaika_api_bundle_TemplateDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances)));
    this.Llaika_internal_directive_StandardDirectives$__f_target$lzy1 = $f_Llaika_api_bundle_DirectiveBuilderContext__eval__T__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$Directive(this$14, "target", part);
    this.Llaika_internal_directive_StandardDirectives$__f_targetbitmap$1 = true;
  }
  return this.Llaika_internal_directive_StandardDirectives$__f_target$lzy1;
});
$c_Llaika_internal_directive_StandardDirectives$.prototype.date__Llaika_api_bundle_DirectiveBuilderContext$Directive = (function() {
  if ((!this.Llaika_internal_directive_StandardDirectives$__f_datebitmap$1)) {
    var this$22 = $m_Llaika_api_bundle_TemplateDirectives$();
    var this$1 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _1 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$1, 0)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string);
    var this$2 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _2 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$2, 1)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string);
    var this$3 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var this$4 = $n($n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$3, 2)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string));
    var _3 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$7(this$4);
    var this$5 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _4 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12(this$5);
    var t4 = new $c_T4(_1, _2, _3, _4);
    var part = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(new $c_Lcats_syntax_Tuple4SemigroupalOps(t4).mapN__F4__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction4(((refKey, pattern, localeAttr, cursor) => {
      var refKey$1 = $as_T(refKey);
      var pattern$1 = $as_T(pattern);
      var localeAttr$1 = $as_s_Option(localeAttr);
      var cursor$1 = $as_Llaika_ast_DocumentCursor(cursor);
      var this$9 = $n(localeAttr$1);
      var locale = (this$9.isEmpty__Z() ? $n($n($n(cursor$1).Llaika_ast_DocumentCursor__f_config).get__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either($n($m_Llaika_config_LaikaKeys$().Llaika_config_LaikaKeys$__f_metadata).child__T__Llaika_api_config_Key("language"), $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string)).toOption__s_Option() : this$9);
      var this$10 = $n($n(cursor$1).Llaika_ast_DocumentCursor__f_config);
      var decoder = $m_Llaika_api_config_ConfigDecoder$().date__Llaika_api_config_ConfigDecoder();
      var eab = $f_Llaika_api_config_Config__get__T__Llaika_api_config_ConfigDecoder__s_util_Either(this$10, refKey$1, decoder);
      matchResult23: {
        var $x_1;
        if ((eab instanceof $c_s_util_Left)) {
          var a = $n($as_s_util_Left(eab)).s_util_Left__f_value;
          var _$2 = $as_Llaika_api_config_ConfigError(a);
          var value = $n(_$2).message__T();
          var $x_1 = new $c_s_util_Left(value);
          break matchResult23;
        }
        if ((eab instanceof $c_s_util_Right)) {
          var r = $as_s_util_Right(eab);
          $m_Lcats_syntax_EitherUtil$();
          var $x_1 = r;
          break matchResult23;
        }
        throw new $c_s_MatchError(eab);
      }
      var this$15 = $n($x_1);
      if ((this$15 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(this$15);
        var b = $n(x2).s_util_Right__f_value;
        var this$17 = $n($m_Llaika_config_PlatformDateTimeImpl$().formatConstant__sjs_js_Date__T__s_Option__s_Option(b, pattern$1, locale));
        var this$19 = $n($as_s_util_Either((this$17.isEmpty__Z() ? $m_Llaika_config_PlatformDateTimeImpl$().format__sjs_js_Date__T__s_Option__s_util_Either(b, pattern$1, locale) : this$17.get__O())));
        if ((this$19 instanceof $c_s_util_Right)) {
          var x2$1 = $as_s_util_Right(this$19);
          var b$1 = $n(x2$1).s_util_Right__f_value;
          var _$3 = $as_T(b$1);
          var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
          return new $c_s_util_Right(new $c_Llaika_ast_TemplateString(_$3, options));
        } else {
          return this$19;
        }
      } else {
        return this$15;
      }
    })), $n($m_Llaika_api_bundle_TemplateDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances, $as_Lcats_Semigroupal($n($m_Llaika_api_bundle_TemplateDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances)));
    this.Llaika_internal_directive_StandardDirectives$__f_date$lzy1 = $f_Llaika_api_bundle_DirectiveBuilderContext__eval__T__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$Directive(this$22, "date", part);
    this.Llaika_internal_directive_StandardDirectives$__f_datebitmap$1 = true;
  }
  return this.Llaika_internal_directive_StandardDirectives$__f_date$lzy1;
});
$c_Llaika_internal_directive_StandardDirectives$.prototype.attr__Llaika_api_bundle_DirectiveBuilderContext$Directive = (function() {
  if ((!this.Llaika_internal_directive_StandardDirectives$__f_attrbitmap$1)) {
    var this$19 = $m_Llaika_api_bundle_TemplateDirectives$();
    var this$1 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _1 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$1, 0)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string);
    var this$2 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _2 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$2, 1)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string);
    var this$3 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _3 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$12(this$3);
    var t3 = new $c_T3(_1, _2, _3);
    var part = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(new $c_Lcats_syntax_Tuple3SemigroupalOps(t3).mapN__F3__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction3(((name, ref, cursor) => {
      var name$1 = $as_T(name);
      var ref$1 = $as_T(ref);
      var cursor$1 = $as_Llaika_ast_DocumentCursor(cursor);
      var eab = $n(cursor$1).resolveReference__Llaika_api_config_Key__s_util_Either($m_Llaika_api_config_Key$().parse__T__Llaika_api_config_Key(ref$1));
      matchResult23: {
        var $x_1;
        if ((eab instanceof $c_s_util_Left)) {
          var a = $n($as_s_util_Left(eab)).s_util_Left__f_value;
          var _$4 = $as_Llaika_api_config_ConfigError(a);
          var value = $n(_$4).message__T();
          var $x_1 = new $c_s_util_Left(value);
          break matchResult23;
        }
        if ((eab instanceof $c_s_util_Right)) {
          var r = $as_s_util_Right(eab);
          $m_Lcats_syntax_EitherUtil$();
          var $x_1 = r;
          break matchResult23;
        }
        throw new $c_s_MatchError(eab);
      }
      var this$11 = $n($x_1);
      if ((this$11 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(this$11);
        var b = $n(x2).s_util_Right__f_value;
        var x$1 = $as_s_Option(b);
        var x = $m_s_None$();
        if ((x === x$1)) {
          var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
          var value$1 = new $c_Llaika_ast_TemplateString("", options);
          return new $c_s_util_Right(value$1);
        }
        if ((x$1 instanceof $c_s_Some)) {
          var x24 = $as_Llaika_api_config_ConfigValue($n($as_s_Some(x$1)).s_Some__f_value);
          if ($is_Llaika_api_config_ConfigValue$SimpleValue(x24)) {
            var value$2 = $as_Llaika_api_config_ConfigValue$SimpleValue(x24);
            var content = (((name$1 + "=\"") + $n(value$2).render__T()) + "\"");
            var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
            var value$3 = new $c_Llaika_ast_TemplateString(content, options$1);
            return new $c_s_util_Right(value$3);
          }
          var value$4 = (("value with key '" + ref$1) + "' is a structured value (Array, Object, AST) which is not supported by this directive");
          return new $c_s_util_Left(value$4);
        }
        throw new $c_s_MatchError(x$1);
      } else {
        return this$11;
      }
    })), $n($m_Llaika_api_bundle_TemplateDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances, $as_Lcats_Semigroupal($n($m_Llaika_api_bundle_TemplateDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances)));
    this.Llaika_internal_directive_StandardDirectives$__f_attr$lzy1 = $f_Llaika_api_bundle_DirectiveBuilderContext__eval__T__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$Directive(this$19, "attribute", part);
    this.Llaika_internal_directive_StandardDirectives$__f_attrbitmap$1 = true;
  }
  return this.Llaika_internal_directive_StandardDirectives$__f_attr$lzy1;
});
$c_Llaika_internal_directive_StandardDirectives$.prototype.format__Llaika_api_bundle_DirectiveBuilderContext$Directive = (function() {
  if ((!this.Llaika_internal_directive_StandardDirectives$__f_formatbitmap$1)) {
    var this$13 = $m_Llaika_api_bundle_BlockDirectives$();
    var this$1 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _1 = $n(new $c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes(this$1, $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_configValue).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string));
    var this$2 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var this$4 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__parsedBody__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$2));
    var f = new $c_sjsr_AnonFunction1(((_$5) => {
      var _$5$1 = $as_sci_Seq(_$5);
      return $p_Llaika_internal_directive_StandardDirectives$__asBlock__sci_Seq__Llaika_ast_Options__Llaika_ast_Block(this, _$5$1, $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty);
    }));
    var _2 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$2(f, this$4);
    var t2 = new $c_T2(_1, _2);
    var part = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(new $c_Lcats_syntax_Tuple2SemigroupalOps(t2).mapN__F2__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction2(((formats, body) => {
      var formats$1 = $as_sci_Seq(formats);
      var body$1 = $as_Llaika_ast_Block(body);
      var $x_1 = $m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet;
      var this$7 = $m_sci_TreeSet$();
      var evidence$7 = $m_s_math_Ordering$String$();
      var this$8 = $n($n($x_1).fromSet__sci_SortedSet__s_Option(this$7.from__sc_IterableOnce__s_math_Ordering__sci_TreeSet(formats$1, evidence$7)));
      if (this$8.isEmpty__Z()) {
        var $x_2 = new $c_s_util_Left("no formats provided");
      } else {
        var arg1 = this$8.get__O();
        var element = $as_Llaika_ast_Element(body$1);
        var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
        var value = new $c_Llaika_ast_TargetFormat(arg1, element, options);
        var $x_2 = new $c_s_util_Right(value);
      }
      return $as_s_util_Either($x_2);
    })), $n($m_Llaika_api_bundle_BlockDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances, $as_Lcats_Semigroupal($n($m_Llaika_api_bundle_BlockDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances)));
    this.Llaika_internal_directive_StandardDirectives$__f_format$lzy1 = $f_Llaika_api_bundle_DirectiveBuilderContext__eval__T__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$Directive(this$13, "format", part);
    this.Llaika_internal_directive_StandardDirectives$__f_formatbitmap$1 = true;
  }
  return this.Llaika_internal_directive_StandardDirectives$__f_format$lzy1;
});
$c_Llaika_internal_directive_StandardDirectives$.prototype.blockStyle__Llaika_api_bundle_DirectiveBuilderContext$Directive = (function() {
  if ((!this.Llaika_internal_directive_StandardDirectives$__f_blockStylebitmap$1)) {
    var this$7 = $m_Llaika_api_bundle_BlockDirectives$();
    var this$1 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _1 = $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__parsedBody__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$1);
    var this$2 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var this$4 = $n(new $c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes(this$2, $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_configValue).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string));
    var f = new $c_sjsr_AnonFunction1(((_$6) => {
      var _$6$1 = $as_sci_Seq(_$6);
      return $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options(_$6$1);
    }));
    var _2 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$2(f, this$4);
    var t2 = new $c_T2(_1, _2);
    var part = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(new $c_Lcats_syntax_Tuple2SemigroupalOps(t2).mapN__F2__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction2(((blocks, options) => {
      var blocks$1 = $as_sci_Seq(blocks);
      var options$1 = $as_Llaika_ast_Options(options);
      return $p_Llaika_internal_directive_StandardDirectives$__asBlock__sci_Seq__Llaika_ast_Options__Llaika_ast_Block(this, blocks$1, options$1);
    })), $n($m_Llaika_api_bundle_BlockDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances, $as_Lcats_Semigroupal($n($m_Llaika_api_bundle_BlockDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances)));
    this.Llaika_internal_directive_StandardDirectives$__f_blockStyle$lzy1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$Directive(this$7, "style", part);
    this.Llaika_internal_directive_StandardDirectives$__f_blockStylebitmap$1 = true;
  }
  return this.Llaika_internal_directive_StandardDirectives$__f_blockStyle$lzy1;
});
$c_Llaika_internal_directive_StandardDirectives$.prototype.spanStyle__Llaika_api_bundle_DirectiveBuilderContext$Directive = (function() {
  if ((!this.Llaika_internal_directive_StandardDirectives$__f_spanStylebitmap$1)) {
    var this$7 = $m_Llaika_api_bundle_SpanDirectives$();
    var this$1 = $n($m_Llaika_api_bundle_SpanDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _1 = $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__parsedBody__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$1);
    var this$2 = $n($m_Llaika_api_bundle_SpanDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var this$4 = $n(new $c_Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes(this$2, $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_configValue).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$PositionalAttributes($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string));
    var f = new $c_sjsr_AnonFunction1(((_$7) => {
      var _$7$1 = $as_sci_Seq(_$7);
      return $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options(_$7$1);
    }));
    var _2 = new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$2(f, this$4);
    var t2 = new $c_T2(_1, _2);
    var part = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(new $c_Lcats_syntax_Tuple2SemigroupalOps(t2).mapN__F2__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction2(((spans, options) => {
      var spans$1 = $as_sci_Seq(spans);
      var options$1 = $as_Llaika_ast_Options(options);
      return $p_Llaika_internal_directive_StandardDirectives$__asSpan__sci_Seq__Llaika_ast_Options__Llaika_ast_Span(this, spans$1, options$1);
    })), $n($m_Llaika_api_bundle_SpanDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances, $as_Lcats_Semigroupal($n($m_Llaika_api_bundle_SpanDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances)));
    this.Llaika_internal_directive_StandardDirectives$__f_spanStyle$lzy1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$Directive(this$7, "style", part);
    this.Llaika_internal_directive_StandardDirectives$__f_spanStylebitmap$1 = true;
  }
  return this.Llaika_internal_directive_StandardDirectives$__f_spanStyle$lzy1;
});
$c_Llaika_internal_directive_StandardDirectives$.prototype.iconSpan__Llaika_api_bundle_DirectiveBuilderContext$Directive = (function() {
  if ((!this.Llaika_internal_directive_StandardDirectives$__f_iconSpanbitmap$1)) {
    var this$7 = $m_Llaika_api_bundle_SpanDirectives$();
    var this$1 = $n($m_Llaika_api_bundle_SpanDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _1 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$1, 0)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string);
    var this$2 = $n($m_Llaika_api_bundle_SpanDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _2 = $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__source__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$2);
    var t2 = new $c_T2(_1, _2);
    var part = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(new $c_Lcats_syntax_Tuple2SemigroupalOps(t2).mapN__F2__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction2(((ref, src) => {
      var ref$1 = $as_T(ref);
      var src$1 = $as_Llaika_parse_SourceFragment(src);
      var options = $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([ref$1])));
      return new $c_Llaika_ast_IconReference(ref$1, src$1, options);
    })), $n($m_Llaika_api_bundle_SpanDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances, $as_Lcats_Semigroupal($n($m_Llaika_api_bundle_SpanDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances)));
    this.Llaika_internal_directive_StandardDirectives$__f_iconSpan$lzy1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$Directive(this$7, "icon", part);
    this.Llaika_internal_directive_StandardDirectives$__f_iconSpanbitmap$1 = true;
  }
  return this.Llaika_internal_directive_StandardDirectives$__f_iconSpan$lzy1;
});
$c_Llaika_internal_directive_StandardDirectives$.prototype.iconTemplate__Llaika_api_bundle_DirectiveBuilderContext$Directive = (function() {
  if ((!this.Llaika_internal_directive_StandardDirectives$__f_iconTemplatebitmap$1)) {
    var this$9 = $m_Llaika_api_bundle_TemplateDirectives$();
    var this$1 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _1 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$1, 0)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string);
    var this$2 = $n($m_Llaika_api_bundle_TemplateDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _2 = $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__source__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$2);
    var t2 = new $c_T2(_1, _2);
    var part = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(new $c_Lcats_syntax_Tuple2SemigroupalOps(t2).mapN__F2__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction2(((ref, src) => {
      var ref$1 = $as_T(ref);
      var src$1 = $as_Llaika_parse_SourceFragment(src);
      var options = $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([ref$1])));
      var element = new $c_Llaika_ast_IconReference(ref$1, src$1, options);
      var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      return new $c_Llaika_ast_TemplateElement(element, 0, options$1);
    })), $n($m_Llaika_api_bundle_TemplateDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances, $as_Lcats_Semigroupal($n($m_Llaika_api_bundle_TemplateDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances)));
    this.Llaika_internal_directive_StandardDirectives$__f_iconTemplate$lzy1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$Directive(this$9, "icon", part);
    this.Llaika_internal_directive_StandardDirectives$__f_iconTemplatebitmap$1 = true;
  }
  return this.Llaika_internal_directive_StandardDirectives$__f_iconTemplate$lzy1;
});
$c_Llaika_internal_directive_StandardDirectives$.prototype.blockFragment__Llaika_api_bundle_DirectiveBuilderContext$Directive = (function() {
  if ((!this.Llaika_internal_directive_StandardDirectives$__f_blockFragmentbitmap$1)) {
    var this$8 = $m_Llaika_api_bundle_BlockDirectives$();
    var this$1 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _1 = $n($f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__attribute__I__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart(this$1, 0)).as__Llaika_api_config_ConfigDecoder__Llaika_api_bundle_DirectiveBuilderContext$Combinators$AttributePart($m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_string);
    var this$2 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var _2 = $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__parsedBody__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$2);
    var t2 = new $c_T2(_1, _2);
    var part = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(new $c_Lcats_syntax_Tuple2SemigroupalOps(t2).mapN__F2__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction2(((name, content) => {
      var name$1 = $as_T(name);
      var content$1 = $as_sci_Seq(content);
      var root = $as_Llaika_ast_Element($p_Llaika_internal_directive_StandardDirectives$__asBlock__sci_Seq__Llaika_ast_Options__Llaika_ast_Block(this, content$1, $m_Llaika_ast_Styles$().apply__sci_Seq__Llaika_ast_Options($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([name$1])))));
      var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      return new $c_Llaika_ast_DocumentFragment(name$1, root, options);
    })), $n($m_Llaika_api_bundle_BlockDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances, $as_Lcats_Semigroupal($n($m_Llaika_api_bundle_BlockDirectives$().DirectivePart__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$()).Llaika_api_bundle_DirectiveBuilderContext$DirectivePart$__f_directivePartInstances)));
    this.Llaika_internal_directive_StandardDirectives$__f_blockFragment$lzy1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$Directive(this$8, "fragment", part);
    this.Llaika_internal_directive_StandardDirectives$__f_blockFragmentbitmap$1 = true;
  }
  return this.Llaika_internal_directive_StandardDirectives$__f_blockFragment$lzy1;
});
$c_Llaika_internal_directive_StandardDirectives$.prototype.pageBreak__Llaika_api_bundle_DirectiveBuilderContext$Directive = (function() {
  if ((!this.Llaika_internal_directive_StandardDirectives$__f_pageBreakbitmap$1)) {
    var this$4 = $m_Llaika_api_bundle_BlockDirectives$();
    var this$3 = $n($m_Llaika_api_bundle_BlockDirectives$().dsl__Llaika_api_bundle_DirectiveBuilderContext$dsl$());
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var result = new $c_Llaika_ast_PageBreak(options);
    var part = $f_Llaika_api_bundle_DirectiveBuilderContext$Combinators__empty__O__Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(this$3, result);
    this.Llaika_internal_directive_StandardDirectives$__f_pageBreak$lzy1 = new $c_Llaika_api_bundle_DirectiveBuilderContext$Directive(this$4, "pageBreak", part);
    this.Llaika_internal_directive_StandardDirectives$__f_pageBreakbitmap$1 = true;
  }
  return this.Llaika_internal_directive_StandardDirectives$__f_pageBreak$lzy1;
});
$c_Llaika_internal_directive_StandardDirectives$.prototype.blockDirectives__sci_Seq = (function() {
  if ((!this.Llaika_internal_directive_StandardDirectives$__f_blockDirectivesbitmap$1)) {
    var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_bundle_DirectiveBuilderContext$Directive.getArrayOf().constr)([$m_Llaika_internal_directive_BreadcrumbDirectives$().forBlocks__Llaika_api_bundle_DirectiveBuilderContext$Directive(), $m_Llaika_internal_directive_NavigationTreeDirectives$().forBlocks__Llaika_api_bundle_DirectiveBuilderContext$Directive(), this.blockFragment__Llaika_api_bundle_DirectiveBuilderContext$Directive(), this.blockStyle__Llaika_api_bundle_DirectiveBuilderContext$Directive(), $m_Llaika_internal_directive_IncludeDirectives$().blockInclude__Llaika_api_bundle_DirectiveBuilderContext$Directive(), $m_Llaika_internal_directive_IncludeDirectives$().blockEmbed__Llaika_api_bundle_DirectiveBuilderContext$Directive(), $m_Llaika_internal_directive_ImageDirectives$().Llaika_internal_directive_ImageDirectives$__f_forBlocks, $m_Llaika_internal_directive_SelectDirective$().Llaika_internal_directive_SelectDirective$__f_forBlocks, this.callout__Llaika_api_bundle_DirectiveBuilderContext$Directive(), this.format__Llaika_api_bundle_DirectiveBuilderContext$Directive(), this.pageBreak__Llaika_api_bundle_DirectiveBuilderContext$Directive(), this.Llaika_internal_directive_StandardDirectives$__f_todoBlock]));
    this.Llaika_internal_directive_StandardDirectives$__f_blockDirectives$lzy1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
    this.Llaika_internal_directive_StandardDirectives$__f_blockDirectivesbitmap$1 = true;
  }
  return this.Llaika_internal_directive_StandardDirectives$__f_blockDirectives$lzy1;
});
$c_Llaika_internal_directive_StandardDirectives$.prototype.spanDirectives__sci_Seq = (function() {
  if ((!this.Llaika_internal_directive_StandardDirectives$__f_spanDirectivesbitmap$1)) {
    var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_bundle_DirectiveBuilderContext$Directive.getArrayOf().constr)([$m_Llaika_internal_directive_ImageDirectives$().Llaika_internal_directive_ImageDirectives$__f_forSpans, this.spanStyle__Llaika_api_bundle_DirectiveBuilderContext$Directive(), this.iconSpan__Llaika_api_bundle_DirectiveBuilderContext$Directive(), this.Llaika_internal_directive_StandardDirectives$__f_todoSpan]));
    this.Llaika_internal_directive_StandardDirectives$__f_spanDirectives$lzy1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
    this.Llaika_internal_directive_StandardDirectives$__f_spanDirectivesbitmap$1 = true;
  }
  return this.Llaika_internal_directive_StandardDirectives$__f_spanDirectives$lzy1;
});
$c_Llaika_internal_directive_StandardDirectives$.prototype.templateDirectives__sci_Seq = (function() {
  if ((!this.Llaika_internal_directive_StandardDirectives$__f_templateDirectivesbitmap$1)) {
    var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_bundle_DirectiveBuilderContext$Directive.getArrayOf().constr)([$m_Llaika_internal_directive_BreadcrumbDirectives$().forTemplates__Llaika_api_bundle_DirectiveBuilderContext$Directive(), $m_Llaika_internal_directive_NavigationTreeDirectives$().forTemplates__Llaika_api_bundle_DirectiveBuilderContext$Directive(), $m_Llaika_internal_directive_ControlFlowDirectives$().templateFor__Llaika_api_bundle_DirectiveBuilderContext$Directive(), $m_Llaika_internal_directive_ControlFlowDirectives$().templateIf__Llaika_api_bundle_DirectiveBuilderContext$Directive(), $m_Llaika_internal_directive_IncludeDirectives$().templateInclude__Llaika_api_bundle_DirectiveBuilderContext$Directive(), $m_Llaika_internal_directive_IncludeDirectives$().templateEmbed__Llaika_api_bundle_DirectiveBuilderContext$Directive(), this.iconTemplate__Llaika_api_bundle_DirectiveBuilderContext$Directive(), this.target__Llaika_api_bundle_DirectiveBuilderContext$Directive(), this.date__Llaika_api_bundle_DirectiveBuilderContext$Directive(), this.attr__Llaika_api_bundle_DirectiveBuilderContext$Directive()]));
    this.Llaika_internal_directive_StandardDirectives$__f_templateDirectives$lzy1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
    this.Llaika_internal_directive_StandardDirectives$__f_templateDirectivesbitmap$1 = true;
  }
  return this.Llaika_internal_directive_StandardDirectives$__f_templateDirectives$lzy1;
});
$c_Llaika_internal_directive_StandardDirectives$.prototype.linkDirectives__sci_Seq = (function() {
  if ((!this.Llaika_internal_directive_StandardDirectives$__f_linkDirectivesbitmap$1)) {
    this.Llaika_internal_directive_StandardDirectives$__f_linkDirectives$lzy1 = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_api_bundle_LinkDirectives$Directive.getArrayOf().constr)([$m_Llaika_internal_directive_StandardLinkDirectives$().api__Llaika_api_bundle_LinkDirectives$Directive(), $m_Llaika_internal_directive_StandardLinkDirectives$().source__Llaika_api_bundle_LinkDirectives$Directive()]))));
    this.Llaika_internal_directive_StandardDirectives$__f_linkDirectivesbitmap$1 = true;
  }
  return this.Llaika_internal_directive_StandardDirectives$__f_linkDirectives$lzy1;
});
var $d_Llaika_internal_directive_StandardDirectives$ = new $TypeData().initClass($c_Llaika_internal_directive_StandardDirectives$, "laika.internal.directive.StandardDirectives$", ({
  Llaika_internal_directive_StandardDirectives$: 1,
  Llaika_api_bundle_ExtensionBundle: 1,
  Llaika_api_bundle_DirectiveRegistry: 1
}));
var $n_Llaika_internal_directive_StandardDirectives$;
function $m_Llaika_internal_directive_StandardDirectives$() {
  if ((!$n_Llaika_internal_directive_StandardDirectives$)) {
    $n_Llaika_internal_directive_StandardDirectives$ = new $c_Llaika_internal_directive_StandardDirectives$();
  }
  return $n_Llaika_internal_directive_StandardDirectives$;
}
/** @constructor */
function $c_Llaika_internal_link_LinkAliasResolver$() {
}
$c_Llaika_internal_link_LinkAliasResolver$.prototype = new $h_O();
$c_Llaika_internal_link_LinkAliasResolver$.prototype.constructor = $c_Llaika_internal_link_LinkAliasResolver$;
/** @constructor */
function $h_Llaika_internal_link_LinkAliasResolver$() {
}
$h_Llaika_internal_link_LinkAliasResolver$.prototype = $c_Llaika_internal_link_LinkAliasResolver$.prototype;
$c_Llaika_internal_link_LinkAliasResolver$.prototype.unresolved__Llaika_internal_link_TargetIdSelector__Llaika_internal_link_TargetIdSelector__Llaika_config_TargetFormats__Llaika_internal_link_LinkAliasResolver = (function(sourceSelector, targetSelector, targetFormats) {
  var this$1 = $m_Llaika_internal_link_TargetResolver$();
  var msg = ("unresolved link alias: " + $n(targetSelector).Llaika_internal_link_TargetIdSelector__f_id);
  var \u03b42$ = new $c_Llaika_internal_link_TargetResolver$$anon$4(sourceSelector, msg, this$1);
  var referenceResolver = new $c_sjsr_AnonFunction1(((linkSource) => {
    var linkSource$1 = $as_Llaika_internal_link_LinkSource(linkSource);
    return $as_s_Option($n(\u03b42$.Llaika_internal_link_TargetResolver$$anon$4__f_resolver).apply__O__O(linkSource$1));
  }));
  return new $c_Llaika_internal_link_LinkAliasResolver(sourceSelector, targetSelector, referenceResolver, targetFormats);
});
var $d_Llaika_internal_link_LinkAliasResolver$ = new $TypeData().initClass($c_Llaika_internal_link_LinkAliasResolver$, "laika.internal.link.LinkAliasResolver$", ({
  Llaika_internal_link_LinkAliasResolver$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_internal_link_LinkAliasResolver$;
function $m_Llaika_internal_link_LinkAliasResolver$() {
  if ((!$n_Llaika_internal_link_LinkAliasResolver$)) {
    $n_Llaika_internal_link_LinkAliasResolver$ = new $c_Llaika_internal_link_LinkAliasResolver$();
  }
  return $n_Llaika_internal_link_LinkAliasResolver$;
}
/** @constructor */
function $c_Llaika_internal_markdown_github_Tables$Header$3$() {
}
$c_Llaika_internal_markdown_github_Tables$Header$3$.prototype = new $h_O();
$c_Llaika_internal_markdown_github_Tables$Header$3$.prototype.constructor = $c_Llaika_internal_markdown_github_Tables$Header$3$;
/** @constructor */
function $h_Llaika_internal_markdown_github_Tables$Header$3$() {
}
$h_Llaika_internal_markdown_github_Tables$Header$3$.prototype = $c_Llaika_internal_markdown_github_Tables$Header$3$.prototype;
$c_Llaika_internal_markdown_github_Tables$Header$3$.prototype.toString__T = (function() {
  return "Header";
});
function $as_Llaika_internal_markdown_github_Tables$Header$3$(obj) {
  return (((obj instanceof $c_Llaika_internal_markdown_github_Tables$Header$3$) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.markdown.github.Tables$Header$3$"));
}
function $isArrayOf_Llaika_internal_markdown_github_Tables$Header$3$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_markdown_github_Tables$Header$3$)));
}
function $asArrayOf_Llaika_internal_markdown_github_Tables$Header$3$(obj, depth) {
  return (($isArrayOf_Llaika_internal_markdown_github_Tables$Header$3$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.markdown.github.Tables$Header$3$;", depth));
}
var $d_Llaika_internal_markdown_github_Tables$Header$3$ = new $TypeData().initClass($c_Llaika_internal_markdown_github_Tables$Header$3$, "laika.internal.markdown.github.Tables$Header$3$", ({
  Llaika_internal_markdown_github_Tables$Header$3$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_hocon_BuilderField$() {
}
$c_Llaika_internal_parse_hocon_BuilderField$.prototype = new $h_O();
$c_Llaika_internal_parse_hocon_BuilderField$.prototype.constructor = $c_Llaika_internal_parse_hocon_BuilderField$;
/** @constructor */
function $h_Llaika_internal_parse_hocon_BuilderField$() {
}
$h_Llaika_internal_parse_hocon_BuilderField$.prototype = $c_Llaika_internal_parse_hocon_BuilderField$.prototype;
$c_Llaika_internal_parse_hocon_BuilderField$.prototype.apply__T__Llaika_internal_parse_hocon_ConfigBuilderValue__Llaika_internal_parse_hocon_BuilderField = (function(key, value) {
  var value$1 = $m_Llaika_api_config_Key$().apply__T__sci_Seq__Llaika_api_config_Key(key, $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([])));
  var key$1 = new $c_s_util_Right(value$1);
  return new $c_Llaika_internal_parse_hocon_BuilderField(key$1, value);
});
$c_Llaika_internal_parse_hocon_BuilderField$.prototype.apply__Llaika_api_config_Key__Llaika_internal_parse_hocon_ConfigBuilderValue__Llaika_internal_parse_hocon_BuilderField = (function(key, value) {
  var key$1 = new $c_s_util_Right(key);
  return new $c_Llaika_internal_parse_hocon_BuilderField(key$1, value);
});
var $d_Llaika_internal_parse_hocon_BuilderField$ = new $TypeData().initClass($c_Llaika_internal_parse_hocon_BuilderField$, "laika.internal.parse.hocon.BuilderField$", ({
  Llaika_internal_parse_hocon_BuilderField$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_internal_parse_hocon_BuilderField$;
function $m_Llaika_internal_parse_hocon_BuilderField$() {
  if ((!$n_Llaika_internal_parse_hocon_BuilderField$)) {
    $n_Llaika_internal_parse_hocon_BuilderField$ = new $c_Llaika_internal_parse_hocon_BuilderField$();
  }
  return $n_Llaika_internal_parse_hocon_BuilderField$;
}
/** @constructor */
function $c_Llaika_internal_parse_hocon_HoconParsers$PathFragments$() {
}
$c_Llaika_internal_parse_hocon_HoconParsers$PathFragments$.prototype = new $h_O();
$c_Llaika_internal_parse_hocon_HoconParsers$PathFragments$.prototype.constructor = $c_Llaika_internal_parse_hocon_HoconParsers$PathFragments$;
/** @constructor */
function $h_Llaika_internal_parse_hocon_HoconParsers$PathFragments$() {
}
$h_Llaika_internal_parse_hocon_HoconParsers$PathFragments$.prototype = $c_Llaika_internal_parse_hocon_HoconParsers$PathFragments$.prototype;
$c_Llaika_internal_parse_hocon_HoconParsers$PathFragments$.prototype.unquoted__Llaika_internal_parse_hocon_StringBuilderValue__Llaika_internal_parse_hocon_HoconParsers$PathFragments = (function(key) {
  if ((key instanceof $c_Llaika_internal_parse_hocon_ValidStringValue)) {
    var x$1 = $as_Llaika_internal_parse_hocon_ValidStringValue(key);
    var this$2 = $n(x$1);
    var x33 = this$2.Llaika_internal_parse_hocon_ValidStringValue__f_value;
    var xs = $f_T__split__T__I__AT($n(x33), "\\.", (-1));
    var fragments = $as_sci_Seq($n($m_sc_ArrayOps$().toIndexedSeq$extension__O__sci_IndexedSeq(xs)).map__F1__O(new $c_sjsr_AnonFunction1(((value$2) => {
      var value = $as_T(value$2);
      return new $c_Llaika_internal_parse_hocon_ValidStringValue(value);
    }))));
  } else {
    var fragments = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_internal_parse_hocon_StringBuilderValue.getArrayOf().constr)([key]))));
  }
  return new $c_Llaika_internal_parse_hocon_HoconParsers$PathFragments(fragments);
});
$c_Llaika_internal_parse_hocon_HoconParsers$PathFragments$.prototype.quoted__Llaika_internal_parse_hocon_StringBuilderValue__Llaika_internal_parse_hocon_HoconParsers$PathFragments = (function(key) {
  var fragments = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_internal_parse_hocon_StringBuilderValue.getArrayOf().constr)([key]))));
  return new $c_Llaika_internal_parse_hocon_HoconParsers$PathFragments(fragments);
});
$c_Llaika_internal_parse_hocon_HoconParsers$PathFragments$.prototype.whitespace__T__Llaika_internal_parse_hocon_HoconParsers$PathFragments = (function(ws) {
  var fragments = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_internal_parse_hocon_ValidStringValue.getArrayOf().constr)([new $c_Llaika_internal_parse_hocon_ValidStringValue(ws)]))));
  return new $c_Llaika_internal_parse_hocon_HoconParsers$PathFragments(fragments);
});
var $d_Llaika_internal_parse_hocon_HoconParsers$PathFragments$ = new $TypeData().initClass($c_Llaika_internal_parse_hocon_HoconParsers$PathFragments$, "laika.internal.parse.hocon.HoconParsers$PathFragments$", ({
  Llaika_internal_parse_hocon_HoconParsers$PathFragments$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_internal_parse_hocon_HoconParsers$PathFragments$;
function $m_Llaika_internal_parse_hocon_HoconParsers$PathFragments$() {
  if ((!$n_Llaika_internal_parse_hocon_HoconParsers$PathFragments$)) {
    $n_Llaika_internal_parse_hocon_HoconParsers$PathFragments$ = new $c_Llaika_internal_parse_hocon_HoconParsers$PathFragments$();
  }
  return $n_Llaika_internal_parse_hocon_HoconParsers$PathFragments$;
}
function $p_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser__spanParser0__Llaika_parse_markup_InlineParser($thiz) {
  if ((!$thiz.Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser__f_spanParser0bitmap$1)) {
    $thiz.Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser__f_spanParser0$lzy1 = $as_Llaika_parse_markup_InlineParser($n($thiz.Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser__f_delegate).apply__O());
    $thiz.Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser__f_spanParser0bitmap$1 = true;
  }
  return $thiz.Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser__f_spanParser0$lzy1;
}
/** @constructor */
function $c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser(outer, textParser, delegate) {
  this.Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser__f_textParser = null;
  this.Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser__f_delegate = null;
  this.Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser__f_spanParser0$lzy1 = null;
  this.Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser__f_spanParser0bitmap$1 = false;
  this.Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser__f_$outer = null;
  this.Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser__f_textParser = textParser;
  this.Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser__f_delegate = delegate;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser__f_$outer = outer;
}
$c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser.prototype = new $h_Llaika_parse_Parser();
$c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser.prototype.constructor = $c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser;
/** @constructor */
function $h_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser() {
}
$h_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser.prototype = $c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser.prototype;
$c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser.prototype.embed__F0__Llaika_parse_markup_InlineParser = (function(parser) {
  return new $c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser(this.Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser__f_$outer, this.Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser__f_textParser, new $c_sjsr_AnonFunction0((() => $n($as_Llaika_parse_markup_InlineParser($n(this.Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser__f_delegate).apply__O())).embed__F0__Llaika_parse_markup_InlineParser(parser))));
});
$c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser.prototype.embedAll__F0__Llaika_parse_markup_InlineParser = (function(parsers) {
  return new $c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser(this.Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser__f_$outer, this.Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser__f_textParser, new $c_sjsr_AnonFunction0((() => $n($as_Llaika_parse_markup_InlineParser($n(this.Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser__f_delegate).apply__O())).embedAll__F0__Llaika_parse_markup_InlineParser(parsers))));
});
$c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser.prototype.parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed = (function(source) {
  matchResult2: {
    var $x_1;
    var x7 = $n(this.Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser__f_textParser).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(source);
    if ((x7 instanceof $c_Llaika_parse_Success)) {
      var x$1 = $as_Llaika_parse_Success(x7);
      var this$2 = $n(x$1);
      var x11 = $as_Llaika_parse_SourceFragment(this$2.Llaika_parse_Success__f_result);
      var this$3 = $n(x$1);
      var x12 = this$3.Llaika_parse_Success__f_next;
      var x1 = $n($as_Llaika_parse_Parser($p_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser__spanParser0__Llaika_parse_markup_InlineParser(this))).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(x11);
      if ((x1 instanceof $c_Llaika_parse_Success)) {
        var x$1$1 = $as_Llaika_parse_Success(x1);
        var this$5 = $n(x$1$1);
        var x5 = $as_sci_List(this$5.Llaika_parse_Success__f_result);
        var this$6 = $n(x$1$1);
        var $x_1 = new $c_Llaika_parse_Success(x5, x12);
        break matchResult2;
      }
      if ((x1 instanceof $c_Llaika_parse_Failure)) {
        var f = $as_Llaika_parse_Failure(x1);
        var $x_1 = f;
        break matchResult2;
      }
      throw new $c_s_MatchError(x1);
    }
    if ((x7 instanceof $c_Llaika_parse_Failure)) {
      var f$2 = $as_Llaika_parse_Failure(x7);
      var $x_1 = f$2;
      break matchResult2;
    }
    throw new $c_s_MatchError(x7);
  }
  return $as_Llaika_parse_Parsed($x_1);
});
var $d_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser = new $TypeData().initClass($c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser, "laika.internal.parse.markup.DefaultRecursiveSpanParsers$TwoPhaseInlineParser", ({
  Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser: 1,
  Llaika_parse_Parser: 1,
  Llaika_parse_markup_InlineParser: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_markup_DocumentParser$DocumentInput$() {
}
$c_Llaika_internal_parse_markup_DocumentParser$DocumentInput$.prototype = new $h_O();
$c_Llaika_internal_parse_markup_DocumentParser$DocumentInput$.prototype.constructor = $c_Llaika_internal_parse_markup_DocumentParser$DocumentInput$;
/** @constructor */
function $h_Llaika_internal_parse_markup_DocumentParser$DocumentInput$() {
}
$h_Llaika_internal_parse_markup_DocumentParser$DocumentInput$.prototype = $c_Llaika_internal_parse_markup_DocumentParser$DocumentInput$.prototype;
$c_Llaika_internal_parse_markup_DocumentParser$DocumentInput$.prototype.apply__Llaika_ast_Path__T__Llaika_internal_parse_markup_DocumentParser$DocumentInput = (function(path, input) {
  return new $c_Llaika_internal_parse_markup_DocumentParser$DocumentInput(path, $m_Llaika_parse_SourceCursor$().apply__T__Llaika_ast_Path__Llaika_parse_SourceCursor(input, path));
});
var $d_Llaika_internal_parse_markup_DocumentParser$DocumentInput$ = new $TypeData().initClass($c_Llaika_internal_parse_markup_DocumentParser$DocumentInput$, "laika.internal.parse.markup.DocumentParser$DocumentInput$", ({
  Llaika_internal_parse_markup_DocumentParser$DocumentInput$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_internal_parse_markup_DocumentParser$DocumentInput$;
function $m_Llaika_internal_parse_markup_DocumentParser$DocumentInput$() {
  if ((!$n_Llaika_internal_parse_markup_DocumentParser$DocumentInput$)) {
    $n_Llaika_internal_parse_markup_DocumentParser$DocumentInput$ = new $c_Llaika_internal_parse_markup_DocumentParser$DocumentInput$();
  }
  return $n_Llaika_internal_parse_markup_DocumentParser$DocumentInput$;
}
/** @constructor */
function $c_Llaika_internal_render_HTMLFormatter(closeEmptyTags, context) {
  this.Llaika_api_format_Formatter__f_nextLevel$lzy1 = null;
  this.Llaika_api_format_Formatter__f_nextLevelbitmap$1 = false;
  this.Llaika_api_format_Formatter__f_newLine = null;
  this.Llaika_internal_render_HTMLFormatter__f_closeEmptyTags = false;
  this.Llaika_internal_render_HTMLFormatter__f_context = null;
  this.Llaika_internal_render_HTMLFormatter__f_emptyTagClosingChar = null;
  this.Llaika_internal_render_HTMLFormatter__f_closeEmptyTags = closeEmptyTags;
  this.Llaika_internal_render_HTMLFormatter__f_context = context;
  $ct_Llaika_api_format_Formatter__(this);
  this.Llaika_internal_render_HTMLFormatter__f_emptyTagClosingChar = (closeEmptyTags ? "/" : "");
}
$c_Llaika_internal_render_HTMLFormatter.prototype = new $h_Llaika_api_format_TagFormatter();
$c_Llaika_internal_render_HTMLFormatter.prototype.constructor = $c_Llaika_internal_render_HTMLFormatter;
/** @constructor */
function $h_Llaika_internal_render_HTMLFormatter() {
}
$h_Llaika_internal_render_HTMLFormatter.prototype = $c_Llaika_internal_render_HTMLFormatter.prototype;
$c_Llaika_internal_render_HTMLFormatter.prototype.context__Llaika_api_format_Formatter$Context = (function() {
  return this.Llaika_internal_render_HTMLFormatter__f_context;
});
$c_Llaika_internal_render_HTMLFormatter.prototype.withChild__Llaika_ast_Element__Llaika_api_format_TagFormatter = (function(element) {
  return new $c_Llaika_internal_render_HTMLFormatter(this.Llaika_internal_render_HTMLFormatter__f_closeEmptyTags, $n(this.Llaika_internal_render_HTMLFormatter__f_context).forChildElement__Llaika_ast_Element__Llaika_api_format_Formatter$Context(element));
});
$c_Llaika_internal_render_HTMLFormatter.prototype.withIndentation__Llaika_api_format_Formatter$Indentation__Llaika_api_format_TagFormatter = (function(newIndentation) {
  var $x_1 = this.Llaika_internal_render_HTMLFormatter__f_closeEmptyTags;
  var this$1 = $n(this.Llaika_internal_render_HTMLFormatter__f_context);
  return new $c_Llaika_internal_render_HTMLFormatter($x_1, new $c_Llaika_api_format_Formatter$Context(this$1.Llaika_api_format_Formatter$Context__f_renderChild, this$1.Llaika_api_format_Formatter$Context__f_currentElement, this$1.Llaika_api_format_Formatter$Context__f_parents, this$1.Llaika_api_format_Formatter$Context__f_styles, this$1.Llaika_api_format_Formatter$Context__f_path, this$1.Llaika_api_format_Formatter$Context__f_pathTranslator, newIndentation, this$1.Llaika_api_format_Formatter$Context__f_messageFilter));
});
$c_Llaika_internal_render_HTMLFormatter.prototype.attributes__T__Llaika_ast_Element__sci_Seq__T = (function(tag, styleHint, attrs) {
  var $x_2 = $m_s_Option$();
  var this$1 = $n($n($n(styleHint).options__Llaika_ast_Options()).Llaika_ast_Options$Impl__f_id);
  if (this$1.isEmpty__Z()) {
    var $x_1 = $m_s_None$();
  } else {
    var arg1 = this$1.get__O();
    var _$1 = $as_T(arg1);
    var $x_1 = new $c_s_Some(new $c_T2("id", _$1));
  }
  var id = $n($n($x_2).option2Iterable__s_Option__sc_Iterable($x_1)).toSeq__sci_Seq();
  if ($n($n($n(styleHint).options__Llaika_ast_Options()).Llaika_ast_Options$Impl__f_styles).isEmpty__Z()) {
    var styles = $m_sci_Nil$();
  } else {
    var $x_4 = $m_sci_Seq$();
    var $x_3 = $m_sr_ScalaRunTime$();
    var this$5 = $n($n($n(styleHint).options__Llaika_ast_Options()).Llaika_ast_Options$Impl__f_styles);
    var y = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$5, "", " ", "");
    var styles = $as_sci_Seq($n($x_4).apply__sci_Seq__sc_SeqOps($n($x_3).wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([new $c_T2("class", y)]))));
  }
  var this$7 = $n(id);
  var this$8 = $n($as_sc_IterableOps(this$7.appendedAll__sc_IterableOnce__O(styles)));
  return this.attributes__sci_Seq__T($as_sci_Seq(this$8.concat__sc_IterableOnce__O(attrs)));
});
$c_Llaika_internal_render_HTMLFormatter.prototype.emptyElement__T__Llaika_ast_Element__sci_Seq__T = (function(tagName, styleHint, attrs) {
  return (((("<" + tagName) + this.attributes__T__Llaika_ast_Element__sci_Seq__T(tagName, styleHint, attrs)) + this.Llaika_internal_render_HTMLFormatter__f_emptyTagClosingChar) + ">");
});
$c_Llaika_internal_render_HTMLFormatter.prototype.withChild__Llaika_ast_Element__Llaika_api_format_Formatter = (function(element) {
  return this.withChild__Llaika_ast_Element__Llaika_api_format_TagFormatter(element);
});
$c_Llaika_internal_render_HTMLFormatter.prototype.withIndentation__Llaika_api_format_Formatter$Indentation__Llaika_api_format_Formatter = (function(newIndentation) {
  return this.withIndentation__Llaika_api_format_Formatter$Indentation__Llaika_api_format_TagFormatter(newIndentation);
});
var $d_Llaika_internal_render_HTMLFormatter = new $TypeData().initClass($c_Llaika_internal_render_HTMLFormatter, "laika.internal.render.HTMLFormatter", ({
  Llaika_internal_render_HTMLFormatter: 1,
  Llaika_api_format_TagFormatter: 1,
  Llaika_api_format_Formatter: 1
}));
/** @constructor */
function $c_Llaika_internal_render_HTMLRenderer$() {
  this.Llaika_internal_render_HTMLRenderer__f_format = null;
  this.Llaika_internal_render_HTMLRenderer__f_ElementSequence$lzy1 = null;
  $ct_Llaika_internal_render_HTMLRenderer__T__(this, "html");
}
$c_Llaika_internal_render_HTMLRenderer$.prototype = new $h_Llaika_internal_render_HTMLRenderer();
$c_Llaika_internal_render_HTMLRenderer$.prototype.constructor = $c_Llaika_internal_render_HTMLRenderer$;
/** @constructor */
function $h_Llaika_internal_render_HTMLRenderer$() {
}
$h_Llaika_internal_render_HTMLRenderer$.prototype = $c_Llaika_internal_render_HTMLRenderer$.prototype;
var $d_Llaika_internal_render_HTMLRenderer$ = new $TypeData().initClass($c_Llaika_internal_render_HTMLRenderer$, "laika.internal.render.HTMLRenderer$", ({
  Llaika_internal_render_HTMLRenderer$: 1,
  Llaika_internal_render_HTMLRenderer: 1,
  F2: 1
}));
var $n_Llaika_internal_render_HTMLRenderer$;
function $m_Llaika_internal_render_HTMLRenderer$() {
  if ((!$n_Llaika_internal_render_HTMLRenderer$)) {
    $n_Llaika_internal_render_HTMLRenderer$ = new $c_Llaika_internal_render_HTMLRenderer$();
  }
  return $n_Llaika_internal_render_HTMLRenderer$;
}
/** @constructor */
function $c_Llaika_internal_render_HTMLRenderer$ElementSequence$(outer) {
  this.Llaika_internal_render_HTMLRenderer$ElementSequence$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_internal_render_HTMLRenderer$ElementSequence$__f_$outer = outer;
}
$c_Llaika_internal_render_HTMLRenderer$ElementSequence$.prototype = new $h_O();
$c_Llaika_internal_render_HTMLRenderer$ElementSequence$.prototype.constructor = $c_Llaika_internal_render_HTMLRenderer$ElementSequence$;
/** @constructor */
function $h_Llaika_internal_render_HTMLRenderer$ElementSequence$() {
}
$h_Llaika_internal_render_HTMLRenderer$ElementSequence$.prototype = $c_Llaika_internal_render_HTMLRenderer$ElementSequence$.prototype;
$c_Llaika_internal_render_HTMLRenderer$ElementSequence$.prototype.apply__sci_Seq__Llaika_ast_Options__Llaika_internal_render_HTMLRenderer$ElementSequence = (function(content, options) {
  return new $c_Llaika_internal_render_HTMLRenderer$ElementSequence(this.Llaika_internal_render_HTMLRenderer$ElementSequence$__f_$outer, content, options);
});
$c_Llaika_internal_render_HTMLRenderer$ElementSequence$.prototype.toString__T = (function() {
  return "ElementSequence";
});
var $d_Llaika_internal_render_HTMLRenderer$ElementSequence$ = new $TypeData().initClass($c_Llaika_internal_render_HTMLRenderer$ElementSequence$, "laika.internal.render.HTMLRenderer$ElementSequence$", ({
  Llaika_internal_render_HTMLRenderer$ElementSequence$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
function $p_Llaika_parse_BlockSource__activeLine__Llaika_parse_LineSource($thiz) {
  if ((!$thiz.Llaika_parse_BlockSource__f_activeLinebitmap$1)) {
    matchResult3: {
      var \u03b41$___1;
      var \u03b41$___2;
      $m_Lcats_data_NonEmptyChainImpl$();
      var value = $thiz.Llaika_parse_BlockSource__f_lines;
      $m_Lcats_data_NonEmptyChainImpl$();
      var x5 = $ps_Llaika_parse_BlockSource__posFromLine$1__sci_List__I__T2($n($as_Lcats_data_Chain(value)).toList__sci_List(), $thiz.Llaika_parse_BlockSource__f_offset);
      if ((x5 !== null)) {
        var lineSource = $as_Llaika_parse_LineSource($n(x5)._1__O());
        var lineOffset = $uI($n(x5)._2__O());
        var \u03b41$___1 = lineSource;
        var \u03b41$___2 = lineOffset;
        break matchResult3;
      }
      throw new $c_s_MatchError(x5);
    }
    var lineSource$2 = $as_Llaika_parse_LineSource(\u03b41$___1);
    var lineOffset$2 = $uI(\u03b41$___2);
    $thiz.Llaika_parse_BlockSource__f_activeLine$lzy1 = $n(lineSource$2).consume__I__Llaika_parse_LineSource(((lineOffset$2 - $n(lineSource$2).Llaika_parse_LineSource__f_offset) | 0));
    $thiz.Llaika_parse_BlockSource__f_activeLinebitmap$1 = true;
  }
  return $thiz.Llaika_parse_BlockSource__f_activeLine$lzy1;
}
function $ps_Llaika_parse_BlockSource__posFromLine$1__sci_List__I__T2(remainingLines, remainingOffset) {
  var remainingOffset$tailLocal1 = remainingOffset;
  var remainingLines$tailLocal1 = remainingLines;
  while (true) {
    var this$1 = $n($as_Llaika_parse_SourceCursor($n(remainingLines$tailLocal1).head__O()));
    var this$2 = $n(this$1.input__T());
    var lineLength = this$2.length;
    if ((lineLength >= remainingOffset$tailLocal1)) {
      var _1 = $n(remainingLines$tailLocal1).head__O();
      var _2 = remainingOffset$tailLocal1;
      return new $c_T2(_1, _2);
    } else if ($n($as_sci_List($n(remainingLines$tailLocal1).tail__O())).isEmpty__Z()) {
      var _1$1 = $n(remainingLines$tailLocal1).head__O();
      return new $c_T2(_1$1, lineLength);
    } else {
      var remainingLines$tailLocal1$tmp1 = $as_sci_List($n(remainingLines$tailLocal1).tail__O());
      var remainingOffset$tailLocal1$tmp1 = ((remainingOffset$tailLocal1 - ((1 + lineLength) | 0)) | 0);
      remainingLines$tailLocal1 = remainingLines$tailLocal1$tmp1;
      remainingOffset$tailLocal1 = remainingOffset$tailLocal1$tmp1;
    }
  }
}
/** @constructor */
function $c_Llaika_parse_BlockSource(inputRef, lines, offset, nestLevel) {
  this.Llaika_parse_BlockSource__f_inputRef = null;
  this.Llaika_parse_BlockSource__f_lines = null;
  this.Llaika_parse_BlockSource__f_offset = 0;
  this.Llaika_parse_BlockSource__f_nestLevel = 0;
  this.Llaika_parse_BlockSource__f_input$lzy1 = null;
  this.Llaika_parse_BlockSource__f_inputbitmap$1 = false;
  this.Llaika_parse_BlockSource__f_activeLine$lzy1 = null;
  this.Llaika_parse_BlockSource__f_activeLinebitmap$1 = false;
  this.Llaika_parse_BlockSource__f_root$lzy2 = null;
  this.Llaika_parse_BlockSource__f_rootbitmap$2 = false;
  this.Llaika_parse_BlockSource__f_position$lzy3 = null;
  this.Llaika_parse_BlockSource__f_positionbitmap$3 = false;
  this.Llaika_parse_BlockSource__f_inputRef = inputRef;
  this.Llaika_parse_BlockSource__f_lines = lines;
  this.Llaika_parse_BlockSource__f_offset = offset;
  this.Llaika_parse_BlockSource__f_nestLevel = nestLevel;
}
$c_Llaika_parse_BlockSource.prototype = new $h_O();
$c_Llaika_parse_BlockSource.prototype.constructor = $c_Llaika_parse_BlockSource;
/** @constructor */
function $h_Llaika_parse_BlockSource() {
}
$h_Llaika_parse_BlockSource.prototype = $c_Llaika_parse_BlockSource.prototype;
$c_Llaika_parse_BlockSource.prototype.path__s_Option = (function() {
  return $n(this.root__Llaika_parse_SourceCursor()).path__s_Option();
});
$c_Llaika_parse_BlockSource.prototype.offset__I = (function() {
  return this.Llaika_parse_BlockSource__f_offset;
});
$c_Llaika_parse_BlockSource.prototype.nestLevel__I = (function() {
  return this.Llaika_parse_BlockSource__f_nestLevel;
});
$c_Llaika_parse_BlockSource.prototype.input__T = (function() {
  if ((!this.Llaika_parse_BlockSource__f_inputbitmap$1)) {
    this.Llaika_parse_BlockSource__f_input$lzy1 = $n(this.Llaika_parse_BlockSource__f_inputRef).Llaika_parse_InputString__f_value;
    this.Llaika_parse_BlockSource__f_inputbitmap$1 = true;
  }
  return this.Llaika_parse_BlockSource__f_input$lzy1;
});
$c_Llaika_parse_BlockSource.prototype.atEnd__Z = (function() {
  var $x_1 = this.Llaika_parse_BlockSource__f_offset;
  var this$1 = $n(this.input__T());
  return ($x_1 >= this$1.length);
});
$c_Llaika_parse_BlockSource.prototype.remaining__I = (function() {
  var this$1 = $n(this.input__T());
  return ((this$1.length - this.Llaika_parse_BlockSource__f_offset) | 0);
});
$c_Llaika_parse_BlockSource.prototype.capture__I__T = (function(numChars) {
  var requirement = (numChars >= 0);
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: numChars cannot be negative");
  }
  var this$2 = $n(this.input__T());
  var a = this$2.length;
  var b = ((this.Llaika_parse_BlockSource__f_offset + numChars) | 0);
  var endIndex = ((a < b) ? a : b);
  var this$4 = $n(this.input__T());
  var beginIndex = this.Llaika_parse_BlockSource__f_offset;
  if ((beginIndex < 0)) {
    $charAt(this$4, beginIndex);
  }
  if ((endIndex > this$4.length)) {
    $charAt(this$4, endIndex);
  }
  if ((endIndex < beginIndex)) {
    $charAt(this$4, (-1));
  }
  return $as_T(this$4.substring(beginIndex, endIndex));
});
$c_Llaika_parse_BlockSource.prototype.consume__I__Llaika_parse_BlockSource = (function(numChars) {
  var toConsume = $f_Llaika_parse_SourceCursor__canConsume__I__I(this, numChars);
  return ((toConsume !== 0) ? new $c_Llaika_parse_BlockSource(this.Llaika_parse_BlockSource__f_inputRef, this.Llaika_parse_BlockSource__f_lines, ((this.Llaika_parse_BlockSource__f_offset + toConsume) | 0), this.Llaika_parse_BlockSource__f_nestLevel) : this);
});
$c_Llaika_parse_BlockSource.prototype.root__Llaika_parse_SourceCursor = (function() {
  if ((!this.Llaika_parse_BlockSource__f_rootbitmap$2)) {
    this.Llaika_parse_BlockSource__f_root$lzy2 = $n($p_Llaika_parse_BlockSource__activeLine__Llaika_parse_LineSource(this)).root__Llaika_parse_SourceCursor();
    this.Llaika_parse_BlockSource__f_rootbitmap$2 = true;
  }
  return this.Llaika_parse_BlockSource__f_root$lzy2;
});
$c_Llaika_parse_BlockSource.prototype.position__Llaika_parse_Position = (function() {
  if ((!this.Llaika_parse_BlockSource__f_positionbitmap$3)) {
    this.Llaika_parse_BlockSource__f_position$lzy3 = $n($p_Llaika_parse_BlockSource__activeLine__Llaika_parse_LineSource(this)).position__Llaika_parse_Position();
    this.Llaika_parse_BlockSource__f_positionbitmap$3 = true;
  }
  return this.Llaika_parse_BlockSource__f_position$lzy3;
});
$c_Llaika_parse_BlockSource.prototype.nextNestLevel__Llaika_parse_BlockSource = (function() {
  return new $c_Llaika_parse_BlockSource(this.Llaika_parse_BlockSource__f_inputRef, this.Llaika_parse_BlockSource__f_lines, this.Llaika_parse_BlockSource__f_offset, ((1 + this.Llaika_parse_BlockSource__f_nestLevel) | 0));
});
$c_Llaika_parse_BlockSource.prototype.reverse__Llaika_parse_BlockSource = (function() {
  var $x_1 = $n(this.Llaika_parse_BlockSource__f_inputRef).reverse__Llaika_parse_InputString();
  $m_Lcats_data_NonEmptyChainImpl$();
  $m_Lcats_data_NonEmptyChainImpl$();
  var value = this.Llaika_parse_BlockSource__f_lines;
  var value$1 = $m_Lcats_data_NonEmptyChainOps$().reverse$extension__O__O(value);
  return new $c_Llaika_parse_BlockSource($x_1, $m_Lcats_data_NonEmptyChainOps$().map$extension__O__F1__O(value$1, new $c_sjsr_AnonFunction1(((_$3) => {
    var _$3$1 = $as_Llaika_parse_LineSource(_$3);
    return $n(_$3$1).reverse__Llaika_parse_LineSource();
  }))), this.remaining__I(), this.Llaika_parse_BlockSource__f_nestLevel);
});
$c_Llaika_parse_BlockSource.prototype.hashCode__I = (function() {
  var _1 = this.input__T();
  $m_Lcats_data_NonEmptyChainImpl$();
  var value = this.Llaika_parse_BlockSource__f_lines;
  var _2 = $m_Lcats_data_NonEmptyChainOps$().iterator$extension__O__sc_Iterator(value);
  var _3 = this.Llaika_parse_BlockSource__f_offset;
  var _4 = this.Llaika_parse_BlockSource__f_nestLevel;
  var this$4 = $m_s_util_hashing_MurmurHash3$();
  var h = (-889275714);
  h = this$4.mix__I__I__I(h, $f_T__hashCode__I("Tuple4"));
  var i = 0;
  while ((i < 4)) {
    var $x_1 = h;
    var n = i;
    switch (n) {
      case 0: {
        var x = _1;
        break;
      }
      case 1: {
        var x = _2;
        break;
      }
      case 2: {
        var x = _3;
        break;
      }
      case 3: {
        var x = _4;
        break;
      }
      default: {
        var x;
        throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 3)"));
      }
    }
    h = this$4.mix__I__I__I($x_1, $m_sr_Statics$().anyHash__O__I(x));
    i = ((1 + i) | 0);
  }
  return this$4.finalizeHash__I__I__I(h, 4);
});
$c_Llaika_parse_BlockSource.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Llaika_parse_BlockSource)) {
    var bs = $as_Llaika_parse_BlockSource(obj);
    if (($n(bs).input__T() === this.input__T())) {
      $m_Lcats_data_NonEmptyChainImpl$();
      var value = $n(bs).Llaika_parse_BlockSource__f_lines;
      var this$3 = $n($m_Lcats_data_NonEmptyChainOps$().iterator$extension__O__sc_Iterator(value));
      $m_Lcats_data_NonEmptyChainImpl$();
      var value$1 = this.Llaika_parse_BlockSource__f_lines;
      var that = $m_Lcats_data_NonEmptyChainOps$().iterator$extension__O__sc_Iterator(value$1);
      var $x_1 = $f_sc_Iterator__sameElements__sc_IterableOnce__Z(this$3, that);
    } else {
      var $x_1 = false;
    }
    if (($x_1 && ($n(bs).Llaika_parse_BlockSource__f_offset === this.Llaika_parse_BlockSource__f_offset))) {
      return ($n(bs).Llaika_parse_BlockSource__f_nestLevel === this.Llaika_parse_BlockSource__f_nestLevel);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_parse_BlockSource.prototype.toString__T = (function() {
  var $x_1 = this.Llaika_parse_BlockSource__f_offset;
  var this$1 = $n(this.input__T());
  return (((((("BlockSource(offset " + $x_1) + " - length ") + this$1.length) + " - root offset ") + $n(this.root__Llaika_parse_SourceCursor()).offset__I()) + ")");
});
$c_Llaika_parse_BlockSource.prototype.consume__I__Llaika_parse_SourceCursor = (function(numChars) {
  return this.consume__I__Llaika_parse_BlockSource(numChars);
});
$c_Llaika_parse_BlockSource.prototype.nextNestLevel__Llaika_parse_SourceCursor = (function() {
  return this.nextNestLevel__Llaika_parse_BlockSource();
});
$c_Llaika_parse_BlockSource.prototype.reverse__Llaika_parse_SourceCursor = (function() {
  return this.reverse__Llaika_parse_BlockSource();
});
function $as_Llaika_parse_BlockSource(obj) {
  return (((obj instanceof $c_Llaika_parse_BlockSource) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.parse.BlockSource"));
}
function $isArrayOf_Llaika_parse_BlockSource(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_parse_BlockSource)));
}
function $asArrayOf_Llaika_parse_BlockSource(obj, depth) {
  return (($isArrayOf_Llaika_parse_BlockSource(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.parse.BlockSource;", depth));
}
var $d_Llaika_parse_BlockSource = new $TypeData().initClass($c_Llaika_parse_BlockSource, "laika.parse.BlockSource", ({
  Llaika_parse_BlockSource: 1,
  Llaika_parse_SourceCursor: 1,
  Llaika_parse_SourceFragment: 1
}));
/** @constructor */
function $c_Llaika_parse_LineSource(input, parentRef, offset, nestLevel) {
  this.Llaika_parse_LineSource__f_input = null;
  this.Llaika_parse_LineSource__f_parentRef = null;
  this.Llaika_parse_LineSource__f_offset = 0;
  this.Llaika_parse_LineSource__f_nestLevel = 0;
  this.Llaika_parse_LineSource__f_parent$lzy1 = null;
  this.Llaika_parse_LineSource__f_parentbitmap$1 = false;
  this.Llaika_parse_LineSource__f_root$lzy1 = null;
  this.Llaika_parse_LineSource__f_rootbitmap$1 = false;
  this.Llaika_parse_LineSource__f_position$lzy2 = null;
  this.Llaika_parse_LineSource__f_positionbitmap$2 = false;
  this.Llaika_parse_LineSource__f_input = input;
  this.Llaika_parse_LineSource__f_parentRef = parentRef;
  this.Llaika_parse_LineSource__f_offset = offset;
  this.Llaika_parse_LineSource__f_nestLevel = nestLevel;
}
$c_Llaika_parse_LineSource.prototype = new $h_O();
$c_Llaika_parse_LineSource.prototype.constructor = $c_Llaika_parse_LineSource;
/** @constructor */
function $h_Llaika_parse_LineSource() {
}
$h_Llaika_parse_LineSource.prototype = $c_Llaika_parse_LineSource.prototype;
$c_Llaika_parse_LineSource.prototype.path__s_Option = (function() {
  return $n(this.root__Llaika_parse_SourceCursor()).path__s_Option();
});
$c_Llaika_parse_LineSource.prototype.input__T = (function() {
  return this.Llaika_parse_LineSource__f_input;
});
$c_Llaika_parse_LineSource.prototype.offset__I = (function() {
  return this.Llaika_parse_LineSource__f_offset;
});
$c_Llaika_parse_LineSource.prototype.nestLevel__I = (function() {
  return this.Llaika_parse_LineSource__f_nestLevel;
});
$c_Llaika_parse_LineSource.prototype.atEnd__Z = (function() {
  var $x_1 = this.Llaika_parse_LineSource__f_offset;
  var this$1 = $n(this.Llaika_parse_LineSource__f_input);
  return ($x_1 >= this$1.length);
});
$c_Llaika_parse_LineSource.prototype.remaining__I = (function() {
  var this$1 = $n(this.Llaika_parse_LineSource__f_input);
  return ((this$1.length - this.Llaika_parse_LineSource__f_offset) | 0);
});
$c_Llaika_parse_LineSource.prototype.capture__I__T = (function(numChars) {
  var requirement = (numChars >= 0);
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: numChars cannot be negative");
  }
  var this$2 = $n(this.Llaika_parse_LineSource__f_input);
  var a = this$2.length;
  var b = ((this.Llaika_parse_LineSource__f_offset + numChars) | 0);
  var endIndex = ((a < b) ? a : b);
  var this$4 = $n(this.Llaika_parse_LineSource__f_input);
  var beginIndex = this.Llaika_parse_LineSource__f_offset;
  if ((beginIndex < 0)) {
    $charAt(this$4, beginIndex);
  }
  if ((endIndex > this$4.length)) {
    $charAt(this$4, endIndex);
  }
  if ((endIndex < beginIndex)) {
    $charAt(this$4, (-1));
  }
  return $as_T(this$4.substring(beginIndex, endIndex));
});
$c_Llaika_parse_LineSource.prototype.consume__I__Llaika_parse_LineSource = (function(numChars) {
  var toConsume = $f_Llaika_parse_SourceCursor__canConsume__I__I(this, numChars);
  return ((toConsume !== 0) ? new $c_Llaika_parse_LineSource(this.Llaika_parse_LineSource__f_input, this.Llaika_parse_LineSource__f_parentRef, ((this.Llaika_parse_LineSource__f_offset + toConsume) | 0), this.Llaika_parse_LineSource__f_nestLevel) : this);
});
$c_Llaika_parse_LineSource.prototype.parent__Llaika_parse_SourceCursor = (function() {
  if ((!this.Llaika_parse_LineSource__f_parentbitmap$1)) {
    this.Llaika_parse_LineSource__f_parent$lzy1 = $n(this.Llaika_parse_LineSource__f_parentRef).consume__I__Llaika_parse_SourceCursor(this.Llaika_parse_LineSource__f_offset);
    this.Llaika_parse_LineSource__f_parentbitmap$1 = true;
  }
  return this.Llaika_parse_LineSource__f_parent$lzy1;
});
$c_Llaika_parse_LineSource.prototype.root__Llaika_parse_SourceCursor = (function() {
  if ((!this.Llaika_parse_LineSource__f_rootbitmap$1)) {
    this.Llaika_parse_LineSource__f_root$lzy1 = $n(this.parent__Llaika_parse_SourceCursor()).root__Llaika_parse_SourceCursor();
    this.Llaika_parse_LineSource__f_rootbitmap$1 = true;
  }
  return this.Llaika_parse_LineSource__f_root$lzy1;
});
$c_Llaika_parse_LineSource.prototype.position__Llaika_parse_Position = (function() {
  if ((!this.Llaika_parse_LineSource__f_positionbitmap$2)) {
    this.Llaika_parse_LineSource__f_position$lzy2 = $n(this.root__Llaika_parse_SourceCursor()).position__Llaika_parse_Position();
    this.Llaika_parse_LineSource__f_positionbitmap$2 = true;
  }
  return this.Llaika_parse_LineSource__f_position$lzy2;
});
$c_Llaika_parse_LineSource.prototype.nextNestLevel__Llaika_parse_LineSource = (function() {
  return new $c_Llaika_parse_LineSource(this.Llaika_parse_LineSource__f_input, this.Llaika_parse_LineSource__f_parentRef, this.Llaika_parse_LineSource__f_offset, ((1 + this.Llaika_parse_LineSource__f_nestLevel) | 0));
});
$c_Llaika_parse_LineSource.prototype.reverse__Llaika_parse_LineSource = (function() {
  var $x_3 = $m_sc_StringOps$();
  var x = this.Llaika_parse_LineSource__f_input;
  var $x_2 = $n($x_3).reverse$extension__T__T(x);
  var $x_1 = this.Llaika_parse_LineSource__f_parentRef;
  var this$2 = $n(this.Llaika_parse_LineSource__f_input);
  return new $c_Llaika_parse_LineSource($x_2, $n($n($x_1).consume__I__Llaika_parse_SourceCursor(this$2.length)).reverse__Llaika_parse_SourceCursor(), this.remaining__I(), this.Llaika_parse_LineSource__f_nestLevel);
});
$c_Llaika_parse_LineSource.prototype.trim__Llaika_parse_LineSource = (function() {
  var this$1 = $n($m_s_Predef$().wrapString__T__sci_WrappedString(this.Llaika_parse_LineSource__f_input));
  var i = 0;
  var this$2 = new $c_sc_StringView(this$1.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
  var it = $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$2).drop__I__sc_Iterator(0);
  while (true) {
    if ($n(it).hasNext__Z()) {
      var arg1 = $n(it).next__O();
      var _$1 = $uC(arg1);
      var $x_1 = (_$1 === 32);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      i = ((1 + i) | 0);
    } else {
      break;
    }
  }
  var spacesRemoved = i;
  var a = this.Llaika_parse_LineSource__f_offset;
  var moveOffset = ((a < spacesRemoved) ? a : spacesRemoved);
  return new $c_Llaika_parse_LineSource($f_T__trim__T($n(this.Llaika_parse_LineSource__f_input)), $n(this.Llaika_parse_LineSource__f_parentRef).consume__I__Llaika_parse_SourceCursor(spacesRemoved), ((this.Llaika_parse_LineSource__f_offset - moveOffset) | 0), this.Llaika_parse_LineSource__f_nestLevel);
});
$c_Llaika_parse_LineSource.prototype.hashCode__I = (function() {
  var _1 = this.Llaika_parse_LineSource__f_input;
  var _2 = $n(this.root__Llaika_parse_SourceCursor()).offset__I();
  var _3 = this.Llaika_parse_LineSource__f_offset;
  var _4 = this.Llaika_parse_LineSource__f_nestLevel;
  var _5 = $n(this.root__Llaika_parse_SourceCursor()).path__s_Option();
  var this$3 = $m_s_util_hashing_MurmurHash3$();
  var h = (-889275714);
  h = this$3.mix__I__I__I(h, $f_T__hashCode__I("Tuple5"));
  var i = 0;
  while ((i < 5)) {
    var $x_1 = h;
    var n = i;
    switch (n) {
      case 0: {
        var x = _1;
        break;
      }
      case 1: {
        var x = _2;
        break;
      }
      case 2: {
        var x = _3;
        break;
      }
      case 3: {
        var x = _4;
        break;
      }
      case 4: {
        var x = _5;
        break;
      }
      default: {
        var x;
        throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 4)"));
      }
    }
    h = this$3.mix__I__I__I($x_1, $m_sr_Statics$().anyHash__O__I(x));
    i = ((1 + i) | 0);
  }
  return this$3.finalizeHash__I__I__I(h, 5);
});
$c_Llaika_parse_LineSource.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Llaika_parse_LineSource)) {
    var ls = $as_Llaika_parse_LineSource(obj);
    if ((((($n(ls).Llaika_parse_LineSource__f_input === this.Llaika_parse_LineSource__f_input) && ($n($n(ls).root__Llaika_parse_SourceCursor()).offset__I() === $n(this.root__Llaika_parse_SourceCursor()).offset__I())) && ($n(ls).Llaika_parse_LineSource__f_offset === this.Llaika_parse_LineSource__f_offset)) && ($n(ls).Llaika_parse_LineSource__f_nestLevel === this.Llaika_parse_LineSource__f_nestLevel))) {
      var this$1 = $n(ls);
      var x = $n(this$1.root__Llaika_parse_SourceCursor()).path__s_Option();
      var x$2 = $n(this.root__Llaika_parse_SourceCursor()).path__s_Option();
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_parse_LineSource.prototype.toString__T = (function() {
  var this$1 = $n($n(this.root__Llaika_parse_SourceCursor()).path__s_Option());
  if (this$1.isEmpty__Z()) {
    var pathStr = "";
  } else {
    var arg1 = this$1.get__O();
    var _$2 = $as_Llaika_ast_Path(arg1);
    var pathStr = ($n(_$2).toString__T() + ": ");
  }
  var $x_1 = this.Llaika_parse_LineSource__f_offset;
  var this$2 = $n(this.Llaika_parse_LineSource__f_input);
  return (((((((("LineSource(" + pathStr) + "offset ") + $x_1) + " - length ") + this$2.length) + " - root offset ") + $n(this.root__Llaika_parse_SourceCursor()).offset__I()) + ")");
});
$c_Llaika_parse_LineSource.prototype.consume__I__Llaika_parse_SourceCursor = (function(numChars) {
  return this.consume__I__Llaika_parse_LineSource(numChars);
});
$c_Llaika_parse_LineSource.prototype.nextNestLevel__Llaika_parse_SourceCursor = (function() {
  return this.nextNestLevel__Llaika_parse_LineSource();
});
$c_Llaika_parse_LineSource.prototype.reverse__Llaika_parse_SourceCursor = (function() {
  return this.reverse__Llaika_parse_LineSource();
});
function $as_Llaika_parse_LineSource(obj) {
  return (((obj instanceof $c_Llaika_parse_LineSource) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.parse.LineSource"));
}
function $isArrayOf_Llaika_parse_LineSource(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_parse_LineSource)));
}
function $asArrayOf_Llaika_parse_LineSource(obj, depth) {
  return (($isArrayOf_Llaika_parse_LineSource(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.parse.LineSource;", depth));
}
var $d_Llaika_parse_LineSource = new $TypeData().initClass($c_Llaika_parse_LineSource, "laika.parse.LineSource", ({
  Llaika_parse_LineSource: 1,
  Llaika_parse_SourceCursor: 1,
  Llaika_parse_SourceFragment: 1
}));
/** @constructor */
function $c_Llaika_parse_SourceCursor$Generated$() {
}
$c_Llaika_parse_SourceCursor$Generated$.prototype = new $h_O();
$c_Llaika_parse_SourceCursor$Generated$.prototype.constructor = $c_Llaika_parse_SourceCursor$Generated$;
/** @constructor */
function $h_Llaika_parse_SourceCursor$Generated$() {
}
$h_Llaika_parse_SourceCursor$Generated$.prototype = $c_Llaika_parse_SourceCursor$Generated$.prototype;
$c_Llaika_parse_SourceCursor$Generated$.prototype.path__s_Option = (function() {
  return new $c_Llaika_parse_RootSource($m_Llaika_parse_InputString$().Llaika_parse_InputString$__f_empty, 0, 0).Llaika_parse_RootSource__f_path;
});
$c_Llaika_parse_SourceCursor$Generated$.prototype.input__T = (function() {
  return "";
});
$c_Llaika_parse_SourceCursor$Generated$.prototype.offset__I = (function() {
  return 0;
});
$c_Llaika_parse_SourceCursor$Generated$.prototype.remaining__I = (function() {
  return 0;
});
$c_Llaika_parse_SourceCursor$Generated$.prototype.atEnd__Z = (function() {
  return true;
});
$c_Llaika_parse_SourceCursor$Generated$.prototype.capture__I__T = (function(numChars) {
  return "";
});
$c_Llaika_parse_SourceCursor$Generated$.prototype.root__Llaika_parse_SourceCursor = (function() {
  return new $c_Llaika_parse_RootSource($m_Llaika_parse_InputString$().Llaika_parse_InputString$__f_empty, 0, 0);
});
$c_Llaika_parse_SourceCursor$Generated$.prototype.position__Llaika_parse_Position = (function() {
  return new $c_Llaika_parse_Position($m_Llaika_parse_InputString$().Llaika_parse_InputString$__f_empty, 0);
});
$c_Llaika_parse_SourceCursor$Generated$.prototype.nestLevel__I = (function() {
  return 0;
});
$c_Llaika_parse_SourceCursor$Generated$.prototype.consume__I__Llaika_parse_SourceCursor = (function(numChars) {
  return this;
});
$c_Llaika_parse_SourceCursor$Generated$.prototype.nextNestLevel__Llaika_parse_SourceCursor = (function() {
  return this;
});
$c_Llaika_parse_SourceCursor$Generated$.prototype.reverse__Llaika_parse_SourceCursor = (function() {
  return this;
});
var $d_Llaika_parse_SourceCursor$Generated$ = new $TypeData().initClass($c_Llaika_parse_SourceCursor$Generated$, "laika.parse.SourceCursor$Generated$", ({
  Llaika_parse_SourceCursor$Generated$: 1,
  Llaika_parse_SourceCursor: 1,
  Llaika_parse_SourceFragment: 1
}));
var $n_Llaika_parse_SourceCursor$Generated$;
function $m_Llaika_parse_SourceCursor$Generated$() {
  if ((!$n_Llaika_parse_SourceCursor$Generated$)) {
    $n_Llaika_parse_SourceCursor$Generated$ = new $c_Llaika_parse_SourceCursor$Generated$();
  }
  return $n_Llaika_parse_SourceCursor$Generated$;
}
function $p_Llaika_parse_markup_InlineParsers$DefaultInlineParser__nestedMap__sci_Map($thiz) {
  if ((!$thiz.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_nestedMapbitmap$1)) {
    $thiz.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_nestedMap$lzy1 = $m_Llaika_parse_text_PrefixedParser$().mapAndMerge__sci_Seq__sci_Map($as_sci_Seq($n($thiz.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_nested).apply__O()));
    $thiz.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_nestedMapbitmap$1 = true;
  }
  return $thiz.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_nestedMap$lzy1;
}
function $p_Llaika_parse_markup_InlineParsers$DefaultInlineParser__textParser__Llaika_parse_text_DelimitedParser($thiz) {
  if ((!$thiz.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_textParserbitmap$1)) {
    $thiz.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_textParser$lzy1 = new $c_Llaika_parse_text_DelimitedParser(new $c_Llaika_internal_parse_markup_InlineDelimiter($n($p_Llaika_parse_markup_InlineParsers$DefaultInlineParser__nestedMap__sci_Map($thiz)).keySet__sci_Set(), $as_Llaika_parse_text_Delimiter($n($thiz.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_textDelimiter).apply__O())));
    $thiz.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_textParserbitmap$1 = true;
  }
  return $thiz.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_textParser$lzy1;
}
function $p_Llaika_parse_markup_InlineParsers$DefaultInlineParser__builder$lzyINIT1$1__sr_LazyRef__Llaika_parse_markup_InlineParsers$ResultBuilder($thiz, builder$lzy1$1) {
  if ((builder$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Llaika_parse_markup_InlineParsers$ResultBuilder(($n(builder$lzy1$1).sr_LazyRef__f__initialized ? $n(builder$lzy1$1).sr_LazyRef__f__value : $n(builder$lzy1$1).initialize__O__O($as_Llaika_parse_markup_InlineParsers$ResultBuilder($n($thiz.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_resultBuilder).apply__O()))));
}
function $p_Llaika_parse_markup_InlineParsers$DefaultInlineParser__builder$1__sr_LazyRef__Llaika_parse_markup_InlineParsers$ResultBuilder($thiz, builder$lzy1$2) {
  return $as_Llaika_parse_markup_InlineParsers$ResultBuilder(($n(builder$lzy1$2).sr_LazyRef__f__initialized ? $n(builder$lzy1$2).sr_LazyRef__f__value : $p_Llaika_parse_markup_InlineParsers$DefaultInlineParser__builder$lzyINIT1$1__sr_LazyRef__Llaika_parse_markup_InlineParsers$ResultBuilder($thiz, builder$lzy1$2)));
}
function $p_Llaika_parse_markup_InlineParsers$DefaultInlineParser__addText$1__sr_LazyRef__T__V($thiz, builder$lzy1$4, text) {
  var this$1 = $n(text);
  if ((!(this$1 === ""))) {
    $n($p_Llaika_parse_markup_InlineParsers$DefaultInlineParser__builder$1__sr_LazyRef__Llaika_parse_markup_InlineParsers$ResultBuilder($thiz, builder$lzy1$4)).$plus$eq__O__V($n($p_Llaika_parse_markup_InlineParsers$DefaultInlineParser__builder$1__sr_LazyRef__Llaika_parse_markup_InlineParsers$ResultBuilder($thiz, builder$lzy1$4)).fromString__T__O(text));
  }
}
function $p_Llaika_parse_markup_InlineParsers$DefaultInlineParser__nestedSpanOrNextChar$1__sr_LazyRef__Llaika_parse_Parser__Llaika_parse_SourceCursor__Llaika_parse_SourceCursor($thiz, builder$lzy1$5, parser, input) {
  var x55 = $n(parser).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(input);
  if ((x55 instanceof $c_Llaika_parse_Success)) {
    var x$1 = $as_Llaika_parse_Success(x55);
    var this$2 = $n(x$1);
    var x58 = this$2.Llaika_parse_Success__f_result;
    var this$3 = $n(x$1);
    var x59 = this$3.Llaika_parse_Success__f_next;
    $n($p_Llaika_parse_markup_InlineParsers$DefaultInlineParser__builder$1__sr_LazyRef__Llaika_parse_markup_InlineParsers$ResultBuilder($thiz, builder$lzy1$5)).$plus$eq__O__V(x58);
    return x59;
  }
  var $x_2 = $n($p_Llaika_parse_markup_InlineParsers$DefaultInlineParser__builder$1__sr_LazyRef__Llaika_parse_markup_InlineParsers$ResultBuilder($thiz, builder$lzy1$5));
  var $x_1 = $p_Llaika_parse_markup_InlineParsers$DefaultInlineParser__builder$1__sr_LazyRef__Llaika_parse_markup_InlineParsers$ResultBuilder($thiz, builder$lzy1$5);
  var this$4 = $n(input);
  var this$5 = $f_Llaika_parse_SourceCursor__charAt__I__C(this$4, 0);
  $n($x_2).$plus$eq__O__V($n($x_1).fromString__T__O(("" + $cToS(this$5))));
  return $n(input).consume__I__Llaika_parse_SourceCursor(1);
}
function $p_Llaika_parse_markup_InlineParsers$DefaultInlineParser__parse$1__Llaika_parse_SourceCursor__sr_LazyRef__Llaika_parse_SourceCursor__Llaika_parse_Parsed($thiz, in$1, builder$lzy1$3, input) {
  var input$tailLocal1 = input;
  while (true) {
    var x60 = $n($p_Llaika_parse_markup_InlineParsers$DefaultInlineParser__textParser__Llaika_parse_text_DelimitedParser($thiz)).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(input$tailLocal1);
    if ((x60 instanceof $c_Llaika_parse_Failure)) {
      var x$1 = $as_Llaika_parse_Failure(x60);
      var this$2 = $n(x$1);
      var x78 = this$2.Llaika_parse_Failure__f_msgProvider;
      var this$3 = $n(x$1);
      var this$4 = $n(x$1);
      var x80 = this$4.Llaika_parse_Failure__f_maxOffset;
      return new $c_Llaika_parse_Failure(x78, in$1, x80);
    }
    if ((x60 instanceof $c_Llaika_parse_Success)) {
      var x$1$1 = $as_Llaika_parse_Success(x60);
      var this$7 = $n(x$1$1);
      var x71 = $as_Llaika_internal_parse_markup_InlineResult(this$7.Llaika_parse_Success__f_result);
      var this$8 = $n(x$1$1);
      var x72 = this$8.Llaika_parse_Success__f_next;
      if ((x71 instanceof $c_Llaika_internal_parse_markup_EndDelimiter)) {
        var x$1$2 = $as_Llaika_internal_parse_markup_EndDelimiter(x71);
        var this$10 = $n(x$1$2);
        var x75 = this$10.Llaika_internal_parse_markup_EndDelimiter__f_capturedText;
        $p_Llaika_parse_markup_InlineParsers$DefaultInlineParser__addText$1__sr_LazyRef__T__V($thiz, builder$lzy1$3, x75);
        var result = $n($p_Llaika_parse_markup_InlineParsers$DefaultInlineParser__builder$1__sr_LazyRef__Llaika_parse_markup_InlineParsers$ResultBuilder($thiz, builder$lzy1$3)).result__O();
        return new $c_Llaika_parse_Success(result, x72);
      }
      if ((x71 instanceof $c_Llaika_internal_parse_markup_NestedDelimiter)) {
        var x$1$3 = $as_Llaika_internal_parse_markup_NestedDelimiter(x71);
        var this$13 = $n(x$1$3);
        var x67 = this$13.Llaika_internal_parse_markup_NestedDelimiter__f_startChar;
        var this$14 = $n(x$1$3);
        var x68 = this$14.Llaika_internal_parse_markup_NestedDelimiter__f_capturedText;
        $p_Llaika_parse_markup_InlineParsers$DefaultInlineParser__addText$1__sr_LazyRef__T__V($thiz, builder$lzy1$3, x68);
        var parser = $as_Llaika_parse_Parser($n($p_Llaika_parse_markup_InlineParsers$DefaultInlineParser__nestedMap__sci_Map($thiz)).apply__O__O($bC(x67)));
        var newIn = $p_Llaika_parse_markup_InlineParsers$DefaultInlineParser__nestedSpanOrNextChar$1__sr_LazyRef__Llaika_parse_Parser__Llaika_parse_SourceCursor__Llaika_parse_SourceCursor($thiz, builder$lzy1$3, parser, x72);
        input$tailLocal1 = newIn;
        continue;
      }
    }
    throw new $c_s_MatchError(x60);
  }
}
/** @constructor */
function $c_Llaika_parse_markup_InlineParsers$DefaultInlineParser(outer, textDelimiter, nested, resultBuilder) {
  this.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_textDelimiter = null;
  this.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_nested = null;
  this.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_resultBuilder = null;
  this.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_nestedMap$lzy1 = null;
  this.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_nestedMapbitmap$1 = false;
  this.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_textParser$lzy1 = null;
  this.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_textParserbitmap$1 = false;
  this.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_$outer = null;
  this.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_textDelimiter = textDelimiter;
  this.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_nested = nested;
  this.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_resultBuilder = resultBuilder;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_$outer = outer;
}
$c_Llaika_parse_markup_InlineParsers$DefaultInlineParser.prototype = new $h_Llaika_parse_Parser();
$c_Llaika_parse_markup_InlineParsers$DefaultInlineParser.prototype.constructor = $c_Llaika_parse_markup_InlineParsers$DefaultInlineParser;
/** @constructor */
function $h_Llaika_parse_markup_InlineParsers$DefaultInlineParser() {
}
$h_Llaika_parse_markup_InlineParsers$DefaultInlineParser.prototype = $c_Llaika_parse_markup_InlineParsers$DefaultInlineParser.prototype;
$c_Llaika_parse_markup_InlineParsers$DefaultInlineParser.prototype.embed__F0__Llaika_parse_markup_InlineParser = (function(parser) {
  return new $c_Llaika_parse_markup_InlineParsers$DefaultInlineParser(this.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_$outer, this.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_textDelimiter, new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n($as_sc_SeqOps($n(this.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_nested).apply__O()));
    var elem = $n(parser).apply__O();
    return $as_sci_Seq(this$2.appended__O__O(elem));
  })), this.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_resultBuilder);
});
$c_Llaika_parse_markup_InlineParsers$DefaultInlineParser.prototype.embedAll__F0__Llaika_parse_markup_InlineParser = (function(parsers) {
  return new $c_Llaika_parse_markup_InlineParsers$DefaultInlineParser(this.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_$outer, this.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_textDelimiter, new $c_sjsr_AnonFunction0((() => {
    var this$2 = $n($as_sc_IterableOps($n(this.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_nested).apply__O()));
    var suffix = $as_sc_IterableOnce($n(parsers).apply__O());
    return $as_sci_Seq(this$2.concat__sc_IterableOnce__O(suffix));
  })), this.Llaika_parse_markup_InlineParsers$DefaultInlineParser__f_resultBuilder);
});
$c_Llaika_parse_markup_InlineParsers$DefaultInlineParser.prototype.parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed = (function(in$1) {
  var builder$lzy1 = new $c_sr_LazyRef();
  return $p_Llaika_parse_markup_InlineParsers$DefaultInlineParser__parse$1__Llaika_parse_SourceCursor__sr_LazyRef__Llaika_parse_SourceCursor__Llaika_parse_Parsed(this, in$1, builder$lzy1, in$1);
});
var $d_Llaika_parse_markup_InlineParsers$DefaultInlineParser = new $TypeData().initClass($c_Llaika_parse_markup_InlineParsers$DefaultInlineParser, "laika.parse.markup.InlineParsers$DefaultInlineParser", ({
  Llaika_parse_markup_InlineParsers$DefaultInlineParser: 1,
  Llaika_parse_Parser: 1,
  Llaika_parse_markup_InlineParser: 1
}));
function $is_Llaika_parse_markup_RecursiveParsers(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_parse_markup_RecursiveParsers)));
}
function $as_Llaika_parse_markup_RecursiveParsers(obj) {
  return (($is_Llaika_parse_markup_RecursiveParsers(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.parse.markup.RecursiveParsers"));
}
function $isArrayOf_Llaika_parse_markup_RecursiveParsers(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_parse_markup_RecursiveParsers)));
}
function $asArrayOf_Llaika_parse_markup_RecursiveParsers(obj, depth) {
  return (($isArrayOf_Llaika_parse_markup_RecursiveParsers(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.parse.markup.RecursiveParsers;", depth));
}
/** @constructor */
function $c_Llaika_parse_text_DelimiterParser(prefix, prevCharInvalid, nextCharInvalid, enclosingCharsInvalid) {
  this.Llaika_parse_text_DelimiterParser__f_prefix = null;
  this.Llaika_parse_text_DelimiterParser__f_prevCharInvalid = null;
  this.Llaika_parse_text_DelimiterParser__f_nextCharInvalid = null;
  this.Llaika_parse_text_DelimiterParser__f_enclosingCharsInvalid = null;
  this.Llaika_parse_text_DelimiterParser__f_startChars = null;
  this.Llaika_parse_text_DelimiterParser__f_prevCharInvalidMsg = null;
  this.Llaika_parse_text_DelimiterParser__f_nextCharInvalidMsg = null;
  this.Llaika_parse_text_DelimiterParser__f_enclosingCharsInvalidMsg = null;
  this.Llaika_parse_text_DelimiterParser__f_underlying = null;
  this.Llaika_parse_text_DelimiterParser__f_prefix = prefix;
  this.Llaika_parse_text_DelimiterParser__f_prevCharInvalid = prevCharInvalid;
  this.Llaika_parse_text_DelimiterParser__f_nextCharInvalid = nextCharInvalid;
  this.Llaika_parse_text_DelimiterParser__f_enclosingCharsInvalid = enclosingCharsInvalid;
  this.Llaika_parse_text_DelimiterParser__f_startChars = $n(prefix).startChars__O();
  $m_Llaika_parse_Message$();
  var f = new $c_sjsr_AnonFunction1(((value) => {
    var value$1 = $uC(value);
    return (("delimiter predicate for preceding character '" + $cToS(value$1)) + "' not satisfied");
  }));
  this.Llaika_parse_text_DelimiterParser__f_prevCharInvalidMsg = new $c_Llaika_parse_Message$MessageFactory(f);
  $m_Llaika_parse_Message$();
  var f$1 = new $c_sjsr_AnonFunction1(((value$2) => {
    var value$3 = $uC(value$2);
    return (("delimiter predicate for following character '" + $cToS(value$3)) + "' not satisfied");
  }));
  this.Llaika_parse_text_DelimiterParser__f_nextCharInvalidMsg = new $c_Llaika_parse_Message$MessageFactory(f$1);
  $m_Llaika_parse_Message$();
  var f$2 = new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var prev = $uC($n(x$1$1)._1__O());
      var next = $uC($n(x$1$1)._2__O());
      return (((("delimiter enclosed by invalid pair of characters: '" + $cToS(prev)) + "' and '") + $cToS(next)) + "'");
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  this.Llaika_parse_text_DelimiterParser__f_enclosingCharsInvalidMsg = new $c_Llaika_parse_Message$MessageFactory(f$2);
  var this$21 = $m_Llaika_parse_Parser$();
  var f$4 = new $c_sjsr_AnonFunction1(((in$1) => {
    var in$2 = $as_Llaika_parse_SourceCursor(in$1);
    matchResult2: {
      var $x_1;
      var this$5 = $n(prefix);
      var x4 = $n(this$5.underlying__Llaika_parse_Parser()).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(in$2);
      if ((x4 instanceof $c_Llaika_parse_Success)) {
        var x6 = $as_Llaika_parse_Success(x4);
        var this$7 = $n(x6);
        $as_T(this$7.Llaika_parse_Success__f_result);
        var this$8 = $n(x6);
        var x9 = this$8.Llaika_parse_Success__f_next;
        if (($n(in$2).offset__I() > 0)) {
          var this$9 = $n(in$2);
          var $x_2 = $uZ($n(prevCharInvalid).apply__O__O($bC($f_Llaika_parse_SourceCursor__charAt__I__C(this$9, (-1)))));
        } else {
          var $x_2 = false;
        }
        if ($x_2) {
          var $x_3 = this.Llaika_parse_text_DelimiterParser__f_prevCharInvalidMsg;
          var this$10 = $n(in$2);
          var msgProvider = $as_Llaika_parse_Message($n($x_3).apply__O__O($bC($f_Llaika_parse_SourceCursor__charAt__I__C(this$10, (-1)))));
          var maxOffset = $n(in$2).offset__I();
          var $x_1 = new $c_Llaika_parse_Failure(msgProvider, in$2, maxOffset);
          break matchResult2;
        } else {
          if (($n(x9).remaining__I() > 0)) {
            var this$12 = $n(x9);
            var $x_4 = $uZ($n(nextCharInvalid).apply__O__O($bC($f_Llaika_parse_SourceCursor__charAt__I__C(this$12, 0))));
          } else {
            var $x_4 = false;
          }
          if ($x_4) {
            var $x_5 = this.Llaika_parse_text_DelimiterParser__f_nextCharInvalidMsg;
            var this$13 = $n(x9);
            var msgProvider$1 = $as_Llaika_parse_Message($n($x_5).apply__O__O($bC($f_Llaika_parse_SourceCursor__charAt__I__C(this$13, 0))));
            var maxOffset$1 = $n(in$2).offset__I();
            var $x_1 = new $c_Llaika_parse_Failure(msgProvider$1, in$2, maxOffset$1);
            break matchResult2;
          } else {
            if ((($n(in$2).offset__I() > 0) && ($n(x9).remaining__I() > 0))) {
              var this$15 = $n(in$2);
              var $x_7 = $f_Llaika_parse_SourceCursor__charAt__I__C(this$15, (-1));
              var this$16 = $n(x9);
              var $x_6 = $uZ($n(enclosingCharsInvalid).apply__O__O__O($bC($x_7), $bC($f_Llaika_parse_SourceCursor__charAt__I__C(this$16, 0))));
            } else {
              var $x_6 = false;
            }
            if ($x_6) {
              var $x_8 = this.Llaika_parse_text_DelimiterParser__f_enclosingCharsInvalidMsg;
              var this$17 = $n(in$2);
              var _1 = $f_Llaika_parse_SourceCursor__charAt__I__C(this$17, (-1));
              var this$18 = $n(x9);
              var _2 = $f_Llaika_parse_SourceCursor__charAt__I__C(this$18, 0);
              var msgProvider$2 = $as_Llaika_parse_Message($n($x_8).apply__O__O(new $c_T2($bC(_1), $bC(_2))));
              var maxOffset$2 = $n(in$2).offset__I();
              var $x_1 = new $c_Llaika_parse_Failure(msgProvider$2, in$2, maxOffset$2);
              break matchResult2;
            } else {
              var $x_1 = x6;
              break matchResult2;
            }
          }
        }
      }
      if ((x4 instanceof $c_Llaika_parse_Failure)) {
        var f$3 = $as_Llaika_parse_Failure(x4);
        var $x_1 = f$3;
        break matchResult2;
      }
      throw new $c_s_MatchError(x4);
    }
    return $as_Llaika_parse_Parsed($x_1);
  }));
  this.Llaika_parse_text_DelimiterParser__f_underlying = new $c_Llaika_parse_Parser$$anon$2(f$4, this$21);
}
$c_Llaika_parse_text_DelimiterParser.prototype = new $h_Llaika_parse_Parser();
$c_Llaika_parse_text_DelimiterParser.prototype.constructor = $c_Llaika_parse_text_DelimiterParser;
/** @constructor */
function $h_Llaika_parse_text_DelimiterParser() {
}
$h_Llaika_parse_text_DelimiterParser.prototype = $c_Llaika_parse_text_DelimiterParser.prototype;
$c_Llaika_parse_text_DelimiterParser.prototype.parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed = (function(in$1) {
  return $n(this.Llaika_parse_text_DelimiterParser__f_underlying).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(in$1);
});
$c_Llaika_parse_text_DelimiterParser.prototype.collect$default$2__F1 = (function() {
  return $f_Llaika_parse_text_PrefixedParser__collect$default$2__F1(this);
});
$c_Llaika_parse_text_DelimiterParser.prototype.startChars__O = (function() {
  return this.Llaika_parse_text_DelimiterParser__f_startChars;
});
$c_Llaika_parse_text_DelimiterParser.prototype.underlying__Llaika_parse_Parser = (function() {
  return this.Llaika_parse_text_DelimiterParser__f_underlying;
});
$c_Llaika_parse_text_DelimiterParser.prototype.prevNot__C__sci_Seq__Llaika_parse_text_DelimiterParser = (function(char, chars) {
  return this.prevNot__O__Llaika_parse_text_DelimiterParser($n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet).of__O__sci_Seq__Lcats_kernel_Order__O($bC(char), chars, $m_Lcats_kernel_instances_char_package$().Lcats_kernel_instances_char_package$__f_catsKernelStdOrderForChar));
});
$c_Llaika_parse_text_DelimiterParser.prototype.prevNot__O__Llaika_parse_text_DelimiterParser = (function(chars) {
  return this.prevNot__F1__Llaika_parse_text_DelimiterParser(new $c_sjsr_AnonFunction1(((_$5) => {
    var _$5$1 = $uC(_$5);
    var this$2 = new $c_Lcats_data_NonEmptySetOps(chars);
    var s = this$2.Lcats_data_NonEmptySetOps__f_value;
    var this$4 = $n($as_sci_SortedSet(s));
    return this$4.contains__O__Z($bC(_$5$1));
  })));
});
$c_Llaika_parse_text_DelimiterParser.prototype.prevNot__F1__Llaika_parse_text_DelimiterParser = (function(predicate) {
  return new $c_Llaika_parse_text_DelimiterParser(this.Llaika_parse_text_DelimiterParser__f_prefix, predicate, this.Llaika_parse_text_DelimiterParser__f_nextCharInvalid, this.Llaika_parse_text_DelimiterParser__f_enclosingCharsInvalid);
});
$c_Llaika_parse_text_DelimiterParser.prototype.nextNot__C__sci_Seq__Llaika_parse_text_DelimiterParser = (function(char, chars) {
  return this.nextNot__O__Llaika_parse_text_DelimiterParser($n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet).of__O__sci_Seq__Lcats_kernel_Order__O($bC(char), chars, $m_Lcats_kernel_instances_char_package$().Lcats_kernel_instances_char_package$__f_catsKernelStdOrderForChar));
});
$c_Llaika_parse_text_DelimiterParser.prototype.nextNot__O__Llaika_parse_text_DelimiterParser = (function(chars) {
  return this.nextNot__F1__Llaika_parse_text_DelimiterParser(new $c_sjsr_AnonFunction1(((_$6) => {
    var _$6$1 = $uC(_$6);
    var this$2 = new $c_Lcats_data_NonEmptySetOps(chars);
    var s = this$2.Lcats_data_NonEmptySetOps__f_value;
    var this$4 = $n($as_sci_SortedSet(s));
    return this$4.contains__O__Z($bC(_$6$1));
  })));
});
$c_Llaika_parse_text_DelimiterParser.prototype.nextNot__F1__Llaika_parse_text_DelimiterParser = (function(predicate) {
  return new $c_Llaika_parse_text_DelimiterParser(this.Llaika_parse_text_DelimiterParser__f_prefix, this.Llaika_parse_text_DelimiterParser__f_prevCharInvalid, predicate, this.Llaika_parse_text_DelimiterParser__f_enclosingCharsInvalid);
});
$c_Llaika_parse_text_DelimiterParser.prototype.$tilde__Llaika_parse_Parser__Llaika_parse_Parser = (function(p) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this, p));
});
$c_Llaika_parse_text_DelimiterParser.prototype.$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser = (function(p) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$tilde$greater__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this, p));
});
$c_Llaika_parse_text_DelimiterParser.prototype.$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser = (function(p) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$less$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this, p));
});
$c_Llaika_parse_text_DelimiterParser.prototype.$tilde__T__Llaika_parse_Parser = (function(value) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$tilde__T__Llaika_parse_text_PrefixedParser(this, value));
});
$c_Llaika_parse_text_DelimiterParser.prototype.$less$tilde__T__Llaika_parse_Parser = (function(value) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$less$tilde__T__Llaika_parse_text_PrefixedParser(this, value));
});
$c_Llaika_parse_text_DelimiterParser.prototype.flatMap__F1__Llaika_parse_Parser = (function(f) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__flatMap__F1__Llaika_parse_text_PrefixedParser(this, f));
});
$c_Llaika_parse_text_DelimiterParser.prototype.$greater$greater__F1__Llaika_parse_Parser = (function(fq) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$greater$greater__F1__Llaika_parse_text_PrefixedParser(this, fq));
});
$c_Llaika_parse_text_DelimiterParser.prototype.map__F1__Llaika_parse_Parser = (function(f) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser(this, f));
});
$c_Llaika_parse_text_DelimiterParser.prototype.$up$up__F1__Llaika_parse_Parser = (function(f) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$up$up__F1__Llaika_parse_text_PrefixedParser(this, f));
});
$c_Llaika_parse_text_DelimiterParser.prototype.as__F0__Llaika_parse_Parser = (function(v) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__as__F0__Llaika_parse_text_PrefixedParser(this, v));
});
$c_Llaika_parse_text_DelimiterParser.prototype.evalMap__F1__Llaika_parse_Parser = (function(f) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__evalMap__F1__Llaika_parse_text_PrefixedParser(this, f));
});
$c_Llaika_parse_text_DelimiterParser.prototype.collect__s_PartialFunction__F1__Llaika_parse_Parser = (function(f, error) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__collect__s_PartialFunction__F1__Llaika_parse_text_PrefixedParser(this, f, error));
});
$c_Llaika_parse_text_DelimiterParser.prototype.$bar__T__s_$less$colon$less__Llaika_parse_Parser = (function(value, ev) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$bar__T__s_$less$colon$less__Llaika_parse_text_PrefixedParser(this, value, ev));
});
$c_Llaika_parse_text_DelimiterParser.prototype.withCursor__Llaika_parse_Parser = (function() {
  var this$1 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = this.Llaika_parse_text_DelimiterParser__f_startChars;
  var p = $c_Llaika_parse_Parser.prototype.withCursor__Llaika_parse_Parser.call(this);
  return new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p, this$1);
});
$c_Llaika_parse_text_DelimiterParser.prototype.source__Llaika_parse_Parser = (function() {
  var this$1 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = this.Llaika_parse_text_DelimiterParser__f_startChars;
  var p = $c_Llaika_parse_Parser.prototype.source__Llaika_parse_Parser.call(this);
  return new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p, this$1);
});
var $d_Llaika_parse_text_DelimiterParser = new $TypeData().initClass($c_Llaika_parse_text_DelimiterParser, "laika.parse.text.DelimiterParser", ({
  Llaika_parse_text_DelimiterParser: 1,
  Llaika_parse_Parser: 1,
  Llaika_parse_text_PrefixedParser: 1
}));
/** @constructor */
function $c_Llaika_parse_text_Literal(expected) {
  this.Llaika_parse_text_Literal__f_startChars = null;
  this.Llaika_parse_text_Literal__f_msgProvider = null;
  this.Llaika_parse_text_Literal__f_underlying = null;
  var this$3 = $n(expected);
  var requirement = (!(this$3 === ""));
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: string may not be empty");
  }
  this.Llaika_parse_text_Literal__f_startChars = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet).one__O__Lcats_kernel_Order__O($bC($m_sc_StringOps$().head$extension__T__C(expected)), $m_Lcats_kernel_instances_char_package$().Lcats_kernel_instances_char_package$__f_catsKernelStdOrderForChar);
  var this$9 = $m_Llaika_parse_Message$();
  var f = new $c_sjsr_AnonFunction1(((context) => {
    var context$1 = $as_Llaika_parse_SourceCursor(context);
    var a = $n(context$1).remaining__I();
    var this$7 = $n(expected);
    var b = this$7.length;
    var toCapture = ((a < b) ? a : b);
    var found = $n(context$1).capture__I__T(toCapture);
    return (((("`" + expected) + "' expected but `") + found) + "` found");
  }));
  this.Llaika_parse_text_Literal__f_msgProvider = new $c_Llaika_parse_Message$$anon$3(f, this$9);
  var this$18 = $m_Llaika_parse_Parser$();
  var f$1 = new $c_sjsr_AnonFunction1(((in$1) => {
    var in$2 = $as_Llaika_parse_SourceCursor(in$1);
    var source = $n(in$2).input__T();
    var start = $n(in$2).offset__I();
    var i = 0;
    var j = start;
    while (true) {
      var $x_3 = i;
      var this$11 = $n(expected);
      if (($x_3 < this$11.length)) {
        var $x_4 = j;
        var this$12 = $n(source);
        var $x_2 = ($x_4 < this$12.length);
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        var this$13 = $n(expected);
        var index = i;
        var this$14 = $n(source);
        var index$1 = j;
        var $x_1 = ($charAt(this$13, index) === $charAt(this$14, index$1));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        i = ((1 + i) | 0);
        j = ((1 + j) | 0);
      } else {
        break;
      }
    }
    var $x_6 = i;
    var this$15 = $n(expected);
    if (($x_6 === this$15.length)) {
      var next = $n(in$2).consume__I__Llaika_parse_SourceCursor(i);
      var $x_5 = new $c_Llaika_parse_Success(expected, next);
    } else {
      var msgProvider = this.Llaika_parse_text_Literal__f_msgProvider;
      var maxOffset = j;
      var $x_5 = new $c_Llaika_parse_Failure(msgProvider, in$2, maxOffset);
    }
    return $as_Llaika_parse_Parsed($x_5);
  }));
  this.Llaika_parse_text_Literal__f_underlying = new $c_Llaika_parse_Parser$$anon$2(f$1, this$18);
}
$c_Llaika_parse_text_Literal.prototype = new $h_Llaika_parse_Parser();
$c_Llaika_parse_text_Literal.prototype.constructor = $c_Llaika_parse_text_Literal;
/** @constructor */
function $h_Llaika_parse_text_Literal() {
}
$h_Llaika_parse_text_Literal.prototype = $c_Llaika_parse_text_Literal.prototype;
$c_Llaika_parse_text_Literal.prototype.parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed = (function(in$1) {
  return $n(this.Llaika_parse_text_Literal__f_underlying).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(in$1);
});
$c_Llaika_parse_text_Literal.prototype.collect$default$2__F1 = (function() {
  return $f_Llaika_parse_text_PrefixedParser__collect$default$2__F1(this);
});
$c_Llaika_parse_text_Literal.prototype.startChars__O = (function() {
  return this.Llaika_parse_text_Literal__f_startChars;
});
$c_Llaika_parse_text_Literal.prototype.underlying__Llaika_parse_Parser = (function() {
  return this.Llaika_parse_text_Literal__f_underlying;
});
$c_Llaika_parse_text_Literal.prototype.$tilde__Llaika_parse_Parser__Llaika_parse_Parser = (function(p) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this, p));
});
$c_Llaika_parse_text_Literal.prototype.$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser = (function(p) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$tilde$greater__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this, p));
});
$c_Llaika_parse_text_Literal.prototype.$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser = (function(p) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$less$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this, p));
});
$c_Llaika_parse_text_Literal.prototype.$tilde__T__Llaika_parse_Parser = (function(value) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$tilde__T__Llaika_parse_text_PrefixedParser(this, value));
});
$c_Llaika_parse_text_Literal.prototype.$less$tilde__T__Llaika_parse_Parser = (function(value) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$less$tilde__T__Llaika_parse_text_PrefixedParser(this, value));
});
$c_Llaika_parse_text_Literal.prototype.flatMap__F1__Llaika_parse_Parser = (function(f) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__flatMap__F1__Llaika_parse_text_PrefixedParser(this, f));
});
$c_Llaika_parse_text_Literal.prototype.$greater$greater__F1__Llaika_parse_Parser = (function(fq) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$greater$greater__F1__Llaika_parse_text_PrefixedParser(this, fq));
});
$c_Llaika_parse_text_Literal.prototype.map__F1__Llaika_parse_Parser = (function(f) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser(this, f));
});
$c_Llaika_parse_text_Literal.prototype.$up$up__F1__Llaika_parse_Parser = (function(f) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$up$up__F1__Llaika_parse_text_PrefixedParser(this, f));
});
$c_Llaika_parse_text_Literal.prototype.as__F0__Llaika_parse_Parser = (function(v) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__as__F0__Llaika_parse_text_PrefixedParser(this, v));
});
$c_Llaika_parse_text_Literal.prototype.evalMap__F1__Llaika_parse_Parser = (function(f) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__evalMap__F1__Llaika_parse_text_PrefixedParser(this, f));
});
$c_Llaika_parse_text_Literal.prototype.collect__s_PartialFunction__F1__Llaika_parse_Parser = (function(f, error) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__collect__s_PartialFunction__F1__Llaika_parse_text_PrefixedParser(this, f, error));
});
$c_Llaika_parse_text_Literal.prototype.$bar__T__s_$less$colon$less__Llaika_parse_Parser = (function(value, ev) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$bar__T__s_$less$colon$less__Llaika_parse_text_PrefixedParser(this, value, ev));
});
$c_Llaika_parse_text_Literal.prototype.withCursor__Llaika_parse_Parser = (function() {
  var this$1 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = this.Llaika_parse_text_Literal__f_startChars;
  var p = $c_Llaika_parse_Parser.prototype.withCursor__Llaika_parse_Parser.call(this);
  return new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p, this$1);
});
$c_Llaika_parse_text_Literal.prototype.source__Llaika_parse_Parser = (function() {
  var this$1 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = this.Llaika_parse_text_Literal__f_startChars;
  var p = $c_Llaika_parse_Parser.prototype.source__Llaika_parse_Parser.call(this);
  return new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p, this$1);
});
var $d_Llaika_parse_text_Literal = new $TypeData().initClass($c_Llaika_parse_text_Literal, "laika.parse.text.Literal", ({
  Llaika_parse_text_Literal: 1,
  Llaika_parse_Parser: 1,
  Llaika_parse_text_PrefixedParser: 1
}));
function $p_Llaika_parse_text_PrefixCharacters__greaterThanZero__I__V($thiz, count) {
  var requirement = (count > 0);
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: count must be positive for an optimizable prefix, use TextParsers.anyOf or anyIn if you need to allow empty sequences");
  }
}
/** @constructor */
function $c_Llaika_parse_text_PrefixCharacters(underlying, startChars) {
  this.Llaika_parse_text_PrefixCharacters__f_underlying = null;
  this.Llaika_parse_text_PrefixCharacters__f_startChars = null;
  this.Llaika_parse_text_PrefixCharacters__f_underlying = underlying;
  this.Llaika_parse_text_PrefixCharacters__f_startChars = startChars;
}
$c_Llaika_parse_text_PrefixCharacters.prototype = new $h_Llaika_parse_Parser();
$c_Llaika_parse_text_PrefixCharacters.prototype.constructor = $c_Llaika_parse_text_PrefixCharacters;
/** @constructor */
function $h_Llaika_parse_text_PrefixCharacters() {
}
$h_Llaika_parse_text_PrefixCharacters.prototype = $c_Llaika_parse_text_PrefixCharacters.prototype;
$c_Llaika_parse_text_PrefixCharacters.prototype.parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed = (function(in$1) {
  return $n(this.Llaika_parse_text_PrefixCharacters__f_underlying).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(in$1);
});
$c_Llaika_parse_text_PrefixCharacters.prototype.collect$default$2__F1 = (function() {
  return $f_Llaika_parse_text_PrefixedParser__collect$default$2__F1(this);
});
$c_Llaika_parse_text_PrefixCharacters.prototype.startChars__O = (function() {
  return this.Llaika_parse_text_PrefixCharacters__f_startChars;
});
$c_Llaika_parse_text_PrefixCharacters.prototype.min__I__Llaika_parse_text_PrefixCharacters = (function(count) {
  $p_Llaika_parse_text_PrefixCharacters__greaterThanZero__I__V(this, count);
  return new $c_Llaika_parse_text_PrefixCharacters($n(this.Llaika_parse_text_PrefixCharacters__f_underlying).min__I__Llaika_parse_text_Characters(count), this.Llaika_parse_text_PrefixCharacters__f_startChars);
});
$c_Llaika_parse_text_PrefixCharacters.prototype.max__I__Llaika_parse_text_PrefixCharacters = (function(count) {
  $p_Llaika_parse_text_PrefixCharacters__greaterThanZero__I__V(this, count);
  return new $c_Llaika_parse_text_PrefixCharacters($n(this.Llaika_parse_text_PrefixCharacters__f_underlying).max__I__Llaika_parse_text_Characters(count), this.Llaika_parse_text_PrefixCharacters__f_startChars);
});
$c_Llaika_parse_text_PrefixCharacters.prototype.take__I__Llaika_parse_text_PrefixCharacters = (function(count) {
  $p_Llaika_parse_text_PrefixCharacters__greaterThanZero__I__V(this, count);
  return new $c_Llaika_parse_text_PrefixCharacters($n(this.Llaika_parse_text_PrefixCharacters__f_underlying).take__I__Llaika_parse_text_Characters(count), this.Llaika_parse_text_PrefixCharacters__f_startChars);
});
$c_Llaika_parse_text_PrefixCharacters.prototype.count__Llaika_parse_text_PrefixCharacters = (function() {
  return new $c_Llaika_parse_text_PrefixCharacters($n(this.Llaika_parse_text_PrefixCharacters__f_underlying).count__Llaika_parse_text_Characters(), this.Llaika_parse_text_PrefixCharacters__f_startChars);
});
$c_Llaika_parse_text_PrefixCharacters.prototype.void__Llaika_parse_text_PrefixCharacters = (function() {
  return new $c_Llaika_parse_text_PrefixCharacters($n(this.Llaika_parse_text_PrefixCharacters__f_underlying).void__Llaika_parse_text_Characters(), this.Llaika_parse_text_PrefixCharacters__f_startChars);
});
$c_Llaika_parse_text_PrefixCharacters.prototype.underlying__Llaika_parse_Parser = (function() {
  return this.Llaika_parse_text_PrefixCharacters__f_underlying;
});
$c_Llaika_parse_text_PrefixCharacters.prototype.void__Llaika_parse_Parser = (function() {
  return this.void__Llaika_parse_text_PrefixCharacters();
});
$c_Llaika_parse_text_PrefixCharacters.prototype.$tilde__Llaika_parse_Parser__Llaika_parse_Parser = (function(p) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this, p));
});
$c_Llaika_parse_text_PrefixCharacters.prototype.$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser = (function(p) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$tilde$greater__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this, p));
});
$c_Llaika_parse_text_PrefixCharacters.prototype.$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser = (function(p) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$less$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this, p));
});
$c_Llaika_parse_text_PrefixCharacters.prototype.$tilde__T__Llaika_parse_Parser = (function(value) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$tilde__T__Llaika_parse_text_PrefixedParser(this, value));
});
$c_Llaika_parse_text_PrefixCharacters.prototype.$less$tilde__T__Llaika_parse_Parser = (function(value) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$less$tilde__T__Llaika_parse_text_PrefixedParser(this, value));
});
$c_Llaika_parse_text_PrefixCharacters.prototype.flatMap__F1__Llaika_parse_Parser = (function(f) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__flatMap__F1__Llaika_parse_text_PrefixedParser(this, f));
});
$c_Llaika_parse_text_PrefixCharacters.prototype.$greater$greater__F1__Llaika_parse_Parser = (function(fq) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$greater$greater__F1__Llaika_parse_text_PrefixedParser(this, fq));
});
$c_Llaika_parse_text_PrefixCharacters.prototype.map__F1__Llaika_parse_Parser = (function(f) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser(this, f));
});
$c_Llaika_parse_text_PrefixCharacters.prototype.$up$up__F1__Llaika_parse_Parser = (function(f) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$up$up__F1__Llaika_parse_text_PrefixedParser(this, f));
});
$c_Llaika_parse_text_PrefixCharacters.prototype.as__F0__Llaika_parse_Parser = (function(v) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__as__F0__Llaika_parse_text_PrefixedParser(this, v));
});
$c_Llaika_parse_text_PrefixCharacters.prototype.evalMap__F1__Llaika_parse_Parser = (function(f) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__evalMap__F1__Llaika_parse_text_PrefixedParser(this, f));
});
$c_Llaika_parse_text_PrefixCharacters.prototype.collect__s_PartialFunction__F1__Llaika_parse_Parser = (function(f, error) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__collect__s_PartialFunction__F1__Llaika_parse_text_PrefixedParser(this, f, error));
});
$c_Llaika_parse_text_PrefixCharacters.prototype.$bar__T__s_$less$colon$less__Llaika_parse_Parser = (function(value, ev) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$bar__T__s_$less$colon$less__Llaika_parse_text_PrefixedParser(this, value, ev));
});
$c_Llaika_parse_text_PrefixCharacters.prototype.withCursor__Llaika_parse_Parser = (function() {
  var this$1 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = this.Llaika_parse_text_PrefixCharacters__f_startChars;
  var p = $c_Llaika_parse_Parser.prototype.withCursor__Llaika_parse_Parser.call(this);
  return new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p, this$1);
});
$c_Llaika_parse_text_PrefixCharacters.prototype.source__Llaika_parse_Parser = (function() {
  var this$1 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = this.Llaika_parse_text_PrefixCharacters__f_startChars;
  var p = $c_Llaika_parse_Parser.prototype.source__Llaika_parse_Parser.call(this);
  return new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p, this$1);
});
var $d_Llaika_parse_text_PrefixCharacters = new $TypeData().initClass($c_Llaika_parse_text_PrefixCharacters, "laika.parse.text.PrefixCharacters", ({
  Llaika_parse_text_PrefixCharacters: 1,
  Llaika_parse_Parser: 1,
  Llaika_parse_text_PrefixedParser: 1
}));
/** @constructor */
function $c_Llaika_parse_text_PrefixedParser$$anon$1(sc$2, p$3, outer) {
  this.Llaika_parse_text_PrefixedParser$$anon$1__f_sc$1 = null;
  this.Llaika_parse_text_PrefixedParser$$anon$1__f_p$1 = null;
  this.Llaika_parse_text_PrefixedParser$$anon$1__f_sc$1 = sc$2;
  this.Llaika_parse_text_PrefixedParser$$anon$1__f_p$1 = p$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_parse_text_PrefixedParser$$anon$1.prototype = new $h_Llaika_parse_Parser();
$c_Llaika_parse_text_PrefixedParser$$anon$1.prototype.constructor = $c_Llaika_parse_text_PrefixedParser$$anon$1;
/** @constructor */
function $h_Llaika_parse_text_PrefixedParser$$anon$1() {
}
$h_Llaika_parse_text_PrefixedParser$$anon$1.prototype = $c_Llaika_parse_text_PrefixedParser$$anon$1.prototype;
$c_Llaika_parse_text_PrefixedParser$$anon$1.prototype.parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed = (function(in$1) {
  return $n(this.Llaika_parse_text_PrefixedParser$$anon$1__f_p$1).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(in$1);
});
$c_Llaika_parse_text_PrefixedParser$$anon$1.prototype.collect$default$2__F1 = (function() {
  return $f_Llaika_parse_text_PrefixedParser__collect$default$2__F1(this);
});
$c_Llaika_parse_text_PrefixedParser$$anon$1.prototype.startChars__O = (function() {
  return this.Llaika_parse_text_PrefixedParser$$anon$1__f_sc$1;
});
$c_Llaika_parse_text_PrefixedParser$$anon$1.prototype.underlying__Llaika_parse_Parser = (function() {
  return this.Llaika_parse_text_PrefixedParser$$anon$1__f_p$1;
});
$c_Llaika_parse_text_PrefixedParser$$anon$1.prototype.$tilde__Llaika_parse_Parser__Llaika_parse_Parser = (function(p) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this, p));
});
$c_Llaika_parse_text_PrefixedParser$$anon$1.prototype.$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser = (function(p) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$tilde$greater__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this, p));
});
$c_Llaika_parse_text_PrefixedParser$$anon$1.prototype.$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser = (function(p) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$less$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this, p));
});
$c_Llaika_parse_text_PrefixedParser$$anon$1.prototype.$tilde__T__Llaika_parse_Parser = (function(value) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$tilde__T__Llaika_parse_text_PrefixedParser(this, value));
});
$c_Llaika_parse_text_PrefixedParser$$anon$1.prototype.$less$tilde__T__Llaika_parse_Parser = (function(value) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$less$tilde__T__Llaika_parse_text_PrefixedParser(this, value));
});
$c_Llaika_parse_text_PrefixedParser$$anon$1.prototype.flatMap__F1__Llaika_parse_Parser = (function(f) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__flatMap__F1__Llaika_parse_text_PrefixedParser(this, f));
});
$c_Llaika_parse_text_PrefixedParser$$anon$1.prototype.$greater$greater__F1__Llaika_parse_Parser = (function(fq) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$greater$greater__F1__Llaika_parse_text_PrefixedParser(this, fq));
});
$c_Llaika_parse_text_PrefixedParser$$anon$1.prototype.map__F1__Llaika_parse_Parser = (function(f) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser(this, f));
});
$c_Llaika_parse_text_PrefixedParser$$anon$1.prototype.$up$up__F1__Llaika_parse_Parser = (function(f) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$up$up__F1__Llaika_parse_text_PrefixedParser(this, f));
});
$c_Llaika_parse_text_PrefixedParser$$anon$1.prototype.as__F0__Llaika_parse_Parser = (function(v) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__as__F0__Llaika_parse_text_PrefixedParser(this, v));
});
$c_Llaika_parse_text_PrefixedParser$$anon$1.prototype.evalMap__F1__Llaika_parse_Parser = (function(f) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__evalMap__F1__Llaika_parse_text_PrefixedParser(this, f));
});
$c_Llaika_parse_text_PrefixedParser$$anon$1.prototype.collect__s_PartialFunction__F1__Llaika_parse_Parser = (function(f, error) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__collect__s_PartialFunction__F1__Llaika_parse_text_PrefixedParser(this, f, error));
});
$c_Llaika_parse_text_PrefixedParser$$anon$1.prototype.$bar__T__s_$less$colon$less__Llaika_parse_Parser = (function(value, ev) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$bar__T__s_$less$colon$less__Llaika_parse_text_PrefixedParser(this, value, ev));
});
$c_Llaika_parse_text_PrefixedParser$$anon$1.prototype.withCursor__Llaika_parse_Parser = (function() {
  var this$1 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = this.Llaika_parse_text_PrefixedParser$$anon$1__f_sc$1;
  var p = $c_Llaika_parse_Parser.prototype.withCursor__Llaika_parse_Parser.call(this);
  return new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p, this$1);
});
$c_Llaika_parse_text_PrefixedParser$$anon$1.prototype.source__Llaika_parse_Parser = (function() {
  var this$1 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = this.Llaika_parse_text_PrefixedParser$$anon$1__f_sc$1;
  var p = $c_Llaika_parse_Parser.prototype.source__Llaika_parse_Parser.call(this);
  return new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p, this$1);
});
var $d_Llaika_parse_text_PrefixedParser$$anon$1 = new $TypeData().initClass($c_Llaika_parse_text_PrefixedParser$$anon$1, "laika.parse.text.PrefixedParser$$anon$1", ({
  Llaika_parse_text_PrefixedParser$$anon$1: 1,
  Llaika_parse_Parser: 1,
  Llaika_parse_text_PrefixedParser: 1
}));
/** @constructor */
function $c_Llaika_parse_text_PrefixedParser$$anon$2(char$2, chars$2, p$4, outer) {
  this.Llaika_parse_text_PrefixedParser$$anon$2__f_char$1 = 0;
  this.Llaika_parse_text_PrefixedParser$$anon$2__f_chars$1 = null;
  this.Llaika_parse_text_PrefixedParser$$anon$2__f_p$2 = null;
  this.Llaika_parse_text_PrefixedParser$$anon$2__f_char$1 = char$2;
  this.Llaika_parse_text_PrefixedParser$$anon$2__f_chars$1 = chars$2;
  this.Llaika_parse_text_PrefixedParser$$anon$2__f_p$2 = p$4;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_parse_text_PrefixedParser$$anon$2.prototype = new $h_Llaika_parse_Parser();
$c_Llaika_parse_text_PrefixedParser$$anon$2.prototype.constructor = $c_Llaika_parse_text_PrefixedParser$$anon$2;
/** @constructor */
function $h_Llaika_parse_text_PrefixedParser$$anon$2() {
}
$h_Llaika_parse_text_PrefixedParser$$anon$2.prototype = $c_Llaika_parse_text_PrefixedParser$$anon$2.prototype;
$c_Llaika_parse_text_PrefixedParser$$anon$2.prototype.parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed = (function(in$1) {
  return $n(this.Llaika_parse_text_PrefixedParser$$anon$2__f_p$2).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(in$1);
});
$c_Llaika_parse_text_PrefixedParser$$anon$2.prototype.collect$default$2__F1 = (function() {
  return $f_Llaika_parse_text_PrefixedParser__collect$default$2__F1(this);
});
$c_Llaika_parse_text_PrefixedParser$$anon$2.prototype.startChars__O = (function() {
  return $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet).of__O__sci_Seq__Lcats_kernel_Order__O($bC(this.Llaika_parse_text_PrefixedParser$$anon$2__f_char$1), this.Llaika_parse_text_PrefixedParser$$anon$2__f_chars$1, $m_Lcats_kernel_instances_char_package$().Lcats_kernel_instances_char_package$__f_catsKernelStdOrderForChar);
});
$c_Llaika_parse_text_PrefixedParser$$anon$2.prototype.underlying__Llaika_parse_Parser = (function() {
  return this.Llaika_parse_text_PrefixedParser$$anon$2__f_p$2;
});
$c_Llaika_parse_text_PrefixedParser$$anon$2.prototype.$tilde__Llaika_parse_Parser__Llaika_parse_Parser = (function(p) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this, p));
});
$c_Llaika_parse_text_PrefixedParser$$anon$2.prototype.$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser = (function(p) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$tilde$greater__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this, p));
});
$c_Llaika_parse_text_PrefixedParser$$anon$2.prototype.$less$tilde__Llaika_parse_Parser__Llaika_parse_Parser = (function(p) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$less$tilde__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser(this, p));
});
$c_Llaika_parse_text_PrefixedParser$$anon$2.prototype.$tilde__T__Llaika_parse_Parser = (function(value) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$tilde__T__Llaika_parse_text_PrefixedParser(this, value));
});
$c_Llaika_parse_text_PrefixedParser$$anon$2.prototype.$less$tilde__T__Llaika_parse_Parser = (function(value) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$less$tilde__T__Llaika_parse_text_PrefixedParser(this, value));
});
$c_Llaika_parse_text_PrefixedParser$$anon$2.prototype.flatMap__F1__Llaika_parse_Parser = (function(f) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__flatMap__F1__Llaika_parse_text_PrefixedParser(this, f));
});
$c_Llaika_parse_text_PrefixedParser$$anon$2.prototype.$greater$greater__F1__Llaika_parse_Parser = (function(fq) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$greater$greater__F1__Llaika_parse_text_PrefixedParser(this, fq));
});
$c_Llaika_parse_text_PrefixedParser$$anon$2.prototype.map__F1__Llaika_parse_Parser = (function(f) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser(this, f));
});
$c_Llaika_parse_text_PrefixedParser$$anon$2.prototype.$up$up__F1__Llaika_parse_Parser = (function(f) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$up$up__F1__Llaika_parse_text_PrefixedParser(this, f));
});
$c_Llaika_parse_text_PrefixedParser$$anon$2.prototype.as__F0__Llaika_parse_Parser = (function(v) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__as__F0__Llaika_parse_text_PrefixedParser(this, v));
});
$c_Llaika_parse_text_PrefixedParser$$anon$2.prototype.evalMap__F1__Llaika_parse_Parser = (function(f) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__evalMap__F1__Llaika_parse_text_PrefixedParser(this, f));
});
$c_Llaika_parse_text_PrefixedParser$$anon$2.prototype.collect__s_PartialFunction__F1__Llaika_parse_Parser = (function(f, error) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__collect__s_PartialFunction__F1__Llaika_parse_text_PrefixedParser(this, f, error));
});
$c_Llaika_parse_text_PrefixedParser$$anon$2.prototype.$bar__T__s_$less$colon$less__Llaika_parse_Parser = (function(value, ev) {
  return $as_Llaika_parse_Parser($f_Llaika_parse_text_PrefixedParser__$bar__T__s_$less$colon$less__Llaika_parse_text_PrefixedParser(this, value, ev));
});
$c_Llaika_parse_text_PrefixedParser$$anon$2.prototype.withCursor__Llaika_parse_Parser = (function() {
  var this$1 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = this.startChars__O();
  var p = $c_Llaika_parse_Parser.prototype.withCursor__Llaika_parse_Parser.call(this);
  return new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p, this$1);
});
$c_Llaika_parse_text_PrefixedParser$$anon$2.prototype.source__Llaika_parse_Parser = (function() {
  var this$1 = $m_Llaika_parse_text_PrefixedParser$();
  var sc = this.startChars__O();
  var p = $c_Llaika_parse_Parser.prototype.source__Llaika_parse_Parser.call(this);
  return new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p, this$1);
});
var $d_Llaika_parse_text_PrefixedParser$$anon$2 = new $TypeData().initClass($c_Llaika_parse_text_PrefixedParser$$anon$2, "laika.parse.text.PrefixedParser$$anon$2", ({
  Llaika_parse_text_PrefixedParser$$anon$2: 1,
  Llaika_parse_Parser: 1,
  Llaika_parse_text_PrefixedParser: 1
}));
/** @constructor */
function $c_Llaika_parse_text_TextDelimiter$() {
}
$c_Llaika_parse_text_TextDelimiter$.prototype = new $h_O();
$c_Llaika_parse_text_TextDelimiter$.prototype.constructor = $c_Llaika_parse_text_TextDelimiter$;
/** @constructor */
function $h_Llaika_parse_text_TextDelimiter$() {
}
$h_Llaika_parse_text_TextDelimiter$.prototype = $c_Llaika_parse_text_TextDelimiter$.prototype;
$c_Llaika_parse_text_TextDelimiter$.prototype.$lessinit$greater$default$5__sci_Set = (function() {
  var this$1 = $m_sci_Set$();
  var elems = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
  return this$1.from__sc_IterableOnce__sci_Set(elems);
});
$c_Llaika_parse_text_TextDelimiter$.prototype.apply__Llaika_parse_text_PrefixedParser__Llaika_parse_text_TextDelimiter = (function(parser) {
  var parser$1 = new $c_s_Some(parser);
  var failOn = this.$lessinit$greater$default$5__sci_Set();
  return new $c_Llaika_parse_text_TextDelimiter(parser$1, false, false, false, failOn);
});
var $d_Llaika_parse_text_TextDelimiter$ = new $TypeData().initClass($c_Llaika_parse_text_TextDelimiter$, "laika.parse.text.TextDelimiter$", ({
  Llaika_parse_text_TextDelimiter$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_parse_text_TextDelimiter$;
function $m_Llaika_parse_text_TextDelimiter$() {
  if ((!$n_Llaika_parse_text_TextDelimiter$)) {
    $n_Llaika_parse_text_TextDelimiter$ = new $c_Llaika_parse_text_TextDelimiter$();
  }
  return $n_Llaika_parse_text_TextDelimiter$;
}
/** @constructor */
function $c_Llaika_parse_text_TextParsers$() {
  this.Llaika_parse_text_TextParsers$__f_ws$lzy1 = null;
  this.Llaika_parse_text_TextParsers$__f_wsbitmap$1 = false;
  this.Llaika_parse_text_TextParsers$__f_eol = null;
  this.Llaika_parse_text_TextParsers$__f_wsEol = null;
  this.Llaika_parse_text_TextParsers$__f_eof = null;
  this.Llaika_parse_text_TextParsers$__f_blankLine = null;
  this.Llaika_parse_text_TextParsers$__f_blankLines = null;
  this.Llaika_parse_text_TextParsers$__f_restOfLine = null;
  this.Llaika_parse_text_TextParsers$__f_anyChars = null;
  this.Llaika_parse_text_TextParsers$__f_oneChar = null;
  $n_Llaika_parse_text_TextParsers$ = this;
  $f_Llaika_parse_text_TextParsers__$init$__V(this);
}
$c_Llaika_parse_text_TextParsers$.prototype = new $h_O();
$c_Llaika_parse_text_TextParsers$.prototype.constructor = $c_Llaika_parse_text_TextParsers$;
/** @constructor */
function $h_Llaika_parse_text_TextParsers$() {
}
$h_Llaika_parse_text_TextParsers$.prototype = $c_Llaika_parse_text_TextParsers$.prototype;
$c_Llaika_parse_text_TextParsers$.prototype.ws__Llaika_parse_text_Characters = (function() {
  if ((!this.Llaika_parse_text_TextParsers$__f_wsbitmap$1)) {
    this.Llaika_parse_text_TextParsers$__f_ws$lzy1 = $f_Llaika_parse_text_TextParsers__ws__Llaika_parse_text_Characters(this);
    this.Llaika_parse_text_TextParsers$__f_wsbitmap$1 = true;
  }
  return this.Llaika_parse_text_TextParsers$__f_ws$lzy1;
});
$c_Llaika_parse_text_TextParsers$.prototype.eol__Llaika_parse_Parser = (function() {
  return this.Llaika_parse_text_TextParsers$__f_eol;
});
$c_Llaika_parse_text_TextParsers$.prototype.wsEol__Llaika_parse_Parser = (function() {
  return this.Llaika_parse_text_TextParsers$__f_wsEol;
});
$c_Llaika_parse_text_TextParsers$.prototype.eof__Llaika_parse_Parser = (function() {
  return this.Llaika_parse_text_TextParsers$__f_eof;
});
$c_Llaika_parse_text_TextParsers$.prototype.blankLine__Llaika_parse_Parser = (function() {
  return this.Llaika_parse_text_TextParsers$__f_blankLine;
});
$c_Llaika_parse_text_TextParsers$.prototype.restOfLine__Llaika_parse_Parser = (function() {
  return this.Llaika_parse_text_TextParsers$__f_restOfLine;
});
$c_Llaika_parse_text_TextParsers$.prototype.anyChars__Llaika_parse_text_Characters = (function() {
  return this.Llaika_parse_text_TextParsers$__f_anyChars;
});
$c_Llaika_parse_text_TextParsers$.prototype.laika$parse$text$TextParsers$_setter_$eol_$eq__Llaika_parse_Parser__V = (function(x$0) {
  this.Llaika_parse_text_TextParsers$__f_eol = x$0;
});
$c_Llaika_parse_text_TextParsers$.prototype.laika$parse$text$TextParsers$_setter_$wsEol_$eq__Llaika_parse_Parser__V = (function(x$0) {
  this.Llaika_parse_text_TextParsers$__f_wsEol = x$0;
});
$c_Llaika_parse_text_TextParsers$.prototype.laika$parse$text$TextParsers$_setter_$eof_$eq__Llaika_parse_Parser__V = (function(x$0) {
  this.Llaika_parse_text_TextParsers$__f_eof = x$0;
});
$c_Llaika_parse_text_TextParsers$.prototype.laika$parse$text$TextParsers$_setter_$atStart_$eq__Llaika_parse_Parser__V = (function(x$0) {
});
$c_Llaika_parse_text_TextParsers$.prototype.laika$parse$text$TextParsers$_setter_$blankLine_$eq__Llaika_parse_Parser__V = (function(x$0) {
  this.Llaika_parse_text_TextParsers$__f_blankLine = x$0;
});
$c_Llaika_parse_text_TextParsers$.prototype.laika$parse$text$TextParsers$_setter_$blankLines_$eq__Llaika_parse_Parser__V = (function(x$0) {
  this.Llaika_parse_text_TextParsers$__f_blankLines = x$0;
});
$c_Llaika_parse_text_TextParsers$.prototype.laika$parse$text$TextParsers$_setter_$restOfLine_$eq__Llaika_parse_Parser__V = (function(x$0) {
  this.Llaika_parse_text_TextParsers$__f_restOfLine = x$0;
});
$c_Llaika_parse_text_TextParsers$.prototype.laika$parse$text$TextParsers$_setter_$textLine_$eq__Llaika_parse_Parser__V = (function(x$0) {
});
$c_Llaika_parse_text_TextParsers$.prototype.laika$parse$text$TextParsers$_setter_$anyChars_$eq__Llaika_parse_text_Characters__V = (function(x$0) {
  this.Llaika_parse_text_TextParsers$__f_anyChars = x$0;
});
$c_Llaika_parse_text_TextParsers$.prototype.laika$parse$text$TextParsers$_setter_$oneChar_$eq__Llaika_parse_Parser__V = (function(x$0) {
  this.Llaika_parse_text_TextParsers$__f_oneChar = x$0;
});
var $d_Llaika_parse_text_TextParsers$ = new $TypeData().initClass($c_Llaika_parse_text_TextParsers$, "laika.parse.text.TextParsers$", ({
  Llaika_parse_text_TextParsers$: 1,
  Llaika_parse_combinator_Parsers: 1,
  Llaika_parse_text_TextParsers: 1
}));
var $n_Llaika_parse_text_TextParsers$;
function $m_Llaika_parse_text_TextParsers$() {
  if ((!$n_Llaika_parse_text_TextParsers$)) {
    $n_Llaika_parse_text_TextParsers$ = new $c_Llaika_parse_text_TextParsers$();
  }
  return $n_Llaika_parse_text_TextParsers$;
}
/** @constructor */
function $c_s_$less$colon$less() {
}
$c_s_$less$colon$less.prototype = new $h_O();
$c_s_$less$colon$less.prototype.constructor = $c_s_$less$colon$less;
/** @constructor */
function $h_s_$less$colon$less() {
}
$h_s_$less$colon$less.prototype = $c_s_$less$colon$less.prototype;
$c_s_$less$colon$less.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(v1);
});
/** @constructor */
function $c_s_Predef$() {
  this.s_Predef$__f_Map = null;
  this.s_Predef$__f_Set = null;
  $n_s_Predef$ = this;
  this.s_Predef$__f_Map = $m_sci_Map$();
  this.s_Predef$__f_Set = $m_sci_Set$();
}
$c_s_Predef$.prototype = new $h_s_LowPriorityImplicits();
$c_s_Predef$.prototype.constructor = $c_s_Predef$;
/** @constructor */
function $h_s_Predef$() {
}
$h_s_Predef$.prototype = $c_s_Predef$.prototype;
$c_s_Predef$.prototype.assert__Z__V = (function(assertion) {
  if ((!assertion)) {
    throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "assertion failed");
  }
});
$c_s_Predef$.prototype.require__Z__V = (function(requirement) {
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed");
  }
});
$c_s_Predef$.prototype.$qmark$qmark$qmark__E = (function() {
  throw new $c_s_NotImplementedError();
});
var $d_s_Predef$ = new $TypeData().initClass($c_s_Predef$, "scala.Predef$", ({
  s_Predef$: 1,
  s_LowPriorityImplicits: 1,
  s_LowPriorityImplicits2: 1
}));
var $n_s_Predef$;
function $m_s_Predef$() {
  if ((!$n_s_Predef$)) {
    $n_s_Predef$ = new $c_s_Predef$();
  }
  return $n_s_Predef$;
}
function $f_s_Product2__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz._1__O();
      break;
    }
    case 1: {
      return $thiz._2__O();
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 1)"));
    }
  }
}
function $f_s_Product3__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T3__f__1;
      break;
    }
    case 1: {
      return $thiz.T3__f__2;
      break;
    }
    case 2: {
      return $thiz.T3__f__3;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 2)"));
    }
  }
}
function $f_s_Product4__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T4__f__1;
      break;
    }
    case 1: {
      return $thiz.T4__f__2;
      break;
    }
    case 2: {
      return $thiz.T4__f__3;
      break;
    }
    case 3: {
      return $thiz.T4__f__4;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 3)"));
    }
  }
}
function $f_s_Product5__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T5__f__1;
      break;
    }
    case 1: {
      return $thiz.T5__f__2;
      break;
    }
    case 2: {
      return $thiz.T5__f__3;
      break;
    }
    case 3: {
      return $thiz.T5__f__4;
      break;
    }
    case 4: {
      return $thiz.T5__f__5;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 4)"));
    }
  }
}
function $f_s_Product6__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T6__f__1;
      break;
    }
    case 1: {
      return $thiz.T6__f__2;
      break;
    }
    case 2: {
      return $thiz.T6__f__3;
      break;
    }
    case 3: {
      return $thiz.T6__f__4;
      break;
    }
    case 4: {
      return $thiz.T6__f__5;
      break;
    }
    case 5: {
      return $thiz.T6__f__6;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 5)"));
    }
  }
}
function $f_s_Product7__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T7__f__1;
      break;
    }
    case 1: {
      return $thiz.T7__f__2;
      break;
    }
    case 2: {
      return $thiz.T7__f__3;
      break;
    }
    case 3: {
      return $thiz.T7__f__4;
      break;
    }
    case 4: {
      return $thiz.T7__f__5;
      break;
    }
    case 5: {
      return $thiz.T7__f__6;
      break;
    }
    case 6: {
      return $thiz.T7__f__7;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 6)"));
    }
  }
}
function $ct_sc_ClassTagIterableFactory$AnyIterableDelegate__sc_ClassTagIterableFactory__($thiz, delegate) {
  $thiz.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate = delegate;
  return $thiz;
}
/** @constructor */
function $c_sc_ClassTagIterableFactory$AnyIterableDelegate() {
  this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate = null;
}
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype = new $h_O();
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.constructor = $c_sc_ClassTagIterableFactory$AnyIterableDelegate;
/** @constructor */
function $h_sc_ClassTagIterableFactory$AnyIterableDelegate() {
}
$h_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype = $c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype;
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.empty__O = (function() {
  return $n(this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate).empty__O__O($m_s_reflect_ManifestFactory$AnyManifest$());
});
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.from__sc_IterableOnce__O = (function(it) {
  return $n(this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate).from__sc_IterableOnce__O__O(it, $m_s_reflect_ManifestFactory$AnyManifest$());
});
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.newBuilder__scm_Builder = (function() {
  var this$1 = $n(this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate);
  var evidence$12 = $m_s_reflect_ManifestFactory$AnyManifest$();
  return this$1.newBuilder__s_reflect_ClassTag__scm_Builder(evidence$12);
});
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.apply__sci_Seq__O = (function(elems) {
  var this$1 = $n(this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate);
  var evidence$7 = $m_s_reflect_ManifestFactory$AnyManifest$();
  return this$1.from__sc_IterableOnce__O__O(elems, evidence$7);
});
function $ct_sc_EvidenceIterableFactory$Delegate__sc_EvidenceIterableFactory__($thiz, delegate) {
  $thiz.sc_EvidenceIterableFactory$Delegate__f_delegate = delegate;
  return $thiz;
}
/** @constructor */
function $c_sc_EvidenceIterableFactory$Delegate() {
  this.sc_EvidenceIterableFactory$Delegate__f_delegate = null;
}
$c_sc_EvidenceIterableFactory$Delegate.prototype = new $h_O();
$c_sc_EvidenceIterableFactory$Delegate.prototype.constructor = $c_sc_EvidenceIterableFactory$Delegate;
/** @constructor */
function $h_sc_EvidenceIterableFactory$Delegate() {
}
$h_sc_EvidenceIterableFactory$Delegate.prototype = $c_sc_EvidenceIterableFactory$Delegate.prototype;
$c_sc_EvidenceIterableFactory$Delegate.prototype.apply__sci_Seq__O__O = (function(xs, evidence$18) {
  return $n(this.sc_EvidenceIterableFactory$Delegate__f_delegate).apply__sci_Seq__O__O(xs, evidence$18);
});
$c_sc_EvidenceIterableFactory$Delegate.prototype.newBuilder__O__scm_Builder = (function(evidence$21) {
  return $n(this.sc_EvidenceIterableFactory$Delegate__f_delegate).newBuilder__O__scm_Builder(evidence$21);
});
function $ct_sc_IterableFactory$Delegate__sc_IterableFactory__($thiz, delegate) {
  $thiz.sc_IterableFactory$Delegate__f_delegate = delegate;
  return $thiz;
}
/** @constructor */
function $c_sc_IterableFactory$Delegate() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
}
$c_sc_IterableFactory$Delegate.prototype = new $h_O();
$c_sc_IterableFactory$Delegate.prototype.constructor = $c_sc_IterableFactory$Delegate;
/** @constructor */
function $h_sc_IterableFactory$Delegate() {
}
$h_sc_IterableFactory$Delegate.prototype = $c_sc_IterableFactory$Delegate.prototype;
$c_sc_IterableFactory$Delegate.prototype.apply__sci_Seq__O = (function(elems) {
  return $n(this.sc_IterableFactory$Delegate__f_delegate).apply__sci_Seq__O(elems);
});
$c_sc_IterableFactory$Delegate.prototype.empty__O = (function() {
  return $n(this.sc_IterableFactory$Delegate__f_delegate).empty__O();
});
$c_sc_IterableFactory$Delegate.prototype.from__sc_IterableOnce__O = (function(it) {
  return $n(this.sc_IterableFactory$Delegate__f_delegate).from__sc_IterableOnce__O(it);
});
$c_sc_IterableFactory$Delegate.prototype.newBuilder__scm_Builder = (function() {
  return $n(this.sc_IterableFactory$Delegate__f_delegate).newBuilder__scm_Builder();
});
/** @constructor */
function $c_sc_IterableFactory$ToFactory(factory) {
  this.sc_IterableFactory$ToFactory__f_factory = null;
  this.sc_IterableFactory$ToFactory__f_factory = factory;
}
$c_sc_IterableFactory$ToFactory.prototype = new $h_O();
$c_sc_IterableFactory$ToFactory.prototype.constructor = $c_sc_IterableFactory$ToFactory;
/** @constructor */
function $h_sc_IterableFactory$ToFactory() {
}
$h_sc_IterableFactory$ToFactory.prototype = $c_sc_IterableFactory$ToFactory.prototype;
$c_sc_IterableFactory$ToFactory.prototype.fromSpecific__sc_IterableOnce__O = (function(it) {
  return $n(this.sc_IterableFactory$ToFactory__f_factory).from__sc_IterableOnce__O(it);
});
var $d_sc_IterableFactory$ToFactory = new $TypeData().initClass($c_sc_IterableFactory$ToFactory, "scala.collection.IterableFactory$ToFactory", ({
  sc_IterableFactory$ToFactory: 1,
  sc_Factory: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_IterableOnceOps$$anon$1(outer) {
}
$c_sc_IterableOnceOps$$anon$1.prototype = new $h_sr_AbstractFunction1();
$c_sc_IterableOnceOps$$anon$1.prototype.constructor = $c_sc_IterableOnceOps$$anon$1;
/** @constructor */
function $h_sc_IterableOnceOps$$anon$1() {
}
$h_sc_IterableOnceOps$$anon$1.prototype = $c_sc_IterableOnceOps$$anon$1.prototype;
$c_sc_IterableOnceOps$$anon$1.prototype.apply__O__O = (function(v1) {
  return this;
});
var $d_sc_IterableOnceOps$$anon$1 = new $TypeData().initClass($c_sc_IterableOnceOps$$anon$1, "scala.collection.IterableOnceOps$$anon$1", ({
  sc_IterableOnceOps$$anon$1: 1,
  sr_AbstractFunction1: 1,
  F1: 1
}));
/** @constructor */
function $c_sc_IterableOnceOps$Maximized(outer, descriptor, f, cmp) {
  this.sc_IterableOnceOps$Maximized__f_descriptor = null;
  this.sc_IterableOnceOps$Maximized__f_f = null;
  this.sc_IterableOnceOps$Maximized__f_cmp = null;
  this.sc_IterableOnceOps$Maximized__f_maxElem = null;
  this.sc_IterableOnceOps$Maximized__f_maxF = null;
  this.sc_IterableOnceOps$Maximized__f_nonEmpty = false;
  this.sc_IterableOnceOps$Maximized__f_descriptor = descriptor;
  this.sc_IterableOnceOps$Maximized__f_f = f;
  this.sc_IterableOnceOps$Maximized__f_cmp = cmp;
  $n(outer);
  this.sc_IterableOnceOps$Maximized__f_maxElem = null;
  this.sc_IterableOnceOps$Maximized__f_maxF = null;
  this.sc_IterableOnceOps$Maximized__f_nonEmpty = false;
}
$c_sc_IterableOnceOps$Maximized.prototype = new $h_sr_AbstractFunction2();
$c_sc_IterableOnceOps$Maximized.prototype.constructor = $c_sc_IterableOnceOps$Maximized;
/** @constructor */
function $h_sc_IterableOnceOps$Maximized() {
}
$h_sc_IterableOnceOps$Maximized.prototype = $c_sc_IterableOnceOps$Maximized.prototype;
$c_sc_IterableOnceOps$Maximized.prototype.result__O = (function() {
  if (this.sc_IterableOnceOps$Maximized__f_nonEmpty) {
    return this.sc_IterableOnceOps$Maximized__f_maxElem;
  } else {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), ("empty." + this.sc_IterableOnceOps$Maximized__f_descriptor));
  }
});
$c_sc_IterableOnceOps$Maximized.prototype.apply__sc_IterableOnceOps$Maximized__O__sc_IterableOnceOps$Maximized = (function(m, a) {
  if ($n(m).sc_IterableOnceOps$Maximized__f_nonEmpty) {
    var fa = $n(this.sc_IterableOnceOps$Maximized__f_f).apply__O__O(a);
    if ($uZ($n(this.sc_IterableOnceOps$Maximized__f_cmp).apply__O__O__O(fa, this.sc_IterableOnceOps$Maximized__f_maxF))) {
      this.sc_IterableOnceOps$Maximized__f_maxF = fa;
      this.sc_IterableOnceOps$Maximized__f_maxElem = a;
    }
    return m;
  } else {
    $n(m).sc_IterableOnceOps$Maximized__f_nonEmpty = true;
    $n(m).sc_IterableOnceOps$Maximized__f_maxElem = a;
    $n(m).sc_IterableOnceOps$Maximized__f_maxF = $n(this.sc_IterableOnceOps$Maximized__f_f).apply__O__O(a);
    return m;
  }
});
$c_sc_IterableOnceOps$Maximized.prototype.apply__O__O__O = (function(v1, v2) {
  return this.apply__sc_IterableOnceOps$Maximized__O__sc_IterableOnceOps$Maximized($as_sc_IterableOnceOps$Maximized(v1), v2);
});
function $as_sc_IterableOnceOps$Maximized(obj) {
  return (((obj instanceof $c_sc_IterableOnceOps$Maximized) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IterableOnceOps$Maximized"));
}
function $isArrayOf_sc_IterableOnceOps$Maximized(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IterableOnceOps$Maximized)));
}
function $asArrayOf_sc_IterableOnceOps$Maximized(obj, depth) {
  return (($isArrayOf_sc_IterableOnceOps$Maximized(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IterableOnceOps$Maximized;", depth));
}
var $d_sc_IterableOnceOps$Maximized = new $TypeData().initClass($c_sc_IterableOnceOps$Maximized, "scala.collection.IterableOnceOps$Maximized", ({
  sc_IterableOnceOps$Maximized: 1,
  sr_AbstractFunction2: 1,
  F2: 1
}));
function $f_sc_IterableOps__headOption__s_Option($thiz) {
  var it = $thiz.iterator__sc_Iterator();
  return ($n(it).hasNext__Z() ? new $c_s_Some($n(it).next__O()) : $m_s_None$());
}
function $f_sc_IterableOps__last__O($thiz) {
  var it = $thiz.iterator__sc_Iterator();
  var lst = $n(it).next__O();
  while ($n(it).hasNext__Z()) {
    lst = $n(it).next__O();
  }
  return lst;
}
function $f_sc_IterableOps__lastOption__s_Option($thiz) {
  return ($thiz.isEmpty__Z() ? $m_s_None$() : new $c_s_Some($thiz.last__O()));
}
function $f_sc_IterableOps__sizeCompare__I__I($thiz, otherSize) {
  if ((otherSize < 0)) {
    return 1;
  } else {
    var known = $thiz.knownSize__I();
    if ((known >= 0)) {
      return ((known === otherSize) ? 0 : ((known < otherSize) ? (-1) : 1));
    } else {
      var i = 0;
      var it = $thiz.iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        if ((i === otherSize)) {
          return 1;
        }
        $n(it).next__O();
        i = ((1 + i) | 0);
      }
      return ((i - otherSize) | 0);
    }
  }
}
function $f_sc_IterableOps__filter__F1__O($thiz, pred) {
  return $thiz.fromSpecific__sc_IterableOnce__O(new $c_sc_View$Filter($thiz, pred, false));
}
function $f_sc_IterableOps__filterNot__F1__O($thiz, pred) {
  return $thiz.fromSpecific__sc_IterableOnce__O(new $c_sc_View$Filter($thiz, pred, true));
}
function $f_sc_IterableOps__partition__F1__T2($thiz, p) {
  var first = new $c_sc_View$Filter($thiz, p, false);
  var second = new $c_sc_View$Filter($thiz, p, true);
  return new $c_T2($thiz.fromSpecific__sc_IterableOnce__O(first), $thiz.fromSpecific__sc_IterableOnce__O(second));
}
function $f_sc_IterableOps__splitAt__I__T2($thiz, n) {
  return new $c_T2($thiz.take__I__O(n), $thiz.drop__I__O(n));
}
function $f_sc_IterableOps__take__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_View$Take__sc_IterableOps__I__(new $c_sc_View$Take(), $thiz, n));
}
function $f_sc_IterableOps__takeWhile__F1__O($thiz, p) {
  return $thiz.fromSpecific__sc_IterableOnce__O(new $c_sc_View$TakeWhile($thiz, p));
}
function $f_sc_IterableOps__span__F1__T2($thiz, p) {
  return new $c_T2($thiz.takeWhile__F1__O(p), $thiz.dropWhile__F1__O(p));
}
function $f_sc_IterableOps__drop__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_View$Drop__sc_IterableOps__I__(new $c_sc_View$Drop(), $thiz, n));
}
function $f_sc_IterableOps__dropRight__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_View$DropRight__sc_IterableOps__I__(new $c_sc_View$DropRight(), $thiz, n));
}
function $f_sc_IterableOps__dropWhile__F1__O($thiz, p) {
  return $thiz.fromSpecific__sc_IterableOnce__O(new $c_sc_View$DropWhile($thiz, p));
}
function $f_sc_IterableOps__sliding__I__I__sc_Iterator($thiz, size, step) {
  var this$1 = $n($thiz.iterator__sc_Iterator());
  var this$3 = new $c_sc_Iterator$GroupedIterator(this$1, this$1, size, step);
  var f = new $c_sjsr_AnonFunction1(((coll$2) => {
    var coll = $as_sc_IterableOnce(coll$2);
    return $thiz.fromSpecific__sc_IterableOnce__O(coll);
  }));
  return new $c_sc_Iterator$$anon$9(this$3, f);
}
function $f_sc_IterableOps__tail__O($thiz) {
  if ($thiz.isEmpty__Z()) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  return $thiz.drop__I__O(1);
}
function $f_sc_IterableOps__init__O($thiz) {
  if ($thiz.isEmpty__Z()) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  return $thiz.dropRight__I__O(1);
}
function $f_sc_IterableOps__map__F1__O($thiz, f) {
  return $n($thiz.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O($ct_sc_View$Map__sc_IterableOps__F1__(new $c_sc_View$Map(), $thiz, f));
}
function $f_sc_IterableOps__flatMap__F1__O($thiz, f) {
  return $n($thiz.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O(new $c_sc_View$FlatMap($thiz, f));
}
function $f_sc_IterableOps__collect__s_PartialFunction__O($thiz, pf) {
  return $n($thiz.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O(new $c_sc_View$Collect($thiz, pf));
}
function $f_sc_IterableOps__concat__sc_IterableOnce__O($thiz, suffix) {
  var $x_2 = $n($thiz.iterableFactory__sc_IterableFactory());
  if ($is_sc_Iterable(suffix)) {
    var x2 = $as_sc_Iterable(suffix);
    var $x_1 = new $c_sc_View$Concat($thiz, x2);
  } else {
    var this$2 = $n($thiz.iterator__sc_Iterator());
    var xs = new $c_sjsr_AnonFunction0((() => $n(suffix).iterator__sc_Iterator()));
    var $x_1 = this$2.concat__F0__sc_Iterator(xs);
  }
  return $n($x_2).from__sc_IterableOnce__O($x_1);
}
function $f_sc_IterableOps__zip__sc_IterableOnce__O($thiz, that) {
  var $x_2 = $n($thiz.iterableFactory__sc_IterableFactory());
  if ($is_sc_Iterable(that)) {
    var x2 = $as_sc_Iterable(that);
    var $x_1 = new $c_sc_View$Zip($thiz, x2);
  } else {
    var this$1 = $n($thiz.iterator__sc_Iterator());
    var $x_1 = new $c_sc_Iterator$$anon$14(this$1, that);
  }
  return $n($x_2).from__sc_IterableOnce__O($x_1);
}
function $f_sc_IterableOps__zipWithIndex__O($thiz) {
  return $n($thiz.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O(new $c_sc_View$ZipWithIndex($thiz));
}
function $is_sc_IterableOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IterableOps)));
}
function $as_sc_IterableOps(obj) {
  return (($is_sc_IterableOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IterableOps"));
}
function $isArrayOf_sc_IterableOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IterableOps)));
}
function $asArrayOf_sc_IterableOps(obj, depth) {
  return (($isArrayOf_sc_IterableOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IterableOps;", depth));
}
function $f_sc_Iterator__partition__F1__T2($thiz, p) {
  var x1 = $f_sc_Iterator__duplicate__T2($thiz);
  if ((x1 === null)) {
    throw new $c_s_MatchError(x1);
  }
  var a = $as_sc_Iterator($n(x1)._1__O());
  var b = $as_sc_Iterator($n(x1)._2__O());
  var this$1 = $n(a);
  var $x_1 = new $c_sc_Iterator$$anon$6(this$1, p, false);
  var this$2 = $n(b);
  return new $c_T2($x_1, new $c_sc_Iterator$$anon$6(this$2, p, true));
}
function $f_sc_Iterator__indexWhere__F1__I__I($thiz, p, from) {
  var i = ((from > 0) ? from : 0);
  var dropped = $thiz.drop__I__sc_Iterator(from);
  while ($n(dropped).hasNext__Z()) {
    if ($uZ($n(p).apply__O__O($n(dropped).next__O()))) {
      return i;
    }
    i = ((1 + i) | 0);
  }
  return (-1);
}
function $f_sc_Iterator__concat__F0__sc_Iterator($thiz, xs) {
  return new $c_sc_Iterator$ConcatIterator($thiz).concat__F0__sc_Iterator(xs);
}
function $f_sc_Iterator__take__I__sc_Iterator($thiz, n) {
  return $thiz.sliceIterator__I__I__sc_Iterator(0, ((n > 0) ? n : 0));
}
function $f_sc_Iterator__sliceIterator__I__I__sc_Iterator($thiz, from, until) {
  var lo = ((from > 0) ? from : 0);
  var rest = ((until < 0) ? (-1) : ((until <= lo) ? 0 : ((until - lo) | 0)));
  return ((rest === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sc_Iterator$SliceIterator($thiz, lo, rest));
}
function $f_sc_Iterator__sameElements__sc_IterableOnce__Z($thiz, that) {
  var those = $n(that).iterator__sc_Iterator();
  while (($thiz.hasNext__Z() && $n(those).hasNext__Z())) {
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z($thiz.next__O(), $n(those).next__O()))) {
      return false;
    }
  }
  return ($thiz.hasNext__Z() === $n(those).hasNext__Z());
}
function $f_sc_Iterator__duplicate__T2($thiz) {
  var gap = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
  var ahead = new $c_sr_ObjectRef(null);
  return new $c_T2(new $c_sc_Iterator$Partner$1($thiz, ahead, gap), new $c_sc_Iterator$Partner$1($thiz, ahead, gap));
}
function $is_sc_Iterator(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Iterator)));
}
function $as_sc_Iterator(obj) {
  return (($is_sc_Iterator(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Iterator"));
}
function $isArrayOf_sc_Iterator(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Iterator)));
}
function $asArrayOf_sc_Iterator(obj, depth) {
  return (($isArrayOf_sc_Iterator(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Iterator;", depth));
}
var $d_sc_Iterator = new $TypeData().initClass(1, "scala.collection.Iterator", ({
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_Iterator$() {
  this.sc_Iterator$__f_scala$collection$Iterator$$_empty = null;
  $n_sc_Iterator$ = this;
  this.sc_Iterator$__f_scala$collection$Iterator$$_empty = new $c_sc_Iterator$$anon$19();
}
$c_sc_Iterator$.prototype = new $h_O();
$c_sc_Iterator$.prototype.constructor = $c_sc_Iterator$;
/** @constructor */
function $h_sc_Iterator$() {
}
$h_sc_Iterator$.prototype = $c_sc_Iterator$.prototype;
$c_sc_Iterator$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sc_Iterator$$anon$21();
});
$c_sc_Iterator$.prototype.apply__sci_Seq__O = (function(elems) {
  return $n(elems).iterator__sc_Iterator();
});
$c_sc_Iterator$.prototype.empty__O = (function() {
  return this.sc_Iterator$__f_scala$collection$Iterator$$_empty;
});
$c_sc_Iterator$.prototype.from__sc_IterableOnce__O = (function(source) {
  return $n(source).iterator__sc_Iterator();
});
var $d_sc_Iterator$ = new $TypeData().initClass($c_sc_Iterator$, "scala.collection.Iterator$", ({
  sc_Iterator$: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sc_Iterator$;
function $m_sc_Iterator$() {
  if ((!$n_sc_Iterator$)) {
    $n_sc_Iterator$ = new $c_sc_Iterator$();
  }
  return $n_sc_Iterator$;
}
function $ct_sc_MapFactory$Delegate__sc_MapFactory__($thiz, delegate) {
  $thiz.sc_MapFactory$Delegate__f_delegate = delegate;
  return $thiz;
}
/** @constructor */
function $c_sc_MapFactory$Delegate() {
  this.sc_MapFactory$Delegate__f_delegate = null;
}
$c_sc_MapFactory$Delegate.prototype = new $h_O();
$c_sc_MapFactory$Delegate.prototype.constructor = $c_sc_MapFactory$Delegate;
/** @constructor */
function $h_sc_MapFactory$Delegate() {
}
$h_sc_MapFactory$Delegate.prototype = $c_sc_MapFactory$Delegate.prototype;
$c_sc_MapFactory$Delegate.prototype.apply__sci_Seq__O = (function(elems) {
  return $n(this.sc_MapFactory$Delegate__f_delegate).apply__sci_Seq__O(elems);
});
$c_sc_MapFactory$Delegate.prototype.from__sc_IterableOnce__O = (function(it) {
  return $n(this.sc_MapFactory$Delegate__f_delegate).from__sc_IterableOnce__O(it);
});
$c_sc_MapFactory$Delegate.prototype.empty__O = (function() {
  return $n(this.sc_MapFactory$Delegate__f_delegate).empty__O();
});
$c_sc_MapFactory$Delegate.prototype.newBuilder__scm_Builder = (function() {
  return $n(this.sc_MapFactory$Delegate__f_delegate).newBuilder__scm_Builder();
});
/** @constructor */
function $c_sc_View$() {
}
$c_sc_View$.prototype = new $h_O();
$c_sc_View$.prototype.constructor = $c_sc_View$;
/** @constructor */
function $h_sc_View$() {
}
$h_sc_View$.prototype = $c_sc_View$.prototype;
$c_sc_View$.prototype.from__sc_IterableOnce__sc_View = (function(it) {
  if ($is_sc_View(it)) {
    var x2 = $as_sc_View(it);
    return x2;
  } else if ($is_sc_Iterable(it)) {
    var x3 = $as_sc_Iterable(it);
    var it$1 = new $c_sjsr_AnonFunction0((() => $n(x3).iterator__sc_Iterator()));
    return new $c_sc_View$$anon$1(it$1);
  } else {
    var this$3 = $n($m_sci_LazyList$().from__sc_IterableOnce__sci_LazyList(it));
    return $ct_sc_SeqView$Id__sc_SeqOps__(new $c_sc_SeqView$Id(), this$3);
  }
});
$c_sc_View$.prototype.newBuilder__scm_Builder = (function() {
  $m_scm_ArrayBuffer$();
  var this$3 = new $c_scm_ArrayBuffer$$anon$1();
  var f = new $c_sjsr_AnonFunction1(((it$2) => {
    var it = $as_sc_IterableOnce(it$2);
    return $m_sc_View$().from__sc_IterableOnce__sc_View(it);
  }));
  return new $c_scm_Builder$$anon$1(this$3, f);
});
$c_sc_View$.prototype.dropRightIterator__sc_Iterator__I__sc_Iterator = (function(it, n) {
  if ((n <= 0)) {
    return it;
  } else {
    var k = $n(it).knownSize__I();
    return ((k >= 0) ? $n(it).take__I__sc_Iterator(((k - n) | 0)) : new $c_sc_View$DropRightIterator(it, n));
  }
});
$c_sc_View$.prototype.apply__sci_Seq__O = (function(elems) {
  return new $c_sc_View$Elems(elems);
});
$c_sc_View$.prototype.empty__O = (function() {
  return $m_sc_View$Empty$();
});
$c_sc_View$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sc_View(source);
});
var $d_sc_View$ = new $TypeData().initClass($c_sc_View$, "scala.collection.View$", ({
  sc_View$: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sc_View$;
function $m_sc_View$() {
  if ((!$n_sc_View$)) {
    $n_sc_View$ = new $c_sc_View$();
  }
  return $n_sc_View$;
}
/** @constructor */
function $c_sci_BitmapIndexedMapNode(dataMap, nodeMap, content, originalHashes, size, cachedJavaKeySetHashCode) {
  this.sci_BitmapIndexedMapNode__f_dataMap = 0;
  this.sci_BitmapIndexedMapNode__f_nodeMap = 0;
  this.sci_BitmapIndexedMapNode__f_content = null;
  this.sci_BitmapIndexedMapNode__f_originalHashes = null;
  this.sci_BitmapIndexedMapNode__f_size = 0;
  this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = 0;
  this.sci_BitmapIndexedMapNode__f_dataMap = dataMap;
  this.sci_BitmapIndexedMapNode__f_nodeMap = nodeMap;
  this.sci_BitmapIndexedMapNode__f_content = content;
  this.sci_BitmapIndexedMapNode__f_originalHashes = originalHashes;
  this.sci_BitmapIndexedMapNode__f_size = size;
  this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = cachedJavaKeySetHashCode;
}
$c_sci_BitmapIndexedMapNode.prototype = new $h_sci_MapNode();
$c_sci_BitmapIndexedMapNode.prototype.constructor = $c_sci_BitmapIndexedMapNode;
/** @constructor */
function $h_sci_BitmapIndexedMapNode() {
}
$h_sci_BitmapIndexedMapNode.prototype = $c_sci_BitmapIndexedMapNode.prototype;
$c_sci_BitmapIndexedMapNode.prototype.size__I = (function() {
  return this.sci_BitmapIndexedMapNode__f_size;
});
$c_sci_BitmapIndexedMapNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode;
});
$c_sci_BitmapIndexedMapNode.prototype.getKey__I__O = (function(index) {
  return $n(this.sci_BitmapIndexedMapNode__f_content).get((index << 1));
});
$c_sci_BitmapIndexedMapNode.prototype.getValue__I__O = (function(index) {
  return $n(this.sci_BitmapIndexedMapNode__f_content).get(((1 + (index << 1)) | 0));
});
$c_sci_BitmapIndexedMapNode.prototype.getPayload__I__T2 = (function(index) {
  return new $c_T2($n(this.sci_BitmapIndexedMapNode__f_content).get((index << 1)), $n(this.sci_BitmapIndexedMapNode__f_content).get(((1 + (index << 1)) | 0)));
});
$c_sci_BitmapIndexedMapNode.prototype.getHash__I__I = (function(index) {
  return $n(this.sci_BitmapIndexedMapNode__f_originalHashes).get(index);
});
$c_sci_BitmapIndexedMapNode.prototype.getNode__I__sci_MapNode = (function(index) {
  return $as_sci_MapNode($n(this.sci_BitmapIndexedMapNode__f_content).get((((((-1) + $n(this.sci_BitmapIndexedMapNode__f_content).u.length) | 0) - index) | 0)));
});
$c_sci_BitmapIndexedMapNode.prototype.apply__O__I__I__I__O = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.getKey__I__O(index))) {
      return this.getValue__I__O(index);
    } else {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
    }
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    return $n(this.getNode__I__sci_MapNode($m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos))).apply__O__I__I__I__O(key, originalHash, keyHash, ((5 + shift) | 0));
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$c_sci_BitmapIndexedMapNode.prototype.get__O__I__I__I__s_Option = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, key0) ? new $c_s_Some(this.getValue__I__O(index)) : $m_s_None$());
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    return $n(this.getNode__I__sci_MapNode(index$2)).get__O__I__I__I__s_Option(key, originalHash, keyHash, ((5 + shift) | 0));
  } else {
    return $m_s_None$();
  }
});
$c_sci_BitmapIndexedMapNode.prototype.getOrElse__O__I__I__I__F0__O = (function(key, originalHash, keyHash, shift, f) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, key0) ? this.getValue__I__O(index) : $n(f).apply__O());
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    return $n(this.getNode__I__sci_MapNode(index$2)).getOrElse__O__I__I__I__F0__O(key, originalHash, keyHash, ((5 + shift) | 0), f);
  } else {
    return $n(f).apply__O();
  }
});
$c_sci_BitmapIndexedMapNode.prototype.containsKey__O__I__I__I__Z = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    return (($n(this.sci_BitmapIndexedMapNode__f_originalHashes).get(index) === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.getKey__I__O(index)));
  } else {
    return (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0) && $n(this.getNode__I__sci_MapNode($m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos))).containsKey__O__I__I__I__Z(key, originalHash, keyHash, ((5 + shift) | 0)));
  }
});
$c_sci_BitmapIndexedMapNode.prototype.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode = (function(key, value, originalHash, keyHash, shift, replaceValue) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    var key0UnimprovedHash = this.getHash__I__I(index);
    if (((key0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key0, key))) {
      if (replaceValue) {
        var value0 = this.getValue__I__O(index);
        return ((Object.is(key0, key) && Object.is(value0, value)) ? this : this.copyAndSetValue__I__O__O__sci_BitmapIndexedMapNode(bitpos, key, value));
      } else {
        return this;
      }
    } else {
      var value0$2 = this.getValue__I__O(index);
      var key0Hash = $m_sc_Hashing$().improve__I__I(key0UnimprovedHash);
      var subNodeNew = this.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(key0, value0$2, key0UnimprovedHash, key0Hash, key, value, originalHash, keyHash, ((5 + shift) | 0));
      return this.copyAndMigrateFromInlineToNode__I__I__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, key0Hash, subNodeNew);
    }
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_MapNode(index$2);
    var subNodeNew$2 = $n(subNode).updated__O__O__I__I__I__Z__sci_MapNode(key, value, originalHash, keyHash, ((5 + shift) | 0), replaceValue);
    return ((subNodeNew$2 === subNode) ? this : this.copyAndSetNode__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, subNode, subNodeNew$2));
  } else {
    return this.copyAndInsertValue__I__O__I__I__O__sci_BitmapIndexedMapNode(bitpos, key, originalHash, keyHash, value);
  }
});
$c_sci_BitmapIndexedMapNode.prototype.updateWithShallowMutations__O__O__I__I__I__I__I = (function(key, value, originalHash, keyHash, shift, shallowlyMutableNodeMap) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    var key0UnimprovedHash = this.getHash__I__I(index);
    if (((key0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key0, key))) {
      var value0 = this.getValue__I__O(index);
      if ((!(Object.is(key0, key) && Object.is(value0, value)))) {
        var dataIx = this.dataIndex__I__I(bitpos);
        var idx = (dataIx << 1);
        $n(this.sci_BitmapIndexedMapNode__f_content).set(((1 + idx) | 0), value);
      }
      return shallowlyMutableNodeMap;
    } else {
      var value0$2 = this.getValue__I__O(index);
      var key0Hash = $m_sc_Hashing$().improve__I__I(key0UnimprovedHash);
      var subNodeNew = this.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(key0, value0$2, key0UnimprovedHash, key0Hash, key, value, originalHash, keyHash, ((5 + shift) | 0));
      this.migrateFromInlineToNodeInPlace__I__I__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, key0Hash, subNodeNew);
      return (shallowlyMutableNodeMap | bitpos);
    }
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_MapNode(index$2);
    var subNodeSize = $n(subNode).size__I();
    var subNodeHashCode = $n(subNode).cachedJavaKeySetHashCode__I();
    var returnMutableNodeMap = shallowlyMutableNodeMap;
    matchEnd4: {
      var subNodeNew$2;
      if ((subNode instanceof $c_sci_BitmapIndexedMapNode)) {
        var x2 = $as_sci_BitmapIndexedMapNode(subNode);
        if (((bitpos & shallowlyMutableNodeMap) !== 0)) {
          $n(x2).updateWithShallowMutations__O__O__I__I__I__I__I(key, value, originalHash, keyHash, ((5 + shift) | 0), 0);
          var subNodeNew$2 = x2;
          break matchEnd4;
        }
      }
      var result = $n(subNode).updated__O__O__I__I__I__Z__sci_MapNode(key, value, originalHash, keyHash, ((5 + shift) | 0), true);
      if ((result !== subNode)) {
        returnMutableNodeMap = (returnMutableNodeMap | bitpos);
      }
      var subNodeNew$2 = result;
    }
    $n(this.sci_BitmapIndexedMapNode__f_content).set((((((-1) + $n(this.sci_BitmapIndexedMapNode__f_content).u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0), subNodeNew$2);
    this.sci_BitmapIndexedMapNode__f_size = ((((this.sci_BitmapIndexedMapNode__f_size - subNodeSize) | 0) + $n(subNodeNew$2).size__I()) | 0);
    this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - subNodeHashCode) | 0) + $n(subNodeNew$2).cachedJavaKeySetHashCode__I()) | 0);
    return returnMutableNodeMap;
  } else {
    var dataIx$2 = this.dataIndex__I__I(bitpos);
    var idx$2 = (dataIx$2 << 1);
    var src = this.sci_BitmapIndexedMapNode__f_content;
    var dst = new $ac_O(((2 + $n(src).u.length) | 0));
    $systemArraycopyRefs($n(src), 0, dst, 0, idx$2);
    $n(dst).set(idx$2, key);
    $n(dst).set(((1 + idx$2) | 0), value);
    var destPos = ((2 + idx$2) | 0);
    var length = (($n(src).u.length - idx$2) | 0);
    $systemArraycopyRefs($n(src), idx$2, dst, destPos, length);
    this.sci_BitmapIndexedMapNode__f_dataMap = (this.sci_BitmapIndexedMapNode__f_dataMap | bitpos);
    this.sci_BitmapIndexedMapNode__f_content = dst;
    this.sci_BitmapIndexedMapNode__f_originalHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx$2, originalHash);
    this.sci_BitmapIndexedMapNode__f_size = ((1 + this.sci_BitmapIndexedMapNode__f_size) | 0);
    this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = ((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode + keyHash) | 0);
    return shallowlyMutableNodeMap;
  }
});
$c_sci_BitmapIndexedMapNode.prototype.removed__O__I__I__I__sci_BitmapIndexedMapNode = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(key0, key)) {
      var i = this.sci_BitmapIndexedMapNode__f_dataMap;
      if (($m_jl_Integer$().bitCount__I__I(i) === 2)) {
        var i$1 = this.sci_BitmapIndexedMapNode__f_nodeMap;
        var $x_1 = ($m_jl_Integer$().bitCount__I__I(i$1) === 0);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var newDataMap = ((shift === 0) ? (this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos) : $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(keyHash, 0)));
        return ((index === 0) ? new $c_sci_BitmapIndexedMapNode(newDataMap, 0, new $ac_O([this.getKey__I__O(1), this.getValue__I__O(1)]), new $ac_I(new Int32Array([$n(this.sci_BitmapIndexedMapNode__f_originalHashes).get(1)])), 1, $m_sc_Hashing$().improve__I__I(this.getHash__I__I(1))) : new $c_sci_BitmapIndexedMapNode(newDataMap, 0, new $ac_O([this.getKey__I__O(0), this.getValue__I__O(0)]), new $ac_I(new Int32Array([$n(this.sci_BitmapIndexedMapNode__f_originalHashes).get(0)])), 1, $m_sc_Hashing$().improve__I__I(this.getHash__I__I(0))));
      } else {
        return this.copyAndRemoveValue__I__I__sci_BitmapIndexedMapNode(bitpos, keyHash);
      }
    } else {
      return this;
    }
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_MapNode(index$2);
    var subNodeNew = $n(subNode).removed__O__I__I__I__sci_MapNode(key, originalHash, keyHash, ((5 + shift) | 0));
    if ((subNodeNew === subNode)) {
      return this;
    }
    var subNodeNewSize = $n(subNodeNew).size__I();
    return ((subNodeNewSize === 1) ? ((this.sci_BitmapIndexedMapNode__f_size === $n(subNode).size__I()) ? $as_sci_BitmapIndexedMapNode(subNodeNew) : this.copyAndMigrateFromNodeToInline__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, subNode, subNodeNew)) : ((subNodeNewSize > 1) ? this.copyAndSetNode__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, subNode, subNodeNew) : this));
  } else {
    return this;
  }
});
$c_sci_BitmapIndexedMapNode.prototype.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode = (function(key0, value0, originalHash0, keyHash0, key1, value1, originalHash1, keyHash1, shift) {
  if ((shift >= 32)) {
    var this$4 = $m_sci_Vector$();
    var array = [new $c_T2(key0, value0), new $c_T2(key1, value1)];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return new $c_sci_HashCollisionMapNode(originalHash0, keyHash0, this$4.from__sc_IterableOnce__sci_Vector(elems));
  } else {
    var mask0 = $m_sci_Node$().maskFrom__I__I__I(keyHash0, shift);
    var mask1 = $m_sci_Node$().maskFrom__I__I__I(keyHash1, shift);
    var newCachedHash = ((keyHash0 + keyHash1) | 0);
    if ((mask0 !== mask1)) {
      var dataMap = ($m_sci_Node$().bitposFrom__I__I(mask0) | $m_sci_Node$().bitposFrom__I__I(mask1));
      return ((mask0 < mask1) ? new $c_sci_BitmapIndexedMapNode(dataMap, 0, new $ac_O([key0, value0, key1, value1]), new $ac_I(new Int32Array([originalHash0, originalHash1])), 2, newCachedHash) : new $c_sci_BitmapIndexedMapNode(dataMap, 0, new $ac_O([key1, value1, key0, value0]), new $ac_I(new Int32Array([originalHash1, originalHash0])), 2, newCachedHash));
    } else {
      var nodeMap = $m_sci_Node$().bitposFrom__I__I(mask0);
      var node = this.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(key0, value0, originalHash0, keyHash0, key1, value1, originalHash1, keyHash1, ((5 + shift) | 0));
      return new $c_sci_BitmapIndexedMapNode(0, nodeMap, new $ac_O([node]), $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, $n(node).size__I(), $n(node).cachedJavaKeySetHashCode__I());
    }
  }
});
$c_sci_BitmapIndexedMapNode.prototype.hasNodes__Z = (function() {
  return (this.sci_BitmapIndexedMapNode__f_nodeMap !== 0);
});
$c_sci_BitmapIndexedMapNode.prototype.nodeArity__I = (function() {
  var i = this.sci_BitmapIndexedMapNode__f_nodeMap;
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_BitmapIndexedMapNode.prototype.hasPayload__Z = (function() {
  return (this.sci_BitmapIndexedMapNode__f_dataMap !== 0);
});
$c_sci_BitmapIndexedMapNode.prototype.payloadArity__I = (function() {
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_BitmapIndexedMapNode.prototype.dataIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedMapNode__f_dataMap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_BitmapIndexedMapNode.prototype.nodeIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedMapNode__f_nodeMap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndSetValue__I__O__O__sci_BitmapIndexedMapNode = (function(bitpos, newKey, newValue) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O($n(src).u.length);
  var length = $n(src).u.length;
  $systemArraycopyRefs($n(src), 0, dst, 0, length);
  $n(dst).set(((1 + idx) | 0), newValue);
  return new $c_sci_BitmapIndexedMapNode(this.sci_BitmapIndexedMapNode__f_dataMap, this.sci_BitmapIndexedMapNode__f_nodeMap, dst, this.sci_BitmapIndexedMapNode__f_originalHashes, this.sci_BitmapIndexedMapNode__f_size, this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode);
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndSetNode__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, oldNode, newNode) {
  var idx = (((((-1) + $n(this.sci_BitmapIndexedMapNode__f_content).u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O($n(src).u.length);
  var length = $n(src).u.length;
  $systemArraycopyRefs($n(src), 0, dst, 0, length);
  $n(dst).set(idx, newNode);
  return new $c_sci_BitmapIndexedMapNode(this.sci_BitmapIndexedMapNode__f_dataMap, this.sci_BitmapIndexedMapNode__f_nodeMap, dst, this.sci_BitmapIndexedMapNode__f_originalHashes, ((((this.sci_BitmapIndexedMapNode__f_size - $n(oldNode).size__I()) | 0) + $n(newNode).size__I()) | 0), ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - $n(oldNode).cachedJavaKeySetHashCode__I()) | 0) + $n(newNode).cachedJavaKeySetHashCode__I()) | 0));
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndInsertValue__I__O__I__I__O__sci_BitmapIndexedMapNode = (function(bitpos, key, originalHash, keyHash, value) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(((2 + $n(src).u.length) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, idx);
  $n(dst).set(idx, key);
  $n(dst).set(((1 + idx) | 0), value);
  var destPos = ((2 + idx) | 0);
  var length = (($n(src).u.length - idx) | 0);
  $systemArraycopyRefs($n(src), idx, dst, destPos, length);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx, originalHash);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap | bitpos), this.sci_BitmapIndexedMapNode__f_nodeMap, dst, dstHashes, ((1 + this.sci_BitmapIndexedMapNode__f_size) | 0), ((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode + keyHash) | 0));
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndRemoveValue__I__I__sci_BitmapIndexedMapNode = (function(bitpos, keyHash) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O((((-2) + $n(src).u.length) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, idx);
  var srcPos = ((2 + idx) | 0);
  var length = (((-2) + (($n(src).u.length - idx) | 0)) | 0);
  $systemArraycopyRefs($n(src), srcPos, dst, idx, length);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos), this.sci_BitmapIndexedMapNode__f_nodeMap, dst, dstHashes, (((-1) + this.sci_BitmapIndexedMapNode__f_size) | 0), ((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - keyHash) | 0));
});
$c_sci_BitmapIndexedMapNode.prototype.migrateFromInlineToNodeInPlace__I__I__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, keyHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxOld = (dataIx << 1);
  var idxNew = (((((-2) + $n(this.sci_BitmapIndexedMapNode__f_content).u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O((((-1) + $n(src).u.length) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, idxOld);
  var srcPos = ((2 + idxOld) | 0);
  var length = ((idxNew - idxOld) | 0);
  $systemArraycopyRefs($n(src), srcPos, dst, idxOld, length);
  $n(dst).set(idxNew, node);
  var srcPos$1 = ((2 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = (((-2) + (($n(src).u.length - idxNew) | 0)) | 0);
  $systemArraycopyRefs($n(src), srcPos$1, dst, destPos, length$1);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx);
  this.sci_BitmapIndexedMapNode__f_dataMap = (this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos);
  this.sci_BitmapIndexedMapNode__f_nodeMap = (this.sci_BitmapIndexedMapNode__f_nodeMap | bitpos);
  this.sci_BitmapIndexedMapNode__f_content = dst;
  this.sci_BitmapIndexedMapNode__f_originalHashes = dstHashes;
  this.sci_BitmapIndexedMapNode__f_size = (((((-1) + this.sci_BitmapIndexedMapNode__f_size) | 0) + $n(node).size__I()) | 0);
  this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - keyHash) | 0) + $n(node).cachedJavaKeySetHashCode__I()) | 0);
  return this;
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndMigrateFromInlineToNode__I__I__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, keyHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxOld = (dataIx << 1);
  var idxNew = (((((-2) + $n(this.sci_BitmapIndexedMapNode__f_content).u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O((((-1) + $n(src).u.length) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, idxOld);
  var srcPos = ((2 + idxOld) | 0);
  var length = ((idxNew - idxOld) | 0);
  $systemArraycopyRefs($n(src), srcPos, dst, idxOld, length);
  $n(dst).set(idxNew, node);
  var srcPos$1 = ((2 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = (((-2) + (($n(src).u.length - idxNew) | 0)) | 0);
  $systemArraycopyRefs($n(src), srcPos$1, dst, destPos, length$1);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos), (this.sci_BitmapIndexedMapNode__f_nodeMap | bitpos), dst, dstHashes, (((((-1) + this.sci_BitmapIndexedMapNode__f_size) | 0) + $n(node).size__I()) | 0), ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - keyHash) | 0) + $n(node).cachedJavaKeySetHashCode__I()) | 0));
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndMigrateFromNodeToInline__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, oldNode, node) {
  var idxOld = (((((-1) + $n(this.sci_BitmapIndexedMapNode__f_content).u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var dataIxNew = this.dataIndex__I__I(bitpos);
  var idxNew = (dataIxNew << 1);
  var key = $n(node).getKey__I__O(0);
  var value = $n(node).getValue__I__O(0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(((1 + $n(src).u.length) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, idxNew);
  $n(dst).set(idxNew, key);
  $n(dst).set(((1 + idxNew) | 0), value);
  var destPos = ((2 + idxNew) | 0);
  var length = ((idxOld - idxNew) | 0);
  $systemArraycopyRefs($n(src), idxNew, dst, destPos, length);
  var srcPos = ((1 + idxOld) | 0);
  var destPos$1 = ((2 + idxOld) | 0);
  var length$1 = (((-1) + (($n(src).u.length - idxOld) | 0)) | 0);
  $systemArraycopyRefs($n(src), srcPos, dst, destPos$1, length$1);
  var hash = $n(node).getHash__I__I(0);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIxNew, hash);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap | bitpos), (this.sci_BitmapIndexedMapNode__f_nodeMap ^ bitpos), dst, dstHashes, ((1 + ((this.sci_BitmapIndexedMapNode__f_size - $n(oldNode).size__I()) | 0)) | 0), ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - $n(oldNode).cachedJavaKeySetHashCode__I()) | 0) + $n(node).cachedJavaKeySetHashCode__I()) | 0));
});
$c_sci_BitmapIndexedMapNode.prototype.foreach__F1__V = (function(f) {
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < iN)) {
    $n(f).apply__O__O(this.getPayload__I__T2(i$1));
    i$1 = ((1 + i$1) | 0);
  }
  var i$2 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    $n(this.getNode__I__sci_MapNode(j)).foreach__F1__V(f);
    j = ((1 + j) | 0);
  }
});
$c_sci_BitmapIndexedMapNode.prototype.foreachEntry__F2__V = (function(f) {
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < iN)) {
    $n(f).apply__O__O__O(this.getKey__I__O(i$1), this.getValue__I__O(i$1));
    i$1 = ((1 + i$1) | 0);
  }
  var i$2 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    $n(this.getNode__I__sci_MapNode(j)).foreachEntry__F2__V(f);
    j = ((1 + j) | 0);
  }
});
$c_sci_BitmapIndexedMapNode.prototype.foreachWithHash__F3__V = (function(f) {
  var i = 0;
  var i$1 = this.sci_BitmapIndexedMapNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i$1);
  while ((i < iN)) {
    $n(f).apply__O__O__O__O(this.getKey__I__O(i), this.getValue__I__O(i), this.getHash__I__I(i));
    i = ((1 + i) | 0);
  }
  var i$2 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    $n(this.getNode__I__sci_MapNode(j)).foreachWithHash__F3__V(f);
    j = ((1 + j) | 0);
  }
});
$c_sci_BitmapIndexedMapNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_BitmapIndexedMapNode)) {
    var x2 = $as_sci_BitmapIndexedMapNode(that);
    if ((this === x2)) {
      return true;
    } else {
      if (((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode === $n(x2).sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode) && (this.sci_BitmapIndexedMapNode__f_nodeMap === $n(x2).sci_BitmapIndexedMapNode__f_nodeMap)) && (this.sci_BitmapIndexedMapNode__f_dataMap === $n(x2).sci_BitmapIndexedMapNode__f_dataMap)) && (this.sci_BitmapIndexedMapNode__f_size === $n(x2).sci_BitmapIndexedMapNode__f_size))) {
        var a = this.sci_BitmapIndexedMapNode__f_originalHashes;
        var b = $n(x2).sci_BitmapIndexedMapNode__f_originalHashes;
        var $x_1 = $m_ju_Arrays$().equals__AI__AI__Z(a, b);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var a1 = this.sci_BitmapIndexedMapNode__f_content;
        var a2 = $n(x2).sci_BitmapIndexedMapNode__f_content;
        var length = $n(this.sci_BitmapIndexedMapNode__f_content).u.length;
        if ((a1 === a2)) {
          return true;
        } else {
          var isEqual = true;
          var i = 0;
          while ((isEqual && (i < length))) {
            isEqual = $m_sr_BoxesRunTime$().equals__O__O__Z($n(a1).get(i), $n(a2).get(i));
            i = ((1 + i) | 0);
          }
          return isEqual;
        }
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$c_sci_BitmapIndexedMapNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.");
});
$c_sci_BitmapIndexedMapNode.prototype.concat__sci_MapNode__I__sci_BitmapIndexedMapNode = (function(that, shift) {
  if ((that instanceof $c_sci_BitmapIndexedMapNode)) {
    var x2 = $as_sci_BitmapIndexedMapNode(that);
    if ((this.sci_BitmapIndexedMapNode__f_size === 0)) {
      return x2;
    } else if ((($n(x2).sci_BitmapIndexedMapNode__f_size === 0) || (x2 === this))) {
      return this;
    } else if (($n(x2).sci_BitmapIndexedMapNode__f_size === 1)) {
      var originalHash = $n(x2).getHash__I__I(0);
      return this.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode($n(x2).getKey__I__O(0), $n(x2).getValue__I__O(0), originalHash, $m_sc_Hashing$().improve__I__I(originalHash), shift, true);
    }
    var anyChangesMadeSoFar = false;
    var allMap = (((this.sci_BitmapIndexedMapNode__f_dataMap | $n(x2).sci_BitmapIndexedMapNode__f_dataMap) | this.sci_BitmapIndexedMapNode__f_nodeMap) | $n(x2).sci_BitmapIndexedMapNode__f_nodeMap);
    var $x_2 = $m_sci_Node$();
    if ((allMap === 0)) {
      var $x_1 = 32;
    } else {
      var i = (allMap & ((-allMap) | 0));
      var $x_1 = ((31 - $uI(Math.clz32(i))) | 0);
    }
    var minimumBitPos = $n($x_2).bitposFrom__I__I($x_1);
    var maximumBitPos = $m_sci_Node$().bitposFrom__I__I(((31 - $uI(Math.clz32(allMap))) | 0));
    var leftNodeRightNode = 0;
    var leftDataRightNode = 0;
    var leftNodeRightData = 0;
    var leftDataOnly = 0;
    var rightDataOnly = 0;
    var leftNodeOnly = 0;
    var rightNodeOnly = 0;
    var leftDataRightDataMigrateToNode = 0;
    var leftDataRightDataRightOverwrites = 0;
    var dataToNodeMigrationTargets = 0;
    var bitpos = minimumBitPos;
    var leftIdx = 0;
    var rightIdx = 0;
    var finished = false;
    while ((!finished)) {
      if (((bitpos & this.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
        if (((bitpos & $n(x2).sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
          var leftOriginalHash = this.getHash__I__I(leftIdx);
          if (((leftOriginalHash === $n(x2).getHash__I__I(rightIdx)) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.getKey__I__O(leftIdx), $n(x2).getKey__I__O(rightIdx)))) {
            leftDataRightDataRightOverwrites = (leftDataRightDataRightOverwrites | bitpos);
          } else {
            leftDataRightDataMigrateToNode = (leftDataRightDataMigrateToNode | bitpos);
            dataToNodeMigrationTargets = (dataToNodeMigrationTargets | $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I($m_sc_Hashing$().improve__I__I(leftOriginalHash), shift)));
          }
          rightIdx = ((1 + rightIdx) | 0);
        } else if (((bitpos & $n(x2).sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
          leftDataRightNode = (leftDataRightNode | bitpos);
        } else {
          leftDataOnly = (leftDataOnly | bitpos);
        }
        leftIdx = ((1 + leftIdx) | 0);
      } else if (((bitpos & this.sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
        if (((bitpos & $n(x2).sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
          leftNodeRightData = (leftNodeRightData | bitpos);
          rightIdx = ((1 + rightIdx) | 0);
        } else if (((bitpos & $n(x2).sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
          leftNodeRightNode = (leftNodeRightNode | bitpos);
        } else {
          leftNodeOnly = (leftNodeOnly | bitpos);
        }
      } else if (((bitpos & $n(x2).sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
        rightDataOnly = (rightDataOnly | bitpos);
        rightIdx = ((1 + rightIdx) | 0);
      } else if (((bitpos & $n(x2).sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
        rightNodeOnly = (rightNodeOnly | bitpos);
      }
      if ((bitpos === maximumBitPos)) {
        finished = true;
      } else {
        bitpos = (bitpos << 1);
      }
    }
    var newDataMap = ((leftDataOnly | rightDataOnly) | leftDataRightDataRightOverwrites);
    var newNodeMap = (((((leftNodeRightNode | leftDataRightNode) | leftNodeRightData) | leftNodeOnly) | rightNodeOnly) | dataToNodeMigrationTargets);
    if (((newDataMap === (rightDataOnly | leftDataRightDataRightOverwrites)) && (newNodeMap === rightNodeOnly))) {
      return x2;
    }
    var newDataSize = $m_jl_Integer$().bitCount__I__I(newDataMap);
    var newContentSize = (((newDataSize << 1) + $m_jl_Integer$().bitCount__I__I(newNodeMap)) | 0);
    var newContent = new $ac_O(newContentSize);
    var newOriginalHashes = new $ac_I(newDataSize);
    var newSize = 0;
    var newCachedHashCode = 0;
    var leftDataIdx = 0;
    var rightDataIdx = 0;
    var leftNodeIdx = 0;
    var rightNodeIdx = 0;
    var nextShift = ((5 + shift) | 0);
    var compressedDataIdx = 0;
    var compressedNodeIdx = 0;
    var bitpos$2 = minimumBitPos;
    var finished$2 = false;
    while ((!finished$2)) {
      if (((bitpos$2 & leftNodeRightNode) !== 0)) {
        var rightNode = $n(x2).getNode__I__sci_MapNode(rightNodeIdx);
        var newNode = $n(this.getNode__I__sci_MapNode(leftNodeIdx)).concat__sci_MapNode__I__sci_MapNode(rightNode, nextShift);
        if ((rightNode !== newNode)) {
          anyChangesMadeSoFar = true;
        }
        $n(newContent).set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        newSize = ((newSize + $n(newNode).size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + $n(newNode).cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & leftDataRightNode) !== 0)) {
        var n = $n(x2).getNode__I__sci_MapNode(rightNodeIdx);
        var leftKey = this.getKey__I__O(leftDataIdx);
        var leftValue = this.getValue__I__O(leftDataIdx);
        var leftOriginalHash$2 = this.getHash__I__I(leftDataIdx);
        var leftImproved = $m_sc_Hashing$().improve__I__I(leftOriginalHash$2);
        var updated = $n(n).updated__O__O__I__I__I__Z__sci_MapNode(leftKey, leftValue, leftOriginalHash$2, leftImproved, nextShift, false);
        if ((updated !== n)) {
          anyChangesMadeSoFar = true;
        }
        $n(newContent).set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), updated);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        newSize = ((newSize + $n(updated).size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + $n(updated).cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & leftNodeRightData) !== 0)) {
        anyChangesMadeSoFar = true;
        var rightOriginalHash = $n(x2).getHash__I__I(rightDataIdx);
        var newNode$3 = $n(this.getNode__I__sci_MapNode(leftNodeIdx)).updated__O__O__I__I__I__Z__sci_MapNode($n(x2).getKey__I__O(rightDataIdx), $n(x2).getValue__I__O(rightDataIdx), $n(x2).getHash__I__I(rightDataIdx), $m_sc_Hashing$().improve__I__I(rightOriginalHash), nextShift, true);
        $n(newContent).set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$3);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((newSize + $n(newNode$3).size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + $n(newNode$3).cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & leftDataOnly) !== 0)) {
        anyChangesMadeSoFar = true;
        var originalHash$2 = $n(this.sci_BitmapIndexedMapNode__f_originalHashes).get(leftDataIdx);
        $n(newContent).set((compressedDataIdx << 1), this.getKey__I__O(leftDataIdx));
        $n(newContent).set(((1 + (compressedDataIdx << 1)) | 0), this.getValue__I__O(leftDataIdx));
        $n(newOriginalHashes).set(compressedDataIdx, originalHash$2);
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$2)) | 0);
      } else if (((bitpos$2 & rightDataOnly) !== 0)) {
        var originalHash$3 = $n($n(x2).sci_BitmapIndexedMapNode__f_originalHashes).get(rightDataIdx);
        $n(newContent).set((compressedDataIdx << 1), $n(x2).getKey__I__O(rightDataIdx));
        $n(newContent).set(((1 + (compressedDataIdx << 1)) | 0), $n(x2).getValue__I__O(rightDataIdx));
        $n(newOriginalHashes).set(compressedDataIdx, originalHash$3);
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$3)) | 0);
      } else if (((bitpos$2 & leftNodeOnly) !== 0)) {
        anyChangesMadeSoFar = true;
        var newNode$4 = this.getNode__I__sci_MapNode(leftNodeIdx);
        $n(newContent).set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$4);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        newSize = ((newSize + $n(newNode$4).size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + $n(newNode$4).cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & rightNodeOnly) !== 0)) {
        var newNode$5 = $n(x2).getNode__I__sci_MapNode(rightNodeIdx);
        $n(newContent).set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$5);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        newSize = ((newSize + $n(newNode$5).size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + $n(newNode$5).cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & leftDataRightDataMigrateToNode) !== 0)) {
        anyChangesMadeSoFar = true;
        var leftOriginalHash$3 = this.getHash__I__I(leftDataIdx);
        var rightOriginalHash$2 = $n(x2).getHash__I__I(rightDataIdx);
        var newNode$6 = $n(x2).mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(this.getKey__I__O(leftDataIdx), this.getValue__I__O(leftDataIdx), leftOriginalHash$3, $m_sc_Hashing$().improve__I__I(leftOriginalHash$3), $n(x2).getKey__I__O(rightDataIdx), $n(x2).getValue__I__O(rightDataIdx), rightOriginalHash$2, $m_sc_Hashing$().improve__I__I(rightOriginalHash$2), nextShift);
        $n(newContent).set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$6);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((newSize + $n(newNode$6).size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + $n(newNode$6).cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & leftDataRightDataRightOverwrites) !== 0)) {
        var originalHash$4 = $n($n(x2).sci_BitmapIndexedMapNode__f_originalHashes).get(rightDataIdx);
        $n(newContent).set((compressedDataIdx << 1), $n(x2).getKey__I__O(rightDataIdx));
        $n(newContent).set(((1 + (compressedDataIdx << 1)) | 0), $n(x2).getValue__I__O(rightDataIdx));
        $n(newOriginalHashes).set(compressedDataIdx, originalHash$4);
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$4)) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
      }
      if ((bitpos$2 === maximumBitPos)) {
        finished$2 = true;
      } else {
        bitpos$2 = (bitpos$2 << 1);
      }
    }
    return (anyChangesMadeSoFar ? new $c_sci_BitmapIndexedMapNode(newDataMap, newNodeMap, newContent, newOriginalHashes, newSize, newCachedHashCode) : x2);
  } else {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Cannot concatenate a HashCollisionMapNode with a BitmapIndexedMapNode");
  }
});
$c_sci_BitmapIndexedMapNode.prototype.copy__sci_BitmapIndexedMapNode = (function() {
  var this$1 = $n(this.sci_BitmapIndexedMapNode__f_content);
  var contentClone = $n(this$1).clone__O();
  var contentLength = $n(contentClone).u.length;
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  var i$1 = ($m_jl_Integer$().bitCount__I__I(i) << 1);
  while ((i$1 < contentLength)) {
    $n(contentClone).set(i$1, $n($as_sci_MapNode($n(contentClone).get(i$1))).copy__sci_MapNode());
    i$1 = ((1 + i$1) | 0);
  }
  var $x_2 = this.sci_BitmapIndexedMapNode__f_dataMap;
  var $x_1 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var this$2 = $n(this.sci_BitmapIndexedMapNode__f_originalHashes);
  return new $c_sci_BitmapIndexedMapNode($x_2, $x_1, contentClone, $n(this$2).clone__O(), this.sci_BitmapIndexedMapNode__f_size, this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode);
});
$c_sci_BitmapIndexedMapNode.prototype.filterImpl__F1__Z__sci_BitmapIndexedMapNode = (function(pred, flipped) {
  if ((this.sci_BitmapIndexedMapNode__f_size === 0)) {
    return this;
  } else if ((this.sci_BitmapIndexedMapNode__f_size === 1)) {
    if (($uZ($n(pred).apply__O__O(this.getPayload__I__T2(0))) !== flipped)) {
      return this;
    } else {
      var this$1 = $m_sci_MapNode$();
      return this$1.sci_MapNode$__f_EmptyMapNode;
    }
  } else if ((this.sci_BitmapIndexedMapNode__f_nodeMap === 0)) {
    var i = this.sci_BitmapIndexedMapNode__f_dataMap;
    if ((i === 0)) {
      var minimumIndex = 32;
    } else {
      var i$1 = (i & ((-i) | 0));
      var minimumIndex = ((31 - $uI(Math.clz32(i$1))) | 0);
    }
    var i$2 = this.sci_BitmapIndexedMapNode__f_dataMap;
    var maximumIndex = ((32 - $uI(Math.clz32(i$2))) | 0);
    var newDataMap = 0;
    var newCachedHashCode = 0;
    var dataIndex = 0;
    var i$3 = minimumIndex;
    while ((i$3 < maximumIndex)) {
      var bitpos = $m_sci_Node$().bitposFrom__I__I(i$3);
      if (((bitpos & this.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
        var payload = this.getPayload__I__T2(dataIndex);
        var passed = ($uZ($n(pred).apply__O__O(payload)) !== flipped);
        if (passed) {
          newDataMap = (newDataMap | bitpos);
          newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(this.getHash__I__I(dataIndex))) | 0);
        }
        dataIndex = ((1 + dataIndex) | 0);
      }
      i$3 = ((1 + i$3) | 0);
    }
    if ((newDataMap === 0)) {
      var this$4 = $m_sci_MapNode$();
      return this$4.sci_MapNode$__f_EmptyMapNode;
    } else if ((newDataMap === this.sci_BitmapIndexedMapNode__f_dataMap)) {
      return this;
    } else {
      var i$4 = newDataMap;
      var newSize = $m_jl_Integer$().bitCount__I__I(i$4);
      var newContent = new $ac_O((newSize << 1));
      var newOriginalHashCodes = new $ac_I(newSize);
      var i$5 = newDataMap;
      var newMaximumIndex = ((32 - $uI(Math.clz32(i$5))) | 0);
      var i$6 = newDataMap;
      if ((i$6 === 0)) {
        var j = 32;
      } else {
        var i$7 = (i$6 & ((-i$6) | 0));
        var j = ((31 - $uI(Math.clz32(i$7))) | 0);
      }
      var newDataIndex = 0;
      while ((j < newMaximumIndex)) {
        var bitpos$2 = $m_sci_Node$().bitposFrom__I__I(j);
        if (((bitpos$2 & newDataMap) !== 0)) {
          var oldIndex = $m_sci_Node$().indexFrom__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, bitpos$2);
          $n(newContent).set((newDataIndex << 1), $n(this.sci_BitmapIndexedMapNode__f_content).get((oldIndex << 1)));
          $n(newContent).set(((1 + (newDataIndex << 1)) | 0), $n(this.sci_BitmapIndexedMapNode__f_content).get(((1 + (oldIndex << 1)) | 0)));
          $n(newOriginalHashCodes).set(newDataIndex, $n(this.sci_BitmapIndexedMapNode__f_originalHashes).get(oldIndex));
          newDataIndex = ((1 + newDataIndex) | 0);
        }
        j = ((1 + j) | 0);
      }
      return new $c_sci_BitmapIndexedMapNode(newDataMap, 0, newContent, newOriginalHashCodes, newSize, newCachedHashCode);
    }
  } else {
    var allMap = (this.sci_BitmapIndexedMapNode__f_dataMap | this.sci_BitmapIndexedMapNode__f_nodeMap);
    if ((allMap === 0)) {
      var minimumIndex$2 = 32;
    } else {
      var i$8 = (allMap & ((-allMap) | 0));
      var minimumIndex$2 = ((31 - $uI(Math.clz32(i$8))) | 0);
    }
    var maximumIndex$2 = ((32 - $uI(Math.clz32(allMap))) | 0);
    var oldDataPassThrough = 0;
    var nodeMigrateToDataTargetMap = 0;
    var nodesToMigrateToData = null;
    var nodesToPassThroughMap = 0;
    var mapOfNewNodes = 0;
    var newNodes = null;
    var newDataMap$2 = 0;
    var newNodeMap = 0;
    var newSize$2 = 0;
    var newCachedHashCode$2 = 0;
    var dataIndex$2 = 0;
    var nodeIndex = 0;
    var i$2$1 = minimumIndex$2;
    while ((i$2$1 < maximumIndex$2)) {
      var bitpos$3 = $m_sci_Node$().bitposFrom__I__I(i$2$1);
      if (((bitpos$3 & this.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
        var payload$2 = this.getPayload__I__T2(dataIndex$2);
        var passed$2 = ($uZ($n(pred).apply__O__O(payload$2)) !== flipped);
        if (passed$2) {
          newDataMap$2 = (newDataMap$2 | bitpos$3);
          oldDataPassThrough = (oldDataPassThrough | bitpos$3);
          newSize$2 = ((1 + newSize$2) | 0);
          newCachedHashCode$2 = ((newCachedHashCode$2 + $m_sc_Hashing$().improve__I__I(this.getHash__I__I(dataIndex$2))) | 0);
        }
        dataIndex$2 = ((1 + dataIndex$2) | 0);
      } else if (((bitpos$3 & this.sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
        var oldSubNode = this.getNode__I__sci_MapNode(nodeIndex);
        var newSubNode = $n(oldSubNode).filterImpl__F1__Z__sci_MapNode(pred, flipped);
        newSize$2 = ((newSize$2 + $n(newSubNode).size__I()) | 0);
        newCachedHashCode$2 = ((newCachedHashCode$2 + $n(newSubNode).cachedJavaKeySetHashCode__I()) | 0);
        if (($n(newSubNode).size__I() > 1)) {
          newNodeMap = (newNodeMap | bitpos$3);
          if ((oldSubNode === newSubNode)) {
            nodesToPassThroughMap = (nodesToPassThroughMap | bitpos$3);
          } else {
            mapOfNewNodes = (mapOfNewNodes | bitpos$3);
            if ((newNodes === null)) {
              newNodes = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
            }
            var this$10 = $n(newNodes);
            this$10.addOne__O__scm_ArrayDeque(newSubNode);
          }
        } else if (($n(newSubNode).size__I() === 1)) {
          newDataMap$2 = (newDataMap$2 | bitpos$3);
          nodeMigrateToDataTargetMap = (nodeMigrateToDataTargetMap | bitpos$3);
          if ((nodesToMigrateToData === null)) {
            var elems = $m_sci_Nil$();
            var this$12 = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
            nodesToMigrateToData = $as_scm_Queue(this$12.addAll__sc_IterableOnce__scm_ArrayDeque(elems));
          }
          var this$13 = $n(nodesToMigrateToData);
          this$13.addOne__O__scm_ArrayDeque(newSubNode);
        }
        nodeIndex = ((1 + nodeIndex) | 0);
      }
      i$2$1 = ((1 + i$2$1) | 0);
    }
    if ((newSize$2 === 0)) {
      var this$14 = $m_sci_MapNode$();
      return this$14.sci_MapNode$__f_EmptyMapNode;
    } else if ((newSize$2 === this.sci_BitmapIndexedMapNode__f_size)) {
      return this;
    } else {
      var i$9 = newDataMap$2;
      var newDataSize = $m_jl_Integer$().bitCount__I__I(i$9);
      var i$10 = newNodeMap;
      var newContentSize = (((newDataSize << 1) + $m_jl_Integer$().bitCount__I__I(i$10)) | 0);
      var newContent$2 = new $ac_O(newContentSize);
      var newOriginalHashes = new $ac_I(newDataSize);
      var newAllMap = (newDataMap$2 | newNodeMap);
      var maxIndex = ((32 - $uI(Math.clz32(newAllMap))) | 0);
      var i$3$1 = minimumIndex$2;
      var oldDataIndex = 0;
      var oldNodeIndex = 0;
      var newDataIndex$2 = 0;
      var newNodeIndex = 0;
      while ((i$3$1 < maxIndex)) {
        var bitpos$4 = $m_sci_Node$().bitposFrom__I__I(i$3$1);
        if (((bitpos$4 & oldDataPassThrough) !== 0)) {
          $n(newContent$2).set((newDataIndex$2 << 1), this.getKey__I__O(oldDataIndex));
          $n(newContent$2).set(((1 + (newDataIndex$2 << 1)) | 0), this.getValue__I__O(oldDataIndex));
          $n(newOriginalHashes).set(newDataIndex$2, this.getHash__I__I(oldDataIndex));
          newDataIndex$2 = ((1 + newDataIndex$2) | 0);
          oldDataIndex = ((1 + oldDataIndex) | 0);
        } else if (((bitpos$4 & nodesToPassThroughMap) !== 0)) {
          $n(newContent$2).set((((-1) + ((newContentSize - newNodeIndex) | 0)) | 0), this.getNode__I__sci_MapNode(oldNodeIndex));
          newNodeIndex = ((1 + newNodeIndex) | 0);
          oldNodeIndex = ((1 + oldNodeIndex) | 0);
        } else if (((bitpos$4 & nodeMigrateToDataTargetMap) !== 0)) {
          var this$16 = $n(nodesToMigrateToData);
          var node = $as_sci_MapNode(this$16.removeHead__Z__O(false));
          $n(newContent$2).set((newDataIndex$2 << 1), $n(node).getKey__I__O(0));
          $n(newContent$2).set(((1 + (newDataIndex$2 << 1)) | 0), $n(node).getValue__I__O(0));
          $n(newOriginalHashes).set(newDataIndex$2, $n(node).getHash__I__I(0));
          newDataIndex$2 = ((1 + newDataIndex$2) | 0);
          oldNodeIndex = ((1 + oldNodeIndex) | 0);
        } else if (((bitpos$4 & mapOfNewNodes) !== 0)) {
          var $x_2 = $n(newContent$2);
          var $x_1 = newNodeIndex;
          var this$17 = $n(newNodes);
          $x_2.set((((-1) + ((newContentSize - $x_1) | 0)) | 0), this$17.removeHead__Z__O(false));
          newNodeIndex = ((1 + newNodeIndex) | 0);
          oldNodeIndex = ((1 + oldNodeIndex) | 0);
        } else if (((bitpos$4 & this.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
          oldDataIndex = ((1 + oldDataIndex) | 0);
        } else if (((bitpos$4 & this.sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
          oldNodeIndex = ((1 + oldNodeIndex) | 0);
        }
        i$3$1 = ((1 + i$3$1) | 0);
      }
      return new $c_sci_BitmapIndexedMapNode(newDataMap$2, newNodeMap, newContent$2, newOriginalHashes, newSize$2, newCachedHashCode$2);
    }
  }
});
$c_sci_BitmapIndexedMapNode.prototype.filterImpl__F1__Z__sci_MapNode = (function(pred, isFlipped) {
  return this.filterImpl__F1__Z__sci_BitmapIndexedMapNode(pred, isFlipped);
});
$c_sci_BitmapIndexedMapNode.prototype.copy__sci_MapNode = (function() {
  return this.copy__sci_BitmapIndexedMapNode();
});
$c_sci_BitmapIndexedMapNode.prototype.concat__sci_MapNode__I__sci_MapNode = (function(that, shift) {
  return this.concat__sci_MapNode__I__sci_BitmapIndexedMapNode(that, shift);
});
$c_sci_BitmapIndexedMapNode.prototype.removed__O__I__I__I__sci_MapNode = (function(key, originalHash, hash, shift) {
  return this.removed__O__I__I__I__sci_BitmapIndexedMapNode(key, originalHash, hash, shift);
});
$c_sci_BitmapIndexedMapNode.prototype.updated__O__O__I__I__I__Z__sci_MapNode = (function(key, value, originalHash, hash, shift, replaceValue) {
  return this.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(key, value, originalHash, hash, shift, replaceValue);
});
$c_sci_BitmapIndexedMapNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_MapNode(index);
});
function $as_sci_BitmapIndexedMapNode(obj) {
  return (((obj instanceof $c_sci_BitmapIndexedMapNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.BitmapIndexedMapNode"));
}
function $isArrayOf_sci_BitmapIndexedMapNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BitmapIndexedMapNode)));
}
function $asArrayOf_sci_BitmapIndexedMapNode(obj, depth) {
  return (($isArrayOf_sci_BitmapIndexedMapNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.BitmapIndexedMapNode;", depth));
}
var $d_sci_BitmapIndexedMapNode = new $TypeData().initClass($c_sci_BitmapIndexedMapNode, "scala.collection.immutable.BitmapIndexedMapNode", ({
  sci_BitmapIndexedMapNode: 1,
  sci_MapNode: 1,
  sci_Node: 1
}));
function $p_sci_BitmapIndexedSetNode__newNodeFrom__I__I__I__I__I__I__I__scm_Queue__I__scm_Queue__I__sci_BitmapIndexedSetNode($thiz, newSize, newDataMap, newNodeMap, minimumIndex, oldDataPassThrough, nodesToPassThroughMap, nodeMigrateToDataTargetMap, nodesToMigrateToData, mapOfNewNodes, newNodes, newCachedHashCode) {
  if ((newSize === 0)) {
    var this$1 = $m_sci_SetNode$();
    return this$1.sci_SetNode$__f_EmptySetNode;
  } else if ((newSize === $thiz.sci_BitmapIndexedSetNode__f_size)) {
    return $thiz;
  } else {
    var newDataSize = $m_jl_Integer$().bitCount__I__I(newDataMap);
    var newContentSize = ((newDataSize + $m_jl_Integer$().bitCount__I__I(newNodeMap)) | 0);
    var newContent = new $ac_O(newContentSize);
    var newOriginalHashes = new $ac_I(newDataSize);
    var newAllMap = (newDataMap | newNodeMap);
    var maxIndex = ((32 - $uI(Math.clz32(newAllMap))) | 0);
    var i = minimumIndex;
    var oldDataIndex = 0;
    var oldNodeIndex = 0;
    var newDataIndex = 0;
    var newNodeIndex = 0;
    while ((i < maxIndex)) {
      var bitpos = $m_sci_Node$().bitposFrom__I__I(i);
      if (((bitpos & oldDataPassThrough) !== 0)) {
        $n(newContent).set(newDataIndex, $thiz.getPayload__I__O(oldDataIndex));
        $n(newOriginalHashes).set(newDataIndex, $thiz.getHash__I__I(oldDataIndex));
        newDataIndex = ((1 + newDataIndex) | 0);
        oldDataIndex = ((1 + oldDataIndex) | 0);
      } else if (((bitpos & nodesToPassThroughMap) !== 0)) {
        $n(newContent).set((((-1) + ((newContentSize - newNodeIndex) | 0)) | 0), $thiz.getNode__I__sci_SetNode(oldNodeIndex));
        newNodeIndex = ((1 + newNodeIndex) | 0);
        oldNodeIndex = ((1 + oldNodeIndex) | 0);
      } else if (((bitpos & nodeMigrateToDataTargetMap) !== 0)) {
        var this$3 = $n(nodesToMigrateToData);
        var node = $as_sci_SetNode(this$3.removeHead__Z__O(false));
        $n(newContent).set(newDataIndex, $n(node).getPayload__I__O(0));
        $n(newOriginalHashes).set(newDataIndex, $n(node).getHash__I__I(0));
        newDataIndex = ((1 + newDataIndex) | 0);
        oldNodeIndex = ((1 + oldNodeIndex) | 0);
      } else if (((bitpos & mapOfNewNodes) !== 0)) {
        var $x_2 = $n(newContent);
        var $x_1 = newNodeIndex;
        var this$4 = $n(newNodes);
        $x_2.set((((-1) + ((newContentSize - $x_1) | 0)) | 0), this$4.removeHead__Z__O(false));
        newNodeIndex = ((1 + newNodeIndex) | 0);
        oldNodeIndex = ((1 + oldNodeIndex) | 0);
      } else if (((bitpos & $thiz.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
        oldDataIndex = ((1 + oldDataIndex) | 0);
      } else if (((bitpos & $thiz.sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
        oldNodeIndex = ((1 + oldNodeIndex) | 0);
      }
      i = ((1 + i) | 0);
    }
    return new $c_sci_BitmapIndexedSetNode(newDataMap, newNodeMap, newContent, newOriginalHashes, newSize, newCachedHashCode);
  }
}
/** @constructor */
function $c_sci_BitmapIndexedSetNode(dataMap, nodeMap, content, originalHashes, size, cachedJavaKeySetHashCode) {
  this.sci_BitmapIndexedSetNode__f_dataMap = 0;
  this.sci_BitmapIndexedSetNode__f_nodeMap = 0;
  this.sci_BitmapIndexedSetNode__f_content = null;
  this.sci_BitmapIndexedSetNode__f_originalHashes = null;
  this.sci_BitmapIndexedSetNode__f_size = 0;
  this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = 0;
  this.sci_BitmapIndexedSetNode__f_dataMap = dataMap;
  this.sci_BitmapIndexedSetNode__f_nodeMap = nodeMap;
  this.sci_BitmapIndexedSetNode__f_content = content;
  this.sci_BitmapIndexedSetNode__f_originalHashes = originalHashes;
  this.sci_BitmapIndexedSetNode__f_size = size;
  this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = cachedJavaKeySetHashCode;
}
$c_sci_BitmapIndexedSetNode.prototype = new $h_sci_SetNode();
$c_sci_BitmapIndexedSetNode.prototype.constructor = $c_sci_BitmapIndexedSetNode;
/** @constructor */
function $h_sci_BitmapIndexedSetNode() {
}
$h_sci_BitmapIndexedSetNode.prototype = $c_sci_BitmapIndexedSetNode.prototype;
$c_sci_BitmapIndexedSetNode.prototype.size__I = (function() {
  return this.sci_BitmapIndexedSetNode__f_size;
});
$c_sci_BitmapIndexedSetNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode;
});
$c_sci_BitmapIndexedSetNode.prototype.getPayload__I__O = (function(index) {
  return $n(this.sci_BitmapIndexedSetNode__f_content).get(index);
});
$c_sci_BitmapIndexedSetNode.prototype.getHash__I__I = (function(index) {
  return $n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(index);
});
$c_sci_BitmapIndexedSetNode.prototype.getNode__I__sci_SetNode = (function(index) {
  return $as_sci_SetNode($n(this.sci_BitmapIndexedSetNode__f_content).get((((((-1) + $n(this.sci_BitmapIndexedSetNode__f_content).u.length) | 0) - index) | 0)));
});
$c_sci_BitmapIndexedSetNode.prototype.contains__O__I__I__I__Z = (function(element, originalHash, elementHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    return (($n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(index) === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(element, this.getPayload__I__O(index)));
  }
  if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    return $n(this.getNode__I__sci_SetNode(index$2)).contains__O__I__I__I__Z(element, originalHash, elementHash, ((5 + shift) | 0));
  }
  return false;
});
$c_sci_BitmapIndexedSetNode.prototype.updated__O__I__I__I__sci_BitmapIndexedSetNode = (function(element, originalHash, elementHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    var element0 = this.getPayload__I__O(index);
    if (Object.is(element0, element)) {
      return this;
    } else {
      var element0UnimprovedHash = this.getHash__I__I(index);
      var element0Hash = $m_sc_Hashing$().improve__I__I(element0UnimprovedHash);
      if (((originalHash === element0UnimprovedHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(element0, element))) {
        return this;
      } else {
        var subNodeNew = this.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(element0, element0UnimprovedHash, element0Hash, element, originalHash, elementHash, ((5 + shift) | 0));
        return this.copyAndMigrateFromInlineToNode__I__I__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, element0Hash, subNodeNew);
      }
    }
  }
  if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_SetNode(index$2);
    var subNodeNew$2 = $n(subNode).updated__O__I__I__I__sci_SetNode(element, originalHash, elementHash, ((5 + shift) | 0));
    if ((subNode === subNodeNew$2)) {
      return this;
    } else {
      return this.copyAndSetNode__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, subNode, subNodeNew$2);
    }
  }
  return this.copyAndInsertValue__I__O__I__I__sci_BitmapIndexedSetNode(bitpos, element, originalHash, elementHash);
});
$c_sci_BitmapIndexedSetNode.prototype.updateWithShallowMutations__O__I__I__I__I__I = (function(element, originalHash, elementHash, shift, shallowlyMutableNodeMap) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    var element0 = this.getPayload__I__O(index);
    var element0UnimprovedHash = this.getHash__I__I(index);
    if (((element0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(element0, element))) {
      return shallowlyMutableNodeMap;
    } else {
      var element0Hash = $m_sc_Hashing$().improve__I__I(element0UnimprovedHash);
      var subNodeNew = this.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(element0, element0UnimprovedHash, element0Hash, element, originalHash, elementHash, ((5 + shift) | 0));
      this.migrateFromInlineToNodeInPlace__I__I__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, element0Hash, subNodeNew);
      return (shallowlyMutableNodeMap | bitpos);
    }
  } else if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_SetNode(index$2);
    var subNodeSize = $n(subNode).size__I();
    var subNodeCachedJavaKeySetHashCode = $n(subNode).cachedJavaKeySetHashCode__I();
    var returnNodeMap = shallowlyMutableNodeMap;
    matchEnd4: {
      var subNodeNew$3;
      if ((subNode instanceof $c_sci_BitmapIndexedSetNode)) {
        var x2 = $as_sci_BitmapIndexedSetNode(subNode);
        if (((bitpos & shallowlyMutableNodeMap) !== 0)) {
          $n(x2).updateWithShallowMutations__O__I__I__I__I__I(element, originalHash, elementHash, ((5 + shift) | 0), 0);
          var subNodeNew$3 = x2;
          break matchEnd4;
        }
      }
      var subNodeNew$2 = $n(subNode).updated__O__I__I__I__sci_SetNode(element, originalHash, elementHash, ((5 + shift) | 0));
      if ((subNodeNew$2 !== subNode)) {
        returnNodeMap = (returnNodeMap | bitpos);
      }
      var subNodeNew$3 = subNodeNew$2;
    }
    $n(this.sci_BitmapIndexedSetNode__f_content).set((((((-1) + $n(this.sci_BitmapIndexedSetNode__f_content).u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0), subNodeNew$3);
    this.sci_BitmapIndexedSetNode__f_size = ((((this.sci_BitmapIndexedSetNode__f_size - subNodeSize) | 0) + $n(subNodeNew$3).size__I()) | 0);
    this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - subNodeCachedJavaKeySetHashCode) | 0) + $n(subNodeNew$3).cachedJavaKeySetHashCode__I()) | 0);
    return returnNodeMap;
  } else {
    var dataIx = this.dataIndex__I__I(bitpos);
    var src = this.sci_BitmapIndexedSetNode__f_content;
    var dst = new $ac_O(((1 + $n(src).u.length) | 0));
    $systemArraycopyRefs($n(src), 0, dst, 0, dataIx);
    $n(dst).set(dataIx, element);
    var destPos = ((1 + dataIx) | 0);
    var length = (($n(src).u.length - dataIx) | 0);
    $systemArraycopyRefs($n(src), dataIx, dst, destPos, length);
    var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx, originalHash);
    this.sci_BitmapIndexedSetNode__f_dataMap = (this.sci_BitmapIndexedSetNode__f_dataMap | bitpos);
    this.sci_BitmapIndexedSetNode__f_content = dst;
    this.sci_BitmapIndexedSetNode__f_originalHashes = dstHashes;
    this.sci_BitmapIndexedSetNode__f_size = ((1 + this.sci_BitmapIndexedSetNode__f_size) | 0);
    this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode + elementHash) | 0);
    return shallowlyMutableNodeMap;
  }
});
$c_sci_BitmapIndexedSetNode.prototype.removed__O__I__I__I__sci_BitmapIndexedSetNode = (function(element, originalHash, elementHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    var element0 = this.getPayload__I__O(index);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(element0, element)) {
      var i = this.sci_BitmapIndexedSetNode__f_dataMap;
      if (($m_jl_Integer$().bitCount__I__I(i) === 2)) {
        var i$1 = this.sci_BitmapIndexedSetNode__f_nodeMap;
        var $x_1 = ($m_jl_Integer$().bitCount__I__I(i$1) === 0);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var newDataMap = ((shift === 0) ? (this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos) : $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(elementHash, 0)));
        return ((index === 0) ? new $c_sci_BitmapIndexedSetNode(newDataMap, 0, new $ac_O([this.getPayload__I__O(1)]), new $ac_I(new Int32Array([$n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(1)])), (((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0), $m_sc_Hashing$().improve__I__I($n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(1))) : new $c_sci_BitmapIndexedSetNode(newDataMap, 0, new $ac_O([this.getPayload__I__O(0)]), new $ac_I(new Int32Array([$n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(0)])), (((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0), $m_sc_Hashing$().improve__I__I($n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(0))));
      } else {
        return this.copyAndRemoveValue__I__I__sci_BitmapIndexedSetNode(bitpos, elementHash);
      }
    } else {
      return this;
    }
  } else if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_SetNode(index$2);
    var subNodeNew = $n(subNode).removed__O__I__I__I__sci_SetNode(element, originalHash, elementHash, ((5 + shift) | 0));
    if ((subNodeNew === subNode)) {
      return this;
    } else {
      var x1 = $n(subNodeNew).size__I();
      return ((x1 === 1) ? ((this.sci_BitmapIndexedSetNode__f_size === $n(subNode).size__I()) ? $as_sci_BitmapIndexedSetNode(subNodeNew) : this.copyAndMigrateFromNodeToInline__I__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, elementHash, subNode, subNodeNew)) : ((x1 > 1) ? this.copyAndSetNode__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, subNode, subNodeNew) : this));
    }
  } else {
    return this;
  }
});
$c_sci_BitmapIndexedSetNode.prototype.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode = (function(key0, originalKeyHash0, keyHash0, key1, originalKeyHash1, keyHash1, shift) {
  if ((shift >= 32)) {
    var this$4 = $m_sci_Vector$();
    var array = [key0, key1];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return new $c_sci_HashCollisionSetNode(originalKeyHash0, keyHash0, this$4.from__sc_IterableOnce__sci_Vector(elems));
  } else {
    var mask0 = $m_sci_Node$().maskFrom__I__I__I(keyHash0, shift);
    var mask1 = $m_sci_Node$().maskFrom__I__I__I(keyHash1, shift);
    if ((mask0 !== mask1)) {
      var dataMap = ($m_sci_Node$().bitposFrom__I__I(mask0) | $m_sci_Node$().bitposFrom__I__I(mask1));
      var newCachedHashCode = ((keyHash0 + keyHash1) | 0);
      return ((mask0 < mask1) ? new $c_sci_BitmapIndexedSetNode(dataMap, 0, new $ac_O([key0, key1]), new $ac_I(new Int32Array([originalKeyHash0, originalKeyHash1])), 2, newCachedHashCode) : new $c_sci_BitmapIndexedSetNode(dataMap, 0, new $ac_O([key1, key0]), new $ac_I(new Int32Array([originalKeyHash1, originalKeyHash0])), 2, newCachedHashCode));
    } else {
      var nodeMap = $m_sci_Node$().bitposFrom__I__I(mask0);
      var node = this.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(key0, originalKeyHash0, keyHash0, key1, originalKeyHash1, keyHash1, ((5 + shift) | 0));
      return new $c_sci_BitmapIndexedSetNode(0, nodeMap, new $ac_O([node]), $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, $n(node).size__I(), $n(node).cachedJavaKeySetHashCode__I());
    }
  }
});
$c_sci_BitmapIndexedSetNode.prototype.hasPayload__Z = (function() {
  return (this.sci_BitmapIndexedSetNode__f_dataMap !== 0);
});
$c_sci_BitmapIndexedSetNode.prototype.payloadArity__I = (function() {
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_BitmapIndexedSetNode.prototype.hasNodes__Z = (function() {
  return (this.sci_BitmapIndexedSetNode__f_nodeMap !== 0);
});
$c_sci_BitmapIndexedSetNode.prototype.nodeArity__I = (function() {
  var i = this.sci_BitmapIndexedSetNode__f_nodeMap;
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_BitmapIndexedSetNode.prototype.dataIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedSetNode__f_dataMap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_BitmapIndexedSetNode.prototype.nodeIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedSetNode__f_nodeMap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndSetNode__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, oldNode, newNode) {
  var idx = (((((-1) + $n(this.sci_BitmapIndexedSetNode__f_content).u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O($n(src).u.length);
  var length = $n(src).u.length;
  $systemArraycopyRefs($n(src), 0, dst, 0, length);
  $n(dst).set(idx, newNode);
  return new $c_sci_BitmapIndexedSetNode(this.sci_BitmapIndexedSetNode__f_dataMap, this.sci_BitmapIndexedSetNode__f_nodeMap, dst, this.sci_BitmapIndexedSetNode__f_originalHashes, ((((this.sci_BitmapIndexedSetNode__f_size - $n(oldNode).size__I()) | 0) + $n(newNode).size__I()) | 0), ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - $n(oldNode).cachedJavaKeySetHashCode__I()) | 0) + $n(newNode).cachedJavaKeySetHashCode__I()) | 0));
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndInsertValue__I__O__I__I__sci_BitmapIndexedSetNode = (function(bitpos, key, originalHash, elementHash) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O(((1 + $n(src).u.length) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, dataIx);
  $n(dst).set(dataIx, key);
  var destPos = ((1 + dataIx) | 0);
  var length = (($n(src).u.length - dataIx) | 0);
  $systemArraycopyRefs($n(src), dataIx, dst, destPos, length);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx, originalHash);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap | bitpos), this.sci_BitmapIndexedSetNode__f_nodeMap, dst, dstHashes, ((1 + this.sci_BitmapIndexedSetNode__f_size) | 0), ((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode + elementHash) | 0));
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndRemoveValue__I__I__sci_BitmapIndexedSetNode = (function(bitpos, elementHash) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O((((-1) + $n(src).u.length) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, dataIx);
  var srcPos = ((1 + dataIx) | 0);
  var length = (((-1) + (($n(src).u.length - dataIx) | 0)) | 0);
  $systemArraycopyRefs($n(src), srcPos, dst, dataIx, length);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos), this.sci_BitmapIndexedSetNode__f_nodeMap, dst, dstHashes, (((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0), ((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - elementHash) | 0));
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndMigrateFromInlineToNode__I__I__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, elementHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxNew = (((((-1) + $n(this.sci_BitmapIndexedSetNode__f_content).u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O($n(src).u.length);
  $systemArraycopyRefs($n(src), 0, dst, 0, dataIx);
  var srcPos = ((1 + dataIx) | 0);
  var length = ((idxNew - dataIx) | 0);
  $systemArraycopyRefs($n(src), srcPos, dst, dataIx, length);
  $n(dst).set(idxNew, node);
  var srcPos$1 = ((1 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = (((-1) + (($n(src).u.length - idxNew) | 0)) | 0);
  $systemArraycopyRefs($n(src), srcPos$1, dst, destPos, length$1);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos), (this.sci_BitmapIndexedSetNode__f_nodeMap | bitpos), dst, dstHashes, (((((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0) + $n(node).size__I()) | 0), ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - elementHash) | 0) + $n(node).cachedJavaKeySetHashCode__I()) | 0));
});
$c_sci_BitmapIndexedSetNode.prototype.migrateFromInlineToNodeInPlace__I__I__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, keyHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxNew = (((((-1) + $n(this.sci_BitmapIndexedSetNode__f_content).u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var srcPos = ((1 + dataIx) | 0);
  var dest = this.sci_BitmapIndexedSetNode__f_content;
  var length = ((idxNew - dataIx) | 0);
  $systemArraycopyRefs($n(src), srcPos, $n(dest), dataIx, length);
  $n(this.sci_BitmapIndexedSetNode__f_content).set(idxNew, node);
  this.sci_BitmapIndexedSetNode__f_dataMap = (this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos);
  this.sci_BitmapIndexedSetNode__f_nodeMap = (this.sci_BitmapIndexedSetNode__f_nodeMap | bitpos);
  this.sci_BitmapIndexedSetNode__f_originalHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx);
  this.sci_BitmapIndexedSetNode__f_size = (((((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0) + $n(node).size__I()) | 0);
  this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - keyHash) | 0) + $n(node).cachedJavaKeySetHashCode__I()) | 0);
  return this;
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndMigrateFromNodeToInline__I__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, elementHash, oldNode, node) {
  var idxOld = (((((-1) + $n(this.sci_BitmapIndexedSetNode__f_content).u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var dataIxNew = this.dataIndex__I__I(bitpos);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O($n(src).u.length);
  $systemArraycopyRefs($n(src), 0, dst, 0, dataIxNew);
  $n(dst).set(dataIxNew, $n(node).getPayload__I__O(0));
  var destPos = ((1 + dataIxNew) | 0);
  var length = ((idxOld - dataIxNew) | 0);
  $systemArraycopyRefs($n(src), dataIxNew, dst, destPos, length);
  var srcPos = ((1 + idxOld) | 0);
  var destPos$1 = ((1 + idxOld) | 0);
  var length$1 = (((-1) + (($n(src).u.length - idxOld) | 0)) | 0);
  $systemArraycopyRefs($n(src), srcPos, dst, destPos$1, length$1);
  var hash = $n(node).getHash__I__I(0);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIxNew, hash);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap | bitpos), (this.sci_BitmapIndexedSetNode__f_nodeMap ^ bitpos), dst, dstHashes, ((1 + ((this.sci_BitmapIndexedSetNode__f_size - $n(oldNode).size__I()) | 0)) | 0), ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - $n(oldNode).cachedJavaKeySetHashCode__I()) | 0) + $n(node).cachedJavaKeySetHashCode__I()) | 0));
});
$c_sci_BitmapIndexedSetNode.prototype.foreach__F1__V = (function(f) {
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  var thisPayloadArity = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < thisPayloadArity)) {
    $n(f).apply__O__O(this.getPayload__I__O(i$1));
    i$1 = ((1 + i$1) | 0);
  }
  var i$2 = this.sci_BitmapIndexedSetNode__f_nodeMap;
  var thisNodeArity = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < thisNodeArity)) {
    $n(this.getNode__I__sci_SetNode(j)).foreach__F1__V(f);
    j = ((1 + j) | 0);
  }
});
$c_sci_BitmapIndexedSetNode.prototype.subsetOf__sci_SetNode__I__Z = (function(that, shift) {
  if ((this === that)) {
    return true;
  } else if ((!(that instanceof $c_sci_HashCollisionSetNode))) {
    if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
      var x3 = $as_sci_BitmapIndexedSetNode(that);
      var thisBitmap = (this.sci_BitmapIndexedSetNode__f_dataMap | this.sci_BitmapIndexedSetNode__f_nodeMap);
      var nodeBitmap = ($n(x3).sci_BitmapIndexedSetNode__f_dataMap | $n(x3).sci_BitmapIndexedSetNode__f_nodeMap);
      if (((thisBitmap | nodeBitmap) !== nodeBitmap)) {
        return false;
      }
      var bitmap = (thisBitmap & nodeBitmap);
      var i = bitmap;
      if ((i === 0)) {
        var bitsToSkip = 32;
      } else {
        var i$1 = (i & ((-i) | 0));
        var bitsToSkip = ((31 - $uI(Math.clz32(i$1))) | 0);
      }
      var isValidSubset = true;
      while ((isValidSubset && (bitsToSkip < 32))) {
        var bitpos = $m_sci_Node$().bitposFrom__I__I(bitsToSkip);
        if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
          if ((($n(x3).sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
            var payload0 = this.getPayload__I__O($m_sci_Node$().indexFrom__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, bitpos));
            var payload1 = $n(x3).getPayload__I__O($m_sci_Node$().indexFrom__I__I__I($n(x3).sci_BitmapIndexedSetNode__f_dataMap, bitpos));
            isValidSubset = $m_sr_BoxesRunTime$().equals__O__O__Z(payload0, payload1);
          } else {
            var thisDataIndex = $m_sci_Node$().indexFrom__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, bitpos);
            var payload = this.getPayload__I__O(thisDataIndex);
            var subNode = $n(that).getNode__I__sci_SetNode($m_sci_Node$().indexFrom__I__I__I($n(x3).sci_BitmapIndexedSetNode__f_nodeMap, bitpos));
            var elementUnimprovedHash = this.getHash__I__I(thisDataIndex);
            var elementHash = $m_sc_Hashing$().improve__I__I(elementUnimprovedHash);
            isValidSubset = $n(subNode).contains__O__I__I__I__Z(payload, elementUnimprovedHash, elementHash, ((5 + shift) | 0));
          }
        } else if ((($n(x3).sci_BitmapIndexedSetNode__f_dataMap & bitpos) === 0)) {
          var subNode0 = this.getNode__I__sci_SetNode($m_sci_Node$().indexFrom__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, bitpos));
          var subNode1 = $n(x3).getNode__I__sci_SetNode($m_sci_Node$().indexFrom__I__I__I($n(x3).sci_BitmapIndexedSetNode__f_nodeMap, bitpos));
          isValidSubset = $n(subNode0).subsetOf__sci_SetNode__I__Z(subNode1, ((5 + shift) | 0));
        } else {
          isValidSubset = false;
        }
        var newBitmap = (bitmap ^ bitpos);
        bitmap = newBitmap;
        if ((newBitmap === 0)) {
          bitsToSkip = 32;
        } else {
          var i$2 = (newBitmap & ((-newBitmap) | 0));
          bitsToSkip = ((31 - $uI(Math.clz32(i$2))) | 0);
        }
      }
      return isValidSubset;
    } else {
      throw new $c_s_MatchError(that);
    }
  } else {
    return false;
  }
});
$c_sci_BitmapIndexedSetNode.prototype.filterImpl__F1__Z__sci_BitmapIndexedSetNode = (function(pred, flipped) {
  if ((this.sci_BitmapIndexedSetNode__f_size === 0)) {
    return this;
  } else if ((this.sci_BitmapIndexedSetNode__f_size === 1)) {
    if (($uZ($n(pred).apply__O__O(this.getPayload__I__O(0))) !== flipped)) {
      return this;
    } else {
      var this$1 = $m_sci_SetNode$();
      return this$1.sci_SetNode$__f_EmptySetNode;
    }
  } else if ((this.sci_BitmapIndexedSetNode__f_nodeMap === 0)) {
    var i = this.sci_BitmapIndexedSetNode__f_dataMap;
    if ((i === 0)) {
      var minimumIndex = 32;
    } else {
      var i$1 = (i & ((-i) | 0));
      var minimumIndex = ((31 - $uI(Math.clz32(i$1))) | 0);
    }
    var i$2 = this.sci_BitmapIndexedSetNode__f_dataMap;
    var maximumIndex = ((32 - $uI(Math.clz32(i$2))) | 0);
    var newDataMap = 0;
    var newCachedHashCode = 0;
    var dataIndex = 0;
    var i$3 = minimumIndex;
    while ((i$3 < maximumIndex)) {
      var bitpos = $m_sci_Node$().bitposFrom__I__I(i$3);
      if (((bitpos & this.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
        var payload = this.getPayload__I__O(dataIndex);
        var passed = ($uZ($n(pred).apply__O__O(payload)) !== flipped);
        if (passed) {
          newDataMap = (newDataMap | bitpos);
          newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(this.getHash__I__I(dataIndex))) | 0);
        }
        dataIndex = ((1 + dataIndex) | 0);
      }
      i$3 = ((1 + i$3) | 0);
    }
    if ((newDataMap === 0)) {
      var this$4 = $m_sci_SetNode$();
      return this$4.sci_SetNode$__f_EmptySetNode;
    } else if ((newDataMap === this.sci_BitmapIndexedSetNode__f_dataMap)) {
      return this;
    } else {
      var i$4 = newDataMap;
      var newSize = $m_jl_Integer$().bitCount__I__I(i$4);
      var newContent = new $ac_O(newSize);
      var newOriginalHashCodes = new $ac_I(newSize);
      var i$5 = newDataMap;
      var newMaximumIndex = ((32 - $uI(Math.clz32(i$5))) | 0);
      var i$6 = newDataMap;
      if ((i$6 === 0)) {
        var j = 32;
      } else {
        var i$7 = (i$6 & ((-i$6) | 0));
        var j = ((31 - $uI(Math.clz32(i$7))) | 0);
      }
      var newDataIndex = 0;
      while ((j < newMaximumIndex)) {
        var bitpos$2 = $m_sci_Node$().bitposFrom__I__I(j);
        if (((bitpos$2 & newDataMap) !== 0)) {
          var oldIndex = $m_sci_Node$().indexFrom__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, bitpos$2);
          $n(newContent).set(newDataIndex, $n(this.sci_BitmapIndexedSetNode__f_content).get(oldIndex));
          $n(newOriginalHashCodes).set(newDataIndex, $n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(oldIndex));
          newDataIndex = ((1 + newDataIndex) | 0);
        }
        j = ((1 + j) | 0);
      }
      return new $c_sci_BitmapIndexedSetNode(newDataMap, 0, newContent, newOriginalHashCodes, newSize, newCachedHashCode);
    }
  } else {
    var allMap = (this.sci_BitmapIndexedSetNode__f_dataMap | this.sci_BitmapIndexedSetNode__f_nodeMap);
    if ((allMap === 0)) {
      var minimumIndex$2 = 32;
    } else {
      var i$8 = (allMap & ((-allMap) | 0));
      var minimumIndex$2 = ((31 - $uI(Math.clz32(i$8))) | 0);
    }
    var maximumIndex$2 = ((32 - $uI(Math.clz32(allMap))) | 0);
    var oldDataPassThrough = 0;
    var nodeMigrateToDataTargetMap = 0;
    var nodesToMigrateToData = null;
    var nodesToPassThroughMap = 0;
    var mapOfNewNodes = 0;
    var newNodes = null;
    var newDataMap$2 = 0;
    var newNodeMap = 0;
    var newSize$2 = 0;
    var newCachedHashCode$2 = 0;
    var dataIndex$2 = 0;
    var nodeIndex = 0;
    var i$2$1 = minimumIndex$2;
    while ((i$2$1 < maximumIndex$2)) {
      var bitpos$3 = $m_sci_Node$().bitposFrom__I__I(i$2$1);
      if (((bitpos$3 & this.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
        var payload$2 = this.getPayload__I__O(dataIndex$2);
        var passed$2 = ($uZ($n(pred).apply__O__O(payload$2)) !== flipped);
        if (passed$2) {
          newDataMap$2 = (newDataMap$2 | bitpos$3);
          oldDataPassThrough = (oldDataPassThrough | bitpos$3);
          newSize$2 = ((1 + newSize$2) | 0);
          newCachedHashCode$2 = ((newCachedHashCode$2 + $m_sc_Hashing$().improve__I__I(this.getHash__I__I(dataIndex$2))) | 0);
        }
        dataIndex$2 = ((1 + dataIndex$2) | 0);
      } else if (((bitpos$3 & this.sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
        var oldSubNode = this.getNode__I__sci_SetNode(nodeIndex);
        var newSubNode = $n(oldSubNode).filterImpl__F1__Z__sci_SetNode(pred, flipped);
        newSize$2 = ((newSize$2 + $n(newSubNode).size__I()) | 0);
        newCachedHashCode$2 = ((newCachedHashCode$2 + $n(newSubNode).cachedJavaKeySetHashCode__I()) | 0);
        if (($n(newSubNode).size__I() > 1)) {
          newNodeMap = (newNodeMap | bitpos$3);
          if ((oldSubNode === newSubNode)) {
            nodesToPassThroughMap = (nodesToPassThroughMap | bitpos$3);
          } else {
            mapOfNewNodes = (mapOfNewNodes | bitpos$3);
            if ((newNodes === null)) {
              newNodes = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
            }
            var this$10 = $n(newNodes);
            this$10.addOne__O__scm_ArrayDeque(newSubNode);
          }
        } else if (($n(newSubNode).size__I() === 1)) {
          newDataMap$2 = (newDataMap$2 | bitpos$3);
          nodeMigrateToDataTargetMap = (nodeMigrateToDataTargetMap | bitpos$3);
          if ((nodesToMigrateToData === null)) {
            nodesToMigrateToData = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
          }
          var this$12 = $n(nodesToMigrateToData);
          this$12.addOne__O__scm_ArrayDeque(newSubNode);
        }
        nodeIndex = ((1 + nodeIndex) | 0);
      }
      i$2$1 = ((1 + i$2$1) | 0);
    }
    return $p_sci_BitmapIndexedSetNode__newNodeFrom__I__I__I__I__I__I__I__scm_Queue__I__scm_Queue__I__sci_BitmapIndexedSetNode(this, newSize$2, newDataMap$2, newNodeMap, minimumIndex$2, oldDataPassThrough, nodesToPassThroughMap, nodeMigrateToDataTargetMap, nodesToMigrateToData, mapOfNewNodes, newNodes, newCachedHashCode$2);
  }
});
$c_sci_BitmapIndexedSetNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    var x2 = $as_sci_BitmapIndexedSetNode(that);
    if ((this === x2)) {
      return true;
    } else {
      if (((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode === $n(x2).sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode) && (this.sci_BitmapIndexedSetNode__f_nodeMap === $n(x2).sci_BitmapIndexedSetNode__f_nodeMap)) && (this.sci_BitmapIndexedSetNode__f_dataMap === $n(x2).sci_BitmapIndexedSetNode__f_dataMap)) && (this.sci_BitmapIndexedSetNode__f_size === $n(x2).sci_BitmapIndexedSetNode__f_size))) {
        var a = this.sci_BitmapIndexedSetNode__f_originalHashes;
        var b = $n(x2).sci_BitmapIndexedSetNode__f_originalHashes;
        var $x_1 = $m_ju_Arrays$().equals__AI__AI__Z(a, b);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var a1 = this.sci_BitmapIndexedSetNode__f_content;
        var a2 = $n(x2).sci_BitmapIndexedSetNode__f_content;
        var length = $n(this.sci_BitmapIndexedSetNode__f_content).u.length;
        if ((a1 === a2)) {
          return true;
        } else {
          var isEqual = true;
          var i = 0;
          while ((isEqual && (i < length))) {
            isEqual = $m_sr_BoxesRunTime$().equals__O__O__Z($n(a1).get(i), $n(a2).get(i));
            i = ((1 + i) | 0);
          }
          return isEqual;
        }
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$c_sci_BitmapIndexedSetNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.");
});
$c_sci_BitmapIndexedSetNode.prototype.toString__T = (function() {
  var $x_1 = $m_sc_StringOps$();
  var array = [this.sci_BitmapIndexedSetNode__f_size, this.sci_BitmapIndexedSetNode__f_dataMap, this.sci_BitmapIndexedSetNode__f_nodeMap];
  return $n($x_1).format$extension__T__sci_Seq__T("BitmapIndexedSetNode(size=%s, dataMap=%x, nodeMap=%x)", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
});
$c_sci_BitmapIndexedSetNode.prototype.copy__sci_BitmapIndexedSetNode = (function() {
  var this$1 = $n(this.sci_BitmapIndexedSetNode__f_content);
  var contentClone = $n(this$1).clone__O();
  var contentLength = $n(contentClone).u.length;
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  var i$1 = $m_jl_Integer$().bitCount__I__I(i);
  while ((i$1 < contentLength)) {
    $n(contentClone).set(i$1, $n($as_sci_SetNode($n(contentClone).get(i$1))).copy__sci_SetNode());
    i$1 = ((1 + i$1) | 0);
  }
  var $x_2 = this.sci_BitmapIndexedSetNode__f_dataMap;
  var $x_1 = this.sci_BitmapIndexedSetNode__f_nodeMap;
  var this$2 = $n(this.sci_BitmapIndexedSetNode__f_originalHashes);
  return new $c_sci_BitmapIndexedSetNode($x_2, $x_1, contentClone, $n(this$2).clone__O(), this.sci_BitmapIndexedSetNode__f_size, this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode);
});
$c_sci_BitmapIndexedSetNode.prototype.concat__sci_SetNode__I__sci_BitmapIndexedSetNode = (function(that, shift) {
  if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    var x2 = $as_sci_BitmapIndexedSetNode(that);
    if ((this.sci_BitmapIndexedSetNode__f_size === 0)) {
      return x2;
    } else if ((($n(x2).sci_BitmapIndexedSetNode__f_size === 0) || (x2 === this))) {
      return this;
    } else if (($n(x2).sci_BitmapIndexedSetNode__f_size === 1)) {
      var originalHash = $n(x2).getHash__I__I(0);
      return this.updated__O__I__I__I__sci_BitmapIndexedSetNode($n(x2).getPayload__I__O(0), originalHash, $m_sc_Hashing$().improve__I__I(originalHash), shift);
    }
    var anyChangesMadeSoFar = false;
    var allMap = (((this.sci_BitmapIndexedSetNode__f_dataMap | $n(x2).sci_BitmapIndexedSetNode__f_dataMap) | this.sci_BitmapIndexedSetNode__f_nodeMap) | $n(x2).sci_BitmapIndexedSetNode__f_nodeMap);
    var $x_2 = $m_sci_Node$();
    if ((allMap === 0)) {
      var $x_1 = 32;
    } else {
      var i = (allMap & ((-allMap) | 0));
      var $x_1 = ((31 - $uI(Math.clz32(i))) | 0);
    }
    var minimumBitPos = $n($x_2).bitposFrom__I__I($x_1);
    var maximumBitPos = $m_sci_Node$().bitposFrom__I__I(((31 - $uI(Math.clz32(allMap))) | 0));
    var leftNodeRightNode = 0;
    var leftDataRightNode = 0;
    var leftNodeRightData = 0;
    var leftDataOnly = 0;
    var rightDataOnly = 0;
    var leftNodeOnly = 0;
    var rightNodeOnly = 0;
    var leftDataRightDataMigrateToNode = 0;
    var leftDataRightDataLeftOverwrites = 0;
    var dataToNodeMigrationTargets = 0;
    var bitpos = minimumBitPos;
    var leftIdx = 0;
    var rightIdx = 0;
    var finished = false;
    while ((!finished)) {
      if (((bitpos & this.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
        if (((bitpos & $n(x2).sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
          if (((this.getHash__I__I(leftIdx) === $n(x2).getHash__I__I(rightIdx)) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.getPayload__I__O(leftIdx), $n(x2).getPayload__I__O(rightIdx)))) {
            leftDataRightDataLeftOverwrites = (leftDataRightDataLeftOverwrites | bitpos);
          } else {
            leftDataRightDataMigrateToNode = (leftDataRightDataMigrateToNode | bitpos);
            dataToNodeMigrationTargets = (dataToNodeMigrationTargets | $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I($m_sc_Hashing$().improve__I__I(this.getHash__I__I(leftIdx)), shift)));
          }
          rightIdx = ((1 + rightIdx) | 0);
        } else if (((bitpos & $n(x2).sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
          leftDataRightNode = (leftDataRightNode | bitpos);
        } else {
          leftDataOnly = (leftDataOnly | bitpos);
        }
        leftIdx = ((1 + leftIdx) | 0);
      } else if (((bitpos & this.sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
        if (((bitpos & $n(x2).sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
          leftNodeRightData = (leftNodeRightData | bitpos);
          rightIdx = ((1 + rightIdx) | 0);
        } else if (((bitpos & $n(x2).sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
          leftNodeRightNode = (leftNodeRightNode | bitpos);
        } else {
          leftNodeOnly = (leftNodeOnly | bitpos);
        }
      } else if (((bitpos & $n(x2).sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
        rightDataOnly = (rightDataOnly | bitpos);
        rightIdx = ((1 + rightIdx) | 0);
      } else if (((bitpos & $n(x2).sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
        rightNodeOnly = (rightNodeOnly | bitpos);
      }
      if ((bitpos === maximumBitPos)) {
        finished = true;
      } else {
        bitpos = (bitpos << 1);
      }
    }
    var newDataMap = ((leftDataOnly | rightDataOnly) | leftDataRightDataLeftOverwrites);
    var newNodeMap = (((((leftNodeRightNode | leftDataRightNode) | leftNodeRightData) | leftNodeOnly) | rightNodeOnly) | dataToNodeMigrationTargets);
    if (((newDataMap === (leftDataOnly | leftDataRightDataLeftOverwrites)) && (newNodeMap === leftNodeOnly))) {
      return this;
    }
    var newDataSize = $m_jl_Integer$().bitCount__I__I(newDataMap);
    var newContentSize = ((newDataSize + $m_jl_Integer$().bitCount__I__I(newNodeMap)) | 0);
    var newContent = new $ac_O(newContentSize);
    var newOriginalHashes = new $ac_I(newDataSize);
    var newSize = 0;
    var newCachedHashCode = 0;
    var leftDataIdx = 0;
    var rightDataIdx = 0;
    var leftNodeIdx = 0;
    var rightNodeIdx = 0;
    var nextShift = ((5 + shift) | 0);
    var compressedDataIdx = 0;
    var compressedNodeIdx = 0;
    var bitpos$2 = minimumBitPos;
    var finished$2 = false;
    while ((!finished$2)) {
      if (((bitpos$2 & leftNodeRightNode) !== 0)) {
        var leftNode = this.getNode__I__sci_SetNode(leftNodeIdx);
        var newNode = $n(leftNode).concat__sci_SetNode__I__sci_SetNode($n(x2).getNode__I__sci_SetNode(rightNodeIdx), nextShift);
        if ((leftNode !== newNode)) {
          anyChangesMadeSoFar = true;
        }
        $n(newContent).set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        newSize = ((newSize + $n(newNode).size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + $n(newNode).cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & leftDataRightNode) !== 0)) {
        anyChangesMadeSoFar = true;
        var n = $n(x2).getNode__I__sci_SetNode(rightNodeIdx);
        var leftPayload = this.getPayload__I__O(leftDataIdx);
        var leftOriginalHash = this.getHash__I__I(leftDataIdx);
        var leftImproved = $m_sc_Hashing$().improve__I__I(leftOriginalHash);
        var newNode$2 = $n(n).updated__O__I__I__I__sci_SetNode(leftPayload, leftOriginalHash, leftImproved, nextShift);
        $n(newContent).set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$2);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        newSize = ((newSize + $n(newNode$2).size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + $n(newNode$2).cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & leftNodeRightData) !== 0)) {
        var rightOriginalHash = $n(x2).getHash__I__I(rightDataIdx);
        var leftNode$2 = this.getNode__I__sci_SetNode(leftNodeIdx);
        var updated = $n(leftNode$2).updated__O__I__I__I__sci_SetNode($n(x2).getPayload__I__O(rightDataIdx), $n(x2).getHash__I__I(rightDataIdx), $m_sc_Hashing$().improve__I__I(rightOriginalHash), nextShift);
        if ((updated !== leftNode$2)) {
          anyChangesMadeSoFar = true;
        }
        $n(newContent).set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), updated);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((newSize + $n(updated).size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + $n(updated).cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & leftDataOnly) !== 0)) {
        var originalHash$2 = $n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(leftDataIdx);
        $n(newContent).set(compressedDataIdx, this.getPayload__I__O(leftDataIdx));
        $n(newOriginalHashes).set(compressedDataIdx, originalHash$2);
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$2)) | 0);
      } else if (((bitpos$2 & rightDataOnly) !== 0)) {
        anyChangesMadeSoFar = true;
        var originalHash$3 = $n($n(x2).sci_BitmapIndexedSetNode__f_originalHashes).get(rightDataIdx);
        $n(newContent).set(compressedDataIdx, $n(x2).getPayload__I__O(rightDataIdx));
        $n(newOriginalHashes).set(compressedDataIdx, originalHash$3);
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$3)) | 0);
      } else if (((bitpos$2 & leftNodeOnly) !== 0)) {
        var newNode$4 = this.getNode__I__sci_SetNode(leftNodeIdx);
        $n(newContent).set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$4);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        newSize = ((newSize + $n(newNode$4).size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + $n(newNode$4).cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & rightNodeOnly) !== 0)) {
        anyChangesMadeSoFar = true;
        var newNode$5 = $n(x2).getNode__I__sci_SetNode(rightNodeIdx);
        $n(newContent).set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$5);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        newSize = ((newSize + $n(newNode$5).size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + $n(newNode$5).cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & leftDataRightDataMigrateToNode) !== 0)) {
        anyChangesMadeSoFar = true;
        var leftOriginalHash$2 = this.getHash__I__I(leftDataIdx);
        var rightOriginalHash$2 = $n(x2).getHash__I__I(rightDataIdx);
        var newNode$6 = $n(x2).mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(this.getPayload__I__O(leftDataIdx), leftOriginalHash$2, $m_sc_Hashing$().improve__I__I(leftOriginalHash$2), $n(x2).getPayload__I__O(rightDataIdx), rightOriginalHash$2, $m_sc_Hashing$().improve__I__I(rightOriginalHash$2), nextShift);
        $n(newContent).set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$6);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((newSize + $n(newNode$6).size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + $n(newNode$6).cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & leftDataRightDataLeftOverwrites) !== 0)) {
        var originalHash$4 = $n($n(x2).sci_BitmapIndexedSetNode__f_originalHashes).get(rightDataIdx);
        $n(newContent).set(compressedDataIdx, $n(x2).getPayload__I__O(rightDataIdx));
        $n(newOriginalHashes).set(compressedDataIdx, originalHash$4);
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$4)) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
      }
      if ((bitpos$2 === maximumBitPos)) {
        finished$2 = true;
      } else {
        bitpos$2 = (bitpos$2 << 1);
      }
    }
    return (anyChangesMadeSoFar ? new $c_sci_BitmapIndexedSetNode(newDataMap, newNodeMap, newContent, newOriginalHashes, newSize, newCachedHashCode) : this);
  } else {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Cannot concatenate a HashCollisionSetNode with a BitmapIndexedSetNode");
  }
});
$c_sci_BitmapIndexedSetNode.prototype.foreachWithHash__F2__V = (function(f) {
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < iN)) {
    $n(f).apply__O__O__O(this.getPayload__I__O(i$1), this.getHash__I__I(i$1));
    i$1 = ((1 + i$1) | 0);
  }
  var i$2 = this.sci_BitmapIndexedSetNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    $n(this.getNode__I__sci_SetNode(j)).foreachWithHash__F2__V(f);
    j = ((1 + j) | 0);
  }
});
$c_sci_BitmapIndexedSetNode.prototype.concat__sci_SetNode__I__sci_SetNode = (function(that, shift) {
  return this.concat__sci_SetNode__I__sci_BitmapIndexedSetNode(that, shift);
});
$c_sci_BitmapIndexedSetNode.prototype.copy__sci_SetNode = (function() {
  return this.copy__sci_BitmapIndexedSetNode();
});
$c_sci_BitmapIndexedSetNode.prototype.filterImpl__F1__Z__sci_SetNode = (function(pred, flipped) {
  return this.filterImpl__F1__Z__sci_BitmapIndexedSetNode(pred, flipped);
});
$c_sci_BitmapIndexedSetNode.prototype.removed__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  return this.removed__O__I__I__I__sci_BitmapIndexedSetNode(element, originalHash, hash, shift);
});
$c_sci_BitmapIndexedSetNode.prototype.updated__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  return this.updated__O__I__I__I__sci_BitmapIndexedSetNode(element, originalHash, hash, shift);
});
$c_sci_BitmapIndexedSetNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_SetNode(index);
});
function $as_sci_BitmapIndexedSetNode(obj) {
  return (((obj instanceof $c_sci_BitmapIndexedSetNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.BitmapIndexedSetNode"));
}
function $isArrayOf_sci_BitmapIndexedSetNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BitmapIndexedSetNode)));
}
function $asArrayOf_sci_BitmapIndexedSetNode(obj, depth) {
  return (($isArrayOf_sci_BitmapIndexedSetNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.BitmapIndexedSetNode;", depth));
}
var $d_sci_BitmapIndexedSetNode = new $TypeData().initClass($c_sci_BitmapIndexedSetNode, "scala.collection.immutable.BitmapIndexedSetNode", ({
  sci_BitmapIndexedSetNode: 1,
  sci_SetNode: 1,
  sci_Node: 1
}));
/** @constructor */
function $c_sci_HashCollisionMapNode(originalHash, hash, content) {
  this.sci_HashCollisionMapNode__f_originalHash = 0;
  this.sci_HashCollisionMapNode__f_hash = 0;
  this.sci_HashCollisionMapNode__f_content = null;
  this.sci_HashCollisionMapNode__f_originalHash = originalHash;
  this.sci_HashCollisionMapNode__f_hash = hash;
  this.sci_HashCollisionMapNode__f_content = content;
  $m_s_Predef$().require__Z__V(($n(this.sci_HashCollisionMapNode__f_content).length__I() >= 2));
}
$c_sci_HashCollisionMapNode.prototype = new $h_sci_MapNode();
$c_sci_HashCollisionMapNode.prototype.constructor = $c_sci_HashCollisionMapNode;
/** @constructor */
function $h_sci_HashCollisionMapNode() {
}
$h_sci_HashCollisionMapNode.prototype = $c_sci_HashCollisionMapNode.prototype;
$c_sci_HashCollisionMapNode.prototype.indexOf__O__I = (function(key) {
  var iter = $n(this.sci_HashCollisionMapNode__f_content).iterator__sc_Iterator();
  var i = 0;
  while ($n(iter).hasNext__Z()) {
    if ($m_sr_BoxesRunTime$().equals__O__O__Z($n($as_T2($n(iter).next__O()))._1__O(), key)) {
      return i;
    }
    i = ((1 + i) | 0);
  }
  return (-1);
});
$c_sci_HashCollisionMapNode.prototype.size__I = (function() {
  return $n(this.sci_HashCollisionMapNode__f_content).length__I();
});
$c_sci_HashCollisionMapNode.prototype.apply__O__I__I__I__O = (function(key, originalHash, hash, shift) {
  var this$1 = $n(this.get__O__I__I__I__s_Option(key, originalHash, hash, shift));
  if (this$1.isEmpty__Z()) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
    throw $ct_jl_ClassCastException__(new $c_jl_ClassCastException());
  } else {
    return this$1.get__O();
  }
});
$c_sci_HashCollisionMapNode.prototype.get__O__I__I__I__s_Option = (function(key, originalHash, hash, shift) {
  if ((this.sci_HashCollisionMapNode__f_hash === hash)) {
    var index = this.indexOf__O__I(key);
    return ((index >= 0) ? new $c_s_Some($n($as_T2($n(this.sci_HashCollisionMapNode__f_content).apply__I__O(index)))._2__O()) : $m_s_None$());
  } else {
    return $m_s_None$();
  }
});
$c_sci_HashCollisionMapNode.prototype.getOrElse__O__I__I__I__F0__O = (function(key, originalHash, hash, shift, f) {
  if ((this.sci_HashCollisionMapNode__f_hash === hash)) {
    var x1 = this.indexOf__O__I(key);
    return ((x1 === (-1)) ? $n(f).apply__O() : $n($as_T2($n(this.sci_HashCollisionMapNode__f_content).apply__I__O(x1)))._2__O());
  } else {
    return $n(f).apply__O();
  }
});
$c_sci_HashCollisionMapNode.prototype.containsKey__O__I__I__I__Z = (function(key, originalHash, hash, shift) {
  return ((this.sci_HashCollisionMapNode__f_hash === hash) && (this.indexOf__O__I(key) >= 0));
});
$c_sci_HashCollisionMapNode.prototype.updated__O__O__I__I__I__Z__sci_MapNode = (function(key, value, originalHash, hash, shift, replaceValue) {
  var index = this.indexOf__O__I(key);
  return ((index >= 0) ? (replaceValue ? (Object.is($n($as_T2($n(this.sci_HashCollisionMapNode__f_content).apply__I__O(index)))._2__O(), value) ? this : new $c_sci_HashCollisionMapNode(originalHash, hash, $n(this.sci_HashCollisionMapNode__f_content).updated__I__O__sci_Vector(index, new $c_T2(key, value)))) : this) : new $c_sci_HashCollisionMapNode(originalHash, hash, $n(this.sci_HashCollisionMapNode__f_content).appended__O__sci_Vector(new $c_T2(key, value))));
});
$c_sci_HashCollisionMapNode.prototype.removed__O__I__I__I__sci_MapNode = (function(key, originalHash, hash, shift) {
  if ((!this.containsKey__O__I__I__I__Z(key, originalHash, hash, shift))) {
    return this;
  } else {
    var this$2 = $n(this.sci_HashCollisionMapNode__f_content);
    var pred = new $c_sjsr_AnonFunction1(((keyValuePair$2) => {
      var keyValuePair = $as_T2(keyValuePair$2);
      return $m_sr_BoxesRunTime$().equals__O__O__Z($n(keyValuePair)._1__O(), key);
    }));
    var updatedContent = this$2.filterImpl__F1__Z__sci_Vector(pred, true);
    var this$3 = $n(updatedContent);
    var x1 = this$3.length__I();
    if ((x1 === 1)) {
      var x1$2 = $as_T2($n(updatedContent).apply__I__O(0));
      if ((x1$2 === null)) {
        throw new $c_s_MatchError(x1$2);
      }
      var k = $n(x1$2)._1__O();
      var v = $n(x1$2)._2__O();
      return new $c_sci_BitmapIndexedMapNode($m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(hash, 0)), 0, new $ac_O([k, v]), new $ac_I(new Int32Array([originalHash])), 1, hash);
    } else {
      return new $c_sci_HashCollisionMapNode(originalHash, hash, updatedContent);
    }
  }
});
$c_sci_HashCollisionMapNode.prototype.hasNodes__Z = (function() {
  return false;
});
$c_sci_HashCollisionMapNode.prototype.nodeArity__I = (function() {
  return 0;
});
$c_sci_HashCollisionMapNode.prototype.getNode__I__sci_MapNode = (function(index) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), "No sub-nodes present in hash-collision leaf node.");
});
$c_sci_HashCollisionMapNode.prototype.hasPayload__Z = (function() {
  return true;
});
$c_sci_HashCollisionMapNode.prototype.payloadArity__I = (function() {
  return $n(this.sci_HashCollisionMapNode__f_content).length__I();
});
$c_sci_HashCollisionMapNode.prototype.getKey__I__O = (function(index) {
  return $n($as_T2($n(this.sci_HashCollisionMapNode__f_content).apply__I__O(index)))._1__O();
});
$c_sci_HashCollisionMapNode.prototype.getValue__I__O = (function(index) {
  return $n($as_T2($n(this.sci_HashCollisionMapNode__f_content).apply__I__O(index)))._2__O();
});
$c_sci_HashCollisionMapNode.prototype.getPayload__I__T2 = (function(index) {
  return $as_T2($n(this.sci_HashCollisionMapNode__f_content).apply__I__O(index));
});
$c_sci_HashCollisionMapNode.prototype.getHash__I__I = (function(index) {
  return this.sci_HashCollisionMapNode__f_originalHash;
});
$c_sci_HashCollisionMapNode.prototype.foreach__F1__V = (function(f) {
  $n(this.sci_HashCollisionMapNode__f_content).foreach__F1__V(f);
});
$c_sci_HashCollisionMapNode.prototype.foreachEntry__F2__V = (function(f) {
  $n(this.sci_HashCollisionMapNode__f_content).foreach__F1__V(new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var k = $n(x0$1)._1__O();
      var v = $n(x0$1)._2__O();
      return $n(f).apply__O__O__O(k, v);
    } else {
      throw new $c_s_MatchError(x0$1);
    }
  })));
});
$c_sci_HashCollisionMapNode.prototype.foreachWithHash__F3__V = (function(f) {
  var iter = $n(this.sci_HashCollisionMapNode__f_content).iterator__sc_Iterator();
  while ($n(iter).hasNext__Z()) {
    var next = $as_T2($n(iter).next__O());
    $n(f).apply__O__O__O__O($n(next)._1__O(), $n(next)._2__O(), this.sci_HashCollisionMapNode__f_originalHash);
  }
});
$c_sci_HashCollisionMapNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashCollisionMapNode)) {
    var x2 = $as_sci_HashCollisionMapNode(that);
    if ((this === x2)) {
      return true;
    } else if (((this.sci_HashCollisionMapNode__f_hash === $n(x2).sci_HashCollisionMapNode__f_hash) && ($n(this.sci_HashCollisionMapNode__f_content).length__I() === $n($n(x2).sci_HashCollisionMapNode__f_content).length__I()))) {
      var iter = $n(this.sci_HashCollisionMapNode__f_content).iterator__sc_Iterator();
      while ($n(iter).hasNext__Z()) {
        var x1$2 = $as_T2($n(iter).next__O());
        if ((x1$2 === null)) {
          throw new $c_s_MatchError(x1$2);
        }
        var key = $n(x1$2)._1__O();
        var value = $n(x1$2)._2__O();
        var index = $n(x2).indexOf__O__I(key);
        if (((index < 0) || (!$m_sr_BoxesRunTime$().equals__O__O__Z(value, $n($as_T2($n($n(x2).sci_HashCollisionMapNode__f_content).apply__I__O(index)))._2__O())))) {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_sci_HashCollisionMapNode.prototype.concat__sci_MapNode__I__sci_HashCollisionMapNode = (function(that, shift) {
  if ((that instanceof $c_sci_HashCollisionMapNode)) {
    var x2 = $as_sci_HashCollisionMapNode(that);
    if ((x2 === this)) {
      return this;
    } else {
      var newContent = null;
      var iter = $n(this.sci_HashCollisionMapNode__f_content).iterator__sc_Iterator();
      while ($n(iter).hasNext__Z()) {
        var nextPayload = $as_T2($n(iter).next__O());
        if (($n(x2).indexOf__O__I($n(nextPayload)._1__O()) < 0)) {
          if ((newContent === null)) {
            newContent = new $c_sci_VectorBuilder();
            $n(newContent).addAll__sc_IterableOnce__sci_VectorBuilder($n(x2).sci_HashCollisionMapNode__f_content);
          }
          $n(newContent).addOne__O__sci_VectorBuilder(nextPayload);
        }
      }
      return ((newContent === null) ? x2 : new $c_sci_HashCollisionMapNode(this.sci_HashCollisionMapNode__f_originalHash, this.sci_HashCollisionMapNode__f_hash, $n(newContent).result__sci_Vector()));
    }
  } else if ((that instanceof $c_sci_BitmapIndexedMapNode)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Cannot concatenate a HashCollisionMapNode with a BitmapIndexedMapNode");
  } else {
    throw new $c_s_MatchError(that);
  }
});
$c_sci_HashCollisionMapNode.prototype.filterImpl__F1__Z__sci_MapNode = (function(pred, flipped) {
  var newContent = $n(this.sci_HashCollisionMapNode__f_content).filterImpl__F1__Z__sci_Vector(pred, flipped);
  var newContentLength = $n(newContent).length__I();
  if ((newContentLength === 0)) {
    var this$1 = $m_sci_MapNode$();
    return this$1.sci_MapNode$__f_EmptyMapNode;
  } else if ((newContentLength === 1)) {
    var x1 = $as_T2($n(newContent).head__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = $n(x1)._1__O();
    var v = $n(x1)._2__O();
    return new $c_sci_BitmapIndexedMapNode($m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(this.sci_HashCollisionMapNode__f_hash, 0)), 0, new $ac_O([k, v]), new $ac_I(new Int32Array([this.sci_HashCollisionMapNode__f_originalHash])), 1, this.sci_HashCollisionMapNode__f_hash);
  } else {
    return ((newContentLength === $n(this.sci_HashCollisionMapNode__f_content).length__I()) ? this : new $c_sci_HashCollisionMapNode(this.sci_HashCollisionMapNode__f_originalHash, this.sci_HashCollisionMapNode__f_hash, newContent));
  }
});
$c_sci_HashCollisionMapNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.");
});
$c_sci_HashCollisionMapNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return Math.imul($n(this.sci_HashCollisionMapNode__f_content).length__I(), this.sci_HashCollisionMapNode__f_hash);
});
$c_sci_HashCollisionMapNode.prototype.copy__sci_MapNode = (function() {
  return new $c_sci_HashCollisionMapNode(this.sci_HashCollisionMapNode__f_originalHash, this.sci_HashCollisionMapNode__f_hash, this.sci_HashCollisionMapNode__f_content);
});
$c_sci_HashCollisionMapNode.prototype.concat__sci_MapNode__I__sci_MapNode = (function(that, shift) {
  return this.concat__sci_MapNode__I__sci_HashCollisionMapNode(that, shift);
});
$c_sci_HashCollisionMapNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_MapNode(index);
});
function $as_sci_HashCollisionMapNode(obj) {
  return (((obj instanceof $c_sci_HashCollisionMapNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashCollisionMapNode"));
}
function $isArrayOf_sci_HashCollisionMapNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashCollisionMapNode)));
}
function $asArrayOf_sci_HashCollisionMapNode(obj, depth) {
  return (($isArrayOf_sci_HashCollisionMapNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashCollisionMapNode;", depth));
}
var $d_sci_HashCollisionMapNode = new $TypeData().initClass($c_sci_HashCollisionMapNode, "scala.collection.immutable.HashCollisionMapNode", ({
  sci_HashCollisionMapNode: 1,
  sci_MapNode: 1,
  sci_Node: 1
}));
/** @constructor */
function $c_sci_HashCollisionSetNode(originalHash, hash, content) {
  this.sci_HashCollisionSetNode__f_originalHash = 0;
  this.sci_HashCollisionSetNode__f_hash = 0;
  this.sci_HashCollisionSetNode__f_content = null;
  this.sci_HashCollisionSetNode__f_originalHash = originalHash;
  this.sci_HashCollisionSetNode__f_hash = hash;
  this.sci_HashCollisionSetNode__f_content = content;
  $m_s_Predef$().require__Z__V(($n(this.sci_HashCollisionSetNode__f_content).length__I() >= 2));
}
$c_sci_HashCollisionSetNode.prototype = new $h_sci_SetNode();
$c_sci_HashCollisionSetNode.prototype.constructor = $c_sci_HashCollisionSetNode;
/** @constructor */
function $h_sci_HashCollisionSetNode() {
}
$h_sci_HashCollisionSetNode.prototype = $c_sci_HashCollisionSetNode.prototype;
$c_sci_HashCollisionSetNode.prototype.contains__O__I__I__I__Z = (function(element, originalHash, hash, shift) {
  if ((this.sci_HashCollisionSetNode__f_hash === hash)) {
    var this$1 = $n(this.sci_HashCollisionSetNode__f_content);
    return $f_sc_SeqOps__contains__O__Z(this$1, element);
  } else {
    return false;
  }
});
$c_sci_HashCollisionSetNode.prototype.updated__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  return (this.contains__O__I__I__I__Z(element, originalHash, hash, shift) ? this : new $c_sci_HashCollisionSetNode(originalHash, hash, $n(this.sci_HashCollisionSetNode__f_content).appended__O__sci_Vector(element)));
});
$c_sci_HashCollisionSetNode.prototype.removed__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  if ((!this.contains__O__I__I__I__Z(element, originalHash, hash, shift))) {
    return this;
  } else {
    var this$2 = $n(this.sci_HashCollisionSetNode__f_content);
    var pred = new $c_sjsr_AnonFunction1(((element0$2) => $m_sr_BoxesRunTime$().equals__O__O__Z(element0$2, element)));
    var updatedContent = this$2.filterImpl__F1__Z__sci_Vector(pred, true);
    var this$3 = $n(updatedContent);
    var x1 = this$3.length__I();
    return ((x1 === 1) ? new $c_sci_BitmapIndexedSetNode($m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(hash, 0)), 0, new $ac_O([$n(updatedContent).apply__I__O(0)]), new $ac_I(new Int32Array([originalHash])), 1, hash) : new $c_sci_HashCollisionSetNode(originalHash, hash, updatedContent));
  }
});
$c_sci_HashCollisionSetNode.prototype.hasNodes__Z = (function() {
  return false;
});
$c_sci_HashCollisionSetNode.prototype.nodeArity__I = (function() {
  return 0;
});
$c_sci_HashCollisionSetNode.prototype.getNode__I__sci_SetNode = (function(index) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), "No sub-nodes present in hash-collision leaf node.");
});
$c_sci_HashCollisionSetNode.prototype.hasPayload__Z = (function() {
  return true;
});
$c_sci_HashCollisionSetNode.prototype.payloadArity__I = (function() {
  return $n(this.sci_HashCollisionSetNode__f_content).length__I();
});
$c_sci_HashCollisionSetNode.prototype.getPayload__I__O = (function(index) {
  return $n(this.sci_HashCollisionSetNode__f_content).apply__I__O(index);
});
$c_sci_HashCollisionSetNode.prototype.getHash__I__I = (function(index) {
  return this.sci_HashCollisionSetNode__f_originalHash;
});
$c_sci_HashCollisionSetNode.prototype.size__I = (function() {
  return $n(this.sci_HashCollisionSetNode__f_content).length__I();
});
$c_sci_HashCollisionSetNode.prototype.foreach__F1__V = (function(f) {
  var iter = $n(this.sci_HashCollisionSetNode__f_content).iterator__sc_Iterator();
  while ($n(iter).hasNext__Z()) {
    $n(f).apply__O__O($n(iter).next__O());
  }
});
$c_sci_HashCollisionSetNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return Math.imul($n(this.sci_HashCollisionSetNode__f_content).length__I(), this.sci_HashCollisionSetNode__f_hash);
});
$c_sci_HashCollisionSetNode.prototype.subsetOf__sci_SetNode__I__Z = (function(that, shift) {
  if ((this === that)) {
    return true;
  } else if ((that instanceof $c_sci_HashCollisionSetNode)) {
    var x2 = $as_sci_HashCollisionSetNode(that);
    var $x_1 = $n(this.sci_HashCollisionSetNode__f_content).length__I();
    var this$1 = $n(x2);
    if (($x_1 <= $n(this$1.sci_HashCollisionSetNode__f_content).length__I())) {
      var this$2 = $n(this.sci_HashCollisionSetNode__f_content);
      var eta$0$1 = $n(x2).sci_HashCollisionSetNode__f_content;
      var res = true;
      var it = this$2.iterator__sc_Iterator();
      while ((res && $n(it).hasNext__Z())) {
        var arg1 = $n(it).next__O();
        var this$3 = $n(eta$0$1);
        res = $f_sc_SeqOps__contains__O__Z(this$3, arg1);
      }
      return res;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_sci_HashCollisionSetNode.prototype.filterImpl__F1__Z__sci_SetNode = (function(pred, flipped) {
  var newContent = $n(this.sci_HashCollisionSetNode__f_content).filterImpl__F1__Z__sci_Vector(pred, flipped);
  var newContentLength = $n(newContent).length__I();
  if ((newContentLength === 0)) {
    var this$1 = $m_sci_SetNode$();
    return this$1.sci_SetNode$__f_EmptySetNode;
  } else {
    return ((newContentLength === 1) ? new $c_sci_BitmapIndexedSetNode($m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(this.sci_HashCollisionSetNode__f_hash, 0)), 0, new $ac_O([$n(newContent).head__O()]), new $ac_I(new Int32Array([this.sci_HashCollisionSetNode__f_originalHash])), 1, this.sci_HashCollisionSetNode__f_hash) : (($n(newContent).length__I() === $n(this.sci_HashCollisionSetNode__f_content).length__I()) ? this : new $c_sci_HashCollisionSetNode(this.sci_HashCollisionSetNode__f_originalHash, this.sci_HashCollisionSetNode__f_hash, newContent)));
  }
});
$c_sci_HashCollisionSetNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashCollisionSetNode)) {
    var x2 = $as_sci_HashCollisionSetNode(that);
    if ((this === x2)) {
      return true;
    } else {
      if ((this.sci_HashCollisionSetNode__f_hash === $n(x2).sci_HashCollisionSetNode__f_hash)) {
        var this$1 = $n(this.sci_HashCollisionSetNode__f_content);
        var $x_2 = this$1.length__I();
        var this$2 = $n($n(x2).sci_HashCollisionSetNode__f_content);
        var $x_1 = ($x_2 === this$2.length__I());
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var this$3 = $n(this.sci_HashCollisionSetNode__f_content);
        var eta$0$1 = $n(x2).sci_HashCollisionSetNode__f_content;
        var res = true;
        var it = this$3.iterator__sc_Iterator();
        while ((res && $n(it).hasNext__Z())) {
          var arg1 = $n(it).next__O();
          var this$4 = $n(eta$0$1);
          res = $f_sc_SeqOps__contains__O__Z(this$4, arg1);
        }
        return res;
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$c_sci_HashCollisionSetNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.");
});
$c_sci_HashCollisionSetNode.prototype.concat__sci_SetNode__I__sci_SetNode = (function(that, shift) {
  if ((that instanceof $c_sci_HashCollisionSetNode)) {
    var x2 = $as_sci_HashCollisionSetNode(that);
    if ((x2 === this)) {
      return this;
    } else {
      var newContent = null;
      var iter = $n($n(x2).sci_HashCollisionSetNode__f_content).iterator__sc_Iterator();
      while ($n(iter).hasNext__Z()) {
        var nextPayload = $n(iter).next__O();
        var this$1 = $n(this.sci_HashCollisionSetNode__f_content);
        if ((!$f_sc_SeqOps__contains__O__Z(this$1, nextPayload))) {
          if ((newContent === null)) {
            newContent = new $c_sci_VectorBuilder();
            $n(newContent).addAll__sc_IterableOnce__sci_VectorBuilder(this.sci_HashCollisionSetNode__f_content);
          }
          $n(newContent).addOne__O__sci_VectorBuilder(nextPayload);
        }
      }
      return ((newContent === null) ? this : new $c_sci_HashCollisionSetNode(this.sci_HashCollisionSetNode__f_originalHash, this.sci_HashCollisionSetNode__f_hash, $n(newContent).result__sci_Vector()));
    }
  } else if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Cannot concatenate a HashCollisionSetNode with a BitmapIndexedSetNode");
  } else {
    throw new $c_s_MatchError(that);
  }
});
$c_sci_HashCollisionSetNode.prototype.foreachWithHash__F2__V = (function(f) {
  var iter = $n(this.sci_HashCollisionSetNode__f_content).iterator__sc_Iterator();
  while ($n(iter).hasNext__Z()) {
    var next = $n(iter).next__O();
    $n(f).apply__O__O__O(next, this.sci_HashCollisionSetNode__f_originalHash);
  }
});
$c_sci_HashCollisionSetNode.prototype.copy__sci_SetNode = (function() {
  return new $c_sci_HashCollisionSetNode(this.sci_HashCollisionSetNode__f_originalHash, this.sci_HashCollisionSetNode__f_hash, this.sci_HashCollisionSetNode__f_content);
});
$c_sci_HashCollisionSetNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_SetNode(index);
});
function $as_sci_HashCollisionSetNode(obj) {
  return (((obj instanceof $c_sci_HashCollisionSetNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashCollisionSetNode"));
}
function $isArrayOf_sci_HashCollisionSetNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashCollisionSetNode)));
}
function $asArrayOf_sci_HashCollisionSetNode(obj, depth) {
  return (($isArrayOf_sci_HashCollisionSetNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashCollisionSetNode;", depth));
}
var $d_sci_HashCollisionSetNode = new $TypeData().initClass($c_sci_HashCollisionSetNode, "scala.collection.immutable.HashCollisionSetNode", ({
  sci_HashCollisionSetNode: 1,
  sci_SetNode: 1,
  sci_Node: 1
}));
/** @constructor */
function $c_sci_HashMap$() {
  this.sci_HashMap$__f_EmptyMap = null;
  $n_sci_HashMap$ = this;
  var this$1 = $m_sci_MapNode$();
  this.sci_HashMap$__f_EmptyMap = new $c_sci_HashMap(this$1.sci_MapNode$__f_EmptyMapNode);
}
$c_sci_HashMap$.prototype = new $h_O();
$c_sci_HashMap$.prototype.constructor = $c_sci_HashMap$;
/** @constructor */
function $h_sci_HashMap$() {
}
$h_sci_HashMap$.prototype = $c_sci_HashMap$.prototype;
$c_sci_HashMap$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_HashMap(elems);
});
$c_sci_HashMap$.prototype.from__sc_IterableOnce__sci_HashMap = (function(source) {
  if ((source instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(source);
    return x2;
  } else {
    var this$1 = new $c_sci_HashMapBuilder();
    var this$2 = $n(this$1.addAll__sc_IterableOnce__sci_HashMapBuilder(source));
    return this$2.result__sci_HashMap();
  }
});
$c_sci_HashMap$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_HashMapBuilder();
});
$c_sci_HashMap$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__sci_HashMap(it);
});
$c_sci_HashMap$.prototype.empty__O = (function() {
  return this.sci_HashMap$__f_EmptyMap;
});
var $d_sci_HashMap$ = new $TypeData().initClass($c_sci_HashMap$, "scala.collection.immutable.HashMap$", ({
  sci_HashMap$: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_HashMap$;
function $m_sci_HashMap$() {
  if ((!$n_sci_HashMap$)) {
    $n_sci_HashMap$ = new $c_sci_HashMap$();
  }
  return $n_sci_HashMap$;
}
/** @constructor */
function $c_sci_HashSet$() {
  this.sci_HashSet$__f_EmptySet = null;
  $n_sci_HashSet$ = this;
  var this$1 = $m_sci_SetNode$();
  this.sci_HashSet$__f_EmptySet = new $c_sci_HashSet(this$1.sci_SetNode$__f_EmptySetNode);
}
$c_sci_HashSet$.prototype = new $h_O();
$c_sci_HashSet$.prototype.constructor = $c_sci_HashSet$;
/** @constructor */
function $h_sci_HashSet$() {
}
$h_sci_HashSet$.prototype = $c_sci_HashSet$.prototype;
$c_sci_HashSet$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_HashSet(elems);
});
$c_sci_HashSet$.prototype.from__sc_IterableOnce__sci_HashSet = (function(source) {
  if ((source instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(source);
    return x2;
  } else if (($n(source).knownSize__I() === 0)) {
    return this.sci_HashSet$__f_EmptySet;
  } else {
    var this$1 = new $c_sci_HashSetBuilder();
    var this$2 = $n(this$1.addAll__sc_IterableOnce__sci_HashSetBuilder(source));
    return this$2.result__sci_HashSet();
  }
});
$c_sci_HashSet$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_HashSetBuilder();
});
$c_sci_HashSet$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_HashSet(source);
});
$c_sci_HashSet$.prototype.empty__O = (function() {
  return this.sci_HashSet$__f_EmptySet;
});
var $d_sci_HashSet$ = new $TypeData().initClass($c_sci_HashSet$, "scala.collection.immutable.HashSet$", ({
  sci_HashSet$: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_HashSet$;
function $m_sci_HashSet$() {
  if ((!$n_sci_HashSet$)) {
    $n_sci_HashSet$ = new $c_sci_HashSet$();
  }
  return $n_sci_HashSet$;
}
/** @constructor */
function $c_sci_LazyList$State$Cons(head, tail) {
  this.sci_LazyList$State$Cons__f_head = null;
  this.sci_LazyList$State$Cons__f_tail = null;
  this.sci_LazyList$State$Cons__f_head = head;
  this.sci_LazyList$State$Cons__f_tail = tail;
}
$c_sci_LazyList$State$Cons.prototype = new $h_O();
$c_sci_LazyList$State$Cons.prototype.constructor = $c_sci_LazyList$State$Cons;
/** @constructor */
function $h_sci_LazyList$State$Cons() {
}
$h_sci_LazyList$State$Cons.prototype = $c_sci_LazyList$State$Cons.prototype;
$c_sci_LazyList$State$Cons.prototype.head__O = (function() {
  return this.sci_LazyList$State$Cons__f_head;
});
$c_sci_LazyList$State$Cons.prototype.tail__sci_LazyList = (function() {
  return this.sci_LazyList$State$Cons__f_tail;
});
var $d_sci_LazyList$State$Cons = new $TypeData().initClass($c_sci_LazyList$State$Cons, "scala.collection.immutable.LazyList$State$Cons", ({
  sci_LazyList$State$Cons: 1,
  sci_LazyList$State: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_LazyList$State$Empty$() {
}
$c_sci_LazyList$State$Empty$.prototype = new $h_O();
$c_sci_LazyList$State$Empty$.prototype.constructor = $c_sci_LazyList$State$Empty$;
/** @constructor */
function $h_sci_LazyList$State$Empty$() {
}
$h_sci_LazyList$State$Empty$.prototype = $c_sci_LazyList$State$Empty$.prototype;
$c_sci_LazyList$State$Empty$.prototype.head__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty lazy list");
});
$c_sci_LazyList$State$Empty$.prototype.tail__sci_LazyList = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty lazy list");
});
$c_sci_LazyList$State$Empty$.prototype.head__O = (function() {
  this.head__E();
});
var $d_sci_LazyList$State$Empty$ = new $TypeData().initClass($c_sci_LazyList$State$Empty$, "scala.collection.immutable.LazyList$State$Empty$", ({
  sci_LazyList$State$Empty$: 1,
  sci_LazyList$State: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_LazyList$State$Empty$;
function $m_sci_LazyList$State$Empty$() {
  if ((!$n_sci_LazyList$State$Empty$)) {
    $n_sci_LazyList$State$Empty$ = new $c_sci_LazyList$State$Empty$();
  }
  return $n_sci_LazyList$State$Empty$;
}
/** @constructor */
function $c_sci_Map$() {
}
$c_sci_Map$.prototype = new $h_O();
$c_sci_Map$.prototype.constructor = $c_sci_Map$;
/** @constructor */
function $h_sci_Map$() {
}
$h_sci_Map$.prototype = $c_sci_Map$.prototype;
$c_sci_Map$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_Map(elems);
});
$c_sci_Map$.prototype.from__sc_IterableOnce__sci_Map = (function(it) {
  if ($is_sci_Iterable(it)) {
    var x2 = $as_sci_Iterable(it);
    if ($n(x2).isEmpty__Z()) {
      return $m_sci_Map$EmptyMap$();
    }
  }
  if ((it instanceof $c_sci_HashMap)) {
    var x3 = $as_sci_HashMap(it);
    return x3;
  }
  if ((it instanceof $c_sci_Map$Map1)) {
    var x4 = $as_sci_Map$Map1(it);
    return x4;
  }
  if ((it instanceof $c_sci_Map$Map2)) {
    var x5 = $as_sci_Map$Map2(it);
    return x5;
  }
  if ((it instanceof $c_sci_Map$Map3)) {
    var x6 = $as_sci_Map$Map3(it);
    return x6;
  }
  if ((it instanceof $c_sci_Map$Map4)) {
    var x7 = $as_sci_Map$Map4(it);
    return x7;
  }
  if (false) {
    var x8 = $as_sci_ListMap(it);
    return x8;
  }
  if ((it instanceof $c_sci_TreeSeqMap)) {
    var x9 = $as_sci_TreeSeqMap(it);
    return x9;
  }
  if (false) {
    var x10 = $as_sci_VectorMap(it);
    return x10;
  }
  if (false) {
    var x11 = $as_sci_SeqMap$SeqMap1(it);
    return x11;
  }
  if (false) {
    var x12 = $as_sci_SeqMap$SeqMap2(it);
    return x12;
  }
  if (false) {
    var x13 = $as_sci_SeqMap$SeqMap3(it);
    return x13;
  }
  if (false) {
    var x14 = $as_sci_SeqMap$SeqMap4(it);
    return x14;
  }
  var this$1 = new $c_sci_MapBuilderImpl();
  var this$2 = $n(this$1.addAll__sc_IterableOnce__sci_MapBuilderImpl(it));
  return this$2.result__sci_Map();
});
$c_sci_Map$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_MapBuilderImpl();
});
$c_sci_Map$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__sci_Map(it);
});
$c_sci_Map$.prototype.empty__O = (function() {
  return $m_sci_Map$EmptyMap$();
});
var $d_sci_Map$ = new $TypeData().initClass($c_sci_Map$, "scala.collection.immutable.Map$", ({
  sci_Map$: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_Map$;
function $m_sci_Map$() {
  if ((!$n_sci_Map$)) {
    $n_sci_Map$ = new $c_sci_Map$();
  }
  return $n_sci_Map$;
}
/** @constructor */
function $c_sci_Set$() {
}
$c_sci_Set$.prototype = new $h_O();
$c_sci_Set$.prototype.constructor = $c_sci_Set$;
/** @constructor */
function $h_sci_Set$() {
}
$h_sci_Set$.prototype = $c_sci_Set$.prototype;
$c_sci_Set$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_Set(elems);
});
$c_sci_Set$.prototype.from__sc_IterableOnce__sci_Set = (function(it) {
  if (($n(it).knownSize__I() === 0)) {
    return $m_sci_Set$EmptySet$();
  } else if ((it instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(it);
    return x2;
  } else if (false) {
    var x3 = $as_sci_ListSet(it);
    return x3;
  } else if ((it instanceof $c_sci_Set$Set1)) {
    var x4 = $as_sci_Set$Set1(it);
    return x4;
  } else if ((it instanceof $c_sci_Set$Set2)) {
    var x5 = $as_sci_Set$Set2(it);
    return x5;
  } else if ((it instanceof $c_sci_Set$Set3)) {
    var x6 = $as_sci_Set$Set3(it);
    return x6;
  } else if ((it instanceof $c_sci_Set$Set4)) {
    var x7 = $as_sci_Set$Set4(it);
    return x7;
  } else if ((it instanceof $c_sci_HashMap$HashKeySet)) {
    var x8 = $as_sci_HashMap$HashKeySet(it);
    return x8;
  } else if ((it instanceof $c_sci_MapOps$ImmutableKeySet)) {
    var x9 = $as_sci_MapOps$ImmutableKeySet(it);
    return x9;
  } else {
    var this$1 = new $c_sci_SetBuilderImpl();
    var this$2 = $n(this$1.addAll__sc_IterableOnce__sci_SetBuilderImpl(it));
    return this$2.result__sci_Set();
  }
});
$c_sci_Set$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_SetBuilderImpl();
});
$c_sci_Set$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Set(source);
});
$c_sci_Set$.prototype.empty__O = (function() {
  return $m_sci_Set$EmptySet$();
});
var $d_sci_Set$ = new $TypeData().initClass($c_sci_Set$, "scala.collection.immutable.Set$", ({
  sci_Set$: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_Set$;
function $m_sci_Set$() {
  if ((!$n_sci_Set$)) {
    $n_sci_Set$ = new $c_sci_Set$();
  }
  return $n_sci_Set$;
}
/** @constructor */
function $c_sci_TreeSeqMap$() {
  this.sci_TreeSeqMap$__f_EmptyByInsertion = null;
  this.sci_TreeSeqMap$__f_EmptyByModification = null;
  $n_sci_TreeSeqMap$ = this;
  var $x_1 = $m_sci_TreeSeqMap$Ordering$Zero$();
  var this$2 = $m_sci_HashMap$();
  this.sci_TreeSeqMap$__f_EmptyByInsertion = new $c_sci_TreeSeqMap($x_1, this$2.sci_HashMap$__f_EmptyMap, 0, $m_sci_TreeSeqMap$OrderBy$Insertion$());
  var $x_2 = $m_sci_TreeSeqMap$Ordering$Zero$();
  var this$4 = $m_sci_HashMap$();
  this.sci_TreeSeqMap$__f_EmptyByModification = new $c_sci_TreeSeqMap($x_2, this$4.sci_HashMap$__f_EmptyMap, 0, $m_sci_TreeSeqMap$OrderBy$Modification$());
}
$c_sci_TreeSeqMap$.prototype = new $h_O();
$c_sci_TreeSeqMap$.prototype.constructor = $c_sci_TreeSeqMap$;
/** @constructor */
function $h_sci_TreeSeqMap$() {
}
$h_sci_TreeSeqMap$.prototype = $c_sci_TreeSeqMap$.prototype;
$c_sci_TreeSeqMap$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_TreeSeqMap(elems);
});
$c_sci_TreeSeqMap$.prototype.empty__sci_TreeSeqMap$OrderBy__sci_TreeSeqMap = (function(orderBy) {
  var x$2 = $m_sci_TreeSeqMap$OrderBy$Modification$();
  if ((orderBy !== null)) {
    var this$1 = $n(orderBy);
    var $x_1 = (this$1 === x$2);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return this.sci_TreeSeqMap$__f_EmptyByModification;
  } else {
    return this.sci_TreeSeqMap$__f_EmptyByInsertion;
  }
});
$c_sci_TreeSeqMap$.prototype.from__sc_IterableOnce__sci_TreeSeqMap = (function(it) {
  if ((it instanceof $c_sci_TreeSeqMap)) {
    var x2 = $as_sci_TreeSeqMap(it);
    return x2;
  } else {
    var orderedBy = $m_sci_TreeSeqMap$OrderBy$Insertion$();
    var this$1 = new $c_sci_TreeSeqMap$Builder(orderedBy);
    return $as_sci_TreeSeqMap($n($as_scm_Builder($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this$1, it))).result__O());
  }
});
$c_sci_TreeSeqMap$.prototype.newBuilder__scm_Builder = (function() {
  var orderedBy = $m_sci_TreeSeqMap$OrderBy$Insertion$();
  return new $c_sci_TreeSeqMap$Builder(orderedBy);
});
$c_sci_TreeSeqMap$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__sci_TreeSeqMap(it);
});
$c_sci_TreeSeqMap$.prototype.empty__O = (function() {
  return this.empty__sci_TreeSeqMap$OrderBy__sci_TreeSeqMap($m_sci_TreeSeqMap$OrderBy$Insertion$());
});
var $d_sci_TreeSeqMap$ = new $TypeData().initClass($c_sci_TreeSeqMap$, "scala.collection.immutable.TreeSeqMap$", ({
  sci_TreeSeqMap$: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_TreeSeqMap$;
function $m_sci_TreeSeqMap$() {
  if ((!$n_sci_TreeSeqMap$)) {
    $n_sci_TreeSeqMap$ = new $c_sci_TreeSeqMap$();
  }
  return $n_sci_TreeSeqMap$;
}
function $f_scm_Builder__sizeHint__sc_IterableOnce__I__V($thiz, coll, delta) {
  var x1 = $n(coll).knownSize__I();
  if ((x1 !== (-1))) {
    var that = ((x1 + delta) | 0);
    $thiz.sizeHint__I__V(((that < 0) ? 0 : that));
  }
}
function $is_scm_Builder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Builder)));
}
function $as_scm_Builder(obj) {
  return (($is_scm_Builder(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Builder"));
}
function $isArrayOf_scm_Builder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Builder)));
}
function $asArrayOf_scm_Builder(obj, depth) {
  return (($isArrayOf_scm_Builder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Builder;", depth));
}
/** @constructor */
function $c_scm_HashMap$() {
}
$c_scm_HashMap$.prototype = new $h_O();
$c_scm_HashMap$.prototype.constructor = $c_scm_HashMap$;
/** @constructor */
function $h_scm_HashMap$() {
}
$h_scm_HashMap$.prototype = $c_scm_HashMap$.prototype;
$c_scm_HashMap$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__scm_HashMap(elems);
});
$c_scm_HashMap$.prototype.from__sc_IterableOnce__scm_HashMap = (function(it) {
  var k = $n(it).knownSize__I();
  var cap = ((k > 0) ? $doubleToInt((((1 + k) | 0) / 0.75)) : 16);
  return $ct_scm_HashMap__I__D__(new $c_scm_HashMap(), cap, 0.75).addAll__sc_IterableOnce__scm_HashMap(it);
});
$c_scm_HashMap$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_HashMap$$anon$6(16, 0.75);
});
$c_scm_HashMap$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__scm_HashMap(it);
});
$c_scm_HashMap$.prototype.empty__O = (function() {
  return $ct_scm_HashMap__(new $c_scm_HashMap());
});
var $d_scm_HashMap$ = new $TypeData().initClass($c_scm_HashMap$, "scala.collection.mutable.HashMap$", ({
  scm_HashMap$: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_scm_HashMap$;
function $m_scm_HashMap$() {
  if ((!$n_scm_HashMap$)) {
    $n_scm_HashMap$ = new $c_scm_HashMap$();
  }
  return $n_scm_HashMap$;
}
/** @constructor */
function $c_scm_HashSet$() {
}
$c_scm_HashSet$.prototype = new $h_O();
$c_scm_HashSet$.prototype.constructor = $c_scm_HashSet$;
/** @constructor */
function $h_scm_HashSet$() {
}
$h_scm_HashSet$.prototype = $c_scm_HashSet$.prototype;
$c_scm_HashSet$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__scm_HashSet(elems);
});
$c_scm_HashSet$.prototype.from__sc_IterableOnce__scm_HashSet = (function(it) {
  var k = $n(it).knownSize__I();
  var cap = ((k > 0) ? $doubleToInt((((1 + k) | 0) / 0.75)) : 16);
  var this$1 = $ct_scm_HashSet__I__D__(new $c_scm_HashSet(), cap, 0.75);
  return this$1.addAll__sc_IterableOnce__scm_HashSet(it);
});
$c_scm_HashSet$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_HashSet$$anon$4(16, 0.75);
});
$c_scm_HashSet$.prototype.empty__O = (function() {
  return $ct_scm_HashSet__(new $c_scm_HashSet());
});
$c_scm_HashSet$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__scm_HashSet(source);
});
var $d_scm_HashSet$ = new $TypeData().initClass($c_scm_HashSet$, "scala.collection.mutable.HashSet$", ({
  scm_HashSet$: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_scm_HashSet$;
function $m_scm_HashSet$() {
  if ((!$n_scm_HashSet$)) {
    $n_scm_HashSet$ = new $c_scm_HashSet$();
  }
  return $n_scm_HashSet$;
}
/** @constructor */
function $c_s_concurrent_BatchingExecutor$SyncBatch(outer, runnable) {
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_first = null;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_other = null;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = 0;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_$outer = null;
  $ct_s_concurrent_BatchingExecutor$AbstractBatch__s_concurrent_BatchingExecutor__jl_Runnable__Ajl_Runnable__I__(this, outer, runnable, $m_s_concurrent_BatchingExecutorStatics$().s_concurrent_BatchingExecutorStatics$__f_emptyBatchArray, 1);
}
$c_s_concurrent_BatchingExecutor$SyncBatch.prototype = new $h_s_concurrent_BatchingExecutor$AbstractBatch();
$c_s_concurrent_BatchingExecutor$SyncBatch.prototype.constructor = $c_s_concurrent_BatchingExecutor$SyncBatch;
/** @constructor */
function $h_s_concurrent_BatchingExecutor$SyncBatch() {
}
$h_s_concurrent_BatchingExecutor$SyncBatch.prototype = $c_s_concurrent_BatchingExecutor$SyncBatch.prototype;
$c_s_concurrent_BatchingExecutor$SyncBatch.prototype.run__V = (function() {
  while (true) {
    try {
      this.runN__I__V(1024);
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      if (false) {
        var x2 = $as_jl_InterruptedException(e$2);
        $n(this.s_concurrent_BatchingExecutor$AbstractBatch__f_$outer);
        $n($m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter).apply__O__O(x2);
      } else if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        $n(this.s_concurrent_BatchingExecutor$AbstractBatch__f_$outer);
        $n($m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter).apply__O__O(e$2);
      } else {
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2));
      }
    }
    if ((this.s_concurrent_BatchingExecutor$AbstractBatch__f_size > 0)) {
      continue;
    }
    return (void 0);
  }
});
function $as_s_concurrent_BatchingExecutor$SyncBatch(obj) {
  return (((obj instanceof $c_s_concurrent_BatchingExecutor$SyncBatch) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.BatchingExecutor$SyncBatch"));
}
function $isArrayOf_s_concurrent_BatchingExecutor$SyncBatch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_BatchingExecutor$SyncBatch)));
}
function $asArrayOf_s_concurrent_BatchingExecutor$SyncBatch(obj, depth) {
  return (($isArrayOf_s_concurrent_BatchingExecutor$SyncBatch(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.BatchingExecutor$SyncBatch;", depth));
}
var $d_s_concurrent_BatchingExecutor$SyncBatch = new $TypeData().initClass($c_s_concurrent_BatchingExecutor$SyncBatch, "scala.concurrent.BatchingExecutor$SyncBatch", ({
  s_concurrent_BatchingExecutor$SyncBatch: 1,
  s_concurrent_BatchingExecutor$AbstractBatch: 1,
  jl_Runnable: 1
}));
/** @constructor */
function $c_s_concurrent_impl_Promise$Link(to) {
  this.ju_concurrent_atomic_AtomicReference__f_value = null;
  $ct_ju_concurrent_atomic_AtomicReference__O__(this, to);
}
$c_s_concurrent_impl_Promise$Link.prototype = new $h_ju_concurrent_atomic_AtomicReference();
$c_s_concurrent_impl_Promise$Link.prototype.constructor = $c_s_concurrent_impl_Promise$Link;
/** @constructor */
function $h_s_concurrent_impl_Promise$Link() {
}
$h_s_concurrent_impl_Promise$Link.prototype = $c_s_concurrent_impl_Promise$Link.prototype;
$c_s_concurrent_impl_Promise$Link.prototype.promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise = (function(owner) {
  var c = $as_s_concurrent_impl_Promise$DefaultPromise(this.ju_concurrent_atomic_AtomicReference__f_value);
  var current = c;
  var target = c;
  while (true) {
    var value = $n(target).ju_concurrent_atomic_AtomicReference__f_value;
    if ($is_s_concurrent_impl_Promise$Callbacks(value)) {
      if (this.compareAndSet__O__O__Z(current, target)) {
        return target;
      } else {
        current = $as_s_concurrent_impl_Promise$DefaultPromise(this.ju_concurrent_atomic_AtomicReference__f_value);
      }
    } else if ((value instanceof $c_s_concurrent_impl_Promise$Link)) {
      target = $as_s_concurrent_impl_Promise$DefaultPromise($n($as_s_concurrent_impl_Promise$Link(value)).ju_concurrent_atomic_AtomicReference__f_value);
    } else {
      $n(owner).unlink__s_util_Try__V($as_s_util_Try(value));
      return owner;
    }
  }
});
function $as_s_concurrent_impl_Promise$Link(obj) {
  return (((obj instanceof $c_s_concurrent_impl_Promise$Link) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.impl.Promise$Link"));
}
function $isArrayOf_s_concurrent_impl_Promise$Link(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$Link)));
}
function $asArrayOf_s_concurrent_impl_Promise$Link(obj, depth) {
  return (($isArrayOf_s_concurrent_impl_Promise$Link(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.impl.Promise$Link;", depth));
}
var $d_s_concurrent_impl_Promise$Link = new $TypeData().initClass($c_s_concurrent_impl_Promise$Link, "scala.concurrent.impl.Promise$Link", ({
  s_concurrent_impl_Promise$Link: 1,
  ju_concurrent_atomic_AtomicReference: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_math_Ordering$() {
}
$c_s_math_Ordering$.prototype = new $h_O();
$c_s_math_Ordering$.prototype.constructor = $c_s_math_Ordering$;
/** @constructor */
function $h_s_math_Ordering$() {
}
$h_s_math_Ordering$.prototype = $c_s_math_Ordering$.prototype;
var $d_s_math_Ordering$ = new $TypeData().initClass($c_s_math_Ordering$, "scala.math.Ordering$", ({
  s_math_Ordering$: 1,
  s_math_LowPriorityOrderingImplicits: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_math_Ordering$;
function $m_s_math_Ordering$() {
  if ((!$n_s_math_Ordering$)) {
    $n_s_math_Ordering$ = new $c_s_math_Ordering$();
  }
  return $n_s_math_Ordering$;
}
function $is_s_math_PartialOrdering(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_math_PartialOrdering)));
}
function $as_s_math_PartialOrdering(obj) {
  return (($is_s_math_PartialOrdering(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.PartialOrdering"));
}
function $isArrayOf_s_math_PartialOrdering(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_PartialOrdering)));
}
function $asArrayOf_s_math_PartialOrdering(obj, depth) {
  return (($isArrayOf_s_math_PartialOrdering(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.PartialOrdering;", depth));
}
/** @constructor */
function $c_s_math_ScalaNumber() {
}
$c_s_math_ScalaNumber.prototype = new $h_jl_Number();
$c_s_math_ScalaNumber.prototype.constructor = $c_s_math_ScalaNumber;
/** @constructor */
function $h_s_math_ScalaNumber() {
}
$h_s_math_ScalaNumber.prototype = $c_s_math_ScalaNumber.prototype;
function $as_s_math_ScalaNumber(obj) {
  return (((obj instanceof $c_s_math_ScalaNumber) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.ScalaNumber"));
}
function $isArrayOf_s_math_ScalaNumber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_ScalaNumber)));
}
function $asArrayOf_s_math_ScalaNumber(obj, depth) {
  return (($isArrayOf_s_math_ScalaNumber(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.ScalaNumber;", depth));
}
/** @constructor */
function $c_sr_AbstractPartialFunction() {
}
$c_sr_AbstractPartialFunction.prototype = new $h_O();
$c_sr_AbstractPartialFunction.prototype.constructor = $c_sr_AbstractPartialFunction;
/** @constructor */
function $h_sr_AbstractPartialFunction() {
}
$h_sr_AbstractPartialFunction.prototype = $c_sr_AbstractPartialFunction.prototype;
$c_sr_AbstractPartialFunction.prototype.orElse__s_PartialFunction__s_PartialFunction = (function(that) {
  return new $c_s_PartialFunction$OrElse(this, that);
});
$c_sr_AbstractPartialFunction.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_sr_AbstractPartialFunction.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_sr_AbstractPartialFunction.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_sr_AbstractPartialFunction.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sr_AbstractPartialFunction.prototype.toString__T = (function() {
  return "<function1>";
});
$c_sr_AbstractPartialFunction.prototype.apply__O__O = (function(x) {
  return this.applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf);
});
$c_sr_AbstractPartialFunction.prototype.apply$mcZI$sp__I__Z = (function(x) {
  return $uZ(this.apply__O__O(x));
});
$c_sr_AbstractPartialFunction.prototype.andThen__F1__F1 = (function(g) {
  return this.andThen__F1__s_PartialFunction(g);
});
var $d_sr_Nothing$ = new $TypeData().initClass(0, "scala.runtime.Nothing$", ({
  sr_Nothing$: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sjs_js_Any$() {
}
$c_sjs_js_Any$.prototype = new $h_O();
$c_sjs_js_Any$.prototype.constructor = $c_sjs_js_Any$;
/** @constructor */
function $h_sjs_js_Any$() {
}
$h_sjs_js_Any$.prototype = $c_sjs_js_Any$.prototype;
$c_sjs_js_Any$.prototype.fromFunction0__F0__sjs_js_Function0 = (function(f) {
  return (() => $n(f).apply__O());
});
$c_sjs_js_Any$.prototype.fromFunction1__F1__sjs_js_Function1 = (function(f) {
  return ((arg1$2) => $n(f).apply__O__O(arg1$2));
});
$c_sjs_js_Any$.prototype.fromFunction2__F2__sjs_js_Function2 = (function(f) {
  return ((arg1$2, arg2$2) => $n(f).apply__O__O__O(arg1$2, arg2$2));
});
var $d_sjs_js_Any$ = new $TypeData().initClass($c_sjs_js_Any$, "scala.scalajs.js.Any$", ({
  sjs_js_Any$: 1,
  sjs_js_LowPrioAnyImplicits: 1,
  sjs_js_LowestPrioAnyImplicits: 1
}));
var $n_sjs_js_Any$;
function $m_sjs_js_Any$() {
  if ((!$n_sjs_js_Any$)) {
    $n_sjs_js_Any$ = new $c_sjs_js_Any$();
  }
  return $n_sjs_js_Any$;
}
/** @constructor */
function $c_sjsr_AnonFunction0(f) {
  this.sjsr_AnonFunction0__f_f = null;
  this.sjsr_AnonFunction0__f_f = f;
}
$c_sjsr_AnonFunction0.prototype = new $h_sr_AbstractFunction0();
$c_sjsr_AnonFunction0.prototype.constructor = $c_sjsr_AnonFunction0;
/** @constructor */
function $h_sjsr_AnonFunction0() {
}
$h_sjsr_AnonFunction0.prototype = $c_sjsr_AnonFunction0.prototype;
$c_sjsr_AnonFunction0.prototype.apply__O = (function() {
  return (0, this.sjsr_AnonFunction0__f_f)();
});
var $d_sjsr_AnonFunction0 = new $TypeData().initClass($c_sjsr_AnonFunction0, "scala.scalajs.runtime.AnonFunction0", ({
  sjsr_AnonFunction0: 1,
  sr_AbstractFunction0: 1,
  F0: 1
}));
/** @constructor */
function $c_sjsr_AnonFunction1(f) {
  this.sjsr_AnonFunction1__f_f = null;
  this.sjsr_AnonFunction1__f_f = f;
}
$c_sjsr_AnonFunction1.prototype = new $h_sr_AbstractFunction1();
$c_sjsr_AnonFunction1.prototype.constructor = $c_sjsr_AnonFunction1;
/** @constructor */
function $h_sjsr_AnonFunction1() {
}
$h_sjsr_AnonFunction1.prototype = $c_sjsr_AnonFunction1.prototype;
$c_sjsr_AnonFunction1.prototype.apply__O__O = (function(arg1) {
  return (0, this.sjsr_AnonFunction1__f_f)(arg1);
});
var $d_sjsr_AnonFunction1 = new $TypeData().initClass($c_sjsr_AnonFunction1, "scala.scalajs.runtime.AnonFunction1", ({
  sjsr_AnonFunction1: 1,
  sr_AbstractFunction1: 1,
  F1: 1
}));
/** @constructor */
function $c_sjsr_AnonFunction2(f) {
  this.sjsr_AnonFunction2__f_f = null;
  this.sjsr_AnonFunction2__f_f = f;
}
$c_sjsr_AnonFunction2.prototype = new $h_sr_AbstractFunction2();
$c_sjsr_AnonFunction2.prototype.constructor = $c_sjsr_AnonFunction2;
/** @constructor */
function $h_sjsr_AnonFunction2() {
}
$h_sjsr_AnonFunction2.prototype = $c_sjsr_AnonFunction2.prototype;
$c_sjsr_AnonFunction2.prototype.apply__O__O__O = (function(arg1, arg2) {
  return (0, this.sjsr_AnonFunction2__f_f)(arg1, arg2);
});
var $d_sjsr_AnonFunction2 = new $TypeData().initClass($c_sjsr_AnonFunction2, "scala.scalajs.runtime.AnonFunction2", ({
  sjsr_AnonFunction2: 1,
  sr_AbstractFunction2: 1,
  F2: 1
}));
/** @constructor */
function $c_sjsr_AnonFunction3(f) {
  this.sjsr_AnonFunction3__f_f = null;
  this.sjsr_AnonFunction3__f_f = f;
}
$c_sjsr_AnonFunction3.prototype = new $h_sr_AbstractFunction3();
$c_sjsr_AnonFunction3.prototype.constructor = $c_sjsr_AnonFunction3;
/** @constructor */
function $h_sjsr_AnonFunction3() {
}
$h_sjsr_AnonFunction3.prototype = $c_sjsr_AnonFunction3.prototype;
$c_sjsr_AnonFunction3.prototype.apply__O__O__O__O = (function(arg1, arg2, arg3) {
  return (0, this.sjsr_AnonFunction3__f_f)(arg1, arg2, arg3);
});
var $d_sjsr_AnonFunction3 = new $TypeData().initClass($c_sjsr_AnonFunction3, "scala.scalajs.runtime.AnonFunction3", ({
  sjsr_AnonFunction3: 1,
  sr_AbstractFunction3: 1,
  F3: 1
}));
/** @constructor */
function $c_sjsr_AnonFunction4(f) {
  this.sjsr_AnonFunction4__f_f = null;
  this.sjsr_AnonFunction4__f_f = f;
}
$c_sjsr_AnonFunction4.prototype = new $h_sr_AbstractFunction4();
$c_sjsr_AnonFunction4.prototype.constructor = $c_sjsr_AnonFunction4;
/** @constructor */
function $h_sjsr_AnonFunction4() {
}
$h_sjsr_AnonFunction4.prototype = $c_sjsr_AnonFunction4.prototype;
$c_sjsr_AnonFunction4.prototype.apply__O__O__O__O__O = (function(arg1, arg2, arg3, arg4) {
  return (0, this.sjsr_AnonFunction4__f_f)(arg1, arg2, arg3, arg4);
});
var $d_sjsr_AnonFunction4 = new $TypeData().initClass($c_sjsr_AnonFunction4, "scala.scalajs.runtime.AnonFunction4", ({
  sjsr_AnonFunction4: 1,
  sr_AbstractFunction4: 1,
  F4: 1
}));
/** @constructor */
function $c_sjsr_AnonFunction5(f) {
  this.sjsr_AnonFunction5__f_f = null;
  this.sjsr_AnonFunction5__f_f = f;
}
$c_sjsr_AnonFunction5.prototype = new $h_sr_AbstractFunction5();
$c_sjsr_AnonFunction5.prototype.constructor = $c_sjsr_AnonFunction5;
/** @constructor */
function $h_sjsr_AnonFunction5() {
}
$h_sjsr_AnonFunction5.prototype = $c_sjsr_AnonFunction5.prototype;
$c_sjsr_AnonFunction5.prototype.apply__O__O__O__O__O__O = (function(arg1, arg2, arg3, arg4, arg5) {
  return (0, this.sjsr_AnonFunction5__f_f)(arg1, arg2, arg3, arg4, arg5);
});
var $d_sjsr_AnonFunction5 = new $TypeData().initClass($c_sjsr_AnonFunction5, "scala.scalajs.runtime.AnonFunction5", ({
  sjsr_AnonFunction5: 1,
  sr_AbstractFunction5: 1,
  F5: 1
}));
/** @constructor */
function $c_sjsr_AnonFunction6(f) {
  this.sjsr_AnonFunction6__f_f = null;
  this.sjsr_AnonFunction6__f_f = f;
}
$c_sjsr_AnonFunction6.prototype = new $h_sr_AbstractFunction6();
$c_sjsr_AnonFunction6.prototype.constructor = $c_sjsr_AnonFunction6;
/** @constructor */
function $h_sjsr_AnonFunction6() {
}
$h_sjsr_AnonFunction6.prototype = $c_sjsr_AnonFunction6.prototype;
$c_sjsr_AnonFunction6.prototype.apply__O__O__O__O__O__O__O = (function(arg1, arg2, arg3, arg4, arg5, arg6) {
  return (0, this.sjsr_AnonFunction6__f_f)(arg1, arg2, arg3, arg4, arg5, arg6);
});
var $d_sjsr_AnonFunction6 = new $TypeData().initClass($c_sjsr_AnonFunction6, "scala.scalajs.runtime.AnonFunction6", ({
  sjsr_AnonFunction6: 1,
  sr_AbstractFunction6: 1,
  F6: 1
}));
/** @constructor */
function $c_sjsr_AnonFunction7(f) {
  this.sjsr_AnonFunction7__f_f = null;
  this.sjsr_AnonFunction7__f_f = f;
}
$c_sjsr_AnonFunction7.prototype = new $h_sr_AbstractFunction7();
$c_sjsr_AnonFunction7.prototype.constructor = $c_sjsr_AnonFunction7;
/** @constructor */
function $h_sjsr_AnonFunction7() {
}
$h_sjsr_AnonFunction7.prototype = $c_sjsr_AnonFunction7.prototype;
$c_sjsr_AnonFunction7.prototype.apply__O__O__O__O__O__O__O__O = (function(arg1, arg2, arg3, arg4, arg5, arg6, arg7) {
  return (0, this.sjsr_AnonFunction7__f_f)(arg1, arg2, arg3, arg4, arg5, arg6, arg7);
});
var $d_sjsr_AnonFunction7 = new $TypeData().initClass($c_sjsr_AnonFunction7, "scala.scalajs.runtime.AnonFunction7", ({
  sjsr_AnonFunction7: 1,
  sr_AbstractFunction7: 1,
  F7: 1
}));
/** @constructor */
function $c_s_util_Random$() {
  this.s_util_Random__f_self = null;
  $ct_s_util_Random__ju_Random__(this, $ct_ju_Random__(new $c_ju_Random()));
}
$c_s_util_Random$.prototype = new $h_s_util_Random();
$c_s_util_Random$.prototype.constructor = $c_s_util_Random$;
/** @constructor */
function $h_s_util_Random$() {
}
$h_s_util_Random$.prototype = $c_s_util_Random$.prototype;
var $d_s_util_Random$ = new $TypeData().initClass($c_s_util_Random$, "scala.util.Random$", ({
  s_util_Random$: 1,
  s_util_Random: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_util_Random$;
function $m_s_util_Random$() {
  if ((!$n_s_util_Random$)) {
    $n_s_util_Random$ = new $c_s_util_Random$();
  }
  return $n_s_util_Random$;
}
function $as_s_util_control_ControlThrowable(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.control.ControlThrowable"));
}
function $isArrayOf_s_util_control_ControlThrowable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_control_ControlThrowable)));
}
function $asArrayOf_s_util_control_ControlThrowable(obj, depth) {
  return (($isArrayOf_s_util_control_ControlThrowable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.control.ControlThrowable;", depth));
}
/** @constructor */
function $c_Lsnabbdom_VNodeData$() {
  this.Lsnabbdom_VNodeData$__f_empty = null;
  $n_Lsnabbdom_VNodeData$ = this;
  $m_Lsnabbdom_VNodeData$();
  $m_Lsnabbdom_VNodeData$();
  var props = $m_sci_Map$EmptyMap$();
  $m_Lsnabbdom_VNodeData$();
  var attrs = $m_sci_Map$EmptyMap$();
  $m_Lsnabbdom_VNodeData$();
  var classes = $m_sci_Map$EmptyMap$();
  $m_Lsnabbdom_VNodeData$();
  var style = $m_sci_Map$EmptyMap$();
  $m_Lsnabbdom_VNodeData$();
  var dataset = $m_sci_Map$EmptyMap$();
  $m_Lsnabbdom_VNodeData$();
  var on = $m_sci_Map$EmptyMap$();
  $m_Lsnabbdom_VNodeData$();
  var hook = $m_s_None$();
  $m_Lsnabbdom_VNodeData$();
  var key = $m_s_None$();
  $m_Lsnabbdom_VNodeData$();
  var ns = $m_s_None$();
  $m_Lsnabbdom_VNodeData$();
  var fn = $m_s_None$();
  $m_Lsnabbdom_VNodeData$();
  var args = $m_s_None$();
  $m_Lsnabbdom_VNodeData$();
  var is = $m_s_None$();
  this.Lsnabbdom_VNodeData$__f_empty = new $c_Lsnabbdom_VNodeData(props, attrs, classes, style, dataset, on, hook, key, ns, fn, args, is);
}
$c_Lsnabbdom_VNodeData$.prototype = new $h_O();
$c_Lsnabbdom_VNodeData$.prototype.constructor = $c_Lsnabbdom_VNodeData$;
/** @constructor */
function $h_Lsnabbdom_VNodeData$() {
}
$h_Lsnabbdom_VNodeData$.prototype = $c_Lsnabbdom_VNodeData$.prototype;
$c_Lsnabbdom_VNodeData$.prototype.toString__T = (function() {
  return "VNodeData";
});
var $d_Lsnabbdom_VNodeData$ = new $TypeData().initClass($c_Lsnabbdom_VNodeData$, "snabbdom.VNodeData$", ({
  Lsnabbdom_VNodeData$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Lsnabbdom_VNodeData$;
function $m_Lsnabbdom_VNodeData$() {
  if ((!$n_Lsnabbdom_VNodeData$)) {
    $n_Lsnabbdom_VNodeData$ = new $c_Lsnabbdom_VNodeData$();
  }
  return $n_Lsnabbdom_VNodeData$;
}
/** @constructor */
function $c_Ltyrian_Attribute$() {
  $n_Ltyrian_Attribute$ = this;
  $m_Ltyrian_Attribute$();
}
$c_Ltyrian_Attribute$.prototype = new $h_O();
$c_Ltyrian_Attribute$.prototype.constructor = $c_Ltyrian_Attribute$;
/** @constructor */
function $h_Ltyrian_Attribute$() {
}
$h_Ltyrian_Attribute$.prototype = $c_Ltyrian_Attribute$.prototype;
var $d_Ltyrian_Attribute$ = new $TypeData().initClass($c_Ltyrian_Attribute$, "tyrian.Attribute$", ({
  Ltyrian_Attribute$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Ltyrian_Attribute$;
function $m_Ltyrian_Attribute$() {
  if ((!$n_Ltyrian_Attribute$)) {
    $n_Ltyrian_Attribute$ = new $c_Ltyrian_Attribute$();
  }
  return $n_Ltyrian_Attribute$;
}
function $p_Ltyrian_LocationDetails$__parsePath__T__Ltyrian_LocationDetails$LocationPathDetails($thiz, path) {
  if ((path === "")) {
    var search = $m_s_None$();
    var hash = $m_s_None$();
    return new $c_Ltyrian_LocationDetails$LocationPathDetails(path, search, hash);
  }
  if ((path !== null)) {
    var x20 = $n($thiz.Ltyrian_LocationDetails$__f_pathMatchAll).unapplySeq__jl_CharSequence__s_Option(path);
    if ((!$n(x20).isEmpty__Z())) {
      var x21 = $as_sci_List($n(x20).get__O());
      if (($n(x21).lengthCompare__I__I(3) === 0)) {
        var this$2 = $n(x21);
        var x22 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$2, 0));
        var this$3 = $n(x21);
        var x23 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$3, 1));
        var this$4 = $n(x21);
        var x24 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$4, 2));
        var search$1 = $m_s_Option$().apply__O__s_Option(x23);
        var hash$1 = $m_s_Option$().apply__O__s_Option(x24);
        return new $c_Ltyrian_LocationDetails$LocationPathDetails(x22, search$1, hash$1);
      }
    }
    var x16 = $n($thiz.Ltyrian_LocationDetails$__f_pathMatchHash).unapplySeq__jl_CharSequence__s_Option(path);
    if ((!$n(x16).isEmpty__Z())) {
      var x17 = $as_sci_List($n(x16).get__O());
      if (($n(x17).lengthCompare__I__I(2) === 0)) {
        var this$6 = $n(x17);
        var x18 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$6, 0));
        var this$7 = $n(x17);
        var x19 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$7, 1));
        var search$2 = $m_s_None$();
        var hash$2 = $m_s_Option$().apply__O__s_Option(x19);
        return new $c_Ltyrian_LocationDetails$LocationPathDetails(x18, search$2, hash$2);
      }
    }
    var x12 = $n($thiz.Ltyrian_LocationDetails$__f_pathMatchSearch).unapplySeq__jl_CharSequence__s_Option(path);
    if ((!$n(x12).isEmpty__Z())) {
      var x13 = $as_sci_List($n(x12).get__O());
      if (($n(x13).lengthCompare__I__I(2) === 0)) {
        var this$9 = $n(x13);
        var x14 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$9, 0));
        var this$10 = $n(x13);
        var x15 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$10, 1));
        var search$3 = $m_s_Option$().apply__O__s_Option(x15);
        var hash$3 = $m_s_None$();
        return new $c_Ltyrian_LocationDetails$LocationPathDetails(x14, search$3, hash$3);
      }
    }
  }
  var search$4 = $m_s_None$();
  var hash$4 = $m_s_None$();
  return new $c_Ltyrian_LocationDetails$LocationPathDetails(path, search$4, hash$4);
}
/** @constructor */
function $c_Ltyrian_LocationDetails$() {
  this.Ltyrian_LocationDetails$__f_urlFileMatch = null;
  this.Ltyrian_LocationDetails$__f_urlDataMatch = null;
  this.Ltyrian_LocationDetails$__f_urlMatch = null;
  this.Ltyrian_LocationDetails$__f_pathMatchAll = null;
  this.Ltyrian_LocationDetails$__f_pathMatchHash = null;
  this.Ltyrian_LocationDetails$__f_pathMatchSearch = null;
  $n_Ltyrian_LocationDetails$ = this;
  this.Ltyrian_LocationDetails$__f_urlFileMatch = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "^(file\\:)\\/\\/(\\/.*)?", $m_sci_Nil$());
  this.Ltyrian_LocationDetails$__f_urlDataMatch = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "^(data\\:)(.*)?", $m_sci_Nil$());
  this.Ltyrian_LocationDetails$__f_urlMatch = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "^([a-z]+\\:)(\\/+)?([a-zA-Z0-9-\\.\\@]+)(:)?([0-9]+)?(.*)?", $m_sci_Nil$());
  this.Ltyrian_LocationDetails$__f_pathMatchAll = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(.*)(\\?.*)(#.*)", $m_sci_Nil$());
  this.Ltyrian_LocationDetails$__f_pathMatchHash = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(.*)(#.*)", $m_sci_Nil$());
  this.Ltyrian_LocationDetails$__f_pathMatchSearch = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(.*)(\\?.*)", $m_sci_Nil$());
}
$c_Ltyrian_LocationDetails$.prototype = new $h_O();
$c_Ltyrian_LocationDetails$.prototype.constructor = $c_Ltyrian_LocationDetails$;
/** @constructor */
function $h_Ltyrian_LocationDetails$() {
}
$h_Ltyrian_LocationDetails$.prototype = $c_Ltyrian_LocationDetails$.prototype;
$c_Ltyrian_LocationDetails$.prototype.fromUrl__T__Ltyrian_LocationDetails = (function(url) {
  if ((url !== null)) {
    var x38 = $n(this.Ltyrian_LocationDetails$__f_urlFileMatch).unapplySeq__jl_CharSequence__s_Option(url);
    if ((!$n(x38).isEmpty__Z())) {
      var x39 = $as_sci_List($n(x38).get__O());
      if (($n(x39).lengthCompare__I__I(2) === 0)) {
        var this$1 = $n(x39);
        var x40 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$1, 0));
        var this$2 = $n(x39);
        var x41 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$2, 1));
        var this$3 = $n($m_s_Option$().apply__O__s_Option(x41));
        var p = $p_Ltyrian_LocationDetails$__parsePath__T__Ltyrian_LocationDetails$LocationPathDetails(this, $as_T((this$3.isEmpty__Z() ? "" : this$3.get__O())));
        $m_Ltyrian_LocationDetails$();
        var hash = $n(p).Ltyrian_LocationDetails$LocationPathDetails__f_hash;
        var hostName = $m_s_None$();
        var pathName = $n(p).Ltyrian_LocationDetails$LocationPathDetails__f_path;
        var port = $m_s_None$();
        var protocol = $m_s_Option$().apply__O__s_Option(x40);
        var search = $n(p).Ltyrian_LocationDetails$LocationPathDetails__f_search;
        return new $c_Ltyrian_LocationDetails(hash, hostName, pathName, port, protocol, search, url);
      }
    }
    var x34 = $n(this.Ltyrian_LocationDetails$__f_urlDataMatch).unapplySeq__jl_CharSequence__s_Option(url);
    if ((!$n(x34).isEmpty__Z())) {
      var x35 = $as_sci_List($n(x34).get__O());
      if (($n(x35).lengthCompare__I__I(2) === 0)) {
        var this$5 = $n(x35);
        var x36 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$5, 0));
        var this$6 = $n(x35);
        var x37 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$6, 1));
        var this$7 = $n($m_s_Option$().apply__O__s_Option(x37));
        var p$2 = $p_Ltyrian_LocationDetails$__parsePath__T__Ltyrian_LocationDetails$LocationPathDetails(this, $as_T((this$7.isEmpty__Z() ? "" : this$7.get__O())));
        $m_Ltyrian_LocationDetails$();
        var hash$1 = $n(p$2).Ltyrian_LocationDetails$LocationPathDetails__f_hash;
        var hostName$1 = $m_s_None$();
        var pathName$1 = $n(p$2).Ltyrian_LocationDetails$LocationPathDetails__f_path;
        var port$1 = $m_s_None$();
        var protocol$1 = $m_s_Option$().apply__O__s_Option(x36);
        var search$1 = $n(p$2).Ltyrian_LocationDetails$LocationPathDetails__f_search;
        return new $c_Ltyrian_LocationDetails(hash$1, hostName$1, pathName$1, port$1, protocol$1, search$1, url);
      }
    }
    var x26 = $n(this.Ltyrian_LocationDetails$__f_urlMatch).unapplySeq__jl_CharSequence__s_Option(url);
    if ((!$n(x26).isEmpty__Z())) {
      var x27 = $as_sci_List($n(x26).get__O());
      if (($n(x27).lengthCompare__I__I(6) === 0)) {
        var this$9 = $n(x27);
        var x28 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$9, 0));
        var this$10 = $n(x27);
        $as_T($f_sc_LinearSeqOps__apply__I__O(this$10, 1));
        var this$11 = $n(x27);
        var x30 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$11, 2));
        var this$12 = $n(x27);
        $as_T($f_sc_LinearSeqOps__apply__I__O(this$12, 3));
        var this$13 = $n(x27);
        var x32 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$13, 4));
        var this$14 = $n(x27);
        var x33 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$14, 5));
        var this$15 = $n($m_s_Option$().apply__O__s_Option(x33));
        var p$3 = $p_Ltyrian_LocationDetails$__parsePath__T__Ltyrian_LocationDetails$LocationPathDetails(this, $as_T((this$15.isEmpty__Z() ? "" : this$15.get__O())));
        $m_Ltyrian_LocationDetails$();
        var hash$2 = $n(p$3).Ltyrian_LocationDetails$LocationPathDetails__f_hash;
        var hostName$2 = $m_s_Option$().apply__O__s_Option(x30);
        var pathName$2 = $n(p$3).Ltyrian_LocationDetails$LocationPathDetails__f_path;
        var port$2 = $m_s_Option$().apply__O__s_Option(x32);
        var protocol$2 = $m_s_Option$().apply__O__s_Option(x28);
        var search$2 = $n(p$3).Ltyrian_LocationDetails$LocationPathDetails__f_search;
        return new $c_Ltyrian_LocationDetails(hash$2, hostName$2, pathName$2, port$2, protocol$2, search$2, url);
      }
    }
  }
  var this$17 = $n($m_s_Option$().apply__O__s_Option(url));
  var p$4 = $p_Ltyrian_LocationDetails$__parsePath__T__Ltyrian_LocationDetails$LocationPathDetails(this, $as_T((this$17.isEmpty__Z() ? "" : this$17.get__O())));
  $m_Ltyrian_LocationDetails$();
  var hash$3 = $n(p$4).Ltyrian_LocationDetails$LocationPathDetails__f_hash;
  var hostName$3 = $m_s_None$();
  var pathName$3 = $n(p$4).Ltyrian_LocationDetails$LocationPathDetails__f_path;
  var port$3 = $m_s_None$();
  var protocol$3 = $m_s_None$();
  var search$3 = $n(p$4).Ltyrian_LocationDetails$LocationPathDetails__f_search;
  return new $c_Ltyrian_LocationDetails(hash$3, hostName$3, pathName$3, port$3, protocol$3, search$3, url);
});
var $d_Ltyrian_LocationDetails$ = new $TypeData().initClass($c_Ltyrian_LocationDetails$, "tyrian.LocationDetails$", ({
  Ltyrian_LocationDetails$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Ltyrian_LocationDetails$;
function $m_Ltyrian_LocationDetails$() {
  if ((!$n_Ltyrian_LocationDetails$)) {
    $n_Ltyrian_LocationDetails$ = new $c_Ltyrian_LocationDetails$();
  }
  return $n_Ltyrian_LocationDetails$;
}
function $p_Ltyrian_Sub$__cancel$2__F1__O__s_Option($thiz, release$5, res) {
  return $m_s_Option$().apply__O__s_Option($n(release$5).apply__O__O(res));
}
/** @constructor */
function $c_Ltyrian_Sub$() {
}
$c_Ltyrian_Sub$.prototype = new $h_O();
$c_Ltyrian_Sub$.prototype.constructor = $c_Ltyrian_Sub$;
/** @constructor */
function $h_Ltyrian_Sub$() {
}
$h_Ltyrian_Sub$.prototype = $c_Ltyrian_Sub$.prototype;
$c_Ltyrian_Sub$.prototype.merge__Ltyrian_Sub__Ltyrian_Sub__Ltyrian_Sub = (function(a, b) {
  var x = $m_Ltyrian_Sub$None$();
  if ((x === a)) {
    var x$3 = $m_Ltyrian_Sub$None$();
    if ((x$3 === b)) {
      return $m_Ltyrian_Sub$None$();
    }
    return b;
  }
  var x$5 = $m_Ltyrian_Sub$None$();
  if ((x$5 === b)) {
    return a;
  }
  return new $c_Ltyrian_Sub$Combine(a, b);
});
$c_Ltyrian_Sub$.prototype.make__T__F1__F1__F1__Lcats_effect_kernel_Sync__Ltyrian_Sub = (function(id, acquire, release, toMsg, evidence$1) {
  var task = $n(evidence$1).delay__F0__O(new $c_sjsr_AnonFunction0((() => new $c_sjsr_AnonFunction1(((cb) => {
    var cb$1 = $as_F1(cb);
    var target = $n(acquire).apply__O__O(cb$1);
    var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, evidence$1);
    var f = new $c_sjsr_AnonFunction1(((res) => $p_Ltyrian_Sub$__cancel$2__F1__O__s_Option(this, release, res)));
    return $n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  })))));
  return new $c_Ltyrian_Sub$Observe(id, task, toMsg);
});
$c_Ltyrian_Sub$.prototype.make__T__F1__F1__Lcats_effect_kernel_Sync__Ltyrian_Sub = (function(id, acquire, release, evidence$1) {
  return this.make__T__F1__F1__F1__Lcats_effect_kernel_Sync__Ltyrian_Sub(id, acquire, release, new $c_sjsr_AnonFunction1(((x) => $m_s_Option$().apply__O__s_Option(x))), evidence$1);
});
$c_Ltyrian_Sub$.prototype.make__T__Lfs2_Stream__O__Lcats_effect_kernel_Async__Ltyrian_Sub = (function(id, stream, cleanUp, evidence$1) {
  return this.make__T__F1__F1__Lcats_effect_kernel_Sync__Ltyrian_Sub(id, new $c_sjsr_AnonFunction1(((cb) => {
    var cb$1 = $as_F1(cb);
    var $x_1 = $n(evidence$1);
    var this$5 = $n($n($n(stream).attempt__Lfs2_Stream()).foreach__F1__Lfs2_Stream(new $c_sjsr_AnonFunction1(((result) => {
      var result$1 = $as_s_util_Either(result);
      return $n(evidence$1).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
        $n(cb$1).apply__O__O(result$1);
      })));
    }))));
    $m_Lfs2_Compiler$();
    var F = new $c_Lfs2_Compiler$Target$ConcurrentTarget(evidence$1);
    var compiler = new $c_Lfs2_CompilerLowPriority1$$anon$2(F);
    return $n($x_1).start__O__O(new $c_Lfs2_Stream$CompileOps(this$5.Lfs2_Stream__f_underlying, compiler).drain__O());
  })), new $c_sjsr_AnonFunction1(((_$12) => {
    var _$12$1 = $as_Lcats_effect_kernel_Fiber(_$12);
    var target = $n(_$12$1).cancel__O();
    var this$7 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, evidence$1);
    var f = new $c_sjsr_AnonFunction1(((_$13) => {
      $as_jl_Void(_$13);
      return cleanUp;
    }));
    return $n(this$7.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$7.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  })), evidence$1);
});
$c_Ltyrian_Sub$.prototype.fromEvent__T__Lorg_scalajs_dom_EventTarget__F1__Lcats_effect_kernel_Sync__Ltyrian_Sub = (function(name, target, extract, evidence$1) {
  return $m_Ltyrian_Sub$().make__T__F1__F1__F1__Lcats_effect_kernel_Sync__Ltyrian_Sub((("" + name) + $dp_hashCode__I($n(target))), new $c_sjsr_AnonFunction1(((callback) => {
    var callback$1 = $as_F1(callback);
    return $n(evidence$1).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
      var f = new $c_sjsr_AnonFunction1(((a) => {
        $n(callback$1).apply__O__O(new $c_s_util_Right(a));
      }));
      var listener = $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(f);
      target.addEventListener(name, listener);
      return listener;
    })));
  })), new $c_sjsr_AnonFunction1(((listener$1) => $n(evidence$1).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
    target.removeEventListener(name, listener$1);
  }))))), extract, evidence$1);
});
var $d_Ltyrian_Sub$ = new $TypeData().initClass($c_Ltyrian_Sub$, "tyrian.Sub$", ({
  Ltyrian_Sub$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Ltyrian_Sub$;
function $m_Ltyrian_Sub$() {
  if ((!$n_Ltyrian_Sub$)) {
    $n_Ltyrian_Sub$ = new $c_Ltyrian_Sub$();
  }
  return $n_Ltyrian_Sub$;
}
function $p_Ltyrian_runtime_Renderer$__render__Lcats_effect_std_Dispatcher__Lcats_effect_kernel_Ref__Lcats_effect_kernel_Ref__F1__F1__F1__J__Lcats_effect_kernel_Async__Lcats_effect_kernel_Clock__V($thiz, dispatcher, renderer, model, view, onMsg, router, t, F, clock) {
  var this$30 = $n(dispatcher);
  var target = $n(clock).realTime__O();
  var this$3 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, F);
  var f = new $c_sjsr_AnonFunction1(((_$5) => {
    var _$5$1 = $as_s_concurrent_duration_FiniteDuration(_$5);
    var this$2 = $n(_$5$1);
    return $n(this$2.s_concurrent_duration_FiniteDuration__f_unit).toMillis__J__J(this$2.s_concurrent_duration_FiniteDuration__f_length);
  }));
  var target$1 = $n(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  var this$29 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, F);
  var f$3 = new $c_sjsr_AnonFunction1(((time) => {
    var t$1 = $uJ(time);
    var lo = t$1.RTLong__f_lo;
    var hi = t$1.RTLong__f_hi;
    var target$2 = $n(model).get__O();
    var this$28 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, F);
    var f$2 = new $c_sjsr_AnonFunction1(((time$2) => ((m) => {
      var ffa = $n(renderer).modify__F1__O(new $c_sjsr_AnonFunction1(((r) => {
        var r$1 = $as_Ltyrian_runtime_Renderer(r);
        var x9 = $n(r$1).Ltyrian_runtime_Renderer__f_state;
        var x = $s_Ltyrian_runtime_RendererState$__Idle__Ltyrian_runtime_RendererState();
        if (((x === null) ? (x9 === null) : $n(x).equals__O__Z(x9))) {
          var this$7 = $n(F);
          var y = this$7.pure__O__O((void 0));
          return new $c_T2(r$1, y);
        }
        if ((x9 instanceof $c_Ltyrian_runtime_RendererState$Running)) {
          var x$1 = $as_Ltyrian_runtime_RendererState$Running(x9);
          var this$10 = $n(x$1);
          var t$2 = this$10.Ltyrian_runtime_RendererState$Running__f_lastTriggered;
          var lo$1 = t$2.RTLong__f_lo;
          var hi$1 = t$2.RTLong__f_hi;
          var alo = t.RTLong__f_lo;
          var ahi = t.RTLong__f_hi;
          var lo$2 = ((alo - lo$1) | 0);
          var hi$2 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - hi$1) | 0)) | 0) : ((ahi - hi$1) | 0));
          if (((hi$2 === 0) ? (((-2147483648) ^ lo$2) >= (-2147482648)) : (hi$2 > 0))) {
            var state$2 = $s_Ltyrian_runtime_RendererState$__Idle__Ltyrian_runtime_RendererState();
            var this$12 = $n(r$1);
            var vnode$2 = this$12.Ltyrian_runtime_Renderer__f_vnode;
            $n(r$1);
            var self = new $c_Ltyrian_runtime_Renderer(vnode$2, state$2);
            var this$15 = $n(F);
            var y$1 = this$15.pure__O__O((void 0));
            return new $c_T2(self, y$1);
          } else {
            $n(r$1);
            var vnode = $m_Ltyrian_runtime_Rendering$().render__O__O__F1__F1__F1__Lsnabbdom_VNode($n(r$1).Ltyrian_runtime_Renderer__f_vnode, m, view, onMsg, router);
            var this$17 = $n(r$1);
            var state = this$17.Ltyrian_runtime_Renderer__f_state;
            var self$1 = new $c_Ltyrian_runtime_Renderer(vnode, state);
            var target$3 = $n(F).delay__F0__O(new $c_sjsr_AnonFunction0((() => $uI(window.requestAnimationFrame(((_$6) => {
              $uD(_$6);
              $p_Ltyrian_runtime_Renderer$__render__Lcats_effect_std_Dispatcher__Lcats_effect_kernel_Ref__Lcats_effect_kernel_Ref__F1__F1__F1__J__Lcats_effect_kernel_Async__Lcats_effect_kernel_Clock__V($m_Ltyrian_runtime_Renderer$(), dispatcher, renderer, model, view, onMsg, router, time$2, F, F);
            }))))));
            var this$21 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, F);
            var y$2 = $n(this$21.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$21.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
            return new $c_T2(self$1, y$2);
          }
        }
        throw new $c_s_MatchError(x9);
      })));
      var this$25 = $n(F);
      var target$4 = $f_Lcats_FlatMap__flatten__O__O(this$25, ffa);
      var this$27 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$4, F);
      var f$1 = new $c_sjsr_AnonFunction1(((res) => {
        $as_jl_Void(res);
      }));
      return $n(this$27.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$27.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
    }))(new $c_RTLong(lo, hi)));
    return $n(this$28.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$28.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
  }));
  var fa = $n(this$29.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$29.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
  $f_Lcats_effect_std_Dispatcher__unsafeRunAndForget__O__V(this$30, fa);
}
/** @constructor */
function $c_Ltyrian_runtime_Renderer$() {
  this.Ltyrian_runtime_Renderer$__f_timeout = $L0;
  this.Ltyrian_runtime_Renderer$__f_timeout = new $c_RTLong(1000, 0);
}
$c_Ltyrian_runtime_Renderer$.prototype = new $h_O();
$c_Ltyrian_runtime_Renderer$.prototype.constructor = $c_Ltyrian_runtime_Renderer$;
/** @constructor */
function $h_Ltyrian_runtime_Renderer$() {
}
$h_Ltyrian_runtime_Renderer$.prototype = $c_Ltyrian_runtime_Renderer$.prototype;
$c_Ltyrian_runtime_Renderer$.prototype.init__Lsnabbdom_VNode__Lcats_effect_kernel_Async__O = (function(vnode, F) {
  var $x_1 = $n(F);
  var state = $s_Ltyrian_runtime_RendererState$__Idle__Ltyrian_runtime_RendererState();
  return $n($x_1).ref__O__O(new $c_Ltyrian_runtime_Renderer(vnode, state));
});
$c_Ltyrian_runtime_Renderer$.prototype.redraw__Lcats_effect_std_Dispatcher__Lcats_effect_kernel_Ref__Lcats_effect_kernel_Ref__F1__F1__F1__Lcats_effect_kernel_Async__Lcats_effect_kernel_Clock__O = (function(dispatcher, renderer, model, view, onMsg, router, F, clock) {
  var target = $n(clock).realTime__O();
  var this$14 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F);
  var f = new $c_sjsr_AnonFunction1(((time) => {
    var time$1 = $as_s_concurrent_duration_FiniteDuration(time);
    return $n(renderer).modify__F1__O(new $c_sjsr_AnonFunction1(((r) => {
      var r$1 = $as_Ltyrian_runtime_Renderer(r);
      var x5 = $n(r$1).Ltyrian_runtime_Renderer__f_state;
      var x = $s_Ltyrian_runtime_RendererState$__Idle__Ltyrian_runtime_RendererState();
      if (((x === null) ? (x5 === null) : $n(x).equals__O__Z(x5))) {
        var $x_1 = $n(r$1);
        var this$2 = $n(time$1);
        var self = $n($x_1).runningAt__J__Ltyrian_runtime_Renderer($n(this$2.s_concurrent_duration_FiniteDuration__f_unit).toMillis__J__J(this$2.s_concurrent_duration_FiniteDuration__f_length));
        var target$1 = $n(F).delay__F0__O(new $c_sjsr_AnonFunction0((() => $uI(window.requestAnimationFrame(((_$3) => {
          $uD(_$3);
          var $x_2 = $m_Ltyrian_runtime_Renderer$();
          var this$4 = $n(time$1);
          $p_Ltyrian_runtime_Renderer$__render__Lcats_effect_std_Dispatcher__Lcats_effect_kernel_Ref__Lcats_effect_kernel_Ref__F1__F1__F1__J__Lcats_effect_kernel_Async__Lcats_effect_kernel_Clock__V($n($x_2), dispatcher, renderer, model, view, onMsg, router, $n(this$4.s_concurrent_duration_FiniteDuration__f_unit).toMillis__J__J(this$4.s_concurrent_duration_FiniteDuration__f_length), F, F);
        }))))));
        var this$6 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, F);
        var y = $n(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
        return new $c_T2(self, y);
      }
      if ((x5 instanceof $c_Ltyrian_runtime_RendererState$Running)) {
        var x$1 = $as_Ltyrian_runtime_RendererState$Running(x5);
        var this$9 = $n(x$1);
        var t = this$9.Ltyrian_runtime_RendererState$Running__f_lastTriggered;
        var $x_3 = $n(r$1);
        var this$10 = $n(time$1);
        var self$1 = $n($x_3).runningAt__J__Ltyrian_runtime_Renderer($n(this$10.s_concurrent_duration_FiniteDuration__f_unit).toMillis__J__J(this$10.s_concurrent_duration_FiniteDuration__f_length));
        var this$12 = $n(F);
        var y$1 = this$12.pure__O__O((void 0));
        return new $c_T2(self$1, y$1);
      }
      throw new $c_s_MatchError(x5);
    })));
  }));
  var ffa = $n(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  var this$17 = $n(F);
  return $f_Lcats_FlatMap__flatten__O__O(this$17, ffa);
});
var $d_Ltyrian_runtime_Renderer$ = new $TypeData().initClass($c_Ltyrian_runtime_Renderer$, "tyrian.runtime.Renderer$", ({
  Ltyrian_runtime_Renderer$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Ltyrian_runtime_Renderer$;
function $m_Ltyrian_runtime_Renderer$() {
  if ((!$n_Ltyrian_runtime_Renderer$)) {
    $n_Ltyrian_runtime_Renderer$ = new $c_Ltyrian_runtime_Renderer$();
  }
  return $n_Ltyrian_runtime_Renderer$;
}
function $s_Ltyrian_runtime_RendererState$__Idle__Ltyrian_runtime_RendererState() {
  $m_Ltyrian_runtime_RendererState$();
  return $t_Ltyrian_runtime_RendererState$__Idle;
}
/** @constructor */
function $c_Ltyrian_runtime_RendererState$() {
  $n_Ltyrian_runtime_RendererState$ = this;
  $t_Ltyrian_runtime_RendererState$__Idle = new $c_Ltyrian_runtime_RendererState$$anon$1("Idle", 0, this);
}
$c_Ltyrian_runtime_RendererState$.prototype = new $h_O();
$c_Ltyrian_runtime_RendererState$.prototype.constructor = $c_Ltyrian_runtime_RendererState$;
/** @constructor */
function $h_Ltyrian_runtime_RendererState$() {
}
$h_Ltyrian_runtime_RendererState$.prototype = $c_Ltyrian_runtime_RendererState$.prototype;
var $d_Ltyrian_runtime_RendererState$ = new $TypeData().initClass($c_Ltyrian_runtime_RendererState$, "tyrian.runtime.RendererState$", ({
  Ltyrian_runtime_RendererState$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Ltyrian_runtime_RendererState$;
function $m_Ltyrian_runtime_RendererState$() {
  if ((!$n_Ltyrian_runtime_RendererState$)) {
    $n_Ltyrian_runtime_RendererState$ = new $c_Ltyrian_runtime_RendererState$();
  }
  return $n_Ltyrian_runtime_RendererState$;
}
/** @constructor */
function $c_Lcats_Always(f) {
  this.Lcats_Always__f_f = null;
  this.Lcats_Always__f_f = f;
}
$c_Lcats_Always.prototype = new $h_Lcats_Eval$Leaf();
$c_Lcats_Always.prototype.constructor = $c_Lcats_Always;
/** @constructor */
function $h_Lcats_Always() {
}
$h_Lcats_Always.prototype = $c_Lcats_Always.prototype;
$c_Lcats_Always.prototype.value__O = (function() {
  return $n(this.Lcats_Always__f_f).apply__O();
});
$c_Lcats_Always.prototype.memoize__Lcats_Eval = (function() {
  return new $c_Lcats_Later(this.Lcats_Always__f_f);
});
var $d_Lcats_Always = new $TypeData().initClass($c_Lcats_Always, "cats.Always", ({
  Lcats_Always: 1,
  Lcats_Eval$Leaf: 1,
  Lcats_Eval: 1,
  Ljava_io_Serializable: 1
}));
function $is_Lcats_CoflatMap(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_CoflatMap)));
}
function $as_Lcats_CoflatMap(obj) {
  return (($is_Lcats_CoflatMap(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.CoflatMap"));
}
function $isArrayOf_Lcats_CoflatMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_CoflatMap)));
}
function $asArrayOf_Lcats_CoflatMap(obj, depth) {
  return (($isArrayOf_Lcats_CoflatMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.CoflatMap;", depth));
}
function $p_Lcats_Eval$__addToMemo$1__Lcats_Eval$Memoize__F1($thiz, m) {
  return new $c_sjsr_AnonFunction1(((a) => {
    $n(m).Lcats_Eval$Memoize__f_result = new $c_s_Some(a);
    return new $c_Lcats_Now(a);
  }));
}
function $p_Lcats_Eval$__loop$1__Lcats_Eval__Lcats_Eval$FnStack__O($thiz, curr, fs) {
  var fs$tailLocal1 = fs;
  var curr$tailLocal1 = curr;
  while (true) {
    var x52 = curr$tailLocal1;
    if ((x52 instanceof $c_Lcats_Eval$FlatMap)) {
      var c = $as_Lcats_Eval$FlatMap(x52);
      var x26 = $as_Lcats_Eval($n($n(c).start__F0()).apply__O());
      if ((x26 instanceof $c_Lcats_Eval$FlatMap)) {
        var cc = $as_Lcats_Eval$FlatMap(x26);
        var first = $n(c).run__F1();
        var rest = fs$tailLocal1;
        var nextFs = new $c_Lcats_Eval$Many(first, rest);
        var curr$tailLocal1$tmp1 = $as_Lcats_Eval($n($n(cc).start__F0()).apply__O());
        var first$1 = $n(cc).run__F1();
        var fs$tailLocal1$tmp1 = new $c_Lcats_Eval$Many(first$1, nextFs);
        curr$tailLocal1 = curr$tailLocal1$tmp1;
        fs$tailLocal1 = fs$tailLocal1$tmp1;
        continue;
      }
      if ((x26 instanceof $c_Lcats_Eval$Defer)) {
        var call = $as_Lcats_Eval$Defer(x26);
        var curr$tailLocal1$tmp2 = $as_Lcats_Eval($n($n(call).Lcats_Eval$Defer__f_thunk).apply__O());
        var first$2 = $n(c).run__F1();
        var rest$1 = fs$tailLocal1;
        var fs$tailLocal1$tmp2 = new $c_Lcats_Eval$Many(first$2, rest$1);
        curr$tailLocal1 = curr$tailLocal1$tmp2;
        fs$tailLocal1 = fs$tailLocal1$tmp2;
        continue;
      }
      if ((x26 instanceof $c_Lcats_Eval$Memoize)) {
        var x28 = $as_Lcats_Eval$Memoize(x26);
        var this$5 = $n(x28);
        var x30 = this$5.Lcats_Eval$Memoize__f_eval;
        var x23 = $n(x28).Lcats_Eval$Memoize__f_result;
        if ((x23 instanceof $c_s_Some)) {
          var a = $n($as_s_Some(x23)).s_Some__f_value;
          curr$tailLocal1 = $as_Lcats_Eval($n($n(c).run__F1()).apply__O__O(a));
          continue;
        }
        var x = $m_s_None$();
        if ((x === x23)) {
          var first$3 = $n(c).run__F1();
          var rest$2 = fs$tailLocal1;
          var nextFs$2 = new $c_Lcats_Eval$Many(first$3, rest$2);
          var first$4 = $p_Lcats_Eval$__addToMemo$1__Lcats_Eval$Memoize__F1($thiz, x28);
          var fs$tailLocal1$tmp3 = new $c_Lcats_Eval$Many(first$4, nextFs$2);
          curr$tailLocal1 = x30;
          fs$tailLocal1 = fs$tailLocal1$tmp3;
          continue;
        }
        throw new $c_s_MatchError(x23);
      }
      if ((x26 instanceof $c_Lcats_Eval$Leaf)) {
        var xx = $as_Lcats_Eval$Leaf(x26);
        curr$tailLocal1 = $as_Lcats_Eval($n($n(c).run__F1()).apply__O__O($n(xx).value__O()));
        continue;
      }
      throw new $c_s_MatchError(x26);
    }
    if ((x52 instanceof $c_Lcats_Eval$Defer)) {
      var call$2 = $as_Lcats_Eval$Defer(x52);
      curr$tailLocal1 = $as_Lcats_Eval($n($n(call$2).Lcats_Eval$Defer__f_thunk).apply__O());
      continue;
    }
    if ((x52 instanceof $c_Lcats_Eval$Memoize)) {
      var m = $as_Lcats_Eval$Memoize(x52);
      var x41 = $n(m).Lcats_Eval$Memoize__f_result;
      if ((x41 instanceof $c_s_Some)) {
        var a$2 = $n($as_s_Some(x41)).s_Some__f_value;
        var x33 = fs$tailLocal1;
        if ((x33 instanceof $c_Lcats_Eval$Many)) {
          var x$1 = $as_Lcats_Eval$Many(x33);
          var this$9 = $n(x$1);
          var x39 = this$9.Lcats_Eval$Many__f_first;
          var this$10 = $n(x$1);
          var x40 = this$10.Lcats_Eval$Many__f_rest;
          var curr$tailLocal1$tmp4 = $as_Lcats_Eval($n(x39).apply__O__O(a$2));
          curr$tailLocal1 = curr$tailLocal1$tmp4;
          fs$tailLocal1 = x40;
          continue;
        }
        if ((x33 instanceof $c_Lcats_Eval$Ident)) {
          var x$1$1 = $as_Lcats_Eval$Ident(x33);
          var this$12 = $n(x$1$1);
          var x36 = this$12.Lcats_Eval$Ident__f_ev;
          $n(x36);
          return a$2;
        }
        throw new $c_s_MatchError(x33);
      }
      var x$3 = $m_s_None$();
      if ((x$3 === x41)) {
        var curr$tailLocal1$tmp5 = $n(m).Lcats_Eval$Memoize__f_eval;
        var first$5 = $p_Lcats_Eval$__addToMemo$1__Lcats_Eval$Memoize__F1($thiz, m);
        var rest$3 = fs$tailLocal1;
        var fs$tailLocal1$tmp5 = new $c_Lcats_Eval$Many(first$5, rest$3);
        curr$tailLocal1 = curr$tailLocal1$tmp5;
        fs$tailLocal1 = fs$tailLocal1$tmp5;
        continue;
      }
      throw new $c_s_MatchError(x41);
    }
    if ((x52 instanceof $c_Lcats_Eval$Leaf)) {
      var x$5 = $as_Lcats_Eval$Leaf(x52);
      var a1 = $n(x$5).value__O();
      var x44 = fs$tailLocal1;
      if ((x44 instanceof $c_Lcats_Eval$Many)) {
        var x$1$2 = $as_Lcats_Eval$Many(x44);
        var this$16 = $n(x$1$2);
        var x50 = this$16.Lcats_Eval$Many__f_first;
        var this$17 = $n(x$1$2);
        var x51 = this$17.Lcats_Eval$Many__f_rest;
        var curr$tailLocal1$tmp6 = $as_Lcats_Eval($n(x50).apply__O__O(a1));
        curr$tailLocal1 = curr$tailLocal1$tmp6;
        fs$tailLocal1 = x51;
        continue;
      }
      if ((x44 instanceof $c_Lcats_Eval$Ident)) {
        var x$1$3 = $as_Lcats_Eval$Ident(x44);
        var this$19 = $n(x$1$3);
        var x47 = this$19.Lcats_Eval$Ident__f_ev;
        $n(x47);
        return a1;
      }
      throw new $c_s_MatchError(x44);
    }
    throw new $c_s_MatchError(x52);
  }
}
/** @constructor */
function $c_Lcats_Eval$() {
  this.Lcats_EvalInstances__f_catsBimonadForEval = null;
  this.Lcats_Eval$__f_Unit = null;
  this.Lcats_Eval$__f_True = null;
  this.Lcats_Eval$__f_False = null;
  $ct_Lcats_EvalInstances__(this);
  $n_Lcats_Eval$ = this;
  this.Lcats_Eval$__f_Unit = new $c_Lcats_Now((void 0));
  this.Lcats_Eval$__f_True = new $c_Lcats_Now(true);
  this.Lcats_Eval$__f_False = new $c_Lcats_Now(false);
}
$c_Lcats_Eval$.prototype = new $h_Lcats_EvalInstances();
$c_Lcats_Eval$.prototype.constructor = $c_Lcats_Eval$;
/** @constructor */
function $h_Lcats_Eval$() {
}
$h_Lcats_Eval$.prototype = $c_Lcats_Eval$.prototype;
$c_Lcats_Eval$.prototype.cats$Eval$$$evaluate__Lcats_Eval__O = (function(e) {
  var this$1 = $m_s_$less$colon$less$();
  var e$1 = this$1.s_$less$colon$less$__f_singleton;
  return $p_Lcats_Eval$__loop$1__Lcats_Eval__Lcats_Eval$FnStack__O(this, e, new $c_Lcats_Eval$Ident(e$1));
});
var $d_Lcats_Eval$ = new $TypeData().initClass($c_Lcats_Eval$, "cats.Eval$", ({
  Lcats_Eval$: 1,
  Lcats_EvalInstances: 1,
  Lcats_EvalInstances0: 1,
  Lcats_EvalInstances1: 1
}));
var $n_Lcats_Eval$;
function $m_Lcats_Eval$() {
  if ((!$n_Lcats_Eval$)) {
    $n_Lcats_Eval$ = new $c_Lcats_Eval$();
  }
  return $n_Lcats_Eval$;
}
/** @constructor */
function $c_Lcats_Eval$$anon$1(c$1, f$2) {
  this.Lcats_Eval$$anon$1__f_start = null;
  this.Lcats_Eval$$anon$1__f_run = null;
  this.Lcats_Eval$$anon$1__f_start = $n(c$1).start__F0();
  this.Lcats_Eval$$anon$1__f_run = new $c_sjsr_AnonFunction1(((s) => new $c_Lcats_Eval$$anon$2(c$1, s, f$2, this)));
}
$c_Lcats_Eval$$anon$1.prototype = new $h_Lcats_Eval$FlatMap();
$c_Lcats_Eval$$anon$1.prototype.constructor = $c_Lcats_Eval$$anon$1;
/** @constructor */
function $h_Lcats_Eval$$anon$1() {
}
$h_Lcats_Eval$$anon$1.prototype = $c_Lcats_Eval$$anon$1.prototype;
$c_Lcats_Eval$$anon$1.prototype.start__F0 = (function() {
  return this.Lcats_Eval$$anon$1__f_start;
});
$c_Lcats_Eval$$anon$1.prototype.run__F1 = (function() {
  return this.Lcats_Eval$$anon$1__f_run;
});
var $d_Lcats_Eval$$anon$1 = new $TypeData().initClass($c_Lcats_Eval$$anon$1, "cats.Eval$$anon$1", ({
  Lcats_Eval$$anon$1: 1,
  Lcats_Eval$FlatMap: 1,
  Lcats_Eval: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_Eval$$anon$2(c$3, s$1, f$4, outer) {
  this.Lcats_Eval$$anon$2__f_start = null;
  this.Lcats_Eval$$anon$2__f_run = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_Eval$$anon$2__f_start = new $c_sjsr_AnonFunction0((() => $as_Lcats_Eval($n($n(c$3).run__F1()).apply__O__O(s$1))));
  this.Lcats_Eval$$anon$2__f_run = f$4;
}
$c_Lcats_Eval$$anon$2.prototype = new $h_Lcats_Eval$FlatMap();
$c_Lcats_Eval$$anon$2.prototype.constructor = $c_Lcats_Eval$$anon$2;
/** @constructor */
function $h_Lcats_Eval$$anon$2() {
}
$h_Lcats_Eval$$anon$2.prototype = $c_Lcats_Eval$$anon$2.prototype;
$c_Lcats_Eval$$anon$2.prototype.start__F0 = (function() {
  return this.Lcats_Eval$$anon$2__f_start;
});
$c_Lcats_Eval$$anon$2.prototype.run__F1 = (function() {
  return this.Lcats_Eval$$anon$2__f_run;
});
var $d_Lcats_Eval$$anon$2 = new $TypeData().initClass($c_Lcats_Eval$$anon$2, "cats.Eval$$anon$2", ({
  Lcats_Eval$$anon$2: 1,
  Lcats_Eval$FlatMap: 1,
  Lcats_Eval: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_Eval$$anon$3(c$5, f$5) {
  this.Lcats_Eval$$anon$3__f_start = null;
  this.Lcats_Eval$$anon$3__f_run = null;
  this.Lcats_Eval$$anon$3__f_start = $n(c$5).Lcats_Eval$Defer__f_thunk;
  this.Lcats_Eval$$anon$3__f_run = f$5;
}
$c_Lcats_Eval$$anon$3.prototype = new $h_Lcats_Eval$FlatMap();
$c_Lcats_Eval$$anon$3.prototype.constructor = $c_Lcats_Eval$$anon$3;
/** @constructor */
function $h_Lcats_Eval$$anon$3() {
}
$h_Lcats_Eval$$anon$3.prototype = $c_Lcats_Eval$$anon$3.prototype;
$c_Lcats_Eval$$anon$3.prototype.start__F0 = (function() {
  return this.Lcats_Eval$$anon$3__f_start;
});
$c_Lcats_Eval$$anon$3.prototype.run__F1 = (function() {
  return this.Lcats_Eval$$anon$3__f_run;
});
var $d_Lcats_Eval$$anon$3 = new $TypeData().initClass($c_Lcats_Eval$$anon$3, "cats.Eval$$anon$3", ({
  Lcats_Eval$$anon$3: 1,
  Lcats_Eval$FlatMap: 1,
  Lcats_Eval: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_Eval$$anon$4(f$6, outer) {
  this.Lcats_Eval$$anon$4__f_start = null;
  this.Lcats_Eval$$anon$4__f_run = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_Eval$$anon$4__f_start = new $c_sjsr_AnonFunction0((() => outer));
  this.Lcats_Eval$$anon$4__f_run = f$6;
}
$c_Lcats_Eval$$anon$4.prototype = new $h_Lcats_Eval$FlatMap();
$c_Lcats_Eval$$anon$4.prototype.constructor = $c_Lcats_Eval$$anon$4;
/** @constructor */
function $h_Lcats_Eval$$anon$4() {
}
$h_Lcats_Eval$$anon$4.prototype = $c_Lcats_Eval$$anon$4.prototype;
$c_Lcats_Eval$$anon$4.prototype.start__F0 = (function() {
  return this.Lcats_Eval$$anon$4__f_start;
});
$c_Lcats_Eval$$anon$4.prototype.run__F1 = (function() {
  return this.Lcats_Eval$$anon$4__f_run;
});
var $d_Lcats_Eval$$anon$4 = new $TypeData().initClass($c_Lcats_Eval$$anon$4, "cats.Eval$$anon$4", ({
  Lcats_Eval$$anon$4: 1,
  Lcats_Eval$FlatMap: 1,
  Lcats_Eval: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_Eval$$anon$5(a$2, outer) {
  this.Lcats_Eval$Defer__f_thunk = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Lcats_Eval$Defer__F0__(this, ($m_Lcats_Eval$(), a$2));
}
$c_Lcats_Eval$$anon$5.prototype = new $h_Lcats_Eval$Defer();
$c_Lcats_Eval$$anon$5.prototype.constructor = $c_Lcats_Eval$$anon$5;
/** @constructor */
function $h_Lcats_Eval$$anon$5() {
}
$h_Lcats_Eval$$anon$5.prototype = $c_Lcats_Eval$$anon$5.prototype;
var $d_Lcats_Eval$$anon$5 = new $TypeData().initClass($c_Lcats_Eval$$anon$5, "cats.Eval$$anon$5", ({
  Lcats_Eval$$anon$5: 1,
  Lcats_Eval$Defer: 1,
  Lcats_Eval: 1,
  Ljava_io_Serializable: 1
}));
function $f_Lcats_Foldable__reduceLeftToOption__O__F1__F2__s_Option($thiz, fa, f, g) {
  return $as_s_Option($thiz.foldLeft__O__O__F2__O(fa, $m_s_None$(), new $c_sjsr_AnonFunction2(((x$1, x$2) => {
    var x$1$1 = $as_s_Option(x$1);
    var x6 = new $c_T2(x$1$1, x$2);
    var x9 = $as_s_Option(x6.T2__f__1);
    var x10 = x6.T2__f__2;
    if ((x9 instanceof $c_s_Some)) {
      var b = $n($as_s_Some(x9)).s_Some__f_value;
      var value = $n(g).apply__O__O__O(b, x10);
      return new $c_s_Some(value);
    }
    var x = $m_s_None$();
    if ((x === x9)) {
      var value$1 = $n(f).apply__O__O(x10);
      return new $c_s_Some(value$1);
    }
    throw new $c_s_MatchError(x6);
  }))));
}
function $f_Lcats_Foldable__reduceLeftOption__O__F2__s_Option($thiz, fa, f) {
  return $thiz.reduceLeftToOption__O__F1__F2__s_Option(fa, new $c_sjsr_AnonFunction1(((x) => x)), f);
}
function $f_Lcats_Foldable__maximumOption__O__Lcats_kernel_Order__s_Option($thiz, fa, A) {
  return $thiz.reduceLeftOption__O__F2__s_Option(fa, new $c_sjsr_AnonFunction2(((x, y) => $n(A).max__O__O__O(x, y))));
}
function $f_Lcats_Foldable__maximumByOption__O__F1__Lcats_kernel_Order__s_Option($thiz, fa, f, evidence$1) {
  var this$1 = $n($m_Lcats_package$().Lcats_package$__f_Order);
  return $thiz.maximumOption__O__Lcats_kernel_Order__s_Option(fa, new $c_Lcats_kernel_Order$$anon$2(evidence$1, f, this$1));
}
function $f_Lcats_Foldable__fold__O__Lcats_kernel_Monoid__O($thiz, fa, A) {
  return $n(A).combineAll__sc_IterableOnce__O($thiz.toIterable__O__sc_Iterable(fa));
}
function $f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O($thiz, fa, z, f, G) {
  var src = $m_Lcats_Foldable$Source$().fromFoldable__O__Lcats_Foldable__Lcats_Foldable$Source(fa, $thiz);
  return $n(G).tailRecM__O__F1__O(new $c_T2(z, src), new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var b = $n(x$1$1)._1__O();
      var src$1 = $as_Lcats_Foldable$Source($n(x$1$1)._2__O());
      var x63 = $n(src$1).uncons__s_Option();
      if ((x63 instanceof $c_s_Some)) {
        var x65 = $as_T2($n($as_s_Some(x63)).s_Some__f_value);
        if ((x65 !== null)) {
          var a = $n(x65)._1__O();
          var src$2 = $as_Lcats_Eval($n(x65)._2__O());
          return $n(G).map__O__F1__O($n(f).apply__O__O__O(b, a), new $c_sjsr_AnonFunction1(((b$2) => {
            var _2 = $n(src$2).value__O();
            var value = new $c_T2(b$2, _2);
            return new $c_s_util_Left(value);
          })));
        }
      }
      var x = $m_s_None$();
      if ((x === x63)) {
        return $n(G).pure__O__O(new $c_s_util_Right(b));
      }
      throw new $c_s_MatchError(x63);
    }
    throw new $c_s_MatchError(x$1$1);
  })));
}
function $f_Lcats_Foldable__foldMapM__O__F1__Lcats_Monad__Lcats_kernel_Monoid__O($thiz, fa, f, G, B) {
  return $thiz.foldM__O__O__F2__Lcats_Monad__O(fa, $n(B).empty__O(), new $c_sjsr_AnonFunction2(((b, a) => $n(G).map__O__F1__O($n(f).apply__O__O(a), new $c_sjsr_AnonFunction1(((_$14) => $n(B).combine__O__O__O(b, _$14)))))), G);
}
function $f_Lcats_Foldable__traverse___O__F1__Lcats_Applicative__O($thiz, fa, f, G) {
  var a = new $c_sjsr_AnonFunction0((() => $n(G).unit__O()));
  return $n($thiz.foldRight__O__Lcats_Eval__F2__Lcats_Eval(fa, new $c_Lcats_Always(a), new $c_sjsr_AnonFunction2(((a$1, acc) => {
    var acc$1 = $as_Lcats_Eval(acc);
    return $n(G).map2Eval__O__Lcats_Eval__F2__Lcats_Eval($n(f).apply__O__O(a$1), acc$1, new $c_sjsr_AnonFunction2(((_$17, _$18) => {
      $as_jl_Void(_$18);
    })));
  })))).value__O();
}
function $f_Lcats_Foldable__toList__O__sci_List($thiz, fa) {
  return $n($as_scm_ListBuffer($thiz.foldLeft__O__O__F2__O(fa, new $c_scm_ListBuffer(), new $c_sjsr_AnonFunction2(((buf, a) => {
    var buf$1 = $as_scm_ListBuffer(buf);
    var this$2 = $n(buf$1);
    return this$2.addOne__O__scm_ListBuffer(a);
  }))))).toList__sci_List();
}
function $is_Lcats_Foldable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_Foldable)));
}
function $as_Lcats_Foldable(obj) {
  return (($is_Lcats_Foldable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Foldable"));
}
function $isArrayOf_Lcats_Foldable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Foldable)));
}
function $asArrayOf_Lcats_Foldable(obj, depth) {
  return (($isArrayOf_Lcats_Foldable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Foldable;", depth));
}
/** @constructor */
function $c_Lcats_Later(f) {
  this.Lcats_Later__f_thunk = null;
  this.Lcats_Later__f_value$lzy1 = null;
  this.Lcats_Later__f_valuebitmap$1 = false;
  this.Lcats_Later__f_thunk = f;
}
$c_Lcats_Later.prototype = new $h_Lcats_Eval$Leaf();
$c_Lcats_Later.prototype.constructor = $c_Lcats_Later;
/** @constructor */
function $h_Lcats_Later() {
}
$h_Lcats_Later.prototype = $c_Lcats_Later.prototype;
$c_Lcats_Later.prototype.value__O = (function() {
  if ((!this.Lcats_Later__f_valuebitmap$1)) {
    var result = $n(this.Lcats_Later__f_thunk).apply__O();
    this.Lcats_Later__f_thunk = null;
    this.Lcats_Later__f_value$lzy1 = result;
    this.Lcats_Later__f_valuebitmap$1 = true;
  }
  return this.Lcats_Later__f_value$lzy1;
});
$c_Lcats_Later.prototype.memoize__Lcats_Eval = (function() {
  return this;
});
var $d_Lcats_Later = new $TypeData().initClass($c_Lcats_Later, "cats.Later", ({
  Lcats_Later: 1,
  Lcats_Eval$Leaf: 1,
  Lcats_Eval: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_MonoidK$$anon$1(outer) {
  this.Lcats_MonoidK$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_MonoidK$$anon$1__f_$outer = outer;
}
$c_Lcats_MonoidK$$anon$1.prototype = new $h_O();
$c_Lcats_MonoidK$$anon$1.prototype.constructor = $c_Lcats_MonoidK$$anon$1;
/** @constructor */
function $h_Lcats_MonoidK$$anon$1() {
}
$h_Lcats_MonoidK$$anon$1.prototype = $c_Lcats_MonoidK$$anon$1.prototype;
$c_Lcats_MonoidK$$anon$1.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_MonoidK$$anon$1.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAllOption__sc_IterableOnce__s_Option(this, as);
});
$c_Lcats_MonoidK$$anon$1.prototype.empty__O = (function() {
  return $n(this.Lcats_MonoidK$$anon$1__f_$outer).empty__O();
});
$c_Lcats_MonoidK$$anon$1.prototype.combine__O__O__O = (function(x, y) {
  return $n(this.Lcats_MonoidK$$anon$1__f_$outer).combineK__O__O__O(x, y);
});
var $d_Lcats_MonoidK$$anon$1 = new $TypeData().initClass($c_Lcats_MonoidK$$anon$1, "cats.MonoidK$$anon$1", ({
  Lcats_MonoidK$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
}));
/** @constructor */
function $c_Lcats_Parallel$$anon$2(evidence$1$1, outer) {
  this.Lcats_Parallel$$anon$2__f_applicative = null;
  this.Lcats_Parallel$$anon$2__f_sequential = null;
  this.Lcats_Parallel$$anon$2__f_parallel = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_Parallel$$anon$2__f_applicative = evidence$1$1;
  var this$3 = $m_Lcats_arrow_FunctionK$();
  this.Lcats_Parallel$$anon$2__f_sequential = new $c_Lcats_arrow_FunctionK$$anon$4(this$3);
  var this$4 = $m_Lcats_arrow_FunctionK$();
  this.Lcats_Parallel$$anon$2__f_parallel = new $c_Lcats_arrow_FunctionK$$anon$4(this$4);
}
$c_Lcats_Parallel$$anon$2.prototype = new $h_O();
$c_Lcats_Parallel$$anon$2.prototype.constructor = $c_Lcats_Parallel$$anon$2;
/** @constructor */
function $h_Lcats_Parallel$$anon$2() {
}
$h_Lcats_Parallel$$anon$2.prototype = $c_Lcats_Parallel$$anon$2.prototype;
$c_Lcats_Parallel$$anon$2.prototype.applicative__Lcats_Applicative = (function() {
  return this.Lcats_Parallel$$anon$2__f_applicative;
});
$c_Lcats_Parallel$$anon$2.prototype.sequential__Lcats_arrow_FunctionK = (function() {
  return this.Lcats_Parallel$$anon$2__f_sequential;
});
$c_Lcats_Parallel$$anon$2.prototype.parallel__Lcats_arrow_FunctionK = (function() {
  return this.Lcats_Parallel$$anon$2__f_parallel;
});
var $d_Lcats_Parallel$$anon$2 = new $TypeData().initClass($c_Lcats_Parallel$$anon$2, "cats.Parallel$$anon$2", ({
  Lcats_Parallel$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_NonEmptyParallel: 1,
  Lcats_Parallel: 1
}));
/** @constructor */
function $c_Lcats_Show$$anon$5(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_Show$$anon$5.prototype = new $h_O();
$c_Lcats_Show$$anon$5.prototype.constructor = $c_Lcats_Show$$anon$5;
/** @constructor */
function $h_Lcats_Show$$anon$5() {
}
$h_Lcats_Show$$anon$5.prototype = $c_Lcats_Show$$anon$5.prototype;
$c_Lcats_Show$$anon$5.prototype.show__O__T = (function(_$2) {
  return $dp_toString__T($n(_$2));
});
var $d_Lcats_Show$$anon$5 = new $TypeData().initClass($c_Lcats_Show$$anon$5, "cats.Show$$anon$5", ({
  Lcats_Show$$anon$5: 1,
  Ljava_io_Serializable: 1,
  Lcats_Show$ContravariantShow: 1,
  Lcats_Show: 1
}));
/** @constructor */
function $c_Lcats_UnorderedFoldable$() {
  $n_Lcats_UnorderedFoldable$ = this;
  new $c_Lcats_UnorderedFoldable$$anon$1();
  new $c_Lcats_UnorderedFoldable$$anon$2();
}
$c_Lcats_UnorderedFoldable$.prototype = new $h_O();
$c_Lcats_UnorderedFoldable$.prototype.constructor = $c_Lcats_UnorderedFoldable$;
/** @constructor */
function $h_Lcats_UnorderedFoldable$() {
}
$h_Lcats_UnorderedFoldable$.prototype = $c_Lcats_UnorderedFoldable$.prototype;
var $d_Lcats_UnorderedFoldable$ = new $TypeData().initClass($c_Lcats_UnorderedFoldable$, "cats.UnorderedFoldable$", ({
  Lcats_UnorderedFoldable$: 1,
  Lcats_ScalaVersionSpecificTraverseInstances: 1,
  Lcats_instances_NTupleUnorderedFoldableInstances: 1,
  Lcats_UnorderedFoldableLowPriority: 1
}));
var $n_Lcats_UnorderedFoldable$;
function $m_Lcats_UnorderedFoldable$() {
  if ((!$n_Lcats_UnorderedFoldable$)) {
    $n_Lcats_UnorderedFoldable$ = new $c_Lcats_UnorderedFoldable$();
  }
  return $n_Lcats_UnorderedFoldable$;
}
function $p_Lcats_data_Chain$ChainIterator__go$3__O($thiz) {
  while (true) {
    if ((($thiz.Lcats_data_Chain$ChainIterator__f_currentIterator !== null) && $n($thiz.Lcats_data_Chain$ChainIterator__f_currentIterator).hasNext__Z())) {
      return $n($thiz.Lcats_data_Chain$ChainIterator__f_currentIterator).next__O();
    } else {
      $thiz.Lcats_data_Chain$ChainIterator__f_currentIterator = null;
      var x210 = $thiz.Lcats_data_Chain$ChainIterator__f_c;
      if ((x210 instanceof $c_Lcats_data_Chain$Singleton)) {
        var x$1 = $as_Lcats_data_Chain$Singleton(x210);
        var this$2 = $n(x$1);
        var x220 = this$2.Lcats_data_Chain$Singleton__f_a;
        if ($n($thiz.Lcats_data_Chain$ChainIterator__f_rights).isEmpty__Z()) {
          var $x_1 = null;
        } else {
          var head = $as_Lcats_data_Chain$NonEmpty($n($thiz.Lcats_data_Chain$ChainIterator__f_rights).head__O());
          $thiz.Lcats_data_Chain$ChainIterator__f_rights = $as_sci_List($n($thiz.Lcats_data_Chain$ChainIterator__f_rights).tail__O());
          var $x_1 = head;
        }
        $thiz.Lcats_data_Chain$ChainIterator__f_c = $x_1;
        return x220;
      }
      if ((x210 instanceof $c_Lcats_data_Chain$Append)) {
        var x$1$1 = $as_Lcats_data_Chain$Append(x210);
        var this$4 = $n(x$1$1);
        var x216 = this$4.Lcats_data_Chain$Append__f_leftNE;
        var this$5 = $n(x$1$1);
        var x217 = this$5.Lcats_data_Chain$Append__f_rightNE;
        $thiz.Lcats_data_Chain$ChainIterator__f_c = x216;
        var this$6 = $n($thiz.Lcats_data_Chain$ChainIterator__f_rights);
        $thiz.Lcats_data_Chain$ChainIterator__f_rights = new $c_sci_$colon$colon(x217, this$6);
        continue;
      }
      if ((x210 instanceof $c_Lcats_data_Chain$Wrap)) {
        var x$1$2 = $as_Lcats_data_Chain$Wrap(x210);
        var this$8 = $n(x$1$2);
        var x213 = this$8.Lcats_data_Chain$Wrap__f_seq;
        if ($n($thiz.Lcats_data_Chain$ChainIterator__f_rights).isEmpty__Z()) {
          var $x_2 = null;
        } else {
          var head$2 = $as_Lcats_data_Chain$NonEmpty($n($thiz.Lcats_data_Chain$ChainIterator__f_rights).head__O());
          $thiz.Lcats_data_Chain$ChainIterator__f_rights = $as_sci_List($n($thiz.Lcats_data_Chain$ChainIterator__f_rights).tail__O());
          var $x_2 = head$2;
        }
        $thiz.Lcats_data_Chain$ChainIterator__f_c = $x_2;
        $thiz.Lcats_data_Chain$ChainIterator__f_currentIterator = $n(x213).iterator__sc_Iterator();
        return $n($thiz.Lcats_data_Chain$ChainIterator__f_currentIterator).next__O();
      }
      if ((x210 === null)) {
        throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next called on empty iterator");
      }
      throw new $c_s_MatchError(x210);
    }
  }
}
/** @constructor */
function $c_Lcats_data_Chain$ChainIterator(self) {
  this.Lcats_data_Chain$ChainIterator__f_c = null;
  this.Lcats_data_Chain$ChainIterator__f_rights = null;
  this.Lcats_data_Chain$ChainIterator__f_currentIterator = null;
  this.Lcats_data_Chain$ChainIterator__f_c = self;
  this.Lcats_data_Chain$ChainIterator__f_rights = $m_sci_Nil$();
  this.Lcats_data_Chain$ChainIterator__f_currentIterator = null;
}
$c_Lcats_data_Chain$ChainIterator.prototype = new $h_O();
$c_Lcats_data_Chain$ChainIterator.prototype.constructor = $c_Lcats_data_Chain$ChainIterator;
/** @constructor */
function $h_Lcats_data_Chain$ChainIterator() {
}
$h_Lcats_data_Chain$ChainIterator.prototype = $c_Lcats_data_Chain$ChainIterator.prototype;
$c_Lcats_data_Chain$ChainIterator.prototype.knownSize__I = (function() {
  return (-1);
});
$c_Lcats_data_Chain$ChainIterator.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lcats_data_Chain$ChainIterator.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_Lcats_data_Chain$ChainIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lcats_data_Chain$ChainIterator.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$c_Lcats_data_Chain$ChainIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lcats_data_Chain$ChainIterator.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lcats_data_Chain$ChainIterator.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lcats_data_Chain$ChainIterator.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this);
});
$c_Lcats_data_Chain$ChainIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lcats_data_Chain$ChainIterator.prototype.iterator__sc_Iterator = (function() {
  return this;
});
$c_Lcats_data_Chain$ChainIterator.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z());
});
$c_Lcats_data_Chain$ChainIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$c_Lcats_data_Chain$ChainIterator.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$c_Lcats_data_Chain$ChainIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$c_Lcats_data_Chain$ChainIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$c_Lcats_data_Chain$ChainIterator.prototype.toString__T = (function() {
  return "<iterator>";
});
$c_Lcats_data_Chain$ChainIterator.prototype.hasNext__Z = (function() {
  return ((this.Lcats_data_Chain$ChainIterator__f_c !== null) || ((this.Lcats_data_Chain$ChainIterator__f_currentIterator !== null) && $n(this.Lcats_data_Chain$ChainIterator__f_currentIterator).hasNext__Z()));
});
$c_Lcats_data_Chain$ChainIterator.prototype.next__O = (function() {
  return $p_Lcats_data_Chain$ChainIterator__go$3__O(this);
});
var $d_Lcats_data_Chain$ChainIterator = new $TypeData().initClass($c_Lcats_data_Chain$ChainIterator, "cats.data.Chain$ChainIterator", ({
  Lcats_data_Chain$ChainIterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
}));
function $ct_Lcats_data_ChainInstances__($thiz) {
  $thiz.Lcats_data_ChainInstances__f_catsDataInstancesForChain = new $c_Lcats_data_ChainInstances$$anon$3();
  $thiz.Lcats_data_ChainInstances__f_theMonoid = new $c_Lcats_data_ChainInstances$$anon$6();
  return $thiz;
}
function $ps_Lcats_data_ChainInstances__loop$6__F2__Lcats_Eval__Lcats_data_Chain__Lcats_Eval(f$18, lb$1, as) {
  var x237 = $n(as).uncons__s_Option();
  if ((x237 instanceof $c_s_Some)) {
    var x239 = $as_T2($n($as_s_Some(x237)).s_Some__f_value);
    if ((x239 !== null)) {
      var h = $n(x239)._1__O();
      var t = $as_Lcats_data_Chain($n(x239)._2__O());
      var this$1 = $m_Lcats_Eval$();
      var a = new $c_sjsr_AnonFunction0((() => $ps_Lcats_data_ChainInstances__loop$6__F2__Lcats_Eval__Lcats_data_Chain__Lcats_Eval(f$18, lb$1, t)));
      return $as_Lcats_Eval($n(f$18).apply__O__O__O(h, new $c_Lcats_Eval$$anon$5(a, this$1)));
    }
  }
  var x = $m_s_None$();
  if ((x === x237)) {
    return lb$1;
  }
  throw new $c_s_MatchError(x237);
}
function $s_Lcats_data_ChainInstances__cats$data$ChainInstances$$anon$3$$_$go$6__F1__sci_List__Lcats_data_Chain__Lcats_data_Chain(f$23, rest, acc) {
  var acc$tailLocal4 = acc;
  var rest$tailLocal1 = rest;
  while (true) {
    var x261 = rest$tailLocal1;
    if ((x261 instanceof $c_sci_$colon$colon)) {
      var x262 = $as_sci_$colon$colon(x261);
      var x264 = $n(x262).sci_$colon$colon__f_next;
      var hd = $as_Lcats_data_Chain($n(x262).sci_$colon$colon__f_head);
      var x256 = $n(hd).uncons__s_Option();
      if ((x256 instanceof $c_s_Some)) {
        var x258 = $as_T2($n($as_s_Some(x256)).s_Some__f_value);
        if ((x258 !== null)) {
          var hdh = $as_s_util_Either($n(x258)._1__O());
          var hdt = $as_Lcats_data_Chain($n(x258)._2__O());
          if ((hdh instanceof $c_s_util_Right)) {
            var b = $n($as_s_util_Right(hdh)).s_util_Right__f_value;
            var this$1 = $n(x264);
            var rest$tailLocal1$tmp1 = new $c_sci_$colon$colon(hdt, this$1);
            var this$2 = $n(acc$tailLocal4);
            var acc$tailLocal4$tmp1 = this$2.append__O__Lcats_data_Chain(b);
            rest$tailLocal1 = rest$tailLocal1$tmp1;
            acc$tailLocal4 = acc$tailLocal4$tmp1;
            continue;
          }
          if ((hdh instanceof $c_s_util_Left)) {
            var a = $n($as_s_util_Left(hdh)).s_util_Left__f_value;
            var elem$3 = $as_Lcats_data_Chain($n(f$23).apply__O__O(a));
            var this$3 = $n(x264);
            var this$4 = new $c_sci_$colon$colon(hdt, this$3);
            rest$tailLocal1 = new $c_sci_$colon$colon(elem$3, this$4);
            continue;
          }
          throw new $c_s_MatchError(hdh);
        }
      }
      var x = $m_s_None$();
      if ((x === x256)) {
        rest$tailLocal1 = x264;
        continue;
      }
      throw new $c_s_MatchError(x256);
    }
    return acc$tailLocal4;
  }
}
/** @constructor */
function $c_Lcats_data_ChainInstances() {
  this.Lcats_data_ChainInstances__f_catsDataInstancesForChain = null;
  this.Lcats_data_ChainInstances__f_theMonoid = null;
}
$c_Lcats_data_ChainInstances.prototype = new $h_Lcats_data_ChainInstances1();
$c_Lcats_data_ChainInstances.prototype.constructor = $c_Lcats_data_ChainInstances;
/** @constructor */
function $h_Lcats_data_ChainInstances() {
}
$h_Lcats_data_ChainInstances.prototype = $c_Lcats_data_ChainInstances.prototype;
/** @constructor */
function $c_Lcats_data_ChainInstances$$anon$6() {
}
$c_Lcats_data_ChainInstances$$anon$6.prototype = new $h_O();
$c_Lcats_data_ChainInstances$$anon$6.prototype.constructor = $c_Lcats_data_ChainInstances$$anon$6;
/** @constructor */
function $h_Lcats_data_ChainInstances$$anon$6() {
}
$h_Lcats_data_ChainInstances$$anon$6.prototype = $c_Lcats_data_ChainInstances$$anon$6.prototype;
$c_Lcats_data_ChainInstances$$anon$6.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_data_ChainInstances$$anon$6.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAllOption__sc_IterableOnce__s_Option(this, as);
});
$c_Lcats_data_ChainInstances$$anon$6.prototype.empty__O = (function() {
  return $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil;
});
$c_Lcats_data_ChainInstances$$anon$6.prototype.combine__O__O__O = (function(x, y) {
  var c = $as_Lcats_data_Chain(x);
  var c2 = $as_Lcats_data_Chain(y);
  return $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(c, c2);
});
var $d_Lcats_data_ChainInstances$$anon$6 = new $TypeData().initClass($c_Lcats_data_ChainInstances$$anon$6, "cats.data.ChainInstances$$anon$6", ({
  Lcats_data_ChainInstances$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
}));
/** @constructor */
function $c_Lcats_data_Kleisli(run) {
  this.Lcats_data_Kleisli__f_run = null;
  this.Lcats_data_Kleisli__f_run = run;
}
$c_Lcats_data_Kleisli.prototype = new $h_O();
$c_Lcats_data_Kleisli.prototype.constructor = $c_Lcats_data_Kleisli;
/** @constructor */
function $h_Lcats_data_Kleisli() {
}
$h_Lcats_data_Kleisli.prototype = $c_Lcats_data_Kleisli.prototype;
$c_Lcats_data_Kleisli.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_data_Kleisli.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_data_Kleisli.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_data_Kleisli)) {
    var x$0$2 = $as_Lcats_data_Kleisli(x$0);
    var x = this.Lcats_data_Kleisli__f_run;
    var x$2 = $n(x$0$2).Lcats_data_Kleisli__f_run;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_data_Kleisli.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_data_Kleisli.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_data_Kleisli.prototype.productPrefix__T = (function() {
  return "Kleisli";
});
$c_Lcats_data_Kleisli.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_Kleisli__f_run;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_data_Kleisli.prototype.ap__Lcats_data_Kleisli__Lcats_Apply__Lcats_evidence_As__Lcats_data_Kleisli = (function(f, F, ev) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((a) => {
    var fb = $n(F).map__O__F1__O($n(this.Lcats_data_Kleisli__f_run).apply__O__O(a), new $c_sjsr_AnonFunction1(((a$2) => {
      var this$2 = $n(ev);
      return $as_F1($n($m_Lcats_evidence_As$().witness__Lcats_evidence_As__F1(this$2)).apply__O__O(a$2));
    })));
    var fc = $n($n(f).Lcats_data_Kleisli__f_run).apply__O__O(a);
    return $n(F).ap__O__O__O(fb, fc);
  }));
  return new $c_Lcats_data_Kleisli(run);
});
$c_Lcats_data_Kleisli.prototype.map__F1__Lcats_Functor__Lcats_data_Kleisli = (function(f, F) {
  return this.mapF__F1__Lcats_data_Kleisli(new $c_sjsr_AnonFunction1(((_$3) => $n(F).map__O__F1__O(_$3, f))));
});
$c_Lcats_data_Kleisli.prototype.mapF__F1__Lcats_data_Kleisli = (function(f) {
  $m_Lcats_data_Kleisli$();
  var run = $n(this.Lcats_data_Kleisli__f_run).andThen__F1__F1(f);
  return new $c_Lcats_data_Kleisli(run);
});
$c_Lcats_data_Kleisli.prototype.flatMap__F1__Lcats_FlatMap__Lcats_data_Kleisli = (function(f, F) {
  var x5 = this.Lcats_data_Kleisli__f_run;
  if ((x5 instanceof $c_Lcats_data_StrictConstFunction1)) {
    var x$1 = $as_Lcats_data_StrictConstFunction1(x5);
    var this$2 = $n(x$1);
    var x8 = this$2.Lcats_data_StrictConstFunction1__f_a;
    $m_Lcats_data_Kleisli$();
    var run = new $c_sjsr_AnonFunction1(((a) => $n(F).flatMap__O__F1__O(x8, new $c_sjsr_AnonFunction1(((_$7) => $n($n($as_Lcats_data_Kleisli($n(f).apply__O__O(_$7))).Lcats_data_Kleisli__f_run).apply__O__O(a))))));
    return new $c_Lcats_data_Kleisli(run);
  }
  return $m_Lcats_data_Kleisli$().shift__F1__Lcats_FlatMap__Lcats_data_Kleisli(new $c_sjsr_AnonFunction1(((a$2) => $n(F).flatMap__O__F1__O($n(this.Lcats_data_Kleisli__f_run).apply__O__O(a$2), new $c_sjsr_AnonFunction1(((_$8) => $n($n($as_Lcats_data_Kleisli($n(f).apply__O__O(_$8))).Lcats_data_Kleisli__f_run).apply__O__O(a$2)))))), F);
});
function $as_Lcats_data_Kleisli(obj) {
  return (((obj instanceof $c_Lcats_data_Kleisli) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Kleisli"));
}
function $isArrayOf_Lcats_data_Kleisli(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Kleisli)));
}
function $asArrayOf_Lcats_data_Kleisli(obj, depth) {
  return (($isArrayOf_Lcats_data_Kleisli(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Kleisli;", depth));
}
var $d_Lcats_data_Kleisli = new $TypeData().initClass($c_Lcats_data_Kleisli, "cats.data.Kleisli", ({
  Lcats_data_Kleisli: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $f_Lcats_data_KleisliFunctor__void__Lcats_data_Kleisli__Lcats_data_Kleisli($thiz, fa) {
  $m_Lcats_data_Kleisli$();
  var $x_1 = $n($n(fa).Lcats_data_Kleisli__f_run);
  var \u03b41$ = $thiz.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  var run = $n($x_1).andThen__F1__F1(new $c_sjsr_AnonFunction1(((fa$2) => $n(\u03b41$).void__O__O(fa$2))));
  return new $c_Lcats_data_Kleisli(run);
}
/** @constructor */
function $c_Lcats_data_KleisliInstances6() {
}
$c_Lcats_data_KleisliInstances6.prototype = new $h_Lcats_data_KleisliInstances7();
$c_Lcats_data_KleisliInstances6.prototype.constructor = $c_Lcats_data_KleisliInstances6;
/** @constructor */
function $h_Lcats_data_KleisliInstances6() {
}
$h_Lcats_data_KleisliInstances6.prototype = $c_Lcats_data_KleisliInstances6.prototype;
function $ct_Lcats_data_NonEmptyChainInstances__($thiz) {
  $thiz.Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1 = new $c_Lcats_data_NonEmptyChainInstances$$anon$1();
  return $thiz;
}
/** @constructor */
function $c_Lcats_data_NonEmptyChainInstances() {
  this.Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1 = null;
}
$c_Lcats_data_NonEmptyChainInstances.prototype = new $h_Lcats_data_NonEmptyChainInstances1();
$c_Lcats_data_NonEmptyChainInstances.prototype.constructor = $c_Lcats_data_NonEmptyChainInstances;
/** @constructor */
function $h_Lcats_data_NonEmptyChainInstances() {
}
$h_Lcats_data_NonEmptyChainInstances.prototype = $c_Lcats_data_NonEmptyChainInstances.prototype;
/** @constructor */
function $c_Lcats_data_OptionT(value) {
  this.Lcats_data_OptionT__f_value = null;
  this.Lcats_data_OptionT__f_value = value;
}
$c_Lcats_data_OptionT.prototype = new $h_O();
$c_Lcats_data_OptionT.prototype.constructor = $c_Lcats_data_OptionT;
/** @constructor */
function $h_Lcats_data_OptionT() {
}
$h_Lcats_data_OptionT.prototype = $c_Lcats_data_OptionT.prototype;
$c_Lcats_data_OptionT.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_data_OptionT.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_data_OptionT.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_data_OptionT)) {
    var x$0$2 = $as_Lcats_data_OptionT(x$0);
    var x = this.Lcats_data_OptionT__f_value;
    var y = $n(x$0$2).Lcats_data_OptionT__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_data_OptionT.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_data_OptionT.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_data_OptionT.prototype.productPrefix__T = (function() {
  return "OptionT";
});
$c_Lcats_data_OptionT.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_OptionT__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_data_OptionT.prototype.collect__s_PartialFunction__Lcats_Functor__Lcats_data_OptionT = (function(f, F) {
  var value = $n(F).map__O__F1__O(this.Lcats_data_OptionT__f_value, new $c_sjsr_AnonFunction1(((_$15) => {
    var _$15$1 = $as_s_Option(_$15);
    var this$1 = $n(_$15$1);
    return ((!this$1.isEmpty__Z()) ? $as_s_Option($n($n(f).lift__F1()).apply__O__O(this$1.get__O())) : $m_s_None$());
  })));
  return new $c_Lcats_data_OptionT(value);
});
$c_Lcats_data_OptionT.prototype.orElseF__F0__Lcats_Monad__Lcats_data_OptionT = (function(default$1, F) {
  var value = $n(F).flatMap__O__F1__O(this.Lcats_data_OptionT__f_value, new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_s_Option(x$1);
    if ((x$1$1 instanceof $c_s_Some)) {
      var s = $as_s_Some(x$1$1);
      return $n(F).pure__O__O(s);
    }
    var x = $m_s_None$();
    if ((x === x$1$1)) {
      return $n(default$1).apply__O();
    }
    throw new $c_s_MatchError(x$1$1);
  })));
  return new $c_Lcats_data_OptionT(value);
});
function $as_Lcats_data_OptionT(obj) {
  return (((obj instanceof $c_Lcats_data_OptionT) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.OptionT"));
}
function $isArrayOf_Lcats_data_OptionT(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_OptionT)));
}
function $asArrayOf_Lcats_data_OptionT(obj, depth) {
  return (($isArrayOf_Lcats_data_OptionT(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.OptionT;", depth));
}
var $d_Lcats_data_OptionT = new $TypeData().initClass($c_Lcats_data_OptionT, "cats.data.OptionT", ({
  Lcats_data_OptionT: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_data_Validated() {
}
$c_Lcats_data_Validated.prototype = new $h_O();
$c_Lcats_data_Validated.prototype.constructor = $c_Lcats_data_Validated;
/** @constructor */
function $h_Lcats_data_Validated() {
}
$h_Lcats_data_Validated.prototype = $c_Lcats_data_Validated.prototype;
$c_Lcats_data_Validated.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_data_Validated.prototype.toEither__s_util_Either = (function() {
  if ((this instanceof $c_Lcats_data_Validated$Invalid)) {
    var x$1 = $as_Lcats_data_Validated$Invalid(this);
    var this$2 = $n(x$1);
    var x63 = this$2.Lcats_data_Validated$Invalid__f_e;
    return new $c_s_util_Left(x63);
  }
  if ((this instanceof $c_Lcats_data_Validated$Valid)) {
    var x$1$1 = $as_Lcats_data_Validated$Valid(this);
    var this$5 = $n(x$1$1);
    var x60 = this$5.Lcats_data_Validated$Valid__f_a;
    return new $c_s_util_Right(x60);
  }
  throw new $c_s_MatchError(this);
});
$c_Lcats_data_Validated.prototype.ap__Lcats_data_Validated__Lcats_kernel_Semigroup__Lcats_data_Validated = (function(f, EE) {
  var x171 = new $c_T2(this, f);
  var x190 = $as_Lcats_data_Validated(x171.T2__f__1);
  var x191 = $as_Lcats_data_Validated(x171.T2__f__2);
  if ((x190 instanceof $c_Lcats_data_Validated$Valid)) {
    var x$1 = $as_Lcats_data_Validated$Valid(x190);
    var this$3 = $n(x$1);
    var x197 = this$3.Lcats_data_Validated$Valid__f_a;
    if ((x191 instanceof $c_Lcats_data_Validated$Valid)) {
      var x$1$1 = $as_Lcats_data_Validated$Valid(x191);
      var this$5 = $n(x$1$1);
      var x194 = $as_F1(this$5.Lcats_data_Validated$Valid__f_a);
      var a = $n(x194).apply__O__O(x197);
      return new $c_Lcats_data_Validated$Valid(a);
    }
  }
  if ((x190 instanceof $c_Lcats_data_Validated$Invalid)) {
    var x187 = $as_Lcats_data_Validated$Invalid(x190);
    var this$8 = $n(x187);
    var x189 = this$8.Lcats_data_Validated$Invalid__f_e;
    if ((x191 instanceof $c_Lcats_data_Validated$Invalid)) {
      var x$1$2 = $as_Lcats_data_Validated$Invalid(x191);
      var this$10 = $n(x$1$2);
      var x186 = this$10.Lcats_data_Validated$Invalid__f_e;
      var e = $n(EE).combine__O__O__O(x186, x189);
      return new $c_Lcats_data_Validated$Invalid(e);
    }
    return x187;
  }
  if ((x191 instanceof $c_Lcats_data_Validated$Invalid)) {
    var x$1$3 = $as_Lcats_data_Validated$Invalid(x191);
    var this$13 = $n(x$1$3);
    var e$2 = $as_Lcats_data_Validated$Invalid(x191);
    return e$2;
  }
  throw new $c_s_MatchError(x171);
});
$c_Lcats_data_Validated.prototype.product__Lcats_data_Validated__Lcats_kernel_Semigroup__Lcats_data_Validated = (function(fb, EE) {
  var x198 = new $c_T2(this, fb);
  var x217 = $as_Lcats_data_Validated(x198.T2__f__1);
  var x218 = $as_Lcats_data_Validated(x198.T2__f__2);
  if ((x217 instanceof $c_Lcats_data_Validated$Valid)) {
    var x$1 = $as_Lcats_data_Validated$Valid(x217);
    var this$3 = $n(x$1);
    var x224 = this$3.Lcats_data_Validated$Valid__f_a;
    if ((x218 instanceof $c_Lcats_data_Validated$Valid)) {
      var x$1$1 = $as_Lcats_data_Validated$Valid(x218);
      var this$5 = $n(x$1$1);
      var x221 = this$5.Lcats_data_Validated$Valid__f_a;
      var a = new $c_T2(x224, x221);
      return new $c_Lcats_data_Validated$Valid(a);
    }
  }
  if ((x217 instanceof $c_Lcats_data_Validated$Invalid)) {
    var x214 = $as_Lcats_data_Validated$Invalid(x217);
    var this$9 = $n(x214);
    var x216 = this$9.Lcats_data_Validated$Invalid__f_e;
    if ((x218 instanceof $c_Lcats_data_Validated$Invalid)) {
      var x$1$2 = $as_Lcats_data_Validated$Invalid(x218);
      var this$11 = $n(x$1$2);
      var x213 = this$11.Lcats_data_Validated$Invalid__f_e;
      var e = $n(EE).combine__O__O__O(x216, x213);
      return new $c_Lcats_data_Validated$Invalid(e);
    }
    return x214;
  }
  if ((x218 instanceof $c_Lcats_data_Validated$Invalid)) {
    var x$1$3 = $as_Lcats_data_Validated$Invalid(x218);
    var this$14 = $n(x$1$3);
    var e$2 = $as_Lcats_data_Validated$Invalid(x218);
    return e$2;
  }
  throw new $c_s_MatchError(x198);
});
$c_Lcats_data_Validated.prototype.map__F1__Lcats_data_Validated = (function(f) {
  if ((this instanceof $c_Lcats_data_Validated$Invalid)) {
    var x$1 = $as_Lcats_data_Validated$Invalid(this);
    var this$2 = $n(x$1);
    var i = $as_Lcats_data_Validated$Invalid(this);
    return i;
  }
  if ((this instanceof $c_Lcats_data_Validated$Valid)) {
    var x$1$1 = $as_Lcats_data_Validated$Valid(this);
    var this$4 = $n(x$1$1);
    var x228 = this$4.Lcats_data_Validated$Valid__f_a;
    var a = $n(f).apply__O__O(x228);
    return new $c_Lcats_data_Validated$Valid(a);
  }
  throw new $c_s_MatchError(this);
});
$c_Lcats_data_Validated.prototype.combine__Lcats_data_Validated__Lcats_kernel_Semigroup__Lcats_kernel_Semigroup__Lcats_data_Validated = (function(that, EE, AA) {
  if ((this instanceof $c_Lcats_data_Validated$Valid)) {
    var x$1 = $as_Lcats_data_Validated$Valid(this);
    var this$3 = $n(x$1);
    var x299 = this$3.Lcats_data_Validated$Valid__f_a;
    if ((that instanceof $c_Lcats_data_Validated$Valid)) {
      var x$1$1 = $as_Lcats_data_Validated$Valid(that);
      var this$5 = $n(x$1$1);
      var x296 = this$5.Lcats_data_Validated$Valid__f_a;
      var a = $n(AA).combine__O__O__O(x299, x296);
      return new $c_Lcats_data_Validated$Valid(a);
    }
  }
  if ((this instanceof $c_Lcats_data_Validated$Invalid)) {
    var x$1$2 = $as_Lcats_data_Validated$Invalid(this);
    var this$8 = $n(x$1$2);
    var x291 = this$8.Lcats_data_Validated$Invalid__f_e;
    if ((that instanceof $c_Lcats_data_Validated$Invalid)) {
      var x$1$3 = $as_Lcats_data_Validated$Invalid(that);
      var this$10 = $n(x$1$3);
      var x288 = this$10.Lcats_data_Validated$Invalid__f_e;
      var e = $n(EE).combine__O__O__O(x291, x288);
      return new $c_Lcats_data_Validated$Invalid(e);
    }
    return this;
  }
  return that;
});
function $as_Lcats_data_Validated(obj) {
  return (((obj instanceof $c_Lcats_data_Validated) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Validated"));
}
function $isArrayOf_Lcats_data_Validated(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Validated)));
}
function $asArrayOf_Lcats_data_Validated(obj, depth) {
  return (($isArrayOf_Lcats_data_Validated(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Validated;", depth));
}
/** @constructor */
function $c_Lcats_data_ValidatedInstances$$anon$4(B$2, A$4) {
  this.Lcats_data_ValidatedInstances$$anon$4__f_B$1 = null;
  this.Lcats_data_ValidatedInstances$$anon$4__f_A$2 = null;
  this.Lcats_data_ValidatedInstances$$anon$4__f_B$1 = B$2;
  this.Lcats_data_ValidatedInstances$$anon$4__f_A$2 = A$4;
}
$c_Lcats_data_ValidatedInstances$$anon$4.prototype = new $h_O();
$c_Lcats_data_ValidatedInstances$$anon$4.prototype.constructor = $c_Lcats_data_ValidatedInstances$$anon$4;
/** @constructor */
function $h_Lcats_data_ValidatedInstances$$anon$4() {
}
$h_Lcats_data_ValidatedInstances$$anon$4.prototype = $c_Lcats_data_ValidatedInstances$$anon$4.prototype;
$c_Lcats_data_ValidatedInstances$$anon$4.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_data_ValidatedInstances$$anon$4.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAllOption__sc_IterableOnce__s_Option(this, as);
});
$c_Lcats_data_ValidatedInstances$$anon$4.prototype.empty__Lcats_data_Validated = (function() {
  var a = $n(this.Lcats_data_ValidatedInstances$$anon$4__f_B$1).empty__O();
  return new $c_Lcats_data_Validated$Valid(a);
});
$c_Lcats_data_ValidatedInstances$$anon$4.prototype.combine__Lcats_data_Validated__Lcats_data_Validated__Lcats_data_Validated = (function(x, y) {
  return $n(x).combine__Lcats_data_Validated__Lcats_kernel_Semigroup__Lcats_kernel_Semigroup__Lcats_data_Validated(y, this.Lcats_data_ValidatedInstances$$anon$4__f_A$2, this.Lcats_data_ValidatedInstances$$anon$4__f_B$1);
});
$c_Lcats_data_ValidatedInstances$$anon$4.prototype.empty__O = (function() {
  return this.empty__Lcats_data_Validated();
});
$c_Lcats_data_ValidatedInstances$$anon$4.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__Lcats_data_Validated__Lcats_data_Validated__Lcats_data_Validated($as_Lcats_data_Validated(x), $as_Lcats_data_Validated(y));
});
var $d_Lcats_data_ValidatedInstances$$anon$4 = new $TypeData().initClass($c_Lcats_data_ValidatedInstances$$anon$4, "cats.data.ValidatedInstances$$anon$4", ({
  Lcats_data_ValidatedInstances$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
}));
function $as_Lcats_effect_ExitCode(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.ExitCode"));
}
function $isArrayOf_Lcats_effect_ExitCode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_ExitCode)));
}
function $asArrayOf_Lcats_effect_ExitCode(obj, depth) {
  return (($isArrayOf_Lcats_effect_ExitCode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.ExitCode;", depth));
}
/** @constructor */
function $c_Lcats_effect_IOFiber$$anon$1(id$2, outer) {
  this.Lcats_effect_IOFiber$$anon$1__f_id$1 = 0;
  this.Lcats_effect_IOFiber$$anon$1__f_$outer = null;
  this.Lcats_effect_IOFiber$$anon$1__f_id$1 = id$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_IOFiber$$anon$1__f_$outer = outer;
}
$c_Lcats_effect_IOFiber$$anon$1.prototype = new $h_O();
$c_Lcats_effect_IOFiber$$anon$1.prototype.constructor = $c_Lcats_effect_IOFiber$$anon$1;
/** @constructor */
function $h_Lcats_effect_IOFiber$$anon$1() {
}
$h_Lcats_effect_IOFiber$$anon$1.prototype = $c_Lcats_effect_IOFiber$$anon$1.prototype;
$c_Lcats_effect_IOFiber$$anon$1.prototype.apply__Lcats_effect_IO__Lcats_effect_IO = (function(ioa) {
  var id = this.Lcats_effect_IOFiber$$anon$1__f_id$1;
  var self = this.Lcats_effect_IOFiber$$anon$1__f_$outer;
  return new $c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(ioa, id, self);
});
$c_Lcats_effect_IOFiber$$anon$1.prototype.apply__O__O = (function(fa) {
  return this.apply__Lcats_effect_IO__Lcats_effect_IO($as_Lcats_effect_IO(fa));
});
var $d_Lcats_effect_IOFiber$$anon$1 = new $TypeData().initClass($c_Lcats_effect_IOFiber$$anon$1, "cats.effect.IOFiber$$anon$1", ({
  Lcats_effect_IOFiber$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1,
  Lcats_effect_kernel_Poll: 1
}));
function $f_Lcats_effect_kernel_Clock$KleisliClock__realTime__Lcats_data_Kleisli($thiz) {
  var this$1 = $m_Lcats_data_Kleisli$();
  var x = $n($thiz.C__Lcats_effect_kernel_Clock()).realTime__O();
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$1, x);
}
/** @constructor */
function $c_Lcats_effect_kernel_Deferred() {
}
$c_Lcats_effect_kernel_Deferred.prototype = new $h_O();
$c_Lcats_effect_kernel_Deferred.prototype.constructor = $c_Lcats_effect_kernel_Deferred;
/** @constructor */
function $h_Lcats_effect_kernel_Deferred() {
}
$h_Lcats_effect_kernel_Deferred.prototype = $c_Lcats_effect_kernel_Deferred.prototype;
function $as_Lcats_effect_kernel_Deferred(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Deferred) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Deferred"));
}
function $isArrayOf_Lcats_effect_kernel_Deferred(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Deferred)));
}
function $asArrayOf_Lcats_effect_kernel_Deferred(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Deferred(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Deferred;", depth));
}
/** @constructor */
function $c_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13(nat$9) {
  this.Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13__f_nat$4 = null;
  this.Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13__f_nat$4 = nat$9;
}
$c_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13.prototype = new $h_O();
$c_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13.prototype.constructor = $c_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13;
/** @constructor */
function $h_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13() {
}
$h_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13.prototype = $c_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13.prototype;
$c_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13.prototype.apply__Lcats_data_Kleisli__Lcats_data_Kleisli = (function(stfa) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((r) => $n(this.Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13__f_nat$4).apply__O__O($n($n(stfa).Lcats_data_Kleisli__f_run).apply__O__O(r))));
  return new $c_Lcats_data_Kleisli(run);
});
$c_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13.prototype.apply__O__O = (function(fa) {
  return this.apply__Lcats_data_Kleisli__Lcats_data_Kleisli($as_Lcats_data_Kleisli(fa));
});
var $d_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13 = new $TypeData().initClass($c_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13, "cats.effect.kernel.MonadCancel$KleisliMonadCancel$$anon$13", ({
  Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1,
  Lcats_effect_kernel_Poll: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9() {
}
$c_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9.prototype = new $h_O();
$c_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9.prototype.constructor = $c_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9;
/** @constructor */
function $h_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9() {
}
$h_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9.prototype = $c_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9.prototype;
$c_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9.prototype.apply__O__O = (function(fa) {
  return fa;
});
var $d_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9 = new $TypeData().initClass($c_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9, "cats.effect.kernel.MonadCancel$Uncancelable$$anon$9", ({
  Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1,
  Lcats_effect_kernel_Poll: 1
}));
function $f_Lcats_effect_kernel_Outcome__embed__O__Lcats_effect_kernel_MonadCancel__O($thiz, onCancel, F) {
  if ((($thiz instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled($thiz), true))) {
    return onCancel;
  }
  if (($thiz instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
    var x$1 = $as_Lcats_effect_kernel_Outcome$Errored($thiz);
    var this$2 = $n(x$1);
    var x7 = this$2.Lcats_effect_kernel_Outcome$Errored__f_e;
    return $n(F).raiseError__O__O(x7);
  }
  if (($thiz instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
    var x$1$1 = $as_Lcats_effect_kernel_Outcome$Succeeded($thiz);
    var this$4 = $n(x$1$1);
    var x4 = this$4.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
    return x4;
  }
  throw new $c_s_MatchError($thiz);
}
function $f_Lcats_effect_kernel_Outcome__mapK__Lcats_arrow_FunctionK__Lcats_effect_kernel_Outcome($thiz, f) {
  if ((($thiz instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled($thiz), true))) {
    return new $c_Lcats_effect_kernel_Outcome$Canceled();
  }
  if (($thiz instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
    var x$1 = $as_Lcats_effect_kernel_Outcome$Errored($thiz);
    var this$3 = $n(x$1);
    var x15 = this$3.Lcats_effect_kernel_Outcome$Errored__f_e;
    return new $c_Lcats_effect_kernel_Outcome$Errored(x15);
  }
  if (($thiz instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
    var x$1$1 = $as_Lcats_effect_kernel_Outcome$Succeeded($thiz);
    var this$6 = $n(x$1$1);
    var x12 = this$6.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
    var fa = $n(f).apply__O__O(x12);
    return new $c_Lcats_effect_kernel_Outcome$Succeeded(fa);
  }
  throw new $c_s_MatchError($thiz);
}
function $is_Lcats_effect_kernel_Outcome(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_kernel_Outcome)));
}
function $as_Lcats_effect_kernel_Outcome(obj) {
  return (($is_Lcats_effect_kernel_Outcome(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Outcome"));
}
function $isArrayOf_Lcats_effect_kernel_Outcome(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Outcome)));
}
function $asArrayOf_Lcats_effect_kernel_Outcome(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Outcome(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Outcome;", depth));
}
/** @constructor */
function $c_Lcats_effect_kernel_Ref() {
}
$c_Lcats_effect_kernel_Ref.prototype = new $h_O();
$c_Lcats_effect_kernel_Ref.prototype.constructor = $c_Lcats_effect_kernel_Ref;
/** @constructor */
function $h_Lcats_effect_kernel_Ref() {
}
$h_Lcats_effect_kernel_Ref.prototype = $c_Lcats_effect_kernel_Ref.prototype;
$c_Lcats_effect_kernel_Ref.prototype.flatModify__F1__Lcats_effect_kernel_MonadCancel__O = (function(f, F) {
  return $n(F).uncancelable__F1__O(new $c_sjsr_AnonFunction1(((_$3) => {
    $as_Lcats_effect_kernel_Poll(_$3);
    var this$2 = $n(F);
    var ffa = this.modify__F1__O(f);
    return $f_Lcats_FlatMap__flatten__O__O(this$2, ffa);
  })));
});
function $as_Lcats_effect_kernel_Ref(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Ref) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Ref"));
}
function $isArrayOf_Lcats_effect_kernel_Ref(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Ref)));
}
function $asArrayOf_Lcats_effect_kernel_Ref(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Ref(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Ref;", depth));
}
/** @constructor */
function $c_Lcats_effect_kernel_Resource$$anon$6(F$97, poll$6) {
  this.Lcats_effect_kernel_Resource$$anon$6__f_F$81 = null;
  this.Lcats_effect_kernel_Resource$$anon$6__f_poll$5 = null;
  this.Lcats_effect_kernel_Resource$$anon$6__f_F$81 = F$97;
  this.Lcats_effect_kernel_Resource$$anon$6__f_poll$5 = poll$6;
}
$c_Lcats_effect_kernel_Resource$$anon$6.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$$anon$6.prototype.constructor = $c_Lcats_effect_kernel_Resource$$anon$6;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$$anon$6() {
}
$h_Lcats_effect_kernel_Resource$$anon$6.prototype = $c_Lcats_effect_kernel_Resource$$anon$6.prototype;
$c_Lcats_effect_kernel_Resource$$anon$6.prototype.apply__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource = (function(rfb) {
  var resource = new $c_sjsr_AnonFunction1(((innerPoll) => {
    var innerPoll$1 = $as_Lcats_effect_kernel_Poll(innerPoll);
    return $n(innerPoll$1).apply__O__O($n(this.Lcats_effect_kernel_Resource$$anon$6__f_poll$5).apply__O__O($n(rfb).allocatedCase__Lcats_effect_kernel_MonadCancel__O(this.Lcats_effect_kernel_Resource$$anon$6__f_F$81)));
  }));
  return new $c_Lcats_effect_kernel_Resource$Allocate(resource);
});
$c_Lcats_effect_kernel_Resource$$anon$6.prototype.apply__O__O = (function(fa) {
  return this.apply__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource($as_Lcats_effect_kernel_Resource(fa));
});
var $d_Lcats_effect_kernel_Resource$$anon$6 = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$$anon$6, "cats.effect.kernel.Resource$$anon$6", ({
  Lcats_effect_kernel_Resource$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1,
  Lcats_effect_kernel_Poll: 1
}));
function $is_Lcats_effect_kernel_Resource$ExitCase(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_kernel_Resource$ExitCase)));
}
function $as_Lcats_effect_kernel_Resource$ExitCase(obj) {
  return (($is_Lcats_effect_kernel_Resource$ExitCase(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$ExitCase"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$ExitCase(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$ExitCase)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$ExitCase(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$ExitCase(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$ExitCase;", depth));
}
/** @constructor */
function $c_Lcats_effect_kernel_Resource$State$1(outer, fin, finalizeOnComplete, confirmedFinalizeOnComplete) {
  this.Lcats_effect_kernel_Resource$State$1__f_fin = null;
  this.Lcats_effect_kernel_Resource$State$1__f_finalizeOnComplete = false;
  this.Lcats_effect_kernel_Resource$State$1__f_confirmedFinalizeOnComplete = false;
  this.Lcats_effect_kernel_Resource$State$1__f_$outer = null;
  this.Lcats_effect_kernel_Resource$State$1__f_fin = fin;
  this.Lcats_effect_kernel_Resource$State$1__f_finalizeOnComplete = finalizeOnComplete;
  this.Lcats_effect_kernel_Resource$State$1__f_confirmedFinalizeOnComplete = confirmedFinalizeOnComplete;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_kernel_Resource$State$1__f_$outer = outer;
}
$c_Lcats_effect_kernel_Resource$State$1.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$State$1.prototype.constructor = $c_Lcats_effect_kernel_Resource$State$1;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$State$1() {
}
$h_Lcats_effect_kernel_Resource$State$1.prototype = $c_Lcats_effect_kernel_Resource$State$1.prototype;
$c_Lcats_effect_kernel_Resource$State$1.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$State$1.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcats_effect_kernel_Resource$State$1__f_fin;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lcats_effect_kernel_Resource$State$1__f_finalizeOnComplete ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = (this.Lcats_effect_kernel_Resource$State$1__f_confirmedFinalizeOnComplete ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Lcats_effect_kernel_Resource$State$1.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$State$1)) {
    var x$0$2 = $as_Lcats_effect_kernel_Resource$State$1(x$0);
    if (((this.Lcats_effect_kernel_Resource$State$1__f_finalizeOnComplete === $n(x$0$2).Lcats_effect_kernel_Resource$State$1__f_finalizeOnComplete) && (this.Lcats_effect_kernel_Resource$State$1__f_confirmedFinalizeOnComplete === $n(x$0$2).Lcats_effect_kernel_Resource$State$1__f_confirmedFinalizeOnComplete))) {
      var x = this.Lcats_effect_kernel_Resource$State$1__f_fin;
      var y = $n(x$0$2).Lcats_effect_kernel_Resource$State$1__f_fin;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Resource$State$1.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Resource$State$1.prototype.productArity__I = (function() {
  return 3;
});
$c_Lcats_effect_kernel_Resource$State$1.prototype.productPrefix__T = (function() {
  return "State";
});
$c_Lcats_effect_kernel_Resource$State$1.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_kernel_Resource$State$1__f_fin;
      break;
    }
    case 1: {
      return this.Lcats_effect_kernel_Resource$State$1__f_finalizeOnComplete;
      break;
    }
    case 2: {
      return this.Lcats_effect_kernel_Resource$State$1__f_confirmedFinalizeOnComplete;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lcats_effect_kernel_Resource$State$1.prototype.copy__O__Z__Z__Lcats_effect_kernel_Resource$State$1 = (function(fin, finalizeOnComplete, confirmedFinalizeOnComplete) {
  return new $c_Lcats_effect_kernel_Resource$State$1(this.Lcats_effect_kernel_Resource$State$1__f_$outer, fin, finalizeOnComplete, confirmedFinalizeOnComplete);
});
function $as_Lcats_effect_kernel_Resource$State$1(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$State$1) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$State$1"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$State$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$State$1)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$State$1(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$State$1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$State$1;", depth));
}
var $d_Lcats_effect_kernel_Resource$State$1 = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$State$1, "cats.effect.kernel.Resource$State$1", ({
  Lcats_effect_kernel_Resource$State$1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1(M$2, outer) {
  this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1__f_M$1 = null;
  this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1__f_$outer = null;
  this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1__f_M$1 = M$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1__f_$outer = outer;
}
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype = new $h_O();
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype.constructor = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1;
/** @constructor */
function $h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1() {
}
$h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype;
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype.applicative__Lcats_Applicative = (function() {
  $n(this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1__f_$outer);
  var F = this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1__f_M$1;
  return new $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4(F);
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype.sequential__Lcats_arrow_FunctionK = (function() {
  return new $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2();
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype.parallel__Lcats_arrow_FunctionK = (function() {
  return new $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3();
});
var $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1 = new $TypeData().initClass($c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1, "cats.effect.kernel.instances.GenSpawnInstances$$anon$1", ({
  Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_NonEmptyParallel: 1,
  Lcats_Parallel: 1
}));
/** @constructor */
function $c_Lcats_effect_metrics_CpuStarvationWarningMetrics(occurrenceTime, clockDrift, starvationThreshold, starvationInterval) {
  this.Lcats_effect_metrics_CpuStarvationWarningMetrics__f_occurrenceTime = null;
  this.Lcats_effect_metrics_CpuStarvationWarningMetrics__f_clockDrift = null;
  this.Lcats_effect_metrics_CpuStarvationWarningMetrics__f_starvationThreshold = 0.0;
  this.Lcats_effect_metrics_CpuStarvationWarningMetrics__f_starvationInterval = null;
  this.Lcats_effect_metrics_CpuStarvationWarningMetrics__f_occurrenceTime = occurrenceTime;
  this.Lcats_effect_metrics_CpuStarvationWarningMetrics__f_clockDrift = clockDrift;
  this.Lcats_effect_metrics_CpuStarvationWarningMetrics__f_starvationThreshold = starvationThreshold;
  this.Lcats_effect_metrics_CpuStarvationWarningMetrics__f_starvationInterval = starvationInterval;
}
$c_Lcats_effect_metrics_CpuStarvationWarningMetrics.prototype = new $h_O();
$c_Lcats_effect_metrics_CpuStarvationWarningMetrics.prototype.constructor = $c_Lcats_effect_metrics_CpuStarvationWarningMetrics;
/** @constructor */
function $h_Lcats_effect_metrics_CpuStarvationWarningMetrics() {
}
$h_Lcats_effect_metrics_CpuStarvationWarningMetrics.prototype = $c_Lcats_effect_metrics_CpuStarvationWarningMetrics.prototype;
$c_Lcats_effect_metrics_CpuStarvationWarningMetrics.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_metrics_CpuStarvationWarningMetrics.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("CpuStarvationWarningMetrics");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcats_effect_metrics_CpuStarvationWarningMetrics__f_occurrenceTime;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lcats_effect_metrics_CpuStarvationWarningMetrics__f_clockDrift;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var dv = this.Lcats_effect_metrics_CpuStarvationWarningMetrics__f_starvationThreshold;
  var data$3 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Lcats_effect_metrics_CpuStarvationWarningMetrics__f_starvationInterval;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4);
});
$c_Lcats_effect_metrics_CpuStarvationWarningMetrics.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_metrics_CpuStarvationWarningMetrics)) {
    var x$0$2 = $as_Lcats_effect_metrics_CpuStarvationWarningMetrics(x$0);
    if ((this.Lcats_effect_metrics_CpuStarvationWarningMetrics__f_starvationThreshold === $n(x$0$2).Lcats_effect_metrics_CpuStarvationWarningMetrics__f_starvationThreshold)) {
      var x = this.Lcats_effect_metrics_CpuStarvationWarningMetrics__f_occurrenceTime;
      var x$2 = $n(x$0$2).Lcats_effect_metrics_CpuStarvationWarningMetrics__f_occurrenceTime;
      var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Lcats_effect_metrics_CpuStarvationWarningMetrics__f_clockDrift;
      var x$4 = $n(x$0$2).Lcats_effect_metrics_CpuStarvationWarningMetrics__f_clockDrift;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lcats_effect_metrics_CpuStarvationWarningMetrics__f_starvationInterval;
      var x$6 = $n(x$0$2).Lcats_effect_metrics_CpuStarvationWarningMetrics__f_starvationInterval;
      return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_metrics_CpuStarvationWarningMetrics.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_metrics_CpuStarvationWarningMetrics.prototype.productArity__I = (function() {
  return 4;
});
$c_Lcats_effect_metrics_CpuStarvationWarningMetrics.prototype.productPrefix__T = (function() {
  return "CpuStarvationWarningMetrics";
});
$c_Lcats_effect_metrics_CpuStarvationWarningMetrics.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_metrics_CpuStarvationWarningMetrics__f_occurrenceTime;
      break;
    }
    case 1: {
      return this.Lcats_effect_metrics_CpuStarvationWarningMetrics__f_clockDrift;
      break;
    }
    case 2: {
      return this.Lcats_effect_metrics_CpuStarvationWarningMetrics__f_starvationThreshold;
      break;
    }
    case 3: {
      return this.Lcats_effect_metrics_CpuStarvationWarningMetrics__f_starvationInterval;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Lcats_effect_metrics_CpuStarvationWarningMetrics(obj) {
  return (((obj instanceof $c_Lcats_effect_metrics_CpuStarvationWarningMetrics) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.metrics.CpuStarvationWarningMetrics"));
}
function $isArrayOf_Lcats_effect_metrics_CpuStarvationWarningMetrics(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_metrics_CpuStarvationWarningMetrics)));
}
function $asArrayOf_Lcats_effect_metrics_CpuStarvationWarningMetrics(obj, depth) {
  return (($isArrayOf_Lcats_effect_metrics_CpuStarvationWarningMetrics(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.metrics.CpuStarvationWarningMetrics;", depth));
}
var $d_Lcats_effect_metrics_CpuStarvationWarningMetrics = new $TypeData().initClass($c_Lcats_effect_metrics_CpuStarvationWarningMetrics, "cats.effect.metrics.CpuStarvationWarningMetrics", ({
  Lcats_effect_metrics_CpuStarvationWarningMetrics: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $is_Lcats_effect_std_Dispatcher$Executor$TaskState$1(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_std_Dispatcher$Executor$TaskState$1)));
}
function $as_Lcats_effect_std_Dispatcher$Executor$TaskState$1(obj) {
  return (($is_Lcats_effect_std_Dispatcher$Executor$TaskState$1(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$Executor$TaskState$1"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$Executor$TaskState$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$Executor$TaskState$1)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$Executor$TaskState$1(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$Executor$TaskState$1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$Executor$TaskState$1;", depth));
}
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$RegState() {
}
$c_Lcats_effect_std_Dispatcher$RegState.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$RegState.prototype.constructor = $c_Lcats_effect_std_Dispatcher$RegState;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$RegState() {
}
$h_Lcats_effect_std_Dispatcher$RegState.prototype = $c_Lcats_effect_std_Dispatcher$RegState.prototype;
$c_Lcats_effect_std_Dispatcher$RegState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
function $as_Lcats_effect_std_Dispatcher$RegState(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$RegState) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$RegState"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$RegState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$RegState)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$RegState(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$RegState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$RegState;", depth));
}
function $ct_Lcats_effect_std_Queue$AbstractQueue__I__Lcats_effect_kernel_Ref__Lcats_effect_kernel_GenConcurrent__($thiz, capacity, state, F) {
  $thiz.Lcats_effect_std_Queue$AbstractQueue__f_capacity = capacity;
  $thiz.Lcats_effect_std_Queue$AbstractQueue__f_state = state;
  $thiz.Lcats_effect_std_Queue$AbstractQueue__f_F = F;
  $thiz.Lcats_effect_std_Queue$AbstractQueue__f_take = $n(F).uncancelable__F1__O(new $c_sjsr_AnonFunction1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var target = $n(F).deferred__O();
    var this$67 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F);
    var f = new $c_sjsr_AnonFunction1(((taker) => {
      var taker$1 = $as_Lcats_effect_kernel_Deferred(taker);
      var modificationF = $n(state).modify__F1__O(new $c_sjsr_AnonFunction1(((x$1) => {
        var x$1$1 = $as_Lcats_effect_std_Queue$State(x$1);
        if ((x$1$1 !== null)) {
          var this$4 = $n(x$1$1);
          var x122 = this$4.Lcats_effect_std_Queue$State__f_queue;
          var this$5 = $n(x$1$1);
          var x123 = this$5.Lcats_effect_std_Queue$State__f_size;
          var this$6 = $n(x$1$1);
          var x124 = this$6.Lcats_effect_std_Queue$State__f_takers;
          var this$7 = $n(x$1$1);
          var x125 = this$7.Lcats_effect_std_Queue$State__f_offerers;
          var this$8 = $n(x122);
          if (((!this$8.isEmpty__Z()) && $n(x125).isEmpty__Z())) {
            matchResult24: {
              var \u03b49$___1;
              var \u03b49$___2;
              var x95 = $n(x122).dequeue__T2();
              if ((x95 !== null)) {
                var a = $n(x95)._1__O();
                var rest = $as_sci_Queue($n(x95)._2__O());
                var \u03b49$___1 = a;
                var \u03b49$___2 = rest;
                break matchResult24;
              }
              throw new $c_s_MatchError(x95);
            }
            var a$2 = \u03b49$___1;
            var rest$2 = $as_sci_Queue(\u03b49$___2);
            var size = (((-1) + x123) | 0);
            var self = new $c_Lcats_effect_std_Queue$State(rest$2, size, x124, x125);
            var y = $n(F).pure__O__O(a$2);
            return new $c_T2(self, y);
          }
          var this$13 = $n(x122);
          if ((!this$13.isEmpty__Z())) {
            matchResult25: {
              var \u03b410$___1;
              var \u03b410$___2;
              var x98 = $n(x122).dequeue__T2();
              if ((x98 !== null)) {
                var a$3 = $n(x98)._1__O();
                var rest$3 = $as_sci_Queue($n(x98)._2__O());
                var \u03b410$___1 = a$3;
                var \u03b410$___2 = rest$3;
                break matchResult25;
              }
              throw new $c_s_MatchError(x98);
            }
            var a$4 = \u03b410$___1;
            var rest$4 = $as_sci_Queue(\u03b410$___2);
            if (((((-1) + x123) | 0) < capacity)) {
              matchResult26: {
                var \u03b411$___1;
                var \u03b411$___2;
                var x101 = $n(x125).dequeue__T2();
                if ((x101 !== null)) {
                  var release = $as_Lcats_effect_kernel_Deferred($n(x101)._1__O());
                  var tail = $as_sci_Queue($n(x101)._2__O());
                  var \u03b411$___1 = release;
                  var \u03b411$___2 = tail;
                  break matchResult26;
                }
                throw new $c_s_MatchError(x101);
              }
              var release$2 = $as_Lcats_effect_kernel_Deferred(\u03b411$___1);
              var tail$2 = $as_sci_Queue(\u03b411$___2);
              var size$1 = (((-1) + x123) | 0);
              var self$1 = new $c_Lcats_effect_std_Queue$State(rest$4, size$1, x124, tail$2);
              var target$1 = $n(release$2).complete__O__O((void 0));
              var this$19 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, F);
              var y$1 = $n(this$19.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$19.Lcats_Functor$ToFunctorOps$$anon$5__f_self, a$4);
              return new $c_T2(self$1, y$1);
            } else {
              var size$2 = (((-1) + x123) | 0);
              var self$2 = new $c_Lcats_effect_std_Queue$State(rest$4, size$2, x124, x125);
              var y$2 = $n(F).pure__O__O(a$4);
              return new $c_T2(self$2, y$2);
            }
          }
          var cleanup = $n(state).modify__F1__O(new $c_sjsr_AnonFunction1(((s) => {
            var s$1 = $as_Lcats_effect_std_Queue$State(s);
            var this$24 = $n($n(s$1).Lcats_effect_std_Queue$State__f_takers);
            var b = $m_sci_Queue$().newBuilder__scm_Builder();
            var it = this$24.iterator__sc_Iterator();
            while ($n(it).hasNext__Z()) {
              var elem = $n(it).next__O();
              var _$22 = $as_Lcats_effect_kernel_Deferred(elem);
              if (((_$22 !== taker$1) !== false)) {
                var this$25 = $n(b);
                this$25.addOne__O__scm_Growable(elem);
              }
            }
            var takers2 = $as_sci_Queue($n(b).result__O());
            if ($n(takers2).isEmpty__Z()) {
              $n(s$1);
              var this$26 = $n(s$1);
              var queue = this$26.Lcats_effect_std_Queue$State__f_queue;
              var this$27 = $n(s$1);
              var size$3 = this$27.Lcats_effect_std_Queue$State__f_size;
              var this$28 = $n(s$1);
              var offerers = this$28.Lcats_effect_std_Queue$State__f_offerers;
              var self$3 = new $c_Lcats_effect_std_Queue$State(queue, size$3, takers2, offerers);
              var this$31 = $n(F);
              var y$3 = this$31.pure__O__O((void 0));
              return new $c_T2(self$3, y$3);
            } else {
              matchResult27: {
                var \u03b413$___1;
                var \u03b413$___2;
                var x104 = $n(takers2).dequeue__T2();
                if ((x104 !== null)) {
                  var taker$2 = $as_Lcats_effect_kernel_Deferred($n(x104)._1__O());
                  var rest$1 = $as_sci_Queue($n(x104)._2__O());
                  var \u03b413$___1 = taker$2;
                  var \u03b413$___2 = rest$1;
                  break matchResult27;
                }
                throw new $c_s_MatchError(x104);
              }
              var taker$2$1 = $as_Lcats_effect_kernel_Deferred(\u03b413$___1);
              var rest$2$1 = $as_sci_Queue(\u03b413$___2);
              $n(s$1);
              var this$34 = $n(s$1);
              var queue$1 = this$34.Lcats_effect_std_Queue$State__f_queue;
              var this$35 = $n(s$1);
              var size$4 = this$35.Lcats_effect_std_Queue$State__f_size;
              var this$36 = $n(s$1);
              var offerers$1 = this$36.Lcats_effect_std_Queue$State__f_offerers;
              var self$4 = new $c_Lcats_effect_std_Queue$State(queue$1, size$4, rest$2$1, offerers$1);
              var target$2 = $n(taker$2$1).complete__O__O((void 0));
              var this$40 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, F);
              var y$4 = $n(this$40.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$40.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
              return new $c_T2(self$4, y$4);
            }
          })));
          var wrapped = $n(poll$1).apply__O__O($n(taker$1).get__O());
          var this$45 = $n(F);
          var fin = $f_Lcats_FlatMap__flatten__O__O(this$45, cleanup);
          var fa = $n(F).onCancel__O__O__O(wrapped, fin);
          var this$53 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa, F);
          var wrapped$1 = $n(poll$1).apply__O__O($thiz.Lcats_effect_std_Queue$AbstractQueue__f_take);
          var ffa = $thiz.Lcats_effect_std_Queue$AbstractQueue__f_notifyNextTaker;
          var this$51 = $n(F);
          var fin$1 = $f_Lcats_FlatMap__flatten__O__O(this$51, ffa);
          var fb = $n(F).onCancel__O__O__O(wrapped$1, fin$1);
          var this$54 = $n(this$53.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
          var fa$1 = this$53.Lcats_syntax_ApplySyntax$$anon$1__f_self;
          var await$1 = this$54.productR__O__O__O(fa$1, fb);
          if ($n(x125).isEmpty__Z()) {
            var \u03b412$___1 = await$1;
            var \u03b412$___2 = x125;
          } else {
            matchResult28: {
              var \u03b415$___1;
              var \u03b415$___2;
              var x107 = $n(x125).dequeue__T2();
              if ((x107 !== null)) {
                var release$3 = $as_Lcats_effect_kernel_Deferred($n(x107)._1__O());
                var rest$5 = $as_sci_Queue($n(x107)._2__O());
                var \u03b415$___1 = release$3;
                var \u03b415$___2 = rest$5;
                break matchResult28;
              }
              throw new $c_s_MatchError(x107);
            }
            var release$4 = $as_Lcats_effect_kernel_Deferred(\u03b415$___1);
            var rest$6 = $as_sci_Queue(\u03b415$___2);
            var fa$2 = $n(release$4).complete__O__O((void 0));
            var this$58 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$2, F);
            var this$59 = $n(this$58.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
            var fa$3 = this$58.Lcats_syntax_ApplySyntax$$anon$1__f_self;
            var _1 = this$59.productR__O__O__O(fa$3, await$1);
            var \u03b412$___1 = _1;
            var \u03b412$___2 = rest$6;
          }
          var fulfill = \u03b412$___1;
          var offerers2 = $as_sci_Queue(\u03b412$___2);
          var takers = $n(x124).enqueue__O__sci_Queue(taker$1);
          var self$5 = new $c_Lcats_effect_std_Queue$State(x122, x123, takers, offerers2);
          return new $c_T2(self$5, fulfill);
        }
        throw new $c_s_MatchError(x$1$1);
      })));
      var this$66 = $n(F);
      return $f_Lcats_FlatMap__flatten__O__O(this$66, modificationF);
    }));
    return $n(this$67.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$67.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  })));
  $thiz.Lcats_effect_std_Queue$AbstractQueue__f_tryTake = $n(state).flatModify__F1__Lcats_effect_kernel_MonadCancel__O(new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1$3 = $as_Lcats_effect_std_Queue$State(x$1$2);
    if ((x$1$3 !== null)) {
      var this$69 = $n(x$1$3);
      var x142 = this$69.Lcats_effect_std_Queue$State__f_queue;
      var this$70 = $n(x$1$3);
      var x143 = this$70.Lcats_effect_std_Queue$State__f_size;
      var this$71 = $n(x$1$3);
      var x144 = this$71.Lcats_effect_std_Queue$State__f_takers;
      var this$72 = $n(x$1$3);
      var x145 = this$72.Lcats_effect_std_Queue$State__f_offerers;
      var this$73 = $n(x142);
      if (((!this$73.isEmpty__Z()) && $n(x145).isEmpty__Z())) {
        matchResult30: {
          var \u03b416$___1;
          var \u03b416$___2;
          var x126 = $n(x142).dequeue__T2();
          if ((x126 !== null)) {
            var a$1 = $n(x126)._1__O();
            var rest$7 = $as_sci_Queue($n(x126)._2__O());
            var \u03b416$___1 = a$1;
            var \u03b416$___2 = rest$7;
            break matchResult30;
          }
          throw new $c_s_MatchError(x126);
        }
        var a$2$1 = \u03b416$___1;
        var rest$2$2 = $as_sci_Queue(\u03b416$___2);
        var size$5 = (((-1) + x143) | 0);
        var self$6 = new $c_Lcats_effect_std_Queue$State(rest$2$2, size$5, x144, x145);
        var y$5 = $n(F).pure__O__O(new $c_s_Some(a$2$1));
        return new $c_T2(self$6, y$5);
      }
      var this$81 = $n(x142);
      if ((!this$81.isEmpty__Z())) {
        matchResult31: {
          var \u03b417$___1;
          var \u03b417$___2;
          var x129 = $n(x142).dequeue__T2();
          if ((x129 !== null)) {
            var a$3$1 = $n(x129)._1__O();
            var rest$3$1 = $as_sci_Queue($n(x129)._2__O());
            var \u03b417$___1 = a$3$1;
            var \u03b417$___2 = rest$3$1;
            break matchResult31;
          }
          throw new $c_s_MatchError(x129);
        }
        var a$4$1 = \u03b417$___1;
        var rest$4$1 = $as_sci_Queue(\u03b417$___2);
        matchResult32: {
          var \u03b418$___1;
          var \u03b418$___2;
          var x132 = $n(x145).dequeue__T2();
          if ((x132 !== null)) {
            var release$1 = $as_Lcats_effect_kernel_Deferred($n(x132)._1__O());
            var tail$1 = $as_sci_Queue($n(x132)._2__O());
            var \u03b418$___1 = release$1;
            var \u03b418$___2 = tail$1;
            break matchResult32;
          }
          throw new $c_s_MatchError(x132);
        }
        var release$2$1 = $as_Lcats_effect_kernel_Deferred(\u03b418$___1);
        var tail$2$1 = $as_sci_Queue(\u03b418$___2);
        var size$6 = (((-1) + x143) | 0);
        var self$7 = new $c_Lcats_effect_std_Queue$State(rest$4$1, size$6, x144, tail$2$1);
        var target$3 = $n(release$2$1).complete__O__O((void 0));
        var this$90 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, F);
        var b$1 = new $c_s_Some(a$4$1);
        var y$6 = $n(this$90.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$90.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b$1);
        return new $c_T2(self$7, y$6);
      }
    }
    var y$7 = $n(F).pure__O__O($m_s_None$());
    return new $c_T2(x$1$3, y$7);
  })), F);
  var target$4 = $n(state).get__O();
  var this$97 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$4, F);
  var f$1 = new $c_sjsr_AnonFunction1(((_$23) => {
    var _$23$1 = $as_Lcats_effect_std_Queue$State(_$23);
    return $n(_$23$1).Lcats_effect_std_Queue$State__f_size;
  }));
  $n(this$97.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$97.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
  $thiz.Lcats_effect_std_Queue$AbstractQueue__f_notifyNextTaker = $n(state).modify__F1__O(new $c_sjsr_AnonFunction1(((s$2) => {
    var s$3 = $as_Lcats_effect_std_Queue$State(s$2);
    if ($n($n(s$3).Lcats_effect_std_Queue$State__f_takers).isEmpty__Z()) {
      var this$99 = $n(F);
      var y$8 = this$99.pure__O__O((void 0));
      return new $c_T2(s$3, y$8);
    } else {
      matchResult34: {
        var \u03b414$___1;
        var \u03b414$___2;
        var x146 = $n($n(s$3).Lcats_effect_std_Queue$State__f_takers).dequeue__T2();
        if ((x146 !== null)) {
          var taker$3 = $as_Lcats_effect_kernel_Deferred($n(x146)._1__O());
          var rest$8 = $as_sci_Queue($n(x146)._2__O());
          var \u03b414$___1 = taker$3;
          var \u03b414$___2 = rest$8;
          break matchResult34;
        }
        throw new $c_s_MatchError(x146);
      }
      var taker$2$2 = $as_Lcats_effect_kernel_Deferred(\u03b414$___1);
      var rest$2$3 = $as_sci_Queue(\u03b414$___2);
      $n(s$3);
      var this$102 = $n(s$3);
      var queue$2 = this$102.Lcats_effect_std_Queue$State__f_queue;
      var this$103 = $n(s$3);
      var size$7 = this$103.Lcats_effect_std_Queue$State__f_size;
      var this$104 = $n(s$3);
      var offerers$2 = this$104.Lcats_effect_std_Queue$State__f_offerers;
      var self$8 = new $c_Lcats_effect_std_Queue$State(queue$2, size$7, rest$2$3, offerers$2);
      var target$5 = $n(taker$2$2).complete__O__O((void 0));
      var this$108 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$5, F);
      var y$9 = $n(this$108.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$108.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
      return new $c_T2(self$8, y$9);
    }
  })));
  return $thiz;
}
/** @constructor */
function $c_Lcats_effect_std_Queue$AbstractQueue() {
  this.Lcats_effect_std_Queue$AbstractQueue__f_capacity = 0;
  this.Lcats_effect_std_Queue$AbstractQueue__f_state = null;
  this.Lcats_effect_std_Queue$AbstractQueue__f_F = null;
  this.Lcats_effect_std_Queue$AbstractQueue__f_take = null;
  this.Lcats_effect_std_Queue$AbstractQueue__f_tryTake = null;
  this.Lcats_effect_std_Queue$AbstractQueue__f_notifyNextTaker = null;
}
$c_Lcats_effect_std_Queue$AbstractQueue.prototype = new $h_Lcats_effect_std_Queue();
$c_Lcats_effect_std_Queue$AbstractQueue.prototype.constructor = $c_Lcats_effect_std_Queue$AbstractQueue;
/** @constructor */
function $h_Lcats_effect_std_Queue$AbstractQueue() {
}
$h_Lcats_effect_std_Queue$AbstractQueue.prototype = $c_Lcats_effect_std_Queue$AbstractQueue.prototype;
$c_Lcats_effect_std_Queue$AbstractQueue.prototype.offer__O__O = (function(a) {
  return $n(this.Lcats_effect_std_Queue$AbstractQueue__f_F).uncancelable__F1__O(new $c_sjsr_AnonFunction1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var target = $n(this.Lcats_effect_std_Queue$AbstractQueue__f_F).deferred__O();
    var tc = this.Lcats_effect_std_Queue$AbstractQueue__f_F;
    var this$58 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
    var f = new $c_sjsr_AnonFunction1(((offerer) => {
      var offerer$1 = $as_Lcats_effect_kernel_Deferred(offerer);
      var modificationF = $n(this.Lcats_effect_std_Queue$AbstractQueue__f_state).modify__F1__O(new $c_sjsr_AnonFunction1(((x$1) => {
        var x$1$1 = $as_Lcats_effect_std_Queue$State(x$1);
        if ((x$1$1 !== null)) {
          var this$4 = $n(x$1$1);
          var x77 = this$4.Lcats_effect_std_Queue$State__f_queue;
          var this$5 = $n(x$1$1);
          var x78 = this$5.Lcats_effect_std_Queue$State__f_size;
          var this$6 = $n(x$1$1);
          var x79 = this$6.Lcats_effect_std_Queue$State__f_takers;
          var this$7 = $n(x$1$1);
          var x80 = this$7.Lcats_effect_std_Queue$State__f_offerers;
          var this$8 = $n(x79);
          if ((!this$8.isEmpty__Z())) {
            matchResult20: {
              var \u03b47$___1;
              var \u03b47$___2;
              var x67 = $n(x79).dequeue__T2();
              if ((x67 !== null)) {
                var taker = $as_Lcats_effect_kernel_Deferred($n(x67)._1__O());
                var rest = $as_sci_Queue($n(x67)._2__O());
                var \u03b47$___1 = taker;
                var \u03b47$___2 = rest;
                break matchResult20;
              }
              throw new $c_s_MatchError(x67);
            }
            var taker$2 = $as_Lcats_effect_kernel_Deferred(\u03b47$___1);
            var rest$2 = $as_sci_Queue(\u03b47$___2);
            var queue = $n(x77).enqueue__O__sci_Queue(a);
            var size = ((1 + x78) | 0);
            var self = new $c_Lcats_effect_std_Queue$State(queue, size, rest$2, x80);
            var target$1 = $n(taker$2).complete__O__O((void 0));
            var tc$1 = this.Lcats_effect_std_Queue$AbstractQueue__f_F;
            var this$13 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, tc$1);
            var y = $n(this$13.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$13.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
            return new $c_T2(self, y);
          }
          if ((x78 < this.Lcats_effect_std_Queue$AbstractQueue__f_capacity)) {
            var queue$1 = $n(x77).enqueue__O__sci_Queue(a);
            var size$1 = ((1 + x78) | 0);
            var self$1 = new $c_Lcats_effect_std_Queue$State(queue$1, size$1, x79, x80);
            var this$17 = $n(this.Lcats_effect_std_Queue$AbstractQueue__f_F);
            var y$1 = this$17.pure__O__O((void 0));
            return new $c_T2(self$1, y$1);
          }
        }
        matchResult35: {
          var \u03b419$___1;
          var \u03b419$___2;
          var \u03b419$___3;
          var \u03b419$___4;
          if ((x$1$1 !== null)) {
            var this$20 = $n(x$1$1);
            var x151 = this$20.Lcats_effect_std_Queue$State__f_queue;
            var this$21 = $n(x$1$1);
            var x152 = this$21.Lcats_effect_std_Queue$State__f_size;
            var this$22 = $n(x$1$1);
            var x153 = this$22.Lcats_effect_std_Queue$State__f_takers;
            var this$23 = $n(x$1$1);
            var x154 = this$23.Lcats_effect_std_Queue$State__f_offerers;
            var \u03b419$___1 = x151;
            var \u03b419$___2 = x152;
            var \u03b419$___3 = x153;
            var \u03b419$___4 = x154;
            break matchResult35;
          }
          throw new $c_s_MatchError(x$1$1);
        }
        var queue$2 = $as_sci_Queue(\u03b419$___1);
        var size$2 = $uI(\u03b419$___2);
        var takers$2 = $as_sci_Queue(\u03b419$___3);
        var offerers$2 = $as_sci_Queue(\u03b419$___4);
        var cleanup = $n(this.Lcats_effect_std_Queue$BoundedQueue__f_state).modify__F1__O(new $c_sjsr_AnonFunction1(((s$2) => {
          var s = $as_Lcats_effect_std_Queue$State(s$2);
          var this$26 = $n($n(s).Lcats_effect_std_Queue$State__f_offerers);
          var b = $m_sci_Queue$().newBuilder__scm_Builder();
          var it = this$26.iterator__sc_Iterator();
          while ($n(it).hasNext__Z()) {
            var elem = $n(it).next__O();
            var _$25 = $as_Lcats_effect_kernel_Deferred(elem);
            if (((_$25 !== offerer$1) !== false)) {
              var this$27 = $n(b);
              this$27.addOne__O__scm_Growable(elem);
            }
          }
          var offerers2 = $as_sci_Queue($n(b).result__O());
          if ($n(offerers2).isEmpty__Z()) {
            $n(s);
            var this$28 = $n(s);
            var queue$3 = this$28.Lcats_effect_std_Queue$State__f_queue;
            var this$29 = $n(s);
            var size$3 = this$29.Lcats_effect_std_Queue$State__f_size;
            var this$30 = $n(s);
            var takers = this$30.Lcats_effect_std_Queue$State__f_takers;
            var self$2 = new $c_Lcats_effect_std_Queue$State(queue$3, size$3, takers, offerers2);
            var this$33 = $n(this.Lcats_effect_std_Queue$BoundedQueue__f_F);
            var y$2 = this$33.pure__O__O((void 0));
            return new $c_T2(self$2, y$2);
          } else {
            matchResult36: {
              var \u03b420$___1;
              var \u03b420$___2;
              var x155 = $n(offerers2).dequeue__T2();
              if ((x155 !== null)) {
                var offerer$2 = $as_Lcats_effect_kernel_Deferred($n(x155)._1__O());
                var rest$1 = $as_sci_Queue($n(x155)._2__O());
                var \u03b420$___1 = offerer$2;
                var \u03b420$___2 = rest$1;
                break matchResult36;
              }
              throw new $c_s_MatchError(x155);
            }
            var offerer$3 = $as_Lcats_effect_kernel_Deferred(\u03b420$___1);
            var rest$2$1 = $as_sci_Queue(\u03b420$___2);
            $n(s);
            var this$36 = $n(s);
            var queue$4 = this$36.Lcats_effect_std_Queue$State__f_queue;
            var this$37 = $n(s);
            var size$4 = this$37.Lcats_effect_std_Queue$State__f_size;
            var this$38 = $n(s);
            var takers$1 = this$38.Lcats_effect_std_Queue$State__f_takers;
            var self$3 = new $c_Lcats_effect_std_Queue$State(queue$4, size$4, takers$1, rest$2$1);
            var target$2 = $n(offerer$3).complete__O__O((void 0));
            var tc$2 = this.Lcats_effect_std_Queue$BoundedQueue__f_F;
            var this$42 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, tc$2);
            var y$3 = $n(this$42.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$42.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
            return new $c_T2(self$3, y$3);
          }
        })));
        var offerers = $n(offerers$2).enqueue__O__sci_Queue(offerer$1);
        var self$4 = new $c_Lcats_effect_std_Queue$State(queue$2, size$2, takers$2, offerers);
        var fa = $n(poll$1).apply__O__O($n(offerer$1).get__O());
        var F = this.Lcats_effect_std_Queue$BoundedQueue__f_F;
        var this$47 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa, F);
        var fb = $n(poll$1).apply__O__O(this.offer__O__O(a));
        var this$48 = $n(this$47.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
        var fa$1 = this$47.Lcats_syntax_ApplySyntax$$anon$1__f_self;
        var wrapped = this$48.productR__O__O__O(fa$1, fb);
        var F$1 = this.Lcats_effect_std_Queue$BoundedQueue__f_F;
        var this$52 = $n(F$1);
        var fin = $f_Lcats_FlatMap__flatten__O__O(this$52, cleanup);
        var F$2 = this.Lcats_effect_std_Queue$BoundedQueue__f_F;
        var y$4 = $n(F$2).onCancel__O__O__O(wrapped, fin);
        return new $c_T2(self$4, y$4);
      })));
      var F$3 = this.Lcats_effect_std_Queue$AbstractQueue__f_F;
      var this$57 = $n(F$3);
      return $f_Lcats_FlatMap__flatten__O__O(this$57, modificationF);
    }));
    return $n(this$58.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$58.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  })));
});
$c_Lcats_effect_std_Queue$AbstractQueue.prototype.take__O = (function() {
  return this.Lcats_effect_std_Queue$AbstractQueue__f_take;
});
$c_Lcats_effect_std_Queue$AbstractQueue.prototype.tryTake__O = (function() {
  return this.Lcats_effect_std_Queue$AbstractQueue__f_tryTake;
});
/** @constructor */
function $c_Lcats_effect_std_Queue$State(queue, size, takers, offerers) {
  this.Lcats_effect_std_Queue$State__f_queue = null;
  this.Lcats_effect_std_Queue$State__f_size = 0;
  this.Lcats_effect_std_Queue$State__f_takers = null;
  this.Lcats_effect_std_Queue$State__f_offerers = null;
  this.Lcats_effect_std_Queue$State__f_queue = queue;
  this.Lcats_effect_std_Queue$State__f_size = size;
  this.Lcats_effect_std_Queue$State__f_takers = takers;
  this.Lcats_effect_std_Queue$State__f_offerers = offerers;
}
$c_Lcats_effect_std_Queue$State.prototype = new $h_O();
$c_Lcats_effect_std_Queue$State.prototype.constructor = $c_Lcats_effect_std_Queue$State;
/** @constructor */
function $h_Lcats_effect_std_Queue$State() {
}
$h_Lcats_effect_std_Queue$State.prototype = $c_Lcats_effect_std_Queue$State.prototype;
$c_Lcats_effect_std_Queue$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_std_Queue$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcats_effect_std_Queue$State__f_queue;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lcats_effect_std_Queue$State__f_size;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lcats_effect_std_Queue$State__f_takers;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Lcats_effect_std_Queue$State__f_offerers;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4);
});
$c_Lcats_effect_std_Queue$State.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_std_Queue$State)) {
    var x$0$2 = $as_Lcats_effect_std_Queue$State(x$0);
    if ((this.Lcats_effect_std_Queue$State__f_size === $n(x$0$2).Lcats_effect_std_Queue$State__f_size)) {
      var x = this.Lcats_effect_std_Queue$State__f_queue;
      var x$2 = $n(x$0$2).Lcats_effect_std_Queue$State__f_queue;
      if ((x === null)) {
        var $x_2 = (x$2 === null);
      } else {
        var this$1 = $n(x);
        var $x_2 = $f_sc_Seq__equals__O__Z(this$1, x$2);
      }
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Lcats_effect_std_Queue$State__f_takers;
      var x$4 = $n(x$0$2).Lcats_effect_std_Queue$State__f_takers;
      if ((x$3 === null)) {
        var $x_1 = (x$4 === null);
      } else {
        var this$2 = $n(x$3);
        var $x_1 = $f_sc_Seq__equals__O__Z(this$2, x$4);
      }
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lcats_effect_std_Queue$State__f_offerers;
      var x$6 = $n(x$0$2).Lcats_effect_std_Queue$State__f_offerers;
      if ((x$5 === null)) {
        return (x$6 === null);
      } else {
        var this$3 = $n(x$5);
        return $f_sc_Seq__equals__O__Z(this$3, x$6);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_std_Queue$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_std_Queue$State.prototype.productArity__I = (function() {
  return 4;
});
$c_Lcats_effect_std_Queue$State.prototype.productPrefix__T = (function() {
  return "State";
});
$c_Lcats_effect_std_Queue$State.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_std_Queue$State__f_queue;
      break;
    }
    case 1: {
      return this.Lcats_effect_std_Queue$State__f_size;
      break;
    }
    case 2: {
      return this.Lcats_effect_std_Queue$State__f_takers;
      break;
    }
    case 3: {
      return this.Lcats_effect_std_Queue$State__f_offerers;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Lcats_effect_std_Queue$State(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Queue$State) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Queue$State"));
}
function $isArrayOf_Lcats_effect_std_Queue$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Queue$State)));
}
function $asArrayOf_Lcats_effect_std_Queue$State(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Queue$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Queue$State;", depth));
}
var $d_Lcats_effect_std_Queue$State = new $TypeData().initClass($c_Lcats_effect_std_Queue$State, "cats.effect.std.Queue$State", ({
  Lcats_effect_std_Queue$State: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $p_Lcats_effect_std_Queue$UnboundedAsyncQueue__notifyOne__V($thiz) {
  while (true) {
    try {
      var f = $as_F1($n($thiz.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_takers).take__O());
      var retry = ((f === null) || ($n(f).apply__O__O($m_Lcats_effect_std_Queue$().Lcats_effect_std_Queue$__f_cats$effect$std$Queue$$$EitherUnit), false));
    } catch (e) {
      var e$1 = e;
      var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
      matchResult55: {
        var retry;
        var x = $thiz.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_FailureSignal;
        if ((x !== null)) {
          var this$2 = $n(x);
          var $x_1 = (this$2 === e$2);
        } else {
          var $x_1 = false;
        }
        if ($x_1) {
          var retry = false;
          break matchResult55;
        }
        throw e$2;
      }
    }
    if (retry) {
      continue;
    }
    return (void 0);
  }
}
/** @constructor */
function $c_Lcats_effect_std_Queue$UnboundedAsyncQueue(F) {
  this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_F = null;
  this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_buffer = null;
  this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_takers = null;
  this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_FailureSignal = null;
  this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_take = null;
  this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_tryTake = null;
  this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_F = F;
  this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_buffer = new $c_Lcats_effect_std_UnsafeUnbounded();
  this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_takers = new $c_Lcats_effect_std_UnsafeUnbounded();
  this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_FailureSignal = $m_Lcats_effect_std_FailureSignal$();
  $n(F).delay__F0__O(new $c_sjsr_AnonFunction0((() => $n(this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_buffer).size__I())));
  this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_take = $n(F).uncancelable__F1__O(new $c_sjsr_AnonFunction1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var this$17 = $n(F);
    var thunk$1 = new $c_sjsr_AnonFunction0((() => {
      try {
        return $n(F).pure__O__O($n(this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_buffer).take__O());
      } catch (e) {
        var e$1 = e;
        var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
        var x = this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_FailureSignal;
        if ((x !== null)) {
          var this$4 = $n(x);
          var $x_1 = (this$4 === e$2);
        } else {
          var $x_1 = false;
        }
        if ($x_1) {
          var received = new $c_sr_BooleanRef(false);
          var result = new $c_sr_ObjectRef(null);
          var wait = $n(F).asyncCheckAttempt__F1__O(new $c_sjsr_AnonFunction1(((k) => {
            var k$1 = $as_F1(k);
            return $n(F).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
              var clear = $n(this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_takers).put__O__F0(k$1);
              try {
                var ev$59 = $n(this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_buffer).take__O();
                result.sr_ObjectRef__f_elem = ev$59;
                ev$59 = null;
                $n(clear).apply__O();
                var ev$60 = true;
                received.sr_BooleanRef__f_elem = ev$60;
                $p_Lcats_effect_std_Queue$UnboundedAsyncQueue__notifyOne__V(this);
                return $m_Lcats_effect_std_Queue$().Lcats_effect_std_Queue$__f_cats$effect$std$Queue$$$EitherUnit;
              } catch (e$3) {
                var e$4 = e$3;
                var e$2$1 = ((e$4 instanceof $c_jl_Throwable) ? e$4 : new $c_sjs_js_JavaScriptException(e$4));
                var x$1 = this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_FailureSignal;
                if ((x$1 !== null)) {
                  var this$8 = $n(x$1);
                  var $x_2 = (this$8 === e$2$1);
                } else {
                  var $x_2 = false;
                }
                if ($x_2) {
                  var value = $n(F).delay__F0__O(clear);
                  var value$1 = new $c_s_Some(value);
                  return new $c_s_util_Left(value$1);
                }
                throw e$2$1;
              }
            })));
          })));
          var notifyAnyway = $n(F).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
            $p_Lcats_effect_std_Queue$UnboundedAsyncQueue__notifyOne__V(this);
          })));
          var fa = $n(poll$1).apply__O__O(wait);
          var this$13 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa, F);
          var this$12 = $n(F);
          var thunk = new $c_sjsr_AnonFunction0((() => (received.sr_BooleanRef__f_elem ? $n(F).pure__O__O(result.sr_ObjectRef__f_elem) : $n(poll$1).apply__O__O(this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_take))));
          var fb = $f_Lcats_effect_kernel_Sync__defer__F0__O(this$12, thunk);
          var this$14 = $n(this$13.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
          var fa$1 = this$13.Lcats_syntax_ApplySyntax$$anon$1__f_self;
          var wrapped = this$14.productR__O__O__O(fa$1, fb);
          return $n(F).onCancel__O__O__O(wrapped, notifyAnyway);
        }
        throw e$2;
      }
    }));
    return $f_Lcats_effect_kernel_Sync__defer__F0__O(this$17, thunk$1);
  })));
  this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_tryTake = $n(F).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
    try {
      var value$2 = $n(this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_buffer).take__O();
      return new $c_s_Some(value$2);
    } catch (e$5) {
      var e$6 = e$5;
      var e$2$2 = ((e$6 instanceof $c_jl_Throwable) ? e$6 : new $c_sjs_js_JavaScriptException(e$6));
      var x$2 = this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_FailureSignal;
      if ((x$2 !== null)) {
        var this$20 = $n(x$2);
        var $x_3 = (this$20 === e$2$2);
      } else {
        var $x_3 = false;
      }
      if ($x_3) {
        return $m_s_None$();
      }
      throw e$2$2;
    }
  })));
}
$c_Lcats_effect_std_Queue$UnboundedAsyncQueue.prototype = new $h_Lcats_effect_std_Queue();
$c_Lcats_effect_std_Queue$UnboundedAsyncQueue.prototype.constructor = $c_Lcats_effect_std_Queue$UnboundedAsyncQueue;
/** @constructor */
function $h_Lcats_effect_std_Queue$UnboundedAsyncQueue() {
}
$h_Lcats_effect_std_Queue$UnboundedAsyncQueue.prototype = $c_Lcats_effect_std_Queue$UnboundedAsyncQueue.prototype;
$c_Lcats_effect_std_Queue$UnboundedAsyncQueue.prototype.offer__O__O = (function(a) {
  return $n(this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_F).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
    $n(this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_buffer).put__O__F0(a);
    $p_Lcats_effect_std_Queue$UnboundedAsyncQueue__notifyOne__V(this);
  })));
});
$c_Lcats_effect_std_Queue$UnboundedAsyncQueue.prototype.take__O = (function() {
  return this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_take;
});
$c_Lcats_effect_std_Queue$UnboundedAsyncQueue.prototype.tryTake__O = (function() {
  return this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_tryTake;
});
var $d_Lcats_effect_std_Queue$UnboundedAsyncQueue = new $TypeData().initClass($c_Lcats_effect_std_Queue$UnboundedAsyncQueue, "cats.effect.std.Queue$UnboundedAsyncQueue", ({
  Lcats_effect_std_Queue$UnboundedAsyncQueue: 1,
  Lcats_effect_std_Queue: 1,
  Lcats_effect_std_QueueSource: 1,
  Lcats_effect_std_QueueSink: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Random$$anon$2(evidence$1$1, sRandom$1) {
  this.Lcats_effect_std_Random$RandomCommon__f_evidence$24 = null;
  this.Lcats_effect_std_Random$ScalaRandom__f_f = null;
  this.Lcats_effect_std_Random$ScalaRandom__f_evidence$25 = null;
  $ct_Lcats_effect_std_Random$ScalaRandom__O__Lcats_effect_kernel_Sync__(this, $n(evidence$1$1).pure__O__O(sRandom$1), evidence$1$1);
}
$c_Lcats_effect_std_Random$$anon$2.prototype = new $h_Lcats_effect_std_Random$ScalaRandom();
$c_Lcats_effect_std_Random$$anon$2.prototype.constructor = $c_Lcats_effect_std_Random$$anon$2;
/** @constructor */
function $h_Lcats_effect_std_Random$$anon$2() {
}
$h_Lcats_effect_std_Random$$anon$2.prototype = $c_Lcats_effect_std_Random$$anon$2.prototype;
var $d_Lcats_effect_std_Random$$anon$2 = new $TypeData().initClass($c_Lcats_effect_std_Random$$anon$2, "cats.effect.std.Random$$anon$2", ({
  Lcats_effect_std_Random$$anon$2: 1,
  Lcats_effect_std_Random$ScalaRandom: 1,
  Lcats_effect_std_Random$RandomCommon: 1,
  Lcats_effect_std_Random: 1
}));
/** @constructor */
function $c_Lcats_effect_std_UnsafeUnbounded$Cell(_data) {
  this.ju_concurrent_atomic_AtomicReference__f_value = null;
  this.Lcats_effect_std_UnsafeUnbounded$Cell__f__data = null;
  this.Lcats_effect_std_UnsafeUnbounded$Cell__f__data = _data;
  $ct_ju_concurrent_atomic_AtomicReference__O__(this, null);
}
$c_Lcats_effect_std_UnsafeUnbounded$Cell.prototype = new $h_ju_concurrent_atomic_AtomicReference();
$c_Lcats_effect_std_UnsafeUnbounded$Cell.prototype.constructor = $c_Lcats_effect_std_UnsafeUnbounded$Cell;
/** @constructor */
function $h_Lcats_effect_std_UnsafeUnbounded$Cell() {
}
$h_Lcats_effect_std_UnsafeUnbounded$Cell.prototype = $c_Lcats_effect_std_UnsafeUnbounded$Cell.prototype;
$c_Lcats_effect_std_UnsafeUnbounded$Cell.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lcats_effect_std_UnsafeUnbounded$Cell.prototype.apply__V = (function() {
  this.Lcats_effect_std_UnsafeUnbounded$Cell__f__data = null;
});
$c_Lcats_effect_std_UnsafeUnbounded$Cell.prototype.apply__O = (function() {
  this.apply__V();
});
function $as_Lcats_effect_std_UnsafeUnbounded$Cell(obj) {
  return (((obj instanceof $c_Lcats_effect_std_UnsafeUnbounded$Cell) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.UnsafeUnbounded$Cell"));
}
function $isArrayOf_Lcats_effect_std_UnsafeUnbounded$Cell(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_UnsafeUnbounded$Cell)));
}
function $asArrayOf_Lcats_effect_std_UnsafeUnbounded$Cell(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_UnsafeUnbounded$Cell(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.UnsafeUnbounded$Cell;", depth));
}
var $d_Lcats_effect_std_UnsafeUnbounded$Cell = new $TypeData().initClass($c_Lcats_effect_std_UnsafeUnbounded$Cell, "cats.effect.std.UnsafeUnbounded$Cell", ({
  Lcats_effect_std_UnsafeUnbounded$Cell: 1,
  ju_concurrent_atomic_AtomicReference: 1,
  Ljava_io_Serializable: 1,
  F0: 1
}));
class $c_Lcats_effect_tracing_TracingEvent$StackTrace extends $c_jl_Throwable {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
}
function $as_Lcats_effect_tracing_TracingEvent$StackTrace(obj) {
  return (((obj instanceof $c_Lcats_effect_tracing_TracingEvent$StackTrace) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.tracing.TracingEvent$StackTrace"));
}
function $isArrayOf_Lcats_effect_tracing_TracingEvent$StackTrace(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_tracing_TracingEvent$StackTrace)));
}
function $asArrayOf_Lcats_effect_tracing_TracingEvent$StackTrace(obj, depth) {
  return (($isArrayOf_Lcats_effect_tracing_TracingEvent$StackTrace(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.tracing.TracingEvent$StackTrace;", depth));
}
var $d_Lcats_effect_tracing_TracingEvent$StackTrace = new $TypeData().initClass($c_Lcats_effect_tracing_TracingEvent$StackTrace, "cats.effect.tracing.TracingEvent$StackTrace", ({
  Lcats_effect_tracing_TracingEvent$StackTrace: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_tracing_TracingEvent: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor(batchSize, reportFailure0) {
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$batchSize = 0;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_reportFailure0 = null;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_queueMicrotask = null;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$needsReschedule = false;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$fibers = null;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_executeBatchTaskRunnable = null;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_executeBatchTaskJSFunction = null;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_fiberBag = null;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$batchSize = batchSize;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_reportFailure0 = reportFailure0;
  if (($as_T((typeof queueMicrotask)) === "function")) {
    var $x_1 = queueMicrotask;
  } else {
    var resolved = Promise.resolve((void 0));
    var $x_1 = ((task) => resolved.then(task));
  }
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_queueMicrotask = $x_1;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$needsReschedule = true;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$fibers = new $c_Lcats_effect_unsafe_JSArrayQueue();
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_executeBatchTaskRunnable = new $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1(this);
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_executeBatchTaskJSFunction = (() => {
    $n(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_executeBatchTaskRunnable).run__V();
  });
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_fiberBag = (($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing && $m_Lcats_effect_unsafe_FiberMonitor$().weakRefsAvailable__Z()) ? $as_scm_Set($m_scm_Set$().empty__O()) : null);
}
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor.prototype = new $h_O();
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor.prototype.constructor = $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor;
/** @constructor */
function $h_Lcats_effect_unsafe_BatchingMacrotaskExecutor() {
}
$h_Lcats_effect_unsafe_BatchingMacrotaskExecutor.prototype = $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor.prototype;
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor.prototype.execute__jl_Runnable__V = (function(runnable) {
  var $x_2 = $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$();
  if ((this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_fiberBag !== null)) {
    if ((runnable instanceof $c_Lcats_effect_IOFiber)) {
      var r = $as_Lcats_effect_IOFiber(runnable);
      var this$2 = $n(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_fiberBag);
      this$2.addOne__O__scm_Growable(r);
      var $x_1 = new $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2(r, this);
    } else {
      var $x_1 = runnable;
    }
  } else {
    var $x_1 = runnable;
  }
  $n($x_2).execute__jl_Runnable__V($x_1);
});
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor.prototype.schedule__Lcats_effect_IOFiber__V = (function(fiber) {
  var this$1 = $n(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$fibers);
  if ((!this$1.Lcats_effect_unsafe_JSArrayQueue__f_empty)) {
    if (((this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex === 0) && (this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex === $uI(this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer.length)))) {
      this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer.push(null);
    } else if ((this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex === this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex)) {
      var i = 0;
      while ((i < this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex)) {
        this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer.push(this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer[i]);
        this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer[i] = null;
        i = ((1 + i) | 0);
      }
      this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex = $uI(this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer.length);
    }
  }
  this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex = ((1 + this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex) | 0);
  if ((this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex > $uI(this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer.length))) {
    this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex = 1;
  }
  this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer[(((-1) + this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex) | 0)] = fiber;
  this$1.Lcats_effect_unsafe_JSArrayQueue__f_empty = false;
  if (this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$needsReschedule) {
    this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$needsReschedule = false;
    (0, this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_queueMicrotask)(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_executeBatchTaskJSFunction);
  }
});
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor.prototype.reportFailure__jl_Throwable__V = (function(t) {
  $n(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_reportFailure0).apply__O__O(t);
});
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor.prototype.liveTraces__sci_Map = (function() {
  var traces = new $c_sci_MapBuilderImpl();
  var this$4 = $n(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$fibers);
  var f$2 = ((f) => {
    var f$1 = $as_Lcats_effect_IOFiber(f);
    if ((!$n(f$1).isDone__Z())) {
      var y = $n(f$1).captureTrace__Lcats_effect_Trace();
      traces.addOne__O__O__sci_MapBuilderImpl(f$1, y);
    }
  });
  if ((!this$4.Lcats_effect_unsafe_JSArrayQueue__f_empty)) {
    if ((this$4.Lcats_effect_unsafe_JSArrayQueue__f_startIndex < this$4.Lcats_effect_unsafe_JSArrayQueue__f_endIndex)) {
      var i = this$4.Lcats_effect_unsafe_JSArrayQueue__f_startIndex;
      while ((i < this$4.Lcats_effect_unsafe_JSArrayQueue__f_endIndex)) {
        var arg1 = this$4.Lcats_effect_unsafe_JSArrayQueue__f_buffer[i];
        f$2(arg1);
        i = ((1 + i) | 0);
      }
    } else {
      var i$2 = this$4.Lcats_effect_unsafe_JSArrayQueue__f_startIndex;
      while ((i$2 < $uI(this$4.Lcats_effect_unsafe_JSArrayQueue__f_buffer.length))) {
        var arg1$1 = this$4.Lcats_effect_unsafe_JSArrayQueue__f_buffer[i$2];
        f$2(arg1$1);
        i$2 = ((1 + i$2) | 0);
      }
      i$2 = 0;
      while ((i$2 < this$4.Lcats_effect_unsafe_JSArrayQueue__f_endIndex)) {
        var arg1$2 = this$4.Lcats_effect_unsafe_JSArrayQueue__f_buffer[i$2];
        f$2(arg1$2);
        i$2 = ((1 + i$2) | 0);
      }
    }
  }
  $n(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_fiberBag).foreach__F1__V(new $c_sjsr_AnonFunction1(((f$2$1) => {
    var f$3 = $as_Lcats_effect_IOFiber(f$2$1);
    if ((!$n(f$3).isDone__Z())) {
      var y$1 = $n(f$3).captureTrace__Lcats_effect_Trace();
      traces.addOne__O__O__sci_MapBuilderImpl(f$3, y$1);
    }
  })));
  return traces.result__sci_Map();
});
function $as_Lcats_effect_unsafe_BatchingMacrotaskExecutor(obj) {
  return (((obj instanceof $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.BatchingMacrotaskExecutor"));
}
function $isArrayOf_Lcats_effect_unsafe_BatchingMacrotaskExecutor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_BatchingMacrotaskExecutor)));
}
function $asArrayOf_Lcats_effect_unsafe_BatchingMacrotaskExecutor(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_BatchingMacrotaskExecutor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.BatchingMacrotaskExecutor;", depth));
}
var $d_Lcats_effect_unsafe_BatchingMacrotaskExecutor = new $TypeData().initClass($c_Lcats_effect_unsafe_BatchingMacrotaskExecutor, "cats.effect.unsafe.BatchingMacrotaskExecutor", ({
  Lcats_effect_unsafe_BatchingMacrotaskExecutor: 1,
  s_concurrent_ExecutionContext: 1,
  ju_concurrent_Executor: 1,
  s_concurrent_ExecutionContextExecutor: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_IORuntimeConfig(cancelationCheckThreshold, autoYieldThreshold, enhancedExceptions, traceBufferSize, shutdownHookTimeout, reportUnhandledFiberErrors, cpuStarvationCheckInterval, cpuStarvationCheckInitialDelay, cpuStarvationCheckThreshold) {
  this.Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold = 0;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold = 0;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions = false;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferSize = 0;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_shutdownHookTimeout = null;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_reportUnhandledFiberErrors = false;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInterval = null;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInitialDelay = null;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckThreshold = 0.0;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferLogSize = 0;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold = cancelationCheckThreshold;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold = autoYieldThreshold;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions = enhancedExceptions;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferSize = traceBufferSize;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_shutdownHookTimeout = shutdownHookTimeout;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_reportUnhandledFiberErrors = reportUnhandledFiberErrors;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInterval = cpuStarvationCheckInterval;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInitialDelay = cpuStarvationCheckInitialDelay;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckThreshold = cpuStarvationCheckThreshold;
  var requirement = (autoYieldThreshold > 1);
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + ("Auto yield threshold " + autoYieldThreshold)) + " must be > 1"));
  }
  var requirement$1 = (cancelationCheckThreshold > 0);
  if ((!requirement$1)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + ("Cancelation check threshold " + cancelationCheckThreshold)) + " must be > 0"));
  }
  var requirement$2 = ($intMod(autoYieldThreshold, cancelationCheckThreshold) === 0);
  if ((!requirement$2)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + (("Auto yield threshold " + autoYieldThreshold) + " must be a multiple of cancelation check threshold ")) + cancelationCheckThreshold));
  }
  var requirement$3 = (cpuStarvationCheckThreshold > 0.0);
  if ((!requirement$3)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + ("CPU starvation check threshold " + cpuStarvationCheckThreshold)) + " must be > 0"));
  }
  var a = traceBufferSize;
  var a$1 = ($uD(Math.log(a)) / $uD(Math.log(2.0)));
  var this$8 = $m_RTLong$();
  var value = $uD(Math.round(a$1));
  var lo = this$8.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferLogSize = lo;
}
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype = new $h_O();
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.constructor = $c_Lcats_effect_unsafe_IORuntimeConfig;
/** @constructor */
function $h_Lcats_effect_unsafe_IORuntimeConfig() {
}
$h_Lcats_effect_unsafe_IORuntimeConfig.prototype = $c_Lcats_effect_unsafe_IORuntimeConfig.prototype;
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("IORuntimeConfig");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = (this.Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferSize;
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x = this.Lcats_effect_unsafe_IORuntimeConfig__f_shutdownHookTimeout;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var data$6 = (this.Lcats_effect_unsafe_IORuntimeConfig__f_reportUnhandledFiberErrors ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var x$1 = this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInterval;
  var data$7 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  var x$2 = this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInitialDelay;
  var data$8 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$8, data$8);
  var hash$9 = acc;
  var dv = this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckThreshold;
  var data$9 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$9, data$9);
  var hash$10 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$10, 9);
});
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_unsafe_IORuntimeConfig)) {
    var x$0$2 = $as_Lcats_effect_unsafe_IORuntimeConfig(x$0);
    if (((((((this.Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold === $n(x$0$2).Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold) && (this.Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold === $n(x$0$2).Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold)) && (this.Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions === $n(x$0$2).Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions)) && (this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferSize === $n(x$0$2).Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferSize)) && (this.Lcats_effect_unsafe_IORuntimeConfig__f_reportUnhandledFiberErrors === $n(x$0$2).Lcats_effect_unsafe_IORuntimeConfig__f_reportUnhandledFiberErrors)) && (this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckThreshold === $n(x$0$2).Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckThreshold))) {
      var x = this.Lcats_effect_unsafe_IORuntimeConfig__f_shutdownHookTimeout;
      var x$2 = $n(x$0$2).Lcats_effect_unsafe_IORuntimeConfig__f_shutdownHookTimeout;
      var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInterval;
      var x$4 = $n(x$0$2).Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInterval;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInitialDelay;
      var x$6 = $n(x$0$2).Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInitialDelay;
      return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.productArity__I = (function() {
  return 9;
});
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.productPrefix__T = (function() {
  return "IORuntimeConfig";
});
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold;
      break;
    }
    case 1: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold;
      break;
    }
    case 2: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions;
      break;
    }
    case 3: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferSize;
      break;
    }
    case 4: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_shutdownHookTimeout;
      break;
    }
    case 5: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_reportUnhandledFiberErrors;
      break;
    }
    case 6: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInterval;
      break;
    }
    case 7: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInitialDelay;
      break;
    }
    case 8: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckThreshold;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Lcats_effect_unsafe_IORuntimeConfig(obj) {
  return (((obj instanceof $c_Lcats_effect_unsafe_IORuntimeConfig) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.IORuntimeConfig"));
}
function $isArrayOf_Lcats_effect_unsafe_IORuntimeConfig(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_IORuntimeConfig)));
}
function $asArrayOf_Lcats_effect_unsafe_IORuntimeConfig(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_IORuntimeConfig(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.IORuntimeConfig;", depth));
}
var $d_Lcats_effect_unsafe_IORuntimeConfig = new $TypeData().initClass($c_Lcats_effect_unsafe_IORuntimeConfig, "cats.effect.unsafe.IORuntimeConfig", ({
  Lcats_effect_unsafe_IORuntimeConfig: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_IORuntimeConfig$() {
  this.Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__f_Default = null;
  $ct_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__(this);
}
$c_Lcats_effect_unsafe_IORuntimeConfig$.prototype = new $h_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform();
$c_Lcats_effect_unsafe_IORuntimeConfig$.prototype.constructor = $c_Lcats_effect_unsafe_IORuntimeConfig$;
/** @constructor */
function $h_Lcats_effect_unsafe_IORuntimeConfig$() {
}
$h_Lcats_effect_unsafe_IORuntimeConfig$.prototype = $c_Lcats_effect_unsafe_IORuntimeConfig$.prototype;
$c_Lcats_effect_unsafe_IORuntimeConfig$.prototype.toString__T = (function() {
  return "IORuntimeConfig";
});
$c_Lcats_effect_unsafe_IORuntimeConfig$.prototype.DefaultCpuStarvationCheckInterval__s_concurrent_duration_FiniteDuration = (function() {
  var this$2 = new $c_s_concurrent_duration_package$DurationInt(1);
  var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var this$ = this$2.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $m_s_concurrent_duration_Duration$();
  var hi = (this$ >> 31);
  return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(this$, hi), unit);
});
$c_Lcats_effect_unsafe_IORuntimeConfig$.prototype.DefaultCpuStarvationCheckInitialDelay__s_concurrent_duration_FiniteDuration = (function() {
  var this$2 = new $c_s_concurrent_duration_package$DurationInt(10);
  var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var this$ = this$2.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $m_s_concurrent_duration_Duration$();
  var hi = (this$ >> 31);
  return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(this$, hi), unit);
});
function $as_Lcats_effect_unsafe_IORuntimeConfig$(obj) {
  return (((obj instanceof $c_Lcats_effect_unsafe_IORuntimeConfig$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.IORuntimeConfig$"));
}
function $isArrayOf_Lcats_effect_unsafe_IORuntimeConfig$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_IORuntimeConfig$)));
}
function $asArrayOf_Lcats_effect_unsafe_IORuntimeConfig$(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_IORuntimeConfig$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.IORuntimeConfig$;", depth));
}
var $d_Lcats_effect_unsafe_IORuntimeConfig$ = new $TypeData().initClass($c_Lcats_effect_unsafe_IORuntimeConfig$, "cats.effect.unsafe.IORuntimeConfig$", ({
  Lcats_effect_unsafe_IORuntimeConfig$: 1,
  Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Lcats_effect_unsafe_IORuntimeConfig$;
function $m_Lcats_effect_unsafe_IORuntimeConfig$() {
  if ((!$n_Lcats_effect_unsafe_IORuntimeConfig$)) {
    $n_Lcats_effect_unsafe_IORuntimeConfig$ = new $c_Lcats_effect_unsafe_IORuntimeConfig$();
  }
  return $n_Lcats_effect_unsafe_IORuntimeConfig$;
}
/** @constructor */
function $c_Lcats_effect_unsafe_WeakBag$Entry(a, index, rq) {
  this.Lcats_effect_unsafe_ref_Reference__f_queue = null;
  this.Lcats_effect_unsafe_ref_Reference__f_weakRef = null;
  this.Lcats_effect_unsafe_ref_Reference__f_enqueued = false;
  this.Lcats_effect_unsafe_WeakBag$Entry__f_index = 0;
  this.Lcats_effect_unsafe_WeakBag$Entry__f_index = index;
  $ct_Lcats_effect_unsafe_ref_Reference__O__Lcats_effect_unsafe_ref_ReferenceQueue__(this, a, rq);
}
$c_Lcats_effect_unsafe_WeakBag$Entry.prototype = new $h_Lcats_effect_unsafe_ref_WeakReference();
$c_Lcats_effect_unsafe_WeakBag$Entry.prototype.constructor = $c_Lcats_effect_unsafe_WeakBag$Entry;
/** @constructor */
function $h_Lcats_effect_unsafe_WeakBag$Entry() {
}
$h_Lcats_effect_unsafe_WeakBag$Entry.prototype = $c_Lcats_effect_unsafe_WeakBag$Entry.prototype;
$c_Lcats_effect_unsafe_WeakBag$Entry.prototype.deregister__V = (function() {
  this.enqueue__Z();
});
function $as_Lcats_effect_unsafe_WeakBag$Entry(obj) {
  return (((obj instanceof $c_Lcats_effect_unsafe_WeakBag$Entry) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.WeakBag$Entry"));
}
function $isArrayOf_Lcats_effect_unsafe_WeakBag$Entry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_WeakBag$Entry)));
}
function $asArrayOf_Lcats_effect_unsafe_WeakBag$Entry(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_WeakBag$Entry(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.WeakBag$Entry;", depth));
}
var $d_Lcats_effect_unsafe_WeakBag$Entry = new $TypeData().initClass($c_Lcats_effect_unsafe_WeakBag$Entry, "cats.effect.unsafe.WeakBag$Entry", ({
  Lcats_effect_unsafe_WeakBag$Entry: 1,
  Lcats_effect_unsafe_ref_WeakReference: 1,
  Lcats_effect_unsafe_ref_Reference: 1,
  Lcats_effect_unsafe_WeakBag$Handle: 1
}));
/** @constructor */
function $c_Lcats_instances_EitherInstances$$anon$5(evidence$1$2) {
  this.Lcats_instances_EitherInstances$$anon$5__f_evidence$1$1 = null;
  this.Lcats_instances_EitherInstances$$anon$5__f_evidence$1$1 = evidence$1$2;
}
$c_Lcats_instances_EitherInstances$$anon$5.prototype = new $h_O();
$c_Lcats_instances_EitherInstances$$anon$5.prototype.constructor = $c_Lcats_instances_EitherInstances$$anon$5;
/** @constructor */
function $h_Lcats_instances_EitherInstances$$anon$5() {
}
$h_Lcats_instances_EitherInstances$$anon$5.prototype = $c_Lcats_instances_EitherInstances$$anon$5.prototype;
$c_Lcats_instances_EitherInstances$$anon$5.prototype.applicative__Lcats_Applicative = (function() {
  $m_Lcats_data_Validated$();
  var E = this.Lcats_instances_EitherInstances$$anon$5__f_evidence$1$1;
  return new $c_Lcats_data_ValidatedInstances$$anon$7(E);
});
$c_Lcats_instances_EitherInstances$$anon$5.prototype.sequential__Lcats_arrow_FunctionK = (function() {
  return new $c_Lcats_instances_EitherInstances$$anon$6();
});
$c_Lcats_instances_EitherInstances$$anon$5.prototype.parallel__Lcats_arrow_FunctionK = (function() {
  return new $c_Lcats_instances_EitherInstances$$anon$7();
});
var $d_Lcats_instances_EitherInstances$$anon$5 = new $TypeData().initClass($c_Lcats_instances_EitherInstances$$anon$5, "cats.instances.EitherInstances$$anon$5", ({
  Lcats_instances_EitherInstances$$anon$5: 1,
  Ljava_io_Serializable: 1,
  Lcats_NonEmptyParallel: 1,
  Lcats_Parallel: 1
}));
/** @constructor */
function $c_Lcats_instances_Function1Instances$$anon$7(outer) {
  this.Lcats_instances_Function1Instances$$anon$7__f_category = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  var instance = $n(outer).catsStdInstancesForFunction1__Lcats_arrow_ArrowChoice();
  this.Lcats_instances_Function1Instances$$anon$7__f_category = instance;
}
$c_Lcats_instances_Function1Instances$$anon$7.prototype = new $h_O();
$c_Lcats_instances_Function1Instances$$anon$7.prototype.constructor = $c_Lcats_instances_Function1Instances$$anon$7;
/** @constructor */
function $h_Lcats_instances_Function1Instances$$anon$7() {
}
$h_Lcats_instances_Function1Instances$$anon$7.prototype = $c_Lcats_instances_Function1Instances$$anon$7.prototype;
$c_Lcats_instances_Function1Instances$$anon$7.prototype.combineK__F1__F1__F1 = (function(x, y) {
  return $m_Lcats_data_AndThen$().apply__F1__Lcats_data_AndThen($as_F1($n(this.Lcats_instances_Function1Instances$$anon$7__f_category).compose__O__O__O(x, y)));
});
$c_Lcats_instances_Function1Instances$$anon$7.prototype.empty__O = (function() {
  return $as_F1($n(this.Lcats_instances_Function1Instances$$anon$7__f_category).id__O());
});
$c_Lcats_instances_Function1Instances$$anon$7.prototype.combineK__O__O__O = (function(x, y) {
  return this.combineK__F1__F1__F1($as_F1(x), $as_F1(y));
});
var $d_Lcats_instances_Function1Instances$$anon$7 = new $TypeData().initClass($c_Lcats_instances_Function1Instances$$anon$7, "cats.instances.Function1Instances$$anon$7", ({
  Lcats_instances_Function1Instances$$anon$7: 1,
  Ljava_io_Serializable: 1,
  Lcats_SemigroupK: 1,
  Lcats_MonoidK: 1
}));
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$5(fa$20, fb$8, outer) {
  this.Lcats_instances_InvariantMonoidalInstances$$anon$5__f_fa$15 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$5__f_fb$6 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$5__f_fa$15 = fa$20;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$5__f_fb$6 = fb$8;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$5.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$5.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$5;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$5() {
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$5.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$5.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$5.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  return $f_Lcats_kernel_Semigroup__combineAllOption__sc_IterableOnce__s_Option(this, as);
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$5.prototype.combine__T2__T2__T2 = (function(x, y) {
  var fa$3 = this.Lcats_instances_InvariantMonoidalInstances$$anon$5__f_fa$15;
  var fb$2 = this.Lcats_instances_InvariantMonoidalInstances$$anon$5__f_fb$6;
  var self = $n(fa$3).combine__O__O__O($n(x)._1__O(), $n(y)._1__O());
  var y$1 = $n(fb$2).combine__O__O__O($n(x)._2__O(), $n(y)._2__O());
  return new $c_T2(self, y$1);
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$5.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__T2__T2__T2($as_T2(x), $as_T2(y));
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$5 = new $TypeData().initClass($c_Lcats_instances_InvariantMonoidalInstances$$anon$5, "cats.instances.InvariantMonoidalInstances$$anon$5", ({
  Lcats_instances_InvariantMonoidalInstances$$anon$5: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_CommutativeSemigroup: 1
}));
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$6(f$13, fa$21, g$13, outer) {
  this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_f$10 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_fa$16 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_g$10 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_f$10 = f$13;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_fa$16 = fa$21;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_g$10 = g$13;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$6;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$6() {
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  return $f_Lcats_kernel_Semigroup__combineAllOption__sc_IterableOnce__s_Option(this, as);
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype.combine__O__O__O = (function(x, y) {
  var f$2 = this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_f$10;
  var fa$4 = this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_fa$16;
  var g$2 = this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_g$10;
  return $n(f$2).apply__O__O($n(fa$4).combine__O__O__O($n(g$2).apply__O__O(x), $n(g$2).apply__O__O(y)));
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$6 = new $TypeData().initClass($c_Lcats_instances_InvariantMonoidalInstances$$anon$6, "cats.instances.InvariantMonoidalInstances$$anon$6", ({
  Lcats_instances_InvariantMonoidalInstances$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_CommutativeSemigroup: 1
}));
function $f_Lcats_instances_LazyListInstances__$init$__V($thiz) {
  $thiz.cats$instances$LazyListInstances$_setter_$catsStdInstancesForLazyList_$eq__Lcats_Align__V(new $c_Lcats_instances_LazyListInstances$$anon$1());
  $thiz.cats$instances$LazyListInstances$_setter_$catsStdTraverseFilterForLazyList_$eq__Lcats_TraverseFilter__V(new $c_Lcats_instances_LazyListInstances$$anon$3($thiz));
}
function $ps_Lcats_instances_LazyListInstances__step$1__Lcats_Monad__F2__T2__O(G$3, f$8, in$1) {
  matchResult5: {
    var \u03b41$___1;
    var \u03b41$___2;
    if ((in$1 !== null)) {
      var s = $as_sci_LazyList($n(in$1)._1__O());
      var b = $n(in$1)._2__O();
      var \u03b41$___1 = s;
      var \u03b41$___2 = b;
      break matchResult5;
    }
    throw new $c_s_MatchError(in$1);
  }
  var s$2 = $as_sci_LazyList(\u03b41$___1);
  var b$2 = \u03b41$___2;
  if ($n(s$2).isEmpty__Z()) {
    return $n(G$3).pure__O__O(new $c_s_util_Right(b$2));
  } else {
    var $x_1 = $n(G$3);
    var this$3 = $n(s$2);
    return $n($x_1).map__O__F1__O($n(f$8).apply__O__O__O(b$2, $n(this$3.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O()), new $c_sjsr_AnonFunction1(((bnext) => {
      var this$4 = $n(s$2);
      var _1 = $n(this$4.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
      var value = new $c_T2(_1, bnext);
      return new $c_s_util_Left(value);
    })));
  }
}
/** @constructor */
function $c_Lcats_instances_LazyListInstances$$anon$3(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $as_Lcats_Traverse($n(outer).catsStdInstancesForLazyList__Lcats_Align());
}
$c_Lcats_instances_LazyListInstances$$anon$3.prototype = new $h_O();
$c_Lcats_instances_LazyListInstances$$anon$3.prototype.constructor = $c_Lcats_instances_LazyListInstances$$anon$3;
/** @constructor */
function $h_Lcats_instances_LazyListInstances$$anon$3() {
}
$h_Lcats_instances_LazyListInstances$$anon$3.prototype = $c_Lcats_instances_LazyListInstances$$anon$3.prototype;
var $d_Lcats_instances_LazyListInstances$$anon$3 = new $TypeData().initClass($c_Lcats_instances_LazyListInstances$$anon$3, "cats.instances.LazyListInstances$$anon$3", ({
  Lcats_instances_LazyListInstances$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
}));
function $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$go$1__scm_Builder__F1__sci_List__V(buf$1, f$4, lists) {
  var lists$tailLocal1 = lists;
  while (true) {
    matchResult2: {
      var x6 = lists$tailLocal1;
      if ((x6 instanceof $c_sci_$colon$colon)) {
        var x10 = $as_sci_$colon$colon(x6);
        var x11 = $as_sci_List($n(x10).sci_$colon$colon__f_head);
        var x12 = $n(x10).sci_$colon$colon__f_next;
        if ((x11 instanceof $c_sci_$colon$colon)) {
          var x13 = $as_sci_$colon$colon(x11);
          var x15 = $n(x13).sci_$colon$colon__f_next;
          var ab = $as_s_util_Either($n(x13).sci_$colon$colon__f_head);
          if ((ab instanceof $c_s_util_Right)) {
            var b = $n($as_s_util_Right(ab)).s_util_Right__f_value;
            var this$1 = $n(buf$1);
            this$1.addOne__O__scm_Growable(b);
            var this$2 = $n(x12);
            lists$tailLocal1 = new $c_sci_$colon$colon(x15, this$2);
            continue;
          }
          if ((ab instanceof $c_s_util_Left)) {
            var a = $n($as_s_util_Left(ab)).s_util_Left__f_value;
            var elem$1 = $as_sci_List($n(f$4).apply__O__O(a));
            var this$3 = $n(x12);
            var this$4 = new $c_sci_$colon$colon(x15, this$3);
            lists$tailLocal1 = new $c_sci_$colon$colon(elem$1, this$4);
            continue;
          }
          throw new $c_s_MatchError(ab);
          break matchResult2;
        }
        var x = $m_sci_Nil$();
        if (x.equals__O__Z(x11)) {
          lists$tailLocal1 = x12;
          continue;
        }
      }
      var x$3 = $m_sci_Nil$();
      if (x$3.equals__O__Z(x6)) {
        break matchResult2;
      }
      throw new $c_s_MatchError(x6);
    }
    return (void 0);
  }
}
function $ps_Lcats_instances_ListInstances__loop$2__Lcats_Eval__F2__sci_List__Lcats_Eval(lb$1, f$6, as) {
  var x = $m_sci_Nil$();
  if (x.equals__O__Z(as)) {
    return lb$1;
  }
  if ((as instanceof $c_sci_$colon$colon)) {
    var x21 = $as_sci_$colon$colon(as);
    var x23 = $n(x21).sci_$colon$colon__f_next;
    var h = $n(x21).sci_$colon$colon__f_head;
    var this$1 = $m_Lcats_Eval$();
    var a = new $c_sjsr_AnonFunction0((() => $ps_Lcats_instances_ListInstances__loop$2__Lcats_Eval__F2__sci_List__Lcats_Eval(lb$1, f$6, x23)));
    return $as_Lcats_Eval($n(f$6).apply__O__O__O(h, new $c_Lcats_Eval$$anon$5(a, this$1)));
  }
  throw new $c_s_MatchError(as);
}
function $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__F1__I__sci_List__Lcats_Eval(G$4, f$12, size, fa) {
  if ((size > 1)) {
    var leftSize = ((size / 2) | 0);
    var rightSize = ((size - leftSize) | 0);
    matchResult7: {
      var \u03b41$___1;
      var \u03b41$___2;
      var x30 = $n(fa).splitAt__I__T2(leftSize);
      if ((x30 !== null)) {
        var leftL = $as_sci_List($n(x30)._1__O());
        var rightL = $as_sci_List($n(x30)._2__O());
        var \u03b41$___1 = leftL;
        var \u03b41$___2 = rightL;
        break matchResult7;
      }
      throw new $c_s_MatchError(x30);
    }
    var leftL$2 = $as_sci_List(\u03b41$___1);
    var rightL$2 = $as_sci_List(\u03b41$___2);
    return $n($s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__F1__I__sci_List__Lcats_Eval(G$4, f$12, leftSize, leftL$2)).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((left) => {
      var right = $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__F1__I__sci_List__Lcats_Eval(G$4, f$12, rightSize, rightL$2);
      return $n(G$4).map2Eval__O__Lcats_Eval__F2__Lcats_Eval(left, right, new $c_sjsr_AnonFunction2(((_$6, _$7) => {
        $as_jl_Void(_$6);
        $as_jl_Void(_$7);
      })));
    })));
  } else {
    var a = $n(fa).head__O();
    $m_Lcats_Eval$();
    var a$1 = new $c_sjsr_AnonFunction0((() => {
      var gb = $n(f$12).apply__O__O(a);
      return $n(G$4).void__O__O(gb);
    }));
    return new $c_Lcats_Always(a$1);
  }
}
function $ps_Lcats_instances_ListInstances__step$1__Lcats_Monad__F2__T2__O(G$6, f$18, in$1) {
  if ((in$1 !== null)) {
    var x65 = $as_sci_List($n(in$1)._1__O());
    var x66 = $n(in$1)._2__O();
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x65)) {
      return $n(G$6).pure__O__O(new $c_s_util_Right(x66));
    }
    if ((x65 instanceof $c_sci_$colon$colon)) {
      var x62 = $as_sci_$colon$colon(x65);
      var x64 = $n(x62).sci_$colon$colon__f_next;
      var a = $n(x62).sci_$colon$colon__f_head;
      return $n(G$6).map__O__F1__O($n(f$18).apply__O__O__O(x66, a), new $c_sjsr_AnonFunction1(((bnext) => {
        var value = new $c_T2(x64, bnext);
        return new $c_s_util_Left(value);
      })));
    }
  }
  throw new $c_s_MatchError(in$1);
}
function $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$build$1__sci_List__sci_List__sci_List(fa, acc) {
  var acc$tailLocal1 = acc;
  var fa$tailLocal2 = fa;
  while (true) {
    if ($n(fa$tailLocal2).isEmpty__Z()) {
      return acc$tailLocal1;
    } else {
      var fa$tailLocal2$tmp1 = $as_sci_List($n(fa$tailLocal2).tail__O());
      var this$1 = $n(acc$tailLocal1);
      var acc$tailLocal1$tmp1 = new $c_sci_$colon$colon((void 0), this$1);
      fa$tailLocal2 = fa$tailLocal2$tmp1;
      acc$tailLocal1 = acc$tailLocal1$tmp1;
    }
  }
}
/** @constructor */
function $c_Lcats_instances_ListInstancesBinCompat0$$anon$6() {
  $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
}
$c_Lcats_instances_ListInstancesBinCompat0$$anon$6.prototype = new $h_O();
$c_Lcats_instances_ListInstancesBinCompat0$$anon$6.prototype.constructor = $c_Lcats_instances_ListInstancesBinCompat0$$anon$6;
/** @constructor */
function $h_Lcats_instances_ListInstancesBinCompat0$$anon$6() {
}
$h_Lcats_instances_ListInstancesBinCompat0$$anon$6.prototype = $c_Lcats_instances_ListInstancesBinCompat0$$anon$6.prototype;
var $d_Lcats_instances_ListInstancesBinCompat0$$anon$6 = new $TypeData().initClass($c_Lcats_instances_ListInstancesBinCompat0$$anon$6, "cats.instances.ListInstancesBinCompat0$$anon$6", ({
  Lcats_instances_ListInstancesBinCompat0$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
}));
/** @constructor */
function $c_Lcats_instances_OptionInstancesBinCompat0$$anon$3() {
  $as_Lcats_Traverse($m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption);
}
$c_Lcats_instances_OptionInstancesBinCompat0$$anon$3.prototype = new $h_O();
$c_Lcats_instances_OptionInstancesBinCompat0$$anon$3.prototype.constructor = $c_Lcats_instances_OptionInstancesBinCompat0$$anon$3;
/** @constructor */
function $h_Lcats_instances_OptionInstancesBinCompat0$$anon$3() {
}
$h_Lcats_instances_OptionInstancesBinCompat0$$anon$3.prototype = $c_Lcats_instances_OptionInstancesBinCompat0$$anon$3.prototype;
var $d_Lcats_instances_OptionInstancesBinCompat0$$anon$3 = new $TypeData().initClass($c_Lcats_instances_OptionInstancesBinCompat0$$anon$3, "cats.instances.OptionInstancesBinCompat0$$anon$3", ({
  Lcats_instances_OptionInstancesBinCompat0$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
}));
/** @constructor */
function $c_Lcats_instances_PartialOrderInstances$$anon$2(fa$6, fb$3, outer) {
  this.Lcats_instances_PartialOrderInstances$$anon$2__f_fa$4 = null;
  this.Lcats_instances_PartialOrderInstances$$anon$2__f_fb$2 = null;
  this.Lcats_instances_PartialOrderInstances$$anon$2__f_fa$4 = fa$6;
  this.Lcats_instances_PartialOrderInstances$$anon$2__f_fb$2 = fb$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.constructor = $c_Lcats_instances_PartialOrderInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_PartialOrderInstances$$anon$2() {
}
$h_Lcats_instances_PartialOrderInstances$$anon$2.prototype = $c_Lcats_instances_PartialOrderInstances$$anon$2.prototype;
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.eqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_PartialOrder__eqv__O__O__Z(this, x, y);
});
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.partialCompare__T2__T2__D = (function(x, y) {
  var fa$1 = this.Lcats_instances_PartialOrderInstances$$anon$2__f_fa$4;
  var fb$1 = this.Lcats_instances_PartialOrderInstances$$anon$2__f_fb$2;
  var z = $n(fa$1).partialCompare__O__O__D($n(x)._1__O(), $n(y)._1__O());
  return ((z === 0.0) ? $n(fb$1).partialCompare__O__O__D($n(x)._2__O(), $n(y)._2__O()) : z);
});
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.partialCompare__O__O__D = (function(x, y) {
  return this.partialCompare__T2__T2__D($as_T2(x), $as_T2(y));
});
var $d_Lcats_instances_PartialOrderInstances$$anon$2 = new $TypeData().initClass($c_Lcats_instances_PartialOrderInstances$$anon$2, "cats.instances.PartialOrderInstances$$anon$2", ({
  Lcats_instances_PartialOrderInstances$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1
}));
/** @constructor */
function $c_Lcats_instances_PartialOrderingInstances$$anon$2(fa$5, f$2) {
}
$c_Lcats_instances_PartialOrderingInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_PartialOrderingInstances$$anon$2.prototype.constructor = $c_Lcats_instances_PartialOrderingInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_PartialOrderingInstances$$anon$2() {
}
$h_Lcats_instances_PartialOrderingInstances$$anon$2.prototype = $c_Lcats_instances_PartialOrderingInstances$$anon$2.prototype;
var $d_Lcats_instances_PartialOrderingInstances$$anon$2 = new $TypeData().initClass($c_Lcats_instances_PartialOrderingInstances$$anon$2, "cats.instances.PartialOrderingInstances$$anon$2", ({
  Lcats_instances_PartialOrderingInstances$$anon$2: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1,
  s_math_PartialOrdering: 1
}));
/** @constructor */
function $c_Lcats_instances_PartialOrderingInstances$$anon$3(fa$6, fb$2) {
}
$c_Lcats_instances_PartialOrderingInstances$$anon$3.prototype = new $h_O();
$c_Lcats_instances_PartialOrderingInstances$$anon$3.prototype.constructor = $c_Lcats_instances_PartialOrderingInstances$$anon$3;
/** @constructor */
function $h_Lcats_instances_PartialOrderingInstances$$anon$3() {
}
$h_Lcats_instances_PartialOrderingInstances$$anon$3.prototype = $c_Lcats_instances_PartialOrderingInstances$$anon$3.prototype;
var $d_Lcats_instances_PartialOrderingInstances$$anon$3 = new $TypeData().initClass($c_Lcats_instances_PartialOrderingInstances$$anon$3, "cats.instances.PartialOrderingInstances$$anon$3", ({
  Lcats_instances_PartialOrderingInstances$$anon$3: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1,
  s_math_PartialOrdering: 1
}));
function $f_Lcats_instances_SeqInstances__$init$__V($thiz) {
  $thiz.cats$instances$SeqInstances$_setter_$catsStdInstancesForSeq_$eq__Lcats_Align__V(new $c_Lcats_instances_SeqInstances$$anon$1());
  $thiz.cats$instances$SeqInstances$_setter_$catsStdTraverseFilterForSeq_$eq__Lcats_TraverseFilter__V(new $c_Lcats_instances_SeqInstances$$anon$2());
}
/** @constructor */
function $c_Lcats_instances_SeqInstances$$anon$2() {
  $as_Lcats_Traverse($m_Lcats_instances_package$seq$().Lcats_instances_package$seq$__f_catsStdInstancesForSeq);
}
$c_Lcats_instances_SeqInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_SeqInstances$$anon$2.prototype.constructor = $c_Lcats_instances_SeqInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_SeqInstances$$anon$2() {
}
$h_Lcats_instances_SeqInstances$$anon$2.prototype = $c_Lcats_instances_SeqInstances$$anon$2.prototype;
var $d_Lcats_instances_SeqInstances$$anon$2 = new $TypeData().initClass($c_Lcats_instances_SeqInstances$$anon$2, "cats.instances.SeqInstances$$anon$2", ({
  Lcats_instances_SeqInstances$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
}));
function $ps_Lcats_instances_StreamInstances__step$1__Lcats_Monad__F2__T2__O(G$3, f$8, in$1) {
  matchResult5: {
    var \u03b41$___1;
    var \u03b41$___2;
    if ((in$1 !== null)) {
      var s = $as_sci_Stream($n(in$1)._1__O());
      var b = $n(in$1)._2__O();
      var \u03b41$___1 = s;
      var \u03b41$___2 = b;
      break matchResult5;
    }
    throw new $c_s_MatchError(in$1);
  }
  var s$2 = $as_sci_Stream(\u03b41$___1);
  var b$2 = \u03b41$___2;
  return ($n(s$2).isEmpty__Z() ? $n(G$3).pure__O__O(new $c_s_util_Right(b$2)) : $n(G$3).map__O__F1__O($n(f$8).apply__O__O__O(b$2, $n(s$2).head__O()), new $c_sjsr_AnonFunction1(((bnext) => {
    var _1 = $n(s$2).tail__sci_Stream();
    var value = new $c_T2(_1, bnext);
    return new $c_s_util_Left(value);
  }))));
}
/** @constructor */
function $c_Lcats_instances_StreamInstances$$anon$2(fn$1, a$2) {
  this.Lcats_instances_StreamInstances$$anon$2__f_fn$2 = null;
  this.Lcats_instances_StreamInstances$$anon$2__f_stack = null;
  this.Lcats_instances_StreamInstances$$anon$2__f_state = null;
  this.Lcats_instances_StreamInstances$$anon$2__f_fn$2 = fn$1;
  this.Lcats_instances_StreamInstances$$anon$2__f_stack = $as_sci_Stream($n(fn$1).apply__O__O(a$2));
  this.Lcats_instances_StreamInstances$$anon$2__f_state = new $c_s_util_Left((void 0));
}
$c_Lcats_instances_StreamInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_StreamInstances$$anon$2.prototype.constructor = $c_Lcats_instances_StreamInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_StreamInstances$$anon$2() {
}
$h_Lcats_instances_StreamInstances$$anon$2.prototype = $c_Lcats_instances_StreamInstances$$anon$2.prototype;
$c_Lcats_instances_StreamInstances$$anon$2.prototype.knownSize__I = (function() {
  return (-1);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.iterator__sc_Iterator = (function() {
  return this;
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z());
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.toString__T = (function() {
  return "<iterator>";
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.advance__V = (function() {
  while (true) {
    matchResult1: {
      var x1 = this.Lcats_instances_StreamInstances$$anon$2__f_stack;
      if ((x1 !== null)) {
        var x8 = $m_s_package$$hash$colon$colon$().unapply__sci_Stream__s_Option(x1);
        if ((!$n(x8).isEmpty__Z())) {
          var x9 = $as_T2($n(x8).get__O());
          var x10 = $as_s_util_Either($n(x9)._1__O());
          var x11 = $as_sci_Stream($n(x9)._2__O());
          if ((x10 instanceof $c_s_util_Right)) {
            var b = $n($as_s_util_Right(x10)).s_util_Right__f_value;
            this.Lcats_instances_StreamInstances$$anon$2__f_stack = x11;
            var value = new $c_s_Some(b);
            this.Lcats_instances_StreamInstances$$anon$2__f_state = new $c_s_util_Right(value);
            break matchResult1;
          }
          if ((x10 instanceof $c_s_util_Left)) {
            var a = $n($as_s_util_Left(x10)).s_util_Left__f_value;
            var prefix$1 = $as_sci_Stream($n(this.Lcats_instances_StreamInstances$$anon$2__f_fn$2).apply__O__O(a));
            var l = new $c_sjsr_AnonFunction0(((x11) => (() => x11))(x11));
            this.Lcats_instances_StreamInstances$$anon$2__f_stack = $n(prefix$1).lazyAppendedAll__F0__sci_Stream(l);
            continue;
          }
        }
      }
      var value$1 = $m_s_None$();
      this.Lcats_instances_StreamInstances$$anon$2__f_state = new $c_s_util_Right(value$1);
    }
    return (void 0);
  }
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.hasNext__Z = (function() {
  while (true) {
    var x14 = this.Lcats_instances_StreamInstances$$anon$2__f_state;
    if ((x14 instanceof $c_s_util_Left)) {
      var x$2 = $n($as_s_util_Left(x14)).s_util_Left__f_value;
      var $x_1 = (x$2 === (void 0));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      this.advance__V();
      continue;
    }
    if ((x14 instanceof $c_s_util_Right)) {
      var o = $as_s_Option($n($as_s_util_Right(x14)).s_util_Right__f_value);
      var this$1 = $n(o);
      return (!this$1.isEmpty__Z());
    }
    throw new $c_s_MatchError(x14);
  }
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.next__O = (function() {
  while (true) {
    var x19 = this.Lcats_instances_StreamInstances$$anon$2__f_state;
    if ((x19 instanceof $c_s_util_Left)) {
      var x$2 = $n($as_s_util_Left(x19)).s_util_Left__f_value;
      var $x_1 = (x$2 === (void 0));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      this.advance__V();
      continue;
    }
    if ((x19 instanceof $c_s_util_Right)) {
      var o = $as_s_Option($n($as_s_util_Right(x19)).s_util_Right__f_value);
      var b = $n(o).get__O();
      this.advance__V();
      return b;
    }
    throw new $c_s_MatchError(x19);
  }
});
var $d_Lcats_instances_StreamInstances$$anon$2 = new $TypeData().initClass($c_Lcats_instances_StreamInstances$$anon$2, "cats.instances.StreamInstances$$anon$2", ({
  Lcats_instances_StreamInstances$$anon$2: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
}));
/** @constructor */
function $c_Lcats_instances_StreamInstancesBinCompat0$$anon$7() {
  $as_Lcats_Traverse($m_Lcats_instances_package$stream$().Lcats_instances_package$stream$__f_catsStdInstancesForStream);
}
$c_Lcats_instances_StreamInstancesBinCompat0$$anon$7.prototype = new $h_O();
$c_Lcats_instances_StreamInstancesBinCompat0$$anon$7.prototype.constructor = $c_Lcats_instances_StreamInstancesBinCompat0$$anon$7;
/** @constructor */
function $h_Lcats_instances_StreamInstancesBinCompat0$$anon$7() {
}
$h_Lcats_instances_StreamInstancesBinCompat0$$anon$7.prototype = $c_Lcats_instances_StreamInstancesBinCompat0$$anon$7.prototype;
var $d_Lcats_instances_StreamInstancesBinCompat0$$anon$7 = new $TypeData().initClass($c_Lcats_instances_StreamInstancesBinCompat0$$anon$7, "cats.instances.StreamInstancesBinCompat0$$anon$7", ({
  Lcats_instances_StreamInstancesBinCompat0$$anon$7: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
}));
function $ps_Lcats_instances_VectorInstances__loop$2__sci_Vector__F2__Lcats_Eval__I__Lcats_Eval(fa$2, f$5, lb$1, i) {
  if ((i < $n(fa$2).length__I())) {
    var $x_1 = $n(fa$2).apply__I__O(i);
    var this$1 = $m_Lcats_Eval$();
    var a = new $c_sjsr_AnonFunction0((() => $ps_Lcats_instances_VectorInstances__loop$2__sci_Vector__F2__Lcats_Eval__I__Lcats_Eval(fa$2, f$5, lb$1, ((1 + i) | 0))));
    return $as_Lcats_Eval($n(f$5).apply__O__O__O($x_1, new $c_Lcats_Eval$$anon$5(a, this$1)));
  } else {
    return lb$1;
  }
}
function $s_Lcats_instances_VectorInstances__cats$instances$VectorInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__sci_Vector__F1__I__I__Lcats_Eval(G$4, fa$7, f$10, size, idx) {
  if ((size > 1)) {
    var leftSize = ((size / 2) | 0);
    var rightSize = ((size - leftSize) | 0);
    return $n($s_Lcats_instances_VectorInstances__cats$instances$VectorInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__sci_Vector__F1__I__I__Lcats_Eval(G$4, fa$7, f$10, leftSize, idx)).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((left) => {
      var right = $s_Lcats_instances_VectorInstances__cats$instances$VectorInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__sci_Vector__F1__I__I__Lcats_Eval(G$4, fa$7, f$10, rightSize, ((idx + leftSize) | 0));
      return $n(G$4).map2Eval__O__Lcats_Eval__F2__Lcats_Eval(left, right, new $c_sjsr_AnonFunction2(((_$6, _$7) => {
        $as_jl_Void(_$6);
        $as_jl_Void(_$7);
      })));
    })));
  } else {
    var a = $n(fa$7).apply__I__O(idx);
    $m_Lcats_Eval$();
    var a$1 = new $c_sjsr_AnonFunction0((() => {
      var gb = $n(f$10).apply__O__O(a);
      return $n(G$4).void__O__O(gb);
    }));
    return new $c_Lcats_Always(a$1);
  }
}
/** @constructor */
function $c_Lcats_instances_VectorInstancesBinCompat0$$anon$6() {
  $as_Lcats_Traverse($m_Lcats_instances_package$vector$().Lcats_instances_package$vector$__f_catsStdInstancesForVector);
}
$c_Lcats_instances_VectorInstancesBinCompat0$$anon$6.prototype = new $h_O();
$c_Lcats_instances_VectorInstancesBinCompat0$$anon$6.prototype.constructor = $c_Lcats_instances_VectorInstancesBinCompat0$$anon$6;
/** @constructor */
function $h_Lcats_instances_VectorInstancesBinCompat0$$anon$6() {
}
$h_Lcats_instances_VectorInstancesBinCompat0$$anon$6.prototype = $c_Lcats_instances_VectorInstancesBinCompat0$$anon$6.prototype;
var $d_Lcats_instances_VectorInstancesBinCompat0$$anon$6 = new $TypeData().initClass($c_Lcats_instances_VectorInstancesBinCompat0$$anon$6, "cats.instances.VectorInstancesBinCompat0$$anon$6", ({
  Lcats_instances_VectorInstancesBinCompat0$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
}));
/** @constructor */
function $c_Lcats_instances_package$eq$() {
  this.Lcats_instances_package$eq$__f_catsContravariantMonoidalForEq = null;
  $n_Lcats_instances_package$eq$ = this;
  this.Lcats_instances_package$eq$__f_catsContravariantMonoidalForEq = new $c_Lcats_instances_EqInstances$$anon$1();
}
$c_Lcats_instances_package$eq$.prototype = new $h_O();
$c_Lcats_instances_package$eq$.prototype.constructor = $c_Lcats_instances_package$eq$;
/** @constructor */
function $h_Lcats_instances_package$eq$() {
}
$h_Lcats_instances_package$eq$.prototype = $c_Lcats_instances_package$eq$.prototype;
var $d_Lcats_instances_package$eq$ = new $TypeData().initClass($c_Lcats_instances_package$eq$, "cats.instances.package$eq$", ({
  Lcats_instances_package$eq$: 1,
  Lcats_kernel_EqToEquivConversion: 1,
  Lcats_kernel_instances_EqInstances: 1,
  Lcats_instances_EqInstances: 1
}));
var $n_Lcats_instances_package$eq$;
function $m_Lcats_instances_package$eq$() {
  if ((!$n_Lcats_instances_package$eq$)) {
    $n_Lcats_instances_package$eq$ = new $c_Lcats_instances_package$eq$();
  }
  return $n_Lcats_instances_package$eq$;
}
/** @constructor */
function $c_Lcats_instances_package$invariant$() {
  this.Lcats_instances_package$invariant$__f_catsInvariantMonoidalSemigroup = null;
  this.Lcats_instances_package$invariant$__f_catsInvariantMonoidalCommutativeSemigroup = null;
  $n_Lcats_instances_package$invariant$ = this;
  $f_Lcats_instances_InvariantMonoidalInstances__$init$__V(this);
  $f_Lcats_instances_InvariantInstances__$init$__V(this);
}
$c_Lcats_instances_package$invariant$.prototype = new $h_O();
$c_Lcats_instances_package$invariant$.prototype.constructor = $c_Lcats_instances_package$invariant$;
/** @constructor */
function $h_Lcats_instances_package$invariant$() {
}
$h_Lcats_instances_package$invariant$.prototype = $c_Lcats_instances_package$invariant$.prototype;
$c_Lcats_instances_package$invariant$.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
  this.Lcats_instances_package$invariant$__f_catsInvariantMonoidalSemigroup = x$0;
});
$c_Lcats_instances_package$invariant$.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalCommutativeSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
  this.Lcats_instances_package$invariant$__f_catsInvariantMonoidalCommutativeSemigroup = x$0;
});
$c_Lcats_instances_package$invariant$.prototype.cats$instances$InvariantInstances$_setter_$catsInvariantForNumeric_$eq__Lcats_Invariant__V = (function(x$0) {
});
$c_Lcats_instances_package$invariant$.prototype.cats$instances$InvariantInstances$_setter_$catsInvariantForIntegral_$eq__Lcats_Invariant__V = (function(x$0) {
});
var $d_Lcats_instances_package$invariant$ = new $TypeData().initClass($c_Lcats_instances_package$invariant$, "cats.instances.package$invariant$", ({
  Lcats_instances_package$invariant$: 1,
  Lcats_instances_InvariantMonoidalInstances: 1,
  Lcats_instances_InvariantInstances: 1,
  Lcats_instances_InvariantInstancesBinCompat0: 1
}));
var $n_Lcats_instances_package$invariant$;
function $m_Lcats_instances_package$invariant$() {
  if ((!$n_Lcats_instances_package$invariant$)) {
    $n_Lcats_instances_package$invariant$ = new $c_Lcats_instances_package$invariant$();
  }
  return $n_Lcats_instances_package$invariant$;
}
/** @constructor */
function $c_Lcats_instances_package$order$() {
  this.Lcats_instances_package$order$__f_catsContravariantMonoidalForOrder = null;
  $n_Lcats_instances_package$order$ = this;
  this.Lcats_instances_package$order$__f_catsContravariantMonoidalForOrder = new $c_Lcats_instances_OrderInstances$$anon$1();
}
$c_Lcats_instances_package$order$.prototype = new $h_O();
$c_Lcats_instances_package$order$.prototype.constructor = $c_Lcats_instances_package$order$;
/** @constructor */
function $h_Lcats_instances_package$order$() {
}
$h_Lcats_instances_package$order$.prototype = $c_Lcats_instances_package$order$.prototype;
var $d_Lcats_instances_package$order$ = new $TypeData().initClass($c_Lcats_instances_package$order$, "cats.instances.package$order$", ({
  Lcats_instances_package$order$: 1,
  Lcats_kernel_OrderToOrderingConversion: 1,
  Lcats_kernel_instances_OrderInstances: 1,
  Lcats_instances_OrderInstances: 1
}));
var $n_Lcats_instances_package$order$;
function $m_Lcats_instances_package$order$() {
  if ((!$n_Lcats_instances_package$order$)) {
    $n_Lcats_instances_package$order$ = new $c_Lcats_instances_package$order$();
  }
  return $n_Lcats_instances_package$order$;
}
/** @constructor */
function $c_Lcats_instances_package$partialOrder$() {
  this.Lcats_instances_package$partialOrder$__f_catsContravariantMonoidalForPartialOrder = null;
  $n_Lcats_instances_package$partialOrder$ = this;
  this.Lcats_instances_package$partialOrder$__f_catsContravariantMonoidalForPartialOrder = new $c_Lcats_instances_PartialOrderInstances$$anon$1();
}
$c_Lcats_instances_package$partialOrder$.prototype = new $h_O();
$c_Lcats_instances_package$partialOrder$.prototype.constructor = $c_Lcats_instances_package$partialOrder$;
/** @constructor */
function $h_Lcats_instances_package$partialOrder$() {
}
$h_Lcats_instances_package$partialOrder$.prototype = $c_Lcats_instances_package$partialOrder$.prototype;
var $d_Lcats_instances_package$partialOrder$ = new $TypeData().initClass($c_Lcats_instances_package$partialOrder$, "cats.instances.package$partialOrder$", ({
  Lcats_instances_package$partialOrder$: 1,
  Lcats_kernel_PartialOrderToPartialOrderingConversion: 1,
  Lcats_kernel_instances_PartialOrderInstances: 1,
  Lcats_instances_PartialOrderInstances: 1
}));
var $n_Lcats_instances_package$partialOrder$;
function $m_Lcats_instances_package$partialOrder$() {
  if ((!$n_Lcats_instances_package$partialOrder$)) {
    $n_Lcats_instances_package$partialOrder$ = new $c_Lcats_instances_package$partialOrder$();
  }
  return $n_Lcats_instances_package$partialOrder$;
}
/** @constructor */
function $c_Lcats_kernel_Hash$$anon$3(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_kernel_Hash$$anon$3.prototype = new $h_O();
$c_Lcats_kernel_Hash$$anon$3.prototype.constructor = $c_Lcats_kernel_Hash$$anon$3;
/** @constructor */
function $h_Lcats_kernel_Hash$$anon$3() {
}
$h_Lcats_kernel_Hash$$anon$3.prototype = $c_Lcats_kernel_Hash$$anon$3.prototype;
$c_Lcats_kernel_Hash$$anon$3.prototype.hash__O__I = (function(x) {
  return $dp_hashCode__I($n(x));
});
$c_Lcats_kernel_Hash$$anon$3.prototype.eqv__O__O__Z = (function(x, y) {
  return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
});
var $d_Lcats_kernel_Hash$$anon$3 = new $TypeData().initClass($c_Lcats_kernel_Hash$$anon$3, "cats.kernel.Hash$$anon$3", ({
  Lcats_kernel_Hash$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_Hash: 1
}));
function $f_Lcats_kernel_Order__partialCompare__O__O__D($thiz, x, y) {
  return $thiz.compare__O__O__I(x, y);
}
function $f_Lcats_kernel_Order__max__O__O__O($thiz, x, y) {
  return ($thiz.gt__O__O__Z(x, y) ? x : y);
}
function $f_Lcats_kernel_Order__eqv__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) === 0);
}
function $f_Lcats_kernel_Order__gt__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) > 0);
}
function $is_Lcats_kernel_Order(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_Order)));
}
function $as_Lcats_kernel_Order(obj) {
  return (($is_Lcats_kernel_Order(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.Order"));
}
function $isArrayOf_Lcats_kernel_Order(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_Order)));
}
function $asArrayOf_Lcats_kernel_Order(obj, depth) {
  return (($isArrayOf_Lcats_kernel_Order(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.Order;", depth));
}
/** @constructor */
function $c_Lcats_kernel_PartialOrder$() {
}
$c_Lcats_kernel_PartialOrder$.prototype = new $h_Lcats_kernel_PartialOrderFunctions();
$c_Lcats_kernel_PartialOrder$.prototype.constructor = $c_Lcats_kernel_PartialOrder$;
/** @constructor */
function $h_Lcats_kernel_PartialOrder$() {
}
$h_Lcats_kernel_PartialOrder$.prototype = $c_Lcats_kernel_PartialOrder$.prototype;
var $d_Lcats_kernel_PartialOrder$ = new $TypeData().initClass($c_Lcats_kernel_PartialOrder$, "cats.kernel.PartialOrder$", ({
  Lcats_kernel_PartialOrder$: 1,
  Lcats_kernel_PartialOrderFunctions: 1,
  Lcats_kernel_EqFunctions: 1,
  Lcats_kernel_PartialOrderToPartialOrderingConversion: 1
}));
var $n_Lcats_kernel_PartialOrder$;
function $m_Lcats_kernel_PartialOrder$() {
  if ((!$n_Lcats_kernel_PartialOrder$)) {
    $n_Lcats_kernel_PartialOrder$ = new $c_Lcats_kernel_PartialOrder$();
  }
  return $n_Lcats_kernel_PartialOrder$;
}
/** @constructor */
function $c_Lcats_kernel_PartialOrder$$anon$1(ev$7, f$5, outer) {
  this.Lcats_kernel_PartialOrder$$anon$1__f_ev$4 = null;
  this.Lcats_kernel_PartialOrder$$anon$1__f_f$3 = null;
  this.Lcats_kernel_PartialOrder$$anon$1__f_ev$4 = ev$7;
  this.Lcats_kernel_PartialOrder$$anon$1__f_f$3 = f$5;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_kernel_PartialOrder$$anon$1.prototype = new $h_O();
$c_Lcats_kernel_PartialOrder$$anon$1.prototype.constructor = $c_Lcats_kernel_PartialOrder$$anon$1;
/** @constructor */
function $h_Lcats_kernel_PartialOrder$$anon$1() {
}
$h_Lcats_kernel_PartialOrder$$anon$1.prototype = $c_Lcats_kernel_PartialOrder$$anon$1.prototype;
$c_Lcats_kernel_PartialOrder$$anon$1.prototype.eqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_PartialOrder__eqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_PartialOrder$$anon$1.prototype.partialCompare__O__O__D = (function(x, y) {
  var ev$1 = this.Lcats_kernel_PartialOrder$$anon$1__f_ev$4;
  var f$1 = this.Lcats_kernel_PartialOrder$$anon$1__f_f$3;
  return $n(ev$1).partialCompare__O__O__D($n(f$1).apply__O__O(x), $n(f$1).apply__O__O(y));
});
var $d_Lcats_kernel_PartialOrder$$anon$1 = new $TypeData().initClass($c_Lcats_kernel_PartialOrder$$anon$1, "cats.kernel.PartialOrder$$anon$1", ({
  Lcats_kernel_PartialOrder$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_LazyListMonoid() {
}
$c_Lcats_kernel_instances_LazyListMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_LazyListMonoid.prototype.constructor = $c_Lcats_kernel_instances_LazyListMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_LazyListMonoid() {
}
$h_Lcats_kernel_instances_LazyListMonoid.prototype = $c_Lcats_kernel_instances_LazyListMonoid.prototype;
$c_Lcats_kernel_instances_LazyListMonoid.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAllOption__sc_IterableOnce__s_Option(this, as);
});
$c_Lcats_kernel_instances_LazyListMonoid.prototype.combineAll__sc_IterableOnce__sci_LazyList = (function(xs) {
  return $as_sci_LazyList($m_Lcats_kernel_instances_StaticMethods$().combineAllIterable__scm_Builder__sc_IterableOnce__O(($m_sci_LazyList$(), new $c_sci_LazyList$LazyBuilder()), xs));
});
$c_Lcats_kernel_instances_LazyListMonoid.prototype.empty__O = (function() {
  return $m_sci_LazyList$().sci_LazyList$__f__empty;
});
$c_Lcats_kernel_instances_LazyListMonoid.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_LazyList(x);
  var y$1 = $as_sci_LazyList(y);
  var this$1 = $n(x$1);
  return this$1.appendedAll__sc_IterableOnce__sci_LazyList(y$1);
});
$c_Lcats_kernel_instances_LazyListMonoid.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return this.combineAll__sc_IterableOnce__sci_LazyList(as);
});
var $d_Lcats_kernel_instances_LazyListMonoid = new $TypeData().initClass($c_Lcats_kernel_instances_LazyListMonoid, "cats.kernel.instances.LazyListMonoid", ({
  Lcats_kernel_instances_LazyListMonoid: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_ListMonoid() {
}
$c_Lcats_kernel_instances_ListMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_ListMonoid.prototype.constructor = $c_Lcats_kernel_instances_ListMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_ListMonoid() {
}
$h_Lcats_kernel_instances_ListMonoid.prototype = $c_Lcats_kernel_instances_ListMonoid.prototype;
$c_Lcats_kernel_instances_ListMonoid.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAllOption__sc_IterableOnce__s_Option(this, as);
});
$c_Lcats_kernel_instances_ListMonoid.prototype.combineAll__sc_IterableOnce__sci_List = (function(xs) {
  return $as_sci_List($m_Lcats_kernel_instances_StaticMethods$().combineAllIterable__scm_Builder__sc_IterableOnce__O(new $c_scm_ListBuffer(), xs));
});
$c_Lcats_kernel_instances_ListMonoid.prototype.empty__O = (function() {
  return $m_sci_Nil$();
});
$c_Lcats_kernel_instances_ListMonoid.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_List(x);
  var y$1 = $as_sci_List(y);
  return $n(y$1).$colon$colon$colon__sci_List__sci_List(x$1);
});
$c_Lcats_kernel_instances_ListMonoid.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return this.combineAll__sc_IterableOnce__sci_List(as);
});
var $d_Lcats_kernel_instances_ListMonoid = new $TypeData().initClass($c_Lcats_kernel_instances_ListMonoid, "cats.kernel.instances.ListMonoid", ({
  Lcats_kernel_instances_ListMonoid: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_SeqMonoid() {
}
$c_Lcats_kernel_instances_SeqMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_SeqMonoid.prototype.constructor = $c_Lcats_kernel_instances_SeqMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_SeqMonoid() {
}
$h_Lcats_kernel_instances_SeqMonoid.prototype = $c_Lcats_kernel_instances_SeqMonoid.prototype;
$c_Lcats_kernel_instances_SeqMonoid.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAllOption__sc_IterableOnce__s_Option(this, as);
});
$c_Lcats_kernel_instances_SeqMonoid.prototype.empty__O = (function() {
  return $as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps());
});
$c_Lcats_kernel_instances_SeqMonoid.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Seq(x);
  var y$1 = $as_sci_Seq(y);
  var this$1 = $n(x$1);
  return $as_sci_Seq(this$1.appendedAll__sc_IterableOnce__O(y$1));
});
$c_Lcats_kernel_instances_SeqMonoid.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $as_sci_Seq($m_Lcats_kernel_instances_StaticMethods$().combineAllIterable__scm_Builder__sc_IterableOnce__O($m_sci_Seq$().newBuilder__scm_Builder(), as));
});
function $as_Lcats_kernel_instances_SeqMonoid(obj) {
  return (((obj instanceof $c_Lcats_kernel_instances_SeqMonoid) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.instances.SeqMonoid"));
}
function $isArrayOf_Lcats_kernel_instances_SeqMonoid(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_instances_SeqMonoid)));
}
function $asArrayOf_Lcats_kernel_instances_SeqMonoid(obj, depth) {
  return (($isArrayOf_Lcats_kernel_instances_SeqMonoid(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.instances.SeqMonoid;", depth));
}
var $d_Lcats_kernel_instances_SeqMonoid = new $TypeData().initClass($c_Lcats_kernel_instances_SeqMonoid, "cats.kernel.instances.SeqMonoid", ({
  Lcats_kernel_instances_SeqMonoid: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_StreamMonoid() {
}
$c_Lcats_kernel_instances_StreamMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_StreamMonoid.prototype.constructor = $c_Lcats_kernel_instances_StreamMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_StreamMonoid() {
}
$h_Lcats_kernel_instances_StreamMonoid.prototype = $c_Lcats_kernel_instances_StreamMonoid.prototype;
$c_Lcats_kernel_instances_StreamMonoid.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAllOption__sc_IterableOnce__s_Option(this, as);
});
$c_Lcats_kernel_instances_StreamMonoid.prototype.combineAll__sc_IterableOnce__sci_Stream = (function(xs) {
  return $as_sci_Stream($m_Lcats_kernel_instances_StaticMethods$().combineAllIterable__scm_Builder__sc_IterableOnce__O($m_sci_Stream$().newBuilder__scm_Builder(), xs));
});
$c_Lcats_kernel_instances_StreamMonoid.prototype.empty__O = (function() {
  return $m_sci_Stream$Empty$();
});
$c_Lcats_kernel_instances_StreamMonoid.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Stream(x);
  var y$1 = $as_sci_Stream(y);
  var this$1 = $n(x$1);
  return $as_sci_Stream($f_sc_IterableOps__concat__sc_IterableOnce__O(this$1, y$1));
});
$c_Lcats_kernel_instances_StreamMonoid.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return this.combineAll__sc_IterableOnce__sci_Stream(as);
});
var $d_Lcats_kernel_instances_StreamMonoid = new $TypeData().initClass($c_Lcats_kernel_instances_StreamMonoid, "cats.kernel.instances.StreamMonoid", ({
  Lcats_kernel_instances_StreamMonoid: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_StringMonoid() {
}
$c_Lcats_kernel_instances_StringMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_StringMonoid.prototype.constructor = $c_Lcats_kernel_instances_StringMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_StringMonoid() {
}
$h_Lcats_kernel_instances_StringMonoid.prototype = $c_Lcats_kernel_instances_StringMonoid.prototype;
$c_Lcats_kernel_instances_StringMonoid.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAllOption__sc_IterableOnce__s_Option(this, as);
});
$c_Lcats_kernel_instances_StringMonoid.prototype.combine__T__T__T = (function(x, y) {
  return (("" + x) + y);
});
$c_Lcats_kernel_instances_StringMonoid.prototype.combineAll__sc_IterableOnce__T = (function(xs) {
  var sb = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var this$1 = $n($n(xs).iterator__sc_Iterator());
  while (this$1.hasNext__Z()) {
    var arg1 = this$1.next__O();
    var s = $as_T(arg1);
    sb.append__T__scm_StringBuilder(s);
  }
  return $n(sb.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_Lcats_kernel_instances_StringMonoid.prototype.empty__O = (function() {
  return "";
});
$c_Lcats_kernel_instances_StringMonoid.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__T__T__T($as_T(x), $as_T(y));
});
$c_Lcats_kernel_instances_StringMonoid.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return this.combineAll__sc_IterableOnce__T(as);
});
var $d_Lcats_kernel_instances_StringMonoid = new $TypeData().initClass($c_Lcats_kernel_instances_StringMonoid, "cats.kernel.instances.StringMonoid", ({
  Lcats_kernel_instances_StringMonoid: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_VectorMonoid() {
}
$c_Lcats_kernel_instances_VectorMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_VectorMonoid.prototype.constructor = $c_Lcats_kernel_instances_VectorMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_VectorMonoid() {
}
$h_Lcats_kernel_instances_VectorMonoid.prototype = $c_Lcats_kernel_instances_VectorMonoid.prototype;
$c_Lcats_kernel_instances_VectorMonoid.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAllOption__sc_IterableOnce__s_Option(this, as);
});
$c_Lcats_kernel_instances_VectorMonoid.prototype.combineAll__sc_IterableOnce__sci_Vector = (function(xs) {
  return $as_sci_Vector($m_Lcats_kernel_instances_StaticMethods$().combineAllIterable__scm_Builder__sc_IterableOnce__O(($m_sci_Vector$(), new $c_sci_VectorBuilder()), xs));
});
$c_Lcats_kernel_instances_VectorMonoid.prototype.empty__O = (function() {
  $m_sci_Vector$();
  return $m_sci_Vector0$();
});
$c_Lcats_kernel_instances_VectorMonoid.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Vector(x);
  var y$1 = $as_sci_Vector(y);
  var this$1 = $n(x$1);
  return this$1.appendedAll__sc_IterableOnce__sci_Vector(y$1);
});
$c_Lcats_kernel_instances_VectorMonoid.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return this.combineAll__sc_IterableOnce__sci_Vector(as);
});
var $d_Lcats_kernel_instances_VectorMonoid = new $TypeData().initClass($c_Lcats_kernel_instances_VectorMonoid, "cats.kernel.instances.VectorMonoid", ({
  Lcats_kernel_instances_VectorMonoid: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
}));
/** @constructor */
function $c_Lcats_syntax_SemigroupalSyntax$$anon$1(fa$1, F$1) {
  this.Lcats_syntax_SemigroupalSyntax$$anon$1__f_self = null;
  this.Lcats_syntax_SemigroupalSyntax$$anon$1__f_typeClassInstance = null;
  this.Lcats_syntax_SemigroupalSyntax$$anon$1__f_self = fa$1;
  this.Lcats_syntax_SemigroupalSyntax$$anon$1__f_typeClassInstance = F$1;
}
$c_Lcats_syntax_SemigroupalSyntax$$anon$1.prototype = new $h_Lcats_syntax_SemigroupalOps();
$c_Lcats_syntax_SemigroupalSyntax$$anon$1.prototype.constructor = $c_Lcats_syntax_SemigroupalSyntax$$anon$1;
/** @constructor */
function $h_Lcats_syntax_SemigroupalSyntax$$anon$1() {
}
$h_Lcats_syntax_SemigroupalSyntax$$anon$1.prototype = $c_Lcats_syntax_SemigroupalSyntax$$anon$1.prototype;
var $d_Lcats_syntax_SemigroupalSyntax$$anon$1 = new $TypeData().initClass($c_Lcats_syntax_SemigroupalSyntax$$anon$1, "cats.syntax.SemigroupalSyntax$$anon$1", ({
  Lcats_syntax_SemigroupalSyntax$$anon$1: 1,
  Lcats_syntax_SemigroupalOps: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal$Ops: 1
}));
/** @constructor */
function $c_Ldev_sungkm_enchantedrealm_EnchantedRealm(dispatcher, queue, evidence$1, evidence$2) {
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm__f_dispatcher = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm__f_queue = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm__f_dev$sungkm$enchantedrealm$EnchantedRealm$$evidence$1 = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm__f_dev$sungkm$enchantedrealm$EnchantedRealm$$evidence$2 = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm__f_Model$lzy1 = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm__f_Modelbitmap$1 = false;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm__f_Msg$lzy1 = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm__f_app = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm__f_dispatcher = dispatcher;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm__f_queue = queue;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm__f_dev$sungkm$enchantedrealm$EnchantedRealm$$evidence$1 = evidence$1;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm__f_dev$sungkm$enchantedrealm$EnchantedRealm$$evidence$2 = evidence$2;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm__f_Msg$lzy1 = new $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$(this);
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm__f_app = new $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$1(this);
}
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm.prototype = new $h_O();
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm.prototype.constructor = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm;
/** @constructor */
function $h_Ldev_sungkm_enchantedrealm_EnchantedRealm() {
}
$h_Ldev_sungkm_enchantedrealm_EnchantedRealm.prototype = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm.prototype;
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ldev_sungkm_enchantedrealm_EnchantedRealm)) {
    var x$0$2 = $as_Ldev_sungkm_enchantedrealm_EnchantedRealm(x$0);
    var x = this.Ldev_sungkm_enchantedrealm_EnchantedRealm__f_dispatcher;
    var x$2 = $n(x$0$2).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_dispatcher;
    if ((x === null)) {
      var $x_1 = (x$2 === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === x$2);
    }
    if ($x_1) {
      var x$3 = this.Ldev_sungkm_enchantedrealm_EnchantedRealm__f_queue;
      var x$4 = $n(x$0$2).Ldev_sungkm_enchantedrealm_EnchantedRealm__f_queue;
      if ((x$3 === null)) {
        return (x$4 === null);
      } else {
        var this$2 = $n(x$3);
        return (this$2 === x$4);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm.prototype.productArity__I = (function() {
  return 2;
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm.prototype.productPrefix__T = (function() {
  return "EnchantedRealm";
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ldev_sungkm_enchantedrealm_EnchantedRealm__f_dispatcher;
  }
  if ((n === 1)) {
    return this.Ldev_sungkm_enchantedrealm_EnchantedRealm__f_queue;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm.prototype.Model__Ldev_sungkm_enchantedrealm_EnchantedRealm$Model$ = (function() {
  if ((!this.Ldev_sungkm_enchantedrealm_EnchantedRealm__f_Modelbitmap$1)) {
    this.Ldev_sungkm_enchantedrealm_EnchantedRealm__f_Model$lzy1 = new $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model$(this);
    this.Ldev_sungkm_enchantedrealm_EnchantedRealm__f_Modelbitmap$1 = true;
  }
  return this.Ldev_sungkm_enchantedrealm_EnchantedRealm__f_Model$lzy1;
});
function $as_Ldev_sungkm_enchantedrealm_EnchantedRealm(obj) {
  return (((obj instanceof $c_Ldev_sungkm_enchantedrealm_EnchantedRealm) || (obj === null)) ? obj : $throwClassCastException(obj, "dev.sungkm.enchantedrealm.EnchantedRealm"));
}
function $isArrayOf_Ldev_sungkm_enchantedrealm_EnchantedRealm(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldev_sungkm_enchantedrealm_EnchantedRealm)));
}
function $asArrayOf_Ldev_sungkm_enchantedrealm_EnchantedRealm(obj, depth) {
  return (($isArrayOf_Ldev_sungkm_enchantedrealm_EnchantedRealm(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldev.sungkm.enchantedrealm.EnchantedRealm;", depth));
}
var $d_Ldev_sungkm_enchantedrealm_EnchantedRealm = new $TypeData().initClass($c_Ldev_sungkm_enchantedrealm_EnchantedRealm, "dev.sungkm.enchantedrealm.EnchantedRealm", ({
  Ldev_sungkm_enchantedrealm_EnchantedRealm: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model(outer, text, systemMessage, userChoices, engine, engineResponseStream) {
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_text = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_systemMessage = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_userChoices = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_engine = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_engineResponseStream = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_$outer = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_text = text;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_systemMessage = systemMessage;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_userChoices = userChoices;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_engine = engine;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_engineResponseStream = engineResponseStream;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_$outer = outer;
}
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model.prototype = new $h_O();
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model.prototype.constructor = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model;
/** @constructor */
function $h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model() {
}
$h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model.prototype = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model.prototype;
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model) && ($n($as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model(x$0)).Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_$outer === this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_$outer))) {
    var x$0$2 = $as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model(x$0);
    if ((this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_text === $n(x$0$2).Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_text)) {
      var x = this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_systemMessage;
      var x$2 = $n(x$0$2).Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_systemMessage;
      var $x_3 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_userChoices;
      var x$4 = $n(x$0$2).Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_userChoices;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_engine;
      var x$6 = $n(x$0$2).Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_engine;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_engineResponseStream;
      var x$8 = $n(x$0$2).Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_engineResponseStream;
      return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model.prototype.productArity__I = (function() {
  return 5;
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model.prototype.productPrefix__T = (function() {
  return "Model";
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_text;
      break;
    }
    case 1: {
      return this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_systemMessage;
      break;
    }
    case 2: {
      return this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_userChoices;
      break;
    }
    case 3: {
      return this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_engine;
      break;
    }
    case 4: {
      return this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_engineResponseStream;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model.prototype.copy__T__s_Option__sci_List__s_Option__s_Option__Ldev_sungkm_enchantedrealm_EnchantedRealm$Model = (function(text, systemMessage, userChoices, engine, engineResponseStream) {
  return new $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model(this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model__f_$outer, text, systemMessage, userChoices, engine, engineResponseStream);
});
function $as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model(obj) {
  return (((obj instanceof $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model) || (obj === null)) ? obj : $throwClassCastException(obj, "dev.sungkm.enchantedrealm.EnchantedRealm$Model"));
}
function $isArrayOf_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldev_sungkm_enchantedrealm_EnchantedRealm$Model)));
}
function $asArrayOf_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model(obj, depth) {
  return (($isArrayOf_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldev.sungkm.enchantedrealm.EnchantedRealm$Model;", depth));
}
var $d_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model = new $TypeData().initClass($c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Model, "dev.sungkm.enchantedrealm.EnchantedRealm$Model", ({
  Ldev_sungkm_enchantedrealm_EnchantedRealm$Model: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lfs2_Chunk$$anon$1(outer) {
  this.Lfs2_Chunk$$anon$1__f_i = 0;
  this.Lfs2_Chunk$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lfs2_Chunk$$anon$1__f_$outer = outer;
  this.Lfs2_Chunk$$anon$1__f_i = 0;
}
$c_Lfs2_Chunk$$anon$1.prototype = new $h_O();
$c_Lfs2_Chunk$$anon$1.prototype.constructor = $c_Lfs2_Chunk$$anon$1;
/** @constructor */
function $h_Lfs2_Chunk$$anon$1() {
}
$h_Lfs2_Chunk$$anon$1.prototype = $c_Lfs2_Chunk$$anon$1.prototype;
$c_Lfs2_Chunk$$anon$1.prototype.knownSize__I = (function() {
  return (-1);
});
$c_Lfs2_Chunk$$anon$1.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lfs2_Chunk$$anon$1.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_Lfs2_Chunk$$anon$1.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lfs2_Chunk$$anon$1.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$c_Lfs2_Chunk$$anon$1.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lfs2_Chunk$$anon$1.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lfs2_Chunk$$anon$1.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lfs2_Chunk$$anon$1.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this);
});
$c_Lfs2_Chunk$$anon$1.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lfs2_Chunk$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return this;
});
$c_Lfs2_Chunk$$anon$1.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z());
});
$c_Lfs2_Chunk$$anon$1.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$c_Lfs2_Chunk$$anon$1.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$c_Lfs2_Chunk$$anon$1.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$c_Lfs2_Chunk$$anon$1.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$c_Lfs2_Chunk$$anon$1.prototype.toString__T = (function() {
  return "<iterator>";
});
$c_Lfs2_Chunk$$anon$1.prototype.hasNext__Z = (function() {
  return (this.Lfs2_Chunk$$anon$1__f_i < $n(this.Lfs2_Chunk$$anon$1__f_$outer).size__I());
});
$c_Lfs2_Chunk$$anon$1.prototype.next__O = (function() {
  var result = $n(this.Lfs2_Chunk$$anon$1__f_$outer).apply__I__O(this.Lfs2_Chunk$$anon$1__f_i);
  this.Lfs2_Chunk$$anon$1__f_i = ((1 + this.Lfs2_Chunk$$anon$1__f_i) | 0);
  return result;
});
var $d_Lfs2_Chunk$$anon$1 = new $TypeData().initClass($c_Lfs2_Chunk$$anon$1, "fs2.Chunk$$anon$1", ({
  Lfs2_Chunk$$anon$1: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
}));
/** @constructor */
function $c_Lfs2_Pull$AlgEffect() {
}
$c_Lfs2_Pull$AlgEffect.prototype = new $h_Lfs2_Pull$Action();
$c_Lfs2_Pull$AlgEffect.prototype.constructor = $c_Lfs2_Pull$AlgEffect;
/** @constructor */
function $h_Lfs2_Pull$AlgEffect() {
}
$h_Lfs2_Pull$AlgEffect.prototype = $c_Lfs2_Pull$AlgEffect.prototype;
function $as_Lfs2_Pull$AlgEffect(obj) {
  return (((obj instanceof $c_Lfs2_Pull$AlgEffect) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$AlgEffect"));
}
function $isArrayOf_Lfs2_Pull$AlgEffect(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$AlgEffect)));
}
function $asArrayOf_Lfs2_Pull$AlgEffect(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$AlgEffect(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$AlgEffect;", depth));
}
function $ct_Lfs2_Pull$Bind__Lfs2_Pull__($thiz, step) {
  $thiz.Lfs2_Pull$Bind__f_step = step;
  return $thiz;
}
/** @constructor */
function $c_Lfs2_Pull$Bind() {
  this.Lfs2_Pull$Bind__f_step = null;
}
$c_Lfs2_Pull$Bind.prototype = new $h_Lfs2_Pull();
$c_Lfs2_Pull$Bind.prototype.constructor = $c_Lfs2_Pull$Bind;
/** @constructor */
function $h_Lfs2_Pull$Bind() {
}
$h_Lfs2_Pull$Bind.prototype = $c_Lfs2_Pull$Bind.prototype;
$c_Lfs2_Pull$Bind.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_Lfs2_Pull$Bind.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_Lfs2_Pull$Bind.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Lfs2_Pull$Bind.prototype.delegate__Lfs2_Pull$Bind = (function() {
  return this;
});
$c_Lfs2_Pull$Bind.prototype.apply__O__O = (function(v1) {
  var r = $as_Lfs2_Pull$Terminal(v1);
  return this.cont__Lfs2_Pull$Terminal__Lfs2_Pull(r);
});
$c_Lfs2_Pull$Bind.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  var r = $as_Lfs2_Pull$Terminal(v1);
  return $uZ(this.cont__Lfs2_Pull$Terminal__Lfs2_Pull(r));
});
function $as_Lfs2_Pull$Bind(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Bind) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Bind"));
}
function $isArrayOf_Lfs2_Pull$Bind(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Bind)));
}
function $asArrayOf_Lfs2_Pull$Bind(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Bind(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Bind;", depth));
}
function $p_Lfs2_internal_InterruptContext__complete__Lcats_effect_kernel_Outcome__O($thiz, outcome) {
  var wrapped = $n($thiz.Lfs2_internal_InterruptContext__f_ref).update__F1__O(new $c_sjsr_AnonFunction1(((_$2) => {
    var _$2$1 = $as_s_Option(_$2);
    var this$1 = $n(_$2$1);
    return (this$1.isEmpty__Z() ? new $c_s_Some(outcome) : this$1);
  })));
  var target = $n($thiz.Lfs2_internal_InterruptContext__f_deferred).complete__O__O(outcome);
  var tc = $thiz.Lfs2_internal_InterruptContext__f_F;
  var this$5 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
  var fin = $n(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
  var F = $thiz.Lfs2_internal_InterruptContext__f_F;
  return $n(F).guarantee__O__O__O(wrapped, fin);
}
/** @constructor */
function $c_Lfs2_internal_InterruptContext(deferred, ref, interruptRoot, cancelParent, F) {
  this.Lfs2_internal_InterruptContext__f_deferred = null;
  this.Lfs2_internal_InterruptContext__f_ref = null;
  this.Lfs2_internal_InterruptContext__f_interruptRoot = null;
  this.Lfs2_internal_InterruptContext__f_cancelParent = null;
  this.Lfs2_internal_InterruptContext__f_F = null;
  this.Lfs2_internal_InterruptContext__f_deferred = deferred;
  this.Lfs2_internal_InterruptContext__f_ref = ref;
  this.Lfs2_internal_InterruptContext__f_interruptRoot = interruptRoot;
  this.Lfs2_internal_InterruptContext__f_cancelParent = cancelParent;
  this.Lfs2_internal_InterruptContext__f_F = F;
}
$c_Lfs2_internal_InterruptContext.prototype = new $h_O();
$c_Lfs2_internal_InterruptContext.prototype.constructor = $c_Lfs2_internal_InterruptContext;
/** @constructor */
function $h_Lfs2_internal_InterruptContext() {
}
$h_Lfs2_internal_InterruptContext.prototype = $c_Lfs2_internal_InterruptContext.prototype;
$c_Lfs2_internal_InterruptContext.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_internal_InterruptContext.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lfs2_internal_InterruptContext.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_internal_InterruptContext)) {
    var x$0$2 = $as_Lfs2_internal_InterruptContext(x$0);
    var x = this.Lfs2_internal_InterruptContext__f_deferred;
    var x$2 = $n(x$0$2).Lfs2_internal_InterruptContext__f_deferred;
    if ((x === null)) {
      var $x_3 = (x$2 === null);
    } else {
      var this$1 = $n(x);
      var $x_3 = (this$1 === x$2);
    }
    if ($x_3) {
      var x$3 = this.Lfs2_internal_InterruptContext__f_ref;
      var x$4 = $n(x$0$2).Lfs2_internal_InterruptContext__f_ref;
      if ((x$3 === null)) {
        var $x_2 = (x$4 === null);
      } else {
        var this$2 = $n(x$3);
        var $x_2 = (this$2 === x$4);
      }
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Lfs2_internal_InterruptContext__f_interruptRoot;
      var x$6 = $n(x$0$2).Lfs2_internal_InterruptContext__f_interruptRoot;
      if ((x$5 === null)) {
        var $x_1 = (x$6 === null);
      } else {
        var this$3 = $n(x$5);
        var $x_1 = (this$3 === x$6);
      }
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$1 = this.Lfs2_internal_InterruptContext__f_cancelParent;
      var y = $n(x$0$2).Lfs2_internal_InterruptContext__f_cancelParent;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_internal_InterruptContext.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_internal_InterruptContext.prototype.productArity__I = (function() {
  return 4;
});
$c_Lfs2_internal_InterruptContext.prototype.productPrefix__T = (function() {
  return "InterruptContext";
});
$c_Lfs2_internal_InterruptContext.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lfs2_internal_InterruptContext__f_deferred;
      break;
    }
    case 1: {
      return this.Lfs2_internal_InterruptContext__f_ref;
      break;
    }
    case 2: {
      return this.Lfs2_internal_InterruptContext__f_interruptRoot;
      break;
    }
    case 3: {
      return this.Lfs2_internal_InterruptContext__f_cancelParent;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lfs2_internal_InterruptContext.prototype.completeWhen__O__O = (function(outcome) {
  var $x_1 = $n(this.Lfs2_internal_InterruptContext__f_F);
  var tc = this.Lfs2_internal_InterruptContext__f_F;
  var this$3 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(outcome, tc);
  var f = new $c_sjsr_AnonFunction1(((outcome$2) => {
    var outcome$1 = $as_Lcats_effect_kernel_Outcome(outcome$2);
    return $p_Lfs2_internal_InterruptContext__complete__Lcats_effect_kernel_Outcome__O(this, outcome$1);
  }));
  return $n($x_1).start__O__O($n(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f));
});
$c_Lfs2_internal_InterruptContext.prototype.childContext__Z__Lcats_effect_kernel_Unique$Token__O = (function(interruptible, newScopeId) {
  if (interruptible) {
    var this$1 = $m_Lcats_effect_kernel_implicits$();
    var wrapped = $n(this.Lfs2_internal_InterruptContext__f_deferred).get__O();
    var F = this.Lfs2_internal_InterruptContext__f_F;
    var ev$2 = $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O(this$1, wrapped, F);
    var F$1 = this.Lfs2_internal_InterruptContext__f_F;
    var target = $n(F$1).start__O__O(ev$2);
    var tc = this.Lfs2_internal_InterruptContext__f_F;
    var this$21 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
    var f$3 = new $c_sjsr_AnonFunction1(((fiber) => {
      var fiber$1 = $as_Lcats_effect_kernel_Fiber(fiber);
      var target$1 = $m_Lfs2_internal_InterruptContext$().apply__Lcats_effect_kernel_Unique$Token__O__Lcats_effect_kernel_GenConcurrent__O(newScopeId, $n(fiber$1).cancel__O(), this.Lfs2_internal_InterruptContext__f_F);
      var tc$1 = this.Lfs2_internal_InterruptContext__f_F;
      var this$20 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
      var f$2 = new $c_sjsr_AnonFunction1(((context) => {
        var context$1 = $as_Lfs2_internal_InterruptContext(context);
        var this$16 = $m_Lcats_effect_kernel_implicits$();
        var target$2 = $n(fiber$1).join__O();
        var tc$2 = this.Lfs2_internal_InterruptContext__f_F;
        var this$15 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, tc$2);
        var f$1 = new $c_sjsr_AnonFunction1(((x$1) => {
          var x$1$1 = $as_Lcats_effect_kernel_Outcome(x$1);
          if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
            var x$1$2 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$1);
            var this$8 = $n(x$1$2);
            var x12 = this$8.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
            var tc$3 = this.Lfs2_internal_InterruptContext__f_F;
            var this$10 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(x12, tc$3);
            var f = new $c_sjsr_AnonFunction1(((i) => {
              var i$1 = $as_Lcats_effect_kernel_Outcome(i);
              return $p_Lfs2_internal_InterruptContext__complete__Lcats_effect_kernel_Outcome__O($n(context$1), i$1);
            }));
            return $n(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
          }
          if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
            var x$1$3 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$1);
            var this$12 = $n(x$1$3);
            var x9 = $as_jl_Throwable(this$12.Lcats_effect_kernel_Outcome$Errored__f_e);
            return $p_Lfs2_internal_InterruptContext__complete__Lcats_effect_kernel_Outcome__O($n(context$1), new $c_Lcats_effect_kernel_Outcome$Errored(x9));
          }
          if (((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$1), true))) {
            return $p_Lfs2_internal_InterruptContext__complete__Lcats_effect_kernel_Outcome__O($n(context$1), new $c_Lcats_effect_kernel_Outcome$Canceled());
          }
          throw new $c_s_MatchError(x$1$1);
        }));
        var wrapped$1 = $n(this$15.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$15.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
        var F$2 = this.Lfs2_internal_InterruptContext__f_F;
        var ev$3 = $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O(this$16, wrapped$1, F$2);
        var F$3 = this.Lfs2_internal_InterruptContext__f_F;
        var target$3 = $n(F$3).start__O__O(ev$3);
        var tc$4 = this.Lfs2_internal_InterruptContext__f_F;
        var this$19 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, tc$4);
        return $n(this$19.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$19.Lcats_Functor$ToFunctorOps$$anon$5__f_self, context$1);
      }));
      return $n(this$20.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$20.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
    }));
    return $n(this$21.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$21.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
  } else {
    var instance = this.Lfs2_internal_InterruptContext__f_F;
    var this$23 = $n(instance);
    var cancelParent$1 = this$23.pure__O__O((void 0));
    var deferred$1 = this.Lfs2_internal_InterruptContext__f_deferred;
    var ref$1 = this.Lfs2_internal_InterruptContext__f_ref;
    var interruptRoot$1 = this.Lfs2_internal_InterruptContext__f_interruptRoot;
    var F$4 = this.Lfs2_internal_InterruptContext__f_F;
    var a = new $c_Lfs2_internal_InterruptContext(deferred$1, ref$1, interruptRoot$1, cancelParent$1, F$4);
    var F$5 = this.Lfs2_internal_InterruptContext__f_F;
    return $n(F$5).pure__O__O(a);
  }
});
$c_Lfs2_internal_InterruptContext.prototype.eval__O__O = (function(fa) {
  var target = $n(this.Lfs2_internal_InterruptContext__f_ref).get__O();
  var tc = this.Lfs2_internal_InterruptContext__f_F;
  var this$28 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f$3 = new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_s_Option(x$1);
    if ((x$1$1 instanceof $c_s_Some)) {
      var outcome = $as_Lcats_effect_kernel_Outcome($n($as_s_Some(x$1$1)).s_Some__f_value);
      return $n(this.Lfs2_internal_InterruptContext__f_F).pure__O__O(new $c_s_util_Left(outcome));
    }
    var x = $m_s_None$();
    if ((x === x$1$1)) {
      var $x_2 = $n(this.Lfs2_internal_InterruptContext__f_F);
      var $x_1 = $n(this.Lfs2_internal_InterruptContext__f_deferred).get__O();
      var F$1 = this.Lfs2_internal_InterruptContext__f_F;
      var target$1 = $n($x_2).raceOutcome__O__O__O($x_1, $n(F$1).attempt__O__O(fa));
      var tc$1 = this.Lfs2_internal_InterruptContext__f_F;
      var this$27 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
      var f$2 = new $c_sjsr_AnonFunction1(((x$1$2) => {
        var x$1$3 = $as_s_util_Either(x$1$2);
        if ((x$1$3 instanceof $c_s_util_Right)) {
          var oc = $as_Lcats_effect_kernel_Outcome($n($as_s_util_Right(x$1$3)).s_util_Right__f_value);
          var this$7 = $n(oc);
          if (((this$7 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(this$7), true))) {
            var target$2 = $n(this.Lfs2_internal_InterruptContext__f_F).canceled__O();
            var tc$2 = this.Lfs2_internal_InterruptContext__f_F;
            var this$11 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, tc$2);
            var value = new $c_Lcats_effect_kernel_Outcome$Canceled();
            var b = new $c_s_util_Left(value);
            return $n(this$11.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$11.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b);
          }
          if ((this$7 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
            var x$1$4 = $as_Lcats_effect_kernel_Outcome$Errored(this$7);
            var this$13 = $n(x$1$4);
            var x7 = this$13.Lcats_effect_kernel_Outcome$Errored__f_e;
            var e = $as_jl_Throwable(x7);
            return $n(this.Lfs2_internal_InterruptContext__f_F).raiseError__O__O(e);
          }
          if ((this$7 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
            var x$1$5 = $as_Lcats_effect_kernel_Outcome$Succeeded(this$7);
            var this$15 = $n(x$1$5);
            var x4 = this$15.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
            var tc$3 = this.Lfs2_internal_InterruptContext__f_F;
            var this$22 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(x4, tc$3);
            var f = new $c_sjsr_AnonFunction1(((_$3) => {
              var _$3$1 = $as_s_util_Either(_$3);
              if ((_$3$1 instanceof $c_s_util_Left)) {
                var a = $n($as_s_util_Left(_$3$1)).s_util_Left__f_value;
                var _$4 = $as_jl_Throwable(a);
                var value$1 = new $c_Lcats_effect_kernel_Outcome$Errored(_$4);
                return new $c_s_util_Left(value$1);
              }
              if ((_$3$1 instanceof $c_s_util_Right)) {
                var r = $as_s_util_Right(_$3$1);
                $m_Lcats_syntax_EitherUtil$();
                return r;
              }
              throw new $c_s_MatchError(_$3$1);
            }));
            return $n(this$22.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$22.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
          }
          throw new $c_s_MatchError(this$7);
        }
        if ((x$1$3 instanceof $c_s_util_Left)) {
          var oc$2 = $as_Lcats_effect_kernel_Outcome($n($as_s_util_Left(x$1$3)).s_util_Left__f_value);
          var this$23 = $n(oc$2);
          var F$2 = this.Lfs2_internal_InterruptContext__f_F;
          var onCancel = $n(F$2).never__O();
          var target$3 = $f_Lcats_effect_kernel_Outcome__embed__O__Lcats_effect_kernel_MonadCancel__O(this$23, onCancel, F$2);
          var tc$4 = this.Lfs2_internal_InterruptContext__f_F;
          var this$26 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, tc$4);
          var f$1 = new $c_sjsr_AnonFunction1(((_$5) => {
            var _$5$1 = $as_Lcats_effect_kernel_Outcome(_$5);
            return new $c_s_util_Left(_$5$1);
          }));
          return $n(this$26.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$26.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
        }
        throw new $c_s_MatchError(x$1$3);
      }));
      return $n(this$27.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$27.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return $n(this$28.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$28.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
});
function $as_Lfs2_internal_InterruptContext(obj) {
  return (((obj instanceof $c_Lfs2_internal_InterruptContext) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.internal.InterruptContext"));
}
function $isArrayOf_Lfs2_internal_InterruptContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_internal_InterruptContext)));
}
function $asArrayOf_Lfs2_internal_InterruptContext(obj, depth) {
  return (($isArrayOf_Lfs2_internal_InterruptContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.internal.InterruptContext;", depth));
}
var $d_Lfs2_internal_InterruptContext = new $TypeData().initClass($c_Lfs2_internal_InterruptContext, "fs2.internal.InterruptContext", ({
  Lfs2_internal_InterruptContext: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lfs2_internal_ScopedResource$State(open, finalizer, leases) {
  this.Lfs2_internal_ScopedResource$State__f_open = false;
  this.Lfs2_internal_ScopedResource$State__f_finalizer = null;
  this.Lfs2_internal_ScopedResource$State__f_leases = 0;
  this.Lfs2_internal_ScopedResource$State__f_open = open;
  this.Lfs2_internal_ScopedResource$State__f_finalizer = finalizer;
  this.Lfs2_internal_ScopedResource$State__f_leases = leases;
}
$c_Lfs2_internal_ScopedResource$State.prototype = new $h_O();
$c_Lfs2_internal_ScopedResource$State.prototype.constructor = $c_Lfs2_internal_ScopedResource$State;
/** @constructor */
function $h_Lfs2_internal_ScopedResource$State() {
}
$h_Lfs2_internal_ScopedResource$State.prototype = $c_Lfs2_internal_ScopedResource$State.prototype;
$c_Lfs2_internal_ScopedResource$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_internal_ScopedResource$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lfs2_internal_ScopedResource$State__f_open ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lfs2_internal_ScopedResource$State__f_finalizer;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Lfs2_internal_ScopedResource$State__f_leases;
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Lfs2_internal_ScopedResource$State.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_internal_ScopedResource$State)) {
    var x$0$2 = $as_Lfs2_internal_ScopedResource$State(x$0);
    if (((this.Lfs2_internal_ScopedResource$State__f_open === $n(x$0$2).Lfs2_internal_ScopedResource$State__f_open) && (this.Lfs2_internal_ScopedResource$State__f_leases === $n(x$0$2).Lfs2_internal_ScopedResource$State__f_leases))) {
      var x = this.Lfs2_internal_ScopedResource$State__f_finalizer;
      var x$2 = $n(x$0$2).Lfs2_internal_ScopedResource$State__f_finalizer;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_internal_ScopedResource$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_internal_ScopedResource$State.prototype.productArity__I = (function() {
  return 3;
});
$c_Lfs2_internal_ScopedResource$State.prototype.productPrefix__T = (function() {
  return "State";
});
$c_Lfs2_internal_ScopedResource$State.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lfs2_internal_ScopedResource$State__f_open;
      break;
    }
    case 1: {
      return this.Lfs2_internal_ScopedResource$State__f_finalizer;
      break;
    }
    case 2: {
      return this.Lfs2_internal_ScopedResource$State__f_leases;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Lfs2_internal_ScopedResource$State(obj) {
  return (((obj instanceof $c_Lfs2_internal_ScopedResource$State) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.internal.ScopedResource$State"));
}
function $isArrayOf_Lfs2_internal_ScopedResource$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_internal_ScopedResource$State)));
}
function $asArrayOf_Lfs2_internal_ScopedResource$State(obj, depth) {
  return (($isArrayOf_Lfs2_internal_ScopedResource$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.internal.ScopedResource$State;", depth));
}
var $d_Lfs2_internal_ScopedResource$State = new $TypeData().initClass($c_Lfs2_internal_ScopedResource$State, "fs2.internal.ScopedResource$State", ({
  Lfs2_internal_ScopedResource$State: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $ct_Ljava_io_IOException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
class $c_Ljava_io_IOException extends $c_jl_Exception {
}
function $as_Ljava_io_IOException(obj) {
  return (((obj instanceof $c_Ljava_io_IOException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.io.IOException"));
}
function $isArrayOf_Ljava_io_IOException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_io_IOException)));
}
function $asArrayOf_Ljava_io_IOException(obj, depth) {
  return (($isArrayOf_Ljava_io_IOException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.io.IOException;", depth));
}
var $d_Ljava_io_IOException = new $TypeData().initClass($c_Ljava_io_IOException, "java.io.IOException", ({
  Ljava_io_IOException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ljava_io_OutputStream() {
}
$c_Ljava_io_OutputStream.prototype = new $h_O();
$c_Ljava_io_OutputStream.prototype.constructor = $c_Ljava_io_OutputStream;
/** @constructor */
function $h_Ljava_io_OutputStream() {
}
$h_Ljava_io_OutputStream.prototype = $c_Ljava_io_OutputStream.prototype;
$c_Ljava_io_OutputStream.prototype.write__AB__I__I__V = (function(b, off, len) {
  if ((((off < 0) || (len < 0)) || (len > (($n(b).u.length - off) | 0)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  var n = off;
  var stop = ((off + len) | 0);
  while ((n < stop)) {
    this.write__I__V($n(b).get(n));
    n = ((1 + n) | 0);
  }
});
$c_Ljava_io_OutputStream.prototype.flush__V = (function() {
});
function $ct_jl_AssertionError__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
function $ct_jl_AssertionError__O__($thiz, detailMessage) {
  var message = ("" + detailMessage);
  if ((detailMessage instanceof $c_jl_Throwable)) {
    var x2 = $as_jl_Throwable(detailMessage);
    var cause = x2;
  } else {
    var cause = null;
  }
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, message, cause, true, true);
  return $thiz;
}
class $c_jl_AssertionError extends $c_jl_Error {
}
var $d_jl_AssertionError = new $TypeData().initClass($c_jl_AssertionError, "java.lang.AssertionError", ({
  jl_AssertionError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $f_jl_Boolean__equals__O__Z($thiz, that) {
  return ($thiz === that);
}
function $f_jl_Boolean__hashCode__I($thiz) {
  return ($thiz ? 1231 : 1237);
}
function $f_jl_Boolean__toString__T($thiz) {
  return ("" + $thiz);
}
function $f_jl_Boolean__compareTo__O__I($thiz, o) {
  var that = $as_jl_Boolean(o);
  var this$1 = $n(that);
  return (($thiz === this$1) ? 0 : ($thiz ? 1 : (-1)));
}
function $as_jl_Boolean(obj) {
  return ((((typeof obj) === "boolean") || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Boolean"));
}
function $isArrayOf_jl_Boolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Boolean)));
}
function $asArrayOf_jl_Boolean(obj, depth) {
  return (($isArrayOf_jl_Boolean(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Boolean;", depth));
}
var $d_jl_Boolean = new $TypeData().initClass(0, "java.lang.Boolean", ({
  jl_Boolean: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1
}), ((x) => ((typeof x) === "boolean")));
function $f_jl_Character__hashCode__I($thiz) {
  return $thiz;
}
function $f_jl_Character__equals__O__Z($thiz, that) {
  if ((that instanceof $Char)) {
    var this$1 = $uC($n($as_jl_Character(that)));
    return ($thiz === this$1);
  } else {
    return false;
  }
}
function $f_jl_Character__toString__T($thiz) {
  return ("" + $cToS($thiz));
}
function $f_jl_Character__compareTo__O__I($thiz, o) {
  var that = $as_jl_Character(o);
  var this$1 = $uC($n(that));
  return (($thiz - this$1) | 0);
}
function $as_jl_Character(obj) {
  return (((obj instanceof $Char) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Character"));
}
function $isArrayOf_jl_Character(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Character)));
}
function $asArrayOf_jl_Character(obj, depth) {
  return (($isArrayOf_jl_Character(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Character;", depth));
}
var $d_jl_Character = new $TypeData().initClass(0, "java.lang.Character", ({
  jl_Character: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1
}), ((x) => (x instanceof $Char)));
function $as_jl_InterruptedException(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.InterruptedException"));
}
function $isArrayOf_jl_InterruptedException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_InterruptedException)));
}
function $asArrayOf_jl_InterruptedException(obj, depth) {
  return (($isArrayOf_jl_InterruptedException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.InterruptedException;", depth));
}
function $as_jl_LinkageError(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.LinkageError"));
}
function $isArrayOf_jl_LinkageError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_LinkageError)));
}
function $asArrayOf_jl_LinkageError(obj, depth) {
  return (($isArrayOf_jl_LinkageError(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.LinkageError;", depth));
}
function $ct_jl_RuntimeException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
class $c_jl_RuntimeException extends $c_jl_Exception {
}
var $d_jl_RuntimeException = new $TypeData().initClass($c_jl_RuntimeException, "java.lang.RuntimeException", ({
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_jl_StringBuffer__jl_StringBuilder__($thiz, builder) {
  $thiz.jl_StringBuffer__f_builder = builder;
  return $thiz;
}
function $ct_jl_StringBuffer__($thiz) {
  $ct_jl_StringBuffer__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__(new $c_jl_StringBuilder()));
  return $thiz;
}
/** @constructor */
function $c_jl_StringBuffer() {
  this.jl_StringBuffer__f_builder = null;
}
$c_jl_StringBuffer.prototype = new $h_O();
$c_jl_StringBuffer.prototype.constructor = $c_jl_StringBuffer;
/** @constructor */
function $h_jl_StringBuffer() {
}
$h_jl_StringBuffer.prototype = $c_jl_StringBuffer.prototype;
$c_jl_StringBuffer.prototype.length__I = (function() {
  return $n(this.jl_StringBuffer__f_builder).length__I();
});
$c_jl_StringBuffer.prototype.charAt__I__C = (function(index) {
  return $n(this.jl_StringBuffer__f_builder).charAt__I__C(index);
});
$c_jl_StringBuffer.prototype.append__T__jl_StringBuffer = (function(str) {
  var this$1 = $n(this.jl_StringBuffer__f_builder);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  return this;
});
$c_jl_StringBuffer.prototype.append__jl_CharSequence__jl_StringBuffer = (function(s) {
  var this$1 = $n(this.jl_StringBuffer__f_builder);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s);
  return this;
});
$c_jl_StringBuffer.prototype.append__C__jl_StringBuffer = (function(c) {
  var this$1 = $n(this.jl_StringBuffer__f_builder);
  var str = ("" + $cToS(c));
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
  return this;
});
$c_jl_StringBuffer.prototype.subSequence__I__I__jl_CharSequence = (function(start, end) {
  var this$1 = $n(this.jl_StringBuffer__f_builder);
  return this$1.substring__I__I__T(start, end);
});
$c_jl_StringBuffer.prototype.toString__T = (function() {
  return $n(this.jl_StringBuffer__f_builder).jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_jl_StringBuffer.prototype.append__jl_CharSequence__jl_Appendable = (function(csq) {
  return this.append__jl_CharSequence__jl_StringBuffer(csq);
});
var $d_jl_StringBuffer = new $TypeData().initClass($c_jl_StringBuffer, "java.lang.StringBuffer", ({
  jl_StringBuffer: 1,
  jl_CharSequence: 1,
  jl_Appendable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_jl_StringBuilder__($thiz) {
  $thiz.jl_StringBuilder__f_java$lang$StringBuilder$$content = "";
  return $thiz;
}
function $ct_jl_StringBuilder__T__($thiz, str) {
  $ct_jl_StringBuilder__($thiz);
  if ((str === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $thiz.jl_StringBuilder__f_java$lang$StringBuilder$$content = str;
  return $thiz;
}
function $ct_jl_StringBuilder__I__($thiz, initialCapacity) {
  $ct_jl_StringBuilder__($thiz);
  if ((initialCapacity < 0)) {
    throw new $c_jl_NegativeArraySizeException();
  }
  return $thiz;
}
/** @constructor */
function $c_jl_StringBuilder() {
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = null;
}
$c_jl_StringBuilder.prototype = new $h_O();
$c_jl_StringBuilder.prototype.constructor = $c_jl_StringBuilder;
/** @constructor */
function $h_jl_StringBuilder() {
}
$h_jl_StringBuilder.prototype = $c_jl_StringBuilder.prototype;
$c_jl_StringBuilder.prototype.append__AC__jl_StringBuilder = (function(str) {
  var this$1 = $m_jl_String$();
  var count = $n(str).u.length;
  var str$1 = this$1.new__AC__I__I__T(str, 0, count);
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1);
  return this;
});
$c_jl_StringBuilder.prototype.reverse__jl_StringBuilder = (function() {
  var original = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  var result = "";
  var this$1 = $n(original);
  var i = (((-1) + this$1.length) | 0);
  while ((i > 0)) {
    var this$2 = $n(original);
    var index = i;
    var c = $charAt(this$2, index);
    if (((64512 & c) === 56320)) {
      var this$4 = $n(original);
      var index$1 = (((-1) + i) | 0);
      var c2 = $charAt(this$4, index$1);
      if (((64512 & c2) === 55296)) {
        result = ((((result + "") + $cToS(c2)) + "") + $cToS(c));
        i = (((-2) + i) | 0);
      } else {
        result = ((result + "") + $cToS(c));
        i = (((-1) + i) | 0);
      }
    } else {
      result = ((result + "") + $cToS(c));
      i = (((-1) + i) | 0);
    }
  }
  if ((i === 0)) {
    var $x_1 = result;
    var this$10 = $n(original);
    var this$11 = $charAt(this$10, 0);
    result = ($x_1 + ("" + $cToS(this$11)));
  }
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = result;
  return this;
});
$c_jl_StringBuilder.prototype.toString__T = (function() {
  return this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_jl_StringBuilder.prototype.length__I = (function() {
  var this$1 = $n(this.jl_StringBuilder__f_java$lang$StringBuilder$$content);
  return this$1.length;
});
$c_jl_StringBuilder.prototype.charAt__I__C = (function(index) {
  var this$1 = $n(this.jl_StringBuilder__f_java$lang$StringBuilder$$content);
  return $charAt(this$1, index);
});
$c_jl_StringBuilder.prototype.getChars__I__I__AC__I__V = (function(srcBegin, srcEnd, dst, dstBegin) {
  $f_T__getChars__I__I__AC__I__V($n(this.jl_StringBuilder__f_java$lang$StringBuilder$$content), srcBegin, srcEnd, dst, dstBegin);
});
$c_jl_StringBuilder.prototype.subSequence__I__I__jl_CharSequence = (function(start, end) {
  return this.substring__I__I__T(start, end);
});
$c_jl_StringBuilder.prototype.substring__I__I__T = (function(start, end) {
  var this$1 = $n(this.jl_StringBuilder__f_java$lang$StringBuilder$$content);
  if ((start < 0)) {
    $charAt(this$1, start);
  }
  if ((end > this$1.length)) {
    $charAt(this$1, end);
  }
  if ((end < start)) {
    $charAt(this$1, (-1));
  }
  return $as_T(this$1.substring(start, end));
});
$c_jl_StringBuilder.prototype.append__jl_CharSequence__jl_Appendable = (function(csq) {
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this.jl_StringBuilder__f_java$lang$StringBuilder$$content) + csq);
  return this;
});
var $d_jl_StringBuilder = new $TypeData().initClass($c_jl_StringBuilder, "java.lang.StringBuilder", ({
  jl_StringBuilder: 1,
  jl_CharSequence: 1,
  jl_Appendable: 1,
  Ljava_io_Serializable: 1
}));
function $as_jl_ThreadDeath(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.ThreadDeath"));
}
function $isArrayOf_jl_ThreadDeath(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_ThreadDeath)));
}
function $asArrayOf_jl_ThreadDeath(obj, depth) {
  return (($isArrayOf_jl_ThreadDeath(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.ThreadDeath;", depth));
}
class $c_jl_VirtualMachineError extends $c_jl_Error {
}
function $as_jl_VirtualMachineError(obj) {
  return (((obj instanceof $c_jl_VirtualMachineError) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.VirtualMachineError"));
}
function $isArrayOf_jl_VirtualMachineError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_VirtualMachineError)));
}
function $asArrayOf_jl_VirtualMachineError(obj, depth) {
  return (($isArrayOf_jl_VirtualMachineError(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.VirtualMachineError;", depth));
}
function $p_Ljava_math_BigDecimal__decimalDigitsInLong__J__I($thiz, value) {
  if (((value.RTLong__f_lo === 0) && (value.RTLong__f_hi === (-2147483648)))) {
    return 19;
  } else {
    var $x_3 = $m_ju_Arrays$();
    var $x_2 = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows;
    var ahi = value.RTLong__f_hi;
    if ((ahi < 0)) {
      var lo = value.RTLong__f_lo;
      var hi = value.RTLong__f_hi;
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
      var x__lo = lo$1;
      var x__hi = hi$1;
      var $x_1 = new $c_RTLong(x__lo, x__hi);
    } else {
      var $x_1 = value;
    }
    var index = $n($x_3).binarySearch__AJ__J__I($x_2, $x_1);
    return ((index < 0) ? (((-1) - index) | 0) : ((1 + index) | 0));
  }
}
function $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V($thiz, mc) {
  var mcPrecision = $n(mc).Ljava_math_MathContext__f_precision;
  var discardedPrecision = (($thiz.precision__I() - mcPrecision) | 0);
  var mcPrecGood = (($p_Ljava_math_BigDecimal__approxPrecision__I($thiz) < mcPrecision) || (mcPrecision === 0));
  if ((!(mcPrecGood || (discardedPrecision <= 0)))) {
    if (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
      $p_Ljava_math_BigDecimal__smallRound__Ljava_math_MathContext__I__V($thiz, mc, discardedPrecision);
    } else {
      var $x_1 = $m_Ljava_math_Multiplication$();
      var hi = (discardedPrecision >> 31);
      var sizeOfFraction = $n($x_1).powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(discardedPrecision, hi));
      var integerAndFraction = $n($thiz.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger()).divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger(sizeOfFraction);
      var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi$1 = (value >> 31);
      var hi$2 = (discardedPrecision >> 31);
      var lo = ((value - discardedPrecision) | 0);
      var hi$3 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (((-1) + ((hi$1 - hi$2) | 0)) | 0) : ((hi$1 - hi$2) | 0));
      var this$5 = $n($n(integerAndFraction).get(1));
      if ((this$5.Ljava_math_BigInteger__f_sign !== 0)) {
        var absBi = $n($n(integerAndFraction).get(1)).abs__Ljava_math_BigInteger();
        var compRem = $n($n(absBi).shiftLeftOneBit__Ljava_math_BigInteger()).compareTo__Ljava_math_BigInteger__I(sizeOfFraction);
        var parityBit = ($n($n(integerAndFraction).get(0)).testBit__I__Z(0) ? 1 : 0);
        var this$6 = $n($n(integerAndFraction).get(1));
        var frac = Math.imul(this$6.Ljava_math_BigInteger__f_sign, ((5 + compRem) | 0));
        var carry = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I(parityBit, frac, $n(mc).Ljava_math_MathContext__f_roundingMode);
        if ((carry !== 0)) {
          var $x_2 = $m_Ljava_math_BigInteger$();
          var hi$4 = (carry >> 31);
          var bi = $n($x_2).valueOf__J__Ljava_math_BigInteger(new $c_RTLong(carry, hi$4));
          var $x_3 = $n(integerAndFraction);
          var this$8 = $n($n(integerAndFraction).get(0));
          $x_3.set(0, $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$8, bi));
        }
        var tempBD = $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__(new $c_Ljava_math_BigDecimal(), $n(integerAndFraction).get(0));
        if ((tempBD.precision__I() > mcPrecision)) {
          $n(integerAndFraction).set(0, $n($n(integerAndFraction).get(0)).divide__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN));
          var lo$1 = (((-1) + lo) | 0);
          var hi$5 = ((lo$1 !== (-1)) ? hi$3 : (((-1) + hi$3) | 0));
          var newScale__lo = lo$1;
          var newScale__hi = hi$5;
        } else {
          var newScale__lo = lo;
          var newScale__hi = hi$3;
        }
      } else {
        var newScale__lo = lo;
        var newScale__hi = hi$3;
      }
      $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(newScale__lo, newScale__hi));
      $thiz.Ljava_math_BigDecimal__f__precision = mcPrecision;
      $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, $n(integerAndFraction).get(0));
    }
  }
}
function $p_Ljava_math_BigDecimal__isZero__Z($thiz) {
  if (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength === 0)) {
    var this$1 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    return (!((this$1.RTLong__f_lo === (-1)) && (this$1.RTLong__f_hi === (-1))));
  } else {
    return false;
  }
}
function $p_Ljava_math_BigDecimal__smallRound__Ljava_math_MathContext__I__V($thiz, mc, discardedPrecision) {
  var t = $n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows).get(discardedPrecision);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi$1 = (value >> 31);
  var hi$2 = (discardedPrecision >> 31);
  var lo$1 = ((value - discardedPrecision) | 0);
  var hi$3 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ value)) ? (((-1) + ((hi$1 - hi$2) | 0)) | 0) : ((hi$1 - hi$2) | 0));
  var t$1 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
  var lo$2 = t$1.RTLong__f_lo;
  var hi$4 = t$1.RTLong__f_hi;
  var this$4 = $m_RTLong$();
  var lo$3 = this$4.divideImpl__I__I__I__I__I(lo$2, hi$4, lo, hi);
  var hi$5 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var this$5 = $m_RTLong$();
  var lo$4 = this$5.remainderImpl__I__I__I__I__I(lo$2, hi$4, lo, hi);
  var hi$6 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if ((!((lo$4 === 0) && (hi$6 === 0)))) {
    var $x_1 = $m_Ljava_math_BigDecimal$();
    if ((hi$6 < 0)) {
      var lo$5 = ((-lo$4) | 0);
      var hi$7 = ((lo$4 !== 0) ? (~hi$6) : ((-hi$6) | 0));
      var this$9__lo = lo$5;
      var this$9__hi = hi$7;
    } else {
      var this$9__lo = lo$4;
      var this$9__hi = hi$6;
    }
    var lo$6 = this$9__lo;
    var lo$7 = (lo$6 << 1);
    var hi$8 = (((lo$6 >>> 31) | 0) | (this$9__hi << 1));
    var compRem = $n($x_1).java$math$BigDecimal$$longCompareTo__J__J__I(new $c_RTLong(lo$7, hi$8), new $c_RTLong(lo, hi));
    var frac = Math.imul(((hi$6 < 0) ? (-1) : (((hi$6 === 0) && (lo$4 === 0)) ? 0 : 1)), ((5 + compRem) | 0));
    var value$1 = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I((1 & lo$3), frac, $n(mc).Ljava_math_MathContext__f_roundingMode);
    var hi$9 = (value$1 >> 31);
    var lo$8 = ((lo$3 + value$1) | 0);
    var hi$10 = ((((-2147483648) ^ lo$8) < ((-2147483648) ^ lo$3)) ? ((1 + ((hi$5 + hi$9) | 0)) | 0) : ((hi$5 + hi$9) | 0));
    if ((hi$10 < 0)) {
      var lo$9 = ((-lo$8) | 0);
      var hi$11 = ((lo$8 !== 0) ? (~hi$10) : ((-hi$10) | 0));
      var this$16__lo = lo$9;
      var this$16__hi = hi$11;
    } else {
      var this$16__lo = lo$8;
      var this$16__hi = hi$10;
    }
    var a = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$16__lo, this$16__hi);
    if (($uD(Math.log10(a)) >= $n(mc).Ljava_math_MathContext__f_precision)) {
      var lo$10 = (((-1) + lo$1) | 0);
      var hi$12 = ((lo$10 !== (-1)) ? hi$3 : (((-1) + hi$3) | 0));
      var this$19 = $m_RTLong$();
      var lo$11 = this$19.divideImpl__I__I__I__I__I(lo$8, hi$10, 10, 0);
      var hi$13 = this$19.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var x1___1 = new $c_RTLong(lo$10, hi$12);
      var x1___2 = new $c_RTLong(lo$11, hi$13);
    } else {
      var x1___1 = new $c_RTLong(lo$1, hi$3);
      var x1___2 = new $c_RTLong(lo$8, hi$10);
    }
  } else {
    var x1___1 = new $c_RTLong(lo$1, hi$3);
    var x1___2 = new $c_RTLong(lo$3, hi$5);
  }
  var t$2 = $uJ(x1___1);
  var lo$12 = t$2.RTLong__f_lo;
  var hi$14 = t$2.RTLong__f_hi;
  var t$3 = $uJ(x1___2);
  var lo$13 = t$3.RTLong__f_lo;
  var hi$15 = t$3.RTLong__f_hi;
  var t$4 = $uJ(new $c_RTLong(lo$12, hi$14));
  var lo$14 = t$4.RTLong__f_lo;
  var hi$16 = t$4.RTLong__f_hi;
  var t$5 = $uJ(new $c_RTLong(lo$13, hi$15));
  var lo$15 = t$5.RTLong__f_lo;
  var hi$17 = t$5.RTLong__f_hi;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo$14, hi$16));
  $thiz.Ljava_math_BigDecimal__f__precision = $n(mc).Ljava_math_MathContext__f_precision;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = new $c_RTLong(lo$15, hi$17);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().bitLength__J__I(new $c_RTLong(lo$15, hi$17));
  $thiz.Ljava_math_BigDecimal__f__intVal = null;
}
function $p_Ljava_math_BigDecimal__valueExact__I__J($thiz, bitLengthOfType) {
  var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var lo = ((-value) | 0);
  var hi$1 = ((value !== 0) ? (~hi) : ((-hi) | 0));
  var value$1 = $p_Ljava_math_BigDecimal__approxPrecision__I($thiz);
  var hi$2 = (value$1 >> 31);
  var lo$1 = ((lo + value$1) | 0);
  var hi$3 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + ((hi$1 + hi$2) | 0)) | 0) : ((hi$1 + hi$2) | 0));
  if (((hi$3 === 0) ? (((-2147483648) ^ lo$1) > (-2147483629)) : (hi$3 > 0))) {
    throw new $c_jl_ArithmeticException("Rounding necessary");
  }
  var bigInteger = $thiz.toBigIntegerExact__Ljava_math_BigInteger();
  var this$6 = $n(bigInteger);
  if (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$6) < bitLengthOfType)) {
    return $n(bigInteger).longValue__J();
  } else {
    throw new $c_jl_ArithmeticException("Rounding necessary");
  }
}
function $p_Ljava_math_BigDecimal__approxPrecision__I($thiz) {
  return (($thiz.Ljava_math_BigDecimal__f__precision > 0) ? $thiz.Ljava_math_BigDecimal__f__precision : ((1 + $doubleToInt((0.3010299956639812 * (((-1) + $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength) | 0)))) | 0));
}
function $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, unscaledVal) {
  $thiz.Ljava_math_BigDecimal__f__intVal = unscaledVal;
  var this$1 = $n(unscaledVal);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$1);
  if (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = $n(unscaledVal).longValue__J();
  }
}
function $ct_Ljava_math_BigDecimal__($thiz) {
  $thiz.Ljava_math_BigDecimal__f__toStringImage = null;
  $thiz.Ljava_math_BigDecimal__f__hashCode = 0;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = 0;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = $L0;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = 0;
  $thiz.Ljava_math_BigDecimal__f__precision = 0;
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__J__I__($thiz, smallValue, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = smallValue;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = scale;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().bitLength__J__I(smallValue);
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__I__I__($thiz, smallValue, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  var hi = (smallValue >> 31);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = new $c_RTLong(smallValue, hi);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = scale;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$bitLength__I__I(smallValue);
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__AC__I__I__($thiz, in$1, offset, len) {
  $ct_Ljava_math_BigDecimal__($thiz);
  var last = (((-1) + ((offset + len) | 0)) | 0);
  if ((in$1 === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "in == null");
  }
  if (((((last >= $n(in$1).u.length) || (offset < 0)) || (len <= 0)) || (last < 0))) {
    throw new $c_jl_NumberFormatException(((((("Bad offset/length: offset=" + offset) + " len=") + len) + " in.length=") + $n(in$1).u.length));
  }
  var index = offset;
  if (((offset <= last) && ($n(in$1).get(offset) === 43))) {
    index = ((1 + index) | 0);
    if (((index < last) && $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$charEqualTo__C__AC__Z($n(in$1).get(index), new $ac_C(new Uint16Array([43, 45]))))) {
      throw new $c_jl_NumberFormatException(("For input string: " + $n(in$1).toString__T()));
    }
  } else {
    var isMinus = ((index <= last) && ($n(in$1).get(index) === 45));
    var nextIsSign = ((((1 + index) | 0) < last) && $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$charEqualTo__C__AC__Z($n(in$1).get(((1 + index) | 0)), new $ac_C(new Uint16Array([43, 45]))));
    if ((isMinus && nextIsSign)) {
      throw new $c_jl_NumberFormatException(("For input string: " + $n(in$1).toString__T()));
    }
  }
  var begin = index;
  var counter = 0;
  var wasNonZero = false;
  while (((index <= last) && $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$charNotEqualTo__C__AC__Z($n(in$1).get(index), new $ac_C(new Uint16Array([46, 101, 69]))))) {
    if ((!wasNonZero)) {
      if (($n(in$1).get(index) === 48)) {
        counter = ((1 + counter) | 0);
      } else {
        wasNonZero = true;
      }
    }
    index = ((1 + index) | 0);
  }
  var count = ((index - begin) | 0);
  var this$1 = $m_jl_String$();
  var u = this$1.new__AC__I__I__T(in$1, begin, count);
  var b = ((index - begin) | 0);
  if (((index <= last) && ($n(in$1).get(index) === 46))) {
    index = ((1 + index) | 0);
    var begin$2 = index;
    while (((index <= last) && $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$charNotEqualTo__C__AC__Z($n(in$1).get(index), new $ac_C(new Uint16Array([101, 69]))))) {
      if ((!wasNonZero)) {
        if (($n(in$1).get(index) === 48)) {
          counter = ((1 + counter) | 0);
        } else {
          wasNonZero = true;
        }
      }
      index = ((1 + index) | 0);
    }
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = ((index - begin$2) | 0);
    var count$1 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var this$2 = $m_jl_String$();
    var _1 = (("" + u) + this$2.new__AC__I__I__T(in$1, begin$2, count$1));
    var _2 = ((b + $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
    var x1___1 = _1;
    var x1___2 = _2;
  } else {
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = 0;
    var x1___1 = u;
    var x1___2 = b;
  }
  var unscaled = $as_T(x1___1);
  var bufLength = $uI(x1___2);
  if (((index <= last) && $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$charEqualTo__C__AC__Z($n(in$1).get(index), new $ac_C(new Uint16Array([101, 69]))))) {
    index = ((1 + index) | 0);
    var indexIsPlus = ((index <= last) && ($n(in$1).get(index) === 43));
    var nextIsNotMinus = ((((1 + index) | 0) <= last) && ($n(in$1).get(((1 + index) | 0)) !== 45));
    var begin$3 = ((indexIsPlus && nextIsNotMinus) ? ((1 + index) | 0) : index);
    var count$2 = ((((1 + last) | 0) - begin$3) | 0);
    var this$3 = $m_jl_String$();
    var scaleString = this$3.new__AC__I__I__T(in$1, begin$3, count$2);
    var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var this$5 = $m_jl_Integer$();
    var value$1 = this$5.parseInt__T__I__I(scaleString, 10);
    var hi$1 = (value$1 >> 31);
    var lo = ((value - value$1) | 0);
    var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = lo;
    var value$2 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi$3 = (value$2 >> 31);
    if ((!((lo === value$2) && (hi$2 === hi$3)))) {
      throw new $c_jl_NumberFormatException("Scale out of range");
    }
  }
  if ((bufLength < 19)) {
    var this$9 = $m_jl_Long$();
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = this$9.parseLong__T__I__J(unscaled, 10);
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().bitLength__J__I($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue);
  } else {
    $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, $ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), unscaled));
  }
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__T__Ljava_math_MathContext__($thiz, sVal, mc) {
  var $x_1 = $f_T__toCharArray__AC($n(sVal));
  var this$1 = $n(sVal);
  $ct_Ljava_math_BigDecimal__AC__I__I__($thiz, $x_1, 0, this$1.length);
  $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V($thiz, mc);
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__($thiz, unscaledVal, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  if ((unscaledVal === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "unscaledVal == null");
  }
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = scale;
  $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, unscaledVal);
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__($thiz, bi) {
  $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__($thiz, bi, 0);
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__J__Ljava_math_MathContext__($thiz, lVal, mc) {
  $ct_Ljava_math_BigDecimal__J__I__($thiz, lVal, 0);
  $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V($thiz, mc);
  return $thiz;
}
/** @constructor */
function $c_Ljava_math_BigDecimal() {
  this.Ljava_math_BigDecimal__f__toStringImage = null;
  this.Ljava_math_BigDecimal__f__hashCode = 0;
  this.Ljava_math_BigDecimal__f__intVal = null;
  this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = 0;
  this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = $L0;
  this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = 0;
  this.Ljava_math_BigDecimal__f__precision = 0;
}
$c_Ljava_math_BigDecimal.prototype = new $h_jl_Number();
$c_Ljava_math_BigDecimal.prototype.constructor = $c_Ljava_math_BigDecimal;
/** @constructor */
function $h_Ljava_math_BigDecimal() {
}
$h_Ljava_math_BigDecimal.prototype = $c_Ljava_math_BigDecimal.prototype;
$c_Ljava_math_BigDecimal.prototype.add__Ljava_math_BigDecimal__Ljava_math_BigDecimal = (function(augend) {
  var diffScale = ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale - $n(augend).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
  if (($p_Ljava_math_BigDecimal__isZero__Z(this) && (diffScale <= 0))) {
    return augend;
  } else if (($p_Ljava_math_BigDecimal__isZero__Z($n(augend)) && ($p_Ljava_math_BigDecimal__isZero__Z(this) || (diffScale >= 0)))) {
    return this;
  } else if ((diffScale === 0)) {
    var a = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
    var b = $n(augend).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
    if ((((1 + ((a > b) ? a : b)) | 0) < 64)) {
      var $x_1 = $m_Ljava_math_BigDecimal$();
      var this$2 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var b$1 = $n(augend).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var alo = this$2.RTLong__f_lo;
      var ahi = this$2.RTLong__f_hi;
      var bhi = b$1.RTLong__f_hi;
      var lo = ((alo + b$1.RTLong__f_lo) | 0);
      var hi = ((((-2147483648) ^ lo) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + bhi) | 0)) | 0) : ((ahi + bhi) | 0));
      return $n($x_1).valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo, hi), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
    } else {
      var this$4 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
      var bi = $n(augend).java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$4, bi), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
    }
  } else {
    return ((diffScale > 0) ? $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$addAndMult10__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__Ljava_math_BigDecimal(this, augend, diffScale) : $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$addAndMult10__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__Ljava_math_BigDecimal(augend, this, ((-diffScale) | 0)));
  }
});
$c_Ljava_math_BigDecimal.prototype.signum__I = (function() {
  if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    var this$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var ahi = this$1.RTLong__f_hi;
    if ((ahi < 0)) {
      return (-1);
    } else {
      var this$2 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var ahi$1 = this$2.RTLong__f_hi;
      if (((ahi$1 === 0) ? (this$2.RTLong__f_lo !== 0) : (ahi$1 > 0))) {
        return 1;
      } else {
        return 0;
      }
    }
  } else {
    var this$3 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
    return this$3.Ljava_math_BigInteger__f_sign;
  }
});
$c_Ljava_math_BigDecimal.prototype.precision__I = (function() {
  if ((this.Ljava_math_BigDecimal__f__precision === 0)) {
    if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength === 0)) {
      var $x_1 = 1;
    } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
      var $x_1 = $p_Ljava_math_BigDecimal__decimalDigitsInLong__J__I(this, this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue);
    } else {
      var decimalDigits = ((1 + $doubleToInt((0.3010299956639812 * (((-1) + this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength) | 0)))) | 0);
      var $x_3 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      var $x_2 = $m_Ljava_math_Multiplication$();
      var hi = (decimalDigits >> 31);
      var this$2 = $n($n($x_3).divide__Ljava_math_BigInteger__Ljava_math_BigInteger($n($x_2).powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(decimalDigits, hi))));
      if ((this$2.Ljava_math_BigInteger__f_sign !== 0)) {
        var $x_1 = ((1 + decimalDigits) | 0);
      } else {
        var $x_1 = decimalDigits;
      }
    }
    this.Ljava_math_BigDecimal__f__precision = $x_1;
  }
  return this.Ljava_math_BigDecimal__f__precision;
});
$c_Ljava_math_BigDecimal.prototype.scaleByPowerOfTen__I__Ljava_math_BigDecimal = (function(n) {
  var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var hi$1 = (n >> 31);
  var lo = ((value - n) | 0);
  var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
  if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    var this$4 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    if (((this$4.RTLong__f_lo === 0) && (this$4.RTLong__f_hi === 0))) {
      return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$zeroScaledBy__J__Ljava_math_BigDecimal(new $c_RTLong(lo, hi$2));
    } else {
      return $m_Ljava_math_BigDecimal$().valueOf__J__I__Ljava_math_BigDecimal(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo, hi$2)));
    }
  } else {
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger(), $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo, hi$2)));
  }
});
$c_Ljava_math_BigDecimal.prototype.stripTrailingZeros__Ljava_math_BigDecimal = (function() {
  if ($p_Ljava_math_BigDecimal__isZero__Z(this)) {
    return this;
  } else {
    var lastPow = (((-1) + $n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows).u.length) | 0);
    var i = 1;
    var strippedBI = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var scale__lo = value;
    var scale__hi = hi;
    var x1___1;
    var x1___2;
    while (true) {
      if ((!$n(strippedBI).testBit__I__Z(0))) {
        var qr = $n(strippedBI).divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem($n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows).get(i));
        var this$2 = $n($n(qr).Ljava_math_BigInteger$QuotAndRem__f_rem);
        if ((this$2.Ljava_math_BigInteger__f_sign === 0)) {
          var temp$i = ((i < lastPow) ? ((1 + i) | 0) : i);
          var temp$strippedBI = $n(qr).Ljava_math_BigInteger$QuotAndRem__f_quot;
          var this$4__lo = scale__lo;
          var this$4__hi = scale__hi;
          var value$1 = i;
          var hi$1 = (value$1 >> 31);
          var alo = this$4__lo;
          var ahi = this$4__hi;
          var lo = ((alo - value$1) | 0);
          var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - hi$1) | 0)) | 0) : ((ahi - hi$1) | 0));
          i = temp$i;
          strippedBI = temp$strippedBI;
          var $x_1__lo = lo;
          var $x_1__hi = hi$2;
          scale__lo = $x_1__lo;
          scale__hi = $x_1__hi;
          continue;
        }
        if ((i !== 1)) {
          i = 1;
          continue;
        }
        var _1 = strippedBI;
        var _2__lo = scale__lo;
        var _2__hi = scale__hi;
        var x1___1 = _1;
        var x1___2 = new $c_RTLong(_2__lo, _2__hi);
        break;
      } else {
        var _1$1 = strippedBI;
        var _2$1__lo = scale__lo;
        var _2$1__hi = scale__hi;
        var x1___1 = _1$1;
        var x1___2 = new $c_RTLong(_2$1__lo, _2$1__hi);
        break;
      }
    }
    var strippedBI$1 = $as_Ljava_math_BigInteger(x1___1);
    var t = $uJ(x1___2);
    var lo$1 = t.RTLong__f_lo;
    var hi$3 = t.RTLong__f_hi;
    var t$1 = $uJ(new $c_RTLong(lo$1, hi$3));
    var lo$2 = t$1.RTLong__f_lo;
    var hi$4 = t$1.RTLong__f_hi;
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), strippedBI$1, $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo$2, hi$4)));
  }
});
$c_Ljava_math_BigDecimal.prototype.compareTo__Ljava_math_BigDecimal__I = (function(bi) {
  var thisSign = this.signum__I();
  var valueSign = $n(bi).signum__I();
  if ((thisSign === valueSign)) {
    if ((((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === $n(bi).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) && (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) && ($n(bi).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64))) {
      var this$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var b = $n(bi).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var ahi = this$1.RTLong__f_hi;
      var bhi = b.RTLong__f_hi;
      if (((ahi === bhi) ? (((-2147483648) ^ this$1.RTLong__f_lo) < ((-2147483648) ^ b.RTLong__f_lo)) : (ahi < bhi))) {
        return (-1);
      } else {
        var this$2 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        var b$1 = $n(bi).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        var ahi$1 = this$2.RTLong__f_hi;
        var bhi$1 = b$1.RTLong__f_hi;
        if (((ahi$1 === bhi$1) ? (((-2147483648) ^ this$2.RTLong__f_lo) > ((-2147483648) ^ b$1.RTLong__f_lo)) : (ahi$1 > bhi$1))) {
          return 1;
        } else {
          return 0;
        }
      }
    } else {
      var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi = (value >> 31);
      var value$1 = $n(bi).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi$1 = (value$1 >> 31);
      var lo = ((value - value$1) | 0);
      var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
      var diffPrecision = (($p_Ljava_math_BigDecimal__approxPrecision__I(this) - $p_Ljava_math_BigDecimal__approxPrecision__I($n(bi))) | 0);
      var hi$3 = (diffPrecision >> 31);
      var lo$1 = ((1 + lo) | 0);
      var hi$4 = ((lo$1 === 0) ? ((1 + hi$2) | 0) : hi$2);
      if (((hi$3 === hi$4) ? (((-2147483648) ^ diffPrecision) > ((-2147483648) ^ lo$1)) : (hi$3 > hi$4))) {
        return thisSign;
      } else {
        var hi$5 = (diffPrecision >> 31);
        var lo$2 = (((-1) + lo) | 0);
        var hi$6 = ((lo$2 !== (-1)) ? hi$2 : (((-1) + hi$2) | 0));
        if (((hi$5 === hi$6) ? (((-2147483648) ^ diffPrecision) < ((-2147483648) ^ lo$2)) : (hi$5 < hi$6))) {
          return ((-thisSign) | 0);
        } else {
          var t = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
          var v = $n(bi).java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
          if ((hi$2 < 0)) {
            var $x_2 = $n(t);
            var $x_1 = $m_Ljava_math_Multiplication$();
            var lo$3 = ((-lo) | 0);
            var hi$7 = ((lo !== 0) ? (~hi$2) : ((-hi$2) | 0));
            var _1 = $n($x_2).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n($x_1).powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo$3, hi$7)));
            var x1___1 = _1;
            var x1___2 = v;
          } else if (((hi$2 === 0) ? (lo !== 0) : (hi$2 > 0))) {
            var _2 = $n(v).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_Multiplication$().powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi$2)));
            var x1___1 = t;
            var x1___2 = _2;
          } else {
            var x1___1 = t;
            var x1___2 = v;
          }
          var thisUnscaled = $as_Ljava_math_BigInteger(x1___1);
          var valUnscaled = $as_Ljava_math_BigInteger(x1___2);
          return $n(thisUnscaled).compareTo__Ljava_math_BigInteger__I(valUnscaled);
        }
      }
    }
  } else {
    return ((thisSign < valueSign) ? (-1) : 1);
  }
});
$c_Ljava_math_BigDecimal.prototype.equals__O__Z = (function(x) {
  if ((x instanceof $c_Ljava_math_BigDecimal)) {
    var x2 = $as_Ljava_math_BigDecimal(x);
    if (($n(x2).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)) {
      if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
        var this$1 = $n(x2).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        var b = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        return ((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi));
      } else {
        return $n(this.Ljava_math_BigDecimal__f__intVal).equals__O__Z($n(x2).Ljava_math_BigDecimal__f__intVal);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ljava_math_BigDecimal.prototype.hashCode__I = (function() {
  if ((this.Ljava_math_BigDecimal__f__hashCode !== 0)) {
    return this.Ljava_math_BigDecimal__f__hashCode;
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    var this$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    this.Ljava_math_BigDecimal__f__hashCode = this$1.RTLong__f_lo;
    var $x_1 = this.Ljava_math_BigDecimal__f__hashCode;
    var this$2 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var hi = this$2.RTLong__f_hi;
    this.Ljava_math_BigDecimal__f__hashCode = ((Math.imul(33, $x_1) + hi) | 0);
    this.Ljava_math_BigDecimal__f__hashCode = ((Math.imul(17, this.Ljava_math_BigDecimal__f__hashCode) + this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
    return this.Ljava_math_BigDecimal__f__hashCode;
  } else {
    this.Ljava_math_BigDecimal__f__hashCode = ((Math.imul(17, $n(this.Ljava_math_BigDecimal__f__intVal).hashCode__I()) + this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
    return this.Ljava_math_BigDecimal__f__hashCode;
  }
});
$c_Ljava_math_BigDecimal.prototype.toString__T = (function() {
  if ((this.Ljava_math_BigDecimal__f__toStringImage !== null)) {
    return this.Ljava_math_BigDecimal__f__toStringImage;
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 32)) {
    this.Ljava_math_BigDecimal__f__toStringImage = $m_Ljava_math_Conversion$().toDecimalScaledString__J__I__T(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
    return this.Ljava_math_BigDecimal__f__toStringImage;
  } else {
    var this$1 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
    var intString = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1);
    if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0)) {
      return intString;
    } else {
      var this$2 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
      if ((this$2.Ljava_math_BigInteger__f_sign < 0)) {
        var begin = 2;
      } else {
        var begin = 1;
      }
      var this$3 = $n(intString);
      var end = this$3.length;
      var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi = (value >> 31);
      var lo = ((-value) | 0);
      var hi$1 = ((value !== 0) ? (~hi) : ((-hi) | 0));
      var hi$2 = (end >> 31);
      var lo$1 = ((lo + end) | 0);
      var hi$3 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + ((hi$1 + hi$2) | 0)) | 0) : ((hi$1 + hi$2) | 0));
      var hi$4 = (begin >> 31);
      var lo$2 = ((lo$1 - begin) | 0);
      var hi$5 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ lo$1)) ? (((-1) + ((hi$3 - hi$4) | 0)) | 0) : ((hi$3 - hi$4) | 0));
      if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > 0) && ((hi$5 === (-1)) ? (((-2147483648) ^ lo$2) >= 2147483642) : (hi$5 > (-1))))) {
        if ((hi$5 >= 0)) {
          $m_Ljava_math_BigDecimal$();
          var pos = ((end - this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
          $m_Ljava_math_BigDecimal$();
          var this$14 = $n(intString);
          if ((pos > this$14.length)) {
            $charAt(this$14, pos);
          }
          if ((pos < 0)) {
            $charAt(this$14, (-1));
          }
          var $x_1 = $as_T(this$14.substring(0, pos));
          var this$15 = $n(intString);
          if (((pos < 0) || (pos > this$15.length))) {
            $charAt(this$15, pos);
          }
          var result = (($x_1 + ".") + $as_T(this$15.substring(pos)));
        } else {
          $m_Ljava_math_BigDecimal$();
          $m_Ljava_math_BigDecimal$();
          var pos$1 = (((-1) + begin) | 0);
          $m_Ljava_math_BigDecimal$();
          var this$19 = $n(intString);
          if ((pos$1 > this$19.length)) {
            $charAt(this$19, pos$1);
          }
          if ((pos$1 < 0)) {
            $charAt(this$19, (-1));
          }
          var $x_2 = $as_T(this$19.substring(0, pos$1));
          var this$20 = $n(intString);
          if (((pos$1 < 0) || (pos$1 > this$20.length))) {
            $charAt(this$20, pos$1);
          }
          var s = (($x_2 + "0.") + $as_T(this$20.substring(pos$1)));
          var pos$2 = ((1 + begin) | 0);
          var s2 = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros;
          var s2Len = (((-1) - lo$2) | 0);
          $m_Ljava_math_BigDecimal$();
          var this$24 = $n(s2);
          if ((s2Len > this$24.length)) {
            $charAt(this$24, s2Len);
          }
          if ((s2Len < 0)) {
            $charAt(this$24, (-1));
          }
          var s2$1 = $as_T(this$24.substring(0, s2Len));
          if ((pos$2 > s.length)) {
            $charAt(s, pos$2);
          }
          if ((pos$2 < 0)) {
            $charAt(s, (-1));
          }
          var $x_3 = $as_T(s.substring(0, pos$2));
          if (((pos$2 < 0) || (pos$2 > s.length))) {
            $charAt(s, pos$2);
          }
          var result = ((("" + $x_3) + s2$1) + $as_T(s.substring(pos$2)));
        }
      } else {
        if ((((end - begin) | 0) >= 1)) {
          $m_Ljava_math_BigDecimal$();
          $m_Ljava_math_BigDecimal$();
          var this$28 = $n(intString);
          if ((begin > this$28.length)) {
            $charAt(this$28, begin);
          }
          if ((begin < 0)) {
            $charAt(this$28, (-1));
          }
          var $x_4 = $as_T(this$28.substring(0, begin));
          var this$29 = $n(intString);
          if (((begin < 0) || (begin > this$29.length))) {
            $charAt(this$29, begin);
          }
          var r0 = (($x_4 + ".") + $as_T(this$29.substring(begin)));
        } else {
          var r0 = intString;
        }
        var r1 = (r0 + "E");
        var r2 = (((hi$5 === 0) ? (lo$2 !== 0) : (hi$5 > 0)) ? (r1 + "+") : r1);
        var result = (r2 + $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo$2, hi$5));
      }
      this.Ljava_math_BigDecimal__f__toStringImage = result;
      return this.Ljava_math_BigDecimal__f__toStringImage;
    }
  }
});
$c_Ljava_math_BigDecimal.prototype.toBigInteger__Ljava_math_BigInteger = (function() {
  if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0) || $p_Ljava_math_BigDecimal__isZero__Z(this))) {
    return this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale < 0)) {
    var $x_2 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
    var $x_1 = $m_Ljava_math_Multiplication$();
    var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var lo = ((-value) | 0);
    var hi$1 = ((value !== 0) ? (~hi) : ((-hi) | 0));
    return $n($x_2).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n($x_1).powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi$1)));
  } else {
    var $x_4 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
    var $x_3 = $m_Ljava_math_Multiplication$();
    var value$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi$2 = (value$1 >> 31);
    return $n($x_4).divide__Ljava_math_BigInteger__Ljava_math_BigInteger($n($x_3).powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(value$1, hi$2)));
  }
});
$c_Ljava_math_BigDecimal.prototype.toBigIntegerExact__Ljava_math_BigInteger = (function() {
  if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0) || $p_Ljava_math_BigDecimal__isZero__Z(this))) {
    return this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale < 0)) {
    var $x_2 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
    var $x_1 = $m_Ljava_math_Multiplication$();
    var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var lo = ((-value) | 0);
    var hi$1 = ((value !== 0) ? (~hi) : ((-hi) | 0));
    return $n($x_2).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n($x_1).powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi$1)));
  } else {
    if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > $p_Ljava_math_BigDecimal__approxPrecision__I(this)) || (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger()).getLowestSetBit__I()))) {
      throw new $c_jl_ArithmeticException("Rounding necessary");
    }
    var $x_4 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
    var $x_3 = $m_Ljava_math_Multiplication$();
    var value$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi$2 = (value$1 >> 31);
    var integerAndFraction = $n($x_4).divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger($n($x_3).powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(value$1, hi$2)));
    var this$5 = $n($n(integerAndFraction).get(1));
    if ((this$5.Ljava_math_BigInteger__f_sign !== 0)) {
      throw new $c_jl_ArithmeticException("Rounding necessary");
    }
    return $n(integerAndFraction).get(0);
  }
});
$c_Ljava_math_BigDecimal.prototype.longValue__J = (function() {
  return (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= (-64)) || (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > $p_Ljava_math_BigDecimal__approxPrecision__I(this))) ? $L0 : $n(this.toBigInteger__Ljava_math_BigInteger()).longValue__J());
});
$c_Ljava_math_BigDecimal.prototype.intValue__I = (function() {
  return (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= (-32)) || (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > $p_Ljava_math_BigDecimal__approxPrecision__I(this))) ? 0 : $n(this.toBigInteger__Ljava_math_BigInteger()).intValue__I());
});
$c_Ljava_math_BigDecimal.prototype.intValueExact__I = (function() {
  var this$1 = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 32);
  return this$1.RTLong__f_lo;
});
$c_Ljava_math_BigDecimal.prototype.shortValueExact__S = (function() {
  var this$1 = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 16);
  return ((this$1.RTLong__f_lo << 16) >> 16);
});
$c_Ljava_math_BigDecimal.prototype.byteValueExact__B = (function() {
  var this$1 = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 8);
  return ((this$1.RTLong__f_lo << 24) >> 24);
});
$c_Ljava_math_BigDecimal.prototype.floatValue__F = (function() {
  return $m_jl_Float$().parseFloat__T__F(((this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger() + "e") + ((-this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0)));
});
$c_Ljava_math_BigDecimal.prototype.doubleValue__D = (function() {
  return $m_jl_Double$().parseDouble__T__D(((this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger() + "e") + ((-this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0)));
});
$c_Ljava_math_BigDecimal.prototype.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger = (function() {
  if ((this.Ljava_math_BigDecimal__f__intVal === null)) {
    this.Ljava_math_BigDecimal__f__intVal = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue);
  }
  return this.Ljava_math_BigDecimal__f__intVal;
});
$c_Ljava_math_BigDecimal.prototype.compareTo__O__I = (function(o) {
  return this.compareTo__Ljava_math_BigDecimal__I($as_Ljava_math_BigDecimal(o));
});
function $as_Ljava_math_BigDecimal(obj) {
  return (((obj instanceof $c_Ljava_math_BigDecimal) || (obj === null)) ? obj : $throwClassCastException(obj, "java.math.BigDecimal"));
}
function $isArrayOf_Ljava_math_BigDecimal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_math_BigDecimal)));
}
function $asArrayOf_Ljava_math_BigDecimal(obj, depth) {
  return (($isArrayOf_Ljava_math_BigDecimal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.math.BigDecimal;", depth));
}
var $d_Ljava_math_BigDecimal = new $TypeData().initClass($c_Ljava_math_BigDecimal, "java.math.BigDecimal", ({
  Ljava_math_BigDecimal: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
}));
function $p_Ljava_math_BigInteger__setFromString__T__I__V($thiz, s, radix) {
  if ((((s === "") || (s === "+")) || (s === "-"))) {
    throw new $c_jl_NumberFormatException("Zero length BigInteger");
  }
  var this$1 = $n(s);
  var stringLength0 = this$1.length;
  var this$2 = $n(s);
  if (($charAt(this$2, 0) === 45)) {
    var _3 = (((-1) + stringLength0) | 0);
    var x1___1 = (-1);
    var x1___2 = 1;
    var x1___3 = _3;
  } else {
    var this$3 = $n(s);
    if (($charAt(this$3, 0) === 43)) {
      var _3$1 = (((-1) + stringLength0) | 0);
      var x1___1 = 1;
      var x1___2 = 1;
      var x1___3 = _3$1;
    } else {
      var x1___1 = 1;
      var x1___2 = 0;
      var x1___3 = stringLength0;
    }
  }
  var _sign = $uI(x1___1);
  var startChar = $uI(x1___2);
  var stringLength = $uI(x1___3);
  var i = startChar;
  while ((i < stringLength0)) {
    var i$2 = i;
    var this$6 = $n(s);
    var c = $charAt(this$6, i$2);
    if (((c === 43) || (c === 45))) {
      throw new $c_jl_NumberFormatException("Illegal embedded sign character");
    }
    i = ((1 + i) | 0);
  }
  var charsPerInt = $n($m_Ljava_math_Conversion$().Ljava_math_Conversion$__f_DigitFitInInt).get(radix);
  var bigRadixDigitsLength = $intDiv(stringLength, charsPerInt);
  var topChars = $intMod(stringLength, charsPerInt);
  if ((topChars !== 0)) {
    bigRadixDigitsLength = ((1 + bigRadixDigitsLength) | 0);
  }
  var _digits = new $ac_I(bigRadixDigitsLength);
  var bigRadix = $n($m_Ljava_math_Conversion$().Ljava_math_Conversion$__f_BigRadices).get((((-2) + radix) | 0));
  var digitIndex = 0;
  var substrEnd = ((startChar + ((topChars === 0) ? charsPerInt : topChars)) | 0);
  var newDigit = 0;
  var substrStart = startChar;
  while ((substrStart < stringLength0)) {
    var $x_1 = $m_jl_Integer$();
    var this$7 = $n(s);
    var beginIndex = substrStart;
    var endIndex = substrEnd;
    if ((beginIndex < 0)) {
      $charAt(this$7, beginIndex);
    }
    if ((endIndex > this$7.length)) {
      $charAt(this$7, endIndex);
    }
    if ((endIndex < beginIndex)) {
      $charAt(this$7, (-1));
    }
    var bigRadixDigit = $n($x_1).parseInt__T__I__I($as_T(this$7.substring(beginIndex, endIndex)), radix);
    var this$8 = $m_Ljava_math_Multiplication$();
    var aSize = digitIndex;
    newDigit = $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this$8, _digits, _digits, aSize, bigRadix);
    newDigit = ((newDigit + $m_Ljava_math_Elementary$().inplaceAdd__AI__I__I__I(_digits, digitIndex, bigRadixDigit)) | 0);
    $n(_digits).set(digitIndex, newDigit);
    digitIndex = ((1 + digitIndex) | 0);
    substrStart = substrEnd;
    substrEnd = ((substrStart + charsPerInt) | 0);
  }
  $thiz.Ljava_math_BigInteger__f_sign = _sign;
  $thiz.Ljava_math_BigInteger__f_numberLength = digitIndex;
  $thiz.Ljava_math_BigInteger__f_digits = _digits;
  $thiz.cutOffLeadingZeroes__V();
}
function $ct_Ljava_math_BigInteger__($thiz) {
  $thiz.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit = (-2);
  $thiz.Ljava_math_BigInteger__f__hashCode = 0;
  return $thiz;
}
function $ct_Ljava_math_BigInteger__T__I__($thiz, s, radix) {
  $ct_Ljava_math_BigInteger__($thiz);
  $m_Ljava_math_BigInteger$();
  if ((s === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if (((radix < 2) || (radix > 36))) {
    throw new $c_jl_NumberFormatException("Radix out of range");
  }
  var this$2 = $n(s);
  if ((this$2 === "")) {
    throw new $c_jl_NumberFormatException("Zero length BigInteger");
  }
  $p_Ljava_math_BigInteger__setFromString__T__I__V($thiz, s, radix);
  return $thiz;
}
function $ct_Ljava_math_BigInteger__T__($thiz, s) {
  $ct_Ljava_math_BigInteger__T__I__($thiz, s, 10);
  return $thiz;
}
function $ct_Ljava_math_BigInteger__I__I__($thiz, sign, value) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.Ljava_math_BigInteger__f_sign = sign;
  $thiz.Ljava_math_BigInteger__f_numberLength = 1;
  $thiz.Ljava_math_BigInteger__f_digits = new $ac_I(new Int32Array([value]));
  return $thiz;
}
function $ct_Ljava_math_BigInteger__I__AI__($thiz, signum, digits) {
  $ct_Ljava_math_BigInteger__($thiz);
  if (($n(digits).u.length === 0)) {
    $thiz.Ljava_math_BigInteger__f_sign = 0;
    $thiz.Ljava_math_BigInteger__f_numberLength = 1;
    $thiz.Ljava_math_BigInteger__f_digits = new $ac_I(new Int32Array([0]));
  } else {
    $thiz.Ljava_math_BigInteger__f_sign = signum;
    $thiz.Ljava_math_BigInteger__f_numberLength = $n(digits).u.length;
    $thiz.Ljava_math_BigInteger__f_digits = digits;
    $thiz.cutOffLeadingZeroes__V();
  }
  return $thiz;
}
function $ct_Ljava_math_BigInteger__I__I__AI__($thiz, sign, numberLength, digits) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.Ljava_math_BigInteger__f_sign = sign;
  $thiz.Ljava_math_BigInteger__f_numberLength = numberLength;
  $thiz.Ljava_math_BigInteger__f_digits = digits;
  return $thiz;
}
function $ct_Ljava_math_BigInteger__I__J__($thiz, sign, lVal) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.Ljava_math_BigInteger__f_sign = sign;
  var hi = lVal.RTLong__f_hi;
  if ((hi === 0)) {
    $thiz.Ljava_math_BigInteger__f_numberLength = 1;
    $thiz.Ljava_math_BigInteger__f_digits = new $ac_I(new Int32Array([lVal.RTLong__f_lo]));
  } else {
    $thiz.Ljava_math_BigInteger__f_numberLength = 2;
    $thiz.Ljava_math_BigInteger__f_digits = new $ac_I(new Int32Array([lVal.RTLong__f_lo, hi]));
  }
  return $thiz;
}
/** @constructor */
function $c_Ljava_math_BigInteger() {
  this.Ljava_math_BigInteger__f_digits = null;
  this.Ljava_math_BigInteger__f_numberLength = 0;
  this.Ljava_math_BigInteger__f_sign = 0;
  this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit = 0;
  this.Ljava_math_BigInteger__f__hashCode = 0;
}
$c_Ljava_math_BigInteger.prototype = new $h_jl_Number();
$c_Ljava_math_BigInteger.prototype.constructor = $c_Ljava_math_BigInteger;
/** @constructor */
function $h_Ljava_math_BigInteger() {
}
$h_Ljava_math_BigInteger.prototype = $c_Ljava_math_BigInteger.prototype;
$c_Ljava_math_BigInteger.prototype.abs__Ljava_math_BigInteger = (function() {
  return ((this.Ljava_math_BigInteger__f_sign < 0) ? $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), 1, this.Ljava_math_BigInteger__f_numberLength, this.Ljava_math_BigInteger__f_digits) : this);
});
$c_Ljava_math_BigInteger.prototype.compareTo__Ljava_math_BigInteger__I = (function(bi) {
  return ((this.Ljava_math_BigInteger__f_sign > $n(bi).Ljava_math_BigInteger__f_sign) ? 1 : ((this.Ljava_math_BigInteger__f_sign < $n(bi).Ljava_math_BigInteger__f_sign) ? (-1) : ((this.Ljava_math_BigInteger__f_numberLength > $n(bi).Ljava_math_BigInteger__f_numberLength) ? this.Ljava_math_BigInteger__f_sign : ((this.Ljava_math_BigInteger__f_numberLength < $n(bi).Ljava_math_BigInteger__f_numberLength) ? ((-$n(bi).Ljava_math_BigInteger__f_sign) | 0) : Math.imul(this.Ljava_math_BigInteger__f_sign, $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I(this.Ljava_math_BigInteger__f_digits, $n(bi).Ljava_math_BigInteger__f_digits, this.Ljava_math_BigInteger__f_numberLength))))));
});
$c_Ljava_math_BigInteger.prototype.divide__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(divisor) {
  if (($n(divisor).Ljava_math_BigInteger__f_sign === 0)) {
    throw new $c_jl_ArithmeticException("BigInteger divide by zero");
  }
  var divisorSign = $n(divisor).Ljava_math_BigInteger__f_sign;
  if ($n(divisor).isOne__Z()) {
    return (($n(divisor).Ljava_math_BigInteger__f_sign > 0) ? this : this.negate__Ljava_math_BigInteger());
  } else {
    var thisSign = this.Ljava_math_BigInteger__f_sign;
    var thisLen = this.Ljava_math_BigInteger__f_numberLength;
    var divisorLen = $n(divisor).Ljava_math_BigInteger__f_numberLength;
    if ((((thisLen + divisorLen) | 0) === 2)) {
      var value = $n(this.Ljava_math_BigInteger__f_digits).get(0);
      var value$1 = $n($n(divisor).Ljava_math_BigInteger__f_digits).get(0);
      var this$3 = $m_RTLong$();
      var lo = this$3.divideImpl__I__I__I__I__I(value, 0, value$1, 0);
      var hi$2 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var bi__lo = lo;
      var bi__hi = hi$2;
      if ((thisSign !== divisorSign)) {
        var this$4__lo = bi__lo;
        var this$4__hi = bi__hi;
        var lo$1 = this$4__lo;
        var hi$3 = this$4__hi;
        var lo$2 = ((-lo$1) | 0);
        var hi$4 = ((lo$1 !== 0) ? (~hi$3) : ((-hi$3) | 0));
        var $x_1__lo = lo$2;
        var $x_1__hi = hi$4;
        bi__lo = $x_1__lo;
        bi__hi = $x_1__hi;
      }
      return $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(bi__lo, bi__hi));
    } else {
      var cmp = ((thisLen !== divisorLen) ? ((thisLen > divisorLen) ? 1 : (-1)) : $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I(this.Ljava_math_BigInteger__f_digits, $n(divisor).Ljava_math_BigInteger__f_digits, thisLen));
      if ((cmp === 0)) {
        return ((thisSign === divisorSign) ? $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE : $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_MINUS_ONE);
      } else if ((cmp === (-1))) {
        return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
      } else {
        var resLength = ((1 + ((thisLen - divisorLen) | 0)) | 0);
        var resDigits = new $ac_I(resLength);
        var resSign = ((thisSign === divisorSign) ? 1 : (-1));
        if ((divisorLen === 1)) {
          $m_Ljava_math_Division$().divideArrayByInt__AI__AI__I__I__I(resDigits, this.Ljava_math_BigInteger__f_digits, thisLen, $n($n(divisor).Ljava_math_BigInteger__f_digits).get(0));
        } else {
          $m_Ljava_math_Division$().divide__AI__I__AI__I__AI__I__AI(resDigits, resLength, this.Ljava_math_BigInteger__f_digits, thisLen, $n(divisor).Ljava_math_BigInteger__f_digits, divisorLen);
        }
        var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
        result.cutOffLeadingZeroes__V();
        return result;
      }
    }
  }
});
$c_Ljava_math_BigInteger.prototype.divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger = (function(divisor) {
  return $n(this.divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem(divisor)).toArray__ALjava_math_BigInteger();
});
$c_Ljava_math_BigInteger.prototype.divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem = (function(divisor) {
  var divisorSign = $n(divisor).Ljava_math_BigInteger__f_sign;
  if ((divisorSign === 0)) {
    throw new $c_jl_ArithmeticException("BigInteger divide by zero");
  }
  var divisorLen = $n(divisor).Ljava_math_BigInteger__f_numberLength;
  var divisorDigits = $n(divisor).Ljava_math_BigInteger__f_digits;
  if ((divisorLen === 1)) {
    return $m_Ljava_math_Division$().divideAndRemainderByInteger__Ljava_math_BigInteger__I__I__Ljava_math_BigInteger$QuotAndRem(this, $n(divisorDigits).get(0), divisorSign);
  } else {
    var thisDigits = this.Ljava_math_BigInteger__f_digits;
    var thisLen = this.Ljava_math_BigInteger__f_numberLength;
    var cmp = ((thisLen !== divisorLen) ? ((thisLen > divisorLen) ? 1 : (-1)) : $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I(thisDigits, divisorDigits, thisLen));
    if ((cmp < 0)) {
      return new $c_Ljava_math_BigInteger$QuotAndRem($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO, this);
    } else {
      var thisSign = this.Ljava_math_BigInteger__f_sign;
      var quotientLength = ((1 + ((thisLen - divisorLen) | 0)) | 0);
      var quotientSign = ((thisSign === divisorSign) ? 1 : (-1));
      var quotientDigits = new $ac_I(quotientLength);
      var remainderDigits = $m_Ljava_math_Division$().divide__AI__I__AI__I__AI__I__AI(quotientDigits, quotientLength, thisDigits, thisLen, divisorDigits, divisorLen);
      var result0 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), quotientSign, quotientLength, quotientDigits);
      var result1 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), thisSign, divisorLen, remainderDigits);
      result0.cutOffLeadingZeroes__V();
      result1.cutOffLeadingZeroes__V();
      return new $c_Ljava_math_BigInteger$QuotAndRem(result0, result1);
    }
  }
});
$c_Ljava_math_BigInteger.prototype.equals__O__Z = (function(x) {
  if ((x instanceof $c_Ljava_math_BigInteger)) {
    var x2 = $as_Ljava_math_BigInteger(x);
    return (((this.Ljava_math_BigInteger__f_sign === $n(x2).Ljava_math_BigInteger__f_sign) && (this.Ljava_math_BigInteger__f_numberLength === $n(x2).Ljava_math_BigInteger__f_numberLength)) && this.equalsArrays__AI__Z($n(x2).Ljava_math_BigInteger__f_digits));
  } else {
    return false;
  }
});
$c_Ljava_math_BigInteger.prototype.getLowestSetBit__I = (function() {
  if ((this.Ljava_math_BigInteger__f_sign === 0)) {
    return (-1);
  } else {
    var i = this.getFirstNonzeroDigit__I();
    var i$1 = $n(this.Ljava_math_BigInteger__f_digits).get(i);
    if ((i$1 === 0)) {
      var $x_1 = 32;
    } else {
      var i$2 = (i$1 & ((-i$1) | 0));
      var $x_1 = ((31 - $uI(Math.clz32(i$2))) | 0);
    }
    return (((i << 5) + $x_1) | 0);
  }
});
$c_Ljava_math_BigInteger.prototype.hashCode__I = (function() {
  if ((this.Ljava_math_BigInteger__f__hashCode !== 0)) {
    return this.Ljava_math_BigInteger__f__hashCode;
  } else {
    var end = this.Ljava_math_BigInteger__f_numberLength;
    var i = 0;
    while ((i < end)) {
      var i$2 = i;
      this.Ljava_math_BigInteger__f__hashCode = ((Math.imul(33, this.Ljava_math_BigInteger__f__hashCode) + $n(this.Ljava_math_BigInteger__f_digits).get(i$2)) | 0);
      i = ((1 + i) | 0);
    }
    this.Ljava_math_BigInteger__f__hashCode = Math.imul(this.Ljava_math_BigInteger__f__hashCode, this.Ljava_math_BigInteger__f_sign);
    return this.Ljava_math_BigInteger__f__hashCode;
  }
});
$c_Ljava_math_BigInteger.prototype.intValue__I = (function() {
  return Math.imul(this.Ljava_math_BigInteger__f_sign, $n(this.Ljava_math_BigInteger__f_digits).get(0));
});
$c_Ljava_math_BigInteger.prototype.longValue__J = (function() {
  if ((this.Ljava_math_BigInteger__f_numberLength > 1)) {
    var value = $n(this.Ljava_math_BigInteger__f_digits).get(1);
    var value$1 = $n(this.Ljava_math_BigInteger__f_digits).get(0);
    var value$3__lo = value$1;
    var value$3__hi = value;
  } else {
    var value$2 = $n(this.Ljava_math_BigInteger__f_digits).get(0);
    var value$3__lo = value$2;
    var value$3__hi = 0;
  }
  var value$4 = this.Ljava_math_BigInteger__f_sign;
  var hi$3 = (value$4 >> 31);
  var blo = value$3__lo;
  var a0 = (65535 & value$4);
  var a1 = ((value$4 >>> 16) | 0);
  var b0 = (65535 & blo);
  var b1 = ((blo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$4 = ((((((((Math.imul(value$4, value$3__hi) + Math.imul(hi$3, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return new $c_RTLong(lo, hi$4);
});
$c_Ljava_math_BigInteger.prototype.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(bi) {
  if ((($n(bi).Ljava_math_BigInteger__f_sign === 0) || (this.Ljava_math_BigInteger__f_sign === 0))) {
    return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
  } else {
    var this$1 = $m_Ljava_math_Multiplication$();
    return this$1.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this, bi);
  }
});
$c_Ljava_math_BigInteger.prototype.negate__Ljava_math_BigInteger = (function() {
  return ((this.Ljava_math_BigInteger__f_sign === 0) ? this : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), ((-this.Ljava_math_BigInteger__f_sign) | 0), this.Ljava_math_BigInteger__f_numberLength, this.Ljava_math_BigInteger__f_digits));
});
$c_Ljava_math_BigInteger.prototype.pow__I__Ljava_math_BigInteger = (function(exp) {
  if ((exp < 0)) {
    throw new $c_jl_ArithmeticException("Negative exponent");
  } else if ((exp === 0)) {
    return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE;
  } else if ((((exp === 1) || this.equals__O__Z($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE)) || this.equals__O__Z($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO))) {
    return this;
  } else if ((!this.testBit__I__Z(0))) {
    var x = 1;
    while ((!this.testBit__I__Z(x))) {
      x = ((1 + x) | 0);
    }
    return $n($m_Ljava_math_BigInteger$().getPowerOfTwo__I__Ljava_math_BigInteger(Math.imul(x, exp))).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n(this.shiftRight__I__Ljava_math_BigInteger(x)).pow__I__Ljava_math_BigInteger(exp));
  } else {
    return $m_Ljava_math_Multiplication$().pow__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, exp);
  }
});
$c_Ljava_math_BigInteger.prototype.shiftLeft__I__Ljava_math_BigInteger = (function(n) {
  return (((n === 0) || (this.Ljava_math_BigInteger__f_sign === 0)) ? this : ((n > 0) ? $m_Ljava_math_BitLevel$().shiftLeft__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, n) : $m_Ljava_math_BitLevel$().shiftRight__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, ((-n) | 0))));
});
$c_Ljava_math_BigInteger.prototype.shiftRight__I__Ljava_math_BigInteger = (function(n) {
  return (((n === 0) || (this.Ljava_math_BigInteger__f_sign === 0)) ? this : ((n > 0) ? $m_Ljava_math_BitLevel$().shiftRight__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, n) : $m_Ljava_math_BitLevel$().shiftLeft__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, ((-n) | 0))));
});
$c_Ljava_math_BigInteger.prototype.testBit__I__Z = (function(n) {
  var intCount = (n >> 5);
  if ((n === 0)) {
    return ((1 & $n(this.Ljava_math_BigInteger__f_digits).get(0)) !== 0);
  } else if ((n < 0)) {
    throw new $c_jl_ArithmeticException("Negative bit address");
  } else if ((intCount >= this.Ljava_math_BigInteger__f_numberLength)) {
    return (this.Ljava_math_BigInteger__f_sign < 0);
  } else if ((!((this.Ljava_math_BigInteger__f_sign < 0) && (intCount < this.getFirstNonzeroDigit__I())))) {
    var digit = $n(this.Ljava_math_BigInteger__f_digits).get(intCount);
    if ((this.Ljava_math_BigInteger__f_sign < 0)) {
      digit = ((this.getFirstNonzeroDigit__I() === intCount) ? ((-digit) | 0) : (~digit));
    }
    var i = (1 << (31 & n));
    return ((digit & i) !== 0);
  } else {
    return false;
  }
});
$c_Ljava_math_BigInteger.prototype.toString__T = (function() {
  return $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this);
});
$c_Ljava_math_BigInteger.prototype.cutOffLeadingZeroes__V = (function() {
  while (true) {
    if ((this.Ljava_math_BigInteger__f_numberLength > 0)) {
      this.Ljava_math_BigInteger__f_numberLength = (((-1) + this.Ljava_math_BigInteger__f_numberLength) | 0);
      if (($n(this.Ljava_math_BigInteger__f_digits).get(this.Ljava_math_BigInteger__f_numberLength) === 0)) {
        continue;
      }
    }
    break;
  }
  if (($n(this.Ljava_math_BigInteger__f_digits).get(this.Ljava_math_BigInteger__f_numberLength) === 0)) {
    this.Ljava_math_BigInteger__f_sign = 0;
  }
  this.Ljava_math_BigInteger__f_numberLength = ((1 + this.Ljava_math_BigInteger__f_numberLength) | 0);
});
$c_Ljava_math_BigInteger.prototype.equalsArrays__AI__Z = (function(b) {
  var i = 0;
  while ((i !== this.Ljava_math_BigInteger__f_numberLength)) {
    if (($n(this.Ljava_math_BigInteger__f_digits).get(i) !== $n(b).get(i))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$c_Ljava_math_BigInteger.prototype.getFirstNonzeroDigit__I = (function() {
  if ((this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit === (-2))) {
    if ((this.Ljava_math_BigInteger__f_sign === 0)) {
      var $x_1 = (-1);
    } else {
      var i = 0;
      while (($n(this.Ljava_math_BigInteger__f_digits).get(i) === 0)) {
        i = ((1 + i) | 0);
      }
      var $x_1 = i;
    }
    this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit = $x_1;
  }
  return this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit;
});
$c_Ljava_math_BigInteger.prototype.isOne__Z = (function() {
  return ((this.Ljava_math_BigInteger__f_numberLength === 1) && ($n(this.Ljava_math_BigInteger__f_digits).get(0) === 1));
});
$c_Ljava_math_BigInteger.prototype.shiftLeftOneBit__Ljava_math_BigInteger = (function() {
  return ((this.Ljava_math_BigInteger__f_sign === 0) ? this : $m_Ljava_math_BitLevel$().shiftLeftOneBit__Ljava_math_BigInteger__Ljava_math_BigInteger(this));
});
$c_Ljava_math_BigInteger.prototype.compareTo__O__I = (function(o) {
  return this.compareTo__Ljava_math_BigInteger__I($as_Ljava_math_BigInteger(o));
});
function $as_Ljava_math_BigInteger(obj) {
  return (((obj instanceof $c_Ljava_math_BigInteger) || (obj === null)) ? obj : $throwClassCastException(obj, "java.math.BigInteger"));
}
function $isArrayOf_Ljava_math_BigInteger(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_math_BigInteger)));
}
function $asArrayOf_Ljava_math_BigInteger(obj, depth) {
  return (($isArrayOf_Ljava_math_BigInteger(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.math.BigInteger;", depth));
}
var $d_Ljava_math_BigInteger = new $TypeData().initClass($c_Ljava_math_BigInteger, "java.math.BigInteger", ({
  Ljava_math_BigInteger: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
}));
/** @constructor */
function $c_Ljava_math_RoundingMode(name, ordinal) {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, name, ordinal);
}
$c_Ljava_math_RoundingMode.prototype = new $h_jl_Enum();
$c_Ljava_math_RoundingMode.prototype.constructor = $c_Ljava_math_RoundingMode;
/** @constructor */
function $h_Ljava_math_RoundingMode() {
}
$h_Ljava_math_RoundingMode.prototype = $c_Ljava_math_RoundingMode.prototype;
var $d_Ljava_math_RoundingMode = new $TypeData().initClass($c_Ljava_math_RoundingMode, "java.math.RoundingMode", ({
  Ljava_math_RoundingMode: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_Ljava_net_URISyntaxException__T__T__I__($thiz, input, reason, index) {
  var s = ((((reason + " in ") + input) + " at ") + index);
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_Ljava_net_URISyntaxException__T__T__($thiz, input, reason) {
  $ct_Ljava_net_URISyntaxException__T__T__I__($thiz, input, reason, (-1));
  return $thiz;
}
class $c_Ljava_net_URISyntaxException extends $c_jl_Exception {
}
var $d_Ljava_net_URISyntaxException = new $TypeData().initClass($c_Ljava_net_URISyntaxException, "java.net.URISyntaxException", ({
  Ljava_net_URISyntaxException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ljava_nio_HeapByteBuffer(_capacity, _array0, _arrayOffset0, _initialPosition, _initialLimit, _readOnly) {
  this.Ljava_nio_Buffer__f__capacity = 0;
  this.Ljava_nio_Buffer__f__limit = 0;
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  this.Ljava_nio_Buffer__f__mark = 0;
  this.Ljava_nio_ByteBuffer__f__array = null;
  this.Ljava_nio_ByteBuffer__f__arrayOffset = 0;
  this.Ljava_nio_HeapByteBuffer__f__readOnly = false;
  this.Ljava_nio_HeapByteBuffer__f__readOnly = _readOnly;
  $ct_Ljava_nio_ByteBuffer__I__AB__I__(this, _capacity, _array0, _arrayOffset0);
  $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this, _initialPosition);
  $c_Ljava_nio_Buffer.prototype.limit__I__Ljava_nio_Buffer.call(this, _initialLimit);
}
$c_Ljava_nio_HeapByteBuffer.prototype = new $h_Ljava_nio_ByteBuffer();
$c_Ljava_nio_HeapByteBuffer.prototype.constructor = $c_Ljava_nio_HeapByteBuffer;
/** @constructor */
function $h_Ljava_nio_HeapByteBuffer() {
}
$h_Ljava_nio_HeapByteBuffer.prototype = $c_Ljava_nio_HeapByteBuffer.prototype;
$c_Ljava_nio_HeapByteBuffer.prototype.get__B = (function() {
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  if ((p === this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferUnderflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = ((1 + p) | 0);
  var a = this.Ljava_nio_ByteBuffer__f__array;
  var i = ((this.Ljava_nio_ByteBuffer__f__arrayOffset + p) | 0);
  return $n(a).get(i);
});
$c_Ljava_nio_HeapByteBuffer.prototype.put__B__Ljava_nio_ByteBuffer = (function(b) {
  if (this.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  if ((p === this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferOverflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = ((1 + p) | 0);
  var a = this.Ljava_nio_ByteBuffer__f__array;
  var i = ((this.Ljava_nio_ByteBuffer__f__arrayOffset + p) | 0);
  $n(a).set(i, b);
  return this;
});
$c_Ljava_nio_HeapByteBuffer.prototype.put__AB__I__I__Ljava_nio_ByteBuffer = (function(src, offset, length) {
  if (this.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  if ((((offset < 0) || (length < 0)) || (offset > (($n(src).u.length - length) | 0)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var newPos = ((p + length) | 0);
  if ((newPos > this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferOverflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPos;
  var x2 = this.Ljava_nio_ByteBuffer__f__array;
  var x3 = ((this.Ljava_nio_ByteBuffer__f__arrayOffset + p) | 0);
  $systemArraycopy($n(src), offset, $n(x2), x3, length);
  return this;
});
var $d_Ljava_nio_HeapByteBuffer = new $TypeData().initClass($c_Ljava_nio_HeapByteBuffer, "java.nio.HeapByteBuffer", ({
  Ljava_nio_HeapByteBuffer: 1,
  Ljava_nio_ByteBuffer: 1,
  Ljava_nio_Buffer: 1,
  jl_Comparable: 1
}));
class $c_Ljava_nio_charset_CoderMalfunctionError extends $c_jl_Error {
  constructor(cause) {
    super();
    $ct_jl_Error__jl_Throwable__(this, cause);
  }
}
var $d_Ljava_nio_charset_CoderMalfunctionError = new $TypeData().initClass($c_Ljava_nio_charset_CoderMalfunctionError, "java.nio.charset.CoderMalfunctionError", ({
  Ljava_nio_charset_CoderMalfunctionError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_ju_AbstractRandomAccessListIterator__I__I__I__($thiz, i, start, end) {
  $thiz.ju_AbstractRandomAccessListIterator__f_i = i;
  $thiz.ju_AbstractRandomAccessListIterator__f_end = end;
  $thiz.ju_AbstractRandomAccessListIterator__f_last = (-1);
  return $thiz;
}
/** @constructor */
function $c_ju_AbstractRandomAccessListIterator() {
  this.ju_AbstractRandomAccessListIterator__f_i = 0;
  this.ju_AbstractRandomAccessListIterator__f_end = 0;
  this.ju_AbstractRandomAccessListIterator__f_last = 0;
}
$c_ju_AbstractRandomAccessListIterator.prototype = new $h_O();
$c_ju_AbstractRandomAccessListIterator.prototype.constructor = $c_ju_AbstractRandomAccessListIterator;
/** @constructor */
function $h_ju_AbstractRandomAccessListIterator() {
}
$h_ju_AbstractRandomAccessListIterator.prototype = $c_ju_AbstractRandomAccessListIterator.prototype;
$c_ju_AbstractRandomAccessListIterator.prototype.hasNext__Z = (function() {
  return (this.ju_AbstractRandomAccessListIterator__f_i < this.ju_AbstractRandomAccessListIterator__f_end);
});
$c_ju_AbstractRandomAccessListIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException());
  }
  this.ju_AbstractRandomAccessListIterator__f_last = this.ju_AbstractRandomAccessListIterator__f_i;
  this.ju_AbstractRandomAccessListIterator__f_i = ((1 + this.ju_AbstractRandomAccessListIterator__f_i) | 0);
  return this.get__I__O(this.ju_AbstractRandomAccessListIterator__f_last);
});
function $p_ju_Formatter__sendToDest__T__V($thiz, s) {
  if (($thiz.ju_Formatter__f_dest === null)) {
    $thiz.ju_Formatter__f_stringOutput = (("" + $thiz.ju_Formatter__f_stringOutput) + s);
  } else {
    $p_ju_Formatter__sendToDestSlowPath__O__V($thiz, [s]);
  }
}
function $p_ju_Formatter__sendToDest__T__T__V($thiz, s1, s2) {
  if (($thiz.ju_Formatter__f_dest === null)) {
    $thiz.ju_Formatter__f_stringOutput = ((("" + $thiz.ju_Formatter__f_stringOutput) + s1) + s2);
  } else {
    $p_ju_Formatter__sendToDestSlowPath__O__V($thiz, [s1, s2]);
  }
}
function $p_ju_Formatter__sendToDest__T__T__T__V($thiz, s1, s2, s3) {
  if (($thiz.ju_Formatter__f_dest === null)) {
    $thiz.ju_Formatter__f_stringOutput = (($thiz.ju_Formatter__f_stringOutput + (("" + s1) + s2)) + s3);
  } else {
    $p_ju_Formatter__sendToDestSlowPath__O__V($thiz, [s1, s2, s3]);
  }
}
function $p_ju_Formatter__sendToDestSlowPath__O__V($thiz, ss) {
  try {
    var len = $uI(ss.length);
    var i = 0;
    while ((i !== len)) {
      var x$1$2 = ss[i];
      var x$1 = $as_T(x$1$2);
      $n($thiz.ju_Formatter__f_dest).append__jl_CharSequence__jl_Appendable(x$1);
      i = ((1 + i) | 0);
    }
  } catch (e) {
    if ((e instanceof $c_Ljava_io_IOException)) {
      $as_Ljava_io_IOException(e);
    } else {
      throw e;
    }
  }
}
function $p_ju_Formatter__format__ju_Formatter$LocaleInfo__T__AO__ju_Formatter($thiz, localeInfo, format, args) {
  if ($thiz.ju_Formatter__f_java$util$Formatter$$closed) {
    throw new $c_ju_FormatterClosedException();
  }
  var lastImplicitArgIndex = 0;
  var lastArgIndex = 0;
  var this$1 = $n(format);
  var fmtLength = this$1.length;
  var fmtIndex = 0;
  while ((fmtIndex !== fmtLength)) {
    var this$2 = $n(format);
    var fromIndex = fmtIndex;
    var nextPercentIndex = $uI(this$2.indexOf("%", fromIndex));
    if ((nextPercentIndex < 0)) {
      var this$3 = $n(format);
      var beginIndex = fmtIndex;
      if (((beginIndex < 0) || (beginIndex > this$3.length))) {
        $charAt(this$3, beginIndex);
      }
      $p_ju_Formatter__sendToDest__T__V($thiz, $as_T(this$3.substring(beginIndex)));
      return $thiz;
    }
    var this$4 = $n(format);
    var beginIndex$1 = fmtIndex;
    if ((beginIndex$1 < 0)) {
      $charAt(this$4, beginIndex$1);
    }
    if ((nextPercentIndex > this$4.length)) {
      $charAt(this$4, nextPercentIndex);
    }
    if ((nextPercentIndex < beginIndex$1)) {
      $charAt(this$4, (-1));
    }
    $p_ju_Formatter__sendToDest__T__V($thiz, $as_T(this$4.substring(beginIndex$1, nextPercentIndex)));
    var formatSpecifierIndex = ((1 + nextPercentIndex) | 0);
    var re = $m_ju_Formatter$().ju_Formatter$__f_java$util$Formatter$$FormatSpecifier;
    re.lastIndex = formatSpecifierIndex;
    var execResult = re.exec(format);
    if (((execResult === null) || ($uI(execResult.index) !== formatSpecifierIndex))) {
      if ((formatSpecifierIndex === fmtLength)) {
        var conversion = 37;
      } else {
        var this$5 = $n(format);
        var conversion = $charAt(this$5, formatSpecifierIndex);
      }
      $p_ju_Formatter__throwUnknownFormatConversionException__C__E($thiz, conversion);
    }
    fmtIndex = $uI(re.lastIndex);
    var this$6 = $n(format);
    var index = (((-1) + fmtIndex) | 0);
    var conversion$2 = $charAt(this$6, index);
    var flags = $p_ju_Formatter__parseFlags__T__C__I($thiz, $as_T(execResult[2]), conversion$2);
    var width = $p_ju_Formatter__parsePositiveInt__O__I($thiz, execResult[3]);
    var precision = $p_ju_Formatter__parsePositiveInt__O__I($thiz, execResult[4]);
    if ((width === (-2))) {
      $p_ju_Formatter__throwIllegalFormatWidthException__I__E($thiz, (-2147483648));
    }
    if ((precision === (-2))) {
      $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, (-2147483648));
    }
    if ((conversion$2 === 110)) {
      if ((precision !== (-1))) {
        $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision);
      }
      if ((width !== (-1))) {
        $p_ju_Formatter__throwIllegalFormatWidthException__I__E($thiz, width);
      }
      if ((flags !== 0)) {
        $thiz.java$util$Formatter$$throwIllegalFormatFlagsException__I__E(flags);
      }
      $p_ju_Formatter__sendToDest__T__V($thiz, "\n");
    } else if ((conversion$2 === 37)) {
      if ((precision !== (-1))) {
        $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision);
      }
      if ((((17 & flags) === 17) || ((12 & flags) === 12))) {
        $thiz.java$util$Formatter$$throwIllegalFormatFlagsException__I__E(flags);
      }
      if ((((1 & flags) !== 0) && (width === (-1)))) {
        $p_ju_Formatter__throwMissingFormatWidthException__T__E($thiz, $p_ju_Formatter__fullFormatSpecifier$1__O__T($thiz, execResult));
      }
      if ((((-2) & flags) !== 0)) {
        $thiz.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E(37, flags, (-2));
      }
      $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, "%");
    } else {
      var conversionLower = (((256 & flags) !== 0) ? (65535 & ((32 + conversion$2) | 0)) : conversion$2);
      var illegalFlags = $n($m_ju_Formatter$().ju_Formatter$__f_java$util$Formatter$$ConversionsIllegalFlags).get((((-97) + conversionLower) | 0));
      if (((illegalFlags === (-1)) || (((256 & flags) & illegalFlags) !== 0))) {
        $p_ju_Formatter__throwUnknownFormatConversionException__C__E($thiz, conversion$2);
      }
      if ((((17 & flags) !== 0) && (width === (-1)))) {
        $p_ju_Formatter__throwMissingFormatWidthException__T__E($thiz, $p_ju_Formatter__fullFormatSpecifier$1__O__T($thiz, execResult));
      }
      if ((((17 & flags) === 17) || ((12 & flags) === 12))) {
        $thiz.java$util$Formatter$$throwIllegalFormatFlagsException__I__E(flags);
      }
      if (((precision !== (-1)) && ((512 & illegalFlags) !== 0))) {
        $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision);
      }
      if (((flags & illegalFlags) !== 0)) {
        $thiz.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E(conversionLower, flags, illegalFlags);
      }
      if (((128 & flags) !== 0)) {
        var argIndex = lastArgIndex;
      } else {
        var i = $p_ju_Formatter__parsePositiveInt__O__I($thiz, execResult[1]);
        if ((i === (-1))) {
          lastImplicitArgIndex = ((1 + lastImplicitArgIndex) | 0);
          var argIndex = lastImplicitArgIndex;
        } else {
          if ((i <= 0)) {
            $p_ju_Formatter__throwIllegalFormatArgumentIndexException__I__E($thiz, i);
          }
          var argIndex = i;
        }
      }
      if (((argIndex <= 0) || (argIndex > $n(args).u.length))) {
        $p_ju_Formatter__throwMissingFormatArgumentException__T__E($thiz, $p_ju_Formatter__fullFormatSpecifier$1__O__T($thiz, execResult));
      }
      lastArgIndex = argIndex;
      var arg = $n(args).get((((-1) + argIndex) | 0));
      if ((((arg === null) && (conversionLower !== 98)) && (conversionLower !== 115))) {
        $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, precision, "null");
      } else {
        $p_ju_Formatter__formatArg__ju_Formatter$LocaleInfo__O__C__I__I__I__V($thiz, localeInfo, arg, conversionLower, flags, width, precision);
      }
    }
  }
  return $thiz;
}
function $p_ju_Formatter__parseFlags__T__C__I($thiz, flags, conversion) {
  var bits = (((conversion >= 65) && (conversion <= 90)) ? 256 : 0);
  var this$1 = $n(flags);
  var len = this$1.length;
  var i = 0;
  while ((i !== len)) {
    var this$2 = $n(flags);
    var index = i;
    var f = $charAt(this$2, index);
    switch (f) {
      case 45: {
        var bit = 1;
        break;
      }
      case 35: {
        var bit = 2;
        break;
      }
      case 43: {
        var bit = 4;
        break;
      }
      case 32: {
        var bit = 8;
        break;
      }
      case 48: {
        var bit = 16;
        break;
      }
      case 44: {
        var bit = 32;
        break;
      }
      case 40: {
        var bit = 64;
        break;
      }
      case 60: {
        var bit = 128;
        break;
      }
      default: {
        var bit;
        throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), $bC(f));
      }
    }
    if (((bits & bit) !== 0)) {
      $p_ju_Formatter__throwDuplicateFormatFlagsException__C__E($thiz, f);
    }
    bits = (bits | bit);
    i = ((1 + i) | 0);
  }
  return bits;
}
function $p_ju_Formatter__parsePositiveInt__O__I($thiz, capture) {
  if ((capture !== (void 0))) {
    var s = $as_T(capture);
    var x = $uD(parseInt(s, 10));
    return ((x <= 2.147483647E9) ? $doubleToInt(x) : (-2));
  } else {
    return (-1);
  }
}
function $p_ju_Formatter__formatArg__ju_Formatter$LocaleInfo__O__C__I__I__I__V($thiz, localeInfo, arg, conversionLower, flags, width, precision) {
  switch (conversionLower) {
    case 98: {
      var str = (((arg === false) || (arg === null)) ? "false" : "true");
      $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, precision, str);
      break;
    }
    case 104: {
      var i = $dp_hashCode__I($n(arg));
      var str$2 = $as_T($uD((i >>> 0.0)).toString(16));
      $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, precision, str$2);
      break;
    }
    case 115: {
      if ($is_ju_Formattable(arg)) {
        var x2 = $as_ju_Formattable(arg);
        var formattableFlags = (((((1 & flags) !== 0) ? 1 : 0) | (((2 & flags) !== 0) ? 4 : 0)) | (((256 & flags) !== 0) ? 2 : 0));
        $n(x2).formatTo__ju_Formatter__I__I__I__V($thiz, formattableFlags, width, precision);
      } else {
        if (((2 & flags) !== 0)) {
          $thiz.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E(conversionLower, flags, 2);
        }
        var str$3 = ("" + arg);
        $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, localeInfo, flags, width, precision, str$3);
      }
      break;
    }
    case 99: {
      if ((arg instanceof $Char)) {
        var x2$2 = $uC(arg);
        var str$4 = ("" + $cToS(x2$2));
      } else {
        if ((!$isInt(arg))) {
          $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg);
        }
        var x3 = $uI(arg);
        if ((!((x3 >= 0) && (x3 <= 1114111)))) {
          $p_ju_Formatter__throwIllegalFormatCodePointException__I__E($thiz, x3);
        }
        var str$4 = ((x3 < 65536) ? $as_T(String.fromCharCode(x3)) : $as_T(String.fromCharCode((55296 | (((-64) + (x3 >> 10)) | 0)), (56320 | (1023 & x3)))));
      }
      $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, localeInfo, flags, width, (-1), str$4);
      break;
    }
    case 100: {
      if ($isInt(arg)) {
        var x2$3 = $uI(arg);
        var str$5 = ("" + x2$3);
      } else if ((arg instanceof $c_RTLong)) {
        var t = $uJ(arg);
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        var str$5 = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo, hi);
      } else {
        if ((!(arg instanceof $c_Ljava_math_BigInteger))) {
          $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg);
        }
        var x4 = $as_Ljava_math_BigInteger(arg);
        var this$10 = $n(x4);
        var str$5 = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$10);
      }
      $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, str$5, "");
      break;
    }
    case 111:
    case 120: {
      var isOctal = (conversionLower === 111);
      var prefix = (((2 & flags) === 0) ? "" : (isOctal ? "0" : (((256 & flags) !== 0) ? "0X" : "0x")));
      if ((arg instanceof $c_Ljava_math_BigInteger)) {
        var x2$4 = $as_Ljava_math_BigInteger(arg);
        var radix = (isOctal ? 8 : 16);
        var $x_1 = $m_ju_Formatter$RootLocaleInfo$();
        var this$13 = $n(x2$4);
        $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, $x_1, flags, width, $m_Ljava_math_Conversion$().bigInteger2String__Ljava_math_BigInteger__I__T(this$13, radix), prefix);
      } else {
        if ($isInt(arg)) {
          var x2$5 = $uI(arg);
          var str$6 = (isOctal ? $as_T($uD((x2$5 >>> 0.0)).toString(8)) : $as_T($uD((x2$5 >>> 0.0)).toString(16)));
        } else {
          if ((!(arg instanceof $c_RTLong))) {
            $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg);
          }
          var t$1 = $uJ(arg);
          var lo$1 = t$1.RTLong__f_lo;
          var hi$1 = t$1.RTLong__f_hi;
          if (isOctal) {
            var this$16 = $m_jl_Long$();
            var str$6 = this$16.java$lang$Long$$toOctalString__I__I__T(lo$1, hi$1);
          } else {
            var this$17 = $m_jl_Long$();
            var str$6 = this$17.java$lang$Long$$toHexString__I__I__T(lo$1, hi$1);
          }
        }
        if (((76 & flags) !== 0)) {
          $thiz.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E(conversionLower, flags, 76);
        }
        $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, prefix, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str$6));
      }
      break;
    }
    case 101:
    case 102:
    case 103: {
      if (((typeof arg) === "number")) {
        var x2$6 = $uD(arg);
        if (((x2$6 !== x2$6) || ((x2$6 === Infinity) || (x2$6 === (-Infinity))))) {
          $p_ju_Formatter__formatNaNOrInfinite__I__I__D__V($thiz, flags, width, x2$6);
        } else {
          $p_ju_Formatter__formatDecimal$1__ju_Formatter$Decimal__I__I__C__ju_Formatter$LocaleInfo__I__V($thiz, $m_ju_Formatter$().java$util$Formatter$$numberToDecimal__D__ju_Formatter$Decimal(x2$6), flags, precision, conversionLower, localeInfo, width);
        }
      } else if ((arg instanceof $c_Ljava_math_BigDecimal)) {
        var x3$4 = $as_Ljava_math_BigDecimal(arg);
        $p_ju_Formatter__formatDecimal$1__ju_Formatter$Decimal__I__I__C__ju_Formatter$LocaleInfo__I__V($thiz, $m_ju_Formatter$().java$util$Formatter$$bigDecimalToDecimal__Ljava_math_BigDecimal__ju_Formatter$Decimal(x3$4), flags, precision, conversionLower, localeInfo, width);
      } else {
        $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg);
      }
      break;
    }
    case 97: {
      if (((typeof arg) === "number")) {
        var x2$7 = $uD(arg);
        $p_ju_Formatter__formatHexFloatingPoint__I__I__I__D__V($thiz, flags, width, precision, x2$7);
      } else {
        $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg);
      }
      break;
    }
    default: {
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), (("Unknown conversion '" + $cToS(conversionLower)) + "' was not rejected earlier"));
    }
  }
}
function $p_ju_Formatter__flagsToString__I__T($thiz, flags) {
  return ((((((((((1 & flags) !== 0) ? "-" : "") + (((2 & flags) !== 0) ? "#" : "")) + (((4 & flags) !== 0) ? "+" : "")) + (((8 & flags) !== 0) ? " " : "")) + (((16 & flags) !== 0) ? "0" : "")) + (((32 & flags) !== 0) ? "," : "")) + (((64 & flags) !== 0) ? "(" : "")) + (((128 & flags) !== 0) ? "<" : ""));
}
function $p_ju_Formatter__computerizedScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, digitsAfterDot, forceDecimalSep) {
  var rounded = $n(x).round__I__ju_Formatter$Decimal(((1 + digitsAfterDot) | 0));
  var signStr = ($n(rounded).ju_Formatter$Decimal__f_negative ? "-" : "");
  var intStr = $n(rounded).ju_Formatter$Decimal__f_unscaledValue;
  var this$1 = $n(intStr);
  var fractionalDigitCount = (((-1) + this$1.length) | 0);
  var missingZeros = ((digitsAfterDot - fractionalDigitCount) | 0);
  var this$2 = $n(intStr);
  if ((this$2.length < 1)) {
    $charAt(this$2, 1);
  }
  var integerPart = $as_T(this$2.substring(0, 1));
  var this$3 = $n(intStr);
  if ((this$3.length < 1)) {
    $charAt(this$3, 1);
  }
  var fractionalPart = (("" + $as_T(this$3.substring(1))) + $m_ju_Formatter$().java$util$Formatter$$strOfZeros__I__T(missingZeros));
  var significandStr = (((fractionalPart === "") && (!forceDecimalSep)) ? integerPart : ((integerPart + ".") + fractionalPart));
  var exponent = ((fractionalDigitCount - $n(rounded).ju_Formatter$Decimal__f_scale) | 0);
  var exponentSign = ((exponent < 0) ? "-" : "+");
  var this$5 = ((exponent < 0) ? ((-exponent) | 0) : exponent);
  var exponentAbsStr0 = ("" + this$5);
  var exponentAbsStr = ((exponentAbsStr0.length === 1) ? ("0" + exponentAbsStr0) : exponentAbsStr0);
  return ((((signStr + significandStr) + "e") + exponentSign) + exponentAbsStr);
}
function $p_ju_Formatter__decimalNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, scale, forceDecimalSep) {
  var rounded = $n(x).setScale__I__ju_Formatter$Decimal(scale);
  var signStr = ($n(rounded).ju_Formatter$Decimal__f_negative ? "-" : "");
  var intStr = $n(rounded).ju_Formatter$Decimal__f_unscaledValue;
  var this$1 = $n(intStr);
  var intStrLen = this$1.length;
  var minDigits = ((1 + scale) | 0);
  var expandedIntStr = ((intStrLen >= minDigits) ? intStr : (("" + $m_ju_Formatter$().java$util$Formatter$$strOfZeros__I__T(((minDigits - intStrLen) | 0))) + intStr));
  var this$2 = $n(expandedIntStr);
  var dotPos = ((this$2.length - scale) | 0);
  var this$3 = $n(expandedIntStr);
  if ((dotPos > this$3.length)) {
    $charAt(this$3, dotPos);
  }
  if ((dotPos < 0)) {
    $charAt(this$3, (-1));
  }
  var integerPart = (signStr + $as_T(this$3.substring(0, dotPos)));
  if (((scale === 0) && (!forceDecimalSep))) {
    return integerPart;
  } else {
    var this$4 = $n(expandedIntStr);
    if (((dotPos < 0) || (dotPos > this$4.length))) {
      $charAt(this$4, dotPos);
    }
    return ((integerPart + ".") + $as_T(this$4.substring(dotPos)));
  }
}
function $p_ju_Formatter__generalScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, precision, forceDecimalSep) {
  var p = ((precision === 0) ? 1 : precision);
  var rounded = $n(x).round__I__ju_Formatter$Decimal(p);
  var this$1 = $n(rounded);
  var this$2 = $n(this$1.ju_Formatter$Decimal__f_unscaledValue);
  var orderOfMagnitude = (((((-1) + this$2.length) | 0) - $n(rounded).ju_Formatter$Decimal__f_scale) | 0);
  if (((orderOfMagnitude >= (-4)) && (orderOfMagnitude < p))) {
    var b = (((-1) + ((p - orderOfMagnitude) | 0)) | 0);
    return $p_ju_Formatter__decimalNotation__ju_Formatter$Decimal__I__Z__T($thiz, rounded, ((b < 0) ? 0 : b), forceDecimalSep);
  } else {
    return $p_ju_Formatter__computerizedScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, rounded, (((-1) + p) | 0), forceDecimalSep);
  }
}
function $p_ju_Formatter__formatHexFloatingPoint__I__I__I__D__V($thiz, flags, width, precision, arg) {
  if (((arg !== arg) || ((arg === Infinity) || (arg === (-Infinity))))) {
    $p_ju_Formatter__formatNaNOrInfinite__I__I__D__V($thiz, flags, width, arg);
  } else {
    var t = $m_jl_FloatingPointBits$().doubleToLongBits__D__J(arg);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var negative = (hi < 0);
    var hi$1 = (1048575 & hi);
    var lo$1 = ((hi >>> 20) | 0);
    var biasedExponent = (2047 & lo$1);
    var actualPrecision = ((precision === 0) ? 1 : ((precision > 12) ? (-1) : precision));
    var signStr = (negative ? "-" : (((4 & flags) !== 0) ? "+" : (((8 & flags) !== 0) ? " " : "")));
    if ((biasedExponent === 0)) {
      if (((lo === 0) && (hi$1 === 0))) {
        var x1___1 = "0";
        var x1___2 = $L0;
        var x1___3 = 0;
      } else if ((actualPrecision === (-1))) {
        var x1___1 = "0";
        var x1___2 = new $c_RTLong(lo, hi$1);
        var x1___3 = (-1022);
      } else {
        var leadingZeros = ((hi$1 !== 0) ? $uI(Math.clz32(hi$1)) : ((32 + $uI(Math.clz32(lo))) | 0));
        var shift = (((-11) + leadingZeros) | 0);
        var lo$2 = (((32 & shift) === 0) ? (lo << shift) : 0);
        var hi$2 = (((32 & shift) === 0) ? (((((lo >>> 1) | 0) >>> ((31 - shift) | 0)) | 0) | (hi$1 << shift)) : (lo << shift));
        var hi$3 = (1048575 & hi$2);
        var normalizedExponent = (((-1022) - shift) | 0);
        var x1___1 = "1";
        var x1___2 = new $c_RTLong(lo$2, hi$3);
        var x1___3 = normalizedExponent;
      }
    } else {
      var _3 = (((-1023) + biasedExponent) | 0);
      var x1___1 = "1";
      var x1___2 = new $c_RTLong(lo, hi$1);
      var x1___3 = _3;
    }
    var implicitBitStr = $as_T(x1___1);
    var t$1 = $uJ(x1___2);
    var lo$3 = t$1.RTLong__f_lo;
    var hi$4 = t$1.RTLong__f_hi;
    var exponent = $uI(x1___3);
    var t$2 = $uJ(new $c_RTLong(lo$3, hi$4));
    var lo$4 = t$2.RTLong__f_lo;
    var hi$5 = t$2.RTLong__f_hi;
    if ((actualPrecision === (-1))) {
      var roundedMantissa__lo = lo$4;
      var roundedMantissa__hi = hi$5;
    } else {
      var n = ((52 - (actualPrecision << 2)) | 0);
      var lo$5 = (((32 & n) === 0) ? (1 << n) : 0);
      var hi$6 = (((32 & n) === 0) ? 0 : (1 << n));
      var lo$6 = (((-1) + lo$5) | 0);
      var hi$7 = ((lo$6 !== (-1)) ? hi$6 : (((-1) + hi$6) | 0));
      var lo$7 = (((lo$5 >>> 1) | 0) | (hi$6 << 31));
      var hi$8 = (hi$6 >> 1);
      var lo$8 = (~lo$6);
      var hi$9 = (~hi$7);
      var lo$9 = (lo$4 & lo$8);
      var hi$10 = (hi$5 & hi$9);
      var lo$10 = (lo$4 & lo$6);
      var hi$11 = (hi$5 & hi$7);
      if (((hi$11 === hi$8) ? (((-2147483648) ^ lo$10) < ((-2147483648) ^ lo$7)) : (hi$11 < hi$8))) {
        var roundedMantissa__lo = lo$9;
        var roundedMantissa__hi = hi$10;
      } else if (((hi$11 === hi$8) ? (((-2147483648) ^ lo$10) > ((-2147483648) ^ lo$7)) : (hi$11 > hi$8))) {
        var lo$11 = ((lo$9 + lo$5) | 0);
        var hi$12 = ((((-2147483648) ^ lo$11) < ((-2147483648) ^ lo$9)) ? ((1 + ((hi$10 + hi$6) | 0)) | 0) : ((hi$10 + hi$6) | 0));
        var roundedMantissa__lo = lo$11;
        var roundedMantissa__hi = hi$12;
      } else {
        var lo$12 = (lo$9 & lo$5);
        var hi$13 = (hi$10 & hi$6);
        if (((lo$12 === 0) && (hi$13 === 0))) {
          var roundedMantissa__lo = lo$9;
          var roundedMantissa__hi = hi$10;
        } else {
          var lo$13 = ((lo$9 + lo$5) | 0);
          var hi$14 = ((((-2147483648) ^ lo$13) < ((-2147483648) ^ lo$9)) ? ((1 + ((hi$10 + hi$6) | 0)) | 0) : ((hi$10 + hi$6) | 0));
          var roundedMantissa__lo = lo$13;
          var roundedMantissa__hi = hi$14;
        }
      }
    }
    var this$12 = $m_jl_Long$();
    var hi$15 = roundedMantissa__hi;
    var baseStr = this$12.java$lang$Long$$toHexString__I__I__T(roundedMantissa__lo, hi$15);
    var this$13 = $n(baseStr);
    var beginIndex = this$13.length;
    if (((beginIndex < 0) || (beginIndex > 13))) {
      $charAt("0000000000000", beginIndex);
    }
    var padded = (("" + $as_T("0000000000000".substring(beginIndex))) + baseStr);
    $m_ju_Formatter$();
    var condition = (padded.length === 13);
    if ((!condition)) {
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "padded mantissa does not have the right number of bits");
    }
    var minLength = ((actualPrecision < 1) ? 1 : actualPrecision);
    var len = padded.length;
    while (true) {
      if ((len > minLength)) {
        var index = (((-1) + len) | 0);
        var $x_1 = ($charAt(padded, index) === 48);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        len = (((-1) + len) | 0);
      } else {
        break;
      }
    }
    var endIndex = len;
    if ((endIndex > padded.length)) {
      $charAt(padded, endIndex);
    }
    if ((endIndex < 0)) {
      $charAt(padded, (-1));
    }
    var mantissaStr = $as_T(padded.substring(0, endIndex));
    var exponentStr = ("" + exponent);
    var prefix = (signStr + (((256 & flags) !== 0) ? "0X" : "0x"));
    var rest = ((((implicitBitStr + ".") + mantissaStr) + "p") + exponentStr);
    $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, prefix, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, rest));
  }
}
function $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, localeInfo, flags, width, precision, str) {
  if ((precision < 0)) {
    var $x_1 = true;
  } else {
    var this$1 = $n(str);
    var $x_1 = (precision >= this$1.length);
  }
  if ($x_1) {
    var truncatedStr = str;
  } else {
    var this$2 = $n(str);
    if ((precision > this$2.length)) {
      $charAt(this$2, precision);
    }
    if ((precision < 0)) {
      $charAt(this$2, (-1));
    }
    var truncatedStr = $as_T(this$2.substring(0, precision));
  }
  $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, $p_ju_Formatter__applyUpperCase__ju_Formatter$LocaleInfo__I__T__T($thiz, localeInfo, flags, truncatedStr));
}
function $p_ju_Formatter__formatNaNOrInfinite__I__I__D__V($thiz, flags, width, x) {
  var str = ((x !== x) ? "NaN" : ((x > 0.0) ? (((4 & flags) !== 0) ? "+Infinity" : (((8 & flags) !== 0) ? " Infinity" : "Infinity")) : (((64 & flags) !== 0) ? "(Infinity)" : "-Infinity")));
  $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str));
}
function $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, str, basePrefix) {
  var this$1 = $n(str);
  if (((this$1.length >= width) && ((110 & flags) === 0))) {
    $n(localeInfo);
    var str$1 = $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str);
    $p_ju_Formatter__sendToDest__T__V($thiz, str$1);
  } else if (((126 & flags) === 0)) {
    $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str));
  } else {
    var this$5 = $n(str);
    if (($charAt(this$5, 0) !== 45)) {
      if (((4 & flags) !== 0)) {
        var x1___1 = "+";
        var x1___2 = str;
      } else if (((8 & flags) !== 0)) {
        var x1___1 = " ";
        var x1___2 = str;
      } else {
        var x1___1 = "";
        var x1___2 = str;
      }
    } else if (((64 & flags) !== 0)) {
      var this$9 = $n(str);
      if ((this$9.length < 1)) {
        $charAt(this$9, 1);
      }
      var _2 = ($as_T(this$9.substring(1)) + ")");
      var x1___1 = "(";
      var x1___2 = _2;
    } else {
      var this$10 = $n(str);
      if ((this$10.length < 1)) {
        $charAt(this$10, 1);
      }
      var _2$1 = $as_T(this$10.substring(1));
      var x1___1 = "-";
      var x1___2 = _2$1;
    }
    var numberPrefix = $as_T(x1___1);
    var rest0 = $as_T(x1___2);
    var prefix = (("" + numberPrefix) + basePrefix);
    var rest = (((32 & flags) !== 0) ? $p_ju_Formatter__insertGroupingCommas__ju_Formatter$LocaleInfo__T__T($thiz, localeInfo, rest0) : rest0);
    $n(localeInfo);
    var str$2 = $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, rest);
    $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, prefix, str$2);
  }
}
function $p_ju_Formatter__insertGroupingCommas__ju_Formatter$LocaleInfo__T__T($thiz, localeInfo, s) {
  $n(localeInfo);
  var groupingSize = 3;
  var this$1 = $n(s);
  var len = this$1.length;
  var index = 0;
  while (true) {
    if ((index !== len)) {
      var this$2 = $n(s);
      var index$1 = index;
      var c = $charAt(this$2, index$1);
      var $x_1 = ((c >= 48) && (c <= 57));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      index = ((1 + index) | 0);
    } else {
      break;
    }
  }
  index = ((index - groupingSize) | 0);
  if ((index <= 0)) {
    return s;
  } else {
    var this$3 = $n(s);
    var beginIndex = index;
    if (((beginIndex < 0) || (beginIndex > this$3.length))) {
      $charAt(this$3, beginIndex);
    }
    var result = $as_T(this$3.substring(beginIndex));
    while ((index > groupingSize)) {
      var next = ((index - groupingSize) | 0);
      var this$4 = $n(s);
      var endIndex = index;
      if ((next < 0)) {
        $charAt(this$4, next);
      }
      if ((endIndex > this$4.length)) {
        $charAt(this$4, endIndex);
      }
      if ((endIndex < next)) {
        $charAt(this$4, (-1));
      }
      result = (($as_T(this$4.substring(next, endIndex)) + ",") + result);
      index = next;
    }
    var this$5 = $n(s);
    var endIndex$1 = index;
    if ((endIndex$1 > this$5.length)) {
      $charAt(this$5, endIndex$1);
    }
    if ((endIndex$1 < 0)) {
      $charAt(this$5, (-1));
    }
    return (($as_T(this$5.substring(0, endIndex$1)) + ",") + result);
  }
}
function $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str) {
  if (((256 & flags) !== 0)) {
    var this$2 = $n(str);
    return $as_T(this$2.toUpperCase());
  } else {
    return str;
  }
}
function $p_ju_Formatter__applyUpperCase__ju_Formatter$LocaleInfo__I__T__T($thiz, localeInfo, flags, str) {
  if (((256 & flags) !== 0)) {
    $n(localeInfo);
    var this$3 = $n(str);
    return $as_T(this$3.toUpperCase());
  } else {
    return str;
  }
}
function $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, str) {
  var this$1 = $n(str);
  var len = this$1.length;
  if ((len >= width)) {
    $p_ju_Formatter__sendToDest__T__V($thiz, str);
  } else if (((1 & flags) !== 0)) {
    $p_ju_Formatter__sendToDest__T__T__V($thiz, str, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)));
  } else {
    $p_ju_Formatter__sendToDest__T__T__V($thiz, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)), str);
  }
}
function $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, prefix, str) {
  var this$1 = $n(prefix);
  var this$2 = $n(str);
  var len = ((this$1.length + this$2.length) | 0);
  if ((len >= width)) {
    $p_ju_Formatter__sendToDest__T__T__V($thiz, prefix, str);
  } else if (((16 & flags) !== 0)) {
    $p_ju_Formatter__sendToDest__T__T__T__V($thiz, prefix, $p_ju_Formatter__strRepeat__T__I__T($thiz, ($n(localeInfo), "0"), ((width - len) | 0)), str);
  } else if (((1 & flags) !== 0)) {
    $p_ju_Formatter__sendToDest__T__T__T__V($thiz, prefix, str, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)));
  } else {
    $p_ju_Formatter__sendToDest__T__T__T__V($thiz, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)), prefix, str);
  }
}
function $p_ju_Formatter__strRepeat__T__I__T($thiz, s, times) {
  var result = "";
  var i = 0;
  while ((i !== times)) {
    result = (("" + result) + s);
    i = ((1 + i) | 0);
  }
  return result;
}
function $p_ju_Formatter__throwDuplicateFormatFlagsException__C__E($thiz, flag) {
  throw new $c_ju_DuplicateFormatFlagsException(("" + $cToS(flag)));
}
function $p_ju_Formatter__throwUnknownFormatConversionException__C__E($thiz, conversion) {
  throw new $c_ju_UnknownFormatConversionException(("" + $cToS(conversion)));
}
function $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision) {
  throw new $c_ju_IllegalFormatPrecisionException(precision);
}
function $p_ju_Formatter__throwIllegalFormatWidthException__I__E($thiz, width) {
  throw new $c_ju_IllegalFormatWidthException(width);
}
function $p_ju_Formatter__throwIllegalFormatArgumentIndexException__I__E($thiz, index) {
  var msg = ((index === 0) ? "Illegal format argument index = 0" : "Format argument index: (not representable as int)");
  throw new $c_ju_IllegalFormatArgumentIndexException(msg);
}
function $p_ju_Formatter__throwMissingFormatWidthException__T__E($thiz, fullFormatSpecifier) {
  throw new $c_ju_MissingFormatWidthException(fullFormatSpecifier);
}
function $p_ju_Formatter__throwMissingFormatArgumentException__T__E($thiz, fullFormatSpecifier) {
  throw new $c_ju_MissingFormatArgumentException(fullFormatSpecifier);
}
function $p_ju_Formatter__throwIllegalFormatCodePointException__I__E($thiz, arg) {
  throw new $c_ju_IllegalFormatCodePointException(arg);
}
function $p_ju_Formatter__fullFormatSpecifier$1__O__T($thiz, execResult$1) {
  return ("%" + execResult$1[0]);
}
function $p_ju_Formatter__formatDecimal$1__ju_Formatter$Decimal__I__I__C__ju_Formatter$LocaleInfo__I__V($thiz, x, flags$1, precision$1, conversionLower$1, localeInfo$1, width$1) {
  var forceDecimalSep = ((2 & flags$1) !== 0);
  var actualPrecision = ((precision$1 >= 0) ? precision$1 : 6);
  switch (conversionLower$1) {
    case 101: {
      var notation = $p_ju_Formatter__computerizedScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, actualPrecision, forceDecimalSep);
      break;
    }
    case 102: {
      var notation = $p_ju_Formatter__decimalNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, actualPrecision, forceDecimalSep);
      break;
    }
    default: {
      var notation = $p_ju_Formatter__generalScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, actualPrecision, forceDecimalSep);
    }
  }
  $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo$1, flags$1, width$1, notation, "");
}
function $ct_ju_Formatter__jl_Appendable__ju_Formatter$LocaleInfo__($thiz, dest, formatterLocaleInfo) {
  $thiz.ju_Formatter__f_dest = dest;
  $thiz.ju_Formatter__f_formatterLocaleInfo = formatterLocaleInfo;
  $thiz.ju_Formatter__f_stringOutput = "";
  $thiz.ju_Formatter__f_java$util$Formatter$$closed = false;
  return $thiz;
}
function $ct_ju_Formatter__($thiz) {
  $ct_ju_Formatter__jl_Appendable__ju_Formatter$LocaleInfo__($thiz, null, $m_ju_Formatter$RootLocaleInfo$());
  return $thiz;
}
/** @constructor */
function $c_ju_Formatter() {
  this.ju_Formatter__f_dest = null;
  this.ju_Formatter__f_formatterLocaleInfo = null;
  this.ju_Formatter__f_stringOutput = null;
  this.ju_Formatter__f_java$util$Formatter$$closed = false;
}
$c_ju_Formatter.prototype = new $h_O();
$c_ju_Formatter.prototype.constructor = $c_ju_Formatter;
/** @constructor */
function $h_ju_Formatter() {
}
$h_ju_Formatter.prototype = $c_ju_Formatter.prototype;
$c_ju_Formatter.prototype.format__T__AO__ju_Formatter = (function(format, args) {
  return $p_ju_Formatter__format__ju_Formatter$LocaleInfo__T__AO__ju_Formatter(this, this.ju_Formatter__f_formatterLocaleInfo, format, args);
});
$c_ju_Formatter.prototype.toString__T = (function() {
  if (this.ju_Formatter__f_java$util$Formatter$$closed) {
    throw new $c_ju_FormatterClosedException();
  }
  return ((this.ju_Formatter__f_dest === null) ? this.ju_Formatter__f_stringOutput : $n(this.ju_Formatter__f_dest).toString__T());
});
$c_ju_Formatter.prototype.java$util$Formatter$$throwIllegalFormatFlagsException__I__E = (function(flags) {
  throw new $c_ju_IllegalFormatFlagsException($p_ju_Formatter__flagsToString__I__T(this, flags));
});
$c_ju_Formatter.prototype.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E = (function(conversionLower, flags, illegalFlags) {
  throw new $c_ju_FormatFlagsConversionMismatchException($p_ju_Formatter__flagsToString__I__T(this, (flags & illegalFlags)), conversionLower);
});
$c_ju_Formatter.prototype.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E = (function(conversionLower, arg) {
  var this$1 = $n(arg);
  throw new $c_ju_IllegalFormatConversionException(conversionLower, $objectGetClass(this$1));
});
var $d_ju_Formatter = new $TypeData().initClass($c_ju_Formatter, "java.util.Formatter", ({
  ju_Formatter: 1,
  Ljava_io_Closeable: 1,
  jl_AutoCloseable: 1,
  Ljava_io_Flushable: 1
}));
/** @constructor */
function $c_ju_HashMap$Values(outer) {
  this.ju_HashMap$Values__f_$outer = null;
  $n(outer);
  this.ju_HashMap$Values__f_$outer = outer;
}
$c_ju_HashMap$Values.prototype = new $h_ju_AbstractCollection();
$c_ju_HashMap$Values.prototype.constructor = $c_ju_HashMap$Values;
/** @constructor */
function $h_ju_HashMap$Values() {
}
$h_ju_HashMap$Values.prototype = $c_ju_HashMap$Values.prototype;
$c_ju_HashMap$Values.prototype.iterator__ju_Iterator = (function() {
  var this$1 = $n(this.ju_HashMap$Values__f_$outer);
  return new $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator(this$1);
});
$c_ju_HashMap$Values.prototype.size__I = (function() {
  return $n(this.ju_HashMap$Values__f_$outer).ju_HashMap__f_contentSize;
});
$c_ju_HashMap$Values.prototype.contains__O__Z = (function(o) {
  return $n(this.ju_HashMap$Values__f_$outer).containsValue__O__Z(o);
});
var $d_ju_HashMap$Values = new $TypeData().initClass($c_ju_HashMap$Values, "java.util.HashMap$Values", ({
  ju_HashMap$Values: 1,
  ju_AbstractCollection: 1,
  ju_Collection: 1,
  jl_Iterable: 1
}));
class $c_ju_concurrent_ExecutionException extends $c_jl_Exception {
  constructor(message, cause) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, cause, true, true);
  }
}
var $d_ju_concurrent_ExecutionException = new $TypeData().initClass($c_ju_concurrent_ExecutionException, "java.util.concurrent.ExecutionException", ({
  ju_concurrent_ExecutionException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
}
$c_ju_concurrent_TimeUnit.prototype = new $h_jl_Enum();
$c_ju_concurrent_TimeUnit.prototype.constructor = $c_ju_concurrent_TimeUnit;
/** @constructor */
function $h_ju_concurrent_TimeUnit() {
}
$h_ju_concurrent_TimeUnit.prototype = $c_ju_concurrent_TimeUnit.prototype;
function $as_ju_concurrent_TimeUnit(obj) {
  return (((obj instanceof $c_ju_concurrent_TimeUnit) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.concurrent.TimeUnit"));
}
function $isArrayOf_ju_concurrent_TimeUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_concurrent_TimeUnit)));
}
function $asArrayOf_ju_concurrent_TimeUnit(obj, depth) {
  return (($isArrayOf_ju_concurrent_TimeUnit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.concurrent.TimeUnit;", depth));
}
/** @constructor */
function $c_ju_internal_GenericArrayOps$ByteArrayOps$() {
}
$c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype = new $h_O();
$c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype.constructor = $c_ju_internal_GenericArrayOps$ByteArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$ByteArrayOps$() {
}
$h_ju_internal_GenericArrayOps$ByteArrayOps$.prototype = $c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype;
$c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype.compare__O__O__I = (function(o1, o2) {
  var x = $uB(o1);
  var y = $uB(o2);
  return ((x - y) | 0);
});
$c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype.set__O__I__O__V = (function(a, i, v) {
  var a$1 = $asArrayOf_B(a, 1);
  var v$1 = $uB(v);
  $n(a$1).set(i, v$1);
});
$c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype.get__O__I__O = (function(a, i) {
  var a$1 = $asArrayOf_B(a, 1);
  return $n(a$1).get(i);
});
var $d_ju_internal_GenericArrayOps$ByteArrayOps$ = new $TypeData().initClass($c_ju_internal_GenericArrayOps$ByteArrayOps$, "java.util.internal.GenericArrayOps$ByteArrayOps$", ({
  ju_internal_GenericArrayOps$ByteArrayOps$: 1,
  ju_internal_GenericArrayOps$ArrayOps: 1,
  ju_internal_GenericArrayOps$ArrayCreateOps: 1,
  ju_Comparator: 1
}));
var $n_ju_internal_GenericArrayOps$ByteArrayOps$;
function $m_ju_internal_GenericArrayOps$ByteArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$ByteArrayOps$)) {
    $n_ju_internal_GenericArrayOps$ByteArrayOps$ = new $c_ju_internal_GenericArrayOps$ByteArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$ByteArrayOps$;
}
/** @constructor */
function $c_ju_internal_GenericArrayOps$CharArrayOps$() {
}
$c_ju_internal_GenericArrayOps$CharArrayOps$.prototype = new $h_O();
$c_ju_internal_GenericArrayOps$CharArrayOps$.prototype.constructor = $c_ju_internal_GenericArrayOps$CharArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$CharArrayOps$() {
}
$h_ju_internal_GenericArrayOps$CharArrayOps$.prototype = $c_ju_internal_GenericArrayOps$CharArrayOps$.prototype;
$c_ju_internal_GenericArrayOps$CharArrayOps$.prototype.compare__O__O__I = (function(o1, o2) {
  var x = $uC(o1);
  var y = $uC(o2);
  return ((x - y) | 0);
});
$c_ju_internal_GenericArrayOps$CharArrayOps$.prototype.set__O__I__O__V = (function(a, i, v) {
  var a$1 = $asArrayOf_C(a, 1);
  var v$1 = $uC(v);
  $n(a$1).set(i, v$1);
});
$c_ju_internal_GenericArrayOps$CharArrayOps$.prototype.get__O__I__O = (function(a, i) {
  var a$1 = $asArrayOf_C(a, 1);
  return $bC($n(a$1).get(i));
});
var $d_ju_internal_GenericArrayOps$CharArrayOps$ = new $TypeData().initClass($c_ju_internal_GenericArrayOps$CharArrayOps$, "java.util.internal.GenericArrayOps$CharArrayOps$", ({
  ju_internal_GenericArrayOps$CharArrayOps$: 1,
  ju_internal_GenericArrayOps$ArrayOps: 1,
  ju_internal_GenericArrayOps$ArrayCreateOps: 1,
  ju_Comparator: 1
}));
var $n_ju_internal_GenericArrayOps$CharArrayOps$;
function $m_ju_internal_GenericArrayOps$CharArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$CharArrayOps$)) {
    $n_ju_internal_GenericArrayOps$CharArrayOps$ = new $c_ju_internal_GenericArrayOps$CharArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$CharArrayOps$;
}
/** @constructor */
function $c_ju_internal_GenericArrayOps$IntArrayOps$() {
}
$c_ju_internal_GenericArrayOps$IntArrayOps$.prototype = new $h_O();
$c_ju_internal_GenericArrayOps$IntArrayOps$.prototype.constructor = $c_ju_internal_GenericArrayOps$IntArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$IntArrayOps$() {
}
$h_ju_internal_GenericArrayOps$IntArrayOps$.prototype = $c_ju_internal_GenericArrayOps$IntArrayOps$.prototype;
$c_ju_internal_GenericArrayOps$IntArrayOps$.prototype.compare__O__O__I = (function(o1, o2) {
  var x = $uI(o1);
  var y = $uI(o2);
  return ((x === y) ? 0 : ((x < y) ? (-1) : 1));
});
$c_ju_internal_GenericArrayOps$IntArrayOps$.prototype.set__O__I__O__V = (function(a, i, v) {
  var a$1 = $asArrayOf_I(a, 1);
  var v$1 = $uI(v);
  $n(a$1).set(i, v$1);
});
$c_ju_internal_GenericArrayOps$IntArrayOps$.prototype.get__O__I__O = (function(a, i) {
  var a$1 = $asArrayOf_I(a, 1);
  return $n(a$1).get(i);
});
var $d_ju_internal_GenericArrayOps$IntArrayOps$ = new $TypeData().initClass($c_ju_internal_GenericArrayOps$IntArrayOps$, "java.util.internal.GenericArrayOps$IntArrayOps$", ({
  ju_internal_GenericArrayOps$IntArrayOps$: 1,
  ju_internal_GenericArrayOps$ArrayOps: 1,
  ju_internal_GenericArrayOps$ArrayCreateOps: 1,
  ju_Comparator: 1
}));
var $n_ju_internal_GenericArrayOps$IntArrayOps$;
function $m_ju_internal_GenericArrayOps$IntArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$IntArrayOps$)) {
    $n_ju_internal_GenericArrayOps$IntArrayOps$ = new $c_ju_internal_GenericArrayOps$IntArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$IntArrayOps$;
}
/** @constructor */
function $c_ju_internal_GenericArrayOps$LongArrayOps$() {
}
$c_ju_internal_GenericArrayOps$LongArrayOps$.prototype = new $h_O();
$c_ju_internal_GenericArrayOps$LongArrayOps$.prototype.constructor = $c_ju_internal_GenericArrayOps$LongArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$LongArrayOps$() {
}
$h_ju_internal_GenericArrayOps$LongArrayOps$.prototype = $c_ju_internal_GenericArrayOps$LongArrayOps$.prototype;
$c_ju_internal_GenericArrayOps$LongArrayOps$.prototype.compare__O__O__I = (function(o1, o2) {
  var t = $uJ(o1);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(o2);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1);
});
$c_ju_internal_GenericArrayOps$LongArrayOps$.prototype.set__O__I__O__V = (function(a, i, v) {
  var a$1 = $asArrayOf_J(a, 1);
  var t = $uJ(v);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  $n(a$1).set(i, new $c_RTLong(lo, hi));
});
$c_ju_internal_GenericArrayOps$LongArrayOps$.prototype.get__O__I__O = (function(a, i) {
  var a$1 = $asArrayOf_J(a, 1);
  return $n(a$1).get(i);
});
var $d_ju_internal_GenericArrayOps$LongArrayOps$ = new $TypeData().initClass($c_ju_internal_GenericArrayOps$LongArrayOps$, "java.util.internal.GenericArrayOps$LongArrayOps$", ({
  ju_internal_GenericArrayOps$LongArrayOps$: 1,
  ju_internal_GenericArrayOps$ArrayOps: 1,
  ju_internal_GenericArrayOps$ArrayCreateOps: 1,
  ju_Comparator: 1
}));
var $n_ju_internal_GenericArrayOps$LongArrayOps$;
function $m_ju_internal_GenericArrayOps$LongArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$LongArrayOps$)) {
    $n_ju_internal_GenericArrayOps$LongArrayOps$ = new $c_ju_internal_GenericArrayOps$LongArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$LongArrayOps$;
}
/** @constructor */
function $c_ju_internal_GenericArrayOps$ShortArrayOps$() {
}
$c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype = new $h_O();
$c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype.constructor = $c_ju_internal_GenericArrayOps$ShortArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$ShortArrayOps$() {
}
$h_ju_internal_GenericArrayOps$ShortArrayOps$.prototype = $c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype;
$c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype.compare__O__O__I = (function(o1, o2) {
  var x = $uS(o1);
  var y = $uS(o2);
  return ((x - y) | 0);
});
$c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype.set__O__I__O__V = (function(a, i, v) {
  var a$1 = $asArrayOf_S(a, 1);
  var v$1 = $uS(v);
  $n(a$1).set(i, v$1);
});
$c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype.get__O__I__O = (function(a, i) {
  var a$1 = $asArrayOf_S(a, 1);
  return $n(a$1).get(i);
});
var $d_ju_internal_GenericArrayOps$ShortArrayOps$ = new $TypeData().initClass($c_ju_internal_GenericArrayOps$ShortArrayOps$, "java.util.internal.GenericArrayOps$ShortArrayOps$", ({
  ju_internal_GenericArrayOps$ShortArrayOps$: 1,
  ju_internal_GenericArrayOps$ArrayOps: 1,
  ju_internal_GenericArrayOps$ArrayCreateOps: 1,
  ju_Comparator: 1
}));
var $n_ju_internal_GenericArrayOps$ShortArrayOps$;
function $m_ju_internal_GenericArrayOps$ShortArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$ShortArrayOps$)) {
    $n_ju_internal_GenericArrayOps$ShortArrayOps$ = new $c_ju_internal_GenericArrayOps$ShortArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$ShortArrayOps$;
}
/** @constructor */
function $c_Llaika_api_builder_BundleFilter(strict, acceptRawContent) {
  this.Llaika_api_builder_BundleFilter__f_strict = false;
  this.Llaika_api_builder_BundleFilter__f_acceptRawContent = false;
  this.Llaika_api_builder_BundleFilter__f_strict = strict;
  this.Llaika_api_builder_BundleFilter__f_acceptRawContent = acceptRawContent;
}
$c_Llaika_api_builder_BundleFilter.prototype = new $h_O();
$c_Llaika_api_builder_BundleFilter.prototype.constructor = $c_Llaika_api_builder_BundleFilter;
/** @constructor */
function $h_Llaika_api_builder_BundleFilter() {
}
$h_Llaika_api_builder_BundleFilter.prototype = $c_Llaika_api_builder_BundleFilter.prototype;
$c_Llaika_api_builder_BundleFilter.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_builder_BundleFilter.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("BundleFilter");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Llaika_api_builder_BundleFilter__f_strict ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Llaika_api_builder_BundleFilter__f_acceptRawContent ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
});
$c_Llaika_api_builder_BundleFilter.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_builder_BundleFilter)) {
    var x$0$2 = $as_Llaika_api_builder_BundleFilter(x$0);
    return (((this.Llaika_api_builder_BundleFilter__f_strict === $n(x$0$2).Llaika_api_builder_BundleFilter__f_strict) && (this.Llaika_api_builder_BundleFilter__f_acceptRawContent === $n(x$0$2).Llaika_api_builder_BundleFilter__f_acceptRawContent)) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Llaika_api_builder_BundleFilter.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_builder_BundleFilter.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_api_builder_BundleFilter.prototype.productPrefix__T = (function() {
  return "BundleFilter";
});
$c_Llaika_api_builder_BundleFilter.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_builder_BundleFilter__f_strict;
  }
  if ((n === 1)) {
    return this.Llaika_api_builder_BundleFilter__f_acceptRawContent;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_api_builder_BundleFilter.prototype.apply__sci_Seq__sci_Seq = (function(bundles) {
  var strictApplied = ((!this.Llaika_api_builder_BundleFilter__f_strict) ? bundles : $as_sci_Seq($n(bundles).flatMap__F1__O(new $c_sjsr_AnonFunction1(((_$6) => {
    var _$6$1 = $as_Llaika_api_bundle_ExtensionBundle(_$6);
    return $n(_$6$1).forStrictMode__s_Option();
  })))));
  return (this.Llaika_api_builder_BundleFilter__f_acceptRawContent ? strictApplied : $as_sci_Seq($n(strictApplied).flatMap__F1__O(new $c_sjsr_AnonFunction1(((_$7) => {
    var _$7$1 = $as_Llaika_api_bundle_ExtensionBundle(_$7);
    return $n(_$7$1).rawContentDisabled__s_Option();
  })))));
});
function $as_Llaika_api_builder_BundleFilter(obj) {
  return (((obj instanceof $c_Llaika_api_builder_BundleFilter) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.builder.BundleFilter"));
}
function $isArrayOf_Llaika_api_builder_BundleFilter(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_builder_BundleFilter)));
}
function $asArrayOf_Llaika_api_builder_BundleFilter(obj, depth) {
  return (($isArrayOf_Llaika_api_builder_BundleFilter(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.builder.BundleFilter;", depth));
}
var $d_Llaika_api_builder_BundleFilter = new $TypeData().initClass($c_Llaika_api_builder_BundleFilter, "laika.api.builder.BundleFilter", ({
  Llaika_api_builder_BundleFilter: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent(outer, attributes, body) {
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent__f_attributes = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent__f_body = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent__f_$outer = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent__f_attributes = attributes;
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent__f_body = body;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent__f_$outer = outer;
}
$c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent.prototype = new $h_O();
$c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent.prototype;
$c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent) && ($n($as_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent(x$0)).Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent__f_$outer === this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent__f_$outer))) {
    var x$0$2 = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent(x$0);
    var x = this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent__f_attributes;
    var x$2 = $n(x$0$2).Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent__f_attributes;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent__f_body;
      var x$4 = $n(x$0$2).Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent__f_body;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent.prototype.productPrefix__T = (function() {
  return "DirectiveContent";
});
$c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent__f_attributes;
  }
  if ((n === 1)) {
    return this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent__f_body;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent.prototype.copy__Llaika_api_config_Config__s_Option__Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent = (function(attributes, body) {
  return new $c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent(this.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent__f_$outer, attributes, body);
});
function $as_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent(obj) {
  return (((obj instanceof $c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.DirectiveBuilderContext$DirectiveContent"));
}
function $isArrayOf_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent)));
}
function $asArrayOf_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.DirectiveBuilderContext$DirectiveContent;", depth));
}
var $d_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent, "laika.api.bundle.DirectiveBuilderContext$DirectiveContent", ({
  Llaika_api_bundle_DirectiveBuilderContext$DirectiveContent: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$Multipart(outer, mainBody, children) {
  this.Llaika_api_bundle_DirectiveBuilderContext$Multipart__f_mainBody = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$Multipart__f_children = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$Multipart__f_$outer = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$Multipart__f_mainBody = mainBody;
  this.Llaika_api_bundle_DirectiveBuilderContext$Multipart__f_children = children;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_bundle_DirectiveBuilderContext$Multipart__f_$outer = outer;
}
$c_Llaika_api_bundle_DirectiveBuilderContext$Multipart.prototype = new $h_O();
$c_Llaika_api_bundle_DirectiveBuilderContext$Multipart.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$Multipart;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$Multipart() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$Multipart.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$Multipart.prototype;
$c_Llaika_api_bundle_DirectiveBuilderContext$Multipart.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$Multipart.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$Multipart.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Llaika_api_bundle_DirectiveBuilderContext$Multipart) && ($n($as_Llaika_api_bundle_DirectiveBuilderContext$Multipart(x$0)).Llaika_api_bundle_DirectiveBuilderContext$Multipart__f_$outer === this.Llaika_api_bundle_DirectiveBuilderContext$Multipart__f_$outer))) {
    var x$0$2 = $as_Llaika_api_bundle_DirectiveBuilderContext$Multipart(x$0);
    var x = this.Llaika_api_bundle_DirectiveBuilderContext$Multipart__f_mainBody;
    var x$2 = $n(x$0$2).Llaika_api_bundle_DirectiveBuilderContext$Multipart__f_mainBody;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_api_bundle_DirectiveBuilderContext$Multipart__f_children;
      var x$4 = $n(x$0$2).Llaika_api_bundle_DirectiveBuilderContext$Multipart__f_children;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_bundle_DirectiveBuilderContext$Multipart.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$Multipart.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_api_bundle_DirectiveBuilderContext$Multipart.prototype.productPrefix__T = (function() {
  return "Multipart";
});
$c_Llaika_api_bundle_DirectiveBuilderContext$Multipart.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_bundle_DirectiveBuilderContext$Multipart__f_mainBody;
  }
  if ((n === 1)) {
    return this.Llaika_api_bundle_DirectiveBuilderContext$Multipart__f_children;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_api_bundle_DirectiveBuilderContext$Multipart.prototype.collect__s_reflect_ClassTag__sci_Seq = (function(evidence$1) {
  return $as_sci_Seq($n(this.Llaika_api_bundle_DirectiveBuilderContext$Multipart__f_children).collect__s_PartialFunction__O(new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$1(evidence$1)));
});
function $as_Llaika_api_bundle_DirectiveBuilderContext$Multipart(obj) {
  return (((obj instanceof $c_Llaika_api_bundle_DirectiveBuilderContext$Multipart) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.DirectiveBuilderContext$Multipart"));
}
function $isArrayOf_Llaika_api_bundle_DirectiveBuilderContext$Multipart(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_DirectiveBuilderContext$Multipart)));
}
function $asArrayOf_Llaika_api_bundle_DirectiveBuilderContext$Multipart(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_DirectiveBuilderContext$Multipart(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.DirectiveBuilderContext$Multipart;", depth));
}
var $d_Llaika_api_bundle_DirectiveBuilderContext$Multipart = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$Multipart, "laika.api.bundle.DirectiveBuilderContext$Multipart", ({
  Llaika_api_bundle_DirectiveBuilderContext$Multipart: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_TranslatorConfig(versions, titleDocInputName, titleDocOutputName, siteBaseURL) {
  this.Llaika_api_bundle_TranslatorConfig__f_versions = null;
  this.Llaika_api_bundle_TranslatorConfig__f_titleDocInputName = null;
  this.Llaika_api_bundle_TranslatorConfig__f_titleDocOutputName = null;
  this.Llaika_api_bundle_TranslatorConfig__f_siteBaseURL = null;
  this.Llaika_api_bundle_TranslatorConfig__f_versions = versions;
  this.Llaika_api_bundle_TranslatorConfig__f_titleDocInputName = titleDocInputName;
  this.Llaika_api_bundle_TranslatorConfig__f_titleDocOutputName = titleDocOutputName;
  this.Llaika_api_bundle_TranslatorConfig__f_siteBaseURL = siteBaseURL;
}
$c_Llaika_api_bundle_TranslatorConfig.prototype = new $h_O();
$c_Llaika_api_bundle_TranslatorConfig.prototype.constructor = $c_Llaika_api_bundle_TranslatorConfig;
/** @constructor */
function $h_Llaika_api_bundle_TranslatorConfig() {
}
$h_Llaika_api_bundle_TranslatorConfig.prototype = $c_Llaika_api_bundle_TranslatorConfig.prototype;
$c_Llaika_api_bundle_TranslatorConfig.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_bundle_TranslatorConfig.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_bundle_TranslatorConfig.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_bundle_TranslatorConfig)) {
    var x$0$2 = $as_Llaika_api_bundle_TranslatorConfig(x$0);
    var x = this.Llaika_api_bundle_TranslatorConfig__f_versions;
    var x$2 = $n(x$0$2).Llaika_api_bundle_TranslatorConfig__f_versions;
    if (((((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) && (this.Llaika_api_bundle_TranslatorConfig__f_titleDocInputName === $n(x$0$2).Llaika_api_bundle_TranslatorConfig__f_titleDocInputName)) && (this.Llaika_api_bundle_TranslatorConfig__f_titleDocOutputName === $n(x$0$2).Llaika_api_bundle_TranslatorConfig__f_titleDocOutputName))) {
      var x$3 = this.Llaika_api_bundle_TranslatorConfig__f_siteBaseURL;
      var x$4 = $n(x$0$2).Llaika_api_bundle_TranslatorConfig__f_siteBaseURL;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_bundle_TranslatorConfig.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_bundle_TranslatorConfig.prototype.productArity__I = (function() {
  return 4;
});
$c_Llaika_api_bundle_TranslatorConfig.prototype.productPrefix__T = (function() {
  return "TranslatorConfig";
});
$c_Llaika_api_bundle_TranslatorConfig.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_api_bundle_TranslatorConfig__f_versions;
      break;
    }
    case 1: {
      return this.Llaika_api_bundle_TranslatorConfig__f_titleDocInputName;
      break;
    }
    case 2: {
      return this.Llaika_api_bundle_TranslatorConfig__f_titleDocOutputName;
      break;
    }
    case 3: {
      return this.Llaika_api_bundle_TranslatorConfig__f_siteBaseURL;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Llaika_api_bundle_TranslatorConfig(obj) {
  return (((obj instanceof $c_Llaika_api_bundle_TranslatorConfig) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.TranslatorConfig"));
}
function $isArrayOf_Llaika_api_bundle_TranslatorConfig(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_TranslatorConfig)));
}
function $asArrayOf_Llaika_api_bundle_TranslatorConfig(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_TranslatorConfig(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.TranslatorConfig;", depth));
}
var $d_Llaika_api_bundle_TranslatorConfig = new $TypeData().initClass($c_Llaika_api_bundle_TranslatorConfig, "laika.api.bundle.TranslatorConfig", ({
  Llaika_api_bundle_TranslatorConfig: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigError$InvalidField(name, failure) {
  this.Llaika_api_config_ConfigError$InvalidField__f_name = null;
  this.Llaika_api_config_ConfigError$InvalidField__f_failure = null;
  this.Llaika_api_config_ConfigError$InvalidField__f_name = name;
  this.Llaika_api_config_ConfigError$InvalidField__f_failure = failure;
}
$c_Llaika_api_config_ConfigError$InvalidField.prototype = new $h_O();
$c_Llaika_api_config_ConfigError$InvalidField.prototype.constructor = $c_Llaika_api_config_ConfigError$InvalidField;
/** @constructor */
function $h_Llaika_api_config_ConfigError$InvalidField() {
}
$h_Llaika_api_config_ConfigError$InvalidField.prototype = $c_Llaika_api_config_ConfigError$InvalidField.prototype;
$c_Llaika_api_config_ConfigError$InvalidField.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_ConfigError$InvalidField.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_config_ConfigError$InvalidField.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_config_ConfigError$InvalidField)) {
    var x$0$2 = $as_Llaika_api_config_ConfigError$InvalidField(x$0);
    if ((this.Llaika_api_config_ConfigError$InvalidField__f_name === $n(x$0$2).Llaika_api_config_ConfigError$InvalidField__f_name)) {
      var x = this.Llaika_api_config_ConfigError$InvalidField__f_failure;
      var x$2 = $n(x$0$2).Llaika_api_config_ConfigError$InvalidField__f_failure;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_config_ConfigError$InvalidField.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_api_config_ConfigError$InvalidField.prototype.productPrefix__T = (function() {
  return "InvalidField";
});
$c_Llaika_api_config_ConfigError$InvalidField.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_config_ConfigError$InvalidField__f_name;
  }
  if ((n === 1)) {
    return this.Llaika_api_config_ConfigError$InvalidField__f_failure;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_api_config_ConfigError$InvalidField.prototype.toString__T = (function() {
  var prefix = (((this.Llaika_api_config_ConfigError$InvalidField__f_name === "<invalid>") || (this.Llaika_api_config_ConfigError$InvalidField__f_name === "<RootKey>")) ? "" : (("'" + this.Llaika_api_config_ConfigError$InvalidField__f_name) + "': "));
  return (prefix + $n(this.Llaika_api_config_ConfigError$InvalidField__f_failure).toString__T());
});
function $as_Llaika_api_config_ConfigError$InvalidField(obj) {
  return (((obj instanceof $c_Llaika_api_config_ConfigError$InvalidField) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.ConfigError$InvalidField"));
}
function $isArrayOf_Llaika_api_config_ConfigError$InvalidField(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_ConfigError$InvalidField)));
}
function $asArrayOf_Llaika_api_config_ConfigError$InvalidField(obj, depth) {
  return (($isArrayOf_Llaika_api_config_ConfigError$InvalidField(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.ConfigError$InvalidField;", depth));
}
var $d_Llaika_api_config_ConfigError$InvalidField = new $TypeData().initClass($c_Llaika_api_config_ConfigError$InvalidField, "laika.api.config.ConfigError$InvalidField", ({
  Llaika_api_config_ConfigError$InvalidField: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $is_Llaika_api_config_ConfigValue(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_api_config_ConfigValue)));
}
function $as_Llaika_api_config_ConfigValue(obj) {
  return (($is_Llaika_api_config_ConfigValue(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.ConfigValue"));
}
function $isArrayOf_Llaika_api_config_ConfigValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_ConfigValue)));
}
function $asArrayOf_Llaika_api_config_ConfigValue(obj, depth) {
  return (($isArrayOf_Llaika_api_config_ConfigValue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.ConfigValue;", depth));
}
var $d_Llaika_api_config_ConfigValue = new $TypeData().initClass(1, "laika.api.config.ConfigValue", ({
  Llaika_api_config_ConfigValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_config_Field(key, value, origin) {
  this.Llaika_api_config_Field__f_key = null;
  this.Llaika_api_config_Field__f_value = null;
  this.Llaika_api_config_Field__f_origin = null;
  this.Llaika_api_config_Field__f_key = key;
  this.Llaika_api_config_Field__f_value = value;
  this.Llaika_api_config_Field__f_origin = origin;
}
$c_Llaika_api_config_Field.prototype = new $h_O();
$c_Llaika_api_config_Field.prototype.constructor = $c_Llaika_api_config_Field;
/** @constructor */
function $h_Llaika_api_config_Field() {
}
$h_Llaika_api_config_Field.prototype = $c_Llaika_api_config_Field.prototype;
$c_Llaika_api_config_Field.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_Field.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_config_Field.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_config_Field)) {
    var x$0$2 = $as_Llaika_api_config_Field(x$0);
    if ((this.Llaika_api_config_Field__f_key === $n(x$0$2).Llaika_api_config_Field__f_key)) {
      var x = this.Llaika_api_config_Field__f_value;
      var x$2 = $n(x$0$2).Llaika_api_config_Field__f_value;
      var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Llaika_api_config_Field__f_origin;
      var x$4 = $n(x$0$2).Llaika_api_config_Field__f_origin;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_config_Field.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_config_Field.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_api_config_Field.prototype.productPrefix__T = (function() {
  return "Field";
});
$c_Llaika_api_config_Field.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_api_config_Field__f_key;
      break;
    }
    case 1: {
      return this.Llaika_api_config_Field__f_value;
      break;
    }
    case 2: {
      return this.Llaika_api_config_Field__f_origin;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Llaika_api_config_Field(obj) {
  return (((obj instanceof $c_Llaika_api_config_Field) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.Field"));
}
function $isArrayOf_Llaika_api_config_Field(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_Field)));
}
function $asArrayOf_Llaika_api_config_Field(obj, depth) {
  return (($isArrayOf_Llaika_api_config_Field(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.Field;", depth));
}
var $d_Llaika_api_config_Field = new $TypeData().initClass($c_Llaika_api_config_Field, "laika.api.config.Field", ({
  Llaika_api_config_Field: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_config_Key(segments) {
  this.Llaika_api_config_Key__f_segments = null;
  this.Llaika_api_config_Key__f_segments = segments;
}
$c_Llaika_api_config_Key.prototype = new $h_O();
$c_Llaika_api_config_Key.prototype.constructor = $c_Llaika_api_config_Key;
/** @constructor */
function $h_Llaika_api_config_Key() {
}
$h_Llaika_api_config_Key.prototype = $c_Llaika_api_config_Key.prototype;
$c_Llaika_api_config_Key.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_Key.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_config_Key.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_config_Key)) {
    var x$0$2 = $as_Llaika_api_config_Key(x$0);
    var x = this.Llaika_api_config_Key__f_segments;
    var x$2 = $n(x$0$2).Llaika_api_config_Key__f_segments;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_config_Key.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_api_config_Key.prototype.productPrefix__T = (function() {
  return "Key";
});
$c_Llaika_api_config_Key.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_config_Key__f_segments;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_api_config_Key.prototype.child__T__Llaika_api_config_Key = (function(segment) {
  $m_Llaika_api_config_Key$();
  var this$1 = $n(this.Llaika_api_config_Key__f_segments);
  var segments = $as_sci_Seq(this$1.appended__O__O(segment));
  return new $c_Llaika_api_config_Key(segments);
});
$c_Llaika_api_config_Key.prototype.child__Llaika_api_config_Key__Llaika_api_config_Key = (function(childKey) {
  $m_Llaika_api_config_Key$();
  var this$1 = $n(this.Llaika_api_config_Key__f_segments);
  var suffix = $n(childKey).Llaika_api_config_Key__f_segments;
  var segments = $as_sci_Seq(this$1.appendedAll__sc_IterableOnce__O(suffix));
  return new $c_Llaika_api_config_Key(segments);
});
$c_Llaika_api_config_Key.prototype.isChild__Llaika_api_config_Key__Z = (function(other) {
  return $n(this.Llaika_api_config_Key__f_segments).startsWith__sc_IterableOnce__I__Z($n(other).Llaika_api_config_Key__f_segments, $n(this.Llaika_api_config_Key__f_segments).startsWith$default$2__I());
});
$c_Llaika_api_config_Key.prototype.parent__Llaika_api_config_Key = (function() {
  if ($n(this.Llaika_api_config_Key__f_segments).isEmpty__Z()) {
    return this;
  } else {
    $m_Llaika_api_config_Key$();
    var segments = $as_sci_Seq($n(this.Llaika_api_config_Key__f_segments).init__O());
    return new $c_Llaika_api_config_Key(segments);
  }
});
$c_Llaika_api_config_Key.prototype.local__Llaika_api_config_Key = (function() {
  return ($n(this.Llaika_api_config_Key__f_segments).isEmpty__Z() ? this : $m_Llaika_api_config_Key$().apply__T__sci_Seq__Llaika_api_config_Key($as_T($n(this.Llaika_api_config_Key__f_segments).last__O()), $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([]))));
});
$c_Llaika_api_config_Key.prototype.toString__T = (function() {
  if ($n(this.Llaika_api_config_Key__f_segments).isEmpty__Z()) {
    return "<RootKey>";
  } else {
    var this$1 = $n(this.Llaika_api_config_Key__f_segments);
    return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, "", ".", "");
  }
});
function $as_Llaika_api_config_Key(obj) {
  return (((obj instanceof $c_Llaika_api_config_Key) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.Key"));
}
function $isArrayOf_Llaika_api_config_Key(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_Key)));
}
function $asArrayOf_Llaika_api_config_Key(obj, depth) {
  return (($isArrayOf_Llaika_api_config_Key(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.Key;", depth));
}
var $d_Llaika_api_config_Key = new $TypeData().initClass($c_Llaika_api_config_Key, "laika.api.config.Key", ({
  Llaika_api_config_Key: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_config_Origin(scope, path, sourcePath) {
  this.Llaika_api_config_Origin__f_scope = null;
  this.Llaika_api_config_Origin__f_path = null;
  this.Llaika_api_config_Origin__f_sourcePath = null;
  this.Llaika_api_config_Origin__f_scope = scope;
  this.Llaika_api_config_Origin__f_path = path;
  this.Llaika_api_config_Origin__f_sourcePath = sourcePath;
}
$c_Llaika_api_config_Origin.prototype = new $h_O();
$c_Llaika_api_config_Origin.prototype.constructor = $c_Llaika_api_config_Origin;
/** @constructor */
function $h_Llaika_api_config_Origin() {
}
$h_Llaika_api_config_Origin.prototype = $c_Llaika_api_config_Origin.prototype;
$c_Llaika_api_config_Origin.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_Origin.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_config_Origin.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_config_Origin)) {
    var x$0$2 = $as_Llaika_api_config_Origin(x$0);
    var x = this.Llaika_api_config_Origin__f_scope;
    var x$2 = $n(x$0$2).Llaika_api_config_Origin__f_scope;
    if ((x === null)) {
      var $x_3 = (x$2 === null);
    } else {
      var this$1 = $n(x);
      var $x_3 = (this$1 === x$2);
    }
    if ($x_3) {
      var x$3 = this.Llaika_api_config_Origin__f_path;
      var x$4 = $n(x$0$2).Llaika_api_config_Origin__f_path;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llaika_api_config_Origin__f_sourcePath;
      var x$6 = $n(x$0$2).Llaika_api_config_Origin__f_sourcePath;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_config_Origin.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_config_Origin.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_api_config_Origin.prototype.productPrefix__T = (function() {
  return "Origin";
});
$c_Llaika_api_config_Origin.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_api_config_Origin__f_scope;
      break;
    }
    case 1: {
      return this.Llaika_api_config_Origin__f_path;
      break;
    }
    case 2: {
      return this.Llaika_api_config_Origin__f_sourcePath;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Llaika_api_config_Origin(obj) {
  return (((obj instanceof $c_Llaika_api_config_Origin) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.Origin"));
}
function $isArrayOf_Llaika_api_config_Origin(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_Origin)));
}
function $asArrayOf_Llaika_api_config_Origin(obj, depth) {
  return (($isArrayOf_Llaika_api_config_Origin(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.Origin;", depth));
}
var $d_Llaika_api_config_Origin = new $TypeData().initClass($c_Llaika_api_config_Origin, "laika.api.config.Origin", ({
  Llaika_api_config_Origin: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_config_Traced(value, origin) {
  this.Llaika_api_config_Traced__f_value = null;
  this.Llaika_api_config_Traced__f_origin = null;
  this.Llaika_api_config_Traced__f_value = value;
  this.Llaika_api_config_Traced__f_origin = origin;
}
$c_Llaika_api_config_Traced.prototype = new $h_O();
$c_Llaika_api_config_Traced.prototype.constructor = $c_Llaika_api_config_Traced;
/** @constructor */
function $h_Llaika_api_config_Traced() {
}
$h_Llaika_api_config_Traced.prototype = $c_Llaika_api_config_Traced.prototype;
$c_Llaika_api_config_Traced.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_Traced.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_config_Traced.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_config_Traced)) {
    var x$0$2 = $as_Llaika_api_config_Traced(x$0);
    var x = this.Llaika_api_config_Traced__f_value;
    var y = $n(x$0$2).Llaika_api_config_Traced__f_value;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Llaika_api_config_Traced__f_origin;
      var x$2 = $n(x$0$2).Llaika_api_config_Traced__f_origin;
      var $x_1 = ((x$1 === null) ? (x$2 === null) : $n(x$1).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_config_Traced.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_config_Traced.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_api_config_Traced.prototype.productPrefix__T = (function() {
  return "Traced";
});
$c_Llaika_api_config_Traced.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_config_Traced__f_value;
  }
  if ((n === 1)) {
    return this.Llaika_api_config_Traced__f_origin;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_api_config_Traced(obj) {
  return (((obj instanceof $c_Llaika_api_config_Traced) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.Traced"));
}
function $isArrayOf_Llaika_api_config_Traced(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_Traced)));
}
function $asArrayOf_Llaika_api_config_Traced(obj, depth) {
  return (($isArrayOf_Llaika_api_config_Traced(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.Traced;", depth));
}
var $d_Llaika_api_config_Traced = new $TypeData().initClass($c_Llaika_api_config_Traced, "laika.api.config.Traced", ({
  Llaika_api_config_Traced: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_format_Formatter$Indentation(currentLevel, numSpaces, dotted) {
  this.Llaika_api_format_Formatter$Indentation__f_currentLevel = 0;
  this.Llaika_api_format_Formatter$Indentation__f_numSpaces = 0;
  this.Llaika_api_format_Formatter$Indentation__f_dotted = false;
  this.Llaika_api_format_Formatter$Indentation__f_newLine = null;
  this.Llaika_api_format_Formatter$Indentation__f_nextLevel$lzy2 = null;
  this.Llaika_api_format_Formatter$Indentation__f_nextLevelbitmap$2 = false;
  this.Llaika_api_format_Formatter$Indentation__f_currentLevel = currentLevel;
  this.Llaika_api_format_Formatter$Indentation__f_numSpaces = numSpaces;
  this.Llaika_api_format_Formatter$Indentation__f_dotted = dotted;
  this.Llaika_api_format_Formatter$Indentation__f_newLine = (dotted ? (("\n" + $m_sc_StringOps$().$times$extension__T__I__T(". ", ((currentLevel / 2) | 0))) + ((((currentLevel % 2) | 0) === 1) ? "." : "")) : ("\n" + $m_sc_StringOps$().$times$extension__T__I__T(" ", currentLevel)));
}
$c_Llaika_api_format_Formatter$Indentation.prototype = new $h_O();
$c_Llaika_api_format_Formatter$Indentation.prototype.constructor = $c_Llaika_api_format_Formatter$Indentation;
/** @constructor */
function $h_Llaika_api_format_Formatter$Indentation() {
}
$h_Llaika_api_format_Formatter$Indentation.prototype = $c_Llaika_api_format_Formatter$Indentation.prototype;
$c_Llaika_api_format_Formatter$Indentation.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_format_Formatter$Indentation.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Indentation");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Llaika_api_format_Formatter$Indentation__f_currentLevel;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Llaika_api_format_Formatter$Indentation__f_numSpaces;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = (this.Llaika_api_format_Formatter$Indentation__f_dotted ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Llaika_api_format_Formatter$Indentation.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_format_Formatter$Indentation)) {
    var x$0$2 = $as_Llaika_api_format_Formatter$Indentation(x$0);
    return ((((this.Llaika_api_format_Formatter$Indentation__f_currentLevel === $n(x$0$2).Llaika_api_format_Formatter$Indentation__f_currentLevel) && (this.Llaika_api_format_Formatter$Indentation__f_numSpaces === $n(x$0$2).Llaika_api_format_Formatter$Indentation__f_numSpaces)) && (this.Llaika_api_format_Formatter$Indentation__f_dotted === $n(x$0$2).Llaika_api_format_Formatter$Indentation__f_dotted)) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Llaika_api_format_Formatter$Indentation.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_format_Formatter$Indentation.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_api_format_Formatter$Indentation.prototype.productPrefix__T = (function() {
  return "Indentation";
});
$c_Llaika_api_format_Formatter$Indentation.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_api_format_Formatter$Indentation__f_currentLevel;
      break;
    }
    case 1: {
      return this.Llaika_api_format_Formatter$Indentation__f_numSpaces;
      break;
    }
    case 2: {
      return this.Llaika_api_format_Formatter$Indentation__f_dotted;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_api_format_Formatter$Indentation.prototype.nextLevel__Llaika_api_format_Formatter$Indentation = (function() {
  if ((!this.Llaika_api_format_Formatter$Indentation__f_nextLevelbitmap$2)) {
    if ((this.Llaika_api_format_Formatter$Indentation__f_numSpaces === 0)) {
      var $x_1 = this;
    } else {
      var currentLevel = ((this.Llaika_api_format_Formatter$Indentation__f_currentLevel + this.Llaika_api_format_Formatter$Indentation__f_numSpaces) | 0);
      var numSpaces = this.Llaika_api_format_Formatter$Indentation__f_numSpaces;
      var dotted = this.Llaika_api_format_Formatter$Indentation__f_dotted;
      var $x_1 = new $c_Llaika_api_format_Formatter$Indentation(currentLevel, numSpaces, dotted);
    }
    this.Llaika_api_format_Formatter$Indentation__f_nextLevel$lzy2 = $x_1;
    this.Llaika_api_format_Formatter$Indentation__f_nextLevelbitmap$2 = true;
  }
  return this.Llaika_api_format_Formatter$Indentation__f_nextLevel$lzy2;
});
function $as_Llaika_api_format_Formatter$Indentation(obj) {
  return (((obj instanceof $c_Llaika_api_format_Formatter$Indentation) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.format.Formatter$Indentation"));
}
function $isArrayOf_Llaika_api_format_Formatter$Indentation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_format_Formatter$Indentation)));
}
function $asArrayOf_Llaika_api_format_Formatter$Indentation(obj, depth) {
  return (($isArrayOf_Llaika_api_format_Formatter$Indentation(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.format.Formatter$Indentation;", depth));
}
var $d_Llaika_api_format_Formatter$Indentation = new $TypeData().initClass($c_Llaika_api_format_Formatter$Indentation, "laika.api.format.Formatter$Indentation", ({
  Llaika_api_format_Formatter$Indentation: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $p_Llaika_ast_Document__findRoot__sci_Seq($thiz) {
  var this$1 = $n($thiz.Llaika_ast_Document__f_content);
  var pf = new $c_Llaika_ast_Document$$anon$1();
  var this$4 = $n($f_Llaika_ast_ElementTraversal__collect__s_PartialFunction__sci_List(this$1, pf));
  var this$3 = $m_s_$less$colon$less$();
  var toIterableOnce = this$3.s_$less$colon$less$__f_singleton;
  var this$5 = $n($n($as_sc_LinearSeqOps($f_sc_StrictOptimizedIterableOps__flatten__F1__O(this$4, toIterableOnce))).headOption__s_Option());
  return $as_sci_Seq((this$5.isEmpty__Z() ? $m_sci_Nil$() : this$5.get__O()));
}
function $p_Llaika_ast_Document__titleFromTree$1__s_Option($thiz) {
  var content = $p_Llaika_ast_Document__findRoot__sci_Seq($thiz);
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  var this$3 = new $c_Llaika_ast_RootElement(content, options);
  var pf = new $c_Llaika_ast_Document$$anon$2();
  return $n($f_Llaika_ast_ElementTraversal__collect__s_PartialFunction__sci_List(this$3, pf)).headOption__s_Option();
}
/** @constructor */
function $c_Llaika_ast_Document(context, content, fragments) {
  this.Llaika_ast_Document__f_context = null;
  this.Llaika_ast_Document__f_content = null;
  this.Llaika_ast_Document__f_fragments = null;
  this.Llaika_ast_Document__f_sections$lzy1 = null;
  this.Llaika_ast_Document__f_sectionsbitmap$1 = false;
  this.Llaika_ast_Document__f_configScope = null;
  this.Llaika_ast_Document__f_context = context;
  this.Llaika_ast_Document__f_content = content;
  this.Llaika_ast_Document__f_fragments = fragments;
  this.Llaika_ast_Document__f_configScope = $m_Llaika_api_config_Origin$DocumentScope$();
}
$c_Llaika_ast_Document.prototype = new $h_O();
$c_Llaika_ast_Document.prototype.constructor = $c_Llaika_ast_Document;
/** @constructor */
function $h_Llaika_ast_Document() {
}
$h_Llaika_ast_Document.prototype = $c_Llaika_ast_Document.prototype;
$c_Llaika_ast_Document.prototype.asNavigationItem__Llaika_ast_NavigationBuilderContext__Llaika_ast_NavigationItem = (function(context) {
  return $f_Llaika_ast_DocumentNavigation__asNavigationItem__Llaika_ast_NavigationBuilderContext__Llaika_ast_NavigationItem(this, context);
});
$c_Llaika_ast_Document.prototype.path__Llaika_ast_Path = (function() {
  return $n(this.Llaika_ast_Document__f_context).path__Llaika_ast_Path();
});
$c_Llaika_ast_Document.prototype.config__Llaika_api_config_Config = (function() {
  return $n(this.Llaika_ast_Document__f_context).config__Llaika_api_config_Config();
});
$c_Llaika_ast_Document.prototype.withConfig__Llaika_api_config_Config__Llaika_ast_Document = (function(config) {
  $n(this.Llaika_ast_Document__f_context);
  var this$1 = $n(this.Llaika_ast_Document__f_context);
  var localPath = this$1.Llaika_ast_TreeNodeContext__f_localPath;
  var this$2 = $n(this.Llaika_ast_Document__f_context);
  var index = this$2.Llaika_ast_TreeNodeContext__f_index;
  var this$3 = $n(this.Llaika_ast_Document__f_context);
  var parent = this$3.Llaika_ast_TreeNodeContext__f_parent;
  var newContext = new $c_Llaika_ast_TreeNodeContext(localPath, config, index, parent);
  return new $c_Llaika_ast_Document(newContext, this.Llaika_ast_Document__f_content, this.Llaika_ast_Document__f_fragments);
});
$c_Llaika_ast_Document.prototype.withFragments__sci_Map__Llaika_ast_Document = (function(newFragments) {
  return new $c_Llaika_ast_Document(this.Llaika_ast_Document__f_context, this.Llaika_ast_Document__f_content, newFragments);
});
$c_Llaika_ast_Document.prototype.position__Llaika_ast_TreePosition = (function() {
  return $n(this.Llaika_ast_Document__f_context).position__Llaika_ast_TreePosition();
});
$c_Llaika_ast_Document.prototype.withPosition__Llaika_ast_TreeNodeIndex__Llaika_ast_Document = (function(index) {
  $n(this.Llaika_ast_Document__f_context);
  var this$1 = $n(this.Llaika_ast_Document__f_context);
  var localPath = this$1.Llaika_ast_TreeNodeContext__f_localPath;
  var this$2 = $n(this.Llaika_ast_Document__f_context);
  var localConfig = this$2.Llaika_ast_TreeNodeContext__f_localConfig;
  var this$3 = $n(this.Llaika_ast_Document__f_context);
  var parent = this$3.Llaika_ast_TreeNodeContext__f_parent;
  return new $c_Llaika_ast_Document(new $c_Llaika_ast_TreeNodeContext(localPath, localConfig, index, parent), this.Llaika_ast_Document__f_content, this.Llaika_ast_Document__f_fragments);
});
$c_Llaika_ast_Document.prototype.withContent__Llaika_ast_RootElement__sci_Map__Llaika_ast_Document = (function(content, fragments) {
  return new $c_Llaika_ast_Document(this.Llaika_ast_Document__f_context, content, fragments);
});
$c_Llaika_ast_Document.prototype.withParent__Llaika_ast_TreeNodeContext__Llaika_ast_Document = (function(parent) {
  var parent$1 = new $c_s_Some(parent);
  var this$2 = $n(this.Llaika_ast_Document__f_context);
  var localPath$1 = this$2.Llaika_ast_TreeNodeContext__f_localPath;
  var this$3 = $n(this.Llaika_ast_Document__f_context);
  var localConfig$1 = this$3.Llaika_ast_TreeNodeContext__f_localConfig;
  var this$4 = $n(this.Llaika_ast_Document__f_context);
  var index$1 = this$4.Llaika_ast_TreeNodeContext__f_index;
  $n(this.Llaika_ast_Document__f_context);
  return new $c_Llaika_ast_Document(new $c_Llaika_ast_TreeNodeContext(localPath$1, localConfig$1, index$1, parent$1), this.Llaika_ast_Document__f_content, this.Llaika_ast_Document__f_fragments);
});
$c_Llaika_ast_Document.prototype.title__s_Option = (function() {
  var this$1 = $n($f_Llaika_ast_TreeContent__titleFromConfig__s_Option(this));
  return (this$1.isEmpty__Z() ? $p_Llaika_ast_Document__titleFromTree$1__s_Option(this) : this$1);
});
$c_Llaika_ast_Document.prototype.sections__sci_Seq = (function() {
  if ((!this.Llaika_ast_Document__f_sectionsbitmap$1)) {
    this.Llaika_ast_Document__f_sections$lzy1 = this.laika$ast$Document$$_$extractSections$1__sci_Seq__sci_Seq($p_Llaika_ast_Document__findRoot__sci_Seq(this));
    this.Llaika_ast_Document__f_sectionsbitmap$1 = true;
  }
  return this.Llaika_ast_Document__f_sections$lzy1;
});
$c_Llaika_ast_Document.prototype.invalidElements__Llaika_config_MessageFilter__sci_Seq = (function(filter) {
  var x = $m_Llaika_config_MessageFilter$None$();
  if ((x === filter)) {
    return $m_sci_Nil$();
  } else {
    var this$1 = $n(this.Llaika_ast_Document__f_content);
    var pf = new $c_Llaika_ast_Document$$anon$5(filter);
    return $f_Llaika_ast_ElementTraversal__collect__s_PartialFunction__sci_List(this$1, pf);
  }
});
$c_Llaika_ast_Document.prototype.rewrite__Llaika_ast_RewriteRules__s_util_Either = (function(rules) {
  var this$2 = $n($m_Llaika_ast_DocumentCursor$().apply__Llaika_ast_Document__s_Option__s_util_Either(this, $m_s_None$()));
  if ((this$2 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$2);
    var b = $n(x2).s_util_Right__f_value;
    var _$6 = $as_Llaika_ast_DocumentCursor(b);
    return new $c_s_util_Right($n(_$6).rewriteTarget__Llaika_ast_RewriteRules__Llaika_ast_Document(rules));
  } else {
    return this$2;
  }
});
$c_Llaika_ast_Document.prototype.configScope__Llaika_api_config_Origin$Scope = (function() {
  return this.Llaika_ast_Document__f_configScope;
});
$c_Llaika_ast_Document.prototype.laika$ast$Document$$_$extractSections$1__sci_Seq__sci_Seq = (function(blocks) {
  return $as_sci_Seq($n(blocks).collect__s_PartialFunction__O(new $c_Llaika_ast_Document$$anon$3(this)));
});
function $as_Llaika_ast_Document(obj) {
  return (((obj instanceof $c_Llaika_ast_Document) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Document"));
}
function $isArrayOf_Llaika_ast_Document(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Document)));
}
function $asArrayOf_Llaika_ast_Document(obj, depth) {
  return (($isArrayOf_Llaika_ast_Document(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Document;", depth));
}
var $d_Llaika_ast_Document = new $TypeData().initClass($c_Llaika_ast_Document, "laika.ast.Document", ({
  Llaika_ast_Document: 1,
  Llaika_ast_Navigatable: 1,
  Llaika_ast_DocumentNavigation: 1,
  Llaika_ast_TreeContent: 1
}));
/** @constructor */
function $c_Llaika_ast_Element() {
}
$c_Llaika_ast_Element.prototype = new $h_O();
$c_Llaika_ast_Element.prototype.constructor = $c_Llaika_ast_Element;
/** @constructor */
function $h_Llaika_ast_Element() {
}
$h_Llaika_ast_Element.prototype = $c_Llaika_ast_Element.prototype;
$c_Llaika_ast_Element.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_Element.prototype.hasStyle__T__Z = (function(name) {
  return $n($n(this.options__Llaika_ast_Options()).Llaika_ast_Options$Impl__f_styles).contains__O__Z(name);
});
$c_Llaika_ast_Element.prototype.hasId__Z = (function() {
  var this$1 = $n($n(this.options__Llaika_ast_Options()).Llaika_ast_Options$Impl__f_id);
  return (!this$1.isEmpty__Z());
});
$c_Llaika_ast_Element.prototype.withoutId__Llaika_ast_Element = (function() {
  var arg1 = this.options__Llaika_ast_Options();
  return this.withOptions__Llaika_ast_Options__Llaika_ast_Element($m_Llaika_ast_Options$().apply__s_Option__sci_Set__Llaika_ast_Options($m_s_None$(), $n(arg1).Llaika_ast_Options$Impl__f_styles));
});
$c_Llaika_ast_Element.prototype.withId__T__Llaika_ast_Element = (function(id) {
  var arg1 = this.options__Llaika_ast_Options();
  return this.withOptions__Llaika_ast_Options__Llaika_ast_Element($m_Llaika_ast_Options$().apply__s_Option__sci_Set__Llaika_ast_Options(new $c_s_Some(id), $n(arg1).Llaika_ast_Options$Impl__f_styles));
});
$c_Llaika_ast_Element.prototype.withStyles__T__sci_Seq__Llaika_ast_Element = (function(style, styles) {
  var this$1 = $n(styles);
  var this$2 = $n($as_sc_IterableOnceOps(this$1.prepended__O__O(style)));
  var values = $m_sci_Set$().from__sc_IterableOnce__sci_Set($as_sc_IterableOnce(this$2));
  return this.mergeOptions__Llaika_ast_Options__Llaika_ast_Element($m_Llaika_ast_Options$().apply__s_Option__sci_Set__Llaika_ast_Options(($m_Llaika_ast_Options$(), $m_s_None$()), values));
});
$c_Llaika_ast_Element.prototype.mergeOptions__Llaika_ast_Options__Llaika_ast_Element = (function(opt) {
  var arg1 = this.options__Llaika_ast_Options();
  return this.withOptions__Llaika_ast_Options__Llaika_ast_Element($n(arg1).$plus__Llaika_ast_Options__Llaika_ast_Options(opt));
});
function $as_Llaika_ast_Element(obj) {
  return (((obj instanceof $c_Llaika_ast_Element) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Element"));
}
function $isArrayOf_Llaika_ast_Element(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Element)));
}
function $asArrayOf_Llaika_ast_Element(obj, depth) {
  return (($isArrayOf_Llaika_ast_Element(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Element;", depth));
}
/** @constructor */
function $c_Llaika_ast_EnumFormat(enumType, prefix, suffix) {
  this.Llaika_ast_EnumFormat__f_enumType = null;
  this.Llaika_ast_EnumFormat__f_prefix = null;
  this.Llaika_ast_EnumFormat__f_suffix = null;
  this.Llaika_ast_EnumFormat__f_enumType = enumType;
  this.Llaika_ast_EnumFormat__f_prefix = prefix;
  this.Llaika_ast_EnumFormat__f_suffix = suffix;
}
$c_Llaika_ast_EnumFormat.prototype = new $h_O();
$c_Llaika_ast_EnumFormat.prototype.constructor = $c_Llaika_ast_EnumFormat;
/** @constructor */
function $h_Llaika_ast_EnumFormat() {
}
$h_Llaika_ast_EnumFormat.prototype = $c_Llaika_ast_EnumFormat.prototype;
$c_Llaika_ast_EnumFormat.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_EnumFormat.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_EnumFormat.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_EnumFormat)) {
    var x$0$2 = $as_Llaika_ast_EnumFormat(x$0);
    var x = this.Llaika_ast_EnumFormat__f_enumType;
    var x$2 = $n(x$0$2).Llaika_ast_EnumFormat__f_enumType;
    if ((x === null)) {
      var $x_1 = (x$2 === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === x$2);
    }
    if ((($x_1 && (this.Llaika_ast_EnumFormat__f_prefix === $n(x$0$2).Llaika_ast_EnumFormat__f_prefix)) && (this.Llaika_ast_EnumFormat__f_suffix === $n(x$0$2).Llaika_ast_EnumFormat__f_suffix))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_EnumFormat.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_EnumFormat.prototype.productPrefix__T = (function() {
  return "EnumFormat";
});
$c_Llaika_ast_EnumFormat.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_EnumFormat__f_enumType;
      break;
    }
    case 1: {
      return this.Llaika_ast_EnumFormat__f_prefix;
      break;
    }
    case 2: {
      return this.Llaika_ast_EnumFormat__f_suffix;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_EnumFormat.prototype.toString__T = (function() {
  return (((((("EnumFormat(" + this.Llaika_ast_EnumFormat__f_enumType) + ",") + this.Llaika_ast_EnumFormat__f_prefix) + "N") + this.Llaika_ast_EnumFormat__f_suffix) + ")");
});
function $as_Llaika_ast_EnumFormat(obj) {
  return (((obj instanceof $c_Llaika_ast_EnumFormat) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.EnumFormat"));
}
function $isArrayOf_Llaika_ast_EnumFormat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_EnumFormat)));
}
function $asArrayOf_Llaika_ast_EnumFormat(obj, depth) {
  return (($isArrayOf_Llaika_ast_EnumFormat(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.EnumFormat;", depth));
}
var $d_Llaika_ast_EnumFormat = new $TypeData().initClass($c_Llaika_ast_EnumFormat, "laika.ast.EnumFormat", ({
  Llaika_ast_EnumFormat: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_Length(amount, unit) {
  this.Llaika_ast_Length__f_amount = 0.0;
  this.Llaika_ast_Length__f_unit = null;
  this.Llaika_ast_Length__f_amount = amount;
  this.Llaika_ast_Length__f_unit = unit;
}
$c_Llaika_ast_Length.prototype = new $h_O();
$c_Llaika_ast_Length.prototype.constructor = $c_Llaika_ast_Length;
/** @constructor */
function $h_Llaika_ast_Length() {
}
$h_Llaika_ast_Length.prototype = $c_Llaika_ast_Length.prototype;
$c_Llaika_ast_Length.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_Length.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Length");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Llaika_ast_Length__f_amount;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Llaika_ast_Length__f_unit;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
});
$c_Llaika_ast_Length.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_Length)) {
    var x$0$2 = $as_Llaika_ast_Length(x$0);
    if ((this.Llaika_ast_Length__f_amount === $n(x$0$2).Llaika_ast_Length__f_amount)) {
      var x = this.Llaika_ast_Length__f_unit;
      var x$2 = $n(x$0$2).Llaika_ast_Length__f_unit;
      if ((x === null)) {
        var $x_1 = (x$2 === null);
      } else {
        var this$1 = $n(x);
        var $x_1 = (this$1 === x$2);
      }
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_Length.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_Length.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_Length.prototype.productPrefix__T = (function() {
  return "Length";
});
$c_Llaika_ast_Length.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_Length__f_amount;
  }
  if ((n === 1)) {
    return this.Llaika_ast_Length__f_unit;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_Length.prototype.displayValue__T = (function() {
  var $x_1 = $m_sc_StringOps$();
  var this$1 = this.Llaika_ast_Length__f_amount;
  var x = ("" + this$1);
  return (("" + $n($x_1).stripSuffix$extension__T__T__T(x, ".0")) + $n(this.Llaika_ast_Length__f_unit).Llaika_ast_LengthUnit__f_displayValue);
});
function $as_Llaika_ast_Length(obj) {
  return (((obj instanceof $c_Llaika_ast_Length) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Length"));
}
function $isArrayOf_Llaika_ast_Length(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Length)));
}
function $asArrayOf_Llaika_ast_Length(obj, depth) {
  return (($isArrayOf_Llaika_ast_Length(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Length;", depth));
}
var $d_Llaika_ast_Length = new $TypeData().initClass($c_Llaika_ast_Length, "laika.ast.Length", ({
  Llaika_ast_Length: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $is_Llaika_ast_ListContainer(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_ListContainer)));
}
function $as_Llaika_ast_ListContainer(obj) {
  return (($is_Llaika_ast_ListContainer(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.ListContainer"));
}
function $isArrayOf_Llaika_ast_ListContainer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_ListContainer)));
}
function $asArrayOf_Llaika_ast_ListContainer(obj, depth) {
  return (($isArrayOf_Llaika_ast_ListContainer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.ListContainer;", depth));
}
/** @constructor */
function $c_Llaika_ast_NavigationLink(target, selfLink, targetFormats) {
  this.Llaika_ast_NavigationLink__f_target = null;
  this.Llaika_ast_NavigationLink__f_selfLink = false;
  this.Llaika_ast_NavigationLink__f_targetFormats = null;
  this.Llaika_ast_NavigationLink__f_target = target;
  this.Llaika_ast_NavigationLink__f_selfLink = selfLink;
  this.Llaika_ast_NavigationLink__f_targetFormats = targetFormats;
}
$c_Llaika_ast_NavigationLink.prototype = new $h_O();
$c_Llaika_ast_NavigationLink.prototype.constructor = $c_Llaika_ast_NavigationLink;
/** @constructor */
function $h_Llaika_ast_NavigationLink() {
}
$h_Llaika_ast_NavigationLink.prototype = $c_Llaika_ast_NavigationLink.prototype;
$c_Llaika_ast_NavigationLink.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_NavigationLink.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("NavigationLink");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Llaika_ast_NavigationLink__f_target;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Llaika_ast_NavigationLink__f_selfLink ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Llaika_ast_NavigationLink__f_targetFormats;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Llaika_ast_NavigationLink.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_NavigationLink)) {
    var x$0$2 = $as_Llaika_ast_NavigationLink(x$0);
    if ((this.Llaika_ast_NavigationLink__f_selfLink === $n(x$0$2).Llaika_ast_NavigationLink__f_selfLink)) {
      var x = this.Llaika_ast_NavigationLink__f_target;
      var x$2 = $n(x$0$2).Llaika_ast_NavigationLink__f_target;
      var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Llaika_ast_NavigationLink__f_targetFormats;
      var x$4 = $n(x$0$2).Llaika_ast_NavigationLink__f_targetFormats;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_NavigationLink.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_NavigationLink.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_NavigationLink.prototype.productPrefix__T = (function() {
  return "NavigationLink";
});
$c_Llaika_ast_NavigationLink.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_NavigationLink__f_target;
      break;
    }
    case 1: {
      return this.Llaika_ast_NavigationLink__f_selfLink;
      break;
    }
    case 2: {
      return this.Llaika_ast_NavigationLink__f_targetFormats;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Llaika_ast_NavigationLink(obj) {
  return (((obj instanceof $c_Llaika_ast_NavigationLink) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.NavigationLink"));
}
function $isArrayOf_Llaika_ast_NavigationLink(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_NavigationLink)));
}
function $asArrayOf_Llaika_ast_NavigationLink(obj, depth) {
  return (($isArrayOf_Llaika_ast_NavigationLink(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.NavigationLink;", depth));
}
var $d_Llaika_ast_NavigationLink = new $TypeData().initClass($c_Llaika_ast_NavigationLink, "laika.ast.NavigationLink", ({
  Llaika_ast_NavigationLink: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_Paragraph$() {
}
$c_Llaika_ast_Paragraph$.prototype = new $h_O();
$c_Llaika_ast_Paragraph$.prototype.constructor = $c_Llaika_ast_Paragraph$;
/** @constructor */
function $h_Llaika_ast_Paragraph$() {
}
$h_Llaika_ast_Paragraph$.prototype = $c_Llaika_ast_Paragraph$.prototype;
$c_Llaika_ast_Paragraph$.prototype.createSpanContainer__sci_Seq__O = (function(spans) {
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  return new $c_Llaika_ast_Paragraph(spans, options);
});
var $d_Llaika_ast_Paragraph$ = new $TypeData().initClass($c_Llaika_ast_Paragraph$, "laika.ast.Paragraph$", ({
  Llaika_ast_Paragraph$: 1,
  Llaika_ast_SpanContainerCompanion: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_ast_Paragraph$;
function $m_Llaika_ast_Paragraph$() {
  if ((!$n_Llaika_ast_Paragraph$)) {
    $n_Llaika_ast_Paragraph$ = new $c_Llaika_ast_Paragraph$();
  }
  return $n_Llaika_ast_Paragraph$;
}
function $is_Llaika_ast_PathReference(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_PathReference)));
}
function $as_Llaika_ast_PathReference(obj) {
  return (($is_Llaika_ast_PathReference(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.PathReference"));
}
function $isArrayOf_Llaika_ast_PathReference(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_PathReference)));
}
function $asArrayOf_Llaika_ast_PathReference(obj, depth) {
  return (($isArrayOf_Llaika_ast_PathReference(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.PathReference;", depth));
}
/** @constructor */
function $c_Llaika_ast_SpanSequence$() {
}
$c_Llaika_ast_SpanSequence$.prototype = new $h_O();
$c_Llaika_ast_SpanSequence$.prototype.constructor = $c_Llaika_ast_SpanSequence$;
/** @constructor */
function $h_Llaika_ast_SpanSequence$() {
}
$h_Llaika_ast_SpanSequence$.prototype = $c_Llaika_ast_SpanSequence$.prototype;
$c_Llaika_ast_SpanSequence$.prototype.createSpanContainer__sci_Seq__O = (function(spans) {
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  return new $c_Llaika_ast_SpanSequence(spans, options);
});
var $d_Llaika_ast_SpanSequence$ = new $TypeData().initClass($c_Llaika_ast_SpanSequence$, "laika.ast.SpanSequence$", ({
  Llaika_ast_SpanSequence$: 1,
  Llaika_ast_SpanContainerCompanion: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_ast_SpanSequence$;
function $m_Llaika_ast_SpanSequence$() {
  if ((!$n_Llaika_ast_SpanSequence$)) {
    $n_Llaika_ast_SpanSequence$ = new $c_Llaika_ast_SpanSequence$();
  }
  return $n_Llaika_ast_SpanSequence$;
}
function $as_Llaika_ast_StaticDocument(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.StaticDocument"));
}
function $isArrayOf_Llaika_ast_StaticDocument(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_StaticDocument)));
}
function $asArrayOf_Llaika_ast_StaticDocument(obj, depth) {
  return (($isArrayOf_Llaika_ast_StaticDocument(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.StaticDocument;", depth));
}
/** @constructor */
function $c_Llaika_ast_Strong$() {
}
$c_Llaika_ast_Strong$.prototype = new $h_O();
$c_Llaika_ast_Strong$.prototype.constructor = $c_Llaika_ast_Strong$;
/** @constructor */
function $h_Llaika_ast_Strong$() {
}
$h_Llaika_ast_Strong$.prototype = $c_Llaika_ast_Strong$.prototype;
$c_Llaika_ast_Strong$.prototype.createSpanContainer__sci_Seq__O = (function(spans) {
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  return new $c_Llaika_ast_Strong(spans, options);
});
var $d_Llaika_ast_Strong$ = new $TypeData().initClass($c_Llaika_ast_Strong$, "laika.ast.Strong$", ({
  Llaika_ast_Strong$: 1,
  Llaika_ast_SpanContainerCompanion: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_ast_Strong$;
function $m_Llaika_ast_Strong$() {
  if ((!$n_Llaika_ast_Strong$)) {
    $n_Llaika_ast_Strong$ = new $c_Llaika_ast_Strong$();
  }
  return $n_Llaika_ast_Strong$;
}
/** @constructor */
function $c_Llaika_ast_TemplateRoot$() {
  $n_Llaika_ast_TemplateRoot$ = this;
  var this$3 = $m_Llaika_ast_TemplateRoot$();
  var ref = $m_Llaika_internal_rewrite_ReferenceResolver$CursorKeys$().Llaika_internal_rewrite_ReferenceResolver$CursorKeys$__f_documentContent;
  var source = $m_Llaika_parse_SourceCursor$Generated$();
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  var span = new $c_Llaika_ast_TemplateContextReference(ref, true, source, options);
  var spans = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_TemplateSpan.getArrayOf().constr)([]));
  $as_Llaika_ast_TemplateRoot($f_Llaika_ast_TemplateSpanContainerCompanion__apply__Llaika_ast_TemplateSpan__sci_Seq__O(this$3, span, spans));
}
$c_Llaika_ast_TemplateRoot$.prototype = new $h_O();
$c_Llaika_ast_TemplateRoot$.prototype.constructor = $c_Llaika_ast_TemplateRoot$;
/** @constructor */
function $h_Llaika_ast_TemplateRoot$() {
}
$h_Llaika_ast_TemplateRoot$.prototype = $c_Llaika_ast_TemplateRoot$.prototype;
$c_Llaika_ast_TemplateRoot$.prototype.createSpanContainer__sci_Seq__O = (function(spans) {
  $m_Llaika_ast_TemplateRoot$();
  $m_Llaika_ast_TemplateRoot$();
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  return new $c_Llaika_ast_TemplateRoot(spans, options);
});
var $d_Llaika_ast_TemplateRoot$ = new $TypeData().initClass($c_Llaika_ast_TemplateRoot$, "laika.ast.TemplateRoot$", ({
  Llaika_ast_TemplateRoot$: 1,
  Llaika_ast_TemplateSpanContainerCompanion: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_ast_TemplateRoot$;
function $m_Llaika_ast_TemplateRoot$() {
  if ((!$n_Llaika_ast_TemplateRoot$)) {
    $n_Llaika_ast_TemplateRoot$ = new $c_Llaika_ast_TemplateRoot$();
  }
  return $n_Llaika_ast_TemplateRoot$;
}
/** @constructor */
function $c_Llaika_ast_TemplateSpanSequence$() {
}
$c_Llaika_ast_TemplateSpanSequence$.prototype = new $h_O();
$c_Llaika_ast_TemplateSpanSequence$.prototype.constructor = $c_Llaika_ast_TemplateSpanSequence$;
/** @constructor */
function $h_Llaika_ast_TemplateSpanSequence$() {
}
$h_Llaika_ast_TemplateSpanSequence$.prototype = $c_Llaika_ast_TemplateSpanSequence$.prototype;
$c_Llaika_ast_TemplateSpanSequence$.prototype.createSpanContainer__sci_Seq__O = (function(spans) {
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  return new $c_Llaika_ast_TemplateSpanSequence(spans, options);
});
var $d_Llaika_ast_TemplateSpanSequence$ = new $TypeData().initClass($c_Llaika_ast_TemplateSpanSequence$, "laika.ast.TemplateSpanSequence$", ({
  Llaika_ast_TemplateSpanSequence$: 1,
  Llaika_ast_TemplateSpanContainerCompanion: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_ast_TemplateSpanSequence$;
function $m_Llaika_ast_TemplateSpanSequence$() {
  if ((!$n_Llaika_ast_TemplateSpanSequence$)) {
    $n_Llaika_ast_TemplateSpanSequence$ = new $c_Llaika_ast_TemplateSpanSequence$();
  }
  return $n_Llaika_ast_TemplateSpanSequence$;
}
/** @constructor */
function $c_Llaika_ast_TextDocumentType() {
}
$c_Llaika_ast_TextDocumentType.prototype = new $h_Llaika_ast_DocumentType();
$c_Llaika_ast_TextDocumentType.prototype.constructor = $c_Llaika_ast_TextDocumentType;
/** @constructor */
function $h_Llaika_ast_TextDocumentType() {
}
$h_Llaika_ast_TextDocumentType.prototype = $c_Llaika_ast_TextDocumentType.prototype;
/** @constructor */
function $c_Llaika_ast_TreeNodeContext(localPath, localConfig, index, parent) {
  this.Llaika_ast_TreeNodeContext__f_localPath = null;
  this.Llaika_ast_TreeNodeContext__f_localConfig = null;
  this.Llaika_ast_TreeNodeContext__f_index = null;
  this.Llaika_ast_TreeNodeContext__f_parent = null;
  this.Llaika_ast_TreeNodeContext__f_path$lzy1 = null;
  this.Llaika_ast_TreeNodeContext__f_pathbitmap$1 = false;
  this.Llaika_ast_TreeNodeContext__f_config$lzy1 = null;
  this.Llaika_ast_TreeNodeContext__f_configbitmap$1 = false;
  this.Llaika_ast_TreeNodeContext__f_position$lzy1 = null;
  this.Llaika_ast_TreeNodeContext__f_positionbitmap$1 = false;
  this.Llaika_ast_TreeNodeContext__f_localPath = localPath;
  this.Llaika_ast_TreeNodeContext__f_localConfig = localConfig;
  this.Llaika_ast_TreeNodeContext__f_index = index;
  this.Llaika_ast_TreeNodeContext__f_parent = parent;
}
$c_Llaika_ast_TreeNodeContext.prototype = new $h_O();
$c_Llaika_ast_TreeNodeContext.prototype.constructor = $c_Llaika_ast_TreeNodeContext;
/** @constructor */
function $h_Llaika_ast_TreeNodeContext() {
}
$h_Llaika_ast_TreeNodeContext.prototype = $c_Llaika_ast_TreeNodeContext.prototype;
$c_Llaika_ast_TreeNodeContext.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_TreeNodeContext.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_TreeNodeContext.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_TreeNodeContext)) {
    var x$0$2 = $as_Llaika_ast_TreeNodeContext(x$0);
    var x = this.Llaika_ast_TreeNodeContext__f_localPath;
    var x$2 = $n(x$0$2).Llaika_ast_TreeNodeContext__f_localPath;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_TreeNodeContext__f_localConfig;
      var x$4 = $n(x$0$2).Llaika_ast_TreeNodeContext__f_localConfig;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.Llaika_ast_TreeNodeContext__f_index;
      var x$6 = $n(x$0$2).Llaika_ast_TreeNodeContext__f_index;
      if ((x$5 === null)) {
        var $x_2 = (x$6 === null);
      } else {
        var this$1 = $n(x$5);
        var $x_2 = (this$1 === x$6);
      }
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.Llaika_ast_TreeNodeContext__f_parent;
      var x$8 = $n(x$0$2).Llaika_ast_TreeNodeContext__f_parent;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_TreeNodeContext.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_TreeNodeContext.prototype.productArity__I = (function() {
  return 4;
});
$c_Llaika_ast_TreeNodeContext.prototype.productPrefix__T = (function() {
  return "TreeNodeContext";
});
$c_Llaika_ast_TreeNodeContext.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_TreeNodeContext__f_localPath;
      break;
    }
    case 1: {
      return this.Llaika_ast_TreeNodeContext__f_localConfig;
      break;
    }
    case 2: {
      return this.Llaika_ast_TreeNodeContext__f_index;
      break;
    }
    case 3: {
      return this.Llaika_ast_TreeNodeContext__f_parent;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_TreeNodeContext.prototype.path__Llaika_ast_Path = (function() {
  if ((!this.Llaika_ast_TreeNodeContext__f_pathbitmap$1)) {
    matchResult36: {
      var $x_1;
      var this$1 = $n(this.Llaika_ast_TreeNodeContext__f_parent);
      if (this$1.isEmpty__Z()) {
        var x122 = $m_s_None$();
      } else {
        var arg1 = this$1.get__O();
        var _$7 = $as_Llaika_ast_TreeNodeContext(arg1);
        var x122 = new $c_s_Some($n(_$7).path__Llaika_ast_Path());
      }
      if ((x122 instanceof $c_s_Some)) {
        var parentPath = $as_Llaika_ast_Path($n($as_s_Some(x122)).s_Some__f_value);
        var this$3 = $n(parentPath);
        var this$2 = $n(this.Llaika_ast_TreeNodeContext__f_localPath);
        var name = $as_T((this$2.isEmpty__Z() ? "" : this$2.get__O()));
        var $x_1 = $as_Llaika_ast_Path($f_Llaika_ast_GenericPath__$div__T__Llaika_ast_GenericPath(this$3, name));
        break matchResult36;
      }
      var x = $m_s_None$();
      if ((x === x122)) {
        var this$4 = $n(this.Llaika_ast_TreeNodeContext__f_localPath);
        if (this$4.isEmpty__Z()) {
          var $x_2 = $m_Llaika_ast_Path$Root$();
        } else {
          var arg1$1 = this$4.get__O();
          var _$8 = $as_T(arg1$1);
          var this$5 = $m_Llaika_ast_Path$Root$();
          var $x_2 = $as_Llaika_ast_Path($f_Llaika_ast_GenericPath__$div__T__Llaika_ast_GenericPath(this$5, _$8));
        }
        var $x_1 = $as_Llaika_ast_Path($x_2);
        break matchResult36;
      }
      throw new $c_s_MatchError(x122);
    }
    this.Llaika_ast_TreeNodeContext__f_path$lzy1 = $x_1;
    this.Llaika_ast_TreeNodeContext__f_pathbitmap$1 = true;
  }
  return this.Llaika_ast_TreeNodeContext__f_path$lzy1;
});
$c_Llaika_ast_TreeNodeContext.prototype.config__Llaika_api_config_Config = (function() {
  if ((!this.Llaika_ast_TreeNodeContext__f_configbitmap$1)) {
    var $x_2 = this.Llaika_ast_TreeNodeContext__f_localConfig;
    var this$1 = $n(this.Llaika_ast_TreeNodeContext__f_parent);
    if (this$1.isEmpty__Z()) {
      var $x_1 = $m_Llaika_api_config_Config$().Llaika_api_config_Config$__f_empty;
    } else {
      var arg1 = this$1.get__O();
      var _$9 = $as_Llaika_ast_TreeNodeContext(arg1);
      var $x_1 = $n(_$9).config__Llaika_api_config_Config();
    }
    this.Llaika_ast_TreeNodeContext__f_config$lzy1 = $n($x_2).withFallback__Llaika_api_config_Config__Llaika_api_config_Config($x_1);
    this.Llaika_ast_TreeNodeContext__f_configbitmap$1 = true;
  }
  return this.Llaika_ast_TreeNodeContext__f_config$lzy1;
});
$c_Llaika_ast_TreeNodeContext.prototype.position__Llaika_ast_TreePosition = (function() {
  if ((!this.Llaika_ast_TreeNodeContext__f_positionbitmap$1)) {
    matchResult37: {
      var $x_1;
      var x125 = this.Llaika_ast_TreeNodeContext__f_index;
      if (false) {
        var x$1 = $as_Llaika_ast_TreeNodeIndex$Value(x125);
        var x128 = $n(x$1)._1__I();
        var this$2 = $n(this.Llaika_ast_TreeNodeContext__f_parent);
        if (this$2.isEmpty__Z()) {
          var $x_2 = $m_Llaika_ast_TreePosition$().Llaika_ast_TreePosition$__f_root;
        } else {
          var arg1 = this$2.get__O();
          var _$10 = $as_Llaika_ast_TreeNodeContext(arg1);
          var $x_2 = $n(_$10).position__Llaika_ast_TreePosition();
        }
        var $x_1 = $n($x_2).forChild__I__Llaika_ast_TreePosition(x128);
        break matchResult37;
      }
      var x = $m_Llaika_ast_TreeNodeIndex$Inherit$();
      if ((x === x125)) {
        var this$3 = $n(this.Llaika_ast_TreeNodeContext__f_parent);
        if (this$3.isEmpty__Z()) {
          var $x_1 = $m_Llaika_ast_TreePosition$().Llaika_ast_TreePosition$__f_root;
          break matchResult37;
        } else {
          var arg1$1 = this$3.get__O();
          var _$11 = $as_Llaika_ast_TreeNodeContext(arg1$1);
          var $x_1 = $n(_$11).position__Llaika_ast_TreePosition();
          break matchResult37;
        }
      }
      var x$3 = $m_Llaika_ast_TreeNodeIndex$Unassigned$();
      if ((x$3 === x125)) {
        var $x_1 = $m_Llaika_ast_TreePosition$().Llaika_ast_TreePosition$__f_root;
        break matchResult37;
      }
      throw new $c_s_MatchError(x125);
    }
    this.Llaika_ast_TreeNodeContext__f_position$lzy1 = $x_1;
    this.Llaika_ast_TreeNodeContext__f_positionbitmap$1 = true;
  }
  return this.Llaika_ast_TreeNodeContext__f_position$lzy1;
});
function $as_Llaika_ast_TreeNodeContext(obj) {
  return (((obj instanceof $c_Llaika_ast_TreeNodeContext) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.TreeNodeContext"));
}
function $isArrayOf_Llaika_ast_TreeNodeContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_TreeNodeContext)));
}
function $asArrayOf_Llaika_ast_TreeNodeContext(obj, depth) {
  return (($isArrayOf_Llaika_ast_TreeNodeContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.TreeNodeContext;", depth));
}
var $d_Llaika_ast_TreeNodeContext = new $TypeData().initClass($c_Llaika_ast_TreeNodeContext, "laika.ast.TreeNodeContext", ({
  Llaika_ast_TreeNodeContext: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_UnresolvedDocument(document, config) {
  this.Llaika_ast_UnresolvedDocument__f_document = null;
  this.Llaika_ast_UnresolvedDocument__f_config = null;
  this.Llaika_ast_UnresolvedDocument__f_document = document;
  this.Llaika_ast_UnresolvedDocument__f_config = config;
}
$c_Llaika_ast_UnresolvedDocument.prototype = new $h_O();
$c_Llaika_ast_UnresolvedDocument.prototype.constructor = $c_Llaika_ast_UnresolvedDocument;
/** @constructor */
function $h_Llaika_ast_UnresolvedDocument() {
}
$h_Llaika_ast_UnresolvedDocument.prototype = $c_Llaika_ast_UnresolvedDocument.prototype;
$c_Llaika_ast_UnresolvedDocument.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_UnresolvedDocument.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_UnresolvedDocument.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_UnresolvedDocument)) {
    var x$0$2 = $as_Llaika_ast_UnresolvedDocument(x$0);
    var x = this.Llaika_ast_UnresolvedDocument__f_document;
    var x$2 = $n(x$0$2).Llaika_ast_UnresolvedDocument__f_document;
    if ((x === null)) {
      var $x_2 = (x$2 === null);
    } else {
      var this$1 = $n(x);
      var $x_2 = (this$1 === x$2);
    }
    if ($x_2) {
      var x$3 = this.Llaika_ast_UnresolvedDocument__f_config;
      var x$4 = $n(x$0$2).Llaika_ast_UnresolvedDocument__f_config;
      if ((x$3 === null)) {
        var $x_1 = (x$4 === null);
      } else {
        var this$2 = $n(x$3);
        var $x_1 = (this$2 === x$4);
      }
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_UnresolvedDocument.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_UnresolvedDocument.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_UnresolvedDocument.prototype.productPrefix__T = (function() {
  return "UnresolvedDocument";
});
$c_Llaika_ast_UnresolvedDocument.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_UnresolvedDocument__f_document;
  }
  if ((n === 1)) {
    return this.Llaika_ast_UnresolvedDocument__f_config;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_ast_UnresolvedDocument(obj) {
  return (((obj instanceof $c_Llaika_ast_UnresolvedDocument) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.UnresolvedDocument"));
}
function $isArrayOf_Llaika_ast_UnresolvedDocument(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_UnresolvedDocument)));
}
function $asArrayOf_Llaika_ast_UnresolvedDocument(obj, depth) {
  return (($isArrayOf_Llaika_ast_UnresolvedDocument(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.UnresolvedDocument;", depth));
}
var $d_Llaika_ast_UnresolvedDocument = new $TypeData().initClass($c_Llaika_ast_UnresolvedDocument, "laika.ast.UnresolvedDocument", ({
  Llaika_ast_UnresolvedDocument: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_html_HTMLAttribute(name, value, quotedWith) {
  this.Llaika_ast_html_HTMLAttribute__f_name = null;
  this.Llaika_ast_html_HTMLAttribute__f_value = null;
  this.Llaika_ast_html_HTMLAttribute__f_quotedWith = null;
  this.Llaika_ast_html_HTMLAttribute__f_name = name;
  this.Llaika_ast_html_HTMLAttribute__f_value = value;
  this.Llaika_ast_html_HTMLAttribute__f_quotedWith = quotedWith;
}
$c_Llaika_ast_html_HTMLAttribute.prototype = new $h_O();
$c_Llaika_ast_html_HTMLAttribute.prototype.constructor = $c_Llaika_ast_html_HTMLAttribute;
/** @constructor */
function $h_Llaika_ast_html_HTMLAttribute() {
}
$h_Llaika_ast_html_HTMLAttribute.prototype = $c_Llaika_ast_html_HTMLAttribute.prototype;
$c_Llaika_ast_html_HTMLAttribute.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_html_HTMLAttribute.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_html_HTMLAttribute.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_html_HTMLAttribute)) {
    var x$0$2 = $as_Llaika_ast_html_HTMLAttribute(x$0);
    if ((this.Llaika_ast_html_HTMLAttribute__f_name === $n(x$0$2).Llaika_ast_html_HTMLAttribute__f_name)) {
      var x = this.Llaika_ast_html_HTMLAttribute__f_value;
      var x$2 = $n(x$0$2).Llaika_ast_html_HTMLAttribute__f_value;
      var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Llaika_ast_html_HTMLAttribute__f_quotedWith;
      var x$4 = $n(x$0$2).Llaika_ast_html_HTMLAttribute__f_quotedWith;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_html_HTMLAttribute.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_html_HTMLAttribute.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_html_HTMLAttribute.prototype.productPrefix__T = (function() {
  return "HTMLAttribute";
});
$c_Llaika_ast_html_HTMLAttribute.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_html_HTMLAttribute__f_name;
      break;
    }
    case 1: {
      return this.Llaika_ast_html_HTMLAttribute__f_value;
      break;
    }
    case 2: {
      return this.Llaika_ast_html_HTMLAttribute__f_quotedWith;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Llaika_ast_html_HTMLAttribute(obj) {
  return (((obj instanceof $c_Llaika_ast_html_HTMLAttribute) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.html.HTMLAttribute"));
}
function $isArrayOf_Llaika_ast_html_HTMLAttribute(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_html_HTMLAttribute)));
}
function $asArrayOf_Llaika_ast_html_HTMLAttribute(obj, depth) {
  return (($isArrayOf_Llaika_ast_html_HTMLAttribute(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.html.HTMLAttribute;", depth));
}
var $d_Llaika_ast_html_HTMLAttribute = new $TypeData().initClass($c_Llaika_ast_html_HTMLAttribute, "laika.ast.html.HTMLAttribute", ({
  Llaika_ast_html_HTMLAttribute: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_styles_ParentSelector(selector, immediate) {
  this.Llaika_ast_styles_ParentSelector__f_selector = null;
  this.Llaika_ast_styles_ParentSelector__f_immediate = false;
  this.Llaika_ast_styles_ParentSelector__f_selector = selector;
  this.Llaika_ast_styles_ParentSelector__f_immediate = immediate;
}
$c_Llaika_ast_styles_ParentSelector.prototype = new $h_O();
$c_Llaika_ast_styles_ParentSelector.prototype.constructor = $c_Llaika_ast_styles_ParentSelector;
/** @constructor */
function $h_Llaika_ast_styles_ParentSelector() {
}
$h_Llaika_ast_styles_ParentSelector.prototype = $c_Llaika_ast_styles_ParentSelector.prototype;
$c_Llaika_ast_styles_ParentSelector.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_styles_ParentSelector.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("ParentSelector");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Llaika_ast_styles_ParentSelector__f_selector;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Llaika_ast_styles_ParentSelector__f_immediate ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
});
$c_Llaika_ast_styles_ParentSelector.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_styles_ParentSelector)) {
    var x$0$2 = $as_Llaika_ast_styles_ParentSelector(x$0);
    if ((this.Llaika_ast_styles_ParentSelector__f_immediate === $n(x$0$2).Llaika_ast_styles_ParentSelector__f_immediate)) {
      var x = this.Llaika_ast_styles_ParentSelector__f_selector;
      var x$2 = $n(x$0$2).Llaika_ast_styles_ParentSelector__f_selector;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_styles_ParentSelector.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_styles_ParentSelector.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_styles_ParentSelector.prototype.productPrefix__T = (function() {
  return "ParentSelector";
});
$c_Llaika_ast_styles_ParentSelector.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_styles_ParentSelector__f_selector;
  }
  if ((n === 1)) {
    return this.Llaika_ast_styles_ParentSelector__f_immediate;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_ast_styles_ParentSelector(obj) {
  return (((obj instanceof $c_Llaika_ast_styles_ParentSelector) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.styles.ParentSelector"));
}
function $isArrayOf_Llaika_ast_styles_ParentSelector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_styles_ParentSelector)));
}
function $asArrayOf_Llaika_ast_styles_ParentSelector(obj, depth) {
  return (($isArrayOf_Llaika_ast_styles_ParentSelector(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.styles.ParentSelector;", depth));
}
var $d_Llaika_ast_styles_ParentSelector = new $TypeData().initClass($c_Llaika_ast_styles_ParentSelector, "laika.ast.styles.ParentSelector", ({
  Llaika_ast_styles_ParentSelector: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_styles_StyleDeclaration(selector, styles) {
  this.Llaika_ast_styles_StyleDeclaration__f_selector = null;
  this.Llaika_ast_styles_StyleDeclaration__f_styles = null;
  this.Llaika_ast_styles_StyleDeclaration__f_selector = selector;
  this.Llaika_ast_styles_StyleDeclaration__f_styles = styles;
}
$c_Llaika_ast_styles_StyleDeclaration.prototype = new $h_O();
$c_Llaika_ast_styles_StyleDeclaration.prototype.constructor = $c_Llaika_ast_styles_StyleDeclaration;
/** @constructor */
function $h_Llaika_ast_styles_StyleDeclaration() {
}
$h_Llaika_ast_styles_StyleDeclaration.prototype = $c_Llaika_ast_styles_StyleDeclaration.prototype;
$c_Llaika_ast_styles_StyleDeclaration.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_styles_StyleDeclaration.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_styles_StyleDeclaration.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_styles_StyleDeclaration)) {
    var x$0$2 = $as_Llaika_ast_styles_StyleDeclaration(x$0);
    var x = this.Llaika_ast_styles_StyleDeclaration__f_selector;
    var x$2 = $n(x$0$2).Llaika_ast_styles_StyleDeclaration__f_selector;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_styles_StyleDeclaration__f_styles;
      var x$4 = $n(x$0$2).Llaika_ast_styles_StyleDeclaration__f_styles;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_styles_StyleDeclaration.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_styles_StyleDeclaration.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_styles_StyleDeclaration.prototype.productPrefix__T = (function() {
  return "StyleDeclaration";
});
$c_Llaika_ast_styles_StyleDeclaration.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_styles_StyleDeclaration__f_selector;
  }
  if ((n === 1)) {
    return this.Llaika_ast_styles_StyleDeclaration__f_styles;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_styles_StyleDeclaration.prototype.increaseOrderBy__I__Llaika_ast_styles_StyleDeclaration = (function(amount) {
  if ((amount === 0)) {
    return this;
  } else {
    var order$1 = (($n(this.Llaika_ast_styles_StyleDeclaration__f_selector).Llaika_ast_styles_StyleSelector__f_order + amount) | 0);
    var this$1 = $n(this.Llaika_ast_styles_StyleDeclaration__f_selector);
    var predicates$1 = this$1.Llaika_ast_styles_StyleSelector__f_predicates;
    var this$2 = $n(this.Llaika_ast_styles_StyleDeclaration__f_selector);
    var parent$1 = this$2.Llaika_ast_styles_StyleSelector__f_parent;
    $n(this.Llaika_ast_styles_StyleDeclaration__f_selector);
    var selector = new $c_Llaika_ast_styles_StyleSelector(predicates$1, parent$1, order$1);
    var styles = this.Llaika_ast_styles_StyleDeclaration__f_styles;
    return new $c_Llaika_ast_styles_StyleDeclaration(selector, styles);
  }
});
function $as_Llaika_ast_styles_StyleDeclaration(obj) {
  return (((obj instanceof $c_Llaika_ast_styles_StyleDeclaration) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.styles.StyleDeclaration"));
}
function $isArrayOf_Llaika_ast_styles_StyleDeclaration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_styles_StyleDeclaration)));
}
function $asArrayOf_Llaika_ast_styles_StyleDeclaration(obj, depth) {
  return (($isArrayOf_Llaika_ast_styles_StyleDeclaration(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.styles.StyleDeclaration;", depth));
}
var $d_Llaika_ast_styles_StyleDeclaration = new $TypeData().initClass($c_Llaika_ast_styles_StyleDeclaration, "laika.ast.styles.StyleDeclaration", ({
  Llaika_ast_styles_StyleDeclaration: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_styles_StyleDeclarationSet(paths, styles, precedence) {
  this.Llaika_ast_styles_StyleDeclarationSet__f_paths = null;
  this.Llaika_ast_styles_StyleDeclarationSet__f_styles = null;
  this.Llaika_ast_styles_StyleDeclarationSet__f_precedence = null;
  this.Llaika_ast_styles_StyleDeclarationSet__f_paths = paths;
  this.Llaika_ast_styles_StyleDeclarationSet__f_styles = styles;
  this.Llaika_ast_styles_StyleDeclarationSet__f_precedence = precedence;
}
$c_Llaika_ast_styles_StyleDeclarationSet.prototype = new $h_O();
$c_Llaika_ast_styles_StyleDeclarationSet.prototype.constructor = $c_Llaika_ast_styles_StyleDeclarationSet;
/** @constructor */
function $h_Llaika_ast_styles_StyleDeclarationSet() {
}
$h_Llaika_ast_styles_StyleDeclarationSet.prototype = $c_Llaika_ast_styles_StyleDeclarationSet.prototype;
$c_Llaika_ast_styles_StyleDeclarationSet.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_styles_StyleDeclarationSet.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_styles_StyleDeclarationSet.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_styles_StyleDeclarationSet)) {
    var x$0$2 = $as_Llaika_ast_styles_StyleDeclarationSet(x$0);
    var x = this.Llaika_ast_styles_StyleDeclarationSet__f_paths;
    var x$2 = $n(x$0$2).Llaika_ast_styles_StyleDeclarationSet__f_paths;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_styles_StyleDeclarationSet__f_styles;
      var x$4 = $n(x$0$2).Llaika_ast_styles_StyleDeclarationSet__f_styles;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llaika_ast_styles_StyleDeclarationSet__f_precedence;
      var x$6 = $n(x$0$2).Llaika_ast_styles_StyleDeclarationSet__f_precedence;
      if ((x$5 === null)) {
        var $x_1 = (x$6 === null);
      } else {
        var this$1 = $n(x$5);
        var $x_1 = (this$1 === x$6);
      }
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_styles_StyleDeclarationSet.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_styles_StyleDeclarationSet.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_styles_StyleDeclarationSet.prototype.productPrefix__T = (function() {
  return "StyleDeclarationSet";
});
$c_Llaika_ast_styles_StyleDeclarationSet.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_styles_StyleDeclarationSet__f_paths;
      break;
    }
    case 1: {
      return this.Llaika_ast_styles_StyleDeclarationSet__f_styles;
      break;
    }
    case 2: {
      return this.Llaika_ast_styles_StyleDeclarationSet__f_precedence;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Llaika_ast_styles_StyleDeclarationSet(obj) {
  return (((obj instanceof $c_Llaika_ast_styles_StyleDeclarationSet) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.styles.StyleDeclarationSet"));
}
function $isArrayOf_Llaika_ast_styles_StyleDeclarationSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_styles_StyleDeclarationSet)));
}
function $asArrayOf_Llaika_ast_styles_StyleDeclarationSet(obj, depth) {
  return (($isArrayOf_Llaika_ast_styles_StyleDeclarationSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.styles.StyleDeclarationSet;", depth));
}
var $d_Llaika_ast_styles_StyleDeclarationSet = new $TypeData().initClass($c_Llaika_ast_styles_StyleDeclarationSet, "laika.ast.styles.StyleDeclarationSet", ({
  Llaika_ast_styles_StyleDeclarationSet: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_styles_StyleDeclarationSet$() {
  this.Llaika_ast_styles_StyleDeclarationSet$__f_empty = null;
  $n_Llaika_ast_styles_StyleDeclarationSet$ = this;
  var this$1 = $m_sci_Set$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Path.getArrayOf().constr)([$m_Llaika_ast_Path$Root$()]));
  this.Llaika_ast_styles_StyleDeclarationSet$__f_empty = new $c_Llaika_ast_styles_StyleDeclarationSet(this$1.from__sc_IterableOnce__sci_Set(elems), $m_sci_Set$EmptySet$(), ($m_Llaika_ast_styles_StyleDeclarationSet$(), $m_Llaika_api_bundle_Precedence$High$()));
}
$c_Llaika_ast_styles_StyleDeclarationSet$.prototype = new $h_O();
$c_Llaika_ast_styles_StyleDeclarationSet$.prototype.constructor = $c_Llaika_ast_styles_StyleDeclarationSet$;
/** @constructor */
function $h_Llaika_ast_styles_StyleDeclarationSet$() {
}
$h_Llaika_ast_styles_StyleDeclarationSet$.prototype = $c_Llaika_ast_styles_StyleDeclarationSet$.prototype;
$c_Llaika_ast_styles_StyleDeclarationSet$.prototype.toString__T = (function() {
  return "<function3>";
});
$c_Llaika_ast_styles_StyleDeclarationSet$.prototype.apply__O__O__O__O = (function(v1, v2, v3) {
  var paths = $as_sci_Set(v1);
  var styles = $as_sci_Set(v2);
  var precedence = $as_Llaika_api_bundle_Precedence(v3);
  return new $c_Llaika_ast_styles_StyleDeclarationSet(paths, styles, precedence);
});
var $d_Llaika_ast_styles_StyleDeclarationSet$ = new $TypeData().initClass($c_Llaika_ast_styles_StyleDeclarationSet$, "laika.ast.styles.StyleDeclarationSet$", ({
  Llaika_ast_styles_StyleDeclarationSet$: 1,
  F3: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_ast_styles_StyleDeclarationSet$;
function $m_Llaika_ast_styles_StyleDeclarationSet$() {
  if ((!$n_Llaika_ast_styles_StyleDeclarationSet$)) {
    $n_Llaika_ast_styles_StyleDeclarationSet$ = new $c_Llaika_ast_styles_StyleDeclarationSet$();
  }
  return $n_Llaika_ast_styles_StyleDeclarationSet$;
}
/** @constructor */
function $c_Llaika_ast_styles_StyleSelector(predicates, parent, order) {
  this.Llaika_ast_styles_StyleSelector__f_predicates = null;
  this.Llaika_ast_styles_StyleSelector__f_parent = null;
  this.Llaika_ast_styles_StyleSelector__f_order = 0;
  this.Llaika_ast_styles_StyleSelector__f_predicates = predicates;
  this.Llaika_ast_styles_StyleSelector__f_parent = parent;
  this.Llaika_ast_styles_StyleSelector__f_order = order;
}
$c_Llaika_ast_styles_StyleSelector.prototype = new $h_O();
$c_Llaika_ast_styles_StyleSelector.prototype.constructor = $c_Llaika_ast_styles_StyleSelector;
/** @constructor */
function $h_Llaika_ast_styles_StyleSelector() {
}
$h_Llaika_ast_styles_StyleSelector.prototype = $c_Llaika_ast_styles_StyleSelector.prototype;
$c_Llaika_ast_styles_StyleSelector.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_styles_StyleSelector.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("StyleSelector");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Llaika_ast_styles_StyleSelector__f_predicates;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Llaika_ast_styles_StyleSelector__f_parent;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Llaika_ast_styles_StyleSelector__f_order;
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Llaika_ast_styles_StyleSelector.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_styles_StyleSelector)) {
    var x$0$2 = $as_Llaika_ast_styles_StyleSelector(x$0);
    if ((this.Llaika_ast_styles_StyleSelector__f_order === $n(x$0$2).Llaika_ast_styles_StyleSelector__f_order)) {
      var x = this.Llaika_ast_styles_StyleSelector__f_predicates;
      var x$2 = $n(x$0$2).Llaika_ast_styles_StyleSelector__f_predicates;
      var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Llaika_ast_styles_StyleSelector__f_parent;
      var x$4 = $n(x$0$2).Llaika_ast_styles_StyleSelector__f_parent;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_styles_StyleSelector.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_styles_StyleSelector.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_styles_StyleSelector.prototype.productPrefix__T = (function() {
  return "StyleSelector";
});
$c_Llaika_ast_styles_StyleSelector.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_styles_StyleSelector__f_predicates;
      break;
    }
    case 1: {
      return this.Llaika_ast_styles_StyleSelector__f_parent;
      break;
    }
    case 2: {
      return this.Llaika_ast_styles_StyleSelector__f_order;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Llaika_ast_styles_StyleSelector(obj) {
  return (((obj instanceof $c_Llaika_ast_styles_StyleSelector) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.styles.StyleSelector"));
}
function $isArrayOf_Llaika_ast_styles_StyleSelector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_styles_StyleSelector)));
}
function $asArrayOf_Llaika_ast_styles_StyleSelector(obj, depth) {
  return (($isArrayOf_Llaika_ast_styles_StyleSelector(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.styles.StyleSelector;", depth));
}
var $d_Llaika_ast_styles_StyleSelector = new $TypeData().initClass($c_Llaika_ast_styles_StyleSelector, "laika.ast.styles.StyleSelector", ({
  Llaika_ast_styles_StyleSelector: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_directive_ControlFlowDirectives$Empty$1(outer, spans) {
  this.Llaika_internal_directive_ControlFlowDirectives$Empty$1__f_spans = null;
  this.Llaika_internal_directive_ControlFlowDirectives$Empty$1__f_spans = spans;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_internal_directive_ControlFlowDirectives$Empty$1.prototype = new $h_O();
$c_Llaika_internal_directive_ControlFlowDirectives$Empty$1.prototype.constructor = $c_Llaika_internal_directive_ControlFlowDirectives$Empty$1;
/** @constructor */
function $h_Llaika_internal_directive_ControlFlowDirectives$Empty$1() {
}
$h_Llaika_internal_directive_ControlFlowDirectives$Empty$1.prototype = $c_Llaika_internal_directive_ControlFlowDirectives$Empty$1.prototype;
$c_Llaika_internal_directive_ControlFlowDirectives$Empty$1.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_directive_ControlFlowDirectives$Empty$1.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_directive_ControlFlowDirectives$Empty$1.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_directive_ControlFlowDirectives$Empty$1)) {
    var x$0$2 = $as_Llaika_internal_directive_ControlFlowDirectives$Empty$1(x$0);
    var x = this.Llaika_internal_directive_ControlFlowDirectives$Empty$1__f_spans;
    var x$2 = $n(x$0$2).Llaika_internal_directive_ControlFlowDirectives$Empty$1__f_spans;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_directive_ControlFlowDirectives$Empty$1.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_directive_ControlFlowDirectives$Empty$1.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_internal_directive_ControlFlowDirectives$Empty$1.prototype.productPrefix__T = (function() {
  return "Empty";
});
$c_Llaika_internal_directive_ControlFlowDirectives$Empty$1.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_directive_ControlFlowDirectives$Empty$1__f_spans;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_internal_directive_ControlFlowDirectives$Empty$1(obj) {
  return (((obj instanceof $c_Llaika_internal_directive_ControlFlowDirectives$Empty$1) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.directive.ControlFlowDirectives$Empty$1"));
}
function $isArrayOf_Llaika_internal_directive_ControlFlowDirectives$Empty$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_directive_ControlFlowDirectives$Empty$1)));
}
function $asArrayOf_Llaika_internal_directive_ControlFlowDirectives$Empty$1(obj, depth) {
  return (($isArrayOf_Llaika_internal_directive_ControlFlowDirectives$Empty$1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.directive.ControlFlowDirectives$Empty$1;", depth));
}
var $d_Llaika_internal_directive_ControlFlowDirectives$Empty$1 = new $TypeData().initClass($c_Llaika_internal_directive_ControlFlowDirectives$Empty$1, "laika.internal.directive.ControlFlowDirectives$Empty$1", ({
  Llaika_internal_directive_ControlFlowDirectives$Empty$1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $is_Llaika_internal_directive_ControlFlowDirectives$IfSeparator$1(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_internal_directive_ControlFlowDirectives$IfSeparator$1)));
}
function $as_Llaika_internal_directive_ControlFlowDirectives$IfSeparator$1(obj) {
  return (($is_Llaika_internal_directive_ControlFlowDirectives$IfSeparator$1(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.directive.ControlFlowDirectives$IfSeparator$1"));
}
function $isArrayOf_Llaika_internal_directive_ControlFlowDirectives$IfSeparator$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_directive_ControlFlowDirectives$IfSeparator$1)));
}
function $asArrayOf_Llaika_internal_directive_ControlFlowDirectives$IfSeparator$1(obj, depth) {
  return (($isArrayOf_Llaika_internal_directive_ControlFlowDirectives$IfSeparator$1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.directive.ControlFlowDirectives$IfSeparator$1;", depth));
}
/** @constructor */
function $c_Llaika_internal_link_LinkSource(span, path) {
  this.Llaika_internal_link_LinkSource__f_span = null;
  this.Llaika_internal_link_LinkSource__f_path = null;
  this.Llaika_internal_link_LinkSource__f_span = span;
  this.Llaika_internal_link_LinkSource__f_path = path;
}
$c_Llaika_internal_link_LinkSource.prototype = new $h_O();
$c_Llaika_internal_link_LinkSource.prototype.constructor = $c_Llaika_internal_link_LinkSource;
/** @constructor */
function $h_Llaika_internal_link_LinkSource() {
}
$h_Llaika_internal_link_LinkSource.prototype = $c_Llaika_internal_link_LinkSource.prototype;
$c_Llaika_internal_link_LinkSource.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_link_LinkSource.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_link_LinkSource.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_link_LinkSource)) {
    var x$0$2 = $as_Llaika_internal_link_LinkSource(x$0);
    var x = this.Llaika_internal_link_LinkSource__f_span;
    var x$2 = $n(x$0$2).Llaika_internal_link_LinkSource__f_span;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_internal_link_LinkSource__f_path;
      var x$4 = $n(x$0$2).Llaika_internal_link_LinkSource__f_path;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_link_LinkSource.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_link_LinkSource.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_internal_link_LinkSource.prototype.productPrefix__T = (function() {
  return "LinkSource";
});
$c_Llaika_internal_link_LinkSource.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return $as_Ljava_io_Serializable(this.Llaika_internal_link_LinkSource__f_span);
  }
  if ((n === 1)) {
    return this.Llaika_internal_link_LinkSource__f_path;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_internal_link_LinkSource(obj) {
  return (((obj instanceof $c_Llaika_internal_link_LinkSource) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.link.LinkSource"));
}
function $isArrayOf_Llaika_internal_link_LinkSource(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_link_LinkSource)));
}
function $asArrayOf_Llaika_internal_link_LinkSource(obj, depth) {
  return (($isArrayOf_Llaika_internal_link_LinkSource(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.link.LinkSource;", depth));
}
var $d_Llaika_internal_link_LinkSource = new $TypeData().initClass($c_Llaika_internal_link_LinkSource, "laika.internal.link.LinkSource", ({
  Llaika_internal_link_LinkSource: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_markdown_InlineParsers$Resource(text, target, suffix) {
  this.Llaika_internal_markdown_InlineParsers$Resource__f_text = null;
  this.Llaika_internal_markdown_InlineParsers$Resource__f_target = null;
  this.Llaika_internal_markdown_InlineParsers$Resource__f_suffix = null;
  this.Llaika_internal_markdown_InlineParsers$Resource__f_text = text;
  this.Llaika_internal_markdown_InlineParsers$Resource__f_target = target;
  this.Llaika_internal_markdown_InlineParsers$Resource__f_suffix = suffix;
}
$c_Llaika_internal_markdown_InlineParsers$Resource.prototype = new $h_O();
$c_Llaika_internal_markdown_InlineParsers$Resource.prototype.constructor = $c_Llaika_internal_markdown_InlineParsers$Resource;
/** @constructor */
function $h_Llaika_internal_markdown_InlineParsers$Resource() {
}
$h_Llaika_internal_markdown_InlineParsers$Resource.prototype = $c_Llaika_internal_markdown_InlineParsers$Resource.prototype;
$c_Llaika_internal_markdown_InlineParsers$Resource.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_markdown_InlineParsers$Resource.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_markdown_InlineParsers$Resource.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_markdown_InlineParsers$Resource)) {
    var x$0$2 = $as_Llaika_internal_markdown_InlineParsers$Resource(x$0);
    var x = this.Llaika_internal_markdown_InlineParsers$Resource__f_text;
    var x$2 = $n(x$0$2).Llaika_internal_markdown_InlineParsers$Resource__f_text;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_internal_markdown_InlineParsers$Resource__f_target;
      var x$4 = $n(x$0$2).Llaika_internal_markdown_InlineParsers$Resource__f_target;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if (($x_1 && (this.Llaika_internal_markdown_InlineParsers$Resource__f_suffix === $n(x$0$2).Llaika_internal_markdown_InlineParsers$Resource__f_suffix))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_markdown_InlineParsers$Resource.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_markdown_InlineParsers$Resource.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_internal_markdown_InlineParsers$Resource.prototype.productPrefix__T = (function() {
  return "Resource";
});
$c_Llaika_internal_markdown_InlineParsers$Resource.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_internal_markdown_InlineParsers$Resource__f_text;
      break;
    }
    case 1: {
      return this.Llaika_internal_markdown_InlineParsers$Resource__f_target;
      break;
    }
    case 2: {
      return this.Llaika_internal_markdown_InlineParsers$Resource__f_suffix;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Llaika_internal_markdown_InlineParsers$Resource(obj) {
  return (((obj instanceof $c_Llaika_internal_markdown_InlineParsers$Resource) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.markdown.InlineParsers$Resource"));
}
function $isArrayOf_Llaika_internal_markdown_InlineParsers$Resource(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_markdown_InlineParsers$Resource)));
}
function $asArrayOf_Llaika_internal_markdown_InlineParsers$Resource(obj, depth) {
  return (($isArrayOf_Llaika_internal_markdown_InlineParsers$Resource(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.markdown.InlineParsers$Resource;", depth));
}
var $d_Llaika_internal_markdown_InlineParsers$Resource = new $TypeData().initClass($c_Llaika_internal_markdown_InlineParsers$Resource, "laika.internal.markdown.InlineParsers$Resource", ({
  Llaika_internal_markdown_InlineParsers$Resource: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_markdown_github_Tables$Header$1(row, columnOptions) {
  this.Llaika_internal_markdown_github_Tables$Header$1__f_row = null;
  this.Llaika_internal_markdown_github_Tables$Header$1__f_columnOptions = null;
  this.Llaika_internal_markdown_github_Tables$Header$1__f_row = row;
  this.Llaika_internal_markdown_github_Tables$Header$1__f_columnOptions = columnOptions;
}
$c_Llaika_internal_markdown_github_Tables$Header$1.prototype = new $h_O();
$c_Llaika_internal_markdown_github_Tables$Header$1.prototype.constructor = $c_Llaika_internal_markdown_github_Tables$Header$1;
/** @constructor */
function $h_Llaika_internal_markdown_github_Tables$Header$1() {
}
$h_Llaika_internal_markdown_github_Tables$Header$1.prototype = $c_Llaika_internal_markdown_github_Tables$Header$1.prototype;
$c_Llaika_internal_markdown_github_Tables$Header$1.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_markdown_github_Tables$Header$1.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_markdown_github_Tables$Header$1.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_markdown_github_Tables$Header$1)) {
    var x$0$2 = $as_Llaika_internal_markdown_github_Tables$Header$1(x$0);
    var x = this.Llaika_internal_markdown_github_Tables$Header$1__f_row;
    var x$2 = $n(x$0$2).Llaika_internal_markdown_github_Tables$Header$1__f_row;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_internal_markdown_github_Tables$Header$1__f_columnOptions;
      var x$4 = $n(x$0$2).Llaika_internal_markdown_github_Tables$Header$1__f_columnOptions;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_markdown_github_Tables$Header$1.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_markdown_github_Tables$Header$1.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_internal_markdown_github_Tables$Header$1.prototype.productPrefix__T = (function() {
  return "Header";
});
$c_Llaika_internal_markdown_github_Tables$Header$1.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_markdown_github_Tables$Header$1__f_row;
  }
  if ((n === 1)) {
    return this.Llaika_internal_markdown_github_Tables$Header$1__f_columnOptions;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_internal_markdown_github_Tables$Header$1(obj) {
  return (((obj instanceof $c_Llaika_internal_markdown_github_Tables$Header$1) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.markdown.github.Tables$Header$1"));
}
function $isArrayOf_Llaika_internal_markdown_github_Tables$Header$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_markdown_github_Tables$Header$1)));
}
function $asArrayOf_Llaika_internal_markdown_github_Tables$Header$1(obj, depth) {
  return (($isArrayOf_Llaika_internal_markdown_github_Tables$Header$1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.markdown.github.Tables$Header$1;", depth));
}
var $d_Llaika_internal_markdown_github_Tables$Header$1 = new $TypeData().initClass($c_Llaika_internal_markdown_github_Tables$Header$1, "laika.internal.markdown.github.Tables$Header$1", ({
  Llaika_internal_markdown_github_Tables$Header$1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_css_CSSParsers$Style(name, value) {
  this.Llaika_internal_parse_css_CSSParsers$Style__f_name = null;
  this.Llaika_internal_parse_css_CSSParsers$Style__f_value = null;
  this.Llaika_internal_parse_css_CSSParsers$Style__f_name = name;
  this.Llaika_internal_parse_css_CSSParsers$Style__f_value = value;
}
$c_Llaika_internal_parse_css_CSSParsers$Style.prototype = new $h_O();
$c_Llaika_internal_parse_css_CSSParsers$Style.prototype.constructor = $c_Llaika_internal_parse_css_CSSParsers$Style;
/** @constructor */
function $h_Llaika_internal_parse_css_CSSParsers$Style() {
}
$h_Llaika_internal_parse_css_CSSParsers$Style.prototype = $c_Llaika_internal_parse_css_CSSParsers$Style.prototype;
$c_Llaika_internal_parse_css_CSSParsers$Style.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_parse_css_CSSParsers$Style.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_parse_css_CSSParsers$Style.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_parse_css_CSSParsers$Style)) {
    var x$0$2 = $as_Llaika_internal_parse_css_CSSParsers$Style(x$0);
    return (((this.Llaika_internal_parse_css_CSSParsers$Style__f_name === $n(x$0$2).Llaika_internal_parse_css_CSSParsers$Style__f_name) && (this.Llaika_internal_parse_css_CSSParsers$Style__f_value === $n(x$0$2).Llaika_internal_parse_css_CSSParsers$Style__f_value)) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Llaika_internal_parse_css_CSSParsers$Style.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_parse_css_CSSParsers$Style.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_internal_parse_css_CSSParsers$Style.prototype.productPrefix__T = (function() {
  return "Style";
});
$c_Llaika_internal_parse_css_CSSParsers$Style.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_parse_css_CSSParsers$Style__f_name;
  }
  if ((n === 1)) {
    return this.Llaika_internal_parse_css_CSSParsers$Style__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_internal_parse_css_CSSParsers$Style(obj) {
  return (((obj instanceof $c_Llaika_internal_parse_css_CSSParsers$Style) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.css.CSSParsers$Style"));
}
function $isArrayOf_Llaika_internal_parse_css_CSSParsers$Style(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_css_CSSParsers$Style)));
}
function $asArrayOf_Llaika_internal_parse_css_CSSParsers$Style(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_css_CSSParsers$Style(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.css.CSSParsers$Style;", depth));
}
var $d_Llaika_internal_parse_css_CSSParsers$Style = new $TypeData().initClass($c_Llaika_internal_parse_css_CSSParsers$Style, "laika.internal.parse.css.CSSParsers$Style", ({
  Llaika_internal_parse_css_CSSParsers$Style: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec(name, fence) {
  this.Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec__f_name = null;
  this.Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec__f_fence = null;
  this.Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec__f_name = name;
  this.Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec__f_fence = fence;
}
$c_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec.prototype = new $h_O();
$c_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec.prototype.constructor = $c_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec;
/** @constructor */
function $h_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec() {
}
$h_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec.prototype = $c_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec.prototype;
$c_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec)) {
    var x$0$2 = $as_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec(x$0);
    return (((this.Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec__f_name === $n(x$0$2).Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec__f_name) && (this.Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec__f_fence === $n(x$0$2).Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec__f_fence)) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec.prototype.productPrefix__T = (function() {
  return "DirectiveSpec";
});
$c_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec__f_name;
  }
  if ((n === 1)) {
    return this.Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec__f_fence;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec(obj) {
  return (((obj instanceof $c_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.directive.DirectiveParsers$DirectiveSpec"));
}
function $isArrayOf_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec)));
}
function $asArrayOf_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.directive.DirectiveParsers$DirectiveSpec;", depth));
}
var $d_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec = new $TypeData().initClass($c_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec, "laika.internal.parse.directive.DirectiveParsers$DirectiveSpec", ({
  Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective(name, attributes, body) {
  this.Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_name = null;
  this.Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_attributes = null;
  this.Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_body = null;
  this.Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_name = name;
  this.Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_attributes = attributes;
  this.Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_body = body;
}
$c_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective.prototype = new $h_O();
$c_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective.prototype.constructor = $c_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective;
/** @constructor */
function $h_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective() {
}
$h_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective.prototype = $c_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective.prototype;
$c_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective)) {
    var x$0$2 = $as_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective(x$0);
    if ((this.Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_name === $n(x$0$2).Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_name)) {
      var x = this.Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_attributes;
      var x$2 = $n(x$0$2).Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_attributes;
      var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_body;
      var x$4 = $n(x$0$2).Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_body;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective.prototype.productPrefix__T = (function() {
  return "ParsedDirective";
});
$c_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_name;
      break;
    }
    case 1: {
      return this.Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_attributes;
      break;
    }
    case 2: {
      return this.Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_body;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective(obj) {
  return (((obj instanceof $c_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.directive.DirectiveParsers$ParsedDirective"));
}
function $isArrayOf_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective)));
}
function $asArrayOf_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.directive.DirectiveParsers$ParsedDirective;", depth));
}
var $d_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective = new $TypeData().initClass($c_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective, "laika.internal.parse.directive.DirectiveParsers$ParsedDirective", ({
  Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_hocon_BuilderField(key, value) {
  this.Llaika_internal_parse_hocon_BuilderField__f_key = null;
  this.Llaika_internal_parse_hocon_BuilderField__f_value = null;
  this.Llaika_internal_parse_hocon_BuilderField__f_key = key;
  this.Llaika_internal_parse_hocon_BuilderField__f_value = value;
}
$c_Llaika_internal_parse_hocon_BuilderField.prototype = new $h_O();
$c_Llaika_internal_parse_hocon_BuilderField.prototype.constructor = $c_Llaika_internal_parse_hocon_BuilderField;
/** @constructor */
function $h_Llaika_internal_parse_hocon_BuilderField() {
}
$h_Llaika_internal_parse_hocon_BuilderField.prototype = $c_Llaika_internal_parse_hocon_BuilderField.prototype;
$c_Llaika_internal_parse_hocon_BuilderField.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_parse_hocon_BuilderField.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_parse_hocon_BuilderField.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_parse_hocon_BuilderField)) {
    var x$0$2 = $as_Llaika_internal_parse_hocon_BuilderField(x$0);
    var x = this.Llaika_internal_parse_hocon_BuilderField__f_key;
    var x$2 = $n(x$0$2).Llaika_internal_parse_hocon_BuilderField__f_key;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_internal_parse_hocon_BuilderField__f_value;
      var x$4 = $n(x$0$2).Llaika_internal_parse_hocon_BuilderField__f_value;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_parse_hocon_BuilderField.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_parse_hocon_BuilderField.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_internal_parse_hocon_BuilderField.prototype.productPrefix__T = (function() {
  return "BuilderField";
});
$c_Llaika_internal_parse_hocon_BuilderField.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_parse_hocon_BuilderField__f_key;
  }
  if ((n === 1)) {
    return this.Llaika_internal_parse_hocon_BuilderField__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_internal_parse_hocon_BuilderField.prototype.validKey__Llaika_api_config_Key = (function() {
  var this$1 = $n(this.Llaika_internal_parse_hocon_BuilderField__f_key);
  if ((this$1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$1);
    var b = $n(x2).s_util_Right__f_value;
    var $x_1 = b;
  } else {
    var $x_1 = $m_Llaika_api_config_Key$().Llaika_api_config_Key$__f_root;
  }
  return $as_Llaika_api_config_Key($x_1);
});
function $as_Llaika_internal_parse_hocon_BuilderField(obj) {
  return (((obj instanceof $c_Llaika_internal_parse_hocon_BuilderField) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.hocon.BuilderField"));
}
function $isArrayOf_Llaika_internal_parse_hocon_BuilderField(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_hocon_BuilderField)));
}
function $asArrayOf_Llaika_internal_parse_hocon_BuilderField(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_hocon_BuilderField(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.hocon.BuilderField;", depth));
}
var $d_Llaika_internal_parse_hocon_BuilderField = new $TypeData().initClass($c_Llaika_internal_parse_hocon_BuilderField, "laika.internal.parse.hocon.BuilderField", ({
  Llaika_internal_parse_hocon_BuilderField: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_hocon_ConcatPart(whitespace, value) {
  this.Llaika_internal_parse_hocon_ConcatPart__f_whitespace = null;
  this.Llaika_internal_parse_hocon_ConcatPart__f_value = null;
  this.Llaika_internal_parse_hocon_ConcatPart__f_whitespace = whitespace;
  this.Llaika_internal_parse_hocon_ConcatPart__f_value = value;
}
$c_Llaika_internal_parse_hocon_ConcatPart.prototype = new $h_O();
$c_Llaika_internal_parse_hocon_ConcatPart.prototype.constructor = $c_Llaika_internal_parse_hocon_ConcatPart;
/** @constructor */
function $h_Llaika_internal_parse_hocon_ConcatPart() {
}
$h_Llaika_internal_parse_hocon_ConcatPart.prototype = $c_Llaika_internal_parse_hocon_ConcatPart.prototype;
$c_Llaika_internal_parse_hocon_ConcatPart.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_parse_hocon_ConcatPart.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_parse_hocon_ConcatPart.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_parse_hocon_ConcatPart)) {
    var x$0$2 = $as_Llaika_internal_parse_hocon_ConcatPart(x$0);
    if ((this.Llaika_internal_parse_hocon_ConcatPart__f_whitespace === $n(x$0$2).Llaika_internal_parse_hocon_ConcatPart__f_whitespace)) {
      var x = this.Llaika_internal_parse_hocon_ConcatPart__f_value;
      var x$2 = $n(x$0$2).Llaika_internal_parse_hocon_ConcatPart__f_value;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_parse_hocon_ConcatPart.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_parse_hocon_ConcatPart.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_internal_parse_hocon_ConcatPart.prototype.productPrefix__T = (function() {
  return "ConcatPart";
});
$c_Llaika_internal_parse_hocon_ConcatPart.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_parse_hocon_ConcatPart__f_whitespace;
  }
  if ((n === 1)) {
    return this.Llaika_internal_parse_hocon_ConcatPart__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_internal_parse_hocon_ConcatPart(obj) {
  return (((obj instanceof $c_Llaika_internal_parse_hocon_ConcatPart) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.hocon.ConcatPart"));
}
function $isArrayOf_Llaika_internal_parse_hocon_ConcatPart(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_hocon_ConcatPart)));
}
function $asArrayOf_Llaika_internal_parse_hocon_ConcatPart(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_hocon_ConcatPart(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.hocon.ConcatPart;", depth));
}
var $d_Llaika_internal_parse_hocon_ConcatPart = new $TypeData().initClass($c_Llaika_internal_parse_hocon_ConcatPart, "laika.internal.parse.hocon.ConcatPart", ({
  Llaika_internal_parse_hocon_ConcatPart: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $is_Llaika_internal_parse_hocon_ConfigBuilderValue(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_internal_parse_hocon_ConfigBuilderValue)));
}
function $as_Llaika_internal_parse_hocon_ConfigBuilderValue(obj) {
  return (($is_Llaika_internal_parse_hocon_ConfigBuilderValue(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.hocon.ConfigBuilderValue"));
}
function $isArrayOf_Llaika_internal_parse_hocon_ConfigBuilderValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_hocon_ConfigBuilderValue)));
}
function $asArrayOf_Llaika_internal_parse_hocon_ConfigBuilderValue(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_hocon_ConfigBuilderValue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.hocon.ConfigBuilderValue;", depth));
}
var $d_Llaika_internal_parse_hocon_ConfigBuilderValue = new $TypeData().initClass(1, "laika.internal.parse.hocon.ConfigBuilderValue", ({
  Llaika_internal_parse_hocon_ConfigBuilderValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_hocon_HoconParsers$PathFragments(fragments) {
  this.Llaika_internal_parse_hocon_HoconParsers$PathFragments__f_fragments = null;
  this.Llaika_internal_parse_hocon_HoconParsers$PathFragments__f_fragments = fragments;
}
$c_Llaika_internal_parse_hocon_HoconParsers$PathFragments.prototype = new $h_O();
$c_Llaika_internal_parse_hocon_HoconParsers$PathFragments.prototype.constructor = $c_Llaika_internal_parse_hocon_HoconParsers$PathFragments;
/** @constructor */
function $h_Llaika_internal_parse_hocon_HoconParsers$PathFragments() {
}
$h_Llaika_internal_parse_hocon_HoconParsers$PathFragments.prototype = $c_Llaika_internal_parse_hocon_HoconParsers$PathFragments.prototype;
$c_Llaika_internal_parse_hocon_HoconParsers$PathFragments.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_parse_hocon_HoconParsers$PathFragments.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_parse_hocon_HoconParsers$PathFragments.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_parse_hocon_HoconParsers$PathFragments)) {
    var x$0$2 = $as_Llaika_internal_parse_hocon_HoconParsers$PathFragments(x$0);
    var x = this.Llaika_internal_parse_hocon_HoconParsers$PathFragments__f_fragments;
    var x$2 = $n(x$0$2).Llaika_internal_parse_hocon_HoconParsers$PathFragments__f_fragments;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_parse_hocon_HoconParsers$PathFragments.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_parse_hocon_HoconParsers$PathFragments.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_internal_parse_hocon_HoconParsers$PathFragments.prototype.productPrefix__T = (function() {
  return "PathFragments";
});
$c_Llaika_internal_parse_hocon_HoconParsers$PathFragments.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_parse_hocon_HoconParsers$PathFragments__f_fragments;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_internal_parse_hocon_HoconParsers$PathFragments.prototype.join__Llaika_internal_parse_hocon_HoconParsers$PathFragments__Llaika_internal_parse_hocon_HoconParsers$PathFragments = (function(other) {
  if (($n(this.Llaika_internal_parse_hocon_HoconParsers$PathFragments__f_fragments).isEmpty__Z() || $n($n(other).Llaika_internal_parse_hocon_HoconParsers$PathFragments__f_fragments).isEmpty__Z())) {
    var this$1 = $n(this.Llaika_internal_parse_hocon_HoconParsers$PathFragments__f_fragments);
    var suffix = $n(other).Llaika_internal_parse_hocon_HoconParsers$PathFragments__f_fragments;
    var fragments = $as_sci_Seq(this$1.appendedAll__sc_IterableOnce__O(suffix));
    return new $c_Llaika_internal_parse_hocon_HoconParsers$PathFragments(fragments);
  } else {
    matchResult6: {
      var glue;
      var _1 = $n(this.Llaika_internal_parse_hocon_HoconParsers$PathFragments__f_fragments).last__O();
      var _2 = $n($n(other).Llaika_internal_parse_hocon_HoconParsers$PathFragments__f_fragments).head__O();
      var x22 = $as_Llaika_internal_parse_hocon_StringBuilderValue(_1);
      var x23 = $as_Llaika_internal_parse_hocon_StringBuilderValue(_2);
      if ((x22 instanceof $c_Llaika_internal_parse_hocon_ValidStringValue)) {
        var x$1 = $as_Llaika_internal_parse_hocon_ValidStringValue(x22);
        var this$5 = $n(x$1);
        var x29 = this$5.Llaika_internal_parse_hocon_ValidStringValue__f_value;
        if ((x23 instanceof $c_Llaika_internal_parse_hocon_ValidStringValue)) {
          var x$1$1 = $as_Llaika_internal_parse_hocon_ValidStringValue(x23);
          var this$7 = $n(x$1$1);
          var x26 = this$7.Llaika_internal_parse_hocon_ValidStringValue__f_value;
          var $x_2 = $m_sci_Seq$();
          var $x_1 = $m_sr_ScalaRunTime$();
          var value = (("" + x29) + x26);
          var glue = $as_sci_Seq($n($x_2).apply__sci_Seq__sc_SeqOps($n($x_1).wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_internal_parse_hocon_ValidStringValue.getArrayOf().constr)([new $c_Llaika_internal_parse_hocon_ValidStringValue(value)]))));
          break matchResult6;
        }
      }
      var glue = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_internal_parse_hocon_StringBuilderValue.getArrayOf().constr)([x22, x23]))));
    }
    var this$12 = $n($as_sc_IterableOps($n(this.Llaika_internal_parse_hocon_HoconParsers$PathFragments__f_fragments).init__O()));
    var this$13 = $n($as_sc_IterableOps(this$12.concat__sc_IterableOnce__O(glue)));
    var suffix$1 = $as_sc_IterableOnce($n($n(other).Llaika_internal_parse_hocon_HoconParsers$PathFragments__f_fragments).tail__O());
    var fragments$1 = $as_sci_Seq(this$13.concat__sc_IterableOnce__O(suffix$1));
    return new $c_Llaika_internal_parse_hocon_HoconParsers$PathFragments(fragments$1);
  }
});
function $as_Llaika_internal_parse_hocon_HoconParsers$PathFragments(obj) {
  return (((obj instanceof $c_Llaika_internal_parse_hocon_HoconParsers$PathFragments) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.hocon.HoconParsers$PathFragments"));
}
function $isArrayOf_Llaika_internal_parse_hocon_HoconParsers$PathFragments(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_hocon_HoconParsers$PathFragments)));
}
function $asArrayOf_Llaika_internal_parse_hocon_HoconParsers$PathFragments(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_hocon_HoconParsers$PathFragments(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.hocon.HoconParsers$PathFragments;", depth));
}
var $d_Llaika_internal_parse_hocon_HoconParsers$PathFragments = new $TypeData().initClass($c_Llaika_internal_parse_hocon_HoconParsers$PathFragments, "laika.internal.parse.hocon.HoconParsers$PathFragments", ({
  Llaika_internal_parse_hocon_HoconParsers$PathFragments: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $f_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers__defaultSpanParser__Llaika_parse_markup_InlineParser($thiz) {
  var this$1 = $m_Llaika_parse_markup_InlineParsers$();
  var parser = new $c_sjsr_AnonFunction0((() => $m_Llaika_parse_text_DelimitedText$().Undelimited__Llaika_parse_text_DelimitedText()));
  return $n($f_Llaika_parse_markup_InlineParsers__spans__F0__Llaika_parse_markup_InlineParser(this$1, parser)).embedAll__F0__Llaika_parse_markup_InlineParser(new $c_sjsr_AnonFunction0((() => $thiz.spanParsers__sci_Seq())));
}
function $f_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers__recursiveSpans__Llaika_parse_text_DelimitedText__Llaika_parse_markup_InlineParser($thiz, p) {
  var this$1 = $m_Llaika_parse_markup_InlineParsers$();
  var parser = new $c_sjsr_AnonFunction0((() => p));
  return $n($f_Llaika_parse_markup_InlineParsers__spans__F0__Llaika_parse_markup_InlineParser(this$1, parser)).embedAll__F0__Llaika_parse_markup_InlineParser(new $c_sjsr_AnonFunction0((() => $thiz.spanParsers__sci_Seq())));
}
function $f_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers__recursiveSpans__Llaika_parse_Parser__Llaika_parse_markup_InlineParser($thiz, parser) {
  return new $c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$TwoPhaseInlineParser($thiz, parser, new $c_sjsr_AnonFunction0((() => $thiz.defaultSpanParser__Llaika_parse_markup_InlineParser())));
}
/** @constructor */
function $c_Llaika_internal_parse_markup_DocumentParser$DocumentInput(path, source) {
  this.Llaika_internal_parse_markup_DocumentParser$DocumentInput__f_path = null;
  this.Llaika_internal_parse_markup_DocumentParser$DocumentInput__f_source = null;
  this.Llaika_internal_parse_markup_DocumentParser$DocumentInput__f_path = path;
  this.Llaika_internal_parse_markup_DocumentParser$DocumentInput__f_source = source;
}
$c_Llaika_internal_parse_markup_DocumentParser$DocumentInput.prototype = new $h_O();
$c_Llaika_internal_parse_markup_DocumentParser$DocumentInput.prototype.constructor = $c_Llaika_internal_parse_markup_DocumentParser$DocumentInput;
/** @constructor */
function $h_Llaika_internal_parse_markup_DocumentParser$DocumentInput() {
}
$h_Llaika_internal_parse_markup_DocumentParser$DocumentInput.prototype = $c_Llaika_internal_parse_markup_DocumentParser$DocumentInput.prototype;
$c_Llaika_internal_parse_markup_DocumentParser$DocumentInput.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_parse_markup_DocumentParser$DocumentInput.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_parse_markup_DocumentParser$DocumentInput.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_parse_markup_DocumentParser$DocumentInput)) {
    var x$0$2 = $as_Llaika_internal_parse_markup_DocumentParser$DocumentInput(x$0);
    var x = this.Llaika_internal_parse_markup_DocumentParser$DocumentInput__f_path;
    var x$2 = $n(x$0$2).Llaika_internal_parse_markup_DocumentParser$DocumentInput__f_path;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_internal_parse_markup_DocumentParser$DocumentInput__f_source;
      var x$4 = $n(x$0$2).Llaika_internal_parse_markup_DocumentParser$DocumentInput__f_source;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_parse_markup_DocumentParser$DocumentInput.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_parse_markup_DocumentParser$DocumentInput.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_internal_parse_markup_DocumentParser$DocumentInput.prototype.productPrefix__T = (function() {
  return "DocumentInput";
});
$c_Llaika_internal_parse_markup_DocumentParser$DocumentInput.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_parse_markup_DocumentParser$DocumentInput__f_path;
  }
  if ((n === 1)) {
    return this.Llaika_internal_parse_markup_DocumentParser$DocumentInput__f_source;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_internal_parse_markup_DocumentParser$DocumentInput(obj) {
  return (((obj instanceof $c_Llaika_internal_parse_markup_DocumentParser$DocumentInput) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.markup.DocumentParser$DocumentInput"));
}
function $isArrayOf_Llaika_internal_parse_markup_DocumentParser$DocumentInput(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_markup_DocumentParser$DocumentInput)));
}
function $asArrayOf_Llaika_internal_parse_markup_DocumentParser$DocumentInput(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_markup_DocumentParser$DocumentInput(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.markup.DocumentParser$DocumentInput;", depth));
}
var $d_Llaika_internal_parse_markup_DocumentParser$DocumentInput = new $TypeData().initClass($c_Llaika_internal_parse_markup_DocumentParser$DocumentInput, "laika.internal.parse.markup.DocumentParser$DocumentInput", ({
  Llaika_internal_parse_markup_DocumentParser$DocumentInput: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_parse_builders$$tilde(_1, _2) {
  this.Llaika_parse_builders$$tilde__f__1 = null;
  this.Llaika_parse_builders$$tilde__f__2 = null;
  this.Llaika_parse_builders$$tilde__f__1 = _1;
  this.Llaika_parse_builders$$tilde__f__2 = _2;
}
$c_Llaika_parse_builders$$tilde.prototype = new $h_O();
$c_Llaika_parse_builders$$tilde.prototype.constructor = $c_Llaika_parse_builders$$tilde;
/** @constructor */
function $h_Llaika_parse_builders$$tilde() {
}
$h_Llaika_parse_builders$$tilde.prototype = $c_Llaika_parse_builders$$tilde.prototype;
$c_Llaika_parse_builders$$tilde.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_parse_builders$$tilde.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_parse_builders$$tilde.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_parse_builders$$tilde)) {
    var x$0$2 = $as_Llaika_parse_builders$$tilde(x$0);
    var x = this.Llaika_parse_builders$$tilde__f__1;
    var y = $n(x$0$2).Llaika_parse_builders$$tilde__f__1;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Llaika_parse_builders$$tilde__f__2;
      var y$1 = $n(x$0$2).Llaika_parse_builders$$tilde__f__2;
      var $x_1 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y$1);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_parse_builders$$tilde.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_parse_builders$$tilde.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_parse_builders$$tilde.prototype.productPrefix__T = (function() {
  return "~";
});
$c_Llaika_parse_builders$$tilde.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_parse_builders$$tilde__f__1;
  }
  if ((n === 1)) {
    return this.Llaika_parse_builders$$tilde__f__2;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_parse_builders$$tilde(obj) {
  return (((obj instanceof $c_Llaika_parse_builders$$tilde) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.parse.builders$$tilde"));
}
function $isArrayOf_Llaika_parse_builders$$tilde(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_parse_builders$$tilde)));
}
function $asArrayOf_Llaika_parse_builders$$tilde(obj, depth) {
  return (($isArrayOf_Llaika_parse_builders$$tilde(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.parse.builders$$tilde;", depth));
}
var $d_Llaika_parse_builders$$tilde = new $TypeData().initClass($c_Llaika_parse_builders$$tilde, "laika.parse.builders$$tilde", ({
  Llaika_parse_builders$$tilde: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $is_Llaika_parse_code_CodeCategory(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_parse_code_CodeCategory)));
}
function $as_Llaika_parse_code_CodeCategory(obj) {
  return (($is_Llaika_parse_code_CodeCategory(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.parse.code.CodeCategory"));
}
function $isArrayOf_Llaika_parse_code_CodeCategory(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_parse_code_CodeCategory)));
}
function $asArrayOf_Llaika_parse_code_CodeCategory(obj, depth) {
  return (($isArrayOf_Llaika_parse_code_CodeCategory(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.parse.code.CodeCategory;", depth));
}
/** @constructor */
function $c_Lorg_scalajs_dom_DOMList$DOMListIterator(domList) {
  this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_domList = null;
  this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_index = 0;
  this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_domList = domList;
  this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_index = 0;
}
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype = new $h_O();
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.constructor = $c_Lorg_scalajs_dom_DOMList$DOMListIterator;
/** @constructor */
function $h_Lorg_scalajs_dom_DOMList$DOMListIterator() {
}
$h_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype = $c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype;
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.knownSize__I = (function() {
  return (-1);
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.iterator__sc_Iterator = (function() {
  return this;
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z());
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.toString__T = (function() {
  return "<iterator>";
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.hasNext__Z = (function() {
  return (this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_index < $uI(this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_domList.length));
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.next__O = (function() {
  var res = this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_domList[this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_index];
  this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_index = ((1 + this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_index) | 0);
  return res;
});
var $d_Lorg_scalajs_dom_DOMList$DOMListIterator = new $TypeData().initClass($c_Lorg_scalajs_dom_DOMList$DOMListIterator, "org.scalajs.dom.DOMList$DOMListIterator", ({
  Lorg_scalajs_dom_DOMList$DOMListIterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
}));
/** @constructor */
function $c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1(outer) {
  this.Lorg_scalajs_dom_NamedNodeMapMap$$anon$1__f_index = 0;
  this.Lorg_scalajs_dom_NamedNodeMapMap$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lorg_scalajs_dom_NamedNodeMapMap$$anon$1__f_$outer = outer;
  this.Lorg_scalajs_dom_NamedNodeMapMap$$anon$1__f_index = 0;
}
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype = new $h_O();
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.constructor = $c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1;
/** @constructor */
function $h_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1() {
}
$h_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype = $c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype;
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.knownSize__I = (function() {
  return (-1);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return this;
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z());
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.toString__T = (function() {
  return "<iterator>";
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.next__T2 = (function() {
  var n = $n(this.Lorg_scalajs_dom_NamedNodeMapMap$$anon$1__f_$outer).Lorg_scalajs_dom_NamedNodeMapMap__f_org$scalajs$dom$NamedNodeMapMap$$namedNodeMap.item(this.Lorg_scalajs_dom_NamedNodeMapMap$$anon$1__f_index);
  this.Lorg_scalajs_dom_NamedNodeMapMap$$anon$1__f_index = ((1 + this.Lorg_scalajs_dom_NamedNodeMapMap$$anon$1__f_index) | 0);
  var _1 = $as_T(n.name);
  return new $c_T2(_1, n);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.hasNext__Z = (function() {
  return (this.Lorg_scalajs_dom_NamedNodeMapMap$$anon$1__f_index < $uI($n(this.Lorg_scalajs_dom_NamedNodeMapMap$$anon$1__f_$outer).Lorg_scalajs_dom_NamedNodeMapMap__f_org$scalajs$dom$NamedNodeMapMap$$namedNodeMap.length));
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.next__O = (function() {
  return this.next__T2();
});
var $d_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1 = new $TypeData().initClass($c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1, "org.scalajs.dom.NamedNodeMapMap$$anon$1", ({
  Lorg_scalajs_dom_NamedNodeMapMap$$anon$1: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
}));
function $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__canUsePostMessage$1__Z($thiz) {
  if ((($as_T((typeof postMessage)) !== "undefined") && ($as_T((typeof importScripts)) === "undefined"))) {
    var postMessageIsAsynchronous = new $c_sr_BooleanRef(true);
    var oldOnMessage = onmessage;
    try {
      onmessage = $m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(new $c_sjsr_AnonFunction0((() => {
        var ev$4 = false;
        postMessageIsAsynchronous.sr_BooleanRef__f_elem = ev$4;
      })));
      postMessage("", "*");
      onmessage = oldOnMessage;
      return postMessageIsAsynchronous.sr_BooleanRef__f_elem;
    } catch (e) {
      var e$1 = e;
      var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
      var x2 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!$n(x2).isEmpty__Z())) {
        $as_jl_Throwable($n(x2).get__O());
        return false;
      }
      throw e$2;
    }
  } else {
    return false;
  }
}
function $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__runIfPresent$1__scm_Map__sr_BooleanRef__I__V($thiz, tasksByHandle$1, currentlyRunningATask$1, handle) {
  if ($n(currentlyRunningATask$1).sr_BooleanRef__f_elem) {
    setTimeout($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(new $c_sjsr_AnonFunction0((() => {
      $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__runIfPresent$1__scm_Map__sr_BooleanRef__I__V($thiz, tasksByHandle$1, currentlyRunningATask$1, handle);
    }))), 0);
  } else {
    matchResult2: {
      var x5 = $n(tasksByHandle$1).get__O__s_Option(handle);
      if ((x5 instanceof $c_s_Some)) {
        var task = $as_F0($n($as_s_Some(x5)).s_Some__f_value);
        var ev$5 = true;
        $n(currentlyRunningATask$1).sr_BooleanRef__f_elem = ev$5;
        try {
          $n(task).apply__O();
        } finally {
          var this$3 = $n(tasksByHandle$1);
          this$3.subtractOne__O__scm_Shrinkable(handle);
          var ev$6 = false;
          $n(currentlyRunningATask$1).sr_BooleanRef__f_elem = ev$6;
        }
        break matchResult2;
      }
      var x = $m_s_None$();
      if ((x === x5)) {
        break matchResult2;
      }
      throw new $c_s_MatchError(x5);
    }
  }
}
function $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__onGlobalMessage$1__scm_Map__sr_BooleanRef__T__sjs_js_Dynamic__V($thiz, tasksByHandle$3, currentlyRunningATask$3, messagePrefix$1, event) {
  if ((($as_T((typeof event.data)) === "string") && ($uI(event.data.indexOf(messagePrefix$1)) === 0))) {
    var this$3 = $n($dp_toString__T($n(event.data)));
    var this$2 = $n(messagePrefix$1);
    var beginIndex = this$2.length;
    if (((beginIndex < 0) || (beginIndex > this$3.length))) {
      $charAt(this$3, beginIndex);
    }
    var x = $as_T(this$3.substring(beginIndex));
    var this$6 = $m_jl_Integer$();
    $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__runIfPresent$1__scm_Map__sr_BooleanRef__I__V($thiz, tasksByHandle$3, currentlyRunningATask$3, this$6.parseInt__T__I__I(x, 10));
  }
}
/** @constructor */
function $c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$() {
  this.Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__f_setImmediate = null;
  $n_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$ = this;
  if (($as_T((typeof setImmediate)) === "undefined")) {
    var nextHandle = new $c_sr_IntRef(1);
    var tasksByHandle = $as_scm_Map($m_scm_Map$().apply__sci_Seq__O($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([]))));
    var currentlyRunningATask = new $c_sr_BooleanRef(false);
    if (($as_T((typeof navigator)) !== "undefined")) {
      var x = navigator.userAgent;
      if ((x !== (void 0))) {
        var _$1 = $as_T(x);
        var this$8 = $n(_$1);
        var $x_5 = ($uI(this$8.indexOf("jsdom")) !== (-1));
      } else {
        var $x_5 = false;
      }
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var setImmediate$1 = Node.constructor("return setImmediate")();
      var $x_4 = new $c_sjsr_AnonFunction1(((k) => {
        var k$1 = $as_F0(k);
        setImmediate$1($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(k$1));
      }));
    } else if ($p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__canUsePostMessage$1__Z(this)) {
      var this$10 = $m_s_util_Random$();
      var this$11 = $n(this$10.s_util_Random__f_self);
      var messagePrefix = (("setImmediate$" + this$11.next__I__I(32)) + "$");
      if (($as_T((typeof addEventListener)) !== "undefined")) {
        addEventListener("message", $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(new $c_sjsr_AnonFunction1(((event) => {
          $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__onGlobalMessage$1__scm_Map__sr_BooleanRef__T__sjs_js_Dynamic__V(this, tasksByHandle, currentlyRunningATask, messagePrefix, event);
        }))), false);
      } else {
        attachEvent("onmessage", $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(new $c_sjsr_AnonFunction1(((event$2) => {
          $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__onGlobalMessage$1__scm_Map__sr_BooleanRef__T__sjs_js_Dynamic__V(this, tasksByHandle, currentlyRunningATask, messagePrefix, event$2);
        }))));
      }
      var $x_4 = new $c_sjsr_AnonFunction1(((k$2) => {
        var k$3 = $as_F0(k$2);
        var handle = nextHandle.sr_IntRef__f_elem;
        var ev$7 = ((1 + nextHandle.sr_IntRef__f_elem) | 0);
        nextHandle.sr_IntRef__f_elem = ev$7;
        var this$17 = $n(tasksByHandle);
        var elem = new $c_T2(handle, k$3);
        this$17.addOne__O__scm_Growable(elem);
        var $x_6 = postMessage;
        var s = (messagePrefix + handle);
        $x_6(s, "*");
      }));
    } else if (($as_T((typeof MessageChannel)) !== "undefined")) {
      var channel = new MessageChannel();
      channel.port1.onmessage = $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(new $c_sjsr_AnonFunction1(((event$3) => {
        $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__runIfPresent$1__scm_Map__sr_BooleanRef__I__V(this, tasksByHandle, currentlyRunningATask, $uI(event$3.data));
      })));
      var $x_4 = new $c_sjsr_AnonFunction1(((k$3$1) => {
        var k$4 = $as_F0(k$3$1);
        var handle$1 = nextHandle.sr_IntRef__f_elem;
        var ev$8 = ((1 + nextHandle.sr_IntRef__f_elem) | 0);
        nextHandle.sr_IntRef__f_elem = ev$8;
        var this$22 = $n(tasksByHandle);
        var elem$1 = new $c_T2(handle$1, k$4);
        this$22.addOne__O__scm_Growable(elem$1);
        channel.port2.postMessage(handle$1);
      }));
    } else {
      var $x_4 = new $c_sjsr_AnonFunction1(((k$4$1) => {
        var k$5 = $as_F0(k$4$1);
        setTimeout($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(k$5), 0);
      }));
    }
  } else {
    var $x_4 = new $c_sjsr_AnonFunction1(((k$5$1) => {
      var k$6 = $as_F0(k$5$1);
      setImmediate($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(k$6));
    }));
  }
  this.Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__f_setImmediate = $x_4;
}
$c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype = new $h_O();
$c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype.constructor = $c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$;
/** @constructor */
function $h_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$() {
}
$h_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype = $c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype;
$c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype.execute__jl_Runnable__V = (function(runnable) {
  $n(this.Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__f_setImmediate).apply__O__O(new $c_sjsr_AnonFunction0((() => {
    $n(runnable).run__V();
  })));
});
$c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype.reportFailure__jl_Throwable__V = (function(cause) {
  var this$1 = $n(cause);
  this$1.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err);
});
var $d_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$ = new $TypeData().initClass($c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$, "org.scalajs.macrotaskexecutor.MacrotaskExecutor$", ({
  Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$: 1,
  s_concurrent_ExecutionContext: 1,
  ju_concurrent_Executor: 1,
  s_concurrent_ExecutionContextExecutor: 1
}));
var $n_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$;
function $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$() {
  if ((!$n_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$)) {
    $n_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$ = new $c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$();
  }
  return $n_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$;
}
/** @constructor */
function $c_s_$eq$colon$eq() {
}
$c_s_$eq$colon$eq.prototype = new $h_s_$less$colon$less();
$c_s_$eq$colon$eq.prototype.constructor = $c_s_$eq$colon$eq;
/** @constructor */
function $h_s_$eq$colon$eq() {
}
$h_s_$eq$colon$eq.prototype = $c_s_$eq$colon$eq.prototype;
class $c_s_NotImplementedError extends $c_jl_Error {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, "an implementation is missing", null, true, true);
  }
}
var $d_s_NotImplementedError = new $TypeData().initClass($c_s_NotImplementedError, "scala.NotImplementedError", ({
  s_NotImplementedError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_PartialFunction$$anon$1() {
  this.s_PartialFunction$$anon$1__f_lift = null;
  this.s_PartialFunction$$anon$1__f_lift = new $c_sjsr_AnonFunction1(((x$2) => $m_s_None$()));
}
$c_s_PartialFunction$$anon$1.prototype = new $h_O();
$c_s_PartialFunction$$anon$1.prototype.constructor = $c_s_PartialFunction$$anon$1;
/** @constructor */
function $h_s_PartialFunction$$anon$1() {
}
$h_s_PartialFunction$$anon$1.prototype = $c_s_PartialFunction$$anon$1.prototype;
$c_s_PartialFunction$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1);
});
$c_s_PartialFunction$$anon$1.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  this.apply__O__E(v1);
});
$c_s_PartialFunction$$anon$1.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_s_PartialFunction$$anon$1.prototype.toString__T = (function() {
  return "<function1>";
});
$c_s_PartialFunction$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return false;
});
$c_s_PartialFunction$$anon$1.prototype.apply__O__E = (function(x) {
  throw new $c_s_MatchError(x);
});
$c_s_PartialFunction$$anon$1.prototype.orElse__s_PartialFunction__s_PartialFunction = (function(that) {
  return that;
});
$c_s_PartialFunction$$anon$1.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return this;
});
$c_s_PartialFunction$$anon$1.prototype.lift__F1 = (function() {
  return this.s_PartialFunction$$anon$1__f_lift;
});
$c_s_PartialFunction$$anon$1.prototype.runWith__F1__F1 = (function(action) {
  return $m_s_PartialFunction$().s_PartialFunction$__f_scala$PartialFunction$$constFalse;
});
$c_s_PartialFunction$$anon$1.prototype.andThen__F1__F1 = (function(g) {
  return this;
});
$c_s_PartialFunction$$anon$1.prototype.apply__O__O = (function(v1) {
  this.apply__O__E(v1);
});
var $d_s_PartialFunction$$anon$1 = new $TypeData().initClass($c_s_PartialFunction$$anon$1, "scala.PartialFunction$$anon$1", ({
  s_PartialFunction$$anon$1: 1,
  s_PartialFunction: 1,
  F1: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_PartialFunction$AndThen(pf, k) {
  this.s_PartialFunction$AndThen__f_pf = null;
  this.s_PartialFunction$AndThen__f_k = null;
  this.s_PartialFunction$AndThen__f_pf = pf;
  this.s_PartialFunction$AndThen__f_k = k;
}
$c_s_PartialFunction$AndThen.prototype = new $h_O();
$c_s_PartialFunction$AndThen.prototype.constructor = $c_s_PartialFunction$AndThen;
/** @constructor */
function $h_s_PartialFunction$AndThen() {
}
$h_s_PartialFunction$AndThen.prototype = $c_s_PartialFunction$AndThen.prototype;
$c_s_PartialFunction$AndThen.prototype.orElse__s_PartialFunction__s_PartialFunction = (function(that) {
  return new $c_s_PartialFunction$OrElse(this, that);
});
$c_s_PartialFunction$AndThen.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_s_PartialFunction$AndThen.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_s_PartialFunction$AndThen.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_s_PartialFunction$AndThen.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__O__O(v1));
});
$c_s_PartialFunction$AndThen.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_s_PartialFunction$AndThen.prototype.toString__T = (function() {
  return "<function1>";
});
$c_s_PartialFunction$AndThen.prototype.isDefinedAt__O__Z = (function(x) {
  return $n(this.s_PartialFunction$AndThen__f_pf).isDefinedAt__O__Z(x);
});
$c_s_PartialFunction$AndThen.prototype.apply__O__O = (function(x) {
  return $n(this.s_PartialFunction$AndThen__f_k).apply__O__O($n(this.s_PartialFunction$AndThen__f_pf).apply__O__O(x));
});
$c_s_PartialFunction$AndThen.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  var z = $n(this.s_PartialFunction$AndThen__f_pf).applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
  return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(z)) ? $n(this.s_PartialFunction$AndThen__f_k).apply__O__O(z) : $n(default$1).apply__O__O(x));
});
$c_s_PartialFunction$AndThen.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
var $d_s_PartialFunction$AndThen = new $TypeData().initClass($c_s_PartialFunction$AndThen, "scala.PartialFunction$AndThen", ({
  s_PartialFunction$AndThen: 1,
  s_PartialFunction: 1,
  F1: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_PartialFunction$Combined(pf, k) {
  this.s_PartialFunction$Combined__f_pf = null;
  this.s_PartialFunction$Combined__f_k = null;
  this.s_PartialFunction$Combined__f_pf = pf;
  this.s_PartialFunction$Combined__f_k = k;
}
$c_s_PartialFunction$Combined.prototype = new $h_O();
$c_s_PartialFunction$Combined.prototype.constructor = $c_s_PartialFunction$Combined;
/** @constructor */
function $h_s_PartialFunction$Combined() {
}
$h_s_PartialFunction$Combined.prototype = $c_s_PartialFunction$Combined.prototype;
$c_s_PartialFunction$Combined.prototype.orElse__s_PartialFunction__s_PartialFunction = (function(that) {
  return new $c_s_PartialFunction$OrElse(this, that);
});
$c_s_PartialFunction$Combined.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_s_PartialFunction$Combined.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_s_PartialFunction$Combined.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_s_PartialFunction$Combined.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__O__O(v1));
});
$c_s_PartialFunction$Combined.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_s_PartialFunction$Combined.prototype.toString__T = (function() {
  return "<function1>";
});
$c_s_PartialFunction$Combined.prototype.isDefinedAt__O__Z = (function(x) {
  var b = $n(this.s_PartialFunction$Combined__f_pf).applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
  return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(b)) && $n(this.s_PartialFunction$Combined__f_k).isDefinedAt__O__Z(b));
});
$c_s_PartialFunction$Combined.prototype.apply__O__O = (function(x) {
  return $n(this.s_PartialFunction$Combined__f_k).apply__O__O($n(this.s_PartialFunction$Combined__f_pf).apply__O__O(x));
});
$c_s_PartialFunction$Combined.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  var pfv = $n(this.s_PartialFunction$Combined__f_pf).applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
  return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(pfv)) ? $n(this.s_PartialFunction$Combined__f_k).applyOrElse__O__F1__O(pfv, new $c_sjsr_AnonFunction1(((x$1$2) => $n(default$1).apply__O__O(x)))) : $n(default$1).apply__O__O(x));
});
$c_s_PartialFunction$Combined.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
var $d_s_PartialFunction$Combined = new $TypeData().initClass($c_s_PartialFunction$Combined, "scala.PartialFunction$Combined", ({
  s_PartialFunction$Combined: 1,
  s_PartialFunction: 1,
  F1: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_PartialFunction$Lifted(pf) {
  this.s_PartialFunction$Lifted__f_pf = null;
  this.s_PartialFunction$Lifted__f_pf = pf;
}
$c_s_PartialFunction$Lifted.prototype = new $h_sr_AbstractFunction1();
$c_s_PartialFunction$Lifted.prototype.constructor = $c_s_PartialFunction$Lifted;
/** @constructor */
function $h_s_PartialFunction$Lifted() {
}
$h_s_PartialFunction$Lifted.prototype = $c_s_PartialFunction$Lifted.prototype;
$c_s_PartialFunction$Lifted.prototype.apply__O__s_Option = (function(x) {
  var z = $n(this.s_PartialFunction$Lifted__f_pf).applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
  return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(z)) ? new $c_s_Some(z) : $m_s_None$());
});
$c_s_PartialFunction$Lifted.prototype.apply__O__O = (function(v1) {
  return this.apply__O__s_Option(v1);
});
var $d_s_PartialFunction$Lifted = new $TypeData().initClass($c_s_PartialFunction$Lifted, "scala.PartialFunction$Lifted", ({
  s_PartialFunction$Lifted: 1,
  sr_AbstractFunction1: 1,
  F1: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_AbstractIterator() {
}
$c_sc_AbstractIterator.prototype = new $h_O();
$c_sc_AbstractIterator.prototype.constructor = $c_sc_AbstractIterator;
/** @constructor */
function $h_sc_AbstractIterator() {
}
$h_sc_AbstractIterator.prototype = $c_sc_AbstractIterator.prototype;
$c_sc_AbstractIterator.prototype.iterator__sc_Iterator = (function() {
  return this;
});
$c_sc_AbstractIterator.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z());
});
$c_sc_AbstractIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$c_sc_AbstractIterator.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$c_sc_AbstractIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return this.sliceIterator__I__I__sc_Iterator(n, (-1));
});
$c_sc_AbstractIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$c_sc_AbstractIterator.prototype.toString__T = (function() {
  return "<iterator>";
});
$c_sc_AbstractIterator.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_sc_AbstractIterator.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_sc_AbstractIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_sc_AbstractIterator.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$c_sc_AbstractIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_sc_AbstractIterator.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_sc_AbstractIterator.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_sc_AbstractIterator.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this);
});
$c_sc_AbstractIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_sc_AbstractIterator.prototype.knownSize__I = (function() {
  return (-1);
});
/** @constructor */
function $c_sc_Iterable$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_sci_Iterable$());
}
$c_sc_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$c_sc_Iterable$.prototype.constructor = $c_sc_Iterable$;
/** @constructor */
function $h_sc_Iterable$() {
}
$h_sc_Iterable$.prototype = $c_sc_Iterable$.prototype;
var $d_sc_Iterable$ = new $TypeData().initClass($c_sc_Iterable$, "scala.collection.Iterable$", ({
  sc_Iterable$: 1,
  sc_IterableFactory$Delegate: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sc_Iterable$;
function $m_sc_Iterable$() {
  if ((!$n_sc_Iterable$)) {
    $n_sc_Iterable$ = new $c_sc_Iterable$();
  }
  return $n_sc_Iterable$;
}
/** @constructor */
function $c_sc_Map$() {
  this.sc_MapFactory$Delegate__f_delegate = null;
  this.sc_Map$__f_DefaultSentinel = null;
  this.sc_Map$__f_scala$collection$Map$$DefaultSentinelFn = null;
  $ct_sc_MapFactory$Delegate__sc_MapFactory__(this, $m_sci_Map$());
  $n_sc_Map$ = this;
  this.sc_Map$__f_DefaultSentinel = $ct_O__(new $c_O());
  this.sc_Map$__f_scala$collection$Map$$DefaultSentinelFn = new $c_sjsr_AnonFunction0((() => $m_sc_Map$().sc_Map$__f_DefaultSentinel));
}
$c_sc_Map$.prototype = new $h_sc_MapFactory$Delegate();
$c_sc_Map$.prototype.constructor = $c_sc_Map$;
/** @constructor */
function $h_sc_Map$() {
}
$h_sc_Map$.prototype = $c_sc_Map$.prototype;
var $d_sc_Map$ = new $TypeData().initClass($c_sc_Map$, "scala.collection.Map$", ({
  sc_Map$: 1,
  sc_MapFactory$Delegate: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sc_Map$;
function $m_sc_Map$() {
  if ((!$n_sc_Map$)) {
    $n_sc_Map$ = new $c_sc_Map$();
  }
  return $n_sc_Map$;
}
/** @constructor */
function $c_sc_MapView$() {
  this.sc_MapView$__f_EmptyMapView = null;
  $n_sc_MapView$ = this;
  this.sc_MapView$__f_EmptyMapView = new $c_sc_MapView$$anon$1();
}
$c_sc_MapView$.prototype = new $h_O();
$c_sc_MapView$.prototype.constructor = $c_sc_MapView$;
/** @constructor */
function $h_sc_MapView$() {
}
$h_sc_MapView$.prototype = $c_sc_MapView$.prototype;
$c_sc_MapView$.prototype.newBuilder__scm_Builder = (function() {
  var this$4 = new $c_scm_HashMap$$anon$6(16, 0.75);
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_scm_HashMap(x$1$2);
    var this$3 = $n(x$1);
    return new $c_sc_MapView$Id(this$3);
  }));
  return new $c_scm_Builder$$anon$1(this$4, f);
});
$c_sc_MapView$.prototype.from__sc_MapOps__sc_MapView = (function(it) {
  if ($is_sc_MapView(it)) {
    var x2 = $as_sc_MapView(it);
    return x2;
  } else {
    return new $c_sc_MapView$Id(it);
  }
});
$c_sc_MapView$.prototype.apply__sci_Seq__sc_MapView = (function(elems) {
  var this$2 = $n(elems);
  var this$1 = $m_s_$less$colon$less$();
  return this.from__sc_MapOps__sc_MapView($m_sci_Map$().from__sc_IterableOnce__sci_Map(this$2));
});
$c_sc_MapView$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.apply__sci_Seq__sc_MapView(elems);
});
$c_sc_MapView$.prototype.from__sc_IterableOnce__O = (function(it) {
  return $m_sc_View$().from__sc_IterableOnce__sc_View(it);
});
$c_sc_MapView$.prototype.empty__O = (function() {
  return this.sc_MapView$__f_EmptyMapView;
});
var $d_sc_MapView$ = new $TypeData().initClass($c_sc_MapView$, "scala.collection.MapView$", ({
  sc_MapView$: 1,
  sc_MapViewFactory: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sc_MapView$;
function $m_sc_MapView$() {
  if ((!$n_sc_MapView$)) {
    $n_sc_MapView$ = new $c_sc_MapView$();
  }
  return $n_sc_MapView$;
}
function $ct_sc_SeqFactory$Delegate__sc_SeqFactory__($thiz, delegate) {
  $thiz.sc_SeqFactory$Delegate__f_delegate = delegate;
  return $thiz;
}
/** @constructor */
function $c_sc_SeqFactory$Delegate() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
}
$c_sc_SeqFactory$Delegate.prototype = new $h_O();
$c_sc_SeqFactory$Delegate.prototype.constructor = $c_sc_SeqFactory$Delegate;
/** @constructor */
function $h_sc_SeqFactory$Delegate() {
}
$h_sc_SeqFactory$Delegate.prototype = $c_sc_SeqFactory$Delegate.prototype;
$c_sc_SeqFactory$Delegate.prototype.apply__sci_Seq__sc_SeqOps = (function(elems) {
  return $as_sc_SeqOps($n(this.sc_SeqFactory$Delegate__f_delegate).apply__sci_Seq__O(elems));
});
$c_sc_SeqFactory$Delegate.prototype.empty__sc_SeqOps = (function() {
  return $as_sc_SeqOps($n(this.sc_SeqFactory$Delegate__f_delegate).empty__O());
});
$c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__sc_SeqOps = (function(it) {
  return $as_sc_SeqOps($n(this.sc_SeqFactory$Delegate__f_delegate).from__sc_IterableOnce__O(it));
});
$c_sc_SeqFactory$Delegate.prototype.newBuilder__scm_Builder = (function() {
  return $n(this.sc_SeqFactory$Delegate__f_delegate).newBuilder__scm_Builder();
});
$c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sc_SeqOps(source);
});
$c_sc_SeqFactory$Delegate.prototype.empty__O = (function() {
  return this.empty__sc_SeqOps();
});
$c_sc_SeqFactory$Delegate.prototype.apply__sci_Seq__O = (function(elems) {
  return this.apply__sci_Seq__sc_SeqOps(elems);
});
function $f_sc_SeqOps__prepended__O__O($thiz, elem) {
  return $n($thiz.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O($ct_sc_View$Prepended__O__sc_IterableOps__(new $c_sc_View$Prepended(), elem, $thiz));
}
function $f_sc_SeqOps__appended__O__O($thiz, elem) {
  return $n($thiz.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O($ct_sc_View$Appended__sc_IterableOps__O__(new $c_sc_View$Appended(), $thiz, elem));
}
function $f_sc_SeqOps__prependedAll__sc_IterableOnce__O($thiz, prefix) {
  var $x_2 = $n($thiz.iterableFactory__sc_IterableFactory());
  if ($is_sc_Iterable(prefix)) {
    var x2 = $as_sc_Iterable(prefix);
    var $x_1 = new $c_sc_View$Concat(x2, $thiz);
  } else {
    var this$2 = $n($n(prefix).iterator__sc_Iterator());
    var xs = new $c_sjsr_AnonFunction0((() => $thiz.iterator__sc_Iterator()));
    var $x_1 = this$2.concat__F0__sc_Iterator(xs);
  }
  return $n($x_2).from__sc_IterableOnce__O($x_1);
}
function $f_sc_SeqOps__distinct__O($thiz) {
  return $thiz.distinctBy__F1__O(new $c_sjsr_AnonFunction1(((x$2) => x$2)));
}
function $f_sc_SeqOps__distinctBy__F1__O($thiz, f) {
  return $thiz.fromSpecific__sc_IterableOnce__O(new $c_sc_View$DistinctBy($thiz, f));
}
function $f_sc_SeqOps__startsWith__sc_IterableOnce__I__Z($thiz, that, offset) {
  var i = $n($thiz.iterator__sc_Iterator()).drop__I__sc_Iterator(offset);
  var j = $n(that).iterator__sc_Iterator();
  while (($n(j).hasNext__Z() && $n(i).hasNext__Z())) {
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z($n(i).next__O(), $n(j).next__O()))) {
      return false;
    }
  }
  return (!$n(j).hasNext__Z());
}
function $f_sc_SeqOps__isDefinedAt__I__Z($thiz, idx) {
  return ((idx >= 0) && ($thiz.lengthCompare__I__I(idx) > 0));
}
function $f_sc_SeqOps__padTo__I__O__O($thiz, len, elem) {
  return $n($thiz.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O(new $c_sc_View$PadTo($thiz, len, elem));
}
function $f_sc_SeqOps__indexOf__O__I__I($thiz, elem, from) {
  return $thiz.indexWhere__F1__I__I(new $c_sjsr_AnonFunction1(((x$1$2) => $m_sr_BoxesRunTime$().equals__O__O__Z(elem, x$1$2))), from);
}
function $f_sc_SeqOps__contains__O__Z($thiz, elem) {
  return $thiz.exists__F1__Z(new $c_sjsr_AnonFunction1(((x$3$2) => $m_sr_BoxesRunTime$().equals__O__O__Z(x$3$2, elem))));
}
function $f_sc_SeqOps__sorted__s_math_Ordering__O($thiz, ord) {
  var len = $thiz.length__I();
  var b = $thiz.newSpecificBuilder__scm_Builder();
  if ((len === 1)) {
    var this$1 = $n(b);
    var elem = $thiz.head__O();
    this$1.addOne__O__scm_Growable(elem);
  } else if ((len > 1)) {
    $n(b).sizeHint__I__V(len);
    var arr = new $ac_O(len);
    $thiz.copyToArray__O__I__I__I(arr, 0, 2147483647);
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(arr, ord);
    var i = 0;
    while ((i < len)) {
      var this$2 = $n(b);
      var elem$1 = $n(arr).get(i);
      this$2.addOne__O__scm_Growable(elem$1);
      i = ((1 + i) | 0);
    }
  }
  return $n(b).result__O();
}
function $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($thiz, f, ord) {
  var this$1 = $n(ord);
  return $thiz.sorted__s_math_Ordering__O(new $c_s_math_Ordering$$anon$1(this$1, f));
}
function $f_sc_SeqOps__isEmpty__Z($thiz) {
  return ($thiz.lengthCompare__I__I(0) === 0);
}
function $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, that) {
  var thisKnownSize = $thiz.knownSize__I();
  if ((thisKnownSize !== (-1))) {
    var thatKnownSize = $n(that).knownSize__I();
    var knownSizeDifference = ((thatKnownSize !== (-1)) && (thisKnownSize !== thatKnownSize));
  } else {
    var knownSizeDifference = false;
  }
  if ((!knownSizeDifference)) {
    var this$1 = $n($thiz.iterator__sc_Iterator());
    return $f_sc_Iterator__sameElements__sc_IterableOnce__Z(this$1, that);
  } else {
    return false;
  }
}
function $is_sc_SeqOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_SeqOps)));
}
function $as_sc_SeqOps(obj) {
  return (($is_sc_SeqOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.SeqOps"));
}
function $isArrayOf_sc_SeqOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_SeqOps)));
}
function $asArrayOf_sc_SeqOps(obj, depth) {
  return (($isArrayOf_sc_SeqOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.SeqOps;", depth));
}
/** @constructor */
function $c_sc_Set$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_sci_Set$());
}
$c_sc_Set$.prototype = new $h_sc_IterableFactory$Delegate();
$c_sc_Set$.prototype.constructor = $c_sc_Set$;
/** @constructor */
function $h_sc_Set$() {
}
$h_sc_Set$.prototype = $c_sc_Set$.prototype;
var $d_sc_Set$ = new $TypeData().initClass($c_sc_Set$, "scala.collection.Set$", ({
  sc_Set$: 1,
  sc_IterableFactory$Delegate: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sc_Set$;
function $m_sc_Set$() {
  if ((!$n_sc_Set$)) {
    $n_sc_Set$ = new $c_sc_Set$();
  }
  return $n_sc_Set$;
}
function $f_sc_StrictOptimizedIterableOps__partition__F1__T2($thiz, p) {
  var l = $thiz.newSpecificBuilder__scm_Builder();
  var r = $thiz.newSpecificBuilder__scm_Builder();
  var this$1 = $n($thiz.iterator__sc_Iterator());
  while (this$1.hasNext__Z()) {
    var arg1 = this$1.next__O();
    var this$2 = $n(($uZ($n(p).apply__O__O(arg1)) ? l : r));
    $as_scm_Builder(this$2.addOne__O__scm_Growable(arg1));
  }
  return new $c_T2($n(l).result__O(), $n(r).result__O());
}
function $f_sc_StrictOptimizedIterableOps__span__F1__T2($thiz, p) {
  var first = $thiz.newSpecificBuilder__scm_Builder();
  var second = $thiz.newSpecificBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  var inFirst = true;
  while (($n(it).hasNext__Z() && inFirst)) {
    var a = $n(it).next__O();
    if ($uZ($n(p).apply__O__O(a))) {
      var this$1 = $n(first);
      this$1.addOne__O__scm_Growable(a);
    } else {
      var this$2 = $n(second);
      this$2.addOne__O__scm_Growable(a);
      inFirst = false;
    }
  }
  while ($n(it).hasNext__Z()) {
    var this$3 = $n(second);
    var elem = $n(it).next__O();
    this$3.addOne__O__scm_Growable(elem);
  }
  return new $c_T2($n(first).result__O(), $n(second).result__O());
}
function $f_sc_StrictOptimizedIterableOps__map__F1__O($thiz, f) {
  var b = $n($thiz.iterableFactory__sc_IterableFactory()).newBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var this$1 = $n(b);
    var elem = $n(f).apply__O__O($n(it).next__O());
    this$1.addOne__O__scm_Growable(elem);
  }
  return $n(b).result__O();
}
function $f_sc_StrictOptimizedIterableOps__flatMap__F1__O($thiz, f) {
  var b = $n($thiz.iterableFactory__sc_IterableFactory()).newBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var this$1 = $n(b);
    var xs = $as_sc_IterableOnce($n(f).apply__O__O($n(it).next__O()));
    this$1.addAll__sc_IterableOnce__scm_Growable(xs);
  }
  return $n(b).result__O();
}
function $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O($thiz, pf) {
  var b = $n($thiz.iterableFactory__sc_IterableFactory()).newBuilder__scm_Builder();
  var marker = $m_sr_Statics$PFMarker$();
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    var v = $n(pf).applyOrElse__O__F1__O(elem, new $c_sjsr_AnonFunction1(((marker) => ((x$2) => marker))(marker)));
    if ((marker !== v)) {
      var this$3 = $n(b);
      this$3.addOne__O__scm_Growable(v);
    }
  }
  return $n(b).result__O();
}
function $f_sc_StrictOptimizedIterableOps__flatten__F1__O($thiz, toIterableOnce) {
  var b = $n($thiz.iterableFactory__sc_IterableFactory()).newBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var this$1 = $n(b);
    var xs = $as_sc_IterableOnce($n(toIterableOnce).apply__O__O($n(it).next__O()));
    this$1.addAll__sc_IterableOnce__scm_Growable(xs);
  }
  return $n(b).result__O();
}
function $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O($thiz, that) {
  var b = $n($thiz.iterableFactory__sc_IterableFactory()).newBuilder__scm_Builder();
  var it1 = $thiz.iterator__sc_Iterator();
  var it2 = $n(that).iterator__sc_Iterator();
  while (($n(it1).hasNext__Z() && $n(it2).hasNext__Z())) {
    var this$1 = $n(b);
    var elem = new $c_T2($n(it1).next__O(), $n(it2).next__O());
    this$1.addOne__O__scm_Growable(elem);
  }
  return $n(b).result__O();
}
function $f_sc_StrictOptimizedIterableOps__zipWithIndex__O($thiz) {
  var b = $n($thiz.iterableFactory__sc_IterableFactory()).newBuilder__scm_Builder();
  var i = 0;
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var this$1 = $n(b);
    var elem = new $c_T2($n(it).next__O(), i);
    this$1.addOne__O__scm_Growable(elem);
    i = ((1 + i) | 0);
  }
  return $n(b).result__O();
}
function $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O($thiz, pred, isFlipped) {
  var b = $thiz.newSpecificBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    if (($uZ($n(pred).apply__O__O(elem)) !== isFlipped)) {
      var this$1 = $n(b);
      this$1.addOne__O__scm_Growable(elem);
    }
  }
  return $n(b).result__O();
}
function $f_sc_StrictOptimizedIterableOps__dropRight__I__O($thiz, n) {
  var b = $thiz.newSpecificBuilder__scm_Builder();
  if ((n >= 0)) {
    var this$1 = $n(b);
    var delta = ((-n) | 0);
    $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(this$1, $thiz, delta);
  }
  var lead = $n($thiz.iterator__sc_Iterator()).drop__I__sc_Iterator(n);
  var it = $thiz.iterator__sc_Iterator();
  while ($n(lead).hasNext__Z()) {
    var this$2 = $n(b);
    var elem = $n(it).next__O();
    this$2.addOne__O__scm_Growable(elem);
    $n(lead).next__O();
  }
  return $n(b).result__O();
}
function $is_sc_StrictOptimizedIterableOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_StrictOptimizedIterableOps)));
}
function $as_sc_StrictOptimizedIterableOps(obj) {
  return (($is_sc_StrictOptimizedIterableOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.StrictOptimizedIterableOps"));
}
function $isArrayOf_sc_StrictOptimizedIterableOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_StrictOptimizedIterableOps)));
}
function $asArrayOf_sc_StrictOptimizedIterableOps(obj, depth) {
  return (($isArrayOf_sc_StrictOptimizedIterableOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.StrictOptimizedIterableOps;", depth));
}
/** @constructor */
function $c_sci_BitSet$() {
  this.sci_BitSet$__f_empty = null;
  $n_sci_BitSet$ = this;
  this.sci_BitSet$__f_empty = new $c_sci_BitSet$BitSet1($L0);
}
$c_sci_BitSet$.prototype = new $h_O();
$c_sci_BitSet$.prototype.constructor = $c_sci_BitSet$;
/** @constructor */
function $h_sci_BitSet$() {
}
$h_sci_BitSet$.prototype = $c_sci_BitSet$.prototype;
$c_sci_BitSet$.prototype.fromSpecific__sc_IterableOnce__sci_BitSet = (function(it) {
  if ((it instanceof $c_sci_BitSet)) {
    var x2 = $as_sci_BitSet(it);
    return x2;
  } else {
    var this$1 = $n(this.newBuilder__scm_Builder());
    return $as_sci_BitSet($n($as_scm_Builder(this$1.addAll__sc_IterableOnce__scm_Growable(it))).result__O());
  }
});
$c_sci_BitSet$.prototype.newBuilder__scm_Builder = (function() {
  var this$3 = $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_BitSet__(new $c_scm_BitSet()));
  var f = new $c_sjsr_AnonFunction1(((bs$2) => {
    var bs = $as_scm_BitSet(bs$2);
    return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet($n(bs).scm_BitSet__f_elems);
  }));
  return new $c_scm_Builder$$anon$1(this$3, f);
});
$c_sci_BitSet$.prototype.scala$collection$immutable$BitSet$$createSmall__J__J__sci_BitSet = (function(a, b) {
  return (((b.RTLong__f_lo === 0) && (b.RTLong__f_hi === 0)) ? new $c_sci_BitSet$BitSet1(a) : new $c_sci_BitSet$BitSet2(a, b));
});
$c_sci_BitSet$.prototype.fromBitMaskNoCopy__AJ__sci_BitSet = (function(elems) {
  var len = $n(elems).u.length;
  return ((len === 0) ? this.sci_BitSet$__f_empty : ((len === 1) ? new $c_sci_BitSet$BitSet1($n(elems).get(0)) : ((len === 2) ? this.scala$collection$immutable$BitSet$$createSmall__J__J__sci_BitSet($n(elems).get(0), $n(elems).get(1)) : new $c_sci_BitSet$BitSetN(elems))));
});
var $d_sci_BitSet$ = new $TypeData().initClass($c_sci_BitSet$, "scala.collection.immutable.BitSet$", ({
  sci_BitSet$: 1,
  sc_SpecificIterableFactory: 1,
  sc_Factory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_BitSet$;
function $m_sci_BitSet$() {
  if ((!$n_sci_BitSet$)) {
    $n_sci_BitSet$ = new $c_sci_BitSet$();
  }
  return $n_sci_BitSet$;
}
/** @constructor */
function $c_sci_HashMap$accum$1(outer) {
  this.sci_HashMap$accum$1__f_changed = false;
  this.sci_HashMap$accum$1__f_shallowlyMutableNodeMap = 0;
  this.sci_HashMap$accum$1__f_current = null;
  this.sci_HashMap$accum$1__f_$outer = null;
  $n(outer);
  this.sci_HashMap$accum$1__f_$outer = outer;
  this.sci_HashMap$accum$1__f_changed = false;
  this.sci_HashMap$accum$1__f_shallowlyMutableNodeMap = 0;
  this.sci_HashMap$accum$1__f_current = $n(outer).sci_HashMap__f_rootNode;
}
$c_sci_HashMap$accum$1.prototype = new $h_sr_AbstractFunction2();
$c_sci_HashMap$accum$1.prototype.constructor = $c_sci_HashMap$accum$1;
/** @constructor */
function $h_sci_HashMap$accum$1() {
}
$h_sci_HashMap$accum$1.prototype = $c_sci_HashMap$accum$1.prototype;
$c_sci_HashMap$accum$1.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  var kv = $as_T2(v1);
  this.apply__O__O__V($n(kv)._1__O(), $n(kv)._2__O());
  return $uZ((void 0));
});
$c_sci_HashMap$accum$1.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sci_HashMap$accum$1.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_sci_HashMap$accum$1.prototype.toString__T = (function() {
  return "<function1>";
});
$c_sci_HashMap$accum$1.prototype.apply__O__O__V = (function(key, value) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var improved = $m_sc_Hashing$().improve__I__I(originalHash);
  if ((!this.sci_HashMap$accum$1__f_changed)) {
    this.sci_HashMap$accum$1__f_current = $n(this.sci_HashMap$accum$1__f_current).updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(key, value, originalHash, improved, 0, true);
    if ((this.sci_HashMap$accum$1__f_current !== $n(this.sci_HashMap$accum$1__f_$outer).sci_HashMap__f_rootNode)) {
      this.sci_HashMap$accum$1__f_changed = true;
      this.sci_HashMap$accum$1__f_shallowlyMutableNodeMap = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(improved, 0));
    }
  } else {
    this.sci_HashMap$accum$1__f_shallowlyMutableNodeMap = $n(this.sci_HashMap$accum$1__f_current).updateWithShallowMutations__O__O__I__I__I__I__I(key, value, originalHash, improved, 0, this.sci_HashMap$accum$1__f_shallowlyMutableNodeMap);
  }
});
$c_sci_HashMap$accum$1.prototype.apply__O__O__O = (function(v1, v2) {
  this.apply__O__O__V(v1, v2);
});
$c_sci_HashMap$accum$1.prototype.apply__O__O = (function(v1) {
  var kv = $as_T2(v1);
  this.apply__O__O__V($n(kv)._1__O(), $n(kv)._2__O());
});
var $d_sci_HashMap$accum$1 = new $TypeData().initClass($c_sci_HashMap$accum$1, "scala.collection.immutable.HashMap$accum$1", ({
  sci_HashMap$accum$1: 1,
  sr_AbstractFunction2: 1,
  F2: 1,
  F1: 1
}));
/** @constructor */
function $c_sci_Iterable$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_sci_List$());
}
$c_sci_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$c_sci_Iterable$.prototype.constructor = $c_sci_Iterable$;
/** @constructor */
function $h_sci_Iterable$() {
}
$h_sci_Iterable$.prototype = $c_sci_Iterable$.prototype;
$c_sci_Iterable$.prototype.from__sc_IterableOnce__sci_Iterable = (function(it) {
  if ($is_sci_Iterable(it)) {
    var x2 = $as_sci_Iterable(it);
    return x2;
  } else {
    return $as_sci_Iterable($c_sc_IterableFactory$Delegate.prototype.from__sc_IterableOnce__O.call(this, it));
  }
});
$c_sci_Iterable$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__sci_Iterable(it);
});
var $d_sci_Iterable$ = new $TypeData().initClass($c_sci_Iterable$, "scala.collection.immutable.Iterable$", ({
  sci_Iterable$: 1,
  sc_IterableFactory$Delegate: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_Iterable$;
function $m_sci_Iterable$() {
  if ((!$n_sci_Iterable$)) {
    $n_sci_Iterable$ = new $c_sci_Iterable$();
  }
  return $n_sci_Iterable$;
}
/** @constructor */
function $c_sci_LazyList$() {
  this.sci_LazyList$__f__empty = null;
  this.sci_LazyList$__f_scala$collection$immutable$LazyList$$anyToMarker = null;
  $n_sci_LazyList$ = this;
  var state = new $c_sjsr_AnonFunction0((() => $m_sci_LazyList$State$Empty$()));
  this.sci_LazyList$__f__empty = new $c_sci_LazyList(state).force__sci_LazyList();
  this.sci_LazyList$__f_scala$collection$immutable$LazyList$$anyToMarker = new $c_sjsr_AnonFunction1(((x$10$2) => $m_sr_Statics$PFMarker$()));
}
$c_sci_LazyList$.prototype = new $h_O();
$c_sci_LazyList$.prototype.constructor = $c_sci_LazyList$;
/** @constructor */
function $h_sci_LazyList$() {
}
$h_sci_LazyList$.prototype = $c_sci_LazyList$.prototype;
$c_sci_LazyList$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_LazyList(elems);
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$filterImpl__sci_LazyList__F1__Z__sci_LazyList = (function(ll, p, isFlipped) {
  var restRef = new $c_sr_ObjectRef(ll);
  var state = new $c_sjsr_AnonFunction0((() => {
    var elem = null;
    var found = false;
    var rest = $as_sci_LazyList(restRef.sr_ObjectRef__f_elem);
    while (((!found) && (!$n(rest).isEmpty__Z()))) {
      var this$3 = $n(rest);
      elem = $n(this$3.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
      found = ($uZ($n(p).apply__O__O(elem)) !== isFlipped);
      var this$4 = $n(rest);
      rest = $n(this$4.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
      restRef.sr_ObjectRef__f_elem = rest;
    }
    if (found) {
      $m_sci_LazyList$();
      var hd = elem;
      var tl = $m_sci_LazyList$().scala$collection$immutable$LazyList$$filterImpl__sci_LazyList__F1__Z__sci_LazyList(rest, p, isFlipped);
      return new $c_sci_LazyList$State$Cons(hd, tl);
    } else {
      return $m_sci_LazyList$State$Empty$();
    }
  }));
  return new $c_sci_LazyList(state);
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$collectImpl__sci_LazyList__s_PartialFunction__sci_LazyList = (function(ll, pf) {
  var restRef = new $c_sr_ObjectRef(ll);
  var state = new $c_sjsr_AnonFunction0((() => {
    var marker = $m_sr_Statics$PFMarker$();
    var toMarker = $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$anyToMarker;
    var res = marker;
    var rest = $as_sci_LazyList(restRef.sr_ObjectRef__f_elem);
    while (((res === marker) && (!$n(rest).isEmpty__Z()))) {
      var $x_1 = $n(pf);
      var this$4 = $n(rest);
      res = $n($x_1).applyOrElse__O__F1__O($n(this$4.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O(), toMarker);
      var this$5 = $n(rest);
      rest = $n(this$5.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
      restRef.sr_ObjectRef__f_elem = rest;
    }
    if ((res === marker)) {
      return $m_sci_LazyList$State$Empty$();
    } else {
      $m_sci_LazyList$();
      var hd = res;
      var tl = $m_sci_LazyList$().scala$collection$immutable$LazyList$$collectImpl__sci_LazyList__s_PartialFunction__sci_LazyList(rest, pf);
      return new $c_sci_LazyList$State$Cons(hd, tl);
    }
  }));
  return new $c_sci_LazyList(state);
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$flatMapImpl__sci_LazyList__F1__sci_LazyList = (function(ll, f) {
  var restRef = new $c_sr_ObjectRef(ll);
  var state$1 = new $c_sjsr_AnonFunction0((() => {
    var it = new $c_sr_ObjectRef(null);
    var itHasNext = false;
    var elem = $as_sci_LazyList(restRef.sr_ObjectRef__f_elem);
    var rest = new $c_sr_ObjectRef(elem);
    while (((!itHasNext) && (!$n($as_sci_LazyList(rest.sr_ObjectRef__f_elem)).isEmpty__Z()))) {
      var this$5 = $n($as_sci_LazyList(rest.sr_ObjectRef__f_elem));
      it.sr_ObjectRef__f_elem = $n($as_sc_IterableOnce($n(f).apply__O__O($n(this$5.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O()))).iterator__sc_Iterator();
      itHasNext = $n($as_sc_Iterator(it.sr_ObjectRef__f_elem)).hasNext__Z();
      if ((!itHasNext)) {
        var this$6 = $n($as_sci_LazyList(rest.sr_ObjectRef__f_elem));
        rest.sr_ObjectRef__f_elem = $n(this$6.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
        restRef.sr_ObjectRef__f_elem = $as_sci_LazyList(rest.sr_ObjectRef__f_elem);
      }
    }
    if (itHasNext) {
      var head = $n($as_sc_Iterator(it.sr_ObjectRef__f_elem)).next__O();
      var this$7 = $n($as_sci_LazyList(rest.sr_ObjectRef__f_elem));
      rest.sr_ObjectRef__f_elem = $n(this$7.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
      restRef.sr_ObjectRef__f_elem = $as_sci_LazyList(rest.sr_ObjectRef__f_elem);
      $m_sci_LazyList$();
      $m_sci_LazyList$();
      var state = new $c_sjsr_AnonFunction0((() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIteratorConcatSuffix__sc_Iterator__F0__sci_LazyList$State($as_sc_Iterator(it.sr_ObjectRef__f_elem), new $c_sjsr_AnonFunction0((() => $n($m_sci_LazyList$().scala$collection$immutable$LazyList$$flatMapImpl__sci_LazyList__F1__sci_LazyList($as_sci_LazyList(rest.sr_ObjectRef__f_elem), f)).scala$collection$immutable$LazyList$$state__sci_LazyList$State())))));
      var tl = new $c_sci_LazyList(state);
      return new $c_sci_LazyList$State$Cons(head, tl);
    } else {
      return $m_sci_LazyList$State$Empty$();
    }
  }));
  return new $c_sci_LazyList(state$1);
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$dropImpl__sci_LazyList__I__sci_LazyList = (function(ll, n) {
  var restRef = new $c_sr_ObjectRef(ll);
  var iRef = new $c_sr_IntRef(n);
  var state = new $c_sjsr_AnonFunction0((() => {
    var rest = $as_sci_LazyList(restRef.sr_ObjectRef__f_elem);
    var i = iRef.sr_IntRef__f_elem;
    while (((i > 0) && (!$n(rest).isEmpty__Z()))) {
      var this$4 = $n(rest);
      rest = $n(this$4.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
      restRef.sr_ObjectRef__f_elem = rest;
      i = (((-1) + i) | 0);
      iRef.sr_IntRef__f_elem = i;
    }
    return $n(rest).scala$collection$immutable$LazyList$$state__sci_LazyList$State();
  }));
  return new $c_sci_LazyList(state);
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$dropWhileImpl__sci_LazyList__F1__sci_LazyList = (function(ll, p) {
  var restRef = new $c_sr_ObjectRef(ll);
  var state = new $c_sjsr_AnonFunction0((() => {
    var rest = $as_sci_LazyList(restRef.sr_ObjectRef__f_elem);
    while (true) {
      if ((!$n(rest).isEmpty__Z())) {
        var this$3 = $n(rest);
        var $x_1 = $uZ($n(p).apply__O__O($n(this$3.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O()));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var this$4 = $n(rest);
        rest = $n(this$4.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
        restRef.sr_ObjectRef__f_elem = rest;
      } else {
        break;
      }
    }
    return $n(rest).scala$collection$immutable$LazyList$$state__sci_LazyList$State();
  }));
  return new $c_sci_LazyList(state);
});
$c_sci_LazyList$.prototype.from__sc_IterableOnce__sci_LazyList = (function(coll) {
  if ((coll instanceof $c_sci_LazyList)) {
    var x2 = $as_sci_LazyList(coll);
    return x2;
  } else if (($n(coll).knownSize__I() === 0)) {
    return this.sci_LazyList$__f__empty;
  } else {
    var state = new $c_sjsr_AnonFunction0((() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIterator__sc_Iterator__sci_LazyList$State($n(coll).iterator__sc_Iterator())));
    return new $c_sci_LazyList(state);
  }
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$stateFromIteratorConcatSuffix__sc_Iterator__F0__sci_LazyList$State = (function(it, suffix) {
  if ($n(it).hasNext__Z()) {
    var hd = $n(it).next__O();
    var state = new $c_sjsr_AnonFunction0((() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIteratorConcatSuffix__sc_Iterator__F0__sci_LazyList$State(it, suffix)));
    var tl = new $c_sci_LazyList(state);
    return new $c_sci_LazyList$State$Cons(hd, tl);
  } else {
    return $as_sci_LazyList$State($n(suffix).apply__O());
  }
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$stateFromIterator__sc_Iterator__sci_LazyList$State = (function(it) {
  if ($n(it).hasNext__Z()) {
    var hd = $n(it).next__O();
    var state = new $c_sjsr_AnonFunction0((() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIterator__sc_Iterator__sci_LazyList$State(it)));
    var tl = new $c_sci_LazyList(state);
    return new $c_sci_LazyList$State$Cons(hd, tl);
  } else {
    return $m_sci_LazyList$State$Empty$();
  }
});
$c_sci_LazyList$.prototype.from__I__I__sci_LazyList = (function(start, step) {
  var state = new $c_sjsr_AnonFunction0((() => {
    $m_sci_LazyList$();
    var tl = $m_sci_LazyList$().from__I__I__sci_LazyList(((start + step) | 0), step);
    return new $c_sci_LazyList$State$Cons(start, tl);
  }));
  return new $c_sci_LazyList(state);
});
$c_sci_LazyList$.prototype.fill__I__F0__sci_LazyList = (function(n, elem) {
  if ((n > 0)) {
    var state = new $c_sjsr_AnonFunction0((() => {
      $m_sci_LazyList$();
      var hd = $n(elem).apply__O();
      var tl = $m_sci_LazyList$().fill__I__F0__sci_LazyList((((-1) + n) | 0), elem);
      return new $c_sci_LazyList$State$Cons(hd, tl);
    }));
    return new $c_sci_LazyList(state);
  } else {
    return this.sci_LazyList$__f__empty;
  }
});
$c_sci_LazyList$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_LazyList$LazyBuilder();
});
$c_sci_LazyList$.prototype.empty__O = (function() {
  return this.sci_LazyList$__f__empty;
});
$c_sci_LazyList$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_LazyList(source);
});
var $d_sci_LazyList$ = new $TypeData().initClass($c_sci_LazyList$, "scala.collection.immutable.LazyList$", ({
  sci_LazyList$: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_LazyList$;
function $m_sci_LazyList$() {
  if ((!$n_sci_LazyList$)) {
    $n_sci_LazyList$ = new $c_sci_LazyList$();
  }
  return $n_sci_LazyList$;
}
/** @constructor */
function $c_sci_Stream$() {
}
$c_sci_Stream$.prototype = new $h_O();
$c_sci_Stream$.prototype.constructor = $c_sci_Stream$;
/** @constructor */
function $h_sci_Stream$() {
}
$h_sci_Stream$.prototype = $c_sci_Stream$.prototype;
$c_sci_Stream$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_Stream(elems);
});
$c_sci_Stream$.prototype.from__sc_IterableOnce__sci_Stream = (function(coll) {
  if ((coll instanceof $c_sci_Stream)) {
    var x2 = $as_sci_Stream(coll);
    return x2;
  } else {
    return this.fromIterator__sc_Iterator__sci_Stream($n(coll).iterator__sc_Iterator());
  }
});
$c_sci_Stream$.prototype.fromIterator__sc_Iterator__sci_Stream = (function(it) {
  return ($n(it).hasNext__Z() ? new $c_sci_Stream$Cons($n(it).next__O(), new $c_sjsr_AnonFunction0((() => $m_sci_Stream$().fromIterator__sc_Iterator__sci_Stream(it)))) : $m_sci_Stream$Empty$());
});
$c_sci_Stream$.prototype.newBuilder__scm_Builder = (function() {
  $m_scm_ArrayBuffer$();
  var this$3 = new $c_scm_ArrayBuffer$$anon$1();
  var f = new $c_sjsr_AnonFunction1(((array$2) => {
    var array = $as_scm_ArrayBuffer(array$2);
    return $m_sci_Stream$().from__sc_IterableOnce__sci_Stream(array);
  }));
  return new $c_scm_Builder$$anon$1(this$3, f);
});
$c_sci_Stream$.prototype.filteredTail__sci_Stream__F1__Z__sci_Stream = (function(stream, p, isFlipped) {
  var hd = $n(stream).head__O();
  var tl = new $c_sjsr_AnonFunction0((() => $n($as_sci_Stream($n(stream).tail__O())).filterImpl__F1__Z__sci_Stream(p, isFlipped)));
  return new $c_sci_Stream$Cons(hd, tl);
});
$c_sci_Stream$.prototype.collectedTail__O__sci_Stream__s_PartialFunction__sci_Stream = (function(head, stream, pf) {
  var tl = new $c_sjsr_AnonFunction0((() => $n($as_sci_Stream($n(stream).tail__O())).collect__s_PartialFunction__sci_Stream(pf)));
  return new $c_sci_Stream$Cons(head, tl);
});
$c_sci_Stream$.prototype.empty__O = (function() {
  return $m_sci_Stream$Empty$();
});
$c_sci_Stream$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Stream(source);
});
var $d_sci_Stream$ = new $TypeData().initClass($c_sci_Stream$, "scala.collection.immutable.Stream$", ({
  sci_Stream$: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_Stream$;
function $m_sci_Stream$() {
  if ((!$n_sci_Stream$)) {
    $n_sci_Stream$ = new $c_sci_Stream$();
  }
  return $n_sci_Stream$;
}
/** @constructor */
function $c_sci_TreeSeqMap$Builder(orderedBy) {
  this.sci_TreeSeqMap$Builder__f_orderedBy = null;
  this.sci_TreeSeqMap$Builder__f_bdr = null;
  this.sci_TreeSeqMap$Builder__f_ong = null;
  this.sci_TreeSeqMap$Builder__f_ord = 0;
  this.sci_TreeSeqMap$Builder__f_aliased = null;
  this.sci_TreeSeqMap$Builder__f_orderedBy = orderedBy;
  this.sci_TreeSeqMap$Builder__f_bdr = new $c_sci_MapBuilderImpl();
  this.sci_TreeSeqMap$Builder__f_ong = $m_sci_TreeSeqMap$Ordering$Zero$();
  this.sci_TreeSeqMap$Builder__f_ord = 0;
}
$c_sci_TreeSeqMap$Builder.prototype = new $h_O();
$c_sci_TreeSeqMap$Builder.prototype.constructor = $c_sci_TreeSeqMap$Builder;
/** @constructor */
function $h_sci_TreeSeqMap$Builder() {
}
$h_sci_TreeSeqMap$Builder.prototype = $c_sci_TreeSeqMap$Builder.prototype;
$c_sci_TreeSeqMap$Builder.prototype.sizeHint__I__V = (function(size) {
});
$c_sci_TreeSeqMap$Builder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$c_sci_TreeSeqMap$Builder.prototype.addOne__O__O__sci_TreeSeqMap$Builder = (function(key, value) {
  if ((this.sci_TreeSeqMap$Builder__f_aliased !== null)) {
    this.sci_TreeSeqMap$Builder__f_aliased = $n(this.sci_TreeSeqMap$Builder__f_aliased).updated__O__O__sci_TreeSeqMap(key, value);
  } else {
    var x1 = $as_T2($n(this.sci_TreeSeqMap$Builder__f_bdr).getOrElse__O__O__O(key, null));
    if ((x1 !== null)) {
      var o = $n(x1)._1$mcI$sp__I();
      var v = $n(x1)._2__O();
      var x = this.sci_TreeSeqMap$Builder__f_orderedBy;
      var x$2 = $m_sci_TreeSeqMap$OrderBy$Insertion$();
      if ((x !== null)) {
        var this$1 = $n(x);
        var $x_1 = (this$1 === x$2);
      } else {
        var $x_1 = false;
      }
      if (($x_1 && (!$m_sr_BoxesRunTime$().equals__O__O__Z(v, value)))) {
        $n(this.sci_TreeSeqMap$Builder__f_bdr).addOne__O__O__sci_MapBuilderImpl(key, new $c_T2(o, value));
      } else {
        var x$3 = this.sci_TreeSeqMap$Builder__f_orderedBy;
        var x$4 = $m_sci_TreeSeqMap$OrderBy$Modification$();
        if ((x$3 !== null)) {
          var this$2 = $n(x$3);
          var $x_2 = (this$2 === x$4);
        } else {
          var $x_2 = false;
        }
        if ($x_2) {
          $n(this.sci_TreeSeqMap$Builder__f_bdr).addOne__O__O__sci_MapBuilderImpl(key, new $c_T2(this.sci_TreeSeqMap$Builder__f_ord, value));
          var this$3 = $n($n(this.sci_TreeSeqMap$Builder__f_ong).exclude__I__sci_TreeSeqMap$Ordering(o));
          var ordinal = this.sci_TreeSeqMap$Builder__f_ord;
          this.sci_TreeSeqMap$Builder__f_ong = this$3.appendInPlace1__sci_TreeSeqMap$Ordering$Bin__I__O__sci_TreeSeqMap$Ordering(null, ordinal, key);
          $m_sci_TreeSeqMap$();
          var ord = this.sci_TreeSeqMap$Builder__f_ord;
          this.sci_TreeSeqMap$Builder__f_ord = ((ord === 2147483647) ? (-2147483648) : ((1 + ord) | 0));
        }
      }
    } else if ((x1 === null)) {
      $n(this.sci_TreeSeqMap$Builder__f_bdr).addOne__O__O__sci_MapBuilderImpl(key, new $c_T2(this.sci_TreeSeqMap$Builder__f_ord, value));
      var this$5 = $n(this.sci_TreeSeqMap$Builder__f_ong);
      var ordinal$1 = this.sci_TreeSeqMap$Builder__f_ord;
      this.sci_TreeSeqMap$Builder__f_ong = this$5.appendInPlace1__sci_TreeSeqMap$Ordering$Bin__I__O__sci_TreeSeqMap$Ordering(null, ordinal$1, key);
      $m_sci_TreeSeqMap$();
      var ord$1 = this.sci_TreeSeqMap$Builder__f_ord;
      this.sci_TreeSeqMap$Builder__f_ord = ((ord$1 === 2147483647) ? (-2147483648) : ((1 + ord$1) | 0));
    } else {
      throw new $c_s_MatchError(x1);
    }
  }
  return this;
});
$c_sci_TreeSeqMap$Builder.prototype.result__sci_TreeSeqMap = (function() {
  if ((this.sci_TreeSeqMap$Builder__f_aliased === null)) {
    this.sci_TreeSeqMap$Builder__f_aliased = new $c_sci_TreeSeqMap(this.sci_TreeSeqMap$Builder__f_ong, $n(this.sci_TreeSeqMap$Builder__f_bdr).result__sci_Map(), this.sci_TreeSeqMap$Builder__f_ord, this.sci_TreeSeqMap$Builder__f_orderedBy);
  }
  return this.sci_TreeSeqMap$Builder__f_aliased;
});
$c_sci_TreeSeqMap$Builder.prototype.result__O = (function() {
  return this.result__sci_TreeSeqMap();
});
$c_sci_TreeSeqMap$Builder.prototype.addOne__O__scm_Growable = (function(elem) {
  var elem$1 = $as_T2(elem);
  return this.addOne__O__O__sci_TreeSeqMap$Builder($n(elem$1)._1__O(), $n(elem$1)._2__O());
});
var $d_sci_TreeSeqMap$Builder = new $TypeData().initClass($c_sci_TreeSeqMap$Builder, "scala.collection.immutable.TreeSeqMap$Builder", ({
  sci_TreeSeqMap$Builder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
/** @constructor */
function $c_sci_TreeSet$() {
}
$c_sci_TreeSet$.prototype = new $h_O();
$c_sci_TreeSet$.prototype.constructor = $c_sci_TreeSet$;
/** @constructor */
function $h_sci_TreeSet$() {
}
$h_sci_TreeSet$.prototype = $c_sci_TreeSet$.prototype;
$c_sci_TreeSet$.prototype.apply__sci_Seq__O__O = (function(xs, evidence$7) {
  return this.from__sc_IterableOnce__s_math_Ordering__sci_TreeSet(xs, $as_s_math_Ordering(evidence$7));
});
$c_sci_TreeSet$.prototype.from__sc_IterableOnce__s_math_Ordering__sci_TreeSet = (function(it, ordering) {
  if ((it instanceof $c_sci_TreeSet)) {
    var x2 = $as_sci_TreeSet(it);
    var x$2 = $n(x2).sci_TreeSet__f_ordering;
    if (((ordering === null) ? (x$2 === null) : $n(ordering).equals__O__Z(x$2))) {
      return x2;
    }
  }
  if ($is_sc_SortedSet(it)) {
    var x3 = $as_sc_SortedSet(it);
    var x$4 = $n(x3).ordering__s_math_Ordering();
    if (((ordering === null) ? (x$4 === null) : $n(ordering).equals__O__Z(x$4))) {
      return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), $m_sci_RedBlackTree$().fromOrderedKeys__sc_Iterator__I__sci_RedBlackTree$Tree($n(x3).iterator__sc_Iterator(), $n(x3).size__I()), ordering);
    }
  }
  if (false) {
    var x4 = $as_sci_Range(it);
    if ((ordering === $m_s_math_Ordering$Int$())) {
      var $x_1 = true;
    } else {
      var this$1 = $m_s_math_Ordering$Int$();
      var $x_1 = $f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z(this$1, ordering);
    }
    if ($x_1) {
      if (((ordering === $m_s_math_Ordering$Int$()) === ($n(x4).sci_Range__f_step > 0))) {
        var it$2 = $n(x4).iterator__sc_Iterator();
      } else {
        var this$2 = $n(x4);
        var this$3 = new $c_sc_IndexedSeqView$Id(this$2);
        var it$2 = $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$3);
      }
      var $x_2 = $m_sci_RedBlackTree$();
      var this$4 = $n(x4);
      var tree = $n($x_2).fromOrderedKeys__sc_Iterator__I__sci_RedBlackTree$Tree(it$2, this$4.length__I());
      return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), tree, ordering);
    }
  }
  var t = null;
  var i = $n(it).iterator__sc_Iterator();
  while ($n(i).hasNext__Z()) {
    t = $m_sci_RedBlackTree$().update__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree(t, $n(i).next__O(), null, false, ordering);
  }
  return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), t, ordering);
});
$c_sci_TreeSet$.prototype.newBuilder__O__scm_Builder = (function(evidence$12) {
  var ordering = $as_s_math_Ordering(evidence$12);
  return new $c_sci_TreeSet$TreeSetBuilder(ordering);
});
var $d_sci_TreeSet$ = new $TypeData().initClass($c_sci_TreeSet$, "scala.collection.immutable.TreeSet$", ({
  sci_TreeSet$: 1,
  sc_SortedIterableFactory: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_TreeSet$;
function $m_sci_TreeSet$() {
  if ((!$n_sci_TreeSet$)) {
    $n_sci_TreeSet$ = new $c_sci_TreeSet$();
  }
  return $n_sci_TreeSet$;
}
/** @constructor */
function $c_sci_WrappedString$() {
  this.sci_WrappedString$__f_empty = null;
  $n_sci_WrappedString$ = this;
  this.sci_WrappedString$__f_empty = new $c_sci_WrappedString("");
}
$c_sci_WrappedString$.prototype = new $h_O();
$c_sci_WrappedString$.prototype.constructor = $c_sci_WrappedString$;
/** @constructor */
function $h_sci_WrappedString$() {
}
$h_sci_WrappedString$.prototype = $c_sci_WrappedString$.prototype;
$c_sci_WrappedString$.prototype.fromSpecific__sc_IterableOnce__sci_WrappedString = (function(it) {
  var b = this.newBuilder__scm_Builder();
  var this$2 = $n(b);
  $n(b);
  var delta = 0;
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(this$2, it, delta);
  var this$3 = $n(b);
  this$3.addAll__sc_IterableOnce__scm_Growable(it);
  return $as_sci_WrappedString($n(b).result__O());
});
$c_sci_WrappedString$.prototype.newBuilder__scm_Builder = (function() {
  var this$2 = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var f = new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_T(x$2);
    return new $c_sci_WrappedString(x);
  }));
  return new $c_scm_Builder$$anon$1(this$2, f);
});
var $d_sci_WrappedString$ = new $TypeData().initClass($c_sci_WrappedString$, "scala.collection.immutable.WrappedString$", ({
  sci_WrappedString$: 1,
  sc_SpecificIterableFactory: 1,
  sc_Factory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_WrappedString$;
function $m_sci_WrappedString$() {
  if ((!$n_sci_WrappedString$)) {
    $n_sci_WrappedString$ = new $c_sci_WrappedString$();
  }
  return $n_sci_WrappedString$;
}
/** @constructor */
function $c_scm_Builder$$anon$1(outer, f$1) {
  this.scm_Builder$$anon$1__f_$outer = null;
  this.scm_Builder$$anon$1__f_f$1 = null;
  $n(outer);
  this.scm_Builder$$anon$1__f_$outer = outer;
  this.scm_Builder$$anon$1__f_f$1 = f$1;
}
$c_scm_Builder$$anon$1.prototype = new $h_O();
$c_scm_Builder$$anon$1.prototype.constructor = $c_scm_Builder$$anon$1;
/** @constructor */
function $h_scm_Builder$$anon$1() {
}
$h_scm_Builder$$anon$1.prototype = $c_scm_Builder$$anon$1.prototype;
$c_scm_Builder$$anon$1.prototype.addOne__O__scm_Builder$$anon$1 = (function(x) {
  var this$1 = $n(this.scm_Builder$$anon$1__f_$outer);
  this$1.addOne__O__scm_Growable(x);
  return this;
});
$c_scm_Builder$$anon$1.prototype.addAll__sc_IterableOnce__scm_Builder$$anon$1 = (function(xs) {
  var this$1 = $n(this.scm_Builder$$anon$1__f_$outer);
  this$1.addAll__sc_IterableOnce__scm_Growable(xs);
  return this;
});
$c_scm_Builder$$anon$1.prototype.sizeHint__I__V = (function(size) {
  $n(this.scm_Builder$$anon$1__f_$outer).sizeHint__I__V(size);
});
$c_scm_Builder$$anon$1.prototype.result__O = (function() {
  return $n(this.scm_Builder$$anon$1__f_f$1).apply__O__O($n(this.scm_Builder$$anon$1__f_$outer).result__O());
});
$c_scm_Builder$$anon$1.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_Builder$$anon$1(elems);
});
$c_scm_Builder$$anon$1.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_Builder$$anon$1(elem);
});
var $d_scm_Builder$$anon$1 = new $TypeData().initClass($c_scm_Builder$$anon$1, "scala.collection.mutable.Builder$$anon$1", ({
  scm_Builder$$anon$1: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
function $ct_scm_GrowableBuilder__scm_Growable__($thiz, elems) {
  $thiz.scm_GrowableBuilder__f_elems = elems;
  return $thiz;
}
/** @constructor */
function $c_scm_GrowableBuilder() {
  this.scm_GrowableBuilder__f_elems = null;
}
$c_scm_GrowableBuilder.prototype = new $h_O();
$c_scm_GrowableBuilder.prototype.constructor = $c_scm_GrowableBuilder;
/** @constructor */
function $h_scm_GrowableBuilder() {
}
$h_scm_GrowableBuilder.prototype = $c_scm_GrowableBuilder.prototype;
$c_scm_GrowableBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_scm_GrowableBuilder.prototype.addOne__O__scm_GrowableBuilder = (function(elem) {
  var this$1 = $n(this.scm_GrowableBuilder__f_elems);
  this$1.addOne__O__scm_Growable(elem);
  return this;
});
$c_scm_GrowableBuilder.prototype.addAll__sc_IterableOnce__scm_GrowableBuilder = (function(xs) {
  $n(this.scm_GrowableBuilder__f_elems).addAll__sc_IterableOnce__scm_Growable(xs);
  return this;
});
$c_scm_GrowableBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_GrowableBuilder(elems);
});
$c_scm_GrowableBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_GrowableBuilder(elem);
});
$c_scm_GrowableBuilder.prototype.result__O = (function() {
  return this.scm_GrowableBuilder__f_elems;
});
var $d_scm_GrowableBuilder = new $TypeData().initClass($c_scm_GrowableBuilder, "scala.collection.mutable.GrowableBuilder", ({
  scm_GrowableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
/** @constructor */
function $c_scm_Iterable$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_scm_ArrayBuffer$());
}
$c_scm_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$c_scm_Iterable$.prototype.constructor = $c_scm_Iterable$;
/** @constructor */
function $h_scm_Iterable$() {
}
$h_scm_Iterable$.prototype = $c_scm_Iterable$.prototype;
var $d_scm_Iterable$ = new $TypeData().initClass($c_scm_Iterable$, "scala.collection.mutable.Iterable$", ({
  scm_Iterable$: 1,
  sc_IterableFactory$Delegate: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_scm_Iterable$;
function $m_scm_Iterable$() {
  if ((!$n_scm_Iterable$)) {
    $n_scm_Iterable$ = new $c_scm_Iterable$();
  }
  return $n_scm_Iterable$;
}
/** @constructor */
function $c_scm_Map$() {
  this.sc_MapFactory$Delegate__f_delegate = null;
  $ct_sc_MapFactory$Delegate__sc_MapFactory__(this, $m_scm_HashMap$());
}
$c_scm_Map$.prototype = new $h_sc_MapFactory$Delegate();
$c_scm_Map$.prototype.constructor = $c_scm_Map$;
/** @constructor */
function $h_scm_Map$() {
}
$h_scm_Map$.prototype = $c_scm_Map$.prototype;
var $d_scm_Map$ = new $TypeData().initClass($c_scm_Map$, "scala.collection.mutable.Map$", ({
  scm_Map$: 1,
  sc_MapFactory$Delegate: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_scm_Map$;
function $m_scm_Map$() {
  if ((!$n_scm_Map$)) {
    $n_scm_Map$ = new $c_scm_Map$();
  }
  return $n_scm_Map$;
}
/** @constructor */
function $c_scm_Set$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_scm_HashSet$());
}
$c_scm_Set$.prototype = new $h_sc_IterableFactory$Delegate();
$c_scm_Set$.prototype.constructor = $c_scm_Set$;
/** @constructor */
function $h_scm_Set$() {
}
$h_scm_Set$.prototype = $c_scm_Set$.prototype;
var $d_scm_Set$ = new $TypeData().initClass($c_scm_Set$, "scala.collection.mutable.Set$", ({
  scm_Set$: 1,
  sc_IterableFactory$Delegate: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_scm_Set$;
function $m_scm_Set$() {
  if ((!$n_scm_Set$)) {
    $n_scm_Set$ = new $c_scm_Set$();
  }
  return $n_scm_Set$;
}
/** @constructor */
function $c_scm_TreeSet$() {
}
$c_scm_TreeSet$.prototype = new $h_O();
$c_scm_TreeSet$.prototype.constructor = $c_scm_TreeSet$;
/** @constructor */
function $h_scm_TreeSet$() {
}
$h_scm_TreeSet$.prototype = $c_scm_TreeSet$.prototype;
$c_scm_TreeSet$.prototype.apply__sci_Seq__O__O = (function(xs, evidence$7) {
  return this.from__sc_IterableOnce__s_math_Ordering__scm_TreeSet(xs, $as_s_math_Ordering(evidence$7));
});
$c_scm_TreeSet$.prototype.from__sc_IterableOnce__s_math_Ordering__scm_TreeSet = (function(it, ordering) {
  if ((it instanceof $c_scm_TreeSet)) {
    var x2 = $as_scm_TreeSet(it);
    var x$2 = $n(x2).scm_TreeSet__f_ordering;
    if (((ordering === null) ? (x$2 === null) : $n(ordering).equals__O__Z(x$2))) {
      return $ct_scm_TreeSet__scm_RedBlackTree$Tree__s_math_Ordering__(new $c_scm_TreeSet(), $n($n(x2).scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree).treeCopy__scm_RedBlackTree$Tree(), ordering);
    }
  }
  if ($is_sc_SortedSet(it)) {
    var x3 = $as_sc_SortedSet(it);
    var x$4 = $n(x3).ordering__s_math_Ordering();
    if (((ordering === null) ? (x$4 === null) : $n(ordering).equals__O__Z(x$4))) {
      return $ct_scm_TreeSet__scm_RedBlackTree$Tree__s_math_Ordering__(new $c_scm_TreeSet(), $m_scm_RedBlackTree$().fromOrderedKeys__sc_Iterator__I__scm_RedBlackTree$Tree($n(x3).iterator__sc_Iterator(), $n(x3).size__I()), ordering);
    }
  }
  if (false) {
    var x4 = $as_sci_Range(it);
    if ((ordering === $m_s_math_Ordering$Int$())) {
      var $x_1 = true;
    } else {
      var this$1 = $m_s_math_Ordering$Int$();
      var $x_1 = (ordering === this$1.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse);
    }
    if ($x_1) {
      if (((ordering === $m_s_math_Ordering$Int$()) === ($n(x4).sci_Range__f_step > 0))) {
        var it$2 = $n(x4).iterator__sc_Iterator();
      } else {
        var this$2 = $n(x4);
        var this$3 = new $c_sc_IndexedSeqView$Id(this$2);
        var it$2 = $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$3);
      }
      var $x_2 = $m_scm_RedBlackTree$();
      var this$4 = $n(x4);
      return $ct_scm_TreeSet__scm_RedBlackTree$Tree__s_math_Ordering__(new $c_scm_TreeSet(), $n($x_2).fromOrderedKeys__sc_Iterator__I__scm_RedBlackTree$Tree(it$2, this$4.length__I()), ordering);
    }
  }
  var t = new $c_scm_RedBlackTree$Tree(null, 0);
  var i = $n(it).iterator__sc_Iterator();
  while ($n(i).hasNext__Z()) {
    $m_scm_RedBlackTree$().insert__scm_RedBlackTree$Tree__O__O__s_math_Ordering__V(t, $n(i).next__O(), null, ordering);
  }
  return $ct_scm_TreeSet__scm_RedBlackTree$Tree__s_math_Ordering__(new $c_scm_TreeSet(), t, ordering);
});
$c_scm_TreeSet$.prototype.newBuilder__O__scm_Builder = (function(evidence$12) {
  var ordering = $as_s_math_Ordering(evidence$12);
  return new $c_scm_TreeSet$$anon$1(ordering);
});
var $d_scm_TreeSet$ = new $TypeData().initClass($c_scm_TreeSet$, "scala.collection.mutable.TreeSet$", ({
  scm_TreeSet$: 1,
  sc_SortedIterableFactory: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_scm_TreeSet$;
function $m_scm_TreeSet$() {
  if ((!$n_scm_TreeSet$)) {
    $n_scm_TreeSet$ = new $c_scm_TreeSet$();
  }
  return $n_scm_TreeSet$;
}
class $c_s_concurrent_Future$$anon$4 extends $c_jl_Throwable {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  fillInStackTrace__jl_Throwable() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this);
  }
}
var $d_s_concurrent_Future$$anon$4 = new $TypeData().initClass($c_s_concurrent_Future$$anon$4, "scala.concurrent.Future$$anon$4", ({
  s_concurrent_Future$$anon$4: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_util_control_NoStackTrace: 1
}));
/** @constructor */
function $c_s_concurrent_duration_Duration() {
}
$c_s_concurrent_duration_Duration.prototype = new $h_O();
$c_s_concurrent_duration_Duration.prototype.constructor = $c_s_concurrent_duration_Duration;
/** @constructor */
function $h_s_concurrent_duration_Duration() {
}
$h_s_concurrent_duration_Duration.prototype = $c_s_concurrent_duration_Duration.prototype;
$c_s_concurrent_duration_Duration.prototype.compareTo__O__I = (function(that) {
  return this.compare__s_concurrent_duration_Duration__I($as_s_concurrent_duration_Duration(that));
});
$c_s_concurrent_duration_Duration.prototype.max__s_concurrent_duration_Duration__s_concurrent_duration_Duration = (function(other) {
  return ($f_s_math_Ordered__$greater__O__Z(this, other) ? this : other);
});
function $as_s_concurrent_duration_Duration(obj) {
  return (((obj instanceof $c_s_concurrent_duration_Duration) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.Duration"));
}
function $isArrayOf_s_concurrent_duration_Duration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_Duration)));
}
function $asArrayOf_s_concurrent_duration_Duration(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_Duration(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.Duration;", depth));
}
function $f_sr_EnumValue__productElement__I__O($thiz, n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
}
function $as_sr_NonLocalReturnControl(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.runtime.NonLocalReturnControl"));
}
function $isArrayOf_sr_NonLocalReturnControl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sr_NonLocalReturnControl)));
}
function $asArrayOf_sr_NonLocalReturnControl(obj, depth) {
  return (($isArrayOf_sr_NonLocalReturnControl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.runtime.NonLocalReturnControl;", depth));
}
/** @constructor */
function $c_sjs_js_WrappedDictionary$DictionaryIterator(dict) {
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_dict = null;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys = null;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_index = 0;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_dict = dict;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys = Object.keys(dict);
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_index = 0;
}
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype = new $h_O();
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.constructor = $c_sjs_js_WrappedDictionary$DictionaryIterator;
/** @constructor */
function $h_sjs_js_WrappedDictionary$DictionaryIterator() {
}
$h_sjs_js_WrappedDictionary$DictionaryIterator.prototype = $c_sjs_js_WrappedDictionary$DictionaryIterator.prototype;
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.iterator__sc_Iterator = (function() {
  return this;
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z());
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.toString__T = (function() {
  return "<iterator>";
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.knownSize__I = (function() {
  return (-1);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.hasNext__Z = (function() {
  return (this.sjs_js_WrappedDictionary$DictionaryIterator__f_index < $uI(this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys.length));
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.next__T2 = (function() {
  var key = $as_T(this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys[this.sjs_js_WrappedDictionary$DictionaryIterator__f_index]);
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_index = ((1 + this.sjs_js_WrappedDictionary$DictionaryIterator__f_index) | 0);
  var dict = this.sjs_js_WrappedDictionary$DictionaryIterator__f_dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    var $x_1 = dict[key];
  } else {
    var $x_1;
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
  return new $c_T2(key, $x_1);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.next__O = (function() {
  return this.next__T2();
});
var $d_sjs_js_WrappedDictionary$DictionaryIterator = new $TypeData().initClass($c_sjs_js_WrappedDictionary$DictionaryIterator, "scala.scalajs.js.WrappedDictionary$DictionaryIterator", ({
  sjs_js_WrappedDictionary$DictionaryIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder() {
  this.sjs_js_WrappedDictionary$WrappedDictionaryBuilder__f_dict = null;
  this.sjs_js_WrappedDictionary$WrappedDictionaryBuilder__f_dict = ({});
}
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype = new $h_O();
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.constructor = $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder;
/** @constructor */
function $h_sjs_js_WrappedDictionary$WrappedDictionaryBuilder() {
}
$h_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype = $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype;
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.addOne__T2__sjs_js_WrappedDictionary$WrappedDictionaryBuilder = (function(elem) {
  var dict = this.sjs_js_WrappedDictionary$WrappedDictionaryBuilder__f_dict;
  var key = $as_T($n(elem)._1__O());
  var value = $n(elem)._2__O();
  dict[key] = value;
  return this;
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.result__sjs_js_WrappedDictionary = (function() {
  return new $c_sjs_js_WrappedDictionary(this.sjs_js_WrappedDictionary$WrappedDictionaryBuilder__f_dict);
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.result__O = (function() {
  return this.result__sjs_js_WrappedDictionary();
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__sjs_js_WrappedDictionary$WrappedDictionaryBuilder($as_T2(elem));
});
var $d_sjs_js_WrappedDictionary$WrappedDictionaryBuilder = new $TypeData().initClass($c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder, "scala.scalajs.js.WrappedDictionary$WrappedDictionaryBuilder", ({
  sjs_js_WrappedDictionary$WrappedDictionaryBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
/** @constructor */
function $c_s_util_Either() {
}
$c_s_util_Either.prototype = new $h_O();
$c_s_util_Either.prototype.constructor = $c_s_util_Either;
/** @constructor */
function $h_s_util_Either() {
}
$h_s_util_Either.prototype = $c_s_util_Either.prototype;
$c_s_util_Either.prototype.fold__F1__F1__O = (function(fa, fb) {
  if ((this instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this);
    var b = $n(x2).s_util_Right__f_value;
    return $n(fb).apply__O__O(b);
  } else if ((this instanceof $c_s_util_Left)) {
    var x3 = $as_s_util_Left(this);
    var a = $n(x3).s_util_Left__f_value;
    return $n(fa).apply__O__O(a);
  } else {
    throw new $c_s_MatchError(this);
  }
});
$c_s_util_Either.prototype.swap__s_util_Either = (function() {
  if ((this instanceof $c_s_util_Left)) {
    var x2 = $as_s_util_Left(this);
    var a = $n(x2).s_util_Left__f_value;
    return new $c_s_util_Right(a);
  } else if ((this instanceof $c_s_util_Right)) {
    var x3 = $as_s_util_Right(this);
    var b = $n(x3).s_util_Right__f_value;
    return new $c_s_util_Left(b);
  } else {
    throw new $c_s_MatchError(this);
  }
});
$c_s_util_Either.prototype.flatMap__F1__s_util_Either = (function(f) {
  if ((this instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this);
    var b = $n(x2).s_util_Right__f_value;
    return $as_s_util_Either($n(f).apply__O__O(b));
  } else {
    return this;
  }
});
$c_s_util_Either.prototype.map__F1__s_util_Either = (function(f) {
  if ((this instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this);
    var b = $n(x2).s_util_Right__f_value;
    return new $c_s_util_Right($n(f).apply__O__O(b));
  } else {
    return this;
  }
});
$c_s_util_Either.prototype.toOption__s_Option = (function() {
  if ((this instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this);
    var b = $n(x2).s_util_Right__f_value;
    return new $c_s_Some(b);
  } else {
    return $m_s_None$();
  }
});
function $as_s_util_Either(obj) {
  return (((obj instanceof $c_s_util_Either) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Either"));
}
function $isArrayOf_s_util_Either(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Either)));
}
function $asArrayOf_s_util_Either(obj, depth) {
  return (($isArrayOf_s_util_Either(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Either;", depth));
}
var $d_s_util_Either = new $TypeData().initClass(0, "scala.util.Either", ({
  s_util_Either: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_util_Either$LeftProjection(e) {
  this.s_util_Either$LeftProjection__f_e = null;
  this.s_util_Either$LeftProjection__f_e = e;
}
$c_s_util_Either$LeftProjection.prototype = new $h_O();
$c_s_util_Either$LeftProjection.prototype.constructor = $c_s_util_Either$LeftProjection;
/** @constructor */
function $h_s_util_Either$LeftProjection() {
}
$h_s_util_Either$LeftProjection.prototype = $c_s_util_Either$LeftProjection.prototype;
$c_s_util_Either$LeftProjection.prototype.map__F1__s_util_Either = (function(f) {
  var x1 = this.s_util_Either$LeftProjection__f_e;
  if ((x1 instanceof $c_s_util_Left)) {
    var x2 = $as_s_util_Left(x1);
    var a = $n(x2).s_util_Left__f_value;
    return new $c_s_util_Left($n(f).apply__O__O(a));
  } else {
    return this.s_util_Either$LeftProjection__f_e;
  }
});
$c_s_util_Either$LeftProjection.prototype.toOption__s_Option = (function() {
  var x1 = this.s_util_Either$LeftProjection__f_e;
  if ((x1 instanceof $c_s_util_Left)) {
    var x2 = $as_s_util_Left(x1);
    var a = $n(x2).s_util_Left__f_value;
    return new $c_s_Some(a);
  } else {
    return $m_s_None$();
  }
});
$c_s_util_Either$LeftProjection.prototype.productPrefix__T = (function() {
  return "LeftProjection";
});
$c_s_util_Either$LeftProjection.prototype.productArity__I = (function() {
  return 1;
});
$c_s_util_Either$LeftProjection.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Either$LeftProjection__f_e : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_s_util_Either$LeftProjection.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_s_util_Either$LeftProjection.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_s_util_Either$LeftProjection.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_s_util_Either$LeftProjection.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_s_util_Either$LeftProjection)) {
    var LeftProjection$1 = $as_s_util_Either$LeftProjection(x$1);
    var x = this.s_util_Either$LeftProjection__f_e;
    var x$2 = $n(LeftProjection$1).s_util_Either$LeftProjection__f_e;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
function $as_s_util_Either$LeftProjection(obj) {
  return (((obj instanceof $c_s_util_Either$LeftProjection) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Either$LeftProjection"));
}
function $isArrayOf_s_util_Either$LeftProjection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Either$LeftProjection)));
}
function $asArrayOf_s_util_Either$LeftProjection(obj, depth) {
  return (($isArrayOf_s_util_Either$LeftProjection(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Either$LeftProjection;", depth));
}
var $d_s_util_Either$LeftProjection = new $TypeData().initClass($c_s_util_Either$LeftProjection, "scala.util.Either$LeftProjection", ({
  s_util_Either$LeftProjection: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_util_Try() {
}
$c_s_util_Try.prototype = new $h_O();
$c_s_util_Try.prototype.constructor = $c_s_util_Try;
/** @constructor */
function $h_s_util_Try() {
}
$h_s_util_Try.prototype = $c_s_util_Try.prototype;
function $as_s_util_Try(obj) {
  return (((obj instanceof $c_s_util_Try) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Try"));
}
function $isArrayOf_s_util_Try(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Try)));
}
function $asArrayOf_s_util_Try(obj, depth) {
  return (($isArrayOf_s_util_Try(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Try;", depth));
}
function $as_Lsnabbdom_Hooks(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.Hooks"));
}
function $isArrayOf_Lsnabbdom_Hooks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_Hooks)));
}
function $asArrayOf_Lsnabbdom_Hooks(obj, depth) {
  return (($isArrayOf_Lsnabbdom_Hooks(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.Hooks;", depth));
}
/** @constructor */
function $c_Lsnabbdom_Module(pre, create, update, destroy, remove, post) {
  this.Lsnabbdom_Module__f_pre = null;
  this.Lsnabbdom_Module__f_create = null;
  this.Lsnabbdom_Module__f_update = null;
  this.Lsnabbdom_Module__f_destroy = null;
  this.Lsnabbdom_Module__f_remove = null;
  this.Lsnabbdom_Module__f_post = null;
  this.Lsnabbdom_Module__f_pre = pre;
  this.Lsnabbdom_Module__f_create = create;
  this.Lsnabbdom_Module__f_update = update;
  this.Lsnabbdom_Module__f_destroy = destroy;
  this.Lsnabbdom_Module__f_remove = remove;
  this.Lsnabbdom_Module__f_post = post;
}
$c_Lsnabbdom_Module.prototype = new $h_O();
$c_Lsnabbdom_Module.prototype.constructor = $c_Lsnabbdom_Module;
/** @constructor */
function $h_Lsnabbdom_Module() {
}
$h_Lsnabbdom_Module.prototype = $c_Lsnabbdom_Module.prototype;
$c_Lsnabbdom_Module.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsnabbdom_Module.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lsnabbdom_Module.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsnabbdom_Module)) {
    var x$0$2 = $as_Lsnabbdom_Module(x$0);
    var x = this.Lsnabbdom_Module__f_pre;
    var x$2 = $n(x$0$2).Lsnabbdom_Module__f_pre;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lsnabbdom_Module__f_create;
      var x$4 = $n(x$0$2).Lsnabbdom_Module__f_create;
      var $x_4 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.Lsnabbdom_Module__f_update;
      var x$6 = $n(x$0$2).Lsnabbdom_Module__f_update;
      var $x_3 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.Lsnabbdom_Module__f_destroy;
      var x$8 = $n(x$0$2).Lsnabbdom_Module__f_destroy;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.Lsnabbdom_Module__f_remove;
      var x$10 = $n(x$0$2).Lsnabbdom_Module__f_remove;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$11 = this.Lsnabbdom_Module__f_post;
      var x$12 = $n(x$0$2).Lsnabbdom_Module__f_post;
      return ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsnabbdom_Module.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsnabbdom_Module.prototype.productArity__I = (function() {
  return 6;
});
$c_Lsnabbdom_Module.prototype.productPrefix__T = (function() {
  return "Module";
});
$c_Lsnabbdom_Module.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsnabbdom_Module__f_pre;
      break;
    }
    case 1: {
      return this.Lsnabbdom_Module__f_create;
      break;
    }
    case 2: {
      return this.Lsnabbdom_Module__f_update;
      break;
    }
    case 3: {
      return this.Lsnabbdom_Module__f_destroy;
      break;
    }
    case 4: {
      return this.Lsnabbdom_Module__f_remove;
      break;
    }
    case 5: {
      return this.Lsnabbdom_Module__f_post;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Lsnabbdom_Module(obj) {
  return (((obj instanceof $c_Lsnabbdom_Module) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.Module"));
}
function $isArrayOf_Lsnabbdom_Module(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_Module)));
}
function $asArrayOf_Lsnabbdom_Module(obj, depth) {
  return (($isArrayOf_Lsnabbdom_Module(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.Module;", depth));
}
var $d_Lsnabbdom_Module = new $TypeData().initClass($c_Lsnabbdom_Module, "snabbdom.Module", ({
  Lsnabbdom_Module: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lsnabbdom_ModuleHooks(create, update, remove, destroy, pre, post) {
  this.Lsnabbdom_ModuleHooks__f_create = null;
  this.Lsnabbdom_ModuleHooks__f_update = null;
  this.Lsnabbdom_ModuleHooks__f_remove = null;
  this.Lsnabbdom_ModuleHooks__f_destroy = null;
  this.Lsnabbdom_ModuleHooks__f_pre = null;
  this.Lsnabbdom_ModuleHooks__f_post = null;
  this.Lsnabbdom_ModuleHooks__f_create = create;
  this.Lsnabbdom_ModuleHooks__f_update = update;
  this.Lsnabbdom_ModuleHooks__f_remove = remove;
  this.Lsnabbdom_ModuleHooks__f_destroy = destroy;
  this.Lsnabbdom_ModuleHooks__f_pre = pre;
  this.Lsnabbdom_ModuleHooks__f_post = post;
}
$c_Lsnabbdom_ModuleHooks.prototype = new $h_O();
$c_Lsnabbdom_ModuleHooks.prototype.constructor = $c_Lsnabbdom_ModuleHooks;
/** @constructor */
function $h_Lsnabbdom_ModuleHooks() {
}
$h_Lsnabbdom_ModuleHooks.prototype = $c_Lsnabbdom_ModuleHooks.prototype;
$c_Lsnabbdom_ModuleHooks.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsnabbdom_ModuleHooks.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lsnabbdom_ModuleHooks.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsnabbdom_ModuleHooks)) {
    var x$0$2 = $as_Lsnabbdom_ModuleHooks(x$0);
    var x = this.Lsnabbdom_ModuleHooks__f_create;
    var x$2 = $n(x$0$2).Lsnabbdom_ModuleHooks__f_create;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lsnabbdom_ModuleHooks__f_update;
      var x$4 = $n(x$0$2).Lsnabbdom_ModuleHooks__f_update;
      var $x_4 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.Lsnabbdom_ModuleHooks__f_remove;
      var x$6 = $n(x$0$2).Lsnabbdom_ModuleHooks__f_remove;
      var $x_3 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.Lsnabbdom_ModuleHooks__f_destroy;
      var x$8 = $n(x$0$2).Lsnabbdom_ModuleHooks__f_destroy;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.Lsnabbdom_ModuleHooks__f_pre;
      var x$10 = $n(x$0$2).Lsnabbdom_ModuleHooks__f_pre;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$11 = this.Lsnabbdom_ModuleHooks__f_post;
      var x$12 = $n(x$0$2).Lsnabbdom_ModuleHooks__f_post;
      return ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsnabbdom_ModuleHooks.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsnabbdom_ModuleHooks.prototype.productArity__I = (function() {
  return 6;
});
$c_Lsnabbdom_ModuleHooks.prototype.productPrefix__T = (function() {
  return "ModuleHooks";
});
$c_Lsnabbdom_ModuleHooks.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsnabbdom_ModuleHooks__f_create;
      break;
    }
    case 1: {
      return this.Lsnabbdom_ModuleHooks__f_update;
      break;
    }
    case 2: {
      return this.Lsnabbdom_ModuleHooks__f_remove;
      break;
    }
    case 3: {
      return this.Lsnabbdom_ModuleHooks__f_destroy;
      break;
    }
    case 4: {
      return this.Lsnabbdom_ModuleHooks__f_pre;
      break;
    }
    case 5: {
      return this.Lsnabbdom_ModuleHooks__f_post;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Lsnabbdom_ModuleHooks(obj) {
  return (((obj instanceof $c_Lsnabbdom_ModuleHooks) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.ModuleHooks"));
}
function $isArrayOf_Lsnabbdom_ModuleHooks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_ModuleHooks)));
}
function $asArrayOf_Lsnabbdom_ModuleHooks(obj, depth) {
  return (($isArrayOf_Lsnabbdom_ModuleHooks(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.ModuleHooks;", depth));
}
var $d_Lsnabbdom_ModuleHooks = new $TypeData().initClass($c_Lsnabbdom_ModuleHooks, "snabbdom.ModuleHooks", ({
  Lsnabbdom_ModuleHooks: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lsnabbdom_VNodeData(props, attrs, classes, style, dataset, on, hook, key, ns, fn, args, is) {
  this.Lsnabbdom_VNodeData__f_props = null;
  this.Lsnabbdom_VNodeData__f_attrs = null;
  this.Lsnabbdom_VNodeData__f_classes = null;
  this.Lsnabbdom_VNodeData__f_style = null;
  this.Lsnabbdom_VNodeData__f_dataset = null;
  this.Lsnabbdom_VNodeData__f_on = null;
  this.Lsnabbdom_VNodeData__f_hook = null;
  this.Lsnabbdom_VNodeData__f_key = null;
  this.Lsnabbdom_VNodeData__f_ns = null;
  this.Lsnabbdom_VNodeData__f_fn = null;
  this.Lsnabbdom_VNodeData__f_args = null;
  this.Lsnabbdom_VNodeData__f_is = null;
  this.Lsnabbdom_VNodeData__f_props = props;
  this.Lsnabbdom_VNodeData__f_attrs = attrs;
  this.Lsnabbdom_VNodeData__f_classes = classes;
  this.Lsnabbdom_VNodeData__f_style = style;
  this.Lsnabbdom_VNodeData__f_dataset = dataset;
  this.Lsnabbdom_VNodeData__f_on = on;
  this.Lsnabbdom_VNodeData__f_hook = hook;
  this.Lsnabbdom_VNodeData__f_key = key;
  this.Lsnabbdom_VNodeData__f_ns = ns;
  this.Lsnabbdom_VNodeData__f_fn = fn;
  this.Lsnabbdom_VNodeData__f_args = args;
  this.Lsnabbdom_VNodeData__f_is = is;
}
$c_Lsnabbdom_VNodeData.prototype = new $h_O();
$c_Lsnabbdom_VNodeData.prototype.constructor = $c_Lsnabbdom_VNodeData;
/** @constructor */
function $h_Lsnabbdom_VNodeData() {
}
$h_Lsnabbdom_VNodeData.prototype = $c_Lsnabbdom_VNodeData.prototype;
$c_Lsnabbdom_VNodeData.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsnabbdom_VNodeData.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lsnabbdom_VNodeData.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsnabbdom_VNodeData)) {
    var x$0$2 = $as_Lsnabbdom_VNodeData(x$0);
    var x = this.Lsnabbdom_VNodeData__f_props;
    var x$2 = $n(x$0$2).Lsnabbdom_VNodeData__f_props;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lsnabbdom_VNodeData__f_attrs;
      var x$4 = $n(x$0$2).Lsnabbdom_VNodeData__f_attrs;
      var $x_11 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$5 = this.Lsnabbdom_VNodeData__f_classes;
      var x$6 = $n(x$0$2).Lsnabbdom_VNodeData__f_classes;
      var $x_10 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$7 = this.Lsnabbdom_VNodeData__f_style;
      var x$8 = $n(x$0$2).Lsnabbdom_VNodeData__f_style;
      var $x_9 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$9 = this.Lsnabbdom_VNodeData__f_dataset;
      var x$10 = $n(x$0$2).Lsnabbdom_VNodeData__f_dataset;
      var $x_8 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$11 = this.Lsnabbdom_VNodeData__f_on;
      var x$12 = $n(x$0$2).Lsnabbdom_VNodeData__f_on;
      var $x_7 = ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$13 = this.Lsnabbdom_VNodeData__f_hook;
      var x$14 = $n(x$0$2).Lsnabbdom_VNodeData__f_hook;
      var $x_6 = ((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$15 = this.Lsnabbdom_VNodeData__f_key;
      var x$16 = $n(x$0$2).Lsnabbdom_VNodeData__f_key;
      var $x_5 = ((x$15 === null) ? (x$16 === null) : $n(x$15).equals__O__Z(x$16));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$17 = this.Lsnabbdom_VNodeData__f_ns;
      var x$18 = $n(x$0$2).Lsnabbdom_VNodeData__f_ns;
      var $x_4 = ((x$17 === null) ? (x$18 === null) : $n(x$17).equals__O__Z(x$18));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$19 = this.Lsnabbdom_VNodeData__f_fn;
      var x$20 = $n(x$0$2).Lsnabbdom_VNodeData__f_fn;
      var $x_3 = ((x$19 === null) ? (x$20 === null) : $n(x$19).equals__O__Z(x$20));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$21 = this.Lsnabbdom_VNodeData__f_args;
      var x$22 = $n(x$0$2).Lsnabbdom_VNodeData__f_args;
      var $x_2 = ((x$21 === null) ? (x$22 === null) : $n(x$21).equals__O__Z(x$22));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$23 = this.Lsnabbdom_VNodeData__f_is;
      var x$24 = $n(x$0$2).Lsnabbdom_VNodeData__f_is;
      var $x_1 = ((x$23 === null) ? (x$24 === null) : $n(x$23).equals__O__Z(x$24));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsnabbdom_VNodeData.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsnabbdom_VNodeData.prototype.productArity__I = (function() {
  return 12;
});
$c_Lsnabbdom_VNodeData.prototype.productPrefix__T = (function() {
  return "VNodeData";
});
$c_Lsnabbdom_VNodeData.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsnabbdom_VNodeData__f_props;
      break;
    }
    case 1: {
      return this.Lsnabbdom_VNodeData__f_attrs;
      break;
    }
    case 2: {
      return this.Lsnabbdom_VNodeData__f_classes;
      break;
    }
    case 3: {
      return this.Lsnabbdom_VNodeData__f_style;
      break;
    }
    case 4: {
      return this.Lsnabbdom_VNodeData__f_dataset;
      break;
    }
    case 5: {
      return this.Lsnabbdom_VNodeData__f_on;
      break;
    }
    case 6: {
      return this.Lsnabbdom_VNodeData__f_hook;
      break;
    }
    case 7: {
      return this.Lsnabbdom_VNodeData__f_key;
      break;
    }
    case 8: {
      return this.Lsnabbdom_VNodeData__f_ns;
      break;
    }
    case 9: {
      return this.Lsnabbdom_VNodeData__f_fn;
      break;
    }
    case 10: {
      return this.Lsnabbdom_VNodeData__f_args;
      break;
    }
    case 11: {
      return this.Lsnabbdom_VNodeData__f_is;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Lsnabbdom_VNodeData(obj) {
  return (((obj instanceof $c_Lsnabbdom_VNodeData) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.VNodeData"));
}
function $isArrayOf_Lsnabbdom_VNodeData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_VNodeData)));
}
function $asArrayOf_Lsnabbdom_VNodeData(obj, depth) {
  return (($isArrayOf_Lsnabbdom_VNodeData(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.VNodeData;", depth));
}
var $d_Lsnabbdom_VNodeData = new $TypeData().initClass($c_Lsnabbdom_VNodeData, "snabbdom.VNodeData", ({
  Lsnabbdom_VNodeData: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_Location$() {
}
$c_Ltyrian_Location$.prototype = new $h_O();
$c_Ltyrian_Location$.prototype.constructor = $c_Ltyrian_Location$;
/** @constructor */
function $h_Ltyrian_Location$() {
}
$h_Ltyrian_Location$.prototype = $c_Ltyrian_Location$.prototype;
$c_Ltyrian_Location$.prototype.fromUrl__T__Ltyrian_Location$Internal__Ltyrian_Location = (function(url, currentLocation) {
  var ld = $m_Ltyrian_LocationDetails$().fromUrl__T__Ltyrian_LocationDetails(url);
  if ($n($n(ld).Ltyrian_LocationDetails__f_protocol).isEmpty__Z()) {
    return new $c_Ltyrian_Location$Internal(ld);
  } else {
    var x = $n(ld).Ltyrian_LocationDetails__f_origin;
    var this$2 = $n(currentLocation);
    var x$2 = $n(this$2.Ltyrian_Location$Internal__f_locationDetails).Ltyrian_LocationDetails__f_origin;
    return $as_Ltyrian_Location((((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) ? new $c_Ltyrian_Location$Internal(ld) : new $c_Ltyrian_Location$External(ld)));
  }
});
var $d_Ltyrian_Location$ = new $TypeData().initClass($c_Ltyrian_Location$, "tyrian.Location$", ({
  Ltyrian_Location$: 1,
  Ltyrian_LocationPlatform: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Ltyrian_Location$;
function $m_Ltyrian_Location$() {
  if ((!$n_Ltyrian_Location$)) {
    $n_Ltyrian_Location$ = new $c_Ltyrian_Location$();
  }
  return $n_Ltyrian_Location$;
}
function $p_Ltyrian_LocationDetails__whichSeparator__T__T($thiz, protocol) {
  return ($n($thiz.Ltyrian_LocationDetails__f_noSep).contains__O__Z(protocol) ? "" : "//");
}
/** @constructor */
function $c_Ltyrian_LocationDetails(hash, hostName, pathName, port, protocol, search, url) {
  this.Ltyrian_LocationDetails__f_hash = null;
  this.Ltyrian_LocationDetails__f_hostName = null;
  this.Ltyrian_LocationDetails__f_pathName = null;
  this.Ltyrian_LocationDetails__f_port = null;
  this.Ltyrian_LocationDetails__f_protocol = null;
  this.Ltyrian_LocationDetails__f_search = null;
  this.Ltyrian_LocationDetails__f_url = null;
  this.Ltyrian_LocationDetails__f_noSep = null;
  this.Ltyrian_LocationDetails__f_host = null;
  this.Ltyrian_LocationDetails__f_href = null;
  this.Ltyrian_LocationDetails__f_origin = null;
  this.Ltyrian_LocationDetails__f_hash = hash;
  this.Ltyrian_LocationDetails__f_hostName = hostName;
  this.Ltyrian_LocationDetails__f_pathName = pathName;
  this.Ltyrian_LocationDetails__f_port = port;
  this.Ltyrian_LocationDetails__f_protocol = protocol;
  this.Ltyrian_LocationDetails__f_search = search;
  this.Ltyrian_LocationDetails__f_url = url;
  this.Ltyrian_LocationDetails__f_noSep = new $c_sci_$colon$colon("xmpp:", new $c_sci_$colon$colon("data:", new $c_sci_$colon$colon("mailto:", $m_sci_Nil$())));
  matchResult4: {
    var $x_1;
    var x = $m_s_None$();
    if ((x === port)) {
      var $x_1 = hostName;
      break matchResult4;
    }
    if ((port instanceof $c_s_Some)) {
      var p = $as_T($n($as_s_Some(port)).s_Some__f_value);
      var this$1 = $n(hostName);
      if (this$1.isEmpty__Z()) {
        var $x_1 = $m_s_None$();
        break matchResult4;
      } else {
        var arg1 = this$1.get__O();
        var h = $as_T(arg1);
        var $x_1 = new $c_s_Some(((h + ":") + p));
        break matchResult4;
      }
    }
    throw new $c_s_MatchError(port);
  }
  this.Ltyrian_LocationDetails__f_host = $x_1;
  this.Ltyrian_LocationDetails__f_href = url;
  var this$2 = $n(protocol);
  if (this$2.isEmpty__Z()) {
    var $x_2 = $m_s_None$();
  } else {
    var arg1$1 = this$2.get__O();
    var pr = $as_T(arg1$1);
    var this$3 = $n(this.Ltyrian_LocationDetails__f_host);
    if (this$3.isEmpty__Z()) {
      var $x_2 = $m_s_None$();
    } else {
      var arg1$2 = this$3.get__O();
      var ht = $as_T(arg1$2);
      var $x_2 = new $c_s_Some(((("" + pr) + $p_Ltyrian_LocationDetails__whichSeparator__T__T(this, pr)) + ht));
    }
  }
  this.Ltyrian_LocationDetails__f_origin = $x_2;
  matchResult5: {
    var x8 = this.Ltyrian_LocationDetails__f_origin;
    var x$3 = $m_s_None$();
    if ((x$3 === x8)) {
      break matchResult5;
    }
    if ((x8 instanceof $c_s_Some)) {
      var o = $as_T($n($as_s_Some(x8)).s_Some__f_value);
      $f_T__replaceFirst__T__T__T($n(this.Ltyrian_LocationDetails__f_href), o, "");
      break matchResult5;
    }
    throw new $c_s_MatchError(x8);
  }
}
$c_Ltyrian_LocationDetails.prototype = new $h_O();
$c_Ltyrian_LocationDetails.prototype.constructor = $c_Ltyrian_LocationDetails;
/** @constructor */
function $h_Ltyrian_LocationDetails() {
}
$h_Ltyrian_LocationDetails.prototype = $c_Ltyrian_LocationDetails.prototype;
$c_Ltyrian_LocationDetails.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_LocationDetails.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Ltyrian_LocationDetails.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_LocationDetails)) {
    var x$0$2 = $as_Ltyrian_LocationDetails(x$0);
    var x = this.Ltyrian_LocationDetails__f_hash;
    var x$2 = $n(x$0$2).Ltyrian_LocationDetails__f_hash;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Ltyrian_LocationDetails__f_hostName;
      var x$4 = $n(x$0$2).Ltyrian_LocationDetails__f_hostName;
      var $x_4 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_4 = false;
    }
    if (($x_4 && (this.Ltyrian_LocationDetails__f_pathName === $n(x$0$2).Ltyrian_LocationDetails__f_pathName))) {
      var x$5 = this.Ltyrian_LocationDetails__f_port;
      var x$6 = $n(x$0$2).Ltyrian_LocationDetails__f_port;
      var $x_3 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.Ltyrian_LocationDetails__f_protocol;
      var x$8 = $n(x$0$2).Ltyrian_LocationDetails__f_protocol;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.Ltyrian_LocationDetails__f_search;
      var x$10 = $n(x$0$2).Ltyrian_LocationDetails__f_search;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.Ltyrian_LocationDetails__f_url === $n(x$0$2).Ltyrian_LocationDetails__f_url);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ltyrian_LocationDetails.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ltyrian_LocationDetails.prototype.productArity__I = (function() {
  return 7;
});
$c_Ltyrian_LocationDetails.prototype.productPrefix__T = (function() {
  return "LocationDetails";
});
$c_Ltyrian_LocationDetails.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Ltyrian_LocationDetails__f_hash;
      break;
    }
    case 1: {
      return this.Ltyrian_LocationDetails__f_hostName;
      break;
    }
    case 2: {
      return this.Ltyrian_LocationDetails__f_pathName;
      break;
    }
    case 3: {
      return this.Ltyrian_LocationDetails__f_port;
      break;
    }
    case 4: {
      return this.Ltyrian_LocationDetails__f_protocol;
      break;
    }
    case 5: {
      return this.Ltyrian_LocationDetails__f_search;
      break;
    }
    case 6: {
      return this.Ltyrian_LocationDetails__f_url;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Ltyrian_LocationDetails(obj) {
  return (((obj instanceof $c_Ltyrian_LocationDetails) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.LocationDetails"));
}
function $isArrayOf_Ltyrian_LocationDetails(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_LocationDetails)));
}
function $asArrayOf_Ltyrian_LocationDetails(obj, depth) {
  return (($isArrayOf_Ltyrian_LocationDetails(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.LocationDetails;", depth));
}
var $d_Ltyrian_LocationDetails = new $TypeData().initClass($c_Ltyrian_LocationDetails, "tyrian.LocationDetails", ({
  Ltyrian_LocationDetails: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_LocationDetails$LocationPathDetails(path, search, hash) {
  this.Ltyrian_LocationDetails$LocationPathDetails__f_path = null;
  this.Ltyrian_LocationDetails$LocationPathDetails__f_search = null;
  this.Ltyrian_LocationDetails$LocationPathDetails__f_hash = null;
  this.Ltyrian_LocationDetails$LocationPathDetails__f_path = path;
  this.Ltyrian_LocationDetails$LocationPathDetails__f_search = search;
  this.Ltyrian_LocationDetails$LocationPathDetails__f_hash = hash;
}
$c_Ltyrian_LocationDetails$LocationPathDetails.prototype = new $h_O();
$c_Ltyrian_LocationDetails$LocationPathDetails.prototype.constructor = $c_Ltyrian_LocationDetails$LocationPathDetails;
/** @constructor */
function $h_Ltyrian_LocationDetails$LocationPathDetails() {
}
$h_Ltyrian_LocationDetails$LocationPathDetails.prototype = $c_Ltyrian_LocationDetails$LocationPathDetails.prototype;
$c_Ltyrian_LocationDetails$LocationPathDetails.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_LocationDetails$LocationPathDetails.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Ltyrian_LocationDetails$LocationPathDetails.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_LocationDetails$LocationPathDetails)) {
    var x$0$2 = $as_Ltyrian_LocationDetails$LocationPathDetails(x$0);
    if ((this.Ltyrian_LocationDetails$LocationPathDetails__f_path === $n(x$0$2).Ltyrian_LocationDetails$LocationPathDetails__f_path)) {
      var x = this.Ltyrian_LocationDetails$LocationPathDetails__f_search;
      var x$2 = $n(x$0$2).Ltyrian_LocationDetails$LocationPathDetails__f_search;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Ltyrian_LocationDetails$LocationPathDetails__f_hash;
      var x$4 = $n(x$0$2).Ltyrian_LocationDetails$LocationPathDetails__f_hash;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ltyrian_LocationDetails$LocationPathDetails.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ltyrian_LocationDetails$LocationPathDetails.prototype.productArity__I = (function() {
  return 3;
});
$c_Ltyrian_LocationDetails$LocationPathDetails.prototype.productPrefix__T = (function() {
  return "LocationPathDetails";
});
$c_Ltyrian_LocationDetails$LocationPathDetails.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Ltyrian_LocationDetails$LocationPathDetails__f_path;
      break;
    }
    case 1: {
      return this.Ltyrian_LocationDetails$LocationPathDetails__f_search;
      break;
    }
    case 2: {
      return this.Ltyrian_LocationDetails$LocationPathDetails__f_hash;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Ltyrian_LocationDetails$LocationPathDetails(obj) {
  return (((obj instanceof $c_Ltyrian_LocationDetails$LocationPathDetails) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.LocationDetails$LocationPathDetails"));
}
function $isArrayOf_Ltyrian_LocationDetails$LocationPathDetails(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_LocationDetails$LocationPathDetails)));
}
function $asArrayOf_Ltyrian_LocationDetails$LocationPathDetails(obj, depth) {
  return (($isArrayOf_Ltyrian_LocationDetails$LocationPathDetails(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.LocationDetails$LocationPathDetails;", depth));
}
var $d_Ltyrian_LocationDetails$LocationPathDetails = new $TypeData().initClass($c_Ltyrian_LocationDetails$LocationPathDetails, "tyrian.LocationDetails$LocationPathDetails", ({
  Ltyrian_LocationDetails$LocationPathDetails: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_runtime_Renderer(vnode, state) {
  this.Ltyrian_runtime_Renderer__f_vnode = null;
  this.Ltyrian_runtime_Renderer__f_state = null;
  this.Ltyrian_runtime_Renderer__f_vnode = vnode;
  this.Ltyrian_runtime_Renderer__f_state = state;
}
$c_Ltyrian_runtime_Renderer.prototype = new $h_O();
$c_Ltyrian_runtime_Renderer.prototype.constructor = $c_Ltyrian_runtime_Renderer;
/** @constructor */
function $h_Ltyrian_runtime_Renderer() {
}
$h_Ltyrian_runtime_Renderer.prototype = $c_Ltyrian_runtime_Renderer.prototype;
$c_Ltyrian_runtime_Renderer.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_runtime_Renderer.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Ltyrian_runtime_Renderer.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_runtime_Renderer)) {
    var x$0$2 = $as_Ltyrian_runtime_Renderer(x$0);
    var x = this.Ltyrian_runtime_Renderer__f_vnode;
    var x$2 = $n(x$0$2).Ltyrian_runtime_Renderer__f_vnode;
    if ((x === null)) {
      var $x_1 = (x$2 === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === x$2);
    }
    if ($x_1) {
      var x$3 = this.Ltyrian_runtime_Renderer__f_state;
      var x$4 = $n(x$0$2).Ltyrian_runtime_Renderer__f_state;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ltyrian_runtime_Renderer.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ltyrian_runtime_Renderer.prototype.productArity__I = (function() {
  return 2;
});
$c_Ltyrian_runtime_Renderer.prototype.productPrefix__T = (function() {
  return "Renderer";
});
$c_Ltyrian_runtime_Renderer.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_runtime_Renderer__f_vnode;
  }
  if ((n === 1)) {
    return this.Ltyrian_runtime_Renderer__f_state;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Ltyrian_runtime_Renderer.prototype.runningAt__J__Ltyrian_runtime_Renderer = (function(t) {
  var state$1 = new $c_Ltyrian_runtime_RendererState$Running(t);
  var vnode$1 = this.Ltyrian_runtime_Renderer__f_vnode;
  return new $c_Ltyrian_runtime_Renderer(vnode$1, state$1);
});
function $as_Ltyrian_runtime_Renderer(obj) {
  return (((obj instanceof $c_Ltyrian_runtime_Renderer) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.runtime.Renderer"));
}
function $isArrayOf_Ltyrian_runtime_Renderer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_runtime_Renderer)));
}
function $asArrayOf_Ltyrian_runtime_Renderer(obj, depth) {
  return (($isArrayOf_Ltyrian_runtime_Renderer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.runtime.Renderer;", depth));
}
var $d_Ltyrian_runtime_Renderer = new $TypeData().initClass($c_Ltyrian_runtime_Renderer, "tyrian.runtime.Renderer", ({
  Ltyrian_runtime_Renderer: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $f_Lcats_ComposedFunctor__map__O__F1__O($thiz, fga, f) {
  return $n($thiz.Lcats_Functor$$anon$1__f_F).map__O__F1__O(fga, new $c_sjsr_AnonFunction1(((ga) => $n($thiz.Lcats_Functor$$anon$1__f_G).map__O__F1__O(ga, f))));
}
/** @constructor */
function $c_Lcats_Eval$Ident(ev) {
  this.Lcats_Eval$Ident__f_ev = null;
  this.Lcats_Eval$Ident__f_ev = ev;
}
$c_Lcats_Eval$Ident.prototype = new $h_Lcats_Eval$FnStack();
$c_Lcats_Eval$Ident.prototype.constructor = $c_Lcats_Eval$Ident;
/** @constructor */
function $h_Lcats_Eval$Ident() {
}
$h_Lcats_Eval$Ident.prototype = $c_Lcats_Eval$Ident.prototype;
$c_Lcats_Eval$Ident.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_Eval$Ident.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_Eval$Ident.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_Eval$Ident)) {
    var x$0$2 = $as_Lcats_Eval$Ident(x$0);
    var x = this.Lcats_Eval$Ident__f_ev;
    var x$2 = $n(x$0$2).Lcats_Eval$Ident__f_ev;
    if ((x === null)) {
      return (x$2 === null);
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2);
    }
  } else {
    return false;
  }
});
$c_Lcats_Eval$Ident.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_Eval$Ident.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_Eval$Ident.prototype.productPrefix__T = (function() {
  return "Ident";
});
$c_Lcats_Eval$Ident.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_Eval$Ident__f_ev;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_Eval$Ident(obj) {
  return (((obj instanceof $c_Lcats_Eval$Ident) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval$Ident"));
}
function $isArrayOf_Lcats_Eval$Ident(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$Ident)));
}
function $asArrayOf_Lcats_Eval$Ident(obj, depth) {
  return (($isArrayOf_Lcats_Eval$Ident(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval$Ident;", depth));
}
var $d_Lcats_Eval$Ident = new $TypeData().initClass($c_Lcats_Eval$Ident, "cats.Eval$Ident", ({
  Lcats_Eval$Ident: 1,
  Lcats_Eval$FnStack: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_Eval$Many(first, rest) {
  this.Lcats_Eval$Many__f_first = null;
  this.Lcats_Eval$Many__f_rest = null;
  this.Lcats_Eval$Many__f_first = first;
  this.Lcats_Eval$Many__f_rest = rest;
}
$c_Lcats_Eval$Many.prototype = new $h_Lcats_Eval$FnStack();
$c_Lcats_Eval$Many.prototype.constructor = $c_Lcats_Eval$Many;
/** @constructor */
function $h_Lcats_Eval$Many() {
}
$h_Lcats_Eval$Many.prototype = $c_Lcats_Eval$Many.prototype;
$c_Lcats_Eval$Many.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_Eval$Many.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_Eval$Many.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_Eval$Many)) {
    var x$0$2 = $as_Lcats_Eval$Many(x$0);
    var x = this.Lcats_Eval$Many__f_first;
    var x$2 = $n(x$0$2).Lcats_Eval$Many__f_first;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_Eval$Many__f_rest;
      var x$4 = $n(x$0$2).Lcats_Eval$Many__f_rest;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_Eval$Many.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_Eval$Many.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_Eval$Many.prototype.productPrefix__T = (function() {
  return "Many";
});
$c_Lcats_Eval$Many.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_Eval$Many__f_first;
  }
  if ((n === 1)) {
    return this.Lcats_Eval$Many__f_rest;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_Eval$Many(obj) {
  return (((obj instanceof $c_Lcats_Eval$Many) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval$Many"));
}
function $isArrayOf_Lcats_Eval$Many(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$Many)));
}
function $asArrayOf_Lcats_Eval$Many(obj, depth) {
  return (($isArrayOf_Lcats_Eval$Many(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval$Many;", depth));
}
var $d_Lcats_Eval$Many = new $TypeData().initClass($c_Lcats_Eval$Many, "cats.Eval$Many", ({
  Lcats_Eval$Many: 1,
  Lcats_Eval$FnStack: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_Eval$Memoize(eval$1) {
  this.Lcats_Eval$Memoize__f_eval = null;
  this.Lcats_Eval$Memoize__f_result = null;
  this.Lcats_Eval$Memoize__f_eval = eval$1;
  this.Lcats_Eval$Memoize__f_result = $m_s_None$();
}
$c_Lcats_Eval$Memoize.prototype = new $h_Lcats_Eval();
$c_Lcats_Eval$Memoize.prototype.constructor = $c_Lcats_Eval$Memoize;
/** @constructor */
function $h_Lcats_Eval$Memoize() {
}
$h_Lcats_Eval$Memoize.prototype = $c_Lcats_Eval$Memoize.prototype;
$c_Lcats_Eval$Memoize.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_Eval$Memoize.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_Eval$Memoize.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_Eval$Memoize)) {
    var x$0$2 = $as_Lcats_Eval$Memoize(x$0);
    var x = this.Lcats_Eval$Memoize__f_eval;
    var x$2 = $n(x$0$2).Lcats_Eval$Memoize__f_eval;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_Eval$Memoize.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_Eval$Memoize.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_Eval$Memoize.prototype.productPrefix__T = (function() {
  return "Memoize";
});
$c_Lcats_Eval$Memoize.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_Eval$Memoize__f_eval;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_Eval$Memoize.prototype.memoize__Lcats_Eval = (function() {
  return this;
});
$c_Lcats_Eval$Memoize.prototype.value__O = (function() {
  var x12 = this.Lcats_Eval$Memoize__f_result;
  if ((x12 instanceof $c_s_Some)) {
    var a = $n($as_s_Some(x12)).s_Some__f_value;
    return a;
  }
  var x = $m_s_None$();
  if ((x === x12)) {
    var a$2 = $m_Lcats_Eval$().cats$Eval$$$evaluate__Lcats_Eval__O(this);
    this.Lcats_Eval$Memoize__f_result = new $c_s_Some(a$2);
    return a$2;
  }
  throw new $c_s_MatchError(x12);
});
function $as_Lcats_Eval$Memoize(obj) {
  return (((obj instanceof $c_Lcats_Eval$Memoize) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval$Memoize"));
}
function $isArrayOf_Lcats_Eval$Memoize(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$Memoize)));
}
function $asArrayOf_Lcats_Eval$Memoize(obj, depth) {
  return (($isArrayOf_Lcats_Eval$Memoize(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval$Memoize;", depth));
}
var $d_Lcats_Eval$Memoize = new $TypeData().initClass($c_Lcats_Eval$Memoize, "cats.Eval$Memoize", ({
  Lcats_Eval$Memoize: 1,
  Lcats_Eval: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
function $f_Lcats_Reducible__reduceLeftToOption__O__F1__F2__s_Option($thiz, fa, f, g) {
  var value = $thiz.reduceLeftTo__O__F1__F2__O(fa, f, g);
  return new $c_s_Some(value);
}
function $f_Lcats_Reducible__maximum__O__Lcats_kernel_Order__O($thiz, fa, A) {
  return $thiz.reduceLeft__O__F2__O(fa, new $c_sjsr_AnonFunction2(((x, y) => $n(A).max__O__O__O(x, y))));
}
function $f_Lcats_Reducible__maximumOption__O__Lcats_kernel_Order__s_Option($thiz, fa, A) {
  var value = $f_Lcats_Reducible__maximum__O__Lcats_kernel_Order__O($thiz, fa, A);
  return new $c_s_Some(value);
}
/** @constructor */
function $c_Lcats_Show$() {
}
$c_Lcats_Show$.prototype = new $h_O();
$c_Lcats_Show$.prototype.constructor = $c_Lcats_Show$;
/** @constructor */
function $h_Lcats_Show$() {
}
$h_Lcats_Show$.prototype = $c_Lcats_Show$.prototype;
var $d_Lcats_Show$ = new $TypeData().initClass($c_Lcats_Show$, "cats.Show$", ({
  Lcats_Show$: 1,
  Lcats_ScalaVersionSpecificShowInstances: 1,
  Lcats_instances_NTupleShowInstances: 1,
  Lcats_ShowInstances0: 1,
  Lcats_ShowInstances: 1
}));
var $n_Lcats_Show$;
function $m_Lcats_Show$() {
  if ((!$n_Lcats_Show$)) {
    $n_Lcats_Show$ = new $c_Lcats_Show$();
  }
  return $n_Lcats_Show$;
}
function $ps_Lcats_data_AndThen__loop$1__Lcats_data_AndThen__O__O(self, current) {
  var current$tailLocal1 = current;
  var self$tailLocal1 = self;
  while (true) {
    var x31 = self$tailLocal1;
    if ((x31 instanceof $c_Lcats_data_AndThen$Single)) {
      var x$1 = $as_Lcats_data_AndThen$Single(x31);
      var this$2 = $n(x$1);
      var x50 = this$2.Lcats_data_AndThen$Single__f_f;
      var this$3 = $n(x$1);
      return $n(x50).apply__O__O(current$tailLocal1);
    }
    if ((x31 instanceof $c_Lcats_data_AndThen$Concat)) {
      var x$1$1 = $as_Lcats_data_AndThen$Concat(x31);
      var this$5 = $n(x$1$1);
      var x42 = this$5.Lcats_data_AndThen$Concat__f_left;
      var this$6 = $n(x$1$1);
      var x43 = this$6.Lcats_data_AndThen$Concat__f_right;
      if ((x42 instanceof $c_Lcats_data_AndThen$Single)) {
        var x$1$2 = $as_Lcats_data_AndThen$Single(x42);
        var this$8 = $n(x$1$2);
        var x46 = this$8.Lcats_data_AndThen$Single__f_f;
        var this$9 = $n(x$1$2);
        var current$tailLocal1$tmp1 = $n(x46).apply__O__O(current$tailLocal1);
        self$tailLocal1 = x43;
        current$tailLocal1 = current$tailLocal1$tmp1;
        continue;
      }
    }
    if ((x31 instanceof $c_Lcats_data_AndThen$Concat)) {
      var x$1$3 = $as_Lcats_data_AndThen$Concat(x31);
      var this$11 = $n(x$1$3);
      var x34 = this$11.Lcats_data_AndThen$Concat__f_left;
      var this$12 = $n(x$1$3);
      var x35 = this$12.Lcats_data_AndThen$Concat__f_right;
      if ((x34 instanceof $c_Lcats_data_AndThen$Concat)) {
        var x$1$4 = $as_Lcats_data_AndThen$Concat(x34);
        var this$14 = $n(x$1$4);
        var this$15 = $n(x$1$4);
        var left = $as_Lcats_data_AndThen$Concat(x34);
        var this$16 = $n(left);
        self$tailLocal1 = $ps_Lcats_data_AndThen__loop$2__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen(this$16, x35);
        continue;
      }
    }
    throw new $c_s_MatchError(x31);
  }
}
function $ps_Lcats_data_AndThen__loop$2__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen(left, right) {
  var right$tailLocal1 = right;
  var left$tailLocal1 = left;
  while (true) {
    var x52 = left$tailLocal1;
    if ((x52 instanceof $c_Lcats_data_AndThen$Concat)) {
      var x$1 = $as_Lcats_data_AndThen$Concat(x52);
      var this$2 = $n(x$1);
      var x55 = this$2.Lcats_data_AndThen$Concat__f_left;
      var this$3 = $n(x$1);
      var x56 = this$3.Lcats_data_AndThen$Concat__f_right;
      var right$1 = right$tailLocal1;
      var right$tailLocal1$tmp1 = new $c_Lcats_data_AndThen$Concat(x56, right$1);
      left$tailLocal1 = x55;
      right$tailLocal1 = right$tailLocal1$tmp1;
      continue;
    }
    var right$2 = right$tailLocal1;
    return new $c_Lcats_data_AndThen$Concat(x52, right$2);
  }
}
/** @constructor */
function $c_Lcats_data_AndThen() {
}
$c_Lcats_data_AndThen.prototype = new $h_O();
$c_Lcats_data_AndThen.prototype.constructor = $c_Lcats_data_AndThen;
/** @constructor */
function $h_Lcats_data_AndThen() {
}
$h_Lcats_data_AndThen.prototype = $c_Lcats_data_AndThen.prototype;
$c_Lcats_data_AndThen.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_data_AndThen.prototype.apply__O__O = (function(a) {
  return $ps_Lcats_data_AndThen__loop$1__Lcats_data_AndThen__O__O(this, a);
});
$c_Lcats_data_AndThen.prototype.andThen__F1__Lcats_data_AndThen = (function(g) {
  if ((g instanceof $c_Lcats_data_AndThen)) {
    var atg = $as_Lcats_data_AndThen(g);
    return $m_Lcats_data_AndThen$().andThen__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen(this, atg);
  } else {
    if ((this instanceof $c_Lcats_data_AndThen$Single)) {
      var x$1 = $as_Lcats_data_AndThen$Single(this);
      var this$2 = $n(x$1);
      var x12 = this$2.Lcats_data_AndThen$Single__f_f;
      var this$3 = $n(x$1);
      var x13 = this$3.Lcats_data_AndThen$Single__f_index;
      if ((x13 < 128)) {
        var f = $n(x12).andThen__F1__F1(g);
        var index = ((1 + x13) | 0);
        return new $c_Lcats_data_AndThen$Single(f, index);
      }
    }
    if ((this instanceof $c_Lcats_data_AndThen$Concat)) {
      var x$1$1 = $as_Lcats_data_AndThen$Concat(this);
      var this$6 = $n(x$1$1);
      var x4 = this$6.Lcats_data_AndThen$Concat__f_left;
      var this$7 = $n(x$1$1);
      var x5 = this$7.Lcats_data_AndThen$Concat__f_right;
      if ((x5 instanceof $c_Lcats_data_AndThen$Single)) {
        var x$1$2 = $as_Lcats_data_AndThen$Single(x5);
        var this$9 = $n(x$1$2);
        var x8 = this$9.Lcats_data_AndThen$Single__f_f;
        var this$10 = $n(x$1$2);
        var x9 = this$10.Lcats_data_AndThen$Single__f_index;
        if ((x9 < 128)) {
          var f$1 = $n(x8).andThen__F1__F1(g);
          var index$1 = ((1 + x9) | 0);
          var right = new $c_Lcats_data_AndThen$Single(f$1, index$1);
          return new $c_Lcats_data_AndThen$Concat(x4, right);
        }
      }
    }
    var right$1 = new $c_Lcats_data_AndThen$Single(g, 0);
    return new $c_Lcats_data_AndThen$Concat(this, right$1);
  }
});
$c_Lcats_data_AndThen.prototype.compose__F1__Lcats_data_AndThen = (function(g) {
  if ((g instanceof $c_Lcats_data_AndThen)) {
    var atg = $as_Lcats_data_AndThen(g);
    return $m_Lcats_data_AndThen$().andThen__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen(atg, this);
  } else {
    if ((this instanceof $c_Lcats_data_AndThen$Single)) {
      var x$1 = $as_Lcats_data_AndThen$Single(this);
      var this$2 = $n(x$1);
      var x27 = this$2.Lcats_data_AndThen$Single__f_f;
      var this$3 = $n(x$1);
      var x28 = this$3.Lcats_data_AndThen$Single__f_index;
      if ((x28 < 128)) {
        var f = $n(x27).compose__F1__F1(g);
        var index = ((1 + x28) | 0);
        return new $c_Lcats_data_AndThen$Single(f, index);
      }
    }
    if ((this instanceof $c_Lcats_data_AndThen$Concat)) {
      var x$1$1 = $as_Lcats_data_AndThen$Concat(this);
      var this$6 = $n(x$1$1);
      var x19 = this$6.Lcats_data_AndThen$Concat__f_left;
      var this$7 = $n(x$1$1);
      var x20 = this$7.Lcats_data_AndThen$Concat__f_right;
      if ((x19 instanceof $c_Lcats_data_AndThen$Single)) {
        var x$1$2 = $as_Lcats_data_AndThen$Single(x19);
        var this$9 = $n(x$1$2);
        var x23 = this$9.Lcats_data_AndThen$Single__f_f;
        var this$10 = $n(x$1$2);
        var x24 = this$10.Lcats_data_AndThen$Single__f_index;
        if ((x24 < 128)) {
          var f$1 = $n(x23).compose__F1__F1(g);
          var index$1 = ((1 + x24) | 0);
          var left = new $c_Lcats_data_AndThen$Single(f$1, index$1);
          return new $c_Lcats_data_AndThen$Concat(left, x20);
        }
      }
    }
    var left$1 = new $c_Lcats_data_AndThen$Single(g, 0);
    return new $c_Lcats_data_AndThen$Concat(left$1, this);
  }
});
$c_Lcats_data_AndThen.prototype.toString__T = (function() {
  return ("AndThen$" + $systemIdentityHashCode(this));
});
$c_Lcats_data_AndThen.prototype.andThen__F1__F1 = (function(g) {
  return this.andThen__F1__Lcats_data_AndThen(g);
});
$c_Lcats_data_AndThen.prototype.compose__F1__F1 = (function(g) {
  return this.compose__F1__Lcats_data_AndThen(g);
});
$c_Lcats_data_AndThen.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ($ps_Lcats_data_AndThen__loop$1__Lcats_data_AndThen__O__O(this, v1));
});
function $as_Lcats_data_AndThen(obj) {
  return (((obj instanceof $c_Lcats_data_AndThen) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.AndThen"));
}
function $isArrayOf_Lcats_data_AndThen(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_AndThen)));
}
function $asArrayOf_Lcats_data_AndThen(obj, depth) {
  return (($isArrayOf_Lcats_data_AndThen(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.AndThen;", depth));
}
/** @constructor */
function $c_Lcats_data_AndThen$() {
  $ct_Lcats_data_AndThenInstances0__(this);
}
$c_Lcats_data_AndThen$.prototype = new $h_Lcats_data_AndThenInstances0();
$c_Lcats_data_AndThen$.prototype.constructor = $c_Lcats_data_AndThen$;
/** @constructor */
function $h_Lcats_data_AndThen$() {
}
$h_Lcats_data_AndThen$.prototype = $c_Lcats_data_AndThen$.prototype;
$c_Lcats_data_AndThen$.prototype.apply__F1__Lcats_data_AndThen = (function(f) {
  if ((f instanceof $c_Lcats_data_AndThen)) {
    var ref = $as_Lcats_data_AndThen(f);
    return ref;
  } else {
    return new $c_Lcats_data_AndThen$Single(f, 0);
  }
});
$c_Lcats_data_AndThen$.prototype.andThen__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen = (function(ab, bc) {
  if ((ab instanceof $c_Lcats_data_AndThen$Single)) {
    var x$1 = $as_Lcats_data_AndThen$Single(ab);
    var this$2 = $n(x$1);
    var x177 = this$2.Lcats_data_AndThen$Single__f_f;
    var this$3 = $n(x$1);
    var x178 = this$3.Lcats_data_AndThen$Single__f_index;
    if ((bc instanceof $c_Lcats_data_AndThen$Single)) {
      var x$1$1 = $as_Lcats_data_AndThen$Single(bc);
      var this$5 = $n(x$1$1);
      var x151 = this$5.Lcats_data_AndThen$Single__f_f;
      var this$6 = $n(x$1$1);
      var x152 = this$6.Lcats_data_AndThen$Single__f_index;
      if ((((x178 + x152) | 0) < 128)) {
        var f = $n(x177).andThen__F1__F1(x151);
        var index = ((1 + ((x178 + x152) | 0)) | 0);
        return new $c_Lcats_data_AndThen$Single(f, index);
      } else {
        return new $c_Lcats_data_AndThen$Concat(ab, bc);
      }
    }
    if ((bc instanceof $c_Lcats_data_AndThen$Concat)) {
      var x$1$2 = $as_Lcats_data_AndThen$Concat(bc);
      var this$10 = $n(x$1$2);
      var x143 = this$10.Lcats_data_AndThen$Concat__f_left;
      var this$11 = $n(x$1$2);
      var x144 = this$11.Lcats_data_AndThen$Concat__f_right;
      if ((x143 instanceof $c_Lcats_data_AndThen$Single)) {
        var x$1$3 = $as_Lcats_data_AndThen$Single(x143);
        var this$13 = $n(x$1$3);
        var x147 = this$13.Lcats_data_AndThen$Single__f_f;
        var this$14 = $n(x$1$3);
        var x148 = this$14.Lcats_data_AndThen$Single__f_index;
        if ((((x178 + x148) | 0) < 128)) {
          var f$1 = $n(x177).andThen__F1__F1(x147);
          var index$1 = ((1 + ((x178 + x148) | 0)) | 0);
          var left = new $c_Lcats_data_AndThen$Single(f$1, index$1);
          return new $c_Lcats_data_AndThen$Concat(left, x144);
        }
      }
    }
    return new $c_Lcats_data_AndThen$Concat(ab, bc);
  }
  if ((ab instanceof $c_Lcats_data_AndThen$Concat)) {
    var x$1$4 = $as_Lcats_data_AndThen$Concat(ab);
    var this$19 = $n(x$1$4);
    var x169 = this$19.Lcats_data_AndThen$Concat__f_left;
    var this$20 = $n(x$1$4);
    var x170 = this$20.Lcats_data_AndThen$Concat__f_right;
    if ((x170 instanceof $c_Lcats_data_AndThen$Single)) {
      var x$1$5 = $as_Lcats_data_AndThen$Single(x170);
      var this$22 = $n(x$1$5);
      var x173 = this$22.Lcats_data_AndThen$Single__f_f;
      var this$23 = $n(x$1$5);
      var x174 = this$23.Lcats_data_AndThen$Single__f_index;
      if ((bc instanceof $c_Lcats_data_AndThen$Single)) {
        var x$1$6 = $as_Lcats_data_AndThen$Single(bc);
        var this$25 = $n(x$1$6);
        var x164 = this$25.Lcats_data_AndThen$Single__f_f;
        var this$26 = $n(x$1$6);
        var x165 = this$26.Lcats_data_AndThen$Single__f_index;
        if ((((x174 + x165) | 0) < 128)) {
          var f$2 = $n(x173).andThen__F1__F1(x164);
          var index$2 = ((1 + ((x174 + x165) | 0)) | 0);
          var right = new $c_Lcats_data_AndThen$Single(f$2, index$2);
          return new $c_Lcats_data_AndThen$Concat(x169, right);
        } else {
          return new $c_Lcats_data_AndThen$Concat(ab, bc);
        }
      }
      if ((bc instanceof $c_Lcats_data_AndThen$Concat)) {
        var x$1$7 = $as_Lcats_data_AndThen$Concat(bc);
        var this$31 = $n(x$1$7);
        var x156 = this$31.Lcats_data_AndThen$Concat__f_left;
        var this$32 = $n(x$1$7);
        var x157 = this$32.Lcats_data_AndThen$Concat__f_right;
        if ((x156 instanceof $c_Lcats_data_AndThen$Single)) {
          var x$1$8 = $as_Lcats_data_AndThen$Single(x156);
          var this$34 = $n(x$1$8);
          var x160 = this$34.Lcats_data_AndThen$Single__f_f;
          var this$35 = $n(x$1$8);
          var x161 = this$35.Lcats_data_AndThen$Single__f_index;
          if ((((x174 + x161) | 0) < 128)) {
            var f$3 = $n(x173).andThen__F1__F1(x160);
            var index$3 = ((1 + ((x174 + x161) | 0)) | 0);
            var left$1 = new $c_Lcats_data_AndThen$Single(f$3, index$3);
            var right$1 = new $c_Lcats_data_AndThen$Concat(left$1, x157);
            return new $c_Lcats_data_AndThen$Concat(x169, right$1);
          }
        }
      }
      return new $c_Lcats_data_AndThen$Concat(ab, bc);
    }
  }
  return new $c_Lcats_data_AndThen$Concat(ab, bc);
});
var $d_Lcats_data_AndThen$ = new $TypeData().initClass($c_Lcats_data_AndThen$, "cats.data.AndThen$", ({
  Lcats_data_AndThen$: 1,
  Lcats_data_AndThenInstances0: 1,
  Lcats_data_AndThenInstances1: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Lcats_data_AndThen$;
function $m_Lcats_data_AndThen$() {
  if ((!$n_Lcats_data_AndThen$)) {
    $n_Lcats_data_AndThen$ = new $c_Lcats_data_AndThen$();
  }
  return $n_Lcats_data_AndThen$;
}
/** @constructor */
function $c_Lcats_data_KleisliInstances5() {
}
$c_Lcats_data_KleisliInstances5.prototype = new $h_Lcats_data_KleisliInstances6();
$c_Lcats_data_KleisliInstances5.prototype.constructor = $c_Lcats_data_KleisliInstances5;
/** @constructor */
function $h_Lcats_data_KleisliInstances5() {
}
$h_Lcats_data_KleisliInstances5.prototype = $c_Lcats_data_KleisliInstances5.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyList(head, tail) {
  this.Lcats_data_NonEmptyList__f_head = null;
  this.Lcats_data_NonEmptyList__f_tail = null;
  this.Lcats_data_NonEmptyList__f_head = head;
  this.Lcats_data_NonEmptyList__f_tail = tail;
}
$c_Lcats_data_NonEmptyList.prototype = new $h_O();
$c_Lcats_data_NonEmptyList.prototype.constructor = $c_Lcats_data_NonEmptyList;
/** @constructor */
function $h_Lcats_data_NonEmptyList() {
}
$h_Lcats_data_NonEmptyList.prototype = $c_Lcats_data_NonEmptyList.prototype;
$c_Lcats_data_NonEmptyList.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_data_NonEmptyList.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_data_NonEmptyList.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_data_NonEmptyList)) {
    var x$0$2 = $as_Lcats_data_NonEmptyList(x$0);
    var x = this.Lcats_data_NonEmptyList__f_head;
    var y = $n(x$0$2).Lcats_data_NonEmptyList__f_head;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lcats_data_NonEmptyList__f_tail;
      var x$2 = $n(x$0$2).Lcats_data_NonEmptyList__f_tail;
      return ((x$1 === null) ? (x$2 === null) : $n(x$1).equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_data_NonEmptyList.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_data_NonEmptyList.prototype.productPrefix__T = (function() {
  return "NonEmptyList";
});
$c_Lcats_data_NonEmptyList.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_NonEmptyList__f_head;
  }
  if ((n === 1)) {
    return this.Lcats_data_NonEmptyList__f_tail;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_data_NonEmptyList.prototype.size__I = (function() {
  var this$1 = $n(this.Lcats_data_NonEmptyList__f_tail);
  return ((1 + this$1.length__I()) | 0);
});
$c_Lcats_data_NonEmptyList.prototype.map__F1__Lcats_data_NonEmptyList = (function(f) {
  $m_Lcats_data_NonEmptyList$();
  var head = $n(f).apply__O__O(this.Lcats_data_NonEmptyList__f_head);
  var tail = $n(this.Lcats_data_NonEmptyList__f_tail).map__F1__sci_List(f);
  return new $c_Lcats_data_NonEmptyList(head, tail);
});
$c_Lcats_data_NonEmptyList.prototype.concat__sci_List__Lcats_data_NonEmptyList = (function(other) {
  $m_Lcats_data_NonEmptyList$();
  var head = this.Lcats_data_NonEmptyList__f_head;
  var tail = $n(other).$colon$colon$colon__sci_List__sci_List(this.Lcats_data_NonEmptyList__f_tail);
  return new $c_Lcats_data_NonEmptyList(head, tail);
});
$c_Lcats_data_NonEmptyList.prototype.concatNel__Lcats_data_NonEmptyList__Lcats_data_NonEmptyList = (function(other) {
  $m_Lcats_data_NonEmptyList$();
  var head = this.Lcats_data_NonEmptyList__f_head;
  var this$1 = $n(other);
  var this$2 = $n(this$1.Lcats_data_NonEmptyList__f_tail);
  var elem = this$1.Lcats_data_NonEmptyList__f_head;
  var tail = new $c_sci_$colon$colon(elem, this$2).$colon$colon$colon__sci_List__sci_List(this.Lcats_data_NonEmptyList__f_tail);
  return new $c_Lcats_data_NonEmptyList(head, tail);
});
$c_Lcats_data_NonEmptyList.prototype.flatMap__F1__Lcats_data_NonEmptyList = (function(f) {
  var this$5 = $n($as_Lcats_data_NonEmptyList($n(f).apply__O__O(this.Lcats_data_NonEmptyList__f_head)));
  var this$1 = $n(this.Lcats_data_NonEmptyList__f_tail);
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var arg1 = $n(rest).head__O();
    var this$2 = $n($as_Lcats_data_NonEmptyList($n(f).apply__O__O(arg1)));
    var this$3 = $n(this$2.Lcats_data_NonEmptyList__f_tail);
    var elem = this$2.Lcats_data_NonEmptyList__f_head;
    var this$4 = new $c_sci_$colon$colon(elem, this$3);
    var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
    while (it.hasNext__Z()) {
      var nx = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        $n(t).sci_$colon$colon__f_next = nx;
      }
      t = nx;
    }
    rest = $as_sci_List($n(rest).tail__O());
  }
  var l = ((h === null) ? $m_sci_Nil$() : h);
  return this$5.concat__sci_List__Lcats_data_NonEmptyList(l);
});
$c_Lcats_data_NonEmptyList.prototype.prepend__O__Lcats_data_NonEmptyList = (function(a) {
  $m_Lcats_data_NonEmptyList$();
  var this$1 = $n(this.Lcats_data_NonEmptyList__f_tail);
  var elem = this.Lcats_data_NonEmptyList__f_head;
  var tail = new $c_sci_$colon$colon(elem, this$1);
  return new $c_Lcats_data_NonEmptyList(a, tail);
});
$c_Lcats_data_NonEmptyList.prototype.foldLeft__O__F2__O = (function(b, f) {
  var this$1 = $n(this.Lcats_data_NonEmptyList__f_tail);
  var z = $n(f).apply__O__O__O(b, this.Lcats_data_NonEmptyList__f_head);
  return $f_sc_LinearSeqOps__foldLeft__O__F2__O(this$1, z, f);
});
$c_Lcats_data_NonEmptyList.prototype.foldRight__Lcats_Eval__F2__Lcats_Eval = (function(lb, f) {
  $m_Lcats_UnorderedFoldable$();
  var instance = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
  var $x_1 = $n(instance);
  var this$3 = $n(this.Lcats_data_NonEmptyList__f_tail);
  var elem = this.Lcats_data_NonEmptyList__f_head;
  return $n($x_1).foldRight__O__Lcats_Eval__F2__Lcats_Eval(new $c_sci_$colon$colon(elem, this$3), lb, f);
});
$c_Lcats_data_NonEmptyList.prototype.reduce__Lcats_kernel_Semigroup__O = (function(S) {
  var this$1 = $n(this.Lcats_data_NonEmptyList__f_tail);
  var elem = this.Lcats_data_NonEmptyList__f_head;
  return $n($n(S).combineAllOption__sc_IterableOnce__s_Option(new $c_sci_$colon$colon(elem, this$1))).get__O();
});
$c_Lcats_data_NonEmptyList.prototype.traverse__F1__Lcats_Applicative__O = (function(f, G) {
  var $x_1 = $n(f).apply__O__O(this.Lcats_data_NonEmptyList__f_head);
  var a = new $c_sjsr_AnonFunction0((() => {
    $m_Lcats_UnorderedFoldable$();
    var instance = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
    return $n(instance).traverse__O__F1__Lcats_Applicative__O(this.Lcats_data_NonEmptyList__f_tail, f, G);
  }));
  return $n($n(G).map2Eval__O__Lcats_Eval__F2__Lcats_Eval($x_1, new $c_Lcats_Always(a), new $c_sjsr_AnonFunction2(((_$2, _$3) => {
    var _$3$1 = $as_sci_List(_$3);
    $m_Lcats_data_NonEmptyList$();
    return new $c_Lcats_data_NonEmptyList(_$2, _$3$1);
  })))).value__O();
});
$c_Lcats_data_NonEmptyList.prototype.toString__T = (function() {
  var this$1 = $n(this.Lcats_data_NonEmptyList__f_tail);
  var elem = this.Lcats_data_NonEmptyList__f_head;
  return ("NonEmpty" + new $c_sci_$colon$colon(elem, this$1));
});
function $as_Lcats_data_NonEmptyList(obj) {
  return (((obj instanceof $c_Lcats_data_NonEmptyList) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.NonEmptyList"));
}
function $isArrayOf_Lcats_data_NonEmptyList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_NonEmptyList)));
}
function $asArrayOf_Lcats_data_NonEmptyList(obj, depth) {
  return (($isArrayOf_Lcats_data_NonEmptyList(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.NonEmptyList;", depth));
}
var $d_Lcats_data_NonEmptyList = new $TypeData().initClass($c_Lcats_data_NonEmptyList, "cats.data.NonEmptyList", ({
  Lcats_data_NonEmptyList: 1,
  Lcats_data_NonEmptyCollection: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_data_NonEmptySetImpl$() {
  this.Lcats_data_NonEmptySetInstances__f_catsDataInstancesForNonEmptySet = null;
  $ct_Lcats_data_NonEmptySetInstances__(this);
}
$c_Lcats_data_NonEmptySetImpl$.prototype = new $h_Lcats_data_NonEmptySetInstances();
$c_Lcats_data_NonEmptySetImpl$.prototype.constructor = $c_Lcats_data_NonEmptySetImpl$;
/** @constructor */
function $h_Lcats_data_NonEmptySetImpl$() {
}
$h_Lcats_data_NonEmptySetImpl$.prototype = $c_Lcats_data_NonEmptySetImpl$.prototype;
$c_Lcats_data_NonEmptySetImpl$.prototype.fromSet__sci_SortedSet__s_Option = (function(as) {
  var this$1 = $n(as);
  if ((!this$1.isEmpty__Z())) {
    return $m_s_Option$().apply__O__s_Option(as);
  } else {
    return $m_s_None$();
  }
});
$c_Lcats_data_NonEmptySetImpl$.prototype.fromSetUnsafe__sci_SortedSet__O = (function(set) {
  var this$1 = $n(set);
  if ((!this$1.isEmpty__Z())) {
    return set;
  } else {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Cannot create NonEmptySet from empty set");
  }
});
$c_Lcats_data_NonEmptySetImpl$.prototype.of__O__sci_Seq__Lcats_kernel_Order__O = (function(a, as, A) {
  var $x_1 = $m_sci_SortedSet$();
  var this$1 = $n(as);
  var s = $as_sci_SortedSet($n($x_1).apply__sci_Seq__O__O($as_sci_Seq(this$1.prepended__O__O(a)), $n(A).toOrdering__s_math_Ordering()));
  return s;
});
$c_Lcats_data_NonEmptySetImpl$.prototype.one__O__Lcats_kernel_Order__O = (function(a, A) {
  var s = $as_sci_SortedSet($m_sci_SortedSet$().apply__sci_Seq__O__O($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([a])), $n(A).toOrdering__s_math_Ordering()));
  return s;
});
var $d_Lcats_data_NonEmptySetImpl$ = new $TypeData().initClass($c_Lcats_data_NonEmptySetImpl$, "cats.data.NonEmptySetImpl$", ({
  Lcats_data_NonEmptySetImpl$: 1,
  Lcats_data_NonEmptySetInstances: 1,
  Lcats_data_NonEmptySetInstances0: 1,
  Lcats_data_NonEmptySetInstances1: 1,
  Lcats_data_Newtype: 1
}));
var $n_Lcats_data_NonEmptySetImpl$;
function $m_Lcats_data_NonEmptySetImpl$() {
  if ((!$n_Lcats_data_NonEmptySetImpl$)) {
    $n_Lcats_data_NonEmptySetImpl$ = new $c_Lcats_data_NonEmptySetImpl$();
  }
  return $n_Lcats_data_NonEmptySetImpl$;
}
/** @constructor */
function $c_Lcats_data_StrictConstFunction1(a) {
  this.Lcats_data_StrictConstFunction1__f_a = null;
  this.Lcats_data_StrictConstFunction1__f_a = a;
}
$c_Lcats_data_StrictConstFunction1.prototype = new $h_O();
$c_Lcats_data_StrictConstFunction1.prototype.constructor = $c_Lcats_data_StrictConstFunction1;
/** @constructor */
function $h_Lcats_data_StrictConstFunction1() {
}
$h_Lcats_data_StrictConstFunction1.prototype = $c_Lcats_data_StrictConstFunction1.prototype;
$c_Lcats_data_StrictConstFunction1.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Lcats_data_StrictConstFunction1.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_data_StrictConstFunction1.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_data_StrictConstFunction1.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_data_StrictConstFunction1)) {
    var x$0$2 = $as_Lcats_data_StrictConstFunction1(x$0);
    var x = this.Lcats_data_StrictConstFunction1__f_a;
    var y = $n(x$0$2).Lcats_data_StrictConstFunction1__f_a;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_data_StrictConstFunction1.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_data_StrictConstFunction1.prototype.productPrefix__T = (function() {
  return "StrictConstFunction1";
});
$c_Lcats_data_StrictConstFunction1.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_StrictConstFunction1__f_a;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_data_StrictConstFunction1.prototype.apply__O__O = (function(arg) {
  return this.Lcats_data_StrictConstFunction1__f_a;
});
$c_Lcats_data_StrictConstFunction1.prototype.andThen__F1__F1 = (function(g) {
  if ((g instanceof $c_Lcats_data_StrictConstFunction1)) {
    var g$2 = $as_Lcats_data_StrictConstFunction1(g);
    return g$2;
  } else {
    var a = $n(g).apply__O__O(this.Lcats_data_StrictConstFunction1__f_a);
    return new $c_Lcats_data_StrictConstFunction1(a);
  }
});
$c_Lcats_data_StrictConstFunction1.prototype.compose__F1__F1 = (function(g) {
  return this;
});
$c_Lcats_data_StrictConstFunction1.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.Lcats_data_StrictConstFunction1__f_a);
});
function $as_Lcats_data_StrictConstFunction1(obj) {
  return (((obj instanceof $c_Lcats_data_StrictConstFunction1) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.StrictConstFunction1"));
}
function $isArrayOf_Lcats_data_StrictConstFunction1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_StrictConstFunction1)));
}
function $asArrayOf_Lcats_data_StrictConstFunction1(obj, depth) {
  return (($isArrayOf_Lcats_data_StrictConstFunction1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.StrictConstFunction1;", depth));
}
var $d_Lcats_data_StrictConstFunction1 = new $TypeData().initClass($c_Lcats_data_StrictConstFunction1, "cats.data.StrictConstFunction1", ({
  Lcats_data_StrictConstFunction1: 1,
  F1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_data_Validated$Invalid(e) {
  this.Lcats_data_Validated$Invalid__f_e = null;
  this.Lcats_data_Validated$Invalid__f_e = e;
}
$c_Lcats_data_Validated$Invalid.prototype = new $h_Lcats_data_Validated();
$c_Lcats_data_Validated$Invalid.prototype.constructor = $c_Lcats_data_Validated$Invalid;
/** @constructor */
function $h_Lcats_data_Validated$Invalid() {
}
$h_Lcats_data_Validated$Invalid.prototype = $c_Lcats_data_Validated$Invalid.prototype;
$c_Lcats_data_Validated$Invalid.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_data_Validated$Invalid.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_data_Validated$Invalid)) {
    var x$0$2 = $as_Lcats_data_Validated$Invalid(x$0);
    var x = this.Lcats_data_Validated$Invalid__f_e;
    var y = $n(x$0$2).Lcats_data_Validated$Invalid__f_e;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_data_Validated$Invalid.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_data_Validated$Invalid.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_data_Validated$Invalid.prototype.productPrefix__T = (function() {
  return "Invalid";
});
$c_Lcats_data_Validated$Invalid.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_Validated$Invalid__f_e;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_data_Validated$Invalid(obj) {
  return (((obj instanceof $c_Lcats_data_Validated$Invalid) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Validated$Invalid"));
}
function $isArrayOf_Lcats_data_Validated$Invalid(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Validated$Invalid)));
}
function $asArrayOf_Lcats_data_Validated$Invalid(obj, depth) {
  return (($isArrayOf_Lcats_data_Validated$Invalid(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Validated$Invalid;", depth));
}
var $d_Lcats_data_Validated$Invalid = new $TypeData().initClass($c_Lcats_data_Validated$Invalid, "cats.data.Validated$Invalid", ({
  Lcats_data_Validated$Invalid: 1,
  Lcats_data_Validated: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_data_Validated$Valid(a) {
  this.Lcats_data_Validated$Valid__f_a = null;
  this.Lcats_data_Validated$Valid__f_a = a;
}
$c_Lcats_data_Validated$Valid.prototype = new $h_Lcats_data_Validated();
$c_Lcats_data_Validated$Valid.prototype.constructor = $c_Lcats_data_Validated$Valid;
/** @constructor */
function $h_Lcats_data_Validated$Valid() {
}
$h_Lcats_data_Validated$Valid.prototype = $c_Lcats_data_Validated$Valid.prototype;
$c_Lcats_data_Validated$Valid.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_data_Validated$Valid.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_data_Validated$Valid)) {
    var x$0$2 = $as_Lcats_data_Validated$Valid(x$0);
    var x = this.Lcats_data_Validated$Valid__f_a;
    var y = $n(x$0$2).Lcats_data_Validated$Valid__f_a;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_data_Validated$Valid.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_data_Validated$Valid.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_data_Validated$Valid.prototype.productPrefix__T = (function() {
  return "Valid";
});
$c_Lcats_data_Validated$Valid.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_Validated$Valid__f_a;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_data_Validated$Valid(obj) {
  return (((obj instanceof $c_Lcats_data_Validated$Valid) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Validated$Valid"));
}
function $isArrayOf_Lcats_data_Validated$Valid(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Validated$Valid)));
}
function $asArrayOf_Lcats_data_Validated$Valid(obj, depth) {
  return (($isArrayOf_Lcats_data_Validated$Valid(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Validated$Valid;", depth));
}
var $d_Lcats_data_Validated$Valid = new $TypeData().initClass($c_Lcats_data_Validated$Valid, "cats.data.Validated$Valid", ({
  Lcats_data_Validated$Valid: 1,
  Lcats_data_Validated: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$() {
  this.Lcats_effect_IO$__f__unit = null;
  this.Lcats_effect_IO$__f__asyncForIO = null;
  this.Lcats_effect_IO$__f_consoleForIO = null;
  this.Lcats_effect_IO$__f__never = null;
  $n_Lcats_effect_IO$ = this;
  this.Lcats_effect_IO$__f__unit = new $c_Lcats_effect_IO$Pure((void 0));
  this.Lcats_effect_IO$__f__asyncForIO = new $c_Lcats_effect_IO$$anon$2();
  var this$2 = $m_Lcats_effect_instances_package$spawn$();
  var M = this.Lcats_effect_IO$__f__asyncForIO;
  new $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1(M, this$2);
  this.Lcats_effect_IO$__f_consoleForIO = $m_Lcats_effect_std_Console$().make__Lcats_effect_kernel_Async__Lcats_effect_std_Console(this.Lcats_effect_IO$__f__asyncForIO);
  var this$3 = $m_Lcats_effect_std_Env$();
  var F = this.Lcats_effect_IO$__f__asyncForIO;
  new $c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv(this$3, F);
  this.Lcats_effect_IO$__f__never = $as_Lcats_effect_IO($n(this.Lcats_effect_IO$__f__asyncForIO).never__O());
}
$c_Lcats_effect_IO$.prototype = new $h_Lcats_effect_IOCompanionPlatform();
$c_Lcats_effect_IO$.prototype.constructor = $c_Lcats_effect_IO$;
/** @constructor */
function $h_Lcats_effect_IO$() {
}
$h_Lcats_effect_IO$.prototype = $c_Lcats_effect_IO$.prototype;
$c_Lcats_effect_IO$.prototype.delay__F0__Lcats_effect_IO = (function(thunk) {
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F0__Lcats_effect_tracing_TracingEvent(thunk);
  return new $c_Lcats_effect_IO$Delay(thunk, event);
});
$c_Lcats_effect_IO$.prototype.defer__F0__Lcats_effect_IO = (function(thunk) {
  var this$2 = $n(this.delay__F0__Lcats_effect_IO(thunk));
  var this$1 = $m_s_$less$colon$less$();
  var ev = this$1.s_$less$colon$less$__f_singleton;
  return this$2.flatMap__F1__Lcats_effect_IO(ev);
});
$c_Lcats_effect_IO$.prototype.asyncCheckAttempt__F1__Lcats_effect_IO = (function(k) {
  var body = new $c_Lcats_effect_IO$$anon$3(k);
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(k);
  return new $c_Lcats_effect_IO$IOCont(body, event);
});
$c_Lcats_effect_IO$.prototype.async__F1__Lcats_effect_IO = (function(k) {
  var body = new $c_Lcats_effect_IO$$anon$4(k);
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(k);
  return new $c_Lcats_effect_IO$IOCont(body, event);
});
$c_Lcats_effect_IO$.prototype.async___F1__Lcats_effect_IO = (function(k) {
  var body = new $c_Lcats_effect_IO$$anon$5(k);
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(k);
  return new $c_Lcats_effect_IO$IOCont(body, event);
});
$c_Lcats_effect_IO$.prototype.cont__Lcats_effect_kernel_Cont__Lcats_effect_IO = (function(body) {
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__Lcats_effect_kernel_Cont__Lcats_effect_tracing_TracingEvent(body);
  return new $c_Lcats_effect_IO$IOCont(body, event);
});
$c_Lcats_effect_IO$.prototype.sleep__s_concurrent_duration_Duration__Lcats_effect_IO = (function(delay) {
  if ((delay instanceof $c_s_concurrent_duration_FiniteDuration)) {
    var fd = $as_s_concurrent_duration_FiniteDuration(delay);
    var $x_1 = new $c_Lcats_effect_IO$Sleep(fd);
  } else {
    var x = $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Inf;
    if (((x === null) ? (delay === null) : $n(x).equals__O__Z(delay))) {
      var $x_1 = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__never;
    } else {
      var $x_1;
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Duration must be either a `FiniteDuration` or `Duration.Inf`, but got: " + delay));
    }
  }
  return $as_Lcats_effect_IO($x_1);
});
$c_Lcats_effect_IO$.prototype.uncancelable__F1__Lcats_effect_IO = (function(body) {
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(body);
  return new $c_Lcats_effect_IO$Uncancelable(body, event);
});
$c_Lcats_effect_IO$.prototype.ref__O__Lcats_effect_IO = (function(a) {
  var this$3 = $m_Lcats_effect_IO$();
  var thunk = new $c_sjsr_AnonFunction0((() => {
    var F = this.Lcats_effect_IO$__f__asyncForIO;
    return new $c_Lcats_effect_kernel_SyncRef(a, F);
  }));
  return this$3.delay__F0__Lcats_effect_IO(thunk);
});
$c_Lcats_effect_IO$.prototype.deferred__Lcats_effect_IO = (function() {
  var this$2 = $m_Lcats_effect_IO$();
  var thunk = new $c_sjsr_AnonFunction0((() => new $c_Lcats_effect_IODeferred()));
  return this$2.delay__F0__Lcats_effect_IO(thunk);
});
$c_Lcats_effect_IO$.prototype.bracketFull__F1__F1__F2__Lcats_effect_IO = (function(acquire, use, release) {
  return $m_Lcats_effect_IO$().uncancelable__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    return $n($as_Lcats_effect_IO($n(acquire).apply__O__O(poll$1))).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((a) => $n($m_Lcats_effect_IO$().defer__F0__Lcats_effect_IO(new $c_sjsr_AnonFunction0((() => $as_Lcats_effect_IO($n(poll$1).apply__O__O($n(use).apply__O__O(a))))))).guaranteeCase__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((_$37) => {
      var _$37$1 = $as_Lcats_effect_kernel_Outcome(_$37);
      return $as_Lcats_effect_IO($n(release).apply__O__O__O(a, _$37$1));
    }))))));
  })));
});
function $as_Lcats_effect_IO$(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$"));
}
function $isArrayOf_Lcats_effect_IO$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$)));
}
function $asArrayOf_Lcats_effect_IO$(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$;", depth));
}
var $d_Lcats_effect_IO$ = new $TypeData().initClass($c_Lcats_effect_IO$, "cats.effect.IO$", ({
  Lcats_effect_IO$: 1,
  Lcats_effect_IOCompanionPlatform: 1,
  Lcats_effect_IOLowPriorityImplicits: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Lcats_effect_IO$;
function $m_Lcats_effect_IO$() {
  if ((!$n_Lcats_effect_IO$)) {
    $n_Lcats_effect_IO$ = new $c_Lcats_effect_IO$();
  }
  return $n_Lcats_effect_IO$;
}
function $p_Lcats_effect_IODeferred__clear$1__I__V($thiz, handle$1) {
  var stack = $thiz.Lcats_effect_IODeferred__f_callbacks;
  delete stack[handle$1];
  var removed = true;
  if ((!removed)) {
    var this$3 = $n($thiz.Lcats_effect_IODeferred__f_clearCounter);
    var newValue = ((1 + this$3.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value) | 0);
    this$3.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value = newValue;
    if (((newValue & (((-1) + newValue) | 0)) === 0)) {
      var this$6 = $n($thiz.Lcats_effect_IODeferred__f_clearCounter);
      var delta = ((-((newValue - newValue) | 0)) | 0);
      var newValue$1 = ((this$6.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value + delta) | 0);
      this$6.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value = newValue$1;
    }
  }
}
/** @constructor */
function $c_Lcats_effect_IODeferred() {
  this.Lcats_effect_IODeferred__f_initial = null;
  this.Lcats_effect_IODeferred__f_cell = null;
  this.Lcats_effect_IODeferred__f_callbacks = null;
  this.Lcats_effect_IODeferred__f_clearCounter = null;
  var await$1 = $m_Lcats_effect_IO$().asyncCheckAttempt__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((cb) => {
    var cb$1 = $as_F1(cb);
    var this$8 = $m_Lcats_effect_IO$();
    var thunk$1 = new $c_sjsr_AnonFunction0((() => {
      var stack = this.Lcats_effect_IODeferred__f_callbacks;
      stack.push(cb$1);
      var handle = (((-1) + $uI(stack.length)) | 0);
      var back = $as_Lcats_effect_IO($n(this.Lcats_effect_IODeferred__f_cell).ju_concurrent_atomic_AtomicReference__f_value);
      if ((back === this.Lcats_effect_IODeferred__f_initial)) {
        var this$4 = $m_Lcats_effect_IO$();
        var thunk = new $c_sjsr_AnonFunction0((() => {
          $p_Lcats_effect_IODeferred__clear$1__I__V(this, handle);
        }));
        var value = this$4.delay__F0__Lcats_effect_IO(thunk);
        var value$1 = new $c_s_Some(value);
        return new $c_s_util_Left(value$1);
      } else {
        $p_Lcats_effect_IODeferred__clear$1__I__V(this, handle);
        var value$2 = $n($as_Lcats_effect_IO$Pure(back)).Lcats_effect_IO$Pure__f_value;
        return new $c_s_util_Right(value$2);
      }
    }));
    return this$8.delay__F0__Lcats_effect_IO(thunk$1);
  })));
  this.Lcats_effect_IODeferred__f_initial = $m_Lcats_effect_IO$().defer__F0__Lcats_effect_IO(new $c_sjsr_AnonFunction0((() => {
    var back$1 = $as_Lcats_effect_IO($n(this.Lcats_effect_IODeferred__f_cell).ju_concurrent_atomic_AtomicReference__f_value);
    return ((back$1 === this.Lcats_effect_IODeferred__f_initial) ? await$1 : back$1);
  })));
  this.Lcats_effect_IODeferred__f_cell = $ct_ju_concurrent_atomic_AtomicReference__O__(new $c_ju_concurrent_atomic_AtomicReference(), this.Lcats_effect_IODeferred__f_initial);
  this.Lcats_effect_IODeferred__f_callbacks = [null];
  this.Lcats_effect_IODeferred__f_clearCounter = $ct_ju_concurrent_atomic_AtomicInteger__(new $c_ju_concurrent_atomic_AtomicInteger());
}
$c_Lcats_effect_IODeferred.prototype = new $h_Lcats_effect_kernel_Deferred();
$c_Lcats_effect_IODeferred.prototype.constructor = $c_Lcats_effect_IODeferred;
/** @constructor */
function $h_Lcats_effect_IODeferred() {
}
$h_Lcats_effect_IODeferred.prototype = $c_Lcats_effect_IODeferred.prototype;
$c_Lcats_effect_IODeferred.prototype.complete__O__Lcats_effect_IO = (function(a) {
  var this$8 = $m_Lcats_effect_IO$();
  var thunk = new $c_sjsr_AnonFunction0((() => {
    if ($n(this.Lcats_effect_IODeferred__f_cell).compareAndSet__O__O__Z(this.Lcats_effect_IODeferred__f_initial, ($m_Lcats_effect_IO$(), new $c_Lcats_effect_IO$Pure(a)))) {
      var stack = this.Lcats_effect_IODeferred__f_callbacks;
      var oc = new $c_s_util_Right(a);
      $uZ(stack.reduceRight($m_sjs_js_Any$().fromFunction2__F2__sjs_js_Function2(new $c_sjsr_AnonFunction2(((acc, cb) => {
        var acc$1 = $uZ(acc);
        var cb$1 = $as_F1(cb);
        return ((cb$1 !== null) ? ($n(cb$1).apply__O__O(oc), true) : acc$1);
      }))), false));
      return true;
    } else {
      return false;
    }
  }));
  return this$8.delay__F0__Lcats_effect_IO(thunk);
});
$c_Lcats_effect_IODeferred.prototype.get__Lcats_effect_IO = (function() {
  return $as_Lcats_effect_IO($n(this.Lcats_effect_IODeferred__f_cell).ju_concurrent_atomic_AtomicReference__f_value);
});
$c_Lcats_effect_IODeferred.prototype.tryGet__Lcats_effect_IO = (function() {
  var this$3 = $m_Lcats_effect_IO$();
  var thunk = new $c_sjsr_AnonFunction0((() => {
    var back = $as_Lcats_effect_IO($n(this.Lcats_effect_IODeferred__f_cell).ju_concurrent_atomic_AtomicReference__f_value);
    if ((back === this.Lcats_effect_IODeferred__f_initial)) {
      return $m_s_None$();
    } else {
      var value = $n($as_Lcats_effect_IO$Pure(back)).Lcats_effect_IO$Pure__f_value;
      return new $c_s_Some(value);
    }
  }));
  return this$3.delay__F0__Lcats_effect_IO(thunk);
});
$c_Lcats_effect_IODeferred.prototype.complete__O__O = (function(a) {
  return this.complete__O__Lcats_effect_IO(a);
});
$c_Lcats_effect_IODeferred.prototype.get__O = (function() {
  return this.get__Lcats_effect_IO();
});
$c_Lcats_effect_IODeferred.prototype.tryGet__O = (function() {
  return this.tryGet__Lcats_effect_IO();
});
var $d_Lcats_effect_IODeferred = new $TypeData().initClass($c_Lcats_effect_IODeferred, "cats.effect.IODeferred", ({
  Lcats_effect_IODeferred: 1,
  Lcats_effect_kernel_Deferred: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_DeferredSource: 1,
  Lcats_effect_kernel_DeferredSink: 1
}));
/** @constructor */
function $c_Lcats_effect_SyncIO$() {
  this.Lcats_effect_SyncIO$__f_realTime = null;
  this.Lcats_effect_SyncIO$__f__unit = null;
  this.Lcats_effect_SyncIO$__f__syncForSyncIO = null;
  $n_Lcats_effect_SyncIO$ = this;
  this.Lcats_effect_SyncIO$__f_realTime = $m_Lcats_effect_SyncIO$RealTime$();
  this.Lcats_effect_SyncIO$__f__unit = new $c_Lcats_effect_SyncIO$Pure((void 0));
  this.Lcats_effect_SyncIO$__f__syncForSyncIO = new $c_Lcats_effect_SyncIO$$anon$2();
}
$c_Lcats_effect_SyncIO$.prototype = new $h_O();
$c_Lcats_effect_SyncIO$.prototype.constructor = $c_Lcats_effect_SyncIO$;
/** @constructor */
function $h_Lcats_effect_SyncIO$() {
}
$h_Lcats_effect_SyncIO$.prototype = $c_Lcats_effect_SyncIO$.prototype;
var $d_Lcats_effect_SyncIO$ = new $TypeData().initClass($c_Lcats_effect_SyncIO$, "cats.effect.SyncIO$", ({
  Lcats_effect_SyncIO$: 1,
  Lcats_effect_SyncIOCompanionPlatform: 1,
  Lcats_effect_SyncIOLowPriorityImplicits: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Lcats_effect_SyncIO$;
function $m_Lcats_effect_SyncIO$() {
  if ((!$n_Lcats_effect_SyncIO$)) {
    $n_Lcats_effect_SyncIO$ = new $c_Lcats_effect_SyncIO$();
  }
  return $n_Lcats_effect_SyncIO$;
}
/** @constructor */
function $c_Lcats_effect_SyncIO$Attempt(ioa) {
  this.Lcats_effect_SyncIO$Attempt__f_ioa = null;
  this.Lcats_effect_SyncIO$Attempt__f_ioa = ioa;
}
$c_Lcats_effect_SyncIO$Attempt.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Attempt.prototype.constructor = $c_Lcats_effect_SyncIO$Attempt;
/** @constructor */
function $h_Lcats_effect_SyncIO$Attempt() {
}
$h_Lcats_effect_SyncIO$Attempt.prototype = $c_Lcats_effect_SyncIO$Attempt.prototype;
$c_Lcats_effect_SyncIO$Attempt.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$Attempt.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_SyncIO$Attempt.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$Attempt)) {
    var x$0$2 = $as_Lcats_effect_SyncIO$Attempt(x$0);
    var x = this.Lcats_effect_SyncIO$Attempt__f_ioa;
    var x$2 = $n(x$0$2).Lcats_effect_SyncIO$Attempt__f_ioa;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_SyncIO$Attempt.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_SyncIO$Attempt.prototype.productPrefix__T = (function() {
  return "Attempt";
});
$c_Lcats_effect_SyncIO$Attempt.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$Attempt__f_ioa;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Attempt.prototype.tag__B = (function() {
  return 8;
});
function $as_Lcats_effect_SyncIO$Attempt(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO$Attempt) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$Attempt"));
}
function $isArrayOf_Lcats_effect_SyncIO$Attempt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Attempt)));
}
function $asArrayOf_Lcats_effect_SyncIO$Attempt(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$Attempt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$Attempt;", depth));
}
var $d_Lcats_effect_SyncIO$Attempt = new $TypeData().initClass($c_Lcats_effect_SyncIO$Attempt, "cats.effect.SyncIO$Attempt", ({
  Lcats_effect_SyncIO$Attempt: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lcats_effect_SyncIO$Error(t) {
  this.Lcats_effect_SyncIO$Error__f_t = null;
  this.Lcats_effect_SyncIO$Error__f_t = t;
}
$c_Lcats_effect_SyncIO$Error.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Error.prototype.constructor = $c_Lcats_effect_SyncIO$Error;
/** @constructor */
function $h_Lcats_effect_SyncIO$Error() {
}
$h_Lcats_effect_SyncIO$Error.prototype = $c_Lcats_effect_SyncIO$Error.prototype;
$c_Lcats_effect_SyncIO$Error.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$Error.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_SyncIO$Error.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$Error)) {
    var x$0$2 = $as_Lcats_effect_SyncIO$Error(x$0);
    var x = this.Lcats_effect_SyncIO$Error__f_t;
    var x$2 = $n(x$0$2).Lcats_effect_SyncIO$Error__f_t;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_SyncIO$Error.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_SyncIO$Error.prototype.productPrefix__T = (function() {
  return "Error";
});
$c_Lcats_effect_SyncIO$Error.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$Error__f_t;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Error.prototype.tag__B = (function() {
  return 2;
});
function $as_Lcats_effect_SyncIO$Error(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO$Error) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$Error"));
}
function $isArrayOf_Lcats_effect_SyncIO$Error(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Error)));
}
function $asArrayOf_Lcats_effect_SyncIO$Error(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$Error(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$Error;", depth));
}
var $d_Lcats_effect_SyncIO$Error = new $TypeData().initClass($c_Lcats_effect_SyncIO$Error, "cats.effect.SyncIO$Error", ({
  Lcats_effect_SyncIO$Error: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lcats_effect_SyncIO$Failure(t) {
  this.Lcats_effect_SyncIO$Failure__f_t = null;
  this.Lcats_effect_SyncIO$Failure__f_t = t;
}
$c_Lcats_effect_SyncIO$Failure.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Failure.prototype.constructor = $c_Lcats_effect_SyncIO$Failure;
/** @constructor */
function $h_Lcats_effect_SyncIO$Failure() {
}
$h_Lcats_effect_SyncIO$Failure.prototype = $c_Lcats_effect_SyncIO$Failure.prototype;
$c_Lcats_effect_SyncIO$Failure.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$Failure.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_SyncIO$Failure.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$Failure)) {
    var x$0$2 = $as_Lcats_effect_SyncIO$Failure(x$0);
    var x = this.Lcats_effect_SyncIO$Failure__f_t;
    var x$2 = $n(x$0$2).Lcats_effect_SyncIO$Failure__f_t;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_SyncIO$Failure.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_SyncIO$Failure.prototype.productPrefix__T = (function() {
  return "Failure";
});
$c_Lcats_effect_SyncIO$Failure.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$Failure__f_t;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Failure.prototype.tag__B = (function() {
  return 7;
});
function $as_Lcats_effect_SyncIO$Failure(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO$Failure) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$Failure"));
}
function $isArrayOf_Lcats_effect_SyncIO$Failure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Failure)));
}
function $asArrayOf_Lcats_effect_SyncIO$Failure(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$Failure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$Failure;", depth));
}
var $d_Lcats_effect_SyncIO$Failure = new $TypeData().initClass($c_Lcats_effect_SyncIO$Failure, "cats.effect.SyncIO$Failure", ({
  Lcats_effect_SyncIO$Failure: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lcats_effect_SyncIO$FlatMap(ioe, f) {
  this.Lcats_effect_SyncIO$FlatMap__f_ioe = null;
  this.Lcats_effect_SyncIO$FlatMap__f_f = null;
  this.Lcats_effect_SyncIO$FlatMap__f_ioe = ioe;
  this.Lcats_effect_SyncIO$FlatMap__f_f = f;
}
$c_Lcats_effect_SyncIO$FlatMap.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$FlatMap.prototype.constructor = $c_Lcats_effect_SyncIO$FlatMap;
/** @constructor */
function $h_Lcats_effect_SyncIO$FlatMap() {
}
$h_Lcats_effect_SyncIO$FlatMap.prototype = $c_Lcats_effect_SyncIO$FlatMap.prototype;
$c_Lcats_effect_SyncIO$FlatMap.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$FlatMap.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_SyncIO$FlatMap.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$FlatMap)) {
    var x$0$2 = $as_Lcats_effect_SyncIO$FlatMap(x$0);
    var x = this.Lcats_effect_SyncIO$FlatMap__f_ioe;
    var x$2 = $n(x$0$2).Lcats_effect_SyncIO$FlatMap__f_ioe;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_SyncIO$FlatMap__f_f;
      var x$4 = $n(x$0$2).Lcats_effect_SyncIO$FlatMap__f_f;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_SyncIO$FlatMap.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_SyncIO$FlatMap.prototype.productPrefix__T = (function() {
  return "FlatMap";
});
$c_Lcats_effect_SyncIO$FlatMap.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$FlatMap__f_ioe;
  }
  if ((n === 1)) {
    return this.Lcats_effect_SyncIO$FlatMap__f_f;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$FlatMap.prototype.tag__B = (function() {
  return 4;
});
function $as_Lcats_effect_SyncIO$FlatMap(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO$FlatMap) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$FlatMap"));
}
function $isArrayOf_Lcats_effect_SyncIO$FlatMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$FlatMap)));
}
function $asArrayOf_Lcats_effect_SyncIO$FlatMap(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$FlatMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$FlatMap;", depth));
}
var $d_Lcats_effect_SyncIO$FlatMap = new $TypeData().initClass($c_Lcats_effect_SyncIO$FlatMap, "cats.effect.SyncIO$FlatMap", ({
  Lcats_effect_SyncIO$FlatMap: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lcats_effect_SyncIO$HandleErrorWith(ioa, f) {
  this.Lcats_effect_SyncIO$HandleErrorWith__f_ioa = null;
  this.Lcats_effect_SyncIO$HandleErrorWith__f_f = null;
  this.Lcats_effect_SyncIO$HandleErrorWith__f_ioa = ioa;
  this.Lcats_effect_SyncIO$HandleErrorWith__f_f = f;
}
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.constructor = $c_Lcats_effect_SyncIO$HandleErrorWith;
/** @constructor */
function $h_Lcats_effect_SyncIO$HandleErrorWith() {
}
$h_Lcats_effect_SyncIO$HandleErrorWith.prototype = $c_Lcats_effect_SyncIO$HandleErrorWith.prototype;
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$HandleErrorWith)) {
    var x$0$2 = $as_Lcats_effect_SyncIO$HandleErrorWith(x$0);
    var x = this.Lcats_effect_SyncIO$HandleErrorWith__f_ioa;
    var x$2 = $n(x$0$2).Lcats_effect_SyncIO$HandleErrorWith__f_ioa;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_SyncIO$HandleErrorWith__f_f;
      var x$4 = $n(x$0$2).Lcats_effect_SyncIO$HandleErrorWith__f_f;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.productPrefix__T = (function() {
  return "HandleErrorWith";
});
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$HandleErrorWith__f_ioa;
  }
  if ((n === 1)) {
    return this.Lcats_effect_SyncIO$HandleErrorWith__f_f;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.tag__B = (function() {
  return 5;
});
function $as_Lcats_effect_SyncIO$HandleErrorWith(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO$HandleErrorWith) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$HandleErrorWith"));
}
function $isArrayOf_Lcats_effect_SyncIO$HandleErrorWith(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$HandleErrorWith)));
}
function $asArrayOf_Lcats_effect_SyncIO$HandleErrorWith(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$HandleErrorWith(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$HandleErrorWith;", depth));
}
var $d_Lcats_effect_SyncIO$HandleErrorWith = new $TypeData().initClass($c_Lcats_effect_SyncIO$HandleErrorWith, "cats.effect.SyncIO$HandleErrorWith", ({
  Lcats_effect_SyncIO$HandleErrorWith: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
function $as_Lcats_effect_SyncIO$Map(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$Map"));
}
function $isArrayOf_Lcats_effect_SyncIO$Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Map)));
}
function $asArrayOf_Lcats_effect_SyncIO$Map(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$Map;", depth));
}
/** @constructor */
function $c_Lcats_effect_SyncIO$Pure(value) {
  this.Lcats_effect_SyncIO$Pure__f_value = null;
  this.Lcats_effect_SyncIO$Pure__f_value = value;
}
$c_Lcats_effect_SyncIO$Pure.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Pure.prototype.constructor = $c_Lcats_effect_SyncIO$Pure;
/** @constructor */
function $h_Lcats_effect_SyncIO$Pure() {
}
$h_Lcats_effect_SyncIO$Pure.prototype = $c_Lcats_effect_SyncIO$Pure.prototype;
$c_Lcats_effect_SyncIO$Pure.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$Pure.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_SyncIO$Pure.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$Pure)) {
    var x$0$2 = $as_Lcats_effect_SyncIO$Pure(x$0);
    var x = this.Lcats_effect_SyncIO$Pure__f_value;
    var y = $n(x$0$2).Lcats_effect_SyncIO$Pure__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_SyncIO$Pure.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_SyncIO$Pure.prototype.productPrefix__T = (function() {
  return "Pure";
});
$c_Lcats_effect_SyncIO$Pure.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$Pure__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Pure.prototype.tag__B = (function() {
  return 0;
});
$c_Lcats_effect_SyncIO$Pure.prototype.toString__T = (function() {
  return (("SyncIO(" + this.Lcats_effect_SyncIO$Pure__f_value) + ")");
});
function $as_Lcats_effect_SyncIO$Pure(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO$Pure) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$Pure"));
}
function $isArrayOf_Lcats_effect_SyncIO$Pure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Pure)));
}
function $asArrayOf_Lcats_effect_SyncIO$Pure(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$Pure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$Pure;", depth));
}
var $d_Lcats_effect_SyncIO$Pure = new $TypeData().initClass($c_Lcats_effect_SyncIO$Pure, "cats.effect.SyncIO$Pure", ({
  Lcats_effect_SyncIO$Pure: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lcats_effect_SyncIO$Success(value) {
  this.Lcats_effect_SyncIO$Success__f_value = null;
  this.Lcats_effect_SyncIO$Success__f_value = value;
}
$c_Lcats_effect_SyncIO$Success.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Success.prototype.constructor = $c_Lcats_effect_SyncIO$Success;
/** @constructor */
function $h_Lcats_effect_SyncIO$Success() {
}
$h_Lcats_effect_SyncIO$Success.prototype = $c_Lcats_effect_SyncIO$Success.prototype;
$c_Lcats_effect_SyncIO$Success.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$Success.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_SyncIO$Success.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$Success)) {
    var x$0$2 = $as_Lcats_effect_SyncIO$Success(x$0);
    var x = this.Lcats_effect_SyncIO$Success__f_value;
    var y = $n(x$0$2).Lcats_effect_SyncIO$Success__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_SyncIO$Success.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_SyncIO$Success.prototype.productPrefix__T = (function() {
  return "Success";
});
$c_Lcats_effect_SyncIO$Success.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$Success__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Success.prototype.tag__B = (function() {
  return 6;
});
function $as_Lcats_effect_SyncIO$Success(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO$Success) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$Success"));
}
function $isArrayOf_Lcats_effect_SyncIO$Success(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Success)));
}
function $asArrayOf_Lcats_effect_SyncIO$Success(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$Success(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$Success;", depth));
}
var $d_Lcats_effect_SyncIO$Success = new $TypeData().initClass($c_Lcats_effect_SyncIO$Success, "cats.effect.SyncIO$Success", ({
  Lcats_effect_SyncIO$Success: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lcats_effect_SyncIO$Suspend(hint, thunk) {
  this.Lcats_effect_SyncIO$Suspend__f_hint = null;
  this.Lcats_effect_SyncIO$Suspend__f_thunk = null;
  this.Lcats_effect_SyncIO$Suspend__f_hint = hint;
  this.Lcats_effect_SyncIO$Suspend__f_thunk = thunk;
}
$c_Lcats_effect_SyncIO$Suspend.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Suspend.prototype.constructor = $c_Lcats_effect_SyncIO$Suspend;
/** @constructor */
function $h_Lcats_effect_SyncIO$Suspend() {
}
$h_Lcats_effect_SyncIO$Suspend.prototype = $c_Lcats_effect_SyncIO$Suspend.prototype;
$c_Lcats_effect_SyncIO$Suspend.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$Suspend.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_SyncIO$Suspend.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$Suspend)) {
    var x$0$2 = $as_Lcats_effect_SyncIO$Suspend(x$0);
    var x = this.Lcats_effect_SyncIO$Suspend__f_hint;
    var x$2 = $n(x$0$2).Lcats_effect_SyncIO$Suspend__f_hint;
    if ((x === null)) {
      var $x_1 = (x$2 === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === x$2);
    }
    if ($x_1) {
      var x$3 = this.Lcats_effect_SyncIO$Suspend__f_thunk;
      var x$4 = $n(x$0$2).Lcats_effect_SyncIO$Suspend__f_thunk;
      if ((x$3 === null)) {
        return (x$4 === null);
      } else {
        var this$2 = $n(x$3);
        return (this$2 === x$4);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_SyncIO$Suspend.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_SyncIO$Suspend.prototype.productPrefix__T = (function() {
  return "Suspend";
});
$c_Lcats_effect_SyncIO$Suspend.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$Suspend__f_hint;
  }
  if ((n === 1)) {
    return this.Lcats_effect_SyncIO$Suspend__f_thunk;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Suspend.prototype.tag__B = (function() {
  return 1;
});
function $as_Lcats_effect_SyncIO$Suspend(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO$Suspend) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$Suspend"));
}
function $isArrayOf_Lcats_effect_SyncIO$Suspend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Suspend)));
}
function $asArrayOf_Lcats_effect_SyncIO$Suspend(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$Suspend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$Suspend;", depth));
}
var $d_Lcats_effect_SyncIO$Suspend = new $TypeData().initClass($c_Lcats_effect_SyncIO$Suspend, "cats.effect.SyncIO$Suspend", ({
  Lcats_effect_SyncIO$Suspend: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Deferred$TransformedDeferred(underlying, trans) {
  this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_underlying = null;
  this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_trans = null;
  this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_underlying = underlying;
  this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_trans = trans;
}
$c_Lcats_effect_kernel_Deferred$TransformedDeferred.prototype = new $h_Lcats_effect_kernel_Deferred();
$c_Lcats_effect_kernel_Deferred$TransformedDeferred.prototype.constructor = $c_Lcats_effect_kernel_Deferred$TransformedDeferred;
/** @constructor */
function $h_Lcats_effect_kernel_Deferred$TransformedDeferred() {
}
$h_Lcats_effect_kernel_Deferred$TransformedDeferred.prototype = $c_Lcats_effect_kernel_Deferred$TransformedDeferred.prototype;
$c_Lcats_effect_kernel_Deferred$TransformedDeferred.prototype.get__O = (function() {
  return $n(this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_trans).apply__O__O($n(this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_underlying).get__O());
});
$c_Lcats_effect_kernel_Deferred$TransformedDeferred.prototype.tryGet__O = (function() {
  return $n(this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_trans).apply__O__O($n(this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_underlying).tryGet__O());
});
$c_Lcats_effect_kernel_Deferred$TransformedDeferred.prototype.complete__O__O = (function(a) {
  return $n(this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_trans).apply__O__O($n(this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_underlying).complete__O__O(a));
});
var $d_Lcats_effect_kernel_Deferred$TransformedDeferred = new $TypeData().initClass($c_Lcats_effect_kernel_Deferred$TransformedDeferred, "cats.effect.kernel.Deferred$TransformedDeferred", ({
  Lcats_effect_kernel_Deferred$TransformedDeferred: 1,
  Lcats_effect_kernel_Deferred: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_DeferredSource: 1,
  Lcats_effect_kernel_DeferredSink: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_MonadCancel$$anon$1(fin$18, outer) {
  this.Lcats_effect_kernel_MonadCancel$$anon$1__f_fin$3 = null;
  this.Lcats_effect_kernel_MonadCancel$$anon$1__f_$outer = null;
  this.Lcats_effect_kernel_MonadCancel$$anon$1__f_fin$3 = fin$18;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_kernel_MonadCancel$$anon$1__f_$outer = outer;
}
$c_Lcats_effect_kernel_MonadCancel$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcats_effect_kernel_MonadCancel$$anon$1.prototype.constructor = $c_Lcats_effect_kernel_MonadCancel$$anon$1;
/** @constructor */
function $h_Lcats_effect_kernel_MonadCancel$$anon$1() {
}
$h_Lcats_effect_kernel_MonadCancel$$anon$1.prototype = $c_Lcats_effect_kernel_MonadCancel$$anon$1.prototype;
$c_Lcats_effect_kernel_MonadCancel$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return true;
});
$c_Lcats_effect_kernel_MonadCancel$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $n(this.Lcats_effect_kernel_MonadCancel$$anon$1__f_$outer).handleError__O__F1__O($n(this.Lcats_effect_kernel_MonadCancel$$anon$1__f_fin$3).apply__O__O(new $c_Lcats_effect_kernel_Outcome$Errored(x)), new $c_sjsr_AnonFunction1(((_$3) => (void 0))));
});
var $d_Lcats_effect_kernel_MonadCancel$$anon$1 = new $TypeData().initClass($c_Lcats_effect_kernel_MonadCancel$$anon$1, "cats.effect.kernel.MonadCancel$$anon$1", ({
  Lcats_effect_kernel_MonadCancel$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Outcome$Canceled() {
}
$c_Lcats_effect_kernel_Outcome$Canceled.prototype = new $h_O();
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.constructor = $c_Lcats_effect_kernel_Outcome$Canceled;
/** @constructor */
function $h_Lcats_effect_kernel_Outcome$Canceled() {
}
$h_Lcats_effect_kernel_Outcome$Canceled.prototype = $c_Lcats_effect_kernel_Outcome$Canceled.prototype;
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$0), true)));
});
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.productPrefix__T = (function() {
  return "Canceled";
});
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_kernel_Outcome$Canceled(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Outcome$Canceled) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Outcome$Canceled"));
}
function $isArrayOf_Lcats_effect_kernel_Outcome$Canceled(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Outcome$Canceled)));
}
function $asArrayOf_Lcats_effect_kernel_Outcome$Canceled(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Outcome$Canceled(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Outcome$Canceled;", depth));
}
var $d_Lcats_effect_kernel_Outcome$Canceled = new $TypeData().initClass($c_Lcats_effect_kernel_Outcome$Canceled, "cats.effect.kernel.Outcome$Canceled", ({
  Lcats_effect_kernel_Outcome$Canceled: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Outcome: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Outcome$Errored(e) {
  this.Lcats_effect_kernel_Outcome$Errored__f_e = null;
  this.Lcats_effect_kernel_Outcome$Errored__f_e = e;
}
$c_Lcats_effect_kernel_Outcome$Errored.prototype = new $h_O();
$c_Lcats_effect_kernel_Outcome$Errored.prototype.constructor = $c_Lcats_effect_kernel_Outcome$Errored;
/** @constructor */
function $h_Lcats_effect_kernel_Outcome$Errored() {
}
$h_Lcats_effect_kernel_Outcome$Errored.prototype = $c_Lcats_effect_kernel_Outcome$Errored.prototype;
$c_Lcats_effect_kernel_Outcome$Errored.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Outcome$Errored.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_kernel_Outcome$Errored.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
    var x$0$2 = $as_Lcats_effect_kernel_Outcome$Errored(x$0);
    var x = this.Lcats_effect_kernel_Outcome$Errored__f_e;
    var y = $n(x$0$2).Lcats_effect_kernel_Outcome$Errored__f_e;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Outcome$Errored.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Outcome$Errored.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_kernel_Outcome$Errored.prototype.productPrefix__T = (function() {
  return "Errored";
});
$c_Lcats_effect_kernel_Outcome$Errored.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Outcome$Errored__f_e;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_kernel_Outcome$Errored(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Outcome$Errored) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Outcome$Errored"));
}
function $isArrayOf_Lcats_effect_kernel_Outcome$Errored(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Outcome$Errored)));
}
function $asArrayOf_Lcats_effect_kernel_Outcome$Errored(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Outcome$Errored(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Outcome$Errored;", depth));
}
var $d_Lcats_effect_kernel_Outcome$Errored = new $TypeData().initClass($c_Lcats_effect_kernel_Outcome$Errored, "cats.effect.kernel.Outcome$Errored", ({
  Lcats_effect_kernel_Outcome$Errored: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Outcome: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Outcome$Succeeded(fa) {
  this.Lcats_effect_kernel_Outcome$Succeeded__f_fa = null;
  this.Lcats_effect_kernel_Outcome$Succeeded__f_fa = fa;
}
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype = new $h_O();
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.constructor = $c_Lcats_effect_kernel_Outcome$Succeeded;
/** @constructor */
function $h_Lcats_effect_kernel_Outcome$Succeeded() {
}
$h_Lcats_effect_kernel_Outcome$Succeeded.prototype = $c_Lcats_effect_kernel_Outcome$Succeeded.prototype;
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
    var x$0$2 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$0);
    var x = this.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
    var y = $n(x$0$2).Lcats_effect_kernel_Outcome$Succeeded__f_fa;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.productPrefix__T = (function() {
  return "Succeeded";
});
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_kernel_Outcome$Succeeded(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Outcome$Succeeded) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Outcome$Succeeded"));
}
function $isArrayOf_Lcats_effect_kernel_Outcome$Succeeded(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Outcome$Succeeded)));
}
function $asArrayOf_Lcats_effect_kernel_Outcome$Succeeded(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Outcome$Succeeded(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Outcome$Succeeded;", depth));
}
var $d_Lcats_effect_kernel_Outcome$Succeeded = new $TypeData().initClass($c_Lcats_effect_kernel_Outcome$Succeeded, "cats.effect.kernel.Outcome$Succeeded", ({
  Lcats_effect_kernel_Outcome$Succeeded: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Outcome: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Ref$TransformedRef(underlying, trans, F) {
  this.Lcats_effect_kernel_Ref$TransformedRef__f_underlying = null;
  this.Lcats_effect_kernel_Ref$TransformedRef__f_trans = null;
  this.Lcats_effect_kernel_Ref$TransformedRef__f_F = null;
  this.Lcats_effect_kernel_Ref$TransformedRef__f_underlying = underlying;
  this.Lcats_effect_kernel_Ref$TransformedRef__f_trans = trans;
  this.Lcats_effect_kernel_Ref$TransformedRef__f_F = F;
}
$c_Lcats_effect_kernel_Ref$TransformedRef.prototype = new $h_Lcats_effect_kernel_Ref();
$c_Lcats_effect_kernel_Ref$TransformedRef.prototype.constructor = $c_Lcats_effect_kernel_Ref$TransformedRef;
/** @constructor */
function $h_Lcats_effect_kernel_Ref$TransformedRef() {
}
$h_Lcats_effect_kernel_Ref$TransformedRef.prototype = $c_Lcats_effect_kernel_Ref$TransformedRef.prototype;
$c_Lcats_effect_kernel_Ref$TransformedRef.prototype.get__O = (function() {
  return $n(this.Lcats_effect_kernel_Ref$TransformedRef__f_trans).apply__O__O($n(this.Lcats_effect_kernel_Ref$TransformedRef__f_underlying).get__O());
});
$c_Lcats_effect_kernel_Ref$TransformedRef.prototype.set__O__O = (function(a) {
  return $n(this.Lcats_effect_kernel_Ref$TransformedRef__f_trans).apply__O__O($n(this.Lcats_effect_kernel_Ref$TransformedRef__f_underlying).set__O__O(a));
});
$c_Lcats_effect_kernel_Ref$TransformedRef.prototype.getAndSet__O__O = (function(a) {
  return $n(this.Lcats_effect_kernel_Ref$TransformedRef__f_trans).apply__O__O($n(this.Lcats_effect_kernel_Ref$TransformedRef__f_underlying).getAndSet__O__O(a));
});
$c_Lcats_effect_kernel_Ref$TransformedRef.prototype.update__F1__O = (function(f) {
  return $n(this.Lcats_effect_kernel_Ref$TransformedRef__f_trans).apply__O__O($n(this.Lcats_effect_kernel_Ref$TransformedRef__f_underlying).update__F1__O(f));
});
$c_Lcats_effect_kernel_Ref$TransformedRef.prototype.modify__F1__O = (function(f) {
  return $n(this.Lcats_effect_kernel_Ref$TransformedRef__f_trans).apply__O__O($n(this.Lcats_effect_kernel_Ref$TransformedRef__f_underlying).modify__F1__O(f));
});
$c_Lcats_effect_kernel_Ref$TransformedRef.prototype.access__O = (function() {
  var $x_1 = $n(this.Lcats_effect_kernel_Ref$TransformedRef__f_trans);
  var this$2 = $n(this.Lcats_effect_kernel_Ref$TransformedRef__f_F);
  var this$1 = $m_Lcats_Invariant$();
  var evidence$1 = $f_Lcats_instances_NTupleMonadInstances__catsStdInstancesForTuple2__Lcats_Comonad(this$1);
  var this$5 = new $c_Lcats_Functor$$anon$1(evidence$1, this$2);
  $m_Lcats_instances_package$function$();
  var evidence$1$1 = new $c_Lcats_instances_Function1Instances0$$anon$11();
  var this$7 = new $c_Lcats_Functor$$anon$1(evidence$1$1, this$5);
  var fga = $n(this.Lcats_effect_kernel_Ref$TransformedRef__f_underlying).access__O();
  var f = new $c_sjsr_AnonFunction1(((_$26) => $n(this.Lcats_effect_kernel_Ref$TransformedRef__f_trans).apply__O__O(_$26)));
  return $n($x_1).apply__O__O($f_Lcats_ComposedFunctor__map__O__F1__O(this$7, fga, f));
});
var $d_Lcats_effect_kernel_Ref$TransformedRef = new $TypeData().initClass($c_Lcats_effect_kernel_Ref$TransformedRef, "cats.effect.kernel.Ref$TransformedRef", ({
  Lcats_effect_kernel_Ref$TransformedRef: 1,
  Lcats_effect_kernel_Ref: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_RefSource: 1,
  Lcats_effect_kernel_RefSink: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$$anon$2(F$93, rel$4) {
  this.Lcats_effect_kernel_Resource$$anon$2__f_F$41 = null;
  this.Lcats_effect_kernel_Resource$$anon$2__f_rel$2 = null;
  this.Lcats_effect_kernel_Resource$$anon$2__f_F$41 = F$93;
  this.Lcats_effect_kernel_Resource$$anon$2__f_rel$2 = rel$4;
}
$c_Lcats_effect_kernel_Resource$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcats_effect_kernel_Resource$$anon$2.prototype.constructor = $c_Lcats_effect_kernel_Resource$$anon$2;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$$anon$2() {
}
$h_Lcats_effect_kernel_Resource$$anon$2.prototype = $c_Lcats_effect_kernel_Resource$$anon$2.prototype;
$c_Lcats_effect_kernel_Resource$$anon$2.prototype.isDefinedAt__jl_Throwable__Z = (function(x) {
  return true;
});
$c_Lcats_effect_kernel_Resource$$anon$2.prototype.applyOrElse__jl_Throwable__F1__O = (function(x, default$1) {
  var fa = $n(this.Lcats_effect_kernel_Resource$$anon$2__f_rel$2).apply__O__O(new $c_Lcats_effect_kernel_Resource$ExitCase$Errored(x));
  var f = new $c_sjsr_AnonFunction1(((_$26) => {
    $as_jl_Throwable(_$26);
  }));
  var F$1 = this.Lcats_effect_kernel_Resource$$anon$2__f_F$41;
  return $n(F$1).handleError__O__F1__O(fa, f);
});
$c_Lcats_effect_kernel_Resource$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x));
});
$c_Lcats_effect_kernel_Resource$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O($as_jl_Throwable(x), default$1);
});
var $d_Lcats_effect_kernel_Resource$$anon$2 = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$$anon$2, "cats.effect.kernel.Resource$$anon$2", ({
  Lcats_effect_kernel_Resource$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Allocate(resource) {
  this.Lcats_effect_kernel_Resource$Allocate__f_resource = null;
  this.Lcats_effect_kernel_Resource$Allocate__f_resource = resource;
}
$c_Lcats_effect_kernel_Resource$Allocate.prototype = new $h_Lcats_effect_kernel_Resource();
$c_Lcats_effect_kernel_Resource$Allocate.prototype.constructor = $c_Lcats_effect_kernel_Resource$Allocate;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Allocate() {
}
$h_Lcats_effect_kernel_Resource$Allocate.prototype = $c_Lcats_effect_kernel_Resource$Allocate.prototype;
$c_Lcats_effect_kernel_Resource$Allocate.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$Allocate.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_kernel_Resource$Allocate.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$Allocate)) {
    var x$0$2 = $as_Lcats_effect_kernel_Resource$Allocate(x$0);
    var x = this.Lcats_effect_kernel_Resource$Allocate__f_resource;
    var x$2 = $n(x$0$2).Lcats_effect_kernel_Resource$Allocate__f_resource;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Resource$Allocate.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Resource$Allocate.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_kernel_Resource$Allocate.prototype.productPrefix__T = (function() {
  return "Allocate";
});
$c_Lcats_effect_kernel_Resource$Allocate.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Resource$Allocate__f_resource;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_kernel_Resource$Allocate(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Allocate) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Allocate"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$Allocate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Allocate)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$Allocate(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Allocate(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Allocate;", depth));
}
var $d_Lcats_effect_kernel_Resource$Allocate = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$Allocate, "cats.effect.kernel.Resource$Allocate", ({
  Lcats_effect_kernel_Resource$Allocate: 1,
  Lcats_effect_kernel_Resource: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Bind(source, fs) {
  this.Lcats_effect_kernel_Resource$Bind__f_source = null;
  this.Lcats_effect_kernel_Resource$Bind__f_fs = null;
  this.Lcats_effect_kernel_Resource$Bind__f_source = source;
  this.Lcats_effect_kernel_Resource$Bind__f_fs = fs;
}
$c_Lcats_effect_kernel_Resource$Bind.prototype = new $h_Lcats_effect_kernel_Resource();
$c_Lcats_effect_kernel_Resource$Bind.prototype.constructor = $c_Lcats_effect_kernel_Resource$Bind;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Bind() {
}
$h_Lcats_effect_kernel_Resource$Bind.prototype = $c_Lcats_effect_kernel_Resource$Bind.prototype;
$c_Lcats_effect_kernel_Resource$Bind.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$Bind.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_kernel_Resource$Bind.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$Bind)) {
    var x$0$2 = $as_Lcats_effect_kernel_Resource$Bind(x$0);
    var x = this.Lcats_effect_kernel_Resource$Bind__f_source;
    var x$2 = $n(x$0$2).Lcats_effect_kernel_Resource$Bind__f_source;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_kernel_Resource$Bind__f_fs;
      var x$4 = $n(x$0$2).Lcats_effect_kernel_Resource$Bind__f_fs;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Resource$Bind.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Resource$Bind.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_kernel_Resource$Bind.prototype.productPrefix__T = (function() {
  return "Bind";
});
$c_Lcats_effect_kernel_Resource$Bind.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Resource$Bind__f_source;
  }
  if ((n === 1)) {
    return this.Lcats_effect_kernel_Resource$Bind__f_fs;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_kernel_Resource$Bind(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Bind) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Bind"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$Bind(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Bind)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$Bind(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Bind(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Bind;", depth));
}
var $d_Lcats_effect_kernel_Resource$Bind = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$Bind, "cats.effect.kernel.Resource$Bind", ({
  Lcats_effect_kernel_Resource$Bind: 1,
  Lcats_effect_kernel_Resource: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Eval(fa) {
  this.Lcats_effect_kernel_Resource$Eval__f_fa = null;
  this.Lcats_effect_kernel_Resource$Eval__f_fa = fa;
}
$c_Lcats_effect_kernel_Resource$Eval.prototype = new $h_Lcats_effect_kernel_Resource();
$c_Lcats_effect_kernel_Resource$Eval.prototype.constructor = $c_Lcats_effect_kernel_Resource$Eval;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Eval() {
}
$h_Lcats_effect_kernel_Resource$Eval.prototype = $c_Lcats_effect_kernel_Resource$Eval.prototype;
$c_Lcats_effect_kernel_Resource$Eval.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$Eval.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_kernel_Resource$Eval.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$Eval)) {
    var x$0$2 = $as_Lcats_effect_kernel_Resource$Eval(x$0);
    var x = this.Lcats_effect_kernel_Resource$Eval__f_fa;
    var y = $n(x$0$2).Lcats_effect_kernel_Resource$Eval__f_fa;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Resource$Eval.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Resource$Eval.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_kernel_Resource$Eval.prototype.productPrefix__T = (function() {
  return "Eval";
});
$c_Lcats_effect_kernel_Resource$Eval.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Resource$Eval__f_fa;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_kernel_Resource$Eval(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Eval) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Eval"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$Eval(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Eval)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$Eval(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Eval(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Eval;", depth));
}
var $d_Lcats_effect_kernel_Resource$Eval = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$Eval, "cats.effect.kernel.Resource$Eval", ({
  Lcats_effect_kernel_Resource$Eval: 1,
  Lcats_effect_kernel_Resource: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$ExitCase$Errored(e) {
  this.Lcats_effect_kernel_Resource$ExitCase$Errored__f_e = null;
  this.Lcats_effect_kernel_Resource$ExitCase$Errored__f_e = e;
}
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.constructor = $c_Lcats_effect_kernel_Resource$ExitCase$Errored;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$ExitCase$Errored() {
}
$h_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype = $c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype;
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$ExitCase$Errored)) {
    var x$0$2 = $as_Lcats_effect_kernel_Resource$ExitCase$Errored(x$0);
    var x = this.Lcats_effect_kernel_Resource$ExitCase$Errored__f_e;
    var x$2 = $n(x$0$2).Lcats_effect_kernel_Resource$ExitCase$Errored__f_e;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.productPrefix__T = (function() {
  return "Errored";
});
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Resource$ExitCase$Errored__f_e;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_kernel_Resource$ExitCase$Errored(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$ExitCase$Errored) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$ExitCase$Errored"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$ExitCase$Errored(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$ExitCase$Errored)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$ExitCase$Errored(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$ExitCase$Errored(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$ExitCase$Errored;", depth));
}
var $d_Lcats_effect_kernel_Resource$ExitCase$Errored = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$ExitCase$Errored, "cats.effect.kernel.Resource$ExitCase$Errored", ({
  Lcats_effect_kernel_Resource$ExitCase$Errored: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Resource$ExitCase: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Frame$1(outer, head, tail) {
  this.Lcats_effect_kernel_Resource$Frame$1__f_head = null;
  this.Lcats_effect_kernel_Resource$Frame$1__f_tail = null;
  this.Lcats_effect_kernel_Resource$Frame$1__f_head = head;
  this.Lcats_effect_kernel_Resource$Frame$1__f_tail = tail;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_effect_kernel_Resource$Frame$1.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.constructor = $c_Lcats_effect_kernel_Resource$Frame$1;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Frame$1() {
}
$h_Lcats_effect_kernel_Resource$Frame$1.prototype = $c_Lcats_effect_kernel_Resource$Frame$1.prototype;
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$Frame$1)) {
    var x$0$2 = $as_Lcats_effect_kernel_Resource$Frame$1(x$0);
    var x = this.Lcats_effect_kernel_Resource$Frame$1__f_head;
    var x$2 = $n(x$0$2).Lcats_effect_kernel_Resource$Frame$1__f_head;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_kernel_Resource$Frame$1__f_tail;
      var x$4 = $n(x$0$2).Lcats_effect_kernel_Resource$Frame$1__f_tail;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.productPrefix__T = (function() {
  return "Frame";
});
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Resource$Frame$1__f_head;
  }
  if ((n === 1)) {
    return this.Lcats_effect_kernel_Resource$Frame$1__f_tail;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_kernel_Resource$Frame$1(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Frame$1) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Frame$1"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$Frame$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Frame$1)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$Frame$1(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Frame$1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Frame$1;", depth));
}
var $d_Lcats_effect_kernel_Resource$Frame$1 = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$Frame$1, "cats.effect.kernel.Resource$Frame$1", ({
  Lcats_effect_kernel_Resource$Frame$1: 1,
  Lcats_effect_kernel_Resource$Stack$1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Frame$4(outer, head, tail) {
  this.Lcats_effect_kernel_Resource$Frame$4__f_head = null;
  this.Lcats_effect_kernel_Resource$Frame$4__f_tail = null;
  this.Lcats_effect_kernel_Resource$Frame$4__f_head = head;
  this.Lcats_effect_kernel_Resource$Frame$4__f_tail = tail;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_effect_kernel_Resource$Frame$4.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$Frame$4.prototype.constructor = $c_Lcats_effect_kernel_Resource$Frame$4;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Frame$4() {
}
$h_Lcats_effect_kernel_Resource$Frame$4.prototype = $c_Lcats_effect_kernel_Resource$Frame$4.prototype;
$c_Lcats_effect_kernel_Resource$Frame$4.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$Frame$4.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_kernel_Resource$Frame$4.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$Frame$4)) {
    var x$0$2 = $as_Lcats_effect_kernel_Resource$Frame$4(x$0);
    var x = this.Lcats_effect_kernel_Resource$Frame$4__f_head;
    var x$2 = $n(x$0$2).Lcats_effect_kernel_Resource$Frame$4__f_head;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_kernel_Resource$Frame$4__f_tail;
      var x$4 = $n(x$0$2).Lcats_effect_kernel_Resource$Frame$4__f_tail;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Resource$Frame$4.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Resource$Frame$4.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_kernel_Resource$Frame$4.prototype.productPrefix__T = (function() {
  return "Frame";
});
$c_Lcats_effect_kernel_Resource$Frame$4.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Resource$Frame$4__f_head;
  }
  if ((n === 1)) {
    return this.Lcats_effect_kernel_Resource$Frame$4__f_tail;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_kernel_Resource$Frame$4(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Frame$4) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Frame$4"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$Frame$4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Frame$4)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$Frame$4(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Frame$4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Frame$4;", depth));
}
var $d_Lcats_effect_kernel_Resource$Frame$4 = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$Frame$4, "cats.effect.kernel.Resource$Frame$4", ({
  Lcats_effect_kernel_Resource$Frame$4: 1,
  Lcats_effect_kernel_Resource$Stack$2: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Pure(a) {
  this.Lcats_effect_kernel_Resource$Pure__f_a = null;
  this.Lcats_effect_kernel_Resource$Pure__f_a = a;
}
$c_Lcats_effect_kernel_Resource$Pure.prototype = new $h_Lcats_effect_kernel_Resource();
$c_Lcats_effect_kernel_Resource$Pure.prototype.constructor = $c_Lcats_effect_kernel_Resource$Pure;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Pure() {
}
$h_Lcats_effect_kernel_Resource$Pure.prototype = $c_Lcats_effect_kernel_Resource$Pure.prototype;
$c_Lcats_effect_kernel_Resource$Pure.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$Pure.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_kernel_Resource$Pure.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$Pure)) {
    var x$0$2 = $as_Lcats_effect_kernel_Resource$Pure(x$0);
    var x = this.Lcats_effect_kernel_Resource$Pure__f_a;
    var y = $n(x$0$2).Lcats_effect_kernel_Resource$Pure__f_a;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Resource$Pure.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Resource$Pure.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_kernel_Resource$Pure.prototype.productPrefix__T = (function() {
  return "Pure";
});
$c_Lcats_effect_kernel_Resource$Pure.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Resource$Pure__f_a;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_kernel_Resource$Pure(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Pure) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Pure"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$Pure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Pure)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$Pure(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Pure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Pure;", depth));
}
var $d_Lcats_effect_kernel_Resource$Pure = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$Pure, "cats.effect.kernel.Resource$Pure", ({
  Lcats_effect_kernel_Resource$Pure: 1,
  Lcats_effect_kernel_Resource: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
function $p_Lcats_effect_kernel_SyncRef__setter$1__O__F1($thiz, snapshot$1) {
  return new $c_sjsr_AnonFunction1(((a) => $n($thiz.Lcats_effect_kernel_SyncRef__f_F).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
    if (Object.is($thiz.Lcats_effect_kernel_SyncRef__f_value, snapshot$1)) {
      $thiz.Lcats_effect_kernel_SyncRef__f_value = a;
      return true;
    } else {
      return false;
    }
  })))));
}
/** @constructor */
function $c_Lcats_effect_kernel_SyncRef(value, F) {
  this.Lcats_effect_kernel_SyncRef__f_value = null;
  this.Lcats_effect_kernel_SyncRef__f_F = null;
  this.Lcats_effect_kernel_SyncRef__f_value = value;
  this.Lcats_effect_kernel_SyncRef__f_F = F;
}
$c_Lcats_effect_kernel_SyncRef.prototype = new $h_Lcats_effect_kernel_Ref();
$c_Lcats_effect_kernel_SyncRef.prototype.constructor = $c_Lcats_effect_kernel_SyncRef;
/** @constructor */
function $h_Lcats_effect_kernel_SyncRef() {
}
$h_Lcats_effect_kernel_SyncRef.prototype = $c_Lcats_effect_kernel_SyncRef.prototype;
$c_Lcats_effect_kernel_SyncRef.prototype.get__O = (function() {
  return $n(this.Lcats_effect_kernel_SyncRef__f_F).delay__F0__O(new $c_sjsr_AnonFunction0((() => this.Lcats_effect_kernel_SyncRef__f_value)));
});
$c_Lcats_effect_kernel_SyncRef.prototype.set__O__O = (function(a) {
  return $n(this.Lcats_effect_kernel_SyncRef__f_F).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
    this.Lcats_effect_kernel_SyncRef__f_value = a;
  })));
});
$c_Lcats_effect_kernel_SyncRef.prototype.getAndSet__O__O = (function(a) {
  return $n(this.Lcats_effect_kernel_SyncRef__f_F).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
    var current = this.Lcats_effect_kernel_SyncRef__f_value;
    this.Lcats_effect_kernel_SyncRef__f_value = a;
    return current;
  })));
});
$c_Lcats_effect_kernel_SyncRef.prototype.access__O = (function() {
  return $n(this.Lcats_effect_kernel_SyncRef__f_F).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
    var snapshot = this.Lcats_effect_kernel_SyncRef__f_value;
    var _2 = $p_Lcats_effect_kernel_SyncRef__setter$1__O__F1(this, snapshot);
    return new $c_T2(snapshot, _2);
  })));
});
$c_Lcats_effect_kernel_SyncRef.prototype.update__F1__O = (function(f) {
  return $n(this.Lcats_effect_kernel_SyncRef__f_F).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
    this.Lcats_effect_kernel_SyncRef__f_value = $n(f).apply__O__O(this.Lcats_effect_kernel_SyncRef__f_value);
  })));
});
$c_Lcats_effect_kernel_SyncRef.prototype.modify__F1__O = (function(f) {
  return $n(this.Lcats_effect_kernel_SyncRef__f_F).delay__F0__O(new $c_sjsr_AnonFunction0((() => {
    matchResult2: {
      var \u03b42$___1;
      var \u03b42$___2;
      var x4 = $as_T2($n(f).apply__O__O(this.Lcats_effect_kernel_SyncRef__f_value));
      if ((x4 !== null)) {
        var u = $n(x4)._1__O();
        var b = $n(x4)._2__O();
        var \u03b42$___1 = u;
        var \u03b42$___2 = b;
        break matchResult2;
      }
      throw new $c_s_MatchError(x4);
    }
    var u$2 = \u03b42$___1;
    var b$2 = \u03b42$___2;
    this.Lcats_effect_kernel_SyncRef__f_value = u$2;
    return b$2;
  })));
});
var $d_Lcats_effect_kernel_SyncRef = new $TypeData().initClass($c_Lcats_effect_kernel_SyncRef, "cats.effect.kernel.SyncRef", ({
  Lcats_effect_kernel_SyncRef: 1,
  Lcats_effect_kernel_Ref: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_RefSource: 1,
  Lcats_effect_kernel_RefSink: 1
}));
/** @constructor */
function $c_Lcats_effect_process$$anon$1() {
}
$c_Lcats_effect_process$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcats_effect_process$$anon$1.prototype.constructor = $c_Lcats_effect_process$$anon$1;
/** @constructor */
function $h_Lcats_effect_process$$anon$1() {
}
$h_Lcats_effect_process$$anon$1.prototype = $c_Lcats_effect_process$$anon$1.prototype;
$c_Lcats_effect_process$$anon$1.prototype.isDefinedAt__jl_Throwable__Z = (function(x) {
  return true;
});
$c_Lcats_effect_process$$anon$1.prototype.applyOrElse__jl_Throwable__F1__O = (function(x, default$1) {
  return (void 0);
});
$c_Lcats_effect_process$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x));
});
$c_Lcats_effect_process$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O($as_jl_Throwable(x), default$1);
});
var $d_Lcats_effect_process$$anon$1 = new $TypeData().initClass($c_Lcats_effect_process$$anon$1, "cats.effect.process$$anon$1", ({
  Lcats_effect_process$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(outer, latch) {
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_latch = null;
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_$outer = null;
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_latch = latch;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_$outer = outer;
}
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling() {
}
$h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling.prototype = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling.prototype;
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling) && ($n($as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(x$0)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_$outer === this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_$outer))) {
    var x$0$2 = $as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(x$0);
    var x = this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_latch;
    var x$2 = $n(x$0$2).Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_latch;
    if ((x === null)) {
      return (x$2 === null);
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2);
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling.prototype.productPrefix__T = (function() {
  return "Canceling";
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_latch;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$Executor$TaskState$3$Canceling"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$Executor$TaskState$3$Canceling;", depth));
}
var $d_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling, "cats.effect.std.Dispatcher$Executor$TaskState$3$Canceling", ({
  Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_std_Dispatcher$Executor$TaskState$1: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready(outer, task) {
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready__f_task = null;
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready__f_$outer = null;
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready__f_task = task;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready__f_$outer = outer;
}
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready() {
}
$h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready.prototype = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready.prototype;
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready) && ($n($as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready(x$0)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready__f_$outer === this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready__f_$outer))) {
    var x$0$2 = $as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready(x$0);
    var x = this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready__f_task;
    var y = $n(x$0$2).Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready__f_task;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready.prototype.productPrefix__T = (function() {
  return "Ready";
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready__f_task;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$Executor$TaskState$3$Ready"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$Executor$TaskState$3$Ready;", depth));
}
var $d_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready, "cats.effect.std.Dispatcher$Executor$TaskState$3$Ready", ({
  Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_std_Dispatcher$Executor$TaskState$1: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$RegState$CancelRequested(latch) {
  this.Lcats_effect_std_Dispatcher$RegState$CancelRequested__f_latch = null;
  this.Lcats_effect_std_Dispatcher$RegState$CancelRequested__f_latch = latch;
}
$c_Lcats_effect_std_Dispatcher$RegState$CancelRequested.prototype = new $h_Lcats_effect_std_Dispatcher$RegState();
$c_Lcats_effect_std_Dispatcher$RegState$CancelRequested.prototype.constructor = $c_Lcats_effect_std_Dispatcher$RegState$CancelRequested;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$RegState$CancelRequested() {
}
$h_Lcats_effect_std_Dispatcher$RegState$CancelRequested.prototype = $c_Lcats_effect_std_Dispatcher$RegState$CancelRequested.prototype;
$c_Lcats_effect_std_Dispatcher$RegState$CancelRequested.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_std_Dispatcher$RegState$CancelRequested.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_std_Dispatcher$RegState$CancelRequested)) {
    var x$0$2 = $as_Lcats_effect_std_Dispatcher$RegState$CancelRequested(x$0);
    var x = this.Lcats_effect_std_Dispatcher$RegState$CancelRequested__f_latch;
    var x$2 = $n(x$0$2).Lcats_effect_std_Dispatcher$RegState$CancelRequested__f_latch;
    if ((x === null)) {
      return (x$2 === null);
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2);
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_std_Dispatcher$RegState$CancelRequested.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_std_Dispatcher$RegState$CancelRequested.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_std_Dispatcher$RegState$CancelRequested.prototype.productPrefix__T = (function() {
  return "CancelRequested";
});
$c_Lcats_effect_std_Dispatcher$RegState$CancelRequested.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_std_Dispatcher$RegState$CancelRequested__f_latch;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_std_Dispatcher$RegState$CancelRequested(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$RegState$CancelRequested) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$RegState$CancelRequested"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$RegState$CancelRequested(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$RegState$CancelRequested)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$RegState$CancelRequested(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$RegState$CancelRequested(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$RegState$CancelRequested;", depth));
}
var $d_Lcats_effect_std_Dispatcher$RegState$CancelRequested = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$RegState$CancelRequested, "cats.effect.std.Dispatcher$RegState$CancelRequested", ({
  Lcats_effect_std_Dispatcher$RegState$CancelRequested: 1,
  Lcats_effect_std_Dispatcher$RegState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$RegState$Running(cancel) {
  this.Lcats_effect_std_Dispatcher$RegState$Running__f_cancel = null;
  this.Lcats_effect_std_Dispatcher$RegState$Running__f_cancel = cancel;
}
$c_Lcats_effect_std_Dispatcher$RegState$Running.prototype = new $h_Lcats_effect_std_Dispatcher$RegState();
$c_Lcats_effect_std_Dispatcher$RegState$Running.prototype.constructor = $c_Lcats_effect_std_Dispatcher$RegState$Running;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$RegState$Running() {
}
$h_Lcats_effect_std_Dispatcher$RegState$Running.prototype = $c_Lcats_effect_std_Dispatcher$RegState$Running.prototype;
$c_Lcats_effect_std_Dispatcher$RegState$Running.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_std_Dispatcher$RegState$Running.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_std_Dispatcher$RegState$Running)) {
    var x$0$2 = $as_Lcats_effect_std_Dispatcher$RegState$Running(x$0);
    var x = this.Lcats_effect_std_Dispatcher$RegState$Running__f_cancel;
    var y = $n(x$0$2).Lcats_effect_std_Dispatcher$RegState$Running__f_cancel;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_std_Dispatcher$RegState$Running.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_std_Dispatcher$RegState$Running.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_std_Dispatcher$RegState$Running.prototype.productPrefix__T = (function() {
  return "Running";
});
$c_Lcats_effect_std_Dispatcher$RegState$Running.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_std_Dispatcher$RegState$Running__f_cancel;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_std_Dispatcher$RegState$Running(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$RegState$Running) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$RegState$Running"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$RegState$Running(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$RegState$Running)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$RegState$Running(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$RegState$Running(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$RegState$Running;", depth));
}
var $d_Lcats_effect_std_Dispatcher$RegState$Running = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$RegState$Running, "cats.effect.std.Dispatcher$RegState$Running", ({
  Lcats_effect_std_Dispatcher$RegState$Running: 1,
  Lcats_effect_std_Dispatcher$RegState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Registration$Finalizer(action) {
  this.Lcats_effect_std_Dispatcher$Registration$Finalizer__f_action = null;
  this.Lcats_effect_std_Dispatcher$Registration$Finalizer__f_action = action;
}
$c_Lcats_effect_std_Dispatcher$Registration$Finalizer.prototype = new $h_Lcats_effect_std_Dispatcher$Registration();
$c_Lcats_effect_std_Dispatcher$Registration$Finalizer.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Registration$Finalizer;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Registration$Finalizer() {
}
$h_Lcats_effect_std_Dispatcher$Registration$Finalizer.prototype = $c_Lcats_effect_std_Dispatcher$Registration$Finalizer.prototype;
$c_Lcats_effect_std_Dispatcher$Registration$Finalizer.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_std_Dispatcher$Registration$Finalizer.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_std_Dispatcher$Registration$Finalizer.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_std_Dispatcher$Registration$Finalizer)) {
    var x$0$2 = $as_Lcats_effect_std_Dispatcher$Registration$Finalizer(x$0);
    var x = this.Lcats_effect_std_Dispatcher$Registration$Finalizer__f_action;
    var y = $n(x$0$2).Lcats_effect_std_Dispatcher$Registration$Finalizer__f_action;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_std_Dispatcher$Registration$Finalizer.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_std_Dispatcher$Registration$Finalizer.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_std_Dispatcher$Registration$Finalizer.prototype.productPrefix__T = (function() {
  return "Finalizer";
});
$c_Lcats_effect_std_Dispatcher$Registration$Finalizer.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_std_Dispatcher$Registration$Finalizer__f_action;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_std_Dispatcher$Registration$Finalizer(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$Registration$Finalizer) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$Registration$Finalizer"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$Registration$Finalizer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$Registration$Finalizer)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$Registration$Finalizer(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$Registration$Finalizer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$Registration$Finalizer;", depth));
}
var $d_Lcats_effect_std_Dispatcher$Registration$Finalizer = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Registration$Finalizer, "cats.effect.std.Dispatcher$Registration$Finalizer", ({
  Lcats_effect_std_Dispatcher$Registration$Finalizer: 1,
  Lcats_effect_std_Dispatcher$Registration: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Registration$PoisonPill() {
}
$c_Lcats_effect_std_Dispatcher$Registration$PoisonPill.prototype = new $h_Lcats_effect_std_Dispatcher$Registration();
$c_Lcats_effect_std_Dispatcher$Registration$PoisonPill.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Registration$PoisonPill;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Registration$PoisonPill() {
}
$h_Lcats_effect_std_Dispatcher$Registration$PoisonPill.prototype = $c_Lcats_effect_std_Dispatcher$Registration$PoisonPill.prototype;
$c_Lcats_effect_std_Dispatcher$Registration$PoisonPill.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_std_Dispatcher$Registration$PoisonPill.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_std_Dispatcher$Registration$PoisonPill.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcats_effect_std_Dispatcher$Registration$PoisonPill) && ($as_Lcats_effect_std_Dispatcher$Registration$PoisonPill(x$0), true)));
});
$c_Lcats_effect_std_Dispatcher$Registration$PoisonPill.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_std_Dispatcher$Registration$PoisonPill.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_std_Dispatcher$Registration$PoisonPill.prototype.productPrefix__T = (function() {
  return "PoisonPill";
});
$c_Lcats_effect_std_Dispatcher$Registration$PoisonPill.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_std_Dispatcher$Registration$PoisonPill(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$Registration$PoisonPill) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$Registration$PoisonPill"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$Registration$PoisonPill(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$Registration$PoisonPill)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$Registration$PoisonPill(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$Registration$PoisonPill(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$Registration$PoisonPill;", depth));
}
var $d_Lcats_effect_std_Dispatcher$Registration$PoisonPill = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Registration$PoisonPill, "cats.effect.std.Dispatcher$Registration$PoisonPill", ({
  Lcats_effect_std_Dispatcher$Registration$PoisonPill: 1,
  Lcats_effect_std_Dispatcher$Registration: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_std_EnvCompanionPlatform$$anon$1() {
}
$c_Lcats_effect_std_EnvCompanionPlatform$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcats_effect_std_EnvCompanionPlatform$$anon$1.prototype.constructor = $c_Lcats_effect_std_EnvCompanionPlatform$$anon$1;
/** @constructor */
function $h_Lcats_effect_std_EnvCompanionPlatform$$anon$1() {
}
$h_Lcats_effect_std_EnvCompanionPlatform$$anon$1.prototype = $c_Lcats_effect_std_EnvCompanionPlatform$$anon$1.prototype;
$c_Lcats_effect_std_EnvCompanionPlatform$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return (((typeof x) === "string") && ($as_T(x), true));
});
$c_Lcats_effect_std_EnvCompanionPlatform$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  if (((typeof x) === "string")) {
    var value = $as_T(x);
    return value;
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
var $d_Lcats_effect_std_EnvCompanionPlatform$$anon$1 = new $TypeData().initClass($c_Lcats_effect_std_EnvCompanionPlatform$$anon$1, "cats.effect.std.EnvCompanionPlatform$$anon$1", ({
  Lcats_effect_std_EnvCompanionPlatform$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Queue$BoundedQueue(capacity, state, F) {
  this.Lcats_effect_std_Queue$AbstractQueue__f_capacity = 0;
  this.Lcats_effect_std_Queue$AbstractQueue__f_state = null;
  this.Lcats_effect_std_Queue$AbstractQueue__f_F = null;
  this.Lcats_effect_std_Queue$AbstractQueue__f_take = null;
  this.Lcats_effect_std_Queue$AbstractQueue__f_tryTake = null;
  this.Lcats_effect_std_Queue$AbstractQueue__f_notifyNextTaker = null;
  this.Lcats_effect_std_Queue$BoundedQueue__f_state = null;
  this.Lcats_effect_std_Queue$BoundedQueue__f_F = null;
  this.Lcats_effect_std_Queue$BoundedQueue__f_state = state;
  this.Lcats_effect_std_Queue$BoundedQueue__f_F = F;
  $ct_Lcats_effect_std_Queue$AbstractQueue__I__Lcats_effect_kernel_Ref__Lcats_effect_kernel_GenConcurrent__(this, capacity, state, F);
  $m_s_Predef$().require__Z__V((capacity > 0));
}
$c_Lcats_effect_std_Queue$BoundedQueue.prototype = new $h_Lcats_effect_std_Queue$AbstractQueue();
$c_Lcats_effect_std_Queue$BoundedQueue.prototype.constructor = $c_Lcats_effect_std_Queue$BoundedQueue;
/** @constructor */
function $h_Lcats_effect_std_Queue$BoundedQueue() {
}
$h_Lcats_effect_std_Queue$BoundedQueue.prototype = $c_Lcats_effect_std_Queue$BoundedQueue.prototype;
var $d_Lcats_effect_std_Queue$BoundedQueue = new $TypeData().initClass($c_Lcats_effect_std_Queue$BoundedQueue, "cats.effect.std.Queue$BoundedQueue", ({
  Lcats_effect_std_Queue$BoundedQueue: 1,
  Lcats_effect_std_Queue$AbstractQueue: 1,
  Lcats_effect_std_Queue: 1,
  Lcats_effect_std_QueueSource: 1,
  Lcats_effect_std_QueueSink: 1
}));
/** @constructor */
function $c_Lcats_effect_tracing_Tracing$$anon$1() {
}
$c_Lcats_effect_tracing_Tracing$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcats_effect_tracing_Tracing$$anon$1.prototype.constructor = $c_Lcats_effect_tracing_Tracing$$anon$1;
/** @constructor */
function $h_Lcats_effect_tracing_Tracing$$anon$1() {
}
$h_Lcats_effect_tracing_Tracing$$anon$1.prototype = $c_Lcats_effect_tracing_Tracing$$anon$1.prototype;
$c_Lcats_effect_tracing_Tracing$$anon$1.prototype.isDefinedAt__Lcats_effect_tracing_TracingEvent__Z = (function(x) {
  return ((x instanceof $c_Lcats_effect_tracing_TracingEvent$StackTrace) && ($as_Lcats_effect_tracing_TracingEvent$StackTrace(x), true));
});
$c_Lcats_effect_tracing_Tracing$$anon$1.prototype.applyOrElse__Lcats_effect_tracing_TracingEvent__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Lcats_effect_tracing_TracingEvent$StackTrace)) {
    var ev = $as_Lcats_effect_tracing_TracingEvent$StackTrace(x);
    return $m_Lcats_effect_tracing_Tracing$().cats$effect$tracing$Tracing$$$getOpAndCallSite__Ajl_StackTraceElement__jl_StackTraceElement($n(ev).getStackTrace__Ajl_StackTraceElement());
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Lcats_effect_tracing_Tracing$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lcats_effect_tracing_TracingEvent__Z($as_Lcats_effect_tracing_TracingEvent(x));
});
$c_Lcats_effect_tracing_Tracing$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lcats_effect_tracing_TracingEvent__F1__O($as_Lcats_effect_tracing_TracingEvent(x), default$1);
});
var $d_Lcats_effect_tracing_Tracing$$anon$1 = new $TypeData().initClass($c_Lcats_effect_tracing_Tracing$$anon$1, "cats.effect.tracing.Tracing$$anon$1", ({
  Lcats_effect_tracing_Tracing$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_instances_EitherInstances$$anon$1() {
}
$c_Lcats_instances_EitherInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_EitherInstances$$anon$1.prototype.constructor = $c_Lcats_instances_EitherInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_EitherInstances$$anon$1() {
}
$h_Lcats_instances_EitherInstances$$anon$1.prototype = $c_Lcats_instances_EitherInstances$$anon$1.prototype;
$c_Lcats_instances_EitherInstances$$anon$1.prototype.bimap__O__F1__F1__O = (function(fab, f, g) {
  var evidence$1 = $m_Lcats_package$().Lcats_package$__f_catsInstancesForId;
  return this.bitraverse__s_util_Either__F1__F1__Lcats_Applicative__O($as_s_util_Either(fab), f, g, evidence$1);
});
$c_Lcats_instances_EitherInstances$$anon$1.prototype.bitraverse__s_util_Either__F1__F1__Lcats_Applicative__O = (function(fab, f, g, G) {
  if ((fab instanceof $c_s_util_Left)) {
    var a = $n($as_s_util_Left(fab)).s_util_Left__f_value;
    return $n(G).map__O__F1__O($n(f).apply__O__O(a), new $c_sjsr_AnonFunction1(((_$2) => new $c_s_util_Left(_$2))));
  }
  if ((fab instanceof $c_s_util_Right)) {
    var b = $n($as_s_util_Right(fab)).s_util_Right__f_value;
    return $n(G).map__O__F1__O($n(g).apply__O__O(b), new $c_sjsr_AnonFunction1(((_$3) => new $c_s_util_Right(_$3))));
  }
  throw new $c_s_MatchError(fab);
});
$c_Lcats_instances_EitherInstances$$anon$1.prototype.bifoldLeft__s_util_Either__O__F2__F2__O = (function(fab, c, f, g) {
  if ((fab instanceof $c_s_util_Left)) {
    var a = $n($as_s_util_Left(fab)).s_util_Left__f_value;
    return $n(f).apply__O__O__O(c, a);
  }
  if ((fab instanceof $c_s_util_Right)) {
    var b = $n($as_s_util_Right(fab)).s_util_Right__f_value;
    return $n(g).apply__O__O__O(c, b);
  }
  throw new $c_s_MatchError(fab);
});
$c_Lcats_instances_EitherInstances$$anon$1.prototype.bifoldLeft__O__O__F2__F2__O = (function(fab, c, f, g) {
  return this.bifoldLeft__s_util_Either__O__F2__F2__O($as_s_util_Either(fab), c, f, g);
});
var $d_Lcats_instances_EitherInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_EitherInstances$$anon$1, "cats.instances.EitherInstances$$anon$1", ({
  Lcats_instances_EitherInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Bifoldable: 1,
  Lcats_Bifunctor: 1,
  Lcats_Bitraverse: 1
}));
/** @constructor */
function $c_Lcats_instances_Function1Instances0$$anon$11() {
}
$c_Lcats_instances_Function1Instances0$$anon$11.prototype = new $h_O();
$c_Lcats_instances_Function1Instances0$$anon$11.prototype.constructor = $c_Lcats_instances_Function1Instances0$$anon$11;
/** @constructor */
function $h_Lcats_instances_Function1Instances0$$anon$11() {
}
$h_Lcats_instances_Function1Instances0$$anon$11.prototype = $c_Lcats_instances_Function1Instances0$$anon$11.prototype;
$c_Lcats_instances_Function1Instances0$$anon$11.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return this.map__F1__F1__F1($as_F1(fa), f);
});
$c_Lcats_instances_Function1Instances0$$anon$11.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_instances_Function1Instances0$$anon$11.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_Function1Instances0$$anon$11.prototype.map__F1__F1__F1 = (function(fa, f) {
  return new $c_sjsr_AnonFunction1(((t1) => $n(f).apply__O__O($n(fa).apply__O__O(t1))));
});
$c_Lcats_instances_Function1Instances0$$anon$11.prototype.map__O__F1__O = (function(fa, f) {
  return this.map__F1__F1__F1($as_F1(fa), f);
});
var $d_Lcats_instances_Function1Instances0$$anon$11 = new $TypeData().initClass($c_Lcats_instances_Function1Instances0$$anon$11, "cats.instances.Function1Instances0$$anon$11", ({
  Lcats_instances_Function1Instances0$$anon$11: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Distributive: 1
}));
/** @constructor */
function $c_Lcats_instances_LazyListInstances$$anon$2() {
}
$c_Lcats_instances_LazyListInstances$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcats_instances_LazyListInstances$$anon$2.prototype.constructor = $c_Lcats_instances_LazyListInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_LazyListInstances$$anon$2() {
}
$h_Lcats_instances_LazyListInstances$$anon$2.prototype = $c_Lcats_instances_LazyListInstances$$anon$2.prototype;
$c_Lcats_instances_LazyListInstances$$anon$2.prototype.isDefinedAt__s_Option__Z = (function(x) {
  return ((x instanceof $c_s_Some) && ($n($as_s_Some(x)), true));
});
$c_Lcats_instances_LazyListInstances$$anon$2.prototype.applyOrElse__s_Option__F1__O = (function(x, default$1) {
  if ((x instanceof $c_s_Some)) {
    var v = $n($as_s_Some(x)).s_Some__f_value;
    return v;
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Lcats_instances_LazyListInstances$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__s_Option__Z($as_s_Option(x));
});
$c_Lcats_instances_LazyListInstances$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__s_Option__F1__O($as_s_Option(x), default$1);
});
var $d_Lcats_instances_LazyListInstances$$anon$2 = new $TypeData().initClass($c_Lcats_instances_LazyListInstances$$anon$2, "cats.instances.LazyListInstances$$anon$2", ({
  Lcats_instances_LazyListInstances$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_instances_OrderInstances$$anon$2(fa$6, fb$3, outer) {
  this.Lcats_instances_OrderInstances$$anon$2__f_fa$4 = null;
  this.Lcats_instances_OrderInstances$$anon$2__f_fb$2 = null;
  this.Lcats_instances_OrderInstances$$anon$2__f_fa$4 = fa$6;
  this.Lcats_instances_OrderInstances$$anon$2__f_fb$2 = fb$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_instances_OrderInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_OrderInstances$$anon$2.prototype.constructor = $c_Lcats_instances_OrderInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_OrderInstances$$anon$2() {
}
$h_Lcats_instances_OrderInstances$$anon$2.prototype = $c_Lcats_instances_OrderInstances$$anon$2.prototype;
$c_Lcats_instances_OrderInstances$$anon$2.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.max__O__O__O = (function(x, y) {
  return $f_Lcats_kernel_Order__max__O__O__O(this, x, y);
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.eqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__eqv__O__O__Z(this, x, y);
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.gt__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__gt__O__O__Z(this, x, y);
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.toOrdering__s_math_Ordering = (function() {
  return new $c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.compare__T2__T2__I = (function(x, y) {
  var fa$1 = this.Lcats_instances_OrderInstances$$anon$2__f_fa$4;
  var fb$1 = this.Lcats_instances_OrderInstances$$anon$2__f_fb$2;
  var z = $n(fa$1).compare__O__O__I($n(x)._1__O(), $n(y)._1__O());
  return ((z === 0) ? $n(fb$1).compare__O__O__I($n(x)._2__O(), $n(y)._2__O()) : z);
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__T2__T2__I($as_T2(x), $as_T2(y));
});
var $d_Lcats_instances_OrderInstances$$anon$2 = new $TypeData().initClass($c_Lcats_instances_OrderInstances$$anon$2, "cats.instances.OrderInstances$$anon$2", ({
  Lcats_instances_OrderInstances$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1
}));
/** @constructor */
function $c_Lcats_instances_package$either$() {
  this.Lcats_instances_package$either$__f_catsStdBitraverseForEither = null;
  $n_Lcats_instances_package$either$ = this;
  this.Lcats_instances_package$either$__f_catsStdBitraverseForEither = new $c_Lcats_instances_EitherInstances$$anon$1();
}
$c_Lcats_instances_package$either$.prototype = new $h_O();
$c_Lcats_instances_package$either$.prototype.constructor = $c_Lcats_instances_package$either$;
/** @constructor */
function $h_Lcats_instances_package$either$() {
}
$h_Lcats_instances_package$either$.prototype = $c_Lcats_instances_package$either$.prototype;
var $d_Lcats_instances_package$either$ = new $TypeData().initClass($c_Lcats_instances_package$either$, "cats.instances.package$either$", ({
  Lcats_instances_package$either$: 1,
  Lcats_kernel_instances_EitherInstances1: 1,
  Lcats_kernel_instances_EitherInstances0: 1,
  Lcats_kernel_instances_EitherInstances: 1,
  Lcats_instances_EitherInstances: 1
}));
var $n_Lcats_instances_package$either$;
function $m_Lcats_instances_package$either$() {
  if ((!$n_Lcats_instances_package$either$)) {
    $n_Lcats_instances_package$either$ = new $c_Lcats_instances_package$either$();
  }
  return $n_Lcats_instances_package$either$;
}
/** @constructor */
function $c_Lcats_instances_package$seq$() {
  this.Lcats_instances_package$seq$__f_catsStdInstancesForSeq = null;
  $n_Lcats_instances_package$seq$ = this;
  $f_Lcats_instances_SeqInstances__$init$__V(this);
}
$c_Lcats_instances_package$seq$.prototype = new $h_O();
$c_Lcats_instances_package$seq$.prototype.constructor = $c_Lcats_instances_package$seq$;
/** @constructor */
function $h_Lcats_instances_package$seq$() {
}
$h_Lcats_instances_package$seq$.prototype = $c_Lcats_instances_package$seq$.prototype;
$c_Lcats_instances_package$seq$.prototype.cats$instances$SeqInstances$_setter_$catsStdInstancesForSeq_$eq__Lcats_Align__V = (function(x$0) {
  this.Lcats_instances_package$seq$__f_catsStdInstancesForSeq = x$0;
});
$c_Lcats_instances_package$seq$.prototype.cats$instances$SeqInstances$_setter_$catsStdTraverseFilterForSeq_$eq__Lcats_TraverseFilter__V = (function(x$0) {
});
var $d_Lcats_instances_package$seq$ = new $TypeData().initClass($c_Lcats_instances_package$seq$, "cats.instances.package$seq$", ({
  Lcats_instances_package$seq$: 1,
  Lcats_kernel_instances_SeqInstances2: 1,
  Lcats_kernel_instances_SeqInstances1: 1,
  Lcats_kernel_instances_SeqInstances: 1,
  Lcats_instances_SeqInstances: 1
}));
var $n_Lcats_instances_package$seq$;
function $m_Lcats_instances_package$seq$() {
  if ((!$n_Lcats_instances_package$seq$)) {
    $n_Lcats_instances_package$seq$ = new $c_Lcats_instances_package$seq$();
  }
  return $n_Lcats_instances_package$seq$;
}
/** @constructor */
function $c_Lcats_kernel_Order$() {
}
$c_Lcats_kernel_Order$.prototype = new $h_Lcats_kernel_OrderFunctions();
$c_Lcats_kernel_Order$.prototype.constructor = $c_Lcats_kernel_Order$;
/** @constructor */
function $h_Lcats_kernel_Order$() {
}
$h_Lcats_kernel_Order$.prototype = $c_Lcats_kernel_Order$.prototype;
var $d_Lcats_kernel_Order$ = new $TypeData().initClass($c_Lcats_kernel_Order$, "cats.kernel.Order$", ({
  Lcats_kernel_Order$: 1,
  Lcats_kernel_OrderFunctions: 1,
  Lcats_kernel_PartialOrderFunctions: 1,
  Lcats_kernel_EqFunctions: 1,
  Lcats_kernel_OrderToOrderingConversion: 1
}));
var $n_Lcats_kernel_Order$;
function $m_Lcats_kernel_Order$() {
  if ((!$n_Lcats_kernel_Order$)) {
    $n_Lcats_kernel_Order$ = new $c_Lcats_kernel_Order$();
  }
  return $n_Lcats_kernel_Order$;
}
/** @constructor */
function $c_Lcats_kernel_Order$$anon$2(ev$5, f$7, outer) {
  this.Lcats_kernel_Order$$anon$2__f_ev$3 = null;
  this.Lcats_kernel_Order$$anon$2__f_f$4 = null;
  this.Lcats_kernel_Order$$anon$2__f_ev$3 = ev$5;
  this.Lcats_kernel_Order$$anon$2__f_f$4 = f$7;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_kernel_Order$$anon$2.prototype = new $h_O();
$c_Lcats_kernel_Order$$anon$2.prototype.constructor = $c_Lcats_kernel_Order$$anon$2;
/** @constructor */
function $h_Lcats_kernel_Order$$anon$2() {
}
$h_Lcats_kernel_Order$$anon$2.prototype = $c_Lcats_kernel_Order$$anon$2.prototype;
$c_Lcats_kernel_Order$$anon$2.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_Order$$anon$2.prototype.max__O__O__O = (function(x, y) {
  return $f_Lcats_kernel_Order__max__O__O__O(this, x, y);
});
$c_Lcats_kernel_Order$$anon$2.prototype.eqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__eqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Order$$anon$2.prototype.gt__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__gt__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Order$$anon$2.prototype.toOrdering__s_math_Ordering = (function() {
  return new $c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_Order$$anon$2.prototype.compare__O__O__I = (function(x, y) {
  var ev$1 = this.Lcats_kernel_Order$$anon$2__f_ev$3;
  var f$1 = this.Lcats_kernel_Order$$anon$2__f_f$4;
  return $n(ev$1).compare__O__O__I($n(f$1).apply__O__O(x), $n(f$1).apply__O__O(y));
});
var $d_Lcats_kernel_Order$$anon$2 = new $TypeData().initClass($c_Lcats_kernel_Order$$anon$2, "cats.kernel.Order$$anon$2", ({
  Lcats_kernel_Order$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1
}));
/** @constructor */
function $c_Lcats_kernel_Order$$anon$9(ev$4, outer) {
  this.Lcats_kernel_Order$$anon$9__f_ev$2 = null;
  this.Lcats_kernel_Order$$anon$9__f_ev$2 = ev$4;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_kernel_Order$$anon$9.prototype = new $h_O();
$c_Lcats_kernel_Order$$anon$9.prototype.constructor = $c_Lcats_kernel_Order$$anon$9;
/** @constructor */
function $h_Lcats_kernel_Order$$anon$9() {
}
$h_Lcats_kernel_Order$$anon$9.prototype = $c_Lcats_kernel_Order$$anon$9.prototype;
$c_Lcats_kernel_Order$$anon$9.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_Order$$anon$9.prototype.max__O__O__O = (function(x, y) {
  return $f_Lcats_kernel_Order__max__O__O__O(this, x, y);
});
$c_Lcats_kernel_Order$$anon$9.prototype.eqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__eqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Order$$anon$9.prototype.gt__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__gt__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Order$$anon$9.prototype.compare__O__O__I = (function(x, y) {
  return $n(this.Lcats_kernel_Order$$anon$9__f_ev$2).compare__O__O__I(x, y);
});
$c_Lcats_kernel_Order$$anon$9.prototype.toOrdering__s_math_Ordering = (function() {
  return this.Lcats_kernel_Order$$anon$9__f_ev$2;
});
var $d_Lcats_kernel_Order$$anon$9 = new $TypeData().initClass($c_Lcats_kernel_Order$$anon$9, "cats.kernel.Order$$anon$9", ({
  Lcats_kernel_Order$$anon$9: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_BitSetPartialOrder() {
}
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.constructor = $c_Lcats_kernel_instances_BitSetPartialOrder;
/** @constructor */
function $h_Lcats_kernel_instances_BitSetPartialOrder() {
}
$h_Lcats_kernel_instances_BitSetPartialOrder.prototype = $c_Lcats_kernel_instances_BitSetPartialOrder.prototype;
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.partialCompare__sci_BitSet__sci_BitSet__D = (function(x, y) {
  if ((x === y)) {
    return 0.0;
  } else {
    var this$1 = $n(x);
    var $x_1 = $f_sc_BitSetOps__size__I(this$1);
    var this$2 = $n(y);
    if (($x_1 < $f_sc_BitSetOps__size__I(this$2))) {
      var this$3 = $n(x);
      if ($f_sc_IterableOnceOps__forall__F1__Z(this$3, y)) {
        return (-1.0);
      } else {
        return (NaN);
      }
    } else {
      var this$4 = $n(y);
      var $x_2 = $f_sc_BitSetOps__size__I(this$4);
      var this$5 = $n(x);
      if (($x_2 < $f_sc_BitSetOps__size__I(this$5))) {
        var this$6 = $n(y);
        if ($f_sc_IterableOnceOps__forall__F1__Z(this$6, x)) {
          return 1.0;
        } else {
          return (NaN);
        }
      } else {
        if ((x === null)) {
          var $x_3 = (y === null);
        } else {
          var this$7 = $n(x);
          var $x_3 = $f_sc_SortedSet__equals__O__Z(this$7, y);
        }
        if ($x_3) {
          return 0.0;
        } else {
          return (NaN);
        }
      }
    }
  }
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.eqv__sci_BitSet__sci_BitSet__Z = (function(x, y) {
  if ((x === null)) {
    return (y === null);
  } else {
    var this$1 = $n(x);
    return $f_sc_SortedSet__equals__O__Z(this$1, y);
  }
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_sci_BitSet(x);
  var this$1 = $n(x$1);
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.unorderedHash__sc_IterableOnce__I__I(this$1, this$2.s_util_hashing_MurmurHash3$__f_setSeed);
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return this.partialCompare__sci_BitSet__sci_BitSet__D($as_sci_BitSet(x), $as_sci_BitSet(y));
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__sci_BitSet__sci_BitSet__Z($as_sci_BitSet(x), $as_sci_BitSet(y));
});
var $d_Lcats_kernel_instances_BitSetPartialOrder = new $TypeData().initClass($c_Lcats_kernel_instances_BitSetPartialOrder, "cats.kernel.instances.BitSetPartialOrder", ({
  Lcats_kernel_instances_BitSetPartialOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Hash: 1
}));
function $ct_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg__Ldev_sungkm_enchantedrealm_EnchantedRealm__($thiz, outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $thiz;
}
/** @constructor */
function $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg() {
}
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg.prototype = new $h_O();
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg.prototype.constructor = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg;
/** @constructor */
function $h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg() {
}
$h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg.prototype = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg.prototype;
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
function $as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg(obj) {
  return (((obj instanceof $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg) || (obj === null)) ? obj : $throwClassCastException(obj, "dev.sungkm.enchantedrealm.EnchantedRealm$Msg"));
}
function $isArrayOf_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg)));
}
function $asArrayOf_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg(obj, depth) {
  return (($isArrayOf_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldev.sungkm.enchantedrealm.EnchantedRealm$Msg;", depth));
}
/** @constructor */
function $c_Lfs2_Chunk() {
}
$c_Lfs2_Chunk.prototype = new $h_O();
$c_Lfs2_Chunk.prototype.constructor = $c_Lfs2_Chunk;
/** @constructor */
function $h_Lfs2_Chunk() {
}
$h_Lfs2_Chunk.prototype = $c_Lfs2_Chunk.prototype;
$c_Lfs2_Chunk.prototype.foreach__F1__V = (function(f) {
  var i = 0;
  while ((i < this.size__I())) {
    $n(f).apply__O__O(this.apply__I__O(i));
    i = ((1 + i) | 0);
  }
});
$c_Lfs2_Chunk.prototype.isEmpty__Z = (function() {
  return (this.size__I() === 0);
});
$c_Lfs2_Chunk.prototype.iterator__sc_Iterator = (function() {
  return new $c_Lfs2_Chunk$$anon$1(this);
});
$c_Lfs2_Chunk.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var elem = this$1.stringHash__T__I__I("Chunk", (-137723950));
  var h = new $c_sr_IntRef(elem);
  this.foreach__F1__V(new $c_sjsr_AnonFunction1(((o) => {
    var ev$18 = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h.sr_IntRef__f_elem, $m_sr_Statics$().anyHash__O__I(o));
    h.sr_IntRef__f_elem = ev$18;
  })));
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h.sr_IntRef__f_elem, this.size__I());
});
$c_Lfs2_Chunk.prototype.equals__O__Z = (function(a) {
  if ((a instanceof $c_Lfs2_Chunk)) {
    var c = $as_Lfs2_Chunk(a);
    if ((this.size__I() === $n(c).size__I())) {
      var this$1 = $n(this.iterator__sc_Iterator());
      var that = $n(c).iterator__sc_Iterator();
      return $f_sc_Iterator__sameElements__sc_IterableOnce__Z(this$1, that);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_Chunk.prototype.toString__T = (function() {
  var this$1 = $n(this.iterator__sc_Iterator());
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, "Chunk(", ", ", ")");
});
function $as_Lfs2_Chunk(obj) {
  return (((obj instanceof $c_Lfs2_Chunk) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Chunk"));
}
function $isArrayOf_Lfs2_Chunk(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Chunk)));
}
function $asArrayOf_Lfs2_Chunk(obj, depth) {
  return (($isArrayOf_Lfs2_Chunk(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Chunk;", depth));
}
/** @constructor */
function $c_Lfs2_Chunk$() {
  this.Lfs2_Chunk$__f_empty_ = null;
  this.Lfs2_Chunk$__f_unit = null;
  $n_Lfs2_Chunk$ = this;
  this.Lfs2_Chunk$__f_empty_ = new $c_Lfs2_Chunk$EmptyChunk();
  this.Lfs2_Chunk$__f_unit = new $c_Lfs2_Chunk$Singleton((void 0));
}
$c_Lfs2_Chunk$.prototype = new $h_O();
$c_Lfs2_Chunk$.prototype.constructor = $c_Lfs2_Chunk$;
/** @constructor */
function $h_Lfs2_Chunk$() {
}
$h_Lfs2_Chunk$.prototype = $c_Lfs2_Chunk$.prototype;
var $d_Lfs2_Chunk$ = new $TypeData().initClass($c_Lfs2_Chunk$, "fs2.Chunk$", ({
  Lfs2_Chunk$: 1,
  Lfs2_CollectorK: 1,
  Lfs2_ChunkCompanion213And3Compat: 1,
  Lfs2_ChunkCompanionPlatform: 1,
  Lfs2_ChunkCompanionRuntimePlatform: 1
}));
var $n_Lfs2_Chunk$;
function $m_Lfs2_Chunk$() {
  if ((!$n_Lfs2_Chunk$)) {
    $n_Lfs2_Chunk$ = new $c_Lfs2_Chunk$();
  }
  return $n_Lfs2_Chunk$;
}
/** @constructor */
function $c_Lfs2_Compiler$() {
  $n_Lfs2_Compiler$ = this;
  new $c_Lfs2_CompilerLowPriority0$$anon$3();
  new $c_Lfs2_CompilerLowPriority$$anon$4();
  new $c_Lfs2_Compiler$$anon$5();
}
$c_Lfs2_Compiler$.prototype = new $h_O();
$c_Lfs2_Compiler$.prototype.constructor = $c_Lfs2_Compiler$;
/** @constructor */
function $h_Lfs2_Compiler$() {
}
$h_Lfs2_Compiler$.prototype = $c_Lfs2_Compiler$.prototype;
var $d_Lfs2_Compiler$ = new $TypeData().initClass($c_Lfs2_Compiler$, "fs2.Compiler$", ({
  Lfs2_Compiler$: 1,
  Lfs2_CompilerLowPriority2: 1,
  Lfs2_CompilerLowPriority1: 1,
  Lfs2_CompilerLowPriority0: 1,
  Lfs2_CompilerLowPriority: 1
}));
var $n_Lfs2_Compiler$;
function $m_Lfs2_Compiler$() {
  if ((!$n_Lfs2_Compiler$)) {
    $n_Lfs2_Compiler$ = new $c_Lfs2_Compiler$();
  }
  return $n_Lfs2_Compiler$;
}
class $c_Lfs2_CompositeFailure extends $c_jl_Throwable {
  constructor(head, tail) {
    super();
    this.Lfs2_CompositeFailure__f_head = null;
    this.Lfs2_CompositeFailure__f_tail = null;
    this.Lfs2_CompositeFailure__f_head = head;
    this.Lfs2_CompositeFailure__f_tail = tail;
    var $x_1 = $n(tail).size__I();
    var this$1 = $n(head);
    var message = ((((("Multiple exceptions were thrown (" + ((1 + $x_1) | 0)) + "), first ") + $objectGetClass(this$1).getName__T()) + ": ") + $n(head).getMessage__T());
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, head, true, true);
  }
  productIterator__sc_Iterator() {
    return new $c_s_Product$$anon$1(this);
  }
  hashCode__I() {
    var this$2 = $m_s_util_hashing_MurmurHash3$();
    return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
  }
  equals__O__Z(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lfs2_CompositeFailure)) {
      var x$0$2 = $as_Lfs2_CompositeFailure(x$0);
      var x = this.Lfs2_CompositeFailure__f_head;
      var x$2 = $n(x$0$2).Lfs2_CompositeFailure__f_head;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lfs2_CompositeFailure__f_tail;
        var x$4 = $n(x$0$2).Lfs2_CompositeFailure__f_tail;
        var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        $n(x$0$2);
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  productArity__I() {
    return 2;
  }
  productPrefix__T() {
    return "CompositeFailure";
  }
  productElement__I__O(n) {
    if ((n === 0)) {
      return this.Lfs2_CompositeFailure__f_head;
    }
    if ((n === 1)) {
      return this.Lfs2_CompositeFailure__f_tail;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
}
function $as_Lfs2_CompositeFailure(obj) {
  return (((obj instanceof $c_Lfs2_CompositeFailure) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.CompositeFailure"));
}
function $isArrayOf_Lfs2_CompositeFailure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_CompositeFailure)));
}
function $asArrayOf_Lfs2_CompositeFailure(obj, depth) {
  return (($isArrayOf_Lfs2_CompositeFailure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.CompositeFailure;", depth));
}
var $d_Lfs2_CompositeFailure = new $TypeData().initClass($c_Lfs2_CompositeFailure, "fs2.CompositeFailure", ({
  Lfs2_CompositeFailure: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lfs2_Pull$$anon$1(f$14, outer) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$$anon$1__f_f$1 = null;
  this.Lfs2_Pull$$anon$1__f_f$1 = f$14;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, outer);
}
$c_Lfs2_Pull$$anon$1.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$$anon$1.prototype.constructor = $c_Lfs2_Pull$$anon$1;
/** @constructor */
function $h_Lfs2_Pull$$anon$1() {
}
$h_Lfs2_Pull$$anon$1.prototype = $c_Lfs2_Pull$$anon$1.prototype;
$c_Lfs2_Pull$$anon$1.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(e) {
  if ((e instanceof $c_Lfs2_Pull$Succeeded)) {
    var x$1 = $as_Lfs2_Pull$Succeeded(e);
    var this$2 = $n(x$1);
    var x15 = this$2.Lfs2_Pull$Succeeded__f_r;
    try {
      return $as_Lfs2_Pull($n(this.Lfs2_Pull$$anon$1__f_f$1).apply__O__O(x15));
    } catch (e$2) {
      var e$3 = ((e$2 instanceof $c_jl_Throwable) ? e$2 : new $c_sjs_js_JavaScriptException(e$2));
      var x2 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$3);
      if ((!$n(x2).isEmpty__Z())) {
        var x3 = $as_jl_Throwable($n(x2).get__O());
        return new $c_Lfs2_Pull$Fail(x3);
      }
      throw ((e$3 instanceof $c_sjs_js_JavaScriptException) ? e$3.sjs_js_JavaScriptException__f_exception : $n(e$3));
    }
  }
  if ((e instanceof $c_Lfs2_Pull$Interrupted)) {
    var x$1$1 = $as_Lfs2_Pull$Interrupted(e);
    var this$5 = $n(x$1$1);
    var this$6 = $n(x$1$1);
    var res = $as_Lfs2_Pull$Interrupted(e);
    return res;
  }
  if ((e instanceof $c_Lfs2_Pull$Fail)) {
    var x$1$2 = $as_Lfs2_Pull$Fail(e);
    var this$8 = $n(x$1$2);
    var res$2 = $as_Lfs2_Pull$Fail(e);
    return res$2;
  }
  throw new $c_s_MatchError(e);
});
var $d_Lfs2_Pull$$anon$1 = new $TypeData().initClass($c_Lfs2_Pull$$anon$1, "fs2.Pull$$anon$1", ({
  Lfs2_Pull$$anon$1: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
/** @constructor */
function $c_Lfs2_Pull$$anon$2(post$3, outer) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$$anon$2__f_post$1 = null;
  this.Lfs2_Pull$$anon$2__f_post$1 = post$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, outer);
}
$c_Lfs2_Pull$$anon$2.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$$anon$2.prototype.constructor = $c_Lfs2_Pull$$anon$2;
/** @constructor */
function $h_Lfs2_Pull$$anon$2() {
}
$h_Lfs2_Pull$$anon$2.prototype = $c_Lfs2_Pull$$anon$2.prototype;
$c_Lfs2_Pull$$anon$2.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(r) {
  if ((r instanceof $c_Lfs2_Pull$Succeeded)) {
    return $as_Lfs2_Pull($n(this.Lfs2_Pull$$anon$2__f_post$1).apply__O());
  }
  if ((r instanceof $c_Lfs2_Pull$Interrupted)) {
    var r$2 = $as_Lfs2_Pull$Interrupted(r);
    return r$2;
  }
  if ((r instanceof $c_Lfs2_Pull$Fail)) {
    var r$3 = $as_Lfs2_Pull$Fail(r);
    return r$3;
  }
  throw new $c_s_MatchError(r);
});
var $d_Lfs2_Pull$$anon$2 = new $TypeData().initClass($c_Lfs2_Pull$$anon$2, "fs2.Pull$$anon$2", ({
  Lfs2_Pull$$anon$2: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
/** @constructor */
function $c_Lfs2_Pull$$anon$3(handler$2, outer) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$$anon$3__f_handler$1 = null;
  this.Lfs2_Pull$$anon$3__f_handler$1 = handler$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, outer);
}
$c_Lfs2_Pull$$anon$3.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$$anon$3.prototype.constructor = $c_Lfs2_Pull$$anon$3;
/** @constructor */
function $h_Lfs2_Pull$$anon$3() {
}
$h_Lfs2_Pull$$anon$3.prototype = $c_Lfs2_Pull$$anon$3.prototype;
$c_Lfs2_Pull$$anon$3.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(term) {
  if ((term instanceof $c_Lfs2_Pull$Fail)) {
    var x$1 = $as_Lfs2_Pull$Fail(term);
    var this$2 = $n(x$1);
    var x27 = this$2.Lfs2_Pull$Fail__f_error;
    try {
      return $as_Lfs2_Pull($n(this.Lfs2_Pull$$anon$3__f_handler$1).apply__O__O(x27));
    } catch (e$2) {
      var e$3 = ((e$2 instanceof $c_jl_Throwable) ? e$2 : new $c_sjs_js_JavaScriptException(e$2));
      var x21 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$3);
      if ((!$n(x21).isEmpty__Z())) {
        var x22 = $as_jl_Throwable($n(x21).get__O());
        return new $c_Lfs2_Pull$Fail(x22);
      }
      throw ((e$3 instanceof $c_sjs_js_JavaScriptException) ? e$3.sjs_js_JavaScriptException__f_exception : $n(e$3));
    }
  } else {
    return term;
  }
});
var $d_Lfs2_Pull$$anon$3 = new $TypeData().initClass($c_Lfs2_Pull$$anon$3, "fs2.Pull$$anon$3", ({
  Lfs2_Pull$$anon$3: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
/** @constructor */
function $c_Lfs2_Pull$$anon$5(p$3, outer) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$$anon$5__f_p$1 = null;
  this.Lfs2_Pull$$anon$5__f_p$1 = p$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, $m_Lfs2_Pull$().Lfs2_Pull$__f_fs2$Pull$$$unit);
}
$c_Lfs2_Pull$$anon$5.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$$anon$5.prototype.constructor = $c_Lfs2_Pull$$anon$5;
/** @constructor */
function $h_Lfs2_Pull$$anon$5() {
}
$h_Lfs2_Pull$$anon$5.prototype = $c_Lfs2_Pull$$anon$5.prototype;
$c_Lfs2_Pull$$anon$5.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(r) {
  return $as_Lfs2_Pull($n(this.Lfs2_Pull$$anon$5__f_p$1).apply__O());
});
var $d_Lfs2_Pull$$anon$5 = new $TypeData().initClass($c_Lfs2_Pull$$anon$5, "fs2.Pull$$anon$5", ({
  Lfs2_Pull$$anon$5: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
/** @constructor */
function $c_Lfs2_Pull$$anon$7(fmoc$1, view$1, outer) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$$anon$7__f_view$2 = null;
  this.Lfs2_Pull$$anon$7__f_view$2 = view$1;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, fmoc$1);
}
$c_Lfs2_Pull$$anon$7.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$$anon$7.prototype.constructor = $c_Lfs2_Pull$$anon$7;
/** @constructor */
function $h_Lfs2_Pull$$anon$7() {
}
$h_Lfs2_Pull$$anon$7.prototype = $c_Lfs2_Pull$$anon$7.prototype;
$c_Lfs2_Pull$$anon$7.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(r) {
  return $as_Lfs2_Pull($n(this.Lfs2_Pull$$anon$7__f_view$2).apply__O__O(r));
});
var $d_Lfs2_Pull$$anon$7 = new $TypeData().initClass($c_Lfs2_Pull$$anon$7, "fs2.Pull$$anon$7", ({
  Lfs2_Pull$$anon$7: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
/** @constructor */
function $c_Lfs2_Pull$$anon$8(stream$3, childScope$1) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$$anon$8__f_childScope$2 = null;
  this.Lfs2_Pull$$anon$8__f_childScope$2 = childScope$1;
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, stream$3);
}
$c_Lfs2_Pull$$anon$8.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$$anon$8.prototype.constructor = $c_Lfs2_Pull$$anon$8;
/** @constructor */
function $h_Lfs2_Pull$$anon$8() {
}
$h_Lfs2_Pull$$anon$8.prototype = $c_Lfs2_Pull$$anon$8.prototype;
$c_Lfs2_Pull$$anon$8.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(r) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$endScope$1__Lcats_effect_kernel_Unique$Token__Lfs2_Pull$Terminal__Lfs2_Pull($n(this.Lfs2_Pull$$anon$8__f_childScope$2).Lfs2_internal_Scope__f_id, r);
});
var $d_Lfs2_Pull$$anon$8 = new $TypeData().initClass($c_Lfs2_Pull$$anon$8, "fs2.Pull$$anon$8", ({
  Lfs2_Pull$$anon$8: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
/** @constructor */
function $c_Lfs2_Pull$$anon$9(p$2, f$11, outer) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$$anon$9__f_f$12 = null;
  this.Lfs2_Pull$$anon$9__f_f$12 = f$11;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, p$2);
}
$c_Lfs2_Pull$$anon$9.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$$anon$9.prototype.constructor = $c_Lfs2_Pull$$anon$9;
/** @constructor */
function $h_Lfs2_Pull$$anon$9() {
}
$h_Lfs2_Pull$$anon$9.prototype = $c_Lfs2_Pull$$anon$9.prototype;
$c_Lfs2_Pull$$anon$9.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(r) {
  try {
    return $as_Lfs2_Pull($n(this.Lfs2_Pull$$anon$9__f_f$12).apply__O__O(r));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    var x340 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
    if ((!$n(x340).isEmpty__Z())) {
      var x341 = $as_jl_Throwable($n(x340).get__O());
      return new $c_Lfs2_Pull$Fail(x341);
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2));
  }
});
var $d_Lfs2_Pull$$anon$9 = new $TypeData().initClass($c_Lfs2_Pull$$anon$9, "fs2.Pull$$anon$9", ({
  Lfs2_Pull$$anon$9: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
/** @constructor */
function $c_Lfs2_Pull$BindBind(step, bb, del) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$BindBind__f_bb = null;
  this.Lfs2_Pull$BindBind__f_del = null;
  this.Lfs2_Pull$BindBind__f_bb = bb;
  this.Lfs2_Pull$BindBind__f_del = del;
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, step);
}
$c_Lfs2_Pull$BindBind.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$BindBind.prototype.constructor = $c_Lfs2_Pull$BindBind;
/** @constructor */
function $h_Lfs2_Pull$BindBind() {
}
$h_Lfs2_Pull$BindBind.prototype = $c_Lfs2_Pull$BindBind.prototype;
$c_Lfs2_Pull$BindBind.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(tx) {
  try {
    return $m_Lfs2_Pull$().fs2$Pull$$$bindBindAux__Lfs2_Pull__Lfs2_Pull$Bind__Lfs2_Pull($n(this.Lfs2_Pull$BindBind__f_bb).cont__Lfs2_Pull$Terminal__Lfs2_Pull(tx), this.Lfs2_Pull$BindBind__f_del);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    var x103 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
    if ((!$n(x103).isEmpty__Z())) {
      var x104 = $as_jl_Throwable($n(x103).get__O());
      return new $c_Lfs2_Pull$Fail(x104);
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2));
  }
});
function $as_Lfs2_Pull$BindBind(obj) {
  return (((obj instanceof $c_Lfs2_Pull$BindBind) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$BindBind"));
}
function $isArrayOf_Lfs2_Pull$BindBind(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$BindBind)));
}
function $asArrayOf_Lfs2_Pull$BindBind(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$BindBind(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$BindBind;", depth));
}
var $d_Lfs2_Pull$BindBind = new $TypeData().initClass($c_Lfs2_Pull$BindBind, "fs2.Pull$BindBind", ({
  Lfs2_Pull$BindBind: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
/** @constructor */
function $c_Lfs2_Pull$CloseScope() {
}
$c_Lfs2_Pull$CloseScope.prototype = new $h_Lfs2_Pull$AlgEffect();
$c_Lfs2_Pull$CloseScope.prototype.constructor = $c_Lfs2_Pull$CloseScope;
/** @constructor */
function $h_Lfs2_Pull$CloseScope() {
}
$h_Lfs2_Pull$CloseScope.prototype = $c_Lfs2_Pull$CloseScope.prototype;
function $as_Lfs2_Pull$CloseScope(obj) {
  return (((obj instanceof $c_Lfs2_Pull$CloseScope) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$CloseScope"));
}
function $isArrayOf_Lfs2_Pull$CloseScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$CloseScope)));
}
function $asArrayOf_Lfs2_Pull$CloseScope(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$CloseScope(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$CloseScope;", depth));
}
/** @constructor */
function $c_Lfs2_Pull$DelegateBind(step, delegate) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$DelegateBind__f_delegate = null;
  this.Lfs2_Pull$DelegateBind__f_delegate = delegate;
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, step);
}
$c_Lfs2_Pull$DelegateBind.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$DelegateBind.prototype.constructor = $c_Lfs2_Pull$DelegateBind;
/** @constructor */
function $h_Lfs2_Pull$DelegateBind() {
}
$h_Lfs2_Pull$DelegateBind.prototype = $c_Lfs2_Pull$DelegateBind.prototype;
$c_Lfs2_Pull$DelegateBind.prototype.delegate__Lfs2_Pull$Bind = (function() {
  return this.Lfs2_Pull$DelegateBind__f_delegate;
});
$c_Lfs2_Pull$DelegateBind.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(yr) {
  return $n(this.Lfs2_Pull$DelegateBind__f_delegate).cont__Lfs2_Pull$Terminal__Lfs2_Pull(yr);
});
var $d_Lfs2_Pull$DelegateBind = new $TypeData().initClass($c_Lfs2_Pull$DelegateBind, "fs2.Pull$DelegateBind", ({
  Lfs2_Pull$DelegateBind: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
/** @constructor */
function $c_Lfs2_internal_Scope$$anon$1() {
}
$c_Lfs2_internal_Scope$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lfs2_internal_Scope$$anon$1.prototype.constructor = $c_Lfs2_internal_Scope$$anon$1;
/** @constructor */
function $h_Lfs2_internal_Scope$$anon$1() {
}
$h_Lfs2_internal_Scope$$anon$1.prototype = $c_Lfs2_internal_Scope$$anon$1.prototype;
$c_Lfs2_internal_Scope$$anon$1.prototype.isDefinedAt__s_util_Either__Z = (function(x) {
  return ((x instanceof $c_s_util_Left) && ($as_jl_Throwable($n($as_s_util_Left(x)).s_util_Left__f_value), true));
});
$c_Lfs2_internal_Scope$$anon$1.prototype.applyOrElse__s_util_Either__F1__O = (function(x, default$1) {
  if ((x instanceof $c_s_util_Left)) {
    var err = $as_jl_Throwable($n($as_s_util_Left(x)).s_util_Left__f_value);
    return err;
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Lfs2_internal_Scope$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__s_util_Either__Z($as_s_util_Either(x));
});
$c_Lfs2_internal_Scope$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__s_util_Either__F1__O($as_s_util_Either(x), default$1);
});
var $d_Lfs2_internal_Scope$$anon$1 = new $TypeData().initClass($c_Lfs2_internal_Scope$$anon$1, "fs2.internal.Scope$$anon$1", ({
  Lfs2_internal_Scope$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lfs2_internal_Scope$State$Closed() {
}
$c_Lfs2_internal_Scope$State$Closed.prototype = new $h_O();
$c_Lfs2_internal_Scope$State$Closed.prototype.constructor = $c_Lfs2_internal_Scope$State$Closed;
/** @constructor */
function $h_Lfs2_internal_Scope$State$Closed() {
}
$h_Lfs2_internal_Scope$State$Closed.prototype = $c_Lfs2_internal_Scope$State$Closed.prototype;
$c_Lfs2_internal_Scope$State$Closed.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_internal_Scope$State$Closed.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lfs2_internal_Scope$State$Closed.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
    var x$0$2 = $as_Lfs2_internal_Scope$State$Closed(x$0);
    $n(x$0$2);
    return true;
  } else {
    return false;
  }
});
$c_Lfs2_internal_Scope$State$Closed.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_internal_Scope$State$Closed.prototype.productArity__I = (function() {
  return 0;
});
$c_Lfs2_internal_Scope$State$Closed.prototype.productPrefix__T = (function() {
  return "Closed";
});
$c_Lfs2_internal_Scope$State$Closed.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lfs2_internal_Scope$State$Closed(obj) {
  return (((obj instanceof $c_Lfs2_internal_Scope$State$Closed) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.internal.Scope$State$Closed"));
}
function $isArrayOf_Lfs2_internal_Scope$State$Closed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_internal_Scope$State$Closed)));
}
function $asArrayOf_Lfs2_internal_Scope$State$Closed(obj, depth) {
  return (($isArrayOf_Lfs2_internal_Scope$State$Closed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.internal.Scope$State$Closed;", depth));
}
var $d_Lfs2_internal_Scope$State$Closed = new $TypeData().initClass($c_Lfs2_internal_Scope$State$Closed, "fs2.internal.Scope$State$Closed", ({
  Lfs2_internal_Scope$State$Closed: 1,
  Lfs2_internal_Scope$State: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lfs2_internal_Scope$State$Open(resources, children) {
  this.Lfs2_internal_Scope$State$Open__f_resources = null;
  this.Lfs2_internal_Scope$State$Open__f_children = null;
  this.Lfs2_internal_Scope$State$Open__f_resources = resources;
  this.Lfs2_internal_Scope$State$Open__f_children = children;
}
$c_Lfs2_internal_Scope$State$Open.prototype = new $h_O();
$c_Lfs2_internal_Scope$State$Open.prototype.constructor = $c_Lfs2_internal_Scope$State$Open;
/** @constructor */
function $h_Lfs2_internal_Scope$State$Open() {
}
$h_Lfs2_internal_Scope$State$Open.prototype = $c_Lfs2_internal_Scope$State$Open.prototype;
$c_Lfs2_internal_Scope$State$Open.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_internal_Scope$State$Open.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lfs2_internal_Scope$State$Open.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_internal_Scope$State$Open)) {
    var x$0$2 = $as_Lfs2_internal_Scope$State$Open(x$0);
    var x = this.Lfs2_internal_Scope$State$Open__f_resources;
    var x$2 = $n(x$0$2).Lfs2_internal_Scope$State$Open__f_resources;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lfs2_internal_Scope$State$Open__f_children;
      var x$4 = $n(x$0$2).Lfs2_internal_Scope$State$Open__f_children;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_internal_Scope$State$Open.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_internal_Scope$State$Open.prototype.productArity__I = (function() {
  return 2;
});
$c_Lfs2_internal_Scope$State$Open.prototype.productPrefix__T = (function() {
  return "Open";
});
$c_Lfs2_internal_Scope$State$Open.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_internal_Scope$State$Open__f_resources;
  }
  if ((n === 1)) {
    return this.Lfs2_internal_Scope$State$Open__f_children;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_internal_Scope$State$Open.prototype.unregisterChild__Lcats_effect_kernel_Unique$Token__Lfs2_internal_Scope$State = (function(id) {
  var this$1 = $n(this.Lfs2_internal_Scope$State$Open__f_children);
  var acc = $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil;
  var x116;
  var acc$tailLocal2 = acc;
  var rem$tailLocal2 = this$1;
  while (true) {
    var x86 = $n(rem$tailLocal2).uncons__s_Option();
    if ((x86 instanceof $c_s_Some)) {
      var x88 = $as_T2($n($as_s_Some(x86)).s_Some__f_value);
      if ((x88 !== null)) {
        var a = $n(x88)._1__O();
        var tail = $as_Lcats_data_Chain($n(x88)._2__O());
        var _$20 = $as_Lfs2_internal_Scope(a);
        var x = $n(_$20).Lfs2_internal_Scope__f_id;
        if ((x === null)) {
          var $x_1 = (id === null);
        } else {
          var this$2 = $n(x);
          var $x_1 = (this$2 === id);
        }
        if ((!$x_1)) {
          var this$3 = $n(acc$tailLocal2);
          var acc$tailLocal2$tmp1 = this$3.append__O__Lcats_data_Chain(a);
          rem$tailLocal2 = tail;
          acc$tailLocal2 = acc$tailLocal2$tmp1;
          continue;
        }
        var this$4 = $n(acc$tailLocal2);
        var _2 = $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this$4, tail);
        var value = new $c_T2(a, _2);
        var x116 = new $c_s_Some(value);
        break;
      }
    }
    var x$1 = $m_s_None$();
    if ((x$1 === x86)) {
      var x116 = $m_s_None$();
      break;
    }
    throw new $c_s_MatchError(x86);
  }
  if ((x116 instanceof $c_s_Some)) {
    var x118 = $as_T2($n($as_s_Some(x116)).s_Some__f_value);
    if ((x118 !== null)) {
      var newChildren = $as_Lcats_data_Chain($n(x118)._2__O());
      var resources = this.Lfs2_internal_Scope$State$Open__f_resources;
      return new $c_Lfs2_internal_Scope$State$Open(resources, newChildren);
    }
  }
  var x$2 = $m_s_None$();
  if ((x$2 === x116)) {
    return this;
  }
  throw new $c_s_MatchError(x116);
});
function $as_Lfs2_internal_Scope$State$Open(obj) {
  return (((obj instanceof $c_Lfs2_internal_Scope$State$Open) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.internal.Scope$State$Open"));
}
function $isArrayOf_Lfs2_internal_Scope$State$Open(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_internal_Scope$State$Open)));
}
function $asArrayOf_Lfs2_internal_Scope$State$Open(obj, depth) {
  return (($isArrayOf_Lfs2_internal_Scope$State$Open(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.internal.Scope$State$Open;", depth));
}
var $d_Lfs2_internal_Scope$State$Open = new $TypeData().initClass($c_Lfs2_internal_Scope$State$Open, "fs2.internal.Scope$State$Open", ({
  Lfs2_internal_Scope$State$Open: 1,
  Lfs2_internal_Scope$State: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $p_Ljava_io_ByteArrayOutputStream__growBuf__I__V($thiz, minIncrement) {
  var a = (($thiz.Ljava_io_ByteArrayOutputStream__f_count + minIncrement) | 0);
  var b = ($n($thiz.Ljava_io_ByteArrayOutputStream__f_buf).u.length << 1);
  var newSize = ((a > b) ? a : b);
  var newBuf = new $ac_B(newSize);
  var x0 = $thiz.Ljava_io_ByteArrayOutputStream__f_buf;
  var x4 = $thiz.Ljava_io_ByteArrayOutputStream__f_count;
  $systemArraycopy($n(x0), 0, newBuf, 0, x4);
  $thiz.Ljava_io_ByteArrayOutputStream__f_buf = newBuf;
}
function $ct_Ljava_io_ByteArrayOutputStream__I__($thiz, initBufSize) {
  $thiz.Ljava_io_ByteArrayOutputStream__f_buf = new $ac_B(initBufSize);
  $thiz.Ljava_io_ByteArrayOutputStream__f_count = 0;
  return $thiz;
}
function $ct_Ljava_io_ByteArrayOutputStream__($thiz) {
  $ct_Ljava_io_ByteArrayOutputStream__I__($thiz, 32);
  return $thiz;
}
/** @constructor */
function $c_Ljava_io_ByteArrayOutputStream() {
  this.Ljava_io_ByteArrayOutputStream__f_buf = null;
  this.Ljava_io_ByteArrayOutputStream__f_count = 0;
}
$c_Ljava_io_ByteArrayOutputStream.prototype = new $h_Ljava_io_OutputStream();
$c_Ljava_io_ByteArrayOutputStream.prototype.constructor = $c_Ljava_io_ByteArrayOutputStream;
/** @constructor */
function $h_Ljava_io_ByteArrayOutputStream() {
}
$h_Ljava_io_ByteArrayOutputStream.prototype = $c_Ljava_io_ByteArrayOutputStream.prototype;
$c_Ljava_io_ByteArrayOutputStream.prototype.write__I__V = (function(b) {
  if ((this.Ljava_io_ByteArrayOutputStream__f_count >= $n(this.Ljava_io_ByteArrayOutputStream__f_buf).u.length)) {
    $p_Ljava_io_ByteArrayOutputStream__growBuf__I__V(this, 1);
  }
  $n(this.Ljava_io_ByteArrayOutputStream__f_buf).set(this.Ljava_io_ByteArrayOutputStream__f_count, ((b << 24) >> 24));
  this.Ljava_io_ByteArrayOutputStream__f_count = ((1 + this.Ljava_io_ByteArrayOutputStream__f_count) | 0);
});
$c_Ljava_io_ByteArrayOutputStream.prototype.write__AB__I__I__V = (function(b, off, len) {
  if ((((off < 0) || (len < 0)) || (len > (($n(b).u.length - off) | 0)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  if ((((this.Ljava_io_ByteArrayOutputStream__f_count + len) | 0) > $n(this.Ljava_io_ByteArrayOutputStream__f_buf).u.length)) {
    $p_Ljava_io_ByteArrayOutputStream__growBuf__I__V(this, len);
  }
  var x2 = this.Ljava_io_ByteArrayOutputStream__f_buf;
  var x3 = this.Ljava_io_ByteArrayOutputStream__f_count;
  $systemArraycopy($n(b), off, $n(x2), x3, len);
  this.Ljava_io_ByteArrayOutputStream__f_count = ((this.Ljava_io_ByteArrayOutputStream__f_count + len) | 0);
});
$c_Ljava_io_ByteArrayOutputStream.prototype.toString__T = (function() {
  var bytes = this.Ljava_io_ByteArrayOutputStream__f_buf;
  var length = this.Ljava_io_ByteArrayOutputStream__f_count;
  var this$1 = $m_jl_String$();
  return this$1.new__AB__I__I__Ljava_nio_charset_Charset__T(bytes, 0, length, $m_Ljava_nio_charset_UTF\uff3f8$());
});
var $d_Ljava_io_ByteArrayOutputStream = new $TypeData().initClass($c_Ljava_io_ByteArrayOutputStream, "java.io.ByteArrayOutputStream", ({
  Ljava_io_ByteArrayOutputStream: 1,
  Ljava_io_OutputStream: 1,
  Ljava_io_Closeable: 1,
  jl_AutoCloseable: 1,
  Ljava_io_Flushable: 1
}));
function $ct_Ljava_io_FilterOutputStream__Ljava_io_OutputStream__($thiz, out) {
  $thiz.Ljava_io_FilterOutputStream__f_out = out;
  return $thiz;
}
/** @constructor */
function $c_Ljava_io_FilterOutputStream() {
  this.Ljava_io_FilterOutputStream__f_out = null;
}
$c_Ljava_io_FilterOutputStream.prototype = new $h_Ljava_io_OutputStream();
$c_Ljava_io_FilterOutputStream.prototype.constructor = $c_Ljava_io_FilterOutputStream;
/** @constructor */
function $h_Ljava_io_FilterOutputStream() {
}
$h_Ljava_io_FilterOutputStream.prototype = $c_Ljava_io_FilterOutputStream.prototype;
function $ct_Ljava_io_Writer__($thiz) {
  return $thiz;
}
/** @constructor */
function $c_Ljava_io_Writer() {
}
$c_Ljava_io_Writer.prototype = new $h_O();
$c_Ljava_io_Writer.prototype.constructor = $c_Ljava_io_Writer;
/** @constructor */
function $h_Ljava_io_Writer() {
}
$h_Ljava_io_Writer.prototype = $c_Ljava_io_Writer.prototype;
$c_Ljava_io_Writer.prototype.append__jl_CharSequence__Ljava_io_Writer = (function(csq) {
  var str = ((csq === null) ? "null" : $dp_toString__T($n(csq)));
  var cbuf = $f_T__toCharArray__AC($n(str));
  this.write__AC__I__I__V(cbuf, 0, $n(cbuf).u.length);
  return this;
});
$c_Ljava_io_Writer.prototype.append__jl_CharSequence__jl_Appendable = (function(csq) {
  return this.append__jl_CharSequence__Ljava_io_Writer(csq);
});
class $c_jl_ArithmeticException extends $c_jl_RuntimeException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
}
function $as_jl_ArithmeticException(obj) {
  return (((obj instanceof $c_jl_ArithmeticException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.ArithmeticException"));
}
function $isArrayOf_jl_ArithmeticException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_ArithmeticException)));
}
function $asArrayOf_jl_ArithmeticException(obj, depth) {
  return (($isArrayOf_jl_ArithmeticException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.ArithmeticException;", depth));
}
var $d_jl_ArithmeticException = new $TypeData().initClass($c_jl_ArithmeticException, "java.lang.ArithmeticException", ({
  jl_ArithmeticException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_jl_ArrayStoreException extends $c_jl_RuntimeException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
}
var $d_jl_ArrayStoreException = new $TypeData().initClass($c_jl_ArrayStoreException, "java.lang.ArrayStoreException", ({
  jl_ArrayStoreException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $f_jl_Byte__equals__O__Z($thiz, that) {
  return Object.is($thiz, that);
}
function $f_jl_Byte__hashCode__I($thiz) {
  return $thiz;
}
function $f_jl_Byte__toString__T($thiz) {
  return ("" + $thiz);
}
function $f_jl_Byte__compareTo__O__I($thiz, o) {
  var that = $as_jl_Byte(o);
  var this$1 = $n(that);
  return (($thiz - this$1) | 0);
}
function $as_jl_Byte(obj) {
  return (($isByte(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Byte"));
}
function $isArrayOf_jl_Byte(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Byte)));
}
function $asArrayOf_jl_Byte(obj, depth) {
  return (($isArrayOf_jl_Byte(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Byte;", depth));
}
var $d_jl_Byte = new $TypeData().initClass(0, "java.lang.Byte", ({
  jl_Byte: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1
}), ((x) => $isByte(x)));
function $ct_jl_ClassCastException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_jl_ClassCastException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_jl_ClassCastException extends $c_jl_RuntimeException {
}
function $as_jl_ClassCastException(obj) {
  return (((obj instanceof $c_jl_ClassCastException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.ClassCastException"));
}
function $isArrayOf_jl_ClassCastException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_ClassCastException)));
}
function $asArrayOf_jl_ClassCastException(obj, depth) {
  return (($isArrayOf_jl_ClassCastException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.ClassCastException;", depth));
}
var $d_jl_ClassCastException = new $TypeData().initClass($c_jl_ClassCastException, "java.lang.ClassCastException", ({
  jl_ClassCastException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_jl_IllegalArgumentException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_jl_IllegalArgumentException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_jl_IllegalArgumentException extends $c_jl_RuntimeException {
}
var $d_jl_IllegalArgumentException = new $TypeData().initClass($c_jl_IllegalArgumentException, "java.lang.IllegalArgumentException", ({
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_jl_IllegalStateException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_jl_IllegalStateException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_jl_IllegalStateException extends $c_jl_RuntimeException {
}
var $d_jl_IllegalStateException = new $TypeData().initClass($c_jl_IllegalStateException, "java.lang.IllegalStateException", ({
  jl_IllegalStateException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_jl_IndexOutOfBoundsException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_jl_IndexOutOfBoundsException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_jl_IndexOutOfBoundsException extends $c_jl_RuntimeException {
}
var $d_jl_IndexOutOfBoundsException = new $TypeData().initClass($c_jl_IndexOutOfBoundsException, "java.lang.IndexOutOfBoundsException", ({
  jl_IndexOutOfBoundsException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_jl_JSConsoleBasedPrintStream$DummyOutputStream() {
}
$c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype = new $h_Ljava_io_OutputStream();
$c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype.constructor = $c_jl_JSConsoleBasedPrintStream$DummyOutputStream;
/** @constructor */
function $h_jl_JSConsoleBasedPrintStream$DummyOutputStream() {
}
$h_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype = $c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype;
$c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype.write__I__V = (function(c) {
  throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "Should not get in JSConsoleBasedPrintStream.DummyOutputStream");
});
var $d_jl_JSConsoleBasedPrintStream$DummyOutputStream = new $TypeData().initClass($c_jl_JSConsoleBasedPrintStream$DummyOutputStream, "java.lang.JSConsoleBasedPrintStream$DummyOutputStream", ({
  jl_JSConsoleBasedPrintStream$DummyOutputStream: 1,
  Ljava_io_OutputStream: 1,
  Ljava_io_Closeable: 1,
  jl_AutoCloseable: 1,
  Ljava_io_Flushable: 1
}));
class $c_jl_NegativeArraySizeException extends $c_jl_RuntimeException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
}
var $d_jl_NegativeArraySizeException = new $TypeData().initClass($c_jl_NegativeArraySizeException, "java.lang.NegativeArraySizeException", ({
  jl_NegativeArraySizeException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_jl_NullPointerException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_jl_NullPointerException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_jl_NullPointerException extends $c_jl_RuntimeException {
}
var $d_jl_NullPointerException = new $TypeData().initClass($c_jl_NullPointerException, "java.lang.NullPointerException", ({
  jl_NullPointerException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $as_jl_SecurityException(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.SecurityException"));
}
function $isArrayOf_jl_SecurityException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_SecurityException)));
}
function $asArrayOf_jl_SecurityException(obj, depth) {
  return (($isArrayOf_jl_SecurityException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.SecurityException;", depth));
}
function $f_jl_Short__equals__O__Z($thiz, that) {
  return Object.is($thiz, that);
}
function $f_jl_Short__hashCode__I($thiz) {
  return $thiz;
}
function $f_jl_Short__toString__T($thiz) {
  return ("" + $thiz);
}
function $f_jl_Short__compareTo__O__I($thiz, o) {
  var that = $as_jl_Short(o);
  var this$1 = $n(that);
  return (($thiz - this$1) | 0);
}
function $as_jl_Short(obj) {
  return (($isShort(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Short"));
}
function $isArrayOf_jl_Short(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Short)));
}
function $asArrayOf_jl_Short(obj, depth) {
  return (($isArrayOf_jl_Short(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Short;", depth));
}
var $d_jl_Short = new $TypeData().initClass(0, "java.lang.Short", ({
  jl_Short: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1
}), ((x) => $isShort(x)));
class $c_jl_StackOverflowError extends $c_jl_VirtualMachineError {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
}
var $d_jl_StackOverflowError = new $TypeData().initClass($c_jl_StackOverflowError, "java.lang.StackOverflowError", ({
  jl_StackOverflowError: 1,
  jl_VirtualMachineError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_jl_UnsupportedOperationException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
function $ct_jl_UnsupportedOperationException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
class $c_jl_UnsupportedOperationException extends $c_jl_RuntimeException {
}
var $d_jl_UnsupportedOperationException = new $TypeData().initClass($c_jl_UnsupportedOperationException, "java.lang.UnsupportedOperationException", ({
  jl_UnsupportedOperationException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_Ljava_nio_BufferOverflowException extends $c_jl_RuntimeException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
}
function $as_Ljava_nio_BufferOverflowException(obj) {
  return (((obj instanceof $c_Ljava_nio_BufferOverflowException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.nio.BufferOverflowException"));
}
function $isArrayOf_Ljava_nio_BufferOverflowException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_nio_BufferOverflowException)));
}
function $asArrayOf_Ljava_nio_BufferOverflowException(obj, depth) {
  return (($isArrayOf_Ljava_nio_BufferOverflowException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.nio.BufferOverflowException;", depth));
}
var $d_Ljava_nio_BufferOverflowException = new $TypeData().initClass($c_Ljava_nio_BufferOverflowException, "java.nio.BufferOverflowException", ({
  Ljava_nio_BufferOverflowException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_Ljava_nio_BufferUnderflowException extends $c_jl_RuntimeException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
}
function $as_Ljava_nio_BufferUnderflowException(obj) {
  return (((obj instanceof $c_Ljava_nio_BufferUnderflowException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.nio.BufferUnderflowException"));
}
function $isArrayOf_Ljava_nio_BufferUnderflowException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_nio_BufferUnderflowException)));
}
function $asArrayOf_Ljava_nio_BufferUnderflowException(obj, depth) {
  return (($isArrayOf_Ljava_nio_BufferUnderflowException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.nio.BufferUnderflowException;", depth));
}
var $d_Ljava_nio_BufferUnderflowException = new $TypeData().initClass($c_Ljava_nio_BufferUnderflowException, "java.nio.BufferUnderflowException", ({
  Ljava_nio_BufferUnderflowException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_Ljava_nio_charset_CharacterCodingException extends $c_Ljava_io_IOException {
}
/** @constructor */
function $c_ju_AbstractList() {
}
$c_ju_AbstractList.prototype = new $h_ju_AbstractCollection();
$c_ju_AbstractList.prototype.constructor = $c_ju_AbstractList;
/** @constructor */
function $h_ju_AbstractList() {
}
$h_ju_AbstractList.prototype = $c_ju_AbstractList.prototype;
$c_ju_AbstractList.prototype.iterator__ju_Iterator = (function() {
  return this.listIterator__I__ju_ListIterator(0);
});
$c_ju_AbstractList.prototype.listIterator__I__ju_ListIterator = (function(index) {
  this.checkIndexOnBounds__I__V(index);
  return new $c_ju_RandomAccessListIterator(this, index, 0, this.size__I());
});
$c_ju_AbstractList.prototype.equals__O__Z = (function(o) {
  if ((o === this)) {
    return true;
  } else if ($is_ju_List(o)) {
    var x2 = $as_ju_List(o);
    var this$1 = $n(x2);
    var oIter = this$1.listIterator__I__ju_ListIterator(0);
    var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
    _return: {
      while ($n(_\uff3fself).hasNext__Z()) {
        var x$2 = $n(_\uff3fself).next__O();
        if ($n(oIter).hasNext__Z()) {
          var b = $n(oIter).next__O();
          var $x_2 = ((x$2 === null) ? (b === null) : $dp_equals__O__Z($n(x$2), b));
        } else {
          var $x_2 = false;
        }
        if ((!$x_2)) {
          var $x_1 = true;
          break _return;
        }
      }
      var $x_1 = false;
    }
    if ((!$x_1)) {
      return (!$n(oIter).hasNext__Z());
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_ju_AbstractList.prototype.hashCode__I = (function() {
  var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
  var result = 1;
  while ($n(_\uff3fself).hasNext__Z()) {
    var prev$2 = result;
    var elem$2 = $n(_\uff3fself).next__O();
    var prev = $uI(prev$2);
    result = ((Math.imul(31, prev) + ((elem$2 === null) ? 0 : $dp_hashCode__I($n(elem$2)))) | 0);
  }
  return $uI(result);
});
$c_ju_AbstractList.prototype.checkIndexInBounds__I__V = (function(index) {
  if (((index < 0) || (index >= this.size__I()))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index));
  }
});
$c_ju_AbstractList.prototype.checkIndexOnBounds__I__V = (function(index) {
  if (((index < 0) || (index > this.size__I()))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index));
  }
});
/** @constructor */
function $c_ju_AbstractSet() {
}
$c_ju_AbstractSet.prototype = new $h_ju_AbstractCollection();
$c_ju_AbstractSet.prototype.constructor = $c_ju_AbstractSet;
/** @constructor */
function $h_ju_AbstractSet() {
}
$h_ju_AbstractSet.prototype = $c_ju_AbstractSet.prototype;
$c_ju_AbstractSet.prototype.equals__O__Z = (function(that) {
  if ((that === this)) {
    return true;
  } else if ($is_ju_Collection(that)) {
    var x2 = $as_ju_Collection(that);
    return (($n(x2).size__I() === this.size__I()) && this.containsAll__ju_Collection__Z(x2));
  } else {
    return false;
  }
});
$c_ju_AbstractSet.prototype.hashCode__I = (function() {
  var _\uff3fself = this.iterator__ju_Iterator();
  var result = 0;
  while ($n(_\uff3fself).hasNext__Z()) {
    var prev$2 = result;
    var item$2 = $n(_\uff3fself).next__O();
    var prev = $uI(prev$2);
    result = (($dp_hashCode__I($n(item$2)) + prev) | 0);
  }
  return $uI(result);
});
class $c_ju_ConcurrentModificationException extends $c_jl_RuntimeException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
}
var $d_ju_ConcurrentModificationException = new $TypeData().initClass($c_ju_ConcurrentModificationException, "java.util.ConcurrentModificationException", ({
  ju_ConcurrentModificationException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $p_ju_HashMap__getOrDefaultImpl__O__O__O($thiz, key, defaultValue) {
  if ((key === null)) {
    var hash = 0;
  } else {
    var originalHash = $dp_hashCode__I($n(key));
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  var node = $thiz.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, (hash & (((-1) + $n($thiz.ju_HashMap__f_java$util$HashMap$$table).u.length) | 0)));
  return ((node === null) ? defaultValue : $n(node).ju_HashMap$Node__f_value);
}
function $p_ju_HashMap__growTable__V($thiz) {
  var oldTable = $thiz.ju_HashMap__f_java$util$HashMap$$table;
  var oldlen = $n(oldTable).u.length;
  var newlen = (oldlen << 1);
  var newTable = new ($d_ju_HashMap$Node.getArrayOf().constr)(newlen);
  $thiz.ju_HashMap__f_java$util$HashMap$$table = newTable;
  $thiz.ju_HashMap__f_threshold = $doubleToInt((newlen * $thiz.ju_HashMap__f_java$util$HashMap$$loadFactor));
  var i = 0;
  while ((i < oldlen)) {
    var lastLow = null;
    var lastHigh = null;
    var node = $n(oldTable).get(i);
    while ((node !== null)) {
      if ((($n(node).ju_HashMap$Node__f_hash & oldlen) === 0)) {
        $n(node).ju_HashMap$Node__f_previous = lastLow;
        if ((lastLow === null)) {
          $n(newTable).set(i, node);
        } else {
          $n(lastLow).ju_HashMap$Node__f_next = node;
        }
        lastLow = node;
      } else {
        $n(node).ju_HashMap$Node__f_previous = lastHigh;
        if ((lastHigh === null)) {
          $n(newTable).set(((oldlen + i) | 0), node);
        } else {
          $n(lastHigh).ju_HashMap$Node__f_next = node;
        }
        lastHigh = node;
      }
      node = $n(node).ju_HashMap$Node__f_next;
    }
    if ((lastLow !== null)) {
      $n(lastLow).ju_HashMap$Node__f_next = null;
    }
    if ((lastHigh !== null)) {
      $n(lastHigh).ju_HashMap$Node__f_next = null;
    }
    i = ((1 + i) | 0);
  }
}
function $ct_ju_HashMap__I__F__($thiz, initialCapacity, loadFactor) {
  $thiz.ju_HashMap__f_java$util$HashMap$$loadFactor = loadFactor;
  if ((initialCapacity < 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "initialCapacity < 0");
  }
  if ((loadFactor <= 0.0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "loadFactor <= 0.0");
  }
  var a = (((-1) + initialCapacity) | 0);
  var i = ((a > 4) ? a : 4);
  var a$1 = ((((-2147483648) >> $uI(Math.clz32(i))) & i) << 1);
  $thiz.ju_HashMap__f_java$util$HashMap$$table = new ($d_ju_HashMap$Node.getArrayOf().constr)(((a$1 < 1073741824) ? a$1 : 1073741824));
  var size = $n($thiz.ju_HashMap__f_java$util$HashMap$$table).u.length;
  $thiz.ju_HashMap__f_threshold = $doubleToInt((size * $thiz.ju_HashMap__f_java$util$HashMap$$loadFactor));
  $thiz.ju_HashMap__f_contentSize = 0;
  return $thiz;
}
/** @constructor */
function $c_ju_HashMap() {
  this.ju_HashMap__f_java$util$HashMap$$loadFactor = 0.0;
  this.ju_HashMap__f_java$util$HashMap$$table = null;
  this.ju_HashMap__f_threshold = 0;
  this.ju_HashMap__f_contentSize = 0;
}
$c_ju_HashMap.prototype = new $h_ju_AbstractMap();
$c_ju_HashMap.prototype.constructor = $c_ju_HashMap;
/** @constructor */
function $h_ju_HashMap() {
}
$h_ju_HashMap.prototype = $c_ju_HashMap.prototype;
$c_ju_HashMap.prototype.size__I = (function() {
  return this.ju_HashMap__f_contentSize;
});
$c_ju_HashMap.prototype.remove__O__O = (function(key) {
  var node = this.java$util$HashMap$$remove0__O__ju_HashMap$Node(key);
  return ((node === null) ? null : $n(node).ju_HashMap$Node__f_value);
});
$c_ju_HashMap.prototype.containsValue__O__Z = (function(value) {
  var _\uff3fself = new $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator(this);
  while (_\uff3fself.hasNext__Z()) {
    var x$1$2 = _\uff3fself.next__O();
    if (((value === null) ? (x$1$2 === null) : $dp_equals__O__Z($n(value), x$1$2))) {
      return true;
    }
  }
  return false;
});
$c_ju_HashMap.prototype.entrySet__ju_Set = (function() {
  return new $c_ju_HashMap$EntrySet(this);
});
$c_ju_HashMap.prototype.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node = (function(key, hash, idx) {
  var node = $n(this.ju_HashMap__f_java$util$HashMap$$table).get(idx);
  while (true) {
    if ((node === null)) {
      return null;
    } else {
      if ((hash === $n(node).ju_HashMap$Node__f_hash)) {
        var b = $n(node).ju_HashMap$Node__f_key;
        var $x_1 = ((key === null) ? (b === null) : $dp_equals__O__Z($n(key), b));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        return node;
      } else if ((hash < $n(node).ju_HashMap$Node__f_hash)) {
        return null;
      } else {
        node = $n(node).ju_HashMap$Node__f_next;
      }
    }
  }
});
$c_ju_HashMap.prototype.java$util$HashMap$$put0__O__O__I__Z__O = (function(key, value, hash, ifAbsent) {
  var newContentSize = ((1 + this.ju_HashMap__f_contentSize) | 0);
  if ((newContentSize >= this.ju_HashMap__f_threshold)) {
    $p_ju_HashMap__growTable__V(this);
  }
  var idx = (hash & (((-1) + $n(this.ju_HashMap__f_java$util$HashMap$$table).u.length) | 0));
  var x1 = $n(this.ju_HashMap__f_java$util$HashMap$$table).get(idx);
  if ((x1 === null)) {
    var newNode = new $c_ju_NullRejectingHashMap$Node(key, hash, value, null, null);
    $n(this.ju_HashMap__f_java$util$HashMap$$table).set(idx, newNode);
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && ($n(n).ju_HashMap$Node__f_hash <= hash))) {
      if (($n(n).ju_HashMap$Node__f_hash === hash)) {
        var b = $n(n).ju_HashMap$Node__f_key;
        var $x_1 = ((key === null) ? (b === null) : $dp_equals__O__Z($n(key), b));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var old = $n(n).ju_HashMap$Node__f_value;
        if (((!ifAbsent) || (old === null))) {
          $n(n).ju_HashMap$Node__f_value = value;
        }
        return old;
      }
      prev = n;
      n = $n(n).ju_HashMap$Node__f_next;
    }
    var previous = prev;
    var next = n;
    var newNode$2 = new $c_ju_NullRejectingHashMap$Node(key, hash, value, previous, next);
    if ((prev === null)) {
      $n(this.ju_HashMap__f_java$util$HashMap$$table).set(idx, newNode$2);
    } else {
      $n(prev).ju_HashMap$Node__f_next = newNode$2;
    }
    if ((n !== null)) {
      $n(n).ju_HashMap$Node__f_previous = newNode$2;
    }
  }
  this.ju_HashMap__f_contentSize = newContentSize;
  return null;
});
$c_ju_HashMap.prototype.java$util$HashMap$$remove0__O__ju_HashMap$Node = (function(key) {
  if ((key === null)) {
    var hash = 0;
  } else {
    var originalHash = $dp_hashCode__I($n(key));
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  var idx = (hash & (((-1) + $n(this.ju_HashMap__f_java$util$HashMap$$table).u.length) | 0));
  var node = this.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, idx);
  if ((node !== null)) {
    this.java$util$HashMap$$remove0__ju_HashMap$Node__I__V(node, idx);
  }
  return node;
});
$c_ju_HashMap.prototype.java$util$HashMap$$remove0__ju_HashMap$Node__I__V = (function(node, idx) {
  var previous = $n(node).ju_HashMap$Node__f_previous;
  var next = $n(node).ju_HashMap$Node__f_next;
  if ((previous === null)) {
    $n(this.ju_HashMap__f_java$util$HashMap$$table).set(idx, next);
  } else {
    $n(previous).ju_HashMap$Node__f_next = next;
  }
  if ((next !== null)) {
    $n(next).ju_HashMap$Node__f_previous = previous;
  }
  this.ju_HashMap__f_contentSize = (((-1) + this.ju_HashMap__f_contentSize) | 0);
});
function $ct_ju_NoSuchElementException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_ju_NoSuchElementException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_ju_NoSuchElementException extends $c_jl_RuntimeException {
}
var $d_ju_NoSuchElementException = new $TypeData().initClass($c_ju_NoSuchElementException, "java.util.NoSuchElementException", ({
  ju_NoSuchElementException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_RandomAccessListIterator(list, i, start, end) {
  this.ju_AbstractRandomAccessListIterator__f_i = 0;
  this.ju_AbstractRandomAccessListIterator__f_end = 0;
  this.ju_AbstractRandomAccessListIterator__f_last = 0;
  this.ju_RandomAccessListIterator__f_list = null;
  this.ju_RandomAccessListIterator__f_list = list;
  $ct_ju_AbstractRandomAccessListIterator__I__I__I__(this, i, start, end);
}
$c_ju_RandomAccessListIterator.prototype = new $h_ju_AbstractRandomAccessListIterator();
$c_ju_RandomAccessListIterator.prototype.constructor = $c_ju_RandomAccessListIterator;
/** @constructor */
function $h_ju_RandomAccessListIterator() {
}
$h_ju_RandomAccessListIterator.prototype = $c_ju_RandomAccessListIterator.prototype;
$c_ju_RandomAccessListIterator.prototype.get__I__O = (function(index) {
  return $n(this.ju_RandomAccessListIterator__f_list).get__I__O(index);
});
var $d_ju_RandomAccessListIterator = new $TypeData().initClass($c_ju_RandomAccessListIterator, "java.util.RandomAccessListIterator", ({
  ju_RandomAccessListIterator: 1,
  ju_AbstractRandomAccessListIterator: 1,
  ju_ListIterator: 1,
  ju_Iterator: 1,
  ju_SizeChangeEvent: 1
}));
function $ct_ju_concurrent_ConcurrentHashMap__I__F__($thiz, initialCapacity, loadFactor) {
  $thiz.ju_concurrent_ConcurrentHashMap__f_inner = new $c_ju_concurrent_ConcurrentHashMap$InnerHashMap(initialCapacity, loadFactor);
  return $thiz;
}
function $ct_ju_concurrent_ConcurrentHashMap__($thiz) {
  $ct_ju_concurrent_ConcurrentHashMap__I__F__($thiz, 16, 0.75);
  return $thiz;
}
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap() {
  this.ju_concurrent_ConcurrentHashMap__f_inner = null;
}
$c_ju_concurrent_ConcurrentHashMap.prototype = new $h_ju_AbstractMap();
$c_ju_concurrent_ConcurrentHashMap.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap() {
}
$h_ju_concurrent_ConcurrentHashMap.prototype = $c_ju_concurrent_ConcurrentHashMap.prototype;
$c_ju_concurrent_ConcurrentHashMap.prototype.size__I = (function() {
  return $n(this.ju_concurrent_ConcurrentHashMap__f_inner).ju_HashMap__f_contentSize;
});
$c_ju_concurrent_ConcurrentHashMap.prototype.get__O__O = (function(key) {
  return $n(this.ju_concurrent_ConcurrentHashMap__f_inner).get__O__O(key);
});
$c_ju_concurrent_ConcurrentHashMap.prototype.put__O__O__O = (function(key, value) {
  return $n(this.ju_concurrent_ConcurrentHashMap__f_inner).put__O__O__O(key, value);
});
$c_ju_concurrent_ConcurrentHashMap.prototype.remove__O__O = (function(key) {
  return $n(this.ju_concurrent_ConcurrentHashMap__f_inner).remove__O__O(key);
});
$c_ju_concurrent_ConcurrentHashMap.prototype.values__ju_Collection = (function() {
  var this$1 = $n(this.ju_concurrent_ConcurrentHashMap__f_inner);
  return new $c_ju_HashMap$Values(this$1);
});
$c_ju_concurrent_ConcurrentHashMap.prototype.entrySet__ju_Set = (function() {
  var this$1 = $n(this.ju_concurrent_ConcurrentHashMap__f_inner);
  return new $c_ju_HashMap$EntrySet(this$1);
});
$c_ju_concurrent_ConcurrentHashMap.prototype.hashCode__I = (function() {
  return $n(this.ju_concurrent_ConcurrentHashMap__f_inner).hashCode__I();
});
$c_ju_concurrent_ConcurrentHashMap.prototype.toString__T = (function() {
  return $n(this.ju_concurrent_ConcurrentHashMap__f_inner).toString__T();
});
$c_ju_concurrent_ConcurrentHashMap.prototype.equals__O__Z = (function(o) {
  return $n(this.ju_concurrent_ConcurrentHashMap__f_inner).equals__O__Z(o);
});
var $d_ju_concurrent_ConcurrentHashMap = new $TypeData().initClass($c_ju_concurrent_ConcurrentHashMap, "java.util.concurrent.ConcurrentHashMap", ({
  ju_concurrent_ConcurrentHashMap: 1,
  ju_AbstractMap: 1,
  ju_Map: 1,
  ju_concurrent_ConcurrentMap: 1,
  Ljava_io_Serializable: 1
}));
function $as_ju_concurrent_RejectedExecutionException(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.concurrent.RejectedExecutionException"));
}
function $isArrayOf_ju_concurrent_RejectedExecutionException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_concurrent_RejectedExecutionException)));
}
function $asArrayOf_ju_concurrent_RejectedExecutionException(obj, depth) {
  return (($isArrayOf_ju_concurrent_RejectedExecutionException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.concurrent.RejectedExecutionException;", depth));
}
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "NANOSECONDS", 0);
}
$c_ju_concurrent_TimeUnit$$anon$1.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$1.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$1;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$1() {
}
$h_ju_concurrent_TimeUnit$$anon$1.prototype = $c_ju_concurrent_TimeUnit$$anon$1.prototype;
$c_ju_concurrent_TimeUnit$$anon$1.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return $n(u).toNanos__J__J(a);
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toNanos__J__J = (function(a) {
  return a;
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toMicros__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toMillis__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toSeconds__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toMinutes__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, (-129542144), 13);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 817405952, 838);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, (-1857093632), 20116);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
var $d_ju_concurrent_TimeUnit$$anon$1 = new $TypeData().initClass($c_ju_concurrent_TimeUnit$$anon$1, "java.util.concurrent.TimeUnit$$anon$1", ({
  ju_concurrent_TimeUnit$$anon$1: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "MICROSECONDS", 1);
}
$c_ju_concurrent_TimeUnit$$anon$2.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$2.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$2;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$2() {
}
$h_ju_concurrent_TimeUnit$$anon$2.prototype = $c_ju_concurrent_TimeUnit$$anon$2.prototype;
$c_ju_concurrent_TimeUnit$$anon$2.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return $n(u).toMicros__J__J(a);
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000, 0), new $c_RTLong((-1511828489), 2147483));
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toMicros__J__J = (function(a) {
  return a;
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toMillis__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toSeconds__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toMinutes__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 60000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, (-694967296), 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 500654080, 20);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
var $d_ju_concurrent_TimeUnit$$anon$2 = new $TypeData().initClass($c_ju_concurrent_TimeUnit$$anon$2, "java.util.concurrent.TimeUnit$$anon$2", ({
  ju_concurrent_TimeUnit$$anon$2: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "MILLISECONDS", 2);
}
$c_ju_concurrent_TimeUnit$$anon$3.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$3.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$3;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$3() {
}
$h_ju_concurrent_TimeUnit$$anon$3.prototype = $c_ju_concurrent_TimeUnit$$anon$3.prototype;
$c_ju_concurrent_TimeUnit$$anon$3.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return $n(u).toMillis__J__J(a);
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000000, 0), new $c_RTLong(2077252342, 2147));
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000, 0), new $c_RTLong((-1511828489), 2147483));
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toMillis__J__J = (function(a) {
  return a;
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toSeconds__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toMinutes__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 60000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 3600000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 86400000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
var $d_ju_concurrent_TimeUnit$$anon$3 = new $TypeData().initClass($c_ju_concurrent_TimeUnit$$anon$3, "java.util.concurrent.TimeUnit$$anon$3", ({
  ju_concurrent_TimeUnit$$anon$3: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "SECONDS", 3);
}
$c_ju_concurrent_TimeUnit$$anon$4.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$4.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$4;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$4() {
}
$h_ju_concurrent_TimeUnit$$anon$4.prototype = $c_ju_concurrent_TimeUnit$$anon$4.prototype;
$c_ju_concurrent_TimeUnit$$anon$4.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return $n(u).toSeconds__J__J(a);
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000000000, 0), new $c_RTLong(633437444, 2));
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000000, 0), new $c_RTLong(2077252342, 2147));
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toMillis__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000, 0), new $c_RTLong((-1511828489), 2147483));
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toSeconds__J__J = (function(a) {
  return a;
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toMinutes__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 60, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 3600, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 86400, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
var $d_ju_concurrent_TimeUnit$$anon$4 = new $TypeData().initClass($c_ju_concurrent_TimeUnit$$anon$4, "java.util.concurrent.TimeUnit$$anon$4", ({
  ju_concurrent_TimeUnit$$anon$4: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$5() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "MINUTES", 4);
}
$c_ju_concurrent_TimeUnit$$anon$5.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$5.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$5;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$5() {
}
$h_ju_concurrent_TimeUnit$$anon$5.prototype = $c_ju_concurrent_TimeUnit$$anon$5.prototype;
$c_ju_concurrent_TimeUnit$$anon$5.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return $n(u).toMinutes__J__J(a);
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong((-129542144), 13), new $c_RTLong(153722867, 0));
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(60000000, 0), new $c_RTLong((-895955376), 35));
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toMillis__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(60000, 0), new $c_RTLong(1692789776, 35791));
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toSeconds__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(60, 0), new $c_RTLong(572662306, 35791394));
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toMinutes__J__J = (function(a) {
  return a;
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 60, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1440, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
var $d_ju_concurrent_TimeUnit$$anon$5 = new $TypeData().initClass($c_ju_concurrent_TimeUnit$$anon$5, "java.util.concurrent.TimeUnit$$anon$5", ({
  ju_concurrent_TimeUnit$$anon$5: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$6() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "HOURS", 5);
}
$c_ju_concurrent_TimeUnit$$anon$6.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$6.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$6;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$6() {
}
$h_ju_concurrent_TimeUnit$$anon$6.prototype = $c_ju_concurrent_TimeUnit$$anon$6.prototype;
$c_ju_concurrent_TimeUnit$$anon$6.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return $n(u).toHours__J__J(a);
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(817405952, 838), new $c_RTLong(2562047, 0));
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong((-694967296), 0), new $c_RTLong((-1732919508), 0));
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toMillis__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(3600000, 0), new $c_RTLong((-2047687697), 596));
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toSeconds__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(3600, 0), new $c_RTLong(1011703407, 596523));
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toMinutes__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(60, 0), new $c_RTLong(572662306, 35791394));
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toHours__J__J = (function(a) {
  return a;
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 24, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
var $d_ju_concurrent_TimeUnit$$anon$6 = new $TypeData().initClass($c_ju_concurrent_TimeUnit$$anon$6, "java.util.concurrent.TimeUnit$$anon$6", ({
  ju_concurrent_TimeUnit$$anon$6: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$7() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "DAYS", 6);
}
$c_ju_concurrent_TimeUnit$$anon$7.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$7.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$7;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$7() {
}
$h_ju_concurrent_TimeUnit$$anon$7.prototype = $c_ju_concurrent_TimeUnit$$anon$7.prototype;
$c_ju_concurrent_TimeUnit$$anon$7.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return $n(u).toDays__J__J(a);
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong((-1857093632), 20116), new $c_RTLong(106751, 0));
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(500654080, 20), new $c_RTLong(106751991, 0));
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toMillis__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(86400000, 0), new $c_RTLong((-622191233), 24));
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toSeconds__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(86400, 0), new $c_RTLong(579025220, 24855));
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toMinutes__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1440, 0), new $c_RTLong(381774870, 1491308));
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toHours__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(24, 0), new $c_RTLong(1431655765, 89478485));
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toDays__J__J = (function(a) {
  return a;
});
var $d_ju_concurrent_TimeUnit$$anon$7 = new $TypeData().initClass($c_ju_concurrent_TimeUnit$$anon$7, "java.util.concurrent.TimeUnit$$anon$7", ({
  ju_concurrent_TimeUnit$$anon$7: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_MarkupParser$$anon$1() {
}
$c_Llaika_api_MarkupParser$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_api_MarkupParser$$anon$1.prototype.constructor = $c_Llaika_api_MarkupParser$$anon$1;
/** @constructor */
function $h_Llaika_api_MarkupParser$$anon$1() {
}
$h_Llaika_api_MarkupParser$$anon$1.prototype = $c_Llaika_api_MarkupParser$$anon$1.prototype;
$c_Llaika_api_MarkupParser$$anon$1.prototype.isDefinedAt__Llaika_ast_Element__Z = (function(x) {
  return (false && ($as_Llaika_ast_EmbeddedConfigValue(x), true));
});
$c_Llaika_api_MarkupParser$$anon$1.prototype.applyOrElse__Llaika_ast_Element__F1__O = (function(x, default$1) {
  if (false) {
    var c = $as_Llaika_ast_EmbeddedConfigValue(x);
    var _1 = $n(c).key__T();
    var _2 = $n(c).value__Llaika_api_config_ConfigValue();
    return new $c_T2(_1, _2);
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_api_MarkupParser$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Element__Z($as_Llaika_ast_Element(x));
});
$c_Llaika_api_MarkupParser$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Element__F1__O($as_Llaika_ast_Element(x), default$1);
});
var $d_Llaika_api_MarkupParser$$anon$1 = new $TypeData().initClass($c_Llaika_api_MarkupParser$$anon$1, "laika.api.MarkupParser$$anon$1", ({
  Llaika_api_MarkupParser$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_builder_OperationConfig$$anon$1(format$2) {
  this.Llaika_api_builder_OperationConfig$$anon$1__f_format$1 = null;
  this.Llaika_api_builder_OperationConfig$$anon$1__f_format$1 = format$2;
}
$c_Llaika_api_builder_OperationConfig$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_api_builder_OperationConfig$$anon$1.prototype.constructor = $c_Llaika_api_builder_OperationConfig$$anon$1;
/** @constructor */
function $h_Llaika_api_builder_OperationConfig$$anon$1() {
}
$h_Llaika_api_builder_OperationConfig$$anon$1.prototype = $c_Llaika_api_builder_OperationConfig$$anon$1.prototype;
$c_Llaika_api_builder_OperationConfig$$anon$1.prototype.isDefinedAt__Llaika_api_bundle_RenderOverrides__Z = (function(x) {
  return (((x instanceof $c_Llaika_api_format_RenderFormat$Overrides) && ($n($as_Llaika_api_format_RenderFormat$Overrides(x)).Llaika_api_format_RenderFormat$Overrides__f_$outer === this.Llaika_api_builder_OperationConfig$$anon$1__f_format$1)) && ($as_Llaika_api_format_RenderFormat$Overrides(x), true));
});
$c_Llaika_api_builder_OperationConfig$$anon$1.prototype.applyOrElse__Llaika_api_bundle_RenderOverrides__F1__O = (function(x, default$1) {
  if (((x instanceof $c_Llaika_api_format_RenderFormat$Overrides) && ($n($as_Llaika_api_format_RenderFormat$Overrides(x)).Llaika_api_format_RenderFormat$Overrides__f_$outer === this.Llaika_api_builder_OperationConfig$$anon$1__f_format$1))) {
    var t = $as_Llaika_api_format_RenderFormat$Overrides(x);
    return t;
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_api_builder_OperationConfig$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_api_bundle_RenderOverrides__Z($as_Llaika_api_bundle_RenderOverrides(x));
});
$c_Llaika_api_builder_OperationConfig$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_api_bundle_RenderOverrides__F1__O($as_Llaika_api_bundle_RenderOverrides(x), default$1);
});
var $d_Llaika_api_builder_OperationConfig$$anon$1 = new $TypeData().initClass($c_Llaika_api_builder_OperationConfig$$anon$1, "laika.api.builder.OperationConfig$$anon$1", ({
  Llaika_api_builder_OperationConfig$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_builder_TransformerBuilder(markupFormat, renderFormat, config) {
  this.Llaika_api_builder_TransformerBuilder__f_markupFormat = null;
  this.Llaika_api_builder_TransformerBuilder__f_renderFormat = null;
  this.Llaika_api_builder_TransformerBuilder__f_config = null;
  this.Llaika_api_builder_TransformerBuilder__f_markupFormat = markupFormat;
  this.Llaika_api_builder_TransformerBuilder__f_renderFormat = renderFormat;
  this.Llaika_api_builder_TransformerBuilder__f_config = config;
}
$c_Llaika_api_builder_TransformerBuilder.prototype = new $h_O();
$c_Llaika_api_builder_TransformerBuilder.prototype.constructor = $c_Llaika_api_builder_TransformerBuilder;
/** @constructor */
function $h_Llaika_api_builder_TransformerBuilder() {
}
$h_Llaika_api_builder_TransformerBuilder.prototype = $c_Llaika_api_builder_TransformerBuilder.prototype;
$c_Llaika_api_builder_TransformerBuilder.prototype.config__Llaika_api_builder_OperationConfig = (function() {
  return this.Llaika_api_builder_TransformerBuilder__f_config;
});
$c_Llaika_api_builder_TransformerBuilder.prototype.withConfig__Llaika_api_builder_OperationConfig__Llaika_api_builder_TransformerBuilder = (function(newConfig) {
  return new $c_Llaika_api_builder_TransformerBuilder(this.Llaika_api_builder_TransformerBuilder__f_markupFormat, this.Llaika_api_builder_TransformerBuilder__f_renderFormat, newConfig);
});
$c_Llaika_api_builder_TransformerBuilder.prototype.build__Llaika_api_Transformer = (function() {
  var parser = new $c_Llaika_api_MarkupParser(this.Llaika_api_builder_TransformerBuilder__f_markupFormat, this.Llaika_api_builder_TransformerBuilder__f_config);
  var this$1 = new $c_Llaika_api_builder_RendererBuilder(this.Llaika_api_builder_TransformerBuilder__f_renderFormat, this.Llaika_api_builder_TransformerBuilder__f_config, false);
  var renderer = new $c_Llaika_api_builder_RendererBuilder$$anon$1(this$1);
  return new $c_Llaika_api_Transformer(parser, renderer);
});
$c_Llaika_api_builder_TransformerBuilder.prototype.withConfig__Llaika_api_builder_OperationConfig__O = (function(newConfig) {
  return this.withConfig__Llaika_api_builder_OperationConfig__Llaika_api_builder_TransformerBuilder(newConfig);
});
function $as_Llaika_api_builder_TransformerBuilder(obj) {
  return (((obj instanceof $c_Llaika_api_builder_TransformerBuilder) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.builder.TransformerBuilder"));
}
function $isArrayOf_Llaika_api_builder_TransformerBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_builder_TransformerBuilder)));
}
function $asArrayOf_Llaika_api_builder_TransformerBuilder(obj, depth) {
  return (($isArrayOf_Llaika_api_builder_TransformerBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.builder.TransformerBuilder;", depth));
}
var $d_Llaika_api_builder_TransformerBuilder = new $TypeData().initClass($c_Llaika_api_builder_TransformerBuilder, "laika.api.builder.TransformerBuilder", ({
  Llaika_api_builder_TransformerBuilder: 1,
  Llaika_api_builder_CommonBuilderOps: 1,
  Llaika_api_builder_ParserBuilderOps: 1,
  Llaika_api_builder_RendererBuilderOps: 1,
  Llaika_api_builder_TransformerBuilderOps: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_AttributeKey$Named(key) {
  this.Llaika_api_bundle_AttributeKey$Named__f_key = null;
  this.Llaika_api_bundle_AttributeKey$Named__f_key = key;
}
$c_Llaika_api_bundle_AttributeKey$Named.prototype = new $h_Llaika_api_bundle_AttributeKey();
$c_Llaika_api_bundle_AttributeKey$Named.prototype.constructor = $c_Llaika_api_bundle_AttributeKey$Named;
/** @constructor */
function $h_Llaika_api_bundle_AttributeKey$Named() {
}
$h_Llaika_api_bundle_AttributeKey$Named.prototype = $c_Llaika_api_bundle_AttributeKey$Named.prototype;
$c_Llaika_api_bundle_AttributeKey$Named.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_bundle_AttributeKey$Named.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_bundle_AttributeKey$Named.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_bundle_AttributeKey$Named)) {
    var x$0$2 = $as_Llaika_api_bundle_AttributeKey$Named(x$0);
    return ((this.Llaika_api_bundle_AttributeKey$Named__f_key === $n(x$0$2).Llaika_api_bundle_AttributeKey$Named__f_key) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Llaika_api_bundle_AttributeKey$Named.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_bundle_AttributeKey$Named.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_api_bundle_AttributeKey$Named.prototype.productPrefix__T = (function() {
  return "Named";
});
$c_Llaika_api_bundle_AttributeKey$Named.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_bundle_AttributeKey$Named__f_key;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_api_bundle_AttributeKey$Named.prototype.key__T = (function() {
  return this.Llaika_api_bundle_AttributeKey$Named__f_key;
});
$c_Llaika_api_bundle_AttributeKey$Named.prototype.desc__T = (function() {
  return (("attribute '" + this.Llaika_api_bundle_AttributeKey$Named__f_key) + "'");
});
function $as_Llaika_api_bundle_AttributeKey$Named(obj) {
  return (((obj instanceof $c_Llaika_api_bundle_AttributeKey$Named) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.AttributeKey$Named"));
}
function $isArrayOf_Llaika_api_bundle_AttributeKey$Named(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_AttributeKey$Named)));
}
function $asArrayOf_Llaika_api_bundle_AttributeKey$Named(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_AttributeKey$Named(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.AttributeKey$Named;", depth));
}
var $d_Llaika_api_bundle_AttributeKey$Named = new $TypeData().initClass($c_Llaika_api_bundle_AttributeKey$Named, "laika.api.bundle.AttributeKey$Named", ({
  Llaika_api_bundle_AttributeKey$Named: 1,
  Llaika_api_bundle_AttributeKey: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_AttributeKey$PositionalAt(pos) {
  this.Llaika_api_bundle_AttributeKey$PositionalAt__f_pos = 0;
  this.Llaika_api_bundle_AttributeKey$PositionalAt__f_key = null;
  this.Llaika_api_bundle_AttributeKey$PositionalAt__f_pos = pos;
  this.Llaika_api_bundle_AttributeKey$PositionalAt__f_key = ("__$$:positional:$$__." + pos);
}
$c_Llaika_api_bundle_AttributeKey$PositionalAt.prototype = new $h_Llaika_api_bundle_AttributeKey();
$c_Llaika_api_bundle_AttributeKey$PositionalAt.prototype.constructor = $c_Llaika_api_bundle_AttributeKey$PositionalAt;
/** @constructor */
function $h_Llaika_api_bundle_AttributeKey$PositionalAt() {
}
$h_Llaika_api_bundle_AttributeKey$PositionalAt.prototype = $c_Llaika_api_bundle_AttributeKey$PositionalAt.prototype;
$c_Llaika_api_bundle_AttributeKey$PositionalAt.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_bundle_AttributeKey$PositionalAt.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("PositionalAt");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Llaika_api_bundle_AttributeKey$PositionalAt__f_pos;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1);
});
$c_Llaika_api_bundle_AttributeKey$PositionalAt.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_bundle_AttributeKey$PositionalAt)) {
    var x$0$2 = $as_Llaika_api_bundle_AttributeKey$PositionalAt(x$0);
    return ((this.Llaika_api_bundle_AttributeKey$PositionalAt__f_pos === $n(x$0$2).Llaika_api_bundle_AttributeKey$PositionalAt__f_pos) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Llaika_api_bundle_AttributeKey$PositionalAt.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_bundle_AttributeKey$PositionalAt.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_api_bundle_AttributeKey$PositionalAt.prototype.productPrefix__T = (function() {
  return "PositionalAt";
});
$c_Llaika_api_bundle_AttributeKey$PositionalAt.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_bundle_AttributeKey$PositionalAt__f_pos;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_api_bundle_AttributeKey$PositionalAt.prototype.key__T = (function() {
  return this.Llaika_api_bundle_AttributeKey$PositionalAt__f_key;
});
$c_Llaika_api_bundle_AttributeKey$PositionalAt.prototype.desc__T = (function() {
  return ("positional attribute at index " + this.Llaika_api_bundle_AttributeKey$PositionalAt__f_pos);
});
function $as_Llaika_api_bundle_AttributeKey$PositionalAt(obj) {
  return (((obj instanceof $c_Llaika_api_bundle_AttributeKey$PositionalAt) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.AttributeKey$PositionalAt"));
}
function $isArrayOf_Llaika_api_bundle_AttributeKey$PositionalAt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_AttributeKey$PositionalAt)));
}
function $asArrayOf_Llaika_api_bundle_AttributeKey$PositionalAt(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_AttributeKey$PositionalAt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.AttributeKey$PositionalAt;", depth));
}
var $d_Llaika_api_bundle_AttributeKey$PositionalAt = new $TypeData().initClass($c_Llaika_api_bundle_AttributeKey$PositionalAt, "laika.api.bundle.AttributeKey$PositionalAt", ({
  Llaika_api_bundle_AttributeKey$PositionalAt: 1,
  Llaika_api_bundle_AttributeKey: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$1(evidence$1$2) {
  this.Llaika_api_bundle_DirectiveBuilderContext$$anon$1__f_evidence$1$1 = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$$anon$1__f_evidence$1$1 = evidence$1$2;
}
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$1.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$1;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$$anon$1() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$$anon$1.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$1.prototype;
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  if ((x !== null)) {
    var x20 = $n(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$1__f_evidence$1$1).unapply__O__s_Option(x);
    if ((!$n(x20).isEmpty__Z())) {
      $n(x20).get__O();
      return true;
    }
  }
  return false;
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var x24 = $n(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$1__f_evidence$1$1).unapply__O__s_Option(x);
    if ((!$n(x24).isEmpty__Z())) {
      var x25 = $n(x24).get__O();
      return x25;
    }
  }
  return $n(default$1).apply__O__O(x);
});
var $d_Llaika_api_bundle_DirectiveBuilderContext$$anon$1 = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$$anon$1, "laika.api.bundle.DirectiveBuilderContext$$anon$1", ({
  Llaika_api_bundle_DirectiveBuilderContext$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$10() {
}
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$10.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$10.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$10;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$$anon$10() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$$anon$10.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$10.prototype;
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$10.prototype.isDefinedAt__s_util_Either__Z = (function(x) {
  return ((x instanceof $c_s_util_Right) && ($as_T2($n($as_s_util_Right(x)).s_util_Right__f_value), true));
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$10.prototype.applyOrElse__s_util_Either__F1__O = (function(x, default$1) {
  if ((x instanceof $c_s_util_Right)) {
    var v = $as_T2($n($as_s_util_Right(x)).s_util_Right__f_value);
    return v;
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$10.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__s_util_Either__Z($as_s_util_Either(x));
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$10.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__s_util_Either__F1__O($as_s_util_Either(x), default$1);
});
var $d_Llaika_api_bundle_DirectiveBuilderContext$$anon$10 = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$$anon$10, "laika.api.bundle.DirectiveBuilderContext$$anon$10", ({
  Llaika_api_bundle_DirectiveBuilderContext$$anon$10: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$4(outer) {
  this.Llaika_api_bundle_DirectiveBuilderContext$$anon$4__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_bundle_DirectiveBuilderContext$$anon$4__f_$outer = outer;
}
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$4.prototype = new $h_O();
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$4.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$4;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$$anon$4() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$$anon$4.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$4.prototype;
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$4.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(fa);
  var this$1 = $n(fa$1);
  return new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$2(f, this$1);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$4.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$4.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$4.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(fa);
  var this$1 = $n(fa$1);
  return new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$2(f, this$1);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$4.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(fa);
  var fb$1 = $as_Llaika_api_bundle_DirectiveBuilderContext$DirectivePart(fb);
  return new $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$5(fa$1, fb$1, this);
});
var $d_Llaika_api_bundle_DirectiveBuilderContext$$anon$4 = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$$anon$4, "laika.api.bundle.DirectiveBuilderContext$$anon$4", ({
  Llaika_api_bundle_DirectiveBuilderContext$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$8(outer) {
  this.Llaika_api_bundle_DirectiveBuilderContext$$anon$8__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_bundle_DirectiveBuilderContext$$anon$8__f_$outer = outer;
}
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$8.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$8.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$8;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$$anon$8() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$$anon$8.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$8.prototype;
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$8.prototype.isDefinedAt__Llaika_ast_Element__Z = (function(x) {
  return (($is_Llaika_api_bundle_DirectiveBuilderContext$SeparatorInstanceBase(x) && ($n($as_Llaika_api_bundle_DirectiveBuilderContext$SeparatorInstanceBase(x)).laika$api$bundle$DirectiveBuilderContext$SeparatorInstanceBase$$$outer__Llaika_api_bundle_DirectiveBuilderContext() === $n($n(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$8__f_$outer).Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart__f_$outer).Llaika_api_bundle_DirectiveBuilderContext$dsl$__f_$outer)) && ($as_Llaika_ast_Element($as_Llaika_api_bundle_DirectiveBuilderContext$SeparatorInstanceBase(x)), true));
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$8.prototype.applyOrElse__Llaika_ast_Element__F1__O = (function(x, default$1) {
  if (($is_Llaika_api_bundle_DirectiveBuilderContext$SeparatorInstanceBase(x) && ($n($as_Llaika_api_bundle_DirectiveBuilderContext$SeparatorInstanceBase(x)).laika$api$bundle$DirectiveBuilderContext$SeparatorInstanceBase$$$outer__Llaika_api_bundle_DirectiveBuilderContext() === $n($n(this.Llaika_api_bundle_DirectiveBuilderContext$$anon$8__f_$outer).Llaika_api_bundle_DirectiveBuilderContext$Combinators$SeparatedBodyPart__f_$outer).Llaika_api_bundle_DirectiveBuilderContext$dsl$__f_$outer))) {
    var i = $as_Llaika_ast_Element($as_Llaika_api_bundle_DirectiveBuilderContext$SeparatorInstanceBase(x));
    return i;
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$8.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Element__Z($as_Llaika_ast_Element(x));
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$8.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Element__F1__O($as_Llaika_ast_Element(x), default$1);
});
var $d_Llaika_api_bundle_DirectiveBuilderContext$$anon$8 = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$$anon$8, "laika.api.bundle.DirectiveBuilderContext$$anon$8", ({
  Llaika_api_bundle_DirectiveBuilderContext$$anon$8: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$9() {
}
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$9.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$9.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$9;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$$anon$9() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$$anon$9.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$$anon$9.prototype;
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$9.prototype.isDefinedAt__s_util_Either__Z = (function(x) {
  return ((x instanceof $c_s_util_Left) && ($as_sci_Seq($n($as_s_util_Left(x)).s_util_Left__f_value), true));
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$9.prototype.applyOrElse__s_util_Either__F1__O = (function(x, default$1) {
  if ((x instanceof $c_s_util_Left)) {
    var e = $as_sci_Seq($n($as_s_util_Left(x)).s_util_Left__f_value);
    return e;
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$9.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__s_util_Either__Z($as_s_util_Either(x));
});
$c_Llaika_api_bundle_DirectiveBuilderContext$$anon$9.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__s_util_Either__F1__O($as_s_util_Either(x), default$1);
});
var $d_Llaika_api_bundle_DirectiveBuilderContext$$anon$9 = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$$anon$9, "laika.api.bundle.DirectiveBuilderContext$$anon$9", ({
  Llaika_api_bundle_DirectiveBuilderContext$$anon$9: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed(outer, value) {
  this.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed__f_value = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed__f_$outer = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed__f_value = value;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed__f_$outer = outer;
}
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed.prototype = new $h_O();
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed.prototype;
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed) && ($n($as_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed(x$0)).Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed__f_$outer === this.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed__f_$outer))) {
    var x$0$2 = $as_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed(x$0);
    var x = this.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed__f_value;
    var x$2 = $n(x$0$2).Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed__f_value;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed.prototype.productPrefix__T = (function() {
  return "Parsed";
});
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed(obj) {
  return (((obj instanceof $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.DirectiveBuilderContext$BodyContent$Parsed"));
}
function $isArrayOf_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed)));
}
function $asArrayOf_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.DirectiveBuilderContext$BodyContent$Parsed;", depth));
}
var $d_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed, "laika.api.bundle.DirectiveBuilderContext$BodyContent$Parsed", ({
  Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Parsed: 1,
  Llaika_api_bundle_DirectiveBuilderContext$BodyContent: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source(outer, value) {
  this.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source__f_value = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source__f_$outer = null;
  this.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source__f_value = value;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source__f_$outer = outer;
}
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source.prototype = new $h_O();
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source.prototype.constructor = $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source() {
}
$h_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source.prototype = $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source.prototype;
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source) && ($n($as_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source(x$0)).Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source__f_$outer === this.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source__f_$outer))) {
    var x$0$2 = $as_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source(x$0);
    var x = this.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source__f_value;
    var x$2 = $n(x$0$2).Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source__f_value;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source.prototype.productPrefix__T = (function() {
  return "Source";
});
$c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source(obj) {
  return (((obj instanceof $c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.DirectiveBuilderContext$BodyContent$Source"));
}
function $isArrayOf_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source)));
}
function $asArrayOf_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.DirectiveBuilderContext$BodyContent$Source;", depth));
}
var $d_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source, "laika.api.bundle.DirectiveBuilderContext$BodyContent$Source", ({
  Llaika_api_bundle_DirectiveBuilderContext$BodyContent$Source: 1,
  Llaika_api_bundle_DirectiveBuilderContext$BodyContent: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DirectiveRegistry$$anon$2(outer) {
  this.Llaika_api_bundle_DirectiveRegistry$$anon$2__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_bundle_DirectiveRegistry$$anon$2__f_$outer = outer;
}
$c_Llaika_api_bundle_DirectiveRegistry$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_api_bundle_DirectiveRegistry$$anon$2.prototype.constructor = $c_Llaika_api_bundle_DirectiveRegistry$$anon$2;
/** @constructor */
function $h_Llaika_api_bundle_DirectiveRegistry$$anon$2() {
}
$h_Llaika_api_bundle_DirectiveRegistry$$anon$2.prototype = $c_Llaika_api_bundle_DirectiveRegistry$$anon$2.prototype;
$c_Llaika_api_bundle_DirectiveRegistry$$anon$2.prototype.isDefinedAt__Llaika_api_bundle_ExtensionBundle__Z = (function(x) {
  return ((x instanceof $c_Llaika_internal_directive_DirectiveSupport) && ($as_Llaika_internal_directive_DirectiveSupport(x), true));
});
$c_Llaika_api_bundle_DirectiveRegistry$$anon$2.prototype.applyOrElse__Llaika_api_bundle_ExtensionBundle__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Llaika_internal_directive_DirectiveSupport)) {
    var ds = $as_Llaika_internal_directive_DirectiveSupport(x);
    return $n(ds).withDirectives__sci_Seq__sci_Seq__sci_Seq__sci_Seq__Llaika_internal_directive_DirectiveSupport($n(this.Llaika_api_bundle_DirectiveRegistry$$anon$2__f_$outer).blockDirectives__sci_Seq(), $n(this.Llaika_api_bundle_DirectiveRegistry$$anon$2__f_$outer).spanDirectives__sci_Seq(), $n(this.Llaika_api_bundle_DirectiveRegistry$$anon$2__f_$outer).templateDirectives__sci_Seq(), $n(this.Llaika_api_bundle_DirectiveRegistry$$anon$2__f_$outer).linkDirectives__sci_Seq());
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_api_bundle_DirectiveRegistry$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_api_bundle_ExtensionBundle__Z($as_Llaika_api_bundle_ExtensionBundle(x));
});
$c_Llaika_api_bundle_DirectiveRegistry$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_api_bundle_ExtensionBundle__F1__O($as_Llaika_api_bundle_ExtensionBundle(x), default$1);
});
var $d_Llaika_api_bundle_DirectiveRegistry$$anon$2 = new $TypeData().initClass($c_Llaika_api_bundle_DirectiveRegistry$$anon$2, "laika.api.bundle.DirectiveRegistry$$anon$2", ({
  Llaika_api_bundle_DirectiveRegistry$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DocumentTypeMatcher$$anon$1() {
}
$c_Llaika_api_bundle_DocumentTypeMatcher$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_api_bundle_DocumentTypeMatcher$$anon$1.prototype.constructor = $c_Llaika_api_bundle_DocumentTypeMatcher$$anon$1;
/** @constructor */
function $h_Llaika_api_bundle_DocumentTypeMatcher$$anon$1() {
}
$h_Llaika_api_bundle_DocumentTypeMatcher$$anon$1.prototype = $c_Llaika_api_bundle_DocumentTypeMatcher$$anon$1.prototype;
$c_Llaika_api_bundle_DocumentTypeMatcher$$anon$1.prototype.isDefinedAt__Llaika_ast_Path__Z = (function(x) {
  return (x !== null);
});
$c_Llaika_api_bundle_DocumentTypeMatcher$$anon$1.prototype.applyOrElse__Llaika_ast_Path__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var _1 = $n(x).basename__T();
    var _2 = $n(x).suffix__s_Option();
    if ((((_1 === "directory") && (_2 instanceof $c_s_Some)) && ($n($as_s_Some(_2)).s_Some__f_value === "conf"))) {
      return $m_Llaika_ast_DocumentType$Config$();
    }
    if ((_2 instanceof $c_s_Some)) {
      if ($f_T__endsWith__T__Z($n(_1), ".template")) {
        return $m_Llaika_ast_DocumentType$Template$();
      }
      if ((($n($as_s_Some(_2)).s_Some__f_value === "css") && $f_T__endsWith__T__Z($n(_1), ".fo"))) {
        return new $c_Llaika_ast_DocumentType$StyleSheet("fo");
      }
    }
    var formats = $m_Llaika_api_bundle_DocumentTypeMatcher$().laika$api$bundle$DocumentTypeMatcher$$$staticTargetFormats__Llaika_ast_Path__Llaika_config_TargetFormats(x);
    return new $c_Llaika_ast_DocumentType$Static(formats);
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_api_bundle_DocumentTypeMatcher$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Path__Z($as_Llaika_ast_Path(x));
});
$c_Llaika_api_bundle_DocumentTypeMatcher$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Path__F1__O($as_Llaika_ast_Path(x), default$1);
});
var $d_Llaika_api_bundle_DocumentTypeMatcher$$anon$1 = new $TypeData().initClass($c_Llaika_api_bundle_DocumentTypeMatcher$$anon$1, "laika.api.bundle.DocumentTypeMatcher$$anon$1", ({
  Llaika_api_bundle_DocumentTypeMatcher$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_DocumentTypeMatcher$$anon$2(fileSuffixes$2, outer) {
  this.Llaika_api_bundle_DocumentTypeMatcher$$anon$2__f_fileSuffixes$1 = null;
  this.Llaika_api_bundle_DocumentTypeMatcher$$anon$2__f_fileSuffixes$1 = fileSuffixes$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_api_bundle_DocumentTypeMatcher$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_api_bundle_DocumentTypeMatcher$$anon$2.prototype.constructor = $c_Llaika_api_bundle_DocumentTypeMatcher$$anon$2;
/** @constructor */
function $h_Llaika_api_bundle_DocumentTypeMatcher$$anon$2() {
}
$h_Llaika_api_bundle_DocumentTypeMatcher$$anon$2.prototype = $c_Llaika_api_bundle_DocumentTypeMatcher$$anon$2.prototype;
$c_Llaika_api_bundle_DocumentTypeMatcher$$anon$2.prototype.isDefinedAt__Llaika_ast_Path__Z = (function(x) {
  var this$1 = $n($n(x).suffix__s_Option());
  if ((!this$1.isEmpty__Z())) {
    var arg1 = this$1.get__O();
    var elem = $as_T(arg1);
    return $n(this.Llaika_api_bundle_DocumentTypeMatcher$$anon$2__f_fileSuffixes$1).contains__O__Z(elem);
  } else {
    return false;
  }
});
$c_Llaika_api_bundle_DocumentTypeMatcher$$anon$2.prototype.applyOrElse__Llaika_ast_Path__F1__O = (function(x, default$1) {
  var this$1 = $n($n(x).suffix__s_Option());
  if ((!this$1.isEmpty__Z())) {
    var arg1 = this$1.get__O();
    var elem = $as_T(arg1);
    var $x_1 = $n(this.Llaika_api_bundle_DocumentTypeMatcher$$anon$2__f_fileSuffixes$1).contains__O__Z(elem);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return $m_Llaika_ast_DocumentType$Markup$();
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_api_bundle_DocumentTypeMatcher$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Path__Z($as_Llaika_ast_Path(x));
});
$c_Llaika_api_bundle_DocumentTypeMatcher$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Path__F1__O($as_Llaika_ast_Path(x), default$1);
});
var $d_Llaika_api_bundle_DocumentTypeMatcher$$anon$2 = new $TypeData().initClass($c_Llaika_api_bundle_DocumentTypeMatcher$$anon$2, "laika.api.bundle.DocumentTypeMatcher$$anon$2", ({
  Llaika_api_bundle_DocumentTypeMatcher$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_ExtensionBundle$$anon$1$$anon$2(outer) {
  this.Llaika_api_bundle_ExtensionBundle$$anon$1$$anon$2__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_bundle_ExtensionBundle$$anon$1$$anon$2__f_$outer = outer;
}
$c_Llaika_api_bundle_ExtensionBundle$$anon$1$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_api_bundle_ExtensionBundle$$anon$1$$anon$2.prototype.constructor = $c_Llaika_api_bundle_ExtensionBundle$$anon$1$$anon$2;
/** @constructor */
function $h_Llaika_api_bundle_ExtensionBundle$$anon$1$$anon$2() {
}
$h_Llaika_api_bundle_ExtensionBundle$$anon$1$$anon$2.prototype = $c_Llaika_api_bundle_ExtensionBundle$$anon$1$$anon$2.prototype;
$c_Llaika_api_bundle_ExtensionBundle$$anon$1$$anon$2.prototype.isDefinedAt__Llaika_ast_RewritePhase__Z = (function(x) {
  return true;
});
$c_Llaika_api_bundle_ExtensionBundle$$anon$1$$anon$2.prototype.applyOrElse__Llaika_ast_RewritePhase__F1__O = (function(x, default$1) {
  var this$1 = $n($as_s_Option($n($n($n($n(this.Llaika_api_bundle_ExtensionBundle$$anon$1$$anon$2__f_$outer).Llaika_api_bundle_ExtensionBundle$$anon$1__f_laika$api$bundle$ExtensionBundle$$anon$1$$base$1).rewriteRules__s_PartialFunction()).lift__F1()).apply__O__O(x)));
  var this$3 = $n($as_sc_IterableOps((this$1.isEmpty__Z() ? $m_sci_Nil$() : this$1.get__O())));
  var this$2 = $n($as_s_Option($n($n($n($n(this.Llaika_api_bundle_ExtensionBundle$$anon$1$$anon$2__f_$outer).Llaika_api_bundle_ExtensionBundle$$anon$1__f_$outer).rewriteRules__s_PartialFunction()).lift__F1()).apply__O__O(x)));
  var suffix = $as_sc_IterableOnce((this$2.isEmpty__Z() ? $m_sci_Nil$() : this$2.get__O()));
  return $as_sci_Seq(this$3.concat__sc_IterableOnce__O(suffix));
});
$c_Llaika_api_bundle_ExtensionBundle$$anon$1$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_RewritePhase__Z($as_Llaika_ast_RewritePhase(x));
});
$c_Llaika_api_bundle_ExtensionBundle$$anon$1$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_RewritePhase__F1__O($as_Llaika_ast_RewritePhase(x), default$1);
});
var $d_Llaika_api_bundle_ExtensionBundle$$anon$1$$anon$2 = new $TypeData().initClass($c_Llaika_api_bundle_ExtensionBundle$$anon$1$$anon$2, "laika.api.bundle.ExtensionBundle$$anon$1$$anon$2", ({
  Llaika_api_bundle_ExtensionBundle$$anon$1$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_TemplateDirectives$$anon$13() {
}
$c_Llaika_api_bundle_TemplateDirectives$$anon$13.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_api_bundle_TemplateDirectives$$anon$13.prototype.constructor = $c_Llaika_api_bundle_TemplateDirectives$$anon$13;
/** @constructor */
function $h_Llaika_api_bundle_TemplateDirectives$$anon$13() {
}
$h_Llaika_api_bundle_TemplateDirectives$$anon$13.prototype = $c_Llaika_api_bundle_TemplateDirectives$$anon$13.prototype;
$c_Llaika_api_bundle_TemplateDirectives$$anon$13.prototype.isDefinedAt__Llaika_ast_Span__Z = (function(x) {
  if ($is_Llaika_ast_TemplateSpan(x)) {
    $as_Llaika_ast_TemplateSpan(x);
    return true;
  } else if ((x instanceof $c_Llaika_ast_Text)) {
    var x$1 = $as_Llaika_ast_Text(x);
    var this$2 = $n(x$1);
    var this$3 = $n(x$1);
    return true;
  } else {
    return false;
  }
});
$c_Llaika_api_bundle_TemplateDirectives$$anon$13.prototype.applyOrElse__Llaika_ast_Span__F1__O = (function(x, default$1) {
  if ($is_Llaika_ast_TemplateSpan(x)) {
    var s = $as_Llaika_ast_TemplateSpan(x);
    return s;
  } else if ((x instanceof $c_Llaika_ast_Text)) {
    var x$1 = $as_Llaika_ast_Text(x);
    var this$2 = $n(x$1);
    var x137 = this$2.Llaika_ast_Text__f_content;
    var this$3 = $n(x$1);
    var x138 = this$3.Llaika_ast_Text__f_options;
    return new $c_Llaika_ast_TemplateString(x137, x138);
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_api_bundle_TemplateDirectives$$anon$13.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Span__Z($as_Llaika_ast_Span(x));
});
$c_Llaika_api_bundle_TemplateDirectives$$anon$13.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Span__F1__O($as_Llaika_ast_Span(x), default$1);
});
var $d_Llaika_api_bundle_TemplateDirectives$$anon$13 = new $TypeData().initClass($c_Llaika_api_bundle_TemplateDirectives$$anon$13, "laika.api.bundle.TemplateDirectives$$anon$13", ({
  Llaika_api_bundle_TemplateDirectives$$anon$13: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigError$DecodingFailed(error, key) {
  this.Llaika_api_config_ConfigError$DecodingFailed__f_error = null;
  this.Llaika_api_config_ConfigError$DecodingFailed__f_key = null;
  this.Llaika_api_config_ConfigError$DecodingFailed__f_message = null;
  this.Llaika_api_config_ConfigError$DecodingFailed__f_error = error;
  this.Llaika_api_config_ConfigError$DecodingFailed__f_key = key;
  var this$1 = $n(key);
  if (this$1.isEmpty__Z()) {
    var $x_1 = "";
  } else {
    var arg1 = this$1.get__O();
    var k = $as_Llaika_api_config_Key(arg1);
    var $x_1 = (("Error decoding '" + $n(k).toString__T()) + "': ");
  }
  this.Llaika_api_config_ConfigError$DecodingFailed__f_message = ($x_1 + error);
}
$c_Llaika_api_config_ConfigError$DecodingFailed.prototype = new $h_O();
$c_Llaika_api_config_ConfigError$DecodingFailed.prototype.constructor = $c_Llaika_api_config_ConfigError$DecodingFailed;
/** @constructor */
function $h_Llaika_api_config_ConfigError$DecodingFailed() {
}
$h_Llaika_api_config_ConfigError$DecodingFailed.prototype = $c_Llaika_api_config_ConfigError$DecodingFailed.prototype;
$c_Llaika_api_config_ConfigError$DecodingFailed.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_ConfigError$DecodingFailed.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_config_ConfigError$DecodingFailed.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_config_ConfigError$DecodingFailed)) {
    var x$0$2 = $as_Llaika_api_config_ConfigError$DecodingFailed(x$0);
    if ((this.Llaika_api_config_ConfigError$DecodingFailed__f_error === $n(x$0$2).Llaika_api_config_ConfigError$DecodingFailed__f_error)) {
      var x = this.Llaika_api_config_ConfigError$DecodingFailed__f_key;
      var x$2 = $n(x$0$2).Llaika_api_config_ConfigError$DecodingFailed__f_key;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_config_ConfigError$DecodingFailed.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_config_ConfigError$DecodingFailed.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_api_config_ConfigError$DecodingFailed.prototype.productPrefix__T = (function() {
  return "DecodingFailed";
});
$c_Llaika_api_config_ConfigError$DecodingFailed.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_config_ConfigError$DecodingFailed__f_error;
  }
  if ((n === 1)) {
    return this.Llaika_api_config_ConfigError$DecodingFailed__f_key;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_api_config_ConfigError$DecodingFailed.prototype.message__T = (function() {
  return this.Llaika_api_config_ConfigError$DecodingFailed__f_message;
});
$c_Llaika_api_config_ConfigError$DecodingFailed.prototype.withKey__Llaika_api_config_Key__Llaika_api_config_ConfigError$DecodingFailed = (function(key) {
  var key$1 = new $c_s_Some(key);
  var error$1 = this.Llaika_api_config_ConfigError$DecodingFailed__f_error;
  return new $c_Llaika_api_config_ConfigError$DecodingFailed(error$1, key$1);
});
function $as_Llaika_api_config_ConfigError$DecodingFailed(obj) {
  return (((obj instanceof $c_Llaika_api_config_ConfigError$DecodingFailed) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.ConfigError$DecodingFailed"));
}
function $isArrayOf_Llaika_api_config_ConfigError$DecodingFailed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_ConfigError$DecodingFailed)));
}
function $asArrayOf_Llaika_api_config_ConfigError$DecodingFailed(obj, depth) {
  return (($isArrayOf_Llaika_api_config_ConfigError$DecodingFailed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.ConfigError$DecodingFailed;", depth));
}
var $d_Llaika_api_config_ConfigError$DecodingFailed = new $TypeData().initClass($c_Llaika_api_config_ConfigError$DecodingFailed, "laika.api.config.ConfigError$DecodingFailed", ({
  Llaika_api_config_ConfigError$DecodingFailed: 1,
  Llaika_api_config_ConfigError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigError$DocumentErrors(path, failures) {
  this.Llaika_api_config_ConfigError$DocumentErrors__f_path = null;
  this.Llaika_api_config_ConfigError$DocumentErrors__f_failures = null;
  this.Llaika_api_config_ConfigError$DocumentErrors__f_message = null;
  this.Llaika_api_config_ConfigError$DocumentErrors__f_path = path;
  this.Llaika_api_config_ConfigError$DocumentErrors__f_failures = failures;
  var tc = $as_Lcats_Functor($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
  var this$3 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(failures, tc);
  var f = new $c_sjsr_AnonFunction1(((_$3) => {
    var _$3$1 = $as_Llaika_api_config_ConfigError(_$3);
    return $n(_$3$1).toString__T();
  }));
  var fa = $n(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  this.Llaika_api_config_ConfigError$DocumentErrors__f_message = $m_Lcats_syntax_FoldableOps$().mkString_$extension__O__T__T__T__Lcats_Show__Lcats_Foldable__T(fa, (("Multiple errors processing configuration for document '" + path) + "': "), ", ", "", $m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString, $as_Lcats_Foldable($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1));
}
$c_Llaika_api_config_ConfigError$DocumentErrors.prototype = new $h_O();
$c_Llaika_api_config_ConfigError$DocumentErrors.prototype.constructor = $c_Llaika_api_config_ConfigError$DocumentErrors;
/** @constructor */
function $h_Llaika_api_config_ConfigError$DocumentErrors() {
}
$h_Llaika_api_config_ConfigError$DocumentErrors.prototype = $c_Llaika_api_config_ConfigError$DocumentErrors.prototype;
$c_Llaika_api_config_ConfigError$DocumentErrors.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_ConfigError$DocumentErrors.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_config_ConfigError$DocumentErrors.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_config_ConfigError$DocumentErrors)) {
    var x$0$2 = $as_Llaika_api_config_ConfigError$DocumentErrors(x$0);
    var x = this.Llaika_api_config_ConfigError$DocumentErrors__f_path;
    var x$2 = $n(x$0$2).Llaika_api_config_ConfigError$DocumentErrors__f_path;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$1 = this.Llaika_api_config_ConfigError$DocumentErrors__f_failures;
      var y = $n(x$0$2).Llaika_api_config_ConfigError$DocumentErrors__f_failures;
      var $x_1 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_config_ConfigError$DocumentErrors.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_config_ConfigError$DocumentErrors.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_api_config_ConfigError$DocumentErrors.prototype.productPrefix__T = (function() {
  return "DocumentErrors";
});
$c_Llaika_api_config_ConfigError$DocumentErrors.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_config_ConfigError$DocumentErrors__f_path;
  }
  if ((n === 1)) {
    return this.Llaika_api_config_ConfigError$DocumentErrors__f_failures;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_api_config_ConfigError$DocumentErrors.prototype.message__T = (function() {
  return this.Llaika_api_config_ConfigError$DocumentErrors__f_message;
});
function $as_Llaika_api_config_ConfigError$DocumentErrors(obj) {
  return (((obj instanceof $c_Llaika_api_config_ConfigError$DocumentErrors) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.ConfigError$DocumentErrors"));
}
function $isArrayOf_Llaika_api_config_ConfigError$DocumentErrors(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_ConfigError$DocumentErrors)));
}
function $asArrayOf_Llaika_api_config_ConfigError$DocumentErrors(obj, depth) {
  return (($isArrayOf_Llaika_api_config_ConfigError$DocumentErrors(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.ConfigError$DocumentErrors;", depth));
}
var $d_Llaika_api_config_ConfigError$DocumentErrors = new $TypeData().initClass($c_Llaika_api_config_ConfigError$DocumentErrors, "laika.api.config.ConfigError$DocumentErrors", ({
  Llaika_api_config_ConfigError$DocumentErrors: 1,
  Llaika_api_config_ConfigError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigError$InvalidFields(fields) {
  this.Llaika_api_config_ConfigError$InvalidFields__f_fields = null;
  this.Llaika_api_config_ConfigError$InvalidFields__f_message = null;
  this.Llaika_api_config_ConfigError$InvalidFields__f_fields = fields;
  var tc = $as_Lcats_Functor($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
  var this$3 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(fields, tc);
  var f = new $c_sjsr_AnonFunction1(((_$1) => {
    var _$1$1 = $as_Llaika_api_config_ConfigError$InvalidField(_$1);
    return $n(_$1$1).toString__T();
  }));
  var fa = $n(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  this.Llaika_api_config_ConfigError$InvalidFields__f_message = $m_Lcats_syntax_FoldableOps$().mkString_$extension__O__T__T__T__Lcats_Show__Lcats_Foldable__T(fa, "Multiple invalid fields in HOCON source: ", ", ", "", $m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString, $as_Lcats_Foldable($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1));
}
$c_Llaika_api_config_ConfigError$InvalidFields.prototype = new $h_O();
$c_Llaika_api_config_ConfigError$InvalidFields.prototype.constructor = $c_Llaika_api_config_ConfigError$InvalidFields;
/** @constructor */
function $h_Llaika_api_config_ConfigError$InvalidFields() {
}
$h_Llaika_api_config_ConfigError$InvalidFields.prototype = $c_Llaika_api_config_ConfigError$InvalidFields.prototype;
$c_Llaika_api_config_ConfigError$InvalidFields.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_ConfigError$InvalidFields.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_config_ConfigError$InvalidFields.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_config_ConfigError$InvalidFields)) {
    var x$0$2 = $as_Llaika_api_config_ConfigError$InvalidFields(x$0);
    var x = this.Llaika_api_config_ConfigError$InvalidFields__f_fields;
    var y = $n(x$0$2).Llaika_api_config_ConfigError$InvalidFields__f_fields;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_config_ConfigError$InvalidFields.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_config_ConfigError$InvalidFields.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_api_config_ConfigError$InvalidFields.prototype.productPrefix__T = (function() {
  return "InvalidFields";
});
$c_Llaika_api_config_ConfigError$InvalidFields.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_config_ConfigError$InvalidFields__f_fields;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_api_config_ConfigError$InvalidFields.prototype.message__T = (function() {
  return this.Llaika_api_config_ConfigError$InvalidFields__f_message;
});
function $as_Llaika_api_config_ConfigError$InvalidFields(obj) {
  return (((obj instanceof $c_Llaika_api_config_ConfigError$InvalidFields) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.ConfigError$InvalidFields"));
}
function $isArrayOf_Llaika_api_config_ConfigError$InvalidFields(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_ConfigError$InvalidFields)));
}
function $asArrayOf_Llaika_api_config_ConfigError$InvalidFields(obj, depth) {
  return (($isArrayOf_Llaika_api_config_ConfigError$InvalidFields(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.ConfigError$InvalidFields;", depth));
}
var $d_Llaika_api_config_ConfigError$InvalidFields = new $TypeData().initClass($c_Llaika_api_config_ConfigError$InvalidFields, "laika.api.config.ConfigError$InvalidFields", ({
  Llaika_api_config_ConfigError$InvalidFields: 1,
  Llaika_api_config_ConfigError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigError$InvalidType(expected, actual) {
  this.Llaika_api_config_ConfigError$InvalidType__f_expected = null;
  this.Llaika_api_config_ConfigError$InvalidType__f_actual = null;
  this.Llaika_api_config_ConfigError$InvalidType__f_message = null;
  this.Llaika_api_config_ConfigError$InvalidType__f_expected = expected;
  this.Llaika_api_config_ConfigError$InvalidType__f_actual = actual;
  var this$1 = $n($n(actual).productPrefix__T());
  this.Llaika_api_config_ConfigError$InvalidType__f_message = ((("Invalid type - expected: " + expected) + ", actual: ") + $as_T(this$1.split("Value").join("")));
}
$c_Llaika_api_config_ConfigError$InvalidType.prototype = new $h_O();
$c_Llaika_api_config_ConfigError$InvalidType.prototype.constructor = $c_Llaika_api_config_ConfigError$InvalidType;
/** @constructor */
function $h_Llaika_api_config_ConfigError$InvalidType() {
}
$h_Llaika_api_config_ConfigError$InvalidType.prototype = $c_Llaika_api_config_ConfigError$InvalidType.prototype;
$c_Llaika_api_config_ConfigError$InvalidType.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_ConfigError$InvalidType.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_config_ConfigError$InvalidType.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_config_ConfigError$InvalidType)) {
    var x$0$2 = $as_Llaika_api_config_ConfigError$InvalidType(x$0);
    if ((this.Llaika_api_config_ConfigError$InvalidType__f_expected === $n(x$0$2).Llaika_api_config_ConfigError$InvalidType__f_expected)) {
      var x = this.Llaika_api_config_ConfigError$InvalidType__f_actual;
      var x$2 = $n(x$0$2).Llaika_api_config_ConfigError$InvalidType__f_actual;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_config_ConfigError$InvalidType.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_config_ConfigError$InvalidType.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_api_config_ConfigError$InvalidType.prototype.productPrefix__T = (function() {
  return "InvalidType";
});
$c_Llaika_api_config_ConfigError$InvalidType.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_config_ConfigError$InvalidType__f_expected;
  }
  if ((n === 1)) {
    return this.Llaika_api_config_ConfigError$InvalidType__f_actual;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_api_config_ConfigError$InvalidType.prototype.message__T = (function() {
  return this.Llaika_api_config_ConfigError$InvalidType__f_message;
});
function $as_Llaika_api_config_ConfigError$InvalidType(obj) {
  return (((obj instanceof $c_Llaika_api_config_ConfigError$InvalidType) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.ConfigError$InvalidType"));
}
function $isArrayOf_Llaika_api_config_ConfigError$InvalidType(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_ConfigError$InvalidType)));
}
function $asArrayOf_Llaika_api_config_ConfigError$InvalidType(obj, depth) {
  return (($isArrayOf_Llaika_api_config_ConfigError$InvalidType(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.ConfigError$InvalidType;", depth));
}
var $d_Llaika_api_config_ConfigError$InvalidType = new $TypeData().initClass($c_Llaika_api_config_ConfigError$InvalidType, "laika.api.config.ConfigError$InvalidType", ({
  Llaika_api_config_ConfigError$InvalidType: 1,
  Llaika_api_config_ConfigError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigError$MultipleErrors(failures) {
  this.Llaika_api_config_ConfigError$MultipleErrors__f_failures = null;
  this.Llaika_api_config_ConfigError$MultipleErrors__f_message = null;
  this.Llaika_api_config_ConfigError$MultipleErrors__f_failures = failures;
  var tc = $as_Lcats_Functor($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
  var this$3 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(failures, tc);
  var f = new $c_sjsr_AnonFunction1(((_$2) => {
    var _$2$1 = $as_Llaika_api_config_ConfigError(_$2);
    return $n(_$2$1).toString__T();
  }));
  var fa = $n(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  this.Llaika_api_config_ConfigError$MultipleErrors__f_message = $m_Lcats_syntax_FoldableOps$().mkString_$extension__O__T__T__T__Lcats_Show__Lcats_Foldable__T(fa, "Multiple errors processing configuration: ", ", ", "", $m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString, $as_Lcats_Foldable($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1));
}
$c_Llaika_api_config_ConfigError$MultipleErrors.prototype = new $h_O();
$c_Llaika_api_config_ConfigError$MultipleErrors.prototype.constructor = $c_Llaika_api_config_ConfigError$MultipleErrors;
/** @constructor */
function $h_Llaika_api_config_ConfigError$MultipleErrors() {
}
$h_Llaika_api_config_ConfigError$MultipleErrors.prototype = $c_Llaika_api_config_ConfigError$MultipleErrors.prototype;
$c_Llaika_api_config_ConfigError$MultipleErrors.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_ConfigError$MultipleErrors.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_config_ConfigError$MultipleErrors.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_config_ConfigError$MultipleErrors)) {
    var x$0$2 = $as_Llaika_api_config_ConfigError$MultipleErrors(x$0);
    var x = this.Llaika_api_config_ConfigError$MultipleErrors__f_failures;
    var y = $n(x$0$2).Llaika_api_config_ConfigError$MultipleErrors__f_failures;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_config_ConfigError$MultipleErrors.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_config_ConfigError$MultipleErrors.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_api_config_ConfigError$MultipleErrors.prototype.productPrefix__T = (function() {
  return "MultipleErrors";
});
$c_Llaika_api_config_ConfigError$MultipleErrors.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_config_ConfigError$MultipleErrors__f_failures;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_api_config_ConfigError$MultipleErrors.prototype.message__T = (function() {
  return this.Llaika_api_config_ConfigError$MultipleErrors__f_message;
});
function $as_Llaika_api_config_ConfigError$MultipleErrors(obj) {
  return (((obj instanceof $c_Llaika_api_config_ConfigError$MultipleErrors) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.ConfigError$MultipleErrors"));
}
function $isArrayOf_Llaika_api_config_ConfigError$MultipleErrors(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_ConfigError$MultipleErrors)));
}
function $asArrayOf_Llaika_api_config_ConfigError$MultipleErrors(obj, depth) {
  return (($isArrayOf_Llaika_api_config_ConfigError$MultipleErrors(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.ConfigError$MultipleErrors;", depth));
}
var $d_Llaika_api_config_ConfigError$MultipleErrors = new $TypeData().initClass($c_Llaika_api_config_ConfigError$MultipleErrors, "laika.api.config.ConfigError$MultipleErrors", ({
  Llaika_api_config_ConfigError$MultipleErrors: 1,
  Llaika_api_config_ConfigError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigError$NotFound(key) {
  this.Llaika_api_config_ConfigError$NotFound__f_key = null;
  this.Llaika_api_config_ConfigError$NotFound__f_message = null;
  this.Llaika_api_config_ConfigError$NotFound__f_key = key;
  this.Llaika_api_config_ConfigError$NotFound__f_message = (("Not found: '" + key) + "'");
}
$c_Llaika_api_config_ConfigError$NotFound.prototype = new $h_O();
$c_Llaika_api_config_ConfigError$NotFound.prototype.constructor = $c_Llaika_api_config_ConfigError$NotFound;
/** @constructor */
function $h_Llaika_api_config_ConfigError$NotFound() {
}
$h_Llaika_api_config_ConfigError$NotFound.prototype = $c_Llaika_api_config_ConfigError$NotFound.prototype;
$c_Llaika_api_config_ConfigError$NotFound.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_ConfigError$NotFound.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_config_ConfigError$NotFound.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_config_ConfigError$NotFound)) {
    var x$0$2 = $as_Llaika_api_config_ConfigError$NotFound(x$0);
    var x = this.Llaika_api_config_ConfigError$NotFound__f_key;
    var x$2 = $n(x$0$2).Llaika_api_config_ConfigError$NotFound__f_key;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_config_ConfigError$NotFound.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_config_ConfigError$NotFound.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_api_config_ConfigError$NotFound.prototype.productPrefix__T = (function() {
  return "NotFound";
});
$c_Llaika_api_config_ConfigError$NotFound.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_config_ConfigError$NotFound__f_key;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_api_config_ConfigError$NotFound.prototype.message__T = (function() {
  return this.Llaika_api_config_ConfigError$NotFound__f_message;
});
function $as_Llaika_api_config_ConfigError$NotFound(obj) {
  return (((obj instanceof $c_Llaika_api_config_ConfigError$NotFound) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.ConfigError$NotFound"));
}
function $isArrayOf_Llaika_api_config_ConfigError$NotFound(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_ConfigError$NotFound)));
}
function $asArrayOf_Llaika_api_config_ConfigError$NotFound(obj, depth) {
  return (($isArrayOf_Llaika_api_config_ConfigError$NotFound(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.ConfigError$NotFound;", depth));
}
var $d_Llaika_api_config_ConfigError$NotFound = new $TypeData().initClass($c_Llaika_api_config_ConfigError$NotFound, "laika.api.config.ConfigError$NotFound", ({
  Llaika_api_config_ConfigError$NotFound: 1,
  Llaika_api_config_ConfigError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigError$ParsingFailed(failure) {
  this.Llaika_api_config_ConfigError$ParsingFailed__f_failure = null;
  this.Llaika_api_config_ConfigError$ParsingFailed__f_message = null;
  this.Llaika_api_config_ConfigError$ParsingFailed__f_failure = failure;
  this.Llaika_api_config_ConfigError$ParsingFailed__f_message = $n(failure).toString__T();
}
$c_Llaika_api_config_ConfigError$ParsingFailed.prototype = new $h_O();
$c_Llaika_api_config_ConfigError$ParsingFailed.prototype.constructor = $c_Llaika_api_config_ConfigError$ParsingFailed;
/** @constructor */
function $h_Llaika_api_config_ConfigError$ParsingFailed() {
}
$h_Llaika_api_config_ConfigError$ParsingFailed.prototype = $c_Llaika_api_config_ConfigError$ParsingFailed.prototype;
$c_Llaika_api_config_ConfigError$ParsingFailed.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_ConfigError$ParsingFailed.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_config_ConfigError$ParsingFailed.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_config_ConfigError$ParsingFailed)) {
    var x$0$2 = $as_Llaika_api_config_ConfigError$ParsingFailed(x$0);
    var x = this.Llaika_api_config_ConfigError$ParsingFailed__f_failure;
    var x$2 = $n(x$0$2).Llaika_api_config_ConfigError$ParsingFailed__f_failure;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_config_ConfigError$ParsingFailed.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_config_ConfigError$ParsingFailed.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_api_config_ConfigError$ParsingFailed.prototype.productPrefix__T = (function() {
  return "ParsingFailed";
});
$c_Llaika_api_config_ConfigError$ParsingFailed.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_config_ConfigError$ParsingFailed__f_failure;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_api_config_ConfigError$ParsingFailed.prototype.message__T = (function() {
  return this.Llaika_api_config_ConfigError$ParsingFailed__f_message;
});
function $as_Llaika_api_config_ConfigError$ParsingFailed(obj) {
  return (((obj instanceof $c_Llaika_api_config_ConfigError$ParsingFailed) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.ConfigError$ParsingFailed"));
}
function $isArrayOf_Llaika_api_config_ConfigError$ParsingFailed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_ConfigError$ParsingFailed)));
}
function $asArrayOf_Llaika_api_config_ConfigError$ParsingFailed(obj, depth) {
  return (($isArrayOf_Llaika_api_config_ConfigError$ParsingFailed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.ConfigError$ParsingFailed;", depth));
}
var $d_Llaika_api_config_ConfigError$ParsingFailed = new $TypeData().initClass($c_Llaika_api_config_ConfigError$ParsingFailed, "laika.api.config.ConfigError$ParsingFailed", ({
  Llaika_api_config_ConfigError$ParsingFailed: 1,
  Llaika_api_config_ConfigError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigError$ResolverFailed(message) {
  this.Llaika_api_config_ConfigError$ResolverFailed__f_message = null;
  this.Llaika_api_config_ConfigError$ResolverFailed__f_message = message;
}
$c_Llaika_api_config_ConfigError$ResolverFailed.prototype = new $h_O();
$c_Llaika_api_config_ConfigError$ResolverFailed.prototype.constructor = $c_Llaika_api_config_ConfigError$ResolverFailed;
/** @constructor */
function $h_Llaika_api_config_ConfigError$ResolverFailed() {
}
$h_Llaika_api_config_ConfigError$ResolverFailed.prototype = $c_Llaika_api_config_ConfigError$ResolverFailed.prototype;
$c_Llaika_api_config_ConfigError$ResolverFailed.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_ConfigError$ResolverFailed.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_config_ConfigError$ResolverFailed.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_config_ConfigError$ResolverFailed)) {
    var x$0$2 = $as_Llaika_api_config_ConfigError$ResolverFailed(x$0);
    return ((this.Llaika_api_config_ConfigError$ResolverFailed__f_message === $n(x$0$2).Llaika_api_config_ConfigError$ResolverFailed__f_message) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Llaika_api_config_ConfigError$ResolverFailed.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_config_ConfigError$ResolverFailed.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_api_config_ConfigError$ResolverFailed.prototype.productPrefix__T = (function() {
  return "ResolverFailed";
});
$c_Llaika_api_config_ConfigError$ResolverFailed.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_config_ConfigError$ResolverFailed__f_message;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_api_config_ConfigError$ResolverFailed.prototype.message__T = (function() {
  return this.Llaika_api_config_ConfigError$ResolverFailed__f_message;
});
function $as_Llaika_api_config_ConfigError$ResolverFailed(obj) {
  return (((obj instanceof $c_Llaika_api_config_ConfigError$ResolverFailed) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.ConfigError$ResolverFailed"));
}
function $isArrayOf_Llaika_api_config_ConfigError$ResolverFailed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_ConfigError$ResolverFailed)));
}
function $asArrayOf_Llaika_api_config_ConfigError$ResolverFailed(obj, depth) {
  return (($isArrayOf_Llaika_api_config_ConfigError$ResolverFailed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.ConfigError$ResolverFailed;", depth));
}
var $d_Llaika_api_config_ConfigError$ResolverFailed = new $TypeData().initClass($c_Llaika_api_config_ConfigError$ResolverFailed, "laika.api.config.ConfigError$ResolverFailed", ({
  Llaika_api_config_ConfigError$ResolverFailed: 1,
  Llaika_api_config_ConfigError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigError$ResourceLoadingFailed(message) {
  this.Llaika_api_config_ConfigError$ResourceLoadingFailed__f_message = null;
  this.Llaika_api_config_ConfigError$ResourceLoadingFailed__f_message = message;
}
$c_Llaika_api_config_ConfigError$ResourceLoadingFailed.prototype = new $h_O();
$c_Llaika_api_config_ConfigError$ResourceLoadingFailed.prototype.constructor = $c_Llaika_api_config_ConfigError$ResourceLoadingFailed;
/** @constructor */
function $h_Llaika_api_config_ConfigError$ResourceLoadingFailed() {
}
$h_Llaika_api_config_ConfigError$ResourceLoadingFailed.prototype = $c_Llaika_api_config_ConfigError$ResourceLoadingFailed.prototype;
$c_Llaika_api_config_ConfigError$ResourceLoadingFailed.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_ConfigError$ResourceLoadingFailed.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_config_ConfigError$ResourceLoadingFailed.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_config_ConfigError$ResourceLoadingFailed)) {
    var x$0$2 = $as_Llaika_api_config_ConfigError$ResourceLoadingFailed(x$0);
    return ((this.Llaika_api_config_ConfigError$ResourceLoadingFailed__f_message === $n(x$0$2).Llaika_api_config_ConfigError$ResourceLoadingFailed__f_message) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Llaika_api_config_ConfigError$ResourceLoadingFailed.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_config_ConfigError$ResourceLoadingFailed.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_api_config_ConfigError$ResourceLoadingFailed.prototype.productPrefix__T = (function() {
  return "ResourceLoadingFailed";
});
$c_Llaika_api_config_ConfigError$ResourceLoadingFailed.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_config_ConfigError$ResourceLoadingFailed__f_message;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_api_config_ConfigError$ResourceLoadingFailed.prototype.message__T = (function() {
  return this.Llaika_api_config_ConfigError$ResourceLoadingFailed__f_message;
});
function $as_Llaika_api_config_ConfigError$ResourceLoadingFailed(obj) {
  return (((obj instanceof $c_Llaika_api_config_ConfigError$ResourceLoadingFailed) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.ConfigError$ResourceLoadingFailed"));
}
function $isArrayOf_Llaika_api_config_ConfigError$ResourceLoadingFailed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_ConfigError$ResourceLoadingFailed)));
}
function $asArrayOf_Llaika_api_config_ConfigError$ResourceLoadingFailed(obj, depth) {
  return (($isArrayOf_Llaika_api_config_ConfigError$ResourceLoadingFailed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.ConfigError$ResourceLoadingFailed;", depth));
}
var $d_Llaika_api_config_ConfigError$ResourceLoadingFailed = new $TypeData().initClass($c_Llaika_api_config_ConfigError$ResourceLoadingFailed, "laika.api.config.ConfigError$ResourceLoadingFailed", ({
  Llaika_api_config_ConfigError$ResourceLoadingFailed: 1,
  Llaika_api_config_ConfigError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigError$TreeErrors(failures) {
  this.Llaika_api_config_ConfigError$TreeErrors__f_failures = null;
  this.Llaika_api_config_ConfigError$TreeErrors__f_message = null;
  this.Llaika_api_config_ConfigError$TreeErrors__f_failures = failures;
  var tc = $as_Lcats_Functor($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
  var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(failures, tc);
  var f = new $c_sjsr_AnonFunction1(((_$4) => {
    var _$4$1 = $as_Llaika_api_config_ConfigError$DocumentErrors(_$4);
    var this$3 = $n(_$4$1);
    return $m_sr_ScalaRunTime$()._toString__s_Product__T(this$3);
  }));
  var fa = $n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  this.Llaika_api_config_ConfigError$TreeErrors__f_message = $m_Lcats_syntax_FoldableOps$().mkString_$extension__O__T__T__T__Lcats_Show__Lcats_Foldable__T(fa, "Multiple errors processing configuration for document tree: ", ", ", "", $m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString, $as_Lcats_Foldable($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1));
}
$c_Llaika_api_config_ConfigError$TreeErrors.prototype = new $h_O();
$c_Llaika_api_config_ConfigError$TreeErrors.prototype.constructor = $c_Llaika_api_config_ConfigError$TreeErrors;
/** @constructor */
function $h_Llaika_api_config_ConfigError$TreeErrors() {
}
$h_Llaika_api_config_ConfigError$TreeErrors.prototype = $c_Llaika_api_config_ConfigError$TreeErrors.prototype;
$c_Llaika_api_config_ConfigError$TreeErrors.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_ConfigError$TreeErrors.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_config_ConfigError$TreeErrors.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_config_ConfigError$TreeErrors)) {
    var x$0$2 = $as_Llaika_api_config_ConfigError$TreeErrors(x$0);
    var x = this.Llaika_api_config_ConfigError$TreeErrors__f_failures;
    var y = $n(x$0$2).Llaika_api_config_ConfigError$TreeErrors__f_failures;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_config_ConfigError$TreeErrors.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_config_ConfigError$TreeErrors.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_api_config_ConfigError$TreeErrors.prototype.productPrefix__T = (function() {
  return "TreeErrors";
});
$c_Llaika_api_config_ConfigError$TreeErrors.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_config_ConfigError$TreeErrors__f_failures;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_api_config_ConfigError$TreeErrors.prototype.message__T = (function() {
  return this.Llaika_api_config_ConfigError$TreeErrors__f_message;
});
function $as_Llaika_api_config_ConfigError$TreeErrors(obj) {
  return (((obj instanceof $c_Llaika_api_config_ConfigError$TreeErrors) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.ConfigError$TreeErrors"));
}
function $isArrayOf_Llaika_api_config_ConfigError$TreeErrors(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_ConfigError$TreeErrors)));
}
function $asArrayOf_Llaika_api_config_ConfigError$TreeErrors(obj, depth) {
  return (($isArrayOf_Llaika_api_config_ConfigError$TreeErrors(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.ConfigError$TreeErrors;", depth));
}
var $d_Llaika_api_config_ConfigError$TreeErrors = new $TypeData().initClass($c_Llaika_api_config_ConfigError$TreeErrors, "laika.api.config.ConfigError$TreeErrors", ({
  Llaika_api_config_ConfigError$TreeErrors: 1,
  Llaika_api_config_ConfigError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigError$ValidationFailed(message) {
  this.Llaika_api_config_ConfigError$ValidationFailed__f_message = null;
  this.Llaika_api_config_ConfigError$ValidationFailed__f_message = message;
}
$c_Llaika_api_config_ConfigError$ValidationFailed.prototype = new $h_O();
$c_Llaika_api_config_ConfigError$ValidationFailed.prototype.constructor = $c_Llaika_api_config_ConfigError$ValidationFailed;
/** @constructor */
function $h_Llaika_api_config_ConfigError$ValidationFailed() {
}
$h_Llaika_api_config_ConfigError$ValidationFailed.prototype = $c_Llaika_api_config_ConfigError$ValidationFailed.prototype;
$c_Llaika_api_config_ConfigError$ValidationFailed.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_ConfigError$ValidationFailed.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_config_ConfigError$ValidationFailed.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_config_ConfigError$ValidationFailed)) {
    var x$0$2 = $as_Llaika_api_config_ConfigError$ValidationFailed(x$0);
    return ((this.Llaika_api_config_ConfigError$ValidationFailed__f_message === $n(x$0$2).Llaika_api_config_ConfigError$ValidationFailed__f_message) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Llaika_api_config_ConfigError$ValidationFailed.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_config_ConfigError$ValidationFailed.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_api_config_ConfigError$ValidationFailed.prototype.productPrefix__T = (function() {
  return "ValidationFailed";
});
$c_Llaika_api_config_ConfigError$ValidationFailed.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_config_ConfigError$ValidationFailed__f_message;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_api_config_ConfigError$ValidationFailed.prototype.message__T = (function() {
  return this.Llaika_api_config_ConfigError$ValidationFailed__f_message;
});
function $as_Llaika_api_config_ConfigError$ValidationFailed(obj) {
  return (((obj instanceof $c_Llaika_api_config_ConfigError$ValidationFailed) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.ConfigError$ValidationFailed"));
}
function $isArrayOf_Llaika_api_config_ConfigError$ValidationFailed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_ConfigError$ValidationFailed)));
}
function $asArrayOf_Llaika_api_config_ConfigError$ValidationFailed(obj, depth) {
  return (($isArrayOf_Llaika_api_config_ConfigError$ValidationFailed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.ConfigError$ValidationFailed;", depth));
}
var $d_Llaika_api_config_ConfigError$ValidationFailed = new $TypeData().initClass($c_Llaika_api_config_ConfigError$ValidationFailed, "laika.api.config.ConfigError$ValidationFailed", ({
  Llaika_api_config_ConfigError$ValidationFailed: 1,
  Llaika_api_config_ConfigError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigValue$ASTValue(value) {
  this.Llaika_api_config_ConfigValue$ASTValue__f_value = null;
  this.Llaika_api_config_ConfigValue$ASTValue__f_value = value;
}
$c_Llaika_api_config_ConfigValue$ASTValue.prototype = new $h_O();
$c_Llaika_api_config_ConfigValue$ASTValue.prototype.constructor = $c_Llaika_api_config_ConfigValue$ASTValue;
/** @constructor */
function $h_Llaika_api_config_ConfigValue$ASTValue() {
}
$h_Llaika_api_config_ConfigValue$ASTValue.prototype = $c_Llaika_api_config_ConfigValue$ASTValue.prototype;
$c_Llaika_api_config_ConfigValue$ASTValue.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_ConfigValue$ASTValue.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_config_ConfigValue$ASTValue.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_config_ConfigValue$ASTValue)) {
    var x$0$2 = $as_Llaika_api_config_ConfigValue$ASTValue(x$0);
    var x = this.Llaika_api_config_ConfigValue$ASTValue__f_value;
    var x$2 = $n(x$0$2).Llaika_api_config_ConfigValue$ASTValue__f_value;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_config_ConfigValue$ASTValue.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_config_ConfigValue$ASTValue.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_api_config_ConfigValue$ASTValue.prototype.productPrefix__T = (function() {
  return "ASTValue";
});
$c_Llaika_api_config_ConfigValue$ASTValue.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_config_ConfigValue$ASTValue__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_api_config_ConfigValue$ASTValue(obj) {
  return (((obj instanceof $c_Llaika_api_config_ConfigValue$ASTValue) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.ConfigValue$ASTValue"));
}
function $isArrayOf_Llaika_api_config_ConfigValue$ASTValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_ConfigValue$ASTValue)));
}
function $asArrayOf_Llaika_api_config_ConfigValue$ASTValue(obj, depth) {
  return (($isArrayOf_Llaika_api_config_ConfigValue$ASTValue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.ConfigValue$ASTValue;", depth));
}
var $d_Llaika_api_config_ConfigValue$ASTValue = new $TypeData().initClass($c_Llaika_api_config_ConfigValue$ASTValue, "laika.api.config.ConfigValue$ASTValue", ({
  Llaika_api_config_ConfigValue$ASTValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_api_config_ConfigValue: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigValue$ArrayValue(values) {
  this.Llaika_api_config_ConfigValue$ArrayValue__f_values = null;
  this.Llaika_api_config_ConfigValue$ArrayValue__f_values = values;
}
$c_Llaika_api_config_ConfigValue$ArrayValue.prototype = new $h_O();
$c_Llaika_api_config_ConfigValue$ArrayValue.prototype.constructor = $c_Llaika_api_config_ConfigValue$ArrayValue;
/** @constructor */
function $h_Llaika_api_config_ConfigValue$ArrayValue() {
}
$h_Llaika_api_config_ConfigValue$ArrayValue.prototype = $c_Llaika_api_config_ConfigValue$ArrayValue.prototype;
$c_Llaika_api_config_ConfigValue$ArrayValue.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_ConfigValue$ArrayValue.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_config_ConfigValue$ArrayValue.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_config_ConfigValue$ArrayValue)) {
    var x$0$2 = $as_Llaika_api_config_ConfigValue$ArrayValue(x$0);
    var x = this.Llaika_api_config_ConfigValue$ArrayValue__f_values;
    var x$2 = $n(x$0$2).Llaika_api_config_ConfigValue$ArrayValue__f_values;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_config_ConfigValue$ArrayValue.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_config_ConfigValue$ArrayValue.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_api_config_ConfigValue$ArrayValue.prototype.productPrefix__T = (function() {
  return "ArrayValue";
});
$c_Llaika_api_config_ConfigValue$ArrayValue.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_config_ConfigValue$ArrayValue__f_values;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_api_config_ConfigValue$ArrayValue(obj) {
  return (((obj instanceof $c_Llaika_api_config_ConfigValue$ArrayValue) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.ConfigValue$ArrayValue"));
}
function $isArrayOf_Llaika_api_config_ConfigValue$ArrayValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_ConfigValue$ArrayValue)));
}
function $asArrayOf_Llaika_api_config_ConfigValue$ArrayValue(obj, depth) {
  return (($isArrayOf_Llaika_api_config_ConfigValue$ArrayValue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.ConfigValue$ArrayValue;", depth));
}
var $d_Llaika_api_config_ConfigValue$ArrayValue = new $TypeData().initClass($c_Llaika_api_config_ConfigValue$ArrayValue, "laika.api.config.ConfigValue$ArrayValue", ({
  Llaika_api_config_ConfigValue$ArrayValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_api_config_ConfigValue: 1
}));
function $p_Llaika_api_config_ConfigValue$ObjectValue__mergeValues$1__Llaika_api_config_Field__Llaika_api_config_Field__Llaika_api_config_Field($thiz, cbv1, cbv2) {
  if ((cbv1 !== null)) {
    var this$3 = $n(cbv1);
    var x42 = this$3.Llaika_api_config_Field__f_key;
    var this$4 = $n(cbv1);
    var x43 = this$4.Llaika_api_config_Field__f_value;
    var this$5 = $n(cbv1);
    var x44 = this$5.Llaika_api_config_Field__f_origin;
    if ((x43 instanceof $c_Llaika_api_config_ConfigValue$ObjectValue)) {
      var o1 = $as_Llaika_api_config_ConfigValue$ObjectValue(x43);
      if ((cbv2 !== null)) {
        var this$7 = $n(cbv2);
        var this$8 = $n(cbv2);
        var x38 = this$8.Llaika_api_config_Field__f_value;
        var this$9 = $n(cbv2);
        if ((x38 instanceof $c_Llaika_api_config_ConfigValue$ObjectValue)) {
          var o2 = $as_Llaika_api_config_ConfigValue$ObjectValue(x38);
          var value = $n(o1).merge__Llaika_api_config_ConfigValue$ObjectValue__Llaika_api_config_ConfigValue$ObjectValue(o2);
          return new $c_Llaika_api_config_Field(x42, value, x44);
        }
      }
    }
  }
  return cbv1;
}
/** @constructor */
function $c_Llaika_api_config_ConfigValue$ObjectValue(values) {
  this.Llaika_api_config_ConfigValue$ObjectValue__f_values = null;
  this.Llaika_api_config_ConfigValue$ObjectValue__f_values = values;
}
$c_Llaika_api_config_ConfigValue$ObjectValue.prototype = new $h_O();
$c_Llaika_api_config_ConfigValue$ObjectValue.prototype.constructor = $c_Llaika_api_config_ConfigValue$ObjectValue;
/** @constructor */
function $h_Llaika_api_config_ConfigValue$ObjectValue() {
}
$h_Llaika_api_config_ConfigValue$ObjectValue.prototype = $c_Llaika_api_config_ConfigValue$ObjectValue.prototype;
$c_Llaika_api_config_ConfigValue$ObjectValue.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_ConfigValue$ObjectValue.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_config_ConfigValue$ObjectValue.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_config_ConfigValue$ObjectValue)) {
    var x$0$2 = $as_Llaika_api_config_ConfigValue$ObjectValue(x$0);
    var x = this.Llaika_api_config_ConfigValue$ObjectValue__f_values;
    var x$2 = $n(x$0$2).Llaika_api_config_ConfigValue$ObjectValue__f_values;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_config_ConfigValue$ObjectValue.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_config_ConfigValue$ObjectValue.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_api_config_ConfigValue$ObjectValue.prototype.productPrefix__T = (function() {
  return "ObjectValue";
});
$c_Llaika_api_config_ConfigValue$ObjectValue.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_config_ConfigValue$ObjectValue__f_values;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_api_config_ConfigValue$ObjectValue.prototype.merge__Llaika_api_config_ConfigValue$ObjectValue__Llaika_api_config_ConfigValue$ObjectValue = (function(other) {
  var this$1 = $n(this.Llaika_api_config_ConfigValue$ObjectValue__f_values);
  var suffix = $n(other).Llaika_api_config_ConfigValue$ObjectValue__f_values;
  var this$2 = $n($as_sc_IterableOps(this$1.appendedAll__sc_IterableOnce__O(suffix)));
  var m = $as_scm_Map($m_scm_Map$().empty__O());
  var it = this$2.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    var _$1 = $as_Llaika_api_config_Field(elem);
    var key = $n(_$1).Llaika_api_config_Field__f_key;
    var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0(((this$2) => (() => this$2.newSpecificBuilder__scm_Builder()))(this$2))));
    var this$3 = $n(bldr);
    this$3.addOne__O__scm_Growable(elem);
  }
  var this$4 = $m_sci_HashMap$();
  var result = this$4.sci_HashMap$__f_EmptyMap;
  var mapIt = $n(m).iterator__sc_Iterator();
  while ($n(mapIt).hasNext__Z()) {
    var x1 = $as_T2($n(mapIt).next__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = $n(x1)._1__O();
    var v = $as_scm_Builder($n(x1)._2__O());
    result = $n(result).updated__O__O__sci_HashMap(k, $n(v).result__O());
  }
  var this$5 = $n(result);
  var mergedFields = $as_sci_Seq($n($m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$5)).map__F1__O(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var fields = $as_sci_Seq($n(x$1$1)._2__O());
      var this$6 = $n(fields);
      var op = new $c_sjsr_AnonFunction2(((cbv1, cbv2) => {
        var cbv1$1 = $as_Llaika_api_config_Field(cbv1);
        var cbv2$1 = $as_Llaika_api_config_Field(cbv2);
        return $p_Llaika_api_config_ConfigValue$ObjectValue__mergeValues$1__Llaika_api_config_Field__Llaika_api_config_Field__Llaika_api_config_Field(this, cbv1$1, cbv2$1);
      }));
      return $as_Llaika_api_config_Field(this$6.reduceLeft__F2__O(op));
    }
    throw new $c_s_MatchError(x$1$1);
  }))));
  return new $c_Llaika_api_config_ConfigValue$ObjectValue(mergedFields);
});
$c_Llaika_api_config_ConfigValue$ObjectValue.prototype.toConfig__Llaika_api_config_Config = (function() {
  if ($n(this.Llaika_api_config_ConfigValue$ObjectValue__f_values).isEmpty__Z()) {
    var origin = $m_Llaika_api_config_Origin$().Llaika_api_config_Origin$__f_root;
  } else {
    var this$1 = $n(this.Llaika_api_config_ConfigValue$ObjectValue__f_values);
    var m = $as_scm_Map($m_scm_Map$().empty__O());
    var it = this$1.iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var elem = $n(it).next__O();
      var _$2 = $as_Llaika_api_config_Field(elem);
      var key = $n(_$2).Llaika_api_config_Field__f_origin;
      var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0(((this$1) => (() => this$1.newSpecificBuilder__scm_Builder()))(this$1))));
      var this$2 = $n(bldr);
      this$2.addOne__O__scm_Growable(elem);
    }
    var this$3 = $m_sci_HashMap$();
    var result = this$3.sci_HashMap$__f_EmptyMap;
    var mapIt = $n(m).iterator__sc_Iterator();
    while ($n(mapIt).hasNext__Z()) {
      var x1 = $as_T2($n(mapIt).next__O());
      if ((x1 === null)) {
        throw new $c_s_MatchError(x1);
      }
      var k = $n(x1)._1__O();
      var v = $as_scm_Builder($n(x1)._2__O());
      result = $n(result).updated__O__O__sci_HashMap(k, $n(v).result__O());
    }
    var this$4 = $n(result);
    var this$6 = $n($m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$4));
    var f = new $c_sjsr_AnonFunction1(((_$3) => {
      var _$3$1 = $as_T2(_$3);
      var this$5 = $n($as_sc_SeqOps($n(_$3$1)._2__O()));
      return this$5.length__I();
    }));
    var ord = $m_s_math_Ordering$Int$();
    var origin = $as_Llaika_api_config_Origin($n($as_T2($f_sc_IterableOnceOps__maxBy__F1__s_math_Ordering__O(this$6, f, ord)))._1__O());
  }
  return new $c_Llaika_api_config_ObjectConfig(this, origin, $m_Llaika_api_config_EmptyConfig$());
});
function $as_Llaika_api_config_ConfigValue$ObjectValue(obj) {
  return (((obj instanceof $c_Llaika_api_config_ConfigValue$ObjectValue) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.ConfigValue$ObjectValue"));
}
function $isArrayOf_Llaika_api_config_ConfigValue$ObjectValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_ConfigValue$ObjectValue)));
}
function $asArrayOf_Llaika_api_config_ConfigValue$ObjectValue(obj, depth) {
  return (($isArrayOf_Llaika_api_config_ConfigValue$ObjectValue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.ConfigValue$ObjectValue;", depth));
}
var $d_Llaika_api_config_ConfigValue$ObjectValue = new $TypeData().initClass($c_Llaika_api_config_ConfigValue$ObjectValue, "laika.api.config.ConfigValue$ObjectValue", ({
  Llaika_api_config_ConfigValue$ObjectValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_api_config_ConfigValue: 1
}));
function $is_Llaika_api_config_ConfigValue$SimpleValue(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_api_config_ConfigValue$SimpleValue)));
}
function $as_Llaika_api_config_ConfigValue$SimpleValue(obj) {
  return (($is_Llaika_api_config_ConfigValue$SimpleValue(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.ConfigValue$SimpleValue"));
}
function $isArrayOf_Llaika_api_config_ConfigValue$SimpleValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_ConfigValue$SimpleValue)));
}
function $asArrayOf_Llaika_api_config_ConfigValue$SimpleValue(obj, depth) {
  return (($isArrayOf_Llaika_api_config_ConfigValue$SimpleValue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.ConfigValue$SimpleValue;", depth));
}
/** @constructor */
function $c_Llaika_api_format_RenderFormat$Overrides(outer, value) {
  this.Llaika_api_format_RenderFormat$Overrides__f_value = null;
  this.Llaika_api_format_RenderFormat$Overrides__f_$outer = null;
  this.Llaika_api_format_RenderFormat$Overrides__f_value = value;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_api_format_RenderFormat$Overrides__f_$outer = outer;
}
$c_Llaika_api_format_RenderFormat$Overrides.prototype = new $h_O();
$c_Llaika_api_format_RenderFormat$Overrides.prototype.constructor = $c_Llaika_api_format_RenderFormat$Overrides;
/** @constructor */
function $h_Llaika_api_format_RenderFormat$Overrides() {
}
$h_Llaika_api_format_RenderFormat$Overrides.prototype = $c_Llaika_api_format_RenderFormat$Overrides.prototype;
$c_Llaika_api_format_RenderFormat$Overrides.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_format_RenderFormat$Overrides.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_format_RenderFormat$Overrides.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Llaika_api_format_RenderFormat$Overrides) && ($n($as_Llaika_api_format_RenderFormat$Overrides(x$0)).Llaika_api_format_RenderFormat$Overrides__f_$outer === this.Llaika_api_format_RenderFormat$Overrides__f_$outer))) {
    var x$0$2 = $as_Llaika_api_format_RenderFormat$Overrides(x$0);
    var x = this.Llaika_api_format_RenderFormat$Overrides__f_value;
    var x$2 = $n(x$0$2).Llaika_api_format_RenderFormat$Overrides__f_value;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_format_RenderFormat$Overrides.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_format_RenderFormat$Overrides.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_api_format_RenderFormat$Overrides.prototype.productPrefix__T = (function() {
  return "Overrides";
});
$c_Llaika_api_format_RenderFormat$Overrides.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_format_RenderFormat$Overrides__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_api_format_RenderFormat$Overrides.prototype.withBase__Llaika_api_format_RenderFormat$Overrides__Llaika_api_format_RenderFormat$Overrides = (function(base) {
  return $n($n(this.Llaika_api_format_RenderFormat$Overrides__f_$outer).Overrides__Llaika_api_format_RenderFormat$Overrides$()).apply__s_PartialFunction__Llaika_api_format_RenderFormat$Overrides($n(this.Llaika_api_format_RenderFormat$Overrides__f_value).orElse__s_PartialFunction__s_PartialFunction($n(base).Llaika_api_format_RenderFormat$Overrides__f_value));
});
function $as_Llaika_api_format_RenderFormat$Overrides(obj) {
  return (((obj instanceof $c_Llaika_api_format_RenderFormat$Overrides) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.format.RenderFormat$Overrides"));
}
function $isArrayOf_Llaika_api_format_RenderFormat$Overrides(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_format_RenderFormat$Overrides)));
}
function $asArrayOf_Llaika_api_format_RenderFormat$Overrides(obj, depth) {
  return (($isArrayOf_Llaika_api_format_RenderFormat$Overrides(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.format.RenderFormat$Overrides;", depth));
}
var $d_Llaika_api_format_RenderFormat$Overrides = new $TypeData().initClass($c_Llaika_api_format_RenderFormat$Overrides, "laika.api.format.RenderFormat$Overrides", ({
  Llaika_api_format_RenderFormat$Overrides: 1,
  Llaika_api_bundle_RenderOverrides: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_format_TagFormatter$$anon$1() {
}
$c_Llaika_api_format_TagFormatter$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_api_format_TagFormatter$$anon$1.prototype.constructor = $c_Llaika_api_format_TagFormatter$$anon$1;
/** @constructor */
function $h_Llaika_api_format_TagFormatter$$anon$1() {
}
$h_Llaika_api_format_TagFormatter$$anon$1.prototype = $c_Llaika_api_format_TagFormatter$$anon$1.prototype;
$c_Llaika_api_format_TagFormatter$$anon$1.prototype.isDefinedAt__T2__Z = (function(x) {
  if ((x !== null)) {
    var x3 = $as_s_Option($n(x)._2__O());
    $as_T($n(x)._1__O());
    if ((x3 instanceof $c_s_Some)) {
      $as_T($n($as_s_Some(x3)).s_Some__f_value);
      return true;
    }
  }
  return false;
});
$c_Llaika_api_format_TagFormatter$$anon$1.prototype.applyOrElse__T2__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var x8 = $as_s_Option($n(x)._2__O());
    var name = $as_T($n(x)._1__O());
    if ((x8 instanceof $c_s_Some)) {
      var value = $as_T($n($as_s_Some(x8)).s_Some__f_value);
      return new $c_T2(name, value);
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_api_format_TagFormatter$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z($as_T2(x));
});
$c_Llaika_api_format_TagFormatter$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O($as_T2(x), default$1);
});
var $d_Llaika_api_format_TagFormatter$$anon$1 = new $TypeData().initClass($c_Llaika_api_format_TagFormatter$$anon$1, "laika.api.format.TagFormatter$$anon$1", ({
  Llaika_api_format_TagFormatter$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
function $f_Llaika_ast_BlockContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_BlockContainer($thiz, rules) {
  var this$1 = $n(rules);
  var blocks = $thiz.content__sci_Seq();
  return $thiz.withContent__sci_Seq__Llaika_ast_BlockContainer($p_Llaika_ast_RewriteRules__rewrite__F1__sci_Seq__sci_Seq(this$1, $p_Llaika_ast_RewriteRules__chainedBlockRules__F1(this$1), blocks));
}
function $is_Llaika_ast_BlockContainer(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_BlockContainer)));
}
function $as_Llaika_ast_BlockContainer(obj) {
  return (($is_Llaika_ast_BlockContainer(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.BlockContainer"));
}
function $isArrayOf_Llaika_ast_BlockContainer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_BlockContainer)));
}
function $asArrayOf_Llaika_ast_BlockContainer(obj, depth) {
  return (($isArrayOf_Llaika_ast_BlockContainer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.BlockContainer;", depth));
}
/** @constructor */
function $c_Llaika_ast_BlockSequence$() {
}
$c_Llaika_ast_BlockSequence$.prototype = new $h_O();
$c_Llaika_ast_BlockSequence$.prototype.constructor = $c_Llaika_ast_BlockSequence$;
/** @constructor */
function $h_Llaika_ast_BlockSequence$() {
}
$h_Llaika_ast_BlockSequence$.prototype = $c_Llaika_ast_BlockSequence$.prototype;
$c_Llaika_ast_BlockSequence$.prototype.createSpanContainer__sci_Seq__O = (function(spans) {
  return $f_Llaika_ast_BlockContainerCompanion__createSpanContainer__sci_Seq__O(this, spans);
});
$c_Llaika_ast_BlockSequence$.prototype.createBlockContainer__sci_Seq__O = (function(blocks) {
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  return new $c_Llaika_ast_BlockSequence(blocks, options);
});
var $d_Llaika_ast_BlockSequence$ = new $TypeData().initClass($c_Llaika_ast_BlockSequence$, "laika.ast.BlockSequence$", ({
  Llaika_ast_BlockSequence$: 1,
  Llaika_ast_SpanContainerCompanion: 1,
  Llaika_ast_BlockContainerCompanion: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_ast_BlockSequence$;
function $m_Llaika_ast_BlockSequence$() {
  if ((!$n_Llaika_ast_BlockSequence$)) {
    $n_Llaika_ast_BlockSequence$ = new $c_Llaika_ast_BlockSequence$();
  }
  return $n_Llaika_ast_BlockSequence$;
}
/** @constructor */
function $c_Llaika_ast_BulletFormat$StringBullet(bullet) {
  this.Llaika_ast_BulletFormat$StringBullet__f_bullet = null;
  this.Llaika_ast_BulletFormat$StringBullet__f_bullet = bullet;
}
$c_Llaika_ast_BulletFormat$StringBullet.prototype = new $h_O();
$c_Llaika_ast_BulletFormat$StringBullet.prototype.constructor = $c_Llaika_ast_BulletFormat$StringBullet;
/** @constructor */
function $h_Llaika_ast_BulletFormat$StringBullet() {
}
$h_Llaika_ast_BulletFormat$StringBullet.prototype = $c_Llaika_ast_BulletFormat$StringBullet.prototype;
$c_Llaika_ast_BulletFormat$StringBullet.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_BulletFormat$StringBullet.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_BulletFormat$StringBullet.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_BulletFormat$StringBullet)) {
    var x$0$2 = $as_Llaika_ast_BulletFormat$StringBullet(x$0);
    return ((this.Llaika_ast_BulletFormat$StringBullet__f_bullet === $n(x$0$2).Llaika_ast_BulletFormat$StringBullet__f_bullet) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Llaika_ast_BulletFormat$StringBullet.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_BulletFormat$StringBullet.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_ast_BulletFormat$StringBullet.prototype.productPrefix__T = (function() {
  return "StringBullet";
});
$c_Llaika_ast_BulletFormat$StringBullet.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_BulletFormat$StringBullet__f_bullet;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_ast_BulletFormat$StringBullet(obj) {
  return (((obj instanceof $c_Llaika_ast_BulletFormat$StringBullet) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.BulletFormat$StringBullet"));
}
function $isArrayOf_Llaika_ast_BulletFormat$StringBullet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_BulletFormat$StringBullet)));
}
function $asArrayOf_Llaika_ast_BulletFormat$StringBullet(obj, depth) {
  return (($isArrayOf_Llaika_ast_BulletFormat$StringBullet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.BulletFormat$StringBullet;", depth));
}
var $d_Llaika_ast_BulletFormat$StringBullet = new $TypeData().initClass($c_Llaika_ast_BulletFormat$StringBullet, "laika.ast.BulletFormat$StringBullet", ({
  Llaika_ast_BulletFormat$StringBullet: 1,
  Llaika_ast_BulletFormat: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_Document$$anon$1() {
}
$c_Llaika_ast_Document$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_ast_Document$$anon$1.prototype.constructor = $c_Llaika_ast_Document$$anon$1;
/** @constructor */
function $h_Llaika_ast_Document$$anon$1() {
}
$h_Llaika_ast_Document$$anon$1.prototype = $c_Llaika_ast_Document$$anon$1.prototype;
$c_Llaika_ast_Document$$anon$1.prototype.isDefinedAt__Llaika_ast_Element__Z = (function(x) {
  if ((x instanceof $c_Llaika_ast_RootElement)) {
    var x$1 = $as_Llaika_ast_RootElement(x);
    var this$2 = $n(x$1);
    var x29 = this$2.Llaika_ast_RootElement__f_content;
    var this$3 = $n(x$1);
    if ((x29 instanceof $c_sci_$colon$colon)) {
      var x31 = $as_sci_$colon$colon(x29);
      var x33 = $n(x31).sci_$colon$colon__f_next;
      if (($n(x31).sci_$colon$colon__f_head instanceof $c_Llaika_ast_TemplateRoot)) {
        $m_Llaika_ast_TemplateRoot$();
        var x$1$1 = $as_Llaika_ast_TemplateRoot($n(x31).sci_$colon$colon__f_head);
        var this$5 = $n(x$1$1);
        var this$6 = $n(x$1$1);
        var x$2 = $m_sci_Nil$();
        if (x$2.equals__O__Z(x33)) {
          return true;
        }
      }
    }
    return true;
  }
  if ((x instanceof $c_Llaika_ast_EmbeddedRoot)) {
    var x$1$2 = $as_Llaika_ast_EmbeddedRoot(x);
    var this$8 = $n(x$1$2);
    var this$9 = $n(x$1$2);
    var this$10 = $n(x$1$2);
    return true;
  }
  return false;
});
$c_Llaika_ast_Document$$anon$1.prototype.applyOrElse__Llaika_ast_Element__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Llaika_ast_RootElement)) {
    var x$1 = $as_Llaika_ast_RootElement(x);
    var this$2 = $n(x$1);
    var x50 = this$2.Llaika_ast_RootElement__f_content;
    var this$3 = $n(x$1);
    if ((x50 instanceof $c_sci_$colon$colon)) {
      var x52 = $as_sci_$colon$colon(x50);
      var x54 = $n(x52).sci_$colon$colon__f_next;
      if (($n(x52).sci_$colon$colon__f_head instanceof $c_Llaika_ast_TemplateRoot)) {
        $m_Llaika_ast_TemplateRoot$();
        var x$1$1 = $as_Llaika_ast_TemplateRoot($n(x52).sci_$colon$colon__f_head);
        var this$5 = $n(x$1$1);
        var this$6 = $n(x$1$1);
        var x$2 = $m_sci_Nil$();
        if (x$2.equals__O__Z(x54)) {
          return $m_sci_Nil$();
        }
      }
    }
    return $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_sci_Seq.getArrayOf().constr)([x50])));
  }
  if ((x instanceof $c_Llaika_ast_EmbeddedRoot)) {
    var x$1$2 = $as_Llaika_ast_EmbeddedRoot(x);
    var this$8 = $n(x$1$2);
    var x41 = this$8.Llaika_ast_EmbeddedRoot__f_content;
    var this$9 = $n(x$1$2);
    var this$10 = $n(x$1$2);
    return $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_sci_Seq.getArrayOf().constr)([x41])));
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_ast_Document$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Element__Z($as_Llaika_ast_Element(x));
});
$c_Llaika_ast_Document$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Element__F1__O($as_Llaika_ast_Element(x), default$1);
});
var $d_Llaika_ast_Document$$anon$1 = new $TypeData().initClass($c_Llaika_ast_Document$$anon$1, "laika.ast.Document$$anon$1", ({
  Llaika_ast_Document$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_Document$$anon$2() {
}
$c_Llaika_ast_Document$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_ast_Document$$anon$2.prototype.constructor = $c_Llaika_ast_Document$$anon$2;
/** @constructor */
function $h_Llaika_ast_Document$$anon$2() {
}
$h_Llaika_ast_Document$$anon$2.prototype = $c_Llaika_ast_Document$$anon$2.prototype;
$c_Llaika_ast_Document$$anon$2.prototype.isDefinedAt__Llaika_ast_Element__Z = (function(x) {
  if ((x instanceof $c_Llaika_ast_Title)) {
    var x$1 = $as_Llaika_ast_Title(x);
    var this$2 = $n(x$1);
    var this$3 = $n(x$1);
    return true;
  } else {
    return false;
  }
});
$c_Llaika_ast_Document$$anon$2.prototype.applyOrElse__Llaika_ast_Element__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Llaika_ast_Title)) {
    var x$1 = $as_Llaika_ast_Title(x);
    var this$2 = $n(x$1);
    var x67 = this$2.Llaika_ast_Title__f_content;
    var this$3 = $n(x$1);
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    return new $c_Llaika_ast_SpanSequence(x67, options);
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_ast_Document$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Element__Z($as_Llaika_ast_Element(x));
});
$c_Llaika_ast_Document$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Element__F1__O($as_Llaika_ast_Element(x), default$1);
});
var $d_Llaika_ast_Document$$anon$2 = new $TypeData().initClass($c_Llaika_ast_Document$$anon$2, "laika.ast.Document$$anon$2", ({
  Llaika_ast_Document$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_Document$$anon$3(outer) {
  this.Llaika_ast_Document$$anon$3__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_ast_Document$$anon$3__f_$outer = outer;
}
$c_Llaika_ast_Document$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_ast_Document$$anon$3.prototype.constructor = $c_Llaika_ast_Document$$anon$3;
/** @constructor */
function $h_Llaika_ast_Document$$anon$3() {
}
$h_Llaika_ast_Document$$anon$3.prototype = $c_Llaika_ast_Document$$anon$3.prototype;
$c_Llaika_ast_Document$$anon$3.prototype.isDefinedAt__Llaika_ast_Block__Z = (function(x) {
  if ((x instanceof $c_Llaika_ast_Section)) {
    var x$1 = $as_Llaika_ast_Section(x);
    var this$2 = $n(x$1);
    var x72 = this$2.Llaika_ast_Section__f_header;
    var this$3 = $n(x$1);
    var this$4 = $n(x$1);
    if ((x72 !== null)) {
      var this$6 = $n(x72);
      var this$7 = $n(x72);
      var this$8 = $n(x72);
      var x78 = this$8.Llaika_ast_Header__f_options;
      if ((x78 !== null)) {
        var x79 = $n(x78).Llaika_ast_Options$Impl__f_id;
        if ((!$n(x79).isEmpty__Z())) {
          $as_T($n(x79).get__O());
          return true;
        }
      }
    }
  }
  return false;
});
$c_Llaika_ast_Document$$anon$3.prototype.applyOrElse__Llaika_ast_Block__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Llaika_ast_Section)) {
    var x$1 = $as_Llaika_ast_Section(x);
    var this$2 = $n(x$1);
    var x85 = this$2.Llaika_ast_Section__f_header;
    var this$3 = $n(x$1);
    var x86 = this$3.Llaika_ast_Section__f_content;
    var this$4 = $n(x$1);
    if ((x85 !== null)) {
      var this$6 = $n(x85);
      var this$7 = $n(x85);
      var x90 = this$7.Llaika_ast_Header__f_content;
      var this$8 = $n(x85);
      var x91 = this$8.Llaika_ast_Header__f_options;
      if ((x91 !== null)) {
        var x92 = $n(x91).Llaika_ast_Options$Impl__f_id;
        if ((!$n(x92).isEmpty__Z())) {
          var x93 = $as_T($n(x92).get__O());
          var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
          var title = new $c_Llaika_ast_SpanSequence(x90, options);
          var content = $n(this.Llaika_ast_Document$$anon$3__f_$outer).laika$ast$Document$$_$extractSections$1__sci_Seq__sci_Seq(x86);
          var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
          return new $c_Llaika_ast_SectionInfo(x93, title, content, options$1);
        }
      }
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_ast_Document$$anon$3.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Block__Z($as_Llaika_ast_Block(x));
});
$c_Llaika_ast_Document$$anon$3.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Block__F1__O($as_Llaika_ast_Block(x), default$1);
});
var $d_Llaika_ast_Document$$anon$3 = new $TypeData().initClass($c_Llaika_ast_Document$$anon$3, "laika.ast.Document$$anon$3", ({
  Llaika_ast_Document$$anon$3: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_Document$$anon$5(filter$9) {
  this.Llaika_ast_Document$$anon$5__f_filter$2 = null;
  this.Llaika_ast_Document$$anon$5__f_filter$2 = filter$9;
}
$c_Llaika_ast_Document$$anon$5.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_ast_Document$$anon$5.prototype.constructor = $c_Llaika_ast_Document$$anon$5;
/** @constructor */
function $h_Llaika_ast_Document$$anon$5() {
}
$h_Llaika_ast_Document$$anon$5.prototype = $c_Llaika_ast_Document$$anon$5.prototype;
$c_Llaika_ast_Document$$anon$5.prototype.isDefinedAt__Llaika_ast_Element__Z = (function(x) {
  if ($is_Llaika_ast_Invalid(x)) {
    var inv = $as_Llaika_ast_Invalid(x);
    if ($n(this.Llaika_ast_Document$$anon$5__f_filter$2).apply__Llaika_ast_RuntimeMessage__Z($n(inv).message__Llaika_ast_RuntimeMessage())) {
      return true;
    }
  }
  return false;
});
$c_Llaika_ast_Document$$anon$5.prototype.applyOrElse__Llaika_ast_Element__F1__O = (function(x, default$1) {
  if ($is_Llaika_ast_Invalid(x)) {
    var inv = $as_Llaika_ast_Invalid(x);
    if ($n(this.Llaika_ast_Document$$anon$5__f_filter$2).apply__Llaika_ast_RuntimeMessage__Z($n(inv).message__Llaika_ast_RuntimeMessage())) {
      return inv;
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_ast_Document$$anon$5.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Element__Z($as_Llaika_ast_Element(x));
});
$c_Llaika_ast_Document$$anon$5.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Element__F1__O($as_Llaika_ast_Element(x), default$1);
});
var $d_Llaika_ast_Document$$anon$5 = new $TypeData().initClass($c_Llaika_ast_Document$$anon$5, "laika.ast.Document$$anon$5", ({
  Llaika_ast_Document$$anon$5: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
function $p_Llaika_ast_DocumentFragment$__combine__sci_List__Llaika_ast_Element($thiz, fragments) {
  if ((fragments !== null)) {
    if (($n(fragments).lengthCompare__I__I(1) === 0)) {
      var this$4 = $n(fragments);
      var x61 = $as_Llaika_ast_DocumentFragment($f_sc_LinearSeqOps__apply__I__O(this$4, 0));
      return $n(x61).Llaika_ast_DocumentFragment__f_root;
    }
  }
  var this$6 = $n(fragments);
  var f = ((_$1) => {
    var _$1$1 = $as_Llaika_ast_DocumentFragment(_$1);
    return $n(_$1$1).Llaika_ast_DocumentFragment__f_root;
  });
  if ((this$6 === $m_sci_Nil$())) {
    var $x_1 = $m_sci_Nil$();
  } else {
    var arg1 = this$6.head__O();
    var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$6.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O());
    }
    var $x_1 = h;
  }
  var this$19 = $n($x_1);
  var f$1 = ((x$1, x$2) => {
    var x$1$1 = $as_Llaika_ast_Element(x$1);
    var x$2$1 = $as_Llaika_ast_Element(x$2);
    matchResult26: {
      var $x_2;
      if ($is_Llaika_ast_Span(x$1$1)) {
        var s1 = $as_Llaika_ast_Span(x$1$1);
        if ($is_Llaika_ast_Span(x$2$1)) {
          var s2 = $as_Llaika_ast_Span(x$2$1);
          var this$8 = $m_Llaika_ast_SpanSequence$();
          var spans = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Span.getArrayOf().constr)([s2]));
          var $x_2 = $as_Llaika_ast_RewritableContainer($f_Llaika_ast_SpanContainerCompanion__apply__Llaika_ast_Span__sci_Seq__O(this$8, s1, spans));
          break matchResult26;
        }
      }
      if ($is_Llaika_ast_Block(x$1$1)) {
        var b = $as_Llaika_ast_Block(x$1$1);
        if ($is_Llaika_ast_Span(x$2$1)) {
          var s = $as_Llaika_ast_Span(x$2$1);
          var this$10 = $m_Llaika_ast_BlockSequence$();
          var $x_3 = $m_sr_ScalaRunTime$();
          var this$9 = $m_Llaika_ast_SpanSequence$();
          var spans$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Span.getArrayOf().constr)([]));
          var blocks = $n($x_3).wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Block.getArrayOf().constr)([$as_Llaika_ast_Block($f_Llaika_ast_SpanContainerCompanion__apply__Llaika_ast_Span__sci_Seq__O(this$9, s, spans$1))]));
          var $x_2 = $as_Llaika_ast_RewritableContainer($f_Llaika_ast_BlockContainerCompanion__apply__Llaika_ast_Block__sci_Seq__O(this$10, b, blocks));
          break matchResult26;
        }
      }
      if ($is_Llaika_ast_Span(x$1$1)) {
        var s$2 = $as_Llaika_ast_Span(x$1$1);
        if ($is_Llaika_ast_Block(x$2$1)) {
          var b$2 = $as_Llaika_ast_Block(x$2$1);
          var this$12 = $m_Llaika_ast_BlockSequence$();
          var this$11 = $m_Llaika_ast_SpanSequence$();
          var spans$2 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Span.getArrayOf().constr)([]));
          var block = $as_Llaika_ast_Block($f_Llaika_ast_SpanContainerCompanion__apply__Llaika_ast_Span__sci_Seq__O(this$11, s$2, spans$2));
          var blocks$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Block.getArrayOf().constr)([b$2]));
          var $x_2 = $as_Llaika_ast_RewritableContainer($f_Llaika_ast_BlockContainerCompanion__apply__Llaika_ast_Block__sci_Seq__O(this$12, block, blocks$1));
          break matchResult26;
        }
      }
      if ($is_Llaika_ast_Block(x$1$1)) {
        var b1 = $as_Llaika_ast_Block(x$1$1);
        if ($is_Llaika_ast_Block(x$2$1)) {
          var b2 = $as_Llaika_ast_Block(x$2$1);
          var this$13 = $m_Llaika_ast_BlockSequence$();
          var blocks$2 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_Block.getArrayOf().constr)([b2]));
          var $x_2 = $as_Llaika_ast_RewritableContainer($f_Llaika_ast_BlockContainerCompanion__apply__Llaika_ast_Block__sci_Seq__O(this$13, b1, blocks$2));
          break matchResult26;
        }
      }
      var this$18 = $m_Llaika_ast_TemplateSpanSequence$();
      var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      var span = new $c_Llaika_ast_TemplateElement(x$1$1, 0, options);
      var $x_4 = $m_sr_ScalaRunTime$();
      var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      var spans$3 = $n($x_4).wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_TemplateSpan.getArrayOf().constr)([new $c_Llaika_ast_TemplateElement(x$2$1, 0, options$1)]));
      var $x_2 = $as_Llaika_ast_RewritableContainer($f_Llaika_ast_TemplateSpanContainerCompanion__apply__Llaika_ast_TemplateSpan__sci_Seq__O(this$18, span, spans$3));
    }
    return $as_Llaika_ast_Element($x_2);
  });
  matchEnd4: {
    var $x_5;
    if ($is_sc_IndexedSeq(this$19)) {
      var x2 = $as_sc_IndexedSeq(this$19);
      if (($n(x2).length__I() > 0)) {
        var z = $n(x2).apply__I__O(0);
        var at = 1;
        var end = $n(x2).length__I();
        var acc = z;
        while (true) {
          if ((at !== end)) {
            var temp$at = ((1 + at) | 0);
            var arg1$2 = acc;
            var arg2 = $n(x2).apply__I__O(at);
            var temp$acc = f$1(arg1$2, arg2);
            at = temp$at;
            acc = temp$acc;
            continue;
          }
          var $x_5 = acc;
          break matchEnd4;
        }
      }
    }
    if ((this$19.knownSize__I() === 0)) {
      throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
    }
    var it = this$19.iterator__sc_Iterator();
    if ((!$n(it).hasNext__Z())) {
      throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
    }
    var acc$1 = $n(it).next__O();
    while ($n(it).hasNext__Z()) {
      var arg1$3 = acc$1;
      var arg2$1 = $n(it).next__O();
      acc$1 = f$1(arg1$3, arg2$1);
    }
    var $x_5 = acc$1;
  }
  return $as_Llaika_ast_Element($x_5);
}
/** @constructor */
function $c_Llaika_ast_DocumentFragment$() {
}
$c_Llaika_ast_DocumentFragment$.prototype = new $h_sr_AbstractFunction3();
$c_Llaika_ast_DocumentFragment$.prototype.constructor = $c_Llaika_ast_DocumentFragment$;
/** @constructor */
function $h_Llaika_ast_DocumentFragment$() {
}
$h_Llaika_ast_DocumentFragment$.prototype = $c_Llaika_ast_DocumentFragment$.prototype;
$c_Llaika_ast_DocumentFragment$.prototype.collect__Llaika_ast_RootElement__sci_Map = (function(root) {
  var this$1 = $n(root);
  var pf = new $c_Llaika_ast_DocumentFragment$$anon$1(this);
  var this$2 = $n($f_Llaika_ast_ElementTraversal__collect__s_PartialFunction__sci_List(this$1, pf));
  var m = $as_scm_Map($m_scm_Map$().empty__O());
  var it = this$2.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    var _$2 = $as_Llaika_ast_DocumentFragment(elem);
    var key = $n(_$2).Llaika_ast_DocumentFragment__f_name;
    var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0((() => new $c_scm_ListBuffer()))));
    var this$4 = $n(bldr);
    this$4.addOne__O__scm_Growable(elem);
  }
  var this$5 = $m_sci_HashMap$();
  var result = this$5.sci_HashMap$__f_EmptyMap;
  var mapIt = $n(m).iterator__sc_Iterator();
  while ($n(mapIt).hasNext__Z()) {
    var x1 = $as_T2($n(mapIt).next__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = $n(x1)._1__O();
    var v = $as_scm_Builder($n(x1)._2__O());
    result = $n(result).updated__O__O__sci_HashMap(k, $n(v).result__O());
  }
  var map = result;
  var this$8 = $n(map);
  $m_sci_HashMap$();
  var b = new $c_sci_HashMapBuilder();
  var it$1 = this$8.iterator__sc_Iterator();
  while ($n(it$1).hasNext__Z()) {
    var arg1 = $n(it$1).next__O();
    var x$1 = $as_T2(arg1);
    matchResult2: {
      var elem$1___1;
      var elem$1___2;
      if ((x$1 !== null)) {
        var k$1 = $n(x$1)._1__O();
        var v$1 = $n(x$1)._2__O();
        var fragments = $as_sci_List(v$1);
        var _2 = $p_Llaika_ast_DocumentFragment$__combine__sci_List__Llaika_ast_Element(this, fragments);
        var elem$1___1 = k$1;
        var elem$1___2 = _2;
        break matchResult2;
      }
      throw new $c_s_MatchError(x$1);
    }
    $p_sci_HashMapBuilder__ensureUnaliased__V(b);
    var x = elem$1___1;
    var h = $m_sr_Statics$().anyHash__O__I(x);
    var im = $m_sc_Hashing$().improve__I__I(h);
    b.update__sci_MapNode__O__O__I__I__I__V(b.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, elem$1___1, elem$1___2, h, im, 0);
  }
  return b.result__sci_HashMap();
});
$c_Llaika_ast_DocumentFragment$.prototype.apply__O__O__O__O = (function(v1, v2, v3) {
  var name = $as_T(v1);
  var root = $as_Llaika_ast_Element(v2);
  var options = $as_Llaika_ast_Options(v3);
  return new $c_Llaika_ast_DocumentFragment(name, root, options);
});
var $d_Llaika_ast_DocumentFragment$ = new $TypeData().initClass($c_Llaika_ast_DocumentFragment$, "laika.ast.DocumentFragment$", ({
  Llaika_ast_DocumentFragment$: 1,
  sr_AbstractFunction3: 1,
  F3: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_ast_DocumentFragment$;
function $m_Llaika_ast_DocumentFragment$() {
  if ((!$n_Llaika_ast_DocumentFragment$)) {
    $n_Llaika_ast_DocumentFragment$ = new $c_Llaika_ast_DocumentFragment$();
  }
  return $n_Llaika_ast_DocumentFragment$;
}
/** @constructor */
function $c_Llaika_ast_DocumentFragment$$anon$1(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_ast_DocumentFragment$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_ast_DocumentFragment$$anon$1.prototype.constructor = $c_Llaika_ast_DocumentFragment$$anon$1;
/** @constructor */
function $h_Llaika_ast_DocumentFragment$$anon$1() {
}
$h_Llaika_ast_DocumentFragment$$anon$1.prototype = $c_Llaika_ast_DocumentFragment$$anon$1.prototype;
$c_Llaika_ast_DocumentFragment$$anon$1.prototype.isDefinedAt__Llaika_ast_Element__Z = (function(x) {
  return ((x instanceof $c_Llaika_ast_DocumentFragment) && ($as_Llaika_ast_DocumentFragment(x), true));
});
$c_Llaika_ast_DocumentFragment$$anon$1.prototype.applyOrElse__Llaika_ast_Element__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Llaika_ast_DocumentFragment)) {
    var f = $as_Llaika_ast_DocumentFragment(x);
    return f;
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_ast_DocumentFragment$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Element__Z($as_Llaika_ast_Element(x));
});
$c_Llaika_ast_DocumentFragment$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Element__F1__O($as_Llaika_ast_Element(x), default$1);
});
var $d_Llaika_ast_DocumentFragment$$anon$1 = new $TypeData().initClass($c_Llaika_ast_DocumentFragment$$anon$1, "laika.ast.DocumentFragment$$anon$1", ({
  Llaika_ast_DocumentFragment$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_DocumentTree$$anon$6(localName$7) {
  this.Llaika_ast_DocumentTree$$anon$6__f_localName$1 = null;
  this.Llaika_ast_DocumentTree$$anon$6__f_localName$1 = localName$7;
}
$c_Llaika_ast_DocumentTree$$anon$6.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_ast_DocumentTree$$anon$6.prototype.constructor = $c_Llaika_ast_DocumentTree$$anon$6;
/** @constructor */
function $h_Llaika_ast_DocumentTree$$anon$6() {
}
$h_Llaika_ast_DocumentTree$$anon$6.prototype = $c_Llaika_ast_DocumentTree$$anon$6.prototype;
$c_Llaika_ast_DocumentTree$$anon$6.prototype.isDefinedAt__Llaika_ast_TreeContent__Z = (function(x) {
  if ((x instanceof $c_Llaika_ast_Document)) {
    var d = $as_Llaika_ast_Document(x);
    if (($n($n(d).path__Llaika_ast_Path()).name__T() === this.Llaika_ast_DocumentTree$$anon$6__f_localName$1)) {
      return true;
    }
  }
  return false;
});
$c_Llaika_ast_DocumentTree$$anon$6.prototype.applyOrElse__Llaika_ast_TreeContent__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Llaika_ast_Document)) {
    var d = $as_Llaika_ast_Document(x);
    if (($n($n(d).path__Llaika_ast_Path()).name__T() === this.Llaika_ast_DocumentTree$$anon$6__f_localName$1)) {
      return d;
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_ast_DocumentTree$$anon$6.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_TreeContent__Z($as_Llaika_ast_TreeContent(x));
});
$c_Llaika_ast_DocumentTree$$anon$6.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_TreeContent__F1__O($as_Llaika_ast_TreeContent(x), default$1);
});
var $d_Llaika_ast_DocumentTree$$anon$6 = new $TypeData().initClass($c_Llaika_ast_DocumentTree$$anon$6, "laika.ast.DocumentTree$$anon$6", ({
  Llaika_ast_DocumentTree$$anon$6: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_DocumentTree$$anon$7(localName$8) {
  this.Llaika_ast_DocumentTree$$anon$7__f_localName$5 = null;
  this.Llaika_ast_DocumentTree$$anon$7__f_localName$5 = localName$8;
}
$c_Llaika_ast_DocumentTree$$anon$7.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_ast_DocumentTree$$anon$7.prototype.constructor = $c_Llaika_ast_DocumentTree$$anon$7;
/** @constructor */
function $h_Llaika_ast_DocumentTree$$anon$7() {
}
$h_Llaika_ast_DocumentTree$$anon$7.prototype = $c_Llaika_ast_DocumentTree$$anon$7.prototype;
$c_Llaika_ast_DocumentTree$$anon$7.prototype.isDefinedAt__Llaika_ast_TreeContent__Z = (function(x) {
  if ((x instanceof $c_Llaika_ast_DocumentTree)) {
    var t = $as_Llaika_ast_DocumentTree(x);
    if (($n($n(t).path__Llaika_ast_Path()).name__T() === this.Llaika_ast_DocumentTree$$anon$7__f_localName$5)) {
      return true;
    }
  }
  return false;
});
$c_Llaika_ast_DocumentTree$$anon$7.prototype.applyOrElse__Llaika_ast_TreeContent__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Llaika_ast_DocumentTree)) {
    var t = $as_Llaika_ast_DocumentTree(x);
    if (($n($n(t).path__Llaika_ast_Path()).name__T() === this.Llaika_ast_DocumentTree$$anon$7__f_localName$5)) {
      return t;
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_ast_DocumentTree$$anon$7.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_TreeContent__Z($as_Llaika_ast_TreeContent(x));
});
$c_Llaika_ast_DocumentTree$$anon$7.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_TreeContent__F1__O($as_Llaika_ast_TreeContent(x), default$1);
});
var $d_Llaika_ast_DocumentTree$$anon$7 = new $TypeData().initClass($c_Llaika_ast_DocumentTree$$anon$7, "laika.ast.DocumentTree$$anon$7", ({
  Llaika_ast_DocumentTree$$anon$7: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_DocumentTreeBuilder$$anon$1(docName$3) {
  this.Llaika_ast_DocumentTreeBuilder$$anon$1__f_docName$1 = null;
  this.Llaika_ast_DocumentTreeBuilder$$anon$1__f_docName$1 = docName$3;
}
$c_Llaika_ast_DocumentTreeBuilder$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_ast_DocumentTreeBuilder$$anon$1.prototype.constructor = $c_Llaika_ast_DocumentTreeBuilder$$anon$1;
/** @constructor */
function $h_Llaika_ast_DocumentTreeBuilder$$anon$1() {
}
$h_Llaika_ast_DocumentTreeBuilder$$anon$1.prototype = $c_Llaika_ast_DocumentTreeBuilder$$anon$1.prototype;
$c_Llaika_ast_DocumentTreeBuilder$$anon$1.prototype.isDefinedAt__Llaika_ast_TreeContent__Z = (function(x) {
  if ((x instanceof $c_Llaika_ast_Document)) {
    var d = $as_Llaika_ast_Document(x);
    if (($n($n(d).path__Llaika_ast_Path()).basename__T() === this.Llaika_ast_DocumentTreeBuilder$$anon$1__f_docName$1)) {
      return true;
    }
  }
  return false;
});
$c_Llaika_ast_DocumentTreeBuilder$$anon$1.prototype.applyOrElse__Llaika_ast_TreeContent__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Llaika_ast_Document)) {
    var d = $as_Llaika_ast_Document(x);
    if (($n($n(d).path__Llaika_ast_Path()).basename__T() === this.Llaika_ast_DocumentTreeBuilder$$anon$1__f_docName$1)) {
      return d;
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_ast_DocumentTreeBuilder$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_TreeContent__Z($as_Llaika_ast_TreeContent(x));
});
$c_Llaika_ast_DocumentTreeBuilder$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_TreeContent__F1__O($as_Llaika_ast_TreeContent(x), default$1);
});
var $d_Llaika_ast_DocumentTreeBuilder$$anon$1 = new $TypeData().initClass($c_Llaika_ast_DocumentTreeBuilder$$anon$1, "laika.ast.DocumentTreeBuilder$$anon$1", ({
  Llaika_ast_DocumentTreeBuilder$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_DocumentTreeBuilder$$anon$2() {
}
$c_Llaika_ast_DocumentTreeBuilder$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_ast_DocumentTreeBuilder$$anon$2.prototype.constructor = $c_Llaika_ast_DocumentTreeBuilder$$anon$2;
/** @constructor */
function $h_Llaika_ast_DocumentTreeBuilder$$anon$2() {
}
$h_Llaika_ast_DocumentTreeBuilder$$anon$2.prototype = $c_Llaika_ast_DocumentTreeBuilder$$anon$2.prototype;
$c_Llaika_ast_DocumentTreeBuilder$$anon$2.prototype.isDefinedAt__Llaika_ast_DocumentTreeBuilder$BuilderPart__Z = (function(x) {
  return ((x instanceof $c_Llaika_ast_DocumentTreeBuilder$TreePart) ? ($as_Llaika_ast_DocumentTreeBuilder$TreePart(x), true) : (false ? ($as_Llaika_ast_DocumentTreeBuilder$MarkupPart(x), true) : ((x instanceof $c_Llaika_ast_DocumentTreeBuilder$DocumentPart) && ($as_Llaika_ast_DocumentTreeBuilder$DocumentPart(x), true))));
});
$c_Llaika_ast_DocumentTreeBuilder$$anon$2.prototype.applyOrElse__Llaika_ast_DocumentTreeBuilder$BuilderPart__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Llaika_ast_DocumentTreeBuilder$TreePart)) {
    var tree = $as_Llaika_ast_DocumentTreeBuilder$TreePart(x);
    return tree;
  } else if (false) {
    var markup = $as_Llaika_ast_DocumentTreeBuilder$MarkupPart(x);
    return markup;
  } else if ((x instanceof $c_Llaika_ast_DocumentTreeBuilder$DocumentPart)) {
    var doc = $as_Llaika_ast_DocumentTreeBuilder$DocumentPart(x);
    return doc;
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_ast_DocumentTreeBuilder$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_DocumentTreeBuilder$BuilderPart__Z($as_Llaika_ast_DocumentTreeBuilder$BuilderPart(x));
});
$c_Llaika_ast_DocumentTreeBuilder$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_DocumentTreeBuilder$BuilderPart__F1__O($as_Llaika_ast_DocumentTreeBuilder$BuilderPart(x), default$1);
});
var $d_Llaika_ast_DocumentTreeBuilder$$anon$2 = new $TypeData().initClass($c_Llaika_ast_DocumentTreeBuilder$$anon$2, "laika.ast.DocumentTreeBuilder$$anon$2", ({
  Llaika_ast_DocumentTreeBuilder$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_DocumentTreeBuilder$$anon$3() {
}
$c_Llaika_ast_DocumentTreeBuilder$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_ast_DocumentTreeBuilder$$anon$3.prototype.constructor = $c_Llaika_ast_DocumentTreeBuilder$$anon$3;
/** @constructor */
function $h_Llaika_ast_DocumentTreeBuilder$$anon$3() {
}
$h_Llaika_ast_DocumentTreeBuilder$$anon$3.prototype = $c_Llaika_ast_DocumentTreeBuilder$$anon$3.prototype;
$c_Llaika_ast_DocumentTreeBuilder$$anon$3.prototype.isDefinedAt__Llaika_ast_DocumentTreeBuilder$BuilderPart__Z = (function(x) {
  if (false) {
    var x$1 = $as_Llaika_ast_DocumentTreeBuilder$TemplatePart(x);
    $n(x$1)._1__Llaika_ast_TemplateDocument();
    return true;
  } else {
    return false;
  }
});
$c_Llaika_ast_DocumentTreeBuilder$$anon$3.prototype.applyOrElse__Llaika_ast_DocumentTreeBuilder$BuilderPart__F1__O = (function(x, default$1) {
  if (false) {
    var x$1 = $as_Llaika_ast_DocumentTreeBuilder$TemplatePart(x);
    var x20 = $n(x$1)._1__Llaika_ast_TemplateDocument();
    return x20;
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_ast_DocumentTreeBuilder$$anon$3.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_DocumentTreeBuilder$BuilderPart__Z($as_Llaika_ast_DocumentTreeBuilder$BuilderPart(x));
});
$c_Llaika_ast_DocumentTreeBuilder$$anon$3.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_DocumentTreeBuilder$BuilderPart__F1__O($as_Llaika_ast_DocumentTreeBuilder$BuilderPart(x), default$1);
});
var $d_Llaika_ast_DocumentTreeBuilder$$anon$3 = new $TypeData().initClass($c_Llaika_ast_DocumentTreeBuilder$$anon$3, "laika.ast.DocumentTreeBuilder$$anon$3", ({
  Llaika_ast_DocumentTreeBuilder$$anon$3: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_DocumentTreeBuilder$$anon$4() {
}
$c_Llaika_ast_DocumentTreeBuilder$$anon$4.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_ast_DocumentTreeBuilder$$anon$4.prototype.constructor = $c_Llaika_ast_DocumentTreeBuilder$$anon$4;
/** @constructor */
function $h_Llaika_ast_DocumentTreeBuilder$$anon$4() {
}
$h_Llaika_ast_DocumentTreeBuilder$$anon$4.prototype = $c_Llaika_ast_DocumentTreeBuilder$$anon$4.prototype;
$c_Llaika_ast_DocumentTreeBuilder$$anon$4.prototype.isDefinedAt__Llaika_ast_DocumentTreeBuilder$BuilderPart__Z = (function(x) {
  return (false && ($as_Llaika_ast_DocumentTreeBuilder$HoconPart(x), true));
});
$c_Llaika_ast_DocumentTreeBuilder$$anon$4.prototype.applyOrElse__Llaika_ast_DocumentTreeBuilder$BuilderPart__F1__O = (function(x, default$1) {
  if (false) {
    var c = $as_Llaika_ast_DocumentTreeBuilder$HoconPart(x);
    return c;
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_ast_DocumentTreeBuilder$$anon$4.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_DocumentTreeBuilder$BuilderPart__Z($as_Llaika_ast_DocumentTreeBuilder$BuilderPart(x));
});
$c_Llaika_ast_DocumentTreeBuilder$$anon$4.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_DocumentTreeBuilder$BuilderPart__F1__O($as_Llaika_ast_DocumentTreeBuilder$BuilderPart(x), default$1);
});
var $d_Llaika_ast_DocumentTreeBuilder$$anon$4 = new $TypeData().initClass($c_Llaika_ast_DocumentTreeBuilder$$anon$4, "laika.ast.DocumentTreeBuilder$$anon$4", ({
  Llaika_ast_DocumentTreeBuilder$$anon$4: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_DocumentTreeBuilder$$anon$5() {
}
$c_Llaika_ast_DocumentTreeBuilder$$anon$5.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_ast_DocumentTreeBuilder$$anon$5.prototype.constructor = $c_Llaika_ast_DocumentTreeBuilder$$anon$5;
/** @constructor */
function $h_Llaika_ast_DocumentTreeBuilder$$anon$5() {
}
$h_Llaika_ast_DocumentTreeBuilder$$anon$5.prototype = $c_Llaika_ast_DocumentTreeBuilder$$anon$5.prototype;
$c_Llaika_ast_DocumentTreeBuilder$$anon$5.prototype.isDefinedAt__Llaika_ast_DocumentTreeBuilder$BuilderPart__Z = (function(x) {
  return (false && ($as_Llaika_ast_DocumentTreeBuilder$ConfigPart(x), true));
});
$c_Llaika_ast_DocumentTreeBuilder$$anon$5.prototype.applyOrElse__Llaika_ast_DocumentTreeBuilder$BuilderPart__F1__O = (function(x, default$1) {
  if (false) {
    var c = $as_Llaika_ast_DocumentTreeBuilder$ConfigPart(x);
    return c;
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_ast_DocumentTreeBuilder$$anon$5.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_DocumentTreeBuilder$BuilderPart__Z($as_Llaika_ast_DocumentTreeBuilder$BuilderPart(x));
});
$c_Llaika_ast_DocumentTreeBuilder$$anon$5.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_DocumentTreeBuilder$BuilderPart__F1__O($as_Llaika_ast_DocumentTreeBuilder$BuilderPart(x), default$1);
});
var $d_Llaika_ast_DocumentTreeBuilder$$anon$5 = new $TypeData().initClass($c_Llaika_ast_DocumentTreeBuilder$$anon$5, "laika.ast.DocumentTreeBuilder$$anon$5", ({
  Llaika_ast_DocumentTreeBuilder$$anon$5: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_DocumentType$Static(formats) {
  this.Llaika_ast_DocumentType$Static__f_formats = null;
  this.Llaika_ast_DocumentType$Static__f_formats = formats;
}
$c_Llaika_ast_DocumentType$Static.prototype = new $h_Llaika_ast_DocumentType();
$c_Llaika_ast_DocumentType$Static.prototype.constructor = $c_Llaika_ast_DocumentType$Static;
/** @constructor */
function $h_Llaika_ast_DocumentType$Static() {
}
$h_Llaika_ast_DocumentType$Static.prototype = $c_Llaika_ast_DocumentType$Static.prototype;
$c_Llaika_ast_DocumentType$Static.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_DocumentType$Static.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_DocumentType$Static)) {
    var x$0$2 = $as_Llaika_ast_DocumentType$Static(x$0);
    var x = this.Llaika_ast_DocumentType$Static__f_formats;
    var x$2 = $n(x$0$2).Llaika_ast_DocumentType$Static__f_formats;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_DocumentType$Static.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_DocumentType$Static.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_ast_DocumentType$Static.prototype.productPrefix__T = (function() {
  return "Static";
});
$c_Llaika_ast_DocumentType$Static.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_DocumentType$Static__f_formats;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_ast_DocumentType$Static(obj) {
  return (((obj instanceof $c_Llaika_ast_DocumentType$Static) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.DocumentType$Static"));
}
function $isArrayOf_Llaika_ast_DocumentType$Static(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_DocumentType$Static)));
}
function $asArrayOf_Llaika_ast_DocumentType$Static(obj, depth) {
  return (($isArrayOf_Llaika_ast_DocumentType$Static(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.DocumentType$Static;", depth));
}
var $d_Llaika_ast_DocumentType$Static = new $TypeData().initClass($c_Llaika_ast_DocumentType$Static, "laika.ast.DocumentType$Static", ({
  Llaika_ast_DocumentType$Static: 1,
  Llaika_ast_DocumentType: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_ExternalTarget(url) {
  this.Llaika_ast_ExternalTarget__f_url = null;
  this.Llaika_ast_ExternalTarget__f_url = url;
}
$c_Llaika_ast_ExternalTarget.prototype = new $h_O();
$c_Llaika_ast_ExternalTarget.prototype.constructor = $c_Llaika_ast_ExternalTarget;
/** @constructor */
function $h_Llaika_ast_ExternalTarget() {
}
$h_Llaika_ast_ExternalTarget.prototype = $c_Llaika_ast_ExternalTarget.prototype;
$c_Llaika_ast_ExternalTarget.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_ExternalTarget.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_ExternalTarget.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_ExternalTarget)) {
    var x$0$2 = $as_Llaika_ast_ExternalTarget(x$0);
    return ((this.Llaika_ast_ExternalTarget__f_url === $n(x$0$2).Llaika_ast_ExternalTarget__f_url) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Llaika_ast_ExternalTarget.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_ExternalTarget.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_ast_ExternalTarget.prototype.productPrefix__T = (function() {
  return "ExternalTarget";
});
$c_Llaika_ast_ExternalTarget.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_ExternalTarget__f_url;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_ExternalTarget.prototype.render__Z__T = (function(internalTargetsAbsolute) {
  return this.Llaika_ast_ExternalTarget__f_url;
});
$c_Llaika_ast_ExternalTarget.prototype.render$default$1__Z = (function() {
  return false;
});
function $as_Llaika_ast_ExternalTarget(obj) {
  return (((obj instanceof $c_Llaika_ast_ExternalTarget) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.ExternalTarget"));
}
function $isArrayOf_Llaika_ast_ExternalTarget(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_ExternalTarget)));
}
function $asArrayOf_Llaika_ast_ExternalTarget(obj, depth) {
  return (($isArrayOf_Llaika_ast_ExternalTarget(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.ExternalTarget;", depth));
}
var $d_Llaika_ast_ExternalTarget = new $TypeData().initClass($c_Llaika_ast_ExternalTarget, "laika.ast.ExternalTarget", ({
  Llaika_ast_ExternalTarget: 1,
  Llaika_ast_Target: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $as_Llaika_ast_FootnoteLabel$AutonumberLabel(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.FootnoteLabel$AutonumberLabel"));
}
function $isArrayOf_Llaika_ast_FootnoteLabel$AutonumberLabel(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_FootnoteLabel$AutonumberLabel)));
}
function $asArrayOf_Llaika_ast_FootnoteLabel$AutonumberLabel(obj, depth) {
  return (($isArrayOf_Llaika_ast_FootnoteLabel$AutonumberLabel(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.FootnoteLabel$AutonumberLabel;", depth));
}
function $as_Llaika_ast_FootnoteLabel$NumericLabel(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.FootnoteLabel$NumericLabel"));
}
function $isArrayOf_Llaika_ast_FootnoteLabel$NumericLabel(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_FootnoteLabel$NumericLabel)));
}
function $asArrayOf_Llaika_ast_FootnoteLabel$NumericLabel(obj, depth) {
  return (($isArrayOf_Llaika_ast_FootnoteLabel$NumericLabel(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.FootnoteLabel$NumericLabel;", depth));
}
function $ct_Llaika_ast_MessageLevel__I__($thiz, level) {
  $thiz.Llaika_ast_MessageLevel__f_level = level;
  var this$1 = $n($thiz.productPrefix__T());
  $thiz.Llaika_ast_MessageLevel__f_toString = $as_T(this$1.toLowerCase());
  return $thiz;
}
/** @constructor */
function $c_Llaika_ast_MessageLevel() {
  this.Llaika_ast_MessageLevel__f_level = 0;
  this.Llaika_ast_MessageLevel__f_toString = null;
}
$c_Llaika_ast_MessageLevel.prototype = new $h_O();
$c_Llaika_ast_MessageLevel.prototype.constructor = $c_Llaika_ast_MessageLevel;
/** @constructor */
function $h_Llaika_ast_MessageLevel() {
}
$h_Llaika_ast_MessageLevel.prototype = $c_Llaika_ast_MessageLevel.prototype;
$c_Llaika_ast_MessageLevel.prototype.compareTo__O__I = (function(that) {
  return this.compare__Llaika_ast_MessageLevel__I($as_Llaika_ast_MessageLevel(that));
});
$c_Llaika_ast_MessageLevel.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_MessageLevel.prototype.compare__Llaika_ast_MessageLevel__I = (function(that) {
  var x = this.Llaika_ast_MessageLevel__f_level;
  var this$2 = new $c_sr_RichInt(x);
  var y = $n(that).Llaika_ast_MessageLevel__f_level;
  $m_s_math_Ordering$Int$();
  var x$1 = this$2.sr_RichInt__f_self;
  return ((x$1 === y) ? 0 : ((x$1 < y) ? (-1) : 1));
});
$c_Llaika_ast_MessageLevel.prototype.toString__T = (function() {
  return this.Llaika_ast_MessageLevel__f_toString;
});
$c_Llaika_ast_MessageLevel.prototype.compare__O__I = (function(that) {
  return this.compare__Llaika_ast_MessageLevel__I($as_Llaika_ast_MessageLevel(that));
});
function $as_Llaika_ast_MessageLevel(obj) {
  return (((obj instanceof $c_Llaika_ast_MessageLevel) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.MessageLevel"));
}
function $isArrayOf_Llaika_ast_MessageLevel(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_MessageLevel)));
}
function $asArrayOf_Llaika_ast_MessageLevel(obj, depth) {
  return (($isArrayOf_Llaika_ast_MessageLevel(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.MessageLevel;", depth));
}
/** @constructor */
function $c_Llaika_ast_NavigationBuilderContext$Impl(refPath, itemStyles, maxLevels, currentLevel, excludeSections, excludeSelf) {
  this.Llaika_ast_NavigationBuilderContext__f_isComplete = false;
  this.Llaika_ast_NavigationBuilderContext$Impl__f_refPath = null;
  this.Llaika_ast_NavigationBuilderContext$Impl__f_itemStyles = null;
  this.Llaika_ast_NavigationBuilderContext$Impl__f_maxLevels = 0;
  this.Llaika_ast_NavigationBuilderContext$Impl__f_currentLevel = 0;
  this.Llaika_ast_NavigationBuilderContext$Impl__f_excludeSections = false;
  this.Llaika_ast_NavigationBuilderContext$Impl__f_excludeSelf = false;
  this.Llaika_ast_NavigationBuilderContext$Impl__f_nextLevel$lzy1 = null;
  this.Llaika_ast_NavigationBuilderContext$Impl__f_nextLevelbitmap$1 = false;
  this.Llaika_ast_NavigationBuilderContext$Impl__f_refPath = refPath;
  this.Llaika_ast_NavigationBuilderContext$Impl__f_itemStyles = itemStyles;
  this.Llaika_ast_NavigationBuilderContext$Impl__f_maxLevels = maxLevels;
  this.Llaika_ast_NavigationBuilderContext$Impl__f_currentLevel = currentLevel;
  this.Llaika_ast_NavigationBuilderContext$Impl__f_excludeSections = excludeSections;
  this.Llaika_ast_NavigationBuilderContext$Impl__f_excludeSelf = excludeSelf;
  $ct_Llaika_ast_NavigationBuilderContext__(this);
}
$c_Llaika_ast_NavigationBuilderContext$Impl.prototype = new $h_Llaika_ast_NavigationBuilderContext();
$c_Llaika_ast_NavigationBuilderContext$Impl.prototype.constructor = $c_Llaika_ast_NavigationBuilderContext$Impl;
/** @constructor */
function $h_Llaika_ast_NavigationBuilderContext$Impl() {
}
$h_Llaika_ast_NavigationBuilderContext$Impl.prototype = $c_Llaika_ast_NavigationBuilderContext$Impl.prototype;
$c_Llaika_ast_NavigationBuilderContext$Impl.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_NavigationBuilderContext$Impl.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("NavigationBuilderContext");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Llaika_ast_NavigationBuilderContext$Impl__f_refPath;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Llaika_ast_NavigationBuilderContext$Impl__f_itemStyles;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Llaika_ast_NavigationBuilderContext$Impl__f_maxLevels;
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = this.Llaika_ast_NavigationBuilderContext$Impl__f_currentLevel;
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var data$5 = (this.Llaika_ast_NavigationBuilderContext$Impl__f_excludeSections ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var data$6 = (this.Llaika_ast_NavigationBuilderContext$Impl__f_excludeSelf ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$7, 6);
});
$c_Llaika_ast_NavigationBuilderContext$Impl.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_NavigationBuilderContext$Impl)) {
    var x$0$2 = $as_Llaika_ast_NavigationBuilderContext$Impl(x$0);
    if (((((this.Llaika_ast_NavigationBuilderContext$Impl__f_maxLevels === $n(x$0$2).Llaika_ast_NavigationBuilderContext$Impl__f_maxLevels) && (this.Llaika_ast_NavigationBuilderContext$Impl__f_currentLevel === $n(x$0$2).Llaika_ast_NavigationBuilderContext$Impl__f_currentLevel)) && (this.Llaika_ast_NavigationBuilderContext$Impl__f_excludeSections === $n(x$0$2).Llaika_ast_NavigationBuilderContext$Impl__f_excludeSections)) && (this.Llaika_ast_NavigationBuilderContext$Impl__f_excludeSelf === $n(x$0$2).Llaika_ast_NavigationBuilderContext$Impl__f_excludeSelf))) {
      var x = this.Llaika_ast_NavigationBuilderContext$Impl__f_refPath;
      var x$2 = $n(x$0$2).Llaika_ast_NavigationBuilderContext$Impl__f_refPath;
      var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Llaika_ast_NavigationBuilderContext$Impl__f_itemStyles;
      var x$4 = $n(x$0$2).Llaika_ast_NavigationBuilderContext$Impl__f_itemStyles;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_NavigationBuilderContext$Impl.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_NavigationBuilderContext$Impl.prototype.productArity__I = (function() {
  return 6;
});
$c_Llaika_ast_NavigationBuilderContext$Impl.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_NavigationBuilderContext$Impl__f_refPath;
      break;
    }
    case 1: {
      return this.Llaika_ast_NavigationBuilderContext$Impl__f_itemStyles;
      break;
    }
    case 2: {
      return this.Llaika_ast_NavigationBuilderContext$Impl__f_maxLevels;
      break;
    }
    case 3: {
      return this.Llaika_ast_NavigationBuilderContext$Impl__f_currentLevel;
      break;
    }
    case 4: {
      return this.Llaika_ast_NavigationBuilderContext$Impl__f_excludeSections;
      break;
    }
    case 5: {
      return this.Llaika_ast_NavigationBuilderContext$Impl__f_excludeSelf;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_NavigationBuilderContext$Impl.prototype.productPrefix__T = (function() {
  return "NavigationBuilderContext";
});
$c_Llaika_ast_NavigationBuilderContext$Impl.prototype.nextLevel__Llaika_ast_NavigationBuilderContext = (function() {
  if ((!this.Llaika_ast_NavigationBuilderContext$Impl__f_nextLevelbitmap$1)) {
    var currentLevel$1 = ((1 + this.Llaika_ast_NavigationBuilderContext$Impl__f_currentLevel) | 0);
    var refPath$1 = this.Llaika_ast_NavigationBuilderContext$Impl__f_refPath;
    var itemStyles$1 = this.Llaika_ast_NavigationBuilderContext$Impl__f_itemStyles;
    var maxLevels$1 = this.Llaika_ast_NavigationBuilderContext$Impl__f_maxLevels;
    var excludeSections$1 = this.Llaika_ast_NavigationBuilderContext$Impl__f_excludeSections;
    var excludeSelf$1 = this.Llaika_ast_NavigationBuilderContext$Impl__f_excludeSelf;
    this.Llaika_ast_NavigationBuilderContext$Impl__f_nextLevel$lzy1 = new $c_Llaika_ast_NavigationBuilderContext$Impl(refPath$1, itemStyles$1, maxLevels$1, currentLevel$1, excludeSections$1, excludeSelf$1);
    this.Llaika_ast_NavigationBuilderContext$Impl__f_nextLevelbitmap$1 = true;
  }
  return this.Llaika_ast_NavigationBuilderContext$Impl__f_nextLevel$lzy1;
});
$c_Llaika_ast_NavigationBuilderContext$Impl.prototype.withItemStyles__sci_Seq__Llaika_ast_NavigationBuilderContext = (function(itemStyles) {
  var this$1 = $n(itemStyles);
  var itemStyles$2 = $m_sci_Set$().from__sc_IterableOnce__sci_Set(this$1);
  var refPath$2 = this.Llaika_ast_NavigationBuilderContext$Impl__f_refPath;
  var maxLevels$2 = this.Llaika_ast_NavigationBuilderContext$Impl__f_maxLevels;
  var currentLevel$2 = this.Llaika_ast_NavigationBuilderContext$Impl__f_currentLevel;
  var excludeSections$2 = this.Llaika_ast_NavigationBuilderContext$Impl__f_excludeSections;
  var excludeSelf$2 = this.Llaika_ast_NavigationBuilderContext$Impl__f_excludeSelf;
  return new $c_Llaika_ast_NavigationBuilderContext$Impl(refPath$2, itemStyles$2, maxLevels$2, currentLevel$2, excludeSections$2, excludeSelf$2);
});
function $as_Llaika_ast_NavigationBuilderContext$Impl(obj) {
  return (((obj instanceof $c_Llaika_ast_NavigationBuilderContext$Impl) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.NavigationBuilderContext$Impl"));
}
function $isArrayOf_Llaika_ast_NavigationBuilderContext$Impl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_NavigationBuilderContext$Impl)));
}
function $asArrayOf_Llaika_ast_NavigationBuilderContext$Impl(obj, depth) {
  return (($isArrayOf_Llaika_ast_NavigationBuilderContext$Impl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.NavigationBuilderContext$Impl;", depth));
}
var $d_Llaika_ast_NavigationBuilderContext$Impl = new $TypeData().initClass($c_Llaika_ast_NavigationBuilderContext$Impl, "laika.ast.NavigationBuilderContext$Impl", ({
  Llaika_ast_NavigationBuilderContext$Impl: 1,
  Llaika_ast_NavigationBuilderContext: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_NavigationList$FormatFilter$$anon$3(cursor$2, outer) {
  this.Llaika_ast_NavigationList$FormatFilter$$anon$3__f_cursor$1 = null;
  this.Llaika_ast_NavigationList$FormatFilter$$anon$3__f_cursor$1 = cursor$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_ast_NavigationList$FormatFilter$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_ast_NavigationList$FormatFilter$$anon$3.prototype.constructor = $c_Llaika_ast_NavigationList$FormatFilter$$anon$3;
/** @constructor */
function $h_Llaika_ast_NavigationList$FormatFilter$$anon$3() {
}
$h_Llaika_ast_NavigationList$FormatFilter$$anon$3.prototype = $c_Llaika_ast_NavigationList$FormatFilter$$anon$3.prototype;
$c_Llaika_ast_NavigationList$FormatFilter$$anon$3.prototype.isDefinedAt__Llaika_ast_Block__Z = (function(x) {
  if ((x instanceof $c_Llaika_ast_NavigationList)) {
    var nl = $as_Llaika_ast_NavigationList(x);
    if ((!$n(nl).hasStyle__T__Z("breadcrumb"))) {
      return true;
    }
  }
  return false;
});
$c_Llaika_ast_NavigationList$FormatFilter$$anon$3.prototype.applyOrElse__Llaika_ast_Block__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Llaika_ast_NavigationList)) {
    var nl = $as_Llaika_ast_NavigationList(x);
    if ((!$n(nl).hasStyle__T__Z("breadcrumb"))) {
      var this$1 = $n($n($n(this.Llaika_ast_NavigationList$FormatFilter$$anon$3__f_cursor$1).root__Llaika_ast_RootCursor()).Llaika_ast_RootCursor__f_outputContext);
      if (this$1.isEmpty__Z()) {
        var newValue = nl;
      } else {
        var arg1 = this$1.get__O();
        var ctx = $as_Llaika_ast_OutputContext(arg1);
        var newValue = $n(nl).forFormat__T__Llaika_ast_NavigationList($n(ctx).Llaika_ast_OutputContext$Impl__f_formatSelector);
      }
      return new $c_Llaika_ast_RewriteAction$Replace(newValue);
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_ast_NavigationList$FormatFilter$$anon$3.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Block__Z($as_Llaika_ast_Block(x));
});
$c_Llaika_ast_NavigationList$FormatFilter$$anon$3.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Block__F1__O($as_Llaika_ast_Block(x), default$1);
});
var $d_Llaika_ast_NavigationList$FormatFilter$$anon$3 = new $TypeData().initClass($c_Llaika_ast_NavigationList$FormatFilter$$anon$3, "laika.ast.NavigationList$FormatFilter$$anon$3", ({
  Llaika_ast_NavigationList$FormatFilter$$anon$3: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_Options$Impl(id, styles) {
  this.Llaika_ast_Options$Impl__f_id = null;
  this.Llaika_ast_Options$Impl__f_styles = null;
  this.Llaika_ast_Options$Impl__f_id = id;
  this.Llaika_ast_Options$Impl__f_styles = styles;
}
$c_Llaika_ast_Options$Impl.prototype = new $h_Llaika_ast_Options();
$c_Llaika_ast_Options$Impl.prototype.constructor = $c_Llaika_ast_Options$Impl;
/** @constructor */
function $h_Llaika_ast_Options$Impl() {
}
$h_Llaika_ast_Options$Impl.prototype = $c_Llaika_ast_Options$Impl.prototype;
$c_Llaika_ast_Options$Impl.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_Options$Impl.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_Options$Impl.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_Options$Impl)) {
    var x$0$2 = $as_Llaika_ast_Options$Impl(x$0);
    var x = this.Llaika_ast_Options$Impl__f_id;
    var x$2 = $n(x$0$2).Llaika_ast_Options$Impl__f_id;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_Options$Impl__f_styles;
      var x$4 = $n(x$0$2).Llaika_ast_Options$Impl__f_styles;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_Options$Impl.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_Options$Impl.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_Options$Impl.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_Options$Impl__f_id;
  }
  if ((n === 1)) {
    return this.Llaika_ast_Options$Impl__f_styles;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_Options$Impl.prototype.productPrefix__T = (function() {
  return "Options";
});
$c_Llaika_ast_Options$Impl.prototype.isEmpty__Z = (function() {
  return ($n(this.Llaika_ast_Options$Impl__f_id).isEmpty__Z() && $n(this.Llaika_ast_Options$Impl__f_styles).isEmpty__Z());
});
$c_Llaika_ast_Options$Impl.prototype.$plus__Llaika_ast_Options__Llaika_ast_Options = (function(other) {
  var this$1 = $n($n(other).Llaika_ast_Options$Impl__f_id);
  var id = (this$1.isEmpty__Z() ? this.Llaika_ast_Options$Impl__f_id : this$1);
  var this$2 = $n(this.Llaika_ast_Options$Impl__f_styles);
  var that = $n(other).Llaika_ast_Options$Impl__f_styles;
  var styles = $as_sci_Set(this$2.concat__sc_IterableOnce__sc_SetOps(that));
  return new $c_Llaika_ast_Options$Impl(id, styles);
});
function $as_Llaika_ast_Options$Impl(obj) {
  return (((obj instanceof $c_Llaika_ast_Options$Impl) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Options$Impl"));
}
function $isArrayOf_Llaika_ast_Options$Impl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Options$Impl)));
}
function $asArrayOf_Llaika_ast_Options$Impl(obj, depth) {
  return (($isArrayOf_Llaika_ast_Options$Impl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Options$Impl;", depth));
}
var $d_Llaika_ast_Options$Impl = new $TypeData().initClass($c_Llaika_ast_Options$Impl, "laika.ast.Options$Impl", ({
  Llaika_ast_Options$Impl: 1,
  Llaika_ast_Options: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_OutputContext$Impl(fileSuffix, formatSelector) {
  this.Llaika_ast_OutputContext$Impl__f_fileSuffix = null;
  this.Llaika_ast_OutputContext$Impl__f_formatSelector = null;
  this.Llaika_ast_OutputContext$Impl__f_fileSuffix = fileSuffix;
  this.Llaika_ast_OutputContext$Impl__f_formatSelector = formatSelector;
}
$c_Llaika_ast_OutputContext$Impl.prototype = new $h_Llaika_ast_OutputContext();
$c_Llaika_ast_OutputContext$Impl.prototype.constructor = $c_Llaika_ast_OutputContext$Impl;
/** @constructor */
function $h_Llaika_ast_OutputContext$Impl() {
}
$h_Llaika_ast_OutputContext$Impl.prototype = $c_Llaika_ast_OutputContext$Impl.prototype;
$c_Llaika_ast_OutputContext$Impl.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_OutputContext$Impl.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_OutputContext$Impl.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_OutputContext$Impl)) {
    var x$0$2 = $as_Llaika_ast_OutputContext$Impl(x$0);
    return ((this.Llaika_ast_OutputContext$Impl__f_fileSuffix === $n(x$0$2).Llaika_ast_OutputContext$Impl__f_fileSuffix) && (this.Llaika_ast_OutputContext$Impl__f_formatSelector === $n(x$0$2).Llaika_ast_OutputContext$Impl__f_formatSelector));
  } else {
    return false;
  }
});
$c_Llaika_ast_OutputContext$Impl.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_OutputContext$Impl.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_OutputContext$Impl.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_OutputContext$Impl__f_fileSuffix;
  }
  if ((n === 1)) {
    return this.Llaika_ast_OutputContext$Impl__f_formatSelector;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_OutputContext$Impl.prototype.productPrefix__T = (function() {
  return "OutputContext";
});
function $as_Llaika_ast_OutputContext$Impl(obj) {
  return (((obj instanceof $c_Llaika_ast_OutputContext$Impl) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.OutputContext$Impl"));
}
function $isArrayOf_Llaika_ast_OutputContext$Impl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_OutputContext$Impl)));
}
function $asArrayOf_Llaika_ast_OutputContext$Impl(obj, depth) {
  return (($isArrayOf_Llaika_ast_OutputContext$Impl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.OutputContext$Impl;", depth));
}
var $d_Llaika_ast_OutputContext$Impl = new $TypeData().initClass($c_Llaika_ast_OutputContext$Impl, "laika.ast.OutputContext$Impl", ({
  Llaika_ast_OutputContext$Impl: 1,
  Llaika_ast_OutputContext: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_RewriteAction$Replace(newValue) {
  this.Llaika_ast_RewriteAction$Replace__f_newValue = null;
  this.Llaika_ast_RewriteAction$Replace__f_newValue = newValue;
}
$c_Llaika_ast_RewriteAction$Replace.prototype = new $h_O();
$c_Llaika_ast_RewriteAction$Replace.prototype.constructor = $c_Llaika_ast_RewriteAction$Replace;
/** @constructor */
function $h_Llaika_ast_RewriteAction$Replace() {
}
$h_Llaika_ast_RewriteAction$Replace.prototype = $c_Llaika_ast_RewriteAction$Replace.prototype;
$c_Llaika_ast_RewriteAction$Replace.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_RewriteAction$Replace.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_RewriteAction$Replace.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_RewriteAction$Replace)) {
    var x$0$2 = $as_Llaika_ast_RewriteAction$Replace(x$0);
    var x = this.Llaika_ast_RewriteAction$Replace__f_newValue;
    var y = $n(x$0$2).Llaika_ast_RewriteAction$Replace__f_newValue;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_RewriteAction$Replace.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_RewriteAction$Replace.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_ast_RewriteAction$Replace.prototype.productPrefix__T = (function() {
  return "Replace";
});
$c_Llaika_ast_RewriteAction$Replace.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_RewriteAction$Replace__f_newValue;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_ast_RewriteAction$Replace(obj) {
  return (((obj instanceof $c_Llaika_ast_RewriteAction$Replace) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.RewriteAction$Replace"));
}
function $isArrayOf_Llaika_ast_RewriteAction$Replace(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_RewriteAction$Replace)));
}
function $asArrayOf_Llaika_ast_RewriteAction$Replace(obj, depth) {
  return (($isArrayOf_Llaika_ast_RewriteAction$Replace(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.RewriteAction$Replace;", depth));
}
var $d_Llaika_ast_RewriteAction$Replace = new $TypeData().initClass($c_Llaika_ast_RewriteAction$Replace, "laika.ast.RewriteAction$Replace", ({
  Llaika_ast_RewriteAction$Replace: 1,
  Llaika_ast_RewriteAction: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_RewritePhase$Render(context) {
  this.Llaika_ast_RewritePhase$Render__f_context = null;
  this.Llaika_ast_RewritePhase$Render__f_context = context;
}
$c_Llaika_ast_RewritePhase$Render.prototype = new $h_O();
$c_Llaika_ast_RewritePhase$Render.prototype.constructor = $c_Llaika_ast_RewritePhase$Render;
/** @constructor */
function $h_Llaika_ast_RewritePhase$Render() {
}
$h_Llaika_ast_RewritePhase$Render.prototype = $c_Llaika_ast_RewritePhase$Render.prototype;
$c_Llaika_ast_RewritePhase$Render.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_RewritePhase$Render.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_RewritePhase$Render.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_RewritePhase$Render)) {
    var x$0$2 = $as_Llaika_ast_RewritePhase$Render(x$0);
    var x = this.Llaika_ast_RewritePhase$Render__f_context;
    var x$2 = $n(x$0$2).Llaika_ast_RewritePhase$Render__f_context;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_RewritePhase$Render.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_RewritePhase$Render.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_ast_RewritePhase$Render.prototype.productPrefix__T = (function() {
  return "Render";
});
$c_Llaika_ast_RewritePhase$Render.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_RewritePhase$Render__f_context;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_ast_RewritePhase$Render(obj) {
  return (((obj instanceof $c_Llaika_ast_RewritePhase$Render) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.RewritePhase$Render"));
}
function $isArrayOf_Llaika_ast_RewritePhase$Render(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_RewritePhase$Render)));
}
function $asArrayOf_Llaika_ast_RewritePhase$Render(obj, depth) {
  return (($isArrayOf_Llaika_ast_RewritePhase$Render(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.RewritePhase$Render;", depth));
}
var $d_Llaika_ast_RewritePhase$Render = new $TypeData().initClass($c_Llaika_ast_RewritePhase$Render, "laika.ast.RewritePhase$Render", ({
  Llaika_ast_RewritePhase$Render: 1,
  Llaika_ast_RewritePhase: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_RootElement$() {
}
$c_Llaika_ast_RootElement$.prototype = new $h_O();
$c_Llaika_ast_RootElement$.prototype.constructor = $c_Llaika_ast_RootElement$;
/** @constructor */
function $h_Llaika_ast_RootElement$() {
}
$h_Llaika_ast_RootElement$.prototype = $c_Llaika_ast_RootElement$.prototype;
$c_Llaika_ast_RootElement$.prototype.createSpanContainer__sci_Seq__O = (function(spans) {
  return $f_Llaika_ast_BlockContainerCompanion__createSpanContainer__sci_Seq__O(this, spans);
});
$c_Llaika_ast_RootElement$.prototype.createBlockContainer__sci_Seq__O = (function(blocks) {
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  return new $c_Llaika_ast_RootElement(blocks, options);
});
var $d_Llaika_ast_RootElement$ = new $TypeData().initClass($c_Llaika_ast_RootElement$, "laika.ast.RootElement$", ({
  Llaika_ast_RootElement$: 1,
  Llaika_ast_SpanContainerCompanion: 1,
  Llaika_ast_BlockContainerCompanion: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llaika_ast_RootElement$;
function $m_Llaika_ast_RootElement$() {
  if ((!$n_Llaika_ast_RootElement$)) {
    $n_Llaika_ast_RootElement$ = new $c_Llaika_ast_RootElement$();
  }
  return $n_Llaika_ast_RootElement$;
}
function $f_Llaika_ast_SpanContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_SpanContainer($thiz, rules) {
  var this$1 = $n(rules);
  var spans = $thiz.content__sci_Seq();
  return $thiz.withContent__sci_Seq__Llaika_ast_SpanContainer($p_Llaika_ast_RewriteRules__rewrite__F1__sci_Seq__sci_Seq(this$1, $p_Llaika_ast_RewriteRules__chainedSpanRules__F1(this$1), spans));
}
function $f_Llaika_ast_SpanContainer__extractText__T($thiz) {
  var this$2 = $n($as_sc_IterableOnceOps($n($thiz.content__sci_Seq()).map__F1__O(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Llaika_ast_Span(x$1);
    if ($is_Llaika_ast_TextContainer(x$1$1)) {
      var tc = $as_Llaika_ast_Span($as_Llaika_ast_TextContainer(x$1$1));
      return $as_T($n($as_Llaika_ast_Container(tc)).content__O());
    } else if ($is_Llaika_ast_SpanContainer(x$1$1)) {
      var sc = $as_Llaika_ast_Span($as_Llaika_ast_SpanContainer(x$1$1));
      var this$1 = $n($as_Llaika_ast_SpanContainer(sc));
      return $f_Llaika_ast_SpanContainer__extractText__T(this$1);
    } else {
      return "";
    }
  })))));
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$2, "", "", "");
}
function $is_Llaika_ast_SpanContainer(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_SpanContainer)));
}
function $as_Llaika_ast_SpanContainer(obj) {
  return (($is_Llaika_ast_SpanContainer(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.SpanContainer"));
}
function $isArrayOf_Llaika_ast_SpanContainer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_SpanContainer)));
}
function $asArrayOf_Llaika_ast_SpanContainer(obj, depth) {
  return (($isArrayOf_Llaika_ast_SpanContainer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.SpanContainer;", depth));
}
/** @constructor */
function $c_Llaika_ast_TargetValidation$InvalidTarget(message) {
  this.Llaika_ast_TargetValidation$InvalidTarget__f_message = null;
  this.Llaika_ast_TargetValidation$InvalidTarget__f_message = message;
}
$c_Llaika_ast_TargetValidation$InvalidTarget.prototype = new $h_O();
$c_Llaika_ast_TargetValidation$InvalidTarget.prototype.constructor = $c_Llaika_ast_TargetValidation$InvalidTarget;
/** @constructor */
function $h_Llaika_ast_TargetValidation$InvalidTarget() {
}
$h_Llaika_ast_TargetValidation$InvalidTarget.prototype = $c_Llaika_ast_TargetValidation$InvalidTarget.prototype;
$c_Llaika_ast_TargetValidation$InvalidTarget.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_TargetValidation$InvalidTarget.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_TargetValidation$InvalidTarget.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_TargetValidation$InvalidTarget)) {
    var x$0$2 = $as_Llaika_ast_TargetValidation$InvalidTarget(x$0);
    return ((this.Llaika_ast_TargetValidation$InvalidTarget__f_message === $n(x$0$2).Llaika_ast_TargetValidation$InvalidTarget__f_message) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Llaika_ast_TargetValidation$InvalidTarget.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_TargetValidation$InvalidTarget.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_ast_TargetValidation$InvalidTarget.prototype.productPrefix__T = (function() {
  return "InvalidTarget";
});
$c_Llaika_ast_TargetValidation$InvalidTarget.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_TargetValidation$InvalidTarget__f_message;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_ast_TargetValidation$InvalidTarget(obj) {
  return (((obj instanceof $c_Llaika_ast_TargetValidation$InvalidTarget) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.TargetValidation$InvalidTarget"));
}
function $isArrayOf_Llaika_ast_TargetValidation$InvalidTarget(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_TargetValidation$InvalidTarget)));
}
function $asArrayOf_Llaika_ast_TargetValidation$InvalidTarget(obj, depth) {
  return (($isArrayOf_Llaika_ast_TargetValidation$InvalidTarget(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.TargetValidation$InvalidTarget;", depth));
}
var $d_Llaika_ast_TargetValidation$InvalidTarget = new $TypeData().initClass($c_Llaika_ast_TargetValidation$InvalidTarget, "laika.ast.TargetValidation$InvalidTarget", ({
  Llaika_ast_TargetValidation$InvalidTarget: 1,
  Llaika_ast_TargetValidation: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_TargetValidation$RecoveredTarget(message, recoveredTarget) {
  this.Llaika_ast_TargetValidation$RecoveredTarget__f_message = null;
  this.Llaika_ast_TargetValidation$RecoveredTarget__f_recoveredTarget = null;
  this.Llaika_ast_TargetValidation$RecoveredTarget__f_message = message;
  this.Llaika_ast_TargetValidation$RecoveredTarget__f_recoveredTarget = recoveredTarget;
}
$c_Llaika_ast_TargetValidation$RecoveredTarget.prototype = new $h_O();
$c_Llaika_ast_TargetValidation$RecoveredTarget.prototype.constructor = $c_Llaika_ast_TargetValidation$RecoveredTarget;
/** @constructor */
function $h_Llaika_ast_TargetValidation$RecoveredTarget() {
}
$h_Llaika_ast_TargetValidation$RecoveredTarget.prototype = $c_Llaika_ast_TargetValidation$RecoveredTarget.prototype;
$c_Llaika_ast_TargetValidation$RecoveredTarget.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_TargetValidation$RecoveredTarget.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_TargetValidation$RecoveredTarget.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_TargetValidation$RecoveredTarget)) {
    var x$0$2 = $as_Llaika_ast_TargetValidation$RecoveredTarget(x$0);
    if ((this.Llaika_ast_TargetValidation$RecoveredTarget__f_message === $n(x$0$2).Llaika_ast_TargetValidation$RecoveredTarget__f_message)) {
      var x = this.Llaika_ast_TargetValidation$RecoveredTarget__f_recoveredTarget;
      var x$2 = $n(x$0$2).Llaika_ast_TargetValidation$RecoveredTarget__f_recoveredTarget;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_TargetValidation$RecoveredTarget.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_TargetValidation$RecoveredTarget.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_TargetValidation$RecoveredTarget.prototype.productPrefix__T = (function() {
  return "RecoveredTarget";
});
$c_Llaika_ast_TargetValidation$RecoveredTarget.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_TargetValidation$RecoveredTarget__f_message;
  }
  if ((n === 1)) {
    return this.Llaika_ast_TargetValidation$RecoveredTarget__f_recoveredTarget;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_ast_TargetValidation$RecoveredTarget(obj) {
  return (((obj instanceof $c_Llaika_ast_TargetValidation$RecoveredTarget) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.TargetValidation$RecoveredTarget"));
}
function $isArrayOf_Llaika_ast_TargetValidation$RecoveredTarget(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_TargetValidation$RecoveredTarget)));
}
function $asArrayOf_Llaika_ast_TargetValidation$RecoveredTarget(obj, depth) {
  return (($isArrayOf_Llaika_ast_TargetValidation$RecoveredTarget(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.TargetValidation$RecoveredTarget;", depth));
}
var $d_Llaika_ast_TargetValidation$RecoveredTarget = new $TypeData().initClass($c_Llaika_ast_TargetValidation$RecoveredTarget, "laika.ast.TargetValidation$RecoveredTarget", ({
  Llaika_ast_TargetValidation$RecoveredTarget: 1,
  Llaika_ast_TargetValidation: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $f_Llaika_ast_TemplateSpanContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_TemplateSpanContainer($thiz, rules) {
  var this$1 = $n(rules);
  var spans = $thiz.content__sci_Seq();
  return $thiz.withContent__sci_Seq__Llaika_ast_TemplateSpanContainer($p_Llaika_ast_RewriteRules__rewrite__F1__sci_Seq__sci_Seq(this$1, $p_Llaika_ast_RewriteRules__chainedTemplateRules__F1(this$1), spans));
}
function $is_Llaika_ast_TemplateSpanContainer(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_TemplateSpanContainer)));
}
function $as_Llaika_ast_TemplateSpanContainer(obj) {
  return (($is_Llaika_ast_TemplateSpanContainer(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.TemplateSpanContainer"));
}
function $isArrayOf_Llaika_ast_TemplateSpanContainer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_TemplateSpanContainer)));
}
function $asArrayOf_Llaika_ast_TemplateSpanContainer(obj, depth) {
  return (($isArrayOf_Llaika_ast_TemplateSpanContainer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.TemplateSpanContainer;", depth));
}
function $as_Llaika_ast_TreeNodeIndex$Value(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.TreeNodeIndex$Value"));
}
function $isArrayOf_Llaika_ast_TreeNodeIndex$Value(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_TreeNodeIndex$Value)));
}
function $asArrayOf_Llaika_ast_TreeNodeIndex$Value(obj, depth) {
  return (($isArrayOf_Llaika_ast_TreeNodeIndex$Value(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.TreeNodeIndex$Value;", depth));
}
/** @constructor */
function $c_Llaika_ast_styles_StylePredicate$ElementType(name) {
  this.Llaika_ast_styles_StylePredicate$ElementType__f_name = null;
  this.Llaika_ast_styles_StylePredicate$ElementType__f_name = name;
}
$c_Llaika_ast_styles_StylePredicate$ElementType.prototype = new $h_O();
$c_Llaika_ast_styles_StylePredicate$ElementType.prototype.constructor = $c_Llaika_ast_styles_StylePredicate$ElementType;
/** @constructor */
function $h_Llaika_ast_styles_StylePredicate$ElementType() {
}
$h_Llaika_ast_styles_StylePredicate$ElementType.prototype = $c_Llaika_ast_styles_StylePredicate$ElementType.prototype;
$c_Llaika_ast_styles_StylePredicate$ElementType.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_styles_StylePredicate$ElementType.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_styles_StylePredicate$ElementType.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_styles_StylePredicate$ElementType)) {
    var x$0$2 = $as_Llaika_ast_styles_StylePredicate$ElementType(x$0);
    return ((this.Llaika_ast_styles_StylePredicate$ElementType__f_name === $n(x$0$2).Llaika_ast_styles_StylePredicate$ElementType__f_name) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Llaika_ast_styles_StylePredicate$ElementType.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_styles_StylePredicate$ElementType.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_ast_styles_StylePredicate$ElementType.prototype.productPrefix__T = (function() {
  return "ElementType";
});
$c_Llaika_ast_styles_StylePredicate$ElementType.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_styles_StylePredicate$ElementType__f_name;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_ast_styles_StylePredicate$ElementType(obj) {
  return (((obj instanceof $c_Llaika_ast_styles_StylePredicate$ElementType) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.styles.StylePredicate$ElementType"));
}
function $isArrayOf_Llaika_ast_styles_StylePredicate$ElementType(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_styles_StylePredicate$ElementType)));
}
function $asArrayOf_Llaika_ast_styles_StylePredicate$ElementType(obj, depth) {
  return (($isArrayOf_Llaika_ast_styles_StylePredicate$ElementType(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.styles.StylePredicate$ElementType;", depth));
}
var $d_Llaika_ast_styles_StylePredicate$ElementType = new $TypeData().initClass($c_Llaika_ast_styles_StylePredicate$ElementType, "laika.ast.styles.StylePredicate$ElementType", ({
  Llaika_ast_styles_StylePredicate$ElementType: 1,
  Llaika_ast_styles_StylePredicate: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_styles_StylePredicate$Id(id) {
  this.Llaika_ast_styles_StylePredicate$Id__f_id = null;
  this.Llaika_ast_styles_StylePredicate$Id__f_id = id;
}
$c_Llaika_ast_styles_StylePredicate$Id.prototype = new $h_O();
$c_Llaika_ast_styles_StylePredicate$Id.prototype.constructor = $c_Llaika_ast_styles_StylePredicate$Id;
/** @constructor */
function $h_Llaika_ast_styles_StylePredicate$Id() {
}
$h_Llaika_ast_styles_StylePredicate$Id.prototype = $c_Llaika_ast_styles_StylePredicate$Id.prototype;
$c_Llaika_ast_styles_StylePredicate$Id.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_styles_StylePredicate$Id.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_styles_StylePredicate$Id.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_styles_StylePredicate$Id)) {
    var x$0$2 = $as_Llaika_ast_styles_StylePredicate$Id(x$0);
    return ((this.Llaika_ast_styles_StylePredicate$Id__f_id === $n(x$0$2).Llaika_ast_styles_StylePredicate$Id__f_id) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Llaika_ast_styles_StylePredicate$Id.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_styles_StylePredicate$Id.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_ast_styles_StylePredicate$Id.prototype.productPrefix__T = (function() {
  return "Id";
});
$c_Llaika_ast_styles_StylePredicate$Id.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_styles_StylePredicate$Id__f_id;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_ast_styles_StylePredicate$Id(obj) {
  return (((obj instanceof $c_Llaika_ast_styles_StylePredicate$Id) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.styles.StylePredicate$Id"));
}
function $isArrayOf_Llaika_ast_styles_StylePredicate$Id(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_styles_StylePredicate$Id)));
}
function $asArrayOf_Llaika_ast_styles_StylePredicate$Id(obj, depth) {
  return (($isArrayOf_Llaika_ast_styles_StylePredicate$Id(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.styles.StylePredicate$Id;", depth));
}
var $d_Llaika_ast_styles_StylePredicate$Id = new $TypeData().initClass($c_Llaika_ast_styles_StylePredicate$Id, "laika.ast.styles.StylePredicate$Id", ({
  Llaika_ast_styles_StylePredicate$Id: 1,
  Llaika_ast_styles_StylePredicate: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_styles_StylePredicate$StyleName(name) {
  this.Llaika_ast_styles_StylePredicate$StyleName__f_name = null;
  this.Llaika_ast_styles_StylePredicate$StyleName__f_name = name;
}
$c_Llaika_ast_styles_StylePredicate$StyleName.prototype = new $h_O();
$c_Llaika_ast_styles_StylePredicate$StyleName.prototype.constructor = $c_Llaika_ast_styles_StylePredicate$StyleName;
/** @constructor */
function $h_Llaika_ast_styles_StylePredicate$StyleName() {
}
$h_Llaika_ast_styles_StylePredicate$StyleName.prototype = $c_Llaika_ast_styles_StylePredicate$StyleName.prototype;
$c_Llaika_ast_styles_StylePredicate$StyleName.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_styles_StylePredicate$StyleName.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_styles_StylePredicate$StyleName.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_styles_StylePredicate$StyleName)) {
    var x$0$2 = $as_Llaika_ast_styles_StylePredicate$StyleName(x$0);
    return ((this.Llaika_ast_styles_StylePredicate$StyleName__f_name === $n(x$0$2).Llaika_ast_styles_StylePredicate$StyleName__f_name) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Llaika_ast_styles_StylePredicate$StyleName.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_styles_StylePredicate$StyleName.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_ast_styles_StylePredicate$StyleName.prototype.productPrefix__T = (function() {
  return "StyleName";
});
$c_Llaika_ast_styles_StylePredicate$StyleName.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_styles_StylePredicate$StyleName__f_name;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_ast_styles_StylePredicate$StyleName(obj) {
  return (((obj instanceof $c_Llaika_ast_styles_StylePredicate$StyleName) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.styles.StylePredicate$StyleName"));
}
function $isArrayOf_Llaika_ast_styles_StylePredicate$StyleName(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_styles_StylePredicate$StyleName)));
}
function $asArrayOf_Llaika_ast_styles_StylePredicate$StyleName(obj, depth) {
  return (($isArrayOf_Llaika_ast_styles_StylePredicate$StyleName(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.styles.StylePredicate$StyleName;", depth));
}
var $d_Llaika_ast_styles_StylePredicate$StyleName = new $TypeData().initClass($c_Llaika_ast_styles_StylePredicate$StyleName, "laika.ast.styles.StylePredicate$StyleName", ({
  Llaika_ast_styles_StylePredicate$StyleName: 1,
  Llaika_ast_styles_StylePredicate: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_config_ApiLinks$Impl(baseUri, packagePrefix, packageSummary) {
  this.Llaika_config_ApiLinks$Impl__f_baseUri = null;
  this.Llaika_config_ApiLinks$Impl__f_packagePrefix = null;
  this.Llaika_config_ApiLinks$Impl__f_packageSummary = null;
  this.Llaika_config_ApiLinks$Impl__f_baseUri = baseUri;
  this.Llaika_config_ApiLinks$Impl__f_packagePrefix = packagePrefix;
  this.Llaika_config_ApiLinks$Impl__f_packageSummary = packageSummary;
}
$c_Llaika_config_ApiLinks$Impl.prototype = new $h_Llaika_config_ApiLinks();
$c_Llaika_config_ApiLinks$Impl.prototype.constructor = $c_Llaika_config_ApiLinks$Impl;
/** @constructor */
function $h_Llaika_config_ApiLinks$Impl() {
}
$h_Llaika_config_ApiLinks$Impl.prototype = $c_Llaika_config_ApiLinks$Impl.prototype;
$c_Llaika_config_ApiLinks$Impl.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_config_ApiLinks$Impl.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_config_ApiLinks$Impl.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_config_ApiLinks$Impl)) {
    var x$0$2 = $as_Llaika_config_ApiLinks$Impl(x$0);
    return (((this.Llaika_config_ApiLinks$Impl__f_baseUri === $n(x$0$2).Llaika_config_ApiLinks$Impl__f_baseUri) && (this.Llaika_config_ApiLinks$Impl__f_packagePrefix === $n(x$0$2).Llaika_config_ApiLinks$Impl__f_packagePrefix)) && (this.Llaika_config_ApiLinks$Impl__f_packageSummary === $n(x$0$2).Llaika_config_ApiLinks$Impl__f_packageSummary));
  } else {
    return false;
  }
});
$c_Llaika_config_ApiLinks$Impl.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_config_ApiLinks$Impl.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_config_ApiLinks$Impl.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_config_ApiLinks$Impl__f_baseUri;
      break;
    }
    case 1: {
      return this.Llaika_config_ApiLinks$Impl__f_packagePrefix;
      break;
    }
    case 2: {
      return this.Llaika_config_ApiLinks$Impl__f_packageSummary;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_config_ApiLinks$Impl.prototype.productPrefix__T = (function() {
  return "ApiLinks";
});
function $as_Llaika_config_ApiLinks$Impl(obj) {
  return (((obj instanceof $c_Llaika_config_ApiLinks$Impl) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.ApiLinks$Impl"));
}
function $isArrayOf_Llaika_config_ApiLinks$Impl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_ApiLinks$Impl)));
}
function $asArrayOf_Llaika_config_ApiLinks$Impl(obj, depth) {
  return (($isArrayOf_Llaika_config_ApiLinks$Impl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.ApiLinks$Impl;", depth));
}
var $d_Llaika_config_ApiLinks$Impl = new $TypeData().initClass($c_Llaika_config_ApiLinks$Impl, "laika.config.ApiLinks$Impl", ({
  Llaika_config_ApiLinks$Impl: 1,
  Llaika_config_ApiLinks: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_config_AutonumberConfig$Impl(documents, sections, maxDepth) {
  this.Llaika_config_AutonumberConfig$Impl__f_documents = false;
  this.Llaika_config_AutonumberConfig$Impl__f_sections = false;
  this.Llaika_config_AutonumberConfig$Impl__f_maxDepth = 0;
  this.Llaika_config_AutonumberConfig$Impl__f_documents = documents;
  this.Llaika_config_AutonumberConfig$Impl__f_sections = sections;
  this.Llaika_config_AutonumberConfig$Impl__f_maxDepth = maxDepth;
}
$c_Llaika_config_AutonumberConfig$Impl.prototype = new $h_Llaika_config_AutonumberConfig();
$c_Llaika_config_AutonumberConfig$Impl.prototype.constructor = $c_Llaika_config_AutonumberConfig$Impl;
/** @constructor */
function $h_Llaika_config_AutonumberConfig$Impl() {
}
$h_Llaika_config_AutonumberConfig$Impl.prototype = $c_Llaika_config_AutonumberConfig$Impl.prototype;
$c_Llaika_config_AutonumberConfig$Impl.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_config_AutonumberConfig$Impl.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("AutonumberConfig");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Llaika_config_AutonumberConfig$Impl__f_documents ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Llaika_config_AutonumberConfig$Impl__f_sections ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Llaika_config_AutonumberConfig$Impl__f_maxDepth;
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Llaika_config_AutonumberConfig$Impl.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_config_AutonumberConfig$Impl)) {
    var x$0$2 = $as_Llaika_config_AutonumberConfig$Impl(x$0);
    return (((this.Llaika_config_AutonumberConfig$Impl__f_documents === $n(x$0$2).Llaika_config_AutonumberConfig$Impl__f_documents) && (this.Llaika_config_AutonumberConfig$Impl__f_sections === $n(x$0$2).Llaika_config_AutonumberConfig$Impl__f_sections)) && (this.Llaika_config_AutonumberConfig$Impl__f_maxDepth === $n(x$0$2).Llaika_config_AutonumberConfig$Impl__f_maxDepth));
  } else {
    return false;
  }
});
$c_Llaika_config_AutonumberConfig$Impl.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_config_AutonumberConfig$Impl.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_config_AutonumberConfig$Impl.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_config_AutonumberConfig$Impl__f_documents;
      break;
    }
    case 1: {
      return this.Llaika_config_AutonumberConfig$Impl__f_sections;
      break;
    }
    case 2: {
      return this.Llaika_config_AutonumberConfig$Impl__f_maxDepth;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_config_AutonumberConfig$Impl.prototype.productPrefix__T = (function() {
  return "AutonumberConfig";
});
function $as_Llaika_config_AutonumberConfig$Impl(obj) {
  return (((obj instanceof $c_Llaika_config_AutonumberConfig$Impl) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.AutonumberConfig$Impl"));
}
function $isArrayOf_Llaika_config_AutonumberConfig$Impl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_AutonumberConfig$Impl)));
}
function $asArrayOf_Llaika_config_AutonumberConfig$Impl(obj, depth) {
  return (($isArrayOf_Llaika_config_AutonumberConfig$Impl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.AutonumberConfig$Impl;", depth));
}
var $d_Llaika_config_AutonumberConfig$Impl = new $TypeData().initClass($c_Llaika_config_AutonumberConfig$Impl, "laika.config.AutonumberConfig$Impl", ({
  Llaika_config_AutonumberConfig$Impl: 1,
  Llaika_config_AutonumberConfig: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_config_ChoiceConfig$Impl(name, label, selected) {
  this.Llaika_config_ChoiceConfig$Impl__f_name = null;
  this.Llaika_config_ChoiceConfig$Impl__f_label = null;
  this.Llaika_config_ChoiceConfig$Impl__f_selected = false;
  this.Llaika_config_ChoiceConfig$Impl__f_name = name;
  this.Llaika_config_ChoiceConfig$Impl__f_label = label;
  this.Llaika_config_ChoiceConfig$Impl__f_selected = selected;
}
$c_Llaika_config_ChoiceConfig$Impl.prototype = new $h_Llaika_config_ChoiceConfig();
$c_Llaika_config_ChoiceConfig$Impl.prototype.constructor = $c_Llaika_config_ChoiceConfig$Impl;
/** @constructor */
function $h_Llaika_config_ChoiceConfig$Impl() {
}
$h_Llaika_config_ChoiceConfig$Impl.prototype = $c_Llaika_config_ChoiceConfig$Impl.prototype;
$c_Llaika_config_ChoiceConfig$Impl.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_config_ChoiceConfig$Impl.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("ChoiceConfig");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Llaika_config_ChoiceConfig$Impl__f_name;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Llaika_config_ChoiceConfig$Impl__f_label;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = (this.Llaika_config_ChoiceConfig$Impl__f_selected ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Llaika_config_ChoiceConfig$Impl.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_config_ChoiceConfig$Impl)) {
    var x$0$2 = $as_Llaika_config_ChoiceConfig$Impl(x$0);
    return (((this.Llaika_config_ChoiceConfig$Impl__f_selected === $n(x$0$2).Llaika_config_ChoiceConfig$Impl__f_selected) && (this.Llaika_config_ChoiceConfig$Impl__f_name === $n(x$0$2).Llaika_config_ChoiceConfig$Impl__f_name)) && (this.Llaika_config_ChoiceConfig$Impl__f_label === $n(x$0$2).Llaika_config_ChoiceConfig$Impl__f_label));
  } else {
    return false;
  }
});
$c_Llaika_config_ChoiceConfig$Impl.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_config_ChoiceConfig$Impl.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_config_ChoiceConfig$Impl.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_config_ChoiceConfig$Impl__f_name;
      break;
    }
    case 1: {
      return this.Llaika_config_ChoiceConfig$Impl__f_label;
      break;
    }
    case 2: {
      return this.Llaika_config_ChoiceConfig$Impl__f_selected;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_config_ChoiceConfig$Impl.prototype.productPrefix__T = (function() {
  return "ChoiceConfig";
});
function $as_Llaika_config_ChoiceConfig$Impl(obj) {
  return (((obj instanceof $c_Llaika_config_ChoiceConfig$Impl) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.ChoiceConfig$Impl"));
}
function $isArrayOf_Llaika_config_ChoiceConfig$Impl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_ChoiceConfig$Impl)));
}
function $asArrayOf_Llaika_config_ChoiceConfig$Impl(obj, depth) {
  return (($isArrayOf_Llaika_config_ChoiceConfig$Impl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.ChoiceConfig$Impl;", depth));
}
var $d_Llaika_config_ChoiceConfig$Impl = new $TypeData().initClass($c_Llaika_config_ChoiceConfig$Impl, "laika.config.ChoiceConfig$Impl", ({
  Llaika_config_ChoiceConfig$Impl: 1,
  Llaika_config_ChoiceConfig: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_config_LinkConfig$Impl(targets, apiLinks, sourceLinks) {
  this.Llaika_config_LinkConfig$Impl__f_targets = null;
  this.Llaika_config_LinkConfig$Impl__f_apiLinks = null;
  this.Llaika_config_LinkConfig$Impl__f_sourceLinks = null;
  this.Llaika_config_LinkConfig$Impl__f_targets = targets;
  this.Llaika_config_LinkConfig$Impl__f_apiLinks = apiLinks;
  this.Llaika_config_LinkConfig$Impl__f_sourceLinks = sourceLinks;
}
$c_Llaika_config_LinkConfig$Impl.prototype = new $h_Llaika_config_LinkConfig();
$c_Llaika_config_LinkConfig$Impl.prototype.constructor = $c_Llaika_config_LinkConfig$Impl;
/** @constructor */
function $h_Llaika_config_LinkConfig$Impl() {
}
$h_Llaika_config_LinkConfig$Impl.prototype = $c_Llaika_config_LinkConfig$Impl.prototype;
$c_Llaika_config_LinkConfig$Impl.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_config_LinkConfig$Impl.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_config_LinkConfig$Impl.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_config_LinkConfig$Impl)) {
    var x$0$2 = $as_Llaika_config_LinkConfig$Impl(x$0);
    var x = this.Llaika_config_LinkConfig$Impl__f_targets;
    var x$2 = $n(x$0$2).Llaika_config_LinkConfig$Impl__f_targets;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_config_LinkConfig$Impl__f_apiLinks;
      var x$4 = $n(x$0$2).Llaika_config_LinkConfig$Impl__f_apiLinks;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Llaika_config_LinkConfig$Impl__f_sourceLinks;
      var x$6 = $n(x$0$2).Llaika_config_LinkConfig$Impl__f_sourceLinks;
      return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_config_LinkConfig$Impl.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_config_LinkConfig$Impl.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_config_LinkConfig$Impl.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_config_LinkConfig$Impl__f_targets;
      break;
    }
    case 1: {
      return this.Llaika_config_LinkConfig$Impl__f_apiLinks;
      break;
    }
    case 2: {
      return this.Llaika_config_LinkConfig$Impl__f_sourceLinks;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_config_LinkConfig$Impl.prototype.productPrefix__T = (function() {
  return "LinkConfig";
});
function $as_Llaika_config_LinkConfig$Impl(obj) {
  return (((obj instanceof $c_Llaika_config_LinkConfig$Impl) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.LinkConfig$Impl"));
}
function $isArrayOf_Llaika_config_LinkConfig$Impl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_LinkConfig$Impl)));
}
function $asArrayOf_Llaika_config_LinkConfig$Impl(obj, depth) {
  return (($isArrayOf_Llaika_config_LinkConfig$Impl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.LinkConfig$Impl;", depth));
}
var $d_Llaika_config_LinkConfig$Impl = new $TypeData().initClass($c_Llaika_config_LinkConfig$Impl, "laika.config.LinkConfig$Impl", ({
  Llaika_config_LinkConfig$Impl: 1,
  Llaika_config_LinkConfig: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_config_LinkValidation$Global(excluded) {
  this.Llaika_config_LinkValidation$Global__f_excluded = null;
  this.Llaika_config_LinkValidation$Global__f_excluded = excluded;
}
$c_Llaika_config_LinkValidation$Global.prototype = new $h_O();
$c_Llaika_config_LinkValidation$Global.prototype.constructor = $c_Llaika_config_LinkValidation$Global;
/** @constructor */
function $h_Llaika_config_LinkValidation$Global() {
}
$h_Llaika_config_LinkValidation$Global.prototype = $c_Llaika_config_LinkValidation$Global.prototype;
$c_Llaika_config_LinkValidation$Global.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_config_LinkValidation$Global.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_config_LinkValidation$Global.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_config_LinkValidation$Global)) {
    var x$0$2 = $as_Llaika_config_LinkValidation$Global(x$0);
    var x = this.Llaika_config_LinkValidation$Global__f_excluded;
    var x$2 = $n(x$0$2).Llaika_config_LinkValidation$Global__f_excluded;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_config_LinkValidation$Global.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_config_LinkValidation$Global.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_config_LinkValidation$Global.prototype.productPrefix__T = (function() {
  return "Global";
});
$c_Llaika_config_LinkValidation$Global.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_config_LinkValidation$Global__f_excluded;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_config_LinkValidation$Global(obj) {
  return (((obj instanceof $c_Llaika_config_LinkValidation$Global) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.LinkValidation$Global"));
}
function $isArrayOf_Llaika_config_LinkValidation$Global(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_LinkValidation$Global)));
}
function $asArrayOf_Llaika_config_LinkValidation$Global(obj, depth) {
  return (($isArrayOf_Llaika_config_LinkValidation$Global(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.LinkValidation$Global;", depth));
}
var $d_Llaika_config_LinkValidation$Global = new $TypeData().initClass($c_Llaika_config_LinkValidation$Global, "laika.config.LinkValidation$Global", ({
  Llaika_config_LinkValidation$Global: 1,
  Llaika_config_LinkValidation: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_config_MessageFilters$Impl(failOn, render) {
  this.Llaika_config_MessageFilters$Impl__f_failOn = null;
  this.Llaika_config_MessageFilters$Impl__f_render = null;
  this.Llaika_config_MessageFilters$Impl__f_failOn = failOn;
  this.Llaika_config_MessageFilters$Impl__f_render = render;
}
$c_Llaika_config_MessageFilters$Impl.prototype = new $h_Llaika_config_MessageFilters();
$c_Llaika_config_MessageFilters$Impl.prototype.constructor = $c_Llaika_config_MessageFilters$Impl;
/** @constructor */
function $h_Llaika_config_MessageFilters$Impl() {
}
$h_Llaika_config_MessageFilters$Impl.prototype = $c_Llaika_config_MessageFilters$Impl.prototype;
$c_Llaika_config_MessageFilters$Impl.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_config_MessageFilters$Impl.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_config_MessageFilters$Impl.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_config_MessageFilters$Impl)) {
    var x$0$2 = $as_Llaika_config_MessageFilters$Impl(x$0);
    var x = this.Llaika_config_MessageFilters$Impl__f_failOn;
    var x$2 = $n(x$0$2).Llaika_config_MessageFilters$Impl__f_failOn;
    if ((x === null)) {
      var $x_1 = (x$2 === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === x$2);
    }
    if ($x_1) {
      var x$3 = this.Llaika_config_MessageFilters$Impl__f_render;
      var x$4 = $n(x$0$2).Llaika_config_MessageFilters$Impl__f_render;
      if ((x$3 === null)) {
        return (x$4 === null);
      } else {
        var this$2 = $n(x$3);
        return (this$2 === x$4);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_config_MessageFilters$Impl.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_config_MessageFilters$Impl.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_config_MessageFilters$Impl.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_config_MessageFilters$Impl__f_failOn;
  }
  if ((n === 1)) {
    return this.Llaika_config_MessageFilters$Impl__f_render;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_config_MessageFilters$Impl.prototype.productPrefix__T = (function() {
  return "MessageFilters";
});
function $as_Llaika_config_MessageFilters$Impl(obj) {
  return (((obj instanceof $c_Llaika_config_MessageFilters$Impl) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.MessageFilters$Impl"));
}
function $isArrayOf_Llaika_config_MessageFilters$Impl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_MessageFilters$Impl)));
}
function $asArrayOf_Llaika_config_MessageFilters$Impl(obj, depth) {
  return (($isArrayOf_Llaika_config_MessageFilters$Impl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.MessageFilters$Impl;", depth));
}
var $d_Llaika_config_MessageFilters$Impl = new $TypeData().initClass($c_Llaika_config_MessageFilters$Impl, "laika.config.MessageFilters$Impl", ({
  Llaika_config_MessageFilters$Impl: 1,
  Llaika_config_MessageFilters: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_config_SelectionConfig$Impl(name, choices, separateEbooks) {
  this.Llaika_config_SelectionConfig$Impl__f_name = null;
  this.Llaika_config_SelectionConfig$Impl__f_choices = null;
  this.Llaika_config_SelectionConfig$Impl__f_separateEbooks = false;
  this.Llaika_config_SelectionConfig$Impl__f_name = name;
  this.Llaika_config_SelectionConfig$Impl__f_choices = choices;
  this.Llaika_config_SelectionConfig$Impl__f_separateEbooks = separateEbooks;
}
$c_Llaika_config_SelectionConfig$Impl.prototype = new $h_Llaika_config_SelectionConfig();
$c_Llaika_config_SelectionConfig$Impl.prototype.constructor = $c_Llaika_config_SelectionConfig$Impl;
/** @constructor */
function $h_Llaika_config_SelectionConfig$Impl() {
}
$h_Llaika_config_SelectionConfig$Impl.prototype = $c_Llaika_config_SelectionConfig$Impl.prototype;
$c_Llaika_config_SelectionConfig$Impl.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_config_SelectionConfig$Impl.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("SelectionConfig");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Llaika_config_SelectionConfig$Impl__f_name;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Llaika_config_SelectionConfig$Impl__f_choices;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = (this.Llaika_config_SelectionConfig$Impl__f_separateEbooks ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Llaika_config_SelectionConfig$Impl.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_config_SelectionConfig$Impl)) {
    var x$0$2 = $as_Llaika_config_SelectionConfig$Impl(x$0);
    if (((this.Llaika_config_SelectionConfig$Impl__f_separateEbooks === $n(x$0$2).Llaika_config_SelectionConfig$Impl__f_separateEbooks) && (this.Llaika_config_SelectionConfig$Impl__f_name === $n(x$0$2).Llaika_config_SelectionConfig$Impl__f_name))) {
      var x = this.Llaika_config_SelectionConfig$Impl__f_choices;
      var y = $n(x$0$2).Llaika_config_SelectionConfig$Impl__f_choices;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_config_SelectionConfig$Impl.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_config_SelectionConfig$Impl.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_config_SelectionConfig$Impl.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_config_SelectionConfig$Impl__f_name;
      break;
    }
    case 1: {
      return this.Llaika_config_SelectionConfig$Impl__f_choices;
      break;
    }
    case 2: {
      return this.Llaika_config_SelectionConfig$Impl__f_separateEbooks;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_config_SelectionConfig$Impl.prototype.productPrefix__T = (function() {
  return "SelectionConfig";
});
function $as_Llaika_config_SelectionConfig$Impl(obj) {
  return (((obj instanceof $c_Llaika_config_SelectionConfig$Impl) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.SelectionConfig$Impl"));
}
function $isArrayOf_Llaika_config_SelectionConfig$Impl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_SelectionConfig$Impl)));
}
function $asArrayOf_Llaika_config_SelectionConfig$Impl(obj, depth) {
  return (($isArrayOf_Llaika_config_SelectionConfig$Impl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.SelectionConfig$Impl;", depth));
}
var $d_Llaika_config_SelectionConfig$Impl = new $TypeData().initClass($c_Llaika_config_SelectionConfig$Impl, "laika.config.SelectionConfig$Impl", ({
  Llaika_config_SelectionConfig$Impl: 1,
  Llaika_config_SelectionConfig: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_config_Selections$FormatFilter$$anon$1(selections$7) {
  this.Llaika_config_Selections$FormatFilter$$anon$1__f_selections$6 = null;
  this.Llaika_config_Selections$FormatFilter$$anon$1__f_selections$6 = selections$7;
}
$c_Llaika_config_Selections$FormatFilter$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_config_Selections$FormatFilter$$anon$1.prototype.constructor = $c_Llaika_config_Selections$FormatFilter$$anon$1;
/** @constructor */
function $h_Llaika_config_Selections$FormatFilter$$anon$1() {
}
$h_Llaika_config_Selections$FormatFilter$$anon$1.prototype = $c_Llaika_config_Selections$FormatFilter$$anon$1.prototype;
$c_Llaika_config_Selections$FormatFilter$$anon$1.prototype.isDefinedAt__Llaika_ast_Block__Z = (function(x) {
  if ((x instanceof $c_Llaika_ast_Selection)) {
    var sel = $as_Llaika_ast_Selection(x);
    if ($n(this.Llaika_config_Selections$FormatFilter$$anon$1__f_selections$6).contains__O__Z($n(sel).Llaika_ast_Selection__f_name)) {
      return true;
    }
  }
  return false;
});
$c_Llaika_config_Selections$FormatFilter$$anon$1.prototype.applyOrElse__Llaika_ast_Block__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Llaika_ast_Selection)) {
    var sel = $as_Llaika_ast_Selection(x);
    if ($n(this.Llaika_config_Selections$FormatFilter$$anon$1__f_selections$6).contains__O__Z($n(sel).Llaika_ast_Selection__f_name)) {
      var newValue = $m_Llaika_config_Selections$FormatFilter$().laika$config$Selections$FormatFilter$$$_$select$1__Llaika_ast_Selection__T__Llaika_ast_Block(sel, $as_T($n(this.Llaika_config_Selections$FormatFilter$$anon$1__f_selections$6).apply__O__O($n(sel).Llaika_ast_Selection__f_name)));
      return new $c_Llaika_ast_RewriteAction$Replace(newValue);
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_config_Selections$FormatFilter$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Block__Z($as_Llaika_ast_Block(x));
});
$c_Llaika_config_Selections$FormatFilter$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Block__F1__O($as_Llaika_ast_Block(x), default$1);
});
var $d_Llaika_config_Selections$FormatFilter$$anon$1 = new $TypeData().initClass($c_Llaika_config_Selections$FormatFilter$$anon$1, "laika.config.Selections$FormatFilter$$anon$1", ({
  Llaika_config_Selections$FormatFilter$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_config_Selections$Impl(all) {
  this.Llaika_config_Selections$Impl__f_all = null;
  this.Llaika_config_Selections$Impl__f_all = all;
}
$c_Llaika_config_Selections$Impl.prototype = new $h_Llaika_config_Selections();
$c_Llaika_config_Selections$Impl.prototype.constructor = $c_Llaika_config_Selections$Impl;
/** @constructor */
function $h_Llaika_config_Selections$Impl() {
}
$h_Llaika_config_Selections$Impl.prototype = $c_Llaika_config_Selections$Impl.prototype;
$c_Llaika_config_Selections$Impl.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_config_Selections$Impl.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_config_Selections$Impl.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_config_Selections$Impl)) {
    var x$0$2 = $as_Llaika_config_Selections$Impl(x$0);
    var x = this.Llaika_config_Selections$Impl__f_all;
    var x$2 = $n(x$0$2).Llaika_config_Selections$Impl__f_all;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Llaika_config_Selections$Impl.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_config_Selections$Impl.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_config_Selections$Impl.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_config_Selections$Impl__f_all;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_config_Selections$Impl.prototype.productPrefix__T = (function() {
  return "Selections";
});
function $as_Llaika_config_Selections$Impl(obj) {
  return (((obj instanceof $c_Llaika_config_Selections$Impl) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.Selections$Impl"));
}
function $isArrayOf_Llaika_config_Selections$Impl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_Selections$Impl)));
}
function $asArrayOf_Llaika_config_Selections$Impl(obj, depth) {
  return (($isArrayOf_Llaika_config_Selections$Impl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.Selections$Impl;", depth));
}
var $d_Llaika_config_Selections$Impl = new $TypeData().initClass($c_Llaika_config_Selections$Impl, "laika.config.Selections$Impl", ({
  Llaika_config_Selections$Impl: 1,
  Llaika_config_Selections: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_config_SourceLinks$Impl(baseUri, suffix, packagePrefix) {
  this.Llaika_config_SourceLinks$Impl__f_baseUri = null;
  this.Llaika_config_SourceLinks$Impl__f_suffix = null;
  this.Llaika_config_SourceLinks$Impl__f_packagePrefix = null;
  this.Llaika_config_SourceLinks$Impl__f_baseUri = baseUri;
  this.Llaika_config_SourceLinks$Impl__f_suffix = suffix;
  this.Llaika_config_SourceLinks$Impl__f_packagePrefix = packagePrefix;
}
$c_Llaika_config_SourceLinks$Impl.prototype = new $h_Llaika_config_SourceLinks();
$c_Llaika_config_SourceLinks$Impl.prototype.constructor = $c_Llaika_config_SourceLinks$Impl;
/** @constructor */
function $h_Llaika_config_SourceLinks$Impl() {
}
$h_Llaika_config_SourceLinks$Impl.prototype = $c_Llaika_config_SourceLinks$Impl.prototype;
$c_Llaika_config_SourceLinks$Impl.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_config_SourceLinks$Impl.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_config_SourceLinks$Impl.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_config_SourceLinks$Impl)) {
    var x$0$2 = $as_Llaika_config_SourceLinks$Impl(x$0);
    return (((this.Llaika_config_SourceLinks$Impl__f_baseUri === $n(x$0$2).Llaika_config_SourceLinks$Impl__f_baseUri) && (this.Llaika_config_SourceLinks$Impl__f_suffix === $n(x$0$2).Llaika_config_SourceLinks$Impl__f_suffix)) && (this.Llaika_config_SourceLinks$Impl__f_packagePrefix === $n(x$0$2).Llaika_config_SourceLinks$Impl__f_packagePrefix));
  } else {
    return false;
  }
});
$c_Llaika_config_SourceLinks$Impl.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_config_SourceLinks$Impl.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_config_SourceLinks$Impl.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_config_SourceLinks$Impl__f_baseUri;
      break;
    }
    case 1: {
      return this.Llaika_config_SourceLinks$Impl__f_suffix;
      break;
    }
    case 2: {
      return this.Llaika_config_SourceLinks$Impl__f_packagePrefix;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_config_SourceLinks$Impl.prototype.productPrefix__T = (function() {
  return "SourceLinks";
});
function $as_Llaika_config_SourceLinks$Impl(obj) {
  return (((obj instanceof $c_Llaika_config_SourceLinks$Impl) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.SourceLinks$Impl"));
}
function $isArrayOf_Llaika_config_SourceLinks$Impl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_SourceLinks$Impl)));
}
function $asArrayOf_Llaika_config_SourceLinks$Impl(obj, depth) {
  return (($isArrayOf_Llaika_config_SourceLinks$Impl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.SourceLinks$Impl;", depth));
}
var $d_Llaika_config_SourceLinks$Impl = new $TypeData().initClass($c_Llaika_config_SourceLinks$Impl, "laika.config.SourceLinks$Impl", ({
  Llaika_config_SourceLinks$Impl: 1,
  Llaika_config_SourceLinks: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_config_TargetDefinition$Impl(id, target) {
  this.Llaika_config_TargetDefinition$Impl__f_id = null;
  this.Llaika_config_TargetDefinition$Impl__f_target = null;
  this.Llaika_config_TargetDefinition$Impl__f_id = id;
  this.Llaika_config_TargetDefinition$Impl__f_target = target;
}
$c_Llaika_config_TargetDefinition$Impl.prototype = new $h_Llaika_config_TargetDefinition();
$c_Llaika_config_TargetDefinition$Impl.prototype.constructor = $c_Llaika_config_TargetDefinition$Impl;
/** @constructor */
function $h_Llaika_config_TargetDefinition$Impl() {
}
$h_Llaika_config_TargetDefinition$Impl.prototype = $c_Llaika_config_TargetDefinition$Impl.prototype;
$c_Llaika_config_TargetDefinition$Impl.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_config_TargetDefinition$Impl.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_config_TargetDefinition$Impl.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_config_TargetDefinition$Impl)) {
    var x$0$2 = $as_Llaika_config_TargetDefinition$Impl(x$0);
    if ((this.Llaika_config_TargetDefinition$Impl__f_id === $n(x$0$2).Llaika_config_TargetDefinition$Impl__f_id)) {
      var x = this.Llaika_config_TargetDefinition$Impl__f_target;
      var x$2 = $n(x$0$2).Llaika_config_TargetDefinition$Impl__f_target;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_config_TargetDefinition$Impl.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_config_TargetDefinition$Impl.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_config_TargetDefinition$Impl.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_config_TargetDefinition$Impl__f_id;
  }
  if ((n === 1)) {
    return this.Llaika_config_TargetDefinition$Impl__f_target;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_config_TargetDefinition$Impl.prototype.productPrefix__T = (function() {
  return "TargetDefinition";
});
function $as_Llaika_config_TargetDefinition$Impl(obj) {
  return (((obj instanceof $c_Llaika_config_TargetDefinition$Impl) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.TargetDefinition$Impl"));
}
function $isArrayOf_Llaika_config_TargetDefinition$Impl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_TargetDefinition$Impl)));
}
function $asArrayOf_Llaika_config_TargetDefinition$Impl(obj, depth) {
  return (($isArrayOf_Llaika_config_TargetDefinition$Impl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.TargetDefinition$Impl;", depth));
}
var $d_Llaika_config_TargetDefinition$Impl = new $TypeData().initClass($c_Llaika_config_TargetDefinition$Impl, "laika.config.TargetDefinition$Impl", ({
  Llaika_config_TargetDefinition$Impl: 1,
  Llaika_config_TargetDefinition: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_config_TargetFormats$Selected(formats) {
  this.Llaika_config_TargetFormats$Selected__f_formats = null;
  this.Llaika_config_TargetFormats$Selected__f_formats = formats;
}
$c_Llaika_config_TargetFormats$Selected.prototype = new $h_O();
$c_Llaika_config_TargetFormats$Selected.prototype.constructor = $c_Llaika_config_TargetFormats$Selected;
/** @constructor */
function $h_Llaika_config_TargetFormats$Selected() {
}
$h_Llaika_config_TargetFormats$Selected.prototype = $c_Llaika_config_TargetFormats$Selected.prototype;
$c_Llaika_config_TargetFormats$Selected.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_config_TargetFormats$Selected.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_config_TargetFormats$Selected.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_config_TargetFormats$Selected)) {
    var x$0$2 = $as_Llaika_config_TargetFormats$Selected(x$0);
    var x = this.Llaika_config_TargetFormats$Selected__f_formats;
    var y = $n(x$0$2).Llaika_config_TargetFormats$Selected__f_formats;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_config_TargetFormats$Selected.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_config_TargetFormats$Selected.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_config_TargetFormats$Selected.prototype.productPrefix__T = (function() {
  return "Selected";
});
$c_Llaika_config_TargetFormats$Selected.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_config_TargetFormats$Selected__f_formats;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_config_TargetFormats$Selected.prototype.contains__T__Z = (function(format) {
  var value = this.Llaika_config_TargetFormats$Selected__f_formats;
  var this$2 = new $c_Lcats_data_NonEmptySetOps(value);
  var s = this$2.Lcats_data_NonEmptySetOps__f_value;
  var this$4 = $n($as_sci_SortedSet(s));
  return this$4.contains__O__Z(format);
});
function $as_Llaika_config_TargetFormats$Selected(obj) {
  return (((obj instanceof $c_Llaika_config_TargetFormats$Selected) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.TargetFormats$Selected"));
}
function $isArrayOf_Llaika_config_TargetFormats$Selected(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_TargetFormats$Selected)));
}
function $asArrayOf_Llaika_config_TargetFormats$Selected(obj, depth) {
  return (($isArrayOf_Llaika_config_TargetFormats$Selected(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.TargetFormats$Selected;", depth));
}
var $d_Llaika_config_TargetFormats$Selected = new $TypeData().initClass($c_Llaika_config_TargetFormats$Selected, "laika.config.TargetFormats$Selected", ({
  Llaika_config_TargetFormats$Selected: 1,
  Llaika_config_TargetFormats: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_config_Version$Impl(displayValue, pathSegment, fallbackLink, label, canonical) {
  this.Llaika_config_Version$Impl__f_displayValue = null;
  this.Llaika_config_Version$Impl__f_pathSegment = null;
  this.Llaika_config_Version$Impl__f_fallbackLink = null;
  this.Llaika_config_Version$Impl__f_label = null;
  this.Llaika_config_Version$Impl__f_canonical = false;
  this.Llaika_config_Version$Impl__f_displayValue = displayValue;
  this.Llaika_config_Version$Impl__f_pathSegment = pathSegment;
  this.Llaika_config_Version$Impl__f_fallbackLink = fallbackLink;
  this.Llaika_config_Version$Impl__f_label = label;
  this.Llaika_config_Version$Impl__f_canonical = canonical;
}
$c_Llaika_config_Version$Impl.prototype = new $h_Llaika_config_Version();
$c_Llaika_config_Version$Impl.prototype.constructor = $c_Llaika_config_Version$Impl;
/** @constructor */
function $h_Llaika_config_Version$Impl() {
}
$h_Llaika_config_Version$Impl.prototype = $c_Llaika_config_Version$Impl.prototype;
$c_Llaika_config_Version$Impl.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_config_Version$Impl.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Version");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Llaika_config_Version$Impl__f_displayValue;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Llaika_config_Version$Impl__f_pathSegment;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Llaika_config_Version$Impl__f_fallbackLink;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$3 = this.Llaika_config_Version$Impl__f_label;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var data$5 = (this.Llaika_config_Version$Impl__f_canonical ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$6, 5);
});
$c_Llaika_config_Version$Impl.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_config_Version$Impl)) {
    var x$0$2 = $as_Llaika_config_Version$Impl(x$0);
    if (((((this.Llaika_config_Version$Impl__f_canonical === $n(x$0$2).Llaika_config_Version$Impl__f_canonical) && (this.Llaika_config_Version$Impl__f_displayValue === $n(x$0$2).Llaika_config_Version$Impl__f_displayValue)) && (this.Llaika_config_Version$Impl__f_pathSegment === $n(x$0$2).Llaika_config_Version$Impl__f_pathSegment)) && (this.Llaika_config_Version$Impl__f_fallbackLink === $n(x$0$2).Llaika_config_Version$Impl__f_fallbackLink))) {
      var x = this.Llaika_config_Version$Impl__f_label;
      var x$2 = $n(x$0$2).Llaika_config_Version$Impl__f_label;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_config_Version$Impl.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_config_Version$Impl.prototype.productArity__I = (function() {
  return 5;
});
$c_Llaika_config_Version$Impl.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_config_Version$Impl__f_displayValue;
      break;
    }
    case 1: {
      return this.Llaika_config_Version$Impl__f_pathSegment;
      break;
    }
    case 2: {
      return this.Llaika_config_Version$Impl__f_fallbackLink;
      break;
    }
    case 3: {
      return this.Llaika_config_Version$Impl__f_label;
      break;
    }
    case 4: {
      return this.Llaika_config_Version$Impl__f_canonical;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_config_Version$Impl.prototype.productPrefix__T = (function() {
  return "Version";
});
function $as_Llaika_config_Version$Impl(obj) {
  return (((obj instanceof $c_Llaika_config_Version$Impl) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.Version$Impl"));
}
function $isArrayOf_Llaika_config_Version$Impl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_Version$Impl)));
}
function $asArrayOf_Llaika_config_Version$Impl(obj, depth) {
  return (($isArrayOf_Llaika_config_Version$Impl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.Version$Impl;", depth));
}
var $d_Llaika_config_Version$Impl = new $TypeData().initClass($c_Llaika_config_Version$Impl, "laika.config.Version$Impl", ({
  Llaika_config_Version$Impl: 1,
  Llaika_config_Version: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_config_VersionScannerConfig$Impl(rootDirectory, exclude) {
  this.Llaika_config_VersionScannerConfig$Impl__f_rootDirectory = null;
  this.Llaika_config_VersionScannerConfig$Impl__f_exclude = null;
  this.Llaika_config_VersionScannerConfig$Impl__f_rootDirectory = rootDirectory;
  this.Llaika_config_VersionScannerConfig$Impl__f_exclude = exclude;
}
$c_Llaika_config_VersionScannerConfig$Impl.prototype = new $h_Llaika_config_VersionScannerConfig();
$c_Llaika_config_VersionScannerConfig$Impl.prototype.constructor = $c_Llaika_config_VersionScannerConfig$Impl;
/** @constructor */
function $h_Llaika_config_VersionScannerConfig$Impl() {
}
$h_Llaika_config_VersionScannerConfig$Impl.prototype = $c_Llaika_config_VersionScannerConfig$Impl.prototype;
$c_Llaika_config_VersionScannerConfig$Impl.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_config_VersionScannerConfig$Impl.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_config_VersionScannerConfig$Impl.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_config_VersionScannerConfig$Impl)) {
    var x$0$2 = $as_Llaika_config_VersionScannerConfig$Impl(x$0);
    if ((this.Llaika_config_VersionScannerConfig$Impl__f_rootDirectory === $n(x$0$2).Llaika_config_VersionScannerConfig$Impl__f_rootDirectory)) {
      var x = this.Llaika_config_VersionScannerConfig$Impl__f_exclude;
      var x$2 = $n(x$0$2).Llaika_config_VersionScannerConfig$Impl__f_exclude;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_config_VersionScannerConfig$Impl.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_config_VersionScannerConfig$Impl.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_config_VersionScannerConfig$Impl.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_config_VersionScannerConfig$Impl__f_rootDirectory;
  }
  if ((n === 1)) {
    return this.Llaika_config_VersionScannerConfig$Impl__f_exclude;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_config_VersionScannerConfig$Impl.prototype.productPrefix__T = (function() {
  return "VersionScannerConfig";
});
function $as_Llaika_config_VersionScannerConfig$Impl(obj) {
  return (((obj instanceof $c_Llaika_config_VersionScannerConfig$Impl) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.VersionScannerConfig$Impl"));
}
function $isArrayOf_Llaika_config_VersionScannerConfig$Impl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_VersionScannerConfig$Impl)));
}
function $asArrayOf_Llaika_config_VersionScannerConfig$Impl(obj, depth) {
  return (($isArrayOf_Llaika_config_VersionScannerConfig$Impl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.VersionScannerConfig$Impl;", depth));
}
var $d_Llaika_config_VersionScannerConfig$Impl = new $TypeData().initClass($c_Llaika_config_VersionScannerConfig$Impl, "laika.config.VersionScannerConfig$Impl", ({
  Llaika_config_VersionScannerConfig$Impl: 1,
  Llaika_config_VersionScannerConfig: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_config_Versions$Impl(currentVersion, olderVersions, newerVersions, renderUnversioned, scannerConfig) {
  this.Llaika_config_Versions__f_allVersions$lzy1 = null;
  this.Llaika_config_Versions__f_allVersionsbitmap$1 = false;
  this.Llaika_config_Versions$Impl__f_currentVersion = null;
  this.Llaika_config_Versions$Impl__f_olderVersions = null;
  this.Llaika_config_Versions$Impl__f_newerVersions = null;
  this.Llaika_config_Versions$Impl__f_renderUnversioned = false;
  this.Llaika_config_Versions$Impl__f_scannerConfig = null;
  this.Llaika_config_Versions$Impl__f_currentVersion = currentVersion;
  this.Llaika_config_Versions$Impl__f_olderVersions = olderVersions;
  this.Llaika_config_Versions$Impl__f_newerVersions = newerVersions;
  this.Llaika_config_Versions$Impl__f_renderUnversioned = renderUnversioned;
  this.Llaika_config_Versions$Impl__f_scannerConfig = scannerConfig;
}
$c_Llaika_config_Versions$Impl.prototype = new $h_Llaika_config_Versions();
$c_Llaika_config_Versions$Impl.prototype.constructor = $c_Llaika_config_Versions$Impl;
/** @constructor */
function $h_Llaika_config_Versions$Impl() {
}
$h_Llaika_config_Versions$Impl.prototype = $c_Llaika_config_Versions$Impl.prototype;
$c_Llaika_config_Versions$Impl.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_config_Versions$Impl.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Versions");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Llaika_config_Versions$Impl__f_currentVersion;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Llaika_config_Versions$Impl__f_olderVersions;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Llaika_config_Versions$Impl__f_newerVersions;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = (this.Llaika_config_Versions$Impl__f_renderUnversioned ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$3 = this.Llaika_config_Versions$Impl__f_scannerConfig;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$6, 5);
});
$c_Llaika_config_Versions$Impl.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_config_Versions$Impl)) {
    var x$0$2 = $as_Llaika_config_Versions$Impl(x$0);
    if ((this.Llaika_config_Versions$Impl__f_renderUnversioned === $n(x$0$2).Llaika_config_Versions$Impl__f_renderUnversioned)) {
      var x = this.Llaika_config_Versions$Impl__f_currentVersion;
      var x$2 = $n(x$0$2).Llaika_config_Versions$Impl__f_currentVersion;
      var $x_3 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.Llaika_config_Versions$Impl__f_olderVersions;
      var x$4 = $n(x$0$2).Llaika_config_Versions$Impl__f_olderVersions;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llaika_config_Versions$Impl__f_newerVersions;
      var x$6 = $n(x$0$2).Llaika_config_Versions$Impl__f_newerVersions;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.Llaika_config_Versions$Impl__f_scannerConfig;
      var x$8 = $n(x$0$2).Llaika_config_Versions$Impl__f_scannerConfig;
      return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_config_Versions$Impl.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_config_Versions$Impl.prototype.productArity__I = (function() {
  return 5;
});
$c_Llaika_config_Versions$Impl.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_config_Versions$Impl__f_currentVersion;
      break;
    }
    case 1: {
      return this.Llaika_config_Versions$Impl__f_olderVersions;
      break;
    }
    case 2: {
      return this.Llaika_config_Versions$Impl__f_newerVersions;
      break;
    }
    case 3: {
      return this.Llaika_config_Versions$Impl__f_renderUnversioned;
      break;
    }
    case 4: {
      return this.Llaika_config_Versions$Impl__f_scannerConfig;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_config_Versions$Impl.prototype.productPrefix__T = (function() {
  return "Versions";
});
$c_Llaika_config_Versions$Impl.prototype.validated__s_util_Either = (function() {
  var this$1 = $n(this.allVersions__sci_Seq());
  var m = $as_scm_Map($m_scm_Map$().empty__O());
  var it = this$1.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    var _$1 = $as_Llaika_config_Version(elem);
    var key = $n(_$1).Llaika_config_Version$Impl__f_pathSegment;
    var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0(((this$1) => (() => this$1.newSpecificBuilder__scm_Builder()))(this$1))));
    var this$2 = $n(bldr);
    this$2.addOne__O__scm_Growable(elem);
  }
  var this$3 = $m_sci_HashMap$();
  var result = this$3.sci_HashMap$__f_EmptyMap;
  var mapIt = $n(m).iterator__sc_Iterator();
  while ($n(mapIt).hasNext__Z()) {
    var x1 = $as_T2($n(mapIt).next__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = $n(x1)._1__O();
    var v = $as_scm_Builder($n(x1)._2__O());
    result = $n(result).updated__O__O__sci_HashMap(k, $n(v).result__O());
  }
  var this$5 = $n(result);
  var pred = new $c_sjsr_AnonFunction1(((_$2) => {
    var _$2$1 = $as_T2(_$2);
    var this$4 = $n($as_sc_SeqOps($n(_$2$1)._2__O()));
    return (this$4.length__I() > 1);
  }));
  var this$6 = $n(this$5.filterImpl__F1__Z__sci_HashMap(pred, false));
  var this$7 = $n(this$6.keySet__sci_Set());
  var this$9 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$7));
  var ord = $m_s_math_Ordering$String$();
  var dupSegments = $as_sci_List($f_sc_SeqOps__sorted__s_math_Ordering__O(this$9, ord));
  if ($n(dupSegments).isEmpty__Z()) {
    var dupSegmentsMsg = $m_s_None$();
  } else {
    var this$10 = $n(dupSegments);
    var value = ("Path segments used for more than one version: " + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$10, "", ", ", ""));
    var dupSegmentsMsg = new $c_s_Some(value);
  }
  var this$12 = $n($n($as_sc_IterableOnceOps($n($as_sc_IterableOps($n(this.allVersions__sci_Seq()).filter__F1__O(new $c_sjsr_AnonFunction1(((_$3) => {
    var _$3$1 = $as_Llaika_config_Version(_$3);
    return $n(_$3$1).Llaika_config_Version$Impl__f_canonical;
  }))))).map__F1__O(new $c_sjsr_AnonFunction1(((_$4) => {
    var _$4$1 = $as_Llaika_config_Version(_$4);
    return $n(_$4$1).Llaika_config_Version$Impl__f_displayValue;
  }))))).toList__sci_List());
  var ord$1 = $m_s_math_Ordering$String$();
  var dupCanonical = $as_sci_List($f_sc_SeqOps__sorted__s_math_Ordering__O(this$12, ord$1));
  var this$13 = $n(dupCanonical);
  if ((this$13.length__I() < 2)) {
    var dupCanonicalMsg = $m_s_None$();
  } else {
    var this$14 = $n(dupCanonical);
    var value$1 = ("More than one version marked as canonical: " + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$14, "", ", ", ""));
    var dupCanonicalMsg = new $c_s_Some(value$1);
  }
  var $x_1 = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptyChain);
  var this$16 = $n($n(dupSegmentsMsg).toList__sci_List());
  var suffix = $n(dupCanonicalMsg).toList__sci_List();
  var x11 = $n($x_1).fromSeq__sci_Seq__s_Option(this$16.appendedAll__sc_IterableOnce__sci_List(suffix));
  if ((x11 instanceof $c_s_Some)) {
    var chain = $n($as_s_Some(x11)).s_Some__f_value;
    return new $c_s_util_Left(chain);
  }
  var x = $m_s_None$();
  if ((x === x11)) {
    return new $c_s_util_Right(this);
  }
  throw new $c_s_MatchError(x11);
});
function $as_Llaika_config_Versions$Impl(obj) {
  return (((obj instanceof $c_Llaika_config_Versions$Impl) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.config.Versions$Impl"));
}
function $isArrayOf_Llaika_config_Versions$Impl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_config_Versions$Impl)));
}
function $asArrayOf_Llaika_config_Versions$Impl(obj, depth) {
  return (($isArrayOf_Llaika_config_Versions$Impl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.config.Versions$Impl;", depth));
}
var $d_Llaika_config_Versions$Impl = new $TypeData().initClass($c_Llaika_config_Versions$Impl, "laika.config.Versions$Impl", ({
  Llaika_config_Versions$Impl: 1,
  Llaika_config_Versions: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_directive_ControlFlowDirectives$$anon$1() {
}
$c_Llaika_internal_directive_ControlFlowDirectives$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_directive_ControlFlowDirectives$$anon$1.prototype.constructor = $c_Llaika_internal_directive_ControlFlowDirectives$$anon$1;
/** @constructor */
function $h_Llaika_internal_directive_ControlFlowDirectives$$anon$1() {
}
$h_Llaika_internal_directive_ControlFlowDirectives$$anon$1.prototype = $c_Llaika_internal_directive_ControlFlowDirectives$$anon$1.prototype;
$c_Llaika_internal_directive_ControlFlowDirectives$$anon$1.prototype.isDefinedAt__Llaika_internal_directive_ControlFlowDirectives$IfSeparator$1__Z = (function(x) {
  return ((x instanceof $c_Llaika_internal_directive_ControlFlowDirectives$Else$1) && ($as_Llaika_internal_directive_ControlFlowDirectives$Else$1(x), true));
});
$c_Llaika_internal_directive_ControlFlowDirectives$$anon$1.prototype.applyOrElse__Llaika_internal_directive_ControlFlowDirectives$IfSeparator$1__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Llaika_internal_directive_ControlFlowDirectives$Else$1)) {
    var e = $as_Llaika_internal_directive_ControlFlowDirectives$Else$1(x);
    return e;
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_internal_directive_ControlFlowDirectives$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_internal_directive_ControlFlowDirectives$IfSeparator$1__Z($as_Llaika_internal_directive_ControlFlowDirectives$IfSeparator$1(x));
});
$c_Llaika_internal_directive_ControlFlowDirectives$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_internal_directive_ControlFlowDirectives$IfSeparator$1__F1__O($as_Llaika_internal_directive_ControlFlowDirectives$IfSeparator$1(x), default$1);
});
var $d_Llaika_internal_directive_ControlFlowDirectives$$anon$1 = new $TypeData().initClass($c_Llaika_internal_directive_ControlFlowDirectives$$anon$1, "laika.internal.directive.ControlFlowDirectives$$anon$1", ({
  Llaika_internal_directive_ControlFlowDirectives$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_directive_ControlFlowDirectives$Else$1(outer, body) {
  this.Llaika_internal_directive_ControlFlowDirectives$Else$1__f_body = null;
  this.Llaika_internal_directive_ControlFlowDirectives$Else$1__f_body = body;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_internal_directive_ControlFlowDirectives$Else$1.prototype = new $h_O();
$c_Llaika_internal_directive_ControlFlowDirectives$Else$1.prototype.constructor = $c_Llaika_internal_directive_ControlFlowDirectives$Else$1;
/** @constructor */
function $h_Llaika_internal_directive_ControlFlowDirectives$Else$1() {
}
$h_Llaika_internal_directive_ControlFlowDirectives$Else$1.prototype = $c_Llaika_internal_directive_ControlFlowDirectives$Else$1.prototype;
$c_Llaika_internal_directive_ControlFlowDirectives$Else$1.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_directive_ControlFlowDirectives$Else$1.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_directive_ControlFlowDirectives$Else$1.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_directive_ControlFlowDirectives$Else$1)) {
    var x$0$2 = $as_Llaika_internal_directive_ControlFlowDirectives$Else$1(x$0);
    var x = this.Llaika_internal_directive_ControlFlowDirectives$Else$1__f_body;
    var x$2 = $n(x$0$2).Llaika_internal_directive_ControlFlowDirectives$Else$1__f_body;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_directive_ControlFlowDirectives$Else$1.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_directive_ControlFlowDirectives$Else$1.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_internal_directive_ControlFlowDirectives$Else$1.prototype.productPrefix__T = (function() {
  return "Else";
});
$c_Llaika_internal_directive_ControlFlowDirectives$Else$1.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_directive_ControlFlowDirectives$Else$1__f_body;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_internal_directive_ControlFlowDirectives$Else$1(obj) {
  return (((obj instanceof $c_Llaika_internal_directive_ControlFlowDirectives$Else$1) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.directive.ControlFlowDirectives$Else$1"));
}
function $isArrayOf_Llaika_internal_directive_ControlFlowDirectives$Else$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_directive_ControlFlowDirectives$Else$1)));
}
function $asArrayOf_Llaika_internal_directive_ControlFlowDirectives$Else$1(obj, depth) {
  return (($isArrayOf_Llaika_internal_directive_ControlFlowDirectives$Else$1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.directive.ControlFlowDirectives$Else$1;", depth));
}
var $d_Llaika_internal_directive_ControlFlowDirectives$Else$1 = new $TypeData().initClass($c_Llaika_internal_directive_ControlFlowDirectives$Else$1, "laika.internal.directive.ControlFlowDirectives$Else$1", ({
  Llaika_internal_directive_ControlFlowDirectives$Else$1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_internal_directive_ControlFlowDirectives$IfSeparator$1: 1
}));
/** @constructor */
function $c_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1(outer, ref, body) {
  this.Llaika_internal_directive_ControlFlowDirectives$ElseIf$1__f_ref = null;
  this.Llaika_internal_directive_ControlFlowDirectives$ElseIf$1__f_body = null;
  this.Llaika_internal_directive_ControlFlowDirectives$ElseIf$1__f_ref = ref;
  this.Llaika_internal_directive_ControlFlowDirectives$ElseIf$1__f_body = body;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1.prototype = new $h_O();
$c_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1.prototype.constructor = $c_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1;
/** @constructor */
function $h_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1() {
}
$h_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1.prototype = $c_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1.prototype;
$c_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1)) {
    var x$0$2 = $as_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1(x$0);
    if ((this.Llaika_internal_directive_ControlFlowDirectives$ElseIf$1__f_ref === $n(x$0$2).Llaika_internal_directive_ControlFlowDirectives$ElseIf$1__f_ref)) {
      var x = this.Llaika_internal_directive_ControlFlowDirectives$ElseIf$1__f_body;
      var x$2 = $n(x$0$2).Llaika_internal_directive_ControlFlowDirectives$ElseIf$1__f_body;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1.prototype.productPrefix__T = (function() {
  return "ElseIf";
});
$c_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_directive_ControlFlowDirectives$ElseIf$1__f_ref;
  }
  if ((n === 1)) {
    return this.Llaika_internal_directive_ControlFlowDirectives$ElseIf$1__f_body;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1(obj) {
  return (((obj instanceof $c_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.directive.ControlFlowDirectives$ElseIf$1"));
}
function $isArrayOf_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_directive_ControlFlowDirectives$ElseIf$1)));
}
function $asArrayOf_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1(obj, depth) {
  return (($isArrayOf_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.directive.ControlFlowDirectives$ElseIf$1;", depth));
}
var $d_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1 = new $TypeData().initClass($c_Llaika_internal_directive_ControlFlowDirectives$ElseIf$1, "laika.internal.directive.ControlFlowDirectives$ElseIf$1", ({
  Llaika_internal_directive_ControlFlowDirectives$ElseIf$1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_internal_directive_ControlFlowDirectives$IfSeparator$1: 1
}));
/** @constructor */
function $c_Llaika_internal_directive_DirectiveSupport$$anon$2(outer) {
  this.Llaika_internal_directive_DirectiveSupport$$anon$2__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_internal_directive_DirectiveSupport$$anon$2__f_$outer = outer;
}
$c_Llaika_internal_directive_DirectiveSupport$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_directive_DirectiveSupport$$anon$2.prototype.constructor = $c_Llaika_internal_directive_DirectiveSupport$$anon$2;
/** @constructor */
function $h_Llaika_internal_directive_DirectiveSupport$$anon$2() {
}
$h_Llaika_internal_directive_DirectiveSupport$$anon$2.prototype = $c_Llaika_internal_directive_DirectiveSupport$$anon$2.prototype;
$c_Llaika_internal_directive_DirectiveSupport$$anon$2.prototype.isDefinedAt__Llaika_ast_RewritePhase__Z = (function(x) {
  var x$2 = $m_Llaika_ast_RewritePhase$Resolve$();
  return (x$2 === x);
});
$c_Llaika_internal_directive_DirectiveSupport$$anon$2.prototype.applyOrElse__Llaika_ast_RewritePhase__F1__O = (function(x, default$1) {
  var x$2 = $m_Llaika_ast_RewritePhase$Resolve$();
  if ((x$2 === x)) {
    return ($n(this.Llaika_internal_directive_DirectiveSupport$$anon$2__f_$outer).Llaika_internal_directive_DirectiveSupport__f_laika$internal$directive$DirectiveSupport$$strictMode ? $m_sci_Nil$() : $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_F1.getArrayOf().constr)([$n($m_Llaika_ast_RewriteRules$().forSpans__s_PartialFunction__Llaika_ast_RewriteRules(new $c_Llaika_internal_directive_DirectiveSupport$$anon$3(this))).asBuilder__F1()]))));
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_internal_directive_DirectiveSupport$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_RewritePhase__Z($as_Llaika_ast_RewritePhase(x));
});
$c_Llaika_internal_directive_DirectiveSupport$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_RewritePhase__F1__O($as_Llaika_ast_RewritePhase(x), default$1);
});
var $d_Llaika_internal_directive_DirectiveSupport$$anon$2 = new $TypeData().initClass($c_Llaika_internal_directive_DirectiveSupport$$anon$2, "laika.internal.directive.DirectiveSupport$$anon$2", ({
  Llaika_internal_directive_DirectiveSupport$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_directive_DirectiveSupport$$anon$3(outer) {
  this.Llaika_internal_directive_DirectiveSupport$$anon$3__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_internal_directive_DirectiveSupport$$anon$3__f_$outer = outer;
}
$c_Llaika_internal_directive_DirectiveSupport$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_directive_DirectiveSupport$$anon$3.prototype.constructor = $c_Llaika_internal_directive_DirectiveSupport$$anon$3;
/** @constructor */
function $h_Llaika_internal_directive_DirectiveSupport$$anon$3() {
}
$h_Llaika_internal_directive_DirectiveSupport$$anon$3.prototype = $c_Llaika_internal_directive_DirectiveSupport$$anon$3.prototype;
$c_Llaika_internal_directive_DirectiveSupport$$anon$3.prototype.isDefinedAt__Llaika_ast_Span__Z = (function(x) {
  if ((x instanceof $c_Llaika_ast_LinkPathReference)) {
    var ref = $as_Llaika_ast_LinkPathReference(x);
    var this$1 = $n($n($n(ref).Llaika_ast_LinkPathReference__f_path).toString__T());
    if (((this$1.length >= 0) && ($as_T(this$1.substring(0, 2)) === "@:"))) {
      return true;
    }
  }
  return false;
});
$c_Llaika_internal_directive_DirectiveSupport$$anon$3.prototype.applyOrElse__Llaika_ast_Span__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Llaika_ast_LinkPathReference)) {
    var ref = $as_Llaika_ast_LinkPathReference(x);
    var this$1 = $n($n($n(ref).Llaika_ast_LinkPathReference__f_path).toString__T());
    if (((this$1.length >= 0) && ($as_T(this$1.substring(0, 2)) === "@:"))) {
      var $x_2 = $n($n(this.Llaika_internal_directive_DirectiveSupport$$anon$3__f_$outer).Llaika_internal_directive_DirectiveSupport$$anon$2__f_$outer).Llaika_internal_directive_DirectiveSupport__f_laika$internal$directive$DirectiveSupport$$linkParser;
      var $x_1 = $m_sc_StringOps$();
      var x$1 = $n($n(ref).Llaika_ast_LinkPathReference__f_path).toString__T();
      var this$3 = $n($n($n($x_2).parse__T__Llaika_parse_Parsed($n($x_1).drop$extension__T__I__T(x$1, 2))).toEither__s_util_Either());
      if ((this$3 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(this$3);
        var b = $n(x2).s_util_Right__f_value;
        var res = $as_Llaika_parse_builders$$tilde(b);
        var newValue = $n($n($n(this.Llaika_internal_directive_DirectiveSupport$$anon$3__f_$outer).Llaika_internal_directive_DirectiveSupport$$anon$2__f_$outer).Llaika_internal_directive_DirectiveSupport__f_LinkDirectiveResolver2$lzy1).apply__Llaika_ast_LinkPathReference__T__T__Llaika_parse_SourceFragment__Llaika_ast_Options__Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2(ref, $as_T($n(res).Llaika_parse_builders$$tilde__f__1), $as_T($n(res).Llaika_parse_builders$$tilde__f__2), $n(ref).Llaika_ast_LinkPathReference__f_source, $n(ref).Llaika_ast_LinkPathReference__f_options);
        return new $c_Llaika_ast_RewriteAction$Replace(newValue);
      } else if ((this$3 instanceof $c_s_util_Left)) {
        var x3 = $as_s_util_Left(this$3);
        var a = $n(x3).s_util_Left__f_value;
        var err = $as_T(a);
        var newValue$1 = $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan(("Invalid link directive: " + err), $n(ref).Llaika_ast_LinkPathReference__f_source);
        return new $c_Llaika_ast_RewriteAction$Replace(newValue$1);
      } else {
        throw new $c_s_MatchError(this$3);
      }
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_internal_directive_DirectiveSupport$$anon$3.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Span__Z($as_Llaika_ast_Span(x));
});
$c_Llaika_internal_directive_DirectiveSupport$$anon$3.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Span__F1__O($as_Llaika_ast_Span(x), default$1);
});
var $d_Llaika_internal_directive_DirectiveSupport$$anon$3 = new $TypeData().initClass($c_Llaika_internal_directive_DirectiveSupport$$anon$3, "laika.internal.directive.DirectiveSupport$$anon$3", ({
  Llaika_internal_directive_DirectiveSupport$$anon$3: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode(target, title, depth, excludeRoot, excludeSections) {
  this.Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_target = null;
  this.Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_title = null;
  this.Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_depth = null;
  this.Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_excludeRoot = null;
  this.Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_excludeSections = null;
  this.Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_target = target;
  this.Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_title = title;
  this.Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_depth = depth;
  this.Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_excludeRoot = excludeRoot;
  this.Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_excludeSections = excludeSections;
}
$c_Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode.prototype = new $h_O();
$c_Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode.prototype.constructor = $c_Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode;
/** @constructor */
function $h_Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode() {
}
$h_Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode.prototype = $c_Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode.prototype;
$c_Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode)) {
    var x$0$2 = $as_Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode(x$0);
    var x = this.Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_target;
    var x$2 = $n(x$0$2).Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_target;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_title;
      var x$4 = $n(x$0$2).Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_title;
      var $x_4 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_depth;
      var x$6 = $n(x$0$2).Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_depth;
      var $x_3 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_excludeRoot;
      var x$8 = $n(x$0$2).Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_excludeRoot;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_excludeSections;
      var x$10 = $n(x$0$2).Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_excludeSections;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode.prototype.productArity__I = (function() {
  return 5;
});
$c_Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode.prototype.productPrefix__T = (function() {
  return "GeneratedNavigationNode";
});
$c_Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_target;
      break;
    }
    case 1: {
      return this.Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_title;
      break;
    }
    case 2: {
      return this.Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_depth;
      break;
    }
    case 3: {
      return this.Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_excludeRoot;
      break;
    }
    case 4: {
      return this.Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_excludeSections;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode(obj) {
  return (((obj instanceof $c_Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.directive.NavigationTreeDirectives$GeneratedNavigationNode"));
}
function $isArrayOf_Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode)));
}
function $asArrayOf_Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode(obj, depth) {
  return (($isArrayOf_Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.directive.NavigationTreeDirectives$GeneratedNavigationNode;", depth));
}
var $d_Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode = new $TypeData().initClass($c_Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode, "laika.internal.directive.NavigationTreeDirectives$GeneratedNavigationNode", ({
  Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode: 1,
  Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode(title, target, entries) {
  this.Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode__f_title = null;
  this.Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode__f_target = null;
  this.Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode__f_entries = null;
  this.Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode__f_title = title;
  this.Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode__f_target = target;
  this.Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode__f_entries = entries;
}
$c_Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode.prototype = new $h_O();
$c_Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode.prototype.constructor = $c_Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode;
/** @constructor */
function $h_Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode() {
}
$h_Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode.prototype = $c_Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode.prototype;
$c_Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode)) {
    var x$0$2 = $as_Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode(x$0);
    var x = this.Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode__f_title;
    var x$2 = $n(x$0$2).Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode__f_title;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode__f_target;
      var x$4 = $n(x$0$2).Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode__f_target;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode__f_entries;
      var x$6 = $n(x$0$2).Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode__f_entries;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode.prototype.productPrefix__T = (function() {
  return "ManualNavigationNode";
});
$c_Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode__f_title;
      break;
    }
    case 1: {
      return this.Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode__f_target;
      break;
    }
    case 2: {
      return this.Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode__f_entries;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode(obj) {
  return (((obj instanceof $c_Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.directive.NavigationTreeDirectives$ManualNavigationNode"));
}
function $isArrayOf_Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode)));
}
function $asArrayOf_Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode(obj, depth) {
  return (($isArrayOf_Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.directive.NavigationTreeDirectives$ManualNavigationNode;", depth));
}
var $d_Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode = new $TypeData().initClass($c_Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode, "laika.internal.directive.NavigationTreeDirectives$ManualNavigationNode", ({
  Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode: 1,
  Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_link_DocumentTargets$$anon$1(symbolNumbers$2, symbols$2, numbers$2, levels$2, document$5, outer) {
  this.Llaika_internal_link_DocumentTargets$$anon$1__f_symbolNumbers$1 = null;
  this.Llaika_internal_link_DocumentTargets$$anon$1__f_symbols$1 = null;
  this.Llaika_internal_link_DocumentTargets$$anon$1__f_numbers$1 = null;
  this.Llaika_internal_link_DocumentTargets$$anon$1__f_levels$1 = null;
  this.Llaika_internal_link_DocumentTargets$$anon$1__f_document$2 = null;
  this.Llaika_internal_link_DocumentTargets$$anon$1__f_$outer = null;
  this.Llaika_internal_link_DocumentTargets$$anon$1__f_symbolNumbers$1 = symbolNumbers$2;
  this.Llaika_internal_link_DocumentTargets$$anon$1__f_symbols$1 = symbols$2;
  this.Llaika_internal_link_DocumentTargets$$anon$1__f_numbers$1 = numbers$2;
  this.Llaika_internal_link_DocumentTargets$$anon$1__f_levels$1 = levels$2;
  this.Llaika_internal_link_DocumentTargets$$anon$1__f_document$2 = document$5;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_internal_link_DocumentTargets$$anon$1__f_$outer = outer;
}
$c_Llaika_internal_link_DocumentTargets$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_link_DocumentTargets$$anon$1.prototype.constructor = $c_Llaika_internal_link_DocumentTargets$$anon$1;
/** @constructor */
function $h_Llaika_internal_link_DocumentTargets$$anon$1() {
}
$h_Llaika_internal_link_DocumentTargets$$anon$1.prototype = $c_Llaika_internal_link_DocumentTargets$$anon$1.prototype;
$c_Llaika_internal_link_DocumentTargets$$anon$1.prototype.isDefinedAt__Llaika_ast_Element__Z = (function(x) {
  if ((x instanceof $c_Llaika_ast_Citation)) {
    $as_Llaika_ast_Citation(x);
    return true;
  }
  if (false) {
    $as_Llaika_ast_FootnoteDefinition(x);
    return true;
  }
  if ((x instanceof $c_Llaika_ast_LinkDefinition)) {
    $as_Llaika_ast_LinkDefinition(x);
    return true;
  }
  if (false) {
    var x54 = $as_Llaika_ast_DecoratedHeader(x);
    $n(x54)._1__Llaika_ast_HeaderDecoration();
    $n(x54)._2__sci_Seq();
    $n(x54)._3__Llaika_parse_SourceFragment();
    $n(x54)._4__Llaika_ast_Options();
    return true;
  }
  if ((x instanceof $c_Llaika_ast_Header)) {
    var x49 = $as_Llaika_ast_Header(x);
    var this$3 = $n(x49);
    var this$4 = $n(x49);
    var this$5 = $n(x49);
    return true;
  }
  if (false) {
    $as_Llaika_ast_LinkAlias(x);
    return true;
  }
  if ($is_Llaika_ast_Block(x)) {
    var c$2 = $as_Llaika_ast_Block(x);
    if ($n($as_Llaika_ast_Element(c$2)).hasId__Z()) {
      return true;
    }
  }
  if ($is_Llaika_ast_Span(x)) {
    var c$3 = $as_Llaika_ast_Span(x);
    if ($n($as_Llaika_ast_Element(c$3)).hasId__Z()) {
      return true;
    }
  }
  return false;
});
$c_Llaika_internal_link_DocumentTargets$$anon$1.prototype.applyOrElse__Llaika_ast_Element__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Llaika_ast_Citation)) {
    var c = $as_Llaika_ast_Citation(x);
    var id = $as_T($n($n(this.Llaika_internal_link_DocumentTargets$$anon$1__f_$outer).Llaika_internal_link_DocumentTargets__f_laika$internal$link$DocumentTargets$$slugBuilder).apply__O__O($n(c).Llaika_ast_Citation__f_label));
    var selector = new $c_Llaika_internal_link_TargetIdSelector(id);
    var docId = ("__cit-" + selector.Llaika_internal_link_TargetIdSelector__f_id);
    var f = new $c_Llaika_internal_link_DocumentTargets$$anon$2(docId);
    var resolver = new $c_s_PartialFunction$Lifted(f);
    $m_Llaika_internal_link_TargetReplacer$();
    var f$1 = new $c_Llaika_internal_link_DocumentTargets$$anon$3(docId);
    var replacer = new $c_s_PartialFunction$Lifted(f$1);
    var this$4 = $m_Llaika_internal_link_TargetResolver$();
    var targetFormats = $n(this.Llaika_internal_link_DocumentTargets$$anon$1__f_$outer).Llaika_internal_link_DocumentTargets__f_laika$internal$link$DocumentTargets$$targetFormats;
    return new $c_Llaika_internal_link_TargetResolver$$anon$2(selector, targetFormats, 0, resolver, replacer, this$4);
  }
  if (false) {
    var f$2 = $as_Llaika_ast_FootnoteDefinition(x);
    matchResult10: {
      var \u03b42$___1;
      var \u03b42$___2;
      var \u03b42$___3;
      var x93 = $n(f$2).label__Llaika_ast_FootnoteLabel();
      var x$2 = $m_Llaika_ast_FootnoteLabel$Autosymbol$();
      if ((x$2 === x93)) {
        var _1 = ("__fns-" + $n(this.Llaika_internal_link_DocumentTargets$$anon$1__f_symbolNumbers$1).next__O());
        var _2 = $n(this.Llaika_internal_link_DocumentTargets$$anon$1__f_symbols$1).next__T();
        var _3 = $m_Llaika_internal_link_AutosymbolSelector$();
        var \u03b42$___1 = _1;
        var \u03b42$___2 = _2;
        var \u03b42$___3 = _3;
        break matchResult10;
      }
      var x$4 = $m_Llaika_ast_FootnoteLabel$Autonumber$();
      if ((x$4 === x93)) {
        var num = $uI($n(this.Llaika_internal_link_DocumentTargets$$anon$1__f_numbers$1).next__O());
        var _1$1 = ("__fn-" + num);
        var _2$1 = ("" + num);
        var _3$1 = $m_Llaika_internal_link_AutonumberSelector$();
        var \u03b42$___1 = _1$1;
        var \u03b42$___2 = _2$1;
        var \u03b42$___3 = _3$1;
        break matchResult10;
      }
      if (false) {
        var x$1 = $as_Llaika_ast_FootnoteLabel$AutonumberLabel(x93);
        var x99 = $n(x$1)._1__T();
        var _1$2 = $n($n(this.Llaika_internal_link_DocumentTargets$$anon$1__f_$outer).Llaika_internal_link_DocumentTargets__f_laika$internal$link$DocumentTargets$$slugBuilder).apply__O__O(x99);
        var _2$2 = $dp_toString__T($n($n(this.Llaika_internal_link_DocumentTargets$$anon$1__f_numbers$1).next__O()));
        var id$1 = $as_T($n($n(this.Llaika_internal_link_DocumentTargets$$anon$1__f_$outer).Llaika_internal_link_DocumentTargets__f_laika$internal$link$DocumentTargets$$slugBuilder).apply__O__O(x99));
        var _3$2 = new $c_Llaika_internal_link_TargetIdSelector(id$1);
        var \u03b42$___1 = _1$2;
        var \u03b42$___2 = _2$2;
        var \u03b42$___3 = _3$2;
        break matchResult10;
      }
      if (false) {
        var x$1$1 = $as_Llaika_ast_FootnoteLabel$NumericLabel(x93);
        var x96 = $n(x$1$1)._1__I();
        var _1$3 = ("__fnl-" + x96);
        var _2$3 = ("" + x96);
        var id$2 = ("" + x96);
        var _3$3 = new $c_Llaika_internal_link_TargetIdSelector(id$2);
        var \u03b42$___1 = _1$3;
        var \u03b42$___2 = _2$3;
        var \u03b42$___3 = _3$3;
        break matchResult10;
      }
      throw new $c_s_MatchError(x93);
    }
    var docId$2 = $as_T(\u03b42$___1);
    var displayId = $as_T(\u03b42$___2);
    var selector$2 = $as_Llaika_internal_link_Selector(\u03b42$___3);
    var f$3 = new $c_Llaika_internal_link_DocumentTargets$$anon$4(docId$2, displayId);
    var resolver$2 = new $c_s_PartialFunction$Lifted(f$3);
    $m_Llaika_internal_link_TargetReplacer$();
    var f$4 = new $c_Llaika_internal_link_DocumentTargets$$anon$5(displayId, docId$2);
    var replacer$2 = new $c_s_PartialFunction$Lifted(f$4);
    var this$18 = $m_Llaika_internal_link_TargetResolver$();
    var targetFormats$1 = $n(this.Llaika_internal_link_DocumentTargets$$anon$1__f_$outer).Llaika_internal_link_DocumentTargets__f_laika$internal$link$DocumentTargets$$targetFormats;
    return new $c_Llaika_internal_link_TargetResolver$$anon$2(selector$2, targetFormats$1, 0, resolver$2, replacer$2, this$18);
  }
  if ((x instanceof $c_Llaika_ast_LinkDefinition)) {
    var ld = $as_Llaika_ast_LinkDefinition(x);
    var this$19 = $n($n(ld).Llaika_ast_LinkDefinition__f_id);
    if ((this$19 === "")) {
      var $x_1 = $m_Llaika_internal_link_AnonymousSelector$();
    } else {
      var id$3 = $n(ld).Llaika_ast_LinkDefinition__f_id;
      var $x_1 = new $c_Llaika_internal_link_LinkDefinitionSelector(id$3);
    }
    var selector$3 = $as_Llaika_internal_link_Selector($x_1);
    return $n(this.Llaika_internal_link_DocumentTargets$$anon$1__f_$outer).laika$internal$link$DocumentTargets$$linkDefinitionResolver__Llaika_internal_link_Selector__Llaika_ast_Target__s_Option__Llaika_internal_link_TargetResolver(selector$3, $n(ld).Llaika_ast_LinkDefinition__f_target, $n(ld).Llaika_ast_LinkDefinition__f_title);
  }
  if (false) {
    var x155 = $as_Llaika_ast_DecoratedHeader(x);
    var x157 = $n(x155)._1__Llaika_ast_HeaderDecoration();
    $n(x155)._2__sci_Seq();
    $n(x155)._3__Llaika_parse_SourceFragment();
    $n(x155)._4__Llaika_ast_Options();
    var $x_2 = $n(this.Llaika_internal_link_DocumentTargets$$anon$1__f_$outer).Llaika_internal_link_DocumentTargets__f_laika$internal$link$DocumentTargets$$slugBuilder;
    var this$22 = $n($n($n(x155).options__Llaika_ast_Options()).Llaika_ast_Options$Impl__f_id);
    var id$4 = $as_T($n($x_2).apply__O__O((this$22.isEmpty__Z() ? $n(x155).extractText__T() : this$22.get__O())));
    var selector$4 = new $c_Llaika_internal_link_TargetIdSelector(id$4);
    var level = $n(this.Llaika_internal_link_DocumentTargets$$anon$1__f_levels$1).levelFor__Llaika_ast_HeaderDecoration__I(x157);
    $m_Llaika_internal_link_TargetReplacer$();
    var f$5 = new $c_Llaika_internal_link_DocumentTargets$$anon$6(level, selector$4);
    var finalHeader = new $c_s_PartialFunction$Lifted(f$5);
    var this$25 = $m_Llaika_internal_link_TargetResolver$();
    var referenceResolver = $s_Llaika_internal_link_DocumentTargets__laika$internal$link$DocumentTargets$$_$_$internalResolver$1__Llaika_ast_Document__Llaika_internal_link_TargetIdSelector__F1(this.Llaika_internal_link_DocumentTargets$$anon$1__f_document$2, selector$4);
    var targetFormats$2 = $n(this.Llaika_internal_link_DocumentTargets$$anon$1__f_$outer).Llaika_internal_link_DocumentTargets__f_laika$internal$link$DocumentTargets$$targetFormats;
    var precedence = ((10 - level) | 0);
    return new $c_Llaika_internal_link_TargetResolver$$anon$2(selector$4, targetFormats$2, precedence, referenceResolver, finalHeader, this$25);
  }
  if ((x instanceof $c_Llaika_ast_Header)) {
    var x150 = $as_Llaika_ast_Header(x);
    var this$27 = $n(x150);
    var x152 = this$27.Llaika_ast_Header__f_level;
    var this$28 = $n(x150);
    var this$29 = $n(x150);
    var $x_4 = $n(this.Llaika_internal_link_DocumentTargets$$anon$1__f_$outer).Llaika_internal_link_DocumentTargets__f_laika$internal$link$DocumentTargets$$slugBuilder;
    var this$30 = $n($n($n(x150).Llaika_ast_Header__f_options).Llaika_ast_Options$Impl__f_id);
    if (this$30.isEmpty__Z()) {
      var this$31 = $n(x150);
      var $x_3 = $f_Llaika_ast_SpanContainer__extractText__T(this$31);
    } else {
      var $x_3 = this$30.get__O();
    }
    var id$5 = $as_T($n($x_4).apply__O__O($x_3));
    var selector$5 = new $c_Llaika_internal_link_TargetIdSelector(id$5);
    var this$33 = $m_Llaika_internal_link_TargetResolver$();
    var referenceResolver$1 = $s_Llaika_internal_link_DocumentTargets__laika$internal$link$DocumentTargets$$_$_$internalResolver$1__Llaika_ast_Document__Llaika_internal_link_TargetIdSelector__F1(this.Llaika_internal_link_DocumentTargets$$anon$1__f_document$2, selector$5);
    var targetResolver = $m_Llaika_internal_link_TargetReplacer$().addId__T__F1(selector$5.Llaika_internal_link_TargetIdSelector__f_id);
    var targetFormats$3 = $n(this.Llaika_internal_link_DocumentTargets$$anon$1__f_$outer).Llaika_internal_link_DocumentTargets__f_laika$internal$link$DocumentTargets$$targetFormats;
    var precedence$1 = ((10 - x152) | 0);
    return new $c_Llaika_internal_link_TargetResolver$$anon$2(selector$5, targetFormats$3, precedence$1, referenceResolver$1, targetResolver, this$33);
  }
  if (false) {
    var alias = $as_Llaika_ast_LinkAlias(x);
    var $x_6 = $m_Llaika_internal_link_LinkAliasResolver$();
    var id$6 = $as_T($n($n(this.Llaika_internal_link_DocumentTargets$$anon$1__f_$outer).Llaika_internal_link_DocumentTargets__f_laika$internal$link$DocumentTargets$$slugBuilder).apply__O__O($n(alias).id__T()));
    var $x_5 = new $c_Llaika_internal_link_TargetIdSelector(id$6);
    var id$7 = $as_T($n($n(this.Llaika_internal_link_DocumentTargets$$anon$1__f_$outer).Llaika_internal_link_DocumentTargets__f_laika$internal$link$DocumentTargets$$slugBuilder).apply__O__O($n(alias).target__T()));
    return $n($x_6).unresolved__Llaika_internal_link_TargetIdSelector__Llaika_internal_link_TargetIdSelector__Llaika_config_TargetFormats__Llaika_internal_link_LinkAliasResolver($x_5, new $c_Llaika_internal_link_TargetIdSelector(id$7), $n(this.Llaika_internal_link_DocumentTargets$$anon$1__f_$outer).Llaika_internal_link_DocumentTargets__f_laika$internal$link$DocumentTargets$$targetFormats);
  }
  if ($is_Llaika_ast_Block(x)) {
    var c$2 = $as_Llaika_ast_Block(x);
    if ($n($as_Llaika_ast_Element(c$2)).hasId__Z()) {
      var id$8 = $as_T($n($n(this.Llaika_internal_link_DocumentTargets$$anon$1__f_$outer).Llaika_internal_link_DocumentTargets__f_laika$internal$link$DocumentTargets$$slugBuilder).apply__O__O($n($n($n($as_Llaika_ast_Element(c$2)).options__Llaika_ast_Options()).Llaika_ast_Options$Impl__f_id).get__O()));
      var selector$6 = new $c_Llaika_internal_link_TargetIdSelector(id$8);
      var this$37 = $m_Llaika_internal_link_TargetResolver$();
      var referenceResolver$2 = $s_Llaika_internal_link_DocumentTargets__laika$internal$link$DocumentTargets$$_$_$internalResolver$1__Llaika_ast_Document__Llaika_internal_link_TargetIdSelector__F1(this.Llaika_internal_link_DocumentTargets$$anon$1__f_document$2, selector$6);
      var targetResolver$1 = $m_Llaika_internal_link_TargetReplacer$().addId__T__F1(selector$6.Llaika_internal_link_TargetIdSelector__f_id);
      var targetFormats$4 = $n(this.Llaika_internal_link_DocumentTargets$$anon$1__f_$outer).Llaika_internal_link_DocumentTargets__f_laika$internal$link$DocumentTargets$$targetFormats;
      return new $c_Llaika_internal_link_TargetResolver$$anon$2(selector$6, targetFormats$4, 0, referenceResolver$2, targetResolver$1, this$37);
    }
  }
  if ($is_Llaika_ast_Span(x)) {
    var c$3 = $as_Llaika_ast_Span(x);
    if ($n($as_Llaika_ast_Element(c$3)).hasId__Z()) {
      var id$9 = $as_T($n($n(this.Llaika_internal_link_DocumentTargets$$anon$1__f_$outer).Llaika_internal_link_DocumentTargets__f_laika$internal$link$DocumentTargets$$slugBuilder).apply__O__O($n($n($n($as_Llaika_ast_Element(c$3)).options__Llaika_ast_Options()).Llaika_ast_Options$Impl__f_id).get__O()));
      var selector$7 = new $c_Llaika_internal_link_TargetIdSelector(id$9);
      var this$39 = $m_Llaika_internal_link_TargetResolver$();
      var referenceResolver$3 = $s_Llaika_internal_link_DocumentTargets__laika$internal$link$DocumentTargets$$_$_$internalResolver$1__Llaika_ast_Document__Llaika_internal_link_TargetIdSelector__F1(this.Llaika_internal_link_DocumentTargets$$anon$1__f_document$2, selector$7);
      var targetFormats$5 = $n(this.Llaika_internal_link_DocumentTargets$$anon$1__f_$outer).Llaika_internal_link_DocumentTargets__f_laika$internal$link$DocumentTargets$$targetFormats;
      return new $c_Llaika_internal_link_TargetResolver$$anon$3(selector$7, targetFormats$5, referenceResolver$3, this$39);
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_internal_link_DocumentTargets$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Element__Z($as_Llaika_ast_Element(x));
});
$c_Llaika_internal_link_DocumentTargets$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Element__F1__O($as_Llaika_ast_Element(x), default$1);
});
var $d_Llaika_internal_link_DocumentTargets$$anon$1 = new $TypeData().initClass($c_Llaika_internal_link_DocumentTargets$$anon$1, "laika.internal.link.DocumentTargets$$anon$1", ({
  Llaika_internal_link_DocumentTargets$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_link_DocumentTargets$$anon$2(docId$5) {
  this.Llaika_internal_link_DocumentTargets$$anon$2__f_docId$1 = null;
  this.Llaika_internal_link_DocumentTargets$$anon$2__f_docId$1 = docId$5;
}
$c_Llaika_internal_link_DocumentTargets$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_link_DocumentTargets$$anon$2.prototype.constructor = $c_Llaika_internal_link_DocumentTargets$$anon$2;
/** @constructor */
function $h_Llaika_internal_link_DocumentTargets$$anon$2() {
}
$h_Llaika_internal_link_DocumentTargets$$anon$2.prototype = $c_Llaika_internal_link_DocumentTargets$$anon$2.prototype;
$c_Llaika_internal_link_DocumentTargets$$anon$2.prototype.isDefinedAt__Llaika_internal_link_LinkSource__Z = (function(x) {
  if ((x !== null)) {
    var this$2 = $n(x);
    var x65 = this$2.Llaika_internal_link_LinkSource__f_span;
    var this$3 = $n(x);
    if (false) {
      var x$1 = $as_Llaika_ast_CitationReference(x65);
      $n(x$1)._1__T();
      $n(x$1)._2__Llaika_parse_SourceFragment();
      $n(x$1)._3__Llaika_ast_Options();
      return true;
    }
  }
  return false;
});
$c_Llaika_internal_link_DocumentTargets$$anon$2.prototype.applyOrElse__Llaika_internal_link_LinkSource__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var this$2 = $n(x);
    var x74 = this$2.Llaika_internal_link_LinkSource__f_span;
    var this$3 = $n(x);
    if (false) {
      var x$1 = $as_Llaika_ast_CitationReference(x74);
      var x78 = $n(x$1)._1__T();
      $n(x$1)._2__Llaika_parse_SourceFragment();
      var x80 = $n(x$1)._3__Llaika_ast_Options();
      var refId = this.Llaika_internal_link_DocumentTargets$$anon$2__f_docId$1;
      return new $c_Llaika_ast_CitationLink(refId, x78, x80);
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_internal_link_DocumentTargets$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_internal_link_LinkSource__Z($as_Llaika_internal_link_LinkSource(x));
});
$c_Llaika_internal_link_DocumentTargets$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_internal_link_LinkSource__F1__O($as_Llaika_internal_link_LinkSource(x), default$1);
});
var $d_Llaika_internal_link_DocumentTargets$$anon$2 = new $TypeData().initClass($c_Llaika_internal_link_DocumentTargets$$anon$2, "laika.internal.link.DocumentTargets$$anon$2", ({
  Llaika_internal_link_DocumentTargets$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_link_DocumentTargets$$anon$3(docId$6) {
  this.Llaika_internal_link_DocumentTargets$$anon$3__f_docId$2 = null;
  this.Llaika_internal_link_DocumentTargets$$anon$3__f_docId$2 = docId$6;
}
$c_Llaika_internal_link_DocumentTargets$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_link_DocumentTargets$$anon$3.prototype.constructor = $c_Llaika_internal_link_DocumentTargets$$anon$3;
/** @constructor */
function $h_Llaika_internal_link_DocumentTargets$$anon$3() {
}
$h_Llaika_internal_link_DocumentTargets$$anon$3.prototype = $c_Llaika_internal_link_DocumentTargets$$anon$3.prototype;
$c_Llaika_internal_link_DocumentTargets$$anon$3.prototype.isDefinedAt__Llaika_ast_Block__Z = (function(x) {
  if ((x instanceof $c_Llaika_ast_Citation)) {
    var x$1 = $as_Llaika_ast_Citation(x);
    var this$2 = $n(x$1);
    var this$3 = $n(x$1);
    var this$4 = $n(x$1);
    return true;
  } else {
    return false;
  }
});
$c_Llaika_internal_link_DocumentTargets$$anon$3.prototype.applyOrElse__Llaika_ast_Block__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Llaika_ast_Citation)) {
    var x$1 = $as_Llaika_ast_Citation(x);
    var this$2 = $n(x$1);
    var x90 = this$2.Llaika_ast_Citation__f_label;
    var this$3 = $n(x$1);
    var x91 = this$3.Llaika_ast_Citation__f_content;
    var this$4 = $n(x$1);
    var x92 = this$4.Llaika_ast_Citation__f_options;
    var options = $n(x92).$plus__Llaika_ast_Options__Llaika_ast_Options($m_Llaika_ast_Id$().apply__T__Llaika_ast_Options(this.Llaika_internal_link_DocumentTargets$$anon$3__f_docId$2));
    return new $c_Llaika_ast_Citation(x90, x91, options);
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_internal_link_DocumentTargets$$anon$3.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Block__Z($as_Llaika_ast_Block(x));
});
$c_Llaika_internal_link_DocumentTargets$$anon$3.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Block__F1__O($as_Llaika_ast_Block(x), default$1);
});
var $d_Llaika_internal_link_DocumentTargets$$anon$3 = new $TypeData().initClass($c_Llaika_internal_link_DocumentTargets$$anon$3, "laika.internal.link.DocumentTargets$$anon$3", ({
  Llaika_internal_link_DocumentTargets$$anon$3: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_link_DocumentTargets$$anon$4(docId$7, displayId$3) {
  this.Llaika_internal_link_DocumentTargets$$anon$4__f_docId$3 = null;
  this.Llaika_internal_link_DocumentTargets$$anon$4__f_displayId$1 = null;
  this.Llaika_internal_link_DocumentTargets$$anon$4__f_docId$3 = docId$7;
  this.Llaika_internal_link_DocumentTargets$$anon$4__f_displayId$1 = displayId$3;
}
$c_Llaika_internal_link_DocumentTargets$$anon$4.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_link_DocumentTargets$$anon$4.prototype.constructor = $c_Llaika_internal_link_DocumentTargets$$anon$4;
/** @constructor */
function $h_Llaika_internal_link_DocumentTargets$$anon$4() {
}
$h_Llaika_internal_link_DocumentTargets$$anon$4.prototype = $c_Llaika_internal_link_DocumentTargets$$anon$4.prototype;
$c_Llaika_internal_link_DocumentTargets$$anon$4.prototype.isDefinedAt__Llaika_internal_link_LinkSource__Z = (function(x) {
  if ((x !== null)) {
    var this$2 = $n(x);
    var x102 = this$2.Llaika_internal_link_LinkSource__f_span;
    var this$3 = $n(x);
    if (false) {
      var x$1 = $as_Llaika_ast_FootnoteReference(x102);
      $n(x$1)._1__Llaika_ast_FootnoteLabel();
      $n(x$1)._2__Llaika_parse_SourceFragment();
      $n(x$1)._3__Llaika_ast_Options();
      return true;
    }
  }
  return false;
});
$c_Llaika_internal_link_DocumentTargets$$anon$4.prototype.applyOrElse__Llaika_internal_link_LinkSource__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var this$2 = $n(x);
    var x111 = this$2.Llaika_internal_link_LinkSource__f_span;
    var this$3 = $n(x);
    if (false) {
      var x$1 = $as_Llaika_ast_FootnoteReference(x111);
      $n(x$1)._1__Llaika_ast_FootnoteLabel();
      $n(x$1)._2__Llaika_parse_SourceFragment();
      var x117 = $n(x$1)._3__Llaika_ast_Options();
      var refId = this.Llaika_internal_link_DocumentTargets$$anon$4__f_docId$3;
      var label = this.Llaika_internal_link_DocumentTargets$$anon$4__f_displayId$1;
      return new $c_Llaika_ast_FootnoteLink(refId, label, x117);
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_internal_link_DocumentTargets$$anon$4.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_internal_link_LinkSource__Z($as_Llaika_internal_link_LinkSource(x));
});
$c_Llaika_internal_link_DocumentTargets$$anon$4.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_internal_link_LinkSource__F1__O($as_Llaika_internal_link_LinkSource(x), default$1);
});
var $d_Llaika_internal_link_DocumentTargets$$anon$4 = new $TypeData().initClass($c_Llaika_internal_link_DocumentTargets$$anon$4, "laika.internal.link.DocumentTargets$$anon$4", ({
  Llaika_internal_link_DocumentTargets$$anon$4: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_link_DocumentTargets$$anon$5(displayId$4, docId$8) {
  this.Llaika_internal_link_DocumentTargets$$anon$5__f_displayId$2 = null;
  this.Llaika_internal_link_DocumentTargets$$anon$5__f_docId$4 = null;
  this.Llaika_internal_link_DocumentTargets$$anon$5__f_displayId$2 = displayId$4;
  this.Llaika_internal_link_DocumentTargets$$anon$5__f_docId$4 = docId$8;
}
$c_Llaika_internal_link_DocumentTargets$$anon$5.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_link_DocumentTargets$$anon$5.prototype.constructor = $c_Llaika_internal_link_DocumentTargets$$anon$5;
/** @constructor */
function $h_Llaika_internal_link_DocumentTargets$$anon$5() {
}
$h_Llaika_internal_link_DocumentTargets$$anon$5.prototype = $c_Llaika_internal_link_DocumentTargets$$anon$5.prototype;
$c_Llaika_internal_link_DocumentTargets$$anon$5.prototype.isDefinedAt__Llaika_ast_Block__Z = (function(x) {
  if (false) {
    var x$1 = $as_Llaika_ast_FootnoteDefinition(x);
    $n(x$1)._1__Llaika_ast_FootnoteLabel();
    $n(x$1)._2__sci_Seq();
    $n(x$1)._3__Llaika_parse_SourceFragment();
    $n(x$1)._4__Llaika_ast_Options();
    return true;
  } else {
    return false;
  }
});
$c_Llaika_internal_link_DocumentTargets$$anon$5.prototype.applyOrElse__Llaika_ast_Block__F1__O = (function(x, default$1) {
  if (false) {
    var x$1 = $as_Llaika_ast_FootnoteDefinition(x);
    $n(x$1)._1__Llaika_ast_FootnoteLabel();
    var x129 = $n(x$1)._2__sci_Seq();
    $n(x$1)._3__Llaika_parse_SourceFragment();
    var x131 = $n(x$1)._4__Llaika_ast_Options();
    var label = this.Llaika_internal_link_DocumentTargets$$anon$5__f_displayId$2;
    var options = $n(x131).$plus__Llaika_ast_Options__Llaika_ast_Options($m_Llaika_ast_Id$().apply__T__Llaika_ast_Options(this.Llaika_internal_link_DocumentTargets$$anon$5__f_docId$4));
    return new $c_Llaika_ast_Footnote(label, x129, options);
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_internal_link_DocumentTargets$$anon$5.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Block__Z($as_Llaika_ast_Block(x));
});
$c_Llaika_internal_link_DocumentTargets$$anon$5.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Block__F1__O($as_Llaika_ast_Block(x), default$1);
});
var $d_Llaika_internal_link_DocumentTargets$$anon$5 = new $TypeData().initClass($c_Llaika_internal_link_DocumentTargets$$anon$5, "laika.internal.link.DocumentTargets$$anon$5", ({
  Llaika_internal_link_DocumentTargets$$anon$5: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_link_DocumentTargets$$anon$6(level$2, selector$2) {
  this.Llaika_internal_link_DocumentTargets$$anon$6__f_level$1 = 0;
  this.Llaika_internal_link_DocumentTargets$$anon$6__f_selector$1 = null;
  this.Llaika_internal_link_DocumentTargets$$anon$6__f_level$1 = level$2;
  this.Llaika_internal_link_DocumentTargets$$anon$6__f_selector$1 = selector$2;
}
$c_Llaika_internal_link_DocumentTargets$$anon$6.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_link_DocumentTargets$$anon$6.prototype.constructor = $c_Llaika_internal_link_DocumentTargets$$anon$6;
/** @constructor */
function $h_Llaika_internal_link_DocumentTargets$$anon$6() {
}
$h_Llaika_internal_link_DocumentTargets$$anon$6.prototype = $c_Llaika_internal_link_DocumentTargets$$anon$6.prototype;
$c_Llaika_internal_link_DocumentTargets$$anon$6.prototype.isDefinedAt__Llaika_ast_Block__Z = (function(x) {
  if (false) {
    var x$1 = $as_Llaika_ast_DecoratedHeader(x);
    $n(x$1)._1__Llaika_ast_HeaderDecoration();
    $n(x$1)._2__sci_Seq();
    $n(x$1)._3__Llaika_parse_SourceFragment();
    $n(x$1)._4__Llaika_ast_Options();
    return true;
  } else {
    return false;
  }
});
$c_Llaika_internal_link_DocumentTargets$$anon$6.prototype.applyOrElse__Llaika_ast_Block__F1__O = (function(x, default$1) {
  if (false) {
    var x$1 = $as_Llaika_ast_DecoratedHeader(x);
    $n(x$1)._1__Llaika_ast_HeaderDecoration();
    var x143 = $n(x$1)._2__sci_Seq();
    $n(x$1)._3__Llaika_parse_SourceFragment();
    var x145 = $n(x$1)._4__Llaika_ast_Options();
    var level = this.Llaika_internal_link_DocumentTargets$$anon$6__f_level$1;
    var options = $n(x145).$plus__Llaika_ast_Options__Llaika_ast_Options($m_Llaika_ast_Id$().apply__T__Llaika_ast_Options($n(this.Llaika_internal_link_DocumentTargets$$anon$6__f_selector$1).Llaika_internal_link_TargetIdSelector__f_id));
    return new $c_Llaika_ast_Header(level, x143, options);
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_internal_link_DocumentTargets$$anon$6.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Block__Z($as_Llaika_ast_Block(x));
});
$c_Llaika_internal_link_DocumentTargets$$anon$6.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Block__F1__O($as_Llaika_ast_Block(x), default$1);
});
var $d_Llaika_internal_link_DocumentTargets$$anon$6 = new $TypeData().initClass($c_Llaika_internal_link_DocumentTargets$$anon$6, "laika.internal.link.DocumentTargets$$anon$6", ({
  Llaika_internal_link_DocumentTargets$$anon$6: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_link_DocumentTargets$$anon$7(target$3, title$2) {
  this.Llaika_internal_link_DocumentTargets$$anon$7__f_target$2 = null;
  this.Llaika_internal_link_DocumentTargets$$anon$7__f_title$1 = null;
  this.Llaika_internal_link_DocumentTargets$$anon$7__f_target$2 = target$3;
  this.Llaika_internal_link_DocumentTargets$$anon$7__f_title$1 = title$2;
}
$c_Llaika_internal_link_DocumentTargets$$anon$7.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_link_DocumentTargets$$anon$7.prototype.constructor = $c_Llaika_internal_link_DocumentTargets$$anon$7;
/** @constructor */
function $h_Llaika_internal_link_DocumentTargets$$anon$7() {
}
$h_Llaika_internal_link_DocumentTargets$$anon$7.prototype = $c_Llaika_internal_link_DocumentTargets$$anon$7.prototype;
$c_Llaika_internal_link_DocumentTargets$$anon$7.prototype.isDefinedAt__Llaika_internal_link_LinkSource__Z = (function(x) {
  if ((x !== null)) {
    var this$2 = $n(x);
    var x18 = this$2.Llaika_internal_link_LinkSource__f_span;
    var this$3 = $n(x);
    if ((x18 instanceof $c_Llaika_ast_LinkIdReference)) {
      var x$1 = $as_Llaika_ast_LinkIdReference(x18);
      var this$5 = $n(x$1);
      var this$6 = $n(x$1);
      var this$7 = $n(x$1);
      var this$8 = $n(x$1);
      return true;
    }
    if ((x18 instanceof $c_Llaika_ast_ImageIdReference)) {
      var x$1$1 = $as_Llaika_ast_ImageIdReference(x18);
      var this$10 = $n(x$1$1);
      var this$11 = $n(x$1$1);
      var this$12 = $n(x$1$1);
      var this$13 = $n(x$1$1);
      return true;
    }
  }
  return false;
});
$c_Llaika_internal_link_DocumentTargets$$anon$7.prototype.applyOrElse__Llaika_internal_link_LinkSource__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var this$2 = $n(x);
    var x37 = this$2.Llaika_internal_link_LinkSource__f_span;
    var this$3 = $n(x);
    var x38 = this$3.Llaika_internal_link_LinkSource__f_path;
    if ((x37 instanceof $c_Llaika_ast_LinkIdReference)) {
      var x$1 = $as_Llaika_ast_LinkIdReference(x37);
      var this$5 = $n(x$1);
      var x41 = this$5.Llaika_ast_LinkIdReference__f_content;
      var this$6 = $n(x$1);
      var this$7 = $n(x$1);
      var this$8 = $n(x$1);
      var x44 = this$8.Llaika_ast_LinkIdReference__f_options;
      var target = $m_Llaika_internal_link_ReferenceResolver$().resolveTarget__Llaika_ast_Target__Llaika_ast_Path__Llaika_ast_Target(this.Llaika_internal_link_DocumentTargets$$anon$7__f_target$2, x38);
      var title = this.Llaika_internal_link_DocumentTargets$$anon$7__f_title$1;
      return new $c_Llaika_ast_SpanLink(x41, target, title, x44);
    }
    if ((x37 instanceof $c_Llaika_ast_ImageIdReference)) {
      var x$1$1 = $as_Llaika_ast_ImageIdReference(x37);
      var this$11 = $n(x$1$1);
      var x32 = this$11.Llaika_ast_ImageIdReference__f_text;
      var this$12 = $n(x$1$1);
      var this$13 = $n(x$1$1);
      var this$14 = $n(x$1$1);
      var x35 = this$14.Llaika_ast_ImageIdReference__f_options;
      var target$1 = $m_Llaika_internal_link_ReferenceResolver$().resolveTarget__Llaika_ast_Target__Llaika_ast_Path__Llaika_ast_Target(this.Llaika_internal_link_DocumentTargets$$anon$7__f_target$2, x38);
      var alt$1 = new $c_s_Some(x32);
      var width$1 = $m_s_None$();
      var height$1 = $m_s_None$();
      var title$1 = this.Llaika_internal_link_DocumentTargets$$anon$7__f_title$1;
      return new $c_Llaika_ast_Image(target$1, width$1, height$1, alt$1, title$1, x35);
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_internal_link_DocumentTargets$$anon$7.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_internal_link_LinkSource__Z($as_Llaika_internal_link_LinkSource(x));
});
$c_Llaika_internal_link_DocumentTargets$$anon$7.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_internal_link_LinkSource__F1__O($as_Llaika_internal_link_LinkSource(x), default$1);
});
var $d_Llaika_internal_link_DocumentTargets$$anon$7 = new $TypeData().initClass($c_Llaika_internal_link_DocumentTargets$$anon$7, "laika.internal.link.DocumentTargets$$anon$7", ({
  Llaika_internal_link_DocumentTargets$$anon$7: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_link_LinkAliasResolver(sourceSelector, targetSelector, referenceResolver, formats) {
  this.Llaika_internal_link_TargetResolver__f_selector = null;
  this.Llaika_internal_link_TargetResolver__f_targetFormats = null;
  this.Llaika_internal_link_TargetResolver__f_precedence = 0;
  this.Llaika_internal_link_LinkAliasResolver__f_sourceSelector = null;
  this.Llaika_internal_link_LinkAliasResolver__f_targetSelector = null;
  this.Llaika_internal_link_LinkAliasResolver__f_referenceResolver = null;
  this.Llaika_internal_link_LinkAliasResolver__f_formats = null;
  this.Llaika_internal_link_LinkAliasResolver__f_sourceSelector = sourceSelector;
  this.Llaika_internal_link_LinkAliasResolver__f_targetSelector = targetSelector;
  this.Llaika_internal_link_LinkAliasResolver__f_referenceResolver = referenceResolver;
  this.Llaika_internal_link_LinkAliasResolver__f_formats = formats;
  $ct_Llaika_internal_link_TargetResolver__Llaika_internal_link_Selector__Llaika_config_TargetFormats__I__(this, sourceSelector, formats, 0);
}
$c_Llaika_internal_link_LinkAliasResolver.prototype = new $h_Llaika_internal_link_TargetResolver();
$c_Llaika_internal_link_LinkAliasResolver.prototype.constructor = $c_Llaika_internal_link_LinkAliasResolver;
/** @constructor */
function $h_Llaika_internal_link_LinkAliasResolver() {
}
$h_Llaika_internal_link_LinkAliasResolver.prototype = $c_Llaika_internal_link_LinkAliasResolver.prototype;
$c_Llaika_internal_link_LinkAliasResolver.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_link_LinkAliasResolver.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_link_LinkAliasResolver.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_link_LinkAliasResolver)) {
    var x$0$2 = $as_Llaika_internal_link_LinkAliasResolver(x$0);
    var x = this.Llaika_internal_link_LinkAliasResolver__f_sourceSelector;
    var x$2 = $n(x$0$2).Llaika_internal_link_LinkAliasResolver__f_sourceSelector;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_internal_link_LinkAliasResolver__f_targetSelector;
      var x$4 = $n(x$0$2).Llaika_internal_link_LinkAliasResolver__f_targetSelector;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.Llaika_internal_link_LinkAliasResolver__f_referenceResolver;
      var x$6 = $n(x$0$2).Llaika_internal_link_LinkAliasResolver__f_referenceResolver;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.Llaika_internal_link_LinkAliasResolver__f_formats;
      var x$8 = $n(x$0$2).Llaika_internal_link_LinkAliasResolver__f_formats;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_link_LinkAliasResolver.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_link_LinkAliasResolver.prototype.productArity__I = (function() {
  return 4;
});
$c_Llaika_internal_link_LinkAliasResolver.prototype.productPrefix__T = (function() {
  return "LinkAliasResolver";
});
$c_Llaika_internal_link_LinkAliasResolver.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_internal_link_LinkAliasResolver__f_sourceSelector;
      break;
    }
    case 1: {
      return this.Llaika_internal_link_LinkAliasResolver__f_targetSelector;
      break;
    }
    case 2: {
      return this.Llaika_internal_link_LinkAliasResolver__f_referenceResolver;
      break;
    }
    case 3: {
      return this.Llaika_internal_link_LinkAliasResolver__f_formats;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_internal_link_LinkAliasResolver.prototype.resolveReference__Llaika_internal_link_LinkSource__s_Option = (function(linkSource) {
  return $as_s_Option($n(this.Llaika_internal_link_LinkAliasResolver__f_referenceResolver).apply__O__O(linkSource));
});
$c_Llaika_internal_link_LinkAliasResolver.prototype.replaceTarget__Llaika_ast_Element__s_Option = (function(rewrittenOriginal) {
  return $m_s_None$();
});
$c_Llaika_internal_link_LinkAliasResolver.prototype.circularReference__Llaika_internal_link_LinkAliasResolver = (function() {
  var this$1 = $m_Llaika_internal_link_TargetResolver$();
  var selector = this.Llaika_internal_link_LinkAliasResolver__f_sourceSelector;
  var msg = ("circular link reference: " + $n(this.Llaika_internal_link_LinkAliasResolver__f_targetSelector).Llaika_internal_link_TargetIdSelector__f_id);
  var \u03b41$ = new $c_Llaika_internal_link_TargetResolver$$anon$4(selector, msg, this$1);
  var referenceResolver$1 = new $c_sjsr_AnonFunction1(((linkSource) => {
    var linkSource$1 = $as_Llaika_internal_link_LinkSource(linkSource);
    return $as_s_Option($n(\u03b41$.Llaika_internal_link_TargetResolver$$anon$4__f_resolver).apply__O__O(linkSource$1));
  }));
  var sourceSelector$1 = this.Llaika_internal_link_LinkAliasResolver__f_sourceSelector;
  var targetSelector$1 = this.Llaika_internal_link_LinkAliasResolver__f_targetSelector;
  var formats$1 = this.Llaika_internal_link_LinkAliasResolver__f_formats;
  return new $c_Llaika_internal_link_LinkAliasResolver(sourceSelector$1, targetSelector$1, referenceResolver$1, formats$1);
});
function $as_Llaika_internal_link_LinkAliasResolver(obj) {
  return (((obj instanceof $c_Llaika_internal_link_LinkAliasResolver) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.link.LinkAliasResolver"));
}
function $isArrayOf_Llaika_internal_link_LinkAliasResolver(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_link_LinkAliasResolver)));
}
function $asArrayOf_Llaika_internal_link_LinkAliasResolver(obj, depth) {
  return (($isArrayOf_Llaika_internal_link_LinkAliasResolver(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.link.LinkAliasResolver;", depth));
}
var $d_Llaika_internal_link_LinkAliasResolver = new $TypeData().initClass($c_Llaika_internal_link_LinkAliasResolver, "laika.internal.link.LinkAliasResolver", ({
  Llaika_internal_link_LinkAliasResolver: 1,
  Llaika_internal_link_TargetResolver: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_link_LinkResolver$$anon$1(cursor$14, outer) {
  this.Llaika_internal_link_LinkResolver$$anon$1__f_cursor$9 = null;
  this.Llaika_internal_link_LinkResolver$$anon$1__f_$outer = null;
  this.Llaika_internal_link_LinkResolver$$anon$1__f_cursor$9 = cursor$14;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_internal_link_LinkResolver$$anon$1__f_$outer = outer;
}
$c_Llaika_internal_link_LinkResolver$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_link_LinkResolver$$anon$1.prototype.constructor = $c_Llaika_internal_link_LinkResolver$$anon$1;
/** @constructor */
function $h_Llaika_internal_link_LinkResolver$$anon$1() {
}
$h_Llaika_internal_link_LinkResolver$$anon$1.prototype = $c_Llaika_internal_link_LinkResolver$$anon$1.prototype;
$c_Llaika_internal_link_LinkResolver$$anon$1.prototype.isDefinedAt__Llaika_ast_Block__Z = (function(x) {
  if (false) {
    $as_Llaika_ast_FootnoteDefinition(x);
    return true;
  }
  if ((x instanceof $c_Llaika_ast_Citation)) {
    $as_Llaika_ast_Citation(x);
    return true;
  }
  if (false) {
    $as_Llaika_ast_DecoratedHeader(x);
    return true;
  }
  if ((x instanceof $c_Llaika_ast_Header)) {
    $as_Llaika_ast_Header(x);
    return true;
  }
  if ((x instanceof $c_Llaika_api_bundle_BlockDirectives$DirectiveInstance)) {
    var d = $as_Llaika_api_bundle_BlockDirectives$DirectiveInstance(x);
    var this$1 = $n($n(d).Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_directive);
    if ((!this$1.isEmpty__Z())) {
      var arg1 = this$1.get__O();
      var _$4 = $as_Llaika_api_bundle_DirectiveBuilderContext$Directive(arg1);
      var $x_1 = ($n(_$4).Llaika_api_bundle_DirectiveBuilderContext$Directive__f_name === "fragment");
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return true;
    }
  }
  if ($is_Llaika_ast_Hidden(x)) {
    return true;
  }
  if ($n($as_Llaika_ast_Element(x)).hasId__Z()) {
    return true;
  }
  return false;
});
$c_Llaika_internal_link_LinkResolver$$anon$1.prototype.applyOrElse__Llaika_ast_Block__F1__O = (function(x, default$1) {
  if (false) {
    var f = $as_Llaika_ast_FootnoteDefinition(x);
    var x30 = $n(f).label__Llaika_ast_FootnoteLabel();
    if (false) {
      var x$1 = $as_Llaika_ast_FootnoteLabel$NumericLabel(x30);
      var x36 = $n(x$1)._1__I();
      var $x_2 = $n(this.Llaika_internal_link_LinkResolver$$anon$1__f_$outer);
      var $x_1 = this.Llaika_internal_link_LinkResolver$$anon$1__f_cursor$9;
      var id = ("" + x36);
      return $n($x_2).laika$internal$link$LinkResolver$$_$replaceBlock$1__Llaika_ast_DocumentCursor__Llaika_ast_Block__Llaika_internal_link_Selector__Llaika_ast_RewriteAction($x_1, f, new $c_Llaika_internal_link_TargetIdSelector(id));
    }
    if (false) {
      var x$1$1 = $as_Llaika_ast_FootnoteLabel$AutonumberLabel(x30);
      var x33 = $n(x$1$1)._1__T();
      var $x_4 = $n(this.Llaika_internal_link_LinkResolver$$anon$1__f_$outer);
      var $x_3 = this.Llaika_internal_link_LinkResolver$$anon$1__f_cursor$9;
      var id$1 = $as_T($n($n(this.Llaika_internal_link_LinkResolver$$anon$1__f_$outer).Llaika_internal_link_LinkResolver__f_laika$internal$link$LinkResolver$$slugBuilder).apply__O__O(x33));
      return $n($x_4).laika$internal$link$LinkResolver$$_$replaceBlock$1__Llaika_ast_DocumentCursor__Llaika_ast_Block__Llaika_internal_link_Selector__Llaika_ast_RewriteAction($x_3, f, new $c_Llaika_internal_link_TargetIdSelector(id$1));
    }
    var x$2 = $m_Llaika_ast_FootnoteLabel$Autonumber$();
    if ((x$2 === x30)) {
      return $n(this.Llaika_internal_link_LinkResolver$$anon$1__f_$outer).laika$internal$link$LinkResolver$$_$replaceBlock$1__Llaika_ast_DocumentCursor__Llaika_ast_Block__Llaika_internal_link_Selector__Llaika_ast_RewriteAction(this.Llaika_internal_link_LinkResolver$$anon$1__f_cursor$9, f, $m_Llaika_internal_link_AutonumberSelector$());
    }
    var x$4 = $m_Llaika_ast_FootnoteLabel$Autosymbol$();
    if ((x$4 === x30)) {
      return $n(this.Llaika_internal_link_LinkResolver$$anon$1__f_$outer).laika$internal$link$LinkResolver$$_$replaceBlock$1__Llaika_ast_DocumentCursor__Llaika_ast_Block__Llaika_internal_link_Selector__Llaika_ast_RewriteAction(this.Llaika_internal_link_LinkResolver$$anon$1__f_cursor$9, f, $m_Llaika_internal_link_AutosymbolSelector$());
    }
    throw new $c_s_MatchError(x30);
  }
  if ((x instanceof $c_Llaika_ast_Citation)) {
    var c = $as_Llaika_ast_Citation(x);
    var $x_6 = $n(this.Llaika_internal_link_LinkResolver$$anon$1__f_$outer);
    var $x_5 = this.Llaika_internal_link_LinkResolver$$anon$1__f_cursor$9;
    var id$2 = $as_T($n($n(this.Llaika_internal_link_LinkResolver$$anon$1__f_$outer).Llaika_internal_link_LinkResolver__f_laika$internal$link$LinkResolver$$slugBuilder).apply__O__O($n(c).Llaika_ast_Citation__f_label));
    return $n($x_6).laika$internal$link$LinkResolver$$_$replaceBlock$1__Llaika_ast_DocumentCursor__Llaika_ast_Block__Llaika_internal_link_Selector__Llaika_ast_RewriteAction($x_5, c, new $c_Llaika_internal_link_TargetIdSelector(id$2));
  }
  if (false) {
    var h = $as_Llaika_ast_DecoratedHeader(x);
    var $x_9 = $n(this.Llaika_internal_link_LinkResolver$$anon$1__f_$outer);
    var $x_8 = this.Llaika_internal_link_LinkResolver$$anon$1__f_cursor$9;
    var $x_7 = $n(this.Llaika_internal_link_LinkResolver$$anon$1__f_$outer).Llaika_internal_link_LinkResolver__f_laika$internal$link$LinkResolver$$slugBuilder;
    var this$7 = $n($n($n(h).options__Llaika_ast_Options()).Llaika_ast_Options$Impl__f_id);
    var id$3 = $as_T($n($x_7).apply__O__O((this$7.isEmpty__Z() ? $n(h).extractText__T() : this$7.get__O())));
    return $n($x_9).laika$internal$link$LinkResolver$$_$replaceBlock$1__Llaika_ast_DocumentCursor__Llaika_ast_Block__Llaika_internal_link_Selector__Llaika_ast_RewriteAction($x_8, h, new $c_Llaika_internal_link_TargetIdSelector(id$3));
  }
  if ((x instanceof $c_Llaika_ast_Header)) {
    var h$3 = $as_Llaika_ast_Header(x);
    var $x_13 = $n(this.Llaika_internal_link_LinkResolver$$anon$1__f_$outer);
    var $x_12 = this.Llaika_internal_link_LinkResolver$$anon$1__f_cursor$9;
    var $x_11 = $n(this.Llaika_internal_link_LinkResolver$$anon$1__f_$outer).Llaika_internal_link_LinkResolver__f_laika$internal$link$LinkResolver$$slugBuilder;
    var this$9 = $n($n($n(h$3).Llaika_ast_Header__f_options).Llaika_ast_Options$Impl__f_id);
    if (this$9.isEmpty__Z()) {
      var this$10 = $n(h$3);
      var $x_10 = $f_Llaika_ast_SpanContainer__extractText__T(this$10);
    } else {
      var $x_10 = this$9.get__O();
    }
    var id$4 = $as_T($n($x_11).apply__O__O($x_10));
    return $n($x_13).laika$internal$link$LinkResolver$$_$replaceBlock$1__Llaika_ast_DocumentCursor__Llaika_ast_Block__Llaika_internal_link_Selector__Llaika_ast_RewriteAction($x_12, h$3, new $c_Llaika_internal_link_TargetIdSelector(id$4));
  }
  if ((x instanceof $c_Llaika_api_bundle_BlockDirectives$DirectiveInstance)) {
    var d = $as_Llaika_api_bundle_BlockDirectives$DirectiveInstance(x);
    var this$12 = $n($n(d).Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_directive);
    if ((!this$12.isEmpty__Z())) {
      var arg1 = this$12.get__O();
      var _$4 = $as_Llaika_api_bundle_DirectiveBuilderContext$Directive(arg1);
      var $x_14 = ($n(_$4).Llaika_api_bundle_DirectiveBuilderContext$Directive__f_name === "fragment");
    } else {
      var $x_14 = false;
    }
    if ($x_14) {
      var newValue = $n(d).resolve__Llaika_ast_DocumentCursor__Llaika_ast_Block(this.Llaika_internal_link_LinkResolver$$anon$1__f_cursor$9);
      return new $c_Llaika_ast_RewriteAction$Replace(newValue);
    }
  }
  if ($is_Llaika_ast_Hidden(x)) {
    return $m_Llaika_ast_RewriteAction$Remove$();
  }
  if ($n($as_Llaika_ast_Element(x)).hasId__Z()) {
    var $x_16 = $n(this.Llaika_internal_link_LinkResolver$$anon$1__f_$outer);
    var $x_15 = this.Llaika_internal_link_LinkResolver$$anon$1__f_cursor$9;
    var id$5 = $as_T($n($n(this.Llaika_internal_link_LinkResolver$$anon$1__f_$outer).Llaika_internal_link_LinkResolver__f_laika$internal$link$LinkResolver$$slugBuilder).apply__O__O($n($n($n($as_Llaika_ast_Element(x)).options__Llaika_ast_Options()).Llaika_ast_Options$Impl__f_id).get__O()));
    return $n($x_16).laika$internal$link$LinkResolver$$_$replaceBlock$1__Llaika_ast_DocumentCursor__Llaika_ast_Block__Llaika_internal_link_Selector__Llaika_ast_RewriteAction($x_15, x, new $c_Llaika_internal_link_TargetIdSelector(id$5));
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_internal_link_LinkResolver$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Block__Z($as_Llaika_ast_Block(x));
});
$c_Llaika_internal_link_LinkResolver$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Block__F1__O($as_Llaika_ast_Block(x), default$1);
});
var $d_Llaika_internal_link_LinkResolver$$anon$1 = new $TypeData().initClass($c_Llaika_internal_link_LinkResolver$$anon$1, "laika.internal.link.LinkResolver$$anon$1", ({
  Llaika_internal_link_LinkResolver$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_link_LinkResolver$$anon$2(cursor$16, validator$7, outer) {
  this.Llaika_internal_link_LinkResolver$$anon$2__f_cursor$15 = null;
  this.Llaika_internal_link_LinkResolver$$anon$2__f_validator$6 = null;
  this.Llaika_internal_link_LinkResolver$$anon$2__f_$outer = null;
  this.Llaika_internal_link_LinkResolver$$anon$2__f_cursor$15 = cursor$16;
  this.Llaika_internal_link_LinkResolver$$anon$2__f_validator$6 = validator$7;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_internal_link_LinkResolver$$anon$2__f_$outer = outer;
}
$c_Llaika_internal_link_LinkResolver$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_link_LinkResolver$$anon$2.prototype.constructor = $c_Llaika_internal_link_LinkResolver$$anon$2;
/** @constructor */
function $h_Llaika_internal_link_LinkResolver$$anon$2() {
}
$h_Llaika_internal_link_LinkResolver$$anon$2.prototype = $c_Llaika_internal_link_LinkResolver$$anon$2.prototype;
$c_Llaika_internal_link_LinkResolver$$anon$2.prototype.isDefinedAt__Llaika_ast_Span__Z = (function(x) {
  if (false) {
    var x50 = $as_Llaika_ast_CitationReference(x);
    $n(x50)._1__T();
    $n(x50)._2__Llaika_parse_SourceFragment();
    $n(x50)._3__Llaika_ast_Options();
    return true;
  } else {
    return (false ? ($as_Llaika_ast_FootnoteReference(x), true) : ($is_Llaika_ast_PathReference(x) ? ($as_Llaika_ast_PathReference(x), true) : ((x instanceof $c_Llaika_ast_LinkIdReference) ? ($as_Llaika_ast_LinkIdReference(x), true) : ((x instanceof $c_Llaika_ast_ImageIdReference) ? ($as_Llaika_ast_ImageIdReference(x), true) : ($n($as_Llaika_ast_Element(x)).hasId__Z() || $is_Llaika_ast_Hidden(x))))));
  }
});
$c_Llaika_internal_link_LinkResolver$$anon$2.prototype.applyOrElse__Llaika_ast_Span__F1__O = (function(x, default$1) {
  if (false) {
    var x68 = $as_Llaika_ast_CitationReference(x);
    var x70 = $n(x68)._1__T();
    $n(x68)._2__Llaika_parse_SourceFragment();
    $n(x68)._3__Llaika_ast_Options();
    var this$3 = $n(this.Llaika_internal_link_LinkResolver$$anon$2__f_$outer);
    var cursor$4 = this.Llaika_internal_link_LinkResolver$$anon$2__f_cursor$15;
    var validator$2 = this.Llaika_internal_link_LinkResolver$$anon$2__f_validator$6;
    var id = $as_T($n($n(this.Llaika_internal_link_LinkResolver$$anon$2__f_$outer).Llaika_internal_link_LinkResolver__f_laika$internal$link$LinkResolver$$slugBuilder).apply__O__O(x70));
    var selector = new $c_Llaika_internal_link_TargetIdSelector(id);
    var target = $n(this$3.Llaika_internal_link_LinkResolver__f_targets).select__Llaika_ast_Path__Llaika_internal_link_Selector__s_Option($n(cursor$4).Llaika_ast_DocumentCursor__f_path, selector);
    matchResult4: {
      var resolvedTarget;
      var this$4 = $n(target);
      if (this$4.isEmpty__Z()) {
        var x11 = $m_s_None$();
      } else {
        var arg1 = this$4.get__O();
        var _$3 = $as_Llaika_internal_link_TargetResolver(arg1);
        var $x_1 = $n(_$3);
        var path = $n(cursor$4).Llaika_ast_DocumentCursor__f_path;
        var x11 = $n($x_1).resolveReference__Llaika_internal_link_LinkSource__s_Option(new $c_Llaika_internal_link_LinkSource(x68, path));
      }
      if ((x11 instanceof $c_s_Some)) {
        var x18 = $as_Llaika_ast_Span($n($as_s_Some(x11)).s_Some__f_value);
        if ((x18 instanceof $c_Llaika_ast_SpanLink)) {
          var link = $as_Llaika_ast_SpanLink(x18);
          var resolvedTarget = $n(validator$2).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span(link, $n(x68).source__Llaika_parse_SourceFragment());
          break matchResult4;
        }
        if ((x18 instanceof $c_Llaika_ast_Image)) {
          var img = $as_Llaika_ast_Image(x18);
          var resolvedTarget = $n(validator$2).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span(img, $n(x68).source__Llaika_parse_SourceFragment());
          break matchResult4;
        }
        var resolvedTarget = x18;
        break matchResult4;
      }
      var x$1 = $m_s_None$();
      if ((x$1 === x11)) {
        if ($is_Llaika_ast_PathReference(x68)) {
          var p = $as_Llaika_ast_PathReference(x68);
          var target$2 = $m_Llaika_internal_link_ReferenceResolver$().resolveTarget__Llaika_ast_VirtualPath__Llaika_ast_Path__Llaika_ast_Target($n(p).path__Llaika_ast_VirtualPath(), $n(cursor$4).Llaika_ast_DocumentCursor__f_path);
          var resolvedTarget = $n(validator$2).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span($n(p).resolve__Llaika_ast_Target__Llaika_ast_Link(target$2), $n(x68).source__Llaika_parse_SourceFragment());
          break matchResult4;
        } else {
          var resolvedTarget = $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan(("unresolved citation reference: " + x70), $n(x68).source__Llaika_parse_SourceFragment());
          break matchResult4;
        }
      }
      throw new $c_s_MatchError(x11);
    }
    return new $c_Llaika_ast_RewriteAction$Replace(resolvedTarget);
  } else if (false) {
    var ref = $as_Llaika_ast_FootnoteReference(x);
    var x55 = $n(ref).label__Llaika_ast_FootnoteLabel();
    if (false) {
      var x$1$1 = $as_Llaika_ast_FootnoteLabel$NumericLabel(x55);
      var x61 = $n(x$1$1)._1__I();
      var this$10 = $n(this.Llaika_internal_link_LinkResolver$$anon$2__f_$outer);
      var cursor$4$1 = this.Llaika_internal_link_LinkResolver$$anon$2__f_cursor$15;
      var validator$2$1 = this.Llaika_internal_link_LinkResolver$$anon$2__f_validator$6;
      var id$1 = ("" + x61);
      var selector$1 = new $c_Llaika_internal_link_TargetIdSelector(id$1);
      var target$1 = $n(this$10.Llaika_internal_link_LinkResolver__f_targets).select__Llaika_ast_Path__Llaika_internal_link_Selector__s_Option($n(cursor$4$1).Llaika_ast_DocumentCursor__f_path, selector$1);
      matchResult4$1: {
        var resolvedTarget$1;
        var this$11 = $n(target$1);
        if (this$11.isEmpty__Z()) {
          var x11$1 = $m_s_None$();
        } else {
          var arg1$1 = this$11.get__O();
          var _$3$1 = $as_Llaika_internal_link_TargetResolver(arg1$1);
          var $x_2 = $n(_$3$1);
          var path$1 = $n(cursor$4$1).Llaika_ast_DocumentCursor__f_path;
          var x11$1 = $n($x_2).resolveReference__Llaika_internal_link_LinkSource__s_Option(new $c_Llaika_internal_link_LinkSource(ref, path$1));
        }
        if ((x11$1 instanceof $c_s_Some)) {
          var x18$1 = $as_Llaika_ast_Span($n($as_s_Some(x11$1)).s_Some__f_value);
          if ((x18$1 instanceof $c_Llaika_ast_SpanLink)) {
            var link$1 = $as_Llaika_ast_SpanLink(x18$1);
            var resolvedTarget$1 = $n(validator$2$1).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span(link$1, $n(ref).source__Llaika_parse_SourceFragment());
            break matchResult4$1;
          }
          if ((x18$1 instanceof $c_Llaika_ast_Image)) {
            var img$1 = $as_Llaika_ast_Image(x18$1);
            var resolvedTarget$1 = $n(validator$2$1).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span(img$1, $n(ref).source__Llaika_parse_SourceFragment());
            break matchResult4$1;
          }
          var resolvedTarget$1 = x18$1;
          break matchResult4$1;
        }
        var x$2 = $m_s_None$();
        if ((x$2 === x11$1)) {
          if ($is_Llaika_ast_PathReference(ref)) {
            var p$1 = $as_Llaika_ast_PathReference(ref);
            var target$2$1 = $m_Llaika_internal_link_ReferenceResolver$().resolveTarget__Llaika_ast_VirtualPath__Llaika_ast_Path__Llaika_ast_Target($n(p$1).path__Llaika_ast_VirtualPath(), $n(cursor$4$1).Llaika_ast_DocumentCursor__f_path);
            var resolvedTarget$1 = $n(validator$2$1).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span($n(p$1).resolve__Llaika_ast_Target__Llaika_ast_Link(target$2$1), $n(ref).source__Llaika_parse_SourceFragment());
            break matchResult4$1;
          } else {
            var resolvedTarget$1 = $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan(("unresolved footnote reference: " + x61), $n(ref).source__Llaika_parse_SourceFragment());
            break matchResult4$1;
          }
        }
        throw new $c_s_MatchError(x11$1);
      }
      return new $c_Llaika_ast_RewriteAction$Replace(resolvedTarget$1);
    }
    if (false) {
      var x$1$2 = $as_Llaika_ast_FootnoteLabel$AutonumberLabel(x55);
      var x58 = $n(x$1$2)._1__T();
      var this$16 = $n(this.Llaika_internal_link_LinkResolver$$anon$2__f_$outer);
      var cursor$4$2 = this.Llaika_internal_link_LinkResolver$$anon$2__f_cursor$15;
      var validator$2$2 = this.Llaika_internal_link_LinkResolver$$anon$2__f_validator$6;
      var id$2 = $as_T($n($n(this.Llaika_internal_link_LinkResolver$$anon$2__f_$outer).Llaika_internal_link_LinkResolver__f_laika$internal$link$LinkResolver$$slugBuilder).apply__O__O(x58));
      var selector$2 = new $c_Llaika_internal_link_TargetIdSelector(id$2);
      var target$3 = $n(this$16.Llaika_internal_link_LinkResolver__f_targets).select__Llaika_ast_Path__Llaika_internal_link_Selector__s_Option($n(cursor$4$2).Llaika_ast_DocumentCursor__f_path, selector$2);
      matchResult4$2: {
        var resolvedTarget$2;
        var this$17 = $n(target$3);
        if (this$17.isEmpty__Z()) {
          var x11$2 = $m_s_None$();
        } else {
          var arg1$2 = this$17.get__O();
          var _$3$2 = $as_Llaika_internal_link_TargetResolver(arg1$2);
          var $x_3 = $n(_$3$2);
          var path$2 = $n(cursor$4$2).Llaika_ast_DocumentCursor__f_path;
          var x11$2 = $n($x_3).resolveReference__Llaika_internal_link_LinkSource__s_Option(new $c_Llaika_internal_link_LinkSource(ref, path$2));
        }
        if ((x11$2 instanceof $c_s_Some)) {
          var x18$2 = $as_Llaika_ast_Span($n($as_s_Some(x11$2)).s_Some__f_value);
          if ((x18$2 instanceof $c_Llaika_ast_SpanLink)) {
            var link$2 = $as_Llaika_ast_SpanLink(x18$2);
            var resolvedTarget$2 = $n(validator$2$2).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span(link$2, $n(ref).source__Llaika_parse_SourceFragment());
            break matchResult4$2;
          }
          if ((x18$2 instanceof $c_Llaika_ast_Image)) {
            var img$2 = $as_Llaika_ast_Image(x18$2);
            var resolvedTarget$2 = $n(validator$2$2).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span(img$2, $n(ref).source__Llaika_parse_SourceFragment());
            break matchResult4$2;
          }
          var resolvedTarget$2 = x18$2;
          break matchResult4$2;
        }
        var x$3 = $m_s_None$();
        if ((x$3 === x11$2)) {
          if ($is_Llaika_ast_PathReference(ref)) {
            var p$2 = $as_Llaika_ast_PathReference(ref);
            var target$2$2 = $m_Llaika_internal_link_ReferenceResolver$().resolveTarget__Llaika_ast_VirtualPath__Llaika_ast_Path__Llaika_ast_Target($n(p$2).path__Llaika_ast_VirtualPath(), $n(cursor$4$2).Llaika_ast_DocumentCursor__f_path);
            var resolvedTarget$2 = $n(validator$2$2).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span($n(p$2).resolve__Llaika_ast_Target__Llaika_ast_Link(target$2$2), $n(ref).source__Llaika_parse_SourceFragment());
            break matchResult4$2;
          } else {
            var resolvedTarget$2 = $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan(("unresolved footnote reference: " + x58), $n(ref).source__Llaika_parse_SourceFragment());
            break matchResult4$2;
          }
        }
        throw new $c_s_MatchError(x11$2);
      }
      return new $c_Llaika_ast_RewriteAction$Replace(resolvedTarget$2);
    }
    var x$2$1 = $m_Llaika_ast_FootnoteLabel$Autonumber$();
    if ((x$2$1 === x55)) {
      var this$20 = $n(this.Llaika_internal_link_LinkResolver$$anon$2__f_$outer);
      var cursor$4$3 = this.Llaika_internal_link_LinkResolver$$anon$2__f_cursor$15;
      var validator$2$3 = this.Llaika_internal_link_LinkResolver$$anon$2__f_validator$6;
      var selector$3 = $m_Llaika_internal_link_AutonumberSelector$();
      var target$4 = $n(this$20.Llaika_internal_link_LinkResolver__f_targets).select__Llaika_ast_Path__Llaika_internal_link_Selector__s_Option($n(cursor$4$3).Llaika_ast_DocumentCursor__f_path, selector$3);
      matchResult4$3: {
        var resolvedTarget$3;
        var this$21 = $n(target$4);
        if (this$21.isEmpty__Z()) {
          var x11$3 = $m_s_None$();
        } else {
          var arg1$3 = this$21.get__O();
          var _$3$3 = $as_Llaika_internal_link_TargetResolver(arg1$3);
          var $x_4 = $n(_$3$3);
          var path$3 = $n(cursor$4$3).Llaika_ast_DocumentCursor__f_path;
          var x11$3 = $n($x_4).resolveReference__Llaika_internal_link_LinkSource__s_Option(new $c_Llaika_internal_link_LinkSource(ref, path$3));
        }
        if ((x11$3 instanceof $c_s_Some)) {
          var x18$3 = $as_Llaika_ast_Span($n($as_s_Some(x11$3)).s_Some__f_value);
          if ((x18$3 instanceof $c_Llaika_ast_SpanLink)) {
            var link$3 = $as_Llaika_ast_SpanLink(x18$3);
            var resolvedTarget$3 = $n(validator$2$3).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span(link$3, $n(ref).source__Llaika_parse_SourceFragment());
            break matchResult4$3;
          }
          if ((x18$3 instanceof $c_Llaika_ast_Image)) {
            var img$3 = $as_Llaika_ast_Image(x18$3);
            var resolvedTarget$3 = $n(validator$2$3).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span(img$3, $n(ref).source__Llaika_parse_SourceFragment());
            break matchResult4$3;
          }
          var resolvedTarget$3 = x18$3;
          break matchResult4$3;
        }
        var x$4 = $m_s_None$();
        if ((x$4 === x11$3)) {
          if ($is_Llaika_ast_PathReference(ref)) {
            var p$3 = $as_Llaika_ast_PathReference(ref);
            var target$2$3 = $m_Llaika_internal_link_ReferenceResolver$().resolveTarget__Llaika_ast_VirtualPath__Llaika_ast_Path__Llaika_ast_Target($n(p$3).path__Llaika_ast_VirtualPath(), $n(cursor$4$3).Llaika_ast_DocumentCursor__f_path);
            var resolvedTarget$3 = $n(validator$2$3).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span($n(p$3).resolve__Llaika_ast_Target__Llaika_ast_Link(target$2$3), $n(ref).source__Llaika_parse_SourceFragment());
            break matchResult4$3;
          } else {
            var resolvedTarget$3 = $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan("too many autonumber references", $n(ref).source__Llaika_parse_SourceFragment());
            break matchResult4$3;
          }
        }
        throw new $c_s_MatchError(x11$3);
      }
      return new $c_Llaika_ast_RewriteAction$Replace(resolvedTarget$3);
    }
    var x$4$1 = $m_Llaika_ast_FootnoteLabel$Autosymbol$();
    if ((x$4$1 === x55)) {
      var this$24 = $n(this.Llaika_internal_link_LinkResolver$$anon$2__f_$outer);
      var cursor$4$4 = this.Llaika_internal_link_LinkResolver$$anon$2__f_cursor$15;
      var validator$2$4 = this.Llaika_internal_link_LinkResolver$$anon$2__f_validator$6;
      var selector$4 = $m_Llaika_internal_link_AutosymbolSelector$();
      var target$5 = $n(this$24.Llaika_internal_link_LinkResolver__f_targets).select__Llaika_ast_Path__Llaika_internal_link_Selector__s_Option($n(cursor$4$4).Llaika_ast_DocumentCursor__f_path, selector$4);
      matchResult4$4: {
        var resolvedTarget$4;
        var this$25 = $n(target$5);
        if (this$25.isEmpty__Z()) {
          var x11$4 = $m_s_None$();
        } else {
          var arg1$4 = this$25.get__O();
          var _$3$4 = $as_Llaika_internal_link_TargetResolver(arg1$4);
          var $x_5 = $n(_$3$4);
          var path$4 = $n(cursor$4$4).Llaika_ast_DocumentCursor__f_path;
          var x11$4 = $n($x_5).resolveReference__Llaika_internal_link_LinkSource__s_Option(new $c_Llaika_internal_link_LinkSource(ref, path$4));
        }
        if ((x11$4 instanceof $c_s_Some)) {
          var x18$4 = $as_Llaika_ast_Span($n($as_s_Some(x11$4)).s_Some__f_value);
          if ((x18$4 instanceof $c_Llaika_ast_SpanLink)) {
            var link$4 = $as_Llaika_ast_SpanLink(x18$4);
            var resolvedTarget$4 = $n(validator$2$4).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span(link$4, $n(ref).source__Llaika_parse_SourceFragment());
            break matchResult4$4;
          }
          if ((x18$4 instanceof $c_Llaika_ast_Image)) {
            var img$4 = $as_Llaika_ast_Image(x18$4);
            var resolvedTarget$4 = $n(validator$2$4).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span(img$4, $n(ref).source__Llaika_parse_SourceFragment());
            break matchResult4$4;
          }
          var resolvedTarget$4 = x18$4;
          break matchResult4$4;
        }
        var x$5 = $m_s_None$();
        if ((x$5 === x11$4)) {
          if ($is_Llaika_ast_PathReference(ref)) {
            var p$4 = $as_Llaika_ast_PathReference(ref);
            var target$2$4 = $m_Llaika_internal_link_ReferenceResolver$().resolveTarget__Llaika_ast_VirtualPath__Llaika_ast_Path__Llaika_ast_Target($n(p$4).path__Llaika_ast_VirtualPath(), $n(cursor$4$4).Llaika_ast_DocumentCursor__f_path);
            var resolvedTarget$4 = $n(validator$2$4).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span($n(p$4).resolve__Llaika_ast_Target__Llaika_ast_Link(target$2$4), $n(ref).source__Llaika_parse_SourceFragment());
            break matchResult4$4;
          } else {
            var resolvedTarget$4 = $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan("too many autosymbol references", $n(ref).source__Llaika_parse_SourceFragment());
            break matchResult4$4;
          }
        }
        throw new $c_s_MatchError(x11$4);
      }
      return new $c_Llaika_ast_RewriteAction$Replace(resolvedTarget$4);
    }
    throw new $c_s_MatchError(x55);
  } else if ($is_Llaika_ast_PathReference(x)) {
    var ref$2 = $as_Llaika_ast_PathReference(x);
    var this$28 = $n(this.Llaika_internal_link_LinkResolver$$anon$2__f_$outer);
    var cursor$5 = this.Llaika_internal_link_LinkResolver$$anon$2__f_cursor$15;
    var validator$3 = this.Llaika_internal_link_LinkResolver$$anon$2__f_validator$6;
    var path$5 = $n(ref$2).path__Llaika_ast_VirtualPath();
    var path$6 = $n($n($m_Llaika_ast_InternalTarget$().apply__Llaika_ast_VirtualPath__Llaika_ast_InternalTarget(path$5)).relativeTo__Llaika_ast_Path__Llaika_ast_InternalTarget$Resolved($n(cursor$5).Llaika_ast_DocumentCursor__f_path)).Llaika_ast_InternalTarget$Resolved__f_absolutePath;
    var selector$5 = new $c_Llaika_internal_link_PathSelector(path$6);
    var target$6 = $n(this$28.Llaika_internal_link_LinkResolver__f_targets).select__Llaika_ast_Path__Llaika_internal_link_Selector__s_Option($m_Llaika_ast_Path$Root$(), selector$5);
    matchResult4$5: {
      var resolvedTarget$5;
      var this$30 = $n(target$6);
      if (this$30.isEmpty__Z()) {
        var x11$5 = $m_s_None$();
      } else {
        var arg1$5 = this$30.get__O();
        var _$3$5 = $as_Llaika_internal_link_TargetResolver(arg1$5);
        var $x_6 = $n(_$3$5);
        var path$7 = $n(cursor$5).Llaika_ast_DocumentCursor__f_path;
        var x11$5 = $n($x_6).resolveReference__Llaika_internal_link_LinkSource__s_Option(new $c_Llaika_internal_link_LinkSource(ref$2, path$7));
      }
      if ((x11$5 instanceof $c_s_Some)) {
        var x18$5 = $as_Llaika_ast_Span($n($as_s_Some(x11$5)).s_Some__f_value);
        if ((x18$5 instanceof $c_Llaika_ast_SpanLink)) {
          var link$5 = $as_Llaika_ast_SpanLink(x18$5);
          var resolvedTarget$5 = $n(validator$3).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span(link$5, $n(ref$2).source__Llaika_parse_SourceFragment());
          break matchResult4$5;
        }
        if ((x18$5 instanceof $c_Llaika_ast_Image)) {
          var img$5 = $as_Llaika_ast_Image(x18$5);
          var resolvedTarget$5 = $n(validator$3).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span(img$5, $n(ref$2).source__Llaika_parse_SourceFragment());
          break matchResult4$5;
        }
        var resolvedTarget$5 = x18$5;
        break matchResult4$5;
      }
      var x$6 = $m_s_None$();
      if ((x$6 === x11$5)) {
        if ((ref$2 !== null)) {
          var target$2$5 = $m_Llaika_internal_link_ReferenceResolver$().resolveTarget__Llaika_ast_VirtualPath__Llaika_ast_Path__Llaika_ast_Target($n(ref$2).path__Llaika_ast_VirtualPath(), $n(cursor$5).Llaika_ast_DocumentCursor__f_path);
          var resolvedTarget$5 = $n(validator$3).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span($n(ref$2).resolve__Llaika_ast_Target__Llaika_ast_Link(target$2$5), $n(ref$2).source__Llaika_parse_SourceFragment());
          break matchResult4$5;
        } else {
          var resolvedTarget$5 = $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan(("unresolved internal reference: " + $n($n(ref$2).path__Llaika_ast_VirtualPath()).toString__T()), $n(ref$2).source__Llaika_parse_SourceFragment());
          break matchResult4$5;
        }
      }
      throw new $c_s_MatchError(x11$5);
    }
    return new $c_Llaika_ast_RewriteAction$Replace(resolvedTarget$5);
  } else if ((x instanceof $c_Llaika_ast_LinkIdReference)) {
    var ref$4 = $as_Llaika_ast_LinkIdReference(x);
    var this$33 = $n($n(ref$4).Llaika_ast_LinkIdReference__f_ref);
    if ((this$33 === "")) {
      var this$34 = $n(this.Llaika_internal_link_LinkResolver$$anon$2__f_$outer);
      var cursor$4$5 = this.Llaika_internal_link_LinkResolver$$anon$2__f_cursor$15;
      var validator$2$5 = this.Llaika_internal_link_LinkResolver$$anon$2__f_validator$6;
      var selector$6 = $m_Llaika_internal_link_AnonymousSelector$();
      var target$7 = $n(this$34.Llaika_internal_link_LinkResolver__f_targets).select__Llaika_ast_Path__Llaika_internal_link_Selector__s_Option($n(cursor$4$5).Llaika_ast_DocumentCursor__f_path, selector$6);
      matchResult4$6: {
        var resolvedTarget$6;
        var this$35 = $n(target$7);
        if (this$35.isEmpty__Z()) {
          var x11$6 = $m_s_None$();
        } else {
          var arg1$6 = this$35.get__O();
          var _$3$6 = $as_Llaika_internal_link_TargetResolver(arg1$6);
          var $x_7 = $n(_$3$6);
          var path$8 = $n(cursor$4$5).Llaika_ast_DocumentCursor__f_path;
          var x11$6 = $n($x_7).resolveReference__Llaika_internal_link_LinkSource__s_Option(new $c_Llaika_internal_link_LinkSource(ref$4, path$8));
        }
        if ((x11$6 instanceof $c_s_Some)) {
          var x18$6 = $as_Llaika_ast_Span($n($as_s_Some(x11$6)).s_Some__f_value);
          if ((x18$6 instanceof $c_Llaika_ast_SpanLink)) {
            var link$6 = $as_Llaika_ast_SpanLink(x18$6);
            var resolvedTarget$6 = $n(validator$2$5).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span(link$6, $n(ref$4).Llaika_ast_LinkIdReference__f_source);
            break matchResult4$6;
          }
          if ((x18$6 instanceof $c_Llaika_ast_Image)) {
            var img$6 = $as_Llaika_ast_Image(x18$6);
            var resolvedTarget$6 = $n(validator$2$5).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span(img$6, $n(ref$4).Llaika_ast_LinkIdReference__f_source);
            break matchResult4$6;
          }
          var resolvedTarget$6 = x18$6;
          break matchResult4$6;
        }
        var x$7 = $m_s_None$();
        if ((x$7 === x11$6)) {
          if ($is_Llaika_ast_PathReference(ref$4)) {
            var p$5 = $as_Llaika_ast_PathReference(ref$4);
            var target$2$6 = $m_Llaika_internal_link_ReferenceResolver$().resolveTarget__Llaika_ast_VirtualPath__Llaika_ast_Path__Llaika_ast_Target($n(p$5).path__Llaika_ast_VirtualPath(), $n(cursor$4$5).Llaika_ast_DocumentCursor__f_path);
            var resolvedTarget$6 = $n(validator$2$5).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span($n(p$5).resolve__Llaika_ast_Target__Llaika_ast_Link(target$2$6), $n(ref$4).Llaika_ast_LinkIdReference__f_source);
            break matchResult4$6;
          } else {
            var resolvedTarget$6 = $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan("too many anonymous references", $n(ref$4).Llaika_ast_LinkIdReference__f_source);
            break matchResult4$6;
          }
        }
        throw new $c_s_MatchError(x11$6);
      }
      return new $c_Llaika_ast_RewriteAction$Replace(resolvedTarget$6);
    } else {
      var this$38 = $n(this.Llaika_internal_link_LinkResolver$$anon$2__f_$outer);
      var cursor$13 = this.Llaika_internal_link_LinkResolver$$anon$2__f_cursor$15;
      var validator$5 = this.Llaika_internal_link_LinkResolver$$anon$2__f_validator$6;
      var id$3 = $n(ref$4).Llaika_ast_LinkIdReference__f_ref;
      var this$40 = $n($p_Llaika_internal_link_LinkResolver__selectRecursive$1__Llaika_ast_DocumentCursor__Llaika_internal_link_UniqueSelector__s_Option(this$38, cursor$13, new $c_Llaika_internal_link_LinkDefinitionSelector(id$3)));
      if (this$40.isEmpty__Z()) {
        var id$4 = $as_T($n(this$38.Llaika_internal_link_LinkResolver__f_laika$internal$link$LinkResolver$$slugBuilder).apply__O__O($n(ref$4).Llaika_ast_LinkIdReference__f_ref));
        var target$8 = $p_Llaika_internal_link_LinkResolver__selectRecursive$1__Llaika_ast_DocumentCursor__Llaika_internal_link_UniqueSelector__s_Option(this$38, cursor$13, new $c_Llaika_internal_link_TargetIdSelector(id$4));
      } else {
        var target$8 = this$40;
      }
      matchResult4$7: {
        var resolvedTarget$7;
        var this$42 = $n(target$8);
        if (this$42.isEmpty__Z()) {
          var x11$7 = $m_s_None$();
        } else {
          var arg1$7 = this$42.get__O();
          var _$3$7 = $as_Llaika_internal_link_TargetResolver(arg1$7);
          var $x_8 = $n(_$3$7);
          var path$9 = $n(cursor$13).Llaika_ast_DocumentCursor__f_path;
          var x11$7 = $n($x_8).resolveReference__Llaika_internal_link_LinkSource__s_Option(new $c_Llaika_internal_link_LinkSource(ref$4, path$9));
        }
        if ((x11$7 instanceof $c_s_Some)) {
          var x18$7 = $as_Llaika_ast_Span($n($as_s_Some(x11$7)).s_Some__f_value);
          if ((x18$7 instanceof $c_Llaika_ast_SpanLink)) {
            var link$7 = $as_Llaika_ast_SpanLink(x18$7);
            var resolvedTarget$7 = $n(validator$5).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span(link$7, $n(ref$4).Llaika_ast_LinkIdReference__f_source);
            break matchResult4$7;
          }
          if ((x18$7 instanceof $c_Llaika_ast_Image)) {
            var img$7 = $as_Llaika_ast_Image(x18$7);
            var resolvedTarget$7 = $n(validator$5).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span(img$7, $n(ref$4).Llaika_ast_LinkIdReference__f_source);
            break matchResult4$7;
          }
          var resolvedTarget$7 = x18$7;
          break matchResult4$7;
        }
        var x$8 = $m_s_None$();
        if ((x$8 === x11$7)) {
          if ($is_Llaika_ast_PathReference(ref$4)) {
            var p$6 = $as_Llaika_ast_PathReference(ref$4);
            var target$2$7 = $m_Llaika_internal_link_ReferenceResolver$().resolveTarget__Llaika_ast_VirtualPath__Llaika_ast_Path__Llaika_ast_Target($n(p$6).path__Llaika_ast_VirtualPath(), $n(cursor$13).Llaika_ast_DocumentCursor__f_path);
            var resolvedTarget$7 = $n(validator$5).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span($n(p$6).resolve__Llaika_ast_Target__Llaika_ast_Link(target$2$7), $n(ref$4).Llaika_ast_LinkIdReference__f_source);
            break matchResult4$7;
          } else {
            var resolvedTarget$7 = $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan(("unresolved link id reference: " + $n(ref$4).Llaika_ast_LinkIdReference__f_ref), $n(ref$4).Llaika_ast_LinkIdReference__f_source);
            break matchResult4$7;
          }
        }
        throw new $c_s_MatchError(x11$7);
      }
      return new $c_Llaika_ast_RewriteAction$Replace(resolvedTarget$7);
    }
  } else if ((x instanceof $c_Llaika_ast_ImageIdReference)) {
    var ref$6 = $as_Llaika_ast_ImageIdReference(x);
    var this$46 = $n(this.Llaika_internal_link_LinkResolver$$anon$2__f_$outer);
    var cursor$12 = this.Llaika_internal_link_LinkResolver$$anon$2__f_cursor$15;
    var validator$4 = this.Llaika_internal_link_LinkResolver$$anon$2__f_validator$6;
    var id$5 = $n(ref$6).Llaika_ast_ImageIdReference__f_id;
    var selector$7 = new $c_Llaika_internal_link_LinkDefinitionSelector(id$5);
    var target$9 = $p_Llaika_internal_link_LinkResolver__selectRecursive$1__Llaika_ast_DocumentCursor__Llaika_internal_link_UniqueSelector__s_Option(this$46, cursor$12, selector$7);
    matchResult4$8: {
      var resolvedTarget$8;
      var this$47 = $n(target$9);
      if (this$47.isEmpty__Z()) {
        var x11$8 = $m_s_None$();
      } else {
        var arg1$8 = this$47.get__O();
        var _$3$8 = $as_Llaika_internal_link_TargetResolver(arg1$8);
        var $x_9 = $n(_$3$8);
        var path$10 = $n(cursor$12).Llaika_ast_DocumentCursor__f_path;
        var x11$8 = $n($x_9).resolveReference__Llaika_internal_link_LinkSource__s_Option(new $c_Llaika_internal_link_LinkSource(ref$6, path$10));
      }
      if ((x11$8 instanceof $c_s_Some)) {
        var x18$8 = $as_Llaika_ast_Span($n($as_s_Some(x11$8)).s_Some__f_value);
        if ((x18$8 instanceof $c_Llaika_ast_SpanLink)) {
          var link$8 = $as_Llaika_ast_SpanLink(x18$8);
          var resolvedTarget$8 = $n(validator$4).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span(link$8, $n(ref$6).Llaika_ast_ImageIdReference__f_source);
          break matchResult4$8;
        }
        if ((x18$8 instanceof $c_Llaika_ast_Image)) {
          var img$8 = $as_Llaika_ast_Image(x18$8);
          var resolvedTarget$8 = $n(validator$4).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span(img$8, $n(ref$6).Llaika_ast_ImageIdReference__f_source);
          break matchResult4$8;
        }
        var resolvedTarget$8 = x18$8;
        break matchResult4$8;
      }
      var x$9 = $m_s_None$();
      if ((x$9 === x11$8)) {
        if ($is_Llaika_ast_PathReference(ref$6)) {
          var p$7 = $as_Llaika_ast_PathReference(ref$6);
          var target$2$8 = $m_Llaika_internal_link_ReferenceResolver$().resolveTarget__Llaika_ast_VirtualPath__Llaika_ast_Path__Llaika_ast_Target($n(p$7).path__Llaika_ast_VirtualPath(), $n(cursor$12).Llaika_ast_DocumentCursor__f_path);
          var resolvedTarget$8 = $n(validator$4).validateAndRecover__Llaika_ast_Link__Llaika_parse_SourceFragment__Llaika_ast_Span($n(p$7).resolve__Llaika_ast_Target__Llaika_ast_Link(target$2$8), $n(ref$6).Llaika_ast_ImageIdReference__f_source);
          break matchResult4$8;
        } else {
          var resolvedTarget$8 = $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan(("unresolved image reference: " + $n(ref$6).Llaika_ast_ImageIdReference__f_id), $n(ref$6).Llaika_ast_ImageIdReference__f_source);
          break matchResult4$8;
        }
      }
      throw new $c_s_MatchError(x11$8);
    }
    return new $c_Llaika_ast_RewriteAction$Replace(resolvedTarget$8);
  } else if ($n($as_Llaika_ast_Element(x)).hasId__Z()) {
    var $x_11 = $n(this.Llaika_internal_link_LinkResolver$$anon$2__f_$outer);
    var $x_10 = this.Llaika_internal_link_LinkResolver$$anon$2__f_cursor$15;
    var id$6 = $as_T($n($n(this.Llaika_internal_link_LinkResolver$$anon$2__f_$outer).Llaika_internal_link_LinkResolver__f_laika$internal$link$LinkResolver$$slugBuilder).apply__O__O($n($n($n($as_Llaika_ast_Element(x)).options__Llaika_ast_Options()).Llaika_ast_Options$Impl__f_id).get__O()));
    return $n($x_11).laika$internal$link$LinkResolver$$_$replaceSpan$1__Llaika_ast_DocumentCursor__Llaika_ast_Span__Llaika_internal_link_Selector__Llaika_ast_RewriteAction($x_10, x, new $c_Llaika_internal_link_TargetIdSelector(id$6));
  } else {
    return ($is_Llaika_ast_Hidden(x) ? $m_Llaika_ast_RewriteAction$Remove$() : $n(default$1).apply__O__O(x));
  }
});
$c_Llaika_internal_link_LinkResolver$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Span__Z($as_Llaika_ast_Span(x));
});
$c_Llaika_internal_link_LinkResolver$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Span__F1__O($as_Llaika_ast_Span(x), default$1);
});
var $d_Llaika_internal_link_LinkResolver$$anon$2 = new $TypeData().initClass($c_Llaika_internal_link_LinkResolver$$anon$2, "laika.internal.link.LinkResolver$$anon$2", ({
  Llaika_internal_link_LinkResolver$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_link_ReferenceResolver$$anon$1(target$2, outer) {
  this.Llaika_internal_link_ReferenceResolver$$anon$1__f_target$1 = null;
  this.Llaika_internal_link_ReferenceResolver$$anon$1__f_target$1 = target$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_internal_link_ReferenceResolver$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_link_ReferenceResolver$$anon$1.prototype.constructor = $c_Llaika_internal_link_ReferenceResolver$$anon$1;
/** @constructor */
function $h_Llaika_internal_link_ReferenceResolver$$anon$1() {
}
$h_Llaika_internal_link_ReferenceResolver$$anon$1.prototype = $c_Llaika_internal_link_ReferenceResolver$$anon$1.prototype;
$c_Llaika_internal_link_ReferenceResolver$$anon$1.prototype.isDefinedAt__Llaika_internal_link_LinkSource__Z = (function(x) {
  if ((x !== null)) {
    var this$2 = $n(x);
    var x16 = this$2.Llaika_internal_link_LinkSource__f_span;
    var this$3 = $n(x);
    if ($is_Llaika_ast_PathReference(x16)) {
      $as_Llaika_ast_PathReference(x16);
      return true;
    }
    if ((x16 instanceof $c_Llaika_ast_LinkIdReference)) {
      var x$1 = $as_Llaika_ast_LinkIdReference(x16);
      var this$5 = $n(x$1);
      var this$6 = $n(x$1);
      var this$7 = $n(x$1);
      var this$8 = $n(x$1);
      return true;
    }
  }
  return false;
});
$c_Llaika_internal_link_ReferenceResolver$$anon$1.prototype.applyOrElse__Llaika_internal_link_LinkSource__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var this$2 = $n(x);
    var x30 = this$2.Llaika_internal_link_LinkSource__f_span;
    var this$3 = $n(x);
    var x31 = this$3.Llaika_internal_link_LinkSource__f_path;
    if ($is_Llaika_ast_PathReference(x30)) {
      var ref = $as_Llaika_ast_PathReference(x30);
      return $n(ref).resolve__Llaika_ast_Target__Llaika_ast_Link($n($m_Llaika_ast_InternalTarget$().apply__Llaika_ast_VirtualPath__Llaika_ast_InternalTarget(this.Llaika_internal_link_ReferenceResolver$$anon$1__f_target$1)).relativeTo__Llaika_ast_Path__Llaika_ast_InternalTarget$Resolved(x31));
    }
    if ((x30 instanceof $c_Llaika_ast_LinkIdReference)) {
      var x$1 = $as_Llaika_ast_LinkIdReference(x30);
      var this$5 = $n(x$1);
      var x25 = this$5.Llaika_ast_LinkIdReference__f_content;
      var this$6 = $n(x$1);
      var this$7 = $n(x$1);
      var this$8 = $n(x$1);
      var x28 = this$8.Llaika_ast_LinkIdReference__f_options;
      var target = $n($m_Llaika_ast_InternalTarget$().apply__Llaika_ast_VirtualPath__Llaika_ast_InternalTarget(this.Llaika_internal_link_ReferenceResolver$$anon$1__f_target$1)).relativeTo__Llaika_ast_Path__Llaika_ast_InternalTarget$Resolved(x31);
      var title = $m_s_None$();
      return new $c_Llaika_ast_SpanLink(x25, target, title, x28);
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_internal_link_ReferenceResolver$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_internal_link_LinkSource__Z($as_Llaika_internal_link_LinkSource(x));
});
$c_Llaika_internal_link_ReferenceResolver$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_internal_link_LinkSource__F1__O($as_Llaika_internal_link_LinkSource(x), default$1);
});
var $d_Llaika_internal_link_ReferenceResolver$$anon$1 = new $TypeData().initClass($c_Llaika_internal_link_ReferenceResolver$$anon$1, "laika.internal.link.ReferenceResolver$$anon$1", ({
  Llaika_internal_link_ReferenceResolver$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_link_TargetLookup$$anon$1() {
}
$c_Llaika_internal_link_TargetLookup$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_link_TargetLookup$$anon$1.prototype.constructor = $c_Llaika_internal_link_TargetLookup$$anon$1;
/** @constructor */
function $h_Llaika_internal_link_TargetLookup$$anon$1() {
}
$h_Llaika_internal_link_TargetLookup$$anon$1.prototype = $c_Llaika_internal_link_TargetLookup$$anon$1.prototype;
$c_Llaika_internal_link_TargetLookup$$anon$1.prototype.isDefinedAt__Llaika_ast_Element__Z = (function(x) {
  return $n(x).hasId__Z();
});
$c_Llaika_internal_link_TargetLookup$$anon$1.prototype.applyOrElse__Llaika_ast_Element__F1__O = (function(x, default$1) {
  return ($n(x).hasId__Z() ? $n($n(x).options__Llaika_ast_Options()).Llaika_ast_Options$Impl__f_id : $n(default$1).apply__O__O(x));
});
$c_Llaika_internal_link_TargetLookup$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Element__Z($as_Llaika_ast_Element(x));
});
$c_Llaika_internal_link_TargetLookup$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Element__F1__O($as_Llaika_ast_Element(x), default$1);
});
var $d_Llaika_internal_link_TargetLookup$$anon$1 = new $TypeData().initClass($c_Llaika_internal_link_TargetLookup$$anon$1, "laika.internal.link.TargetLookup$$anon$1", ({
  Llaika_internal_link_TargetLookup$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_link_TargetResolver$$anon$5(msg$3, outer) {
  this.Llaika_internal_link_TargetResolver$$anon$5__f_msg$2 = null;
  this.Llaika_internal_link_TargetResolver$$anon$5__f_msg$2 = msg$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_internal_link_TargetResolver$$anon$5.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_link_TargetResolver$$anon$5.prototype.constructor = $c_Llaika_internal_link_TargetResolver$$anon$5;
/** @constructor */
function $h_Llaika_internal_link_TargetResolver$$anon$5() {
}
$h_Llaika_internal_link_TargetResolver$$anon$5.prototype = $c_Llaika_internal_link_TargetResolver$$anon$5.prototype;
$c_Llaika_internal_link_TargetResolver$$anon$5.prototype.isDefinedAt__Llaika_internal_link_LinkSource__Z = (function(x) {
  if ((x !== null)) {
    var this$2 = $n(x);
    var x44 = this$2.Llaika_internal_link_LinkSource__f_span;
    var this$3 = $n(x);
    if ($is_Llaika_ast_Reference(x44)) {
      $as_Llaika_ast_Reference(x44);
      return true;
    }
  }
  return false;
});
$c_Llaika_internal_link_TargetResolver$$anon$5.prototype.applyOrElse__Llaika_internal_link_LinkSource__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var this$2 = $n(x);
    var x49 = this$2.Llaika_internal_link_LinkSource__f_span;
    var this$3 = $n(x);
    if ($is_Llaika_ast_Reference(x49)) {
      var ref = $as_Llaika_ast_Reference(x49);
      return $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan(this.Llaika_internal_link_TargetResolver$$anon$5__f_msg$2, $n(ref).source__Llaika_parse_SourceFragment());
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_internal_link_TargetResolver$$anon$5.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_internal_link_LinkSource__Z($as_Llaika_internal_link_LinkSource(x));
});
$c_Llaika_internal_link_TargetResolver$$anon$5.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_internal_link_LinkSource__F1__O($as_Llaika_internal_link_LinkSource(x), default$1);
});
var $d_Llaika_internal_link_TargetResolver$$anon$5 = new $TypeData().initClass($c_Llaika_internal_link_TargetResolver$$anon$5, "laika.internal.link.TargetResolver$$anon$5", ({
  Llaika_internal_link_TargetResolver$$anon$5: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_link_TargetResolver$$anon$7(uniqueSelector$3, path$3, outer) {
  this.Llaika_internal_link_TargetResolver$$anon$7__f_uniqueSelector$2 = null;
  this.Llaika_internal_link_TargetResolver$$anon$7__f_path$2 = null;
  this.Llaika_internal_link_TargetResolver$$anon$7__f_uniqueSelector$2 = uniqueSelector$3;
  this.Llaika_internal_link_TargetResolver$$anon$7__f_path$2 = path$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_internal_link_TargetResolver$$anon$7.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_link_TargetResolver$$anon$7.prototype.constructor = $c_Llaika_internal_link_TargetResolver$$anon$7;
/** @constructor */
function $h_Llaika_internal_link_TargetResolver$$anon$7() {
}
$h_Llaika_internal_link_TargetResolver$$anon$7.prototype = $c_Llaika_internal_link_TargetResolver$$anon$7.prototype;
$c_Llaika_internal_link_TargetResolver$$anon$7.prototype.isDefinedAt__Llaika_internal_link_LinkSource__Z = (function(x) {
  if ((x !== null)) {
    var this$2 = $n(x);
    var x57 = this$2.Llaika_internal_link_LinkSource__f_span;
    var this$3 = $n(x);
    if ($is_Llaika_ast_Reference(x57)) {
      $as_Llaika_ast_Reference(x57);
      return true;
    }
  }
  return false;
});
$c_Llaika_internal_link_TargetResolver$$anon$7.prototype.applyOrElse__Llaika_internal_link_LinkSource__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var this$2 = $n(x);
    var x62 = this$2.Llaika_internal_link_LinkSource__f_span;
    var this$3 = $n(x);
    if ($is_Llaika_ast_Reference(x62)) {
      var ref = $as_Llaika_ast_Reference(x62);
      return $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan(((("Ambiguous reference: more than one " + $n(this.Llaika_internal_link_TargetResolver$$anon$7__f_uniqueSelector$2).description__T()) + " in path ") + this.Llaika_internal_link_TargetResolver$$anon$7__f_path$2), $n(ref).source__Llaika_parse_SourceFragment());
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_internal_link_TargetResolver$$anon$7.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_internal_link_LinkSource__Z($as_Llaika_internal_link_LinkSource(x));
});
$c_Llaika_internal_link_TargetResolver$$anon$7.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_internal_link_LinkSource__F1__O($as_Llaika_internal_link_LinkSource(x), default$1);
});
var $d_Llaika_internal_link_TargetResolver$$anon$7 = new $TypeData().initClass($c_Llaika_internal_link_TargetResolver$$anon$7, "laika.internal.link.TargetResolver$$anon$7", ({
  Llaika_internal_link_TargetResolver$$anon$7: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
function $p_Llaika_internal_link_TargetSequenceResolver__nextOption__sc_Iterator__s_Option($thiz, it) {
  if ($n(it).hasNext__Z()) {
    var value = $n(it).next__O();
    return new $c_s_Some(value);
  } else {
    return $m_s_None$();
  }
}
/** @constructor */
function $c_Llaika_internal_link_TargetSequenceResolver(targets, sel) {
  this.Llaika_internal_link_TargetResolver__f_selector = null;
  this.Llaika_internal_link_TargetResolver__f_targetFormats = null;
  this.Llaika_internal_link_TargetResolver__f_precedence = 0;
  this.Llaika_internal_link_TargetSequenceResolver__f_targets = null;
  this.Llaika_internal_link_TargetSequenceResolver__f_sel = null;
  this.Llaika_internal_link_TargetSequenceResolver__f_refIt = null;
  this.Llaika_internal_link_TargetSequenceResolver__f_targetIt = null;
  this.Llaika_internal_link_TargetSequenceResolver__f_targets = targets;
  this.Llaika_internal_link_TargetSequenceResolver__f_sel = sel;
  $ct_Llaika_internal_link_TargetResolver__Llaika_internal_link_Selector__Llaika_config_TargetFormats__I__(this, sel, $m_Llaika_config_TargetFormats$All$(), 0);
  this.Llaika_internal_link_TargetSequenceResolver__f_refIt = $n(targets).iterator__sc_Iterator();
  this.Llaika_internal_link_TargetSequenceResolver__f_targetIt = $n(targets).iterator__sc_Iterator();
}
$c_Llaika_internal_link_TargetSequenceResolver.prototype = new $h_Llaika_internal_link_TargetResolver();
$c_Llaika_internal_link_TargetSequenceResolver.prototype.constructor = $c_Llaika_internal_link_TargetSequenceResolver;
/** @constructor */
function $h_Llaika_internal_link_TargetSequenceResolver() {
}
$h_Llaika_internal_link_TargetSequenceResolver.prototype = $c_Llaika_internal_link_TargetSequenceResolver.prototype;
$c_Llaika_internal_link_TargetSequenceResolver.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_link_TargetSequenceResolver.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_link_TargetSequenceResolver.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_link_TargetSequenceResolver)) {
    var x$0$2 = $as_Llaika_internal_link_TargetSequenceResolver(x$0);
    var x = this.Llaika_internal_link_TargetSequenceResolver__f_targets;
    var x$2 = $n(x$0$2).Llaika_internal_link_TargetSequenceResolver__f_targets;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_internal_link_TargetSequenceResolver__f_sel;
      var x$4 = $n(x$0$2).Llaika_internal_link_TargetSequenceResolver__f_sel;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_link_TargetSequenceResolver.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_link_TargetSequenceResolver.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_internal_link_TargetSequenceResolver.prototype.productPrefix__T = (function() {
  return "TargetSequenceResolver";
});
$c_Llaika_internal_link_TargetSequenceResolver.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_link_TargetSequenceResolver__f_targets;
  }
  if ((n === 1)) {
    return this.Llaika_internal_link_TargetSequenceResolver__f_sel;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_internal_link_TargetSequenceResolver.prototype.resolveReference__Llaika_internal_link_LinkSource__s_Option = (function(linkSource) {
  var this$1 = $n($p_Llaika_internal_link_TargetSequenceResolver__nextOption__sc_Iterator__s_Option(this, this.Llaika_internal_link_TargetSequenceResolver__f_refIt));
  if (this$1.isEmpty__Z()) {
    return $m_s_None$();
  } else {
    var arg1 = this$1.get__O();
    var _$3 = $as_Llaika_internal_link_TargetResolver(arg1);
    return $n(_$3).resolveReference__Llaika_internal_link_LinkSource__s_Option(linkSource);
  }
});
$c_Llaika_internal_link_TargetSequenceResolver.prototype.replaceTarget__Llaika_ast_Element__s_Option = (function(rewrittenOriginal) {
  var this$1 = $n($p_Llaika_internal_link_TargetSequenceResolver__nextOption__sc_Iterator__s_Option(this, this.Llaika_internal_link_TargetSequenceResolver__f_targetIt));
  if (this$1.isEmpty__Z()) {
    return $m_s_None$();
  } else {
    var arg1 = this$1.get__O();
    var _$4 = $as_Llaika_internal_link_TargetResolver(arg1);
    return $n(_$4).replaceTarget__Llaika_ast_Element__s_Option(rewrittenOriginal);
  }
});
function $as_Llaika_internal_link_TargetSequenceResolver(obj) {
  return (((obj instanceof $c_Llaika_internal_link_TargetSequenceResolver) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.link.TargetSequenceResolver"));
}
function $isArrayOf_Llaika_internal_link_TargetSequenceResolver(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_link_TargetSequenceResolver)));
}
function $asArrayOf_Llaika_internal_link_TargetSequenceResolver(obj, depth) {
  return (($isArrayOf_Llaika_internal_link_TargetSequenceResolver(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.link.TargetSequenceResolver;", depth));
}
var $d_Llaika_internal_link_TargetSequenceResolver = new $TypeData().initClass($c_Llaika_internal_link_TargetSequenceResolver, "laika.internal.link.TargetSequenceResolver", ({
  Llaika_internal_link_TargetSequenceResolver: 1,
  Llaika_internal_link_TargetResolver: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_link_TreeTargets$$anon$1() {
}
$c_Llaika_internal_link_TreeTargets$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_link_TreeTargets$$anon$1.prototype.constructor = $c_Llaika_internal_link_TreeTargets$$anon$1;
/** @constructor */
function $h_Llaika_internal_link_TreeTargets$$anon$1() {
}
$h_Llaika_internal_link_TreeTargets$$anon$1.prototype = $c_Llaika_internal_link_TreeTargets$$anon$1.prototype;
$c_Llaika_internal_link_TreeTargets$$anon$1.prototype.isDefinedAt__T2__Z = (function(x) {
  if ((x !== null)) {
    var x7 = $as_T2($n(x)._1__O());
    var x8 = $as_sci_Seq($n(x)._2__O());
    if ((x8 !== null)) {
      if (($n(x8).lengthCompare__I__I(1) === 0)) {
        var x10 = $as_T2($n(x8).apply__I__O(0));
        if ((x10 !== null)) {
          $as_Llaika_internal_link_TargetResolver($n(x10)._2__O());
          return true;
        }
      }
    }
    if ((x7 !== null)) {
      var x5 = $as_Llaika_internal_link_Selector($n(x7)._2__O());
      $as_Llaika_ast_Path($n(x7)._1__O());
      if ($is_Llaika_internal_link_UniqueSelector(x5)) {
        $as_Llaika_internal_link_UniqueSelector(x5);
        return true;
      }
    }
  }
  return false;
});
$c_Llaika_internal_link_TreeTargets$$anon$1.prototype.applyOrElse__T2__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var x19 = $as_T2($n(x)._1__O());
    var x20 = $as_sci_Seq($n(x)._2__O());
    if ((x20 !== null)) {
      if (($n(x20).lengthCompare__I__I(1) === 0)) {
        var x22 = $as_T2($n(x20).apply__I__O(0));
        if ((x22 !== null)) {
          var target = $as_Llaika_internal_link_TargetResolver($n(x22)._2__O());
          return new $c_T2(x19, target);
        }
      }
    }
    if ((x19 !== null)) {
      var x17 = $as_Llaika_internal_link_Selector($n(x19)._2__O());
      var path = $as_Llaika_ast_Path($n(x19)._1__O());
      if ($is_Llaika_internal_link_UniqueSelector(x17)) {
        var selector = $as_Llaika_internal_link_UniqueSelector(x17);
        var _1 = new $c_T2(path, selector);
        var this$6 = $m_Llaika_internal_link_TargetResolver$();
        var targets = $as_sci_Seq($n(x20).map__F1__O(new $c_sjsr_AnonFunction1(((_$3) => {
          var _$3$1 = $as_T2(_$3);
          return $as_Llaika_internal_link_TargetResolver($n(_$3$1)._2__O());
        }))));
        var _2 = new $c_Llaika_internal_link_TargetResolver$$anon$6(selector, targets, false, path, this$6);
        return new $c_T2(_1, _2);
      }
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_internal_link_TreeTargets$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z($as_T2(x));
});
$c_Llaika_internal_link_TreeTargets$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O($as_T2(x), default$1);
});
var $d_Llaika_internal_link_TreeTargets$$anon$1 = new $TypeData().initClass($c_Llaika_internal_link_TreeTargets$$anon$1, "laika.internal.link.TreeTargets$$anon$1", ({
  Llaika_internal_link_TreeTargets$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_markdown_HTMLParsers$$anon$1() {
}
$c_Llaika_internal_markdown_HTMLParsers$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_markdown_HTMLParsers$$anon$1.prototype.constructor = $c_Llaika_internal_markdown_HTMLParsers$$anon$1;
/** @constructor */
function $h_Llaika_internal_markdown_HTMLParsers$$anon$1() {
}
$h_Llaika_internal_markdown_HTMLParsers$$anon$1.prototype = $c_Llaika_internal_markdown_HTMLParsers$$anon$1.prototype;
$c_Llaika_internal_markdown_HTMLParsers$$anon$1.prototype.isDefinedAt__Llaika_ast_html_HTMLStartTag__Z = (function(x) {
  if ((x !== null)) {
    var this$2 = $n(x);
    var x18 = this$2.Llaika_ast_html_HTMLStartTag__f_name;
    var this$3 = $n(x);
    var this$4 = $n(x);
    if ($n($m_Llaika_internal_markdown_HTMLParsers$().Llaika_internal_markdown_HTMLParsers$__f_laika$internal$markdown$HTMLParsers$$$htmlBlockElements).contains__O__Z(x18)) {
      return true;
    }
  }
  return false;
});
$c_Llaika_internal_markdown_HTMLParsers$$anon$1.prototype.applyOrElse__Llaika_ast_html_HTMLStartTag__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var this$2 = $n(x);
    var x23 = this$2.Llaika_ast_html_HTMLStartTag__f_name;
    var this$3 = $n(x);
    var this$4 = $n(x);
    if ($n($m_Llaika_internal_markdown_HTMLParsers$().Llaika_internal_markdown_HTMLParsers$__f_laika$internal$markdown$HTMLParsers$$$htmlBlockElements).contains__O__Z(x23)) {
      return x;
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_internal_markdown_HTMLParsers$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_html_HTMLStartTag__Z($as_Llaika_ast_html_HTMLStartTag(x));
});
$c_Llaika_internal_markdown_HTMLParsers$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_html_HTMLStartTag__F1__O($as_Llaika_ast_html_HTMLStartTag(x), default$1);
});
var $d_Llaika_internal_markdown_HTMLParsers$$anon$1 = new $TypeData().initClass($c_Llaika_internal_markdown_HTMLParsers$$anon$1, "laika.internal.markdown.HTMLParsers$$anon$1", ({
  Llaika_internal_markdown_HTMLParsers$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_markdown_HTMLParsers$$anon$2(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_internal_markdown_HTMLParsers$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_markdown_HTMLParsers$$anon$2.prototype.constructor = $c_Llaika_internal_markdown_HTMLParsers$$anon$2;
/** @constructor */
function $h_Llaika_internal_markdown_HTMLParsers$$anon$2() {
}
$h_Llaika_internal_markdown_HTMLParsers$$anon$2.prototype = $c_Llaika_internal_markdown_HTMLParsers$$anon$2.prototype;
$c_Llaika_internal_markdown_HTMLParsers$$anon$2.prototype.isDefinedAt__Llaika_ast_Span__Z = (function(x) {
  return ($is_Llaika_ast_TextContainer(x) && ($as_Llaika_ast_Span($as_Llaika_ast_TextContainer(x)), true));
});
$c_Llaika_internal_markdown_HTMLParsers$$anon$2.prototype.applyOrElse__Llaika_ast_Span__F1__O = (function(x, default$1) {
  if ($is_Llaika_ast_TextContainer(x)) {
    var tc = $as_Llaika_ast_Span($as_Llaika_ast_TextContainer(x));
    return tc;
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_internal_markdown_HTMLParsers$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Span__Z($as_Llaika_ast_Span(x));
});
$c_Llaika_internal_markdown_HTMLParsers$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Span__F1__O($as_Llaika_ast_Span(x), default$1);
});
var $d_Llaika_internal_markdown_HTMLParsers$$anon$2 = new $TypeData().initClass($c_Llaika_internal_markdown_HTMLParsers$$anon$2, "laika.internal.markdown.HTMLParsers$$anon$2", ({
  Llaika_internal_markdown_HTMLParsers$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_markdown_InlineParsers$$anon$1() {
}
$c_Llaika_internal_markdown_InlineParsers$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_markdown_InlineParsers$$anon$1.prototype.constructor = $c_Llaika_internal_markdown_InlineParsers$$anon$1;
/** @constructor */
function $h_Llaika_internal_markdown_InlineParsers$$anon$1() {
}
$h_Llaika_internal_markdown_InlineParsers$$anon$1.prototype = $c_Llaika_internal_markdown_InlineParsers$$anon$1.prototype;
$c_Llaika_internal_markdown_InlineParsers$$anon$1.prototype.isDefinedAt__T__Z = (function(x) {
  return ($m_Llaika_internal_markdown_InlineParsers$().laika$internal$markdown$InlineParsers$$$_$isURI$1__T__Z(x) || $m_Llaika_internal_markdown_InlineParsers$().laika$internal$markdown$InlineParsers$$$_$isEmail$1__T__Z(x));
});
$c_Llaika_internal_markdown_InlineParsers$$anon$1.prototype.applyOrElse__T__F1__O = (function(x, default$1) {
  return ($m_Llaika_internal_markdown_InlineParsers$().laika$internal$markdown$InlineParsers$$$_$isURI$1__T__Z(x) ? $m_Llaika_internal_markdown_InlineParsers$().laika$internal$markdown$InlineParsers$$$_$toLink$1__T__Llaika_ast_SpanLink(x) : ($m_Llaika_internal_markdown_InlineParsers$().laika$internal$markdown$InlineParsers$$$_$isEmail$1__T__Z(x) ? $m_Llaika_internal_markdown_InlineParsers$().laika$internal$markdown$InlineParsers$$$_$toLink$1__T__Llaika_ast_SpanLink(("mailto:" + x)) : $n(default$1).apply__O__O(x)));
});
$c_Llaika_internal_markdown_InlineParsers$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T__Z($as_T(x));
});
$c_Llaika_internal_markdown_InlineParsers$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T__F1__O($as_T(x), default$1);
});
var $d_Llaika_internal_markdown_InlineParsers$$anon$1 = new $TypeData().initClass($c_Llaika_internal_markdown_InlineParsers$$anon$1, "laika.internal.markdown.InlineParsers$$anon$1", ({
  Llaika_internal_markdown_InlineParsers$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_markdown_InlineParsers$TargetId(id) {
  this.Llaika_internal_markdown_InlineParsers$TargetId__f_id = null;
  this.Llaika_internal_markdown_InlineParsers$TargetId__f_id = id;
}
$c_Llaika_internal_markdown_InlineParsers$TargetId.prototype = new $h_O();
$c_Llaika_internal_markdown_InlineParsers$TargetId.prototype.constructor = $c_Llaika_internal_markdown_InlineParsers$TargetId;
/** @constructor */
function $h_Llaika_internal_markdown_InlineParsers$TargetId() {
}
$h_Llaika_internal_markdown_InlineParsers$TargetId.prototype = $c_Llaika_internal_markdown_InlineParsers$TargetId.prototype;
$c_Llaika_internal_markdown_InlineParsers$TargetId.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_markdown_InlineParsers$TargetId.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_markdown_InlineParsers$TargetId.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_markdown_InlineParsers$TargetId)) {
    var x$0$2 = $as_Llaika_internal_markdown_InlineParsers$TargetId(x$0);
    return ((this.Llaika_internal_markdown_InlineParsers$TargetId__f_id === $n(x$0$2).Llaika_internal_markdown_InlineParsers$TargetId__f_id) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Llaika_internal_markdown_InlineParsers$TargetId.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_markdown_InlineParsers$TargetId.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_internal_markdown_InlineParsers$TargetId.prototype.productPrefix__T = (function() {
  return "TargetId";
});
$c_Llaika_internal_markdown_InlineParsers$TargetId.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_markdown_InlineParsers$TargetId__f_id;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_internal_markdown_InlineParsers$TargetId(obj) {
  return (((obj instanceof $c_Llaika_internal_markdown_InlineParsers$TargetId) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.markdown.InlineParsers$TargetId"));
}
function $isArrayOf_Llaika_internal_markdown_InlineParsers$TargetId(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_markdown_InlineParsers$TargetId)));
}
function $asArrayOf_Llaika_internal_markdown_InlineParsers$TargetId(obj, depth) {
  return (($isArrayOf_Llaika_internal_markdown_InlineParsers$TargetId(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.markdown.InlineParsers$TargetId;", depth));
}
var $d_Llaika_internal_markdown_InlineParsers$TargetId = new $TypeData().initClass($c_Llaika_internal_markdown_InlineParsers$TargetId, "laika.internal.markdown.InlineParsers$TargetId", ({
  Llaika_internal_markdown_InlineParsers$TargetId: 1,
  Llaika_internal_markdown_InlineParsers$ResourceTarget: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_markdown_InlineParsers$TargetUrl(url, title) {
  this.Llaika_internal_markdown_InlineParsers$TargetUrl__f_url = null;
  this.Llaika_internal_markdown_InlineParsers$TargetUrl__f_title = null;
  this.Llaika_internal_markdown_InlineParsers$TargetUrl__f_url = url;
  this.Llaika_internal_markdown_InlineParsers$TargetUrl__f_title = title;
}
$c_Llaika_internal_markdown_InlineParsers$TargetUrl.prototype = new $h_O();
$c_Llaika_internal_markdown_InlineParsers$TargetUrl.prototype.constructor = $c_Llaika_internal_markdown_InlineParsers$TargetUrl;
/** @constructor */
function $h_Llaika_internal_markdown_InlineParsers$TargetUrl() {
}
$h_Llaika_internal_markdown_InlineParsers$TargetUrl.prototype = $c_Llaika_internal_markdown_InlineParsers$TargetUrl.prototype;
$c_Llaika_internal_markdown_InlineParsers$TargetUrl.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_markdown_InlineParsers$TargetUrl.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_markdown_InlineParsers$TargetUrl.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_markdown_InlineParsers$TargetUrl)) {
    var x$0$2 = $as_Llaika_internal_markdown_InlineParsers$TargetUrl(x$0);
    if ((this.Llaika_internal_markdown_InlineParsers$TargetUrl__f_url === $n(x$0$2).Llaika_internal_markdown_InlineParsers$TargetUrl__f_url)) {
      var x = this.Llaika_internal_markdown_InlineParsers$TargetUrl__f_title;
      var x$2 = $n(x$0$2).Llaika_internal_markdown_InlineParsers$TargetUrl__f_title;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_markdown_InlineParsers$TargetUrl.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_markdown_InlineParsers$TargetUrl.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_internal_markdown_InlineParsers$TargetUrl.prototype.productPrefix__T = (function() {
  return "TargetUrl";
});
$c_Llaika_internal_markdown_InlineParsers$TargetUrl.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_markdown_InlineParsers$TargetUrl__f_url;
  }
  if ((n === 1)) {
    return this.Llaika_internal_markdown_InlineParsers$TargetUrl__f_title;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_internal_markdown_InlineParsers$TargetUrl(obj) {
  return (((obj instanceof $c_Llaika_internal_markdown_InlineParsers$TargetUrl) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.markdown.InlineParsers$TargetUrl"));
}
function $isArrayOf_Llaika_internal_markdown_InlineParsers$TargetUrl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_markdown_InlineParsers$TargetUrl)));
}
function $asArrayOf_Llaika_internal_markdown_InlineParsers$TargetUrl(obj, depth) {
  return (($isArrayOf_Llaika_internal_markdown_InlineParsers$TargetUrl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.markdown.InlineParsers$TargetUrl;", depth));
}
var $d_Llaika_internal_markdown_InlineParsers$TargetUrl = new $TypeData().initClass($c_Llaika_internal_markdown_InlineParsers$TargetUrl, "laika.internal.markdown.InlineParsers$TargetUrl", ({
  Llaika_internal_markdown_InlineParsers$TargetUrl: 1,
  Llaika_internal_markdown_InlineParsers$ResourceTarget: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_markdown_bundle_HTMLRenderer$$anon$1() {
}
$c_Llaika_internal_markdown_bundle_HTMLRenderer$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_markdown_bundle_HTMLRenderer$$anon$1.prototype.constructor = $c_Llaika_internal_markdown_bundle_HTMLRenderer$$anon$1;
/** @constructor */
function $h_Llaika_internal_markdown_bundle_HTMLRenderer$$anon$1() {
}
$h_Llaika_internal_markdown_bundle_HTMLRenderer$$anon$1.prototype = $c_Llaika_internal_markdown_bundle_HTMLRenderer$$anon$1.prototype;
$c_Llaika_internal_markdown_bundle_HTMLRenderer$$anon$1.prototype.isDefinedAt__T2__Z = (function(x) {
  if ((x !== null)) {
    $as_Llaika_api_format_TagFormatter($n(x)._1__O());
    var x76 = $as_Llaika_ast_Element($n(x)._2__O());
    if ((x76 instanceof $c_Llaika_ast_html_HTMLElement)) {
      var x$1 = $as_Llaika_ast_html_HTMLElement(x76);
      var this$2 = $n(x$1);
      var x79 = this$2.Llaika_ast_html_HTMLElement__f_startTag;
      var this$3 = $n(x$1);
      var this$4 = $n(x$1);
      if ((x79 !== null)) {
        var this$6 = $n(x79);
        var x83 = this$6.Llaika_ast_html_HTMLStartTag__f_name;
        var this$7 = $n(x79);
        var this$8 = $n(x79);
        if ((x83 === "pre")) {
          return true;
        }
      }
      return true;
    }
    if ((x76 instanceof $c_Llaika_ast_html_HTMLStartTag)) {
      var x$1$1 = $as_Llaika_ast_html_HTMLStartTag(x76);
      var this$10 = $n(x$1$1);
      var this$11 = $n(x$1$1);
      var this$12 = $n(x$1$1);
      return true;
    }
    if ((x76 instanceof $c_Llaika_ast_html_HTMLEmptyElement)) {
      var x$1$2 = $as_Llaika_ast_html_HTMLEmptyElement(x76);
      var this$14 = $n(x$1$2);
      var this$15 = $n(x$1$2);
      var this$16 = $n(x$1$2);
      return true;
    }
    if ((x76 instanceof $c_Llaika_ast_html_HTMLEndTag)) {
      var x$1$3 = $as_Llaika_ast_html_HTMLEndTag(x76);
      var this$18 = $n(x$1$3);
      var this$19 = $n(x$1$3);
      return true;
    }
    if ((x76 instanceof $c_Llaika_ast_html_HTMLComment)) {
      var x$1$4 = $as_Llaika_ast_html_HTMLComment(x76);
      var this$21 = $n(x$1$4);
      var this$22 = $n(x$1$4);
      return true;
    }
    if ((x76 instanceof $c_Llaika_ast_html_HTMLScriptElement)) {
      var x$1$5 = $as_Llaika_ast_html_HTMLScriptElement(x76);
      var this$24 = $n(x$1$5);
      var this$25 = $n(x$1$5);
      var this$26 = $n(x$1$5);
      return true;
    }
    if ((x76 instanceof $c_Llaika_ast_html_HTMLCharacterReference)) {
      var x$1$6 = $as_Llaika_ast_html_HTMLCharacterReference(x76);
      var this$28 = $n(x$1$6);
      var this$29 = $n(x$1$6);
      return true;
    }
    if ((x76 instanceof $c_Llaika_ast_html_HTMLBlock)) {
      var x$1$7 = $as_Llaika_ast_html_HTMLBlock(x76);
      var this$31 = $n(x$1$7);
      var this$32 = $n(x$1$7);
      return true;
    }
  }
  return false;
});
$c_Llaika_internal_markdown_bundle_HTMLRenderer$$anon$1.prototype.applyOrElse__T2__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var x139 = $as_Llaika_api_format_TagFormatter($n(x)._1__O());
    var x140 = $as_Llaika_ast_Element($n(x)._2__O());
    if ((x140 instanceof $c_Llaika_ast_html_HTMLElement)) {
      var x$1 = $as_Llaika_ast_html_HTMLElement(x140);
      var this$2 = $n(x$1);
      var x143 = this$2.Llaika_ast_html_HTMLElement__f_startTag;
      var this$3 = $n(x$1);
      var x144 = this$3.Llaika_ast_html_HTMLElement__f_content;
      var this$4 = $n(x$1);
      if ((x143 !== null)) {
        var this$6 = $n(x143);
        var x147 = this$6.Llaika_ast_html_HTMLStartTag__f_name;
        var this$7 = $n(x143);
        var this$8 = $n(x143);
        if ((x147 === "pre")) {
          var $x_1 = $n(x139).child__Llaika_ast_Element__T(x143);
          var this$9 = $n(x139);
          var newIndentation = $m_Llaika_api_format_Formatter$Indentation$().Llaika_api_format_Formatter$Indentation$__f_none;
          var arg1 = this$9.withIndentation__Llaika_api_format_Formatter$Indentation__Llaika_api_format_TagFormatter(newIndentation);
          return (((("" + $x_1) + $n(arg1).children__sci_Seq__T(x144)) + ("</" + $n(x143).Llaika_ast_html_HTMLStartTag__f_name)) + ">");
        }
      }
      return (((("" + $n(x139).child__Llaika_ast_Element__T(x143)) + $n(x139).children__sci_Seq__T(x144)) + ("</" + $n(x143).Llaika_ast_html_HTMLStartTag__f_name)) + ">");
    }
    if ((x140 instanceof $c_Llaika_ast_html_HTMLStartTag)) {
      var x$1$1 = $as_Llaika_ast_html_HTMLStartTag(x140);
      var this$11 = $n(x$1$1);
      var x129 = this$11.Llaika_ast_html_HTMLStartTag__f_name;
      var this$12 = $n(x$1$1);
      var x130 = this$12.Llaika_ast_html_HTMLStartTag__f_attributes;
      var this$13 = $n(x$1$1);
      return ($m_Llaika_internal_markdown_bundle_HTMLRenderer$().laika$internal$markdown$bundle$HTMLRenderer$$$tagStart__T__sci_List__T(x129, x130) + ">");
    }
    if ((x140 instanceof $c_Llaika_ast_html_HTMLEmptyElement)) {
      var x$1$2 = $as_Llaika_ast_html_HTMLEmptyElement(x140);
      var this$15 = $n(x$1$2);
      var x122 = this$15.Llaika_ast_html_HTMLEmptyElement__f_name;
      var this$16 = $n(x$1$2);
      var x123 = this$16.Llaika_ast_html_HTMLEmptyElement__f_attributes;
      var this$17 = $n(x$1$2);
      return ($m_Llaika_internal_markdown_bundle_HTMLRenderer$().laika$internal$markdown$bundle$HTMLRenderer$$$tagStart__T__sci_List__T(x122, x123) + "/>");
    }
    if ((x140 instanceof $c_Llaika_ast_html_HTMLEndTag)) {
      var x$1$3 = $as_Llaika_ast_html_HTMLEndTag(x140);
      var this$19 = $n(x$1$3);
      var x116 = this$19.Llaika_ast_html_HTMLEndTag__f_name;
      var this$20 = $n(x$1$3);
      return (("</" + x116) + ">");
    }
    if ((x140 instanceof $c_Llaika_ast_html_HTMLComment)) {
      var x$1$4 = $as_Llaika_ast_html_HTMLComment(x140);
      var this$22 = $n(x$1$4);
      var x110 = this$22.Llaika_ast_html_HTMLComment__f_content;
      var this$23 = $n(x$1$4);
      return (("<!--" + x110) + "-->");
    }
    if ((x140 instanceof $c_Llaika_ast_html_HTMLScriptElement)) {
      var x$1$5 = $as_Llaika_ast_html_HTMLScriptElement(x140);
      var this$25 = $n(x$1$5);
      var x103 = this$25.Llaika_ast_html_HTMLScriptElement__f_attributes;
      var this$26 = $n(x$1$5);
      var x104 = this$26.Llaika_ast_html_HTMLScriptElement__f_content;
      var this$27 = $n(x$1$5);
      return (($m_Llaika_internal_markdown_bundle_HTMLRenderer$().laika$internal$markdown$bundle$HTMLRenderer$$$tagStart__T__sci_List__T("script", x103) + (">" + x104)) + "</script>");
    }
    if ((x140 instanceof $c_Llaika_ast_html_HTMLCharacterReference)) {
      var x$1$6 = $as_Llaika_ast_html_HTMLCharacterReference(x140);
      var this$29 = $n(x$1$6);
      var x97 = this$29.Llaika_ast_html_HTMLCharacterReference__f_content;
      var this$30 = $n(x$1$6);
      return x97;
    }
    if ((x140 instanceof $c_Llaika_ast_html_HTMLBlock)) {
      var x$1$7 = $as_Llaika_ast_html_HTMLBlock(x140);
      var this$32 = $n(x$1$7);
      var x91 = this$32.Llaika_ast_html_HTMLBlock__f_root;
      var this$33 = $n(x$1$7);
      return $n(x139).child__Llaika_ast_Element__T(x91);
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_internal_markdown_bundle_HTMLRenderer$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z($as_T2(x));
});
$c_Llaika_internal_markdown_bundle_HTMLRenderer$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O($as_T2(x), default$1);
});
var $d_Llaika_internal_markdown_bundle_HTMLRenderer$$anon$1 = new $TypeData().initClass($c_Llaika_internal_markdown_bundle_HTMLRenderer$$anon$1, "laika.internal.markdown.bundle.HTMLRenderer$$anon$1", ({
  Llaika_internal_markdown_bundle_HTMLRenderer$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_markdown_github_Tables$$anon$1() {
}
$c_Llaika_internal_markdown_github_Tables$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_markdown_github_Tables$$anon$1.prototype.constructor = $c_Llaika_internal_markdown_github_Tables$$anon$1;
/** @constructor */
function $h_Llaika_internal_markdown_github_Tables$$anon$1() {
}
$h_Llaika_internal_markdown_github_Tables$$anon$1.prototype = $c_Llaika_internal_markdown_github_Tables$$anon$1.prototype;
$c_Llaika_internal_markdown_github_Tables$$anon$1.prototype.isDefinedAt__Llaika_parse_builders$$tilde__Z = (function(x) {
  if ((x !== null)) {
    var cells = $as_sci_List($n(x).Llaika_parse_builders$$tilde__f__1);
    var optFinal = $as_s_Option($n(x).Llaika_parse_builders$$tilde__f__2);
    var this$2 = $n(cells);
    if ((!this$2.isEmpty__Z())) {
      var $x_1 = true;
    } else {
      var this$3 = $n(optFinal);
      var $x_1 = (!this$3.isEmpty__Z());
    }
    if ($x_1) {
      return true;
    }
  }
  return false;
});
$c_Llaika_internal_markdown_github_Tables$$anon$1.prototype.applyOrElse__Llaika_parse_builders$$tilde__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var cells = $as_sci_List($n(x).Llaika_parse_builders$$tilde__f__1);
    var optFinal = $as_s_Option($n(x).Llaika_parse_builders$$tilde__f__2);
    var this$2 = $n(cells);
    if ((!this$2.isEmpty__Z())) {
      var $x_1 = true;
    } else {
      var this$3 = $n(optFinal);
      var $x_1 = (!this$3.isEmpty__Z());
    }
    if ($x_1) {
      var this$4 = $n(cells);
      var suffix = $n($m_s_Option$().option2Iterable__s_Option__sc_Iterable(optFinal)).toSeq__sci_Seq();
      var content = this$4.appendedAll__sc_IterableOnce__sci_List(suffix);
      var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      return new $c_Llaika_ast_Row(content, options);
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_internal_markdown_github_Tables$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_parse_builders$$tilde__Z($as_Llaika_parse_builders$$tilde(x));
});
$c_Llaika_internal_markdown_github_Tables$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_parse_builders$$tilde__F1__O($as_Llaika_parse_builders$$tilde(x), default$1);
});
var $d_Llaika_internal_markdown_github_Tables$$anon$1 = new $TypeData().initClass($c_Llaika_internal_markdown_github_Tables$$anon$1, "laika.internal.markdown.github.Tables$$anon$1", ({
  Llaika_internal_markdown_github_Tables$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_markdown_github_Tables$$anon$2(Header$lzy1$4) {
  this.Llaika_internal_markdown_github_Tables$$anon$2__f_Header$lzy1$3 = null;
  this.Llaika_internal_markdown_github_Tables$$anon$2__f_Header$lzy1$3 = Header$lzy1$4;
}
$c_Llaika_internal_markdown_github_Tables$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_markdown_github_Tables$$anon$2.prototype.constructor = $c_Llaika_internal_markdown_github_Tables$$anon$2;
/** @constructor */
function $h_Llaika_internal_markdown_github_Tables$$anon$2() {
}
$h_Llaika_internal_markdown_github_Tables$$anon$2.prototype = $c_Llaika_internal_markdown_github_Tables$$anon$2.prototype;
$c_Llaika_internal_markdown_github_Tables$$anon$2.prototype.isDefinedAt__Llaika_parse_builders$$tilde__Z = (function(x) {
  if ((x !== null)) {
    var row = $as_Llaika_ast_Row($n(x).Llaika_parse_builders$$tilde__f__1);
    var sep = $as_sci_Seq($n(x).Llaika_parse_builders$$tilde__f__2);
    var this$2 = $n($n(row).Llaika_ast_Row__f_content);
    var $x_1 = this$2.length__I();
    var this$3 = $n(sep);
    if (($x_1 === this$3.length__I())) {
      return true;
    }
  }
  return false;
});
$c_Llaika_internal_markdown_github_Tables$$anon$2.prototype.applyOrElse__Llaika_parse_builders$$tilde__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var row = $as_Llaika_ast_Row($n(x).Llaika_parse_builders$$tilde__f__1);
    var sep = $as_sci_Seq($n(x).Llaika_parse_builders$$tilde__f__2);
    var this$2 = $n($n(row).Llaika_ast_Row__f_content);
    var $x_1 = this$2.length__I();
    var this$3 = $n(sep);
    if (($x_1 === this$3.length__I())) {
      $n($m_Llaika_internal_markdown_github_Tables$().laika$internal$markdown$github$Tables$$$_$Header$2__sr_LazyRef__Llaika_internal_markdown_github_Tables$Header$3$(this.Llaika_internal_markdown_github_Tables$$anon$2__f_Header$lzy1$3));
      return new $c_Llaika_internal_markdown_github_Tables$Header$1(row, sep);
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_internal_markdown_github_Tables$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_parse_builders$$tilde__Z($as_Llaika_parse_builders$$tilde(x));
});
$c_Llaika_internal_markdown_github_Tables$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_parse_builders$$tilde__F1__O($as_Llaika_parse_builders$$tilde(x), default$1);
});
var $d_Llaika_internal_markdown_github_Tables$$anon$2 = new $TypeData().initClass($c_Llaika_internal_markdown_github_Tables$$anon$2, "laika.internal.markdown.github.Tables$$anon$2", ({
  Llaika_internal_markdown_github_Tables$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$1(outer) {
  this.Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$1__f_$outer = outer;
}
$c_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$1.prototype.constructor = $c_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$1;
/** @constructor */
function $h_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$1() {
}
$h_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$1.prototype = $c_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$1.prototype;
$c_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$1.prototype.isDefinedAt__Llaika_ast_Block__Z = (function(x) {
  return ((x instanceof $c_Llaika_ast_RootElement) && ($as_Llaika_ast_RootElement(x), true));
});
$c_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$1.prototype.applyOrElse__Llaika_ast_Block__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Llaika_ast_RootElement)) {
    var root = $as_Llaika_ast_RootElement(x);
    var newValue = $n(this.Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$1__f_$outer).buildSections__Llaika_ast_RootElement__Llaika_ast_RootElement(root);
    return new $c_Llaika_ast_RewriteAction$Replace(newValue);
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Block__Z($as_Llaika_ast_Block(x));
});
$c_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Block__F1__O($as_Llaika_ast_Block(x), default$1);
});
var $d_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$1 = new $TypeData().initClass($c_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$1, "laika.internal.nav.SectionBuilder$DefaultRule$$anon$1", ({
  Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$2(docPosition$2, outer) {
  this.Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$2__f_docPosition$1 = null;
  this.Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$2__f_$outer = null;
  this.Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$2__f_docPosition$1 = docPosition$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$2__f_$outer = outer;
}
$c_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$2.prototype.constructor = $c_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$2;
/** @constructor */
function $h_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$2() {
}
$h_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$2.prototype = $c_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$2.prototype;
$c_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$2.prototype.isDefinedAt__Llaika_ast_Block__Z = (function(x) {
  return ((x instanceof $c_Llaika_ast_Header) && ($as_Llaika_ast_Header(x), true));
});
$c_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$2.prototype.applyOrElse__Llaika_ast_Block__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Llaika_ast_Header)) {
    var h = $as_Llaika_ast_Header(x);
    if ($n($n(this.Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$2__f_$outer).Llaika_internal_nav_SectionBuilder$DefaultRule__f_laika$internal$nav$SectionBuilder$DefaultRule$$autonumberConfig).Llaika_config_AutonumberConfig$Impl__f_documents) {
      var content = $n(this.Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$2__f_$outer).addNumber__sci_Seq__Llaika_ast_TreePosition__sci_Seq($n(h).Llaika_ast_Header__f_content, this.Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$2__f_docPosition$1);
      var options = $n($n(h).Llaika_ast_Header__f_options).$plus__Llaika_ast_Options__Llaika_ast_Options($m_Llaika_ast_Style$().Llaika_ast_Style$__f_title);
      return new $c_Llaika_ast_Title(content, options);
    } else {
      var content$1 = $n(h).Llaika_ast_Header__f_content;
      var options$1 = $n($n(h).Llaika_ast_Header__f_options).$plus__Llaika_ast_Options__Llaika_ast_Options($m_Llaika_ast_Style$().Llaika_ast_Style$__f_title);
      return new $c_Llaika_ast_Title(content$1, options$1);
    }
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Block__Z($as_Llaika_ast_Block(x));
});
$c_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Block__F1__O($as_Llaika_ast_Block(x), default$1);
});
var $d_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$2 = new $TypeData().initClass($c_Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$2, "laika.internal.nav.SectionBuilder$DefaultRule$$anon$2", ({
  Llaika_internal_nav_SectionBuilder$DefaultRule$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_css_CSSParsers$$anon$1() {
}
$c_Llaika_internal_parse_css_CSSParsers$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_parse_css_CSSParsers$$anon$1.prototype.constructor = $c_Llaika_internal_parse_css_CSSParsers$$anon$1;
/** @constructor */
function $h_Llaika_internal_parse_css_CSSParsers$$anon$1() {
}
$h_Llaika_internal_parse_css_CSSParsers$$anon$1.prototype = $c_Llaika_internal_parse_css_CSSParsers$$anon$1.prototype;
$c_Llaika_internal_parse_css_CSSParsers$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return ((x instanceof $c_Llaika_internal_parse_css_CSSParsers$Style) && ($as_Llaika_internal_parse_css_CSSParsers$Style(x), true));
});
$c_Llaika_internal_parse_css_CSSParsers$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Llaika_internal_parse_css_CSSParsers$Style)) {
    var st = $as_Llaika_internal_parse_css_CSSParsers$Style(x);
    var _1 = $n(st).Llaika_internal_parse_css_CSSParsers$Style__f_name;
    var _2 = $n(st).Llaika_internal_parse_css_CSSParsers$Style__f_value;
    return new $c_T2(_1, _2);
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
var $d_Llaika_internal_parse_css_CSSParsers$$anon$1 = new $TypeData().initClass($c_Llaika_internal_parse_css_CSSParsers$$anon$1, "laika.internal.parse.css.CSSParsers$$anon$1", ({
  Llaika_internal_parse_css_CSSParsers$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_directive_TemplateParsers(directives) {
  this.Llaika_internal_parse_directive_TemplateParsers__f_escapedChar$lzy1 = null;
  this.Llaika_internal_parse_directive_TemplateParsers__f_escapedCharbitmap$1 = false;
  this.Llaika_internal_parse_directive_TemplateParsers__f_escapeSequence$lzy1 = null;
  this.Llaika_internal_parse_directive_TemplateParsers__f_escapeSequencebitmap$1 = false;
  this.Llaika_internal_parse_directive_TemplateParsers__f_defaultSpanParser$lzy1 = null;
  this.Llaika_internal_parse_directive_TemplateParsers__f_defaultSpanParserbitmap$1 = false;
  this.Llaika_internal_parse_directive_TemplateParsers__f_directives = null;
  this.Llaika_internal_parse_directive_TemplateParsers__f_spanParsers$lzy1 = null;
  this.Llaika_internal_parse_directive_TemplateParsers__f_spanParsersbitmap$1 = false;
  this.Llaika_internal_parse_directive_TemplateParsers__f_templateDirective$lzy1 = null;
  this.Llaika_internal_parse_directive_TemplateParsers__f_templateDirectivebitmap$1 = false;
  this.Llaika_internal_parse_directive_TemplateParsers__f_templateSpans$lzy1 = null;
  this.Llaika_internal_parse_directive_TemplateParsers__f_templateSpansbitmap$1 = false;
  this.Llaika_internal_parse_directive_TemplateParsers__f_templateRoot$lzy1 = null;
  this.Llaika_internal_parse_directive_TemplateParsers__f_templateRootbitmap$1 = false;
  this.Llaika_internal_parse_directive_TemplateParsers__f_directives = directives;
}
$c_Llaika_internal_parse_directive_TemplateParsers.prototype = new $h_O();
$c_Llaika_internal_parse_directive_TemplateParsers.prototype.constructor = $c_Llaika_internal_parse_directive_TemplateParsers;
/** @constructor */
function $h_Llaika_internal_parse_directive_TemplateParsers() {
}
$h_Llaika_internal_parse_directive_TemplateParsers.prototype = $c_Llaika_internal_parse_directive_TemplateParsers.prototype;
$c_Llaika_internal_parse_directive_TemplateParsers.prototype.escapedChar__Llaika_parse_Parser = (function() {
  if ((!this.Llaika_internal_parse_directive_TemplateParsers__f_escapedCharbitmap$1)) {
    this.Llaika_internal_parse_directive_TemplateParsers__f_escapedChar$lzy1 = $m_Llaika_parse_text_TextParsers$().Llaika_parse_text_TextParsers$__f_oneChar;
    this.Llaika_internal_parse_directive_TemplateParsers__f_escapedCharbitmap$1 = true;
  }
  return this.Llaika_internal_parse_directive_TemplateParsers__f_escapedChar$lzy1;
});
$c_Llaika_internal_parse_directive_TemplateParsers.prototype.escapeSequence__Llaika_parse_text_PrefixedParser = (function() {
  if ((!this.Llaika_internal_parse_directive_TemplateParsers__f_escapeSequencebitmap$1)) {
    this.Llaika_internal_parse_directive_TemplateParsers__f_escapeSequence$lzy1 = $f_Llaika_internal_parse_markup_DefaultEscapedTextParsers__escapeSequence__Llaika_parse_text_PrefixedParser(this);
    this.Llaika_internal_parse_directive_TemplateParsers__f_escapeSequencebitmap$1 = true;
  }
  return this.Llaika_internal_parse_directive_TemplateParsers__f_escapeSequence$lzy1;
});
$c_Llaika_internal_parse_directive_TemplateParsers.prototype.defaultSpanParser__Llaika_parse_markup_InlineParser = (function() {
  if ((!this.Llaika_internal_parse_directive_TemplateParsers__f_defaultSpanParserbitmap$1)) {
    this.Llaika_internal_parse_directive_TemplateParsers__f_defaultSpanParser$lzy1 = $f_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers__defaultSpanParser__Llaika_parse_markup_InlineParser(this);
    this.Llaika_internal_parse_directive_TemplateParsers__f_defaultSpanParserbitmap$1 = true;
  }
  return this.Llaika_internal_parse_directive_TemplateParsers__f_defaultSpanParser$lzy1;
});
$c_Llaika_internal_parse_directive_TemplateParsers.prototype.spanParsers__sci_Seq = (function() {
  if ((!this.Llaika_internal_parse_directive_TemplateParsers__f_spanParsersbitmap$1)) {
    this.Llaika_internal_parse_directive_TemplateParsers__f_spanParsers$lzy1 = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_parse_text_PrefixedParser.getArrayOf().constr)([$m_Llaika_internal_parse_directive_DirectiveParsers$().hoconReference__F3__F1__Llaika_parse_text_PrefixedParser(new $c_sjsr_AnonFunction3(((_$1, _$2, _$3) => {
      var _$1$1 = $as_Llaika_api_config_Key(_$1);
      var _$2$1 = $uZ(_$2);
      var _$3$1 = $as_Llaika_parse_SourceFragment(_$3);
      var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      return new $c_Llaika_ast_TemplateContextReference(_$1$1, _$2$1, _$3$1, options);
    })), new $c_sjsr_AnonFunction1(((_$4) => {
      var _$4$1 = $as_Llaika_ast_InvalidSpan(_$4);
      var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      return new $c_Llaika_ast_TemplateElement(_$4$1, 0, options$1);
    }))), this.templateDirective__Llaika_parse_text_PrefixedParser(), $m_Llaika_parse_syntax$LiteralStringOps$().$tilde$greater$extension__T__Llaika_parse_Parser__Llaika_parse_text_PrefixedParser("\\", $n($m_Llaika_parse_builders$().Llaika_parse_builders$__f_oneChar).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$5) => {
      var _$5$1 = $as_T(_$5);
      var options$2 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      return new $c_Llaika_ast_Text(_$5$1, options$2);
    }))))]))));
    this.Llaika_internal_parse_directive_TemplateParsers__f_spanParsersbitmap$1 = true;
  }
  return this.Llaika_internal_parse_directive_TemplateParsers__f_spanParsers$lzy1;
});
$c_Llaika_internal_parse_directive_TemplateParsers.prototype.templateDirective__Llaika_parse_text_PrefixedParser = (function() {
  if ((!this.Llaika_internal_parse_directive_TemplateParsers__f_templateDirectivebitmap$1)) {
    var body = new $c_sjsr_AnonFunction1(((spec) => {
      var spec$1 = $as_Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec(spec);
      var this$2 = $n($n(this.Llaika_internal_parse_directive_TemplateParsers__f_directives).get__O__s_Option($n(spec$1).Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec__f_name));
      if ((!this$2.isEmpty__Z())) {
        var arg1 = this$2.get__O();
        var _$6 = $as_Llaika_api_bundle_DirectiveBuilderContext$Directive(arg1);
        var $x_1 = $n(_$6).hasBody__Z();
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var this$3 = $m_Llaika_parse_builders$();
        var str = $n(spec$1).Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec__f_fence;
        var p = $f_Llaika_parse_text_TextParsers__delimitedBy__T__Llaika_parse_text_DelimitedText(this$3, str);
        var p$1 = $n($as_Llaika_parse_Parser($f_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers__recursiveSpans__Llaika_parse_text_DelimitedText__Llaika_parse_markup_InlineParser(this, p))).source__Llaika_parse_Parser();
        var this$10 = $n($n($m_Llaika_parse_syntax$StringParserOps$().line$extension__Llaika_parse_Parser__Llaika_parse_Parser(p$1)).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((src) => {
          var src$1 = $as_Llaika_parse_LineSource(src);
          var $x_2 = $m_sc_StringOps$();
          var x = $n(src$1).Llaika_parse_LineSource__f_input;
          var this$6 = $n($n(spec$1).Llaika_internal_parse_directive_DirectiveParsers$DirectiveSpec__f_fence);
          var input = $n($x_2).dropRight$extension__T__I__T(x, this$6.length);
          var parent = $n(src$1).parent__Llaika_parse_SourceCursor();
          var value = new $c_Llaika_parse_LineSource(input, parent, 0, $n(parent).nestLevel__I());
          return new $c_s_Some(value);
        }))));
        var p$2 = new $c_sjsr_AnonFunction0((() => {
          var this$9 = $m_Llaika_parse_builders$();
          var v = $m_s_None$();
          return $f_Llaika_parse_combinator_Parsers__success__O__Llaika_parse_Parser(this$9, v);
        }));
        return this$10.orElse__F0__Llaika_parse_Parser(p$2);
      } else {
        var this$11 = $m_Llaika_parse_builders$();
        var v$1 = $m_s_None$();
        return $f_Llaika_parse_combinator_Parsers__success__O__Llaika_parse_Parser(this$11, v$1);
      }
    }));
    var this$12 = $n(this.Llaika_internal_parse_directive_TemplateParsers__f_directives);
    var this$13 = new $c_sc_MapOps$$anon$1(this$12);
    var f = new $c_sjsr_AnonFunction1(((_$7) => {
      var _$7$1 = $as_Llaika_api_bundle_DirectiveBuilderContext$Directive(_$7);
      return $n(_$7$1).separators__sci_Set();
    }));
    var this$14 = $n($as_sc_IterableOnceOps($f_sc_IterableOps__flatMap__F1__O(this$13, f)));
    var separators = $m_sci_Set$().from__sc_IterableOnce__sci_Set($as_sc_IterableOnce(this$14));
    var this$19 = $m_Llaika_parse_text_PrefixedParser$();
    var chars = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([])));
    var p$3 = $n($n($m_Llaika_internal_parse_directive_DirectiveParsers$().directiveParser__F1__Z__Llaika_parse_Parser(body, ($m_Llaika_internal_parse_directive_DirectiveParsers$(), false))).withCursor__Llaika_parse_Parser()).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((x$1) => {
      var x$1$1 = $as_T2(x$1);
      matchResult1: {
        var $x_3;
        if ((x$1$1 !== null)) {
          var res = $as_Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective($n(x$1$1)._1__O());
          var source = $as_Llaika_parse_SourceFragment($n(x$1$1)._2__O());
          if ($n(separators).contains__O__Z($n(res).Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_name)) {
            var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
            var $x_3 = new $c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance(res, source, options);
            break matchResult1;
          } else {
            var directive = $n(this.Llaika_internal_parse_directive_TemplateParsers__f_directives).get__O__s_Option($n(res).Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_name);
            var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
            var $x_3 = new $c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance(directive, res, this, source, options$1);
            break matchResult1;
          }
        }
        throw new $c_s_MatchError(x$1$1);
      }
      return $as_Llaika_api_bundle_DirectiveBuilderContext$DirectiveProcessor($x_3);
    })));
    this.Llaika_internal_parse_directive_TemplateParsers__f_templateDirective$lzy1 = new $c_Llaika_parse_text_PrefixedParser$$anon$2(64, chars, p$3, this$19);
    this.Llaika_internal_parse_directive_TemplateParsers__f_templateDirectivebitmap$1 = true;
  }
  return this.Llaika_internal_parse_directive_TemplateParsers__f_templateDirective$lzy1;
});
$c_Llaika_internal_parse_directive_TemplateParsers.prototype.templateSpans__Llaika_parse_Parser = (function() {
  if ((!this.Llaika_internal_parse_directive_TemplateParsers__f_templateSpansbitmap$1)) {
    this.Llaika_internal_parse_directive_TemplateParsers__f_templateSpans$lzy1 = $n($as_Llaika_parse_Parser(this.defaultSpanParser__Llaika_parse_markup_InlineParser())).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$8) => {
      var _$8$1 = $as_sci_List(_$8);
      return $n(_$8$1).collect__s_PartialFunction__sci_List(new $c_Llaika_internal_parse_directive_TemplateParsers$$anon$1());
    })));
    this.Llaika_internal_parse_directive_TemplateParsers__f_templateSpansbitmap$1 = true;
  }
  return this.Llaika_internal_parse_directive_TemplateParsers__f_templateSpans$lzy1;
});
$c_Llaika_internal_parse_directive_TemplateParsers.prototype.templateRoot__Llaika_parse_Parser = (function() {
  if ((!this.Llaika_internal_parse_directive_TemplateParsers__f_templateRootbitmap$1)) {
    this.Llaika_internal_parse_directive_TemplateParsers__f_templateRoot$lzy1 = $n(this.templateSpans__Llaika_parse_Parser()).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$9) => {
      var _$9$1 = $as_sci_List(_$9);
      $m_Llaika_ast_TemplateRoot$();
      $m_Llaika_ast_TemplateRoot$();
      var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      return new $c_Llaika_ast_TemplateRoot(_$9$1, options);
    })));
    this.Llaika_internal_parse_directive_TemplateParsers__f_templateRootbitmap$1 = true;
  }
  return this.Llaika_internal_parse_directive_TemplateParsers__f_templateRoot$lzy1;
});
var $d_Llaika_internal_parse_directive_TemplateParsers = new $TypeData().initClass($c_Llaika_internal_parse_directive_TemplateParsers, "laika.internal.parse.directive.TemplateParsers", ({
  Llaika_internal_parse_directive_TemplateParsers: 1,
  Llaika_parse_markup_EscapedTextParsers: 1,
  Llaika_parse_markup_RecursiveSpanParsers: 1,
  Llaika_internal_parse_markup_DefaultEscapedTextParsers: 1,
  Llaika_internal_parse_markup_DefaultRecursiveSpanParsers: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_directive_TemplateParsers$$anon$1() {
}
$c_Llaika_internal_parse_directive_TemplateParsers$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_parse_directive_TemplateParsers$$anon$1.prototype.constructor = $c_Llaika_internal_parse_directive_TemplateParsers$$anon$1;
/** @constructor */
function $h_Llaika_internal_parse_directive_TemplateParsers$$anon$1() {
}
$h_Llaika_internal_parse_directive_TemplateParsers$$anon$1.prototype = $c_Llaika_internal_parse_directive_TemplateParsers$$anon$1.prototype;
$c_Llaika_internal_parse_directive_TemplateParsers$$anon$1.prototype.isDefinedAt__Llaika_ast_Span__Z = (function(x) {
  if ($is_Llaika_ast_TemplateSpan(x)) {
    $as_Llaika_ast_TemplateSpan(x);
    return true;
  } else if ((x instanceof $c_Llaika_ast_Text)) {
    var x$1 = $as_Llaika_ast_Text(x);
    var this$2 = $n(x$1);
    var this$3 = $n(x$1);
    return true;
  } else {
    return false;
  }
});
$c_Llaika_internal_parse_directive_TemplateParsers$$anon$1.prototype.applyOrElse__Llaika_ast_Span__F1__O = (function(x, default$1) {
  if ($is_Llaika_ast_TemplateSpan(x)) {
    var s = $as_Llaika_ast_TemplateSpan(x);
    return s;
  } else if ((x instanceof $c_Llaika_ast_Text)) {
    var x$1 = $as_Llaika_ast_Text(x);
    var this$2 = $n(x$1);
    var x13 = this$2.Llaika_ast_Text__f_content;
    var this$3 = $n(x$1);
    var x14 = this$3.Llaika_ast_Text__f_options;
    return new $c_Llaika_ast_TemplateString(x13, x14);
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_internal_parse_directive_TemplateParsers$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Span__Z($as_Llaika_ast_Span(x));
});
$c_Llaika_internal_parse_directive_TemplateParsers$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Span__F1__O($as_Llaika_ast_Span(x), default$1);
});
var $d_Llaika_internal_parse_directive_TemplateParsers$$anon$1 = new $TypeData().initClass($c_Llaika_internal_parse_directive_TemplateParsers$$anon$1, "laika.internal.parse.directive.TemplateParsers$$anon$1", ({
  Llaika_internal_parse_directive_TemplateParsers$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_hocon_ArrayBuilderValue(values) {
  this.Llaika_internal_parse_hocon_ArrayBuilderValue__f_values = null;
  this.Llaika_internal_parse_hocon_ArrayBuilderValue__f_values = values;
}
$c_Llaika_internal_parse_hocon_ArrayBuilderValue.prototype = new $h_O();
$c_Llaika_internal_parse_hocon_ArrayBuilderValue.prototype.constructor = $c_Llaika_internal_parse_hocon_ArrayBuilderValue;
/** @constructor */
function $h_Llaika_internal_parse_hocon_ArrayBuilderValue() {
}
$h_Llaika_internal_parse_hocon_ArrayBuilderValue.prototype = $c_Llaika_internal_parse_hocon_ArrayBuilderValue.prototype;
$c_Llaika_internal_parse_hocon_ArrayBuilderValue.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_parse_hocon_ArrayBuilderValue.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_parse_hocon_ArrayBuilderValue.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_parse_hocon_ArrayBuilderValue)) {
    var x$0$2 = $as_Llaika_internal_parse_hocon_ArrayBuilderValue(x$0);
    var x = this.Llaika_internal_parse_hocon_ArrayBuilderValue__f_values;
    var x$2 = $n(x$0$2).Llaika_internal_parse_hocon_ArrayBuilderValue__f_values;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_parse_hocon_ArrayBuilderValue.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_parse_hocon_ArrayBuilderValue.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_internal_parse_hocon_ArrayBuilderValue.prototype.productPrefix__T = (function() {
  return "ArrayBuilderValue";
});
$c_Llaika_internal_parse_hocon_ArrayBuilderValue.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_parse_hocon_ArrayBuilderValue__f_values;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_internal_parse_hocon_ArrayBuilderValue(obj) {
  return (((obj instanceof $c_Llaika_internal_parse_hocon_ArrayBuilderValue) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.hocon.ArrayBuilderValue"));
}
function $isArrayOf_Llaika_internal_parse_hocon_ArrayBuilderValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_hocon_ArrayBuilderValue)));
}
function $asArrayOf_Llaika_internal_parse_hocon_ArrayBuilderValue(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_hocon_ArrayBuilderValue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.hocon.ArrayBuilderValue;", depth));
}
var $d_Llaika_internal_parse_hocon_ArrayBuilderValue = new $TypeData().initClass($c_Llaika_internal_parse_hocon_ArrayBuilderValue, "laika.internal.parse.hocon.ArrayBuilderValue", ({
  Llaika_internal_parse_hocon_ArrayBuilderValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_internal_parse_hocon_ConfigBuilderValue: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_hocon_ConcatValue(first, rest) {
  this.Llaika_internal_parse_hocon_ConcatValue__f_first = null;
  this.Llaika_internal_parse_hocon_ConcatValue__f_rest = null;
  this.Llaika_internal_parse_hocon_ConcatValue__f_allParts = null;
  this.Llaika_internal_parse_hocon_ConcatValue__f_first = first;
  this.Llaika_internal_parse_hocon_ConcatValue__f_rest = rest;
  var elem$1 = new $c_Llaika_internal_parse_hocon_ConcatPart("", first);
  var this$2 = $n(rest);
  this.Llaika_internal_parse_hocon_ConcatValue__f_allParts = $as_sci_Seq(this$2.prepended__O__O(elem$1));
}
$c_Llaika_internal_parse_hocon_ConcatValue.prototype = new $h_O();
$c_Llaika_internal_parse_hocon_ConcatValue.prototype.constructor = $c_Llaika_internal_parse_hocon_ConcatValue;
/** @constructor */
function $h_Llaika_internal_parse_hocon_ConcatValue() {
}
$h_Llaika_internal_parse_hocon_ConcatValue.prototype = $c_Llaika_internal_parse_hocon_ConcatValue.prototype;
$c_Llaika_internal_parse_hocon_ConcatValue.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_parse_hocon_ConcatValue.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_parse_hocon_ConcatValue.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_parse_hocon_ConcatValue)) {
    var x$0$2 = $as_Llaika_internal_parse_hocon_ConcatValue(x$0);
    var x = this.Llaika_internal_parse_hocon_ConcatValue__f_first;
    var x$2 = $n(x$0$2).Llaika_internal_parse_hocon_ConcatValue__f_first;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_internal_parse_hocon_ConcatValue__f_rest;
      var x$4 = $n(x$0$2).Llaika_internal_parse_hocon_ConcatValue__f_rest;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_parse_hocon_ConcatValue.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_parse_hocon_ConcatValue.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_internal_parse_hocon_ConcatValue.prototype.productPrefix__T = (function() {
  return "ConcatValue";
});
$c_Llaika_internal_parse_hocon_ConcatValue.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_parse_hocon_ConcatValue__f_first;
  }
  if ((n === 1)) {
    return this.Llaika_internal_parse_hocon_ConcatValue__f_rest;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_internal_parse_hocon_ConcatValue(obj) {
  return (((obj instanceof $c_Llaika_internal_parse_hocon_ConcatValue) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.hocon.ConcatValue"));
}
function $isArrayOf_Llaika_internal_parse_hocon_ConcatValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_hocon_ConcatValue)));
}
function $asArrayOf_Llaika_internal_parse_hocon_ConcatValue(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_hocon_ConcatValue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.hocon.ConcatValue;", depth));
}
var $d_Llaika_internal_parse_hocon_ConcatValue = new $TypeData().initClass($c_Llaika_internal_parse_hocon_ConcatValue, "laika.internal.parse.hocon.ConcatValue", ({
  Llaika_internal_parse_hocon_ConcatValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_internal_parse_hocon_ConfigBuilderValue: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_hocon_HoconParsers$$anon$2() {
}
$c_Llaika_internal_parse_hocon_HoconParsers$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_parse_hocon_HoconParsers$$anon$2.prototype.constructor = $c_Llaika_internal_parse_hocon_HoconParsers$$anon$2;
/** @constructor */
function $h_Llaika_internal_parse_hocon_HoconParsers$$anon$2() {
}
$h_Llaika_internal_parse_hocon_HoconParsers$$anon$2.prototype = $c_Llaika_internal_parse_hocon_HoconParsers$$anon$2.prototype;
$c_Llaika_internal_parse_hocon_HoconParsers$$anon$2.prototype.isDefinedAt__Llaika_internal_parse_hocon_StringBuilderValue__Z = (function(x) {
  return ((x instanceof $c_Llaika_internal_parse_hocon_InvalidStringValue) && ($as_Llaika_internal_parse_hocon_InvalidStringValue(x), true));
});
$c_Llaika_internal_parse_hocon_HoconParsers$$anon$2.prototype.applyOrElse__Llaika_internal_parse_hocon_StringBuilderValue__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Llaika_internal_parse_hocon_InvalidStringValue)) {
    var inv = $as_Llaika_internal_parse_hocon_InvalidStringValue(x);
    return inv;
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_internal_parse_hocon_HoconParsers$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_internal_parse_hocon_StringBuilderValue__Z($as_Llaika_internal_parse_hocon_StringBuilderValue(x));
});
$c_Llaika_internal_parse_hocon_HoconParsers$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_internal_parse_hocon_StringBuilderValue__F1__O($as_Llaika_internal_parse_hocon_StringBuilderValue(x), default$1);
});
var $d_Llaika_internal_parse_hocon_HoconParsers$$anon$2 = new $TypeData().initClass($c_Llaika_internal_parse_hocon_HoconParsers$$anon$2, "laika.internal.parse.hocon.HoconParsers$$anon$2", ({
  Llaika_internal_parse_hocon_HoconParsers$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_hocon_IncludeAny(resourceId, isRequired) {
  this.Llaika_internal_parse_hocon_IncludeAny__f_resourceId = null;
  this.Llaika_internal_parse_hocon_IncludeAny__f_isRequired = false;
  this.Llaika_internal_parse_hocon_IncludeAny__f_resourceId = resourceId;
  this.Llaika_internal_parse_hocon_IncludeAny__f_isRequired = isRequired;
}
$c_Llaika_internal_parse_hocon_IncludeAny.prototype = new $h_O();
$c_Llaika_internal_parse_hocon_IncludeAny.prototype.constructor = $c_Llaika_internal_parse_hocon_IncludeAny;
/** @constructor */
function $h_Llaika_internal_parse_hocon_IncludeAny() {
}
$h_Llaika_internal_parse_hocon_IncludeAny.prototype = $c_Llaika_internal_parse_hocon_IncludeAny.prototype;
$c_Llaika_internal_parse_hocon_IncludeAny.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_parse_hocon_IncludeAny.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("IncludeAny");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Llaika_internal_parse_hocon_IncludeAny__f_resourceId;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Llaika_internal_parse_hocon_IncludeAny__f_isRequired ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
});
$c_Llaika_internal_parse_hocon_IncludeAny.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_parse_hocon_IncludeAny)) {
    var x$0$2 = $as_Llaika_internal_parse_hocon_IncludeAny(x$0);
    if ((this.Llaika_internal_parse_hocon_IncludeAny__f_isRequired === $n(x$0$2).Llaika_internal_parse_hocon_IncludeAny__f_isRequired)) {
      var x = this.Llaika_internal_parse_hocon_IncludeAny__f_resourceId;
      var x$2 = $n(x$0$2).Llaika_internal_parse_hocon_IncludeAny__f_resourceId;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_parse_hocon_IncludeAny.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_parse_hocon_IncludeAny.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_internal_parse_hocon_IncludeAny.prototype.productPrefix__T = (function() {
  return "IncludeAny";
});
$c_Llaika_internal_parse_hocon_IncludeAny.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_parse_hocon_IncludeAny__f_resourceId;
  }
  if ((n === 1)) {
    return this.Llaika_internal_parse_hocon_IncludeAny__f_isRequired;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_internal_parse_hocon_IncludeAny.prototype.resourceId__Llaika_internal_parse_hocon_StringBuilderValue = (function() {
  return this.Llaika_internal_parse_hocon_IncludeAny__f_resourceId;
});
$c_Llaika_internal_parse_hocon_IncludeAny.prototype.isRequired__Z = (function() {
  return this.Llaika_internal_parse_hocon_IncludeAny__f_isRequired;
});
function $as_Llaika_internal_parse_hocon_IncludeAny(obj) {
  return (((obj instanceof $c_Llaika_internal_parse_hocon_IncludeAny) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.hocon.IncludeAny"));
}
function $isArrayOf_Llaika_internal_parse_hocon_IncludeAny(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_hocon_IncludeAny)));
}
function $asArrayOf_Llaika_internal_parse_hocon_IncludeAny(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_hocon_IncludeAny(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.hocon.IncludeAny;", depth));
}
var $d_Llaika_internal_parse_hocon_IncludeAny = new $TypeData().initClass($c_Llaika_internal_parse_hocon_IncludeAny, "laika.internal.parse.hocon.IncludeAny", ({
  Llaika_internal_parse_hocon_IncludeAny: 1,
  Llaika_internal_parse_hocon_IncludeResource: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_hocon_IncludeBuilderValue(resource) {
  this.Llaika_internal_parse_hocon_IncludeBuilderValue__f_resource = null;
  this.Llaika_internal_parse_hocon_IncludeBuilderValue__f_resource = resource;
}
$c_Llaika_internal_parse_hocon_IncludeBuilderValue.prototype = new $h_O();
$c_Llaika_internal_parse_hocon_IncludeBuilderValue.prototype.constructor = $c_Llaika_internal_parse_hocon_IncludeBuilderValue;
/** @constructor */
function $h_Llaika_internal_parse_hocon_IncludeBuilderValue() {
}
$h_Llaika_internal_parse_hocon_IncludeBuilderValue.prototype = $c_Llaika_internal_parse_hocon_IncludeBuilderValue.prototype;
$c_Llaika_internal_parse_hocon_IncludeBuilderValue.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_parse_hocon_IncludeBuilderValue.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_parse_hocon_IncludeBuilderValue.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_parse_hocon_IncludeBuilderValue)) {
    var x$0$2 = $as_Llaika_internal_parse_hocon_IncludeBuilderValue(x$0);
    var x = this.Llaika_internal_parse_hocon_IncludeBuilderValue__f_resource;
    var x$2 = $n(x$0$2).Llaika_internal_parse_hocon_IncludeBuilderValue__f_resource;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_parse_hocon_IncludeBuilderValue.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_parse_hocon_IncludeBuilderValue.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_internal_parse_hocon_IncludeBuilderValue.prototype.productPrefix__T = (function() {
  return "IncludeBuilderValue";
});
$c_Llaika_internal_parse_hocon_IncludeBuilderValue.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_parse_hocon_IncludeBuilderValue__f_resource;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_internal_parse_hocon_IncludeBuilderValue(obj) {
  return (((obj instanceof $c_Llaika_internal_parse_hocon_IncludeBuilderValue) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.hocon.IncludeBuilderValue"));
}
function $isArrayOf_Llaika_internal_parse_hocon_IncludeBuilderValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_hocon_IncludeBuilderValue)));
}
function $asArrayOf_Llaika_internal_parse_hocon_IncludeBuilderValue(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_hocon_IncludeBuilderValue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.hocon.IncludeBuilderValue;", depth));
}
var $d_Llaika_internal_parse_hocon_IncludeBuilderValue = new $TypeData().initClass($c_Llaika_internal_parse_hocon_IncludeBuilderValue, "laika.internal.parse.hocon.IncludeBuilderValue", ({
  Llaika_internal_parse_hocon_IncludeBuilderValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_internal_parse_hocon_ConfigBuilderValue: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_hocon_IncludeClassPath(resourceId, isRequired) {
  this.Llaika_internal_parse_hocon_IncludeClassPath__f_resourceId = null;
  this.Llaika_internal_parse_hocon_IncludeClassPath__f_isRequired = false;
  this.Llaika_internal_parse_hocon_IncludeClassPath__f_resourceId = resourceId;
  this.Llaika_internal_parse_hocon_IncludeClassPath__f_isRequired = isRequired;
}
$c_Llaika_internal_parse_hocon_IncludeClassPath.prototype = new $h_O();
$c_Llaika_internal_parse_hocon_IncludeClassPath.prototype.constructor = $c_Llaika_internal_parse_hocon_IncludeClassPath;
/** @constructor */
function $h_Llaika_internal_parse_hocon_IncludeClassPath() {
}
$h_Llaika_internal_parse_hocon_IncludeClassPath.prototype = $c_Llaika_internal_parse_hocon_IncludeClassPath.prototype;
$c_Llaika_internal_parse_hocon_IncludeClassPath.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_parse_hocon_IncludeClassPath.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("IncludeClassPath");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Llaika_internal_parse_hocon_IncludeClassPath__f_resourceId;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Llaika_internal_parse_hocon_IncludeClassPath__f_isRequired ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
});
$c_Llaika_internal_parse_hocon_IncludeClassPath.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_parse_hocon_IncludeClassPath)) {
    var x$0$2 = $as_Llaika_internal_parse_hocon_IncludeClassPath(x$0);
    if ((this.Llaika_internal_parse_hocon_IncludeClassPath__f_isRequired === $n(x$0$2).Llaika_internal_parse_hocon_IncludeClassPath__f_isRequired)) {
      var x = this.Llaika_internal_parse_hocon_IncludeClassPath__f_resourceId;
      var x$2 = $n(x$0$2).Llaika_internal_parse_hocon_IncludeClassPath__f_resourceId;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_parse_hocon_IncludeClassPath.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_parse_hocon_IncludeClassPath.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_internal_parse_hocon_IncludeClassPath.prototype.productPrefix__T = (function() {
  return "IncludeClassPath";
});
$c_Llaika_internal_parse_hocon_IncludeClassPath.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_parse_hocon_IncludeClassPath__f_resourceId;
  }
  if ((n === 1)) {
    return this.Llaika_internal_parse_hocon_IncludeClassPath__f_isRequired;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_internal_parse_hocon_IncludeClassPath.prototype.resourceId__Llaika_internal_parse_hocon_StringBuilderValue = (function() {
  return this.Llaika_internal_parse_hocon_IncludeClassPath__f_resourceId;
});
$c_Llaika_internal_parse_hocon_IncludeClassPath.prototype.isRequired__Z = (function() {
  return this.Llaika_internal_parse_hocon_IncludeClassPath__f_isRequired;
});
function $as_Llaika_internal_parse_hocon_IncludeClassPath(obj) {
  return (((obj instanceof $c_Llaika_internal_parse_hocon_IncludeClassPath) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.hocon.IncludeClassPath"));
}
function $isArrayOf_Llaika_internal_parse_hocon_IncludeClassPath(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_hocon_IncludeClassPath)));
}
function $asArrayOf_Llaika_internal_parse_hocon_IncludeClassPath(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_hocon_IncludeClassPath(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.hocon.IncludeClassPath;", depth));
}
var $d_Llaika_internal_parse_hocon_IncludeClassPath = new $TypeData().initClass($c_Llaika_internal_parse_hocon_IncludeClassPath, "laika.internal.parse.hocon.IncludeClassPath", ({
  Llaika_internal_parse_hocon_IncludeClassPath: 1,
  Llaika_internal_parse_hocon_IncludeResource: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_hocon_IncludeFile(resourceId, isRequired) {
  this.Llaika_internal_parse_hocon_IncludeFile__f_resourceId = null;
  this.Llaika_internal_parse_hocon_IncludeFile__f_isRequired = false;
  this.Llaika_internal_parse_hocon_IncludeFile__f_resourceId = resourceId;
  this.Llaika_internal_parse_hocon_IncludeFile__f_isRequired = isRequired;
}
$c_Llaika_internal_parse_hocon_IncludeFile.prototype = new $h_O();
$c_Llaika_internal_parse_hocon_IncludeFile.prototype.constructor = $c_Llaika_internal_parse_hocon_IncludeFile;
/** @constructor */
function $h_Llaika_internal_parse_hocon_IncludeFile() {
}
$h_Llaika_internal_parse_hocon_IncludeFile.prototype = $c_Llaika_internal_parse_hocon_IncludeFile.prototype;
$c_Llaika_internal_parse_hocon_IncludeFile.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_parse_hocon_IncludeFile.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("IncludeFile");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Llaika_internal_parse_hocon_IncludeFile__f_resourceId;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Llaika_internal_parse_hocon_IncludeFile__f_isRequired ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
});
$c_Llaika_internal_parse_hocon_IncludeFile.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_parse_hocon_IncludeFile)) {
    var x$0$2 = $as_Llaika_internal_parse_hocon_IncludeFile(x$0);
    if ((this.Llaika_internal_parse_hocon_IncludeFile__f_isRequired === $n(x$0$2).Llaika_internal_parse_hocon_IncludeFile__f_isRequired)) {
      var x = this.Llaika_internal_parse_hocon_IncludeFile__f_resourceId;
      var x$2 = $n(x$0$2).Llaika_internal_parse_hocon_IncludeFile__f_resourceId;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_parse_hocon_IncludeFile.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_parse_hocon_IncludeFile.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_internal_parse_hocon_IncludeFile.prototype.productPrefix__T = (function() {
  return "IncludeFile";
});
$c_Llaika_internal_parse_hocon_IncludeFile.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_parse_hocon_IncludeFile__f_resourceId;
  }
  if ((n === 1)) {
    return this.Llaika_internal_parse_hocon_IncludeFile__f_isRequired;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_internal_parse_hocon_IncludeFile.prototype.resourceId__Llaika_internal_parse_hocon_StringBuilderValue = (function() {
  return this.Llaika_internal_parse_hocon_IncludeFile__f_resourceId;
});
$c_Llaika_internal_parse_hocon_IncludeFile.prototype.isRequired__Z = (function() {
  return this.Llaika_internal_parse_hocon_IncludeFile__f_isRequired;
});
function $as_Llaika_internal_parse_hocon_IncludeFile(obj) {
  return (((obj instanceof $c_Llaika_internal_parse_hocon_IncludeFile) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.hocon.IncludeFile"));
}
function $isArrayOf_Llaika_internal_parse_hocon_IncludeFile(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_hocon_IncludeFile)));
}
function $asArrayOf_Llaika_internal_parse_hocon_IncludeFile(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_hocon_IncludeFile(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.hocon.IncludeFile;", depth));
}
var $d_Llaika_internal_parse_hocon_IncludeFile = new $TypeData().initClass($c_Llaika_internal_parse_hocon_IncludeFile, "laika.internal.parse.hocon.IncludeFile", ({
  Llaika_internal_parse_hocon_IncludeFile: 1,
  Llaika_internal_parse_hocon_IncludeResource: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_hocon_IncludeUrl(resourceId, isRequired) {
  this.Llaika_internal_parse_hocon_IncludeUrl__f_resourceId = null;
  this.Llaika_internal_parse_hocon_IncludeUrl__f_isRequired = false;
  this.Llaika_internal_parse_hocon_IncludeUrl__f_resourceId = resourceId;
  this.Llaika_internal_parse_hocon_IncludeUrl__f_isRequired = isRequired;
}
$c_Llaika_internal_parse_hocon_IncludeUrl.prototype = new $h_O();
$c_Llaika_internal_parse_hocon_IncludeUrl.prototype.constructor = $c_Llaika_internal_parse_hocon_IncludeUrl;
/** @constructor */
function $h_Llaika_internal_parse_hocon_IncludeUrl() {
}
$h_Llaika_internal_parse_hocon_IncludeUrl.prototype = $c_Llaika_internal_parse_hocon_IncludeUrl.prototype;
$c_Llaika_internal_parse_hocon_IncludeUrl.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_parse_hocon_IncludeUrl.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("IncludeUrl");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Llaika_internal_parse_hocon_IncludeUrl__f_resourceId;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Llaika_internal_parse_hocon_IncludeUrl__f_isRequired ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
});
$c_Llaika_internal_parse_hocon_IncludeUrl.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_parse_hocon_IncludeUrl)) {
    var x$0$2 = $as_Llaika_internal_parse_hocon_IncludeUrl(x$0);
    if ((this.Llaika_internal_parse_hocon_IncludeUrl__f_isRequired === $n(x$0$2).Llaika_internal_parse_hocon_IncludeUrl__f_isRequired)) {
      var x = this.Llaika_internal_parse_hocon_IncludeUrl__f_resourceId;
      var x$2 = $n(x$0$2).Llaika_internal_parse_hocon_IncludeUrl__f_resourceId;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_parse_hocon_IncludeUrl.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_parse_hocon_IncludeUrl.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_internal_parse_hocon_IncludeUrl.prototype.productPrefix__T = (function() {
  return "IncludeUrl";
});
$c_Llaika_internal_parse_hocon_IncludeUrl.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_parse_hocon_IncludeUrl__f_resourceId;
  }
  if ((n === 1)) {
    return this.Llaika_internal_parse_hocon_IncludeUrl__f_isRequired;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_internal_parse_hocon_IncludeUrl.prototype.resourceId__Llaika_internal_parse_hocon_StringBuilderValue = (function() {
  return this.Llaika_internal_parse_hocon_IncludeUrl__f_resourceId;
});
$c_Llaika_internal_parse_hocon_IncludeUrl.prototype.isRequired__Z = (function() {
  return this.Llaika_internal_parse_hocon_IncludeUrl__f_isRequired;
});
function $as_Llaika_internal_parse_hocon_IncludeUrl(obj) {
  return (((obj instanceof $c_Llaika_internal_parse_hocon_IncludeUrl) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.hocon.IncludeUrl"));
}
function $isArrayOf_Llaika_internal_parse_hocon_IncludeUrl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_hocon_IncludeUrl)));
}
function $asArrayOf_Llaika_internal_parse_hocon_IncludeUrl(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_hocon_IncludeUrl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.hocon.IncludeUrl;", depth));
}
var $d_Llaika_internal_parse_hocon_IncludeUrl = new $TypeData().initClass($c_Llaika_internal_parse_hocon_IncludeUrl, "laika.internal.parse.hocon.IncludeUrl", ({
  Llaika_internal_parse_hocon_IncludeUrl: 1,
  Llaika_internal_parse_hocon_IncludeResource: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_hocon_InvalidBuilderValue(value, failure) {
  this.Llaika_internal_parse_hocon_InvalidBuilderValue__f_value = null;
  this.Llaika_internal_parse_hocon_InvalidBuilderValue__f_failure = null;
  this.Llaika_internal_parse_hocon_InvalidBuilderValue__f_value = value;
  this.Llaika_internal_parse_hocon_InvalidBuilderValue__f_failure = failure;
}
$c_Llaika_internal_parse_hocon_InvalidBuilderValue.prototype = new $h_O();
$c_Llaika_internal_parse_hocon_InvalidBuilderValue.prototype.constructor = $c_Llaika_internal_parse_hocon_InvalidBuilderValue;
/** @constructor */
function $h_Llaika_internal_parse_hocon_InvalidBuilderValue() {
}
$h_Llaika_internal_parse_hocon_InvalidBuilderValue.prototype = $c_Llaika_internal_parse_hocon_InvalidBuilderValue.prototype;
$c_Llaika_internal_parse_hocon_InvalidBuilderValue.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_parse_hocon_InvalidBuilderValue.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_parse_hocon_InvalidBuilderValue.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_parse_hocon_InvalidBuilderValue)) {
    var x$0$2 = $as_Llaika_internal_parse_hocon_InvalidBuilderValue(x$0);
    var x = this.Llaika_internal_parse_hocon_InvalidBuilderValue__f_value;
    var x$2 = $n(x$0$2).Llaika_internal_parse_hocon_InvalidBuilderValue__f_value;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_internal_parse_hocon_InvalidBuilderValue__f_failure;
      var x$4 = $n(x$0$2).Llaika_internal_parse_hocon_InvalidBuilderValue__f_failure;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_parse_hocon_InvalidBuilderValue.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_parse_hocon_InvalidBuilderValue.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_internal_parse_hocon_InvalidBuilderValue.prototype.productPrefix__T = (function() {
  return "InvalidBuilderValue";
});
$c_Llaika_internal_parse_hocon_InvalidBuilderValue.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_parse_hocon_InvalidBuilderValue__f_value;
  }
  if ((n === 1)) {
    return this.Llaika_internal_parse_hocon_InvalidBuilderValue__f_failure;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_internal_parse_hocon_InvalidBuilderValue(obj) {
  return (((obj instanceof $c_Llaika_internal_parse_hocon_InvalidBuilderValue) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.hocon.InvalidBuilderValue"));
}
function $isArrayOf_Llaika_internal_parse_hocon_InvalidBuilderValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_hocon_InvalidBuilderValue)));
}
function $asArrayOf_Llaika_internal_parse_hocon_InvalidBuilderValue(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_hocon_InvalidBuilderValue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.hocon.InvalidBuilderValue;", depth));
}
var $d_Llaika_internal_parse_hocon_InvalidBuilderValue = new $TypeData().initClass($c_Llaika_internal_parse_hocon_InvalidBuilderValue, "laika.internal.parse.hocon.InvalidBuilderValue", ({
  Llaika_internal_parse_hocon_InvalidBuilderValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_internal_parse_hocon_ConfigBuilderValue: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_hocon_MergedValue(values) {
  this.Llaika_internal_parse_hocon_MergedValue__f_values = null;
  this.Llaika_internal_parse_hocon_MergedValue__f_values = values;
}
$c_Llaika_internal_parse_hocon_MergedValue.prototype = new $h_O();
$c_Llaika_internal_parse_hocon_MergedValue.prototype.constructor = $c_Llaika_internal_parse_hocon_MergedValue;
/** @constructor */
function $h_Llaika_internal_parse_hocon_MergedValue() {
}
$h_Llaika_internal_parse_hocon_MergedValue.prototype = $c_Llaika_internal_parse_hocon_MergedValue.prototype;
$c_Llaika_internal_parse_hocon_MergedValue.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_parse_hocon_MergedValue.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_parse_hocon_MergedValue.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_parse_hocon_MergedValue)) {
    var x$0$2 = $as_Llaika_internal_parse_hocon_MergedValue(x$0);
    var x = this.Llaika_internal_parse_hocon_MergedValue__f_values;
    var x$2 = $n(x$0$2).Llaika_internal_parse_hocon_MergedValue__f_values;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_parse_hocon_MergedValue.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_parse_hocon_MergedValue.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_internal_parse_hocon_MergedValue.prototype.productPrefix__T = (function() {
  return "MergedValue";
});
$c_Llaika_internal_parse_hocon_MergedValue.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_parse_hocon_MergedValue__f_values;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_internal_parse_hocon_MergedValue(obj) {
  return (((obj instanceof $c_Llaika_internal_parse_hocon_MergedValue) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.hocon.MergedValue"));
}
function $isArrayOf_Llaika_internal_parse_hocon_MergedValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_hocon_MergedValue)));
}
function $asArrayOf_Llaika_internal_parse_hocon_MergedValue(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_hocon_MergedValue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.hocon.MergedValue;", depth));
}
var $d_Llaika_internal_parse_hocon_MergedValue = new $TypeData().initClass($c_Llaika_internal_parse_hocon_MergedValue, "laika.internal.parse.hocon.MergedValue", ({
  Llaika_internal_parse_hocon_MergedValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_internal_parse_hocon_ConfigBuilderValue: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_hocon_ObjectBuilderValue(values) {
  this.Llaika_internal_parse_hocon_ObjectBuilderValue__f_values = null;
  this.Llaika_internal_parse_hocon_ObjectBuilderValue__f_values = values;
}
$c_Llaika_internal_parse_hocon_ObjectBuilderValue.prototype = new $h_O();
$c_Llaika_internal_parse_hocon_ObjectBuilderValue.prototype.constructor = $c_Llaika_internal_parse_hocon_ObjectBuilderValue;
/** @constructor */
function $h_Llaika_internal_parse_hocon_ObjectBuilderValue() {
}
$h_Llaika_internal_parse_hocon_ObjectBuilderValue.prototype = $c_Llaika_internal_parse_hocon_ObjectBuilderValue.prototype;
$c_Llaika_internal_parse_hocon_ObjectBuilderValue.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_parse_hocon_ObjectBuilderValue.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_parse_hocon_ObjectBuilderValue.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_parse_hocon_ObjectBuilderValue)) {
    var x$0$2 = $as_Llaika_internal_parse_hocon_ObjectBuilderValue(x$0);
    var x = this.Llaika_internal_parse_hocon_ObjectBuilderValue__f_values;
    var x$2 = $n(x$0$2).Llaika_internal_parse_hocon_ObjectBuilderValue__f_values;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_parse_hocon_ObjectBuilderValue.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_parse_hocon_ObjectBuilderValue.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_internal_parse_hocon_ObjectBuilderValue.prototype.productPrefix__T = (function() {
  return "ObjectBuilderValue";
});
$c_Llaika_internal_parse_hocon_ObjectBuilderValue.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_parse_hocon_ObjectBuilderValue__f_values;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_internal_parse_hocon_ObjectBuilderValue(obj) {
  return (((obj instanceof $c_Llaika_internal_parse_hocon_ObjectBuilderValue) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.hocon.ObjectBuilderValue"));
}
function $isArrayOf_Llaika_internal_parse_hocon_ObjectBuilderValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_hocon_ObjectBuilderValue)));
}
function $asArrayOf_Llaika_internal_parse_hocon_ObjectBuilderValue(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_hocon_ObjectBuilderValue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.hocon.ObjectBuilderValue;", depth));
}
var $d_Llaika_internal_parse_hocon_ObjectBuilderValue = new $TypeData().initClass($c_Llaika_internal_parse_hocon_ObjectBuilderValue, "laika.internal.parse.hocon.ObjectBuilderValue", ({
  Llaika_internal_parse_hocon_ObjectBuilderValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_internal_parse_hocon_ConfigBuilderValue: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_hocon_ResolvedBuilderValue(value) {
  this.Llaika_internal_parse_hocon_ResolvedBuilderValue__f_value = null;
  this.Llaika_internal_parse_hocon_ResolvedBuilderValue__f_value = value;
}
$c_Llaika_internal_parse_hocon_ResolvedBuilderValue.prototype = new $h_O();
$c_Llaika_internal_parse_hocon_ResolvedBuilderValue.prototype.constructor = $c_Llaika_internal_parse_hocon_ResolvedBuilderValue;
/** @constructor */
function $h_Llaika_internal_parse_hocon_ResolvedBuilderValue() {
}
$h_Llaika_internal_parse_hocon_ResolvedBuilderValue.prototype = $c_Llaika_internal_parse_hocon_ResolvedBuilderValue.prototype;
$c_Llaika_internal_parse_hocon_ResolvedBuilderValue.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_parse_hocon_ResolvedBuilderValue.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_parse_hocon_ResolvedBuilderValue.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_parse_hocon_ResolvedBuilderValue)) {
    var x$0$2 = $as_Llaika_internal_parse_hocon_ResolvedBuilderValue(x$0);
    var x = this.Llaika_internal_parse_hocon_ResolvedBuilderValue__f_value;
    var x$2 = $n(x$0$2).Llaika_internal_parse_hocon_ResolvedBuilderValue__f_value;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_parse_hocon_ResolvedBuilderValue.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_parse_hocon_ResolvedBuilderValue.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_internal_parse_hocon_ResolvedBuilderValue.prototype.productPrefix__T = (function() {
  return "ResolvedBuilderValue";
});
$c_Llaika_internal_parse_hocon_ResolvedBuilderValue.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_parse_hocon_ResolvedBuilderValue__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_internal_parse_hocon_ResolvedBuilderValue(obj) {
  return (((obj instanceof $c_Llaika_internal_parse_hocon_ResolvedBuilderValue) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.hocon.ResolvedBuilderValue"));
}
function $isArrayOf_Llaika_internal_parse_hocon_ResolvedBuilderValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_hocon_ResolvedBuilderValue)));
}
function $asArrayOf_Llaika_internal_parse_hocon_ResolvedBuilderValue(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_hocon_ResolvedBuilderValue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.hocon.ResolvedBuilderValue;", depth));
}
var $d_Llaika_internal_parse_hocon_ResolvedBuilderValue = new $TypeData().initClass($c_Llaika_internal_parse_hocon_ResolvedBuilderValue, "laika.internal.parse.hocon.ResolvedBuilderValue", ({
  Llaika_internal_parse_hocon_ResolvedBuilderValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_internal_parse_hocon_ConfigBuilderValue: 1
}));
function $is_Llaika_internal_parse_hocon_StringBuilderValue(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_internal_parse_hocon_StringBuilderValue)));
}
function $as_Llaika_internal_parse_hocon_StringBuilderValue(obj) {
  return (($is_Llaika_internal_parse_hocon_StringBuilderValue(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.hocon.StringBuilderValue"));
}
function $isArrayOf_Llaika_internal_parse_hocon_StringBuilderValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_hocon_StringBuilderValue)));
}
function $asArrayOf_Llaika_internal_parse_hocon_StringBuilderValue(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_hocon_StringBuilderValue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.hocon.StringBuilderValue;", depth));
}
var $d_Llaika_internal_parse_hocon_StringBuilderValue = new $TypeData().initClass(1, "laika.internal.parse.hocon.StringBuilderValue", ({
  Llaika_internal_parse_hocon_StringBuilderValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_internal_parse_hocon_ConfigBuilderValue: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_hocon_SubstitutionValue(ref, optional) {
  this.Llaika_internal_parse_hocon_SubstitutionValue__f_ref = null;
  this.Llaika_internal_parse_hocon_SubstitutionValue__f_optional = false;
  this.Llaika_internal_parse_hocon_SubstitutionValue__f_ref = ref;
  this.Llaika_internal_parse_hocon_SubstitutionValue__f_optional = optional;
}
$c_Llaika_internal_parse_hocon_SubstitutionValue.prototype = new $h_O();
$c_Llaika_internal_parse_hocon_SubstitutionValue.prototype.constructor = $c_Llaika_internal_parse_hocon_SubstitutionValue;
/** @constructor */
function $h_Llaika_internal_parse_hocon_SubstitutionValue() {
}
$h_Llaika_internal_parse_hocon_SubstitutionValue.prototype = $c_Llaika_internal_parse_hocon_SubstitutionValue.prototype;
$c_Llaika_internal_parse_hocon_SubstitutionValue.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_parse_hocon_SubstitutionValue.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("SubstitutionValue");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Llaika_internal_parse_hocon_SubstitutionValue__f_ref;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Llaika_internal_parse_hocon_SubstitutionValue__f_optional ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
});
$c_Llaika_internal_parse_hocon_SubstitutionValue.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_parse_hocon_SubstitutionValue)) {
    var x$0$2 = $as_Llaika_internal_parse_hocon_SubstitutionValue(x$0);
    if ((this.Llaika_internal_parse_hocon_SubstitutionValue__f_optional === $n(x$0$2).Llaika_internal_parse_hocon_SubstitutionValue__f_optional)) {
      var x = this.Llaika_internal_parse_hocon_SubstitutionValue__f_ref;
      var x$2 = $n(x$0$2).Llaika_internal_parse_hocon_SubstitutionValue__f_ref;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_parse_hocon_SubstitutionValue.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_parse_hocon_SubstitutionValue.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_internal_parse_hocon_SubstitutionValue.prototype.productPrefix__T = (function() {
  return "SubstitutionValue";
});
$c_Llaika_internal_parse_hocon_SubstitutionValue.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_parse_hocon_SubstitutionValue__f_ref;
  }
  if ((n === 1)) {
    return this.Llaika_internal_parse_hocon_SubstitutionValue__f_optional;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_internal_parse_hocon_SubstitutionValue(obj) {
  return (((obj instanceof $c_Llaika_internal_parse_hocon_SubstitutionValue) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.hocon.SubstitutionValue"));
}
function $isArrayOf_Llaika_internal_parse_hocon_SubstitutionValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_hocon_SubstitutionValue)));
}
function $asArrayOf_Llaika_internal_parse_hocon_SubstitutionValue(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_hocon_SubstitutionValue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.hocon.SubstitutionValue;", depth));
}
var $d_Llaika_internal_parse_hocon_SubstitutionValue = new $TypeData().initClass($c_Llaika_internal_parse_hocon_SubstitutionValue, "laika.internal.parse.hocon.SubstitutionValue", ({
  Llaika_internal_parse_hocon_SubstitutionValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_internal_parse_hocon_ConfigBuilderValue: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_markup_EndDelimiter(capturedText) {
  this.Llaika_internal_parse_markup_EndDelimiter__f_capturedText = null;
  this.Llaika_internal_parse_markup_EndDelimiter__f_capturedText = capturedText;
}
$c_Llaika_internal_parse_markup_EndDelimiter.prototype = new $h_O();
$c_Llaika_internal_parse_markup_EndDelimiter.prototype.constructor = $c_Llaika_internal_parse_markup_EndDelimiter;
/** @constructor */
function $h_Llaika_internal_parse_markup_EndDelimiter() {
}
$h_Llaika_internal_parse_markup_EndDelimiter.prototype = $c_Llaika_internal_parse_markup_EndDelimiter.prototype;
$c_Llaika_internal_parse_markup_EndDelimiter.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_parse_markup_EndDelimiter.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_parse_markup_EndDelimiter.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_parse_markup_EndDelimiter)) {
    var x$0$2 = $as_Llaika_internal_parse_markup_EndDelimiter(x$0);
    return ((this.Llaika_internal_parse_markup_EndDelimiter__f_capturedText === $n(x$0$2).Llaika_internal_parse_markup_EndDelimiter__f_capturedText) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Llaika_internal_parse_markup_EndDelimiter.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_parse_markup_EndDelimiter.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_internal_parse_markup_EndDelimiter.prototype.productPrefix__T = (function() {
  return "EndDelimiter";
});
$c_Llaika_internal_parse_markup_EndDelimiter.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_parse_markup_EndDelimiter__f_capturedText;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_internal_parse_markup_EndDelimiter(obj) {
  return (((obj instanceof $c_Llaika_internal_parse_markup_EndDelimiter) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.markup.EndDelimiter"));
}
function $isArrayOf_Llaika_internal_parse_markup_EndDelimiter(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_markup_EndDelimiter)));
}
function $asArrayOf_Llaika_internal_parse_markup_EndDelimiter(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_markup_EndDelimiter(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.markup.EndDelimiter;", depth));
}
var $d_Llaika_internal_parse_markup_EndDelimiter = new $TypeData().initClass($c_Llaika_internal_parse_markup_EndDelimiter, "laika.internal.parse.markup.EndDelimiter", ({
  Llaika_internal_parse_markup_EndDelimiter: 1,
  Llaika_internal_parse_markup_InlineResult: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_markup_NestedDelimiter(startChar, capturedText) {
  this.Llaika_internal_parse_markup_NestedDelimiter__f_startChar = 0;
  this.Llaika_internal_parse_markup_NestedDelimiter__f_capturedText = null;
  this.Llaika_internal_parse_markup_NestedDelimiter__f_startChar = startChar;
  this.Llaika_internal_parse_markup_NestedDelimiter__f_capturedText = capturedText;
}
$c_Llaika_internal_parse_markup_NestedDelimiter.prototype = new $h_O();
$c_Llaika_internal_parse_markup_NestedDelimiter.prototype.constructor = $c_Llaika_internal_parse_markup_NestedDelimiter;
/** @constructor */
function $h_Llaika_internal_parse_markup_NestedDelimiter() {
}
$h_Llaika_internal_parse_markup_NestedDelimiter.prototype = $c_Llaika_internal_parse_markup_NestedDelimiter.prototype;
$c_Llaika_internal_parse_markup_NestedDelimiter.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_parse_markup_NestedDelimiter.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("NestedDelimiter");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Llaika_internal_parse_markup_NestedDelimiter__f_startChar;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Llaika_internal_parse_markup_NestedDelimiter__f_capturedText;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
});
$c_Llaika_internal_parse_markup_NestedDelimiter.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_parse_markup_NestedDelimiter)) {
    var x$0$2 = $as_Llaika_internal_parse_markup_NestedDelimiter(x$0);
    return (((this.Llaika_internal_parse_markup_NestedDelimiter__f_startChar === $n(x$0$2).Llaika_internal_parse_markup_NestedDelimiter__f_startChar) && (this.Llaika_internal_parse_markup_NestedDelimiter__f_capturedText === $n(x$0$2).Llaika_internal_parse_markup_NestedDelimiter__f_capturedText)) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Llaika_internal_parse_markup_NestedDelimiter.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_parse_markup_NestedDelimiter.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_internal_parse_markup_NestedDelimiter.prototype.productPrefix__T = (function() {
  return "NestedDelimiter";
});
$c_Llaika_internal_parse_markup_NestedDelimiter.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return $bC(this.Llaika_internal_parse_markup_NestedDelimiter__f_startChar);
  }
  if ((n === 1)) {
    return this.Llaika_internal_parse_markup_NestedDelimiter__f_capturedText;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_internal_parse_markup_NestedDelimiter(obj) {
  return (((obj instanceof $c_Llaika_internal_parse_markup_NestedDelimiter) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.markup.NestedDelimiter"));
}
function $isArrayOf_Llaika_internal_parse_markup_NestedDelimiter(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_markup_NestedDelimiter)));
}
function $asArrayOf_Llaika_internal_parse_markup_NestedDelimiter(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_markup_NestedDelimiter(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.markup.NestedDelimiter;", depth));
}
var $d_Llaika_internal_parse_markup_NestedDelimiter = new $TypeData().initClass($c_Llaika_internal_parse_markup_NestedDelimiter, "laika.internal.parse.markup.NestedDelimiter", ({
  Llaika_internal_parse_markup_NestedDelimiter: 1,
  Llaika_internal_parse_markup_InlineResult: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_uri_AutoLinkParsers$$anon$1() {
}
$c_Llaika_internal_parse_uri_AutoLinkParsers$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_parse_uri_AutoLinkParsers$$anon$1.prototype.constructor = $c_Llaika_internal_parse_uri_AutoLinkParsers$$anon$1;
/** @constructor */
function $h_Llaika_internal_parse_uri_AutoLinkParsers$$anon$1() {
}
$h_Llaika_internal_parse_uri_AutoLinkParsers$$anon$1.prototype = $c_Llaika_internal_parse_uri_AutoLinkParsers$$anon$1.prototype;
$c_Llaika_internal_parse_uri_AutoLinkParsers$$anon$1.prototype.isDefinedAt__Llaika_parse_builders$$tilde__Z = (function(x) {
  if ((x !== null)) {
    var local = $as_T($n(x).Llaika_parse_builders$$tilde__f__1);
    var domain = $as_T($n(x).Llaika_parse_builders$$tilde__f__2);
    var this$4 = $n(local);
    if ((!(this$4 === ""))) {
      var this$7 = $n(domain);
      var $x_1 = (!(this$7 === ""));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return true;
    }
  }
  return false;
});
$c_Llaika_internal_parse_uri_AutoLinkParsers$$anon$1.prototype.applyOrElse__Llaika_parse_builders$$tilde__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var local = $as_T($n(x).Llaika_parse_builders$$tilde__f__1);
    var domain = $as_T($n(x).Llaika_parse_builders$$tilde__f__2);
    var this$4 = $n(local);
    if ((!(this$4 === ""))) {
      var this$7 = $n(domain);
      var $x_1 = (!(this$7 === ""));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return new $c_T3(local, "@", domain);
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_internal_parse_uri_AutoLinkParsers$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_parse_builders$$tilde__Z($as_Llaika_parse_builders$$tilde(x));
});
$c_Llaika_internal_parse_uri_AutoLinkParsers$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_parse_builders$$tilde__F1__O($as_Llaika_parse_builders$$tilde(x), default$1);
});
var $d_Llaika_internal_parse_uri_AutoLinkParsers$$anon$1 = new $TypeData().initClass($c_Llaika_internal_parse_uri_AutoLinkParsers$$anon$1, "laika.internal.parse.uri.AutoLinkParsers$$anon$1", ({
  Llaika_internal_parse_uri_AutoLinkParsers$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$1(phase$7, removeScopes$6, cursor$7, rules$lzy1$6, baseRules$7) {
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$1__f_phase$3 = null;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$1__f_removeScopes$2 = false;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$1__f_cursor$3 = null;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$1__f_rules$lzy1$2 = null;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$1__f_baseRules$3 = null;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$1__f_phase$3 = phase$7;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$1__f_removeScopes$2 = removeScopes$6;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$1__f_cursor$3 = cursor$7;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$1__f_rules$lzy1$2 = rules$lzy1$6;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$1__f_baseRules$3 = baseRules$7;
}
$c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$1.prototype.constructor = $c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$1;
/** @constructor */
function $h_Llaika_internal_rewrite_RecursiveResolverRules$$anon$1() {
}
$h_Llaika_internal_rewrite_RecursiveResolverRules$$anon$1.prototype = $c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$1.prototype;
$c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$1.prototype.isDefinedAt__Llaika_ast_Block__Z = (function(x) {
  if ($is_Llaika_ast_BlockResolver(x)) {
    var ph = $as_Llaika_ast_BlockResolver(x);
    if ($n(ph).runsIn__Llaika_ast_RewritePhase__Z(this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$1__f_phase$3)) {
      return true;
    }
  }
  if ((x instanceof $c_Llaika_ast_BlockScope)) {
    $as_Llaika_ast_BlockScope(x);
    if (this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$1__f_removeScopes$2) {
      return true;
    }
    return true;
  }
  return false;
});
$c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$1.prototype.applyOrElse__Llaika_ast_Block__F1__O = (function(x, default$1) {
  if ($is_Llaika_ast_BlockResolver(x)) {
    var ph = $as_Llaika_ast_BlockResolver(x);
    if ($n(ph).runsIn__Llaika_ast_RewritePhase__Z(this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$1__f_phase$3)) {
      var newValue = $n($m_Llaika_internal_rewrite_RecursiveResolverRules$().laika$internal$rewrite$RecursiveResolverRules$$$_$rules$1__sr_LazyRef__Llaika_ast_RewritePhase__Z__Llaika_ast_DocumentCursor__Llaika_ast_RewriteRules__Llaika_ast_RewriteRules(this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$1__f_rules$lzy1$2, this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$1__f_phase$3, this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$1__f_removeScopes$2, this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$1__f_cursor$3, this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$1__f_baseRules$3)).rewriteBlock__Llaika_ast_Block__Llaika_ast_Block($n(ph).resolve__Llaika_ast_DocumentCursor__Llaika_ast_Block(this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$1__f_cursor$3));
      return new $c_Llaika_ast_RewriteAction$Replace(newValue);
    }
  }
  if ((x instanceof $c_Llaika_ast_BlockScope)) {
    var x9 = $as_Llaika_ast_BlockScope(x);
    if (this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$1__f_removeScopes$2) {
      var newValue$1 = $n($m_Llaika_internal_rewrite_RecursiveResolverRules$().laika$internal$rewrite$RecursiveResolverRules$$$_$rulesForScope$1__Llaika_ast_DocumentCursor__Llaika_ast_RewriteRules__Llaika_ast_RewritePhase__Llaika_ast_ElementScope__Llaika_ast_RewriteRules(this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$1__f_cursor$3, this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$1__f_baseRules$3, this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$1__f_phase$3, x9)).rewriteBlock__Llaika_ast_Block__Llaika_ast_Block($n(x9).Llaika_ast_BlockScope__f_content);
      return new $c_Llaika_ast_RewriteAction$Replace(newValue$1);
    }
    $n(x9);
    var content = $n($m_Llaika_internal_rewrite_RecursiveResolverRules$().laika$internal$rewrite$RecursiveResolverRules$$$_$rulesForScope$1__Llaika_ast_DocumentCursor__Llaika_ast_RewriteRules__Llaika_ast_RewritePhase__Llaika_ast_ElementScope__Llaika_ast_RewriteRules(this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$1__f_cursor$3, this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$1__f_baseRules$3, this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$1__f_phase$3, x9)).rewriteBlock__Llaika_ast_Block__Llaika_ast_Block($n(x9).Llaika_ast_BlockScope__f_content);
    var this$3 = $n(x9);
    var context = this$3.Llaika_ast_BlockScope__f_context;
    var this$4 = $n(x9);
    var source = this$4.Llaika_ast_BlockScope__f_source;
    var this$5 = $n(x9);
    var options = this$5.Llaika_ast_BlockScope__f_options;
    var newValue$2 = new $c_Llaika_ast_BlockScope(content, context, source, options);
    return new $c_Llaika_ast_RewriteAction$Replace(newValue$2);
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Block__Z($as_Llaika_ast_Block(x));
});
$c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Block__F1__O($as_Llaika_ast_Block(x), default$1);
});
var $d_Llaika_internal_rewrite_RecursiveResolverRules$$anon$1 = new $TypeData().initClass($c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$1, "laika.internal.rewrite.RecursiveResolverRules$$anon$1", ({
  Llaika_internal_rewrite_RecursiveResolverRules$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$2(phase$8, removeScopes$7, cursor$8, rules$lzy1$7, baseRules$8) {
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$2__f_phase$4 = null;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$2__f_removeScopes$3 = false;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$2__f_cursor$4 = null;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$2__f_rules$lzy1$3 = null;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$2__f_baseRules$4 = null;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$2__f_phase$4 = phase$8;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$2__f_removeScopes$3 = removeScopes$7;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$2__f_cursor$4 = cursor$8;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$2__f_rules$lzy1$3 = rules$lzy1$7;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$2__f_baseRules$4 = baseRules$8;
}
$c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$2.prototype.constructor = $c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$2;
/** @constructor */
function $h_Llaika_internal_rewrite_RecursiveResolverRules$$anon$2() {
}
$h_Llaika_internal_rewrite_RecursiveResolverRules$$anon$2.prototype = $c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$2.prototype;
$c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$2.prototype.isDefinedAt__Llaika_ast_Span__Z = (function(x) {
  if ($is_Llaika_ast_SpanResolver(x)) {
    var ph = $as_Llaika_ast_SpanResolver(x);
    if ($n(ph).runsIn__Llaika_ast_RewritePhase__Z(this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$2__f_phase$4)) {
      return true;
    }
  }
  if (false) {
    $as_Llaika_ast_SpanScope(x);
    if (this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$2__f_removeScopes$3) {
      return true;
    }
    return true;
  }
  return false;
});
$c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$2.prototype.applyOrElse__Llaika_ast_Span__F1__O = (function(x, default$1) {
  if ($is_Llaika_ast_SpanResolver(x)) {
    var ph = $as_Llaika_ast_SpanResolver(x);
    if ($n(ph).runsIn__Llaika_ast_RewritePhase__Z(this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$2__f_phase$4)) {
      var newValue = $n($m_Llaika_internal_rewrite_RecursiveResolverRules$().laika$internal$rewrite$RecursiveResolverRules$$$_$rules$1__sr_LazyRef__Llaika_ast_RewritePhase__Z__Llaika_ast_DocumentCursor__Llaika_ast_RewriteRules__Llaika_ast_RewriteRules(this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$2__f_rules$lzy1$3, this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$2__f_phase$4, this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$2__f_removeScopes$3, this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$2__f_cursor$4, this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$2__f_baseRules$4)).rewriteSpan__Llaika_ast_Span__Llaika_ast_Span($n(ph).resolve__Llaika_ast_DocumentCursor__Llaika_ast_Span(this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$2__f_cursor$4));
      return new $c_Llaika_ast_RewriteAction$Replace(newValue);
    }
  }
  if (false) {
    var x17 = $as_Llaika_ast_SpanScope(x);
    if (this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$2__f_removeScopes$3) {
      var newValue$1 = $n($m_Llaika_internal_rewrite_RecursiveResolverRules$().laika$internal$rewrite$RecursiveResolverRules$$$_$rulesForScope$1__Llaika_ast_DocumentCursor__Llaika_ast_RewriteRules__Llaika_ast_RewritePhase__Llaika_ast_ElementScope__Llaika_ast_RewriteRules(this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$2__f_cursor$4, this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$2__f_baseRules$4, this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$2__f_phase$4, x17)).rewriteSpan__Llaika_ast_Span__Llaika_ast_Span($n(x17).content__Llaika_ast_Span());
      return new $c_Llaika_ast_RewriteAction$Replace(newValue$1);
    }
    var newValue$2 = $n(x17).copy__Llaika_ast_Span__Llaika_api_config_ConfigValue__Llaika_parse_SourceFragment__Llaika_ast_Options__Llaika_ast_SpanScope($n($m_Llaika_internal_rewrite_RecursiveResolverRules$().laika$internal$rewrite$RecursiveResolverRules$$$_$rulesForScope$1__Llaika_ast_DocumentCursor__Llaika_ast_RewriteRules__Llaika_ast_RewritePhase__Llaika_ast_ElementScope__Llaika_ast_RewriteRules(this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$2__f_cursor$4, this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$2__f_baseRules$4, this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$2__f_phase$4, x17)).rewriteSpan__Llaika_ast_Span__Llaika_ast_Span($n(x17).content__Llaika_ast_Span()), $n(x17).copy$default$2__Llaika_api_config_ConfigValue(), $n(x17).copy$default$3__Llaika_parse_SourceFragment(), $n(x17).copy$default$4__Llaika_ast_Options());
    return new $c_Llaika_ast_RewriteAction$Replace(newValue$2);
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Span__Z($as_Llaika_ast_Span(x));
});
$c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Span__F1__O($as_Llaika_ast_Span(x), default$1);
});
var $d_Llaika_internal_rewrite_RecursiveResolverRules$$anon$2 = new $TypeData().initClass($c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$2, "laika.internal.rewrite.RecursiveResolverRules$$anon$2", ({
  Llaika_internal_rewrite_RecursiveResolverRules$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$3(phase$9, removeScopes$8, cursor$9, rules$lzy1$8, baseRules$9) {
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$3__f_phase$5 = null;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$3__f_removeScopes$4 = false;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$3__f_cursor$5 = null;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$3__f_rules$lzy1$4 = null;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$3__f_baseRules$5 = null;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$3__f_phase$5 = phase$9;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$3__f_removeScopes$4 = removeScopes$8;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$3__f_cursor$5 = cursor$9;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$3__f_rules$lzy1$4 = rules$lzy1$8;
  this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$3__f_baseRules$5 = baseRules$9;
}
$c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$3.prototype.constructor = $c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$3;
/** @constructor */
function $h_Llaika_internal_rewrite_RecursiveResolverRules$$anon$3() {
}
$h_Llaika_internal_rewrite_RecursiveResolverRules$$anon$3.prototype = $c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$3.prototype;
$c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$3.prototype.isDefinedAt__Llaika_ast_TemplateSpan__Z = (function(x) {
  if ($is_Llaika_ast_SpanResolver(x)) {
    var ph = $as_Llaika_ast_SpanResolver(x);
    if ($n(ph).runsIn__Llaika_ast_RewritePhase__Z(this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$3__f_phase$5)) {
      return true;
    }
  }
  if ((x instanceof $c_Llaika_ast_TemplateScope)) {
    $as_Llaika_ast_TemplateScope(x);
    if (this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$3__f_removeScopes$4) {
      return true;
    }
    return true;
  }
  return false;
});
$c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$3.prototype.applyOrElse__Llaika_ast_TemplateSpan__F1__O = (function(x, default$1) {
  if ($is_Llaika_ast_SpanResolver(x)) {
    var ph = $as_Llaika_ast_SpanResolver(x);
    if ($n(ph).runsIn__Llaika_ast_RewritePhase__Z(this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$3__f_phase$5)) {
      var newValue = $n($m_Llaika_internal_rewrite_RecursiveResolverRules$().laika$internal$rewrite$RecursiveResolverRules$$$_$rules$1__sr_LazyRef__Llaika_ast_RewritePhase__Z__Llaika_ast_DocumentCursor__Llaika_ast_RewriteRules__Llaika_ast_RewriteRules(this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$3__f_rules$lzy1$4, this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$3__f_phase$5, this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$3__f_removeScopes$4, this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$3__f_cursor$5, this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$3__f_baseRules$5)).rewriteTemplateSpan__Llaika_ast_TemplateSpan__Llaika_ast_TemplateSpan($m_Llaika_internal_rewrite_RecursiveResolverRules$().laika$internal$rewrite$RecursiveResolverRules$$$asTemplateSpan__Llaika_ast_Span__Llaika_ast_TemplateSpan($n(ph).resolve__Llaika_ast_DocumentCursor__Llaika_ast_Span(this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$3__f_cursor$5)));
      return new $c_Llaika_ast_RewriteAction$Replace(newValue);
    }
  }
  if ((x instanceof $c_Llaika_ast_TemplateScope)) {
    var x25 = $as_Llaika_ast_TemplateScope(x);
    if (this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$3__f_removeScopes$4) {
      var newValue$1 = $n($m_Llaika_internal_rewrite_RecursiveResolverRules$().laika$internal$rewrite$RecursiveResolverRules$$$_$rulesForScope$1__Llaika_ast_DocumentCursor__Llaika_ast_RewriteRules__Llaika_ast_RewritePhase__Llaika_ast_ElementScope__Llaika_ast_RewriteRules(this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$3__f_cursor$5, this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$3__f_baseRules$5, this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$3__f_phase$5, x25)).rewriteTemplateSpan__Llaika_ast_TemplateSpan__Llaika_ast_TemplateSpan($n(x25).Llaika_ast_TemplateScope__f_content);
      return new $c_Llaika_ast_RewriteAction$Replace(newValue$1);
    }
    $n(x25);
    var content = $n($m_Llaika_internal_rewrite_RecursiveResolverRules$().laika$internal$rewrite$RecursiveResolverRules$$$_$rulesForScope$1__Llaika_ast_DocumentCursor__Llaika_ast_RewriteRules__Llaika_ast_RewritePhase__Llaika_ast_ElementScope__Llaika_ast_RewriteRules(this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$3__f_cursor$5, this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$3__f_baseRules$5, this.Llaika_internal_rewrite_RecursiveResolverRules$$anon$3__f_phase$5, x25)).rewriteTemplateSpan__Llaika_ast_TemplateSpan__Llaika_ast_TemplateSpan($n(x25).Llaika_ast_TemplateScope__f_content);
    var this$3 = $n(x25);
    var context = this$3.Llaika_ast_TemplateScope__f_context;
    var this$4 = $n(x25);
    var source = this$4.Llaika_ast_TemplateScope__f_source;
    var this$5 = $n(x25);
    var options = this$5.Llaika_ast_TemplateScope__f_options;
    var newValue$2 = new $c_Llaika_ast_TemplateScope(content, context, source, options);
    return new $c_Llaika_ast_RewriteAction$Replace(newValue$2);
  }
  return $n(default$1).apply__O__O(x);
});
$c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$3.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_TemplateSpan__Z($as_Llaika_ast_TemplateSpan(x));
});
$c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$3.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_TemplateSpan__F1__O($as_Llaika_ast_TemplateSpan(x), default$1);
});
var $d_Llaika_internal_rewrite_RecursiveResolverRules$$anon$3 = new $TypeData().initClass($c_Llaika_internal_rewrite_RecursiveResolverRules$$anon$3, "laika.internal.rewrite.RecursiveResolverRules$$anon$3", ({
  Llaika_internal_rewrite_RecursiveResolverRules$$anon$3: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_rewrite_TemplateFormatter$$anon$1() {
}
$c_Llaika_internal_rewrite_TemplateFormatter$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_rewrite_TemplateFormatter$$anon$1.prototype.constructor = $c_Llaika_internal_rewrite_TemplateFormatter$$anon$1;
/** @constructor */
function $h_Llaika_internal_rewrite_TemplateFormatter$$anon$1() {
}
$h_Llaika_internal_rewrite_TemplateFormatter$$anon$1.prototype = $c_Llaika_internal_rewrite_TemplateFormatter$$anon$1.prototype;
$c_Llaika_internal_rewrite_TemplateFormatter$$anon$1.prototype.isDefinedAt__Llaika_ast_Block__Z = (function(x) {
  if ((x instanceof $c_Llaika_ast_TemplateRoot)) {
    $m_Llaika_ast_TemplateRoot$();
    var x$1 = $as_Llaika_ast_TemplateRoot(x);
    var this$2 = $n(x$1);
    var this$3 = $n(x$1);
    return true;
  } else {
    return ($is_Llaika_ast_SpanContainer(x) && (x !== null));
  }
});
$c_Llaika_internal_rewrite_TemplateFormatter$$anon$1.prototype.applyOrElse__Llaika_ast_Block__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Llaika_ast_TemplateRoot)) {
    $m_Llaika_ast_TemplateRoot$();
    var x$1 = $as_Llaika_ast_TemplateRoot(x);
    var this$2 = $n(x$1);
    var x69 = this$2.Llaika_ast_TemplateRoot__f_content;
    var this$3 = $n(x$1);
    var x70 = this$3.Llaika_ast_TemplateRoot__f_options;
    $m_Llaika_ast_TemplateRoot$();
    var content = $m_Llaika_internal_rewrite_TemplateFormatter$().laika$internal$rewrite$TemplateFormatter$$$format__sci_Seq__sci_Seq(x69);
    var newValue = new $c_Llaika_ast_TemplateRoot(content, x70);
    return new $c_Llaika_ast_RewriteAction$Replace(newValue);
  } else if (($is_Llaika_ast_SpanContainer(x) && (x !== null))) {
    var newValue$1 = $as_Llaika_ast_Block($n($as_Llaika_ast_SpanContainer(x)).withContent__sci_Seq__Llaika_ast_SpanContainer($m_Llaika_internal_rewrite_TemplateFormatter$().laika$internal$rewrite$TemplateFormatter$$$joinTextSpans__sci_Seq__sci_Seq($as_sci_Seq($n($as_Llaika_ast_Container(x)).content__O()))));
    return new $c_Llaika_ast_RewriteAction$Replace(newValue$1);
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_internal_rewrite_TemplateFormatter$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Block__Z($as_Llaika_ast_Block(x));
});
$c_Llaika_internal_rewrite_TemplateFormatter$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Block__F1__O($as_Llaika_ast_Block(x), default$1);
});
var $d_Llaika_internal_rewrite_TemplateFormatter$$anon$1 = new $TypeData().initClass($c_Llaika_internal_rewrite_TemplateFormatter$$anon$1, "laika.internal.rewrite.TemplateFormatter$$anon$1", ({
  Llaika_internal_rewrite_TemplateFormatter$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_rewrite_TemplateFormatter$$anon$2() {
}
$c_Llaika_internal_rewrite_TemplateFormatter$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_rewrite_TemplateFormatter$$anon$2.prototype.constructor = $c_Llaika_internal_rewrite_TemplateFormatter$$anon$2;
/** @constructor */
function $h_Llaika_internal_rewrite_TemplateFormatter$$anon$2() {
}
$h_Llaika_internal_rewrite_TemplateFormatter$$anon$2.prototype = $c_Llaika_internal_rewrite_TemplateFormatter$$anon$2.prototype;
$c_Llaika_internal_rewrite_TemplateFormatter$$anon$2.prototype.isDefinedAt__Llaika_ast_Span__Z = (function(x) {
  return ($is_Llaika_ast_SpanContainer(x) && (x !== null));
});
$c_Llaika_internal_rewrite_TemplateFormatter$$anon$2.prototype.applyOrElse__Llaika_ast_Span__F1__O = (function(x, default$1) {
  if (($is_Llaika_ast_SpanContainer(x) && (x !== null))) {
    var newValue = $as_Llaika_ast_Span($n($as_Llaika_ast_SpanContainer(x)).withContent__sci_Seq__Llaika_ast_SpanContainer($m_Llaika_internal_rewrite_TemplateFormatter$().laika$internal$rewrite$TemplateFormatter$$$joinTextSpans__sci_Seq__sci_Seq($as_sci_Seq($n($as_Llaika_ast_Container(x)).content__O()))));
    return new $c_Llaika_ast_RewriteAction$Replace(newValue);
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_internal_rewrite_TemplateFormatter$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Span__Z($as_Llaika_ast_Span(x));
});
$c_Llaika_internal_rewrite_TemplateFormatter$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Span__F1__O($as_Llaika_ast_Span(x), default$1);
});
var $d_Llaika_internal_rewrite_TemplateFormatter$$anon$2 = new $TypeData().initClass($c_Llaika_internal_rewrite_TemplateFormatter$$anon$2, "laika.internal.rewrite.TemplateFormatter$$anon$2", ({
  Llaika_internal_rewrite_TemplateFormatter$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_rewrite_TemplateFormatter$$anon$3() {
}
$c_Llaika_internal_rewrite_TemplateFormatter$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_rewrite_TemplateFormatter$$anon$3.prototype.constructor = $c_Llaika_internal_rewrite_TemplateFormatter$$anon$3;
/** @constructor */
function $h_Llaika_internal_rewrite_TemplateFormatter$$anon$3() {
}
$h_Llaika_internal_rewrite_TemplateFormatter$$anon$3.prototype = $c_Llaika_internal_rewrite_TemplateFormatter$$anon$3.prototype;
$c_Llaika_internal_rewrite_TemplateFormatter$$anon$3.prototype.isDefinedAt__Llaika_ast_TemplateSpan__Z = (function(x) {
  if ((x instanceof $c_Llaika_ast_TemplateSpanSequence)) {
    var x$1 = $as_Llaika_ast_TemplateSpanSequence(x);
    var this$2 = $n(x$1);
    var this$3 = $n(x$1);
    return true;
  } else {
    return false;
  }
});
$c_Llaika_internal_rewrite_TemplateFormatter$$anon$3.prototype.applyOrElse__Llaika_ast_TemplateSpan__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Llaika_ast_TemplateSpanSequence)) {
    var x$1 = $as_Llaika_ast_TemplateSpanSequence(x);
    var this$2 = $n(x$1);
    var x83 = this$2.Llaika_ast_TemplateSpanSequence__f_content;
    var this$3 = $n(x$1);
    var x84 = this$3.Llaika_ast_TemplateSpanSequence__f_options;
    var content = $m_Llaika_internal_rewrite_TemplateFormatter$().laika$internal$rewrite$TemplateFormatter$$$format__sci_Seq__sci_Seq(x83);
    var newValue = new $c_Llaika_ast_TemplateSpanSequence(content, x84);
    return new $c_Llaika_ast_RewriteAction$Replace(newValue);
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_internal_rewrite_TemplateFormatter$$anon$3.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_TemplateSpan__Z($as_Llaika_ast_TemplateSpan(x));
});
$c_Llaika_internal_rewrite_TemplateFormatter$$anon$3.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_TemplateSpan__F1__O($as_Llaika_ast_TemplateSpan(x), default$1);
});
var $d_Llaika_internal_rewrite_TemplateFormatter$$anon$3 = new $TypeData().initClass($c_Llaika_internal_rewrite_TemplateFormatter$$anon$3, "laika.internal.rewrite.TemplateFormatter$$anon$3", ({
  Llaika_internal_rewrite_TemplateFormatter$$anon$3: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$1(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$1.prototype.constructor = $c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$1;
/** @constructor */
function $h_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$1() {
}
$h_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$1.prototype = $c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$1.prototype;
$c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$1.prototype.isDefinedAt__Llaika_ast_Block__Z = (function(x) {
  return ($is_Llaika_ast_Unresolved(x) && ($as_Llaika_ast_Block($as_Llaika_ast_Unresolved(x)), true));
});
$c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$1.prototype.applyOrElse__Llaika_ast_Block__F1__O = (function(x, default$1) {
  if ($is_Llaika_ast_Unresolved(x)) {
    var unresolved = $as_Llaika_ast_Block($as_Llaika_ast_Unresolved(x));
    var newValue = $m_Llaika_ast_InvalidBlock$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidBlock($n($as_Llaika_ast_Unresolved(unresolved)).unresolvedMessage__T(), $n($as_Llaika_ast_Unresolved(unresolved)).source__Llaika_parse_SourceFragment());
    return new $c_Llaika_ast_RewriteAction$Replace(newValue);
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Block__Z($as_Llaika_ast_Block(x));
});
$c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Block__F1__O($as_Llaika_ast_Block(x), default$1);
});
var $d_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$1 = new $TypeData().initClass($c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$1, "laika.internal.rewrite.UnresolvedNodeDetector$$anon$1", ({
  Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$2(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$2.prototype.constructor = $c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$2;
/** @constructor */
function $h_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$2() {
}
$h_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$2.prototype = $c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$2.prototype;
$c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$2.prototype.isDefinedAt__Llaika_ast_Span__Z = (function(x) {
  return ($is_Llaika_ast_Unresolved(x) && ($as_Llaika_ast_Span($as_Llaika_ast_Unresolved(x)), true));
});
$c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$2.prototype.applyOrElse__Llaika_ast_Span__F1__O = (function(x, default$1) {
  if ($is_Llaika_ast_Unresolved(x)) {
    var unresolved = $as_Llaika_ast_Span($as_Llaika_ast_Unresolved(x));
    var newValue = $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan($n($as_Llaika_ast_Unresolved(unresolved)).unresolvedMessage__T(), $n($as_Llaika_ast_Unresolved(unresolved)).source__Llaika_parse_SourceFragment());
    return new $c_Llaika_ast_RewriteAction$Replace(newValue);
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_Span__Z($as_Llaika_ast_Span(x));
});
$c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_Span__F1__O($as_Llaika_ast_Span(x), default$1);
});
var $d_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$2 = new $TypeData().initClass($c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$2, "laika.internal.rewrite.UnresolvedNodeDetector$$anon$2", ({
  Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$3(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$3.prototype.constructor = $c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$3;
/** @constructor */
function $h_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$3() {
}
$h_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$3.prototype = $c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$3.prototype;
$c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$3.prototype.isDefinedAt__Llaika_ast_TemplateSpan__Z = (function(x) {
  return ($is_Llaika_ast_Unresolved(x) && ($as_Llaika_ast_TemplateSpan($as_Llaika_ast_Unresolved(x)), true));
});
$c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$3.prototype.applyOrElse__Llaika_ast_TemplateSpan__F1__O = (function(x, default$1) {
  if ($is_Llaika_ast_Unresolved(x)) {
    var unresolved = $as_Llaika_ast_TemplateSpan($as_Llaika_ast_Unresolved(x));
    var element = $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan($n($as_Llaika_ast_Unresolved(unresolved)).unresolvedMessage__T(), $n($as_Llaika_ast_Unresolved(unresolved)).source__Llaika_parse_SourceFragment());
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var newValue = new $c_Llaika_ast_TemplateElement(element, 0, options);
    return new $c_Llaika_ast_RewriteAction$Replace(newValue);
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$3.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Llaika_ast_TemplateSpan__Z($as_Llaika_ast_TemplateSpan(x));
});
$c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$3.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Llaika_ast_TemplateSpan__F1__O($as_Llaika_ast_TemplateSpan(x), default$1);
});
var $d_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$3 = new $TypeData().initClass($c_Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$3, "laika.internal.rewrite.UnresolvedNodeDetector$$anon$3", ({
  Llaika_internal_rewrite_UnresolvedNodeDetector$$anon$3: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
function $p_Llaika_parse_Failure__failureContext__Llaika_parse_SourceCursor($thiz) {
  if ((!$thiz.Llaika_parse_Failure__f_failureContextbitmap$1)) {
    $thiz.Llaika_parse_Failure__f_failureContext$lzy1 = $n($thiz.Llaika_parse_Failure__f_next).consume__I__Llaika_parse_SourceCursor((($thiz.Llaika_parse_Failure__f_maxOffset - $n($thiz.Llaika_parse_Failure__f_next).offset__I()) | 0));
    $thiz.Llaika_parse_Failure__f_failureContextbitmap$1 = true;
  }
  return $thiz.Llaika_parse_Failure__f_failureContext$lzy1;
}
/** @constructor */
function $c_Llaika_parse_Failure(msgProvider, next, maxOffset) {
  this.Llaika_parse_Failure__f_msgProvider = null;
  this.Llaika_parse_Failure__f_next = null;
  this.Llaika_parse_Failure__f_maxOffset = 0;
  this.Llaika_parse_Failure__f_failureContext$lzy1 = null;
  this.Llaika_parse_Failure__f_failureContextbitmap$1 = false;
  this.Llaika_parse_Failure__f_message$lzy1 = null;
  this.Llaika_parse_Failure__f_messagebitmap$1 = false;
  this.Llaika_parse_Failure__f_msgProvider = msgProvider;
  this.Llaika_parse_Failure__f_next = next;
  this.Llaika_parse_Failure__f_maxOffset = maxOffset;
}
$c_Llaika_parse_Failure.prototype = new $h_Llaika_parse_Parsed();
$c_Llaika_parse_Failure.prototype.constructor = $c_Llaika_parse_Failure;
/** @constructor */
function $h_Llaika_parse_Failure() {
}
$h_Llaika_parse_Failure.prototype = $c_Llaika_parse_Failure.prototype;
$c_Llaika_parse_Failure.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_parse_Failure.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Failure");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Llaika_parse_Failure__f_msgProvider;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Llaika_parse_Failure__f_next;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Llaika_parse_Failure__f_maxOffset;
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Llaika_parse_Failure.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_parse_Failure)) {
    var x$0$2 = $as_Llaika_parse_Failure(x$0);
    if ((this.Llaika_parse_Failure__f_maxOffset === $n(x$0$2).Llaika_parse_Failure__f_maxOffset)) {
      var x = this.Llaika_parse_Failure__f_msgProvider;
      var x$2 = $n(x$0$2).Llaika_parse_Failure__f_msgProvider;
      if ((x === null)) {
        var $x_2 = (x$2 === null);
      } else {
        var this$1 = $n(x);
        var $x_2 = (this$1 === x$2);
      }
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Llaika_parse_Failure__f_next;
      var x$4 = $n(x$0$2).Llaika_parse_Failure__f_next;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_parse_Failure.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_parse_Failure.prototype.productPrefix__T = (function() {
  return "Failure";
});
$c_Llaika_parse_Failure.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_parse_Failure__f_msgProvider;
      break;
    }
    case 1: {
      return this.Llaika_parse_Failure__f_next;
      break;
    }
    case 2: {
      return this.Llaika_parse_Failure__f_maxOffset;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_parse_Failure.prototype.message__T = (function() {
  if ((!this.Llaika_parse_Failure__f_messagebitmap$1)) {
    this.Llaika_parse_Failure__f_message$lzy1 = $n(this.Llaika_parse_Failure__f_msgProvider).message__Llaika_parse_SourceCursor__T($p_Llaika_parse_Failure__failureContext__Llaika_parse_SourceCursor(this));
    this.Llaika_parse_Failure__f_messagebitmap$1 = true;
  }
  return this.Llaika_parse_Failure__f_message$lzy1;
});
$c_Llaika_parse_Failure.prototype.toEither__s_util_Either = (function() {
  var value = this.message__T();
  return new $c_s_util_Left(value);
});
$c_Llaika_parse_Failure.prototype.orElse__F0__Llaika_parse_Parsed = (function(default$1) {
  matchResult7: {
    var $x_1;
    var x9 = $as_Llaika_parse_Parsed($n(default$1).apply__O());
    if ((x9 instanceof $c_Llaika_parse_Success)) {
      var s = $as_Llaika_parse_Success(x9);
      var $x_1 = s;
      break matchResult7;
    }
    if ((x9 instanceof $c_Llaika_parse_Failure)) {
      var f = $as_Llaika_parse_Failure(x9);
      var $x_1 = (($n(f).Llaika_parse_Failure__f_maxOffset > this.Llaika_parse_Failure__f_maxOffset) ? f : this);
      break matchResult7;
    }
    throw new $c_s_MatchError(x9);
  }
  return $as_Llaika_parse_Parsed($x_1);
});
$c_Llaika_parse_Failure.prototype.toString__T = (function() {
  var pointOfFailure = $n($p_Llaika_parse_Failure__failureContext__Llaika_parse_SourceCursor(this)).position__Llaika_parse_Position();
  return ((((("[" + pointOfFailure) + "] failure: ") + this.message__T()) + "\n\n") + $n(pointOfFailure).lineContentWithCaret__T());
});
$c_Llaika_parse_Failure.prototype.map__F1__Llaika_parse_Parsed = (function(f) {
  return this;
});
function $as_Llaika_parse_Failure(obj) {
  return (((obj instanceof $c_Llaika_parse_Failure) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.parse.Failure"));
}
function $isArrayOf_Llaika_parse_Failure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_parse_Failure)));
}
function $asArrayOf_Llaika_parse_Failure(obj, depth) {
  return (($isArrayOf_Llaika_parse_Failure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.parse.Failure;", depth));
}
var $d_Llaika_parse_Failure = new $TypeData().initClass($c_Llaika_parse_Failure, "laika.parse.Failure", ({
  Llaika_parse_Failure: 1,
  Llaika_parse_Parsed: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_parse_Success(result, next) {
  this.Llaika_parse_Success__f_result = null;
  this.Llaika_parse_Success__f_next = null;
  this.Llaika_parse_Success__f_result = result;
  this.Llaika_parse_Success__f_next = next;
}
$c_Llaika_parse_Success.prototype = new $h_Llaika_parse_Parsed();
$c_Llaika_parse_Success.prototype.constructor = $c_Llaika_parse_Success;
/** @constructor */
function $h_Llaika_parse_Success() {
}
$h_Llaika_parse_Success.prototype = $c_Llaika_parse_Success.prototype;
$c_Llaika_parse_Success.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_parse_Success.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_parse_Success.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_parse_Success)) {
    var x$0$2 = $as_Llaika_parse_Success(x$0);
    var x = this.Llaika_parse_Success__f_result;
    var y = $n(x$0$2).Llaika_parse_Success__f_result;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Llaika_parse_Success__f_next;
      var x$2 = $n(x$0$2).Llaika_parse_Success__f_next;
      var $x_1 = ((x$1 === null) ? (x$2 === null) : $n(x$1).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_parse_Success.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_parse_Success.prototype.productPrefix__T = (function() {
  return "Success";
});
$c_Llaika_parse_Success.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_parse_Success__f_result;
  }
  if ((n === 1)) {
    return this.Llaika_parse_Success__f_next;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_parse_Success.prototype.toEither__s_util_Either = (function() {
  var value = this.Llaika_parse_Success__f_result;
  return new $c_s_util_Right(value);
});
$c_Llaika_parse_Success.prototype.orElse__F0__Llaika_parse_Parsed = (function(default$1) {
  return this;
});
$c_Llaika_parse_Success.prototype.map__F1__Llaika_parse_Parsed = (function(f) {
  var result = $n(f).apply__O__O(this.Llaika_parse_Success__f_result);
  var next = this.Llaika_parse_Success__f_next;
  return new $c_Llaika_parse_Success(result, next);
});
$c_Llaika_parse_Success.prototype.toString__T = (function() {
  return ((("[" + $n(this.Llaika_parse_Success__f_next).position__Llaika_parse_Position()) + "] parsed: ") + this.Llaika_parse_Success__f_result);
});
function $as_Llaika_parse_Success(obj) {
  return (((obj instanceof $c_Llaika_parse_Success) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.parse.Success"));
}
function $isArrayOf_Llaika_parse_Success(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_parse_Success)));
}
function $asArrayOf_Llaika_parse_Success(obj, depth) {
  return (($isArrayOf_Llaika_parse_Success(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.parse.Success;", depth));
}
var $d_Llaika_parse_Success = new $TypeData().initClass($c_Llaika_parse_Success, "laika.parse.Success", ({
  Llaika_parse_Success: 1,
  Llaika_parse_Parsed: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_parse_builders$() {
  this.Llaika_parse_builders$__f_ws$lzy1 = null;
  this.Llaika_parse_builders$__f_wsbitmap$1 = false;
  this.Llaika_parse_builders$__f_eol = null;
  this.Llaika_parse_builders$__f_wsEol = null;
  this.Llaika_parse_builders$__f_eof = null;
  this.Llaika_parse_builders$__f_blankLine = null;
  this.Llaika_parse_builders$__f_blankLines = null;
  this.Llaika_parse_builders$__f_restOfLine = null;
  this.Llaika_parse_builders$__f_textLine = null;
  this.Llaika_parse_builders$__f_anyChars = null;
  this.Llaika_parse_builders$__f_oneChar = null;
  $n_Llaika_parse_builders$ = this;
  $f_Llaika_parse_text_TextParsers__$init$__V(this);
  $f_Llaika_parse_markup_BlockParsers__$init$__V(this);
}
$c_Llaika_parse_builders$.prototype = new $h_O();
$c_Llaika_parse_builders$.prototype.constructor = $c_Llaika_parse_builders$;
/** @constructor */
function $h_Llaika_parse_builders$() {
}
$h_Llaika_parse_builders$.prototype = $c_Llaika_parse_builders$.prototype;
$c_Llaika_parse_builders$.prototype.ws__Llaika_parse_text_Characters = (function() {
  if ((!this.Llaika_parse_builders$__f_wsbitmap$1)) {
    this.Llaika_parse_builders$__f_ws$lzy1 = $f_Llaika_parse_text_TextParsers__ws__Llaika_parse_text_Characters(this);
    this.Llaika_parse_builders$__f_wsbitmap$1 = true;
  }
  return this.Llaika_parse_builders$__f_ws$lzy1;
});
$c_Llaika_parse_builders$.prototype.eol__Llaika_parse_Parser = (function() {
  return this.Llaika_parse_builders$__f_eol;
});
$c_Llaika_parse_builders$.prototype.wsEol__Llaika_parse_Parser = (function() {
  return this.Llaika_parse_builders$__f_wsEol;
});
$c_Llaika_parse_builders$.prototype.eof__Llaika_parse_Parser = (function() {
  return this.Llaika_parse_builders$__f_eof;
});
$c_Llaika_parse_builders$.prototype.blankLine__Llaika_parse_Parser = (function() {
  return this.Llaika_parse_builders$__f_blankLine;
});
$c_Llaika_parse_builders$.prototype.restOfLine__Llaika_parse_Parser = (function() {
  return this.Llaika_parse_builders$__f_restOfLine;
});
$c_Llaika_parse_builders$.prototype.anyChars__Llaika_parse_text_Characters = (function() {
  return this.Llaika_parse_builders$__f_anyChars;
});
$c_Llaika_parse_builders$.prototype.laika$parse$text$TextParsers$_setter_$eol_$eq__Llaika_parse_Parser__V = (function(x$0) {
  this.Llaika_parse_builders$__f_eol = x$0;
});
$c_Llaika_parse_builders$.prototype.laika$parse$text$TextParsers$_setter_$wsEol_$eq__Llaika_parse_Parser__V = (function(x$0) {
  this.Llaika_parse_builders$__f_wsEol = x$0;
});
$c_Llaika_parse_builders$.prototype.laika$parse$text$TextParsers$_setter_$eof_$eq__Llaika_parse_Parser__V = (function(x$0) {
  this.Llaika_parse_builders$__f_eof = x$0;
});
$c_Llaika_parse_builders$.prototype.laika$parse$text$TextParsers$_setter_$atStart_$eq__Llaika_parse_Parser__V = (function(x$0) {
});
$c_Llaika_parse_builders$.prototype.laika$parse$text$TextParsers$_setter_$blankLine_$eq__Llaika_parse_Parser__V = (function(x$0) {
  this.Llaika_parse_builders$__f_blankLine = x$0;
});
$c_Llaika_parse_builders$.prototype.laika$parse$text$TextParsers$_setter_$blankLines_$eq__Llaika_parse_Parser__V = (function(x$0) {
  this.Llaika_parse_builders$__f_blankLines = x$0;
});
$c_Llaika_parse_builders$.prototype.laika$parse$text$TextParsers$_setter_$restOfLine_$eq__Llaika_parse_Parser__V = (function(x$0) {
  this.Llaika_parse_builders$__f_restOfLine = x$0;
});
$c_Llaika_parse_builders$.prototype.laika$parse$text$TextParsers$_setter_$textLine_$eq__Llaika_parse_Parser__V = (function(x$0) {
  this.Llaika_parse_builders$__f_textLine = x$0;
});
$c_Llaika_parse_builders$.prototype.laika$parse$text$TextParsers$_setter_$anyChars_$eq__Llaika_parse_text_Characters__V = (function(x$0) {
  this.Llaika_parse_builders$__f_anyChars = x$0;
});
$c_Llaika_parse_builders$.prototype.laika$parse$text$TextParsers$_setter_$oneChar_$eq__Llaika_parse_Parser__V = (function(x$0) {
  this.Llaika_parse_builders$__f_oneChar = x$0;
});
var $d_Llaika_parse_builders$ = new $TypeData().initClass($c_Llaika_parse_builders$, "laika.parse.builders$", ({
  Llaika_parse_builders$: 1,
  Llaika_parse_combinator_Parsers: 1,
  Llaika_parse_text_TextParsers: 1,
  Llaika_parse_markup_InlineParsers: 1,
  Llaika_parse_markup_BlockParsers: 1
}));
var $n_Llaika_parse_builders$;
function $m_Llaika_parse_builders$() {
  if ((!$n_Llaika_parse_builders$)) {
    $n_Llaika_parse_builders$ = new $c_Llaika_parse_builders$();
  }
  return $n_Llaika_parse_builders$;
}
/** @constructor */
function $c_Llaika_parse_text_DelimiterResult$Complete(result) {
  this.Llaika_parse_text_DelimiterResult$Complete__f_result = null;
  this.Llaika_parse_text_DelimiterResult$Complete__f_result = result;
}
$c_Llaika_parse_text_DelimiterResult$Complete.prototype = new $h_O();
$c_Llaika_parse_text_DelimiterResult$Complete.prototype.constructor = $c_Llaika_parse_text_DelimiterResult$Complete;
/** @constructor */
function $h_Llaika_parse_text_DelimiterResult$Complete() {
}
$h_Llaika_parse_text_DelimiterResult$Complete.prototype = $c_Llaika_parse_text_DelimiterResult$Complete.prototype;
$c_Llaika_parse_text_DelimiterResult$Complete.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_parse_text_DelimiterResult$Complete.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_parse_text_DelimiterResult$Complete.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_parse_text_DelimiterResult$Complete)) {
    var x$0$2 = $as_Llaika_parse_text_DelimiterResult$Complete(x$0);
    var x = this.Llaika_parse_text_DelimiterResult$Complete__f_result;
    var x$2 = $n(x$0$2).Llaika_parse_text_DelimiterResult$Complete__f_result;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_parse_text_DelimiterResult$Complete.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_parse_text_DelimiterResult$Complete.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_parse_text_DelimiterResult$Complete.prototype.productPrefix__T = (function() {
  return "Complete";
});
$c_Llaika_parse_text_DelimiterResult$Complete.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_parse_text_DelimiterResult$Complete__f_result;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_parse_text_DelimiterResult$Complete(obj) {
  return (((obj instanceof $c_Llaika_parse_text_DelimiterResult$Complete) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.parse.text.DelimiterResult$Complete"));
}
function $isArrayOf_Llaika_parse_text_DelimiterResult$Complete(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_parse_text_DelimiterResult$Complete)));
}
function $asArrayOf_Llaika_parse_text_DelimiterResult$Complete(obj, depth) {
  return (($isArrayOf_Llaika_parse_text_DelimiterResult$Complete(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.parse.text.DelimiterResult$Complete;", depth));
}
var $d_Llaika_parse_text_DelimiterResult$Complete = new $TypeData().initClass($c_Llaika_parse_text_DelimiterResult$Complete, "laika.parse.text.DelimiterResult$Complete", ({
  Llaika_parse_text_DelimiterResult$Complete: 1,
  Llaika_parse_text_DelimiterResult: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $p_Llaika_parse_text_TextDelimiter__applyPostCondition$1__Llaika_parse_SourceCursor__I__s_Option($thiz, source$3, charsConsumed$1) {
  var this$1 = $n($thiz.Llaika_parse_text_TextDelimiter__f_parser);
  if (this$1.isEmpty__Z()) {
    return $m_s_Option$().apply__O__s_Option(0);
  } else {
    var arg1 = this$1.get__O();
    var parser = $as_Llaika_parse_text_PrefixedParser(arg1);
    var this$2 = $n(parser);
    var in$1 = $n(source$3).consume__I__Llaika_parse_SourceCursor(charsConsumed$1);
    var x9 = $n(this$2.underlying__Llaika_parse_Parser()).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(in$1);
    if ((x9 instanceof $c_Llaika_parse_Success)) {
      var x$1 = $as_Llaika_parse_Success(x9);
      var this$4 = $n(x$1);
      $as_T(this$4.Llaika_parse_Success__f_result);
      var this$5 = $n(x$1);
      var x13 = this$5.Llaika_parse_Success__f_next;
      var value = (($n(x13).offset__I() - (($n(source$3).offset__I() + charsConsumed$1) | 0)) | 0);
      return new $c_s_Some(value);
    }
    return $m_s_None$();
  }
}
function $p_Llaika_parse_text_TextDelimiter__result$1__Llaika_parse_SourceCursor__I__I__Llaika_parse_Success($thiz, source$5, charsConsumed$3, delimConsumed) {
  var capturedText = $n(source$5).capture__I__T(charsConsumed$3);
  var totalConsumed = ($thiz.Llaika_parse_text_TextDelimiter__f_keepDelimiter ? charsConsumed$3 : ((charsConsumed$3 + delimConsumed) | 0));
  var next = $n(source$5).consume__I__Llaika_parse_SourceCursor(totalConsumed);
  return new $c_Llaika_parse_Success(capturedText, next);
}
/** @constructor */
function $c_Llaika_parse_text_TextDelimiter(parser, acceptEOF, nonEmpty, keepDelimiter, failOn) {
  this.Llaika_parse_text_TextDelimiter__f_parser = null;
  this.Llaika_parse_text_TextDelimiter__f_acceptEOF = false;
  this.Llaika_parse_text_TextDelimiter__f_nonEmpty = false;
  this.Llaika_parse_text_TextDelimiter__f_keepDelimiter = false;
  this.Llaika_parse_text_TextDelimiter__f_failOn = null;
  this.Llaika_parse_text_TextDelimiter__f_startChars = null;
  this.Llaika_parse_text_TextDelimiter__f_emptyResult = null;
  this.Llaika_parse_text_TextDelimiter__f_unexpectedInput = null;
  this.Llaika_parse_text_TextDelimiter__f_parser = parser;
  this.Llaika_parse_text_TextDelimiter__f_acceptEOF = acceptEOF;
  this.Llaika_parse_text_TextDelimiter__f_nonEmpty = nonEmpty;
  this.Llaika_parse_text_TextDelimiter__f_keepDelimiter = keepDelimiter;
  this.Llaika_parse_text_TextDelimiter__f_failOn = failOn;
  var this$1 = $n(parser);
  if (this$1.isEmpty__Z()) {
    var $x_1 = failOn;
  } else {
    var arg1 = this$1.get__O();
    var _$1 = $as_Llaika_parse_text_PrefixedParser(arg1);
    var value = $n(_$1).startChars__O();
    var this$3 = new $c_Lcats_data_NonEmptySetOps(value);
    var s = this$3.Lcats_data_NonEmptySetOps__f_value;
    var this$5 = $n($as_sci_SortedSet(s));
    var $x_1 = $as_sci_Set(this$5.concat__sc_IterableOnce__sc_SetOps(failOn));
  }
  this.Llaika_parse_text_TextDelimiter__f_startChars = $x_1;
  var this$6 = $m_Llaika_parse_Message$();
  this.Llaika_parse_text_TextDelimiter__f_emptyResult = new $c_Llaika_parse_Message$$anon$2("expected at least 1 character before end delimiter", this$6);
  $m_Llaika_parse_Message$();
  var f = new $c_sjsr_AnonFunction1(((char) => {
    var char$1 = $uC(char);
    return (("unexpected input in delimited text: `" + $cToS(char$1)) + "`");
  }));
  this.Llaika_parse_text_TextDelimiter__f_unexpectedInput = new $c_Llaika_parse_Message$MessageFactory(f);
}
$c_Llaika_parse_text_TextDelimiter.prototype = new $h_O();
$c_Llaika_parse_text_TextDelimiter.prototype.constructor = $c_Llaika_parse_text_TextDelimiter;
/** @constructor */
function $h_Llaika_parse_text_TextDelimiter() {
}
$h_Llaika_parse_text_TextDelimiter.prototype = $c_Llaika_parse_text_TextDelimiter.prototype;
$c_Llaika_parse_text_TextDelimiter.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_parse_text_TextDelimiter.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("TextDelimiter");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Llaika_parse_text_TextDelimiter__f_parser;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Llaika_parse_text_TextDelimiter__f_acceptEOF ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = (this.Llaika_parse_text_TextDelimiter__f_nonEmpty ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = (this.Llaika_parse_text_TextDelimiter__f_keepDelimiter ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$1 = this.Llaika_parse_text_TextDelimiter__f_failOn;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$6, 5);
});
$c_Llaika_parse_text_TextDelimiter.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_parse_text_TextDelimiter)) {
    var x$0$2 = $as_Llaika_parse_text_TextDelimiter(x$0);
    if ((((this.Llaika_parse_text_TextDelimiter__f_acceptEOF === $n(x$0$2).Llaika_parse_text_TextDelimiter__f_acceptEOF) && (this.Llaika_parse_text_TextDelimiter__f_nonEmpty === $n(x$0$2).Llaika_parse_text_TextDelimiter__f_nonEmpty)) && (this.Llaika_parse_text_TextDelimiter__f_keepDelimiter === $n(x$0$2).Llaika_parse_text_TextDelimiter__f_keepDelimiter))) {
      var x = this.Llaika_parse_text_TextDelimiter__f_parser;
      var x$2 = $n(x$0$2).Llaika_parse_text_TextDelimiter__f_parser;
      var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Llaika_parse_text_TextDelimiter__f_failOn;
      var x$4 = $n(x$0$2).Llaika_parse_text_TextDelimiter__f_failOn;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_parse_text_TextDelimiter.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_parse_text_TextDelimiter.prototype.productArity__I = (function() {
  return 5;
});
$c_Llaika_parse_text_TextDelimiter.prototype.productPrefix__T = (function() {
  return "TextDelimiter";
});
$c_Llaika_parse_text_TextDelimiter.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_parse_text_TextDelimiter__f_parser;
      break;
    }
    case 1: {
      return this.Llaika_parse_text_TextDelimiter__f_acceptEOF;
      break;
    }
    case 2: {
      return this.Llaika_parse_text_TextDelimiter__f_nonEmpty;
      break;
    }
    case 3: {
      return this.Llaika_parse_text_TextDelimiter__f_keepDelimiter;
      break;
    }
    case 4: {
      return this.Llaika_parse_text_TextDelimiter__f_failOn;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_parse_text_TextDelimiter.prototype.startChars__sci_Set = (function() {
  return this.Llaika_parse_text_TextDelimiter__f_startChars;
});
$c_Llaika_parse_text_TextDelimiter.prototype.atStartChar__C__I__Llaika_parse_SourceCursor__Llaika_parse_text_DelimiterResult = (function(startChar, charsConsumed, source) {
  if ($n(this.Llaika_parse_text_TextDelimiter__f_failOn).contains__O__Z($bC(startChar))) {
    var msgProvider = $as_Llaika_parse_Message($n(this.Llaika_parse_text_TextDelimiter__f_unexpectedInput).apply__O__O($bC(startChar)));
    var maxOffset = (($n(source).offset__I() + charsConsumed) | 0);
    var result = new $c_Llaika_parse_Failure(msgProvider, source, maxOffset);
    return new $c_Llaika_parse_text_DelimiterResult$Complete(result);
  } else {
    matchResult6: {
      var $x_1;
      var x14 = $p_Llaika_parse_text_TextDelimiter__applyPostCondition$1__Llaika_parse_SourceCursor__I__s_Option(this, source, charsConsumed);
      var x = $m_s_None$();
      if ((x === x14)) {
        var $x_1 = $m_Llaika_parse_text_DelimiterResult$Continue$();
        break matchResult6;
      }
      if ((x14 instanceof $c_s_Some)) {
        if (((charsConsumed === 0) && this.Llaika_parse_text_TextDelimiter__f_nonEmpty)) {
          var msgProvider$1 = this.Llaika_parse_text_TextDelimiter__f_emptyResult;
          var maxOffset$1 = $n(source).offset__I();
          var result$1 = new $c_Llaika_parse_Failure(msgProvider$1, source, maxOffset$1);
          var $x_1 = new $c_Llaika_parse_text_DelimiterResult$Complete(result$1);
          break matchResult6;
        }
        var delimConsumed = $uI($n($as_s_Some(x14)).s_Some__f_value);
        var result$2 = $p_Llaika_parse_text_TextDelimiter__result$1__Llaika_parse_SourceCursor__I__I__Llaika_parse_Success(this, source, charsConsumed, delimConsumed);
        var $x_1 = new $c_Llaika_parse_text_DelimiterResult$Complete(result$2);
        break matchResult6;
      }
      throw new $c_s_MatchError(x14);
    }
    return $as_Llaika_parse_text_DelimiterResult($x_1);
  }
});
$c_Llaika_parse_text_TextDelimiter.prototype.atEOF__I__Llaika_parse_SourceCursor__Llaika_parse_Parsed = (function(charsConsumed, source) {
  if ((!this.Llaika_parse_text_TextDelimiter__f_acceptEOF)) {
    var msgProvider = $m_Llaika_parse_Message$().Llaika_parse_Message$__f_UnexpectedEOF;
    var maxOffset = (($n(source).offset__I() + charsConsumed) | 0);
    return new $c_Llaika_parse_Failure(msgProvider, source, maxOffset);
  } else {
    if (((charsConsumed === 0) && this.Llaika_parse_text_TextDelimiter__f_nonEmpty)) {
      var msgProvider$1 = this.Llaika_parse_text_TextDelimiter__f_emptyResult;
      var maxOffset$1 = $n(source).offset__I();
      var $x_1 = new $c_Llaika_parse_Failure(msgProvider$1, source, maxOffset$1);
    } else {
      var result = $n(source).capture__I__T(charsConsumed);
      var next = $n(source).consume__I__Llaika_parse_SourceCursor(charsConsumed);
      var $x_1 = new $c_Llaika_parse_Success(result, next);
    }
    return $as_Llaika_parse_Parsed($x_1);
  }
});
function $as_Llaika_parse_text_TextDelimiter(obj) {
  return (((obj instanceof $c_Llaika_parse_text_TextDelimiter) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.parse.text.TextDelimiter"));
}
function $isArrayOf_Llaika_parse_text_TextDelimiter(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_parse_text_TextDelimiter)));
}
function $asArrayOf_Llaika_parse_text_TextDelimiter(obj, depth) {
  return (($isArrayOf_Llaika_parse_text_TextDelimiter(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.parse.text.TextDelimiter;", depth));
}
var $d_Llaika_parse_text_TextDelimiter = new $TypeData().initClass($c_Llaika_parse_text_TextDelimiter, "laika.parse.text.TextDelimiter", ({
  Llaika_parse_text_TextDelimiter: 1,
  Llaika_parse_text_Delimiter: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
class $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError extends $c_jl_VirtualMachineError {
  constructor(cause) {
    super();
    var message = ((cause === null) ? null : $n(cause).toString__T());
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, cause, true, true);
  }
}
var $d_Lorg_scalajs_linker_runtime_UndefinedBehaviorError = new $TypeData().initClass($c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError, "org.scalajs.linker.runtime.UndefinedBehaviorError", ({
  Lorg_scalajs_linker_runtime_UndefinedBehaviorError: 1,
  jl_VirtualMachineError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_$less$colon$less$$anon$1() {
}
$c_s_$less$colon$less$$anon$1.prototype = new $h_s_$eq$colon$eq();
$c_s_$less$colon$less$$anon$1.prototype.constructor = $c_s_$less$colon$less$$anon$1;
/** @constructor */
function $h_s_$less$colon$less$$anon$1() {
}
$h_s_$less$colon$less$$anon$1.prototype = $c_s_$less$colon$less$$anon$1.prototype;
$c_s_$less$colon$less$$anon$1.prototype.apply__O__O = (function(x) {
  return x;
});
$c_s_$less$colon$less$$anon$1.prototype.compose__F1__F1 = (function(r) {
  return r;
});
$c_s_$less$colon$less$$anon$1.prototype.andThen__F1__F1 = (function(r) {
  return r;
});
$c_s_$less$colon$less$$anon$1.prototype.toString__T = (function() {
  return "generalized constraint";
});
var $d_s_$less$colon$less$$anon$1 = new $TypeData().initClass($c_s_$less$colon$less$$anon$1, "scala.$less$colon$less$$anon$1", ({
  s_$less$colon$less$$anon$1: 1,
  s_$eq$colon$eq: 1,
  s_$less$colon$less: 1,
  F1: 1,
  Ljava_io_Serializable: 1
}));
function $p_s_MatchError__objString$lzycompute__T($thiz) {
  if ((!$thiz.s_MatchError__f_bitmap$0)) {
    $thiz.s_MatchError__f_objString = (($thiz.s_MatchError__f_obj === null) ? "null" : $p_s_MatchError__liftedTree1$1__T($thiz));
    $thiz.s_MatchError__f_bitmap$0 = true;
  }
  return $thiz.s_MatchError__f_objString;
}
function $p_s_MatchError__objString__T($thiz) {
  return ((!$thiz.s_MatchError__f_bitmap$0) ? $p_s_MatchError__objString$lzycompute__T($thiz) : $thiz.s_MatchError__f_objString);
}
function $p_s_MatchError__ofClass$1__T($thiz) {
  var this$1 = $n($thiz.s_MatchError__f_obj);
  return ("of class " + $n($objectGetClass(this$1)).getName__T());
}
function $p_s_MatchError__liftedTree1$1__T($thiz) {
  try {
    return ((($thiz.s_MatchError__f_obj + " (") + $p_s_MatchError__ofClass$1__T($thiz)) + ")");
  } catch (e) {
    return ("an instance " + $p_s_MatchError__ofClass$1__T($thiz));
  }
}
class $c_s_MatchError extends $c_jl_RuntimeException {
  constructor(obj) {
    super();
    this.s_MatchError__f_objString = null;
    this.s_MatchError__f_obj = null;
    this.s_MatchError__f_bitmap$0 = false;
    this.s_MatchError__f_obj = obj;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  getMessage__T() {
    return $p_s_MatchError__objString__T(this);
  }
}
var $d_s_MatchError = new $TypeData().initClass($c_s_MatchError, "scala.MatchError", ({
  s_MatchError: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_Option() {
}
$c_s_Option.prototype = new $h_O();
$c_s_Option.prototype.constructor = $c_s_Option;
/** @constructor */
function $h_s_Option() {
}
$h_s_Option.prototype = $c_s_Option.prototype;
$c_s_Option.prototype.isEmpty__Z = (function() {
  return (this === $m_s_None$());
});
$c_s_Option.prototype.knownSize__I = (function() {
  return (this.isEmpty__Z() ? 0 : 1);
});
$c_s_Option.prototype.flatten__s_$less$colon$less__s_Option = (function(ev) {
  if (this.isEmpty__Z()) {
    return $m_s_None$();
  } else {
    $n(ev);
    var x = this.get__O();
    return $as_s_Option(x);
  }
});
$c_s_Option.prototype.contains__O__Z = (function(elem) {
  return ((!this.isEmpty__Z()) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.get__O(), elem));
});
$c_s_Option.prototype.iterator__sc_Iterator = (function() {
  if (this.isEmpty__Z()) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  } else {
    var a = this.get__O();
    return new $c_sc_Iterator$$anon$20(a);
  }
});
$c_s_Option.prototype.toList__sci_List = (function() {
  return (this.isEmpty__Z() ? $m_sci_Nil$() : new $c_sci_$colon$colon(this.get__O(), $m_sci_Nil$()));
});
function $as_s_Option(obj) {
  return (((obj instanceof $c_s_Option) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Option"));
}
function $isArrayOf_s_Option(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_Option)));
}
function $asArrayOf_s_Option(obj, depth) {
  return (($isArrayOf_s_Option(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Option;", depth));
}
var $d_s_Option = new $TypeData().initClass(0, "scala.Option", ({
  s_Option: 1,
  sc_IterableOnce: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_PartialFunction$OrElse(f1, f2) {
  this.s_PartialFunction$OrElse__f_f1 = null;
  this.s_PartialFunction$OrElse__f_f2 = null;
  this.s_PartialFunction$OrElse__f_f1 = f1;
  this.s_PartialFunction$OrElse__f_f2 = f2;
}
$c_s_PartialFunction$OrElse.prototype = new $h_sr_AbstractPartialFunction();
$c_s_PartialFunction$OrElse.prototype.constructor = $c_s_PartialFunction$OrElse;
/** @constructor */
function $h_s_PartialFunction$OrElse() {
}
$h_s_PartialFunction$OrElse.prototype = $c_s_PartialFunction$OrElse.prototype;
$c_s_PartialFunction$OrElse.prototype.isDefinedAt__O__Z = (function(x) {
  return ($n(this.s_PartialFunction$OrElse__f_f1).isDefinedAt__O__Z(x) || $n(this.s_PartialFunction$OrElse__f_f2).isDefinedAt__O__Z(x));
});
$c_s_PartialFunction$OrElse.prototype.apply__O__O = (function(x) {
  return $n(this.s_PartialFunction$OrElse__f_f1).applyOrElse__O__F1__O(x, this.s_PartialFunction$OrElse__f_f2);
});
$c_s_PartialFunction$OrElse.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  var z = $n(this.s_PartialFunction$OrElse__f_f1).applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
  return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(z)) ? z : $n(this.s_PartialFunction$OrElse__f_f2).applyOrElse__O__F1__O(x, default$1));
});
$c_s_PartialFunction$OrElse.prototype.orElse__s_PartialFunction__s_PartialFunction$OrElse = (function(that) {
  return new $c_s_PartialFunction$OrElse(this.s_PartialFunction$OrElse__f_f1, $n(this.s_PartialFunction$OrElse__f_f2).orElse__s_PartialFunction__s_PartialFunction(that));
});
$c_s_PartialFunction$OrElse.prototype.andThen__F1__s_PartialFunction$OrElse = (function(k) {
  return new $c_s_PartialFunction$OrElse($n(this.s_PartialFunction$OrElse__f_f1).andThen__F1__s_PartialFunction(k), $n(this.s_PartialFunction$OrElse__f_f2).andThen__F1__s_PartialFunction(k));
});
$c_s_PartialFunction$OrElse.prototype.andThen__F1__F1 = (function(g) {
  return this.andThen__F1__s_PartialFunction$OrElse(g);
});
$c_s_PartialFunction$OrElse.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return this.andThen__F1__s_PartialFunction$OrElse(k);
});
$c_s_PartialFunction$OrElse.prototype.orElse__s_PartialFunction__s_PartialFunction = (function(that) {
  return this.orElse__s_PartialFunction__s_PartialFunction$OrElse(that);
});
var $d_s_PartialFunction$OrElse = new $TypeData().initClass($c_s_PartialFunction$OrElse, "scala.PartialFunction$OrElse", ({
  s_PartialFunction$OrElse: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_Product$$anon$1(outer) {
  this.s_Product$$anon$1__f_c = 0;
  this.s_Product$$anon$1__f_cmax = 0;
  this.s_Product$$anon$1__f_$outer = null;
  $n(outer);
  this.s_Product$$anon$1__f_$outer = outer;
  this.s_Product$$anon$1__f_c = 0;
  this.s_Product$$anon$1__f_cmax = $n(outer).productArity__I();
}
$c_s_Product$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_s_Product$$anon$1.prototype.constructor = $c_s_Product$$anon$1;
/** @constructor */
function $h_s_Product$$anon$1() {
}
$h_s_Product$$anon$1.prototype = $c_s_Product$$anon$1.prototype;
$c_s_Product$$anon$1.prototype.hasNext__Z = (function() {
  return (this.s_Product$$anon$1__f_c < this.s_Product$$anon$1__f_cmax);
});
$c_s_Product$$anon$1.prototype.next__O = (function() {
  var result = $n(this.s_Product$$anon$1__f_$outer).productElement__I__O(this.s_Product$$anon$1__f_c);
  this.s_Product$$anon$1__f_c = ((1 + this.s_Product$$anon$1__f_c) | 0);
  return result;
});
var $d_s_Product$$anon$1 = new $TypeData().initClass($c_s_Product$$anon$1, "scala.Product$$anon$1", ({
  s_Product$$anon$1: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_T2(_1, _2) {
  this.T2__f__1 = null;
  this.T2__f__2 = null;
  this.T2__f__1 = _1;
  this.T2__f__2 = _2;
}
$c_T2.prototype = new $h_O();
$c_T2.prototype.constructor = $c_T2;
/** @constructor */
function $h_T2() {
}
$h_T2.prototype = $c_T2.prototype;
$c_T2.prototype.productArity__I = (function() {
  return 2;
});
$c_T2.prototype.productElement__I__O = (function(n) {
  return $f_s_Product2__productElement__I__O(this, n);
});
$c_T2.prototype._1__O = (function() {
  return this.T2__f__1;
});
$c_T2.prototype._2__O = (function() {
  return this.T2__f__2;
});
$c_T2.prototype.toString__T = (function() {
  return (((("(" + this._1__O()) + ",") + this._2__O()) + ")");
});
$c_T2.prototype.copy$default$1__O = (function() {
  return this._1__O();
});
$c_T2.prototype.copy$default$2__O = (function() {
  return this._2__O();
});
$c_T2.prototype.productPrefix__T = (function() {
  return "Tuple2";
});
$c_T2.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T2.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_T2.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_T2)) {
    var Tuple2$1 = $as_T2(x$1);
    return ($m_sr_BoxesRunTime$().equals__O__O__Z(this._1__O(), $n(Tuple2$1)._1__O()) && $m_sr_BoxesRunTime$().equals__O__O__Z(this._2__O(), $n(Tuple2$1)._2__O()));
  } else {
    return false;
  }
});
$c_T2.prototype._1$mcI$sp__I = (function() {
  return $uI(this._1__O());
});
function $as_T2(obj) {
  return (((obj instanceof $c_T2) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple2"));
}
function $isArrayOf_T2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T2)));
}
function $asArrayOf_T2(obj, depth) {
  return (($isArrayOf_T2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple2;", depth));
}
var $d_T2 = new $TypeData().initClass($c_T2, "scala.Tuple2", ({
  T2: 1,
  s_Product2: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_T3(_1, _2, _3) {
  this.T3__f__1 = null;
  this.T3__f__2 = null;
  this.T3__f__3 = null;
  this.T3__f__1 = _1;
  this.T3__f__2 = _2;
  this.T3__f__3 = _3;
}
$c_T3.prototype = new $h_O();
$c_T3.prototype.constructor = $c_T3;
/** @constructor */
function $h_T3() {
}
$h_T3.prototype = $c_T3.prototype;
$c_T3.prototype.productArity__I = (function() {
  return 3;
});
$c_T3.prototype.productElement__I__O = (function(n) {
  return $f_s_Product3__productElement__I__O(this, n);
});
$c_T3.prototype.toString__T = (function() {
  return (((((("(" + this.T3__f__1) + ",") + this.T3__f__2) + ",") + this.T3__f__3) + ")");
});
$c_T3.prototype.productPrefix__T = (function() {
  return "Tuple3";
});
$c_T3.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T3.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_T3.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_T3)) {
    var Tuple3$1 = $as_T3(x$1);
    return ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T3__f__1, $n(Tuple3$1).T3__f__1) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T3__f__2, $n(Tuple3$1).T3__f__2) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T3__f__3, $n(Tuple3$1).T3__f__3)));
  } else {
    return false;
  }
});
function $as_T3(obj) {
  return (((obj instanceof $c_T3) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple3"));
}
function $isArrayOf_T3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T3)));
}
function $asArrayOf_T3(obj, depth) {
  return (($isArrayOf_T3(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple3;", depth));
}
var $d_T3 = new $TypeData().initClass($c_T3, "scala.Tuple3", ({
  T3: 1,
  s_Product3: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_T4(_1, _2, _3, _4) {
  this.T4__f__1 = null;
  this.T4__f__2 = null;
  this.T4__f__3 = null;
  this.T4__f__4 = null;
  this.T4__f__1 = _1;
  this.T4__f__2 = _2;
  this.T4__f__3 = _3;
  this.T4__f__4 = _4;
}
$c_T4.prototype = new $h_O();
$c_T4.prototype.constructor = $c_T4;
/** @constructor */
function $h_T4() {
}
$h_T4.prototype = $c_T4.prototype;
$c_T4.prototype.productArity__I = (function() {
  return 4;
});
$c_T4.prototype.productElement__I__O = (function(n) {
  return $f_s_Product4__productElement__I__O(this, n);
});
$c_T4.prototype.toString__T = (function() {
  return (((((((("(" + this.T4__f__1) + ",") + this.T4__f__2) + ",") + this.T4__f__3) + ",") + this.T4__f__4) + ")");
});
$c_T4.prototype.productPrefix__T = (function() {
  return "Tuple4";
});
$c_T4.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T4.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_T4.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_T4)) {
    var Tuple4$1 = $as_T4(x$1);
    return (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T4__f__1, $n(Tuple4$1).T4__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T4__f__2, $n(Tuple4$1).T4__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T4__f__3, $n(Tuple4$1).T4__f__3) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T4__f__4, $n(Tuple4$1).T4__f__4)));
  } else {
    return false;
  }
});
function $as_T4(obj) {
  return (((obj instanceof $c_T4) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple4"));
}
function $isArrayOf_T4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T4)));
}
function $asArrayOf_T4(obj, depth) {
  return (($isArrayOf_T4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple4;", depth));
}
var $d_T4 = new $TypeData().initClass($c_T4, "scala.Tuple4", ({
  T4: 1,
  s_Product4: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_T5(_1, _2, _3, _4, _5) {
  this.T5__f__1 = null;
  this.T5__f__2 = null;
  this.T5__f__3 = null;
  this.T5__f__4 = null;
  this.T5__f__5 = null;
  this.T5__f__1 = _1;
  this.T5__f__2 = _2;
  this.T5__f__3 = _3;
  this.T5__f__4 = _4;
  this.T5__f__5 = _5;
}
$c_T5.prototype = new $h_O();
$c_T5.prototype.constructor = $c_T5;
/** @constructor */
function $h_T5() {
}
$h_T5.prototype = $c_T5.prototype;
$c_T5.prototype.productArity__I = (function() {
  return 5;
});
$c_T5.prototype.productElement__I__O = (function(n) {
  return $f_s_Product5__productElement__I__O(this, n);
});
$c_T5.prototype.toString__T = (function() {
  return (((((((((("(" + this.T5__f__1) + ",") + this.T5__f__2) + ",") + this.T5__f__3) + ",") + this.T5__f__4) + ",") + this.T5__f__5) + ")");
});
$c_T5.prototype.productPrefix__T = (function() {
  return "Tuple5";
});
$c_T5.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T5.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_T5.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_T5)) {
    var Tuple5$1 = $as_T5(x$1);
    return (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T5__f__1, $n(Tuple5$1).T5__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T5__f__2, $n(Tuple5$1).T5__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T5__f__3, $n(Tuple5$1).T5__f__3) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T5__f__4, $n(Tuple5$1).T5__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T5__f__5, $n(Tuple5$1).T5__f__5))));
  } else {
    return false;
  }
});
function $as_T5(obj) {
  return (((obj instanceof $c_T5) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple5"));
}
function $isArrayOf_T5(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T5)));
}
function $asArrayOf_T5(obj, depth) {
  return (($isArrayOf_T5(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple5;", depth));
}
var $d_T5 = new $TypeData().initClass($c_T5, "scala.Tuple5", ({
  T5: 1,
  s_Product5: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_T6(_1, _2, _3, _4, _5, _6) {
  this.T6__f__1 = null;
  this.T6__f__2 = null;
  this.T6__f__3 = null;
  this.T6__f__4 = null;
  this.T6__f__5 = null;
  this.T6__f__6 = null;
  this.T6__f__1 = _1;
  this.T6__f__2 = _2;
  this.T6__f__3 = _3;
  this.T6__f__4 = _4;
  this.T6__f__5 = _5;
  this.T6__f__6 = _6;
}
$c_T6.prototype = new $h_O();
$c_T6.prototype.constructor = $c_T6;
/** @constructor */
function $h_T6() {
}
$h_T6.prototype = $c_T6.prototype;
$c_T6.prototype.productArity__I = (function() {
  return 6;
});
$c_T6.prototype.productElement__I__O = (function(n) {
  return $f_s_Product6__productElement__I__O(this, n);
});
$c_T6.prototype.toString__T = (function() {
  return (((((((((((("(" + this.T6__f__1) + ",") + this.T6__f__2) + ",") + this.T6__f__3) + ",") + this.T6__f__4) + ",") + this.T6__f__5) + ",") + this.T6__f__6) + ")");
});
$c_T6.prototype.productPrefix__T = (function() {
  return "Tuple6";
});
$c_T6.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T6.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_T6.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_T6)) {
    var Tuple6$1 = $as_T6(x$1);
    return (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T6__f__1, $n(Tuple6$1).T6__f__1) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T6__f__2, $n(Tuple6$1).T6__f__2) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T6__f__3, $n(Tuple6$1).T6__f__3))) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T6__f__4, $n(Tuple6$1).T6__f__4) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T6__f__5, $n(Tuple6$1).T6__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T6__f__6, $n(Tuple6$1).T6__f__6))));
  } else {
    return false;
  }
});
function $as_T6(obj) {
  return (((obj instanceof $c_T6) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple6"));
}
function $isArrayOf_T6(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T6)));
}
function $asArrayOf_T6(obj, depth) {
  return (($isArrayOf_T6(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple6;", depth));
}
var $d_T6 = new $TypeData().initClass($c_T6, "scala.Tuple6", ({
  T6: 1,
  s_Product6: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_T7(_1, _2, _3, _4, _5, _6, _7) {
  this.T7__f__1 = null;
  this.T7__f__2 = null;
  this.T7__f__3 = null;
  this.T7__f__4 = null;
  this.T7__f__5 = null;
  this.T7__f__6 = null;
  this.T7__f__7 = null;
  this.T7__f__1 = _1;
  this.T7__f__2 = _2;
  this.T7__f__3 = _3;
  this.T7__f__4 = _4;
  this.T7__f__5 = _5;
  this.T7__f__6 = _6;
  this.T7__f__7 = _7;
}
$c_T7.prototype = new $h_O();
$c_T7.prototype.constructor = $c_T7;
/** @constructor */
function $h_T7() {
}
$h_T7.prototype = $c_T7.prototype;
$c_T7.prototype.productArity__I = (function() {
  return 7;
});
$c_T7.prototype.productElement__I__O = (function(n) {
  return $f_s_Product7__productElement__I__O(this, n);
});
$c_T7.prototype.toString__T = (function() {
  return (((((((((((((("(" + this.T7__f__1) + ",") + this.T7__f__2) + ",") + this.T7__f__3) + ",") + this.T7__f__4) + ",") + this.T7__f__5) + ",") + this.T7__f__6) + ",") + this.T7__f__7) + ")");
});
$c_T7.prototype.productPrefix__T = (function() {
  return "Tuple7";
});
$c_T7.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T7.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_T7.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_T7)) {
    var Tuple7$1 = $as_T7(x$1);
    return (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__1, $n(Tuple7$1).T7__f__1) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__2, $n(Tuple7$1).T7__f__2) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__3, $n(Tuple7$1).T7__f__3))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__4, $n(Tuple7$1).T7__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__5, $n(Tuple7$1).T7__f__5)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__6, $n(Tuple7$1).T7__f__6) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__7, $n(Tuple7$1).T7__f__7))));
  } else {
    return false;
  }
});
function $as_T7(obj) {
  return (((obj instanceof $c_T7) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple7"));
}
function $isArrayOf_T7(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T7)));
}
function $asArrayOf_T7(obj, depth) {
  return (($isArrayOf_T7(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple7;", depth));
}
var $d_T7 = new $TypeData().initClass($c_T7, "scala.Tuple7", ({
  T7: 1,
  s_Product7: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_BitSetOps$$anon$1(outer, start$1) {
  this.sc_BitSetOps$$anon$1__f_currentPos = 0;
  this.sc_BitSetOps$$anon$1__f_currentWord = $L0;
  this.sc_BitSetOps$$anon$1__f_$outer = null;
  $n(outer);
  this.sc_BitSetOps$$anon$1__f_$outer = outer;
  this.sc_BitSetOps$$anon$1__f_currentPos = ((start$1 > 0) ? (start$1 >> 6) : 0);
  if ((start$1 > 0)) {
    var this$1 = $n(outer).word__I__J(this.sc_BitSetOps$$anon$1__f_currentPos);
    var n = (63 & start$1);
    var lo = (((32 & n) === 0) ? ((-1) << n) : 0);
    var hi = (((32 & n) === 0) ? (((2147483647 >>> ((31 - n) | 0)) | 0) | ((-1) << n)) : ((-1) << n));
    var lo$1 = (this$1.RTLong__f_lo & lo);
    var hi$1 = (this$1.RTLong__f_hi & hi);
    var x__lo = lo$1;
    var x__hi = hi$1;
    var $x_1 = new $c_RTLong(x__lo, x__hi);
  } else {
    var $x_1 = $n(outer).word__I__J(0);
  }
  this.sc_BitSetOps$$anon$1__f_currentWord = $x_1;
}
$c_sc_BitSetOps$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sc_BitSetOps$$anon$1.prototype.constructor = $c_sc_BitSetOps$$anon$1;
/** @constructor */
function $h_sc_BitSetOps$$anon$1() {
}
$h_sc_BitSetOps$$anon$1.prototype = $c_sc_BitSetOps$$anon$1.prototype;
$c_sc_BitSetOps$$anon$1.prototype.hasNext__Z = (function() {
  while (true) {
    var this$1 = this.sc_BitSetOps$$anon$1__f_currentWord;
    if (((this$1.RTLong__f_lo === 0) && (this$1.RTLong__f_hi === 0))) {
      if ((((1 + this.sc_BitSetOps$$anon$1__f_currentPos) | 0) >= $n(this.sc_BitSetOps$$anon$1__f_$outer).nwords__I())) {
        return false;
      }
      this.sc_BitSetOps$$anon$1__f_currentPos = ((1 + this.sc_BitSetOps$$anon$1__f_currentPos) | 0);
      this.sc_BitSetOps$$anon$1__f_currentWord = $n(this.sc_BitSetOps$$anon$1__f_$outer).word__I__J(this.sc_BitSetOps$$anon$1__f_currentPos);
    } else {
      break;
    }
  }
  return true;
});
$c_sc_BitSetOps$$anon$1.prototype.next__I = (function() {
  if (this.hasNext__Z()) {
    var t = this.sc_BitSetOps$$anon$1__f_currentWord;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    if ((lo !== 0)) {
      if ((lo === 0)) {
        var bitPos = 32;
      } else {
        var i = (lo & ((-lo) | 0));
        var bitPos = ((31 - $uI(Math.clz32(i))) | 0);
      }
    } else {
      if ((hi === 0)) {
        var $x_1 = 32;
      } else {
        var i$1 = (hi & ((-hi) | 0));
        var $x_1 = ((31 - $uI(Math.clz32(i$1))) | 0);
      }
      var bitPos = ((32 + $x_1) | 0);
    }
    var this$5 = this.sc_BitSetOps$$anon$1__f_currentWord;
    var b = this.sc_BitSetOps$$anon$1__f_currentWord;
    var bhi = b.RTLong__f_hi;
    var lo$1 = (((-1) + b.RTLong__f_lo) | 0);
    var hi$1 = ((lo$1 !== (-1)) ? bhi : (((-1) + bhi) | 0));
    var lo$2 = (this$5.RTLong__f_lo & lo$1);
    var hi$2 = (this$5.RTLong__f_hi & hi$1);
    this.sc_BitSetOps$$anon$1__f_currentWord = new $c_RTLong(lo$2, hi$2);
    return (((this.sc_BitSetOps$$anon$1__f_currentPos << 6) + bitPos) | 0);
  } else {
    return $uI($n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O());
  }
});
$c_sc_BitSetOps$$anon$1.prototype.next__O = (function() {
  return this.next__I();
});
var $d_sc_BitSetOps$$anon$1 = new $TypeData().initClass($c_sc_BitSetOps$$anon$1, "scala.collection.BitSetOps$$anon$1", ({
  sc_BitSetOps$$anon$1: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_ClassTagSeqFactory$AnySeqDelegate(delegate) {
  this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate = null;
  $ct_sc_ClassTagIterableFactory$AnyIterableDelegate__sc_ClassTagIterableFactory__(this, delegate);
}
$c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype = new $h_sc_ClassTagIterableFactory$AnyIterableDelegate();
$c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype.constructor = $c_sc_ClassTagSeqFactory$AnySeqDelegate;
/** @constructor */
function $h_sc_ClassTagSeqFactory$AnySeqDelegate() {
}
$h_sc_ClassTagSeqFactory$AnySeqDelegate.prototype = $c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype;
var $d_sc_ClassTagSeqFactory$AnySeqDelegate = new $TypeData().initClass($c_sc_ClassTagSeqFactory$AnySeqDelegate, "scala.collection.ClassTagSeqFactory$AnySeqDelegate", ({
  sc_ClassTagSeqFactory$AnySeqDelegate: 1,
  sc_ClassTagIterableFactory$AnyIterableDelegate: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1,
  sc_SeqFactory: 1
}));
function $f_sc_IndexedSeqOps__prepended__O__O($thiz, elem) {
  return $n($thiz.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O($ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, $thiz));
}
function $f_sc_IndexedSeqOps__take__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), $thiz, n));
}
function $f_sc_IndexedSeqOps__drop__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), $thiz, n));
}
function $f_sc_IndexedSeqOps__dropRight__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), $thiz, n));
}
function $f_sc_IndexedSeqOps__map__F1__O($thiz, f) {
  return $n($thiz.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O($ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), $thiz, f));
}
function $f_sc_IndexedSeqOps__reverse__O($thiz) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), $thiz));
}
function $f_sc_IndexedSeqOps__head__O($thiz) {
  if ((!$thiz.isEmpty__Z())) {
    return $thiz.apply__I__O(0);
  } else {
    if ($is_sc_IndexedSeq($thiz)) {
      var x2 = $as_sc_IndexedSeq($thiz);
      var this$1 = $n(x2);
      var $x_1 = this$1.className__T();
    } else {
      var $x_1 = $thiz.toString__T();
    }
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("head of empty " + $x_1));
  }
}
function $f_sc_IndexedSeqOps__headOption__s_Option($thiz) {
  return ($thiz.isEmpty__Z() ? $m_s_None$() : new $c_s_Some($thiz.head__O()));
}
function $f_sc_IndexedSeqOps__last__O($thiz) {
  if ((!$thiz.isEmpty__Z())) {
    return $thiz.apply__I__O((((-1) + $thiz.length__I()) | 0));
  } else {
    if ($is_sc_IndexedSeq($thiz)) {
      var x2 = $as_sc_IndexedSeq($thiz);
      var this$1 = $n(x2);
      var $x_1 = this$1.className__T();
    } else {
      var $x_1 = $thiz.toString__T();
    }
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("last of empty " + $x_1));
  }
}
function $f_sc_Iterable__toString__T($thiz) {
  var start = ($thiz.className__T() + "(");
  return $f_sc_IterableOnceOps__mkString__T__T__T__T($thiz, start, ", ", ")");
}
function $is_sc_Iterable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Iterable)));
}
function $as_sc_Iterable(obj) {
  return (($is_sc_Iterable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Iterable"));
}
function $isArrayOf_sc_Iterable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Iterable)));
}
function $asArrayOf_sc_Iterable(obj, depth) {
  return (($isArrayOf_sc_Iterable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Iterable;", depth));
}
function $p_sc_Iterator$$anon$10__nextCur__V($thiz) {
  $thiz.sc_Iterator$$anon$10__f_cur = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  $thiz.sc_Iterator$$anon$10__f_cur = $n($as_sc_IterableOnce($n($thiz.sc_Iterator$$anon$10__f_f$3).apply__O__O($n($thiz.sc_Iterator$$anon$10__f_$outer).next__O()))).iterator__sc_Iterator();
  $thiz.sc_Iterator$$anon$10__f__hasNext = (-1);
}
/** @constructor */
function $c_sc_Iterator$$anon$10(outer, f$3) {
  this.sc_Iterator$$anon$10__f_cur = null;
  this.sc_Iterator$$anon$10__f__hasNext = 0;
  this.sc_Iterator$$anon$10__f_$outer = null;
  this.sc_Iterator$$anon$10__f_f$3 = null;
  $n(outer);
  this.sc_Iterator$$anon$10__f_$outer = outer;
  this.sc_Iterator$$anon$10__f_f$3 = f$3;
  this.sc_Iterator$$anon$10__f_cur = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  this.sc_Iterator$$anon$10__f__hasNext = (-1);
}
$c_sc_Iterator$$anon$10.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$10.prototype.constructor = $c_sc_Iterator$$anon$10;
/** @constructor */
function $h_sc_Iterator$$anon$10() {
}
$h_sc_Iterator$$anon$10.prototype = $c_sc_Iterator$$anon$10.prototype;
$c_sc_Iterator$$anon$10.prototype.hasNext__Z = (function() {
  if ((this.sc_Iterator$$anon$10__f__hasNext === (-1))) {
    while ((!$n(this.sc_Iterator$$anon$10__f_cur).hasNext__Z())) {
      if ((!$n(this.sc_Iterator$$anon$10__f_$outer).hasNext__Z())) {
        this.sc_Iterator$$anon$10__f__hasNext = 0;
        this.sc_Iterator$$anon$10__f_cur = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
        return false;
      }
      $p_sc_Iterator$$anon$10__nextCur__V(this);
    }
    this.sc_Iterator$$anon$10__f__hasNext = 1;
    return true;
  } else {
    return (this.sc_Iterator$$anon$10__f__hasNext === 1);
  }
});
$c_sc_Iterator$$anon$10.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$$anon$10__f__hasNext = (-1);
  }
  return $n(this.sc_Iterator$$anon$10__f_cur).next__O();
});
var $d_sc_Iterator$$anon$10 = new $TypeData().initClass($c_sc_Iterator$$anon$10, "scala.collection.Iterator$$anon$10", ({
  sc_Iterator$$anon$10: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$11(outer, p$2) {
  this.sc_Iterator$$anon$11__f_hd = null;
  this.sc_Iterator$$anon$11__f_hdDefined = false;
  this.sc_Iterator$$anon$11__f_tail = null;
  this.sc_Iterator$$anon$11__f_p$2 = null;
  this.sc_Iterator$$anon$11__f_p$2 = p$2;
  this.sc_Iterator$$anon$11__f_hdDefined = false;
  this.sc_Iterator$$anon$11__f_tail = outer;
}
$c_sc_Iterator$$anon$11.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$11.prototype.constructor = $c_sc_Iterator$$anon$11;
/** @constructor */
function $h_sc_Iterator$$anon$11() {
}
$h_sc_Iterator$$anon$11.prototype = $c_sc_Iterator$$anon$11.prototype;
$c_sc_Iterator$$anon$11.prototype.hasNext__Z = (function() {
  if (this.sc_Iterator$$anon$11__f_hdDefined) {
    return true;
  } else if ($n(this.sc_Iterator$$anon$11__f_tail).hasNext__Z()) {
    this.sc_Iterator$$anon$11__f_hd = $n(this.sc_Iterator$$anon$11__f_tail).next__O();
    if ($uZ($n(this.sc_Iterator$$anon$11__f_p$2).apply__O__O(this.sc_Iterator$$anon$11__f_hd))) {
      this.sc_Iterator$$anon$11__f_hdDefined = true;
    } else {
      this.sc_Iterator$$anon$11__f_tail = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
    }
    return this.sc_Iterator$$anon$11__f_hdDefined;
  } else {
    return false;
  }
});
$c_sc_Iterator$$anon$11.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$$anon$11__f_hdDefined = false;
    return this.sc_Iterator$$anon$11__f_hd;
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
});
var $d_sc_Iterator$$anon$11 = new $TypeData().initClass($c_sc_Iterator$$anon$11, "scala.collection.Iterator$$anon$11", ({
  sc_Iterator$$anon$11: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$12(outer, p$3) {
  this.sc_Iterator$$anon$12__f_status = 0;
  this.sc_Iterator$$anon$12__f_fst = null;
  this.sc_Iterator$$anon$12__f_$outer = null;
  this.sc_Iterator$$anon$12__f_p$3 = null;
  $n(outer);
  this.sc_Iterator$$anon$12__f_$outer = outer;
  this.sc_Iterator$$anon$12__f_p$3 = p$3;
  this.sc_Iterator$$anon$12__f_status = (-1);
}
$c_sc_Iterator$$anon$12.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$12.prototype.constructor = $c_sc_Iterator$$anon$12;
/** @constructor */
function $h_sc_Iterator$$anon$12() {
}
$h_sc_Iterator$$anon$12.prototype = $c_sc_Iterator$$anon$12.prototype;
$c_sc_Iterator$$anon$12.prototype.hasNext__Z = (function() {
  if ((this.sc_Iterator$$anon$12__f_status === 1)) {
    return $n(this.sc_Iterator$$anon$12__f_$outer).hasNext__Z();
  } else if ((this.sc_Iterator$$anon$12__f_status === 0)) {
    return true;
  } else {
    while ($n(this.sc_Iterator$$anon$12__f_$outer).hasNext__Z()) {
      var a = $n(this.sc_Iterator$$anon$12__f_$outer).next__O();
      if ((!$uZ($n(this.sc_Iterator$$anon$12__f_p$3).apply__O__O(a)))) {
        this.sc_Iterator$$anon$12__f_fst = a;
        this.sc_Iterator$$anon$12__f_status = 0;
        return true;
      }
    }
    this.sc_Iterator$$anon$12__f_status = 1;
    return false;
  }
});
$c_sc_Iterator$$anon$12.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    if ((this.sc_Iterator$$anon$12__f_status === 1)) {
      return $n(this.sc_Iterator$$anon$12__f_$outer).next__O();
    } else {
      this.sc_Iterator$$anon$12__f_status = 1;
      return this.sc_Iterator$$anon$12__f_fst;
    }
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
});
var $d_sc_Iterator$$anon$12 = new $TypeData().initClass($c_sc_Iterator$$anon$12, "scala.collection.Iterator$$anon$12", ({
  sc_Iterator$$anon$12: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$14(outer, that$1) {
  this.sc_Iterator$$anon$14__f_thatIterator = null;
  this.sc_Iterator$$anon$14__f_$outer = null;
  $n(outer);
  this.sc_Iterator$$anon$14__f_$outer = outer;
  this.sc_Iterator$$anon$14__f_thatIterator = $n(that$1).iterator__sc_Iterator();
}
$c_sc_Iterator$$anon$14.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$14.prototype.constructor = $c_sc_Iterator$$anon$14;
/** @constructor */
function $h_sc_Iterator$$anon$14() {
}
$h_sc_Iterator$$anon$14.prototype = $c_sc_Iterator$$anon$14.prototype;
$c_sc_Iterator$$anon$14.prototype.knownSize__I = (function() {
  var x = $n(this.sc_Iterator$$anon$14__f_$outer).knownSize__I();
  var that = $n(this.sc_Iterator$$anon$14__f_thatIterator).knownSize__I();
  return ((x < that) ? x : that);
});
$c_sc_Iterator$$anon$14.prototype.hasNext__Z = (function() {
  return ($n(this.sc_Iterator$$anon$14__f_$outer).hasNext__Z() && $n(this.sc_Iterator$$anon$14__f_thatIterator).hasNext__Z());
});
$c_sc_Iterator$$anon$14.prototype.next__T2 = (function() {
  return new $c_T2($n(this.sc_Iterator$$anon$14__f_$outer).next__O(), $n(this.sc_Iterator$$anon$14__f_thatIterator).next__O());
});
$c_sc_Iterator$$anon$14.prototype.next__O = (function() {
  return this.next__T2();
});
var $d_sc_Iterator$$anon$14 = new $TypeData().initClass($c_sc_Iterator$$anon$14, "scala.collection.Iterator$$anon$14", ({
  sc_Iterator$$anon$14: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$16(outer) {
  this.sc_Iterator$$anon$16__f_idx = 0;
  this.sc_Iterator$$anon$16__f_$outer = null;
  $n(outer);
  this.sc_Iterator$$anon$16__f_$outer = outer;
  this.sc_Iterator$$anon$16__f_idx = 0;
}
$c_sc_Iterator$$anon$16.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$16.prototype.constructor = $c_sc_Iterator$$anon$16;
/** @constructor */
function $h_sc_Iterator$$anon$16() {
}
$h_sc_Iterator$$anon$16.prototype = $c_sc_Iterator$$anon$16.prototype;
$c_sc_Iterator$$anon$16.prototype.knownSize__I = (function() {
  return $n(this.sc_Iterator$$anon$16__f_$outer).knownSize__I();
});
$c_sc_Iterator$$anon$16.prototype.hasNext__Z = (function() {
  return $n(this.sc_Iterator$$anon$16__f_$outer).hasNext__Z();
});
$c_sc_Iterator$$anon$16.prototype.next__T2 = (function() {
  var ret = new $c_T2($n(this.sc_Iterator$$anon$16__f_$outer).next__O(), this.sc_Iterator$$anon$16__f_idx);
  this.sc_Iterator$$anon$16__f_idx = ((1 + this.sc_Iterator$$anon$16__f_idx) | 0);
  return ret;
});
$c_sc_Iterator$$anon$16.prototype.next__O = (function() {
  return this.next__T2();
});
var $d_sc_Iterator$$anon$16 = new $TypeData().initClass($c_sc_Iterator$$anon$16, "scala.collection.Iterator$$anon$16", ({
  sc_Iterator$$anon$16: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$19() {
}
$c_sc_Iterator$$anon$19.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$19.prototype.constructor = $c_sc_Iterator$$anon$19;
/** @constructor */
function $h_sc_Iterator$$anon$19() {
}
$h_sc_Iterator$$anon$19.prototype = $c_sc_Iterator$$anon$19.prototype;
$c_sc_Iterator$$anon$19.prototype.hasNext__Z = (function() {
  return false;
});
$c_sc_Iterator$$anon$19.prototype.next__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator");
});
$c_sc_Iterator$$anon$19.prototype.knownSize__I = (function() {
  return 0;
});
$c_sc_Iterator$$anon$19.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return this;
});
$c_sc_Iterator$$anon$19.prototype.next__O = (function() {
  this.next__E();
});
var $d_sc_Iterator$$anon$19 = new $TypeData().initClass($c_sc_Iterator$$anon$19, "scala.collection.Iterator$$anon$19", ({
  sc_Iterator$$anon$19: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$2(outer, len$1, elem$2) {
  this.sc_Iterator$$anon$2__f_i = 0;
  this.sc_Iterator$$anon$2__f_$outer = null;
  this.sc_Iterator$$anon$2__f_len$1 = 0;
  this.sc_Iterator$$anon$2__f_elem$2 = null;
  $n(outer);
  this.sc_Iterator$$anon$2__f_$outer = outer;
  this.sc_Iterator$$anon$2__f_len$1 = len$1;
  this.sc_Iterator$$anon$2__f_elem$2 = elem$2;
  this.sc_Iterator$$anon$2__f_i = 0;
}
$c_sc_Iterator$$anon$2.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$2.prototype.constructor = $c_sc_Iterator$$anon$2;
/** @constructor */
function $h_sc_Iterator$$anon$2() {
}
$h_sc_Iterator$$anon$2.prototype = $c_sc_Iterator$$anon$2.prototype;
$c_sc_Iterator$$anon$2.prototype.knownSize__I = (function() {
  var thisSize = $n(this.sc_Iterator$$anon$2__f_$outer).knownSize__I();
  if ((thisSize < 0)) {
    return (-1);
  } else {
    var that = ((this.sc_Iterator$$anon$2__f_len$1 - this.sc_Iterator$$anon$2__f_i) | 0);
    return ((thisSize > that) ? thisSize : that);
  }
});
$c_sc_Iterator$$anon$2.prototype.next__O = (function() {
  var b = ($n(this.sc_Iterator$$anon$2__f_$outer).hasNext__Z() ? $n(this.sc_Iterator$$anon$2__f_$outer).next__O() : ((this.sc_Iterator$$anon$2__f_i < this.sc_Iterator$$anon$2__f_len$1) ? this.sc_Iterator$$anon$2__f_elem$2 : $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()));
  this.sc_Iterator$$anon$2__f_i = ((1 + this.sc_Iterator$$anon$2__f_i) | 0);
  return b;
});
$c_sc_Iterator$$anon$2.prototype.hasNext__Z = (function() {
  return ($n(this.sc_Iterator$$anon$2__f_$outer).hasNext__Z() || (this.sc_Iterator$$anon$2__f_i < this.sc_Iterator$$anon$2__f_len$1));
});
var $d_sc_Iterator$$anon$2 = new $TypeData().initClass($c_sc_Iterator$$anon$2, "scala.collection.Iterator$$anon$2", ({
  sc_Iterator$$anon$2: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$20(a$1) {
  this.sc_Iterator$$anon$20__f_consumed = false;
  this.sc_Iterator$$anon$20__f_a$1 = null;
  this.sc_Iterator$$anon$20__f_a$1 = a$1;
  this.sc_Iterator$$anon$20__f_consumed = false;
}
$c_sc_Iterator$$anon$20.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$20.prototype.constructor = $c_sc_Iterator$$anon$20;
/** @constructor */
function $h_sc_Iterator$$anon$20() {
}
$h_sc_Iterator$$anon$20.prototype = $c_sc_Iterator$$anon$20.prototype;
$c_sc_Iterator$$anon$20.prototype.hasNext__Z = (function() {
  return (!this.sc_Iterator$$anon$20__f_consumed);
});
$c_sc_Iterator$$anon$20.prototype.next__O = (function() {
  if (this.sc_Iterator$$anon$20__f_consumed) {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  } else {
    this.sc_Iterator$$anon$20__f_consumed = true;
    return this.sc_Iterator$$anon$20__f_a$1;
  }
});
$c_sc_Iterator$$anon$20.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return (((this.sc_Iterator$$anon$20__f_consumed || (from > 0)) || (until === 0)) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : this);
});
var $d_sc_Iterator$$anon$20 = new $TypeData().initClass($c_sc_Iterator$$anon$20, "scala.collection.Iterator$$anon$20", ({
  sc_Iterator$$anon$20: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$24(start$1, step$1) {
  this.sc_Iterator$$anon$24__f_i = 0;
  this.sc_Iterator$$anon$24__f_step$1 = 0;
  this.sc_Iterator$$anon$24__f_step$1 = step$1;
  this.sc_Iterator$$anon$24__f_i = start$1;
}
$c_sc_Iterator$$anon$24.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$24.prototype.constructor = $c_sc_Iterator$$anon$24;
/** @constructor */
function $h_sc_Iterator$$anon$24() {
}
$h_sc_Iterator$$anon$24.prototype = $c_sc_Iterator$$anon$24.prototype;
$c_sc_Iterator$$anon$24.prototype.hasNext__Z = (function() {
  return true;
});
$c_sc_Iterator$$anon$24.prototype.next__I = (function() {
  var result = this.sc_Iterator$$anon$24__f_i;
  this.sc_Iterator$$anon$24__f_i = ((this.sc_Iterator$$anon$24__f_i + this.sc_Iterator$$anon$24__f_step$1) | 0);
  return result;
});
$c_sc_Iterator$$anon$24.prototype.next__O = (function() {
  return this.next__I();
});
var $d_sc_Iterator$$anon$24 = new $TypeData().initClass($c_sc_Iterator$$anon$24, "scala.collection.Iterator$$anon$24", ({
  sc_Iterator$$anon$24: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$26(start$3, f$6) {
  this.sc_Iterator$$anon$26__f_first = false;
  this.sc_Iterator$$anon$26__f_acc = null;
  this.sc_Iterator$$anon$26__f_f$6 = null;
  this.sc_Iterator$$anon$26__f_f$6 = f$6;
  this.sc_Iterator$$anon$26__f_first = true;
  this.sc_Iterator$$anon$26__f_acc = start$3;
}
$c_sc_Iterator$$anon$26.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$26.prototype.constructor = $c_sc_Iterator$$anon$26;
/** @constructor */
function $h_sc_Iterator$$anon$26() {
}
$h_sc_Iterator$$anon$26.prototype = $c_sc_Iterator$$anon$26.prototype;
$c_sc_Iterator$$anon$26.prototype.hasNext__Z = (function() {
  return true;
});
$c_sc_Iterator$$anon$26.prototype.next__O = (function() {
  if (this.sc_Iterator$$anon$26__f_first) {
    this.sc_Iterator$$anon$26__f_first = false;
  } else {
    this.sc_Iterator$$anon$26__f_acc = $n(this.sc_Iterator$$anon$26__f_f$6).apply__O__O(this.sc_Iterator$$anon$26__f_acc);
  }
  return this.sc_Iterator$$anon$26__f_acc;
});
var $d_sc_Iterator$$anon$26 = new $TypeData().initClass($c_sc_Iterator$$anon$26, "scala.collection.Iterator$$anon$26", ({
  sc_Iterator$$anon$26: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$6(outer, p$1, isFlipped$1) {
  this.sc_Iterator$$anon$6__f_hd = null;
  this.sc_Iterator$$anon$6__f_hdDefined = false;
  this.sc_Iterator$$anon$6__f_$outer = null;
  this.sc_Iterator$$anon$6__f_p$1 = null;
  this.sc_Iterator$$anon$6__f_isFlipped$1 = false;
  $n(outer);
  this.sc_Iterator$$anon$6__f_$outer = outer;
  this.sc_Iterator$$anon$6__f_p$1 = p$1;
  this.sc_Iterator$$anon$6__f_isFlipped$1 = isFlipped$1;
  this.sc_Iterator$$anon$6__f_hdDefined = false;
}
$c_sc_Iterator$$anon$6.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$6.prototype.constructor = $c_sc_Iterator$$anon$6;
/** @constructor */
function $h_sc_Iterator$$anon$6() {
}
$h_sc_Iterator$$anon$6.prototype = $c_sc_Iterator$$anon$6.prototype;
$c_sc_Iterator$$anon$6.prototype.hasNext__Z = (function() {
  if (this.sc_Iterator$$anon$6__f_hdDefined) {
    return true;
  } else {
    if ((!$n(this.sc_Iterator$$anon$6__f_$outer).hasNext__Z())) {
      return false;
    }
    this.sc_Iterator$$anon$6__f_hd = $n(this.sc_Iterator$$anon$6__f_$outer).next__O();
    while (($uZ($n(this.sc_Iterator$$anon$6__f_p$1).apply__O__O(this.sc_Iterator$$anon$6__f_hd)) === this.sc_Iterator$$anon$6__f_isFlipped$1)) {
      if ((!$n(this.sc_Iterator$$anon$6__f_$outer).hasNext__Z())) {
        return false;
      }
      this.sc_Iterator$$anon$6__f_hd = $n(this.sc_Iterator$$anon$6__f_$outer).next__O();
    }
    this.sc_Iterator$$anon$6__f_hdDefined = true;
    return true;
  }
});
$c_sc_Iterator$$anon$6.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$$anon$6__f_hdDefined = false;
    return this.sc_Iterator$$anon$6__f_hd;
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
});
var $d_sc_Iterator$$anon$6 = new $TypeData().initClass($c_sc_Iterator$$anon$6, "scala.collection.Iterator$$anon$6", ({
  sc_Iterator$$anon$6: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$8(outer, f$1) {
  this.sc_Iterator$$anon$8__f_traversedValues = null;
  this.sc_Iterator$$anon$8__f_nextElementDefined = false;
  this.sc_Iterator$$anon$8__f_nextElement = null;
  this.sc_Iterator$$anon$8__f_$outer = null;
  this.sc_Iterator$$anon$8__f_f$1 = null;
  $n(outer);
  this.sc_Iterator$$anon$8__f_$outer = outer;
  this.sc_Iterator$$anon$8__f_f$1 = f$1;
  this.sc_Iterator$$anon$8__f_traversedValues = $ct_scm_HashSet__(new $c_scm_HashSet());
  this.sc_Iterator$$anon$8__f_nextElementDefined = false;
}
$c_sc_Iterator$$anon$8.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$8.prototype.constructor = $c_sc_Iterator$$anon$8;
/** @constructor */
function $h_sc_Iterator$$anon$8() {
}
$h_sc_Iterator$$anon$8.prototype = $c_sc_Iterator$$anon$8.prototype;
$c_sc_Iterator$$anon$8.prototype.hasNext__Z = (function() {
  while (true) {
    if (this.sc_Iterator$$anon$8__f_nextElementDefined) {
      return true;
    } else if ($n(this.sc_Iterator$$anon$8__f_$outer).hasNext__Z()) {
      var a = $n(this.sc_Iterator$$anon$8__f_$outer).next__O();
      if ($n(this.sc_Iterator$$anon$8__f_traversedValues).add__O__Z($n(this.sc_Iterator$$anon$8__f_f$1).apply__O__O(a))) {
        this.sc_Iterator$$anon$8__f_nextElement = a;
        this.sc_Iterator$$anon$8__f_nextElementDefined = true;
        return true;
      }
    } else {
      return false;
    }
  }
});
$c_sc_Iterator$$anon$8.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$$anon$8__f_nextElementDefined = false;
    return this.sc_Iterator$$anon$8__f_nextElement;
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
});
var $d_sc_Iterator$$anon$8 = new $TypeData().initClass($c_sc_Iterator$$anon$8, "scala.collection.Iterator$$anon$8", ({
  sc_Iterator$$anon$8: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$9(outer, f$2) {
  this.sc_Iterator$$anon$9__f_$outer = null;
  this.sc_Iterator$$anon$9__f_f$2 = null;
  $n(outer);
  this.sc_Iterator$$anon$9__f_$outer = outer;
  this.sc_Iterator$$anon$9__f_f$2 = f$2;
}
$c_sc_Iterator$$anon$9.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$9.prototype.constructor = $c_sc_Iterator$$anon$9;
/** @constructor */
function $h_sc_Iterator$$anon$9() {
}
$h_sc_Iterator$$anon$9.prototype = $c_sc_Iterator$$anon$9.prototype;
$c_sc_Iterator$$anon$9.prototype.knownSize__I = (function() {
  return $n(this.sc_Iterator$$anon$9__f_$outer).knownSize__I();
});
$c_sc_Iterator$$anon$9.prototype.hasNext__Z = (function() {
  return $n(this.sc_Iterator$$anon$9__f_$outer).hasNext__Z();
});
$c_sc_Iterator$$anon$9.prototype.next__O = (function() {
  return $n(this.sc_Iterator$$anon$9__f_f$2).apply__O__O($n(this.sc_Iterator$$anon$9__f_$outer).next__O());
});
var $d_sc_Iterator$$anon$9 = new $TypeData().initClass($c_sc_Iterator$$anon$9, "scala.collection.Iterator$$anon$9", ({
  sc_Iterator$$anon$9: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
function $p_sc_Iterator$ConcatIterator__merge$1__V($thiz) {
  while (($thiz.sc_Iterator$ConcatIterator__f_current instanceof $c_sc_Iterator$ConcatIterator)) {
    var c = $as_sc_Iterator$ConcatIterator($thiz.sc_Iterator$ConcatIterator__f_current);
    $thiz.sc_Iterator$ConcatIterator__f_current = $n(c).sc_Iterator$ConcatIterator__f_current;
    $thiz.sc_Iterator$ConcatIterator__f_currentHasNextChecked = $n(c).sc_Iterator$ConcatIterator__f_currentHasNextChecked;
    if (($n(c).sc_Iterator$ConcatIterator__f_tail !== null)) {
      if (($thiz.sc_Iterator$ConcatIterator__f_last === null)) {
        $thiz.sc_Iterator$ConcatIterator__f_last = $n(c).sc_Iterator$ConcatIterator__f_last;
      }
      $n($n(c).sc_Iterator$ConcatIterator__f_last).sc_Iterator$ConcatIteratorCell__f_tail = $thiz.sc_Iterator$ConcatIterator__f_tail;
      $thiz.sc_Iterator$ConcatIterator__f_tail = $n(c).sc_Iterator$ConcatIterator__f_tail;
    }
  }
}
function $p_sc_Iterator$ConcatIterator__advance$1__Z($thiz) {
  while (true) {
    if (($thiz.sc_Iterator$ConcatIterator__f_tail === null)) {
      $thiz.sc_Iterator$ConcatIterator__f_current = null;
      $thiz.sc_Iterator$ConcatIterator__f_last = null;
      return false;
    } else {
      $thiz.sc_Iterator$ConcatIterator__f_current = $n($thiz.sc_Iterator$ConcatIterator__f_tail).headIterator__sc_Iterator();
      if (($thiz.sc_Iterator$ConcatIterator__f_last === $thiz.sc_Iterator$ConcatIterator__f_tail)) {
        $thiz.sc_Iterator$ConcatIterator__f_last = $n($thiz.sc_Iterator$ConcatIterator__f_last).sc_Iterator$ConcatIteratorCell__f_tail;
      }
      $thiz.sc_Iterator$ConcatIterator__f_tail = $n($thiz.sc_Iterator$ConcatIterator__f_tail).sc_Iterator$ConcatIteratorCell__f_tail;
      $p_sc_Iterator$ConcatIterator__merge$1__V($thiz);
      if ($thiz.sc_Iterator$ConcatIterator__f_currentHasNextChecked) {
        return true;
      } else if ((($thiz.sc_Iterator$ConcatIterator__f_current !== null) && $n($thiz.sc_Iterator$ConcatIterator__f_current).hasNext__Z())) {
        $thiz.sc_Iterator$ConcatIterator__f_currentHasNextChecked = true;
        return true;
      }
    }
  }
}
/** @constructor */
function $c_sc_Iterator$ConcatIterator(current) {
  this.sc_Iterator$ConcatIterator__f_current = null;
  this.sc_Iterator$ConcatIterator__f_tail = null;
  this.sc_Iterator$ConcatIterator__f_last = null;
  this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = false;
  this.sc_Iterator$ConcatIterator__f_current = current;
  this.sc_Iterator$ConcatIterator__f_tail = null;
  this.sc_Iterator$ConcatIterator__f_last = null;
  this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = false;
}
$c_sc_Iterator$ConcatIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$ConcatIterator.prototype.constructor = $c_sc_Iterator$ConcatIterator;
/** @constructor */
function $h_sc_Iterator$ConcatIterator() {
}
$h_sc_Iterator$ConcatIterator.prototype = $c_sc_Iterator$ConcatIterator.prototype;
$c_sc_Iterator$ConcatIterator.prototype.hasNext__Z = (function() {
  if (this.sc_Iterator$ConcatIterator__f_currentHasNextChecked) {
    return true;
  } else if ((this.sc_Iterator$ConcatIterator__f_current !== null)) {
    if ($n(this.sc_Iterator$ConcatIterator__f_current).hasNext__Z()) {
      this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = true;
      return true;
    } else {
      return $p_sc_Iterator$ConcatIterator__advance$1__Z(this);
    }
  } else {
    return false;
  }
});
$c_sc_Iterator$ConcatIterator.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = false;
    return $n(this.sc_Iterator$ConcatIterator__f_current).next__O();
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
});
$c_sc_Iterator$ConcatIterator.prototype.concat__F0__sc_Iterator = (function(that) {
  var c = new $c_sc_Iterator$ConcatIteratorCell(that, null);
  if ((this.sc_Iterator$ConcatIterator__f_tail === null)) {
    this.sc_Iterator$ConcatIterator__f_tail = c;
    this.sc_Iterator$ConcatIterator__f_last = c;
  } else {
    $n(this.sc_Iterator$ConcatIterator__f_last).sc_Iterator$ConcatIteratorCell__f_tail = c;
    this.sc_Iterator$ConcatIterator__f_last = c;
  }
  if ((this.sc_Iterator$ConcatIterator__f_current === null)) {
    this.sc_Iterator$ConcatIterator__f_current = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  }
  return this;
});
function $as_sc_Iterator$ConcatIterator(obj) {
  return (((obj instanceof $c_sc_Iterator$ConcatIterator) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Iterator$ConcatIterator"));
}
function $isArrayOf_sc_Iterator$ConcatIterator(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Iterator$ConcatIterator)));
}
function $asArrayOf_sc_Iterator$ConcatIterator(obj, depth) {
  return (($isArrayOf_sc_Iterator$ConcatIterator(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Iterator$ConcatIterator;", depth));
}
var $d_sc_Iterator$ConcatIterator = new $TypeData().initClass($c_sc_Iterator$ConcatIterator, "scala.collection.Iterator$ConcatIterator", ({
  sc_Iterator$ConcatIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
function $p_sc_Iterator$GroupedIterator__pad__Z($thiz) {
  return ($thiz.sc_Iterator$GroupedIterator__f_padding !== null);
}
function $p_sc_Iterator$GroupedIterator__newBuilder__scm_ArrayBuilder($thiz) {
  var b = new $c_scm_ArrayBuilder$generic($d_O.getClassOf());
  var k = $n($thiz.sc_Iterator$GroupedIterator__f_self).knownSize__I();
  if ((k > 0)) {
    var that = $thiz.sc_Iterator$GroupedIterator__f_size;
    b.sizeHint__I__V(((k < that) ? k : that));
  }
  return b;
}
function $p_sc_Iterator$GroupedIterator__fulfill__Z($thiz) {
  var builder = $p_sc_Iterator$GroupedIterator__newBuilder__scm_ArrayBuilder($thiz);
  var done = false;
  if (($thiz.sc_Iterator$GroupedIterator__f_prev !== null)) {
    $n(builder).addAll__O__scm_ArrayBuilder($thiz.sc_Iterator$GroupedIterator__f_prev);
  }
  if (((!$thiz.sc_Iterator$GroupedIterator__f_first) && ($thiz.sc_Iterator$GroupedIterator__f_step > $thiz.sc_Iterator$GroupedIterator__f_size))) {
    var dropping = (($thiz.sc_Iterator$GroupedIterator__f_step - $thiz.sc_Iterator$GroupedIterator__f_size) | 0);
    while (((dropping > 0) && $n($thiz.sc_Iterator$GroupedIterator__f_self).hasNext__Z())) {
      $n($thiz.sc_Iterator$GroupedIterator__f_self).next__O();
      dropping = (((-1) + dropping) | 0);
    }
    done = (dropping > 0);
  }
  var index = $n(builder).length__I();
  if ((!done)) {
    while (((index < $thiz.sc_Iterator$GroupedIterator__f_size) && $n($thiz.sc_Iterator$GroupedIterator__f_self).hasNext__Z())) {
      var this$1 = $n(builder);
      var elem = $n($thiz.sc_Iterator$GroupedIterator__f_self).next__O();
      this$1.addOne__O__scm_ArrayBuilder$generic(elem);
      index = ((1 + index) | 0);
    }
    if (((index < $thiz.sc_Iterator$GroupedIterator__f_size) && $p_sc_Iterator$GroupedIterator__pad__Z($thiz))) {
      $n(builder).sizeHint__I__V($thiz.sc_Iterator$GroupedIterator__f_size);
      while ((index < $thiz.sc_Iterator$GroupedIterator__f_size)) {
        var this$2 = $n(builder);
        var elem$1 = $n($thiz.sc_Iterator$GroupedIterator__f_padding).apply__O();
        this$2.addOne__O__scm_ArrayBuilder$generic(elem$1);
        index = ((1 + index) | 0);
      }
    }
  }
  var ok = ((index > 0) && ($thiz.sc_Iterator$GroupedIterator__f_partial || (index === $thiz.sc_Iterator$GroupedIterator__f_size)));
  if (ok) {
    $thiz.sc_Iterator$GroupedIterator__f_buffer = $n(builder).result__O();
  } else {
    $thiz.sc_Iterator$GroupedIterator__f_prev = null;
  }
  return ok;
}
function $p_sc_Iterator$GroupedIterator__fill__Z($thiz) {
  if ($thiz.sc_Iterator$GroupedIterator__f_filled) {
    return true;
  } else {
    $thiz.sc_Iterator$GroupedIterator__f_filled = ($n($thiz.sc_Iterator$GroupedIterator__f_self).hasNext__Z() && $p_sc_Iterator$GroupedIterator__fulfill__Z($thiz));
    return $thiz.sc_Iterator$GroupedIterator__f_filled;
  }
}
/** @constructor */
function $c_sc_Iterator$GroupedIterator(outer, self, size, step) {
  this.sc_Iterator$GroupedIterator__f_self = null;
  this.sc_Iterator$GroupedIterator__f_size = 0;
  this.sc_Iterator$GroupedIterator__f_step = 0;
  this.sc_Iterator$GroupedIterator__f_buffer = null;
  this.sc_Iterator$GroupedIterator__f_prev = null;
  this.sc_Iterator$GroupedIterator__f_first = false;
  this.sc_Iterator$GroupedIterator__f_filled = false;
  this.sc_Iterator$GroupedIterator__f_partial = false;
  this.sc_Iterator$GroupedIterator__f_padding = null;
  this.sc_Iterator$GroupedIterator__f_self = self;
  this.sc_Iterator$GroupedIterator__f_size = size;
  this.sc_Iterator$GroupedIterator__f_step = step;
  $n(outer);
  var requirement = ((size >= 1) && (step >= 1));
  if ((!requirement)) {
    var $x_1 = $m_sc_StringOps$();
    var array = [this.sc_Iterator$GroupedIterator__f_size, this.sc_Iterator$GroupedIterator__f_step];
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("requirement failed: " + $n($x_1).format$extension__T__sci_Seq__T("size=%d and step=%d, but both must be positive", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))));
  }
  this.sc_Iterator$GroupedIterator__f_buffer = null;
  this.sc_Iterator$GroupedIterator__f_prev = null;
  this.sc_Iterator$GroupedIterator__f_first = true;
  this.sc_Iterator$GroupedIterator__f_filled = false;
  this.sc_Iterator$GroupedIterator__f_partial = true;
  this.sc_Iterator$GroupedIterator__f_padding = null;
}
$c_sc_Iterator$GroupedIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$GroupedIterator.prototype.constructor = $c_sc_Iterator$GroupedIterator;
/** @constructor */
function $h_sc_Iterator$GroupedIterator() {
}
$h_sc_Iterator$GroupedIterator.prototype = $c_sc_Iterator$GroupedIterator.prototype;
$c_sc_Iterator$GroupedIterator.prototype.hasNext__Z = (function() {
  return $p_sc_Iterator$GroupedIterator__fill__Z(this);
});
$c_sc_Iterator$GroupedIterator.prototype.next__sci_Seq = (function() {
  if ((!$p_sc_Iterator$GroupedIterator__fill__Z(this))) {
    return $as_sci_Seq($n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O());
  } else {
    this.sc_Iterator$GroupedIterator__f_filled = false;
    if ((this.sc_Iterator$GroupedIterator__f_step < this.sc_Iterator$GroupedIterator__f_size)) {
      if (this.sc_Iterator$GroupedIterator__f_first) {
        var $x_1 = $m_sc_ArrayOps$();
        var xs = this.sc_Iterator$GroupedIterator__f_buffer;
        this.sc_Iterator$GroupedIterator__f_prev = $n($x_1).drop$extension__O__I__O(xs, this.sc_Iterator$GroupedIterator__f_step);
      } else {
        var xs$1 = this.sc_Iterator$GroupedIterator__f_buffer;
        if (($m_jl_reflect_Array$().getLength__O__I(xs$1) === this.sc_Iterator$GroupedIterator__f_size)) {
          $m_s_Array$().copy__O__I__O__I__I__V(this.sc_Iterator$GroupedIterator__f_buffer, this.sc_Iterator$GroupedIterator__f_step, this.sc_Iterator$GroupedIterator__f_prev, 0, ((this.sc_Iterator$GroupedIterator__f_size - this.sc_Iterator$GroupedIterator__f_step) | 0));
        } else {
          this.sc_Iterator$GroupedIterator__f_prev = null;
        }
      }
    }
    var res = $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(this.sc_Iterator$GroupedIterator__f_buffer);
    this.sc_Iterator$GroupedIterator__f_buffer = null;
    this.sc_Iterator$GroupedIterator__f_first = false;
    return res;
  }
});
$c_sc_Iterator$GroupedIterator.prototype.next__O = (function() {
  return this.next__sci_Seq();
});
var $d_sc_Iterator$GroupedIterator = new $TypeData().initClass($c_sc_Iterator$GroupedIterator, "scala.collection.Iterator$GroupedIterator", ({
  sc_Iterator$GroupedIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
function $p_sc_Iterator$Partner$1__compareGap__scm_Queue__Z($thiz, queue) {
  return ($thiz.sc_Iterator$Partner$1__f_gap$1 === queue);
}
/** @constructor */
function $c_sc_Iterator$Partner$1(outer, ahead$1, gap$1) {
  this.sc_Iterator$Partner$1__f_$outer = null;
  this.sc_Iterator$Partner$1__f_ahead$1 = null;
  this.sc_Iterator$Partner$1__f_gap$1 = null;
  $n(outer);
  this.sc_Iterator$Partner$1__f_$outer = outer;
  this.sc_Iterator$Partner$1__f_ahead$1 = ahead$1;
  this.sc_Iterator$Partner$1__f_gap$1 = gap$1;
}
$c_sc_Iterator$Partner$1.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$Partner$1.prototype.constructor = $c_sc_Iterator$Partner$1;
/** @constructor */
function $h_sc_Iterator$Partner$1() {
}
$h_sc_Iterator$Partner$1.prototype = $c_sc_Iterator$Partner$1.prototype;
$c_sc_Iterator$Partner$1.prototype.knownSize__I = (function() {
  $n(this.sc_Iterator$Partner$1__f_$outer);
  var thisSize = $n(this.sc_Iterator$Partner$1__f_$outer).knownSize__I();
  if ((this === $as_sc_Iterator($n(this.sc_Iterator$Partner$1__f_ahead$1).sr_ObjectRef__f_elem))) {
    return thisSize;
  } else {
    if ((thisSize < 0)) {
      var $x_1 = true;
    } else {
      var this$1 = $n(this.sc_Iterator$Partner$1__f_gap$1);
      var idx = this$1.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
      var $x_1 = ((((this$1.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $n(this$1.scm_ArrayDeque__f_array).u.length) | 0)) < 0);
    }
    if ($x_1) {
      return (-1);
    } else {
      var this$2 = $n(this.sc_Iterator$Partner$1__f_gap$1);
      var idx$1 = this$2.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
      return ((thisSize + (((this$2.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (((-1) + $n(this$2.scm_ArrayDeque__f_array).u.length) | 0))) | 0);
    }
  }
});
$c_sc_Iterator$Partner$1.prototype.hasNext__Z = (function() {
  $n(this.sc_Iterator$Partner$1__f_$outer);
  return (((this !== $as_sc_Iterator($n(this.sc_Iterator$Partner$1__f_ahead$1).sr_ObjectRef__f_elem)) && (!$n(this.sc_Iterator$Partner$1__f_gap$1).isEmpty__Z())) || $n(this.sc_Iterator$Partner$1__f_$outer).hasNext__Z());
});
$c_sc_Iterator$Partner$1.prototype.next__O = (function() {
  $n(this.sc_Iterator$Partner$1__f_$outer);
  if ($n(this.sc_Iterator$Partner$1__f_gap$1).isEmpty__Z()) {
    $n(this.sc_Iterator$Partner$1__f_ahead$1).sr_ObjectRef__f_elem = this;
  }
  if ((this === $as_sc_Iterator($n(this.sc_Iterator$Partner$1__f_ahead$1).sr_ObjectRef__f_elem))) {
    var e = $n(this.sc_Iterator$Partner$1__f_$outer).next__O();
    var this$1 = $n(this.sc_Iterator$Partner$1__f_gap$1);
    $as_scm_Queue(this$1.addOne__O__scm_ArrayDeque(e));
    return e;
  } else {
    var this$2 = $n(this.sc_Iterator$Partner$1__f_gap$1);
    return this$2.removeHead__Z__O(false);
  }
});
$c_sc_Iterator$Partner$1.prototype.hashCode__I = (function() {
  var this$1 = $n(this.sc_Iterator$Partner$1__f_gap$1);
  return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this$1);
});
$c_sc_Iterator$Partner$1.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_sc_Iterator$Partner$1)) {
    var x2 = $as_sc_Iterator$Partner$1(other);
    return ($p_sc_Iterator$Partner$1__compareGap__scm_Queue__Z($n(x2), this.sc_Iterator$Partner$1__f_gap$1) && $n(this.sc_Iterator$Partner$1__f_gap$1).isEmpty__Z());
  } else {
    return (this === other);
  }
});
function $as_sc_Iterator$Partner$1(obj) {
  return (((obj instanceof $c_sc_Iterator$Partner$1) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Iterator$Partner$1"));
}
function $isArrayOf_sc_Iterator$Partner$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Iterator$Partner$1)));
}
function $asArrayOf_sc_Iterator$Partner$1(obj, depth) {
  return (($isArrayOf_sc_Iterator$Partner$1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Iterator$Partner$1;", depth));
}
var $d_sc_Iterator$Partner$1 = new $TypeData().initClass($c_sc_Iterator$Partner$1, "scala.collection.Iterator$Partner$1", ({
  sc_Iterator$Partner$1: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
function $p_sc_Iterator$SliceIterator__skip__V($thiz) {
  while (($thiz.sc_Iterator$SliceIterator__f_dropping > 0)) {
    if ($n($thiz.sc_Iterator$SliceIterator__f_underlying).hasNext__Z()) {
      $n($thiz.sc_Iterator$SliceIterator__f_underlying).next__O();
      $thiz.sc_Iterator$SliceIterator__f_dropping = (((-1) + $thiz.sc_Iterator$SliceIterator__f_dropping) | 0);
    } else {
      $thiz.sc_Iterator$SliceIterator__f_dropping = 0;
    }
  }
}
function $p_sc_Iterator$SliceIterator__adjustedBound$1__I__I($thiz, lo$1) {
  if (($thiz.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining < 0)) {
    return (-1);
  } else {
    var that = (($thiz.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining - lo$1) | 0);
    return ((that < 0) ? 0 : that);
  }
}
/** @constructor */
function $c_sc_Iterator$SliceIterator(underlying, start, limit) {
  this.sc_Iterator$SliceIterator__f_underlying = null;
  this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining = 0;
  this.sc_Iterator$SliceIterator__f_dropping = 0;
  this.sc_Iterator$SliceIterator__f_underlying = underlying;
  this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining = limit;
  this.sc_Iterator$SliceIterator__f_dropping = start;
}
$c_sc_Iterator$SliceIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$SliceIterator.prototype.constructor = $c_sc_Iterator$SliceIterator;
/** @constructor */
function $h_sc_Iterator$SliceIterator() {
}
$h_sc_Iterator$SliceIterator.prototype = $c_sc_Iterator$SliceIterator.prototype;
$c_sc_Iterator$SliceIterator.prototype.knownSize__I = (function() {
  var size = $n(this.sc_Iterator$SliceIterator__f_underlying).knownSize__I();
  if ((size < 0)) {
    return (-1);
  } else {
    var that = ((size - this.sc_Iterator$SliceIterator__f_dropping) | 0);
    var dropSize = ((that < 0) ? 0 : that);
    if ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining < 0)) {
      return dropSize;
    } else {
      var x = this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining;
      return ((x < dropSize) ? x : dropSize);
    }
  }
});
$c_sc_Iterator$SliceIterator.prototype.hasNext__Z = (function() {
  $p_sc_Iterator$SliceIterator__skip__V(this);
  return ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining !== 0) && $n(this.sc_Iterator$SliceIterator__f_underlying).hasNext__Z());
});
$c_sc_Iterator$SliceIterator.prototype.next__O = (function() {
  $p_sc_Iterator$SliceIterator__skip__V(this);
  if ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining > 0)) {
    this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining = (((-1) + this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining) | 0);
    return $n(this.sc_Iterator$SliceIterator__f_underlying).next__O();
  } else {
    return ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining < 0) ? $n(this.sc_Iterator$SliceIterator__f_underlying).next__O() : $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O());
  }
});
$c_sc_Iterator$SliceIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  var lo = ((from > 0) ? from : 0);
  if ((until < 0)) {
    var rest = $p_sc_Iterator$SliceIterator__adjustedBound$1__I__I(this, lo);
  } else if ((until <= lo)) {
    var rest = 0;
  } else if ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining < 0)) {
    var rest = ((until - lo) | 0);
  } else {
    var x = $p_sc_Iterator$SliceIterator__adjustedBound$1__I__I(this, lo);
    var that = ((until - lo) | 0);
    var rest = ((x < that) ? x : that);
  }
  if ((rest === 0)) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  } else {
    var sum = ((this.sc_Iterator$SliceIterator__f_dropping + lo) | 0);
    this.sc_Iterator$SliceIterator__f_dropping = ((sum < 0) ? 2147483647 : sum);
    this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining = rest;
    return this;
  }
});
var $d_sc_Iterator$SliceIterator = new $TypeData().initClass($c_sc_Iterator$SliceIterator, "scala.collection.Iterator$SliceIterator", ({
  sc_Iterator$SliceIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_Iterator$UnfoldIterator(init, f) {
  this.sc_Iterator$UnfoldIterator__f_f = null;
  this.sc_Iterator$UnfoldIterator__f_state = null;
  this.sc_Iterator$UnfoldIterator__f_nextResult = null;
  this.sc_Iterator$UnfoldIterator__f_f = f;
  this.sc_Iterator$UnfoldIterator__f_state = init;
  this.sc_Iterator$UnfoldIterator__f_nextResult = null;
}
$c_sc_Iterator$UnfoldIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$UnfoldIterator.prototype.constructor = $c_sc_Iterator$UnfoldIterator;
/** @constructor */
function $h_sc_Iterator$UnfoldIterator() {
}
$h_sc_Iterator$UnfoldIterator.prototype = $c_sc_Iterator$UnfoldIterator.prototype;
$c_sc_Iterator$UnfoldIterator.prototype.hasNext__Z = (function() {
  if ((this.sc_Iterator$UnfoldIterator__f_nextResult === null)) {
    var res = $as_s_Option($n(this.sc_Iterator$UnfoldIterator__f_f).apply__O__O(this.sc_Iterator$UnfoldIterator__f_state));
    if ((res === null)) {
      throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "null during unfold");
    }
    this.sc_Iterator$UnfoldIterator__f_nextResult = res;
    this.sc_Iterator$UnfoldIterator__f_state = null;
  }
  var this$1 = $n(this.sc_Iterator$UnfoldIterator__f_nextResult);
  return (!this$1.isEmpty__Z());
});
$c_sc_Iterator$UnfoldIterator.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    var x1 = $as_T2($n(this.sc_Iterator$UnfoldIterator__f_nextResult).get__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var value = $n(x1)._1__O();
    var newState = $n(x1)._2__O();
    this.sc_Iterator$UnfoldIterator__f_state = newState;
    this.sc_Iterator$UnfoldIterator__f_nextResult = null;
    return value;
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
});
var $d_sc_Iterator$UnfoldIterator = new $TypeData().initClass($c_sc_Iterator$UnfoldIterator, "scala.collection.Iterator$UnfoldIterator", ({
  sc_Iterator$UnfoldIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_LinearSeqIterator(coll) {
  this.sc_LinearSeqIterator__f_these = null;
  this.sc_LinearSeqIterator__f_these = new $c_sc_LinearSeqIterator$LazyCell(this, new $c_sjsr_AnonFunction0((() => coll)));
}
$c_sc_LinearSeqIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_LinearSeqIterator.prototype.constructor = $c_sc_LinearSeqIterator;
/** @constructor */
function $h_sc_LinearSeqIterator() {
}
$h_sc_LinearSeqIterator.prototype = $c_sc_LinearSeqIterator.prototype;
$c_sc_LinearSeqIterator.prototype.hasNext__Z = (function() {
  var this$1 = $n($n(this.sc_LinearSeqIterator__f_these).v__sc_LinearSeqOps());
  return (!this$1.isEmpty__Z());
});
$c_sc_LinearSeqIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  } else {
    var cur = $n(this.sc_LinearSeqIterator__f_these).v__sc_LinearSeqOps();
    var result = $n(cur).head__O();
    this.sc_LinearSeqIterator__f_these = new $c_sc_LinearSeqIterator$LazyCell(this, new $c_sjsr_AnonFunction0((() => $as_sc_LinearSeq($n(cur).tail__O()))));
    return result;
  }
});
var $d_sc_LinearSeqIterator = new $TypeData().initClass($c_sc_LinearSeqIterator, "scala.collection.LinearSeqIterator", ({
  sc_LinearSeqIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
function $f_sc_LinearSeqOps__headOption__s_Option($thiz) {
  return ($thiz.isEmpty__Z() ? $m_s_None$() : new $c_s_Some($thiz.head__O()));
}
function $f_sc_LinearSeqOps__iterator__sc_Iterator($thiz) {
  return (($thiz.knownSize__I() === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sc_LinearSeqIterator($thiz));
}
function $f_sc_LinearSeqOps__length__I($thiz) {
  var these = $as_sc_LinearSeq($thiz);
  var len = 0;
  while (true) {
    var this$1 = $n(these);
    if ((!this$1.isEmpty__Z())) {
      len = ((1 + len) | 0);
      these = $as_sc_LinearSeq($n(these).tail__O());
    } else {
      break;
    }
  }
  return len;
}
function $f_sc_LinearSeqOps__last__O($thiz) {
  if ($thiz.isEmpty__Z()) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "LinearSeq.last");
  } else {
    var these = $as_sc_LinearSeq($thiz);
    var scout = $as_sc_LinearSeq($thiz.tail__O());
    while (true) {
      var this$1 = $n(scout);
      if ((!this$1.isEmpty__Z())) {
        these = scout;
        scout = $as_sc_LinearSeq($n(scout).tail__O());
      } else {
        break;
      }
    }
    return $n(these).head__O();
  }
}
function $f_sc_LinearSeqOps__lengthCompare__I__I($thiz, len) {
  return ((len < 0) ? 1 : $p_sc_LinearSeqOps__loop$1__I__sc_LinearSeq__I__I($thiz, 0, $as_sc_LinearSeq($thiz), len));
}
function $f_sc_LinearSeqOps__isDefinedAt__I__Z($thiz, x) {
  return ((x >= 0) && ($thiz.lengthCompare__I__I(x) > 0));
}
function $f_sc_LinearSeqOps__apply__I__O($thiz, n) {
  if ((n < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  var skipped = $as_sc_LinearSeq($thiz.drop__I__O(n));
  if ($n(skipped).isEmpty__Z()) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  return $n(skipped).head__O();
}
function $f_sc_LinearSeqOps__foreach__F1__V($thiz, f) {
  var these = $as_sc_LinearSeq($thiz);
  while ((!$n(these).isEmpty__Z())) {
    $n(f).apply__O__O($n(these).head__O());
    these = $as_sc_LinearSeq($n(these).tail__O());
  }
}
function $f_sc_LinearSeqOps__exists__F1__Z($thiz, p) {
  var these = $as_sc_LinearSeq($thiz);
  while ((!$n(these).isEmpty__Z())) {
    if ($uZ($n(p).apply__O__O($n(these).head__O()))) {
      return true;
    }
    these = $as_sc_LinearSeq($n(these).tail__O());
  }
  return false;
}
function $f_sc_LinearSeqOps__find__F1__s_Option($thiz, p) {
  var these = $as_sc_LinearSeq($thiz);
  while ((!$n(these).isEmpty__Z())) {
    if ($uZ($n(p).apply__O__O($n(these).head__O()))) {
      return new $c_s_Some($n(these).head__O());
    }
    these = $as_sc_LinearSeq($n(these).tail__O());
  }
  return $m_s_None$();
}
function $f_sc_LinearSeqOps__foldLeft__O__F2__O($thiz, z, op) {
  var acc = z;
  var these = $as_sc_LinearSeq($thiz);
  while ((!$n(these).isEmpty__Z())) {
    acc = $n(op).apply__O__O__O(acc, $n(these).head__O());
    these = $as_sc_LinearSeq($n(these).tail__O());
  }
  return acc;
}
function $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z($thiz, that) {
  if ($is_sc_LinearSeq(that)) {
    var x2 = $as_sc_LinearSeq(that);
    return $p_sc_LinearSeqOps__linearSeqEq$1__sc_LinearSeq__sc_LinearSeq__Z($thiz, $as_sc_LinearSeq($thiz), x2);
  } else {
    return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, that);
  }
}
function $f_sc_LinearSeqOps__indexWhere__F1__I__I($thiz, p, from) {
  var i = ((from > 0) ? from : 0);
  var these = $as_sc_LinearSeq($thiz.drop__I__O(from));
  while (true) {
    var this$3 = $n(these);
    if ((!this$3.isEmpty__Z())) {
      if ($uZ($n(p).apply__O__O($n(these).head__O()))) {
        return i;
      }
      i = ((1 + i) | 0);
      these = $as_sc_LinearSeq($n(these).tail__O());
    } else {
      break;
    }
  }
  return (-1);
}
function $p_sc_LinearSeqOps__loop$1__I__sc_LinearSeq__I__I($thiz, i, xs, len$1) {
  while (true) {
    if ((i === len$1)) {
      return ($n(xs).isEmpty__Z() ? 0 : 1);
    } else if ($n(xs).isEmpty__Z()) {
      return (-1);
    } else {
      var temp$i = ((1 + i) | 0);
      var temp$xs = $as_sc_LinearSeq($n(xs).tail__O());
      i = temp$i;
      xs = temp$xs;
    }
  }
}
function $p_sc_LinearSeqOps__linearSeqEq$1__sc_LinearSeq__sc_LinearSeq__Z($thiz, a, b) {
  while (true) {
    if ((a === b)) {
      return true;
    } else {
      var this$1 = $n(a);
      if ((!this$1.isEmpty__Z())) {
        var this$2 = $n(b);
        var $x_1 = (!this$2.isEmpty__Z());
      } else {
        var $x_1 = false;
      }
      if (($x_1 && $m_sr_BoxesRunTime$().equals__O__O__Z($n(a).head__O(), $n(b).head__O()))) {
        var temp$a = $as_sc_LinearSeq($n(a).tail__O());
        var temp$b = $as_sc_LinearSeq($n(b).tail__O());
        a = temp$a;
        b = temp$b;
      } else {
        return ($n(a).isEmpty__Z() && $n(b).isEmpty__Z());
      }
    }
  }
}
function $is_sc_LinearSeqOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_LinearSeqOps)));
}
function $as_sc_LinearSeqOps(obj) {
  return (($is_sc_LinearSeqOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.LinearSeqOps"));
}
function $isArrayOf_sc_LinearSeqOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_LinearSeqOps)));
}
function $asArrayOf_sc_LinearSeqOps(obj, depth) {
  return (($isArrayOf_sc_LinearSeqOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.LinearSeqOps;", depth));
}
/** @constructor */
function $c_sc_MapOps$$anon$2(outer) {
  this.sc_MapOps$$anon$2__f_iter = null;
  this.sc_MapOps$$anon$2__f_iter = $n(outer).iterator__sc_Iterator();
}
$c_sc_MapOps$$anon$2.prototype = new $h_sc_AbstractIterator();
$c_sc_MapOps$$anon$2.prototype.constructor = $c_sc_MapOps$$anon$2;
/** @constructor */
function $h_sc_MapOps$$anon$2() {
}
$h_sc_MapOps$$anon$2.prototype = $c_sc_MapOps$$anon$2.prototype;
$c_sc_MapOps$$anon$2.prototype.hasNext__Z = (function() {
  return $n(this.sc_MapOps$$anon$2__f_iter).hasNext__Z();
});
$c_sc_MapOps$$anon$2.prototype.next__O = (function() {
  return $n($as_T2($n(this.sc_MapOps$$anon$2__f_iter).next__O()))._1__O();
});
var $d_sc_MapOps$$anon$2 = new $TypeData().initClass($c_sc_MapOps$$anon$2, "scala.collection.MapOps$$anon$2", ({
  sc_MapOps$$anon$2: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_MapOps$$anon$3(outer) {
  this.sc_MapOps$$anon$3__f_iter = null;
  this.sc_MapOps$$anon$3__f_iter = $n(outer).iterator__sc_Iterator();
}
$c_sc_MapOps$$anon$3.prototype = new $h_sc_AbstractIterator();
$c_sc_MapOps$$anon$3.prototype.constructor = $c_sc_MapOps$$anon$3;
/** @constructor */
function $h_sc_MapOps$$anon$3() {
}
$h_sc_MapOps$$anon$3.prototype = $c_sc_MapOps$$anon$3.prototype;
$c_sc_MapOps$$anon$3.prototype.hasNext__Z = (function() {
  return $n(this.sc_MapOps$$anon$3__f_iter).hasNext__Z();
});
$c_sc_MapOps$$anon$3.prototype.next__O = (function() {
  return $n($as_T2($n(this.sc_MapOps$$anon$3__f_iter).next__O()))._2__O();
});
var $d_sc_MapOps$$anon$3 = new $TypeData().initClass($c_sc_MapOps$$anon$3, "scala.collection.MapOps$$anon$3", ({
  sc_MapOps$$anon$3: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_Seq$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sci_Seq$());
}
$c_sc_Seq$.prototype = new $h_sc_SeqFactory$Delegate();
$c_sc_Seq$.prototype.constructor = $c_sc_Seq$;
/** @constructor */
function $h_sc_Seq$() {
}
$h_sc_Seq$.prototype = $c_sc_Seq$.prototype;
var $d_sc_Seq$ = new $TypeData().initClass($c_sc_Seq$, "scala.collection.Seq$", ({
  sc_Seq$: 1,
  sc_SeqFactory$Delegate: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sc_Seq$;
function $m_sc_Seq$() {
  if ((!$n_sc_Seq$)) {
    $n_sc_Seq$ = new $c_sc_Seq$();
  }
  return $n_sc_Seq$;
}
function $f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps($thiz, that) {
  if ((($thiz instanceof $c_sci_Set$Set1) || (($thiz instanceof $c_sci_Set$Set2) || (($thiz instanceof $c_sci_Set$Set3) || ($thiz instanceof $c_sci_Set$Set4))))) {
    var result = $as_sci_SetOps($thiz);
    var it = $n(that).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var this$1 = $n(result);
      var elem = $n(it).next__O();
      result = this$1.incl__O__sci_SetOps(elem);
    }
    return result;
  } else {
    if ($is_sc_Iterable(that)) {
      var x2 = $as_sc_Iterable(that);
      var $x_1 = new $c_sc_View$Concat($thiz, x2);
    } else {
      var $x_1 = $n($thiz.iterator__sc_Iterator()).concat__F0__sc_Iterator(new $c_sjsr_AnonFunction0((() => $n(that).iterator__sc_Iterator())));
    }
    return $as_sc_SetOps($thiz.fromSpecific__sc_IterableOnce__O($x_1));
  }
}
function $is_sc_SetOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_SetOps)));
}
function $as_sc_SetOps(obj) {
  return (($is_sc_SetOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.SetOps"));
}
function $isArrayOf_sc_SetOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_SetOps)));
}
function $asArrayOf_sc_SetOps(obj, depth) {
  return (($isArrayOf_sc_SetOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.SetOps;", depth));
}
/** @constructor */
function $c_sc_SortedIterableFactory$Delegate() {
  this.sc_EvidenceIterableFactory$Delegate__f_delegate = null;
}
$c_sc_SortedIterableFactory$Delegate.prototype = new $h_sc_EvidenceIterableFactory$Delegate();
$c_sc_SortedIterableFactory$Delegate.prototype.constructor = $c_sc_SortedIterableFactory$Delegate;
/** @constructor */
function $h_sc_SortedIterableFactory$Delegate() {
}
$h_sc_SortedIterableFactory$Delegate.prototype = $c_sc_SortedIterableFactory$Delegate.prototype;
/** @constructor */
function $c_sc_StrictOptimizedLinearSeqOps$$anon$1(outer) {
  this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current = null;
  this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current = outer;
}
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype.constructor = $c_sc_StrictOptimizedLinearSeqOps$$anon$1;
/** @constructor */
function $h_sc_StrictOptimizedLinearSeqOps$$anon$1() {
}
$h_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype = $c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype;
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype.hasNext__Z = (function() {
  return (!$n(this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current).isEmpty__Z());
});
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype.next__O = (function() {
  var r = $n(this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current).head__O();
  this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current = $as_sc_StrictOptimizedLinearSeqOps($n(this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current).tail__O());
  return r;
});
var $d_sc_StrictOptimizedLinearSeqOps$$anon$1 = new $TypeData().initClass($c_sc_StrictOptimizedLinearSeqOps$$anon$1, "scala.collection.StrictOptimizedLinearSeqOps$$anon$1", ({
  sc_StrictOptimizedLinearSeqOps$$anon$1: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
function $p_sc_StringOps$$anon$1__advance__T($thiz) {
  var start = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
  while (true) {
    if (($thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)) {
      var this$ = $thiz.sc_StringOps$$anon$1__f_$this$2;
      var i = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
      var this$2 = $n(this$);
      var c = $charAt(this$2, i);
      var $x_1 = (!((c === 13) || (c === 10)));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = ((1 + $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index) | 0);
    } else {
      break;
    }
  }
  var end = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
  if (($thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)) {
    var this$$2 = $thiz.sc_StringOps$$anon$1__f_$this$2;
    var i$1 = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
    var this$5 = $n(this$$2);
    var c$1 = $charAt(this$5, i$1);
    $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = ((1 + $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index) | 0);
    if (($thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)) {
      var this$$3 = $thiz.sc_StringOps$$anon$1__f_$this$2;
      var i$2 = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
      var this$7 = $n(this$$3);
      var c$2 = $charAt(this$7, i$2);
      var $x_2 = ((c$1 === 13) && (c$2 === 10));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = ((1 + $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index) | 0);
    }
    if ((!$thiz.sc_StringOps$$anon$1__f_stripped$1)) {
      end = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
    }
  }
  var this$9 = $n($thiz.sc_StringOps$$anon$1__f_$this$2);
  var endIndex = end;
  if ((start < 0)) {
    $charAt(this$9, start);
  }
  if ((endIndex > this$9.length)) {
    $charAt(this$9, endIndex);
  }
  if ((endIndex < start)) {
    $charAt(this$9, (-1));
  }
  return $as_T(this$9.substring(start, endIndex));
}
/** @constructor */
function $c_sc_StringOps$$anon$1(\u03b4this$2, stripped$1) {
  this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len = 0;
  this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = 0;
  this.sc_StringOps$$anon$1__f_$this$2 = null;
  this.sc_StringOps$$anon$1__f_stripped$1 = false;
  this.sc_StringOps$$anon$1__f_$this$2 = \u03b4this$2;
  this.sc_StringOps$$anon$1__f_stripped$1 = stripped$1;
  var this$1 = $n(\u03b4this$2);
  this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len = this$1.length;
  this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = 0;
}
$c_sc_StringOps$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sc_StringOps$$anon$1.prototype.constructor = $c_sc_StringOps$$anon$1;
/** @constructor */
function $h_sc_StringOps$$anon$1() {
}
$h_sc_StringOps$$anon$1.prototype = $c_sc_StringOps$$anon$1.prototype;
$c_sc_StringOps$$anon$1.prototype.hasNext__Z = (function() {
  return (this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len);
});
$c_sc_StringOps$$anon$1.prototype.next__T = (function() {
  return ((this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index >= this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len) ? $as_T($n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()) : $p_sc_StringOps$$anon$1__advance__T(this));
});
$c_sc_StringOps$$anon$1.prototype.next__O = (function() {
  return this.next__T();
});
var $d_sc_StringOps$$anon$1 = new $TypeData().initClass($c_sc_StringOps$$anon$1, "scala.collection.StringOps$$anon$1", ({
  sc_StringOps$$anon$1: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_View$DropRightIterator(underlying, maxlen) {
  this.sc_View$DropRightIterator__f_underlying = null;
  this.sc_View$DropRightIterator__f_maxlen = 0;
  this.sc_View$DropRightIterator__f_len = 0;
  this.sc_View$DropRightIterator__f_pos = 0;
  this.sc_View$DropRightIterator__f_buf = null;
  this.sc_View$DropRightIterator__f_underlying = underlying;
  this.sc_View$DropRightIterator__f_maxlen = maxlen;
  this.sc_View$DropRightIterator__f_len = (-1);
  this.sc_View$DropRightIterator__f_pos = 0;
}
$c_sc_View$DropRightIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_View$DropRightIterator.prototype.constructor = $c_sc_View$DropRightIterator;
/** @constructor */
function $h_sc_View$DropRightIterator() {
}
$h_sc_View$DropRightIterator.prototype = $c_sc_View$DropRightIterator.prototype;
$c_sc_View$DropRightIterator.prototype.init__V = (function() {
  if ((this.sc_View$DropRightIterator__f_buf === null)) {
    var x = this.sc_View$DropRightIterator__f_maxlen;
    this.sc_View$DropRightIterator__f_buf = $ct_scm_ArrayBuffer__I__(new $c_scm_ArrayBuffer(), ((x < 256) ? x : 256));
    while (((this.sc_View$DropRightIterator__f_pos < this.sc_View$DropRightIterator__f_maxlen) && $n(this.sc_View$DropRightIterator__f_underlying).hasNext__Z())) {
      $n(this.sc_View$DropRightIterator__f_buf).addOne__O__scm_ArrayBuffer($n(this.sc_View$DropRightIterator__f_underlying).next__O());
      this.sc_View$DropRightIterator__f_pos = ((1 + this.sc_View$DropRightIterator__f_pos) | 0);
    }
    if ((!$n(this.sc_View$DropRightIterator__f_underlying).hasNext__Z())) {
      this.sc_View$DropRightIterator__f_len = 0;
    }
    this.sc_View$DropRightIterator__f_pos = 0;
  }
});
$c_sc_View$DropRightIterator.prototype.knownSize__I = (function() {
  return this.sc_View$DropRightIterator__f_len;
});
$c_sc_View$DropRightIterator.prototype.hasNext__Z = (function() {
  this.init__V();
  return (this.sc_View$DropRightIterator__f_len !== 0);
});
$c_sc_View$DropRightIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  } else {
    var x = $n(this.sc_View$DropRightIterator__f_buf).apply__I__O(this.sc_View$DropRightIterator__f_pos);
    if ((this.sc_View$DropRightIterator__f_len === (-1))) {
      $n(this.sc_View$DropRightIterator__f_buf).update__I__O__V(this.sc_View$DropRightIterator__f_pos, $n(this.sc_View$DropRightIterator__f_underlying).next__O());
      if ((!$n(this.sc_View$DropRightIterator__f_underlying).hasNext__Z())) {
        this.sc_View$DropRightIterator__f_len = 0;
      }
    } else {
      this.sc_View$DropRightIterator__f_len = (((-1) + this.sc_View$DropRightIterator__f_len) | 0);
    }
    this.sc_View$DropRightIterator__f_pos = ((1 + this.sc_View$DropRightIterator__f_pos) | 0);
    if ((this.sc_View$DropRightIterator__f_pos === this.sc_View$DropRightIterator__f_maxlen)) {
      this.sc_View$DropRightIterator__f_pos = 0;
    }
    return x;
  }
});
var $d_sc_View$DropRightIterator = new $TypeData().initClass($c_sc_View$DropRightIterator, "scala.collection.View$DropRightIterator", ({
  sc_View$DropRightIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
function $p_sci_ChampBaseIterator__initNodes__V($thiz) {
  if (($thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths === null)) {
    $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths = new $ac_I(($m_sci_Node$().sci_Node$__f_MaxDepth << 1));
    $thiz.sci_ChampBaseIterator__f_nodes = new ($d_sci_Node.getArrayOf().constr)($m_sci_Node$().sci_Node$__f_MaxDepth);
  }
}
function $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, node) {
  $thiz.sci_ChampBaseIterator__f_currentValueNode = node;
  $thiz.sci_ChampBaseIterator__f_currentValueCursor = 0;
  $thiz.sci_ChampBaseIterator__f_currentValueLength = $n(node).payloadArity__I();
}
function $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, node) {
  $p_sci_ChampBaseIterator__initNodes__V($thiz);
  $thiz.sci_ChampBaseIterator__f_currentStackLevel = ((1 + $thiz.sci_ChampBaseIterator__f_currentStackLevel) | 0);
  var cursorIndex = ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1);
  var lengthIndex = ((1 + ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1)) | 0);
  $n($thiz.sci_ChampBaseIterator__f_nodes).set($thiz.sci_ChampBaseIterator__f_currentStackLevel, node);
  $n($thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths).set(cursorIndex, 0);
  $n($thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths).set(lengthIndex, $n(node).nodeArity__I());
}
function $p_sci_ChampBaseIterator__popNode__V($thiz) {
  $thiz.sci_ChampBaseIterator__f_currentStackLevel = (((-1) + $thiz.sci_ChampBaseIterator__f_currentStackLevel) | 0);
}
function $p_sci_ChampBaseIterator__searchNextValueNode__Z($thiz) {
  while (($thiz.sci_ChampBaseIterator__f_currentStackLevel >= 0)) {
    var cursorIndex = ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1);
    var lengthIndex = ((1 + ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1)) | 0);
    var nodeCursor = $n($thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths).get(cursorIndex);
    var nodeLength = $n($thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths).get(lengthIndex);
    if ((nodeCursor < nodeLength)) {
      var ev$1 = $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths;
      $n(ev$1).set(cursorIndex, ((1 + $n(ev$1).get(cursorIndex)) | 0));
      var nextNode = $n($n($thiz.sci_ChampBaseIterator__f_nodes).get($thiz.sci_ChampBaseIterator__f_currentStackLevel)).getNode__I__sci_Node(nodeCursor);
      if ($n(nextNode).hasNodes__Z()) {
        $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, nextNode);
      }
      if ($n(nextNode).hasPayload__Z()) {
        $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, nextNode);
        return true;
      }
    } else {
      $p_sci_ChampBaseIterator__popNode__V($thiz);
    }
  }
  return false;
}
function $ct_sci_ChampBaseIterator__($thiz) {
  $thiz.sci_ChampBaseIterator__f_currentValueCursor = 0;
  $thiz.sci_ChampBaseIterator__f_currentValueLength = 0;
  $thiz.sci_ChampBaseIterator__f_currentStackLevel = (-1);
  return $thiz;
}
function $ct_sci_ChampBaseIterator__sci_Node__($thiz, rootNode) {
  $ct_sci_ChampBaseIterator__($thiz);
  if ($n(rootNode).hasNodes__Z()) {
    $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, rootNode);
  }
  if ($n(rootNode).hasPayload__Z()) {
    $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, rootNode);
  }
  return $thiz;
}
/** @constructor */
function $c_sci_ChampBaseIterator() {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
}
$c_sci_ChampBaseIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_ChampBaseIterator.prototype.constructor = $c_sci_ChampBaseIterator;
/** @constructor */
function $h_sci_ChampBaseIterator() {
}
$h_sci_ChampBaseIterator.prototype = $c_sci_ChampBaseIterator.prototype;
$c_sci_ChampBaseIterator.prototype.hasNext__Z = (function() {
  return ((this.sci_ChampBaseIterator__f_currentValueCursor < this.sci_ChampBaseIterator__f_currentValueLength) || $p_sci_ChampBaseIterator__searchNextValueNode__Z(this));
});
function $p_sci_ChampBaseReverseIterator__setupPayloadNode__sci_Node__V($thiz, node) {
  $thiz.sci_ChampBaseReverseIterator__f_currentValueNode = node;
  $thiz.sci_ChampBaseReverseIterator__f_currentValueCursor = (((-1) + $n(node).payloadArity__I()) | 0);
}
function $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, node) {
  $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel = ((1 + $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel) | 0);
  $n($thiz.sci_ChampBaseReverseIterator__f_nodeStack).set($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel, node);
  $n($thiz.sci_ChampBaseReverseIterator__f_nodeIndex).set($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel, (((-1) + $n(node).nodeArity__I()) | 0));
}
function $p_sci_ChampBaseReverseIterator__popNode__V($thiz) {
  $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel = (((-1) + $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel) | 0);
}
function $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z($thiz) {
  while (($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel >= 0)) {
    var nodeCursor = $n($thiz.sci_ChampBaseReverseIterator__f_nodeIndex).get($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel);
    $n($thiz.sci_ChampBaseReverseIterator__f_nodeIndex).set($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel, (((-1) + nodeCursor) | 0));
    if ((nodeCursor >= 0)) {
      var nextNode = $n($n($thiz.sci_ChampBaseReverseIterator__f_nodeStack).get($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel)).getNode__I__sci_Node(nodeCursor);
      $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, nextNode);
    } else {
      var currNode = $n($thiz.sci_ChampBaseReverseIterator__f_nodeStack).get($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel);
      $p_sci_ChampBaseReverseIterator__popNode__V($thiz);
      if ($n(currNode).hasPayload__Z()) {
        $p_sci_ChampBaseReverseIterator__setupPayloadNode__sci_Node__V($thiz, currNode);
        return true;
      }
    }
  }
  return false;
}
function $ct_sci_ChampBaseReverseIterator__($thiz) {
  $thiz.sci_ChampBaseReverseIterator__f_currentValueCursor = (-1);
  $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel = (-1);
  $thiz.sci_ChampBaseReverseIterator__f_nodeIndex = new $ac_I(((1 + $m_sci_Node$().sci_Node$__f_MaxDepth) | 0));
  $thiz.sci_ChampBaseReverseIterator__f_nodeStack = new ($d_sci_Node.getArrayOf().constr)(((1 + $m_sci_Node$().sci_Node$__f_MaxDepth) | 0));
  return $thiz;
}
function $ct_sci_ChampBaseReverseIterator__sci_Node__($thiz, rootNode) {
  $ct_sci_ChampBaseReverseIterator__($thiz);
  $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, rootNode);
  $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z($thiz);
  return $thiz;
}
/** @constructor */
function $c_sci_ChampBaseReverseIterator() {
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseReverseIterator__f_currentValueNode = null;
  this.sci_ChampBaseReverseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseReverseIterator__f_nodeIndex = null;
  this.sci_ChampBaseReverseIterator__f_nodeStack = null;
}
$c_sci_ChampBaseReverseIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_ChampBaseReverseIterator.prototype.constructor = $c_sci_ChampBaseReverseIterator;
/** @constructor */
function $h_sci_ChampBaseReverseIterator() {
}
$h_sci_ChampBaseReverseIterator.prototype = $c_sci_ChampBaseReverseIterator.prototype;
$c_sci_ChampBaseReverseIterator.prototype.hasNext__Z = (function() {
  return ((this.sci_ChampBaseReverseIterator__f_currentValueCursor >= 0) || $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z(this));
});
function $p_sci_HashMapBuilder__isAliased__Z($thiz) {
  return ($thiz.sci_HashMapBuilder__f_aliased !== null);
}
function $p_sci_HashMapBuilder__insertElement__AI__I__I__AI($thiz, as, ix, elem) {
  if ((ix < 0)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
  }
  if ((ix > $n(as).u.length)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
  }
  var result = new $ac_I(((1 + $n(as).u.length) | 0));
  $systemArraycopy($n(as), 0, result, 0, ix);
  $n(result).set(ix, elem);
  var destPos = ((1 + ix) | 0);
  var length = (($n(as).u.length - ix) | 0);
  $systemArraycopy($n(as), ix, result, destPos, length);
  return result;
}
function $p_sci_HashMapBuilder__insertValue__sci_BitmapIndexedMapNode__I__O__I__I__O__V($thiz, bm, bitpos, key, originalHash, keyHash, value) {
  var dataIx = $n(bm).dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = $n(bm).sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(((2 + $n(src).u.length) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, idx);
  $n(dst).set(idx, key);
  $n(dst).set(((1 + idx) | 0), value);
  var destPos = ((2 + idx) | 0);
  var length = (($n(src).u.length - idx) | 0);
  $systemArraycopyRefs($n(src), idx, dst, destPos, length);
  var dstHashes = $p_sci_HashMapBuilder__insertElement__AI__I__I__AI($thiz, $n(bm).sci_BitmapIndexedMapNode__f_originalHashes, dataIx, originalHash);
  $n(bm).sci_BitmapIndexedMapNode__f_dataMap = ($n(bm).sci_BitmapIndexedMapNode__f_dataMap | bitpos);
  $n(bm).sci_BitmapIndexedMapNode__f_content = dst;
  $n(bm).sci_BitmapIndexedMapNode__f_originalHashes = dstHashes;
  $n(bm).sci_BitmapIndexedMapNode__f_size = ((1 + $n(bm).sci_BitmapIndexedMapNode__f_size) | 0);
  $n(bm).sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = (($n(bm).sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode + keyHash) | 0);
}
function $p_sci_HashMapBuilder__ensureUnaliased__V($thiz) {
  if ($p_sci_HashMapBuilder__isAliased__Z($thiz)) {
    $p_sci_HashMapBuilder__copyElems__V($thiz);
  }
  $thiz.sci_HashMapBuilder__f_aliased = null;
}
function $p_sci_HashMapBuilder__copyElems__V($thiz) {
  $thiz.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode = $n($thiz.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode).copy__sci_BitmapIndexedMapNode();
}
/** @constructor */
function $c_sci_HashMapBuilder() {
  this.sci_HashMapBuilder__f_aliased = null;
  this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode = null;
  this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode = new $c_sci_BitmapIndexedMapNode(0, 0, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyObjectArray, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, 0, 0);
}
$c_sci_HashMapBuilder.prototype = new $h_O();
$c_sci_HashMapBuilder.prototype.constructor = $c_sci_HashMapBuilder;
/** @constructor */
function $h_sci_HashMapBuilder() {
}
$h_sci_HashMapBuilder.prototype = $c_sci_HashMapBuilder.prototype;
$c_sci_HashMapBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_sci_HashMapBuilder.prototype.getOrElse__O__O__O = (function(key, value) {
  if (($n(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode).sci_BitmapIndexedMapNode__f_size === 0)) {
    return value;
  } else {
    var originalHash = $m_sr_Statics$().anyHash__O__I(key);
    return $n(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode).getOrElse__O__I__I__I__F0__O(key, originalHash, $m_sc_Hashing$().improve__I__I(originalHash), 0, new $c_sjsr_AnonFunction0((() => value)));
  }
});
$c_sci_HashMapBuilder.prototype.update__sci_MapNode__O__O__I__I__I__V = (function(mapNode, key, value, originalHash, keyHash, shift) {
  if ((mapNode instanceof $c_sci_BitmapIndexedMapNode)) {
    var x2 = $as_sci_BitmapIndexedMapNode(mapNode);
    var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
    var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
    if ((($n(x2).sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
      var index = $m_sci_Node$().indexFrom__I__I__I__I($n(x2).sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
      var key0 = $n(x2).getKey__I__O(index);
      var key0UnimprovedHash = $n(x2).getHash__I__I(index);
      if (((key0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key0, key))) {
        $n($n(x2).sci_BitmapIndexedMapNode__f_content).set(((1 + (index << 1)) | 0), value);
      } else {
        var value0 = $n(x2).getValue__I__O(index);
        var key0Hash = $m_sc_Hashing$().improve__I__I(key0UnimprovedHash);
        var subNodeNew = $n(x2).mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(key0, value0, key0UnimprovedHash, key0Hash, key, value, originalHash, keyHash, ((5 + shift) | 0));
        $n(x2).migrateFromInlineToNodeInPlace__I__I__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, key0Hash, subNodeNew);
      }
    } else if ((($n(x2).sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
      var index$2 = $m_sci_Node$().indexFrom__I__I__I__I($n(x2).sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
      var subNode = $n(x2).getNode__I__sci_MapNode(index$2);
      var beforeSize = $n(subNode).size__I();
      var beforeHash = $n(subNode).cachedJavaKeySetHashCode__I();
      this.update__sci_MapNode__O__O__I__I__I__V(subNode, key, value, originalHash, keyHash, ((5 + shift) | 0));
      $n(x2).sci_BitmapIndexedMapNode__f_size = (($n(x2).sci_BitmapIndexedMapNode__f_size + (($n(subNode).size__I() - beforeSize) | 0)) | 0);
      $n(x2).sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = (($n(x2).sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode + (($n(subNode).cachedJavaKeySetHashCode__I() - beforeHash) | 0)) | 0);
    } else {
      $p_sci_HashMapBuilder__insertValue__sci_BitmapIndexedMapNode__I__O__I__I__O__V(this, x2, bitpos, key, originalHash, keyHash, value);
    }
  } else if ((mapNode instanceof $c_sci_HashCollisionMapNode)) {
    var x3 = $as_sci_HashCollisionMapNode(mapNode);
    var index$3 = $n(x3).indexOf__O__I(key);
    if ((index$3 < 0)) {
      $n(x3).sci_HashCollisionMapNode__f_content = $n($n(x3).sci_HashCollisionMapNode__f_content).appended__O__sci_Vector(new $c_T2(key, value));
    } else {
      $n(x3).sci_HashCollisionMapNode__f_content = $n($n(x3).sci_HashCollisionMapNode__f_content).updated__I__O__sci_Vector(index$3, new $c_T2(key, value));
    }
  } else {
    throw new $c_s_MatchError(mapNode);
  }
});
$c_sci_HashMapBuilder.prototype.result__sci_HashMap = (function() {
  if (($n(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode).sci_BitmapIndexedMapNode__f_size === 0)) {
    var this$1 = $m_sci_HashMap$();
    return this$1.sci_HashMap$__f_EmptyMap;
  } else if ((this.sci_HashMapBuilder__f_aliased !== null)) {
    return this.sci_HashMapBuilder__f_aliased;
  } else {
    this.sci_HashMapBuilder__f_aliased = new $c_sci_HashMap(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode);
    return this.sci_HashMapBuilder__f_aliased;
  }
});
$c_sci_HashMapBuilder.prototype.addOne__T2__sci_HashMapBuilder = (function(elem) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  var x = $n(elem)._1__O();
  var h = $m_sr_Statics$().anyHash__O__I(x);
  var im = $m_sc_Hashing$().improve__I__I(h);
  this.update__sci_MapNode__O__O__I__I__I__V(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, $n(elem)._1__O(), $n(elem)._2__O(), h, im, 0);
  return this;
});
$c_sci_HashMapBuilder.prototype.addOne__O__O__sci_HashMapBuilder = (function(key, value) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  this.update__sci_MapNode__O__O__I__I__I__V(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, key, value, originalHash, $m_sc_Hashing$().improve__I__I(originalHash), 0);
  return this;
});
$c_sci_HashMapBuilder.prototype.addAll__sc_IterableOnce__sci_HashMapBuilder = (function(xs) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  if ((xs instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(xs);
    new $c_sci_HashMapBuilder$$anon$1(this, x2);
  } else if ((xs instanceof $c_scm_HashMap)) {
    var x3 = $as_scm_HashMap(xs);
    var iter = $n(x3).nodeIterator__sc_Iterator();
    while ($n(iter).hasNext__Z()) {
      var next = $as_scm_HashMap$Node($n(iter).next__O());
      $n(x3);
      var improvedHash = $n(next).scm_HashMap$Node__f__hash;
      var originalHash = (improvedHash ^ ((improvedHash >>> 16) | 0));
      var hash = $m_sc_Hashing$().improve__I__I(originalHash);
      this.update__sci_MapNode__O__O__I__I__I__V(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, $n(next).scm_HashMap$Node__f__key, $n(next).scm_HashMap$Node__f__value, originalHash, hash, 0);
    }
  } else if (false) {
    var x4 = $as_scm_LinkedHashMap(xs);
    var iter$2 = $n(x4).entryIterator__sc_Iterator();
    while ($n(iter$2).hasNext__Z()) {
      var next$2 = $as_scm_LinkedHashMap$LinkedEntry($n(iter$2).next__O());
      var originalHash$2 = $n(x4).unimproveHash__I__I($n(next$2).hash__I());
      var hash$2 = $m_sc_Hashing$().improve__I__I(originalHash$2);
      this.update__sci_MapNode__O__O__I__I__I__V(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, $n(next$2).key__O(), $n(next$2).value__O(), originalHash$2, hash$2, 0);
    }
  } else if ($is_sci_Map(xs)) {
    var x5 = $as_sci_Map(xs);
    $n(x5).foreachEntry__F2__V(new $c_sjsr_AnonFunction2(((key$2, value$2) => this.addOne__O__O__sci_HashMapBuilder(key$2, value$2))));
  } else {
    var it = $n(xs).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      this.addOne__T2__sci_HashMapBuilder($as_T2($n(it).next__O()));
    }
  }
  return this;
});
$c_sci_HashMapBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__sci_HashMapBuilder(elems);
});
$c_sci_HashMapBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__sci_HashMapBuilder($as_T2(elem));
});
$c_sci_HashMapBuilder.prototype.result__O = (function() {
  return this.result__sci_HashMap();
});
var $d_sci_HashMapBuilder = new $TypeData().initClass($c_sci_HashMapBuilder, "scala.collection.immutable.HashMapBuilder", ({
  sci_HashMapBuilder: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
function $p_sci_HashSetBuilder__isAliased__Z($thiz) {
  return ($thiz.sci_HashSetBuilder__f_aliased !== null);
}
function $p_sci_HashSetBuilder__insertElement__AI__I__I__AI($thiz, as, ix, elem) {
  if ((ix < 0)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
  }
  if ((ix > $n(as).u.length)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
  }
  var result = new $ac_I(((1 + $n(as).u.length) | 0));
  $systemArraycopy($n(as), 0, result, 0, ix);
  $n(result).set(ix, elem);
  var destPos = ((1 + ix) | 0);
  var length = (($n(as).u.length - ix) | 0);
  $systemArraycopy($n(as), ix, result, destPos, length);
  return result;
}
function $p_sci_HashSetBuilder__insertValue__sci_BitmapIndexedSetNode__I__O__I__I__V($thiz, bm, bitpos, key, originalHash, keyHash) {
  var dataIx = $n(bm).dataIndex__I__I(bitpos);
  var src = $n(bm).sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O(((1 + $n(src).u.length) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, dataIx);
  $n(dst).set(dataIx, key);
  var destPos = ((1 + dataIx) | 0);
  var length = (($n(src).u.length - dataIx) | 0);
  $systemArraycopyRefs($n(src), dataIx, dst, destPos, length);
  var dstHashes = $p_sci_HashSetBuilder__insertElement__AI__I__I__AI($thiz, $n(bm).sci_BitmapIndexedSetNode__f_originalHashes, dataIx, originalHash);
  $n(bm).sci_BitmapIndexedSetNode__f_dataMap = ($n(bm).sci_BitmapIndexedSetNode__f_dataMap | bitpos);
  $n(bm).sci_BitmapIndexedSetNode__f_content = dst;
  $n(bm).sci_BitmapIndexedSetNode__f_originalHashes = dstHashes;
  $n(bm).sci_BitmapIndexedSetNode__f_size = ((1 + $n(bm).sci_BitmapIndexedSetNode__f_size) | 0);
  $n(bm).sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = (($n(bm).sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode + keyHash) | 0);
}
function $p_sci_HashSetBuilder__setValue__sci_BitmapIndexedSetNode__I__O__V($thiz, bm, bitpos, elem) {
  var dataIx = $n(bm).dataIndex__I__I(bitpos);
  $n($n(bm).sci_BitmapIndexedSetNode__f_content).set(dataIx, elem);
}
function $p_sci_HashSetBuilder__ensureUnaliased__V($thiz) {
  if ($p_sci_HashSetBuilder__isAliased__Z($thiz)) {
    $p_sci_HashSetBuilder__copyElems__V($thiz);
  }
  $thiz.sci_HashSetBuilder__f_aliased = null;
}
function $p_sci_HashSetBuilder__copyElems__V($thiz) {
  $thiz.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode = $n($thiz.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode).copy__sci_BitmapIndexedSetNode();
}
/** @constructor */
function $c_sci_HashSetBuilder() {
  this.sci_HashSetBuilder__f_aliased = null;
  this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode = null;
  this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode = new $c_sci_BitmapIndexedSetNode(0, 0, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyObjectArray, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, 0, 0);
}
$c_sci_HashSetBuilder.prototype = new $h_O();
$c_sci_HashSetBuilder.prototype.constructor = $c_sci_HashSetBuilder;
/** @constructor */
function $h_sci_HashSetBuilder() {
}
$h_sci_HashSetBuilder.prototype = $c_sci_HashSetBuilder.prototype;
$c_sci_HashSetBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_sci_HashSetBuilder.prototype.update__sci_SetNode__O__I__I__I__V = (function(setNode, element, originalHash, elementHash, shift) {
  if ((setNode instanceof $c_sci_BitmapIndexedSetNode)) {
    var x2 = $as_sci_BitmapIndexedSetNode(setNode);
    var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
    var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
    if ((($n(x2).sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
      var index = $m_sci_Node$().indexFrom__I__I__I__I($n(x2).sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
      var element0 = $n(x2).getPayload__I__O(index);
      var element0UnimprovedHash = $n(x2).getHash__I__I(index);
      if (((element0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(element0, element))) {
        $p_sci_HashSetBuilder__setValue__sci_BitmapIndexedSetNode__I__O__V(this, x2, bitpos, element0);
      } else {
        var element0Hash = $m_sc_Hashing$().improve__I__I(element0UnimprovedHash);
        var subNodeNew = $n(x2).mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(element0, element0UnimprovedHash, element0Hash, element, originalHash, elementHash, ((5 + shift) | 0));
        $n(x2).migrateFromInlineToNodeInPlace__I__I__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, element0Hash, subNodeNew);
      }
    } else if ((($n(x2).sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
      var index$2 = $m_sci_Node$().indexFrom__I__I__I__I($n(x2).sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
      var subNode = $n(x2).getNode__I__sci_SetNode(index$2);
      var beforeSize = $n(subNode).size__I();
      var beforeHashCode = $n(subNode).cachedJavaKeySetHashCode__I();
      this.update__sci_SetNode__O__I__I__I__V(subNode, element, originalHash, elementHash, ((5 + shift) | 0));
      $n(x2).sci_BitmapIndexedSetNode__f_size = (($n(x2).sci_BitmapIndexedSetNode__f_size + (($n(subNode).size__I() - beforeSize) | 0)) | 0);
      $n(x2).sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = (($n(x2).sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode + (($n(subNode).cachedJavaKeySetHashCode__I() - beforeHashCode) | 0)) | 0);
    } else {
      $p_sci_HashSetBuilder__insertValue__sci_BitmapIndexedSetNode__I__O__I__I__V(this, x2, bitpos, element, originalHash, elementHash);
    }
  } else if ((setNode instanceof $c_sci_HashCollisionSetNode)) {
    var x3 = $as_sci_HashCollisionSetNode(setNode);
    var this$1 = $n($n(x3).sci_HashCollisionSetNode__f_content);
    var index$3 = $f_sc_SeqOps__indexOf__O__I__I(this$1, element, 0);
    if ((index$3 < 0)) {
      $n(x3).sci_HashCollisionSetNode__f_content = $n($n(x3).sci_HashCollisionSetNode__f_content).appended__O__sci_Vector(element);
    } else {
      $n(x3).sci_HashCollisionSetNode__f_content = $n($n(x3).sci_HashCollisionSetNode__f_content).updated__I__O__sci_Vector(index$3, element);
    }
  } else {
    throw new $c_s_MatchError(setNode);
  }
});
$c_sci_HashSetBuilder.prototype.result__sci_HashSet = (function() {
  if (($n(this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode).sci_BitmapIndexedSetNode__f_size === 0)) {
    var this$1 = $m_sci_HashSet$();
    return this$1.sci_HashSet$__f_EmptySet;
  } else if ((this.sci_HashSetBuilder__f_aliased !== null)) {
    return this.sci_HashSetBuilder__f_aliased;
  } else {
    this.sci_HashSetBuilder__f_aliased = new $c_sci_HashSet(this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode);
    return this.sci_HashSetBuilder__f_aliased;
  }
});
$c_sci_HashSetBuilder.prototype.addOne__O__sci_HashSetBuilder = (function(elem) {
  $p_sci_HashSetBuilder__ensureUnaliased__V(this);
  var h = $m_sr_Statics$().anyHash__O__I(elem);
  var im = $m_sc_Hashing$().improve__I__I(h);
  this.update__sci_SetNode__O__I__I__I__V(this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode, elem, h, im, 0);
  return this;
});
$c_sci_HashSetBuilder.prototype.addAll__sc_IterableOnce__sci_HashSetBuilder = (function(xs) {
  $p_sci_HashSetBuilder__ensureUnaliased__V(this);
  if ((xs instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(xs);
    new $c_sci_HashSetBuilder$$anon$1(this, x2);
  } else {
    var it = $n(xs).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      this.addOne__O__sci_HashSetBuilder($n(it).next__O());
    }
  }
  return this;
});
$c_sci_HashSetBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__sci_HashSetBuilder(elems);
});
$c_sci_HashSetBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_HashSetBuilder(elem);
});
$c_sci_HashSetBuilder.prototype.result__O = (function() {
  return this.result__sci_HashSet();
});
var $d_sci_HashSetBuilder = new $TypeData().initClass($c_sci_HashSetBuilder, "scala.collection.immutable.HashSetBuilder", ({
  sci_HashSetBuilder: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
/** @constructor */
function $c_sci_IndexedSeq$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sci_Vector$());
}
$c_sci_IndexedSeq$.prototype = new $h_sc_SeqFactory$Delegate();
$c_sci_IndexedSeq$.prototype.constructor = $c_sci_IndexedSeq$;
/** @constructor */
function $h_sci_IndexedSeq$() {
}
$h_sci_IndexedSeq$.prototype = $c_sci_IndexedSeq$.prototype;
$c_sci_IndexedSeq$.prototype.from__sc_IterableOnce__sci_IndexedSeq = (function(it) {
  if ($is_sci_IndexedSeq(it)) {
    var x2 = $as_sci_IndexedSeq(it);
    return x2;
  } else {
    return $as_sci_IndexedSeq($c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__sc_SeqOps.call(this, it));
  }
});
$c_sci_IndexedSeq$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_IndexedSeq(source);
});
$c_sci_IndexedSeq$.prototype.from__sc_IterableOnce__sc_SeqOps = (function(it) {
  return this.from__sc_IterableOnce__sci_IndexedSeq(it);
});
var $d_sci_IndexedSeq$ = new $TypeData().initClass($c_sci_IndexedSeq$, "scala.collection.immutable.IndexedSeq$", ({
  sci_IndexedSeq$: 1,
  sc_SeqFactory$Delegate: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_IndexedSeq$;
function $m_sci_IndexedSeq$() {
  if ((!$n_sci_IndexedSeq$)) {
    $n_sci_IndexedSeq$ = new $c_sci_IndexedSeq$();
  }
  return $n_sci_IndexedSeq$;
}
/** @constructor */
function $c_sci_LazyList$LazyBuilder() {
  this.sci_LazyList$LazyBuilder__f_next = null;
  this.sci_LazyList$LazyBuilder__f_list = null;
  this.clear__V();
}
$c_sci_LazyList$LazyBuilder.prototype = new $h_O();
$c_sci_LazyList$LazyBuilder.prototype.constructor = $c_sci_LazyList$LazyBuilder;
/** @constructor */
function $h_sci_LazyList$LazyBuilder() {
}
$h_sci_LazyList$LazyBuilder.prototype = $c_sci_LazyList$LazyBuilder.prototype;
$c_sci_LazyList$LazyBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_sci_LazyList$LazyBuilder.prototype.clear__V = (function() {
  var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
  $m_sci_LazyList$();
  var state = new $c_sjsr_AnonFunction0((() => deferred.eval__sci_LazyList$State()));
  this.sci_LazyList$LazyBuilder__f_list = new $c_sci_LazyList(state);
  this.sci_LazyList$LazyBuilder__f_next = deferred;
});
$c_sci_LazyList$LazyBuilder.prototype.result__sci_LazyList = (function() {
  $n(this.sci_LazyList$LazyBuilder__f_next).init__F0__V(new $c_sjsr_AnonFunction0((() => $m_sci_LazyList$State$Empty$())));
  return this.sci_LazyList$LazyBuilder__f_list;
});
$c_sci_LazyList$LazyBuilder.prototype.addOne__O__sci_LazyList$LazyBuilder = (function(elem) {
  var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
  $n(this.sci_LazyList$LazyBuilder__f_next).init__F0__V(new $c_sjsr_AnonFunction0((() => {
    $m_sci_LazyList$();
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((() => deferred.eval__sci_LazyList$State()));
    var tl = new $c_sci_LazyList(state);
    return new $c_sci_LazyList$State$Cons(elem, tl);
  })));
  this.sci_LazyList$LazyBuilder__f_next = deferred;
  return this;
});
$c_sci_LazyList$LazyBuilder.prototype.addAll__sc_IterableOnce__sci_LazyList$LazyBuilder = (function(xs) {
  if (($n(xs).knownSize__I() !== 0)) {
    var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
    $n(this.sci_LazyList$LazyBuilder__f_next).init__F0__V(new $c_sjsr_AnonFunction0((() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIteratorConcatSuffix__sc_Iterator__F0__sci_LazyList$State($n(xs).iterator__sc_Iterator(), new $c_sjsr_AnonFunction0((() => deferred.eval__sci_LazyList$State()))))));
    this.sci_LazyList$LazyBuilder__f_next = deferred;
  }
  return this;
});
$c_sci_LazyList$LazyBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__sci_LazyList$LazyBuilder(elems);
});
$c_sci_LazyList$LazyBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_LazyList$LazyBuilder(elem);
});
$c_sci_LazyList$LazyBuilder.prototype.result__O = (function() {
  return this.result__sci_LazyList();
});
var $d_sci_LazyList$LazyBuilder = new $TypeData().initClass($c_sci_LazyList$LazyBuilder, "scala.collection.immutable.LazyList$LazyBuilder", ({
  sci_LazyList$LazyBuilder: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
/** @constructor */
function $c_sci_LazyList$LazyIterator(lazyList) {
  this.sci_LazyList$LazyIterator__f_lazyList = null;
  this.sci_LazyList$LazyIterator__f_lazyList = lazyList;
}
$c_sci_LazyList$LazyIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_LazyList$LazyIterator.prototype.constructor = $c_sci_LazyList$LazyIterator;
/** @constructor */
function $h_sci_LazyList$LazyIterator() {
}
$h_sci_LazyList$LazyIterator.prototype = $c_sci_LazyList$LazyIterator.prototype;
$c_sci_LazyList$LazyIterator.prototype.hasNext__Z = (function() {
  return (!$n(this.sci_LazyList$LazyIterator__f_lazyList).isEmpty__Z());
});
$c_sci_LazyList$LazyIterator.prototype.next__O = (function() {
  if ($n(this.sci_LazyList$LazyIterator__f_lazyList).isEmpty__Z()) {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  } else {
    var this$1 = $n(this.sci_LazyList$LazyIterator__f_lazyList);
    var res = $n(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
    var this$2 = $n(this.sci_LazyList$LazyIterator__f_lazyList);
    this.sci_LazyList$LazyIterator__f_lazyList = $n(this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
    return res;
  }
});
var $d_sci_LazyList$LazyIterator = new $TypeData().initClass($c_sci_LazyList$LazyIterator, "scala.collection.immutable.LazyList$LazyIterator", ({
  sci_LazyList$LazyIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_LazyList$SlidingIterator(lazyList, size, step) {
  this.sci_LazyList$SlidingIterator__f_lazyList = null;
  this.sci_LazyList$SlidingIterator__f_size = 0;
  this.sci_LazyList$SlidingIterator__f_step = 0;
  this.sci_LazyList$SlidingIterator__f_minLen = 0;
  this.sci_LazyList$SlidingIterator__f_first = false;
  this.sci_LazyList$SlidingIterator__f_lazyList = lazyList;
  this.sci_LazyList$SlidingIterator__f_size = size;
  this.sci_LazyList$SlidingIterator__f_step = step;
  var x = ((size - step) | 0);
  this.sci_LazyList$SlidingIterator__f_minLen = ((x > 0) ? x : 0);
  this.sci_LazyList$SlidingIterator__f_first = true;
}
$c_sci_LazyList$SlidingIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_LazyList$SlidingIterator.prototype.constructor = $c_sci_LazyList$SlidingIterator;
/** @constructor */
function $h_sci_LazyList$SlidingIterator() {
}
$h_sci_LazyList$SlidingIterator.prototype = $c_sci_LazyList$SlidingIterator.prototype;
$c_sci_LazyList$SlidingIterator.prototype.hasNext__Z = (function() {
  return (this.sci_LazyList$SlidingIterator__f_first ? (!$n(this.sci_LazyList$SlidingIterator__f_lazyList).isEmpty__Z()) : $n(this.sci_LazyList$SlidingIterator__f_lazyList).scala$collection$immutable$LazyList$$lengthGt__I__Z(this.sci_LazyList$SlidingIterator__f_minLen));
});
$c_sci_LazyList$SlidingIterator.prototype.next__sci_LazyList = (function() {
  if ((!this.hasNext__Z())) {
    return $as_sci_LazyList($n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O());
  } else {
    this.sci_LazyList$SlidingIterator__f_first = false;
    var list = this.sci_LazyList$SlidingIterator__f_lazyList;
    this.sci_LazyList$SlidingIterator__f_lazyList = $n(list).drop__I__sci_LazyList(this.sci_LazyList$SlidingIterator__f_step);
    return $n(list).take__I__sci_LazyList(this.sci_LazyList$SlidingIterator__f_size);
  }
});
$c_sci_LazyList$SlidingIterator.prototype.next__O = (function() {
  return this.next__sci_LazyList();
});
var $d_sci_LazyList$SlidingIterator = new $TypeData().initClass($c_sci_LazyList$SlidingIterator, "scala.collection.immutable.LazyList$SlidingIterator", ({
  sci_LazyList$SlidingIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_List$() {
  this.sci_List$__f_scala$collection$immutable$List$$TupleOfNil = null;
  this.sci_List$__f_partialNotApplied = null;
  $n_sci_List$ = this;
  this.sci_List$__f_scala$collection$immutable$List$$TupleOfNil = new $c_T2($m_sci_Nil$(), $m_sci_Nil$());
  this.sci_List$__f_partialNotApplied = new $c_sci_List$$anon$1();
}
$c_sci_List$.prototype = new $h_O();
$c_sci_List$.prototype.constructor = $c_sci_List$;
/** @constructor */
function $h_sci_List$() {
}
$h_sci_List$.prototype = $c_sci_List$.prototype;
$c_sci_List$.prototype.apply__sci_Seq__O = (function(elems) {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
});
$c_sci_List$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_ListBuffer();
});
$c_sci_List$.prototype.empty__O = (function() {
  return $m_sci_Nil$();
});
$c_sci_List$.prototype.from__sc_IterableOnce__O = (function(source) {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(source);
});
var $d_sci_List$ = new $TypeData().initClass($c_sci_List$, "scala.collection.immutable.List$", ({
  sci_List$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_List$;
function $m_sci_List$() {
  if ((!$n_sci_List$)) {
    $n_sci_List$ = new $c_sci_List$();
  }
  return $n_sci_List$;
}
function $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__($thiz, outer) {
  $n(outer);
  $thiz.sci_Map$Map2$Map2Iterator__f_$outer = outer;
  $thiz.sci_Map$Map2$Map2Iterator__f_i = 0;
  return $thiz;
}
/** @constructor */
function $c_sci_Map$Map2$Map2Iterator() {
  this.sci_Map$Map2$Map2Iterator__f_i = 0;
  this.sci_Map$Map2$Map2Iterator__f_$outer = null;
}
$c_sci_Map$Map2$Map2Iterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Map$Map2$Map2Iterator.prototype.constructor = $c_sci_Map$Map2$Map2Iterator;
/** @constructor */
function $h_sci_Map$Map2$Map2Iterator() {
}
$h_sci_Map$Map2$Map2Iterator.prototype = $c_sci_Map$Map2$Map2Iterator.prototype;
$c_sci_Map$Map2$Map2Iterator.prototype.hasNext__Z = (function() {
  return (this.sci_Map$Map2$Map2Iterator__f_i < 2);
});
$c_sci_Map$Map2$Map2Iterator.prototype.next__O = (function() {
  var x1 = this.sci_Map$Map2$Map2Iterator__f_i;
  switch (x1) {
    case 0: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map2$Map2Iterator__f_$outer).sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, $n(this.sci_Map$Map2$Map2Iterator__f_$outer).sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1);
      break;
    }
    case 1: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map2$Map2Iterator__f_$outer).sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, $n(this.sci_Map$Map2$Map2Iterator__f_$outer).sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2);
      break;
    }
    default: {
      var result = $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
    }
  }
  this.sci_Map$Map2$Map2Iterator__f_i = ((1 + this.sci_Map$Map2$Map2Iterator__f_i) | 0);
  return result;
});
$c_sci_Map$Map2$Map2Iterator.prototype.drop__I__sc_Iterator = (function(n) {
  this.sci_Map$Map2$Map2Iterator__f_i = ((this.sci_Map$Map2$Map2Iterator__f_i + n) | 0);
  return this;
});
function $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__($thiz, outer) {
  $n(outer);
  $thiz.sci_Map$Map3$Map3Iterator__f_$outer = outer;
  $thiz.sci_Map$Map3$Map3Iterator__f_i = 0;
  return $thiz;
}
/** @constructor */
function $c_sci_Map$Map3$Map3Iterator() {
  this.sci_Map$Map3$Map3Iterator__f_i = 0;
  this.sci_Map$Map3$Map3Iterator__f_$outer = null;
}
$c_sci_Map$Map3$Map3Iterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Map$Map3$Map3Iterator.prototype.constructor = $c_sci_Map$Map3$Map3Iterator;
/** @constructor */
function $h_sci_Map$Map3$Map3Iterator() {
}
$h_sci_Map$Map3$Map3Iterator.prototype = $c_sci_Map$Map3$Map3Iterator.prototype;
$c_sci_Map$Map3$Map3Iterator.prototype.hasNext__Z = (function() {
  return (this.sci_Map$Map3$Map3Iterator__f_i < 3);
});
$c_sci_Map$Map3$Map3Iterator.prototype.next__O = (function() {
  var x1 = this.sci_Map$Map3$Map3Iterator__f_i;
  switch (x1) {
    case 0: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map3$Map3Iterator__f_$outer).sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, $n(this.sci_Map$Map3$Map3Iterator__f_$outer).sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1);
      break;
    }
    case 1: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map3$Map3Iterator__f_$outer).sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, $n(this.sci_Map$Map3$Map3Iterator__f_$outer).sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2);
      break;
    }
    case 2: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map3$Map3Iterator__f_$outer).sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, $n(this.sci_Map$Map3$Map3Iterator__f_$outer).sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3);
      break;
    }
    default: {
      var result = $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
    }
  }
  this.sci_Map$Map3$Map3Iterator__f_i = ((1 + this.sci_Map$Map3$Map3Iterator__f_i) | 0);
  return result;
});
$c_sci_Map$Map3$Map3Iterator.prototype.drop__I__sc_Iterator = (function(n) {
  this.sci_Map$Map3$Map3Iterator__f_i = ((this.sci_Map$Map3$Map3Iterator__f_i + n) | 0);
  return this;
});
function $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__($thiz, outer) {
  $n(outer);
  $thiz.sci_Map$Map4$Map4Iterator__f_$outer = outer;
  $thiz.sci_Map$Map4$Map4Iterator__f_i = 0;
  return $thiz;
}
/** @constructor */
function $c_sci_Map$Map4$Map4Iterator() {
  this.sci_Map$Map4$Map4Iterator__f_i = 0;
  this.sci_Map$Map4$Map4Iterator__f_$outer = null;
}
$c_sci_Map$Map4$Map4Iterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Map$Map4$Map4Iterator.prototype.constructor = $c_sci_Map$Map4$Map4Iterator;
/** @constructor */
function $h_sci_Map$Map4$Map4Iterator() {
}
$h_sci_Map$Map4$Map4Iterator.prototype = $c_sci_Map$Map4$Map4Iterator.prototype;
$c_sci_Map$Map4$Map4Iterator.prototype.hasNext__Z = (function() {
  return (this.sci_Map$Map4$Map4Iterator__f_i < 4);
});
$c_sci_Map$Map4$Map4Iterator.prototype.next__O = (function() {
  var x1 = this.sci_Map$Map4$Map4Iterator__f_i;
  switch (x1) {
    case 0: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map4$Map4Iterator__f_$outer).sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, $n(this.sci_Map$Map4$Map4Iterator__f_$outer).sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1);
      break;
    }
    case 1: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map4$Map4Iterator__f_$outer).sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, $n(this.sci_Map$Map4$Map4Iterator__f_$outer).sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2);
      break;
    }
    case 2: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map4$Map4Iterator__f_$outer).sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, $n(this.sci_Map$Map4$Map4Iterator__f_$outer).sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3);
      break;
    }
    case 3: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map4$Map4Iterator__f_$outer).sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, $n(this.sci_Map$Map4$Map4Iterator__f_$outer).sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4);
      break;
    }
    default: {
      var result = $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
    }
  }
  this.sci_Map$Map4$Map4Iterator__f_i = ((1 + this.sci_Map$Map4$Map4Iterator__f_i) | 0);
  return result;
});
$c_sci_Map$Map4$Map4Iterator.prototype.drop__I__sc_Iterator = (function(n) {
  this.sci_Map$Map4$Map4Iterator__f_i = ((this.sci_Map$Map4$Map4Iterator__f_i + n) | 0);
  return this;
});
/** @constructor */
function $c_sci_MapBuilderImpl() {
  this.sci_MapBuilderImpl__f_elems = null;
  this.sci_MapBuilderImpl__f_switchedToHashMapBuilder = false;
  this.sci_MapBuilderImpl__f_hashMapBuilder = null;
  this.sci_MapBuilderImpl__f_elems = $m_sci_Map$EmptyMap$();
  this.sci_MapBuilderImpl__f_switchedToHashMapBuilder = false;
}
$c_sci_MapBuilderImpl.prototype = new $h_O();
$c_sci_MapBuilderImpl.prototype.constructor = $c_sci_MapBuilderImpl;
/** @constructor */
function $h_sci_MapBuilderImpl() {
}
$h_sci_MapBuilderImpl.prototype = $c_sci_MapBuilderImpl.prototype;
$c_sci_MapBuilderImpl.prototype.sizeHint__I__V = (function(size) {
});
$c_sci_MapBuilderImpl.prototype.getOrElse__O__O__O = (function(key, value) {
  return ((this.sci_MapBuilderImpl__f_hashMapBuilder !== null) ? $n(this.sci_MapBuilderImpl__f_hashMapBuilder).getOrElse__O__O__O(key, value) : $n(this.sci_MapBuilderImpl__f_elems).getOrElse__O__F0__O(key, new $c_sjsr_AnonFunction0((() => value))));
});
$c_sci_MapBuilderImpl.prototype.result__sci_Map = (function() {
  return (this.sci_MapBuilderImpl__f_switchedToHashMapBuilder ? $n(this.sci_MapBuilderImpl__f_hashMapBuilder).result__sci_HashMap() : this.sci_MapBuilderImpl__f_elems);
});
$c_sci_MapBuilderImpl.prototype.addOne__O__O__sci_MapBuilderImpl = (function(key, value) {
  if (this.sci_MapBuilderImpl__f_switchedToHashMapBuilder) {
    $n(this.sci_MapBuilderImpl__f_hashMapBuilder).addOne__O__O__sci_HashMapBuilder(key, value);
  } else if (($n(this.sci_MapBuilderImpl__f_elems).size__I() < 4)) {
    this.sci_MapBuilderImpl__f_elems = $as_sci_Map($n(this.sci_MapBuilderImpl__f_elems).updated__O__O__sci_MapOps(key, value));
  } else if ($n(this.sci_MapBuilderImpl__f_elems).contains__O__Z(key)) {
    this.sci_MapBuilderImpl__f_elems = $as_sci_Map($n(this.sci_MapBuilderImpl__f_elems).updated__O__O__sci_MapOps(key, value));
  } else {
    this.sci_MapBuilderImpl__f_switchedToHashMapBuilder = true;
    if ((this.sci_MapBuilderImpl__f_hashMapBuilder === null)) {
      this.sci_MapBuilderImpl__f_hashMapBuilder = new $c_sci_HashMapBuilder();
    }
    $n($as_sci_Map$Map4(this.sci_MapBuilderImpl__f_elems)).buildTo__sci_HashMapBuilder__sci_HashMapBuilder(this.sci_MapBuilderImpl__f_hashMapBuilder);
    $n(this.sci_MapBuilderImpl__f_hashMapBuilder).addOne__O__O__sci_HashMapBuilder(key, value);
  }
  return this;
});
$c_sci_MapBuilderImpl.prototype.addAll__sc_IterableOnce__sci_MapBuilderImpl = (function(xs) {
  return (this.sci_MapBuilderImpl__f_switchedToHashMapBuilder ? ($n(this.sci_MapBuilderImpl__f_hashMapBuilder).addAll__sc_IterableOnce__sci_HashMapBuilder(xs), this) : $as_sci_MapBuilderImpl($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)));
});
$c_sci_MapBuilderImpl.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__sci_MapBuilderImpl(elems);
});
$c_sci_MapBuilderImpl.prototype.addOne__O__scm_Growable = (function(elem) {
  var elem$1 = $as_T2(elem);
  return this.addOne__O__O__sci_MapBuilderImpl($n(elem$1)._1__O(), $n(elem$1)._2__O());
});
$c_sci_MapBuilderImpl.prototype.result__O = (function() {
  return this.result__sci_Map();
});
function $as_sci_MapBuilderImpl(obj) {
  return (((obj instanceof $c_sci_MapBuilderImpl) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.MapBuilderImpl"));
}
function $isArrayOf_sci_MapBuilderImpl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_MapBuilderImpl)));
}
function $asArrayOf_sci_MapBuilderImpl(obj, depth) {
  return (($isArrayOf_sci_MapBuilderImpl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.MapBuilderImpl;", depth));
}
var $d_sci_MapBuilderImpl = new $TypeData().initClass($c_sci_MapBuilderImpl, "scala.collection.immutable.MapBuilderImpl", ({
  sci_MapBuilderImpl: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
/** @constructor */
function $c_sci_Queue$() {
}
$c_sci_Queue$.prototype = new $h_O();
$c_sci_Queue$.prototype.constructor = $c_sci_Queue$;
/** @constructor */
function $h_sci_Queue$() {
}
$h_sci_Queue$.prototype = $c_sci_Queue$.prototype;
$c_sci_Queue$.prototype.newBuilder__scm_Builder = (function() {
  var this$2 = new $c_scm_ListBuffer();
  var f = new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_sci_List(x$2);
    return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), x);
  }));
  return new $c_scm_Builder$$anon$1(this$2, f);
});
$c_sci_Queue$.prototype.from__sc_IterableOnce__sci_Queue = (function(source) {
  if ((source instanceof $c_sci_Queue)) {
    var x2 = $as_sci_Queue(source);
    return x2;
  } else {
    var list = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(source);
    return ($n(list).isEmpty__Z() ? $m_sci_Queue$EmptyQueue$() : $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), list));
  }
});
$c_sci_Queue$.prototype.apply__sci_Seq__O = (function(elems) {
  return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), $n(elems).toList__sci_List());
});
$c_sci_Queue$.prototype.empty__O = (function() {
  return $m_sci_Queue$EmptyQueue$();
});
$c_sci_Queue$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Queue(source);
});
var $d_sci_Queue$ = new $TypeData().initClass($c_sci_Queue$, "scala.collection.immutable.Queue$", ({
  sci_Queue$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_Queue$;
function $m_sci_Queue$() {
  if ((!$n_sci_Queue$)) {
    $n_sci_Queue$ = new $c_sci_Queue$();
  }
  return $n_sci_Queue$;
}
function $p_sci_RedBlackTree$TreeIterator__startFrom__O__sci_RedBlackTree$Tree($thiz, key) {
  return (($thiz.sci_RedBlackTree$TreeIterator__f_root === null) ? null : $p_sci_RedBlackTree$TreeIterator__find$1__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree($thiz, $thiz.sci_RedBlackTree$TreeIterator__f_root, key));
}
function $p_sci_RedBlackTree$TreeIterator__find$1__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree($thiz, tree, key$1) {
  while (true) {
    if ((tree === null)) {
      if (($thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index === 0)) {
        return null;
      } else {
        $thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = (((-1) + $thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        return $n($thiz.sci_RedBlackTree$TreeIterator__f_stackOfNexts).get($thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index);
      }
    } else {
      var $x_1 = $thiz.sci_RedBlackTree$TreeIterator__f_ordering;
      var this$1 = $n(tree);
      if ($n($x_1).lteq__O__O__Z(key$1, this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)) {
        var tree$1 = tree;
        $n($thiz.sci_RedBlackTree$TreeIterator__f_stackOfNexts).set($thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index, tree$1);
        $thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = ((1 + $thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        var this$2 = $n(tree$1);
        tree = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      } else {
        var tree$2 = tree;
        var this$3 = $n(tree$2);
        tree = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      }
    }
  }
}
function $ct_sci_RedBlackTree$TreeIterator__sci_RedBlackTree$Tree__s_Option__s_math_Ordering__($thiz, root, start, ordering) {
  $thiz.sci_RedBlackTree$TreeIterator__f_root = root;
  $thiz.sci_RedBlackTree$TreeIterator__f_ordering = ordering;
  if ((root === null)) {
    var $x_1 = null;
  } else {
    var this$1 = $n(root);
    var i = ((1 + (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) | 0);
    var maximumHeight = (((-2) + (((32 - $uI(Math.clz32(i))) | 0) << 1)) | 0);
    var $x_1 = new ($d_sci_RedBlackTree$Tree.getArrayOf().constr)(maximumHeight);
  }
  $thiz.sci_RedBlackTree$TreeIterator__f_stackOfNexts = $x_1;
  $thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = 0;
  var this$3 = $n(start);
  $thiz.sci_RedBlackTree$TreeIterator__f_lookahead = ((!this$3.isEmpty__Z()) ? $p_sci_RedBlackTree$TreeIterator__startFrom__O__sci_RedBlackTree$Tree($thiz, $n(start).get__O()) : $thiz.findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(root));
  return $thiz;
}
/** @constructor */
function $c_sci_RedBlackTree$TreeIterator() {
  this.sci_RedBlackTree$TreeIterator__f_root = null;
  this.sci_RedBlackTree$TreeIterator__f_ordering = null;
  this.sci_RedBlackTree$TreeIterator__f_stackOfNexts = null;
  this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = 0;
  this.sci_RedBlackTree$TreeIterator__f_lookahead = null;
}
$c_sci_RedBlackTree$TreeIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_RedBlackTree$TreeIterator.prototype.constructor = $c_sci_RedBlackTree$TreeIterator;
/** @constructor */
function $h_sci_RedBlackTree$TreeIterator() {
}
$h_sci_RedBlackTree$TreeIterator.prototype = $c_sci_RedBlackTree$TreeIterator.prototype;
$c_sci_RedBlackTree$TreeIterator.prototype.hasNext__Z = (function() {
  return (this.sci_RedBlackTree$TreeIterator__f_lookahead !== null);
});
$c_sci_RedBlackTree$TreeIterator.prototype.next__O = (function() {
  var tree = this.sci_RedBlackTree$TreeIterator__f_lookahead;
  if ((tree !== null)) {
    var this$1 = $n(tree);
    this.sci_RedBlackTree$TreeIterator__f_lookahead = this.findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
    return this.nextResult__sci_RedBlackTree$Tree__O(tree);
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
});
$c_sci_RedBlackTree$TreeIterator.prototype.findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree) {
  while (true) {
    if ((tree === null)) {
      if ((this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index === 0)) {
        return null;
      } else {
        this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = (((-1) + this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        return $n(this.sci_RedBlackTree$TreeIterator__f_stackOfNexts).get(this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index);
      }
    } else {
      var this$1 = $n(tree);
      if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left === null)) {
        return tree;
      } else {
        var tree$1 = tree;
        $n(this.sci_RedBlackTree$TreeIterator__f_stackOfNexts).set(this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index, tree$1);
        this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = ((1 + this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        var this$2 = $n(tree$1);
        tree = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      }
    }
  }
});
/** @constructor */
function $c_sci_Seq$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sci_List$());
}
$c_sci_Seq$.prototype = new $h_sc_SeqFactory$Delegate();
$c_sci_Seq$.prototype.constructor = $c_sci_Seq$;
/** @constructor */
function $h_sci_Seq$() {
}
$h_sci_Seq$.prototype = $c_sci_Seq$.prototype;
$c_sci_Seq$.prototype.from__sc_IterableOnce__sci_Seq = (function(it) {
  if ($is_sci_Seq(it)) {
    var x2 = $as_sci_Seq(it);
    return x2;
  } else {
    return $as_sci_Seq($c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__sc_SeqOps.call(this, it));
  }
});
$c_sci_Seq$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Seq(source);
});
$c_sci_Seq$.prototype.from__sc_IterableOnce__sc_SeqOps = (function(it) {
  return this.from__sc_IterableOnce__sci_Seq(it);
});
var $d_sci_Seq$ = new $TypeData().initClass($c_sci_Seq$, "scala.collection.immutable.Seq$", ({
  sci_Seq$: 1,
  sc_SeqFactory$Delegate: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_Seq$;
function $m_sci_Seq$() {
  if ((!$n_sci_Seq$)) {
    $n_sci_Seq$ = new $c_sci_Seq$();
  }
  return $n_sci_Seq$;
}
/** @constructor */
function $c_sci_SetBuilderImpl() {
  this.sci_SetBuilderImpl__f_elems = null;
  this.sci_SetBuilderImpl__f_switchedToHashSetBuilder = false;
  this.sci_SetBuilderImpl__f_hashSetBuilder = null;
  this.sci_SetBuilderImpl__f_elems = $m_sci_Set$EmptySet$();
  this.sci_SetBuilderImpl__f_switchedToHashSetBuilder = false;
}
$c_sci_SetBuilderImpl.prototype = new $h_O();
$c_sci_SetBuilderImpl.prototype.constructor = $c_sci_SetBuilderImpl;
/** @constructor */
function $h_sci_SetBuilderImpl() {
}
$h_sci_SetBuilderImpl.prototype = $c_sci_SetBuilderImpl.prototype;
$c_sci_SetBuilderImpl.prototype.sizeHint__I__V = (function(size) {
});
$c_sci_SetBuilderImpl.prototype.result__sci_Set = (function() {
  return (this.sci_SetBuilderImpl__f_switchedToHashSetBuilder ? $n(this.sci_SetBuilderImpl__f_hashSetBuilder).result__sci_HashSet() : this.sci_SetBuilderImpl__f_elems);
});
$c_sci_SetBuilderImpl.prototype.addOne__O__sci_SetBuilderImpl = (function(elem) {
  if (this.sci_SetBuilderImpl__f_switchedToHashSetBuilder) {
    $n(this.sci_SetBuilderImpl__f_hashSetBuilder).addOne__O__sci_HashSetBuilder(elem);
  } else if (($n(this.sci_SetBuilderImpl__f_elems).size__I() < 4)) {
    var this$1 = $n(this.sci_SetBuilderImpl__f_elems);
    this.sci_SetBuilderImpl__f_elems = $as_sci_Set(this$1.incl__O__sci_SetOps(elem));
  } else if ((!$n(this.sci_SetBuilderImpl__f_elems).contains__O__Z(elem))) {
    this.sci_SetBuilderImpl__f_switchedToHashSetBuilder = true;
    if ((this.sci_SetBuilderImpl__f_hashSetBuilder === null)) {
      this.sci_SetBuilderImpl__f_hashSetBuilder = new $c_sci_HashSetBuilder();
    }
    $n($as_sci_Set$Set4(this.sci_SetBuilderImpl__f_elems)).buildTo__scm_Builder__scm_Builder(this.sci_SetBuilderImpl__f_hashSetBuilder);
    $n(this.sci_SetBuilderImpl__f_hashSetBuilder).addOne__O__sci_HashSetBuilder(elem);
  }
  return this;
});
$c_sci_SetBuilderImpl.prototype.addAll__sc_IterableOnce__sci_SetBuilderImpl = (function(xs) {
  return (this.sci_SetBuilderImpl__f_switchedToHashSetBuilder ? ($n(this.sci_SetBuilderImpl__f_hashSetBuilder).addAll__sc_IterableOnce__sci_HashSetBuilder(xs), this) : $as_sci_SetBuilderImpl($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)));
});
$c_sci_SetBuilderImpl.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__sci_SetBuilderImpl(elems);
});
$c_sci_SetBuilderImpl.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_SetBuilderImpl(elem);
});
$c_sci_SetBuilderImpl.prototype.result__O = (function() {
  return this.result__sci_Set();
});
function $as_sci_SetBuilderImpl(obj) {
  return (((obj instanceof $c_sci_SetBuilderImpl) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SetBuilderImpl"));
}
function $isArrayOf_sci_SetBuilderImpl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SetBuilderImpl)));
}
function $asArrayOf_sci_SetBuilderImpl(obj, depth) {
  return (($isArrayOf_sci_SetBuilderImpl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SetBuilderImpl;", depth));
}
var $d_sci_SetBuilderImpl = new $TypeData().initClass($c_sci_SetBuilderImpl, "scala.collection.immutable.SetBuilderImpl", ({
  sci_SetBuilderImpl: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
/** @constructor */
function $c_sci_TreeSeqMap$$anon$1(outer) {
  this.sci_TreeSeqMap$$anon$1__f_iter = null;
  this.sci_TreeSeqMap$$anon$1__f_$outer = null;
  $n(outer);
  this.sci_TreeSeqMap$$anon$1__f_$outer = outer;
  this.sci_TreeSeqMap$$anon$1__f_iter = $n($n(outer).sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$ordering).iterator__sci_TreeSeqMap$Ordering$Iterator();
}
$c_sci_TreeSeqMap$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sci_TreeSeqMap$$anon$1.prototype.constructor = $c_sci_TreeSeqMap$$anon$1;
/** @constructor */
function $h_sci_TreeSeqMap$$anon$1() {
}
$h_sci_TreeSeqMap$$anon$1.prototype = $c_sci_TreeSeqMap$$anon$1.prototype;
$c_sci_TreeSeqMap$$anon$1.prototype.hasNext__Z = (function() {
  return $n(this.sci_TreeSeqMap$$anon$1__f_iter).hasNext__Z();
});
$c_sci_TreeSeqMap$$anon$1.prototype.next__T2 = (function() {
  var this$1 = $n(this.sci_TreeSeqMap$$anon$1__f_$outer);
  var k = $n(this.sci_TreeSeqMap$$anon$1__f_iter).next__O();
  var qual$1 = $as_T2($n(this$1.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$mapping).apply__O__O(k));
  var x$2 = $n(qual$1).copy$default$2__O();
  $n(qual$1);
  return new $c_T2(k, x$2);
});
$c_sci_TreeSeqMap$$anon$1.prototype.next__O = (function() {
  return this.next__T2();
});
var $d_sci_TreeSeqMap$$anon$1 = new $TypeData().initClass($c_sci_TreeSeqMap$$anon$1, "scala.collection.immutable.TreeSeqMap$$anon$1", ({
  sci_TreeSeqMap$$anon$1: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_TreeSeqMap$$anon$2(outer) {
  this.sci_TreeSeqMap$$anon$2__f_iter = null;
  this.sci_TreeSeqMap$$anon$2__f_iter = $n($n(outer).sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$ordering).iterator__sci_TreeSeqMap$Ordering$Iterator();
}
$c_sci_TreeSeqMap$$anon$2.prototype = new $h_sc_AbstractIterator();
$c_sci_TreeSeqMap$$anon$2.prototype.constructor = $c_sci_TreeSeqMap$$anon$2;
/** @constructor */
function $h_sci_TreeSeqMap$$anon$2() {
}
$h_sci_TreeSeqMap$$anon$2.prototype = $c_sci_TreeSeqMap$$anon$2.prototype;
$c_sci_TreeSeqMap$$anon$2.prototype.hasNext__Z = (function() {
  return $n(this.sci_TreeSeqMap$$anon$2__f_iter).hasNext__Z();
});
$c_sci_TreeSeqMap$$anon$2.prototype.next__O = (function() {
  return $n(this.sci_TreeSeqMap$$anon$2__f_iter).next__O();
});
var $d_sci_TreeSeqMap$$anon$2 = new $TypeData().initClass($c_sci_TreeSeqMap$$anon$2, "scala.collection.immutable.TreeSeqMap$$anon$2", ({
  sci_TreeSeqMap$$anon$2: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_TreeSeqMap$$anon$3(outer) {
  this.sci_TreeSeqMap$$anon$3__f_iter = null;
  this.sci_TreeSeqMap$$anon$3__f_$outer = null;
  $n(outer);
  this.sci_TreeSeqMap$$anon$3__f_$outer = outer;
  this.sci_TreeSeqMap$$anon$3__f_iter = $n($n(outer).sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$ordering).iterator__sci_TreeSeqMap$Ordering$Iterator();
}
$c_sci_TreeSeqMap$$anon$3.prototype = new $h_sc_AbstractIterator();
$c_sci_TreeSeqMap$$anon$3.prototype.constructor = $c_sci_TreeSeqMap$$anon$3;
/** @constructor */
function $h_sci_TreeSeqMap$$anon$3() {
}
$h_sci_TreeSeqMap$$anon$3.prototype = $c_sci_TreeSeqMap$$anon$3.prototype;
$c_sci_TreeSeqMap$$anon$3.prototype.hasNext__Z = (function() {
  return $n(this.sci_TreeSeqMap$$anon$3__f_iter).hasNext__Z();
});
$c_sci_TreeSeqMap$$anon$3.prototype.next__O = (function() {
  $n(this.sci_TreeSeqMap$$anon$3__f_$outer);
  var this$1 = $n(this.sci_TreeSeqMap$$anon$3__f_$outer);
  var k = $n(this.sci_TreeSeqMap$$anon$3__f_iter).next__O();
  var qual$1 = $as_T2($n(this$1.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$mapping).apply__O__O(k));
  var x$2 = $n(qual$1).copy$default$2__O();
  $n(qual$1);
  return x$2;
});
var $d_sci_TreeSeqMap$$anon$3 = new $TypeData().initClass($c_sci_TreeSeqMap$$anon$3, "scala.collection.immutable.TreeSeqMap$$anon$3", ({
  sci_TreeSeqMap$$anon$3: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_TreeSeqMap$OrderBy$Insertion$() {
}
$c_sci_TreeSeqMap$OrderBy$Insertion$.prototype = new $h_O();
$c_sci_TreeSeqMap$OrderBy$Insertion$.prototype.constructor = $c_sci_TreeSeqMap$OrderBy$Insertion$;
/** @constructor */
function $h_sci_TreeSeqMap$OrderBy$Insertion$() {
}
$h_sci_TreeSeqMap$OrderBy$Insertion$.prototype = $c_sci_TreeSeqMap$OrderBy$Insertion$.prototype;
$c_sci_TreeSeqMap$OrderBy$Insertion$.prototype.productPrefix__T = (function() {
  return "Insertion";
});
$c_sci_TreeSeqMap$OrderBy$Insertion$.prototype.productArity__I = (function() {
  return 0;
});
$c_sci_TreeSeqMap$OrderBy$Insertion$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1);
});
$c_sci_TreeSeqMap$OrderBy$Insertion$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_sci_TreeSeqMap$OrderBy$Insertion$.prototype.hashCode__I = (function() {
  return 1619512975;
});
$c_sci_TreeSeqMap$OrderBy$Insertion$.prototype.toString__T = (function() {
  return "Insertion";
});
var $d_sci_TreeSeqMap$OrderBy$Insertion$ = new $TypeData().initClass($c_sci_TreeSeqMap$OrderBy$Insertion$, "scala.collection.immutable.TreeSeqMap$OrderBy$Insertion$", ({
  sci_TreeSeqMap$OrderBy$Insertion$: 1,
  sci_TreeSeqMap$OrderBy: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_TreeSeqMap$OrderBy$Insertion$;
function $m_sci_TreeSeqMap$OrderBy$Insertion$() {
  if ((!$n_sci_TreeSeqMap$OrderBy$Insertion$)) {
    $n_sci_TreeSeqMap$OrderBy$Insertion$ = new $c_sci_TreeSeqMap$OrderBy$Insertion$();
  }
  return $n_sci_TreeSeqMap$OrderBy$Insertion$;
}
/** @constructor */
function $c_sci_TreeSeqMap$OrderBy$Modification$() {
}
$c_sci_TreeSeqMap$OrderBy$Modification$.prototype = new $h_O();
$c_sci_TreeSeqMap$OrderBy$Modification$.prototype.constructor = $c_sci_TreeSeqMap$OrderBy$Modification$;
/** @constructor */
function $h_sci_TreeSeqMap$OrderBy$Modification$() {
}
$h_sci_TreeSeqMap$OrderBy$Modification$.prototype = $c_sci_TreeSeqMap$OrderBy$Modification$.prototype;
$c_sci_TreeSeqMap$OrderBy$Modification$.prototype.productPrefix__T = (function() {
  return "Modification";
});
$c_sci_TreeSeqMap$OrderBy$Modification$.prototype.productArity__I = (function() {
  return 0;
});
$c_sci_TreeSeqMap$OrderBy$Modification$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1);
});
$c_sci_TreeSeqMap$OrderBy$Modification$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_sci_TreeSeqMap$OrderBy$Modification$.prototype.hashCode__I = (function() {
  return (-520280644);
});
$c_sci_TreeSeqMap$OrderBy$Modification$.prototype.toString__T = (function() {
  return "Modification";
});
var $d_sci_TreeSeqMap$OrderBy$Modification$ = new $TypeData().initClass($c_sci_TreeSeqMap$OrderBy$Modification$, "scala.collection.immutable.TreeSeqMap$OrderBy$Modification$", ({
  sci_TreeSeqMap$OrderBy$Modification$: 1,
  sci_TreeSeqMap$OrderBy: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_TreeSeqMap$OrderBy$Modification$;
function $m_sci_TreeSeqMap$OrderBy$Modification$() {
  if ((!$n_sci_TreeSeqMap$OrderBy$Modification$)) {
    $n_sci_TreeSeqMap$OrderBy$Modification$ = new $c_sci_TreeSeqMap$OrderBy$Modification$();
  }
  return $n_sci_TreeSeqMap$OrderBy$Modification$;
}
/** @constructor */
function $c_sci_TreeSeqMap$Ordering$Bin(prefix, mask, left, right) {
  this.sci_TreeSeqMap$Ordering$Bin__f_prefix = 0;
  this.sci_TreeSeqMap$Ordering$Bin__f_mask = 0;
  this.sci_TreeSeqMap$Ordering$Bin__f_left = null;
  this.sci_TreeSeqMap$Ordering$Bin__f_right = null;
  this.sci_TreeSeqMap$Ordering$Bin__f_prefix = prefix;
  this.sci_TreeSeqMap$Ordering$Bin__f_mask = mask;
  this.sci_TreeSeqMap$Ordering$Bin__f_left = left;
  this.sci_TreeSeqMap$Ordering$Bin__f_right = right;
}
$c_sci_TreeSeqMap$Ordering$Bin.prototype = new $h_sci_TreeSeqMap$Ordering();
$c_sci_TreeSeqMap$Ordering$Bin.prototype.constructor = $c_sci_TreeSeqMap$Ordering$Bin;
/** @constructor */
function $h_sci_TreeSeqMap$Ordering$Bin() {
}
$h_sci_TreeSeqMap$Ordering$Bin.prototype = $c_sci_TreeSeqMap$Ordering$Bin.prototype;
$c_sci_TreeSeqMap$Ordering$Bin.prototype.format__scm_StringBuilder__T__T__V = (function(sb, prefix, subPrefix) {
  var this$9 = $n(sb);
  var i = this.sci_TreeSeqMap$Ordering$Bin__f_prefix;
  var $x_1 = $as_T($uD((i >>> 0.0)).toString(2));
  var i$1 = this.sci_TreeSeqMap$Ordering$Bin__f_mask;
  var s = (((((prefix + "Bin(") + ((i + "/") + $x_1)) + ":") + ((i$1 + "/") + $as_T($uD((i$1 >>> 0.0)).toString(2)))) + ")\n");
  this$9.addAll__T__scm_StringBuilder(s);
  $n(this.sci_TreeSeqMap$Ordering$Bin__f_left).format__scm_StringBuilder__T__T__V(sb, (subPrefix + "\u251c\u2500\u2500 "), (subPrefix + "\u2502   "));
  $n(this.sci_TreeSeqMap$Ordering$Bin__f_right).format__scm_StringBuilder__T__T__V(sb, (subPrefix + "\u2514\u2500\u2500 "), (subPrefix + "    "));
});
$c_sci_TreeSeqMap$Ordering$Bin.prototype.productPrefix__T = (function() {
  return "Bin";
});
$c_sci_TreeSeqMap$Ordering$Bin.prototype.productArity__I = (function() {
  return 4;
});
$c_sci_TreeSeqMap$Ordering$Bin.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.sci_TreeSeqMap$Ordering$Bin__f_prefix;
      break;
    }
    case 1: {
      return this.sci_TreeSeqMap$Ordering$Bin__f_mask;
      break;
    }
    case 2: {
      return this.sci_TreeSeqMap$Ordering$Bin__f_left;
      break;
    }
    case 3: {
      return this.sci_TreeSeqMap$Ordering$Bin__f_right;
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_sci_TreeSeqMap$Ordering$Bin.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_sci_TreeSeqMap$Ordering$Bin.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Bin");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.sci_TreeSeqMap$Ordering$Bin__f_prefix;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.sci_TreeSeqMap$Ordering$Bin__f_mask;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x = this.sci_TreeSeqMap$Ordering$Bin__f_left;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$1 = this.sci_TreeSeqMap$Ordering$Bin__f_right;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4);
});
$c_sci_TreeSeqMap$Ordering$Bin.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_sci_TreeSeqMap$Ordering$Bin)) {
    var Bin$1 = $as_sci_TreeSeqMap$Ordering$Bin(x$1);
    if (((this.sci_TreeSeqMap$Ordering$Bin__f_prefix === $n(Bin$1).sci_TreeSeqMap$Ordering$Bin__f_prefix) && (this.sci_TreeSeqMap$Ordering$Bin__f_mask === $n(Bin$1).sci_TreeSeqMap$Ordering$Bin__f_mask))) {
      var x = this.sci_TreeSeqMap$Ordering$Bin__f_left;
      var x$2 = $n(Bin$1).sci_TreeSeqMap$Ordering$Bin__f_left;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.sci_TreeSeqMap$Ordering$Bin__f_right;
        var x$4 = $n(Bin$1).sci_TreeSeqMap$Ordering$Bin__f_right;
        return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
function $as_sci_TreeSeqMap$Ordering$Bin(obj) {
  return (((obj instanceof $c_sci_TreeSeqMap$Ordering$Bin) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.TreeSeqMap$Ordering$Bin"));
}
function $isArrayOf_sci_TreeSeqMap$Ordering$Bin(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_TreeSeqMap$Ordering$Bin)));
}
function $asArrayOf_sci_TreeSeqMap$Ordering$Bin(obj, depth) {
  return (($isArrayOf_sci_TreeSeqMap$Ordering$Bin(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.TreeSeqMap$Ordering$Bin;", depth));
}
var $d_sci_TreeSeqMap$Ordering$Bin = new $TypeData().initClass($c_sci_TreeSeqMap$Ordering$Bin, "scala.collection.immutable.TreeSeqMap$Ordering$Bin", ({
  sci_TreeSeqMap$Ordering$Bin: 1,
  sci_TreeSeqMap$Ordering: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_TreeSeqMap$Ordering$Tip(ord, value) {
  this.sci_TreeSeqMap$Ordering$Tip__f_ord = 0;
  this.sci_TreeSeqMap$Ordering$Tip__f_value = null;
  this.sci_TreeSeqMap$Ordering$Tip__f_ord = ord;
  this.sci_TreeSeqMap$Ordering$Tip__f_value = value;
}
$c_sci_TreeSeqMap$Ordering$Tip.prototype = new $h_sci_TreeSeqMap$Ordering();
$c_sci_TreeSeqMap$Ordering$Tip.prototype.constructor = $c_sci_TreeSeqMap$Ordering$Tip;
/** @constructor */
function $h_sci_TreeSeqMap$Ordering$Tip() {
}
$h_sci_TreeSeqMap$Ordering$Tip.prototype = $c_sci_TreeSeqMap$Ordering$Tip.prototype;
$c_sci_TreeSeqMap$Ordering$Tip.prototype.format__scm_StringBuilder__T__T__V = (function(sb, prefix, subPrefix) {
  var this$5 = $n(sb);
  var i = this.sci_TreeSeqMap$Ordering$Tip__f_ord;
  var s = (((((prefix + "Tip(") + ((i + "/") + $as_T($uD((i >>> 0.0)).toString(2)))) + " -> ") + this.sci_TreeSeqMap$Ordering$Tip__f_value) + ")\n");
  this$5.addAll__T__scm_StringBuilder(s);
});
$c_sci_TreeSeqMap$Ordering$Tip.prototype.productPrefix__T = (function() {
  return "Tip";
});
$c_sci_TreeSeqMap$Ordering$Tip.prototype.productArity__I = (function() {
  return 2;
});
$c_sci_TreeSeqMap$Ordering$Tip.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.sci_TreeSeqMap$Ordering$Tip__f_ord;
      break;
    }
    case 1: {
      return this.sci_TreeSeqMap$Ordering$Tip__f_value;
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_sci_TreeSeqMap$Ordering$Tip.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_sci_TreeSeqMap$Ordering$Tip.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Tip");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.sci_TreeSeqMap$Ordering$Tip__f_ord;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.sci_TreeSeqMap$Ordering$Tip__f_value;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
});
$c_sci_TreeSeqMap$Ordering$Tip.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_sci_TreeSeqMap$Ordering$Tip)) {
    var Tip$1 = $as_sci_TreeSeqMap$Ordering$Tip(x$1);
    return ((this.sci_TreeSeqMap$Ordering$Tip__f_ord === $n(Tip$1).sci_TreeSeqMap$Ordering$Tip__f_ord) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.sci_TreeSeqMap$Ordering$Tip__f_value, $n(Tip$1).sci_TreeSeqMap$Ordering$Tip__f_value));
  } else {
    return false;
  }
});
function $as_sci_TreeSeqMap$Ordering$Tip(obj) {
  return (((obj instanceof $c_sci_TreeSeqMap$Ordering$Tip) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.TreeSeqMap$Ordering$Tip"));
}
function $isArrayOf_sci_TreeSeqMap$Ordering$Tip(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_TreeSeqMap$Ordering$Tip)));
}
function $asArrayOf_sci_TreeSeqMap$Ordering$Tip(obj, depth) {
  return (($isArrayOf_sci_TreeSeqMap$Ordering$Tip(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.TreeSeqMap$Ordering$Tip;", depth));
}
var $d_sci_TreeSeqMap$Ordering$Tip = new $TypeData().initClass($c_sci_TreeSeqMap$Ordering$Tip, "scala.collection.immutable.TreeSeqMap$Ordering$Tip", ({
  sci_TreeSeqMap$Ordering$Tip: 1,
  sci_TreeSeqMap$Ordering: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_TreeSeqMap$Ordering$Zero$() {
}
$c_sci_TreeSeqMap$Ordering$Zero$.prototype = new $h_sci_TreeSeqMap$Ordering();
$c_sci_TreeSeqMap$Ordering$Zero$.prototype.constructor = $c_sci_TreeSeqMap$Ordering$Zero$;
/** @constructor */
function $h_sci_TreeSeqMap$Ordering$Zero$() {
}
$h_sci_TreeSeqMap$Ordering$Zero$.prototype = $c_sci_TreeSeqMap$Ordering$Zero$.prototype;
$c_sci_TreeSeqMap$Ordering$Zero$.prototype.equals__O__Z = (function(that) {
  return ((that === this) || ((!(that instanceof $c_sci_TreeSeqMap$Ordering)) && (this === that)));
});
$c_sci_TreeSeqMap$Ordering$Zero$.prototype.format__scm_StringBuilder__T__T__V = (function(sb, prefix, subPrefix) {
  var this$1 = $n(sb);
  var s = (prefix + "\u00d8");
  this$1.addAll__T__scm_StringBuilder(s);
});
$c_sci_TreeSeqMap$Ordering$Zero$.prototype.productPrefix__T = (function() {
  return "Zero";
});
$c_sci_TreeSeqMap$Ordering$Zero$.prototype.productArity__I = (function() {
  return 0;
});
$c_sci_TreeSeqMap$Ordering$Zero$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1);
});
$c_sci_TreeSeqMap$Ordering$Zero$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_sci_TreeSeqMap$Ordering$Zero$.prototype.hashCode__I = (function() {
  return 2781896;
});
var $d_sci_TreeSeqMap$Ordering$Zero$ = new $TypeData().initClass($c_sci_TreeSeqMap$Ordering$Zero$, "scala.collection.immutable.TreeSeqMap$Ordering$Zero$", ({
  sci_TreeSeqMap$Ordering$Zero$: 1,
  sci_TreeSeqMap$Ordering: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_TreeSeqMap$Ordering$Zero$;
function $m_sci_TreeSeqMap$Ordering$Zero$() {
  if ((!$n_sci_TreeSeqMap$Ordering$Zero$)) {
    $n_sci_TreeSeqMap$Ordering$Zero$ = new $c_sci_TreeSeqMap$Ordering$Zero$();
  }
  return $n_sci_TreeSeqMap$Ordering$Zero$;
}
function $p_sci_Vector$__liftedTree1$1__I($thiz) {
  try {
    var x = $m_jl_System$SystemProperties$().getProperty__T__T__T("scala.collection.immutable.Vector.defaultApplyPreferredMaxLength", "250");
    var this$4 = $m_jl_Integer$();
    return this$4.parseInt__T__I__I(x, 10);
  } catch (e) {
    if (false) {
      return 250;
    } else {
      throw e;
    }
  }
}
/** @constructor */
function $c_sci_Vector$() {
  this.sci_Vector$__f_scala$collection$immutable$Vector$$defaultApplyPreferredMaxLength = 0;
  this.sci_Vector$__f_scala$collection$immutable$Vector$$emptyIterator = null;
  $n_sci_Vector$ = this;
  this.sci_Vector$__f_scala$collection$immutable$Vector$$defaultApplyPreferredMaxLength = $p_sci_Vector$__liftedTree1$1__I(this);
  this.sci_Vector$__f_scala$collection$immutable$Vector$$emptyIterator = new $c_sci_NewVectorIterator($m_sci_Vector0$(), 0, 0);
}
$c_sci_Vector$.prototype = new $h_O();
$c_sci_Vector$.prototype.constructor = $c_sci_Vector$;
/** @constructor */
function $h_sci_Vector$() {
}
$h_sci_Vector$.prototype = $c_sci_Vector$.prototype;
$c_sci_Vector$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_Vector(elems);
});
$c_sci_Vector$.prototype.from__sc_IterableOnce__sci_Vector = (function(it) {
  if ((it instanceof $c_sci_Vector)) {
    var x2 = $as_sci_Vector(it);
    return x2;
  } else {
    var knownSize = $n(it).knownSize__I();
    if ((knownSize === 0)) {
      return $m_sci_Vector0$();
    } else if (((knownSize > 0) && (knownSize <= 32))) {
      matchEnd5: {
        var a1$3;
        if ((it instanceof $c_sci_ArraySeq$ofRef)) {
          var x2$2 = $as_sci_ArraySeq$ofRef(it);
          var x = $n($n(x2$2).elemTag__s_reflect_ClassTag()).runtimeClass__jl_Class();
          if ((x !== null)) {
            var this$1 = $n(x);
            var $x_1 = (this$1 === $d_O.getClassOf());
          } else {
            var $x_1 = false;
          }
          if ($x_1) {
            var a1$3 = $n(x2$2).sci_ArraySeq$ofRef__f_unsafeArray;
            break matchEnd5;
          }
        }
        if ($is_sci_Iterable(it)) {
          var x3 = $as_sci_Iterable(it);
          var a1 = new $ac_O(knownSize);
          var this$2 = $n(x3);
          this$2.copyToArray__O__I__I__I(a1, 0, 2147483647);
          var a1$3 = a1;
          break matchEnd5;
        }
        var a1$2 = new $ac_O(knownSize);
        var this$3 = $n($n(it).iterator__sc_Iterator());
        this$3.copyToArray__O__I__I__I(a1$2, 0, 2147483647);
        var a1$3 = a1$2;
      }
      return new $c_sci_Vector1(a1$3);
    } else {
      var this$4 = new $c_sci_VectorBuilder();
      var this$5 = $n(this$4.addAll__sc_IterableOnce__sci_VectorBuilder(it));
      return this$5.result__sci_Vector();
    }
  }
});
$c_sci_Vector$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_VectorBuilder();
});
$c_sci_Vector$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Vector(source);
});
$c_sci_Vector$.prototype.empty__O = (function() {
  return $m_sci_Vector0$();
});
var $d_sci_Vector$ = new $TypeData().initClass($c_sci_Vector$, "scala.collection.immutable.Vector$", ({
  sci_Vector$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_Vector$;
function $m_sci_Vector$() {
  if ((!$n_sci_Vector$)) {
    $n_sci_Vector$ = new $c_sci_Vector$();
  }
  return $n_sci_Vector$;
}
function $p_sci_VectorBuilder__leftAlignPrefix__V($thiz) {
  var a = null;
  var aParent = null;
  if (($thiz.sci_VectorBuilder__f_depth >= 6)) {
    a = $thiz.sci_VectorBuilder__f_a6;
    var i = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset >>> 25) | 0);
    if ((i > 0)) {
      var src = a;
      var dest = a;
      var length = ((64 - i) | 0);
      $systemArraycopyRefs($n(src), i, $n(dest), 0, length);
    }
    var newOffset = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset % 33554432) | 0);
    $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest - (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset - newOffset) | 0)) | 0);
    $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = newOffset;
    if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 25) | 0) === 0)) {
      $thiz.sci_VectorBuilder__f_depth = 5;
    }
    aParent = a;
    a = $asArrayOf_O($n(a).get(0), 1);
  }
  if (($thiz.sci_VectorBuilder__f_depth >= 5)) {
    if ((a === null)) {
      a = $thiz.sci_VectorBuilder__f_a5;
    }
    var i$2 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset >>> 20) | 0));
    if (($thiz.sci_VectorBuilder__f_depth === 5)) {
      if ((i$2 > 0)) {
        var src$1 = a;
        var dest$1 = a;
        var length$1 = ((32 - i$2) | 0);
        $systemArraycopyRefs($n(src$1), i$2, $n(dest$1), 0, length$1);
      }
      $thiz.sci_VectorBuilder__f_a5 = $asArrayOf_O(a, 5);
      var newOffset$1 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset % 1048576) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest - (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset - newOffset$1) | 0)) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = newOffset$1;
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 20) | 0) === 0)) {
        $thiz.sci_VectorBuilder__f_depth = 4;
      }
    } else {
      if ((i$2 > 0)) {
        var original = a;
        a = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(original, i$2, 32);
      }
      $n(aParent).set(0, a);
    }
    aParent = a;
    a = $asArrayOf_O($n(a).get(0), 1);
  }
  if (($thiz.sci_VectorBuilder__f_depth >= 4)) {
    if ((a === null)) {
      a = $thiz.sci_VectorBuilder__f_a4;
    }
    var i$3 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset >>> 15) | 0));
    if (($thiz.sci_VectorBuilder__f_depth === 4)) {
      if ((i$3 > 0)) {
        var src$2 = a;
        var dest$2 = a;
        var length$2 = ((32 - i$3) | 0);
        $systemArraycopyRefs($n(src$2), i$3, $n(dest$2), 0, length$2);
      }
      $thiz.sci_VectorBuilder__f_a4 = $asArrayOf_O(a, 4);
      var newOffset$2 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset % 32768) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest - (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset - newOffset$2) | 0)) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = newOffset$2;
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 15) | 0) === 0)) {
        $thiz.sci_VectorBuilder__f_depth = 3;
      }
    } else {
      if ((i$3 > 0)) {
        var original$1 = a;
        a = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$1, i$3, 32);
      }
      $n(aParent).set(0, a);
    }
    aParent = a;
    a = $asArrayOf_O($n(a).get(0), 1);
  }
  if (($thiz.sci_VectorBuilder__f_depth >= 3)) {
    if ((a === null)) {
      a = $thiz.sci_VectorBuilder__f_a3;
    }
    var i$4 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset >>> 10) | 0));
    if (($thiz.sci_VectorBuilder__f_depth === 3)) {
      if ((i$4 > 0)) {
        var src$3 = a;
        var dest$3 = a;
        var length$3 = ((32 - i$4) | 0);
        $systemArraycopyRefs($n(src$3), i$4, $n(dest$3), 0, length$3);
      }
      $thiz.sci_VectorBuilder__f_a3 = $asArrayOf_O(a, 3);
      var newOffset$3 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset % 1024) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest - (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset - newOffset$3) | 0)) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = newOffset$3;
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 10) | 0) === 0)) {
        $thiz.sci_VectorBuilder__f_depth = 2;
      }
    } else {
      if ((i$4 > 0)) {
        var original$2 = a;
        a = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$2, i$4, 32);
      }
      $n(aParent).set(0, a);
    }
    aParent = a;
    a = $asArrayOf_O($n(a).get(0), 1);
  }
  if (($thiz.sci_VectorBuilder__f_depth >= 2)) {
    if ((a === null)) {
      a = $thiz.sci_VectorBuilder__f_a2;
    }
    var i$5 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset >>> 5) | 0));
    if (($thiz.sci_VectorBuilder__f_depth === 2)) {
      if ((i$5 > 0)) {
        var src$4 = a;
        var dest$4 = a;
        var length$4 = ((32 - i$5) | 0);
        $systemArraycopyRefs($n(src$4), i$5, $n(dest$4), 0, length$4);
      }
      $thiz.sci_VectorBuilder__f_a2 = $asArrayOf_O(a, 2);
      var newOffset$4 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset % 32) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest - (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset - newOffset$4) | 0)) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = newOffset$4;
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 5) | 0) === 0)) {
        $thiz.sci_VectorBuilder__f_depth = 1;
      }
    } else {
      if ((i$5 > 0)) {
        var original$3 = a;
        a = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$3, i$5, 32);
      }
      $n(aParent).set(0, a);
    }
    aParent = a;
    a = $asArrayOf_O($n(a).get(0), 1);
  }
  if (($thiz.sci_VectorBuilder__f_depth >= 1)) {
    if ((a === null)) {
      a = $thiz.sci_VectorBuilder__f_a1;
    }
    var i$6 = (31 & $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset);
    if (($thiz.sci_VectorBuilder__f_depth === 1)) {
      if ((i$6 > 0)) {
        var src$5 = a;
        var dest$5 = a;
        var length$5 = ((32 - i$6) | 0);
        $systemArraycopyRefs($n(src$5), i$6, $n(dest$5), 0, length$5);
      }
      $thiz.sci_VectorBuilder__f_a1 = a;
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = 0;
    } else {
      if ((i$6 > 0)) {
        var original$4 = a;
        a = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$4, i$6, 32);
      }
      $n(aParent).set(0, a);
    }
  }
  $thiz.sci_VectorBuilder__f_prefixIsRightAligned = false;
}
function $p_sci_VectorBuilder__addArr1__AO__V($thiz, data) {
  var dl = $n(data).u.length;
  if ((dl > 0)) {
    if (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 32)) {
      $p_sci_VectorBuilder__advance__V($thiz);
    }
    var a = ((32 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
    var copy1 = ((a < dl) ? a : dl);
    var copy2 = ((dl - copy1) | 0);
    var dest = $thiz.sci_VectorBuilder__f_a1;
    var destPos = $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1;
    $systemArraycopyRefs($n(data), 0, $n(dest), destPos, copy1);
    $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 + copy1) | 0);
    if ((copy2 > 0)) {
      $p_sci_VectorBuilder__advance__V($thiz);
      var dest$1 = $thiz.sci_VectorBuilder__f_a1;
      $systemArraycopyRefs($n(data), copy1, $n(dest$1), 0, copy2);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 + copy2) | 0);
    }
  }
}
function $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, slice, dim) {
  if (($n(slice).u.length === 0)) {
    return (void 0);
  }
  if (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 32)) {
    $p_sci_VectorBuilder__advance__V($thiz);
  }
  var sl = $n(slice).u.length;
  switch (dim) {
    case 2: {
      var a = (31 & ((((1024 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0) >>> 5) | 0));
      var copy1 = ((a < sl) ? a : sl);
      var copy2 = ((sl - copy1) | 0);
      var destPos = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 5) | 0));
      var dest = $thiz.sci_VectorBuilder__f_a2;
      $systemArraycopyRefs($n(slice), 0, $n(dest), destPos, copy1);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy1 << 5));
      if ((copy2 > 0)) {
        var dest$1 = $thiz.sci_VectorBuilder__f_a2;
        $systemArraycopyRefs($n(slice), copy1, $n(dest$1), 0, copy2);
        $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy2 << 5));
      }
      break;
    }
    case 3: {
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest % 1024) | 0) !== 0)) {
        var f = ((e$2) => {
          $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, $asArrayOf_O(e$2, 1), 2);
        });
        var len = $n(slice).u.length;
        var i = 0;
        if ((slice !== null)) {
          while ((i < len)) {
            var arg1 = $n(slice).get(i);
            f(arg1);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_I)) {
          var x3 = $asArrayOf_I(slice, 1);
          while ((i < len)) {
            var arg1$1 = $n(x3).get(i);
            f(arg1$1);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_D)) {
          var x4 = $asArrayOf_D(slice, 1);
          while ((i < len)) {
            var arg1$2 = $n(x4).get(i);
            f(arg1$2);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_J)) {
          var x5 = $asArrayOf_J(slice, 1);
          while ((i < len)) {
            var t = $n(x5).get(i);
            var lo = t.RTLong__f_lo;
            var hi = t.RTLong__f_hi;
            f(new $c_RTLong(lo, hi));
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_F)) {
          var x6 = $asArrayOf_F(slice, 1);
          while ((i < len)) {
            var arg1$3 = $n(x6).get(i);
            f(arg1$3);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_C)) {
          var x7 = $asArrayOf_C(slice, 1);
          while ((i < len)) {
            var arg1$4 = $n(x7).get(i);
            f($bC(arg1$4));
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_B)) {
          var x8 = $asArrayOf_B(slice, 1);
          while ((i < len)) {
            var arg1$5 = $n(x8).get(i);
            f(arg1$5);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_S)) {
          var x9 = $asArrayOf_S(slice, 1);
          while ((i < len)) {
            var arg1$6 = $n(x9).get(i);
            f(arg1$6);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_Z)) {
          var x10 = $asArrayOf_Z(slice, 1);
          while ((i < len)) {
            var arg1$7 = $n(x10).get(i);
            f(arg1$7);
            i = ((1 + i) | 0);
          }
        } else {
          throw new $c_s_MatchError(slice);
        }
        return (void 0);
      }
      var a$1 = (31 & ((((32768 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0) >>> 10) | 0));
      var copy1$2 = ((a$1 < sl) ? a$1 : sl);
      var copy2$2 = ((sl - copy1$2) | 0);
      var destPos$2 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 10) | 0));
      var dest$2 = $thiz.sci_VectorBuilder__f_a3;
      $systemArraycopyRefs($n(slice), 0, $n(dest$2), destPos$2, copy1$2);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy1$2 << 10));
      if ((copy2$2 > 0)) {
        var dest$3 = $thiz.sci_VectorBuilder__f_a3;
        $systemArraycopyRefs($n(slice), copy1$2, $n(dest$3), 0, copy2$2);
        $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy2$2 << 10));
      }
      break;
    }
    case 4: {
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest % 32768) | 0) !== 0)) {
        var f$1 = ((e$3$2) => {
          $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, $asArrayOf_O(e$3$2, 1), 3);
        });
        var len$1 = $n(slice).u.length;
        var i$1 = 0;
        if ((slice !== null)) {
          while ((i$1 < len$1)) {
            var arg1$8 = $n(slice).get(i$1);
            f$1(arg1$8);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_I)) {
          var x3$1 = $asArrayOf_I(slice, 1);
          while ((i$1 < len$1)) {
            var arg1$9 = $n(x3$1).get(i$1);
            f$1(arg1$9);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_D)) {
          var x4$1 = $asArrayOf_D(slice, 1);
          while ((i$1 < len$1)) {
            var arg1$10 = $n(x4$1).get(i$1);
            f$1(arg1$10);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_J)) {
          var x5$1 = $asArrayOf_J(slice, 1);
          while ((i$1 < len$1)) {
            var t$1 = $n(x5$1).get(i$1);
            var lo$1 = t$1.RTLong__f_lo;
            var hi$1 = t$1.RTLong__f_hi;
            f$1(new $c_RTLong(lo$1, hi$1));
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_F)) {
          var x6$1 = $asArrayOf_F(slice, 1);
          while ((i$1 < len$1)) {
            var arg1$11 = $n(x6$1).get(i$1);
            f$1(arg1$11);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_C)) {
          var x7$1 = $asArrayOf_C(slice, 1);
          while ((i$1 < len$1)) {
            var arg1$12 = $n(x7$1).get(i$1);
            f$1($bC(arg1$12));
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_B)) {
          var x8$1 = $asArrayOf_B(slice, 1);
          while ((i$1 < len$1)) {
            var arg1$13 = $n(x8$1).get(i$1);
            f$1(arg1$13);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_S)) {
          var x9$1 = $asArrayOf_S(slice, 1);
          while ((i$1 < len$1)) {
            var arg1$14 = $n(x9$1).get(i$1);
            f$1(arg1$14);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_Z)) {
          var x10$1 = $asArrayOf_Z(slice, 1);
          while ((i$1 < len$1)) {
            var arg1$15 = $n(x10$1).get(i$1);
            f$1(arg1$15);
            i$1 = ((1 + i$1) | 0);
          }
        } else {
          throw new $c_s_MatchError(slice);
        }
        return (void 0);
      }
      var a$2 = (31 & ((((1048576 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0) >>> 15) | 0));
      var copy1$3 = ((a$2 < sl) ? a$2 : sl);
      var copy2$3 = ((sl - copy1$3) | 0);
      var destPos$3 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 15) | 0));
      var dest$4 = $thiz.sci_VectorBuilder__f_a4;
      $systemArraycopyRefs($n(slice), 0, $n(dest$4), destPos$3, copy1$3);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy1$3 << 15));
      if ((copy2$3 > 0)) {
        var dest$5 = $thiz.sci_VectorBuilder__f_a4;
        $systemArraycopyRefs($n(slice), copy1$3, $n(dest$5), 0, copy2$3);
        $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy2$3 << 15));
      }
      break;
    }
    case 5: {
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest % 1048576) | 0) !== 0)) {
        var f$2 = ((e$4$2) => {
          $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, $asArrayOf_O(e$4$2, 1), 4);
        });
        var len$2 = $n(slice).u.length;
        var i$2 = 0;
        if ((slice !== null)) {
          while ((i$2 < len$2)) {
            var arg1$16 = $n(slice).get(i$2);
            f$2(arg1$16);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_I)) {
          var x3$2 = $asArrayOf_I(slice, 1);
          while ((i$2 < len$2)) {
            var arg1$17 = $n(x3$2).get(i$2);
            f$2(arg1$17);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_D)) {
          var x4$2 = $asArrayOf_D(slice, 1);
          while ((i$2 < len$2)) {
            var arg1$18 = $n(x4$2).get(i$2);
            f$2(arg1$18);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_J)) {
          var x5$2 = $asArrayOf_J(slice, 1);
          while ((i$2 < len$2)) {
            var t$2 = $n(x5$2).get(i$2);
            var lo$2 = t$2.RTLong__f_lo;
            var hi$2 = t$2.RTLong__f_hi;
            f$2(new $c_RTLong(lo$2, hi$2));
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_F)) {
          var x6$2 = $asArrayOf_F(slice, 1);
          while ((i$2 < len$2)) {
            var arg1$19 = $n(x6$2).get(i$2);
            f$2(arg1$19);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_C)) {
          var x7$2 = $asArrayOf_C(slice, 1);
          while ((i$2 < len$2)) {
            var arg1$20 = $n(x7$2).get(i$2);
            f$2($bC(arg1$20));
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_B)) {
          var x8$2 = $asArrayOf_B(slice, 1);
          while ((i$2 < len$2)) {
            var arg1$21 = $n(x8$2).get(i$2);
            f$2(arg1$21);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_S)) {
          var x9$2 = $asArrayOf_S(slice, 1);
          while ((i$2 < len$2)) {
            var arg1$22 = $n(x9$2).get(i$2);
            f$2(arg1$22);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_Z)) {
          var x10$2 = $asArrayOf_Z(slice, 1);
          while ((i$2 < len$2)) {
            var arg1$23 = $n(x10$2).get(i$2);
            f$2(arg1$23);
            i$2 = ((1 + i$2) | 0);
          }
        } else {
          throw new $c_s_MatchError(slice);
        }
        return (void 0);
      }
      var a$3 = (31 & ((((33554432 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0) >>> 20) | 0));
      var copy1$4 = ((a$3 < sl) ? a$3 : sl);
      var copy2$4 = ((sl - copy1$4) | 0);
      var destPos$4 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 20) | 0));
      var dest$6 = $thiz.sci_VectorBuilder__f_a5;
      $systemArraycopyRefs($n(slice), 0, $n(dest$6), destPos$4, copy1$4);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy1$4 << 20));
      if ((copy2$4 > 0)) {
        var dest$7 = $thiz.sci_VectorBuilder__f_a5;
        $systemArraycopyRefs($n(slice), copy1$4, $n(dest$7), 0, copy2$4);
        $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy2$4 << 20));
      }
      break;
    }
    case 6: {
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest % 33554432) | 0) !== 0)) {
        var f$3 = ((e$5$2) => {
          $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, $asArrayOf_O(e$5$2, 1), 5);
        });
        var len$3 = $n(slice).u.length;
        var i$3 = 0;
        if ((slice !== null)) {
          while ((i$3 < len$3)) {
            var arg1$24 = $n(slice).get(i$3);
            f$3(arg1$24);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_I)) {
          var x3$3 = $asArrayOf_I(slice, 1);
          while ((i$3 < len$3)) {
            var arg1$25 = $n(x3$3).get(i$3);
            f$3(arg1$25);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_D)) {
          var x4$3 = $asArrayOf_D(slice, 1);
          while ((i$3 < len$3)) {
            var arg1$26 = $n(x4$3).get(i$3);
            f$3(arg1$26);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_J)) {
          var x5$3 = $asArrayOf_J(slice, 1);
          while ((i$3 < len$3)) {
            var t$3 = $n(x5$3).get(i$3);
            var lo$3 = t$3.RTLong__f_lo;
            var hi$3 = t$3.RTLong__f_hi;
            f$3(new $c_RTLong(lo$3, hi$3));
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_F)) {
          var x6$3 = $asArrayOf_F(slice, 1);
          while ((i$3 < len$3)) {
            var arg1$27 = $n(x6$3).get(i$3);
            f$3(arg1$27);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_C)) {
          var x7$3 = $asArrayOf_C(slice, 1);
          while ((i$3 < len$3)) {
            var arg1$28 = $n(x7$3).get(i$3);
            f$3($bC(arg1$28));
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_B)) {
          var x8$3 = $asArrayOf_B(slice, 1);
          while ((i$3 < len$3)) {
            var arg1$29 = $n(x8$3).get(i$3);
            f$3(arg1$29);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_S)) {
          var x9$3 = $asArrayOf_S(slice, 1);
          while ((i$3 < len$3)) {
            var arg1$30 = $n(x9$3).get(i$3);
            f$3(arg1$30);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_Z)) {
          var x10$3 = $asArrayOf_Z(slice, 1);
          while ((i$3 < len$3)) {
            var arg1$31 = $n(x10$3).get(i$3);
            f$3(arg1$31);
            i$3 = ((1 + i$3) | 0);
          }
        } else {
          throw new $c_s_MatchError(slice);
        }
        return (void 0);
      }
      var destPos$5 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 25) | 0);
      if ((((destPos$5 + sl) | 0) > 64)) {
        throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "exceeding 2^31 elements");
      }
      var dest$8 = $thiz.sci_VectorBuilder__f_a6;
      $systemArraycopyRefs($n(slice), 0, $n(dest$8), destPos$5, sl);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (sl << 25));
      break;
    }
    default: {
      throw new $c_s_MatchError(dim);
    }
  }
}
function $p_sci_VectorBuilder__addVector__sci_Vector__sci_VectorBuilder($thiz, xs) {
  var sliceCount = $n(xs).vectorSliceCount__I();
  var sliceIdx = 0;
  while ((sliceIdx < sliceCount)) {
    var slice = $n(xs).vectorSlice__I__AO(sliceIdx);
    var idx = sliceIdx;
    var c = ((sliceCount / 2) | 0);
    var a = ((idx - c) | 0);
    var x1 = ((((1 + c) | 0) - ((a < 0) ? ((-a) | 0) : a)) | 0);
    if ((x1 === 1)) {
      $p_sci_VectorBuilder__addArr1__AO__V($thiz, slice);
    } else if ((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 32) || ($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 0))) {
      $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, slice, x1);
    } else {
      $m_sci_VectorStatics$().foreachRec__I__AO__F1__V((((-2) + x1) | 0), slice, new $c_sjsr_AnonFunction1(((data$2) => {
        var data = $asArrayOf_O(data$2, 1);
        $p_sci_VectorBuilder__addArr1__AO__V($thiz, data);
      })));
    }
    sliceIdx = ((1 + sliceIdx) | 0);
  }
  return $thiz;
}
function $p_sci_VectorBuilder__advance__V($thiz) {
  var idx = ((32 + $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0);
  var xor = (idx ^ $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest);
  $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = idx;
  $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 0;
  $p_sci_VectorBuilder__advance1__I__I__V($thiz, idx, xor);
}
function $p_sci_VectorBuilder__advanceN__I__V($thiz, n) {
  if ((n > 0)) {
    var idx = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest + n) | 0);
    var xor = (idx ^ $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest);
    $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = idx;
    $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 0;
    $p_sci_VectorBuilder__advance1__I__I__V($thiz, idx, xor);
  }
}
function $p_sci_VectorBuilder__advance1__I__I__V($thiz, idx, xor) {
  if ((xor <= 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((((((((((((((((("advance1(" + idx) + ", ") + xor) + "): a1=") + $thiz.sci_VectorBuilder__f_a1) + ", a2=") + $thiz.sci_VectorBuilder__f_a2) + ", a3=") + $thiz.sci_VectorBuilder__f_a3) + ", a4=") + $thiz.sci_VectorBuilder__f_a4) + ", a5=") + $thiz.sci_VectorBuilder__f_a5) + ", a6=") + $thiz.sci_VectorBuilder__f_a6) + ", depth=") + $thiz.sci_VectorBuilder__f_depth));
  } else if ((xor < 1024)) {
    if (($thiz.sci_VectorBuilder__f_depth <= 1)) {
      $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
      $n($thiz.sci_VectorBuilder__f_a2).set(0, $thiz.sci_VectorBuilder__f_a1);
      $thiz.sci_VectorBuilder__f_depth = 2;
    }
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $n($thiz.sci_VectorBuilder__f_a2).set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1);
  } else if ((xor < 32768)) {
    if (($thiz.sci_VectorBuilder__f_depth <= 2)) {
      $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $n($thiz.sci_VectorBuilder__f_a3).set(0, $thiz.sci_VectorBuilder__f_a2);
      $thiz.sci_VectorBuilder__f_depth = 3;
    }
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $n($thiz.sci_VectorBuilder__f_a2).set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1);
    $n($thiz.sci_VectorBuilder__f_a3).set((31 & ((idx >>> 10) | 0)), $thiz.sci_VectorBuilder__f_a2);
  } else if ((xor < 1048576)) {
    if (($thiz.sci_VectorBuilder__f_depth <= 3)) {
      $thiz.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $n($thiz.sci_VectorBuilder__f_a4).set(0, $thiz.sci_VectorBuilder__f_a3);
      $thiz.sci_VectorBuilder__f_depth = 4;
    }
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $n($thiz.sci_VectorBuilder__f_a2).set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1);
    $n($thiz.sci_VectorBuilder__f_a3).set((31 & ((idx >>> 10) | 0)), $thiz.sci_VectorBuilder__f_a2);
    $n($thiz.sci_VectorBuilder__f_a4).set((31 & ((idx >>> 15) | 0)), $thiz.sci_VectorBuilder__f_a3);
  } else if ((xor < 33554432)) {
    if (($thiz.sci_VectorBuilder__f_depth <= 4)) {
      $thiz.sci_VectorBuilder__f_a5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $n($thiz.sci_VectorBuilder__f_a5).set(0, $thiz.sci_VectorBuilder__f_a4);
      $thiz.sci_VectorBuilder__f_depth = 5;
    }
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $n($thiz.sci_VectorBuilder__f_a2).set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1);
    $n($thiz.sci_VectorBuilder__f_a3).set((31 & ((idx >>> 10) | 0)), $thiz.sci_VectorBuilder__f_a2);
    $n($thiz.sci_VectorBuilder__f_a4).set((31 & ((idx >>> 15) | 0)), $thiz.sci_VectorBuilder__f_a3);
    $n($thiz.sci_VectorBuilder__f_a5).set((31 & ((idx >>> 20) | 0)), $thiz.sci_VectorBuilder__f_a4);
  } else {
    if (($thiz.sci_VectorBuilder__f_depth <= 5)) {
      $thiz.sci_VectorBuilder__f_a6 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(64);
      $n($thiz.sci_VectorBuilder__f_a6).set(0, $thiz.sci_VectorBuilder__f_a5);
      $thiz.sci_VectorBuilder__f_depth = 6;
    }
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $n($thiz.sci_VectorBuilder__f_a2).set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1);
    $n($thiz.sci_VectorBuilder__f_a3).set((31 & ((idx >>> 10) | 0)), $thiz.sci_VectorBuilder__f_a2);
    $n($thiz.sci_VectorBuilder__f_a4).set((31 & ((idx >>> 15) | 0)), $thiz.sci_VectorBuilder__f_a3);
    $n($thiz.sci_VectorBuilder__f_a5).set((31 & ((idx >>> 20) | 0)), $thiz.sci_VectorBuilder__f_a4);
    $n($thiz.sci_VectorBuilder__f_a6).set(((idx >>> 25) | 0), $thiz.sci_VectorBuilder__f_a5);
  }
}
/** @constructor */
function $c_sci_VectorBuilder() {
  this.sci_VectorBuilder__f_a6 = null;
  this.sci_VectorBuilder__f_a5 = null;
  this.sci_VectorBuilder__f_a4 = null;
  this.sci_VectorBuilder__f_a3 = null;
  this.sci_VectorBuilder__f_a2 = null;
  this.sci_VectorBuilder__f_a1 = null;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 0;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = 0;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = 0;
  this.sci_VectorBuilder__f_prefixIsRightAligned = false;
  this.sci_VectorBuilder__f_depth = 0;
  this.sci_VectorBuilder__f_a1 = new $ac_O(32);
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 0;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = 0;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = 0;
  this.sci_VectorBuilder__f_prefixIsRightAligned = false;
  this.sci_VectorBuilder__f_depth = 1;
}
$c_sci_VectorBuilder.prototype = new $h_O();
$c_sci_VectorBuilder.prototype.constructor = $c_sci_VectorBuilder;
/** @constructor */
function $h_sci_VectorBuilder() {
}
$h_sci_VectorBuilder.prototype = $c_sci_VectorBuilder.prototype;
$c_sci_VectorBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_sci_VectorBuilder.prototype.initFrom__AO__V = (function(prefix1) {
  this.sci_VectorBuilder__f_depth = 1;
  var i = $n(prefix1).u.length;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i);
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
  this.sci_VectorBuilder__f_a1 = (($n(prefix1).u.length === 32) ? prefix1 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(prefix1, 0, 32));
  if (((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 0) && (this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest > 0))) {
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 32;
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (((-32) + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0);
  }
});
$c_sci_VectorBuilder.prototype.initFrom__sci_Vector__sci_VectorBuilder = (function(v) {
  var x1 = $n(v).vectorSliceCount__I();
  switch (x1) {
    case 0: {
      break;
    }
    case 1: {
      var v1 = $as_sci_Vector1(v);
      this.sci_VectorBuilder__f_depth = 1;
      var i = $n($n(v1).sci_Vector__f_prefix1).u.length;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      var a = $n(v1).sci_Vector__f_prefix1;
      this.sci_VectorBuilder__f_a1 = (($n(a).u.length === 32) ? a : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, 32));
      break;
    }
    case 3: {
      var v2 = $as_sci_Vector2(v);
      var d2 = $n(v2).sci_Vector2__f_data2;
      var a$1 = $n(v2).sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = (($n(a$1).u.length === 32) ? a$1 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$1, 0, 32));
      this.sci_VectorBuilder__f_depth = 2;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = ((32 - $n(v2).sci_Vector2__f_len1) | 0);
      var i$1 = (($n(v2).sci_BigVector__f_length0 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$1);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$1 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
      $n(this.sci_VectorBuilder__f_a2).set(0, $n(v2).sci_Vector__f_prefix1);
      var dest = this.sci_VectorBuilder__f_a2;
      var length = $n(d2).u.length;
      $systemArraycopyRefs($n(d2), 0, $n(dest), 1, length);
      $n(this.sci_VectorBuilder__f_a2).set(((1 + $n(d2).u.length) | 0), this.sci_VectorBuilder__f_a1);
      break;
    }
    case 5: {
      var v3 = $as_sci_Vector3(v);
      var d3 = $n(v3).sci_Vector3__f_data3;
      var s2 = $n(v3).sci_Vector3__f_suffix2;
      var a$2 = $n(v3).sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = (($n(a$2).u.length === 32) ? a$2 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$2, 0, 32));
      this.sci_VectorBuilder__f_depth = 3;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = ((1024 - $n(v3).sci_Vector3__f_len12) | 0);
      var i$2 = (($n(v3).sci_BigVector__f_length0 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$2);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$2 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $n(this.sci_VectorBuilder__f_a3).set(0, $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($n(v3).sci_Vector__f_prefix1, $n(v3).sci_Vector3__f_prefix2), 2));
      var dest$1 = this.sci_VectorBuilder__f_a3;
      var length$1 = $n(d3).u.length;
      $systemArraycopyRefs($n(d3), 0, $n(dest$1), 1, length$1);
      this.sci_VectorBuilder__f_a2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s2, 32), 2);
      $n(this.sci_VectorBuilder__f_a3).set(((1 + $n(d3).u.length) | 0), this.sci_VectorBuilder__f_a2);
      $n(this.sci_VectorBuilder__f_a2).set($n(s2).u.length, this.sci_VectorBuilder__f_a1);
      break;
    }
    case 7: {
      var v4 = $as_sci_Vector4(v);
      var d4 = $n(v4).sci_Vector4__f_data4;
      var s3 = $n(v4).sci_Vector4__f_suffix3;
      var s2$2 = $n(v4).sci_Vector4__f_suffix2;
      var a$3 = $n(v4).sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = (($n(a$3).u.length === 32) ? a$3 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$3, 0, 32));
      this.sci_VectorBuilder__f_depth = 4;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = ((32768 - $n(v4).sci_Vector4__f_len123) | 0);
      var i$3 = (($n(v4).sci_BigVector__f_length0 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$3);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$3 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $n(this.sci_VectorBuilder__f_a4).set(0, $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($n(v4).sci_Vector__f_prefix1, $n(v4).sci_Vector4__f_prefix2), $n(v4).sci_Vector4__f_prefix3), 3));
      var dest$2 = this.sci_VectorBuilder__f_a4;
      var length$2 = $n(d4).u.length;
      $systemArraycopyRefs($n(d4), 0, $n(dest$2), 1, length$2);
      this.sci_VectorBuilder__f_a3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s3, 32), 3);
      this.sci_VectorBuilder__f_a2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s2$2, 32), 2);
      $n(this.sci_VectorBuilder__f_a4).set(((1 + $n(d4).u.length) | 0), this.sci_VectorBuilder__f_a3);
      $n(this.sci_VectorBuilder__f_a3).set($n(s3).u.length, this.sci_VectorBuilder__f_a2);
      $n(this.sci_VectorBuilder__f_a2).set($n(s2$2).u.length, this.sci_VectorBuilder__f_a1);
      break;
    }
    case 9: {
      var v5 = $as_sci_Vector5(v);
      var d5 = $n(v5).sci_Vector5__f_data5;
      var s4 = $n(v5).sci_Vector5__f_suffix4;
      var s3$2 = $n(v5).sci_Vector5__f_suffix3;
      var s2$3 = $n(v5).sci_Vector5__f_suffix2;
      var a$4 = $n(v5).sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = (($n(a$4).u.length === 32) ? a$4 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$4, 0, 32));
      this.sci_VectorBuilder__f_depth = 5;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = ((1048576 - $n(v5).sci_Vector5__f_len1234) | 0);
      var i$4 = (($n(v5).sci_BigVector__f_length0 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$4);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$4 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $n(this.sci_VectorBuilder__f_a5).set(0, $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($n(v5).sci_Vector__f_prefix1, $n(v5).sci_Vector5__f_prefix2), $n(v5).sci_Vector5__f_prefix3), $n(v5).sci_Vector5__f_prefix4), 4));
      var dest$3 = this.sci_VectorBuilder__f_a5;
      var length$3 = $n(d5).u.length;
      $systemArraycopyRefs($n(d5), 0, $n(dest$3), 1, length$3);
      this.sci_VectorBuilder__f_a4 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s4, 32), 4);
      this.sci_VectorBuilder__f_a3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s3$2, 32), 3);
      this.sci_VectorBuilder__f_a2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s2$3, 32), 2);
      $n(this.sci_VectorBuilder__f_a5).set(((1 + $n(d5).u.length) | 0), this.sci_VectorBuilder__f_a4);
      $n(this.sci_VectorBuilder__f_a4).set($n(s4).u.length, this.sci_VectorBuilder__f_a3);
      $n(this.sci_VectorBuilder__f_a3).set($n(s3$2).u.length, this.sci_VectorBuilder__f_a2);
      $n(this.sci_VectorBuilder__f_a2).set($n(s2$3).u.length, this.sci_VectorBuilder__f_a1);
      break;
    }
    case 11: {
      var v6 = $as_sci_Vector6(v);
      var d6 = $n(v6).sci_Vector6__f_data6;
      var s5 = $n(v6).sci_Vector6__f_suffix5;
      var s4$2 = $n(v6).sci_Vector6__f_suffix4;
      var s3$3 = $n(v6).sci_Vector6__f_suffix3;
      var s2$4 = $n(v6).sci_Vector6__f_suffix2;
      var a$5 = $n(v6).sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = (($n(a$5).u.length === 32) ? a$5 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$5, 0, 32));
      this.sci_VectorBuilder__f_depth = 6;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = ((33554432 - $n(v6).sci_Vector6__f_len12345) | 0);
      var i$5 = (($n(v6).sci_BigVector__f_length0 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$5);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$5 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a6 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(64);
      $n(this.sci_VectorBuilder__f_a6).set(0, $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($n(v6).sci_Vector__f_prefix1, $n(v6).sci_Vector6__f_prefix2), $n(v6).sci_Vector6__f_prefix3), $n(v6).sci_Vector6__f_prefix4), $n(v6).sci_Vector6__f_prefix5), 5));
      var dest$4 = this.sci_VectorBuilder__f_a6;
      var length$4 = $n(d6).u.length;
      $systemArraycopyRefs($n(d6), 0, $n(dest$4), 1, length$4);
      this.sci_VectorBuilder__f_a5 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s5, 32), 5);
      this.sci_VectorBuilder__f_a4 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s4$2, 32), 4);
      this.sci_VectorBuilder__f_a3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s3$3, 32), 3);
      this.sci_VectorBuilder__f_a2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s2$4, 32), 2);
      $n(this.sci_VectorBuilder__f_a6).set(((1 + $n(d6).u.length) | 0), this.sci_VectorBuilder__f_a5);
      $n(this.sci_VectorBuilder__f_a5).set($n(s5).u.length, this.sci_VectorBuilder__f_a4);
      $n(this.sci_VectorBuilder__f_a4).set($n(s4$2).u.length, this.sci_VectorBuilder__f_a3);
      $n(this.sci_VectorBuilder__f_a3).set($n(s3$3).u.length, this.sci_VectorBuilder__f_a2);
      $n(this.sci_VectorBuilder__f_a2).set($n(s2$4).u.length, this.sci_VectorBuilder__f_a1);
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
  if (((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 0) && (this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest > 0))) {
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 32;
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (((-32) + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0);
  }
  return this;
});
$c_sci_VectorBuilder.prototype.alignTo__I__sci_Vector__sci_VectorBuilder = (function(before, bigVector) {
  if (((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 !== 0) || (this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest !== 0))) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "A non-empty VectorBuilder cannot be aligned retrospectively. Please call .reset() or use a new VectorBuilder.");
  }
  var x = $m_sci_Vector0$();
  if (x.equals__O__Z(bigVector)) {
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = 0;
    var x1$2___2$mcI$sp = 1;
  } else if ((bigVector instanceof $c_sci_Vector1)) {
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = 0;
    var x1$2___2$mcI$sp = 1;
  } else if ((bigVector instanceof $c_sci_Vector2)) {
    var x4 = $as_sci_Vector2(bigVector);
    var _1$mcI$sp = $n(x4).sci_Vector2__f_len1;
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = _1$mcI$sp;
    var x1$2___2$mcI$sp = 32;
  } else if ((bigVector instanceof $c_sci_Vector3)) {
    var x5 = $as_sci_Vector3(bigVector);
    var _1$mcI$sp$1 = $n(x5).sci_Vector3__f_len12;
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = _1$mcI$sp$1;
    var x1$2___2$mcI$sp = 1024;
  } else if ((bigVector instanceof $c_sci_Vector4)) {
    var x6 = $as_sci_Vector4(bigVector);
    var _1$mcI$sp$2 = $n(x6).sci_Vector4__f_len123;
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = _1$mcI$sp$2;
    var x1$2___2$mcI$sp = 32768;
  } else if ((bigVector instanceof $c_sci_Vector5)) {
    var x7 = $as_sci_Vector5(bigVector);
    var _1$mcI$sp$3 = $n(x7).sci_Vector5__f_len1234;
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = _1$mcI$sp$3;
    var x1$2___2$mcI$sp = 1048576;
  } else {
    if ((!(bigVector instanceof $c_sci_Vector6))) {
      throw new $c_s_MatchError(bigVector);
    }
    var x8 = $as_sci_Vector6(bigVector);
    var _1$mcI$sp$4 = $n(x8).sci_Vector6__f_len12345;
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = _1$mcI$sp$4;
    var x1$2___2$mcI$sp = 33554432;
  }
  var prefixLength = x1$2___1$mcI$sp;
  var maxPrefixLength = x1$2___2$mcI$sp;
  if ((maxPrefixLength === 1)) {
    return this;
  }
  var overallPrefixLength = $intMod(((before + prefixLength) | 0), maxPrefixLength);
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = $intMod(((maxPrefixLength - overallPrefixLength) | 0), maxPrefixLength);
  $p_sci_VectorBuilder__advanceN__I__V(this, ((-32) & this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset));
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset);
  this.sci_VectorBuilder__f_prefixIsRightAligned = true;
  return this;
});
$c_sci_VectorBuilder.prototype.addOne__O__sci_VectorBuilder = (function(elem) {
  if ((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 32)) {
    $p_sci_VectorBuilder__advance__V(this);
  }
  $n(this.sci_VectorBuilder__f_a1).set(this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1, elem);
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = ((1 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
  return this;
});
$c_sci_VectorBuilder.prototype.addAll__sc_IterableOnce__sci_VectorBuilder = (function(xs) {
  if ((xs instanceof $c_sci_Vector)) {
    var x2 = $as_sci_Vector(xs);
    return ((((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 0) && (this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest === 0)) && (!this.sci_VectorBuilder__f_prefixIsRightAligned)) ? this.initFrom__sci_Vector__sci_VectorBuilder(x2) : $p_sci_VectorBuilder__addVector__sci_Vector__sci_VectorBuilder(this, x2));
  } else {
    return $as_sci_VectorBuilder($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs));
  }
});
$c_sci_VectorBuilder.prototype.result__sci_Vector = (function() {
  if (this.sci_VectorBuilder__f_prefixIsRightAligned) {
    $p_sci_VectorBuilder__leftAlignPrefix__V(this);
  }
  var len = ((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0);
  var realLen = ((len - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
  if ((realLen === 0)) {
    $m_sci_Vector$();
    return $m_sci_Vector0$();
  } else if ((len < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("Vector cannot have negative size " + len));
  } else if ((len <= 32)) {
    var a = this.sci_VectorBuilder__f_a1;
    return new $c_sci_Vector1((($n(a).u.length === realLen) ? a : $m_ju_Arrays$().copyOf__AO__I__AO(a, realLen)));
  } else if ((len <= 1024)) {
    var i1 = (31 & (((-1) + len) | 0));
    var i2 = (((((-1) + len) | 0) >>> 5) | 0);
    var original = this.sci_VectorBuilder__f_a2;
    var data = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original, 1, i2), 2);
    var prefix1 = $n(this.sci_VectorBuilder__f_a2).get(0);
    var a$1 = $n(this.sci_VectorBuilder__f_a2).get(i2);
    var len$1 = ((1 + i1) | 0);
    var suffix1 = (($n(a$1).u.length === len$1) ? a$1 : $m_ju_Arrays$().copyOf__AO__I__AO(a$1, len$1));
    return new $c_sci_Vector2(prefix1, ((32 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0), data, suffix1, realLen);
  } else if ((len <= 32768)) {
    var i1$2 = (31 & (((-1) + len) | 0));
    var i2$2 = (31 & (((((-1) + len) | 0) >>> 5) | 0));
    var i3 = (((((-1) + len) | 0) >>> 10) | 0);
    var original$1 = this.sci_VectorBuilder__f_a3;
    var data$2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$1, 1, i3), 3);
    var a$2 = $n(this.sci_VectorBuilder__f_a3).get(0);
    var to = $n(a$2).u.length;
    var prefix2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$2, 1, to), 2);
    var prefix1$2 = $n($n(this.sci_VectorBuilder__f_a3).get(0)).get(0);
    var original$2 = $n(this.sci_VectorBuilder__f_a3).get(i3);
    var suffix2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$2, i2$2), 2);
    var a$3 = $n($n(this.sci_VectorBuilder__f_a3).get(i3)).get(i2$2);
    var len$2 = ((1 + i1$2) | 0);
    var suffix1$2 = (($n(a$3).u.length === len$2) ? a$3 : $m_ju_Arrays$().copyOf__AO__I__AO(a$3, len$2));
    var len1 = $n(prefix1$2).u.length;
    var len12 = ((len1 + ($n(prefix2).u.length << 5)) | 0);
    return new $c_sci_Vector3(prefix1$2, len1, prefix2, len12, data$2, suffix2, suffix1$2, realLen);
  } else if ((len <= 1048576)) {
    var i1$3 = (31 & (((-1) + len) | 0));
    var i2$3 = (31 & (((((-1) + len) | 0) >>> 5) | 0));
    var i3$2 = (31 & (((((-1) + len) | 0) >>> 10) | 0));
    var i4 = (((((-1) + len) | 0) >>> 15) | 0);
    var original$3 = this.sci_VectorBuilder__f_a4;
    var data$3 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$3, 1, i4), 4);
    var a$4 = $n(this.sci_VectorBuilder__f_a4).get(0);
    var to$1 = $n(a$4).u.length;
    var prefix3 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$4, 1, to$1), 3);
    var a$5 = $n($n(this.sci_VectorBuilder__f_a4).get(0)).get(0);
    var to$2 = $n(a$5).u.length;
    var prefix2$2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$5, 1, to$2), 2);
    var prefix1$3 = $n($n($n(this.sci_VectorBuilder__f_a4).get(0)).get(0)).get(0);
    var original$4 = $n(this.sci_VectorBuilder__f_a4).get(i4);
    var suffix3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$4, i3$2), 3);
    var original$5 = $n($n(this.sci_VectorBuilder__f_a4).get(i4)).get(i3$2);
    var suffix2$2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$5, i2$3), 2);
    var a$6 = $n($n($n(this.sci_VectorBuilder__f_a4).get(i4)).get(i3$2)).get(i2$3);
    var len$3 = ((1 + i1$3) | 0);
    var suffix1$3 = (($n(a$6).u.length === len$3) ? a$6 : $m_ju_Arrays$().copyOf__AO__I__AO(a$6, len$3));
    var len1$2 = $n(prefix1$3).u.length;
    var len12$2 = ((len1$2 + ($n(prefix2$2).u.length << 5)) | 0);
    var len123 = ((len12$2 + ($n(prefix3).u.length << 10)) | 0);
    return new $c_sci_Vector4(prefix1$3, len1$2, prefix2$2, len12$2, prefix3, len123, data$3, suffix3, suffix2$2, suffix1$3, realLen);
  } else if ((len <= 33554432)) {
    var i1$4 = (31 & (((-1) + len) | 0));
    var i2$4 = (31 & (((((-1) + len) | 0) >>> 5) | 0));
    var i3$3 = (31 & (((((-1) + len) | 0) >>> 10) | 0));
    var i4$2 = (31 & (((((-1) + len) | 0) >>> 15) | 0));
    var i5 = (((((-1) + len) | 0) >>> 20) | 0);
    var original$6 = this.sci_VectorBuilder__f_a5;
    var data$4 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$6, 1, i5), 5);
    var a$7 = $n(this.sci_VectorBuilder__f_a5).get(0);
    var to$3 = $n(a$7).u.length;
    var prefix4 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$7, 1, to$3), 4);
    var a$8 = $n($n(this.sci_VectorBuilder__f_a5).get(0)).get(0);
    var to$4 = $n(a$8).u.length;
    var prefix3$2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$8, 1, to$4), 3);
    var a$9 = $n($n($n(this.sci_VectorBuilder__f_a5).get(0)).get(0)).get(0);
    var to$5 = $n(a$9).u.length;
    var prefix2$3 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$9, 1, to$5), 2);
    var prefix1$4 = $n($n($n($n(this.sci_VectorBuilder__f_a5).get(0)).get(0)).get(0)).get(0);
    var original$7 = $n(this.sci_VectorBuilder__f_a5).get(i5);
    var suffix4 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$7, i4$2), 4);
    var original$8 = $n($n(this.sci_VectorBuilder__f_a5).get(i5)).get(i4$2);
    var suffix3$2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$8, i3$3), 3);
    var original$9 = $n($n($n(this.sci_VectorBuilder__f_a5).get(i5)).get(i4$2)).get(i3$3);
    var suffix2$3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$9, i2$4), 2);
    var a$10 = $n($n($n($n(this.sci_VectorBuilder__f_a5).get(i5)).get(i4$2)).get(i3$3)).get(i2$4);
    var len$4 = ((1 + i1$4) | 0);
    var suffix1$4 = (($n(a$10).u.length === len$4) ? a$10 : $m_ju_Arrays$().copyOf__AO__I__AO(a$10, len$4));
    var len1$3 = $n(prefix1$4).u.length;
    var len12$3 = ((len1$3 + ($n(prefix2$3).u.length << 5)) | 0);
    var len123$2 = ((len12$3 + ($n(prefix3$2).u.length << 10)) | 0);
    var len1234 = ((len123$2 + ($n(prefix4).u.length << 15)) | 0);
    return new $c_sci_Vector5(prefix1$4, len1$3, prefix2$3, len12$3, prefix3$2, len123$2, prefix4, len1234, data$4, suffix4, suffix3$2, suffix2$3, suffix1$4, realLen);
  } else {
    var i1$5 = (31 & (((-1) + len) | 0));
    var i2$5 = (31 & (((((-1) + len) | 0) >>> 5) | 0));
    var i3$4 = (31 & (((((-1) + len) | 0) >>> 10) | 0));
    var i4$3 = (31 & (((((-1) + len) | 0) >>> 15) | 0));
    var i5$2 = (31 & (((((-1) + len) | 0) >>> 20) | 0));
    var i6 = (((((-1) + len) | 0) >>> 25) | 0);
    var original$10 = this.sci_VectorBuilder__f_a6;
    var data$5 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$10, 1, i6), 6);
    var a$11 = $n(this.sci_VectorBuilder__f_a6).get(0);
    var to$6 = $n(a$11).u.length;
    var prefix5 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$11, 1, to$6), 5);
    var a$12 = $n($n(this.sci_VectorBuilder__f_a6).get(0)).get(0);
    var to$7 = $n(a$12).u.length;
    var prefix4$2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$12, 1, to$7), 4);
    var a$13 = $n($n($n(this.sci_VectorBuilder__f_a6).get(0)).get(0)).get(0);
    var to$8 = $n(a$13).u.length;
    var prefix3$3 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$13, 1, to$8), 3);
    var a$14 = $n($n($n($n(this.sci_VectorBuilder__f_a6).get(0)).get(0)).get(0)).get(0);
    var to$9 = $n(a$14).u.length;
    var prefix2$4 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$14, 1, to$9), 2);
    var prefix1$5 = $n($n($n($n($n(this.sci_VectorBuilder__f_a6).get(0)).get(0)).get(0)).get(0)).get(0);
    var original$11 = $n(this.sci_VectorBuilder__f_a6).get(i6);
    var suffix5 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$11, i5$2), 5);
    var original$12 = $n($n(this.sci_VectorBuilder__f_a6).get(i6)).get(i5$2);
    var suffix4$2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$12, i4$3), 4);
    var original$13 = $n($n($n(this.sci_VectorBuilder__f_a6).get(i6)).get(i5$2)).get(i4$3);
    var suffix3$3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$13, i3$4), 3);
    var original$14 = $n($n($n($n(this.sci_VectorBuilder__f_a6).get(i6)).get(i5$2)).get(i4$3)).get(i3$4);
    var suffix2$4 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$14, i2$5), 2);
    var a$15 = $n($n($n($n($n(this.sci_VectorBuilder__f_a6).get(i6)).get(i5$2)).get(i4$3)).get(i3$4)).get(i2$5);
    var len$5 = ((1 + i1$5) | 0);
    var suffix1$5 = (($n(a$15).u.length === len$5) ? a$15 : $m_ju_Arrays$().copyOf__AO__I__AO(a$15, len$5));
    var len1$4 = $n(prefix1$5).u.length;
    var len12$4 = ((len1$4 + ($n(prefix2$4).u.length << 5)) | 0);
    var len123$3 = ((len12$4 + ($n(prefix3$3).u.length << 10)) | 0);
    var len1234$2 = ((len123$3 + ($n(prefix4$2).u.length << 15)) | 0);
    var len12345 = ((len1234$2 + ($n(prefix5).u.length << 20)) | 0);
    return new $c_sci_Vector6(prefix1$5, len1$4, prefix2$4, len12$4, prefix3$3, len123$3, prefix4$2, len1234$2, prefix5, len12345, data$5, suffix5, suffix4$2, suffix3$3, suffix2$4, suffix1$5, realLen);
  }
});
$c_sci_VectorBuilder.prototype.toString__T = (function() {
  return (((((((("VectorBuilder(len1=" + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) + ", lenRest=") + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) + ", offset=") + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) + ", depth=") + this.sci_VectorBuilder__f_depth) + ")");
});
$c_sci_VectorBuilder.prototype.result__O = (function() {
  return this.result__sci_Vector();
});
$c_sci_VectorBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__sci_VectorBuilder(elems);
});
$c_sci_VectorBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_VectorBuilder(elem);
});
function $as_sci_VectorBuilder(obj) {
  return (((obj instanceof $c_sci_VectorBuilder) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.VectorBuilder"));
}
function $isArrayOf_sci_VectorBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_VectorBuilder)));
}
function $asArrayOf_sci_VectorBuilder(obj, depth) {
  return (($isArrayOf_sci_VectorBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.VectorBuilder;", depth));
}
var $d_sci_VectorBuilder = new $TypeData().initClass($c_sci_VectorBuilder, "scala.collection.immutable.VectorBuilder", ({
  sci_VectorBuilder: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
function $p_scm_ArrayBuffer$__checkArrayLengthLimit$1__I__I__V($thiz, targetLen$1, arrayLen$1) {
  if ((targetLen$1 > 2147483639)) {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), ((("Array of array-backed collection exceeds VM length limit of 2147483639. Requested length: " + targetLen$1) + "; current length: ") + arrayLen$1));
  } else if ((targetLen$1 < 0)) {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), ((((("Overflow while resizing array of array-backed collection. Requested length: " + targetLen$1) + "; current length: ") + arrayLen$1) + "; increase: ") + ((targetLen$1 - arrayLen$1) | 0)));
  }
}
/** @constructor */
function $c_scm_ArrayBuffer$() {
  this.scm_ArrayBuffer$__f_emptyArray = null;
  $n_scm_ArrayBuffer$ = this;
  this.scm_ArrayBuffer$__f_emptyArray = new $ac_O(0);
}
$c_scm_ArrayBuffer$.prototype = new $h_O();
$c_scm_ArrayBuffer$.prototype.constructor = $c_scm_ArrayBuffer$;
/** @constructor */
function $h_scm_ArrayBuffer$() {
}
$h_scm_ArrayBuffer$.prototype = $c_scm_ArrayBuffer$.prototype;
$c_scm_ArrayBuffer$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__scm_ArrayBuffer(elems);
});
$c_scm_ArrayBuffer$.prototype.from__sc_IterableOnce__scm_ArrayBuffer = (function(coll) {
  var k = $n(coll).knownSize__I();
  if ((k >= 0)) {
    var array = this.scala$collection$mutable$ArrayBuffer$$ensureSize__AO__I__I__AO(this.scm_ArrayBuffer$__f_emptyArray, 0, k);
    if ($is_sc_Iterable(coll)) {
      var x2 = $as_sc_Iterable(coll);
      var actual = $n(x2).copyToArray__O__I__I__I(array, 0, 2147483647);
    } else {
      var actual = $n($n(coll).iterator__sc_Iterator()).copyToArray__O__I__I__I(array, 0, 2147483647);
    }
    if ((actual !== k)) {
      throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), ((("Copied " + actual) + " of ") + k));
    }
    return $ct_scm_ArrayBuffer__AO__I__(new $c_scm_ArrayBuffer(), array, k);
  } else {
    var this$2 = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    return this$2.addAll__sc_IterableOnce__scm_ArrayBuffer(coll);
  }
});
$c_scm_ArrayBuffer$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_ArrayBuffer$$anon$1();
});
$c_scm_ArrayBuffer$.prototype.resizeUp__I__I__I = (function(arrayLen, targetLen) {
  if (((targetLen > 0) && (targetLen <= arrayLen))) {
    return (-1);
  } else {
    $p_scm_ArrayBuffer$__checkArrayLengthLimit$1__I__I__V(this, targetLen, arrayLen);
    if ((arrayLen > 1073741819)) {
      return 2147483639;
    } else {
      var x = (arrayLen << 1);
      var y = ((x > 16) ? x : 16);
      return ((targetLen > y) ? targetLen : y);
    }
  }
});
$c_scm_ArrayBuffer$.prototype.scala$collection$mutable$ArrayBuffer$$ensureSize__AO__I__I__AO = (function(array, curSize, targetSize) {
  var newLen = this.resizeUp__I__I__I($n(array).u.length, targetSize);
  if ((newLen < 0)) {
    return array;
  } else {
    var res = new $ac_O(newLen);
    $systemArraycopyRefs($n(array), 0, res, 0, curSize);
    return res;
  }
});
$c_scm_ArrayBuffer$.prototype.empty__O = (function() {
  return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
});
$c_scm_ArrayBuffer$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__scm_ArrayBuffer(source);
});
var $d_scm_ArrayBuffer$ = new $TypeData().initClass($c_scm_ArrayBuffer$, "scala.collection.mutable.ArrayBuffer$", ({
  scm_ArrayBuffer$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_scm_ArrayBuffer$;
function $m_scm_ArrayBuffer$() {
  if ((!$n_scm_ArrayBuffer$)) {
    $n_scm_ArrayBuffer$ = new $c_scm_ArrayBuffer$();
  }
  return $n_scm_ArrayBuffer$;
}
/** @constructor */
function $c_scm_ArrayBuffer$$anon$1() {
  this.scm_GrowableBuilder__f_elems = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer())));
}
$c_scm_ArrayBuffer$$anon$1.prototype = new $h_scm_GrowableBuilder();
$c_scm_ArrayBuffer$$anon$1.prototype.constructor = $c_scm_ArrayBuffer$$anon$1;
/** @constructor */
function $h_scm_ArrayBuffer$$anon$1() {
}
$h_scm_ArrayBuffer$$anon$1.prototype = $c_scm_ArrayBuffer$$anon$1.prototype;
$c_scm_ArrayBuffer$$anon$1.prototype.sizeHint__I__V = (function(size) {
  $n($as_scm_ArrayBuffer(this.scm_GrowableBuilder__f_elems)).sizeHint__I__V(size);
});
var $d_scm_ArrayBuffer$$anon$1 = new $TypeData().initClass($c_scm_ArrayBuffer$$anon$1, "scala.collection.mutable.ArrayBuffer$$anon$1", ({
  scm_ArrayBuffer$$anon$1: 1,
  scm_GrowableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
/** @constructor */
function $c_scm_ArrayDeque$() {
}
$c_scm_ArrayDeque$.prototype = new $h_O();
$c_scm_ArrayDeque$.prototype.constructor = $c_scm_ArrayDeque$;
/** @constructor */
function $h_scm_ArrayDeque$() {
}
$h_scm_ArrayDeque$.prototype = $c_scm_ArrayDeque$.prototype;
$c_scm_ArrayDeque$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__scm_ArrayDeque(elems);
});
$c_scm_ArrayDeque$.prototype.from__sc_IterableOnce__scm_ArrayDeque = (function(coll) {
  var s = $n(coll).knownSize__I();
  if ((s >= 0)) {
    var array = this.alloc__I__AO(s);
    if ($is_sc_Iterable(coll)) {
      var x2 = $as_sc_Iterable(coll);
      var actual = $n(x2).copyToArray__O__I__I__I(array, 0, 2147483647);
    } else {
      var actual = $n($n(coll).iterator__sc_Iterator()).copyToArray__O__I__I__I(array, 0, 2147483647);
    }
    if ((actual !== s)) {
      throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), ((("Copied " + actual) + " of ") + s));
    }
    return $ct_scm_ArrayDeque__AO__I__I__(new $c_scm_ArrayDeque(), array, 0, s);
  } else {
    var this$2 = $ct_scm_ArrayDeque__I__(new $c_scm_ArrayDeque(), 16);
    return this$2.addAll__sc_IterableOnce__scm_ArrayDeque(coll);
  }
});
$c_scm_ArrayDeque$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_ArrayDeque$$anon$1();
});
$c_scm_ArrayDeque$.prototype.alloc__I__AO = (function(len) {
  var requirement = (len >= 0);
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: Non-negative array size required");
  }
  var size = ((((-2147483648) >>> $uI(Math.clz32(len))) | 0) << 1);
  var requirement$1 = (size >= 0);
  if ((!requirement$1)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + "ArrayDeque too big - cannot allocate ArrayDeque of length ") + len));
  }
  return new $ac_O(((size > 16) ? size : 16));
});
$c_scm_ArrayDeque$.prototype.empty__O = (function() {
  return $ct_scm_ArrayDeque__I__(new $c_scm_ArrayDeque(), 16);
});
$c_scm_ArrayDeque$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__scm_ArrayDeque(source);
});
var $d_scm_ArrayDeque$ = new $TypeData().initClass($c_scm_ArrayDeque$, "scala.collection.mutable.ArrayDeque$", ({
  scm_ArrayDeque$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_scm_ArrayDeque$;
function $m_scm_ArrayDeque$() {
  if ((!$n_scm_ArrayDeque$)) {
    $n_scm_ArrayDeque$ = new $c_scm_ArrayDeque$();
  }
  return $n_scm_ArrayDeque$;
}
/** @constructor */
function $c_scm_ArrayDeque$$anon$1() {
  this.scm_GrowableBuilder__f_elems = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, $ct_scm_ArrayDeque__I__(new $c_scm_ArrayDeque(), 16));
}
$c_scm_ArrayDeque$$anon$1.prototype = new $h_scm_GrowableBuilder();
$c_scm_ArrayDeque$$anon$1.prototype.constructor = $c_scm_ArrayDeque$$anon$1;
/** @constructor */
function $h_scm_ArrayDeque$$anon$1() {
}
$h_scm_ArrayDeque$$anon$1.prototype = $c_scm_ArrayDeque$$anon$1.prototype;
$c_scm_ArrayDeque$$anon$1.prototype.sizeHint__I__V = (function(size) {
  var this$1 = $n($as_scm_ArrayDeque(this.scm_GrowableBuilder__f_elems));
  var idx = this$1.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  if (((size > (((this$1.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $n(this$1.scm_ArrayDeque__f_array).u.length) | 0))) && (size >= $n(this$1.scm_ArrayDeque__f_array).u.length))) {
    this$1.scala$collection$mutable$ArrayDeque$$resize__I__V(size);
  }
});
var $d_scm_ArrayDeque$$anon$1 = new $TypeData().initClass($c_scm_ArrayDeque$$anon$1, "scala.collection.mutable.ArrayDeque$$anon$1", ({
  scm_ArrayDeque$$anon$1: 1,
  scm_GrowableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
/** @constructor */
function $c_scm_Buffer$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sjs_js_WrappedArray$());
}
$c_scm_Buffer$.prototype = new $h_sc_SeqFactory$Delegate();
$c_scm_Buffer$.prototype.constructor = $c_scm_Buffer$;
/** @constructor */
function $h_scm_Buffer$() {
}
$h_scm_Buffer$.prototype = $c_scm_Buffer$.prototype;
var $d_scm_Buffer$ = new $TypeData().initClass($c_scm_Buffer$, "scala.collection.mutable.Buffer$", ({
  scm_Buffer$: 1,
  sc_SeqFactory$Delegate: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_scm_Buffer$;
function $m_scm_Buffer$() {
  if ((!$n_scm_Buffer$)) {
    $n_scm_Buffer$ = new $c_scm_Buffer$();
  }
  return $n_scm_Buffer$;
}
/** @constructor */
function $c_scm_HashMap$$anon$6(initialCapacity$1, loadFactor$1) {
  this.scm_GrowableBuilder__f_elems = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, $ct_scm_HashMap__I__D__(new $c_scm_HashMap(), initialCapacity$1, loadFactor$1));
}
$c_scm_HashMap$$anon$6.prototype = new $h_scm_GrowableBuilder();
$c_scm_HashMap$$anon$6.prototype.constructor = $c_scm_HashMap$$anon$6;
/** @constructor */
function $h_scm_HashMap$$anon$6() {
}
$h_scm_HashMap$$anon$6.prototype = $c_scm_HashMap$$anon$6.prototype;
$c_scm_HashMap$$anon$6.prototype.sizeHint__I__V = (function(size) {
  $n($as_scm_HashMap(this.scm_GrowableBuilder__f_elems)).sizeHint__I__V(size);
});
var $d_scm_HashMap$$anon$6 = new $TypeData().initClass($c_scm_HashMap$$anon$6, "scala.collection.mutable.HashMap$$anon$6", ({
  scm_HashMap$$anon$6: 1,
  scm_GrowableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
function $ct_scm_HashMap$HashMapIterator__scm_HashMap__($thiz, outer) {
  $n(outer);
  $thiz.scm_HashMap$HashMapIterator__f_$outer = outer;
  $thiz.scm_HashMap$HashMapIterator__f_i = 0;
  $thiz.scm_HashMap$HashMapIterator__f_node = null;
  $thiz.scm_HashMap$HashMapIterator__f_len = $n($n(outer).scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length;
  return $thiz;
}
/** @constructor */
function $c_scm_HashMap$HashMapIterator() {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
}
$c_scm_HashMap$HashMapIterator.prototype = new $h_sc_AbstractIterator();
$c_scm_HashMap$HashMapIterator.prototype.constructor = $c_scm_HashMap$HashMapIterator;
/** @constructor */
function $h_scm_HashMap$HashMapIterator() {
}
$h_scm_HashMap$HashMapIterator.prototype = $c_scm_HashMap$HashMapIterator.prototype;
$c_scm_HashMap$HashMapIterator.prototype.hasNext__Z = (function() {
  if ((this.scm_HashMap$HashMapIterator__f_node !== null)) {
    return true;
  } else {
    while ((this.scm_HashMap$HashMapIterator__f_i < this.scm_HashMap$HashMapIterator__f_len)) {
      var n = $n($n(this.scm_HashMap$HashMapIterator__f_$outer).scm_HashMap__f_scala$collection$mutable$HashMap$$table).get(this.scm_HashMap$HashMapIterator__f_i);
      this.scm_HashMap$HashMapIterator__f_i = ((1 + this.scm_HashMap$HashMapIterator__f_i) | 0);
      if ((n !== null)) {
        this.scm_HashMap$HashMapIterator__f_node = n;
        return true;
      }
    }
    return false;
  }
});
$c_scm_HashMap$HashMapIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  } else {
    var r = this.extract__scm_HashMap$Node__O(this.scm_HashMap$HashMapIterator__f_node);
    this.scm_HashMap$HashMapIterator__f_node = $n(this.scm_HashMap$HashMapIterator__f_node).scm_HashMap$Node__f__next;
    return r;
  }
});
/** @constructor */
function $c_scm_HashSet$$anon$4(initialCapacity$1, loadFactor$1) {
  this.scm_GrowableBuilder__f_elems = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, $ct_scm_HashSet__I__D__(new $c_scm_HashSet(), initialCapacity$1, loadFactor$1));
}
$c_scm_HashSet$$anon$4.prototype = new $h_scm_GrowableBuilder();
$c_scm_HashSet$$anon$4.prototype.constructor = $c_scm_HashSet$$anon$4;
/** @constructor */
function $h_scm_HashSet$$anon$4() {
}
$h_scm_HashSet$$anon$4.prototype = $c_scm_HashSet$$anon$4.prototype;
$c_scm_HashSet$$anon$4.prototype.sizeHint__I__V = (function(size) {
  $n($as_scm_HashSet(this.scm_GrowableBuilder__f_elems)).sizeHint__I__V(size);
});
var $d_scm_HashSet$$anon$4 = new $TypeData().initClass($c_scm_HashSet$$anon$4, "scala.collection.mutable.HashSet$$anon$4", ({
  scm_HashSet$$anon$4: 1,
  scm_GrowableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
function $ct_scm_HashSet$HashSetIterator__scm_HashSet__($thiz, outer) {
  $n(outer);
  $thiz.scm_HashSet$HashSetIterator__f_$outer = outer;
  $thiz.scm_HashSet$HashSetIterator__f_i = 0;
  $thiz.scm_HashSet$HashSetIterator__f_node = null;
  $thiz.scm_HashSet$HashSetIterator__f_len = $n($n(outer).scm_HashSet__f_scala$collection$mutable$HashSet$$table).u.length;
  return $thiz;
}
/** @constructor */
function $c_scm_HashSet$HashSetIterator() {
  this.scm_HashSet$HashSetIterator__f_i = 0;
  this.scm_HashSet$HashSetIterator__f_node = null;
  this.scm_HashSet$HashSetIterator__f_len = 0;
  this.scm_HashSet$HashSetIterator__f_$outer = null;
}
$c_scm_HashSet$HashSetIterator.prototype = new $h_sc_AbstractIterator();
$c_scm_HashSet$HashSetIterator.prototype.constructor = $c_scm_HashSet$HashSetIterator;
/** @constructor */
function $h_scm_HashSet$HashSetIterator() {
}
$h_scm_HashSet$HashSetIterator.prototype = $c_scm_HashSet$HashSetIterator.prototype;
$c_scm_HashSet$HashSetIterator.prototype.hasNext__Z = (function() {
  if ((this.scm_HashSet$HashSetIterator__f_node !== null)) {
    return true;
  } else {
    while ((this.scm_HashSet$HashSetIterator__f_i < this.scm_HashSet$HashSetIterator__f_len)) {
      var n = $n($n(this.scm_HashSet$HashSetIterator__f_$outer).scm_HashSet__f_scala$collection$mutable$HashSet$$table).get(this.scm_HashSet$HashSetIterator__f_i);
      this.scm_HashSet$HashSetIterator__f_i = ((1 + this.scm_HashSet$HashSetIterator__f_i) | 0);
      if ((n !== null)) {
        this.scm_HashSet$HashSetIterator__f_node = n;
        return true;
      }
    }
    return false;
  }
});
$c_scm_HashSet$HashSetIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  } else {
    var r = this.extract__scm_HashSet$Node__O(this.scm_HashSet$HashSetIterator__f_node);
    this.scm_HashSet$HashSetIterator__f_node = $n(this.scm_HashSet$HashSetIterator__f_node).scm_HashSet$Node__f__next;
    return r;
  }
});
function $ct_scm_ImmutableBuilder__sc_IterableOnce__($thiz, empty) {
  $thiz.scm_ImmutableBuilder__f_elems = empty;
  return $thiz;
}
/** @constructor */
function $c_scm_ImmutableBuilder() {
  this.scm_ImmutableBuilder__f_elems = null;
}
$c_scm_ImmutableBuilder.prototype = new $h_O();
$c_scm_ImmutableBuilder.prototype.constructor = $c_scm_ImmutableBuilder;
/** @constructor */
function $h_scm_ImmutableBuilder() {
}
$h_scm_ImmutableBuilder.prototype = $c_scm_ImmutableBuilder.prototype;
$c_scm_ImmutableBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_scm_ImmutableBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$c_scm_ImmutableBuilder.prototype.result__O = (function() {
  return this.scm_ImmutableBuilder__f_elems;
});
/** @constructor */
function $c_scm_IndexedSeq$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_scm_ArrayBuffer$());
}
$c_scm_IndexedSeq$.prototype = new $h_sc_SeqFactory$Delegate();
$c_scm_IndexedSeq$.prototype.constructor = $c_scm_IndexedSeq$;
/** @constructor */
function $h_scm_IndexedSeq$() {
}
$h_scm_IndexedSeq$.prototype = $c_scm_IndexedSeq$.prototype;
var $d_scm_IndexedSeq$ = new $TypeData().initClass($c_scm_IndexedSeq$, "scala.collection.mutable.IndexedSeq$", ({
  scm_IndexedSeq$: 1,
  sc_SeqFactory$Delegate: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_scm_IndexedSeq$;
function $m_scm_IndexedSeq$() {
  if ((!$n_scm_IndexedSeq$)) {
    $n_scm_IndexedSeq$ = new $c_scm_IndexedSeq$();
  }
  return $n_scm_IndexedSeq$;
}
/** @constructor */
function $c_scm_ListBuffer$() {
}
$c_scm_ListBuffer$.prototype = new $h_O();
$c_scm_ListBuffer$.prototype.constructor = $c_scm_ListBuffer$;
/** @constructor */
function $h_scm_ListBuffer$() {
}
$h_scm_ListBuffer$.prototype = $c_scm_ListBuffer$.prototype;
$c_scm_ListBuffer$.prototype.apply__sci_Seq__O = (function(elems) {
  return new $c_scm_ListBuffer().scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer(elems);
});
$c_scm_ListBuffer$.prototype.newBuilder__scm_Builder = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), new $c_scm_ListBuffer());
});
$c_scm_ListBuffer$.prototype.empty__O = (function() {
  return new $c_scm_ListBuffer();
});
$c_scm_ListBuffer$.prototype.from__sc_IterableOnce__O = (function(source) {
  return new $c_scm_ListBuffer().scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer(source);
});
var $d_scm_ListBuffer$ = new $TypeData().initClass($c_scm_ListBuffer$, "scala.collection.mutable.ListBuffer$", ({
  scm_ListBuffer$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_scm_ListBuffer$;
function $m_scm_ListBuffer$() {
  if ((!$n_scm_ListBuffer$)) {
    $n_scm_ListBuffer$ = new $c_scm_ListBuffer$();
  }
  return $n_scm_ListBuffer$;
}
/** @constructor */
function $c_scm_MutationTracker$CheckedIterator(underlying, mutationCount) {
  this.scm_MutationTracker$CheckedIterator__f_underlying = null;
  this.scm_MutationTracker$CheckedIterator__f_mutationCount = null;
  this.scm_MutationTracker$CheckedIterator__f_expectedCount = 0;
  this.scm_MutationTracker$CheckedIterator__f_underlying = underlying;
  this.scm_MutationTracker$CheckedIterator__f_mutationCount = mutationCount;
  var this$1 = $n(mutationCount);
  this.scm_MutationTracker$CheckedIterator__f_expectedCount = $uI(this$1.apply__O());
}
$c_scm_MutationTracker$CheckedIterator.prototype = new $h_sc_AbstractIterator();
$c_scm_MutationTracker$CheckedIterator.prototype.constructor = $c_scm_MutationTracker$CheckedIterator;
/** @constructor */
function $h_scm_MutationTracker$CheckedIterator() {
}
$h_scm_MutationTracker$CheckedIterator.prototype = $c_scm_MutationTracker$CheckedIterator.prototype;
$c_scm_MutationTracker$CheckedIterator.prototype.hasNext__Z = (function() {
  var this$2 = $m_scm_MutationTracker$();
  var expectedCount = this.scm_MutationTracker$CheckedIterator__f_expectedCount;
  var this$1 = $n(this.scm_MutationTracker$CheckedIterator__f_mutationCount);
  var actualCount = $uI(this$1.apply__O());
  this$2.checkMutations__I__I__T__V(expectedCount, actualCount, "mutation occurred during iteration");
  return $n(this.scm_MutationTracker$CheckedIterator__f_underlying).hasNext__Z();
});
$c_scm_MutationTracker$CheckedIterator.prototype.next__O = (function() {
  return $n(this.scm_MutationTracker$CheckedIterator__f_underlying).next__O();
});
var $d_scm_MutationTracker$CheckedIterator = new $TypeData().initClass($c_scm_MutationTracker$CheckedIterator, "scala.collection.mutable.MutationTracker$CheckedIterator", ({
  scm_MutationTracker$CheckedIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_scm_Queue$() {
}
$c_scm_Queue$.prototype = new $h_O();
$c_scm_Queue$.prototype.constructor = $c_scm_Queue$;
/** @constructor */
function $h_scm_Queue$() {
}
$h_scm_Queue$.prototype = $c_scm_Queue$.prototype;
$c_scm_Queue$.prototype.apply__sci_Seq__O = (function(elems) {
  var this$1 = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
  return $as_scm_Queue(this$1.addAll__sc_IterableOnce__scm_ArrayDeque(elems));
});
$c_scm_Queue$.prototype.newBuilder__scm_Builder = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_Queue__I__(new $c_scm_Queue(), 16));
});
$c_scm_Queue$.prototype.empty__O = (function() {
  return $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
});
$c_scm_Queue$.prototype.from__sc_IterableOnce__O = (function(source) {
  var this$1 = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
  return $as_scm_Queue(this$1.addAll__sc_IterableOnce__scm_ArrayDeque(source));
});
var $d_scm_Queue$ = new $TypeData().initClass($c_scm_Queue$, "scala.collection.mutable.Queue$", ({
  scm_Queue$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_scm_Queue$;
function $m_scm_Queue$() {
  if ((!$n_scm_Queue$)) {
    $n_scm_Queue$ = new $c_scm_Queue$();
  }
  return $n_scm_Queue$;
}
function $p_scm_RedBlackTree$TreeIterator__setNullIfAfterEnd__V($thiz) {
  var this$1 = $n($thiz.scm_RedBlackTree$TreeIterator__f_end);
  if ((((!this$1.isEmpty__Z()) && ($thiz.scm_RedBlackTree$TreeIterator__f_nextNode !== null)) && ($n($thiz.scm_RedBlackTree$TreeIterator__f_ord).compare__O__O__I($n($thiz.scm_RedBlackTree$TreeIterator__f_nextNode).scm_RedBlackTree$Node__f_key, $n($thiz.scm_RedBlackTree$TreeIterator__f_end).get__O()) >= 0))) {
    $thiz.scm_RedBlackTree$TreeIterator__f_nextNode = null;
  }
}
function $ct_scm_RedBlackTree$TreeIterator__scm_RedBlackTree$Tree__s_Option__s_Option__s_math_Ordering__($thiz, tree, start, end, ord) {
  $thiz.scm_RedBlackTree$TreeIterator__f_end = end;
  $thiz.scm_RedBlackTree$TreeIterator__f_ord = ord;
  var x = $m_s_None$();
  if ((x === start)) {
    var $x_1 = $m_scm_RedBlackTree$().scala$collection$mutable$RedBlackTree$$minNode__scm_RedBlackTree$Node__scm_RedBlackTree$Node($n(tree).scm_RedBlackTree$Tree__f_root);
  } else {
    if ((!(start instanceof $c_s_Some))) {
      throw new $c_s_MatchError(start);
    }
    var x3 = $as_s_Some(start);
    var from = $n(x3).s_Some__f_value;
    var $x_1 = $m_scm_RedBlackTree$().scala$collection$mutable$RedBlackTree$$minNodeAfter__scm_RedBlackTree$Node__O__s_math_Ordering__scm_RedBlackTree$Node($n(tree).scm_RedBlackTree$Tree__f_root, from, ord);
  }
  $thiz.scm_RedBlackTree$TreeIterator__f_nextNode = $x_1;
  $p_scm_RedBlackTree$TreeIterator__setNullIfAfterEnd__V($thiz);
  return $thiz;
}
/** @constructor */
function $c_scm_RedBlackTree$TreeIterator() {
  this.scm_RedBlackTree$TreeIterator__f_end = null;
  this.scm_RedBlackTree$TreeIterator__f_ord = null;
  this.scm_RedBlackTree$TreeIterator__f_nextNode = null;
}
$c_scm_RedBlackTree$TreeIterator.prototype = new $h_sc_AbstractIterator();
$c_scm_RedBlackTree$TreeIterator.prototype.constructor = $c_scm_RedBlackTree$TreeIterator;
/** @constructor */
function $h_scm_RedBlackTree$TreeIterator() {
}
$h_scm_RedBlackTree$TreeIterator.prototype = $c_scm_RedBlackTree$TreeIterator.prototype;
$c_scm_RedBlackTree$TreeIterator.prototype.hasNext__Z = (function() {
  return (this.scm_RedBlackTree$TreeIterator__f_nextNode !== null);
});
$c_scm_RedBlackTree$TreeIterator.prototype.next__O = (function() {
  var x1 = this.scm_RedBlackTree$TreeIterator__f_nextNode;
  if ((x1 === null)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator");
  } else {
    this.scm_RedBlackTree$TreeIterator__f_nextNode = $m_scm_RedBlackTree$().scala$collection$mutable$RedBlackTree$$successor__scm_RedBlackTree$Node__scm_RedBlackTree$Node(x1);
    $p_scm_RedBlackTree$TreeIterator__setNullIfAfterEnd__V(this);
    return $n(x1).scm_RedBlackTree$Node__f_key;
  }
});
/** @constructor */
function $c_scm_TreeSet$$anon$1(ordering$1) {
  this.scm_TreeSet$$anon$1__f_tree = null;
  this.scm_TreeSet$$anon$1__f_ordering$1 = null;
  this.scm_TreeSet$$anon$1__f_ordering$1 = ordering$1;
  this.scm_TreeSet$$anon$1__f_tree = new $c_scm_RedBlackTree$Tree(null, 0);
}
$c_scm_TreeSet$$anon$1.prototype = new $h_O();
$c_scm_TreeSet$$anon$1.prototype.constructor = $c_scm_TreeSet$$anon$1;
/** @constructor */
function $h_scm_TreeSet$$anon$1() {
}
$h_scm_TreeSet$$anon$1.prototype = $c_scm_TreeSet$$anon$1.prototype;
$c_scm_TreeSet$$anon$1.prototype.sizeHint__I__V = (function(size) {
});
$c_scm_TreeSet$$anon$1.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$c_scm_TreeSet$$anon$1.prototype.addOne__O__scm_TreeSet$$anon$1 = (function(elem) {
  $m_scm_RedBlackTree$().insert__scm_RedBlackTree$Tree__O__O__s_math_Ordering__V(this.scm_TreeSet$$anon$1__f_tree, elem, null, this.scm_TreeSet$$anon$1__f_ordering$1);
  return this;
});
$c_scm_TreeSet$$anon$1.prototype.result__scm_TreeSet = (function() {
  return $ct_scm_TreeSet__scm_RedBlackTree$Tree__s_math_Ordering__(new $c_scm_TreeSet(), this.scm_TreeSet$$anon$1__f_tree, this.scm_TreeSet$$anon$1__f_ordering$1);
});
$c_scm_TreeSet$$anon$1.prototype.result__O = (function() {
  return this.result__scm_TreeSet();
});
$c_scm_TreeSet$$anon$1.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_TreeSet$$anon$1(elem);
});
var $d_scm_TreeSet$$anon$1 = new $TypeData().initClass($c_scm_TreeSet$$anon$1, "scala.collection.mutable.TreeSet$$anon$1", ({
  scm_TreeSet$$anon$1: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
/** @constructor */
function $c_s_concurrent_ExecutionContext$parasitic$() {
  this.s_concurrent_ExecutionContext$parasitic$__f_scala$concurrent$BatchingExecutor$$_tasksLocal = null;
  $n_s_concurrent_ExecutionContext$parasitic$ = this;
  this.s_concurrent_ExecutionContext$parasitic$__f_scala$concurrent$BatchingExecutor$$_tasksLocal = new $c_jl_ThreadLocal();
}
$c_s_concurrent_ExecutionContext$parasitic$.prototype = new $h_O();
$c_s_concurrent_ExecutionContext$parasitic$.prototype.constructor = $c_s_concurrent_ExecutionContext$parasitic$;
/** @constructor */
function $h_s_concurrent_ExecutionContext$parasitic$() {
}
$h_s_concurrent_ExecutionContext$parasitic$.prototype = $c_s_concurrent_ExecutionContext$parasitic$.prototype;
$c_s_concurrent_ExecutionContext$parasitic$.prototype.execute__jl_Runnable__V = (function(runnable) {
  $f_s_concurrent_BatchingExecutor__submitSyncBatched__jl_Runnable__V(this, runnable);
});
$c_s_concurrent_ExecutionContext$parasitic$.prototype.reportFailure__jl_Throwable__V = (function(t) {
  $n($m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter).apply__O__O(t);
});
var $d_s_concurrent_ExecutionContext$parasitic$ = new $TypeData().initClass($c_s_concurrent_ExecutionContext$parasitic$, "scala.concurrent.ExecutionContext$parasitic$", ({
  s_concurrent_ExecutionContext$parasitic$: 1,
  s_concurrent_ExecutionContextExecutor: 1,
  s_concurrent_ExecutionContext: 1,
  ju_concurrent_Executor: 1,
  s_concurrent_BatchingExecutor: 1
}));
var $n_s_concurrent_ExecutionContext$parasitic$;
function $m_s_concurrent_ExecutionContext$parasitic$() {
  if ((!$n_s_concurrent_ExecutionContext$parasitic$)) {
    $n_s_concurrent_ExecutionContext$parasitic$ = new $c_s_concurrent_ExecutionContext$parasitic$();
  }
  return $n_s_concurrent_ExecutionContext$parasitic$;
}
/** @constructor */
function $c_s_concurrent_duration_Duration$Infinite() {
}
$c_s_concurrent_duration_Duration$Infinite.prototype = new $h_s_concurrent_duration_Duration();
$c_s_concurrent_duration_Duration$Infinite.prototype.constructor = $c_s_concurrent_duration_Duration$Infinite;
/** @constructor */
function $h_s_concurrent_duration_Duration$Infinite() {
}
$h_s_concurrent_duration_Duration$Infinite.prototype = $c_s_concurrent_duration_Duration$Infinite.prototype;
$c_s_concurrent_duration_Duration$Infinite.prototype.$plus__s_concurrent_duration_Duration__s_concurrent_duration_Duration = (function(other) {
  if ((other === $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Undefined)) {
    return $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Undefined;
  }
  if ((other instanceof $c_s_concurrent_duration_Duration$Infinite)) {
    var x2 = $as_s_concurrent_duration_Duration$Infinite(other);
    if ((x2 !== this)) {
      return $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Undefined;
    }
  }
  return this;
});
function $as_s_concurrent_duration_Duration$Infinite(obj) {
  return (((obj instanceof $c_s_concurrent_duration_Duration$Infinite) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.Duration$Infinite"));
}
function $isArrayOf_s_concurrent_duration_Duration$Infinite(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_Duration$Infinite)));
}
function $asArrayOf_s_concurrent_duration_Duration$Infinite(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_Duration$Infinite(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.Duration$Infinite;", depth));
}
function $p_s_concurrent_duration_FiniteDuration__bounded__J__Z($thiz, max) {
  var lo = max.RTLong__f_lo;
  var hi = max.RTLong__f_hi;
  var lo$1 = ((-lo) | 0);
  var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
  var b = $thiz.s_concurrent_duration_FiniteDuration__f_length;
  var bhi = b.RTLong__f_hi;
  if (((hi$1 === bhi) ? (((-2147483648) ^ lo$1) <= ((-2147483648) ^ b.RTLong__f_lo)) : (hi$1 < bhi))) {
    var this$3 = $thiz.s_concurrent_duration_FiniteDuration__f_length;
    var ahi = this$3.RTLong__f_hi;
    var bhi$1 = max.RTLong__f_hi;
    return ((ahi === bhi$1) ? (((-2147483648) ^ this$3.RTLong__f_lo) <= ((-2147483648) ^ max.RTLong__f_lo)) : (ahi < bhi$1));
  } else {
    return false;
  }
}
function $p_s_concurrent_duration_FiniteDuration__unitString__T($thiz) {
  var $x_1 = $as_T($n($m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_timeUnitName).apply__O__O($thiz.s_concurrent_duration_FiniteDuration__f_unit));
  var this$1 = $thiz.s_concurrent_duration_FiniteDuration__f_length;
  return ($x_1 + (((this$1.RTLong__f_lo === 1) && (this$1.RTLong__f_hi === 0)) ? "" : "s"));
}
function $p_s_concurrent_duration_FiniteDuration__safeAdd__J__J__J($thiz, a, b) {
  var ahi = b.RTLong__f_hi;
  if (((ahi === 0) ? (b.RTLong__f_lo !== 0) : (ahi > 0))) {
    var bhi = b.RTLong__f_hi;
    var lo = (((-1) - b.RTLong__f_lo) | 0);
    var hi = ((2147483647 - bhi) | 0);
    var ahi$1 = a.RTLong__f_hi;
    var $x_2 = ((ahi$1 === hi) ? (((-2147483648) ^ a.RTLong__f_lo) > ((-2147483648) ^ lo)) : (ahi$1 > hi));
  } else {
    var $x_2 = false;
  }
  if ($x_2) {
    var $x_1 = true;
  } else {
    var ahi$2 = b.RTLong__f_hi;
    if ((ahi$2 < 0)) {
      var bhi$1 = b.RTLong__f_hi;
      var lo$1 = ((-b.RTLong__f_lo) | 0);
      var hi$1 = ((lo$1 !== 0) ? ((2147483647 - bhi$1) | 0) : (((-2147483648) - bhi$1) | 0));
      var ahi$3 = a.RTLong__f_hi;
      var $x_1 = ((ahi$3 === hi$1) ? (((-2147483648) ^ a.RTLong__f_lo) < ((-2147483648) ^ lo$1)) : (ahi$3 < hi$1));
    } else {
      var $x_1 = false;
    }
  }
  if ($x_1) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "integer overflow");
  }
  var alo = a.RTLong__f_lo;
  var ahi$4 = a.RTLong__f_hi;
  var bhi$2 = b.RTLong__f_hi;
  var lo$2 = ((alo + b.RTLong__f_lo) | 0);
  var hi$2 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ alo)) ? ((1 + ((ahi$4 + bhi$2) | 0)) | 0) : ((ahi$4 + bhi$2) | 0));
  return new $c_RTLong(lo$2, hi$2);
}
function $p_s_concurrent_duration_FiniteDuration__add__J__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration($thiz, otherLength, otherUnit) {
  var this$1 = $n(otherUnit).convert__J__ju_concurrent_TimeUnit__J(new $c_RTLong(1, 0), $thiz.s_concurrent_duration_FiniteDuration__f_unit);
  if (((this$1.RTLong__f_lo === 0) && (this$1.RTLong__f_hi === 0))) {
    var commonUnit = $thiz.s_concurrent_duration_FiniteDuration__f_unit;
  } else {
    var commonUnit = otherUnit;
  }
  var t = $p_s_concurrent_duration_FiniteDuration__safeAdd__J__J__J($thiz, $n(commonUnit).convert__J__ju_concurrent_TimeUnit__J($thiz.s_concurrent_duration_FiniteDuration__f_length, $thiz.s_concurrent_duration_FiniteDuration__f_unit), $n(commonUnit).convert__J__ju_concurrent_TimeUnit__J(otherLength, otherUnit));
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo, hi), commonUnit);
}
/** @constructor */
function $c_s_concurrent_duration_FiniteDuration(length, unit) {
  this.s_concurrent_duration_FiniteDuration__f_length = $L0;
  this.s_concurrent_duration_FiniteDuration__f_unit = null;
  this.s_concurrent_duration_FiniteDuration__f_length = length;
  this.s_concurrent_duration_FiniteDuration__f_unit = unit;
  var x = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
  if ((x === null)) {
    var $x_1 = (unit === null);
  } else {
    var this$1 = $n(x);
    var $x_1 = (this$1 === unit);
  }
  if ($x_1) {
    var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong((-1), 2147483647));
  } else {
    var x$3 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
    if ((x$3 === null)) {
      var $x_2 = (unit === null);
    } else {
      var this$2 = $n(x$3);
      var $x_2 = (this$2 === unit);
    }
    if ($x_2) {
      var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong((-1511828489), 2147483));
    } else {
      var x$5 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
      if ((x$5 === null)) {
        var $x_3 = (unit === null);
      } else {
        var this$3 = $n(x$5);
        var $x_3 = (this$3 === unit);
      }
      if ($x_3) {
        var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(2077252342, 2147));
      } else {
        var x$7 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
        if ((x$7 === null)) {
          var $x_4 = (unit === null);
        } else {
          var this$4 = $n(x$7);
          var $x_4 = (this$4 === unit);
        }
        if ($x_4) {
          var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(633437444, 2));
        } else {
          var x$9 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MINUTES;
          if ((x$9 === null)) {
            var $x_5 = (unit === null);
          } else {
            var this$5 = $n(x$9);
            var $x_5 = (this$5 === unit);
          }
          if ($x_5) {
            var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(153722867, 0));
          } else {
            var x$11 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_HOURS;
            if ((x$11 === null)) {
              var $x_6 = (unit === null);
            } else {
              var this$6 = $n(x$11);
              var $x_6 = (this$6 === unit);
            }
            if ($x_6) {
              var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(2562047, 0));
            } else {
              var x$13 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS;
              if ((x$13 === null)) {
                var $x_7 = (unit === null);
              } else {
                var this$7 = $n(x$13);
                var $x_7 = (this$7 === unit);
              }
              if ($x_7) {
                var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(106751, 0));
              } else {
                var t = $n($m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS).convert__J__ju_concurrent_TimeUnit__J(length, unit);
                var lo = t.RTLong__f_lo;
                var hi = t.RTLong__f_hi;
                var requirement = (((hi === (-1)) ? (((-2147483648) ^ lo) >= 2147376897) : (hi > (-1))) && ((hi === 0) ? (((-2147483648) ^ lo) <= (-2147376897)) : (hi < 0)));
              }
            }
          }
        }
      }
    }
  }
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: Duration is limited to +-(2^63-1)ns (ca. 292 years)");
  }
}
$c_s_concurrent_duration_FiniteDuration.prototype = new $h_s_concurrent_duration_Duration();
$c_s_concurrent_duration_FiniteDuration.prototype.constructor = $c_s_concurrent_duration_FiniteDuration;
/** @constructor */
function $h_s_concurrent_duration_FiniteDuration() {
}
$h_s_concurrent_duration_FiniteDuration.prototype = $c_s_concurrent_duration_FiniteDuration.prototype;
$c_s_concurrent_duration_FiniteDuration.prototype.toString__T = (function() {
  return ((this.s_concurrent_duration_FiniteDuration__f_length + " ") + $p_s_concurrent_duration_FiniteDuration__unitString__T(this));
});
$c_s_concurrent_duration_FiniteDuration.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  if ((other instanceof $c_s_concurrent_duration_FiniteDuration)) {
    var x2 = $as_s_concurrent_duration_FiniteDuration(other);
    var t = $n(this.s_concurrent_duration_FiniteDuration__f_unit).toNanos__J__J(this.s_concurrent_duration_FiniteDuration__f_length);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var this$3 = new $c_sr_RichLong(new $c_RTLong(lo, hi));
    var this$2 = $n(x2);
    var t$1 = $n(this$2.s_concurrent_duration_FiniteDuration__f_unit).toNanos__J__J(this$2.s_concurrent_duration_FiniteDuration__f_length);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var t$3 = this$3.sr_RichLong__f_self;
    var lo$3 = t$3.RTLong__f_lo;
    var hi$3 = t$3.RTLong__f_hi;
    var t$4 = $uJ(new $c_RTLong(lo$3, hi$3));
    var lo$4 = t$4.RTLong__f_lo;
    var hi$4 = t$4.RTLong__f_hi;
    var t$5 = $uJ(new $c_RTLong(lo$1, hi$1));
    var lo$5 = t$5.RTLong__f_lo;
    var hi$5 = t$5.RTLong__f_hi;
    return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo$4, hi$4, lo$5, hi$5);
  } else {
    var this$6 = $n(other);
    return ((-this$6.compare__s_concurrent_duration_Duration__I(this)) | 0);
  }
});
$c_s_concurrent_duration_FiniteDuration.prototype.$plus__s_concurrent_duration_Duration__s_concurrent_duration_Duration = (function(other) {
  if ((other instanceof $c_s_concurrent_duration_FiniteDuration)) {
    var x2 = $as_s_concurrent_duration_FiniteDuration(other);
    return $p_s_concurrent_duration_FiniteDuration__add__J__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration(this, $n(x2).s_concurrent_duration_FiniteDuration__f_length, $n(x2).s_concurrent_duration_FiniteDuration__f_unit);
  } else {
    return other;
  }
});
$c_s_concurrent_duration_FiniteDuration.prototype.$times__D__s_concurrent_duration_Duration = (function(factor) {
  if ((!((factor === Infinity) || (factor === (-Infinity))))) {
    var $x_1 = $m_s_concurrent_duration_Duration$();
    var this$3 = $n(this.s_concurrent_duration_FiniteDuration__f_unit).toNanos__J__J(this.s_concurrent_duration_FiniteDuration__f_length);
    return $n($x_1).fromNanos__D__s_concurrent_duration_Duration(($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$3.RTLong__f_lo, this$3.RTLong__f_hi) * factor));
  } else if ((factor !== factor)) {
    return $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Undefined;
  } else {
    var that = $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Zero;
    if (((factor > 0.0) !== $f_s_math_Ordered__$less__O__Z(this, that))) {
      return $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Inf;
    } else {
      return $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_MinusInf;
    }
  }
});
$c_s_concurrent_duration_FiniteDuration.prototype.$minus__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration = (function(other) {
  var this$1 = $n(other).s_concurrent_duration_FiniteDuration__f_length;
  var lo = this$1.RTLong__f_lo;
  var hi = this$1.RTLong__f_hi;
  var lo$1 = ((-lo) | 0);
  var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
  return $p_s_concurrent_duration_FiniteDuration__add__J__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration(this, new $c_RTLong(lo$1, hi$1), $n(other).s_concurrent_duration_FiniteDuration__f_unit);
});
$c_s_concurrent_duration_FiniteDuration.prototype.max__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration = (function(other) {
  return ($f_s_math_Ordered__$greater__O__Z(this, other) ? this : other);
});
$c_s_concurrent_duration_FiniteDuration.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_s_concurrent_duration_FiniteDuration)) {
    var x2 = $as_s_concurrent_duration_FiniteDuration(other);
    var this$2 = $n(this.s_concurrent_duration_FiniteDuration__f_unit).toNanos__J__J(this.s_concurrent_duration_FiniteDuration__f_length);
    var this$1 = $n(x2);
    var b = $n(this$1.s_concurrent_duration_FiniteDuration__f_unit).toNanos__J__J(this$1.s_concurrent_duration_FiniteDuration__f_length);
    return ((this$2.RTLong__f_lo === b.RTLong__f_lo) && (this$2.RTLong__f_hi === b.RTLong__f_hi));
  } else {
    return (this === other);
  }
});
$c_s_concurrent_duration_FiniteDuration.prototype.hashCode__I = (function() {
  var this$1 = $n(this.s_concurrent_duration_FiniteDuration__f_unit).toNanos__J__J(this.s_concurrent_duration_FiniteDuration__f_length);
  return this$1.RTLong__f_lo;
});
$c_s_concurrent_duration_FiniteDuration.prototype.compare__O__I = (function(that) {
  return this.compare__s_concurrent_duration_Duration__I($as_s_concurrent_duration_Duration(that));
});
function $as_s_concurrent_duration_FiniteDuration(obj) {
  return (((obj instanceof $c_s_concurrent_duration_FiniteDuration) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.FiniteDuration"));
}
function $isArrayOf_s_concurrent_duration_FiniteDuration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_FiniteDuration)));
}
function $asArrayOf_s_concurrent_duration_FiniteDuration(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_FiniteDuration(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.FiniteDuration;", depth));
}
var $d_s_concurrent_duration_FiniteDuration = new $TypeData().initClass($c_s_concurrent_duration_FiniteDuration, "scala.concurrent.duration.FiniteDuration", ({
  s_concurrent_duration_FiniteDuration: 1,
  s_concurrent_duration_Duration: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
}));
function $f_s_math_Ordering__lteq__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) <= 0);
}
function $f_s_math_Ordering__gteq__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) >= 0);
}
function $f_s_math_Ordering__lt__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) < 0);
}
function $f_s_math_Ordering__gt__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) > 0);
}
function $f_s_math_Ordering__equiv__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) === 0);
}
function $f_s_math_Ordering__max__O__O__O($thiz, x, y) {
  return ($thiz.gteq__O__O__Z(x, y) ? x : y);
}
function $f_s_math_Ordering__min__O__O__O($thiz, x, y) {
  return ($thiz.lteq__O__O__Z(x, y) ? x : y);
}
function $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z($thiz, other) {
  if ((other instanceof $c_s_math_Ordering$Reverse)) {
    var x2 = $as_s_math_Ordering$Reverse(other);
    var x = $n(x2).s_math_Ordering$Reverse__f_outer;
    return ((x !== null) && $n(x).equals__O__Z($thiz));
  } else {
    return false;
  }
}
function $is_s_math_Ordering(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_math_Ordering)));
}
function $as_s_math_Ordering(obj) {
  return (($is_s_math_Ordering(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Ordering"));
}
function $isArrayOf_s_math_Ordering(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Ordering)));
}
function $asArrayOf_s_math_Ordering(obj, depth) {
  return (($isArrayOf_s_math_Ordering(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Ordering;", depth));
}
function $f_s_reflect_ClassTag__unapply__O__s_Option($thiz, x) {
  return ($n($thiz.runtimeClass__jl_Class()).isInstance__O__Z(x) ? new $c_s_Some(x) : $m_s_None$());
}
function $f_s_reflect_ClassTag__equals__O__Z($thiz, x) {
  if ($is_s_reflect_ClassTag(x)) {
    var x$2 = $thiz.runtimeClass__jl_Class();
    var x$3 = $n($as_s_reflect_ClassTag(x)).runtimeClass__jl_Class();
    if ((x$2 === null)) {
      return (x$3 === null);
    } else {
      var this$1 = $n(x$2);
      return (this$1 === x$3);
    }
  } else {
    return false;
  }
}
function $p_s_reflect_ClassTag__prettyprint$1__jl_Class__T($thiz, clazz) {
  return ($n(clazz).isArray__Z() ? (("Array[" + $p_s_reflect_ClassTag__prettyprint$1__jl_Class__T($thiz, $n(clazz).getComponentType__jl_Class())) + "]") : $n(clazz).getName__T());
}
function $is_s_reflect_ClassTag(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_reflect_ClassTag)));
}
function $as_s_reflect_ClassTag(obj) {
  return (($is_s_reflect_ClassTag(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.reflect.ClassTag"));
}
function $isArrayOf_s_reflect_ClassTag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_reflect_ClassTag)));
}
function $asArrayOf_s_reflect_ClassTag(obj, depth) {
  return (($isArrayOf_s_reflect_ClassTag(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.reflect.ClassTag;", depth));
}
/** @constructor */
function $c_sr_ScalaRunTime$$anon$1(x$2) {
  this.sr_ScalaRunTime$$anon$1__f_c = 0;
  this.sr_ScalaRunTime$$anon$1__f_cmax = 0;
  this.sr_ScalaRunTime$$anon$1__f_x$2 = null;
  this.sr_ScalaRunTime$$anon$1__f_x$2 = x$2;
  this.sr_ScalaRunTime$$anon$1__f_c = 0;
  this.sr_ScalaRunTime$$anon$1__f_cmax = $n(x$2).productArity__I();
}
$c_sr_ScalaRunTime$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sr_ScalaRunTime$$anon$1.prototype.constructor = $c_sr_ScalaRunTime$$anon$1;
/** @constructor */
function $h_sr_ScalaRunTime$$anon$1() {
}
$h_sr_ScalaRunTime$$anon$1.prototype = $c_sr_ScalaRunTime$$anon$1.prototype;
$c_sr_ScalaRunTime$$anon$1.prototype.hasNext__Z = (function() {
  return (this.sr_ScalaRunTime$$anon$1__f_c < this.sr_ScalaRunTime$$anon$1__f_cmax);
});
$c_sr_ScalaRunTime$$anon$1.prototype.next__O = (function() {
  var result = $n(this.sr_ScalaRunTime$$anon$1__f_x$2).productElement__I__O(this.sr_ScalaRunTime$$anon$1__f_c);
  this.sr_ScalaRunTime$$anon$1__f_c = ((1 + this.sr_ScalaRunTime$$anon$1__f_c) | 0);
  return result;
});
var $d_sr_ScalaRunTime$$anon$1 = new $TypeData().initClass($c_sr_ScalaRunTime$$anon$1, "scala.runtime.ScalaRunTime$$anon$1", ({
  sr_ScalaRunTime$$anon$1: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sjs_js_WrappedArray$() {
}
$c_sjs_js_WrappedArray$.prototype = new $h_O();
$c_sjs_js_WrappedArray$.prototype.constructor = $c_sjs_js_WrappedArray$;
/** @constructor */
function $h_sjs_js_WrappedArray$() {
}
$h_sjs_js_WrappedArray$.prototype = $c_sjs_js_WrappedArray$.prototype;
$c_sjs_js_WrappedArray$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sjs_js_WrappedArray(elems);
});
$c_sjs_js_WrappedArray$.prototype.newBuilder__scm_Builder = (function() {
  return $ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray());
});
$c_sjs_js_WrappedArray$.prototype.from__sc_IterableOnce__sjs_js_WrappedArray = (function(source) {
  var this$1 = $ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray());
  return $as_sjs_js_WrappedArray($n($as_scm_Builder($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this$1, source))).result__O());
});
$c_sjs_js_WrappedArray$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sjs_js_WrappedArray(source);
});
$c_sjs_js_WrappedArray$.prototype.empty__O = (function() {
  return $ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray());
});
var $d_sjs_js_WrappedArray$ = new $TypeData().initClass($c_sjs_js_WrappedArray$, "scala.scalajs.js.WrappedArray$", ({
  sjs_js_WrappedArray$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sjs_js_WrappedArray$;
function $m_sjs_js_WrappedArray$() {
  if ((!$n_sjs_js_WrappedArray$)) {
    $n_sjs_js_WrappedArray$ = new $c_sjs_js_WrappedArray$();
  }
  return $n_sjs_js_WrappedArray$;
}
/** @constructor */
function $c_sjsr_WrappedVarArgs$() {
}
$c_sjsr_WrappedVarArgs$.prototype = new $h_O();
$c_sjsr_WrappedVarArgs$.prototype.constructor = $c_sjsr_WrappedVarArgs$;
/** @constructor */
function $h_sjsr_WrappedVarArgs$() {
}
$h_sjsr_WrappedVarArgs$.prototype = $c_sjsr_WrappedVarArgs$.prototype;
$c_sjsr_WrappedVarArgs$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sjsr_WrappedVarArgs(elems);
});
$c_sjsr_WrappedVarArgs$.prototype.from__sc_IterableOnce__sjsr_WrappedVarArgs = (function(source) {
  var this$1 = $n(this.newBuilder__scm_Builder());
  return $as_sjsr_WrappedVarArgs($n($as_scm_Builder(this$1.addAll__sc_IterableOnce__scm_Growable(source))).result__O());
});
$c_sjsr_WrappedVarArgs$.prototype.newBuilder__scm_Builder = (function() {
  var array = [];
  var this$4 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), array);
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_sjs_js_WrappedArray(x$1$2);
    return $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), $n(x$1).sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array);
  }));
  return new $c_scm_Builder$$anon$1(this$4, f);
});
$c_sjsr_WrappedVarArgs$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sjsr_WrappedVarArgs(source);
});
$c_sjsr_WrappedVarArgs$.prototype.empty__O = (function() {
  return $ct_sjsr_WrappedVarArgs__(new $c_sjsr_WrappedVarArgs());
});
var $d_sjsr_WrappedVarArgs$ = new $TypeData().initClass($c_sjsr_WrappedVarArgs$, "scala.scalajs.runtime.WrappedVarArgs$", ({
  sjsr_WrappedVarArgs$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sjsr_WrappedVarArgs$;
function $m_sjsr_WrappedVarArgs$() {
  if ((!$n_sjsr_WrappedVarArgs$)) {
    $n_sjsr_WrappedVarArgs$ = new $c_sjsr_WrappedVarArgs$();
  }
  return $n_sjsr_WrappedVarArgs$;
}
/** @constructor */
function $c_s_util_Failure(exception) {
  this.s_util_Failure__f_exception = null;
  this.s_util_Failure__f_exception = exception;
}
$c_s_util_Failure.prototype = new $h_s_util_Try();
$c_s_util_Failure.prototype.constructor = $c_s_util_Failure;
/** @constructor */
function $h_s_util_Failure() {
}
$h_s_util_Failure.prototype = $c_s_util_Failure.prototype;
$c_s_util_Failure.prototype.get__O = (function() {
  var $x_1 = this.s_util_Failure__f_exception;
  throw (($x_1 instanceof $c_sjs_js_JavaScriptException) ? $x_1.sjs_js_JavaScriptException__f_exception : $n($x_1));
});
$c_s_util_Failure.prototype.getOrElse__F0__O = (function(default$1) {
  return $n(default$1).apply__O();
});
$c_s_util_Failure.prototype.foreach__F1__V = (function(f) {
});
$c_s_util_Failure.prototype.map__F1__s_util_Try = (function(f) {
  return this;
});
$c_s_util_Failure.prototype.recover__s_PartialFunction__s_util_Try = (function(pf) {
  var marker = $m_sr_Statics$PFMarker$();
  try {
    var v = $n(pf).applyOrElse__O__F1__O(this.s_util_Failure__f_exception, new $c_sjsr_AnonFunction1(((x$2) => {
      $as_jl_Throwable(x$2);
      return marker;
    })));
    return ((marker !== v) ? new $c_s_util_Success(v) : this);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      return new $c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2));
    }
  }
});
$c_s_util_Failure.prototype.toOption__s_Option = (function() {
  return $m_s_None$();
});
$c_s_util_Failure.prototype.toEither__s_util_Either = (function() {
  return new $c_s_util_Left(this.s_util_Failure__f_exception);
});
$c_s_util_Failure.prototype.productPrefix__T = (function() {
  return "Failure";
});
$c_s_util_Failure.prototype.productArity__I = (function() {
  return 1;
});
$c_s_util_Failure.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Failure__f_exception : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_s_util_Failure.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_s_util_Failure.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_s_util_Failure.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_s_util_Failure.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_s_util_Failure)) {
    var Failure$1 = $as_s_util_Failure(x$1);
    var x = this.s_util_Failure__f_exception;
    var x$2 = $n(Failure$1).s_util_Failure__f_exception;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
function $as_s_util_Failure(obj) {
  return (((obj instanceof $c_s_util_Failure) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Failure"));
}
function $isArrayOf_s_util_Failure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Failure)));
}
function $asArrayOf_s_util_Failure(obj, depth) {
  return (($isArrayOf_s_util_Failure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Failure;", depth));
}
var $d_s_util_Failure = new $TypeData().initClass($c_s_util_Failure, "scala.util.Failure", ({
  s_util_Failure: 1,
  s_util_Try: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_util_Left(value) {
  this.s_util_Left__f_value = null;
  this.s_util_Left__f_value = value;
}
$c_s_util_Left.prototype = new $h_s_util_Either();
$c_s_util_Left.prototype.constructor = $c_s_util_Left;
/** @constructor */
function $h_s_util_Left() {
}
$h_s_util_Left.prototype = $c_s_util_Left.prototype;
$c_s_util_Left.prototype.isRight__Z = (function() {
  return false;
});
$c_s_util_Left.prototype.productPrefix__T = (function() {
  return "Left";
});
$c_s_util_Left.prototype.productArity__I = (function() {
  return 1;
});
$c_s_util_Left.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Left__f_value : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_s_util_Left.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_s_util_Left.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_s_util_Left.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_s_util_Left.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_s_util_Left)) {
    var Left$1 = $as_s_util_Left(x$1);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(this.s_util_Left__f_value, $n(Left$1).s_util_Left__f_value);
  } else {
    return false;
  }
});
function $as_s_util_Left(obj) {
  return (((obj instanceof $c_s_util_Left) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Left"));
}
function $isArrayOf_s_util_Left(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Left)));
}
function $asArrayOf_s_util_Left(obj, depth) {
  return (($isArrayOf_s_util_Left(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Left;", depth));
}
var $d_s_util_Left = new $TypeData().initClass($c_s_util_Left, "scala.util.Left", ({
  s_util_Left: 1,
  s_util_Either: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_util_Right(value) {
  this.s_util_Right__f_value = null;
  this.s_util_Right__f_value = value;
}
$c_s_util_Right.prototype = new $h_s_util_Either();
$c_s_util_Right.prototype.constructor = $c_s_util_Right;
/** @constructor */
function $h_s_util_Right() {
}
$h_s_util_Right.prototype = $c_s_util_Right.prototype;
$c_s_util_Right.prototype.isRight__Z = (function() {
  return true;
});
$c_s_util_Right.prototype.productPrefix__T = (function() {
  return "Right";
});
$c_s_util_Right.prototype.productArity__I = (function() {
  return 1;
});
$c_s_util_Right.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Right__f_value : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_s_util_Right.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_s_util_Right.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_s_util_Right.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_s_util_Right.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_s_util_Right)) {
    var Right$1 = $as_s_util_Right(x$1);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(this.s_util_Right__f_value, $n(Right$1).s_util_Right__f_value);
  } else {
    return false;
  }
});
function $as_s_util_Right(obj) {
  return (((obj instanceof $c_s_util_Right) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Right"));
}
function $isArrayOf_s_util_Right(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Right)));
}
function $asArrayOf_s_util_Right(obj, depth) {
  return (($isArrayOf_s_util_Right(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Right;", depth));
}
var $d_s_util_Right = new $TypeData().initClass($c_s_util_Right, "scala.util.Right", ({
  s_util_Right: 1,
  s_util_Either: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_util_Success(value) {
  this.s_util_Success__f_value = null;
  this.s_util_Success__f_value = value;
}
$c_s_util_Success.prototype = new $h_s_util_Try();
$c_s_util_Success.prototype.constructor = $c_s_util_Success;
/** @constructor */
function $h_s_util_Success() {
}
$h_s_util_Success.prototype = $c_s_util_Success.prototype;
$c_s_util_Success.prototype.get__O = (function() {
  return this.s_util_Success__f_value;
});
$c_s_util_Success.prototype.getOrElse__F0__O = (function(default$1) {
  return this.s_util_Success__f_value;
});
$c_s_util_Success.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O(this.s_util_Success__f_value);
});
$c_s_util_Success.prototype.map__F1__s_util_Try = (function(f) {
  try {
    var r1 = $n(f).apply__O__O(this.s_util_Success__f_value);
    return new $c_s_util_Success(r1);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      return new $c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : $n(e$2));
    }
  }
});
$c_s_util_Success.prototype.recover__s_PartialFunction__s_util_Try = (function(pf) {
  return this;
});
$c_s_util_Success.prototype.toOption__s_Option = (function() {
  return new $c_s_Some(this.s_util_Success__f_value);
});
$c_s_util_Success.prototype.toEither__s_util_Either = (function() {
  return new $c_s_util_Right(this.s_util_Success__f_value);
});
$c_s_util_Success.prototype.productPrefix__T = (function() {
  return "Success";
});
$c_s_util_Success.prototype.productArity__I = (function() {
  return 1;
});
$c_s_util_Success.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Success__f_value : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_s_util_Success.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_s_util_Success.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_s_util_Success.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_s_util_Success.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_s_util_Success)) {
    var Success$1 = $as_s_util_Success(x$1);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(this.s_util_Success__f_value, $n(Success$1).s_util_Success__f_value);
  } else {
    return false;
  }
});
function $as_s_util_Success(obj) {
  return (((obj instanceof $c_s_util_Success) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Success"));
}
function $isArrayOf_s_util_Success(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Success)));
}
function $asArrayOf_s_util_Success(obj, depth) {
  return (($isArrayOf_s_util_Success(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Success;", depth));
}
var $d_s_util_Success = new $TypeData().initClass($c_s_util_Success, "scala.util.Success", ({
  s_util_Success: 1,
  s_util_Try: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lsnabbdom_init$$anon$2() {
}
$c_Lsnabbdom_init$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Lsnabbdom_init$$anon$2.prototype.constructor = $c_Lsnabbdom_init$$anon$2;
/** @constructor */
function $h_Lsnabbdom_init$$anon$2() {
}
$h_Lsnabbdom_init$$anon$2.prototype = $c_Lsnabbdom_init$$anon$2.prototype;
$c_Lsnabbdom_init$$anon$2.prototype.isDefinedAt__s_Option__Z = (function(x) {
  return ((x instanceof $c_s_Some) && ($as_T2($n($as_s_Some(x)).s_Some__f_value), true));
});
$c_Lsnabbdom_init$$anon$2.prototype.applyOrElse__s_Option__F1__O = (function(x, default$1) {
  if ((x instanceof $c_s_Some)) {
    var a = $as_T2($n($as_s_Some(x)).s_Some__f_value);
    return a;
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Lsnabbdom_init$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__s_Option__Z($as_s_Option(x));
});
$c_Lsnabbdom_init$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__s_Option__F1__O($as_s_Option(x), default$1);
});
var $d_Lsnabbdom_init$$anon$2 = new $TypeData().initClass($c_Lsnabbdom_init$$anon$2, "snabbdom.init$$anon$2", ({
  Lsnabbdom_init$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_Attribute(name, value) {
  this.Ltyrian_Attribute__f_name = null;
  this.Ltyrian_Attribute__f_value = null;
  this.Ltyrian_Attribute__f_name = name;
  this.Ltyrian_Attribute__f_value = value;
}
$c_Ltyrian_Attribute.prototype = new $h_O();
$c_Ltyrian_Attribute.prototype.constructor = $c_Ltyrian_Attribute;
/** @constructor */
function $h_Ltyrian_Attribute() {
}
$h_Ltyrian_Attribute.prototype = $c_Ltyrian_Attribute.prototype;
$c_Ltyrian_Attribute.prototype.toString__T = (function() {
  return $m_Ltyrian_HTMLRendering$package$().render__Ltyrian_Attr__T(this);
});
$c_Ltyrian_Attribute.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Attribute.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Ltyrian_Attribute.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_Attribute)) {
    var x$0$2 = $as_Ltyrian_Attribute(x$0);
    return ((this.Ltyrian_Attribute__f_name === $n(x$0$2).Ltyrian_Attribute__f_name) && (this.Ltyrian_Attribute__f_value === $n(x$0$2).Ltyrian_Attribute__f_value));
  } else {
    return false;
  }
});
$c_Ltyrian_Attribute.prototype.productArity__I = (function() {
  return 2;
});
$c_Ltyrian_Attribute.prototype.productPrefix__T = (function() {
  return "Attribute";
});
$c_Ltyrian_Attribute.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Attribute__f_name;
  }
  if ((n === 1)) {
    return this.Ltyrian_Attribute__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Ltyrian_Attribute(obj) {
  return (((obj instanceof $c_Ltyrian_Attribute) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Attribute"));
}
function $isArrayOf_Ltyrian_Attribute(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Attribute)));
}
function $asArrayOf_Ltyrian_Attribute(obj, depth) {
  return (($isArrayOf_Ltyrian_Attribute(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Attribute;", depth));
}
var $d_Ltyrian_Attribute = new $TypeData().initClass($c_Ltyrian_Attribute, "tyrian.Attribute", ({
  Ltyrian_Attribute: 1,
  Ltyrian_Attr: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $as_Ltyrian_Cmd$Batch(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Cmd$Batch"));
}
function $isArrayOf_Ltyrian_Cmd$Batch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Cmd$Batch)));
}
function $asArrayOf_Ltyrian_Cmd$Batch(obj, depth) {
  return (($isArrayOf_Ltyrian_Cmd$Batch(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Cmd$Batch;", depth));
}
/** @constructor */
function $c_Ltyrian_Cmd$Combine(cmd1, cmd2) {
  this.Ltyrian_Cmd$Combine__f_cmd1 = null;
  this.Ltyrian_Cmd$Combine__f_cmd2 = null;
  this.Ltyrian_Cmd$Combine__f_cmd1 = cmd1;
  this.Ltyrian_Cmd$Combine__f_cmd2 = cmd2;
}
$c_Ltyrian_Cmd$Combine.prototype = new $h_O();
$c_Ltyrian_Cmd$Combine.prototype.constructor = $c_Ltyrian_Cmd$Combine;
/** @constructor */
function $h_Ltyrian_Cmd$Combine() {
}
$h_Ltyrian_Cmd$Combine.prototype = $c_Ltyrian_Cmd$Combine.prototype;
$c_Ltyrian_Cmd$Combine.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Cmd$Combine.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Ltyrian_Cmd$Combine.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_Cmd$Combine)) {
    var x$0$2 = $as_Ltyrian_Cmd$Combine(x$0);
    var x = this.Ltyrian_Cmd$Combine__f_cmd1;
    var x$2 = $n(x$0$2).Ltyrian_Cmd$Combine__f_cmd1;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Ltyrian_Cmd$Combine__f_cmd2;
      var x$4 = $n(x$0$2).Ltyrian_Cmd$Combine__f_cmd2;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ltyrian_Cmd$Combine.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ltyrian_Cmd$Combine.prototype.productArity__I = (function() {
  return 2;
});
$c_Ltyrian_Cmd$Combine.prototype.productPrefix__T = (function() {
  return "Combine";
});
$c_Ltyrian_Cmd$Combine.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Cmd$Combine__f_cmd1;
  }
  if ((n === 1)) {
    return this.Ltyrian_Cmd$Combine__f_cmd2;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Ltyrian_Cmd$Combine(obj) {
  return (((obj instanceof $c_Ltyrian_Cmd$Combine) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Cmd$Combine"));
}
function $isArrayOf_Ltyrian_Cmd$Combine(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Cmd$Combine)));
}
function $asArrayOf_Ltyrian_Cmd$Combine(obj, depth) {
  return (($isArrayOf_Ltyrian_Cmd$Combine(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Cmd$Combine;", depth));
}
var $d_Ltyrian_Cmd$Combine = new $TypeData().initClass($c_Ltyrian_Cmd$Combine, "tyrian.Cmd$Combine", ({
  Ltyrian_Cmd$Combine: 1,
  Ltyrian_Cmd: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $as_Ltyrian_Cmd$Emit(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Cmd$Emit"));
}
function $isArrayOf_Ltyrian_Cmd$Emit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Cmd$Emit)));
}
function $asArrayOf_Ltyrian_Cmd$Emit(obj, depth) {
  return (($isArrayOf_Ltyrian_Cmd$Emit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Cmd$Emit;", depth));
}
/** @constructor */
function $c_Ltyrian_Cmd$Run(task, toMsg, evidence$1) {
  this.Ltyrian_Cmd$Run__f_task = null;
  this.Ltyrian_Cmd$Run__f_toMsg = null;
  this.Ltyrian_Cmd$Run__f_evidence$1 = null;
  this.Ltyrian_Cmd$Run__f_task = task;
  this.Ltyrian_Cmd$Run__f_toMsg = toMsg;
  this.Ltyrian_Cmd$Run__f_evidence$1 = evidence$1;
}
$c_Ltyrian_Cmd$Run.prototype = new $h_O();
$c_Ltyrian_Cmd$Run.prototype.constructor = $c_Ltyrian_Cmd$Run;
/** @constructor */
function $h_Ltyrian_Cmd$Run() {
}
$h_Ltyrian_Cmd$Run.prototype = $c_Ltyrian_Cmd$Run.prototype;
$c_Ltyrian_Cmd$Run.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Cmd$Run.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Ltyrian_Cmd$Run.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_Cmd$Run)) {
    var x$0$2 = $as_Ltyrian_Cmd$Run(x$0);
    var x = this.Ltyrian_Cmd$Run__f_task;
    var y = $n(x$0$2).Ltyrian_Cmd$Run__f_task;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Ltyrian_Cmd$Run__f_toMsg;
      var x$2 = $n(x$0$2).Ltyrian_Cmd$Run__f_toMsg;
      return ((x$1 === null) ? (x$2 === null) : $n(x$1).equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ltyrian_Cmd$Run.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ltyrian_Cmd$Run.prototype.productArity__I = (function() {
  return 2;
});
$c_Ltyrian_Cmd$Run.prototype.productPrefix__T = (function() {
  return "Run";
});
$c_Ltyrian_Cmd$Run.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Cmd$Run__f_task;
  }
  if ((n === 1)) {
    return this.Ltyrian_Cmd$Run__f_toMsg;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Ltyrian_Cmd$Run.prototype.toTask__O = (function() {
  var instance = this.Ltyrian_Cmd$Run__f_evidence$1;
  return $n(instance).map__O__F1__O(this.Ltyrian_Cmd$Run__f_task, this.Ltyrian_Cmd$Run__f_toMsg);
});
function $as_Ltyrian_Cmd$Run(obj) {
  return (((obj instanceof $c_Ltyrian_Cmd$Run) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Cmd$Run"));
}
function $isArrayOf_Ltyrian_Cmd$Run(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Cmd$Run)));
}
function $asArrayOf_Ltyrian_Cmd$Run(obj, depth) {
  return (($isArrayOf_Ltyrian_Cmd$Run(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Cmd$Run;", depth));
}
var $d_Ltyrian_Cmd$Run = new $TypeData().initClass($c_Ltyrian_Cmd$Run, "tyrian.Cmd$Run", ({
  Ltyrian_Cmd$Run: 1,
  Ltyrian_Cmd: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $as_Ltyrian_Cmd$SideEffect(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Cmd$SideEffect"));
}
function $isArrayOf_Ltyrian_Cmd$SideEffect(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Cmd$SideEffect)));
}
function $asArrayOf_Ltyrian_Cmd$SideEffect(obj, depth) {
  return (($isArrayOf_Ltyrian_Cmd$SideEffect(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Cmd$SideEffect;", depth));
}
function $as_Ltyrian_Event(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Event"));
}
function $isArrayOf_Ltyrian_Event(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Event)));
}
function $asArrayOf_Ltyrian_Event(obj, depth) {
  return (($isArrayOf_Ltyrian_Event(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Event;", depth));
}
/** @constructor */
function $c_Ltyrian_Html$() {
  this.Ltyrian_Html$__f_$u0060class$u0060$minusString = null;
  this.Ltyrian_Html$__f_id$minusString = null;
  $n_Ltyrian_Html$ = this;
  $f_Ltyrian_HtmlAttributes__$init$__V(this);
}
$c_Ltyrian_Html$.prototype = new $h_O();
$c_Ltyrian_Html$.prototype.constructor = $c_Ltyrian_Html$;
/** @constructor */
function $h_Ltyrian_Html$() {
}
$h_Ltyrian_Html$.prototype = $c_Ltyrian_Html$.prototype;
var $d_Ltyrian_Html$ = new $TypeData().initClass($c_Ltyrian_Html$, "tyrian.Html$", ({
  Ltyrian_Html$: 1,
  Ltyrian_HtmlTags: 1,
  Ltyrian_HtmlAttributes: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Ltyrian_Html$;
function $m_Ltyrian_Html$() {
  if ((!$n_Ltyrian_Html$)) {
    $n_Ltyrian_Html$ = new $c_Ltyrian_Html$();
  }
  return $n_Ltyrian_Html$;
}
/** @constructor */
function $c_Ltyrian_Location$External(locationDetails) {
  this.Ltyrian_Location$External__f_locationDetails = null;
  this.Ltyrian_Location$External__f_isInternal = false;
  this.Ltyrian_Location$External__f_locationDetails = locationDetails;
  this.Ltyrian_Location$External__f_isInternal = false;
}
$c_Ltyrian_Location$External.prototype = new $h_O();
$c_Ltyrian_Location$External.prototype.constructor = $c_Ltyrian_Location$External;
/** @constructor */
function $h_Ltyrian_Location$External() {
}
$h_Ltyrian_Location$External.prototype = $c_Ltyrian_Location$External.prototype;
$c_Ltyrian_Location$External.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Location$External.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Ltyrian_Location$External.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_Location$External)) {
    var x$0$2 = $as_Ltyrian_Location$External(x$0);
    var x = this.Ltyrian_Location$External__f_locationDetails;
    var x$2 = $n(x$0$2).Ltyrian_Location$External__f_locationDetails;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Ltyrian_Location$External.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ltyrian_Location$External.prototype.productArity__I = (function() {
  return 1;
});
$c_Ltyrian_Location$External.prototype.productPrefix__T = (function() {
  return "External";
});
$c_Ltyrian_Location$External.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Location$External__f_locationDetails;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Ltyrian_Location$External.prototype.isInternal__Z = (function() {
  return this.Ltyrian_Location$External__f_isInternal;
});
function $as_Ltyrian_Location$External(obj) {
  return (((obj instanceof $c_Ltyrian_Location$External) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Location$External"));
}
function $isArrayOf_Ltyrian_Location$External(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Location$External)));
}
function $asArrayOf_Ltyrian_Location$External(obj, depth) {
  return (($isArrayOf_Ltyrian_Location$External(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Location$External;", depth));
}
var $d_Ltyrian_Location$External = new $TypeData().initClass($c_Ltyrian_Location$External, "tyrian.Location$External", ({
  Ltyrian_Location$External: 1,
  Ltyrian_Location: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_Location$Internal(locationDetails) {
  this.Ltyrian_Location$Internal__f_locationDetails = null;
  this.Ltyrian_Location$Internal__f_isInternal = false;
  this.Ltyrian_Location$Internal__f_locationDetails = locationDetails;
  this.Ltyrian_Location$Internal__f_isInternal = true;
}
$c_Ltyrian_Location$Internal.prototype = new $h_O();
$c_Ltyrian_Location$Internal.prototype.constructor = $c_Ltyrian_Location$Internal;
/** @constructor */
function $h_Ltyrian_Location$Internal() {
}
$h_Ltyrian_Location$Internal.prototype = $c_Ltyrian_Location$Internal.prototype;
$c_Ltyrian_Location$Internal.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Location$Internal.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Ltyrian_Location$Internal.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_Location$Internal)) {
    var x$0$2 = $as_Ltyrian_Location$Internal(x$0);
    var x = this.Ltyrian_Location$Internal__f_locationDetails;
    var x$2 = $n(x$0$2).Ltyrian_Location$Internal__f_locationDetails;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Ltyrian_Location$Internal.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ltyrian_Location$Internal.prototype.productArity__I = (function() {
  return 1;
});
$c_Ltyrian_Location$Internal.prototype.productPrefix__T = (function() {
  return "Internal";
});
$c_Ltyrian_Location$Internal.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Location$Internal__f_locationDetails;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Ltyrian_Location$Internal.prototype.isInternal__Z = (function() {
  return this.Ltyrian_Location$Internal__f_isInternal;
});
function $as_Ltyrian_Location$Internal(obj) {
  return (((obj instanceof $c_Ltyrian_Location$Internal) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Location$Internal"));
}
function $isArrayOf_Ltyrian_Location$Internal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Location$Internal)));
}
function $asArrayOf_Ltyrian_Location$Internal(obj, depth) {
  return (($isArrayOf_Ltyrian_Location$Internal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Location$Internal;", depth));
}
var $d_Ltyrian_Location$Internal = new $TypeData().initClass($c_Ltyrian_Location$Internal, "tyrian.Location$Internal", ({
  Ltyrian_Location$Internal: 1,
  Ltyrian_Location: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $as_Ltyrian_NamedAttribute(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.NamedAttribute"));
}
function $isArrayOf_Ltyrian_NamedAttribute(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_NamedAttribute)));
}
function $asArrayOf_Ltyrian_NamedAttribute(obj, depth) {
  return (($isArrayOf_Ltyrian_NamedAttribute(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.NamedAttribute;", depth));
}
/** @constructor */
function $c_Ltyrian_Sub$Batch(subs) {
  this.Ltyrian_Sub$Batch__f_subs = null;
  this.Ltyrian_Sub$Batch__f_subs = subs;
}
$c_Ltyrian_Sub$Batch.prototype = new $h_O();
$c_Ltyrian_Sub$Batch.prototype.constructor = $c_Ltyrian_Sub$Batch;
/** @constructor */
function $h_Ltyrian_Sub$Batch() {
}
$h_Ltyrian_Sub$Batch.prototype = $c_Ltyrian_Sub$Batch.prototype;
$c_Ltyrian_Sub$Batch.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Sub$Batch.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Ltyrian_Sub$Batch.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_Sub$Batch)) {
    var x$0$2 = $as_Ltyrian_Sub$Batch(x$0);
    var x = this.Ltyrian_Sub$Batch__f_subs;
    var x$2 = $n(x$0$2).Ltyrian_Sub$Batch__f_subs;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Ltyrian_Sub$Batch.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ltyrian_Sub$Batch.prototype.productArity__I = (function() {
  return 1;
});
$c_Ltyrian_Sub$Batch.prototype.productPrefix__T = (function() {
  return "Batch";
});
$c_Ltyrian_Sub$Batch.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Sub$Batch__f_subs;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Ltyrian_Sub$Batch(obj) {
  return (((obj instanceof $c_Ltyrian_Sub$Batch) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Sub$Batch"));
}
function $isArrayOf_Ltyrian_Sub$Batch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Sub$Batch)));
}
function $asArrayOf_Ltyrian_Sub$Batch(obj, depth) {
  return (($isArrayOf_Ltyrian_Sub$Batch(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Sub$Batch;", depth));
}
var $d_Ltyrian_Sub$Batch = new $TypeData().initClass($c_Ltyrian_Sub$Batch, "tyrian.Sub$Batch", ({
  Ltyrian_Sub$Batch: 1,
  Ltyrian_Sub: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_Sub$Combine(sub1, sub2) {
  this.Ltyrian_Sub$Combine__f_sub1 = null;
  this.Ltyrian_Sub$Combine__f_sub2 = null;
  this.Ltyrian_Sub$Combine__f_sub1 = sub1;
  this.Ltyrian_Sub$Combine__f_sub2 = sub2;
}
$c_Ltyrian_Sub$Combine.prototype = new $h_O();
$c_Ltyrian_Sub$Combine.prototype.constructor = $c_Ltyrian_Sub$Combine;
/** @constructor */
function $h_Ltyrian_Sub$Combine() {
}
$h_Ltyrian_Sub$Combine.prototype = $c_Ltyrian_Sub$Combine.prototype;
$c_Ltyrian_Sub$Combine.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Sub$Combine.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Ltyrian_Sub$Combine.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_Sub$Combine)) {
    var x$0$2 = $as_Ltyrian_Sub$Combine(x$0);
    var x = this.Ltyrian_Sub$Combine__f_sub1;
    var x$2 = $n(x$0$2).Ltyrian_Sub$Combine__f_sub1;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Ltyrian_Sub$Combine__f_sub2;
      var x$4 = $n(x$0$2).Ltyrian_Sub$Combine__f_sub2;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ltyrian_Sub$Combine.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ltyrian_Sub$Combine.prototype.productArity__I = (function() {
  return 2;
});
$c_Ltyrian_Sub$Combine.prototype.productPrefix__T = (function() {
  return "Combine";
});
$c_Ltyrian_Sub$Combine.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Sub$Combine__f_sub1;
  }
  if ((n === 1)) {
    return this.Ltyrian_Sub$Combine__f_sub2;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Ltyrian_Sub$Combine(obj) {
  return (((obj instanceof $c_Ltyrian_Sub$Combine) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Sub$Combine"));
}
function $isArrayOf_Ltyrian_Sub$Combine(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Sub$Combine)));
}
function $asArrayOf_Ltyrian_Sub$Combine(obj, depth) {
  return (($isArrayOf_Ltyrian_Sub$Combine(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Sub$Combine;", depth));
}
var $d_Ltyrian_Sub$Combine = new $TypeData().initClass($c_Ltyrian_Sub$Combine, "tyrian.Sub$Combine", ({
  Ltyrian_Sub$Combine: 1,
  Ltyrian_Sub: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_Sub$Observe(id, observable, toMsg) {
  this.Ltyrian_Sub$Observe__f_id = null;
  this.Ltyrian_Sub$Observe__f_observable = null;
  this.Ltyrian_Sub$Observe__f_toMsg = null;
  this.Ltyrian_Sub$Observe__f_id = id;
  this.Ltyrian_Sub$Observe__f_observable = observable;
  this.Ltyrian_Sub$Observe__f_toMsg = toMsg;
}
$c_Ltyrian_Sub$Observe.prototype = new $h_O();
$c_Ltyrian_Sub$Observe.prototype.constructor = $c_Ltyrian_Sub$Observe;
/** @constructor */
function $h_Ltyrian_Sub$Observe() {
}
$h_Ltyrian_Sub$Observe.prototype = $c_Ltyrian_Sub$Observe.prototype;
$c_Ltyrian_Sub$Observe.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Sub$Observe.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Ltyrian_Sub$Observe.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_Sub$Observe)) {
    var x$0$2 = $as_Ltyrian_Sub$Observe(x$0);
    if ((this.Ltyrian_Sub$Observe__f_id === $n(x$0$2).Ltyrian_Sub$Observe__f_id)) {
      var x = this.Ltyrian_Sub$Observe__f_observable;
      var y = $n(x$0$2).Ltyrian_Sub$Observe__f_observable;
      var $x_1 = $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$1 = this.Ltyrian_Sub$Observe__f_toMsg;
      var x$2 = $n(x$0$2).Ltyrian_Sub$Observe__f_toMsg;
      return ((x$1 === null) ? (x$2 === null) : $n(x$1).equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ltyrian_Sub$Observe.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ltyrian_Sub$Observe.prototype.productArity__I = (function() {
  return 3;
});
$c_Ltyrian_Sub$Observe.prototype.productPrefix__T = (function() {
  return "Observe";
});
$c_Ltyrian_Sub$Observe.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Ltyrian_Sub$Observe__f_id;
      break;
    }
    case 1: {
      return this.Ltyrian_Sub$Observe__f_observable;
      break;
    }
    case 2: {
      return this.Ltyrian_Sub$Observe__f_toMsg;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Ltyrian_Sub$Observe(obj) {
  return (((obj instanceof $c_Ltyrian_Sub$Observe) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Sub$Observe"));
}
function $isArrayOf_Ltyrian_Sub$Observe(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Sub$Observe)));
}
function $asArrayOf_Ltyrian_Sub$Observe(obj, depth) {
  return (($isArrayOf_Ltyrian_Sub$Observe(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Sub$Observe;", depth));
}
var $d_Ltyrian_Sub$Observe = new $TypeData().initClass($c_Ltyrian_Sub$Observe, "tyrian.Sub$Observe", ({
  Ltyrian_Sub$Observe: 1,
  Ltyrian_Sub: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_Text(value) {
  this.Ltyrian_Text__f_value = null;
  this.Ltyrian_Text__f_value = value;
}
$c_Ltyrian_Text.prototype = new $h_O();
$c_Ltyrian_Text.prototype.constructor = $c_Ltyrian_Text;
/** @constructor */
function $h_Ltyrian_Text() {
}
$h_Ltyrian_Text.prototype = $c_Ltyrian_Text.prototype;
$c_Ltyrian_Text.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Text.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Ltyrian_Text.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_Text)) {
    var x$0$2 = $as_Ltyrian_Text(x$0);
    return (this.Ltyrian_Text__f_value === $n(x$0$2).Ltyrian_Text__f_value);
  } else {
    return false;
  }
});
$c_Ltyrian_Text.prototype.productArity__I = (function() {
  return 1;
});
$c_Ltyrian_Text.prototype.productPrefix__T = (function() {
  return "Text";
});
$c_Ltyrian_Text.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Text__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Ltyrian_Text.prototype.toString__T = (function() {
  return $m_Ltyrian_HTMLRendering$package$().render__Ltyrian_Elem__T(this);
});
function $as_Ltyrian_Text(obj) {
  return (((obj instanceof $c_Ltyrian_Text) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Text"));
}
function $isArrayOf_Ltyrian_Text(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Text)));
}
function $asArrayOf_Ltyrian_Text(obj, depth) {
  return (($isArrayOf_Ltyrian_Text(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Text;", depth));
}
var $d_Ltyrian_Text = new $TypeData().initClass($c_Ltyrian_Text, "tyrian.Text", ({
  Ltyrian_Text: 1,
  Ltyrian_Elem: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_TyrianApp$$anon$1(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Ltyrian_TyrianApp$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Ltyrian_TyrianApp$$anon$1.prototype.constructor = $c_Ltyrian_TyrianApp$$anon$1;
/** @constructor */
function $h_Ltyrian_TyrianApp$$anon$1() {
}
$h_Ltyrian_TyrianApp$$anon$1.prototype = $c_Ltyrian_TyrianApp$$anon$1.prototype;
$c_Ltyrian_TyrianApp$$anon$1.prototype.isDefinedAt__T2__Z = (function(x) {
  if ((x !== null)) {
    var dataAttr = $as_T($n(x)._1__O());
    $as_T($n(x)._2__O());
    var this$1 = $n(dataAttr);
    if (((this$1.length >= 0) && ($as_T(this$1.substring(0, 10)) === "tyrianFlag"))) {
      return true;
    }
  }
  return false;
});
$c_Ltyrian_TyrianApp$$anon$1.prototype.applyOrElse__T2__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var dataAttr = $as_T($n(x)._1__O());
    var attrValue = $as_T($n(x)._2__O());
    var this$1 = $n(dataAttr);
    if (((this$1.length >= 0) && ($as_T(this$1.substring(0, 10)) === "tyrianFlag"))) {
      var self = $f_T__replaceFirst__T__T__T($n(dataAttr), "^tyrianFlag", "");
      return new $c_T2(self, attrValue);
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Ltyrian_TyrianApp$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z($as_T2(x));
});
$c_Ltyrian_TyrianApp$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O($as_T2(x), default$1);
});
var $d_Ltyrian_TyrianApp$$anon$1 = new $TypeData().initClass($c_Ltyrian_TyrianApp$$anon$1, "tyrian.TyrianApp$$anon$1", ({
  Ltyrian_TyrianApp$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_runtime_RendererState() {
}
$c_Ltyrian_runtime_RendererState.prototype = new $h_O();
$c_Ltyrian_runtime_RendererState.prototype.constructor = $c_Ltyrian_runtime_RendererState;
/** @constructor */
function $h_Ltyrian_runtime_RendererState() {
}
$h_Ltyrian_runtime_RendererState.prototype = $c_Ltyrian_runtime_RendererState.prototype;
$c_Ltyrian_runtime_RendererState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Ltyrian_runtime_Rendering$$anon$1() {
}
$c_Ltyrian_runtime_Rendering$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Ltyrian_runtime_Rendering$$anon$1.prototype.constructor = $c_Ltyrian_runtime_Rendering$$anon$1;
/** @constructor */
function $h_Ltyrian_runtime_Rendering$$anon$1() {
}
$h_Ltyrian_runtime_Rendering$$anon$1.prototype = $c_Ltyrian_runtime_Rendering$$anon$1.prototype;
$c_Ltyrian_runtime_Rendering$$anon$1.prototype.isDefinedAt__Ltyrian_Attr__Z = (function(x) {
  if ((x instanceof $c_Ltyrian_Attribute)) {
    $m_Ltyrian_Attribute$();
    var x$1 = $as_Ltyrian_Attribute(x);
    var this$2 = $n(x$1);
    var this$3 = $n(x$1);
    return true;
  } else if (false) {
    var x$1$1 = $as_Ltyrian_NamedAttribute(x);
    $n(x$1$1)._1__T();
    return true;
  } else {
    return false;
  }
});
$c_Ltyrian_runtime_Rendering$$anon$1.prototype.applyOrElse__Ltyrian_Attr__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Ltyrian_Attribute)) {
    $m_Ltyrian_Attribute$();
    var x$1 = $as_Ltyrian_Attribute(x);
    var this$2 = $n(x$1);
    var x15 = this$2.Ltyrian_Attribute__f_name;
    var this$3 = $n(x$1);
    var x16 = this$3.Ltyrian_Attribute__f_value;
    return new $c_T2(x15, x16);
  } else if (false) {
    var x$1$1 = $as_Ltyrian_NamedAttribute(x);
    var x12 = $n(x$1$1)._1__T();
    return new $c_T2(x12, "");
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Ltyrian_runtime_Rendering$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Ltyrian_Attr__Z($as_Ltyrian_Attr(x));
});
$c_Ltyrian_runtime_Rendering$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Ltyrian_Attr__F1__O($as_Ltyrian_Attr(x), default$1);
});
var $d_Ltyrian_runtime_Rendering$$anon$1 = new $TypeData().initClass($c_Ltyrian_runtime_Rendering$$anon$1, "tyrian.runtime.Rendering$$anon$1", ({
  Ltyrian_runtime_Rendering$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_runtime_Rendering$$anon$2() {
}
$c_Ltyrian_runtime_Rendering$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Ltyrian_runtime_Rendering$$anon$2.prototype.constructor = $c_Ltyrian_runtime_Rendering$$anon$2;
/** @constructor */
function $h_Ltyrian_runtime_Rendering$$anon$2() {
}
$h_Ltyrian_runtime_Rendering$$anon$2.prototype = $c_Ltyrian_runtime_Rendering$$anon$2.prototype;
$c_Ltyrian_runtime_Rendering$$anon$2.prototype.isDefinedAt__Ltyrian_Attr__Z = (function(x) {
  if (false) {
    var x$1 = $as_Ltyrian_PropertyString(x);
    $n(x$1)._1__T();
    $n(x$1)._2__T();
    return true;
  } else if (false) {
    var x$1$1 = $as_Ltyrian_PropertyBoolean(x);
    $n(x$1$1)._1__T();
    $n(x$1$1)._2__Z();
    return true;
  } else {
    return false;
  }
});
$c_Ltyrian_runtime_Rendering$$anon$2.prototype.applyOrElse__Ltyrian_Attr__F1__O = (function(x, default$1) {
  if (false) {
    var x$1 = $as_Ltyrian_PropertyString(x);
    var x33 = $n(x$1)._1__T();
    var x34 = $n(x$1)._2__T();
    return new $c_T2(x33, x34);
  } else if (false) {
    var x$1$1 = $as_Ltyrian_PropertyBoolean(x);
    var x29 = $n(x$1$1)._1__T();
    var x30 = $n(x$1$1)._2__Z();
    return new $c_T2(x29, x30);
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Ltyrian_runtime_Rendering$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Ltyrian_Attr__Z($as_Ltyrian_Attr(x));
});
$c_Ltyrian_runtime_Rendering$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Ltyrian_Attr__F1__O($as_Ltyrian_Attr(x), default$1);
});
var $d_Ltyrian_runtime_Rendering$$anon$2 = new $TypeData().initClass($c_Ltyrian_runtime_Rendering$$anon$2, "tyrian.runtime.Rendering$$anon$2", ({
  Ltyrian_runtime_Rendering$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_runtime_Rendering$$anon$3(onMsg$5) {
  this.Ltyrian_runtime_Rendering$$anon$3__f_onMsg$1 = null;
  this.Ltyrian_runtime_Rendering$$anon$3__f_onMsg$1 = onMsg$5;
}
$c_Ltyrian_runtime_Rendering$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$c_Ltyrian_runtime_Rendering$$anon$3.prototype.constructor = $c_Ltyrian_runtime_Rendering$$anon$3;
/** @constructor */
function $h_Ltyrian_runtime_Rendering$$anon$3() {
}
$h_Ltyrian_runtime_Rendering$$anon$3.prototype = $c_Ltyrian_runtime_Rendering$$anon$3.prototype;
$c_Ltyrian_runtime_Rendering$$anon$3.prototype.isDefinedAt__Ltyrian_Attr__Z = (function(x) {
  if (false) {
    var x$1 = $as_Ltyrian_Event(x);
    $n(x$1)._1__T();
    $n(x$1)._2__F1();
    $n(x$1)._3__Z();
    $n(x$1)._4__Z();
    $n(x$1)._5__Z();
    return true;
  } else {
    return false;
  }
});
$c_Ltyrian_runtime_Rendering$$anon$3.prototype.applyOrElse__Ltyrian_Attr__F1__O = (function(x, default$1) {
  if (false) {
    var x$1 = $as_Ltyrian_Event(x);
    var x46 = $n(x$1)._1__T();
    var x47 = $n(x$1)._2__F1();
    var x48 = $n(x$1)._3__Z();
    var x49 = $n(x$1)._4__Z();
    var x50 = $n(x$1)._5__Z();
    var callback = new $c_sjsr_AnonFunction1(((e) => {
      if (x48) {
        e.preventDefault();
      }
      if (x49) {
        e.stopPropagation();
      }
      if (x50) {
        e.stopImmediatePropagation();
      }
      $n(this.Ltyrian_runtime_Rendering$$anon$3__f_onMsg$1).apply__O__O($n(x47).apply__O__O(e));
    }));
    var _2 = $m_Lsnabbdom_EventHandler$().apply__sci_Seq__Lsnabbdom_EventHandler($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_F1.getArrayOf().constr)([callback])));
    return new $c_T2(x46, _2);
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Ltyrian_runtime_Rendering$$anon$3.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Ltyrian_Attr__Z($as_Ltyrian_Attr(x));
});
$c_Ltyrian_runtime_Rendering$$anon$3.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Ltyrian_Attr__F1__O($as_Ltyrian_Attr(x), default$1);
});
var $d_Ltyrian_runtime_Rendering$$anon$3 = new $TypeData().initClass($c_Ltyrian_runtime_Rendering$$anon$3, "tyrian.runtime.Rendering$$anon$3", ({
  Ltyrian_runtime_Rendering$$anon$3: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_runtime_Rendering$$anon$4() {
}
$c_Ltyrian_runtime_Rendering$$anon$4.prototype = new $h_sr_AbstractPartialFunction();
$c_Ltyrian_runtime_Rendering$$anon$4.prototype.constructor = $c_Ltyrian_runtime_Rendering$$anon$4;
/** @constructor */
function $h_Ltyrian_runtime_Rendering$$anon$4() {
}
$h_Ltyrian_runtime_Rendering$$anon$4.prototype = $c_Ltyrian_runtime_Rendering$$anon$4.prototype;
$c_Ltyrian_runtime_Rendering$$anon$4.prototype.isDefinedAt__Ltyrian_Attr__Z = (function(x) {
  if ((x instanceof $c_Ltyrian_Attribute)) {
    $m_Ltyrian_Attribute$();
    var x$1 = $as_Ltyrian_Attribute(x);
    var this$2 = $n(x$1);
    var x67 = this$2.Ltyrian_Attribute__f_name;
    var this$3 = $n(x$1);
    if ((x67 === "href")) {
      return true;
    }
  }
  return false;
});
$c_Ltyrian_runtime_Rendering$$anon$4.prototype.applyOrElse__Ltyrian_Attr__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Ltyrian_Attribute)) {
    $m_Ltyrian_Attribute$();
    var x$1 = $as_Ltyrian_Attribute(x);
    var this$2 = $n(x$1);
    var x72 = this$2.Ltyrian_Attribute__f_name;
    var this$3 = $n(x$1);
    var x73 = this$3.Ltyrian_Attribute__f_value;
    if ((x72 === "href")) {
      return x73;
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Ltyrian_runtime_Rendering$$anon$4.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Ltyrian_Attr__Z($as_Ltyrian_Attr(x));
});
$c_Ltyrian_runtime_Rendering$$anon$4.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Ltyrian_Attr__F1__O($as_Ltyrian_Attr(x), default$1);
});
var $d_Ltyrian_runtime_Rendering$$anon$4 = new $TypeData().initClass($c_Ltyrian_runtime_Rendering$$anon$4, "tyrian.runtime.Rendering$$anon$4", ({
  Ltyrian_runtime_Rendering$$anon$4: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_Functor$$anon$1(evidence$1$1, outer) {
  this.Lcats_Functor$$anon$1__f_F = null;
  this.Lcats_Functor$$anon$1__f_G = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_Functor$$anon$1__f_F = outer;
  this.Lcats_Functor$$anon$1__f_G = evidence$1$1;
}
$c_Lcats_Functor$$anon$1.prototype = new $h_O();
$c_Lcats_Functor$$anon$1.prototype.constructor = $c_Lcats_Functor$$anon$1;
/** @constructor */
function $h_Lcats_Functor$$anon$1() {
}
$h_Lcats_Functor$$anon$1.prototype = $c_Lcats_Functor$$anon$1.prototype;
$c_Lcats_Functor$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_Functor$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_Functor$$anon$1.prototype.imap__O__F1__F1__O = (function(fga, f, g) {
  return $f_Lcats_ComposedInvariant__imap__O__F1__F1__O(this, fga, f, g);
});
$c_Lcats_Functor$$anon$1.prototype.map__O__F1__O = (function(fga, f) {
  return $f_Lcats_ComposedFunctor__map__O__F1__O(this, fga, f);
});
var $d_Lcats_Functor$$anon$1 = new $TypeData().initClass($c_Lcats_Functor$$anon$1, "cats.Functor$$anon$1", ({
  Lcats_Functor$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_ComposedInvariant: 1,
  Lcats_ComposedFunctor: 1
}));
function $ct_Lcats_NonEmptyReducible__Lcats_Foldable__($thiz, G) {
  $thiz.Lcats_NonEmptyReducible__f_G = G;
  return $thiz;
}
/** @constructor */
function $c_Lcats_NonEmptyReducible() {
  this.Lcats_NonEmptyReducible__f_G = null;
}
$c_Lcats_NonEmptyReducible.prototype = new $h_O();
$c_Lcats_NonEmptyReducible.prototype.constructor = $c_Lcats_NonEmptyReducible;
/** @constructor */
function $h_Lcats_NonEmptyReducible() {
}
$h_Lcats_NonEmptyReducible.prototype = $c_Lcats_NonEmptyReducible.prototype;
$c_Lcats_NonEmptyReducible.prototype.reduceLeftOption__O__F2__s_Option = (function(fa, f) {
  return $f_Lcats_Foldable__reduceLeftOption__O__F2__s_Option(this, fa, f);
});
$c_Lcats_NonEmptyReducible.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverse___O__F1__Lcats_Applicative__O(this, fa, f, G);
});
$c_Lcats_NonEmptyReducible.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return this.foldMap__Lcats_data_NonEmptyList__F1__Lcats_kernel_Monoid__O($as_Lcats_data_NonEmptyList(fa), f, evidence$1);
});
$c_Lcats_NonEmptyReducible.prototype.reduceLeftToOption__O__F1__F2__s_Option = (function(fa, f, g) {
  return $f_Lcats_Reducible__reduceLeftToOption__O__F1__F2__s_Option(this, fa, f, g);
});
$c_Lcats_NonEmptyReducible.prototype.maximumOption__O__Lcats_kernel_Order__s_Option = (function(fa, A) {
  return $f_Lcats_Reducible__maximumOption__O__Lcats_kernel_Order__s_Option(this, fa, A);
});
$c_Lcats_NonEmptyReducible.prototype.reduceLeftTo__O__F1__F2__O = (function(fa, f, g) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  var _1 = $n(fa$1).Lcats_data_NonEmptyList__f_head;
  var _2 = $n(fa$1).Lcats_data_NonEmptyList__f_tail;
  var \u03b42$___1 = _1;
  var \u03b42$___2 = _2;
  var a$2 = \u03b42$___1;
  var ga$2 = \u03b42$___2;
  return $n(this.Lcats_NonEmptyReducible__f_G).foldLeft__O__O__F2__O(ga$2, $n(f).apply__O__O(a$2), g);
});
$c_Lcats_NonEmptyReducible.prototype.size__O__J = (function(fa) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  $n(fa$1);
  var _2 = $n(fa$1).Lcats_data_NonEmptyList__f_tail;
  var tail$2 = _2;
  var b = $n(this.Lcats_NonEmptyReducible__f_G).size__O__J(tail$2);
  var bhi = b.RTLong__f_hi;
  var lo = ((1 + b.RTLong__f_lo) | 0);
  var hi = ((lo === 0) ? ((1 + bhi) | 0) : bhi);
  return new $c_RTLong(lo, hi);
});
$c_Lcats_NonEmptyReducible.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, H) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  var _1 = $n(fa$1).Lcats_data_NonEmptyList__f_head;
  var _2 = $n(fa$1).Lcats_data_NonEmptyList__f_tail;
  var \u03b44$___1 = _1;
  var \u03b44$___2 = _2;
  var a$2 = \u03b44$___1;
  var ga$2 = \u03b44$___2;
  return $n(H).flatMap__O__F1__O($n(f).apply__O__O__O(z, a$2), new $c_sjsr_AnonFunction1(((_$4) => $n(this.Lcats_NonEmptyReducible__f_G).foldM__O__O__F2__Lcats_Monad__O(ga$2, _$4, f, H))));
});
/** @constructor */
function $c_Lcats_Now(value) {
  this.Lcats_Now__f_value = null;
  this.Lcats_Now__f_value = value;
}
$c_Lcats_Now.prototype = new $h_Lcats_Eval$Leaf();
$c_Lcats_Now.prototype.constructor = $c_Lcats_Now;
/** @constructor */
function $h_Lcats_Now() {
}
$h_Lcats_Now.prototype = $c_Lcats_Now.prototype;
$c_Lcats_Now.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_Now.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_Now.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_Now)) {
    var x$0$2 = $as_Lcats_Now(x$0);
    var x = this.Lcats_Now__f_value;
    var y = $n(x$0$2).Lcats_Now__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_Now.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_Now.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_Now.prototype.productPrefix__T = (function() {
  return "Now";
});
$c_Lcats_Now.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_Now__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_Now.prototype.value__O = (function() {
  return this.Lcats_Now__f_value;
});
$c_Lcats_Now.prototype.memoize__Lcats_Eval = (function() {
  return this;
});
function $as_Lcats_Now(obj) {
  return (((obj instanceof $c_Lcats_Now) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Now"));
}
function $isArrayOf_Lcats_Now(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Now)));
}
function $asArrayOf_Lcats_Now(obj, depth) {
  return (($isArrayOf_Lcats_Now(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Now;", depth));
}
var $d_Lcats_Now = new $TypeData().initClass($c_Lcats_Now, "cats.Now", ({
  Lcats_Now: 1,
  Lcats_Eval$Leaf: 1,
  Lcats_Eval: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lcats_UnorderedFoldable$$anon$1() {
  this.Lcats_UnorderedFoldable$$anon$1__f_empty = null;
  this.Lcats_UnorderedFoldable$$anon$1__f_empty = $m_Lcats_Eval$().Lcats_Eval$__f_False;
}
$c_Lcats_UnorderedFoldable$$anon$1.prototype = new $h_O();
$c_Lcats_UnorderedFoldable$$anon$1.prototype.constructor = $c_Lcats_UnorderedFoldable$$anon$1;
/** @constructor */
function $h_Lcats_UnorderedFoldable$$anon$1() {
}
$h_Lcats_UnorderedFoldable$$anon$1.prototype = $c_Lcats_UnorderedFoldable$$anon$1.prototype;
$c_Lcats_UnorderedFoldable$$anon$1.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_UnorderedFoldable$$anon$1.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAllOption__sc_IterableOnce__s_Option(this, as);
});
$c_Lcats_UnorderedFoldable$$anon$1.prototype.combine__Lcats_Eval__Lcats_Eval__Lcats_Eval = (function(lx, ly) {
  return $n(lx).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $uZ(x$1);
    if ((x$1$1 === true)) {
      return $m_Lcats_Eval$().Lcats_Eval$__f_True;
    }
    if ((x$1$1 === false)) {
      return ly;
    }
    throw new $c_s_MatchError(x$1$1);
  })));
});
$c_Lcats_UnorderedFoldable$$anon$1.prototype.empty__O = (function() {
  return this.Lcats_UnorderedFoldable$$anon$1__f_empty;
});
$c_Lcats_UnorderedFoldable$$anon$1.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__Lcats_Eval__Lcats_Eval__Lcats_Eval($as_Lcats_Eval(x), $as_Lcats_Eval(y));
});
var $d_Lcats_UnorderedFoldable$$anon$1 = new $TypeData().initClass($c_Lcats_UnorderedFoldable$$anon$1, "cats.UnorderedFoldable$$anon$1", ({
  Lcats_UnorderedFoldable$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1
}));
/** @constructor */
function $c_Lcats_UnorderedFoldable$$anon$2() {
  this.Lcats_UnorderedFoldable$$anon$2__f_empty = null;
  this.Lcats_UnorderedFoldable$$anon$2__f_empty = $m_Lcats_Eval$().Lcats_Eval$__f_True;
}
$c_Lcats_UnorderedFoldable$$anon$2.prototype = new $h_O();
$c_Lcats_UnorderedFoldable$$anon$2.prototype.constructor = $c_Lcats_UnorderedFoldable$$anon$2;
/** @constructor */
function $h_Lcats_UnorderedFoldable$$anon$2() {
}
$h_Lcats_UnorderedFoldable$$anon$2.prototype = $c_Lcats_UnorderedFoldable$$anon$2.prototype;
$c_Lcats_UnorderedFoldable$$anon$2.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_UnorderedFoldable$$anon$2.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAllOption__sc_IterableOnce__s_Option(this, as);
});
$c_Lcats_UnorderedFoldable$$anon$2.prototype.combine__Lcats_Eval__Lcats_Eval__Lcats_Eval = (function(lx, ly) {
  return $n(lx).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $uZ(x$1);
    if ((x$1$1 === true)) {
      return ly;
    }
    if ((x$1$1 === false)) {
      return $m_Lcats_Eval$().Lcats_Eval$__f_False;
    }
    throw new $c_s_MatchError(x$1$1);
  })));
});
$c_Lcats_UnorderedFoldable$$anon$2.prototype.empty__O = (function() {
  return this.Lcats_UnorderedFoldable$$anon$2__f_empty;
});
$c_Lcats_UnorderedFoldable$$anon$2.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__Lcats_Eval__Lcats_Eval__Lcats_Eval($as_Lcats_Eval(x), $as_Lcats_Eval(y));
});
var $d_Lcats_UnorderedFoldable$$anon$2 = new $TypeData().initClass($c_Lcats_UnorderedFoldable$$anon$2, "cats.UnorderedFoldable$$anon$2", ({
  Lcats_UnorderedFoldable$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1
}));
function $f_Lcats_arrow_Arrow__id__O($thiz) {
  return $thiz.lift__F1__O(new $c_sjsr_AnonFunction1(((x) => x)));
}
/** @constructor */
function $c_Lcats_data_AndThen$Concat(left, right) {
  this.Lcats_data_AndThen$Concat__f_left = null;
  this.Lcats_data_AndThen$Concat__f_right = null;
  this.Lcats_data_AndThen$Concat__f_left = left;
  this.Lcats_data_AndThen$Concat__f_right = right;
}
$c_Lcats_data_AndThen$Concat.prototype = new $h_Lcats_data_AndThen();
$c_Lcats_data_AndThen$Concat.prototype.constructor = $c_Lcats_data_AndThen$Concat;
/** @constructor */
function $h_Lcats_data_AndThen$Concat() {
}
$h_Lcats_data_AndThen$Concat.prototype = $c_Lcats_data_AndThen$Concat.prototype;
$c_Lcats_data_AndThen$Concat.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_data_AndThen$Concat.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_data_AndThen$Concat)) {
    var x$0$2 = $as_Lcats_data_AndThen$Concat(x$0);
    var x = this.Lcats_data_AndThen$Concat__f_left;
    var x$2 = $n(x$0$2).Lcats_data_AndThen$Concat__f_left;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_data_AndThen$Concat__f_right;
      var x$4 = $n(x$0$2).Lcats_data_AndThen$Concat__f_right;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_data_AndThen$Concat.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_data_AndThen$Concat.prototype.productPrefix__T = (function() {
  return "Concat";
});
$c_Lcats_data_AndThen$Concat.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_AndThen$Concat__f_left;
  }
  if ((n === 1)) {
    return this.Lcats_data_AndThen$Concat__f_right;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_data_AndThen$Concat(obj) {
  return (((obj instanceof $c_Lcats_data_AndThen$Concat) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.AndThen$Concat"));
}
function $isArrayOf_Lcats_data_AndThen$Concat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_AndThen$Concat)));
}
function $asArrayOf_Lcats_data_AndThen$Concat(obj, depth) {
  return (($isArrayOf_Lcats_data_AndThen$Concat(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.AndThen$Concat;", depth));
}
var $d_Lcats_data_AndThen$Concat = new $TypeData().initClass($c_Lcats_data_AndThen$Concat, "cats.data.AndThen$Concat", ({
  Lcats_data_AndThen$Concat: 1,
  Lcats_data_AndThen: 1,
  F1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_data_AndThen$Single(f, index) {
  this.Lcats_data_AndThen$Single__f_f = null;
  this.Lcats_data_AndThen$Single__f_index = 0;
  this.Lcats_data_AndThen$Single__f_f = f;
  this.Lcats_data_AndThen$Single__f_index = index;
}
$c_Lcats_data_AndThen$Single.prototype = new $h_Lcats_data_AndThen();
$c_Lcats_data_AndThen$Single.prototype.constructor = $c_Lcats_data_AndThen$Single;
/** @constructor */
function $h_Lcats_data_AndThen$Single() {
}
$h_Lcats_data_AndThen$Single.prototype = $c_Lcats_data_AndThen$Single.prototype;
$c_Lcats_data_AndThen$Single.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Single");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcats_data_AndThen$Single__f_f;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lcats_data_AndThen$Single__f_index;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
});
$c_Lcats_data_AndThen$Single.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_data_AndThen$Single)) {
    var x$0$2 = $as_Lcats_data_AndThen$Single(x$0);
    if ((this.Lcats_data_AndThen$Single__f_index === $n(x$0$2).Lcats_data_AndThen$Single__f_index)) {
      var x = this.Lcats_data_AndThen$Single__f_f;
      var x$2 = $n(x$0$2).Lcats_data_AndThen$Single__f_f;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_data_AndThen$Single.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_data_AndThen$Single.prototype.productPrefix__T = (function() {
  return "Single";
});
$c_Lcats_data_AndThen$Single.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_AndThen$Single__f_f;
  }
  if ((n === 1)) {
    return this.Lcats_data_AndThen$Single__f_index;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_data_AndThen$Single(obj) {
  return (((obj instanceof $c_Lcats_data_AndThen$Single) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.AndThen$Single"));
}
function $isArrayOf_Lcats_data_AndThen$Single(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_AndThen$Single)));
}
function $asArrayOf_Lcats_data_AndThen$Single(obj, depth) {
  return (($isArrayOf_Lcats_data_AndThen$Single(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.AndThen$Single;", depth));
}
var $d_Lcats_data_AndThen$Single = new $TypeData().initClass($c_Lcats_data_AndThen$Single, "cats.data.AndThen$Single", ({
  Lcats_data_AndThen$Single: 1,
  Lcats_data_AndThen: 1,
  F1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_data_KleisliInstances4() {
}
$c_Lcats_data_KleisliInstances4.prototype = new $h_Lcats_data_KleisliInstances5();
$c_Lcats_data_KleisliInstances4.prototype.constructor = $c_Lcats_data_KleisliInstances4;
/** @constructor */
function $h_Lcats_data_KleisliInstances4() {
}
$h_Lcats_data_KleisliInstances4.prototype = $c_Lcats_data_KleisliInstances4.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyChainImpl$() {
  this.Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1 = null;
  $ct_Lcats_data_NonEmptyChainInstances__(this);
}
$c_Lcats_data_NonEmptyChainImpl$.prototype = new $h_Lcats_data_NonEmptyChainInstances();
$c_Lcats_data_NonEmptyChainImpl$.prototype.constructor = $c_Lcats_data_NonEmptyChainImpl$;
/** @constructor */
function $h_Lcats_data_NonEmptyChainImpl$() {
}
$h_Lcats_data_NonEmptyChainImpl$.prototype = $c_Lcats_data_NonEmptyChainImpl$.prototype;
$c_Lcats_data_NonEmptyChainImpl$.prototype.fromChain__Lcats_data_Chain__s_Option = (function(as) {
  var this$1 = $n(as);
  if ((!this$1.isEmpty__Z())) {
    return $m_s_Option$().apply__O__s_Option(as);
  } else {
    return $m_s_None$();
  }
});
$c_Lcats_data_NonEmptyChainImpl$.prototype.fromSeq__sci_Seq__s_Option = (function(as) {
  var this$1 = $n(as);
  if ((!this$1.isEmpty__Z())) {
    var $x_1 = $m_s_Option$();
    var this$2 = $m_Lcats_data_Chain$();
    var s = $f_Lcats_data_ChainCompanionCompat__fromSeq__sci_Seq__Lcats_data_Chain(this$2, as);
    return $n($x_1).apply__O__s_Option(s);
  } else {
    return $m_s_None$();
  }
});
$c_Lcats_data_NonEmptyChainImpl$.prototype.fromChainAppend__Lcats_data_Chain__O__O = (function(ca, a) {
  var this$1 = $n(ca);
  var s = this$1.append__O__Lcats_data_Chain(a);
  return s;
});
$c_Lcats_data_NonEmptyChainImpl$.prototype.apply__O__sci_Seq__O = (function(a, as) {
  var $x_2 = $m_Lcats_data_Chain$();
  $m_Lcats_data_Chain$();
  var $x_1 = new $c_Lcats_data_Chain$Singleton(a);
  var this$3 = $m_Lcats_data_Chain$();
  var s = $n($x_2).concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain($x_1, $f_Lcats_data_ChainCompanionCompat__fromSeq__sci_Seq__Lcats_data_Chain(this$3, as));
  return s;
});
$c_Lcats_data_NonEmptyChainImpl$.prototype.one__O__O = (function(a) {
  $m_Lcats_data_Chain$();
  var s = new $c_Lcats_data_Chain$Singleton(a);
  return s;
});
var $d_Lcats_data_NonEmptyChainImpl$ = new $TypeData().initClass($c_Lcats_data_NonEmptyChainImpl$, "cats.data.NonEmptyChainImpl$", ({
  Lcats_data_NonEmptyChainImpl$: 1,
  Lcats_data_NonEmptyChainInstances: 1,
  Lcats_data_NonEmptyChainInstances1: 1,
  Lcats_data_NonEmptyChainInstances2: 1,
  Lcats_data_NonEmptyChainInstances3: 1,
  Lcats_data_ScalaVersionSpecificNonEmptyChainImpl: 1
}));
var $n_Lcats_data_NonEmptyChainImpl$;
function $m_Lcats_data_NonEmptyChainImpl$() {
  if ((!$n_Lcats_data_NonEmptyChainImpl$)) {
    $n_Lcats_data_NonEmptyChainImpl$ = new $c_Lcats_data_NonEmptyChainImpl$();
  }
  return $n_Lcats_data_NonEmptyChainImpl$;
}
/** @constructor */
function $c_Lcats_data_NonEmptyList$() {
  $ct_Lcats_data_NonEmptyListInstances__(this);
}
$c_Lcats_data_NonEmptyList$.prototype = new $h_Lcats_data_NonEmptyListInstances();
$c_Lcats_data_NonEmptyList$.prototype.constructor = $c_Lcats_data_NonEmptyList$;
/** @constructor */
function $h_Lcats_data_NonEmptyList$() {
}
$h_Lcats_data_NonEmptyList$.prototype = $c_Lcats_data_NonEmptyList$.prototype;
$c_Lcats_data_NonEmptyList$.prototype.fromList__sci_List__s_Option = (function(l) {
  var x = $m_sci_Nil$();
  if (x.equals__O__Z(l)) {
    return $m_s_None$();
  }
  if ((l instanceof $c_sci_$colon$colon)) {
    var x45 = $as_sci_$colon$colon(l);
    var x47 = $n(x45).sci_$colon$colon__f_next;
    var h = $n(x45).sci_$colon$colon__f_head;
    $m_Lcats_data_NonEmptyList$();
    var value = new $c_Lcats_data_NonEmptyList(h, x47);
    return new $c_s_Some(value);
  }
  throw new $c_s_MatchError(l);
});
$c_Lcats_data_NonEmptyList$.prototype.fromListUnsafe__sci_List__Lcats_data_NonEmptyList = (function(l) {
  var x = $m_sci_Nil$();
  if (x.equals__O__Z(l)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Cannot create NonEmptyList from empty list");
  }
  if ((l instanceof $c_sci_$colon$colon)) {
    var x49 = $as_sci_$colon$colon(l);
    var x51 = $n(x49).sci_$colon$colon__f_next;
    var h = $n(x49).sci_$colon$colon__f_head;
    $m_Lcats_data_NonEmptyList$();
    return new $c_Lcats_data_NonEmptyList(h, x51);
  }
  throw new $c_s_MatchError(l);
});
var $d_Lcats_data_NonEmptyList$ = new $TypeData().initClass($c_Lcats_data_NonEmptyList$, "cats.data.NonEmptyList$", ({
  Lcats_data_NonEmptyList$: 1,
  Lcats_data_NonEmptyListInstances: 1,
  Lcats_data_NonEmptyListInstances0: 1,
  Lcats_data_NonEmptyListInstances1: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Lcats_data_NonEmptyList$;
function $m_Lcats_data_NonEmptyList$() {
  if ((!$n_Lcats_data_NonEmptyList$)) {
    $n_Lcats_data_NonEmptyList$ = new $c_Lcats_data_NonEmptyList$();
  }
  return $n_Lcats_data_NonEmptyList$;
}
/** @constructor */
function $c_Lcats_effect_IO$Attempt(ioa) {
  this.Lcats_effect_IO$Attempt__f_ioa = null;
  this.Lcats_effect_IO$Attempt__f_ioa = ioa;
}
$c_Lcats_effect_IO$Attempt.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Attempt.prototype.constructor = $c_Lcats_effect_IO$Attempt;
/** @constructor */
function $h_Lcats_effect_IO$Attempt() {
}
$h_Lcats_effect_IO$Attempt.prototype = $c_Lcats_effect_IO$Attempt.prototype;
$c_Lcats_effect_IO$Attempt.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Attempt.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_IO$Attempt.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Attempt)) {
    var x$0$2 = $as_Lcats_effect_IO$Attempt(x$0);
    var x = this.Lcats_effect_IO$Attempt__f_ioa;
    var x$2 = $n(x$0$2).Lcats_effect_IO$Attempt__f_ioa;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Attempt.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_IO$Attempt.prototype.productPrefix__T = (function() {
  return "Attempt";
});
$c_Lcats_effect_IO$Attempt.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Attempt__f_ioa;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Attempt.prototype.tag__B = (function() {
  return 8;
});
function $as_Lcats_effect_IO$Attempt(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$Attempt) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Attempt"));
}
function $isArrayOf_Lcats_effect_IO$Attempt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Attempt)));
}
function $asArrayOf_Lcats_effect_IO$Attempt(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Attempt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Attempt;", depth));
}
var $d_Lcats_effect_IO$Attempt = new $TypeData().initClass($c_Lcats_effect_IO$Attempt, "cats.effect.IO$Attempt", ({
  Lcats_effect_IO$Attempt: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $as_Lcats_effect_IO$Blocking(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Blocking"));
}
function $isArrayOf_Lcats_effect_IO$Blocking(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Blocking)));
}
function $asArrayOf_Lcats_effect_IO$Blocking(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Blocking(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Blocking;", depth));
}
/** @constructor */
function $c_Lcats_effect_IO$Delay(thunk, event) {
  this.Lcats_effect_IO$Delay__f_thunk = null;
  this.Lcats_effect_IO$Delay__f_event = null;
  this.Lcats_effect_IO$Delay__f_thunk = thunk;
  this.Lcats_effect_IO$Delay__f_event = event;
}
$c_Lcats_effect_IO$Delay.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Delay.prototype.constructor = $c_Lcats_effect_IO$Delay;
/** @constructor */
function $h_Lcats_effect_IO$Delay() {
}
$h_Lcats_effect_IO$Delay.prototype = $c_Lcats_effect_IO$Delay.prototype;
$c_Lcats_effect_IO$Delay.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Delay.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_IO$Delay.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Delay)) {
    var x$0$2 = $as_Lcats_effect_IO$Delay(x$0);
    var x = this.Lcats_effect_IO$Delay__f_thunk;
    var x$2 = $n(x$0$2).Lcats_effect_IO$Delay__f_thunk;
    if ((x === null)) {
      var $x_1 = (x$2 === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === x$2);
    }
    if ($x_1) {
      var x$3 = this.Lcats_effect_IO$Delay__f_event;
      var x$4 = $n(x$0$2).Lcats_effect_IO$Delay__f_event;
      if ((x$3 === null)) {
        return (x$4 === null);
      } else {
        var this$2 = $n(x$3);
        return (this$2 === x$4);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Delay.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_IO$Delay.prototype.productPrefix__T = (function() {
  return "Delay";
});
$c_Lcats_effect_IO$Delay.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Delay__f_thunk;
  }
  if ((n === 1)) {
    return this.Lcats_effect_IO$Delay__f_event;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Delay.prototype.tag__B = (function() {
  return 2;
});
function $as_Lcats_effect_IO$Delay(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$Delay) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Delay"));
}
function $isArrayOf_Lcats_effect_IO$Delay(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Delay)));
}
function $asArrayOf_Lcats_effect_IO$Delay(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Delay(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Delay;", depth));
}
var $d_Lcats_effect_IO$Delay = new $TypeData().initClass($c_Lcats_effect_IO$Delay, "cats.effect.IO$Delay", ({
  Lcats_effect_IO$Delay: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$Error(t) {
  this.Lcats_effect_IO$Error__f_t = null;
  this.Lcats_effect_IO$Error__f_t = t;
}
$c_Lcats_effect_IO$Error.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Error.prototype.constructor = $c_Lcats_effect_IO$Error;
/** @constructor */
function $h_Lcats_effect_IO$Error() {
}
$h_Lcats_effect_IO$Error.prototype = $c_Lcats_effect_IO$Error.prototype;
$c_Lcats_effect_IO$Error.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Error.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_IO$Error.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Error)) {
    var x$0$2 = $as_Lcats_effect_IO$Error(x$0);
    var x = this.Lcats_effect_IO$Error__f_t;
    var x$2 = $n(x$0$2).Lcats_effect_IO$Error__f_t;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Error.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_IO$Error.prototype.productPrefix__T = (function() {
  return "Error";
});
$c_Lcats_effect_IO$Error.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Error__f_t;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Error.prototype.tag__B = (function() {
  return 1;
});
function $as_Lcats_effect_IO$Error(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$Error) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Error"));
}
function $isArrayOf_Lcats_effect_IO$Error(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Error)));
}
function $asArrayOf_Lcats_effect_IO$Error(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Error(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Error;", depth));
}
var $d_Lcats_effect_IO$Error = new $TypeData().initClass($c_Lcats_effect_IO$Error, "cats.effect.IO$Error", ({
  Lcats_effect_IO$Error: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$EvalOn(ioa, ec) {
  this.Lcats_effect_IO$EvalOn__f_ioa = null;
  this.Lcats_effect_IO$EvalOn__f_ec = null;
  this.Lcats_effect_IO$EvalOn__f_ioa = ioa;
  this.Lcats_effect_IO$EvalOn__f_ec = ec;
}
$c_Lcats_effect_IO$EvalOn.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$EvalOn.prototype.constructor = $c_Lcats_effect_IO$EvalOn;
/** @constructor */
function $h_Lcats_effect_IO$EvalOn() {
}
$h_Lcats_effect_IO$EvalOn.prototype = $c_Lcats_effect_IO$EvalOn.prototype;
$c_Lcats_effect_IO$EvalOn.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$EvalOn.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_IO$EvalOn.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$EvalOn)) {
    var x$0$2 = $as_Lcats_effect_IO$EvalOn(x$0);
    var x = this.Lcats_effect_IO$EvalOn__f_ioa;
    var x$2 = $n(x$0$2).Lcats_effect_IO$EvalOn__f_ioa;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$EvalOn__f_ec;
      var x$4 = $n(x$0$2).Lcats_effect_IO$EvalOn__f_ec;
      if ((x$3 === null)) {
        return (x$4 === null);
      } else {
        var this$1 = $n(x$3);
        return (this$1 === x$4);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$EvalOn.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_IO$EvalOn.prototype.productPrefix__T = (function() {
  return "EvalOn";
});
$c_Lcats_effect_IO$EvalOn.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$EvalOn__f_ioa;
  }
  if ((n === 1)) {
    return this.Lcats_effect_IO$EvalOn__f_ec;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$EvalOn.prototype.tag__B = (function() {
  return 20;
});
function $as_Lcats_effect_IO$EvalOn(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$EvalOn) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$EvalOn"));
}
function $isArrayOf_Lcats_effect_IO$EvalOn(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$EvalOn)));
}
function $asArrayOf_Lcats_effect_IO$EvalOn(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$EvalOn(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$EvalOn;", depth));
}
var $d_Lcats_effect_IO$EvalOn = new $TypeData().initClass($c_Lcats_effect_IO$EvalOn, "cats.effect.IO$EvalOn", ({
  Lcats_effect_IO$EvalOn: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$FlatMap(ioe, f, event) {
  this.Lcats_effect_IO$FlatMap__f_ioe = null;
  this.Lcats_effect_IO$FlatMap__f_f = null;
  this.Lcats_effect_IO$FlatMap__f_event = null;
  this.Lcats_effect_IO$FlatMap__f_ioe = ioe;
  this.Lcats_effect_IO$FlatMap__f_f = f;
  this.Lcats_effect_IO$FlatMap__f_event = event;
}
$c_Lcats_effect_IO$FlatMap.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$FlatMap.prototype.constructor = $c_Lcats_effect_IO$FlatMap;
/** @constructor */
function $h_Lcats_effect_IO$FlatMap() {
}
$h_Lcats_effect_IO$FlatMap.prototype = $c_Lcats_effect_IO$FlatMap.prototype;
$c_Lcats_effect_IO$FlatMap.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$FlatMap.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_IO$FlatMap.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$FlatMap)) {
    var x$0$2 = $as_Lcats_effect_IO$FlatMap(x$0);
    var x = this.Lcats_effect_IO$FlatMap__f_ioe;
    var x$2 = $n(x$0$2).Lcats_effect_IO$FlatMap__f_ioe;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$FlatMap__f_f;
      var x$4 = $n(x$0$2).Lcats_effect_IO$FlatMap__f_f;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lcats_effect_IO$FlatMap__f_event;
      var x$6 = $n(x$0$2).Lcats_effect_IO$FlatMap__f_event;
      if ((x$5 === null)) {
        return (x$6 === null);
      } else {
        var this$1 = $n(x$5);
        return (this$1 === x$6);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$FlatMap.prototype.productArity__I = (function() {
  return 3;
});
$c_Lcats_effect_IO$FlatMap.prototype.productPrefix__T = (function() {
  return "FlatMap";
});
$c_Lcats_effect_IO$FlatMap.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_IO$FlatMap__f_ioe;
      break;
    }
    case 1: {
      return this.Lcats_effect_IO$FlatMap__f_f;
      break;
    }
    case 2: {
      return this.Lcats_effect_IO$FlatMap__f_event;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lcats_effect_IO$FlatMap.prototype.tag__B = (function() {
  return 7;
});
function $as_Lcats_effect_IO$FlatMap(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$FlatMap) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$FlatMap"));
}
function $isArrayOf_Lcats_effect_IO$FlatMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$FlatMap)));
}
function $asArrayOf_Lcats_effect_IO$FlatMap(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$FlatMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$FlatMap;", depth));
}
var $d_Lcats_effect_IO$FlatMap = new $TypeData().initClass($c_Lcats_effect_IO$FlatMap, "cats.effect.IO$FlatMap", ({
  Lcats_effect_IO$FlatMap: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$HandleErrorWith(ioa, f, event) {
  this.Lcats_effect_IO$HandleErrorWith__f_ioa = null;
  this.Lcats_effect_IO$HandleErrorWith__f_f = null;
  this.Lcats_effect_IO$HandleErrorWith__f_event = null;
  this.Lcats_effect_IO$HandleErrorWith__f_ioa = ioa;
  this.Lcats_effect_IO$HandleErrorWith__f_f = f;
  this.Lcats_effect_IO$HandleErrorWith__f_event = event;
}
$c_Lcats_effect_IO$HandleErrorWith.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$HandleErrorWith.prototype.constructor = $c_Lcats_effect_IO$HandleErrorWith;
/** @constructor */
function $h_Lcats_effect_IO$HandleErrorWith() {
}
$h_Lcats_effect_IO$HandleErrorWith.prototype = $c_Lcats_effect_IO$HandleErrorWith.prototype;
$c_Lcats_effect_IO$HandleErrorWith.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$HandleErrorWith.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_IO$HandleErrorWith.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$HandleErrorWith)) {
    var x$0$2 = $as_Lcats_effect_IO$HandleErrorWith(x$0);
    var x = this.Lcats_effect_IO$HandleErrorWith__f_ioa;
    var x$2 = $n(x$0$2).Lcats_effect_IO$HandleErrorWith__f_ioa;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$HandleErrorWith__f_f;
      var x$4 = $n(x$0$2).Lcats_effect_IO$HandleErrorWith__f_f;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lcats_effect_IO$HandleErrorWith__f_event;
      var x$6 = $n(x$0$2).Lcats_effect_IO$HandleErrorWith__f_event;
      if ((x$5 === null)) {
        return (x$6 === null);
      } else {
        var this$1 = $n(x$5);
        return (this$1 === x$6);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$HandleErrorWith.prototype.productArity__I = (function() {
  return 3;
});
$c_Lcats_effect_IO$HandleErrorWith.prototype.productPrefix__T = (function() {
  return "HandleErrorWith";
});
$c_Lcats_effect_IO$HandleErrorWith.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_IO$HandleErrorWith__f_ioa;
      break;
    }
    case 1: {
      return this.Lcats_effect_IO$HandleErrorWith__f_f;
      break;
    }
    case 2: {
      return this.Lcats_effect_IO$HandleErrorWith__f_event;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lcats_effect_IO$HandleErrorWith.prototype.tag__B = (function() {
  return 9;
});
function $as_Lcats_effect_IO$HandleErrorWith(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$HandleErrorWith) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$HandleErrorWith"));
}
function $isArrayOf_Lcats_effect_IO$HandleErrorWith(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$HandleErrorWith)));
}
function $asArrayOf_Lcats_effect_IO$HandleErrorWith(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$HandleErrorWith(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$HandleErrorWith;", depth));
}
var $d_Lcats_effect_IO$HandleErrorWith = new $TypeData().initClass($c_Lcats_effect_IO$HandleErrorWith, "cats.effect.IO$HandleErrorWith", ({
  Lcats_effect_IO$HandleErrorWith: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$IOCont(body, event) {
  this.Lcats_effect_IO$IOCont__f_body = null;
  this.Lcats_effect_IO$IOCont__f_event = null;
  this.Lcats_effect_IO$IOCont__f_body = body;
  this.Lcats_effect_IO$IOCont__f_event = event;
}
$c_Lcats_effect_IO$IOCont.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$IOCont.prototype.constructor = $c_Lcats_effect_IO$IOCont;
/** @constructor */
function $h_Lcats_effect_IO$IOCont() {
}
$h_Lcats_effect_IO$IOCont.prototype = $c_Lcats_effect_IO$IOCont.prototype;
$c_Lcats_effect_IO$IOCont.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$IOCont.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_IO$IOCont.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$IOCont)) {
    var x$0$2 = $as_Lcats_effect_IO$IOCont(x$0);
    var x = this.Lcats_effect_IO$IOCont__f_body;
    var x$2 = $n(x$0$2).Lcats_effect_IO$IOCont__f_body;
    if ((x === null)) {
      var $x_1 = (x$2 === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === x$2);
    }
    if ($x_1) {
      var x$3 = this.Lcats_effect_IO$IOCont__f_event;
      var x$4 = $n(x$0$2).Lcats_effect_IO$IOCont__f_event;
      if ((x$3 === null)) {
        return (x$4 === null);
      } else {
        var this$2 = $n(x$3);
        return (this$2 === x$4);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$IOCont.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_IO$IOCont.prototype.productPrefix__T = (function() {
  return "IOCont";
});
$c_Lcats_effect_IO$IOCont.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$IOCont__f_body;
  }
  if ((n === 1)) {
    return this.Lcats_effect_IO$IOCont__f_event;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$IOCont.prototype.tag__B = (function() {
  return 14;
});
function $as_Lcats_effect_IO$IOCont(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$IOCont) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$IOCont"));
}
function $isArrayOf_Lcats_effect_IO$IOCont(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$IOCont)));
}
function $asArrayOf_Lcats_effect_IO$IOCont(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$IOCont(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$IOCont;", depth));
}
var $d_Lcats_effect_IO$IOCont = new $TypeData().initClass($c_Lcats_effect_IO$IOCont, "cats.effect.IO$IOCont", ({
  Lcats_effect_IO$IOCont: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$IOCont$Get(state) {
  this.Lcats_effect_IO$IOCont$Get__f_state = null;
  this.Lcats_effect_IO$IOCont$Get__f_state = state;
}
$c_Lcats_effect_IO$IOCont$Get.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$IOCont$Get.prototype.constructor = $c_Lcats_effect_IO$IOCont$Get;
/** @constructor */
function $h_Lcats_effect_IO$IOCont$Get() {
}
$h_Lcats_effect_IO$IOCont$Get.prototype = $c_Lcats_effect_IO$IOCont$Get.prototype;
$c_Lcats_effect_IO$IOCont$Get.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$IOCont$Get.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_IO$IOCont$Get.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$IOCont$Get)) {
    var x$0$2 = $as_Lcats_effect_IO$IOCont$Get(x$0);
    var x = this.Lcats_effect_IO$IOCont$Get__f_state;
    var x$2 = $n(x$0$2).Lcats_effect_IO$IOCont$Get__f_state;
    if ((x === null)) {
      return (x$2 === null);
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2);
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$IOCont$Get.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_IO$IOCont$Get.prototype.productPrefix__T = (function() {
  return "Get";
});
$c_Lcats_effect_IO$IOCont$Get.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$IOCont$Get__f_state;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$IOCont$Get.prototype.tag__B = (function() {
  return 15;
});
function $as_Lcats_effect_IO$IOCont$Get(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$IOCont$Get) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$IOCont$Get"));
}
function $isArrayOf_Lcats_effect_IO$IOCont$Get(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$IOCont$Get)));
}
function $asArrayOf_Lcats_effect_IO$IOCont$Get(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$IOCont$Get(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$IOCont$Get;", depth));
}
var $d_Lcats_effect_IO$IOCont$Get = new $TypeData().initClass($c_Lcats_effect_IO$IOCont$Get, "cats.effect.IO$IOCont$Get", ({
  Lcats_effect_IO$IOCont$Get: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $as_Lcats_effect_IO$Local(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Local"));
}
function $isArrayOf_Lcats_effect_IO$Local(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Local)));
}
function $asArrayOf_Lcats_effect_IO$Local(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Local(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Local;", depth));
}
/** @constructor */
function $c_Lcats_effect_IO$Map(ioe, f, event) {
  this.Lcats_effect_IO$Map__f_ioe = null;
  this.Lcats_effect_IO$Map__f_f = null;
  this.Lcats_effect_IO$Map__f_event = null;
  this.Lcats_effect_IO$Map__f_ioe = ioe;
  this.Lcats_effect_IO$Map__f_f = f;
  this.Lcats_effect_IO$Map__f_event = event;
}
$c_Lcats_effect_IO$Map.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Map.prototype.constructor = $c_Lcats_effect_IO$Map;
/** @constructor */
function $h_Lcats_effect_IO$Map() {
}
$h_Lcats_effect_IO$Map.prototype = $c_Lcats_effect_IO$Map.prototype;
$c_Lcats_effect_IO$Map.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Map.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_IO$Map.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Map)) {
    var x$0$2 = $as_Lcats_effect_IO$Map(x$0);
    var x = this.Lcats_effect_IO$Map__f_ioe;
    var x$2 = $n(x$0$2).Lcats_effect_IO$Map__f_ioe;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$Map__f_f;
      var x$4 = $n(x$0$2).Lcats_effect_IO$Map__f_f;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lcats_effect_IO$Map__f_event;
      var x$6 = $n(x$0$2).Lcats_effect_IO$Map__f_event;
      if ((x$5 === null)) {
        return (x$6 === null);
      } else {
        var this$1 = $n(x$5);
        return (this$1 === x$6);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Map.prototype.productArity__I = (function() {
  return 3;
});
$c_Lcats_effect_IO$Map.prototype.productPrefix__T = (function() {
  return "Map";
});
$c_Lcats_effect_IO$Map.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_IO$Map__f_ioe;
      break;
    }
    case 1: {
      return this.Lcats_effect_IO$Map__f_f;
      break;
    }
    case 2: {
      return this.Lcats_effect_IO$Map__f_event;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lcats_effect_IO$Map.prototype.tag__B = (function() {
  return 6;
});
function $as_Lcats_effect_IO$Map(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$Map) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Map"));
}
function $isArrayOf_Lcats_effect_IO$Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Map)));
}
function $asArrayOf_Lcats_effect_IO$Map(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Map;", depth));
}
var $d_Lcats_effect_IO$Map = new $TypeData().initClass($c_Lcats_effect_IO$Map, "cats.effect.IO$Map", ({
  Lcats_effect_IO$Map: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$OnCancel(ioa, fin) {
  this.Lcats_effect_IO$OnCancel__f_ioa = null;
  this.Lcats_effect_IO$OnCancel__f_fin = null;
  this.Lcats_effect_IO$OnCancel__f_ioa = ioa;
  this.Lcats_effect_IO$OnCancel__f_fin = fin;
}
$c_Lcats_effect_IO$OnCancel.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$OnCancel.prototype.constructor = $c_Lcats_effect_IO$OnCancel;
/** @constructor */
function $h_Lcats_effect_IO$OnCancel() {
}
$h_Lcats_effect_IO$OnCancel.prototype = $c_Lcats_effect_IO$OnCancel.prototype;
$c_Lcats_effect_IO$OnCancel.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$OnCancel.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_IO$OnCancel.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$OnCancel)) {
    var x$0$2 = $as_Lcats_effect_IO$OnCancel(x$0);
    var x = this.Lcats_effect_IO$OnCancel__f_ioa;
    var x$2 = $n(x$0$2).Lcats_effect_IO$OnCancel__f_ioa;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$OnCancel__f_fin;
      var x$4 = $n(x$0$2).Lcats_effect_IO$OnCancel__f_fin;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$OnCancel.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_IO$OnCancel.prototype.productPrefix__T = (function() {
  return "OnCancel";
});
$c_Lcats_effect_IO$OnCancel.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$OnCancel__f_ioa;
  }
  if ((n === 1)) {
    return this.Lcats_effect_IO$OnCancel__f_fin;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$OnCancel.prototype.tag__B = (function() {
  return 11;
});
function $as_Lcats_effect_IO$OnCancel(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$OnCancel) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$OnCancel"));
}
function $isArrayOf_Lcats_effect_IO$OnCancel(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$OnCancel)));
}
function $asArrayOf_Lcats_effect_IO$OnCancel(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$OnCancel(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$OnCancel;", depth));
}
var $d_Lcats_effect_IO$OnCancel = new $TypeData().initClass($c_Lcats_effect_IO$OnCancel, "cats.effect.IO$OnCancel", ({
  Lcats_effect_IO$OnCancel: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$Pure(value) {
  this.Lcats_effect_IO$Pure__f_value = null;
  this.Lcats_effect_IO$Pure__f_value = value;
}
$c_Lcats_effect_IO$Pure.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Pure.prototype.constructor = $c_Lcats_effect_IO$Pure;
/** @constructor */
function $h_Lcats_effect_IO$Pure() {
}
$h_Lcats_effect_IO$Pure.prototype = $c_Lcats_effect_IO$Pure.prototype;
$c_Lcats_effect_IO$Pure.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Pure.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_IO$Pure.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Pure)) {
    var x$0$2 = $as_Lcats_effect_IO$Pure(x$0);
    var x = this.Lcats_effect_IO$Pure__f_value;
    var y = $n(x$0$2).Lcats_effect_IO$Pure__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Pure.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_IO$Pure.prototype.productPrefix__T = (function() {
  return "Pure";
});
$c_Lcats_effect_IO$Pure.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Pure__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Pure.prototype.tag__B = (function() {
  return 0;
});
$c_Lcats_effect_IO$Pure.prototype.toString__T = (function() {
  return (("IO(" + this.Lcats_effect_IO$Pure__f_value) + ")");
});
function $as_Lcats_effect_IO$Pure(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$Pure) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Pure"));
}
function $isArrayOf_Lcats_effect_IO$Pure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Pure)));
}
function $asArrayOf_Lcats_effect_IO$Pure(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Pure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Pure;", depth));
}
var $d_Lcats_effect_IO$Pure = new $TypeData().initClass($c_Lcats_effect_IO$Pure, "cats.effect.IO$Pure", ({
  Lcats_effect_IO$Pure: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$RacePair(ioa, iob) {
  this.Lcats_effect_IO$RacePair__f_ioa = null;
  this.Lcats_effect_IO$RacePair__f_iob = null;
  this.Lcats_effect_IO$RacePair__f_ioa = ioa;
  this.Lcats_effect_IO$RacePair__f_iob = iob;
}
$c_Lcats_effect_IO$RacePair.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$RacePair.prototype.constructor = $c_Lcats_effect_IO$RacePair;
/** @constructor */
function $h_Lcats_effect_IO$RacePair() {
}
$h_Lcats_effect_IO$RacePair.prototype = $c_Lcats_effect_IO$RacePair.prototype;
$c_Lcats_effect_IO$RacePair.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$RacePair.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_IO$RacePair.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$RacePair)) {
    var x$0$2 = $as_Lcats_effect_IO$RacePair(x$0);
    var x = this.Lcats_effect_IO$RacePair__f_ioa;
    var x$2 = $n(x$0$2).Lcats_effect_IO$RacePair__f_ioa;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$RacePair__f_iob;
      var x$4 = $n(x$0$2).Lcats_effect_IO$RacePair__f_iob;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$RacePair.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_IO$RacePair.prototype.productPrefix__T = (function() {
  return "RacePair";
});
$c_Lcats_effect_IO$RacePair.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$RacePair__f_ioa;
  }
  if ((n === 1)) {
    return this.Lcats_effect_IO$RacePair__f_iob;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$RacePair.prototype.tag__B = (function() {
  return 18;
});
function $as_Lcats_effect_IO$RacePair(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$RacePair) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$RacePair"));
}
function $isArrayOf_Lcats_effect_IO$RacePair(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$RacePair)));
}
function $asArrayOf_Lcats_effect_IO$RacePair(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$RacePair(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$RacePair;", depth));
}
var $d_Lcats_effect_IO$RacePair = new $TypeData().initClass($c_Lcats_effect_IO$RacePair, "cats.effect.IO$RacePair", ({
  Lcats_effect_IO$RacePair: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$Sleep(delay) {
  this.Lcats_effect_IO$Sleep__f_delay = null;
  this.Lcats_effect_IO$Sleep__f_delay = delay;
}
$c_Lcats_effect_IO$Sleep.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Sleep.prototype.constructor = $c_Lcats_effect_IO$Sleep;
/** @constructor */
function $h_Lcats_effect_IO$Sleep() {
}
$h_Lcats_effect_IO$Sleep.prototype = $c_Lcats_effect_IO$Sleep.prototype;
$c_Lcats_effect_IO$Sleep.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Sleep.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_IO$Sleep.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Sleep)) {
    var x$0$2 = $as_Lcats_effect_IO$Sleep(x$0);
    var x = this.Lcats_effect_IO$Sleep__f_delay;
    var x$2 = $n(x$0$2).Lcats_effect_IO$Sleep__f_delay;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Sleep.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_IO$Sleep.prototype.productPrefix__T = (function() {
  return "Sleep";
});
$c_Lcats_effect_IO$Sleep.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Sleep__f_delay;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Sleep.prototype.tag__B = (function() {
  return 19;
});
function $as_Lcats_effect_IO$Sleep(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$Sleep) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Sleep"));
}
function $isArrayOf_Lcats_effect_IO$Sleep(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Sleep)));
}
function $asArrayOf_Lcats_effect_IO$Sleep(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Sleep(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Sleep;", depth));
}
var $d_Lcats_effect_IO$Sleep = new $TypeData().initClass($c_Lcats_effect_IO$Sleep, "cats.effect.IO$Sleep", ({
  Lcats_effect_IO$Sleep: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$Start(ioa) {
  this.Lcats_effect_IO$Start__f_ioa = null;
  this.Lcats_effect_IO$Start__f_ioa = ioa;
}
$c_Lcats_effect_IO$Start.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Start.prototype.constructor = $c_Lcats_effect_IO$Start;
/** @constructor */
function $h_Lcats_effect_IO$Start() {
}
$h_Lcats_effect_IO$Start.prototype = $c_Lcats_effect_IO$Start.prototype;
$c_Lcats_effect_IO$Start.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Start.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_IO$Start.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Start)) {
    var x$0$2 = $as_Lcats_effect_IO$Start(x$0);
    var x = this.Lcats_effect_IO$Start__f_ioa;
    var x$2 = $n(x$0$2).Lcats_effect_IO$Start__f_ioa;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Start.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_IO$Start.prototype.productPrefix__T = (function() {
  return "Start";
});
$c_Lcats_effect_IO$Start.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Start__f_ioa;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Start.prototype.tag__B = (function() {
  return 17;
});
function $as_Lcats_effect_IO$Start(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$Start) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Start"));
}
function $isArrayOf_Lcats_effect_IO$Start(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Start)));
}
function $asArrayOf_Lcats_effect_IO$Start(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Start(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Start;", depth));
}
var $d_Lcats_effect_IO$Start = new $TypeData().initClass($c_Lcats_effect_IO$Start, "cats.effect.IO$Start", ({
  Lcats_effect_IO$Start: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$Uncancelable(body, event) {
  this.Lcats_effect_IO$Uncancelable__f_body = null;
  this.Lcats_effect_IO$Uncancelable__f_event = null;
  this.Lcats_effect_IO$Uncancelable__f_body = body;
  this.Lcats_effect_IO$Uncancelable__f_event = event;
}
$c_Lcats_effect_IO$Uncancelable.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Uncancelable.prototype.constructor = $c_Lcats_effect_IO$Uncancelable;
/** @constructor */
function $h_Lcats_effect_IO$Uncancelable() {
}
$h_Lcats_effect_IO$Uncancelable.prototype = $c_Lcats_effect_IO$Uncancelable.prototype;
$c_Lcats_effect_IO$Uncancelable.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Uncancelable.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lcats_effect_IO$Uncancelable.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Uncancelable)) {
    var x$0$2 = $as_Lcats_effect_IO$Uncancelable(x$0);
    var x = this.Lcats_effect_IO$Uncancelable__f_body;
    var x$2 = $n(x$0$2).Lcats_effect_IO$Uncancelable__f_body;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$Uncancelable__f_event;
      var x$4 = $n(x$0$2).Lcats_effect_IO$Uncancelable__f_event;
      if ((x$3 === null)) {
        return (x$4 === null);
      } else {
        var this$1 = $n(x$3);
        return (this$1 === x$4);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Uncancelable.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_IO$Uncancelable.prototype.productPrefix__T = (function() {
  return "Uncancelable";
});
$c_Lcats_effect_IO$Uncancelable.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Uncancelable__f_body;
  }
  if ((n === 1)) {
    return this.Lcats_effect_IO$Uncancelable__f_event;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Uncancelable.prototype.tag__B = (function() {
  return 12;
});
function $as_Lcats_effect_IO$Uncancelable(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$Uncancelable) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Uncancelable"));
}
function $isArrayOf_Lcats_effect_IO$Uncancelable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Uncancelable)));
}
function $asArrayOf_Lcats_effect_IO$Uncancelable(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Uncancelable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Uncancelable;", depth));
}
var $d_Lcats_effect_IO$Uncancelable = new $TypeData().initClass($c_Lcats_effect_IO$Uncancelable, "cats.effect.IO$Uncancelable", ({
  Lcats_effect_IO$Uncancelable: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(ioa, id, self) {
  this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa = null;
  this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id = 0;
  this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self = null;
  this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa = ioa;
  this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id = id;
  this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self = self;
}
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.constructor = $c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop;
/** @constructor */
function $h_Lcats_effect_IO$Uncancelable$UnmaskRunLoop() {
}
$h_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype = $c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype;
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("UnmaskRunLoop");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop)) {
    var x$0$2 = $as_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(x$0);
    if ((this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id === $n(x$0$2).Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id)) {
      var x = this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa;
      var x$2 = $n(x$0$2).Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self;
      var x$4 = $n(x$0$2).Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self;
      if ((x$3 === null)) {
        return (x$4 === null);
      } else {
        var this$1 = $n(x$3);
        return (this$1 === x$4);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.productArity__I = (function() {
  return 3;
});
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.productPrefix__T = (function() {
  return "UnmaskRunLoop";
});
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa;
      break;
    }
    case 1: {
      return this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id;
      break;
    }
    case 2: {
      return this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.tag__B = (function() {
  return 13;
});
function $as_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Uncancelable$UnmaskRunLoop"));
}
function $isArrayOf_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Uncancelable$UnmaskRunLoop)));
}
function $asArrayOf_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Uncancelable$UnmaskRunLoop;", depth));
}
var $d_Lcats_effect_IO$Uncancelable$UnmaskRunLoop = new $TypeData().initClass($c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop, "cats.effect.IO$Uncancelable$UnmaskRunLoop", ({
  Lcats_effect_IO$Uncancelable$UnmaskRunLoop: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, _cur0, cancelationIterations, autoCedeIterations) {
  var autoCedeIterations$tailLocal1 = autoCedeIterations;
  var cancelationIterations$tailLocal1 = cancelationIterations;
  var _cur0$tailLocal1 = _cur0;
  while (true) {
    if ((_cur0$tailLocal1 === $m_Lcats_effect_IO$EndFiber$())) {
      return (void 0);
    }
    var nextCancelation = (((-1) + cancelationIterations$tailLocal1) | 0);
    var nextAutoCede = autoCedeIterations$tailLocal1;
    if ((nextCancelation <= 0)) {
      nextCancelation = $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold;
      nextAutoCede = ((nextAutoCede - nextCancelation) | 0);
      if ((nextAutoCede <= 0)) {
        $thiz.Lcats_effect_IOFiber__f_resumeTag = 7;
        $thiz.Lcats_effect_IOFiber__f_resumeIO = _cur0$tailLocal1;
        var ec = $thiz.Lcats_effect_IOFiber__f_currentCtx;
        $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, $thiz);
        return (void 0);
      }
    }
    if ($p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz)) {
      var fin = $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, null);
      var cancelationIterations$tailLocal1$tmp1 = nextCancelation;
      var autoCedeIterations$tailLocal1$tmp1 = nextAutoCede;
      _cur0$tailLocal1 = fin;
      cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp1;
      autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp1;
      continue;
    } else {
      if ((_cur0$tailLocal1 === null)) {
        var t = $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
        var cur0 = new $c_Lcats_effect_IO$Error(t);
      } else {
        var cur0 = _cur0$tailLocal1;
      }
      var x38 = $n(cur0).tag__B();
      switch (x38) {
        case 0: {
          var cur = $as_Lcats_effect_IO$Pure(cur0);
          var _cur0$tailLocal1$tmp2 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, $n(cur).Lcats_effect_IO$Pure__f_value, 0);
          var cancelationIterations$tailLocal1$tmp2 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp2 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp2;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp2;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp2;
          continue;
          break;
        }
        case 1: {
          var cur$2 = $as_Lcats_effect_IO$Error(cur0);
          var ex = $n(cur$2).Lcats_effect_IO$Error__f_t;
          if ((!$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(ex))) {
            $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__N(ex);
          }
          var _cur0$tailLocal1$tmp3 = $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, ex, 0);
          var cancelationIterations$tailLocal1$tmp3 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp3 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp3;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp3;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp3;
          continue;
          break;
        }
        case 2: {
          var cur$3 = $as_Lcats_effect_IO$Delay(cur0);
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, $n(cur$3).Lcats_effect_IO$Delay__f_event);
          }
          var error = null;
          try {
            var r = $n($n(cur$3).Lcats_effect_IO$Delay__f_thunk).apply__O();
          } catch (e) {
            var e$1 = e;
            var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
            if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
              error = e$2;
              var r = (void 0);
            } else {
              var r = $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__N(e$2);
            }
          }
          var next = ((error === null) ? $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, r, 0) : $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, error, 0));
          var cancelationIterations$tailLocal1$tmp4 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp4 = nextAutoCede;
          _cur0$tailLocal1 = next;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp4;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp4;
          continue;
          break;
        }
        case 3: {
          var t$1 = $n($n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_scheduler).nowMicros__J();
          var lo = t$1.RTLong__f_lo;
          var hi = t$1.RTLong__f_hi;
          var this$4 = new $c_s_concurrent_duration_package$DurationLong(new $c_RTLong(lo, hi));
          var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
          var t$2 = this$4.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
          var lo$1 = t$2.RTLong__f_lo;
          var hi$1 = t$2.RTLong__f_hi;
          $m_s_concurrent_duration_Duration$();
          var _cur0$tailLocal1$tmp5 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$1, hi$1), unit), 0);
          var cancelationIterations$tailLocal1$tmp5 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp5 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp5;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp5;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp5;
          continue;
          break;
        }
        case 4: {
          $n($n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_scheduler);
          var this$9 = $m_RTLong$();
          var value = (1000000.0 * $uD((0, $m_jl_System$NanoTime$().jl_System$NanoTime$__f_getHighPrecisionTime)()));
          var lo$2 = this$9.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
          var hi$2 = this$9.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var this$11 = new $c_s_concurrent_duration_package$DurationLong(new $c_RTLong(lo$2, hi$2));
          var unit$1 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
          var t$3 = this$11.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
          var lo$3 = t$3.RTLong__f_lo;
          var hi$3 = t$3.RTLong__f_hi;
          $m_s_concurrent_duration_Duration$();
          var _cur0$tailLocal1$tmp6 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$3, hi$3), unit$1), 0);
          var cancelationIterations$tailLocal1$tmp6 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp6 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp6;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp6;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp6;
          continue;
          break;
        }
        case 5: {
          var _cur0$tailLocal1$tmp7 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, $thiz.Lcats_effect_IOFiber__f_currentCtx, 0);
          var cancelationIterations$tailLocal1$tmp7 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp7 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp7;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp7;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp7;
          continue;
          break;
        }
        case 6: {
          var cur$4 = $as_Lcats_effect_IO$Map(cur0);
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, $n(cur$4).Lcats_effect_IO$Map__f_event);
          }
          var ioe = $n(cur$4).Lcats_effect_IO$Map__f_ioe;
          var f = $n(cur$4).Lcats_effect_IO$Map__f_f;
          var x8 = $n(ioe).tag__B();
          switch (x8) {
            case 0: {
              var pure = $as_Lcats_effect_IO$Pure(ioe);
              var _cur0$tailLocal1$tmp8 = $p_Lcats_effect_IOFiber__next$1__F1__O__Lcats_effect_IO($thiz, f, $n(pure).Lcats_effect_IO$Pure__f_value);
              var cancelationIterations$tailLocal1$tmp8 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp8 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp8;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp8;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp8;
              continue;
              break;
            }
            case 1: {
              var error$2 = $as_Lcats_effect_IO$Error(ioe);
              var ex$2 = $n(error$2).Lcats_effect_IO$Error__f_t;
              if ((!$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(ex$2))) {
                $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__N(ex$2);
              }
              var _cur0$tailLocal1$tmp9 = $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, ex$2, 0);
              var cancelationIterations$tailLocal1$tmp9 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp9 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp9;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp9;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp9;
              continue;
              break;
            }
            case 2: {
              var delay = $as_Lcats_effect_IO$Delay(ioe);
              if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
                $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, $n(delay).Lcats_effect_IO$Delay__f_event);
              }
              var error$3 = null;
              try {
                var result = $n(f).apply__O__O($n($n(delay).Lcats_effect_IO$Delay__f_thunk).apply__O());
              } catch (e$3) {
                var e$4 = e$3;
                var e$4$1 = ((e$4 instanceof $c_jl_Throwable) ? e$4 : new $c_sjs_js_JavaScriptException(e$4));
                if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$4$1)) {
                  error$3 = e$4$1;
                  var result = (void 0);
                } else {
                  var result = $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__N(e$4$1);
                }
              }
              var nextIO = ((error$3 === null) ? $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, result, 0) : $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, error$3, 0));
              var cancelationIterations$tailLocal1$tmp10 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp10 = nextAutoCede;
              _cur0$tailLocal1 = nextIO;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp10;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp10;
              continue;
              break;
            }
            case 3: {
              var t$4 = $n($n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_scheduler).nowMicros__J();
              var lo$4 = t$4.RTLong__f_lo;
              var hi$4 = t$4.RTLong__f_hi;
              var this$16 = new $c_s_concurrent_duration_package$DurationLong(new $c_RTLong(lo$4, hi$4));
              var unit$2 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
              var t$5 = this$16.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
              var lo$5 = t$5.RTLong__f_lo;
              var hi$5 = t$5.RTLong__f_hi;
              $m_s_concurrent_duration_Duration$();
              var realTime = new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$5, hi$5), unit$2);
              var _cur0$tailLocal1$tmp11 = $p_Lcats_effect_IOFiber__next$1__F1__O__Lcats_effect_IO($thiz, f, realTime);
              var cancelationIterations$tailLocal1$tmp11 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp11 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp11;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp11;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp11;
              continue;
              break;
            }
            case 4: {
              $n($n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_scheduler);
              var this$21 = $m_RTLong$();
              var value$1 = (1000000.0 * $uD((0, $m_jl_System$NanoTime$().jl_System$NanoTime$__f_getHighPrecisionTime)()));
              var lo$6 = this$21.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$1);
              var hi$6 = this$21.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
              var this$23 = new $c_s_concurrent_duration_package$DurationLong(new $c_RTLong(lo$6, hi$6));
              var unit$3 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
              var t$6 = this$23.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
              var lo$7 = t$6.RTLong__f_lo;
              var hi$7 = t$6.RTLong__f_hi;
              $m_s_concurrent_duration_Duration$();
              var monotonic = new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$7, hi$7), unit$3);
              var _cur0$tailLocal1$tmp12 = $p_Lcats_effect_IOFiber__next$1__F1__O__Lcats_effect_IO($thiz, f, monotonic);
              var cancelationIterations$tailLocal1$tmp12 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp12 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp12;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp12;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp12;
              continue;
              break;
            }
            case 5: {
              var ec$2 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
              var _cur0$tailLocal1$tmp13 = $p_Lcats_effect_IOFiber__next$1__F1__O__Lcats_effect_IO($thiz, f, ec$2);
              var cancelationIterations$tailLocal1$tmp13 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp13 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp13;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp13;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp13;
              continue;
              break;
            }
            default: {
              var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
              this$.push(f);
              var stack = $thiz.Lcats_effect_IOFiber__f_conts;
              var c = $uI(stack[0]);
              var use = ((((1 + (((1 + c) | 0) >> 3)) | 0) < $uI(stack.length)) ? stack : (stack.push(0), stack));
              var s = ((1 + (c >> 3)) | 0);
              var shift = ((7 & c) << 2);
              use[s] = ($uI(use[s]) & (~((-1) << shift)));
              use[0] = ((1 + $uI(use[0])) | 0);
              $thiz.Lcats_effect_IOFiber__f_conts = use;
              var cancelationIterations$tailLocal1$tmp14 = nextCancelation;
              var autoCedeIterations$tailLocal1$tmp14 = nextAutoCede;
              _cur0$tailLocal1 = ioe;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp14;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp14;
              continue;
            }
          }
          break;
        }
        case 7: {
          var cur$5 = $as_Lcats_effect_IO$FlatMap(cur0);
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, $n(cur$5).Lcats_effect_IO$FlatMap__f_event);
          }
          var ioe$2 = $n(cur$5).Lcats_effect_IO$FlatMap__f_ioe;
          var f$2 = $n(cur$5).Lcats_effect_IO$FlatMap__f_f;
          var x13 = $n(ioe$2).tag__B();
          switch (x13) {
            case 0: {
              var pure$2 = $as_Lcats_effect_IO$Pure(ioe$2);
              var _cur0$tailLocal1$tmp15 = $p_Lcats_effect_IOFiber__next$2__F1__O__Lcats_effect_IO($thiz, f$2, $n(pure$2).Lcats_effect_IO$Pure__f_value);
              var cancelationIterations$tailLocal1$tmp15 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp15 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp15;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp15;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp15;
              continue;
              break;
            }
            case 1: {
              var error$4 = $as_Lcats_effect_IO$Error(ioe$2);
              var ex$3 = $n(error$4).Lcats_effect_IO$Error__f_t;
              if ((!$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(ex$3))) {
                $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__N(ex$3);
              }
              var _cur0$tailLocal1$tmp16 = $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, ex$3, 0);
              var cancelationIterations$tailLocal1$tmp16 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp16 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp16;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp16;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp16;
              continue;
              break;
            }
            case 2: {
              var delay$2 = $as_Lcats_effect_IO$Delay(ioe$2);
              if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
                $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, $n(delay$2).Lcats_effect_IO$Delay__f_event);
              }
              try {
                var result$2 = $as_Lcats_effect_IO($n(f$2).apply__O__O($n($n(delay$2).Lcats_effect_IO$Delay__f_thunk).apply__O()));
              } catch (e$5) {
                var e$6 = e$5;
                var e$6$1 = ((e$6 instanceof $c_jl_Throwable) ? e$6 : new $c_sjs_js_JavaScriptException(e$6));
                var result$2 = ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$6$1) ? $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, e$6$1, 0) : $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__N(e$6$1));
              }
              var cancelationIterations$tailLocal1$tmp17 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp17 = nextAutoCede;
              _cur0$tailLocal1 = result$2;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp17;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp17;
              continue;
              break;
            }
            case 3: {
              var t$7 = $n($n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_scheduler).nowMicros__J();
              var lo$8 = t$7.RTLong__f_lo;
              var hi$8 = t$7.RTLong__f_hi;
              var this$30 = new $c_s_concurrent_duration_package$DurationLong(new $c_RTLong(lo$8, hi$8));
              var unit$4 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
              var t$8 = this$30.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
              var lo$9 = t$8.RTLong__f_lo;
              var hi$9 = t$8.RTLong__f_hi;
              $m_s_concurrent_duration_Duration$();
              var realTime$2 = new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$9, hi$9), unit$4);
              var _cur0$tailLocal1$tmp18 = $p_Lcats_effect_IOFiber__next$2__F1__O__Lcats_effect_IO($thiz, f$2, realTime$2);
              var cancelationIterations$tailLocal1$tmp18 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp18 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp18;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp18;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp18;
              continue;
              break;
            }
            case 4: {
              $n($n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_scheduler);
              var this$35 = $m_RTLong$();
              var value$2 = (1000000.0 * $uD((0, $m_jl_System$NanoTime$().jl_System$NanoTime$__f_getHighPrecisionTime)()));
              var lo$10 = this$35.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$2);
              var hi$10 = this$35.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
              var this$37 = new $c_s_concurrent_duration_package$DurationLong(new $c_RTLong(lo$10, hi$10));
              var unit$5 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
              var t$9 = this$37.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
              var lo$11 = t$9.RTLong__f_lo;
              var hi$11 = t$9.RTLong__f_hi;
              $m_s_concurrent_duration_Duration$();
              var monotonic$2 = new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$11, hi$11), unit$5);
              var _cur0$tailLocal1$tmp19 = $p_Lcats_effect_IOFiber__next$2__F1__O__Lcats_effect_IO($thiz, f$2, monotonic$2);
              var cancelationIterations$tailLocal1$tmp19 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp19 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp19;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp19;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp19;
              continue;
              break;
            }
            case 5: {
              var ec$3 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
              var _cur0$tailLocal1$tmp20 = $p_Lcats_effect_IOFiber__next$2__F1__O__Lcats_effect_IO($thiz, f$2, ec$3);
              var cancelationIterations$tailLocal1$tmp20 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp20 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp20;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp20;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp20;
              continue;
              break;
            }
            default: {
              var this$$1 = $thiz.Lcats_effect_IOFiber__f_objectState;
              this$$1.push(f$2);
              var stack$1 = $thiz.Lcats_effect_IOFiber__f_conts;
              var c$1 = $uI(stack$1[0]);
              var use$1 = ((((1 + (((1 + c$1) | 0) >> 3)) | 0) < $uI(stack$1.length)) ? stack$1 : (stack$1.push(0), stack$1));
              var s$1 = ((1 + (c$1 >> 3)) | 0);
              var shift$1 = ((7 & c$1) << 2);
              use$1[s$1] = (($uI(use$1[s$1]) & (~((-1) << shift$1))) | (1 << shift$1));
              use$1[0] = ((1 + $uI(use$1[0])) | 0);
              $thiz.Lcats_effect_IOFiber__f_conts = use$1;
              var cancelationIterations$tailLocal1$tmp21 = nextCancelation;
              var autoCedeIterations$tailLocal1$tmp21 = nextAutoCede;
              _cur0$tailLocal1 = ioe$2;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp21;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp21;
              continue;
            }
          }
          break;
        }
        case 8: {
          var cur$6 = $as_Lcats_effect_IO$Attempt(cur0);
          var ioa = $n(cur$6).Lcats_effect_IO$Attempt__f_ioa;
          var x16 = $n(ioa).tag__B();
          switch (x16) {
            case 0: {
              var pure$3 = $as_Lcats_effect_IO$Pure(ioa);
              var value$3 = $n(pure$3).Lcats_effect_IO$Pure__f_value;
              var _cur0$tailLocal1$tmp22 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $c_s_util_Right(value$3), 0);
              var cancelationIterations$tailLocal1$tmp22 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp22 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp22;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp22;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp22;
              continue;
              break;
            }
            case 1: {
              var error$5 = $as_Lcats_effect_IO$Error(ioa);
              var t$7$1 = $n(error$5).Lcats_effect_IO$Error__f_t;
              if ((!$m_s_util_control_NonFatal$().apply__jl_Throwable__Z(t$7$1))) {
                $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__N(t$7$1);
              }
              $m_Lcats_effect_tracing_Tracing$().augmentThrowable__Z__jl_Throwable__Lcats_effect_tracing_RingBuffer__V($n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_enhancedExceptions, t$7$1, $thiz.Lcats_effect_IOFiber__f_tracingEvents);
              var _cur0$tailLocal1$tmp23 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $c_s_util_Left(t$7$1), 0);
              var cancelationIterations$tailLocal1$tmp23 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp23 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp23;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp23;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp23;
              continue;
              break;
            }
            case 2: {
              var delay$3 = $as_Lcats_effect_IO$Delay(ioa);
              if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
                $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, $n(delay$3).Lcats_effect_IO$Delay__f_event);
              }
              var error$6 = null;
              try {
                var result$3 = $n($n(delay$3).Lcats_effect_IO$Delay__f_thunk).apply__O();
              } catch (e$7) {
                var e$8 = e$7;
                var e$8$1 = ((e$8 instanceof $c_jl_Throwable) ? e$8 : new $c_sjs_js_JavaScriptException(e$8));
                if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$8$1)) {
                  $m_Lcats_effect_tracing_Tracing$().augmentThrowable__Z__jl_Throwable__Lcats_effect_tracing_RingBuffer__V($n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_enhancedExceptions, e$8$1, $thiz.Lcats_effect_IOFiber__f_tracingEvents);
                  error$6 = e$8$1;
                  var result$3 = (void 0);
                } else {
                  var result$3 = $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__N(e$8$1);
                }
              }
              if ((error$6 === null)) {
                var next$2 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $c_s_util_Right(result$3), 0);
              } else {
                var value$4 = error$6;
                var next$2 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $c_s_util_Left(value$4), 0);
              }
              var cancelationIterations$tailLocal1$tmp24 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp24 = nextAutoCede;
              _cur0$tailLocal1 = next$2;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp24;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp24;
              continue;
              break;
            }
            case 3: {
              var t$10 = $n($n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_scheduler).nowMicros__J();
              var lo$12 = t$10.RTLong__f_lo;
              var hi$12 = t$10.RTLong__f_hi;
              var this$48 = new $c_s_concurrent_duration_package$DurationLong(new $c_RTLong(lo$12, hi$12));
              var unit$6 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
              var t$11 = this$48.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
              var lo$13 = t$11.RTLong__f_lo;
              var hi$13 = t$11.RTLong__f_hi;
              $m_s_concurrent_duration_Duration$();
              var realTime$3 = new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$13, hi$13), unit$6);
              var _cur0$tailLocal1$tmp25 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $c_s_util_Right(realTime$3), 0);
              var cancelationIterations$tailLocal1$tmp25 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp25 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp25;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp25;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp25;
              continue;
              break;
            }
            case 4: {
              $n($n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_scheduler);
              var this$54 = $m_RTLong$();
              var value$5 = (1000000.0 * $uD((0, $m_jl_System$NanoTime$().jl_System$NanoTime$__f_getHighPrecisionTime)()));
              var lo$14 = this$54.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$5);
              var hi$14 = this$54.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
              var this$56 = new $c_s_concurrent_duration_package$DurationLong(new $c_RTLong(lo$14, hi$14));
              var unit$7 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
              var t$12 = this$56.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
              var lo$15 = t$12.RTLong__f_lo;
              var hi$15 = t$12.RTLong__f_hi;
              $m_s_concurrent_duration_Duration$();
              var monotonic$3 = new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$15, hi$15), unit$7);
              var _cur0$tailLocal1$tmp26 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $c_s_util_Right(monotonic$3), 0);
              var cancelationIterations$tailLocal1$tmp26 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp26 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp26;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp26;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp26;
              continue;
              break;
            }
            case 5: {
              var ec$4 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
              var _cur0$tailLocal1$tmp27 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $c_s_util_Right(ec$4), 0);
              var cancelationIterations$tailLocal1$tmp27 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp27 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp27;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp27;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp27;
              continue;
              break;
            }
            default: {
              var stack$2 = $thiz.Lcats_effect_IOFiber__f_conts;
              var c$2 = $uI(stack$2[0]);
              var use$2 = ((((1 + (((1 + c$2) | 0) >> 3)) | 0) < $uI(stack$2.length)) ? stack$2 : (stack$2.push(0), stack$2));
              var s$2 = ((1 + (c$2 >> 3)) | 0);
              var shift$2 = ((7 & c$2) << 2);
              use$2[s$2] = (($uI(use$2[s$2]) & (~((-1) << shift$2))) | (9 << shift$2));
              use$2[0] = ((1 + $uI(use$2[0])) | 0);
              $thiz.Lcats_effect_IOFiber__f_conts = use$2;
              var cancelationIterations$tailLocal1$tmp28 = nextCancelation;
              var autoCedeIterations$tailLocal1$tmp28 = nextAutoCede;
              _cur0$tailLocal1 = ioa;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp28;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp28;
              continue;
            }
          }
          break;
        }
        case 9: {
          var cur$7 = $as_Lcats_effect_IO$HandleErrorWith(cur0);
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, $n(cur$7).Lcats_effect_IO$HandleErrorWith__f_event);
          }
          var this$$2 = $thiz.Lcats_effect_IOFiber__f_objectState;
          var a = $n(cur$7).Lcats_effect_IO$HandleErrorWith__f_f;
          this$$2.push(a);
          var stack$3 = $thiz.Lcats_effect_IOFiber__f_conts;
          var c$3 = $uI(stack$3[0]);
          var use$3 = ((((1 + (((1 + c$3) | 0) >> 3)) | 0) < $uI(stack$3.length)) ? stack$3 : (stack$3.push(0), stack$3));
          var s$3 = ((1 + (c$3 >> 3)) | 0);
          var shift$3 = ((7 & c$3) << 2);
          use$3[s$3] = (($uI(use$3[s$3]) & (~((-1) << shift$3))) | (5 << shift$3));
          use$3[0] = ((1 + $uI(use$3[0])) | 0);
          $thiz.Lcats_effect_IOFiber__f_conts = use$3;
          var _cur0$tailLocal1$tmp29 = $n(cur$7).Lcats_effect_IO$HandleErrorWith__f_ioa;
          var cancelationIterations$tailLocal1$tmp29 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp29 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp29;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp29;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp29;
          continue;
          break;
        }
        case 10: {
          $thiz.Lcats_effect_IOFiber__f_canceled = true;
          if ($p_Lcats_effect_IOFiber__isUnmasked__Z($thiz)) {
            var fin$2 = $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, null);
            var cancelationIterations$tailLocal1$tmp30 = nextCancelation;
            var autoCedeIterations$tailLocal1$tmp30 = nextAutoCede;
            _cur0$tailLocal1 = fin$2;
            cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp30;
            autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp30;
            continue;
          } else {
            var _cur0$tailLocal1$tmp31 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, (void 0), 0);
            var cancelationIterations$tailLocal1$tmp31 = nextCancelation;
            var autoCedeIterations$tailLocal1$tmp31 = nextAutoCede;
            _cur0$tailLocal1 = _cur0$tailLocal1$tmp31;
            cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp31;
            autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp31;
            continue;
          }
          break;
        }
        case 11: {
          var cur$8 = $as_Lcats_effect_IO$OnCancel(cur0);
          var this$$3 = $thiz.Lcats_effect_IOFiber__f_finalizers;
          var ioa$1 = $n(cur$8).Lcats_effect_IO$OnCancel__f_fin;
          var ec$1 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
          var a$1 = new $c_Lcats_effect_IO$EvalOn(ioa$1, ec$1);
          this$$3.push(a$1);
          var stack$4 = $thiz.Lcats_effect_IOFiber__f_conts;
          var c$4 = $uI(stack$4[0]);
          var use$4 = ((((1 + (((1 + c$4) | 0) >> 3)) | 0) < $uI(stack$4.length)) ? stack$4 : (stack$4.push(0), stack$4));
          var s$4 = ((1 + (c$4 >> 3)) | 0);
          var shift$4 = ((7 & c$4) << 2);
          use$4[s$4] = (($uI(use$4[s$4]) & (~((-1) << shift$4))) | (6 << shift$4));
          use$4[0] = ((1 + $uI(use$4[0])) | 0);
          $thiz.Lcats_effect_IOFiber__f_conts = use$4;
          var _cur0$tailLocal1$tmp32 = $n(cur$8).Lcats_effect_IO$OnCancel__f_ioa;
          var cancelationIterations$tailLocal1$tmp32 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp32 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp32;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp32;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp32;
          continue;
          break;
        }
        case 12: {
          var cur$9 = $as_Lcats_effect_IO$Uncancelable(cur0);
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, $n(cur$9).Lcats_effect_IO$Uncancelable__f_event);
          }
          $thiz.Lcats_effect_IOFiber__f_masks = ((1 + $thiz.Lcats_effect_IOFiber__f_masks) | 0);
          var id = $thiz.Lcats_effect_IOFiber__f_masks;
          var poll = new $c_Lcats_effect_IOFiber$$anon$1(id, $thiz);
          try {
            var next$3 = $as_Lcats_effect_IO($n($n(cur$9).Lcats_effect_IO$Uncancelable__f_body).apply__O__O(poll));
          } catch (e$9) {
            var e$10 = e$9;
            var e$10$1 = ((e$10 instanceof $c_jl_Throwable) ? e$10 : new $c_sjs_js_JavaScriptException(e$10));
            var next$3 = ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$10$1) ? ($m_Lcats_effect_IO$(), new $c_Lcats_effect_IO$Error(e$10$1)) : $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__N(e$10$1));
          }
          var stack$5 = $thiz.Lcats_effect_IOFiber__f_conts;
          var c$5 = $uI(stack$5[0]);
          var use$5 = ((((1 + (((1 + c$5) | 0) >> 3)) | 0) < $uI(stack$5.length)) ? stack$5 : (stack$5.push(0), stack$5));
          var s$5 = ((1 + (c$5 >> 3)) | 0);
          var shift$5 = ((7 & c$5) << 2);
          use$5[s$5] = (($uI(use$5[s$5]) & (~((-1) << shift$5))) | (7 << shift$5));
          use$5[0] = ((1 + $uI(use$5[0])) | 0);
          $thiz.Lcats_effect_IOFiber__f_conts = use$5;
          var cancelationIterations$tailLocal1$tmp33 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp33 = nextAutoCede;
          _cur0$tailLocal1 = next$3;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp33;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp33;
          continue;
          break;
        }
        case 13: {
          var cur$10 = $as_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(cur0);
          if ((($thiz.Lcats_effect_IOFiber__f_masks === $n(cur$10).Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id) && ($thiz === $n(cur$10).Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self))) {
            $thiz.Lcats_effect_IOFiber__f_masks = (((-1) + $thiz.Lcats_effect_IOFiber__f_masks) | 0);
            var stack$6 = $thiz.Lcats_effect_IOFiber__f_conts;
            var c$6 = $uI(stack$6[0]);
            var use$6 = ((((1 + (((1 + c$6) | 0) >> 3)) | 0) < $uI(stack$6.length)) ? stack$6 : (stack$6.push(0), stack$6));
            var s$6 = ((1 + (c$6 >> 3)) | 0);
            var shift$6 = ((7 & c$6) << 2);
            use$6[s$6] = (($uI(use$6[s$6]) & (~((-1) << shift$6))) | (8 << shift$6));
            use$6[0] = ((1 + $uI(use$6[0])) | 0);
            $thiz.Lcats_effect_IOFiber__f_conts = use$6;
          }
          var _cur0$tailLocal1$tmp34 = $n(cur$10).Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa;
          var cancelationIterations$tailLocal1$tmp34 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp34 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp34;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp34;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp34;
          continue;
          break;
        }
        case 14: {
          var cur$11 = $as_Lcats_effect_IO$IOCont(cur0);
          var body = $n(cur$11).Lcats_effect_IO$IOCont__f_body;
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, $n(cur$11).Lcats_effect_IO$IOCont__f_event);
          }
          var state = new $c_Lcats_effect_ContState($thiz.Lcats_effect_IOFiber__f_finalizing);
          var cb = new $c_sjsr_AnonFunction1(((state) => ((e$11) => {
            var e$12 = $as_s_util_Either(e$11);
            if ((e$12 === null)) {
              var value$6 = $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
              var result$1 = new $c_s_util_Left(value$6);
            } else {
              var result$1 = e$12;
            }
            var waiting = state.Lcats_effect_ContState__f_waiting;
            $p_Lcats_effect_IOFiber__stateLoop$1__Lcats_effect_ContState__s_util_Either__s_util_Either__V($thiz, state, result$1, waiting);
          }))(state));
          var get = new $c_Lcats_effect_IO$IOCont$Get(state);
          try {
            var $x_1 = $n(body).apply__Lcats_effect_kernel_MonadCancel__F3($m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO);
            var this$75 = $m_Lcats_arrow_FunctionK$();
            var next$4 = $as_Lcats_effect_IO($n($x_1).apply__O__O__O__O(cb, get, new $c_Lcats_arrow_FunctionK$$anon$4(this$75)));
          } catch (e$12$1) {
            var e$13 = e$12$1;
            var e$13$1 = ((e$13 instanceof $c_jl_Throwable) ? e$13 : new $c_sjs_js_JavaScriptException(e$13));
            var next$4 = ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$13$1) ? ($m_Lcats_effect_IO$(), new $c_Lcats_effect_IO$Error(e$13$1)) : $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__N(e$13$1));
          }
          var cancelationIterations$tailLocal1$tmp35 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp35 = nextAutoCede;
          _cur0$tailLocal1 = next$4;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp35;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp35;
          continue;
          break;
        }
        case 15: {
          var cur$12 = $as_Lcats_effect_IO$IOCont$Get(cur0);
          var state$3 = $n(cur$12).Lcats_effect_IO$IOCont$Get__f_state;
          var this$79 = $m_Lcats_effect_IO$();
          var thunk = new $c_sjsr_AnonFunction0(((state$3) => (() => {
            $n(state$3).compareAndSet__O__O__Z($n(state$3).Lcats_effect_ContState__f_waiting, null);
          }))(state$3));
          var fin$3 = this$79.delay__F0__Lcats_effect_IO(thunk);
          var this$$4 = $thiz.Lcats_effect_IOFiber__f_finalizers;
          this$$4.push(fin$3);
          var stack$7 = $thiz.Lcats_effect_IOFiber__f_conts;
          var c$7 = $uI(stack$7[0]);
          var use$7 = ((((1 + (((1 + c$7) | 0) >> 3)) | 0) < $uI(stack$7.length)) ? stack$7 : (stack$7.push(0), stack$7));
          var s$7 = ((1 + (c$7 >> 3)) | 0);
          var shift$7 = ((7 & c$7) << 2);
          use$7[s$7] = (($uI(use$7[s$7]) & (~((-1) << shift$7))) | (6 << shift$7));
          use$7[0] = ((1 + $uI(use$7[0])) | 0);
          $thiz.Lcats_effect_IOFiber__f_conts = use$7;
          if ($n(state$3).compareAndSet__O__O__Z(null, $n(state$3).Lcats_effect_ContState__f_waiting)) {
            $n(state$3).Lcats_effect_ContState__f_wasFinalizing = $thiz.Lcats_effect_IOFiber__f_finalizing;
            if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
              $n(state$3).Lcats_effect_ContState__f_handle = $p_Lcats_effect_IOFiber__monitor__Lcats_effect_unsafe_WeakBag$Handle($thiz);
              var this$$5 = $thiz.Lcats_effect_IOFiber__f_finalizers;
              var this$82 = $m_Lcats_effect_IO$();
              var thunk$1 = new $c_sjsr_AnonFunction0(((state$3) => (() => {
                $n($n(state$3).Lcats_effect_ContState__f_handle).deregister__V();
              }))(state$3));
              var a$2 = this$82.delay__F0__Lcats_effect_IO(thunk$1);
              this$$5.push(a$2);
              var stack$8 = $thiz.Lcats_effect_IOFiber__f_conts;
              var c$8 = $uI(stack$8[0]);
              var use$8 = ((((1 + (((1 + c$8) | 0) >> 3)) | 0) < $uI(stack$8.length)) ? stack$8 : (stack$8.push(0), stack$8));
              var s$8 = ((1 + (c$8 >> 3)) | 0);
              var shift$8 = ((7 & c$8) << 2);
              use$8[s$8] = (($uI(use$8[s$8]) & (~((-1) << shift$8))) | (6 << shift$8));
              use$8[0] = ((1 + $uI(use$8[0])) | 0);
              $thiz.Lcats_effect_IOFiber__f_conts = use$8;
            }
            $thiz.getAndSet__Z__Z(true);
            if ($p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz)) {
              if ($thiz.getAndSet__Z__Z(false)) {
                if ($p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz)) {
                  var fin$4 = $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, null);
                  var cancelationIterations$tailLocal1$tmp36 = nextCancelation;
                  var autoCedeIterations$tailLocal1$tmp36 = nextAutoCede;
                  _cur0$tailLocal1 = fin$4;
                  cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp36;
                  autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp36;
                  continue;
                } else {
                  $thiz.ju_concurrent_atomic_AtomicBoolean__f_value = true;
                }
              }
            }
          } else {
            var result$4 = $as_s_util_Either($n(state$3).ju_concurrent_atomic_AtomicReference__f_value);
            if ((!$p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz))) {
              matchResult14: {
                var next$5;
                if ((result$4 instanceof $c_s_util_Left)) {
                  var t$14 = $as_jl_Throwable($n($as_s_util_Left(result$4)).s_util_Left__f_value);
                  var next$5 = $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, t$14, 0);
                  break matchResult14;
                }
                if ((result$4 instanceof $c_s_util_Right)) {
                  var a$3 = $n($as_s_util_Right(result$4)).s_util_Right__f_value;
                  var next$5 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, a$3, 0);
                  break matchResult14;
                }
                throw new $c_s_MatchError(result$4);
              }
              var cancelationIterations$tailLocal1$tmp37 = nextCancelation;
              var autoCedeIterations$tailLocal1$tmp37 = nextAutoCede;
              _cur0$tailLocal1 = next$5;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp37;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp37;
              continue;
            } else if (($thiz.Lcats_effect_IOFiber__f_outcome === null)) {
              var fin$5 = $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, null);
              var cancelationIterations$tailLocal1$tmp38 = nextCancelation;
              var autoCedeIterations$tailLocal1$tmp38 = nextAutoCede;
              _cur0$tailLocal1 = fin$5;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp38;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp38;
              continue;
            }
          }
          break;
        }
        case 16: {
          $thiz.Lcats_effect_IOFiber__f_resumeTag = 6;
          var ec$5 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
          $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec$5, $thiz);
          break;
        }
        case 17: {
          var cur$13 = $as_Lcats_effect_IO$Start(cur0);
          var ec$5$1 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
          var fiber = new $c_Lcats_effect_IOFiber($thiz.Lcats_effect_IOFiber__f_localState, null, $n(cur$13).Lcats_effect_IO$Start__f_ioa, ec$5$1, $thiz.Lcats_effect_IOFiber__f_runtime);
          $p_Lcats_effect_IOFiber__scheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec$5$1, fiber);
          var _cur0$tailLocal1$tmp39 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, fiber, 0);
          var cancelationIterations$tailLocal1$tmp39 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp39 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp39;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp39;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp39;
          continue;
          break;
        }
        case 18: {
          var cur$14 = $as_Lcats_effect_IO$RacePair(cur0);
          var next$6 = $m_Lcats_effect_IO$().async__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((cur$14) => ((cb$2) => {
            var cb$1 = $as_F1(cb$2);
            var this$96 = $m_Lcats_effect_IO$();
            var thunk$2 = new $c_sjsr_AnonFunction0((() => {
              var ec$6 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
              var rt = $thiz.Lcats_effect_IOFiber__f_runtime;
              var fiberA = new $c_Lcats_effect_IOFiber($thiz.Lcats_effect_IOFiber__f_localState, null, $n(cur$14).Lcats_effect_IO$RacePair__f_ioa, ec$6, rt);
              var fiberB = new $c_Lcats_effect_IOFiber($thiz.Lcats_effect_IOFiber__f_localState, null, $n(cur$14).Lcats_effect_IO$RacePair__f_iob, ec$6, rt);
              $p_Lcats_effect_IOFiber__setCallback__F1__V(fiberA, new $c_sjsr_AnonFunction1(((oc) => {
                var oc$1 = $as_Lcats_effect_kernel_Outcome(oc);
                var $x_2 = $n(cb$1);
                var value$7 = new $c_T2(oc$1, fiberB);
                var value$8 = new $c_s_util_Left(value$7);
                $n($x_2).apply__O__O(new $c_s_util_Right(value$8));
              })));
              $p_Lcats_effect_IOFiber__setCallback__F1__V(fiberB, new $c_sjsr_AnonFunction1(((oc$2) => {
                var oc$3 = $as_Lcats_effect_kernel_Outcome(oc$2);
                var $x_3 = $n(cb$1);
                var value$9 = new $c_T2(fiberA, oc$3);
                var value$10 = new $c_s_util_Right(value$9);
                $n($x_3).apply__O__O(new $c_s_util_Right(value$10));
              })));
              $p_Lcats_effect_IOFiber__scheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec$6, fiberA);
              $p_Lcats_effect_IOFiber__scheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec$6, fiberB);
              var this$91 = $n(fiberA.cancel__Lcats_effect_IO());
              var cancel = new $c_Lcats_effect_IO$Start(this$91).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((cancelA) => {
                var cancelA$1 = $as_Lcats_effect_kernel_Fiber(cancelA);
                var this$93 = $n(fiberB.cancel__Lcats_effect_IO());
                return new $c_Lcats_effect_IO$Start(this$93).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((cancelB) => {
                  var cancelB$1 = $as_Lcats_effect_kernel_Fiber(cancelB);
                  return $n($as_Lcats_effect_IO($n(cancelA$1).join__O())).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((x$1) => {
                    $as_Lcats_effect_kernel_Outcome(x$1);
                    return $n($as_Lcats_effect_IO($n(cancelB$1).join__O())).map__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((x$1$2) => {
                      $as_Lcats_effect_kernel_Outcome(x$1$2);
                    })));
                  })));
                })));
              })));
              return new $c_s_Some(cancel);
            }));
            return this$96.delay__F0__Lcats_effect_IO(thunk$2);
          }))(cur$14)));
          var cancelationIterations$tailLocal1$tmp40 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp40 = nextAutoCede;
          _cur0$tailLocal1 = next$6;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp40;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp40;
          continue;
          break;
        }
        case 19: {
          var cur$16 = $as_Lcats_effect_IO$Sleep(cur0);
          var delay$4 = $n(cur$16).Lcats_effect_IO$Sleep__f_delay;
          var this$97 = $n(delay$4).s_concurrent_duration_FiniteDuration__f_length;
          var ahi = this$97.RTLong__f_hi;
          if (((ahi === 0) ? (this$97.RTLong__f_lo !== 0) : (ahi > 0))) {
            var next$7 = $m_Lcats_effect_IO$().async__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((delay$4) => ((cb$3) => {
              var cb$4 = $as_F1(cb$3);
              var this$101 = $m_Lcats_effect_IO$();
              var thunk$5 = new $c_sjsr_AnonFunction0((() => {
                var scheduler = $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_scheduler;
                if (false) {
                  var cancel$1 = $n($as_Lcats_effect_unsafe_WorkStealingThreadPool(scheduler)).sleepInternal__s_concurrent_duration_FiniteDuration__F1__jl_Runnable(delay$4, cb$4);
                  var thunk$3 = $as_F0(cancel$1);
                  var cancelIO = new $c_Lcats_effect_IO$Delay(thunk$3, null);
                } else {
                  var cancel$2 = $n(scheduler).sleep__s_concurrent_duration_FiniteDuration__jl_Runnable__jl_Runnable(delay$4, new $c_Lcats_effect_IOFiber$$anon$2(cb$4, $thiz));
                  var this$99 = $m_Lcats_effect_IO$();
                  var thunk$4 = new $c_sjsr_AnonFunction0((() => {
                    $n(cancel$2).run__V();
                  }));
                  var cancelIO = this$99.delay__F0__Lcats_effect_IO(thunk$4);
                }
                return new $c_s_Some(cancelIO);
              }));
              return this$101.delay__F0__Lcats_effect_IO(thunk$5);
            }))(delay$4)));
          } else {
            $m_Lcats_effect_IO$();
            var next$7 = $m_Lcats_effect_IO$Cede$();
          }
          var cancelationIterations$tailLocal1$tmp41 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp41 = nextAutoCede;
          _cur0$tailLocal1 = next$7;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp41;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp41;
          continue;
          break;
        }
        case 20: {
          var cur$17 = $as_Lcats_effect_IO$EvalOn(cur0);
          if (($n(cur$17).Lcats_effect_IO$EvalOn__f_ec === $thiz.Lcats_effect_IOFiber__f_currentCtx)) {
            var _cur0$tailLocal1$tmp42 = $n(cur$17).Lcats_effect_IO$EvalOn__f_ioa;
            var cancelationIterations$tailLocal1$tmp42 = nextCancelation;
            var autoCedeIterations$tailLocal1$tmp42 = nextAutoCede;
            _cur0$tailLocal1 = _cur0$tailLocal1$tmp42;
            cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp42;
            autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp42;
            continue;
          } else {
            var ec$6$1 = $n(cur$17).Lcats_effect_IO$EvalOn__f_ec;
            var this$$6 = $thiz.Lcats_effect_IOFiber__f_objectState;
            var a$4 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
            this$$6.push(a$4);
            $thiz.Lcats_effect_IOFiber__f_currentCtx = ec$6$1;
            var stack$9 = $thiz.Lcats_effect_IOFiber__f_conts;
            var c$9 = $uI(stack$9[0]);
            var use$9 = ((((1 + (((1 + c$9) | 0) >> 3)) | 0) < $uI(stack$9.length)) ? stack$9 : (stack$9.push(0), stack$9));
            var s$9 = ((1 + (c$9 >> 3)) | 0);
            var shift$9 = ((7 & c$9) << 2);
            use$9[s$9] = (($uI(use$9[s$9]) & (~((-1) << shift$9))) | (4 << shift$9));
            use$9[0] = ((1 + $uI(use$9[0])) | 0);
            $thiz.Lcats_effect_IOFiber__f_conts = use$9;
            $thiz.Lcats_effect_IOFiber__f_resumeTag = 7;
            $thiz.Lcats_effect_IOFiber__f_resumeIO = $n(cur$17).Lcats_effect_IO$EvalOn__f_ioa;
            if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
              var handle = $p_Lcats_effect_IOFiber__monitor__Lcats_effect_unsafe_WeakBag$Handle($thiz);
              var this$$7 = $thiz.Lcats_effect_IOFiber__f_objectState;
              this$$7.push(handle);
            }
            $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec$6$1, $thiz);
          }
          break;
        }
        case 21: {
          var cur$18 = $as_Lcats_effect_IO$Blocking(cur0);
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, $n(cur$18).event__Lcats_effect_tracing_TracingEvent());
          }
          if (($n(cur$18).hint__Lcats_effect_kernel_Sync$Type() === $m_Lcats_effect_IOFiber$().Lcats_effect_IOFiber$__f_TypeBlocking)) {
            var ec$7 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
            if (false) {
              var wstp = $as_Lcats_effect_unsafe_WorkStealingThreadPool(ec$7);
              if ($n(wstp).canExecuteBlockingCode__Z()) {
                $n(wstp).prepareForBlocking__V();
                var error$7 = null;
                try {
                  var r$2 = $n($n(cur$18).thunk__F0()).apply__O();
                } catch (e$14) {
                  var e$15 = e$14;
                  var e$15$1 = ((e$15 instanceof $c_jl_Throwable) ? e$15 : new $c_sjs_js_JavaScriptException(e$15));
                  if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$15$1)) {
                    error$7 = e$15$1;
                    var r$2 = (void 0);
                  } else {
                    var r$2 = $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__N(e$15$1);
                  }
                }
                var next$8 = ((error$7 === null) ? $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, r$2, 0) : $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, error$7, 0));
                var cancelationIterations$tailLocal1$tmp43 = nextCancelation;
                var autoCedeIterations$tailLocal1$tmp43 = $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold;
                _cur0$tailLocal1 = next$8;
                cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp43;
                autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp43;
                continue;
              } else {
                $p_Lcats_effect_IOFiber__blockingFallback__Lcats_effect_IO$Blocking__V($thiz, cur$18);
              }
            } else {
              $p_Lcats_effect_IOFiber__blockingFallback__Lcats_effect_IO$Blocking__V($thiz, cur$18);
            }
          } else {
            var _cur0$tailLocal1$tmp44 = $thiz.interruptibleImpl__Lcats_effect_IO$Blocking__Lcats_effect_IO(cur$18);
            var cancelationIterations$tailLocal1$tmp44 = nextCancelation;
            var autoCedeIterations$tailLocal1$tmp44 = nextAutoCede;
            _cur0$tailLocal1 = _cur0$tailLocal1$tmp44;
            cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp44;
            autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp44;
            continue;
          }
          break;
        }
        case 22: {
          var cur$19 = $as_Lcats_effect_IO$Local(cur0);
          matchResult18: {
            var \u03b41$___1;
            var \u03b41$___2;
            var x35 = $as_T2($n($n(cur$19).f__F1()).apply__O__O($thiz.Lcats_effect_IOFiber__f_localState));
            if ((x35 !== null)) {
              var nextLocalState = $as_sci_Map($n(x35)._1__O());
              var value$11 = $n(x35)._2__O();
              var \u03b41$___1 = nextLocalState;
              var \u03b41$___2 = value$11;
              break matchResult18;
            }
            throw new $c_s_MatchError(x35);
          }
          var nextLocalState$2 = $as_sci_Map(\u03b41$___1);
          var value$2$1 = \u03b41$___2;
          $thiz.Lcats_effect_IOFiber__f_localState = nextLocalState$2;
          var _cur0$tailLocal1$tmp45 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, value$2$1, 0);
          var cancelationIterations$tailLocal1$tmp45 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp45 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp45;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp45;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp45;
          continue;
          break;
        }
        case 23: {
          var _cur0$tailLocal1$tmp46 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, $m_Lcats_effect_Trace$().apply__Lcats_effect_tracing_RingBuffer__Lcats_effect_Trace($thiz.Lcats_effect_IOFiber__f_tracingEvents), 0);
          var cancelationIterations$tailLocal1$tmp46 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp46 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp46;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp46;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp46;
          continue;
          break;
        }
        default: {
          throw new $c_s_MatchError(x38);
        }
      }
    }
    return (void 0);
  }
}
function $p_Lcats_effect_IOFiber__blockingFallback__Lcats_effect_IO$Blocking__V($thiz, cur) {
  $thiz.Lcats_effect_IOFiber__f_resumeTag = 5;
  $thiz.Lcats_effect_IOFiber__f_resumeIO = cur;
  if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
    var handle = $p_Lcats_effect_IOFiber__monitor__Lcats_effect_unsafe_WeakBag$Handle($thiz);
    var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
    this$.push(handle);
  }
  var ec = $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_blocking;
  $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, $thiz);
}
function $p_Lcats_effect_IOFiber__done__Lcats_effect_kernel_Outcome__V($thiz, oc) {
  $thiz.Lcats_effect_IOFiber__f__join = ($m_Lcats_effect_IO$(), new $c_Lcats_effect_IO$Pure(oc));
  $thiz.Lcats_effect_IOFiber__f__cancel = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__unit;
  $thiz.Lcats_effect_IOFiber__f_outcome = oc;
  var stack = $thiz.Lcats_effect_IOFiber__f_callbacks;
  if (((!$uZ(stack.reduceRight($m_sjs_js_Any$().fromFunction2__F2__sjs_js_Function2(new $c_sjsr_AnonFunction2(((acc, cb) => {
    var acc$1 = $uZ(acc);
    var cb$1 = $as_F1(cb);
    return ((cb$1 !== null) ? ($n(cb$1).apply__O__O(oc), true) : acc$1);
  }))), false))) && $n($n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_config).Lcats_effect_unsafe_IORuntimeConfig__f_reportUnhandledFiberErrors)) {
    if ((oc instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
      var x$1 = $as_Lcats_effect_kernel_Outcome$Errored(oc);
      var this$7 = $n(x$1);
      var x42 = $as_jl_Throwable(this$7.Lcats_effect_kernel_Outcome$Errored__f_e);
      $n($thiz.Lcats_effect_IOFiber__f_currentCtx).reportFailure__jl_Throwable__V(x42);
    }
  }
  $thiz.Lcats_effect_IOFiber__f_masks = 0;
  $thiz.Lcats_effect_IOFiber__f_resumeTag = 8;
  $thiz.Lcats_effect_IOFiber__f_resumeIO = null;
  $thiz.ju_concurrent_atomic_AtomicBoolean__f_value = false;
  $thiz.Lcats_effect_IOFiber__f_conts = null;
  var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
  this$.length = 0;
  var this$$1 = $thiz.Lcats_effect_IOFiber__f_finalizers;
  this$$1.length = 0;
  $thiz.Lcats_effect_IOFiber__f_currentCtx = null;
  if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
    $n($thiz.Lcats_effect_IOFiber__f_tracingEvents).invalidate__V();
  }
}
function $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, cb) {
  var this$ = $thiz.Lcats_effect_IOFiber__f_finalizers;
  if ((!($uI(this$.length) === 0))) {
    if ((!$thiz.Lcats_effect_IOFiber__f_finalizing)) {
      $thiz.Lcats_effect_IOFiber__f_finalizing = true;
      $thiz.Lcats_effect_IOFiber__f_conts = [0];
      var stack = $thiz.Lcats_effect_IOFiber__f_conts;
      var c = $uI(stack[0]);
      var use = ((((1 + (((1 + c) | 0) >> 3)) | 0) < $uI(stack.length)) ? stack : (stack.push(0), stack));
      var s = ((1 + (c >> 3)) | 0);
      var shift = ((7 & c) << 2);
      use[s] = (($uI(use[s]) & (~((-1) << shift))) | (2 << shift));
      use[0] = ((1 + $uI(use[0])) | 0);
      $thiz.Lcats_effect_IOFiber__f_conts = use;
      var this$$2 = $thiz.Lcats_effect_IOFiber__f_objectState;
      this$$2.push(cb);
      $thiz.Lcats_effect_IOFiber__f_masks = ((1 + $thiz.Lcats_effect_IOFiber__f_masks) | 0);
    }
    var this$$3 = $thiz.Lcats_effect_IOFiber__f_finalizers;
    return $as_Lcats_effect_IO(this$$3.pop());
  } else {
    if ((cb !== null)) {
      $n(cb).apply__O__O($m_Lcats_effect_IOFiber$().Lcats_effect_IOFiber$__f_RightUnit);
    }
    $p_Lcats_effect_IOFiber__done__Lcats_effect_kernel_Outcome__V($thiz, $m_Lcats_effect_IOFiber$().Lcats_effect_IOFiber$__f_OutcomeCanceled);
    return $m_Lcats_effect_IO$EndFiber$();
  }
}
function $p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz) {
  return ($thiz.Lcats_effect_IOFiber__f_canceled && $p_Lcats_effect_IOFiber__isUnmasked__Z($thiz));
}
function $p_Lcats_effect_IOFiber__isUnmasked__Z($thiz) {
  return ($thiz.Lcats_effect_IOFiber__f_masks === 0);
}
function $p_Lcats_effect_IOFiber__monitor__Lcats_effect_unsafe_WeakBag$Handle($thiz) {
  return $n($n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_fiberMonitor).monitorSuspended__Lcats_effect_IOFiber__Lcats_effect_unsafe_WeakBag$Handle($thiz);
}
function $p_Lcats_effect_IOFiber__setCallback__F1__V($thiz, cb) {
  var stack = $thiz.Lcats_effect_IOFiber__f_callbacks;
  stack[(((-1) + $uI(stack.length)) | 0)] = cb;
}
function $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, result, depth) {
  var depth$tailLocal1 = depth;
  var result$tailLocal1 = result;
  while (true) {
    var stack = $thiz.Lcats_effect_IOFiber__f_conts;
    var c = (((-1) + $uI(stack[0])) | 0);
    if ((c < 0)) {
      throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
    }
    var op = (((15 & (($uI(stack[((1 + (c >> 3)) | 0)]) >>> ((7 & c) << 2)) | 0)) << 24) >> 24);
    stack[0] = (((-1) + $uI(stack[0])) | 0);
    switch (op) {
      case 0: {
        var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
        var f = $as_F1(this$.pop());
        var error = null;
        try {
          var transformed = $n(f).apply__O__O(result$tailLocal1);
        } catch (e) {
          var e$1 = e;
          var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
          if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
            error = e$2;
            var transformed = (void 0);
          } else {
            var transformed = $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__N(e$2);
          }
        }
        if ((depth$tailLocal1 > 512)) {
          if ((error === null)) {
            var $x_1 = new $c_Lcats_effect_IO$Pure(transformed);
          } else {
            var t = error;
            var $x_1 = new $c_Lcats_effect_IO$Error(t);
          }
          return $as_Lcats_effect_IO($x_1);
        } else if ((error === null)) {
          var depth$tailLocal1$tmp1 = ((1 + depth$tailLocal1) | 0);
          result$tailLocal1 = transformed;
          depth$tailLocal1 = depth$tailLocal1$tmp1;
        } else {
          return $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, error, ((1 + depth$tailLocal1) | 0));
        }
        break;
      }
      case 1: {
        var this$$1 = $thiz.Lcats_effect_IOFiber__f_objectState;
        var f$2 = $as_F1(this$$1.pop());
        try {
          return $as_Lcats_effect_IO($n(f$2).apply__O__O(result$tailLocal1));
        } catch (e$3) {
          var e$4 = e$3;
          var e$4$1 = ((e$4 instanceof $c_jl_Throwable) ? e$4 : new $c_sjs_js_JavaScriptException(e$4));
          return ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$4$1) ? $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, e$4$1, ((1 + depth$tailLocal1) | 0)) : $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__N(e$4$1));
        }
        break;
      }
      case 2: {
        return $p_Lcats_effect_IOFiber__cancelationLoopSuccessK__Lcats_effect_IO($thiz);
        break;
      }
      case 3: {
        return $p_Lcats_effect_IOFiber__runTerminusSuccessK__O__Lcats_effect_IO($thiz, result$tailLocal1);
        break;
      }
      case 4: {
        return $p_Lcats_effect_IOFiber__evalOnSuccessK__O__Lcats_effect_IO($thiz, result$tailLocal1);
        break;
      }
      case 5: {
        var this$$2 = $thiz.Lcats_effect_IOFiber__f_objectState;
        this$$2.pop();
        break;
      }
      case 6: {
        var this$$3 = $thiz.Lcats_effect_IOFiber__f_finalizers;
        this$$3.pop();
        depth$tailLocal1 = ((1 + depth$tailLocal1) | 0);
        break;
      }
      case 7: {
        $thiz.Lcats_effect_IOFiber__f_masks = (((-1) + $thiz.Lcats_effect_IOFiber__f_masks) | 0);
        depth$tailLocal1 = ((1 + depth$tailLocal1) | 0);
        break;
      }
      case 8: {
        $thiz.Lcats_effect_IOFiber__f_masks = ((1 + $thiz.Lcats_effect_IOFiber__f_masks) | 0);
        depth$tailLocal1 = ((1 + depth$tailLocal1) | 0);
        break;
      }
      case 9: {
        var value = result$tailLocal1;
        result$tailLocal1 = new $c_s_util_Right(value);
        break;
      }
      default: {
        throw new $c_s_MatchError(op);
      }
    }
  }
}
function $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, error, depth) {
  var depth$tailLocal2 = depth;
  var error$tailLocal1 = error;
  while (true) {
    $m_Lcats_effect_tracing_Tracing$().augmentThrowable__Z__jl_Throwable__Lcats_effect_tracing_RingBuffer__V($n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_enhancedExceptions, error$tailLocal1, $thiz.Lcats_effect_IOFiber__f_tracingEvents);
    var stack = $thiz.Lcats_effect_IOFiber__f_conts;
    var c = (((-1) + $uI(stack[0])) | 0);
    if ((c < 0)) {
      throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
    }
    var op = (((15 & (($uI(stack[((1 + (c >> 3)) | 0)]) >>> ((7 & c) << 2)) | 0)) << 24) >> 24);
    stack[0] = (((-1) + $uI(stack[0])) | 0);
    switch (op) {
      case 0:
      case 1: {
        var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
        this$.pop();
        break;
      }
      case 2: {
        return $p_Lcats_effect_IOFiber__cancelationLoopFailureK__jl_Throwable__Lcats_effect_IO($thiz, error$tailLocal1);
        break;
      }
      case 3: {
        return $p_Lcats_effect_IOFiber__runTerminusFailureK__jl_Throwable__Lcats_effect_IO($thiz, error$tailLocal1);
        break;
      }
      case 4: {
        return $p_Lcats_effect_IOFiber__evalOnFailureK__jl_Throwable__Lcats_effect_IO($thiz, error$tailLocal1);
        break;
      }
      case 5: {
        var this$$1 = $thiz.Lcats_effect_IOFiber__f_objectState;
        var f = $as_F1(this$$1.pop());
        try {
          return $as_Lcats_effect_IO($n(f).apply__O__O(error$tailLocal1));
        } catch (e) {
          var e$1 = e;
          var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
          if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
            var depth$tailLocal2$tmp1 = ((1 + depth$tailLocal2) | 0);
            error$tailLocal1 = e$2;
            depth$tailLocal2 = depth$tailLocal2$tmp1;
          } else {
            return $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__N(e$2);
          }
        }
        break;
      }
      case 6: {
        var this$$2 = $thiz.Lcats_effect_IOFiber__f_finalizers;
        this$$2.pop();
        depth$tailLocal2 = ((1 + depth$tailLocal2) | 0);
        break;
      }
      case 7: {
        $thiz.Lcats_effect_IOFiber__f_masks = (((-1) + $thiz.Lcats_effect_IOFiber__f_masks) | 0);
        depth$tailLocal2 = ((1 + depth$tailLocal2) | 0);
        break;
      }
      case 8: {
        $thiz.Lcats_effect_IOFiber__f_masks = ((1 + $thiz.Lcats_effect_IOFiber__f_masks) | 0);
        depth$tailLocal2 = ((1 + depth$tailLocal2) | 0);
        break;
      }
      case 9: {
        var value = error$tailLocal1;
        return $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $c_s_util_Left(value), depth$tailLocal2);
        break;
      }
      default: {
        throw new $c_s_MatchError(op);
      }
    }
  }
}
function $p_Lcats_effect_IOFiber__scheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, fiber) {
  if ((ec instanceof $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor)) {
    var bmte = $as_Lcats_effect_unsafe_BatchingMacrotaskExecutor(ec);
    $n(bmte).schedule__Lcats_effect_IOFiber__V(fiber);
  } else {
    $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, fiber);
  }
}
function $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, fiber) {
  try {
    $n(ec).execute__jl_Runnable__V(fiber);
  } catch (e) {
    if ((!false)) {
      throw e;
    }
  }
}
function $p_Lcats_effect_IOFiber__execR__V($thiz) {
  if ($thiz.Lcats_effect_IOFiber__f_canceled) {
    $p_Lcats_effect_IOFiber__done__Lcats_effect_kernel_Outcome__V($thiz, $m_Lcats_effect_IOFiber$().Lcats_effect_IOFiber$__f_OutcomeCanceled);
  } else {
    $thiz.Lcats_effect_IOFiber__f_conts = [0];
    var stack = $thiz.Lcats_effect_IOFiber__f_conts;
    var c = $uI(stack[0]);
    var use = ((((1 + (((1 + c) | 0) >> 3)) | 0) < $uI(stack.length)) ? stack : (stack.push(0), stack));
    var s = ((1 + (c >> 3)) | 0);
    var shift = ((7 & c) << 2);
    use[s] = (($uI(use[s]) & (~((-1) << shift))) | (3 << shift));
    use[0] = ((1 + $uI(use[0])) | 0);
    $thiz.Lcats_effect_IOFiber__f_conts = use;
    var io = $thiz.Lcats_effect_IOFiber__f_resumeIO;
    $thiz.Lcats_effect_IOFiber__f_resumeIO = null;
    $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, io, $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold);
  }
}
function $p_Lcats_effect_IOFiber__asyncContinueSuccessfulR__V($thiz) {
  var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
  var a = this$.pop();
  $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, a, 0), $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold);
}
function $p_Lcats_effect_IOFiber__asyncContinueFailedR__V($thiz) {
  var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
  var t = $as_jl_Throwable(this$.pop());
  $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, t, 0), $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold);
}
function $p_Lcats_effect_IOFiber__asyncContinueCanceledR__V($thiz) {
  var fin = $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, null);
  $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, fin, $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold);
}
function $p_Lcats_effect_IOFiber__asyncContinueCanceledWithFinalizerR__V($thiz) {
  var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
  var cb = $as_F1(this$.pop());
  var fin = $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, cb);
  $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, fin, $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold);
}
function $p_Lcats_effect_IOFiber__blockingR__V($thiz) {
  var error = null;
  var cur = $as_Lcats_effect_IO$Blocking($thiz.Lcats_effect_IOFiber__f_resumeIO);
  $thiz.Lcats_effect_IOFiber__f_resumeIO = null;
  try {
    var r = $n($n(cur).thunk__F0()).apply__O();
  } catch (e) {
    var e$1 = e;
    var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      error = e$2;
      var r = (void 0);
    } else {
      var r = $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__N(e$2);
    }
  }
  if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
    var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
    $n($as_Lcats_effect_unsafe_WeakBag$Handle(this$.pop())).deregister__V();
  }
  if ((error === null)) {
    $thiz.Lcats_effect_IOFiber__f_resumeTag = 1;
    var this$$1 = $thiz.Lcats_effect_IOFiber__f_objectState;
    this$$1.push(r);
  } else {
    $thiz.Lcats_effect_IOFiber__f_resumeTag = 2;
    var this$$2 = $thiz.Lcats_effect_IOFiber__f_objectState;
    var a = error;
    this$$2.push(a);
  }
  var ec = $thiz.Lcats_effect_IOFiber__f_currentCtx;
  $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, $thiz);
}
function $p_Lcats_effect_IOFiber__cedeR__V($thiz) {
  $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, (void 0), 0), $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold);
}
function $p_Lcats_effect_IOFiber__autoCedeR__V($thiz) {
  var io = $thiz.Lcats_effect_IOFiber__f_resumeIO;
  $thiz.Lcats_effect_IOFiber__f_resumeIO = null;
  $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, io, $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold);
}
function $p_Lcats_effect_IOFiber__cancelationLoopSuccessK__Lcats_effect_IO($thiz) {
  var this$ = $thiz.Lcats_effect_IOFiber__f_finalizers;
  if ((!($uI(this$.length) === 0))) {
    var stack = $thiz.Lcats_effect_IOFiber__f_conts;
    var c = $uI(stack[0]);
    var use = ((((1 + (((1 + c) | 0) >> 3)) | 0) < $uI(stack.length)) ? stack : (stack.push(0), stack));
    var s = ((1 + (c >> 3)) | 0);
    var shift = ((7 & c) << 2);
    use[s] = (($uI(use[s]) & (~((-1) << shift))) | (2 << shift));
    use[0] = ((1 + $uI(use[0])) | 0);
    $thiz.Lcats_effect_IOFiber__f_conts = use;
    var this$$1 = $thiz.Lcats_effect_IOFiber__f_finalizers;
    return $as_Lcats_effect_IO(this$$1.pop());
  } else {
    var this$$2 = $thiz.Lcats_effect_IOFiber__f_objectState;
    var cb = this$$2.pop();
    if ((cb !== null)) {
      $n($as_F1(cb)).apply__O__O($m_Lcats_effect_IOFiber$().Lcats_effect_IOFiber$__f_RightUnit);
    }
    $p_Lcats_effect_IOFiber__done__Lcats_effect_kernel_Outcome__V($thiz, $m_Lcats_effect_IOFiber$().Lcats_effect_IOFiber$__f_OutcomeCanceled);
    return $m_Lcats_effect_IO$EndFiber$();
  }
}
function $p_Lcats_effect_IOFiber__cancelationLoopFailureK__jl_Throwable__Lcats_effect_IO($thiz, t) {
  $n($thiz.Lcats_effect_IOFiber__f_currentCtx).reportFailure__jl_Throwable__V(t);
  return $p_Lcats_effect_IOFiber__cancelationLoopSuccessK__Lcats_effect_IO($thiz);
}
function $p_Lcats_effect_IOFiber__runTerminusSuccessK__O__Lcats_effect_IO($thiz, result) {
  $m_Lcats_effect_IO$();
  var fa = new $c_Lcats_effect_IO$Pure(result);
  $p_Lcats_effect_IOFiber__done__Lcats_effect_kernel_Outcome__V($thiz, new $c_Lcats_effect_kernel_Outcome$Succeeded(fa));
  return $m_Lcats_effect_IO$EndFiber$();
}
function $p_Lcats_effect_IOFiber__runTerminusFailureK__jl_Throwable__Lcats_effect_IO($thiz, t) {
  $p_Lcats_effect_IOFiber__done__Lcats_effect_kernel_Outcome__V($thiz, new $c_Lcats_effect_kernel_Outcome$Errored(t));
  return $m_Lcats_effect_IO$EndFiber$();
}
function $p_Lcats_effect_IOFiber__evalOnSuccessK__O__Lcats_effect_IO($thiz, result) {
  if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
    var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
    $n($as_Lcats_effect_unsafe_WeakBag$Handle(this$.pop())).deregister__V();
  }
  var this$$1 = $thiz.Lcats_effect_IOFiber__f_objectState;
  var ec = $as_s_concurrent_ExecutionContext(this$$1.pop());
  $thiz.Lcats_effect_IOFiber__f_currentCtx = ec;
  if ((!$p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz))) {
    $thiz.Lcats_effect_IOFiber__f_resumeTag = 1;
    var this$$2 = $thiz.Lcats_effect_IOFiber__f_objectState;
    this$$2.push(result);
    $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, $thiz);
    return $m_Lcats_effect_IO$EndFiber$();
  } else {
    return $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, null);
  }
}
function $p_Lcats_effect_IOFiber__evalOnFailureK__jl_Throwable__Lcats_effect_IO($thiz, t) {
  if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
    var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
    $n($as_Lcats_effect_unsafe_WeakBag$Handle(this$.pop())).deregister__V();
  }
  var this$$1 = $thiz.Lcats_effect_IOFiber__f_objectState;
  var ec = $as_s_concurrent_ExecutionContext(this$$1.pop());
  $thiz.Lcats_effect_IOFiber__f_currentCtx = ec;
  if ((!$p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz))) {
    $thiz.Lcats_effect_IOFiber__f_resumeTag = 2;
    var this$$2 = $thiz.Lcats_effect_IOFiber__f_objectState;
    this$$2.push(t);
    $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, $thiz);
    return $m_Lcats_effect_IO$EndFiber$();
  } else {
    return $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, null);
  }
}
function $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, te) {
  if ((te !== null)) {
    $n($thiz.Lcats_effect_IOFiber__f_tracingEvents).push__Lcats_effect_tracing_TracingEvent__V(te);
  }
}
function $p_Lcats_effect_IOFiber__next$1__F1__O__Lcats_effect_IO($thiz, f$1, v) {
  var error = null;
  try {
    var result = $n(f$1).apply__O__O(v);
  } catch (e) {
    var e$1 = e;
    var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      error = e$2;
      var result = (void 0);
    } else {
      var result = $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__N(e$2);
    }
  }
  return ((error === null) ? $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, result, 0) : $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, error, 0));
}
function $p_Lcats_effect_IOFiber__next$2__F1__O__Lcats_effect_IO($thiz, f$2, v) {
  try {
    return $as_Lcats_effect_IO($n(f$2).apply__O__O(v));
  } catch (e) {
    var e$1 = e;
    var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
    return ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2) ? $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, e$2, 0) : $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__N(e$2));
  }
}
function $p_Lcats_effect_IOFiber__loop$1__Lcats_effect_ContState__s_util_Either__V($thiz, state$2, result$1) {
  while (true) {
    if ($thiz.getAndSet__Z__Z(false)) {
      if (($thiz.Lcats_effect_IOFiber__f_finalizing === $n(state$2).Lcats_effect_ContState__f_wasFinalizing)) {
        if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
          $n($n(state$2).Lcats_effect_ContState__f_handle).deregister__V();
        }
        var ec = $thiz.Lcats_effect_IOFiber__f_currentCtx;
        if ((!$p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz))) {
          matchResult12: {
            if ((result$1 instanceof $c_s_util_Left)) {
              var t = $as_jl_Throwable($n($as_s_util_Left(result$1)).s_util_Left__f_value);
              $thiz.Lcats_effect_IOFiber__f_resumeTag = 2;
              var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
              this$.push(t);
              break matchResult12;
            }
            if ((result$1 instanceof $c_s_util_Right)) {
              var a = $n($as_s_util_Right(result$1)).s_util_Right__f_value;
              $thiz.Lcats_effect_IOFiber__f_resumeTag = 1;
              var this$$1 = $thiz.Lcats_effect_IOFiber__f_objectState;
              this$$1.push(a);
              break matchResult12;
            }
            throw new $c_s_MatchError(result$1);
          }
        } else {
          $thiz.Lcats_effect_IOFiber__f_resumeTag = 3;
        }
        $p_Lcats_effect_IOFiber__scheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, $thiz);
      } else {
        $thiz.ju_concurrent_atomic_AtomicBoolean__f_value = true;
      }
    } else if (((($thiz.Lcats_effect_IOFiber__f_finalizing === $n(state$2).Lcats_effect_ContState__f_wasFinalizing) && (!$p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz))) && ($thiz.Lcats_effect_IOFiber__f_outcome === null))) {
      continue;
    }
    return (void 0);
  }
}
function $p_Lcats_effect_IOFiber__stateLoop$1__Lcats_effect_ContState__s_util_Either__s_util_Either__V($thiz, state$3, result$2, waiting$1) {
  while (true) {
    var tag = $as_s_util_Either($n(state$3).ju_concurrent_atomic_AtomicReference__f_value);
    if (((tag === null) || (tag === waiting$1))) {
      if ((!$n(state$3).compareAndSet__O__O__Z(tag, result$2))) {
        continue;
      } else if ((tag === waiting$1)) {
        $p_Lcats_effect_IOFiber__loop$1__Lcats_effect_ContState__s_util_Either__V($thiz, state$3, result$2);
      }
    }
    return (void 0);
  }
}
/** @constructor */
function $c_Lcats_effect_IOFiber(initState, cb, startIO, startEC, rt) {
  this.ju_concurrent_atomic_AtomicBoolean__f_value = false;
  this.Lcats_effect_IOFiber__f_localState = null;
  this.Lcats_effect_IOFiber__f_currentCtx = null;
  this.Lcats_effect_IOFiber__f_objectState = null;
  this.Lcats_effect_IOFiber__f_finalizers = null;
  this.Lcats_effect_IOFiber__f_callbacks = null;
  this.Lcats_effect_IOFiber__f_resumeTag = 0;
  this.Lcats_effect_IOFiber__f_resumeIO = null;
  this.Lcats_effect_IOFiber__f_runtime = null;
  this.Lcats_effect_IOFiber__f_tracingEvents = null;
  this.Lcats_effect_IOFiber__f_conts = null;
  this.Lcats_effect_IOFiber__f_canceled = false;
  this.Lcats_effect_IOFiber__f_masks = 0;
  this.Lcats_effect_IOFiber__f_finalizing = false;
  this.Lcats_effect_IOFiber__f_outcome = null;
  this.Lcats_effect_IOFiber__f__cancel = null;
  this.Lcats_effect_IOFiber__f__join = null;
  $ct_ju_concurrent_atomic_AtomicBoolean__Z__(this, false);
  this.Lcats_effect_IOFiber__f_localState = initState;
  this.Lcats_effect_IOFiber__f_currentCtx = startEC;
  this.Lcats_effect_IOFiber__f_objectState = [];
  this.Lcats_effect_IOFiber__f_finalizers = [];
  this.Lcats_effect_IOFiber__f_callbacks = [cb];
  this.Lcats_effect_IOFiber__f_resumeTag = 0;
  this.Lcats_effect_IOFiber__f_resumeIO = startIO;
  this.Lcats_effect_IOFiber__f_runtime = rt;
  if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
    var logSize = $n(this.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_traceBufferLogSize;
    var $x_1 = new $c_Lcats_effect_tracing_RingBuffer(logSize);
  } else {
    var $x_1 = null;
  }
  this.Lcats_effect_IOFiber__f_tracingEvents = $x_1;
  this.Lcats_effect_IOFiber__f_canceled = false;
  this.Lcats_effect_IOFiber__f_masks = 0;
  this.Lcats_effect_IOFiber__f_finalizing = false;
  this.Lcats_effect_IOFiber__f__cancel = $m_Lcats_effect_IO$().uncancelable__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((_$3) => {
    $as_Lcats_effect_kernel_Poll(_$3);
    this.Lcats_effect_IOFiber__f_canceled = true;
    if (this.getAndSet__Z__Z(false)) {
      if ($p_Lcats_effect_IOFiber__isUnmasked__Z(this)) {
        return $m_Lcats_effect_IO$().async___F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((fin) => {
          var fin$1 = $as_F1(fin);
          var ec = this.Lcats_effect_IOFiber__f_currentCtx;
          this.Lcats_effect_IOFiber__f_resumeTag = 4;
          var this$ = this.Lcats_effect_IOFiber__f_objectState;
          this$.push(fin$1);
          $p_Lcats_effect_IOFiber__scheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V(this, ec, this);
        })));
      } else {
        this.ju_concurrent_atomic_AtomicBoolean__f_value = true;
        return $n(this.join__Lcats_effect_IO()).void__Lcats_effect_IO();
      }
    } else {
      return $n(this.join__Lcats_effect_IO()).void__Lcats_effect_IO();
    }
  })));
  this.Lcats_effect_IOFiber__f__join = $m_Lcats_effect_IO$().asyncCheckAttempt__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((cb$2) => {
    var cb$1 = $as_F1(cb$2);
    var this$19 = $m_Lcats_effect_IO$();
    var thunk$1 = new $c_sjsr_AnonFunction0((() => {
      if ((this.Lcats_effect_IOFiber__f_outcome === null)) {
        var stack = this.Lcats_effect_IOFiber__f_callbacks;
        var next = new $c_sjsr_AnonFunction1(((oc) => {
          var oc$1 = $as_Lcats_effect_kernel_Outcome(oc);
          $n(cb$1).apply__O__O(new $c_s_util_Right(oc$1));
        }));
        stack.push(next);
        var handle = (((-1) + $uI(stack.length)) | 0);
        if ((this.Lcats_effect_IOFiber__f_outcome !== null)) {
          var stack$1 = this.Lcats_effect_IOFiber__f_callbacks;
          delete stack$1[handle];
          var value = this.Lcats_effect_IOFiber__f_outcome;
          return new $c_s_util_Right(value);
        } else {
          var this$15 = $m_Lcats_effect_IO$();
          var thunk = new $c_sjsr_AnonFunction0((() => {
            var stack$2 = this.Lcats_effect_IOFiber__f_callbacks;
            delete stack$2[handle];
          }));
          var value$1 = this$15.delay__F0__Lcats_effect_IO(thunk);
          var value$2 = new $c_s_Some(value$1);
          return new $c_s_util_Left(value$2);
        }
      } else {
        var value$3 = this.Lcats_effect_IOFiber__f_outcome;
        return new $c_s_util_Right(value$3);
      }
    }));
    return this$19.delay__F0__Lcats_effect_IO(thunk$1);
  })));
}
$c_Lcats_effect_IOFiber.prototype = new $h_Lcats_effect_IOFiberPlatform();
$c_Lcats_effect_IOFiber.prototype.constructor = $c_Lcats_effect_IOFiber;
/** @constructor */
function $h_Lcats_effect_IOFiber() {
}
$h_Lcats_effect_IOFiber.prototype = $c_Lcats_effect_IOFiber.prototype;
$c_Lcats_effect_IOFiber.prototype.run__V = (function() {
  var x1 = this.Lcats_effect_IOFiber__f_resumeTag;
  switch (x1) {
    case 0: {
      $p_Lcats_effect_IOFiber__execR__V(this);
      return (void 0);
      break;
    }
    case 1: {
      $p_Lcats_effect_IOFiber__asyncContinueSuccessfulR__V(this);
      return (void 0);
      break;
    }
    case 2: {
      $p_Lcats_effect_IOFiber__asyncContinueFailedR__V(this);
      return (void 0);
      break;
    }
    case 3: {
      $p_Lcats_effect_IOFiber__asyncContinueCanceledR__V(this);
      return (void 0);
      break;
    }
    case 4: {
      $p_Lcats_effect_IOFiber__asyncContinueCanceledWithFinalizerR__V(this);
      return (void 0);
      break;
    }
    case 5: {
      $p_Lcats_effect_IOFiber__blockingR__V(this);
      return (void 0);
      break;
    }
    case 6: {
      $p_Lcats_effect_IOFiber__cedeR__V(this);
      return (void 0);
      break;
    }
    case 7: {
      $p_Lcats_effect_IOFiber__autoCedeR__V(this);
      return (void 0);
      break;
    }
    case 8: {
      return (void 0);
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
});
$c_Lcats_effect_IOFiber.prototype.cancel__Lcats_effect_IO = (function() {
  return this.Lcats_effect_IOFiber__f__cancel;
});
$c_Lcats_effect_IOFiber.prototype.join__Lcats_effect_IO = (function() {
  return this.Lcats_effect_IOFiber__f__join;
});
$c_Lcats_effect_IOFiber.prototype.toString__T = (function() {
  var state = (this.ju_concurrent_atomic_AtomicBoolean__f_value ? "SUSPENDED" : (this.isDone__Z() ? "COMPLETED" : "RUNNING"));
  var tracingEvents = this.Lcats_effect_IOFiber__f_tracingEvents;
  var this$1 = $n($n($m_Lcats_effect_tracing_Tracing$().getFrames__Lcats_effect_tracing_RingBuffer__sci_List(tracingEvents)).headOption__s_Option());
  if (this$1.isEmpty__Z()) {
    var $x_1 = $m_s_None$();
  } else {
    var arg1 = this$1.get__O();
    var frame = $as_jl_StackTraceElement(arg1);
    var $x_1 = new $c_s_Some((": " + frame));
  }
  var this$2 = $n($x_1);
  var opAndCallSite = $as_T((this$2.isEmpty__Z() ? "" : this$2.get__O()));
  var x = $systemIdentityHashCode(this);
  return (((("cats.effect.IOFiber@" + $as_T($uD((x >>> 0.0)).toString(16))) + " ") + state) + opAndCallSite);
});
$c_Lcats_effect_IOFiber.prototype.isDone__Z = (function() {
  return (this.Lcats_effect_IOFiber__f_outcome !== null);
});
$c_Lcats_effect_IOFiber.prototype.captureTrace__Lcats_effect_Trace = (function() {
  return ((this.Lcats_effect_IOFiber__f_tracingEvents !== null) ? $m_Lcats_effect_Trace$().apply__Lcats_effect_tracing_RingBuffer__Lcats_effect_Trace(this.Lcats_effect_IOFiber__f_tracingEvents) : $m_Lcats_effect_Trace$().apply__Lcats_effect_tracing_RingBuffer__Lcats_effect_Trace(new $c_Lcats_effect_tracing_RingBuffer(1)));
});
$c_Lcats_effect_IOFiber.prototype.cancel__O = (function() {
  return this.cancel__Lcats_effect_IO();
});
$c_Lcats_effect_IOFiber.prototype.join__O = (function() {
  return this.join__Lcats_effect_IO();
});
function $as_Lcats_effect_IOFiber(obj) {
  return (((obj instanceof $c_Lcats_effect_IOFiber) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IOFiber"));
}
function $isArrayOf_Lcats_effect_IOFiber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IOFiber)));
}
function $asArrayOf_Lcats_effect_IOFiber(obj, depth) {
  return (($isArrayOf_Lcats_effect_IOFiber(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IOFiber;", depth));
}
var $d_Lcats_effect_IOFiber = new $TypeData().initClass($c_Lcats_effect_IOFiber, "cats.effect.IOFiber", ({
  Lcats_effect_IOFiber: 1,
  Lcats_effect_IOFiberPlatform: 1,
  ju_concurrent_atomic_AtomicBoolean: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Fiber: 1,
  jl_Runnable: 1
}));
class $c_Lcats_effect_std_FailureSignal$ extends $c_jl_RuntimeException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  fillInStackTrace__jl_Throwable() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this);
  }
}
var $d_Lcats_effect_std_FailureSignal$ = new $TypeData().initClass($c_Lcats_effect_std_FailureSignal$, "cats.effect.std.FailureSignal$", ({
  Lcats_effect_std_FailureSignal$: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_util_control_NoStackTrace: 1
}));
var $n_Lcats_effect_std_FailureSignal$;
function $m_Lcats_effect_std_FailureSignal$() {
  if ((!$n_Lcats_effect_std_FailureSignal$)) {
    $n_Lcats_effect_std_FailureSignal$ = new $c_Lcats_effect_std_FailureSignal$();
  }
  return $n_Lcats_effect_std_FailureSignal$;
}
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$1() {
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$1() {
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_kernel_Semigroup(fa);
  var fb$1 = $as_Lcats_kernel_Semigroup(fb);
  return new $c_Lcats_instances_InvariantMonoidalInstances$$anon$2(fa$1, fb$1, this);
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_Lcats_kernel_Semigroup(fa);
  return new $c_Lcats_instances_InvariantMonoidalInstances$$anon$3(f, fa$1, g, this);
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_InvariantMonoidalInstances$$anon$1, "cats.instances.InvariantMonoidalInstances$$anon$1", ({
  Lcats_instances_InvariantMonoidalInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1
}));
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$4() {
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$4;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$4() {
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_kernel_CommutativeSemigroup(fa);
  var fb$1 = $as_Lcats_kernel_CommutativeSemigroup(fb);
  return new $c_Lcats_instances_InvariantMonoidalInstances$$anon$5(fa$1, fb$1, this);
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_Lcats_kernel_CommutativeSemigroup(fa);
  return new $c_Lcats_instances_InvariantMonoidalInstances$$anon$6(f, fa$1, g, this);
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$4 = new $TypeData().initClass($c_Lcats_instances_InvariantMonoidalInstances$$anon$4, "cats.instances.InvariantMonoidalInstances$$anon$4", ({
  Lcats_instances_InvariantMonoidalInstances$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1
}));
function $f_Lcats_instances_NTupleMonadInstances__catsStdInstancesForTuple2__Lcats_Comonad($thiz) {
  var cofMap = new $c_sjsr_AnonFunction2(((fa, f) => {
    var fa$1 = $as_T2(fa);
    var f$1 = $as_F1(f);
    var _2$1 = $n(f$1).apply__O__O(fa$1);
    var _1$1 = $n(fa$1).copy$default$1__O();
    $n(fa$1);
    return new $c_T2(_1$1, _2$1);
  }));
  return new $c_Lcats_instances_NTupleMonadInstances$$anon$1(cofMap);
}
/** @constructor */
function $c_Lcats_instances_NTupleMonadInstances$$anon$1(cofMap$2) {
  this.Lcats_instances_NTupleMonadInstances$$anon$1__f_cofMap$1 = null;
  this.Lcats_instances_NTupleMonadInstances$$anon$1__f_cofMap$1 = cofMap$2;
}
$c_Lcats_instances_NTupleMonadInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_NTupleMonadInstances$$anon$1.prototype.constructor = $c_Lcats_instances_NTupleMonadInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_NTupleMonadInstances$$anon$1() {
}
$h_Lcats_instances_NTupleMonadInstances$$anon$1.prototype = $c_Lcats_instances_NTupleMonadInstances$$anon$1.prototype;
$c_Lcats_instances_NTupleMonadInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return this.map__s_Product__F1__s_Product($as_s_Product(fa), f);
});
$c_Lcats_instances_NTupleMonadInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_instances_NTupleMonadInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_NTupleMonadInstances$$anon$1.prototype.coflatMap__s_Product__F1__s_Product = (function(fa, f) {
  return $as_s_Product($n(this.Lcats_instances_NTupleMonadInstances$$anon$1__f_cofMap$1).apply__O__O__O(fa, f));
});
$c_Lcats_instances_NTupleMonadInstances$$anon$1.prototype.extract__s_Product__O = (function(fa) {
  return $n(fa).productElement__I__O((((-1) + $n(fa).productArity__I()) | 0));
});
$c_Lcats_instances_NTupleMonadInstances$$anon$1.prototype.map__s_Product__F1__s_Product = (function(fa, f) {
  return this.coflatMap__s_Product__F1__s_Product(fa, new $c_sjsr_AnonFunction1(((fa$2) => {
    var fa$1 = $as_s_Product(fa$2);
    return $n(f).apply__O__O(this.extract__s_Product__O(fa$1));
  })));
});
$c_Lcats_instances_NTupleMonadInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  return this.map__s_Product__F1__s_Product($as_s_Product(fa), f);
});
var $d_Lcats_instances_NTupleMonadInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_NTupleMonadInstances$$anon$1, "cats.instances.NTupleMonadInstances$$anon$1", ({
  Lcats_instances_NTupleMonadInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_CoflatMap: 1,
  Lcats_Comonad: 1
}));
/** @constructor */
function $c_Lcats_instances_OrderingInstances$$anon$2(fa$4, fb$2) {
  this.Lcats_instances_OrderingInstances$$anon$2__f_fa$1 = null;
  this.Lcats_instances_OrderingInstances$$anon$2__f_fb$1 = null;
  this.Lcats_instances_OrderingInstances$$anon$2__f_fa$1 = fa$4;
  this.Lcats_instances_OrderingInstances$$anon$2__f_fb$1 = fb$2;
}
$c_Lcats_instances_OrderingInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.constructor = $c_Lcats_instances_OrderingInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_OrderingInstances$$anon$2() {
}
$h_Lcats_instances_OrderingInstances$$anon$2.prototype = $c_Lcats_instances_OrderingInstances$$anon$2.prototype;
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.compare__T2__T2__I = (function(x, y) {
  var z = $n(this.Lcats_instances_OrderingInstances$$anon$2__f_fa$1).compare__O__O__I($n(x)._1__O(), $n(y)._1__O());
  return ((z === 0) ? $n(this.Lcats_instances_OrderingInstances$$anon$2__f_fb$1).compare__O__O__I($n(x)._2__O(), $n(y)._2__O()) : z);
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__T2__T2__I($as_T2(x), $as_T2(y));
});
var $d_Lcats_instances_OrderingInstances$$anon$2 = new $TypeData().initClass($c_Lcats_instances_OrderingInstances$$anon$2, "cats.instances.OrderingInstances$$anon$2", ({
  Lcats_instances_OrderingInstances$$anon$2: 1,
  ju_Comparator: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1,
  s_math_PartialOrdering: 1,
  s_math_Ordering: 1
}));
/** @constructor */
function $c_Lcats_instances_SortedSetInstances$$anon$1() {
}
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.constructor = $c_Lcats_instances_SortedSetInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_SortedSetInstances$$anon$1() {
}
$h_Lcats_instances_SortedSetInstances$$anon$1.prototype = $c_Lcats_instances_SortedSetInstances$$anon$1.prototype;
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.reduceLeftToOption__O__F1__F2__s_Option = (function(fa, f, g) {
  return $f_Lcats_Foldable__reduceLeftToOption__O__F1__F2__s_Option(this, fa, f, g);
});
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.maximumOption__O__Lcats_kernel_Order__s_Option = (function(fa, A) {
  return $f_Lcats_Foldable__maximumOption__O__Lcats_kernel_Order__s_Option(this, fa, A);
});
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O(this, fa, z, f, G);
});
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverse___O__F1__Lcats_Applicative__O(this, fa, f, G);
});
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return this.foldMap__sci_SortedSet__F1__Lcats_kernel_Monoid__O($as_sci_SortedSet(fa), f, evidence$1);
});
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.foldMap__sci_SortedSet__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var $x_1 = $n(B);
  var this$1 = $n($n(fa).iterator__sc_Iterator());
  return $n($x_1).combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$1, f));
});
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  var fa$1 = $as_sci_SortedSet(fa);
  var this$1 = $n(fa$1);
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this$1, b, f);
});
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  var fa$1 = $as_sci_SortedSet(fa);
  return $m_Lcats_Foldable$().iterateRight__sc_Iterable__Lcats_Eval__F2__Lcats_Eval(fa$1, lb, f);
});
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.size__O__J = (function(fa) {
  var fa$1 = $as_sci_SortedSet(fa);
  var value = $n(fa$1).size__I();
  var hi = (value >> 31);
  return new $c_RTLong(value, hi);
});
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.fold__O__Lcats_kernel_Monoid__O = (function(fa, A) {
  var fa$1 = $as_sci_SortedSet(fa);
  return $n(A).combineAll__sc_IterableOnce__O(fa$1);
});
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.toList__O__sci_List = (function(fa) {
  var fa$1 = $as_sci_SortedSet(fa);
  var this$1 = $n(fa$1);
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$1);
});
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.toIterable__O__sc_Iterable = (function(fa) {
  var fa$1 = $as_sci_SortedSet(fa);
  return fa$1;
});
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.reduceLeftOption__O__F2__s_Option = (function(fa, f) {
  var fa$1 = $as_sci_SortedSet(fa);
  var this$1 = $n(fa$1);
  return $f_sc_IterableOnceOps__reduceLeftOption__F2__s_Option(this$1, f);
});
var $d_Lcats_instances_SortedSetInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_SortedSetInstances$$anon$1, "cats.instances.SortedSetInstances$$anon$1", ({
  Lcats_instances_SortedSetInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_SemigroupK: 1
}));
/** @constructor */
function $c_Lcats_instances_package$list$() {
  this.Lcats_instances_package$list$__f_catsStdInstancesForList = null;
  $n_Lcats_instances_package$list$ = this;
  this.Lcats_instances_package$list$__f_catsStdInstancesForList = new $c_Lcats_instances_ListInstances$$anon$1();
  new $c_Lcats_instances_ListInstancesBinCompat0$$anon$6();
}
$c_Lcats_instances_package$list$.prototype = new $h_O();
$c_Lcats_instances_package$list$.prototype.constructor = $c_Lcats_instances_package$list$;
/** @constructor */
function $h_Lcats_instances_package$list$() {
}
$h_Lcats_instances_package$list$.prototype = $c_Lcats_instances_package$list$.prototype;
var $d_Lcats_instances_package$list$ = new $TypeData().initClass($c_Lcats_instances_package$list$, "cats.instances.package$list$", ({
  Lcats_instances_package$list$: 1,
  Lcats_kernel_instances_ListInstances2: 1,
  Lcats_kernel_instances_ListInstances1: 1,
  Lcats_kernel_instances_ListInstances: 1,
  Lcats_instances_ListInstances: 1,
  Lcats_instances_ListInstancesBinCompat0: 1
}));
var $n_Lcats_instances_package$list$;
function $m_Lcats_instances_package$list$() {
  if ((!$n_Lcats_instances_package$list$)) {
    $n_Lcats_instances_package$list$ = new $c_Lcats_instances_package$list$();
  }
  return $n_Lcats_instances_package$list$;
}
/** @constructor */
function $c_Lcats_instances_package$stream$() {
  this.Lcats_instances_package$stream$__f_catsStdInstancesForStream = null;
  $n_Lcats_instances_package$stream$ = this;
  this.Lcats_instances_package$stream$__f_catsStdInstancesForStream = new $c_Lcats_instances_StreamInstances$$anon$1();
  new $c_Lcats_instances_StreamInstancesBinCompat0$$anon$7();
}
$c_Lcats_instances_package$stream$.prototype = new $h_O();
$c_Lcats_instances_package$stream$.prototype.constructor = $c_Lcats_instances_package$stream$;
/** @constructor */
function $h_Lcats_instances_package$stream$() {
}
$h_Lcats_instances_package$stream$.prototype = $c_Lcats_instances_package$stream$.prototype;
var $d_Lcats_instances_package$stream$ = new $TypeData().initClass($c_Lcats_instances_package$stream$, "cats.instances.package$stream$", ({
  Lcats_instances_package$stream$: 1,
  Lcats_kernel_instances_StreamInstances2: 1,
  Lcats_kernel_instances_StreamInstances1: 1,
  Lcats_kernel_instances_StreamInstances: 1,
  Lcats_instances_StreamInstances: 1,
  Lcats_instances_StreamInstancesBinCompat0: 1
}));
var $n_Lcats_instances_package$stream$;
function $m_Lcats_instances_package$stream$() {
  if ((!$n_Lcats_instances_package$stream$)) {
    $n_Lcats_instances_package$stream$ = new $c_Lcats_instances_package$stream$();
  }
  return $n_Lcats_instances_package$stream$;
}
/** @constructor */
function $c_Lcats_instances_package$vector$() {
  this.Lcats_instances_package$vector$__f_catsStdInstancesForVector = null;
  $n_Lcats_instances_package$vector$ = this;
  this.Lcats_instances_package$vector$__f_catsStdInstancesForVector = new $c_Lcats_instances_VectorInstances$$anon$1();
  new $c_Lcats_instances_VectorInstancesBinCompat0$$anon$6();
}
$c_Lcats_instances_package$vector$.prototype = new $h_O();
$c_Lcats_instances_package$vector$.prototype.constructor = $c_Lcats_instances_package$vector$;
/** @constructor */
function $h_Lcats_instances_package$vector$() {
}
$h_Lcats_instances_package$vector$.prototype = $c_Lcats_instances_package$vector$.prototype;
var $d_Lcats_instances_package$vector$ = new $TypeData().initClass($c_Lcats_instances_package$vector$, "cats.instances.package$vector$", ({
  Lcats_instances_package$vector$: 1,
  Lcats_kernel_instances_VectorInstances2: 1,
  Lcats_kernel_instances_VectorInstances1: 1,
  Lcats_kernel_instances_VectorInstances: 1,
  Lcats_instances_VectorInstances: 1,
  Lcats_instances_VectorInstancesBinCompat0: 1
}));
var $n_Lcats_instances_package$vector$;
function $m_Lcats_instances_package$vector$() {
  if ((!$n_Lcats_instances_package$vector$)) {
    $n_Lcats_instances_package$vector$ = new $c_Lcats_instances_package$vector$();
  }
  return $n_Lcats_instances_package$vector$;
}
/** @constructor */
function $c_Lcats_kernel_Order$$anon$1(outer) {
  this.Lcats_kernel_Order$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_kernel_Order$$anon$1__f_$outer = outer;
}
$c_Lcats_kernel_Order$$anon$1.prototype = new $h_O();
$c_Lcats_kernel_Order$$anon$1.prototype.constructor = $c_Lcats_kernel_Order$$anon$1;
/** @constructor */
function $h_Lcats_kernel_Order$$anon$1() {
}
$h_Lcats_kernel_Order$$anon$1.prototype = $c_Lcats_kernel_Order$$anon$1.prototype;
$c_Lcats_kernel_Order$$anon$1.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Order$$anon$1.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Order$$anon$1.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Order$$anon$1.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Order$$anon$1.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_Lcats_kernel_Order$$anon$1.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_Lcats_kernel_Order$$anon$1.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_Lcats_kernel_Order$$anon$1.prototype.compare__O__O__I = (function(_$1, _$2) {
  var this$1 = $n(this.Lcats_kernel_Order$$anon$1__f_$outer);
  return this$1.compare__O__O__I(_$1, _$2);
});
var $d_Lcats_kernel_Order$$anon$1 = new $TypeData().initClass($c_Lcats_kernel_Order$$anon$1, "cats.kernel.Order$$anon$1", ({
  Lcats_kernel_Order$$anon$1: 1,
  ju_Comparator: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1,
  s_math_PartialOrdering: 1,
  s_math_Ordering: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_BigDecimalOrder() {
}
$c_Lcats_kernel_instances_BigDecimalOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.constructor = $c_Lcats_kernel_instances_BigDecimalOrder;
/** @constructor */
function $h_Lcats_kernel_instances_BigDecimalOrder() {
}
$h_Lcats_kernel_instances_BigDecimalOrder.prototype = $c_Lcats_kernel_instances_BigDecimalOrder.prototype;
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.toOrdering__s_math_Ordering = (function() {
  return new $c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_s_math_BigDecimal(x);
  return $n(x$1).hashCode__I();
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_s_math_BigDecimal(x);
  var y$1 = $as_s_math_BigDecimal(y);
  var this$1 = $n(x$1);
  return $n(this$1.s_math_BigDecimal__f_bigDecimal).compareTo__Ljava_math_BigDecimal__I($n(y$1).s_math_BigDecimal__f_bigDecimal);
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.eqv__O__O__Z = (function(x, y) {
  var x$1 = $as_s_math_BigDecimal(x);
  var y$1 = $as_s_math_BigDecimal(y);
  return $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(x$1, y$1);
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.gt__O__O__Z = (function(x, y) {
  var x$1 = $as_s_math_BigDecimal(x);
  var y$1 = $as_s_math_BigDecimal(y);
  var this$1 = $n(x$1);
  return $f_s_math_Ordered__$greater__O__Z(this$1, y$1);
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.max__O__O__O = (function(x, y) {
  var x$1 = $as_s_math_BigDecimal(x);
  var y$1 = $as_s_math_BigDecimal(y);
  return $n(x$1).max__s_math_BigDecimal__s_math_BigDecimal(y$1);
});
var $d_Lcats_kernel_instances_BigDecimalOrder = new $TypeData().initClass($c_Lcats_kernel_instances_BigDecimalOrder, "cats.kernel.instances.BigDecimalOrder", ({
  Lcats_kernel_instances_BigDecimalOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_DoubleOrder() {
}
$c_Lcats_kernel_instances_DoubleOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_DoubleOrder.prototype.constructor = $c_Lcats_kernel_instances_DoubleOrder;
/** @constructor */
function $h_Lcats_kernel_instances_DoubleOrder() {
}
$h_Lcats_kernel_instances_DoubleOrder.prototype = $c_Lcats_kernel_instances_DoubleOrder.prototype;
$c_Lcats_kernel_instances_DoubleOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.toOrdering__s_math_Ordering = (function() {
  return new $c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.eqv__D__D__Z = (function(x, y) {
  return (x === y);
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.gt__D__D__Z = (function(x, y) {
  return (x > y);
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $uD(x);
  return $m_jl_FloatingPointBits$().numberHashCode__D__I(x$1);
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return $m_jl_Double$().compare__D__D__I(x$1, y$1);
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__D__D__Z($uD(x), $uD(y));
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.gt__O__O__Z = (function(x, y) {
  return this.gt__D__D__Z($uD(x), $uD(y));
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.max__O__O__O = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return $uD(Math.max(x$1, y$1));
});
var $d_Lcats_kernel_instances_DoubleOrder = new $TypeData().initClass($c_Lcats_kernel_instances_DoubleOrder, "cats.kernel.instances.DoubleOrder", ({
  Lcats_kernel_instances_DoubleOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_FloatOrder() {
}
$c_Lcats_kernel_instances_FloatOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_FloatOrder.prototype.constructor = $c_Lcats_kernel_instances_FloatOrder;
/** @constructor */
function $h_Lcats_kernel_instances_FloatOrder() {
}
$h_Lcats_kernel_instances_FloatOrder.prototype = $c_Lcats_kernel_instances_FloatOrder.prototype;
$c_Lcats_kernel_instances_FloatOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_FloatOrder.prototype.toOrdering__s_math_Ordering = (function() {
  return new $c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_instances_FloatOrder.prototype.eqv__F__F__Z = (function(x, y) {
  return (x === y);
});
$c_Lcats_kernel_instances_FloatOrder.prototype.gt__F__F__Z = (function(x, y) {
  return (x > y);
});
$c_Lcats_kernel_instances_FloatOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $uF(x);
  return $m_jl_FloatingPointBits$().numberHashCode__D__I(x$1);
});
$c_Lcats_kernel_instances_FloatOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uF(x);
  var y$1 = $uF(y);
  return $m_jl_Double$().compare__D__D__I(x$1, y$1);
});
$c_Lcats_kernel_instances_FloatOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__F__F__Z($uF(x), $uF(y));
});
$c_Lcats_kernel_instances_FloatOrder.prototype.gt__O__O__Z = (function(x, y) {
  return this.gt__F__F__Z($uF(x), $uF(y));
});
$c_Lcats_kernel_instances_FloatOrder.prototype.max__O__O__O = (function(x, y) {
  var x$1 = $uF(x);
  var y$1 = $uF(y);
  return Math.fround($uD(Math.max(x$1, y$1)));
});
var $d_Lcats_kernel_instances_FloatOrder = new $TypeData().initClass($c_Lcats_kernel_instances_FloatOrder, "cats.kernel.instances.FloatOrder", ({
  Lcats_kernel_instances_FloatOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1
}));
/** @constructor */
function $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse(outer, response) {
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse__f_response = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse__f_$outer = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse__f_response = response;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse__f_$outer = outer;
  $ct_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg__Ldev_sungkm_enchantedrealm_EnchantedRealm__(this, $n(outer).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_$outer);
}
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse.prototype = new $h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg();
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse.prototype.constructor = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse;
/** @constructor */
function $h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse() {
}
$h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse.prototype = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse.prototype;
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse) && ($n($as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse(x$0)).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse__f_$outer === this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse__f_$outer))) {
    var x$0$2 = $as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse(x$0);
    return (this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse__f_response === $n(x$0$2).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse__f_response);
  } else {
    return false;
  }
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse.prototype.productArity__I = (function() {
  return 1;
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse.prototype.productPrefix__T = (function() {
  return "EngineResponse";
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse__f_response;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse(obj) {
  return (((obj instanceof $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse) || (obj === null)) ? obj : $throwClassCastException(obj, "dev.sungkm.enchantedrealm.EnchantedRealm$Msg$EngineResponse"));
}
function $isArrayOf_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse)));
}
function $asArrayOf_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse(obj, depth) {
  return (($isArrayOf_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldev.sungkm.enchantedrealm.EnchantedRealm$Msg$EngineResponse;", depth));
}
var $d_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse = new $TypeData().initClass($c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse, "dev.sungkm.enchantedrealm.EnchantedRealm$Msg$EngineResponse", ({
  Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$EngineResponse: 1,
  Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
/** @constructor */
function $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit(outer, engine) {
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit__f_engine = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit__f_$outer = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit__f_engine = engine;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit__f_$outer = outer;
  $ct_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg__Ldev_sungkm_enchantedrealm_EnchantedRealm__(this, $n(outer).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_$outer);
}
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit.prototype = new $h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg();
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit.prototype.constructor = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit;
/** @constructor */
function $h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit() {
}
$h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit.prototype = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit.prototype;
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit) && ($n($as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit(x$0)).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit__f_$outer === this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit__f_$outer))) {
    var x$0$2 = $as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit(x$0);
    var x = this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit__f_engine;
    var y = $n(x$0$2).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit__f_engine;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit.prototype.productArity__I = (function() {
  return 1;
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit.prototype.productPrefix__T = (function() {
  return "FinishInit";
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit__f_engine;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit(obj) {
  return (((obj instanceof $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit) || (obj === null)) ? obj : $throwClassCastException(obj, "dev.sungkm.enchantedrealm.EnchantedRealm$Msg$FinishInit"));
}
function $isArrayOf_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit)));
}
function $asArrayOf_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit(obj, depth) {
  return (($isArrayOf_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldev.sungkm.enchantedrealm.EnchantedRealm$Msg$FinishInit;", depth));
}
var $d_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit = new $TypeData().initClass($c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit, "dev.sungkm.enchantedrealm.EnchantedRealm$Msg$FinishInit", ({
  Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$FinishInit: 1,
  Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
/** @constructor */
function $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse(outer, stream) {
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse__f_stream = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse__f_$outer = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse__f_stream = stream;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse__f_$outer = outer;
  $ct_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg__Ldev_sungkm_enchantedrealm_EnchantedRealm__(this, $n(outer).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_$outer);
}
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse.prototype = new $h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg();
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse.prototype.constructor = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse;
/** @constructor */
function $h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse() {
}
$h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse.prototype = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse.prototype;
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse) && ($n($as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse(x$0)).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse__f_$outer === this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse__f_$outer))) {
    var x$0$2 = $as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse(x$0);
    var x = this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse__f_stream;
    var x$2 = $n(x$0$2).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse__f_stream;
    if ((x === null)) {
      return (x$2 === null);
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2);
    }
  } else {
    return false;
  }
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse.prototype.productArity__I = (function() {
  return 1;
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse.prototype.productPrefix__T = (function() {
  return "SubscribeEngineResponse";
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse__f_stream;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse(obj) {
  return (((obj instanceof $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse) || (obj === null)) ? obj : $throwClassCastException(obj, "dev.sungkm.enchantedrealm.EnchantedRealm$Msg$SubscribeEngineResponse"));
}
function $isArrayOf_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse)));
}
function $asArrayOf_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse(obj, depth) {
  return (($isArrayOf_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldev.sungkm.enchantedrealm.EnchantedRealm$Msg$SubscribeEngineResponse;", depth));
}
var $d_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse = new $TypeData().initClass($c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse, "dev.sungkm.enchantedrealm.EnchantedRealm$Msg$SubscribeEngineResponse", ({
  Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SubscribeEngineResponse: 1,
  Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
/** @constructor */
function $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage(outer, msg) {
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage__f_msg = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage__f_$outer = null;
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage__f_msg = msg;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage__f_$outer = outer;
  $ct_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg__Ldev_sungkm_enchantedrealm_EnchantedRealm__(this, $n(outer).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_$outer);
}
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage.prototype = new $h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg();
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage.prototype.constructor = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage;
/** @constructor */
function $h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage() {
}
$h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage.prototype = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage.prototype;
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage) && ($n($as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage(x$0)).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage__f_$outer === this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage__f_$outer))) {
    var x$0$2 = $as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage(x$0);
    return (this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage__f_msg === $n(x$0$2).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage__f_msg);
  } else {
    return false;
  }
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage.prototype.productArity__I = (function() {
  return 1;
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage.prototype.productPrefix__T = (function() {
  return "SystemMessage";
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage__f_msg;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage(obj) {
  return (((obj instanceof $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage) || (obj === null)) ? obj : $throwClassCastException(obj, "dev.sungkm.enchantedrealm.EnchantedRealm$Msg$SystemMessage"));
}
function $isArrayOf_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage)));
}
function $asArrayOf_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage(obj, depth) {
  return (($isArrayOf_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ldev.sungkm.enchantedrealm.EnchantedRealm$Msg$SystemMessage;", depth));
}
var $d_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage = new $TypeData().initClass($c_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage, "dev.sungkm.enchantedrealm.EnchantedRealm$Msg$SystemMessage", ({
  Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$SystemMessage: 1,
  Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
/** @constructor */
function $c_Lfs2_Chunk$EmptyChunk() {
}
$c_Lfs2_Chunk$EmptyChunk.prototype = new $h_Lfs2_Chunk();
$c_Lfs2_Chunk$EmptyChunk.prototype.constructor = $c_Lfs2_Chunk$EmptyChunk;
/** @constructor */
function $h_Lfs2_Chunk$EmptyChunk() {
}
$h_Lfs2_Chunk$EmptyChunk.prototype = $c_Lfs2_Chunk$EmptyChunk.prototype;
$c_Lfs2_Chunk$EmptyChunk.prototype.size__I = (function() {
  return 0;
});
$c_Lfs2_Chunk$EmptyChunk.prototype.apply__I__E = (function(i) {
  $m_s_sys_package$().error__T__E((("Chunk.empty.apply(" + i) + ")"));
});
$c_Lfs2_Chunk$EmptyChunk.prototype.map__F1__Lfs2_Chunk = (function(f) {
  return this;
});
$c_Lfs2_Chunk$EmptyChunk.prototype.apply__I__O = (function(i) {
  this.apply__I__E(i);
});
var $d_Lfs2_Chunk$EmptyChunk = new $TypeData().initClass($c_Lfs2_Chunk$EmptyChunk, "fs2.Chunk$EmptyChunk", ({
  Lfs2_Chunk$EmptyChunk: 1,
  Lfs2_Chunk: 1,
  Ljava_io_Serializable: 1,
  Lfs2_Chunk213And3Compat: 1,
  Lfs2_ChunkPlatform: 1,
  Lfs2_ChunkRuntimePlatform: 1
}));
/** @constructor */
function $c_Lfs2_Chunk$Singleton(value) {
  this.Lfs2_Chunk$Singleton__f_value = null;
  this.Lfs2_Chunk$Singleton__f_value = value;
}
$c_Lfs2_Chunk$Singleton.prototype = new $h_Lfs2_Chunk();
$c_Lfs2_Chunk$Singleton.prototype.constructor = $c_Lfs2_Chunk$Singleton;
/** @constructor */
function $h_Lfs2_Chunk$Singleton() {
}
$h_Lfs2_Chunk$Singleton.prototype = $c_Lfs2_Chunk$Singleton.prototype;
$c_Lfs2_Chunk$Singleton.prototype.size__I = (function() {
  return 1;
});
$c_Lfs2_Chunk$Singleton.prototype.apply__I__O = (function(i) {
  if ((i === 0)) {
    return this.Lfs2_Chunk$Singleton__f_value;
  } else {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
});
$c_Lfs2_Chunk$Singleton.prototype.map__F1__Lfs2_Chunk = (function(f) {
  $m_Lfs2_Chunk$();
  var o = $n(f).apply__O__O(this.Lfs2_Chunk$Singleton__f_value);
  return new $c_Lfs2_Chunk$Singleton(o);
});
var $d_Lfs2_Chunk$Singleton = new $TypeData().initClass($c_Lfs2_Chunk$Singleton, "fs2.Chunk$Singleton", ({
  Lfs2_Chunk$Singleton: 1,
  Lfs2_Chunk: 1,
  Ljava_io_Serializable: 1,
  Lfs2_Chunk213And3Compat: 1,
  Lfs2_ChunkPlatform: 1,
  Lfs2_ChunkRuntimePlatform: 1
}));
function $p_Ljava_io_OutputStreamWriter__writeImpl__Ljava_nio_CharBuffer__V($thiz, cbuf) {
  $p_Ljava_io_OutputStreamWriter__ensureOpen__V($thiz);
  if (($thiz.Ljava_io_OutputStreamWriter__f_java$io$OutputStreamWriter$$inBuf !== "")) {
    var this$1 = $m_Ljava_nio_CharBuffer$();
    var csq = (("" + $thiz.Ljava_io_OutputStreamWriter__f_java$io$OutputStreamWriter$$inBuf) + $n(cbuf).toString__T());
    var fullInput = this$1.wrap__jl_CharSequence__I__I__Ljava_nio_CharBuffer(csq, 0, csq.length);
    $thiz.Ljava_io_OutputStreamWriter__f_java$io$OutputStreamWriter$$inBuf = "";
    var cbuf1 = fullInput;
  } else {
    var cbuf1 = cbuf;
  }
  while (true) {
    var result = $n($thiz.Ljava_io_OutputStreamWriter__f_java$io$OutputStreamWriter$$enc).encode__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer__Z__Ljava_nio_charset_CoderResult(cbuf1, $thiz.Ljava_io_OutputStreamWriter__f_java$io$OutputStreamWriter$$outBuf, false);
    var this$2 = $n(result);
    if ((!(this$2.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 0))) {
      var this$3 = $n(result);
      if ((this$3.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 1)) {
        $thiz.java$io$OutputStreamWriter$$makeRoomInOutBuf__V();
        continue;
      } else {
        $n(result).throwException__V();
        throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "should not get here");
      }
    }
    break;
  }
  var this$4 = $n(cbuf1);
  if ((this$4.Ljava_nio_Buffer__f_java$nio$Buffer$$_position !== this$4.Ljava_nio_Buffer__f__limit)) {
    $thiz.Ljava_io_OutputStreamWriter__f_java$io$OutputStreamWriter$$inBuf = $n(cbuf1).toString__T();
  }
}
function $p_Ljava_io_OutputStreamWriter__ensureOpen__V($thiz) {
  if ($thiz.Ljava_io_OutputStreamWriter__f_closed) {
    throw $ct_Ljava_io_IOException__T__(new $c_Ljava_io_IOException(), "Closed writer.");
  }
}
function $ct_Ljava_io_OutputStreamWriter__Ljava_io_OutputStream__Ljava_nio_charset_CharsetEncoder__($thiz, out, enc) {
  $thiz.Ljava_io_OutputStreamWriter__f_out = out;
  $thiz.Ljava_io_OutputStreamWriter__f_java$io$OutputStreamWriter$$enc = enc;
  $ct_Ljava_io_Writer__($thiz);
  $thiz.Ljava_io_OutputStreamWriter__f_closed = false;
  $thiz.Ljava_io_OutputStreamWriter__f_java$io$OutputStreamWriter$$inBuf = "";
  $thiz.Ljava_io_OutputStreamWriter__f_java$io$OutputStreamWriter$$outBuf = $m_Ljava_nio_ByteBuffer$().allocate__I__Ljava_nio_ByteBuffer(4096);
  return $thiz;
}
function $ct_Ljava_io_OutputStreamWriter__Ljava_io_OutputStream__Ljava_nio_charset_Charset__($thiz, out, cs) {
  $ct_Ljava_io_OutputStreamWriter__Ljava_io_OutputStream__Ljava_nio_charset_CharsetEncoder__($thiz, out, $n(($n(cs), new $c_Ljava_nio_charset_UTF\uff3f8$Encoder()).onMalformedInput__Ljava_nio_charset_CodingErrorAction__Ljava_nio_charset_CharsetEncoder($m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPLACE)).onUnmappableCharacter__Ljava_nio_charset_CodingErrorAction__Ljava_nio_charset_CharsetEncoder($m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPLACE));
  return $thiz;
}
/** @constructor */
function $c_Ljava_io_OutputStreamWriter() {
  this.Ljava_io_OutputStreamWriter__f_out = null;
  this.Ljava_io_OutputStreamWriter__f_java$io$OutputStreamWriter$$enc = null;
  this.Ljava_io_OutputStreamWriter__f_closed = false;
  this.Ljava_io_OutputStreamWriter__f_java$io$OutputStreamWriter$$inBuf = null;
  this.Ljava_io_OutputStreamWriter__f_java$io$OutputStreamWriter$$outBuf = null;
}
$c_Ljava_io_OutputStreamWriter.prototype = new $h_Ljava_io_Writer();
$c_Ljava_io_OutputStreamWriter.prototype.constructor = $c_Ljava_io_OutputStreamWriter;
/** @constructor */
function $h_Ljava_io_OutputStreamWriter() {
}
$h_Ljava_io_OutputStreamWriter.prototype = $c_Ljava_io_OutputStreamWriter.prototype;
$c_Ljava_io_OutputStreamWriter.prototype.write__I__V = (function(c) {
  var this$1 = (65535 & c);
  this.write__T__I__I__V(("" + $cToS(this$1)), 0, 1);
});
$c_Ljava_io_OutputStreamWriter.prototype.write__AC__I__I__V = (function(cbuf, off, len) {
  var capacity = $n(cbuf).u.length;
  if (((capacity < 0) || (capacity > $n(cbuf).u.length))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  var initialLimit = ((off + len) | 0);
  if ((((off < 0) || (len < 0)) || (initialLimit > capacity))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  $p_Ljava_io_OutputStreamWriter__writeImpl__Ljava_nio_CharBuffer__V(this, new $c_Ljava_nio_HeapCharBuffer(capacity, cbuf, 0, off, initialLimit, false));
});
$c_Ljava_io_OutputStreamWriter.prototype.write__T__I__I__V = (function(str, off, len) {
  $p_Ljava_io_OutputStreamWriter__writeImpl__Ljava_nio_CharBuffer__V(this, $m_Ljava_nio_CharBuffer$().wrap__jl_CharSequence__I__I__Ljava_nio_CharBuffer(str, off, ((off + len) | 0)));
});
$c_Ljava_io_OutputStreamWriter.prototype.java$io$OutputStreamWriter$$makeRoomInOutBuf__V = (function() {
  var this$1 = $n(this.Ljava_io_OutputStreamWriter__f_java$io$OutputStreamWriter$$outBuf);
  if ((this$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position !== 0)) {
    this.flushBuffer__V();
  } else {
    var this$2 = $n(this.Ljava_io_OutputStreamWriter__f_java$io$OutputStreamWriter$$outBuf);
    $c_Ljava_nio_Buffer.prototype.flip__Ljava_nio_Buffer.call(this$2);
    var $x_1 = $m_Ljava_nio_ByteBuffer$();
    var this$3 = $n(this.Ljava_io_OutputStreamWriter__f_java$io$OutputStreamWriter$$outBuf);
    var newBuf = $n($x_1).allocate__I__Ljava_nio_ByteBuffer((this$3.Ljava_nio_Buffer__f__capacity << 1));
    $n(newBuf).put__Ljava_nio_ByteBuffer__Ljava_nio_ByteBuffer(this.Ljava_io_OutputStreamWriter__f_java$io$OutputStreamWriter$$outBuf);
    this.Ljava_io_OutputStreamWriter__f_java$io$OutputStreamWriter$$outBuf = newBuf;
  }
});
$c_Ljava_io_OutputStreamWriter.prototype.flushBuffer__V = (function() {
  $p_Ljava_io_OutputStreamWriter__ensureOpen__V(this);
  var $x_1 = $n(this.Ljava_io_OutputStreamWriter__f_out);
  var this$1 = $n(this.Ljava_io_OutputStreamWriter__f_java$io$OutputStreamWriter$$outBuf);
  var a = this$1.Ljava_nio_ByteBuffer__f__array;
  if ((a === null)) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (this$1.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var this$4 = $n(this.Ljava_io_OutputStreamWriter__f_java$io$OutputStreamWriter$$outBuf);
  var o = this$4.Ljava_nio_ByteBuffer__f__arrayOffset;
  if ((o === (-1))) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (this$4.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var this$7 = $n(this.Ljava_io_OutputStreamWriter__f_java$io$OutputStreamWriter$$outBuf);
  $n($x_1).write__AB__I__I__V(a, o, this$7.Ljava_nio_Buffer__f_java$nio$Buffer$$_position);
  var this$8 = $n(this.Ljava_io_OutputStreamWriter__f_java$io$OutputStreamWriter$$outBuf);
  $c_Ljava_nio_Buffer.prototype.clear__Ljava_nio_Buffer.call(this$8);
});
var $d_Ljava_io_OutputStreamWriter = new $TypeData().initClass($c_Ljava_io_OutputStreamWriter, "java.io.OutputStreamWriter", ({
  Ljava_io_OutputStreamWriter: 1,
  Ljava_io_Writer: 1,
  jl_Appendable: 1,
  Ljava_io_Closeable: 1,
  jl_AutoCloseable: 1,
  Ljava_io_Flushable: 1
}));
function $ct_jl_ArrayIndexOutOfBoundsException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_jl_ArrayIndexOutOfBoundsException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_jl_ArrayIndexOutOfBoundsException extends $c_jl_IndexOutOfBoundsException {
}
var $d_jl_ArrayIndexOutOfBoundsException = new $TypeData().initClass($c_jl_ArrayIndexOutOfBoundsException, "java.lang.ArrayIndexOutOfBoundsException", ({
  jl_ArrayIndexOutOfBoundsException: 1,
  jl_IndexOutOfBoundsException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $f_jl_Double__equals__O__Z($thiz, that) {
  return Object.is($thiz, that);
}
function $f_jl_Double__hashCode__I($thiz) {
  return $m_jl_FloatingPointBits$().numberHashCode__D__I($thiz);
}
function $f_jl_Double__toString__T($thiz) {
  return ("" + $thiz);
}
function $f_jl_Double__compareTo__O__I($thiz, o) {
  var that = $as_jl_Double(o);
  var $x_1 = $m_jl_Double$();
  var this$1 = $n(that);
  return $n($x_1).compare__D__D__I($thiz, this$1);
}
function $as_jl_Double(obj) {
  return ((((typeof obj) === "number") || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Double"));
}
function $isArrayOf_jl_Double(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Double)));
}
function $asArrayOf_jl_Double(obj, depth) {
  return (($isArrayOf_jl_Double(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Double;", depth));
}
var $d_jl_Double = new $TypeData().initClass(0, "java.lang.Double", ({
  jl_Double: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}), ((x) => ((typeof x) === "number")));
function $f_jl_Float__equals__O__Z($thiz, that) {
  return Object.is($thiz, that);
}
function $f_jl_Float__hashCode__I($thiz) {
  return $m_jl_FloatingPointBits$().numberHashCode__D__I($thiz);
}
function $f_jl_Float__toString__T($thiz) {
  return ("" + $thiz);
}
function $f_jl_Float__compareTo__O__I($thiz, o) {
  var that = $as_jl_Float(o);
  var this$1 = $n(that);
  return $m_jl_Double$().compare__D__D__I($thiz, this$1);
}
function $as_jl_Float(obj) {
  return (($isFloat(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Float"));
}
function $isArrayOf_jl_Float(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Float)));
}
function $asArrayOf_jl_Float(obj, depth) {
  return (($isArrayOf_jl_Float(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Float;", depth));
}
var $d_jl_Float = new $TypeData().initClass(0, "java.lang.Float", ({
  jl_Float: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}), ((x) => $isFloat(x)));
function $f_jl_Integer__equals__O__Z($thiz, that) {
  return Object.is($thiz, that);
}
function $f_jl_Integer__hashCode__I($thiz) {
  return $thiz;
}
function $f_jl_Integer__toString__T($thiz) {
  return ("" + $thiz);
}
function $f_jl_Integer__compareTo__O__I($thiz, o) {
  var that = $as_jl_Integer(o);
  var this$1 = $n(that);
  return (($thiz === this$1) ? 0 : (($thiz < this$1) ? (-1) : 1));
}
function $as_jl_Integer(obj) {
  return (($isInt(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Integer"));
}
function $isArrayOf_jl_Integer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Integer)));
}
function $asArrayOf_jl_Integer(obj, depth) {
  return (($isArrayOf_jl_Integer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Integer;", depth));
}
var $d_jl_Integer = new $TypeData().initClass(0, "java.lang.Integer", ({
  jl_Integer: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}), ((x) => $isInt(x)));
function $f_jl_Long__equals__O__Z($thiz, that) {
  if ((that instanceof $c_RTLong)) {
    var x2 = $as_jl_Long(that);
    var this$1 = $n(x2);
    var b = $uJ(this$1);
    return (($thiz.RTLong__f_lo === b.RTLong__f_lo) && ($thiz.RTLong__f_hi === b.RTLong__f_hi));
  } else {
    return false;
  }
}
function $f_jl_Long__hashCode__I($thiz) {
  var $x_1 = $thiz.RTLong__f_lo;
  var hi = $thiz.RTLong__f_hi;
  return ($x_1 ^ hi);
}
function $f_jl_Long__toString__T($thiz) {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T($thiz.RTLong__f_lo, $thiz.RTLong__f_hi);
}
function $f_jl_Long__compareTo__O__I($thiz, o) {
  var that = $as_jl_Long(o);
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I($thiz.RTLong__f_lo, $thiz.RTLong__f_hi, $n(that).RTLong__f_lo, $n(that).RTLong__f_hi);
}
function $as_jl_Long(obj) {
  return (((obj instanceof $c_RTLong) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Long"));
}
function $isArrayOf_jl_Long(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Long)));
}
function $asArrayOf_jl_Long(obj, depth) {
  return (($isArrayOf_jl_Long(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Long;", depth));
}
var $d_jl_Long = new $TypeData().initClass(0, "java.lang.Long", ({
  jl_Long: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}), ((x) => (x instanceof $c_RTLong)));
class $c_jl_NumberFormatException extends $c_jl_IllegalArgumentException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
}
function $as_jl_NumberFormatException(obj) {
  return (((obj instanceof $c_jl_NumberFormatException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.NumberFormatException"));
}
function $isArrayOf_jl_NumberFormatException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_NumberFormatException)));
}
function $asArrayOf_jl_NumberFormatException(obj, depth) {
  return (($isArrayOf_jl_NumberFormatException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.NumberFormatException;", depth));
}
var $d_jl_NumberFormatException = new $TypeData().initClass($c_jl_NumberFormatException, "java.lang.NumberFormatException", ({
  jl_NumberFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $f_T__length__I($thiz) {
  return $thiz.length;
}
function $f_T__charAt__I__C($thiz, index) {
  return $charAt($thiz, index);
}
function $f_T__codePointAt__I__I($thiz, index) {
  $charAt($thiz, index);
  return $uI($thiz.codePointAt(index));
}
function $f_T__hashCode__I($thiz) {
  var res = 0;
  var mul = 1;
  var i = (((-1) + $thiz.length) | 0);
  while ((i >= 0)) {
    var $x_1 = res;
    var index = i;
    res = (($x_1 + Math.imul($charAt($thiz, index), mul)) | 0);
    mul = Math.imul(31, mul);
    i = (((-1) + i) | 0);
  }
  return res;
}
function $f_T__equals__O__Z($thiz, that) {
  return ($thiz === that);
}
function $f_T__compareTo__T__I($thiz, anotherString) {
  var thisLength = $thiz.length;
  var this$1 = $n(anotherString);
  var strLength = this$1.length;
  var minLength = ((thisLength < strLength) ? thisLength : strLength);
  var i = 0;
  while ((i !== minLength)) {
    var index = i;
    var this$3 = $n(anotherString);
    var index$1 = i;
    var cmp = (($charAt($thiz, index) - $charAt(this$3, index$1)) | 0);
    if ((cmp !== 0)) {
      return cmp;
    }
    i = ((1 + i) | 0);
  }
  return ((thisLength - strLength) | 0);
}
function $f_T__compareToIgnoreCase__T__I($thiz, str) {
  var thisLength = $thiz.length;
  var this$1 = $n(str);
  var strLength = this$1.length;
  var minLength = ((thisLength < strLength) ? thisLength : strLength);
  var i = 0;
  while ((i !== minLength)) {
    var index = i;
    var c = $charAt($thiz, index);
    var $x_1 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c));
    var this$3 = $n(str);
    var index$1 = i;
    var c$1 = $charAt(this$3, index$1);
    var cmp = (($x_1 - $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$1))) | 0);
    if ((cmp !== 0)) {
      return cmp;
    }
    i = ((1 + i) | 0);
  }
  return ((thisLength - strLength) | 0);
}
function $f_T__endsWith__T__Z($thiz, suffix) {
  var this$1 = $n(suffix);
  var $x_1 = $thiz.substring((($thiz.length - this$1.length) | 0));
  return ($as_T($x_1) === suffix);
}
function $f_T__getChars__I__I__AC__I__V($thiz, srcBegin, srcEnd, dst, dstBegin) {
  if (((((srcEnd > $thiz.length) || (srcBegin < 0)) || (srcEnd < 0)) || (srcBegin > srcEnd))) {
    throw $ct_jl_StringIndexOutOfBoundsException__T__(new $c_jl_StringIndexOutOfBoundsException(), "Index out of Bound");
  }
  var offset = ((dstBegin - srcBegin) | 0);
  var i = srcBegin;
  while ((i < srcEnd)) {
    var $x_2 = $n(dst);
    var $x_1 = i;
    var index = i;
    $x_2.set((($x_1 + offset) | 0), $charAt($thiz, index));
    i = ((1 + i) | 0);
  }
}
function $f_T__indexOf__I__I($thiz, ch) {
  var str = $m_jl_Character$().toString__I__T(ch);
  return $uI($thiz.indexOf(str));
}
function $f_T__lastIndexOf__I__I($thiz, ch) {
  var str = $m_jl_Character$().toString__I__T(ch);
  return $uI($thiz.lastIndexOf(str));
}
function $f_T__repeat__I__T($thiz, count) {
  if ((count < 0)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  } else {
    return $as_T($thiz.repeat(count));
  }
}
function $f_T__replaceAll__T__T__T($thiz, regex, replacement) {
  var this$2 = $n($m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern(regex, 0));
  return new $c_ju_regex_Matcher(this$2, $thiz).replaceAll__T__T(replacement);
}
function $f_T__replaceFirst__T__T__T($thiz, regex, replacement) {
  var this$2 = $n($m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern(regex, 0));
  return new $c_ju_regex_Matcher(this$2, $thiz).replaceFirst__T__T(replacement);
}
function $f_T__split__T__I__AT($thiz, regex, limit) {
  var this$2 = $n($m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern(regex, 0));
  return this$2.java$util$regex$Pattern$$split__T__I__AT($thiz, limit);
}
function $f_T__subSequence__I__I__jl_CharSequence($thiz, beginIndex, endIndex) {
  if ((beginIndex < 0)) {
    $charAt($thiz, beginIndex);
  }
  if ((endIndex > $thiz.length)) {
    $charAt($thiz, endIndex);
  }
  if ((endIndex < beginIndex)) {
    $charAt($thiz, (-1));
  }
  return $as_T($thiz.substring(beginIndex, endIndex));
}
function $f_T__toCharArray__AC($thiz) {
  var len = $thiz.length;
  var result = new $ac_C(len);
  var i = 0;
  while ((i < len)) {
    var $x_2 = $n(result);
    var $x_1 = i;
    var index = i;
    $x_2.set($x_1, $charAt($thiz, index));
    i = ((1 + i) | 0);
  }
  return result;
}
function $f_T__trim__T($thiz) {
  var len = $thiz.length;
  var start = 0;
  while (true) {
    if ((start !== len)) {
      var index = start;
      var $x_1 = ($charAt($thiz, index) <= 32);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      start = ((1 + start) | 0);
    } else {
      break;
    }
  }
  if ((start === len)) {
    return "";
  } else {
    var end = len;
    while (true) {
      var index$1 = (((-1) + end) | 0);
      if (($charAt($thiz, index$1) <= 32)) {
        end = (((-1) + end) | 0);
      } else {
        break;
      }
    }
    if (((start === 0) && (end === len))) {
      return $thiz;
    } else {
      var beginIndex = start;
      var endIndex = end;
      if ((beginIndex < 0)) {
        $charAt($thiz, beginIndex);
      }
      if ((endIndex > $thiz.length)) {
        $charAt($thiz, endIndex);
      }
      if ((endIndex < beginIndex)) {
        $charAt($thiz, (-1));
      }
      return $as_T($thiz.substring(beginIndex, endIndex));
    }
  }
}
function $f_T__toString__T($thiz) {
  return $thiz;
}
function $f_T__compareTo__O__I($thiz, o) {
  return $f_T__compareTo__T__I($thiz, $as_T(o));
}
function $as_T(obj) {
  return ((((typeof obj) === "string") || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.String"));
}
function $isArrayOf_T(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T)));
}
function $asArrayOf_T(obj, depth) {
  return (($isArrayOf_T(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.String;", depth));
}
var $d_T = new $TypeData().initClass(0, "java.lang.String", ({
  T: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_CharSequence: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}), ((x) => ((typeof x) === "string")));
function $ct_jl_StringIndexOutOfBoundsException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_jl_StringIndexOutOfBoundsException__I__($thiz, index) {
  var s = ("String index out of range: " + index);
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_jl_StringIndexOutOfBoundsException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_jl_StringIndexOutOfBoundsException extends $c_jl_IndexOutOfBoundsException {
}
var $d_jl_StringIndexOutOfBoundsException = new $TypeData().initClass($c_jl_StringIndexOutOfBoundsException, "java.lang.StringIndexOutOfBoundsException", ({
  jl_StringIndexOutOfBoundsException: 1,
  jl_IndexOutOfBoundsException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_Ljava_nio_CharBuffer__I__AC__I__($thiz, _capacity, _array, _arrayOffset) {
  $thiz.Ljava_nio_CharBuffer__f__array = _array;
  $thiz.Ljava_nio_CharBuffer__f__arrayOffset = _arrayOffset;
  $ct_Ljava_nio_Buffer__I__($thiz, _capacity);
  return $thiz;
}
/** @constructor */
function $c_Ljava_nio_CharBuffer() {
  this.Ljava_nio_Buffer__f__capacity = 0;
  this.Ljava_nio_Buffer__f__limit = 0;
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  this.Ljava_nio_Buffer__f__mark = 0;
  this.Ljava_nio_CharBuffer__f__array = null;
  this.Ljava_nio_CharBuffer__f__arrayOffset = 0;
}
$c_Ljava_nio_CharBuffer.prototype = new $h_Ljava_nio_Buffer();
$c_Ljava_nio_CharBuffer.prototype.constructor = $c_Ljava_nio_CharBuffer;
/** @constructor */
function $h_Ljava_nio_CharBuffer() {
}
$h_Ljava_nio_CharBuffer.prototype = $c_Ljava_nio_CharBuffer.prototype;
$c_Ljava_nio_CharBuffer.prototype.put__Ljava_nio_CharBuffer__Ljava_nio_CharBuffer = (function(src) {
  if ((src === this)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  if (this.isReadOnly__Z()) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var this$3 = $n(src);
  var srcLimit = this$3.Ljava_nio_Buffer__f__limit;
  var this$4 = $n(src);
  var srcPos = this$4.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var length = ((srcLimit - srcPos) | 0);
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var newPos = ((p + length) | 0);
  if ((newPos > this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferOverflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPos;
  var selfPos = p;
  var this$5 = $n(src);
  $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this$5, srcLimit);
  var this$6 = $n(src);
  var srcArray = this$6.Ljava_nio_CharBuffer__f__array;
  if ((srcArray !== null)) {
    var startIndex = selfPos;
    var offset = (($n(src).Ljava_nio_CharBuffer__f__arrayOffset + srcPos) | 0);
    this.store__I__AC__I__I__V(startIndex, srcArray, offset, length);
  } else {
    while ((srcPos !== srcLimit)) {
      var index$1 = selfPos;
      var this$7 = $n(src);
      var index = srcPos;
      var elem = this$7.load__I__C(index);
      this.store__I__C__V(index$1, elem);
      srcPos = ((1 + srcPos) | 0);
      selfPos = ((1 + selfPos) | 0);
    }
  }
  return this;
});
$c_Ljava_nio_CharBuffer.prototype.put__T__I__I__Ljava_nio_CharBuffer = (function(src, start, end) {
  return this.put__Ljava_nio_CharBuffer__Ljava_nio_CharBuffer($m_Ljava_nio_CharBuffer$().wrap__jl_CharSequence__I__I__Ljava_nio_CharBuffer(src, start, end));
});
$c_Ljava_nio_CharBuffer.prototype.hashCode__I = (function() {
  var start = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var end = this.Ljava_nio_Buffer__f__limit;
  var h = (-182887236);
  var i = start;
  while ((i !== end)) {
    var $x_2 = $m_ju_internal_MurmurHash3$();
    var $x_1 = h;
    var index = i;
    var this$3 = this.load__I__C(index);
    h = $n($x_2).mix__I__I__I($x_1, this$3);
    i = ((1 + i) | 0);
  }
  return $m_ju_internal_MurmurHash3$().finalizeHash__I__I__I(h, ((end - start) | 0));
});
$c_Ljava_nio_CharBuffer.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Ljava_nio_CharBuffer)) {
    var x2 = $as_Ljava_nio_CharBuffer(that);
    return (this.compareTo__Ljava_nio_CharBuffer__I(x2) === 0);
  } else {
    return false;
  }
});
$c_Ljava_nio_CharBuffer.prototype.compareTo__Ljava_nio_CharBuffer__I = (function(that) {
  if ((this === that)) {
    return 0;
  } else {
    var thisStart = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
    var thisRemaining = ((this.Ljava_nio_Buffer__f__limit - thisStart) | 0);
    var this$3 = $n(that);
    var thatStart = this$3.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
    var this$4 = $n(that);
    var thatRemaining = ((this$4.Ljava_nio_Buffer__f__limit - thatStart) | 0);
    var shortestLength = ((thisRemaining < thatRemaining) ? thisRemaining : thatRemaining);
    var i = 0;
    while ((i !== shortestLength)) {
      var index = ((thisStart + i) | 0);
      var x$1$2 = this.load__I__C(index);
      var this$6 = $n(that);
      var index$1 = ((thatStart + i) | 0);
      var x$2$2 = this$6.load__I__C(index$1);
      var cmp = ((x$1$2 - x$2$2) | 0);
      if ((cmp !== 0)) {
        return cmp;
      }
      i = ((1 + i) | 0);
    }
    return ((thisRemaining === thatRemaining) ? 0 : ((thisRemaining < thatRemaining) ? (-1) : 1));
  }
});
$c_Ljava_nio_CharBuffer.prototype.toString__T = (function() {
  if ((this.Ljava_nio_CharBuffer__f__array !== null)) {
    var value = this.Ljava_nio_CharBuffer__f__array;
    var offset = ((this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + this.Ljava_nio_CharBuffer__f__arrayOffset) | 0);
    var count = ((this.Ljava_nio_Buffer__f__limit - this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
    return $m_jl_String$().new__AC__I__I__T(value, offset, count);
  } else {
    var chars = new $ac_C(((this.Ljava_nio_Buffer__f__limit - this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0));
    var savedPos = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
    this.get__AC__I__I__Ljava_nio_CharBuffer(chars, 0, $n(chars).u.length);
    $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this, savedPos);
    var this$1 = $m_jl_String$();
    return this$1.new__AC__I__I__T(chars, 0, $n(chars).u.length);
  }
});
$c_Ljava_nio_CharBuffer.prototype.length__I = (function() {
  return ((this.Ljava_nio_Buffer__f__limit - this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
});
$c_Ljava_nio_CharBuffer.prototype.charAt__I__C = (function(index) {
  return this.get__I__C(((this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + index) | 0));
});
$c_Ljava_nio_CharBuffer.prototype.append__jl_CharSequence__jl_Appendable = (function(csq) {
  var src = $dp_toString__T($n(csq));
  var this$1 = $n(src);
  return this.put__T__I__I__Ljava_nio_CharBuffer(src, 0, this$1.length);
});
$c_Ljava_nio_CharBuffer.prototype.compareTo__O__I = (function(o) {
  return this.compareTo__Ljava_nio_CharBuffer__I($as_Ljava_nio_CharBuffer(o));
});
function $as_Ljava_nio_CharBuffer(obj) {
  return (((obj instanceof $c_Ljava_nio_CharBuffer) || (obj === null)) ? obj : $throwClassCastException(obj, "java.nio.CharBuffer"));
}
function $isArrayOf_Ljava_nio_CharBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_nio_CharBuffer)));
}
function $asArrayOf_Ljava_nio_CharBuffer(obj, depth) {
  return (($isArrayOf_Ljava_nio_CharBuffer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.nio.CharBuffer;", depth));
}
class $c_Ljava_nio_ReadOnlyBufferException extends $c_jl_UnsupportedOperationException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
}
var $d_Ljava_nio_ReadOnlyBufferException = new $TypeData().initClass($c_Ljava_nio_ReadOnlyBufferException, "java.nio.ReadOnlyBufferException", ({
  Ljava_nio_ReadOnlyBufferException: 1,
  jl_UnsupportedOperationException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_Ljava_nio_charset_MalformedInputException extends $c_Ljava_nio_charset_CharacterCodingException {
  constructor(inputLength) {
    super();
    this.Ljava_nio_charset_MalformedInputException__f_inputLength = 0;
    this.Ljava_nio_charset_MalformedInputException__f_inputLength = inputLength;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  getMessage__T() {
    return ("Input length = " + this.Ljava_nio_charset_MalformedInputException__f_inputLength);
  }
}
var $d_Ljava_nio_charset_MalformedInputException = new $TypeData().initClass($c_Ljava_nio_charset_MalformedInputException, "java.nio.charset.MalformedInputException", ({
  Ljava_nio_charset_MalformedInputException: 1,
  Ljava_nio_charset_CharacterCodingException: 1,
  Ljava_io_IOException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_Ljava_nio_charset_UnmappableCharacterException extends $c_Ljava_nio_charset_CharacterCodingException {
  constructor(inputLength) {
    super();
    this.Ljava_nio_charset_UnmappableCharacterException__f_inputLength = 0;
    this.Ljava_nio_charset_UnmappableCharacterException__f_inputLength = inputLength;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  getMessage__T() {
    return ("Input length = " + this.Ljava_nio_charset_UnmappableCharacterException__f_inputLength);
  }
}
var $d_Ljava_nio_charset_UnmappableCharacterException = new $TypeData().initClass($c_Ljava_nio_charset_UnmappableCharacterException, "java.nio.charset.UnmappableCharacterException", ({
  Ljava_nio_charset_UnmappableCharacterException: 1,
  Ljava_nio_charset_CharacterCodingException: 1,
  Ljava_io_IOException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_ju_FormatterClosedException extends $c_jl_IllegalStateException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
}
var $d_ju_FormatterClosedException = new $TypeData().initClass($c_ju_FormatterClosedException, "java.util.FormatterClosedException", ({
  ju_FormatterClosedException: 1,
  jl_IllegalStateException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_HashMap$EntrySet(outer) {
  this.ju_HashMap$EntrySet__f_$outer = null;
  $n(outer);
  this.ju_HashMap$EntrySet__f_$outer = outer;
}
$c_ju_HashMap$EntrySet.prototype = new $h_ju_AbstractSet();
$c_ju_HashMap$EntrySet.prototype.constructor = $c_ju_HashMap$EntrySet;
/** @constructor */
function $h_ju_HashMap$EntrySet() {
}
$h_ju_HashMap$EntrySet.prototype = $c_ju_HashMap$EntrySet.prototype;
$c_ju_HashMap$EntrySet.prototype.iterator__ju_Iterator = (function() {
  var this$1 = $n(this.ju_HashMap$EntrySet__f_$outer);
  return this$1.nodeIterator__ju_Iterator();
});
$c_ju_HashMap$EntrySet.prototype.size__I = (function() {
  return $n(this.ju_HashMap$EntrySet__f_$outer).ju_HashMap__f_contentSize;
});
$c_ju_HashMap$EntrySet.prototype.contains__O__Z = (function(o) {
  if ($is_ju_Map$Entry(o)) {
    var x2 = $as_ju_Map$Entry(o);
    var this$2 = $n(this.ju_HashMap$EntrySet__f_$outer);
    var this$1 = $n(x2);
    var key = this$1.ju_HashMap$Node__f_key;
    if ((key === null)) {
      var hash = 0;
    } else {
      var originalHash = $dp_hashCode__I($n(key));
      var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    }
    var node = this$2.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, (hash & (((-1) + $n(this$2.ju_HashMap__f_java$util$HashMap$$table).u.length) | 0)));
    if ((node !== null)) {
      var this$4 = $n(node);
      var a = this$4.ju_HashMap$Node__f_value;
      var this$5 = $n(x2);
      var b = this$5.ju_HashMap$Node__f_value;
      return ((a === null) ? (b === null) : $dp_equals__O__Z($n(a), b));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
var $d_ju_HashMap$EntrySet = new $TypeData().initClass($c_ju_HashMap$EntrySet, "java.util.HashMap$EntrySet", ({
  ju_HashMap$EntrySet: 1,
  ju_AbstractSet: 1,
  ju_AbstractCollection: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_Set: 1
}));
class $c_ju_IllegalFormatException extends $c_jl_IllegalArgumentException {
}
/** @constructor */
function $c_ju_NullRejectingHashMap() {
  this.ju_HashMap__f_java$util$HashMap$$loadFactor = 0.0;
  this.ju_HashMap__f_java$util$HashMap$$table = null;
  this.ju_HashMap__f_threshold = 0;
  this.ju_HashMap__f_contentSize = 0;
}
$c_ju_NullRejectingHashMap.prototype = new $h_ju_HashMap();
$c_ju_NullRejectingHashMap.prototype.constructor = $c_ju_NullRejectingHashMap;
/** @constructor */
function $h_ju_NullRejectingHashMap() {
}
$h_ju_NullRejectingHashMap.prototype = $c_ju_NullRejectingHashMap.prototype;
$c_ju_NullRejectingHashMap.prototype.get__O__O = (function(key) {
  if ((key === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $p_ju_HashMap__getOrDefaultImpl__O__O__O(this, key, null);
});
$c_ju_NullRejectingHashMap.prototype.put__O__O__O = (function(key, value) {
  if (((key === null) || (value === null))) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((key === null)) {
    var $x_1 = 0;
  } else {
    var originalHash = $dp_hashCode__I($n(key));
    var $x_1 = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  return this.java$util$HashMap$$put0__O__O__I__Z__O(key, value, $x_1, false);
});
$c_ju_NullRejectingHashMap.prototype.remove__O__O = (function(key) {
  if ((key === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $c_ju_HashMap.prototype.remove__O__O.call(this, key);
});
$c_ju_NullRejectingHashMap.prototype.containsValue__O__Z = (function(value) {
  if ((value === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $c_ju_HashMap.prototype.containsValue__O__Z.call(this, value);
});
class $c_ju_concurrent_CancellationException extends $c_jl_IllegalStateException {
  constructor(message) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, null, true, true);
  }
}
var $d_ju_concurrent_CancellationException = new $TypeData().initClass($c_ju_concurrent_CancellationException, "java.util.concurrent.CancellationException", ({
  ju_concurrent_CancellationException: 1,
  jl_IllegalStateException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_ju_regex_PatternSyntaxException extends $c_jl_IllegalArgumentException {
  constructor(desc, regex, index) {
    super();
    this.ju_regex_PatternSyntaxException__f_desc = null;
    this.ju_regex_PatternSyntaxException__f_regex = null;
    this.ju_regex_PatternSyntaxException__f_index = 0;
    this.ju_regex_PatternSyntaxException__f_desc = desc;
    this.ju_regex_PatternSyntaxException__f_regex = regex;
    this.ju_regex_PatternSyntaxException__f_index = index;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  getMessage__T() {
    var idx = this.ju_regex_PatternSyntaxException__f_index;
    var re = this.ju_regex_PatternSyntaxException__f_regex;
    var indexHint = ((idx < 0) ? "" : (" near index " + idx));
    var base = (((this.ju_regex_PatternSyntaxException__f_desc + indexHint) + "\n") + re);
    if (((idx >= 0) && (re !== null))) {
      var this$1 = $n(re);
      var $x_1 = (idx < this$1.length);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (((base + "\n") + $f_T__repeat__I__T(" ", idx)) + "^");
    } else {
      return base;
    }
  }
}
var $d_ju_regex_PatternSyntaxException = new $TypeData().initClass($c_ju_regex_PatternSyntaxException, "java.util.regex.PatternSyntaxException", ({
  ju_regex_PatternSyntaxException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigValue$BooleanValue(value) {
  this.Llaika_api_config_ConfigValue$BooleanValue__f_value = false;
  this.Llaika_api_config_ConfigValue$BooleanValue__f_value = value;
}
$c_Llaika_api_config_ConfigValue$BooleanValue.prototype = new $h_O();
$c_Llaika_api_config_ConfigValue$BooleanValue.prototype.constructor = $c_Llaika_api_config_ConfigValue$BooleanValue;
/** @constructor */
function $h_Llaika_api_config_ConfigValue$BooleanValue() {
}
$h_Llaika_api_config_ConfigValue$BooleanValue.prototype = $c_Llaika_api_config_ConfigValue$BooleanValue.prototype;
$c_Llaika_api_config_ConfigValue$BooleanValue.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_ConfigValue$BooleanValue.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("BooleanValue");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Llaika_api_config_ConfigValue$BooleanValue__f_value ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1);
});
$c_Llaika_api_config_ConfigValue$BooleanValue.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_config_ConfigValue$BooleanValue)) {
    var x$0$2 = $as_Llaika_api_config_ConfigValue$BooleanValue(x$0);
    return ((this.Llaika_api_config_ConfigValue$BooleanValue__f_value === $n(x$0$2).Llaika_api_config_ConfigValue$BooleanValue__f_value) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Llaika_api_config_ConfigValue$BooleanValue.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_config_ConfigValue$BooleanValue.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_api_config_ConfigValue$BooleanValue.prototype.productPrefix__T = (function() {
  return "BooleanValue";
});
$c_Llaika_api_config_ConfigValue$BooleanValue.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_config_ConfigValue$BooleanValue__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_api_config_ConfigValue$BooleanValue.prototype.render__T = (function() {
  var this$1 = this.Llaika_api_config_ConfigValue$BooleanValue__f_value;
  return ("" + this$1);
});
function $as_Llaika_api_config_ConfigValue$BooleanValue(obj) {
  return (((obj instanceof $c_Llaika_api_config_ConfigValue$BooleanValue) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.ConfigValue$BooleanValue"));
}
function $isArrayOf_Llaika_api_config_ConfigValue$BooleanValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_ConfigValue$BooleanValue)));
}
function $asArrayOf_Llaika_api_config_ConfigValue$BooleanValue(obj, depth) {
  return (($isArrayOf_Llaika_api_config_ConfigValue$BooleanValue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.ConfigValue$BooleanValue;", depth));
}
var $d_Llaika_api_config_ConfigValue$BooleanValue = new $TypeData().initClass($c_Llaika_api_config_ConfigValue$BooleanValue, "laika.api.config.ConfigValue$BooleanValue", ({
  Llaika_api_config_ConfigValue$BooleanValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_api_config_ConfigValue: 1,
  Llaika_api_config_ConfigValue$SimpleValue: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigValue$DoubleValue(value) {
  this.Llaika_api_config_ConfigValue$DoubleValue__f_value = 0.0;
  this.Llaika_api_config_ConfigValue$DoubleValue__f_value = value;
}
$c_Llaika_api_config_ConfigValue$DoubleValue.prototype = new $h_O();
$c_Llaika_api_config_ConfigValue$DoubleValue.prototype.constructor = $c_Llaika_api_config_ConfigValue$DoubleValue;
/** @constructor */
function $h_Llaika_api_config_ConfigValue$DoubleValue() {
}
$h_Llaika_api_config_ConfigValue$DoubleValue.prototype = $c_Llaika_api_config_ConfigValue$DoubleValue.prototype;
$c_Llaika_api_config_ConfigValue$DoubleValue.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_ConfigValue$DoubleValue.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("DoubleValue");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var dv = this.Llaika_api_config_ConfigValue$DoubleValue__f_value;
  var data$1 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1);
});
$c_Llaika_api_config_ConfigValue$DoubleValue.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_config_ConfigValue$DoubleValue)) {
    var x$0$2 = $as_Llaika_api_config_ConfigValue$DoubleValue(x$0);
    return ((this.Llaika_api_config_ConfigValue$DoubleValue__f_value === $n(x$0$2).Llaika_api_config_ConfigValue$DoubleValue__f_value) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Llaika_api_config_ConfigValue$DoubleValue.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_config_ConfigValue$DoubleValue.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_api_config_ConfigValue$DoubleValue.prototype.productPrefix__T = (function() {
  return "DoubleValue";
});
$c_Llaika_api_config_ConfigValue$DoubleValue.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_config_ConfigValue$DoubleValue__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_api_config_ConfigValue$DoubleValue.prototype.render__T = (function() {
  var this$1 = this.Llaika_api_config_ConfigValue$DoubleValue__f_value;
  return ("" + this$1);
});
function $as_Llaika_api_config_ConfigValue$DoubleValue(obj) {
  return (((obj instanceof $c_Llaika_api_config_ConfigValue$DoubleValue) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.ConfigValue$DoubleValue"));
}
function $isArrayOf_Llaika_api_config_ConfigValue$DoubleValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_ConfigValue$DoubleValue)));
}
function $asArrayOf_Llaika_api_config_ConfigValue$DoubleValue(obj, depth) {
  return (($isArrayOf_Llaika_api_config_ConfigValue$DoubleValue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.ConfigValue$DoubleValue;", depth));
}
var $d_Llaika_api_config_ConfigValue$DoubleValue = new $TypeData().initClass($c_Llaika_api_config_ConfigValue$DoubleValue, "laika.api.config.ConfigValue$DoubleValue", ({
  Llaika_api_config_ConfigValue$DoubleValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_api_config_ConfigValue: 1,
  Llaika_api_config_ConfigValue$SimpleValue: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigValue$LongValue(value) {
  this.Llaika_api_config_ConfigValue$LongValue__f_value = $L0;
  this.Llaika_api_config_ConfigValue$LongValue__f_value = value;
}
$c_Llaika_api_config_ConfigValue$LongValue.prototype = new $h_O();
$c_Llaika_api_config_ConfigValue$LongValue.prototype.constructor = $c_Llaika_api_config_ConfigValue$LongValue;
/** @constructor */
function $h_Llaika_api_config_ConfigValue$LongValue() {
}
$h_Llaika_api_config_ConfigValue$LongValue.prototype = $c_Llaika_api_config_ConfigValue$LongValue.prototype;
$c_Llaika_api_config_ConfigValue$LongValue.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_ConfigValue$LongValue.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("LongValue");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var t = this.Llaika_api_config_ConfigValue$LongValue__f_value;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var data$1 = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi));
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1);
});
$c_Llaika_api_config_ConfigValue$LongValue.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_config_ConfigValue$LongValue)) {
    var x$0$2 = $as_Llaika_api_config_ConfigValue$LongValue(x$0);
    var this$1 = this.Llaika_api_config_ConfigValue$LongValue__f_value;
    var b = $n(x$0$2).Llaika_api_config_ConfigValue$LongValue__f_value;
    if (((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_config_ConfigValue$LongValue.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_config_ConfigValue$LongValue.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_api_config_ConfigValue$LongValue.prototype.productPrefix__T = (function() {
  return "LongValue";
});
$c_Llaika_api_config_ConfigValue$LongValue.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_config_ConfigValue$LongValue__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_api_config_ConfigValue$LongValue.prototype.render__T = (function() {
  var this$1 = this.Llaika_api_config_ConfigValue$LongValue__f_value;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this$1.RTLong__f_lo, this$1.RTLong__f_hi);
});
function $as_Llaika_api_config_ConfigValue$LongValue(obj) {
  return (((obj instanceof $c_Llaika_api_config_ConfigValue$LongValue) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.ConfigValue$LongValue"));
}
function $isArrayOf_Llaika_api_config_ConfigValue$LongValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_ConfigValue$LongValue)));
}
function $asArrayOf_Llaika_api_config_ConfigValue$LongValue(obj, depth) {
  return (($isArrayOf_Llaika_api_config_ConfigValue$LongValue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.ConfigValue$LongValue;", depth));
}
var $d_Llaika_api_config_ConfigValue$LongValue = new $TypeData().initClass($c_Llaika_api_config_ConfigValue$LongValue, "laika.api.config.ConfigValue$LongValue", ({
  Llaika_api_config_ConfigValue$LongValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_api_config_ConfigValue: 1,
  Llaika_api_config_ConfigValue$SimpleValue: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigValue$StringValue(value) {
  this.Llaika_api_config_ConfigValue$StringValue__f_value = null;
  this.Llaika_api_config_ConfigValue$StringValue__f_value = value;
}
$c_Llaika_api_config_ConfigValue$StringValue.prototype = new $h_O();
$c_Llaika_api_config_ConfigValue$StringValue.prototype.constructor = $c_Llaika_api_config_ConfigValue$StringValue;
/** @constructor */
function $h_Llaika_api_config_ConfigValue$StringValue() {
}
$h_Llaika_api_config_ConfigValue$StringValue.prototype = $c_Llaika_api_config_ConfigValue$StringValue.prototype;
$c_Llaika_api_config_ConfigValue$StringValue.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_ConfigValue$StringValue.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_config_ConfigValue$StringValue.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_config_ConfigValue$StringValue)) {
    var x$0$2 = $as_Llaika_api_config_ConfigValue$StringValue(x$0);
    return ((this.Llaika_api_config_ConfigValue$StringValue__f_value === $n(x$0$2).Llaika_api_config_ConfigValue$StringValue__f_value) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Llaika_api_config_ConfigValue$StringValue.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_config_ConfigValue$StringValue.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_api_config_ConfigValue$StringValue.prototype.productPrefix__T = (function() {
  return "StringValue";
});
$c_Llaika_api_config_ConfigValue$StringValue.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_config_ConfigValue$StringValue__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_api_config_ConfigValue$StringValue.prototype.render__T = (function() {
  return this.Llaika_api_config_ConfigValue$StringValue__f_value;
});
function $as_Llaika_api_config_ConfigValue$StringValue(obj) {
  return (((obj instanceof $c_Llaika_api_config_ConfigValue$StringValue) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.config.ConfigValue$StringValue"));
}
function $isArrayOf_Llaika_api_config_ConfigValue$StringValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_config_ConfigValue$StringValue)));
}
function $asArrayOf_Llaika_api_config_ConfigValue$StringValue(obj, depth) {
  return (($isArrayOf_Llaika_api_config_ConfigValue$StringValue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.config.ConfigValue$StringValue;", depth));
}
var $d_Llaika_api_config_ConfigValue$StringValue = new $TypeData().initClass($c_Llaika_api_config_ConfigValue$StringValue, "laika.api.config.ConfigValue$StringValue", ({
  Llaika_api_config_ConfigValue$StringValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_api_config_ConfigValue: 1,
  Llaika_api_config_ConfigValue$SimpleValue: 1
}));
/** @constructor */
function $c_Llaika_api_errors_InvalidElements(elements) {
  this.Llaika_api_errors_InvalidElements__f_elements = null;
  this.Llaika_api_errors_InvalidElements__f_elements = elements;
  var tc = $as_Lcats_Functor($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
  var this$2 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(elements, tc);
  var f = new $c_sjsr_AnonFunction1(((_$1) => {
    var _$1$1 = $as_Llaika_ast_Invalid(_$1);
    return $m_Llaika_api_errors_InvalidDocument$().formatElement__T__Llaika_ast_Invalid__T("", _$1$1);
  }));
  var target = $n(this$2.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$2.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  var tc$1 = $as_Lcats_Foldable($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
  var this$4 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(target, tc$1);
  var this$5 = $n($n(this$4.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).toList__O__sci_List(this$4.Lcats_Foldable$ToFoldableOps$$anon$6__f_self));
  var formatted = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$5, "", "", "");
  $f_T__trim__T(("One or more error nodes in result:\n" + formatted));
}
$c_Llaika_api_errors_InvalidElements.prototype = new $h_O();
$c_Llaika_api_errors_InvalidElements.prototype.constructor = $c_Llaika_api_errors_InvalidElements;
/** @constructor */
function $h_Llaika_api_errors_InvalidElements() {
}
$h_Llaika_api_errors_InvalidElements.prototype = $c_Llaika_api_errors_InvalidElements.prototype;
$c_Llaika_api_errors_InvalidElements.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_errors_InvalidElements.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_errors_InvalidElements.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_errors_InvalidElements)) {
    var x$0$2 = $as_Llaika_api_errors_InvalidElements(x$0);
    var x = this.Llaika_api_errors_InvalidElements__f_elements;
    var y = $n(x$0$2).Llaika_api_errors_InvalidElements__f_elements;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_errors_InvalidElements.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_errors_InvalidElements.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_api_errors_InvalidElements.prototype.productPrefix__T = (function() {
  return "InvalidElements";
});
$c_Llaika_api_errors_InvalidElements.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_errors_InvalidElements__f_elements;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_api_errors_InvalidElements(obj) {
  return (((obj instanceof $c_Llaika_api_errors_InvalidElements) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.errors.InvalidElements"));
}
function $isArrayOf_Llaika_api_errors_InvalidElements(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_errors_InvalidElements)));
}
function $asArrayOf_Llaika_api_errors_InvalidElements(obj, depth) {
  return (($isArrayOf_Llaika_api_errors_InvalidElements(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.errors.InvalidElements;", depth));
}
var $d_Llaika_api_errors_InvalidElements = new $TypeData().initClass($c_Llaika_api_errors_InvalidElements, "laika.api.errors.InvalidElements", ({
  Llaika_api_errors_InvalidElements: 1,
  Llaika_api_errors_TransformationError: 1,
  Llaika_api_errors_ParserError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_errors_InvalidInput(error) {
  this.Llaika_api_errors_InvalidInput__f_error = null;
  this.Llaika_api_errors_InvalidInput__f_error = error;
  $n(error).message__T();
}
$c_Llaika_api_errors_InvalidInput.prototype = new $h_O();
$c_Llaika_api_errors_InvalidInput.prototype.constructor = $c_Llaika_api_errors_InvalidInput;
/** @constructor */
function $h_Llaika_api_errors_InvalidInput() {
}
$h_Llaika_api_errors_InvalidInput.prototype = $c_Llaika_api_errors_InvalidInput.prototype;
$c_Llaika_api_errors_InvalidInput.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_errors_InvalidInput.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_errors_InvalidInput.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_errors_InvalidInput)) {
    var x$0$2 = $as_Llaika_api_errors_InvalidInput(x$0);
    var x = this.Llaika_api_errors_InvalidInput__f_error;
    var x$2 = $n(x$0$2).Llaika_api_errors_InvalidInput__f_error;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_errors_InvalidInput.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_errors_InvalidInput.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_api_errors_InvalidInput.prototype.productPrefix__T = (function() {
  return "InvalidInput";
});
$c_Llaika_api_errors_InvalidInput.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_errors_InvalidInput__f_error;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_api_errors_InvalidInput(obj) {
  return (((obj instanceof $c_Llaika_api_errors_InvalidInput) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.errors.InvalidInput"));
}
function $isArrayOf_Llaika_api_errors_InvalidInput(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_errors_InvalidInput)));
}
function $asArrayOf_Llaika_api_errors_InvalidInput(obj, depth) {
  return (($isArrayOf_Llaika_api_errors_InvalidInput(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.errors.InvalidInput;", depth));
}
var $d_Llaika_api_errors_InvalidInput = new $TypeData().initClass($c_Llaika_api_errors_InvalidInput, "laika.api.errors.InvalidInput", ({
  Llaika_api_errors_InvalidInput: 1,
  Llaika_api_errors_TransformationError: 1,
  Llaika_api_errors_ParserError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_Column(options) {
  this.Llaika_ast_Column__f_options = null;
  this.Llaika_ast_Column__f_options = options;
}
$c_Llaika_ast_Column.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_Column.prototype.constructor = $c_Llaika_ast_Column;
/** @constructor */
function $h_Llaika_ast_Column() {
}
$h_Llaika_ast_Column.prototype = $c_Llaika_ast_Column.prototype;
$c_Llaika_ast_Column.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_Column.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_Column)) {
    var x$0$2 = $as_Llaika_ast_Column(x$0);
    var x = this.Llaika_ast_Column__f_options;
    var x$2 = $n(x$0$2).Llaika_ast_Column__f_options;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_Column.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_Column.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_ast_Column.prototype.productPrefix__T = (function() {
  return "Column";
});
$c_Llaika_ast_Column.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_Column__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_Column.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_Column__f_options;
});
$c_Llaika_ast_Column.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  return new $c_Llaika_ast_Column(options);
});
function $as_Llaika_ast_Column(obj) {
  return (((obj instanceof $c_Llaika_ast_Column) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Column"));
}
function $isArrayOf_Llaika_ast_Column(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Column)));
}
function $asArrayOf_Llaika_ast_Column(obj, depth) {
  return (($isArrayOf_Llaika_ast_Column(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Column;", depth));
}
var $d_Llaika_ast_Column = new $TypeData().initClass($c_Llaika_ast_Column, "laika.ast.Column", ({
  Llaika_ast_Column: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_TableElement: 1
}));
/** @constructor */
function $c_Llaika_ast_DocumentFragment(name, root, options) {
  this.Llaika_ast_DocumentFragment__f_name = null;
  this.Llaika_ast_DocumentFragment__f_root = null;
  this.Llaika_ast_DocumentFragment__f_options = null;
  this.Llaika_ast_DocumentFragment__f_name = name;
  this.Llaika_ast_DocumentFragment__f_root = root;
  this.Llaika_ast_DocumentFragment__f_options = options;
}
$c_Llaika_ast_DocumentFragment.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_DocumentFragment.prototype.constructor = $c_Llaika_ast_DocumentFragment;
/** @constructor */
function $h_Llaika_ast_DocumentFragment() {
}
$h_Llaika_ast_DocumentFragment.prototype = $c_Llaika_ast_DocumentFragment.prototype;
$c_Llaika_ast_DocumentFragment.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_DocumentFragment.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_DocumentFragment)) {
    var x$0$2 = $as_Llaika_ast_DocumentFragment(x$0);
    if ((this.Llaika_ast_DocumentFragment__f_name === $n(x$0$2).Llaika_ast_DocumentFragment__f_name)) {
      var x = this.Llaika_ast_DocumentFragment__f_root;
      var x$2 = $n(x$0$2).Llaika_ast_DocumentFragment__f_root;
      var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Llaika_ast_DocumentFragment__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_DocumentFragment__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_DocumentFragment.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_DocumentFragment.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_DocumentFragment.prototype.productPrefix__T = (function() {
  return "DocumentFragment";
});
$c_Llaika_ast_DocumentFragment.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_DocumentFragment__f_name;
      break;
    }
    case 1: {
      return this.Llaika_ast_DocumentFragment__f_root;
      break;
    }
    case 2: {
      return this.Llaika_ast_DocumentFragment__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_DocumentFragment.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_DocumentFragment__f_options;
});
$c_Llaika_ast_DocumentFragment.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var name = this.Llaika_ast_DocumentFragment__f_name;
  var root = this.Llaika_ast_DocumentFragment__f_root;
  return new $c_Llaika_ast_DocumentFragment(name, root, options);
});
function $as_Llaika_ast_DocumentFragment(obj) {
  return (((obj instanceof $c_Llaika_ast_DocumentFragment) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.DocumentFragment"));
}
function $isArrayOf_Llaika_ast_DocumentFragment(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_DocumentFragment)));
}
function $asArrayOf_Llaika_ast_DocumentFragment(obj, depth) {
  return (($isArrayOf_Llaika_ast_DocumentFragment(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.DocumentFragment;", depth));
}
var $d_Llaika_ast_DocumentFragment = new $TypeData().initClass($c_Llaika_ast_DocumentFragment, "laika.ast.DocumentFragment", ({
  Llaika_ast_DocumentFragment: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1
}));
function $as_Llaika_ast_DocumentTreeBuilder$ConfigPart(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.DocumentTreeBuilder$ConfigPart"));
}
function $isArrayOf_Llaika_ast_DocumentTreeBuilder$ConfigPart(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_DocumentTreeBuilder$ConfigPart)));
}
function $asArrayOf_Llaika_ast_DocumentTreeBuilder$ConfigPart(obj, depth) {
  return (($isArrayOf_Llaika_ast_DocumentTreeBuilder$ConfigPart(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.DocumentTreeBuilder$ConfigPart;", depth));
}
function $as_Llaika_ast_DocumentTreeBuilder$HoconPart(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.DocumentTreeBuilder$HoconPart"));
}
function $isArrayOf_Llaika_ast_DocumentTreeBuilder$HoconPart(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_DocumentTreeBuilder$HoconPart)));
}
function $asArrayOf_Llaika_ast_DocumentTreeBuilder$HoconPart(obj, depth) {
  return (($isArrayOf_Llaika_ast_DocumentTreeBuilder$HoconPart(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.DocumentTreeBuilder$HoconPart;", depth));
}
function $as_Llaika_ast_DocumentTreeBuilder$TemplatePart(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.DocumentTreeBuilder$TemplatePart"));
}
function $isArrayOf_Llaika_ast_DocumentTreeBuilder$TemplatePart(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_DocumentTreeBuilder$TemplatePart)));
}
function $asArrayOf_Llaika_ast_DocumentTreeBuilder$TemplatePart(obj, depth) {
  return (($isArrayOf_Llaika_ast_DocumentTreeBuilder$TemplatePart(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.DocumentTreeBuilder$TemplatePart;", depth));
}
/** @constructor */
function $c_Llaika_ast_DocumentType$StyleSheet(format) {
  this.Llaika_ast_DocumentType$StyleSheet__f_format = null;
  this.Llaika_ast_DocumentType$StyleSheet__f_format = format;
}
$c_Llaika_ast_DocumentType$StyleSheet.prototype = new $h_Llaika_ast_TextDocumentType();
$c_Llaika_ast_DocumentType$StyleSheet.prototype.constructor = $c_Llaika_ast_DocumentType$StyleSheet;
/** @constructor */
function $h_Llaika_ast_DocumentType$StyleSheet() {
}
$h_Llaika_ast_DocumentType$StyleSheet.prototype = $c_Llaika_ast_DocumentType$StyleSheet.prototype;
$c_Llaika_ast_DocumentType$StyleSheet.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_DocumentType$StyleSheet.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_DocumentType$StyleSheet)) {
    var x$0$2 = $as_Llaika_ast_DocumentType$StyleSheet(x$0);
    return ((this.Llaika_ast_DocumentType$StyleSheet__f_format === $n(x$0$2).Llaika_ast_DocumentType$StyleSheet__f_format) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Llaika_ast_DocumentType$StyleSheet.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_DocumentType$StyleSheet.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_ast_DocumentType$StyleSheet.prototype.productPrefix__T = (function() {
  return "StyleSheet";
});
$c_Llaika_ast_DocumentType$StyleSheet.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_DocumentType$StyleSheet__f_format;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_ast_DocumentType$StyleSheet(obj) {
  return (((obj instanceof $c_Llaika_ast_DocumentType$StyleSheet) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.DocumentType$StyleSheet"));
}
function $isArrayOf_Llaika_ast_DocumentType$StyleSheet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_DocumentType$StyleSheet)));
}
function $asArrayOf_Llaika_ast_DocumentType$StyleSheet(obj, depth) {
  return (($isArrayOf_Llaika_ast_DocumentType$StyleSheet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.DocumentType$StyleSheet;", depth));
}
var $d_Llaika_ast_DocumentType$StyleSheet = new $TypeData().initClass($c_Llaika_ast_DocumentType$StyleSheet, "laika.ast.DocumentType$StyleSheet", ({
  Llaika_ast_DocumentType$StyleSheet: 1,
  Llaika_ast_TextDocumentType: 1,
  Llaika_ast_DocumentType: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_InternalTarget$Absolute(path) {
  this.Llaika_ast_InternalTarget$Absolute__f_path = null;
  this.Llaika_ast_InternalTarget$Absolute__f_path = path;
}
$c_Llaika_ast_InternalTarget$Absolute.prototype = new $h_O();
$c_Llaika_ast_InternalTarget$Absolute.prototype.constructor = $c_Llaika_ast_InternalTarget$Absolute;
/** @constructor */
function $h_Llaika_ast_InternalTarget$Absolute() {
}
$h_Llaika_ast_InternalTarget$Absolute.prototype = $c_Llaika_ast_InternalTarget$Absolute.prototype;
$c_Llaika_ast_InternalTarget$Absolute.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_InternalTarget$Absolute.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_InternalTarget$Absolute.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_InternalTarget$Absolute)) {
    var x$0$2 = $as_Llaika_ast_InternalTarget$Absolute(x$0);
    var x = this.Llaika_ast_InternalTarget$Absolute__f_path;
    var x$2 = $n(x$0$2).Llaika_ast_InternalTarget$Absolute__f_path;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_InternalTarget$Absolute.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_InternalTarget$Absolute.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_ast_InternalTarget$Absolute.prototype.productPrefix__T = (function() {
  return "Absolute";
});
$c_Llaika_ast_InternalTarget$Absolute.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_InternalTarget$Absolute__f_path;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_InternalTarget$Absolute.prototype.relativeTo__Llaika_ast_Path__Llaika_ast_InternalTarget$Resolved = (function(refPath) {
  var absolutePath = this.Llaika_ast_InternalTarget$Absolute__f_path;
  var relativePath = $n(this.Llaika_ast_InternalTarget$Absolute__f_path).relativeTo__Llaika_ast_Path__Llaika_ast_RelativePath(refPath);
  var internalFormats = $m_Llaika_config_TargetFormats$All$();
  return new $c_Llaika_ast_InternalTarget$Resolved(absolutePath, relativePath, internalFormats);
});
$c_Llaika_ast_InternalTarget$Absolute.prototype.render__Z__T = (function(internalTargetsAbsolute) {
  return $n(this.Llaika_ast_InternalTarget$Absolute__f_path).toString__T();
});
$c_Llaika_ast_InternalTarget$Absolute.prototype.render$default$1__Z = (function() {
  return false;
});
function $as_Llaika_ast_InternalTarget$Absolute(obj) {
  return (((obj instanceof $c_Llaika_ast_InternalTarget$Absolute) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.InternalTarget$Absolute"));
}
function $isArrayOf_Llaika_ast_InternalTarget$Absolute(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_InternalTarget$Absolute)));
}
function $asArrayOf_Llaika_ast_InternalTarget$Absolute(obj, depth) {
  return (($isArrayOf_Llaika_ast_InternalTarget$Absolute(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.InternalTarget$Absolute;", depth));
}
var $d_Llaika_ast_InternalTarget$Absolute = new $TypeData().initClass($c_Llaika_ast_InternalTarget$Absolute, "laika.ast.InternalTarget$Absolute", ({
  Llaika_ast_InternalTarget$Absolute: 1,
  Llaika_ast_Target: 1,
  Llaika_ast_InternalTarget: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_InternalTarget$Relative(path) {
  this.Llaika_ast_InternalTarget$Relative__f_path = null;
  this.Llaika_ast_InternalTarget$Relative__f_path = path;
}
$c_Llaika_ast_InternalTarget$Relative.prototype = new $h_O();
$c_Llaika_ast_InternalTarget$Relative.prototype.constructor = $c_Llaika_ast_InternalTarget$Relative;
/** @constructor */
function $h_Llaika_ast_InternalTarget$Relative() {
}
$h_Llaika_ast_InternalTarget$Relative.prototype = $c_Llaika_ast_InternalTarget$Relative.prototype;
$c_Llaika_ast_InternalTarget$Relative.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_InternalTarget$Relative.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_InternalTarget$Relative.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_InternalTarget$Relative)) {
    var x$0$2 = $as_Llaika_ast_InternalTarget$Relative(x$0);
    var x = this.Llaika_ast_InternalTarget$Relative__f_path;
    var x$2 = $n(x$0$2).Llaika_ast_InternalTarget$Relative__f_path;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_InternalTarget$Relative.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_InternalTarget$Relative.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_ast_InternalTarget$Relative.prototype.productPrefix__T = (function() {
  return "Relative";
});
$c_Llaika_ast_InternalTarget$Relative.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_InternalTarget$Relative__f_path;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_InternalTarget$Relative.prototype.relativeTo__Llaika_ast_Path__Llaika_ast_InternalTarget$Resolved = (function(refPath) {
  var x20 = this.Llaika_ast_InternalTarget$Relative__f_path;
  if ((x20 instanceof $c_Llaika_ast_RelativePath$CurrentDocument)) {
    var p = $as_Llaika_ast_RelativePath$CurrentDocument(x20);
    var this$1 = $n(refPath);
    var absolutePath = this$1.$div__Llaika_ast_RelativePath__Llaika_ast_Path(p);
    var internalFormats = $m_Llaika_config_TargetFormats$All$();
    return new $c_Llaika_ast_InternalTarget$Resolved(absolutePath, p, internalFormats);
  }
  if ((x20 !== null)) {
    var this$4 = $n($n(refPath).parent__Llaika_ast_Path());
    var absolutePath$1 = this$4.$div__Llaika_ast_RelativePath__Llaika_ast_Path(x20);
    var internalFormats$1 = $m_Llaika_config_TargetFormats$All$();
    return new $c_Llaika_ast_InternalTarget$Resolved(absolutePath$1, x20, internalFormats$1);
  }
  throw new $c_s_MatchError(x20);
});
$c_Llaika_ast_InternalTarget$Relative.prototype.render__Z__T = (function(internalTargetsAbsolute) {
  return $n(this.Llaika_ast_InternalTarget$Relative__f_path).toString__T();
});
$c_Llaika_ast_InternalTarget$Relative.prototype.render$default$1__Z = (function() {
  return false;
});
function $as_Llaika_ast_InternalTarget$Relative(obj) {
  return (((obj instanceof $c_Llaika_ast_InternalTarget$Relative) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.InternalTarget$Relative"));
}
function $isArrayOf_Llaika_ast_InternalTarget$Relative(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_InternalTarget$Relative)));
}
function $asArrayOf_Llaika_ast_InternalTarget$Relative(obj, depth) {
  return (($isArrayOf_Llaika_ast_InternalTarget$Relative(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.InternalTarget$Relative;", depth));
}
var $d_Llaika_ast_InternalTarget$Relative = new $TypeData().initClass($c_Llaika_ast_InternalTarget$Relative, "laika.ast.InternalTarget$Relative", ({
  Llaika_ast_InternalTarget$Relative: 1,
  Llaika_ast_Target: 1,
  Llaika_ast_InternalTarget: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_InternalTarget$Resolved(absolutePath, relativePath, internalFormats) {
  this.Llaika_ast_InternalTarget$Resolved__f_absolutePath = null;
  this.Llaika_ast_InternalTarget$Resolved__f_relativePath = null;
  this.Llaika_ast_InternalTarget$Resolved__f_internalFormats = null;
  this.Llaika_ast_InternalTarget$Resolved__f_absolutePath = absolutePath;
  this.Llaika_ast_InternalTarget$Resolved__f_relativePath = relativePath;
  this.Llaika_ast_InternalTarget$Resolved__f_internalFormats = internalFormats;
}
$c_Llaika_ast_InternalTarget$Resolved.prototype = new $h_O();
$c_Llaika_ast_InternalTarget$Resolved.prototype.constructor = $c_Llaika_ast_InternalTarget$Resolved;
/** @constructor */
function $h_Llaika_ast_InternalTarget$Resolved() {
}
$h_Llaika_ast_InternalTarget$Resolved.prototype = $c_Llaika_ast_InternalTarget$Resolved.prototype;
$c_Llaika_ast_InternalTarget$Resolved.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_InternalTarget$Resolved.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_InternalTarget$Resolved.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_InternalTarget$Resolved)) {
    var x$0$2 = $as_Llaika_ast_InternalTarget$Resolved(x$0);
    var x = this.Llaika_ast_InternalTarget$Resolved__f_absolutePath;
    var x$2 = $n(x$0$2).Llaika_ast_InternalTarget$Resolved__f_absolutePath;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_InternalTarget$Resolved__f_relativePath;
      var x$4 = $n(x$0$2).Llaika_ast_InternalTarget$Resolved__f_relativePath;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llaika_ast_InternalTarget$Resolved__f_internalFormats;
      var x$6 = $n(x$0$2).Llaika_ast_InternalTarget$Resolved__f_internalFormats;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_InternalTarget$Resolved.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_InternalTarget$Resolved.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_InternalTarget$Resolved.prototype.productPrefix__T = (function() {
  return "Resolved";
});
$c_Llaika_ast_InternalTarget$Resolved.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_InternalTarget$Resolved__f_absolutePath;
      break;
    }
    case 1: {
      return this.Llaika_ast_InternalTarget$Resolved__f_relativePath;
      break;
    }
    case 2: {
      return this.Llaika_ast_InternalTarget$Resolved__f_internalFormats;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_InternalTarget$Resolved.prototype.relativeTo__Llaika_ast_Path__Llaika_ast_InternalTarget$Resolved = (function(refPath) {
  var absolutePath = this.Llaika_ast_InternalTarget$Resolved__f_absolutePath;
  var relativePath = $n(this.Llaika_ast_InternalTarget$Resolved__f_absolutePath).relativeTo__Llaika_ast_Path__Llaika_ast_RelativePath(refPath);
  var internalFormats = $m_Llaika_config_TargetFormats$All$();
  return new $c_Llaika_ast_InternalTarget$Resolved(absolutePath, relativePath, internalFormats);
});
$c_Llaika_ast_InternalTarget$Resolved.prototype.render__Z__T = (function(internalTargetsAbsolute) {
  return (internalTargetsAbsolute ? $n(this.Llaika_ast_InternalTarget$Resolved__f_absolutePath).toString__T() : $n(this.Llaika_ast_InternalTarget$Resolved__f_relativePath).toString__T());
});
$c_Llaika_ast_InternalTarget$Resolved.prototype.render$default$1__Z = (function() {
  return false;
});
function $as_Llaika_ast_InternalTarget$Resolved(obj) {
  return (((obj instanceof $c_Llaika_ast_InternalTarget$Resolved) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.InternalTarget$Resolved"));
}
function $isArrayOf_Llaika_ast_InternalTarget$Resolved(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_InternalTarget$Resolved)));
}
function $asArrayOf_Llaika_ast_InternalTarget$Resolved(obj, depth) {
  return (($isArrayOf_Llaika_ast_InternalTarget$Resolved(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.InternalTarget$Resolved;", depth));
}
var $d_Llaika_ast_InternalTarget$Resolved = new $TypeData().initClass($c_Llaika_ast_InternalTarget$Resolved, "laika.ast.InternalTarget$Resolved", ({
  Llaika_ast_InternalTarget$Resolved: 1,
  Llaika_ast_Target: 1,
  Llaika_ast_InternalTarget: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_ast_LineBreak(options) {
  this.Llaika_ast_LineBreak__f_options = null;
  this.Llaika_ast_LineBreak__f_options = options;
}
$c_Llaika_ast_LineBreak.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_LineBreak.prototype.constructor = $c_Llaika_ast_LineBreak;
/** @constructor */
function $h_Llaika_ast_LineBreak() {
}
$h_Llaika_ast_LineBreak.prototype = $c_Llaika_ast_LineBreak.prototype;
$c_Llaika_ast_LineBreak.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_LineBreak.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_LineBreak)) {
    var x$0$2 = $as_Llaika_ast_LineBreak(x$0);
    var x = this.Llaika_ast_LineBreak__f_options;
    var x$2 = $n(x$0$2).Llaika_ast_LineBreak__f_options;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_LineBreak.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_LineBreak.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_ast_LineBreak.prototype.productPrefix__T = (function() {
  return "LineBreak";
});
$c_Llaika_ast_LineBreak.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_LineBreak__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_LineBreak.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_LineBreak__f_options;
});
$c_Llaika_ast_LineBreak.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  return new $c_Llaika_ast_LineBreak(options);
});
function $as_Llaika_ast_LineBreak(obj) {
  return (((obj instanceof $c_Llaika_ast_LineBreak) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.LineBreak"));
}
function $isArrayOf_Llaika_ast_LineBreak(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_LineBreak)));
}
function $asArrayOf_Llaika_ast_LineBreak(obj, depth) {
  return (($isArrayOf_Llaika_ast_LineBreak(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.LineBreak;", depth));
}
var $d_Llaika_ast_LineBreak = new $TypeData().initClass($c_Llaika_ast_LineBreak, "laika.ast.LineBreak", ({
  Llaika_ast_LineBreak: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1
}));
/** @constructor */
function $c_Llaika_ast_PageBreak(options) {
  this.Llaika_ast_PageBreak__f_options = null;
  this.Llaika_ast_PageBreak__f_options = options;
}
$c_Llaika_ast_PageBreak.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_PageBreak.prototype.constructor = $c_Llaika_ast_PageBreak;
/** @constructor */
function $h_Llaika_ast_PageBreak() {
}
$h_Llaika_ast_PageBreak.prototype = $c_Llaika_ast_PageBreak.prototype;
$c_Llaika_ast_PageBreak.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_PageBreak.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_PageBreak)) {
    var x$0$2 = $as_Llaika_ast_PageBreak(x$0);
    var x = this.Llaika_ast_PageBreak__f_options;
    var x$2 = $n(x$0$2).Llaika_ast_PageBreak__f_options;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_PageBreak.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_PageBreak.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_ast_PageBreak.prototype.productPrefix__T = (function() {
  return "PageBreak";
});
$c_Llaika_ast_PageBreak.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_PageBreak__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_PageBreak.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_PageBreak__f_options;
});
$c_Llaika_ast_PageBreak.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  return new $c_Llaika_ast_PageBreak(options);
});
function $as_Llaika_ast_PageBreak(obj) {
  return (((obj instanceof $c_Llaika_ast_PageBreak) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.PageBreak"));
}
function $isArrayOf_Llaika_ast_PageBreak(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_PageBreak)));
}
function $asArrayOf_Llaika_ast_PageBreak(obj, depth) {
  return (($isArrayOf_Llaika_ast_PageBreak(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.PageBreak;", depth));
}
var $d_Llaika_ast_PageBreak = new $TypeData().initClass($c_Llaika_ast_PageBreak, "laika.ast.PageBreak", ({
  Llaika_ast_PageBreak: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1
}));
function $is_Llaika_ast_Path(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_Path)));
}
function $as_Llaika_ast_Path(obj) {
  return (($is_Llaika_ast_Path(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Path"));
}
function $isArrayOf_Llaika_ast_Path(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Path)));
}
function $asArrayOf_Llaika_ast_Path(obj, depth) {
  return (($isArrayOf_Llaika_ast_Path(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Path;", depth));
}
var $d_Llaika_ast_Path = new $TypeData().initClass(1, "laika.ast.Path", ({
  Llaika_ast_Path: 1,
  Llaika_ast_GenericPath: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_VirtualPath: 1
}));
function $is_Llaika_ast_RelativePath(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llaika_ast_RelativePath)));
}
function $as_Llaika_ast_RelativePath(obj) {
  return (($is_Llaika_ast_RelativePath(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.RelativePath"));
}
function $isArrayOf_Llaika_ast_RelativePath(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_RelativePath)));
}
function $asArrayOf_Llaika_ast_RelativePath(obj, depth) {
  return (($isArrayOf_Llaika_ast_RelativePath(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.RelativePath;", depth));
}
/** @constructor */
function $c_Llaika_ast_Reverse(length, target, fallback, options) {
  this.Llaika_ast_Reverse__f_length = 0;
  this.Llaika_ast_Reverse__f_target = null;
  this.Llaika_ast_Reverse__f_fallback = null;
  this.Llaika_ast_Reverse__f_options = null;
  this.Llaika_ast_Reverse__f_length = length;
  this.Llaika_ast_Reverse__f_target = target;
  this.Llaika_ast_Reverse__f_fallback = fallback;
  this.Llaika_ast_Reverse__f_options = options;
}
$c_Llaika_ast_Reverse.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_Reverse.prototype.constructor = $c_Llaika_ast_Reverse;
/** @constructor */
function $h_Llaika_ast_Reverse() {
}
$h_Llaika_ast_Reverse.prototype = $c_Llaika_ast_Reverse.prototype;
$c_Llaika_ast_Reverse.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Reverse");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Llaika_ast_Reverse__f_length;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Llaika_ast_Reverse__f_target;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Llaika_ast_Reverse__f_fallback;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Llaika_ast_Reverse__f_options;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4);
});
$c_Llaika_ast_Reverse.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_Reverse)) {
    var x$0$2 = $as_Llaika_ast_Reverse(x$0);
    if ((this.Llaika_ast_Reverse__f_length === $n(x$0$2).Llaika_ast_Reverse__f_length)) {
      var x = this.Llaika_ast_Reverse__f_target;
      var x$2 = $n(x$0$2).Llaika_ast_Reverse__f_target;
      var $x_3 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.Llaika_ast_Reverse__f_fallback;
      var x$4 = $n(x$0$2).Llaika_ast_Reverse__f_fallback;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llaika_ast_Reverse__f_options;
      var x$6 = $n(x$0$2).Llaika_ast_Reverse__f_options;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_Reverse.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_Reverse.prototype.productArity__I = (function() {
  return 4;
});
$c_Llaika_ast_Reverse.prototype.productPrefix__T = (function() {
  return "Reverse";
});
$c_Llaika_ast_Reverse.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_Reverse__f_length;
      break;
    }
    case 1: {
      return this.Llaika_ast_Reverse__f_target;
      break;
    }
    case 2: {
      return this.Llaika_ast_Reverse__f_fallback;
      break;
    }
    case 3: {
      return this.Llaika_ast_Reverse__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_Reverse.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_Reverse__f_options;
});
$c_Llaika_ast_Reverse.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var length = this.Llaika_ast_Reverse__f_length;
  var target = this.Llaika_ast_Reverse__f_target;
  var fallback = this.Llaika_ast_Reverse__f_fallback;
  return new $c_Llaika_ast_Reverse(length, target, fallback, options);
});
function $as_Llaika_ast_Reverse(obj) {
  return (((obj instanceof $c_Llaika_ast_Reverse) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Reverse"));
}
function $isArrayOf_Llaika_ast_Reverse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Reverse)));
}
function $asArrayOf_Llaika_ast_Reverse(obj, depth) {
  return (($isArrayOf_Llaika_ast_Reverse(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Reverse;", depth));
}
var $d_Llaika_ast_Reverse = new $TypeData().initClass($c_Llaika_ast_Reverse, "laika.ast.Reverse", ({
  Llaika_ast_Reverse: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1
}));
/** @constructor */
function $c_Llaika_ast_Rule(options) {
  this.Llaika_ast_Rule__f_options = null;
  this.Llaika_ast_Rule__f_options = options;
}
$c_Llaika_ast_Rule.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_Rule.prototype.constructor = $c_Llaika_ast_Rule;
/** @constructor */
function $h_Llaika_ast_Rule() {
}
$h_Llaika_ast_Rule.prototype = $c_Llaika_ast_Rule.prototype;
$c_Llaika_ast_Rule.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_Rule.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_Rule)) {
    var x$0$2 = $as_Llaika_ast_Rule(x$0);
    var x = this.Llaika_ast_Rule__f_options;
    var x$2 = $n(x$0$2).Llaika_ast_Rule__f_options;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_Rule.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_Rule.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_ast_Rule.prototype.productPrefix__T = (function() {
  return "Rule";
});
$c_Llaika_ast_Rule.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_Rule__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_Rule.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_Rule__f_options;
});
$c_Llaika_ast_Rule.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  return new $c_Llaika_ast_Rule(options);
});
function $as_Llaika_ast_Rule(obj) {
  return (((obj instanceof $c_Llaika_ast_Rule) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Rule"));
}
function $isArrayOf_Llaika_ast_Rule(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Rule)));
}
function $asArrayOf_Llaika_ast_Rule(obj, depth) {
  return (($isArrayOf_Llaika_ast_Rule(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Rule;", depth));
}
var $d_Llaika_ast_Rule = new $TypeData().initClass($c_Llaika_ast_Rule, "laika.ast.Rule", ({
  Llaika_ast_Rule: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1
}));
/** @constructor */
function $c_Llaika_ast_TargetFormat(formats, element, options) {
  this.Llaika_ast_TargetFormat__f_formats = null;
  this.Llaika_ast_TargetFormat__f_element = null;
  this.Llaika_ast_TargetFormat__f_options = null;
  this.Llaika_ast_TargetFormat__f_formats = formats;
  this.Llaika_ast_TargetFormat__f_element = element;
  this.Llaika_ast_TargetFormat__f_options = options;
}
$c_Llaika_ast_TargetFormat.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_TargetFormat.prototype.constructor = $c_Llaika_ast_TargetFormat;
/** @constructor */
function $h_Llaika_ast_TargetFormat() {
}
$h_Llaika_ast_TargetFormat.prototype = $c_Llaika_ast_TargetFormat.prototype;
$c_Llaika_ast_TargetFormat.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_TargetFormat.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_TargetFormat)) {
    var x$0$2 = $as_Llaika_ast_TargetFormat(x$0);
    var x = this.Llaika_ast_TargetFormat__f_formats;
    var y = $n(x$0$2).Llaika_ast_TargetFormat__f_formats;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Llaika_ast_TargetFormat__f_element;
      var x$2 = $n(x$0$2).Llaika_ast_TargetFormat__f_element;
      var $x_2 = ((x$1 === null) ? (x$2 === null) : $n(x$1).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Llaika_ast_TargetFormat__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_TargetFormat__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_TargetFormat.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_TargetFormat.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_TargetFormat.prototype.productPrefix__T = (function() {
  return "TargetFormat";
});
$c_Llaika_ast_TargetFormat.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_TargetFormat__f_formats;
      break;
    }
    case 1: {
      return this.Llaika_ast_TargetFormat__f_element;
      break;
    }
    case 2: {
      return this.Llaika_ast_TargetFormat__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_TargetFormat.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_TargetFormat__f_options;
});
$c_Llaika_ast_TargetFormat.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var formats = this.Llaika_ast_TargetFormat__f_formats;
  var element = this.Llaika_ast_TargetFormat__f_element;
  return new $c_Llaika_ast_TargetFormat(formats, element, options);
});
function $as_Llaika_ast_TargetFormat(obj) {
  return (((obj instanceof $c_Llaika_ast_TargetFormat) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.TargetFormat"));
}
function $isArrayOf_Llaika_ast_TargetFormat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_TargetFormat)));
}
function $asArrayOf_Llaika_ast_TargetFormat(obj, depth) {
  return (($isArrayOf_Llaika_ast_TargetFormat(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.TargetFormat;", depth));
}
var $d_Llaika_ast_TargetFormat = new $TypeData().initClass($c_Llaika_ast_TargetFormat, "laika.ast.TargetFormat", ({
  Llaika_ast_TargetFormat: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1
}));
function $f_Llaika_ast_VirtualPath$Segments__name__T($thiz) {
  var this$1 = $n($thiz.suffix__s_Option());
  if (this$1.isEmpty__Z()) {
    $m_Lcats_data_NonEmptyChainImpl$();
    var value = $thiz.segments__O();
    var $x_1 = $as_T($m_Lcats_data_NonEmptyChainOps$().last$extension__O__O(value));
  } else {
    var arg1 = this$1.get__O();
    var suf = $as_T(arg1);
    $m_Lcats_data_NonEmptyChainImpl$();
    var value$1 = $thiz.segments__O();
    var $x_1 = (($as_T($m_Lcats_data_NonEmptyChainOps$().last$extension__O__O(value$1)) + ".") + suf);
  }
  return $as_T($x_1);
}
function $f_Llaika_ast_VirtualPath$Segments__basename__T($thiz) {
  $m_Lcats_data_NonEmptyChainImpl$();
  var value = $thiz.segments__O();
  return $as_T($m_Lcats_data_NonEmptyChainOps$().last$extension__O__O(value));
}
function $f_Llaika_ast_VirtualPath$Segments__toString__T($thiz) {
  var $x_4 = $thiz.pathPrefix__T();
  var target = $thiz.segments__O();
  var tc = $as_Lcats_Foldable($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
  var this$2 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(target, tc);
  var this$3 = $n($n(this$2.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).toList__O__sci_List(this$2.Lcats_Foldable$ToFoldableOps$$anon$6__f_self));
  var $x_3 = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$3, "", "/", "");
  var this$4 = $n($thiz.suffix__s_Option());
  if (this$4.isEmpty__Z()) {
    var $x_2 = "";
  } else {
    var arg1 = this$4.get__O();
    var _$1 = $as_T(arg1);
    var $x_2 = ("." + _$1);
  }
  var this$5 = $n($thiz.fragment__s_Option());
  if (this$5.isEmpty__Z()) {
    var $x_1 = "";
  } else {
    var arg1$1 = this$5.get__O();
    var _$2 = $as_T(arg1$1);
    var $x_1 = ("#" + _$2);
  }
  return (((("" + $x_4) + $x_3) + $x_2) + $x_1);
}
/** @constructor */
function $c_Llaika_ast_html_HTMLBlock(root, options) {
  this.Llaika_ast_html_HTMLBlock__f_root = null;
  this.Llaika_ast_html_HTMLBlock__f_options = null;
  this.Llaika_ast_html_HTMLBlock__f_root = root;
  this.Llaika_ast_html_HTMLBlock__f_options = options;
}
$c_Llaika_ast_html_HTMLBlock.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_html_HTMLBlock.prototype.constructor = $c_Llaika_ast_html_HTMLBlock;
/** @constructor */
function $h_Llaika_ast_html_HTMLBlock() {
}
$h_Llaika_ast_html_HTMLBlock.prototype = $c_Llaika_ast_html_HTMLBlock.prototype;
$c_Llaika_ast_html_HTMLBlock.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_html_HTMLBlock.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_html_HTMLBlock)) {
    var x$0$2 = $as_Llaika_ast_html_HTMLBlock(x$0);
    var x = this.Llaika_ast_html_HTMLBlock__f_root;
    var x$2 = $n(x$0$2).Llaika_ast_html_HTMLBlock__f_root;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_html_HTMLBlock__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_html_HTMLBlock__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_html_HTMLBlock.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_html_HTMLBlock.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_html_HTMLBlock.prototype.productPrefix__T = (function() {
  return "HTMLBlock";
});
$c_Llaika_ast_html_HTMLBlock.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_html_HTMLBlock__f_root;
  }
  if ((n === 1)) {
    return this.Llaika_ast_html_HTMLBlock__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_html_HTMLBlock.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_html_HTMLBlock__f_options;
});
$c_Llaika_ast_html_HTMLBlock.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var root = this.Llaika_ast_html_HTMLBlock__f_root;
  return new $c_Llaika_ast_html_HTMLBlock(root, options);
});
function $as_Llaika_ast_html_HTMLBlock(obj) {
  return (((obj instanceof $c_Llaika_ast_html_HTMLBlock) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.html.HTMLBlock"));
}
function $isArrayOf_Llaika_ast_html_HTMLBlock(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_html_HTMLBlock)));
}
function $asArrayOf_Llaika_ast_html_HTMLBlock(obj, depth) {
  return (($isArrayOf_Llaika_ast_html_HTMLBlock(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.html.HTMLBlock;", depth));
}
var $d_Llaika_ast_html_HTMLBlock = new $TypeData().initClass($c_Llaika_ast_html_HTMLBlock, "laika.ast.html.HTMLBlock", ({
  Llaika_ast_html_HTMLBlock: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1
}));
/** @constructor */
function $c_Llaika_ast_html_HTMLSpan() {
}
$c_Llaika_ast_html_HTMLSpan.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_html_HTMLSpan.prototype.constructor = $c_Llaika_ast_html_HTMLSpan;
/** @constructor */
function $h_Llaika_ast_html_HTMLSpan() {
}
$h_Llaika_ast_html_HTMLSpan.prototype = $c_Llaika_ast_html_HTMLSpan.prototype;
/** @constructor */
function $c_Llaika_internal_link_LinkDefinitionSelector(id) {
  this.Llaika_internal_link_LinkDefinitionSelector__f_global = false;
  this.Llaika_internal_link_LinkDefinitionSelector__f_id = null;
  this.Llaika_internal_link_LinkDefinitionSelector__f_description = null;
  this.Llaika_internal_link_LinkDefinitionSelector__f_id = id;
  $f_Llaika_internal_link_UniqueSelector__$init$__V(this);
  this.Llaika_internal_link_LinkDefinitionSelector__f_description = (("link definition with id '" + id) + "'");
}
$c_Llaika_internal_link_LinkDefinitionSelector.prototype = new $h_O();
$c_Llaika_internal_link_LinkDefinitionSelector.prototype.constructor = $c_Llaika_internal_link_LinkDefinitionSelector;
/** @constructor */
function $h_Llaika_internal_link_LinkDefinitionSelector() {
}
$h_Llaika_internal_link_LinkDefinitionSelector.prototype = $c_Llaika_internal_link_LinkDefinitionSelector.prototype;
$c_Llaika_internal_link_LinkDefinitionSelector.prototype.global__Z = (function() {
  return this.Llaika_internal_link_LinkDefinitionSelector__f_global;
});
$c_Llaika_internal_link_LinkDefinitionSelector.prototype.laika$internal$link$UniqueSelector$_setter_$global_$eq__Z__V = (function(x$0) {
  this.Llaika_internal_link_LinkDefinitionSelector__f_global = x$0;
});
$c_Llaika_internal_link_LinkDefinitionSelector.prototype.laika$internal$link$UniqueSelector$_setter_$unique_$eq__Z__V = (function(x$0) {
});
$c_Llaika_internal_link_LinkDefinitionSelector.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_link_LinkDefinitionSelector.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_link_LinkDefinitionSelector.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_link_LinkDefinitionSelector)) {
    var x$0$2 = $as_Llaika_internal_link_LinkDefinitionSelector(x$0);
    return ((this.Llaika_internal_link_LinkDefinitionSelector__f_id === $n(x$0$2).Llaika_internal_link_LinkDefinitionSelector__f_id) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Llaika_internal_link_LinkDefinitionSelector.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_link_LinkDefinitionSelector.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_internal_link_LinkDefinitionSelector.prototype.productPrefix__T = (function() {
  return "LinkDefinitionSelector";
});
$c_Llaika_internal_link_LinkDefinitionSelector.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_link_LinkDefinitionSelector__f_id;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_internal_link_LinkDefinitionSelector.prototype.description__T = (function() {
  return this.Llaika_internal_link_LinkDefinitionSelector__f_description;
});
function $as_Llaika_internal_link_LinkDefinitionSelector(obj) {
  return (((obj instanceof $c_Llaika_internal_link_LinkDefinitionSelector) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.link.LinkDefinitionSelector"));
}
function $isArrayOf_Llaika_internal_link_LinkDefinitionSelector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_link_LinkDefinitionSelector)));
}
function $asArrayOf_Llaika_internal_link_LinkDefinitionSelector(obj, depth) {
  return (($isArrayOf_Llaika_internal_link_LinkDefinitionSelector(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.link.LinkDefinitionSelector;", depth));
}
var $d_Llaika_internal_link_LinkDefinitionSelector = new $TypeData().initClass($c_Llaika_internal_link_LinkDefinitionSelector, "laika.internal.link.LinkDefinitionSelector", ({
  Llaika_internal_link_LinkDefinitionSelector: 1,
  Llaika_internal_link_Selector: 1,
  Llaika_internal_link_UniqueSelector: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_link_PathSelector(path) {
  this.Llaika_internal_link_PathSelector__f_global = false;
  this.Llaika_internal_link_PathSelector__f_path = null;
  this.Llaika_internal_link_PathSelector__f_description = null;
  this.Llaika_internal_link_PathSelector__f_path = path;
  $f_Llaika_internal_link_UniqueSelector__$init$__V(this);
  this.Llaika_internal_link_PathSelector__f_description = (("link target with path '" + path) + "'");
}
$c_Llaika_internal_link_PathSelector.prototype = new $h_O();
$c_Llaika_internal_link_PathSelector.prototype.constructor = $c_Llaika_internal_link_PathSelector;
/** @constructor */
function $h_Llaika_internal_link_PathSelector() {
}
$h_Llaika_internal_link_PathSelector.prototype = $c_Llaika_internal_link_PathSelector.prototype;
$c_Llaika_internal_link_PathSelector.prototype.global__Z = (function() {
  return this.Llaika_internal_link_PathSelector__f_global;
});
$c_Llaika_internal_link_PathSelector.prototype.laika$internal$link$UniqueSelector$_setter_$global_$eq__Z__V = (function(x$0) {
  this.Llaika_internal_link_PathSelector__f_global = x$0;
});
$c_Llaika_internal_link_PathSelector.prototype.laika$internal$link$UniqueSelector$_setter_$unique_$eq__Z__V = (function(x$0) {
});
$c_Llaika_internal_link_PathSelector.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_link_PathSelector.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_link_PathSelector.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_link_PathSelector)) {
    var x$0$2 = $as_Llaika_internal_link_PathSelector(x$0);
    var x = this.Llaika_internal_link_PathSelector__f_path;
    var x$2 = $n(x$0$2).Llaika_internal_link_PathSelector__f_path;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_link_PathSelector.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_link_PathSelector.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_internal_link_PathSelector.prototype.productPrefix__T = (function() {
  return "PathSelector";
});
$c_Llaika_internal_link_PathSelector.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_link_PathSelector__f_path;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_internal_link_PathSelector.prototype.description__T = (function() {
  return this.Llaika_internal_link_PathSelector__f_description;
});
function $as_Llaika_internal_link_PathSelector(obj) {
  return (((obj instanceof $c_Llaika_internal_link_PathSelector) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.link.PathSelector"));
}
function $isArrayOf_Llaika_internal_link_PathSelector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_link_PathSelector)));
}
function $asArrayOf_Llaika_internal_link_PathSelector(obj, depth) {
  return (($isArrayOf_Llaika_internal_link_PathSelector(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.link.PathSelector;", depth));
}
var $d_Llaika_internal_link_PathSelector = new $TypeData().initClass($c_Llaika_internal_link_PathSelector, "laika.internal.link.PathSelector", ({
  Llaika_internal_link_PathSelector: 1,
  Llaika_internal_link_Selector: 1,
  Llaika_internal_link_UniqueSelector: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_link_TargetIdSelector(id) {
  this.Llaika_internal_link_TargetIdSelector__f_global = false;
  this.Llaika_internal_link_TargetIdSelector__f_id = null;
  this.Llaika_internal_link_TargetIdSelector__f_description = null;
  this.Llaika_internal_link_TargetIdSelector__f_id = id;
  $f_Llaika_internal_link_UniqueSelector__$init$__V(this);
  this.Llaika_internal_link_TargetIdSelector__f_description = (("link target with id '" + id) + "'");
}
$c_Llaika_internal_link_TargetIdSelector.prototype = new $h_O();
$c_Llaika_internal_link_TargetIdSelector.prototype.constructor = $c_Llaika_internal_link_TargetIdSelector;
/** @constructor */
function $h_Llaika_internal_link_TargetIdSelector() {
}
$h_Llaika_internal_link_TargetIdSelector.prototype = $c_Llaika_internal_link_TargetIdSelector.prototype;
$c_Llaika_internal_link_TargetIdSelector.prototype.global__Z = (function() {
  return this.Llaika_internal_link_TargetIdSelector__f_global;
});
$c_Llaika_internal_link_TargetIdSelector.prototype.laika$internal$link$UniqueSelector$_setter_$global_$eq__Z__V = (function(x$0) {
  this.Llaika_internal_link_TargetIdSelector__f_global = x$0;
});
$c_Llaika_internal_link_TargetIdSelector.prototype.laika$internal$link$UniqueSelector$_setter_$unique_$eq__Z__V = (function(x$0) {
});
$c_Llaika_internal_link_TargetIdSelector.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_link_TargetIdSelector.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_link_TargetIdSelector.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_link_TargetIdSelector)) {
    var x$0$2 = $as_Llaika_internal_link_TargetIdSelector(x$0);
    return ((this.Llaika_internal_link_TargetIdSelector__f_id === $n(x$0$2).Llaika_internal_link_TargetIdSelector__f_id) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Llaika_internal_link_TargetIdSelector.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_link_TargetIdSelector.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_internal_link_TargetIdSelector.prototype.productPrefix__T = (function() {
  return "TargetIdSelector";
});
$c_Llaika_internal_link_TargetIdSelector.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_link_TargetIdSelector__f_id;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_internal_link_TargetIdSelector.prototype.description__T = (function() {
  return this.Llaika_internal_link_TargetIdSelector__f_description;
});
function $as_Llaika_internal_link_TargetIdSelector(obj) {
  return (((obj instanceof $c_Llaika_internal_link_TargetIdSelector) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.link.TargetIdSelector"));
}
function $isArrayOf_Llaika_internal_link_TargetIdSelector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_link_TargetIdSelector)));
}
function $asArrayOf_Llaika_internal_link_TargetIdSelector(obj, depth) {
  return (($isArrayOf_Llaika_internal_link_TargetIdSelector(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.link.TargetIdSelector;", depth));
}
var $d_Llaika_internal_link_TargetIdSelector = new $TypeData().initClass($c_Llaika_internal_link_TargetIdSelector, "laika.internal.link.TargetIdSelector", ({
  Llaika_internal_link_TargetIdSelector: 1,
  Llaika_internal_link_Selector: 1,
  Llaika_internal_link_UniqueSelector: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_hocon_InvalidStringValue(value, failure) {
  this.Llaika_internal_parse_hocon_InvalidStringValue__f_value = null;
  this.Llaika_internal_parse_hocon_InvalidStringValue__f_failure = null;
  this.Llaika_internal_parse_hocon_InvalidStringValue__f_value = value;
  this.Llaika_internal_parse_hocon_InvalidStringValue__f_failure = failure;
}
$c_Llaika_internal_parse_hocon_InvalidStringValue.prototype = new $h_O();
$c_Llaika_internal_parse_hocon_InvalidStringValue.prototype.constructor = $c_Llaika_internal_parse_hocon_InvalidStringValue;
/** @constructor */
function $h_Llaika_internal_parse_hocon_InvalidStringValue() {
}
$h_Llaika_internal_parse_hocon_InvalidStringValue.prototype = $c_Llaika_internal_parse_hocon_InvalidStringValue.prototype;
$c_Llaika_internal_parse_hocon_InvalidStringValue.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_parse_hocon_InvalidStringValue.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_parse_hocon_InvalidStringValue.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_parse_hocon_InvalidStringValue)) {
    var x$0$2 = $as_Llaika_internal_parse_hocon_InvalidStringValue(x$0);
    if ((this.Llaika_internal_parse_hocon_InvalidStringValue__f_value === $n(x$0$2).Llaika_internal_parse_hocon_InvalidStringValue__f_value)) {
      var x = this.Llaika_internal_parse_hocon_InvalidStringValue__f_failure;
      var x$2 = $n(x$0$2).Llaika_internal_parse_hocon_InvalidStringValue__f_failure;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_parse_hocon_InvalidStringValue.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_parse_hocon_InvalidStringValue.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_internal_parse_hocon_InvalidStringValue.prototype.productPrefix__T = (function() {
  return "InvalidStringValue";
});
$c_Llaika_internal_parse_hocon_InvalidStringValue.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_parse_hocon_InvalidStringValue__f_value;
  }
  if ((n === 1)) {
    return this.Llaika_internal_parse_hocon_InvalidStringValue__f_failure;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_internal_parse_hocon_InvalidStringValue.prototype.value__T = (function() {
  return this.Llaika_internal_parse_hocon_InvalidStringValue__f_value;
});
function $as_Llaika_internal_parse_hocon_InvalidStringValue(obj) {
  return (((obj instanceof $c_Llaika_internal_parse_hocon_InvalidStringValue) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.hocon.InvalidStringValue"));
}
function $isArrayOf_Llaika_internal_parse_hocon_InvalidStringValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_hocon_InvalidStringValue)));
}
function $asArrayOf_Llaika_internal_parse_hocon_InvalidStringValue(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_hocon_InvalidStringValue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.hocon.InvalidStringValue;", depth));
}
var $d_Llaika_internal_parse_hocon_InvalidStringValue = new $TypeData().initClass($c_Llaika_internal_parse_hocon_InvalidStringValue, "laika.internal.parse.hocon.InvalidStringValue", ({
  Llaika_internal_parse_hocon_InvalidStringValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_internal_parse_hocon_ConfigBuilderValue: 1,
  Llaika_internal_parse_hocon_StringBuilderValue: 1
}));
/** @constructor */
function $c_Llaika_internal_parse_hocon_ValidStringValue(value) {
  this.Llaika_internal_parse_hocon_ValidStringValue__f_value = null;
  this.Llaika_internal_parse_hocon_ValidStringValue__f_value = value;
}
$c_Llaika_internal_parse_hocon_ValidStringValue.prototype = new $h_O();
$c_Llaika_internal_parse_hocon_ValidStringValue.prototype.constructor = $c_Llaika_internal_parse_hocon_ValidStringValue;
/** @constructor */
function $h_Llaika_internal_parse_hocon_ValidStringValue() {
}
$h_Llaika_internal_parse_hocon_ValidStringValue.prototype = $c_Llaika_internal_parse_hocon_ValidStringValue.prototype;
$c_Llaika_internal_parse_hocon_ValidStringValue.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_parse_hocon_ValidStringValue.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_parse_hocon_ValidStringValue.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_parse_hocon_ValidStringValue)) {
    var x$0$2 = $as_Llaika_internal_parse_hocon_ValidStringValue(x$0);
    return ((this.Llaika_internal_parse_hocon_ValidStringValue__f_value === $n(x$0$2).Llaika_internal_parse_hocon_ValidStringValue__f_value) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Llaika_internal_parse_hocon_ValidStringValue.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_parse_hocon_ValidStringValue.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_internal_parse_hocon_ValidStringValue.prototype.productPrefix__T = (function() {
  return "ValidStringValue";
});
$c_Llaika_internal_parse_hocon_ValidStringValue.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_parse_hocon_ValidStringValue__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_internal_parse_hocon_ValidStringValue.prototype.value__T = (function() {
  return this.Llaika_internal_parse_hocon_ValidStringValue__f_value;
});
function $as_Llaika_internal_parse_hocon_ValidStringValue(obj) {
  return (((obj instanceof $c_Llaika_internal_parse_hocon_ValidStringValue) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.parse.hocon.ValidStringValue"));
}
function $isArrayOf_Llaika_internal_parse_hocon_ValidStringValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_parse_hocon_ValidStringValue)));
}
function $asArrayOf_Llaika_internal_parse_hocon_ValidStringValue(obj, depth) {
  return (($isArrayOf_Llaika_internal_parse_hocon_ValidStringValue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.parse.hocon.ValidStringValue;", depth));
}
var $d_Llaika_internal_parse_hocon_ValidStringValue = new $TypeData().initClass($c_Llaika_internal_parse_hocon_ValidStringValue, "laika.internal.parse.hocon.ValidStringValue", ({
  Llaika_internal_parse_hocon_ValidStringValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_internal_parse_hocon_ConfigBuilderValue: 1,
  Llaika_internal_parse_hocon_StringBuilderValue: 1
}));
function $f_Llaika_internal_parse_markup_DefaultRecursiveParsers__$init$__V($thiz) {
  $thiz.Llaika_internal_parse_markup_RootParser__f_laika$internal$parse$markup$DefaultRecursiveParsers$$maxNestLevel = 12;
  $thiz.Llaika_internal_parse_markup_RootParser__f_laika$internal$parse$markup$DefaultRecursiveParsers$$recursiveBlockParser = new $c_Llaika_internal_parse_markup_DefaultRecursiveParsers$InternalRecursiveBlockParser($thiz);
}
function $f_Llaika_internal_parse_markup_DefaultRecursiveParsers__recursiveBlocks__Llaika_parse_Parser__Llaika_parse_Parser($thiz, p) {
  var this$9 = $m_Llaika_parse_Parser$();
  var f$1 = new $c_sjsr_AnonFunction1(((in$1) => {
    var in$2 = $as_Llaika_parse_SourceCursor(in$1);
    matchResult2: {
      var $x_1;
      var x7 = $n(p).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(in$2);
      if ((x7 instanceof $c_Llaika_parse_Success)) {
        var x$1 = $as_Llaika_parse_Success(x7);
        var this$3 = $n(x$1);
        var x11 = $as_Llaika_parse_BlockSource(this$3.Llaika_parse_Success__f_result);
        var this$4 = $n(x$1);
        var x12 = this$4.Llaika_parse_Success__f_next;
        var x1 = $n($thiz.Llaika_internal_parse_markup_RootParser__f_laika$internal$parse$markup$DefaultRecursiveParsers$$recursiveBlockParser).parse__Llaika_parse_SourceCursor__Llaika_parse_Parsed(x11);
        if ((x1 instanceof $c_Llaika_parse_Success)) {
          var x$1$1 = $as_Llaika_parse_Success(x1);
          var this$6 = $n(x$1$1);
          var x5 = $as_sci_Seq(this$6.Llaika_parse_Success__f_result);
          var this$7 = $n(x$1$1);
          var $x_1 = new $c_Llaika_parse_Success(x5, x12);
          break matchResult2;
        }
        if ((x1 instanceof $c_Llaika_parse_Failure)) {
          var f = $as_Llaika_parse_Failure(x1);
          var $x_1 = f;
          break matchResult2;
        }
        throw new $c_s_MatchError(x1);
      }
      if ((x7 instanceof $c_Llaika_parse_Failure)) {
        var f$2 = $as_Llaika_parse_Failure(x7);
        var $x_1 = f$2;
        break matchResult2;
      }
      throw new $c_s_MatchError(x7);
    }
    return $as_Llaika_parse_Parsed($x_1);
  }));
  return new $c_Llaika_parse_Parser$$anon$2(f$1, this$9);
}
/** @constructor */
function $c_s_None$() {
}
$c_s_None$.prototype = new $h_s_Option();
$c_s_None$.prototype.constructor = $c_s_None$;
/** @constructor */
function $h_s_None$() {
}
$h_s_None$.prototype = $c_s_None$.prototype;
$c_s_None$.prototype.get__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "None.get");
});
$c_s_None$.prototype.productPrefix__T = (function() {
  return "None";
});
$c_s_None$.prototype.productArity__I = (function() {
  return 0;
});
$c_s_None$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1);
});
$c_s_None$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_s_None$.prototype.hashCode__I = (function() {
  return 2433880;
});
$c_s_None$.prototype.toString__T = (function() {
  return "None";
});
$c_s_None$.prototype.get__O = (function() {
  this.get__E();
});
var $d_s_None$ = new $TypeData().initClass($c_s_None$, "scala.None$", ({
  s_None$: 1,
  s_Option: 1,
  sc_IterableOnce: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_None$;
function $m_s_None$() {
  if ((!$n_s_None$)) {
    $n_s_None$ = new $c_s_None$();
  }
  return $n_s_None$;
}
/** @constructor */
function $c_s_Some(value) {
  this.s_Some__f_value = null;
  this.s_Some__f_value = value;
}
$c_s_Some.prototype = new $h_s_Option();
$c_s_Some.prototype.constructor = $c_s_Some;
/** @constructor */
function $h_s_Some() {
}
$h_s_Some.prototype = $c_s_Some.prototype;
$c_s_Some.prototype.get__O = (function() {
  return this.s_Some__f_value;
});
$c_s_Some.prototype.productPrefix__T = (function() {
  return "Some";
});
$c_s_Some.prototype.productArity__I = (function() {
  return 1;
});
$c_s_Some.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_Some__f_value : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_s_Some.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_s_Some.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_s_Some.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_s_Some.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_s_Some)) {
    var Some$1 = $as_s_Some(x$1);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(this.s_Some__f_value, $n(Some$1).s_Some__f_value);
  } else {
    return false;
  }
});
function $as_s_Some(obj) {
  return (((obj instanceof $c_s_Some) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Some"));
}
function $isArrayOf_s_Some(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_Some)));
}
function $asArrayOf_s_Some(obj, depth) {
  return (($isArrayOf_s_Some(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Some;", depth));
}
var $d_s_Some = new $TypeData().initClass($c_s_Some, "scala.Some", ({
  s_Some: 1,
  s_Option: 1,
  sc_IterableOnce: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_AbstractIterable() {
}
$c_sc_AbstractIterable.prototype = new $h_O();
$c_sc_AbstractIterable.prototype.constructor = $c_sc_AbstractIterable;
/** @constructor */
function $h_sc_AbstractIterable() {
}
$h_sc_AbstractIterable.prototype = $c_sc_AbstractIterable.prototype;
$c_sc_AbstractIterable.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_Iterable$();
});
$c_sc_AbstractIterable.prototype.className__T = (function() {
  return this.stringPrefix__T();
});
$c_sc_AbstractIterable.prototype.stringPrefix__T = (function() {
  return "Iterable";
});
$c_sc_AbstractIterable.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$c_sc_AbstractIterable.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $as_sc_IterableOps($n(this.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O(coll));
});
$c_sc_AbstractIterable.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $n(this.iterableFactory__sc_IterableFactory()).newBuilder__scm_Builder();
});
$c_sc_AbstractIterable.prototype.empty__sc_IterableOps = (function() {
  return $as_sc_IterableOps($n(this.iterableFactory__sc_IterableFactory()).empty__O());
});
$c_sc_AbstractIterable.prototype.head__O = (function() {
  return $n(this.iterator__sc_Iterator()).next__O();
});
$c_sc_AbstractIterable.prototype.headOption__s_Option = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this);
});
$c_sc_AbstractIterable.prototype.last__O = (function() {
  return $f_sc_IterableOps__last__O(this);
});
$c_sc_AbstractIterable.prototype.sizeCompare__I__I = (function(otherSize) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, otherSize);
});
$c_sc_AbstractIterable.prototype.filter__F1__O = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$c_sc_AbstractIterable.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred);
});
$c_sc_AbstractIterable.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_IterableOps__partition__F1__T2(this, p);
});
$c_sc_AbstractIterable.prototype.splitAt__I__T2 = (function(n) {
  return $f_sc_IterableOps__splitAt__I__T2(this, n);
});
$c_sc_AbstractIterable.prototype.take__I__O = (function(n) {
  return $f_sc_IterableOps__take__I__O(this, n);
});
$c_sc_AbstractIterable.prototype.takeWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__takeWhile__F1__O(this, p);
});
$c_sc_AbstractIterable.prototype.span__F1__T2 = (function(p) {
  return $f_sc_IterableOps__span__F1__T2(this, p);
});
$c_sc_AbstractIterable.prototype.drop__I__O = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n);
});
$c_sc_AbstractIterable.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IterableOps__dropRight__I__O(this, n);
});
$c_sc_AbstractIterable.prototype.dropWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__dropWhile__F1__O(this, p);
});
$c_sc_AbstractIterable.prototype.sliding__I__I__sc_Iterator = (function(size, step) {
  return $f_sc_IterableOps__sliding__I__I__sc_Iterator(this, size, step);
});
$c_sc_AbstractIterable.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$c_sc_AbstractIterable.prototype.init__O = (function() {
  return $f_sc_IterableOps__init__O(this);
});
$c_sc_AbstractIterable.prototype.map__F1__O = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f);
});
$c_sc_AbstractIterable.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f);
});
$c_sc_AbstractIterable.prototype.flatten__F1__O = (function(asIterable) {
  return this.flatMap__F1__O(asIterable);
});
$c_sc_AbstractIterable.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_IterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sc_AbstractIterable.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_AbstractIterable.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_IterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_sc_AbstractIterable.prototype.zipWithIndex__O = (function() {
  return $f_sc_IterableOps__zipWithIndex__O(this);
});
$c_sc_AbstractIterable.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$c_sc_AbstractIterable.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_sc_AbstractIterable.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$c_sc_AbstractIterable.prototype.find__F1__s_Option = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$c_sc_AbstractIterable.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_sc_AbstractIterable.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_sc_AbstractIterable.prototype.isEmpty__Z = (function() {
  return $f_sc_IterableOnceOps__isEmpty__Z(this);
});
$c_sc_AbstractIterable.prototype.size__I = (function() {
  return $f_sc_IterableOnceOps__size__I(this);
});
$c_sc_AbstractIterable.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_sc_AbstractIterable.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$c_sc_AbstractIterable.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$c_sc_AbstractIterable.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_sc_AbstractIterable.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_sc_AbstractIterable.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_sc_AbstractIterable.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_sc_AbstractIterable.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this);
});
$c_sc_AbstractIterable.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return $m_sci_IndexedSeq$().from__sc_IterableOnce__sci_IndexedSeq(this);
});
$c_sc_AbstractIterable.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_sc_AbstractIterable.prototype.reversed__sc_Iterable = (function() {
  return $f_sc_IterableOnceOps__reversed__sc_Iterable(this);
});
$c_sc_AbstractIterable.prototype.knownSize__I = (function() {
  return (-1);
});
$c_sc_AbstractIterable.prototype.empty__O = (function() {
  return this.empty__sc_IterableOps();
});
$c_sc_AbstractIterable.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sc_IterableOps(coll);
});
function $ct_sc_ArrayOps$ArrayIterator__O__($thiz, xs) {
  $thiz.sc_ArrayOps$ArrayIterator__f_xs = xs;
  $thiz.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  var xs$1 = $thiz.sc_ArrayOps$ArrayIterator__f_xs;
  $thiz.sc_ArrayOps$ArrayIterator__f_len = $m_jl_reflect_Array$().getLength__O__I(xs$1);
  return $thiz;
}
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator() {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
}
$c_sc_ArrayOps$ArrayIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_ArrayOps$ArrayIterator.prototype.constructor = $c_sc_ArrayOps$ArrayIterator;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator() {
}
$h_sc_ArrayOps$ArrayIterator.prototype = $c_sc_ArrayOps$ArrayIterator.prototype;
$c_sc_ArrayOps$ArrayIterator.prototype.knownSize__I = (function() {
  return ((this.sc_ArrayOps$ArrayIterator__f_len - this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
});
$c_sc_ArrayOps$ArrayIterator.prototype.hasNext__Z = (function() {
  return (this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos < this.sc_ArrayOps$ArrayIterator__f_len);
});
$c_sc_ArrayOps$ArrayIterator.prototype.next__O = (function() {
  var $x_1 = this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos;
  var xs = this.sc_ArrayOps$ArrayIterator__f_xs;
  if (($x_1 >= $m_jl_reflect_Array$().getLength__O__I(xs))) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var r = $m_sr_ScalaRunTime$().array_apply__O__I__O(this.sc_ArrayOps$ArrayIterator__f_xs, this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r;
});
$c_sc_ArrayOps$ArrayIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    var newPos = ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos + n) | 0);
    if ((newPos < 0)) {
      var $x_1 = this.sc_ArrayOps$ArrayIterator__f_len;
    } else {
      var a = this.sc_ArrayOps$ArrayIterator__f_len;
      var $x_1 = ((a < newPos) ? a : newPos);
    }
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = $x_1;
  }
  return this;
});
var $d_sc_ArrayOps$ArrayIterator = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator, "scala.collection.ArrayOps$ArrayIterator", ({
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
function $p_sc_IndexedSeqView$IndexedSeqViewIterator__formatRange$1__I__I($thiz, value) {
  return ((value < 0) ? 0 : ((value > $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder) ? $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder : value));
}
function $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__($thiz, self) {
  $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_self = self;
  $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = 0;
  $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = $n(self).length__I();
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$IndexedSeqViewIterator() {
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_self = null;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = 0;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = 0;
}
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.constructor = $c_sc_IndexedSeqView$IndexedSeqViewIterator;
/** @constructor */
function $h_sc_IndexedSeqView$IndexedSeqViewIterator() {
}
$h_sc_IndexedSeqView$IndexedSeqViewIterator.prototype = $c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype;
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.knownSize__I = (function() {
  return this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder;
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.hasNext__Z = (function() {
  return (this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder > 0);
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.next__O = (function() {
  if ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder > 0)) {
    var r = $n(this.sc_IndexedSeqView$IndexedSeqViewIterator__f_self).apply__I__O(this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current);
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = ((1 + this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current) | 0);
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = (((-1) + this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder) | 0);
    return r;
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current + n) | 0);
    var b = ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder - n) | 0);
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = ((b < 0) ? 0 : b);
  }
  return this;
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  var formatFrom = $p_sc_IndexedSeqView$IndexedSeqViewIterator__formatRange$1__I__I(this, from);
  var formatUntil = $p_sc_IndexedSeqView$IndexedSeqViewIterator__formatRange$1__I__I(this, until);
  var b = ((formatUntil - formatFrom) | 0);
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = ((b < 0) ? 0 : b);
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current + formatFrom) | 0);
  return this;
});
var $d_sc_IndexedSeqView$IndexedSeqViewIterator = new $TypeData().initClass($c_sc_IndexedSeqView$IndexedSeqViewIterator, "scala.collection.IndexedSeqView$IndexedSeqViewIterator", ({
  sc_IndexedSeqView$IndexedSeqViewIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
function $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__($thiz, self) {
  $thiz.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_self = self;
  $thiz.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = $n(self).length__I();
  $thiz.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = (((-1) + $thiz.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder) | 0);
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator() {
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_self = null;
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = 0;
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = 0;
}
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.constructor = $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator;
/** @constructor */
function $h_sc_IndexedSeqView$IndexedSeqViewReverseIterator() {
}
$h_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype = $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype;
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.hasNext__Z = (function() {
  return (this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0);
});
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.next__O = (function() {
  if ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0)) {
    var r = $n(this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_self).apply__I__O(this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos);
    this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = (((-1) + this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos) | 0);
    this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = (((-1) + this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder) | 0);
    return r;
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
});
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  if ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0)) {
    if ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder <= from)) {
      this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = 0;
    } else if ((from <= 0)) {
      if (((until >= 0) && (until < this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder))) {
        this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = until;
      }
    } else {
      this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos - from) | 0);
      if (((until >= 0) && (until < this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder))) {
        if ((until <= from)) {
          this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = 0;
        } else {
          this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = ((until - from) | 0);
        }
      } else {
        this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder - from) | 0);
      }
    }
  }
  return this;
});
var $d_sc_IndexedSeqView$IndexedSeqViewReverseIterator = new $TypeData().initClass($c_sc_IndexedSeqView$IndexedSeqViewReverseIterator, "scala.collection.IndexedSeqView$IndexedSeqViewReverseIterator", ({
  sc_IndexedSeqView$IndexedSeqViewReverseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$21() {
  this.scm_ImmutableBuilder__f_elems = null;
  $ct_scm_ImmutableBuilder__sc_IterableOnce__(this, $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty);
}
$c_sc_Iterator$$anon$21.prototype = new $h_scm_ImmutableBuilder();
$c_sc_Iterator$$anon$21.prototype.constructor = $c_sc_Iterator$$anon$21;
/** @constructor */
function $h_sc_Iterator$$anon$21() {
}
$h_sc_Iterator$$anon$21.prototype = $c_sc_Iterator$$anon$21.prototype;
$c_sc_Iterator$$anon$21.prototype.addOne__O__sc_Iterator$$anon$21 = (function(elem) {
  var this$3 = $n($as_sc_Iterator(this.scm_ImmutableBuilder__f_elems));
  var xs = new $c_sjsr_AnonFunction0((() => new $c_sc_Iterator$$anon$20(elem)));
  this.scm_ImmutableBuilder__f_elems = this$3.concat__F0__sc_Iterator(xs);
  return this;
});
$c_sc_Iterator$$anon$21.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sc_Iterator$$anon$21(elem);
});
var $d_sc_Iterator$$anon$21 = new $TypeData().initClass($c_sc_Iterator$$anon$21, "scala.collection.Iterator$$anon$21", ({
  sc_Iterator$$anon$21: 1,
  scm_ImmutableBuilder: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$7(outer, pf$1) {
  this.sc_Iterator$$anon$7__f_hd = null;
  this.sc_Iterator$$anon$7__f_status = 0;
  this.sc_Iterator$$anon$7__f_$outer = null;
  this.sc_Iterator$$anon$7__f_pf$1 = null;
  $n(outer);
  this.sc_Iterator$$anon$7__f_$outer = outer;
  this.sc_Iterator$$anon$7__f_pf$1 = pf$1;
  this.sc_Iterator$$anon$7__f_status = 0;
}
$c_sc_Iterator$$anon$7.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$7.prototype.constructor = $c_sc_Iterator$$anon$7;
/** @constructor */
function $h_sc_Iterator$$anon$7() {
}
$h_sc_Iterator$$anon$7.prototype = $c_sc_Iterator$$anon$7.prototype;
$c_sc_Iterator$$anon$7.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ($m_sr_Statics$PFMarker$());
});
$c_sc_Iterator$$anon$7.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sc_Iterator$$anon$7.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_sc_Iterator$$anon$7.prototype.toString__T = (function() {
  return "<function1>";
});
$c_sc_Iterator$$anon$7.prototype.apply__O__O = (function(value) {
  return $m_sr_Statics$PFMarker$();
});
$c_sc_Iterator$$anon$7.prototype.hasNext__Z = (function() {
  var marker = $m_sr_Statics$PFMarker$();
  while ((this.sc_Iterator$$anon$7__f_status === 0)) {
    if ($n(this.sc_Iterator$$anon$7__f_$outer).hasNext__Z()) {
      var x = $n(this.sc_Iterator$$anon$7__f_$outer).next__O();
      var v = $n(this.sc_Iterator$$anon$7__f_pf$1).applyOrElse__O__F1__O(x, this);
      if ((marker !== v)) {
        this.sc_Iterator$$anon$7__f_hd = v;
        this.sc_Iterator$$anon$7__f_status = 1;
      }
    } else {
      this.sc_Iterator$$anon$7__f_status = (-1);
    }
  }
  return (this.sc_Iterator$$anon$7__f_status === 1);
});
$c_sc_Iterator$$anon$7.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$$anon$7__f_status = 0;
    return this.sc_Iterator$$anon$7__f_hd;
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
});
var $d_sc_Iterator$$anon$7 = new $TypeData().initClass($c_sc_Iterator$$anon$7, "scala.collection.Iterator$$anon$7", ({
  sc_Iterator$$anon$7: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  F1: 1
}));
function $f_sc_MapOps__getOrElse__O__F0__O($thiz, key, default$1) {
  var x1 = $thiz.get__O__s_Option(key);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var v = $n(x2).s_Some__f_value;
    return v;
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      return $n(default$1).apply__O();
    } else {
      throw new $c_s_MatchError(x1);
    }
  }
}
function $f_sc_MapOps__apply__O__O($thiz, key) {
  var x1 = $thiz.get__O__s_Option(key);
  var x = $m_s_None$();
  if ((x === x1)) {
    return $thiz.default__O__O(key);
  } else if ((x1 instanceof $c_s_Some)) {
    var x3 = $as_s_Some(x1);
    var value = $n(x3).s_Some__f_value;
    return value;
  } else {
    throw new $c_s_MatchError(x1);
  }
}
function $f_sc_MapOps__applyOrElse__O__F1__O($thiz, x, default$1) {
  return $thiz.getOrElse__O__F0__O(x, new $c_sjsr_AnonFunction0((() => $n(default$1).apply__O__O(x))));
}
function $f_sc_MapOps__foreachEntry__F2__V($thiz, f) {
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var next = $as_T2($n(it).next__O());
    $n(f).apply__O__O__O($n(next)._1__O(), $n(next)._2__O());
  }
}
function $f_sc_MapOps__default__O__O($thiz, key) {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
}
function $f_sc_MapOps__contains__O__Z($thiz, key) {
  var this$1 = $n($thiz.get__O__s_Option(key));
  return (!this$1.isEmpty__Z());
}
function $f_sc_MapOps__map__F1__sc_IterableOps($thiz, f) {
  return $as_sc_IterableOps($n($thiz.mapFactory__sc_MapFactory()).from__sc_IterableOnce__O($ct_sc_View$Map__sc_IterableOps__F1__(new $c_sc_View$Map(), $thiz, f)));
}
function $f_sc_MapOps__concat__sc_IterableOnce__sc_IterableOps($thiz, suffix) {
  var $x_2 = $thiz.mapFactory__sc_MapFactory();
  if ($is_sc_Iterable(suffix)) {
    var x2 = $as_sc_Iterable(suffix);
    var $x_1 = new $c_sc_View$Concat($thiz, x2);
  } else {
    var $x_1 = $n($thiz.iterator__sc_Iterator()).concat__F0__sc_Iterator(new $c_sjsr_AnonFunction0((() => $n(suffix).iterator__sc_Iterator())));
  }
  return $as_sc_IterableOps($n($x_2).from__sc_IterableOnce__O($x_1));
}
function $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder($thiz, sb, start, sep, end) {
  var this$2 = $n($thiz.iterator__sc_Iterator());
  var f = new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var k = $n(x0$1)._1__O();
      var v = $n(x0$1)._2__O();
      return ((k + " -> ") + v);
    } else {
      throw new $c_s_MatchError(x0$1);
    }
  }));
  var this$3 = new $c_sc_Iterator$$anon$9(this$2, f);
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this$3, sb, start, sep, end);
}
function $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O($thiz, f) {
  var builder = $thiz.newSpecificBuilder__scm_Builder();
  var seen = $ct_scm_HashSet__(new $c_scm_HashSet());
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var next = $n(it).next__O();
    if (seen.add__O__Z($n(f).apply__O__O(next))) {
      var this$2 = $n(builder);
      this$2.addOne__O__scm_Growable(next);
    }
  }
  return $n(builder).result__O();
}
function $f_sc_StrictOptimizedSeqOps__prepended__O__O($thiz, elem) {
  var b = $n($thiz.iterableFactory__sc_SeqFactory()).newBuilder__scm_Builder();
  var this$1 = $n(b);
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(this$1, $thiz, 1);
  var this$2 = $n(b);
  this$2.addOne__O__scm_Growable(elem);
  var this$3 = $n(b);
  this$3.addAll__sc_IterableOnce__scm_Growable($thiz);
  return $n(b).result__O();
}
function $f_sc_StrictOptimizedSeqOps__appended__O__O($thiz, elem) {
  var b = $n($thiz.iterableFactory__sc_SeqFactory()).newBuilder__scm_Builder();
  var this$1 = $n(b);
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(this$1, $thiz, 1);
  var this$2 = $n(b);
  this$2.addAll__sc_IterableOnce__scm_Growable($thiz);
  var this$3 = $n(b);
  this$3.addOne__O__scm_Growable(elem);
  return $n(b).result__O();
}
function $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O($thiz, suffix) {
  var b = $n($thiz.iterableFactory__sc_SeqFactory()).newBuilder__scm_Builder();
  var this$1 = $n(b);
  this$1.addAll__sc_IterableOnce__scm_Growable($thiz);
  var this$2 = $n(b);
  this$2.addAll__sc_IterableOnce__scm_Growable(suffix);
  return $n(b).result__O();
}
function $f_sc_StrictOptimizedSeqOps__prependedAll__sc_IterableOnce__O($thiz, prefix) {
  var b = $n($thiz.iterableFactory__sc_SeqFactory()).newBuilder__scm_Builder();
  var this$1 = $n(b);
  this$1.addAll__sc_IterableOnce__scm_Growable(prefix);
  var this$2 = $n(b);
  this$2.addAll__sc_IterableOnce__scm_Growable($thiz);
  return $n(b).result__O();
}
function $f_sc_StrictOptimizedSeqOps__padTo__I__O__O($thiz, len, elem) {
  var b = $n($thiz.iterableFactory__sc_SeqFactory()).newBuilder__scm_Builder();
  var L = $thiz.length__I();
  $n(b).sizeHint__I__V(((L > len) ? L : len));
  var diff = ((len - L) | 0);
  var this$3 = $n(b);
  this$3.addAll__sc_IterableOnce__scm_Growable($thiz);
  while ((diff > 0)) {
    var this$4 = $n(b);
    this$4.addOne__O__scm_Growable(elem);
    diff = (((-1) + diff) | 0);
  }
  return $n(b).result__O();
}
function $p_sci_ArraySeq$__emptyImpl$lzycompute__sci_ArraySeq$ofRef($thiz) {
  if ((!$thiz.sci_ArraySeq$__f_bitmap$0)) {
    $thiz.sci_ArraySeq$__f_emptyImpl = new $c_sci_ArraySeq$ofRef(new $ac_O(0));
    $thiz.sci_ArraySeq$__f_bitmap$0 = true;
  }
  return $thiz.sci_ArraySeq$__f_emptyImpl;
}
function $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef($thiz) {
  return ((!$thiz.sci_ArraySeq$__f_bitmap$0) ? $p_sci_ArraySeq$__emptyImpl$lzycompute__sci_ArraySeq$ofRef($thiz) : $thiz.sci_ArraySeq$__f_emptyImpl);
}
/** @constructor */
function $c_sci_ArraySeq$() {
  this.sci_ArraySeq$__f_emptyImpl = null;
  this.sci_ArraySeq$__f_untagged = null;
  this.sci_ArraySeq$__f_bitmap$0 = false;
  $n_sci_ArraySeq$ = this;
  this.sci_ArraySeq$__f_untagged = new $c_sc_ClassTagSeqFactory$AnySeqDelegate(this);
}
$c_sci_ArraySeq$.prototype = new $h_O();
$c_sci_ArraySeq$.prototype.constructor = $c_sci_ArraySeq$;
/** @constructor */
function $h_sci_ArraySeq$() {
}
$h_sci_ArraySeq$.prototype = $c_sci_ArraySeq$.prototype;
$c_sci_ArraySeq$.prototype.apply__sci_Seq__O__O = (function(xs, evidence$7) {
  return this.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq(xs, $as_s_reflect_ClassTag(evidence$7));
});
$c_sci_ArraySeq$.prototype.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq = (function(it, tag) {
  if ((it instanceof $c_sci_ArraySeq)) {
    var x2 = $as_sci_ArraySeq(it);
    return x2;
  } else {
    return this.unsafeWrapArray__O__sci_ArraySeq($m_s_Array$().from__sc_IterableOnce__s_reflect_ClassTag__O(it, tag));
  }
});
$c_sci_ArraySeq$.prototype.newBuilder__s_reflect_ClassTag__scm_Builder = (function(evidence$2) {
  $m_scm_ArrayBuffer$();
  var this$4 = new $c_scm_ArrayBuffer$$anon$1();
  var f = new $c_sjsr_AnonFunction1(((b$2) => {
    var b = $as_scm_ArrayBuffer(b$2);
    var $x_1 = $m_sci_ArraySeq$();
    var this$3 = $n(b);
    return $n($x_1).unsafeWrapArray__O__sci_ArraySeq($f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this$3, evidence$2));
  }));
  return new $c_scm_Builder$$anon$1(this$4, f);
});
$c_sci_ArraySeq$.prototype.unsafeWrapArray__O__sci_ArraySeq = (function(x) {
  if ((x === null)) {
    return null;
  } else if ((x instanceof $ac_O)) {
    var x3 = $asArrayOf_O(x, 1);
    return new $c_sci_ArraySeq$ofRef(x3);
  } else if ((x instanceof $ac_I)) {
    var x4 = $asArrayOf_I(x, 1);
    return new $c_sci_ArraySeq$ofInt(x4);
  } else if ((x instanceof $ac_D)) {
    var x5 = $asArrayOf_D(x, 1);
    return new $c_sci_ArraySeq$ofDouble(x5);
  } else if ((x instanceof $ac_J)) {
    var x6 = $asArrayOf_J(x, 1);
    return new $c_sci_ArraySeq$ofLong(x6);
  } else if ((x instanceof $ac_F)) {
    var x7 = $asArrayOf_F(x, 1);
    return new $c_sci_ArraySeq$ofFloat(x7);
  } else if ((x instanceof $ac_C)) {
    var x8 = $asArrayOf_C(x, 1);
    return new $c_sci_ArraySeq$ofChar(x8);
  } else if ((x instanceof $ac_B)) {
    var x9 = $asArrayOf_B(x, 1);
    return new $c_sci_ArraySeq$ofByte(x9);
  } else if ((x instanceof $ac_S)) {
    var x10 = $asArrayOf_S(x, 1);
    return new $c_sci_ArraySeq$ofShort(x10);
  } else if ((x instanceof $ac_Z)) {
    var x11 = $asArrayOf_Z(x, 1);
    return new $c_sci_ArraySeq$ofBoolean(x11);
  } else if ($isArrayOf_jl_Void(x, 1)) {
    var x12 = $asArrayOf_jl_Void(x, 1);
    return new $c_sci_ArraySeq$ofUnit(x12);
  } else {
    throw new $c_s_MatchError(x);
  }
});
$c_sci_ArraySeq$.prototype.newBuilder__O__scm_Builder = (function(evidence$12) {
  return this.newBuilder__s_reflect_ClassTag__scm_Builder($as_s_reflect_ClassTag(evidence$12));
});
$c_sci_ArraySeq$.prototype.from__sc_IterableOnce__O__O = (function(it, evidence$5) {
  return this.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq(it, $as_s_reflect_ClassTag(evidence$5));
});
$c_sci_ArraySeq$.prototype.empty__O__O = (function(evidence$6) {
  $as_s_reflect_ClassTag(evidence$6);
  return $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef(this);
});
var $d_sci_ArraySeq$ = new $TypeData().initClass($c_sci_ArraySeq$, "scala.collection.immutable.ArraySeq$", ({
  sci_ArraySeq$: 1,
  sc_StrictOptimizedClassTagSeqFactory: 1,
  sc_ClassTagSeqFactory: 1,
  sc_ClassTagIterableFactory: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_ArraySeq$;
function $m_sci_ArraySeq$() {
  if ((!$n_sci_ArraySeq$)) {
    $n_sci_ArraySeq$ = new $c_sci_ArraySeq$();
  }
  return $n_sci_ArraySeq$;
}
/** @constructor */
function $c_sci_HashMapBuilder$$anon$1(outer, x2$1) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, $n(x2$1).sci_HashMap__f_rootNode);
  while (this.hasNext__Z()) {
    var originalHash = $n(this.sci_ChampBaseIterator__f_currentValueNode).getHash__I__I(this.sci_ChampBaseIterator__f_currentValueCursor);
    $n(outer).update__sci_MapNode__O__O__I__I__I__V($n(outer).sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, $n($as_sci_MapNode(this.sci_ChampBaseIterator__f_currentValueNode)).getKey__I__O(this.sci_ChampBaseIterator__f_currentValueCursor), $n($as_sci_MapNode(this.sci_ChampBaseIterator__f_currentValueNode)).getValue__I__O(this.sci_ChampBaseIterator__f_currentValueCursor), originalHash, $m_sc_Hashing$().improve__I__I(originalHash), 0);
    this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  }
}
$c_sci_HashMapBuilder$$anon$1.prototype = new $h_sci_ChampBaseIterator();
$c_sci_HashMapBuilder$$anon$1.prototype.constructor = $c_sci_HashMapBuilder$$anon$1;
/** @constructor */
function $h_sci_HashMapBuilder$$anon$1() {
}
$h_sci_HashMapBuilder$$anon$1.prototype = $c_sci_HashMapBuilder$$anon$1.prototype;
$c_sci_HashMapBuilder$$anon$1.prototype.next__E = (function() {
  $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  throw $ct_jl_ClassCastException__(new $c_jl_ClassCastException());
});
$c_sci_HashMapBuilder$$anon$1.prototype.next__O = (function() {
  this.next__E();
});
var $d_sci_HashMapBuilder$$anon$1 = new $TypeData().initClass($c_sci_HashMapBuilder$$anon$1, "scala.collection.immutable.HashMapBuilder$$anon$1", ({
  sci_HashMapBuilder$$anon$1: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_HashSetBuilder$$anon$1(outer, x2$1) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, $n(x2$1).sci_HashSet__f_rootNode);
  while (this.hasNext__Z()) {
    var originalHash = $n(this.sci_ChampBaseIterator__f_currentValueNode).getHash__I__I(this.sci_ChampBaseIterator__f_currentValueCursor);
    $n(outer).update__sci_SetNode__O__I__I__I__V($n(outer).sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode, $n($as_sci_SetNode(this.sci_ChampBaseIterator__f_currentValueNode)).getPayload__I__O(this.sci_ChampBaseIterator__f_currentValueCursor), originalHash, $m_sc_Hashing$().improve__I__I(originalHash), 0);
    this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  }
}
$c_sci_HashSetBuilder$$anon$1.prototype = new $h_sci_ChampBaseIterator();
$c_sci_HashSetBuilder$$anon$1.prototype.constructor = $c_sci_HashSetBuilder$$anon$1;
/** @constructor */
function $h_sci_HashSetBuilder$$anon$1() {
}
$h_sci_HashSetBuilder$$anon$1.prototype = $c_sci_HashSetBuilder$$anon$1.prototype;
$c_sci_HashSetBuilder$$anon$1.prototype.next__E = (function() {
  $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  throw $ct_jl_ClassCastException__(new $c_jl_ClassCastException());
});
$c_sci_HashSetBuilder$$anon$1.prototype.next__O = (function() {
  this.next__E();
});
var $d_sci_HashSetBuilder$$anon$1 = new $TypeData().initClass($c_sci_HashSetBuilder$$anon$1, "scala.collection.immutable.HashSetBuilder$$anon$1", ({
  sci_HashSetBuilder$$anon$1: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
function $is_sci_Iterable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Iterable)));
}
function $as_sci_Iterable(obj) {
  return (($is_sci_Iterable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Iterable"));
}
function $isArrayOf_sci_Iterable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Iterable)));
}
function $asArrayOf_sci_Iterable(obj, depth) {
  return (($isArrayOf_sci_Iterable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Iterable;", depth));
}
/** @constructor */
function $c_sci_Map$Map2$$anon$1(outer) {
  this.sci_Map$Map2$Map2Iterator__f_i = 0;
  this.sci_Map$Map2$Map2Iterator__f_$outer = null;
  $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__(this, outer);
}
$c_sci_Map$Map2$$anon$1.prototype = new $h_sci_Map$Map2$Map2Iterator();
$c_sci_Map$Map2$$anon$1.prototype.constructor = $c_sci_Map$Map2$$anon$1;
/** @constructor */
function $h_sci_Map$Map2$$anon$1() {
}
$h_sci_Map$Map2$$anon$1.prototype = $c_sci_Map$Map2$$anon$1.prototype;
$c_sci_Map$Map2$$anon$1.prototype.nextResult__O__O__O = (function(k, v) {
  return new $c_T2(k, v);
});
var $d_sci_Map$Map2$$anon$1 = new $TypeData().initClass($c_sci_Map$Map2$$anon$1, "scala.collection.immutable.Map$Map2$$anon$1", ({
  sci_Map$Map2$$anon$1: 1,
  sci_Map$Map2$Map2Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_Map$Map2$$anon$2(outer) {
  this.sci_Map$Map2$Map2Iterator__f_i = 0;
  this.sci_Map$Map2$Map2Iterator__f_$outer = null;
  $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__(this, outer);
}
$c_sci_Map$Map2$$anon$2.prototype = new $h_sci_Map$Map2$Map2Iterator();
$c_sci_Map$Map2$$anon$2.prototype.constructor = $c_sci_Map$Map2$$anon$2;
/** @constructor */
function $h_sci_Map$Map2$$anon$2() {
}
$h_sci_Map$Map2$$anon$2.prototype = $c_sci_Map$Map2$$anon$2.prototype;
$c_sci_Map$Map2$$anon$2.prototype.nextResult__O__O__O = (function(k, v) {
  return k;
});
var $d_sci_Map$Map2$$anon$2 = new $TypeData().initClass($c_sci_Map$Map2$$anon$2, "scala.collection.immutable.Map$Map2$$anon$2", ({
  sci_Map$Map2$$anon$2: 1,
  sci_Map$Map2$Map2Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_Map$Map2$$anon$3(outer) {
  this.sci_Map$Map2$Map2Iterator__f_i = 0;
  this.sci_Map$Map2$Map2Iterator__f_$outer = null;
  $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__(this, outer);
}
$c_sci_Map$Map2$$anon$3.prototype = new $h_sci_Map$Map2$Map2Iterator();
$c_sci_Map$Map2$$anon$3.prototype.constructor = $c_sci_Map$Map2$$anon$3;
/** @constructor */
function $h_sci_Map$Map2$$anon$3() {
}
$h_sci_Map$Map2$$anon$3.prototype = $c_sci_Map$Map2$$anon$3.prototype;
$c_sci_Map$Map2$$anon$3.prototype.nextResult__O__O__O = (function(k, v) {
  return v;
});
var $d_sci_Map$Map2$$anon$3 = new $TypeData().initClass($c_sci_Map$Map2$$anon$3, "scala.collection.immutable.Map$Map2$$anon$3", ({
  sci_Map$Map2$$anon$3: 1,
  sci_Map$Map2$Map2Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_Map$Map3$$anon$4(outer) {
  this.sci_Map$Map3$Map3Iterator__f_i = 0;
  this.sci_Map$Map3$Map3Iterator__f_$outer = null;
  $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__(this, outer);
}
$c_sci_Map$Map3$$anon$4.prototype = new $h_sci_Map$Map3$Map3Iterator();
$c_sci_Map$Map3$$anon$4.prototype.constructor = $c_sci_Map$Map3$$anon$4;
/** @constructor */
function $h_sci_Map$Map3$$anon$4() {
}
$h_sci_Map$Map3$$anon$4.prototype = $c_sci_Map$Map3$$anon$4.prototype;
$c_sci_Map$Map3$$anon$4.prototype.nextResult__O__O__O = (function(k, v) {
  return new $c_T2(k, v);
});
var $d_sci_Map$Map3$$anon$4 = new $TypeData().initClass($c_sci_Map$Map3$$anon$4, "scala.collection.immutable.Map$Map3$$anon$4", ({
  sci_Map$Map3$$anon$4: 1,
  sci_Map$Map3$Map3Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_Map$Map3$$anon$5(outer) {
  this.sci_Map$Map3$Map3Iterator__f_i = 0;
  this.sci_Map$Map3$Map3Iterator__f_$outer = null;
  $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__(this, outer);
}
$c_sci_Map$Map3$$anon$5.prototype = new $h_sci_Map$Map3$Map3Iterator();
$c_sci_Map$Map3$$anon$5.prototype.constructor = $c_sci_Map$Map3$$anon$5;
/** @constructor */
function $h_sci_Map$Map3$$anon$5() {
}
$h_sci_Map$Map3$$anon$5.prototype = $c_sci_Map$Map3$$anon$5.prototype;
$c_sci_Map$Map3$$anon$5.prototype.nextResult__O__O__O = (function(k, v) {
  return k;
});
var $d_sci_Map$Map3$$anon$5 = new $TypeData().initClass($c_sci_Map$Map3$$anon$5, "scala.collection.immutable.Map$Map3$$anon$5", ({
  sci_Map$Map3$$anon$5: 1,
  sci_Map$Map3$Map3Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_Map$Map3$$anon$6(outer) {
  this.sci_Map$Map3$Map3Iterator__f_i = 0;
  this.sci_Map$Map3$Map3Iterator__f_$outer = null;
  $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__(this, outer);
}
$c_sci_Map$Map3$$anon$6.prototype = new $h_sci_Map$Map3$Map3Iterator();
$c_sci_Map$Map3$$anon$6.prototype.constructor = $c_sci_Map$Map3$$anon$6;
/** @constructor */
function $h_sci_Map$Map3$$anon$6() {
}
$h_sci_Map$Map3$$anon$6.prototype = $c_sci_Map$Map3$$anon$6.prototype;
$c_sci_Map$Map3$$anon$6.prototype.nextResult__O__O__O = (function(k, v) {
  return v;
});
var $d_sci_Map$Map3$$anon$6 = new $TypeData().initClass($c_sci_Map$Map3$$anon$6, "scala.collection.immutable.Map$Map3$$anon$6", ({
  sci_Map$Map3$$anon$6: 1,
  sci_Map$Map3$Map3Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_Map$Map4$$anon$7(outer) {
  this.sci_Map$Map4$Map4Iterator__f_i = 0;
  this.sci_Map$Map4$Map4Iterator__f_$outer = null;
  $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__(this, outer);
}
$c_sci_Map$Map4$$anon$7.prototype = new $h_sci_Map$Map4$Map4Iterator();
$c_sci_Map$Map4$$anon$7.prototype.constructor = $c_sci_Map$Map4$$anon$7;
/** @constructor */
function $h_sci_Map$Map4$$anon$7() {
}
$h_sci_Map$Map4$$anon$7.prototype = $c_sci_Map$Map4$$anon$7.prototype;
$c_sci_Map$Map4$$anon$7.prototype.nextResult__O__O__O = (function(k, v) {
  return new $c_T2(k, v);
});
var $d_sci_Map$Map4$$anon$7 = new $TypeData().initClass($c_sci_Map$Map4$$anon$7, "scala.collection.immutable.Map$Map4$$anon$7", ({
  sci_Map$Map4$$anon$7: 1,
  sci_Map$Map4$Map4Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_Map$Map4$$anon$8(outer) {
  this.sci_Map$Map4$Map4Iterator__f_i = 0;
  this.sci_Map$Map4$Map4Iterator__f_$outer = null;
  $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__(this, outer);
}
$c_sci_Map$Map4$$anon$8.prototype = new $h_sci_Map$Map4$Map4Iterator();
$c_sci_Map$Map4$$anon$8.prototype.constructor = $c_sci_Map$Map4$$anon$8;
/** @constructor */
function $h_sci_Map$Map4$$anon$8() {
}
$h_sci_Map$Map4$$anon$8.prototype = $c_sci_Map$Map4$$anon$8.prototype;
$c_sci_Map$Map4$$anon$8.prototype.nextResult__O__O__O = (function(k, v) {
  return k;
});
var $d_sci_Map$Map4$$anon$8 = new $TypeData().initClass($c_sci_Map$Map4$$anon$8, "scala.collection.immutable.Map$Map4$$anon$8", ({
  sci_Map$Map4$$anon$8: 1,
  sci_Map$Map4$Map4Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_Map$Map4$$anon$9(outer) {
  this.sci_Map$Map4$Map4Iterator__f_i = 0;
  this.sci_Map$Map4$Map4Iterator__f_$outer = null;
  $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__(this, outer);
}
$c_sci_Map$Map4$$anon$9.prototype = new $h_sci_Map$Map4$Map4Iterator();
$c_sci_Map$Map4$$anon$9.prototype.constructor = $c_sci_Map$Map4$$anon$9;
/** @constructor */
function $h_sci_Map$Map4$$anon$9() {
}
$h_sci_Map$Map4$$anon$9.prototype = $c_sci_Map$Map4$$anon$9.prototype;
$c_sci_Map$Map4$$anon$9.prototype.nextResult__O__O__O = (function(k, v) {
  return v;
});
var $d_sci_Map$Map4$$anon$9 = new $TypeData().initClass($c_sci_Map$Map4$$anon$9, "scala.collection.immutable.Map$Map4$$anon$9", ({
  sci_Map$Map4$$anon$9: 1,
  sci_Map$Map4$Map4Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_MapKeyIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
}
$c_sci_MapKeyIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_MapKeyIterator.prototype.constructor = $c_sci_MapKeyIterator;
/** @constructor */
function $h_sci_MapKeyIterator() {
}
$h_sci_MapKeyIterator.prototype = $c_sci_MapKeyIterator.prototype;
$c_sci_MapKeyIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var key = $n($as_sci_MapNode(this.sci_ChampBaseIterator__f_currentValueNode)).getKey__I__O(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return key;
});
var $d_sci_MapKeyIterator = new $TypeData().initClass($c_sci_MapKeyIterator, "scala.collection.immutable.MapKeyIterator", ({
  sci_MapKeyIterator: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_MapKeyValueTupleHashIterator(rootNode) {
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseReverseIterator__f_currentValueNode = null;
  this.sci_ChampBaseReverseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseReverseIterator__f_nodeIndex = null;
  this.sci_ChampBaseReverseIterator__f_nodeStack = null;
  this.sci_MapKeyValueTupleHashIterator__f_hash = 0;
  this.sci_MapKeyValueTupleHashIterator__f_value = null;
  $ct_sci_ChampBaseReverseIterator__sci_Node__(this, rootNode);
  this.sci_MapKeyValueTupleHashIterator__f_hash = 0;
}
$c_sci_MapKeyValueTupleHashIterator.prototype = new $h_sci_ChampBaseReverseIterator();
$c_sci_MapKeyValueTupleHashIterator.prototype.constructor = $c_sci_MapKeyValueTupleHashIterator;
/** @constructor */
function $h_sci_MapKeyValueTupleHashIterator() {
}
$h_sci_MapKeyValueTupleHashIterator.prototype = $c_sci_MapKeyValueTupleHashIterator.prototype;
$c_sci_MapKeyValueTupleHashIterator.prototype.hashCode__I = (function() {
  var $x_2 = $m_s_util_hashing_MurmurHash3$();
  var $x_1 = this.sci_MapKeyValueTupleHashIterator__f_hash;
  var x = this.sci_MapKeyValueTupleHashIterator__f_value;
  return $n($x_2).tuple2Hash__I__I__I__I($x_1, $m_sr_Statics$().anyHash__O__I(x), (-889275714));
});
$c_sci_MapKeyValueTupleHashIterator.prototype.next__sci_MapKeyValueTupleHashIterator = (function() {
  if ((!this.hasNext__Z())) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  this.sci_MapKeyValueTupleHashIterator__f_hash = $n(this.sci_ChampBaseReverseIterator__f_currentValueNode).getHash__I__I(this.sci_ChampBaseReverseIterator__f_currentValueCursor);
  this.sci_MapKeyValueTupleHashIterator__f_value = $n($as_sci_MapNode(this.sci_ChampBaseReverseIterator__f_currentValueNode)).getValue__I__O(this.sci_ChampBaseReverseIterator__f_currentValueCursor);
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = (((-1) + this.sci_ChampBaseReverseIterator__f_currentValueCursor) | 0);
  return this;
});
$c_sci_MapKeyValueTupleHashIterator.prototype.next__O = (function() {
  return this.next__sci_MapKeyValueTupleHashIterator();
});
var $d_sci_MapKeyValueTupleHashIterator = new $TypeData().initClass($c_sci_MapKeyValueTupleHashIterator, "scala.collection.immutable.MapKeyValueTupleHashIterator", ({
  sci_MapKeyValueTupleHashIterator: 1,
  sci_ChampBaseReverseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_MapKeyValueTupleIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
}
$c_sci_MapKeyValueTupleIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_MapKeyValueTupleIterator.prototype.constructor = $c_sci_MapKeyValueTupleIterator;
/** @constructor */
function $h_sci_MapKeyValueTupleIterator() {
}
$h_sci_MapKeyValueTupleIterator.prototype = $c_sci_MapKeyValueTupleIterator.prototype;
$c_sci_MapKeyValueTupleIterator.prototype.next__T2 = (function() {
  if ((!this.hasNext__Z())) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var payload = $n($as_sci_MapNode(this.sci_ChampBaseIterator__f_currentValueNode)).getPayload__I__T2(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return payload;
});
$c_sci_MapKeyValueTupleIterator.prototype.next__O = (function() {
  return this.next__T2();
});
var $d_sci_MapKeyValueTupleIterator = new $TypeData().initClass($c_sci_MapKeyValueTupleIterator, "scala.collection.immutable.MapKeyValueTupleIterator", ({
  sci_MapKeyValueTupleIterator: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_MapKeyValueTupleReverseIterator(rootNode) {
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseReverseIterator__f_currentValueNode = null;
  this.sci_ChampBaseReverseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseReverseIterator__f_nodeIndex = null;
  this.sci_ChampBaseReverseIterator__f_nodeStack = null;
  $ct_sci_ChampBaseReverseIterator__sci_Node__(this, rootNode);
}
$c_sci_MapKeyValueTupleReverseIterator.prototype = new $h_sci_ChampBaseReverseIterator();
$c_sci_MapKeyValueTupleReverseIterator.prototype.constructor = $c_sci_MapKeyValueTupleReverseIterator;
/** @constructor */
function $h_sci_MapKeyValueTupleReverseIterator() {
}
$h_sci_MapKeyValueTupleReverseIterator.prototype = $c_sci_MapKeyValueTupleReverseIterator.prototype;
$c_sci_MapKeyValueTupleReverseIterator.prototype.next__T2 = (function() {
  if ((!this.hasNext__Z())) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var payload = $n($as_sci_MapNode(this.sci_ChampBaseReverseIterator__f_currentValueNode)).getPayload__I__T2(this.sci_ChampBaseReverseIterator__f_currentValueCursor);
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = (((-1) + this.sci_ChampBaseReverseIterator__f_currentValueCursor) | 0);
  return payload;
});
$c_sci_MapKeyValueTupleReverseIterator.prototype.next__O = (function() {
  return this.next__T2();
});
var $d_sci_MapKeyValueTupleReverseIterator = new $TypeData().initClass($c_sci_MapKeyValueTupleReverseIterator, "scala.collection.immutable.MapKeyValueTupleReverseIterator", ({
  sci_MapKeyValueTupleReverseIterator: 1,
  sci_ChampBaseReverseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_MapNodeRemoveAllSetNodeIterator(rootSetNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootSetNode);
}
$c_sci_MapNodeRemoveAllSetNodeIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_MapNodeRemoveAllSetNodeIterator.prototype.constructor = $c_sci_MapNodeRemoveAllSetNodeIterator;
/** @constructor */
function $h_sci_MapNodeRemoveAllSetNodeIterator() {
}
$h_sci_MapNodeRemoveAllSetNodeIterator.prototype = $c_sci_MapNodeRemoveAllSetNodeIterator.prototype;
$c_sci_MapNodeRemoveAllSetNodeIterator.prototype.removeAll__sci_BitmapIndexedMapNode__sci_BitmapIndexedMapNode = (function(rootMapNode) {
  var curr = rootMapNode;
  while ((($n(curr).sci_BitmapIndexedMapNode__f_size > 0) && this.hasNext__Z())) {
    var originalHash = $n(this.sci_ChampBaseIterator__f_currentValueNode).getHash__I__I(this.sci_ChampBaseIterator__f_currentValueCursor);
    var qual$1 = curr;
    var x$1 = $n($as_sci_SetNode(this.sci_ChampBaseIterator__f_currentValueNode)).getPayload__I__O(this.sci_ChampBaseIterator__f_currentValueCursor);
    var x$2 = $m_sc_Hashing$().improve__I__I(originalHash);
    curr = $n(qual$1).removed__O__I__I__I__sci_BitmapIndexedMapNode(x$1, originalHash, x$2, 0);
    this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  }
  return curr;
});
$c_sci_MapNodeRemoveAllSetNodeIterator.prototype.next__O = (function() {
  return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
});
var $d_sci_MapNodeRemoveAllSetNodeIterator = new $TypeData().initClass($c_sci_MapNodeRemoveAllSetNodeIterator, "scala.collection.immutable.MapNodeRemoveAllSetNodeIterator", ({
  sci_MapNodeRemoveAllSetNodeIterator: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_MapValueIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
}
$c_sci_MapValueIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_MapValueIterator.prototype.constructor = $c_sci_MapValueIterator;
/** @constructor */
function $h_sci_MapValueIterator() {
}
$h_sci_MapValueIterator.prototype = $c_sci_MapValueIterator.prototype;
$c_sci_MapValueIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var value = $n($as_sci_MapNode(this.sci_ChampBaseIterator__f_currentValueNode)).getValue__I__O(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return value;
});
var $d_sci_MapValueIterator = new $TypeData().initClass($c_sci_MapValueIterator, "scala.collection.immutable.MapValueIterator", ({
  sci_MapValueIterator: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
function $p_sci_NewVectorIterator__advanceSlice__V($thiz) {
  if (($thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 <= $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  $thiz.sci_NewVectorIterator__f_sliceIdx = ((1 + $thiz.sci_NewVectorIterator__f_sliceIdx) | 0);
  var slice = $n($thiz.sci_NewVectorIterator__f_v).vectorSlice__I__AO($thiz.sci_NewVectorIterator__f_sliceIdx);
  while (($n(slice).u.length === 0)) {
    $thiz.sci_NewVectorIterator__f_sliceIdx = ((1 + $thiz.sci_NewVectorIterator__f_sliceIdx) | 0);
    slice = $n($thiz.sci_NewVectorIterator__f_v).vectorSlice__I__AO($thiz.sci_NewVectorIterator__f_sliceIdx);
  }
  $thiz.sci_NewVectorIterator__f_sliceStart = $thiz.sci_NewVectorIterator__f_sliceEnd;
  var count = $thiz.sci_NewVectorIterator__f_sliceCount;
  var idx = $thiz.sci_NewVectorIterator__f_sliceIdx;
  var c = ((count / 2) | 0);
  var a = ((idx - c) | 0);
  $thiz.sci_NewVectorIterator__f_sliceDim = ((((1 + c) | 0) - ((a < 0) ? ((-a) | 0) : a)) | 0);
  var x1 = $thiz.sci_NewVectorIterator__f_sliceDim;
  switch (x1) {
    case 1: {
      $thiz.sci_NewVectorIterator__f_a1 = slice;
      break;
    }
    case 2: {
      $thiz.sci_NewVectorIterator__f_a2 = $asArrayOf_O(slice, 2);
      break;
    }
    case 3: {
      $thiz.sci_NewVectorIterator__f_a3 = $asArrayOf_O(slice, 3);
      break;
    }
    case 4: {
      $thiz.sci_NewVectorIterator__f_a4 = $asArrayOf_O(slice, 4);
      break;
    }
    case 5: {
      $thiz.sci_NewVectorIterator__f_a5 = $asArrayOf_O(slice, 5);
      break;
    }
    case 6: {
      $thiz.sci_NewVectorIterator__f_a6 = $asArrayOf_O(slice, 6);
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
  $thiz.sci_NewVectorIterator__f_sliceEnd = (($thiz.sci_NewVectorIterator__f_sliceStart + Math.imul($n(slice).u.length, (1 << Math.imul(5, (((-1) + $thiz.sci_NewVectorIterator__f_sliceDim) | 0))))) | 0);
  if (($thiz.sci_NewVectorIterator__f_sliceEnd > $thiz.sci_NewVectorIterator__f_totalLength)) {
    $thiz.sci_NewVectorIterator__f_sliceEnd = $thiz.sci_NewVectorIterator__f_totalLength;
  }
  if (($thiz.sci_NewVectorIterator__f_sliceDim > 1)) {
    $thiz.sci_NewVectorIterator__f_oldPos = (((-1) + (1 << Math.imul(5, $thiz.sci_NewVectorIterator__f_sliceDim))) | 0);
  }
}
function $p_sci_NewVectorIterator__advance__V($thiz) {
  var pos = (((($thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 - $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1) | 0) + $thiz.sci_NewVectorIterator__f_totalLength) | 0);
  if ((pos === $thiz.sci_NewVectorIterator__f_sliceEnd)) {
    $p_sci_NewVectorIterator__advanceSlice__V($thiz);
  }
  if (($thiz.sci_NewVectorIterator__f_sliceDim > 1)) {
    var io = ((pos - $thiz.sci_NewVectorIterator__f_sliceStart) | 0);
    var xor = ($thiz.sci_NewVectorIterator__f_oldPos ^ io);
    $p_sci_NewVectorIterator__advanceA__I__I__V($thiz, io, xor);
    $thiz.sci_NewVectorIterator__f_oldPos = io;
  }
  $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = (($thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
  var a = $n($thiz.sci_NewVectorIterator__f_a1).u.length;
  var b = $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1;
  $thiz.sci_NewVectorIterator__f_a1len = ((a < b) ? a : b);
  $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0;
}
function $p_sci_NewVectorIterator__advanceA__I__I__V($thiz, io, xor) {
  if ((xor < 1024)) {
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get((31 & ((io >>> 5) | 0)));
  } else if ((xor < 32768)) {
    $thiz.sci_NewVectorIterator__f_a2 = $n($thiz.sci_NewVectorIterator__f_a3).get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get(0);
  } else if ((xor < 1048576)) {
    $thiz.sci_NewVectorIterator__f_a3 = $n($thiz.sci_NewVectorIterator__f_a4).get((31 & ((io >>> 15) | 0)));
    $thiz.sci_NewVectorIterator__f_a2 = $n($thiz.sci_NewVectorIterator__f_a3).get(0);
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get(0);
  } else if ((xor < 33554432)) {
    $thiz.sci_NewVectorIterator__f_a4 = $n($thiz.sci_NewVectorIterator__f_a5).get((31 & ((io >>> 20) | 0)));
    $thiz.sci_NewVectorIterator__f_a3 = $n($thiz.sci_NewVectorIterator__f_a4).get(0);
    $thiz.sci_NewVectorIterator__f_a2 = $n($thiz.sci_NewVectorIterator__f_a3).get(0);
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get(0);
  } else {
    $thiz.sci_NewVectorIterator__f_a5 = $n($thiz.sci_NewVectorIterator__f_a6).get(((io >>> 25) | 0));
    $thiz.sci_NewVectorIterator__f_a4 = $n($thiz.sci_NewVectorIterator__f_a5).get(0);
    $thiz.sci_NewVectorIterator__f_a3 = $n($thiz.sci_NewVectorIterator__f_a4).get(0);
    $thiz.sci_NewVectorIterator__f_a2 = $n($thiz.sci_NewVectorIterator__f_a3).get(0);
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get(0);
  }
}
function $p_sci_NewVectorIterator__setA__I__I__V($thiz, io, xor) {
  if ((xor < 1024)) {
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get((31 & ((io >>> 5) | 0)));
  } else if ((xor < 32768)) {
    $thiz.sci_NewVectorIterator__f_a2 = $n($thiz.sci_NewVectorIterator__f_a3).get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get((31 & ((io >>> 5) | 0)));
  } else if ((xor < 1048576)) {
    $thiz.sci_NewVectorIterator__f_a3 = $n($thiz.sci_NewVectorIterator__f_a4).get((31 & ((io >>> 15) | 0)));
    $thiz.sci_NewVectorIterator__f_a2 = $n($thiz.sci_NewVectorIterator__f_a3).get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get((31 & ((io >>> 5) | 0)));
  } else if ((xor < 33554432)) {
    $thiz.sci_NewVectorIterator__f_a4 = $n($thiz.sci_NewVectorIterator__f_a5).get((31 & ((io >>> 20) | 0)));
    $thiz.sci_NewVectorIterator__f_a3 = $n($thiz.sci_NewVectorIterator__f_a4).get((31 & ((io >>> 15) | 0)));
    $thiz.sci_NewVectorIterator__f_a2 = $n($thiz.sci_NewVectorIterator__f_a3).get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get((31 & ((io >>> 5) | 0)));
  } else {
    $thiz.sci_NewVectorIterator__f_a5 = $n($thiz.sci_NewVectorIterator__f_a6).get(((io >>> 25) | 0));
    $thiz.sci_NewVectorIterator__f_a4 = $n($thiz.sci_NewVectorIterator__f_a5).get((31 & ((io >>> 20) | 0)));
    $thiz.sci_NewVectorIterator__f_a3 = $n($thiz.sci_NewVectorIterator__f_a4).get((31 & ((io >>> 15) | 0)));
    $thiz.sci_NewVectorIterator__f_a2 = $n($thiz.sci_NewVectorIterator__f_a3).get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get((31 & ((io >>> 5) | 0)));
  }
}
/** @constructor */
function $c_sci_NewVectorIterator(v, totalLength, sliceCount) {
  this.sci_NewVectorIterator__f_v = null;
  this.sci_NewVectorIterator__f_totalLength = 0;
  this.sci_NewVectorIterator__f_sliceCount = 0;
  this.sci_NewVectorIterator__f_a1 = null;
  this.sci_NewVectorIterator__f_a2 = null;
  this.sci_NewVectorIterator__f_a3 = null;
  this.sci_NewVectorIterator__f_a4 = null;
  this.sci_NewVectorIterator__f_a5 = null;
  this.sci_NewVectorIterator__f_a6 = null;
  this.sci_NewVectorIterator__f_a1len = 0;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0;
  this.sci_NewVectorIterator__f_oldPos = 0;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = 0;
  this.sci_NewVectorIterator__f_sliceIdx = 0;
  this.sci_NewVectorIterator__f_sliceDim = 0;
  this.sci_NewVectorIterator__f_sliceStart = 0;
  this.sci_NewVectorIterator__f_sliceEnd = 0;
  this.sci_NewVectorIterator__f_v = v;
  this.sci_NewVectorIterator__f_totalLength = totalLength;
  this.sci_NewVectorIterator__f_sliceCount = sliceCount;
  this.sci_NewVectorIterator__f_a1 = $n(v).sci_Vector__f_prefix1;
  this.sci_NewVectorIterator__f_a1len = $n(this.sci_NewVectorIterator__f_a1).u.length;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0;
  this.sci_NewVectorIterator__f_oldPos = 0;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = this.sci_NewVectorIterator__f_totalLength;
  this.sci_NewVectorIterator__f_sliceIdx = 0;
  this.sci_NewVectorIterator__f_sliceDim = 1;
  this.sci_NewVectorIterator__f_sliceStart = 0;
  this.sci_NewVectorIterator__f_sliceEnd = this.sci_NewVectorIterator__f_a1len;
}
$c_sci_NewVectorIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_NewVectorIterator.prototype.constructor = $c_sci_NewVectorIterator;
/** @constructor */
function $h_sci_NewVectorIterator() {
}
$h_sci_NewVectorIterator.prototype = $c_sci_NewVectorIterator.prototype;
$c_sci_NewVectorIterator.prototype.knownSize__I = (function() {
  return ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
});
$c_sci_NewVectorIterator.prototype.hasNext__Z = (function() {
  return (this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 > this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1);
});
$c_sci_NewVectorIterator.prototype.next__O = (function() {
  if ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 === this.sci_NewVectorIterator__f_a1len)) {
    $p_sci_NewVectorIterator__advance__V(this);
  }
  var r = $n(this.sci_NewVectorIterator__f_a1).get(this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1);
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = ((1 + this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
  return r;
});
$c_sci_NewVectorIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    var oldpos = ((((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1) | 0) + this.sci_NewVectorIterator__f_totalLength) | 0);
    var a = ((oldpos + n) | 0);
    var b = this.sci_NewVectorIterator__f_totalLength;
    var newpos = ((a < b) ? a : b);
    if ((newpos === this.sci_NewVectorIterator__f_totalLength)) {
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0;
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = 0;
      this.sci_NewVectorIterator__f_a1len = 0;
    } else {
      while ((newpos >= this.sci_NewVectorIterator__f_sliceEnd)) {
        $p_sci_NewVectorIterator__advanceSlice__V(this);
      }
      var io = ((newpos - this.sci_NewVectorIterator__f_sliceStart) | 0);
      if ((this.sci_NewVectorIterator__f_sliceDim > 1)) {
        var xor = (this.sci_NewVectorIterator__f_oldPos ^ io);
        $p_sci_NewVectorIterator__setA__I__I__V(this, io, xor);
        this.sci_NewVectorIterator__f_oldPos = io;
      }
      this.sci_NewVectorIterator__f_a1len = $n(this.sci_NewVectorIterator__f_a1).u.length;
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = (31 & io);
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 + ((this.sci_NewVectorIterator__f_totalLength - newpos) | 0)) | 0);
      if ((this.sci_NewVectorIterator__f_a1len > this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1)) {
        this.sci_NewVectorIterator__f_a1len = this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1;
      }
    }
  }
  return this;
});
$c_sci_NewVectorIterator.prototype.take__I__sc_Iterator = (function(n) {
  if ((n < ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0))) {
    var trunc = ((((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0) - ((n < 0) ? 0 : n)) | 0);
    this.sci_NewVectorIterator__f_totalLength = ((this.sci_NewVectorIterator__f_totalLength - trunc) | 0);
    this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - trunc) | 0);
    if ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 < this.sci_NewVectorIterator__f_a1len)) {
      this.sci_NewVectorIterator__f_a1len = this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1;
    }
    if ((this.sci_NewVectorIterator__f_totalLength < this.sci_NewVectorIterator__f_sliceEnd)) {
      this.sci_NewVectorIterator__f_sliceEnd = this.sci_NewVectorIterator__f_totalLength;
    }
  }
  return this;
});
$c_sci_NewVectorIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var xsLen = $m_jl_reflect_Array$().getLength__O__I(xs);
  var srcLen = ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
  var x = ((len < srcLen) ? len : srcLen);
  var y = ((xsLen - start) | 0);
  var x$1 = ((x < y) ? x : y);
  var total = ((x$1 > 0) ? x$1 : 0);
  var copied = 0;
  var isBoxed = (xs instanceof $ac_O);
  while ((copied < total)) {
    if ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 === this.sci_NewVectorIterator__f_a1len)) {
      $p_sci_NewVectorIterator__advance__V(this);
    }
    var a = ((total - copied) | 0);
    var b = (($n(this.sci_NewVectorIterator__f_a1).u.length - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
    var count = ((a < b) ? a : b);
    if (isBoxed) {
      var src = this.sci_NewVectorIterator__f_a1;
      var srcPos = this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1;
      var destPos = ((start + copied) | 0);
      $systemArraycopyFull($n(src), srcPos, $n(xs), destPos, count);
    } else {
      $m_s_Array$().copy__O__I__O__I__I__V(this.sci_NewVectorIterator__f_a1, this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1, xs, ((start + copied) | 0), count);
    }
    this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 + count) | 0);
    copied = ((copied + count) | 0);
  }
  return total;
});
var $d_sci_NewVectorIterator = new $TypeData().initClass($c_sci_NewVectorIterator, "scala.collection.immutable.NewVectorIterator", ({
  sci_NewVectorIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  jl_Cloneable: 1
}));
/** @constructor */
function $c_sci_NumericRange$NumericRangeIterator(self, num) {
  this.sci_NumericRange$NumericRangeIterator__f_self = null;
  this.sci_NumericRange$NumericRangeIterator__f_num = null;
  this.sci_NumericRange$NumericRangeIterator__f__hasNext = false;
  this.sci_NumericRange$NumericRangeIterator__f__next = null;
  this.sci_NumericRange$NumericRangeIterator__f_lastElement = null;
  this.sci_NumericRange$NumericRangeIterator__f_self = self;
  this.sci_NumericRange$NumericRangeIterator__f_num = num;
  this.sci_NumericRange$NumericRangeIterator__f__hasNext = (!$n(self).isEmpty__Z());
  this.sci_NumericRange$NumericRangeIterator__f__next = $n(self).sci_NumericRange__f_start;
  this.sci_NumericRange$NumericRangeIterator__f_lastElement = (this.sci_NumericRange$NumericRangeIterator__f__hasNext ? $n(self).last__O() : $n(self).sci_NumericRange__f_start);
}
$c_sci_NumericRange$NumericRangeIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_NumericRange$NumericRangeIterator.prototype.constructor = $c_sci_NumericRange$NumericRangeIterator;
/** @constructor */
function $h_sci_NumericRange$NumericRangeIterator() {
}
$h_sci_NumericRange$NumericRangeIterator.prototype = $c_sci_NumericRange$NumericRangeIterator.prototype;
$c_sci_NumericRange$NumericRangeIterator.prototype.knownSize__I = (function() {
  if (this.sci_NumericRange$NumericRangeIterator__f__hasNext) {
    var $x_1 = this.sci_NumericRange$NumericRangeIterator__f_num;
    var this$2 = $n(this.sci_NumericRange$NumericRangeIterator__f_num);
    var this$1 = $n(this.sci_NumericRange$NumericRangeIterator__f_num);
    var lhs = this.sci_NumericRange$NumericRangeIterator__f_lastElement;
    var lhs$1 = new $c_s_math_Integral$IntegralOps(this$1, lhs).$minus__O__O(this.sci_NumericRange$NumericRangeIterator__f__next);
    return ((1 + $n($x_1).toInt__O__I(new $c_s_math_Integral$IntegralOps(this$2, lhs$1).$div__O__O($n(this.sci_NumericRange$NumericRangeIterator__f_self).sci_NumericRange__f_step))) | 0);
  } else {
    return 0;
  }
});
$c_sci_NumericRange$NumericRangeIterator.prototype.hasNext__Z = (function() {
  return this.sci_NumericRange$NumericRangeIterator__f__hasNext;
});
$c_sci_NumericRange$NumericRangeIterator.prototype.next__O = (function() {
  if ((!this.sci_NumericRange$NumericRangeIterator__f__hasNext)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var value = this.sci_NumericRange$NumericRangeIterator__f__next;
  this.sci_NumericRange$NumericRangeIterator__f__hasNext = (!$m_sr_BoxesRunTime$().equals__O__O__Z(value, this.sci_NumericRange$NumericRangeIterator__f_lastElement));
  this.sci_NumericRange$NumericRangeIterator__f__next = $n(this.sci_NumericRange$NumericRangeIterator__f_num).plus__O__O__O(value, $n(this.sci_NumericRange$NumericRangeIterator__f_self).sci_NumericRange__f_step);
  return value;
});
var $d_sci_NumericRange$NumericRangeIterator = new $TypeData().initClass($c_sci_NumericRange$NumericRangeIterator, "scala.collection.immutable.NumericRange$NumericRangeIterator", ({
  sci_NumericRange$NumericRangeIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_RangeIterator(start, step, lastElement, initiallyEmpty) {
  this.sci_RangeIterator__f_step = 0;
  this.sci_RangeIterator__f_lastElement = 0;
  this.sci_RangeIterator__f__hasNext = false;
  this.sci_RangeIterator__f__next = 0;
  this.sci_RangeIterator__f_step = step;
  this.sci_RangeIterator__f_lastElement = lastElement;
  this.sci_RangeIterator__f__hasNext = (!initiallyEmpty);
  this.sci_RangeIterator__f__next = start;
}
$c_sci_RangeIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_RangeIterator.prototype.constructor = $c_sci_RangeIterator;
/** @constructor */
function $h_sci_RangeIterator() {
}
$h_sci_RangeIterator.prototype = $c_sci_RangeIterator.prototype;
$c_sci_RangeIterator.prototype.knownSize__I = (function() {
  return (this.sci_RangeIterator__f__hasNext ? ((1 + $intDiv(((this.sci_RangeIterator__f_lastElement - this.sci_RangeIterator__f__next) | 0), this.sci_RangeIterator__f_step)) | 0) : 0);
});
$c_sci_RangeIterator.prototype.hasNext__Z = (function() {
  return this.sci_RangeIterator__f__hasNext;
});
$c_sci_RangeIterator.prototype.next__I = (function() {
  if ((!this.sci_RangeIterator__f__hasNext)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var value = this.sci_RangeIterator__f__next;
  this.sci_RangeIterator__f__hasNext = (value !== this.sci_RangeIterator__f_lastElement);
  this.sci_RangeIterator__f__next = ((value + this.sci_RangeIterator__f_step) | 0);
  return value;
});
$c_sci_RangeIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    var value = this.sci_RangeIterator__f__next;
    var hi = (value >> 31);
    var value$1 = Math.imul(this.sci_RangeIterator__f_step, n);
    var hi$1 = (value$1 >> 31);
    var lo = ((value + value$1) | 0);
    var hi$2 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value)) ? ((1 + ((hi + hi$1) | 0)) | 0) : ((hi + hi$1) | 0));
    if ((this.sci_RangeIterator__f_step > 0)) {
      var value$2 = this.sci_RangeIterator__f_lastElement;
      var hi$3 = (value$2 >> 31);
      if (((hi$3 === hi$2) ? (((-2147483648) ^ value$2) < ((-2147483648) ^ lo)) : (hi$3 < hi$2))) {
        var this$6__lo = value$2;
        var this$6__hi = hi$3;
      } else {
        var this$6__lo = lo;
        var this$6__hi = hi$2;
      }
      this.sci_RangeIterator__f__next = this$6__lo;
      var value$3 = this.sci_RangeIterator__f_lastElement;
      var hi$4 = (value$3 >> 31);
      this.sci_RangeIterator__f__hasNext = ((hi$2 === hi$4) ? (((-2147483648) ^ lo) <= ((-2147483648) ^ value$3)) : (hi$2 < hi$4));
    } else if ((this.sci_RangeIterator__f_step < 0)) {
      var value$4 = this.sci_RangeIterator__f_lastElement;
      var hi$5 = (value$4 >> 31);
      if (((hi$5 === hi$2) ? (((-2147483648) ^ value$4) > ((-2147483648) ^ lo)) : (hi$5 > hi$2))) {
        var this$10__lo = value$4;
        var this$10__hi = hi$5;
      } else {
        var this$10__lo = lo;
        var this$10__hi = hi$2;
      }
      this.sci_RangeIterator__f__next = this$10__lo;
      var value$5 = this.sci_RangeIterator__f_lastElement;
      var hi$6 = (value$5 >> 31);
      this.sci_RangeIterator__f__hasNext = ((hi$2 === hi$6) ? (((-2147483648) ^ lo) >= ((-2147483648) ^ value$5)) : (hi$2 > hi$6));
    }
  }
  return this;
});
$c_sci_RangeIterator.prototype.next__O = (function() {
  return this.next__I();
});
var $d_sci_RangeIterator = new $TypeData().initClass($c_sci_RangeIterator, "scala.collection.immutable.RangeIterator", ({
  sci_RangeIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_RedBlackTree$EqualsIterator(tree, evidence$19) {
  this.sci_RedBlackTree$TreeIterator__f_root = null;
  this.sci_RedBlackTree$TreeIterator__f_ordering = null;
  this.sci_RedBlackTree$TreeIterator__f_stackOfNexts = null;
  this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = 0;
  this.sci_RedBlackTree$TreeIterator__f_lookahead = null;
  $ct_sci_RedBlackTree$TreeIterator__sci_RedBlackTree$Tree__s_Option__s_math_Ordering__(this, tree, $m_s_None$(), evidence$19);
}
$c_sci_RedBlackTree$EqualsIterator.prototype = new $h_sci_RedBlackTree$TreeIterator();
$c_sci_RedBlackTree$EqualsIterator.prototype.constructor = $c_sci_RedBlackTree$EqualsIterator;
/** @constructor */
function $h_sci_RedBlackTree$EqualsIterator() {
}
$h_sci_RedBlackTree$EqualsIterator.prototype = $c_sci_RedBlackTree$EqualsIterator.prototype;
$c_sci_RedBlackTree$EqualsIterator.prototype.sameKeys__sci_RedBlackTree$EqualsIterator__Z = (function(that) {
  var equal = true;
  while (((equal && (this.sci_RedBlackTree$TreeIterator__f_lookahead !== null)) && ($n(that).sci_RedBlackTree$TreeIterator__f_lookahead !== null))) {
    if ((this.sci_RedBlackTree$TreeIterator__f_lookahead === $n(that).sci_RedBlackTree$TreeIterator__f_lookahead)) {
      if ((this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index === 0)) {
        var $x_1 = null;
      } else {
        this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = (((-1) + this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        var $x_1 = $n(this.sci_RedBlackTree$TreeIterator__f_stackOfNexts).get(this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index);
      }
      this.sci_RedBlackTree$TreeIterator__f_lookahead = $x_1;
      var $x_3 = $n(that);
      var this$1 = $n(that);
      if ((this$1.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index === 0)) {
        var $x_2 = null;
      } else {
        this$1.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = (((-1) + this$1.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        var $x_2 = $n(this$1.sci_RedBlackTree$TreeIterator__f_stackOfNexts).get(this$1.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index);
      }
      $x_3.sci_RedBlackTree$TreeIterator__f_lookahead = $x_2;
    } else {
      var this$2 = $n(this.sci_RedBlackTree$TreeIterator__f_lookahead);
      var $x_4 = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
      var this$3 = $n($n(that).sci_RedBlackTree$TreeIterator__f_lookahead);
      if (Object.is($x_4, this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)) {
        equal = true;
      } else {
        var $x_6 = $n(this.sci_RedBlackTree$TreeIterator__f_ordering);
        var this$4 = $n(this.sci_RedBlackTree$TreeIterator__f_lookahead);
        var $x_5 = this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
        var this$5 = $n($n(that).sci_RedBlackTree$TreeIterator__f_lookahead);
        equal = $n($x_6).equiv__O__O__Z($x_5, this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
      }
      var tree = this.sci_RedBlackTree$TreeIterator__f_lookahead;
      var this$6 = $n(tree);
      this.sci_RedBlackTree$TreeIterator__f_lookahead = this.findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
      var $x_7 = $n(that);
      $n(that);
      var tree$1 = $n(that).sci_RedBlackTree$TreeIterator__f_lookahead;
      var this$8 = $n(tree$1);
      $x_7.sci_RedBlackTree$TreeIterator__f_lookahead = $n(that).findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
    }
  }
  return ((equal && (this.sci_RedBlackTree$TreeIterator__f_lookahead === null)) && ($n(that).sci_RedBlackTree$TreeIterator__f_lookahead === null));
});
$c_sci_RedBlackTree$EqualsIterator.prototype.nextResult__sci_RedBlackTree$Tree__O = (function(tree) {
  $m_s_Predef$().$qmark$qmark$qmark__E();
});
var $d_sci_RedBlackTree$EqualsIterator = new $TypeData().initClass($c_sci_RedBlackTree$EqualsIterator, "scala.collection.immutable.RedBlackTree$EqualsIterator", ({
  sci_RedBlackTree$EqualsIterator: 1,
  sci_RedBlackTree$TreeIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_RedBlackTree$KeysIterator(tree, focus, evidence$21) {
  this.sci_RedBlackTree$TreeIterator__f_root = null;
  this.sci_RedBlackTree$TreeIterator__f_ordering = null;
  this.sci_RedBlackTree$TreeIterator__f_stackOfNexts = null;
  this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = 0;
  this.sci_RedBlackTree$TreeIterator__f_lookahead = null;
  $ct_sci_RedBlackTree$TreeIterator__sci_RedBlackTree$Tree__s_Option__s_math_Ordering__(this, tree, focus, evidence$21);
}
$c_sci_RedBlackTree$KeysIterator.prototype = new $h_sci_RedBlackTree$TreeIterator();
$c_sci_RedBlackTree$KeysIterator.prototype.constructor = $c_sci_RedBlackTree$KeysIterator;
/** @constructor */
function $h_sci_RedBlackTree$KeysIterator() {
}
$h_sci_RedBlackTree$KeysIterator.prototype = $c_sci_RedBlackTree$KeysIterator.prototype;
$c_sci_RedBlackTree$KeysIterator.prototype.nextResult__sci_RedBlackTree$Tree__O = (function(tree) {
  var this$1 = $n(tree);
  return this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
});
var $d_sci_RedBlackTree$KeysIterator = new $TypeData().initClass($c_sci_RedBlackTree$KeysIterator, "scala.collection.immutable.RedBlackTree$KeysIterator", ({
  sci_RedBlackTree$KeysIterator: 1,
  sci_RedBlackTree$TreeIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
function $ct_sci_Set$SetNIterator__I__($thiz, n) {
  $thiz.sci_Set$SetNIterator__f_current = 0;
  $thiz.sci_Set$SetNIterator__f_remainder = n;
  return $thiz;
}
/** @constructor */
function $c_sci_Set$SetNIterator() {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0;
}
$c_sci_Set$SetNIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Set$SetNIterator.prototype.constructor = $c_sci_Set$SetNIterator;
/** @constructor */
function $h_sci_Set$SetNIterator() {
}
$h_sci_Set$SetNIterator.prototype = $c_sci_Set$SetNIterator.prototype;
$c_sci_Set$SetNIterator.prototype.knownSize__I = (function() {
  return this.sci_Set$SetNIterator__f_remainder;
});
$c_sci_Set$SetNIterator.prototype.hasNext__Z = (function() {
  return (this.sci_Set$SetNIterator__f_remainder > 0);
});
$c_sci_Set$SetNIterator.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    var r = this.apply__I__O(this.sci_Set$SetNIterator__f_current);
    this.sci_Set$SetNIterator__f_current = ((1 + this.sci_Set$SetNIterator__f_current) | 0);
    this.sci_Set$SetNIterator__f_remainder = (((-1) + this.sci_Set$SetNIterator__f_remainder) | 0);
    return r;
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
});
$c_sci_Set$SetNIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    this.sci_Set$SetNIterator__f_current = ((this.sci_Set$SetNIterator__f_current + n) | 0);
    var b = ((this.sci_Set$SetNIterator__f_remainder - n) | 0);
    this.sci_Set$SetNIterator__f_remainder = ((b < 0) ? 0 : b);
  }
  return this;
});
/** @constructor */
function $c_sci_SetHashIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  this.sci_SetHashIterator__f_hash = 0;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
  this.sci_SetHashIterator__f_hash = 0;
}
$c_sci_SetHashIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_SetHashIterator.prototype.constructor = $c_sci_SetHashIterator;
/** @constructor */
function $h_sci_SetHashIterator() {
}
$h_sci_SetHashIterator.prototype = $c_sci_SetHashIterator.prototype;
$c_sci_SetHashIterator.prototype.hashCode__I = (function() {
  return this.sci_SetHashIterator__f_hash;
});
$c_sci_SetHashIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  this.sci_SetHashIterator__f_hash = $n(this.sci_ChampBaseIterator__f_currentValueNode).getHash__I__I(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return this;
});
var $d_sci_SetHashIterator = new $TypeData().initClass($c_sci_SetHashIterator, "scala.collection.immutable.SetHashIterator", ({
  sci_SetHashIterator: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_SetIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
}
$c_sci_SetIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_SetIterator.prototype.constructor = $c_sci_SetIterator;
/** @constructor */
function $h_sci_SetIterator() {
}
$h_sci_SetIterator.prototype = $c_sci_SetIterator.prototype;
$c_sci_SetIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var payload = $n($as_sci_SetNode(this.sci_ChampBaseIterator__f_currentValueNode)).getPayload__I__O(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return payload;
});
var $d_sci_SetIterator = new $TypeData().initClass($c_sci_SetIterator, "scala.collection.immutable.SetIterator", ({
  sci_SetIterator: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
function $f_sci_SetOps__diff__sc_Set__sci_SetOps($thiz, that) {
  var z = $thiz.empty__O();
  var f = ((result$2, elem$2) => {
    var result = $as_sci_SetOps(result$2);
    if ($n(that).contains__O__Z(elem$2)) {
      return result;
    } else {
      var this$2 = $n(result);
      return this$2.incl__O__sci_SetOps(elem$2);
    }
  });
  if ($is_sc_IndexedSeq($thiz)) {
    var x2 = $as_sc_IndexedSeq($thiz);
    var at = 0;
    var end = $n(x2).length__I();
    var acc = z;
    var $x_1;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var arg1 = acc;
        var arg2 = $n(x2).apply__I__O(at);
        var temp$acc = f(arg1, arg2);
        at = temp$at;
        acc = temp$acc;
        continue;
      }
      var $x_1 = acc;
      break;
    }
  } else {
    var result$1 = z;
    var it = $thiz.iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var arg1$1 = result$1;
      var arg2$1 = $n(it).next__O();
      result$1 = f(arg1$1, arg2$1);
    }
    var $x_1 = result$1;
  }
  return $as_sci_SetOps($x_1);
}
function $is_sci_SetOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_SetOps)));
}
function $as_sci_SetOps(obj) {
  return (($is_sci_SetOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SetOps"));
}
function $isArrayOf_sci_SetOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SetOps)));
}
function $asArrayOf_sci_SetOps(obj, depth) {
  return (($isArrayOf_sci_SetOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SetOps;", depth));
}
/** @constructor */
function $c_sci_SetReverseIterator(rootNode) {
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseReverseIterator__f_currentValueNode = null;
  this.sci_ChampBaseReverseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseReverseIterator__f_nodeIndex = null;
  this.sci_ChampBaseReverseIterator__f_nodeStack = null;
  $ct_sci_ChampBaseReverseIterator__sci_Node__(this, rootNode);
}
$c_sci_SetReverseIterator.prototype = new $h_sci_ChampBaseReverseIterator();
$c_sci_SetReverseIterator.prototype.constructor = $c_sci_SetReverseIterator;
/** @constructor */
function $h_sci_SetReverseIterator() {
}
$h_sci_SetReverseIterator.prototype = $c_sci_SetReverseIterator.prototype;
$c_sci_SetReverseIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var payload = $n($as_sci_SetNode(this.sci_ChampBaseReverseIterator__f_currentValueNode)).getPayload__I__O(this.sci_ChampBaseReverseIterator__f_currentValueCursor);
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = (((-1) + this.sci_ChampBaseReverseIterator__f_currentValueCursor) | 0);
  return payload;
});
var $d_sci_SetReverseIterator = new $TypeData().initClass($c_sci_SetReverseIterator, "scala.collection.immutable.SetReverseIterator", ({
  sci_SetReverseIterator: 1,
  sci_ChampBaseReverseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_SortedSet$() {
  this.sc_EvidenceIterableFactory$Delegate__f_delegate = null;
  var delegate = $m_sci_TreeSet$();
  $ct_sc_EvidenceIterableFactory$Delegate__sc_EvidenceIterableFactory__(this, delegate);
}
$c_sci_SortedSet$.prototype = new $h_sc_SortedIterableFactory$Delegate();
$c_sci_SortedSet$.prototype.constructor = $c_sci_SortedSet$;
/** @constructor */
function $h_sci_SortedSet$() {
}
$h_sci_SortedSet$.prototype = $c_sci_SortedSet$.prototype;
var $d_sci_SortedSet$ = new $TypeData().initClass($c_sci_SortedSet$, "scala.collection.immutable.SortedSet$", ({
  sci_SortedSet$: 1,
  sc_SortedIterableFactory$Delegate: 1,
  sc_EvidenceIterableFactory$Delegate: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1,
  sc_SortedIterableFactory: 1
}));
var $n_sci_SortedSet$;
function $m_sci_SortedSet$() {
  if ((!$n_sci_SortedSet$)) {
    $n_sci_SortedSet$ = new $c_sci_SortedSet$();
  }
  return $n_sci_SortedSet$;
}
function $ct_scm_ArrayBuilder__($thiz) {
  $thiz.scm_ArrayBuilder__f_capacity = 0;
  return $thiz;
}
/** @constructor */
function $c_scm_ArrayBuilder() {
  this.scm_ArrayBuilder__f_capacity = 0;
}
$c_scm_ArrayBuilder.prototype = new $h_O();
$c_scm_ArrayBuilder.prototype.constructor = $c_scm_ArrayBuilder;
/** @constructor */
function $h_scm_ArrayBuilder() {
}
$h_scm_ArrayBuilder.prototype = $c_scm_ArrayBuilder.prototype;
$c_scm_ArrayBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_scm_ArrayBuilder.prototype.addAll__O__scm_ArrayBuilder = (function(xs) {
  var length = $m_jl_reflect_Array$().getLength__O__I(xs);
  return this.addAll__O__I__I__scm_ArrayBuilder$generic(xs, 0, length);
});
/** @constructor */
function $c_scm_ArraySeq$() {
  this.scm_ArraySeq$__f_untagged = null;
  this.scm_ArraySeq$__f_EmptyArraySeq = null;
  $n_scm_ArraySeq$ = this;
  this.scm_ArraySeq$__f_untagged = new $c_sc_ClassTagSeqFactory$AnySeqDelegate(this);
  this.scm_ArraySeq$__f_EmptyArraySeq = new $c_scm_ArraySeq$ofRef(new $ac_O(0));
}
$c_scm_ArraySeq$.prototype = new $h_O();
$c_scm_ArraySeq$.prototype.constructor = $c_scm_ArraySeq$;
/** @constructor */
function $h_scm_ArraySeq$() {
}
$h_scm_ArraySeq$.prototype = $c_scm_ArraySeq$.prototype;
$c_scm_ArraySeq$.prototype.apply__sci_Seq__O__O = (function(xs, evidence$7) {
  return this.from__sc_IterableOnce__s_reflect_ClassTag__scm_ArraySeq(xs, $as_s_reflect_ClassTag(evidence$7));
});
$c_scm_ArraySeq$.prototype.from__sc_IterableOnce__s_reflect_ClassTag__scm_ArraySeq = (function(it, evidence$2) {
  return this.make__O__scm_ArraySeq($m_s_Array$().from__sc_IterableOnce__s_reflect_ClassTag__O(it, evidence$2));
});
$c_scm_ArraySeq$.prototype.newBuilder__s_reflect_ClassTag__scm_Builder = (function(evidence$3) {
  var this$4 = new $c_scm_ArrayBuilder$generic($n(evidence$3).runtimeClass__jl_Class());
  var f = new $c_sjsr_AnonFunction1(((x$2) => $m_scm_ArraySeq$().make__O__scm_ArraySeq(x$2)));
  return new $c_scm_Builder$$anon$1(this$4, f);
});
$c_scm_ArraySeq$.prototype.make__O__scm_ArraySeq = (function(x) {
  if ((x === null)) {
    return null;
  } else if ((x instanceof $ac_O)) {
    var x3 = $asArrayOf_O(x, 1);
    return new $c_scm_ArraySeq$ofRef(x3);
  } else if ((x instanceof $ac_I)) {
    var x4 = $asArrayOf_I(x, 1);
    return new $c_scm_ArraySeq$ofInt(x4);
  } else if ((x instanceof $ac_D)) {
    var x5 = $asArrayOf_D(x, 1);
    return new $c_scm_ArraySeq$ofDouble(x5);
  } else if ((x instanceof $ac_J)) {
    var x6 = $asArrayOf_J(x, 1);
    return new $c_scm_ArraySeq$ofLong(x6);
  } else if ((x instanceof $ac_F)) {
    var x7 = $asArrayOf_F(x, 1);
    return new $c_scm_ArraySeq$ofFloat(x7);
  } else if ((x instanceof $ac_C)) {
    var x8 = $asArrayOf_C(x, 1);
    return new $c_scm_ArraySeq$ofChar(x8);
  } else if ((x instanceof $ac_B)) {
    var x9 = $asArrayOf_B(x, 1);
    return new $c_scm_ArraySeq$ofByte(x9);
  } else if ((x instanceof $ac_S)) {
    var x10 = $asArrayOf_S(x, 1);
    return new $c_scm_ArraySeq$ofShort(x10);
  } else if ((x instanceof $ac_Z)) {
    var x11 = $asArrayOf_Z(x, 1);
    return new $c_scm_ArraySeq$ofBoolean(x11);
  } else if ($isArrayOf_jl_Void(x, 1)) {
    var x12 = $asArrayOf_jl_Void(x, 1);
    return new $c_scm_ArraySeq$ofUnit(x12);
  } else {
    throw new $c_s_MatchError(x);
  }
});
$c_scm_ArraySeq$.prototype.newBuilder__O__scm_Builder = (function(evidence$12) {
  return this.newBuilder__s_reflect_ClassTag__scm_Builder($as_s_reflect_ClassTag(evidence$12));
});
$c_scm_ArraySeq$.prototype.from__sc_IterableOnce__O__O = (function(it, evidence$5) {
  return this.from__sc_IterableOnce__s_reflect_ClassTag__scm_ArraySeq(it, $as_s_reflect_ClassTag(evidence$5));
});
$c_scm_ArraySeq$.prototype.empty__O__O = (function(evidence$6) {
  $as_s_reflect_ClassTag(evidence$6);
  return this.scm_ArraySeq$__f_EmptyArraySeq;
});
var $d_scm_ArraySeq$ = new $TypeData().initClass($c_scm_ArraySeq$, "scala.collection.mutable.ArraySeq$", ({
  scm_ArraySeq$: 1,
  sc_StrictOptimizedClassTagSeqFactory: 1,
  sc_ClassTagSeqFactory: 1,
  sc_ClassTagIterableFactory: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_scm_ArraySeq$;
function $m_scm_ArraySeq$() {
  if ((!$n_scm_ArraySeq$)) {
    $n_scm_ArraySeq$ = new $c_scm_ArraySeq$();
  }
  return $n_scm_ArraySeq$;
}
/** @constructor */
function $c_scm_HashMap$$anon$1(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
}
$c_scm_HashMap$$anon$1.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$1.prototype.constructor = $c_scm_HashMap$$anon$1;
/** @constructor */
function $h_scm_HashMap$$anon$1() {
}
$h_scm_HashMap$$anon$1.prototype = $c_scm_HashMap$$anon$1.prototype;
$c_scm_HashMap$$anon$1.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  return new $c_T2($n(nd).scm_HashMap$Node__f__key, $n(nd).scm_HashMap$Node__f__value);
});
var $d_scm_HashMap$$anon$1 = new $TypeData().initClass($c_scm_HashMap$$anon$1, "scala.collection.mutable.HashMap$$anon$1", ({
  scm_HashMap$$anon$1: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_scm_HashMap$$anon$2(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
}
$c_scm_HashMap$$anon$2.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$2.prototype.constructor = $c_scm_HashMap$$anon$2;
/** @constructor */
function $h_scm_HashMap$$anon$2() {
}
$h_scm_HashMap$$anon$2.prototype = $c_scm_HashMap$$anon$2.prototype;
$c_scm_HashMap$$anon$2.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  return $n(nd).scm_HashMap$Node__f__key;
});
var $d_scm_HashMap$$anon$2 = new $TypeData().initClass($c_scm_HashMap$$anon$2, "scala.collection.mutable.HashMap$$anon$2", ({
  scm_HashMap$$anon$2: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_scm_HashMap$$anon$3(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
}
$c_scm_HashMap$$anon$3.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$3.prototype.constructor = $c_scm_HashMap$$anon$3;
/** @constructor */
function $h_scm_HashMap$$anon$3() {
}
$h_scm_HashMap$$anon$3.prototype = $c_scm_HashMap$$anon$3.prototype;
$c_scm_HashMap$$anon$3.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  return $n(nd).scm_HashMap$Node__f__value;
});
var $d_scm_HashMap$$anon$3 = new $TypeData().initClass($c_scm_HashMap$$anon$3, "scala.collection.mutable.HashMap$$anon$3", ({
  scm_HashMap$$anon$3: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_scm_HashMap$$anon$4(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
}
$c_scm_HashMap$$anon$4.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$4.prototype.constructor = $c_scm_HashMap$$anon$4;
/** @constructor */
function $h_scm_HashMap$$anon$4() {
}
$h_scm_HashMap$$anon$4.prototype = $c_scm_HashMap$$anon$4.prototype;
$c_scm_HashMap$$anon$4.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  return nd;
});
var $d_scm_HashMap$$anon$4 = new $TypeData().initClass($c_scm_HashMap$$anon$4, "scala.collection.mutable.HashMap$$anon$4", ({
  scm_HashMap$$anon$4: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_scm_HashMap$$anon$5(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  this.scm_HashMap$$anon$5__f_hash = 0;
  this.scm_HashMap$$anon$5__f_$outer = null;
  $n(outer);
  this.scm_HashMap$$anon$5__f_$outer = outer;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
  this.scm_HashMap$$anon$5__f_hash = 0;
}
$c_scm_HashMap$$anon$5.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$5.prototype.constructor = $c_scm_HashMap$$anon$5;
/** @constructor */
function $h_scm_HashMap$$anon$5() {
}
$h_scm_HashMap$$anon$5.prototype = $c_scm_HashMap$$anon$5.prototype;
$c_scm_HashMap$$anon$5.prototype.hashCode__I = (function() {
  return this.scm_HashMap$$anon$5__f_hash;
});
$c_scm_HashMap$$anon$5.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  var $x_1 = $m_s_util_hashing_MurmurHash3$();
  $n(this.scm_HashMap$$anon$5__f_$outer);
  var improvedHash = $n(nd).scm_HashMap$Node__f__hash;
  var x = $n(nd).scm_HashMap$Node__f__value;
  this.scm_HashMap$$anon$5__f_hash = $n($x_1).tuple2Hash__O__O__I((improvedHash ^ ((improvedHash >>> 16) | 0)), $m_sr_Statics$().anyHash__O__I(x));
  return this;
});
var $d_scm_HashMap$$anon$5 = new $TypeData().initClass($c_scm_HashMap$$anon$5, "scala.collection.mutable.HashMap$$anon$5", ({
  scm_HashMap$$anon$5: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_scm_HashSet$$anon$1(outer) {
  this.scm_HashSet$HashSetIterator__f_i = 0;
  this.scm_HashSet$HashSetIterator__f_node = null;
  this.scm_HashSet$HashSetIterator__f_len = 0;
  this.scm_HashSet$HashSetIterator__f_$outer = null;
  $ct_scm_HashSet$HashSetIterator__scm_HashSet__(this, outer);
}
$c_scm_HashSet$$anon$1.prototype = new $h_scm_HashSet$HashSetIterator();
$c_scm_HashSet$$anon$1.prototype.constructor = $c_scm_HashSet$$anon$1;
/** @constructor */
function $h_scm_HashSet$$anon$1() {
}
$h_scm_HashSet$$anon$1.prototype = $c_scm_HashSet$$anon$1.prototype;
$c_scm_HashSet$$anon$1.prototype.extract__scm_HashSet$Node__O = (function(nd) {
  return $n(nd).scm_HashSet$Node__f__key;
});
var $d_scm_HashSet$$anon$1 = new $TypeData().initClass($c_scm_HashSet$$anon$1, "scala.collection.mutable.HashSet$$anon$1", ({
  scm_HashSet$$anon$1: 1,
  scm_HashSet$HashSetIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_scm_HashSet$$anon$2(outer) {
  this.scm_HashSet$HashSetIterator__f_i = 0;
  this.scm_HashSet$HashSetIterator__f_node = null;
  this.scm_HashSet$HashSetIterator__f_len = 0;
  this.scm_HashSet$HashSetIterator__f_$outer = null;
  $ct_scm_HashSet$HashSetIterator__scm_HashSet__(this, outer);
}
$c_scm_HashSet$$anon$2.prototype = new $h_scm_HashSet$HashSetIterator();
$c_scm_HashSet$$anon$2.prototype.constructor = $c_scm_HashSet$$anon$2;
/** @constructor */
function $h_scm_HashSet$$anon$2() {
}
$h_scm_HashSet$$anon$2.prototype = $c_scm_HashSet$$anon$2.prototype;
$c_scm_HashSet$$anon$2.prototype.extract__scm_HashSet$Node__O = (function(nd) {
  return nd;
});
var $d_scm_HashSet$$anon$2 = new $TypeData().initClass($c_scm_HashSet$$anon$2, "scala.collection.mutable.HashSet$$anon$2", ({
  scm_HashSet$$anon$2: 1,
  scm_HashSet$HashSetIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_scm_HashSet$$anon$3(outer) {
  this.scm_HashSet$HashSetIterator__f_i = 0;
  this.scm_HashSet$HashSetIterator__f_node = null;
  this.scm_HashSet$HashSetIterator__f_len = 0;
  this.scm_HashSet$HashSetIterator__f_$outer = null;
  this.scm_HashSet$$anon$3__f_hash = 0;
  this.scm_HashSet$$anon$3__f_$outer = null;
  $n(outer);
  this.scm_HashSet$$anon$3__f_$outer = outer;
  $ct_scm_HashSet$HashSetIterator__scm_HashSet__(this, outer);
  this.scm_HashSet$$anon$3__f_hash = 0;
}
$c_scm_HashSet$$anon$3.prototype = new $h_scm_HashSet$HashSetIterator();
$c_scm_HashSet$$anon$3.prototype.constructor = $c_scm_HashSet$$anon$3;
/** @constructor */
function $h_scm_HashSet$$anon$3() {
}
$h_scm_HashSet$$anon$3.prototype = $c_scm_HashSet$$anon$3.prototype;
$c_scm_HashSet$$anon$3.prototype.hashCode__I = (function() {
  return this.scm_HashSet$$anon$3__f_hash;
});
$c_scm_HashSet$$anon$3.prototype.extract__scm_HashSet$Node__O = (function(nd) {
  var this$1 = $n(this.scm_HashSet$$anon$3__f_$outer);
  var improvedHash = $n(nd).scm_HashSet$Node__f__hash;
  this.scm_HashSet$$anon$3__f_hash = this$1.scala$collection$mutable$HashSet$$improveHash__I__I(improvedHash);
  return this;
});
var $d_scm_HashSet$$anon$3 = new $TypeData().initClass($c_scm_HashSet$$anon$3, "scala.collection.mutable.HashSet$$anon$3", ({
  scm_HashSet$$anon$3: 1,
  scm_HashSet$HashSetIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_scm_RedBlackTree$KeysIterator(tree, start, end, evidence$7) {
  this.scm_RedBlackTree$TreeIterator__f_end = null;
  this.scm_RedBlackTree$TreeIterator__f_ord = null;
  this.scm_RedBlackTree$TreeIterator__f_nextNode = null;
  $ct_scm_RedBlackTree$TreeIterator__scm_RedBlackTree$Tree__s_Option__s_Option__s_math_Ordering__(this, tree, start, end, evidence$7);
}
$c_scm_RedBlackTree$KeysIterator.prototype = new $h_scm_RedBlackTree$TreeIterator();
$c_scm_RedBlackTree$KeysIterator.prototype.constructor = $c_scm_RedBlackTree$KeysIterator;
/** @constructor */
function $h_scm_RedBlackTree$KeysIterator() {
}
$h_scm_RedBlackTree$KeysIterator.prototype = $c_scm_RedBlackTree$KeysIterator.prototype;
var $d_scm_RedBlackTree$KeysIterator = new $TypeData().initClass($c_scm_RedBlackTree$KeysIterator, "scala.collection.mutable.RedBlackTree$KeysIterator", ({
  scm_RedBlackTree$KeysIterator: 1,
  scm_RedBlackTree$TreeIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_scm_SortedSet$() {
  this.sc_EvidenceIterableFactory$Delegate__f_delegate = null;
  var delegate = $m_scm_TreeSet$();
  $ct_sc_EvidenceIterableFactory$Delegate__sc_EvidenceIterableFactory__(this, delegate);
}
$c_scm_SortedSet$.prototype = new $h_sc_SortedIterableFactory$Delegate();
$c_scm_SortedSet$.prototype.constructor = $c_scm_SortedSet$;
/** @constructor */
function $h_scm_SortedSet$() {
}
$h_scm_SortedSet$.prototype = $c_scm_SortedSet$.prototype;
var $d_scm_SortedSet$ = new $TypeData().initClass($c_scm_SortedSet$, "scala.collection.mutable.SortedSet$", ({
  scm_SortedSet$: 1,
  sc_SortedIterableFactory$Delegate: 1,
  sc_EvidenceIterableFactory$Delegate: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1,
  sc_SortedIterableFactory: 1
}));
var $n_scm_SortedSet$;
function $m_scm_SortedSet$() {
  if ((!$n_scm_SortedSet$)) {
    $n_scm_SortedSet$ = new $c_scm_SortedSet$();
  }
  return $n_scm_SortedSet$;
}
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$1() {
}
$c_s_concurrent_duration_Duration$$anon$1.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$c_s_concurrent_duration_Duration$$anon$1.prototype.constructor = $c_s_concurrent_duration_Duration$$anon$1;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$1() {
}
$h_s_concurrent_duration_Duration$$anon$1.prototype = $c_s_concurrent_duration_Duration$$anon$1.prototype;
$c_s_concurrent_duration_Duration$$anon$1.prototype.toString__T = (function() {
  return "Duration.Undefined";
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.equals__O__Z = (function(other) {
  return false;
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.$plus__s_concurrent_duration_Duration__s_concurrent_duration_Duration = (function(other) {
  return this;
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  return ((other === this) ? 0 : 1);
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.compare__O__I = (function(that) {
  return this.compare__s_concurrent_duration_Duration__I($as_s_concurrent_duration_Duration(that));
});
var $d_s_concurrent_duration_Duration$$anon$1 = new $TypeData().initClass($c_s_concurrent_duration_Duration$$anon$1, "scala.concurrent.duration.Duration$$anon$1", ({
  s_concurrent_duration_Duration$$anon$1: 1,
  s_concurrent_duration_Duration$Infinite: 1,
  s_concurrent_duration_Duration: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
}));
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$2() {
}
$c_s_concurrent_duration_Duration$$anon$2.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$c_s_concurrent_duration_Duration$$anon$2.prototype.constructor = $c_s_concurrent_duration_Duration$$anon$2;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$2() {
}
$h_s_concurrent_duration_Duration$$anon$2.prototype = $c_s_concurrent_duration_Duration$$anon$2.prototype;
$c_s_concurrent_duration_Duration$$anon$2.prototype.toString__T = (function() {
  return "Duration.Inf";
});
$c_s_concurrent_duration_Duration$$anon$2.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  return ((other === $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Undefined) ? (-1) : ((other === this) ? 0 : 1));
});
$c_s_concurrent_duration_Duration$$anon$2.prototype.compare__O__I = (function(that) {
  return this.compare__s_concurrent_duration_Duration__I($as_s_concurrent_duration_Duration(that));
});
var $d_s_concurrent_duration_Duration$$anon$2 = new $TypeData().initClass($c_s_concurrent_duration_Duration$$anon$2, "scala.concurrent.duration.Duration$$anon$2", ({
  s_concurrent_duration_Duration$$anon$2: 1,
  s_concurrent_duration_Duration$Infinite: 1,
  s_concurrent_duration_Duration: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
}));
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$3() {
}
$c_s_concurrent_duration_Duration$$anon$3.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$c_s_concurrent_duration_Duration$$anon$3.prototype.constructor = $c_s_concurrent_duration_Duration$$anon$3;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$3() {
}
$h_s_concurrent_duration_Duration$$anon$3.prototype = $c_s_concurrent_duration_Duration$$anon$3.prototype;
$c_s_concurrent_duration_Duration$$anon$3.prototype.toString__T = (function() {
  return "Duration.MinusInf";
});
$c_s_concurrent_duration_Duration$$anon$3.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  return ((other === this) ? 0 : (-1));
});
$c_s_concurrent_duration_Duration$$anon$3.prototype.compare__O__I = (function(that) {
  return this.compare__s_concurrent_duration_Duration__I($as_s_concurrent_duration_Duration(that));
});
var $d_s_concurrent_duration_Duration$$anon$3 = new $TypeData().initClass($c_s_concurrent_duration_Duration$$anon$3, "scala.concurrent.duration.Duration$$anon$3", ({
  s_concurrent_duration_Duration$$anon$3: 1,
  s_concurrent_duration_Duration$Infinite: 1,
  s_concurrent_duration_Duration: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
}));
function $f_s_math_Numeric__sign__O__O($thiz, x) {
  var y = $thiz.fromInt__I__O(0);
  if ($f_s_math_Ordering__lt__O__O__Z($thiz, x, y)) {
    return $thiz.negate__O__O($thiz.fromInt__I__O(1));
  } else {
    var y$1 = $thiz.fromInt__I__O(0);
    if ($f_s_math_Ordering__gt__O__O__Z($thiz, x, y$1)) {
      return $thiz.fromInt__I__O(1);
    } else {
      return $thiz.fromInt__I__O(0);
    }
  }
}
function $is_s_math_Numeric(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_math_Numeric)));
}
function $as_s_math_Numeric(obj) {
  return (($is_s_math_Numeric(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Numeric"));
}
function $isArrayOf_s_math_Numeric(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Numeric)));
}
function $asArrayOf_s_math_Numeric(obj, depth) {
  return (($isArrayOf_s_math_Numeric(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Numeric;", depth));
}
/** @constructor */
function $c_s_math_Ordering$$anon$1(outer, f$1) {
  this.s_math_Ordering$$anon$1__f_$outer = null;
  this.s_math_Ordering$$anon$1__f_f$1 = null;
  $n(outer);
  this.s_math_Ordering$$anon$1__f_$outer = outer;
  this.s_math_Ordering$$anon$1__f_f$1 = f$1;
}
$c_s_math_Ordering$$anon$1.prototype = new $h_O();
$c_s_math_Ordering$$anon$1.prototype.constructor = $c_s_math_Ordering$$anon$1;
/** @constructor */
function $h_s_math_Ordering$$anon$1() {
}
$h_s_math_Ordering$$anon$1.prototype = $c_s_math_Ordering$$anon$1.prototype;
$c_s_math_Ordering$$anon$1.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$$anon$1.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$$anon$1.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_Ordering$$anon$1.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Ordering$$anon$1.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Ordering$$anon$1.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Ordering$$anon$1.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Ordering$$anon$1.prototype.compare__O__O__I = (function(x, y) {
  return $n(this.s_math_Ordering$$anon$1__f_$outer).compare__O__O__I($n(this.s_math_Ordering$$anon$1__f_f$1).apply__O__O(x), $n(this.s_math_Ordering$$anon$1__f_f$1).apply__O__O(y));
});
var $d_s_math_Ordering$$anon$1 = new $TypeData().initClass($c_s_math_Ordering$$anon$1, "scala.math.Ordering$$anon$1", ({
  s_math_Ordering$$anon$1: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
}));
function $f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z($thiz, other) {
  return (other === $thiz.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse);
}
/** @constructor */
function $c_s_math_Ordering$Reverse(outer) {
  this.s_math_Ordering$Reverse__f_outer = null;
  this.s_math_Ordering$Reverse__f_outer = outer;
}
$c_s_math_Ordering$Reverse.prototype = new $h_O();
$c_s_math_Ordering$Reverse.prototype.constructor = $c_s_math_Ordering$Reverse;
/** @constructor */
function $h_s_math_Ordering$Reverse() {
}
$h_s_math_Ordering$Reverse.prototype = $c_s_math_Ordering$Reverse.prototype;
$c_s_math_Ordering$Reverse.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  var x$2 = this.s_math_Ordering$Reverse__f_outer;
  return ((other === null) ? (x$2 === null) : $n(other).equals__O__Z(x$2));
});
$c_s_math_Ordering$Reverse.prototype.compare__O__O__I = (function(x, y) {
  return $n(this.s_math_Ordering$Reverse__f_outer).compare__O__O__I(y, x);
});
$c_s_math_Ordering$Reverse.prototype.lteq__O__O__Z = (function(x, y) {
  return $n(this.s_math_Ordering$Reverse__f_outer).lteq__O__O__Z(y, x);
});
$c_s_math_Ordering$Reverse.prototype.gteq__O__O__Z = (function(x, y) {
  return $n(this.s_math_Ordering$Reverse__f_outer).gteq__O__O__Z(y, x);
});
$c_s_math_Ordering$Reverse.prototype.gt__O__O__Z = (function(x, y) {
  return $n(this.s_math_Ordering$Reverse__f_outer).gt__O__O__Z(y, x);
});
$c_s_math_Ordering$Reverse.prototype.equiv__O__O__Z = (function(x, y) {
  return $n(this.s_math_Ordering$Reverse__f_outer).equiv__O__O__Z(y, x);
});
$c_s_math_Ordering$Reverse.prototype.max__O__O__O = (function(x, y) {
  return $n(this.s_math_Ordering$Reverse__f_outer).min__O__O__O(x, y);
});
$c_s_math_Ordering$Reverse.prototype.min__O__O__O = (function(x, y) {
  return $n(this.s_math_Ordering$Reverse__f_outer).max__O__O__O(x, y);
});
$c_s_math_Ordering$Reverse.prototype.equals__O__Z = (function(obj) {
  if ((obj !== null)) {
    if ((this === obj)) {
      return true;
    }
  }
  if ((obj instanceof $c_s_math_Ordering$Reverse)) {
    var x3 = $as_s_math_Ordering$Reverse(obj);
    var x = this.s_math_Ordering$Reverse__f_outer;
    var x$2 = $n(x3).s_math_Ordering$Reverse__f_outer;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  }
  return false;
});
$c_s_math_Ordering$Reverse.prototype.hashCode__I = (function() {
  return Math.imul(41, $n(this.s_math_Ordering$Reverse__f_outer).hashCode__I());
});
function $as_s_math_Ordering$Reverse(obj) {
  return (((obj instanceof $c_s_math_Ordering$Reverse) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Ordering$Reverse"));
}
function $isArrayOf_s_math_Ordering$Reverse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Ordering$Reverse)));
}
function $asArrayOf_s_math_Ordering$Reverse(obj, depth) {
  return (($isArrayOf_s_math_Ordering$Reverse(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Ordering$Reverse;", depth));
}
var $d_s_math_Ordering$Reverse = new $TypeData().initClass($c_s_math_Ordering$Reverse, "scala.math.Ordering$Reverse", ({
  s_math_Ordering$Reverse: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_reflect_ClassTag$GenericClassTag(runtimeClass) {
  this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass = null;
  this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass = runtimeClass;
}
$c_s_reflect_ClassTag$GenericClassTag.prototype = new $h_O();
$c_s_reflect_ClassTag$GenericClassTag.prototype.constructor = $c_s_reflect_ClassTag$GenericClassTag;
/** @constructor */
function $h_s_reflect_ClassTag$GenericClassTag() {
}
$h_s_reflect_ClassTag$GenericClassTag.prototype = $c_s_reflect_ClassTag$GenericClassTag.prototype;
$c_s_reflect_ClassTag$GenericClassTag.prototype.unapply__O__s_Option = (function(x) {
  return $f_s_reflect_ClassTag__unapply__O__s_Option(this, x);
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.equals__O__Z = (function(x) {
  return $f_s_reflect_ClassTag__equals__O__Z(this, x);
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.hashCode__I = (function() {
  var x = this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass;
  return $m_sr_Statics$().anyHash__O__I(x);
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.toString__T = (function() {
  return $p_s_reflect_ClassTag__prettyprint$1__jl_Class__T(this, this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass);
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.runtimeClass__jl_Class = (function() {
  return this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass;
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.newArray__I__O = (function(len) {
  var componentType = this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass;
  return $m_jl_reflect_Array$().newInstance__jl_Class__I__O(componentType, len);
});
var $d_s_reflect_ClassTag$GenericClassTag = new $TypeData().initClass($c_s_reflect_ClassTag$GenericClassTag, "scala.reflect.ClassTag$GenericClassTag", ({
  s_reflect_ClassTag$GenericClassTag: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
function $as_Ltyrian_PropertyBoolean(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.PropertyBoolean"));
}
function $isArrayOf_Ltyrian_PropertyBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_PropertyBoolean)));
}
function $asArrayOf_Ltyrian_PropertyBoolean(obj, depth) {
  return (($isArrayOf_Ltyrian_PropertyBoolean(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.PropertyBoolean;", depth));
}
function $as_Ltyrian_PropertyString(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.PropertyString"));
}
function $isArrayOf_Ltyrian_PropertyString(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_PropertyString)));
}
function $asArrayOf_Ltyrian_PropertyString(obj, depth) {
  return (($isArrayOf_Ltyrian_PropertyString(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.PropertyString;", depth));
}
/** @constructor */
function $c_Ltyrian_RawTag(name, attributes, innerHTML, key) {
  this.Ltyrian_RawTag__f_name = null;
  this.Ltyrian_RawTag__f_attributes = null;
  this.Ltyrian_RawTag__f_innerHTML = null;
  this.Ltyrian_RawTag__f_key = null;
  this.Ltyrian_RawTag__f_name = name;
  this.Ltyrian_RawTag__f_attributes = attributes;
  this.Ltyrian_RawTag__f_innerHTML = innerHTML;
  this.Ltyrian_RawTag__f_key = key;
}
$c_Ltyrian_RawTag.prototype = new $h_O();
$c_Ltyrian_RawTag.prototype.constructor = $c_Ltyrian_RawTag;
/** @constructor */
function $h_Ltyrian_RawTag() {
}
$h_Ltyrian_RawTag.prototype = $c_Ltyrian_RawTag.prototype;
$c_Ltyrian_RawTag.prototype.toString__T = (function() {
  return $m_Ltyrian_HTMLRendering$package$().render__Ltyrian_Html__T(this);
});
$c_Ltyrian_RawTag.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_RawTag.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Ltyrian_RawTag.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_RawTag)) {
    var x$0$2 = $as_Ltyrian_RawTag(x$0);
    if ((this.Ltyrian_RawTag__f_name === $n(x$0$2).Ltyrian_RawTag__f_name)) {
      var x = this.Ltyrian_RawTag__f_attributes;
      var x$2 = $n(x$0$2).Ltyrian_RawTag__f_attributes;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if (($x_1 && (this.Ltyrian_RawTag__f_innerHTML === $n(x$0$2).Ltyrian_RawTag__f_innerHTML))) {
      var x$3 = this.Ltyrian_RawTag__f_key;
      var x$4 = $n(x$0$2).Ltyrian_RawTag__f_key;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ltyrian_RawTag.prototype.productArity__I = (function() {
  return 4;
});
$c_Ltyrian_RawTag.prototype.productPrefix__T = (function() {
  return "RawTag";
});
$c_Ltyrian_RawTag.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Ltyrian_RawTag__f_name;
      break;
    }
    case 1: {
      return this.Ltyrian_RawTag__f_attributes;
      break;
    }
    case 2: {
      return this.Ltyrian_RawTag__f_innerHTML;
      break;
    }
    case 3: {
      return this.Ltyrian_RawTag__f_key;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Ltyrian_RawTag(obj) {
  return (((obj instanceof $c_Ltyrian_RawTag) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.RawTag"));
}
function $isArrayOf_Ltyrian_RawTag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_RawTag)));
}
function $asArrayOf_Ltyrian_RawTag(obj, depth) {
  return (($isArrayOf_Ltyrian_RawTag(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.RawTag;", depth));
}
var $d_Ltyrian_RawTag = new $TypeData().initClass($c_Ltyrian_RawTag, "tyrian.RawTag", ({
  Ltyrian_RawTag: 1,
  Ltyrian_Elem: 1,
  Ltyrian_Html: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_Tag(name, attributes, children, key) {
  this.Ltyrian_Tag__f_name = null;
  this.Ltyrian_Tag__f_attributes = null;
  this.Ltyrian_Tag__f_children = null;
  this.Ltyrian_Tag__f_key = null;
  this.Ltyrian_Tag__f_name = name;
  this.Ltyrian_Tag__f_attributes = attributes;
  this.Ltyrian_Tag__f_children = children;
  this.Ltyrian_Tag__f_key = key;
}
$c_Ltyrian_Tag.prototype = new $h_O();
$c_Ltyrian_Tag.prototype.constructor = $c_Ltyrian_Tag;
/** @constructor */
function $h_Ltyrian_Tag() {
}
$h_Ltyrian_Tag.prototype = $c_Ltyrian_Tag.prototype;
$c_Ltyrian_Tag.prototype.toString__T = (function() {
  return $m_Ltyrian_HTMLRendering$package$().render__Ltyrian_Html__T(this);
});
$c_Ltyrian_Tag.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Tag.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Ltyrian_Tag.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_Tag)) {
    var x$0$2 = $as_Ltyrian_Tag(x$0);
    if ((this.Ltyrian_Tag__f_name === $n(x$0$2).Ltyrian_Tag__f_name)) {
      var x = this.Ltyrian_Tag__f_attributes;
      var x$2 = $n(x$0$2).Ltyrian_Tag__f_attributes;
      var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Ltyrian_Tag__f_children;
      var x$4 = $n(x$0$2).Ltyrian_Tag__f_children;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Ltyrian_Tag__f_key;
      var x$6 = $n(x$0$2).Ltyrian_Tag__f_key;
      return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ltyrian_Tag.prototype.productArity__I = (function() {
  return 4;
});
$c_Ltyrian_Tag.prototype.productPrefix__T = (function() {
  return "Tag";
});
$c_Ltyrian_Tag.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Ltyrian_Tag__f_name;
      break;
    }
    case 1: {
      return this.Ltyrian_Tag__f_attributes;
      break;
    }
    case 2: {
      return this.Ltyrian_Tag__f_children;
      break;
    }
    case 3: {
      return this.Ltyrian_Tag__f_key;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Ltyrian_Tag(obj) {
  return (((obj instanceof $c_Ltyrian_Tag) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Tag"));
}
function $isArrayOf_Ltyrian_Tag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Tag)));
}
function $asArrayOf_Ltyrian_Tag(obj, depth) {
  return (($isArrayOf_Ltyrian_Tag(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Tag;", depth));
}
var $d_Ltyrian_Tag = new $TypeData().initClass($c_Ltyrian_Tag, "tyrian.Tag", ({
  Ltyrian_Tag: 1,
  Ltyrian_Elem: 1,
  Ltyrian_Html: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_runtime_RendererState$Running(lastTriggered) {
  this.Ltyrian_runtime_RendererState$Running__f_lastTriggered = $L0;
  this.Ltyrian_runtime_RendererState$Running__f_lastTriggered = lastTriggered;
}
$c_Ltyrian_runtime_RendererState$Running.prototype = new $h_Ltyrian_runtime_RendererState();
$c_Ltyrian_runtime_RendererState$Running.prototype.constructor = $c_Ltyrian_runtime_RendererState$Running;
/** @constructor */
function $h_Ltyrian_runtime_RendererState$Running() {
}
$h_Ltyrian_runtime_RendererState$Running.prototype = $c_Ltyrian_runtime_RendererState$Running.prototype;
$c_Ltyrian_runtime_RendererState$Running.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Running");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var t = this.Ltyrian_runtime_RendererState$Running__f_lastTriggered;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var data$1 = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi));
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1);
});
$c_Ltyrian_runtime_RendererState$Running.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_runtime_RendererState$Running)) {
    var x$0$2 = $as_Ltyrian_runtime_RendererState$Running(x$0);
    var this$1 = this.Ltyrian_runtime_RendererState$Running__f_lastTriggered;
    var b = $n(x$0$2).Ltyrian_runtime_RendererState$Running__f_lastTriggered;
    return ((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi));
  } else {
    return false;
  }
});
$c_Ltyrian_runtime_RendererState$Running.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ltyrian_runtime_RendererState$Running.prototype.productArity__I = (function() {
  return 1;
});
$c_Ltyrian_runtime_RendererState$Running.prototype.productPrefix__T = (function() {
  return "Running";
});
$c_Ltyrian_runtime_RendererState$Running.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_runtime_RendererState$Running__f_lastTriggered;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Ltyrian_runtime_RendererState$Running(obj) {
  return (((obj instanceof $c_Ltyrian_runtime_RendererState$Running) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.runtime.RendererState$Running"));
}
function $isArrayOf_Ltyrian_runtime_RendererState$Running(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_runtime_RendererState$Running)));
}
function $asArrayOf_Ltyrian_runtime_RendererState$Running(obj, depth) {
  return (($isArrayOf_Ltyrian_runtime_RendererState$Running(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.runtime.RendererState$Running;", depth));
}
var $d_Ltyrian_runtime_RendererState$Running = new $TypeData().initClass($c_Ltyrian_runtime_RendererState$Running, "tyrian.runtime.RendererState$Running", ({
  Ltyrian_runtime_RendererState$Running: 1,
  Ltyrian_runtime_RendererState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
function $f_Lcats_Apply__productR__O__O__O($thiz, fa, fb) {
  return $thiz.ap__O__O__O($thiz.as__O__O__O(fa, new $c_sjsr_AnonFunction1(((b) => b))), fb);
}
function $f_Lcats_Apply__productL__O__O__O($thiz, fa, fb) {
  return $thiz.map2__O__O__F2__O(fa, fb, new $c_sjsr_AnonFunction2(((a, _$2) => a)));
}
function $f_Lcats_Apply__map2__O__O__F2__O($thiz, fa, fb, f) {
  var $x_1 = $thiz.product__O__O__O(fa, fb);
  var this$1 = $n(f);
  return $thiz.map__O__F1__O($x_1, $f_F2__tupled__F1(this$1));
}
function $f_Lcats_Apply__map2Eval__O__Lcats_Eval__F2__Lcats_Eval($thiz, fa, fb, f) {
  return $n(fb).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((fb$2) => $thiz.map2__O__O__F2__O(fa, fb$2, f))));
}
/** @constructor */
function $c_Lcats_data_Chain$Append(leftNE, rightNE) {
  this.Lcats_data_Chain$Append__f_leftNE = null;
  this.Lcats_data_Chain$Append__f_rightNE = null;
  this.Lcats_data_Chain$Append__f_leftNE = leftNE;
  this.Lcats_data_Chain$Append__f_rightNE = rightNE;
}
$c_Lcats_data_Chain$Append.prototype = new $h_Lcats_data_Chain$NonEmpty();
$c_Lcats_data_Chain$Append.prototype.constructor = $c_Lcats_data_Chain$Append;
/** @constructor */
function $h_Lcats_data_Chain$Append() {
}
$h_Lcats_data_Chain$Append.prototype = $c_Lcats_data_Chain$Append.prototype;
$c_Lcats_data_Chain$Append.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_data_Chain$Append.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_data_Chain$Append.prototype.productPrefix__T = (function() {
  return "Append";
});
$c_Lcats_data_Chain$Append.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_Chain$Append__f_leftNE;
  }
  if ((n === 1)) {
    return this.Lcats_data_Chain$Append__f_rightNE;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_data_Chain$Append(obj) {
  return (((obj instanceof $c_Lcats_data_Chain$Append) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Chain$Append"));
}
function $isArrayOf_Lcats_data_Chain$Append(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Chain$Append)));
}
function $asArrayOf_Lcats_data_Chain$Append(obj, depth) {
  return (($isArrayOf_Lcats_data_Chain$Append(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Chain$Append;", depth));
}
var $d_Lcats_data_Chain$Append = new $TypeData().initClass($c_Lcats_data_Chain$Append, "cats.data.Chain$Append", ({
  Lcats_data_Chain$Append: 1,
  Lcats_data_Chain$NonEmpty: 1,
  Lcats_data_Chain: 1,
  Lcats_data_ChainCompat: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_data_Chain$Singleton(a) {
  this.Lcats_data_Chain$Singleton__f_a = null;
  this.Lcats_data_Chain$Singleton__f_a = a;
}
$c_Lcats_data_Chain$Singleton.prototype = new $h_Lcats_data_Chain$NonEmpty();
$c_Lcats_data_Chain$Singleton.prototype.constructor = $c_Lcats_data_Chain$Singleton;
/** @constructor */
function $h_Lcats_data_Chain$Singleton() {
}
$h_Lcats_data_Chain$Singleton.prototype = $c_Lcats_data_Chain$Singleton.prototype;
$c_Lcats_data_Chain$Singleton.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_data_Chain$Singleton.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_data_Chain$Singleton.prototype.productPrefix__T = (function() {
  return "Singleton";
});
$c_Lcats_data_Chain$Singleton.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_Chain$Singleton__f_a;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_data_Chain$Singleton(obj) {
  return (((obj instanceof $c_Lcats_data_Chain$Singleton) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Chain$Singleton"));
}
function $isArrayOf_Lcats_data_Chain$Singleton(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Chain$Singleton)));
}
function $asArrayOf_Lcats_data_Chain$Singleton(obj, depth) {
  return (($isArrayOf_Lcats_data_Chain$Singleton(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Chain$Singleton;", depth));
}
var $d_Lcats_data_Chain$Singleton = new $TypeData().initClass($c_Lcats_data_Chain$Singleton, "cats.data.Chain$Singleton", ({
  Lcats_data_Chain$Singleton: 1,
  Lcats_data_Chain$NonEmpty: 1,
  Lcats_data_Chain: 1,
  Lcats_data_ChainCompat: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_data_Chain$Wrap(seq) {
  this.Lcats_data_Chain$Wrap__f_seq = null;
  this.Lcats_data_Chain$Wrap__f_seq = seq;
}
$c_Lcats_data_Chain$Wrap.prototype = new $h_Lcats_data_Chain$NonEmpty();
$c_Lcats_data_Chain$Wrap.prototype.constructor = $c_Lcats_data_Chain$Wrap;
/** @constructor */
function $h_Lcats_data_Chain$Wrap() {
}
$h_Lcats_data_Chain$Wrap.prototype = $c_Lcats_data_Chain$Wrap.prototype;
$c_Lcats_data_Chain$Wrap.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_data_Chain$Wrap.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_data_Chain$Wrap.prototype.productPrefix__T = (function() {
  return "Wrap";
});
$c_Lcats_data_Chain$Wrap.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_Chain$Wrap__f_seq;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_data_Chain$Wrap(obj) {
  return (((obj instanceof $c_Lcats_data_Chain$Wrap) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Chain$Wrap"));
}
function $isArrayOf_Lcats_data_Chain$Wrap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Chain$Wrap)));
}
function $asArrayOf_Lcats_data_Chain$Wrap(obj, depth) {
  return (($isArrayOf_Lcats_data_Chain$Wrap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Chain$Wrap;", depth));
}
var $d_Lcats_data_Chain$Wrap = new $TypeData().initClass($c_Lcats_data_Chain$Wrap, "cats.data.Chain$Wrap", ({
  Lcats_data_Chain$Wrap: 1,
  Lcats_data_Chain$NonEmpty: 1,
  Lcats_data_Chain: 1,
  Lcats_data_ChainCompat: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $ct_Lcats_data_KleisliInstances3__($thiz) {
  $m_Lcats_package$();
  return $thiz;
}
/** @constructor */
function $c_Lcats_data_KleisliInstances3() {
}
$c_Lcats_data_KleisliInstances3.prototype = new $h_Lcats_data_KleisliInstances4();
$c_Lcats_data_KleisliInstances3.prototype.constructor = $c_Lcats_data_KleisliInstances3;
/** @constructor */
function $h_Lcats_data_KleisliInstances3() {
}
$h_Lcats_data_KleisliInstances3.prototype = $c_Lcats_data_KleisliInstances3.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptySetInstances$$anon$1() {
}
$c_Lcats_data_NonEmptySetInstances$$anon$1.prototype = new $h_O();
$c_Lcats_data_NonEmptySetInstances$$anon$1.prototype.constructor = $c_Lcats_data_NonEmptySetInstances$$anon$1;
/** @constructor */
function $h_Lcats_data_NonEmptySetInstances$$anon$1() {
}
$h_Lcats_data_NonEmptySetInstances$$anon$1.prototype = $c_Lcats_data_NonEmptySetInstances$$anon$1.prototype;
$c_Lcats_data_NonEmptySetInstances$$anon$1.prototype.reduceLeftOption__O__F2__s_Option = (function(fa, f) {
  return $f_Lcats_Foldable__reduceLeftOption__O__F2__s_Option(this, fa, f);
});
$c_Lcats_data_NonEmptySetInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O(this, fa, z, f, G);
});
$c_Lcats_data_NonEmptySetInstances$$anon$1.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverse___O__F1__Lcats_Applicative__O(this, fa, f, G);
});
$c_Lcats_data_NonEmptySetInstances$$anon$1.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return this.foldMap__O__F1__Lcats_kernel_Monoid__O(fa, f, evidence$1);
});
$c_Lcats_data_NonEmptySetInstances$$anon$1.prototype.reduceLeftToOption__O__F1__F2__s_Option = (function(fa, f, g) {
  return $f_Lcats_Reducible__reduceLeftToOption__O__F1__F2__s_Option(this, fa, f, g);
});
$c_Lcats_data_NonEmptySetInstances$$anon$1.prototype.maximumOption__O__Lcats_kernel_Order__s_Option = (function(fa, A) {
  return $f_Lcats_Reducible__maximumOption__O__Lcats_kernel_Order__s_Option(this, fa, A);
});
$c_Lcats_data_NonEmptySetInstances$$anon$1.prototype.size__O__J = (function(fa) {
  var this$2 = new $c_Lcats_data_NonEmptySetOps(fa);
  var s = this$2.Lcats_data_NonEmptySetOps__f_value;
  var value = $n($as_sci_SortedSet(s)).size__I();
  var hi = (value >> 31);
  return new $c_RTLong(value, hi);
});
$c_Lcats_data_NonEmptySetInstances$$anon$1.prototype.reduceLeft__O__F2__O = (function(fa, f) {
  var this$2 = new $c_Lcats_data_NonEmptySetOps(fa);
  var s = this$2.Lcats_data_NonEmptySetOps__f_value;
  var this$4 = $n($as_sci_SortedSet(s));
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this$4, f);
});
$c_Lcats_data_NonEmptySetInstances$$anon$1.prototype.reduceLeftTo__O__F1__F2__O = (function(fa, f, g) {
  return new $c_Lcats_data_NonEmptySetOps(fa).reduceLeftTo__F1__F2__O(f, g);
});
$c_Lcats_data_NonEmptySetInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  var this$2 = new $c_Lcats_data_NonEmptySetOps(fa);
  var s = this$2.Lcats_data_NonEmptySetOps__f_value;
  var this$4 = $n($as_sci_SortedSet(s));
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this$4, b, f);
});
$c_Lcats_data_NonEmptySetInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return new $c_Lcats_data_NonEmptySetOps(fa).foldRight__Lcats_Eval__F2__Lcats_Eval(lb, f);
});
$c_Lcats_data_NonEmptySetInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var $x_1 = $n(B);
  var this$2 = new $c_Lcats_data_NonEmptySetOps(fa);
  var s = this$2.Lcats_data_NonEmptySetOps__f_value;
  var this$4 = $n($n($as_sci_SortedSet(s)).iterator__sc_Iterator());
  return $n($x_1).combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$4, f));
});
$c_Lcats_data_NonEmptySetInstances$$anon$1.prototype.fold__O__Lcats_kernel_Monoid__O = (function(fa, A) {
  return new $c_Lcats_data_NonEmptySetOps(fa).reduce__Lcats_kernel_Semigroup__O(A);
});
$c_Lcats_data_NonEmptySetInstances$$anon$1.prototype.toList__O__sci_List = (function(fa) {
  var this$2 = new $c_Lcats_data_NonEmptySetOps(fa);
  var s = this$2.Lcats_data_NonEmptySetOps__f_value;
  var this$4 = $n($as_sci_SortedSet(s));
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$4);
});
$c_Lcats_data_NonEmptySetInstances$$anon$1.prototype.toIterable__O__sci_Iterable = (function(fa) {
  var this$2 = new $c_Lcats_data_NonEmptySetOps(fa);
  var s = this$2.Lcats_data_NonEmptySetOps__f_value;
  return $as_sci_SortedSet(s);
});
$c_Lcats_data_NonEmptySetInstances$$anon$1.prototype.toIterable__O__sc_Iterable = (function(fa) {
  return this.toIterable__O__sci_Iterable(fa);
});
var $d_Lcats_data_NonEmptySetInstances$$anon$1 = new $TypeData().initClass($c_Lcats_data_NonEmptySetInstances$$anon$1, "cats.data.NonEmptySetInstances$$anon$1", ({
  Lcats_data_NonEmptySetInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_SemigroupK: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_Reducible: 1
}));
function $ct_Lcats_instances_ScalaVersionSpecificNumeric__s_math_Numeric__F1__F1__($thiz, fa, f, g) {
  $thiz.Lcats_instances_ScalaVersionSpecificNumeric__f_fa = fa;
  $thiz.Lcats_instances_ScalaVersionSpecificNumeric__f_f = f;
  $thiz.Lcats_instances_ScalaVersionSpecificNumeric__f_g = g;
  return $thiz;
}
/** @constructor */
function $c_Lcats_instances_ScalaVersionSpecificNumeric() {
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa = null;
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_f = null;
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_g = null;
}
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype = new $h_O();
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.constructor = $c_Lcats_instances_ScalaVersionSpecificNumeric;
/** @constructor */
function $h_Lcats_instances_ScalaVersionSpecificNumeric() {
}
$h_Lcats_instances_ScalaVersionSpecificNumeric.prototype = $c_Lcats_instances_ScalaVersionSpecificNumeric.prototype;
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.sign__O__O = (function(x) {
  return $f_s_math_Numeric__sign__O__O(this, x);
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.compare__O__O__I = (function(x, y) {
  return $n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa).compare__O__O__I($n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g).apply__O__O(x), $n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g).apply__O__O(y));
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.plus__O__O__O = (function(x, y) {
  return $n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_f).apply__O__O($n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa).plus__O__O__O($n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g).apply__O__O(x), $n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g).apply__O__O(y)));
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.minus__O__O__O = (function(x, y) {
  return $n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_f).apply__O__O($n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa).minus__O__O__O($n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g).apply__O__O(x), $n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g).apply__O__O(y)));
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.times__O__O__O = (function(x, y) {
  return $n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_f).apply__O__O($n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa).times__O__O__O($n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g).apply__O__O(x), $n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g).apply__O__O(y)));
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.negate__O__O = (function(x) {
  return $n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_f).apply__O__O($n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa).negate__O__O($n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g).apply__O__O(x)));
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.fromInt__I__O = (function(x) {
  return $n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_f).apply__O__O($n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa).fromInt__I__O(x));
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.toInt__O__I = (function(x) {
  return $n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa).toInt__O__I($n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g).apply__O__O(x));
});
/** @constructor */
function $c_Lcats_instances_package$option$() {
  this.Lcats_instances_package$option$__f_catsStdInstancesForOption = null;
  $n_Lcats_instances_package$option$ = this;
  this.Lcats_instances_package$option$__f_catsStdInstancesForOption = new $c_Lcats_instances_OptionInstances$$anon$1();
  new $c_Lcats_instances_OptionInstancesBinCompat0$$anon$3();
}
$c_Lcats_instances_package$option$.prototype = new $h_O();
$c_Lcats_instances_package$option$.prototype.constructor = $c_Lcats_instances_package$option$;
/** @constructor */
function $h_Lcats_instances_package$option$() {
}
$h_Lcats_instances_package$option$.prototype = $c_Lcats_instances_package$option$.prototype;
var $d_Lcats_instances_package$option$ = new $TypeData().initClass($c_Lcats_instances_package$option$, "cats.instances.package$option$", ({
  Lcats_instances_package$option$: 1,
  Lcats_kernel_instances_OptionInstances2: 1,
  Lcats_kernel_instances_OptionInstances1: 1,
  Lcats_kernel_instances_OptionInstances0: 1,
  Lcats_kernel_instances_OptionInstances: 1,
  Lcats_instances_OptionInstances: 1,
  Lcats_instances_OptionInstancesBinCompat0: 1
}));
var $n_Lcats_instances_package$option$;
function $m_Lcats_instances_package$option$() {
  if ((!$n_Lcats_instances_package$option$)) {
    $n_Lcats_instances_package$option$ = new $c_Lcats_instances_package$option$();
  }
  return $n_Lcats_instances_package$option$;
}
/** @constructor */
function $c_Lfs2_Pull$Fail(error) {
  this.Lfs2_Pull$Fail__f_error = null;
  this.Lfs2_Pull$Fail__f_error = error;
}
$c_Lfs2_Pull$Fail.prototype = new $h_Lfs2_Pull$Terminal();
$c_Lfs2_Pull$Fail.prototype.constructor = $c_Lfs2_Pull$Fail;
/** @constructor */
function $h_Lfs2_Pull$Fail() {
}
$h_Lfs2_Pull$Fail.prototype = $c_Lfs2_Pull$Fail.prototype;
$c_Lfs2_Pull$Fail.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$Fail.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lfs2_Pull$Fail.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$Fail)) {
    var x$0$2 = $as_Lfs2_Pull$Fail(x$0);
    var x = this.Lfs2_Pull$Fail__f_error;
    var x$2 = $n(x$0$2).Lfs2_Pull$Fail__f_error;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lfs2_Pull$Fail.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$Fail.prototype.productArity__I = (function() {
  return 1;
});
$c_Lfs2_Pull$Fail.prototype.productPrefix__T = (function() {
  return "Fail";
});
$c_Lfs2_Pull$Fail.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Fail__f_error;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lfs2_Pull$Fail(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Fail) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Fail"));
}
function $isArrayOf_Lfs2_Pull$Fail(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Fail)));
}
function $asArrayOf_Lfs2_Pull$Fail(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Fail(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Fail;", depth));
}
var $d_Lfs2_Pull$Fail = new $TypeData().initClass($c_Lfs2_Pull$Fail, "fs2.Pull$Fail", ({
  Lfs2_Pull$Fail: 1,
  Lfs2_Pull$Terminal: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lfs2_Pull$FlatMapOutput(stream, fun) {
  this.Lfs2_Pull$FlatMapOutput__f_stream = null;
  this.Lfs2_Pull$FlatMapOutput__f_fun = null;
  this.Lfs2_Pull$FlatMapOutput__f_stream = stream;
  this.Lfs2_Pull$FlatMapOutput__f_fun = fun;
}
$c_Lfs2_Pull$FlatMapOutput.prototype = new $h_Lfs2_Pull$Action();
$c_Lfs2_Pull$FlatMapOutput.prototype.constructor = $c_Lfs2_Pull$FlatMapOutput;
/** @constructor */
function $h_Lfs2_Pull$FlatMapOutput() {
}
$h_Lfs2_Pull$FlatMapOutput.prototype = $c_Lfs2_Pull$FlatMapOutput.prototype;
$c_Lfs2_Pull$FlatMapOutput.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$FlatMapOutput.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lfs2_Pull$FlatMapOutput.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$FlatMapOutput)) {
    var x$0$2 = $as_Lfs2_Pull$FlatMapOutput(x$0);
    var x = this.Lfs2_Pull$FlatMapOutput__f_stream;
    var x$2 = $n(x$0$2).Lfs2_Pull$FlatMapOutput__f_stream;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lfs2_Pull$FlatMapOutput__f_fun;
      var x$4 = $n(x$0$2).Lfs2_Pull$FlatMapOutput__f_fun;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_Pull$FlatMapOutput.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$FlatMapOutput.prototype.productArity__I = (function() {
  return 2;
});
$c_Lfs2_Pull$FlatMapOutput.prototype.productPrefix__T = (function() {
  return "FlatMapOutput";
});
$c_Lfs2_Pull$FlatMapOutput.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$FlatMapOutput__f_stream;
  }
  if ((n === 1)) {
    return this.Lfs2_Pull$FlatMapOutput__f_fun;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lfs2_Pull$FlatMapOutput(obj) {
  return (((obj instanceof $c_Lfs2_Pull$FlatMapOutput) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$FlatMapOutput"));
}
function $isArrayOf_Lfs2_Pull$FlatMapOutput(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$FlatMapOutput)));
}
function $asArrayOf_Lfs2_Pull$FlatMapOutput(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$FlatMapOutput(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$FlatMapOutput;", depth));
}
var $d_Lfs2_Pull$FlatMapOutput = new $TypeData().initClass($c_Lfs2_Pull$FlatMapOutput, "fs2.Pull$FlatMapOutput", ({
  Lfs2_Pull$FlatMapOutput: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lfs2_Pull$InScope(stream, useInterruption) {
  this.Lfs2_Pull$InScope__f_stream = null;
  this.Lfs2_Pull$InScope__f_useInterruption = false;
  this.Lfs2_Pull$InScope__f_stream = stream;
  this.Lfs2_Pull$InScope__f_useInterruption = useInterruption;
}
$c_Lfs2_Pull$InScope.prototype = new $h_Lfs2_Pull$Action();
$c_Lfs2_Pull$InScope.prototype.constructor = $c_Lfs2_Pull$InScope;
/** @constructor */
function $h_Lfs2_Pull$InScope() {
}
$h_Lfs2_Pull$InScope.prototype = $c_Lfs2_Pull$InScope.prototype;
$c_Lfs2_Pull$InScope.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$InScope.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("InScope");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lfs2_Pull$InScope__f_stream;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lfs2_Pull$InScope__f_useInterruption ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
});
$c_Lfs2_Pull$InScope.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$InScope)) {
    var x$0$2 = $as_Lfs2_Pull$InScope(x$0);
    if ((this.Lfs2_Pull$InScope__f_useInterruption === $n(x$0$2).Lfs2_Pull$InScope__f_useInterruption)) {
      var x = this.Lfs2_Pull$InScope__f_stream;
      var x$2 = $n(x$0$2).Lfs2_Pull$InScope__f_stream;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_Pull$InScope.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$InScope.prototype.productArity__I = (function() {
  return 2;
});
$c_Lfs2_Pull$InScope.prototype.productPrefix__T = (function() {
  return "InScope";
});
$c_Lfs2_Pull$InScope.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$InScope__f_stream;
  }
  if ((n === 1)) {
    return this.Lfs2_Pull$InScope__f_useInterruption;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lfs2_Pull$InScope(obj) {
  return (((obj instanceof $c_Lfs2_Pull$InScope) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$InScope"));
}
function $isArrayOf_Lfs2_Pull$InScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$InScope)));
}
function $asArrayOf_Lfs2_Pull$InScope(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$InScope(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$InScope;", depth));
}
var $d_Lfs2_Pull$InScope = new $TypeData().initClass($c_Lfs2_Pull$InScope, "fs2.Pull$InScope", ({
  Lfs2_Pull$InScope: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lfs2_Pull$Interrupted(context, deferredError) {
  this.Lfs2_Pull$Interrupted__f_context = null;
  this.Lfs2_Pull$Interrupted__f_deferredError = null;
  this.Lfs2_Pull$Interrupted__f_context = context;
  this.Lfs2_Pull$Interrupted__f_deferredError = deferredError;
}
$c_Lfs2_Pull$Interrupted.prototype = new $h_Lfs2_Pull$Terminal();
$c_Lfs2_Pull$Interrupted.prototype.constructor = $c_Lfs2_Pull$Interrupted;
/** @constructor */
function $h_Lfs2_Pull$Interrupted() {
}
$h_Lfs2_Pull$Interrupted.prototype = $c_Lfs2_Pull$Interrupted.prototype;
$c_Lfs2_Pull$Interrupted.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$Interrupted.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lfs2_Pull$Interrupted.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$Interrupted)) {
    var x$0$2 = $as_Lfs2_Pull$Interrupted(x$0);
    var x = this.Lfs2_Pull$Interrupted__f_context;
    var x$2 = $n(x$0$2).Lfs2_Pull$Interrupted__f_context;
    if ((x === null)) {
      var $x_1 = (x$2 === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === x$2);
    }
    if ($x_1) {
      var x$3 = this.Lfs2_Pull$Interrupted__f_deferredError;
      var x$4 = $n(x$0$2).Lfs2_Pull$Interrupted__f_deferredError;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_Pull$Interrupted.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$Interrupted.prototype.productArity__I = (function() {
  return 2;
});
$c_Lfs2_Pull$Interrupted.prototype.productPrefix__T = (function() {
  return "Interrupted";
});
$c_Lfs2_Pull$Interrupted.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Interrupted__f_context;
  }
  if ((n === 1)) {
    return this.Lfs2_Pull$Interrupted__f_deferredError;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lfs2_Pull$Interrupted(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Interrupted) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Interrupted"));
}
function $isArrayOf_Lfs2_Pull$Interrupted(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Interrupted)));
}
function $asArrayOf_Lfs2_Pull$Interrupted(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Interrupted(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Interrupted;", depth));
}
var $d_Lfs2_Pull$Interrupted = new $TypeData().initClass($c_Lfs2_Pull$Interrupted, "fs2.Pull$Interrupted", ({
  Lfs2_Pull$Interrupted: 1,
  Lfs2_Pull$Terminal: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lfs2_Pull$Output(values) {
  this.Lfs2_Pull$Output__f_values = null;
  this.Lfs2_Pull$Output__f_values = values;
}
$c_Lfs2_Pull$Output.prototype = new $h_Lfs2_Pull$Action();
$c_Lfs2_Pull$Output.prototype.constructor = $c_Lfs2_Pull$Output;
/** @constructor */
function $h_Lfs2_Pull$Output() {
}
$h_Lfs2_Pull$Output.prototype = $c_Lfs2_Pull$Output.prototype;
$c_Lfs2_Pull$Output.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$Output.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lfs2_Pull$Output.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$Output)) {
    var x$0$2 = $as_Lfs2_Pull$Output(x$0);
    var x = this.Lfs2_Pull$Output__f_values;
    var x$2 = $n(x$0$2).Lfs2_Pull$Output__f_values;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lfs2_Pull$Output.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$Output.prototype.productArity__I = (function() {
  return 1;
});
$c_Lfs2_Pull$Output.prototype.productPrefix__T = (function() {
  return "Output";
});
$c_Lfs2_Pull$Output.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Output__f_values;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lfs2_Pull$Output(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Output) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Output"));
}
function $isArrayOf_Lfs2_Pull$Output(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Output)));
}
function $asArrayOf_Lfs2_Pull$Output(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Output(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Output;", depth));
}
var $d_Lfs2_Pull$Output = new $TypeData().initClass($c_Lfs2_Pull$Output, "fs2.Pull$Output", ({
  Lfs2_Pull$Output: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $as_Lfs2_Pull$StepLeg(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$StepLeg"));
}
function $isArrayOf_Lfs2_Pull$StepLeg(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$StepLeg)));
}
function $asArrayOf_Lfs2_Pull$StepLeg(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$StepLeg(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$StepLeg;", depth));
}
/** @constructor */
function $c_Lfs2_Pull$Succeeded(r) {
  this.Lfs2_Pull$Succeeded__f_r = null;
  this.Lfs2_Pull$Succeeded__f_r = r;
}
$c_Lfs2_Pull$Succeeded.prototype = new $h_Lfs2_Pull$Terminal();
$c_Lfs2_Pull$Succeeded.prototype.constructor = $c_Lfs2_Pull$Succeeded;
/** @constructor */
function $h_Lfs2_Pull$Succeeded() {
}
$h_Lfs2_Pull$Succeeded.prototype = $c_Lfs2_Pull$Succeeded.prototype;
$c_Lfs2_Pull$Succeeded.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$Succeeded.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lfs2_Pull$Succeeded.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$Succeeded)) {
    var x$0$2 = $as_Lfs2_Pull$Succeeded(x$0);
    var x = this.Lfs2_Pull$Succeeded__f_r;
    var y = $n(x$0$2).Lfs2_Pull$Succeeded__f_r;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lfs2_Pull$Succeeded.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$Succeeded.prototype.productArity__I = (function() {
  return 1;
});
$c_Lfs2_Pull$Succeeded.prototype.productPrefix__T = (function() {
  return "Succeeded";
});
$c_Lfs2_Pull$Succeeded.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Succeeded__f_r;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lfs2_Pull$Succeeded(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Succeeded) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Succeeded"));
}
function $isArrayOf_Lfs2_Pull$Succeeded(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Succeeded)));
}
function $asArrayOf_Lfs2_Pull$Succeeded(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Succeeded(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Succeeded;", depth));
}
var $d_Lfs2_Pull$Succeeded = new $TypeData().initClass($c_Lfs2_Pull$Succeeded, "fs2.Pull$Succeeded", ({
  Lfs2_Pull$Succeeded: 1,
  Lfs2_Pull$Terminal: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lfs2_Pull$Translate(stream, fk) {
  this.Lfs2_Pull$Translate__f_stream = null;
  this.Lfs2_Pull$Translate__f_fk = null;
  this.Lfs2_Pull$Translate__f_stream = stream;
  this.Lfs2_Pull$Translate__f_fk = fk;
}
$c_Lfs2_Pull$Translate.prototype = new $h_Lfs2_Pull$Action();
$c_Lfs2_Pull$Translate.prototype.constructor = $c_Lfs2_Pull$Translate;
/** @constructor */
function $h_Lfs2_Pull$Translate() {
}
$h_Lfs2_Pull$Translate.prototype = $c_Lfs2_Pull$Translate.prototype;
$c_Lfs2_Pull$Translate.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$Translate.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lfs2_Pull$Translate.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$Translate)) {
    var x$0$2 = $as_Lfs2_Pull$Translate(x$0);
    var x = this.Lfs2_Pull$Translate__f_stream;
    var x$2 = $n(x$0$2).Lfs2_Pull$Translate__f_stream;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lfs2_Pull$Translate__f_fk;
      var x$4 = $n(x$0$2).Lfs2_Pull$Translate__f_fk;
      if ((x$3 === null)) {
        return (x$4 === null);
      } else {
        var this$1 = $n(x$3);
        return (this$1 === x$4);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_Pull$Translate.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$Translate.prototype.productArity__I = (function() {
  return 2;
});
$c_Lfs2_Pull$Translate.prototype.productPrefix__T = (function() {
  return "Translate";
});
$c_Lfs2_Pull$Translate.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Translate__f_stream;
  }
  if ((n === 1)) {
    return this.Lfs2_Pull$Translate__f_fk;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lfs2_Pull$Translate(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Translate) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Translate"));
}
function $isArrayOf_Lfs2_Pull$Translate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Translate)));
}
function $asArrayOf_Lfs2_Pull$Translate(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Translate(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Translate;", depth));
}
var $d_Lfs2_Pull$Translate = new $TypeData().initClass($c_Lfs2_Pull$Translate, "fs2.Pull$Translate", ({
  Lfs2_Pull$Translate: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lfs2_Pull$Uncons(stream) {
  this.Lfs2_Pull$Uncons__f_stream = null;
  this.Lfs2_Pull$Uncons__f_stream = stream;
}
$c_Lfs2_Pull$Uncons.prototype = new $h_Lfs2_Pull$Action();
$c_Lfs2_Pull$Uncons.prototype.constructor = $c_Lfs2_Pull$Uncons;
/** @constructor */
function $h_Lfs2_Pull$Uncons() {
}
$h_Lfs2_Pull$Uncons.prototype = $c_Lfs2_Pull$Uncons.prototype;
$c_Lfs2_Pull$Uncons.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$Uncons.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lfs2_Pull$Uncons.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$Uncons)) {
    var x$0$2 = $as_Lfs2_Pull$Uncons(x$0);
    var x = this.Lfs2_Pull$Uncons__f_stream;
    var x$2 = $n(x$0$2).Lfs2_Pull$Uncons__f_stream;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lfs2_Pull$Uncons.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$Uncons.prototype.productArity__I = (function() {
  return 1;
});
$c_Lfs2_Pull$Uncons.prototype.productPrefix__T = (function() {
  return "Uncons";
});
$c_Lfs2_Pull$Uncons.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Uncons__f_stream;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lfs2_Pull$Uncons(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Uncons) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Uncons"));
}
function $isArrayOf_Lfs2_Pull$Uncons(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Uncons)));
}
function $asArrayOf_Lfs2_Pull$Uncons(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Uncons(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Uncons;", depth));
}
var $d_Lfs2_Pull$Uncons = new $TypeData().initClass($c_Lfs2_Pull$Uncons, "fs2.Pull$Uncons", ({
  Lfs2_Pull$Uncons: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $p_Ljava_io_PrintStream__encoder$lzycompute__Ljava_io_OutputStreamWriter($thiz) {
  if ((!$thiz.Ljava_io_PrintStream__f_bitmap$0)) {
    var c = (($thiz.Ljava_io_PrintStream__f_charset === null) ? $m_Ljava_nio_charset_UTF\uff3f8$() : $thiz.Ljava_io_PrintStream__f_charset);
    $thiz.Ljava_io_PrintStream__f_encoder = $ct_Ljava_io_OutputStreamWriter__Ljava_io_OutputStream__Ljava_nio_charset_Charset__(new $c_Ljava_io_OutputStreamWriter(), $thiz, c);
    $thiz.Ljava_io_PrintStream__f_bitmap$0 = true;
  }
  return $thiz.Ljava_io_PrintStream__f_encoder;
}
function $p_Ljava_io_PrintStream__encoder__Ljava_io_OutputStreamWriter($thiz) {
  return ((!$thiz.Ljava_io_PrintStream__f_bitmap$0) ? $p_Ljava_io_PrintStream__encoder$lzycompute__Ljava_io_OutputStreamWriter($thiz) : $thiz.Ljava_io_PrintStream__f_encoder);
}
function $p_Ljava_io_PrintStream__printString__T__V($thiz, s) {
  if ((!$thiz.Ljava_io_PrintStream__f_java$io$PrintStream$$closed)) {
    try {
      var this$1 = $n($p_Ljava_io_PrintStream__encoder__Ljava_io_OutputStreamWriter($thiz));
      var cbuf = $f_T__toCharArray__AC($n(s));
      this$1.write__AC__I__I__V(cbuf, 0, $n(cbuf).u.length);
      $n($p_Ljava_io_PrintStream__encoder__Ljava_io_OutputStreamWriter($thiz)).flushBuffer__V();
    } catch (e) {
      if ((!(e instanceof $c_Ljava_io_IOException))) {
        throw e;
      }
    }
  }
}
function $ct_Ljava_io_PrintStream__Ljava_io_OutputStream__Z__Ljava_nio_charset_Charset__($thiz, _out, autoFlush, charset) {
  $thiz.Ljava_io_PrintStream__f_autoFlush = autoFlush;
  $thiz.Ljava_io_PrintStream__f_charset = charset;
  $ct_Ljava_io_FilterOutputStream__Ljava_io_OutputStream__($thiz, _out);
  $thiz.Ljava_io_PrintStream__f_java$io$PrintStream$$closed = false;
  return $thiz;
}
function $ct_Ljava_io_PrintStream__Ljava_io_OutputStream__($thiz, out) {
  $ct_Ljava_io_PrintStream__Ljava_io_OutputStream__Z__Ljava_nio_charset_Charset__($thiz, out, false, null);
  return $thiz;
}
/** @constructor */
function $c_Ljava_io_PrintStream() {
  this.Ljava_io_FilterOutputStream__f_out = null;
  this.Ljava_io_PrintStream__f_encoder = null;
  this.Ljava_io_PrintStream__f_autoFlush = false;
  this.Ljava_io_PrintStream__f_charset = null;
  this.Ljava_io_PrintStream__f_java$io$PrintStream$$closed = false;
  this.Ljava_io_PrintStream__f_bitmap$0 = false;
}
$c_Ljava_io_PrintStream.prototype = new $h_Ljava_io_FilterOutputStream();
$c_Ljava_io_PrintStream.prototype.constructor = $c_Ljava_io_PrintStream;
/** @constructor */
function $h_Ljava_io_PrintStream() {
}
$h_Ljava_io_PrintStream.prototype = $c_Ljava_io_PrintStream.prototype;
$c_Ljava_io_PrintStream.prototype.flush__V = (function() {
  if ((!this.Ljava_io_PrintStream__f_java$io$PrintStream$$closed)) {
    try {
      $n(this.Ljava_io_FilterOutputStream__f_out).flush__V();
    } catch (e) {
      if ((!(e instanceof $c_Ljava_io_IOException))) {
        throw e;
      }
    }
  }
});
$c_Ljava_io_PrintStream.prototype.write__I__V = (function(b) {
  if ((!this.Ljava_io_PrintStream__f_java$io$PrintStream$$closed)) {
    try {
      $n(this.Ljava_io_FilterOutputStream__f_out).write__I__V(b);
      if ((this.Ljava_io_PrintStream__f_autoFlush && (b === 10))) {
        this.flush__V();
      }
    } catch (e) {
      if ((!(e instanceof $c_Ljava_io_IOException))) {
        throw e;
      }
    }
  }
});
$c_Ljava_io_PrintStream.prototype.write__AB__I__I__V = (function(buf, off, len) {
  if ((!this.Ljava_io_PrintStream__f_java$io$PrintStream$$closed)) {
    try {
      $n(this.Ljava_io_FilterOutputStream__f_out).write__AB__I__I__V(buf, off, len);
      if (this.Ljava_io_PrintStream__f_autoFlush) {
        this.flush__V();
      }
    } catch (e) {
      if ((!(e instanceof $c_Ljava_io_IOException))) {
        throw e;
      }
    }
  }
});
$c_Ljava_io_PrintStream.prototype.print__T__V = (function(s) {
  $p_Ljava_io_PrintStream__printString__T__V(this, ((s === null) ? "null" : s));
});
$c_Ljava_io_PrintStream.prototype.print__O__V = (function(obj) {
  $p_Ljava_io_PrintStream__printString__T__V(this, ("" + obj));
});
$c_Ljava_io_PrintStream.prototype.println__V = (function() {
  if ((!this.Ljava_io_PrintStream__f_java$io$PrintStream$$closed)) {
    try {
      $n($p_Ljava_io_PrintStream__encoder__Ljava_io_OutputStreamWriter(this)).write__I__V(10);
      $n($p_Ljava_io_PrintStream__encoder__Ljava_io_OutputStreamWriter(this)).flushBuffer__V();
      if (this.Ljava_io_PrintStream__f_autoFlush) {
        this.flush__V();
      }
    } catch (e) {
      if ((!(e instanceof $c_Ljava_io_IOException))) {
        throw e;
      }
    }
  }
});
$c_Ljava_io_PrintStream.prototype.println__T__V = (function(s) {
  this.print__T__V(s);
  this.println__V();
});
$c_Ljava_io_PrintStream.prototype.println__O__V = (function(obj) {
  this.print__O__V(obj);
  this.println__V();
});
$c_Ljava_io_PrintStream.prototype.append__jl_CharSequence__Ljava_io_PrintStream = (function(csq) {
  this.print__T__V(((csq === null) ? "null" : $dp_toString__T($n(csq))));
  return this;
});
$c_Ljava_io_PrintStream.prototype.append__jl_CharSequence__jl_Appendable = (function(csq) {
  return this.append__jl_CharSequence__Ljava_io_PrintStream(csq);
});
function $as_Ljava_io_PrintStream(obj) {
  return (((obj instanceof $c_Ljava_io_PrintStream) || (obj === null)) ? obj : $throwClassCastException(obj, "java.io.PrintStream"));
}
function $isArrayOf_Ljava_io_PrintStream(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_io_PrintStream)));
}
function $asArrayOf_Ljava_io_PrintStream(obj, depth) {
  return (($isArrayOf_Ljava_io_PrintStream(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.io.PrintStream;", depth));
}
var $d_Ljava_io_PrintStream = new $TypeData().initClass($c_Ljava_io_PrintStream, "java.io.PrintStream", ({
  Ljava_io_PrintStream: 1,
  Ljava_io_FilterOutputStream: 1,
  Ljava_io_OutputStream: 1,
  Ljava_io_Closeable: 1,
  jl_AutoCloseable: 1,
  Ljava_io_Flushable: 1,
  jl_Appendable: 1
}));
/** @constructor */
function $c_Ljava_nio_HeapCharBuffer(_capacity, _array0, _arrayOffset0, _initialPosition, _initialLimit, _readOnly) {
  this.Ljava_nio_Buffer__f__capacity = 0;
  this.Ljava_nio_Buffer__f__limit = 0;
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  this.Ljava_nio_Buffer__f__mark = 0;
  this.Ljava_nio_CharBuffer__f__array = null;
  this.Ljava_nio_CharBuffer__f__arrayOffset = 0;
  this.Ljava_nio_HeapCharBuffer__f__readOnly = false;
  this.Ljava_nio_HeapCharBuffer__f__readOnly = _readOnly;
  $ct_Ljava_nio_CharBuffer__I__AC__I__(this, _capacity, _array0, _arrayOffset0);
  $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this, _initialPosition);
  $c_Ljava_nio_Buffer.prototype.limit__I__Ljava_nio_Buffer.call(this, _initialLimit);
}
$c_Ljava_nio_HeapCharBuffer.prototype = new $h_Ljava_nio_CharBuffer();
$c_Ljava_nio_HeapCharBuffer.prototype.constructor = $c_Ljava_nio_HeapCharBuffer;
/** @constructor */
function $h_Ljava_nio_HeapCharBuffer() {
}
$h_Ljava_nio_HeapCharBuffer.prototype = $c_Ljava_nio_HeapCharBuffer.prototype;
$c_Ljava_nio_HeapCharBuffer.prototype.isReadOnly__Z = (function() {
  return this.Ljava_nio_HeapCharBuffer__f__readOnly;
});
$c_Ljava_nio_HeapCharBuffer.prototype.subSequence__I__I__Ljava_nio_CharBuffer = (function(start, end) {
  if ((((start < 0) || (end < start)) || (end > ((this.Ljava_nio_Buffer__f__limit - this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  return new $c_Ljava_nio_HeapCharBuffer(this.Ljava_nio_Buffer__f__capacity, this.Ljava_nio_CharBuffer__f__array, this.Ljava_nio_CharBuffer__f__arrayOffset, ((this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + start) | 0), ((this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + end) | 0), this.Ljava_nio_HeapCharBuffer__f__readOnly);
});
$c_Ljava_nio_HeapCharBuffer.prototype.get__C = (function() {
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  if ((p === this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferUnderflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = ((1 + p) | 0);
  var a = this.Ljava_nio_CharBuffer__f__array;
  var i = ((this.Ljava_nio_CharBuffer__f__arrayOffset + p) | 0);
  return $n(a).get(i);
});
$c_Ljava_nio_HeapCharBuffer.prototype.put__C__Ljava_nio_CharBuffer = (function(c) {
  if (this.Ljava_nio_HeapCharBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  if ((p === this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferOverflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = ((1 + p) | 0);
  var a = this.Ljava_nio_CharBuffer__f__array;
  var i = ((this.Ljava_nio_CharBuffer__f__arrayOffset + p) | 0);
  $n(a).set(i, c);
  return this;
});
$c_Ljava_nio_HeapCharBuffer.prototype.get__I__C = (function(index) {
  if (((index < 0) || (index >= this.Ljava_nio_Buffer__f__limit))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  var a = this.Ljava_nio_CharBuffer__f__array;
  var i = ((this.Ljava_nio_CharBuffer__f__arrayOffset + index) | 0);
  return $n(a).get(i);
});
$c_Ljava_nio_HeapCharBuffer.prototype.get__AC__I__I__Ljava_nio_CharBuffer = (function(dst, offset, length) {
  if ((((offset < 0) || (length < 0)) || (offset > (($n(dst).u.length - length) | 0)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var newPos = ((p + length) | 0);
  if ((newPos > this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferUnderflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPos;
  var x0 = this.Ljava_nio_CharBuffer__f__array;
  var x1 = ((this.Ljava_nio_CharBuffer__f__arrayOffset + p) | 0);
  $systemArraycopy($n(x0), x1, $n(dst), offset, length);
  return this;
});
$c_Ljava_nio_HeapCharBuffer.prototype.load__I__C = (function(index) {
  var a = this.Ljava_nio_CharBuffer__f__array;
  var i = ((this.Ljava_nio_CharBuffer__f__arrayOffset + index) | 0);
  return $n(a).get(i);
});
$c_Ljava_nio_HeapCharBuffer.prototype.store__I__C__V = (function(index, elem) {
  var a = this.Ljava_nio_CharBuffer__f__array;
  var i = ((this.Ljava_nio_CharBuffer__f__arrayOffset + index) | 0);
  $n(a).set(i, elem);
});
$c_Ljava_nio_HeapCharBuffer.prototype.store__I__AC__I__I__V = (function(startIndex, src, offset, length) {
  var x2 = this.Ljava_nio_CharBuffer__f__array;
  var x3 = ((this.Ljava_nio_CharBuffer__f__arrayOffset + startIndex) | 0);
  $systemArraycopy($n(src), offset, $n(x2), x3, length);
});
$c_Ljava_nio_HeapCharBuffer.prototype.subSequence__I__I__jl_CharSequence = (function(start, end) {
  return this.subSequence__I__I__Ljava_nio_CharBuffer(start, end);
});
var $d_Ljava_nio_HeapCharBuffer = new $TypeData().initClass($c_Ljava_nio_HeapCharBuffer, "java.nio.HeapCharBuffer", ({
  Ljava_nio_HeapCharBuffer: 1,
  Ljava_nio_CharBuffer: 1,
  Ljava_nio_Buffer: 1,
  jl_Comparable: 1,
  jl_CharSequence: 1,
  jl_Appendable: 1,
  jl_Readable: 1
}));
/** @constructor */
function $c_Ljava_nio_StringCharBuffer(_capacity, _csq, _csqOffset, _initialPosition, _initialLimit) {
  this.Ljava_nio_Buffer__f__capacity = 0;
  this.Ljava_nio_Buffer__f__limit = 0;
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  this.Ljava_nio_Buffer__f__mark = 0;
  this.Ljava_nio_CharBuffer__f__array = null;
  this.Ljava_nio_CharBuffer__f__arrayOffset = 0;
  this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csq = null;
  this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csqOffset = 0;
  this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csq = _csq;
  this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csqOffset = _csqOffset;
  $ct_Ljava_nio_CharBuffer__I__AC__I__(this, _capacity, null, (-1));
  $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this, _initialPosition);
  $c_Ljava_nio_Buffer.prototype.limit__I__Ljava_nio_Buffer.call(this, _initialLimit);
}
$c_Ljava_nio_StringCharBuffer.prototype = new $h_Ljava_nio_CharBuffer();
$c_Ljava_nio_StringCharBuffer.prototype.constructor = $c_Ljava_nio_StringCharBuffer;
/** @constructor */
function $h_Ljava_nio_StringCharBuffer() {
}
$h_Ljava_nio_StringCharBuffer.prototype = $c_Ljava_nio_StringCharBuffer.prototype;
$c_Ljava_nio_StringCharBuffer.prototype.isReadOnly__Z = (function() {
  return true;
});
$c_Ljava_nio_StringCharBuffer.prototype.subSequence__I__I__Ljava_nio_CharBuffer = (function(start, end) {
  if ((((start < 0) || (end < start)) || (end > ((this.Ljava_nio_Buffer__f__limit - this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  return new $c_Ljava_nio_StringCharBuffer(this.Ljava_nio_Buffer__f__capacity, this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csq, this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csqOffset, ((this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + start) | 0), ((this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + end) | 0));
});
$c_Ljava_nio_StringCharBuffer.prototype.get__C = (function() {
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  if ((p === this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferUnderflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = ((1 + p) | 0);
  return $dp_charAt__I__C($n(this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csq), ((this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csqOffset + p) | 0));
});
$c_Ljava_nio_StringCharBuffer.prototype.put__C__Ljava_nio_CharBuffer = (function(c) {
  throw new $c_Ljava_nio_ReadOnlyBufferException();
});
$c_Ljava_nio_StringCharBuffer.prototype.get__I__C = (function(index) {
  if (((index < 0) || (index >= this.Ljava_nio_Buffer__f__limit))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  return $dp_charAt__I__C($n(this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csq), ((this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csqOffset + index) | 0));
});
$c_Ljava_nio_StringCharBuffer.prototype.get__AC__I__I__Ljava_nio_CharBuffer = (function(dst, offset, length) {
  if ((((offset < 0) || (length < 0)) || (offset > (($n(dst).u.length - length) | 0)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var newPos = ((p + length) | 0);
  if ((newPos > this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferUnderflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPos;
  var selfPos = p;
  var endPos = ((selfPos + length) | 0);
  var arrayIndex = offset;
  while ((selfPos !== endPos)) {
    var i = arrayIndex;
    var index = selfPos;
    var v = $dp_charAt__I__C($n(this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csq), ((this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csqOffset + index) | 0));
    $n(dst).set(i, v);
    selfPos = ((1 + selfPos) | 0);
    arrayIndex = ((1 + arrayIndex) | 0);
  }
  return this;
});
$c_Ljava_nio_StringCharBuffer.prototype.toString__T = (function() {
  var offset = this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csqOffset;
  return $dp_toString__T($n($dp_subSequence__I__I__jl_CharSequence($n(this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csq), ((this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + offset) | 0), ((this.Ljava_nio_Buffer__f__limit + offset) | 0))));
});
$c_Ljava_nio_StringCharBuffer.prototype.load__I__C = (function(index) {
  return $dp_charAt__I__C($n(this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csq), ((this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csqOffset + index) | 0));
});
$c_Ljava_nio_StringCharBuffer.prototype.store__I__C__V = (function(index, elem) {
  throw new $c_Ljava_nio_ReadOnlyBufferException();
});
$c_Ljava_nio_StringCharBuffer.prototype.store__I__AC__I__I__V = (function(startIndex, src, offset, length) {
  throw new $c_Ljava_nio_ReadOnlyBufferException();
});
$c_Ljava_nio_StringCharBuffer.prototype.subSequence__I__I__jl_CharSequence = (function(start, end) {
  return this.subSequence__I__I__Ljava_nio_CharBuffer(start, end);
});
var $d_Ljava_nio_StringCharBuffer = new $TypeData().initClass($c_Ljava_nio_StringCharBuffer, "java.nio.StringCharBuffer", ({
  Ljava_nio_StringCharBuffer: 1,
  Ljava_nio_CharBuffer: 1,
  Ljava_nio_Buffer: 1,
  jl_Comparable: 1,
  jl_CharSequence: 1,
  jl_Appendable: 1,
  jl_Readable: 1
}));
class $c_ju_DuplicateFormatFlagsException extends $c_ju_IllegalFormatException {
  constructor(f) {
    super();
    this.ju_DuplicateFormatFlagsException__f_f = null;
    this.ju_DuplicateFormatFlagsException__f_f = f;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((f === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
    }
  }
  getMessage__T() {
    return (("Flags = '" + this.ju_DuplicateFormatFlagsException__f_f) + "'");
  }
}
var $d_ju_DuplicateFormatFlagsException = new $TypeData().initClass($c_ju_DuplicateFormatFlagsException, "java.util.DuplicateFormatFlagsException", ({
  ju_DuplicateFormatFlagsException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_ju_FormatFlagsConversionMismatchException extends $c_ju_IllegalFormatException {
  constructor(f, c) {
    super();
    this.ju_FormatFlagsConversionMismatchException__f_f = null;
    this.ju_FormatFlagsConversionMismatchException__f_c = 0;
    this.ju_FormatFlagsConversionMismatchException__f_f = f;
    this.ju_FormatFlagsConversionMismatchException__f_c = c;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((f === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
    }
  }
  getMessage__T() {
    return ((("Conversion = " + $cToS(this.ju_FormatFlagsConversionMismatchException__f_c)) + ", Flags = ") + this.ju_FormatFlagsConversionMismatchException__f_f);
  }
}
var $d_ju_FormatFlagsConversionMismatchException = new $TypeData().initClass($c_ju_FormatFlagsConversionMismatchException, "java.util.FormatFlagsConversionMismatchException", ({
  ju_FormatFlagsConversionMismatchException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_ju_IllegalFormatArgumentIndexException extends $c_ju_IllegalFormatException {
  constructor(msg) {
    super();
    this.ju_IllegalFormatArgumentIndexException__f_msg = null;
    this.ju_IllegalFormatArgumentIndexException__f_msg = msg;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  getMessage__T() {
    return this.ju_IllegalFormatArgumentIndexException__f_msg;
  }
}
var $d_ju_IllegalFormatArgumentIndexException = new $TypeData().initClass($c_ju_IllegalFormatArgumentIndexException, "java.util.IllegalFormatArgumentIndexException", ({
  ju_IllegalFormatArgumentIndexException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_ju_IllegalFormatCodePointException extends $c_ju_IllegalFormatException {
  constructor(c) {
    super();
    this.ju_IllegalFormatCodePointException__f_c = 0;
    this.ju_IllegalFormatCodePointException__f_c = c;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  getMessage__T() {
    var i = this.ju_IllegalFormatCodePointException__f_c;
    return ("Code point = 0x" + $as_T($uD((i >>> 0.0)).toString(16)));
  }
}
var $d_ju_IllegalFormatCodePointException = new $TypeData().initClass($c_ju_IllegalFormatCodePointException, "java.util.IllegalFormatCodePointException", ({
  ju_IllegalFormatCodePointException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_ju_IllegalFormatConversionException extends $c_ju_IllegalFormatException {
  constructor(c, arg) {
    super();
    this.ju_IllegalFormatConversionException__f_c = 0;
    this.ju_IllegalFormatConversionException__f_arg = null;
    this.ju_IllegalFormatConversionException__f_c = c;
    this.ju_IllegalFormatConversionException__f_arg = arg;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((arg === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
    }
  }
  getMessage__T() {
    var this$1 = this.ju_IllegalFormatConversionException__f_c;
    return ((("" + $cToS(this$1)) + " != ") + $n(this.ju_IllegalFormatConversionException__f_arg).getName__T());
  }
}
var $d_ju_IllegalFormatConversionException = new $TypeData().initClass($c_ju_IllegalFormatConversionException, "java.util.IllegalFormatConversionException", ({
  ju_IllegalFormatConversionException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_ju_IllegalFormatFlagsException extends $c_ju_IllegalFormatException {
  constructor(f) {
    super();
    this.ju_IllegalFormatFlagsException__f_f = null;
    this.ju_IllegalFormatFlagsException__f_f = f;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((f === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
    }
  }
  getMessage__T() {
    return (("Flags = '" + this.ju_IllegalFormatFlagsException__f_f) + "'");
  }
}
var $d_ju_IllegalFormatFlagsException = new $TypeData().initClass($c_ju_IllegalFormatFlagsException, "java.util.IllegalFormatFlagsException", ({
  ju_IllegalFormatFlagsException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_ju_IllegalFormatPrecisionException extends $c_ju_IllegalFormatException {
  constructor(p) {
    super();
    this.ju_IllegalFormatPrecisionException__f_p = 0;
    this.ju_IllegalFormatPrecisionException__f_p = p;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  getMessage__T() {
    var i = this.ju_IllegalFormatPrecisionException__f_p;
    return ("" + i);
  }
}
var $d_ju_IllegalFormatPrecisionException = new $TypeData().initClass($c_ju_IllegalFormatPrecisionException, "java.util.IllegalFormatPrecisionException", ({
  ju_IllegalFormatPrecisionException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_ju_IllegalFormatWidthException extends $c_ju_IllegalFormatException {
  constructor(w) {
    super();
    this.ju_IllegalFormatWidthException__f_w = 0;
    this.ju_IllegalFormatWidthException__f_w = w;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  getMessage__T() {
    var i = this.ju_IllegalFormatWidthException__f_w;
    return ("" + i);
  }
}
var $d_ju_IllegalFormatWidthException = new $TypeData().initClass($c_ju_IllegalFormatWidthException, "java.util.IllegalFormatWidthException", ({
  ju_IllegalFormatWidthException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_ju_MissingFormatArgumentException extends $c_ju_IllegalFormatException {
  constructor(s) {
    super();
    this.ju_MissingFormatArgumentException__f_s = null;
    this.ju_MissingFormatArgumentException__f_s = s;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((s === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
    }
  }
  getMessage__T() {
    return (("Format specifier '" + this.ju_MissingFormatArgumentException__f_s) + "'");
  }
}
var $d_ju_MissingFormatArgumentException = new $TypeData().initClass($c_ju_MissingFormatArgumentException, "java.util.MissingFormatArgumentException", ({
  ju_MissingFormatArgumentException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_ju_MissingFormatWidthException extends $c_ju_IllegalFormatException {
  constructor(s) {
    super();
    this.ju_MissingFormatWidthException__f_s = null;
    this.ju_MissingFormatWidthException__f_s = s;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((s === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
    }
  }
  getMessage__T() {
    return this.ju_MissingFormatWidthException__f_s;
  }
}
var $d_ju_MissingFormatWidthException = new $TypeData().initClass($c_ju_MissingFormatWidthException, "java.util.MissingFormatWidthException", ({
  ju_MissingFormatWidthException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_ju_UnknownFormatConversionException extends $c_ju_IllegalFormatException {
  constructor(s) {
    super();
    this.ju_UnknownFormatConversionException__f_s = null;
    this.ju_UnknownFormatConversionException__f_s = s;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((s === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
    }
  }
  getMessage__T() {
    return (("Conversion = '" + this.ju_UnknownFormatConversionException__f_s) + "'");
  }
}
var $d_ju_UnknownFormatConversionException = new $TypeData().initClass($c_ju_UnknownFormatConversionException, "java.util.UnknownFormatConversionException", ({
  ju_UnknownFormatConversionException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap$InnerHashMap(initialCapacity, loadFactor) {
  this.ju_HashMap__f_java$util$HashMap$$loadFactor = 0.0;
  this.ju_HashMap__f_java$util$HashMap$$table = null;
  this.ju_HashMap__f_threshold = 0;
  this.ju_HashMap__f_contentSize = 0;
  $ct_ju_HashMap__I__F__(this, initialCapacity, loadFactor);
}
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype = new $h_ju_NullRejectingHashMap();
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap$InnerHashMap() {
}
$h_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype;
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype.nodeIterator__ju_Iterator = (function() {
  return new $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator(this);
});
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype.java$util$concurrent$ConcurrentHashMap$InnerHashMap$$makeSnapshot__ju_ArrayList = (function() {
  var snapshot = $ct_ju_ArrayList__I__(new $c_ju_ArrayList(), this.ju_HashMap__f_contentSize);
  var iter = new $c_ju_HashMap$NodeIterator(this);
  while (iter.hasNext__Z()) {
    snapshot.add__O__Z(iter.next__O());
  }
  return snapshot;
});
var $d_ju_concurrent_ConcurrentHashMap$InnerHashMap = new $TypeData().initClass($c_ju_concurrent_ConcurrentHashMap$InnerHashMap, "java.util.concurrent.ConcurrentHashMap$InnerHashMap", ({
  ju_concurrent_ConcurrentHashMap$InnerHashMap: 1,
  ju_NullRejectingHashMap: 1,
  ju_HashMap: 1,
  ju_AbstractMap: 1,
  ju_Map: 1,
  Ljava_io_Serializable: 1,
  jl_Cloneable: 1
}));
/** @constructor */
function $c_Llaika_api_errors_InvalidConfig(error) {
  this.Llaika_api_errors_InvalidConfig__f_error = null;
  this.Llaika_api_errors_InvalidConfig__f_error = error;
  $n(error).message__T();
}
$c_Llaika_api_errors_InvalidConfig.prototype = new $h_O();
$c_Llaika_api_errors_InvalidConfig.prototype.constructor = $c_Llaika_api_errors_InvalidConfig;
/** @constructor */
function $h_Llaika_api_errors_InvalidConfig() {
}
$h_Llaika_api_errors_InvalidConfig.prototype = $c_Llaika_api_errors_InvalidConfig.prototype;
$c_Llaika_api_errors_InvalidConfig.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_errors_InvalidConfig.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_errors_InvalidConfig.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_errors_InvalidConfig)) {
    var x$0$2 = $as_Llaika_api_errors_InvalidConfig(x$0);
    var x = this.Llaika_api_errors_InvalidConfig__f_error;
    var x$2 = $n(x$0$2).Llaika_api_errors_InvalidConfig__f_error;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_errors_InvalidConfig.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_errors_InvalidConfig.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_api_errors_InvalidConfig.prototype.productPrefix__T = (function() {
  return "InvalidConfig";
});
$c_Llaika_api_errors_InvalidConfig.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_api_errors_InvalidConfig__f_error;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llaika_api_errors_InvalidConfig(obj) {
  return (((obj instanceof $c_Llaika_api_errors_InvalidConfig) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.errors.InvalidConfig"));
}
function $isArrayOf_Llaika_api_errors_InvalidConfig(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_errors_InvalidConfig)));
}
function $asArrayOf_Llaika_api_errors_InvalidConfig(obj, depth) {
  return (($isArrayOf_Llaika_api_errors_InvalidConfig(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.errors.InvalidConfig;", depth));
}
var $d_Llaika_api_errors_InvalidConfig = new $TypeData().initClass($c_Llaika_api_errors_InvalidConfig, "laika.api.errors.InvalidConfig", ({
  Llaika_api_errors_InvalidConfig: 1,
  Llaika_api_errors_TransformationError: 1,
  Llaika_api_errors_ParserError: 1,
  Llaika_api_errors_RendererError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
class $c_Llaika_api_errors_InvalidDocument extends $c_jl_RuntimeException {
  constructor(errors, path) {
    super();
    this.Llaika_api_errors_InvalidDocument__f_errors = null;
    this.Llaika_api_errors_InvalidDocument__f_path = null;
    this.Llaika_api_errors_InvalidDocument__f_errors = errors;
    this.Llaika_api_errors_InvalidDocument__f_path = path;
    var s = ((("One or more errors processing document '" + path) + "': ") + $m_Llaika_api_errors_InvalidDocument$().format__s_util_Either__Llaika_ast_Path__T(errors, path));
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
  productIterator__sc_Iterator() {
    return new $c_s_Product$$anon$1(this);
  }
  hashCode__I() {
    var this$2 = $m_s_util_hashing_MurmurHash3$();
    return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
  }
  equals__O__Z(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Llaika_api_errors_InvalidDocument)) {
      var x$0$2 = $as_Llaika_api_errors_InvalidDocument(x$0);
      var x = this.Llaika_api_errors_InvalidDocument__f_errors;
      var x$2 = $n(x$0$2).Llaika_api_errors_InvalidDocument__f_errors;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Llaika_api_errors_InvalidDocument__f_path;
        var x$4 = $n(x$0$2).Llaika_api_errors_InvalidDocument__f_path;
        var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        $n(x$0$2);
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  productArity__I() {
    return 2;
  }
  productPrefix__T() {
    return "InvalidDocument";
  }
  productElement__I__O(n) {
    if ((n === 0)) {
      return this.Llaika_api_errors_InvalidDocument__f_errors;
    }
    if ((n === 1)) {
      return this.Llaika_api_errors_InvalidDocument__f_path;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
}
function $as_Llaika_api_errors_InvalidDocument(obj) {
  return (((obj instanceof $c_Llaika_api_errors_InvalidDocument) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.errors.InvalidDocument"));
}
function $isArrayOf_Llaika_api_errors_InvalidDocument(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_errors_InvalidDocument)));
}
function $asArrayOf_Llaika_api_errors_InvalidDocument(obj, depth) {
  return (($isArrayOf_Llaika_api_errors_InvalidDocument(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.errors.InvalidDocument;", depth));
}
var $d_Llaika_api_errors_InvalidDocument = new $TypeData().initClass($c_Llaika_api_errors_InvalidDocument, "laika.api.errors.InvalidDocument", ({
  Llaika_api_errors_InvalidDocument: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Llaika_ast_DocumentTreeBuilder$DocumentPart(doc) {
  this.Llaika_ast_DocumentTreeBuilder$DocumentPart__f_doc = null;
  this.Llaika_ast_DocumentTreeBuilder$DocumentPart__f_path = null;
  this.Llaika_ast_DocumentTreeBuilder$DocumentPart__f_doc = doc;
  this.Llaika_ast_DocumentTreeBuilder$DocumentPart__f_path = $n(doc).path__Llaika_ast_Path();
}
$c_Llaika_ast_DocumentTreeBuilder$DocumentPart.prototype = new $h_O();
$c_Llaika_ast_DocumentTreeBuilder$DocumentPart.prototype.constructor = $c_Llaika_ast_DocumentTreeBuilder$DocumentPart;
/** @constructor */
function $h_Llaika_ast_DocumentTreeBuilder$DocumentPart() {
}
$h_Llaika_ast_DocumentTreeBuilder$DocumentPart.prototype = $c_Llaika_ast_DocumentTreeBuilder$DocumentPart.prototype;
$c_Llaika_ast_DocumentTreeBuilder$DocumentPart.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_DocumentTreeBuilder$DocumentPart.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_DocumentTreeBuilder$DocumentPart.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_DocumentTreeBuilder$DocumentPart)) {
    var x$0$2 = $as_Llaika_ast_DocumentTreeBuilder$DocumentPart(x$0);
    var x = this.Llaika_ast_DocumentTreeBuilder$DocumentPart__f_doc;
    var x$2 = $n(x$0$2).Llaika_ast_DocumentTreeBuilder$DocumentPart__f_doc;
    if ((x === null)) {
      var $x_1 = (x$2 === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === x$2);
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_DocumentTreeBuilder$DocumentPart.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_DocumentTreeBuilder$DocumentPart.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_ast_DocumentTreeBuilder$DocumentPart.prototype.productPrefix__T = (function() {
  return "DocumentPart";
});
$c_Llaika_ast_DocumentTreeBuilder$DocumentPart.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_DocumentTreeBuilder$DocumentPart__f_doc;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_DocumentTreeBuilder$DocumentPart.prototype.path__Llaika_ast_Path = (function() {
  return this.Llaika_ast_DocumentTreeBuilder$DocumentPart__f_path;
});
function $as_Llaika_ast_DocumentTreeBuilder$DocumentPart(obj) {
  return (((obj instanceof $c_Llaika_ast_DocumentTreeBuilder$DocumentPart) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.DocumentTreeBuilder$DocumentPart"));
}
function $isArrayOf_Llaika_ast_DocumentTreeBuilder$DocumentPart(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_DocumentTreeBuilder$DocumentPart)));
}
function $asArrayOf_Llaika_ast_DocumentTreeBuilder$DocumentPart(obj, depth) {
  return (($isArrayOf_Llaika_ast_DocumentTreeBuilder$DocumentPart(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.DocumentTreeBuilder$DocumentPart;", depth));
}
var $d_Llaika_ast_DocumentTreeBuilder$DocumentPart = new $TypeData().initClass($c_Llaika_ast_DocumentTreeBuilder$DocumentPart, "laika.ast.DocumentTreeBuilder$DocumentPart", ({
  Llaika_ast_DocumentTreeBuilder$DocumentPart: 1,
  Llaika_ast_Navigatable: 1,
  Llaika_ast_DocumentTreeBuilder$BuilderPart: 1,
  Llaika_ast_DocumentTreeBuilder$TreeContentPart: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $as_Llaika_ast_DocumentTreeBuilder$MarkupPart(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.DocumentTreeBuilder$MarkupPart"));
}
function $isArrayOf_Llaika_ast_DocumentTreeBuilder$MarkupPart(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_DocumentTreeBuilder$MarkupPart)));
}
function $asArrayOf_Llaika_ast_DocumentTreeBuilder$MarkupPart(obj, depth) {
  return (($isArrayOf_Llaika_ast_DocumentTreeBuilder$MarkupPart(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.DocumentTreeBuilder$MarkupPart;", depth));
}
/** @constructor */
function $c_Llaika_ast_DocumentTreeBuilder$TreePart(path, content, templates, hocon, config) {
  this.Llaika_ast_DocumentTreeBuilder$TreePart__f_path = null;
  this.Llaika_ast_DocumentTreeBuilder$TreePart__f_content = null;
  this.Llaika_ast_DocumentTreeBuilder$TreePart__f_templates = null;
  this.Llaika_ast_DocumentTreeBuilder$TreePart__f_hocon = null;
  this.Llaika_ast_DocumentTreeBuilder$TreePart__f_config = null;
  this.Llaika_ast_DocumentTreeBuilder$TreePart__f_path = path;
  this.Llaika_ast_DocumentTreeBuilder$TreePart__f_content = content;
  this.Llaika_ast_DocumentTreeBuilder$TreePart__f_templates = templates;
  this.Llaika_ast_DocumentTreeBuilder$TreePart__f_hocon = hocon;
  this.Llaika_ast_DocumentTreeBuilder$TreePart__f_config = config;
}
$c_Llaika_ast_DocumentTreeBuilder$TreePart.prototype = new $h_O();
$c_Llaika_ast_DocumentTreeBuilder$TreePart.prototype.constructor = $c_Llaika_ast_DocumentTreeBuilder$TreePart;
/** @constructor */
function $h_Llaika_ast_DocumentTreeBuilder$TreePart() {
}
$h_Llaika_ast_DocumentTreeBuilder$TreePart.prototype = $c_Llaika_ast_DocumentTreeBuilder$TreePart.prototype;
$c_Llaika_ast_DocumentTreeBuilder$TreePart.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_DocumentTreeBuilder$TreePart.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_DocumentTreeBuilder$TreePart.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_DocumentTreeBuilder$TreePart)) {
    var x$0$2 = $as_Llaika_ast_DocumentTreeBuilder$TreePart(x$0);
    var x = this.Llaika_ast_DocumentTreeBuilder$TreePart__f_path;
    var x$2 = $n(x$0$2).Llaika_ast_DocumentTreeBuilder$TreePart__f_path;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_DocumentTreeBuilder$TreePart__f_content;
      var x$4 = $n(x$0$2).Llaika_ast_DocumentTreeBuilder$TreePart__f_content;
      var $x_4 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.Llaika_ast_DocumentTreeBuilder$TreePart__f_templates;
      var x$6 = $n(x$0$2).Llaika_ast_DocumentTreeBuilder$TreePart__f_templates;
      var $x_3 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.Llaika_ast_DocumentTreeBuilder$TreePart__f_hocon;
      var x$8 = $n(x$0$2).Llaika_ast_DocumentTreeBuilder$TreePart__f_hocon;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.Llaika_ast_DocumentTreeBuilder$TreePart__f_config;
      var x$10 = $n(x$0$2).Llaika_ast_DocumentTreeBuilder$TreePart__f_config;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_DocumentTreeBuilder$TreePart.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_DocumentTreeBuilder$TreePart.prototype.productArity__I = (function() {
  return 5;
});
$c_Llaika_ast_DocumentTreeBuilder$TreePart.prototype.productPrefix__T = (function() {
  return "TreePart";
});
$c_Llaika_ast_DocumentTreeBuilder$TreePart.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_DocumentTreeBuilder$TreePart__f_path;
      break;
    }
    case 1: {
      return this.Llaika_ast_DocumentTreeBuilder$TreePart__f_content;
      break;
    }
    case 2: {
      return this.Llaika_ast_DocumentTreeBuilder$TreePart__f_templates;
      break;
    }
    case 3: {
      return this.Llaika_ast_DocumentTreeBuilder$TreePart__f_hocon;
      break;
    }
    case 4: {
      return this.Llaika_ast_DocumentTreeBuilder$TreePart__f_config;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_DocumentTreeBuilder$TreePart.prototype.path__Llaika_ast_Path = (function() {
  return this.Llaika_ast_DocumentTreeBuilder$TreePart__f_path;
});
$c_Llaika_ast_DocumentTreeBuilder$TreePart.prototype.mergeConfigs__Llaika_api_config_Config = (function() {
  return $as_Llaika_api_config_Config($n(this.Llaika_ast_DocumentTreeBuilder$TreePart__f_config).foldLeft__O__F2__O($m_Llaika_api_config_Config$().Llaika_api_config_Config$__f_empty, new $c_sjsr_AnonFunction2(((x$1, x$2) => {
    var x$1$1 = $as_Llaika_api_config_Config(x$1);
    var x$2$1 = $as_Llaika_ast_DocumentTreeBuilder$ConfigPart(x$2);
    var $x_1 = $n($n($n(x$2$1).config__Llaika_api_config_Config()).withFallback__Llaika_api_config_Config__Llaika_api_config_Config(x$1$1));
    $m_Llaika_api_config_Origin$();
    var scope = $m_Llaika_api_config_Origin$TreeScope$();
    var path = $n(x$2$1).path__Llaika_ast_Path();
    $m_Llaika_api_config_Origin$();
    var sourcePath = $m_s_None$();
    return $n($x_1).withOrigin__Llaika_api_config_Origin__Llaika_api_config_Config(new $c_Llaika_api_config_Origin(scope, path, sourcePath));
  }))));
});
function $as_Llaika_ast_DocumentTreeBuilder$TreePart(obj) {
  return (((obj instanceof $c_Llaika_ast_DocumentTreeBuilder$TreePart) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.DocumentTreeBuilder$TreePart"));
}
function $isArrayOf_Llaika_ast_DocumentTreeBuilder$TreePart(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_DocumentTreeBuilder$TreePart)));
}
function $asArrayOf_Llaika_ast_DocumentTreeBuilder$TreePart(obj, depth) {
  return (($isArrayOf_Llaika_ast_DocumentTreeBuilder$TreePart(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.DocumentTreeBuilder$TreePart;", depth));
}
var $d_Llaika_ast_DocumentTreeBuilder$TreePart = new $TypeData().initClass($c_Llaika_ast_DocumentTreeBuilder$TreePart, "laika.ast.DocumentTreeBuilder$TreePart", ({
  Llaika_ast_DocumentTreeBuilder$TreePart: 1,
  Llaika_ast_Navigatable: 1,
  Llaika_ast_DocumentTreeBuilder$BuilderPart: 1,
  Llaika_ast_DocumentTreeBuilder$TreeContentPart: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $as_Llaika_ast_IconGlyph(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.IconGlyph"));
}
function $isArrayOf_Llaika_ast_IconGlyph(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_IconGlyph)));
}
function $asArrayOf_Llaika_ast_IconGlyph(obj, depth) {
  return (($isArrayOf_Llaika_ast_IconGlyph(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.IconGlyph;", depth));
}
function $as_Llaika_ast_IconStyle(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.IconStyle"));
}
function $isArrayOf_Llaika_ast_IconStyle(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_IconStyle)));
}
function $asArrayOf_Llaika_ast_IconStyle(obj, depth) {
  return (($isArrayOf_Llaika_ast_IconStyle(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.IconStyle;", depth));
}
function $as_Llaika_ast_InlineSVGIcon(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.InlineSVGIcon"));
}
function $isArrayOf_Llaika_ast_InlineSVGIcon(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_InlineSVGIcon)));
}
function $asArrayOf_Llaika_ast_InlineSVGIcon(obj, depth) {
  return (($isArrayOf_Llaika_ast_InlineSVGIcon(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.InlineSVGIcon;", depth));
}
/** @constructor */
function $c_Llaika_ast_RelativePath$CurrentDocument(fragment) {
  this.Llaika_ast_RelativePath$CurrentDocument__f_fragment = null;
  this.Llaika_ast_RelativePath$CurrentDocument__f_name = null;
  this.Llaika_ast_RelativePath$CurrentDocument__f_parent = null;
  this.Llaika_ast_RelativePath$CurrentDocument__f_parentLevels = 0;
  this.Llaika_ast_RelativePath$CurrentDocument__f_suffix = null;
  this.Llaika_ast_RelativePath$CurrentDocument__f_toString = null;
  this.Llaika_ast_RelativePath$CurrentDocument__f_fragment = fragment;
  this.Llaika_ast_RelativePath$CurrentDocument__f_name = "";
  this.Llaika_ast_RelativePath$CurrentDocument__f_parent = $m_Llaika_ast_RelativePath$CurrentTree$();
  this.Llaika_ast_RelativePath$CurrentDocument__f_parentLevels = 0;
  this.Llaika_ast_RelativePath$CurrentDocument__f_suffix = $m_s_None$();
  var this$1 = $n(fragment);
  this.Llaika_ast_RelativePath$CurrentDocument__f_toString = ("#" + (this$1.isEmpty__Z() ? "" : this$1.get__O()));
}
$c_Llaika_ast_RelativePath$CurrentDocument.prototype = new $h_O();
$c_Llaika_ast_RelativePath$CurrentDocument.prototype.constructor = $c_Llaika_ast_RelativePath$CurrentDocument;
/** @constructor */
function $h_Llaika_ast_RelativePath$CurrentDocument() {
}
$h_Llaika_ast_RelativePath$CurrentDocument.prototype = $c_Llaika_ast_RelativePath$CurrentDocument.prototype;
$c_Llaika_ast_RelativePath$CurrentDocument.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_RelativePath$CurrentDocument.prototype.copyWith__T__s_Option__s_Option__Llaika_ast_RelativePath = (function(basename, suffix, fragment) {
  return this;
});
$c_Llaika_ast_RelativePath$CurrentDocument.prototype.copyWith$default$1__T = (function() {
  return this.Llaika_ast_RelativePath$CurrentDocument__f_name;
});
$c_Llaika_ast_RelativePath$CurrentDocument.prototype.copyWith$default$2__s_Option = (function() {
  return this.Llaika_ast_RelativePath$CurrentDocument__f_suffix;
});
$c_Llaika_ast_RelativePath$CurrentDocument.prototype.copyWith$default$3__s_Option = (function() {
  return this.Llaika_ast_RelativePath$CurrentDocument__f_fragment;
});
$c_Llaika_ast_RelativePath$CurrentDocument.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_RelativePath$CurrentDocument.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_RelativePath$CurrentDocument)) {
    var x$0$2 = $as_Llaika_ast_RelativePath$CurrentDocument(x$0);
    var x = this.Llaika_ast_RelativePath$CurrentDocument__f_fragment;
    var x$2 = $n(x$0$2).Llaika_ast_RelativePath$CurrentDocument__f_fragment;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_RelativePath$CurrentDocument.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_ast_RelativePath$CurrentDocument.prototype.productPrefix__T = (function() {
  return "CurrentDocument";
});
$c_Llaika_ast_RelativePath$CurrentDocument.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_RelativePath$CurrentDocument__f_fragment;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_RelativePath$CurrentDocument.prototype.name__T = (function() {
  return this.Llaika_ast_RelativePath$CurrentDocument__f_name;
});
$c_Llaika_ast_RelativePath$CurrentDocument.prototype.parent__Llaika_ast_RelativePath = (function() {
  return this.Llaika_ast_RelativePath$CurrentDocument__f_parent;
});
$c_Llaika_ast_RelativePath$CurrentDocument.prototype.parentLevels__I = (function() {
  return this.Llaika_ast_RelativePath$CurrentDocument__f_parentLevels;
});
$c_Llaika_ast_RelativePath$CurrentDocument.prototype.$div__Llaika_ast_RelativePath__Llaika_ast_RelativePath = (function(path) {
  return this;
});
$c_Llaika_ast_RelativePath$CurrentDocument.prototype.withFragment__T__Llaika_ast_RelativePath = (function(fragment) {
  var fragment$1 = new $c_s_Some(fragment);
  return new $c_Llaika_ast_RelativePath$CurrentDocument(fragment$1);
});
$c_Llaika_ast_RelativePath$CurrentDocument.prototype.toString__T = (function() {
  return this.Llaika_ast_RelativePath$CurrentDocument__f_toString;
});
$c_Llaika_ast_RelativePath$CurrentDocument.prototype.$div__Llaika_ast_RelativePath__Llaika_ast_GenericPath = (function(path) {
  return this;
});
$c_Llaika_ast_RelativePath$CurrentDocument.prototype.withFragment__T__Llaika_ast_GenericPath = (function(fragment) {
  return this.withFragment__T__Llaika_ast_RelativePath(fragment);
});
$c_Llaika_ast_RelativePath$CurrentDocument.prototype.copyWith__T__s_Option__s_Option__Llaika_ast_GenericPath = (function(basename, suffix, fragment) {
  return this;
});
function $as_Llaika_ast_RelativePath$CurrentDocument(obj) {
  return (((obj instanceof $c_Llaika_ast_RelativePath$CurrentDocument) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.RelativePath$CurrentDocument"));
}
function $isArrayOf_Llaika_ast_RelativePath$CurrentDocument(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_RelativePath$CurrentDocument)));
}
function $asArrayOf_Llaika_ast_RelativePath$CurrentDocument(obj, depth) {
  return (($isArrayOf_Llaika_ast_RelativePath$CurrentDocument(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.RelativePath$CurrentDocument;", depth));
}
var $d_Llaika_ast_RelativePath$CurrentDocument = new $TypeData().initClass($c_Llaika_ast_RelativePath$CurrentDocument, "laika.ast.RelativePath$CurrentDocument", ({
  Llaika_ast_RelativePath$CurrentDocument: 1,
  Llaika_ast_GenericPath: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_VirtualPath: 1,
  Llaika_ast_RelativePath: 1
}));
/** @constructor */
function $c_Llaika_ast_RelativePath$Parent(parentLevels) {
  this.Llaika_ast_RelativePath$Parent__f_parentLevels = 0;
  this.Llaika_ast_RelativePath$Parent__f_name = null;
  this.Llaika_ast_RelativePath$Parent__f_suffix = null;
  this.Llaika_ast_RelativePath$Parent__f_fragment = null;
  this.Llaika_ast_RelativePath$Parent__f_parent$lzy2 = null;
  this.Llaika_ast_RelativePath$Parent__f_parentbitmap$2 = false;
  this.Llaika_ast_RelativePath$Parent__f_toString = null;
  this.Llaika_ast_RelativePath$Parent__f_parentLevels = parentLevels;
  this.Llaika_ast_RelativePath$Parent__f_name = $m_sc_StringOps$().$times$extension__T__I__T("../", parentLevels);
  this.Llaika_ast_RelativePath$Parent__f_suffix = $m_s_None$();
  this.Llaika_ast_RelativePath$Parent__f_fragment = $m_s_None$();
  this.Llaika_ast_RelativePath$Parent__f_toString = this.Llaika_ast_RelativePath$Parent__f_name;
}
$c_Llaika_ast_RelativePath$Parent.prototype = new $h_O();
$c_Llaika_ast_RelativePath$Parent.prototype.constructor = $c_Llaika_ast_RelativePath$Parent;
/** @constructor */
function $h_Llaika_ast_RelativePath$Parent() {
}
$h_Llaika_ast_RelativePath$Parent.prototype = $c_Llaika_ast_RelativePath$Parent.prototype;
$c_Llaika_ast_RelativePath$Parent.prototype.withFragment__T__Llaika_ast_GenericPath = (function(fragment) {
  return $f_Llaika_ast_GenericPath__withFragment__T__Llaika_ast_GenericPath(this, fragment);
});
$c_Llaika_ast_RelativePath$Parent.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_RelativePath$Parent.prototype.copyWith__T__s_Option__s_Option__Llaika_ast_RelativePath = (function(basename, suffix, fragment) {
  return this;
});
$c_Llaika_ast_RelativePath$Parent.prototype.copyWith$default$1__T = (function() {
  return this.Llaika_ast_RelativePath$Parent__f_name;
});
$c_Llaika_ast_RelativePath$Parent.prototype.copyWith$default$2__s_Option = (function() {
  return this.Llaika_ast_RelativePath$Parent__f_suffix;
});
$c_Llaika_ast_RelativePath$Parent.prototype.copyWith$default$3__s_Option = (function() {
  return this.Llaika_ast_RelativePath$Parent__f_fragment;
});
$c_Llaika_ast_RelativePath$Parent.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Parent");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Llaika_ast_RelativePath$Parent__f_parentLevels;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1);
});
$c_Llaika_ast_RelativePath$Parent.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_RelativePath$Parent)) {
    var x$0$2 = $as_Llaika_ast_RelativePath$Parent(x$0);
    return ((this.Llaika_ast_RelativePath$Parent__f_parentLevels === $n(x$0$2).Llaika_ast_RelativePath$Parent__f_parentLevels) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Llaika_ast_RelativePath$Parent.prototype.productArity__I = (function() {
  return 1;
});
$c_Llaika_ast_RelativePath$Parent.prototype.productPrefix__T = (function() {
  return "Parent";
});
$c_Llaika_ast_RelativePath$Parent.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_RelativePath$Parent__f_parentLevels;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_RelativePath$Parent.prototype.parentLevels__I = (function() {
  return this.Llaika_ast_RelativePath$Parent__f_parentLevels;
});
$c_Llaika_ast_RelativePath$Parent.prototype.name__T = (function() {
  return this.Llaika_ast_RelativePath$Parent__f_name;
});
$c_Llaika_ast_RelativePath$Parent.prototype.parent__Llaika_ast_RelativePath = (function() {
  if ((!this.Llaika_ast_RelativePath$Parent__f_parentbitmap$2)) {
    var parentLevels = ((1 + this.Llaika_ast_RelativePath$Parent__f_parentLevels) | 0);
    this.Llaika_ast_RelativePath$Parent__f_parent$lzy2 = new $c_Llaika_ast_RelativePath$Parent(parentLevels);
    this.Llaika_ast_RelativePath$Parent__f_parentbitmap$2 = true;
  }
  return this.Llaika_ast_RelativePath$Parent__f_parent$lzy2;
});
$c_Llaika_ast_RelativePath$Parent.prototype.$div__Llaika_ast_RelativePath__Llaika_ast_RelativePath = (function(path) {
  if ((path instanceof $c_Llaika_ast_RelativePath$Parent)) {
    var x$1 = $as_Llaika_ast_RelativePath$Parent(path);
    var this$2 = $n(x$1);
    var x93 = this$2.Llaika_ast_RelativePath$Parent__f_parentLevels;
    var parentLevels = ((this.Llaika_ast_RelativePath$Parent__f_parentLevels + x93) | 0);
    return new $c_Llaika_ast_RelativePath$Parent(parentLevels);
  } else if ((path instanceof $c_Llaika_ast_RelativePath$Segments)) {
    var p = $as_Llaika_ast_RelativePath$Segments(path);
    var segments = $n(p).Llaika_ast_RelativePath$Segments__f_segments;
    var suffix = $n(p).Llaika_ast_RelativePath$Segments__f_suffix;
    var fragment = $n(p).Llaika_ast_RelativePath$Segments__f_fragment;
    var parentLevels$1 = ((this.Llaika_ast_RelativePath$Parent__f_parentLevels + $n(p).Llaika_ast_RelativePath$Segments__f_parentLevels) | 0);
    return new $c_Llaika_ast_RelativePath$Segments(segments, suffix, fragment, parentLevels$1);
  } else {
    return this;
  }
});
$c_Llaika_ast_RelativePath$Parent.prototype.toString__T = (function() {
  return this.Llaika_ast_RelativePath$Parent__f_toString;
});
$c_Llaika_ast_RelativePath$Parent.prototype.$div__Llaika_ast_RelativePath__Llaika_ast_GenericPath = (function(path) {
  return this.$div__Llaika_ast_RelativePath__Llaika_ast_RelativePath(path);
});
$c_Llaika_ast_RelativePath$Parent.prototype.copyWith__T__s_Option__s_Option__Llaika_ast_GenericPath = (function(basename, suffix, fragment) {
  return this;
});
function $as_Llaika_ast_RelativePath$Parent(obj) {
  return (((obj instanceof $c_Llaika_ast_RelativePath$Parent) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.RelativePath$Parent"));
}
function $isArrayOf_Llaika_ast_RelativePath$Parent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_RelativePath$Parent)));
}
function $asArrayOf_Llaika_ast_RelativePath$Parent(obj, depth) {
  return (($isArrayOf_Llaika_ast_RelativePath$Parent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.RelativePath$Parent;", depth));
}
var $d_Llaika_ast_RelativePath$Parent = new $TypeData().initClass($c_Llaika_ast_RelativePath$Parent, "laika.ast.RelativePath$Parent", ({
  Llaika_ast_RelativePath$Parent: 1,
  Llaika_ast_GenericPath: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_VirtualPath: 1,
  Llaika_ast_RelativePath: 1
}));
function $as_Llaika_ast_SVGSymbolIcon(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.SVGSymbolIcon"));
}
function $isArrayOf_Llaika_ast_SVGSymbolIcon(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_SVGSymbolIcon)));
}
function $asArrayOf_Llaika_ast_SVGSymbolIcon(obj, depth) {
  return (($isArrayOf_Llaika_ast_SVGSymbolIcon(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.SVGSymbolIcon;", depth));
}
/** @constructor */
function $c_Llaika_ast_Selection(name, choices, options) {
  this.Llaika_ast_Selection__f_name = null;
  this.Llaika_ast_Selection__f_choices = null;
  this.Llaika_ast_Selection__f_options = null;
  this.Llaika_ast_Selection__f_name = name;
  this.Llaika_ast_Selection__f_choices = choices;
  this.Llaika_ast_Selection__f_options = options;
}
$c_Llaika_ast_Selection.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_Selection.prototype.constructor = $c_Llaika_ast_Selection;
/** @constructor */
function $h_Llaika_ast_Selection() {
}
$h_Llaika_ast_Selection.prototype = $c_Llaika_ast_Selection.prototype;
$c_Llaika_ast_Selection.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_Selection.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_Selection)) {
    var x$0$2 = $as_Llaika_ast_Selection(x$0);
    if ((this.Llaika_ast_Selection__f_name === $n(x$0$2).Llaika_ast_Selection__f_name)) {
      var x = this.Llaika_ast_Selection__f_choices;
      var x$2 = $n(x$0$2).Llaika_ast_Selection__f_choices;
      var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Llaika_ast_Selection__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_Selection__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_Selection.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_Selection.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_Selection.prototype.productPrefix__T = (function() {
  return "Selection";
});
$c_Llaika_ast_Selection.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_Selection__f_name;
      break;
    }
    case 1: {
      return this.Llaika_ast_Selection__f_choices;
      break;
    }
    case 2: {
      return this.Llaika_ast_Selection__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_Selection.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_Selection__f_options;
});
$c_Llaika_ast_Selection.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_Selection = (function(rules) {
  var choices$1 = $as_sci_Seq($n(this.Llaika_ast_Selection__f_choices).map__F1__O(new $c_sjsr_AnonFunction1(((c) => {
    var c$1 = $as_Llaika_ast_Choice(c);
    var this$2 = $n(c$1);
    var this$1 = $n(rules);
    var blocks = $n(c$1).Llaika_ast_Choice__f_content;
    var newContent = $p_Llaika_ast_RewriteRules__rewrite__F1__sci_Seq__sci_Seq(this$1, $p_Llaika_ast_RewriteRules__chainedBlockRules__F1(this$1), blocks);
    var name = this$2.Llaika_ast_Choice__f_name;
    var label = this$2.Llaika_ast_Choice__f_label;
    var options = this$2.Llaika_ast_Choice__f_options;
    return new $c_Llaika_ast_Choice(name, label, newContent, options);
  }))));
  var name$1 = this.Llaika_ast_Selection__f_name;
  var options$1 = this.Llaika_ast_Selection__f_options;
  return new $c_Llaika_ast_Selection(name$1, choices$1, options$1);
});
$c_Llaika_ast_Selection.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var name = this.Llaika_ast_Selection__f_name;
  var choices = this.Llaika_ast_Selection__f_choices;
  return new $c_Llaika_ast_Selection(name, choices, options);
});
$c_Llaika_ast_Selection.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return this.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_Selection(rules);
});
function $as_Llaika_ast_Selection(obj) {
  return (((obj instanceof $c_Llaika_ast_Selection) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Selection"));
}
function $isArrayOf_Llaika_ast_Selection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Selection)));
}
function $asArrayOf_Llaika_ast_Selection(obj, depth) {
  return (($isArrayOf_Llaika_ast_Selection(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Selection;", depth));
}
var $d_Llaika_ast_Selection = new $TypeData().initClass($c_Llaika_ast_Selection, "laika.ast.Selection", ({
  Llaika_ast_Selection: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_RewritableContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_html_HTMLEndTag(name, options) {
  this.Llaika_ast_html_HTMLEndTag__f_name = null;
  this.Llaika_ast_html_HTMLEndTag__f_options = null;
  this.Llaika_ast_html_HTMLEndTag__f_name = name;
  this.Llaika_ast_html_HTMLEndTag__f_options = options;
}
$c_Llaika_ast_html_HTMLEndTag.prototype = new $h_Llaika_ast_html_HTMLSpan();
$c_Llaika_ast_html_HTMLEndTag.prototype.constructor = $c_Llaika_ast_html_HTMLEndTag;
/** @constructor */
function $h_Llaika_ast_html_HTMLEndTag() {
}
$h_Llaika_ast_html_HTMLEndTag.prototype = $c_Llaika_ast_html_HTMLEndTag.prototype;
$c_Llaika_ast_html_HTMLEndTag.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_html_HTMLEndTag.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_html_HTMLEndTag)) {
    var x$0$2 = $as_Llaika_ast_html_HTMLEndTag(x$0);
    if ((this.Llaika_ast_html_HTMLEndTag__f_name === $n(x$0$2).Llaika_ast_html_HTMLEndTag__f_name)) {
      var x = this.Llaika_ast_html_HTMLEndTag__f_options;
      var x$2 = $n(x$0$2).Llaika_ast_html_HTMLEndTag__f_options;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_html_HTMLEndTag.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_html_HTMLEndTag.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_html_HTMLEndTag.prototype.productPrefix__T = (function() {
  return "HTMLEndTag";
});
$c_Llaika_ast_html_HTMLEndTag.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_html_HTMLEndTag__f_name;
  }
  if ((n === 1)) {
    return this.Llaika_ast_html_HTMLEndTag__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_html_HTMLEndTag.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_html_HTMLEndTag__f_options;
});
$c_Llaika_ast_html_HTMLEndTag.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var name = this.Llaika_ast_html_HTMLEndTag__f_name;
  return new $c_Llaika_ast_html_HTMLEndTag(name, options);
});
function $as_Llaika_ast_html_HTMLEndTag(obj) {
  return (((obj instanceof $c_Llaika_ast_html_HTMLEndTag) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.html.HTMLEndTag"));
}
function $isArrayOf_Llaika_ast_html_HTMLEndTag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_html_HTMLEndTag)));
}
function $asArrayOf_Llaika_ast_html_HTMLEndTag(obj, depth) {
  return (($isArrayOf_Llaika_ast_html_HTMLEndTag(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.html.HTMLEndTag;", depth));
}
var $d_Llaika_ast_html_HTMLEndTag = new $TypeData().initClass($c_Llaika_ast_html_HTMLEndTag, "laika.ast.html.HTMLEndTag", ({
  Llaika_ast_html_HTMLEndTag: 1,
  Llaika_ast_html_HTMLSpan: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1
}));
function $p_Llaika_internal_parse_markup_RootParser__highlighterMap__sci_Map($thiz) {
  if ((!$thiz.Llaika_internal_parse_markup_RootParser__f_highlighterMapbitmap$1)) {
    var $x_1 = $as_sc_IterableOnceOps($n($n($thiz.Llaika_internal_parse_markup_RootParser__f_markupExtensions).Llaika_api_bundle_MarkupExtensions__f_syntaxHighlighters).flatMap__F1__O(new $c_sjsr_AnonFunction1(((highlighter) => {
      var highlighter$1 = $as_Llaika_api_bundle_SyntaxHighlighter(highlighter);
      var this$1 = $n($n(highlighter$1).language__Lcats_data_NonEmptyList());
      var this$2 = $n(this$1.Lcats_data_NonEmptyList__f_tail);
      var elem = this$1.Lcats_data_NonEmptyList__f_head;
      var this$5 = new $c_sci_$colon$colon(elem, this$2);
      var f = ((lang) => {
        var lang$1 = $as_T(lang);
        var this$3 = $n(lang$1);
        var _1 = $as_T(this$3.toLowerCase());
        var _2 = $n(highlighter$1).rootParser__Llaika_parse_Parser();
        return new $c_T2(_1, _2);
      });
      if ((this$5 === $m_sci_Nil$())) {
        return $m_sci_Nil$();
      } else {
        var arg1 = this$5.sci_$colon$colon__f_head;
        var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
        var t = h;
        var rest = this$5.sci_$colon$colon__f_next;
        while ((rest !== $m_sci_Nil$())) {
          var arg1$1 = $n(rest).head__O();
          var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
          $n(t).sci_$colon$colon__f_next = nx;
          t = nx;
          rest = $as_sci_List($n(rest).tail__O());
        }
        return h;
      }
    }))));
    var this$6 = $m_s_$less$colon$less$();
    $thiz.Llaika_internal_parse_markup_RootParser__f_highlighterMap$lzy1 = $n($x_1).toMap__s_$less$colon$less__sci_Map(this$6.s_$less$colon$less$__f_singleton);
    $thiz.Llaika_internal_parse_markup_RootParser__f_highlighterMapbitmap$1 = true;
  }
  return $thiz.Llaika_internal_parse_markup_RootParser__f_highlighterMap$lzy1;
}
function $p_Llaika_internal_parse_markup_RootParser__sortedBlockParsers__sci_Seq($thiz) {
  if ((!$thiz.Llaika_internal_parse_markup_RootParser__f_sortedBlockParsersbitmap$1)) {
    $thiz.Llaika_internal_parse_markup_RootParser__f_sortedBlockParsers$lzy1 = $p_Llaika_internal_parse_markup_RootParser__createAndSortParsers__sci_Seq__sci_Seq__sci_Seq($thiz, ($n($thiz.Llaika_internal_parse_markup_RootParser__f_markupParser), $m_Llaika_format_Markdown$blockParsers$()).Llaika_format_Markdown$blockParsers$__f_all, $n($thiz.Llaika_internal_parse_markup_RootParser__f_markupExtensions).Llaika_api_bundle_MarkupExtensions__f_blockParsers);
    $thiz.Llaika_internal_parse_markup_RootParser__f_sortedBlockParsersbitmap$1 = true;
  }
  return $thiz.Llaika_internal_parse_markup_RootParser__f_sortedBlockParsers$lzy1;
}
function $p_Llaika_internal_parse_markup_RootParser__rootInterruptions__Llaika_parse_Parser($thiz) {
  if ((!$thiz.Llaika_internal_parse_markup_RootParser__f_rootInterruptionsbitmap$1)) {
    $thiz.Llaika_internal_parse_markup_RootParser__f_rootInterruptions$lzy1 = $p_Llaika_internal_parse_markup_RootParser__mergeInterruptions__sci_Seq__Llaika_parse_Parser($thiz, $as_sci_Seq($n($p_Llaika_internal_parse_markup_RootParser__sortedBlockParsers__sci_Seq($thiz)).filter__F1__O(new $c_sjsr_AnonFunction1(((_$6) => {
      var _$6$1 = $as_Llaika_api_bundle_BlockParserDefinition(_$6);
      var x = $n(_$6$1).Llaika_api_bundle_BlockParserDefinition__f_position;
      var x$2 = $m_Llaika_api_bundle_BlockPosition$NestedOnly$();
      if ((x !== null)) {
        var this$1 = $n(x);
        var $x_1 = (this$1 === x$2);
      } else {
        var $x_1 = false;
      }
      return (!$x_1);
    })))));
    $thiz.Llaika_internal_parse_markup_RootParser__f_rootInterruptionsbitmap$1 = true;
  }
  return $thiz.Llaika_internal_parse_markup_RootParser__f_rootInterruptions$lzy1;
}
function $p_Llaika_internal_parse_markup_RootParser__nestedInterruptions__Llaika_parse_Parser($thiz) {
  if ((!$thiz.Llaika_internal_parse_markup_RootParser__f_nestedInterruptionsbitmap$1)) {
    $thiz.Llaika_internal_parse_markup_RootParser__f_nestedInterruptions$lzy1 = $p_Llaika_internal_parse_markup_RootParser__mergeInterruptions__sci_Seq__Llaika_parse_Parser($thiz, $as_sci_Seq($n($p_Llaika_internal_parse_markup_RootParser__sortedBlockParsers__sci_Seq($thiz)).filter__F1__O(new $c_sjsr_AnonFunction1(((_$7) => {
      var _$7$1 = $as_Llaika_api_bundle_BlockParserDefinition(_$7);
      var x = $n(_$7$1).Llaika_api_bundle_BlockParserDefinition__f_position;
      var x$2 = $m_Llaika_api_bundle_BlockPosition$RootOnly$();
      if ((x !== null)) {
        var this$1 = $n(x);
        var $x_1 = (this$1 === x$2);
      } else {
        var $x_1 = false;
      }
      return (!$x_1);
    })))));
    $thiz.Llaika_internal_parse_markup_RootParser__f_nestedInterruptionsbitmap$1 = true;
  }
  return $thiz.Llaika_internal_parse_markup_RootParser__f_nestedInterruptions$lzy1;
}
function $p_Llaika_internal_parse_markup_RootParser__allInterruptions__Llaika_parse_Parser($thiz) {
  if ((!$thiz.Llaika_internal_parse_markup_RootParser__f_allInterruptionsbitmap$1)) {
    $thiz.Llaika_internal_parse_markup_RootParser__f_allInterruptions$lzy1 = $p_Llaika_internal_parse_markup_RootParser__mergeInterruptions__sci_Seq__Llaika_parse_Parser($thiz, $p_Llaika_internal_parse_markup_RootParser__sortedBlockParsers__sci_Seq($thiz));
    $thiz.Llaika_internal_parse_markup_RootParser__f_allInterruptionsbitmap$1 = true;
  }
  return $thiz.Llaika_internal_parse_markup_RootParser__f_allInterruptions$lzy1;
}
function $p_Llaika_internal_parse_markup_RootParser__createAndSortParsers__sci_Seq__sci_Seq__sci_Seq($thiz, mainParsers, extParsers) {
  matchResult2: {
    var \u03b41$___1;
    var \u03b41$___2;
    var x2 = $p_Llaika_internal_parse_markup_RootParser__createParsers$1__sci_Seq__T2($thiz, mainParsers);
    if ((x2 !== null)) {
      var mainHigh = $as_sci_Seq($n(x2)._1__O());
      var mainLow = $as_sci_Seq($n(x2)._2__O());
      var \u03b41$___1 = mainHigh;
      var \u03b41$___2 = mainLow;
      break matchResult2;
    }
    throw new $c_s_MatchError(x2);
  }
  var mainHigh$2 = $as_sci_Seq(\u03b41$___1);
  var mainLow$2 = $as_sci_Seq(\u03b41$___2);
  matchResult3: {
    var \u03b42$___1;
    var \u03b42$___2;
    var x5 = $p_Llaika_internal_parse_markup_RootParser__createParsers$1__sci_Seq__T2($thiz, extParsers);
    if ((x5 !== null)) {
      var extHigh = $as_sci_Seq($n(x5)._1__O());
      var extLow = $as_sci_Seq($n(x5)._2__O());
      var \u03b42$___1 = extHigh;
      var \u03b42$___2 = extLow;
      break matchResult3;
    }
    throw new $c_s_MatchError(x5);
  }
  var extHigh$2 = $as_sci_Seq(\u03b42$___1);
  var extLow$2 = $as_sci_Seq(\u03b42$___2);
  var this$3 = $n(extHigh$2);
  var this$4 = $n($as_sc_IterableOps(this$3.appendedAll__sc_IterableOnce__O(mainHigh$2)));
  var this$5 = $n($as_sc_IterableOps(this$4.concat__sc_IterableOnce__O(mainLow$2)));
  return $as_sci_Seq(this$5.concat__sc_IterableOnce__O(extLow$2));
}
function $p_Llaika_internal_parse_markup_RootParser__mergeInterruptions__sci_Seq__Llaika_parse_Parser($thiz, parserDefinitions) {
  var interruptions = $as_sci_Seq($n(parserDefinitions).flatMap__F1__O(new $c_sjsr_AnonFunction1(((parserDef) => {
    var parserDef$1 = $as_Llaika_api_bundle_BlockParserDefinition(parserDef);
    var this$1 = $n($n(parserDef$1).Llaika_api_bundle_BlockParserDefinition__f_paragraphLineCheck);
    if (this$1.isEmpty__Z()) {
      return $m_s_None$();
    } else {
      var arg1 = this$1.get__O();
      var lineCheck = $as_Llaika_parse_text_PrefixedParser(arg1);
      var value = $n(lineCheck).startChars__O();
      var this$3 = new $c_Lcats_data_NonEmptySetOps(value);
      var s = this$3.Lcats_data_NonEmptySetOps__f_value;
      var this$5 = $n($as_sci_SortedSet(s));
      var _1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$5);
      var this$7 = $m_Llaika_parse_builders$();
      var p = $as_Llaika_parse_Parser(lineCheck);
      var _2 = $n($f_Llaika_parse_combinator_Parsers__lookAhead__Llaika_parse_Parser__Llaika_parse_Parser(this$7, p)).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($n(parserDef$1).Llaika_api_bundle_BlockParserDefinition__f_parser);
      return new $c_s_Some(new $c_T2(_1, _2));
    }
  }))));
  return $p_Llaika_internal_parse_markup_RootParser__mergePrefixed__sci_Seq__T__Llaika_parse_Parser($thiz, $as_sci_Seq($n(interruptions).flatMap__F1__O(new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var chars = $as_sci_List($n(x$1$1)._1__O());
      var parser = $as_Llaika_parse_Parser($n(x$1$1)._2__O());
      var this$10 = $n(chars);
      var f = ((_$11) => {
        var _$11$1 = $uC(_$11);
        return new $c_T2($bC(_$11$1), parser);
      });
      if ((this$10 === $m_sci_Nil$())) {
        return $m_sci_Nil$();
      } else {
        var arg1$1 = this$10.head__O();
        var h = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
        var t = h;
        var rest = $as_sci_List(this$10.tail__O());
        while ((rest !== $m_sci_Nil$())) {
          var arg1$2 = $n(rest).head__O();
          var nx = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
          $n(t).sci_$colon$colon__f_next = nx;
          t = nx;
          rest = $as_sci_List($n(rest).tail__O());
        }
        return h;
      }
    }
    throw new $c_s_MatchError(x$1$1);
  })))), "No interruptions available");
}
function $p_Llaika_internal_parse_markup_RootParser__mergePrefixed__sci_Seq__T__Llaika_parse_Parser($thiz, definitions, msg) {
  var this$1 = $n(definitions);
  var m = $as_scm_Map($m_scm_Map$().empty__O());
  var it = this$1.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    var _$12 = $as_T2(elem);
    var key = $uC($n(_$12)._1__O());
    var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O($bC(key), new $c_sjsr_AnonFunction0(((this$1) => (() => this$1.newSpecificBuilder__scm_Builder()))(this$1))));
    var this$2 = $n(bldr);
    this$2.addOne__O__scm_Growable(elem);
  }
  var this$3 = $m_sci_HashMap$();
  var result = this$3.sci_HashMap$__f_EmptyMap;
  var mapIt = $n(m).iterator__sc_Iterator();
  while ($n(mapIt).hasNext__Z()) {
    var x1 = $as_T2($n(mapIt).next__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = $n(x1)._1__O();
    var v = $as_scm_Builder($n(x1)._2__O());
    result = $n(result).updated__O__O__sci_HashMap(k, $n(v).result__O());
  }
  var this$4 = $n(result);
  $m_sci_HashMap$();
  var b = new $c_sci_HashMapBuilder();
  var it$1 = this$4.iterator__sc_Iterator();
  while ($n(it$1).hasNext__Z()) {
    var arg1 = $n(it$1).next__O();
    var x$1 = $as_T2(arg1);
    matchResult5: {
      var elem$1___1;
      var elem$1___2;
      if ((x$1 !== null)) {
        var char = $uC($n(x$1)._1__O());
        var tuples = $as_sci_Seq($n(x$1)._2__O());
        var _2 = $n($as_sc_IterableOnceOps($n(tuples).map__F1__O(new $c_sjsr_AnonFunction1(((_$13) => {
          var _$13$1 = $as_T2(_$13);
          return $as_Llaika_parse_Parser($n(_$13$1)._2__O());
        }))))).reduceLeft__F2__O(new $c_sjsr_AnonFunction2(((_$14, _$15) => {
          var _$14$1 = $as_Llaika_parse_Parser(_$14);
          var _$15$1 = $as_Llaika_parse_Parser(_$15);
          var this$6 = $n(_$14$1);
          var p = new $c_sjsr_AnonFunction0((() => _$15$1));
          return this$6.orElse__F0__Llaika_parse_Parser(p);
        })));
        var elem$1___1 = $bC(char);
        var elem$1___2 = _2;
        break matchResult5;
      }
      throw new $c_s_MatchError(x$1);
    }
    $p_sci_HashMapBuilder__ensureUnaliased__V(b);
    var x = elem$1___1;
    var h = $m_sr_Statics$().anyHash__O__I(x);
    var im = $m_sc_Hashing$().improve__I__I(h);
    b.update__sci_MapNode__O__O__I__I__I__V(b.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, elem$1___1, elem$1___2, h, im, 0);
  }
  var groupedPrefixed = b.result__sci_HashMap();
  var $x_1 = $m_Lcats_data_package$().Lcats_data_package$__f_NonEmptySet;
  var evidence$1 = $m_s_math_Ordering$Char$();
  var this$9 = $ct_sci_TreeSet__s_math_Ordering__(new $c_sci_TreeSet(), evidence$1);
  var that = $n(groupedPrefixed).keySet__sci_Set();
  var this$10 = $n($n($x_1).fromSet__sci_SortedSet__s_Option(this$9.concat__sc_IterableOnce__sci_TreeSet(that)));
  if (this$10.isEmpty__Z()) {
    var this$11 = $m_Llaika_parse_builders$();
    return $f_Llaika_parse_combinator_Parsers__failure__T__Llaika_parse_Parser(this$11, msg);
  } else {
    var arg1$1 = this$10.get__O();
    var this$13 = $m_Llaika_parse_builders$();
    var this$12 = $m_Llaika_parse_builders$();
    var p$1 = $as_Llaika_parse_Parser($f_Llaika_parse_text_TextParsers__oneOf__O__Llaika_parse_text_PrefixedParser(this$12, arg1$1));
    var startChars = $n($f_Llaika_parse_combinator_Parsers__lookAhead__Llaika_parse_Parser__Llaika_parse_Parser(this$13, p$1)).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$16) => {
      var _$16$1 = $as_T(_$16);
      var this$14 = $n(_$16$1);
      return $bC($charAt(this$14, 0));
    })));
    return $n(startChars).$greater$greater__F1__Llaika_parse_Parser(groupedPrefixed);
  }
}
function $p_Llaika_internal_parse_markup_RootParser__merge__sci_Seq__Llaika_parse_Parser($thiz, parserDefinitions) {
  matchResult6: {
    var \u03b43$___1;
    var \u03b43$___2;
    var x14 = $n(parserDefinitions).partition__F1__T2(new $c_sjsr_AnonFunction1(((_$17) => {
      var _$17$1 = $as_Llaika_api_bundle_BlockParserDefinition(_$17);
      var this$1 = $n($n(_$17$1).Llaika_api_bundle_BlockParserDefinition__f_startChars);
      return (!this$1.isEmpty__Z());
    })));
    if ((x14 !== null)) {
      var prefixed = $as_sci_Seq($n(x14)._1__O());
      var unprefixed = $as_sci_Seq($n(x14)._2__O());
      var \u03b43$___1 = prefixed;
      var \u03b43$___2 = unprefixed;
      break matchResult6;
    }
    throw new $c_s_MatchError(x14);
  }
  var prefixed$2 = $as_sci_Seq(\u03b43$___1);
  var unprefixed$2 = $as_sci_Seq(\u03b43$___2);
  var prefixedBlock = $p_Llaika_internal_parse_markup_RootParser__mergePrefixed__sci_Seq__T__Llaika_parse_Parser($thiz, $as_sci_Seq($n(prefixed$2).flatMap__F1__O(new $c_sjsr_AnonFunction1(((parserDef) => {
    var parserDef$1 = $as_Llaika_api_bundle_BlockParserDefinition(parserDef);
    var this$3 = $n($n(parserDef$1).Llaika_api_bundle_BlockParserDefinition__f_startChars);
    var this$6 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$3));
    var f = ((_$18) => {
      var _$18$1 = $uC(_$18);
      var _2 = $n(parserDef$1).Llaika_api_bundle_BlockParserDefinition__f_parser;
      return new $c_T2($bC(_$18$1), _2);
    });
    if ((this$6 === $m_sci_Nil$())) {
      return $m_sci_Nil$();
    } else {
      var arg1 = this$6.head__O();
      var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(this$6.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var arg1$1 = $n(rest).head__O();
        var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O());
      }
      return h;
    }
  })))), "No decorated block parser available");
  var this$8 = $n($as_sc_IterableOnceOps($n(unprefixed$2).map__F1__O(new $c_sjsr_AnonFunction1(((_$19) => {
    var _$19$1 = $as_Llaika_api_bundle_BlockParserDefinition(_$19);
    return $n(_$19$1).Llaika_api_bundle_BlockParserDefinition__f_parser;
  })))));
  var op = new $c_sjsr_AnonFunction2(((_$20, _$21) => {
    var _$20$1 = $as_Llaika_parse_Parser(_$20);
    var _$21$1 = $as_Llaika_parse_Parser(_$21);
    var this$7 = $n(_$20$1);
    var p = new $c_sjsr_AnonFunction0((() => _$21$1));
    return this$7.orElse__F0__Llaika_parse_Parser(p);
  }));
  var this$9 = $n($f_sc_IterableOnceOps__reduceLeftOption__F2__s_Option(this$8, op));
  if (this$9.isEmpty__Z()) {
    var this$10 = $m_Llaika_parse_builders$();
    var $x_1 = $f_Llaika_parse_combinator_Parsers__failure__T__Llaika_parse_Parser(this$10, "No undecorated block parser available");
  } else {
    var $x_1 = this$9.get__O();
  }
  var unprefixedBlock = $as_Llaika_parse_Parser($x_1);
  var this$11 = $n(prefixedBlock);
  var p$1 = new $c_sjsr_AnonFunction0((() => unprefixedBlock));
  return this$11.orElse__F0__Llaika_parse_Parser(p$1);
}
function $p_Llaika_internal_parse_markup_RootParser__createParsers$1__sci_Seq__T2($thiz, builders) {
  return $n($as_sc_IterableOps($n(builders).map__F1__O(new $c_sjsr_AnonFunction1(((_$9) => {
    var _$9$1 = $as_Llaika_api_bundle_ParserBuilder(_$9);
    return $n(_$9$1).createParser__Llaika_parse_markup_RecursiveParsers__Llaika_api_bundle_ParserDefinition($thiz);
  }))))).partition__F1__T2(new $c_sjsr_AnonFunction1(((_$10) => {
    var _$10$1 = $as_Llaika_api_bundle_ParserDefinition(_$10);
    var x = $n(_$10$1).precedence__Llaika_api_bundle_Precedence();
    var x$2 = $m_Llaika_api_bundle_Precedence$High$();
    if ((x !== null)) {
      var this$2 = $n(x);
      return (this$2 === x$2);
    } else {
      return false;
    }
  })));
}
/** @constructor */
function $c_Llaika_internal_parse_markup_RootParser(markupParser, markupExtensions) {
  this.Llaika_internal_parse_markup_RootParser__f_escapeSequence$lzy1 = null;
  this.Llaika_internal_parse_markup_RootParser__f_escapeSequencebitmap$1 = false;
  this.Llaika_internal_parse_markup_RootParser__f_defaultSpanParser$lzy1 = null;
  this.Llaika_internal_parse_markup_RootParser__f_defaultSpanParserbitmap$1 = false;
  this.Llaika_internal_parse_markup_RootParser__f_laika$internal$parse$markup$DefaultRecursiveParsers$$maxNestLevel = 0;
  this.Llaika_internal_parse_markup_RootParser__f_laika$internal$parse$markup$DefaultRecursiveParsers$$recursiveBlockParser = null;
  this.Llaika_internal_parse_markup_RootParser__f_markupParser = null;
  this.Llaika_internal_parse_markup_RootParser__f_markupExtensions = null;
  this.Llaika_internal_parse_markup_RootParser__f_highlighterMap$lzy1 = null;
  this.Llaika_internal_parse_markup_RootParser__f_highlighterMapbitmap$1 = false;
  this.Llaika_internal_parse_markup_RootParser__f_escapedChar$lzy1 = null;
  this.Llaika_internal_parse_markup_RootParser__f_escapedCharbitmap$1 = false;
  this.Llaika_internal_parse_markup_RootParser__f_rootElement$lzy1 = null;
  this.Llaika_internal_parse_markup_RootParser__f_rootElementbitmap$1 = false;
  this.Llaika_internal_parse_markup_RootParser__f_sortedBlockParsers$lzy1 = null;
  this.Llaika_internal_parse_markup_RootParser__f_sortedBlockParsersbitmap$1 = false;
  this.Llaika_internal_parse_markup_RootParser__f_rootBlock$lzy1 = null;
  this.Llaika_internal_parse_markup_RootParser__f_rootBlockbitmap$1 = false;
  this.Llaika_internal_parse_markup_RootParser__f_nestedBlock$lzy1 = null;
  this.Llaika_internal_parse_markup_RootParser__f_nestedBlockbitmap$1 = false;
  this.Llaika_internal_parse_markup_RootParser__f_fallbackBlock$lzy1 = null;
  this.Llaika_internal_parse_markup_RootParser__f_fallbackBlockbitmap$1 = false;
  this.Llaika_internal_parse_markup_RootParser__f_rootInterruptions$lzy1 = null;
  this.Llaika_internal_parse_markup_RootParser__f_rootInterruptionsbitmap$1 = false;
  this.Llaika_internal_parse_markup_RootParser__f_nestedInterruptions$lzy1 = null;
  this.Llaika_internal_parse_markup_RootParser__f_nestedInterruptionsbitmap$1 = false;
  this.Llaika_internal_parse_markup_RootParser__f_allInterruptions$lzy1 = null;
  this.Llaika_internal_parse_markup_RootParser__f_allInterruptionsbitmap$1 = false;
  this.Llaika_internal_parse_markup_RootParser__f_spanParsers$lzy1 = null;
  this.Llaika_internal_parse_markup_RootParser__f_spanParsersbitmap$1 = false;
  this.Llaika_internal_parse_markup_RootParser__f_markupParser = markupParser;
  this.Llaika_internal_parse_markup_RootParser__f_markupExtensions = markupExtensions;
  $f_Llaika_internal_parse_markup_DefaultRecursiveParsers__$init$__V(this);
}
$c_Llaika_internal_parse_markup_RootParser.prototype = new $h_O();
$c_Llaika_internal_parse_markup_RootParser.prototype.constructor = $c_Llaika_internal_parse_markup_RootParser;
/** @constructor */
function $h_Llaika_internal_parse_markup_RootParser() {
}
$h_Llaika_internal_parse_markup_RootParser.prototype = $c_Llaika_internal_parse_markup_RootParser.prototype;
$c_Llaika_internal_parse_markup_RootParser.prototype.escapeSequence__Llaika_parse_text_PrefixedParser = (function() {
  if ((!this.Llaika_internal_parse_markup_RootParser__f_escapeSequencebitmap$1)) {
    this.Llaika_internal_parse_markup_RootParser__f_escapeSequence$lzy1 = $f_Llaika_internal_parse_markup_DefaultEscapedTextParsers__escapeSequence__Llaika_parse_text_PrefixedParser(this);
    this.Llaika_internal_parse_markup_RootParser__f_escapeSequencebitmap$1 = true;
  }
  return this.Llaika_internal_parse_markup_RootParser__f_escapeSequence$lzy1;
});
$c_Llaika_internal_parse_markup_RootParser.prototype.defaultSpanParser__Llaika_parse_markup_InlineParser = (function() {
  if ((!this.Llaika_internal_parse_markup_RootParser__f_defaultSpanParserbitmap$1)) {
    this.Llaika_internal_parse_markup_RootParser__f_defaultSpanParser$lzy1 = $f_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers__defaultSpanParser__Llaika_parse_markup_InlineParser(this);
    this.Llaika_internal_parse_markup_RootParser__f_defaultSpanParserbitmap$1 = true;
  }
  return this.Llaika_internal_parse_markup_RootParser__f_defaultSpanParser$lzy1;
});
$c_Llaika_internal_parse_markup_RootParser.prototype.getSyntaxHighlighter__T__s_Option = (function(language) {
  var $x_1 = $p_Llaika_internal_parse_markup_RootParser__highlighterMap__sci_Map(this);
  var this$1 = $n(language);
  var this$2 = $n($n($x_1).get__O__s_Option($as_T(this$1.toLowerCase())));
  if (this$2.isEmpty__Z()) {
    return $m_s_None$();
  } else {
    var arg1 = this$2.get__O();
    var _$1 = $as_Llaika_parse_Parser(arg1);
    return new $c_s_Some(new $c_Llaika_internal_parse_markup_DefaultRecursiveSpanParsers$RecursiveSpanParserDelegate(this, _$1));
  }
});
$c_Llaika_internal_parse_markup_RootParser.prototype.escapedChar__Llaika_parse_Parser = (function() {
  if ((!this.Llaika_internal_parse_markup_RootParser__f_escapedCharbitmap$1)) {
    this.Llaika_internal_parse_markup_RootParser__f_escapedChar$lzy1 = $n(this.Llaika_internal_parse_markup_RootParser__f_markupParser).escapedChar__Llaika_parse_Parser();
    this.Llaika_internal_parse_markup_RootParser__f_escapedCharbitmap$1 = true;
  }
  return this.Llaika_internal_parse_markup_RootParser__f_escapedChar$lzy1;
});
$c_Llaika_internal_parse_markup_RootParser.prototype.rootElement__Llaika_parse_Parser = (function() {
  if ((!this.Llaika_internal_parse_markup_RootParser__f_rootElementbitmap$1)) {
    var this$1 = $m_Llaika_parse_builders$();
    var p = $m_Llaika_parse_builders$().Llaika_parse_builders$__f_blankLines;
    this.Llaika_internal_parse_markup_RootParser__f_rootElement$lzy1 = $n($f_Llaika_parse_combinator_Parsers__opt__Llaika_parse_Parser__Llaika_parse_Parser(this$1, p)).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser($n($n($n(this.Llaika_internal_parse_markup_RootParser__f_markupParser).createBlockListParser__Llaika_parse_Parser__Llaika_parse_Parser(this.rootBlock__Llaika_parse_Parser())).map__F1__Llaika_parse_Parser($n($n(this.Llaika_internal_parse_markup_RootParser__f_markupExtensions).Llaika_api_bundle_MarkupExtensions__f_parserHooks).Llaika_api_bundle_ParserHooks__f_postProcessBlocks)).map__F1__Llaika_parse_Parser(new $c_sjsr_AnonFunction1(((_$2) => {
      var _$2$1 = $as_sci_Seq(_$2);
      var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      return new $c_Llaika_ast_RootElement(_$2$1, options);
    }))));
    this.Llaika_internal_parse_markup_RootParser__f_rootElementbitmap$1 = true;
  }
  return this.Llaika_internal_parse_markup_RootParser__f_rootElement$lzy1;
});
$c_Llaika_internal_parse_markup_RootParser.prototype.rootBlock__Llaika_parse_Parser = (function() {
  if ((!this.Llaika_internal_parse_markup_RootParser__f_rootBlockbitmap$1)) {
    this.Llaika_internal_parse_markup_RootParser__f_rootBlock$lzy1 = $p_Llaika_internal_parse_markup_RootParser__merge__sci_Seq__Llaika_parse_Parser(this, $as_sci_Seq($n($p_Llaika_internal_parse_markup_RootParser__sortedBlockParsers__sci_Seq(this)).filter__F1__O(new $c_sjsr_AnonFunction1(((_$3) => {
      var _$3$1 = $as_Llaika_api_bundle_BlockParserDefinition(_$3);
      var x = $n(_$3$1).Llaika_api_bundle_BlockParserDefinition__f_position;
      var x$2 = $m_Llaika_api_bundle_BlockPosition$NestedOnly$();
      if ((x !== null)) {
        var this$1 = $n(x);
        var $x_1 = (this$1 === x$2);
      } else {
        var $x_1 = false;
      }
      return (!$x_1);
    })))));
    this.Llaika_internal_parse_markup_RootParser__f_rootBlockbitmap$1 = true;
  }
  return this.Llaika_internal_parse_markup_RootParser__f_rootBlock$lzy1;
});
$c_Llaika_internal_parse_markup_RootParser.prototype.nestedBlock__Llaika_parse_Parser = (function() {
  if ((!this.Llaika_internal_parse_markup_RootParser__f_nestedBlockbitmap$1)) {
    this.Llaika_internal_parse_markup_RootParser__f_nestedBlock$lzy1 = $p_Llaika_internal_parse_markup_RootParser__merge__sci_Seq__Llaika_parse_Parser(this, $as_sci_Seq($n($p_Llaika_internal_parse_markup_RootParser__sortedBlockParsers__sci_Seq(this)).filter__F1__O(new $c_sjsr_AnonFunction1(((_$4) => {
      var _$4$1 = $as_Llaika_api_bundle_BlockParserDefinition(_$4);
      var x = $n(_$4$1).Llaika_api_bundle_BlockParserDefinition__f_position;
      var x$2 = $m_Llaika_api_bundle_BlockPosition$RootOnly$();
      if ((x !== null)) {
        var this$1 = $n(x);
        var $x_1 = (this$1 === x$2);
      } else {
        var $x_1 = false;
      }
      return (!$x_1);
    })))));
    this.Llaika_internal_parse_markup_RootParser__f_nestedBlockbitmap$1 = true;
  }
  return this.Llaika_internal_parse_markup_RootParser__f_nestedBlock$lzy1;
});
$c_Llaika_internal_parse_markup_RootParser.prototype.fallbackBlock__Llaika_parse_Parser = (function() {
  if ((!this.Llaika_internal_parse_markup_RootParser__f_fallbackBlockbitmap$1)) {
    this.Llaika_internal_parse_markup_RootParser__f_fallbackBlock$lzy1 = $p_Llaika_internal_parse_markup_RootParser__merge__sci_Seq__Llaika_parse_Parser(this, $as_sci_Seq($n($p_Llaika_internal_parse_markup_RootParser__sortedBlockParsers__sci_Seq(this)).filterNot__F1__O(new $c_sjsr_AnonFunction1(((_$5) => {
      var _$5$1 = $as_Llaika_api_bundle_BlockParserDefinition(_$5);
      return $n(_$5$1).Llaika_api_bundle_BlockParserDefinition__f_isRecursive;
    })))));
    this.Llaika_internal_parse_markup_RootParser__f_fallbackBlockbitmap$1 = true;
  }
  return this.Llaika_internal_parse_markup_RootParser__f_fallbackBlock$lzy1;
});
$c_Llaika_internal_parse_markup_RootParser.prototype.spanParsers__sci_Seq = (function() {
  if ((!this.Llaika_internal_parse_markup_RootParser__f_spanParsersbitmap$1)) {
    var $x_1 = $m_Llaika_api_bundle_SpanParserBuilder$();
    var this$3 = $n(this.escapeSequence__Llaika_parse_text_PrefixedParser());
    var f = new $c_sjsr_AnonFunction1(((_$8) => {
      var _$8$1 = $as_T(_$8);
      var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      return new $c_Llaika_ast_Text(_$8$1, options);
    }));
    var escapedText = $n($n($x_1).standalone__Llaika_parse_text_PrefixedParser__Llaika_api_bundle_SpanParserBuilder($f_Llaika_parse_text_PrefixedParser__map__F1__Llaika_parse_text_PrefixedParser(this$3, f))).withLowPrecedence__Llaika_api_bundle_SpanParserBuilder();
    var this$5 = $n(($n(this.Llaika_internal_parse_markup_RootParser__f_markupParser), $m_Llaika_format_Markdown$spanParsers$()).Llaika_format_Markdown$spanParsers$__f_all);
    var mainParsers = $as_sci_Seq(this$5.appended__O__O(escapedText));
    this.Llaika_internal_parse_markup_RootParser__f_spanParsers$lzy1 = $as_sci_Seq($n($p_Llaika_internal_parse_markup_RootParser__createAndSortParsers__sci_Seq__sci_Seq__sci_Seq(this, mainParsers, $n(this.Llaika_internal_parse_markup_RootParser__f_markupExtensions).Llaika_api_bundle_MarkupExtensions__f_spanParsers)).map__F1__O(new $c_sjsr_AnonFunction1(((parserDef) => {
      var parserDef$1 = $as_Llaika_api_bundle_SpanParserDefinition(parserDef);
      var this$6 = $m_Llaika_parse_text_PrefixedParser$();
      var sc = $n(parserDef$1).Llaika_api_bundle_SpanParserDefinition__f_startChars;
      var p = $n(parserDef$1).Llaika_api_bundle_SpanParserDefinition__f_parser;
      return new $c_Llaika_parse_text_PrefixedParser$$anon$1(sc, p, this$6);
    }))));
    this.Llaika_internal_parse_markup_RootParser__f_spanParsersbitmap$1 = true;
  }
  return this.Llaika_internal_parse_markup_RootParser__f_spanParsers$lzy1;
});
$c_Llaika_internal_parse_markup_RootParser.prototype.paragraphInterruptions__Llaika_api_bundle_BlockPosition__Llaika_parse_Parser = (function(position) {
  var x = $m_Llaika_api_bundle_BlockPosition$Any$();
  if ((x === position)) {
    var this$2 = $m_Llaika_parse_builders$();
    var p = new $c_sjsr_AnonFunction0((() => $p_Llaika_internal_parse_markup_RootParser__allInterruptions__Llaika_parse_Parser(this)));
    return $f_Llaika_parse_combinator_Parsers__lazily__F0__Llaika_parse_Parser(this$2, p);
  }
  var x$3 = $m_Llaika_api_bundle_BlockPosition$RootOnly$();
  if ((x$3 === position)) {
    var this$3 = $m_Llaika_parse_builders$();
    var p$1 = new $c_sjsr_AnonFunction0((() => $p_Llaika_internal_parse_markup_RootParser__rootInterruptions__Llaika_parse_Parser(this)));
    return $f_Llaika_parse_combinator_Parsers__lazily__F0__Llaika_parse_Parser(this$3, p$1);
  }
  var x$5 = $m_Llaika_api_bundle_BlockPosition$NestedOnly$();
  if ((x$5 === position)) {
    var this$4 = $m_Llaika_parse_builders$();
    var p$2 = new $c_sjsr_AnonFunction0((() => $p_Llaika_internal_parse_markup_RootParser__nestedInterruptions__Llaika_parse_Parser(this)));
    return $f_Llaika_parse_combinator_Parsers__lazily__F0__Llaika_parse_Parser(this$4, p$2);
  }
  throw new $c_s_MatchError(position);
});
var $d_Llaika_internal_parse_markup_RootParser = new $TypeData().initClass($c_Llaika_internal_parse_markup_RootParser, "laika.internal.parse.markup.RootParser", ({
  Llaika_internal_parse_markup_RootParser: 1,
  Llaika_parse_markup_EscapedTextParsers: 1,
  Llaika_parse_markup_RecursiveSpanParsers: 1,
  Llaika_parse_markup_RecursiveParsers: 1,
  Llaika_internal_parse_markup_DefaultEscapedTextParsers: 1,
  Llaika_internal_parse_markup_DefaultRecursiveSpanParsers: 1,
  Llaika_internal_parse_markup_DefaultRecursiveParsers: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcB$sp(xs$mcB$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcB$sp__f_xs$mcB$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcB$sp__f_xs$mcB$sp = xs$mcB$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcB$sp);
}
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcB$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcB$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcB$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype.next$mcB$sp__B = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= $n(this.sc_ArrayOps$ArrayIterator$mcB$sp__f_xs$mcB$sp).u.length)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var r = $n(this.sc_ArrayOps$ArrayIterator$mcB$sp__f_xs$mcB$sp).get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r;
});
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype.next__O = (function() {
  return this.next$mcB$sp__B();
});
var $d_sc_ArrayOps$ArrayIterator$mcB$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcB$sp, "scala.collection.ArrayOps$ArrayIterator$mcB$sp", ({
  sc_ArrayOps$ArrayIterator$mcB$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcC$sp(xs$mcC$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcC$sp__f_xs$mcC$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcC$sp__f_xs$mcC$sp = xs$mcC$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcC$sp);
}
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcC$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcC$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcC$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype.next$mcC$sp__C = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= $n(this.sc_ArrayOps$ArrayIterator$mcC$sp__f_xs$mcC$sp).u.length)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var r = $n(this.sc_ArrayOps$ArrayIterator$mcC$sp__f_xs$mcC$sp).get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r;
});
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype.next__O = (function() {
  return $bC(this.next$mcC$sp__C());
});
var $d_sc_ArrayOps$ArrayIterator$mcC$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcC$sp, "scala.collection.ArrayOps$ArrayIterator$mcC$sp", ({
  sc_ArrayOps$ArrayIterator$mcC$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcD$sp(xs$mcD$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcD$sp__f_xs$mcD$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcD$sp__f_xs$mcD$sp = xs$mcD$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcD$sp);
}
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcD$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcD$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcD$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype.next$mcD$sp__D = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= $n(this.sc_ArrayOps$ArrayIterator$mcD$sp__f_xs$mcD$sp).u.length)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var r = $n(this.sc_ArrayOps$ArrayIterator$mcD$sp__f_xs$mcD$sp).get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r;
});
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype.next__O = (function() {
  return this.next$mcD$sp__D();
});
var $d_sc_ArrayOps$ArrayIterator$mcD$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcD$sp, "scala.collection.ArrayOps$ArrayIterator$mcD$sp", ({
  sc_ArrayOps$ArrayIterator$mcD$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcF$sp(xs$mcF$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcF$sp__f_xs$mcF$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcF$sp__f_xs$mcF$sp = xs$mcF$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcF$sp);
}
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcF$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcF$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcF$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype.next$mcF$sp__F = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= $n(this.sc_ArrayOps$ArrayIterator$mcF$sp__f_xs$mcF$sp).u.length)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var r = $n(this.sc_ArrayOps$ArrayIterator$mcF$sp__f_xs$mcF$sp).get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r;
});
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype.next__O = (function() {
  return this.next$mcF$sp__F();
});
var $d_sc_ArrayOps$ArrayIterator$mcF$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcF$sp, "scala.collection.ArrayOps$ArrayIterator$mcF$sp", ({
  sc_ArrayOps$ArrayIterator$mcF$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcI$sp(xs$mcI$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcI$sp__f_xs$mcI$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcI$sp__f_xs$mcI$sp = xs$mcI$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcI$sp);
}
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcI$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcI$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcI$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype.next$mcI$sp__I = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= $n(this.sc_ArrayOps$ArrayIterator$mcI$sp__f_xs$mcI$sp).u.length)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var r = $n(this.sc_ArrayOps$ArrayIterator$mcI$sp__f_xs$mcI$sp).get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r;
});
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype.next__O = (function() {
  return this.next$mcI$sp__I();
});
var $d_sc_ArrayOps$ArrayIterator$mcI$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcI$sp, "scala.collection.ArrayOps$ArrayIterator$mcI$sp", ({
  sc_ArrayOps$ArrayIterator$mcI$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcJ$sp(xs$mcJ$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcJ$sp__f_xs$mcJ$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcJ$sp__f_xs$mcJ$sp = xs$mcJ$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcJ$sp);
}
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcJ$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcJ$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype.next$mcJ$sp__J = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= $n(this.sc_ArrayOps$ArrayIterator$mcJ$sp__f_xs$mcJ$sp).u.length)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var t = $n(this.sc_ArrayOps$ArrayIterator$mcJ$sp__f_xs$mcJ$sp).get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return new $c_RTLong(lo, hi);
});
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype.next__O = (function() {
  return this.next$mcJ$sp__J();
});
var $d_sc_ArrayOps$ArrayIterator$mcJ$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcJ$sp, "scala.collection.ArrayOps$ArrayIterator$mcJ$sp", ({
  sc_ArrayOps$ArrayIterator$mcJ$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcS$sp(xs$mcS$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcS$sp__f_xs$mcS$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcS$sp__f_xs$mcS$sp = xs$mcS$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcS$sp);
}
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcS$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcS$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcS$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype.next$mcS$sp__S = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= $n(this.sc_ArrayOps$ArrayIterator$mcS$sp__f_xs$mcS$sp).u.length)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var r = $n(this.sc_ArrayOps$ArrayIterator$mcS$sp__f_xs$mcS$sp).get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r;
});
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype.next__O = (function() {
  return this.next$mcS$sp__S();
});
var $d_sc_ArrayOps$ArrayIterator$mcS$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcS$sp, "scala.collection.ArrayOps$ArrayIterator$mcS$sp", ({
  sc_ArrayOps$ArrayIterator$mcS$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcV$sp(xs$mcV$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcV$sp__f_xs$mcV$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcV$sp__f_xs$mcV$sp = xs$mcV$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcV$sp);
}
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcV$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcV$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcV$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype.next$mcV$sp__V = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= $n(this.sc_ArrayOps$ArrayIterator$mcV$sp__f_xs$mcV$sp).u.length)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  $n(this.sc_ArrayOps$ArrayIterator$mcV$sp__f_xs$mcV$sp).get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
});
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype.next__O = (function() {
  this.next$mcV$sp__V();
});
var $d_sc_ArrayOps$ArrayIterator$mcV$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcV$sp, "scala.collection.ArrayOps$ArrayIterator$mcV$sp", ({
  sc_ArrayOps$ArrayIterator$mcV$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcZ$sp(xs$mcZ$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcZ$sp__f_xs$mcZ$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcZ$sp__f_xs$mcZ$sp = xs$mcZ$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcZ$sp);
}
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcZ$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcZ$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype.next$mcZ$sp__Z = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= $n(this.sc_ArrayOps$ArrayIterator$mcZ$sp__f_xs$mcZ$sp).u.length)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var r = $n(this.sc_ArrayOps$ArrayIterator$mcZ$sp__f_xs$mcZ$sp).get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r;
});
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype.next__O = (function() {
  return this.next$mcZ$sp__Z();
});
var $d_sc_ArrayOps$ArrayIterator$mcZ$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcZ$sp, "scala.collection.ArrayOps$ArrayIterator$mcZ$sp", ({
  sc_ArrayOps$ArrayIterator$mcZ$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_Iterable$$anon$1(a$1) {
  this.sc_Iterable$$anon$1__f_a$1 = null;
  this.sc_Iterable$$anon$1__f_a$1 = a$1;
}
$c_sc_Iterable$$anon$1.prototype = new $h_sc_AbstractIterable();
$c_sc_Iterable$$anon$1.prototype.constructor = $c_sc_Iterable$$anon$1;
/** @constructor */
function $h_sc_Iterable$$anon$1() {
}
$h_sc_Iterable$$anon$1.prototype = $c_sc_Iterable$$anon$1.prototype;
$c_sc_Iterable$$anon$1.prototype.iterator__sc_Iterator = (function() {
  var a = this.sc_Iterable$$anon$1__f_a$1;
  return new $c_sc_Iterator$$anon$20(a);
});
$c_sc_Iterable$$anon$1.prototype.knownSize__I = (function() {
  return 1;
});
$c_sc_Iterable$$anon$1.prototype.head__O = (function() {
  return this.sc_Iterable$$anon$1__f_a$1;
});
$c_sc_Iterable$$anon$1.prototype.headOption__s_Some = (function() {
  return new $c_s_Some(this.sc_Iterable$$anon$1__f_a$1);
});
$c_sc_Iterable$$anon$1.prototype.last__O = (function() {
  return this.sc_Iterable$$anon$1__f_a$1;
});
$c_sc_Iterable$$anon$1.prototype.take__I__sc_Iterable = (function(n) {
  return ((n > 0) ? this : $as_sc_Iterable($m_sc_Iterable$().empty__O()));
});
$c_sc_Iterable$$anon$1.prototype.drop__I__sc_Iterable = (function(n) {
  return ((n > 0) ? $as_sc_Iterable($m_sc_Iterable$().empty__O()) : this);
});
$c_sc_Iterable$$anon$1.prototype.dropRight__I__sc_Iterable = (function(n) {
  return ((n > 0) ? $as_sc_Iterable($m_sc_Iterable$().empty__O()) : this);
});
$c_sc_Iterable$$anon$1.prototype.tail__O = (function() {
  return $as_sc_Iterable($m_sc_Iterable$().empty__O());
});
$c_sc_Iterable$$anon$1.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_Iterable(n);
});
$c_sc_Iterable$$anon$1.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_Iterable(n);
});
$c_sc_Iterable$$anon$1.prototype.take__I__O = (function(n) {
  return this.take__I__sc_Iterable(n);
});
$c_sc_Iterable$$anon$1.prototype.headOption__s_Option = (function() {
  return this.headOption__s_Some();
});
var $d_sc_Iterable$$anon$1 = new $TypeData().initClass($c_sc_Iterable$$anon$1, "scala.collection.Iterable$$anon$1", ({
  sc_Iterable$$anon$1: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1
}));
function $f_sc_MapFactoryDefaults__empty__sc_IterableOps($thiz) {
  if (($thiz instanceof $c_sci_TreeSeqMap)) {
    var x2 = $as_sci_TreeSeqMap($thiz);
    return $m_sci_TreeSeqMap$().empty__sci_TreeSeqMap$OrderBy__sci_TreeSeqMap($n(x2).sci_TreeSeqMap__f_orderedBy);
  } else {
    return $as_sc_IterableOps($n($thiz.mapFactory__sc_MapFactory()).empty__O());
  }
}
function $f_sc_SortedSetOps__max__s_math_Ordering__O($thiz, ord) {
  if ($thiz.isEmpty__Z()) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.max");
  } else {
    var x$2 = $thiz.ordering__s_math_Ordering();
    if (((ord === null) ? (x$2 === null) : $n(ord).equals__O__Z(x$2))) {
      return $thiz.last__O();
    } else {
      return ($n(ord).isReverseOf__s_math_Ordering__Z($thiz.ordering__s_math_Ordering()) ? $thiz.head__O() : $f_sc_IterableOnceOps__max__s_math_Ordering__O($thiz, ord));
    }
  }
}
function $f_sc_View__toString__T($thiz) {
  return ($thiz.className__T() + "(<not computed>)");
}
function $is_sc_View(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_View)));
}
function $as_sc_View(obj) {
  return (($is_sc_View(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.View"));
}
function $isArrayOf_sc_View(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_View)));
}
function $asArrayOf_sc_View(obj, depth) {
  return (($isArrayOf_sc_View(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.View;", depth));
}
function $f_sci_MapOps__removedAll__sc_IterableOnce__sci_MapOps($thiz, keys) {
  var this$3 = $n($n(keys).iterator__sc_Iterator());
  var f = ((x$2$2, x$3$2) => {
    var x$2 = $as_sci_MapOps(x$2$2);
    var this$2 = $n(x$2);
    return this$2.removed__O__sci_MapOps(x$3$2);
  });
  if ($is_sc_IndexedSeq(this$3)) {
    var x2 = $as_sc_IndexedSeq(this$3);
    var at = 0;
    var end = $n(x2).length__I();
    var acc = $thiz;
    var $x_1;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var arg1 = acc;
        var arg2 = $n(x2).apply__I__O(at);
        var temp$acc = f(arg1, arg2);
        at = temp$at;
        acc = temp$acc;
        continue;
      }
      var $x_1 = acc;
      break;
    }
  } else {
    var result = $thiz;
    while (this$3.hasNext__Z()) {
      var arg1$1 = result;
      var arg2$1 = this$3.next__O();
      result = f(arg1$1, arg2$1);
    }
    var $x_1 = result;
  }
  return $as_sci_MapOps($x_1);
}
function $is_sci_MapOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_MapOps)));
}
function $as_sci_MapOps(obj) {
  return (($is_sci_MapOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.MapOps"));
}
function $isArrayOf_sci_MapOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_MapOps)));
}
function $asArrayOf_sci_MapOps(obj, depth) {
  return (($isArrayOf_sci_MapOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.MapOps;", depth));
}
/** @constructor */
function $c_sci_Set$Set2$$anon$1(outer) {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0;
  this.sci_Set$Set2$$anon$1__f_$outer = null;
  $n(outer);
  this.sci_Set$Set2$$anon$1__f_$outer = outer;
  $ct_sci_Set$SetNIterator__I__(this, ($n(outer), 2));
}
$c_sci_Set$Set2$$anon$1.prototype = new $h_sci_Set$SetNIterator();
$c_sci_Set$Set2$$anon$1.prototype.constructor = $c_sci_Set$Set2$$anon$1;
/** @constructor */
function $h_sci_Set$Set2$$anon$1() {
}
$h_sci_Set$Set2$$anon$1.prototype = $c_sci_Set$Set2$$anon$1.prototype;
$c_sci_Set$Set2$$anon$1.prototype.apply__I__O = (function(i) {
  return $n(this.sci_Set$Set2$$anon$1__f_$outer).scala$collection$immutable$Set$Set2$$getElem__I__O(i);
});
var $d_sci_Set$Set2$$anon$1 = new $TypeData().initClass($c_sci_Set$Set2$$anon$1, "scala.collection.immutable.Set$Set2$$anon$1", ({
  sci_Set$Set2$$anon$1: 1,
  sci_Set$SetNIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Set$Set3$$anon$2(outer) {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0;
  this.sci_Set$Set3$$anon$2__f_$outer = null;
  $n(outer);
  this.sci_Set$Set3$$anon$2__f_$outer = outer;
  $ct_sci_Set$SetNIterator__I__(this, ($n(outer), 3));
}
$c_sci_Set$Set3$$anon$2.prototype = new $h_sci_Set$SetNIterator();
$c_sci_Set$Set3$$anon$2.prototype.constructor = $c_sci_Set$Set3$$anon$2;
/** @constructor */
function $h_sci_Set$Set3$$anon$2() {
}
$h_sci_Set$Set3$$anon$2.prototype = $c_sci_Set$Set3$$anon$2.prototype;
$c_sci_Set$Set3$$anon$2.prototype.apply__I__O = (function(i) {
  return $n(this.sci_Set$Set3$$anon$2__f_$outer).scala$collection$immutable$Set$Set3$$getElem__I__O(i);
});
var $d_sci_Set$Set3$$anon$2 = new $TypeData().initClass($c_sci_Set$Set3$$anon$2, "scala.collection.immutable.Set$Set3$$anon$2", ({
  sci_Set$Set3$$anon$2: 1,
  sci_Set$SetNIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Set$Set4$$anon$3(outer) {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0;
  this.sci_Set$Set4$$anon$3__f_$outer = null;
  $n(outer);
  this.sci_Set$Set4$$anon$3__f_$outer = outer;
  $ct_sci_Set$SetNIterator__I__(this, ($n(outer), 4));
}
$c_sci_Set$Set4$$anon$3.prototype = new $h_sci_Set$SetNIterator();
$c_sci_Set$Set4$$anon$3.prototype.constructor = $c_sci_Set$Set4$$anon$3;
/** @constructor */
function $h_sci_Set$Set4$$anon$3() {
}
$h_sci_Set$Set4$$anon$3.prototype = $c_sci_Set$Set4$$anon$3.prototype;
$c_sci_Set$Set4$$anon$3.prototype.apply__I__O = (function(i) {
  return $n(this.sci_Set$Set4$$anon$3__f_$outer).scala$collection$immutable$Set$Set4$$getElem__I__O(i);
});
var $d_sci_Set$Set4$$anon$3 = new $TypeData().initClass($c_sci_Set$Set4$$anon$3, "scala.collection.immutable.Set$Set4$$anon$3", ({
  sci_Set$Set4$$anon$3: 1,
  sci_Set$SetNIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_TreeSet$TreeSetBuilder(ordering) {
  this.sci_RedBlackTree$Helper__f_ordering = null;
  this.sci_TreeSet$TreeSetBuilder__f_tree = null;
  $ct_sci_RedBlackTree$Helper__s_math_Ordering__(this, ordering);
  this.sci_TreeSet$TreeSetBuilder__f_tree = null;
}
$c_sci_TreeSet$TreeSetBuilder.prototype = new $h_sci_RedBlackTree$SetHelper();
$c_sci_TreeSet$TreeSetBuilder.prototype.constructor = $c_sci_TreeSet$TreeSetBuilder;
/** @constructor */
function $h_sci_TreeSet$TreeSetBuilder() {
}
$h_sci_TreeSet$TreeSetBuilder.prototype = $c_sci_TreeSet$TreeSetBuilder.prototype;
$c_sci_TreeSet$TreeSetBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_sci_TreeSet$TreeSetBuilder.prototype.addOne__O__sci_TreeSet$TreeSetBuilder = (function(elem) {
  this.sci_TreeSet$TreeSetBuilder__f_tree = this.mutableUpd__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree(this.sci_TreeSet$TreeSetBuilder__f_tree, elem);
  return this;
});
$c_sci_TreeSet$TreeSetBuilder.prototype.addAll__sc_IterableOnce__sci_TreeSet$TreeSetBuilder = (function(xs) {
  matchEnd5: {
    if ((xs instanceof $c_sci_TreeSet)) {
      var x2 = $as_sci_TreeSet(xs);
      var x = $n(x2).sci_TreeSet__f_ordering;
      var x$2 = this.sci_RedBlackTree$Helper__f_ordering;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        if ((this.sci_TreeSet$TreeSetBuilder__f_tree === null)) {
          this.sci_TreeSet$TreeSetBuilder__f_tree = $n(x2).sci_TreeSet__f_tree;
          break matchEnd5;
        } else {
          this.sci_TreeSet$TreeSetBuilder__f_tree = $m_sci_RedBlackTree$().union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet$TreeSetBuilder__f_tree), $n(x2).sci_TreeSet__f_tree, this.sci_RedBlackTree$Helper__f_ordering);
          break matchEnd5;
        }
      }
    }
    if (false) {
      var x3 = $as_sci_TreeMap(xs);
      var x$3 = $n(x3).ordering__s_math_Ordering();
      var x$4 = this.sci_RedBlackTree$Helper__f_ordering;
      if (((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4))) {
        if ((this.sci_TreeSet$TreeSetBuilder__f_tree === null)) {
          this.sci_TreeSet$TreeSetBuilder__f_tree = $n(x3).tree0__sci_RedBlackTree$Tree();
          break matchEnd5;
        } else {
          this.sci_TreeSet$TreeSetBuilder__f_tree = $m_sci_RedBlackTree$().union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet$TreeSetBuilder__f_tree), $n(x3).tree0__sci_RedBlackTree$Tree(), this.sci_RedBlackTree$Helper__f_ordering);
          break matchEnd5;
        }
      }
    }
    $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs);
  }
  return this;
});
$c_sci_TreeSet$TreeSetBuilder.prototype.result__sci_TreeSet = (function() {
  return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), this.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet$TreeSetBuilder__f_tree), this.sci_RedBlackTree$Helper__f_ordering);
});
$c_sci_TreeSet$TreeSetBuilder.prototype.result__O = (function() {
  return this.result__sci_TreeSet();
});
$c_sci_TreeSet$TreeSetBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__sci_TreeSet$TreeSetBuilder(elems);
});
$c_sci_TreeSet$TreeSetBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_TreeSet$TreeSetBuilder(elem);
});
var $d_sci_TreeSet$TreeSetBuilder = new $TypeData().initClass($c_sci_TreeSet$TreeSetBuilder, "scala.collection.immutable.TreeSet$TreeSetBuilder", ({
  sci_TreeSet$TreeSetBuilder: 1,
  sci_RedBlackTree$SetHelper: 1,
  sci_RedBlackTree$Helper: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
/** @constructor */
function $c_scm_ArrayBuilder$generic(elementClass) {
  this.scm_ArrayBuilder__f_capacity = 0;
  this.scm_ArrayBuilder$generic__f_elementClass = null;
  this.scm_ArrayBuilder$generic__f_isCharArrayBuilder = false;
  this.scm_ArrayBuilder$generic__f_jsElems = null;
  this.scm_ArrayBuilder$generic__f_elementClass = elementClass;
  $ct_scm_ArrayBuilder__(this);
  this.scm_ArrayBuilder$generic__f_isCharArrayBuilder = (elementClass === $d_C.getClassOf());
  this.scm_ArrayBuilder$generic__f_jsElems = [];
}
$c_scm_ArrayBuilder$generic.prototype = new $h_scm_ArrayBuilder();
$c_scm_ArrayBuilder$generic.prototype.constructor = $c_scm_ArrayBuilder$generic;
/** @constructor */
function $h_scm_ArrayBuilder$generic() {
}
$h_scm_ArrayBuilder$generic.prototype = $c_scm_ArrayBuilder$generic.prototype;
$c_scm_ArrayBuilder$generic.prototype.length__I = (function() {
  return $uI(this.scm_ArrayBuilder$generic__f_jsElems.length);
});
$c_scm_ArrayBuilder$generic.prototype.addOne__O__scm_ArrayBuilder$generic = (function(elem) {
  var unboxedElem = (this.scm_ArrayBuilder$generic__f_isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $n(this.scm_ArrayBuilder$generic__f_elementClass).jl_Class__f_data.zero : elem));
  this.scm_ArrayBuilder$generic__f_jsElems.push(unboxedElem);
  return this;
});
$c_scm_ArrayBuilder$generic.prototype.addAll__O__I__I__scm_ArrayBuilder$generic = (function(xs, offset, length) {
  var end = ((offset + length) | 0);
  var i = offset;
  while ((i < end)) {
    var elem = $m_sr_ScalaRunTime$().array_apply__O__I__O(xs, i);
    this.addOne__O__scm_ArrayBuilder$generic(elem);
    i = ((1 + i) | 0);
  }
  return this;
});
$c_scm_ArrayBuilder$generic.prototype.addAll__sc_IterableOnce__scm_ArrayBuilder$generic = (function(xs) {
  var it = $n(xs).iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    this.addOne__O__scm_ArrayBuilder$generic(elem);
  }
  return this;
});
$c_scm_ArrayBuilder$generic.prototype.result__O = (function() {
  var x$2 = this.scm_ArrayBuilder$generic__f_elementClass;
  if ((x$2 === $d_V.getClassOf())) {
    var elemRuntimeClass = $d_jl_Void.getClassOf();
  } else {
    var x$4 = this.scm_ArrayBuilder$generic__f_elementClass;
    if ((x$4 === $d_sr_Null$.getClassOf())) {
      var $x_1 = true;
    } else {
      var x$6 = this.scm_ArrayBuilder$generic__f_elementClass;
      var $x_1 = (x$6 === $d_sr_Nothing$.getClassOf());
    }
    if ($x_1) {
      var elemRuntimeClass = $d_O.getClassOf();
    } else {
      var elemRuntimeClass = this.scm_ArrayBuilder$generic__f_elementClass;
    }
  }
  return $n(elemRuntimeClass).jl_Class__f_data.getArrayOf().wrapArray(this.scm_ArrayBuilder$generic__f_jsElems);
});
$c_scm_ArrayBuilder$generic.prototype.toString__T = (function() {
  return "ArrayBuilder.generic";
});
$c_scm_ArrayBuilder$generic.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_ArrayBuilder$generic(elems);
});
$c_scm_ArrayBuilder$generic.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ArrayBuilder$generic(elem);
});
var $d_scm_ArrayBuilder$generic = new $TypeData().initClass($c_scm_ArrayBuilder$generic, "scala.collection.mutable.ArrayBuilder$generic", ({
  scm_ArrayBuilder$generic: 1,
  scm_ArrayBuilder: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  Ljava_io_Serializable: 1
}));
function $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O($thiz, srcStart, dest, destStart, maxItems) {
  var until = ((1 + $m_jl_reflect_Array$().getLength__O__I(dest)) | 0);
  if (((destStart < 0) || (destStart >= until))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((destStart + " is out of bounds (min 0, max ") + (((-1) + until) | 0)) + ")"));
  }
  var idx = $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var a = ((((($thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $n($thiz.scm_ArrayDeque__f_array).u.length) | 0)) - srcStart) | 0);
  var b = (($m_jl_reflect_Array$().getLength__O__I(dest) - destStart) | 0);
  var b$1 = ((a < b) ? a : b);
  var toCopy = ((maxItems < b$1) ? maxItems : b$1);
  if ((toCopy > 0)) {
    var idx$1 = $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
    var until$1 = ((($thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (((-1) + $n($thiz.scm_ArrayDeque__f_array).u.length) | 0));
    if (((srcStart < 0) || (srcStart >= until$1))) {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((srcStart + " is out of bounds (min 0, max ") + (((-1) + until$1) | 0)) + ")"));
    }
    var startIdx = ((($thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + srcStart) | 0) & (((-1) + $n($thiz.scm_ArrayDeque__f_array).u.length) | 0));
    var b$2 = (($n($thiz.scm_ArrayDeque__f_array).u.length - startIdx) | 0);
    var block1 = ((toCopy < b$2) ? toCopy : b$2);
    $m_s_Array$().copy__O__I__O__I__I__V($thiz.scm_ArrayDeque__f_array, startIdx, dest, destStart, block1);
    var block2 = ((toCopy - block1) | 0);
    if ((block2 > 0)) {
      $m_s_Array$().copy__O__I__O__I__I__V($thiz.scm_ArrayDeque__f_array, 0, dest, ((destStart + block1) | 0), block2);
    }
  }
  return dest;
}
function $f_scm_ArrayDequeOps__reverse__O($thiz) {
  var idx = $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var n = ((($thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $n($thiz.scm_ArrayDeque__f_array).u.length) | 0));
  var arr = $m_scm_ArrayDeque$().alloc__I__AO(n);
  var i = 0;
  while ((i < n)) {
    $n(arr).set(i, $thiz.apply__I__O((((-1) + ((n - i) | 0)) | 0)));
    i = ((1 + i) | 0);
  }
  return $thiz.ofArray__AO__I__O(arr, n);
}
/** @constructor */
function $c_scm_CheckedIndexedSeqView$CheckedIterator(self, mutationCount) {
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_self = null;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = 0;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = 0;
  this.scm_CheckedIndexedSeqView$CheckedIterator__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$CheckedIterator__f_expectedCount = 0;
  this.scm_CheckedIndexedSeqView$CheckedIterator__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(this, self);
  var this$1 = $n(mutationCount);
  this.scm_CheckedIndexedSeqView$CheckedIterator__f_expectedCount = $uI(this$1.apply__O());
}
$c_scm_CheckedIndexedSeqView$CheckedIterator.prototype = new $h_sc_IndexedSeqView$IndexedSeqViewIterator();
$c_scm_CheckedIndexedSeqView$CheckedIterator.prototype.constructor = $c_scm_CheckedIndexedSeqView$CheckedIterator;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$CheckedIterator() {
}
$h_scm_CheckedIndexedSeqView$CheckedIterator.prototype = $c_scm_CheckedIndexedSeqView$CheckedIterator.prototype;
$c_scm_CheckedIndexedSeqView$CheckedIterator.prototype.hasNext__Z = (function() {
  var this$2 = $m_scm_MutationTracker$();
  var expectedCount = this.scm_CheckedIndexedSeqView$CheckedIterator__f_expectedCount;
  var this$1 = $n(this.scm_CheckedIndexedSeqView$CheckedIterator__f_mutationCount);
  var actualCount = $uI(this$1.apply__O());
  this$2.checkMutations__I__I__T__V(expectedCount, actualCount, "mutation occurred during iteration");
  return (this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder > 0);
});
var $d_scm_CheckedIndexedSeqView$CheckedIterator = new $TypeData().initClass($c_scm_CheckedIndexedSeqView$CheckedIterator, "scala.collection.mutable.CheckedIndexedSeqView$CheckedIterator", ({
  scm_CheckedIndexedSeqView$CheckedIterator: 1,
  sc_IndexedSeqView$IndexedSeqViewIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(self, mutationCount) {
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_self = null;
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = 0;
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = 0;
  this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_expectedCount = 0;
  this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(this, self);
  var this$1 = $n(mutationCount);
  this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_expectedCount = $uI(this$1.apply__O());
}
$c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype = new $h_sc_IndexedSeqView$IndexedSeqViewReverseIterator();
$c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype.constructor = $c_scm_CheckedIndexedSeqView$CheckedReverseIterator;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$CheckedReverseIterator() {
}
$h_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype = $c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype;
$c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype.hasNext__Z = (function() {
  var this$2 = $m_scm_MutationTracker$();
  var expectedCount = this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_expectedCount;
  var this$1 = $n(this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_mutationCount);
  var actualCount = $uI(this$1.apply__O());
  this$2.checkMutations__I__I__T__V(expectedCount, actualCount, "mutation occurred during iteration");
  return (this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0);
});
var $d_scm_CheckedIndexedSeqView$CheckedReverseIterator = new $TypeData().initClass($c_scm_CheckedIndexedSeqView$CheckedReverseIterator, "scala.collection.mutable.CheckedIndexedSeqView$CheckedReverseIterator", ({
  scm_CheckedIndexedSeqView$CheckedReverseIterator: 1,
  sc_IndexedSeqView$IndexedSeqViewReverseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
class $c_s_concurrent_Future$$anon$1 extends $c_ju_NoSuchElementException {
  constructor(t$2) {
    super();
    var s = ("Future.collect partial function is not defined at: " + t$2);
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
  fillInStackTrace__jl_Throwable() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this);
  }
}
var $d_s_concurrent_Future$$anon$1 = new $TypeData().initClass($c_s_concurrent_Future$$anon$1, "scala.concurrent.Future$$anon$1", ({
  s_concurrent_Future$$anon$1: 1,
  ju_NoSuchElementException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_util_control_NoStackTrace: 1
}));
class $c_s_concurrent_Future$$anon$2 extends $c_ju_NoSuchElementException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, "Future.filter predicate is not satisfied", null, true, true);
  }
  fillInStackTrace__jl_Throwable() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this);
  }
}
var $d_s_concurrent_Future$$anon$2 = new $TypeData().initClass($c_s_concurrent_Future$$anon$2, "scala.concurrent.Future$$anon$2", ({
  s_concurrent_Future$$anon$2: 1,
  ju_NoSuchElementException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_util_control_NoStackTrace: 1
}));
class $c_s_concurrent_Future$$anon$3 extends $c_ju_NoSuchElementException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, "Future.failed not completed with a throwable.", null, true, true);
  }
  fillInStackTrace__jl_Throwable() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this);
  }
}
var $d_s_concurrent_Future$$anon$3 = new $TypeData().initClass($c_s_concurrent_Future$$anon$3, "scala.concurrent.Future$$anon$3", ({
  s_concurrent_Future$$anon$3: 1,
  ju_NoSuchElementException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_util_control_NoStackTrace: 1
}));
function $p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try($thiz) {
  var _$this = $thiz;
  while (true) {
    var state = $n(_$this).ju_concurrent_atomic_AtomicReference__f_value;
    if ((state instanceof $c_s_util_Try)) {
      return $as_s_util_Try(state);
    } else if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      _$this = $n($as_s_concurrent_impl_Promise$Link(state)).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
    } else {
      return null;
    }
  }
}
function $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks($thiz, state, callbacks) {
  var _$this = $thiz;
  while (true) {
    if ((state instanceof $c_s_util_Try)) {
      $p_s_concurrent_impl_Promise$DefaultPromise__submitWithValue__s_concurrent_impl_Promise$Callbacks__s_util_Try__V($n(_$this), callbacks, $as_s_util_Try(state));
      return callbacks;
    } else if ($is_s_concurrent_impl_Promise$Callbacks(state)) {
      if ($n(_$this).compareAndSet__O__O__Z(state, ((state !== $m_s_concurrent_impl_Promise$().s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop) ? $p_s_concurrent_impl_Promise$DefaultPromise__concatCallbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks($n(_$this), callbacks, $as_s_concurrent_impl_Promise$Callbacks(state)) : callbacks))) {
        return callbacks;
      } else {
        state = $n(_$this).ju_concurrent_atomic_AtomicReference__f_value;
      }
    } else {
      var p = $n($as_s_concurrent_impl_Promise$Link(state)).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
      var temp$state$2 = $n(p).ju_concurrent_atomic_AtomicReference__f_value;
      _$this = p;
      state = temp$state$2;
    }
  }
}
function $p_s_concurrent_impl_Promise$DefaultPromise__concatCallbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks($thiz, left, right) {
  while (true) {
    if ((left instanceof $c_s_concurrent_impl_Promise$Transformation)) {
      return new $c_s_concurrent_impl_Promise$ManyCallbacks($as_s_concurrent_impl_Promise$Transformation(left), right);
    } else {
      var m = $as_s_concurrent_impl_Promise$ManyCallbacks(left);
      var temp$left = $n(m).s_concurrent_impl_Promise$ManyCallbacks__f_rest;
      var temp$right = new $c_s_concurrent_impl_Promise$ManyCallbacks($n(m).s_concurrent_impl_Promise$ManyCallbacks__f_first, right);
      left = temp$left;
      right = temp$right;
    }
  }
}
function $p_s_concurrent_impl_Promise$DefaultPromise__submitWithValue__s_concurrent_impl_Promise$Callbacks__s_util_Try__V($thiz, callbacks, resolved) {
  while ((callbacks instanceof $c_s_concurrent_impl_Promise$ManyCallbacks)) {
    var m = $as_s_concurrent_impl_Promise$ManyCallbacks(callbacks);
    $n($n(m).s_concurrent_impl_Promise$ManyCallbacks__f_first).submitWithValue__s_util_Try__s_concurrent_impl_Promise$Transformation(resolved);
    callbacks = $n(m).s_concurrent_impl_Promise$ManyCallbacks__f_rest;
  }
  $n($as_s_concurrent_impl_Promise$Transformation(callbacks)).submitWithValue__s_util_Try__s_concurrent_impl_Promise$Transformation(resolved);
}
function $ct_s_concurrent_impl_Promise$DefaultPromise__O__($thiz, initial) {
  $ct_ju_concurrent_atomic_AtomicReference__O__($thiz, initial);
  return $thiz;
}
function $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__($thiz, result) {
  $ct_s_concurrent_impl_Promise$DefaultPromise__O__($thiz, $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try(result));
  return $thiz;
}
function $ct_s_concurrent_impl_Promise$DefaultPromise__($thiz) {
  $ct_s_concurrent_impl_Promise$DefaultPromise__O__($thiz, $m_s_concurrent_impl_Promise$().s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop);
  return $thiz;
}
/** @constructor */
function $c_s_concurrent_impl_Promise$DefaultPromise() {
  this.ju_concurrent_atomic_AtomicReference__f_value = null;
}
$c_s_concurrent_impl_Promise$DefaultPromise.prototype = new $h_ju_concurrent_atomic_AtomicReference();
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.constructor = $c_s_concurrent_impl_Promise$DefaultPromise;
/** @constructor */
function $h_s_concurrent_impl_Promise$DefaultPromise() {
}
$h_s_concurrent_impl_Promise$DefaultPromise.prototype = $c_s_concurrent_impl_Promise$DefaultPromise.prototype;
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  var resolved = $as_s_util_Try(v1);
  this.tryComplete0__O__s_util_Try__Z(this.ju_concurrent_atomic_AtomicReference__f_value, resolved);
  return $uZ((void 0));
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.onComplete__F1__s_concurrent_ExecutionContext__V = (function(func, executor) {
  $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, this.ju_concurrent_atomic_AtomicReference__f_value, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 6, func, executor));
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.toString__T = (function() {
  var _$this = this;
  while (true) {
    var state = $n(_$this).ju_concurrent_atomic_AtomicReference__f_value;
    if ((state instanceof $c_s_util_Try)) {
      return (("Future(" + state) + ")");
    } else if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      _$this = $n($as_s_concurrent_impl_Promise$Link(state)).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
    } else {
      return "Future(<not completed>)";
    }
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.tryComplete__s_util_Try__Z = (function(value) {
  var state = this.ju_concurrent_atomic_AtomicReference__f_value;
  return ((!(state instanceof $c_s_util_Try)) && this.tryComplete0__O__s_util_Try__Z(state, $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try(value)));
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.tryComplete0__O__s_util_Try__Z = (function(state, resolved) {
  var _$this = this;
  while (true) {
    if ($is_s_concurrent_impl_Promise$Callbacks(state)) {
      if ($n(_$this).compareAndSet__O__O__Z(state, resolved)) {
        if ((state !== $m_s_concurrent_impl_Promise$().s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop)) {
          $p_s_concurrent_impl_Promise$DefaultPromise__submitWithValue__s_concurrent_impl_Promise$Callbacks__s_util_Try__V($n(_$this), $as_s_concurrent_impl_Promise$Callbacks(state), resolved);
        }
        return true;
      } else {
        state = $n(_$this).ju_concurrent_atomic_AtomicReference__f_value;
      }
    } else if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      var p = $n($as_s_concurrent_impl_Promise$Link(state)).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
      if ((p !== _$this)) {
        var temp$state$2 = $n(p).ju_concurrent_atomic_AtomicReference__f_value;
        _$this = p;
        state = temp$state$2;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.completeWith__s_concurrent_Future__s_concurrent_impl_Promise$DefaultPromise = (function(other) {
  if ((other !== this)) {
    var state = this.ju_concurrent_atomic_AtomicReference__f_value;
    if ((!(state instanceof $c_s_util_Try))) {
      if ((other instanceof $c_s_concurrent_impl_Promise$DefaultPromise)) {
        var resolved = $p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try($n($as_s_concurrent_impl_Promise$DefaultPromise(other)));
      } else {
        var this$1 = $n(other);
        var this$3 = $n($m_s_Option$().apply__O__s_Option($p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try(this$1)));
        var this$2 = $m_s_$less$colon$less$();
        var ev = this$2.s_$less$colon$less$__f_singleton;
        var resolved = $as_s_util_Try((this$3.isEmpty__Z() ? ($n(ev), null) : this$3.get__O()));
      }
      if ((resolved !== null)) {
        this.tryComplete0__O__s_util_Try__Z(state, resolved);
      } else {
        $n(other).onComplete__F1__s_concurrent_ExecutionContext__V(this, $m_s_concurrent_ExecutionContext$parasitic$());
      }
    }
  }
  return this;
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.linkRootOf__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$Link__V = (function(target, link) {
  var _$this = this;
  while (true) {
    if ((_$this !== target)) {
      var state = $n(_$this).ju_concurrent_atomic_AtomicReference__f_value;
      if ((state instanceof $c_s_util_Try)) {
        if ((!$n(target).tryComplete0__O__s_util_Try__Z($n(target).ju_concurrent_atomic_AtomicReference__f_value, $as_s_util_Try(state)))) {
          throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Cannot link completed promises together");
        }
      } else if ($is_s_concurrent_impl_Promise$Callbacks(state)) {
        var l = ((link !== null) ? link : new $c_s_concurrent_impl_Promise$Link(target));
        var p = $n(l).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
        if (((_$this !== p) && $n(_$this).compareAndSet__O__O__Z(state, l))) {
          if ((state !== $m_s_concurrent_impl_Promise$().s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop)) {
            $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks($n(p), $n(p).ju_concurrent_atomic_AtomicReference__f_value, $as_s_concurrent_impl_Promise$Callbacks(state));
          }
        } else {
          target = p;
          link = l;
          continue;
        }
      } else {
        _$this = $n($as_s_concurrent_impl_Promise$Link(state)).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
        continue;
      }
    }
    break;
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.unlink__s_util_Try__V = (function(resolved) {
  var _$this = this;
  while (true) {
    var state = $n(_$this).ju_concurrent_atomic_AtomicReference__f_value;
    if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      var next = ($n(_$this).compareAndSet__O__O__Z(state, resolved) ? $as_s_concurrent_impl_Promise$DefaultPromise($n($as_s_concurrent_impl_Promise$Link(state)).ju_concurrent_atomic_AtomicReference__f_value) : _$this);
      _$this = next;
      continue;
    } else {
      $n(_$this).tryComplete0__O__s_util_Try__Z(state, resolved);
    }
    break;
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.apply__O__O = (function(v1) {
  var resolved = $as_s_util_Try(v1);
  this.tryComplete0__O__s_util_Try__Z(this.ju_concurrent_atomic_AtomicReference__f_value, resolved);
});
function $as_s_concurrent_impl_Promise$DefaultPromise(obj) {
  return (((obj instanceof $c_s_concurrent_impl_Promise$DefaultPromise) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.impl.Promise$DefaultPromise"));
}
function $isArrayOf_s_concurrent_impl_Promise$DefaultPromise(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$DefaultPromise)));
}
function $asArrayOf_s_concurrent_impl_Promise$DefaultPromise(obj, depth) {
  return (($isArrayOf_s_concurrent_impl_Promise$DefaultPromise(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.impl.Promise$DefaultPromise;", depth));
}
var $d_s_concurrent_impl_Promise$DefaultPromise = new $TypeData().initClass($c_s_concurrent_impl_Promise$DefaultPromise, "scala.concurrent.impl.Promise$DefaultPromise", ({
  s_concurrent_impl_Promise$DefaultPromise: 1,
  ju_concurrent_atomic_AtomicReference: 1,
  Ljava_io_Serializable: 1,
  s_concurrent_Promise: 1,
  s_concurrent_Future: 1,
  s_concurrent_Awaitable: 1,
  F1: 1
}));
function $is_s_math_Integral(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_math_Integral)));
}
function $as_s_math_Integral(obj) {
  return (($is_s_math_Integral(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Integral"));
}
function $isArrayOf_s_math_Integral(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Integral)));
}
function $asArrayOf_s_math_Integral(obj, depth) {
  return (($isArrayOf_s_math_Integral(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Integral;", depth));
}
/** @constructor */
function $c_s_math_Ordering$Boolean$() {
}
$c_s_math_Ordering$Boolean$.prototype = new $h_O();
$c_s_math_Ordering$Boolean$.prototype.constructor = $c_s_math_Ordering$Boolean$;
/** @constructor */
function $h_s_math_Ordering$Boolean$() {
}
$h_s_math_Ordering$Boolean$.prototype = $c_s_math_Ordering$Boolean$.prototype;
$c_s_math_Ordering$Boolean$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Boolean$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Boolean$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Boolean$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Boolean$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Ordering$Boolean$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Ordering$Boolean$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Ordering$Boolean$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uZ(x);
  var y$1 = $uZ(y);
  return ((x$1 === y$1) ? 0 : (x$1 ? 1 : (-1)));
});
var $d_s_math_Ordering$Boolean$ = new $TypeData().initClass($c_s_math_Ordering$Boolean$, "scala.math.Ordering$Boolean$", ({
  s_math_Ordering$Boolean$: 1,
  s_math_Ordering$BooleanOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_math_Ordering$Boolean$;
function $m_s_math_Ordering$Boolean$() {
  if ((!$n_s_math_Ordering$Boolean$)) {
    $n_s_math_Ordering$Boolean$ = new $c_s_math_Ordering$Boolean$();
  }
  return $n_s_math_Ordering$Boolean$;
}
/** @constructor */
function $c_s_math_Ordering$Byte$() {
}
$c_s_math_Ordering$Byte$.prototype = new $h_O();
$c_s_math_Ordering$Byte$.prototype.constructor = $c_s_math_Ordering$Byte$;
/** @constructor */
function $h_s_math_Ordering$Byte$() {
}
$h_s_math_Ordering$Byte$.prototype = $c_s_math_Ordering$Byte$.prototype;
$c_s_math_Ordering$Byte$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Byte$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Byte$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Byte$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Byte$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Ordering$Byte$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Ordering$Byte$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Ordering$Byte$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uB(x);
  var y$1 = $uB(y);
  return ((x$1 - y$1) | 0);
});
var $d_s_math_Ordering$Byte$ = new $TypeData().initClass($c_s_math_Ordering$Byte$, "scala.math.Ordering$Byte$", ({
  s_math_Ordering$Byte$: 1,
  s_math_Ordering$ByteOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_math_Ordering$Byte$;
function $m_s_math_Ordering$Byte$() {
  if ((!$n_s_math_Ordering$Byte$)) {
    $n_s_math_Ordering$Byte$ = new $c_s_math_Ordering$Byte$();
  }
  return $n_s_math_Ordering$Byte$;
}
/** @constructor */
function $c_s_math_Ordering$Char$() {
}
$c_s_math_Ordering$Char$.prototype = new $h_O();
$c_s_math_Ordering$Char$.prototype.constructor = $c_s_math_Ordering$Char$;
/** @constructor */
function $h_s_math_Ordering$Char$() {
}
$h_s_math_Ordering$Char$.prototype = $c_s_math_Ordering$Char$.prototype;
$c_s_math_Ordering$Char$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Char$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Char$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Char$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Char$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Ordering$Char$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Ordering$Char$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Ordering$Char$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return ((x$1 - y$1) | 0);
});
var $d_s_math_Ordering$Char$ = new $TypeData().initClass($c_s_math_Ordering$Char$, "scala.math.Ordering$Char$", ({
  s_math_Ordering$Char$: 1,
  s_math_Ordering$CharOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_math_Ordering$Char$;
function $m_s_math_Ordering$Char$() {
  if ((!$n_s_math_Ordering$Char$)) {
    $n_s_math_Ordering$Char$ = new $c_s_math_Ordering$Char$();
  }
  return $n_s_math_Ordering$Char$;
}
/** @constructor */
function $c_s_math_Ordering$Long$() {
}
$c_s_math_Ordering$Long$.prototype = new $h_O();
$c_s_math_Ordering$Long$.prototype.constructor = $c_s_math_Ordering$Long$;
/** @constructor */
function $h_s_math_Ordering$Long$() {
}
$h_s_math_Ordering$Long$.prototype = $c_s_math_Ordering$Long$.prototype;
$c_s_math_Ordering$Long$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Long$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Long$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Long$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Long$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Ordering$Long$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Ordering$Long$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Ordering$Long$.prototype.compare__O__O__I = (function(x, y) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(y);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1);
});
var $d_s_math_Ordering$Long$ = new $TypeData().initClass($c_s_math_Ordering$Long$, "scala.math.Ordering$Long$", ({
  s_math_Ordering$Long$: 1,
  s_math_Ordering$LongOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_math_Ordering$Long$;
function $m_s_math_Ordering$Long$() {
  if ((!$n_s_math_Ordering$Long$)) {
    $n_s_math_Ordering$Long$ = new $c_s_math_Ordering$Long$();
  }
  return $n_s_math_Ordering$Long$;
}
/** @constructor */
function $c_s_math_Ordering$Short$() {
}
$c_s_math_Ordering$Short$.prototype = new $h_O();
$c_s_math_Ordering$Short$.prototype.constructor = $c_s_math_Ordering$Short$;
/** @constructor */
function $h_s_math_Ordering$Short$() {
}
$h_s_math_Ordering$Short$.prototype = $c_s_math_Ordering$Short$.prototype;
$c_s_math_Ordering$Short$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Short$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Short$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Short$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Short$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Ordering$Short$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Ordering$Short$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Ordering$Short$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uS(x);
  var y$1 = $uS(y);
  return ((x$1 - y$1) | 0);
});
var $d_s_math_Ordering$Short$ = new $TypeData().initClass($c_s_math_Ordering$Short$, "scala.math.Ordering$Short$", ({
  s_math_Ordering$Short$: 1,
  s_math_Ordering$ShortOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_math_Ordering$Short$;
function $m_s_math_Ordering$Short$() {
  if ((!$n_s_math_Ordering$Short$)) {
    $n_s_math_Ordering$Short$ = new $c_s_math_Ordering$Short$();
  }
  return $n_s_math_Ordering$Short$;
}
/** @constructor */
function $c_s_math_Ordering$String$() {
}
$c_s_math_Ordering$String$.prototype = new $h_O();
$c_s_math_Ordering$String$.prototype.constructor = $c_s_math_Ordering$String$;
/** @constructor */
function $h_s_math_Ordering$String$() {
}
$h_s_math_Ordering$String$.prototype = $c_s_math_Ordering$String$.prototype;
$c_s_math_Ordering$String$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$String$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$String$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_Ordering$String$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Ordering$String$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Ordering$String$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Ordering$String$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Ordering$String$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_T(x);
  var y$1 = $as_T(y);
  return $f_T__compareTo__T__I($n(x$1), y$1);
});
var $d_s_math_Ordering$String$ = new $TypeData().initClass($c_s_math_Ordering$String$, "scala.math.Ordering$String$", ({
  s_math_Ordering$String$: 1,
  s_math_Ordering$StringOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_math_Ordering$String$;
function $m_s_math_Ordering$String$() {
  if ((!$n_s_math_Ordering$String$)) {
    $n_s_math_Ordering$String$ = new $c_s_math_Ordering$String$();
  }
  return $n_s_math_Ordering$String$;
}
/** @constructor */
function $c_s_reflect_AnyValManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
$c_s_reflect_AnyValManifest.prototype = new $h_O();
$c_s_reflect_AnyValManifest.prototype.constructor = $c_s_reflect_AnyValManifest;
/** @constructor */
function $h_s_reflect_AnyValManifest() {
}
$h_s_reflect_AnyValManifest.prototype = $c_s_reflect_AnyValManifest.prototype;
$c_s_reflect_AnyValManifest.prototype.toString__T = (function() {
  return this.s_reflect_AnyValManifest__f_toString;
});
$c_s_reflect_AnyValManifest.prototype.equals__O__Z = (function(that) {
  return (this === that);
});
$c_s_reflect_AnyValManifest.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ClassTypeManifest() {
}
$c_s_reflect_ManifestFactory$ClassTypeManifest.prototype = new $h_O();
$c_s_reflect_ManifestFactory$ClassTypeManifest.prototype.constructor = $c_s_reflect_ManifestFactory$ClassTypeManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ClassTypeManifest() {
}
$h_s_reflect_ManifestFactory$ClassTypeManifest.prototype = $c_s_reflect_ManifestFactory$ClassTypeManifest.prototype;
$c_s_reflect_ManifestFactory$ClassTypeManifest.prototype.unapply__O__s_Option = (function(x) {
  return $f_s_reflect_ClassTag__unapply__O__s_Option(this, x);
});
class $c_sjs_js_JavaScriptException extends $c_jl_RuntimeException {
  constructor(exception) {
    super();
    this.sjs_js_JavaScriptException__f_exception = null;
    this.sjs_js_JavaScriptException__f_exception = exception;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  getMessage__T() {
    return $dp_toString__T($n(this.sjs_js_JavaScriptException__f_exception));
  }
  productPrefix__T() {
    return "JavaScriptException";
  }
  productArity__I() {
    return 1;
  }
  productElement__I__O(x$1) {
    return ((x$1 === 0) ? this.sjs_js_JavaScriptException__f_exception : $m_sr_Statics$().ioobe__I__O(x$1));
  }
  productIterator__sc_Iterator() {
    return new $c_sr_ScalaRunTime$$anon$1(this);
  }
  hashCode__I() {
    var this$2 = $m_s_util_hashing_MurmurHash3$();
    return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
  }
  equals__O__Z(x$1) {
    if ((this === x$1)) {
      return true;
    } else if ((x$1 instanceof $c_sjs_js_JavaScriptException)) {
      var JavaScriptException$1 = $as_sjs_js_JavaScriptException(x$1);
      var x = this.sjs_js_JavaScriptException__f_exception;
      var y = $n(JavaScriptException$1).sjs_js_JavaScriptException__f_exception;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
    } else {
      return false;
    }
  }
}
function $as_sjs_js_JavaScriptException(obj) {
  return (((obj instanceof $c_sjs_js_JavaScriptException) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.scalajs.js.JavaScriptException"));
}
function $isArrayOf_sjs_js_JavaScriptException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjs_js_JavaScriptException)));
}
function $asArrayOf_sjs_js_JavaScriptException(obj, depth) {
  return (($isArrayOf_sjs_js_JavaScriptException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.scalajs.js.JavaScriptException;", depth));
}
var $d_sjs_js_JavaScriptException = new $TypeData().initClass($c_sjs_js_JavaScriptException, "scala.scalajs.js.JavaScriptException", ({
  sjs_js_JavaScriptException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
}));
function $f_Lcats_Traverse__sequence__O__Lcats_Applicative__O($thiz, fga, evidence$1) {
  return $thiz.traverse__O__F1__Lcats_Applicative__O(fga, new $c_sjsr_AnonFunction1(((ga) => ga)), evidence$1);
}
function $is_Lcats_Traverse(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_Traverse)));
}
function $as_Lcats_Traverse(obj) {
  return (($is_Lcats_Traverse(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Traverse"));
}
function $isArrayOf_Lcats_Traverse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Traverse)));
}
function $asArrayOf_Lcats_Traverse(obj, depth) {
  return (($isArrayOf_Lcats_Traverse(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Traverse;", depth));
}
function $p_Lcats_data_Chain$__loop$4__I__Lcats_Applicative__F1__sci_IndexedSeq__I__I__Lcats_Eval($thiz, width$1, G$1, f$10, as$1, start, end) {
  if ((((end - start) | 0) <= width$1)) {
    $m_Lcats_Eval$();
    var a = new $c_sjsr_AnonFunction0((() => $n(G$1).map__O__F1__O($n(f$10).apply__O__O($n(as$1).apply__I__O((((-1) + end) | 0))), new $c_sjsr_AnonFunction1(((_$5) => {
      var this$2 = $m_sci_Nil$();
      return new $c_sci_$colon$colon(_$5, this$2);
    })))));
    var flist = new $c_Lcats_Later(a);
    var idx = (((-2) + end) | 0);
    while ((start <= idx)) {
      var a$1 = $n(as$1).apply__I__O(idx);
      var right = flist;
      var this$5 = $m_Lcats_Eval$();
      var a$2 = new $c_sjsr_AnonFunction0(((G$1, f$10, a$1, right) => (() => $n(G$1).map2Eval__O__Lcats_Eval__F2__Lcats_Eval($n(f$10).apply__O__O(a$1), right, new $c_sjsr_AnonFunction2(((_$6, _$7) => {
        var _$7$1 = $as_sci_List(_$7);
        var this$4 = $n(_$7$1);
        return new $c_sci_$colon$colon(_$6, this$4);
      })))))(G$1, f$10, a$1, right));
      flist = new $c_Lcats_Eval$$anon$5(a$2, this$5);
      idx = (((-1) + idx) | 0);
    }
    return $n(flist).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((glist) => $n(G$1).map__O__F1__O(glist, new $c_sjsr_AnonFunction1(((_$8) => {
      var _$8$1 = $as_sci_List(_$8);
      var this$6 = $m_Lcats_data_Chain$();
      return $f_Lcats_data_ChainCompanionCompat__fromSeq__sci_Seq__Lcats_data_Chain(this$6, _$8$1);
    }))))));
  } else {
    var step = $intDiv(((end - start) | 0), width$1);
    var this$7 = $m_Lcats_Eval$();
    var a$3 = new $c_sjsr_AnonFunction0((() => $p_Lcats_data_Chain$__loop$4__I__Lcats_Applicative__F1__sci_IndexedSeq__I__I__Lcats_Eval($thiz, width$1, G$1, f$10, as$1, start, ((start + step) | 0))));
    var fchain = new $c_Lcats_Eval$$anon$5(a$3, this$7);
    var start0 = ((start + step) | 0);
    var end0 = ((start0 + step) | 0);
    while ((start0 < end)) {
      var y = end0;
      var end1 = ((end < y) ? end : y);
      var right$3 = $p_Lcats_data_Chain$__loop$4__I__Lcats_Applicative__F1__sci_IndexedSeq__I__I__Lcats_Eval($thiz, width$1, G$1, f$10, as$1, start0, end1);
      fchain = $n(fchain).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((G$1, right$3) => ((_$9) => $n(G$1).map2Eval__O__Lcats_Eval__F2__Lcats_Eval(_$9, right$3, new $c_sjsr_AnonFunction2(((_$10, _$11) => {
        var _$10$1 = $as_Lcats_data_Chain(_$10);
        var _$11$1 = $as_Lcats_data_Chain(_$11);
        var this$10 = $n(_$10$1);
        return $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this$10, _$11$1);
      })))))(G$1, right$3)));
      start0 = ((start0 + step) | 0);
      end0 = ((end0 + step) | 0);
    }
    return fchain;
  }
}
/** @constructor */
function $c_Lcats_data_Chain$() {
  this.Lcats_data_ChainInstances__f_catsDataInstancesForChain = null;
  this.Lcats_data_ChainInstances__f_theMonoid = null;
  this.Lcats_data_Chain$__f_cats$data$Chain$$$sentinel = null;
  this.Lcats_data_Chain$__f_nil = null;
  $ct_Lcats_data_ChainInstances__(this);
  $n_Lcats_data_Chain$ = this;
  this.Lcats_data_Chain$__f_cats$data$Chain$$$sentinel = new $c_Lcats_data_Chain$$anon$2();
  this.Lcats_data_Chain$__f_nil = $m_Lcats_data_Chain$Empty$();
}
$c_Lcats_data_Chain$.prototype = new $h_Lcats_data_ChainInstances();
$c_Lcats_data_Chain$.prototype.constructor = $c_Lcats_data_Chain$;
/** @constructor */
function $h_Lcats_data_Chain$() {
}
$h_Lcats_data_Chain$.prototype = $c_Lcats_data_Chain$.prototype;
$c_Lcats_data_Chain$.prototype.concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain = (function(c, c2) {
  if ((c instanceof $c_Lcats_data_Chain$NonEmpty)) {
    var non = $as_Lcats_data_Chain$NonEmpty(c);
    if ((c2 instanceof $c_Lcats_data_Chain$NonEmpty)) {
      var non2 = $as_Lcats_data_Chain$NonEmpty(c2);
      return new $c_Lcats_data_Chain$Append(non, non2);
    } else {
      return non;
    }
  } else {
    return c2;
  }
});
$c_Lcats_data_Chain$.prototype.traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O = (function(as, f, G) {
  if ($n(as).isEmpty__Z()) {
    return $n(G).pure__O__O($m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil);
  } else {
    var this$1 = $n(as);
    return $n($p_Lcats_data_Chain$__loop$4__I__Lcats_Applicative__F1__sci_IndexedSeq__I__I__Lcats_Eval(this, 128, G, f, as, 0, this$1.length__I())).value__O();
  }
});
var $d_Lcats_data_Chain$ = new $TypeData().initClass($c_Lcats_data_Chain$, "cats.data.Chain$", ({
  Lcats_data_Chain$: 1,
  Lcats_data_ChainInstances: 1,
  Lcats_data_ChainInstances1: 1,
  Lcats_data_ChainInstances2: 1,
  Lcats_data_ChainInstances3: 1,
  Lcats_data_ChainCompanionCompat: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Lcats_data_Chain$;
function $m_Lcats_data_Chain$() {
  if ((!$n_Lcats_data_Chain$)) {
    $n_Lcats_data_Chain$ = new $c_Lcats_data_Chain$();
  }
  return $n_Lcats_data_Chain$;
}
/** @constructor */
function $c_Lcats_data_KleisliInstances2() {
}
$c_Lcats_data_KleisliInstances2.prototype = new $h_Lcats_data_KleisliInstances3();
$c_Lcats_data_KleisliInstances2.prototype.constructor = $c_Lcats_data_KleisliInstances2;
/** @constructor */
function $h_Lcats_data_KleisliInstances2() {
}
$h_Lcats_data_KleisliInstances2.prototype = $c_Lcats_data_KleisliInstances2.prototype;
/** @constructor */
function $c_Lcats_data_Validated$() {
  this.Lcats_data_Validated$__f_validUnit = null;
  $ct_Lcats_data_ValidatedInstances__(this);
  $n_Lcats_data_Validated$ = this;
  this.Lcats_data_Validated$__f_validUnit = new $c_Lcats_data_Validated$Valid((void 0));
}
$c_Lcats_data_Validated$.prototype = new $h_Lcats_data_ValidatedInstances();
$c_Lcats_data_Validated$.prototype.constructor = $c_Lcats_data_Validated$;
/** @constructor */
function $h_Lcats_data_Validated$() {
}
$h_Lcats_data_Validated$.prototype = $c_Lcats_data_Validated$.prototype;
var $d_Lcats_data_Validated$ = new $TypeData().initClass($c_Lcats_data_Validated$, "cats.data.Validated$", ({
  Lcats_data_Validated$: 1,
  Lcats_data_ValidatedInstances: 1,
  Lcats_data_ValidatedInstances1: 1,
  Lcats_data_ValidatedInstances2: 1,
  Lcats_data_ValidatedFunctions: 1,
  Lcats_data_ValidatedFunctionsBinCompat0: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Lcats_data_Validated$;
function $m_Lcats_data_Validated$() {
  if ((!$n_Lcats_data_Validated$)) {
    $n_Lcats_data_Validated$ = new $c_Lcats_data_Validated$();
  }
  return $n_Lcats_data_Validated$;
}
/** @constructor */
function $c_Lcats_effect_SyncIO$RealTime$() {
}
$c_Lcats_effect_SyncIO$RealTime$.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$RealTime$.prototype.constructor = $c_Lcats_effect_SyncIO$RealTime$;
/** @constructor */
function $h_Lcats_effect_SyncIO$RealTime$() {
}
$h_Lcats_effect_SyncIO$RealTime$.prototype = $c_Lcats_effect_SyncIO$RealTime$.prototype;
$c_Lcats_effect_SyncIO$RealTime$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$RealTime$.prototype.hashCode__I = (function() {
  return (-795507285);
});
$c_Lcats_effect_SyncIO$RealTime$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_SyncIO$RealTime$.prototype.productPrefix__T = (function() {
  return "RealTime";
});
$c_Lcats_effect_SyncIO$RealTime$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$RealTime$.prototype.tag__B = (function() {
  return 9;
});
var $d_Lcats_effect_SyncIO$RealTime$ = new $TypeData().initClass($c_Lcats_effect_SyncIO$RealTime$, "cats.effect.SyncIO$RealTime$", ({
  Lcats_effect_SyncIO$RealTime$: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_SyncIO$RealTime$;
function $m_Lcats_effect_SyncIO$RealTime$() {
  if ((!$n_Lcats_effect_SyncIO$RealTime$)) {
    $n_Lcats_effect_SyncIO$RealTime$ = new $c_Lcats_effect_SyncIO$RealTime$();
  }
  return $n_Lcats_effect_SyncIO$RealTime$;
}
/** @constructor */
function $c_Lcats_effect_kernel_Resource$ExitCase$Canceled$() {
}
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.constructor = $c_Lcats_effect_kernel_Resource$ExitCase$Canceled$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$ExitCase$Canceled$() {
}
$h_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype = $c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype;
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.hashCode__I = (function() {
  return (-58529607);
});
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.toString__T = (function() {
  return "Canceled";
});
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.productPrefix__T = (function() {
  return "Canceled";
});
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcats_effect_kernel_Resource$ExitCase$Canceled$ = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$ExitCase$Canceled$, "cats.effect.kernel.Resource$ExitCase$Canceled$", ({
  Lcats_effect_kernel_Resource$ExitCase$Canceled$: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Resource$ExitCase: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_kernel_Resource$ExitCase$Canceled$;
function $m_Lcats_effect_kernel_Resource$ExitCase$Canceled$() {
  if ((!$n_Lcats_effect_kernel_Resource$ExitCase$Canceled$)) {
    $n_Lcats_effect_kernel_Resource$ExitCase$Canceled$ = new $c_Lcats_effect_kernel_Resource$ExitCase$Canceled$();
  }
  return $n_Lcats_effect_kernel_Resource$ExitCase$Canceled$;
}
/** @constructor */
function $c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$() {
}
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.constructor = $c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$ExitCase$Succeeded$() {
}
$h_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype = $c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype;
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.hashCode__I = (function() {
  return (-1345265087);
});
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.toString__T = (function() {
  return "Succeeded";
});
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.productPrefix__T = (function() {
  return "Succeeded";
});
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcats_effect_kernel_Resource$ExitCase$Succeeded$ = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$, "cats.effect.kernel.Resource$ExitCase$Succeeded$", ({
  Lcats_effect_kernel_Resource$ExitCase$Succeeded$: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Resource$ExitCase: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_kernel_Resource$ExitCase$Succeeded$;
function $m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$() {
  if ((!$n_Lcats_effect_kernel_Resource$ExitCase$Succeeded$)) {
    $n_Lcats_effect_kernel_Resource$ExitCase$Succeeded$ = new $c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$();
  }
  return $n_Lcats_effect_kernel_Resource$ExitCase$Succeeded$;
}
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Nil$2$() {
}
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.constructor = $c_Lcats_effect_kernel_Resource$Nil$2$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Nil$2$() {
}
$h_Lcats_effect_kernel_Resource$Nil$2$.prototype = $c_Lcats_effect_kernel_Resource$Nil$2$.prototype;
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.hashCode__I = (function() {
  return 78321;
});
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.toString__T = (function() {
  return "Nil";
});
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.productPrefix__T = (function() {
  return "Nil";
});
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_kernel_Resource$Nil$2$(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Nil$2$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Nil$2$"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$Nil$2$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Nil$2$)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$Nil$2$(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Nil$2$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Nil$2$;", depth));
}
var $d_Lcats_effect_kernel_Resource$Nil$2$ = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$Nil$2$, "cats.effect.kernel.Resource$Nil$2$", ({
  Lcats_effect_kernel_Resource$Nil$2$: 1,
  Lcats_effect_kernel_Resource$Stack$1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Nil$4$() {
}
$c_Lcats_effect_kernel_Resource$Nil$4$.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$Nil$4$.prototype.constructor = $c_Lcats_effect_kernel_Resource$Nil$4$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Nil$4$() {
}
$h_Lcats_effect_kernel_Resource$Nil$4$.prototype = $c_Lcats_effect_kernel_Resource$Nil$4$.prototype;
$c_Lcats_effect_kernel_Resource$Nil$4$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$Nil$4$.prototype.hashCode__I = (function() {
  return 78321;
});
$c_Lcats_effect_kernel_Resource$Nil$4$.prototype.toString__T = (function() {
  return "Nil";
});
$c_Lcats_effect_kernel_Resource$Nil$4$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_kernel_Resource$Nil$4$.prototype.productPrefix__T = (function() {
  return "Nil";
});
$c_Lcats_effect_kernel_Resource$Nil$4$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_kernel_Resource$Nil$4$(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Nil$4$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Nil$4$"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$Nil$4$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Nil$4$)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$Nil$4$(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Nil$4$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Nil$4$;", depth));
}
var $d_Lcats_effect_kernel_Resource$Nil$4$ = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$Nil$4$, "cats.effect.kernel.Resource$Nil$4$", ({
  Lcats_effect_kernel_Resource$Nil$4$: 1,
  Lcats_effect_kernel_Resource$Stack$2: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Sync$Type$Blocking$() {
}
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype = new $h_O();
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.constructor = $c_Lcats_effect_kernel_Sync$Type$Blocking$;
/** @constructor */
function $h_Lcats_effect_kernel_Sync$Type$Blocking$() {
}
$h_Lcats_effect_kernel_Sync$Type$Blocking$.prototype = $c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype;
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.hashCode__I = (function() {
  return (-599928747);
});
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.toString__T = (function() {
  return "Blocking";
});
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.productPrefix__T = (function() {
  return "Blocking";
});
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcats_effect_kernel_Sync$Type$Blocking$ = new $TypeData().initClass($c_Lcats_effect_kernel_Sync$Type$Blocking$, "cats.effect.kernel.Sync$Type$Blocking$", ({
  Lcats_effect_kernel_Sync$Type$Blocking$: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Sync$Type: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_kernel_Sync$Type$Blocking$;
function $m_Lcats_effect_kernel_Sync$Type$Blocking$() {
  if ((!$n_Lcats_effect_kernel_Sync$Type$Blocking$)) {
    $n_Lcats_effect_kernel_Sync$Type$Blocking$ = new $c_Lcats_effect_kernel_Sync$Type$Blocking$();
  }
  return $n_Lcats_effect_kernel_Sync$Type$Blocking$;
}
/** @constructor */
function $c_Lcats_effect_kernel_Sync$Type$Delay$() {
}
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype = new $h_O();
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.constructor = $c_Lcats_effect_kernel_Sync$Type$Delay$;
/** @constructor */
function $h_Lcats_effect_kernel_Sync$Type$Delay$() {
}
$h_Lcats_effect_kernel_Sync$Type$Delay$.prototype = $c_Lcats_effect_kernel_Sync$Type$Delay$.prototype;
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.hashCode__I = (function() {
  return 65915235;
});
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.toString__T = (function() {
  return "Delay";
});
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.productPrefix__T = (function() {
  return "Delay";
});
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcats_effect_kernel_Sync$Type$Delay$ = new $TypeData().initClass($c_Lcats_effect_kernel_Sync$Type$Delay$, "cats.effect.kernel.Sync$Type$Delay$", ({
  Lcats_effect_kernel_Sync$Type$Delay$: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Sync$Type: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_kernel_Sync$Type$Delay$;
function $m_Lcats_effect_kernel_Sync$Type$Delay$() {
  if ((!$n_Lcats_effect_kernel_Sync$Type$Delay$)) {
    $n_Lcats_effect_kernel_Sync$Type$Delay$ = new $c_Lcats_effect_kernel_Sync$Type$Delay$();
  }
  return $n_Lcats_effect_kernel_Sync$Type$Delay$;
}
/** @constructor */
function $c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$() {
}
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype = new $h_O();
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.constructor = $c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$;
/** @constructor */
function $h_Lcats_effect_kernel_Sync$Type$InterruptibleMany$() {
}
$h_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype = $c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype;
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.hashCode__I = (function() {
  return 430282004;
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.toString__T = (function() {
  return "InterruptibleMany";
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.productPrefix__T = (function() {
  return "InterruptibleMany";
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcats_effect_kernel_Sync$Type$InterruptibleMany$ = new $TypeData().initClass($c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$, "cats.effect.kernel.Sync$Type$InterruptibleMany$", ({
  Lcats_effect_kernel_Sync$Type$InterruptibleMany$: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Sync$Type: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_kernel_Sync$Type$InterruptibleMany$;
function $m_Lcats_effect_kernel_Sync$Type$InterruptibleMany$() {
  if ((!$n_Lcats_effect_kernel_Sync$Type$InterruptibleMany$)) {
    $n_Lcats_effect_kernel_Sync$Type$InterruptibleMany$ = new $c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$();
  }
  return $n_Lcats_effect_kernel_Sync$Type$InterruptibleMany$;
}
/** @constructor */
function $c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$() {
}
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype = new $h_O();
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.constructor = $c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$;
/** @constructor */
function $h_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$() {
}
$h_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype = $c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype;
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.hashCode__I = (function() {
  return 430353718;
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.toString__T = (function() {
  return "InterruptibleOnce";
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.productPrefix__T = (function() {
  return "InterruptibleOnce";
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$ = new $TypeData().initClass($c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$, "cats.effect.kernel.Sync$Type$InterruptibleOnce$", ({
  Lcats_effect_kernel_Sync$Type$InterruptibleOnce$: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Sync$Type: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$;
function $m_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$() {
  if ((!$n_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$)) {
    $n_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$ = new $c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$();
  }
  return $n_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$;
}
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$() {
}
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$() {
}
$h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$.prototype = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$.prototype;
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$.prototype.hashCode__I = (function() {
  return 2125956;
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$.prototype.toString__T = (function() {
  return "Dead";
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$.prototype.productPrefix__T = (function() {
  return "Dead";
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$ = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$, "cats.effect.std.Dispatcher$Executor$TaskState$3$Dead$", ({
  Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_std_Dispatcher$Executor$TaskState$1: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$() {
}
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$() {
}
$h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$.prototype = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$.prototype;
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$.prototype.hashCode__I = (function() {
  return 912992978;
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$.prototype.toString__T = (function() {
  return "Executing";
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$.prototype.productPrefix__T = (function() {
  return "Executing";
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$ = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$, "cats.effect.std.Dispatcher$Executor$TaskState$3$Executing$", ({
  Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_std_Dispatcher$Executor$TaskState$1: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$RegState$Completed$() {
}
$c_Lcats_effect_std_Dispatcher$RegState$Completed$.prototype = new $h_Lcats_effect_std_Dispatcher$RegState();
$c_Lcats_effect_std_Dispatcher$RegState$Completed$.prototype.constructor = $c_Lcats_effect_std_Dispatcher$RegState$Completed$;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$RegState$Completed$() {
}
$h_Lcats_effect_std_Dispatcher$RegState$Completed$.prototype = $c_Lcats_effect_std_Dispatcher$RegState$Completed$.prototype;
$c_Lcats_effect_std_Dispatcher$RegState$Completed$.prototype.hashCode__I = (function() {
  return 601036331;
});
$c_Lcats_effect_std_Dispatcher$RegState$Completed$.prototype.toString__T = (function() {
  return "Completed";
});
$c_Lcats_effect_std_Dispatcher$RegState$Completed$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_std_Dispatcher$RegState$Completed$.prototype.productPrefix__T = (function() {
  return "Completed";
});
$c_Lcats_effect_std_Dispatcher$RegState$Completed$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcats_effect_std_Dispatcher$RegState$Completed$ = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$RegState$Completed$, "cats.effect.std.Dispatcher$RegState$Completed$", ({
  Lcats_effect_std_Dispatcher$RegState$Completed$: 1,
  Lcats_effect_std_Dispatcher$RegState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_std_Dispatcher$RegState$Completed$;
function $m_Lcats_effect_std_Dispatcher$RegState$Completed$() {
  if ((!$n_Lcats_effect_std_Dispatcher$RegState$Completed$)) {
    $n_Lcats_effect_std_Dispatcher$RegState$Completed$ = new $c_Lcats_effect_std_Dispatcher$RegState$Completed$();
  }
  return $n_Lcats_effect_std_Dispatcher$RegState$Completed$;
}
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$RegState$Unstarted$() {
}
$c_Lcats_effect_std_Dispatcher$RegState$Unstarted$.prototype = new $h_Lcats_effect_std_Dispatcher$RegState();
$c_Lcats_effect_std_Dispatcher$RegState$Unstarted$.prototype.constructor = $c_Lcats_effect_std_Dispatcher$RegState$Unstarted$;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$RegState$Unstarted$() {
}
$h_Lcats_effect_std_Dispatcher$RegState$Unstarted$.prototype = $c_Lcats_effect_std_Dispatcher$RegState$Unstarted$.prototype;
$c_Lcats_effect_std_Dispatcher$RegState$Unstarted$.prototype.hashCode__I = (function() {
  return 1818583976;
});
$c_Lcats_effect_std_Dispatcher$RegState$Unstarted$.prototype.toString__T = (function() {
  return "Unstarted";
});
$c_Lcats_effect_std_Dispatcher$RegState$Unstarted$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_std_Dispatcher$RegState$Unstarted$.prototype.productPrefix__T = (function() {
  return "Unstarted";
});
$c_Lcats_effect_std_Dispatcher$RegState$Unstarted$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcats_effect_std_Dispatcher$RegState$Unstarted$ = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$RegState$Unstarted$, "cats.effect.std.Dispatcher$RegState$Unstarted$", ({
  Lcats_effect_std_Dispatcher$RegState$Unstarted$: 1,
  Lcats_effect_std_Dispatcher$RegState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_std_Dispatcher$RegState$Unstarted$;
function $m_Lcats_effect_std_Dispatcher$RegState$Unstarted$() {
  if ((!$n_Lcats_effect_std_Dispatcher$RegState$Unstarted$)) {
    $n_Lcats_effect_std_Dispatcher$RegState$Unstarted$ = new $c_Lcats_effect_std_Dispatcher$RegState$Unstarted$();
  }
  return $n_Lcats_effect_std_Dispatcher$RegState$Unstarted$;
}
/** @constructor */
function $c_Lcats_instances_InvariantInstances$$anon$11(fa$8, f$4, g$4) {
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa = null;
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_f = null;
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_g = null;
  $ct_Lcats_instances_ScalaVersionSpecificNumeric__s_math_Numeric__F1__F1__(this, fa$8, f$4, g$4);
}
$c_Lcats_instances_InvariantInstances$$anon$11.prototype = new $h_Lcats_instances_ScalaVersionSpecificNumeric();
$c_Lcats_instances_InvariantInstances$$anon$11.prototype.constructor = $c_Lcats_instances_InvariantInstances$$anon$11;
/** @constructor */
function $h_Lcats_instances_InvariantInstances$$anon$11() {
}
$h_Lcats_instances_InvariantInstances$$anon$11.prototype = $c_Lcats_instances_InvariantInstances$$anon$11.prototype;
var $d_Lcats_instances_InvariantInstances$$anon$11 = new $TypeData().initClass($c_Lcats_instances_InvariantInstances$$anon$11, "cats.instances.InvariantInstances$$anon$11", ({
  Lcats_instances_InvariantInstances$$anon$11: 1,
  Lcats_instances_ScalaVersionSpecificNumeric: 1,
  ju_Comparator: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1,
  s_math_PartialOrdering: 1,
  s_math_Ordering: 1,
  s_math_Numeric: 1
}));
/** @constructor */
function $c_Lcats_instances_package$sortedSet$() {
  this.Lcats_instances_package$sortedSet$__f_catsStdInstancesForSortedSet = null;
  $n_Lcats_instances_package$sortedSet$ = this;
  this.Lcats_instances_package$sortedSet$__f_catsStdInstancesForSortedSet = new $c_Lcats_instances_SortedSetInstances$$anon$1();
}
$c_Lcats_instances_package$sortedSet$.prototype = new $h_O();
$c_Lcats_instances_package$sortedSet$.prototype.constructor = $c_Lcats_instances_package$sortedSet$;
/** @constructor */
function $h_Lcats_instances_package$sortedSet$() {
}
$h_Lcats_instances_package$sortedSet$.prototype = $c_Lcats_instances_package$sortedSet$.prototype;
var $d_Lcats_instances_package$sortedSet$ = new $TypeData().initClass($c_Lcats_instances_package$sortedSet$, "cats.instances.package$sortedSet$", ({
  Lcats_instances_package$sortedSet$: 1,
  Lcats_instances_SortedSetInstances1: 1,
  Lcats_instances_SortedSetInstances: 1,
  Lcats_instances_SortedSetInstancesBinCompat0: 1,
  Lcats_kernel_instances_SortedSetInstances1: 1,
  Lcats_kernel_instances_SortedSetInstances: 1,
  Lcats_instances_LowPrioritySortedSetInstancesBinCompat1: 1,
  Lcats_instances_SortedSetInstancesBinCompat1: 1
}));
var $n_Lcats_instances_package$sortedSet$;
function $m_Lcats_instances_package$sortedSet$() {
  if ((!$n_Lcats_instances_package$sortedSet$)) {
    $n_Lcats_instances_package$sortedSet$ = new $c_Lcats_instances_package$sortedSet$();
  }
  return $n_Lcats_instances_package$sortedSet$;
}
/** @constructor */
function $c_Lcats_kernel_instances_BigDecimalGroup() {
  this.Lcats_kernel_instances_BigDecimalGroup__f_empty = null;
  var this$1 = $n($m_s_package$().BigDecimal__s_math_BigDecimal$());
  this.Lcats_kernel_instances_BigDecimalGroup__f_empty = this$1.apply__I__Ljava_math_MathContext__s_math_BigDecimal(0, this$1.s_math_BigDecimal$__f_defaultMathContext);
}
$c_Lcats_kernel_instances_BigDecimalGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.constructor = $c_Lcats_kernel_instances_BigDecimalGroup;
/** @constructor */
function $h_Lcats_kernel_instances_BigDecimalGroup() {
}
$h_Lcats_kernel_instances_BigDecimalGroup.prototype = $c_Lcats_kernel_instances_BigDecimalGroup.prototype;
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAllOption__sc_IterableOnce__s_Option(this, as);
});
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.combine__s_math_BigDecimal__s_math_BigDecimal__s_math_BigDecimal = (function(x, y) {
  return new $c_s_math_BigDecimal($n($n(x).s_math_BigDecimal__f_bigDecimal).add__Ljava_math_BigDecimal__Ljava_math_BigDecimal($n(y).s_math_BigDecimal__f_bigDecimal), $n(x).s_math_BigDecimal__f_mc);
});
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.empty__O = (function() {
  return this.Lcats_kernel_instances_BigDecimalGroup__f_empty;
});
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__s_math_BigDecimal__s_math_BigDecimal__s_math_BigDecimal($as_s_math_BigDecimal(x), $as_s_math_BigDecimal(y));
});
var $d_Lcats_kernel_instances_BigDecimalGroup = new $TypeData().initClass($c_Lcats_kernel_instances_BigDecimalGroup, "cats.kernel.instances.BigDecimalGroup", ({
  Lcats_kernel_instances_BigDecimalGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_BigIntGroup() {
  this.Lcats_kernel_instances_BigIntGroup__f_empty = null;
  this.Lcats_kernel_instances_BigIntGroup__f_empty = $n($m_s_package$().BigInt__s_math_BigInt$()).apply__I__s_math_BigInt(0);
}
$c_Lcats_kernel_instances_BigIntGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_BigIntGroup.prototype.constructor = $c_Lcats_kernel_instances_BigIntGroup;
/** @constructor */
function $h_Lcats_kernel_instances_BigIntGroup() {
}
$h_Lcats_kernel_instances_BigIntGroup.prototype = $c_Lcats_kernel_instances_BigIntGroup.prototype;
$c_Lcats_kernel_instances_BigIntGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_BigIntGroup.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAllOption__sc_IterableOnce__s_Option(this, as);
});
$c_Lcats_kernel_instances_BigIntGroup.prototype.empty__O = (function() {
  return this.Lcats_kernel_instances_BigIntGroup__f_empty;
});
$c_Lcats_kernel_instances_BigIntGroup.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_s_math_BigInt(x);
  var y$1 = $as_s_math_BigInt(y);
  return $n(x$1).$plus__s_math_BigInt__s_math_BigInt(y$1);
});
var $d_Lcats_kernel_instances_BigIntGroup = new $TypeData().initClass($c_Lcats_kernel_instances_BigIntGroup, "cats.kernel.instances.BigIntGroup", ({
  Lcats_kernel_instances_BigIntGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_ByteGroup() {
}
$c_Lcats_kernel_instances_ByteGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_ByteGroup.prototype.constructor = $c_Lcats_kernel_instances_ByteGroup;
/** @constructor */
function $h_Lcats_kernel_instances_ByteGroup() {
}
$h_Lcats_kernel_instances_ByteGroup.prototype = $c_Lcats_kernel_instances_ByteGroup.prototype;
$c_Lcats_kernel_instances_ByteGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_ByteGroup.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAllOption__sc_IterableOnce__s_Option(this, as);
});
$c_Lcats_kernel_instances_ByteGroup.prototype.combine__B__B__B = (function(x, y) {
  return ((((x + y) | 0) << 24) >> 24);
});
$c_Lcats_kernel_instances_ByteGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__B__B__B($uB(x), $uB(y));
});
$c_Lcats_kernel_instances_ByteGroup.prototype.empty__O = (function() {
  return 0;
});
var $d_Lcats_kernel_instances_ByteGroup = new $TypeData().initClass($c_Lcats_kernel_instances_ByteGroup, "cats.kernel.instances.ByteGroup", ({
  Lcats_kernel_instances_ByteGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_DoubleGroup() {
}
$c_Lcats_kernel_instances_DoubleGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_DoubleGroup.prototype.constructor = $c_Lcats_kernel_instances_DoubleGroup;
/** @constructor */
function $h_Lcats_kernel_instances_DoubleGroup() {
}
$h_Lcats_kernel_instances_DoubleGroup.prototype = $c_Lcats_kernel_instances_DoubleGroup.prototype;
$c_Lcats_kernel_instances_DoubleGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_DoubleGroup.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAllOption__sc_IterableOnce__s_Option(this, as);
});
$c_Lcats_kernel_instances_DoubleGroup.prototype.combine__D__D__D = (function(x, y) {
  return (x + y);
});
$c_Lcats_kernel_instances_DoubleGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__D__D__D($uD(x), $uD(y));
});
$c_Lcats_kernel_instances_DoubleGroup.prototype.empty__O = (function() {
  return 0.0;
});
var $d_Lcats_kernel_instances_DoubleGroup = new $TypeData().initClass($c_Lcats_kernel_instances_DoubleGroup, "cats.kernel.instances.DoubleGroup", ({
  Lcats_kernel_instances_DoubleGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_DurationGroup() {
}
$c_Lcats_kernel_instances_DurationGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_DurationGroup.prototype.constructor = $c_Lcats_kernel_instances_DurationGroup;
/** @constructor */
function $h_Lcats_kernel_instances_DurationGroup() {
}
$h_Lcats_kernel_instances_DurationGroup.prototype = $c_Lcats_kernel_instances_DurationGroup.prototype;
$c_Lcats_kernel_instances_DurationGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_DurationGroup.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAllOption__sc_IterableOnce__s_Option(this, as);
});
$c_Lcats_kernel_instances_DurationGroup.prototype.empty__O = (function() {
  return $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Zero;
});
$c_Lcats_kernel_instances_DurationGroup.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_Duration(x);
  var y$1 = $as_s_concurrent_duration_Duration(y);
  return $n(x$1).$plus__s_concurrent_duration_Duration__s_concurrent_duration_Duration(y$1);
});
var $d_Lcats_kernel_instances_DurationGroup = new $TypeData().initClass($c_Lcats_kernel_instances_DurationGroup, "cats.kernel.instances.DurationGroup", ({
  Lcats_kernel_instances_DurationGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_FiniteDurationGroup() {
}
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype.constructor = $c_Lcats_kernel_instances_FiniteDurationGroup;
/** @constructor */
function $h_Lcats_kernel_instances_FiniteDurationGroup() {
}
$h_Lcats_kernel_instances_FiniteDurationGroup.prototype = $c_Lcats_kernel_instances_FiniteDurationGroup.prototype;
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAllOption__sc_IterableOnce__s_Option(this, as);
});
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype.empty__O = (function() {
  return $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Zero;
});
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_FiniteDuration(x);
  var y$1 = $as_s_concurrent_duration_FiniteDuration(y);
  var this$1 = $n(x$1);
  return $p_s_concurrent_duration_FiniteDuration__add__J__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration(this$1, $n(y$1).s_concurrent_duration_FiniteDuration__f_length, $n(y$1).s_concurrent_duration_FiniteDuration__f_unit);
});
var $d_Lcats_kernel_instances_FiniteDurationGroup = new $TypeData().initClass($c_Lcats_kernel_instances_FiniteDurationGroup, "cats.kernel.instances.FiniteDurationGroup", ({
  Lcats_kernel_instances_FiniteDurationGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_FloatGroup() {
}
$c_Lcats_kernel_instances_FloatGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_FloatGroup.prototype.constructor = $c_Lcats_kernel_instances_FloatGroup;
/** @constructor */
function $h_Lcats_kernel_instances_FloatGroup() {
}
$h_Lcats_kernel_instances_FloatGroup.prototype = $c_Lcats_kernel_instances_FloatGroup.prototype;
$c_Lcats_kernel_instances_FloatGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_FloatGroup.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAllOption__sc_IterableOnce__s_Option(this, as);
});
$c_Lcats_kernel_instances_FloatGroup.prototype.combine__F__F__F = (function(x, y) {
  return Math.fround((x + y));
});
$c_Lcats_kernel_instances_FloatGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__F__F__F($uF(x), $uF(y));
});
$c_Lcats_kernel_instances_FloatGroup.prototype.empty__O = (function() {
  return 0.0;
});
var $d_Lcats_kernel_instances_FloatGroup = new $TypeData().initClass($c_Lcats_kernel_instances_FloatGroup, "cats.kernel.instances.FloatGroup", ({
  Lcats_kernel_instances_FloatGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_IntGroup() {
}
$c_Lcats_kernel_instances_IntGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_IntGroup.prototype.constructor = $c_Lcats_kernel_instances_IntGroup;
/** @constructor */
function $h_Lcats_kernel_instances_IntGroup() {
}
$h_Lcats_kernel_instances_IntGroup.prototype = $c_Lcats_kernel_instances_IntGroup.prototype;
$c_Lcats_kernel_instances_IntGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_IntGroup.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAllOption__sc_IterableOnce__s_Option(this, as);
});
$c_Lcats_kernel_instances_IntGroup.prototype.combine__I__I__I = (function(x, y) {
  return ((x + y) | 0);
});
$c_Lcats_kernel_instances_IntGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__I__I__I($uI(x), $uI(y));
});
$c_Lcats_kernel_instances_IntGroup.prototype.empty__O = (function() {
  return 0;
});
var $d_Lcats_kernel_instances_IntGroup = new $TypeData().initClass($c_Lcats_kernel_instances_IntGroup, "cats.kernel.instances.IntGroup", ({
  Lcats_kernel_instances_IntGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_LongGroup() {
}
$c_Lcats_kernel_instances_LongGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_LongGroup.prototype.constructor = $c_Lcats_kernel_instances_LongGroup;
/** @constructor */
function $h_Lcats_kernel_instances_LongGroup() {
}
$h_Lcats_kernel_instances_LongGroup.prototype = $c_Lcats_kernel_instances_LongGroup.prototype;
$c_Lcats_kernel_instances_LongGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_LongGroup.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAllOption__sc_IterableOnce__s_Option(this, as);
});
$c_Lcats_kernel_instances_LongGroup.prototype.combine__J__J__J = (function(x, y) {
  var alo = x.RTLong__f_lo;
  var ahi = x.RTLong__f_hi;
  var bhi = y.RTLong__f_hi;
  var lo = ((alo + y.RTLong__f_lo) | 0);
  var hi = ((((-2147483648) ^ lo) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + bhi) | 0)) | 0) : ((ahi + bhi) | 0));
  return new $c_RTLong(lo, hi);
});
$c_Lcats_kernel_instances_LongGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__J__J__J($uJ(x), $uJ(y));
});
$c_Lcats_kernel_instances_LongGroup.prototype.empty__O = (function() {
  return $L0;
});
var $d_Lcats_kernel_instances_LongGroup = new $TypeData().initClass($c_Lcats_kernel_instances_LongGroup, "cats.kernel.instances.LongGroup", ({
  Lcats_kernel_instances_LongGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_ShortGroup() {
}
$c_Lcats_kernel_instances_ShortGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_ShortGroup.prototype.constructor = $c_Lcats_kernel_instances_ShortGroup;
/** @constructor */
function $h_Lcats_kernel_instances_ShortGroup() {
}
$h_Lcats_kernel_instances_ShortGroup.prototype = $c_Lcats_kernel_instances_ShortGroup.prototype;
$c_Lcats_kernel_instances_ShortGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_ShortGroup.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAllOption__sc_IterableOnce__s_Option(this, as);
});
$c_Lcats_kernel_instances_ShortGroup.prototype.combine__S__S__S = (function(x, y) {
  return ((((x + y) | 0) << 16) >> 16);
});
$c_Lcats_kernel_instances_ShortGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__S__S__S($uS(x), $uS(y));
});
$c_Lcats_kernel_instances_ShortGroup.prototype.empty__O = (function() {
  return 0;
});
var $d_Lcats_kernel_instances_ShortGroup = new $TypeData().initClass($c_Lcats_kernel_instances_ShortGroup, "cats.kernel.instances.ShortGroup", ({
  Lcats_kernel_instances_ShortGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_StringOrder() {
}
$c_Lcats_kernel_instances_StringOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_StringOrder.prototype.constructor = $c_Lcats_kernel_instances_StringOrder;
/** @constructor */
function $h_Lcats_kernel_instances_StringOrder() {
}
$h_Lcats_kernel_instances_StringOrder.prototype = $c_Lcats_kernel_instances_StringOrder.prototype;
$c_Lcats_kernel_instances_StringOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_StringOrder.prototype.max__O__O__O = (function(x, y) {
  return $f_Lcats_kernel_Order__max__O__O__O(this, x, y);
});
$c_Lcats_kernel_instances_StringOrder.prototype.gt__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__gt__O__O__Z(this, x, y);
});
$c_Lcats_kernel_instances_StringOrder.prototype.toOrdering__s_math_Ordering = (function() {
  return new $c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_instances_StringOrder.prototype.eqv__T__T__Z = (function(x, y) {
  return (x === y);
});
$c_Lcats_kernel_instances_StringOrder.prototype.compare__T__T__I = (function(x, y) {
  return ((x === y) ? 0 : $f_T__compareTo__T__I($n(x), y));
});
$c_Lcats_kernel_instances_StringOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_T(x);
  return $f_T__hashCode__I($n(x$1));
});
$c_Lcats_kernel_instances_StringOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__T__T__Z($as_T(x), $as_T(y));
});
$c_Lcats_kernel_instances_StringOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__T__T__I($as_T(x), $as_T(y));
});
var $d_Lcats_kernel_instances_StringOrder = new $TypeData().initClass($c_Lcats_kernel_instances_StringOrder, "cats.kernel.instances.StringOrder", ({
  Lcats_kernel_instances_StringOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_instances_StringLowerBounded: 1
}));
function $as_Lfs2_Pull$Acquire(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Acquire"));
}
function $isArrayOf_Lfs2_Pull$Acquire(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Acquire)));
}
function $asArrayOf_Lfs2_Pull$Acquire(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Acquire(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Acquire;", depth));
}
/** @constructor */
function $c_Lfs2_Pull$Eval(value) {
  this.Lfs2_Pull$Eval__f_value = null;
  this.Lfs2_Pull$Eval__f_value = value;
}
$c_Lfs2_Pull$Eval.prototype = new $h_Lfs2_Pull$AlgEffect();
$c_Lfs2_Pull$Eval.prototype.constructor = $c_Lfs2_Pull$Eval;
/** @constructor */
function $h_Lfs2_Pull$Eval() {
}
$h_Lfs2_Pull$Eval.prototype = $c_Lfs2_Pull$Eval.prototype;
$c_Lfs2_Pull$Eval.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$Eval.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lfs2_Pull$Eval.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$Eval)) {
    var x$0$2 = $as_Lfs2_Pull$Eval(x$0);
    var x = this.Lfs2_Pull$Eval__f_value;
    var y = $n(x$0$2).Lfs2_Pull$Eval__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lfs2_Pull$Eval.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$Eval.prototype.productArity__I = (function() {
  return 1;
});
$c_Lfs2_Pull$Eval.prototype.productPrefix__T = (function() {
  return "Eval";
});
$c_Lfs2_Pull$Eval.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Eval__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lfs2_Pull$Eval(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Eval) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Eval"));
}
function $isArrayOf_Lfs2_Pull$Eval(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Eval)));
}
function $asArrayOf_Lfs2_Pull$Eval(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Eval(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Eval;", depth));
}
var $d_Lfs2_Pull$Eval = new $TypeData().initClass($c_Lfs2_Pull$Eval, "fs2.Pull$Eval", ({
  Lfs2_Pull$Eval: 1,
  Lfs2_Pull$AlgEffect: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $as_Lfs2_Pull$GetScope(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$GetScope"));
}
function $isArrayOf_Lfs2_Pull$GetScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$GetScope)));
}
function $asArrayOf_Lfs2_Pull$GetScope(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$GetScope(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$GetScope;", depth));
}
function $as_Lfs2_Pull$InterruptWhen(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$InterruptWhen"));
}
function $isArrayOf_Lfs2_Pull$InterruptWhen(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$InterruptWhen)));
}
function $asArrayOf_Lfs2_Pull$InterruptWhen(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$InterruptWhen(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$InterruptWhen;", depth));
}
class $c_Lfs2_internal_AcquireAfterScopeClosed$ extends $c_jl_Throwable {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  productIterator__sc_Iterator() {
    return new $c_s_Product$$anon$1(this);
  }
  hashCode__I() {
    return (-998855110);
  }
  productArity__I() {
    return 0;
  }
  productPrefix__T() {
    return "AcquireAfterScopeClosed";
  }
  productElement__I__O(n) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  fillInStackTrace__jl_Throwable() {
    return this;
  }
}
var $d_Lfs2_internal_AcquireAfterScopeClosed$ = new $TypeData().initClass($c_Lfs2_internal_AcquireAfterScopeClosed$, "fs2.internal.AcquireAfterScopeClosed$", ({
  Lfs2_internal_AcquireAfterScopeClosed$: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lfs2_internal_AcquireAfterScopeClosed$;
function $m_Lfs2_internal_AcquireAfterScopeClosed$() {
  if ((!$n_Lfs2_internal_AcquireAfterScopeClosed$)) {
    $n_Lfs2_internal_AcquireAfterScopeClosed$ = new $c_Lfs2_internal_AcquireAfterScopeClosed$();
  }
  return $n_Lfs2_internal_AcquireAfterScopeClosed$;
}
function $p_jl_JSConsoleBasedPrintStream__doWriteLine__T__V($thiz, line) {
  if (($as_T((typeof console)) !== "undefined")) {
    if (($thiz.jl_JSConsoleBasedPrintStream__f_isErr && $uZ((!(!console.error))))) {
      console.error(line);
    } else {
      console.log(line);
    }
  }
}
/** @constructor */
function $c_jl_JSConsoleBasedPrintStream(isErr) {
  this.Ljava_io_FilterOutputStream__f_out = null;
  this.Ljava_io_PrintStream__f_encoder = null;
  this.Ljava_io_PrintStream__f_autoFlush = false;
  this.Ljava_io_PrintStream__f_charset = null;
  this.Ljava_io_PrintStream__f_java$io$PrintStream$$closed = false;
  this.Ljava_io_PrintStream__f_bitmap$0 = false;
  this.jl_JSConsoleBasedPrintStream__f_isErr = false;
  this.jl_JSConsoleBasedPrintStream__f_flushed = false;
  this.jl_JSConsoleBasedPrintStream__f_buffer = null;
  this.jl_JSConsoleBasedPrintStream__f_isErr = isErr;
  var out = new $c_jl_JSConsoleBasedPrintStream$DummyOutputStream();
  $ct_Ljava_io_PrintStream__Ljava_io_OutputStream__Z__Ljava_nio_charset_Charset__(this, out, false, null);
  this.jl_JSConsoleBasedPrintStream__f_flushed = true;
  this.jl_JSConsoleBasedPrintStream__f_buffer = "";
}
$c_jl_JSConsoleBasedPrintStream.prototype = new $h_Ljava_io_PrintStream();
$c_jl_JSConsoleBasedPrintStream.prototype.constructor = $c_jl_JSConsoleBasedPrintStream;
/** @constructor */
function $h_jl_JSConsoleBasedPrintStream() {
}
$h_jl_JSConsoleBasedPrintStream.prototype = $c_jl_JSConsoleBasedPrintStream.prototype;
$c_jl_JSConsoleBasedPrintStream.prototype.write__I__V = (function(b) {
  this.write__AB__I__I__V(new $ac_B(new Int8Array([((b << 24) >> 24)])), 0, 1);
});
$c_jl_JSConsoleBasedPrintStream.prototype.write__AB__I__I__V = (function(buf, off, len) {
  if ((((off < 0) || (len < 0)) || (len > (($n(buf).u.length - off) | 0)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  var i = 0;
  while ((i < len)) {
    this.print__C__V((65535 & (255 & $n(buf).get(((i + off) | 0)))));
    i = ((1 + i) | 0);
  }
});
$c_jl_JSConsoleBasedPrintStream.prototype.print__C__V = (function(c) {
  this.java$lang$JSConsoleBasedPrintStream$$printString__T__V(("" + $cToS(c)));
});
$c_jl_JSConsoleBasedPrintStream.prototype.print__T__V = (function(s) {
  this.java$lang$JSConsoleBasedPrintStream$$printString__T__V(((s === null) ? "null" : s));
});
$c_jl_JSConsoleBasedPrintStream.prototype.print__O__V = (function(obj) {
  this.java$lang$JSConsoleBasedPrintStream$$printString__T__V(("" + obj));
});
$c_jl_JSConsoleBasedPrintStream.prototype.println__V = (function() {
  this.java$lang$JSConsoleBasedPrintStream$$printString__T__V("\n");
});
$c_jl_JSConsoleBasedPrintStream.prototype.println__O__V = (function(obj) {
  this.java$lang$JSConsoleBasedPrintStream$$printString__T__V((obj + "\n"));
});
$c_jl_JSConsoleBasedPrintStream.prototype.java$lang$JSConsoleBasedPrintStream$$printString__T__V = (function(s) {
  var rest = s;
  while ((rest !== "")) {
    var this$1 = $n(rest);
    var nlPos = $uI(this$1.indexOf("\n"));
    if ((nlPos < 0)) {
      this.jl_JSConsoleBasedPrintStream__f_buffer = (("" + this.jl_JSConsoleBasedPrintStream__f_buffer) + rest);
      this.jl_JSConsoleBasedPrintStream__f_flushed = false;
      rest = "";
    } else {
      var $x_1 = this.jl_JSConsoleBasedPrintStream__f_buffer;
      var this$2 = $n(rest);
      if ((nlPos > this$2.length)) {
        $charAt(this$2, nlPos);
      }
      if ((nlPos < 0)) {
        $charAt(this$2, (-1));
      }
      $p_jl_JSConsoleBasedPrintStream__doWriteLine__T__V(this, (("" + $x_1) + $as_T(this$2.substring(0, nlPos))));
      this.jl_JSConsoleBasedPrintStream__f_buffer = "";
      this.jl_JSConsoleBasedPrintStream__f_flushed = true;
      var this$3 = $n(rest);
      var beginIndex = ((1 + nlPos) | 0);
      if (((beginIndex < 0) || (beginIndex > this$3.length))) {
        $charAt(this$3, beginIndex);
      }
      rest = $as_T(this$3.substring(beginIndex));
    }
  }
});
$c_jl_JSConsoleBasedPrintStream.prototype.flush__V = (function() {
  if ((!this.jl_JSConsoleBasedPrintStream__f_flushed)) {
    $p_jl_JSConsoleBasedPrintStream__doWriteLine__T__V(this, (this.jl_JSConsoleBasedPrintStream__f_buffer + "\u21a9"));
    this.jl_JSConsoleBasedPrintStream__f_buffer = "\u21aa";
    this.jl_JSConsoleBasedPrintStream__f_flushed = true;
  }
});
var $d_jl_JSConsoleBasedPrintStream = new $TypeData().initClass($c_jl_JSConsoleBasedPrintStream, "java.lang.JSConsoleBasedPrintStream", ({
  jl_JSConsoleBasedPrintStream: 1,
  Ljava_io_PrintStream: 1,
  Ljava_io_FilterOutputStream: 1,
  Ljava_io_OutputStream: 1,
  Ljava_io_Closeable: 1,
  jl_AutoCloseable: 1,
  Ljava_io_Flushable: 1,
  jl_Appendable: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_AttributeKey$Positional$() {
  this.Llaika_api_bundle_AttributeKey$Positional$__f_key = null;
  this.Llaika_api_bundle_AttributeKey$Positional$__f_key = "__$$:positional:$$__";
}
$c_Llaika_api_bundle_AttributeKey$Positional$.prototype = new $h_Llaika_api_bundle_AttributeKey();
$c_Llaika_api_bundle_AttributeKey$Positional$.prototype.constructor = $c_Llaika_api_bundle_AttributeKey$Positional$;
/** @constructor */
function $h_Llaika_api_bundle_AttributeKey$Positional$() {
}
$h_Llaika_api_bundle_AttributeKey$Positional$.prototype = $c_Llaika_api_bundle_AttributeKey$Positional$.prototype;
$c_Llaika_api_bundle_AttributeKey$Positional$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_bundle_AttributeKey$Positional$.prototype.hashCode__I = (function() {
  return (-920462540);
});
$c_Llaika_api_bundle_AttributeKey$Positional$.prototype.toString__T = (function() {
  return "Positional";
});
$c_Llaika_api_bundle_AttributeKey$Positional$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_api_bundle_AttributeKey$Positional$.prototype.productPrefix__T = (function() {
  return "Positional";
});
$c_Llaika_api_bundle_AttributeKey$Positional$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_api_bundle_AttributeKey$Positional$.prototype.key__T = (function() {
  return "__$$:positional:$$__";
});
$c_Llaika_api_bundle_AttributeKey$Positional$.prototype.desc__T = (function() {
  return "positional attributes";
});
var $d_Llaika_api_bundle_AttributeKey$Positional$ = new $TypeData().initClass($c_Llaika_api_bundle_AttributeKey$Positional$, "laika.api.bundle.AttributeKey$Positional$", ({
  Llaika_api_bundle_AttributeKey$Positional$: 1,
  Llaika_api_bundle_AttributeKey: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_api_bundle_AttributeKey$Positional$;
function $m_Llaika_api_bundle_AttributeKey$Positional$() {
  if ((!$n_Llaika_api_bundle_AttributeKey$Positional$)) {
    $n_Llaika_api_bundle_AttributeKey$Positional$ = new $c_Llaika_api_bundle_AttributeKey$Positional$();
  }
  return $n_Llaika_api_bundle_AttributeKey$Positional$;
}
/** @constructor */
function $c_Llaika_api_bundle_BlockPosition$Any$() {
}
$c_Llaika_api_bundle_BlockPosition$Any$.prototype = new $h_O();
$c_Llaika_api_bundle_BlockPosition$Any$.prototype.constructor = $c_Llaika_api_bundle_BlockPosition$Any$;
/** @constructor */
function $h_Llaika_api_bundle_BlockPosition$Any$() {
}
$h_Llaika_api_bundle_BlockPosition$Any$.prototype = $c_Llaika_api_bundle_BlockPosition$Any$.prototype;
$c_Llaika_api_bundle_BlockPosition$Any$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_bundle_BlockPosition$Any$.prototype.hashCode__I = (function() {
  return 65996;
});
$c_Llaika_api_bundle_BlockPosition$Any$.prototype.toString__T = (function() {
  return "Any";
});
$c_Llaika_api_bundle_BlockPosition$Any$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_api_bundle_BlockPosition$Any$.prototype.productPrefix__T = (function() {
  return "Any";
});
$c_Llaika_api_bundle_BlockPosition$Any$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_api_bundle_BlockPosition$Any$ = new $TypeData().initClass($c_Llaika_api_bundle_BlockPosition$Any$, "laika.api.bundle.BlockPosition$Any$", ({
  Llaika_api_bundle_BlockPosition$Any$: 1,
  Llaika_api_bundle_BlockPosition: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_api_bundle_BlockPosition$Any$;
function $m_Llaika_api_bundle_BlockPosition$Any$() {
  if ((!$n_Llaika_api_bundle_BlockPosition$Any$)) {
    $n_Llaika_api_bundle_BlockPosition$Any$ = new $c_Llaika_api_bundle_BlockPosition$Any$();
  }
  return $n_Llaika_api_bundle_BlockPosition$Any$;
}
/** @constructor */
function $c_Llaika_api_bundle_BlockPosition$NestedOnly$() {
}
$c_Llaika_api_bundle_BlockPosition$NestedOnly$.prototype = new $h_O();
$c_Llaika_api_bundle_BlockPosition$NestedOnly$.prototype.constructor = $c_Llaika_api_bundle_BlockPosition$NestedOnly$;
/** @constructor */
function $h_Llaika_api_bundle_BlockPosition$NestedOnly$() {
}
$h_Llaika_api_bundle_BlockPosition$NestedOnly$.prototype = $c_Llaika_api_bundle_BlockPosition$NestedOnly$.prototype;
$c_Llaika_api_bundle_BlockPosition$NestedOnly$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_bundle_BlockPosition$NestedOnly$.prototype.hashCode__I = (function() {
  return 1104837987;
});
$c_Llaika_api_bundle_BlockPosition$NestedOnly$.prototype.toString__T = (function() {
  return "NestedOnly";
});
$c_Llaika_api_bundle_BlockPosition$NestedOnly$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_api_bundle_BlockPosition$NestedOnly$.prototype.productPrefix__T = (function() {
  return "NestedOnly";
});
$c_Llaika_api_bundle_BlockPosition$NestedOnly$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_api_bundle_BlockPosition$NestedOnly$ = new $TypeData().initClass($c_Llaika_api_bundle_BlockPosition$NestedOnly$, "laika.api.bundle.BlockPosition$NestedOnly$", ({
  Llaika_api_bundle_BlockPosition$NestedOnly$: 1,
  Llaika_api_bundle_BlockPosition: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_api_bundle_BlockPosition$NestedOnly$;
function $m_Llaika_api_bundle_BlockPosition$NestedOnly$() {
  if ((!$n_Llaika_api_bundle_BlockPosition$NestedOnly$)) {
    $n_Llaika_api_bundle_BlockPosition$NestedOnly$ = new $c_Llaika_api_bundle_BlockPosition$NestedOnly$();
  }
  return $n_Llaika_api_bundle_BlockPosition$NestedOnly$;
}
/** @constructor */
function $c_Llaika_api_bundle_BlockPosition$RootOnly$() {
}
$c_Llaika_api_bundle_BlockPosition$RootOnly$.prototype = new $h_O();
$c_Llaika_api_bundle_BlockPosition$RootOnly$.prototype.constructor = $c_Llaika_api_bundle_BlockPosition$RootOnly$;
/** @constructor */
function $h_Llaika_api_bundle_BlockPosition$RootOnly$() {
}
$h_Llaika_api_bundle_BlockPosition$RootOnly$.prototype = $c_Llaika_api_bundle_BlockPosition$RootOnly$.prototype;
$c_Llaika_api_bundle_BlockPosition$RootOnly$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_bundle_BlockPosition$RootOnly$.prototype.hashCode__I = (function() {
  return (-102352946);
});
$c_Llaika_api_bundle_BlockPosition$RootOnly$.prototype.toString__T = (function() {
  return "RootOnly";
});
$c_Llaika_api_bundle_BlockPosition$RootOnly$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_api_bundle_BlockPosition$RootOnly$.prototype.productPrefix__T = (function() {
  return "RootOnly";
});
$c_Llaika_api_bundle_BlockPosition$RootOnly$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_api_bundle_BlockPosition$RootOnly$ = new $TypeData().initClass($c_Llaika_api_bundle_BlockPosition$RootOnly$, "laika.api.bundle.BlockPosition$RootOnly$", ({
  Llaika_api_bundle_BlockPosition$RootOnly$: 1,
  Llaika_api_bundle_BlockPosition: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_api_bundle_BlockPosition$RootOnly$;
function $m_Llaika_api_bundle_BlockPosition$RootOnly$() {
  if ((!$n_Llaika_api_bundle_BlockPosition$RootOnly$)) {
    $n_Llaika_api_bundle_BlockPosition$RootOnly$ = new $c_Llaika_api_bundle_BlockPosition$RootOnly$();
  }
  return $n_Llaika_api_bundle_BlockPosition$RootOnly$;
}
/** @constructor */
function $c_Llaika_api_bundle_BundleOrigin$Library$() {
}
$c_Llaika_api_bundle_BundleOrigin$Library$.prototype = new $h_O();
$c_Llaika_api_bundle_BundleOrigin$Library$.prototype.constructor = $c_Llaika_api_bundle_BundleOrigin$Library$;
/** @constructor */
function $h_Llaika_api_bundle_BundleOrigin$Library$() {
}
$h_Llaika_api_bundle_BundleOrigin$Library$.prototype = $c_Llaika_api_bundle_BundleOrigin$Library$.prototype;
$c_Llaika_api_bundle_BundleOrigin$Library$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_bundle_BundleOrigin$Library$.prototype.hashCode__I = (function() {
  return 1830861979;
});
$c_Llaika_api_bundle_BundleOrigin$Library$.prototype.toString__T = (function() {
  return "Library";
});
$c_Llaika_api_bundle_BundleOrigin$Library$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_api_bundle_BundleOrigin$Library$.prototype.productPrefix__T = (function() {
  return "Library";
});
$c_Llaika_api_bundle_BundleOrigin$Library$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_api_bundle_BundleOrigin$Library$ = new $TypeData().initClass($c_Llaika_api_bundle_BundleOrigin$Library$, "laika.api.bundle.BundleOrigin$Library$", ({
  Llaika_api_bundle_BundleOrigin$Library$: 1,
  Llaika_api_bundle_BundleOrigin: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_api_bundle_BundleOrigin$Library$;
function $m_Llaika_api_bundle_BundleOrigin$Library$() {
  if ((!$n_Llaika_api_bundle_BundleOrigin$Library$)) {
    $n_Llaika_api_bundle_BundleOrigin$Library$ = new $c_Llaika_api_bundle_BundleOrigin$Library$();
  }
  return $n_Llaika_api_bundle_BundleOrigin$Library$;
}
/** @constructor */
function $c_Llaika_api_bundle_BundleOrigin$Mixed$() {
}
$c_Llaika_api_bundle_BundleOrigin$Mixed$.prototype = new $h_O();
$c_Llaika_api_bundle_BundleOrigin$Mixed$.prototype.constructor = $c_Llaika_api_bundle_BundleOrigin$Mixed$;
/** @constructor */
function $h_Llaika_api_bundle_BundleOrigin$Mixed$() {
}
$h_Llaika_api_bundle_BundleOrigin$Mixed$.prototype = $c_Llaika_api_bundle_BundleOrigin$Mixed$.prototype;
$c_Llaika_api_bundle_BundleOrigin$Mixed$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_bundle_BundleOrigin$Mixed$.prototype.hashCode__I = (function() {
  return 74357723;
});
$c_Llaika_api_bundle_BundleOrigin$Mixed$.prototype.toString__T = (function() {
  return "Mixed";
});
$c_Llaika_api_bundle_BundleOrigin$Mixed$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_api_bundle_BundleOrigin$Mixed$.prototype.productPrefix__T = (function() {
  return "Mixed";
});
$c_Llaika_api_bundle_BundleOrigin$Mixed$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_api_bundle_BundleOrigin$Mixed$ = new $TypeData().initClass($c_Llaika_api_bundle_BundleOrigin$Mixed$, "laika.api.bundle.BundleOrigin$Mixed$", ({
  Llaika_api_bundle_BundleOrigin$Mixed$: 1,
  Llaika_api_bundle_BundleOrigin: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_api_bundle_BundleOrigin$Mixed$;
function $m_Llaika_api_bundle_BundleOrigin$Mixed$() {
  if ((!$n_Llaika_api_bundle_BundleOrigin$Mixed$)) {
    $n_Llaika_api_bundle_BundleOrigin$Mixed$ = new $c_Llaika_api_bundle_BundleOrigin$Mixed$();
  }
  return $n_Llaika_api_bundle_BundleOrigin$Mixed$;
}
/** @constructor */
function $c_Llaika_api_bundle_BundleOrigin$Parser$() {
}
$c_Llaika_api_bundle_BundleOrigin$Parser$.prototype = new $h_O();
$c_Llaika_api_bundle_BundleOrigin$Parser$.prototype.constructor = $c_Llaika_api_bundle_BundleOrigin$Parser$;
/** @constructor */
function $h_Llaika_api_bundle_BundleOrigin$Parser$() {
}
$h_Llaika_api_bundle_BundleOrigin$Parser$.prototype = $c_Llaika_api_bundle_BundleOrigin$Parser$.prototype;
$c_Llaika_api_bundle_BundleOrigin$Parser$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_bundle_BundleOrigin$Parser$.prototype.hashCode__I = (function() {
  return (-1911543745);
});
$c_Llaika_api_bundle_BundleOrigin$Parser$.prototype.toString__T = (function() {
  return "Parser";
});
$c_Llaika_api_bundle_BundleOrigin$Parser$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_api_bundle_BundleOrigin$Parser$.prototype.productPrefix__T = (function() {
  return "Parser";
});
$c_Llaika_api_bundle_BundleOrigin$Parser$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_api_bundle_BundleOrigin$Parser$ = new $TypeData().initClass($c_Llaika_api_bundle_BundleOrigin$Parser$, "laika.api.bundle.BundleOrigin$Parser$", ({
  Llaika_api_bundle_BundleOrigin$Parser$: 1,
  Llaika_api_bundle_BundleOrigin: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_api_bundle_BundleOrigin$Parser$;
function $m_Llaika_api_bundle_BundleOrigin$Parser$() {
  if ((!$n_Llaika_api_bundle_BundleOrigin$Parser$)) {
    $n_Llaika_api_bundle_BundleOrigin$Parser$ = new $c_Llaika_api_bundle_BundleOrigin$Parser$();
  }
  return $n_Llaika_api_bundle_BundleOrigin$Parser$;
}
/** @constructor */
function $c_Llaika_api_bundle_BundleOrigin$Theme$() {
}
$c_Llaika_api_bundle_BundleOrigin$Theme$.prototype = new $h_O();
$c_Llaika_api_bundle_BundleOrigin$Theme$.prototype.constructor = $c_Llaika_api_bundle_BundleOrigin$Theme$;
/** @constructor */
function $h_Llaika_api_bundle_BundleOrigin$Theme$() {
}
$h_Llaika_api_bundle_BundleOrigin$Theme$.prototype = $c_Llaika_api_bundle_BundleOrigin$Theme$.prototype;
$c_Llaika_api_bundle_BundleOrigin$Theme$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_bundle_BundleOrigin$Theme$.prototype.hashCode__I = (function() {
  return 80774569;
});
$c_Llaika_api_bundle_BundleOrigin$Theme$.prototype.toString__T = (function() {
  return "Theme";
});
$c_Llaika_api_bundle_BundleOrigin$Theme$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_api_bundle_BundleOrigin$Theme$.prototype.productPrefix__T = (function() {
  return "Theme";
});
$c_Llaika_api_bundle_BundleOrigin$Theme$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_api_bundle_BundleOrigin$Theme$ = new $TypeData().initClass($c_Llaika_api_bundle_BundleOrigin$Theme$, "laika.api.bundle.BundleOrigin$Theme$", ({
  Llaika_api_bundle_BundleOrigin$Theme$: 1,
  Llaika_api_bundle_BundleOrigin: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_api_bundle_BundleOrigin$Theme$;
function $m_Llaika_api_bundle_BundleOrigin$Theme$() {
  if ((!$n_Llaika_api_bundle_BundleOrigin$Theme$)) {
    $n_Llaika_api_bundle_BundleOrigin$Theme$ = new $c_Llaika_api_bundle_BundleOrigin$Theme$();
  }
  return $n_Llaika_api_bundle_BundleOrigin$Theme$;
}
/** @constructor */
function $c_Llaika_api_bundle_BundleOrigin$User$() {
}
$c_Llaika_api_bundle_BundleOrigin$User$.prototype = new $h_O();
$c_Llaika_api_bundle_BundleOrigin$User$.prototype.constructor = $c_Llaika_api_bundle_BundleOrigin$User$;
/** @constructor */
function $h_Llaika_api_bundle_BundleOrigin$User$() {
}
$h_Llaika_api_bundle_BundleOrigin$User$.prototype = $c_Llaika_api_bundle_BundleOrigin$User$.prototype;
$c_Llaika_api_bundle_BundleOrigin$User$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_bundle_BundleOrigin$User$.prototype.hashCode__I = (function() {
  return 2645995;
});
$c_Llaika_api_bundle_BundleOrigin$User$.prototype.toString__T = (function() {
  return "User";
});
$c_Llaika_api_bundle_BundleOrigin$User$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_api_bundle_BundleOrigin$User$.prototype.productPrefix__T = (function() {
  return "User";
});
$c_Llaika_api_bundle_BundleOrigin$User$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_api_bundle_BundleOrigin$User$ = new $TypeData().initClass($c_Llaika_api_bundle_BundleOrigin$User$, "laika.api.bundle.BundleOrigin$User$", ({
  Llaika_api_bundle_BundleOrigin$User$: 1,
  Llaika_api_bundle_BundleOrigin: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_api_bundle_BundleOrigin$User$;
function $m_Llaika_api_bundle_BundleOrigin$User$() {
  if ((!$n_Llaika_api_bundle_BundleOrigin$User$)) {
    $n_Llaika_api_bundle_BundleOrigin$User$ = new $c_Llaika_api_bundle_BundleOrigin$User$();
  }
  return $n_Llaika_api_bundle_BundleOrigin$User$;
}
/** @constructor */
function $c_Llaika_api_config_Origin$DirectiveScope$() {
}
$c_Llaika_api_config_Origin$DirectiveScope$.prototype = new $h_O();
$c_Llaika_api_config_Origin$DirectiveScope$.prototype.constructor = $c_Llaika_api_config_Origin$DirectiveScope$;
/** @constructor */
function $h_Llaika_api_config_Origin$DirectiveScope$() {
}
$h_Llaika_api_config_Origin$DirectiveScope$.prototype = $c_Llaika_api_config_Origin$DirectiveScope$.prototype;
$c_Llaika_api_config_Origin$DirectiveScope$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_Origin$DirectiveScope$.prototype.hashCode__I = (function() {
  return 1408953189;
});
$c_Llaika_api_config_Origin$DirectiveScope$.prototype.toString__T = (function() {
  return "DirectiveScope";
});
$c_Llaika_api_config_Origin$DirectiveScope$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_api_config_Origin$DirectiveScope$.prototype.productPrefix__T = (function() {
  return "DirectiveScope";
});
$c_Llaika_api_config_Origin$DirectiveScope$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_api_config_Origin$DirectiveScope$ = new $TypeData().initClass($c_Llaika_api_config_Origin$DirectiveScope$, "laika.api.config.Origin$DirectiveScope$", ({
  Llaika_api_config_Origin$DirectiveScope$: 1,
  Llaika_api_config_Origin$Scope: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_api_config_Origin$DirectiveScope$;
function $m_Llaika_api_config_Origin$DirectiveScope$() {
  if ((!$n_Llaika_api_config_Origin$DirectiveScope$)) {
    $n_Llaika_api_config_Origin$DirectiveScope$ = new $c_Llaika_api_config_Origin$DirectiveScope$();
  }
  return $n_Llaika_api_config_Origin$DirectiveScope$;
}
/** @constructor */
function $c_Llaika_api_config_Origin$DocumentScope$() {
}
$c_Llaika_api_config_Origin$DocumentScope$.prototype = new $h_O();
$c_Llaika_api_config_Origin$DocumentScope$.prototype.constructor = $c_Llaika_api_config_Origin$DocumentScope$;
/** @constructor */
function $h_Llaika_api_config_Origin$DocumentScope$() {
}
$h_Llaika_api_config_Origin$DocumentScope$.prototype = $c_Llaika_api_config_Origin$DocumentScope$.prototype;
$c_Llaika_api_config_Origin$DocumentScope$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_Origin$DocumentScope$.prototype.hashCode__I = (function() {
  return (-1922030119);
});
$c_Llaika_api_config_Origin$DocumentScope$.prototype.toString__T = (function() {
  return "DocumentScope";
});
$c_Llaika_api_config_Origin$DocumentScope$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_api_config_Origin$DocumentScope$.prototype.productPrefix__T = (function() {
  return "DocumentScope";
});
$c_Llaika_api_config_Origin$DocumentScope$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_api_config_Origin$DocumentScope$ = new $TypeData().initClass($c_Llaika_api_config_Origin$DocumentScope$, "laika.api.config.Origin$DocumentScope$", ({
  Llaika_api_config_Origin$DocumentScope$: 1,
  Llaika_api_config_Origin$Scope: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_api_config_Origin$DocumentScope$;
function $m_Llaika_api_config_Origin$DocumentScope$() {
  if ((!$n_Llaika_api_config_Origin$DocumentScope$)) {
    $n_Llaika_api_config_Origin$DocumentScope$ = new $c_Llaika_api_config_Origin$DocumentScope$();
  }
  return $n_Llaika_api_config_Origin$DocumentScope$;
}
/** @constructor */
function $c_Llaika_api_config_Origin$GlobalScope$() {
}
$c_Llaika_api_config_Origin$GlobalScope$.prototype = new $h_O();
$c_Llaika_api_config_Origin$GlobalScope$.prototype.constructor = $c_Llaika_api_config_Origin$GlobalScope$;
/** @constructor */
function $h_Llaika_api_config_Origin$GlobalScope$() {
}
$h_Llaika_api_config_Origin$GlobalScope$.prototype = $c_Llaika_api_config_Origin$GlobalScope$.prototype;
$c_Llaika_api_config_Origin$GlobalScope$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_Origin$GlobalScope$.prototype.hashCode__I = (function() {
  return 814792785;
});
$c_Llaika_api_config_Origin$GlobalScope$.prototype.toString__T = (function() {
  return "GlobalScope";
});
$c_Llaika_api_config_Origin$GlobalScope$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_api_config_Origin$GlobalScope$.prototype.productPrefix__T = (function() {
  return "GlobalScope";
});
$c_Llaika_api_config_Origin$GlobalScope$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_api_config_Origin$GlobalScope$ = new $TypeData().initClass($c_Llaika_api_config_Origin$GlobalScope$, "laika.api.config.Origin$GlobalScope$", ({
  Llaika_api_config_Origin$GlobalScope$: 1,
  Llaika_api_config_Origin$Scope: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_api_config_Origin$GlobalScope$;
function $m_Llaika_api_config_Origin$GlobalScope$() {
  if ((!$n_Llaika_api_config_Origin$GlobalScope$)) {
    $n_Llaika_api_config_Origin$GlobalScope$ = new $c_Llaika_api_config_Origin$GlobalScope$();
  }
  return $n_Llaika_api_config_Origin$GlobalScope$;
}
/** @constructor */
function $c_Llaika_api_config_Origin$TreeScope$() {
}
$c_Llaika_api_config_Origin$TreeScope$.prototype = new $h_O();
$c_Llaika_api_config_Origin$TreeScope$.prototype.constructor = $c_Llaika_api_config_Origin$TreeScope$;
/** @constructor */
function $h_Llaika_api_config_Origin$TreeScope$() {
}
$h_Llaika_api_config_Origin$TreeScope$.prototype = $c_Llaika_api_config_Origin$TreeScope$.prototype;
$c_Llaika_api_config_Origin$TreeScope$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_Origin$TreeScope$.prototype.hashCode__I = (function() {
  return 2024377654;
});
$c_Llaika_api_config_Origin$TreeScope$.prototype.toString__T = (function() {
  return "TreeScope";
});
$c_Llaika_api_config_Origin$TreeScope$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_api_config_Origin$TreeScope$.prototype.productPrefix__T = (function() {
  return "TreeScope";
});
$c_Llaika_api_config_Origin$TreeScope$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_api_config_Origin$TreeScope$ = new $TypeData().initClass($c_Llaika_api_config_Origin$TreeScope$, "laika.api.config.Origin$TreeScope$", ({
  Llaika_api_config_Origin$TreeScope$: 1,
  Llaika_api_config_Origin$Scope: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_api_config_Origin$TreeScope$;
function $m_Llaika_api_config_Origin$TreeScope$() {
  if ((!$n_Llaika_api_config_Origin$TreeScope$)) {
    $n_Llaika_api_config_Origin$TreeScope$ = new $c_Llaika_api_config_Origin$TreeScope$();
  }
  return $n_Llaika_api_config_Origin$TreeScope$;
}
/** @constructor */
function $c_Llaika_ast_BlockScope(content, context, source, options) {
  this.Llaika_ast_BlockScope__f_content = null;
  this.Llaika_ast_BlockScope__f_context = null;
  this.Llaika_ast_BlockScope__f_source = null;
  this.Llaika_ast_BlockScope__f_options = null;
  this.Llaika_ast_BlockScope__f_unresolvedMessage$lzy1 = null;
  this.Llaika_ast_BlockScope__f_unresolvedMessagebitmap$1 = false;
  this.Llaika_ast_BlockScope__f_content = content;
  this.Llaika_ast_BlockScope__f_context = context;
  this.Llaika_ast_BlockScope__f_source = source;
  this.Llaika_ast_BlockScope__f_options = options;
}
$c_Llaika_ast_BlockScope.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_BlockScope.prototype.constructor = $c_Llaika_ast_BlockScope;
/** @constructor */
function $h_Llaika_ast_BlockScope() {
}
$h_Llaika_ast_BlockScope.prototype = $c_Llaika_ast_BlockScope.prototype;
$c_Llaika_ast_BlockScope.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_BlockScope.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_BlockScope)) {
    var x$0$2 = $as_Llaika_ast_BlockScope(x$0);
    var x = this.Llaika_ast_BlockScope__f_content;
    var x$2 = $n(x$0$2).Llaika_ast_BlockScope__f_content;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_BlockScope__f_context;
      var x$4 = $n(x$0$2).Llaika_ast_BlockScope__f_context;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.Llaika_ast_BlockScope__f_source;
      var x$6 = $n(x$0$2).Llaika_ast_BlockScope__f_source;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.Llaika_ast_BlockScope__f_options;
      var x$8 = $n(x$0$2).Llaika_ast_BlockScope__f_options;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_BlockScope.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_BlockScope.prototype.productArity__I = (function() {
  return 4;
});
$c_Llaika_ast_BlockScope.prototype.productPrefix__T = (function() {
  return "BlockScope";
});
$c_Llaika_ast_BlockScope.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_BlockScope__f_content;
      break;
    }
    case 1: {
      return this.Llaika_ast_BlockScope__f_context;
      break;
    }
    case 2: {
      return this.Llaika_ast_BlockScope__f_source;
      break;
    }
    case 3: {
      return this.Llaika_ast_BlockScope__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_BlockScope.prototype.context__Llaika_api_config_ConfigValue = (function() {
  return this.Llaika_ast_BlockScope__f_context;
});
$c_Llaika_ast_BlockScope.prototype.source__Llaika_parse_SourceFragment = (function() {
  return this.Llaika_ast_BlockScope__f_source;
});
$c_Llaika_ast_BlockScope.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_BlockScope__f_options;
});
$c_Llaika_ast_BlockScope.prototype.unresolvedMessage__T = (function() {
  if ((!this.Llaika_ast_BlockScope__f_unresolvedMessagebitmap$1)) {
    this.Llaika_ast_BlockScope__f_unresolvedMessage$lzy1 = "Unresolved block scope";
    this.Llaika_ast_BlockScope__f_unresolvedMessagebitmap$1 = true;
  }
  return this.Llaika_ast_BlockScope__f_unresolvedMessage$lzy1;
});
$c_Llaika_ast_BlockScope.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_BlockScope__f_content;
  var context = this.Llaika_ast_BlockScope__f_context;
  var source = this.Llaika_ast_BlockScope__f_source;
  return new $c_Llaika_ast_BlockScope(content, context, source, options);
});
function $as_Llaika_ast_BlockScope(obj) {
  return (((obj instanceof $c_Llaika_ast_BlockScope) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.BlockScope"));
}
function $isArrayOf_Llaika_ast_BlockScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_BlockScope)));
}
function $asArrayOf_Llaika_ast_BlockScope(obj, depth) {
  return (($isArrayOf_Llaika_ast_BlockScope(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.BlockScope;", depth));
}
var $d_Llaika_ast_BlockScope = new $TypeData().initClass($c_Llaika_ast_BlockScope, "laika.ast.BlockScope", ({
  Llaika_ast_BlockScope: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Unresolved: 1,
  Llaika_ast_ElementScope: 1,
  Llaika_ast_Block: 1
}));
/** @constructor */
function $c_Llaika_ast_CitationLink(refId, label, options) {
  this.Llaika_ast_CitationLink__f_refId = null;
  this.Llaika_ast_CitationLink__f_label = null;
  this.Llaika_ast_CitationLink__f_options = null;
  this.Llaika_ast_CitationLink__f_refId = refId;
  this.Llaika_ast_CitationLink__f_label = label;
  this.Llaika_ast_CitationLink__f_options = options;
}
$c_Llaika_ast_CitationLink.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_CitationLink.prototype.constructor = $c_Llaika_ast_CitationLink;
/** @constructor */
function $h_Llaika_ast_CitationLink() {
}
$h_Llaika_ast_CitationLink.prototype = $c_Llaika_ast_CitationLink.prototype;
$c_Llaika_ast_CitationLink.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_CitationLink.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_CitationLink)) {
    var x$0$2 = $as_Llaika_ast_CitationLink(x$0);
    if (((this.Llaika_ast_CitationLink__f_refId === $n(x$0$2).Llaika_ast_CitationLink__f_refId) && (this.Llaika_ast_CitationLink__f_label === $n(x$0$2).Llaika_ast_CitationLink__f_label))) {
      var x = this.Llaika_ast_CitationLink__f_options;
      var x$2 = $n(x$0$2).Llaika_ast_CitationLink__f_options;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_CitationLink.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_CitationLink.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_CitationLink.prototype.productPrefix__T = (function() {
  return "CitationLink";
});
$c_Llaika_ast_CitationLink.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_CitationLink__f_refId;
      break;
    }
    case 1: {
      return this.Llaika_ast_CitationLink__f_label;
      break;
    }
    case 2: {
      return this.Llaika_ast_CitationLink__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_CitationLink.prototype.refId__T = (function() {
  return this.Llaika_ast_CitationLink__f_refId;
});
$c_Llaika_ast_CitationLink.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_CitationLink__f_options;
});
$c_Llaika_ast_CitationLink.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var refId = this.Llaika_ast_CitationLink__f_refId;
  var label = this.Llaika_ast_CitationLink__f_label;
  return new $c_Llaika_ast_CitationLink(refId, label, options);
});
function $as_Llaika_ast_CitationLink(obj) {
  return (((obj instanceof $c_Llaika_ast_CitationLink) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.CitationLink"));
}
function $isArrayOf_Llaika_ast_CitationLink(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_CitationLink)));
}
function $asArrayOf_Llaika_ast_CitationLink(obj, depth) {
  return (($isArrayOf_Llaika_ast_CitationLink(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.CitationLink;", depth));
}
var $d_Llaika_ast_CitationLink = new $TypeData().initClass($c_Llaika_ast_CitationLink, "laika.ast.CitationLink", ({
  Llaika_ast_CitationLink: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Link: 1,
  Llaika_ast_LocalLink: 1
}));
function $as_Llaika_ast_CitationReference(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.CitationReference"));
}
function $isArrayOf_Llaika_ast_CitationReference(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_CitationReference)));
}
function $asArrayOf_Llaika_ast_CitationReference(obj, depth) {
  return (($isArrayOf_Llaika_ast_CitationReference(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.CitationReference;", depth));
}
function $as_Llaika_ast_Comment(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Comment"));
}
function $isArrayOf_Llaika_ast_Comment(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Comment)));
}
function $asArrayOf_Llaika_ast_Comment(obj, depth) {
  return (($isArrayOf_Llaika_ast_Comment(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Comment;", depth));
}
function $ct_Llaika_ast_ContextReference__Llaika_api_config_Key__Llaika_parse_SourceFragment__($thiz, ref, source) {
  $thiz.Llaika_ast_ContextReference__f_ref = ref;
  $thiz.Llaika_ast_ContextReference__f_source = source;
  return $thiz;
}
/** @constructor */
function $c_Llaika_ast_ContextReference() {
  this.Llaika_ast_ContextReference__f_ref = null;
  this.Llaika_ast_ContextReference__f_source = null;
}
$c_Llaika_ast_ContextReference.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_ContextReference.prototype.constructor = $c_Llaika_ast_ContextReference;
/** @constructor */
function $h_Llaika_ast_ContextReference() {
}
$h_Llaika_ast_ContextReference.prototype = $c_Llaika_ast_ContextReference.prototype;
$c_Llaika_ast_ContextReference.prototype.missing__Llaika_ast_InvalidSpan = (function() {
  return $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan((("Missing required reference: '" + this.Llaika_ast_ContextReference__f_ref) + "'"), this.Llaika_ast_ContextReference__f_source);
});
$c_Llaika_ast_ContextReference.prototype.invalid__Llaika_api_config_ConfigError__Llaika_ast_InvalidSpan = (function(cError) {
  return $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan(((("Error resolving reference: '" + this.Llaika_ast_ContextReference__f_ref) + "': ") + $n(cError).message__T()), this.Llaika_ast_ContextReference__f_source);
});
$c_Llaika_ast_ContextReference.prototype.invalidType__Llaika_api_config_ConfigValue__Llaika_ast_InvalidSpan = (function(value) {
  return $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan(((("Error resolving reference: '" + this.Llaika_ast_ContextReference__f_ref) + "': ") + new $c_Llaika_api_config_ConfigError$InvalidType("AST Element or Simple Value", value).Llaika_api_config_ConfigError$InvalidType__f_message), this.Llaika_ast_ContextReference__f_source);
});
function $as_Llaika_ast_EmbeddedConfigValue(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.EmbeddedConfigValue"));
}
function $isArrayOf_Llaika_ast_EmbeddedConfigValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_EmbeddedConfigValue)));
}
function $asArrayOf_Llaika_ast_EmbeddedConfigValue(obj, depth) {
  return (($isArrayOf_Llaika_ast_EmbeddedConfigValue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.EmbeddedConfigValue;", depth));
}
/** @constructor */
function $c_Llaika_ast_EnumType$Arabic$() {
}
$c_Llaika_ast_EnumType$Arabic$.prototype = new $h_Llaika_ast_EnumType();
$c_Llaika_ast_EnumType$Arabic$.prototype.constructor = $c_Llaika_ast_EnumType$Arabic$;
/** @constructor */
function $h_Llaika_ast_EnumType$Arabic$() {
}
$h_Llaika_ast_EnumType$Arabic$.prototype = $c_Llaika_ast_EnumType$Arabic$.prototype;
$c_Llaika_ast_EnumType$Arabic$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_EnumType$Arabic$.prototype.hashCode__I = (function() {
  return 1969163468;
});
$c_Llaika_ast_EnumType$Arabic$.prototype.toString__T = (function() {
  return "Arabic";
});
$c_Llaika_ast_EnumType$Arabic$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_ast_EnumType$Arabic$.prototype.productPrefix__T = (function() {
  return "Arabic";
});
$c_Llaika_ast_EnumType$Arabic$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_ast_EnumType$Arabic$ = new $TypeData().initClass($c_Llaika_ast_EnumType$Arabic$, "laika.ast.EnumType$Arabic$", ({
  Llaika_ast_EnumType$Arabic$: 1,
  Llaika_ast_EnumType: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_ast_EnumType$Arabic$;
function $m_Llaika_ast_EnumType$Arabic$() {
  if ((!$n_Llaika_ast_EnumType$Arabic$)) {
    $n_Llaika_ast_EnumType$Arabic$ = new $c_Llaika_ast_EnumType$Arabic$();
  }
  return $n_Llaika_ast_EnumType$Arabic$;
}
/** @constructor */
function $c_Llaika_ast_FootnoteLabel$Autonumber$() {
}
$c_Llaika_ast_FootnoteLabel$Autonumber$.prototype = new $h_O();
$c_Llaika_ast_FootnoteLabel$Autonumber$.prototype.constructor = $c_Llaika_ast_FootnoteLabel$Autonumber$;
/** @constructor */
function $h_Llaika_ast_FootnoteLabel$Autonumber$() {
}
$h_Llaika_ast_FootnoteLabel$Autonumber$.prototype = $c_Llaika_ast_FootnoteLabel$Autonumber$.prototype;
$c_Llaika_ast_FootnoteLabel$Autonumber$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_FootnoteLabel$Autonumber$.prototype.hashCode__I = (function() {
  return (-1910417960);
});
$c_Llaika_ast_FootnoteLabel$Autonumber$.prototype.toString__T = (function() {
  return "Autonumber";
});
$c_Llaika_ast_FootnoteLabel$Autonumber$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_ast_FootnoteLabel$Autonumber$.prototype.productPrefix__T = (function() {
  return "Autonumber";
});
$c_Llaika_ast_FootnoteLabel$Autonumber$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_ast_FootnoteLabel$Autonumber$ = new $TypeData().initClass($c_Llaika_ast_FootnoteLabel$Autonumber$, "laika.ast.FootnoteLabel$Autonumber$", ({
  Llaika_ast_FootnoteLabel$Autonumber$: 1,
  Llaika_ast_FootnoteLabel: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_ast_FootnoteLabel$Autonumber$;
function $m_Llaika_ast_FootnoteLabel$Autonumber$() {
  if ((!$n_Llaika_ast_FootnoteLabel$Autonumber$)) {
    $n_Llaika_ast_FootnoteLabel$Autonumber$ = new $c_Llaika_ast_FootnoteLabel$Autonumber$();
  }
  return $n_Llaika_ast_FootnoteLabel$Autonumber$;
}
/** @constructor */
function $c_Llaika_ast_FootnoteLabel$Autosymbol$() {
}
$c_Llaika_ast_FootnoteLabel$Autosymbol$.prototype = new $h_O();
$c_Llaika_ast_FootnoteLabel$Autosymbol$.prototype.constructor = $c_Llaika_ast_FootnoteLabel$Autosymbol$;
/** @constructor */
function $h_Llaika_ast_FootnoteLabel$Autosymbol$() {
}
$h_Llaika_ast_FootnoteLabel$Autosymbol$.prototype = $c_Llaika_ast_FootnoteLabel$Autosymbol$.prototype;
$c_Llaika_ast_FootnoteLabel$Autosymbol$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_FootnoteLabel$Autosymbol$.prototype.hashCode__I = (function() {
  return (-1763577817);
});
$c_Llaika_ast_FootnoteLabel$Autosymbol$.prototype.toString__T = (function() {
  return "Autosymbol";
});
$c_Llaika_ast_FootnoteLabel$Autosymbol$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_ast_FootnoteLabel$Autosymbol$.prototype.productPrefix__T = (function() {
  return "Autosymbol";
});
$c_Llaika_ast_FootnoteLabel$Autosymbol$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_ast_FootnoteLabel$Autosymbol$ = new $TypeData().initClass($c_Llaika_ast_FootnoteLabel$Autosymbol$, "laika.ast.FootnoteLabel$Autosymbol$", ({
  Llaika_ast_FootnoteLabel$Autosymbol$: 1,
  Llaika_ast_FootnoteLabel: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_ast_FootnoteLabel$Autosymbol$;
function $m_Llaika_ast_FootnoteLabel$Autosymbol$() {
  if ((!$n_Llaika_ast_FootnoteLabel$Autosymbol$)) {
    $n_Llaika_ast_FootnoteLabel$Autosymbol$ = new $c_Llaika_ast_FootnoteLabel$Autosymbol$();
  }
  return $n_Llaika_ast_FootnoteLabel$Autosymbol$;
}
/** @constructor */
function $c_Llaika_ast_FootnoteLink(refId, label, options) {
  this.Llaika_ast_FootnoteLink__f_refId = null;
  this.Llaika_ast_FootnoteLink__f_label = null;
  this.Llaika_ast_FootnoteLink__f_options = null;
  this.Llaika_ast_FootnoteLink__f_refId = refId;
  this.Llaika_ast_FootnoteLink__f_label = label;
  this.Llaika_ast_FootnoteLink__f_options = options;
}
$c_Llaika_ast_FootnoteLink.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_FootnoteLink.prototype.constructor = $c_Llaika_ast_FootnoteLink;
/** @constructor */
function $h_Llaika_ast_FootnoteLink() {
}
$h_Llaika_ast_FootnoteLink.prototype = $c_Llaika_ast_FootnoteLink.prototype;
$c_Llaika_ast_FootnoteLink.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_FootnoteLink.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_FootnoteLink)) {
    var x$0$2 = $as_Llaika_ast_FootnoteLink(x$0);
    if (((this.Llaika_ast_FootnoteLink__f_refId === $n(x$0$2).Llaika_ast_FootnoteLink__f_refId) && (this.Llaika_ast_FootnoteLink__f_label === $n(x$0$2).Llaika_ast_FootnoteLink__f_label))) {
      var x = this.Llaika_ast_FootnoteLink__f_options;
      var x$2 = $n(x$0$2).Llaika_ast_FootnoteLink__f_options;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_FootnoteLink.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_FootnoteLink.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_FootnoteLink.prototype.productPrefix__T = (function() {
  return "FootnoteLink";
});
$c_Llaika_ast_FootnoteLink.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_FootnoteLink__f_refId;
      break;
    }
    case 1: {
      return this.Llaika_ast_FootnoteLink__f_label;
      break;
    }
    case 2: {
      return this.Llaika_ast_FootnoteLink__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_FootnoteLink.prototype.refId__T = (function() {
  return this.Llaika_ast_FootnoteLink__f_refId;
});
$c_Llaika_ast_FootnoteLink.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_FootnoteLink__f_options;
});
$c_Llaika_ast_FootnoteLink.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var refId = this.Llaika_ast_FootnoteLink__f_refId;
  var label = this.Llaika_ast_FootnoteLink__f_label;
  return new $c_Llaika_ast_FootnoteLink(refId, label, options);
});
function $as_Llaika_ast_FootnoteLink(obj) {
  return (((obj instanceof $c_Llaika_ast_FootnoteLink) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.FootnoteLink"));
}
function $isArrayOf_Llaika_ast_FootnoteLink(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_FootnoteLink)));
}
function $asArrayOf_Llaika_ast_FootnoteLink(obj, depth) {
  return (($isArrayOf_Llaika_ast_FootnoteLink(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.FootnoteLink;", depth));
}
var $d_Llaika_ast_FootnoteLink = new $TypeData().initClass($c_Llaika_ast_FootnoteLink, "laika.ast.FootnoteLink", ({
  Llaika_ast_FootnoteLink: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Link: 1,
  Llaika_ast_LocalLink: 1
}));
function $as_Llaika_ast_FootnoteReference(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.FootnoteReference"));
}
function $isArrayOf_Llaika_ast_FootnoteReference(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_FootnoteReference)));
}
function $asArrayOf_Llaika_ast_FootnoteReference(obj, depth) {
  return (($isArrayOf_Llaika_ast_FootnoteReference(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.FootnoteReference;", depth));
}
/** @constructor */
function $c_Llaika_ast_Image(target, width, height, alt, title, options) {
  this.Llaika_ast_Image__f_target = null;
  this.Llaika_ast_Image__f_width = null;
  this.Llaika_ast_Image__f_height = null;
  this.Llaika_ast_Image__f_alt = null;
  this.Llaika_ast_Image__f_title = null;
  this.Llaika_ast_Image__f_options = null;
  this.Llaika_ast_Image__f_supportsExternalTargets = false;
  this.Llaika_ast_Image__f_target = target;
  this.Llaika_ast_Image__f_width = width;
  this.Llaika_ast_Image__f_height = height;
  this.Llaika_ast_Image__f_alt = alt;
  this.Llaika_ast_Image__f_title = title;
  this.Llaika_ast_Image__f_options = options;
  this.Llaika_ast_Image__f_supportsExternalTargets = false;
}
$c_Llaika_ast_Image.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_Image.prototype.constructor = $c_Llaika_ast_Image;
/** @constructor */
function $h_Llaika_ast_Image() {
}
$h_Llaika_ast_Image.prototype = $c_Llaika_ast_Image.prototype;
$c_Llaika_ast_Image.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_Image.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_Image)) {
    var x$0$2 = $as_Llaika_ast_Image(x$0);
    var x = this.Llaika_ast_Image__f_target;
    var x$2 = $n(x$0$2).Llaika_ast_Image__f_target;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_Image__f_width;
      var x$4 = $n(x$0$2).Llaika_ast_Image__f_width;
      var $x_5 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$5 = this.Llaika_ast_Image__f_height;
      var x$6 = $n(x$0$2).Llaika_ast_Image__f_height;
      var $x_4 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$7 = this.Llaika_ast_Image__f_alt;
      var x$8 = $n(x$0$2).Llaika_ast_Image__f_alt;
      var $x_3 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$9 = this.Llaika_ast_Image__f_title;
      var x$10 = $n(x$0$2).Llaika_ast_Image__f_title;
      var $x_2 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$11 = this.Llaika_ast_Image__f_options;
      var x$12 = $n(x$0$2).Llaika_ast_Image__f_options;
      var $x_1 = ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_Image.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_Image.prototype.productArity__I = (function() {
  return 6;
});
$c_Llaika_ast_Image.prototype.productPrefix__T = (function() {
  return "Image";
});
$c_Llaika_ast_Image.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_Image__f_target;
      break;
    }
    case 1: {
      return this.Llaika_ast_Image__f_width;
      break;
    }
    case 2: {
      return this.Llaika_ast_Image__f_height;
      break;
    }
    case 3: {
      return this.Llaika_ast_Image__f_alt;
      break;
    }
    case 4: {
      return this.Llaika_ast_Image__f_title;
      break;
    }
    case 5: {
      return this.Llaika_ast_Image__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_Image.prototype.target__Llaika_ast_Target = (function() {
  return this.Llaika_ast_Image__f_target;
});
$c_Llaika_ast_Image.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_Image__f_options;
});
$c_Llaika_ast_Image.prototype.supportsExternalTargets__Z = (function() {
  return this.Llaika_ast_Image__f_supportsExternalTargets;
});
$c_Llaika_ast_Image.prototype.withTarget__Llaika_ast_Target__Llaika_ast_GlobalLink = (function(target) {
  var width = this.Llaika_ast_Image__f_width;
  var height = this.Llaika_ast_Image__f_height;
  var alt = this.Llaika_ast_Image__f_alt;
  var title = this.Llaika_ast_Image__f_title;
  var options = this.Llaika_ast_Image__f_options;
  return new $c_Llaika_ast_Image(target, width, height, alt, title, options);
});
$c_Llaika_ast_Image.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var target = this.Llaika_ast_Image__f_target;
  var width = this.Llaika_ast_Image__f_width;
  var height = this.Llaika_ast_Image__f_height;
  var alt = this.Llaika_ast_Image__f_alt;
  var title = this.Llaika_ast_Image__f_title;
  return new $c_Llaika_ast_Image(target, width, height, alt, title, options);
});
function $as_Llaika_ast_Image(obj) {
  return (((obj instanceof $c_Llaika_ast_Image) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Image"));
}
function $isArrayOf_Llaika_ast_Image(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Image)));
}
function $asArrayOf_Llaika_ast_Image(obj, depth) {
  return (($isArrayOf_Llaika_ast_Image(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Image;", depth));
}
var $d_Llaika_ast_Image = new $TypeData().initClass($c_Llaika_ast_Image, "laika.ast.Image", ({
  Llaika_ast_Image: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Link: 1,
  Llaika_ast_GlobalLink: 1
}));
/** @constructor */
function $c_Llaika_ast_ImageIdReference(text, id, source, options) {
  this.Llaika_ast_ImageIdReference__f_text = null;
  this.Llaika_ast_ImageIdReference__f_id = null;
  this.Llaika_ast_ImageIdReference__f_source = null;
  this.Llaika_ast_ImageIdReference__f_options = null;
  this.Llaika_ast_ImageIdReference__f_unresolvedMessage$lzy5 = null;
  this.Llaika_ast_ImageIdReference__f_unresolvedMessagebitmap$5 = false;
  this.Llaika_ast_ImageIdReference__f_text = text;
  this.Llaika_ast_ImageIdReference__f_id = id;
  this.Llaika_ast_ImageIdReference__f_source = source;
  this.Llaika_ast_ImageIdReference__f_options = options;
}
$c_Llaika_ast_ImageIdReference.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_ImageIdReference.prototype.constructor = $c_Llaika_ast_ImageIdReference;
/** @constructor */
function $h_Llaika_ast_ImageIdReference() {
}
$h_Llaika_ast_ImageIdReference.prototype = $c_Llaika_ast_ImageIdReference.prototype;
$c_Llaika_ast_ImageIdReference.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_ImageIdReference.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_ImageIdReference)) {
    var x$0$2 = $as_Llaika_ast_ImageIdReference(x$0);
    if (((this.Llaika_ast_ImageIdReference__f_text === $n(x$0$2).Llaika_ast_ImageIdReference__f_text) && (this.Llaika_ast_ImageIdReference__f_id === $n(x$0$2).Llaika_ast_ImageIdReference__f_id))) {
      var x = this.Llaika_ast_ImageIdReference__f_source;
      var x$2 = $n(x$0$2).Llaika_ast_ImageIdReference__f_source;
      var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Llaika_ast_ImageIdReference__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_ImageIdReference__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_ImageIdReference.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_ImageIdReference.prototype.productArity__I = (function() {
  return 4;
});
$c_Llaika_ast_ImageIdReference.prototype.productPrefix__T = (function() {
  return "ImageIdReference";
});
$c_Llaika_ast_ImageIdReference.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_ImageIdReference__f_text;
      break;
    }
    case 1: {
      return this.Llaika_ast_ImageIdReference__f_id;
      break;
    }
    case 2: {
      return this.Llaika_ast_ImageIdReference__f_source;
      break;
    }
    case 3: {
      return this.Llaika_ast_ImageIdReference__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_ImageIdReference.prototype.source__Llaika_parse_SourceFragment = (function() {
  return this.Llaika_ast_ImageIdReference__f_source;
});
$c_Llaika_ast_ImageIdReference.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_ImageIdReference__f_options;
});
$c_Llaika_ast_ImageIdReference.prototype.unresolvedMessage__T = (function() {
  if ((!this.Llaika_ast_ImageIdReference__f_unresolvedMessagebitmap$5)) {
    this.Llaika_ast_ImageIdReference__f_unresolvedMessage$lzy5 = (("Unresolved reference to image definition with id '" + this.Llaika_ast_ImageIdReference__f_id) + "'");
    this.Llaika_ast_ImageIdReference__f_unresolvedMessagebitmap$5 = true;
  }
  return this.Llaika_ast_ImageIdReference__f_unresolvedMessage$lzy5;
});
$c_Llaika_ast_ImageIdReference.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var text = this.Llaika_ast_ImageIdReference__f_text;
  var id = this.Llaika_ast_ImageIdReference__f_id;
  var source = this.Llaika_ast_ImageIdReference__f_source;
  return new $c_Llaika_ast_ImageIdReference(text, id, source, options);
});
function $as_Llaika_ast_ImageIdReference(obj) {
  return (((obj instanceof $c_Llaika_ast_ImageIdReference) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.ImageIdReference"));
}
function $isArrayOf_Llaika_ast_ImageIdReference(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_ImageIdReference)));
}
function $asArrayOf_Llaika_ast_ImageIdReference(obj, depth) {
  return (($isArrayOf_Llaika_ast_ImageIdReference(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.ImageIdReference;", depth));
}
var $d_Llaika_ast_ImageIdReference = new $TypeData().initClass($c_Llaika_ast_ImageIdReference, "laika.ast.ImageIdReference", ({
  Llaika_ast_ImageIdReference: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Unresolved: 1,
  Llaika_ast_Reference: 1
}));
function $as_Llaika_ast_InternalLinkTarget(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.InternalLinkTarget"));
}
function $isArrayOf_Llaika_ast_InternalLinkTarget(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_InternalLinkTarget)));
}
function $asArrayOf_Llaika_ast_InternalLinkTarget(obj, depth) {
  return (($isArrayOf_Llaika_ast_InternalLinkTarget(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.InternalLinkTarget;", depth));
}
/** @constructor */
function $c_Llaika_ast_InvalidBlock(message, source, fallback, options) {
  this.Llaika_ast_InvalidBlock__f_message = null;
  this.Llaika_ast_InvalidBlock__f_source = null;
  this.Llaika_ast_InvalidBlock__f_fallback = null;
  this.Llaika_ast_InvalidBlock__f_options = null;
  this.Llaika_ast_InvalidBlock__f_message = message;
  this.Llaika_ast_InvalidBlock__f_source = source;
  this.Llaika_ast_InvalidBlock__f_fallback = fallback;
  this.Llaika_ast_InvalidBlock__f_options = options;
}
$c_Llaika_ast_InvalidBlock.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_InvalidBlock.prototype.constructor = $c_Llaika_ast_InvalidBlock;
/** @constructor */
function $h_Llaika_ast_InvalidBlock() {
}
$h_Llaika_ast_InvalidBlock.prototype = $c_Llaika_ast_InvalidBlock.prototype;
$c_Llaika_ast_InvalidBlock.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_InvalidBlock.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_InvalidBlock)) {
    var x$0$2 = $as_Llaika_ast_InvalidBlock(x$0);
    var x = this.Llaika_ast_InvalidBlock__f_message;
    var x$2 = $n(x$0$2).Llaika_ast_InvalidBlock__f_message;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_InvalidBlock__f_source;
      var x$4 = $n(x$0$2).Llaika_ast_InvalidBlock__f_source;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.Llaika_ast_InvalidBlock__f_fallback;
      var x$6 = $n(x$0$2).Llaika_ast_InvalidBlock__f_fallback;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.Llaika_ast_InvalidBlock__f_options;
      var x$8 = $n(x$0$2).Llaika_ast_InvalidBlock__f_options;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_InvalidBlock.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_InvalidBlock.prototype.productArity__I = (function() {
  return 4;
});
$c_Llaika_ast_InvalidBlock.prototype.productPrefix__T = (function() {
  return "InvalidBlock";
});
$c_Llaika_ast_InvalidBlock.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_InvalidBlock__f_message;
      break;
    }
    case 1: {
      return this.Llaika_ast_InvalidBlock__f_source;
      break;
    }
    case 2: {
      return this.Llaika_ast_InvalidBlock__f_fallback;
      break;
    }
    case 3: {
      return this.Llaika_ast_InvalidBlock__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_InvalidBlock.prototype.message__Llaika_ast_RuntimeMessage = (function() {
  return this.Llaika_ast_InvalidBlock__f_message;
});
$c_Llaika_ast_InvalidBlock.prototype.source__Llaika_parse_SourceFragment = (function() {
  return this.Llaika_ast_InvalidBlock__f_source;
});
$c_Llaika_ast_InvalidBlock.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_InvalidBlock__f_options;
});
$c_Llaika_ast_InvalidBlock.prototype.fallback__Llaika_ast_Element = (function() {
  return $as_Llaika_ast_Element(this.Llaika_ast_InvalidBlock__f_fallback);
});
$c_Llaika_ast_InvalidBlock.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var message = this.Llaika_ast_InvalidBlock__f_message;
  var source = this.Llaika_ast_InvalidBlock__f_source;
  var fallback = this.Llaika_ast_InvalidBlock__f_fallback;
  return new $c_Llaika_ast_InvalidBlock(message, source, fallback, options);
});
function $as_Llaika_ast_InvalidBlock(obj) {
  return (((obj instanceof $c_Llaika_ast_InvalidBlock) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.InvalidBlock"));
}
function $isArrayOf_Llaika_ast_InvalidBlock(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_InvalidBlock)));
}
function $asArrayOf_Llaika_ast_InvalidBlock(obj, depth) {
  return (($isArrayOf_Llaika_ast_InvalidBlock(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.InvalidBlock;", depth));
}
var $d_Llaika_ast_InvalidBlock = new $TypeData().initClass($c_Llaika_ast_InvalidBlock, "laika.ast.InvalidBlock", ({
  Llaika_ast_InvalidBlock: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_Fallback: 1,
  Llaika_ast_Invalid: 1
}));
/** @constructor */
function $c_Llaika_ast_InvalidSpan(message, source, fallback, options) {
  this.Llaika_ast_InvalidSpan__f_message = null;
  this.Llaika_ast_InvalidSpan__f_source = null;
  this.Llaika_ast_InvalidSpan__f_fallback = null;
  this.Llaika_ast_InvalidSpan__f_options = null;
  this.Llaika_ast_InvalidSpan__f_message = message;
  this.Llaika_ast_InvalidSpan__f_source = source;
  this.Llaika_ast_InvalidSpan__f_fallback = fallback;
  this.Llaika_ast_InvalidSpan__f_options = options;
}
$c_Llaika_ast_InvalidSpan.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_InvalidSpan.prototype.constructor = $c_Llaika_ast_InvalidSpan;
/** @constructor */
function $h_Llaika_ast_InvalidSpan() {
}
$h_Llaika_ast_InvalidSpan.prototype = $c_Llaika_ast_InvalidSpan.prototype;
$c_Llaika_ast_InvalidSpan.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_InvalidSpan.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_InvalidSpan)) {
    var x$0$2 = $as_Llaika_ast_InvalidSpan(x$0);
    var x = this.Llaika_ast_InvalidSpan__f_message;
    var x$2 = $n(x$0$2).Llaika_ast_InvalidSpan__f_message;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_InvalidSpan__f_source;
      var x$4 = $n(x$0$2).Llaika_ast_InvalidSpan__f_source;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.Llaika_ast_InvalidSpan__f_fallback;
      var x$6 = $n(x$0$2).Llaika_ast_InvalidSpan__f_fallback;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.Llaika_ast_InvalidSpan__f_options;
      var x$8 = $n(x$0$2).Llaika_ast_InvalidSpan__f_options;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_InvalidSpan.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_InvalidSpan.prototype.productArity__I = (function() {
  return 4;
});
$c_Llaika_ast_InvalidSpan.prototype.productPrefix__T = (function() {
  return "InvalidSpan";
});
$c_Llaika_ast_InvalidSpan.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_InvalidSpan__f_message;
      break;
    }
    case 1: {
      return this.Llaika_ast_InvalidSpan__f_source;
      break;
    }
    case 2: {
      return this.Llaika_ast_InvalidSpan__f_fallback;
      break;
    }
    case 3: {
      return this.Llaika_ast_InvalidSpan__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_InvalidSpan.prototype.message__Llaika_ast_RuntimeMessage = (function() {
  return this.Llaika_ast_InvalidSpan__f_message;
});
$c_Llaika_ast_InvalidSpan.prototype.source__Llaika_parse_SourceFragment = (function() {
  return this.Llaika_ast_InvalidSpan__f_source;
});
$c_Llaika_ast_InvalidSpan.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_InvalidSpan__f_options;
});
$c_Llaika_ast_InvalidSpan.prototype.fallback__Llaika_ast_Element = (function() {
  return $as_Llaika_ast_Element(this.Llaika_ast_InvalidSpan__f_fallback);
});
$c_Llaika_ast_InvalidSpan.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var message = this.Llaika_ast_InvalidSpan__f_message;
  var source = this.Llaika_ast_InvalidSpan__f_source;
  var fallback = this.Llaika_ast_InvalidSpan__f_fallback;
  return new $c_Llaika_ast_InvalidSpan(message, source, fallback, options);
});
function $as_Llaika_ast_InvalidSpan(obj) {
  return (((obj instanceof $c_Llaika_ast_InvalidSpan) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.InvalidSpan"));
}
function $isArrayOf_Llaika_ast_InvalidSpan(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_InvalidSpan)));
}
function $asArrayOf_Llaika_ast_InvalidSpan(obj, depth) {
  return (($isArrayOf_Llaika_ast_InvalidSpan(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.InvalidSpan;", depth));
}
var $d_Llaika_ast_InvalidSpan = new $TypeData().initClass($c_Llaika_ast_InvalidSpan, "laika.ast.InvalidSpan", ({
  Llaika_ast_InvalidSpan: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Fallback: 1,
  Llaika_ast_Invalid: 1
}));
/** @constructor */
function $c_Llaika_ast_Literal(content, options) {
  this.Llaika_ast_Literal__f_content = null;
  this.Llaika_ast_Literal__f_options = null;
  this.Llaika_ast_Literal__f_content = content;
  this.Llaika_ast_Literal__f_options = options;
}
$c_Llaika_ast_Literal.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_Literal.prototype.constructor = $c_Llaika_ast_Literal;
/** @constructor */
function $h_Llaika_ast_Literal() {
}
$h_Llaika_ast_Literal.prototype = $c_Llaika_ast_Literal.prototype;
$c_Llaika_ast_Literal.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_Literal.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_Literal)) {
    var x$0$2 = $as_Llaika_ast_Literal(x$0);
    if ((this.Llaika_ast_Literal__f_content === $n(x$0$2).Llaika_ast_Literal__f_content)) {
      var x = this.Llaika_ast_Literal__f_options;
      var x$2 = $n(x$0$2).Llaika_ast_Literal__f_options;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_Literal.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_Literal.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_Literal.prototype.productPrefix__T = (function() {
  return "Literal";
});
$c_Llaika_ast_Literal.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_Literal__f_content;
  }
  if ((n === 1)) {
    return this.Llaika_ast_Literal__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_Literal.prototype.content__T = (function() {
  return this.Llaika_ast_Literal__f_content;
});
$c_Llaika_ast_Literal.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_Literal__f_options;
});
$c_Llaika_ast_Literal.prototype.content__O = (function() {
  return this.Llaika_ast_Literal__f_content;
});
$c_Llaika_ast_Literal.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_Literal__f_content;
  return new $c_Llaika_ast_Literal(content, options);
});
function $as_Llaika_ast_Literal(obj) {
  return (((obj instanceof $c_Llaika_ast_Literal) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Literal"));
}
function $isArrayOf_Llaika_ast_Literal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Literal)));
}
function $asArrayOf_Llaika_ast_Literal(obj, depth) {
  return (($isArrayOf_Llaika_ast_Literal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Literal;", depth));
}
var $d_Llaika_ast_Literal = new $TypeData().initClass($c_Llaika_ast_Literal, "laika.ast.Literal", ({
  Llaika_ast_Literal: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_TextContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_LiteralBlock(content, options) {
  this.Llaika_ast_LiteralBlock__f_content = null;
  this.Llaika_ast_LiteralBlock__f_options = null;
  this.Llaika_ast_LiteralBlock__f_content = content;
  this.Llaika_ast_LiteralBlock__f_options = options;
}
$c_Llaika_ast_LiteralBlock.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_LiteralBlock.prototype.constructor = $c_Llaika_ast_LiteralBlock;
/** @constructor */
function $h_Llaika_ast_LiteralBlock() {
}
$h_Llaika_ast_LiteralBlock.prototype = $c_Llaika_ast_LiteralBlock.prototype;
$c_Llaika_ast_LiteralBlock.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_LiteralBlock.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_LiteralBlock)) {
    var x$0$2 = $as_Llaika_ast_LiteralBlock(x$0);
    if ((this.Llaika_ast_LiteralBlock__f_content === $n(x$0$2).Llaika_ast_LiteralBlock__f_content)) {
      var x = this.Llaika_ast_LiteralBlock__f_options;
      var x$2 = $n(x$0$2).Llaika_ast_LiteralBlock__f_options;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_LiteralBlock.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_LiteralBlock.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_LiteralBlock.prototype.productPrefix__T = (function() {
  return "LiteralBlock";
});
$c_Llaika_ast_LiteralBlock.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_LiteralBlock__f_content;
  }
  if ((n === 1)) {
    return this.Llaika_ast_LiteralBlock__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_LiteralBlock.prototype.content__T = (function() {
  return this.Llaika_ast_LiteralBlock__f_content;
});
$c_Llaika_ast_LiteralBlock.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_LiteralBlock__f_options;
});
$c_Llaika_ast_LiteralBlock.prototype.content__O = (function() {
  return this.Llaika_ast_LiteralBlock__f_content;
});
$c_Llaika_ast_LiteralBlock.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_LiteralBlock__f_content;
  return new $c_Llaika_ast_LiteralBlock(content, options);
});
function $as_Llaika_ast_LiteralBlock(obj) {
  return (((obj instanceof $c_Llaika_ast_LiteralBlock) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.LiteralBlock"));
}
function $isArrayOf_Llaika_ast_LiteralBlock(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_LiteralBlock)));
}
function $asArrayOf_Llaika_ast_LiteralBlock(obj, depth) {
  return (($isArrayOf_Llaika_ast_LiteralBlock(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.LiteralBlock;", depth));
}
var $d_Llaika_ast_LiteralBlock = new $TypeData().initClass($c_Llaika_ast_LiteralBlock, "laika.ast.LiteralBlock", ({
  Llaika_ast_LiteralBlock: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_TextContainer: 1
}));
function $p_Llaika_ast_Path$Segments__removeCommonParts$1__sci_List__sci_List__T2($thiz, a, b) {
  var b$tailLocal1 = b;
  var a$tailLocal1 = a;
  while (true) {
    var _1 = a$tailLocal1;
    var _2 = b$tailLocal1;
    if ((_1 instanceof $c_sci_$colon$colon)) {
      var x50 = $as_sci_$colon$colon(_1);
      var x52 = $n(x50).sci_$colon$colon__f_next;
      var p1 = $as_T($n(x50).sci_$colon$colon__f_head);
      if ((_2 instanceof $c_sci_$colon$colon)) {
        var x47 = $as_sci_$colon$colon(_2);
        var x49 = $n(x47).sci_$colon$colon__f_next;
        var p2 = $as_T($n(x47).sci_$colon$colon__f_head);
        if ((p1 === p2)) {
          a$tailLocal1 = x52;
          b$tailLocal1 = x49;
          continue;
        }
      }
    }
    var _1$1 = a$tailLocal1;
    var _2$1 = b$tailLocal1;
    return new $c_T2(_1$1, _2$1);
  }
}
/** @constructor */
function $c_Llaika_ast_Path$Segments(segments, suffix, fragment) {
  this.Llaika_ast_Path$Segments__f_name$lzy1 = null;
  this.Llaika_ast_Path$Segments__f_namebitmap$1 = false;
  this.Llaika_ast_Path$Segments__f_basename$lzy1 = null;
  this.Llaika_ast_Path$Segments__f_basenamebitmap$1 = false;
  this.Llaika_ast_Path$Segments__f_segments = null;
  this.Llaika_ast_Path$Segments__f_suffix = null;
  this.Llaika_ast_Path$Segments__f_fragment = null;
  this.Llaika_ast_Path$Segments__f_depth = 0;
  this.Llaika_ast_Path$Segments__f_parent$lzy1 = null;
  this.Llaika_ast_Path$Segments__f_parentbitmap$1 = false;
  this.Llaika_ast_Path$Segments__f_pathPrefix = null;
  this.Llaika_ast_Path$Segments__f_segments = segments;
  this.Llaika_ast_Path$Segments__f_suffix = suffix;
  this.Llaika_ast_Path$Segments__f_fragment = fragment;
  $m_Lcats_data_NonEmptyChainImpl$();
  var this$2 = $m_Lcats_data_NonEmptyChainOps$().length$extension__O__J(segments);
  this.Llaika_ast_Path$Segments__f_depth = this$2.RTLong__f_lo;
  this.Llaika_ast_Path$Segments__f_pathPrefix = "/";
}
$c_Llaika_ast_Path$Segments.prototype = new $h_O();
$c_Llaika_ast_Path$Segments.prototype.constructor = $c_Llaika_ast_Path$Segments;
/** @constructor */
function $h_Llaika_ast_Path$Segments() {
}
$h_Llaika_ast_Path$Segments.prototype = $c_Llaika_ast_Path$Segments.prototype;
$c_Llaika_ast_Path$Segments.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_Path$Segments.prototype.name__T = (function() {
  if ((!this.Llaika_ast_Path$Segments__f_namebitmap$1)) {
    this.Llaika_ast_Path$Segments__f_name$lzy1 = $f_Llaika_ast_VirtualPath$Segments__name__T(this);
    this.Llaika_ast_Path$Segments__f_namebitmap$1 = true;
  }
  return this.Llaika_ast_Path$Segments__f_name$lzy1;
});
$c_Llaika_ast_Path$Segments.prototype.basename__T = (function() {
  if ((!this.Llaika_ast_Path$Segments__f_basenamebitmap$1)) {
    this.Llaika_ast_Path$Segments__f_basename$lzy1 = $f_Llaika_ast_VirtualPath$Segments__basename__T(this);
    this.Llaika_ast_Path$Segments__f_basenamebitmap$1 = true;
  }
  return this.Llaika_ast_Path$Segments__f_basename$lzy1;
});
$c_Llaika_ast_Path$Segments.prototype.toString__T = (function() {
  return $f_Llaika_ast_VirtualPath$Segments__toString__T(this);
});
$c_Llaika_ast_Path$Segments.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_Path$Segments.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_Path$Segments)) {
    var x$0$2 = $as_Llaika_ast_Path$Segments(x$0);
    var x = this.Llaika_ast_Path$Segments__f_segments;
    var y = $n(x$0$2).Llaika_ast_Path$Segments__f_segments;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Llaika_ast_Path$Segments__f_suffix;
      var x$2 = $n(x$0$2).Llaika_ast_Path$Segments__f_suffix;
      var $x_2 = ((x$1 === null) ? (x$2 === null) : $n(x$1).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Llaika_ast_Path$Segments__f_fragment;
      var x$4 = $n(x$0$2).Llaika_ast_Path$Segments__f_fragment;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_Path$Segments.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_Path$Segments.prototype.productPrefix__T = (function() {
  return "Segments";
});
$c_Llaika_ast_Path$Segments.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_Path$Segments__f_segments;
      break;
    }
    case 1: {
      return this.Llaika_ast_Path$Segments__f_suffix;
      break;
    }
    case 2: {
      return this.Llaika_ast_Path$Segments__f_fragment;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_Path$Segments.prototype.segments__O = (function() {
  return this.Llaika_ast_Path$Segments__f_segments;
});
$c_Llaika_ast_Path$Segments.prototype.suffix__s_Option = (function() {
  return this.Llaika_ast_Path$Segments__f_suffix;
});
$c_Llaika_ast_Path$Segments.prototype.fragment__s_Option = (function() {
  return this.Llaika_ast_Path$Segments__f_fragment;
});
$c_Llaika_ast_Path$Segments.prototype.depth__I = (function() {
  return this.Llaika_ast_Path$Segments__f_depth;
});
$c_Llaika_ast_Path$Segments.prototype.parent__Llaika_ast_Path = (function() {
  if ((!this.Llaika_ast_Path$Segments__f_parentbitmap$1)) {
    var $x_1 = $m_Lcats_data_package$().Lcats_data_package$__f_NonEmptyChain;
    $m_Lcats_data_NonEmptyChainImpl$();
    var value = this.Llaika_ast_Path$Segments__f_segments;
    var this$2 = $n($n($x_1).fromChain__Lcats_data_Chain__s_Option($m_Lcats_data_NonEmptyChainOps$().init$extension__O__Lcats_data_Chain(value)));
    if (this$2.isEmpty__Z()) {
      var $x_2 = $m_Llaika_ast_Path$Root$();
    } else {
      var arg1 = this$2.get__O();
      var suffix = $m_s_None$();
      var fragment = $m_s_None$();
      var $x_2 = new $c_Llaika_ast_Path$Segments(arg1, suffix, fragment);
    }
    this.Llaika_ast_Path$Segments__f_parent$lzy1 = $as_Llaika_ast_Path($x_2);
    this.Llaika_ast_Path$Segments__f_parentbitmap$1 = true;
  }
  return this.Llaika_ast_Path$Segments__f_parent$lzy1;
});
$c_Llaika_ast_Path$Segments.prototype.$div__Llaika_ast_RelativePath__Llaika_ast_Path = (function(path) {
  if ((path instanceof $c_Llaika_ast_RelativePath$Segments)) {
    var x$1 = $as_Llaika_ast_RelativePath$Segments(path);
    var this$2 = $n(x$1);
    var x40 = this$2.Llaika_ast_RelativePath$Segments__f_segments;
    var this$3 = $n(x$1);
    var x41 = this$3.Llaika_ast_RelativePath$Segments__f_suffix;
    var this$4 = $n(x$1);
    var x42 = this$4.Llaika_ast_RelativePath$Segments__f_fragment;
    var this$5 = $n(x$1);
    var tc = $as_Lcats_Foldable($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
    var this$7 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(x40, tc);
    var _1 = $n(this$7.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).toList__O__sci_List(this$7.Lcats_Foldable$ToFoldableOps$$anon$6__f_self);
    var _4 = this.Llaika_ast_Path$Segments__f_suffix;
    var \u03b43$___1 = _1;
    var \u03b43$___2 = x41;
    var \u03b43$___3 = x42;
    var \u03b43$___4 = _4;
  } else if ((path instanceof $c_Llaika_ast_RelativePath$CurrentDocument)) {
    var x$1$1 = $as_Llaika_ast_RelativePath$CurrentDocument(path);
    var this$10 = $n(x$1$1);
    var x37 = this$10.Llaika_ast_RelativePath$CurrentDocument__f_fragment;
    var _1$1 = $m_sci_Nil$();
    var _2 = this.Llaika_ast_Path$Segments__f_suffix;
    var _4$1 = $m_s_None$();
    var \u03b43$___1 = _1$1;
    var \u03b43$___2 = _2;
    var \u03b43$___3 = x37;
    var \u03b43$___4 = _4$1;
  } else {
    var _1$2 = $m_sci_Nil$();
    var _2$1 = $m_s_None$();
    var _3 = $m_s_None$();
    var _4$2 = $m_s_None$();
    var \u03b43$___1 = _1$2;
    var \u03b43$___2 = _2$1;
    var \u03b43$___3 = _3;
    var \u03b43$___4 = _4$2;
  }
  var otherSegments = $as_sci_List(\u03b43$___1);
  var otherSuffix = $as_s_Option(\u03b43$___2);
  var otherFragment = $as_s_Option(\u03b43$___3);
  var thisSuffix = $as_s_Option(\u03b43$___4);
  var target = this.Llaika_ast_Path$Segments__f_segments;
  var tc$1 = $as_Lcats_Foldable($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
  var this$14 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(target, tc$1);
  var this$15 = $n($n(this$14.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).toList__O__sci_List(this$14.Lcats_Foldable$ToFoldableOps$$anon$6__f_self));
  var this$18 = $n($as_sc_SeqOps($f_sc_StrictOptimizedIterableOps__dropRight__I__O(this$15, 1)));
  $m_Lcats_data_NonEmptyChainImpl$();
  var value = this.Llaika_ast_Path$Segments__f_segments;
  var $x_2 = $as_T($m_Lcats_data_NonEmptyChainOps$().last$extension__O__O(value));
  var this$17 = $n(thisSuffix);
  if (this$17.isEmpty__Z()) {
    var $x_1 = "";
  } else {
    var arg1 = this$17.get__O();
    var _$4 = $as_T(arg1);
    var $x_1 = ("." + _$4);
  }
  var elem = ($x_2 + $x_1);
  var thisSegments = $as_sci_List(this$18.appended__O__O(elem));
  var this$19 = $n(thisSegments);
  var n = $n(path).parentLevels__I();
  var this$20 = $n($as_sc_IterableOps($f_sc_StrictOptimizedIterableOps__dropRight__I__O(this$19, n)));
  var combinedSegments = $as_sci_List(this$20.concat__sc_IterableOnce__O(otherSegments));
  var this$21 = $n($n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptyChain).fromSeq__sci_Seq__s_Option(combinedSegments));
  if (this$21.isEmpty__Z()) {
    var $x_3 = $m_Llaika_ast_Path$Root$();
  } else {
    var arg1$1 = this$21.get__O();
    var $x_3 = new $c_Llaika_ast_Path$Segments(arg1$1, otherSuffix, otherFragment);
  }
  return $as_Llaika_ast_Path($x_3);
});
$c_Llaika_ast_Path$Segments.prototype.relativeTo__Llaika_ast_Path__Llaika_ast_RelativePath = (function(path) {
  var refPath = ($n(path).isSubPath__Llaika_ast_Path__Z($as_Llaika_ast_Path($f_Llaika_ast_GenericPath__withoutFragment__Llaika_ast_GenericPath(this))) ? path : $n(path).parent__Llaika_ast_Path());
  matchResult15: {
    var \u03b44$___1;
    var \u03b44$___2;
    matchResult14$1: {
      var x55;
      var x = $m_Llaika_ast_Path$Root$();
      if ((x === refPath)) {
        var _1 = $m_sci_Nil$();
        $m_Lcats_data_NonEmptyChainImpl$();
        var value = this.Llaika_ast_Path$Segments__f_segments;
        var this$2 = $n($n($m_Lcats_data_NonEmptyChainOps$().init$extension__O__Lcats_data_Chain(value)).toList__sci_List());
        var elem = this.name__T();
        var _2 = $f_sc_StrictOptimizedSeqOps__appended__O__O(this$2, elem);
        var x55 = new $c_T2(_1, _2);
        break matchResult14$1;
      }
      if ((refPath instanceof $c_Llaika_ast_Path$Segments)) {
        var other = $as_Llaika_ast_Path$Segments(refPath);
        $m_Lcats_data_NonEmptyChainImpl$();
        var value$1 = $n(other).Llaika_ast_Path$Segments__f_segments;
        var this$5 = $n($n($m_Lcats_data_NonEmptyChainOps$().init$extension__O__Lcats_data_Chain(value$1)).toList__sci_List());
        var elem$1 = $n(other).name__T();
        var $x_1 = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$5, elem$1));
        $m_Lcats_data_NonEmptyChainImpl$();
        var value$2 = this.Llaika_ast_Path$Segments__f_segments;
        var this$7 = $n($n($m_Lcats_data_NonEmptyChainOps$().init$extension__O__Lcats_data_Chain(value$2)).toList__sci_List());
        var elem$2 = this.name__T();
        var x55 = $p_Llaika_ast_Path$Segments__removeCommonParts$1__sci_List__sci_List__T2(this, $x_1, $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$7, elem$2)));
        break matchResult14$1;
      }
      throw new $c_s_MatchError(refPath);
    }
    if ((x55 !== null)) {
      var a = $as_sci_List($n(x55)._1__O());
      var b = $as_sci_List($n(x55)._2__O());
      var \u03b44$___1 = a;
      var \u03b44$___2 = b;
      break matchResult15;
    }
    throw new $c_s_MatchError(x55);
  }
  var a$2 = $as_sci_List(\u03b44$___1);
  var b$2 = $as_sci_List(\u03b44$___2);
  var target = this.Llaika_ast_Path$Segments__f_segments;
  var tc = $as_Lcats_Foldable($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
  var this$10 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(target, tc);
  var this$15 = $n($n(this$10.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).toList__O__sci_List(this$10.Lcats_Foldable$ToFoldableOps$$anon$6__f_self));
  var target$1 = this.Llaika_ast_Path$Segments__f_segments;
  var tc$1 = $as_Lcats_UnorderedFoldable($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
  var this$12 = new $c_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4(target$1, tc$1);
  var this$13 = $n(this$12.Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4__f_typeClassInstance).size__O__J(this$12.Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4__f_self);
  var $x_2 = this$13.RTLong__f_lo;
  var this$14 = $n(b$2);
  var n = (($x_2 - this$14.length__I()) | 0);
  var segmentRest = $as_sci_List($p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this$15, n, this$15));
  var this$16 = $n($n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptyChain).fromSeq__sci_Seq__s_Option(segmentRest));
  if (this$16.isEmpty__Z()) {
    if ($n(a$2).isEmpty__Z()) {
      var fragment = $m_s_None$();
      var base = new $c_Llaika_ast_RelativePath$CurrentDocument(fragment);
    } else {
      var parentLevels = $n(a$2).length__I();
      var base = new $c_Llaika_ast_RelativePath$Parent(parentLevels);
    }
    var this$20 = $n(this.Llaika_ast_Path$Segments__f_fragment);
    if (this$20.isEmpty__Z()) {
      return base;
    } else {
      var arg1 = this$20.get__O();
      var fragment$1 = $as_T(arg1);
      return $as_Llaika_ast_RelativePath($n(base).withFragment__T__Llaika_ast_GenericPath(fragment$1));
    }
  } else {
    var arg1$1 = this$16.get__O();
    if ($n(a$2).isEmpty__Z()) {
      var base$1 = $m_Llaika_ast_RelativePath$CurrentTree$();
    } else {
      var parentLevels$1 = $n(a$2).length__I();
      var base$1 = new $c_Llaika_ast_RelativePath$Parent(parentLevels$1);
    }
    var this$23 = $n(base$1);
    var suffix = this.Llaika_ast_Path$Segments__f_suffix;
    var fragment$2 = this.Llaika_ast_Path$Segments__f_fragment;
    var path$1 = new $c_Llaika_ast_RelativePath$Segments(arg1$1, suffix, fragment$2, 0);
    return this$23.$div__Llaika_ast_RelativePath__Llaika_ast_RelativePath(path$1);
  }
});
$c_Llaika_ast_Path$Segments.prototype.isSubPath__Llaika_ast_Path__Z = (function(other) {
  var x = $m_Llaika_ast_Path$Root$();
  if ((x === other)) {
    return true;
  }
  if ((other instanceof $c_Llaika_ast_Path$Segments)) {
    var x$1 = $as_Llaika_ast_Path$Segments(other);
    var this$2 = $n(x$1);
    var x61 = this$2.Llaika_ast_Path$Segments__f_segments;
    var this$3 = $n(x$1);
    var x62 = this$3.Llaika_ast_Path$Segments__f_suffix;
    var this$4 = $n(x$1);
    var x63 = this$4.Llaika_ast_Path$Segments__f_fragment;
    $m_Lcats_data_NonEmptyChainImpl$();
    var value = this.Llaika_ast_Path$Segments__f_segments;
    var this$7 = $m_Lcats_data_NonEmptyChainOps$().length$extension__O__J(value);
    $m_Lcats_data_NonEmptyChainImpl$();
    var b = $m_Lcats_data_NonEmptyChainOps$().length$extension__O__J(x61);
    if (((this$7.RTLong__f_lo === b.RTLong__f_lo) && (this$7.RTLong__f_hi === b.RTLong__f_hi))) {
      var x$2 = this.Llaika_ast_Path$Segments__f_segments;
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(x$2, x61)) {
        var x$3 = this.Llaika_ast_Path$Segments__f_suffix;
        var $x_1 = ((x$3 === null) ? (x62 === null) : $n(x$3).equals__O__Z(x62));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var x$5 = this.Llaika_ast_Path$Segments__f_fragment;
        if (((x$5 === null) ? (x63 === null) : $n(x$5).equals__O__Z(x63))) {
          return true;
        } else {
          return $n(x63).isEmpty__Z();
        }
      } else {
        return false;
      }
    } else {
      var target = this.Llaika_ast_Path$Segments__f_segments;
      var tc = $as_Lcats_Foldable($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
      var this$9 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(target, tc);
      var \u03b45$ = $n(this$9.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).toList__O__sci_List(this$9.Lcats_Foldable$ToFoldableOps$$anon$6__f_self);
      var this$13 = $n(\u03b45$);
      var tc$1 = $as_Lcats_Foldable($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
      var this$11 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(x61, tc$1);
      var that = $n(this$11.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).toList__O__sci_List(this$11.Lcats_Foldable$ToFoldableOps$$anon$6__f_self);
      $n(\u03b45$);
      var offset = 0;
      if (($f_sc_SeqOps__startsWith__sc_IterableOnce__I__Z(this$13, that, offset) && $n(x62).isEmpty__Z())) {
        return $n(x63).isEmpty__Z();
      } else {
        return false;
      }
    }
  }
  throw new $c_s_MatchError(other);
});
$c_Llaika_ast_Path$Segments.prototype.copyWith__T__s_Option__s_Option__Llaika_ast_Path = (function(basename, suffix, fragment) {
  var $x_1 = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptyChain);
  $m_Lcats_data_NonEmptyChainImpl$();
  var value = this.Llaika_ast_Path$Segments__f_segments;
  var segments = $n($x_1).fromChainAppend__Lcats_data_Chain__O__O($m_Lcats_data_NonEmptyChainOps$().init$extension__O__Lcats_data_Chain(value), basename);
  return new $c_Llaika_ast_Path$Segments(segments, suffix, fragment);
});
$c_Llaika_ast_Path$Segments.prototype.copyWith$default$1__T = (function() {
  return this.basename__T();
});
$c_Llaika_ast_Path$Segments.prototype.copyWith$default$2__s_Option = (function() {
  return this.Llaika_ast_Path$Segments__f_suffix;
});
$c_Llaika_ast_Path$Segments.prototype.copyWith$default$3__s_Option = (function() {
  return this.Llaika_ast_Path$Segments__f_fragment;
});
$c_Llaika_ast_Path$Segments.prototype.pathPrefix__T = (function() {
  return this.Llaika_ast_Path$Segments__f_pathPrefix;
});
$c_Llaika_ast_Path$Segments.prototype.$div__Llaika_ast_RelativePath__Llaika_ast_GenericPath = (function(path) {
  return this.$div__Llaika_ast_RelativePath__Llaika_ast_Path(path);
});
$c_Llaika_ast_Path$Segments.prototype.copyWith__T__s_Option__s_Option__Llaika_ast_GenericPath = (function(basename, suffix, fragment) {
  return this.copyWith__T__s_Option__s_Option__Llaika_ast_Path(basename, suffix, fragment);
});
function $as_Llaika_ast_Path$Segments(obj) {
  return (((obj instanceof $c_Llaika_ast_Path$Segments) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Path$Segments"));
}
function $isArrayOf_Llaika_ast_Path$Segments(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Path$Segments)));
}
function $asArrayOf_Llaika_ast_Path$Segments(obj, depth) {
  return (($isArrayOf_Llaika_ast_Path$Segments(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Path$Segments;", depth));
}
var $d_Llaika_ast_Path$Segments = new $TypeData().initClass($c_Llaika_ast_Path$Segments, "laika.ast.Path$Segments", ({
  Llaika_ast_Path$Segments: 1,
  Llaika_ast_GenericPath: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_VirtualPath: 1,
  Llaika_ast_Path: 1,
  Llaika_ast_VirtualPath$Segments: 1
}));
/** @constructor */
function $c_Llaika_ast_RawLink(target, options) {
  this.Llaika_ast_RawLink__f_target = null;
  this.Llaika_ast_RawLink__f_options = null;
  this.Llaika_ast_RawLink__f_supportsExternalTargets = false;
  this.Llaika_ast_RawLink__f_target = target;
  this.Llaika_ast_RawLink__f_options = options;
  this.Llaika_ast_RawLink__f_supportsExternalTargets = true;
}
$c_Llaika_ast_RawLink.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_RawLink.prototype.constructor = $c_Llaika_ast_RawLink;
/** @constructor */
function $h_Llaika_ast_RawLink() {
}
$h_Llaika_ast_RawLink.prototype = $c_Llaika_ast_RawLink.prototype;
$c_Llaika_ast_RawLink.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_RawLink.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_RawLink)) {
    var x$0$2 = $as_Llaika_ast_RawLink(x$0);
    var x = this.Llaika_ast_RawLink__f_target;
    var x$2 = $n(x$0$2).Llaika_ast_RawLink__f_target;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_RawLink__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_RawLink__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_RawLink.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_RawLink.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_RawLink.prototype.productPrefix__T = (function() {
  return "RawLink";
});
$c_Llaika_ast_RawLink.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_RawLink__f_target;
  }
  if ((n === 1)) {
    return this.Llaika_ast_RawLink__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_RawLink.prototype.target__Llaika_ast_Target = (function() {
  return this.Llaika_ast_RawLink__f_target;
});
$c_Llaika_ast_RawLink.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_RawLink__f_options;
});
$c_Llaika_ast_RawLink.prototype.supportsExternalTargets__Z = (function() {
  return this.Llaika_ast_RawLink__f_supportsExternalTargets;
});
$c_Llaika_ast_RawLink.prototype.withTarget__Llaika_ast_Target__Llaika_ast_GlobalLink = (function(target) {
  var options = this.Llaika_ast_RawLink__f_options;
  return new $c_Llaika_ast_RawLink(target, options);
});
$c_Llaika_ast_RawLink.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var target = this.Llaika_ast_RawLink__f_target;
  return new $c_Llaika_ast_RawLink(target, options);
});
function $as_Llaika_ast_RawLink(obj) {
  return (((obj instanceof $c_Llaika_ast_RawLink) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.RawLink"));
}
function $isArrayOf_Llaika_ast_RawLink(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_RawLink)));
}
function $asArrayOf_Llaika_ast_RawLink(obj, depth) {
  return (($isArrayOf_Llaika_ast_RawLink(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.RawLink;", depth));
}
var $d_Llaika_ast_RawLink = new $TypeData().initClass($c_Llaika_ast_RawLink, "laika.ast.RawLink", ({
  Llaika_ast_RawLink: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Link: 1,
  Llaika_ast_GlobalLink: 1
}));
function $p_Llaika_ast_RelativePath$Segments__noSegments$1__Llaika_ast_RelativePath($thiz) {
  if (($thiz.Llaika_ast_RelativePath$Segments__f_parentLevels === 0)) {
    return $m_Llaika_ast_RelativePath$CurrentTree$();
  } else {
    var parentLevels = $thiz.Llaika_ast_RelativePath$Segments__f_parentLevels;
    return new $c_Llaika_ast_RelativePath$Parent(parentLevels);
  }
}
function $p_Llaika_ast_RelativePath$Segments__noSegments$2__I__Llaika_ast_RelativePath($thiz, newParentLevels$1) {
  return ((newParentLevels$1 === 0) ? $m_Llaika_ast_RelativePath$CurrentTree$() : new $c_Llaika_ast_RelativePath$Parent(newParentLevels$1));
}
function $p_Llaika_ast_RelativePath$Segments__construct$1__sci_List__s_Option__s_Option__I__Llaika_ast_RelativePath($thiz, otherSegments, otherSuffix, otherFragment, otherLevels) {
  var $x_1 = $thiz.Llaika_ast_RelativePath$Segments__f_parentLevels;
  var target = $thiz.Llaika_ast_RelativePath$Segments__f_segments;
  var tc = $as_Lcats_UnorderedFoldable($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
  var this$2 = new $c_Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4(target, tc);
  var this$3 = $n(this$2.Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4__f_typeClassInstance).size__O__J(this$2.Lcats_UnorderedFoldable$ToUnorderedFoldableOps$$anon$4__f_self);
  var b = ((otherLevels - this$3.RTLong__f_lo) | 0);
  var newParentLevels = (($x_1 + ((b < 0) ? 0 : b)) | 0);
  var $x_2 = $m_Lcats_data_package$().Lcats_data_package$__f_NonEmptyChain;
  var target$1 = $thiz.Llaika_ast_RelativePath$Segments__f_segments;
  var tc$1 = $as_Lcats_Foldable($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
  var this$6 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(target$1, tc$1);
  var this$7 = $n($n(this$6.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).toList__O__sci_List(this$6.Lcats_Foldable$ToFoldableOps$$anon$6__f_self));
  var this$8 = $n($as_sc_IterableOps($f_sc_StrictOptimizedIterableOps__dropRight__I__O(this$7, otherLevels)));
  var this$9 = $n($n($x_2).fromSeq__sci_Seq__s_Option($as_sci_Seq(this$8.concat__sc_IterableOnce__O(otherSegments))));
  if (this$9.isEmpty__Z()) {
    var $x_3 = $p_Llaika_ast_RelativePath$Segments__noSegments$2__I__Llaika_ast_RelativePath($thiz, newParentLevels);
  } else {
    var arg1 = this$9.get__O();
    var $x_3 = new $c_Llaika_ast_RelativePath$Segments(arg1, otherSuffix, otherFragment, newParentLevels);
  }
  return $as_Llaika_ast_RelativePath($x_3);
}
/** @constructor */
function $c_Llaika_ast_RelativePath$Segments(segments, suffix, fragment, parentLevels) {
  this.Llaika_ast_RelativePath$Segments__f_name$lzy2 = null;
  this.Llaika_ast_RelativePath$Segments__f_namebitmap$2 = false;
  this.Llaika_ast_RelativePath$Segments__f_basename$lzy2 = null;
  this.Llaika_ast_RelativePath$Segments__f_basenamebitmap$2 = false;
  this.Llaika_ast_RelativePath$Segments__f_segments = null;
  this.Llaika_ast_RelativePath$Segments__f_suffix = null;
  this.Llaika_ast_RelativePath$Segments__f_fragment = null;
  this.Llaika_ast_RelativePath$Segments__f_parentLevels = 0;
  this.Llaika_ast_RelativePath$Segments__f_parent$lzy3 = null;
  this.Llaika_ast_RelativePath$Segments__f_parentbitmap$3 = false;
  this.Llaika_ast_RelativePath$Segments__f_pathPrefix = null;
  this.Llaika_ast_RelativePath$Segments__f_segments = segments;
  this.Llaika_ast_RelativePath$Segments__f_suffix = suffix;
  this.Llaika_ast_RelativePath$Segments__f_fragment = fragment;
  this.Llaika_ast_RelativePath$Segments__f_parentLevels = parentLevels;
  this.Llaika_ast_RelativePath$Segments__f_pathPrefix = $m_sc_StringOps$().$times$extension__T__I__T("../", parentLevels);
}
$c_Llaika_ast_RelativePath$Segments.prototype = new $h_O();
$c_Llaika_ast_RelativePath$Segments.prototype.constructor = $c_Llaika_ast_RelativePath$Segments;
/** @constructor */
function $h_Llaika_ast_RelativePath$Segments() {
}
$h_Llaika_ast_RelativePath$Segments.prototype = $c_Llaika_ast_RelativePath$Segments.prototype;
$c_Llaika_ast_RelativePath$Segments.prototype.withFragment__T__Llaika_ast_GenericPath = (function(fragment) {
  return $f_Llaika_ast_GenericPath__withFragment__T__Llaika_ast_GenericPath(this, fragment);
});
$c_Llaika_ast_RelativePath$Segments.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_RelativePath$Segments.prototype.name__T = (function() {
  if ((!this.Llaika_ast_RelativePath$Segments__f_namebitmap$2)) {
    this.Llaika_ast_RelativePath$Segments__f_name$lzy2 = $f_Llaika_ast_VirtualPath$Segments__name__T(this);
    this.Llaika_ast_RelativePath$Segments__f_namebitmap$2 = true;
  }
  return this.Llaika_ast_RelativePath$Segments__f_name$lzy2;
});
$c_Llaika_ast_RelativePath$Segments.prototype.basename__T = (function() {
  if ((!this.Llaika_ast_RelativePath$Segments__f_basenamebitmap$2)) {
    this.Llaika_ast_RelativePath$Segments__f_basename$lzy2 = $f_Llaika_ast_VirtualPath$Segments__basename__T(this);
    this.Llaika_ast_RelativePath$Segments__f_basenamebitmap$2 = true;
  }
  return this.Llaika_ast_RelativePath$Segments__f_basename$lzy2;
});
$c_Llaika_ast_RelativePath$Segments.prototype.toString__T = (function() {
  return $f_Llaika_ast_VirtualPath$Segments__toString__T(this);
});
$c_Llaika_ast_RelativePath$Segments.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Segments");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Llaika_ast_RelativePath$Segments__f_segments;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Llaika_ast_RelativePath$Segments__f_suffix;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Llaika_ast_RelativePath$Segments__f_fragment;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = this.Llaika_ast_RelativePath$Segments__f_parentLevels;
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4);
});
$c_Llaika_ast_RelativePath$Segments.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_RelativePath$Segments)) {
    var x$0$2 = $as_Llaika_ast_RelativePath$Segments(x$0);
    if ((this.Llaika_ast_RelativePath$Segments__f_parentLevels === $n(x$0$2).Llaika_ast_RelativePath$Segments__f_parentLevels)) {
      var x = this.Llaika_ast_RelativePath$Segments__f_segments;
      var y = $n(x$0$2).Llaika_ast_RelativePath$Segments__f_segments;
      var $x_3 = $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$1 = this.Llaika_ast_RelativePath$Segments__f_suffix;
      var x$2 = $n(x$0$2).Llaika_ast_RelativePath$Segments__f_suffix;
      var $x_2 = ((x$1 === null) ? (x$2 === null) : $n(x$1).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Llaika_ast_RelativePath$Segments__f_fragment;
      var x$4 = $n(x$0$2).Llaika_ast_RelativePath$Segments__f_fragment;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_RelativePath$Segments.prototype.productArity__I = (function() {
  return 4;
});
$c_Llaika_ast_RelativePath$Segments.prototype.productPrefix__T = (function() {
  return "Segments";
});
$c_Llaika_ast_RelativePath$Segments.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_RelativePath$Segments__f_segments;
      break;
    }
    case 1: {
      return this.Llaika_ast_RelativePath$Segments__f_suffix;
      break;
    }
    case 2: {
      return this.Llaika_ast_RelativePath$Segments__f_fragment;
      break;
    }
    case 3: {
      return this.Llaika_ast_RelativePath$Segments__f_parentLevels;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_RelativePath$Segments.prototype.segments__O = (function() {
  return this.Llaika_ast_RelativePath$Segments__f_segments;
});
$c_Llaika_ast_RelativePath$Segments.prototype.suffix__s_Option = (function() {
  return this.Llaika_ast_RelativePath$Segments__f_suffix;
});
$c_Llaika_ast_RelativePath$Segments.prototype.fragment__s_Option = (function() {
  return this.Llaika_ast_RelativePath$Segments__f_fragment;
});
$c_Llaika_ast_RelativePath$Segments.prototype.parentLevels__I = (function() {
  return this.Llaika_ast_RelativePath$Segments__f_parentLevels;
});
$c_Llaika_ast_RelativePath$Segments.prototype.parent__Llaika_ast_RelativePath = (function() {
  if ((!this.Llaika_ast_RelativePath$Segments__f_parentbitmap$3)) {
    var $x_1 = $m_Lcats_data_package$().Lcats_data_package$__f_NonEmptyChain;
    var target = this.Llaika_ast_RelativePath$Segments__f_segments;
    var tc = $as_Lcats_Foldable($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
    var this$2 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(target, tc);
    var this$3 = $n($n($x_1).fromSeq__sci_Seq__s_Option($as_sci_Seq($n($n(this$2.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).toList__O__sci_List(this$2.Lcats_Foldable$ToFoldableOps$$anon$6__f_self)).init__O())));
    if (this$3.isEmpty__Z()) {
      var $x_2 = $p_Llaika_ast_RelativePath$Segments__noSegments$1__Llaika_ast_RelativePath(this);
    } else {
      var arg1 = this$3.get__O();
      var suffix = $m_s_None$();
      var fragment = $m_s_None$();
      var parentLevels = this.Llaika_ast_RelativePath$Segments__f_parentLevels;
      var $x_2 = new $c_Llaika_ast_RelativePath$Segments(arg1, suffix, fragment, parentLevels);
    }
    this.Llaika_ast_RelativePath$Segments__f_parent$lzy3 = $as_Llaika_ast_RelativePath($x_2);
    this.Llaika_ast_RelativePath$Segments__f_parentbitmap$3 = true;
  }
  return this.Llaika_ast_RelativePath$Segments__f_parent$lzy3;
});
$c_Llaika_ast_RelativePath$Segments.prototype.$div__Llaika_ast_RelativePath__Llaika_ast_RelativePath = (function(path) {
  matchAlts1: {
    matchAlts2: {
      var x = $m_Llaika_ast_RelativePath$CurrentTree$();
      if ((x === path)) {
        break matchAlts2;
      }
      if ((path instanceof $c_Llaika_ast_RelativePath$CurrentDocument)) {
        var x$1 = $as_Llaika_ast_RelativePath$CurrentDocument(path);
        var this$2 = $n(x$1);
        var x110 = this$2.Llaika_ast_RelativePath$CurrentDocument__f_fragment;
        var x$3 = $m_s_None$();
        if ((x$3 === x110)) {
          break matchAlts2;
        }
      }
      break matchAlts1;
    }
    return this;
  }
  if ((path instanceof $c_Llaika_ast_RelativePath$CurrentDocument)) {
    var x$1$1 = $as_Llaika_ast_RelativePath$CurrentDocument(path);
    var this$4 = $n(x$1$1);
    var x105 = this$4.Llaika_ast_RelativePath$CurrentDocument__f_fragment;
    if ((x105 instanceof $c_s_Some)) {
      var fr = $as_T($n($as_s_Some(x105)).s_Some__f_value);
      return $as_Llaika_ast_RelativePath($f_Llaika_ast_GenericPath__withFragment__T__Llaika_ast_GenericPath(this, fr));
    }
  }
  if ((path instanceof $c_Llaika_ast_RelativePath$Parent)) {
    var x$1$2 = $as_Llaika_ast_RelativePath$Parent(path);
    var this$6 = $n(x$1$2);
    var x102 = this$6.Llaika_ast_RelativePath$Parent__f_parentLevels;
    return $p_Llaika_ast_RelativePath$Segments__construct$1__sci_List__s_Option__s_Option__I__Llaika_ast_RelativePath(this, $m_sci_Nil$(), $m_s_None$(), $m_s_None$(), x102);
  }
  if ((path instanceof $c_Llaika_ast_RelativePath$Segments)) {
    var p = $as_Llaika_ast_RelativePath$Segments(path);
    var target = $n(p).Llaika_ast_RelativePath$Segments__f_segments;
    var tc = $as_Lcats_Foldable($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
    var this$8 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(target, tc);
    return $p_Llaika_ast_RelativePath$Segments__construct$1__sci_List__s_Option__s_Option__I__Llaika_ast_RelativePath(this, $n(this$8.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).toList__O__sci_List(this$8.Lcats_Foldable$ToFoldableOps$$anon$6__f_self), $n(p).Llaika_ast_RelativePath$Segments__f_suffix, $n(p).Llaika_ast_RelativePath$Segments__f_fragment, $n(p).Llaika_ast_RelativePath$Segments__f_parentLevels);
  }
  throw new $c_s_MatchError(path);
});
$c_Llaika_ast_RelativePath$Segments.prototype.copyWith__T__s_Option__s_Option__Llaika_ast_RelativePath = (function(basename, suffix, fragment) {
  var $x_1 = $n($m_Lcats_data_package$().Lcats_data_package$__f_NonEmptyChain);
  $m_Lcats_data_NonEmptyChainImpl$();
  var value = this.Llaika_ast_RelativePath$Segments__f_segments;
  var segments = $n($x_1).fromChainAppend__Lcats_data_Chain__O__O($m_Lcats_data_NonEmptyChainOps$().init$extension__O__Lcats_data_Chain(value), basename);
  var parentLevels = this.Llaika_ast_RelativePath$Segments__f_parentLevels;
  return new $c_Llaika_ast_RelativePath$Segments(segments, suffix, fragment, parentLevels);
});
$c_Llaika_ast_RelativePath$Segments.prototype.copyWith$default$1__T = (function() {
  return this.basename__T();
});
$c_Llaika_ast_RelativePath$Segments.prototype.copyWith$default$2__s_Option = (function() {
  return this.Llaika_ast_RelativePath$Segments__f_suffix;
});
$c_Llaika_ast_RelativePath$Segments.prototype.copyWith$default$3__s_Option = (function() {
  return this.Llaika_ast_RelativePath$Segments__f_fragment;
});
$c_Llaika_ast_RelativePath$Segments.prototype.pathPrefix__T = (function() {
  return this.Llaika_ast_RelativePath$Segments__f_pathPrefix;
});
$c_Llaika_ast_RelativePath$Segments.prototype.$div__Llaika_ast_RelativePath__Llaika_ast_GenericPath = (function(path) {
  return this.$div__Llaika_ast_RelativePath__Llaika_ast_RelativePath(path);
});
$c_Llaika_ast_RelativePath$Segments.prototype.copyWith__T__s_Option__s_Option__Llaika_ast_GenericPath = (function(basename, suffix, fragment) {
  return this.copyWith__T__s_Option__s_Option__Llaika_ast_RelativePath(basename, suffix, fragment);
});
function $as_Llaika_ast_RelativePath$Segments(obj) {
  return (((obj instanceof $c_Llaika_ast_RelativePath$Segments) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.RelativePath$Segments"));
}
function $isArrayOf_Llaika_ast_RelativePath$Segments(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_RelativePath$Segments)));
}
function $asArrayOf_Llaika_ast_RelativePath$Segments(obj, depth) {
  return (($isArrayOf_Llaika_ast_RelativePath$Segments(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.RelativePath$Segments;", depth));
}
var $d_Llaika_ast_RelativePath$Segments = new $TypeData().initClass($c_Llaika_ast_RelativePath$Segments, "laika.ast.RelativePath$Segments", ({
  Llaika_ast_RelativePath$Segments: 1,
  Llaika_ast_GenericPath: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_VirtualPath: 1,
  Llaika_ast_RelativePath: 1,
  Llaika_ast_VirtualPath$Segments: 1
}));
/** @constructor */
function $c_Llaika_ast_RewriteAction$Remove$() {
}
$c_Llaika_ast_RewriteAction$Remove$.prototype = new $h_O();
$c_Llaika_ast_RewriteAction$Remove$.prototype.constructor = $c_Llaika_ast_RewriteAction$Remove$;
/** @constructor */
function $h_Llaika_ast_RewriteAction$Remove$() {
}
$h_Llaika_ast_RewriteAction$Remove$.prototype = $c_Llaika_ast_RewriteAction$Remove$.prototype;
$c_Llaika_ast_RewriteAction$Remove$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_RewriteAction$Remove$.prototype.hashCode__I = (function() {
  return (-1850743644);
});
$c_Llaika_ast_RewriteAction$Remove$.prototype.toString__T = (function() {
  return "Remove";
});
$c_Llaika_ast_RewriteAction$Remove$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_ast_RewriteAction$Remove$.prototype.productPrefix__T = (function() {
  return "Remove";
});
$c_Llaika_ast_RewriteAction$Remove$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_ast_RewriteAction$Remove$ = new $TypeData().initClass($c_Llaika_ast_RewriteAction$Remove$, "laika.ast.RewriteAction$Remove$", ({
  Llaika_ast_RewriteAction$Remove$: 1,
  Llaika_ast_RewriteAction: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_ast_RewriteAction$Remove$;
function $m_Llaika_ast_RewriteAction$Remove$() {
  if ((!$n_Llaika_ast_RewriteAction$Remove$)) {
    $n_Llaika_ast_RewriteAction$Remove$ = new $c_Llaika_ast_RewriteAction$Remove$();
  }
  return $n_Llaika_ast_RewriteAction$Remove$;
}
/** @constructor */
function $c_Llaika_ast_RewriteAction$Retain$() {
}
$c_Llaika_ast_RewriteAction$Retain$.prototype = new $h_O();
$c_Llaika_ast_RewriteAction$Retain$.prototype.constructor = $c_Llaika_ast_RewriteAction$Retain$;
/** @constructor */
function $h_Llaika_ast_RewriteAction$Retain$() {
}
$h_Llaika_ast_RewriteAction$Retain$.prototype = $c_Llaika_ast_RewriteAction$Retain$.prototype;
$c_Llaika_ast_RewriteAction$Retain$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_RewriteAction$Retain$.prototype.hashCode__I = (function() {
  return (-1850548955);
});
$c_Llaika_ast_RewriteAction$Retain$.prototype.toString__T = (function() {
  return "Retain";
});
$c_Llaika_ast_RewriteAction$Retain$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_ast_RewriteAction$Retain$.prototype.productPrefix__T = (function() {
  return "Retain";
});
$c_Llaika_ast_RewriteAction$Retain$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_ast_RewriteAction$Retain$ = new $TypeData().initClass($c_Llaika_ast_RewriteAction$Retain$, "laika.ast.RewriteAction$Retain$", ({
  Llaika_ast_RewriteAction$Retain$: 1,
  Llaika_ast_RewriteAction: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_ast_RewriteAction$Retain$;
function $m_Llaika_ast_RewriteAction$Retain$() {
  if ((!$n_Llaika_ast_RewriteAction$Retain$)) {
    $n_Llaika_ast_RewriteAction$Retain$ = new $c_Llaika_ast_RewriteAction$Retain$();
  }
  return $n_Llaika_ast_RewriteAction$Retain$;
}
/** @constructor */
function $c_Llaika_ast_RewritePhase$Build$() {
}
$c_Llaika_ast_RewritePhase$Build$.prototype = new $h_O();
$c_Llaika_ast_RewritePhase$Build$.prototype.constructor = $c_Llaika_ast_RewritePhase$Build$;
/** @constructor */
function $h_Llaika_ast_RewritePhase$Build$() {
}
$h_Llaika_ast_RewritePhase$Build$.prototype = $c_Llaika_ast_RewritePhase$Build$.prototype;
$c_Llaika_ast_RewritePhase$Build$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_RewritePhase$Build$.prototype.hashCode__I = (function() {
  return 64542286;
});
$c_Llaika_ast_RewritePhase$Build$.prototype.toString__T = (function() {
  return "Build";
});
$c_Llaika_ast_RewritePhase$Build$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_ast_RewritePhase$Build$.prototype.productPrefix__T = (function() {
  return "Build";
});
$c_Llaika_ast_RewritePhase$Build$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_ast_RewritePhase$Build$ = new $TypeData().initClass($c_Llaika_ast_RewritePhase$Build$, "laika.ast.RewritePhase$Build$", ({
  Llaika_ast_RewritePhase$Build$: 1,
  Llaika_ast_RewritePhase: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_ast_RewritePhase$Build$;
function $m_Llaika_ast_RewritePhase$Build$() {
  if ((!$n_Llaika_ast_RewritePhase$Build$)) {
    $n_Llaika_ast_RewritePhase$Build$ = new $c_Llaika_ast_RewritePhase$Build$();
  }
  return $n_Llaika_ast_RewritePhase$Build$;
}
/** @constructor */
function $c_Llaika_ast_RewritePhase$Resolve$() {
}
$c_Llaika_ast_RewritePhase$Resolve$.prototype = new $h_O();
$c_Llaika_ast_RewritePhase$Resolve$.prototype.constructor = $c_Llaika_ast_RewritePhase$Resolve$;
/** @constructor */
function $h_Llaika_ast_RewritePhase$Resolve$() {
}
$h_Llaika_ast_RewritePhase$Resolve$.prototype = $c_Llaika_ast_RewritePhase$Resolve$.prototype;
$c_Llaika_ast_RewritePhase$Resolve$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_RewritePhase$Resolve$.prototype.hashCode__I = (function() {
  return (-1532945972);
});
$c_Llaika_ast_RewritePhase$Resolve$.prototype.toString__T = (function() {
  return "Resolve";
});
$c_Llaika_ast_RewritePhase$Resolve$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_ast_RewritePhase$Resolve$.prototype.productPrefix__T = (function() {
  return "Resolve";
});
$c_Llaika_ast_RewritePhase$Resolve$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_ast_RewritePhase$Resolve$ = new $TypeData().initClass($c_Llaika_ast_RewritePhase$Resolve$, "laika.ast.RewritePhase$Resolve$", ({
  Llaika_ast_RewritePhase$Resolve$: 1,
  Llaika_ast_RewritePhase: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_ast_RewritePhase$Resolve$;
function $m_Llaika_ast_RewritePhase$Resolve$() {
  if ((!$n_Llaika_ast_RewritePhase$Resolve$)) {
    $n_Llaika_ast_RewritePhase$Resolve$ = new $c_Llaika_ast_RewritePhase$Resolve$();
  }
  return $n_Llaika_ast_RewritePhase$Resolve$;
}
/** @constructor */
function $c_Llaika_ast_SectionInfo(id, title, content, options) {
  this.Llaika_ast_SectionInfo__f_id = null;
  this.Llaika_ast_SectionInfo__f_title = null;
  this.Llaika_ast_SectionInfo__f_content = null;
  this.Llaika_ast_SectionInfo__f_options = null;
  this.Llaika_ast_SectionInfo__f_id = id;
  this.Llaika_ast_SectionInfo__f_title = title;
  this.Llaika_ast_SectionInfo__f_content = content;
  this.Llaika_ast_SectionInfo__f_options = options;
}
$c_Llaika_ast_SectionInfo.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_SectionInfo.prototype.constructor = $c_Llaika_ast_SectionInfo;
/** @constructor */
function $h_Llaika_ast_SectionInfo() {
}
$h_Llaika_ast_SectionInfo.prototype = $c_Llaika_ast_SectionInfo.prototype;
$c_Llaika_ast_SectionInfo.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_SectionInfo.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_SectionInfo.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_SectionInfo)) {
    var x$0$2 = $as_Llaika_ast_SectionInfo(x$0);
    if ((this.Llaika_ast_SectionInfo__f_id === $n(x$0$2).Llaika_ast_SectionInfo__f_id)) {
      var x = this.Llaika_ast_SectionInfo__f_title;
      var x$2 = $n(x$0$2).Llaika_ast_SectionInfo__f_title;
      var $x_3 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.Llaika_ast_SectionInfo__f_content;
      var x$4 = $n(x$0$2).Llaika_ast_SectionInfo__f_content;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llaika_ast_SectionInfo__f_options;
      var x$6 = $n(x$0$2).Llaika_ast_SectionInfo__f_options;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_SectionInfo.prototype.productArity__I = (function() {
  return 4;
});
$c_Llaika_ast_SectionInfo.prototype.productPrefix__T = (function() {
  return "SectionInfo";
});
$c_Llaika_ast_SectionInfo.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_SectionInfo__f_id;
      break;
    }
    case 1: {
      return this.Llaika_ast_SectionInfo__f_title;
      break;
    }
    case 2: {
      return this.Llaika_ast_SectionInfo__f_content;
      break;
    }
    case 3: {
      return this.Llaika_ast_SectionInfo__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_SectionInfo.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_SectionInfo__f_content;
});
$c_Llaika_ast_SectionInfo.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_SectionInfo__f_options;
});
$c_Llaika_ast_SectionInfo.prototype.asNavigationItem__Llaika_ast_Path__Llaika_ast_NavigationBuilderContext__Llaika_ast_NavigationItem = (function(docPath, context) {
  var children = ($n(context).Llaika_ast_NavigationBuilderContext__f_isComplete ? $m_sci_Nil$() : $as_sci_Seq($n(this.Llaika_ast_SectionInfo__f_content).map__F1__O(new $c_sjsr_AnonFunction1(((_$3) => {
    var _$3$1 = $as_Llaika_ast_SectionInfo(_$3);
    return $n(_$3$1).asNavigationItem__Llaika_ast_Path__Llaika_ast_NavigationBuilderContext__Llaika_ast_NavigationItem(docPath, $n(context).nextLevel__Llaika_ast_NavigationBuilderContext());
  })))));
  var $x_2 = $n(context);
  var $x_1 = this.Llaika_ast_SectionInfo__f_title;
  var this$1 = $n(docPath);
  var fragment = this.Llaika_ast_SectionInfo__f_id;
  return $n($x_2).newNavigationItem__Llaika_ast_SpanSequence__Llaika_ast_Path__sci_Seq__Llaika_config_TargetFormats__Llaika_ast_NavigationItem($x_1, $as_Llaika_ast_Path($f_Llaika_ast_GenericPath__withFragment__T__Llaika_ast_GenericPath(this$1, fragment)), children, $m_Llaika_config_TargetFormats$All$());
});
$c_Llaika_ast_SectionInfo.prototype.content__O = (function() {
  return this.Llaika_ast_SectionInfo__f_content;
});
$c_Llaika_ast_SectionInfo.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var id = this.Llaika_ast_SectionInfo__f_id;
  var title = this.Llaika_ast_SectionInfo__f_title;
  var content = this.Llaika_ast_SectionInfo__f_content;
  return new $c_Llaika_ast_SectionInfo(id, title, content, options);
});
function $as_Llaika_ast_SectionInfo(obj) {
  return (((obj instanceof $c_Llaika_ast_SectionInfo) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.SectionInfo"));
}
function $isArrayOf_Llaika_ast_SectionInfo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_SectionInfo)));
}
function $asArrayOf_Llaika_ast_SectionInfo(obj, depth) {
  return (($isArrayOf_Llaika_ast_SectionInfo(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.SectionInfo;", depth));
}
var $d_Llaika_ast_SectionInfo = new $TypeData().initClass($c_Llaika_ast_SectionInfo, "laika.ast.SectionInfo", ({
  Llaika_ast_SectionInfo: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_SectionNumber(position, options) {
  this.Llaika_ast_SectionNumber__f_position = null;
  this.Llaika_ast_SectionNumber__f_options = null;
  this.Llaika_ast_SectionNumber__f_content = null;
  this.Llaika_ast_SectionNumber__f_position = position;
  this.Llaika_ast_SectionNumber__f_options = options;
  var this$1 = $n(position);
  this.Llaika_ast_SectionNumber__f_content = ($f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, "", ".", "") + " ");
}
$c_Llaika_ast_SectionNumber.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_SectionNumber.prototype.constructor = $c_Llaika_ast_SectionNumber;
/** @constructor */
function $h_Llaika_ast_SectionNumber() {
}
$h_Llaika_ast_SectionNumber.prototype = $c_Llaika_ast_SectionNumber.prototype;
$c_Llaika_ast_SectionNumber.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_SectionNumber.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_SectionNumber)) {
    var x$0$2 = $as_Llaika_ast_SectionNumber(x$0);
    var x = this.Llaika_ast_SectionNumber__f_position;
    var x$2 = $n(x$0$2).Llaika_ast_SectionNumber__f_position;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_SectionNumber__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_SectionNumber__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_SectionNumber.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_SectionNumber.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_SectionNumber.prototype.productPrefix__T = (function() {
  return "SectionNumber";
});
$c_Llaika_ast_SectionNumber.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_SectionNumber__f_position;
  }
  if ((n === 1)) {
    return this.Llaika_ast_SectionNumber__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_SectionNumber.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_SectionNumber__f_options;
});
$c_Llaika_ast_SectionNumber.prototype.content__T = (function() {
  return this.Llaika_ast_SectionNumber__f_content;
});
$c_Llaika_ast_SectionNumber.prototype.content__O = (function() {
  return this.Llaika_ast_SectionNumber__f_content;
});
$c_Llaika_ast_SectionNumber.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var position = this.Llaika_ast_SectionNumber__f_position;
  return new $c_Llaika_ast_SectionNumber(position, options);
});
function $as_Llaika_ast_SectionNumber(obj) {
  return (((obj instanceof $c_Llaika_ast_SectionNumber) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.SectionNumber"));
}
function $isArrayOf_Llaika_ast_SectionNumber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_SectionNumber)));
}
function $asArrayOf_Llaika_ast_SectionNumber(obj, depth) {
  return (($isArrayOf_Llaika_ast_SectionNumber(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.SectionNumber;", depth));
}
var $d_Llaika_ast_SectionNumber = new $TypeData().initClass($c_Llaika_ast_SectionNumber, "laika.ast.SectionNumber", ({
  Llaika_ast_SectionNumber: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_TextContainer: 1
}));
function $as_Llaika_ast_SpanScope(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.SpanScope"));
}
function $isArrayOf_Llaika_ast_SpanScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_SpanScope)));
}
function $asArrayOf_Llaika_ast_SpanScope(obj, depth) {
  return (($isArrayOf_Llaika_ast_SpanScope(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.SpanScope;", depth));
}
/** @constructor */
function $c_Llaika_ast_Table(head, body, caption, columns, options) {
  this.Llaika_ast_Table__f_head = null;
  this.Llaika_ast_Table__f_body = null;
  this.Llaika_ast_Table__f_caption = null;
  this.Llaika_ast_Table__f_columns = null;
  this.Llaika_ast_Table__f_options = null;
  this.Llaika_ast_Table__f_head = head;
  this.Llaika_ast_Table__f_body = body;
  this.Llaika_ast_Table__f_caption = caption;
  this.Llaika_ast_Table__f_columns = columns;
  this.Llaika_ast_Table__f_options = options;
}
$c_Llaika_ast_Table.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_Table.prototype.constructor = $c_Llaika_ast_Table;
/** @constructor */
function $h_Llaika_ast_Table() {
}
$h_Llaika_ast_Table.prototype = $c_Llaika_ast_Table.prototype;
$c_Llaika_ast_Table.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_Table.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_Table)) {
    var x$0$2 = $as_Llaika_ast_Table(x$0);
    var x = this.Llaika_ast_Table__f_head;
    var x$2 = $n(x$0$2).Llaika_ast_Table__f_head;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_Table__f_body;
      var x$4 = $n(x$0$2).Llaika_ast_Table__f_body;
      var $x_4 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.Llaika_ast_Table__f_caption;
      var x$6 = $n(x$0$2).Llaika_ast_Table__f_caption;
      var $x_3 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.Llaika_ast_Table__f_columns;
      var x$8 = $n(x$0$2).Llaika_ast_Table__f_columns;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.Llaika_ast_Table__f_options;
      var x$10 = $n(x$0$2).Llaika_ast_Table__f_options;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_Table.prototype.productArity__I = (function() {
  return 5;
});
$c_Llaika_ast_Table.prototype.productPrefix__T = (function() {
  return "Table";
});
$c_Llaika_ast_Table.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_Table__f_head;
      break;
    }
    case 1: {
      return this.Llaika_ast_Table__f_body;
      break;
    }
    case 2: {
      return this.Llaika_ast_Table__f_caption;
      break;
    }
    case 3: {
      return this.Llaika_ast_Table__f_columns;
      break;
    }
    case 4: {
      return this.Llaika_ast_Table__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_Table.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_Table__f_options;
});
$c_Llaika_ast_Table.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_Table = (function(rules) {
  var head = $n(this.Llaika_ast_Table__f_head).rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_TableHead(rules);
  var body = $n(this.Llaika_ast_Table__f_body).rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_TableBody(rules);
  var this$1 = $n(this.Llaika_ast_Table__f_caption);
  var caption = $as_Llaika_ast_Caption($f_Llaika_ast_SpanContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_SpanContainer(this$1, rules));
  var columns = this.Llaika_ast_Table__f_columns;
  var options = this.Llaika_ast_Table__f_options;
  return new $c_Llaika_ast_Table(head, body, caption, columns, options);
});
$c_Llaika_ast_Table.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_Table.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return this.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_Table(rules);
});
$c_Llaika_ast_Table.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var head = this.Llaika_ast_Table__f_head;
  var body = this.Llaika_ast_Table__f_body;
  var caption = this.Llaika_ast_Table__f_caption;
  var columns = this.Llaika_ast_Table__f_columns;
  return new $c_Llaika_ast_Table(head, body, caption, columns, options);
});
function $as_Llaika_ast_Table(obj) {
  return (((obj instanceof $c_Llaika_ast_Table) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Table"));
}
function $isArrayOf_Llaika_ast_Table(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Table)));
}
function $asArrayOf_Llaika_ast_Table(obj, depth) {
  return (($isArrayOf_Llaika_ast_Table(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Table;", depth));
}
var $d_Llaika_ast_Table = new $TypeData().initClass($c_Llaika_ast_Table, "laika.ast.Table", ({
  Llaika_ast_Table: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_RewritableContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_TargetValidation$ValidTarget$() {
}
$c_Llaika_ast_TargetValidation$ValidTarget$.prototype = new $h_O();
$c_Llaika_ast_TargetValidation$ValidTarget$.prototype.constructor = $c_Llaika_ast_TargetValidation$ValidTarget$;
/** @constructor */
function $h_Llaika_ast_TargetValidation$ValidTarget$() {
}
$h_Llaika_ast_TargetValidation$ValidTarget$.prototype = $c_Llaika_ast_TargetValidation$ValidTarget$.prototype;
$c_Llaika_ast_TargetValidation$ValidTarget$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_TargetValidation$ValidTarget$.prototype.hashCode__I = (function() {
  return (-72046451);
});
$c_Llaika_ast_TargetValidation$ValidTarget$.prototype.toString__T = (function() {
  return "ValidTarget";
});
$c_Llaika_ast_TargetValidation$ValidTarget$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_ast_TargetValidation$ValidTarget$.prototype.productPrefix__T = (function() {
  return "ValidTarget";
});
$c_Llaika_ast_TargetValidation$ValidTarget$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_ast_TargetValidation$ValidTarget$ = new $TypeData().initClass($c_Llaika_ast_TargetValidation$ValidTarget$, "laika.ast.TargetValidation$ValidTarget$", ({
  Llaika_ast_TargetValidation$ValidTarget$: 1,
  Llaika_ast_TargetValidation: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_ast_TargetValidation$ValidTarget$;
function $m_Llaika_ast_TargetValidation$ValidTarget$() {
  if ((!$n_Llaika_ast_TargetValidation$ValidTarget$)) {
    $n_Llaika_ast_TargetValidation$ValidTarget$ = new $c_Llaika_ast_TargetValidation$ValidTarget$();
  }
  return $n_Llaika_ast_TargetValidation$ValidTarget$;
}
/** @constructor */
function $c_Llaika_ast_Text(content, options) {
  this.Llaika_ast_Text__f_content = null;
  this.Llaika_ast_Text__f_options = null;
  this.Llaika_ast_Text__f_content = content;
  this.Llaika_ast_Text__f_options = options;
}
$c_Llaika_ast_Text.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_Text.prototype.constructor = $c_Llaika_ast_Text;
/** @constructor */
function $h_Llaika_ast_Text() {
}
$h_Llaika_ast_Text.prototype = $c_Llaika_ast_Text.prototype;
$c_Llaika_ast_Text.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_Text.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_Text)) {
    var x$0$2 = $as_Llaika_ast_Text(x$0);
    if ((this.Llaika_ast_Text__f_content === $n(x$0$2).Llaika_ast_Text__f_content)) {
      var x = this.Llaika_ast_Text__f_options;
      var x$2 = $n(x$0$2).Llaika_ast_Text__f_options;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_Text.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_Text.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_Text.prototype.productPrefix__T = (function() {
  return "Text";
});
$c_Llaika_ast_Text.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_Text__f_content;
  }
  if ((n === 1)) {
    return this.Llaika_ast_Text__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_Text.prototype.content__T = (function() {
  return this.Llaika_ast_Text__f_content;
});
$c_Llaika_ast_Text.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_Text__f_options;
});
$c_Llaika_ast_Text.prototype.content__O = (function() {
  return this.Llaika_ast_Text__f_content;
});
$c_Llaika_ast_Text.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_Text__f_content;
  return new $c_Llaika_ast_Text(content, options);
});
function $as_Llaika_ast_Text(obj) {
  return (((obj instanceof $c_Llaika_ast_Text) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Text"));
}
function $isArrayOf_Llaika_ast_Text(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Text)));
}
function $asArrayOf_Llaika_ast_Text(obj, depth) {
  return (($isArrayOf_Llaika_ast_Text(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Text;", depth));
}
var $d_Llaika_ast_Text = new $TypeData().initClass($c_Llaika_ast_Text, "laika.ast.Text", ({
  Llaika_ast_Text: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_TextContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_TreeNodeIndex$Inherit$() {
}
$c_Llaika_ast_TreeNodeIndex$Inherit$.prototype = new $h_O();
$c_Llaika_ast_TreeNodeIndex$Inherit$.prototype.constructor = $c_Llaika_ast_TreeNodeIndex$Inherit$;
/** @constructor */
function $h_Llaika_ast_TreeNodeIndex$Inherit$() {
}
$h_Llaika_ast_TreeNodeIndex$Inherit$.prototype = $c_Llaika_ast_TreeNodeIndex$Inherit$.prototype;
$c_Llaika_ast_TreeNodeIndex$Inherit$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_TreeNodeIndex$Inherit$.prototype.hashCode__I = (function() {
  return (-683333413);
});
$c_Llaika_ast_TreeNodeIndex$Inherit$.prototype.toString__T = (function() {
  return "Inherit";
});
$c_Llaika_ast_TreeNodeIndex$Inherit$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_ast_TreeNodeIndex$Inherit$.prototype.productPrefix__T = (function() {
  return "Inherit";
});
$c_Llaika_ast_TreeNodeIndex$Inherit$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_ast_TreeNodeIndex$Inherit$ = new $TypeData().initClass($c_Llaika_ast_TreeNodeIndex$Inherit$, "laika.ast.TreeNodeIndex$Inherit$", ({
  Llaika_ast_TreeNodeIndex$Inherit$: 1,
  Llaika_ast_TreeNodeIndex: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_ast_TreeNodeIndex$Inherit$;
function $m_Llaika_ast_TreeNodeIndex$Inherit$() {
  if ((!$n_Llaika_ast_TreeNodeIndex$Inherit$)) {
    $n_Llaika_ast_TreeNodeIndex$Inherit$ = new $c_Llaika_ast_TreeNodeIndex$Inherit$();
  }
  return $n_Llaika_ast_TreeNodeIndex$Inherit$;
}
/** @constructor */
function $c_Llaika_ast_TreeNodeIndex$Unassigned$() {
}
$c_Llaika_ast_TreeNodeIndex$Unassigned$.prototype = new $h_O();
$c_Llaika_ast_TreeNodeIndex$Unassigned$.prototype.constructor = $c_Llaika_ast_TreeNodeIndex$Unassigned$;
/** @constructor */
function $h_Llaika_ast_TreeNodeIndex$Unassigned$() {
}
$h_Llaika_ast_TreeNodeIndex$Unassigned$.prototype = $c_Llaika_ast_TreeNodeIndex$Unassigned$.prototype;
$c_Llaika_ast_TreeNodeIndex$Unassigned$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_TreeNodeIndex$Unassigned$.prototype.hashCode__I = (function() {
  return (-1145155705);
});
$c_Llaika_ast_TreeNodeIndex$Unassigned$.prototype.toString__T = (function() {
  return "Unassigned";
});
$c_Llaika_ast_TreeNodeIndex$Unassigned$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_ast_TreeNodeIndex$Unassigned$.prototype.productPrefix__T = (function() {
  return "Unassigned";
});
$c_Llaika_ast_TreeNodeIndex$Unassigned$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_ast_TreeNodeIndex$Unassigned$ = new $TypeData().initClass($c_Llaika_ast_TreeNodeIndex$Unassigned$, "laika.ast.TreeNodeIndex$Unassigned$", ({
  Llaika_ast_TreeNodeIndex$Unassigned$: 1,
  Llaika_ast_TreeNodeIndex: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_ast_TreeNodeIndex$Unassigned$;
function $m_Llaika_ast_TreeNodeIndex$Unassigned$() {
  if ((!$n_Llaika_ast_TreeNodeIndex$Unassigned$)) {
    $n_Llaika_ast_TreeNodeIndex$Unassigned$ = new $c_Llaika_ast_TreeNodeIndex$Unassigned$();
  }
  return $n_Llaika_ast_TreeNodeIndex$Unassigned$;
}
/** @constructor */
function $c_Llaika_ast_html_HTMLEmptyElement(name, attributes, options) {
  this.Llaika_ast_html_HTMLEmptyElement__f_name = null;
  this.Llaika_ast_html_HTMLEmptyElement__f_attributes = null;
  this.Llaika_ast_html_HTMLEmptyElement__f_options = null;
  this.Llaika_ast_html_HTMLEmptyElement__f_name = name;
  this.Llaika_ast_html_HTMLEmptyElement__f_attributes = attributes;
  this.Llaika_ast_html_HTMLEmptyElement__f_options = options;
}
$c_Llaika_ast_html_HTMLEmptyElement.prototype = new $h_Llaika_ast_html_HTMLSpan();
$c_Llaika_ast_html_HTMLEmptyElement.prototype.constructor = $c_Llaika_ast_html_HTMLEmptyElement;
/** @constructor */
function $h_Llaika_ast_html_HTMLEmptyElement() {
}
$h_Llaika_ast_html_HTMLEmptyElement.prototype = $c_Llaika_ast_html_HTMLEmptyElement.prototype;
$c_Llaika_ast_html_HTMLEmptyElement.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_html_HTMLEmptyElement.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_html_HTMLEmptyElement)) {
    var x$0$2 = $as_Llaika_ast_html_HTMLEmptyElement(x$0);
    if ((this.Llaika_ast_html_HTMLEmptyElement__f_name === $n(x$0$2).Llaika_ast_html_HTMLEmptyElement__f_name)) {
      var x = this.Llaika_ast_html_HTMLEmptyElement__f_attributes;
      var x$2 = $n(x$0$2).Llaika_ast_html_HTMLEmptyElement__f_attributes;
      var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Llaika_ast_html_HTMLEmptyElement__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_html_HTMLEmptyElement__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_html_HTMLEmptyElement.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_html_HTMLEmptyElement.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_html_HTMLEmptyElement.prototype.productPrefix__T = (function() {
  return "HTMLEmptyElement";
});
$c_Llaika_ast_html_HTMLEmptyElement.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_html_HTMLEmptyElement__f_name;
      break;
    }
    case 1: {
      return this.Llaika_ast_html_HTMLEmptyElement__f_attributes;
      break;
    }
    case 2: {
      return this.Llaika_ast_html_HTMLEmptyElement__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_html_HTMLEmptyElement.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_html_HTMLEmptyElement__f_options;
});
$c_Llaika_ast_html_HTMLEmptyElement.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var name = this.Llaika_ast_html_HTMLEmptyElement__f_name;
  var attributes = this.Llaika_ast_html_HTMLEmptyElement__f_attributes;
  return new $c_Llaika_ast_html_HTMLEmptyElement(name, attributes, options);
});
function $as_Llaika_ast_html_HTMLEmptyElement(obj) {
  return (((obj instanceof $c_Llaika_ast_html_HTMLEmptyElement) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.html.HTMLEmptyElement"));
}
function $isArrayOf_Llaika_ast_html_HTMLEmptyElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_html_HTMLEmptyElement)));
}
function $asArrayOf_Llaika_ast_html_HTMLEmptyElement(obj, depth) {
  return (($isArrayOf_Llaika_ast_html_HTMLEmptyElement(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.html.HTMLEmptyElement;", depth));
}
var $d_Llaika_ast_html_HTMLEmptyElement = new $TypeData().initClass($c_Llaika_ast_html_HTMLEmptyElement, "laika.ast.html.HTMLEmptyElement", ({
  Llaika_ast_html_HTMLEmptyElement: 1,
  Llaika_ast_html_HTMLSpan: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Block: 1
}));
/** @constructor */
function $c_Llaika_ast_html_HTMLStartTag(name, attributes, options) {
  this.Llaika_ast_html_HTMLStartTag__f_name = null;
  this.Llaika_ast_html_HTMLStartTag__f_attributes = null;
  this.Llaika_ast_html_HTMLStartTag__f_options = null;
  this.Llaika_ast_html_HTMLStartTag__f_name = name;
  this.Llaika_ast_html_HTMLStartTag__f_attributes = attributes;
  this.Llaika_ast_html_HTMLStartTag__f_options = options;
}
$c_Llaika_ast_html_HTMLStartTag.prototype = new $h_Llaika_ast_html_HTMLSpan();
$c_Llaika_ast_html_HTMLStartTag.prototype.constructor = $c_Llaika_ast_html_HTMLStartTag;
/** @constructor */
function $h_Llaika_ast_html_HTMLStartTag() {
}
$h_Llaika_ast_html_HTMLStartTag.prototype = $c_Llaika_ast_html_HTMLStartTag.prototype;
$c_Llaika_ast_html_HTMLStartTag.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_html_HTMLStartTag.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_html_HTMLStartTag)) {
    var x$0$2 = $as_Llaika_ast_html_HTMLStartTag(x$0);
    if ((this.Llaika_ast_html_HTMLStartTag__f_name === $n(x$0$2).Llaika_ast_html_HTMLStartTag__f_name)) {
      var x = this.Llaika_ast_html_HTMLStartTag__f_attributes;
      var x$2 = $n(x$0$2).Llaika_ast_html_HTMLStartTag__f_attributes;
      var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Llaika_ast_html_HTMLStartTag__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_html_HTMLStartTag__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_html_HTMLStartTag.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_html_HTMLStartTag.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_html_HTMLStartTag.prototype.productPrefix__T = (function() {
  return "HTMLStartTag";
});
$c_Llaika_ast_html_HTMLStartTag.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_html_HTMLStartTag__f_name;
      break;
    }
    case 1: {
      return this.Llaika_ast_html_HTMLStartTag__f_attributes;
      break;
    }
    case 2: {
      return this.Llaika_ast_html_HTMLStartTag__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_html_HTMLStartTag.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_html_HTMLStartTag__f_options;
});
$c_Llaika_ast_html_HTMLStartTag.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var name = this.Llaika_ast_html_HTMLStartTag__f_name;
  var attributes = this.Llaika_ast_html_HTMLStartTag__f_attributes;
  return new $c_Llaika_ast_html_HTMLStartTag(name, attributes, options);
});
function $as_Llaika_ast_html_HTMLStartTag(obj) {
  return (((obj instanceof $c_Llaika_ast_html_HTMLStartTag) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.html.HTMLStartTag"));
}
function $isArrayOf_Llaika_ast_html_HTMLStartTag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_html_HTMLStartTag)));
}
function $asArrayOf_Llaika_ast_html_HTMLStartTag(obj, depth) {
  return (($isArrayOf_Llaika_ast_html_HTMLStartTag(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.html.HTMLStartTag;", depth));
}
var $d_Llaika_ast_html_HTMLStartTag = new $TypeData().initClass($c_Llaika_ast_html_HTMLStartTag, "laika.ast.html.HTMLStartTag", ({
  Llaika_ast_html_HTMLStartTag: 1,
  Llaika_ast_html_HTMLSpan: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Block: 1
}));
/** @constructor */
function $c_Llaika_config_LinkValidation$Local$() {
}
$c_Llaika_config_LinkValidation$Local$.prototype = new $h_O();
$c_Llaika_config_LinkValidation$Local$.prototype.constructor = $c_Llaika_config_LinkValidation$Local$;
/** @constructor */
function $h_Llaika_config_LinkValidation$Local$() {
}
$h_Llaika_config_LinkValidation$Local$.prototype = $c_Llaika_config_LinkValidation$Local$.prototype;
$c_Llaika_config_LinkValidation$Local$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_config_LinkValidation$Local$.prototype.hashCode__I = (function() {
  return 73592651;
});
$c_Llaika_config_LinkValidation$Local$.prototype.toString__T = (function() {
  return "Local";
});
$c_Llaika_config_LinkValidation$Local$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_config_LinkValidation$Local$.prototype.productPrefix__T = (function() {
  return "Local";
});
$c_Llaika_config_LinkValidation$Local$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_config_LinkValidation$Local$ = new $TypeData().initClass($c_Llaika_config_LinkValidation$Local$, "laika.config.LinkValidation$Local$", ({
  Llaika_config_LinkValidation$Local$: 1,
  Llaika_config_LinkValidation: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_config_LinkValidation$Local$;
function $m_Llaika_config_LinkValidation$Local$() {
  if ((!$n_Llaika_config_LinkValidation$Local$)) {
    $n_Llaika_config_LinkValidation$Local$ = new $c_Llaika_config_LinkValidation$Local$();
  }
  return $n_Llaika_config_LinkValidation$Local$;
}
/** @constructor */
function $c_Llaika_config_LinkValidation$Off$() {
}
$c_Llaika_config_LinkValidation$Off$.prototype = new $h_O();
$c_Llaika_config_LinkValidation$Off$.prototype.constructor = $c_Llaika_config_LinkValidation$Off$;
/** @constructor */
function $h_Llaika_config_LinkValidation$Off$() {
}
$h_Llaika_config_LinkValidation$Off$.prototype = $c_Llaika_config_LinkValidation$Off$.prototype;
$c_Llaika_config_LinkValidation$Off$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_config_LinkValidation$Off$.prototype.hashCode__I = (function() {
  return 79183;
});
$c_Llaika_config_LinkValidation$Off$.prototype.toString__T = (function() {
  return "Off";
});
$c_Llaika_config_LinkValidation$Off$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_config_LinkValidation$Off$.prototype.productPrefix__T = (function() {
  return "Off";
});
$c_Llaika_config_LinkValidation$Off$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_config_LinkValidation$Off$ = new $TypeData().initClass($c_Llaika_config_LinkValidation$Off$, "laika.config.LinkValidation$Off$", ({
  Llaika_config_LinkValidation$Off$: 1,
  Llaika_config_LinkValidation: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_config_LinkValidation$Off$;
function $m_Llaika_config_LinkValidation$Off$() {
  if ((!$n_Llaika_config_LinkValidation$Off$)) {
    $n_Llaika_config_LinkValidation$Off$ = new $c_Llaika_config_LinkValidation$Off$();
  }
  return $n_Llaika_config_LinkValidation$Off$;
}
/** @constructor */
function $c_Llaika_config_MessageFilter$None$() {
}
$c_Llaika_config_MessageFilter$None$.prototype = new $h_O();
$c_Llaika_config_MessageFilter$None$.prototype.constructor = $c_Llaika_config_MessageFilter$None$;
/** @constructor */
function $h_Llaika_config_MessageFilter$None$() {
}
$h_Llaika_config_MessageFilter$None$.prototype = $c_Llaika_config_MessageFilter$None$.prototype;
$c_Llaika_config_MessageFilter$None$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_config_MessageFilter$None$.prototype.hashCode__I = (function() {
  return 2433880;
});
$c_Llaika_config_MessageFilter$None$.prototype.toString__T = (function() {
  return "None";
});
$c_Llaika_config_MessageFilter$None$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_config_MessageFilter$None$.prototype.productPrefix__T = (function() {
  return "None";
});
$c_Llaika_config_MessageFilter$None$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_config_MessageFilter$None$.prototype.apply__Llaika_ast_RuntimeMessage__Z = (function(message) {
  return false;
});
var $d_Llaika_config_MessageFilter$None$ = new $TypeData().initClass($c_Llaika_config_MessageFilter$None$, "laika.config.MessageFilter$None$", ({
  Llaika_config_MessageFilter$None$: 1,
  Llaika_config_MessageFilter: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_config_MessageFilter$None$;
function $m_Llaika_config_MessageFilter$None$() {
  if ((!$n_Llaika_config_MessageFilter$None$)) {
    $n_Llaika_config_MessageFilter$None$ = new $c_Llaika_config_MessageFilter$None$();
  }
  return $n_Llaika_config_MessageFilter$None$;
}
/** @constructor */
function $c_Llaika_config_Scope$All$() {
}
$c_Llaika_config_Scope$All$.prototype = new $h_O();
$c_Llaika_config_Scope$All$.prototype.constructor = $c_Llaika_config_Scope$All$;
/** @constructor */
function $h_Llaika_config_Scope$All$() {
}
$h_Llaika_config_Scope$All$.prototype = $c_Llaika_config_Scope$All$.prototype;
$c_Llaika_config_Scope$All$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_config_Scope$All$.prototype.hashCode__I = (function() {
  return 65921;
});
$c_Llaika_config_Scope$All$.prototype.toString__T = (function() {
  return "All";
});
$c_Llaika_config_Scope$All$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_config_Scope$All$.prototype.productPrefix__T = (function() {
  return "All";
});
$c_Llaika_config_Scope$All$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_config_Scope$All$ = new $TypeData().initClass($c_Llaika_config_Scope$All$, "laika.config.Scope$All$", ({
  Llaika_config_Scope$All$: 1,
  Llaika_config_Scope: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_config_Scope$All$;
function $m_Llaika_config_Scope$All$() {
  if ((!$n_Llaika_config_Scope$All$)) {
    $n_Llaika_config_Scope$All$ = new $c_Llaika_config_Scope$All$();
  }
  return $n_Llaika_config_Scope$All$;
}
/** @constructor */
function $c_Llaika_config_Scope$Documents$() {
}
$c_Llaika_config_Scope$Documents$.prototype = new $h_O();
$c_Llaika_config_Scope$Documents$.prototype.constructor = $c_Llaika_config_Scope$Documents$;
/** @constructor */
function $h_Llaika_config_Scope$Documents$() {
}
$h_Llaika_config_Scope$Documents$.prototype = $c_Llaika_config_Scope$Documents$.prototype;
$c_Llaika_config_Scope$Documents$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_config_Scope$Documents$.prototype.hashCode__I = (function() {
  return (-1347456360);
});
$c_Llaika_config_Scope$Documents$.prototype.toString__T = (function() {
  return "Documents";
});
$c_Llaika_config_Scope$Documents$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_config_Scope$Documents$.prototype.productPrefix__T = (function() {
  return "Documents";
});
$c_Llaika_config_Scope$Documents$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_config_Scope$Documents$ = new $TypeData().initClass($c_Llaika_config_Scope$Documents$, "laika.config.Scope$Documents$", ({
  Llaika_config_Scope$Documents$: 1,
  Llaika_config_Scope: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_config_Scope$Documents$;
function $m_Llaika_config_Scope$Documents$() {
  if ((!$n_Llaika_config_Scope$Documents$)) {
    $n_Llaika_config_Scope$Documents$ = new $c_Llaika_config_Scope$Documents$();
  }
  return $n_Llaika_config_Scope$Documents$;
}
/** @constructor */
function $c_Llaika_config_Scope$None$() {
}
$c_Llaika_config_Scope$None$.prototype = new $h_O();
$c_Llaika_config_Scope$None$.prototype.constructor = $c_Llaika_config_Scope$None$;
/** @constructor */
function $h_Llaika_config_Scope$None$() {
}
$h_Llaika_config_Scope$None$.prototype = $c_Llaika_config_Scope$None$.prototype;
$c_Llaika_config_Scope$None$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_config_Scope$None$.prototype.hashCode__I = (function() {
  return 2433880;
});
$c_Llaika_config_Scope$None$.prototype.toString__T = (function() {
  return "None";
});
$c_Llaika_config_Scope$None$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_config_Scope$None$.prototype.productPrefix__T = (function() {
  return "None";
});
$c_Llaika_config_Scope$None$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_config_Scope$None$ = new $TypeData().initClass($c_Llaika_config_Scope$None$, "laika.config.Scope$None$", ({
  Llaika_config_Scope$None$: 1,
  Llaika_config_Scope: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_config_Scope$None$;
function $m_Llaika_config_Scope$None$() {
  if ((!$n_Llaika_config_Scope$None$)) {
    $n_Llaika_config_Scope$None$ = new $c_Llaika_config_Scope$None$();
  }
  return $n_Llaika_config_Scope$None$;
}
/** @constructor */
function $c_Llaika_config_Scope$Sections$() {
}
$c_Llaika_config_Scope$Sections$.prototype = new $h_O();
$c_Llaika_config_Scope$Sections$.prototype.constructor = $c_Llaika_config_Scope$Sections$;
/** @constructor */
function $h_Llaika_config_Scope$Sections$() {
}
$h_Llaika_config_Scope$Sections$.prototype = $c_Llaika_config_Scope$Sections$.prototype;
$c_Llaika_config_Scope$Sections$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_config_Scope$Sections$.prototype.hashCode__I = (function() {
  return 1012580942;
});
$c_Llaika_config_Scope$Sections$.prototype.toString__T = (function() {
  return "Sections";
});
$c_Llaika_config_Scope$Sections$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_config_Scope$Sections$.prototype.productPrefix__T = (function() {
  return "Sections";
});
$c_Llaika_config_Scope$Sections$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_config_Scope$Sections$ = new $TypeData().initClass($c_Llaika_config_Scope$Sections$, "laika.config.Scope$Sections$", ({
  Llaika_config_Scope$Sections$: 1,
  Llaika_config_Scope: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_config_Scope$Sections$;
function $m_Llaika_config_Scope$Sections$() {
  if ((!$n_Llaika_config_Scope$Sections$)) {
    $n_Llaika_config_Scope$Sections$ = new $c_Llaika_config_Scope$Sections$();
  }
  return $n_Llaika_config_Scope$Sections$;
}
/** @constructor */
function $c_Llaika_config_TargetFormats$All$() {
}
$c_Llaika_config_TargetFormats$All$.prototype = new $h_O();
$c_Llaika_config_TargetFormats$All$.prototype.constructor = $c_Llaika_config_TargetFormats$All$;
/** @constructor */
function $h_Llaika_config_TargetFormats$All$() {
}
$h_Llaika_config_TargetFormats$All$.prototype = $c_Llaika_config_TargetFormats$All$.prototype;
$c_Llaika_config_TargetFormats$All$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_config_TargetFormats$All$.prototype.hashCode__I = (function() {
  return 65921;
});
$c_Llaika_config_TargetFormats$All$.prototype.toString__T = (function() {
  return "All";
});
$c_Llaika_config_TargetFormats$All$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_config_TargetFormats$All$.prototype.productPrefix__T = (function() {
  return "All";
});
$c_Llaika_config_TargetFormats$All$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_config_TargetFormats$All$.prototype.contains__T__Z = (function(format) {
  return true;
});
var $d_Llaika_config_TargetFormats$All$ = new $TypeData().initClass($c_Llaika_config_TargetFormats$All$, "laika.config.TargetFormats$All$", ({
  Llaika_config_TargetFormats$All$: 1,
  Llaika_config_TargetFormats: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_config_TargetFormats$All$;
function $m_Llaika_config_TargetFormats$All$() {
  if ((!$n_Llaika_config_TargetFormats$All$)) {
    $n_Llaika_config_TargetFormats$All$ = new $c_Llaika_config_TargetFormats$All$();
  }
  return $n_Llaika_config_TargetFormats$All$;
}
/** @constructor */
function $c_Llaika_config_TargetFormats$None$() {
}
$c_Llaika_config_TargetFormats$None$.prototype = new $h_O();
$c_Llaika_config_TargetFormats$None$.prototype.constructor = $c_Llaika_config_TargetFormats$None$;
/** @constructor */
function $h_Llaika_config_TargetFormats$None$() {
}
$h_Llaika_config_TargetFormats$None$.prototype = $c_Llaika_config_TargetFormats$None$.prototype;
$c_Llaika_config_TargetFormats$None$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_config_TargetFormats$None$.prototype.hashCode__I = (function() {
  return 2433880;
});
$c_Llaika_config_TargetFormats$None$.prototype.toString__T = (function() {
  return "None";
});
$c_Llaika_config_TargetFormats$None$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_config_TargetFormats$None$.prototype.productPrefix__T = (function() {
  return "None";
});
$c_Llaika_config_TargetFormats$None$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_config_TargetFormats$None$.prototype.contains__T__Z = (function(format) {
  return false;
});
var $d_Llaika_config_TargetFormats$None$ = new $TypeData().initClass($c_Llaika_config_TargetFormats$None$, "laika.config.TargetFormats$None$", ({
  Llaika_config_TargetFormats$None$: 1,
  Llaika_config_TargetFormats: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_config_TargetFormats$None$;
function $m_Llaika_config_TargetFormats$None$() {
  if ((!$n_Llaika_config_TargetFormats$None$)) {
    $n_Llaika_config_TargetFormats$None$ = new $c_Llaika_config_TargetFormats$None$();
  }
  return $n_Llaika_config_TargetFormats$None$;
}
/** @constructor */
function $c_Llaika_format_AST$() {
  this.Llaika_format_AST$__f_Overrides$lzy1 = null;
  this.Llaika_format_AST$__f_Overridesbitmap$1 = false;
  this.Llaika_format_AST$__f_fileSuffix = null;
  this.Llaika_format_AST$__f_defaultRenderer = null;
  this.Llaika_format_AST$__f_formatterFactory = null;
  $n_Llaika_format_AST$ = this;
  this.Llaika_format_AST$__f_fileSuffix = "txt";
  this.Llaika_format_AST$__f_defaultRenderer = $m_Llaika_internal_render_ASTRenderer$();
  this.Llaika_format_AST$__f_formatterFactory = new $c_sjsr_AnonFunction1(((context) => {
    var context$1 = $as_Llaika_api_format_Formatter$Context(context);
    var $x_1 = $m_Llaika_api_format_Formatter$().defaultFactory__F1();
    var this$2 = $n(context$1);
    var newValue = $m_Llaika_api_format_Formatter$Indentation$().Llaika_api_format_Formatter$Indentation$__f_dotted;
    return $as_Llaika_api_format_Formatter($n($x_1).apply__O__O(new $c_Llaika_api_format_Formatter$Context(this$2.Llaika_api_format_Formatter$Context__f_renderChild, this$2.Llaika_api_format_Formatter$Context__f_currentElement, this$2.Llaika_api_format_Formatter$Context__f_parents, this$2.Llaika_api_format_Formatter$Context__f_styles, this$2.Llaika_api_format_Formatter$Context__f_path, this$2.Llaika_api_format_Formatter$Context__f_pathTranslator, newValue, this$2.Llaika_api_format_Formatter$Context__f_messageFilter)));
  }));
}
$c_Llaika_format_AST$.prototype = new $h_O();
$c_Llaika_format_AST$.prototype.constructor = $c_Llaika_format_AST$;
/** @constructor */
function $h_Llaika_format_AST$() {
}
$h_Llaika_format_AST$.prototype = $c_Llaika_format_AST$.prototype;
$c_Llaika_format_AST$.prototype.Overrides__Llaika_api_format_RenderFormat$Overrides$ = (function() {
  if ((!this.Llaika_format_AST$__f_Overridesbitmap$1)) {
    this.Llaika_format_AST$__f_Overrides$lzy1 = new $c_Llaika_api_format_RenderFormat$Overrides$(this);
    this.Llaika_format_AST$__f_Overridesbitmap$1 = true;
  }
  return this.Llaika_format_AST$__f_Overrides$lzy1;
});
$c_Llaika_format_AST$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_format_AST$.prototype.hashCode__I = (function() {
  return 65122;
});
$c_Llaika_format_AST$.prototype.toString__T = (function() {
  return "AST";
});
$c_Llaika_format_AST$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_format_AST$.prototype.productPrefix__T = (function() {
  return "AST";
});
$c_Llaika_format_AST$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_format_AST$.prototype.fileSuffix__T = (function() {
  return "txt";
});
$c_Llaika_format_AST$.prototype.defaultRenderer__F2 = (function() {
  return $m_Llaika_internal_render_ASTRenderer$();
});
$c_Llaika_format_AST$.prototype.formatterFactory__F1 = (function() {
  return this.Llaika_format_AST$__f_formatterFactory;
});
var $d_Llaika_format_AST$ = new $TypeData().initClass($c_Llaika_format_AST$, "laika.format.AST$", ({
  Llaika_format_AST$: 1,
  Llaika_api_format_RenderFormat: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_format_AST$;
function $m_Llaika_format_AST$() {
  if ((!$n_Llaika_format_AST$)) {
    $n_Llaika_format_AST$ = new $c_Llaika_format_AST$();
  }
  return $n_Llaika_format_AST$;
}
/** @constructor */
function $c_Llaika_format_HTML$() {
  this.Llaika_format_HTML$__f_Overrides$lzy1 = null;
  this.Llaika_format_HTML$__f_Overridesbitmap$1 = false;
  this.Llaika_format_HTML$__f_fileSuffix = null;
  this.Llaika_format_HTML$__f_defaultRenderer = null;
  this.Llaika_format_HTML$__f_formatterFactory = null;
  $n_Llaika_format_HTML$ = this;
  this.Llaika_format_HTML$__f_fileSuffix = "html";
  this.Llaika_format_HTML$__f_defaultRenderer = $m_Llaika_internal_render_HTMLRenderer$();
  this.Llaika_format_HTML$__f_formatterFactory = new $c_sjsr_AnonFunction1(((context) => {
    var context$1 = $as_Llaika_api_format_Formatter$Context(context);
    return new $c_Llaika_internal_render_HTMLFormatter(false, context$1);
  }));
}
$c_Llaika_format_HTML$.prototype = new $h_O();
$c_Llaika_format_HTML$.prototype.constructor = $c_Llaika_format_HTML$;
/** @constructor */
function $h_Llaika_format_HTML$() {
}
$h_Llaika_format_HTML$.prototype = $c_Llaika_format_HTML$.prototype;
$c_Llaika_format_HTML$.prototype.Overrides__Llaika_api_format_RenderFormat$Overrides$ = (function() {
  if ((!this.Llaika_format_HTML$__f_Overridesbitmap$1)) {
    this.Llaika_format_HTML$__f_Overrides$lzy1 = new $c_Llaika_api_format_RenderFormat$Overrides$(this);
    this.Llaika_format_HTML$__f_Overridesbitmap$1 = true;
  }
  return this.Llaika_format_HTML$__f_Overrides$lzy1;
});
$c_Llaika_format_HTML$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_format_HTML$.prototype.hashCode__I = (function() {
  return 2228139;
});
$c_Llaika_format_HTML$.prototype.toString__T = (function() {
  return "HTML";
});
$c_Llaika_format_HTML$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_format_HTML$.prototype.productPrefix__T = (function() {
  return "HTML";
});
$c_Llaika_format_HTML$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_format_HTML$.prototype.fileSuffix__T = (function() {
  return this.Llaika_format_HTML$__f_fileSuffix;
});
$c_Llaika_format_HTML$.prototype.defaultRenderer__F2 = (function() {
  return this.Llaika_format_HTML$__f_defaultRenderer;
});
$c_Llaika_format_HTML$.prototype.formatterFactory__F1 = (function() {
  return this.Llaika_format_HTML$__f_formatterFactory;
});
var $d_Llaika_format_HTML$ = new $TypeData().initClass($c_Llaika_format_HTML$, "laika.format.HTML$", ({
  Llaika_format_HTML$: 1,
  Llaika_api_format_RenderFormat: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_format_HTML$;
function $m_Llaika_format_HTML$() {
  if ((!$n_Llaika_format_HTML$)) {
    $n_Llaika_format_HTML$ = new $c_Llaika_format_HTML$();
  }
  return $n_Llaika_format_HTML$;
}
/** @constructor */
function $c_Llaika_format_Markdown$() {
  this.Llaika_format_Markdown$__f_fileSuffixes = null;
  this.Llaika_format_Markdown$__f_escapedChar$lzy1 = null;
  this.Llaika_format_Markdown$__f_escapedCharbitmap$1 = false;
  this.Llaika_format_Markdown$__f_extensions = null;
  $n_Llaika_format_Markdown$ = this;
  var this$1 = $m_sci_Set$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["md", "markdown"]));
  this.Llaika_format_Markdown$__f_fileSuffixes = this$1.from__sc_IterableOnce__sci_Set(elems);
  this.Llaika_format_Markdown$__f_extensions = $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_internal_markdown_bundle_VerbatimHTML$.getArrayOf().constr)([$m_Llaika_internal_markdown_bundle_VerbatimHTML$()]))));
}
$c_Llaika_format_Markdown$.prototype = new $h_O();
$c_Llaika_format_Markdown$.prototype.constructor = $c_Llaika_format_Markdown$;
/** @constructor */
function $h_Llaika_format_Markdown$() {
}
$h_Llaika_format_Markdown$.prototype = $c_Llaika_format_Markdown$.prototype;
$c_Llaika_format_Markdown$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_format_Markdown$.prototype.hashCode__I = (function() {
  return 311582991;
});
$c_Llaika_format_Markdown$.prototype.toString__T = (function() {
  return "Markdown";
});
$c_Llaika_format_Markdown$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_format_Markdown$.prototype.productPrefix__T = (function() {
  return "Markdown";
});
$c_Llaika_format_Markdown$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_format_Markdown$.prototype.escapedChar__Llaika_parse_Parser = (function() {
  if ((!this.Llaika_format_Markdown$__f_escapedCharbitmap$1)) {
    this.Llaika_format_Markdown$__f_escapedChar$lzy1 = $m_Llaika_internal_markdown_InlineParsers$().Llaika_internal_markdown_InlineParsers$__f_escapedChar;
    this.Llaika_format_Markdown$__f_escapedCharbitmap$1 = true;
  }
  return this.Llaika_format_Markdown$__f_escapedChar$lzy1;
});
$c_Llaika_format_Markdown$.prototype.createBlockListParser__Llaika_parse_Parser__Llaika_parse_Parser = (function(parser) {
  return $f_Llaika_api_format_MarkupFormat__createBlockListParser__Llaika_parse_Parser__Llaika_parse_Parser(this, $n($m_Llaika_internal_markdown_BlockParsers$().Llaika_internal_markdown_BlockParsers$__f_insignificantSpaces).$tilde$greater__Llaika_parse_Parser__Llaika_parse_Parser(parser));
});
var $d_Llaika_format_Markdown$ = new $TypeData().initClass($c_Llaika_format_Markdown$, "laika.format.Markdown$", ({
  Llaika_format_Markdown$: 1,
  Llaika_api_format_MarkupFormat: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_format_Markdown$;
function $m_Llaika_format_Markdown$() {
  if ((!$n_Llaika_format_Markdown$)) {
    $n_Llaika_format_Markdown$ = new $c_Llaika_format_Markdown$();
  }
  return $n_Llaika_format_Markdown$;
}
function $p_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder__entriesFor$1__Llaika_ast_NavigationBuilderContext__Llaika_ast_TreeCursor__sci_List__sci_List($thiz, context$1, tree, items) {
  var items$tailLocal1 = items;
  var tree$tailLocal1 = tree;
  while (true) {
    var this$1 = $n($n($n(tree$tailLocal1).Llaika_ast_TreeCursor__f_target).title__s_Option());
    var tree$tailLocal1$2 = tree$tailLocal1;
    if (this$1.isEmpty__Z()) {
      var this$2 = $m_Llaika_ast_SpanSequence$();
      var text = $n($n(tree$tailLocal1$2).Llaika_ast_TreeCursor__f_path).name__T();
      var texts = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([]));
      var $x_1 = $as_Llaika_ast_SpanSequence($f_Llaika_ast_SpanContainerCompanion__apply__T__sci_Seq__O(this$2, text, texts));
    } else {
      var $x_1 = this$1.get__O();
    }
    var title = $as_Llaika_ast_SpanSequence($x_1);
    var $x_4 = $n(context$1);
    var $x_3 = $n($n(tree$tailLocal1).Llaika_ast_TreeCursor__f_target).Llaika_ast_DocumentTree__f_titleDocument;
    var $x_2 = $m_sci_Nil$();
    var this$3 = $n($n(tree$tailLocal1).Llaika_ast_TreeCursor__f_target);
    var item = $n($x_4).newNavigationItem__Llaika_ast_SpanSequence__s_Option__sci_Seq__Llaika_config_TargetFormats__Llaika_ast_NavigationItem(title, $x_3, $x_2, $f_Llaika_ast_TreeContent__targetFormats__Llaika_config_TargetFormats(this$3));
    var x5 = $n(tree$tailLocal1).Llaika_ast_TreeCursor__f_parent;
    var x = $m_s_None$();
    if ((x === x5)) {
      var this$4 = $n(items$tailLocal1);
      return new $c_sci_$colon$colon(item, this$4);
    }
    if ((x5 instanceof $c_s_Some)) {
      var parent = $as_Llaika_ast_TreeCursor($n($as_s_Some(x5)).s_Some__f_value);
      var this$5 = $n(items$tailLocal1);
      var items$tailLocal1$tmp1 = new $c_sci_$colon$colon(item, this$5);
      tree$tailLocal1 = parent;
      items$tailLocal1 = items$tailLocal1$tmp1;
      continue;
    }
    throw new $c_s_MatchError(x5);
  }
}
/** @constructor */
function $c_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder(source, options) {
  this.Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder__f_source = null;
  this.Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder__f_options = null;
  this.Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder__f_unresolvedMessage$lzy1 = null;
  this.Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder__f_unresolvedMessagebitmap$1 = false;
  this.Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder__f_source = source;
  this.Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder__f_options = options;
}
$c_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder.prototype = new $h_Llaika_ast_Element();
$c_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder.prototype.constructor = $c_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder;
/** @constructor */
function $h_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder() {
}
$h_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder.prototype = $c_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder.prototype;
$c_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder)) {
    var x$0$2 = $as_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder(x$0);
    var x = this.Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder__f_source;
    var x$2 = $n(x$0$2).Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder__f_source;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder__f_options;
      var x$4 = $n(x$0$2).Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder.prototype.productPrefix__T = (function() {
  return "BreadcrumbBuilder";
});
$c_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder__f_source;
  }
  if ((n === 1)) {
    return this.Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder.prototype.source__Llaika_parse_SourceFragment = (function() {
  return this.Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder__f_source;
});
$c_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder__f_options;
});
$c_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder.prototype.resolve__Llaika_ast_DocumentCursor__Llaika_ast_Block = (function(cursor) {
  var this$1 = $n($m_Llaika_ast_NavigationBuilderContext$().defaults__Llaika_ast_NavigationBuilderContext());
  var path = $n(cursor).Llaika_ast_DocumentCursor__f_path;
  var itemStyles = this$1.Llaika_ast_NavigationBuilderContext$Impl__f_itemStyles;
  var maxLevels = this$1.Llaika_ast_NavigationBuilderContext$Impl__f_maxLevels;
  var currentLevel = this$1.Llaika_ast_NavigationBuilderContext$Impl__f_currentLevel;
  var excludeSections = this$1.Llaika_ast_NavigationBuilderContext$Impl__f_excludeSections;
  var excludeSelf = this$1.Llaika_ast_NavigationBuilderContext$Impl__f_excludeSelf;
  var context = new $c_Llaika_ast_NavigationBuilderContext$Impl(path, itemStyles, maxLevels, currentLevel, excludeSections, excludeSelf).withItemStyles__sci_Seq__Llaika_ast_NavigationBuilderContext($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([$as_T($n($n($m_Llaika_ast_Style$().Llaika_ast_Style$__f_breadcrumb).Llaika_ast_Options$Impl__f_styles).head__O())])));
  var this$2 = $n($n($n(cursor).Llaika_ast_DocumentCursor__f_parent).titleDocument__s_Option());
  if ((!this$2.isEmpty__Z())) {
    var arg1 = this$2.get__O();
    var _$1 = $as_Llaika_ast_DocumentCursor(arg1);
    var x = $n(_$1).Llaika_ast_DocumentCursor__f_path;
    var x$2 = $n(cursor).Llaika_ast_DocumentCursor__f_path;
    var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var content = $p_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder__entriesFor$1__Llaika_ast_NavigationBuilderContext__Llaika_ast_TreeCursor__sci_List__sci_List(this, context, $n(cursor).Llaika_ast_DocumentCursor__f_parent, $m_sci_Nil$());
    var options = $m_Llaika_ast_Style$().Llaika_ast_Style$__f_breadcrumb;
    return new $c_Llaika_ast_NavigationList(content, options);
  } else {
    var this$4 = $n($n($n(cursor).Llaika_ast_DocumentCursor__f_target).title__s_Option());
    if (this$4.isEmpty__Z()) {
      var this$5 = $m_Llaika_ast_SpanSequence$();
      var text = $n($n(cursor).Llaika_ast_DocumentCursor__f_path).name__T();
      var texts = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([]));
      var $x_2 = $as_Llaika_ast_SpanSequence($f_Llaika_ast_SpanContainerCompanion__apply__T__sci_Seq__O(this$5, text, texts));
    } else {
      var $x_2 = this$4.get__O();
    }
    var title = $as_Llaika_ast_SpanSequence($x_2);
    var $x_5 = $n(context);
    var value = $n(cursor).Llaika_ast_DocumentCursor__f_target;
    var $x_4 = new $c_s_Some(value);
    var $x_3 = $m_sci_Nil$();
    var this$7 = $n($n(cursor).Llaika_ast_DocumentCursor__f_target);
    var docEntry = $n($x_5).newNavigationItem__Llaika_ast_SpanSequence__s_Option__sci_Seq__Llaika_config_TargetFormats__Llaika_ast_NavigationItem(title, $x_4, $x_3, $f_Llaika_ast_TreeContent__targetFormats__Llaika_config_TargetFormats(this$7));
    var this$8 = $n($p_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder__entriesFor$1__Llaika_ast_NavigationBuilderContext__Llaika_ast_TreeCursor__sci_List__sci_List(this, context, $n(cursor).Llaika_ast_DocumentCursor__f_parent, $m_sci_Nil$()));
    var content$1 = $as_sci_Seq($f_sc_StrictOptimizedSeqOps__appended__O__O(this$8, docEntry));
    var options$1 = $m_Llaika_ast_Style$().Llaika_ast_Style$__f_breadcrumb;
    return new $c_Llaika_ast_NavigationList(content$1, options$1);
  }
});
$c_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder.prototype.runsIn__Llaika_ast_RewritePhase__Z = (function(phase) {
  return (phase instanceof $c_Llaika_ast_RewritePhase$Render);
});
$c_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder.prototype.unresolvedMessage__T = (function() {
  if ((!this.Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder__f_unresolvedMessagebitmap$1)) {
    this.Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder__f_unresolvedMessage$lzy1 = "Unresolved breadcrumb builder";
    this.Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder__f_unresolvedMessagebitmap$1 = true;
  }
  return this.Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder__f_unresolvedMessage$lzy1;
});
$c_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var source = this.Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder__f_source;
  return new $c_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder(source, options);
});
function $as_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder(obj) {
  return (((obj instanceof $c_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.directive.BreadcrumbDirectives$BreadcrumbBuilder"));
}
function $isArrayOf_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder)));
}
function $asArrayOf_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder(obj, depth) {
  return (($isArrayOf_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.directive.BreadcrumbDirectives$BreadcrumbBuilder;", depth));
}
var $d_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder = new $TypeData().initClass($c_Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder, "laika.internal.directive.BreadcrumbDirectives$BreadcrumbBuilder", ({
  Llaika_internal_directive_BreadcrumbDirectives$BreadcrumbBuilder: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_Unresolved: 1,
  Llaika_ast_BlockResolver: 1
}));
/** @constructor */
function $c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2(outer, ref, directiveName, typeName, source, options) {
  this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_ref = null;
  this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_directiveName = null;
  this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_typeName = null;
  this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_source = null;
  this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_options = null;
  this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_$outer = null;
  this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_ref = ref;
  this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_directiveName = directiveName;
  this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_typeName = typeName;
  this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_source = source;
  this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_options = options;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_$outer = outer;
}
$c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2.prototype = new $h_Llaika_ast_Element();
$c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2.prototype.constructor = $c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2;
/** @constructor */
function $h_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2() {
}
$h_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2.prototype = $c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2.prototype;
$c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2) && ($n($as_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2(x$0)).Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_$outer === this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_$outer))) {
    var x$0$2 = $as_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2(x$0);
    var x = this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_ref;
    var x$2 = $n(x$0$2).Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_ref;
    if (((((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) && (this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_directiveName === $n(x$0$2).Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_directiveName)) && (this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_typeName === $n(x$0$2).Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_typeName))) {
      var x$3 = this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_source;
      var x$4 = $n(x$0$2).Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_source;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_options;
      var x$6 = $n(x$0$2).Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_options;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2.prototype.productArity__I = (function() {
  return 5;
});
$c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2.prototype.productPrefix__T = (function() {
  return "LinkDirectiveResolver2";
});
$c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_ref;
      break;
    }
    case 1: {
      return this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_directiveName;
      break;
    }
    case 2: {
      return this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_typeName;
      break;
    }
    case 3: {
      return this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_source;
      break;
    }
    case 4: {
      return this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2.prototype.source__Llaika_parse_SourceFragment = (function() {
  return this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_source;
});
$c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_options;
});
$c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2.prototype.resolve__Llaika_ast_DocumentCursor__Llaika_ast_Span = (function(cursor) {
  var this$1 = $n($n($n(this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_$outer).Llaika_internal_directive_DirectiveSupport__f_laika$internal$directive$DirectiveSupport$$linkDirectiveMap).get__O__s_Option(this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_directiveName));
  if (this$1.isEmpty__Z()) {
    var $x_1 = $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan(("Unknown link directive: " + this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_directiveName), this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_source);
  } else {
    var arg1 = this$1.get__O();
    var dir = $as_Llaika_api_bundle_LinkDirectives$Directive(arg1);
    var this$2 = $n($n(dir).apply__T__Llaika_ast_DocumentCursor__s_util_Either(this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_typeName, cursor));
    if ((this$2 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$2);
      var b = $n(x2).s_util_Right__f_value;
      var res = $as_Llaika_ast_SpanLink(b);
      var options$2 = $n($n(res).Llaika_ast_SpanLink__f_options).$plus__Llaika_ast_Options__Llaika_ast_Options($n(this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_ref).Llaika_ast_LinkPathReference__f_options);
      var this$3 = $n(res);
      var target$2 = this$3.Llaika_ast_SpanLink__f_target;
      var this$4 = $n(res);
      var title$2 = this$4.Llaika_ast_SpanLink__f_title;
      $n(res);
      var content = $n(this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_ref).Llaika_ast_LinkPathReference__f_content;
      var $x_2 = new $c_Llaika_ast_SpanLink(content, target$2, title$2, options$2);
    } else {
      if ((!(this$2 instanceof $c_s_util_Left))) {
        throw new $c_s_MatchError(this$2);
      }
      var x3 = $as_s_util_Left(this$2);
      var a = $n(x3).s_util_Left__f_value;
      var err = $as_T(a);
      var $x_2 = $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan(("Invalid link directive: " + err), this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_source);
    }
    var $x_1 = $as_Llaika_ast_Span($x_2);
  }
  return $as_Llaika_ast_Span($x_1);
});
$c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2.prototype.runsIn__Llaika_ast_RewritePhase__Z = (function(phase) {
  return (phase instanceof $c_Llaika_ast_RewritePhase$Render);
});
$c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2.prototype.unresolvedMessage__T = (function() {
  return ("unresolved api directive for type " + this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_typeName);
});
$c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2.prototype.copy__Llaika_ast_LinkPathReference__T__T__Llaika_parse_SourceFragment__Llaika_ast_Options__Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2 = (function(ref, directiveName, typeName, source, options) {
  return new $c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2(this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_$outer, ref, directiveName, typeName, source, options);
});
$c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  return this.copy__Llaika_ast_LinkPathReference__T__T__Llaika_parse_SourceFragment__Llaika_ast_Options__Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2(this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_ref, this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_directiveName, this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_typeName, this.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2__f_source, options);
});
function $as_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2(obj) {
  return (((obj instanceof $c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.directive.DirectiveSupport$LinkDirectiveResolver2"));
}
function $isArrayOf_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2)));
}
function $asArrayOf_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2(obj, depth) {
  return (($isArrayOf_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.directive.DirectiveSupport$LinkDirectiveResolver2;", depth));
}
var $d_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2 = new $TypeData().initClass($c_Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2, "laika.internal.directive.DirectiveSupport$LinkDirectiveResolver2", ({
  Llaika_internal_directive_DirectiveSupport$LinkDirectiveResolver2: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Unresolved: 1,
  Llaika_ast_SpanResolver: 1
}));
function $p_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__generate$1__Llaika_ast_DocumentCursor__I__Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig__Lcats_data_Validated($thiz, cursor$2, currentLevel, node) {
  if ((node instanceof $c_Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode)) {
    var x$1 = $as_Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode(node);
    var this$2 = $n(x$1);
    var x15 = this$2.Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode__f_title;
    var this$3 = $n(x$1);
    var x16 = this$3.Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode__f_target;
    var this$4 = $n(x$1);
    var x17 = this$4.Llaika_internal_directive_NavigationTreeDirectives$ManualNavigationNode__f_entries;
    var this$5 = $n(x16);
    if (this$5.isEmpty__Z()) {
      var link = $m_s_None$();
    } else {
      var arg1 = this$5.get__O();
      var _$1 = $as_Llaika_ast_ExternalTarget(arg1);
      var targetFormats = $m_Llaika_config_TargetFormats$All$();
      var link = new $c_s_Some(new $c_Llaika_ast_NavigationLink(_$1, false, targetFormats));
    }
    if ((currentLevel < $thiz.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_defaultDepth)) {
      var this$8 = $n($n(x17).toList__sci_List());
      var currentLevel$1 = ((1 + currentLevel) | 0);
      var f = ((node$2) => {
        var node$1 = $as_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig(node$2);
        return $p_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__generate$1__Llaika_ast_DocumentCursor__I__Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig__Lcats_data_Validated($thiz, cursor$2, currentLevel$1, node$1);
      });
      if ((this$8 === $m_sci_Nil$())) {
        var target = $m_sci_Nil$();
      } else {
        var arg1$1 = this$8.head__O();
        var h = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
        var t = h;
        var rest = $as_sci_List(this$8.tail__O());
        while ((rest !== $m_sci_Nil$())) {
          var arg1$2 = $n(rest).head__O();
          var nx = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
          $n(t).sci_$colon$colon__f_next = nx;
          t = nx;
          rest = $as_sci_List($n(rest).tail__O());
        }
        var target = h;
      }
      $m_Lcats_UnorderedFoldable$();
      var tc = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
      var this$16 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(target, tc);
      $m_Lcats_data_Validated$();
      $m_Lcats_data_NonEmptyChainImpl$();
      var ev = $m_Lcats_data_Chain$().Lcats_data_ChainInstances__f_theMonoid;
      var B = $m_Lcats_kernel_instances_ListMonoid$().Lcats_kernel_instances_ListMonoid$__f_singleton;
      var ev$1 = new $c_Lcats_data_ValidatedInstances$$anon$4(B, ev);
      var this$17 = $n(this$16.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance);
      var fa = this$16.Lcats_Foldable$ToFoldableOps$$anon$6__f_self;
      var this$18 = $n($as_Lcats_data_Validated(this$17.fold__O__Lcats_kernel_Monoid__O(fa, ev$1)));
      if ((this$18 instanceof $c_Lcats_data_Validated$Invalid)) {
        var x$1$1 = $as_Lcats_data_Validated$Invalid(this$18);
        var this$20 = $n(x$1$1);
        var i = $as_Lcats_data_Validated$Invalid(this$18);
        return i;
      }
      if ((this$18 instanceof $c_Lcats_data_Validated$Valid)) {
        var x$1$2 = $as_Lcats_data_Validated$Valid(this$18);
        var this$22 = $n(x$1$2);
        var x228 = this$22.Lcats_data_Validated$Valid__f_a;
        var childNodes = $as_sci_List(x228);
        var $x_1 = $m_sr_ScalaRunTime$();
        var options$1 = $m_Llaika_ast_Style$().level__I__Llaika_ast_Options(currentLevel);
        var targetFormats$1 = $m_Llaika_config_TargetFormats$All$();
        var elems = $n($x_1).wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_NavigationItem.getArrayOf().constr)([new $c_Llaika_ast_NavigationItem(x15, childNodes, link, targetFormats$1, options$1)]));
        var a = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
        return new $c_Lcats_data_Validated$Valid(a);
      }
      throw new $c_s_MatchError(this$18);
    } else {
      var this$27 = $n(link);
      if ((!this$27.isEmpty__Z())) {
        var $x_2 = $m_sr_ScalaRunTime$();
        var content = $m_sci_Nil$();
        var targetFormats$2 = $m_Llaika_config_TargetFormats$All$();
        var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
        var elems$1 = $n($x_2).wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_NavigationItem.getArrayOf().constr)([new $c_Llaika_ast_NavigationItem(x15, content, link, targetFormats$2, options)]));
        var a$1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1);
        return new $c_Lcats_data_Validated$Valid(a$1);
      } else {
        var a$2 = $m_sci_Nil$();
        return new $c_Lcats_data_Validated$Valid(a$2);
      }
    }
  }
  if ((node instanceof $c_Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode)) {
    var x$1$3 = $as_Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode(node);
    var this$39 = $n(x$1$3);
    var x8 = this$39.Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_target;
    var this$40 = $n(x$1$3);
    var x9 = this$40.Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_title;
    var this$41 = $n(x$1$3);
    var x10 = this$41.Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_depth;
    var this$42 = $n(x$1$3);
    var x11 = this$42.Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_excludeRoot;
    var this$43 = $n(x$1$3);
    var x12 = this$43.Llaika_internal_directive_NavigationTreeDirectives$GeneratedNavigationNode__f_excludeSections;
    var this$44 = $n($n($n($m_Llaika_ast_InternalTarget$().apply__Llaika_ast_VirtualPath__Llaika_ast_InternalTarget(x8)).relativeTo__Llaika_ast_Path__Llaika_ast_InternalTarget$Resolved($n(cursor$2).Llaika_ast_DocumentCursor__f_path)).Llaika_ast_InternalTarget$Resolved__f_absolutePath);
    var resolvedTarget = this$44.relativeTo__Llaika_ast_Path__Llaika_ast_RelativePath($m_Llaika_ast_Path$Root$());
    var this$45 = $n($n($n($n($n(cursor$2).root__Llaika_ast_RootCursor()).Llaika_ast_RootCursor__f_target).Llaika_ast_DocumentTreeRoot__f_tree).selectDocument__Llaika_ast_RelativePath__s_Option(resolvedTarget));
    var target$2 = (this$45.isEmpty__Z() ? $n($n($n($n(cursor$2).root__Llaika_ast_RootCursor()).Llaika_ast_RootCursor__f_target).Llaika_ast_DocumentTreeRoot__f_tree).selectSubtree__Llaika_ast_RelativePath__s_Option(resolvedTarget) : this$45);
    var this$46 = $n(target$2);
    if (this$46.isEmpty__Z()) {
      var a$3 = ("Unable to resolve document or tree with path: " + x8);
      var this$49 = $m_Lcats_data_Validated$();
      var $x_3 = $f_Lcats_data_ValidatedFunctionsBinCompat0__invalidNec__O__Lcats_data_Validated(this$49, a$3);
    } else {
      var arg1$3 = this$46.get__O();
      var treeContent = $as_Llaika_ast_TreeContent(arg1$3);
      var this$50 = $n(x11);
      var noRoot = $uZ((this$50.isEmpty__Z() ? $thiz.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_excludeRoot : this$50.get__O()));
      var this$51 = $n($m_Llaika_ast_NavigationBuilderContext$().defaults__Llaika_ast_NavigationBuilderContext());
      var path = $n(cursor$2).Llaika_ast_DocumentCursor__f_path;
      var itemStyles = this$51.Llaika_ast_NavigationBuilderContext$Impl__f_itemStyles;
      var maxLevels = this$51.Llaika_ast_NavigationBuilderContext$Impl__f_maxLevels;
      var currentLevel$2 = this$51.Llaika_ast_NavigationBuilderContext$Impl__f_currentLevel;
      var excludeSections = this$51.Llaika_ast_NavigationBuilderContext$Impl__f_excludeSections;
      var excludeSelf = this$51.Llaika_ast_NavigationBuilderContext$Impl__f_excludeSelf;
      var $x_4 = new $c_Llaika_ast_NavigationBuilderContext$Impl(path, itemStyles, maxLevels, currentLevel$2, excludeSections, excludeSelf);
      var this$52 = $n($thiz.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_itemStyles);
      var this$54 = $n($x_4.withItemStyles__sci_Seq__Llaika_ast_NavigationBuilderContext($m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$52)));
      var this$53 = $n(x10);
      var max = $uI((this$53.isEmpty__Z() ? $thiz.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_defaultDepth : this$53.get__O()));
      var refPath = this$54.Llaika_ast_NavigationBuilderContext$Impl__f_refPath;
      var itemStyles$1 = this$54.Llaika_ast_NavigationBuilderContext$Impl__f_itemStyles;
      var currentLevel$3 = this$54.Llaika_ast_NavigationBuilderContext$Impl__f_currentLevel;
      var excludeSections$1 = this$54.Llaika_ast_NavigationBuilderContext$Impl__f_excludeSections;
      var excludeSelf$1 = this$54.Llaika_ast_NavigationBuilderContext$Impl__f_excludeSelf;
      var this$56 = new $c_Llaika_ast_NavigationBuilderContext$Impl(refPath, itemStyles$1, max, currentLevel$3, excludeSections$1, excludeSelf$1);
      var this$55 = $n(x12);
      var value = $uZ((this$55.isEmpty__Z() ? $thiz.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_excludeSections : this$55.get__O()));
      var refPath$1 = this$56.Llaika_ast_NavigationBuilderContext$Impl__f_refPath;
      var itemStyles$2 = this$56.Llaika_ast_NavigationBuilderContext$Impl__f_itemStyles;
      var maxLevels$1 = this$56.Llaika_ast_NavigationBuilderContext$Impl__f_maxLevels;
      var currentLevel$4 = this$56.Llaika_ast_NavigationBuilderContext$Impl__f_currentLevel;
      var excludeSelf$2 = this$56.Llaika_ast_NavigationBuilderContext$Impl__f_excludeSelf;
      var this$57 = new $c_Llaika_ast_NavigationBuilderContext$Impl(refPath$1, itemStyles$2, maxLevels$1, currentLevel$4, value, excludeSelf$2);
      var value$1 = $thiz.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_excludeSelf;
      var refPath$2 = this$57.Llaika_ast_NavigationBuilderContext$Impl__f_refPath;
      var itemStyles$3 = this$57.Llaika_ast_NavigationBuilderContext$Impl__f_itemStyles;
      var maxLevels$2 = this$57.Llaika_ast_NavigationBuilderContext$Impl__f_maxLevels;
      var currentLevel$5 = this$57.Llaika_ast_NavigationBuilderContext$Impl__f_currentLevel;
      var excludeSections$2 = this$57.Llaika_ast_NavigationBuilderContext$Impl__f_excludeSections;
      var this$58 = new $c_Llaika_ast_NavigationBuilderContext$Impl(refPath$2, itemStyles$3, maxLevels$2, currentLevel$5, excludeSections$2, value$1);
      var value$2 = (noRoot ? (((-1) + currentLevel) | 0) : currentLevel);
      var refPath$3 = this$58.Llaika_ast_NavigationBuilderContext$Impl__f_refPath;
      var itemStyles$4 = this$58.Llaika_ast_NavigationBuilderContext$Impl__f_itemStyles;
      var maxLevels$3 = this$58.Llaika_ast_NavigationBuilderContext$Impl__f_maxLevels;
      var excludeSections$3 = this$58.Llaika_ast_NavigationBuilderContext$Impl__f_excludeSections;
      var excludeSelf$3 = this$58.Llaika_ast_NavigationBuilderContext$Impl__f_excludeSelf;
      var context = new $c_Llaika_ast_NavigationBuilderContext$Impl(refPath$3, itemStyles$4, maxLevels$3, value$2, excludeSections$3, excludeSelf$3);
      var navItem = $n(treeContent).asNavigationItem__Llaika_ast_NavigationBuilderContext__Llaika_ast_NavigationItem(context);
      if (noRoot) {
        var a$4 = $n($n(navItem).Llaika_ast_NavigationItem__f_content).toList__sci_List();
        var $x_3 = new $c_Lcats_data_Validated$Valid(a$4);
      } else {
        var $x_6 = $m_sr_ScalaRunTime$();
        var this$62 = $n(x9);
        if (this$62.isEmpty__Z()) {
          var $x_5 = navItem;
        } else {
          var arg1$4 = this$62.get__O();
          var t$1 = $as_Llaika_ast_SpanSequence(arg1$4);
          $n(navItem);
          var this$63 = $n(navItem);
          var content$1 = this$63.Llaika_ast_NavigationItem__f_content;
          var this$64 = $n(navItem);
          var link$1 = this$64.Llaika_ast_NavigationItem__f_link;
          var this$65 = $n(navItem);
          var targetFormats$3 = this$65.Llaika_ast_NavigationItem__f_targetFormats;
          var this$66 = $n(navItem);
          var options$2 = this$66.Llaika_ast_NavigationItem__f_options;
          var $x_5 = new $c_Llaika_ast_NavigationItem(t$1, content$1, link$1, targetFormats$3, options$2);
        }
        var elems$2 = $n($x_6).wrapRefArray__AO__sci_ArraySeq(new ($d_Llaika_ast_NavigationItem.getArrayOf().constr)([$x_5]));
        var a$5 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$2);
        var $x_3 = new $c_Lcats_data_Validated$Valid(a$5);
      }
    }
    return $as_Lcats_data_Validated($x_3);
  }
  throw new $c_s_MatchError(node);
}
/** @constructor */
function $c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig(entries, source, defaultDepth, itemStyles, excludeRoot, excludeSections, excludeSelf, options) {
  this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_entries = null;
  this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_source = null;
  this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_defaultDepth = 0;
  this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_itemStyles = null;
  this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_excludeRoot = false;
  this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_excludeSections = false;
  this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_excludeSelf = false;
  this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_options = null;
  this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_unresolvedMessage$lzy1 = null;
  this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_unresolvedMessagebitmap$1 = false;
  this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_entries = entries;
  this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_source = source;
  this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_defaultDepth = defaultDepth;
  this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_itemStyles = itemStyles;
  this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_excludeRoot = excludeRoot;
  this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_excludeSections = excludeSections;
  this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_excludeSelf = excludeSelf;
  this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_options = options;
}
$c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig.prototype = new $h_Llaika_ast_Element();
$c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig.prototype.constructor = $c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig;
/** @constructor */
function $h_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig() {
}
$h_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig.prototype = $c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig.prototype;
$c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("NavigationBuilderConfig");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_entries;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_source;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_defaultDepth;
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_itemStyles;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var data$5 = (this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_excludeRoot ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var data$6 = (this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_excludeSections ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var data$7 = (this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_excludeSelf ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  var x$3 = this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_options;
  var data$8 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$8, data$8);
  var hash$9 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$9, 8);
});
$c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig)) {
    var x$0$2 = $as_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig(x$0);
    if (((((this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_defaultDepth === $n(x$0$2).Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_defaultDepth) && (this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_excludeRoot === $n(x$0$2).Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_excludeRoot)) && (this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_excludeSections === $n(x$0$2).Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_excludeSections)) && (this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_excludeSelf === $n(x$0$2).Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_excludeSelf))) {
      var x = this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_entries;
      var x$2 = $n(x$0$2).Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_entries;
      var $x_4 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$3 = this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_source;
      var x$4 = $n(x$0$2).Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_source;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_itemStyles;
      var x$6 = $n(x$0$2).Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_itemStyles;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_options;
      var x$8 = $n(x$0$2).Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_options;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig.prototype.productArity__I = (function() {
  return 8;
});
$c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig.prototype.productPrefix__T = (function() {
  return "NavigationBuilderConfig";
});
$c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_entries;
      break;
    }
    case 1: {
      return this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_source;
      break;
    }
    case 2: {
      return this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_defaultDepth;
      break;
    }
    case 3: {
      return this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_itemStyles;
      break;
    }
    case 4: {
      return this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_excludeRoot;
      break;
    }
    case 5: {
      return this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_excludeSections;
      break;
    }
    case 6: {
      return this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_excludeSelf;
      break;
    }
    case 7: {
      return this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig.prototype.source__Llaika_parse_SourceFragment = (function() {
  return this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_source;
});
$c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_options;
});
$c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig.prototype.eval__Llaika_ast_DocumentCursor__s_util_Either = (function(cursor) {
  var this$2 = $n($n(this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_entries).toList__sci_List());
  var f = ((node) => {
    var node$1 = $as_Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig(node);
    return $p_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__generate$1__Llaika_ast_DocumentCursor__I__Llaika_internal_directive_NavigationTreeDirectives$NavigationNodeConfig__Lcats_data_Validated(this, cursor, 1, node$1);
  });
  if ((this$2 === $m_sci_Nil$())) {
    var target = $m_sci_Nil$();
  } else {
    var arg1 = this$2.head__O();
    var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$2.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O());
    }
    var target = h;
  }
  $m_Lcats_UnorderedFoldable$();
  var tc = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
  var this$10 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(target, tc);
  $m_Lcats_data_Validated$();
  $m_Lcats_data_NonEmptyChainImpl$();
  var ev = $m_Lcats_data_Chain$().Lcats_data_ChainInstances__f_theMonoid;
  var B = $m_Lcats_kernel_instances_ListMonoid$().Lcats_kernel_instances_ListMonoid$__f_singleton;
  var ev$1 = new $c_Lcats_data_ValidatedInstances$$anon$4(B, ev);
  var this$11 = $n(this$10.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance);
  var fa = this$10.Lcats_Foldable$ToFoldableOps$$anon$6__f_self;
  var this$12 = $n($n($as_Lcats_data_Validated(this$11.fold__O__Lcats_kernel_Monoid__O(fa, ev$1))).toEither__s_util_Either());
  if ((this$12 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$12);
    var b = $n(x2).s_util_Right__f_value;
    var _$2 = $as_sci_List(b);
    var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    var eab = new $c_s_util_Right(new $c_Llaika_ast_NavigationList(_$2, options));
  } else {
    var eab = this$12;
  }
  if ((eab instanceof $c_s_util_Left)) {
    var a = $n($as_s_util_Left(eab)).s_util_Left__f_value;
    var tc$1 = $as_Lcats_Foldable($m_Lcats_data_NonEmptyChainImpl$().Lcats_data_NonEmptyChainInstances__f_catsDataInstancesForNonEmptyChainBinCompat1);
    var this$18 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(a, tc$1);
    var this$19 = $n($n(this$18.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).toList__O__sci_List(this$18.Lcats_Foldable$ToFoldableOps$$anon$6__f_self));
    var value = ("One or more errors generating navigation: " + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$19, "", ",", ""));
    return new $c_s_util_Left(value);
  }
  if ((eab instanceof $c_s_util_Right)) {
    var r = $as_s_util_Right(eab);
    $m_Lcats_syntax_EitherUtil$();
    return r;
  }
  throw new $c_s_MatchError(eab);
});
$c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig.prototype.resolve__Llaika_ast_DocumentCursor__Llaika_ast_Block = (function(cursor) {
  var this$1 = $n(this.eval__Llaika_ast_DocumentCursor__s_util_Either(cursor));
  if ((this$1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$1);
    var b = $n(x2).s_util_Right__f_value;
    var x = $as_Llaika_ast_NavigationList(b);
    var $x_1 = x;
  } else {
    if ((!(this$1 instanceof $c_s_util_Left))) {
      throw new $c_s_MatchError(this$1);
    }
    var x3 = $as_s_util_Left(this$1);
    var a = $n(x3).s_util_Left__f_value;
    var _$3 = $as_T(a);
    var $x_1 = $m_Llaika_ast_InvalidBlock$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidBlock(_$3, this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_source);
  }
  return $as_Llaika_ast_Block($x_1);
});
$c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig.prototype.runsIn__Llaika_ast_RewritePhase__Z = (function(phase) {
  return (phase instanceof $c_Llaika_ast_RewritePhase$Render);
});
$c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig.prototype.unresolvedMessage__T = (function() {
  if ((!this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_unresolvedMessagebitmap$1)) {
    this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_unresolvedMessage$lzy1 = "Unresolved navigation builder";
    this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_unresolvedMessagebitmap$1 = true;
  }
  return this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_unresolvedMessage$lzy1;
});
$c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var entries = this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_entries;
  var source = this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_source;
  var defaultDepth = this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_defaultDepth;
  var itemStyles = this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_itemStyles;
  var excludeRoot = this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_excludeRoot;
  var excludeSections = this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_excludeSections;
  var excludeSelf = this.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig__f_excludeSelf;
  return new $c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig(entries, source, defaultDepth, itemStyles, excludeRoot, excludeSections, excludeSelf, options);
});
function $as_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig(obj) {
  return (((obj instanceof $c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.directive.NavigationTreeDirectives$NavigationBuilderConfig"));
}
function $isArrayOf_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig)));
}
function $asArrayOf_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig(obj, depth) {
  return (($isArrayOf_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.directive.NavigationTreeDirectives$NavigationBuilderConfig;", depth));
}
var $d_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig = new $TypeData().initClass($c_Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig, "laika.internal.directive.NavigationTreeDirectives$NavigationBuilderConfig", ({
  Llaika_internal_directive_NavigationTreeDirectives$NavigationBuilderConfig: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_Unresolved: 1,
  Llaika_ast_BlockResolver: 1
}));
/** @constructor */
function $c_Llaika_internal_markdown_InlineParsers$ImplicitTarget$() {
}
$c_Llaika_internal_markdown_InlineParsers$ImplicitTarget$.prototype = new $h_O();
$c_Llaika_internal_markdown_InlineParsers$ImplicitTarget$.prototype.constructor = $c_Llaika_internal_markdown_InlineParsers$ImplicitTarget$;
/** @constructor */
function $h_Llaika_internal_markdown_InlineParsers$ImplicitTarget$() {
}
$h_Llaika_internal_markdown_InlineParsers$ImplicitTarget$.prototype = $c_Llaika_internal_markdown_InlineParsers$ImplicitTarget$.prototype;
$c_Llaika_internal_markdown_InlineParsers$ImplicitTarget$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_markdown_InlineParsers$ImplicitTarget$.prototype.hashCode__I = (function() {
  return (-714868746);
});
$c_Llaika_internal_markdown_InlineParsers$ImplicitTarget$.prototype.toString__T = (function() {
  return "ImplicitTarget";
});
$c_Llaika_internal_markdown_InlineParsers$ImplicitTarget$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_internal_markdown_InlineParsers$ImplicitTarget$.prototype.productPrefix__T = (function() {
  return "ImplicitTarget";
});
$c_Llaika_internal_markdown_InlineParsers$ImplicitTarget$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_internal_markdown_InlineParsers$ImplicitTarget$ = new $TypeData().initClass($c_Llaika_internal_markdown_InlineParsers$ImplicitTarget$, "laika.internal.markdown.InlineParsers$ImplicitTarget$", ({
  Llaika_internal_markdown_InlineParsers$ImplicitTarget$: 1,
  Llaika_internal_markdown_InlineParsers$ResourceTarget: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_internal_markdown_InlineParsers$ImplicitTarget$;
function $m_Llaika_internal_markdown_InlineParsers$ImplicitTarget$() {
  if ((!$n_Llaika_internal_markdown_InlineParsers$ImplicitTarget$)) {
    $n_Llaika_internal_markdown_InlineParsers$ImplicitTarget$ = new $c_Llaika_internal_markdown_InlineParsers$ImplicitTarget$();
  }
  return $n_Llaika_internal_markdown_InlineParsers$ImplicitTarget$;
}
/** @constructor */
function $c_Llaika_internal_parse_css_CSSParsers$Child$() {
}
$c_Llaika_internal_parse_css_CSSParsers$Child$.prototype = new $h_Llaika_internal_parse_css_CSSParsers$Combinator();
$c_Llaika_internal_parse_css_CSSParsers$Child$.prototype.constructor = $c_Llaika_internal_parse_css_CSSParsers$Child$;
/** @constructor */
function $h_Llaika_internal_parse_css_CSSParsers$Child$() {
}
$h_Llaika_internal_parse_css_CSSParsers$Child$.prototype = $c_Llaika_internal_parse_css_CSSParsers$Child$.prototype;
$c_Llaika_internal_parse_css_CSSParsers$Child$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_parse_css_CSSParsers$Child$.prototype.hashCode__I = (function() {
  return 65078524;
});
$c_Llaika_internal_parse_css_CSSParsers$Child$.prototype.toString__T = (function() {
  return "Child";
});
$c_Llaika_internal_parse_css_CSSParsers$Child$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_internal_parse_css_CSSParsers$Child$.prototype.productPrefix__T = (function() {
  return "Child";
});
$c_Llaika_internal_parse_css_CSSParsers$Child$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_internal_parse_css_CSSParsers$Child$ = new $TypeData().initClass($c_Llaika_internal_parse_css_CSSParsers$Child$, "laika.internal.parse.css.CSSParsers$Child$", ({
  Llaika_internal_parse_css_CSSParsers$Child$: 1,
  Llaika_internal_parse_css_CSSParsers$Combinator: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_internal_parse_css_CSSParsers$Child$;
function $m_Llaika_internal_parse_css_CSSParsers$Child$() {
  if ((!$n_Llaika_internal_parse_css_CSSParsers$Child$)) {
    $n_Llaika_internal_parse_css_CSSParsers$Child$ = new $c_Llaika_internal_parse_css_CSSParsers$Child$();
  }
  return $n_Llaika_internal_parse_css_CSSParsers$Child$;
}
/** @constructor */
function $c_Llaika_internal_parse_css_CSSParsers$Descendant$() {
}
$c_Llaika_internal_parse_css_CSSParsers$Descendant$.prototype = new $h_Llaika_internal_parse_css_CSSParsers$Combinator();
$c_Llaika_internal_parse_css_CSSParsers$Descendant$.prototype.constructor = $c_Llaika_internal_parse_css_CSSParsers$Descendant$;
/** @constructor */
function $h_Llaika_internal_parse_css_CSSParsers$Descendant$() {
}
$h_Llaika_internal_parse_css_CSSParsers$Descendant$.prototype = $c_Llaika_internal_parse_css_CSSParsers$Descendant$.prototype;
$c_Llaika_internal_parse_css_CSSParsers$Descendant$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_parse_css_CSSParsers$Descendant$.prototype.hashCode__I = (function() {
  return 877160733;
});
$c_Llaika_internal_parse_css_CSSParsers$Descendant$.prototype.toString__T = (function() {
  return "Descendant";
});
$c_Llaika_internal_parse_css_CSSParsers$Descendant$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_internal_parse_css_CSSParsers$Descendant$.prototype.productPrefix__T = (function() {
  return "Descendant";
});
$c_Llaika_internal_parse_css_CSSParsers$Descendant$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_internal_parse_css_CSSParsers$Descendant$ = new $TypeData().initClass($c_Llaika_internal_parse_css_CSSParsers$Descendant$, "laika.internal.parse.css.CSSParsers$Descendant$", ({
  Llaika_internal_parse_css_CSSParsers$Descendant$: 1,
  Llaika_internal_parse_css_CSSParsers$Combinator: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_internal_parse_css_CSSParsers$Descendant$;
function $m_Llaika_internal_parse_css_CSSParsers$Descendant$() {
  if ((!$n_Llaika_internal_parse_css_CSSParsers$Descendant$)) {
    $n_Llaika_internal_parse_css_CSSParsers$Descendant$ = new $c_Llaika_internal_parse_css_CSSParsers$Descendant$();
  }
  return $n_Llaika_internal_parse_css_CSSParsers$Descendant$;
}
/** @constructor */
function $c_Llaika_internal_parse_hocon_SelfReference$() {
}
$c_Llaika_internal_parse_hocon_SelfReference$.prototype = new $h_O();
$c_Llaika_internal_parse_hocon_SelfReference$.prototype.constructor = $c_Llaika_internal_parse_hocon_SelfReference$;
/** @constructor */
function $h_Llaika_internal_parse_hocon_SelfReference$() {
}
$h_Llaika_internal_parse_hocon_SelfReference$.prototype = $c_Llaika_internal_parse_hocon_SelfReference$.prototype;
$c_Llaika_internal_parse_hocon_SelfReference$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_parse_hocon_SelfReference$.prototype.hashCode__I = (function() {
  return (-1013107393);
});
$c_Llaika_internal_parse_hocon_SelfReference$.prototype.toString__T = (function() {
  return "SelfReference";
});
$c_Llaika_internal_parse_hocon_SelfReference$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_internal_parse_hocon_SelfReference$.prototype.productPrefix__T = (function() {
  return "SelfReference";
});
$c_Llaika_internal_parse_hocon_SelfReference$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_internal_parse_hocon_SelfReference$ = new $TypeData().initClass($c_Llaika_internal_parse_hocon_SelfReference$, "laika.internal.parse.hocon.SelfReference$", ({
  Llaika_internal_parse_hocon_SelfReference$: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_internal_parse_hocon_ConfigBuilderValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_internal_parse_hocon_SelfReference$;
function $m_Llaika_internal_parse_hocon_SelfReference$() {
  if ((!$n_Llaika_internal_parse_hocon_SelfReference$)) {
    $n_Llaika_internal_parse_hocon_SelfReference$ = new $c_Llaika_internal_parse_hocon_SelfReference$();
  }
  return $n_Llaika_internal_parse_hocon_SelfReference$;
}
/** @constructor */
function $c_Llaika_internal_render_ASTRenderer$Content(content, desc, options) {
  this.Llaika_internal_render_ASTRenderer$Content__f_content = null;
  this.Llaika_internal_render_ASTRenderer$Content__f_desc = null;
  this.Llaika_internal_render_ASTRenderer$Content__f_options = null;
  this.Llaika_internal_render_ASTRenderer$Content__f_content = content;
  this.Llaika_internal_render_ASTRenderer$Content__f_desc = desc;
  this.Llaika_internal_render_ASTRenderer$Content__f_options = options;
}
$c_Llaika_internal_render_ASTRenderer$Content.prototype = new $h_Llaika_ast_Element();
$c_Llaika_internal_render_ASTRenderer$Content.prototype.constructor = $c_Llaika_internal_render_ASTRenderer$Content;
/** @constructor */
function $h_Llaika_internal_render_ASTRenderer$Content() {
}
$h_Llaika_internal_render_ASTRenderer$Content.prototype = $c_Llaika_internal_render_ASTRenderer$Content.prototype;
$c_Llaika_internal_render_ASTRenderer$Content.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_internal_render_ASTRenderer$Content.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_render_ASTRenderer$Content.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_internal_render_ASTRenderer$Content)) {
    var x$0$2 = $as_Llaika_internal_render_ASTRenderer$Content(x$0);
    var x = this.Llaika_internal_render_ASTRenderer$Content__f_content;
    var x$2 = $n(x$0$2).Llaika_internal_render_ASTRenderer$Content__f_content;
    if ((((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) && (this.Llaika_internal_render_ASTRenderer$Content__f_desc === $n(x$0$2).Llaika_internal_render_ASTRenderer$Content__f_desc))) {
      var x$3 = this.Llaika_internal_render_ASTRenderer$Content__f_options;
      var x$4 = $n(x$0$2).Llaika_internal_render_ASTRenderer$Content__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_render_ASTRenderer$Content.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_internal_render_ASTRenderer$Content.prototype.productPrefix__T = (function() {
  return "Content";
});
$c_Llaika_internal_render_ASTRenderer$Content.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_internal_render_ASTRenderer$Content__f_content;
      break;
    }
    case 1: {
      return this.Llaika_internal_render_ASTRenderer$Content__f_desc;
      break;
    }
    case 2: {
      return this.Llaika_internal_render_ASTRenderer$Content__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_internal_render_ASTRenderer$Content.prototype.content__sci_Seq = (function() {
  return this.Llaika_internal_render_ASTRenderer$Content__f_content;
});
$c_Llaika_internal_render_ASTRenderer$Content.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_internal_render_ASTRenderer$Content__f_options;
});
$c_Llaika_internal_render_ASTRenderer$Content.prototype.content__O = (function() {
  return this.Llaika_internal_render_ASTRenderer$Content__f_content;
});
$c_Llaika_internal_render_ASTRenderer$Content.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_internal_render_ASTRenderer$Content__f_content;
  var desc = this.Llaika_internal_render_ASTRenderer$Content__f_desc;
  return new $c_Llaika_internal_render_ASTRenderer$Content(content, desc, options);
});
function $as_Llaika_internal_render_ASTRenderer$Content(obj) {
  return (((obj instanceof $c_Llaika_internal_render_ASTRenderer$Content) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.render.ASTRenderer$Content"));
}
function $isArrayOf_Llaika_internal_render_ASTRenderer$Content(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_render_ASTRenderer$Content)));
}
function $asArrayOf_Llaika_internal_render_ASTRenderer$Content(obj, depth) {
  return (($isArrayOf_Llaika_internal_render_ASTRenderer$Content(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.render.ASTRenderer$Content;", depth));
}
var $d_Llaika_internal_render_ASTRenderer$Content = new $TypeData().initClass($c_Llaika_internal_render_ASTRenderer$Content, "laika.internal.render.ASTRenderer$Content", ({
  Llaika_internal_render_ASTRenderer$Content: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1
}));
/** @constructor */
function $c_Llaika_internal_render_HTMLRenderer$ElementSequence(outer, content, options) {
  this.Llaika_internal_render_HTMLRenderer$ElementSequence__f_content = null;
  this.Llaika_internal_render_HTMLRenderer$ElementSequence__f_options = null;
  this.Llaika_internal_render_HTMLRenderer$ElementSequence__f_$outer = null;
  this.Llaika_internal_render_HTMLRenderer$ElementSequence__f_content = content;
  this.Llaika_internal_render_HTMLRenderer$ElementSequence__f_options = options;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Llaika_internal_render_HTMLRenderer$ElementSequence__f_$outer = outer;
}
$c_Llaika_internal_render_HTMLRenderer$ElementSequence.prototype = new $h_Llaika_ast_Element();
$c_Llaika_internal_render_HTMLRenderer$ElementSequence.prototype.constructor = $c_Llaika_internal_render_HTMLRenderer$ElementSequence;
/** @constructor */
function $h_Llaika_internal_render_HTMLRenderer$ElementSequence() {
}
$h_Llaika_internal_render_HTMLRenderer$ElementSequence.prototype = $c_Llaika_internal_render_HTMLRenderer$ElementSequence.prototype;
$c_Llaika_internal_render_HTMLRenderer$ElementSequence.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_internal_render_HTMLRenderer$ElementSequence.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_internal_render_HTMLRenderer$ElementSequence.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Llaika_internal_render_HTMLRenderer$ElementSequence) && ($n($as_Llaika_internal_render_HTMLRenderer$ElementSequence(x$0)).Llaika_internal_render_HTMLRenderer$ElementSequence__f_$outer === this.Llaika_internal_render_HTMLRenderer$ElementSequence__f_$outer))) {
    var x$0$2 = $as_Llaika_internal_render_HTMLRenderer$ElementSequence(x$0);
    var x = this.Llaika_internal_render_HTMLRenderer$ElementSequence__f_content;
    var x$2 = $n(x$0$2).Llaika_internal_render_HTMLRenderer$ElementSequence__f_content;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_internal_render_HTMLRenderer$ElementSequence__f_options;
      var x$4 = $n(x$0$2).Llaika_internal_render_HTMLRenderer$ElementSequence__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_internal_render_HTMLRenderer$ElementSequence.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_internal_render_HTMLRenderer$ElementSequence.prototype.productPrefix__T = (function() {
  return "ElementSequence";
});
$c_Llaika_internal_render_HTMLRenderer$ElementSequence.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_internal_render_HTMLRenderer$ElementSequence__f_content;
  }
  if ((n === 1)) {
    return this.Llaika_internal_render_HTMLRenderer$ElementSequence__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_internal_render_HTMLRenderer$ElementSequence.prototype.content__sci_Seq = (function() {
  return this.Llaika_internal_render_HTMLRenderer$ElementSequence__f_content;
});
$c_Llaika_internal_render_HTMLRenderer$ElementSequence.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_internal_render_HTMLRenderer$ElementSequence__f_options;
});
$c_Llaika_internal_render_HTMLRenderer$ElementSequence.prototype.copy__sci_Seq__Llaika_ast_Options__Llaika_internal_render_HTMLRenderer$ElementSequence = (function(content, options) {
  return new $c_Llaika_internal_render_HTMLRenderer$ElementSequence(this.Llaika_internal_render_HTMLRenderer$ElementSequence__f_$outer, content, options);
});
$c_Llaika_internal_render_HTMLRenderer$ElementSequence.prototype.content__O = (function() {
  return this.Llaika_internal_render_HTMLRenderer$ElementSequence__f_content;
});
$c_Llaika_internal_render_HTMLRenderer$ElementSequence.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  return this.copy__sci_Seq__Llaika_ast_Options__Llaika_internal_render_HTMLRenderer$ElementSequence(this.Llaika_internal_render_HTMLRenderer$ElementSequence__f_content, options);
});
function $as_Llaika_internal_render_HTMLRenderer$ElementSequence(obj) {
  return (((obj instanceof $c_Llaika_internal_render_HTMLRenderer$ElementSequence) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.internal.render.HTMLRenderer$ElementSequence"));
}
function $isArrayOf_Llaika_internal_render_HTMLRenderer$ElementSequence(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_internal_render_HTMLRenderer$ElementSequence)));
}
function $asArrayOf_Llaika_internal_render_HTMLRenderer$ElementSequence(obj, depth) {
  return (($isArrayOf_Llaika_internal_render_HTMLRenderer$ElementSequence(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.internal.render.HTMLRenderer$ElementSequence;", depth));
}
var $d_Llaika_internal_render_HTMLRenderer$ElementSequence = new $TypeData().initClass($c_Llaika_internal_render_HTMLRenderer$ElementSequence, "laika.internal.render.HTMLRenderer$ElementSequence", ({
  Llaika_internal_render_HTMLRenderer$ElementSequence: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1
}));
/** @constructor */
function $c_Llaika_parse_text_DelimiterResult$Continue$() {
}
$c_Llaika_parse_text_DelimiterResult$Continue$.prototype = new $h_O();
$c_Llaika_parse_text_DelimiterResult$Continue$.prototype.constructor = $c_Llaika_parse_text_DelimiterResult$Continue$;
/** @constructor */
function $h_Llaika_parse_text_DelimiterResult$Continue$() {
}
$h_Llaika_parse_text_DelimiterResult$Continue$.prototype = $c_Llaika_parse_text_DelimiterResult$Continue$.prototype;
$c_Llaika_parse_text_DelimiterResult$Continue$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_parse_text_DelimiterResult$Continue$.prototype.hashCode__I = (function() {
  return (-502558521);
});
$c_Llaika_parse_text_DelimiterResult$Continue$.prototype.toString__T = (function() {
  return "Continue";
});
$c_Llaika_parse_text_DelimiterResult$Continue$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_parse_text_DelimiterResult$Continue$.prototype.productPrefix__T = (function() {
  return "Continue";
});
$c_Llaika_parse_text_DelimiterResult$Continue$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_parse_text_DelimiterResult$Continue$ = new $TypeData().initClass($c_Llaika_parse_text_DelimiterResult$Continue$, "laika.parse.text.DelimiterResult$Continue$", ({
  Llaika_parse_text_DelimiterResult$Continue$: 1,
  Llaika_parse_text_DelimiterResult: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_parse_text_DelimiterResult$Continue$;
function $m_Llaika_parse_text_DelimiterResult$Continue$() {
  if ((!$n_Llaika_parse_text_DelimiterResult$Continue$)) {
    $n_Llaika_parse_text_DelimiterResult$Continue$ = new $c_Llaika_parse_text_DelimiterResult$Continue$();
  }
  return $n_Llaika_parse_text_DelimiterResult$Continue$;
}
function $f_sc_BitSetOps__contains__I__Z($thiz, elem) {
  if ((elem >= 0)) {
    var this$1 = $thiz.word__I__J((elem >> 6));
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (this$1.RTLong__f_lo & lo);
    var hi$1 = (this$1.RTLong__f_hi & hi);
    return (!((lo$1 === 0) && (hi$1 === 0)));
  } else {
    return false;
  }
}
function $f_sc_BitSetOps__size__I($thiz) {
  var s = 0;
  var i = $thiz.nwords__I();
  while ((i > 0)) {
    i = (((-1) + i) | 0);
    var $x_1 = s;
    var t = $thiz.word__I__J(i);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    s = (($x_1 + (($m_jl_Integer$().bitCount__I__I(lo) + $m_jl_Integer$().bitCount__I__I(hi)) | 0)) | 0);
  }
  return s;
}
function $f_sc_BitSetOps__isEmpty__Z($thiz) {
  var end = $thiz.nwords__I();
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = (((-1) + end) | 0);
  var res = true;
  var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
  while ((res && it.sci_RangeIterator__f__hasNext)) {
    var arg1 = it.next__I();
    var this$6 = $thiz.word__I__J(arg1);
    res = ((this$6.RTLong__f_lo === 0) && (this$6.RTLong__f_hi === 0));
  }
  return res;
}
function $f_sc_BitSetOps__max__s_math_Ordering__I($thiz, ord) {
  if (($m_s_math_Ordering$Int$() === ord)) {
    var i = (((-1) + $thiz.nwords__I()) | 0);
    while ((i >= 0)) {
      var t = $thiz.word__I__J(i);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      if ((!((lo === 0) && (hi === 0)))) {
        return (((-1) + (((((1 + i) | 0) << 6) - ((hi !== 0) ? $uI(Math.clz32(hi)) : ((32 + $uI(Math.clz32(lo))) | 0))) | 0)) | 0);
      }
      i = (((-1) + i) | 0);
    }
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.largestInt");
  } else {
    var this$4 = $m_s_math_Ordering$Int$();
    if ($f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z(this$4, ord)) {
      var thisnwords = $thiz.nwords__I();
      var i$1 = 0;
      while ((i$1 < thisnwords)) {
        var t$1 = $thiz.word__I__J(i$1);
        var lo$1 = t$1.RTLong__f_lo;
        var hi$1 = t$1.RTLong__f_hi;
        if ((!((lo$1 === 0) && (hi$1 === 0)))) {
          if ((lo$1 !== 0)) {
            if ((lo$1 === 0)) {
              var $x_1 = 32;
            } else {
              var i$2 = (lo$1 & ((-lo$1) | 0));
              var $x_1 = ((31 - $uI(Math.clz32(i$2))) | 0);
            }
          } else {
            if ((hi$1 === 0)) {
              var $x_2 = 32;
            } else {
              var i$3 = (hi$1 & ((-hi$1) | 0));
              var $x_2 = ((31 - $uI(Math.clz32(i$3))) | 0);
            }
            var $x_1 = ((32 + $x_2) | 0);
          }
          return (($x_1 + (i$1 << 6)) | 0);
        }
        i$1 = ((1 + i$1) | 0);
      }
      throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.smallestInt");
    } else {
      return $thiz.scala$collection$BitSetOps$$super$max__s_math_Ordering__I(ord);
    }
  }
}
function $f_sc_BitSetOps__foreach__F1__V($thiz, f) {
  var i = 0;
  while ((i < $thiz.nwords__I())) {
    var t = $thiz.word__I__J(i);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var w__lo = lo;
    var w__hi = hi;
    var j = (i << 6);
    while (true) {
      var this$1__lo = w__lo;
      var this$1__hi = w__hi;
      if ((!((this$1__lo === 0) && (this$1__hi === 0)))) {
        var b__lo = w__lo;
        var b__hi = w__hi;
        var lo$1 = (1 & b__lo);
        if ((lo$1 === 1)) {
          $n(f).apply__O__O(j);
        }
        var this$2__lo = w__lo;
        var this$2__hi = w__hi;
        var hi$1 = this$2__hi;
        var lo$2 = (((this$2__lo >>> 1) | 0) | (hi$1 << 31));
        var hi$2 = ((hi$1 >>> 1) | 0);
        var $x_1__lo = lo$2;
        var $x_1__hi = hi$2;
        w__lo = $x_1__lo;
        w__hi = $x_1__hi;
        j = ((1 + j) | 0);
      } else {
        break;
      }
    }
    i = ((1 + i) | 0);
  }
}
function $f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet($thiz, other) {
  if ($is_sc_BitSet(other)) {
    var x2 = $as_sc_BitSet(other);
    var x = $n($as_sc_BitSetOps($thiz)).nwords__I();
    var that = $n(x2).nwords__I();
    var len = ((x > that) ? x : that);
    var words = new $ac_J(len);
    var isEmpty = (len <= 0);
    var scala$collection$immutable$Range$$lastElement = (((-1) + len) | 0);
    if ((!isEmpty)) {
      var i = 0;
      while (true) {
        var v1 = i;
        var $x_1 = $n(words);
        var this$10 = $thiz.word__I__J(v1);
        var b = $n(x2).word__I__J(v1);
        var lo = (this$10.RTLong__f_lo | b.RTLong__f_lo);
        var hi$2 = (this$10.RTLong__f_hi | b.RTLong__f_hi);
        $x_1.set(v1, new $c_RTLong(lo, hi$2));
        if ((i === scala$collection$immutable$Range$$lastElement)) {
          break;
        }
        i = ((1 + i) | 0);
      }
    }
    return $thiz.fromBitMaskNoCopy__AJ__sc_BitSet(words);
  } else {
    return $thiz.scala$collection$BitSetOps$$super$concat__sc_IterableOnce__sc_BitSet(other);
  }
}
function $f_sc_BitSetOps__diff__sc_Set__sc_BitSet($thiz, other) {
  if ($is_sc_BitSet(other)) {
    var x2 = $as_sc_BitSet(other);
    var len = $n($as_sc_BitSetOps($thiz)).nwords__I();
    var words = new $ac_J(len);
    var isEmpty = (len <= 0);
    var scala$collection$immutable$Range$$lastElement = (((-1) + len) | 0);
    if ((!isEmpty)) {
      var i = 0;
      while (true) {
        var v1 = i;
        var $x_1 = $n(words);
        var this$6 = $thiz.word__I__J(v1);
        var b = $n(x2).word__I__J(v1);
        var lo = (~b.RTLong__f_lo);
        var hi$2 = (~b.RTLong__f_hi);
        var lo$1 = (this$6.RTLong__f_lo & lo);
        var hi$3 = (this$6.RTLong__f_hi & hi$2);
        $x_1.set(v1, new $c_RTLong(lo$1, hi$3));
        if ((i === scala$collection$immutable$Range$$lastElement)) {
          break;
        }
        i = ((1 + i) | 0);
      }
    }
    return $thiz.fromBitMaskNoCopy__AJ__sc_BitSet(words);
  } else {
    return $thiz.scala$collection$BitSetOps$$super$diff__sc_Set__sc_BitSet(other);
  }
}
function $f_sc_BitSetOps__partition__F1__T2($thiz, p) {
  var left = $as_sc_BitSet($thiz.filterImpl__F1__Z__O(p, false));
  return new $c_T2(left, $thiz.diff__sc_Set__sc_SetOps(left));
}
function $is_sc_BitSetOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_BitSetOps)));
}
function $as_sc_BitSetOps(obj) {
  return (($is_sc_BitSetOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.BitSetOps"));
}
function $isArrayOf_sc_BitSetOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_BitSetOps)));
}
function $asArrayOf_sc_BitSetOps(obj, depth) {
  return (($isArrayOf_sc_BitSetOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.BitSetOps;", depth));
}
function $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq($thiz, n, s) {
  while (true) {
    if (((n <= 0) || $n(s).isEmpty__Z())) {
      return s;
    } else {
      var temp$n = (((-1) + n) | 0);
      var temp$s = $as_sc_LinearSeq($n(s).tail__O());
      n = temp$n;
      s = temp$s;
    }
  }
}
function $p_sc_StrictOptimizedLinearSeqOps__loop$3__sc_LinearSeq__F1__sc_LinearSeq($thiz, s, p$1) {
  while (true) {
    var this$1 = $n(s);
    if (((!this$1.isEmpty__Z()) && $uZ($n(p$1).apply__O__O($n(s).head__O())))) {
      s = $as_sc_LinearSeq($n(s).tail__O());
    } else {
      break;
    }
  }
  return s;
}
function $is_sc_StrictOptimizedLinearSeqOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_StrictOptimizedLinearSeqOps)));
}
function $as_sc_StrictOptimizedLinearSeqOps(obj) {
  return (($is_sc_StrictOptimizedLinearSeqOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.StrictOptimizedLinearSeqOps"));
}
function $isArrayOf_sc_StrictOptimizedLinearSeqOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_StrictOptimizedLinearSeqOps)));
}
function $asArrayOf_sc_StrictOptimizedLinearSeqOps(obj, depth) {
  return (($isArrayOf_sc_StrictOptimizedLinearSeqOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.StrictOptimizedLinearSeqOps;", depth));
}
function $f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps($thiz, f) {
  var b = $n($thiz.mapFactory__sc_MapFactory()).newBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var this$1 = $n(b);
    var elem = $n(f).apply__O__O($n(it).next__O());
    this$1.addOne__O__scm_Growable(elem);
  }
  return $as_sc_IterableOps($n(b).result__O());
}
function $f_sc_StrictOptimizedMapOps__concat__sc_IterableOnce__sc_IterableOps($thiz, suffix) {
  var b = $n($thiz.mapFactory__sc_MapFactory()).newBuilder__scm_Builder();
  var this$1 = $n(b);
  this$1.addAll__sc_IterableOnce__scm_Growable($thiz);
  var this$2 = $n(b);
  this$2.addAll__sc_IterableOnce__scm_Growable(suffix);
  return $as_sc_IterableOps($n(b).result__O());
}
function $f_sc_StrictOptimizedMapOps__collect__s_PartialFunction__sc_IterableOps($thiz, pf) {
  var b = $n($thiz.mapFactory__sc_MapFactory()).newBuilder__scm_Builder();
  var marker = $m_sr_Statics$PFMarker$();
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    var v = $n(pf).applyOrElse__O__F1__O(elem, new $c_sjsr_AnonFunction1(((marker) => ((x$2) => marker))(marker)));
    if ((marker !== v)) {
      var this$3 = $n(b);
      this$3.addOne__O__scm_Growable(v);
    }
  }
  return $as_sc_IterableOps($n(b).result__O());
}
function $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O($thiz, f) {
  if (($thiz.lengthCompare__I__I(1) <= 0)) {
    return $thiz;
  } else {
    var builder = $thiz.newSpecificBuilder__scm_Builder();
    var seen = $ct_scm_HashSet__(new $c_scm_HashSet());
    var it = $thiz.iterator__sc_Iterator();
    var different = false;
    while ($n(it).hasNext__Z()) {
      var next = $n(it).next__O();
      if (seen.add__O__Z($n(f).apply__O__O(next))) {
        var this$2 = $n(builder);
        this$2.addOne__O__scm_Growable(next);
      } else {
        different = true;
      }
    }
    return (different ? $n(builder).result__O() : $thiz);
  }
}
function $p_s_math_BigDecimal__computeHashCode__V($thiz) {
  if ($thiz.isWhole__Z()) {
    var $x_3 = $n($thiz.s_math_BigDecimal__f_bigDecimal).precision__I();
    var this$1 = $n($thiz.s_math_BigDecimal__f_bigDecimal);
    var $x_2 = ((($x_3 - this$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0) < 4934);
  } else {
    var $x_2 = false;
  }
  if ($x_2) {
    var $x_1 = $n($thiz.toBigInt__s_math_BigInt()).hashCode__I();
  } else if ($thiz.isDecimalDouble__Z()) {
    var dv = $n($thiz.s_math_BigDecimal__f_bigDecimal).doubleValue__D();
    var $x_1 = $m_sr_Statics$().doubleHash__D__I(dv);
  } else {
    var temp = $n($thiz.s_math_BigDecimal__f_bigDecimal).stripTrailingZeros__Ljava_math_BigDecimal();
    var $x_5 = $m_s_util_hashing_MurmurHash3$();
    var this$2 = $n(temp);
    var $x_4 = $n($n($n(temp).scaleByPowerOfTen__I__Ljava_math_BigDecimal(this$2.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)).toBigInteger__Ljava_math_BigInteger()).hashCode__I();
    var this$3 = $n(temp);
    var $x_1 = $n($x_5).mixLast__I__I__I($x_4, this$3.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
  }
  $thiz.s_math_BigDecimal__f_computedHashCode = $x_1;
}
/** @constructor */
function $c_s_math_BigDecimal(bigDecimal, mc) {
  this.s_math_BigDecimal__f_bigDecimal = null;
  this.s_math_BigDecimal__f_mc = null;
  this.s_math_BigDecimal__f_computedHashCode = 0;
  this.s_math_BigDecimal__f_bigDecimal = bigDecimal;
  this.s_math_BigDecimal__f_mc = mc;
  if ((bigDecimal === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null value for BigDecimal");
  }
  if ((mc === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null MathContext for BigDecimal");
  }
  this.s_math_BigDecimal__f_computedHashCode = 1565550863;
}
$c_s_math_BigDecimal.prototype = new $h_s_math_ScalaNumber();
$c_s_math_BigDecimal.prototype.constructor = $c_s_math_BigDecimal;
/** @constructor */
function $h_s_math_BigDecimal() {
}
$h_s_math_BigDecimal.prototype = $c_s_math_BigDecimal.prototype;
$c_s_math_BigDecimal.prototype.compareTo__O__I = (function(that) {
  var that$1 = $as_s_math_BigDecimal(that);
  return $n(this.s_math_BigDecimal__f_bigDecimal).compareTo__Ljava_math_BigDecimal__I($n(that$1).s_math_BigDecimal__f_bigDecimal);
});
$c_s_math_BigDecimal.prototype.hashCode__I = (function() {
  if ((this.s_math_BigDecimal__f_computedHashCode === 1565550863)) {
    $p_s_math_BigDecimal__computeHashCode__V(this);
  }
  return this.s_math_BigDecimal__f_computedHashCode;
});
$c_s_math_BigDecimal.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_s_math_BigDecimal)) {
    var x2 = $as_s_math_BigDecimal(that);
    return this.equals__s_math_BigDecimal__Z(x2);
  } else if ((that instanceof $c_s_math_BigInt)) {
    var x3 = $as_s_math_BigInt(that);
    var $x_2 = $n(x3).bitLength__I();
    var $x_1 = $n(this.s_math_BigDecimal__f_bigDecimal).precision__I();
    var this$1 = $n(this.s_math_BigDecimal__f_bigDecimal);
    if (($x_2 > (3.3219280948873626 * (((-2) + (($x_1 - this$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0)) | 0)))) {
      var this$2 = $n(this.toBigIntExact__s_Option());
      if ((!this$2.isEmpty__Z())) {
        var arg1 = this$2.get__O();
        var x$1 = $as_s_math_BigInt(arg1);
        return $n(x3).equals__s_math_BigInt__Z(x$1);
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else if (((typeof that) === "number")) {
    var x4 = $uD(that);
    if ((!((x4 === Infinity) || (x4 === (-Infinity))))) {
      var d = $n(this.s_math_BigDecimal__f_bigDecimal).doubleValue__D();
      if (((!((d === Infinity) || (d === (-Infinity)))) && (d === x4))) {
        var this$9 = $m_s_math_BigDecimal$();
        return this.equals__s_math_BigDecimal__Z(this$9.decimal__D__Ljava_math_MathContext__s_math_BigDecimal(d, this$9.s_math_BigDecimal$__f_defaultMathContext));
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else if ($isFloat(that)) {
    var x5 = $uF(that);
    if ((!((x5 === Infinity) || (x5 === (-Infinity))))) {
      var f = $n(this.s_math_BigDecimal__f_bigDecimal).floatValue__F();
      if (((!((f === Infinity) || (f === (-Infinity)))) && (f === x5))) {
        var this$16 = $m_s_math_BigDecimal$();
        var d$1 = f;
        return this.equals__s_math_BigDecimal__Z(this$16.decimal__D__Ljava_math_MathContext__s_math_BigDecimal(d$1, this$16.s_math_BigDecimal$__f_defaultMathContext));
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return (this.isValidLong__Z() && $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z(this, that));
  }
});
$c_s_math_BigDecimal.prototype.isValidByte__Z = (function() {
  try {
    $n(this.s_math_BigDecimal__f_bigDecimal).byteValueExact__B();
    return true;
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false;
    } else {
      throw e;
    }
  }
});
$c_s_math_BigDecimal.prototype.isValidShort__Z = (function() {
  try {
    $n(this.s_math_BigDecimal__f_bigDecimal).shortValueExact__S();
    return true;
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false;
    } else {
      throw e;
    }
  }
});
$c_s_math_BigDecimal.prototype.isValidChar__Z = (function() {
  return ((this.isValidInt__Z() && ($n(this.s_math_BigDecimal__f_bigDecimal).intValueExact__I() >= 0)) && ($n(this.s_math_BigDecimal__f_bigDecimal).intValueExact__I() <= 65535));
});
$c_s_math_BigDecimal.prototype.isValidInt__Z = (function() {
  try {
    $n(this.s_math_BigDecimal__f_bigDecimal).intValueExact__I();
    return true;
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false;
    } else {
      throw e;
    }
  }
});
$c_s_math_BigDecimal.prototype.isValidLong__Z = (function() {
  try {
    var this$1 = $n(this.s_math_BigDecimal__f_bigDecimal);
    $p_Ljava_math_BigDecimal__valueExact__I__J(this$1, 64);
    return true;
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false;
    } else {
      throw e;
    }
  }
});
$c_s_math_BigDecimal.prototype.isDecimalDouble__Z = (function() {
  var d = $n(this.s_math_BigDecimal__f_bigDecimal).doubleValue__D();
  if ((!((d === Infinity) || (d === (-Infinity))))) {
    var this$4 = $m_s_math_BigDecimal$();
    return this.equals__s_math_BigDecimal__Z(this$4.decimal__D__Ljava_math_MathContext__s_math_BigDecimal(d, this$4.s_math_BigDecimal$__f_defaultMathContext));
  } else {
    return false;
  }
});
$c_s_math_BigDecimal.prototype.isWhole__Z = (function() {
  var this$1 = $n(this.s_math_BigDecimal__f_bigDecimal);
  if ((this$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= 0)) {
    return true;
  } else {
    var this$2 = $n($n(this.s_math_BigDecimal__f_bigDecimal).stripTrailingZeros__Ljava_math_BigDecimal());
    return (this$2.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= 0);
  }
});
$c_s_math_BigDecimal.prototype.equals__s_math_BigDecimal__Z = (function(that) {
  return ($n(this.s_math_BigDecimal__f_bigDecimal).compareTo__Ljava_math_BigDecimal__I($n(that).s_math_BigDecimal__f_bigDecimal) === 0);
});
$c_s_math_BigDecimal.prototype.max__s_math_BigDecimal__s_math_BigDecimal = (function(that) {
  var x1 = $n(this.s_math_BigDecimal__f_bigDecimal).compareTo__Ljava_math_BigDecimal__I($n(that).s_math_BigDecimal__f_bigDecimal);
  return ((x1 >= 0) ? this : that);
});
$c_s_math_BigDecimal.prototype.byteValue__B = (function() {
  return (($n(this.s_math_BigDecimal__f_bigDecimal).intValue__I() << 24) >> 24);
});
$c_s_math_BigDecimal.prototype.shortValue__S = (function() {
  return (($n(this.s_math_BigDecimal__f_bigDecimal).intValue__I() << 16) >> 16);
});
$c_s_math_BigDecimal.prototype.intValue__I = (function() {
  return $n(this.s_math_BigDecimal__f_bigDecimal).intValue__I();
});
$c_s_math_BigDecimal.prototype.longValue__J = (function() {
  return $n(this.s_math_BigDecimal__f_bigDecimal).longValue__J();
});
$c_s_math_BigDecimal.prototype.floatValue__F = (function() {
  return $n(this.s_math_BigDecimal__f_bigDecimal).floatValue__F();
});
$c_s_math_BigDecimal.prototype.doubleValue__D = (function() {
  return $n(this.s_math_BigDecimal__f_bigDecimal).doubleValue__D();
});
$c_s_math_BigDecimal.prototype.toBigInt__s_math_BigInt = (function() {
  return $ct_s_math_BigInt__Ljava_math_BigInteger__(new $c_s_math_BigInt(), $n(this.s_math_BigDecimal__f_bigDecimal).toBigInteger__Ljava_math_BigInteger());
});
$c_s_math_BigDecimal.prototype.toBigIntExact__s_Option = (function() {
  if (this.isWhole__Z()) {
    try {
      return new $c_s_Some($ct_s_math_BigInt__Ljava_math_BigInteger__(new $c_s_math_BigInt(), $n(this.s_math_BigDecimal__f_bigDecimal).toBigIntegerExact__Ljava_math_BigInteger()));
    } catch (e) {
      if ((e instanceof $c_jl_ArithmeticException)) {
        return $m_s_None$();
      } else {
        throw e;
      }
    }
  } else {
    return $m_s_None$();
  }
});
$c_s_math_BigDecimal.prototype.toString__T = (function() {
  return $n(this.s_math_BigDecimal__f_bigDecimal).toString__T();
});
$c_s_math_BigDecimal.prototype.compare__O__I = (function(that) {
  var that$1 = $as_s_math_BigDecimal(that);
  return $n(this.s_math_BigDecimal__f_bigDecimal).compareTo__Ljava_math_BigDecimal__I($n(that$1).s_math_BigDecimal__f_bigDecimal);
});
$c_s_math_BigDecimal.prototype.underlying__O = (function() {
  return this.s_math_BigDecimal__f_bigDecimal;
});
function $as_s_math_BigDecimal(obj) {
  return (((obj instanceof $c_s_math_BigDecimal) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.BigDecimal"));
}
function $isArrayOf_s_math_BigDecimal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_BigDecimal)));
}
function $asArrayOf_s_math_BigDecimal(obj, depth) {
  return (($isArrayOf_s_math_BigDecimal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.BigDecimal;", depth));
}
var $d_s_math_BigDecimal = new $TypeData().initClass($c_s_math_BigDecimal, "scala.math.BigDecimal", ({
  s_math_BigDecimal: 1,
  s_math_ScalaNumber: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  s_math_ScalaNumericConversions: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
}));
function $p_s_math_BigInt__longEncoding__Z($thiz) {
  var this$1 = $thiz.s_math_BigInt__f__long;
  return (!((this$1.RTLong__f_lo === 0) && (this$1.RTLong__f_hi === (-2147483648))));
}
function $p_s_math_BigInt__bitLengthOverflow__Z($thiz) {
  var shifted = $n($thiz.bigInteger__Ljava_math_BigInteger()).shiftRight__I__Ljava_math_BigInteger(2147483647);
  var this$1 = $n(shifted);
  if ((this$1.Ljava_math_BigInteger__f_sign !== 0)) {
    return (!$n(shifted).equals__O__Z($m_s_math_BigInt$().s_math_BigInt$__f_scala$math$BigInt$$minusOne));
  } else {
    return false;
  }
}
function $ct_s_math_BigInt__Ljava_math_BigInteger__J__($thiz, _bigInteger, _long) {
  $thiz.s_math_BigInt__f__bigInteger = _bigInteger;
  $thiz.s_math_BigInt__f__long = _long;
  return $thiz;
}
function $ct_s_math_BigInt__Ljava_math_BigInteger__($thiz, bigInteger) {
  var this$1 = $n(bigInteger);
  $ct_s_math_BigInt__Ljava_math_BigInteger__J__($thiz, bigInteger, (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$1) <= 63) ? $n(bigInteger).longValue__J() : new $c_RTLong(0, (-2147483648))));
  return $thiz;
}
/** @constructor */
function $c_s_math_BigInt() {
  this.s_math_BigInt__f__bigInteger = null;
  this.s_math_BigInt__f__long = $L0;
}
$c_s_math_BigInt.prototype = new $h_s_math_ScalaNumber();
$c_s_math_BigInt.prototype.constructor = $c_s_math_BigInt;
/** @constructor */
function $h_s_math_BigInt() {
}
$h_s_math_BigInt.prototype = $c_s_math_BigInt.prototype;
$c_s_math_BigInt.prototype.compareTo__O__I = (function(that) {
  return this.compare__s_math_BigInt__I($as_s_math_BigInt(that));
});
$c_s_math_BigInt.prototype.bigInteger__Ljava_math_BigInteger = (function() {
  var read = this.s_math_BigInt__f__bigInteger;
  if ((read !== null)) {
    return read;
  } else {
    var t = this.s_math_BigInt__f__long;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var write = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi));
    this.s_math_BigInt__f__bigInteger = write;
    return write;
  }
});
$c_s_math_BigInt.prototype.hashCode__I = (function() {
  if (this.isValidLong__Z()) {
    return $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveHashcode__I(this);
  } else {
    var x = this.bigInteger__Ljava_math_BigInteger();
    return $m_sr_Statics$().anyHash__O__I(x);
  }
});
$c_s_math_BigInt.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_s_math_BigInt)) {
    var x2 = $as_s_math_BigInt(that);
    return this.equals__s_math_BigInt__Z(x2);
  } else if ((that instanceof $c_s_math_BigDecimal)) {
    var x3 = $as_s_math_BigDecimal(that);
    return $n(x3).equals__O__Z(this);
  } else if (((typeof that) === "number")) {
    var x4 = $uD(that);
    return (this.isValidDouble__Z() && (this.doubleValue__D() === x4));
  } else if ($isFloat(that)) {
    var x5 = $uF(that);
    if (this.isValidFloat__Z()) {
      var this$1 = $n(this.bigInteger__Ljava_math_BigInteger());
      return ($m_jl_Float$().parseFloat__T__F($m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1)) === x5);
    } else {
      return false;
    }
  } else {
    return (this.isValidLong__Z() && $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z(this, that));
  }
});
$c_s_math_BigInt.prototype.isValidByte__Z = (function() {
  var this$1 = this.s_math_BigInt__f__long;
  var ahi = this$1.RTLong__f_hi;
  if (((ahi === (-1)) ? (((-2147483648) ^ this$1.RTLong__f_lo) >= 2147483520) : (ahi > (-1)))) {
    var this$2 = this.s_math_BigInt__f__long;
    var ahi$1 = this$2.RTLong__f_hi;
    return ((ahi$1 === 0) ? (((-2147483648) ^ this$2.RTLong__f_lo) <= (-2147483521)) : (ahi$1 < 0));
  } else {
    return false;
  }
});
$c_s_math_BigInt.prototype.isValidShort__Z = (function() {
  var this$1 = this.s_math_BigInt__f__long;
  var ahi = this$1.RTLong__f_hi;
  if (((ahi === (-1)) ? (((-2147483648) ^ this$1.RTLong__f_lo) >= 2147450880) : (ahi > (-1)))) {
    var this$2 = this.s_math_BigInt__f__long;
    var ahi$1 = this$2.RTLong__f_hi;
    return ((ahi$1 === 0) ? (((-2147483648) ^ this$2.RTLong__f_lo) <= (-2147450881)) : (ahi$1 < 0));
  } else {
    return false;
  }
});
$c_s_math_BigInt.prototype.isValidChar__Z = (function() {
  var this$1 = this.s_math_BigInt__f__long;
  var ahi = this$1.RTLong__f_hi;
  if ((ahi >= 0)) {
    var this$2 = this.s_math_BigInt__f__long;
    var ahi$1 = this$2.RTLong__f_hi;
    return ((ahi$1 === 0) ? (((-2147483648) ^ this$2.RTLong__f_lo) <= (-2147418113)) : (ahi$1 < 0));
  } else {
    return false;
  }
});
$c_s_math_BigInt.prototype.isValidInt__Z = (function() {
  var this$1 = this.s_math_BigInt__f__long;
  var ahi = this$1.RTLong__f_hi;
  if (((ahi === (-1)) ? (((-2147483648) ^ this$1.RTLong__f_lo) >= 0) : (ahi > (-1)))) {
    var this$2 = this.s_math_BigInt__f__long;
    var ahi$1 = this$2.RTLong__f_hi;
    return ((ahi$1 === 0) ? (((-2147483648) ^ this$2.RTLong__f_lo) <= (-1)) : (ahi$1 < 0));
  } else {
    return false;
  }
});
$c_s_math_BigInt.prototype.isValidLong__Z = (function() {
  return ($p_s_math_BigInt__longEncoding__Z(this) || $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(this.s_math_BigInt__f__bigInteger, $m_s_math_BigInt$().s_math_BigInt$__f_scala$math$BigInt$$longMinValueBigInteger));
});
$c_s_math_BigInt.prototype.isValidFloat__Z = (function() {
  var bitLen = this.bitLength__I();
  if ((bitLen <= 24)) {
    var $x_1 = true;
  } else {
    var lowest = this.lowestSetBit__I();
    var $x_1 = (((bitLen <= 128) && (lowest >= (((-24) + bitLen) | 0))) && (lowest < 128));
  }
  if ($x_1) {
    return (!$p_s_math_BigInt__bitLengthOverflow__Z(this));
  } else {
    return false;
  }
});
$c_s_math_BigInt.prototype.isValidDouble__Z = (function() {
  var bitLen = this.bitLength__I();
  if ((bitLen <= 53)) {
    var $x_1 = true;
  } else {
    var lowest = this.lowestSetBit__I();
    var $x_1 = (((bitLen <= 1024) && (lowest >= (((-53) + bitLen) | 0))) && (lowest < 1024));
  }
  if ($x_1) {
    return (!$p_s_math_BigInt__bitLengthOverflow__Z(this));
  } else {
    return false;
  }
});
$c_s_math_BigInt.prototype.isWhole__Z = (function() {
  return true;
});
$c_s_math_BigInt.prototype.equals__s_math_BigInt__Z = (function(that) {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    if ($p_s_math_BigInt__longEncoding__Z($n(that))) {
      var this$1 = this.s_math_BigInt__f__long;
      var b = $n(that).s_math_BigInt__f__long;
      return ((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi));
    } else {
      return false;
    }
  } else {
    return ((!$p_s_math_BigInt__longEncoding__Z($n(that))) && $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(this.s_math_BigInt__f__bigInteger, $n(that).s_math_BigInt__f__bigInteger));
  }
});
$c_s_math_BigInt.prototype.compare__s_math_BigInt__I = (function(that) {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    if ($p_s_math_BigInt__longEncoding__Z($n(that))) {
      var t = this.s_math_BigInt__f__long;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var t$1 = $n(that).s_math_BigInt__f__long;
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1);
    } else {
      var this$1 = $n($n(that).s_math_BigInt__f__bigInteger);
      return ((-this$1.Ljava_math_BigInteger__f_sign) | 0);
    }
  } else if ($p_s_math_BigInt__longEncoding__Z($n(that))) {
    var this$2 = $n(this.s_math_BigInt__f__bigInteger);
    return this$2.Ljava_math_BigInteger__f_sign;
  } else {
    return $n(this.s_math_BigInt__f__bigInteger).compareTo__Ljava_math_BigInteger__I($n(that).s_math_BigInt__f__bigInteger);
  }
});
$c_s_math_BigInt.prototype.$plus__s_math_BigInt__s_math_BigInt = (function(that) {
  if (($p_s_math_BigInt__longEncoding__Z(this) && $p_s_math_BigInt__longEncoding__Z($n(that)))) {
    var t = this.s_math_BigInt__f__long;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = $n(that).s_math_BigInt__f__long;
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var lo$2 = ((lo + lo$1) | 0);
    var hi$2 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo)) ? ((1 + ((hi + hi$1) | 0)) | 0) : ((hi + hi$1) | 0));
    var hi$3 = (hi ^ hi$1);
    var hi$4 = (~hi$3);
    var hi$5 = (hi ^ hi$2);
    var hi$6 = (hi$4 & hi$5);
    if ((hi$6 >= 0)) {
      return $m_s_math_BigInt$().apply__J__s_math_BigInt(new $c_RTLong(lo$2, hi$2));
    }
  }
  var $x_1 = $m_s_math_BigInt$();
  var this$2 = $n(this.bigInteger__Ljava_math_BigInteger());
  var bi = $n(that).bigInteger__Ljava_math_BigInteger();
  return $n($x_1).apply__Ljava_math_BigInteger__s_math_BigInt($m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$2, bi));
});
$c_s_math_BigInt.prototype.max__s_math_BigInt__s_math_BigInt = (function(that) {
  return ($f_s_math_Ordered__$greater$eq__O__Z(this, that) ? this : that);
});
$c_s_math_BigInt.prototype.lowestSetBit__I = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var this$1 = this.s_math_BigInt__f__long;
    if (((this$1.RTLong__f_lo === 0) && (this$1.RTLong__f_hi === 0))) {
      return (-1);
    } else {
      var t = this.s_math_BigInt__f__long;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      if ((lo !== 0)) {
        if ((lo === 0)) {
          return 32;
        } else {
          var i = (lo & ((-lo) | 0));
          return ((31 - $uI(Math.clz32(i))) | 0);
        }
      } else {
        if ((hi === 0)) {
          var $x_1 = 32;
        } else {
          var i$1 = (hi & ((-hi) | 0));
          var $x_1 = ((31 - $uI(Math.clz32(i$1))) | 0);
        }
        return ((32 + $x_1) | 0);
      }
    }
  } else {
    return $n(this.bigInteger__Ljava_math_BigInteger()).getLowestSetBit__I();
  }
});
$c_s_math_BigInt.prototype.bitLength__I = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var this$1 = this.s_math_BigInt__f__long;
    var ahi = this$1.RTLong__f_hi;
    if ((ahi < 0)) {
      var b = this.s_math_BigInt__f__long;
      var bhi = b.RTLong__f_hi;
      var lo = ((1 + b.RTLong__f_lo) | 0);
      var hi = ((lo === 0) ? ((1 + bhi) | 0) : bhi);
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
      return ((64 - ((hi$1 !== 0) ? $uI(Math.clz32(hi$1)) : ((32 + $uI(Math.clz32(lo$1))) | 0))) | 0);
    } else {
      var t = this.s_math_BigInt__f__long;
      var lo$2 = t.RTLong__f_lo;
      var hi$2 = t.RTLong__f_hi;
      return ((64 - ((hi$2 !== 0) ? $uI(Math.clz32(hi$2)) : ((32 + $uI(Math.clz32(lo$2))) | 0))) | 0);
    }
  } else {
    var this$11 = $n(this.s_math_BigInt__f__bigInteger);
    return $m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$11);
  }
});
$c_s_math_BigInt.prototype.byteValue__B = (function() {
  return ((this.intValue__I() << 24) >> 24);
});
$c_s_math_BigInt.prototype.shortValue__S = (function() {
  return ((this.intValue__I() << 16) >> 16);
});
$c_s_math_BigInt.prototype.intValue__I = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var this$1 = this.s_math_BigInt__f__long;
    return this$1.RTLong__f_lo;
  } else {
    return $n(this.bigInteger__Ljava_math_BigInteger()).intValue__I();
  }
});
$c_s_math_BigInt.prototype.longValue__J = (function() {
  return ($p_s_math_BigInt__longEncoding__Z(this) ? this.s_math_BigInt__f__long : $n(this.s_math_BigInt__f__bigInteger).longValue__J());
});
$c_s_math_BigInt.prototype.floatValue__F = (function() {
  var this$1 = $n(this.bigInteger__Ljava_math_BigInteger());
  return $m_jl_Float$().parseFloat__T__F($m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1));
});
$c_s_math_BigInt.prototype.doubleValue__D = (function() {
  if (this.isValidLong__Z()) {
    var this$1 = this.s_math_BigInt__f__long;
    var ahi = this$1.RTLong__f_hi;
    if ((ahi >= (-2097152))) {
      var this$2 = this.s_math_BigInt__f__long;
      var ahi$1 = this$2.RTLong__f_hi;
      var $x_1 = ((ahi$1 === 2097152) ? (this$2.RTLong__f_lo === 0) : (ahi$1 < 2097152));
    } else {
      var $x_1 = false;
    }
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var this$3 = this.s_math_BigInt__f__long;
    return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$3.RTLong__f_lo, this$3.RTLong__f_hi);
  } else {
    var this$4 = $n(this.bigInteger__Ljava_math_BigInteger());
    return $m_jl_Double$().parseDouble__T__D($m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$4));
  }
});
$c_s_math_BigInt.prototype.toString__T = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var this$1 = this.s_math_BigInt__f__long;
    return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this$1.RTLong__f_lo, this$1.RTLong__f_hi);
  } else {
    var this$2 = $n(this.s_math_BigInt__f__bigInteger);
    return $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$2);
  }
});
$c_s_math_BigInt.prototype.compare__O__I = (function(that) {
  return this.compare__s_math_BigInt__I($as_s_math_BigInt(that));
});
$c_s_math_BigInt.prototype.underlying__O = (function() {
  return this.bigInteger__Ljava_math_BigInteger();
});
function $as_s_math_BigInt(obj) {
  return (((obj instanceof $c_s_math_BigInt) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.BigInt"));
}
function $isArrayOf_s_math_BigInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_BigInt)));
}
function $asArrayOf_s_math_BigInt(obj, depth) {
  return (($isArrayOf_s_math_BigInt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.BigInt;", depth));
}
var $d_s_math_BigInt = new $TypeData().initClass($c_s_math_BigInt, "scala.math.BigInt", ({
  s_math_BigInt: 1,
  s_math_ScalaNumber: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  s_math_ScalaNumericConversions: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
}));
function $f_s_math_Numeric$ByteIsIntegral__plus__B__B__B($thiz, x, y) {
  return ((((x + y) | 0) << 24) >> 24);
}
function $f_s_math_Numeric$ByteIsIntegral__minus__B__B__B($thiz, x, y) {
  return ((((x - y) | 0) << 24) >> 24);
}
function $f_s_math_Numeric$ByteIsIntegral__times__B__B__B($thiz, x, y) {
  return ((Math.imul(x, y) << 24) >> 24);
}
function $f_s_math_Numeric$ByteIsIntegral__quot__B__B__B($thiz, x, y) {
  return (($intDiv(x, y) << 24) >> 24);
}
function $f_s_math_Numeric$ByteIsIntegral__rem__B__B__B($thiz, x, y) {
  return (($intMod(x, y) << 24) >> 24);
}
function $f_s_math_Numeric$ByteIsIntegral__negate__B__B($thiz, x) {
  return ((((-x) | 0) << 24) >> 24);
}
function $f_s_math_Numeric$ByteIsIntegral__sign__B__B($thiz, x) {
  var x$1 = x;
  return ((((x$1 === 0) ? 0 : ((x$1 < 0) ? (-1) : 1)) << 24) >> 24);
}
function $f_s_math_Numeric$CharIsIntegral__plus__C__C__C($thiz, x, y) {
  return (65535 & ((x + y) | 0));
}
function $f_s_math_Numeric$CharIsIntegral__minus__C__C__C($thiz, x, y) {
  return (65535 & ((x - y) | 0));
}
function $f_s_math_Numeric$CharIsIntegral__times__C__C__C($thiz, x, y) {
  return (65535 & Math.imul(x, y));
}
function $f_s_math_Numeric$CharIsIntegral__quot__C__C__C($thiz, x, y) {
  return (65535 & $intDiv(x, y));
}
function $f_s_math_Numeric$CharIsIntegral__rem__C__C__C($thiz, x, y) {
  return (65535 & $intMod(x, y));
}
function $f_s_math_Numeric$CharIsIntegral__negate__C__C($thiz, x) {
  return (65535 & ((-x) | 0));
}
function $f_s_math_Numeric$CharIsIntegral__sign__C__C($thiz, x) {
  var x$1 = x;
  return (65535 & ((x$1 === 0) ? 0 : ((x$1 < 0) ? (-1) : 1)));
}
function $f_s_math_Numeric$IntIsIntegral__plus__I__I__I($thiz, x, y) {
  return ((x + y) | 0);
}
function $f_s_math_Numeric$IntIsIntegral__minus__I__I__I($thiz, x, y) {
  return ((x - y) | 0);
}
function $f_s_math_Numeric$IntIsIntegral__times__I__I__I($thiz, x, y) {
  return Math.imul(x, y);
}
function $f_s_math_Numeric$IntIsIntegral__quot__I__I__I($thiz, x, y) {
  return $intDiv(x, y);
}
function $f_s_math_Numeric$IntIsIntegral__rem__I__I__I($thiz, x, y) {
  return $intMod(x, y);
}
function $f_s_math_Numeric$IntIsIntegral__negate__I__I($thiz, x) {
  return ((-x) | 0);
}
function $f_s_math_Numeric$LongIsIntegral__plus__J__J__J($thiz, x, y) {
  var alo = x.RTLong__f_lo;
  var ahi = x.RTLong__f_hi;
  var bhi = y.RTLong__f_hi;
  var lo = ((alo + y.RTLong__f_lo) | 0);
  var hi = ((((-2147483648) ^ lo) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + bhi) | 0)) | 0) : ((ahi + bhi) | 0));
  return new $c_RTLong(lo, hi);
}
function $f_s_math_Numeric$LongIsIntegral__minus__J__J__J($thiz, x, y) {
  var alo = x.RTLong__f_lo;
  var ahi = x.RTLong__f_hi;
  var bhi = y.RTLong__f_hi;
  var lo = ((alo - y.RTLong__f_lo) | 0);
  var hi = ((((-2147483648) ^ lo) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - bhi) | 0)) | 0) : ((ahi - bhi) | 0));
  return new $c_RTLong(lo, hi);
}
function $f_s_math_Numeric$LongIsIntegral__times__J__J__J($thiz, x, y) {
  var alo = x.RTLong__f_lo;
  var blo = y.RTLong__f_lo;
  var a0 = (65535 & alo);
  var a1 = ((alo >>> 16) | 0);
  var b0 = (65535 & blo);
  var b1 = ((blo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi = ((((((((Math.imul(alo, y.RTLong__f_hi) + Math.imul(x.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return new $c_RTLong(lo, hi);
}
function $f_s_math_Numeric$LongIsIntegral__quot__J__J__J($thiz, x, y) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(x.RTLong__f_lo, x.RTLong__f_hi, y.RTLong__f_lo, y.RTLong__f_hi);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
}
function $f_s_math_Numeric$LongIsIntegral__rem__J__J__J($thiz, x, y) {
  var this$1 = $m_RTLong$();
  var lo = this$1.remainderImpl__I__I__I__I__I(x.RTLong__f_lo, x.RTLong__f_hi, y.RTLong__f_lo, y.RTLong__f_hi);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
}
function $f_s_math_Numeric$LongIsIntegral__negate__J__J($thiz, x) {
  var lo = x.RTLong__f_lo;
  var hi = x.RTLong__f_hi;
  var lo$1 = ((-lo) | 0);
  var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
  return new $c_RTLong(lo$1, hi$1);
}
function $f_s_math_Numeric$ShortIsIntegral__plus__S__S__S($thiz, x, y) {
  return ((((x + y) | 0) << 16) >> 16);
}
function $f_s_math_Numeric$ShortIsIntegral__minus__S__S__S($thiz, x, y) {
  return ((((x - y) | 0) << 16) >> 16);
}
function $f_s_math_Numeric$ShortIsIntegral__times__S__S__S($thiz, x, y) {
  return ((Math.imul(x, y) << 16) >> 16);
}
function $f_s_math_Numeric$ShortIsIntegral__quot__S__S__S($thiz, x, y) {
  return (($intDiv(x, y) << 16) >> 16);
}
function $f_s_math_Numeric$ShortIsIntegral__rem__S__S__S($thiz, x, y) {
  return (($intMod(x, y) << 16) >> 16);
}
function $f_s_math_Numeric$ShortIsIntegral__negate__S__S($thiz, x) {
  return ((((-x) | 0) << 16) >> 16);
}
function $f_s_math_Numeric$ShortIsIntegral__sign__S__S($thiz, x) {
  var x$1 = x;
  return ((((x$1 === 0) ? 0 : ((x$1 < 0) ? (-1) : 1)) << 16) >> 16);
}
/** @constructor */
function $c_s_math_Ordering$Int$() {
  this.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse = null;
  $n_s_math_Ordering$Int$ = this;
  this.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse = new $c_s_math_Ordering$Reverse(this);
}
$c_s_math_Ordering$Int$.prototype = new $h_O();
$c_s_math_Ordering$Int$.prototype.constructor = $c_s_math_Ordering$Int$;
/** @constructor */
function $h_s_math_Ordering$Int$() {
}
$h_s_math_Ordering$Int$.prototype = $c_s_math_Ordering$Int$.prototype;
$c_s_math_Ordering$Int$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Ordering$Int$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Int$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Int$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Int$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Int$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Ordering$Int$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Ordering$Int$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return ((x$1 === y$1) ? 0 : ((x$1 < y$1) ? (-1) : 1));
});
var $d_s_math_Ordering$Int$ = new $TypeData().initClass($c_s_math_Ordering$Int$, "scala.math.Ordering$Int$", ({
  s_math_Ordering$Int$: 1,
  s_math_Ordering$IntOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordering$CachedReverse: 1
}));
var $n_s_math_Ordering$Int$;
function $m_s_math_Ordering$Int$() {
  if ((!$n_s_math_Ordering$Int$)) {
    $n_s_math_Ordering$Int$ = new $c_s_math_Ordering$Int$();
  }
  return $n_s_math_Ordering$Int$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$BooleanManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
$c_s_reflect_ManifestFactory$BooleanManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$BooleanManifest.prototype.constructor = $c_s_reflect_ManifestFactory$BooleanManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$BooleanManifest() {
}
$h_s_reflect_ManifestFactory$BooleanManifest.prototype = $c_s_reflect_ManifestFactory$BooleanManifest.prototype;
$c_s_reflect_ManifestFactory$BooleanManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_Z.getClassOf();
});
$c_s_reflect_ManifestFactory$BooleanManifest.prototype.unapply__O__s_Option = (function(x) {
  if (((typeof x) === "boolean")) {
    var x2 = $uZ(x);
    return new $c_s_Some(x2);
  } else {
    return $m_s_None$();
  }
});
$c_s_reflect_ManifestFactory$BooleanManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_Z(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ByteManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
$c_s_reflect_ManifestFactory$ByteManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$ByteManifest.prototype.constructor = $c_s_reflect_ManifestFactory$ByteManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ByteManifest() {
}
$h_s_reflect_ManifestFactory$ByteManifest.prototype = $c_s_reflect_ManifestFactory$ByteManifest.prototype;
$c_s_reflect_ManifestFactory$ByteManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_B.getClassOf();
});
$c_s_reflect_ManifestFactory$ByteManifest.prototype.unapply__O__s_Option = (function(x) {
  if ($isByte(x)) {
    var x2 = $uB(x);
    return new $c_s_Some(x2);
  } else {
    return $m_s_None$();
  }
});
$c_s_reflect_ManifestFactory$ByteManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_B(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$CharManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
$c_s_reflect_ManifestFactory$CharManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$CharManifest.prototype.constructor = $c_s_reflect_ManifestFactory$CharManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$CharManifest() {
}
$h_s_reflect_ManifestFactory$CharManifest.prototype = $c_s_reflect_ManifestFactory$CharManifest.prototype;
$c_s_reflect_ManifestFactory$CharManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_C.getClassOf();
});
$c_s_reflect_ManifestFactory$CharManifest.prototype.unapply__O__s_Option = (function(x) {
  if ((x instanceof $Char)) {
    var x2 = $uC(x);
    return new $c_s_Some($bC(x2));
  } else {
    return $m_s_None$();
  }
});
$c_s_reflect_ManifestFactory$CharManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_C(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$DoubleManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
$c_s_reflect_ManifestFactory$DoubleManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$DoubleManifest.prototype.constructor = $c_s_reflect_ManifestFactory$DoubleManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$DoubleManifest() {
}
$h_s_reflect_ManifestFactory$DoubleManifest.prototype = $c_s_reflect_ManifestFactory$DoubleManifest.prototype;
$c_s_reflect_ManifestFactory$DoubleManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_D.getClassOf();
});
$c_s_reflect_ManifestFactory$DoubleManifest.prototype.unapply__O__s_Option = (function(x) {
  if (((typeof x) === "number")) {
    var x2 = $uD(x);
    return new $c_s_Some(x2);
  } else {
    return $m_s_None$();
  }
});
$c_s_reflect_ManifestFactory$DoubleManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_D(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$FloatManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
$c_s_reflect_ManifestFactory$FloatManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$FloatManifest.prototype.constructor = $c_s_reflect_ManifestFactory$FloatManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$FloatManifest() {
}
$h_s_reflect_ManifestFactory$FloatManifest.prototype = $c_s_reflect_ManifestFactory$FloatManifest.prototype;
$c_s_reflect_ManifestFactory$FloatManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_F.getClassOf();
});
$c_s_reflect_ManifestFactory$FloatManifest.prototype.unapply__O__s_Option = (function(x) {
  if ($isFloat(x)) {
    var x2 = $uF(x);
    return new $c_s_Some(x2);
  } else {
    return $m_s_None$();
  }
});
$c_s_reflect_ManifestFactory$FloatManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_F(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$IntManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
$c_s_reflect_ManifestFactory$IntManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$IntManifest.prototype.constructor = $c_s_reflect_ManifestFactory$IntManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$IntManifest() {
}
$h_s_reflect_ManifestFactory$IntManifest.prototype = $c_s_reflect_ManifestFactory$IntManifest.prototype;
$c_s_reflect_ManifestFactory$IntManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_I.getClassOf();
});
$c_s_reflect_ManifestFactory$IntManifest.prototype.unapply__O__s_Option = (function(x) {
  if ($isInt(x)) {
    var x2 = $uI(x);
    return new $c_s_Some(x2);
  } else {
    return $m_s_None$();
  }
});
$c_s_reflect_ManifestFactory$IntManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_I(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$LongManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
$c_s_reflect_ManifestFactory$LongManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$LongManifest.prototype.constructor = $c_s_reflect_ManifestFactory$LongManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$LongManifest() {
}
$h_s_reflect_ManifestFactory$LongManifest.prototype = $c_s_reflect_ManifestFactory$LongManifest.prototype;
$c_s_reflect_ManifestFactory$LongManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_J.getClassOf();
});
$c_s_reflect_ManifestFactory$LongManifest.prototype.unapply__O__s_Option = (function(x) {
  if ((x instanceof $c_RTLong)) {
    var t = $uJ(x);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return new $c_s_Some(new $c_RTLong(lo, hi));
  } else {
    return $m_s_None$();
  }
});
$c_s_reflect_ManifestFactory$LongManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_J(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$PhantomManifest() {
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
}
$c_s_reflect_ManifestFactory$PhantomManifest.prototype = new $h_s_reflect_ManifestFactory$ClassTypeManifest();
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.constructor = $c_s_reflect_ManifestFactory$PhantomManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$PhantomManifest() {
}
$h_s_reflect_ManifestFactory$PhantomManifest.prototype = $c_s_reflect_ManifestFactory$PhantomManifest.prototype;
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.toString__T = (function() {
  return this.s_reflect_ManifestFactory$PhantomManifest__f_toString;
});
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.equals__O__Z = (function(that) {
  return (this === that);
});
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ShortManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
$c_s_reflect_ManifestFactory$ShortManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$ShortManifest.prototype.constructor = $c_s_reflect_ManifestFactory$ShortManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ShortManifest() {
}
$h_s_reflect_ManifestFactory$ShortManifest.prototype = $c_s_reflect_ManifestFactory$ShortManifest.prototype;
$c_s_reflect_ManifestFactory$ShortManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_S.getClassOf();
});
$c_s_reflect_ManifestFactory$ShortManifest.prototype.unapply__O__s_Option = (function(x) {
  if ($isShort(x)) {
    var x2 = $uS(x);
    return new $c_s_Some(x2);
  } else {
    return $m_s_None$();
  }
});
$c_s_reflect_ManifestFactory$ShortManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_S(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$UnitManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
$c_s_reflect_ManifestFactory$UnitManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$UnitManifest.prototype.constructor = $c_s_reflect_ManifestFactory$UnitManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$UnitManifest() {
}
$h_s_reflect_ManifestFactory$UnitManifest.prototype = $c_s_reflect_ManifestFactory$UnitManifest.prototype;
$c_s_reflect_ManifestFactory$UnitManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_V.getClassOf();
});
$c_s_reflect_ManifestFactory$UnitManifest.prototype.unapply__O__s_Option = (function(x) {
  return ((x === (void 0)) ? new $c_s_Some((void 0)) : $m_s_None$());
});
$c_s_reflect_ManifestFactory$UnitManifest.prototype.newArray__I__O = (function(len) {
  return new ($d_jl_Void.getArrayOf().constr)(len);
});
/** @constructor */
function $c_Ltyrian_Cmd$None$() {
}
$c_Ltyrian_Cmd$None$.prototype = new $h_O();
$c_Ltyrian_Cmd$None$.prototype.constructor = $c_Ltyrian_Cmd$None$;
/** @constructor */
function $h_Ltyrian_Cmd$None$() {
}
$h_Ltyrian_Cmd$None$.prototype = $c_Ltyrian_Cmd$None$.prototype;
$c_Ltyrian_Cmd$None$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Cmd$None$.prototype.hashCode__I = (function() {
  return 2433880;
});
$c_Ltyrian_Cmd$None$.prototype.toString__T = (function() {
  return "None";
});
$c_Ltyrian_Cmd$None$.prototype.productArity__I = (function() {
  return 0;
});
$c_Ltyrian_Cmd$None$.prototype.productPrefix__T = (function() {
  return "None";
});
$c_Ltyrian_Cmd$None$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Ltyrian_Cmd$None$ = new $TypeData().initClass($c_Ltyrian_Cmd$None$, "tyrian.Cmd$None$", ({
  Ltyrian_Cmd$None$: 1,
  Ltyrian_Cmd: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Ltyrian_Cmd$None$;
function $m_Ltyrian_Cmd$None$() {
  if ((!$n_Ltyrian_Cmd$None$)) {
    $n_Ltyrian_Cmd$None$ = new $c_Ltyrian_Cmd$None$();
  }
  return $n_Ltyrian_Cmd$None$;
}
/** @constructor */
function $c_Ltyrian_Empty$() {
}
$c_Ltyrian_Empty$.prototype = new $h_O();
$c_Ltyrian_Empty$.prototype.constructor = $c_Ltyrian_Empty$;
/** @constructor */
function $h_Ltyrian_Empty$() {
}
$h_Ltyrian_Empty$.prototype = $c_Ltyrian_Empty$.prototype;
$c_Ltyrian_Empty$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Empty$.prototype.hashCode__I = (function() {
  return 67081517;
});
$c_Ltyrian_Empty$.prototype.productArity__I = (function() {
  return 0;
});
$c_Ltyrian_Empty$.prototype.productPrefix__T = (function() {
  return "Empty";
});
$c_Ltyrian_Empty$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Ltyrian_Empty$.prototype.toString__T = (function() {
  return $m_Ltyrian_HTMLRendering$package$().render__Ltyrian_Elem__T(this);
});
var $d_Ltyrian_Empty$ = new $TypeData().initClass($c_Ltyrian_Empty$, "tyrian.Empty$", ({
  Ltyrian_Empty$: 1,
  Ltyrian_Elem: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Ltyrian_Empty$;
function $m_Ltyrian_Empty$() {
  if ((!$n_Ltyrian_Empty$)) {
    $n_Ltyrian_Empty$ = new $c_Ltyrian_Empty$();
  }
  return $n_Ltyrian_Empty$;
}
/** @constructor */
function $c_Ltyrian_EmptyAttribute$() {
}
$c_Ltyrian_EmptyAttribute$.prototype = new $h_O();
$c_Ltyrian_EmptyAttribute$.prototype.constructor = $c_Ltyrian_EmptyAttribute$;
/** @constructor */
function $h_Ltyrian_EmptyAttribute$() {
}
$h_Ltyrian_EmptyAttribute$.prototype = $c_Ltyrian_EmptyAttribute$.prototype;
$c_Ltyrian_EmptyAttribute$.prototype.toString__T = (function() {
  return $m_Ltyrian_HTMLRendering$package$().render__Ltyrian_Attr__T(this);
});
$c_Ltyrian_EmptyAttribute$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_EmptyAttribute$.prototype.hashCode__I = (function() {
  return 853194735;
});
$c_Ltyrian_EmptyAttribute$.prototype.productArity__I = (function() {
  return 0;
});
$c_Ltyrian_EmptyAttribute$.prototype.productPrefix__T = (function() {
  return "EmptyAttribute";
});
$c_Ltyrian_EmptyAttribute$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Ltyrian_EmptyAttribute$ = new $TypeData().initClass($c_Ltyrian_EmptyAttribute$, "tyrian.EmptyAttribute$", ({
  Ltyrian_EmptyAttribute$: 1,
  Ltyrian_Attr: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Ltyrian_EmptyAttribute$;
function $m_Ltyrian_EmptyAttribute$() {
  if ((!$n_Ltyrian_EmptyAttribute$)) {
    $n_Ltyrian_EmptyAttribute$ = new $c_Ltyrian_EmptyAttribute$();
  }
  return $n_Ltyrian_EmptyAttribute$;
}
/** @constructor */
function $c_Ltyrian_Sub$None$() {
}
$c_Ltyrian_Sub$None$.prototype = new $h_O();
$c_Ltyrian_Sub$None$.prototype.constructor = $c_Ltyrian_Sub$None$;
/** @constructor */
function $h_Ltyrian_Sub$None$() {
}
$h_Ltyrian_Sub$None$.prototype = $c_Ltyrian_Sub$None$.prototype;
$c_Ltyrian_Sub$None$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Sub$None$.prototype.hashCode__I = (function() {
  return 2433880;
});
$c_Ltyrian_Sub$None$.prototype.toString__T = (function() {
  return "None";
});
$c_Ltyrian_Sub$None$.prototype.productArity__I = (function() {
  return 0;
});
$c_Ltyrian_Sub$None$.prototype.productPrefix__T = (function() {
  return "None";
});
$c_Ltyrian_Sub$None$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Ltyrian_Sub$None$ = new $TypeData().initClass($c_Ltyrian_Sub$None$, "tyrian.Sub$None$", ({
  Ltyrian_Sub$None$: 1,
  Ltyrian_Sub: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Ltyrian_Sub$None$;
function $m_Ltyrian_Sub$None$() {
  if ((!$n_Ltyrian_Sub$None$)) {
    $n_Ltyrian_Sub$None$ = new $c_Ltyrian_Sub$None$();
  }
  return $n_Ltyrian_Sub$None$;
}
function $f_Lcats_Applicative__replicateA__I__O__O($thiz, n, fa) {
  if ((n <= 0)) {
    return $thiz.pure__O__O($m_sci_Nil$());
  } else if ((n === 1)) {
    return $thiz.map__O__F1__O(fa, new $c_sjsr_AnonFunction1(((_$2) => {
      var this$1 = $m_sci_Nil$();
      return new $c_sci_$colon$colon(_$2, this$1);
    })));
  } else {
    var one = $thiz.map__O__F1__O(fa, new $c_sjsr_AnonFunction1(((_$3) => {
      $m_Lcats_data_Chain$();
      return new $c_Lcats_data_Chain$Singleton(_$3);
    })));
    return $thiz.map__O__F1__O($p_Lcats_Applicative__loop$1__O__I__O__O($thiz, one, (((-1) + n) | 0), one), new $c_sjsr_AnonFunction1(((_$10) => {
      var _$10$1 = $as_Lcats_data_Chain(_$10);
      return $n(_$10$1).toList__sci_List();
    })));
  }
}
function $p_Lcats_Applicative__loop$1__O__I__O__O($thiz, fa, n, acc) {
  var acc$tailLocal1 = acc;
  var n$tailLocal1 = n;
  var fa$tailLocal1 = fa;
  while (true) {
    if ((n$tailLocal1 === 1)) {
      return $thiz.map2__O__O__F2__O(fa$tailLocal1, acc$tailLocal1, new $c_sjsr_AnonFunction2(((_$4, _$5) => {
        var _$4$1 = $as_Lcats_data_Chain(_$4);
        var _$5$1 = $as_Lcats_data_Chain(_$5);
        var this$1 = $n(_$4$1);
        return $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this$1, _$5$1);
      })));
    } else {
      var fa$tailLocal1$tmp1 = $thiz.map2__O__O__F2__O(fa$tailLocal1, fa$tailLocal1, new $c_sjsr_AnonFunction2(((_$6, _$7) => {
        var _$6$1 = $as_Lcats_data_Chain(_$6);
        var _$7$1 = $as_Lcats_data_Chain(_$7);
        var this$2 = $n(_$6$1);
        return $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this$2, _$7$1);
      })));
      var n$tailLocal1$tmp1 = (n$tailLocal1 >> 1);
      var acc$tailLocal1$tmp1 = (((1 & n$tailLocal1) === 1) ? $thiz.map2__O__O__F2__O(acc$tailLocal1, fa$tailLocal1, new $c_sjsr_AnonFunction2(((_$8, _$9) => {
        var _$8$1 = $as_Lcats_data_Chain(_$8);
        var _$9$1 = $as_Lcats_data_Chain(_$9);
        var this$3 = $n(_$8$1);
        return $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this$3, _$9$1);
      }))) : acc$tailLocal1);
      fa$tailLocal1 = fa$tailLocal1$tmp1;
      n$tailLocal1 = n$tailLocal1$tmp1;
      acc$tailLocal1 = acc$tailLocal1$tmp1;
    }
  }
}
function $is_Lcats_Applicative(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_Applicative)));
}
function $as_Lcats_Applicative(obj) {
  return (($is_Lcats_Applicative(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Applicative"));
}
function $isArrayOf_Lcats_Applicative(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Applicative)));
}
function $asArrayOf_Lcats_Applicative(obj, depth) {
  return (($isArrayOf_Lcats_Applicative(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Applicative;", depth));
}
function $f_Lcats_FlatMap__flatten__O__O($thiz, ffa) {
  return $thiz.flatMap__O__F1__O(ffa, new $c_sjsr_AnonFunction1(((fa) => fa)));
}
function $f_Lcats_FlatMap__ap__O__O__O($thiz, ff, fa) {
  return $thiz.flatMap__O__F1__O(ff, new $c_sjsr_AnonFunction1(((f) => {
    var f$1 = $as_F1(f);
    return $thiz.map__O__F1__O(fa, f$1);
  })));
}
function $f_Lcats_FlatMap__product__O__O__O($thiz, fa, fb) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1(((a) => $thiz.map__O__F1__O(fb, new $c_sjsr_AnonFunction1(((b) => new $c_T2(a, b)))))));
}
function $f_Lcats_FlatMap__map2__O__O__F2__O($thiz, fa, fb, f) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1(((a) => $thiz.map__O__F1__O(fb, new $c_sjsr_AnonFunction1(((b) => $n(f).apply__O__O__O(a, b)))))));
}
function $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval($thiz, fa, fb, f) {
  $m_Lcats_Eval$();
  var a$1 = $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1(((a) => $thiz.map__O__F1__O($n(fb).value__O(), new $c_sjsr_AnonFunction1(((b) => $n(f).apply__O__O__O(a, b)))))));
  return new $c_Lcats_Now(a$1);
}
function $f_Lcats_FlatMap__productR__O__O__O($thiz, fa, fb) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1(((_$4) => fb)));
}
function $f_Lcats_FlatMap__productL__O__O__O($thiz, fa, fb) {
  return $thiz.map2__O__O__F2__O(fa, fb, new $c_sjsr_AnonFunction2(((a, _$5) => a)));
}
function $f_Lcats_FlatMap__ifM__O__F0__F0__O($thiz, fa, ifTrue, ifFalse) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1(((_$7) => {
    var _$7$1 = $uZ(_$7);
    return (_$7$1 ? $n(ifTrue).apply__O() : $n(ifFalse).apply__O());
  })));
}
function $f_Lcats_FlatMap__flatTap__O__F1__O($thiz, fa, f) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1(((a) => $thiz.as__O__O__O($n(f).apply__O__O(a), a))));
}
function $f_Lcats_FlatMap__foreverM__O__O($thiz, fa) {
  var leftUnit = new $c_s_util_Left((void 0));
  var stepResult = $thiz.as__O__O__O(fa, leftUnit);
  return $thiz.tailRecM__O__F1__O((void 0), new $c_sjsr_AnonFunction1(((_$8) => {
    $as_jl_Void(_$8);
    return stepResult;
  })));
}
function $is_Lcats_FlatMap(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_FlatMap)));
}
function $as_Lcats_FlatMap(obj) {
  return (($is_Lcats_FlatMap(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.FlatMap"));
}
function $isArrayOf_Lcats_FlatMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_FlatMap)));
}
function $asArrayOf_Lcats_FlatMap(obj, depth) {
  return (($isArrayOf_Lcats_FlatMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.FlatMap;", depth));
}
/** @constructor */
function $c_Lcats_data_Chain$Empty$() {
}
$c_Lcats_data_Chain$Empty$.prototype = new $h_Lcats_data_Chain();
$c_Lcats_data_Chain$Empty$.prototype.constructor = $c_Lcats_data_Chain$Empty$;
/** @constructor */
function $h_Lcats_data_Chain$Empty$() {
}
$h_Lcats_data_Chain$Empty$.prototype = $c_Lcats_data_Chain$Empty$.prototype;
$c_Lcats_data_Chain$Empty$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_data_Chain$Empty$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_data_Chain$Empty$.prototype.productPrefix__T = (function() {
  return "Empty";
});
$c_Lcats_data_Chain$Empty$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcats_data_Chain$Empty$ = new $TypeData().initClass($c_Lcats_data_Chain$Empty$, "cats.data.Chain$Empty$", ({
  Lcats_data_Chain$Empty$: 1,
  Lcats_data_Chain: 1,
  Lcats_data_ChainCompat: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_data_Chain$Empty$;
function $m_Lcats_data_Chain$Empty$() {
  if ((!$n_Lcats_data_Chain$Empty$)) {
    $n_Lcats_data_Chain$Empty$ = new $c_Lcats_data_Chain$Empty$();
  }
  return $n_Lcats_data_Chain$Empty$;
}
function $f_Lcats_data_KleisliApply__map2Eval__Lcats_data_Kleisli__Lcats_Eval__F2__Lcats_Eval($thiz, fa, fb, f) {
  var memoFb = $n(fb).memoize__Lcats_Eval();
  $m_Lcats_Eval$();
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((a) => {
    var fb$1 = $n($n(fa).Lcats_data_Kleisli__f_run).apply__O__O(a);
    var efc = $n(memoFb).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((_$176) => {
      var _$176$1 = $as_Lcats_data_Kleisli(_$176);
      return $n($n(_$176$1).Lcats_data_Kleisli__f_run).apply__O__O(a);
    })));
    var efz = $n($thiz.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1).map2Eval__O__Lcats_Eval__F2__Lcats_Eval(fb$1, efc, f);
    return $n(efz).value__O();
  }));
  var a$1 = new $c_Lcats_data_Kleisli(run);
  return new $c_Lcats_Now(a$1);
}
function $f_Lcats_data_KleisliApply__product__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli($thiz, fb, fc) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((a) => $n($thiz.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1).product__O__O__O($n($n(fb).Lcats_data_Kleisli__f_run).apply__O__O(a), $n($n(fc).Lcats_data_Kleisli__f_run).apply__O__O(a))));
  return new $c_Lcats_data_Kleisli(run);
}
/** @constructor */
function $c_Lcats_data_KleisliInstances1() {
}
$c_Lcats_data_KleisliInstances1.prototype = new $h_Lcats_data_KleisliInstances2();
$c_Lcats_data_KleisliInstances1.prototype.constructor = $c_Lcats_data_KleisliInstances1;
/** @constructor */
function $h_Lcats_data_KleisliInstances1() {
}
$h_Lcats_data_KleisliInstances1.prototype = $c_Lcats_data_KleisliInstances1.prototype;
/** @constructor */
function $c_Lcats_effect_IO$Canceled$() {
}
$c_Lcats_effect_IO$Canceled$.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Canceled$.prototype.constructor = $c_Lcats_effect_IO$Canceled$;
/** @constructor */
function $h_Lcats_effect_IO$Canceled$() {
}
$h_Lcats_effect_IO$Canceled$.prototype = $c_Lcats_effect_IO$Canceled$.prototype;
$c_Lcats_effect_IO$Canceled$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Canceled$.prototype.hashCode__I = (function() {
  return (-58529607);
});
$c_Lcats_effect_IO$Canceled$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_IO$Canceled$.prototype.productPrefix__T = (function() {
  return "Canceled";
});
$c_Lcats_effect_IO$Canceled$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Canceled$.prototype.tag__B = (function() {
  return 10;
});
var $d_Lcats_effect_IO$Canceled$ = new $TypeData().initClass($c_Lcats_effect_IO$Canceled$, "cats.effect.IO$Canceled$", ({
  Lcats_effect_IO$Canceled$: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_IO$Canceled$;
function $m_Lcats_effect_IO$Canceled$() {
  if ((!$n_Lcats_effect_IO$Canceled$)) {
    $n_Lcats_effect_IO$Canceled$ = new $c_Lcats_effect_IO$Canceled$();
  }
  return $n_Lcats_effect_IO$Canceled$;
}
/** @constructor */
function $c_Lcats_effect_IO$Cede$() {
}
$c_Lcats_effect_IO$Cede$.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Cede$.prototype.constructor = $c_Lcats_effect_IO$Cede$;
/** @constructor */
function $h_Lcats_effect_IO$Cede$() {
}
$h_Lcats_effect_IO$Cede$.prototype = $c_Lcats_effect_IO$Cede$.prototype;
$c_Lcats_effect_IO$Cede$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Cede$.prototype.hashCode__I = (function() {
  return 2096259;
});
$c_Lcats_effect_IO$Cede$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_IO$Cede$.prototype.productPrefix__T = (function() {
  return "Cede";
});
$c_Lcats_effect_IO$Cede$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Cede$.prototype.tag__B = (function() {
  return 16;
});
var $d_Lcats_effect_IO$Cede$ = new $TypeData().initClass($c_Lcats_effect_IO$Cede$, "cats.effect.IO$Cede$", ({
  Lcats_effect_IO$Cede$: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_IO$Cede$;
function $m_Lcats_effect_IO$Cede$() {
  if ((!$n_Lcats_effect_IO$Cede$)) {
    $n_Lcats_effect_IO$Cede$ = new $c_Lcats_effect_IO$Cede$();
  }
  return $n_Lcats_effect_IO$Cede$;
}
/** @constructor */
function $c_Lcats_effect_IO$EndFiber$() {
}
$c_Lcats_effect_IO$EndFiber$.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$EndFiber$.prototype.constructor = $c_Lcats_effect_IO$EndFiber$;
/** @constructor */
function $h_Lcats_effect_IO$EndFiber$() {
}
$h_Lcats_effect_IO$EndFiber$.prototype = $c_Lcats_effect_IO$EndFiber$.prototype;
$c_Lcats_effect_IO$EndFiber$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$EndFiber$.prototype.hashCode__I = (function() {
  return 1766772977;
});
$c_Lcats_effect_IO$EndFiber$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_IO$EndFiber$.prototype.productPrefix__T = (function() {
  return "EndFiber";
});
$c_Lcats_effect_IO$EndFiber$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$EndFiber$.prototype.tag__B = (function() {
  return (-1);
});
var $d_Lcats_effect_IO$EndFiber$ = new $TypeData().initClass($c_Lcats_effect_IO$EndFiber$, "cats.effect.IO$EndFiber$", ({
  Lcats_effect_IO$EndFiber$: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_IO$EndFiber$;
function $m_Lcats_effect_IO$EndFiber$() {
  if ((!$n_Lcats_effect_IO$EndFiber$)) {
    $n_Lcats_effect_IO$EndFiber$ = new $c_Lcats_effect_IO$EndFiber$();
  }
  return $n_Lcats_effect_IO$EndFiber$;
}
/** @constructor */
function $c_Lcats_effect_IO$Monotonic$() {
}
$c_Lcats_effect_IO$Monotonic$.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Monotonic$.prototype.constructor = $c_Lcats_effect_IO$Monotonic$;
/** @constructor */
function $h_Lcats_effect_IO$Monotonic$() {
}
$h_Lcats_effect_IO$Monotonic$.prototype = $c_Lcats_effect_IO$Monotonic$.prototype;
$c_Lcats_effect_IO$Monotonic$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Monotonic$.prototype.hashCode__I = (function() {
  return 572915850;
});
$c_Lcats_effect_IO$Monotonic$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_IO$Monotonic$.prototype.productPrefix__T = (function() {
  return "Monotonic";
});
$c_Lcats_effect_IO$Monotonic$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Monotonic$.prototype.tag__B = (function() {
  return 4;
});
var $d_Lcats_effect_IO$Monotonic$ = new $TypeData().initClass($c_Lcats_effect_IO$Monotonic$, "cats.effect.IO$Monotonic$", ({
  Lcats_effect_IO$Monotonic$: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_IO$Monotonic$;
function $m_Lcats_effect_IO$Monotonic$() {
  if ((!$n_Lcats_effect_IO$Monotonic$)) {
    $n_Lcats_effect_IO$Monotonic$ = new $c_Lcats_effect_IO$Monotonic$();
  }
  return $n_Lcats_effect_IO$Monotonic$;
}
/** @constructor */
function $c_Lcats_effect_IO$ReadEC$() {
}
$c_Lcats_effect_IO$ReadEC$.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$ReadEC$.prototype.constructor = $c_Lcats_effect_IO$ReadEC$;
/** @constructor */
function $h_Lcats_effect_IO$ReadEC$() {
}
$h_Lcats_effect_IO$ReadEC$.prototype = $c_Lcats_effect_IO$ReadEC$.prototype;
$c_Lcats_effect_IO$ReadEC$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$ReadEC$.prototype.hashCode__I = (function() {
  return (-1851113260);
});
$c_Lcats_effect_IO$ReadEC$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_IO$ReadEC$.prototype.productPrefix__T = (function() {
  return "ReadEC";
});
$c_Lcats_effect_IO$ReadEC$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$ReadEC$.prototype.tag__B = (function() {
  return 5;
});
var $d_Lcats_effect_IO$ReadEC$ = new $TypeData().initClass($c_Lcats_effect_IO$ReadEC$, "cats.effect.IO$ReadEC$", ({
  Lcats_effect_IO$ReadEC$: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_IO$ReadEC$;
function $m_Lcats_effect_IO$ReadEC$() {
  if ((!$n_Lcats_effect_IO$ReadEC$)) {
    $n_Lcats_effect_IO$ReadEC$ = new $c_Lcats_effect_IO$ReadEC$();
  }
  return $n_Lcats_effect_IO$ReadEC$;
}
/** @constructor */
function $c_Lcats_effect_IO$RealTime$() {
}
$c_Lcats_effect_IO$RealTime$.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$RealTime$.prototype.constructor = $c_Lcats_effect_IO$RealTime$;
/** @constructor */
function $h_Lcats_effect_IO$RealTime$() {
}
$h_Lcats_effect_IO$RealTime$.prototype = $c_Lcats_effect_IO$RealTime$.prototype;
$c_Lcats_effect_IO$RealTime$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$RealTime$.prototype.hashCode__I = (function() {
  return (-795507285);
});
$c_Lcats_effect_IO$RealTime$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_IO$RealTime$.prototype.productPrefix__T = (function() {
  return "RealTime";
});
$c_Lcats_effect_IO$RealTime$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$RealTime$.prototype.tag__B = (function() {
  return 3;
});
var $d_Lcats_effect_IO$RealTime$ = new $TypeData().initClass($c_Lcats_effect_IO$RealTime$, "cats.effect.IO$RealTime$", ({
  Lcats_effect_IO$RealTime$: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_IO$RealTime$;
function $m_Lcats_effect_IO$RealTime$() {
  if ((!$n_Lcats_effect_IO$RealTime$)) {
    $n_Lcats_effect_IO$RealTime$ = new $c_Lcats_effect_IO$RealTime$();
  }
  return $n_Lcats_effect_IO$RealTime$;
}
/** @constructor */
function $c_Lcats_instances_EqInstances$$anon$1() {
}
$c_Lcats_instances_EqInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_EqInstances$$anon$1.prototype.constructor = $c_Lcats_instances_EqInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_EqInstances$$anon$1() {
}
$h_Lcats_instances_EqInstances$$anon$1.prototype = $c_Lcats_instances_EqInstances$$anon$1.prototype;
$c_Lcats_instances_EqInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  var fa$1 = $as_Lcats_kernel_Eq(fa);
  var this$1 = $n($m_Lcats_package$().Lcats_package$__f_Eq);
  return new $c_Lcats_kernel_Eq$$anon$2(fa$1, fi, this$1);
});
$c_Lcats_instances_EqInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_kernel_Eq(fa);
  var fb$1 = $as_Lcats_kernel_Eq(fb);
  return new $c_Lcats_instances_EqInstances$$anon$2(fa$1, fb$1, this);
});
var $d_Lcats_instances_EqInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_EqInstances$$anon$1, "cats.instances.EqInstances$$anon$1", ({
  Lcats_instances_EqInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
}));
/** @constructor */
function $c_Lcats_instances_EquivInstances$$anon$1() {
}
$c_Lcats_instances_EquivInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_EquivInstances$$anon$1.prototype.constructor = $c_Lcats_instances_EquivInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_EquivInstances$$anon$1() {
}
$h_Lcats_instances_EquivInstances$$anon$1.prototype = $c_Lcats_instances_EquivInstances$$anon$1.prototype;
$c_Lcats_instances_EquivInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  var fa$1 = $as_s_math_Equiv(fa);
  return new $c_Lcats_instances_EquivInstances$$anon$3(fa$1, fi);
});
$c_Lcats_instances_EquivInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_s_math_Equiv(fa);
  var fb$1 = $as_s_math_Equiv(fb);
  return new $c_Lcats_instances_EquivInstances$$anon$4(fa$1, fb$1);
});
var $d_Lcats_instances_EquivInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_EquivInstances$$anon$1, "cats.instances.EquivInstances$$anon$1", ({
  Lcats_instances_EquivInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
}));
/** @constructor */
function $c_Lcats_instances_InvariantInstances$$anon$13(fa$9, f$5, g$5) {
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa = null;
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_f = null;
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_g = null;
  this.Lcats_instances_InvariantInstances$$anon$13__f_f$6 = null;
  this.Lcats_instances_InvariantInstances$$anon$13__f_fa$10 = null;
  this.Lcats_instances_InvariantInstances$$anon$13__f_g$6 = null;
  this.Lcats_instances_InvariantInstances$$anon$13__f_f$6 = f$5;
  this.Lcats_instances_InvariantInstances$$anon$13__f_fa$10 = fa$9;
  this.Lcats_instances_InvariantInstances$$anon$13__f_g$6 = g$5;
  $ct_Lcats_instances_ScalaVersionSpecificNumeric__s_math_Numeric__F1__F1__(this, fa$9, f$5, g$5);
}
$c_Lcats_instances_InvariantInstances$$anon$13.prototype = new $h_Lcats_instances_ScalaVersionSpecificNumeric();
$c_Lcats_instances_InvariantInstances$$anon$13.prototype.constructor = $c_Lcats_instances_InvariantInstances$$anon$13;
/** @constructor */
function $h_Lcats_instances_InvariantInstances$$anon$13() {
}
$h_Lcats_instances_InvariantInstances$$anon$13.prototype = $c_Lcats_instances_InvariantInstances$$anon$13.prototype;
$c_Lcats_instances_InvariantInstances$$anon$13.prototype.quot__O__O__O = (function(x, y) {
  return $n(this.Lcats_instances_InvariantInstances$$anon$13__f_f$6).apply__O__O($n(this.Lcats_instances_InvariantInstances$$anon$13__f_fa$10).quot__O__O__O($n(this.Lcats_instances_InvariantInstances$$anon$13__f_g$6).apply__O__O(x), $n(this.Lcats_instances_InvariantInstances$$anon$13__f_g$6).apply__O__O(y)));
});
$c_Lcats_instances_InvariantInstances$$anon$13.prototype.rem__O__O__O = (function(x, y) {
  return $n(this.Lcats_instances_InvariantInstances$$anon$13__f_f$6).apply__O__O($n(this.Lcats_instances_InvariantInstances$$anon$13__f_fa$10).rem__O__O__O($n(this.Lcats_instances_InvariantInstances$$anon$13__f_g$6).apply__O__O(x), $n(this.Lcats_instances_InvariantInstances$$anon$13__f_g$6).apply__O__O(y)));
});
var $d_Lcats_instances_InvariantInstances$$anon$13 = new $TypeData().initClass($c_Lcats_instances_InvariantInstances$$anon$13, "cats.instances.InvariantInstances$$anon$13", ({
  Lcats_instances_InvariantInstances$$anon$13: 1,
  Lcats_instances_ScalaVersionSpecificNumeric: 1,
  ju_Comparator: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1,
  s_math_PartialOrdering: 1,
  s_math_Ordering: 1,
  s_math_Numeric: 1,
  s_math_Integral: 1
}));
/** @constructor */
function $c_Lcats_instances_OrderInstances$$anon$1() {
}
$c_Lcats_instances_OrderInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_OrderInstances$$anon$1.prototype.constructor = $c_Lcats_instances_OrderInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_OrderInstances$$anon$1() {
}
$h_Lcats_instances_OrderInstances$$anon$1.prototype = $c_Lcats_instances_OrderInstances$$anon$1.prototype;
$c_Lcats_instances_OrderInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  var fa$1 = $as_Lcats_kernel_Order(fa);
  var this$1 = $n($m_Lcats_package$().Lcats_package$__f_Order);
  return new $c_Lcats_kernel_Order$$anon$2(fa$1, fi, this$1);
});
$c_Lcats_instances_OrderInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_kernel_Order(fa);
  var fb$1 = $as_Lcats_kernel_Order(fb);
  return new $c_Lcats_instances_OrderInstances$$anon$2(fa$1, fb$1, this);
});
var $d_Lcats_instances_OrderInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_OrderInstances$$anon$1, "cats.instances.OrderInstances$$anon$1", ({
  Lcats_instances_OrderInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
}));
/** @constructor */
function $c_Lcats_instances_OrderingInstances$$anon$1() {
}
$c_Lcats_instances_OrderingInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_OrderingInstances$$anon$1.prototype.constructor = $c_Lcats_instances_OrderingInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_OrderingInstances$$anon$1() {
}
$h_Lcats_instances_OrderingInstances$$anon$1.prototype = $c_Lcats_instances_OrderingInstances$$anon$1.prototype;
$c_Lcats_instances_OrderingInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  var fa$1 = $as_s_math_Ordering(fa);
  var this$1 = $n(fa$1);
  return new $c_s_math_Ordering$$anon$1(this$1, fi);
});
$c_Lcats_instances_OrderingInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_s_math_Ordering(fa);
  var fb$1 = $as_s_math_Ordering(fb);
  return new $c_Lcats_instances_OrderingInstances$$anon$2(fa$1, fb$1);
});
var $d_Lcats_instances_OrderingInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_OrderingInstances$$anon$1, "cats.instances.OrderingInstances$$anon$1", ({
  Lcats_instances_OrderingInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
}));
/** @constructor */
function $c_Lcats_instances_PartialOrderInstances$$anon$1() {
}
$c_Lcats_instances_PartialOrderInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_PartialOrderInstances$$anon$1.prototype.constructor = $c_Lcats_instances_PartialOrderInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_PartialOrderInstances$$anon$1() {
}
$h_Lcats_instances_PartialOrderInstances$$anon$1.prototype = $c_Lcats_instances_PartialOrderInstances$$anon$1.prototype;
$c_Lcats_instances_PartialOrderInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  var fa$1 = $as_Lcats_kernel_PartialOrder(fa);
  var this$1 = $n($m_Lcats_package$().Lcats_package$__f_PartialOrder);
  return new $c_Lcats_kernel_PartialOrder$$anon$1(fa$1, fi, this$1);
});
$c_Lcats_instances_PartialOrderInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_kernel_PartialOrder(fa);
  var fb$1 = $as_Lcats_kernel_PartialOrder(fb);
  return new $c_Lcats_instances_PartialOrderInstances$$anon$2(fa$1, fb$1, this);
});
var $d_Lcats_instances_PartialOrderInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_PartialOrderInstances$$anon$1, "cats.instances.PartialOrderInstances$$anon$1", ({
  Lcats_instances_PartialOrderInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
}));
/** @constructor */
function $c_Lcats_instances_PartialOrderingInstances$$anon$1() {
}
$c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype.constructor = $c_Lcats_instances_PartialOrderingInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_PartialOrderingInstances$$anon$1() {
}
$h_Lcats_instances_PartialOrderingInstances$$anon$1.prototype = $c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype;
$c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  var fa$1 = $as_s_math_PartialOrdering(fa);
  return new $c_Lcats_instances_PartialOrderingInstances$$anon$2(fa$1, fi);
});
$c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_s_math_PartialOrdering(fa);
  var fb$1 = $as_s_math_PartialOrdering(fb);
  return new $c_Lcats_instances_PartialOrderingInstances$$anon$3(fa$1, fb$1);
});
var $d_Lcats_instances_PartialOrderingInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_PartialOrderingInstances$$anon$1, "cats.instances.PartialOrderingInstances$$anon$1", ({
  Lcats_instances_PartialOrderingInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_BitSetSemilattice() {
}
$c_Lcats_kernel_instances_BitSetSemilattice.prototype = new $h_O();
$c_Lcats_kernel_instances_BitSetSemilattice.prototype.constructor = $c_Lcats_kernel_instances_BitSetSemilattice;
/** @constructor */
function $h_Lcats_kernel_instances_BitSetSemilattice() {
}
$h_Lcats_kernel_instances_BitSetSemilattice.prototype = $c_Lcats_kernel_instances_BitSetSemilattice.prototype;
$c_Lcats_kernel_instances_BitSetSemilattice.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_BitSetSemilattice.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAllOption__sc_IterableOnce__s_Option(this, as);
});
$c_Lcats_kernel_instances_BitSetSemilattice.prototype.empty__O = (function() {
  return $m_sci_BitSet$().sci_BitSet$__f_empty;
});
$c_Lcats_kernel_instances_BitSetSemilattice.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_BitSet(x);
  var y$1 = $as_sci_BitSet(y);
  var this$1 = $n(x$1);
  return $as_sci_BitSet($f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet(this$1, y$1));
});
var $d_Lcats_kernel_instances_BitSetSemilattice = new $TypeData().initClass($c_Lcats_kernel_instances_BitSetSemilattice, "cats.kernel.instances.BitSetSemilattice", ({
  Lcats_kernel_instances_BitSetSemilattice: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Band: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_Semilattice: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_BoundedSemilattice: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_DurationOrder() {
}
$c_Lcats_kernel_instances_DurationOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_DurationOrder.prototype.constructor = $c_Lcats_kernel_instances_DurationOrder;
/** @constructor */
function $h_Lcats_kernel_instances_DurationOrder() {
}
$h_Lcats_kernel_instances_DurationOrder.prototype = $c_Lcats_kernel_instances_DurationOrder.prototype;
$c_Lcats_kernel_instances_DurationOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_DurationOrder.prototype.toOrdering__s_math_Ordering = (function() {
  return new $c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_instances_DurationOrder.prototype.eqv__s_concurrent_duration_Duration__s_concurrent_duration_Duration__Z = (function(x, y) {
  return ((x === null) ? (y === null) : $n(x).equals__O__Z(y));
});
$c_Lcats_kernel_instances_DurationOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_s_concurrent_duration_Duration(x);
  return $n(x$1).hashCode__I();
});
$c_Lcats_kernel_instances_DurationOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_Duration(x);
  var y$1 = $as_s_concurrent_duration_Duration(y);
  var this$1 = $n(x$1);
  return this$1.compare__s_concurrent_duration_Duration__I(y$1);
});
$c_Lcats_kernel_instances_DurationOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__s_concurrent_duration_Duration__s_concurrent_duration_Duration__Z($as_s_concurrent_duration_Duration(x), $as_s_concurrent_duration_Duration(y));
});
$c_Lcats_kernel_instances_DurationOrder.prototype.gt__O__O__Z = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_Duration(x);
  var y$1 = $as_s_concurrent_duration_Duration(y);
  var this$1 = $n(x$1);
  return $f_s_math_Ordered__$greater__O__Z(this$1, y$1);
});
$c_Lcats_kernel_instances_DurationOrder.prototype.max__O__O__O = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_Duration(x);
  var y$1 = $as_s_concurrent_duration_Duration(y);
  return $n(x$1).max__s_concurrent_duration_Duration__s_concurrent_duration_Duration(y$1);
});
var $d_Lcats_kernel_instances_DurationOrder = new $TypeData().initClass($c_Lcats_kernel_instances_DurationOrder, "cats.kernel.instances.DurationOrder", ({
  Lcats_kernel_instances_DurationOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_DurationBounded: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_FiniteDurationOrder() {
}
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.constructor = $c_Lcats_kernel_instances_FiniteDurationOrder;
/** @constructor */
function $h_Lcats_kernel_instances_FiniteDurationOrder() {
}
$h_Lcats_kernel_instances_FiniteDurationOrder.prototype = $c_Lcats_kernel_instances_FiniteDurationOrder.prototype;
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.toOrdering__s_math_Ordering = (function() {
  return new $c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.eqv__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration__Z = (function(x, y) {
  return ((x === null) ? (y === null) : $n(x).equals__O__Z(y));
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_s_concurrent_duration_FiniteDuration(x);
  var this$1 = $n(x$1);
  var this$2 = $n(this$1.s_concurrent_duration_FiniteDuration__f_unit).toNanos__J__J(this$1.s_concurrent_duration_FiniteDuration__f_length);
  return this$2.RTLong__f_lo;
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_FiniteDuration(x);
  var y$1 = $as_s_concurrent_duration_FiniteDuration(y);
  return $n(x$1).compare__s_concurrent_duration_Duration__I(y$1);
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration__Z($as_s_concurrent_duration_FiniteDuration(x), $as_s_concurrent_duration_FiniteDuration(y));
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.gt__O__O__Z = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_FiniteDuration(x);
  var y$1 = $as_s_concurrent_duration_FiniteDuration(y);
  var this$1 = $n(x$1);
  return $f_s_math_Ordered__$greater__O__Z(this$1, y$1);
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.max__O__O__O = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_FiniteDuration(x);
  var y$1 = $as_s_concurrent_duration_FiniteDuration(y);
  return $n(x$1).max__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration(y$1);
});
var $d_Lcats_kernel_instances_FiniteDurationOrder = new $TypeData().initClass($c_Lcats_kernel_instances_FiniteDurationOrder, "cats.kernel.instances.FiniteDurationOrder", ({
  Lcats_kernel_instances_FiniteDurationOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_FiniteDurationBounded: 1
}));
/** @constructor */
function $c_Lfs2_Pull$CanceledScope(scopeId, inter) {
  this.Lfs2_Pull$CanceledScope__f_scopeId = null;
  this.Lfs2_Pull$CanceledScope__f_inter = null;
  this.Lfs2_Pull$CanceledScope__f_scopeId = scopeId;
  this.Lfs2_Pull$CanceledScope__f_inter = inter;
}
$c_Lfs2_Pull$CanceledScope.prototype = new $h_Lfs2_Pull$CloseScope();
$c_Lfs2_Pull$CanceledScope.prototype.constructor = $c_Lfs2_Pull$CanceledScope;
/** @constructor */
function $h_Lfs2_Pull$CanceledScope() {
}
$h_Lfs2_Pull$CanceledScope.prototype = $c_Lfs2_Pull$CanceledScope.prototype;
$c_Lfs2_Pull$CanceledScope.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$CanceledScope.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lfs2_Pull$CanceledScope.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$CanceledScope)) {
    var x$0$2 = $as_Lfs2_Pull$CanceledScope(x$0);
    var x = this.Lfs2_Pull$CanceledScope__f_scopeId;
    var x$2 = $n(x$0$2).Lfs2_Pull$CanceledScope__f_scopeId;
    if ((x === null)) {
      var $x_1 = (x$2 === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === x$2);
    }
    if ($x_1) {
      var x$3 = this.Lfs2_Pull$CanceledScope__f_inter;
      var x$4 = $n(x$0$2).Lfs2_Pull$CanceledScope__f_inter;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_Pull$CanceledScope.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$CanceledScope.prototype.productArity__I = (function() {
  return 2;
});
$c_Lfs2_Pull$CanceledScope.prototype.productPrefix__T = (function() {
  return "CanceledScope";
});
$c_Lfs2_Pull$CanceledScope.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$CanceledScope__f_scopeId;
  }
  if ((n === 1)) {
    return this.Lfs2_Pull$CanceledScope__f_inter;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_Pull$CanceledScope.prototype.scopeId__Lcats_effect_kernel_Unique$Token = (function() {
  return this.Lfs2_Pull$CanceledScope__f_scopeId;
});
$c_Lfs2_Pull$CanceledScope.prototype.exitCase__Lcats_effect_kernel_Resource$ExitCase = (function() {
  return $m_Lcats_effect_kernel_Resource$ExitCase$Canceled$();
});
$c_Lfs2_Pull$CanceledScope.prototype.interruption__s_Option = (function() {
  var value = this.Lfs2_Pull$CanceledScope__f_inter;
  return new $c_s_Some(value);
});
function $as_Lfs2_Pull$CanceledScope(obj) {
  return (((obj instanceof $c_Lfs2_Pull$CanceledScope) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$CanceledScope"));
}
function $isArrayOf_Lfs2_Pull$CanceledScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$CanceledScope)));
}
function $asArrayOf_Lfs2_Pull$CanceledScope(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$CanceledScope(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$CanceledScope;", depth));
}
var $d_Lfs2_Pull$CanceledScope = new $TypeData().initClass($c_Lfs2_Pull$CanceledScope, "fs2.Pull$CanceledScope", ({
  Lfs2_Pull$CanceledScope: 1,
  Lfs2_Pull$CloseScope: 1,
  Lfs2_Pull$AlgEffect: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lfs2_Pull$FailedScope(scopeId, err) {
  this.Lfs2_Pull$FailedScope__f_scopeId = null;
  this.Lfs2_Pull$FailedScope__f_err = null;
  this.Lfs2_Pull$FailedScope__f_scopeId = scopeId;
  this.Lfs2_Pull$FailedScope__f_err = err;
}
$c_Lfs2_Pull$FailedScope.prototype = new $h_Lfs2_Pull$CloseScope();
$c_Lfs2_Pull$FailedScope.prototype.constructor = $c_Lfs2_Pull$FailedScope;
/** @constructor */
function $h_Lfs2_Pull$FailedScope() {
}
$h_Lfs2_Pull$FailedScope.prototype = $c_Lfs2_Pull$FailedScope.prototype;
$c_Lfs2_Pull$FailedScope.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$FailedScope.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lfs2_Pull$FailedScope.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$FailedScope)) {
    var x$0$2 = $as_Lfs2_Pull$FailedScope(x$0);
    var x = this.Lfs2_Pull$FailedScope__f_scopeId;
    var x$2 = $n(x$0$2).Lfs2_Pull$FailedScope__f_scopeId;
    if ((x === null)) {
      var $x_1 = (x$2 === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === x$2);
    }
    if ($x_1) {
      var x$3 = this.Lfs2_Pull$FailedScope__f_err;
      var x$4 = $n(x$0$2).Lfs2_Pull$FailedScope__f_err;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_Pull$FailedScope.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$FailedScope.prototype.productArity__I = (function() {
  return 2;
});
$c_Lfs2_Pull$FailedScope.prototype.productPrefix__T = (function() {
  return "FailedScope";
});
$c_Lfs2_Pull$FailedScope.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$FailedScope__f_scopeId;
  }
  if ((n === 1)) {
    return this.Lfs2_Pull$FailedScope__f_err;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_Pull$FailedScope.prototype.scopeId__Lcats_effect_kernel_Unique$Token = (function() {
  return this.Lfs2_Pull$FailedScope__f_scopeId;
});
$c_Lfs2_Pull$FailedScope.prototype.exitCase__Lcats_effect_kernel_Resource$ExitCase = (function() {
  var e = this.Lfs2_Pull$FailedScope__f_err;
  return new $c_Lcats_effect_kernel_Resource$ExitCase$Errored(e);
});
$c_Lfs2_Pull$FailedScope.prototype.interruption__s_Option = (function() {
  return $m_s_None$();
});
function $as_Lfs2_Pull$FailedScope(obj) {
  return (((obj instanceof $c_Lfs2_Pull$FailedScope) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$FailedScope"));
}
function $isArrayOf_Lfs2_Pull$FailedScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$FailedScope)));
}
function $asArrayOf_Lfs2_Pull$FailedScope(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$FailedScope(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$FailedScope;", depth));
}
var $d_Lfs2_Pull$FailedScope = new $TypeData().initClass($c_Lfs2_Pull$FailedScope, "fs2.Pull$FailedScope", ({
  Lfs2_Pull$FailedScope: 1,
  Lfs2_Pull$CloseScope: 1,
  Lfs2_Pull$AlgEffect: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lfs2_Pull$SucceedScope(scopeId) {
  this.Lfs2_Pull$SucceedScope__f_scopeId = null;
  this.Lfs2_Pull$SucceedScope__f_scopeId = scopeId;
}
$c_Lfs2_Pull$SucceedScope.prototype = new $h_Lfs2_Pull$CloseScope();
$c_Lfs2_Pull$SucceedScope.prototype.constructor = $c_Lfs2_Pull$SucceedScope;
/** @constructor */
function $h_Lfs2_Pull$SucceedScope() {
}
$h_Lfs2_Pull$SucceedScope.prototype = $c_Lfs2_Pull$SucceedScope.prototype;
$c_Lfs2_Pull$SucceedScope.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$SucceedScope.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Lfs2_Pull$SucceedScope.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$SucceedScope)) {
    var x$0$2 = $as_Lfs2_Pull$SucceedScope(x$0);
    var x = this.Lfs2_Pull$SucceedScope__f_scopeId;
    var x$2 = $n(x$0$2).Lfs2_Pull$SucceedScope__f_scopeId;
    if ((x === null)) {
      return (x$2 === null);
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2);
    }
  } else {
    return false;
  }
});
$c_Lfs2_Pull$SucceedScope.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$SucceedScope.prototype.productArity__I = (function() {
  return 1;
});
$c_Lfs2_Pull$SucceedScope.prototype.productPrefix__T = (function() {
  return "SucceedScope";
});
$c_Lfs2_Pull$SucceedScope.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$SucceedScope__f_scopeId;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_Pull$SucceedScope.prototype.scopeId__Lcats_effect_kernel_Unique$Token = (function() {
  return this.Lfs2_Pull$SucceedScope__f_scopeId;
});
$c_Lfs2_Pull$SucceedScope.prototype.exitCase__Lcats_effect_kernel_Resource$ExitCase = (function() {
  return $m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$();
});
$c_Lfs2_Pull$SucceedScope.prototype.interruption__s_Option = (function() {
  return $m_s_None$();
});
function $as_Lfs2_Pull$SucceedScope(obj) {
  return (((obj instanceof $c_Lfs2_Pull$SucceedScope) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$SucceedScope"));
}
function $isArrayOf_Lfs2_Pull$SucceedScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$SucceedScope)));
}
function $asArrayOf_Lfs2_Pull$SucceedScope(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$SucceedScope(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$SucceedScope;", depth));
}
var $d_Lfs2_Pull$SucceedScope = new $TypeData().initClass($c_Lfs2_Pull$SucceedScope, "fs2.Pull$SucceedScope", ({
  Lfs2_Pull$SucceedScope: 1,
  Lfs2_Pull$CloseScope: 1,
  Lfs2_Pull$AlgEffect: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $ct_ju_ArrayList__O__($thiz, inner) {
  $thiz.ju_ArrayList__f_java$util$ArrayList$$inner = inner;
  return $thiz;
}
function $ct_ju_ArrayList__I__($thiz, initialCapacity) {
  $ct_ju_ArrayList__O__($thiz, []);
  if ((initialCapacity < 0)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  return $thiz;
}
/** @constructor */
function $c_ju_ArrayList() {
  this.ju_ArrayList__f_java$util$ArrayList$$inner = null;
}
$c_ju_ArrayList.prototype = new $h_ju_AbstractList();
$c_ju_ArrayList.prototype.constructor = $c_ju_ArrayList;
/** @constructor */
function $h_ju_ArrayList() {
}
$h_ju_ArrayList.prototype = $c_ju_ArrayList.prototype;
$c_ju_ArrayList.prototype.size__I = (function() {
  return $uI(this.ju_ArrayList__f_java$util$ArrayList$$inner.length);
});
$c_ju_ArrayList.prototype.get__I__O = (function(index) {
  this.checkIndexInBounds__I__V(index);
  return this.ju_ArrayList__f_java$util$ArrayList$$inner[index];
});
$c_ju_ArrayList.prototype.add__O__Z = (function(e) {
  this.ju_ArrayList__f_java$util$ArrayList$$inner.push(e);
  return true;
});
var $d_ju_ArrayList = new $TypeData().initClass($c_ju_ArrayList, "java.util.ArrayList", ({
  ju_ArrayList: 1,
  ju_AbstractList: 1,
  ju_AbstractCollection: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_List: 1,
  ju_RandomAccess: 1,
  jl_Cloneable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llaika_api_config_ConfigValue$NullValue$() {
  this.Llaika_api_config_ConfigValue$NullValue$__f_render = null;
  this.Llaika_api_config_ConfigValue$NullValue$__f_render = null;
}
$c_Llaika_api_config_ConfigValue$NullValue$.prototype = new $h_O();
$c_Llaika_api_config_ConfigValue$NullValue$.prototype.constructor = $c_Llaika_api_config_ConfigValue$NullValue$;
/** @constructor */
function $h_Llaika_api_config_ConfigValue$NullValue$() {
}
$h_Llaika_api_config_ConfigValue$NullValue$.prototype = $c_Llaika_api_config_ConfigValue$NullValue$.prototype;
$c_Llaika_api_config_ConfigValue$NullValue$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_api_config_ConfigValue$NullValue$.prototype.hashCode__I = (function() {
  return (-1256630262);
});
$c_Llaika_api_config_ConfigValue$NullValue$.prototype.toString__T = (function() {
  return "NullValue";
});
$c_Llaika_api_config_ConfigValue$NullValue$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_api_config_ConfigValue$NullValue$.prototype.productPrefix__T = (function() {
  return "NullValue";
});
$c_Llaika_api_config_ConfigValue$NullValue$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_api_config_ConfigValue$NullValue$.prototype.render__T = (function() {
  return null;
});
var $d_Llaika_api_config_ConfigValue$NullValue$ = new $TypeData().initClass($c_Llaika_api_config_ConfigValue$NullValue$, "laika.api.config.ConfigValue$NullValue$", ({
  Llaika_api_config_ConfigValue$NullValue$: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_api_config_ConfigValue: 1,
  Llaika_api_config_ConfigValue$SimpleValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_api_config_ConfigValue$NullValue$;
function $m_Llaika_api_config_ConfigValue$NullValue$() {
  if ((!$n_Llaika_api_config_ConfigValue$NullValue$)) {
    $n_Llaika_api_config_ConfigValue$NullValue$ = new $c_Llaika_api_config_ConfigValue$NullValue$();
  }
  return $n_Llaika_api_config_ConfigValue$NullValue$;
}
function $as_Llaika_ast_CodeSpan(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.CodeSpan"));
}
function $isArrayOf_Llaika_ast_CodeSpan(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_CodeSpan)));
}
function $asArrayOf_Llaika_ast_CodeSpan(obj, depth) {
  return (($isArrayOf_Llaika_ast_CodeSpan(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.CodeSpan;", depth));
}
/** @constructor */
function $c_Llaika_ast_DocumentType$Config$() {
}
$c_Llaika_ast_DocumentType$Config$.prototype = new $h_Llaika_ast_TextDocumentType();
$c_Llaika_ast_DocumentType$Config$.prototype.constructor = $c_Llaika_ast_DocumentType$Config$;
/** @constructor */
function $h_Llaika_ast_DocumentType$Config$() {
}
$h_Llaika_ast_DocumentType$Config$.prototype = $c_Llaika_ast_DocumentType$Config$.prototype;
$c_Llaika_ast_DocumentType$Config$.prototype.hashCode__I = (function() {
  return 2024042338;
});
$c_Llaika_ast_DocumentType$Config$.prototype.toString__T = (function() {
  return "Config";
});
$c_Llaika_ast_DocumentType$Config$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_ast_DocumentType$Config$.prototype.productPrefix__T = (function() {
  return "Config";
});
$c_Llaika_ast_DocumentType$Config$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_ast_DocumentType$Config$ = new $TypeData().initClass($c_Llaika_ast_DocumentType$Config$, "laika.ast.DocumentType$Config$", ({
  Llaika_ast_DocumentType$Config$: 1,
  Llaika_ast_TextDocumentType: 1,
  Llaika_ast_DocumentType: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_ast_DocumentType$Config$;
function $m_Llaika_ast_DocumentType$Config$() {
  if ((!$n_Llaika_ast_DocumentType$Config$)) {
    $n_Llaika_ast_DocumentType$Config$ = new $c_Llaika_ast_DocumentType$Config$();
  }
  return $n_Llaika_ast_DocumentType$Config$;
}
/** @constructor */
function $c_Llaika_ast_DocumentType$Markup$() {
}
$c_Llaika_ast_DocumentType$Markup$.prototype = new $h_Llaika_ast_TextDocumentType();
$c_Llaika_ast_DocumentType$Markup$.prototype.constructor = $c_Llaika_ast_DocumentType$Markup$;
/** @constructor */
function $h_Llaika_ast_DocumentType$Markup$() {
}
$h_Llaika_ast_DocumentType$Markup$.prototype = $c_Llaika_ast_DocumentType$Markup$.prototype;
$c_Llaika_ast_DocumentType$Markup$.prototype.hashCode__I = (function() {
  return (-1997438392);
});
$c_Llaika_ast_DocumentType$Markup$.prototype.toString__T = (function() {
  return "Markup";
});
$c_Llaika_ast_DocumentType$Markup$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_ast_DocumentType$Markup$.prototype.productPrefix__T = (function() {
  return "Markup";
});
$c_Llaika_ast_DocumentType$Markup$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_ast_DocumentType$Markup$ = new $TypeData().initClass($c_Llaika_ast_DocumentType$Markup$, "laika.ast.DocumentType$Markup$", ({
  Llaika_ast_DocumentType$Markup$: 1,
  Llaika_ast_TextDocumentType: 1,
  Llaika_ast_DocumentType: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_ast_DocumentType$Markup$;
function $m_Llaika_ast_DocumentType$Markup$() {
  if ((!$n_Llaika_ast_DocumentType$Markup$)) {
    $n_Llaika_ast_DocumentType$Markup$ = new $c_Llaika_ast_DocumentType$Markup$();
  }
  return $n_Llaika_ast_DocumentType$Markup$;
}
/** @constructor */
function $c_Llaika_ast_DocumentType$Template$() {
}
$c_Llaika_ast_DocumentType$Template$.prototype = new $h_Llaika_ast_TextDocumentType();
$c_Llaika_ast_DocumentType$Template$.prototype.constructor = $c_Llaika_ast_DocumentType$Template$;
/** @constructor */
function $h_Llaika_ast_DocumentType$Template$() {
}
$h_Llaika_ast_DocumentType$Template$.prototype = $c_Llaika_ast_DocumentType$Template$.prototype;
$c_Llaika_ast_DocumentType$Template$.prototype.hashCode__I = (function() {
  return (-1256902502);
});
$c_Llaika_ast_DocumentType$Template$.prototype.toString__T = (function() {
  return "Template";
});
$c_Llaika_ast_DocumentType$Template$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_ast_DocumentType$Template$.prototype.productPrefix__T = (function() {
  return "Template";
});
$c_Llaika_ast_DocumentType$Template$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_ast_DocumentType$Template$ = new $TypeData().initClass($c_Llaika_ast_DocumentType$Template$, "laika.ast.DocumentType$Template$", ({
  Llaika_ast_DocumentType$Template$: 1,
  Llaika_ast_TextDocumentType: 1,
  Llaika_ast_DocumentType: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_ast_DocumentType$Template$;
function $m_Llaika_ast_DocumentType$Template$() {
  if ((!$n_Llaika_ast_DocumentType$Template$)) {
    $n_Llaika_ast_DocumentType$Template$ = new $c_Llaika_ast_DocumentType$Template$();
  }
  return $n_Llaika_ast_DocumentType$Template$;
}
/** @constructor */
function $c_Llaika_ast_IconReference(key, source, options) {
  this.Llaika_ast_IconReference__f_key = null;
  this.Llaika_ast_IconReference__f_source = null;
  this.Llaika_ast_IconReference__f_options = null;
  this.Llaika_ast_IconReference__f_unresolvedMessage$lzy2 = null;
  this.Llaika_ast_IconReference__f_unresolvedMessagebitmap$2 = false;
  this.Llaika_ast_IconReference__f_key = key;
  this.Llaika_ast_IconReference__f_source = source;
  this.Llaika_ast_IconReference__f_options = options;
}
$c_Llaika_ast_IconReference.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_IconReference.prototype.constructor = $c_Llaika_ast_IconReference;
/** @constructor */
function $h_Llaika_ast_IconReference() {
}
$h_Llaika_ast_IconReference.prototype = $c_Llaika_ast_IconReference.prototype;
$c_Llaika_ast_IconReference.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_IconReference.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_IconReference)) {
    var x$0$2 = $as_Llaika_ast_IconReference(x$0);
    if ((this.Llaika_ast_IconReference__f_key === $n(x$0$2).Llaika_ast_IconReference__f_key)) {
      var x = this.Llaika_ast_IconReference__f_source;
      var x$2 = $n(x$0$2).Llaika_ast_IconReference__f_source;
      var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Llaika_ast_IconReference__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_IconReference__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_IconReference.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_IconReference.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_IconReference.prototype.productPrefix__T = (function() {
  return "IconReference";
});
$c_Llaika_ast_IconReference.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_IconReference__f_key;
      break;
    }
    case 1: {
      return this.Llaika_ast_IconReference__f_source;
      break;
    }
    case 2: {
      return this.Llaika_ast_IconReference__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_IconReference.prototype.source__Llaika_parse_SourceFragment = (function() {
  return this.Llaika_ast_IconReference__f_source;
});
$c_Llaika_ast_IconReference.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_IconReference__f_options;
});
$c_Llaika_ast_IconReference.prototype.resolve__Llaika_ast_DocumentCursor__Llaika_ast_Span = (function(cursor) {
  var this$1 = $n($n(cursor).Llaika_ast_DocumentCursor__f_config);
  var key = $n($m_Llaika_config_LaikaKeys$().Llaika_config_LaikaKeys$__f_icons).child__T__Llaika_api_config_Key(this.Llaika_ast_IconReference__f_key);
  var decoder = $m_Llaika_api_config_ConfigDecoder$().Llaika_api_config_ConfigDecoder$__f_configValue;
  var x82 = $f_Llaika_api_config_Config__getOpt__Llaika_api_config_Key__Llaika_api_config_ConfigDecoder__s_util_Either(this$1, key, decoder);
  if ((x82 instanceof $c_s_util_Right)) {
    var x84 = $as_s_Option($n($as_s_util_Right(x82)).s_util_Right__f_value);
    if ((x84 instanceof $c_s_Some)) {
      var x86 = $as_Llaika_api_config_ConfigValue($n($as_s_Some(x84)).s_Some__f_value);
      if ((x86 instanceof $c_Llaika_api_config_ConfigValue$ASTValue)) {
        var x$1 = $as_Llaika_api_config_ConfigValue$ASTValue(x86);
        var this$3 = $n(x$1);
        var x89 = this$3.Llaika_api_config_ConfigValue$ASTValue__f_value;
        if ($is_Llaika_ast_Icon(x89)) {
          var icon = $as_Llaika_ast_Icon(x89);
          return $as_Llaika_ast_Span($n($as_Llaika_ast_Element(icon)).mergeOptions__Llaika_ast_Options__Llaika_ast_Element(this.Llaika_ast_IconReference__f_options));
        }
      }
    }
  }
  return $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan(this.unresolvedMessage__T(), this.Llaika_ast_IconReference__f_source);
});
$c_Llaika_ast_IconReference.prototype.runsIn__Llaika_ast_RewritePhase__Z = (function(phase) {
  return true;
});
$c_Llaika_ast_IconReference.prototype.unresolvedMessage__T = (function() {
  if ((!this.Llaika_ast_IconReference__f_unresolvedMessagebitmap$2)) {
    this.Llaika_ast_IconReference__f_unresolvedMessage$lzy2 = (("Unresolved icon reference with key '" + this.Llaika_ast_IconReference__f_key) + "'");
    this.Llaika_ast_IconReference__f_unresolvedMessagebitmap$2 = true;
  }
  return this.Llaika_ast_IconReference__f_unresolvedMessage$lzy2;
});
$c_Llaika_ast_IconReference.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var key = this.Llaika_ast_IconReference__f_key;
  var source = this.Llaika_ast_IconReference__f_source;
  return new $c_Llaika_ast_IconReference(key, source, options);
});
function $as_Llaika_ast_IconReference(obj) {
  return (((obj instanceof $c_Llaika_ast_IconReference) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.IconReference"));
}
function $isArrayOf_Llaika_ast_IconReference(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_IconReference)));
}
function $asArrayOf_Llaika_ast_IconReference(obj, depth) {
  return (($isArrayOf_Llaika_ast_IconReference(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.IconReference;", depth));
}
var $d_Llaika_ast_IconReference = new $TypeData().initClass($c_Llaika_ast_IconReference, "laika.ast.IconReference", ({
  Llaika_ast_IconReference: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Unresolved: 1,
  Llaika_ast_SpanResolver: 1,
  Llaika_ast_Reference: 1
}));
/** @constructor */
function $c_Llaika_ast_ImagePathReference(path, source, width, height, alt, title, options) {
  this.Llaika_ast_ImagePathReference__f_path = null;
  this.Llaika_ast_ImagePathReference__f_source = null;
  this.Llaika_ast_ImagePathReference__f_width = null;
  this.Llaika_ast_ImagePathReference__f_height = null;
  this.Llaika_ast_ImagePathReference__f_alt = null;
  this.Llaika_ast_ImagePathReference__f_title = null;
  this.Llaika_ast_ImagePathReference__f_options = null;
  this.Llaika_ast_ImagePathReference__f_unresolvedMessage$lzy4 = null;
  this.Llaika_ast_ImagePathReference__f_unresolvedMessagebitmap$4 = false;
  this.Llaika_ast_ImagePathReference__f_path = path;
  this.Llaika_ast_ImagePathReference__f_source = source;
  this.Llaika_ast_ImagePathReference__f_width = width;
  this.Llaika_ast_ImagePathReference__f_height = height;
  this.Llaika_ast_ImagePathReference__f_alt = alt;
  this.Llaika_ast_ImagePathReference__f_title = title;
  this.Llaika_ast_ImagePathReference__f_options = options;
}
$c_Llaika_ast_ImagePathReference.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_ImagePathReference.prototype.constructor = $c_Llaika_ast_ImagePathReference;
/** @constructor */
function $h_Llaika_ast_ImagePathReference() {
}
$h_Llaika_ast_ImagePathReference.prototype = $c_Llaika_ast_ImagePathReference.prototype;
$c_Llaika_ast_ImagePathReference.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_ImagePathReference.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_ImagePathReference)) {
    var x$0$2 = $as_Llaika_ast_ImagePathReference(x$0);
    var x = this.Llaika_ast_ImagePathReference__f_path;
    var x$2 = $n(x$0$2).Llaika_ast_ImagePathReference__f_path;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_ImagePathReference__f_source;
      var x$4 = $n(x$0$2).Llaika_ast_ImagePathReference__f_source;
      var $x_6 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$5 = this.Llaika_ast_ImagePathReference__f_width;
      var x$6 = $n(x$0$2).Llaika_ast_ImagePathReference__f_width;
      var $x_5 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$7 = this.Llaika_ast_ImagePathReference__f_height;
      var x$8 = $n(x$0$2).Llaika_ast_ImagePathReference__f_height;
      var $x_4 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$9 = this.Llaika_ast_ImagePathReference__f_alt;
      var x$10 = $n(x$0$2).Llaika_ast_ImagePathReference__f_alt;
      var $x_3 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$11 = this.Llaika_ast_ImagePathReference__f_title;
      var x$12 = $n(x$0$2).Llaika_ast_ImagePathReference__f_title;
      var $x_2 = ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$13 = this.Llaika_ast_ImagePathReference__f_options;
      var x$14 = $n(x$0$2).Llaika_ast_ImagePathReference__f_options;
      var $x_1 = ((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_ImagePathReference.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_ImagePathReference.prototype.productArity__I = (function() {
  return 7;
});
$c_Llaika_ast_ImagePathReference.prototype.productPrefix__T = (function() {
  return "ImagePathReference";
});
$c_Llaika_ast_ImagePathReference.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_ImagePathReference__f_path;
      break;
    }
    case 1: {
      return this.Llaika_ast_ImagePathReference__f_source;
      break;
    }
    case 2: {
      return this.Llaika_ast_ImagePathReference__f_width;
      break;
    }
    case 3: {
      return this.Llaika_ast_ImagePathReference__f_height;
      break;
    }
    case 4: {
      return this.Llaika_ast_ImagePathReference__f_alt;
      break;
    }
    case 5: {
      return this.Llaika_ast_ImagePathReference__f_title;
      break;
    }
    case 6: {
      return this.Llaika_ast_ImagePathReference__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_ImagePathReference.prototype.path__Llaika_ast_VirtualPath = (function() {
  return this.Llaika_ast_ImagePathReference__f_path;
});
$c_Llaika_ast_ImagePathReference.prototype.source__Llaika_parse_SourceFragment = (function() {
  return this.Llaika_ast_ImagePathReference__f_source;
});
$c_Llaika_ast_ImagePathReference.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_ImagePathReference__f_options;
});
$c_Llaika_ast_ImagePathReference.prototype.resolve__Llaika_ast_Target__Llaika_ast_Link = (function(target) {
  var width = this.Llaika_ast_ImagePathReference__f_width;
  var height = this.Llaika_ast_ImagePathReference__f_height;
  var alt = this.Llaika_ast_ImagePathReference__f_alt;
  var title = this.Llaika_ast_ImagePathReference__f_title;
  var options = this.Llaika_ast_ImagePathReference__f_options;
  return new $c_Llaika_ast_Image(target, width, height, alt, title, options);
});
$c_Llaika_ast_ImagePathReference.prototype.unresolvedMessage__T = (function() {
  if ((!this.Llaika_ast_ImagePathReference__f_unresolvedMessagebitmap$4)) {
    this.Llaika_ast_ImagePathReference__f_unresolvedMessage$lzy4 = (("Unresolved internal reference to image with path '" + this.Llaika_ast_ImagePathReference__f_path) + "'");
    this.Llaika_ast_ImagePathReference__f_unresolvedMessagebitmap$4 = true;
  }
  return this.Llaika_ast_ImagePathReference__f_unresolvedMessage$lzy4;
});
$c_Llaika_ast_ImagePathReference.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var path = this.Llaika_ast_ImagePathReference__f_path;
  var source = this.Llaika_ast_ImagePathReference__f_source;
  var width = this.Llaika_ast_ImagePathReference__f_width;
  var height = this.Llaika_ast_ImagePathReference__f_height;
  var alt = this.Llaika_ast_ImagePathReference__f_alt;
  var title = this.Llaika_ast_ImagePathReference__f_title;
  return new $c_Llaika_ast_ImagePathReference(path, source, width, height, alt, title, options);
});
function $as_Llaika_ast_ImagePathReference(obj) {
  return (((obj instanceof $c_Llaika_ast_ImagePathReference) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.ImagePathReference"));
}
function $isArrayOf_Llaika_ast_ImagePathReference(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_ImagePathReference)));
}
function $asArrayOf_Llaika_ast_ImagePathReference(obj, depth) {
  return (($isArrayOf_Llaika_ast_ImagePathReference(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.ImagePathReference;", depth));
}
var $d_Llaika_ast_ImagePathReference = new $TypeData().initClass($c_Llaika_ast_ImagePathReference, "laika.ast.ImagePathReference", ({
  Llaika_ast_ImagePathReference: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Unresolved: 1,
  Llaika_ast_Reference: 1,
  Llaika_ast_PathReference: 1
}));
function $as_Llaika_ast_LinkAlias(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.LinkAlias"));
}
function $isArrayOf_Llaika_ast_LinkAlias(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_LinkAlias)));
}
function $asArrayOf_Llaika_ast_LinkAlias(obj, depth) {
  return (($isArrayOf_Llaika_ast_LinkAlias(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.LinkAlias;", depth));
}
/** @constructor */
function $c_Llaika_ast_LinkDefinition(id, target, title, options) {
  this.Llaika_ast_LinkDefinition__f_id = null;
  this.Llaika_ast_LinkDefinition__f_target = null;
  this.Llaika_ast_LinkDefinition__f_title = null;
  this.Llaika_ast_LinkDefinition__f_options = null;
  this.Llaika_ast_LinkDefinition__f_id = id;
  this.Llaika_ast_LinkDefinition__f_target = target;
  this.Llaika_ast_LinkDefinition__f_title = title;
  this.Llaika_ast_LinkDefinition__f_options = options;
}
$c_Llaika_ast_LinkDefinition.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_LinkDefinition.prototype.constructor = $c_Llaika_ast_LinkDefinition;
/** @constructor */
function $h_Llaika_ast_LinkDefinition() {
}
$h_Llaika_ast_LinkDefinition.prototype = $c_Llaika_ast_LinkDefinition.prototype;
$c_Llaika_ast_LinkDefinition.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_LinkDefinition.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_LinkDefinition)) {
    var x$0$2 = $as_Llaika_ast_LinkDefinition(x$0);
    if ((this.Llaika_ast_LinkDefinition__f_id === $n(x$0$2).Llaika_ast_LinkDefinition__f_id)) {
      var x = this.Llaika_ast_LinkDefinition__f_target;
      var x$2 = $n(x$0$2).Llaika_ast_LinkDefinition__f_target;
      var $x_3 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.Llaika_ast_LinkDefinition__f_title;
      var x$4 = $n(x$0$2).Llaika_ast_LinkDefinition__f_title;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llaika_ast_LinkDefinition__f_options;
      var x$6 = $n(x$0$2).Llaika_ast_LinkDefinition__f_options;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_LinkDefinition.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_LinkDefinition.prototype.productArity__I = (function() {
  return 4;
});
$c_Llaika_ast_LinkDefinition.prototype.productPrefix__T = (function() {
  return "LinkDefinition";
});
$c_Llaika_ast_LinkDefinition.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_LinkDefinition__f_id;
      break;
    }
    case 1: {
      return this.Llaika_ast_LinkDefinition__f_target;
      break;
    }
    case 2: {
      return this.Llaika_ast_LinkDefinition__f_title;
      break;
    }
    case 3: {
      return this.Llaika_ast_LinkDefinition__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_LinkDefinition.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_LinkDefinition__f_options;
});
$c_Llaika_ast_LinkDefinition.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var id = this.Llaika_ast_LinkDefinition__f_id;
  var target = this.Llaika_ast_LinkDefinition__f_target;
  var title = this.Llaika_ast_LinkDefinition__f_title;
  return new $c_Llaika_ast_LinkDefinition(id, target, title, options);
});
function $as_Llaika_ast_LinkDefinition(obj) {
  return (((obj instanceof $c_Llaika_ast_LinkDefinition) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.LinkDefinition"));
}
function $isArrayOf_Llaika_ast_LinkDefinition(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_LinkDefinition)));
}
function $asArrayOf_Llaika_ast_LinkDefinition(obj, depth) {
  return (($isArrayOf_Llaika_ast_LinkDefinition(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.LinkDefinition;", depth));
}
var $d_Llaika_ast_LinkDefinition = new $TypeData().initClass($c_Llaika_ast_LinkDefinition, "laika.ast.LinkDefinition", ({
  Llaika_ast_LinkDefinition: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_Definition: 1,
  Llaika_ast_Hidden: 1,
  Llaika_ast_Span: 1
}));
/** @constructor */
function $c_Llaika_ast_MarkupContextReference(ref, required, source, options) {
  this.Llaika_ast_ContextReference__f_ref = null;
  this.Llaika_ast_ContextReference__f_source = null;
  this.Llaika_ast_MarkupContextReference__f_ref = null;
  this.Llaika_ast_MarkupContextReference__f_required = false;
  this.Llaika_ast_MarkupContextReference__f_source = null;
  this.Llaika_ast_MarkupContextReference__f_options = null;
  this.Llaika_ast_MarkupContextReference__f_unresolvedMessage$lzy5 = null;
  this.Llaika_ast_MarkupContextReference__f_unresolvedMessagebitmap$5 = false;
  this.Llaika_ast_MarkupContextReference__f_ref = ref;
  this.Llaika_ast_MarkupContextReference__f_required = required;
  this.Llaika_ast_MarkupContextReference__f_source = source;
  this.Llaika_ast_MarkupContextReference__f_options = options;
  $ct_Llaika_ast_ContextReference__Llaika_api_config_Key__Llaika_parse_SourceFragment__(this, ref, source);
}
$c_Llaika_ast_MarkupContextReference.prototype = new $h_Llaika_ast_ContextReference();
$c_Llaika_ast_MarkupContextReference.prototype.constructor = $c_Llaika_ast_MarkupContextReference;
/** @constructor */
function $h_Llaika_ast_MarkupContextReference() {
}
$h_Llaika_ast_MarkupContextReference.prototype = $c_Llaika_ast_MarkupContextReference.prototype;
$c_Llaika_ast_MarkupContextReference.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("MarkupContextReference");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Llaika_ast_MarkupContextReference__f_ref;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Llaika_ast_MarkupContextReference__f_required ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Llaika_ast_MarkupContextReference__f_source;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Llaika_ast_MarkupContextReference__f_options;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4);
});
$c_Llaika_ast_MarkupContextReference.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_MarkupContextReference)) {
    var x$0$2 = $as_Llaika_ast_MarkupContextReference(x$0);
    if ((this.Llaika_ast_MarkupContextReference__f_required === $n(x$0$2).Llaika_ast_MarkupContextReference__f_required)) {
      var x = this.Llaika_ast_MarkupContextReference__f_ref;
      var x$2 = $n(x$0$2).Llaika_ast_MarkupContextReference__f_ref;
      var $x_3 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.Llaika_ast_MarkupContextReference__f_source;
      var x$4 = $n(x$0$2).Llaika_ast_MarkupContextReference__f_source;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llaika_ast_MarkupContextReference__f_options;
      var x$6 = $n(x$0$2).Llaika_ast_MarkupContextReference__f_options;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_MarkupContextReference.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_MarkupContextReference.prototype.productArity__I = (function() {
  return 4;
});
$c_Llaika_ast_MarkupContextReference.prototype.productPrefix__T = (function() {
  return "MarkupContextReference";
});
$c_Llaika_ast_MarkupContextReference.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_MarkupContextReference__f_ref;
      break;
    }
    case 1: {
      return this.Llaika_ast_MarkupContextReference__f_required;
      break;
    }
    case 2: {
      return this.Llaika_ast_MarkupContextReference__f_source;
      break;
    }
    case 3: {
      return this.Llaika_ast_MarkupContextReference__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_MarkupContextReference.prototype.source__Llaika_parse_SourceFragment = (function() {
  return this.Llaika_ast_MarkupContextReference__f_source;
});
$c_Llaika_ast_MarkupContextReference.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_MarkupContextReference__f_options;
});
$c_Llaika_ast_MarkupContextReference.prototype.resolve__Llaika_ast_DocumentCursor__Llaika_ast_Span = (function(cursor) {
  var x64 = $n(cursor).resolveReference__Llaika_api_config_Key__s_util_Either(this.Llaika_ast_MarkupContextReference__f_ref);
  if ((x64 instanceof $c_s_util_Right)) {
    var x89 = $as_s_Option($n($as_s_util_Right(x64)).s_util_Right__f_value);
    if ((x89 instanceof $c_s_Some)) {
      var x91 = $as_Llaika_api_config_ConfigValue($n($as_s_Some(x89)).s_Some__f_value);
      if ((x91 instanceof $c_Llaika_api_config_ConfigValue$ASTValue)) {
        var x$1 = $as_Llaika_api_config_ConfigValue$ASTValue(x91);
        var this$2 = $n(x$1);
        var x94 = this$2.Llaika_api_config_ConfigValue$ASTValue__f_value;
        if ($is_Llaika_ast_Span(x94)) {
          var s = $as_Llaika_ast_Span(x94);
          return s;
        }
        if ((x94 !== null)) {
          var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
          return new $c_Llaika_ast_TemplateElement(x94, 0, options);
        }
      }
      if ($is_Llaika_api_config_ConfigValue$SimpleValue(x91)) {
        var simple = $as_Llaika_api_config_ConfigValue$SimpleValue(x91);
        var content = $n(simple).render__T();
        var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
        return new $c_Llaika_ast_Text(content, options$1);
      }
    }
    var x = $m_s_None$();
    if ((x === x89)) {
      if ((!this.Llaika_ast_MarkupContextReference__f_required)) {
        var options$2 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
        return new $c_Llaika_ast_Text("", options$2);
      }
      return this.missing__Llaika_ast_InvalidSpan();
    }
    if ((x89 instanceof $c_s_Some)) {
      var unsupported = $as_Llaika_api_config_ConfigValue($n($as_s_Some(x89)).s_Some__f_value);
      return this.invalidType__Llaika_api_config_ConfigValue__Llaika_ast_InvalidSpan(unsupported);
    }
  }
  if ((x64 instanceof $c_s_util_Left)) {
    var configError = $as_Llaika_api_config_ConfigError($n($as_s_util_Left(x64)).s_util_Left__f_value);
    return this.invalid__Llaika_api_config_ConfigError__Llaika_ast_InvalidSpan(configError);
  }
  throw new $c_s_MatchError(x64);
});
$c_Llaika_ast_MarkupContextReference.prototype.runsIn__Llaika_ast_RewritePhase__Z = (function(phase) {
  return (phase instanceof $c_Llaika_ast_RewritePhase$Render);
});
$c_Llaika_ast_MarkupContextReference.prototype.unresolvedMessage__T = (function() {
  if ((!this.Llaika_ast_MarkupContextReference__f_unresolvedMessagebitmap$5)) {
    this.Llaika_ast_MarkupContextReference__f_unresolvedMessage$lzy5 = (("Unresolved markup context reference with key '" + $n(this.Llaika_ast_MarkupContextReference__f_ref).toString__T()) + "'");
    this.Llaika_ast_MarkupContextReference__f_unresolvedMessagebitmap$5 = true;
  }
  return this.Llaika_ast_MarkupContextReference__f_unresolvedMessage$lzy5;
});
$c_Llaika_ast_MarkupContextReference.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var ref = this.Llaika_ast_MarkupContextReference__f_ref;
  var required = this.Llaika_ast_MarkupContextReference__f_required;
  var source = this.Llaika_ast_MarkupContextReference__f_source;
  return new $c_Llaika_ast_MarkupContextReference(ref, required, source, options);
});
function $as_Llaika_ast_MarkupContextReference(obj) {
  return (((obj instanceof $c_Llaika_ast_MarkupContextReference) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.MarkupContextReference"));
}
function $isArrayOf_Llaika_ast_MarkupContextReference(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_MarkupContextReference)));
}
function $asArrayOf_Llaika_ast_MarkupContextReference(obj, depth) {
  return (($isArrayOf_Llaika_ast_MarkupContextReference(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.MarkupContextReference;", depth));
}
var $d_Llaika_ast_MarkupContextReference = new $TypeData().initClass($c_Llaika_ast_MarkupContextReference, "laika.ast.MarkupContextReference", ({
  Llaika_ast_MarkupContextReference: 1,
  Llaika_ast_ContextReference: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Unresolved: 1,
  Llaika_ast_SpanResolver: 1
}));
function $as_Llaika_ast_RawContent(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.RawContent"));
}
function $isArrayOf_Llaika_ast_RawContent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_RawContent)));
}
function $asArrayOf_Llaika_ast_RawContent(obj, depth) {
  return (($isArrayOf_Llaika_ast_RawContent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.RawContent;", depth));
}
/** @constructor */
function $c_Llaika_ast_RuntimeMessage(level, content, options) {
  this.Llaika_ast_RuntimeMessage__f_level = null;
  this.Llaika_ast_RuntimeMessage__f_content = null;
  this.Llaika_ast_RuntimeMessage__f_options = null;
  this.Llaika_ast_RuntimeMessage__f_level = level;
  this.Llaika_ast_RuntimeMessage__f_content = content;
  this.Llaika_ast_RuntimeMessage__f_options = options;
}
$c_Llaika_ast_RuntimeMessage.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_RuntimeMessage.prototype.constructor = $c_Llaika_ast_RuntimeMessage;
/** @constructor */
function $h_Llaika_ast_RuntimeMessage() {
}
$h_Llaika_ast_RuntimeMessage.prototype = $c_Llaika_ast_RuntimeMessage.prototype;
$c_Llaika_ast_RuntimeMessage.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_RuntimeMessage.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_RuntimeMessage)) {
    var x$0$2 = $as_Llaika_ast_RuntimeMessage(x$0);
    var x = this.Llaika_ast_RuntimeMessage__f_level;
    var x$2 = $n(x$0$2).Llaika_ast_RuntimeMessage__f_level;
    if ((x === null)) {
      var $x_2 = (x$2 === null);
    } else {
      var this$1 = $n(x);
      var $x_2 = (this$1 === x$2);
    }
    if (($x_2 && (this.Llaika_ast_RuntimeMessage__f_content === $n(x$0$2).Llaika_ast_RuntimeMessage__f_content))) {
      var x$3 = this.Llaika_ast_RuntimeMessage__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_RuntimeMessage__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_RuntimeMessage.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_RuntimeMessage.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_RuntimeMessage.prototype.productPrefix__T = (function() {
  return "RuntimeMessage";
});
$c_Llaika_ast_RuntimeMessage.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_RuntimeMessage__f_level;
      break;
    }
    case 1: {
      return this.Llaika_ast_RuntimeMessage__f_content;
      break;
    }
    case 2: {
      return this.Llaika_ast_RuntimeMessage__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_RuntimeMessage.prototype.content__T = (function() {
  return this.Llaika_ast_RuntimeMessage__f_content;
});
$c_Llaika_ast_RuntimeMessage.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_RuntimeMessage__f_options;
});
$c_Llaika_ast_RuntimeMessage.prototype.content__O = (function() {
  return this.Llaika_ast_RuntimeMessage__f_content;
});
$c_Llaika_ast_RuntimeMessage.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var level = this.Llaika_ast_RuntimeMessage__f_level;
  var content = this.Llaika_ast_RuntimeMessage__f_content;
  return new $c_Llaika_ast_RuntimeMessage(level, content, options);
});
function $as_Llaika_ast_RuntimeMessage(obj) {
  return (((obj instanceof $c_Llaika_ast_RuntimeMessage) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.RuntimeMessage"));
}
function $isArrayOf_Llaika_ast_RuntimeMessage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_RuntimeMessage)));
}
function $asArrayOf_Llaika_ast_RuntimeMessage(obj, depth) {
  return (($isArrayOf_Llaika_ast_RuntimeMessage(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.RuntimeMessage;", depth));
}
var $d_Llaika_ast_RuntimeMessage = new $TypeData().initClass($c_Llaika_ast_RuntimeMessage, "laika.ast.RuntimeMessage", ({
  Llaika_ast_RuntimeMessage: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_TextContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_TemplateElement(element, indent, options) {
  this.Llaika_ast_TemplateElement__f_element = null;
  this.Llaika_ast_TemplateElement__f_indent = 0;
  this.Llaika_ast_TemplateElement__f_options = null;
  this.Llaika_ast_TemplateElement__f_element = element;
  this.Llaika_ast_TemplateElement__f_indent = indent;
  this.Llaika_ast_TemplateElement__f_options = options;
}
$c_Llaika_ast_TemplateElement.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_TemplateElement.prototype.constructor = $c_Llaika_ast_TemplateElement;
/** @constructor */
function $h_Llaika_ast_TemplateElement() {
}
$h_Llaika_ast_TemplateElement.prototype = $c_Llaika_ast_TemplateElement.prototype;
$c_Llaika_ast_TemplateElement.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("TemplateElement");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Llaika_ast_TemplateElement__f_element;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Llaika_ast_TemplateElement__f_indent;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Llaika_ast_TemplateElement__f_options;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Llaika_ast_TemplateElement.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_TemplateElement)) {
    var x$0$2 = $as_Llaika_ast_TemplateElement(x$0);
    if ((this.Llaika_ast_TemplateElement__f_indent === $n(x$0$2).Llaika_ast_TemplateElement__f_indent)) {
      var x = this.Llaika_ast_TemplateElement__f_element;
      var x$2 = $n(x$0$2).Llaika_ast_TemplateElement__f_element;
      var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Llaika_ast_TemplateElement__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_TemplateElement__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_TemplateElement.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_TemplateElement.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_TemplateElement.prototype.productPrefix__T = (function() {
  return "TemplateElement";
});
$c_Llaika_ast_TemplateElement.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_TemplateElement__f_element;
      break;
    }
    case 1: {
      return this.Llaika_ast_TemplateElement__f_indent;
      break;
    }
    case 2: {
      return this.Llaika_ast_TemplateElement__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_TemplateElement.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_TemplateElement__f_options;
});
$c_Llaika_ast_TemplateElement.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_TemplateElement = (function(rules) {
  var element = $n(rules).rewriteElement__Llaika_ast_Element__Llaika_ast_Element(this.Llaika_ast_TemplateElement__f_element);
  var indent = this.Llaika_ast_TemplateElement__f_indent;
  var options = this.Llaika_ast_TemplateElement__f_options;
  return new $c_Llaika_ast_TemplateElement(element, indent, options);
});
$c_Llaika_ast_TemplateElement.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return this.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_TemplateElement(rules);
});
$c_Llaika_ast_TemplateElement.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var element = this.Llaika_ast_TemplateElement__f_element;
  var indent = this.Llaika_ast_TemplateElement__f_indent;
  return new $c_Llaika_ast_TemplateElement(element, indent, options);
});
function $as_Llaika_ast_TemplateElement(obj) {
  return (((obj instanceof $c_Llaika_ast_TemplateElement) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.TemplateElement"));
}
function $isArrayOf_Llaika_ast_TemplateElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_TemplateElement)));
}
function $asArrayOf_Llaika_ast_TemplateElement(obj, depth) {
  return (($isArrayOf_Llaika_ast_TemplateElement(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.TemplateElement;", depth));
}
var $d_Llaika_ast_TemplateElement = new $TypeData().initClass($c_Llaika_ast_TemplateElement, "laika.ast.TemplateElement", ({
  Llaika_ast_TemplateElement: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_TemplateSpan: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_RewritableContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_TemplateScope(content, context, source, options) {
  this.Llaika_ast_TemplateScope__f_content = null;
  this.Llaika_ast_TemplateScope__f_context = null;
  this.Llaika_ast_TemplateScope__f_source = null;
  this.Llaika_ast_TemplateScope__f_options = null;
  this.Llaika_ast_TemplateScope__f_unresolvedMessage$lzy3 = null;
  this.Llaika_ast_TemplateScope__f_unresolvedMessagebitmap$3 = false;
  this.Llaika_ast_TemplateScope__f_content = content;
  this.Llaika_ast_TemplateScope__f_context = context;
  this.Llaika_ast_TemplateScope__f_source = source;
  this.Llaika_ast_TemplateScope__f_options = options;
}
$c_Llaika_ast_TemplateScope.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_TemplateScope.prototype.constructor = $c_Llaika_ast_TemplateScope;
/** @constructor */
function $h_Llaika_ast_TemplateScope() {
}
$h_Llaika_ast_TemplateScope.prototype = $c_Llaika_ast_TemplateScope.prototype;
$c_Llaika_ast_TemplateScope.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_TemplateScope.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_TemplateScope)) {
    var x$0$2 = $as_Llaika_ast_TemplateScope(x$0);
    var x = this.Llaika_ast_TemplateScope__f_content;
    var x$2 = $n(x$0$2).Llaika_ast_TemplateScope__f_content;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_TemplateScope__f_context;
      var x$4 = $n(x$0$2).Llaika_ast_TemplateScope__f_context;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.Llaika_ast_TemplateScope__f_source;
      var x$6 = $n(x$0$2).Llaika_ast_TemplateScope__f_source;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.Llaika_ast_TemplateScope__f_options;
      var x$8 = $n(x$0$2).Llaika_ast_TemplateScope__f_options;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_TemplateScope.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_TemplateScope.prototype.productArity__I = (function() {
  return 4;
});
$c_Llaika_ast_TemplateScope.prototype.productPrefix__T = (function() {
  return "TemplateScope";
});
$c_Llaika_ast_TemplateScope.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_TemplateScope__f_content;
      break;
    }
    case 1: {
      return this.Llaika_ast_TemplateScope__f_context;
      break;
    }
    case 2: {
      return this.Llaika_ast_TemplateScope__f_source;
      break;
    }
    case 3: {
      return this.Llaika_ast_TemplateScope__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_TemplateScope.prototype.context__Llaika_api_config_ConfigValue = (function() {
  return this.Llaika_ast_TemplateScope__f_context;
});
$c_Llaika_ast_TemplateScope.prototype.source__Llaika_parse_SourceFragment = (function() {
  return this.Llaika_ast_TemplateScope__f_source;
});
$c_Llaika_ast_TemplateScope.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_TemplateScope__f_options;
});
$c_Llaika_ast_TemplateScope.prototype.unresolvedMessage__T = (function() {
  if ((!this.Llaika_ast_TemplateScope__f_unresolvedMessagebitmap$3)) {
    this.Llaika_ast_TemplateScope__f_unresolvedMessage$lzy3 = "Unresolved template scope";
    this.Llaika_ast_TemplateScope__f_unresolvedMessagebitmap$3 = true;
  }
  return this.Llaika_ast_TemplateScope__f_unresolvedMessage$lzy3;
});
$c_Llaika_ast_TemplateScope.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_TemplateScope__f_content;
  var context = this.Llaika_ast_TemplateScope__f_context;
  var source = this.Llaika_ast_TemplateScope__f_source;
  return new $c_Llaika_ast_TemplateScope(content, context, source, options);
});
function $as_Llaika_ast_TemplateScope(obj) {
  return (((obj instanceof $c_Llaika_ast_TemplateScope) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.TemplateScope"));
}
function $isArrayOf_Llaika_ast_TemplateScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_TemplateScope)));
}
function $asArrayOf_Llaika_ast_TemplateScope(obj, depth) {
  return (($isArrayOf_Llaika_ast_TemplateScope(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.TemplateScope;", depth));
}
var $d_Llaika_ast_TemplateScope = new $TypeData().initClass($c_Llaika_ast_TemplateScope, "laika.ast.TemplateScope", ({
  Llaika_ast_TemplateScope: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Unresolved: 1,
  Llaika_ast_ElementScope: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_TemplateSpan: 1
}));
/** @constructor */
function $c_Llaika_ast_TemplateString(content, options) {
  this.Llaika_ast_TemplateString__f_content = null;
  this.Llaika_ast_TemplateString__f_options = null;
  this.Llaika_ast_TemplateString__f_content = content;
  this.Llaika_ast_TemplateString__f_options = options;
}
$c_Llaika_ast_TemplateString.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_TemplateString.prototype.constructor = $c_Llaika_ast_TemplateString;
/** @constructor */
function $h_Llaika_ast_TemplateString() {
}
$h_Llaika_ast_TemplateString.prototype = $c_Llaika_ast_TemplateString.prototype;
$c_Llaika_ast_TemplateString.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_TemplateString.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_TemplateString)) {
    var x$0$2 = $as_Llaika_ast_TemplateString(x$0);
    if ((this.Llaika_ast_TemplateString__f_content === $n(x$0$2).Llaika_ast_TemplateString__f_content)) {
      var x = this.Llaika_ast_TemplateString__f_options;
      var x$2 = $n(x$0$2).Llaika_ast_TemplateString__f_options;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_TemplateString.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_TemplateString.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_TemplateString.prototype.productPrefix__T = (function() {
  return "TemplateString";
});
$c_Llaika_ast_TemplateString.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_TemplateString__f_content;
  }
  if ((n === 1)) {
    return this.Llaika_ast_TemplateString__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_TemplateString.prototype.content__T = (function() {
  return this.Llaika_ast_TemplateString__f_content;
});
$c_Llaika_ast_TemplateString.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_TemplateString__f_options;
});
$c_Llaika_ast_TemplateString.prototype.content__O = (function() {
  return this.Llaika_ast_TemplateString__f_content;
});
$c_Llaika_ast_TemplateString.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_TemplateString__f_content;
  return new $c_Llaika_ast_TemplateString(content, options);
});
function $as_Llaika_ast_TemplateString(obj) {
  return (((obj instanceof $c_Llaika_ast_TemplateString) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.TemplateString"));
}
function $isArrayOf_Llaika_ast_TemplateString(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_TemplateString)));
}
function $asArrayOf_Llaika_ast_TemplateString(obj, depth) {
  return (($isArrayOf_Llaika_ast_TemplateString(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.TemplateString;", depth));
}
var $d_Llaika_ast_TemplateString = new $TypeData().initClass($c_Llaika_ast_TemplateString, "laika.ast.TemplateString", ({
  Llaika_ast_TemplateString: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_TemplateSpan: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_TextContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_html_HTMLCharacterReference(content, options) {
  this.Llaika_ast_html_HTMLCharacterReference__f_content = null;
  this.Llaika_ast_html_HTMLCharacterReference__f_options = null;
  this.Llaika_ast_html_HTMLCharacterReference__f_content = content;
  this.Llaika_ast_html_HTMLCharacterReference__f_options = options;
}
$c_Llaika_ast_html_HTMLCharacterReference.prototype = new $h_Llaika_ast_html_HTMLSpan();
$c_Llaika_ast_html_HTMLCharacterReference.prototype.constructor = $c_Llaika_ast_html_HTMLCharacterReference;
/** @constructor */
function $h_Llaika_ast_html_HTMLCharacterReference() {
}
$h_Llaika_ast_html_HTMLCharacterReference.prototype = $c_Llaika_ast_html_HTMLCharacterReference.prototype;
$c_Llaika_ast_html_HTMLCharacterReference.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_html_HTMLCharacterReference.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_html_HTMLCharacterReference)) {
    var x$0$2 = $as_Llaika_ast_html_HTMLCharacterReference(x$0);
    if ((this.Llaika_ast_html_HTMLCharacterReference__f_content === $n(x$0$2).Llaika_ast_html_HTMLCharacterReference__f_content)) {
      var x = this.Llaika_ast_html_HTMLCharacterReference__f_options;
      var x$2 = $n(x$0$2).Llaika_ast_html_HTMLCharacterReference__f_options;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_html_HTMLCharacterReference.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_html_HTMLCharacterReference.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_html_HTMLCharacterReference.prototype.productPrefix__T = (function() {
  return "HTMLCharacterReference";
});
$c_Llaika_ast_html_HTMLCharacterReference.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_html_HTMLCharacterReference__f_content;
  }
  if ((n === 1)) {
    return this.Llaika_ast_html_HTMLCharacterReference__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_html_HTMLCharacterReference.prototype.content__T = (function() {
  return this.Llaika_ast_html_HTMLCharacterReference__f_content;
});
$c_Llaika_ast_html_HTMLCharacterReference.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_html_HTMLCharacterReference__f_options;
});
$c_Llaika_ast_html_HTMLCharacterReference.prototype.content__O = (function() {
  return this.Llaika_ast_html_HTMLCharacterReference__f_content;
});
$c_Llaika_ast_html_HTMLCharacterReference.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_html_HTMLCharacterReference__f_content;
  return new $c_Llaika_ast_html_HTMLCharacterReference(content, options);
});
function $as_Llaika_ast_html_HTMLCharacterReference(obj) {
  return (((obj instanceof $c_Llaika_ast_html_HTMLCharacterReference) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.html.HTMLCharacterReference"));
}
function $isArrayOf_Llaika_ast_html_HTMLCharacterReference(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_html_HTMLCharacterReference)));
}
function $asArrayOf_Llaika_ast_html_HTMLCharacterReference(obj, depth) {
  return (($isArrayOf_Llaika_ast_html_HTMLCharacterReference(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.html.HTMLCharacterReference;", depth));
}
var $d_Llaika_ast_html_HTMLCharacterReference = new $TypeData().initClass($c_Llaika_ast_html_HTMLCharacterReference, "laika.ast.html.HTMLCharacterReference", ({
  Llaika_ast_html_HTMLCharacterReference: 1,
  Llaika_ast_html_HTMLSpan: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_TextContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_html_HTMLScriptElement(attributes, content, options) {
  this.Llaika_ast_html_HTMLScriptElement__f_attributes = null;
  this.Llaika_ast_html_HTMLScriptElement__f_content = null;
  this.Llaika_ast_html_HTMLScriptElement__f_options = null;
  this.Llaika_ast_html_HTMLScriptElement__f_attributes = attributes;
  this.Llaika_ast_html_HTMLScriptElement__f_content = content;
  this.Llaika_ast_html_HTMLScriptElement__f_options = options;
}
$c_Llaika_ast_html_HTMLScriptElement.prototype = new $h_Llaika_ast_html_HTMLSpan();
$c_Llaika_ast_html_HTMLScriptElement.prototype.constructor = $c_Llaika_ast_html_HTMLScriptElement;
/** @constructor */
function $h_Llaika_ast_html_HTMLScriptElement() {
}
$h_Llaika_ast_html_HTMLScriptElement.prototype = $c_Llaika_ast_html_HTMLScriptElement.prototype;
$c_Llaika_ast_html_HTMLScriptElement.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_html_HTMLScriptElement.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_html_HTMLScriptElement)) {
    var x$0$2 = $as_Llaika_ast_html_HTMLScriptElement(x$0);
    var x = this.Llaika_ast_html_HTMLScriptElement__f_attributes;
    var x$2 = $n(x$0$2).Llaika_ast_html_HTMLScriptElement__f_attributes;
    if ((((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) && (this.Llaika_ast_html_HTMLScriptElement__f_content === $n(x$0$2).Llaika_ast_html_HTMLScriptElement__f_content))) {
      var x$3 = this.Llaika_ast_html_HTMLScriptElement__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_html_HTMLScriptElement__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_html_HTMLScriptElement.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_html_HTMLScriptElement.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_html_HTMLScriptElement.prototype.productPrefix__T = (function() {
  return "HTMLScriptElement";
});
$c_Llaika_ast_html_HTMLScriptElement.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_html_HTMLScriptElement__f_attributes;
      break;
    }
    case 1: {
      return this.Llaika_ast_html_HTMLScriptElement__f_content;
      break;
    }
    case 2: {
      return this.Llaika_ast_html_HTMLScriptElement__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_html_HTMLScriptElement.prototype.content__T = (function() {
  return this.Llaika_ast_html_HTMLScriptElement__f_content;
});
$c_Llaika_ast_html_HTMLScriptElement.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_html_HTMLScriptElement__f_options;
});
$c_Llaika_ast_html_HTMLScriptElement.prototype.content__O = (function() {
  return this.Llaika_ast_html_HTMLScriptElement__f_content;
});
$c_Llaika_ast_html_HTMLScriptElement.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var attributes = this.Llaika_ast_html_HTMLScriptElement__f_attributes;
  var content = this.Llaika_ast_html_HTMLScriptElement__f_content;
  return new $c_Llaika_ast_html_HTMLScriptElement(attributes, content, options);
});
function $as_Llaika_ast_html_HTMLScriptElement(obj) {
  return (((obj instanceof $c_Llaika_ast_html_HTMLScriptElement) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.html.HTMLScriptElement"));
}
function $isArrayOf_Llaika_ast_html_HTMLScriptElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_html_HTMLScriptElement)));
}
function $asArrayOf_Llaika_ast_html_HTMLScriptElement(obj, depth) {
  return (($isArrayOf_Llaika_ast_html_HTMLScriptElement(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.html.HTMLScriptElement;", depth));
}
var $d_Llaika_ast_html_HTMLScriptElement = new $TypeData().initClass($c_Llaika_ast_html_HTMLScriptElement, "laika.ast.html.HTMLScriptElement", ({
  Llaika_ast_html_HTMLScriptElement: 1,
  Llaika_ast_html_HTMLSpan: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_TextContainer: 1
}));
/** @constructor */
function $c_Llaika_internal_link_AnonymousSelector$() {
  this.Llaika_internal_link_AnonymousSelector$__f_global = false;
  $n_Llaika_internal_link_AnonymousSelector$ = this;
  $f_Llaika_internal_link_SequenceSelector__$init$__V(this);
}
$c_Llaika_internal_link_AnonymousSelector$.prototype = new $h_O();
$c_Llaika_internal_link_AnonymousSelector$.prototype.constructor = $c_Llaika_internal_link_AnonymousSelector$;
/** @constructor */
function $h_Llaika_internal_link_AnonymousSelector$() {
}
$h_Llaika_internal_link_AnonymousSelector$.prototype = $c_Llaika_internal_link_AnonymousSelector$.prototype;
$c_Llaika_internal_link_AnonymousSelector$.prototype.global__Z = (function() {
  return this.Llaika_internal_link_AnonymousSelector$__f_global;
});
$c_Llaika_internal_link_AnonymousSelector$.prototype.laika$internal$link$SequenceSelector$_setter_$global_$eq__Z__V = (function(x$0) {
  this.Llaika_internal_link_AnonymousSelector$__f_global = x$0;
});
$c_Llaika_internal_link_AnonymousSelector$.prototype.laika$internal$link$SequenceSelector$_setter_$unique_$eq__Z__V = (function(x$0) {
});
$c_Llaika_internal_link_AnonymousSelector$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_link_AnonymousSelector$.prototype.hashCode__I = (function() {
  return (-2010624180);
});
$c_Llaika_internal_link_AnonymousSelector$.prototype.toString__T = (function() {
  return "AnonymousSelector";
});
$c_Llaika_internal_link_AnonymousSelector$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_internal_link_AnonymousSelector$.prototype.productPrefix__T = (function() {
  return "AnonymousSelector";
});
$c_Llaika_internal_link_AnonymousSelector$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_internal_link_AnonymousSelector$ = new $TypeData().initClass($c_Llaika_internal_link_AnonymousSelector$, "laika.internal.link.AnonymousSelector$", ({
  Llaika_internal_link_AnonymousSelector$: 1,
  Llaika_internal_link_Selector: 1,
  Llaika_internal_link_SequenceSelector: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_internal_link_AnonymousSelector$;
function $m_Llaika_internal_link_AnonymousSelector$() {
  if ((!$n_Llaika_internal_link_AnonymousSelector$)) {
    $n_Llaika_internal_link_AnonymousSelector$ = new $c_Llaika_internal_link_AnonymousSelector$();
  }
  return $n_Llaika_internal_link_AnonymousSelector$;
}
/** @constructor */
function $c_Llaika_internal_link_AutonumberSelector$() {
  this.Llaika_internal_link_AutonumberSelector$__f_global = false;
  $n_Llaika_internal_link_AutonumberSelector$ = this;
  $f_Llaika_internal_link_SequenceSelector__$init$__V(this);
}
$c_Llaika_internal_link_AutonumberSelector$.prototype = new $h_O();
$c_Llaika_internal_link_AutonumberSelector$.prototype.constructor = $c_Llaika_internal_link_AutonumberSelector$;
/** @constructor */
function $h_Llaika_internal_link_AutonumberSelector$() {
}
$h_Llaika_internal_link_AutonumberSelector$.prototype = $c_Llaika_internal_link_AutonumberSelector$.prototype;
$c_Llaika_internal_link_AutonumberSelector$.prototype.global__Z = (function() {
  return this.Llaika_internal_link_AutonumberSelector$__f_global;
});
$c_Llaika_internal_link_AutonumberSelector$.prototype.laika$internal$link$SequenceSelector$_setter_$global_$eq__Z__V = (function(x$0) {
  this.Llaika_internal_link_AutonumberSelector$__f_global = x$0;
});
$c_Llaika_internal_link_AutonumberSelector$.prototype.laika$internal$link$SequenceSelector$_setter_$unique_$eq__Z__V = (function(x$0) {
});
$c_Llaika_internal_link_AutonumberSelector$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_link_AutonumberSelector$.prototype.hashCode__I = (function() {
  return (-90548777);
});
$c_Llaika_internal_link_AutonumberSelector$.prototype.toString__T = (function() {
  return "AutonumberSelector";
});
$c_Llaika_internal_link_AutonumberSelector$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_internal_link_AutonumberSelector$.prototype.productPrefix__T = (function() {
  return "AutonumberSelector";
});
$c_Llaika_internal_link_AutonumberSelector$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_internal_link_AutonumberSelector$ = new $TypeData().initClass($c_Llaika_internal_link_AutonumberSelector$, "laika.internal.link.AutonumberSelector$", ({
  Llaika_internal_link_AutonumberSelector$: 1,
  Llaika_internal_link_Selector: 1,
  Llaika_internal_link_SequenceSelector: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_internal_link_AutonumberSelector$;
function $m_Llaika_internal_link_AutonumberSelector$() {
  if ((!$n_Llaika_internal_link_AutonumberSelector$)) {
    $n_Llaika_internal_link_AutonumberSelector$ = new $c_Llaika_internal_link_AutonumberSelector$();
  }
  return $n_Llaika_internal_link_AutonumberSelector$;
}
/** @constructor */
function $c_Llaika_internal_link_AutosymbolSelector$() {
  this.Llaika_internal_link_AutosymbolSelector$__f_global = false;
  $n_Llaika_internal_link_AutosymbolSelector$ = this;
  $f_Llaika_internal_link_SequenceSelector__$init$__V(this);
}
$c_Llaika_internal_link_AutosymbolSelector$.prototype = new $h_O();
$c_Llaika_internal_link_AutosymbolSelector$.prototype.constructor = $c_Llaika_internal_link_AutosymbolSelector$;
/** @constructor */
function $h_Llaika_internal_link_AutosymbolSelector$() {
}
$h_Llaika_internal_link_AutosymbolSelector$.prototype = $c_Llaika_internal_link_AutosymbolSelector$.prototype;
$c_Llaika_internal_link_AutosymbolSelector$.prototype.global__Z = (function() {
  return this.Llaika_internal_link_AutosymbolSelector$__f_global;
});
$c_Llaika_internal_link_AutosymbolSelector$.prototype.laika$internal$link$SequenceSelector$_setter_$global_$eq__Z__V = (function(x$0) {
  this.Llaika_internal_link_AutosymbolSelector$__f_global = x$0;
});
$c_Llaika_internal_link_AutosymbolSelector$.prototype.laika$internal$link$SequenceSelector$_setter_$unique_$eq__Z__V = (function(x$0) {
});
$c_Llaika_internal_link_AutosymbolSelector$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_internal_link_AutosymbolSelector$.prototype.hashCode__I = (function() {
  return 792670502;
});
$c_Llaika_internal_link_AutosymbolSelector$.prototype.toString__T = (function() {
  return "AutosymbolSelector";
});
$c_Llaika_internal_link_AutosymbolSelector$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_internal_link_AutosymbolSelector$.prototype.productPrefix__T = (function() {
  return "AutosymbolSelector";
});
$c_Llaika_internal_link_AutosymbolSelector$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_internal_link_AutosymbolSelector$ = new $TypeData().initClass($c_Llaika_internal_link_AutosymbolSelector$, "laika.internal.link.AutosymbolSelector$", ({
  Llaika_internal_link_AutosymbolSelector$: 1,
  Llaika_internal_link_Selector: 1,
  Llaika_internal_link_SequenceSelector: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_internal_link_AutosymbolSelector$;
function $m_Llaika_internal_link_AutosymbolSelector$() {
  if ((!$n_Llaika_internal_link_AutosymbolSelector$)) {
    $n_Llaika_internal_link_AutosymbolSelector$ = new $c_Llaika_internal_link_AutosymbolSelector$();
  }
  return $n_Llaika_internal_link_AutosymbolSelector$;
}
/** @constructor */
function $c_sc_AbstractView() {
}
$c_sc_AbstractView.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractView.prototype.constructor = $c_sc_AbstractView;
/** @constructor */
function $h_sc_AbstractView() {
}
$h_sc_AbstractView.prototype = $c_sc_AbstractView.prototype;
$c_sc_AbstractView.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_View$();
});
$c_sc_AbstractView.prototype.empty__sc_View = (function() {
  return $m_sc_View$Empty$();
});
$c_sc_AbstractView.prototype.toString__T = (function() {
  return $f_sc_View__toString__T(this);
});
$c_sc_AbstractView.prototype.stringPrefix__T = (function() {
  return "View";
});
$c_sc_AbstractView.prototype.empty__sc_IterableOps = (function() {
  return this.empty__sc_View();
});
/** @constructor */
function $c_sc_MapOps$$anon$1(outer) {
  this.sc_MapOps$$anon$1__f_$outer = null;
  $n(outer);
  this.sc_MapOps$$anon$1__f_$outer = outer;
}
$c_sc_MapOps$$anon$1.prototype = new $h_sc_AbstractIterable();
$c_sc_MapOps$$anon$1.prototype.constructor = $c_sc_MapOps$$anon$1;
/** @constructor */
function $h_sc_MapOps$$anon$1() {
}
$h_sc_MapOps$$anon$1.prototype = $c_sc_MapOps$$anon$1.prototype;
$c_sc_MapOps$$anon$1.prototype.knownSize__I = (function() {
  return $n(this.sc_MapOps$$anon$1__f_$outer).knownSize__I();
});
$c_sc_MapOps$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return $n(this.sc_MapOps$$anon$1__f_$outer).valuesIterator__sc_Iterator();
});
var $d_sc_MapOps$$anon$1 = new $TypeData().initClass($c_sc_MapOps$$anon$1, "scala.collection.MapOps$$anon$1", ({
  sc_MapOps$$anon$1: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
function $f_sc_Set__equals__O__Z($thiz, that) {
  if (($thiz === that)) {
    return true;
  } else {
    if ($is_sc_Set(that)) {
      var x2 = $as_sc_Set(that);
      if (($n(x2), true)) {
        if (($thiz.size__I() === $n(x2).size__I())) {
          try {
            return $thiz.subsetOf__sc_Set__Z(x2);
          } catch (e) {
            if ((e instanceof $c_jl_ClassCastException)) {
              return false;
            } else {
              throw e;
            }
          }
        } else {
          return false;
        }
      }
    }
    return false;
  }
}
function $is_sc_Set(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Set)));
}
function $as_sc_Set(obj) {
  return (($is_sc_Set(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Set"));
}
function $isArrayOf_sc_Set(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Set)));
}
function $asArrayOf_sc_Set(obj, depth) {
  return (($isArrayOf_sc_Set(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Set;", depth));
}
function $f_sci_StrictOptimizedSetOps__concat__sc_IterableOnce__sci_SetOps($thiz, that) {
  var result = $as_sci_SetOps($thiz);
  var it = $n(that).iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var this$1 = $n(result);
    var elem = $n(it).next__O();
    result = this$1.incl__O__sci_SetOps(elem);
  }
  return result;
}
function $is_s_math_Numeric$BigDecimalAsIfIntegral(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_math_Numeric$BigDecimalAsIfIntegral)));
}
function $as_s_math_Numeric$BigDecimalAsIfIntegral(obj) {
  return (($is_s_math_Numeric$BigDecimalAsIfIntegral(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Numeric$BigDecimalAsIfIntegral"));
}
function $isArrayOf_s_math_Numeric$BigDecimalAsIfIntegral(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Numeric$BigDecimalAsIfIntegral)));
}
function $asArrayOf_s_math_Numeric$BigDecimalAsIfIntegral(obj, depth) {
  return (($isArrayOf_s_math_Numeric$BigDecimalAsIfIntegral(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Numeric$BigDecimalAsIfIntegral;", depth));
}
/** @constructor */
function $c_s_reflect_ManifestFactory$AnyManifest$() {
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Any";
}
$c_s_reflect_ManifestFactory$AnyManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$AnyManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$AnyManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$AnyManifest$() {
}
$h_s_reflect_ManifestFactory$AnyManifest$.prototype = $c_s_reflect_ManifestFactory$AnyManifest$.prototype;
$c_s_reflect_ManifestFactory$AnyManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_O.getClassOf();
});
$c_s_reflect_ManifestFactory$AnyManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len);
});
var $d_s_reflect_ManifestFactory$AnyManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$AnyManifest$, "scala.reflect.ManifestFactory$AnyManifest$", ({
  s_reflect_ManifestFactory$AnyManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
var $n_s_reflect_ManifestFactory$AnyManifest$;
function $m_s_reflect_ManifestFactory$AnyManifest$() {
  if ((!$n_s_reflect_ManifestFactory$AnyManifest$)) {
    $n_s_reflect_ManifestFactory$AnyManifest$ = new $c_s_reflect_ManifestFactory$AnyManifest$();
  }
  return $n_s_reflect_ManifestFactory$AnyManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$BooleanManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Boolean";
}
$c_s_reflect_ManifestFactory$BooleanManifest$.prototype = new $h_s_reflect_ManifestFactory$BooleanManifest();
$c_s_reflect_ManifestFactory$BooleanManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$BooleanManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$BooleanManifest$() {
}
$h_s_reflect_ManifestFactory$BooleanManifest$.prototype = $c_s_reflect_ManifestFactory$BooleanManifest$.prototype;
var $d_s_reflect_ManifestFactory$BooleanManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$BooleanManifest$, "scala.reflect.ManifestFactory$BooleanManifest$", ({
  s_reflect_ManifestFactory$BooleanManifest$: 1,
  s_reflect_ManifestFactory$BooleanManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
var $n_s_reflect_ManifestFactory$BooleanManifest$;
function $m_s_reflect_ManifestFactory$BooleanManifest$() {
  if ((!$n_s_reflect_ManifestFactory$BooleanManifest$)) {
    $n_s_reflect_ManifestFactory$BooleanManifest$ = new $c_s_reflect_ManifestFactory$BooleanManifest$();
  }
  return $n_s_reflect_ManifestFactory$BooleanManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$ByteManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Byte";
}
$c_s_reflect_ManifestFactory$ByteManifest$.prototype = new $h_s_reflect_ManifestFactory$ByteManifest();
$c_s_reflect_ManifestFactory$ByteManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$ByteManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ByteManifest$() {
}
$h_s_reflect_ManifestFactory$ByteManifest$.prototype = $c_s_reflect_ManifestFactory$ByteManifest$.prototype;
var $d_s_reflect_ManifestFactory$ByteManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$ByteManifest$, "scala.reflect.ManifestFactory$ByteManifest$", ({
  s_reflect_ManifestFactory$ByteManifest$: 1,
  s_reflect_ManifestFactory$ByteManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
var $n_s_reflect_ManifestFactory$ByteManifest$;
function $m_s_reflect_ManifestFactory$ByteManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ByteManifest$)) {
    $n_s_reflect_ManifestFactory$ByteManifest$ = new $c_s_reflect_ManifestFactory$ByteManifest$();
  }
  return $n_s_reflect_ManifestFactory$ByteManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$CharManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Char";
}
$c_s_reflect_ManifestFactory$CharManifest$.prototype = new $h_s_reflect_ManifestFactory$CharManifest();
$c_s_reflect_ManifestFactory$CharManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$CharManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$CharManifest$() {
}
$h_s_reflect_ManifestFactory$CharManifest$.prototype = $c_s_reflect_ManifestFactory$CharManifest$.prototype;
var $d_s_reflect_ManifestFactory$CharManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$CharManifest$, "scala.reflect.ManifestFactory$CharManifest$", ({
  s_reflect_ManifestFactory$CharManifest$: 1,
  s_reflect_ManifestFactory$CharManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
var $n_s_reflect_ManifestFactory$CharManifest$;
function $m_s_reflect_ManifestFactory$CharManifest$() {
  if ((!$n_s_reflect_ManifestFactory$CharManifest$)) {
    $n_s_reflect_ManifestFactory$CharManifest$ = new $c_s_reflect_ManifestFactory$CharManifest$();
  }
  return $n_s_reflect_ManifestFactory$CharManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$DoubleManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Double";
}
$c_s_reflect_ManifestFactory$DoubleManifest$.prototype = new $h_s_reflect_ManifestFactory$DoubleManifest();
$c_s_reflect_ManifestFactory$DoubleManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$DoubleManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$DoubleManifest$() {
}
$h_s_reflect_ManifestFactory$DoubleManifest$.prototype = $c_s_reflect_ManifestFactory$DoubleManifest$.prototype;
var $d_s_reflect_ManifestFactory$DoubleManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$DoubleManifest$, "scala.reflect.ManifestFactory$DoubleManifest$", ({
  s_reflect_ManifestFactory$DoubleManifest$: 1,
  s_reflect_ManifestFactory$DoubleManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
var $n_s_reflect_ManifestFactory$DoubleManifest$;
function $m_s_reflect_ManifestFactory$DoubleManifest$() {
  if ((!$n_s_reflect_ManifestFactory$DoubleManifest$)) {
    $n_s_reflect_ManifestFactory$DoubleManifest$ = new $c_s_reflect_ManifestFactory$DoubleManifest$();
  }
  return $n_s_reflect_ManifestFactory$DoubleManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$FloatManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Float";
}
$c_s_reflect_ManifestFactory$FloatManifest$.prototype = new $h_s_reflect_ManifestFactory$FloatManifest();
$c_s_reflect_ManifestFactory$FloatManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$FloatManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$FloatManifest$() {
}
$h_s_reflect_ManifestFactory$FloatManifest$.prototype = $c_s_reflect_ManifestFactory$FloatManifest$.prototype;
var $d_s_reflect_ManifestFactory$FloatManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$FloatManifest$, "scala.reflect.ManifestFactory$FloatManifest$", ({
  s_reflect_ManifestFactory$FloatManifest$: 1,
  s_reflect_ManifestFactory$FloatManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
var $n_s_reflect_ManifestFactory$FloatManifest$;
function $m_s_reflect_ManifestFactory$FloatManifest$() {
  if ((!$n_s_reflect_ManifestFactory$FloatManifest$)) {
    $n_s_reflect_ManifestFactory$FloatManifest$ = new $c_s_reflect_ManifestFactory$FloatManifest$();
  }
  return $n_s_reflect_ManifestFactory$FloatManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$IntManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Int";
}
$c_s_reflect_ManifestFactory$IntManifest$.prototype = new $h_s_reflect_ManifestFactory$IntManifest();
$c_s_reflect_ManifestFactory$IntManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$IntManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$IntManifest$() {
}
$h_s_reflect_ManifestFactory$IntManifest$.prototype = $c_s_reflect_ManifestFactory$IntManifest$.prototype;
var $d_s_reflect_ManifestFactory$IntManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$IntManifest$, "scala.reflect.ManifestFactory$IntManifest$", ({
  s_reflect_ManifestFactory$IntManifest$: 1,
  s_reflect_ManifestFactory$IntManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
var $n_s_reflect_ManifestFactory$IntManifest$;
function $m_s_reflect_ManifestFactory$IntManifest$() {
  if ((!$n_s_reflect_ManifestFactory$IntManifest$)) {
    $n_s_reflect_ManifestFactory$IntManifest$ = new $c_s_reflect_ManifestFactory$IntManifest$();
  }
  return $n_s_reflect_ManifestFactory$IntManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$LongManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Long";
}
$c_s_reflect_ManifestFactory$LongManifest$.prototype = new $h_s_reflect_ManifestFactory$LongManifest();
$c_s_reflect_ManifestFactory$LongManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$LongManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$LongManifest$() {
}
$h_s_reflect_ManifestFactory$LongManifest$.prototype = $c_s_reflect_ManifestFactory$LongManifest$.prototype;
var $d_s_reflect_ManifestFactory$LongManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$LongManifest$, "scala.reflect.ManifestFactory$LongManifest$", ({
  s_reflect_ManifestFactory$LongManifest$: 1,
  s_reflect_ManifestFactory$LongManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
var $n_s_reflect_ManifestFactory$LongManifest$;
function $m_s_reflect_ManifestFactory$LongManifest$() {
  if ((!$n_s_reflect_ManifestFactory$LongManifest$)) {
    $n_s_reflect_ManifestFactory$LongManifest$ = new $c_s_reflect_ManifestFactory$LongManifest$();
  }
  return $n_s_reflect_ManifestFactory$LongManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$NothingManifest$() {
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Nothing";
}
$c_s_reflect_ManifestFactory$NothingManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$NothingManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$NothingManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$NothingManifest$() {
}
$h_s_reflect_ManifestFactory$NothingManifest$.prototype = $c_s_reflect_ManifestFactory$NothingManifest$.prototype;
$c_s_reflect_ManifestFactory$NothingManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_sr_Nothing$.getClassOf();
});
$c_s_reflect_ManifestFactory$NothingManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len);
});
var $d_s_reflect_ManifestFactory$NothingManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$NothingManifest$, "scala.reflect.ManifestFactory$NothingManifest$", ({
  s_reflect_ManifestFactory$NothingManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
var $n_s_reflect_ManifestFactory$NothingManifest$;
function $m_s_reflect_ManifestFactory$NothingManifest$() {
  if ((!$n_s_reflect_ManifestFactory$NothingManifest$)) {
    $n_s_reflect_ManifestFactory$NothingManifest$ = new $c_s_reflect_ManifestFactory$NothingManifest$();
  }
  return $n_s_reflect_ManifestFactory$NothingManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$NullManifest$() {
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Null";
}
$c_s_reflect_ManifestFactory$NullManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$NullManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$NullManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$NullManifest$() {
}
$h_s_reflect_ManifestFactory$NullManifest$.prototype = $c_s_reflect_ManifestFactory$NullManifest$.prototype;
$c_s_reflect_ManifestFactory$NullManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_sr_Null$.getClassOf();
});
$c_s_reflect_ManifestFactory$NullManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len);
});
var $d_s_reflect_ManifestFactory$NullManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$NullManifest$, "scala.reflect.ManifestFactory$NullManifest$", ({
  s_reflect_ManifestFactory$NullManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
var $n_s_reflect_ManifestFactory$NullManifest$;
function $m_s_reflect_ManifestFactory$NullManifest$() {
  if ((!$n_s_reflect_ManifestFactory$NullManifest$)) {
    $n_s_reflect_ManifestFactory$NullManifest$ = new $c_s_reflect_ManifestFactory$NullManifest$();
  }
  return $n_s_reflect_ManifestFactory$NullManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$ObjectManifest$() {
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Object";
}
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$ObjectManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ObjectManifest$() {
}
$h_s_reflect_ManifestFactory$ObjectManifest$.prototype = $c_s_reflect_ManifestFactory$ObjectManifest$.prototype;
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_O.getClassOf();
});
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len);
});
var $d_s_reflect_ManifestFactory$ObjectManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$ObjectManifest$, "scala.reflect.ManifestFactory$ObjectManifest$", ({
  s_reflect_ManifestFactory$ObjectManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
var $n_s_reflect_ManifestFactory$ObjectManifest$;
function $m_s_reflect_ManifestFactory$ObjectManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ObjectManifest$)) {
    $n_s_reflect_ManifestFactory$ObjectManifest$ = new $c_s_reflect_ManifestFactory$ObjectManifest$();
  }
  return $n_s_reflect_ManifestFactory$ObjectManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$ShortManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Short";
}
$c_s_reflect_ManifestFactory$ShortManifest$.prototype = new $h_s_reflect_ManifestFactory$ShortManifest();
$c_s_reflect_ManifestFactory$ShortManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$ShortManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ShortManifest$() {
}
$h_s_reflect_ManifestFactory$ShortManifest$.prototype = $c_s_reflect_ManifestFactory$ShortManifest$.prototype;
var $d_s_reflect_ManifestFactory$ShortManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$ShortManifest$, "scala.reflect.ManifestFactory$ShortManifest$", ({
  s_reflect_ManifestFactory$ShortManifest$: 1,
  s_reflect_ManifestFactory$ShortManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
var $n_s_reflect_ManifestFactory$ShortManifest$;
function $m_s_reflect_ManifestFactory$ShortManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ShortManifest$)) {
    $n_s_reflect_ManifestFactory$ShortManifest$ = new $c_s_reflect_ManifestFactory$ShortManifest$();
  }
  return $n_s_reflect_ManifestFactory$ShortManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$UnitManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Unit";
}
$c_s_reflect_ManifestFactory$UnitManifest$.prototype = new $h_s_reflect_ManifestFactory$UnitManifest();
$c_s_reflect_ManifestFactory$UnitManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$UnitManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$UnitManifest$() {
}
$h_s_reflect_ManifestFactory$UnitManifest$.prototype = $c_s_reflect_ManifestFactory$UnitManifest$.prototype;
var $d_s_reflect_ManifestFactory$UnitManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$UnitManifest$, "scala.reflect.ManifestFactory$UnitManifest$", ({
  s_reflect_ManifestFactory$UnitManifest$: 1,
  s_reflect_ManifestFactory$UnitManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
var $n_s_reflect_ManifestFactory$UnitManifest$;
function $m_s_reflect_ManifestFactory$UnitManifest$() {
  if ((!$n_s_reflect_ManifestFactory$UnitManifest$)) {
    $n_s_reflect_ManifestFactory$UnitManifest$ = new $c_s_reflect_ManifestFactory$UnitManifest$();
  }
  return $n_s_reflect_ManifestFactory$UnitManifest$;
}
/** @constructor */
function $c_sr_RichInt(self) {
  this.sr_RichInt__f_self = 0;
  this.sr_RichInt__f_self = self;
}
$c_sr_RichInt.prototype = new $h_O();
$c_sr_RichInt.prototype.constructor = $c_sr_RichInt;
/** @constructor */
function $h_sr_RichInt() {
}
$h_sr_RichInt.prototype = $c_sr_RichInt.prototype;
$c_sr_RichInt.prototype.compare__O__I = (function(y) {
  $m_s_math_Ordering$Int$();
  var x = this.sr_RichInt__f_self;
  var y$1 = $uI(y);
  return ((x === y$1) ? 0 : ((x < y$1) ? (-1) : 1));
});
$c_sr_RichInt.prototype.compareTo__O__I = (function(that) {
  $m_s_math_Ordering$Int$();
  var x = this.sr_RichInt__f_self;
  var y = $uI(that);
  return ((x === y) ? 0 : ((x < y) ? (-1) : 1));
});
$c_sr_RichInt.prototype.toString__T = (function() {
  return $f_s_Proxy__toString__T(this);
});
$c_sr_RichInt.prototype.isValidByte__Z = (function() {
  return $f_s_math_ScalaNumericAnyConversions__isValidByte__Z(this);
});
$c_sr_RichInt.prototype.isValidShort__Z = (function() {
  return $f_s_math_ScalaNumericAnyConversions__isValidShort__Z(this);
});
$c_sr_RichInt.prototype.isValidChar__Z = (function() {
  return $f_s_math_ScalaNumericAnyConversions__isValidChar__Z(this);
});
$c_sr_RichInt.prototype.doubleValue__D = (function() {
  var this$ = this.sr_RichInt__f_self;
  return this$;
});
$c_sr_RichInt.prototype.floatValue__F = (function() {
  var this$ = this.sr_RichInt__f_self;
  return Math.fround(this$);
});
$c_sr_RichInt.prototype.longValue__J = (function() {
  var this$ = this.sr_RichInt__f_self;
  var hi = (this$ >> 31);
  return new $c_RTLong(this$, hi);
});
$c_sr_RichInt.prototype.intValue__I = (function() {
  var this$ = this.sr_RichInt__f_self;
  return this$;
});
$c_sr_RichInt.prototype.byteValue__B = (function() {
  var this$ = this.sr_RichInt__f_self;
  return ((this$ << 24) >> 24);
});
$c_sr_RichInt.prototype.shortValue__S = (function() {
  var this$ = this.sr_RichInt__f_self;
  return ((this$ << 16) >> 16);
});
$c_sr_RichInt.prototype.isWhole__Z = (function() {
  return true;
});
$c_sr_RichInt.prototype.isValidInt__Z = (function() {
  return true;
});
$c_sr_RichInt.prototype.hashCode__I = (function() {
  var this$ = this.sr_RichInt__f_self;
  return this$;
});
$c_sr_RichInt.prototype.equals__O__Z = (function(x$1) {
  return $m_sr_RichInt$().equals$extension__I__O__Z(this.sr_RichInt__f_self, x$1);
});
$c_sr_RichInt.prototype.self__O = (function() {
  return this.sr_RichInt__f_self;
});
function $as_sr_RichInt(obj) {
  return (((obj instanceof $c_sr_RichInt) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.runtime.RichInt"));
}
function $isArrayOf_sr_RichInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sr_RichInt)));
}
function $asArrayOf_sr_RichInt(obj, depth) {
  return (($isArrayOf_sr_RichInt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.runtime.RichInt;", depth));
}
var $d_sr_RichInt = new $TypeData().initClass($c_sr_RichInt, "scala.runtime.RichInt", ({
  sr_RichInt: 1,
  sr_ScalaNumberProxy: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_Proxy$Typed: 1,
  s_Proxy: 1,
  sr_OrderedProxy: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1,
  sr_RangedProxy: 1
}));
function $f_Lcats_ApplicativeError__handleError__O__F1__O($thiz, fa, f) {
  return $thiz.handleErrorWith__O__F1__O(fa, $n(f).andThen__F1__F1(new $c_sjsr_AnonFunction1(((x) => $thiz.pure__O__O(x)))));
}
function $f_Lcats_ApplicativeError__voidError__O__O($thiz, fu) {
  return $thiz.handleError__O__F1__O(fu, new $c_sjsr_AnonFunction1(((y) => (void 0))));
}
function $f_Lcats_ApplicativeError__attempt__O__O($thiz, fa) {
  return $thiz.handleErrorWith__O__F1__O($thiz.map__O__F1__O(fa, new $c_sjsr_AnonFunction1(((_$2) => new $c_s_util_Right(_$2)))), new $c_sjsr_AnonFunction1(((e) => $thiz.pure__O__O(new $c_s_util_Left(e)))));
}
function $f_Lcats_ApplicativeError__onError__O__s_PartialFunction__O($thiz, fa, pf) {
  return $thiz.handleErrorWith__O__F1__O(fa, new $c_sjsr_AnonFunction1(((e) => $n($n(pf).andThen__F1__s_PartialFunction(new $c_sjsr_AnonFunction1(((_$6) => $thiz.map2__O__O__F2__O(_$6, $thiz.raiseError__O__O(e), new $c_sjsr_AnonFunction2(((_$7, b) => {
    $as_jl_Void(_$7);
    return b;
  }))))))).applyOrElse__O__F1__O(e, new $c_sjsr_AnonFunction1(((e$3) => $thiz.raiseError__O__O(e$3)))))));
}
/** @constructor */
function $c_Lcats_data_AndThenInstances0$$anon$1() {
  $m_Lcats_instances_package$all$();
}
$c_Lcats_data_AndThenInstances0$$anon$1.prototype = new $h_O();
$c_Lcats_data_AndThenInstances0$$anon$1.prototype.constructor = $c_Lcats_data_AndThenInstances0$$anon$1;
/** @constructor */
function $h_Lcats_data_AndThenInstances0$$anon$1() {
}
$h_Lcats_data_AndThenInstances0$$anon$1.prototype = $c_Lcats_data_AndThenInstances0$$anon$1.prototype;
$c_Lcats_data_AndThenInstances0$$anon$1.prototype.id__O = (function() {
  return $f_Lcats_arrow_Arrow__id__O(this);
});
$c_Lcats_data_AndThenInstances0$$anon$1.prototype.lift__F1__O = (function(f) {
  return $m_Lcats_data_AndThen$().apply__F1__Lcats_data_AndThen(f);
});
$c_Lcats_data_AndThenInstances0$$anon$1.prototype.compose__O__O__O = (function(f, g) {
  var f$1 = $as_Lcats_data_AndThen(f);
  var g$1 = $as_Lcats_data_AndThen(g);
  return $m_Lcats_data_AndThen$().andThen__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen(g$1, f$1);
});
var $d_Lcats_data_AndThenInstances0$$anon$1 = new $TypeData().initClass($c_Lcats_data_AndThenInstances0$$anon$1, "cats.data.AndThenInstances0$$anon$1", ({
  Lcats_data_AndThenInstances0$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_Compose: 1,
  Lcats_arrow_Category: 1,
  Lcats_arrow_Profunctor: 1,
  Lcats_arrow_Strong: 1,
  Lcats_arrow_Arrow: 1,
  Lcats_arrow_Choice: 1,
  Lcats_arrow_ArrowChoice: 1,
  Lcats_arrow_CommutativeArrow: 1
}));
/** @constructor */
function $c_Lcats_data_KleisliInstances0\uff3f5() {
}
$c_Lcats_data_KleisliInstances0\uff3f5.prototype = new $h_Lcats_data_KleisliInstances1();
$c_Lcats_data_KleisliInstances0\uff3f5.prototype.constructor = $c_Lcats_data_KleisliInstances0\uff3f5;
/** @constructor */
function $h_Lcats_data_KleisliInstances0\uff3f5() {
}
$h_Lcats_data_KleisliInstances0\uff3f5.prototype = $c_Lcats_data_KleisliInstances0\uff3f5.prototype;
/** @constructor */
function $c_Lcats_instances_Function1Instances$$anon$6() {
}
$c_Lcats_instances_Function1Instances$$anon$6.prototype = new $h_O();
$c_Lcats_instances_Function1Instances$$anon$6.prototype.constructor = $c_Lcats_instances_Function1Instances$$anon$6;
/** @constructor */
function $h_Lcats_instances_Function1Instances$$anon$6() {
}
$h_Lcats_instances_Function1Instances$$anon$6.prototype = $c_Lcats_instances_Function1Instances$$anon$6.prototype;
$c_Lcats_instances_Function1Instances$$anon$6.prototype.id__O = (function() {
  return $f_Lcats_arrow_Arrow__id__O(this);
});
$c_Lcats_instances_Function1Instances$$anon$6.prototype.lift__F1__O = (function(f) {
  return f;
});
$c_Lcats_instances_Function1Instances$$anon$6.prototype.compose__O__O__O = (function(f, g) {
  var f$1 = $as_F1(f);
  var g$1 = $as_F1(g);
  return $n(f$1).compose__F1__F1(g$1);
});
var $d_Lcats_instances_Function1Instances$$anon$6 = new $TypeData().initClass($c_Lcats_instances_Function1Instances$$anon$6, "cats.instances.Function1Instances$$anon$6", ({
  Lcats_instances_Function1Instances$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_Compose: 1,
  Lcats_arrow_Category: 1,
  Lcats_arrow_Profunctor: 1,
  Lcats_arrow_Strong: 1,
  Lcats_arrow_Arrow: 1,
  Lcats_arrow_Choice: 1,
  Lcats_arrow_ArrowChoice: 1,
  Lcats_arrow_CommutativeArrow: 1
}));
/** @constructor */
function $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$2(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg__Ldev_sungkm_enchantedrealm_EnchantedRealm__(this, $n(outer).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_$outer);
}
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$2.prototype = new $h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg();
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$2.prototype.constructor = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$2;
/** @constructor */
function $h_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$2() {
}
$h_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$2.prototype = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$2.prototype;
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$2.prototype.productArity__I = (function() {
  return 0;
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$2.prototype.productPrefix__T = (function() {
  return "NoOp";
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$2.prototype.toString__T = (function() {
  return "NoOp";
});
var $d_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$2 = new $TypeData().initClass($c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$2, "dev.sungkm.enchantedrealm.EnchantedRealm$$anon$2", ({
  Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$2: 1,
  Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$3(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg__Ldev_sungkm_enchantedrealm_EnchantedRealm__(this, $n(outer).Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg$__f_$outer);
}
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$3.prototype = new $h_Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg();
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$3.prototype.constructor = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$3;
/** @constructor */
function $h_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$3() {
}
$h_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$3.prototype = $c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$3.prototype;
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$3.prototype.productArity__I = (function() {
  return 0;
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$3.prototype.productPrefix__T = (function() {
  return "FinishEngineResponse";
});
$c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$3.prototype.toString__T = (function() {
  return "FinishEngineResponse";
});
var $d_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$3 = new $TypeData().initClass($c_Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$3, "dev.sungkm.enchantedrealm.EnchantedRealm$$anon$3", ({
  Ldev_sungkm_enchantedrealm_EnchantedRealm$$anon$3: 1,
  Ldev_sungkm_enchantedrealm_EnchantedRealm$Msg: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_BlockDirectives$SeparatorInstance(parsedResult, source, options) {
  this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_typeName = null;
  this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_parsedResult = null;
  this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_source = null;
  this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_options = null;
  this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_unresolvedMessage$lzy4 = null;
  this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_unresolvedMessagebitmap$4 = false;
  this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_parsedResult = parsedResult;
  this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_source = source;
  this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_options = options;
  this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_typeName = "separator";
}
$c_Llaika_api_bundle_BlockDirectives$SeparatorInstance.prototype = new $h_Llaika_ast_Element();
$c_Llaika_api_bundle_BlockDirectives$SeparatorInstance.prototype.constructor = $c_Llaika_api_bundle_BlockDirectives$SeparatorInstance;
/** @constructor */
function $h_Llaika_api_bundle_BlockDirectives$SeparatorInstance() {
}
$h_Llaika_api_bundle_BlockDirectives$SeparatorInstance.prototype = $c_Llaika_api_bundle_BlockDirectives$SeparatorInstance.prototype;
$c_Llaika_api_bundle_BlockDirectives$SeparatorInstance.prototype.typeName__T = (function() {
  return this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_typeName;
});
$c_Llaika_api_bundle_BlockDirectives$SeparatorInstance.prototype.runsIn__Llaika_ast_RewritePhase__Z = (function(phase) {
  return true;
});
$c_Llaika_api_bundle_BlockDirectives$SeparatorInstance.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_bundle_BlockDirectives$SeparatorInstance.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_bundle_BlockDirectives$SeparatorInstance)) {
    var x$0$2 = $as_Llaika_api_bundle_BlockDirectives$SeparatorInstance(x$0);
    var x = this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_parsedResult;
    var x$2 = $n(x$0$2).Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_parsedResult;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_source;
      var x$4 = $n(x$0$2).Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_source;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_options;
      var x$6 = $n(x$0$2).Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_options;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_bundle_BlockDirectives$SeparatorInstance.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_bundle_BlockDirectives$SeparatorInstance.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_api_bundle_BlockDirectives$SeparatorInstance.prototype.productPrefix__T = (function() {
  return "SeparatorInstance";
});
$c_Llaika_api_bundle_BlockDirectives$SeparatorInstance.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_parsedResult;
      break;
    }
    case 1: {
      return this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_source;
      break;
    }
    case 2: {
      return this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_api_bundle_BlockDirectives$SeparatorInstance.prototype.parsedResult__Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective = (function() {
  return this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_parsedResult;
});
$c_Llaika_api_bundle_BlockDirectives$SeparatorInstance.prototype.source__Llaika_parse_SourceFragment = (function() {
  return this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_source;
});
$c_Llaika_api_bundle_BlockDirectives$SeparatorInstance.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_options;
});
$c_Llaika_api_bundle_BlockDirectives$SeparatorInstance.prototype.resolve__Llaika_ast_DocumentCursor__Llaika_ast_Block = (function(cursor) {
  return $m_Llaika_ast_InvalidBlock$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidBlock((("Orphaned separator directive with name '" + $n(this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_parsedResult).Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_name) + "'"), this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_source);
});
$c_Llaika_api_bundle_BlockDirectives$SeparatorInstance.prototype.unresolvedMessage__T = (function() {
  if ((!this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_unresolvedMessagebitmap$4)) {
    this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_unresolvedMessage$lzy4 = (("Unresolved separator directive instance with name '" + $n(this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_parsedResult).Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_name) + "'");
    this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_unresolvedMessagebitmap$4 = true;
  }
  return this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_unresolvedMessage$lzy4;
});
$c_Llaika_api_bundle_BlockDirectives$SeparatorInstance.prototype.laika$api$bundle$DirectiveBuilderContext$DirectiveProcessor$$$outer__Llaika_api_bundle_DirectiveBuilderContext = (function() {
  return $m_Llaika_api_bundle_BlockDirectives$();
});
$c_Llaika_api_bundle_BlockDirectives$SeparatorInstance.prototype.laika$api$bundle$DirectiveBuilderContext$SeparatorInstanceBase$$$outer__Llaika_api_bundle_DirectiveBuilderContext = (function() {
  return $m_Llaika_api_bundle_BlockDirectives$();
});
$c_Llaika_api_bundle_BlockDirectives$SeparatorInstance.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var parsedResult = this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_parsedResult;
  var source = this.Llaika_api_bundle_BlockDirectives$SeparatorInstance__f_source;
  return new $c_Llaika_api_bundle_BlockDirectives$SeparatorInstance(parsedResult, source, options);
});
function $as_Llaika_api_bundle_BlockDirectives$SeparatorInstance(obj) {
  return (((obj instanceof $c_Llaika_api_bundle_BlockDirectives$SeparatorInstance) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.BlockDirectives$SeparatorInstance"));
}
function $isArrayOf_Llaika_api_bundle_BlockDirectives$SeparatorInstance(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_BlockDirectives$SeparatorInstance)));
}
function $asArrayOf_Llaika_api_bundle_BlockDirectives$SeparatorInstance(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_BlockDirectives$SeparatorInstance(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.BlockDirectives$SeparatorInstance;", depth));
}
var $d_Llaika_api_bundle_BlockDirectives$SeparatorInstance = new $TypeData().initClass($c_Llaika_api_bundle_BlockDirectives$SeparatorInstance, "laika.api.bundle.BlockDirectives$SeparatorInstance", ({
  Llaika_api_bundle_BlockDirectives$SeparatorInstance: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1,
  Llaika_api_bundle_DirectiveBuilderContext$DirectiveProcessor: 1,
  Llaika_api_bundle_DirectiveBuilderContext$SeparatorInstanceBase: 1,
  Llaika_ast_Unresolved: 1,
  Llaika_ast_BlockResolver: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_SpanDirectives$SeparatorInstance(parsedResult, source, options) {
  this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_typeName = null;
  this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_parsedResult = null;
  this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_source = null;
  this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_options = null;
  this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_unresolvedMessage$lzy2 = null;
  this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_unresolvedMessagebitmap$2 = false;
  this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_parsedResult = parsedResult;
  this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_source = source;
  this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_options = options;
  this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_typeName = "separator";
}
$c_Llaika_api_bundle_SpanDirectives$SeparatorInstance.prototype = new $h_Llaika_ast_Element();
$c_Llaika_api_bundle_SpanDirectives$SeparatorInstance.prototype.constructor = $c_Llaika_api_bundle_SpanDirectives$SeparatorInstance;
/** @constructor */
function $h_Llaika_api_bundle_SpanDirectives$SeparatorInstance() {
}
$h_Llaika_api_bundle_SpanDirectives$SeparatorInstance.prototype = $c_Llaika_api_bundle_SpanDirectives$SeparatorInstance.prototype;
$c_Llaika_api_bundle_SpanDirectives$SeparatorInstance.prototype.typeName__T = (function() {
  return this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_typeName;
});
$c_Llaika_api_bundle_SpanDirectives$SeparatorInstance.prototype.runsIn__Llaika_ast_RewritePhase__Z = (function(phase) {
  return true;
});
$c_Llaika_api_bundle_SpanDirectives$SeparatorInstance.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_bundle_SpanDirectives$SeparatorInstance.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_bundle_SpanDirectives$SeparatorInstance)) {
    var x$0$2 = $as_Llaika_api_bundle_SpanDirectives$SeparatorInstance(x$0);
    var x = this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_parsedResult;
    var x$2 = $n(x$0$2).Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_parsedResult;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_source;
      var x$4 = $n(x$0$2).Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_source;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_options;
      var x$6 = $n(x$0$2).Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_options;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_bundle_SpanDirectives$SeparatorInstance.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_bundle_SpanDirectives$SeparatorInstance.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_api_bundle_SpanDirectives$SeparatorInstance.prototype.productPrefix__T = (function() {
  return "SeparatorInstance";
});
$c_Llaika_api_bundle_SpanDirectives$SeparatorInstance.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_parsedResult;
      break;
    }
    case 1: {
      return this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_source;
      break;
    }
    case 2: {
      return this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_api_bundle_SpanDirectives$SeparatorInstance.prototype.parsedResult__Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective = (function() {
  return this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_parsedResult;
});
$c_Llaika_api_bundle_SpanDirectives$SeparatorInstance.prototype.source__Llaika_parse_SourceFragment = (function() {
  return this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_source;
});
$c_Llaika_api_bundle_SpanDirectives$SeparatorInstance.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_options;
});
$c_Llaika_api_bundle_SpanDirectives$SeparatorInstance.prototype.resolve__Llaika_ast_DocumentCursor__Llaika_ast_Span = (function(cursor) {
  return $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan((("Orphaned separator directive with name '" + $n(this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_parsedResult).Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_name) + "'"), this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_source);
});
$c_Llaika_api_bundle_SpanDirectives$SeparatorInstance.prototype.unresolvedMessage__T = (function() {
  if ((!this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_unresolvedMessagebitmap$2)) {
    this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_unresolvedMessage$lzy2 = (("Unresolved separator directive instance with name '" + $n(this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_parsedResult).Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_name) + "'");
    this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_unresolvedMessagebitmap$2 = true;
  }
  return this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_unresolvedMessage$lzy2;
});
$c_Llaika_api_bundle_SpanDirectives$SeparatorInstance.prototype.laika$api$bundle$DirectiveBuilderContext$DirectiveProcessor$$$outer__Llaika_api_bundle_DirectiveBuilderContext = (function() {
  return $m_Llaika_api_bundle_SpanDirectives$();
});
$c_Llaika_api_bundle_SpanDirectives$SeparatorInstance.prototype.laika$api$bundle$DirectiveBuilderContext$SeparatorInstanceBase$$$outer__Llaika_api_bundle_DirectiveBuilderContext = (function() {
  return $m_Llaika_api_bundle_SpanDirectives$();
});
$c_Llaika_api_bundle_SpanDirectives$SeparatorInstance.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var parsedResult = this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_parsedResult;
  var source = this.Llaika_api_bundle_SpanDirectives$SeparatorInstance__f_source;
  return new $c_Llaika_api_bundle_SpanDirectives$SeparatorInstance(parsedResult, source, options);
});
function $as_Llaika_api_bundle_SpanDirectives$SeparatorInstance(obj) {
  return (((obj instanceof $c_Llaika_api_bundle_SpanDirectives$SeparatorInstance) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.SpanDirectives$SeparatorInstance"));
}
function $isArrayOf_Llaika_api_bundle_SpanDirectives$SeparatorInstance(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_SpanDirectives$SeparatorInstance)));
}
function $asArrayOf_Llaika_api_bundle_SpanDirectives$SeparatorInstance(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_SpanDirectives$SeparatorInstance(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.SpanDirectives$SeparatorInstance;", depth));
}
var $d_Llaika_api_bundle_SpanDirectives$SeparatorInstance = new $TypeData().initClass($c_Llaika_api_bundle_SpanDirectives$SeparatorInstance, "laika.api.bundle.SpanDirectives$SeparatorInstance", ({
  Llaika_api_bundle_SpanDirectives$SeparatorInstance: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_api_bundle_DirectiveBuilderContext$DirectiveProcessor: 1,
  Llaika_api_bundle_DirectiveBuilderContext$SeparatorInstanceBase: 1,
  Llaika_ast_Unresolved: 1,
  Llaika_ast_SpanResolver: 1
}));
/** @constructor */
function $c_Llaika_ast_CellType$BodyCell$() {
}
$c_Llaika_ast_CellType$BodyCell$.prototype = new $h_Llaika_ast_CellType();
$c_Llaika_ast_CellType$BodyCell$.prototype.constructor = $c_Llaika_ast_CellType$BodyCell$;
/** @constructor */
function $h_Llaika_ast_CellType$BodyCell$() {
}
$h_Llaika_ast_CellType$BodyCell$.prototype = $c_Llaika_ast_CellType$BodyCell$.prototype;
$c_Llaika_ast_CellType$BodyCell$.prototype.createSpanContainer__sci_Seq__O = (function(spans) {
  return $f_Llaika_ast_BlockContainerCompanion__createSpanContainer__sci_Seq__O(this, spans);
});
$c_Llaika_ast_CellType$BodyCell$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_CellType$BodyCell$.prototype.hashCode__I = (function() {
  return 1766783556;
});
$c_Llaika_ast_CellType$BodyCell$.prototype.toString__T = (function() {
  return "BodyCell";
});
$c_Llaika_ast_CellType$BodyCell$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_ast_CellType$BodyCell$.prototype.productPrefix__T = (function() {
  return "BodyCell";
});
$c_Llaika_ast_CellType$BodyCell$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_CellType$BodyCell$.prototype.createBlockContainer__sci_Seq__O = (function(blocks) {
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  return new $c_Llaika_ast_Cell(this, blocks, 1, 1, options);
});
var $d_Llaika_ast_CellType$BodyCell$ = new $TypeData().initClass($c_Llaika_ast_CellType$BodyCell$, "laika.ast.CellType$BodyCell$", ({
  Llaika_ast_CellType$BodyCell$: 1,
  Llaika_ast_CellType: 1,
  Llaika_ast_SpanContainerCompanion: 1,
  Llaika_ast_BlockContainerCompanion: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_ast_CellType$BodyCell$;
function $m_Llaika_ast_CellType$BodyCell$() {
  if ((!$n_Llaika_ast_CellType$BodyCell$)) {
    $n_Llaika_ast_CellType$BodyCell$ = new $c_Llaika_ast_CellType$BodyCell$();
  }
  return $n_Llaika_ast_CellType$BodyCell$;
}
/** @constructor */
function $c_Llaika_ast_CellType$HeadCell$() {
}
$c_Llaika_ast_CellType$HeadCell$.prototype = new $h_Llaika_ast_CellType();
$c_Llaika_ast_CellType$HeadCell$.prototype.constructor = $c_Llaika_ast_CellType$HeadCell$;
/** @constructor */
function $h_Llaika_ast_CellType$HeadCell$() {
}
$h_Llaika_ast_CellType$HeadCell$.prototype = $c_Llaika_ast_CellType$HeadCell$.prototype;
$c_Llaika_ast_CellType$HeadCell$.prototype.createSpanContainer__sci_Seq__O = (function(spans) {
  return $f_Llaika_ast_BlockContainerCompanion__createSpanContainer__sci_Seq__O(this, spans);
});
$c_Llaika_ast_CellType$HeadCell$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_CellType$HeadCell$.prototype.hashCode__I = (function() {
  return (-1051639934);
});
$c_Llaika_ast_CellType$HeadCell$.prototype.toString__T = (function() {
  return "HeadCell";
});
$c_Llaika_ast_CellType$HeadCell$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_ast_CellType$HeadCell$.prototype.productPrefix__T = (function() {
  return "HeadCell";
});
$c_Llaika_ast_CellType$HeadCell$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_CellType$HeadCell$.prototype.createBlockContainer__sci_Seq__O = (function(blocks) {
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  return new $c_Llaika_ast_Cell(this, blocks, 1, 1, options);
});
var $d_Llaika_ast_CellType$HeadCell$ = new $TypeData().initClass($c_Llaika_ast_CellType$HeadCell$, "laika.ast.CellType$HeadCell$", ({
  Llaika_ast_CellType$HeadCell$: 1,
  Llaika_ast_CellType: 1,
  Llaika_ast_SpanContainerCompanion: 1,
  Llaika_ast_BlockContainerCompanion: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_ast_CellType$HeadCell$;
function $m_Llaika_ast_CellType$HeadCell$() {
  if ((!$n_Llaika_ast_CellType$HeadCell$)) {
    $n_Llaika_ast_CellType$HeadCell$ = new $c_Llaika_ast_CellType$HeadCell$();
  }
  return $n_Llaika_ast_CellType$HeadCell$;
}
/** @constructor */
function $c_Llaika_ast_Choice(name, label, content, options) {
  this.Llaika_ast_Choice__f_name = null;
  this.Llaika_ast_Choice__f_label = null;
  this.Llaika_ast_Choice__f_content = null;
  this.Llaika_ast_Choice__f_options = null;
  this.Llaika_ast_Choice__f_name = name;
  this.Llaika_ast_Choice__f_label = label;
  this.Llaika_ast_Choice__f_content = content;
  this.Llaika_ast_Choice__f_options = options;
}
$c_Llaika_ast_Choice.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_Choice.prototype.constructor = $c_Llaika_ast_Choice;
/** @constructor */
function $h_Llaika_ast_Choice() {
}
$h_Llaika_ast_Choice.prototype = $c_Llaika_ast_Choice.prototype;
$c_Llaika_ast_Choice.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_Choice.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_Choice.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_Choice)) {
    var x$0$2 = $as_Llaika_ast_Choice(x$0);
    if (((this.Llaika_ast_Choice__f_name === $n(x$0$2).Llaika_ast_Choice__f_name) && (this.Llaika_ast_Choice__f_label === $n(x$0$2).Llaika_ast_Choice__f_label))) {
      var x = this.Llaika_ast_Choice__f_content;
      var x$2 = $n(x$0$2).Llaika_ast_Choice__f_content;
      var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Llaika_ast_Choice__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_Choice__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_Choice.prototype.productArity__I = (function() {
  return 4;
});
$c_Llaika_ast_Choice.prototype.productPrefix__T = (function() {
  return "Choice";
});
$c_Llaika_ast_Choice.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_Choice__f_name;
      break;
    }
    case 1: {
      return this.Llaika_ast_Choice__f_label;
      break;
    }
    case 2: {
      return this.Llaika_ast_Choice__f_content;
      break;
    }
    case 3: {
      return this.Llaika_ast_Choice__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_Choice.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_Choice__f_content;
});
$c_Llaika_ast_Choice.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_Choice__f_options;
});
$c_Llaika_ast_Choice.prototype.content__O = (function() {
  return this.Llaika_ast_Choice__f_content;
});
$c_Llaika_ast_Choice.prototype.withContent__sci_Seq__Llaika_ast_BlockContainer = (function(newContent) {
  var name = this.Llaika_ast_Choice__f_name;
  var label = this.Llaika_ast_Choice__f_label;
  var options = this.Llaika_ast_Choice__f_options;
  return new $c_Llaika_ast_Choice(name, label, newContent, options);
});
$c_Llaika_ast_Choice.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var name = this.Llaika_ast_Choice__f_name;
  var label = this.Llaika_ast_Choice__f_label;
  var content = this.Llaika_ast_Choice__f_content;
  return new $c_Llaika_ast_Choice(name, label, content, options);
});
$c_Llaika_ast_Choice.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return $f_Llaika_ast_BlockContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_BlockContainer(this, rules);
});
function $as_Llaika_ast_Choice(obj) {
  return (((obj instanceof $c_Llaika_ast_Choice) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Choice"));
}
function $isArrayOf_Llaika_ast_Choice(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Choice)));
}
function $asArrayOf_Llaika_ast_Choice(obj, depth) {
  return (($isArrayOf_Llaika_ast_Choice(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Choice;", depth));
}
var $d_Llaika_ast_Choice = new $TypeData().initClass($c_Llaika_ast_Choice, "laika.ast.Choice", ({
  Llaika_ast_Choice: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_BlockContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_Columns(content, options) {
  this.Llaika_ast_Columns__f_content = null;
  this.Llaika_ast_Columns__f_options = null;
  this.Llaika_ast_Columns__f_content = content;
  this.Llaika_ast_Columns__f_options = options;
}
$c_Llaika_ast_Columns.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_Columns.prototype.constructor = $c_Llaika_ast_Columns;
/** @constructor */
function $h_Llaika_ast_Columns() {
}
$h_Llaika_ast_Columns.prototype = $c_Llaika_ast_Columns.prototype;
$c_Llaika_ast_Columns.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_Columns.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_Columns.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_Columns)) {
    var x$0$2 = $as_Llaika_ast_Columns(x$0);
    var x = this.Llaika_ast_Columns__f_content;
    var x$2 = $n(x$0$2).Llaika_ast_Columns__f_content;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_Columns__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_Columns__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_Columns.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_Columns.prototype.productPrefix__T = (function() {
  return "Columns";
});
$c_Llaika_ast_Columns.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_Columns__f_content;
  }
  if ((n === 1)) {
    return this.Llaika_ast_Columns__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_Columns.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_Columns__f_content;
});
$c_Llaika_ast_Columns.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_Columns__f_options;
});
$c_Llaika_ast_Columns.prototype.content__O = (function() {
  return this.Llaika_ast_Columns__f_content;
});
$c_Llaika_ast_Columns.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_Columns__f_content;
  return new $c_Llaika_ast_Columns(content, options);
});
function $as_Llaika_ast_Columns(obj) {
  return (((obj instanceof $c_Llaika_ast_Columns) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Columns"));
}
function $isArrayOf_Llaika_ast_Columns(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Columns)));
}
function $asArrayOf_Llaika_ast_Columns(obj, depth) {
  return (($isArrayOf_Llaika_ast_Columns(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Columns;", depth));
}
var $d_Llaika_ast_Columns = new $TypeData().initClass($c_Llaika_ast_Columns, "laika.ast.Columns", ({
  Llaika_ast_Columns: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_TableElement: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_TableContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_MessageLevel$Debug$() {
  this.Llaika_ast_MessageLevel__f_level = 0;
  this.Llaika_ast_MessageLevel__f_toString = null;
  $ct_Llaika_ast_MessageLevel__I__(this, 0);
}
$c_Llaika_ast_MessageLevel$Debug$.prototype = new $h_Llaika_ast_MessageLevel();
$c_Llaika_ast_MessageLevel$Debug$.prototype.constructor = $c_Llaika_ast_MessageLevel$Debug$;
/** @constructor */
function $h_Llaika_ast_MessageLevel$Debug$() {
}
$h_Llaika_ast_MessageLevel$Debug$.prototype = $c_Llaika_ast_MessageLevel$Debug$.prototype;
$c_Llaika_ast_MessageLevel$Debug$.prototype.hashCode__I = (function() {
  return 65906227;
});
$c_Llaika_ast_MessageLevel$Debug$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_ast_MessageLevel$Debug$.prototype.productPrefix__T = (function() {
  return "Debug";
});
$c_Llaika_ast_MessageLevel$Debug$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_ast_MessageLevel$Debug$ = new $TypeData().initClass($c_Llaika_ast_MessageLevel$Debug$, "laika.ast.MessageLevel$Debug$", ({
  Llaika_ast_MessageLevel$Debug$: 1,
  Llaika_ast_MessageLevel: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_ast_MessageLevel$Debug$;
function $m_Llaika_ast_MessageLevel$Debug$() {
  if ((!$n_Llaika_ast_MessageLevel$Debug$)) {
    $n_Llaika_ast_MessageLevel$Debug$ = new $c_Llaika_ast_MessageLevel$Debug$();
  }
  return $n_Llaika_ast_MessageLevel$Debug$;
}
/** @constructor */
function $c_Llaika_ast_MessageLevel$Error$() {
  this.Llaika_ast_MessageLevel__f_level = 0;
  this.Llaika_ast_MessageLevel__f_toString = null;
  $ct_Llaika_ast_MessageLevel__I__(this, 3);
}
$c_Llaika_ast_MessageLevel$Error$.prototype = new $h_Llaika_ast_MessageLevel();
$c_Llaika_ast_MessageLevel$Error$.prototype.constructor = $c_Llaika_ast_MessageLevel$Error$;
/** @constructor */
function $h_Llaika_ast_MessageLevel$Error$() {
}
$h_Llaika_ast_MessageLevel$Error$.prototype = $c_Llaika_ast_MessageLevel$Error$.prototype;
$c_Llaika_ast_MessageLevel$Error$.prototype.hashCode__I = (function() {
  return 67232232;
});
$c_Llaika_ast_MessageLevel$Error$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_ast_MessageLevel$Error$.prototype.productPrefix__T = (function() {
  return "Error";
});
$c_Llaika_ast_MessageLevel$Error$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_ast_MessageLevel$Error$ = new $TypeData().initClass($c_Llaika_ast_MessageLevel$Error$, "laika.ast.MessageLevel$Error$", ({
  Llaika_ast_MessageLevel$Error$: 1,
  Llaika_ast_MessageLevel: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_ast_MessageLevel$Error$;
function $m_Llaika_ast_MessageLevel$Error$() {
  if ((!$n_Llaika_ast_MessageLevel$Error$)) {
    $n_Llaika_ast_MessageLevel$Error$ = new $c_Llaika_ast_MessageLevel$Error$();
  }
  return $n_Llaika_ast_MessageLevel$Error$;
}
/** @constructor */
function $c_Llaika_ast_MessageLevel$Fatal$() {
  this.Llaika_ast_MessageLevel__f_level = 0;
  this.Llaika_ast_MessageLevel__f_toString = null;
  $ct_Llaika_ast_MessageLevel__I__(this, 4);
}
$c_Llaika_ast_MessageLevel$Fatal$.prototype = new $h_Llaika_ast_MessageLevel();
$c_Llaika_ast_MessageLevel$Fatal$.prototype.constructor = $c_Llaika_ast_MessageLevel$Fatal$;
/** @constructor */
function $h_Llaika_ast_MessageLevel$Fatal$() {
}
$h_Llaika_ast_MessageLevel$Fatal$.prototype = $c_Llaika_ast_MessageLevel$Fatal$.prototype;
$c_Llaika_ast_MessageLevel$Fatal$.prototype.hashCode__I = (function() {
  return 67650788;
});
$c_Llaika_ast_MessageLevel$Fatal$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_ast_MessageLevel$Fatal$.prototype.productPrefix__T = (function() {
  return "Fatal";
});
$c_Llaika_ast_MessageLevel$Fatal$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_ast_MessageLevel$Fatal$ = new $TypeData().initClass($c_Llaika_ast_MessageLevel$Fatal$, "laika.ast.MessageLevel$Fatal$", ({
  Llaika_ast_MessageLevel$Fatal$: 1,
  Llaika_ast_MessageLevel: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_ast_MessageLevel$Fatal$;
function $m_Llaika_ast_MessageLevel$Fatal$() {
  if ((!$n_Llaika_ast_MessageLevel$Fatal$)) {
    $n_Llaika_ast_MessageLevel$Fatal$ = new $c_Llaika_ast_MessageLevel$Fatal$();
  }
  return $n_Llaika_ast_MessageLevel$Fatal$;
}
/** @constructor */
function $c_Llaika_ast_MessageLevel$Info$() {
  this.Llaika_ast_MessageLevel__f_level = 0;
  this.Llaika_ast_MessageLevel__f_toString = null;
  $ct_Llaika_ast_MessageLevel__I__(this, 1);
}
$c_Llaika_ast_MessageLevel$Info$.prototype = new $h_Llaika_ast_MessageLevel();
$c_Llaika_ast_MessageLevel$Info$.prototype.constructor = $c_Llaika_ast_MessageLevel$Info$;
/** @constructor */
function $h_Llaika_ast_MessageLevel$Info$() {
}
$h_Llaika_ast_MessageLevel$Info$.prototype = $c_Llaika_ast_MessageLevel$Info$.prototype;
$c_Llaika_ast_MessageLevel$Info$.prototype.hashCode__I = (function() {
  return 2283726;
});
$c_Llaika_ast_MessageLevel$Info$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_ast_MessageLevel$Info$.prototype.productPrefix__T = (function() {
  return "Info";
});
$c_Llaika_ast_MessageLevel$Info$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_ast_MessageLevel$Info$ = new $TypeData().initClass($c_Llaika_ast_MessageLevel$Info$, "laika.ast.MessageLevel$Info$", ({
  Llaika_ast_MessageLevel$Info$: 1,
  Llaika_ast_MessageLevel: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_ast_MessageLevel$Info$;
function $m_Llaika_ast_MessageLevel$Info$() {
  if ((!$n_Llaika_ast_MessageLevel$Info$)) {
    $n_Llaika_ast_MessageLevel$Info$ = new $c_Llaika_ast_MessageLevel$Info$();
  }
  return $n_Llaika_ast_MessageLevel$Info$;
}
/** @constructor */
function $c_Llaika_ast_MessageLevel$Warning$() {
  this.Llaika_ast_MessageLevel__f_level = 0;
  this.Llaika_ast_MessageLevel__f_toString = null;
  $ct_Llaika_ast_MessageLevel__I__(this, 2);
}
$c_Llaika_ast_MessageLevel$Warning$.prototype = new $h_Llaika_ast_MessageLevel();
$c_Llaika_ast_MessageLevel$Warning$.prototype.constructor = $c_Llaika_ast_MessageLevel$Warning$;
/** @constructor */
function $h_Llaika_ast_MessageLevel$Warning$() {
}
$h_Llaika_ast_MessageLevel$Warning$.prototype = $c_Llaika_ast_MessageLevel$Warning$.prototype;
$c_Llaika_ast_MessageLevel$Warning$.prototype.hashCode__I = (function() {
  return (-1505867908);
});
$c_Llaika_ast_MessageLevel$Warning$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_ast_MessageLevel$Warning$.prototype.productPrefix__T = (function() {
  return "Warning";
});
$c_Llaika_ast_MessageLevel$Warning$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Llaika_ast_MessageLevel$Warning$ = new $TypeData().initClass($c_Llaika_ast_MessageLevel$Warning$, "laika.ast.MessageLevel$Warning$", ({
  Llaika_ast_MessageLevel$Warning$: 1,
  Llaika_ast_MessageLevel: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_ast_MessageLevel$Warning$;
function $m_Llaika_ast_MessageLevel$Warning$() {
  if ((!$n_Llaika_ast_MessageLevel$Warning$)) {
    $n_Llaika_ast_MessageLevel$Warning$ = new $c_Llaika_ast_MessageLevel$Warning$();
  }
  return $n_Llaika_ast_MessageLevel$Warning$;
}
/** @constructor */
function $c_Llaika_ast_Path$Root$() {
  this.Llaika_ast_Path$Root$__f_depth = 0;
  this.Llaika_ast_Path$Root$__f_parent = null;
  this.Llaika_ast_Path$Root$__f_name = null;
  this.Llaika_ast_Path$Root$__f_suffix = null;
  this.Llaika_ast_Path$Root$__f_fragment = null;
  this.Llaika_ast_Path$Root$__f_toString = null;
  $n_Llaika_ast_Path$Root$ = this;
  this.Llaika_ast_Path$Root$__f_depth = 0;
  this.Llaika_ast_Path$Root$__f_parent = this;
  this.Llaika_ast_Path$Root$__f_name = "/";
  this.Llaika_ast_Path$Root$__f_suffix = $m_s_None$();
  this.Llaika_ast_Path$Root$__f_fragment = $m_s_None$();
  this.Llaika_ast_Path$Root$__f_toString = "/";
}
$c_Llaika_ast_Path$Root$.prototype = new $h_O();
$c_Llaika_ast_Path$Root$.prototype.constructor = $c_Llaika_ast_Path$Root$;
/** @constructor */
function $h_Llaika_ast_Path$Root$() {
}
$h_Llaika_ast_Path$Root$.prototype = $c_Llaika_ast_Path$Root$.prototype;
$c_Llaika_ast_Path$Root$.prototype.basename__T = (function() {
  return "/";
});
$c_Llaika_ast_Path$Root$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_Path$Root$.prototype.hashCode__I = (function() {
  return 2553090;
});
$c_Llaika_ast_Path$Root$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_ast_Path$Root$.prototype.productPrefix__T = (function() {
  return "Root";
});
$c_Llaika_ast_Path$Root$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_Path$Root$.prototype.depth__I = (function() {
  return 0;
});
$c_Llaika_ast_Path$Root$.prototype.parent__Llaika_ast_Path = (function() {
  return this.Llaika_ast_Path$Root$__f_parent;
});
$c_Llaika_ast_Path$Root$.prototype.name__T = (function() {
  return "/";
});
$c_Llaika_ast_Path$Root$.prototype.suffix__s_Option = (function() {
  return $m_s_None$();
});
$c_Llaika_ast_Path$Root$.prototype.fragment__s_Option = (function() {
  return $m_s_None$();
});
$c_Llaika_ast_Path$Root$.prototype.copyWith$default$1__T = (function() {
  return "/";
});
$c_Llaika_ast_Path$Root$.prototype.copyWith$default$2__s_Option = (function() {
  return $m_s_None$();
});
$c_Llaika_ast_Path$Root$.prototype.copyWith$default$3__s_Option = (function() {
  return $m_s_None$();
});
$c_Llaika_ast_Path$Root$.prototype.$div__Llaika_ast_RelativePath__Llaika_ast_Path = (function(path) {
  if ((path instanceof $c_Llaika_ast_RelativePath$Segments)) {
    var x$1 = $as_Llaika_ast_RelativePath$Segments(path);
    var this$2 = $n(x$1);
    var x20 = this$2.Llaika_ast_RelativePath$Segments__f_segments;
    var this$3 = $n(x$1);
    var x21 = this$3.Llaika_ast_RelativePath$Segments__f_suffix;
    var this$4 = $n(x$1);
    var x22 = this$4.Llaika_ast_RelativePath$Segments__f_fragment;
    var this$5 = $n(x$1);
    return new $c_Llaika_ast_Path$Segments(x20, x21, x22);
  } else {
    return this;
  }
});
$c_Llaika_ast_Path$Root$.prototype.relativeTo__Llaika_ast_Path__Llaika_ast_RelativePath = (function(path) {
  var x = $m_Llaika_ast_Path$Root$();
  if ((x === path)) {
    return $m_Llaika_ast_RelativePath$CurrentTree$();
  }
  if ((path instanceof $c_Llaika_ast_Path$Segments)) {
    var x$1 = $as_Llaika_ast_Path$Segments(path);
    var this$2 = $n(x$1);
    var x27 = this$2.Llaika_ast_Path$Segments__f_segments;
    var this$3 = $n(x$1);
    var this$4 = $n(x$1);
    $m_Lcats_data_NonEmptyChainImpl$();
    var this$6 = $m_Lcats_data_NonEmptyChainOps$().length$extension__O__J(x27);
    var parentLevels = this$6.RTLong__f_lo;
    return new $c_Llaika_ast_RelativePath$Parent(parentLevels);
  }
  throw new $c_s_MatchError(path);
});
$c_Llaika_ast_Path$Root$.prototype.isSubPath__Llaika_ast_Path__Z = (function(other) {
  var x$2 = $m_Llaika_ast_Path$Root$();
  return ((other !== null) && $n(other).equals__O__Z(x$2));
});
$c_Llaika_ast_Path$Root$.prototype.toString__T = (function() {
  return "/";
});
$c_Llaika_ast_Path$Root$.prototype.copyWith__T__s_Option__s_Option__Llaika_ast_GenericPath = (function(basename, suffix, fragment) {
  return this;
});
$c_Llaika_ast_Path$Root$.prototype.$div__Llaika_ast_RelativePath__Llaika_ast_GenericPath = (function(path) {
  return this.$div__Llaika_ast_RelativePath__Llaika_ast_Path(path);
});
var $d_Llaika_ast_Path$Root$ = new $TypeData().initClass($c_Llaika_ast_Path$Root$, "laika.ast.Path$Root$", ({
  Llaika_ast_Path$Root$: 1,
  Llaika_ast_GenericPath: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_VirtualPath: 1,
  Llaika_ast_Path: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_ast_Path$Root$;
function $m_Llaika_ast_Path$Root$() {
  if ((!$n_Llaika_ast_Path$Root$)) {
    $n_Llaika_ast_Path$Root$ = new $c_Llaika_ast_Path$Root$();
  }
  return $n_Llaika_ast_Path$Root$;
}
/** @constructor */
function $c_Llaika_ast_RelativePath$CurrentTree$() {
  this.Llaika_ast_RelativePath$CurrentTree$__f_name = null;
  this.Llaika_ast_RelativePath$CurrentTree$__f_parent = null;
  this.Llaika_ast_RelativePath$CurrentTree$__f_parentLevels = 0;
  this.Llaika_ast_RelativePath$CurrentTree$__f_suffix = null;
  this.Llaika_ast_RelativePath$CurrentTree$__f_fragment = null;
  this.Llaika_ast_RelativePath$CurrentTree$__f_toString = null;
  $n_Llaika_ast_RelativePath$CurrentTree$ = this;
  this.Llaika_ast_RelativePath$CurrentTree$__f_name = ".";
  this.Llaika_ast_RelativePath$CurrentTree$__f_parent = new $c_Llaika_ast_RelativePath$Parent(1);
  this.Llaika_ast_RelativePath$CurrentTree$__f_parentLevels = 0;
  this.Llaika_ast_RelativePath$CurrentTree$__f_suffix = $m_s_None$();
  this.Llaika_ast_RelativePath$CurrentTree$__f_fragment = $m_s_None$();
  this.Llaika_ast_RelativePath$CurrentTree$__f_toString = this.Llaika_ast_RelativePath$CurrentTree$__f_name;
}
$c_Llaika_ast_RelativePath$CurrentTree$.prototype = new $h_O();
$c_Llaika_ast_RelativePath$CurrentTree$.prototype.constructor = $c_Llaika_ast_RelativePath$CurrentTree$;
/** @constructor */
function $h_Llaika_ast_RelativePath$CurrentTree$() {
}
$h_Llaika_ast_RelativePath$CurrentTree$.prototype = $c_Llaika_ast_RelativePath$CurrentTree$.prototype;
$c_Llaika_ast_RelativePath$CurrentTree$.prototype.withFragment__T__Llaika_ast_GenericPath = (function(fragment) {
  return $f_Llaika_ast_GenericPath__withFragment__T__Llaika_ast_GenericPath(this, fragment);
});
$c_Llaika_ast_RelativePath$CurrentTree$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llaika_ast_RelativePath$CurrentTree$.prototype.copyWith__T__s_Option__s_Option__Llaika_ast_RelativePath = (function(basename, suffix, fragment) {
  return this;
});
$c_Llaika_ast_RelativePath$CurrentTree$.prototype.copyWith$default$1__T = (function() {
  return this.Llaika_ast_RelativePath$CurrentTree$__f_name;
});
$c_Llaika_ast_RelativePath$CurrentTree$.prototype.copyWith$default$2__s_Option = (function() {
  return this.Llaika_ast_RelativePath$CurrentTree$__f_suffix;
});
$c_Llaika_ast_RelativePath$CurrentTree$.prototype.copyWith$default$3__s_Option = (function() {
  return this.Llaika_ast_RelativePath$CurrentTree$__f_fragment;
});
$c_Llaika_ast_RelativePath$CurrentTree$.prototype.hashCode__I = (function() {
  return (-2025854825);
});
$c_Llaika_ast_RelativePath$CurrentTree$.prototype.productArity__I = (function() {
  return 0;
});
$c_Llaika_ast_RelativePath$CurrentTree$.prototype.productPrefix__T = (function() {
  return "CurrentTree";
});
$c_Llaika_ast_RelativePath$CurrentTree$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_RelativePath$CurrentTree$.prototype.name__T = (function() {
  return this.Llaika_ast_RelativePath$CurrentTree$__f_name;
});
$c_Llaika_ast_RelativePath$CurrentTree$.prototype.parent__Llaika_ast_RelativePath = (function() {
  return this.Llaika_ast_RelativePath$CurrentTree$__f_parent;
});
$c_Llaika_ast_RelativePath$CurrentTree$.prototype.parentLevels__I = (function() {
  return this.Llaika_ast_RelativePath$CurrentTree$__f_parentLevels;
});
$c_Llaika_ast_RelativePath$CurrentTree$.prototype.$div__Llaika_ast_RelativePath__Llaika_ast_RelativePath = (function(path) {
  return path;
});
$c_Llaika_ast_RelativePath$CurrentTree$.prototype.toString__T = (function() {
  return this.Llaika_ast_RelativePath$CurrentTree$__f_toString;
});
$c_Llaika_ast_RelativePath$CurrentTree$.prototype.$div__Llaika_ast_RelativePath__Llaika_ast_GenericPath = (function(path) {
  return path;
});
$c_Llaika_ast_RelativePath$CurrentTree$.prototype.copyWith__T__s_Option__s_Option__Llaika_ast_GenericPath = (function(basename, suffix, fragment) {
  return this;
});
var $d_Llaika_ast_RelativePath$CurrentTree$ = new $TypeData().initClass($c_Llaika_ast_RelativePath$CurrentTree$, "laika.ast.RelativePath$CurrentTree$", ({
  Llaika_ast_RelativePath$CurrentTree$: 1,
  Llaika_ast_GenericPath: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_VirtualPath: 1,
  Llaika_ast_RelativePath: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Llaika_ast_RelativePath$CurrentTree$;
function $m_Llaika_ast_RelativePath$CurrentTree$() {
  if ((!$n_Llaika_ast_RelativePath$CurrentTree$)) {
    $n_Llaika_ast_RelativePath$CurrentTree$ = new $c_Llaika_ast_RelativePath$CurrentTree$();
  }
  return $n_Llaika_ast_RelativePath$CurrentTree$;
}
/** @constructor */
function $c_Llaika_ast_TemplateContextReference(ref, required, source, options) {
  this.Llaika_ast_ContextReference__f_ref = null;
  this.Llaika_ast_ContextReference__f_source = null;
  this.Llaika_ast_TemplateContextReference__f_ref = null;
  this.Llaika_ast_TemplateContextReference__f_required = false;
  this.Llaika_ast_TemplateContextReference__f_source = null;
  this.Llaika_ast_TemplateContextReference__f_options = null;
  this.Llaika_ast_TemplateContextReference__f_unresolvedMessage$lzy4 = null;
  this.Llaika_ast_TemplateContextReference__f_unresolvedMessagebitmap$4 = false;
  this.Llaika_ast_TemplateContextReference__f_ref = ref;
  this.Llaika_ast_TemplateContextReference__f_required = required;
  this.Llaika_ast_TemplateContextReference__f_source = source;
  this.Llaika_ast_TemplateContextReference__f_options = options;
  $ct_Llaika_ast_ContextReference__Llaika_api_config_Key__Llaika_parse_SourceFragment__(this, ref, source);
}
$c_Llaika_ast_TemplateContextReference.prototype = new $h_Llaika_ast_ContextReference();
$c_Llaika_ast_TemplateContextReference.prototype.constructor = $c_Llaika_ast_TemplateContextReference;
/** @constructor */
function $h_Llaika_ast_TemplateContextReference() {
}
$h_Llaika_ast_TemplateContextReference.prototype = $c_Llaika_ast_TemplateContextReference.prototype;
$c_Llaika_ast_TemplateContextReference.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("TemplateContextReference");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Llaika_ast_TemplateContextReference__f_ref;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Llaika_ast_TemplateContextReference__f_required ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Llaika_ast_TemplateContextReference__f_source;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Llaika_ast_TemplateContextReference__f_options;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4);
});
$c_Llaika_ast_TemplateContextReference.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_TemplateContextReference)) {
    var x$0$2 = $as_Llaika_ast_TemplateContextReference(x$0);
    if ((this.Llaika_ast_TemplateContextReference__f_required === $n(x$0$2).Llaika_ast_TemplateContextReference__f_required)) {
      var x = this.Llaika_ast_TemplateContextReference__f_ref;
      var x$2 = $n(x$0$2).Llaika_ast_TemplateContextReference__f_ref;
      var $x_3 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.Llaika_ast_TemplateContextReference__f_source;
      var x$4 = $n(x$0$2).Llaika_ast_TemplateContextReference__f_source;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llaika_ast_TemplateContextReference__f_options;
      var x$6 = $n(x$0$2).Llaika_ast_TemplateContextReference__f_options;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_TemplateContextReference.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_TemplateContextReference.prototype.productArity__I = (function() {
  return 4;
});
$c_Llaika_ast_TemplateContextReference.prototype.productPrefix__T = (function() {
  return "TemplateContextReference";
});
$c_Llaika_ast_TemplateContextReference.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_TemplateContextReference__f_ref;
      break;
    }
    case 1: {
      return this.Llaika_ast_TemplateContextReference__f_required;
      break;
    }
    case 2: {
      return this.Llaika_ast_TemplateContextReference__f_source;
      break;
    }
    case 3: {
      return this.Llaika_ast_TemplateContextReference__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_TemplateContextReference.prototype.source__Llaika_parse_SourceFragment = (function() {
  return this.Llaika_ast_TemplateContextReference__f_source;
});
$c_Llaika_ast_TemplateContextReference.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_TemplateContextReference__f_options;
});
$c_Llaika_ast_TemplateContextReference.prototype.resolve__Llaika_ast_DocumentCursor__Llaika_ast_Span = (function(cursor) {
  var x17 = $n(cursor).resolveReference__Llaika_api_config_Key__s_util_Either(this.Llaika_ast_TemplateContextReference__f_ref);
  if ((x17 instanceof $c_s_util_Right)) {
    var x53 = $as_s_Option($n($as_s_util_Right(x17)).s_util_Right__f_value);
    if ((x53 instanceof $c_s_Some)) {
      var x55 = $as_Llaika_api_config_ConfigValue($n($as_s_Some(x53)).s_Some__f_value);
      if ((x55 instanceof $c_Llaika_api_config_ConfigValue$ASTValue)) {
        var x$1 = $as_Llaika_api_config_ConfigValue$ASTValue(x55);
        var this$2 = $n(x$1);
        var x58 = this$2.Llaika_api_config_ConfigValue$ASTValue__f_value;
        if ($is_Llaika_ast_TemplateSpan(x58)) {
          var s = $as_Llaika_ast_TemplateSpan(x58);
          return s;
        }
        if ((x58 instanceof $c_Llaika_ast_RootElement)) {
          var x$1$1 = $as_Llaika_ast_RootElement(x58);
          var this$4 = $n(x$1$1);
          var x50 = this$4.Llaika_ast_RootElement__f_content;
          var this$5 = $n(x$1$1);
          var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
          return new $c_Llaika_ast_EmbeddedRoot(x50, 0, options);
        }
        if ((x58 !== null)) {
          var options$1 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
          return new $c_Llaika_ast_TemplateElement(x58, 0, options$1);
        }
      }
      if ($is_Llaika_api_config_ConfigValue$SimpleValue(x55)) {
        var simple = $as_Llaika_api_config_ConfigValue$SimpleValue(x55);
        var content = $n(simple).render__T();
        var options$2 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
        return new $c_Llaika_ast_TemplateString(content, options$2);
      }
    }
    var x = $m_s_None$();
    if ((x === x53)) {
      if ((!this.Llaika_ast_TemplateContextReference__f_required)) {
        var options$3 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
        return new $c_Llaika_ast_TemplateString("", options$3);
      }
      var element = this.missing__Llaika_ast_InvalidSpan();
      var options$4 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      return new $c_Llaika_ast_TemplateElement(element, 0, options$4);
    }
    if ((x53 instanceof $c_s_Some)) {
      var unsupported = $as_Llaika_api_config_ConfigValue($n($as_s_Some(x53)).s_Some__f_value);
      var element$1 = this.invalidType__Llaika_api_config_ConfigValue__Llaika_ast_InvalidSpan(unsupported);
      var options$5 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
      return new $c_Llaika_ast_TemplateElement(element$1, 0, options$5);
    }
  }
  if ((x17 instanceof $c_s_util_Left)) {
    var configError = $as_Llaika_api_config_ConfigError($n($as_s_util_Left(x17)).s_util_Left__f_value);
    var element$2 = this.invalid__Llaika_api_config_ConfigError__Llaika_ast_InvalidSpan(configError);
    var options$6 = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
    return new $c_Llaika_ast_TemplateElement(element$2, 0, options$6);
  }
  throw new $c_s_MatchError(x17);
});
$c_Llaika_ast_TemplateContextReference.prototype.runsIn__Llaika_ast_RewritePhase__Z = (function(phase) {
  return (phase instanceof $c_Llaika_ast_RewritePhase$Render);
});
$c_Llaika_ast_TemplateContextReference.prototype.unresolvedMessage__T = (function() {
  if ((!this.Llaika_ast_TemplateContextReference__f_unresolvedMessagebitmap$4)) {
    this.Llaika_ast_TemplateContextReference__f_unresolvedMessage$lzy4 = (("Unresolved template context reference with key '" + $n(this.Llaika_ast_TemplateContextReference__f_ref).toString__T()) + "'");
    this.Llaika_ast_TemplateContextReference__f_unresolvedMessagebitmap$4 = true;
  }
  return this.Llaika_ast_TemplateContextReference__f_unresolvedMessage$lzy4;
});
$c_Llaika_ast_TemplateContextReference.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var ref = this.Llaika_ast_TemplateContextReference__f_ref;
  var required = this.Llaika_ast_TemplateContextReference__f_required;
  var source = this.Llaika_ast_TemplateContextReference__f_source;
  return new $c_Llaika_ast_TemplateContextReference(ref, required, source, options);
});
function $as_Llaika_ast_TemplateContextReference(obj) {
  return (((obj instanceof $c_Llaika_ast_TemplateContextReference) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.TemplateContextReference"));
}
function $isArrayOf_Llaika_ast_TemplateContextReference(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_TemplateContextReference)));
}
function $asArrayOf_Llaika_ast_TemplateContextReference(obj, depth) {
  return (($isArrayOf_Llaika_ast_TemplateContextReference(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.TemplateContextReference;", depth));
}
var $d_Llaika_ast_TemplateContextReference = new $TypeData().initClass($c_Llaika_ast_TemplateContextReference, "laika.ast.TemplateContextReference", ({
  Llaika_ast_TemplateContextReference: 1,
  Llaika_ast_ContextReference: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Unresolved: 1,
  Llaika_ast_SpanResolver: 1,
  Llaika_ast_TemplateSpan: 1
}));
/** @constructor */
function $c_Llaika_ast_html_HTMLComment(content, options) {
  this.Llaika_ast_html_HTMLComment__f_content = null;
  this.Llaika_ast_html_HTMLComment__f_options = null;
  this.Llaika_ast_html_HTMLComment__f_content = content;
  this.Llaika_ast_html_HTMLComment__f_options = options;
}
$c_Llaika_ast_html_HTMLComment.prototype = new $h_Llaika_ast_html_HTMLSpan();
$c_Llaika_ast_html_HTMLComment.prototype.constructor = $c_Llaika_ast_html_HTMLComment;
/** @constructor */
function $h_Llaika_ast_html_HTMLComment() {
}
$h_Llaika_ast_html_HTMLComment.prototype = $c_Llaika_ast_html_HTMLComment.prototype;
$c_Llaika_ast_html_HTMLComment.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_html_HTMLComment.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_html_HTMLComment)) {
    var x$0$2 = $as_Llaika_ast_html_HTMLComment(x$0);
    if ((this.Llaika_ast_html_HTMLComment__f_content === $n(x$0$2).Llaika_ast_html_HTMLComment__f_content)) {
      var x = this.Llaika_ast_html_HTMLComment__f_options;
      var x$2 = $n(x$0$2).Llaika_ast_html_HTMLComment__f_options;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_html_HTMLComment.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_ast_html_HTMLComment.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_html_HTMLComment.prototype.productPrefix__T = (function() {
  return "HTMLComment";
});
$c_Llaika_ast_html_HTMLComment.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_html_HTMLComment__f_content;
  }
  if ((n === 1)) {
    return this.Llaika_ast_html_HTMLComment__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_html_HTMLComment.prototype.content__T = (function() {
  return this.Llaika_ast_html_HTMLComment__f_content;
});
$c_Llaika_ast_html_HTMLComment.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_html_HTMLComment__f_options;
});
$c_Llaika_ast_html_HTMLComment.prototype.content__O = (function() {
  return this.Llaika_ast_html_HTMLComment__f_content;
});
$c_Llaika_ast_html_HTMLComment.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_html_HTMLComment__f_content;
  return new $c_Llaika_ast_html_HTMLComment(content, options);
});
function $as_Llaika_ast_html_HTMLComment(obj) {
  return (((obj instanceof $c_Llaika_ast_html_HTMLComment) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.html.HTMLComment"));
}
function $isArrayOf_Llaika_ast_html_HTMLComment(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_html_HTMLComment)));
}
function $asArrayOf_Llaika_ast_html_HTMLComment(obj, depth) {
  return (($isArrayOf_Llaika_ast_html_HTMLComment(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.html.HTMLComment;", depth));
}
var $d_Llaika_ast_html_HTMLComment = new $TypeData().initClass($c_Llaika_ast_html_HTMLComment, "laika.ast.html.HTMLComment", ({
  Llaika_ast_html_HTMLComment: 1,
  Llaika_ast_html_HTMLSpan: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_TextContainer: 1
}));
function $f_sc_Seq__equals__O__Z($thiz, o) {
  if (($thiz === o)) {
    return true;
  } else {
    if ($is_sc_Seq(o)) {
      var x2 = $as_sc_Seq(o);
      if ($n(x2).canEqual__O__Z($thiz)) {
        return $thiz.sameElements__sc_IterableOnce__Z(x2);
      }
    }
    return false;
  }
}
function $is_sc_Seq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Seq)));
}
function $as_sc_Seq(obj) {
  return (($is_sc_Seq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Seq"));
}
function $isArrayOf_sc_Seq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Seq)));
}
function $asArrayOf_sc_Seq(obj, depth) {
  return (($isArrayOf_sc_Seq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Seq;", depth));
}
function $p_sc_SeqView$Sorted___sorted$lzycompute__sc_Seq($thiz) {
  if ((!$thiz.sc_SeqView$Sorted__f_bitmap$0)) {
    var len = $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len;
    if ((len === 0)) {
      var res = $m_sci_Nil$();
    } else if ((len === 1)) {
      var array = [$n($thiz.sc_SeqView$Sorted__f_underlying).head__O()];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      var res = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
    } else {
      var arr = new $ac_O(len);
      var this$5 = $n($thiz.sc_SeqView$Sorted__f_underlying);
      this$5.copyToArray__O__I__I__I(arr, 0, 2147483647);
      var comparator = $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord;
      $m_ju_Arrays$().sort__AO__ju_Comparator__V(arr, comparator);
      var res = $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(arr);
    }
    $thiz.sc_SeqView$Sorted__f_evaluated = true;
    $thiz.sc_SeqView$Sorted__f_underlying = null;
    $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$_sorted = res;
    $thiz.sc_SeqView$Sorted__f_bitmap$0 = true;
  }
  return $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$_sorted;
}
function $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__($thiz, underlying, len, ord) {
  $thiz.sc_SeqView$Sorted__f_underlying = underlying;
  $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len = len;
  $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord = ord;
  $thiz.sc_SeqView$Sorted__f_evaluated = false;
  return $thiz;
}
function $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__($thiz, underlying, ord) {
  $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__($thiz, underlying, $n(underlying).length__I(), ord);
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Sorted() {
  this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$_sorted = null;
  this.sc_SeqView$Sorted__f_underlying = null;
  this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len = 0;
  this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord = null;
  this.sc_SeqView$Sorted__f_evaluated = false;
  this.sc_SeqView$Sorted__f_bitmap$0 = false;
}
$c_sc_SeqView$Sorted.prototype = new $h_O();
$c_sc_SeqView$Sorted.prototype.constructor = $c_sc_SeqView$Sorted;
/** @constructor */
function $h_sc_SeqView$Sorted() {
}
$h_sc_SeqView$Sorted.prototype = $c_sc_SeqView$Sorted.prototype;
$c_sc_SeqView$Sorted.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_View$();
});
$c_sc_SeqView$Sorted.prototype.toString__T = (function() {
  return $f_sc_View__toString__T(this);
});
$c_sc_SeqView$Sorted.prototype.className__T = (function() {
  return "SeqView";
});
$c_sc_SeqView$Sorted.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sc_View$().newBuilder__scm_Builder();
});
$c_sc_SeqView$Sorted.prototype.prependedAll__sc_IterableOnce__O = (function(prefix) {
  return $f_sc_SeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$c_sc_SeqView$Sorted.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_SeqView$Sorted.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_SeqView$Sorted.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$c_sc_SeqView$Sorted.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_sc_SeqView$Sorted$ReverseSorted(this).iterator__sc_Iterator();
});
$c_sc_SeqView$Sorted.prototype.padTo__I__O__O = (function(len, elem) {
  return $f_sc_SeqOps__padTo__I__O__O(this, len, elem);
});
$c_sc_SeqView$Sorted.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = $n(this.iterator__sc_Iterator());
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from);
});
$c_sc_SeqView$Sorted.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_sc_SeqView$Sorted.prototype.head__O = (function() {
  return $n(this.iterator__sc_Iterator()).next__O();
});
$c_sc_SeqView$Sorted.prototype.headOption__s_Option = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this);
});
$c_sc_SeqView$Sorted.prototype.last__O = (function() {
  return $f_sc_IterableOps__last__O(this);
});
$c_sc_SeqView$Sorted.prototype.filter__F1__O = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$c_sc_SeqView$Sorted.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred);
});
$c_sc_SeqView$Sorted.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_IterableOps__partition__F1__T2(this, p);
});
$c_sc_SeqView$Sorted.prototype.takeWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__takeWhile__F1__O(this, p);
});
$c_sc_SeqView$Sorted.prototype.dropWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__dropWhile__F1__O(this, p);
});
$c_sc_SeqView$Sorted.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$c_sc_SeqView$Sorted.prototype.init__O = (function() {
  return $f_sc_IterableOps__init__O(this);
});
$c_sc_SeqView$Sorted.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f);
});
$c_sc_SeqView$Sorted.prototype.flatten__F1__O = (function(asIterable) {
  return $f_sc_IterableOps__flatMap__F1__O(this, asIterable);
});
$c_sc_SeqView$Sorted.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_IterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_sc_SeqView$Sorted.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$c_sc_SeqView$Sorted.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$c_sc_SeqView$Sorted.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_sc_SeqView$Sorted.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_sc_SeqView$Sorted.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_sc_SeqView$Sorted.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$c_sc_SeqView$Sorted.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$c_sc_SeqView$Sorted.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_sc_SeqView$Sorted.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_sc_SeqView$Sorted.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_sc_SeqView$Sorted.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_sc_SeqView$Sorted.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this);
});
$c_sc_SeqView$Sorted.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_sc_SeqView$Sorted.prototype.scala$collection$SeqView$Sorted$$_sorted__sc_Seq = (function() {
  return ((!this.sc_SeqView$Sorted__f_bitmap$0) ? $p_sc_SeqView$Sorted___sorted$lzycompute__sc_Seq(this) : this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$_sorted);
});
$c_sc_SeqView$Sorted.prototype.scala$collection$SeqView$Sorted$$elems__sc_SeqOps = (function() {
  var orig = this.sc_SeqView$Sorted__f_underlying;
  return (this.sc_SeqView$Sorted__f_evaluated ? this.scala$collection$SeqView$Sorted$$_sorted__sc_Seq() : orig);
});
$c_sc_SeqView$Sorted.prototype.apply__I__O = (function(i) {
  return $n(this.scala$collection$SeqView$Sorted$$_sorted__sc_Seq()).apply__I__O(i);
});
$c_sc_SeqView$Sorted.prototype.length__I = (function() {
  return this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len;
});
$c_sc_SeqView$Sorted.prototype.iterator__sc_Iterator = (function() {
  var this$2 = $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty);
  var xs = new $c_sjsr_AnonFunction0((() => $n(this.scala$collection$SeqView$Sorted$$_sorted__sc_Seq()).iterator__sc_Iterator()));
  return this$2.concat__F0__sc_Iterator(xs);
});
$c_sc_SeqView$Sorted.prototype.knownSize__I = (function() {
  return this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len;
});
$c_sc_SeqView$Sorted.prototype.isEmpty__Z = (function() {
  return (this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len === 0);
});
$c_sc_SeqView$Sorted.prototype.sorted__s_math_Ordering__sc_SeqView = (function(ord1) {
  var x$2 = this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord;
  if (((ord1 === null) ? (x$2 === null) : $n(ord1).equals__O__Z(x$2))) {
    return this;
  } else {
    return ($n(ord1).isReverseOf__s_math_Ordering__Z(this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord) ? new $c_sc_SeqView$Sorted$ReverseSorted(this) : $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this.scala$collection$SeqView$Sorted$$elems__sc_SeqOps(), this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len, ord1));
  }
});
$c_sc_SeqView$Sorted.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sc_View$();
  return this$1.from__sc_IterableOnce__sc_View(coll);
});
$c_sc_SeqView$Sorted.prototype.dropRight__I__O = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$c_sc_SeqView$Sorted.prototype.drop__I__O = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$c_sc_SeqView$Sorted.prototype.take__I__O = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n);
});
$c_sc_SeqView$Sorted.prototype.prepended__O__O = (function(elem) {
  return $ct_sc_SeqView$Prepended__O__sc_SeqOps__(new $c_sc_SeqView$Prepended(), elem, this);
});
$c_sc_SeqView$Sorted.prototype.appended__O__O = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$c_sc_SeqView$Sorted.prototype.map__F1__O = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$c_sc_SeqView$Sorted.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sc_SeqView(ord);
});
$c_sc_SeqView$Sorted.prototype.reverse__O = (function() {
  return new $c_sc_SeqView$Sorted$ReverseSorted(this);
});
var $d_sc_SeqView$Sorted = new $TypeData().initClass($c_sc_SeqView$Sorted, "scala.collection.SeqView$Sorted", ({
  sc_SeqView$Sorted: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IterableOps: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_View: 1,
  sc_Iterable: 1,
  sc_IterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
function $p_sc_SeqView$Sorted$ReverseSorted___reversed$lzycompute__sc_SeqView$Reverse($thiz) {
  if ((!$thiz.sc_SeqView$Sorted$ReverseSorted__f_bitmap$0)) {
    $thiz.sc_SeqView$Sorted$ReverseSorted__f__reversed = $ct_sc_SeqView$Reverse__sc_SeqOps__(new $c_sc_SeqView$Reverse(), $n($thiz.sc_SeqView$Sorted$ReverseSorted__f_$outer).scala$collection$SeqView$Sorted$$_sorted__sc_Seq());
    $thiz.sc_SeqView$Sorted$ReverseSorted__f_bitmap$0 = true;
  }
  return $thiz.sc_SeqView$Sorted$ReverseSorted__f__reversed;
}
function $p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse($thiz) {
  return ((!$thiz.sc_SeqView$Sorted$ReverseSorted__f_bitmap$0) ? $p_sc_SeqView$Sorted$ReverseSorted___reversed$lzycompute__sc_SeqView$Reverse($thiz) : $thiz.sc_SeqView$Sorted$ReverseSorted__f__reversed);
}
/** @constructor */
function $c_sc_SeqView$Sorted$ReverseSorted(outer) {
  this.sc_SeqView$Sorted$ReverseSorted__f__reversed = null;
  this.sc_SeqView$Sorted$ReverseSorted__f_bitmap$0 = false;
  this.sc_SeqView$Sorted$ReverseSorted__f_$outer = null;
  $n(outer);
  this.sc_SeqView$Sorted$ReverseSorted__f_$outer = outer;
}
$c_sc_SeqView$Sorted$ReverseSorted.prototype = new $h_O();
$c_sc_SeqView$Sorted$ReverseSorted.prototype.constructor = $c_sc_SeqView$Sorted$ReverseSorted;
/** @constructor */
function $h_sc_SeqView$Sorted$ReverseSorted() {
}
$h_sc_SeqView$Sorted$ReverseSorted.prototype = $c_sc_SeqView$Sorted$ReverseSorted.prototype;
$c_sc_SeqView$Sorted$ReverseSorted.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_View$();
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.toString__T = (function() {
  return $f_sc_View__toString__T(this);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.className__T = (function() {
  return "SeqView";
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sc_View$().newBuilder__scm_Builder();
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.prependedAll__sc_IterableOnce__O = (function(prefix) {
  return $f_sc_SeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.sc_SeqView$Sorted$ReverseSorted__f_$outer).iterator__sc_Iterator();
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.padTo__I__O__O = (function(len, elem) {
  return $f_sc_SeqOps__padTo__I__O__O(this, len, elem);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = $n(this.iterator__sc_Iterator());
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.head__O = (function() {
  return $n(this.iterator__sc_Iterator()).next__O();
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.headOption__s_Option = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.last__O = (function() {
  return $f_sc_IterableOps__last__O(this);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.filter__F1__O = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_IterableOps__partition__F1__T2(this, p);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.takeWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__takeWhile__F1__O(this, p);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.dropWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__dropWhile__F1__O(this, p);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.init__O = (function() {
  return $f_sc_IterableOps__init__O(this);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.flatten__F1__O = (function(asIterable) {
  return $f_sc_IterableOps__flatMap__F1__O(this, asIterable);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_IterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.apply__I__O = (function(i) {
  return $n($p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse(this)).apply__I__O(i);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.length__I = (function() {
  return $n(this.sc_SeqView$Sorted$ReverseSorted__f_$outer).sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len;
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.iterator__sc_Iterator = (function() {
  var this$2 = $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty);
  var xs = new $c_sjsr_AnonFunction0((() => $n($p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse(this)).iterator__sc_Iterator()));
  return this$2.concat__F0__sc_Iterator(xs);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.knownSize__I = (function() {
  return $n(this.sc_SeqView$Sorted$ReverseSorted__f_$outer).sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len;
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.isEmpty__Z = (function() {
  return ($n(this.sc_SeqView$Sorted$ReverseSorted__f_$outer).sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len === 0);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.sorted__s_math_Ordering__sc_SeqView = (function(ord1) {
  var x$2 = $n(this.sc_SeqView$Sorted$ReverseSorted__f_$outer).sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord;
  if (((ord1 === null) ? (x$2 === null) : $n(ord1).equals__O__Z(x$2))) {
    return this.sc_SeqView$Sorted$ReverseSorted__f_$outer;
  } else {
    return ($n(ord1).isReverseOf__s_math_Ordering__Z($n(this.sc_SeqView$Sorted$ReverseSorted__f_$outer).sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord) ? this : $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__(new $c_sc_SeqView$Sorted(), $n(this.sc_SeqView$Sorted$ReverseSorted__f_$outer).scala$collection$SeqView$Sorted$$elems__sc_SeqOps(), $n(this.sc_SeqView$Sorted$ReverseSorted__f_$outer).sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len, ord1));
  }
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sc_View$();
  return this$1.from__sc_IterableOnce__sc_View(coll);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.dropRight__I__O = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.drop__I__O = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.take__I__O = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.prepended__O__O = (function(elem) {
  return $ct_sc_SeqView$Prepended__O__sc_SeqOps__(new $c_sc_SeqView$Prepended(), elem, this);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.appended__O__O = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.map__F1__O = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sc_SeqView(ord);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.reverse__O = (function() {
  return this.sc_SeqView$Sorted$ReverseSorted__f_$outer;
});
var $d_sc_SeqView$Sorted$ReverseSorted = new $TypeData().initClass($c_sc_SeqView$Sorted$ReverseSorted, "scala.collection.SeqView$Sorted$ReverseSorted", ({
  sc_SeqView$Sorted$ReverseSorted: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IterableOps: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_View: 1,
  sc_Iterable: 1,
  sc_IterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
function $f_sc_StrictOptimizedSortedSetOps__map__F1__s_math_Ordering__sc_SortedSet($thiz, f, ev) {
  var b = $n($thiz.sortedIterableFactory__sc_SortedIterableFactory()).newBuilder__O__scm_Builder(ev);
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var this$1 = $n(b);
    var elem = $n(f).apply__O__O($n(it).next__O());
    this$1.addOne__O__scm_Growable(elem);
  }
  return $as_sc_SortedSet($n(b).result__O());
}
/** @constructor */
function $c_sc_View$$anon$1(it$1) {
  this.sc_View$$anon$1__f_it$1 = null;
  this.sc_View$$anon$1__f_it$1 = it$1;
}
$c_sc_View$$anon$1.prototype = new $h_sc_AbstractView();
$c_sc_View$$anon$1.prototype.constructor = $c_sc_View$$anon$1;
/** @constructor */
function $h_sc_View$$anon$1() {
}
$h_sc_View$$anon$1.prototype = $c_sc_View$$anon$1.prototype;
$c_sc_View$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return $as_sc_Iterator($n(this.sc_View$$anon$1__f_it$1).apply__O());
});
var $d_sc_View$$anon$1 = new $TypeData().initClass($c_sc_View$$anon$1, "scala.collection.View$$anon$1", ({
  sc_View$$anon$1: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
function $ct_sc_View$Appended__sc_IterableOps__O__($thiz, underlying, elem) {
  $thiz.sc_View$Appended__f_underlying = underlying;
  $thiz.sc_View$Appended__f_elem = elem;
  return $thiz;
}
/** @constructor */
function $c_sc_View$Appended() {
  this.sc_View$Appended__f_underlying = null;
  this.sc_View$Appended__f_elem = null;
}
$c_sc_View$Appended.prototype = new $h_sc_AbstractView();
$c_sc_View$Appended.prototype.constructor = $c_sc_View$Appended;
/** @constructor */
function $h_sc_View$Appended() {
}
$h_sc_View$Appended.prototype = $c_sc_View$Appended.prototype;
$c_sc_View$Appended.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_View$Concat(this.sc_View$Appended__f_underlying, new $c_sc_View$Single(this.sc_View$Appended__f_elem)).iterator__sc_Iterator();
});
$c_sc_View$Appended.prototype.knownSize__I = (function() {
  var size = $n(this.sc_View$Appended__f_underlying).knownSize__I();
  return ((size >= 0) ? ((1 + size) | 0) : (-1));
});
$c_sc_View$Appended.prototype.isEmpty__Z = (function() {
  return false;
});
var $d_sc_View$Appended = new $TypeData().initClass($c_sc_View$Appended, "scala.collection.View$Appended", ({
  sc_View$Appended: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_View$Collect(underlying, pf) {
  this.sc_View$Collect__f_underlying = null;
  this.sc_View$Collect__f_pf = null;
  this.sc_View$Collect__f_underlying = underlying;
  this.sc_View$Collect__f_pf = pf;
}
$c_sc_View$Collect.prototype = new $h_sc_AbstractView();
$c_sc_View$Collect.prototype.constructor = $c_sc_View$Collect;
/** @constructor */
function $h_sc_View$Collect() {
}
$h_sc_View$Collect.prototype = $c_sc_View$Collect.prototype;
$c_sc_View$Collect.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_View$Collect__f_underlying).iterator__sc_Iterator());
  var pf = this.sc_View$Collect__f_pf;
  return new $c_sc_Iterator$$anon$7(this$1, pf);
});
var $d_sc_View$Collect = new $TypeData().initClass($c_sc_View$Collect, "scala.collection.View$Collect", ({
  sc_View$Collect: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_View$Concat(prefix, suffix) {
  this.sc_View$Concat__f_prefix = null;
  this.sc_View$Concat__f_suffix = null;
  this.sc_View$Concat__f_prefix = prefix;
  this.sc_View$Concat__f_suffix = suffix;
}
$c_sc_View$Concat.prototype = new $h_sc_AbstractView();
$c_sc_View$Concat.prototype.constructor = $c_sc_View$Concat;
/** @constructor */
function $h_sc_View$Concat() {
}
$h_sc_View$Concat.prototype = $c_sc_View$Concat.prototype;
$c_sc_View$Concat.prototype.iterator__sc_Iterator = (function() {
  var this$2 = $n($n(this.sc_View$Concat__f_prefix).iterator__sc_Iterator());
  var xs = new $c_sjsr_AnonFunction0((() => $n(this.sc_View$Concat__f_suffix).iterator__sc_Iterator()));
  return this$2.concat__F0__sc_Iterator(xs);
});
$c_sc_View$Concat.prototype.knownSize__I = (function() {
  var prefixSize = $n(this.sc_View$Concat__f_prefix).knownSize__I();
  if ((prefixSize >= 0)) {
    var suffixSize = $n(this.sc_View$Concat__f_suffix).knownSize__I();
    return ((suffixSize >= 0) ? ((prefixSize + suffixSize) | 0) : (-1));
  } else {
    return (-1);
  }
});
$c_sc_View$Concat.prototype.isEmpty__Z = (function() {
  return ($n(this.sc_View$Concat__f_prefix).isEmpty__Z() && $n(this.sc_View$Concat__f_suffix).isEmpty__Z());
});
var $d_sc_View$Concat = new $TypeData().initClass($c_sc_View$Concat, "scala.collection.View$Concat", ({
  sc_View$Concat: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_View$DistinctBy(underlying, f) {
  this.sc_View$DistinctBy__f_underlying = null;
  this.sc_View$DistinctBy__f_f = null;
  this.sc_View$DistinctBy__f_underlying = underlying;
  this.sc_View$DistinctBy__f_f = f;
}
$c_sc_View$DistinctBy.prototype = new $h_sc_AbstractView();
$c_sc_View$DistinctBy.prototype.constructor = $c_sc_View$DistinctBy;
/** @constructor */
function $h_sc_View$DistinctBy() {
}
$h_sc_View$DistinctBy.prototype = $c_sc_View$DistinctBy.prototype;
$c_sc_View$DistinctBy.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_View$DistinctBy__f_underlying).iterator__sc_Iterator());
  var f = this.sc_View$DistinctBy__f_f;
  return new $c_sc_Iterator$$anon$8(this$1, f);
});
$c_sc_View$DistinctBy.prototype.knownSize__I = (function() {
  return (($n(this.sc_View$DistinctBy__f_underlying).knownSize__I() === 0) ? 0 : (-1));
});
$c_sc_View$DistinctBy.prototype.isEmpty__Z = (function() {
  return $n(this.sc_View$DistinctBy__f_underlying).isEmpty__Z();
});
var $d_sc_View$DistinctBy = new $TypeData().initClass($c_sc_View$DistinctBy, "scala.collection.View$DistinctBy", ({
  sc_View$DistinctBy: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
function $ct_sc_View$Drop__sc_IterableOps__I__($thiz, underlying, n) {
  $thiz.sc_View$Drop__f_underlying = underlying;
  $thiz.sc_View$Drop__f_n = n;
  $thiz.sc_View$Drop__f_normN = ((n > 0) ? n : 0);
  return $thiz;
}
/** @constructor */
function $c_sc_View$Drop() {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0;
}
$c_sc_View$Drop.prototype = new $h_sc_AbstractView();
$c_sc_View$Drop.prototype.constructor = $c_sc_View$Drop;
/** @constructor */
function $h_sc_View$Drop() {
}
$h_sc_View$Drop.prototype = $c_sc_View$Drop.prototype;
$c_sc_View$Drop.prototype.iterator__sc_Iterator = (function() {
  return $n($n(this.sc_View$Drop__f_underlying).iterator__sc_Iterator()).drop__I__sc_Iterator(this.sc_View$Drop__f_n);
});
$c_sc_View$Drop.prototype.knownSize__I = (function() {
  var size = $n(this.sc_View$Drop__f_underlying).knownSize__I();
  if ((size >= 0)) {
    var x = ((size - this.sc_View$Drop__f_normN) | 0);
    return ((x > 0) ? x : 0);
  } else {
    return (-1);
  }
});
$c_sc_View$Drop.prototype.isEmpty__Z = (function() {
  var this$1 = $n(this.iterator__sc_Iterator());
  return (!this$1.hasNext__Z());
});
var $d_sc_View$Drop = new $TypeData().initClass($c_sc_View$Drop, "scala.collection.View$Drop", ({
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
function $ct_sc_View$DropRight__sc_IterableOps__I__($thiz, underlying, n) {
  $thiz.sc_View$DropRight__f_underlying = underlying;
  $thiz.sc_View$DropRight__f_n = n;
  $thiz.sc_View$DropRight__f_normN = ((n > 0) ? n : 0);
  return $thiz;
}
/** @constructor */
function $c_sc_View$DropRight() {
  this.sc_View$DropRight__f_underlying = null;
  this.sc_View$DropRight__f_n = 0;
  this.sc_View$DropRight__f_normN = 0;
}
$c_sc_View$DropRight.prototype = new $h_sc_AbstractView();
$c_sc_View$DropRight.prototype.constructor = $c_sc_View$DropRight;
/** @constructor */
function $h_sc_View$DropRight() {
}
$h_sc_View$DropRight.prototype = $c_sc_View$DropRight.prototype;
$c_sc_View$DropRight.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_View$().dropRightIterator__sc_Iterator__I__sc_Iterator($n(this.sc_View$DropRight__f_underlying).iterator__sc_Iterator(), this.sc_View$DropRight__f_n);
});
$c_sc_View$DropRight.prototype.knownSize__I = (function() {
  var size = $n(this.sc_View$DropRight__f_underlying).knownSize__I();
  if ((size >= 0)) {
    var x = ((size - this.sc_View$DropRight__f_normN) | 0);
    return ((x > 0) ? x : 0);
  } else {
    return (-1);
  }
});
$c_sc_View$DropRight.prototype.isEmpty__Z = (function() {
  if ((this.knownSize__I() >= 0)) {
    return (this.knownSize__I() === 0);
  } else {
    var this$1 = $n(this.iterator__sc_Iterator());
    return (!this$1.hasNext__Z());
  }
});
var $d_sc_View$DropRight = new $TypeData().initClass($c_sc_View$DropRight, "scala.collection.View$DropRight", ({
  sc_View$DropRight: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_View$DropWhile(underlying, p) {
  this.sc_View$DropWhile__f_underlying = null;
  this.sc_View$DropWhile__f_p = null;
  this.sc_View$DropWhile__f_underlying = underlying;
  this.sc_View$DropWhile__f_p = p;
}
$c_sc_View$DropWhile.prototype = new $h_sc_AbstractView();
$c_sc_View$DropWhile.prototype.constructor = $c_sc_View$DropWhile;
/** @constructor */
function $h_sc_View$DropWhile() {
}
$h_sc_View$DropWhile.prototype = $c_sc_View$DropWhile.prototype;
$c_sc_View$DropWhile.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_View$DropWhile__f_underlying).iterator__sc_Iterator());
  var p = this.sc_View$DropWhile__f_p;
  return new $c_sc_Iterator$$anon$12(this$1, p);
});
$c_sc_View$DropWhile.prototype.knownSize__I = (function() {
  return (($n(this.sc_View$DropWhile__f_underlying).knownSize__I() === 0) ? 0 : (-1));
});
$c_sc_View$DropWhile.prototype.isEmpty__Z = (function() {
  var this$1 = $n(this.iterator__sc_Iterator());
  return (!this$1.hasNext__Z());
});
var $d_sc_View$DropWhile = new $TypeData().initClass($c_sc_View$DropWhile, "scala.collection.View$DropWhile", ({
  sc_View$DropWhile: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_View$Elems(xs) {
  this.sc_View$Elems__f_xs = null;
  this.sc_View$Elems__f_xs = xs;
}
$c_sc_View$Elems.prototype = new $h_sc_AbstractView();
$c_sc_View$Elems.prototype.constructor = $c_sc_View$Elems;
/** @constructor */
function $h_sc_View$Elems() {
}
$h_sc_View$Elems.prototype = $c_sc_View$Elems.prototype;
$c_sc_View$Elems.prototype.iterator__sc_Iterator = (function() {
  return $n(this.sc_View$Elems__f_xs).iterator__sc_Iterator();
});
$c_sc_View$Elems.prototype.knownSize__I = (function() {
  return $n(this.sc_View$Elems__f_xs).knownSize__I();
});
$c_sc_View$Elems.prototype.isEmpty__Z = (function() {
  return $n(this.sc_View$Elems__f_xs).isEmpty__Z();
});
var $d_sc_View$Elems = new $TypeData().initClass($c_sc_View$Elems, "scala.collection.View$Elems", ({
  sc_View$Elems: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_View$Filter(underlying, p, isFlipped) {
  this.sc_View$Filter__f_underlying = null;
  this.sc_View$Filter__f_p = null;
  this.sc_View$Filter__f_isFlipped = false;
  this.sc_View$Filter__f_underlying = underlying;
  this.sc_View$Filter__f_p = p;
  this.sc_View$Filter__f_isFlipped = isFlipped;
}
$c_sc_View$Filter.prototype = new $h_sc_AbstractView();
$c_sc_View$Filter.prototype.constructor = $c_sc_View$Filter;
/** @constructor */
function $h_sc_View$Filter() {
}
$h_sc_View$Filter.prototype = $c_sc_View$Filter.prototype;
$c_sc_View$Filter.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_View$Filter__f_underlying).iterator__sc_Iterator());
  var p = this.sc_View$Filter__f_p;
  var isFlipped = this.sc_View$Filter__f_isFlipped;
  return new $c_sc_Iterator$$anon$6(this$1, p, isFlipped);
});
$c_sc_View$Filter.prototype.knownSize__I = (function() {
  return (($n(this.sc_View$Filter__f_underlying).knownSize__I() === 0) ? 0 : (-1));
});
$c_sc_View$Filter.prototype.isEmpty__Z = (function() {
  var this$1 = $n(this.iterator__sc_Iterator());
  return (!this$1.hasNext__Z());
});
var $d_sc_View$Filter = new $TypeData().initClass($c_sc_View$Filter, "scala.collection.View$Filter", ({
  sc_View$Filter: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_View$FlatMap(underlying, f) {
  this.sc_View$FlatMap__f_underlying = null;
  this.sc_View$FlatMap__f_f = null;
  this.sc_View$FlatMap__f_underlying = underlying;
  this.sc_View$FlatMap__f_f = f;
}
$c_sc_View$FlatMap.prototype = new $h_sc_AbstractView();
$c_sc_View$FlatMap.prototype.constructor = $c_sc_View$FlatMap;
/** @constructor */
function $h_sc_View$FlatMap() {
}
$h_sc_View$FlatMap.prototype = $c_sc_View$FlatMap.prototype;
$c_sc_View$FlatMap.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_View$FlatMap__f_underlying).iterator__sc_Iterator());
  var f = this.sc_View$FlatMap__f_f;
  return new $c_sc_Iterator$$anon$10(this$1, f);
});
$c_sc_View$FlatMap.prototype.knownSize__I = (function() {
  return (($n(this.sc_View$FlatMap__f_underlying).knownSize__I() === 0) ? 0 : (-1));
});
$c_sc_View$FlatMap.prototype.isEmpty__Z = (function() {
  var this$1 = $n(this.iterator__sc_Iterator());
  return (!this$1.hasNext__Z());
});
var $d_sc_View$FlatMap = new $TypeData().initClass($c_sc_View$FlatMap, "scala.collection.View$FlatMap", ({
  sc_View$FlatMap: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
function $ct_sc_View$Map__sc_IterableOps__F1__($thiz, underlying, f) {
  $thiz.sc_View$Map__f_underlying = underlying;
  $thiz.sc_View$Map__f_f = f;
  return $thiz;
}
/** @constructor */
function $c_sc_View$Map() {
  this.sc_View$Map__f_underlying = null;
  this.sc_View$Map__f_f = null;
}
$c_sc_View$Map.prototype = new $h_sc_AbstractView();
$c_sc_View$Map.prototype.constructor = $c_sc_View$Map;
/** @constructor */
function $h_sc_View$Map() {
}
$h_sc_View$Map.prototype = $c_sc_View$Map.prototype;
$c_sc_View$Map.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_View$Map__f_underlying).iterator__sc_Iterator());
  var f = this.sc_View$Map__f_f;
  return new $c_sc_Iterator$$anon$9(this$1, f);
});
$c_sc_View$Map.prototype.knownSize__I = (function() {
  return $n(this.sc_View$Map__f_underlying).knownSize__I();
});
$c_sc_View$Map.prototype.isEmpty__Z = (function() {
  return $n(this.sc_View$Map__f_underlying).isEmpty__Z();
});
var $d_sc_View$Map = new $TypeData().initClass($c_sc_View$Map, "scala.collection.View$Map", ({
  sc_View$Map: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_View$PadTo(underlying, len, elem) {
  this.sc_View$PadTo__f_underlying = null;
  this.sc_View$PadTo__f_len = 0;
  this.sc_View$PadTo__f_elem = null;
  this.sc_View$PadTo__f_underlying = underlying;
  this.sc_View$PadTo__f_len = len;
  this.sc_View$PadTo__f_elem = elem;
}
$c_sc_View$PadTo.prototype = new $h_sc_AbstractView();
$c_sc_View$PadTo.prototype.constructor = $c_sc_View$PadTo;
/** @constructor */
function $h_sc_View$PadTo() {
}
$h_sc_View$PadTo.prototype = $c_sc_View$PadTo.prototype;
$c_sc_View$PadTo.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_View$PadTo__f_underlying).iterator__sc_Iterator());
  var len = this.sc_View$PadTo__f_len;
  var elem = this.sc_View$PadTo__f_elem;
  return new $c_sc_Iterator$$anon$2(this$1, len, elem);
});
$c_sc_View$PadTo.prototype.knownSize__I = (function() {
  var size = $n(this.sc_View$PadTo__f_underlying).knownSize__I();
  if ((size >= 0)) {
    var that = this.sc_View$PadTo__f_len;
    return ((size > that) ? size : that);
  } else {
    return (-1);
  }
});
$c_sc_View$PadTo.prototype.isEmpty__Z = (function() {
  return ($n(this.sc_View$PadTo__f_underlying).isEmpty__Z() && (this.sc_View$PadTo__f_len <= 0));
});
var $d_sc_View$PadTo = new $TypeData().initClass($c_sc_View$PadTo, "scala.collection.View$PadTo", ({
  sc_View$PadTo: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
function $ct_sc_View$Prepended__O__sc_IterableOps__($thiz, elem, underlying) {
  $thiz.sc_View$Prepended__f_elem = elem;
  $thiz.sc_View$Prepended__f_underlying = underlying;
  return $thiz;
}
/** @constructor */
function $c_sc_View$Prepended() {
  this.sc_View$Prepended__f_elem = null;
  this.sc_View$Prepended__f_underlying = null;
}
$c_sc_View$Prepended.prototype = new $h_sc_AbstractView();
$c_sc_View$Prepended.prototype.constructor = $c_sc_View$Prepended;
/** @constructor */
function $h_sc_View$Prepended() {
}
$h_sc_View$Prepended.prototype = $c_sc_View$Prepended.prototype;
$c_sc_View$Prepended.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_View$Concat(new $c_sc_View$Single(this.sc_View$Prepended__f_elem), this.sc_View$Prepended__f_underlying).iterator__sc_Iterator();
});
$c_sc_View$Prepended.prototype.knownSize__I = (function() {
  var size = $n(this.sc_View$Prepended__f_underlying).knownSize__I();
  return ((size >= 0) ? ((1 + size) | 0) : (-1));
});
$c_sc_View$Prepended.prototype.isEmpty__Z = (function() {
  return false;
});
var $d_sc_View$Prepended = new $TypeData().initClass($c_sc_View$Prepended, "scala.collection.View$Prepended", ({
  sc_View$Prepended: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_View$Single(a) {
  this.sc_View$Single__f_a = null;
  this.sc_View$Single__f_a = a;
}
$c_sc_View$Single.prototype = new $h_sc_AbstractView();
$c_sc_View$Single.prototype.constructor = $c_sc_View$Single;
/** @constructor */
function $h_sc_View$Single() {
}
$h_sc_View$Single.prototype = $c_sc_View$Single.prototype;
$c_sc_View$Single.prototype.iterator__sc_Iterator = (function() {
  var a = this.sc_View$Single__f_a;
  return new $c_sc_Iterator$$anon$20(a);
});
$c_sc_View$Single.prototype.knownSize__I = (function() {
  return 1;
});
$c_sc_View$Single.prototype.isEmpty__Z = (function() {
  return false;
});
var $d_sc_View$Single = new $TypeData().initClass($c_sc_View$Single, "scala.collection.View$Single", ({
  sc_View$Single: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
function $ct_sc_View$Take__sc_IterableOps__I__($thiz, underlying, n) {
  $thiz.sc_View$Take__f_underlying = underlying;
  $thiz.sc_View$Take__f_n = n;
  $thiz.sc_View$Take__f_normN = ((n > 0) ? n : 0);
  return $thiz;
}
/** @constructor */
function $c_sc_View$Take() {
  this.sc_View$Take__f_underlying = null;
  this.sc_View$Take__f_n = 0;
  this.sc_View$Take__f_normN = 0;
}
$c_sc_View$Take.prototype = new $h_sc_AbstractView();
$c_sc_View$Take.prototype.constructor = $c_sc_View$Take;
/** @constructor */
function $h_sc_View$Take() {
}
$h_sc_View$Take.prototype = $c_sc_View$Take.prototype;
$c_sc_View$Take.prototype.iterator__sc_Iterator = (function() {
  return $n($n(this.sc_View$Take__f_underlying).iterator__sc_Iterator()).take__I__sc_Iterator(this.sc_View$Take__f_n);
});
$c_sc_View$Take.prototype.knownSize__I = (function() {
  var size = $n(this.sc_View$Take__f_underlying).knownSize__I();
  if ((size >= 0)) {
    var that = this.sc_View$Take__f_normN;
    return ((size < that) ? size : that);
  } else {
    return (-1);
  }
});
$c_sc_View$Take.prototype.isEmpty__Z = (function() {
  var this$1 = $n(this.iterator__sc_Iterator());
  return (!this$1.hasNext__Z());
});
var $d_sc_View$Take = new $TypeData().initClass($c_sc_View$Take, "scala.collection.View$Take", ({
  sc_View$Take: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_View$TakeWhile(underlying, p) {
  this.sc_View$TakeWhile__f_underlying = null;
  this.sc_View$TakeWhile__f_p = null;
  this.sc_View$TakeWhile__f_underlying = underlying;
  this.sc_View$TakeWhile__f_p = p;
}
$c_sc_View$TakeWhile.prototype = new $h_sc_AbstractView();
$c_sc_View$TakeWhile.prototype.constructor = $c_sc_View$TakeWhile;
/** @constructor */
function $h_sc_View$TakeWhile() {
}
$h_sc_View$TakeWhile.prototype = $c_sc_View$TakeWhile.prototype;
$c_sc_View$TakeWhile.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_View$TakeWhile__f_underlying).iterator__sc_Iterator());
  var p = this.sc_View$TakeWhile__f_p;
  return new $c_sc_Iterator$$anon$11(this$1, p);
});
$c_sc_View$TakeWhile.prototype.knownSize__I = (function() {
  return (($n(this.sc_View$TakeWhile__f_underlying).knownSize__I() === 0) ? 0 : (-1));
});
$c_sc_View$TakeWhile.prototype.isEmpty__Z = (function() {
  var this$1 = $n(this.iterator__sc_Iterator());
  return (!this$1.hasNext__Z());
});
var $d_sc_View$TakeWhile = new $TypeData().initClass($c_sc_View$TakeWhile, "scala.collection.View$TakeWhile", ({
  sc_View$TakeWhile: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_View$Zip(underlying, other) {
  this.sc_View$Zip__f_underlying = null;
  this.sc_View$Zip__f_other = null;
  this.sc_View$Zip__f_underlying = underlying;
  this.sc_View$Zip__f_other = other;
}
$c_sc_View$Zip.prototype = new $h_sc_AbstractView();
$c_sc_View$Zip.prototype.constructor = $c_sc_View$Zip;
/** @constructor */
function $h_sc_View$Zip() {
}
$h_sc_View$Zip.prototype = $c_sc_View$Zip.prototype;
$c_sc_View$Zip.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_View$Zip__f_underlying).iterator__sc_Iterator());
  var that = this.sc_View$Zip__f_other;
  return new $c_sc_Iterator$$anon$14(this$1, that);
});
$c_sc_View$Zip.prototype.knownSize__I = (function() {
  var s1 = $n(this.sc_View$Zip__f_underlying).knownSize__I();
  if ((s1 === 0)) {
    return 0;
  } else {
    var s2 = $n(this.sc_View$Zip__f_other).knownSize__I();
    return ((s2 === 0) ? 0 : ((s1 < s2) ? s1 : s2));
  }
});
$c_sc_View$Zip.prototype.isEmpty__Z = (function() {
  return ($n(this.sc_View$Zip__f_underlying).isEmpty__Z() || $n(this.sc_View$Zip__f_other).isEmpty__Z());
});
var $d_sc_View$Zip = new $TypeData().initClass($c_sc_View$Zip, "scala.collection.View$Zip", ({
  sc_View$Zip: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_View$ZipWithIndex(underlying) {
  this.sc_View$ZipWithIndex__f_underlying = null;
  this.sc_View$ZipWithIndex__f_underlying = underlying;
}
$c_sc_View$ZipWithIndex.prototype = new $h_sc_AbstractView();
$c_sc_View$ZipWithIndex.prototype.constructor = $c_sc_View$ZipWithIndex;
/** @constructor */
function $h_sc_View$ZipWithIndex() {
}
$h_sc_View$ZipWithIndex.prototype = $c_sc_View$ZipWithIndex.prototype;
$c_sc_View$ZipWithIndex.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_View$ZipWithIndex__f_underlying).iterator__sc_Iterator());
  return new $c_sc_Iterator$$anon$16(this$1);
});
$c_sc_View$ZipWithIndex.prototype.knownSize__I = (function() {
  return $n(this.sc_View$ZipWithIndex__f_underlying).knownSize__I();
});
$c_sc_View$ZipWithIndex.prototype.isEmpty__Z = (function() {
  return $n(this.sc_View$ZipWithIndex__f_underlying).isEmpty__Z();
});
var $d_sc_View$ZipWithIndex = new $TypeData().initClass($c_sc_View$ZipWithIndex, "scala.collection.View$ZipWithIndex", ({
  sc_View$ZipWithIndex: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_math_Numeric$ByteIsIntegral$() {
}
$c_s_math_Numeric$ByteIsIntegral$.prototype = new $h_O();
$c_s_math_Numeric$ByteIsIntegral$.prototype.constructor = $c_s_math_Numeric$ByteIsIntegral$;
/** @constructor */
function $h_s_math_Numeric$ByteIsIntegral$() {
}
$h_s_math_Numeric$ByteIsIntegral$.prototype = $c_s_math_Numeric$ByteIsIntegral$.prototype;
$c_s_math_Numeric$ByteIsIntegral$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.sign__O__O = (function(x) {
  var x$1 = $uB(x);
  return $f_s_math_Numeric$ByteIsIntegral__sign__B__B(this, x$1);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.toInt__O__I = (function(x) {
  var x$1 = $uB(x);
  return x$1;
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.fromInt__I__O = (function(x) {
  return ((x << 24) >> 24);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.negate__O__O = (function(x) {
  var x$1 = $uB(x);
  return $f_s_math_Numeric$ByteIsIntegral__negate__B__B(this, x$1);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.rem__O__O__O = (function(x, y) {
  var x$1 = $uB(x);
  var y$1 = $uB(y);
  return $f_s_math_Numeric$ByteIsIntegral__rem__B__B__B(this, x$1, y$1);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.quot__O__O__O = (function(x, y) {
  var x$1 = $uB(x);
  var y$1 = $uB(y);
  return $f_s_math_Numeric$ByteIsIntegral__quot__B__B__B(this, x$1, y$1);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.times__O__O__O = (function(x, y) {
  var x$1 = $uB(x);
  var y$1 = $uB(y);
  return $f_s_math_Numeric$ByteIsIntegral__times__B__B__B(this, x$1, y$1);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.minus__O__O__O = (function(x, y) {
  var x$1 = $uB(x);
  var y$1 = $uB(y);
  return $f_s_math_Numeric$ByteIsIntegral__minus__B__B__B(this, x$1, y$1);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.plus__O__O__O = (function(x, y) {
  var x$1 = $uB(x);
  var y$1 = $uB(y);
  return $f_s_math_Numeric$ByteIsIntegral__plus__B__B__B(this, x$1, y$1);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uB(x);
  var y$1 = $uB(y);
  return ((x$1 - y$1) | 0);
});
var $d_s_math_Numeric$ByteIsIntegral$ = new $TypeData().initClass($c_s_math_Numeric$ByteIsIntegral$, "scala.math.Numeric$ByteIsIntegral$", ({
  s_math_Numeric$ByteIsIntegral$: 1,
  s_math_Numeric$ByteIsIntegral: 1,
  s_math_Integral: 1,
  s_math_Numeric: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordering$ByteOrdering: 1
}));
var $n_s_math_Numeric$ByteIsIntegral$;
function $m_s_math_Numeric$ByteIsIntegral$() {
  if ((!$n_s_math_Numeric$ByteIsIntegral$)) {
    $n_s_math_Numeric$ByteIsIntegral$ = new $c_s_math_Numeric$ByteIsIntegral$();
  }
  return $n_s_math_Numeric$ByteIsIntegral$;
}
/** @constructor */
function $c_s_math_Numeric$CharIsIntegral$() {
}
$c_s_math_Numeric$CharIsIntegral$.prototype = new $h_O();
$c_s_math_Numeric$CharIsIntegral$.prototype.constructor = $c_s_math_Numeric$CharIsIntegral$;
/** @constructor */
function $h_s_math_Numeric$CharIsIntegral$() {
}
$h_s_math_Numeric$CharIsIntegral$.prototype = $c_s_math_Numeric$CharIsIntegral$.prototype;
$c_s_math_Numeric$CharIsIntegral$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_Numeric$CharIsIntegral$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Numeric$CharIsIntegral$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_Numeric$CharIsIntegral$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Numeric$CharIsIntegral$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Numeric$CharIsIntegral$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Numeric$CharIsIntegral$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Numeric$CharIsIntegral$.prototype.sign__O__O = (function(x) {
  var x$1 = $uC(x);
  return $bC($f_s_math_Numeric$CharIsIntegral__sign__C__C(this, x$1));
});
$c_s_math_Numeric$CharIsIntegral$.prototype.toInt__O__I = (function(x) {
  var x$1 = $uC(x);
  return x$1;
});
$c_s_math_Numeric$CharIsIntegral$.prototype.fromInt__I__O = (function(x) {
  return $bC((65535 & x));
});
$c_s_math_Numeric$CharIsIntegral$.prototype.negate__O__O = (function(x) {
  var x$1 = $uC(x);
  return $bC($f_s_math_Numeric$CharIsIntegral__negate__C__C(this, x$1));
});
$c_s_math_Numeric$CharIsIntegral$.prototype.rem__O__O__O = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return $bC($f_s_math_Numeric$CharIsIntegral__rem__C__C__C(this, x$1, y$1));
});
$c_s_math_Numeric$CharIsIntegral$.prototype.quot__O__O__O = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return $bC($f_s_math_Numeric$CharIsIntegral__quot__C__C__C(this, x$1, y$1));
});
$c_s_math_Numeric$CharIsIntegral$.prototype.times__O__O__O = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return $bC($f_s_math_Numeric$CharIsIntegral__times__C__C__C(this, x$1, y$1));
});
$c_s_math_Numeric$CharIsIntegral$.prototype.minus__O__O__O = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return $bC($f_s_math_Numeric$CharIsIntegral__minus__C__C__C(this, x$1, y$1));
});
$c_s_math_Numeric$CharIsIntegral$.prototype.plus__O__O__O = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return $bC($f_s_math_Numeric$CharIsIntegral__plus__C__C__C(this, x$1, y$1));
});
$c_s_math_Numeric$CharIsIntegral$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return ((x$1 - y$1) | 0);
});
var $d_s_math_Numeric$CharIsIntegral$ = new $TypeData().initClass($c_s_math_Numeric$CharIsIntegral$, "scala.math.Numeric$CharIsIntegral$", ({
  s_math_Numeric$CharIsIntegral$: 1,
  s_math_Numeric$CharIsIntegral: 1,
  s_math_Integral: 1,
  s_math_Numeric: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordering$CharOrdering: 1
}));
var $n_s_math_Numeric$CharIsIntegral$;
function $m_s_math_Numeric$CharIsIntegral$() {
  if ((!$n_s_math_Numeric$CharIsIntegral$)) {
    $n_s_math_Numeric$CharIsIntegral$ = new $c_s_math_Numeric$CharIsIntegral$();
  }
  return $n_s_math_Numeric$CharIsIntegral$;
}
/** @constructor */
function $c_s_math_Numeric$IntIsIntegral$() {
}
$c_s_math_Numeric$IntIsIntegral$.prototype = new $h_O();
$c_s_math_Numeric$IntIsIntegral$.prototype.constructor = $c_s_math_Numeric$IntIsIntegral$;
/** @constructor */
function $h_s_math_Numeric$IntIsIntegral$() {
}
$h_s_math_Numeric$IntIsIntegral$.prototype = $c_s_math_Numeric$IntIsIntegral$.prototype;
$c_s_math_Numeric$IntIsIntegral$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.sign__O__O = (function(x) {
  var x$1 = $uI(x);
  return ((x$1 === 0) ? 0 : ((x$1 < 0) ? (-1) : 1));
});
$c_s_math_Numeric$IntIsIntegral$.prototype.toInt__O__I = (function(x) {
  var x$1 = $uI(x);
  return x$1;
});
$c_s_math_Numeric$IntIsIntegral$.prototype.fromInt__I__O = (function(x) {
  return x;
});
$c_s_math_Numeric$IntIsIntegral$.prototype.negate__O__O = (function(x) {
  var x$1 = $uI(x);
  return $f_s_math_Numeric$IntIsIntegral__negate__I__I(this, x$1);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.rem__O__O__O = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return $f_s_math_Numeric$IntIsIntegral__rem__I__I__I(this, x$1, y$1);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.quot__O__O__O = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return $f_s_math_Numeric$IntIsIntegral__quot__I__I__I(this, x$1, y$1);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.times__O__O__O = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return $f_s_math_Numeric$IntIsIntegral__times__I__I__I(this, x$1, y$1);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.minus__O__O__O = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return $f_s_math_Numeric$IntIsIntegral__minus__I__I__I(this, x$1, y$1);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.plus__O__O__O = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return $f_s_math_Numeric$IntIsIntegral__plus__I__I__I(this, x$1, y$1);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return ((x$1 === y$1) ? 0 : ((x$1 < y$1) ? (-1) : 1));
});
var $d_s_math_Numeric$IntIsIntegral$ = new $TypeData().initClass($c_s_math_Numeric$IntIsIntegral$, "scala.math.Numeric$IntIsIntegral$", ({
  s_math_Numeric$IntIsIntegral$: 1,
  s_math_Numeric$IntIsIntegral: 1,
  s_math_Integral: 1,
  s_math_Numeric: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordering$IntOrdering: 1
}));
var $n_s_math_Numeric$IntIsIntegral$;
function $m_s_math_Numeric$IntIsIntegral$() {
  if ((!$n_s_math_Numeric$IntIsIntegral$)) {
    $n_s_math_Numeric$IntIsIntegral$ = new $c_s_math_Numeric$IntIsIntegral$();
  }
  return $n_s_math_Numeric$IntIsIntegral$;
}
/** @constructor */
function $c_s_math_Numeric$LongIsIntegral$() {
}
$c_s_math_Numeric$LongIsIntegral$.prototype = new $h_O();
$c_s_math_Numeric$LongIsIntegral$.prototype.constructor = $c_s_math_Numeric$LongIsIntegral$;
/** @constructor */
function $h_s_math_Numeric$LongIsIntegral$() {
}
$h_s_math_Numeric$LongIsIntegral$.prototype = $c_s_math_Numeric$LongIsIntegral$.prototype;
$c_s_math_Numeric$LongIsIntegral$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.sign__O__O = (function(x) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return $m_s_math_package$().signum__J__J(new $c_RTLong(lo, hi));
});
$c_s_math_Numeric$LongIsIntegral$.prototype.toInt__O__I = (function(x) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  return lo;
});
$c_s_math_Numeric$LongIsIntegral$.prototype.fromInt__I__O = (function(x) {
  var hi = (x >> 31);
  return new $c_RTLong(x, hi);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.negate__O__O = (function(x) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return $f_s_math_Numeric$LongIsIntegral__negate__J__J(this, new $c_RTLong(lo, hi));
});
$c_s_math_Numeric$LongIsIntegral$.prototype.rem__O__O__O = (function(x, y) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(y);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return $f_s_math_Numeric$LongIsIntegral__rem__J__J__J(this, new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1));
});
$c_s_math_Numeric$LongIsIntegral$.prototype.quot__O__O__O = (function(x, y) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(y);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return $f_s_math_Numeric$LongIsIntegral__quot__J__J__J(this, new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1));
});
$c_s_math_Numeric$LongIsIntegral$.prototype.times__O__O__O = (function(x, y) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(y);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return $f_s_math_Numeric$LongIsIntegral__times__J__J__J(this, new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1));
});
$c_s_math_Numeric$LongIsIntegral$.prototype.minus__O__O__O = (function(x, y) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(y);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return $f_s_math_Numeric$LongIsIntegral__minus__J__J__J(this, new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1));
});
$c_s_math_Numeric$LongIsIntegral$.prototype.plus__O__O__O = (function(x, y) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(y);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return $f_s_math_Numeric$LongIsIntegral__plus__J__J__J(this, new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1));
});
$c_s_math_Numeric$LongIsIntegral$.prototype.compare__O__O__I = (function(x, y) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(y);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1);
});
var $d_s_math_Numeric$LongIsIntegral$ = new $TypeData().initClass($c_s_math_Numeric$LongIsIntegral$, "scala.math.Numeric$LongIsIntegral$", ({
  s_math_Numeric$LongIsIntegral$: 1,
  s_math_Numeric$LongIsIntegral: 1,
  s_math_Integral: 1,
  s_math_Numeric: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordering$LongOrdering: 1
}));
var $n_s_math_Numeric$LongIsIntegral$;
function $m_s_math_Numeric$LongIsIntegral$() {
  if ((!$n_s_math_Numeric$LongIsIntegral$)) {
    $n_s_math_Numeric$LongIsIntegral$ = new $c_s_math_Numeric$LongIsIntegral$();
  }
  return $n_s_math_Numeric$LongIsIntegral$;
}
/** @constructor */
function $c_s_math_Numeric$ShortIsIntegral$() {
}
$c_s_math_Numeric$ShortIsIntegral$.prototype = new $h_O();
$c_s_math_Numeric$ShortIsIntegral$.prototype.constructor = $c_s_math_Numeric$ShortIsIntegral$;
/** @constructor */
function $h_s_math_Numeric$ShortIsIntegral$() {
}
$h_s_math_Numeric$ShortIsIntegral$.prototype = $c_s_math_Numeric$ShortIsIntegral$.prototype;
$c_s_math_Numeric$ShortIsIntegral$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.sign__O__O = (function(x) {
  var x$1 = $uS(x);
  return $f_s_math_Numeric$ShortIsIntegral__sign__S__S(this, x$1);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.toInt__O__I = (function(x) {
  var x$1 = $uS(x);
  return x$1;
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.fromInt__I__O = (function(x) {
  return ((x << 16) >> 16);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.negate__O__O = (function(x) {
  var x$1 = $uS(x);
  return $f_s_math_Numeric$ShortIsIntegral__negate__S__S(this, x$1);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.rem__O__O__O = (function(x, y) {
  var x$1 = $uS(x);
  var y$1 = $uS(y);
  return $f_s_math_Numeric$ShortIsIntegral__rem__S__S__S(this, x$1, y$1);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.quot__O__O__O = (function(x, y) {
  var x$1 = $uS(x);
  var y$1 = $uS(y);
  return $f_s_math_Numeric$ShortIsIntegral__quot__S__S__S(this, x$1, y$1);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.times__O__O__O = (function(x, y) {
  var x$1 = $uS(x);
  var y$1 = $uS(y);
  return $f_s_math_Numeric$ShortIsIntegral__times__S__S__S(this, x$1, y$1);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.minus__O__O__O = (function(x, y) {
  var x$1 = $uS(x);
  var y$1 = $uS(y);
  return $f_s_math_Numeric$ShortIsIntegral__minus__S__S__S(this, x$1, y$1);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.plus__O__O__O = (function(x, y) {
  var x$1 = $uS(x);
  var y$1 = $uS(y);
  return $f_s_math_Numeric$ShortIsIntegral__plus__S__S__S(this, x$1, y$1);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uS(x);
  var y$1 = $uS(y);
  return ((x$1 - y$1) | 0);
});
var $d_s_math_Numeric$ShortIsIntegral$ = new $TypeData().initClass($c_s_math_Numeric$ShortIsIntegral$, "scala.math.Numeric$ShortIsIntegral$", ({
  s_math_Numeric$ShortIsIntegral$: 1,
  s_math_Numeric$ShortIsIntegral: 1,
  s_math_Integral: 1,
  s_math_Numeric: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordering$ShortOrdering: 1
}));
var $n_s_math_Numeric$ShortIsIntegral$;
function $m_s_math_Numeric$ShortIsIntegral$() {
  if ((!$n_s_math_Numeric$ShortIsIntegral$)) {
    $n_s_math_Numeric$ShortIsIntegral$ = new $c_s_math_Numeric$ShortIsIntegral$();
  }
  return $n_s_math_Numeric$ShortIsIntegral$;
}
function $f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive($thiz, end) {
  $m_sci_NumericRange$();
  var start = $thiz.self__O();
  var this$1 = $n($thiz.num__s_math_Integral());
  var step = this$1.fromInt__I__O(1);
  var num = $thiz.num__s_math_Integral();
  return new $c_sci_NumericRange$Inclusive(start, end, step, num);
}
/** @constructor */
function $c_Ltyrian_runtime_RendererState$$anon$1(\u03b4name$2, _$ordinal$2, outer) {
  this.Ltyrian_runtime_RendererState$$anon$1__f_$name$1 = null;
  this.Ltyrian_runtime_RendererState$$anon$1__f_$name$1 = \u03b4name$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Ltyrian_runtime_RendererState$$anon$1.prototype = new $h_Ltyrian_runtime_RendererState();
$c_Ltyrian_runtime_RendererState$$anon$1.prototype.constructor = $c_Ltyrian_runtime_RendererState$$anon$1;
/** @constructor */
function $h_Ltyrian_runtime_RendererState$$anon$1() {
}
$h_Ltyrian_runtime_RendererState$$anon$1.prototype = $c_Ltyrian_runtime_RendererState$$anon$1.prototype;
$c_Ltyrian_runtime_RendererState$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Ltyrian_runtime_RendererState$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ltyrian_runtime_RendererState$$anon$1.prototype.productPrefix__T = (function() {
  return this.Ltyrian_runtime_RendererState$$anon$1__f_$name$1;
});
$c_Ltyrian_runtime_RendererState$$anon$1.prototype.toString__T = (function() {
  return this.Ltyrian_runtime_RendererState$$anon$1__f_$name$1;
});
var $d_Ltyrian_runtime_RendererState$$anon$1 = new $TypeData().initClass($c_Ltyrian_runtime_RendererState$$anon$1, "tyrian.runtime.RendererState$$anon$1", ({
  Ltyrian_runtime_RendererState$$anon$1: 1,
  Ltyrian_runtime_RendererState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Lcats_data_KleisliInstances0() {
}
$c_Lcats_data_KleisliInstances0.prototype = new $h_Lcats_data_KleisliInstances0\uff3f5();
$c_Lcats_data_KleisliInstances0.prototype.constructor = $c_Lcats_data_KleisliInstances0;
/** @constructor */
function $h_Lcats_data_KleisliInstances0() {
}
$h_Lcats_data_KleisliInstances0.prototype = $c_Lcats_data_KleisliInstances0.prototype;
/** @constructor */
function $c_Lcats_effect_kernel_implicits$() {
}
$c_Lcats_effect_kernel_implicits$.prototype = new $h_O();
$c_Lcats_effect_kernel_implicits$.prototype.constructor = $c_Lcats_effect_kernel_implicits$;
/** @constructor */
function $h_Lcats_effect_kernel_implicits$() {
}
$h_Lcats_effect_kernel_implicits$.prototype = $c_Lcats_effect_kernel_implicits$.prototype;
var $d_Lcats_effect_kernel_implicits$ = new $TypeData().initClass($c_Lcats_effect_kernel_implicits$, "cats.effect.kernel.implicits$", ({
  Lcats_effect_kernel_implicits$: 1,
  Lcats_effect_kernel_syntax_MonadCancelSyntax: 1,
  Lcats_effect_kernel_syntax_GenSpawnSyntax: 1,
  Lcats_effect_kernel_syntax_GenTemporalSyntax: 1,
  Lcats_effect_kernel_syntax_GenConcurrentSyntax: 1,
  Lcats_effect_kernel_syntax_AsyncSyntax: 1,
  Lcats_effect_kernel_syntax_ResourceSyntax: 1,
  Lcats_effect_kernel_syntax_ClockSyntax: 1,
  Lcats_effect_kernel_syntax_AllSyntax: 1,
  Lcats_effect_kernel_instances_GenSpawnInstances: 1,
  Lcats_effect_kernel_instances_AllInstances: 1
}));
var $n_Lcats_effect_kernel_implicits$;
function $m_Lcats_effect_kernel_implicits$() {
  if ((!$n_Lcats_effect_kernel_implicits$)) {
    $n_Lcats_effect_kernel_implicits$ = new $c_Lcats_effect_kernel_implicits$();
  }
  return $n_Lcats_effect_kernel_implicits$;
}
/** @constructor */
function $c_Lcats_kernel_instances_UnitAlgebra() {
}
$c_Lcats_kernel_instances_UnitAlgebra.prototype = new $h_O();
$c_Lcats_kernel_instances_UnitAlgebra.prototype.constructor = $c_Lcats_kernel_instances_UnitAlgebra;
/** @constructor */
function $h_Lcats_kernel_instances_UnitAlgebra() {
}
$h_Lcats_kernel_instances_UnitAlgebra.prototype = $c_Lcats_kernel_instances_UnitAlgebra.prototype;
$c_Lcats_kernel_instances_UnitAlgebra.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_UnitAlgebra.prototype.combineAllOption__sc_IterableOnce__s_Option = (function(as) {
  var this$1 = $n($n(as).iterator__sc_Iterator());
  if ((!this$1.hasNext__Z())) {
    return $m_s_None$();
  } else {
    return new $c_s_Some((void 0));
  }
});
$c_Lcats_kernel_instances_UnitAlgebra.prototype.empty__O = (function() {
  return (void 0);
});
$c_Lcats_kernel_instances_UnitAlgebra.prototype.combine__O__O__O = (function(x, y) {
  $as_jl_Void(x);
  $as_jl_Void(y);
});
var $d_Lcats_kernel_instances_UnitAlgebra = new $TypeData().initClass($c_Lcats_kernel_instances_UnitAlgebra, "cats.kernel.instances.UnitAlgebra", ({
  Lcats_kernel_instances_UnitAlgebra: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Band: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_Semilattice: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_BoundedSemilattice: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_BlockDirectives$DirectiveInstance(directive, parsedResult, parser, source, rewriteRules, options) {
  this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_directive = null;
  this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_parsedResult = null;
  this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_parser = null;
  this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_source = null;
  this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_rewriteRules = null;
  this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_options = null;
  this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_typeName = null;
  this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_unresolvedMessage$lzy3 = null;
  this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_unresolvedMessagebitmap$3 = false;
  this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_directive = directive;
  this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_parsedResult = parsedResult;
  this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_parser = parser;
  this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_source = source;
  this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_rewriteRules = rewriteRules;
  this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_options = options;
  this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_typeName = "block";
}
$c_Llaika_api_bundle_BlockDirectives$DirectiveInstance.prototype = new $h_Llaika_ast_Element();
$c_Llaika_api_bundle_BlockDirectives$DirectiveInstance.prototype.constructor = $c_Llaika_api_bundle_BlockDirectives$DirectiveInstance;
/** @constructor */
function $h_Llaika_api_bundle_BlockDirectives$DirectiveInstance() {
}
$h_Llaika_api_bundle_BlockDirectives$DirectiveInstance.prototype = $c_Llaika_api_bundle_BlockDirectives$DirectiveInstance.prototype;
$c_Llaika_api_bundle_BlockDirectives$DirectiveInstance.prototype.runsIn__Llaika_ast_RewritePhase__Z = (function(phase) {
  return $f_Llaika_api_bundle_DirectiveBuilderContext$DirectiveInstanceBase__runsIn__Llaika_ast_RewritePhase__Z(this, phase);
});
$c_Llaika_api_bundle_BlockDirectives$DirectiveInstance.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_bundle_BlockDirectives$DirectiveInstance.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_bundle_BlockDirectives$DirectiveInstance)) {
    var x$0$2 = $as_Llaika_api_bundle_BlockDirectives$DirectiveInstance(x$0);
    var x = this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_directive;
    var x$2 = $n(x$0$2).Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_directive;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_parsedResult;
      var x$4 = $n(x$0$2).Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_parsedResult;
      var $x_5 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$5 = this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_parser;
      var x$6 = $n(x$0$2).Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_parser;
      if ((x$5 === null)) {
        var $x_4 = (x$6 === null);
      } else {
        var this$1 = $n(x$5);
        var $x_4 = (this$1 === x$6);
      }
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$7 = this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_source;
      var x$8 = $n(x$0$2).Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_source;
      var $x_3 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$9 = this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_rewriteRules;
      var x$10 = $n(x$0$2).Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_rewriteRules;
      if ((x$9 === null)) {
        var $x_2 = (x$10 === null);
      } else {
        var this$2 = $n(x$9);
        var $x_2 = (this$2 === x$10);
      }
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$11 = this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_options;
      var x$12 = $n(x$0$2).Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_options;
      var $x_1 = ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_bundle_BlockDirectives$DirectiveInstance.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_bundle_BlockDirectives$DirectiveInstance.prototype.productArity__I = (function() {
  return 6;
});
$c_Llaika_api_bundle_BlockDirectives$DirectiveInstance.prototype.productPrefix__T = (function() {
  return "DirectiveInstance";
});
$c_Llaika_api_bundle_BlockDirectives$DirectiveInstance.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_directive;
      break;
    }
    case 1: {
      return this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_parsedResult;
      break;
    }
    case 2: {
      return this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_parser;
      break;
    }
    case 3: {
      return this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_source;
      break;
    }
    case 4: {
      return this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_rewriteRules;
      break;
    }
    case 5: {
      return this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_api_bundle_BlockDirectives$DirectiveInstance.prototype.directive__s_Option = (function() {
  return this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_directive;
});
$c_Llaika_api_bundle_BlockDirectives$DirectiveInstance.prototype.parsedResult__Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective = (function() {
  return this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_parsedResult;
});
$c_Llaika_api_bundle_BlockDirectives$DirectiveInstance.prototype.source__Llaika_parse_SourceFragment = (function() {
  return this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_source;
});
$c_Llaika_api_bundle_BlockDirectives$DirectiveInstance.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_options;
});
$c_Llaika_api_bundle_BlockDirectives$DirectiveInstance.prototype.typeName__T = (function() {
  return this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_typeName;
});
$c_Llaika_api_bundle_BlockDirectives$DirectiveInstance.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_api_bundle_BlockDirectives$DirectiveInstance = (function(rules) {
  var rewriteRules$2 = $n(this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_rewriteRules).$plus$plus__Llaika_ast_RewriteRules__Llaika_ast_RewriteRules(rules);
  var directive$2 = this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_directive;
  var parsedResult$2 = this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_parsedResult;
  var parser$2 = this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_parser;
  var source$2 = this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_source;
  var options$2 = this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_options;
  return new $c_Llaika_api_bundle_BlockDirectives$DirectiveInstance(directive$2, parsedResult$2, parser$2, source$2, rewriteRules$2, options$2);
});
$c_Llaika_api_bundle_BlockDirectives$DirectiveInstance.prototype.resolve__Llaika_ast_DocumentCursor__Llaika_ast_Block = (function(cursor) {
  return $n(this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_rewriteRules).rewriteBlock__Llaika_ast_Block__Llaika_ast_Block($as_Llaika_ast_Block($f_Llaika_api_bundle_DirectiveBuilderContext$DirectiveInstanceBase__resolve__Llaika_ast_DocumentCursor__Llaika_ast_Element(this, cursor)));
});
$c_Llaika_api_bundle_BlockDirectives$DirectiveInstance.prototype.unresolvedMessage__T = (function() {
  if ((!this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_unresolvedMessagebitmap$3)) {
    var this$1 = $n(this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_directive);
    if (this$1.isEmpty__Z()) {
      var $x_1 = "<unknown>";
    } else {
      var arg1 = this$1.get__O();
      var _$20 = $as_Llaika_api_bundle_DirectiveBuilderContext$Directive(arg1);
      var $x_1 = $n(_$20).Llaika_api_bundle_DirectiveBuilderContext$Directive__f_name;
    }
    this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_unresolvedMessage$lzy3 = (("Unresolved block directive instance with name '" + $x_1) + "'");
    this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_unresolvedMessagebitmap$3 = true;
  }
  return this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_unresolvedMessage$lzy3;
});
$c_Llaika_api_bundle_BlockDirectives$DirectiveInstance.prototype.laika$api$bundle$DirectiveBuilderContext$DirectiveProcessor$$$outer__Llaika_api_bundle_DirectiveBuilderContext = (function() {
  return $m_Llaika_api_bundle_BlockDirectives$();
});
$c_Llaika_api_bundle_BlockDirectives$DirectiveInstance.prototype.laika$api$bundle$DirectiveBuilderContext$DirectiveInstanceBase$$$outer__Llaika_api_bundle_DirectiveBuilderContext = (function() {
  return $m_Llaika_api_bundle_BlockDirectives$();
});
$c_Llaika_api_bundle_BlockDirectives$DirectiveInstance.prototype.parser__O = (function() {
  return this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_parser;
});
$c_Llaika_api_bundle_BlockDirectives$DirectiveInstance.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var directive = this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_directive;
  var parsedResult = this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_parsedResult;
  var parser = this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_parser;
  var source = this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_source;
  var rewriteRules = this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_rewriteRules;
  return new $c_Llaika_api_bundle_BlockDirectives$DirectiveInstance(directive, parsedResult, parser, source, rewriteRules, options);
});
$c_Llaika_api_bundle_BlockDirectives$DirectiveInstance.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return this.rewriteChildren__Llaika_ast_RewriteRules__Llaika_api_bundle_BlockDirectives$DirectiveInstance(rules);
});
$c_Llaika_api_bundle_BlockDirectives$DirectiveInstance.prototype.createInvalidElement__T__Llaika_ast_Element = (function(message) {
  return $m_Llaika_ast_InvalidBlock$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidBlock(message, this.Llaika_api_bundle_BlockDirectives$DirectiveInstance__f_source);
});
function $as_Llaika_api_bundle_BlockDirectives$DirectiveInstance(obj) {
  return (((obj instanceof $c_Llaika_api_bundle_BlockDirectives$DirectiveInstance) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.BlockDirectives$DirectiveInstance"));
}
function $isArrayOf_Llaika_api_bundle_BlockDirectives$DirectiveInstance(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_BlockDirectives$DirectiveInstance)));
}
function $asArrayOf_Llaika_api_bundle_BlockDirectives$DirectiveInstance(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_BlockDirectives$DirectiveInstance(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.BlockDirectives$DirectiveInstance;", depth));
}
var $d_Llaika_api_bundle_BlockDirectives$DirectiveInstance = new $TypeData().initClass($c_Llaika_api_bundle_BlockDirectives$DirectiveInstance, "laika.api.bundle.BlockDirectives$DirectiveInstance", ({
  Llaika_api_bundle_BlockDirectives$DirectiveInstance: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_Unresolved: 1,
  Llaika_ast_BlockResolver: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_api_bundle_DirectiveBuilderContext$DirectiveProcessor: 1,
  Llaika_api_bundle_DirectiveBuilderContext$DirectiveInstanceBase: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_SpanDirectives$DirectiveInstance(directive, parsedResult, parser, source, rewriteRules, options) {
  this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_directive = null;
  this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_parsedResult = null;
  this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_parser = null;
  this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_source = null;
  this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_rewriteRules = null;
  this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_options = null;
  this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_typeName = null;
  this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_unresolvedMessage$lzy1 = null;
  this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_unresolvedMessagebitmap$1 = false;
  this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_directive = directive;
  this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_parsedResult = parsedResult;
  this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_parser = parser;
  this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_source = source;
  this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_rewriteRules = rewriteRules;
  this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_options = options;
  this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_typeName = "span";
}
$c_Llaika_api_bundle_SpanDirectives$DirectiveInstance.prototype = new $h_Llaika_ast_Element();
$c_Llaika_api_bundle_SpanDirectives$DirectiveInstance.prototype.constructor = $c_Llaika_api_bundle_SpanDirectives$DirectiveInstance;
/** @constructor */
function $h_Llaika_api_bundle_SpanDirectives$DirectiveInstance() {
}
$h_Llaika_api_bundle_SpanDirectives$DirectiveInstance.prototype = $c_Llaika_api_bundle_SpanDirectives$DirectiveInstance.prototype;
$c_Llaika_api_bundle_SpanDirectives$DirectiveInstance.prototype.runsIn__Llaika_ast_RewritePhase__Z = (function(phase) {
  return $f_Llaika_api_bundle_DirectiveBuilderContext$DirectiveInstanceBase__runsIn__Llaika_ast_RewritePhase__Z(this, phase);
});
$c_Llaika_api_bundle_SpanDirectives$DirectiveInstance.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_bundle_SpanDirectives$DirectiveInstance.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_bundle_SpanDirectives$DirectiveInstance)) {
    var x$0$2 = $as_Llaika_api_bundle_SpanDirectives$DirectiveInstance(x$0);
    var x = this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_directive;
    var x$2 = $n(x$0$2).Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_directive;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_parsedResult;
      var x$4 = $n(x$0$2).Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_parsedResult;
      var $x_5 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$5 = this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_parser;
      var x$6 = $n(x$0$2).Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_parser;
      if ((x$5 === null)) {
        var $x_4 = (x$6 === null);
      } else {
        var this$1 = $n(x$5);
        var $x_4 = (this$1 === x$6);
      }
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$7 = this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_source;
      var x$8 = $n(x$0$2).Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_source;
      var $x_3 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$9 = this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_rewriteRules;
      var x$10 = $n(x$0$2).Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_rewriteRules;
      if ((x$9 === null)) {
        var $x_2 = (x$10 === null);
      } else {
        var this$2 = $n(x$9);
        var $x_2 = (this$2 === x$10);
      }
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$11 = this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_options;
      var x$12 = $n(x$0$2).Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_options;
      var $x_1 = ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_bundle_SpanDirectives$DirectiveInstance.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_bundle_SpanDirectives$DirectiveInstance.prototype.productArity__I = (function() {
  return 6;
});
$c_Llaika_api_bundle_SpanDirectives$DirectiveInstance.prototype.productPrefix__T = (function() {
  return "DirectiveInstance";
});
$c_Llaika_api_bundle_SpanDirectives$DirectiveInstance.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_directive;
      break;
    }
    case 1: {
      return this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_parsedResult;
      break;
    }
    case 2: {
      return this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_parser;
      break;
    }
    case 3: {
      return this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_source;
      break;
    }
    case 4: {
      return this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_rewriteRules;
      break;
    }
    case 5: {
      return this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_api_bundle_SpanDirectives$DirectiveInstance.prototype.directive__s_Option = (function() {
  return this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_directive;
});
$c_Llaika_api_bundle_SpanDirectives$DirectiveInstance.prototype.parsedResult__Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective = (function() {
  return this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_parsedResult;
});
$c_Llaika_api_bundle_SpanDirectives$DirectiveInstance.prototype.source__Llaika_parse_SourceFragment = (function() {
  return this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_source;
});
$c_Llaika_api_bundle_SpanDirectives$DirectiveInstance.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_options;
});
$c_Llaika_api_bundle_SpanDirectives$DirectiveInstance.prototype.typeName__T = (function() {
  return this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_typeName;
});
$c_Llaika_api_bundle_SpanDirectives$DirectiveInstance.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_api_bundle_SpanDirectives$DirectiveInstance = (function(rules) {
  var rewriteRules$1 = $n(this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_rewriteRules).$plus$plus__Llaika_ast_RewriteRules__Llaika_ast_RewriteRules(rules);
  var directive$1 = this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_directive;
  var parsedResult$1 = this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_parsedResult;
  var parser$1 = this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_parser;
  var source$1 = this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_source;
  var options$1 = this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_options;
  return new $c_Llaika_api_bundle_SpanDirectives$DirectiveInstance(directive$1, parsedResult$1, parser$1, source$1, rewriteRules$1, options$1);
});
$c_Llaika_api_bundle_SpanDirectives$DirectiveInstance.prototype.resolve__Llaika_ast_DocumentCursor__Llaika_ast_Span = (function(cursor) {
  return $n(this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_rewriteRules).rewriteSpan__Llaika_ast_Span__Llaika_ast_Span($as_Llaika_ast_Span($f_Llaika_api_bundle_DirectiveBuilderContext$DirectiveInstanceBase__resolve__Llaika_ast_DocumentCursor__Llaika_ast_Element(this, cursor)));
});
$c_Llaika_api_bundle_SpanDirectives$DirectiveInstance.prototype.unresolvedMessage__T = (function() {
  if ((!this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_unresolvedMessagebitmap$1)) {
    var this$1 = $n(this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_directive);
    if (this$1.isEmpty__Z()) {
      var $x_1 = "<unknown>";
    } else {
      var arg1 = this$1.get__O();
      var _$18 = $as_Llaika_api_bundle_DirectiveBuilderContext$Directive(arg1);
      var $x_1 = $n(_$18).Llaika_api_bundle_DirectiveBuilderContext$Directive__f_name;
    }
    this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_unresolvedMessage$lzy1 = (("Unresolved span directive instance with name '" + $x_1) + "'");
    this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_unresolvedMessagebitmap$1 = true;
  }
  return this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_unresolvedMessage$lzy1;
});
$c_Llaika_api_bundle_SpanDirectives$DirectiveInstance.prototype.laika$api$bundle$DirectiveBuilderContext$DirectiveProcessor$$$outer__Llaika_api_bundle_DirectiveBuilderContext = (function() {
  return $m_Llaika_api_bundle_SpanDirectives$();
});
$c_Llaika_api_bundle_SpanDirectives$DirectiveInstance.prototype.laika$api$bundle$DirectiveBuilderContext$DirectiveInstanceBase$$$outer__Llaika_api_bundle_DirectiveBuilderContext = (function() {
  return $m_Llaika_api_bundle_SpanDirectives$();
});
$c_Llaika_api_bundle_SpanDirectives$DirectiveInstance.prototype.parser__O = (function() {
  return this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_parser;
});
$c_Llaika_api_bundle_SpanDirectives$DirectiveInstance.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var directive = this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_directive;
  var parsedResult = this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_parsedResult;
  var parser = this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_parser;
  var source = this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_source;
  var rewriteRules = this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_rewriteRules;
  return new $c_Llaika_api_bundle_SpanDirectives$DirectiveInstance(directive, parsedResult, parser, source, rewriteRules, options);
});
$c_Llaika_api_bundle_SpanDirectives$DirectiveInstance.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return this.rewriteChildren__Llaika_ast_RewriteRules__Llaika_api_bundle_SpanDirectives$DirectiveInstance(rules);
});
$c_Llaika_api_bundle_SpanDirectives$DirectiveInstance.prototype.createInvalidElement__T__Llaika_ast_Element = (function(message) {
  return $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan(message, this.Llaika_api_bundle_SpanDirectives$DirectiveInstance__f_source);
});
function $as_Llaika_api_bundle_SpanDirectives$DirectiveInstance(obj) {
  return (((obj instanceof $c_Llaika_api_bundle_SpanDirectives$DirectiveInstance) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.SpanDirectives$DirectiveInstance"));
}
function $isArrayOf_Llaika_api_bundle_SpanDirectives$DirectiveInstance(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_SpanDirectives$DirectiveInstance)));
}
function $asArrayOf_Llaika_api_bundle_SpanDirectives$DirectiveInstance(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_SpanDirectives$DirectiveInstance(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.SpanDirectives$DirectiveInstance;", depth));
}
var $d_Llaika_api_bundle_SpanDirectives$DirectiveInstance = new $TypeData().initClass($c_Llaika_api_bundle_SpanDirectives$DirectiveInstance, "laika.api.bundle.SpanDirectives$DirectiveInstance", ({
  Llaika_api_bundle_SpanDirectives$DirectiveInstance: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Unresolved: 1,
  Llaika_ast_SpanResolver: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_api_bundle_DirectiveBuilderContext$DirectiveProcessor: 1,
  Llaika_api_bundle_DirectiveBuilderContext$DirectiveInstanceBase: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance(directive, parsedResult, parser, source, options) {
  this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_directive = null;
  this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_parsedResult = null;
  this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_parser = null;
  this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_source = null;
  this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_options = null;
  this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_typeName = null;
  this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_unresolvedMessage$lzy5 = null;
  this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_unresolvedMessagebitmap$5 = false;
  this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_directive = directive;
  this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_parsedResult = parsedResult;
  this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_parser = parser;
  this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_source = source;
  this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_options = options;
  this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_typeName = "template";
}
$c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance.prototype = new $h_Llaika_ast_Element();
$c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance.prototype.constructor = $c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance;
/** @constructor */
function $h_Llaika_api_bundle_TemplateDirectives$DirectiveInstance() {
}
$h_Llaika_api_bundle_TemplateDirectives$DirectiveInstance.prototype = $c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance.prototype;
$c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance.prototype.runsIn__Llaika_ast_RewritePhase__Z = (function(phase) {
  return $f_Llaika_api_bundle_DirectiveBuilderContext$DirectiveInstanceBase__runsIn__Llaika_ast_RewritePhase__Z(this, phase);
});
$c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance)) {
    var x$0$2 = $as_Llaika_api_bundle_TemplateDirectives$DirectiveInstance(x$0);
    var x = this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_directive;
    var x$2 = $n(x$0$2).Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_directive;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_parsedResult;
      var x$4 = $n(x$0$2).Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_parsedResult;
      var $x_4 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_parser;
      var x$6 = $n(x$0$2).Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_parser;
      if ((x$5 === null)) {
        var $x_3 = (x$6 === null);
      } else {
        var this$1 = $n(x$5);
        var $x_3 = (this$1 === x$6);
      }
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_source;
      var x$8 = $n(x$0$2).Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_source;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_options;
      var x$10 = $n(x$0$2).Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_options;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance.prototype.productArity__I = (function() {
  return 5;
});
$c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance.prototype.productPrefix__T = (function() {
  return "DirectiveInstance";
});
$c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_directive;
      break;
    }
    case 1: {
      return this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_parsedResult;
      break;
    }
    case 2: {
      return this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_parser;
      break;
    }
    case 3: {
      return this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_source;
      break;
    }
    case 4: {
      return this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance.prototype.directive__s_Option = (function() {
  return this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_directive;
});
$c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance.prototype.parsedResult__Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective = (function() {
  return this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_parsedResult;
});
$c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance.prototype.source__Llaika_parse_SourceFragment = (function() {
  return this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_source;
});
$c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_options;
});
$c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance.prototype.typeName__T = (function() {
  return this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_typeName;
});
$c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance.prototype.createInvalidElement__T__Llaika_ast_TemplateSpan = (function(message) {
  var element = $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan(message, this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_source);
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  return new $c_Llaika_ast_TemplateElement(element, 0, options);
});
$c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance.prototype.unresolvedMessage__T = (function() {
  if ((!this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_unresolvedMessagebitmap$5)) {
    var this$1 = $n(this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_directive);
    if (this$1.isEmpty__Z()) {
      var $x_1 = "<unknown>";
    } else {
      var arg1 = this$1.get__O();
      var _$23 = $as_Llaika_api_bundle_DirectiveBuilderContext$Directive(arg1);
      var $x_1 = $n(_$23).Llaika_api_bundle_DirectiveBuilderContext$Directive__f_name;
    }
    this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_unresolvedMessage$lzy5 = (("Unresolved template directive instance with name '" + $x_1) + "'");
    this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_unresolvedMessagebitmap$5 = true;
  }
  return this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_unresolvedMessage$lzy5;
});
$c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance.prototype.laika$api$bundle$DirectiveBuilderContext$DirectiveProcessor$$$outer__Llaika_api_bundle_DirectiveBuilderContext = (function() {
  return $m_Llaika_api_bundle_TemplateDirectives$();
});
$c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance.prototype.laika$api$bundle$DirectiveBuilderContext$DirectiveInstanceBase$$$outer__Llaika_api_bundle_DirectiveBuilderContext = (function() {
  return $m_Llaika_api_bundle_TemplateDirectives$();
});
$c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance.prototype.parser__O = (function() {
  return this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_parser;
});
$c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var directive = this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_directive;
  var parsedResult = this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_parsedResult;
  var parser = this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_parser;
  var source = this.Llaika_api_bundle_TemplateDirectives$DirectiveInstance__f_source;
  return new $c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance(directive, parsedResult, parser, source, options);
});
$c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance.prototype.createInvalidElement__T__Llaika_ast_Element = (function(message) {
  return $as_Llaika_ast_Element(this.createInvalidElement__T__Llaika_ast_TemplateSpan(message));
});
$c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance.prototype.resolve__Llaika_ast_DocumentCursor__Llaika_ast_Span = (function(cursor) {
  return $as_Llaika_ast_Span($f_Llaika_api_bundle_DirectiveBuilderContext$DirectiveInstanceBase__resolve__Llaika_ast_DocumentCursor__Llaika_ast_Element(this, cursor));
});
function $as_Llaika_api_bundle_TemplateDirectives$DirectiveInstance(obj) {
  return (((obj instanceof $c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.TemplateDirectives$DirectiveInstance"));
}
function $isArrayOf_Llaika_api_bundle_TemplateDirectives$DirectiveInstance(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_TemplateDirectives$DirectiveInstance)));
}
function $asArrayOf_Llaika_api_bundle_TemplateDirectives$DirectiveInstance(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_TemplateDirectives$DirectiveInstance(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.TemplateDirectives$DirectiveInstance;", depth));
}
var $d_Llaika_api_bundle_TemplateDirectives$DirectiveInstance = new $TypeData().initClass($c_Llaika_api_bundle_TemplateDirectives$DirectiveInstance, "laika.api.bundle.TemplateDirectives$DirectiveInstance", ({
  Llaika_api_bundle_TemplateDirectives$DirectiveInstance: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Unresolved: 1,
  Llaika_ast_SpanResolver: 1,
  Llaika_ast_TemplateSpan: 1,
  Llaika_api_bundle_DirectiveBuilderContext$DirectiveProcessor: 1,
  Llaika_api_bundle_DirectiveBuilderContext$DirectiveInstanceBase: 1
}));
/** @constructor */
function $c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance(parsedResult, source, options) {
  this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_typeName = null;
  this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_parsedResult = null;
  this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_source = null;
  this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_options = null;
  this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_unresolvedMessage$lzy6 = null;
  this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_unresolvedMessagebitmap$6 = false;
  this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_parsedResult = parsedResult;
  this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_source = source;
  this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_options = options;
  this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_typeName = "separator";
}
$c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance.prototype = new $h_Llaika_ast_Element();
$c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance.prototype.constructor = $c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance;
/** @constructor */
function $h_Llaika_api_bundle_TemplateDirectives$SeparatorInstance() {
}
$h_Llaika_api_bundle_TemplateDirectives$SeparatorInstance.prototype = $c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance.prototype;
$c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance.prototype.typeName__T = (function() {
  return this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_typeName;
});
$c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance.prototype.runsIn__Llaika_ast_RewritePhase__Z = (function(phase) {
  return true;
});
$c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance)) {
    var x$0$2 = $as_Llaika_api_bundle_TemplateDirectives$SeparatorInstance(x$0);
    var x = this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_parsedResult;
    var x$2 = $n(x$0$2).Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_parsedResult;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_source;
      var x$4 = $n(x$0$2).Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_source;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_options;
      var x$6 = $n(x$0$2).Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_options;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance.prototype.productPrefix__T = (function() {
  return "SeparatorInstance";
});
$c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_parsedResult;
      break;
    }
    case 1: {
      return this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_source;
      break;
    }
    case 2: {
      return this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance.prototype.parsedResult__Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective = (function() {
  return this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_parsedResult;
});
$c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance.prototype.source__Llaika_parse_SourceFragment = (function() {
  return this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_source;
});
$c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_options;
});
$c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance.prototype.resolve__Llaika_ast_DocumentCursor__Llaika_ast_TemplateSpan = (function(cursor) {
  var element = $m_Llaika_ast_InvalidSpan$().apply__T__Llaika_parse_SourceFragment__Llaika_ast_InvalidSpan((("Orphaned separator directive with name '" + $n(this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_parsedResult).Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_name) + "'"), this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_source);
  var options = $m_Llaika_ast_Options$().Llaika_ast_Options$__f_empty;
  return new $c_Llaika_ast_TemplateElement(element, 0, options);
});
$c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance.prototype.unresolvedMessage__T = (function() {
  if ((!this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_unresolvedMessagebitmap$6)) {
    this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_unresolvedMessage$lzy6 = (("Unresolved separator directive instance with name '" + $n(this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_parsedResult).Llaika_internal_parse_directive_DirectiveParsers$ParsedDirective__f_name) + "'");
    this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_unresolvedMessagebitmap$6 = true;
  }
  return this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_unresolvedMessage$lzy6;
});
$c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance.prototype.laika$api$bundle$DirectiveBuilderContext$DirectiveProcessor$$$outer__Llaika_api_bundle_DirectiveBuilderContext = (function() {
  return $m_Llaika_api_bundle_TemplateDirectives$();
});
$c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance.prototype.laika$api$bundle$DirectiveBuilderContext$SeparatorInstanceBase$$$outer__Llaika_api_bundle_DirectiveBuilderContext = (function() {
  return $m_Llaika_api_bundle_TemplateDirectives$();
});
$c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var parsedResult = this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_parsedResult;
  var source = this.Llaika_api_bundle_TemplateDirectives$SeparatorInstance__f_source;
  return new $c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance(parsedResult, source, options);
});
$c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance.prototype.resolve__Llaika_ast_DocumentCursor__Llaika_ast_Span = (function(cursor) {
  return this.resolve__Llaika_ast_DocumentCursor__Llaika_ast_TemplateSpan(cursor);
});
function $as_Llaika_api_bundle_TemplateDirectives$SeparatorInstance(obj) {
  return (((obj instanceof $c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.api.bundle.TemplateDirectives$SeparatorInstance"));
}
function $isArrayOf_Llaika_api_bundle_TemplateDirectives$SeparatorInstance(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_api_bundle_TemplateDirectives$SeparatorInstance)));
}
function $asArrayOf_Llaika_api_bundle_TemplateDirectives$SeparatorInstance(obj, depth) {
  return (($isArrayOf_Llaika_api_bundle_TemplateDirectives$SeparatorInstance(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.api.bundle.TemplateDirectives$SeparatorInstance;", depth));
}
var $d_Llaika_api_bundle_TemplateDirectives$SeparatorInstance = new $TypeData().initClass($c_Llaika_api_bundle_TemplateDirectives$SeparatorInstance, "laika.api.bundle.TemplateDirectives$SeparatorInstance", ({
  Llaika_api_bundle_TemplateDirectives$SeparatorInstance: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_TemplateSpan: 1,
  Llaika_api_bundle_DirectiveBuilderContext$DirectiveProcessor: 1,
  Llaika_api_bundle_DirectiveBuilderContext$SeparatorInstanceBase: 1,
  Llaika_ast_Unresolved: 1,
  Llaika_ast_SpanResolver: 1
}));
/** @constructor */
function $c_Llaika_ast_BlockSequence(content, options) {
  this.Llaika_ast_BlockSequence__f_content = null;
  this.Llaika_ast_BlockSequence__f_options = null;
  this.Llaika_ast_BlockSequence__f_content = content;
  this.Llaika_ast_BlockSequence__f_options = options;
}
$c_Llaika_ast_BlockSequence.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_BlockSequence.prototype.constructor = $c_Llaika_ast_BlockSequence;
/** @constructor */
function $h_Llaika_ast_BlockSequence() {
}
$h_Llaika_ast_BlockSequence.prototype = $c_Llaika_ast_BlockSequence.prototype;
$c_Llaika_ast_BlockSequence.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_BlockSequence.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_BlockSequence.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_BlockSequence)) {
    var x$0$2 = $as_Llaika_ast_BlockSequence(x$0);
    var x = this.Llaika_ast_BlockSequence__f_content;
    var x$2 = $n(x$0$2).Llaika_ast_BlockSequence__f_content;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_BlockSequence__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_BlockSequence__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_BlockSequence.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_BlockSequence.prototype.productPrefix__T = (function() {
  return "BlockSequence";
});
$c_Llaika_ast_BlockSequence.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_BlockSequence__f_content;
  }
  if ((n === 1)) {
    return this.Llaika_ast_BlockSequence__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_BlockSequence.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_BlockSequence__f_content;
});
$c_Llaika_ast_BlockSequence.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_BlockSequence__f_options;
});
$c_Llaika_ast_BlockSequence.prototype.content__O = (function() {
  return this.Llaika_ast_BlockSequence__f_content;
});
$c_Llaika_ast_BlockSequence.prototype.withContent__sci_Seq__Llaika_ast_BlockContainer = (function(newContent) {
  var options = this.Llaika_ast_BlockSequence__f_options;
  return new $c_Llaika_ast_BlockSequence(newContent, options);
});
$c_Llaika_ast_BlockSequence.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_BlockSequence__f_content;
  return new $c_Llaika_ast_BlockSequence(content, options);
});
$c_Llaika_ast_BlockSequence.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return $f_Llaika_ast_BlockContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_BlockContainer(this, rules);
});
function $as_Llaika_ast_BlockSequence(obj) {
  return (((obj instanceof $c_Llaika_ast_BlockSequence) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.BlockSequence"));
}
function $isArrayOf_Llaika_ast_BlockSequence(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_BlockSequence)));
}
function $asArrayOf_Llaika_ast_BlockSequence(obj, depth) {
  return (($isArrayOf_Llaika_ast_BlockSequence(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.BlockSequence;", depth));
}
var $d_Llaika_ast_BlockSequence = new $TypeData().initClass($c_Llaika_ast_BlockSequence, "laika.ast.BlockSequence", ({
  Llaika_ast_BlockSequence: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_BlockContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_BulletList(content, format, options) {
  this.Llaika_ast_BulletList__f_content = null;
  this.Llaika_ast_BulletList__f_format = null;
  this.Llaika_ast_BulletList__f_options = null;
  this.Llaika_ast_BulletList__f_content = content;
  this.Llaika_ast_BulletList__f_format = format;
  this.Llaika_ast_BulletList__f_options = options;
}
$c_Llaika_ast_BulletList.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_BulletList.prototype.constructor = $c_Llaika_ast_BulletList;
/** @constructor */
function $h_Llaika_ast_BulletList() {
}
$h_Llaika_ast_BulletList.prototype = $c_Llaika_ast_BulletList.prototype;
$c_Llaika_ast_BulletList.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_BulletList.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_BulletList.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_BulletList)) {
    var x$0$2 = $as_Llaika_ast_BulletList(x$0);
    var x = this.Llaika_ast_BulletList__f_content;
    var x$2 = $n(x$0$2).Llaika_ast_BulletList__f_content;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_BulletList__f_format;
      var x$4 = $n(x$0$2).Llaika_ast_BulletList__f_format;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llaika_ast_BulletList__f_options;
      var x$6 = $n(x$0$2).Llaika_ast_BulletList__f_options;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_BulletList.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_BulletList.prototype.productPrefix__T = (function() {
  return "BulletList";
});
$c_Llaika_ast_BulletList.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_BulletList__f_content;
      break;
    }
    case 1: {
      return this.Llaika_ast_BulletList__f_format;
      break;
    }
    case 2: {
      return this.Llaika_ast_BulletList__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_BulletList.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_BulletList__f_content;
});
$c_Llaika_ast_BulletList.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_BulletList__f_options;
});
$c_Llaika_ast_BulletList.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_BulletList = (function(rules) {
  var content = $as_sci_Seq($n(this.Llaika_ast_BulletList__f_content).map__F1__O(new $c_sjsr_AnonFunction1(((_$1) => {
    var _$1$1 = $as_Llaika_ast_BulletListItem(_$1);
    var this$1 = $n(_$1$1);
    return $as_Llaika_ast_BulletListItem($f_Llaika_ast_BlockContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_BlockContainer(this$1, rules));
  }))));
  var format = this.Llaika_ast_BulletList__f_format;
  var options = this.Llaika_ast_BulletList__f_options;
  return new $c_Llaika_ast_BulletList(content, format, options);
});
$c_Llaika_ast_BulletList.prototype.content__O = (function() {
  return this.Llaika_ast_BulletList__f_content;
});
$c_Llaika_ast_BulletList.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return this.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_BulletList(rules);
});
$c_Llaika_ast_BulletList.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_BulletList__f_content;
  var format = this.Llaika_ast_BulletList__f_format;
  return new $c_Llaika_ast_BulletList(content, format, options);
});
function $as_Llaika_ast_BulletList(obj) {
  return (((obj instanceof $c_Llaika_ast_BulletList) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.BulletList"));
}
function $isArrayOf_Llaika_ast_BulletList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_BulletList)));
}
function $asArrayOf_Llaika_ast_BulletList(obj, depth) {
  return (($isArrayOf_Llaika_ast_BulletList(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.BulletList;", depth));
}
var $d_Llaika_ast_BulletList = new $TypeData().initClass($c_Llaika_ast_BulletList, "laika.ast.BulletList", ({
  Llaika_ast_BulletList: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_ListContainer: 1,
  Llaika_ast_RewritableContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_BulletListItem(content, format, options) {
  this.Llaika_ast_BulletListItem__f_content = null;
  this.Llaika_ast_BulletListItem__f_format = null;
  this.Llaika_ast_BulletListItem__f_options = null;
  this.Llaika_ast_BulletListItem__f_content = content;
  this.Llaika_ast_BulletListItem__f_format = format;
  this.Llaika_ast_BulletListItem__f_options = options;
}
$c_Llaika_ast_BulletListItem.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_BulletListItem.prototype.constructor = $c_Llaika_ast_BulletListItem;
/** @constructor */
function $h_Llaika_ast_BulletListItem() {
}
$h_Llaika_ast_BulletListItem.prototype = $c_Llaika_ast_BulletListItem.prototype;
$c_Llaika_ast_BulletListItem.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_BulletListItem.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_BulletListItem.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_BulletListItem)) {
    var x$0$2 = $as_Llaika_ast_BulletListItem(x$0);
    var x = this.Llaika_ast_BulletListItem__f_content;
    var x$2 = $n(x$0$2).Llaika_ast_BulletListItem__f_content;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_BulletListItem__f_format;
      var x$4 = $n(x$0$2).Llaika_ast_BulletListItem__f_format;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llaika_ast_BulletListItem__f_options;
      var x$6 = $n(x$0$2).Llaika_ast_BulletListItem__f_options;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_BulletListItem.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_BulletListItem.prototype.productPrefix__T = (function() {
  return "BulletListItem";
});
$c_Llaika_ast_BulletListItem.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_BulletListItem__f_content;
      break;
    }
    case 1: {
      return this.Llaika_ast_BulletListItem__f_format;
      break;
    }
    case 2: {
      return this.Llaika_ast_BulletListItem__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_BulletListItem.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_BulletListItem__f_content;
});
$c_Llaika_ast_BulletListItem.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_BulletListItem__f_options;
});
$c_Llaika_ast_BulletListItem.prototype.content__O = (function() {
  return this.Llaika_ast_BulletListItem__f_content;
});
$c_Llaika_ast_BulletListItem.prototype.withContent__sci_Seq__Llaika_ast_BlockContainer = (function(newContent) {
  var format = this.Llaika_ast_BulletListItem__f_format;
  var options = this.Llaika_ast_BulletListItem__f_options;
  return new $c_Llaika_ast_BulletListItem(newContent, format, options);
});
$c_Llaika_ast_BulletListItem.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_BulletListItem__f_content;
  var format = this.Llaika_ast_BulletListItem__f_format;
  return new $c_Llaika_ast_BulletListItem(content, format, options);
});
$c_Llaika_ast_BulletListItem.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return $f_Llaika_ast_BlockContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_BlockContainer(this, rules);
});
function $as_Llaika_ast_BulletListItem(obj) {
  return (((obj instanceof $c_Llaika_ast_BulletListItem) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.BulletListItem"));
}
function $isArrayOf_Llaika_ast_BulletListItem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_BulletListItem)));
}
function $asArrayOf_Llaika_ast_BulletListItem(obj, depth) {
  return (($isArrayOf_Llaika_ast_BulletListItem(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.BulletListItem;", depth));
}
var $d_Llaika_ast_BulletListItem = new $TypeData().initClass($c_Llaika_ast_BulletListItem, "laika.ast.BulletListItem", ({
  Llaika_ast_BulletListItem: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_ListItem: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_BlockContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_Caption(content, options) {
  this.Llaika_ast_Caption__f_content = null;
  this.Llaika_ast_Caption__f_options = null;
  this.Llaika_ast_Caption__f_content = content;
  this.Llaika_ast_Caption__f_options = options;
}
$c_Llaika_ast_Caption.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_Caption.prototype.constructor = $c_Llaika_ast_Caption;
/** @constructor */
function $h_Llaika_ast_Caption() {
}
$h_Llaika_ast_Caption.prototype = $c_Llaika_ast_Caption.prototype;
$c_Llaika_ast_Caption.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_Caption.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_Caption.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_Caption)) {
    var x$0$2 = $as_Llaika_ast_Caption(x$0);
    var x = this.Llaika_ast_Caption__f_content;
    var x$2 = $n(x$0$2).Llaika_ast_Caption__f_content;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_Caption__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_Caption__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_Caption.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_Caption.prototype.productPrefix__T = (function() {
  return "Caption";
});
$c_Llaika_ast_Caption.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_Caption__f_content;
  }
  if ((n === 1)) {
    return this.Llaika_ast_Caption__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_Caption.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_Caption__f_content;
});
$c_Llaika_ast_Caption.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_Caption__f_options;
});
$c_Llaika_ast_Caption.prototype.content__O = (function() {
  return this.Llaika_ast_Caption__f_content;
});
$c_Llaika_ast_Caption.prototype.withContent__sci_Seq__Llaika_ast_SpanContainer = (function(newContent) {
  var options = this.Llaika_ast_Caption__f_options;
  return new $c_Llaika_ast_Caption(newContent, options);
});
$c_Llaika_ast_Caption.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_Caption__f_content;
  return new $c_Llaika_ast_Caption(content, options);
});
$c_Llaika_ast_Caption.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return $f_Llaika_ast_SpanContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_SpanContainer(this, rules);
});
function $as_Llaika_ast_Caption(obj) {
  return (((obj instanceof $c_Llaika_ast_Caption) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Caption"));
}
function $isArrayOf_Llaika_ast_Caption(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Caption)));
}
function $asArrayOf_Llaika_ast_Caption(obj, depth) {
  return (($isArrayOf_Llaika_ast_Caption(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Caption;", depth));
}
var $d_Llaika_ast_Caption = new $TypeData().initClass($c_Llaika_ast_Caption, "laika.ast.Caption", ({
  Llaika_ast_Caption: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_TableElement: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_SpanContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_Cell(cellType, content, colspan, rowspan, options) {
  this.Llaika_ast_Cell__f_cellType = null;
  this.Llaika_ast_Cell__f_content = null;
  this.Llaika_ast_Cell__f_colspan = 0;
  this.Llaika_ast_Cell__f_rowspan = 0;
  this.Llaika_ast_Cell__f_options = null;
  this.Llaika_ast_Cell__f_cellType = cellType;
  this.Llaika_ast_Cell__f_content = content;
  this.Llaika_ast_Cell__f_colspan = colspan;
  this.Llaika_ast_Cell__f_rowspan = rowspan;
  this.Llaika_ast_Cell__f_options = options;
}
$c_Llaika_ast_Cell.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_Cell.prototype.constructor = $c_Llaika_ast_Cell;
/** @constructor */
function $h_Llaika_ast_Cell() {
}
$h_Llaika_ast_Cell.prototype = $c_Llaika_ast_Cell.prototype;
$c_Llaika_ast_Cell.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_Cell.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Cell");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Llaika_ast_Cell__f_cellType;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Llaika_ast_Cell__f_content;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Llaika_ast_Cell__f_colspan;
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = this.Llaika_ast_Cell__f_rowspan;
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$2 = this.Llaika_ast_Cell__f_options;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$6, 5);
});
$c_Llaika_ast_Cell.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_Cell)) {
    var x$0$2 = $as_Llaika_ast_Cell(x$0);
    if (((this.Llaika_ast_Cell__f_colspan === $n(x$0$2).Llaika_ast_Cell__f_colspan) && (this.Llaika_ast_Cell__f_rowspan === $n(x$0$2).Llaika_ast_Cell__f_rowspan))) {
      var x = this.Llaika_ast_Cell__f_cellType;
      var x$2 = $n(x$0$2).Llaika_ast_Cell__f_cellType;
      if ((x === null)) {
        var $x_3 = (x$2 === null);
      } else {
        var this$1 = $n(x);
        var $x_3 = (this$1 === x$2);
      }
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.Llaika_ast_Cell__f_content;
      var x$4 = $n(x$0$2).Llaika_ast_Cell__f_content;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llaika_ast_Cell__f_options;
      var x$6 = $n(x$0$2).Llaika_ast_Cell__f_options;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_Cell.prototype.productArity__I = (function() {
  return 5;
});
$c_Llaika_ast_Cell.prototype.productPrefix__T = (function() {
  return "Cell";
});
$c_Llaika_ast_Cell.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_Cell__f_cellType;
      break;
    }
    case 1: {
      return this.Llaika_ast_Cell__f_content;
      break;
    }
    case 2: {
      return this.Llaika_ast_Cell__f_colspan;
      break;
    }
    case 3: {
      return this.Llaika_ast_Cell__f_rowspan;
      break;
    }
    case 4: {
      return this.Llaika_ast_Cell__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_Cell.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_Cell__f_content;
});
$c_Llaika_ast_Cell.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_Cell__f_options;
});
$c_Llaika_ast_Cell.prototype.content__O = (function() {
  return this.Llaika_ast_Cell__f_content;
});
$c_Llaika_ast_Cell.prototype.withContent__sci_Seq__Llaika_ast_BlockContainer = (function(newContent) {
  var cellType = this.Llaika_ast_Cell__f_cellType;
  var colspan = this.Llaika_ast_Cell__f_colspan;
  var rowspan = this.Llaika_ast_Cell__f_rowspan;
  var options = this.Llaika_ast_Cell__f_options;
  return new $c_Llaika_ast_Cell(cellType, newContent, colspan, rowspan, options);
});
$c_Llaika_ast_Cell.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var cellType = this.Llaika_ast_Cell__f_cellType;
  var content = this.Llaika_ast_Cell__f_content;
  var colspan = this.Llaika_ast_Cell__f_colspan;
  var rowspan = this.Llaika_ast_Cell__f_rowspan;
  return new $c_Llaika_ast_Cell(cellType, content, colspan, rowspan, options);
});
$c_Llaika_ast_Cell.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return $f_Llaika_ast_BlockContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_BlockContainer(this, rules);
});
function $as_Llaika_ast_Cell(obj) {
  return (((obj instanceof $c_Llaika_ast_Cell) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Cell"));
}
function $isArrayOf_Llaika_ast_Cell(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Cell)));
}
function $asArrayOf_Llaika_ast_Cell(obj, depth) {
  return (($isArrayOf_Llaika_ast_Cell(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Cell;", depth));
}
var $d_Llaika_ast_Cell = new $TypeData().initClass($c_Llaika_ast_Cell, "laika.ast.Cell", ({
  Llaika_ast_Cell: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_TableElement: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_BlockContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_CodeBlock(language, content, codeOptions, options) {
  this.Llaika_ast_CodeBlock__f_language = null;
  this.Llaika_ast_CodeBlock__f_content = null;
  this.Llaika_ast_CodeBlock__f_codeOptions = null;
  this.Llaika_ast_CodeBlock__f_options = null;
  this.Llaika_ast_CodeBlock__f_language = language;
  this.Llaika_ast_CodeBlock__f_content = content;
  this.Llaika_ast_CodeBlock__f_codeOptions = codeOptions;
  this.Llaika_ast_CodeBlock__f_options = options;
}
$c_Llaika_ast_CodeBlock.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_CodeBlock.prototype.constructor = $c_Llaika_ast_CodeBlock;
/** @constructor */
function $h_Llaika_ast_CodeBlock() {
}
$h_Llaika_ast_CodeBlock.prototype = $c_Llaika_ast_CodeBlock.prototype;
$c_Llaika_ast_CodeBlock.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_CodeBlock.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_CodeBlock.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_CodeBlock)) {
    var x$0$2 = $as_Llaika_ast_CodeBlock(x$0);
    if ((this.Llaika_ast_CodeBlock__f_language === $n(x$0$2).Llaika_ast_CodeBlock__f_language)) {
      var x = this.Llaika_ast_CodeBlock__f_content;
      var x$2 = $n(x$0$2).Llaika_ast_CodeBlock__f_content;
      var $x_3 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.Llaika_ast_CodeBlock__f_codeOptions;
      var x$4 = $n(x$0$2).Llaika_ast_CodeBlock__f_codeOptions;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llaika_ast_CodeBlock__f_options;
      var x$6 = $n(x$0$2).Llaika_ast_CodeBlock__f_options;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_CodeBlock.prototype.productArity__I = (function() {
  return 4;
});
$c_Llaika_ast_CodeBlock.prototype.productPrefix__T = (function() {
  return "CodeBlock";
});
$c_Llaika_ast_CodeBlock.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_CodeBlock__f_language;
      break;
    }
    case 1: {
      return this.Llaika_ast_CodeBlock__f_content;
      break;
    }
    case 2: {
      return this.Llaika_ast_CodeBlock__f_codeOptions;
      break;
    }
    case 3: {
      return this.Llaika_ast_CodeBlock__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_CodeBlock.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_CodeBlock__f_content;
});
$c_Llaika_ast_CodeBlock.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_CodeBlock__f_options;
});
$c_Llaika_ast_CodeBlock.prototype.hasSyntaxHighlighting__Z = (function() {
  var x21 = this.Llaika_ast_CodeBlock__f_content;
  if ((x21 !== null)) {
    if (($n(x21).lengthCompare__I__I(1) === 0)) {
      var x23 = $as_Llaika_ast_Span($n(x21).apply__I__O(0));
      if ((x23 instanceof $c_Llaika_ast_Text)) {
        var x$1 = $as_Llaika_ast_Text(x23);
        var this$5 = $n(x$1);
        var this$6 = $n(x$1);
        return false;
      }
    }
  }
  return true;
});
$c_Llaika_ast_CodeBlock.prototype.content__O = (function() {
  return this.Llaika_ast_CodeBlock__f_content;
});
$c_Llaika_ast_CodeBlock.prototype.withContent__sci_Seq__Llaika_ast_SpanContainer = (function(newContent) {
  var language = this.Llaika_ast_CodeBlock__f_language;
  var codeOptions = this.Llaika_ast_CodeBlock__f_codeOptions;
  var options = this.Llaika_ast_CodeBlock__f_options;
  return new $c_Llaika_ast_CodeBlock(language, newContent, codeOptions, options);
});
$c_Llaika_ast_CodeBlock.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var language = this.Llaika_ast_CodeBlock__f_language;
  var content = this.Llaika_ast_CodeBlock__f_content;
  var codeOptions = this.Llaika_ast_CodeBlock__f_codeOptions;
  return new $c_Llaika_ast_CodeBlock(language, content, codeOptions, options);
});
$c_Llaika_ast_CodeBlock.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return $f_Llaika_ast_SpanContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_SpanContainer(this, rules);
});
function $as_Llaika_ast_CodeBlock(obj) {
  return (((obj instanceof $c_Llaika_ast_CodeBlock) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.CodeBlock"));
}
function $isArrayOf_Llaika_ast_CodeBlock(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_CodeBlock)));
}
function $asArrayOf_Llaika_ast_CodeBlock(obj, depth) {
  return (($isArrayOf_Llaika_ast_CodeBlock(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.CodeBlock;", depth));
}
var $d_Llaika_ast_CodeBlock = new $TypeData().initClass($c_Llaika_ast_CodeBlock, "laika.ast.CodeBlock", ({
  Llaika_ast_CodeBlock: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_SpanContainer: 1
}));
function $as_Llaika_ast_DefinitionList(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.DefinitionList"));
}
function $isArrayOf_Llaika_ast_DefinitionList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_DefinitionList)));
}
function $asArrayOf_Llaika_ast_DefinitionList(obj, depth) {
  return (($isArrayOf_Llaika_ast_DefinitionList(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.DefinitionList;", depth));
}
function $as_Llaika_ast_DefinitionListItem(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.DefinitionListItem"));
}
function $isArrayOf_Llaika_ast_DefinitionListItem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_DefinitionListItem)));
}
function $asArrayOf_Llaika_ast_DefinitionListItem(obj, depth) {
  return (($isArrayOf_Llaika_ast_DefinitionListItem(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.DefinitionListItem;", depth));
}
/** @constructor */
function $c_Llaika_ast_Deleted(content, options) {
  this.Llaika_ast_Deleted__f_content = null;
  this.Llaika_ast_Deleted__f_options = null;
  this.Llaika_ast_Deleted__f_content = content;
  this.Llaika_ast_Deleted__f_options = options;
}
$c_Llaika_ast_Deleted.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_Deleted.prototype.constructor = $c_Llaika_ast_Deleted;
/** @constructor */
function $h_Llaika_ast_Deleted() {
}
$h_Llaika_ast_Deleted.prototype = $c_Llaika_ast_Deleted.prototype;
$c_Llaika_ast_Deleted.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_Deleted.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_Deleted.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_Deleted)) {
    var x$0$2 = $as_Llaika_ast_Deleted(x$0);
    var x = this.Llaika_ast_Deleted__f_content;
    var x$2 = $n(x$0$2).Llaika_ast_Deleted__f_content;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_Deleted__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_Deleted__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_Deleted.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_Deleted.prototype.productPrefix__T = (function() {
  return "Deleted";
});
$c_Llaika_ast_Deleted.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_Deleted__f_content;
  }
  if ((n === 1)) {
    return this.Llaika_ast_Deleted__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_Deleted.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_Deleted__f_content;
});
$c_Llaika_ast_Deleted.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_Deleted__f_options;
});
$c_Llaika_ast_Deleted.prototype.content__O = (function() {
  return this.Llaika_ast_Deleted__f_content;
});
$c_Llaika_ast_Deleted.prototype.withContent__sci_Seq__Llaika_ast_SpanContainer = (function(newContent) {
  var options = this.Llaika_ast_Deleted__f_options;
  return new $c_Llaika_ast_Deleted(newContent, options);
});
$c_Llaika_ast_Deleted.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_Deleted__f_content;
  return new $c_Llaika_ast_Deleted(content, options);
});
$c_Llaika_ast_Deleted.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return $f_Llaika_ast_SpanContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_SpanContainer(this, rules);
});
function $as_Llaika_ast_Deleted(obj) {
  return (((obj instanceof $c_Llaika_ast_Deleted) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Deleted"));
}
function $isArrayOf_Llaika_ast_Deleted(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Deleted)));
}
function $asArrayOf_Llaika_ast_Deleted(obj, depth) {
  return (($isArrayOf_Llaika_ast_Deleted(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Deleted;", depth));
}
var $d_Llaika_ast_Deleted = new $TypeData().initClass($c_Llaika_ast_Deleted, "laika.ast.Deleted", ({
  Llaika_ast_Deleted: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_SpanContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_Emphasized(content, options) {
  this.Llaika_ast_Emphasized__f_content = null;
  this.Llaika_ast_Emphasized__f_options = null;
  this.Llaika_ast_Emphasized__f_content = content;
  this.Llaika_ast_Emphasized__f_options = options;
}
$c_Llaika_ast_Emphasized.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_Emphasized.prototype.constructor = $c_Llaika_ast_Emphasized;
/** @constructor */
function $h_Llaika_ast_Emphasized() {
}
$h_Llaika_ast_Emphasized.prototype = $c_Llaika_ast_Emphasized.prototype;
$c_Llaika_ast_Emphasized.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_Emphasized.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_Emphasized.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_Emphasized)) {
    var x$0$2 = $as_Llaika_ast_Emphasized(x$0);
    var x = this.Llaika_ast_Emphasized__f_content;
    var x$2 = $n(x$0$2).Llaika_ast_Emphasized__f_content;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_Emphasized__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_Emphasized__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_Emphasized.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_Emphasized.prototype.productPrefix__T = (function() {
  return "Emphasized";
});
$c_Llaika_ast_Emphasized.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_Emphasized__f_content;
  }
  if ((n === 1)) {
    return this.Llaika_ast_Emphasized__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_Emphasized.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_Emphasized__f_content;
});
$c_Llaika_ast_Emphasized.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_Emphasized__f_options;
});
$c_Llaika_ast_Emphasized.prototype.content__O = (function() {
  return this.Llaika_ast_Emphasized__f_content;
});
$c_Llaika_ast_Emphasized.prototype.withContent__sci_Seq__Llaika_ast_SpanContainer = (function(newContent) {
  var options = this.Llaika_ast_Emphasized__f_options;
  return new $c_Llaika_ast_Emphasized(newContent, options);
});
$c_Llaika_ast_Emphasized.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_Emphasized__f_content;
  return new $c_Llaika_ast_Emphasized(content, options);
});
$c_Llaika_ast_Emphasized.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return $f_Llaika_ast_SpanContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_SpanContainer(this, rules);
});
function $as_Llaika_ast_Emphasized(obj) {
  return (((obj instanceof $c_Llaika_ast_Emphasized) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Emphasized"));
}
function $isArrayOf_Llaika_ast_Emphasized(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Emphasized)));
}
function $asArrayOf_Llaika_ast_Emphasized(obj, depth) {
  return (($isArrayOf_Llaika_ast_Emphasized(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Emphasized;", depth));
}
var $d_Llaika_ast_Emphasized = new $TypeData().initClass($c_Llaika_ast_Emphasized, "laika.ast.Emphasized", ({
  Llaika_ast_Emphasized: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_SpanContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_EnumList(content, format, start, options) {
  this.Llaika_ast_EnumList__f_content = null;
  this.Llaika_ast_EnumList__f_format = null;
  this.Llaika_ast_EnumList__f_start = 0;
  this.Llaika_ast_EnumList__f_options = null;
  this.Llaika_ast_EnumList__f_content = content;
  this.Llaika_ast_EnumList__f_format = format;
  this.Llaika_ast_EnumList__f_start = start;
  this.Llaika_ast_EnumList__f_options = options;
}
$c_Llaika_ast_EnumList.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_EnumList.prototype.constructor = $c_Llaika_ast_EnumList;
/** @constructor */
function $h_Llaika_ast_EnumList() {
}
$h_Llaika_ast_EnumList.prototype = $c_Llaika_ast_EnumList.prototype;
$c_Llaika_ast_EnumList.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_EnumList.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("EnumList");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Llaika_ast_EnumList__f_content;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Llaika_ast_EnumList__f_format;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Llaika_ast_EnumList__f_start;
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Llaika_ast_EnumList__f_options;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4);
});
$c_Llaika_ast_EnumList.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_EnumList)) {
    var x$0$2 = $as_Llaika_ast_EnumList(x$0);
    if ((this.Llaika_ast_EnumList__f_start === $n(x$0$2).Llaika_ast_EnumList__f_start)) {
      var x = this.Llaika_ast_EnumList__f_content;
      var x$2 = $n(x$0$2).Llaika_ast_EnumList__f_content;
      var $x_3 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.Llaika_ast_EnumList__f_format;
      var x$4 = $n(x$0$2).Llaika_ast_EnumList__f_format;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llaika_ast_EnumList__f_options;
      var x$6 = $n(x$0$2).Llaika_ast_EnumList__f_options;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_EnumList.prototype.productArity__I = (function() {
  return 4;
});
$c_Llaika_ast_EnumList.prototype.productPrefix__T = (function() {
  return "EnumList";
});
$c_Llaika_ast_EnumList.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_EnumList__f_content;
      break;
    }
    case 1: {
      return this.Llaika_ast_EnumList__f_format;
      break;
    }
    case 2: {
      return this.Llaika_ast_EnumList__f_start;
      break;
    }
    case 3: {
      return this.Llaika_ast_EnumList__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_EnumList.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_EnumList__f_content;
});
$c_Llaika_ast_EnumList.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_EnumList__f_options;
});
$c_Llaika_ast_EnumList.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_EnumList = (function(rules) {
  var content = $as_sci_Seq($n(this.Llaika_ast_EnumList__f_content).map__F1__O(new $c_sjsr_AnonFunction1(((_$4) => {
    var _$4$1 = $as_Llaika_ast_EnumListItem(_$4);
    var this$1 = $n(_$4$1);
    return $as_Llaika_ast_EnumListItem($f_Llaika_ast_BlockContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_BlockContainer(this$1, rules));
  }))));
  var format = this.Llaika_ast_EnumList__f_format;
  var start = this.Llaika_ast_EnumList__f_start;
  var options = this.Llaika_ast_EnumList__f_options;
  return new $c_Llaika_ast_EnumList(content, format, start, options);
});
$c_Llaika_ast_EnumList.prototype.content__O = (function() {
  return this.Llaika_ast_EnumList__f_content;
});
$c_Llaika_ast_EnumList.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return this.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_EnumList(rules);
});
$c_Llaika_ast_EnumList.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_EnumList__f_content;
  var format = this.Llaika_ast_EnumList__f_format;
  var start = this.Llaika_ast_EnumList__f_start;
  return new $c_Llaika_ast_EnumList(content, format, start, options);
});
function $as_Llaika_ast_EnumList(obj) {
  return (((obj instanceof $c_Llaika_ast_EnumList) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.EnumList"));
}
function $isArrayOf_Llaika_ast_EnumList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_EnumList)));
}
function $asArrayOf_Llaika_ast_EnumList(obj, depth) {
  return (($isArrayOf_Llaika_ast_EnumList(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.EnumList;", depth));
}
var $d_Llaika_ast_EnumList = new $TypeData().initClass($c_Llaika_ast_EnumList, "laika.ast.EnumList", ({
  Llaika_ast_EnumList: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_ListContainer: 1,
  Llaika_ast_RewritableContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_EnumListItem(content, format, position, options) {
  this.Llaika_ast_EnumListItem__f_content = null;
  this.Llaika_ast_EnumListItem__f_format = null;
  this.Llaika_ast_EnumListItem__f_position = 0;
  this.Llaika_ast_EnumListItem__f_options = null;
  this.Llaika_ast_EnumListItem__f_content = content;
  this.Llaika_ast_EnumListItem__f_format = format;
  this.Llaika_ast_EnumListItem__f_position = position;
  this.Llaika_ast_EnumListItem__f_options = options;
}
$c_Llaika_ast_EnumListItem.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_EnumListItem.prototype.constructor = $c_Llaika_ast_EnumListItem;
/** @constructor */
function $h_Llaika_ast_EnumListItem() {
}
$h_Llaika_ast_EnumListItem.prototype = $c_Llaika_ast_EnumListItem.prototype;
$c_Llaika_ast_EnumListItem.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_EnumListItem.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("EnumListItem");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Llaika_ast_EnumListItem__f_content;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Llaika_ast_EnumListItem__f_format;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Llaika_ast_EnumListItem__f_position;
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Llaika_ast_EnumListItem__f_options;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4);
});
$c_Llaika_ast_EnumListItem.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_EnumListItem)) {
    var x$0$2 = $as_Llaika_ast_EnumListItem(x$0);
    if ((this.Llaika_ast_EnumListItem__f_position === $n(x$0$2).Llaika_ast_EnumListItem__f_position)) {
      var x = this.Llaika_ast_EnumListItem__f_content;
      var x$2 = $n(x$0$2).Llaika_ast_EnumListItem__f_content;
      var $x_3 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.Llaika_ast_EnumListItem__f_format;
      var x$4 = $n(x$0$2).Llaika_ast_EnumListItem__f_format;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llaika_ast_EnumListItem__f_options;
      var x$6 = $n(x$0$2).Llaika_ast_EnumListItem__f_options;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_EnumListItem.prototype.productArity__I = (function() {
  return 4;
});
$c_Llaika_ast_EnumListItem.prototype.productPrefix__T = (function() {
  return "EnumListItem";
});
$c_Llaika_ast_EnumListItem.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_EnumListItem__f_content;
      break;
    }
    case 1: {
      return this.Llaika_ast_EnumListItem__f_format;
      break;
    }
    case 2: {
      return this.Llaika_ast_EnumListItem__f_position;
      break;
    }
    case 3: {
      return this.Llaika_ast_EnumListItem__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_EnumListItem.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_EnumListItem__f_content;
});
$c_Llaika_ast_EnumListItem.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_EnumListItem__f_options;
});
$c_Llaika_ast_EnumListItem.prototype.content__O = (function() {
  return this.Llaika_ast_EnumListItem__f_content;
});
$c_Llaika_ast_EnumListItem.prototype.withContent__sci_Seq__Llaika_ast_BlockContainer = (function(newContent) {
  var format = this.Llaika_ast_EnumListItem__f_format;
  var position = this.Llaika_ast_EnumListItem__f_position;
  var options = this.Llaika_ast_EnumListItem__f_options;
  return new $c_Llaika_ast_EnumListItem(newContent, format, position, options);
});
$c_Llaika_ast_EnumListItem.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_EnumListItem__f_content;
  var format = this.Llaika_ast_EnumListItem__f_format;
  var position = this.Llaika_ast_EnumListItem__f_position;
  return new $c_Llaika_ast_EnumListItem(content, format, position, options);
});
$c_Llaika_ast_EnumListItem.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return $f_Llaika_ast_BlockContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_BlockContainer(this, rules);
});
function $as_Llaika_ast_EnumListItem(obj) {
  return (((obj instanceof $c_Llaika_ast_EnumListItem) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.EnumListItem"));
}
function $isArrayOf_Llaika_ast_EnumListItem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_EnumListItem)));
}
function $asArrayOf_Llaika_ast_EnumListItem(obj, depth) {
  return (($isArrayOf_Llaika_ast_EnumListItem(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.EnumListItem;", depth));
}
var $d_Llaika_ast_EnumListItem = new $TypeData().initClass($c_Llaika_ast_EnumListItem, "laika.ast.EnumListItem", ({
  Llaika_ast_EnumListItem: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_ListItem: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_BlockContainer: 1
}));
function $as_Llaika_ast_Figure(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Figure"));
}
function $isArrayOf_Llaika_ast_Figure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Figure)));
}
function $asArrayOf_Llaika_ast_Figure(obj, depth) {
  return (($isArrayOf_Llaika_ast_Figure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Figure;", depth));
}
/** @constructor */
function $c_Llaika_ast_Header(level, content, options) {
  this.Llaika_ast_Header__f_level = 0;
  this.Llaika_ast_Header__f_content = null;
  this.Llaika_ast_Header__f_options = null;
  this.Llaika_ast_Header__f_level = level;
  this.Llaika_ast_Header__f_content = content;
  this.Llaika_ast_Header__f_options = options;
}
$c_Llaika_ast_Header.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_Header.prototype.constructor = $c_Llaika_ast_Header;
/** @constructor */
function $h_Llaika_ast_Header() {
}
$h_Llaika_ast_Header.prototype = $c_Llaika_ast_Header.prototype;
$c_Llaika_ast_Header.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_Header.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Header");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Llaika_ast_Header__f_level;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Llaika_ast_Header__f_content;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Llaika_ast_Header__f_options;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Llaika_ast_Header.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_Header)) {
    var x$0$2 = $as_Llaika_ast_Header(x$0);
    if ((this.Llaika_ast_Header__f_level === $n(x$0$2).Llaika_ast_Header__f_level)) {
      var x = this.Llaika_ast_Header__f_content;
      var x$2 = $n(x$0$2).Llaika_ast_Header__f_content;
      var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Llaika_ast_Header__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_Header__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_Header.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_Header.prototype.productPrefix__T = (function() {
  return "Header";
});
$c_Llaika_ast_Header.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_Header__f_level;
      break;
    }
    case 1: {
      return this.Llaika_ast_Header__f_content;
      break;
    }
    case 2: {
      return this.Llaika_ast_Header__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_Header.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_Header__f_content;
});
$c_Llaika_ast_Header.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_Header__f_options;
});
$c_Llaika_ast_Header.prototype.content__O = (function() {
  return this.Llaika_ast_Header__f_content;
});
$c_Llaika_ast_Header.prototype.withContent__sci_Seq__Llaika_ast_SpanContainer = (function(newContent) {
  var level = this.Llaika_ast_Header__f_level;
  var options = this.Llaika_ast_Header__f_options;
  return new $c_Llaika_ast_Header(level, newContent, options);
});
$c_Llaika_ast_Header.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var level = this.Llaika_ast_Header__f_level;
  var content = this.Llaika_ast_Header__f_content;
  return new $c_Llaika_ast_Header(level, content, options);
});
$c_Llaika_ast_Header.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return $f_Llaika_ast_SpanContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_SpanContainer(this, rules);
});
function $as_Llaika_ast_Header(obj) {
  return (((obj instanceof $c_Llaika_ast_Header) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Header"));
}
function $isArrayOf_Llaika_ast_Header(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Header)));
}
function $asArrayOf_Llaika_ast_Header(obj, depth) {
  return (($isArrayOf_Llaika_ast_Header(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Header;", depth));
}
var $d_Llaika_ast_Header = new $TypeData().initClass($c_Llaika_ast_Header, "laika.ast.Header", ({
  Llaika_ast_Header: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_SpanContainer: 1
}));
function $as_Llaika_ast_InlineCode(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.InlineCode"));
}
function $isArrayOf_Llaika_ast_InlineCode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_InlineCode)));
}
function $asArrayOf_Llaika_ast_InlineCode(obj, depth) {
  return (($isArrayOf_Llaika_ast_InlineCode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.InlineCode;", depth));
}
function $as_Llaika_ast_Inserted(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Inserted"));
}
function $isArrayOf_Llaika_ast_Inserted(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Inserted)));
}
function $asArrayOf_Llaika_ast_Inserted(obj, depth) {
  return (($isArrayOf_Llaika_ast_Inserted(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Inserted;", depth));
}
function $ps_Llaika_ast_NavigationList__filter$1__T__sci_Seq__sci_Seq(format$2, items) {
  return $as_sci_Seq($n(items).flatMap__F1__O(new $c_sjsr_AnonFunction1(((item) => {
    var item$1 = $as_Llaika_ast_NavigationItem(item);
    if ($n($n(item$1).Llaika_ast_NavigationItem__f_targetFormats).contains__T__Z(format$2)) {
      var this$1 = $n($n(item$1).Llaika_ast_NavigationItem__f_link);
      if (this$1.isEmpty__Z()) {
        var $x_1 = true;
      } else {
        var arg1 = this$1.get__O();
        var _$7 = $as_Llaika_ast_NavigationLink(arg1);
        var $x_1 = $n($n(_$7).Llaika_ast_NavigationLink__f_targetFormats).contains__T__Z(format$2);
      }
      if ($x_1) {
        var link = this$1;
      } else {
        var link = $m_s_None$();
      }
      var content = $ps_Llaika_ast_NavigationList__filter$1__T__sci_Seq__sci_Seq(format$2, $n(item$1).Llaika_ast_NavigationItem__f_content);
      if (($n(link).isEmpty__Z() && $n(content).isEmpty__Z())) {
        return $m_s_None$();
      } else {
        $n(item$1);
        var this$2 = $n(item$1);
        var title = this$2.Llaika_ast_NavigationItem__f_title;
        var this$3 = $n(item$1);
        var targetFormats = this$3.Llaika_ast_NavigationItem__f_targetFormats;
        var this$4 = $n(item$1);
        var options = this$4.Llaika_ast_NavigationItem__f_options;
        var value = new $c_Llaika_ast_NavigationItem(title, content, link, targetFormats, options);
        return new $c_s_Some(value);
      }
    } else {
      return $m_s_None$();
    }
  }))));
}
/** @constructor */
function $c_Llaika_ast_NavigationList(content, options) {
  this.Llaika_ast_NavigationList__f_content = null;
  this.Llaika_ast_NavigationList__f_options = null;
  this.Llaika_ast_NavigationList__f_content = content;
  this.Llaika_ast_NavigationList__f_options = options;
}
$c_Llaika_ast_NavigationList.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_NavigationList.prototype.constructor = $c_Llaika_ast_NavigationList;
/** @constructor */
function $h_Llaika_ast_NavigationList() {
}
$h_Llaika_ast_NavigationList.prototype = $c_Llaika_ast_NavigationList.prototype;
$c_Llaika_ast_NavigationList.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_NavigationList.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_NavigationList.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_NavigationList)) {
    var x$0$2 = $as_Llaika_ast_NavigationList(x$0);
    var x = this.Llaika_ast_NavigationList__f_content;
    var x$2 = $n(x$0$2).Llaika_ast_NavigationList__f_content;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_NavigationList__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_NavigationList__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_NavigationList.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_NavigationList.prototype.productPrefix__T = (function() {
  return "NavigationList";
});
$c_Llaika_ast_NavigationList.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_NavigationList__f_content;
  }
  if ((n === 1)) {
    return this.Llaika_ast_NavigationList__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_NavigationList.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_NavigationList__f_content;
});
$c_Llaika_ast_NavigationList.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_NavigationList__f_options;
});
$c_Llaika_ast_NavigationList.prototype.forFormat__T__Llaika_ast_NavigationList = (function(format) {
  var content = $ps_Llaika_ast_NavigationList__filter$1__T__sci_Seq__sci_Seq(format, this.Llaika_ast_NavigationList__f_content);
  var options = this.Llaika_ast_NavigationList__f_options;
  return new $c_Llaika_ast_NavigationList(content, options);
});
$c_Llaika_ast_NavigationList.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_NavigationList = (function(rules) {
  var content = $as_sci_Seq($n(this.Llaika_ast_NavigationList__f_content).map__F1__O(new $c_sjsr_AnonFunction1(((_$8) => {
    var _$8$1 = $as_Llaika_ast_NavigationItem(_$8);
    return $n(_$8$1).rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_NavigationItem(rules);
  }))));
  var options = this.Llaika_ast_NavigationList__f_options;
  return new $c_Llaika_ast_NavigationList(content, options);
});
$c_Llaika_ast_NavigationList.prototype.content__O = (function() {
  return this.Llaika_ast_NavigationList__f_content;
});
$c_Llaika_ast_NavigationList.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return this.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_NavigationList(rules);
});
$c_Llaika_ast_NavigationList.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_NavigationList__f_content;
  return new $c_Llaika_ast_NavigationList(content, options);
});
function $as_Llaika_ast_NavigationList(obj) {
  return (((obj instanceof $c_Llaika_ast_NavigationList) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.NavigationList"));
}
function $isArrayOf_Llaika_ast_NavigationList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_NavigationList)));
}
function $asArrayOf_Llaika_ast_NavigationList(obj, depth) {
  return (($isArrayOf_Llaika_ast_NavigationList(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.NavigationList;", depth));
}
var $d_Llaika_ast_NavigationList = new $TypeData().initClass($c_Llaika_ast_NavigationList, "laika.ast.NavigationList", ({
  Llaika_ast_NavigationList: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_ListContainer: 1,
  Llaika_ast_RewritableContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_Paragraph(content, options) {
  this.Llaika_ast_Paragraph__f_content = null;
  this.Llaika_ast_Paragraph__f_options = null;
  this.Llaika_ast_Paragraph__f_content = content;
  this.Llaika_ast_Paragraph__f_options = options;
}
$c_Llaika_ast_Paragraph.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_Paragraph.prototype.constructor = $c_Llaika_ast_Paragraph;
/** @constructor */
function $h_Llaika_ast_Paragraph() {
}
$h_Llaika_ast_Paragraph.prototype = $c_Llaika_ast_Paragraph.prototype;
$c_Llaika_ast_Paragraph.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_Paragraph.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_Paragraph.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_Paragraph)) {
    var x$0$2 = $as_Llaika_ast_Paragraph(x$0);
    var x = this.Llaika_ast_Paragraph__f_content;
    var x$2 = $n(x$0$2).Llaika_ast_Paragraph__f_content;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_Paragraph__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_Paragraph__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_Paragraph.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_Paragraph.prototype.productPrefix__T = (function() {
  return "Paragraph";
});
$c_Llaika_ast_Paragraph.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_Paragraph__f_content;
  }
  if ((n === 1)) {
    return this.Llaika_ast_Paragraph__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_Paragraph.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_Paragraph__f_content;
});
$c_Llaika_ast_Paragraph.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_Paragraph__f_options;
});
$c_Llaika_ast_Paragraph.prototype.content__O = (function() {
  return this.Llaika_ast_Paragraph__f_content;
});
$c_Llaika_ast_Paragraph.prototype.withContent__sci_Seq__Llaika_ast_SpanContainer = (function(newContent) {
  var options = this.Llaika_ast_Paragraph__f_options;
  return new $c_Llaika_ast_Paragraph(newContent, options);
});
$c_Llaika_ast_Paragraph.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_Paragraph__f_content;
  return new $c_Llaika_ast_Paragraph(content, options);
});
$c_Llaika_ast_Paragraph.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return $f_Llaika_ast_SpanContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_SpanContainer(this, rules);
});
function $as_Llaika_ast_Paragraph(obj) {
  return (((obj instanceof $c_Llaika_ast_Paragraph) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Paragraph"));
}
function $isArrayOf_Llaika_ast_Paragraph(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Paragraph)));
}
function $asArrayOf_Llaika_ast_Paragraph(obj, depth) {
  return (($isArrayOf_Llaika_ast_Paragraph(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Paragraph;", depth));
}
var $d_Llaika_ast_Paragraph = new $TypeData().initClass($c_Llaika_ast_Paragraph, "laika.ast.Paragraph", ({
  Llaika_ast_Paragraph: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_SpanContainer: 1
}));
function $as_Llaika_ast_ParsedLiteralBlock(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.ParsedLiteralBlock"));
}
function $isArrayOf_Llaika_ast_ParsedLiteralBlock(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_ParsedLiteralBlock)));
}
function $asArrayOf_Llaika_ast_ParsedLiteralBlock(obj, depth) {
  return (($isArrayOf_Llaika_ast_ParsedLiteralBlock(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.ParsedLiteralBlock;", depth));
}
/** @constructor */
function $c_Llaika_ast_QuotedBlock(content, attribution, options) {
  this.Llaika_ast_QuotedBlock__f_content = null;
  this.Llaika_ast_QuotedBlock__f_attribution = null;
  this.Llaika_ast_QuotedBlock__f_options = null;
  this.Llaika_ast_QuotedBlock__f_content = content;
  this.Llaika_ast_QuotedBlock__f_attribution = attribution;
  this.Llaika_ast_QuotedBlock__f_options = options;
}
$c_Llaika_ast_QuotedBlock.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_QuotedBlock.prototype.constructor = $c_Llaika_ast_QuotedBlock;
/** @constructor */
function $h_Llaika_ast_QuotedBlock() {
}
$h_Llaika_ast_QuotedBlock.prototype = $c_Llaika_ast_QuotedBlock.prototype;
$c_Llaika_ast_QuotedBlock.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_QuotedBlock.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_QuotedBlock.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_QuotedBlock)) {
    var x$0$2 = $as_Llaika_ast_QuotedBlock(x$0);
    var x = this.Llaika_ast_QuotedBlock__f_content;
    var x$2 = $n(x$0$2).Llaika_ast_QuotedBlock__f_content;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_QuotedBlock__f_attribution;
      var x$4 = $n(x$0$2).Llaika_ast_QuotedBlock__f_attribution;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llaika_ast_QuotedBlock__f_options;
      var x$6 = $n(x$0$2).Llaika_ast_QuotedBlock__f_options;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_QuotedBlock.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_QuotedBlock.prototype.productPrefix__T = (function() {
  return "QuotedBlock";
});
$c_Llaika_ast_QuotedBlock.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_QuotedBlock__f_content;
      break;
    }
    case 1: {
      return this.Llaika_ast_QuotedBlock__f_attribution;
      break;
    }
    case 2: {
      return this.Llaika_ast_QuotedBlock__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_QuotedBlock.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_QuotedBlock__f_content;
});
$c_Llaika_ast_QuotedBlock.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_QuotedBlock__f_options;
});
$c_Llaika_ast_QuotedBlock.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_QuotedBlock = (function(rules) {
  var this$1 = $n(rules);
  var blocks = this.Llaika_ast_QuotedBlock__f_content;
  var content = $p_Llaika_ast_RewriteRules__rewrite__F1__sci_Seq__sci_Seq(this$1, $p_Llaika_ast_RewriteRules__chainedBlockRules__F1(this$1), blocks);
  var this$2 = $n(rules);
  var spans = this.Llaika_ast_QuotedBlock__f_attribution;
  var attribution = $p_Llaika_ast_RewriteRules__rewrite__F1__sci_Seq__sci_Seq(this$2, $p_Llaika_ast_RewriteRules__chainedSpanRules__F1(this$2), spans);
  var options = this.Llaika_ast_QuotedBlock__f_options;
  return new $c_Llaika_ast_QuotedBlock(content, attribution, options);
});
$c_Llaika_ast_QuotedBlock.prototype.content__O = (function() {
  return this.Llaika_ast_QuotedBlock__f_content;
});
$c_Llaika_ast_QuotedBlock.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return this.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_QuotedBlock(rules);
});
$c_Llaika_ast_QuotedBlock.prototype.withContent__sci_Seq__Llaika_ast_BlockContainer = (function(newContent) {
  var attribution = this.Llaika_ast_QuotedBlock__f_attribution;
  var options = this.Llaika_ast_QuotedBlock__f_options;
  return new $c_Llaika_ast_QuotedBlock(newContent, attribution, options);
});
$c_Llaika_ast_QuotedBlock.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_QuotedBlock__f_content;
  var attribution = this.Llaika_ast_QuotedBlock__f_attribution;
  return new $c_Llaika_ast_QuotedBlock(content, attribution, options);
});
function $as_Llaika_ast_QuotedBlock(obj) {
  return (((obj instanceof $c_Llaika_ast_QuotedBlock) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.QuotedBlock"));
}
function $isArrayOf_Llaika_ast_QuotedBlock(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_QuotedBlock)));
}
function $asArrayOf_Llaika_ast_QuotedBlock(obj, depth) {
  return (($isArrayOf_Llaika_ast_QuotedBlock(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.QuotedBlock;", depth));
}
var $d_Llaika_ast_QuotedBlock = new $TypeData().initClass($c_Llaika_ast_QuotedBlock, "laika.ast.QuotedBlock", ({
  Llaika_ast_QuotedBlock: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_BlockContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_RootElement(content, options) {
  this.Llaika_ast_RootElement__f_content = null;
  this.Llaika_ast_RootElement__f_options = null;
  this.Llaika_ast_RootElement__f_content = content;
  this.Llaika_ast_RootElement__f_options = options;
}
$c_Llaika_ast_RootElement.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_RootElement.prototype.constructor = $c_Llaika_ast_RootElement;
/** @constructor */
function $h_Llaika_ast_RootElement() {
}
$h_Llaika_ast_RootElement.prototype = $c_Llaika_ast_RootElement.prototype;
$c_Llaika_ast_RootElement.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_RootElement.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_RootElement.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_RootElement)) {
    var x$0$2 = $as_Llaika_ast_RootElement(x$0);
    var x = this.Llaika_ast_RootElement__f_content;
    var x$2 = $n(x$0$2).Llaika_ast_RootElement__f_content;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_RootElement__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_RootElement__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_RootElement.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_RootElement.prototype.productPrefix__T = (function() {
  return "RootElement";
});
$c_Llaika_ast_RootElement.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_RootElement__f_content;
  }
  if ((n === 1)) {
    return this.Llaika_ast_RootElement__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_RootElement.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_RootElement__f_content;
});
$c_Llaika_ast_RootElement.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_RootElement__f_options;
});
$c_Llaika_ast_RootElement.prototype.content__O = (function() {
  return this.Llaika_ast_RootElement__f_content;
});
$c_Llaika_ast_RootElement.prototype.withContent__sci_Seq__Llaika_ast_BlockContainer = (function(newContent) {
  var options = this.Llaika_ast_RootElement__f_options;
  return new $c_Llaika_ast_RootElement(newContent, options);
});
$c_Llaika_ast_RootElement.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_RootElement__f_content;
  return new $c_Llaika_ast_RootElement(content, options);
});
$c_Llaika_ast_RootElement.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return $f_Llaika_ast_BlockContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_BlockContainer(this, rules);
});
function $as_Llaika_ast_RootElement(obj) {
  return (((obj instanceof $c_Llaika_ast_RootElement) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.RootElement"));
}
function $isArrayOf_Llaika_ast_RootElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_RootElement)));
}
function $asArrayOf_Llaika_ast_RootElement(obj, depth) {
  return (($isArrayOf_Llaika_ast_RootElement(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.RootElement;", depth));
}
var $d_Llaika_ast_RootElement = new $TypeData().initClass($c_Llaika_ast_RootElement, "laika.ast.RootElement", ({
  Llaika_ast_RootElement: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_BlockContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_Row(content, options) {
  this.Llaika_ast_Row__f_content = null;
  this.Llaika_ast_Row__f_options = null;
  this.Llaika_ast_Row__f_content = content;
  this.Llaika_ast_Row__f_options = options;
}
$c_Llaika_ast_Row.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_Row.prototype.constructor = $c_Llaika_ast_Row;
/** @constructor */
function $h_Llaika_ast_Row() {
}
$h_Llaika_ast_Row.prototype = $c_Llaika_ast_Row.prototype;
$c_Llaika_ast_Row.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_Row.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_Row.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_Row)) {
    var x$0$2 = $as_Llaika_ast_Row(x$0);
    var x = this.Llaika_ast_Row__f_content;
    var x$2 = $n(x$0$2).Llaika_ast_Row__f_content;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_Row__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_Row__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_Row.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_Row.prototype.productPrefix__T = (function() {
  return "Row";
});
$c_Llaika_ast_Row.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_Row__f_content;
  }
  if ((n === 1)) {
    return this.Llaika_ast_Row__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_Row.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_Row__f_content;
});
$c_Llaika_ast_Row.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_Row__f_options;
});
$c_Llaika_ast_Row.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_Row = (function(rules) {
  var content = $as_sci_Seq($n(this.Llaika_ast_Row__f_content).map__F1__O(new $c_sjsr_AnonFunction1(((_$3) => {
    var _$3$1 = $as_Llaika_ast_Cell(_$3);
    var this$1 = $n(_$3$1);
    return $as_Llaika_ast_Cell($f_Llaika_ast_BlockContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_BlockContainer(this$1, rules));
  }))));
  var options = this.Llaika_ast_Row__f_options;
  return new $c_Llaika_ast_Row(content, options);
});
$c_Llaika_ast_Row.prototype.content__O = (function() {
  return this.Llaika_ast_Row__f_content;
});
$c_Llaika_ast_Row.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return this.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_Row(rules);
});
$c_Llaika_ast_Row.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_Row__f_content;
  return new $c_Llaika_ast_Row(content, options);
});
function $as_Llaika_ast_Row(obj) {
  return (((obj instanceof $c_Llaika_ast_Row) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Row"));
}
function $isArrayOf_Llaika_ast_Row(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Row)));
}
function $asArrayOf_Llaika_ast_Row(obj, depth) {
  return (($isArrayOf_Llaika_ast_Row(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Row;", depth));
}
var $d_Llaika_ast_Row = new $TypeData().initClass($c_Llaika_ast_Row, "laika.ast.Row", ({
  Llaika_ast_Row: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_TableElement: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_TableContainer: 1,
  Llaika_ast_RewritableContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_Section(header, content, options) {
  this.Llaika_ast_Section__f_header = null;
  this.Llaika_ast_Section__f_content = null;
  this.Llaika_ast_Section__f_options = null;
  this.Llaika_ast_Section__f_header = header;
  this.Llaika_ast_Section__f_content = content;
  this.Llaika_ast_Section__f_options = options;
}
$c_Llaika_ast_Section.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_Section.prototype.constructor = $c_Llaika_ast_Section;
/** @constructor */
function $h_Llaika_ast_Section() {
}
$h_Llaika_ast_Section.prototype = $c_Llaika_ast_Section.prototype;
$c_Llaika_ast_Section.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_Section.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_Section.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_Section)) {
    var x$0$2 = $as_Llaika_ast_Section(x$0);
    var x = this.Llaika_ast_Section__f_header;
    var x$2 = $n(x$0$2).Llaika_ast_Section__f_header;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_Section__f_content;
      var x$4 = $n(x$0$2).Llaika_ast_Section__f_content;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llaika_ast_Section__f_options;
      var x$6 = $n(x$0$2).Llaika_ast_Section__f_options;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_Section.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_Section.prototype.productPrefix__T = (function() {
  return "Section";
});
$c_Llaika_ast_Section.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_Section__f_header;
      break;
    }
    case 1: {
      return this.Llaika_ast_Section__f_content;
      break;
    }
    case 2: {
      return this.Llaika_ast_Section__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_Section.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_Section__f_content;
});
$c_Llaika_ast_Section.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_Section__f_options;
});
$c_Llaika_ast_Section.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_Section = (function(rules) {
  var this$1 = $n(rules);
  var blocks = this.Llaika_ast_Section__f_content;
  var _1 = $p_Llaika_ast_RewriteRules__rewrite__F1__sci_Seq__sci_Seq(this$1, $p_Llaika_ast_RewriteRules__chainedBlockRules__F1(this$1), blocks);
  var _2 = $n(rules).rewriteBlock__Llaika_ast_Block__Llaika_ast_Block(this.Llaika_ast_Section__f_header);
  if ((_2 instanceof $c_Llaika_ast_Header)) {
    var newHeader = $as_Llaika_ast_Header(_2);
    var options = this.Llaika_ast_Section__f_options;
    return new $c_Llaika_ast_Section(newHeader, _1, options);
  }
  var this$3 = $n(_1);
  var content$1 = $as_sci_Seq(this$3.prepended__O__O(_2));
  $n(this.Llaika_ast_Section__f_header);
  var this$4 = $n(this.Llaika_ast_Section__f_header);
  var level = this$4.Llaika_ast_Header__f_level;
  var content = $m_sci_Nil$();
  var this$5 = $n(this.Llaika_ast_Section__f_header);
  var options$1 = this$5.Llaika_ast_Header__f_options;
  var header$1 = new $c_Llaika_ast_Header(level, content, options$1);
  var options$2 = this.Llaika_ast_Section__f_options;
  return new $c_Llaika_ast_Section(header$1, content$1, options$2);
});
$c_Llaika_ast_Section.prototype.content__O = (function() {
  return this.Llaika_ast_Section__f_content;
});
$c_Llaika_ast_Section.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return this.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_Section(rules);
});
$c_Llaika_ast_Section.prototype.withContent__sci_Seq__Llaika_ast_BlockContainer = (function(newContent) {
  var header = this.Llaika_ast_Section__f_header;
  var options = this.Llaika_ast_Section__f_options;
  return new $c_Llaika_ast_Section(header, newContent, options);
});
$c_Llaika_ast_Section.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var header = this.Llaika_ast_Section__f_header;
  var content = this.Llaika_ast_Section__f_content;
  return new $c_Llaika_ast_Section(header, content, options);
});
function $as_Llaika_ast_Section(obj) {
  return (((obj instanceof $c_Llaika_ast_Section) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Section"));
}
function $isArrayOf_Llaika_ast_Section(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Section)));
}
function $asArrayOf_Llaika_ast_Section(obj, depth) {
  return (($isArrayOf_Llaika_ast_Section(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Section;", depth));
}
var $d_Llaika_ast_Section = new $TypeData().initClass($c_Llaika_ast_Section, "laika.ast.Section", ({
  Llaika_ast_Section: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_BlockContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_Strong(content, options) {
  this.Llaika_ast_Strong__f_content = null;
  this.Llaika_ast_Strong__f_options = null;
  this.Llaika_ast_Strong__f_content = content;
  this.Llaika_ast_Strong__f_options = options;
}
$c_Llaika_ast_Strong.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_Strong.prototype.constructor = $c_Llaika_ast_Strong;
/** @constructor */
function $h_Llaika_ast_Strong() {
}
$h_Llaika_ast_Strong.prototype = $c_Llaika_ast_Strong.prototype;
$c_Llaika_ast_Strong.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_Strong.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_Strong.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_Strong)) {
    var x$0$2 = $as_Llaika_ast_Strong(x$0);
    var x = this.Llaika_ast_Strong__f_content;
    var x$2 = $n(x$0$2).Llaika_ast_Strong__f_content;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_Strong__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_Strong__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_Strong.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_Strong.prototype.productPrefix__T = (function() {
  return "Strong";
});
$c_Llaika_ast_Strong.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_Strong__f_content;
  }
  if ((n === 1)) {
    return this.Llaika_ast_Strong__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_Strong.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_Strong__f_content;
});
$c_Llaika_ast_Strong.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_Strong__f_options;
});
$c_Llaika_ast_Strong.prototype.content__O = (function() {
  return this.Llaika_ast_Strong__f_content;
});
$c_Llaika_ast_Strong.prototype.withContent__sci_Seq__Llaika_ast_SpanContainer = (function(newContent) {
  var options = this.Llaika_ast_Strong__f_options;
  return new $c_Llaika_ast_Strong(newContent, options);
});
$c_Llaika_ast_Strong.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_Strong__f_content;
  return new $c_Llaika_ast_Strong(content, options);
});
$c_Llaika_ast_Strong.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return $f_Llaika_ast_SpanContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_SpanContainer(this, rules);
});
function $as_Llaika_ast_Strong(obj) {
  return (((obj instanceof $c_Llaika_ast_Strong) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Strong"));
}
function $isArrayOf_Llaika_ast_Strong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Strong)));
}
function $asArrayOf_Llaika_ast_Strong(obj, depth) {
  return (($isArrayOf_Llaika_ast_Strong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Strong;", depth));
}
var $d_Llaika_ast_Strong = new $TypeData().initClass($c_Llaika_ast_Strong, "laika.ast.Strong", ({
  Llaika_ast_Strong: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_SpanContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_TableBody(content, options) {
  this.Llaika_ast_TableBody__f_content = null;
  this.Llaika_ast_TableBody__f_options = null;
  this.Llaika_ast_TableBody__f_content = content;
  this.Llaika_ast_TableBody__f_options = options;
}
$c_Llaika_ast_TableBody.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_TableBody.prototype.constructor = $c_Llaika_ast_TableBody;
/** @constructor */
function $h_Llaika_ast_TableBody() {
}
$h_Llaika_ast_TableBody.prototype = $c_Llaika_ast_TableBody.prototype;
$c_Llaika_ast_TableBody.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_TableBody.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_TableBody.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_TableBody)) {
    var x$0$2 = $as_Llaika_ast_TableBody(x$0);
    var x = this.Llaika_ast_TableBody__f_content;
    var x$2 = $n(x$0$2).Llaika_ast_TableBody__f_content;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_TableBody__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_TableBody__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_TableBody.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_TableBody.prototype.productPrefix__T = (function() {
  return "TableBody";
});
$c_Llaika_ast_TableBody.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_TableBody__f_content;
  }
  if ((n === 1)) {
    return this.Llaika_ast_TableBody__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_TableBody.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_TableBody__f_content;
});
$c_Llaika_ast_TableBody.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_TableBody__f_options;
});
$c_Llaika_ast_TableBody.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_TableBody = (function(rules) {
  var content = $as_sci_Seq($n(this.Llaika_ast_TableBody__f_content).map__F1__O(new $c_sjsr_AnonFunction1(((_$2) => {
    var _$2$1 = $as_Llaika_ast_Row(_$2);
    return $n(_$2$1).rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_Row(rules);
  }))));
  var options = this.Llaika_ast_TableBody__f_options;
  return new $c_Llaika_ast_TableBody(content, options);
});
$c_Llaika_ast_TableBody.prototype.content__O = (function() {
  return this.Llaika_ast_TableBody__f_content;
});
$c_Llaika_ast_TableBody.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return this.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_TableBody(rules);
});
$c_Llaika_ast_TableBody.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_TableBody__f_content;
  return new $c_Llaika_ast_TableBody(content, options);
});
function $as_Llaika_ast_TableBody(obj) {
  return (((obj instanceof $c_Llaika_ast_TableBody) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.TableBody"));
}
function $isArrayOf_Llaika_ast_TableBody(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_TableBody)));
}
function $asArrayOf_Llaika_ast_TableBody(obj, depth) {
  return (($isArrayOf_Llaika_ast_TableBody(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.TableBody;", depth));
}
var $d_Llaika_ast_TableBody = new $TypeData().initClass($c_Llaika_ast_TableBody, "laika.ast.TableBody", ({
  Llaika_ast_TableBody: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_TableElement: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_TableContainer: 1,
  Llaika_ast_RewritableContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_TableHead(content, options) {
  this.Llaika_ast_TableHead__f_content = null;
  this.Llaika_ast_TableHead__f_options = null;
  this.Llaika_ast_TableHead__f_content = content;
  this.Llaika_ast_TableHead__f_options = options;
}
$c_Llaika_ast_TableHead.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_TableHead.prototype.constructor = $c_Llaika_ast_TableHead;
/** @constructor */
function $h_Llaika_ast_TableHead() {
}
$h_Llaika_ast_TableHead.prototype = $c_Llaika_ast_TableHead.prototype;
$c_Llaika_ast_TableHead.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_TableHead.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_TableHead.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_TableHead)) {
    var x$0$2 = $as_Llaika_ast_TableHead(x$0);
    var x = this.Llaika_ast_TableHead__f_content;
    var x$2 = $n(x$0$2).Llaika_ast_TableHead__f_content;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_TableHead__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_TableHead__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_TableHead.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_TableHead.prototype.productPrefix__T = (function() {
  return "TableHead";
});
$c_Llaika_ast_TableHead.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_TableHead__f_content;
  }
  if ((n === 1)) {
    return this.Llaika_ast_TableHead__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_TableHead.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_TableHead__f_content;
});
$c_Llaika_ast_TableHead.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_TableHead__f_options;
});
$c_Llaika_ast_TableHead.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_TableHead = (function(rules) {
  var content = $as_sci_Seq($n(this.Llaika_ast_TableHead__f_content).map__F1__O(new $c_sjsr_AnonFunction1(((_$1) => {
    var _$1$1 = $as_Llaika_ast_Row(_$1);
    return $n(_$1$1).rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_Row(rules);
  }))));
  var options = this.Llaika_ast_TableHead__f_options;
  return new $c_Llaika_ast_TableHead(content, options);
});
$c_Llaika_ast_TableHead.prototype.content__O = (function() {
  return this.Llaika_ast_TableHead__f_content;
});
$c_Llaika_ast_TableHead.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return this.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_TableHead(rules);
});
$c_Llaika_ast_TableHead.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_TableHead__f_content;
  return new $c_Llaika_ast_TableHead(content, options);
});
function $as_Llaika_ast_TableHead(obj) {
  return (((obj instanceof $c_Llaika_ast_TableHead) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.TableHead"));
}
function $isArrayOf_Llaika_ast_TableHead(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_TableHead)));
}
function $asArrayOf_Llaika_ast_TableHead(obj, depth) {
  return (($isArrayOf_Llaika_ast_TableHead(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.TableHead;", depth));
}
var $d_Llaika_ast_TableHead = new $TypeData().initClass($c_Llaika_ast_TableHead, "laika.ast.TableHead", ({
  Llaika_ast_TableHead: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_TableElement: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_TableContainer: 1,
  Llaika_ast_RewritableContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_Title(content, options) {
  this.Llaika_ast_Title__f_content = null;
  this.Llaika_ast_Title__f_options = null;
  this.Llaika_ast_Title__f_content = content;
  this.Llaika_ast_Title__f_options = options;
}
$c_Llaika_ast_Title.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_Title.prototype.constructor = $c_Llaika_ast_Title;
/** @constructor */
function $h_Llaika_ast_Title() {
}
$h_Llaika_ast_Title.prototype = $c_Llaika_ast_Title.prototype;
$c_Llaika_ast_Title.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_Title.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_Title.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_Title)) {
    var x$0$2 = $as_Llaika_ast_Title(x$0);
    var x = this.Llaika_ast_Title__f_content;
    var x$2 = $n(x$0$2).Llaika_ast_Title__f_content;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_Title__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_Title__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_Title.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_Title.prototype.productPrefix__T = (function() {
  return "Title";
});
$c_Llaika_ast_Title.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_Title__f_content;
  }
  if ((n === 1)) {
    return this.Llaika_ast_Title__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_Title.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_Title__f_content;
});
$c_Llaika_ast_Title.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_Title__f_options;
});
$c_Llaika_ast_Title.prototype.content__O = (function() {
  return this.Llaika_ast_Title__f_content;
});
$c_Llaika_ast_Title.prototype.withContent__sci_Seq__Llaika_ast_SpanContainer = (function(newContent) {
  var options = this.Llaika_ast_Title__f_options;
  return new $c_Llaika_ast_Title(newContent, options);
});
$c_Llaika_ast_Title.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_Title__f_content;
  return new $c_Llaika_ast_Title(content, options);
});
$c_Llaika_ast_Title.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return $f_Llaika_ast_SpanContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_SpanContainer(this, rules);
});
function $as_Llaika_ast_Title(obj) {
  return (((obj instanceof $c_Llaika_ast_Title) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Title"));
}
function $isArrayOf_Llaika_ast_Title(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Title)));
}
function $asArrayOf_Llaika_ast_Title(obj, depth) {
  return (($isArrayOf_Llaika_ast_Title(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Title;", depth));
}
var $d_Llaika_ast_Title = new $TypeData().initClass($c_Llaika_ast_Title, "laika.ast.Title", ({
  Llaika_ast_Title: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_SpanContainer: 1
}));
function $as_Llaika_ast_TitledBlock(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.TitledBlock"));
}
function $isArrayOf_Llaika_ast_TitledBlock(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_TitledBlock)));
}
function $asArrayOf_Llaika_ast_TitledBlock(obj, depth) {
  return (($isArrayOf_Llaika_ast_TitledBlock(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.TitledBlock;", depth));
}
/** @constructor */
function $c_Lorg_scalajs_dom_DOMList$DOMListSeq(domList) {
  this.Lorg_scalajs_dom_DOMList$DOMListSeq__f_domList = null;
  this.Lorg_scalajs_dom_DOMList$DOMListSeq__f_domList = domList;
}
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype = new $h_O();
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.constructor = $c_Lorg_scalajs_dom_DOMList$DOMListSeq;
/** @constructor */
function $h_Lorg_scalajs_dom_DOMList$DOMListSeq() {
}
$h_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype = $c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype;
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.knownSize__I = (function() {
  return (-1);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.head__O = (function() {
  return $n(this.iterator__sc_Iterator()).next__O();
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.headOption__s_Option = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.last__O = (function() {
  return $f_sc_IterableOps__last__O(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.filter__F1__O = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_IterableOps__partition__F1__T2(this, p);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.take__I__O = (function(n) {
  return $f_sc_IterableOps__take__I__O(this, n);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.takeWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__takeWhile__F1__O(this, p);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.drop__I__O = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IterableOps__dropRight__I__O(this, n);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.dropWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__dropWhile__F1__O(this, p);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.init__O = (function() {
  return $f_sc_IterableOps__init__O(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.map__F1__O = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.flatten__F1__O = (function(asIterable) {
  return $f_sc_IterableOps__flatMap__F1__O(this, asIterable);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_IterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sc_Seq$().newBuilder__scm_Builder();
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.className__T = (function() {
  return "Seq";
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.orElse__s_PartialFunction__s_PartialFunction = (function(that) {
  return new $c_s_PartialFunction$OrElse(this, that);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.prepended__O__O = (function(elem) {
  return $f_sc_SeqOps__prepended__O__O(this, elem);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.appended__O__O = (function(elem) {
  return $f_sc_SeqOps__appended__O__O(this, elem);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.prependedAll__sc_IterableOnce__O = (function(prefix) {
  return $f_sc_SeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $as_sc_Seq($f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix));
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $as_sc_Seq($f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix));
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.reverse__O = (function() {
  var coll = $f_sc_IterableOnceOps__reversed__sc_Iterable(this);
  var this$1 = $m_sc_Seq$();
  return this$1.from__sc_IterableOnce__sc_SeqOps(coll);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.reverseIterator__sc_Iterator = (function() {
  return $n($f_sc_IterableOnceOps__reversed__sc_Iterable(this)).iterator__sc_Iterator();
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.padTo__I__O__O = (function(len, elem) {
  return $f_sc_SeqOps__padTo__I__O__O(this, len, elem);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = $n(this.iterator__sc_Iterator());
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this, that);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.canEqual__O__Z = (function(that) {
  return true;
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.equals__O__Z = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.length__I = (function() {
  return $uI(this.Lorg_scalajs_dom_DOMList$DOMListSeq__f_domList.length);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.apply__I__O = (function(x) {
  return this.Lorg_scalajs_dom_DOMList$DOMListSeq__f_domList[x];
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.iterator__sc_Iterator = (function() {
  return new $c_Lorg_scalajs_dom_DOMList$DOMListIterator(this.Lorg_scalajs_dom_DOMList$DOMListSeq__f_domList);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1));
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_Seq$();
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.isDefinedAt__O__Z = (function(x) {
  var idx = $uI(x);
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sc_Seq$();
  return this$1.from__sc_IterableOnce__sc_SeqOps(coll);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__I__O(v1));
});
var $d_Lorg_scalajs_dom_DOMList$DOMListSeq = new $TypeData().initClass($c_Lorg_scalajs_dom_DOMList$DOMListSeq, "org.scalajs.dom.DOMList$DOMListSeq", ({
  Lorg_scalajs_dom_DOMList$DOMListSeq: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_IterableOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Iterable: 1,
  F1: 1,
  s_PartialFunction: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sc_Seq: 1
}));
/** @constructor */
function $c_sc_AbstractSet() {
}
$c_sc_AbstractSet.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractSet.prototype.constructor = $c_sc_AbstractSet;
/** @constructor */
function $h_sc_AbstractSet() {
}
$h_sc_AbstractSet.prototype = $c_sc_AbstractSet.prototype;
$c_sc_AbstractSet.prototype.equals__O__Z = (function(that) {
  return $f_sc_Set__equals__O__Z(this, that);
});
$c_sc_AbstractSet.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.unorderedHash__sc_IterableOnce__I__I(this, this$1.s_util_hashing_MurmurHash3$__f_setSeed);
});
$c_sc_AbstractSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_Set$();
});
$c_sc_AbstractSet.prototype.stringPrefix__T = (function() {
  return "Set";
});
$c_sc_AbstractSet.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$c_sc_AbstractSet.prototype.subsetOf__sc_Set__Z = (function(that) {
  return this.forall__F1__Z(that);
});
$c_sc_AbstractSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  return $f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps(this, that);
});
$c_sc_AbstractSet.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return this.contains__O__Z(v1);
});
$c_sc_AbstractSet.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sc_AbstractSet.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_sc_AbstractSet.prototype.apply__O__O = (function(v1) {
  return this.contains__O__Z(v1);
});
function $is_sc_IndexedSeqView(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IndexedSeqView)));
}
function $as_sc_IndexedSeqView(obj) {
  return (($is_sc_IndexedSeqView(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IndexedSeqView"));
}
function $isArrayOf_sc_IndexedSeqView(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IndexedSeqView)));
}
function $asArrayOf_sc_IndexedSeqView(obj, depth) {
  return (($isArrayOf_sc_IndexedSeqView(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IndexedSeqView;", depth));
}
function $f_sc_Map__equals__O__Z($thiz, o) {
  if (($thiz === o)) {
    return true;
  } else {
    if ($is_sc_Map(o)) {
      var x2 = $as_sc_Map(o);
      if (($n(x2), true)) {
        if (($thiz.size__I() === $n(x2).size__I())) {
          try {
            return $thiz.forall__F1__Z(new $c_sjsr_AnonFunction1(((kv$2) => {
              var kv = $as_T2(kv$2);
              return $m_sr_BoxesRunTime$().equals__O__O__Z($n(x2).getOrElse__O__F0__O($n(kv)._1__O(), $m_sc_Map$().sc_Map$__f_scala$collection$Map$$DefaultSentinelFn), $n(kv)._2__O());
            })));
          } catch (e) {
            if ((e instanceof $c_jl_ClassCastException)) {
              return false;
            } else {
              throw e;
            }
          }
        } else {
          return false;
        }
      }
    }
    return false;
  }
}
function $is_sc_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Map)));
}
function $as_sc_Map(obj) {
  return (($is_sc_Map(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Map"));
}
function $isArrayOf_sc_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Map)));
}
function $asArrayOf_sc_Map(obj, depth) {
  return (($isArrayOf_sc_Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Map;", depth));
}
function $f_sc_MapView__partition__F1__T2($thiz, p) {
  return new $c_T2($thiz.filter__F1__sc_MapView(p), $thiz.filterNot__F1__sc_MapView(p));
}
function $is_sc_MapView(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_MapView)));
}
function $as_sc_MapView(obj) {
  return (($is_sc_MapView(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.MapView"));
}
function $isArrayOf_sc_MapView(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_MapView)));
}
function $asArrayOf_sc_MapView(obj, depth) {
  return (($isArrayOf_sc_MapView(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.MapView;", depth));
}
function $p_s_concurrent_impl_Promise$Transformation__handleFailure__jl_Throwable__s_concurrent_ExecutionContext__V($thiz, t, e) {
  var wasInterrupted = false;
  if ((wasInterrupted || $m_s_util_control_NonFatal$().apply__jl_Throwable__Z(t))) {
    var completed = $thiz.tryComplete0__O__s_util_Try__Z($thiz.ju_concurrent_atomic_AtomicReference__f_value, $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try(new $c_s_util_Failure(t)));
    if ((completed && wasInterrupted)) {
      var this$1 = $n($m_jl_Thread$().jl_Thread$__f_SingleThread);
      this$1.jl_Thread__f_java$lang$Thread$$interruptedState = true;
    }
    if (((($thiz.s_concurrent_impl_Promise$Transformation__f__xform === 5) || ($thiz.s_concurrent_impl_Promise$Transformation__f__xform === 6)) || (!completed))) {
      $n(e).reportFailure__jl_Throwable__V(t);
    }
  } else {
    throw ((t instanceof $c_sjs_js_JavaScriptException) ? t.sjs_js_JavaScriptException__f_exception : $n(t));
  }
}
function $ct_s_concurrent_impl_Promise$Transformation__F1__s_concurrent_ExecutionContext__s_util_Try__I__($thiz, _fun, _ec, _arg, _xform) {
  $thiz.s_concurrent_impl_Promise$Transformation__f__fun = _fun;
  $thiz.s_concurrent_impl_Promise$Transformation__f__ec = _ec;
  $thiz.s_concurrent_impl_Promise$Transformation__f__arg = _arg;
  $thiz.s_concurrent_impl_Promise$Transformation__f__xform = _xform;
  $ct_s_concurrent_impl_Promise$DefaultPromise__($thiz);
  return $thiz;
}
function $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__($thiz, xform, f, ec) {
  var this$1 = $n(ec);
  $ct_s_concurrent_impl_Promise$Transformation__F1__s_concurrent_ExecutionContext__s_util_Try__I__($thiz, f, this$1, null, xform);
  return $thiz;
}
/** @constructor */
function $c_s_concurrent_impl_Promise$Transformation() {
  this.ju_concurrent_atomic_AtomicReference__f_value = null;
  this.s_concurrent_impl_Promise$Transformation__f__fun = null;
  this.s_concurrent_impl_Promise$Transformation__f__ec = null;
  this.s_concurrent_impl_Promise$Transformation__f__arg = null;
  this.s_concurrent_impl_Promise$Transformation__f__xform = 0;
}
$c_s_concurrent_impl_Promise$Transformation.prototype = new $h_s_concurrent_impl_Promise$DefaultPromise();
$c_s_concurrent_impl_Promise$Transformation.prototype.constructor = $c_s_concurrent_impl_Promise$Transformation;
/** @constructor */
function $h_s_concurrent_impl_Promise$Transformation() {
}
$h_s_concurrent_impl_Promise$Transformation.prototype = $c_s_concurrent_impl_Promise$Transformation.prototype;
$c_s_concurrent_impl_Promise$Transformation.prototype.submitWithValue__s_util_Try__s_concurrent_impl_Promise$Transformation = (function(resolved) {
  this.s_concurrent_impl_Promise$Transformation__f__arg = resolved;
  var e = this.s_concurrent_impl_Promise$Transformation__f__ec;
  try {
    $n(e).execute__jl_Runnable__V(this);
  } catch (e$2) {
    var e$3 = ((e$2 instanceof $c_jl_Throwable) ? e$2 : new $c_sjs_js_JavaScriptException(e$2));
    this.s_concurrent_impl_Promise$Transformation__f__fun = null;
    this.s_concurrent_impl_Promise$Transformation__f__arg = null;
    this.s_concurrent_impl_Promise$Transformation__f__ec = null;
    $p_s_concurrent_impl_Promise$Transformation__handleFailure__jl_Throwable__s_concurrent_ExecutionContext__V(this, e$3, e);
  }
  return this;
});
$c_s_concurrent_impl_Promise$Transformation.prototype.run__V = (function() {
  var v = this.s_concurrent_impl_Promise$Transformation__f__arg;
  var fun = this.s_concurrent_impl_Promise$Transformation__f__fun;
  var ec = this.s_concurrent_impl_Promise$Transformation__f__ec;
  this.s_concurrent_impl_Promise$Transformation__f__fun = null;
  this.s_concurrent_impl_Promise$Transformation__f__arg = null;
  this.s_concurrent_impl_Promise$Transformation__f__ec = null;
  try {
    var x1 = this.s_concurrent_impl_Promise$Transformation__f__xform;
    switch (x1) {
      case 0: {
        var resolvedResult = null;
        break;
      }
      case 1: {
        var resolvedResult = ((v instanceof $c_s_util_Success) ? new $c_s_util_Success($n(fun).apply__O__O($n(v).get__O())) : v);
        break;
      }
      case 2: {
        if ((v instanceof $c_s_util_Success)) {
          var f = $n(fun).apply__O__O($n(v).get__O());
          if ((f instanceof $c_s_concurrent_impl_Promise$DefaultPromise)) {
            $n($as_s_concurrent_impl_Promise$DefaultPromise(f)).linkRootOf__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$Link__V(this, null);
          } else {
            this.completeWith__s_concurrent_Future__s_concurrent_impl_Promise$DefaultPromise($as_s_concurrent_Future(f));
          }
          var resolvedResult = null;
        } else {
          var resolvedResult = v;
        }
        break;
      }
      case 3: {
        var resolvedResult = $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try($as_s_util_Try($n(fun).apply__O__O(v)));
        break;
      }
      case 4: {
        var f$2 = $n(fun).apply__O__O(v);
        if ((f$2 instanceof $c_s_concurrent_impl_Promise$DefaultPromise)) {
          $n($as_s_concurrent_impl_Promise$DefaultPromise(f$2)).linkRootOf__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$Link__V(this, null);
        } else {
          this.completeWith__s_concurrent_Future__s_concurrent_impl_Promise$DefaultPromise($as_s_concurrent_Future(f$2));
        }
        var resolvedResult = null;
        break;
      }
      case 5: {
        $n(v).foreach__F1__V(fun);
        var resolvedResult = null;
        break;
      }
      case 6: {
        $n(fun).apply__O__O(v);
        var resolvedResult = null;
        break;
      }
      case 7: {
        var resolvedResult = ((v instanceof $c_s_util_Failure) ? $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try($n(v).recover__s_PartialFunction__s_util_Try($as_s_PartialFunction(fun))) : v);
        break;
      }
      case 8: {
        if ((v instanceof $c_s_util_Failure)) {
          var f$3 = $as_s_concurrent_Future($n($as_s_PartialFunction(fun)).applyOrElse__O__F1__O($n($as_s_util_Failure(v)).s_util_Failure__f_exception, $m_s_concurrent_Future$().s_concurrent_Future$__f_recoverWithFailed));
          var resolvedResult = ((f$3 !== $m_s_concurrent_Future$().s_concurrent_Future$__f_recoverWithFailedMarker) ? (((f$3 instanceof $c_s_concurrent_impl_Promise$DefaultPromise) ? $n($as_s_concurrent_impl_Promise$DefaultPromise(f$3)).linkRootOf__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$Link__V(this, null) : this.completeWith__s_concurrent_Future__s_concurrent_impl_Promise$DefaultPromise(f$3)), null) : v);
        } else {
          var resolvedResult = v;
        }
        break;
      }
      case 9: {
        var resolvedResult = (((v instanceof $c_s_util_Failure) || $uZ($n(fun).apply__O__O($n(v).get__O()))) ? v : $m_s_concurrent_Future$().s_concurrent_Future$__f_filterFailure);
        break;
      }
      case 10: {
        var resolvedResult = ((v instanceof $c_s_util_Success) ? new $c_s_util_Success($n($as_s_PartialFunction(fun)).applyOrElse__O__F1__O($n(v).get__O(), $m_s_concurrent_Future$().s_concurrent_Future$__f_collectFailed)) : v);
        break;
      }
      default: {
        var resolvedResult = new $c_s_util_Failure($ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), ("BUG: encountered transformation promise with illegal type: " + this.s_concurrent_impl_Promise$Transformation__f__xform)));
      }
    }
    if ((resolvedResult !== null)) {
      this.tryComplete0__O__s_util_Try__Z(this.ju_concurrent_atomic_AtomicReference__f_value, resolvedResult);
    }
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    $p_s_concurrent_impl_Promise$Transformation__handleFailure__jl_Throwable__s_concurrent_ExecutionContext__V(this, e$2, ec);
  }
});
function $as_s_concurrent_impl_Promise$Transformation(obj) {
  return (((obj instanceof $c_s_concurrent_impl_Promise$Transformation) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.impl.Promise$Transformation"));
}
function $isArrayOf_s_concurrent_impl_Promise$Transformation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$Transformation)));
}
function $asArrayOf_s_concurrent_impl_Promise$Transformation(obj, depth) {
  return (($isArrayOf_s_concurrent_impl_Promise$Transformation(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.impl.Promise$Transformation;", depth));
}
var $d_s_concurrent_impl_Promise$Transformation = new $TypeData().initClass($c_s_concurrent_impl_Promise$Transformation, "scala.concurrent.impl.Promise$Transformation", ({
  s_concurrent_impl_Promise$Transformation: 1,
  s_concurrent_impl_Promise$DefaultPromise: 1,
  ju_concurrent_atomic_AtomicReference: 1,
  Ljava_io_Serializable: 1,
  s_concurrent_Promise: 1,
  s_concurrent_Future: 1,
  s_concurrent_Awaitable: 1,
  F1: 1,
  s_concurrent_impl_Promise$Callbacks: 1,
  jl_Runnable: 1,
  s_concurrent_Batchable: 1
}));
/** @constructor */
function $c_sr_RichChar(self) {
  this.sr_RichChar__f_self = 0;
  this.sr_RichChar__f_self = self;
}
$c_sr_RichChar.prototype = new $h_O();
$c_sr_RichChar.prototype.constructor = $c_sr_RichChar;
/** @constructor */
function $h_sr_RichChar() {
}
$h_sr_RichChar.prototype = $c_sr_RichChar.prototype;
$c_sr_RichChar.prototype.isWhole__Z = (function() {
  return true;
});
$c_sr_RichChar.prototype.compare__O__I = (function(y) {
  var x = this.sr_RichChar__f_self;
  var y$1 = $uC(y);
  return ((x - y$1) | 0);
});
$c_sr_RichChar.prototype.compareTo__O__I = (function(that) {
  var x = this.sr_RichChar__f_self;
  var y = $uC(that);
  return ((x - y) | 0);
});
$c_sr_RichChar.prototype.toString__T = (function() {
  return $f_s_Proxy__toString__T(this);
});
$c_sr_RichChar.prototype.isValidByte__Z = (function() {
  return $f_s_math_ScalaNumericAnyConversions__isValidByte__Z(this);
});
$c_sr_RichChar.prototype.isValidShort__Z = (function() {
  return $f_s_math_ScalaNumericAnyConversions__isValidShort__Z(this);
});
$c_sr_RichChar.prototype.isValidInt__Z = (function() {
  return $f_s_math_ScalaNumericAnyConversions__isValidInt__Z(this);
});
$c_sr_RichChar.prototype.doubleValue__D = (function() {
  var this$ = this.sr_RichChar__f_self;
  return this$;
});
$c_sr_RichChar.prototype.floatValue__F = (function() {
  var this$ = this.sr_RichChar__f_self;
  return Math.fround(this$);
});
$c_sr_RichChar.prototype.longValue__J = (function() {
  var this$ = this.sr_RichChar__f_self;
  var value = this$;
  var hi = (value >> 31);
  return new $c_RTLong(value, hi);
});
$c_sr_RichChar.prototype.intValue__I = (function() {
  var this$ = this.sr_RichChar__f_self;
  return this$;
});
$c_sr_RichChar.prototype.byteValue__B = (function() {
  var this$ = this.sr_RichChar__f_self;
  return ((this$ << 24) >> 24);
});
$c_sr_RichChar.prototype.shortValue__S = (function() {
  var this$ = this.sr_RichChar__f_self;
  return ((this$ << 16) >> 16);
});
$c_sr_RichChar.prototype.isValidChar__Z = (function() {
  return true;
});
$c_sr_RichChar.prototype.hashCode__I = (function() {
  var this$ = this.sr_RichChar__f_self;
  return this$;
});
$c_sr_RichChar.prototype.equals__O__Z = (function(x$1) {
  return $m_sr_RichChar$().equals$extension__C__O__Z(this.sr_RichChar__f_self, x$1);
});
$c_sr_RichChar.prototype.num__s_math_Integral = (function() {
  return $m_s_math_Numeric$CharIsIntegral$();
});
$c_sr_RichChar.prototype.self__O = (function() {
  return $bC(this.sr_RichChar__f_self);
});
function $as_sr_RichChar(obj) {
  return (((obj instanceof $c_sr_RichChar) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.runtime.RichChar"));
}
function $isArrayOf_sr_RichChar(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sr_RichChar)));
}
function $asArrayOf_sr_RichChar(obj, depth) {
  return (($isArrayOf_sr_RichChar(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.runtime.RichChar;", depth));
}
var $d_sr_RichChar = new $TypeData().initClass($c_sr_RichChar, "scala.runtime.RichChar", ({
  sr_RichChar: 1,
  sr_IntegralProxy: 1,
  sr_ScalaWholeNumberProxy: 1,
  sr_ScalaNumberProxy: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_Proxy$Typed: 1,
  s_Proxy: 1,
  sr_OrderedProxy: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1,
  sr_RangedProxy: 1
}));
/** @constructor */
function $c_sr_RichLong(self) {
  this.sr_RichLong__f_self = $L0;
  this.sr_RichLong__f_self = self;
}
$c_sr_RichLong.prototype = new $h_O();
$c_sr_RichLong.prototype.constructor = $c_sr_RichLong;
/** @constructor */
function $h_sr_RichLong() {
}
$h_sr_RichLong.prototype = $c_sr_RichLong.prototype;
$c_sr_RichLong.prototype.isWhole__Z = (function() {
  return true;
});
$c_sr_RichLong.prototype.compare__O__I = (function(y) {
  var t$1 = this.sr_RichLong__f_self;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var t$2 = $uJ(new $c_RTLong(lo$1, hi$1));
  var lo$2 = t$2.RTLong__f_lo;
  var hi$2 = t$2.RTLong__f_hi;
  var t$3 = $uJ(y);
  var lo$3 = t$3.RTLong__f_lo;
  var hi$3 = t$3.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo$2, hi$2, lo$3, hi$3);
});
$c_sr_RichLong.prototype.compareTo__O__I = (function(that) {
  var t$1 = this.sr_RichLong__f_self;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var t$2 = $uJ(new $c_RTLong(lo$1, hi$1));
  var lo$2 = t$2.RTLong__f_lo;
  var hi$2 = t$2.RTLong__f_hi;
  var t$3 = $uJ(that);
  var lo$3 = t$3.RTLong__f_lo;
  var hi$3 = t$3.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo$2, hi$2, lo$3, hi$3);
});
$c_sr_RichLong.prototype.toString__T = (function() {
  return $f_s_Proxy__toString__T(this);
});
$c_sr_RichLong.prototype.doubleValue__D = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo, hi);
});
$c_sr_RichLong.prototype.floatValue__F = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toFloat__I__I__F(lo, hi);
});
$c_sr_RichLong.prototype.longValue__J = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return new $c_RTLong(lo, hi);
});
$c_sr_RichLong.prototype.intValue__I = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  return lo;
});
$c_sr_RichLong.prototype.byteValue__B = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  return ((lo << 24) >> 24);
});
$c_sr_RichLong.prototype.shortValue__S = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  return ((lo << 16) >> 16);
});
$c_sr_RichLong.prototype.isValidByte__Z = (function() {
  return $m_sr_RichLong$().isValidByte$extension__J__Z(this.sr_RichLong__f_self);
});
$c_sr_RichLong.prototype.isValidShort__Z = (function() {
  return $m_sr_RichLong$().isValidShort$extension__J__Z(this.sr_RichLong__f_self);
});
$c_sr_RichLong.prototype.isValidChar__Z = (function() {
  return $m_sr_RichLong$().isValidChar$extension__J__Z(this.sr_RichLong__f_self);
});
$c_sr_RichLong.prototype.isValidInt__Z = (function() {
  return $m_sr_RichLong$().isValidInt$extension__J__Z(this.sr_RichLong__f_self);
});
$c_sr_RichLong.prototype.hashCode__I = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return (lo ^ hi);
});
$c_sr_RichLong.prototype.equals__O__Z = (function(x$1) {
  return $m_sr_RichLong$().equals$extension__J__O__Z(this.sr_RichLong__f_self, x$1);
});
$c_sr_RichLong.prototype.num__s_math_Integral = (function() {
  var t = this.sr_RichLong__f_self;
  return $m_s_math_Numeric$LongIsIntegral$();
});
$c_sr_RichLong.prototype.self__O = (function() {
  return this.sr_RichLong__f_self;
});
function $as_sr_RichLong(obj) {
  return (((obj instanceof $c_sr_RichLong) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.runtime.RichLong"));
}
function $isArrayOf_sr_RichLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sr_RichLong)));
}
function $asArrayOf_sr_RichLong(obj, depth) {
  return (($isArrayOf_sr_RichLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.runtime.RichLong;", depth));
}
var $d_sr_RichLong = new $TypeData().initClass($c_sr_RichLong, "scala.runtime.RichLong", ({
  sr_RichLong: 1,
  sr_IntegralProxy: 1,
  sr_ScalaWholeNumberProxy: 1,
  sr_ScalaNumberProxy: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_Proxy$Typed: 1,
  s_Proxy: 1,
  sr_OrderedProxy: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1,
  sr_RangedProxy: 1
}));
function $f_Lcats_Monad__map__O__F1__O($thiz, fa, f) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1(((a) => $thiz.pure__O__O($n(f).apply__O__O(a)))));
}
function $f_Lcats_Monad__iterateWhile__O__F1__O($thiz, f, p) {
  return $thiz.flatMap__O__F1__O(f, new $c_sjsr_AnonFunction1(((i) => {
    var f$1 = new $c_sjsr_AnonFunction1(((_$8) => f));
    return $f_Lcats_Monad__iterateWhileM__O__F1__F1__O($thiz, i, f$1, p);
  })));
}
function $f_Lcats_Monad__iterateWhileM__O__F1__F1__O($thiz, init, f, p) {
  return $thiz.tailRecM__O__F1__O(init, new $c_sjsr_AnonFunction1(((a) => ($uZ($n(p).apply__O__O(a)) ? $thiz.map__O__F1__O($n(f).apply__O__O(a), new $c_sjsr_AnonFunction1(((_$10) => new $c_s_util_Left(_$10)))) : $thiz.pure__O__O(new $c_s_util_Right(a))))));
}
function $is_Lcats_Monad(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_Monad)));
}
function $as_Lcats_Monad(obj) {
  return (($is_Lcats_Monad(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Monad"));
}
function $isArrayOf_Lcats_Monad(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Monad)));
}
function $asArrayOf_Lcats_Monad(obj, depth) {
  return (($isArrayOf_Lcats_Monad(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Monad;", depth));
}
function $f_Lcats_data_KleisliFlatMap__tailRecM__O__F1__Lcats_data_Kleisli($thiz, b, f) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((a) => $n($thiz.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1).tailRecM__O__F1__O(b, new $c_sjsr_AnonFunction1(((_$171) => $n($n($as_Lcats_data_Kleisli($n(f).apply__O__O(_$171))).Lcats_data_Kleisli__f_run).apply__O__O(a))))));
  return new $c_Lcats_data_Kleisli(run);
}
function $ct_Lcats_data_KleisliInstances__($thiz) {
  $ct_Lcats_data_KleisliInstances3__($thiz);
  $as_Lcats_CommutativeMonad($m_Lcats_package$().Lcats_package$__f_catsInstancesForId);
  return $thiz;
}
/** @constructor */
function $c_Lcats_data_KleisliInstances() {
}
$c_Lcats_data_KleisliInstances.prototype = new $h_Lcats_data_KleisliInstances0();
$c_Lcats_data_KleisliInstances.prototype.constructor = $c_Lcats_data_KleisliInstances;
/** @constructor */
function $h_Lcats_data_KleisliInstances() {
}
$h_Lcats_data_KleisliInstances.prototype = $c_Lcats_data_KleisliInstances.prototype;
function $ct_Lcats_data_ValidatedApplicative__Lcats_kernel_Semigroup__($thiz, evidence$1) {
  $thiz.Lcats_data_ValidatedApplicative__f_evidence$1 = evidence$1;
  return $thiz;
}
/** @constructor */
function $c_Lcats_data_ValidatedApplicative() {
  this.Lcats_data_ValidatedApplicative__f_evidence$1 = null;
}
$c_Lcats_data_ValidatedApplicative.prototype = new $h_O();
$c_Lcats_data_ValidatedApplicative.prototype.constructor = $c_Lcats_data_ValidatedApplicative;
/** @constructor */
function $h_Lcats_data_ValidatedApplicative() {
}
$h_Lcats_data_ValidatedApplicative.prototype = $c_Lcats_data_ValidatedApplicative.prototype;
$c_Lcats_data_ValidatedApplicative.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_Lcats_data_Validated(fa);
  return $n(fa$1).map__F1__Lcats_data_Validated(f);
});
$c_Lcats_data_ValidatedApplicative.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_data_ValidatedApplicative.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_data_ValidatedApplicative.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_Apply__productR__O__O__O(this, fa, fb);
});
$c_Lcats_data_ValidatedApplicative.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_Apply__productL__O__O__O(this, fa, fb);
});
$c_Lcats_data_ValidatedApplicative.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_Apply__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_data_ValidatedApplicative.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_Apply__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_data_ValidatedApplicative.prototype.ap__Lcats_data_Validated__Lcats_data_Validated__Lcats_data_Validated = (function(ff, fa) {
  var $x_1 = $n(fa);
  $n($m_Lcats_package$().Lcats_package$__f_Semigroup);
  var ev = this.Lcats_data_ValidatedApplicative__f_evidence$1;
  return $n($x_1).ap__Lcats_data_Validated__Lcats_kernel_Semigroup__Lcats_data_Validated(ff, ev);
});
$c_Lcats_data_ValidatedApplicative.prototype.product__Lcats_data_Validated__Lcats_data_Validated__Lcats_data_Validated = (function(fa, fb) {
  var $x_1 = $n(fa);
  $n($m_Lcats_package$().Lcats_package$__f_Semigroup);
  var ev = this.Lcats_data_ValidatedApplicative__f_evidence$1;
  return $n($x_1).product__Lcats_data_Validated__Lcats_kernel_Semigroup__Lcats_data_Validated(fb, ev);
});
$c_Lcats_data_ValidatedApplicative.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Validated(fa);
  return $n(fa$1).map__F1__Lcats_data_Validated(f);
});
$c_Lcats_data_ValidatedApplicative.prototype.pure__O__O = (function(x) {
  $m_Lcats_data_Validated$();
  return new $c_Lcats_data_Validated$Valid(x);
});
$c_Lcats_data_ValidatedApplicative.prototype.ap__O__O__O = (function(ff, fa) {
  return this.ap__Lcats_data_Validated__Lcats_data_Validated__Lcats_data_Validated($as_Lcats_data_Validated(ff), $as_Lcats_data_Validated(fa));
});
$c_Lcats_data_ValidatedApplicative.prototype.product__O__O__O = (function(fa, fb) {
  return this.product__Lcats_data_Validated__Lcats_data_Validated__Lcats_data_Validated($as_Lcats_data_Validated(fa), $as_Lcats_data_Validated(fb));
});
$c_Lcats_data_ValidatedApplicative.prototype.unit__O = (function() {
  return $m_Lcats_data_Validated$().Lcats_data_Validated$__f_validUnit;
});
/** @constructor */
function $c_Lcats_effect_kernel_Resource$() {
}
$c_Lcats_effect_kernel_Resource$.prototype = new $h_Lcats_effect_kernel_ResourceFOInstances0();
$c_Lcats_effect_kernel_Resource$.prototype.constructor = $c_Lcats_effect_kernel_Resource$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$() {
}
$h_Lcats_effect_kernel_Resource$.prototype = $c_Lcats_effect_kernel_Resource$.prototype;
$c_Lcats_effect_kernel_Resource$.prototype.apply__O__Lcats_Functor__Lcats_effect_kernel_Resource = (function(resource, F) {
  var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(resource, F);
  var f = new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var a = $n(x$1$1)._1__O();
      var release = $n(x$1$1)._2__O();
      var _2 = new $c_sjsr_AnonFunction1(((_$51) => {
        $as_Lcats_effect_kernel_Resource$ExitCase(_$51);
        return release;
      }));
      return new $c_T2(a, _2);
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return this.applyCase__O__Lcats_effect_kernel_Resource($n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f));
});
$c_Lcats_effect_kernel_Resource$.prototype.applyCase__O__Lcats_effect_kernel_Resource = (function(resource) {
  var resource$1 = new $c_sjsr_AnonFunction1(((_$53) => {
    $as_Lcats_effect_kernel_Poll(_$53);
    return resource;
  }));
  return new $c_Lcats_effect_kernel_Resource$Allocate(resource$1);
});
$c_Lcats_effect_kernel_Resource$.prototype.make__O__F1__Lcats_Functor__Lcats_effect_kernel_Resource = (function(acquire, release, F) {
  var this$5 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(acquire, F);
  var f = new $c_sjsr_AnonFunction1(((a) => {
    var y = $n(release).apply__O__O(a);
    return new $c_T2(a, y);
  }));
  return this.apply__O__Lcats_Functor__Lcats_effect_kernel_Resource($n(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f), F);
});
$c_Lcats_effect_kernel_Resource$.prototype.makeCase__O__F2__Lcats_Functor__Lcats_effect_kernel_Resource = (function(acquire, release, F) {
  var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(acquire, F);
  var f = new $c_sjsr_AnonFunction1(((a) => {
    var _2 = new $c_sjsr_AnonFunction1(((e) => {
      var e$1 = $as_Lcats_effect_kernel_Resource$ExitCase(e);
      return $n(release).apply__O__O__O(a, e$1);
    }));
    return new $c_T2(a, _2);
  }));
  return this.applyCase__O__Lcats_effect_kernel_Resource($n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f));
});
$c_Lcats_effect_kernel_Resource$.prototype.makeFull__F1__F1__Lcats_Functor__Lcats_effect_kernel_Resource = (function(acquire, release, F) {
  var resource = new $c_sjsr_AnonFunction1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var target = $n(acquire).apply__O__O(poll$1);
    var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, F);
    var f = new $c_sjsr_AnonFunction1(((a) => {
      var _2 = new $c_sjsr_AnonFunction1(((_$59) => {
        $as_Lcats_effect_kernel_Resource$ExitCase(_$59);
        return $n(release).apply__O__O(a);
      }));
      return new $c_T2(a, _2);
    }));
    return $n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  }));
  return new $c_Lcats_effect_kernel_Resource$Allocate(resource);
});
$c_Lcats_effect_kernel_Resource$.prototype.uncancelable__F1__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource = (function(body, F) {
  var resource = new $c_sjsr_AnonFunction1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var inner = new $c_Lcats_effect_kernel_Resource$$anon$6(F, poll$1);
    return $n($as_Lcats_effect_kernel_Resource($n(body).apply__O__O(inner))).allocatedCase__Lcats_effect_kernel_MonadCancel__O(F);
  }));
  return new $c_Lcats_effect_kernel_Resource$Allocate(resource);
});
$c_Lcats_effect_kernel_Resource$.prototype.deferred__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource = (function(F) {
  var fa = $n(F).deferred__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa).map__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1(((_$81) => {
    var _$81$1 = $as_Lcats_effect_kernel_Deferred(_$81);
    var this$5 = $n(_$81$1);
    var f = new $c_Lcats_effect_kernel_Resource$$anon$5();
    return new $c_Lcats_effect_kernel_Deferred$TransformedDeferred(this$5, f);
  })));
});
$c_Lcats_effect_kernel_Resource$.prototype.ref__O__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource = (function(a, F) {
  var fa = $n(F).ref__O__O(a);
  return new $c_Lcats_effect_kernel_Resource$Eval(fa).map__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1(((_$84) => {
    var _$84$1 = $as_Lcats_effect_kernel_Ref(_$84);
    var this$5 = $n(_$84$1);
    var f = new $c_Lcats_effect_kernel_Resource$$anon$5();
    return new $c_Lcats_effect_kernel_Ref$TransformedRef(this$5, f, F);
  })));
});
$c_Lcats_effect_kernel_Resource$.prototype.suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_effect_kernel_Sync__Lcats_effect_kernel_Resource = (function(hint, thunk, F) {
  var fa = $n(F).suspend__Lcats_effect_kernel_Sync$Type__F0__O(hint, thunk);
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
});
$c_Lcats_effect_kernel_Resource$.prototype.cont__Lcats_effect_kernel_Cont__Lcats_effect_kernel_Async__Lcats_effect_kernel_Resource = (function(body, F) {
  var resource = new $c_sjsr_AnonFunction1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    return $n(poll$1).apply__O__O($n(F).cont__Lcats_effect_kernel_Cont__O(new $c_Lcats_effect_kernel_Resource$$anon$7(body, F)));
  }));
  return new $c_Lcats_effect_kernel_Resource$Allocate(resource);
});
$c_Lcats_effect_kernel_Resource$.prototype.raiseError__O__Lcats_ApplicativeError__Lcats_effect_kernel_Resource = (function(e, F) {
  var fa = $n(F).raiseError__O__O(e);
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
});
var $d_Lcats_effect_kernel_Resource$ = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$, "cats.effect.kernel.Resource$", ({
  Lcats_effect_kernel_Resource$: 1,
  Lcats_effect_kernel_ResourceFOInstances0: 1,
  Lcats_effect_kernel_ResourceFOInstances1: 1,
  Lcats_effect_kernel_ResourceHOInstances5: 1,
  Lcats_effect_kernel_ResourceHOInstances4: 1,
  Lcats_effect_kernel_ResourceHOInstances3: 1,
  Lcats_effect_kernel_ResourceHOInstances2: 1,
  Lcats_effect_kernel_ResourceHOInstances1: 1,
  Lcats_effect_kernel_ResourceHOInstances0: 1,
  Lcats_effect_kernel_ResourcePlatform: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Lcats_effect_kernel_Resource$;
function $m_Lcats_effect_kernel_Resource$() {
  if ((!$n_Lcats_effect_kernel_Resource$)) {
    $n_Lcats_effect_kernel_Resource$ = new $c_Lcats_effect_kernel_Resource$();
  }
  return $n_Lcats_effect_kernel_Resource$;
}
/** @constructor */
function $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4(F$3) {
  this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4__f_F$1 = null;
  this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4__f_F$1 = F$3;
}
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype = new $h_O();
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.constructor = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4;
/** @constructor */
function $h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4() {
}
$h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype;
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return this.map__O__F1__O(fa, f);
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_Apply__productR__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_Apply__productL__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_Apply__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.pure__O__O = (function(a) {
  var fa = $n(this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4__f_F$1).pure__O__O(a);
  $n($m_Lcats_effect_kernel_Par$().Lcats_effect_kernel_Par$__f_instance);
  return fa;
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  $m_Lcats_implicits$();
  var target = $n(this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4__f_F$1).both__O__O__O(($n($m_Lcats_effect_kernel_Par$().Lcats_effect_kernel_Par$__f_instance), fa), ($n($m_Lcats_effect_kernel_Par$().Lcats_effect_kernel_Par$__f_instance), fb));
  var tc = this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4__f_F$1;
  var this$6 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
  var f$1 = new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var a = $n(x$1$1)._1__O();
      var b = $n(x$1$1)._2__O();
      return $n(f).apply__O__O__O(a, b);
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  var fa$1 = $n(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
  $n($m_Lcats_effect_kernel_Par$().Lcats_effect_kernel_Par$__f_instance);
  return fa$1;
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.ap__O__O__O = (function(ff, fa) {
  return this.map2__O__O__F2__O(ff, fa, new $c_sjsr_AnonFunction2(((_$6, _$7) => {
    var _$6$1 = $as_F1(_$6);
    return $n(_$6$1).apply__O__O(_$7);
  })));
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.product__O__O__O = (function(fa, fb) {
  return this.map2__O__O__F2__O(fa, fb, new $c_sjsr_AnonFunction2(((_$8, _$9) => new $c_T2(_$8, _$9))));
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.map__O__F1__O = (function(fa, f) {
  $m_Lcats_implicits$();
  $n($m_Lcats_effect_kernel_Par$().Lcats_effect_kernel_Par$__f_instance);
  var tc = this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4__f_F$1;
  var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(fa, tc);
  var fa$1 = $n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  $n($m_Lcats_effect_kernel_Par$().Lcats_effect_kernel_Par$__f_instance);
  return fa$1;
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.unit__O = (function() {
  var this$1 = $n(this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4__f_F$1);
  var fa = this$1.pure__O__O((void 0));
  $n($m_Lcats_effect_kernel_Par$().Lcats_effect_kernel_Par$__f_instance);
  return fa;
});
var $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4 = new $TypeData().initClass($c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4, "cats.effect.kernel.instances.GenSpawnInstances$$anon$4", ({
  Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_CommutativeApply: 1,
  Lcats_CommutativeApplicative: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_BigIntOrder() {
}
$c_Lcats_kernel_instances_BigIntOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_BigIntOrder.prototype.constructor = $c_Lcats_kernel_instances_BigIntOrder;
/** @constructor */
function $h_Lcats_kernel_instances_BigIntOrder() {
}
$h_Lcats_kernel_instances_BigIntOrder.prototype = $c_Lcats_kernel_instances_BigIntOrder.prototype;
$c_Lcats_kernel_instances_BigIntOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.toOrdering__s_math_Ordering = (function() {
  return new $c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_s_math_BigInt(x);
  return $n(x$1).hashCode__I();
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_s_math_BigInt(x);
  var y$1 = $as_s_math_BigInt(y);
  return $n(x$1).compare__s_math_BigInt__I(y$1);
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.eqv__O__O__Z = (function(x, y) {
  var x$1 = $as_s_math_BigInt(x);
  var y$1 = $as_s_math_BigInt(y);
  return $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(x$1, y$1);
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.gt__O__O__Z = (function(x, y) {
  var x$1 = $as_s_math_BigInt(x);
  var y$1 = $as_s_math_BigInt(y);
  var this$1 = $n(x$1);
  return $f_s_math_Ordered__$greater__O__Z(this$1, y$1);
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.max__O__O__O = (function(x, y) {
  var x$1 = $as_s_math_BigInt(x);
  var y$1 = $as_s_math_BigInt(y);
  return $n(x$1).max__s_math_BigInt__s_math_BigInt(y$1);
});
var $d_Lcats_kernel_instances_BigIntOrder = new $TypeData().initClass($c_Lcats_kernel_instances_BigIntOrder, "cats.kernel.instances.BigIntOrder", ({
  Lcats_kernel_instances_BigIntOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_Next: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_Previous: 1,
  Lcats_kernel_UnboundedEnumerable: 1,
  Lcats_kernel_instances_BigIntUnboundedEnum: 1
}));
/** @constructor */
function $c_Llaika_ast_Citation(label, content, options) {
  this.Llaika_ast_Citation__f_label = null;
  this.Llaika_ast_Citation__f_content = null;
  this.Llaika_ast_Citation__f_options = null;
  this.Llaika_ast_Citation__f_label = label;
  this.Llaika_ast_Citation__f_content = content;
  this.Llaika_ast_Citation__f_options = options;
}
$c_Llaika_ast_Citation.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_Citation.prototype.constructor = $c_Llaika_ast_Citation;
/** @constructor */
function $h_Llaika_ast_Citation() {
}
$h_Llaika_ast_Citation.prototype = $c_Llaika_ast_Citation.prototype;
$c_Llaika_ast_Citation.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_Citation.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_Citation.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_Citation)) {
    var x$0$2 = $as_Llaika_ast_Citation(x$0);
    if ((this.Llaika_ast_Citation__f_label === $n(x$0$2).Llaika_ast_Citation__f_label)) {
      var x = this.Llaika_ast_Citation__f_content;
      var x$2 = $n(x$0$2).Llaika_ast_Citation__f_content;
      var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Llaika_ast_Citation__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_Citation__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_Citation.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_Citation.prototype.productPrefix__T = (function() {
  return "Citation";
});
$c_Llaika_ast_Citation.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_Citation__f_label;
      break;
    }
    case 1: {
      return this.Llaika_ast_Citation__f_content;
      break;
    }
    case 2: {
      return this.Llaika_ast_Citation__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_Citation.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_Citation__f_content;
});
$c_Llaika_ast_Citation.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_Citation__f_options;
});
$c_Llaika_ast_Citation.prototype.content__O = (function() {
  return this.Llaika_ast_Citation__f_content;
});
$c_Llaika_ast_Citation.prototype.withContent__sci_Seq__Llaika_ast_BlockContainer = (function(newContent) {
  var label = this.Llaika_ast_Citation__f_label;
  var options = this.Llaika_ast_Citation__f_options;
  return new $c_Llaika_ast_Citation(label, newContent, options);
});
$c_Llaika_ast_Citation.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var label = this.Llaika_ast_Citation__f_label;
  var content = this.Llaika_ast_Citation__f_content;
  return new $c_Llaika_ast_Citation(label, content, options);
});
$c_Llaika_ast_Citation.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return $f_Llaika_ast_BlockContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_BlockContainer(this, rules);
});
function $as_Llaika_ast_Citation(obj) {
  return (((obj instanceof $c_Llaika_ast_Citation) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Citation"));
}
function $isArrayOf_Llaika_ast_Citation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Citation)));
}
function $asArrayOf_Llaika_ast_Citation(obj, depth) {
  return (($isArrayOf_Llaika_ast_Citation(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Citation;", depth));
}
var $d_Llaika_ast_Citation = new $TypeData().initClass($c_Llaika_ast_Citation, "laika.ast.Citation", ({
  Llaika_ast_Citation: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_LinkTarget: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_BlockContainer: 1
}));
function $as_Llaika_ast_CodeSpanSequence(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.CodeSpanSequence"));
}
function $isArrayOf_Llaika_ast_CodeSpanSequence(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_CodeSpanSequence)));
}
function $asArrayOf_Llaika_ast_CodeSpanSequence(obj, depth) {
  return (($isArrayOf_Llaika_ast_CodeSpanSequence(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.CodeSpanSequence;", depth));
}
function $as_Llaika_ast_DecoratedHeader(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.DecoratedHeader"));
}
function $isArrayOf_Llaika_ast_DecoratedHeader(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_DecoratedHeader)));
}
function $asArrayOf_Llaika_ast_DecoratedHeader(obj, depth) {
  return (($isArrayOf_Llaika_ast_DecoratedHeader(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.DecoratedHeader;", depth));
}
/** @constructor */
function $c_Llaika_ast_EmbeddedRoot(content, indent, options) {
  this.Llaika_ast_EmbeddedRoot__f_content = null;
  this.Llaika_ast_EmbeddedRoot__f_indent = 0;
  this.Llaika_ast_EmbeddedRoot__f_options = null;
  this.Llaika_ast_EmbeddedRoot__f_content = content;
  this.Llaika_ast_EmbeddedRoot__f_indent = indent;
  this.Llaika_ast_EmbeddedRoot__f_options = options;
}
$c_Llaika_ast_EmbeddedRoot.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_EmbeddedRoot.prototype.constructor = $c_Llaika_ast_EmbeddedRoot;
/** @constructor */
function $h_Llaika_ast_EmbeddedRoot() {
}
$h_Llaika_ast_EmbeddedRoot.prototype = $c_Llaika_ast_EmbeddedRoot.prototype;
$c_Llaika_ast_EmbeddedRoot.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_EmbeddedRoot.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("EmbeddedRoot");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Llaika_ast_EmbeddedRoot__f_content;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Llaika_ast_EmbeddedRoot__f_indent;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Llaika_ast_EmbeddedRoot__f_options;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Llaika_ast_EmbeddedRoot.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_EmbeddedRoot)) {
    var x$0$2 = $as_Llaika_ast_EmbeddedRoot(x$0);
    if ((this.Llaika_ast_EmbeddedRoot__f_indent === $n(x$0$2).Llaika_ast_EmbeddedRoot__f_indent)) {
      var x = this.Llaika_ast_EmbeddedRoot__f_content;
      var x$2 = $n(x$0$2).Llaika_ast_EmbeddedRoot__f_content;
      var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Llaika_ast_EmbeddedRoot__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_EmbeddedRoot__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_EmbeddedRoot.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_EmbeddedRoot.prototype.productPrefix__T = (function() {
  return "EmbeddedRoot";
});
$c_Llaika_ast_EmbeddedRoot.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_EmbeddedRoot__f_content;
      break;
    }
    case 1: {
      return this.Llaika_ast_EmbeddedRoot__f_indent;
      break;
    }
    case 2: {
      return this.Llaika_ast_EmbeddedRoot__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_EmbeddedRoot.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_EmbeddedRoot__f_content;
});
$c_Llaika_ast_EmbeddedRoot.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_EmbeddedRoot__f_options;
});
$c_Llaika_ast_EmbeddedRoot.prototype.content__O = (function() {
  return this.Llaika_ast_EmbeddedRoot__f_content;
});
$c_Llaika_ast_EmbeddedRoot.prototype.withContent__sci_Seq__Llaika_ast_BlockContainer = (function(newContent) {
  var indent = this.Llaika_ast_EmbeddedRoot__f_indent;
  var options = this.Llaika_ast_EmbeddedRoot__f_options;
  return new $c_Llaika_ast_EmbeddedRoot(newContent, indent, options);
});
$c_Llaika_ast_EmbeddedRoot.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_EmbeddedRoot__f_content;
  var indent = this.Llaika_ast_EmbeddedRoot__f_indent;
  return new $c_Llaika_ast_EmbeddedRoot(content, indent, options);
});
$c_Llaika_ast_EmbeddedRoot.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return $f_Llaika_ast_BlockContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_BlockContainer(this, rules);
});
function $as_Llaika_ast_EmbeddedRoot(obj) {
  return (((obj instanceof $c_Llaika_ast_EmbeddedRoot) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.EmbeddedRoot"));
}
function $isArrayOf_Llaika_ast_EmbeddedRoot(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_EmbeddedRoot)));
}
function $asArrayOf_Llaika_ast_EmbeddedRoot(obj, depth) {
  return (($isArrayOf_Llaika_ast_EmbeddedRoot(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.EmbeddedRoot;", depth));
}
var $d_Llaika_ast_EmbeddedRoot = new $TypeData().initClass($c_Llaika_ast_EmbeddedRoot, "laika.ast.EmbeddedRoot", ({
  Llaika_ast_EmbeddedRoot: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_TemplateSpan: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_BlockContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_Footnote(label, content, options) {
  this.Llaika_ast_Footnote__f_label = null;
  this.Llaika_ast_Footnote__f_content = null;
  this.Llaika_ast_Footnote__f_options = null;
  this.Llaika_ast_Footnote__f_label = label;
  this.Llaika_ast_Footnote__f_content = content;
  this.Llaika_ast_Footnote__f_options = options;
}
$c_Llaika_ast_Footnote.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_Footnote.prototype.constructor = $c_Llaika_ast_Footnote;
/** @constructor */
function $h_Llaika_ast_Footnote() {
}
$h_Llaika_ast_Footnote.prototype = $c_Llaika_ast_Footnote.prototype;
$c_Llaika_ast_Footnote.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_Footnote.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_Footnote.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_Footnote)) {
    var x$0$2 = $as_Llaika_ast_Footnote(x$0);
    if ((this.Llaika_ast_Footnote__f_label === $n(x$0$2).Llaika_ast_Footnote__f_label)) {
      var x = this.Llaika_ast_Footnote__f_content;
      var x$2 = $n(x$0$2).Llaika_ast_Footnote__f_content;
      var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Llaika_ast_Footnote__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_Footnote__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_Footnote.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_Footnote.prototype.productPrefix__T = (function() {
  return "Footnote";
});
$c_Llaika_ast_Footnote.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_Footnote__f_label;
      break;
    }
    case 1: {
      return this.Llaika_ast_Footnote__f_content;
      break;
    }
    case 2: {
      return this.Llaika_ast_Footnote__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_Footnote.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_Footnote__f_content;
});
$c_Llaika_ast_Footnote.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_Footnote__f_options;
});
$c_Llaika_ast_Footnote.prototype.content__O = (function() {
  return this.Llaika_ast_Footnote__f_content;
});
$c_Llaika_ast_Footnote.prototype.withContent__sci_Seq__Llaika_ast_BlockContainer = (function(newContent) {
  var label = this.Llaika_ast_Footnote__f_label;
  var options = this.Llaika_ast_Footnote__f_options;
  return new $c_Llaika_ast_Footnote(label, newContent, options);
});
$c_Llaika_ast_Footnote.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var label = this.Llaika_ast_Footnote__f_label;
  var content = this.Llaika_ast_Footnote__f_content;
  return new $c_Llaika_ast_Footnote(label, content, options);
});
$c_Llaika_ast_Footnote.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return $f_Llaika_ast_BlockContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_BlockContainer(this, rules);
});
function $as_Llaika_ast_Footnote(obj) {
  return (((obj instanceof $c_Llaika_ast_Footnote) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.Footnote"));
}
function $isArrayOf_Llaika_ast_Footnote(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_Footnote)));
}
function $asArrayOf_Llaika_ast_Footnote(obj, depth) {
  return (($isArrayOf_Llaika_ast_Footnote(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.Footnote;", depth));
}
var $d_Llaika_ast_Footnote = new $TypeData().initClass($c_Llaika_ast_Footnote, "laika.ast.Footnote", ({
  Llaika_ast_Footnote: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_LinkTarget: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_BlockContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_ForcedParagraph(content, options) {
  this.Llaika_ast_ForcedParagraph__f_content = null;
  this.Llaika_ast_ForcedParagraph__f_options = null;
  this.Llaika_ast_ForcedParagraph__f_content = content;
  this.Llaika_ast_ForcedParagraph__f_options = options;
}
$c_Llaika_ast_ForcedParagraph.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_ForcedParagraph.prototype.constructor = $c_Llaika_ast_ForcedParagraph;
/** @constructor */
function $h_Llaika_ast_ForcedParagraph() {
}
$h_Llaika_ast_ForcedParagraph.prototype = $c_Llaika_ast_ForcedParagraph.prototype;
$c_Llaika_ast_ForcedParagraph.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_ForcedParagraph.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_ForcedParagraph.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_ForcedParagraph)) {
    var x$0$2 = $as_Llaika_ast_ForcedParagraph(x$0);
    var x = this.Llaika_ast_ForcedParagraph__f_content;
    var x$2 = $n(x$0$2).Llaika_ast_ForcedParagraph__f_content;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_ForcedParagraph__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_ForcedParagraph__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_ForcedParagraph.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_ForcedParagraph.prototype.productPrefix__T = (function() {
  return "ForcedParagraph";
});
$c_Llaika_ast_ForcedParagraph.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_ForcedParagraph__f_content;
  }
  if ((n === 1)) {
    return this.Llaika_ast_ForcedParagraph__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_ForcedParagraph.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_ForcedParagraph__f_content;
});
$c_Llaika_ast_ForcedParagraph.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_ForcedParagraph__f_options;
});
$c_Llaika_ast_ForcedParagraph.prototype.fallback__Llaika_ast_Element = (function() {
  var content = this.Llaika_ast_ForcedParagraph__f_content;
  var options = this.Llaika_ast_ForcedParagraph__f_options;
  return new $c_Llaika_ast_Paragraph(content, options);
});
$c_Llaika_ast_ForcedParagraph.prototype.content__O = (function() {
  return this.Llaika_ast_ForcedParagraph__f_content;
});
$c_Llaika_ast_ForcedParagraph.prototype.withContent__sci_Seq__Llaika_ast_SpanContainer = (function(newContent) {
  var options = this.Llaika_ast_ForcedParagraph__f_options;
  return new $c_Llaika_ast_ForcedParagraph(newContent, options);
});
$c_Llaika_ast_ForcedParagraph.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_ForcedParagraph__f_content;
  return new $c_Llaika_ast_ForcedParagraph(content, options);
});
$c_Llaika_ast_ForcedParagraph.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return $f_Llaika_ast_SpanContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_SpanContainer(this, rules);
});
function $as_Llaika_ast_ForcedParagraph(obj) {
  return (((obj instanceof $c_Llaika_ast_ForcedParagraph) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.ForcedParagraph"));
}
function $isArrayOf_Llaika_ast_ForcedParagraph(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_ForcedParagraph)));
}
function $asArrayOf_Llaika_ast_ForcedParagraph(obj, depth) {
  return (($isArrayOf_Llaika_ast_ForcedParagraph(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.ForcedParagraph;", depth));
}
var $d_Llaika_ast_ForcedParagraph = new $TypeData().initClass($c_Llaika_ast_ForcedParagraph, "laika.ast.ForcedParagraph", ({
  Llaika_ast_ForcedParagraph: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_SpanContainer: 1,
  Llaika_ast_Fallback: 1
}));
/** @constructor */
function $c_Llaika_ast_NavigationItem(title, content, link, targetFormats, options) {
  this.Llaika_ast_NavigationItem__f_title = null;
  this.Llaika_ast_NavigationItem__f_content = null;
  this.Llaika_ast_NavigationItem__f_link = null;
  this.Llaika_ast_NavigationItem__f_targetFormats = null;
  this.Llaika_ast_NavigationItem__f_options = null;
  this.Llaika_ast_NavigationItem__f_title = title;
  this.Llaika_ast_NavigationItem__f_content = content;
  this.Llaika_ast_NavigationItem__f_link = link;
  this.Llaika_ast_NavigationItem__f_targetFormats = targetFormats;
  this.Llaika_ast_NavigationItem__f_options = options;
}
$c_Llaika_ast_NavigationItem.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_NavigationItem.prototype.constructor = $c_Llaika_ast_NavigationItem;
/** @constructor */
function $h_Llaika_ast_NavigationItem() {
}
$h_Llaika_ast_NavigationItem.prototype = $c_Llaika_ast_NavigationItem.prototype;
$c_Llaika_ast_NavigationItem.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_NavigationItem.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_NavigationItem.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_NavigationItem)) {
    var x$0$2 = $as_Llaika_ast_NavigationItem(x$0);
    var x = this.Llaika_ast_NavigationItem__f_title;
    var x$2 = $n(x$0$2).Llaika_ast_NavigationItem__f_title;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_NavigationItem__f_content;
      var x$4 = $n(x$0$2).Llaika_ast_NavigationItem__f_content;
      var $x_4 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.Llaika_ast_NavigationItem__f_link;
      var x$6 = $n(x$0$2).Llaika_ast_NavigationItem__f_link;
      var $x_3 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.Llaika_ast_NavigationItem__f_targetFormats;
      var x$8 = $n(x$0$2).Llaika_ast_NavigationItem__f_targetFormats;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.Llaika_ast_NavigationItem__f_options;
      var x$10 = $n(x$0$2).Llaika_ast_NavigationItem__f_options;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_NavigationItem.prototype.productArity__I = (function() {
  return 5;
});
$c_Llaika_ast_NavigationItem.prototype.productPrefix__T = (function() {
  return "NavigationItem";
});
$c_Llaika_ast_NavigationItem.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_NavigationItem__f_title;
      break;
    }
    case 1: {
      return this.Llaika_ast_NavigationItem__f_content;
      break;
    }
    case 2: {
      return this.Llaika_ast_NavigationItem__f_link;
      break;
    }
    case 3: {
      return this.Llaika_ast_NavigationItem__f_targetFormats;
      break;
    }
    case 4: {
      return this.Llaika_ast_NavigationItem__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_NavigationItem.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_NavigationItem__f_content;
});
$c_Llaika_ast_NavigationItem.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_NavigationItem__f_options;
});
$c_Llaika_ast_NavigationItem.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_NavigationItem = (function(rules) {
  var this$1 = $n(this.Llaika_ast_NavigationItem__f_title);
  var title = $as_Llaika_ast_SpanSequence($f_Llaika_ast_SpanContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_SpanContainer(this$1, rules));
  var content = $as_sci_Seq($n(this.Llaika_ast_NavigationItem__f_content).map__F1__O(new $c_sjsr_AnonFunction1(((_$9) => {
    var _$9$1 = $as_Llaika_ast_NavigationItem(_$9);
    return $n(_$9$1).rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_NavigationItem(rules);
  }))));
  var link = this.Llaika_ast_NavigationItem__f_link;
  var targetFormats = this.Llaika_ast_NavigationItem__f_targetFormats;
  var options = this.Llaika_ast_NavigationItem__f_options;
  return new $c_Llaika_ast_NavigationItem(title, content, link, targetFormats, options);
});
$c_Llaika_ast_NavigationItem.prototype.content__O = (function() {
  return this.Llaika_ast_NavigationItem__f_content;
});
$c_Llaika_ast_NavigationItem.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return this.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_NavigationItem(rules);
});
$c_Llaika_ast_NavigationItem.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var title = this.Llaika_ast_NavigationItem__f_title;
  var content = this.Llaika_ast_NavigationItem__f_content;
  var link = this.Llaika_ast_NavigationItem__f_link;
  var targetFormats = this.Llaika_ast_NavigationItem__f_targetFormats;
  return new $c_Llaika_ast_NavigationItem(title, content, link, targetFormats, options);
});
function $as_Llaika_ast_NavigationItem(obj) {
  return (((obj instanceof $c_Llaika_ast_NavigationItem) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.NavigationItem"));
}
function $isArrayOf_Llaika_ast_NavigationItem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_NavigationItem)));
}
function $asArrayOf_Llaika_ast_NavigationItem(obj, depth) {
  return (($isArrayOf_Llaika_ast_NavigationItem(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.NavigationItem;", depth));
}
var $d_Llaika_ast_NavigationItem = new $TypeData().initClass($c_Llaika_ast_NavigationItem, "laika.ast.NavigationItem", ({
  Llaika_ast_NavigationItem: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_ListItem: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_ListContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_SpanSequence(content, options) {
  this.Llaika_ast_SpanSequence__f_content = null;
  this.Llaika_ast_SpanSequence__f_options = null;
  this.Llaika_ast_SpanSequence__f_content = content;
  this.Llaika_ast_SpanSequence__f_options = options;
}
$c_Llaika_ast_SpanSequence.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_SpanSequence.prototype.constructor = $c_Llaika_ast_SpanSequence;
/** @constructor */
function $h_Llaika_ast_SpanSequence() {
}
$h_Llaika_ast_SpanSequence.prototype = $c_Llaika_ast_SpanSequence.prototype;
$c_Llaika_ast_SpanSequence.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_SpanSequence.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_SpanSequence.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_SpanSequence)) {
    var x$0$2 = $as_Llaika_ast_SpanSequence(x$0);
    var x = this.Llaika_ast_SpanSequence__f_content;
    var x$2 = $n(x$0$2).Llaika_ast_SpanSequence__f_content;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_SpanSequence__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_SpanSequence__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_SpanSequence.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_SpanSequence.prototype.productPrefix__T = (function() {
  return "SpanSequence";
});
$c_Llaika_ast_SpanSequence.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_SpanSequence__f_content;
  }
  if ((n === 1)) {
    return this.Llaika_ast_SpanSequence__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_SpanSequence.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_SpanSequence__f_content;
});
$c_Llaika_ast_SpanSequence.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_SpanSequence__f_options;
});
$c_Llaika_ast_SpanSequence.prototype.content__O = (function() {
  return this.Llaika_ast_SpanSequence__f_content;
});
$c_Llaika_ast_SpanSequence.prototype.withContent__sci_Seq__Llaika_ast_SpanContainer = (function(newContent) {
  var options = this.Llaika_ast_SpanSequence__f_options;
  return new $c_Llaika_ast_SpanSequence(newContent, options);
});
$c_Llaika_ast_SpanSequence.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_SpanSequence__f_content;
  return new $c_Llaika_ast_SpanSequence(content, options);
});
$c_Llaika_ast_SpanSequence.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return $f_Llaika_ast_SpanContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_SpanContainer(this, rules);
});
function $as_Llaika_ast_SpanSequence(obj) {
  return (((obj instanceof $c_Llaika_ast_SpanSequence) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.SpanSequence"));
}
function $isArrayOf_Llaika_ast_SpanSequence(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_SpanSequence)));
}
function $asArrayOf_Llaika_ast_SpanSequence(obj, depth) {
  return (($isArrayOf_Llaika_ast_SpanSequence(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.SpanSequence;", depth));
}
var $d_Llaika_ast_SpanSequence = new $TypeData().initClass($c_Llaika_ast_SpanSequence, "laika.ast.SpanSequence", ({
  Llaika_ast_SpanSequence: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_SpanContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_TemplateSpanSequence(content, options) {
  this.Llaika_ast_TemplateSpanSequence__f_content = null;
  this.Llaika_ast_TemplateSpanSequence__f_options = null;
  this.Llaika_ast_TemplateSpanSequence__f_content = content;
  this.Llaika_ast_TemplateSpanSequence__f_options = options;
}
$c_Llaika_ast_TemplateSpanSequence.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_TemplateSpanSequence.prototype.constructor = $c_Llaika_ast_TemplateSpanSequence;
/** @constructor */
function $h_Llaika_ast_TemplateSpanSequence() {
}
$h_Llaika_ast_TemplateSpanSequence.prototype = $c_Llaika_ast_TemplateSpanSequence.prototype;
$c_Llaika_ast_TemplateSpanSequence.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_TemplateSpanSequence.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_TemplateSpanSequence.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_TemplateSpanSequence)) {
    var x$0$2 = $as_Llaika_ast_TemplateSpanSequence(x$0);
    var x = this.Llaika_ast_TemplateSpanSequence__f_content;
    var x$2 = $n(x$0$2).Llaika_ast_TemplateSpanSequence__f_content;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_TemplateSpanSequence__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_TemplateSpanSequence__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_TemplateSpanSequence.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_TemplateSpanSequence.prototype.productPrefix__T = (function() {
  return "TemplateSpanSequence";
});
$c_Llaika_ast_TemplateSpanSequence.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_TemplateSpanSequence__f_content;
  }
  if ((n === 1)) {
    return this.Llaika_ast_TemplateSpanSequence__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_TemplateSpanSequence.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_TemplateSpanSequence__f_content;
});
$c_Llaika_ast_TemplateSpanSequence.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_TemplateSpanSequence__f_options;
});
$c_Llaika_ast_TemplateSpanSequence.prototype.content__O = (function() {
  return this.Llaika_ast_TemplateSpanSequence__f_content;
});
$c_Llaika_ast_TemplateSpanSequence.prototype.withContent__sci_Seq__Llaika_ast_TemplateSpanContainer = (function(newContent) {
  var options = this.Llaika_ast_TemplateSpanSequence__f_options;
  return new $c_Llaika_ast_TemplateSpanSequence(newContent, options);
});
$c_Llaika_ast_TemplateSpanSequence.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_TemplateSpanSequence__f_content;
  return new $c_Llaika_ast_TemplateSpanSequence(content, options);
});
$c_Llaika_ast_TemplateSpanSequence.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return $f_Llaika_ast_TemplateSpanContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_TemplateSpanContainer(this, rules);
});
function $as_Llaika_ast_TemplateSpanSequence(obj) {
  return (((obj instanceof $c_Llaika_ast_TemplateSpanSequence) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.TemplateSpanSequence"));
}
function $isArrayOf_Llaika_ast_TemplateSpanSequence(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_TemplateSpanSequence)));
}
function $asArrayOf_Llaika_ast_TemplateSpanSequence(obj, depth) {
  return (($isArrayOf_Llaika_ast_TemplateSpanSequence(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.TemplateSpanSequence;", depth));
}
var $d_Llaika_ast_TemplateSpanSequence = new $TypeData().initClass($c_Llaika_ast_TemplateSpanSequence, "laika.ast.TemplateSpanSequence", ({
  Llaika_ast_TemplateSpanSequence: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_TemplateSpan: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_TemplateSpanContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_html_HTMLElement(startTag, content, options) {
  this.Llaika_ast_html_HTMLElement__f_startTag = null;
  this.Llaika_ast_html_HTMLElement__f_content = null;
  this.Llaika_ast_html_HTMLElement__f_options = null;
  this.Llaika_ast_html_HTMLElement__f_startTag = startTag;
  this.Llaika_ast_html_HTMLElement__f_content = content;
  this.Llaika_ast_html_HTMLElement__f_options = options;
}
$c_Llaika_ast_html_HTMLElement.prototype = new $h_Llaika_ast_html_HTMLSpan();
$c_Llaika_ast_html_HTMLElement.prototype.constructor = $c_Llaika_ast_html_HTMLElement;
/** @constructor */
function $h_Llaika_ast_html_HTMLElement() {
}
$h_Llaika_ast_html_HTMLElement.prototype = $c_Llaika_ast_html_HTMLElement.prototype;
$c_Llaika_ast_html_HTMLElement.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_html_HTMLElement.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_html_HTMLElement.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_html_HTMLElement)) {
    var x$0$2 = $as_Llaika_ast_html_HTMLElement(x$0);
    var x = this.Llaika_ast_html_HTMLElement__f_startTag;
    var x$2 = $n(x$0$2).Llaika_ast_html_HTMLElement__f_startTag;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_html_HTMLElement__f_content;
      var x$4 = $n(x$0$2).Llaika_ast_html_HTMLElement__f_content;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llaika_ast_html_HTMLElement__f_options;
      var x$6 = $n(x$0$2).Llaika_ast_html_HTMLElement__f_options;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_html_HTMLElement.prototype.productArity__I = (function() {
  return 3;
});
$c_Llaika_ast_html_HTMLElement.prototype.productPrefix__T = (function() {
  return "HTMLElement";
});
$c_Llaika_ast_html_HTMLElement.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_html_HTMLElement__f_startTag;
      break;
    }
    case 1: {
      return this.Llaika_ast_html_HTMLElement__f_content;
      break;
    }
    case 2: {
      return this.Llaika_ast_html_HTMLElement__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_html_HTMLElement.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_html_HTMLElement__f_content;
});
$c_Llaika_ast_html_HTMLElement.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_html_HTMLElement__f_options;
});
$c_Llaika_ast_html_HTMLElement.prototype.content__O = (function() {
  return this.Llaika_ast_html_HTMLElement__f_content;
});
$c_Llaika_ast_html_HTMLElement.prototype.withContent__sci_Seq__Llaika_ast_SpanContainer = (function(newContent) {
  var startTag = this.Llaika_ast_html_HTMLElement__f_startTag;
  var options = this.Llaika_ast_html_HTMLElement__f_options;
  return new $c_Llaika_ast_html_HTMLElement(startTag, newContent, options);
});
$c_Llaika_ast_html_HTMLElement.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var startTag = this.Llaika_ast_html_HTMLElement__f_startTag;
  var content = this.Llaika_ast_html_HTMLElement__f_content;
  return new $c_Llaika_ast_html_HTMLElement(startTag, content, options);
});
$c_Llaika_ast_html_HTMLElement.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return $f_Llaika_ast_SpanContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_SpanContainer(this, rules);
});
function $as_Llaika_ast_html_HTMLElement(obj) {
  return (((obj instanceof $c_Llaika_ast_html_HTMLElement) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.html.HTMLElement"));
}
function $isArrayOf_Llaika_ast_html_HTMLElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_html_HTMLElement)));
}
function $asArrayOf_Llaika_ast_html_HTMLElement(obj, depth) {
  return (($isArrayOf_Llaika_ast_html_HTMLElement(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.html.HTMLElement;", depth));
}
var $d_Llaika_ast_html_HTMLElement = new $TypeData().initClass($c_Llaika_ast_html_HTMLElement, "laika.ast.html.HTMLElement", ({
  Llaika_ast_html_HTMLElement: 1,
  Llaika_ast_html_HTMLSpan: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_SpanContainer: 1
}));
/** @constructor */
function $c_sc_AbstractSeq() {
}
$c_sc_AbstractSeq.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractSeq.prototype.constructor = $c_sc_AbstractSeq;
/** @constructor */
function $h_sc_AbstractSeq() {
}
$h_sc_AbstractSeq.prototype = $c_sc_AbstractSeq.prototype;
$c_sc_AbstractSeq.prototype.canEqual__O__Z = (function(that) {
  return true;
});
$c_sc_AbstractSeq.prototype.equals__O__Z = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o);
});
$c_sc_AbstractSeq.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this);
});
$c_sc_AbstractSeq.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$c_sc_AbstractSeq.prototype.appended__O__O = (function(elem) {
  return $f_sc_SeqOps__appended__O__O(this, elem);
});
$c_sc_AbstractSeq.prototype.prependedAll__sc_IterableOnce__O = (function(prefix) {
  return $f_sc_SeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$c_sc_AbstractSeq.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_AbstractSeq.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__O(suffix);
});
$c_sc_AbstractSeq.prototype.size__I = (function() {
  return this.length__I();
});
$c_sc_AbstractSeq.prototype.distinct__O = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$c_sc_AbstractSeq.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$c_sc_AbstractSeq.prototype.reverse__O = (function() {
  return this.fromSpecific__sc_IterableOnce__O(this.reversed__sc_Iterable());
});
$c_sc_AbstractSeq.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.reversed__sc_Iterable()).iterator__sc_Iterator();
});
$c_sc_AbstractSeq.prototype.startsWith__sc_IterableOnce__I__Z = (function(that, offset) {
  return $f_sc_SeqOps__startsWith__sc_IterableOnce__I__Z(this, that, offset);
});
$c_sc_AbstractSeq.prototype.startsWith$default$2__I = (function() {
  return 0;
});
$c_sc_AbstractSeq.prototype.isDefinedAt__I__Z = (function(idx) {
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx);
});
$c_sc_AbstractSeq.prototype.padTo__I__O__O = (function(len, elem) {
  return $f_sc_SeqOps__padTo__I__O__O(this, len, elem);
});
$c_sc_AbstractSeq.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = $n(this.iterator__sc_Iterator());
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from);
});
$c_sc_AbstractSeq.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$c_sc_AbstractSeq.prototype.sizeCompare__I__I = (function(otherSize) {
  return this.lengthCompare__I__I(otherSize);
});
$c_sc_AbstractSeq.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_sc_AbstractSeq.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_sc_AbstractSeq.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this, that);
});
$c_sc_AbstractSeq.prototype.orElse__s_PartialFunction__s_PartialFunction = (function(that) {
  return new $c_s_PartialFunction$OrElse(this, that);
});
$c_sc_AbstractSeq.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_sc_AbstractSeq.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_sc_AbstractSeq.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1);
});
$c_sc_AbstractSeq.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_sc_AbstractSeq.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__O__O(v1));
});
$c_sc_AbstractSeq.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sc_AbstractSeq.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
$c_sc_AbstractSeq.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__I__Z($uI(x));
});
/** @constructor */
function $c_sc_AbstractSeqView() {
}
$c_sc_AbstractSeqView.prototype = new $h_sc_AbstractView();
$c_sc_AbstractSeqView.prototype.constructor = $c_sc_AbstractSeqView;
/** @constructor */
function $h_sc_AbstractSeqView() {
}
$h_sc_AbstractSeqView.prototype = $c_sc_AbstractSeqView.prototype;
$c_sc_AbstractSeqView.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$c_sc_AbstractSeqView.prototype.appended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$c_sc_AbstractSeqView.prototype.prepended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Prepended__O__sc_SeqOps__(new $c_sc_SeqView$Prepended(), elem, this);
});
$c_sc_AbstractSeqView.prototype.reverse__sc_SeqView = (function() {
  return $ct_sc_SeqView$Reverse__sc_SeqOps__(new $c_sc_SeqView$Reverse(), this);
});
$c_sc_AbstractSeqView.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n);
});
$c_sc_AbstractSeqView.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$c_sc_AbstractSeqView.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$c_sc_AbstractSeqView.prototype.stringPrefix__T = (function() {
  return "SeqView";
});
$c_sc_AbstractSeqView.prototype.prependedAll__sc_IterableOnce__O = (function(prefix) {
  return $f_sc_SeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$c_sc_AbstractSeqView.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_AbstractSeqView.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_AbstractSeqView.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$c_sc_AbstractSeqView.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.reversed__sc_Iterable()).iterator__sc_Iterator();
});
$c_sc_AbstractSeqView.prototype.padTo__I__O__O = (function(len, elem) {
  return $f_sc_SeqOps__padTo__I__O__O(this, len, elem);
});
$c_sc_AbstractSeqView.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = $n(this.iterator__sc_Iterator());
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from);
});
$c_sc_AbstractSeqView.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_sc_AbstractSeqView.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_sc_AbstractSeqView.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
$c_sc_AbstractSeqView.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_SeqView(n);
});
$c_sc_AbstractSeqView.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n);
});
$c_sc_AbstractSeqView.prototype.take__I__O = (function(n) {
  return this.take__I__sc_SeqView(n);
});
$c_sc_AbstractSeqView.prototype.reverse__O = (function() {
  return this.reverse__sc_SeqView();
});
$c_sc_AbstractSeqView.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_SeqView(elem);
});
$c_sc_AbstractSeqView.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_SeqView(elem);
});
$c_sc_AbstractSeqView.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f);
});
function $is_sc_IndexedSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IndexedSeq)));
}
function $as_sc_IndexedSeq(obj) {
  return (($is_sc_IndexedSeq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IndexedSeq"));
}
function $isArrayOf_sc_IndexedSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IndexedSeq)));
}
function $asArrayOf_sc_IndexedSeq(obj, depth) {
  return (($isArrayOf_sc_IndexedSeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IndexedSeq;", depth));
}
function $is_sc_LinearSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_LinearSeq)));
}
function $as_sc_LinearSeq(obj) {
  return (($is_sc_LinearSeq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.LinearSeq"));
}
function $isArrayOf_sc_LinearSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_LinearSeq)));
}
function $asArrayOf_sc_LinearSeq(obj, depth) {
  return (($isArrayOf_sc_LinearSeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.LinearSeq;", depth));
}
/** @constructor */
function $c_sc_View$Empty$() {
}
$c_sc_View$Empty$.prototype = new $h_sc_AbstractView();
$c_sc_View$Empty$.prototype.constructor = $c_sc_View$Empty$;
/** @constructor */
function $h_sc_View$Empty$() {
}
$h_sc_View$Empty$.prototype = $c_sc_View$Empty$.prototype;
$c_sc_View$Empty$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
});
$c_sc_View$Empty$.prototype.knownSize__I = (function() {
  return 0;
});
$c_sc_View$Empty$.prototype.isEmpty__Z = (function() {
  return true;
});
$c_sc_View$Empty$.prototype.productPrefix__T = (function() {
  return "Empty";
});
$c_sc_View$Empty$.prototype.productArity__I = (function() {
  return 0;
});
$c_sc_View$Empty$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1);
});
$c_sc_View$Empty$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_sc_View$Empty$.prototype.hashCode__I = (function() {
  return 67081517;
});
var $d_sc_View$Empty$ = new $TypeData().initClass($c_sc_View$Empty$, "scala.collection.View$Empty$", ({
  sc_View$Empty$: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
}));
var $n_sc_View$Empty$;
function $m_sc_View$Empty$() {
  if ((!$n_sc_View$Empty$)) {
    $n_sc_View$Empty$ = new $c_sc_View$Empty$();
  }
  return $n_sc_View$Empty$;
}
function $is_sci_Set(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Set)));
}
function $as_sci_Set(obj) {
  return (($is_sci_Set(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Set"));
}
function $isArrayOf_sci_Set(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Set)));
}
function $asArrayOf_sci_Set(obj, depth) {
  return (($isArrayOf_sci_Set(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Set;", depth));
}
function $f_scm_SetOps__add__O__Z($thiz, elem) {
  if ((!$thiz.contains__O__Z(elem))) {
    var this$1 = $n($as_scm_Growable($thiz));
    this$1.addOne__O__scm_Growable(elem);
    return true;
  } else {
    return false;
  }
}
function $f_scm_SetOps__diff__sc_Set__scm_SetOps($thiz, that) {
  var z = $thiz.empty__O();
  var f = ((result$2, elem$2) => {
    var result = $as_scm_SetOps(result$2);
    if ($n(that).contains__O__Z(elem$2)) {
      return result;
    } else {
      var this$2 = $n(result);
      return $as_scm_SetOps(this$2.addOne__O__scm_Growable(elem$2));
    }
  });
  if ($is_sc_IndexedSeq($thiz)) {
    var x2 = $as_sc_IndexedSeq($thiz);
    var at = 0;
    var end = $n(x2).length__I();
    var acc = z;
    var $x_1;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var arg1 = acc;
        var arg2 = $n(x2).apply__I__O(at);
        var temp$acc = f(arg1, arg2);
        at = temp$at;
        acc = temp$acc;
        continue;
      }
      var $x_1 = acc;
      break;
    }
  } else {
    var result$1 = z;
    var it = $thiz.iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var arg1$1 = result$1;
      var arg2$1 = $n(it).next__O();
      result$1 = f(arg1$1, arg2$1);
    }
    var $x_1 = result$1;
  }
  return $as_scm_SetOps($x_1);
}
function $is_scm_SetOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_SetOps)));
}
function $as_scm_SetOps(obj) {
  return (($is_scm_SetOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.SetOps"));
}
function $isArrayOf_scm_SetOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_SetOps)));
}
function $asArrayOf_scm_SetOps(obj, depth) {
  return (($isArrayOf_scm_SetOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.SetOps;", depth));
}
function $f_Lcats_Alternative__separate__O__Lcats_FlatMap__Lcats_Bifoldable__T2($thiz, fgab, FM, G) {
  var as = $n(FM).flatMap__O__F1__O(fgab, new $c_sjsr_AnonFunction1(((gab) => {
    var this$2 = $n(G);
    var f = new $c_sjsr_AnonFunction1(((x) => $thiz.pure__O__O(x)));
    var g = new $c_sjsr_AnonFunction1(((_$9) => $thiz.empty__O()));
    var C = $thiz.algebra__Lcats_kernel_Monoid();
    return $f_Lcats_Bifoldable__bifoldMap__O__F1__F1__Lcats_kernel_Monoid__O(this$2, gab, f, g, C);
  })));
  var bs = $n(FM).flatMap__O__F1__O(fgab, new $c_sjsr_AnonFunction1(((gab$2) => {
    var this$3 = $n(G);
    var f$1 = new $c_sjsr_AnonFunction1(((_$10) => $thiz.empty__O()));
    var g$1 = new $c_sjsr_AnonFunction1(((x$1) => $thiz.pure__O__O(x$1)));
    var C$1 = $thiz.algebra__Lcats_kernel_Monoid();
    return $f_Lcats_Bifoldable__bifoldMap__O__F1__F1__Lcats_kernel_Monoid__O(this$3, gab$2, f$1, g$1, C$1);
  })));
  return new $c_T2(as, bs);
}
function $is_Lcats_Alternative(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_Alternative)));
}
function $as_Lcats_Alternative(obj) {
  return (($is_Lcats_Alternative(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Alternative"));
}
function $isArrayOf_Lcats_Alternative(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Alternative)));
}
function $asArrayOf_Lcats_Alternative(obj, depth) {
  return (($isArrayOf_Lcats_Alternative(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Alternative;", depth));
}
function $f_Lcats_StackSafeMonad__tailRecM__O__F1__O($thiz, a, f) {
  return $thiz.flatMap__O__F1__O($n(f).apply__O__O(a), new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_s_util_Either(x$1);
    if ((x$1$1 instanceof $c_s_util_Left)) {
      var a$1 = $n($as_s_util_Left(x$1$1)).s_util_Left__f_value;
      return $f_Lcats_StackSafeMonad__tailRecM__O__F1__O($thiz, a$1, f);
    }
    if ((x$1$1 instanceof $c_s_util_Right)) {
      var b = $n($as_s_util_Right(x$1$1)).s_util_Right__f_value;
      return $thiz.pure__O__O(b);
    }
    throw new $c_s_MatchError(x$1$1);
  })));
}
function $is_Lcats_StackSafeMonad(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_StackSafeMonad)));
}
function $as_Lcats_StackSafeMonad(obj) {
  return (($is_Lcats_StackSafeMonad(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.StackSafeMonad"));
}
function $isArrayOf_Lcats_StackSafeMonad(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_StackSafeMonad)));
}
function $asArrayOf_Lcats_StackSafeMonad(obj, depth) {
  return (($isArrayOf_Lcats_StackSafeMonad(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.StackSafeMonad;", depth));
}
/** @constructor */
function $c_Lcats_instances_package$function$() {
  this.Lcats_instances_package$function$__f_catsStdInstancesForFunction1 = null;
  $n_Lcats_instances_package$function$ = this;
  $f_Lcats_instances_Function1Instances__$init$__V(this);
  new $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1();
}
$c_Lcats_instances_package$function$.prototype = new $h_O();
$c_Lcats_instances_package$function$.prototype.constructor = $c_Lcats_instances_package$function$;
/** @constructor */
function $h_Lcats_instances_package$function$() {
}
$h_Lcats_instances_package$function$.prototype = $c_Lcats_instances_package$function$.prototype;
$c_Lcats_instances_package$function$.prototype.catsStdInstancesForFunction1__Lcats_arrow_ArrowChoice = (function() {
  return this.Lcats_instances_package$function$__f_catsStdInstancesForFunction1;
});
$c_Lcats_instances_package$function$.prototype.cats$instances$Function1Instances$_setter_$catsStdInstancesForFunction1_$eq__Lcats_arrow_ArrowChoice__V = (function(x$0) {
  this.Lcats_instances_package$function$__f_catsStdInstancesForFunction1 = x$0;
});
$c_Lcats_instances_package$function$.prototype.cats$instances$Function1Instances$_setter_$catsStdMonoidKForFunction1_$eq__Lcats_MonoidK__V = (function(x$0) {
});
var $d_Lcats_instances_package$function$ = new $TypeData().initClass($c_Lcats_instances_package$function$, "cats.instances.package$function$", ({
  Lcats_instances_package$function$: 1,
  Lcats_kernel_instances_FunctionInstances4: 1,
  Lcats_kernel_instances_FunctionInstances3: 1,
  Lcats_kernel_instances_FunctionInstances2: 1,
  Lcats_kernel_instances_FunctionInstances1: 1,
  Lcats_kernel_instances_FunctionInstances0: 1,
  Lcats_kernel_instances_FunctionInstances: 1,
  Lcats_instances_Function0Instances0: 1,
  Lcats_instances_Function0Instances: 1,
  Lcats_instances_Function1Instances0: 1,
  Lcats_instances_Function1Instances: 1,
  Lcats_instances_FunctionInstances: 1,
  Lcats_instances_FunctionInstancesBinCompat0: 1
}));
var $n_Lcats_instances_package$function$;
function $m_Lcats_instances_package$function$() {
  if ((!$n_Lcats_instances_package$function$)) {
    $n_Lcats_instances_package$function$ = new $c_Lcats_instances_package$function$();
  }
  return $n_Lcats_instances_package$function$;
}
function $as_Llaika_ast_FootnoteDefinition(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.FootnoteDefinition"));
}
function $isArrayOf_Llaika_ast_FootnoteDefinition(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_FootnoteDefinition)));
}
function $asArrayOf_Llaika_ast_FootnoteDefinition(obj, depth) {
  return (($isArrayOf_Llaika_ast_FootnoteDefinition(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.FootnoteDefinition;", depth));
}
/** @constructor */
function $c_Llaika_ast_LinkIdReference(content, ref, source, options) {
  this.Llaika_ast_LinkIdReference__f_content = null;
  this.Llaika_ast_LinkIdReference__f_ref = null;
  this.Llaika_ast_LinkIdReference__f_source = null;
  this.Llaika_ast_LinkIdReference__f_options = null;
  this.Llaika_ast_LinkIdReference__f_unresolvedMessage$lzy8 = null;
  this.Llaika_ast_LinkIdReference__f_unresolvedMessagebitmap$8 = false;
  this.Llaika_ast_LinkIdReference__f_content = content;
  this.Llaika_ast_LinkIdReference__f_ref = ref;
  this.Llaika_ast_LinkIdReference__f_source = source;
  this.Llaika_ast_LinkIdReference__f_options = options;
}
$c_Llaika_ast_LinkIdReference.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_LinkIdReference.prototype.constructor = $c_Llaika_ast_LinkIdReference;
/** @constructor */
function $h_Llaika_ast_LinkIdReference() {
}
$h_Llaika_ast_LinkIdReference.prototype = $c_Llaika_ast_LinkIdReference.prototype;
$c_Llaika_ast_LinkIdReference.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_LinkIdReference.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_LinkIdReference.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_LinkIdReference)) {
    var x$0$2 = $as_Llaika_ast_LinkIdReference(x$0);
    var x = this.Llaika_ast_LinkIdReference__f_content;
    var x$2 = $n(x$0$2).Llaika_ast_LinkIdReference__f_content;
    if ((((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) && (this.Llaika_ast_LinkIdReference__f_ref === $n(x$0$2).Llaika_ast_LinkIdReference__f_ref))) {
      var x$3 = this.Llaika_ast_LinkIdReference__f_source;
      var x$4 = $n(x$0$2).Llaika_ast_LinkIdReference__f_source;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llaika_ast_LinkIdReference__f_options;
      var x$6 = $n(x$0$2).Llaika_ast_LinkIdReference__f_options;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_LinkIdReference.prototype.productArity__I = (function() {
  return 4;
});
$c_Llaika_ast_LinkIdReference.prototype.productPrefix__T = (function() {
  return "LinkIdReference";
});
$c_Llaika_ast_LinkIdReference.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_LinkIdReference__f_content;
      break;
    }
    case 1: {
      return this.Llaika_ast_LinkIdReference__f_ref;
      break;
    }
    case 2: {
      return this.Llaika_ast_LinkIdReference__f_source;
      break;
    }
    case 3: {
      return this.Llaika_ast_LinkIdReference__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_LinkIdReference.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_LinkIdReference__f_content;
});
$c_Llaika_ast_LinkIdReference.prototype.source__Llaika_parse_SourceFragment = (function() {
  return this.Llaika_ast_LinkIdReference__f_source;
});
$c_Llaika_ast_LinkIdReference.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_LinkIdReference__f_options;
});
$c_Llaika_ast_LinkIdReference.prototype.unresolvedMessage__T = (function() {
  if ((!this.Llaika_ast_LinkIdReference__f_unresolvedMessagebitmap$8)) {
    this.Llaika_ast_LinkIdReference__f_unresolvedMessage$lzy8 = (("Unresolved link id reference '" + this.Llaika_ast_LinkIdReference__f_ref) + "'");
    this.Llaika_ast_LinkIdReference__f_unresolvedMessagebitmap$8 = true;
  }
  return this.Llaika_ast_LinkIdReference__f_unresolvedMessage$lzy8;
});
$c_Llaika_ast_LinkIdReference.prototype.content__O = (function() {
  return this.Llaika_ast_LinkIdReference__f_content;
});
$c_Llaika_ast_LinkIdReference.prototype.withContent__sci_Seq__Llaika_ast_SpanContainer = (function(newContent) {
  var ref = this.Llaika_ast_LinkIdReference__f_ref;
  var source = this.Llaika_ast_LinkIdReference__f_source;
  var options = this.Llaika_ast_LinkIdReference__f_options;
  return new $c_Llaika_ast_LinkIdReference(newContent, ref, source, options);
});
$c_Llaika_ast_LinkIdReference.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_LinkIdReference__f_content;
  var ref = this.Llaika_ast_LinkIdReference__f_ref;
  var source = this.Llaika_ast_LinkIdReference__f_source;
  return new $c_Llaika_ast_LinkIdReference(content, ref, source, options);
});
$c_Llaika_ast_LinkIdReference.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return $f_Llaika_ast_SpanContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_SpanContainer(this, rules);
});
function $as_Llaika_ast_LinkIdReference(obj) {
  return (((obj instanceof $c_Llaika_ast_LinkIdReference) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.LinkIdReference"));
}
function $isArrayOf_Llaika_ast_LinkIdReference(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_LinkIdReference)));
}
function $asArrayOf_Llaika_ast_LinkIdReference(obj, depth) {
  return (($isArrayOf_Llaika_ast_LinkIdReference(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.LinkIdReference;", depth));
}
var $d_Llaika_ast_LinkIdReference = new $TypeData().initClass($c_Llaika_ast_LinkIdReference, "laika.ast.LinkIdReference", ({
  Llaika_ast_LinkIdReference: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Unresolved: 1,
  Llaika_ast_Reference: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_SpanContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_SpanLink(content, target, title, options) {
  this.Llaika_ast_SpanLink__f_content = null;
  this.Llaika_ast_SpanLink__f_target = null;
  this.Llaika_ast_SpanLink__f_title = null;
  this.Llaika_ast_SpanLink__f_options = null;
  this.Llaika_ast_SpanLink__f_supportsExternalTargets = false;
  this.Llaika_ast_SpanLink__f_content = content;
  this.Llaika_ast_SpanLink__f_target = target;
  this.Llaika_ast_SpanLink__f_title = title;
  this.Llaika_ast_SpanLink__f_options = options;
  this.Llaika_ast_SpanLink__f_supportsExternalTargets = true;
}
$c_Llaika_ast_SpanLink.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_SpanLink.prototype.constructor = $c_Llaika_ast_SpanLink;
/** @constructor */
function $h_Llaika_ast_SpanLink() {
}
$h_Llaika_ast_SpanLink.prototype = $c_Llaika_ast_SpanLink.prototype;
$c_Llaika_ast_SpanLink.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_SpanLink.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_SpanLink.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_SpanLink)) {
    var x$0$2 = $as_Llaika_ast_SpanLink(x$0);
    var x = this.Llaika_ast_SpanLink__f_content;
    var x$2 = $n(x$0$2).Llaika_ast_SpanLink__f_content;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_SpanLink__f_target;
      var x$4 = $n(x$0$2).Llaika_ast_SpanLink__f_target;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.Llaika_ast_SpanLink__f_title;
      var x$6 = $n(x$0$2).Llaika_ast_SpanLink__f_title;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.Llaika_ast_SpanLink__f_options;
      var x$8 = $n(x$0$2).Llaika_ast_SpanLink__f_options;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_SpanLink.prototype.productArity__I = (function() {
  return 4;
});
$c_Llaika_ast_SpanLink.prototype.productPrefix__T = (function() {
  return "SpanLink";
});
$c_Llaika_ast_SpanLink.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_SpanLink__f_content;
      break;
    }
    case 1: {
      return this.Llaika_ast_SpanLink__f_target;
      break;
    }
    case 2: {
      return this.Llaika_ast_SpanLink__f_title;
      break;
    }
    case 3: {
      return this.Llaika_ast_SpanLink__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_SpanLink.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_SpanLink__f_content;
});
$c_Llaika_ast_SpanLink.prototype.target__Llaika_ast_Target = (function() {
  return this.Llaika_ast_SpanLink__f_target;
});
$c_Llaika_ast_SpanLink.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_SpanLink__f_options;
});
$c_Llaika_ast_SpanLink.prototype.supportsExternalTargets__Z = (function() {
  return this.Llaika_ast_SpanLink__f_supportsExternalTargets;
});
$c_Llaika_ast_SpanLink.prototype.content__O = (function() {
  return this.Llaika_ast_SpanLink__f_content;
});
$c_Llaika_ast_SpanLink.prototype.withTarget__Llaika_ast_Target__Llaika_ast_GlobalLink = (function(target) {
  var content = this.Llaika_ast_SpanLink__f_content;
  var title = this.Llaika_ast_SpanLink__f_title;
  var options = this.Llaika_ast_SpanLink__f_options;
  return new $c_Llaika_ast_SpanLink(content, target, title, options);
});
$c_Llaika_ast_SpanLink.prototype.withContent__sci_Seq__Llaika_ast_SpanContainer = (function(newContent) {
  var target = this.Llaika_ast_SpanLink__f_target;
  var title = this.Llaika_ast_SpanLink__f_title;
  var options = this.Llaika_ast_SpanLink__f_options;
  return new $c_Llaika_ast_SpanLink(newContent, target, title, options);
});
$c_Llaika_ast_SpanLink.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_SpanLink__f_content;
  var target = this.Llaika_ast_SpanLink__f_target;
  var title = this.Llaika_ast_SpanLink__f_title;
  return new $c_Llaika_ast_SpanLink(content, target, title, options);
});
$c_Llaika_ast_SpanLink.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return $f_Llaika_ast_SpanContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_SpanContainer(this, rules);
});
function $as_Llaika_ast_SpanLink(obj) {
  return (((obj instanceof $c_Llaika_ast_SpanLink) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.SpanLink"));
}
function $isArrayOf_Llaika_ast_SpanLink(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_SpanLink)));
}
function $asArrayOf_Llaika_ast_SpanLink(obj, depth) {
  return (($isArrayOf_Llaika_ast_SpanLink(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.SpanLink;", depth));
}
var $d_Llaika_ast_SpanLink = new $TypeData().initClass($c_Llaika_ast_SpanLink, "laika.ast.SpanLink", ({
  Llaika_ast_SpanLink: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Link: 1,
  Llaika_ast_GlobalLink: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_SpanContainer: 1
}));
/** @constructor */
function $c_Llaika_ast_TemplateRoot(content, options) {
  this.Llaika_ast_TemplateRoot__f_content = null;
  this.Llaika_ast_TemplateRoot__f_options = null;
  this.Llaika_ast_TemplateRoot__f_content = content;
  this.Llaika_ast_TemplateRoot__f_options = options;
}
$c_Llaika_ast_TemplateRoot.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_TemplateRoot.prototype.constructor = $c_Llaika_ast_TemplateRoot;
/** @constructor */
function $h_Llaika_ast_TemplateRoot() {
}
$h_Llaika_ast_TemplateRoot.prototype = $c_Llaika_ast_TemplateRoot.prototype;
$c_Llaika_ast_TemplateRoot.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_TemplateRoot.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_TemplateRoot.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_TemplateRoot)) {
    var x$0$2 = $as_Llaika_ast_TemplateRoot(x$0);
    var x = this.Llaika_ast_TemplateRoot__f_content;
    var x$2 = $n(x$0$2).Llaika_ast_TemplateRoot__f_content;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_TemplateRoot__f_options;
      var x$4 = $n(x$0$2).Llaika_ast_TemplateRoot__f_options;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_TemplateRoot.prototype.productArity__I = (function() {
  return 2;
});
$c_Llaika_ast_TemplateRoot.prototype.productPrefix__T = (function() {
  return "TemplateRoot";
});
$c_Llaika_ast_TemplateRoot.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llaika_ast_TemplateRoot__f_content;
  }
  if ((n === 1)) {
    return this.Llaika_ast_TemplateRoot__f_options;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llaika_ast_TemplateRoot.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_TemplateRoot__f_content;
});
$c_Llaika_ast_TemplateRoot.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_TemplateRoot__f_options;
});
$c_Llaika_ast_TemplateRoot.prototype.content__O = (function() {
  return this.Llaika_ast_TemplateRoot__f_content;
});
$c_Llaika_ast_TemplateRoot.prototype.withContent__sci_Seq__Llaika_ast_TemplateSpanContainer = (function(newContent) {
  var options = this.Llaika_ast_TemplateRoot__f_options;
  return new $c_Llaika_ast_TemplateRoot(newContent, options);
});
$c_Llaika_ast_TemplateRoot.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_TemplateRoot__f_content;
  return new $c_Llaika_ast_TemplateRoot(content, options);
});
$c_Llaika_ast_TemplateRoot.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return $f_Llaika_ast_TemplateSpanContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_TemplateSpanContainer(this, rules);
});
function $as_Llaika_ast_TemplateRoot(obj) {
  return (((obj instanceof $c_Llaika_ast_TemplateRoot) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.TemplateRoot"));
}
function $isArrayOf_Llaika_ast_TemplateRoot(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_TemplateRoot)));
}
function $asArrayOf_Llaika_ast_TemplateRoot(obj, depth) {
  return (($isArrayOf_Llaika_ast_TemplateRoot(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.TemplateRoot;", depth));
}
var $d_Llaika_ast_TemplateRoot = new $TypeData().initClass($c_Llaika_ast_TemplateRoot, "laika.ast.TemplateRoot", ({
  Llaika_ast_TemplateRoot: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Block: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_TemplateSpan: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_TemplateSpanContainer: 1
}));
/** @constructor */
function $c_sc_AbstractMap() {
}
$c_sc_AbstractMap.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractMap.prototype.constructor = $c_sc_AbstractMap;
/** @constructor */
function $h_sc_AbstractMap() {
}
$h_sc_AbstractMap.prototype = $c_sc_AbstractMap.prototype;
$c_sc_AbstractMap.prototype.equals__O__Z = (function(o) {
  return $f_sc_Map__equals__O__Z(this, o);
});
$c_sc_AbstractMap.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().mapHash__sc_Map__I(this);
});
$c_sc_AbstractMap.prototype.stringPrefix__T = (function() {
  return "Map";
});
$c_sc_AbstractMap.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$c_sc_AbstractMap.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $as_sc_IterableOps($n(this.mapFactory__sc_MapFactory()).from__sc_IterableOnce__O(coll));
});
$c_sc_AbstractMap.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $n(this.mapFactory__sc_MapFactory()).newBuilder__scm_Builder();
});
$c_sc_AbstractMap.prototype.empty__sc_IterableOps = (function() {
  return $f_sc_MapFactoryDefaults__empty__sc_IterableOps(this);
});
$c_sc_AbstractMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1);
});
$c_sc_AbstractMap.prototype.apply__O__O = (function(key) {
  return $f_sc_MapOps__apply__O__O(this, key);
});
$c_sc_AbstractMap.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_sc_MapOps__applyOrElse__O__F1__O(this, x, default$1);
});
$c_sc_AbstractMap.prototype.keySet__sc_Set = (function() {
  return new $c_sc_MapOps$KeySet(this);
});
$c_sc_AbstractMap.prototype.keysIterator__sc_Iterator = (function() {
  return new $c_sc_MapOps$$anon$2(this);
});
$c_sc_AbstractMap.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sc_MapOps$$anon$3(this);
});
$c_sc_AbstractMap.prototype.foreachEntry__F2__V = (function(f) {
  $f_sc_MapOps__foreachEntry__F2__V(this, f);
});
$c_sc_AbstractMap.prototype.default__O__O = (function(key) {
  return $f_sc_MapOps__default__O__O(this, key);
});
$c_sc_AbstractMap.prototype.contains__O__Z = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key);
});
$c_sc_AbstractMap.prototype.isDefinedAt__O__Z = (function(key) {
  return this.contains__O__Z(key);
});
$c_sc_AbstractMap.prototype.map__F1__sc_IterableOps = (function(f) {
  return $f_sc_MapOps__map__F1__sc_IterableOps(this, f);
});
$c_sc_AbstractMap.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return $f_sc_MapOps__concat__sc_IterableOnce__sc_IterableOps(this, suffix);
});
$c_sc_AbstractMap.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  return $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, sb, start, sep, end);
});
$c_sc_AbstractMap.prototype.orElse__s_PartialFunction__s_PartialFunction = (function(that) {
  return new $c_s_PartialFunction$OrElse(this, that);
});
$c_sc_AbstractMap.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_sc_AbstractMap.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_sc_AbstractMap.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_sc_AbstractMap.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__O__O(v1));
});
$c_sc_AbstractMap.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sc_AbstractMap.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
$c_sc_AbstractMap.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sc_IterableOps(coll);
});
function $ct_sc_SeqView$Appended__sc_SeqOps__O__($thiz, underlying, elem) {
  $thiz.sc_SeqView$Appended__f_underlying = underlying;
  $thiz.sc_SeqView$Appended__f_elem = elem;
  $ct_sc_View$Appended__sc_IterableOps__O__($thiz, underlying, elem);
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Appended() {
  this.sc_View$Appended__f_underlying = null;
  this.sc_View$Appended__f_elem = null;
  this.sc_SeqView$Appended__f_underlying = null;
  this.sc_SeqView$Appended__f_elem = null;
}
$c_sc_SeqView$Appended.prototype = new $h_sc_View$Appended();
$c_sc_SeqView$Appended.prototype.constructor = $c_sc_SeqView$Appended;
/** @constructor */
function $h_sc_SeqView$Appended() {
}
$h_sc_SeqView$Appended.prototype = $c_sc_SeqView$Appended.prototype;
$c_sc_SeqView$Appended.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$c_sc_SeqView$Appended.prototype.appended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$c_sc_SeqView$Appended.prototype.prepended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Prepended__O__sc_SeqOps__(new $c_sc_SeqView$Prepended(), elem, this);
});
$c_sc_SeqView$Appended.prototype.reverse__sc_SeqView = (function() {
  return $ct_sc_SeqView$Reverse__sc_SeqOps__(new $c_sc_SeqView$Reverse(), this);
});
$c_sc_SeqView$Appended.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n);
});
$c_sc_SeqView$Appended.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$c_sc_SeqView$Appended.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$c_sc_SeqView$Appended.prototype.stringPrefix__T = (function() {
  return "SeqView";
});
$c_sc_SeqView$Appended.prototype.prependedAll__sc_IterableOnce__O = (function(prefix) {
  return $f_sc_SeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$c_sc_SeqView$Appended.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_SeqView$Appended.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_SeqView$Appended.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$c_sc_SeqView$Appended.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.reversed__sc_Iterable()).iterator__sc_Iterator();
});
$c_sc_SeqView$Appended.prototype.padTo__I__O__O = (function(len, elem) {
  return $f_sc_SeqOps__padTo__I__O__O(this, len, elem);
});
$c_sc_SeqView$Appended.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = $n(this.iterator__sc_Iterator());
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from);
});
$c_sc_SeqView$Appended.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_sc_SeqView$Appended.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_sc_SeqView$Appended.prototype.apply__I__O = (function(idx) {
  return ((idx === $n(this.sc_SeqView$Appended__f_underlying).length__I()) ? this.sc_SeqView$Appended__f_elem : $n(this.sc_SeqView$Appended__f_underlying).apply__I__O(idx));
});
$c_sc_SeqView$Appended.prototype.length__I = (function() {
  return ((1 + $n(this.sc_SeqView$Appended__f_underlying).length__I()) | 0);
});
$c_sc_SeqView$Appended.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
$c_sc_SeqView$Appended.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_SeqView(n);
});
$c_sc_SeqView$Appended.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n);
});
$c_sc_SeqView$Appended.prototype.take__I__O = (function(n) {
  return this.take__I__sc_SeqView(n);
});
$c_sc_SeqView$Appended.prototype.reverse__O = (function() {
  return this.reverse__sc_SeqView();
});
$c_sc_SeqView$Appended.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_SeqView(elem);
});
$c_sc_SeqView$Appended.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_SeqView(elem);
});
$c_sc_SeqView$Appended.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f);
});
var $d_sc_SeqView$Appended = new $TypeData().initClass($c_sc_SeqView$Appended, "scala.collection.SeqView$Appended", ({
  sc_SeqView$Appended: 1,
  sc_View$Appended: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
}));
function $ct_sc_SeqView$Drop__sc_SeqOps__I__($thiz, underlying, n) {
  $thiz.sc_SeqView$Drop__f_underlying = underlying;
  $thiz.sc_SeqView$Drop__f_n = n;
  $ct_sc_View$Drop__sc_IterableOps__I__($thiz, underlying, n);
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Drop() {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0;
  this.sc_SeqView$Drop__f_underlying = null;
  this.sc_SeqView$Drop__f_n = 0;
}
$c_sc_SeqView$Drop.prototype = new $h_sc_View$Drop();
$c_sc_SeqView$Drop.prototype.constructor = $c_sc_SeqView$Drop;
/** @constructor */
function $h_sc_SeqView$Drop() {
}
$h_sc_SeqView$Drop.prototype = $c_sc_SeqView$Drop.prototype;
$c_sc_SeqView$Drop.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$c_sc_SeqView$Drop.prototype.appended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$c_sc_SeqView$Drop.prototype.prepended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Prepended__O__sc_SeqOps__(new $c_sc_SeqView$Prepended(), elem, this);
});
$c_sc_SeqView$Drop.prototype.reverse__sc_SeqView = (function() {
  return $ct_sc_SeqView$Reverse__sc_SeqOps__(new $c_sc_SeqView$Reverse(), this);
});
$c_sc_SeqView$Drop.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n);
});
$c_sc_SeqView$Drop.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$c_sc_SeqView$Drop.prototype.stringPrefix__T = (function() {
  return "SeqView";
});
$c_sc_SeqView$Drop.prototype.prependedAll__sc_IterableOnce__O = (function(prefix) {
  return $f_sc_SeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$c_sc_SeqView$Drop.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_SeqView$Drop.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_SeqView$Drop.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$c_sc_SeqView$Drop.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.reversed__sc_Iterable()).iterator__sc_Iterator();
});
$c_sc_SeqView$Drop.prototype.padTo__I__O__O = (function(len, elem) {
  return $f_sc_SeqOps__padTo__I__O__O(this, len, elem);
});
$c_sc_SeqView$Drop.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = $n(this.iterator__sc_Iterator());
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from);
});
$c_sc_SeqView$Drop.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_sc_SeqView$Drop.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_sc_SeqView$Drop.prototype.length__I = (function() {
  var this$1 = $n(this.sc_SeqView$Drop__f_underlying);
  var x = ((this$1.length__I() - this.sc_View$Drop__f_normN) | 0);
  return ((x > 0) ? x : 0);
});
$c_sc_SeqView$Drop.prototype.apply__I__O = (function(i) {
  return $n(this.sc_SeqView$Drop__f_underlying).apply__I__O(((i + this.sc_View$Drop__f_normN) | 0));
});
$c_sc_SeqView$Drop.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this.sc_SeqView$Drop__f_underlying, ((this.sc_SeqView$Drop__f_n + n) | 0));
});
$c_sc_SeqView$Drop.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
$c_sc_SeqView$Drop.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_SeqView(n);
});
$c_sc_SeqView$Drop.prototype.take__I__O = (function(n) {
  return this.take__I__sc_SeqView(n);
});
$c_sc_SeqView$Drop.prototype.reverse__O = (function() {
  return this.reverse__sc_SeqView();
});
$c_sc_SeqView$Drop.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_SeqView(elem);
});
$c_sc_SeqView$Drop.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_SeqView(elem);
});
$c_sc_SeqView$Drop.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f);
});
$c_sc_SeqView$Drop.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n);
});
var $d_sc_SeqView$Drop = new $TypeData().initClass($c_sc_SeqView$Drop, "scala.collection.SeqView$Drop", ({
  sc_SeqView$Drop: 1,
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
}));
function $ct_sc_SeqView$DropRight__sc_SeqOps__I__($thiz, underlying, n) {
  $thiz.sc_SeqView$DropRight__f_underlying = underlying;
  $ct_sc_View$DropRight__sc_IterableOps__I__($thiz, underlying, n);
  var this$1 = $n(underlying);
  var x = ((this$1.length__I() - ((n > 0) ? n : 0)) | 0);
  $thiz.sc_SeqView$DropRight__f_len = ((x > 0) ? x : 0);
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$DropRight() {
  this.sc_View$DropRight__f_underlying = null;
  this.sc_View$DropRight__f_n = 0;
  this.sc_View$DropRight__f_normN = 0;
  this.sc_SeqView$DropRight__f_underlying = null;
  this.sc_SeqView$DropRight__f_len = 0;
}
$c_sc_SeqView$DropRight.prototype = new $h_sc_View$DropRight();
$c_sc_SeqView$DropRight.prototype.constructor = $c_sc_SeqView$DropRight;
/** @constructor */
function $h_sc_SeqView$DropRight() {
}
$h_sc_SeqView$DropRight.prototype = $c_sc_SeqView$DropRight.prototype;
$c_sc_SeqView$DropRight.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$c_sc_SeqView$DropRight.prototype.appended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$c_sc_SeqView$DropRight.prototype.prepended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Prepended__O__sc_SeqOps__(new $c_sc_SeqView$Prepended(), elem, this);
});
$c_sc_SeqView$DropRight.prototype.reverse__sc_SeqView = (function() {
  return $ct_sc_SeqView$Reverse__sc_SeqOps__(new $c_sc_SeqView$Reverse(), this);
});
$c_sc_SeqView$DropRight.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n);
});
$c_sc_SeqView$DropRight.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$c_sc_SeqView$DropRight.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$c_sc_SeqView$DropRight.prototype.stringPrefix__T = (function() {
  return "SeqView";
});
$c_sc_SeqView$DropRight.prototype.prependedAll__sc_IterableOnce__O = (function(prefix) {
  return $f_sc_SeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$c_sc_SeqView$DropRight.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_SeqView$DropRight.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_SeqView$DropRight.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$c_sc_SeqView$DropRight.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.reversed__sc_Iterable()).iterator__sc_Iterator();
});
$c_sc_SeqView$DropRight.prototype.padTo__I__O__O = (function(len, elem) {
  return $f_sc_SeqOps__padTo__I__O__O(this, len, elem);
});
$c_sc_SeqView$DropRight.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = $n(this.iterator__sc_Iterator());
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from);
});
$c_sc_SeqView$DropRight.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_sc_SeqView$DropRight.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_sc_SeqView$DropRight.prototype.length__I = (function() {
  return this.sc_SeqView$DropRight__f_len;
});
$c_sc_SeqView$DropRight.prototype.apply__I__O = (function(i) {
  return $n(this.sc_SeqView$DropRight__f_underlying).apply__I__O(i);
});
$c_sc_SeqView$DropRight.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
$c_sc_SeqView$DropRight.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_SeqView(n);
});
$c_sc_SeqView$DropRight.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n);
});
$c_sc_SeqView$DropRight.prototype.take__I__O = (function(n) {
  return this.take__I__sc_SeqView(n);
});
$c_sc_SeqView$DropRight.prototype.reverse__O = (function() {
  return this.reverse__sc_SeqView();
});
$c_sc_SeqView$DropRight.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_SeqView(elem);
});
$c_sc_SeqView$DropRight.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_SeqView(elem);
});
$c_sc_SeqView$DropRight.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f);
});
var $d_sc_SeqView$DropRight = new $TypeData().initClass($c_sc_SeqView$DropRight, "scala.collection.SeqView$DropRight", ({
  sc_SeqView$DropRight: 1,
  sc_View$DropRight: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
}));
function $ct_sc_SeqView$Id__sc_SeqOps__($thiz, underlying) {
  $thiz.sc_SeqView$Id__f_underlying = underlying;
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Id() {
  this.sc_SeqView$Id__f_underlying = null;
}
$c_sc_SeqView$Id.prototype = new $h_sc_AbstractSeqView();
$c_sc_SeqView$Id.prototype.constructor = $c_sc_SeqView$Id;
/** @constructor */
function $h_sc_SeqView$Id() {
}
$h_sc_SeqView$Id.prototype = $c_sc_SeqView$Id.prototype;
$c_sc_SeqView$Id.prototype.apply__I__O = (function(idx) {
  return $n(this.sc_SeqView$Id__f_underlying).apply__I__O(idx);
});
$c_sc_SeqView$Id.prototype.length__I = (function() {
  return $n(this.sc_SeqView$Id__f_underlying).length__I();
});
$c_sc_SeqView$Id.prototype.iterator__sc_Iterator = (function() {
  return $n(this.sc_SeqView$Id__f_underlying).iterator__sc_Iterator();
});
$c_sc_SeqView$Id.prototype.knownSize__I = (function() {
  return $n(this.sc_SeqView$Id__f_underlying).knownSize__I();
});
$c_sc_SeqView$Id.prototype.isEmpty__Z = (function() {
  return $n(this.sc_SeqView$Id__f_underlying).isEmpty__Z();
});
var $d_sc_SeqView$Id = new $TypeData().initClass($c_sc_SeqView$Id, "scala.collection.SeqView$Id", ({
  sc_SeqView$Id: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
}));
function $ct_sc_SeqView$Map__sc_SeqOps__F1__($thiz, underlying, f) {
  $thiz.sc_SeqView$Map__f_underlying = underlying;
  $thiz.sc_SeqView$Map__f_f = f;
  $ct_sc_View$Map__sc_IterableOps__F1__($thiz, underlying, f);
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Map() {
  this.sc_View$Map__f_underlying = null;
  this.sc_View$Map__f_f = null;
  this.sc_SeqView$Map__f_underlying = null;
  this.sc_SeqView$Map__f_f = null;
}
$c_sc_SeqView$Map.prototype = new $h_sc_View$Map();
$c_sc_SeqView$Map.prototype.constructor = $c_sc_SeqView$Map;
/** @constructor */
function $h_sc_SeqView$Map() {
}
$h_sc_SeqView$Map.prototype = $c_sc_SeqView$Map.prototype;
$c_sc_SeqView$Map.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$c_sc_SeqView$Map.prototype.appended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$c_sc_SeqView$Map.prototype.prepended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Prepended__O__sc_SeqOps__(new $c_sc_SeqView$Prepended(), elem, this);
});
$c_sc_SeqView$Map.prototype.reverse__sc_SeqView = (function() {
  return $ct_sc_SeqView$Reverse__sc_SeqOps__(new $c_sc_SeqView$Reverse(), this);
});
$c_sc_SeqView$Map.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n);
});
$c_sc_SeqView$Map.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$c_sc_SeqView$Map.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$c_sc_SeqView$Map.prototype.stringPrefix__T = (function() {
  return "SeqView";
});
$c_sc_SeqView$Map.prototype.prependedAll__sc_IterableOnce__O = (function(prefix) {
  return $f_sc_SeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$c_sc_SeqView$Map.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_SeqView$Map.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_SeqView$Map.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$c_sc_SeqView$Map.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.reversed__sc_Iterable()).iterator__sc_Iterator();
});
$c_sc_SeqView$Map.prototype.padTo__I__O__O = (function(len, elem) {
  return $f_sc_SeqOps__padTo__I__O__O(this, len, elem);
});
$c_sc_SeqView$Map.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = $n(this.iterator__sc_Iterator());
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from);
});
$c_sc_SeqView$Map.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_sc_SeqView$Map.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_sc_SeqView$Map.prototype.apply__I__O = (function(idx) {
  return $n(this.sc_SeqView$Map__f_f).apply__O__O($n(this.sc_SeqView$Map__f_underlying).apply__I__O(idx));
});
$c_sc_SeqView$Map.prototype.length__I = (function() {
  return $n(this.sc_SeqView$Map__f_underlying).length__I();
});
$c_sc_SeqView$Map.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
$c_sc_SeqView$Map.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_SeqView(n);
});
$c_sc_SeqView$Map.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n);
});
$c_sc_SeqView$Map.prototype.take__I__O = (function(n) {
  return this.take__I__sc_SeqView(n);
});
$c_sc_SeqView$Map.prototype.reverse__O = (function() {
  return this.reverse__sc_SeqView();
});
$c_sc_SeqView$Map.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_SeqView(elem);
});
$c_sc_SeqView$Map.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_SeqView(elem);
});
$c_sc_SeqView$Map.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f);
});
var $d_sc_SeqView$Map = new $TypeData().initClass($c_sc_SeqView$Map, "scala.collection.SeqView$Map", ({
  sc_SeqView$Map: 1,
  sc_View$Map: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
}));
function $ct_sc_SeqView$Prepended__O__sc_SeqOps__($thiz, elem, underlying) {
  $thiz.sc_SeqView$Prepended__f_elem = elem;
  $thiz.sc_SeqView$Prepended__f_underlying = underlying;
  $ct_sc_View$Prepended__O__sc_IterableOps__($thiz, elem, underlying);
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Prepended() {
  this.sc_View$Prepended__f_elem = null;
  this.sc_View$Prepended__f_underlying = null;
  this.sc_SeqView$Prepended__f_elem = null;
  this.sc_SeqView$Prepended__f_underlying = null;
}
$c_sc_SeqView$Prepended.prototype = new $h_sc_View$Prepended();
$c_sc_SeqView$Prepended.prototype.constructor = $c_sc_SeqView$Prepended;
/** @constructor */
function $h_sc_SeqView$Prepended() {
}
$h_sc_SeqView$Prepended.prototype = $c_sc_SeqView$Prepended.prototype;
$c_sc_SeqView$Prepended.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$c_sc_SeqView$Prepended.prototype.appended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$c_sc_SeqView$Prepended.prototype.prepended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Prepended__O__sc_SeqOps__(new $c_sc_SeqView$Prepended(), elem, this);
});
$c_sc_SeqView$Prepended.prototype.reverse__sc_SeqView = (function() {
  return $ct_sc_SeqView$Reverse__sc_SeqOps__(new $c_sc_SeqView$Reverse(), this);
});
$c_sc_SeqView$Prepended.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n);
});
$c_sc_SeqView$Prepended.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$c_sc_SeqView$Prepended.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$c_sc_SeqView$Prepended.prototype.stringPrefix__T = (function() {
  return "SeqView";
});
$c_sc_SeqView$Prepended.prototype.prependedAll__sc_IterableOnce__O = (function(prefix) {
  return $f_sc_SeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$c_sc_SeqView$Prepended.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_SeqView$Prepended.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_SeqView$Prepended.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$c_sc_SeqView$Prepended.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.reversed__sc_Iterable()).iterator__sc_Iterator();
});
$c_sc_SeqView$Prepended.prototype.padTo__I__O__O = (function(len, elem) {
  return $f_sc_SeqOps__padTo__I__O__O(this, len, elem);
});
$c_sc_SeqView$Prepended.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = $n(this.iterator__sc_Iterator());
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from);
});
$c_sc_SeqView$Prepended.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_sc_SeqView$Prepended.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_sc_SeqView$Prepended.prototype.apply__I__O = (function(idx) {
  return ((idx === 0) ? this.sc_SeqView$Prepended__f_elem : $n(this.sc_SeqView$Prepended__f_underlying).apply__I__O((((-1) + idx) | 0)));
});
$c_sc_SeqView$Prepended.prototype.length__I = (function() {
  return ((1 + $n(this.sc_SeqView$Prepended__f_underlying).length__I()) | 0);
});
$c_sc_SeqView$Prepended.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
$c_sc_SeqView$Prepended.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_SeqView(n);
});
$c_sc_SeqView$Prepended.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n);
});
$c_sc_SeqView$Prepended.prototype.take__I__O = (function(n) {
  return this.take__I__sc_SeqView(n);
});
$c_sc_SeqView$Prepended.prototype.reverse__O = (function() {
  return this.reverse__sc_SeqView();
});
$c_sc_SeqView$Prepended.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_SeqView(elem);
});
$c_sc_SeqView$Prepended.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_SeqView(elem);
});
$c_sc_SeqView$Prepended.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f);
});
var $d_sc_SeqView$Prepended = new $TypeData().initClass($c_sc_SeqView$Prepended, "scala.collection.SeqView$Prepended", ({
  sc_SeqView$Prepended: 1,
  sc_View$Prepended: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
}));
function $ct_sc_SeqView$Reverse__sc_SeqOps__($thiz, underlying) {
  $thiz.sc_SeqView$Reverse__f_underlying = underlying;
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Reverse() {
  this.sc_SeqView$Reverse__f_underlying = null;
}
$c_sc_SeqView$Reverse.prototype = new $h_sc_AbstractSeqView();
$c_sc_SeqView$Reverse.prototype.constructor = $c_sc_SeqView$Reverse;
/** @constructor */
function $h_sc_SeqView$Reverse() {
}
$h_sc_SeqView$Reverse.prototype = $c_sc_SeqView$Reverse.prototype;
$c_sc_SeqView$Reverse.prototype.apply__I__O = (function(i) {
  return $n(this.sc_SeqView$Reverse__f_underlying).apply__I__O((((((-1) + this.length__I()) | 0) - i) | 0));
});
$c_sc_SeqView$Reverse.prototype.length__I = (function() {
  var this$1 = $n(this.sc_SeqView$Reverse__f_underlying);
  return this$1.length__I();
});
$c_sc_SeqView$Reverse.prototype.iterator__sc_Iterator = (function() {
  return $n(this.sc_SeqView$Reverse__f_underlying).reverseIterator__sc_Iterator();
});
$c_sc_SeqView$Reverse.prototype.knownSize__I = (function() {
  return $n(this.sc_SeqView$Reverse__f_underlying).knownSize__I();
});
$c_sc_SeqView$Reverse.prototype.isEmpty__Z = (function() {
  return $n(this.sc_SeqView$Reverse__f_underlying).isEmpty__Z();
});
var $d_sc_SeqView$Reverse = new $TypeData().initClass($c_sc_SeqView$Reverse, "scala.collection.SeqView$Reverse", ({
  sc_SeqView$Reverse: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
}));
function $ct_sc_SeqView$Take__sc_SeqOps__I__($thiz, underlying, n) {
  $thiz.sc_SeqView$Take__f_underlying = underlying;
  $thiz.sc_SeqView$Take__f_n = n;
  $ct_sc_View$Take__sc_IterableOps__I__($thiz, underlying, n);
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Take() {
  this.sc_View$Take__f_underlying = null;
  this.sc_View$Take__f_n = 0;
  this.sc_View$Take__f_normN = 0;
  this.sc_SeqView$Take__f_underlying = null;
  this.sc_SeqView$Take__f_n = 0;
}
$c_sc_SeqView$Take.prototype = new $h_sc_View$Take();
$c_sc_SeqView$Take.prototype.constructor = $c_sc_SeqView$Take;
/** @constructor */
function $h_sc_SeqView$Take() {
}
$h_sc_SeqView$Take.prototype = $c_sc_SeqView$Take.prototype;
$c_sc_SeqView$Take.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$c_sc_SeqView$Take.prototype.appended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$c_sc_SeqView$Take.prototype.prepended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Prepended__O__sc_SeqOps__(new $c_sc_SeqView$Prepended(), elem, this);
});
$c_sc_SeqView$Take.prototype.reverse__sc_SeqView = (function() {
  return $ct_sc_SeqView$Reverse__sc_SeqOps__(new $c_sc_SeqView$Reverse(), this);
});
$c_sc_SeqView$Take.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n);
});
$c_sc_SeqView$Take.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$c_sc_SeqView$Take.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$c_sc_SeqView$Take.prototype.stringPrefix__T = (function() {
  return "SeqView";
});
$c_sc_SeqView$Take.prototype.prependedAll__sc_IterableOnce__O = (function(prefix) {
  return $f_sc_SeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$c_sc_SeqView$Take.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_SeqView$Take.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_SeqView$Take.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$c_sc_SeqView$Take.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.reversed__sc_Iterable()).iterator__sc_Iterator();
});
$c_sc_SeqView$Take.prototype.padTo__I__O__O = (function(len, elem) {
  return $f_sc_SeqOps__padTo__I__O__O(this, len, elem);
});
$c_sc_SeqView$Take.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = $n(this.iterator__sc_Iterator());
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from);
});
$c_sc_SeqView$Take.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_sc_SeqView$Take.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_sc_SeqView$Take.prototype.apply__I__O = (function(idx) {
  if ((idx < this.sc_SeqView$Take__f_n)) {
    return $n(this.sc_SeqView$Take__f_underlying).apply__I__O(idx);
  } else {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((idx + " is out of bounds (min 0, max ") + (($n(this.sc_SeqView$Take__f_underlying).knownSize__I() >= 0) ? (((-1) + this.knownSize__I()) | 0) : "unknown")) + ")"));
  }
});
$c_sc_SeqView$Take.prototype.length__I = (function() {
  var x = $n(this.sc_SeqView$Take__f_underlying).length__I();
  var that = this.sc_View$Take__f_normN;
  return ((x < that) ? x : that);
});
$c_sc_SeqView$Take.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
$c_sc_SeqView$Take.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_SeqView(n);
});
$c_sc_SeqView$Take.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n);
});
$c_sc_SeqView$Take.prototype.take__I__O = (function(n) {
  return this.take__I__sc_SeqView(n);
});
$c_sc_SeqView$Take.prototype.reverse__O = (function() {
  return this.reverse__sc_SeqView();
});
$c_sc_SeqView$Take.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_SeqView(elem);
});
$c_sc_SeqView$Take.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_SeqView(elem);
});
$c_sc_SeqView$Take.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f);
});
var $d_sc_SeqView$Take = new $TypeData().initClass($c_sc_SeqView$Take, "scala.collection.SeqView$Take", ({
  sc_SeqView$Take: 1,
  sc_View$Take: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
}));
function $f_sc_SortedSet__equals__O__Z($thiz, that) {
  if (($thiz === that)) {
    return true;
  }
  if ($is_sc_SortedSet(that)) {
    var x2 = $as_sc_SortedSet(that);
    var x = $n(x2).ordering__s_math_Ordering();
    var x$2 = $thiz.ordering__s_math_Ordering();
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      if ((($n(x2), true) && ($thiz.size__I() === $n(x2).size__I()))) {
        var i1 = $thiz.iterator__sc_Iterator();
        var i2 = $n(x2).iterator__sc_Iterator();
        var allEqual = true;
        while ((allEqual && $n(i1).hasNext__Z())) {
          allEqual = $n($thiz.ordering__s_math_Ordering()).equiv__O__O__Z($n(i1).next__O(), $n(i2).next__O());
        }
        return allEqual;
      } else {
        return false;
      }
    }
  }
  return $f_sc_Set__equals__O__Z($thiz, that);
}
function $is_sc_SortedSet(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_SortedSet)));
}
function $as_sc_SortedSet(obj) {
  return (($is_sc_SortedSet(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.SortedSet"));
}
function $isArrayOf_sc_SortedSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_SortedSet)));
}
function $asArrayOf_sc_SortedSet(obj, depth) {
  return (($isArrayOf_sc_SortedSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.SortedSet;", depth));
}
function $is_sci_Seq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Seq)));
}
function $as_sci_Seq(obj) {
  return (($is_sci_Seq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Seq"));
}
function $isArrayOf_sci_Seq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Seq)));
}
function $asArrayOf_sci_Seq(obj, depth) {
  return (($isArrayOf_sci_Seq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Seq;", depth));
}
var $d_sci_Seq = new $TypeData().initClass(1, "scala.collection.immutable.Seq", ({
  sci_Seq: 1,
  sci_Iterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_SeqOps: 1
}));
function $f_scm_MapOps__update__O__O__V($thiz, key, value) {
  var elem = new $c_T2(key, value);
  $thiz.addOne__O__scm_Growable(elem);
}
function $f_scm_MapOps__getOrElseUpdate__O__F0__O($thiz, key, defaultValue) {
  var x1 = $thiz.get__O__s_Option(key);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var v = $n(x2).s_Some__f_value;
    return v;
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var d = $n(defaultValue).apply__O();
      $thiz.update__O__O__V(key, d);
      return d;
    } else {
      throw new $c_s_MatchError(x1);
    }
  }
}
/** @constructor */
function $c_Lcats_Invariant$() {
}
$c_Lcats_Invariant$.prototype = new $h_O();
$c_Lcats_Invariant$.prototype.constructor = $c_Lcats_Invariant$;
/** @constructor */
function $h_Lcats_Invariant$() {
}
$h_Lcats_Invariant$.prototype = $c_Lcats_Invariant$.prototype;
var $d_Lcats_Invariant$ = new $TypeData().initClass($c_Lcats_Invariant$, "cats.Invariant$", ({
  Lcats_Invariant$: 1,
  Lcats_ScalaVersionSpecificInvariantInstances: 1,
  Lcats_instances_NTupleMonadInstances5: 1,
  Lcats_instances_NTupleMonadInstances4: 1,
  Lcats_instances_NTupleMonadInstances3: 1,
  Lcats_instances_NTupleMonadInstances2: 1,
  Lcats_instances_NTupleMonadInstances1: 1,
  Lcats_instances_NTupleMonadInstances: 1,
  Lcats_TupleInstances2: 1,
  Lcats_TupleInstances1: 1,
  Lcats_TupleInstances0: 1,
  Lcats_InvariantInstances2: 1,
  Lcats_InvariantInstances1: 1,
  Lcats_InvariantInstances0: 1
}));
var $n_Lcats_Invariant$;
function $m_Lcats_Invariant$() {
  if ((!$n_Lcats_Invariant$)) {
    $n_Lcats_Invariant$ = new $c_Lcats_Invariant$();
  }
  return $n_Lcats_Invariant$;
}
function $f_Lcats_MonadError__redeemWith__O__F1__F1__O($thiz, fa, recover, bind) {
  return $thiz.flatMap__O__F1__O($thiz.attempt__O__O(fa), new $c_sjsr_AnonFunction1(((_$3) => {
    var _$3$1 = $as_s_util_Either(_$3);
    return $n(_$3$1).fold__F1__F1__O(recover, bind);
  })));
}
function $f_Lcats_data_KleisliApplicativeError__raiseError__O__Lcats_data_Kleisli($thiz, e) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((_$166) => $n($thiz.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1).raiseError__O__O(e)));
  return new $c_Lcats_data_Kleisli(run);
}
function $f_Lcats_data_KleisliApplicativeError__handleErrorWith__Lcats_data_Kleisli__F1__Lcats_data_Kleisli($thiz, kb, f) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((a) => $n($thiz.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1).handleErrorWith__O__F1__O($n($n(kb).Lcats_data_Kleisli__f_run).apply__O__O(a), new $c_sjsr_AnonFunction1(((e) => $n($n($as_Lcats_data_Kleisli($n(f).apply__O__O(e))).Lcats_data_Kleisli__f_run).apply__O__O(a))))));
  return new $c_Lcats_data_Kleisli(run);
}
/** @constructor */
function $c_Lcats_data_ValidatedInstances$$anon$7(E$1) {
  this.Lcats_data_ValidatedApplicative__f_evidence$1 = null;
  $ct_Lcats_data_ValidatedApplicative__Lcats_kernel_Semigroup__(this, E$1);
}
$c_Lcats_data_ValidatedInstances$$anon$7.prototype = new $h_Lcats_data_ValidatedApplicative();
$c_Lcats_data_ValidatedInstances$$anon$7.prototype.constructor = $c_Lcats_data_ValidatedInstances$$anon$7;
/** @constructor */
function $h_Lcats_data_ValidatedInstances$$anon$7() {
}
$h_Lcats_data_ValidatedInstances$$anon$7.prototype = $c_Lcats_data_ValidatedInstances$$anon$7.prototype;
$c_Lcats_data_ValidatedInstances$$anon$7.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lcats_data_ValidatedInstances$$anon$7.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa);
});
$c_Lcats_data_ValidatedInstances$$anon$7.prototype.handleErrorWith__Lcats_data_Validated__F1__Lcats_data_Validated = (function(fa, f) {
  if ((fa instanceof $c_Lcats_data_Validated$Invalid)) {
    var x$1 = $as_Lcats_data_Validated$Invalid(fa);
    var this$2 = $n(x$1);
    var x398 = this$2.Lcats_data_Validated$Invalid__f_e;
    return $as_Lcats_data_Validated($n(f).apply__O__O(x398));
  }
  if ((fa instanceof $c_Lcats_data_Validated$Valid)) {
    var x$1$1 = $as_Lcats_data_Validated$Valid(fa);
    var this$4 = $n(x$1$1);
    var v = $as_Lcats_data_Validated$Valid(fa);
    return v;
  }
  throw new $c_s_MatchError(fa);
});
$c_Lcats_data_ValidatedInstances$$anon$7.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return this.handleErrorWith__Lcats_data_Validated__F1__Lcats_data_Validated($as_Lcats_data_Validated(fa), f);
});
$c_Lcats_data_ValidatedInstances$$anon$7.prototype.raiseError__O__O = (function(e) {
  return new $c_Lcats_data_Validated$Invalid(e);
});
var $d_Lcats_data_ValidatedInstances$$anon$7 = new $TypeData().initClass($c_Lcats_data_ValidatedInstances$$anon$7, "cats.data.ValidatedInstances$$anon$7", ({
  Lcats_data_ValidatedInstances$$anon$7: 1,
  Lcats_data_ValidatedApplicative: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_CommutativeApply: 1,
  Lcats_CommutativeApplicative: 1,
  Lcats_ApplicativeError: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_ResourceMonad() {
}
$c_Lcats_effect_kernel_ResourceMonad.prototype = new $h_O();
$c_Lcats_effect_kernel_ResourceMonad.prototype.constructor = $c_Lcats_effect_kernel_ResourceMonad;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceMonad() {
}
$h_Lcats_effect_kernel_ResourceMonad.prototype = $c_Lcats_effect_kernel_ResourceMonad.prototype;
$c_Lcats_effect_kernel_ResourceMonad.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.unit__O = (function() {
  return new $c_Lcats_effect_kernel_Resource$Pure((void 0));
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.tailRecM__O__F1__O = (function(a, f) {
  return $f_Lcats_StackSafeMonad__tailRecM__O__F1__O(this, a, f);
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.pure__O__O = (function(x) {
  return new $c_Lcats_effect_kernel_Resource$Pure(x);
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_effect_kernel_Resource(fa);
  var this$1 = $n(fa$1);
  return new $c_Lcats_effect_kernel_Resource$Bind(this$1, f);
});
/** @constructor */
function $c_Lcats_effect_syntax_package$all$() {
}
$c_Lcats_effect_syntax_package$all$.prototype = new $h_O();
$c_Lcats_effect_syntax_package$all$.prototype.constructor = $c_Lcats_effect_syntax_package$all$;
/** @constructor */
function $h_Lcats_effect_syntax_package$all$() {
}
$h_Lcats_effect_syntax_package$all$.prototype = $c_Lcats_effect_syntax_package$all$.prototype;
var $d_Lcats_effect_syntax_package$all$ = new $TypeData().initClass($c_Lcats_effect_syntax_package$all$, "cats.effect.syntax.package$all$", ({
  Lcats_effect_syntax_package$all$: 1,
  Lcats_effect_kernel_syntax_MonadCancelSyntax: 1,
  Lcats_effect_kernel_syntax_GenSpawnSyntax: 1,
  Lcats_effect_kernel_syntax_GenTemporalSyntax: 1,
  Lcats_effect_kernel_syntax_GenConcurrentSyntax: 1,
  Lcats_effect_kernel_syntax_AsyncSyntax: 1,
  Lcats_effect_kernel_syntax_ResourceSyntax: 1,
  Lcats_effect_kernel_syntax_ClockSyntax: 1,
  Lcats_effect_kernel_syntax_AllSyntax: 1,
  Lcats_effect_std_syntax_BackpressureSyntax: 1,
  Lcats_effect_std_syntax_SupervisorSyntax: 1,
  Lcats_effect_std_syntax_AllSyntax: 1,
  Lcats_effect_syntax_DispatcherSyntax: 1,
  Lcats_effect_syntax_AllSyntax: 1
}));
var $n_Lcats_effect_syntax_package$all$;
function $m_Lcats_effect_syntax_package$all$() {
  if ((!$n_Lcats_effect_syntax_package$all$)) {
    $n_Lcats_effect_syntax_package$all$ = new $c_Lcats_effect_syntax_package$all$();
  }
  return $n_Lcats_effect_syntax_package$all$;
}
/** @constructor */
function $c_Llaika_ast_LinkPathReference(content, path, source, title, options) {
  this.Llaika_ast_LinkPathReference__f_content = null;
  this.Llaika_ast_LinkPathReference__f_path = null;
  this.Llaika_ast_LinkPathReference__f_source = null;
  this.Llaika_ast_LinkPathReference__f_title = null;
  this.Llaika_ast_LinkPathReference__f_options = null;
  this.Llaika_ast_LinkPathReference__f_unresolvedMessage$lzy3 = null;
  this.Llaika_ast_LinkPathReference__f_unresolvedMessagebitmap$3 = false;
  this.Llaika_ast_LinkPathReference__f_content = content;
  this.Llaika_ast_LinkPathReference__f_path = path;
  this.Llaika_ast_LinkPathReference__f_source = source;
  this.Llaika_ast_LinkPathReference__f_title = title;
  this.Llaika_ast_LinkPathReference__f_options = options;
}
$c_Llaika_ast_LinkPathReference.prototype = new $h_Llaika_ast_Element();
$c_Llaika_ast_LinkPathReference.prototype.constructor = $c_Llaika_ast_LinkPathReference;
/** @constructor */
function $h_Llaika_ast_LinkPathReference() {
}
$h_Llaika_ast_LinkPathReference.prototype = $c_Llaika_ast_LinkPathReference.prototype;
$c_Llaika_ast_LinkPathReference.prototype.toString__T = (function() {
  return $m_Llaika_ast_FormattedElementString$().render__Llaika_ast_Element__T(this);
});
$c_Llaika_ast_LinkPathReference.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_Llaika_ast_LinkPathReference.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llaika_ast_LinkPathReference)) {
    var x$0$2 = $as_Llaika_ast_LinkPathReference(x$0);
    var x = this.Llaika_ast_LinkPathReference__f_content;
    var x$2 = $n(x$0$2).Llaika_ast_LinkPathReference__f_content;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llaika_ast_LinkPathReference__f_path;
      var x$4 = $n(x$0$2).Llaika_ast_LinkPathReference__f_path;
      var $x_4 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.Llaika_ast_LinkPathReference__f_source;
      var x$6 = $n(x$0$2).Llaika_ast_LinkPathReference__f_source;
      var $x_3 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.Llaika_ast_LinkPathReference__f_title;
      var x$8 = $n(x$0$2).Llaika_ast_LinkPathReference__f_title;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.Llaika_ast_LinkPathReference__f_options;
      var x$10 = $n(x$0$2).Llaika_ast_LinkPathReference__f_options;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llaika_ast_LinkPathReference.prototype.productArity__I = (function() {
  return 5;
});
$c_Llaika_ast_LinkPathReference.prototype.productPrefix__T = (function() {
  return "LinkPathReference";
});
$c_Llaika_ast_LinkPathReference.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llaika_ast_LinkPathReference__f_content;
      break;
    }
    case 1: {
      return this.Llaika_ast_LinkPathReference__f_path;
      break;
    }
    case 2: {
      return this.Llaika_ast_LinkPathReference__f_source;
      break;
    }
    case 3: {
      return this.Llaika_ast_LinkPathReference__f_title;
      break;
    }
    case 4: {
      return this.Llaika_ast_LinkPathReference__f_options;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llaika_ast_LinkPathReference.prototype.content__sci_Seq = (function() {
  return this.Llaika_ast_LinkPathReference__f_content;
});
$c_Llaika_ast_LinkPathReference.prototype.path__Llaika_ast_VirtualPath = (function() {
  return this.Llaika_ast_LinkPathReference__f_path;
});
$c_Llaika_ast_LinkPathReference.prototype.source__Llaika_parse_SourceFragment = (function() {
  return this.Llaika_ast_LinkPathReference__f_source;
});
$c_Llaika_ast_LinkPathReference.prototype.options__Llaika_ast_Options = (function() {
  return this.Llaika_ast_LinkPathReference__f_options;
});
$c_Llaika_ast_LinkPathReference.prototype.resolve__Llaika_ast_Target__Llaika_ast_Link = (function(target) {
  var content = this.Llaika_ast_LinkPathReference__f_content;
  var title = this.Llaika_ast_LinkPathReference__f_title;
  var options = this.Llaika_ast_LinkPathReference__f_options;
  return new $c_Llaika_ast_SpanLink(content, target, title, options);
});
$c_Llaika_ast_LinkPathReference.prototype.unresolvedMessage__T = (function() {
  if ((!this.Llaika_ast_LinkPathReference__f_unresolvedMessagebitmap$3)) {
    this.Llaika_ast_LinkPathReference__f_unresolvedMessage$lzy3 = (("Unresolved internal reference to '" + $n(this.Llaika_ast_LinkPathReference__f_path).toString__T()) + "'");
    this.Llaika_ast_LinkPathReference__f_unresolvedMessagebitmap$3 = true;
  }
  return this.Llaika_ast_LinkPathReference__f_unresolvedMessage$lzy3;
});
$c_Llaika_ast_LinkPathReference.prototype.content__O = (function() {
  return this.Llaika_ast_LinkPathReference__f_content;
});
$c_Llaika_ast_LinkPathReference.prototype.withContent__sci_Seq__Llaika_ast_SpanContainer = (function(newContent) {
  var path = this.Llaika_ast_LinkPathReference__f_path;
  var source = this.Llaika_ast_LinkPathReference__f_source;
  var title = this.Llaika_ast_LinkPathReference__f_title;
  var options = this.Llaika_ast_LinkPathReference__f_options;
  return new $c_Llaika_ast_LinkPathReference(newContent, path, source, title, options);
});
$c_Llaika_ast_LinkPathReference.prototype.withOptions__Llaika_ast_Options__Llaika_ast_Element = (function(options) {
  var content = this.Llaika_ast_LinkPathReference__f_content;
  var path = this.Llaika_ast_LinkPathReference__f_path;
  var source = this.Llaika_ast_LinkPathReference__f_source;
  var title = this.Llaika_ast_LinkPathReference__f_title;
  return new $c_Llaika_ast_LinkPathReference(content, path, source, title, options);
});
$c_Llaika_ast_LinkPathReference.prototype.rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_RewritableContainer = (function(rules) {
  return $f_Llaika_ast_SpanContainer__rewriteChildren__Llaika_ast_RewriteRules__Llaika_ast_SpanContainer(this, rules);
});
function $as_Llaika_ast_LinkPathReference(obj) {
  return (((obj instanceof $c_Llaika_ast_LinkPathReference) || (obj === null)) ? obj : $throwClassCastException(obj, "laika.ast.LinkPathReference"));
}
function $isArrayOf_Llaika_ast_LinkPathReference(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llaika_ast_LinkPathReference)));
}
function $asArrayOf_Llaika_ast_LinkPathReference(obj, depth) {
  return (($isArrayOf_Llaika_ast_LinkPathReference(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llaika.ast.LinkPathReference;", depth));
}
var $d_Llaika_ast_LinkPathReference = new $TypeData().initClass($c_Llaika_ast_LinkPathReference, "laika.ast.LinkPathReference", ({
  Llaika_ast_LinkPathReference: 1,
  Llaika_ast_Element: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Llaika_ast_Span: 1,
  Llaika_ast_Unresolved: 1,
  Llaika_ast_Reference: 1,
  Llaika_ast_PathReference: 1,
  Llaika_ast_Container: 1,
  Llaika_ast_ElementTraversal: 1,
  Llaika_ast_ElementContainer: 1,
  Llaika_ast_RewritableContainer: 1,
  Llaika_ast_SpanContainer: 1
}));
/** @constructor */
function $c_sc_AbstractMapView() {
}
$c_sc_AbstractMapView.prototype = new $h_sc_AbstractView();
$c_sc_AbstractMapView.prototype.constructor = $c_sc_AbstractMapView;
/** @constructor */
function $h_sc_AbstractMapView() {
}
$h_sc_AbstractMapView.prototype = $c_sc_AbstractMapView.prototype;
$c_sc_AbstractMapView.prototype.filter__F1__sc_MapView = (function(pred) {
  return new $c_sc_MapView$Filter(this, false, pred);
});
$c_sc_AbstractMapView.prototype.filterNot__F1__sc_MapView = (function(pred) {
  return new $c_sc_MapView$Filter(this, true, pred);
});
$c_sc_AbstractMapView.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_MapView__partition__F1__T2(this, p);
});
$c_sc_AbstractMapView.prototype.toString__T = (function() {
  return $f_sc_View__toString__T(this);
});
$c_sc_AbstractMapView.prototype.stringPrefix__T = (function() {
  return "MapView";
});
$c_sc_AbstractMapView.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1);
});
$c_sc_AbstractMapView.prototype.apply__O__O = (function(key) {
  return $f_sc_MapOps__apply__O__O(this, key);
});
$c_sc_AbstractMapView.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_sc_MapOps__applyOrElse__O__F1__O(this, x, default$1);
});
$c_sc_AbstractMapView.prototype.keysIterator__sc_Iterator = (function() {
  return new $c_sc_MapOps$$anon$2(this);
});
$c_sc_AbstractMapView.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sc_MapOps$$anon$3(this);
});
$c_sc_AbstractMapView.prototype.default__O__O = (function(key) {
  return $f_sc_MapOps__default__O__O(this, key);
});
$c_sc_AbstractMapView.prototype.contains__O__Z = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key);
});
$c_sc_AbstractMapView.prototype.isDefinedAt__O__Z = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key);
});
$c_sc_AbstractMapView.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  return $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, sb, start, sep, end);
});
$c_sc_AbstractMapView.prototype.orElse__s_PartialFunction__s_PartialFunction = (function(that) {
  return new $c_s_PartialFunction$OrElse(this, that);
});
$c_sc_AbstractMapView.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_sc_AbstractMapView.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_sc_AbstractMapView.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_sc_AbstractMapView.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ($f_sc_MapOps__apply__O__O(this, v1));
});
$c_sc_AbstractMapView.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sc_AbstractMapView.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
$c_sc_AbstractMapView.prototype.empty__sc_IterableOps = (function() {
  var this$1 = $m_sc_MapView$();
  return this$1.sc_MapView$__f_EmptyMapView;
});
$c_sc_AbstractMapView.prototype.empty__sc_View = (function() {
  var this$1 = $m_sc_MapView$();
  return this$1.sc_MapView$__f_EmptyMapView;
});
$c_sc_AbstractMapView.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_sc_MapView$();
});
$c_sc_AbstractMapView.prototype.filterNot__F1__O = (function(pred) {
  return this.filterNot__F1__sc_MapView(pred);
});
$c_sc_AbstractMapView.prototype.filter__F1__O = (function(pred) {
  return this.filter__F1__sc_MapView(pred);
});
function $f_sci_Map__withDefaultValue__O__sci_Map($thiz, d) {
  return new $c_sci_Map$WithDefault($thiz, new $c_sjsr_AnonFunction1(((x$1$2) => d)));
}
function $is_sci_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Map)));
}
function $as_sci_Map(obj) {
  return (($is_sci_Map(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Map"));
}
function $isArrayOf_sci_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Map)));
}
function $asArrayOf_sci_Map(obj, depth) {
  return (($isArrayOf_sci_Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Map;", depth));
}
function $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O($thiz, fa, fin) {
  return $thiz.guaranteeCase__O__F1__O(fa, new $c_sjsr_AnonFunction1(((_$2) => {
    $as_Lcats_effect_kernel_Outcome(_$2);
    return fin;
  })));
}
function $f_Lcats_effect_kernel_MonadCancel__guaranteeCase__O__F1__O($thiz, fa, fin) {
  return $thiz.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var finalized = $thiz.onCancel__O__O__O($n(poll$1).apply__O__O(fa), $n(fin).apply__O__O(new $c_Lcats_effect_kernel_Outcome$Canceled()));
    var pf = new $c_Lcats_effect_kernel_MonadCancel$$anon$1(fin, $thiz);
    var handled = $f_Lcats_ApplicativeError__onError__O__s_PartialFunction__O($thiz, finalized, pf);
    var f = new $c_sjsr_AnonFunction1(((a) => {
      var $x_1 = $n(fin);
      var fa$1 = $thiz.pure__O__O(a);
      return $n($x_1).apply__O__O(new $c_Lcats_effect_kernel_Outcome$Succeeded(fa$1));
    }));
    return $f_Lcats_FlatMap__flatTap__O__F1__O($thiz, handled, f);
  })));
}
function $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O($thiz, acquire, use, release) {
  return $thiz.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var target = $n(acquire).apply__O__O(poll$1);
    var this$4 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, $thiz);
    var f = new $c_sjsr_AnonFunction1(((a) => {
      var fa = $thiz.unit__O();
      return $thiz.guaranteeCase__O__F1__O($n(poll$1).apply__O__O($m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa, new $c_sjsr_AnonFunction0((() => $n(use).apply__O__O(a))), $thiz)), new $c_sjsr_AnonFunction1(((_$6) => {
        var _$6$1 = $as_Lcats_effect_kernel_Outcome(_$6);
        return $n(release).apply__O__O__O(a, _$6$1);
      })));
    }));
    return $n(this$4.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$4.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  })));
}
/** @constructor */
function $c_Lcats_kernel_instances_ByteOrder() {
}
$c_Lcats_kernel_instances_ByteOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_ByteOrder.prototype.constructor = $c_Lcats_kernel_instances_ByteOrder;
/** @constructor */
function $h_Lcats_kernel_instances_ByteOrder() {
}
$h_Lcats_kernel_instances_ByteOrder.prototype = $c_Lcats_kernel_instances_ByteOrder.prototype;
$c_Lcats_kernel_instances_ByteOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_ByteOrder.prototype.toOrdering__s_math_Ordering = (function() {
  return new $c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_instances_ByteOrder.prototype.compare__B__B__I = (function(x, y) {
  return ((x < y) ? (-1) : ((x > y) ? 1 : 0));
});
$c_Lcats_kernel_instances_ByteOrder.prototype.eqv__B__B__Z = (function(x, y) {
  return (x === y);
});
$c_Lcats_kernel_instances_ByteOrder.prototype.gt__B__B__Z = (function(x, y) {
  return (x > y);
});
$c_Lcats_kernel_instances_ByteOrder.prototype.max__B__B__B = (function(x, y) {
  var a = x;
  var b = y;
  return ((((a > b) ? a : b) << 24) >> 24);
});
$c_Lcats_kernel_instances_ByteOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $uB(x);
  return x$1;
});
$c_Lcats_kernel_instances_ByteOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__B__B__I($uB(x), $uB(y));
});
$c_Lcats_kernel_instances_ByteOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__B__B__Z($uB(x), $uB(y));
});
$c_Lcats_kernel_instances_ByteOrder.prototype.gt__O__O__Z = (function(x, y) {
  return this.gt__B__B__Z($uB(x), $uB(y));
});
$c_Lcats_kernel_instances_ByteOrder.prototype.max__O__O__O = (function(x, y) {
  return this.max__B__B__B($uB(x), $uB(y));
});
var $d_Lcats_kernel_instances_ByteOrder = new $TypeData().initClass($c_Lcats_kernel_instances_ByteOrder, "cats.kernel.instances.ByteOrder", ({
  Lcats_kernel_instances_ByteOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_ByteBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_ByteEnumerable: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_CharOrder() {
}
$c_Lcats_kernel_instances_CharOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_CharOrder.prototype.constructor = $c_Lcats_kernel_instances_CharOrder;
/** @constructor */
function $h_Lcats_kernel_instances_CharOrder() {
}
$h_Lcats_kernel_instances_CharOrder.prototype = $c_Lcats_kernel_instances_CharOrder.prototype;
$c_Lcats_kernel_instances_CharOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_CharOrder.prototype.max__O__O__O = (function(x, y) {
  return $f_Lcats_kernel_Order__max__O__O__O(this, x, y);
});
$c_Lcats_kernel_instances_CharOrder.prototype.toOrdering__s_math_Ordering = (function() {
  return new $c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_instances_CharOrder.prototype.compare__C__C__I = (function(x, y) {
  return ((x < y) ? (-1) : ((x > y) ? 1 : 0));
});
$c_Lcats_kernel_instances_CharOrder.prototype.eqv__C__C__Z = (function(x, y) {
  return (x === y);
});
$c_Lcats_kernel_instances_CharOrder.prototype.gt__C__C__Z = (function(x, y) {
  return (x > y);
});
$c_Lcats_kernel_instances_CharOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $uC(x);
  return x$1;
});
$c_Lcats_kernel_instances_CharOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__C__C__I($uC(x), $uC(y));
});
$c_Lcats_kernel_instances_CharOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__C__C__Z($uC(x), $uC(y));
});
$c_Lcats_kernel_instances_CharOrder.prototype.gt__O__O__Z = (function(x, y) {
  return this.gt__C__C__Z($uC(x), $uC(y));
});
var $d_Lcats_kernel_instances_CharOrder = new $TypeData().initClass($c_Lcats_kernel_instances_CharOrder, "cats.kernel.instances.CharOrder", ({
  Lcats_kernel_instances_CharOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_CharBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_CharEnumerable: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_IntOrder() {
}
$c_Lcats_kernel_instances_IntOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_IntOrder.prototype.constructor = $c_Lcats_kernel_instances_IntOrder;
/** @constructor */
function $h_Lcats_kernel_instances_IntOrder() {
}
$h_Lcats_kernel_instances_IntOrder.prototype = $c_Lcats_kernel_instances_IntOrder.prototype;
$c_Lcats_kernel_instances_IntOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_IntOrder.prototype.toOrdering__s_math_Ordering = (function() {
  return new $c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_instances_IntOrder.prototype.compare__I__I__I = (function(x, y) {
  return ((x < y) ? (-1) : ((x > y) ? 1 : 0));
});
$c_Lcats_kernel_instances_IntOrder.prototype.eqv__I__I__Z = (function(x, y) {
  return (x === y);
});
$c_Lcats_kernel_instances_IntOrder.prototype.gt__I__I__Z = (function(x, y) {
  return (x > y);
});
$c_Lcats_kernel_instances_IntOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $uI(x);
  return x$1;
});
$c_Lcats_kernel_instances_IntOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__I__I__I($uI(x), $uI(y));
});
$c_Lcats_kernel_instances_IntOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__I__I__Z($uI(x), $uI(y));
});
$c_Lcats_kernel_instances_IntOrder.prototype.gt__O__O__Z = (function(x, y) {
  return this.gt__I__I__Z($uI(x), $uI(y));
});
$c_Lcats_kernel_instances_IntOrder.prototype.max__O__O__O = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return ((x$1 > y$1) ? x$1 : y$1);
});
var $d_Lcats_kernel_instances_IntOrder = new $TypeData().initClass($c_Lcats_kernel_instances_IntOrder, "cats.kernel.instances.IntOrder", ({
  Lcats_kernel_instances_IntOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_IntBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_IntEnumerable: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_LongOrder() {
}
$c_Lcats_kernel_instances_LongOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_LongOrder.prototype.constructor = $c_Lcats_kernel_instances_LongOrder;
/** @constructor */
function $h_Lcats_kernel_instances_LongOrder() {
}
$h_Lcats_kernel_instances_LongOrder.prototype = $c_Lcats_kernel_instances_LongOrder.prototype;
$c_Lcats_kernel_instances_LongOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_LongOrder.prototype.toOrdering__s_math_Ordering = (function() {
  return new $c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_instances_LongOrder.prototype.compare__J__J__I = (function(x, y) {
  var ahi = x.RTLong__f_hi;
  var bhi = y.RTLong__f_hi;
  if (((ahi === bhi) ? (((-2147483648) ^ x.RTLong__f_lo) < ((-2147483648) ^ y.RTLong__f_lo)) : (ahi < bhi))) {
    return (-1);
  } else {
    var ahi$1 = x.RTLong__f_hi;
    var bhi$1 = y.RTLong__f_hi;
    if (((ahi$1 === bhi$1) ? (((-2147483648) ^ x.RTLong__f_lo) > ((-2147483648) ^ y.RTLong__f_lo)) : (ahi$1 > bhi$1))) {
      return 1;
    } else {
      return 0;
    }
  }
});
$c_Lcats_kernel_instances_LongOrder.prototype.eqv__J__J__Z = (function(x, y) {
  return ((x.RTLong__f_lo === y.RTLong__f_lo) && (x.RTLong__f_hi === y.RTLong__f_hi));
});
$c_Lcats_kernel_instances_LongOrder.prototype.gt__J__J__Z = (function(x, y) {
  var ahi = x.RTLong__f_hi;
  var bhi = y.RTLong__f_hi;
  return ((ahi === bhi) ? (((-2147483648) ^ x.RTLong__f_lo) > ((-2147483648) ^ y.RTLong__f_lo)) : (ahi > bhi));
});
$c_Lcats_kernel_instances_LongOrder.prototype.hash__O__I = (function(x) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return (lo ^ hi);
});
$c_Lcats_kernel_instances_LongOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__J__J__I($uJ(x), $uJ(y));
});
$c_Lcats_kernel_instances_LongOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__J__J__Z($uJ(x), $uJ(y));
});
$c_Lcats_kernel_instances_LongOrder.prototype.gt__O__O__Z = (function(x, y) {
  return this.gt__J__J__Z($uJ(x), $uJ(y));
});
$c_Lcats_kernel_instances_LongOrder.prototype.max__O__O__O = (function(x, y) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(y);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return (((hi === hi$1) ? (((-2147483648) ^ lo) > ((-2147483648) ^ lo$1)) : (hi > hi$1)) ? new $c_RTLong(lo, hi) : new $c_RTLong(lo$1, hi$1));
});
var $d_Lcats_kernel_instances_LongOrder = new $TypeData().initClass($c_Lcats_kernel_instances_LongOrder, "cats.kernel.instances.LongOrder", ({
  Lcats_kernel_instances_LongOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_instances_LongBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_LongEnumerable: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_ShortOrder() {
}
$c_Lcats_kernel_instances_ShortOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_ShortOrder.prototype.constructor = $c_Lcats_kernel_instances_ShortOrder;
/** @constructor */
function $h_Lcats_kernel_instances_ShortOrder() {
}
$h_Lcats_kernel_instances_ShortOrder.prototype = $c_Lcats_kernel_instances_ShortOrder.prototype;
$c_Lcats_kernel_instances_ShortOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_ShortOrder.prototype.toOrdering__s_math_Ordering = (function() {
  return new $c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_instances_ShortOrder.prototype.compare__S__S__I = (function(x, y) {
  return ((x < y) ? (-1) : ((x > y) ? 1 : 0));
});
$c_Lcats_kernel_instances_ShortOrder.prototype.eqv__S__S__Z = (function(x, y) {
  return (x === y);
});
$c_Lcats_kernel_instances_ShortOrder.prototype.gt__S__S__Z = (function(x, y) {
  return (x > y);
});
$c_Lcats_kernel_instances_ShortOrder.prototype.max__S__S__S = (function(x, y) {
  var a = x;
  var b = y;
  return ((((a > b) ? a : b) << 16) >> 16);
});
$c_Lcats_kernel_instances_ShortOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $uS(x);
  return x$1;
});
$c_Lcats_kernel_instances_ShortOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__S__S__I($uS(x), $uS(y));
});
$c_Lcats_kernel_instances_ShortOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__S__S__Z($uS(x), $uS(y));
});
$c_Lcats_kernel_instances_ShortOrder.prototype.gt__O__O__Z = (function(x, y) {
  return this.gt__S__S__Z($uS(x), $uS(y));
});
$c_Lcats_kernel_instances_ShortOrder.prototype.max__O__O__O = (function(x, y) {
  return this.max__S__S__S($uS(x), $uS(y));
});
var $d_Lcats_kernel_instances_ShortOrder = new $TypeData().initClass($c_Lcats_kernel_instances_ShortOrder, "cats.kernel.instances.ShortOrder", ({
  Lcats_kernel_instances_ShortOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_ShortBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_ShortEnumerable: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_UnitOrder() {
}
$c_Lcats_kernel_instances_UnitOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_UnitOrder.prototype.constructor = $c_Lcats_kernel_instances_UnitOrder;
/** @constructor */
function $h_Lcats_kernel_instances_UnitOrder() {
}
$h_Lcats_kernel_instances_UnitOrder.prototype = $c_Lcats_kernel_instances_UnitOrder.prototype;
$c_Lcats_kernel_instances_UnitOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_UnitOrder.prototype.toOrdering__s_math_Ordering = (function() {
  return new $c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_instances_UnitOrder.prototype.compare__O__O__I = (function(x, y) {
  $as_jl_Void(x);
  $as_jl_Void(y);
  return 0;
});
$c_Lcats_kernel_instances_UnitOrder.prototype.hash__O__I = (function(x) {
  $as_jl_Void(x);
  return 0;
});
$c_Lcats_kernel_instances_UnitOrder.prototype.eqv__O__O__Z = (function(x, y) {
  $as_jl_Void(x);
  $as_jl_Void(y);
  return true;
});
$c_Lcats_kernel_instances_UnitOrder.prototype.gt__O__O__Z = (function(x, y) {
  $as_jl_Void(x);
  $as_jl_Void(y);
  return false;
});
$c_Lcats_kernel_instances_UnitOrder.prototype.max__O__O__O = (function(x, y) {
  $as_jl_Void(x);
  $as_jl_Void(y);
});
var $d_Lcats_kernel_instances_UnitOrder = new $TypeData().initClass($c_Lcats_kernel_instances_UnitOrder, "cats.kernel.instances.UnitOrder", ({
  Lcats_kernel_instances_UnitOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_UnitBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_UnitEnumerable: 1
}));
/** @constructor */
function $c_sc_AbstractIndexedSeqView() {
}
$c_sc_AbstractIndexedSeqView.prototype = new $h_sc_AbstractSeqView();
$c_sc_AbstractIndexedSeqView.prototype.constructor = $c_sc_AbstractIndexedSeqView;
/** @constructor */
function $h_sc_AbstractIndexedSeqView() {
}
$h_sc_AbstractIndexedSeqView.prototype = $c_sc_AbstractIndexedSeqView.prototype;
$c_sc_AbstractIndexedSeqView.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$c_sc_AbstractIndexedSeqView.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$c_sc_AbstractIndexedSeqView.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$c_sc_AbstractIndexedSeqView.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this);
});
$c_sc_AbstractIndexedSeqView.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n);
});
$c_sc_AbstractIndexedSeqView.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$c_sc_AbstractIndexedSeqView.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_AbstractIndexedSeqView.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_AbstractIndexedSeqView.prototype.reverse__sc_IndexedSeqView = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_AbstractIndexedSeqView.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView";
});
$c_sc_AbstractIndexedSeqView.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_AbstractIndexedSeqView.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sc_AbstractIndexedSeqView.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sc_AbstractIndexedSeqView.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sc_AbstractIndexedSeqView.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sc_AbstractIndexedSeqView.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sc_AbstractIndexedSeqView.prototype.reverse__sc_SeqView = (function() {
  return this.reverse__sc_IndexedSeqView();
});
$c_sc_AbstractIndexedSeqView.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView();
});
$c_sc_AbstractIndexedSeqView.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_AbstractIndexedSeqView.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_AbstractIndexedSeqView.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_AbstractIndexedSeqView.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_AbstractIndexedSeqView.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_AbstractIndexedSeqView.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_AbstractIndexedSeqView.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_AbstractIndexedSeqView.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_AbstractIndexedSeqView.prototype.prepended__O__sc_SeqView = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem);
});
$c_sc_AbstractIndexedSeqView.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem);
});
$c_sc_AbstractIndexedSeqView.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
$c_sc_AbstractIndexedSeqView.prototype.appended__O__sc_SeqView = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
function $is_sc_BitSet(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_BitSet)));
}
function $as_sc_BitSet(obj) {
  return (($is_sc_BitSet(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.BitSet"));
}
function $isArrayOf_sc_BitSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_BitSet)));
}
function $asArrayOf_sc_BitSet(obj, depth) {
  return (($isArrayOf_sc_BitSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.BitSet;", depth));
}
/** @constructor */
function $c_sc_MapOps$KeySet(outer) {
  this.sc_MapOps$KeySet__f_$outer = null;
  $n(outer);
  this.sc_MapOps$KeySet__f_$outer = outer;
}
$c_sc_MapOps$KeySet.prototype = new $h_sc_AbstractSet();
$c_sc_MapOps$KeySet.prototype.constructor = $c_sc_MapOps$KeySet;
/** @constructor */
function $h_sc_MapOps$KeySet() {
}
$h_sc_MapOps$KeySet.prototype = $c_sc_MapOps$KeySet.prototype;
$c_sc_MapOps$KeySet.prototype.iterator__sc_Iterator = (function() {
  return $n(this.sc_MapOps$KeySet__f_$outer).keysIterator__sc_Iterator();
});
$c_sc_MapOps$KeySet.prototype.contains__O__Z = (function(key) {
  return $n(this.sc_MapOps$KeySet__f_$outer).contains__O__Z(key);
});
$c_sc_MapOps$KeySet.prototype.size__I = (function() {
  return $n(this.sc_MapOps$KeySet__f_$outer).size__I();
});
$c_sc_MapOps$KeySet.prototype.knownSize__I = (function() {
  return $n(this.sc_MapOps$KeySet__f_$outer).knownSize__I();
});
$c_sc_MapOps$KeySet.prototype.isEmpty__Z = (function() {
  return $n(this.sc_MapOps$KeySet__f_$outer).isEmpty__Z();
});
var $d_sc_MapOps$KeySet = new $TypeData().initClass($c_sc_MapOps$KeySet, "scala.collection.MapOps$KeySet", ({
  sc_MapOps$KeySet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sc_MapOps$GenKeySet: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_MapView$$anon$1() {
}
$c_sc_MapView$$anon$1.prototype = new $h_sc_AbstractMapView();
$c_sc_MapView$$anon$1.prototype.constructor = $c_sc_MapView$$anon$1;
/** @constructor */
function $h_sc_MapView$$anon$1() {
}
$h_sc_MapView$$anon$1.prototype = $c_sc_MapView$$anon$1.prototype;
$c_sc_MapView$$anon$1.prototype.get__O__s_Option = (function(key) {
  return $m_s_None$();
});
$c_sc_MapView$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
});
$c_sc_MapView$$anon$1.prototype.knownSize__I = (function() {
  return 0;
});
$c_sc_MapView$$anon$1.prototype.isEmpty__Z = (function() {
  return true;
});
$c_sc_MapView$$anon$1.prototype.filter__F1__sc_MapView = (function(pred) {
  return this;
});
$c_sc_MapView$$anon$1.prototype.filterNot__F1__sc_MapView = (function(pred) {
  return this;
});
$c_sc_MapView$$anon$1.prototype.partition__F1__T2 = (function(p) {
  return new $c_T2(this, this);
});
$c_sc_MapView$$anon$1.prototype.filterNot__F1__O = (function(pred) {
  return this;
});
$c_sc_MapView$$anon$1.prototype.filter__F1__O = (function(pred) {
  return this;
});
var $d_sc_MapView$$anon$1 = new $TypeData().initClass($c_sc_MapView$$anon$1, "scala.collection.MapView$$anon$1", ({
  sc_MapView$$anon$1: 1,
  sc_AbstractMapView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_MapView: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1
}));
/** @constructor */
function $c_sc_MapView$Filter(underlying, isFlipped, p) {
  this.sc_MapView$Filter__f_underlying = null;
  this.sc_MapView$Filter__f_isFlipped = false;
  this.sc_MapView$Filter__f_p = null;
  this.sc_MapView$Filter__f_underlying = underlying;
  this.sc_MapView$Filter__f_isFlipped = isFlipped;
  this.sc_MapView$Filter__f_p = p;
}
$c_sc_MapView$Filter.prototype = new $h_sc_AbstractMapView();
$c_sc_MapView$Filter.prototype.constructor = $c_sc_MapView$Filter;
/** @constructor */
function $h_sc_MapView$Filter() {
}
$h_sc_MapView$Filter.prototype = $c_sc_MapView$Filter.prototype;
$c_sc_MapView$Filter.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_MapView$Filter__f_underlying).iterator__sc_Iterator());
  var p = this.sc_MapView$Filter__f_p;
  var isFlipped = this.sc_MapView$Filter__f_isFlipped;
  return new $c_sc_Iterator$$anon$6(this$1, p, isFlipped);
});
$c_sc_MapView$Filter.prototype.get__O__s_Option = (function(key) {
  var x1 = $n(this.sc_MapView$Filter__f_underlying).get__O__s_Option(key);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var v = $n(x2).s_Some__f_value;
    if (($uZ($n(this.sc_MapView$Filter__f_p).apply__O__O(new $c_T2(key, v))) !== this.sc_MapView$Filter__f_isFlipped)) {
      return x2;
    }
  }
  return $m_s_None$();
});
$c_sc_MapView$Filter.prototype.knownSize__I = (function() {
  return (($n(this.sc_MapView$Filter__f_underlying).knownSize__I() === 0) ? 0 : (-1));
});
$c_sc_MapView$Filter.prototype.isEmpty__Z = (function() {
  var this$1 = $n(this.iterator__sc_Iterator());
  return (!this$1.hasNext__Z());
});
var $d_sc_MapView$Filter = new $TypeData().initClass($c_sc_MapView$Filter, "scala.collection.MapView$Filter", ({
  sc_MapView$Filter: 1,
  sc_AbstractMapView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_MapView: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1
}));
/** @constructor */
function $c_sc_MapView$Id(underlying) {
  this.sc_MapView$Id__f_underlying = null;
  this.sc_MapView$Id__f_underlying = underlying;
}
$c_sc_MapView$Id.prototype = new $h_sc_AbstractMapView();
$c_sc_MapView$Id.prototype.constructor = $c_sc_MapView$Id;
/** @constructor */
function $h_sc_MapView$Id() {
}
$h_sc_MapView$Id.prototype = $c_sc_MapView$Id.prototype;
$c_sc_MapView$Id.prototype.get__O__s_Option = (function(key) {
  return $n(this.sc_MapView$Id__f_underlying).get__O__s_Option(key);
});
$c_sc_MapView$Id.prototype.iterator__sc_Iterator = (function() {
  return $n(this.sc_MapView$Id__f_underlying).iterator__sc_Iterator();
});
$c_sc_MapView$Id.prototype.knownSize__I = (function() {
  return $n(this.sc_MapView$Id__f_underlying).knownSize__I();
});
$c_sc_MapView$Id.prototype.isEmpty__Z = (function() {
  return $n(this.sc_MapView$Id__f_underlying).isEmpty__Z();
});
var $d_sc_MapView$Id = new $TypeData().initClass($c_sc_MapView$Id, "scala.collection.MapView$Id", ({
  sc_MapView$Id: 1,
  sc_AbstractMapView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_MapView: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1
}));
/** @constructor */
function $c_sc_MapView$MapValues(underlying, f) {
  this.sc_MapView$MapValues__f_underlying = null;
  this.sc_MapView$MapValues__f_f = null;
  this.sc_MapView$MapValues__f_underlying = underlying;
  this.sc_MapView$MapValues__f_f = f;
}
$c_sc_MapView$MapValues.prototype = new $h_sc_AbstractMapView();
$c_sc_MapView$MapValues.prototype.constructor = $c_sc_MapView$MapValues;
/** @constructor */
function $h_sc_MapView$MapValues() {
}
$h_sc_MapView$MapValues.prototype = $c_sc_MapView$MapValues.prototype;
$c_sc_MapView$MapValues.prototype.iterator__sc_Iterator = (function() {
  var this$2 = $n($n(this.sc_MapView$MapValues__f_underlying).iterator__sc_Iterator());
  var f = new $c_sjsr_AnonFunction1(((kv$2) => {
    var kv = $as_T2(kv$2);
    return new $c_T2($n(kv)._1__O(), $n(this.sc_MapView$MapValues__f_f).apply__O__O($n(kv)._2__O()));
  }));
  return new $c_sc_Iterator$$anon$9(this$2, f);
});
$c_sc_MapView$MapValues.prototype.get__O__s_Option = (function(key) {
  var this$1 = $n($n(this.sc_MapView$MapValues__f_underlying).get__O__s_Option(key));
  var f = this.sc_MapView$MapValues__f_f;
  return (this$1.isEmpty__Z() ? $m_s_None$() : new $c_s_Some($n(f).apply__O__O(this$1.get__O())));
});
$c_sc_MapView$MapValues.prototype.knownSize__I = (function() {
  return $n(this.sc_MapView$MapValues__f_underlying).knownSize__I();
});
$c_sc_MapView$MapValues.prototype.isEmpty__Z = (function() {
  return $n(this.sc_MapView$MapValues__f_underlying).isEmpty__Z();
});
var $d_sc_MapView$MapValues = new $TypeData().initClass($c_sc_MapView$MapValues, "scala.collection.MapView$MapValues", ({
  sc_MapView$MapValues: 1,
  sc_AbstractMapView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_MapView: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1
}));
/** @constructor */
function $c_sci_AbstractSet() {
}
$c_sci_AbstractSet.prototype = new $h_sc_AbstractSet();
$c_sci_AbstractSet.prototype.constructor = $c_sci_AbstractSet;
/** @constructor */
function $h_sci_AbstractSet() {
}
$h_sci_AbstractSet.prototype = $c_sci_AbstractSet.prototype;
$c_sci_AbstractSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Set$();
});
function $is_Lcats_CommutativeMonad(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_CommutativeMonad)));
}
function $as_Lcats_CommutativeMonad(obj) {
  return (($is_Lcats_CommutativeMonad(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.CommutativeMonad"));
}
function $isArrayOf_Lcats_CommutativeMonad(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_CommutativeMonad)));
}
function $asArrayOf_Lcats_CommutativeMonad(obj, depth) {
  return (($isArrayOf_Lcats_CommutativeMonad(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.CommutativeMonad;", depth));
}
function $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__uncancelable__F1__Lcats_data_Kleisli($thiz, body) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((r) => $n($thiz.F__Lcats_effect_kernel_MonadCancel()).uncancelable__F1__O(new $c_sjsr_AnonFunction1(((nat) => {
    var nat$1 = $as_Lcats_effect_kernel_Poll(nat);
    var natT = new $c_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13(nat$1);
    return $n($n($as_Lcats_data_Kleisli($n(body).apply__O__O(natT))).Lcats_data_Kleisli__f_run).apply__O__O(r);
  })))));
  return new $c_Lcats_data_Kleisli(run);
}
function $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__canceled__Lcats_data_Kleisli($thiz) {
  var this$1 = $m_Lcats_data_Kleisli$();
  var x = $n($thiz.F__Lcats_effect_kernel_MonadCancel()).canceled__O();
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$1, x);
}
function $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__onCancel__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli($thiz, fa, fin) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((r) => $n($thiz.F__Lcats_effect_kernel_MonadCancel()).onCancel__O__O__O($n($n(fa).Lcats_data_Kleisli__f_run).apply__O__O(r), $n($n(fin).Lcats_data_Kleisli__f_run).apply__O__O(r))));
  return new $c_Lcats_data_Kleisli(run);
}
function $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__forceR__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli($thiz, fa, fb) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((r) => $n($thiz.F__Lcats_effect_kernel_MonadCancel()).forceR__O__O__O($n($n(fa).Lcats_data_Kleisli__f_run).apply__O__O(r), $n($n(fb).Lcats_data_Kleisli__f_run).apply__O__O(r))));
  return new $c_Lcats_data_Kleisli(run);
}
function $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__guaranteeCase__Lcats_data_Kleisli__F1__Lcats_data_Kleisli($thiz, fa, fin) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((r) => $n($thiz.F__Lcats_effect_kernel_MonadCancel()).guaranteeCase__O__F1__O($n($n(fa).Lcats_data_Kleisli__f_run).apply__O__O(r), new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_Lcats_effect_kernel_Outcome(x$1);
    if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
      var x$1$2 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$1);
      var this$3 = $n(x$1$2);
      var x69 = this$3.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
      var this$4 = $m_Lcats_data_Kleisli$();
      var fa$1 = $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$4, x69);
      return $n($n($as_Lcats_data_Kleisli($n(fin).apply__O__O(new $c_Lcats_effect_kernel_Outcome$Succeeded(fa$1)))).Lcats_data_Kleisli__f_run).apply__O__O(r);
    }
    if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
      var x$1$3 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$1);
      var this$8 = $n(x$1$3);
      var x66 = this$8.Lcats_effect_kernel_Outcome$Errored__f_e;
      var fa$2 = $n($n($as_Lcats_data_Kleisli($n(fin).apply__O__O(new $c_Lcats_effect_kernel_Outcome$Errored(x66)))).Lcats_data_Kleisli__f_run).apply__O__O(r);
      $thiz.F__Lcats_effect_kernel_MonadCancel();
      var f = new $c_sjsr_AnonFunction1(((_$51) => (void 0)));
      var F$1 = $thiz.F__Lcats_effect_kernel_MonadCancel();
      return $n(F$1).handleError__O__F1__O(fa$2, f);
    }
    if (((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$1), true))) {
      return $n($n($as_Lcats_data_Kleisli($n(fin).apply__O__O(new $c_Lcats_effect_kernel_Outcome$Canceled()))).Lcats_data_Kleisli__f_run).apply__O__O(r);
    }
    throw new $c_s_MatchError(x$1$1);
  })))));
  return new $c_Lcats_data_Kleisli(run);
}
function $f_Lfs2_Compiler$Target__compile__Lfs2_Pull__O__F2__O($thiz, p, init, foldChunk) {
  return $n($m_Lcats_effect_kernel_Resource$().makeCase__O__F2__Lcats_Functor__Lcats_effect_kernel_Resource($m_Lfs2_internal_Scope$().newRoot__Lfs2_Compiler$Target__O($thiz), new $c_sjsr_AnonFunction2(((scope, ec) => {
    var scope$1 = $as_Lfs2_internal_Scope(scope);
    var ec$1 = $as_Lcats_effect_kernel_Resource$ExitCase(ec);
    var fea = $n(scope$1).close__Lcats_effect_kernel_Resource$ExitCase__O(ec$1);
    $thiz.F__Lcats_effect_kernel_MonadCancel();
    return $m_Lcats_syntax_MonadErrorRethrowOps$().rethrow$extension__O__Lcats_MonadError__O(fea, $thiz.F__Lcats_effect_kernel_MonadCancel());
  })), $thiz.F__Lcats_effect_kernel_MonadCancel())).use__F1__Lcats_effect_kernel_MonadCancel__O(new $c_sjsr_AnonFunction1(((scope$2) => {
    var scope$3 = $as_Lfs2_internal_Scope(scope$2);
    return $m_Lfs2_Pull$().compile__Lfs2_Pull__Lfs2_internal_Scope__Z__O__F2__Lcats_MonadError__O(p, scope$3, false, init, foldChunk, $thiz.F__Lcats_effect_kernel_MonadCancel());
  })), $thiz.F__Lcats_effect_kernel_MonadCancel());
}
function $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__($thiz, underlying, elem) {
  $ct_sc_SeqView$Appended__sc_SeqOps__O__($thiz, underlying, elem);
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$Appended() {
  this.sc_View$Appended__f_underlying = null;
  this.sc_View$Appended__f_elem = null;
  this.sc_SeqView$Appended__f_underlying = null;
  this.sc_SeqView$Appended__f_elem = null;
}
$c_sc_IndexedSeqView$Appended.prototype = new $h_sc_SeqView$Appended();
$c_sc_IndexedSeqView$Appended.prototype.constructor = $c_sc_IndexedSeqView$Appended;
/** @constructor */
function $h_sc_IndexedSeqView$Appended() {
}
$h_sc_IndexedSeqView$Appended.prototype = $c_sc_IndexedSeqView$Appended.prototype;
$c_sc_IndexedSeqView$Appended.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$c_sc_IndexedSeqView$Appended.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$c_sc_IndexedSeqView$Appended.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$c_sc_IndexedSeqView$Appended.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this);
});
$c_sc_IndexedSeqView$Appended.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n);
});
$c_sc_IndexedSeqView$Appended.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$c_sc_IndexedSeqView$Appended.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_IndexedSeqView$Appended.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_IndexedSeqView$Appended.prototype.reverse__sc_IndexedSeqView = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Appended.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView";
});
$c_sc_IndexedSeqView$Appended.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Appended.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sc_IndexedSeqView$Appended.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sc_IndexedSeqView$Appended.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sc_IndexedSeqView$Appended.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sc_IndexedSeqView$Appended.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sc_IndexedSeqView$Appended.prototype.reverse__sc_SeqView = (function() {
  return this.reverse__sc_IndexedSeqView();
});
$c_sc_IndexedSeqView$Appended.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView();
});
$c_sc_IndexedSeqView$Appended.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Appended.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Appended.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Appended.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Appended.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Appended.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Appended.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Appended.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Appended.prototype.prepended__O__sc_SeqView = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$Appended.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$Appended.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$Appended.prototype.appended__O__sc_SeqView = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
var $d_sc_IndexedSeqView$Appended = new $TypeData().initClass($c_sc_IndexedSeqView$Appended, "scala.collection.IndexedSeqView$Appended", ({
  sc_IndexedSeqView$Appended: 1,
  sc_SeqView$Appended: 1,
  sc_View$Appended: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
}));
function $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__($thiz, underlying, n) {
  $ct_sc_SeqView$Drop__sc_SeqOps__I__($thiz, underlying, n);
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$Drop() {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0;
  this.sc_SeqView$Drop__f_underlying = null;
  this.sc_SeqView$Drop__f_n = 0;
}
$c_sc_IndexedSeqView$Drop.prototype = new $h_sc_SeqView$Drop();
$c_sc_IndexedSeqView$Drop.prototype.constructor = $c_sc_IndexedSeqView$Drop;
/** @constructor */
function $h_sc_IndexedSeqView$Drop() {
}
$h_sc_IndexedSeqView$Drop.prototype = $c_sc_IndexedSeqView$Drop.prototype;
$c_sc_IndexedSeqView$Drop.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$c_sc_IndexedSeqView$Drop.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$c_sc_IndexedSeqView$Drop.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$c_sc_IndexedSeqView$Drop.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this);
});
$c_sc_IndexedSeqView$Drop.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n);
});
$c_sc_IndexedSeqView$Drop.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$c_sc_IndexedSeqView$Drop.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_IndexedSeqView$Drop.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_IndexedSeqView$Drop.prototype.reverse__sc_IndexedSeqView = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Drop.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView";
});
$c_sc_IndexedSeqView$Drop.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Drop.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sc_IndexedSeqView$Drop.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sc_IndexedSeqView$Drop.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sc_IndexedSeqView$Drop.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sc_IndexedSeqView$Drop.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sc_IndexedSeqView$Drop.prototype.reverse__sc_SeqView = (function() {
  return this.reverse__sc_IndexedSeqView();
});
$c_sc_IndexedSeqView$Drop.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView();
});
$c_sc_IndexedSeqView$Drop.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Drop.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Drop.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Drop.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Drop.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Drop.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Drop.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Drop.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Drop.prototype.prepended__O__sc_SeqView = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$Drop.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$Drop.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$Drop.prototype.appended__O__sc_SeqView = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
var $d_sc_IndexedSeqView$Drop = new $TypeData().initClass($c_sc_IndexedSeqView$Drop, "scala.collection.IndexedSeqView$Drop", ({
  sc_IndexedSeqView$Drop: 1,
  sc_SeqView$Drop: 1,
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
}));
function $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__($thiz, underlying, n) {
  $ct_sc_SeqView$DropRight__sc_SeqOps__I__($thiz, underlying, n);
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$DropRight() {
  this.sc_View$DropRight__f_underlying = null;
  this.sc_View$DropRight__f_n = 0;
  this.sc_View$DropRight__f_normN = 0;
  this.sc_SeqView$DropRight__f_underlying = null;
  this.sc_SeqView$DropRight__f_len = 0;
}
$c_sc_IndexedSeqView$DropRight.prototype = new $h_sc_SeqView$DropRight();
$c_sc_IndexedSeqView$DropRight.prototype.constructor = $c_sc_IndexedSeqView$DropRight;
/** @constructor */
function $h_sc_IndexedSeqView$DropRight() {
}
$h_sc_IndexedSeqView$DropRight.prototype = $c_sc_IndexedSeqView$DropRight.prototype;
$c_sc_IndexedSeqView$DropRight.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$c_sc_IndexedSeqView$DropRight.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$c_sc_IndexedSeqView$DropRight.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$c_sc_IndexedSeqView$DropRight.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this);
});
$c_sc_IndexedSeqView$DropRight.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n);
});
$c_sc_IndexedSeqView$DropRight.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$c_sc_IndexedSeqView$DropRight.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_IndexedSeqView$DropRight.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_IndexedSeqView$DropRight.prototype.reverse__sc_IndexedSeqView = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$DropRight.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView";
});
$c_sc_IndexedSeqView$DropRight.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$DropRight.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sc_IndexedSeqView$DropRight.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sc_IndexedSeqView$DropRight.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sc_IndexedSeqView$DropRight.prototype.lengthCompare__I__I = (function(len) {
  var x = this.sc_SeqView$DropRight__f_len;
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sc_IndexedSeqView$DropRight.prototype.knownSize__I = (function() {
  return this.sc_SeqView$DropRight__f_len;
});
$c_sc_IndexedSeqView$DropRight.prototype.reverse__sc_SeqView = (function() {
  return this.reverse__sc_IndexedSeqView();
});
$c_sc_IndexedSeqView$DropRight.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView();
});
$c_sc_IndexedSeqView$DropRight.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$DropRight.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$DropRight.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$DropRight.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$DropRight.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$DropRight.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$DropRight.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$DropRight.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$DropRight.prototype.prepended__O__sc_SeqView = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$DropRight.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$DropRight.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$DropRight.prototype.appended__O__sc_SeqView = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
var $d_sc_IndexedSeqView$DropRight = new $TypeData().initClass($c_sc_IndexedSeqView$DropRight, "scala.collection.IndexedSeqView$DropRight", ({
  sc_IndexedSeqView$DropRight: 1,
  sc_SeqView$DropRight: 1,
  sc_View$DropRight: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
}));
/** @constructor */
function $c_sc_IndexedSeqView$Id(underlying) {
  this.sc_SeqView$Id__f_underlying = null;
  $ct_sc_SeqView$Id__sc_SeqOps__(this, underlying);
}
$c_sc_IndexedSeqView$Id.prototype = new $h_sc_SeqView$Id();
$c_sc_IndexedSeqView$Id.prototype.constructor = $c_sc_IndexedSeqView$Id;
/** @constructor */
function $h_sc_IndexedSeqView$Id() {
}
$h_sc_IndexedSeqView$Id.prototype = $c_sc_IndexedSeqView$Id.prototype;
$c_sc_IndexedSeqView$Id.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$c_sc_IndexedSeqView$Id.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$c_sc_IndexedSeqView$Id.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView";
});
$c_sc_IndexedSeqView$Id.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Id.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sc_IndexedSeqView$Id.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sc_IndexedSeqView$Id.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sc_IndexedSeqView$Id.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sc_IndexedSeqView$Id.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sc_IndexedSeqView$Id.prototype.reverse__sc_SeqView = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Id.prototype.reverse__O = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Id.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_IndexedSeqView$Id.prototype.map__F1__O = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_IndexedSeqView$Id.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_IndexedSeqView$Id.prototype.dropRight__I__O = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_IndexedSeqView$Id.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$c_sc_IndexedSeqView$Id.prototype.drop__I__O = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$c_sc_IndexedSeqView$Id.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n);
});
$c_sc_IndexedSeqView$Id.prototype.take__I__O = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n);
});
$c_sc_IndexedSeqView$Id.prototype.prepended__O__sc_SeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this);
});
$c_sc_IndexedSeqView$Id.prototype.prepended__O__O = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this);
});
$c_sc_IndexedSeqView$Id.prototype.appended__O__O = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$c_sc_IndexedSeqView$Id.prototype.appended__O__sc_SeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
var $d_sc_IndexedSeqView$Id = new $TypeData().initClass($c_sc_IndexedSeqView$Id, "scala.collection.IndexedSeqView$Id", ({
  sc_IndexedSeqView$Id: 1,
  sc_SeqView$Id: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
}));
function $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__($thiz, underlying, f) {
  $ct_sc_SeqView$Map__sc_SeqOps__F1__($thiz, underlying, f);
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$Map() {
  this.sc_View$Map__f_underlying = null;
  this.sc_View$Map__f_f = null;
  this.sc_SeqView$Map__f_underlying = null;
  this.sc_SeqView$Map__f_f = null;
}
$c_sc_IndexedSeqView$Map.prototype = new $h_sc_SeqView$Map();
$c_sc_IndexedSeqView$Map.prototype.constructor = $c_sc_IndexedSeqView$Map;
/** @constructor */
function $h_sc_IndexedSeqView$Map() {
}
$h_sc_IndexedSeqView$Map.prototype = $c_sc_IndexedSeqView$Map.prototype;
$c_sc_IndexedSeqView$Map.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$c_sc_IndexedSeqView$Map.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$c_sc_IndexedSeqView$Map.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$c_sc_IndexedSeqView$Map.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this);
});
$c_sc_IndexedSeqView$Map.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n);
});
$c_sc_IndexedSeqView$Map.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$c_sc_IndexedSeqView$Map.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_IndexedSeqView$Map.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_IndexedSeqView$Map.prototype.reverse__sc_IndexedSeqView = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Map.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView";
});
$c_sc_IndexedSeqView$Map.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Map.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sc_IndexedSeqView$Map.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sc_IndexedSeqView$Map.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sc_IndexedSeqView$Map.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sc_IndexedSeqView$Map.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sc_IndexedSeqView$Map.prototype.reverse__sc_SeqView = (function() {
  return this.reverse__sc_IndexedSeqView();
});
$c_sc_IndexedSeqView$Map.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView();
});
$c_sc_IndexedSeqView$Map.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Map.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Map.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Map.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Map.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Map.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Map.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Map.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Map.prototype.prepended__O__sc_SeqView = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$Map.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$Map.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$Map.prototype.appended__O__sc_SeqView = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
var $d_sc_IndexedSeqView$Map = new $TypeData().initClass($c_sc_IndexedSeqView$Map, "scala.collection.IndexedSeqView$Map", ({
  sc_IndexedSeqView$Map: 1,
  sc_SeqView$Map: 1,
  sc_View$Map: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
}));
function $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__($thiz, elem, underlying) {
  $ct_sc_SeqView$Prepended__O__sc_SeqOps__($thiz, elem, underlying);
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$Prepended() {
  this.sc_View$Prepended__f_elem = null;
  this.sc_View$Prepended__f_underlying = null;
  this.sc_SeqView$Prepended__f_elem = null;
  this.sc_SeqView$Prepended__f_underlying = null;
}
$c_sc_IndexedSeqView$Prepended.prototype = new $h_sc_SeqView$Prepended();
$c_sc_IndexedSeqView$Prepended.prototype.constructor = $c_sc_IndexedSeqView$Prepended;
/** @constructor */
function $h_sc_IndexedSeqView$Prepended() {
}
$h_sc_IndexedSeqView$Prepended.prototype = $c_sc_IndexedSeqView$Prepended.prototype;
$c_sc_IndexedSeqView$Prepended.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$c_sc_IndexedSeqView$Prepended.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$c_sc_IndexedSeqView$Prepended.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$c_sc_IndexedSeqView$Prepended.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this);
});
$c_sc_IndexedSeqView$Prepended.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n);
});
$c_sc_IndexedSeqView$Prepended.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$c_sc_IndexedSeqView$Prepended.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_IndexedSeqView$Prepended.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_IndexedSeqView$Prepended.prototype.reverse__sc_IndexedSeqView = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Prepended.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView";
});
$c_sc_IndexedSeqView$Prepended.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Prepended.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sc_IndexedSeqView$Prepended.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sc_IndexedSeqView$Prepended.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sc_IndexedSeqView$Prepended.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sc_IndexedSeqView$Prepended.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sc_IndexedSeqView$Prepended.prototype.reverse__sc_SeqView = (function() {
  return this.reverse__sc_IndexedSeqView();
});
$c_sc_IndexedSeqView$Prepended.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView();
});
$c_sc_IndexedSeqView$Prepended.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Prepended.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Prepended.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Prepended.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Prepended.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Prepended.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Prepended.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Prepended.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Prepended.prototype.prepended__O__sc_SeqView = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$Prepended.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$Prepended.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$Prepended.prototype.appended__O__sc_SeqView = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
var $d_sc_IndexedSeqView$Prepended = new $TypeData().initClass($c_sc_IndexedSeqView$Prepended, "scala.collection.IndexedSeqView$Prepended", ({
  sc_IndexedSeqView$Prepended: 1,
  sc_SeqView$Prepended: 1,
  sc_View$Prepended: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
}));
function $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__($thiz, underlying) {
  $thiz.sc_IndexedSeqView$Reverse__f_underlying = underlying;
  $ct_sc_SeqView$Reverse__sc_SeqOps__($thiz, underlying);
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$Reverse() {
  this.sc_SeqView$Reverse__f_underlying = null;
  this.sc_IndexedSeqView$Reverse__f_underlying = null;
}
$c_sc_IndexedSeqView$Reverse.prototype = new $h_sc_SeqView$Reverse();
$c_sc_IndexedSeqView$Reverse.prototype.constructor = $c_sc_IndexedSeqView$Reverse;
/** @constructor */
function $h_sc_IndexedSeqView$Reverse() {
}
$h_sc_IndexedSeqView$Reverse.prototype = $c_sc_IndexedSeqView$Reverse.prototype;
$c_sc_IndexedSeqView$Reverse.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$c_sc_IndexedSeqView$Reverse.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$c_sc_IndexedSeqView$Reverse.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$c_sc_IndexedSeqView$Reverse.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this);
});
$c_sc_IndexedSeqView$Reverse.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n);
});
$c_sc_IndexedSeqView$Reverse.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$c_sc_IndexedSeqView$Reverse.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_IndexedSeqView$Reverse.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_IndexedSeqView$Reverse.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView";
});
$c_sc_IndexedSeqView$Reverse.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Reverse.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sc_IndexedSeqView$Reverse.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sc_IndexedSeqView$Reverse.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sc_IndexedSeqView$Reverse.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sc_IndexedSeqView$Reverse.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sc_IndexedSeqView$Reverse.prototype.reverse__sc_IndexedSeqView = (function() {
  var x1 = this.sc_IndexedSeqView$Reverse__f_underlying;
  if ($is_sc_IndexedSeqView(x1)) {
    var x2 = $as_sc_IndexedSeqView(x1);
    return x2;
  } else {
    return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
  }
});
$c_sc_IndexedSeqView$Reverse.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Reverse.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Reverse.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Reverse.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Reverse.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Reverse.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Reverse.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Reverse.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Reverse.prototype.prepended__O__sc_SeqView = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$Reverse.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$Reverse.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$Reverse.prototype.appended__O__sc_SeqView = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$Reverse.prototype.reverse__sc_SeqView = (function() {
  return this.reverse__sc_IndexedSeqView();
});
$c_sc_IndexedSeqView$Reverse.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView();
});
var $d_sc_IndexedSeqView$Reverse = new $TypeData().initClass($c_sc_IndexedSeqView$Reverse, "scala.collection.IndexedSeqView$Reverse", ({
  sc_IndexedSeqView$Reverse: 1,
  sc_SeqView$Reverse: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
}));
function $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__($thiz, underlying, n) {
  $ct_sc_SeqView$Take__sc_SeqOps__I__($thiz, underlying, n);
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$Take() {
  this.sc_View$Take__f_underlying = null;
  this.sc_View$Take__f_n = 0;
  this.sc_View$Take__f_normN = 0;
  this.sc_SeqView$Take__f_underlying = null;
  this.sc_SeqView$Take__f_n = 0;
}
$c_sc_IndexedSeqView$Take.prototype = new $h_sc_SeqView$Take();
$c_sc_IndexedSeqView$Take.prototype.constructor = $c_sc_IndexedSeqView$Take;
/** @constructor */
function $h_sc_IndexedSeqView$Take() {
}
$h_sc_IndexedSeqView$Take.prototype = $c_sc_IndexedSeqView$Take.prototype;
$c_sc_IndexedSeqView$Take.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$c_sc_IndexedSeqView$Take.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$c_sc_IndexedSeqView$Take.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$c_sc_IndexedSeqView$Take.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Prepended(), elem, this);
});
$c_sc_IndexedSeqView$Take.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n);
});
$c_sc_IndexedSeqView$Take.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$c_sc_IndexedSeqView$Take.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_IndexedSeqView$Take.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_IndexedSeqView$Take.prototype.reverse__sc_IndexedSeqView = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Take.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView";
});
$c_sc_IndexedSeqView$Take.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Take.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sc_IndexedSeqView$Take.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sc_IndexedSeqView$Take.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sc_IndexedSeqView$Take.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sc_IndexedSeqView$Take.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sc_IndexedSeqView$Take.prototype.reverse__sc_SeqView = (function() {
  return this.reverse__sc_IndexedSeqView();
});
$c_sc_IndexedSeqView$Take.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView();
});
$c_sc_IndexedSeqView$Take.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Take.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Take.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Take.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Take.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Take.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Take.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Take.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Take.prototype.prepended__O__sc_SeqView = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$Take.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$Take.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$Take.prototype.appended__O__sc_SeqView = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
var $d_sc_IndexedSeqView$Take = new $TypeData().initClass($c_sc_IndexedSeqView$Take, "scala.collection.IndexedSeqView$Take", ({
  sc_IndexedSeqView$Take: 1,
  sc_SeqView$Take: 1,
  sc_View$Take: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
}));
/** @constructor */
function $c_sci_AbstractSeq() {
}
$c_sci_AbstractSeq.prototype = new $h_sc_AbstractSeq();
$c_sci_AbstractSeq.prototype.constructor = $c_sci_AbstractSeq;
/** @constructor */
function $h_sci_AbstractSeq() {
}
$h_sci_AbstractSeq.prototype = $c_sci_AbstractSeq.prototype;
$c_sci_AbstractSeq.prototype.toSeq__sci_Seq = (function() {
  return this;
});
/** @constructor */
function $c_scm_ArrayBufferView(underlying, mutationCount) {
  this.scm_ArrayBufferView__f_underlying = null;
  this.scm_ArrayBufferView__f_mutationCount = null;
  this.scm_ArrayBufferView__f_underlying = underlying;
  this.scm_ArrayBufferView__f_mutationCount = mutationCount;
}
$c_scm_ArrayBufferView.prototype = new $h_sc_AbstractIndexedSeqView();
$c_scm_ArrayBufferView.prototype.constructor = $c_scm_ArrayBufferView;
/** @constructor */
function $h_scm_ArrayBufferView() {
}
$h_scm_ArrayBufferView.prototype = $c_scm_ArrayBufferView.prototype;
$c_scm_ArrayBufferView.prototype.apply__I__O = (function(n) {
  return $n(this.scm_ArrayBufferView__f_underlying).apply__I__O(n);
});
$c_scm_ArrayBufferView.prototype.length__I = (function() {
  var this$1 = $n(this.scm_ArrayBufferView__f_underlying);
  return this$1.scm_ArrayBuffer__f_size0;
});
$c_scm_ArrayBufferView.prototype.className__T = (function() {
  return "ArrayBufferView";
});
$c_scm_ArrayBufferView.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_ArrayBufferView__f_mutationCount);
});
$c_scm_ArrayBufferView.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_ArrayBufferView__f_mutationCount);
});
$c_scm_ArrayBufferView.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_ArrayBufferView__f_mutationCount);
});
$c_scm_ArrayBufferView.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_ArrayBufferView__f_mutationCount);
});
$c_scm_ArrayBufferView.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_ArrayBufferView__f_mutationCount);
});
$c_scm_ArrayBufferView.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_ArrayBufferView__f_mutationCount);
});
$c_scm_ArrayBufferView.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_ArrayBufferView__f_mutationCount);
});
$c_scm_ArrayBufferView.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_ArrayBufferView__f_mutationCount);
});
$c_scm_ArrayBufferView.prototype.reverse__sc_IndexedSeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_ArrayBufferView__f_mutationCount);
});
$c_scm_ArrayBufferView.prototype.reverse__sc_SeqView = (function() {
  return this.reverse__sc_IndexedSeqView();
});
$c_scm_ArrayBufferView.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView();
});
$c_scm_ArrayBufferView.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_scm_ArrayBufferView.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_scm_ArrayBufferView.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_scm_ArrayBufferView.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_scm_ArrayBufferView.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_scm_ArrayBufferView.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_scm_ArrayBufferView.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_scm_ArrayBufferView.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_scm_ArrayBufferView.prototype.prepended__O__sc_SeqView = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem);
});
$c_scm_ArrayBufferView.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sc_IndexedSeqView(elem);
});
$c_scm_ArrayBufferView.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
$c_scm_ArrayBufferView.prototype.appended__O__sc_SeqView = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
var $d_scm_ArrayBufferView = new $TypeData().initClass($c_scm_ArrayBufferView, "scala.collection.mutable.ArrayBufferView", ({
  scm_ArrayBufferView: 1,
  sc_AbstractIndexedSeqView: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
}));
function $f_Lcats_effect_kernel_GenSpawn__background__O__Lcats_effect_kernel_Resource($thiz, fa) {
  return $n($m_Lcats_effect_kernel_Resource$().make__O__F1__Lcats_Functor__Lcats_effect_kernel_Resource($thiz.start__O__O(fa), new $c_sjsr_AnonFunction1(((_$2) => {
    var _$2$1 = $as_Lcats_effect_kernel_Fiber(_$2);
    return $n(_$2$1).cancel__O();
  })), $thiz)).map__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1(((_$3) => {
    var _$3$1 = $as_Lcats_effect_kernel_Fiber(_$3);
    return $n(_$3$1).join__O();
  })));
}
function $f_Lcats_effect_kernel_GenSpawn__raceOutcome__O__O__O($thiz, fa, fb) {
  return $thiz.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var target = $n(poll$1).apply__O__O($thiz.racePair__O__O__O(fa, fb));
    var this$9 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, $thiz);
    var f$1 = new $c_sjsr_AnonFunction1(((x$1) => {
      var x$1$1 = $as_s_util_Either(x$1);
      if ((x$1$1 instanceof $c_s_util_Left)) {
        var x7 = $as_T2($n($as_s_util_Left(x$1$1)).s_util_Left__f_value);
        if ((x7 !== null)) {
          var oc = $as_Lcats_effect_kernel_Outcome($n(x7)._1__O());
          var f = $as_Lcats_effect_kernel_Fiber($n(x7)._2__O());
          var target$1 = $n(f).cancel__O();
          var this$5 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, $thiz);
          var b = new $c_s_util_Left(oc);
          return $n(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b);
        }
      }
      if ((x$1$1 instanceof $c_s_util_Right)) {
        var x3 = $as_T2($n($as_s_util_Right(x$1$1)).s_util_Right__f_value);
        if ((x3 !== null)) {
          var f$2 = $as_Lcats_effect_kernel_Fiber($n(x3)._1__O());
          var oc$2 = $as_Lcats_effect_kernel_Outcome($n(x3)._2__O());
          var target$2 = $n(f$2).cancel__O();
          var this$8 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, $thiz);
          var b$1 = new $c_s_util_Right(oc$2);
          return $n(this$8.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$8.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b$1);
        }
      }
      throw new $c_s_MatchError(x$1$1);
    }));
    return $n(this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
  })));
}
function $f_Lcats_effect_kernel_GenSpawn__both__O__O__O($thiz, fa, fb) {
  return $thiz.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var target = $n(poll$1).apply__O__O($thiz.racePair__O__O__O(fa, fb));
    var this$55 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, $thiz);
    var f$4 = new $c_sjsr_AnonFunction1(((x$1) => {
      var x$1$1 = $as_s_util_Either(x$1);
      if ((x$1$1 instanceof $c_s_util_Left)) {
        var x98 = $as_T2($n($as_s_util_Left(x$1$1)).s_util_Left__f_value);
        if ((x98 !== null)) {
          var oc = $as_Lcats_effect_kernel_Outcome($n(x98)._1__O());
          var f = $as_Lcats_effect_kernel_Fiber($n(x98)._2__O());
          if ((oc instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
            var x$1$2 = $as_Lcats_effect_kernel_Outcome$Succeeded(oc);
            var this$4 = $n(x$1$2);
            var x75 = this$4.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
            var wrapped = $n(poll$1).apply__O__O($n(f).join__O());
            var fin = $n(f).cancel__O();
            var target$1 = $thiz.onCancel__O__O__O(wrapped, fin);
            var this$17 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, $thiz);
            var f$1 = new $c_sjsr_AnonFunction1(((x$1$2$1) => {
              var x$1$3 = $as_Lcats_effect_kernel_Outcome(x$1$2$1);
              if ((x$1$3 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
                var x$1$4 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$3);
                var this$9 = $n(x$1$4);
                var x67 = this$9.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
                var this$11 = new $c_Lcats_syntax_SemigroupalSyntax$$anon$1(x75, $thiz);
                return $n(this$11.Lcats_syntax_SemigroupalSyntax$$anon$1__f_typeClassInstance).product__O__O__O(this$11.Lcats_syntax_SemigroupalSyntax$$anon$1__f_self, x67);
              }
              if ((x$1$3 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
                var x$1$5 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$3);
                var this$13 = $n(x$1$5);
                var x64 = this$13.Lcats_effect_kernel_Outcome$Errored__f_e;
                return $thiz.raiseError__O__O(x64);
              }
              if (((x$1$3 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$3), true))) {
                var fa$1 = $n(poll$1).apply__O__O($thiz.canceled__O());
                var this$15 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$1, $thiz);
                var fb$1 = $thiz.never__O();
                var this$16 = $n(this$15.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
                var fa$2 = this$15.Lcats_syntax_ApplySyntax$$anon$1__f_self;
                return this$16.productR__O__O__O(fa$2, fb$1);
              }
              throw new $c_s_MatchError(x$1$3);
            }));
            return $n(this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
          }
          if ((oc instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
            var x$1$6 = $as_Lcats_effect_kernel_Outcome$Errored(oc);
            var this$19 = $n(x$1$6);
            var x72 = this$19.Lcats_effect_kernel_Outcome$Errored__f_e;
            var fa$3 = $n(f).cancel__O();
            var this$21 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$3, $thiz);
            var fb$2 = $thiz.raiseError__O__O(x72);
            var this$22 = $n(this$21.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
            var fa$4 = this$21.Lcats_syntax_ApplySyntax$$anon$1__f_self;
            return this$22.productR__O__O__O(fa$4, fb$2);
          }
          if (((oc instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(oc), true))) {
            var fa$5 = $n(f).cancel__O();
            var this$24 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$5, $thiz);
            var fb$3 = $n(poll$1).apply__O__O($thiz.canceled__O());
            var this$25 = $n(this$24.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
            var fa$6 = this$24.Lcats_syntax_ApplySyntax$$anon$1__f_self;
            var fa$7 = this$25.productR__O__O__O(fa$6, fb$3);
            var this$27 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$7, $thiz);
            var fb$4 = $thiz.never__O();
            var this$28 = $n(this$27.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
            var fa$8 = this$27.Lcats_syntax_ApplySyntax$$anon$1__f_self;
            return this$28.productR__O__O__O(fa$8, fb$4);
          }
          throw new $c_s_MatchError(oc);
        }
      }
      if ((x$1$1 instanceof $c_s_util_Right)) {
        var x94 = $as_T2($n($as_s_util_Right(x$1$1)).s_util_Right__f_value);
        if ((x94 !== null)) {
          var f$2 = $as_Lcats_effect_kernel_Fiber($n(x94)._1__O());
          var oc$2 = $as_Lcats_effect_kernel_Outcome($n(x94)._2__O());
          if ((oc$2 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
            var x$1$7 = $as_Lcats_effect_kernel_Outcome$Succeeded(oc$2);
            var this$30 = $n(x$1$7);
            var x91 = this$30.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
            var wrapped$1 = $n(poll$1).apply__O__O($n(f$2).join__O());
            var fin$1 = $n(f$2).cancel__O();
            var target$2 = $thiz.onCancel__O__O__O(wrapped$1, fin$1);
            var this$43 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, $thiz);
            var f$3 = new $c_sjsr_AnonFunction1(((x$1$3$1) => {
              var x$1$8 = $as_Lcats_effect_kernel_Outcome(x$1$3$1);
              if ((x$1$8 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
                var x$1$9 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$8);
                var this$35 = $n(x$1$9);
                var x83 = this$35.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
                var this$37 = new $c_Lcats_syntax_SemigroupalSyntax$$anon$1(x83, $thiz);
                return $n(this$37.Lcats_syntax_SemigroupalSyntax$$anon$1__f_typeClassInstance).product__O__O__O(this$37.Lcats_syntax_SemigroupalSyntax$$anon$1__f_self, x91);
              }
              if ((x$1$8 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
                var x$1$10 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$8);
                var this$39 = $n(x$1$10);
                var x80 = this$39.Lcats_effect_kernel_Outcome$Errored__f_e;
                return $thiz.raiseError__O__O(x80);
              }
              if (((x$1$8 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$8), true))) {
                var fa$9 = $n(poll$1).apply__O__O($thiz.canceled__O());
                var this$41 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$9, $thiz);
                var fb$5 = $thiz.never__O();
                var this$42 = $n(this$41.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
                var fa$10 = this$41.Lcats_syntax_ApplySyntax$$anon$1__f_self;
                return this$42.productR__O__O__O(fa$10, fb$5);
              }
              throw new $c_s_MatchError(x$1$8);
            }));
            return $n(this$43.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$43.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
          }
          if ((oc$2 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
            var x$1$11 = $as_Lcats_effect_kernel_Outcome$Errored(oc$2);
            var this$45 = $n(x$1$11);
            var x88 = this$45.Lcats_effect_kernel_Outcome$Errored__f_e;
            var fa$11 = $n(f$2).cancel__O();
            var this$47 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$11, $thiz);
            var fb$6 = $thiz.raiseError__O__O(x88);
            var this$48 = $n(this$47.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
            var fa$12 = this$47.Lcats_syntax_ApplySyntax$$anon$1__f_self;
            return this$48.productR__O__O__O(fa$12, fb$6);
          }
          if (((oc$2 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(oc$2), true))) {
            var fa$13 = $n(f$2).cancel__O();
            var this$50 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$13, $thiz);
            var fb$7 = $n(poll$1).apply__O__O($thiz.canceled__O());
            var this$51 = $n(this$50.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
            var fa$14 = this$50.Lcats_syntax_ApplySyntax$$anon$1__f_self;
            var fa$15 = this$51.productR__O__O__O(fa$14, fb$7);
            var this$53 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$15, $thiz);
            var fb$8 = $thiz.never__O();
            var this$54 = $n(this$53.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance);
            var fa$16 = this$53.Lcats_syntax_ApplySyntax$$anon$1__f_self;
            return this$54.productR__O__O__O(fa$16, fb$8);
          }
          throw new $c_s_MatchError(oc$2);
        }
      }
      throw new $c_s_MatchError(x$1$1);
    }));
    return $n(this$55.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$55.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$4);
  })));
}
function $is_Lcats_effect_kernel_GenSpawn(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_kernel_GenSpawn)));
}
function $as_Lcats_effect_kernel_GenSpawn(obj) {
  return (($is_Lcats_effect_kernel_GenSpawn(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.GenSpawn"));
}
function $isArrayOf_Lcats_effect_kernel_GenSpawn(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_GenSpawn)));
}
function $asArrayOf_Lcats_effect_kernel_GenSpawn(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_GenSpawn(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.GenSpawn;", depth));
}
/** @constructor */
function $c_Lcats_effect_kernel_MonadCancel$$anon$4(F0$10, cancel$10) {
  this.Lcats_effect_kernel_MonadCancel$$anon$4__f_cancel$3 = null;
  this.Lcats_effect_kernel_MonadCancel$$anon$4__f_cancel$3 = cancel$10;
}
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype = new $h_O();
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.constructor = $c_Lcats_effect_kernel_MonadCancel$$anon$4;
/** @constructor */
function $h_Lcats_effect_kernel_MonadCancel$$anon$4() {
}
$h_Lcats_effect_kernel_MonadCancel$$anon$4.prototype = $c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype;
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.unit__O = (function() {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_MonadCancel$$anon$4__f_cancel$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  var this$3 = $m_Lcats_data_Kleisli$();
  var F = this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$3, (void 0), F);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.guarantee__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O(this, fa, fin);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.F__Lcats_effect_kernel_MonadCancel = (function() {
  return this.Lcats_effect_kernel_MonadCancel$$anon$4__f_cancel$3;
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.uncancelable__F1__O = (function(body) {
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__uncancelable__F1__Lcats_data_Kleisli(this, body);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.canceled__O = (function() {
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__canceled__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.onCancel__O__O__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fin$1 = $as_Lcats_data_Kleisli(fin);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__onCancel__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fin$1);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.forceR__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__forceR__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__guaranteeCase__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this, fa$1, fin);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.pure__O__O = (function(x) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_MonadCancel$$anon$4__f_cancel$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  var this$3 = $m_Lcats_data_Kleisli$();
  var F = this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$3, x, F);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.raiseError__O__O = (function(e) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_MonadCancel$$anon$4__f_cancel$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliApplicativeError__raiseError__O__Lcats_data_Kleisli(this$2, e);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_MonadCancel$$anon$4__f_cancel$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliApplicativeError__handleErrorWith__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this$2, fa$1, f);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_MonadCancel$$anon$4__f_cancel$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $n(fa$1).flatMap__F1__Lcats_FlatMap__Lcats_data_Kleisli(f, this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.tailRecM__O__F1__O = (function(a, f) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_MonadCancel$$anon$4__f_cancel$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliFlatMap__tailRecM__O__F1__Lcats_data_Kleisli(this$2, a, f);
});
var $d_Lcats_effect_kernel_MonadCancel$$anon$4 = new $TypeData().initClass($c_Lcats_effect_kernel_MonadCancel$$anon$4, "cats.effect.kernel.MonadCancel$$anon$4", ({
  Lcats_effect_kernel_MonadCancel$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lcats_effect_kernel_MonadCancel$KleisliMonadCancel: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_ResourceMonadError() {
}
$c_Lcats_effect_kernel_ResourceMonadError.prototype = new $h_Lcats_effect_kernel_ResourceMonad();
$c_Lcats_effect_kernel_ResourceMonadError.prototype.constructor = $c_Lcats_effect_kernel_ResourceMonadError;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceMonadError() {
}
$h_Lcats_effect_kernel_ResourceMonadError.prototype = $c_Lcats_effect_kernel_ResourceMonadError.prototype;
$c_Lcats_effect_kernel_ResourceMonadError.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_ResourceMonadError.prototype.redeemWith__O__F1__F1__O = (function(fa, recover, bind) {
  return $f_Lcats_MonadError__redeemWith__O__F1__F1__O(this, fa, recover, bind);
});
$c_Lcats_effect_kernel_ResourceMonadError.prototype.attempt__O__O = (function(fa) {
  var fa$1 = $as_Lcats_effect_kernel_Resource(fa);
  return $n(fa$1).attempt__Lcats_ApplicativeError__Lcats_effect_kernel_Resource(this.F__Lcats_MonadError());
});
$c_Lcats_effect_kernel_ResourceMonadError.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_effect_kernel_Resource(fa);
  return $n(fa$1).handleErrorWith__F1__Lcats_ApplicativeError__Lcats_effect_kernel_Resource(f, this.F__Lcats_MonadError());
});
$c_Lcats_effect_kernel_ResourceMonadError.prototype.raiseError__O__O = (function(e) {
  return $m_Lcats_effect_kernel_Resource$().raiseError__O__Lcats_ApplicativeError__Lcats_effect_kernel_Resource(e, this.F__Lcats_MonadError());
});
/** @constructor */
function $c_Lfs2_Compiler$Target$ConcurrentTarget(F0) {
  this.Lfs2_Compiler$Target$ConcurrentTarget__f_F0 = null;
  this.Lfs2_Compiler$Target$ConcurrentTarget__f_F = null;
  this.Lfs2_Compiler$Target$ConcurrentTarget__f_F0 = F0;
  this.Lfs2_Compiler$Target$ConcurrentTarget__f_F = F0;
}
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype = new $h_O();
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.constructor = $c_Lfs2_Compiler$Target$ConcurrentTarget;
/** @constructor */
function $h_Lfs2_Compiler$Target$ConcurrentTarget() {
}
$h_Lfs2_Compiler$Target$ConcurrentTarget.prototype = $c_Lfs2_Compiler$Target$ConcurrentTarget.prototype;
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.unit__O = (function() {
  return $n(this.Lfs2_Compiler$Target$ConcurrentTarget__f_F).pure__O__O((void 0));
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.guarantee__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O(this, fa, fin);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guaranteeCase__O__F1__O(this, fa, fin);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.pure__O__O = (function(a) {
  return $n(this.Lfs2_Compiler$Target$ConcurrentTarget__f_F).pure__O__O(a);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return $n(this.Lfs2_Compiler$Target$ConcurrentTarget__f_F).handleErrorWith__O__F1__O(fa, f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.flatMap__O__F1__O = (function(fa, f) {
  return $n(this.Lfs2_Compiler$Target$ConcurrentTarget__f_F).flatMap__O__F1__O(fa, f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.tailRecM__O__F1__O = (function(a, f) {
  return $n(this.Lfs2_Compiler$Target$ConcurrentTarget__f_F).tailRecM__O__F1__O(a, f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.uncancelable__F1__O = (function(f) {
  return $n(this.Lfs2_Compiler$Target$ConcurrentTarget__f_F).uncancelable__F1__O(f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.canceled__O = (function() {
  return $n(this.Lfs2_Compiler$Target$ConcurrentTarget__f_F).canceled__O();
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.forceR__O__O__O = (function(fa, fb) {
  return $n(this.Lfs2_Compiler$Target$ConcurrentTarget__f_F).forceR__O__O__O(fa, fb);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.onCancel__O__O__O = (function(fa, fin) {
  return $n(this.Lfs2_Compiler$Target$ConcurrentTarget__f_F).onCancel__O__O__O(fa, fin);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.F__Lcats_effect_kernel_MonadCancel = (function() {
  return this.Lfs2_Compiler$Target$ConcurrentTarget__f_F;
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.unique__O = (function() {
  var F = this.Lfs2_Compiler$Target$ConcurrentTarget__f_F0;
  return $n(F).unique__O();
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.ref__O__O = (function(a) {
  return $n(this.Lfs2_Compiler$Target$ConcurrentTarget__f_F0).ref__O__O(a);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.interruptContext__Lcats_effect_kernel_Unique$Token__s_Option = (function(root) {
  var value = $m_Lfs2_internal_InterruptContext$().apply__Lcats_effect_kernel_Unique$Token__O__Lcats_effect_kernel_GenConcurrent__O(root, $n(this.Lfs2_Compiler$Target$ConcurrentTarget__f_F).unit__O(), this.Lfs2_Compiler$Target$ConcurrentTarget__f_F0);
  return new $c_s_Some(value);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.raiseError__O__O = (function(e) {
  var e$1 = $as_jl_Throwable(e);
  return $n(this.Lfs2_Compiler$Target$ConcurrentTarget__f_F).raiseError__O__O(e$1);
});
var $d_Lfs2_Compiler$Target$ConcurrentTarget = new $TypeData().initClass($c_Lfs2_Compiler$Target$ConcurrentTarget, "fs2.Compiler$Target$ConcurrentTarget", ({
  Lfs2_Compiler$Target$ConcurrentTarget: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lfs2_Compiler$Target: 1
}));
/** @constructor */
function $c_Lfs2_Compiler$TargetLowPriority$SyncTarget(F0) {
  this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F0 = null;
  this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F = null;
  this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F0 = F0;
  this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F = F0;
}
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype = new $h_O();
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.constructor = $c_Lfs2_Compiler$TargetLowPriority$SyncTarget;
/** @constructor */
function $h_Lfs2_Compiler$TargetLowPriority$SyncTarget() {
}
$h_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype = $c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype;
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.unit__O = (function() {
  return $n(this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F).pure__O__O((void 0));
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.guarantee__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O(this, fa, fin);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guaranteeCase__O__F1__O(this, fa, fin);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.pure__O__O = (function(a) {
  return $n(this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F).pure__O__O(a);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return $n(this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F).handleErrorWith__O__F1__O(fa, f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.flatMap__O__F1__O = (function(fa, f) {
  return $n(this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F).flatMap__O__F1__O(fa, f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.tailRecM__O__F1__O = (function(a, f) {
  return $n(this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F).tailRecM__O__F1__O(a, f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.uncancelable__F1__O = (function(f) {
  return $n(this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F).uncancelable__F1__O(f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.canceled__O = (function() {
  return $n(this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F).canceled__O();
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.forceR__O__O__O = (function(fa, fb) {
  return $n(this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F).forceR__O__O__O(fa, fb);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.onCancel__O__O__O = (function(fa, fin) {
  return $n(this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F).onCancel__O__O__O(fa, fin);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.F__Lcats_effect_kernel_MonadCancel = (function() {
  return this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F;
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.unique__O = (function() {
  var F = this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F0;
  return $n(F).unique__O();
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.ref__O__O = (function(a) {
  var F = this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F0;
  var mk = new $c_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2(F);
  return mk.refOf__O__O(a);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.interruptContext__Lcats_effect_kernel_Unique$Token__s_Option = (function(root) {
  return $m_s_None$();
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.raiseError__O__O = (function(e) {
  var e$1 = $as_jl_Throwable(e);
  return $n(this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F).raiseError__O__O(e$1);
});
var $d_Lfs2_Compiler$TargetLowPriority$SyncTarget = new $TypeData().initClass($c_Lfs2_Compiler$TargetLowPriority$SyncTarget, "fs2.Compiler$TargetLowPriority$SyncTarget", ({
  Lfs2_Compiler$TargetLowPriority$SyncTarget: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lfs2_Compiler$Target: 1
}));
/** @constructor */
function $c_sci_AbstractMap() {
}
$c_sci_AbstractMap.prototype = new $h_sc_AbstractMap();
$c_sci_AbstractMap.prototype.constructor = $c_sci_AbstractMap;
/** @constructor */
function $h_sci_AbstractMap() {
}
$h_sci_AbstractMap.prototype = $c_sci_AbstractMap.prototype;
$c_sci_AbstractMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_sci_Map$();
});
$c_sci_AbstractMap.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_sci_AbstractMap.prototype.removedAll__sc_IterableOnce__sci_MapOps = (function(keys) {
  return $f_sci_MapOps__removedAll__sc_IterableOnce__sci_MapOps(this, keys);
});
$c_sci_AbstractMap.prototype.keySet__sci_Set = (function() {
  return $ct_sci_MapOps$ImmutableKeySet__sci_MapOps__(new $c_sci_MapOps$ImmutableKeySet(), this);
});
$c_sci_AbstractMap.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Iterable$();
});
$c_sci_AbstractMap.prototype.keySet__sc_Set = (function() {
  return this.keySet__sci_Set();
});
function $f_sci_IndexedSeq__canEqual__O__Z($thiz, that) {
  if ((!$is_sci_IndexedSeq(that))) {
    return true;
  } else {
    var x2 = $as_sci_IndexedSeq(that);
    return ($thiz.length__I() === $n(x2).length__I());
  }
}
function $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z($thiz, o) {
  if ($is_sci_IndexedSeq(o)) {
    var x2 = $as_sci_IndexedSeq(o);
    if (($thiz === x2)) {
      return true;
    } else {
      var length = $thiz.length__I();
      var equal = (length === $n(x2).length__I());
      if (equal) {
        var index = 0;
        var a = $thiz.applyPreferredMaxLength__I();
        var b = $n(x2).applyPreferredMaxLength__I();
        var preferredLength = ((a < b) ? a : b);
        var hi = (length >> 31);
        var hi$1 = (preferredLength >> 31);
        var lo = (preferredLength << 1);
        var hi$2 = (((preferredLength >>> 31) | 0) | (hi$1 << 1));
        if (((hi === hi$2) ? (((-2147483648) ^ length) > ((-2147483648) ^ lo)) : (hi > hi$2))) {
          var maxApplyCompare = preferredLength;
        } else {
          var maxApplyCompare = length;
        }
        while (((index < maxApplyCompare) && equal)) {
          equal = $m_sr_BoxesRunTime$().equals__O__O__Z($thiz.apply__I__O(index), $n(x2).apply__I__O(index));
          index = ((1 + index) | 0);
        }
        if (((index < length) && equal)) {
          var thisIt = $n($thiz.iterator__sc_Iterator()).drop__I__sc_Iterator(index);
          var thatIt = $n($n(x2).iterator__sc_Iterator()).drop__I__sc_Iterator(index);
          while ((equal && $n(thisIt).hasNext__Z())) {
            equal = $m_sr_BoxesRunTime$().equals__O__O__Z($n(thisIt).next__O(), $n(thatIt).next__O());
          }
        }
      }
      return equal;
    }
  } else {
    return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, o);
  }
}
function $is_sci_IndexedSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_IndexedSeq)));
}
function $as_sci_IndexedSeq(obj) {
  return (($is_sci_IndexedSeq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.IndexedSeq"));
}
function $isArrayOf_sci_IndexedSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_IndexedSeq)));
}
function $asArrayOf_sci_IndexedSeq(obj, depth) {
  return (($isArrayOf_sci_IndexedSeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.IndexedSeq;", depth));
}
/** @constructor */
function $c_sci_Set$EmptySet$() {
}
$c_sci_Set$EmptySet$.prototype = new $h_sci_AbstractSet();
$c_sci_Set$EmptySet$.prototype.constructor = $c_sci_Set$EmptySet$;
/** @constructor */
function $h_sci_Set$EmptySet$() {
}
$h_sci_Set$EmptySet$.prototype = $c_sci_Set$EmptySet$.prototype;
$c_sci_Set$EmptySet$.prototype.size__I = (function() {
  return 0;
});
$c_sci_Set$EmptySet$.prototype.isEmpty__Z = (function() {
  return true;
});
$c_sci_Set$EmptySet$.prototype.knownSize__I = (function() {
  return 0;
});
$c_sci_Set$EmptySet$.prototype.subsetOf__sc_Set__Z = (function(that) {
  return true;
});
$c_sci_Set$EmptySet$.prototype.contains__O__Z = (function(elem) {
  return false;
});
$c_sci_Set$EmptySet$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
});
$c_sci_Set$EmptySet$.prototype.foreach__F1__V = (function(f) {
});
$c_sci_Set$EmptySet$.prototype.excl__O__sci_SetOps = (function(elem) {
  return this;
});
$c_sci_Set$EmptySet$.prototype.incl__O__sci_SetOps = (function(elem) {
  return new $c_sci_Set$Set1(elem);
});
$c_sci_Set$EmptySet$.prototype.filterNot__F1__O = (function(pred) {
  return this;
});
$c_sci_Set$EmptySet$.prototype.filter__F1__O = (function(pred) {
  return this;
});
var $d_sci_Set$EmptySet$ = new $TypeData().initClass($c_sci_Set$EmptySet$, "scala.collection.immutable.Set$EmptySet$", ({
  sci_Set$EmptySet$: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_Set$EmptySet$;
function $m_sci_Set$EmptySet$() {
  if ((!$n_sci_Set$EmptySet$)) {
    $n_sci_Set$EmptySet$ = new $c_sci_Set$EmptySet$();
  }
  return $n_sci_Set$EmptySet$;
}
/** @constructor */
function $c_Lcats_data_Kleisli$() {
  $ct_Lcats_data_KleisliInstances__(this);
}
$c_Lcats_data_Kleisli$.prototype = new $h_Lcats_data_KleisliInstances();
$c_Lcats_data_Kleisli$.prototype.constructor = $c_Lcats_data_Kleisli$;
/** @constructor */
function $h_Lcats_data_Kleisli$() {
}
$h_Lcats_data_Kleisli$.prototype = $c_Lcats_data_Kleisli$.prototype;
$c_Lcats_data_Kleisli$.prototype.shift__F1__Lcats_FlatMap__Lcats_data_Kleisli = (function(run, F) {
  if ($is_Lcats_Applicative(F)) {
    var ap = $as_Lcats_Applicative(F);
    $m_Lcats_data_Kleisli$();
    var run$1 = new $c_sjsr_AnonFunction1(((r) => $n(F).flatMap__O__F1__O($n(ap).pure__O__O(r), run)));
    return new $c_Lcats_data_Kleisli(run$1);
  } else {
    $m_Lcats_data_Kleisli$();
    return new $c_Lcats_data_Kleisli(run);
  }
});
var $d_Lcats_data_Kleisli$ = new $TypeData().initClass($c_Lcats_data_Kleisli$, "cats.data.Kleisli$", ({
  Lcats_data_Kleisli$: 1,
  Lcats_data_KleisliInstances: 1,
  Lcats_data_KleisliInstances0: 1,
  Lcats_data_KleisliInstances0\uff3f5: 1,
  Lcats_data_KleisliInstances1: 1,
  Lcats_data_KleisliInstances2: 1,
  Lcats_data_KleisliInstances3: 1,
  Lcats_data_KleisliInstances4: 1,
  Lcats_data_KleisliInstances5: 1,
  Lcats_data_KleisliInstances6: 1,
  Lcats_data_KleisliInstances7: 1,
  Lcats_data_KleisliInstances8: 1,
  Lcats_data_KleisliInstances9: 1,
  Lcats_data_KleisliFunctions: 1,
  Lcats_data_KleisliFunctionsBinCompat: 1,
  Lcats_data_KleisliExplicitInstances: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Lcats_data_Kleisli$;
function $m_Lcats_data_Kleisli$() {
  if ((!$n_Lcats_data_Kleisli$)) {
    $n_Lcats_data_Kleisli$ = new $c_Lcats_data_Kleisli$();
  }
  return $n_Lcats_data_Kleisli$;
}
function $f_Lcats_effect_kernel_GenConcurrent__racePair__O__O__O($thiz, fa, fb) {
  return $thiz.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var target = $thiz.deferred__O();
    var this$27 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, $thiz);
    var f$7 = new $c_sjsr_AnonFunction1(((result) => {
      var result$1 = $as_Lcats_effect_kernel_Deferred(result);
      var target$2 = $thiz.start__O__O($thiz.guaranteeCase__O__F1__O(fa, new $c_sjsr_AnonFunction1(((oc) => {
        var oc$1 = $as_Lcats_effect_kernel_Outcome(oc);
        var target$1 = $n(result$1).complete__O__O(new $c_s_util_Left(oc$1));
        var this$5 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, $thiz);
        return $n(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
      }))));
      var this$26 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, $thiz);
      var f$6 = new $c_sjsr_AnonFunction1(((fibA) => {
        var fibA$1 = $as_Lcats_effect_kernel_Fiber(fibA);
        var target$4 = $thiz.start__O__O($thiz.guaranteeCase__O__F1__O(fb, new $c_sjsr_AnonFunction1(((oc$2) => {
          var oc$3 = $as_Lcats_effect_kernel_Outcome(oc$2);
          var target$3 = $n(result$1).complete__O__O(new $c_s_util_Right(oc$3));
          var this$9 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, $thiz);
          return $n(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
        }))));
        var this$25 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$4, $thiz);
        var f$5 = new $c_sjsr_AnonFunction1(((fibB) => {
          var fibB$1 = $as_Lcats_effect_kernel_Fiber(fibB);
          var $x_1 = $n(poll$1).apply__O__O($n(result$1).get__O());
          var target$5 = $thiz.start__O__O($n(fibA$1).cancel__O());
          var this$18 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$5, $thiz);
          var f$3 = new $c_sjsr_AnonFunction1(((canA) => {
            var canA$1 = $as_Lcats_effect_kernel_Fiber(canA);
            var target$6 = $thiz.start__O__O($n(fibB$1).cancel__O());
            var this$17 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$6, $thiz);
            var f$2 = new $c_sjsr_AnonFunction1(((canB) => {
              var canB$1 = $as_Lcats_effect_kernel_Fiber(canB);
              var target$7 = $n(canA$1).join__O();
              var this$16 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$7, $thiz);
              var f$1 = new $c_sjsr_AnonFunction1(((x$1) => {
                $as_Lcats_effect_kernel_Outcome(x$1);
                var target$8 = $n(canB$1).join__O();
                var this$15 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$8, $thiz);
                var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
                  $as_Lcats_effect_kernel_Outcome(x$1$2);
                }));
                return $n(this$15.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$15.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
              }));
              return $n(this$16.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$16.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
            }));
            return $n(this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
          }));
          var target$9 = $thiz.onCancel__O__O__O($x_1, $n(this$18.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$18.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3));
          var this$24 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$9, $thiz);
          var f$4 = new $c_sjsr_AnonFunction1(((back) => {
            var back$1 = $as_s_util_Either(back);
            if ((back$1 instanceof $c_s_util_Left)) {
              var oc$4 = $as_Lcats_effect_kernel_Outcome($n($as_s_util_Left(back$1)).s_util_Left__f_value);
              var value = new $c_T2(oc$4, fibB$1);
              return new $c_s_util_Left(value);
            }
            if ((back$1 instanceof $c_s_util_Right)) {
              var oc$2$1 = $as_Lcats_effect_kernel_Outcome($n($as_s_util_Right(back$1)).s_util_Right__f_value);
              var value$1 = new $c_T2(fibA$1, oc$2$1);
              return new $c_s_util_Right(value$1);
            }
            throw new $c_s_MatchError(back$1);
          }));
          return $n(this$24.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$24.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$4);
        }));
        return $n(this$25.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$25.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$5);
      }));
      return $n(this$26.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$26.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$6);
    }));
    return $n(this$27.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$27.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$7);
  })));
}
function $is_Lcats_effect_kernel_GenConcurrent(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_kernel_GenConcurrent)));
}
function $as_Lcats_effect_kernel_GenConcurrent(obj) {
  return (($is_Lcats_effect_kernel_GenConcurrent(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.GenConcurrent"));
}
function $isArrayOf_Lcats_effect_kernel_GenConcurrent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_GenConcurrent)));
}
function $asArrayOf_Lcats_effect_kernel_GenConcurrent(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_GenConcurrent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.GenConcurrent;", depth));
}
/** @constructor */
function $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq(m) {
  this.Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq__f_m = null;
  this.Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq__f_m = m;
}
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype = new $h_O();
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.constructor = $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq;
/** @constructor */
function $h_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq() {
}
$h_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype = $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype;
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.find__F1__s_Option = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.filter__F1__O = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_IterableOps__partition__F1__T2(this, p);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.splitAt__I__T2 = (function(n) {
  return $f_sc_IterableOps__splitAt__I__T2(this, n);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.takeWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__takeWhile__F1__O(this, p);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.span__F1__T2 = (function(p) {
  return $f_sc_IterableOps__span__F1__T2(this, p);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.dropWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__dropWhile__F1__O(this, p);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.sliding__I__I__sc_Iterator = (function(size, step) {
  return $f_sc_IterableOps__sliding__I__I__sc_Iterator(this, size, step);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.init__O = (function() {
  return $f_sc_IterableOps__init__O(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.flatten__F1__O = (function(asIterable) {
  return $f_sc_IterableOps__flatMap__F1__O(this, asIterable);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_IterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_IterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.zipWithIndex__O = (function() {
  return $f_sc_IterableOps__zipWithIndex__O(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sci_IndexedSeq$().newBuilder__scm_Builder();
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.className__T = (function() {
  return "IndexedSeq";
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.orElse__s_PartialFunction__s_PartialFunction = (function(that) {
  return new $c_s_PartialFunction$OrElse(this, that);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.appended__O__O = (function(elem) {
  return $f_sc_SeqOps__appended__O__O(this, elem);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.prependedAll__sc_IterableOnce__O = (function(prefix) {
  return $f_sc_SeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $as_sci_IndexedSeq($f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix));
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $as_sci_IndexedSeq($f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix));
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.size__I = (function() {
  return this.length__I();
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.distinct__O = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.startsWith__sc_IterableOnce__I__Z = (function(that, offset) {
  return $f_sc_SeqOps__startsWith__sc_IterableOnce__I__Z(this, that, offset);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.startsWith$default$2__I = (function() {
  return 0;
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.padTo__I__O__O = (function(len, elem) {
  return $f_sc_SeqOps__padTo__I__O__O(this, len, elem);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = $n(this.iterator__sc_Iterator());
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.sizeCompare__I__I = (function(otherSize) {
  var x = this.length__I();
  return ((x === otherSize) ? 0 : ((x < otherSize) ? (-1) : 1));
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.equals__O__Z = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toSeq__sci_Seq = (function() {
  return this;
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.view__sc_IndexedSeqView = (function() {
  return new $c_sc_IndexedSeqView$Id(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.prepended__O__O = (function(elem) {
  return $f_sc_IndexedSeqOps__prepended__O__O(this, elem);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__dropRight__I__O(this, n);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.map__F1__O = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.reverse__O = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this;
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.applyPreferredMaxLength__I = (function() {
  return $m_sci_IndexedSeqDefaults$().sci_IndexedSeqDefaults$__f_defaultApplyPreferredMaxLength;
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.length__I = (function() {
  return $n(this.Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq__f_m).length__I();
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.apply__I__O = (function(i) {
  return $n(this.Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq__f_m).apply__I__O(i);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.iterator__sc_Iterator = (function() {
  return $n(this.Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq__f_m).iterator__sc_Iterator();
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1));
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_IndexedSeq$();
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.isDefinedAt__O__Z = (function(x) {
  var idx = $uI(x);
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sci_IndexedSeq$();
  return this$1.from__sc_IterableOnce__sci_IndexedSeq(coll);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__I__O(v1));
});
var $d_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq = new $TypeData().initClass($c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq, "cats.kernel.instances.StaticMethods$WrappedIndexedSeq", ({
  Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_IterableOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Iterable: 1,
  sci_Iterable: 1,
  F1: 1,
  s_PartialFunction: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sc_Seq: 1,
  sci_SeqOps: 1,
  sci_Seq: 1,
  sc_IndexedSeqOps: 1,
  sc_IndexedSeq: 1,
  sci_IndexedSeqOps: 1,
  sci_IndexedSeq: 1
}));
/** @constructor */
function $c_sc_StringView(s) {
  this.sc_StringView__f_s = null;
  this.sc_StringView__f_s = s;
}
$c_sc_StringView.prototype = new $h_sc_AbstractIndexedSeqView();
$c_sc_StringView.prototype.constructor = $c_sc_StringView;
/** @constructor */
function $h_sc_StringView() {
}
$h_sc_StringView.prototype = $c_sc_StringView.prototype;
$c_sc_StringView.prototype.length__I = (function() {
  var this$1 = $n(this.sc_StringView__f_s);
  return this$1.length;
});
$c_sc_StringView.prototype.toString__T = (function() {
  return (("StringView(" + this.sc_StringView__f_s) + ")");
});
$c_sc_StringView.prototype.productPrefix__T = (function() {
  return "StringView";
});
$c_sc_StringView.prototype.productArity__I = (function() {
  return 1;
});
$c_sc_StringView.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.sc_StringView__f_s : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_sc_StringView.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_sc_StringView.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false);
});
$c_sc_StringView.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_sc_StringView)) {
    var StringView$1 = $as_sc_StringView(x$1);
    return (this.sc_StringView__f_s === $n(StringView$1).sc_StringView__f_s);
  } else {
    return false;
  }
});
$c_sc_StringView.prototype.apply__I__O = (function(i) {
  var this$1 = $n(this.sc_StringView__f_s);
  return $bC($charAt(this$1, i));
});
function $as_sc_StringView(obj) {
  return (((obj instanceof $c_sc_StringView) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.StringView"));
}
function $isArrayOf_sc_StringView(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_StringView)));
}
function $asArrayOf_sc_StringView(obj, depth) {
  return (($isArrayOf_sc_StringView(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.StringView;", depth));
}
var $d_sc_StringView = new $TypeData().initClass($c_sc_StringView, "scala.collection.StringView", ({
  sc_StringView: 1,
  sc_AbstractIndexedSeqView: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  s_Product: 1,
  s_Equals: 1
}));
function $as_sci_SeqMap$SeqMap1(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SeqMap$SeqMap1"));
}
function $isArrayOf_sci_SeqMap$SeqMap1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SeqMap$SeqMap1)));
}
function $asArrayOf_sci_SeqMap$SeqMap1(obj, depth) {
  return (($isArrayOf_sci_SeqMap$SeqMap1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SeqMap$SeqMap1;", depth));
}
function $as_sci_SeqMap$SeqMap2(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SeqMap$SeqMap2"));
}
function $isArrayOf_sci_SeqMap$SeqMap2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SeqMap$SeqMap2)));
}
function $asArrayOf_sci_SeqMap$SeqMap2(obj, depth) {
  return (($isArrayOf_sci_SeqMap$SeqMap2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SeqMap$SeqMap2;", depth));
}
function $as_sci_SeqMap$SeqMap3(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SeqMap$SeqMap3"));
}
function $isArrayOf_sci_SeqMap$SeqMap3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SeqMap$SeqMap3)));
}
function $asArrayOf_sci_SeqMap$SeqMap3(obj, depth) {
  return (($isArrayOf_sci_SeqMap$SeqMap3(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SeqMap$SeqMap3;", depth));
}
function $as_sci_SeqMap$SeqMap4(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SeqMap$SeqMap4"));
}
function $isArrayOf_sci_SeqMap$SeqMap4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SeqMap$SeqMap4)));
}
function $asArrayOf_sci_SeqMap$SeqMap4(obj, depth) {
  return (($isArrayOf_sci_SeqMap$SeqMap4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SeqMap$SeqMap4;", depth));
}
/** @constructor */
function $c_sci_Set$Set1(elem1) {
  this.sci_Set$Set1__f_elem1 = null;
  this.sci_Set$Set1__f_elem1 = elem1;
}
$c_sci_Set$Set1.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set1.prototype.constructor = $c_sci_Set$Set1;
/** @constructor */
function $h_sci_Set$Set1() {
}
$h_sci_Set$Set1.prototype = $c_sci_Set$Set1.prototype;
$c_sci_Set$Set1.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_sci_Set$Set1.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Set$Set1.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_Set$Set1.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_sci_Set$Set1.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, false);
});
$c_sci_Set$Set1.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, true);
});
$c_sci_Set$Set1.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Set$Set1.prototype.size__I = (function() {
  return 1;
});
$c_sci_Set$Set1.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Set$Set1.prototype.knownSize__I = (function() {
  return 1;
});
$c_sci_Set$Set1.prototype.contains__O__Z = (function(elem) {
  return $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set1__f_elem1);
});
$c_sci_Set$Set1.prototype.incl__O__sci_Set = (function(elem) {
  return (this.contains__O__Z(elem) ? this : new $c_sci_Set$Set2(this.sci_Set$Set1__f_elem1, elem));
});
$c_sci_Set$Set1.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set1__f_elem1) ? $m_sci_Set$EmptySet$() : this);
});
$c_sci_Set$Set1.prototype.iterator__sc_Iterator = (function() {
  var a = this.sci_Set$Set1__f_elem1;
  return new $c_sc_Iterator$$anon$20(a);
});
$c_sci_Set$Set1.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O(this.sci_Set$Set1__f_elem1);
});
$c_sci_Set$Set1.prototype.exists__F1__Z = (function(p) {
  return $uZ($n(p).apply__O__O(this.sci_Set$Set1__f_elem1));
});
$c_sci_Set$Set1.prototype.forall__F1__Z = (function(p) {
  return $uZ($n(p).apply__O__O(this.sci_Set$Set1__f_elem1));
});
$c_sci_Set$Set1.prototype.filterImpl__F1__Z__sci_Set = (function(pred, isFlipped) {
  return (($uZ($n(pred).apply__O__O(this.sci_Set$Set1__f_elem1)) !== isFlipped) ? this : $m_sci_Set$EmptySet$());
});
$c_sci_Set$Set1.prototype.head__O = (function() {
  return this.sci_Set$Set1__f_elem1;
});
$c_sci_Set$Set1.prototype.tail__O = (function() {
  return $m_sci_Set$EmptySet$();
});
$c_sci_Set$Set1.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem);
});
$c_sci_Set$Set1.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem);
});
function $as_sci_Set$Set1(obj) {
  return (((obj instanceof $c_sci_Set$Set1) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Set$Set1"));
}
function $isArrayOf_sci_Set$Set1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Set$Set1)));
}
function $asArrayOf_sci_Set$Set1(obj, depth) {
  return (($isArrayOf_sci_Set$Set1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Set$Set1;", depth));
}
var $d_sci_Set$Set1 = new $TypeData().initClass($c_sci_Set$Set1, "scala.collection.immutable.Set$Set1", ({
  sci_Set$Set1: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Set$Set2(elem1, elem2) {
  this.sci_Set$Set2__f_elem1 = null;
  this.sci_Set$Set2__f_elem2 = null;
  this.sci_Set$Set2__f_elem1 = elem1;
  this.sci_Set$Set2__f_elem2 = elem2;
}
$c_sci_Set$Set2.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set2.prototype.constructor = $c_sci_Set$Set2;
/** @constructor */
function $h_sci_Set$Set2() {
}
$h_sci_Set$Set2.prototype = $c_sci_Set$Set2.prototype;
$c_sci_Set$Set2.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_sci_Set$Set2.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Set$Set2.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_Set$Set2.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_sci_Set$Set2.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, false);
});
$c_sci_Set$Set2.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, true);
});
$c_sci_Set$Set2.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Set$Set2.prototype.size__I = (function() {
  return 2;
});
$c_sci_Set$Set2.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Set$Set2.prototype.knownSize__I = (function() {
  return 2;
});
$c_sci_Set$Set2.prototype.contains__O__Z = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem1) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem2));
});
$c_sci_Set$Set2.prototype.incl__O__sci_Set = (function(elem) {
  return (this.contains__O__Z(elem) ? this : new $c_sci_Set$Set3(this.sci_Set$Set2__f_elem1, this.sci_Set$Set2__f_elem2, elem));
});
$c_sci_Set$Set2.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem1) ? new $c_sci_Set$Set1(this.sci_Set$Set2__f_elem2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem2) ? new $c_sci_Set$Set1(this.sci_Set$Set2__f_elem1) : this));
});
$c_sci_Set$Set2.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Set$Set2$$anon$1(this);
});
$c_sci_Set$Set2.prototype.scala$collection$immutable$Set$Set2$$getElem__I__O = (function(i) {
  switch (i) {
    case 0: {
      return this.sci_Set$Set2__f_elem1;
      break;
    }
    case 1: {
      return this.sci_Set$Set2__f_elem2;
      break;
    }
    default: {
      throw new $c_s_MatchError(i);
    }
  }
});
$c_sci_Set$Set2.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O(this.sci_Set$Set2__f_elem1);
  $n(f).apply__O__O(this.sci_Set$Set2__f_elem2);
});
$c_sci_Set$Set2.prototype.exists__F1__Z = (function(p) {
  return ($uZ($n(p).apply__O__O(this.sci_Set$Set2__f_elem1)) || $uZ($n(p).apply__O__O(this.sci_Set$Set2__f_elem2)));
});
$c_sci_Set$Set2.prototype.forall__F1__Z = (function(p) {
  return ($uZ($n(p).apply__O__O(this.sci_Set$Set2__f_elem1)) && $uZ($n(p).apply__O__O(this.sci_Set$Set2__f_elem2)));
});
$c_sci_Set$Set2.prototype.filterImpl__F1__Z__sci_Set = (function(pred, isFlipped) {
  var r1 = null;
  var n = 0;
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set2__f_elem1)) !== isFlipped)) {
    r1 = this.sci_Set$Set2__f_elem1;
    n = ((1 + n) | 0);
  }
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set2__f_elem2)) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.sci_Set$Set2__f_elem2;
    }
    n = ((1 + n) | 0);
  }
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Set$EmptySet$();
      break;
    }
    case 1: {
      return new $c_sci_Set$Set1(r1);
      break;
    }
    case 2: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
});
$c_sci_Set$Set2.prototype.head__O = (function() {
  return this.sci_Set$Set2__f_elem1;
});
$c_sci_Set$Set2.prototype.tail__sci_Set = (function() {
  return new $c_sci_Set$Set1(this.sci_Set$Set2__f_elem2);
});
$c_sci_Set$Set2.prototype.tail__O = (function() {
  return this.tail__sci_Set();
});
$c_sci_Set$Set2.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem);
});
$c_sci_Set$Set2.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem);
});
function $as_sci_Set$Set2(obj) {
  return (((obj instanceof $c_sci_Set$Set2) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Set$Set2"));
}
function $isArrayOf_sci_Set$Set2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Set$Set2)));
}
function $asArrayOf_sci_Set$Set2(obj, depth) {
  return (($isArrayOf_sci_Set$Set2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Set$Set2;", depth));
}
var $d_sci_Set$Set2 = new $TypeData().initClass($c_sci_Set$Set2, "scala.collection.immutable.Set$Set2", ({
  sci_Set$Set2: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Set$Set3(elem1, elem2, elem3) {
  this.sci_Set$Set3__f_elem1 = null;
  this.sci_Set$Set3__f_elem2 = null;
  this.sci_Set$Set3__f_elem3 = null;
  this.sci_Set$Set3__f_elem1 = elem1;
  this.sci_Set$Set3__f_elem2 = elem2;
  this.sci_Set$Set3__f_elem3 = elem3;
}
$c_sci_Set$Set3.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set3.prototype.constructor = $c_sci_Set$Set3;
/** @constructor */
function $h_sci_Set$Set3() {
}
$h_sci_Set$Set3.prototype = $c_sci_Set$Set3.prototype;
$c_sci_Set$Set3.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_sci_Set$Set3.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Set$Set3.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_Set$Set3.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_sci_Set$Set3.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, false);
});
$c_sci_Set$Set3.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, true);
});
$c_sci_Set$Set3.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Set$Set3.prototype.size__I = (function() {
  return 3;
});
$c_sci_Set$Set3.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Set$Set3.prototype.knownSize__I = (function() {
  return 3;
});
$c_sci_Set$Set3.prototype.contains__O__Z = (function(elem) {
  return (($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem1) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem3));
});
$c_sci_Set$Set3.prototype.incl__O__sci_Set = (function(elem) {
  return (this.contains__O__Z(elem) ? this : new $c_sci_Set$Set4(this.sci_Set$Set3__f_elem1, this.sci_Set$Set3__f_elem2, this.sci_Set$Set3__f_elem3, elem));
});
$c_sci_Set$Set3.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem1) ? new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem2, this.sci_Set$Set3__f_elem3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem2) ? new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem1, this.sci_Set$Set3__f_elem3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem3) ? new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem1, this.sci_Set$Set3__f_elem2) : this)));
});
$c_sci_Set$Set3.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Set$Set3$$anon$2(this);
});
$c_sci_Set$Set3.prototype.scala$collection$immutable$Set$Set3$$getElem__I__O = (function(i) {
  switch (i) {
    case 0: {
      return this.sci_Set$Set3__f_elem1;
      break;
    }
    case 1: {
      return this.sci_Set$Set3__f_elem2;
      break;
    }
    case 2: {
      return this.sci_Set$Set3__f_elem3;
      break;
    }
    default: {
      throw new $c_s_MatchError(i);
    }
  }
});
$c_sci_Set$Set3.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O(this.sci_Set$Set3__f_elem1);
  $n(f).apply__O__O(this.sci_Set$Set3__f_elem2);
  $n(f).apply__O__O(this.sci_Set$Set3__f_elem3);
});
$c_sci_Set$Set3.prototype.exists__F1__Z = (function(p) {
  return (($uZ($n(p).apply__O__O(this.sci_Set$Set3__f_elem1)) || $uZ($n(p).apply__O__O(this.sci_Set$Set3__f_elem2))) || $uZ($n(p).apply__O__O(this.sci_Set$Set3__f_elem3)));
});
$c_sci_Set$Set3.prototype.forall__F1__Z = (function(p) {
  return (($uZ($n(p).apply__O__O(this.sci_Set$Set3__f_elem1)) && $uZ($n(p).apply__O__O(this.sci_Set$Set3__f_elem2))) && $uZ($n(p).apply__O__O(this.sci_Set$Set3__f_elem3)));
});
$c_sci_Set$Set3.prototype.filterImpl__F1__Z__sci_Set = (function(pred, isFlipped) {
  var r1 = null;
  var r2 = null;
  var n = 0;
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set3__f_elem1)) !== isFlipped)) {
    r1 = this.sci_Set$Set3__f_elem1;
    n = ((1 + n) | 0);
  }
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set3__f_elem2)) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.sci_Set$Set3__f_elem2;
    } else {
      r2 = this.sci_Set$Set3__f_elem2;
    }
    n = ((1 + n) | 0);
  }
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set3__f_elem3)) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.sci_Set$Set3__f_elem3;
    } else if ((n === 1)) {
      r2 = this.sci_Set$Set3__f_elem3;
    }
    n = ((1 + n) | 0);
  }
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Set$EmptySet$();
      break;
    }
    case 1: {
      return new $c_sci_Set$Set1(r1);
      break;
    }
    case 2: {
      return new $c_sci_Set$Set2(r1, r2);
      break;
    }
    case 3: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
});
$c_sci_Set$Set3.prototype.head__O = (function() {
  return this.sci_Set$Set3__f_elem1;
});
$c_sci_Set$Set3.prototype.tail__sci_Set = (function() {
  return new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem2, this.sci_Set$Set3__f_elem3);
});
$c_sci_Set$Set3.prototype.tail__O = (function() {
  return this.tail__sci_Set();
});
$c_sci_Set$Set3.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem);
});
$c_sci_Set$Set3.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem);
});
function $as_sci_Set$Set3(obj) {
  return (((obj instanceof $c_sci_Set$Set3) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Set$Set3"));
}
function $isArrayOf_sci_Set$Set3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Set$Set3)));
}
function $asArrayOf_sci_Set$Set3(obj, depth) {
  return (($isArrayOf_sci_Set$Set3(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Set$Set3;", depth));
}
var $d_sci_Set$Set3 = new $TypeData().initClass($c_sci_Set$Set3, "scala.collection.immutable.Set$Set3", ({
  sci_Set$Set3: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Set$Set4(elem1, elem2, elem3, elem4) {
  this.sci_Set$Set4__f_elem1 = null;
  this.sci_Set$Set4__f_elem2 = null;
  this.sci_Set$Set4__f_elem3 = null;
  this.sci_Set$Set4__f_elem4 = null;
  this.sci_Set$Set4__f_elem1 = elem1;
  this.sci_Set$Set4__f_elem2 = elem2;
  this.sci_Set$Set4__f_elem3 = elem3;
  this.sci_Set$Set4__f_elem4 = elem4;
}
$c_sci_Set$Set4.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set4.prototype.constructor = $c_sci_Set$Set4;
/** @constructor */
function $h_sci_Set$Set4() {
}
$h_sci_Set$Set4.prototype = $c_sci_Set$Set4.prototype;
$c_sci_Set$Set4.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_sci_Set$Set4.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Set$Set4.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_Set$Set4.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_sci_Set$Set4.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, false);
});
$c_sci_Set$Set4.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, true);
});
$c_sci_Set$Set4.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Set$Set4.prototype.size__I = (function() {
  return 4;
});
$c_sci_Set$Set4.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Set$Set4.prototype.knownSize__I = (function() {
  return 4;
});
$c_sci_Set$Set4.prototype.contains__O__Z = (function(elem) {
  return ((($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem1) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem3)) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem4));
});
$c_sci_Set$Set4.prototype.incl__O__sci_Set = (function(elem) {
  if (this.contains__O__Z(elem)) {
    return this;
  } else {
    var this$1 = $m_sci_HashSet$();
    var this$2 = $n(this$1.sci_HashSet$__f_EmptySet);
    var elem$1 = this.sci_Set$Set4__f_elem1;
    var this$3 = $n(this$2.incl__O__sci_HashSet(elem$1));
    var elem$2 = this.sci_Set$Set4__f_elem2;
    var this$4 = $n(this$3.incl__O__sci_HashSet(elem$2));
    var elem$3 = this.sci_Set$Set4__f_elem3;
    var this$5 = $n(this$4.incl__O__sci_HashSet(elem$3));
    var elem$4 = this.sci_Set$Set4__f_elem4;
    var this$6 = $n(this$5.incl__O__sci_HashSet(elem$4));
    return this$6.incl__O__sci_HashSet(elem);
  }
});
$c_sci_Set$Set4.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem1) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem3, this.sci_Set$Set4__f_elem4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem2) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem1, this.sci_Set$Set4__f_elem3, this.sci_Set$Set4__f_elem4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem3) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem1, this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem4) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem1, this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem3) : this))));
});
$c_sci_Set$Set4.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Set$Set4$$anon$3(this);
});
$c_sci_Set$Set4.prototype.scala$collection$immutable$Set$Set4$$getElem__I__O = (function(i) {
  switch (i) {
    case 0: {
      return this.sci_Set$Set4__f_elem1;
      break;
    }
    case 1: {
      return this.sci_Set$Set4__f_elem2;
      break;
    }
    case 2: {
      return this.sci_Set$Set4__f_elem3;
      break;
    }
    case 3: {
      return this.sci_Set$Set4__f_elem4;
      break;
    }
    default: {
      throw new $c_s_MatchError(i);
    }
  }
});
$c_sci_Set$Set4.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O(this.sci_Set$Set4__f_elem1);
  $n(f).apply__O__O(this.sci_Set$Set4__f_elem2);
  $n(f).apply__O__O(this.sci_Set$Set4__f_elem3);
  $n(f).apply__O__O(this.sci_Set$Set4__f_elem4);
});
$c_sci_Set$Set4.prototype.exists__F1__Z = (function(p) {
  return ((($uZ($n(p).apply__O__O(this.sci_Set$Set4__f_elem1)) || $uZ($n(p).apply__O__O(this.sci_Set$Set4__f_elem2))) || $uZ($n(p).apply__O__O(this.sci_Set$Set4__f_elem3))) || $uZ($n(p).apply__O__O(this.sci_Set$Set4__f_elem4)));
});
$c_sci_Set$Set4.prototype.forall__F1__Z = (function(p) {
  return ((($uZ($n(p).apply__O__O(this.sci_Set$Set4__f_elem1)) && $uZ($n(p).apply__O__O(this.sci_Set$Set4__f_elem2))) && $uZ($n(p).apply__O__O(this.sci_Set$Set4__f_elem3))) && $uZ($n(p).apply__O__O(this.sci_Set$Set4__f_elem4)));
});
$c_sci_Set$Set4.prototype.filterImpl__F1__Z__sci_Set = (function(pred, isFlipped) {
  var r1 = null;
  var r2 = null;
  var r3 = null;
  var n = 0;
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set4__f_elem1)) !== isFlipped)) {
    r1 = this.sci_Set$Set4__f_elem1;
    n = ((1 + n) | 0);
  }
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set4__f_elem2)) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.sci_Set$Set4__f_elem2;
    } else {
      r2 = this.sci_Set$Set4__f_elem2;
    }
    n = ((1 + n) | 0);
  }
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set4__f_elem3)) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.sci_Set$Set4__f_elem3;
    } else if ((n === 1)) {
      r2 = this.sci_Set$Set4__f_elem3;
    } else {
      r3 = this.sci_Set$Set4__f_elem3;
    }
    n = ((1 + n) | 0);
  }
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set4__f_elem4)) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.sci_Set$Set4__f_elem4;
    } else if ((n === 1)) {
      r2 = this.sci_Set$Set4__f_elem4;
    } else if ((n === 2)) {
      r3 = this.sci_Set$Set4__f_elem4;
    }
    n = ((1 + n) | 0);
  }
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Set$EmptySet$();
      break;
    }
    case 1: {
      return new $c_sci_Set$Set1(r1);
      break;
    }
    case 2: {
      return new $c_sci_Set$Set2(r1, r2);
      break;
    }
    case 3: {
      return new $c_sci_Set$Set3(r1, r2, r3);
      break;
    }
    case 4: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
});
$c_sci_Set$Set4.prototype.head__O = (function() {
  return this.sci_Set$Set4__f_elem1;
});
$c_sci_Set$Set4.prototype.tail__sci_Set = (function() {
  return new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem3, this.sci_Set$Set4__f_elem4);
});
$c_sci_Set$Set4.prototype.buildTo__scm_Builder__scm_Builder = (function(builder) {
  return $as_scm_Builder($n($n($n($n(builder).addOne__O__scm_Growable(this.sci_Set$Set4__f_elem1)).addOne__O__scm_Growable(this.sci_Set$Set4__f_elem2)).addOne__O__scm_Growable(this.sci_Set$Set4__f_elem3)).addOne__O__scm_Growable(this.sci_Set$Set4__f_elem4));
});
$c_sci_Set$Set4.prototype.tail__O = (function() {
  return this.tail__sci_Set();
});
$c_sci_Set$Set4.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem);
});
$c_sci_Set$Set4.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem);
});
function $as_sci_Set$Set4(obj) {
  return (((obj instanceof $c_sci_Set$Set4) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Set$Set4"));
}
function $isArrayOf_sci_Set$Set4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Set$Set4)));
}
function $asArrayOf_sci_Set$Set4(obj, depth) {
  return (($isArrayOf_sci_Set$Set4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Set$Set4;", depth));
}
var $d_sci_Set$Set4 = new $TypeData().initClass($c_sci_Set$Set4, "scala.collection.immutable.Set$Set4", ({
  sci_Set$Set4: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
function $is_sci_SortedSet(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_SortedSet)));
}
function $as_sci_SortedSet(obj) {
  return (($is_sci_SortedSet(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SortedSet"));
}
function $isArrayOf_sci_SortedSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SortedSet)));
}
function $asArrayOf_sci_SortedSet(obj, depth) {
  return (($isArrayOf_sci_SortedSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SortedSet;", depth));
}
/** @constructor */
function $c_scm_AbstractSeq() {
}
$c_scm_AbstractSeq.prototype = new $h_sc_AbstractSeq();
$c_scm_AbstractSeq.prototype.constructor = $c_scm_AbstractSeq;
/** @constructor */
function $h_scm_AbstractSeq() {
}
$h_scm_AbstractSeq.prototype = $c_scm_AbstractSeq.prototype;
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Appended(underlying, elem, mutationCount) {
  this.sc_View$Appended__f_underlying = null;
  this.sc_View$Appended__f_elem = null;
  this.sc_SeqView$Appended__f_underlying = null;
  this.sc_SeqView$Appended__f_elem = null;
  this.scm_CheckedIndexedSeqView$Appended__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$Appended__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(this, underlying, elem);
}
$c_scm_CheckedIndexedSeqView$Appended.prototype = new $h_sc_IndexedSeqView$Appended();
$c_scm_CheckedIndexedSeqView$Appended.prototype.constructor = $c_scm_CheckedIndexedSeqView$Appended;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Appended() {
}
$h_scm_CheckedIndexedSeqView$Appended.prototype = $c_scm_CheckedIndexedSeqView$Appended.prototype;
$c_scm_CheckedIndexedSeqView$Appended.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.reverse__sc_IndexedSeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.reverse__sc_SeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.reverse__O = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.map__F1__O = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.dropRight__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.dropRight__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.take__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.take__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.prepended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.prepended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.appended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.appended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
var $d_scm_CheckedIndexedSeqView$Appended = new $TypeData().initClass($c_scm_CheckedIndexedSeqView$Appended, "scala.collection.mutable.CheckedIndexedSeqView$Appended", ({
  scm_CheckedIndexedSeqView$Appended: 1,
  sc_IndexedSeqView$Appended: 1,
  sc_SeqView$Appended: 1,
  sc_View$Appended: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
}));
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Drop(underlying, n, mutationCount) {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0;
  this.sc_SeqView$Drop__f_underlying = null;
  this.sc_SeqView$Drop__f_n = 0;
  this.scm_CheckedIndexedSeqView$Drop__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$Drop__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(this, underlying, n);
}
$c_scm_CheckedIndexedSeqView$Drop.prototype = new $h_sc_IndexedSeqView$Drop();
$c_scm_CheckedIndexedSeqView$Drop.prototype.constructor = $c_scm_CheckedIndexedSeqView$Drop;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Drop() {
}
$h_scm_CheckedIndexedSeqView$Drop.prototype = $c_scm_CheckedIndexedSeqView$Drop.prototype;
$c_scm_CheckedIndexedSeqView$Drop.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.reverse__sc_IndexedSeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.reverse__sc_SeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.reverse__O = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.map__F1__O = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.dropRight__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.dropRight__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.take__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.take__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.prepended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.prepended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.appended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.appended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
var $d_scm_CheckedIndexedSeqView$Drop = new $TypeData().initClass($c_scm_CheckedIndexedSeqView$Drop, "scala.collection.mutable.CheckedIndexedSeqView$Drop", ({
  scm_CheckedIndexedSeqView$Drop: 1,
  sc_IndexedSeqView$Drop: 1,
  sc_SeqView$Drop: 1,
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
}));
/** @constructor */
function $c_scm_CheckedIndexedSeqView$DropRight(underlying, n, mutationCount) {
  this.sc_View$DropRight__f_underlying = null;
  this.sc_View$DropRight__f_n = 0;
  this.sc_View$DropRight__f_normN = 0;
  this.sc_SeqView$DropRight__f_underlying = null;
  this.sc_SeqView$DropRight__f_len = 0;
  this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(this, underlying, n);
}
$c_scm_CheckedIndexedSeqView$DropRight.prototype = new $h_sc_IndexedSeqView$DropRight();
$c_scm_CheckedIndexedSeqView$DropRight.prototype.constructor = $c_scm_CheckedIndexedSeqView$DropRight;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$DropRight() {
}
$h_scm_CheckedIndexedSeqView$DropRight.prototype = $c_scm_CheckedIndexedSeqView$DropRight.prototype;
$c_scm_CheckedIndexedSeqView$DropRight.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.reverse__sc_IndexedSeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.reverse__sc_SeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.reverse__O = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.map__F1__O = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.dropRight__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.dropRight__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.take__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.take__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.prepended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.prepended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.appended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.appended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
var $d_scm_CheckedIndexedSeqView$DropRight = new $TypeData().initClass($c_scm_CheckedIndexedSeqView$DropRight, "scala.collection.mutable.CheckedIndexedSeqView$DropRight", ({
  scm_CheckedIndexedSeqView$DropRight: 1,
  sc_IndexedSeqView$DropRight: 1,
  sc_SeqView$DropRight: 1,
  sc_View$DropRight: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
}));
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Map(underlying, f, mutationCount) {
  this.sc_View$Map__f_underlying = null;
  this.sc_View$Map__f_f = null;
  this.sc_SeqView$Map__f_underlying = null;
  this.sc_SeqView$Map__f_f = null;
  this.scm_CheckedIndexedSeqView$Map__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$Map__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(this, underlying, f);
}
$c_scm_CheckedIndexedSeqView$Map.prototype = new $h_sc_IndexedSeqView$Map();
$c_scm_CheckedIndexedSeqView$Map.prototype.constructor = $c_scm_CheckedIndexedSeqView$Map;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Map() {
}
$h_scm_CheckedIndexedSeqView$Map.prototype = $c_scm_CheckedIndexedSeqView$Map.prototype;
$c_scm_CheckedIndexedSeqView$Map.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.reverse__sc_IndexedSeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.reverse__sc_SeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.reverse__O = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.map__F1__O = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.dropRight__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.dropRight__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.take__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.take__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.prepended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.prepended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.appended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.appended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
var $d_scm_CheckedIndexedSeqView$Map = new $TypeData().initClass($c_scm_CheckedIndexedSeqView$Map, "scala.collection.mutable.CheckedIndexedSeqView$Map", ({
  scm_CheckedIndexedSeqView$Map: 1,
  sc_IndexedSeqView$Map: 1,
  sc_SeqView$Map: 1,
  sc_View$Map: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
}));
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Prepended(elem, underlying, mutationCount) {
  this.sc_View$Prepended__f_elem = null;
  this.sc_View$Prepended__f_underlying = null;
  this.sc_SeqView$Prepended__f_elem = null;
  this.sc_SeqView$Prepended__f_underlying = null;
  this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$Prepended__O__sc_IndexedSeqOps__(this, elem, underlying);
}
$c_scm_CheckedIndexedSeqView$Prepended.prototype = new $h_sc_IndexedSeqView$Prepended();
$c_scm_CheckedIndexedSeqView$Prepended.prototype.constructor = $c_scm_CheckedIndexedSeqView$Prepended;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Prepended() {
}
$h_scm_CheckedIndexedSeqView$Prepended.prototype = $c_scm_CheckedIndexedSeqView$Prepended.prototype;
$c_scm_CheckedIndexedSeqView$Prepended.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.reverse__sc_IndexedSeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.reverse__sc_SeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.reverse__O = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.map__F1__O = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.dropRight__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.dropRight__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.take__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.take__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.prepended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.prepended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.appended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Prepended.prototype.appended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Prepended__f_mutationCount);
});
var $d_scm_CheckedIndexedSeqView$Prepended = new $TypeData().initClass($c_scm_CheckedIndexedSeqView$Prepended, "scala.collection.mutable.CheckedIndexedSeqView$Prepended", ({
  scm_CheckedIndexedSeqView$Prepended: 1,
  sc_IndexedSeqView$Prepended: 1,
  sc_SeqView$Prepended: 1,
  sc_View$Prepended: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
}));
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Reverse(underlying, mutationCount) {
  this.sc_SeqView$Reverse__f_underlying = null;
  this.sc_IndexedSeqView$Reverse__f_underlying = null;
  this.scm_CheckedIndexedSeqView$Reverse__f_underlying = null;
  this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$Reverse__f_underlying = underlying;
  this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(this, underlying);
}
$c_scm_CheckedIndexedSeqView$Reverse.prototype = new $h_sc_IndexedSeqView$Reverse();
$c_scm_CheckedIndexedSeqView$Reverse.prototype.constructor = $c_scm_CheckedIndexedSeqView$Reverse;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Reverse() {
}
$h_scm_CheckedIndexedSeqView$Reverse.prototype = $c_scm_CheckedIndexedSeqView$Reverse.prototype;
$c_scm_CheckedIndexedSeqView$Reverse.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.reverse__sc_IndexedSeqView = (function() {
  var x1 = this.scm_CheckedIndexedSeqView$Reverse__f_underlying;
  if ($is_sc_IndexedSeqView(x1)) {
    var x2 = $as_sc_IndexedSeqView(x1);
    return x2;
  } else {
    return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
  }
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.map__F1__O = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.dropRight__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.dropRight__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.take__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.take__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.prepended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.prepended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.appended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.appended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.reverse__sc_SeqView = (function() {
  return this.reverse__sc_IndexedSeqView();
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView();
});
var $d_scm_CheckedIndexedSeqView$Reverse = new $TypeData().initClass($c_scm_CheckedIndexedSeqView$Reverse, "scala.collection.mutable.CheckedIndexedSeqView$Reverse", ({
  scm_CheckedIndexedSeqView$Reverse: 1,
  sc_IndexedSeqView$Reverse: 1,
  sc_SeqView$Reverse: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
}));
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Take(underlying, n, mutationCount) {
  this.sc_View$Take__f_underlying = null;
  this.sc_View$Take__f_n = 0;
  this.sc_View$Take__f_normN = 0;
  this.sc_SeqView$Take__f_underlying = null;
  this.sc_SeqView$Take__f_n = 0;
  this.scm_CheckedIndexedSeqView$Take__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$Take__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(this, underlying, n);
}
$c_scm_CheckedIndexedSeqView$Take.prototype = new $h_sc_IndexedSeqView$Take();
$c_scm_CheckedIndexedSeqView$Take.prototype.constructor = $c_scm_CheckedIndexedSeqView$Take;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Take() {
}
$h_scm_CheckedIndexedSeqView$Take.prototype = $c_scm_CheckedIndexedSeqView$Take.prototype;
$c_scm_CheckedIndexedSeqView$Take.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.prepended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.reverse__sc_IndexedSeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.reverse__sc_SeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.reverse__O = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.map__F1__O = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.dropRight__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.dropRight__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.take__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.take__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.prepended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.prepended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Prepended(elem, this, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.appended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.appended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
var $d_scm_CheckedIndexedSeqView$Take = new $TypeData().initClass($c_scm_CheckedIndexedSeqView$Take, "scala.collection.mutable.CheckedIndexedSeqView$Take", ({
  scm_CheckedIndexedSeqView$Take: 1,
  sc_IndexedSeqView$Take: 1,
  sc_SeqView$Take: 1,
  sc_View$Take: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
}));
function $is_scm_Set(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Set)));
}
function $as_scm_Set(obj) {
  return (($is_scm_Set(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Set"));
}
function $isArrayOf_scm_Set(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Set)));
}
function $asArrayOf_scm_Set(obj, depth) {
  return (($isArrayOf_scm_Set(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Set;", depth));
}
function $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__unique__Lcats_data_Kleisli($thiz) {
  var this$1 = $m_Lcats_data_Kleisli$();
  var x = $n($thiz.F__Lcats_effect_kernel_GenSpawn()).unique__O();
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$1, x);
}
function $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__start__Lcats_data_Kleisli__Lcats_data_Kleisli($thiz, fa) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((r) => {
    var target = $n($thiz.F__Lcats_effect_kernel_GenSpawn()).start__O__O($n($n(fa).Lcats_data_Kleisli__f_run).apply__O__O(r));
    var tc = $thiz.F__Lcats_effect_kernel_GenSpawn();
    var this$3 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
    var f = new $c_sjsr_AnonFunction1(((fib) => {
      var fib$1 = $as_Lcats_effect_kernel_Fiber(fib);
      return new $c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10(fib$1, $thiz);
    }));
    return $n(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  }));
  return new $c_Lcats_data_Kleisli(run);
}
function $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__never__Lcats_data_Kleisli($thiz) {
  var this$1 = $m_Lcats_data_Kleisli$();
  var x = $n($thiz.F__Lcats_effect_kernel_GenSpawn()).never__O();
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$1, x);
}
function $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__cede__Lcats_data_Kleisli($thiz) {
  var this$1 = $m_Lcats_data_Kleisli$();
  var x = $n($thiz.F__Lcats_effect_kernel_GenSpawn()).cede__O();
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$1, x);
}
function $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__racePair__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli($thiz, fa, fb) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((r) => $n($thiz.F__Lcats_effect_kernel_GenSpawn()).uncancelable__F1__O(new $c_sjsr_AnonFunction1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var $x_1 = $n(poll$1);
    var target = $n($thiz.F__Lcats_effect_kernel_GenSpawn()).racePair__O__O__O($n($n(fa).Lcats_data_Kleisli__f_run).apply__O__O(r), $n($n(fb).Lcats_data_Kleisli__f_run).apply__O__O(r));
    var tc = $thiz.F__Lcats_effect_kernel_GenSpawn();
    var this$7 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
    var f = new $c_sjsr_AnonFunction1(((x$1) => {
      var x$1$1 = $as_s_util_Either(x$1);
      if ((x$1$1 instanceof $c_s_util_Left)) {
        var x178 = $as_T2($n($as_s_util_Left(x$1$1)).s_util_Left__f_value);
        if ((x178 !== null)) {
          var oc = $as_Lcats_effect_kernel_Outcome($n(x178)._1__O());
          var fib = $as_Lcats_effect_kernel_Fiber($n(x178)._2__O());
          var _1 = $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__cats$effect$kernel$GenSpawn$KleisliGenSpawn$$liftOutcome__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Outcome($thiz, oc);
          var _2 = new $c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10(fib, $thiz);
          var value = new $c_T2(_1, _2);
          return new $c_s_util_Left(value);
        }
      }
      if ((x$1$1 instanceof $c_s_util_Right)) {
        var x174 = $as_T2($n($as_s_util_Right(x$1$1)).s_util_Right__f_value);
        if ((x174 !== null)) {
          var fib$2 = $as_Lcats_effect_kernel_Fiber($n(x174)._1__O());
          var oc$2 = $as_Lcats_effect_kernel_Outcome($n(x174)._2__O());
          var _1$1 = new $c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10(fib$2, $thiz);
          var _2$1 = $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__cats$effect$kernel$GenSpawn$KleisliGenSpawn$$liftOutcome__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Outcome($thiz, oc$2);
          var value$1 = new $c_T2(_1$1, _2$1);
          return new $c_s_util_Right(value$1);
        }
      }
      throw new $c_s_MatchError(x$1$1);
    }));
    return $n($x_1).apply__O__O($n(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f));
  })))));
  return new $c_Lcats_data_Kleisli(run);
}
function $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__both__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli($thiz, fa, fb) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((r) => $n($thiz.F__Lcats_effect_kernel_GenSpawn()).both__O__O__O($n($n(fa).Lcats_data_Kleisli__f_run).apply__O__O(r), $n($n(fb).Lcats_data_Kleisli__f_run).apply__O__O(r))));
  return new $c_Lcats_data_Kleisli(run);
}
function $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__raceOutcome__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli($thiz, fa, fb) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((r) => {
    var target = $n($thiz.F__Lcats_effect_kernel_GenSpawn()).raceOutcome__O__O__O($n($n(fa).Lcats_data_Kleisli__f_run).apply__O__O(r), $n($n(fb).Lcats_data_Kleisli__f_run).apply__O__O(r));
    var tc = $thiz.F__Lcats_effect_kernel_GenSpawn();
    var this$7 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
    var f = new $c_sjsr_AnonFunction1(((_$104) => {
      var _$104$1 = $as_s_util_Either(_$104);
      if ((_$104$1 instanceof $c_s_util_Left)) {
        var a = $n($as_s_util_Left(_$104$1)).s_util_Left__f_value;
        var _$105 = $as_Lcats_effect_kernel_Outcome(a);
        var value = $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__cats$effect$kernel$GenSpawn$KleisliGenSpawn$$liftOutcome__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Outcome($thiz, _$105);
        return new $c_s_util_Left(value);
      }
      if ((_$104$1 instanceof $c_s_util_Right)) {
        var b = $n($as_s_util_Right(_$104$1)).s_util_Right__f_value;
        var _$106 = $as_Lcats_effect_kernel_Outcome(b);
        var value$1 = $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__cats$effect$kernel$GenSpawn$KleisliGenSpawn$$liftOutcome__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Outcome($thiz, _$106);
        return new $c_s_util_Right(value$1);
      }
      throw new $c_s_MatchError(_$104$1);
    }));
    return $n(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  }));
  return new $c_Lcats_data_Kleisli(run);
}
function $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__cats$effect$kernel$GenSpawn$KleisliGenSpawn$$liftOutcome__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Outcome($thiz, oc) {
  var nat = new $c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$9();
  var this$1 = $n(oc);
  return $f_Lcats_effect_kernel_Outcome__mapK__Lcats_arrow_FunctionK__Lcats_effect_kernel_Outcome(this$1, nat);
}
/** @constructor */
function $c_Lcats_effect_kernel_ResourceMonadCancel() {
}
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype = new $h_Lcats_effect_kernel_ResourceMonadError();
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.constructor = $c_Lcats_effect_kernel_ResourceMonadCancel;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceMonadCancel() {
}
$h_Lcats_effect_kernel_ResourceMonadCancel.prototype = $c_Lcats_effect_kernel_ResourceMonadCancel.prototype;
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.guarantee__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O(this, fa, fin);
});
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release);
});
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.canceled__O = (function() {
  var F = this.F__Lcats_effect_kernel_MonadCancel();
  var fa = $n(F).canceled__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
});
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.forceR__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_effect_kernel_Resource(fa);
  var fb$1 = $as_Lcats_effect_kernel_Resource(fb);
  return $n(fa$1).forceR__Lcats_effect_kernel_Resource__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource(fb$1, this.F__Lcats_effect_kernel_MonadCancel());
});
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.onCancel__O__O__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_effect_kernel_Resource(fa);
  var fin$1 = $as_Lcats_effect_kernel_Resource(fin);
  return $n(fa$1).onCancel__Lcats_effect_kernel_Resource__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource(fin$1, this.F__Lcats_effect_kernel_MonadCancel());
});
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.uncancelable__F1__O = (function(body) {
  return $m_Lcats_effect_kernel_Resource$().uncancelable__F1__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource(body, this.F__Lcats_effect_kernel_MonadCancel());
});
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  var rfa = $as_Lcats_effect_kernel_Resource(fa);
  return $n(rfa).guaranteeCase__F1__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource(fin, this.F__Lcats_effect_kernel_MonadCancel());
});
/** @constructor */
function $c_sci_Map$EmptyMap$() {
}
$c_sci_Map$EmptyMap$.prototype = new $h_sci_AbstractMap();
$c_sci_Map$EmptyMap$.prototype.constructor = $c_sci_Map$EmptyMap$;
/** @constructor */
function $h_sci_Map$EmptyMap$() {
}
$h_sci_Map$EmptyMap$.prototype = $c_sci_Map$EmptyMap$.prototype;
$c_sci_Map$EmptyMap$.prototype.size__I = (function() {
  return 0;
});
$c_sci_Map$EmptyMap$.prototype.knownSize__I = (function() {
  return 0;
});
$c_sci_Map$EmptyMap$.prototype.isEmpty__Z = (function() {
  return true;
});
$c_sci_Map$EmptyMap$.prototype.apply__O__E = (function(key) {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
});
$c_sci_Map$EmptyMap$.prototype.contains__O__Z = (function(key) {
  return false;
});
$c_sci_Map$EmptyMap$.prototype.get__O__s_Option = (function(key) {
  return $m_s_None$();
});
$c_sci_Map$EmptyMap$.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return $n(default$1).apply__O();
});
$c_sci_Map$EmptyMap$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
});
$c_sci_Map$EmptyMap$.prototype.keysIterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
});
$c_sci_Map$EmptyMap$.prototype.valuesIterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
});
$c_sci_Map$EmptyMap$.prototype.concat__sc_IterableOnce__sci_Map = (function(suffix) {
  if ($is_sci_Map(suffix)) {
    var x2 = $as_sci_Map(suffix);
    return x2;
  } else {
    return $as_sci_Map($f_sc_MapOps__concat__sc_IterableOnce__sc_IterableOps(this, suffix));
  }
});
$c_sci_Map$EmptyMap$.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return this.concat__sc_IterableOnce__sci_Map(suffix);
});
$c_sci_Map$EmptyMap$.prototype.removed__O__sci_MapOps = (function(key) {
  return this;
});
$c_sci_Map$EmptyMap$.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return new $c_sci_Map$Map1(key, value);
});
$c_sci_Map$EmptyMap$.prototype.apply__O__O = (function(key) {
  this.apply__O__E(key);
});
var $d_sci_Map$EmptyMap$ = new $TypeData().initClass($c_sci_Map$EmptyMap$, "scala.collection.immutable.Map$EmptyMap$", ({
  sci_Map$EmptyMap$: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_Map$EmptyMap$;
function $m_sci_Map$EmptyMap$() {
  if ((!$n_sci_Map$EmptyMap$)) {
    $n_sci_Map$EmptyMap$ = new $c_sci_Map$EmptyMap$();
  }
  return $n_sci_Map$EmptyMap$;
}
/** @constructor */
function $c_sci_Map$WithDefault(underlying, defaultValue) {
  this.sci_Map$WithDefault__f_underlying = null;
  this.sci_Map$WithDefault__f_defaultValue = null;
  this.sci_Map$WithDefault__f_underlying = underlying;
  this.sci_Map$WithDefault__f_defaultValue = defaultValue;
}
$c_sci_Map$WithDefault.prototype = new $h_sci_AbstractMap();
$c_sci_Map$WithDefault.prototype.constructor = $c_sci_Map$WithDefault;
/** @constructor */
function $h_sci_Map$WithDefault() {
}
$h_sci_Map$WithDefault.prototype = $c_sci_Map$WithDefault.prototype;
$c_sci_Map$WithDefault.prototype.get__O__s_Option = (function(key) {
  return $n(this.sci_Map$WithDefault__f_underlying).get__O__s_Option(key);
});
$c_sci_Map$WithDefault.prototype.default__O__O = (function(key) {
  return $n(this.sci_Map$WithDefault__f_defaultValue).apply__O__O(key);
});
$c_sci_Map$WithDefault.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $n(this.sci_Map$WithDefault__f_underlying).iterableFactory__sc_IterableFactory();
});
$c_sci_Map$WithDefault.prototype.iterator__sc_Iterator = (function() {
  return $n(this.sci_Map$WithDefault__f_underlying).iterator__sc_Iterator();
});
$c_sci_Map$WithDefault.prototype.isEmpty__Z = (function() {
  return $n(this.sci_Map$WithDefault__f_underlying).isEmpty__Z();
});
$c_sci_Map$WithDefault.prototype.mapFactory__sc_MapFactory = (function() {
  return $n(this.sci_Map$WithDefault__f_underlying).mapFactory__sc_MapFactory();
});
$c_sci_Map$WithDefault.prototype.concat__sc_IterableOnce__sci_Map$WithDefault = (function(xs) {
  return new $c_sci_Map$WithDefault($as_sci_Map($n(this.sci_Map$WithDefault__f_underlying).concat__sc_IterableOnce__sc_IterableOps(xs)), this.sci_Map$WithDefault__f_defaultValue);
});
$c_sci_Map$WithDefault.prototype.removed__O__sci_Map$WithDefault = (function(key) {
  return new $c_sci_Map$WithDefault($as_sci_Map($n(this.sci_Map$WithDefault__f_underlying).removed__O__sci_MapOps(key)), this.sci_Map$WithDefault__f_defaultValue);
});
$c_sci_Map$WithDefault.prototype.updated__O__O__sci_Map$WithDefault = (function(key, value) {
  return new $c_sci_Map$WithDefault($as_sci_Map($n(this.sci_Map$WithDefault__f_underlying).updated__O__O__sci_MapOps(key, value)), this.sci_Map$WithDefault__f_defaultValue);
});
$c_sci_Map$WithDefault.prototype.empty__sci_Map$WithDefault = (function() {
  return new $c_sci_Map$WithDefault($as_sci_Map($n(this.sci_Map$WithDefault__f_underlying).empty__sc_IterableOps()), this.sci_Map$WithDefault__f_defaultValue);
});
$c_sci_Map$WithDefault.prototype.fromSpecific__sc_IterableOnce__sci_Map$WithDefault = (function(coll) {
  return new $c_sci_Map$WithDefault($as_sci_Map($n($n(this.sci_Map$WithDefault__f_underlying).mapFactory__sc_MapFactory()).from__sc_IterableOnce__O(coll)), this.sci_Map$WithDefault__f_defaultValue);
});
$c_sci_Map$WithDefault.prototype.newSpecificBuilder__scm_Builder = (function() {
  var this$3 = new $c_sci_MapBuilderImpl();
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_sci_Map(p$2);
    return new $c_sci_Map$WithDefault(p, this.sci_Map$WithDefault__f_defaultValue);
  }));
  return new $c_scm_Builder$$anon$1(this$3, f);
});
$c_sci_Map$WithDefault.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sci_Map$WithDefault(coll);
});
$c_sci_Map$WithDefault.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sci_Map$WithDefault(coll);
});
$c_sci_Map$WithDefault.prototype.empty__sc_IterableOps = (function() {
  return this.empty__sci_Map$WithDefault();
});
$c_sci_Map$WithDefault.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map$WithDefault(key, value);
});
$c_sci_Map$WithDefault.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map$WithDefault(key);
});
$c_sci_Map$WithDefault.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return this.concat__sc_IterableOnce__sci_Map$WithDefault(suffix);
});
var $d_sci_Map$WithDefault = new $TypeData().initClass($c_sci_Map$WithDefault, "scala.collection.immutable.Map$WithDefault", ({
  sci_Map$WithDefault: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  Ljava_io_Serializable: 1
}));
function $ct_sci_MapOps$ImmutableKeySet__sci_MapOps__($thiz, outer) {
  $n(outer);
  $thiz.sci_MapOps$ImmutableKeySet__f_$outer = outer;
  return $thiz;
}
/** @constructor */
function $c_sci_MapOps$ImmutableKeySet() {
  this.sci_MapOps$ImmutableKeySet__f_$outer = null;
}
$c_sci_MapOps$ImmutableKeySet.prototype = new $h_sci_AbstractSet();
$c_sci_MapOps$ImmutableKeySet.prototype.constructor = $c_sci_MapOps$ImmutableKeySet;
/** @constructor */
function $h_sci_MapOps$ImmutableKeySet() {
}
$h_sci_MapOps$ImmutableKeySet.prototype = $c_sci_MapOps$ImmutableKeySet.prototype;
$c_sci_MapOps$ImmutableKeySet.prototype.iterator__sc_Iterator = (function() {
  return $n(this.sci_MapOps$ImmutableKeySet__f_$outer).keysIterator__sc_Iterator();
});
$c_sci_MapOps$ImmutableKeySet.prototype.contains__O__Z = (function(key) {
  return $n(this.sci_MapOps$ImmutableKeySet__f_$outer).contains__O__Z(key);
});
$c_sci_MapOps$ImmutableKeySet.prototype.size__I = (function() {
  return $n(this.sci_MapOps$ImmutableKeySet__f_$outer).size__I();
});
$c_sci_MapOps$ImmutableKeySet.prototype.knownSize__I = (function() {
  return $n(this.sci_MapOps$ImmutableKeySet__f_$outer).knownSize__I();
});
$c_sci_MapOps$ImmutableKeySet.prototype.isEmpty__Z = (function() {
  return $n(this.sci_MapOps$ImmutableKeySet__f_$outer).isEmpty__Z();
});
$c_sci_MapOps$ImmutableKeySet.prototype.incl__O__sci_Set = (function(elem) {
  if ($n(this.sci_MapOps$ImmutableKeySet__f_$outer).contains__O__Z(elem)) {
    return this;
  } else {
    var this$2 = $m_sci_Set$EmptySet$();
    var this$3 = $n($as_sci_SetOps($f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps(this$2, this)));
    return $as_sci_Set(this$3.incl__O__sci_SetOps(elem));
  }
});
$c_sci_MapOps$ImmutableKeySet.prototype.excl__O__sci_Set = (function(elem) {
  if ($n(this.sci_MapOps$ImmutableKeySet__f_$outer).contains__O__Z(elem)) {
    var this$2 = $m_sci_Set$EmptySet$();
    var this$3 = $n($as_sci_SetOps($f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps(this$2, this)));
    return $as_sci_Set(this$3.excl__O__sci_SetOps(elem));
  } else {
    return this;
  }
});
$c_sci_MapOps$ImmutableKeySet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem);
});
$c_sci_MapOps$ImmutableKeySet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem);
});
function $as_sci_MapOps$ImmutableKeySet(obj) {
  return (((obj instanceof $c_sci_MapOps$ImmutableKeySet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.MapOps$ImmutableKeySet"));
}
function $isArrayOf_sci_MapOps$ImmutableKeySet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_MapOps$ImmutableKeySet)));
}
function $asArrayOf_sci_MapOps$ImmutableKeySet(obj, depth) {
  return (($isArrayOf_sci_MapOps$ImmutableKeySet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.MapOps$ImmutableKeySet;", depth));
}
var $d_sci_MapOps$ImmutableKeySet = new $TypeData().initClass($c_sci_MapOps$ImmutableKeySet, "scala.collection.immutable.MapOps$ImmutableKeySet", ({
  sci_MapOps$ImmutableKeySet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_MapOps$GenKeySet: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_GenSpawn$$anon$3(F0$8) {
  this.Lcats_effect_kernel_GenSpawn$$anon$3__f_F0$3 = null;
  this.Lcats_effect_kernel_GenSpawn$$anon$3__f_F0$3 = F0$8;
}
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype = new $h_O();
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.constructor = $c_Lcats_effect_kernel_GenSpawn$$anon$3;
/** @constructor */
function $h_Lcats_effect_kernel_GenSpawn$$anon$3() {
}
$h_Lcats_effect_kernel_GenSpawn$$anon$3.prototype = $c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype;
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.unit__O = (function() {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenSpawn$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  var this$3 = $m_Lcats_data_Kleisli$();
  var F = this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$3, (void 0), F);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.guarantee__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O(this, fa, fin);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.F__Lcats_effect_kernel_GenSpawn = (function() {
  return this.Lcats_effect_kernel_GenSpawn$$anon$3__f_F0$3;
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.F__Lcats_effect_kernel_MonadCancel = (function() {
  return this.Lcats_effect_kernel_GenSpawn$$anon$3__f_F0$3;
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.unique__O = (function() {
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__unique__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.start__O__O = (function(fa) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__start__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.never__O = (function() {
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__never__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.cede__O = (function() {
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__cede__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.racePair__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__racePair__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.both__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__both__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.raceOutcome__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__raceOutcome__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.uncancelable__F1__O = (function(body) {
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__uncancelable__F1__Lcats_data_Kleisli(this, body);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.canceled__O = (function() {
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__canceled__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.onCancel__O__O__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fin$1 = $as_Lcats_data_Kleisli(fin);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__onCancel__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fin$1);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.forceR__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__forceR__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__guaranteeCase__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this, fa$1, fin);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.pure__O__O = (function(x) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenSpawn$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  var this$3 = $m_Lcats_data_Kleisli$();
  var F = this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$3, x, F);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.raiseError__O__O = (function(e) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenSpawn$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliApplicativeError__raiseError__O__Lcats_data_Kleisli(this$2, e);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenSpawn$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliApplicativeError__handleErrorWith__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this$2, fa$1, f);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenSpawn$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $n(fa$1).flatMap__F1__Lcats_FlatMap__Lcats_data_Kleisli(f, this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.tailRecM__O__F1__O = (function(a, f) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenSpawn$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliFlatMap__tailRecM__O__F1__Lcats_data_Kleisli(this$2, a, f);
});
var $d_Lcats_effect_kernel_GenSpawn$$anon$3 = new $TypeData().initClass($c_Lcats_effect_kernel_GenSpawn$$anon$3, "cats.effect.kernel.GenSpawn$$anon$3", ({
  Lcats_effect_kernel_GenSpawn$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lcats_effect_kernel_Unique: 1,
  Lcats_effect_kernel_GenSpawn: 1,
  Lcats_effect_kernel_MonadCancel$KleisliMonadCancel: 1,
  Lcats_effect_kernel_GenSpawn$KleisliGenSpawn: 1
}));
function $f_Lcats_effect_kernel_Sync__$init$__V($thiz) {
  $thiz.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Delay_$eq__Lcats_effect_kernel_Sync$Type$Delay$__V($m_Lcats_effect_kernel_Sync$Type$Delay$());
  $thiz.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Blocking_$eq__Lcats_effect_kernel_Sync$Type$Blocking$__V($m_Lcats_effect_kernel_Sync$Type$Blocking$());
  $thiz.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleOnce_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleOnce$__V($m_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$());
  $thiz.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleMany_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleMany$__V($m_Lcats_effect_kernel_Sync$Type$InterruptibleMany$());
}
function $f_Lcats_effect_kernel_Sync__unique__O($thiz) {
  return $thiz.delay__F0__O(new $c_sjsr_AnonFunction0((() => new $c_Lcats_effect_kernel_Unique$Token())));
}
function $f_Lcats_effect_kernel_Sync__defer__F0__O($thiz, thunk) {
  return $thiz.flatMap__O__F1__O($thiz.delay__F0__O(thunk), new $c_sjsr_AnonFunction1(((x) => x)));
}
function $is_Lcats_effect_kernel_Sync(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_kernel_Sync)));
}
function $as_Lcats_effect_kernel_Sync(obj) {
  return (($is_Lcats_effect_kernel_Sync(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Sync"));
}
function $isArrayOf_Lcats_effect_kernel_Sync(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Sync)));
}
function $asArrayOf_Lcats_effect_kernel_Sync(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Sync(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Sync;", depth));
}
/** @constructor */
function $c_Lcats_kernel_Eq$() {
}
$c_Lcats_kernel_Eq$.prototype = new $h_Lcats_kernel_EqFunctions();
$c_Lcats_kernel_Eq$.prototype.constructor = $c_Lcats_kernel_Eq$;
/** @constructor */
function $h_Lcats_kernel_Eq$() {
}
$h_Lcats_kernel_Eq$.prototype = $c_Lcats_kernel_Eq$.prototype;
var $d_Lcats_kernel_Eq$ = new $TypeData().initClass($c_Lcats_kernel_Eq$, "cats.kernel.Eq$", ({
  Lcats_kernel_Eq$: 1,
  Lcats_kernel_EqFunctions: 1,
  Lcats_kernel_EqToEquivConversion: 1,
  Lcats_kernel_ScalaVersionSpecificEqInstances: 1,
  Lcats_kernel_ScalaVersionSpecificHashInstances: 1,
  Lcats_kernel_ScalaVersionSpecificPartialOrderInstances: 1,
  Lcats_kernel_ScalaVersionSpecificOrderInstances: 1,
  Lcats_kernel_instances_TupleEqInstances: 1,
  Lcats_kernel_instances_TupleHashInstances: 1,
  Lcats_kernel_instances_TuplePartialOrderInstances: 1,
  Lcats_kernel_instances_TupleOrderInstances: 1,
  Lcats_kernel_EqInstances0: 1,
  Lcats_kernel_EqInstances: 1,
  Lcats_kernel_HashInstances0: 1,
  Lcats_kernel_HashInstances: 1,
  Lcats_kernel_PartialOrderInstances0: 1,
  Lcats_kernel_PartialOrderInstances1: 1,
  Lcats_kernel_PartialOrderInstances: 1,
  Lcats_kernel_OrderInstances0: 1,
  Lcats_kernel_OrderInstances1: 1
}));
var $n_Lcats_kernel_Eq$;
function $m_Lcats_kernel_Eq$() {
  if ((!$n_Lcats_kernel_Eq$)) {
    $n_Lcats_kernel_Eq$ = new $c_Lcats_kernel_Eq$();
  }
  return $n_Lcats_kernel_Eq$;
}
/** @constructor */
function $c_Lcats_kernel_Semigroup$() {
}
$c_Lcats_kernel_Semigroup$.prototype = new $h_Lcats_kernel_SemigroupFunctions();
$c_Lcats_kernel_Semigroup$.prototype.constructor = $c_Lcats_kernel_Semigroup$;
/** @constructor */
function $h_Lcats_kernel_Semigroup$() {
}
$h_Lcats_kernel_Semigroup$.prototype = $c_Lcats_kernel_Semigroup$.prototype;
var $d_Lcats_kernel_Semigroup$ = new $TypeData().initClass($c_Lcats_kernel_Semigroup$, "cats.kernel.Semigroup$", ({
  Lcats_kernel_Semigroup$: 1,
  Lcats_kernel_SemigroupFunctions: 1,
  Lcats_kernel_ScalaVersionSpecificMonoidInstances: 1,
  Lcats_kernel_instances_TupleSemigroupInstances: 1,
  Lcats_kernel_instances_TupleBandInstances: 1,
  Lcats_kernel_instances_TupleCommutativeSemigroupInstances: 1,
  Lcats_kernel_instances_TupleMonoidInstances: 1,
  Lcats_kernel_instances_TupleSemilatticeInstances: 1,
  Lcats_kernel_instances_TupleCommutativeMonoidInstances: 1,
  Lcats_kernel_instances_TupleGroupInstances: 1,
  Lcats_kernel_instances_TupleBoundedSemilatticeInstances: 1,
  Lcats_kernel_instances_TupleCommutativeGroupInstances: 1,
  Lcats_kernel_SemigroupInstances: 1,
  Lcats_kernel_CommutativeSemigroupInstances: 1,
  Lcats_kernel_BandInstances: 1,
  Lcats_kernel_MonoidInstances: 1,
  Lcats_kernel_CommutativeMonoidInstances: 1,
  Lcats_kernel_SemilatticeInstances: 1,
  Lcats_kernel_BoundedSemilatticeInstances: 1,
  Lcats_kernel_GroupInstances: 1
}));
var $n_Lcats_kernel_Semigroup$;
function $m_Lcats_kernel_Semigroup$() {
  if ((!$n_Lcats_kernel_Semigroup$)) {
    $n_Lcats_kernel_Semigroup$ = new $c_Lcats_kernel_Semigroup$();
  }
  return $n_Lcats_kernel_Semigroup$;
}
function $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_HashMap__sci_Set($thiz, newHashMap) {
  return ((newHashMap === $as_sci_HashMap($thiz.sci_MapOps$ImmutableKeySet__f_$outer)) ? $thiz : $n(newHashMap).keySet__sci_Set());
}
function $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_BitmapIndexedMapNode__sci_Set($thiz, newRootNode) {
  return ((newRootNode === $n($as_sci_HashMap($thiz.sci_MapOps$ImmutableKeySet__f_$outer)).sci_HashMap__f_rootNode) ? $thiz : new $c_sci_HashMap(newRootNode).keySet__sci_Set());
}
/** @constructor */
function $c_sci_HashMap$HashKeySet(outer) {
  this.sci_MapOps$ImmutableKeySet__f_$outer = null;
  $ct_sci_MapOps$ImmutableKeySet__sci_MapOps__(this, outer);
}
$c_sci_HashMap$HashKeySet.prototype = new $h_sci_MapOps$ImmutableKeySet();
$c_sci_HashMap$HashKeySet.prototype.constructor = $c_sci_HashMap$HashKeySet;
/** @constructor */
function $h_sci_HashMap$HashKeySet() {
}
$h_sci_HashMap$HashKeySet.prototype = $c_sci_HashMap$HashKeySet.prototype;
$c_sci_HashMap$HashKeySet.prototype.incl__O__sci_Set = (function(elem) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(elem);
  var improvedHash = $m_sc_Hashing$().improve__I__I(originalHash);
  var newNode = $n($n($as_sci_HashMap(this.sci_MapOps$ImmutableKeySet__f_$outer)).sci_HashMap__f_rootNode).updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(elem, null, originalHash, improvedHash, 0, false);
  return $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_BitmapIndexedMapNode__sci_Set(this, newNode);
});
$c_sci_HashMap$HashKeySet.prototype.excl__O__sci_Set = (function(elem) {
  var this$1 = $n($as_sci_HashMap(this.sci_MapOps$ImmutableKeySet__f_$outer));
  return $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_HashMap__sci_Set(this, this$1.removed__O__sci_HashMap(elem));
});
$c_sci_HashMap$HashKeySet.prototype.filter__F1__sci_Set = (function(pred) {
  var this$2 = $n($as_sci_HashMap(this.sci_MapOps$ImmutableKeySet__f_$outer));
  var pred$1 = new $c_sjsr_AnonFunction1(((kv$2) => {
    var kv = $as_T2(kv$2);
    return $uZ($n(pred).apply__O__O($n(kv)._1__O()));
  }));
  return $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_HashMap__sci_Set(this, this$2.filterImpl__F1__Z__sci_HashMap(pred$1, false));
});
$c_sci_HashMap$HashKeySet.prototype.filterNot__F1__sci_Set = (function(pred) {
  var this$2 = $n($as_sci_HashMap(this.sci_MapOps$ImmutableKeySet__f_$outer));
  var pred$1 = new $c_sjsr_AnonFunction1(((kv$2) => {
    var kv = $as_T2(kv$2);
    return $uZ($n(pred).apply__O__O($n(kv)._1__O()));
  }));
  return $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_HashMap__sci_Set(this, this$2.filterImpl__F1__Z__sci_HashMap(pred$1, true));
});
$c_sci_HashMap$HashKeySet.prototype.filterNot__F1__O = (function(pred) {
  return this.filterNot__F1__sci_Set(pred);
});
$c_sci_HashMap$HashKeySet.prototype.filter__F1__O = (function(pred) {
  return this.filter__F1__sci_Set(pred);
});
$c_sci_HashMap$HashKeySet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem);
});
$c_sci_HashMap$HashKeySet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem);
});
function $as_sci_HashMap$HashKeySet(obj) {
  return (((obj instanceof $c_sci_HashMap$HashKeySet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashMap$HashKeySet"));
}
function $isArrayOf_sci_HashMap$HashKeySet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashMap$HashKeySet)));
}
function $asArrayOf_sci_HashMap$HashKeySet(obj, depth) {
  return (($isArrayOf_sci_HashMap$HashKeySet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashMap$HashKeySet;", depth));
}
var $d_sci_HashMap$HashKeySet = new $TypeData().initClass($c_sci_HashMap$HashKeySet, "scala.collection.immutable.HashMap$HashKeySet", ({
  sci_HashMap$HashKeySet: 1,
  sci_MapOps$ImmutableKeySet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_MapOps$GenKeySet: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Map$Map1(key1, value1) {
  this.sci_Map$Map1__f_key1 = null;
  this.sci_Map$Map1__f_value1 = null;
  this.sci_Map$Map1__f_key1 = key1;
  this.sci_Map$Map1__f_value1 = value1;
}
$c_sci_Map$Map1.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map1.prototype.constructor = $c_sci_Map$Map1;
/** @constructor */
function $h_sci_Map$Map1() {
}
$h_sci_Map$Map1.prototype = $c_sci_Map$Map1.prototype;
$c_sci_Map$Map1.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_sci_Map$Map1.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Map$Map1.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_Map$Map1.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_sci_Map$Map1.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, false);
});
$c_sci_Map$Map1.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, true);
});
$c_sci_Map$Map1.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Map$Map1.prototype.size__I = (function() {
  return 1;
});
$c_sci_Map$Map1.prototype.knownSize__I = (function() {
  return 1;
});
$c_sci_Map$Map1.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Map$Map1.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1)) {
    return this.sci_Map$Map1__f_value1;
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$c_sci_Map$Map1.prototype.contains__O__Z = (function(key) {
  return $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1);
});
$c_sci_Map$Map1.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? new $c_s_Some(this.sci_Map$Map1__f_value1) : $m_s_None$());
});
$c_sci_Map$Map1.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? this.sci_Map$Map1__f_value1 : $n(default$1).apply__O());
});
$c_sci_Map$Map1.prototype.iterator__sc_Iterator = (function() {
  var a = new $c_T2(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1);
  return new $c_sc_Iterator$$anon$20(a);
});
$c_sci_Map$Map1.prototype.keysIterator__sc_Iterator = (function() {
  var a = this.sci_Map$Map1__f_key1;
  return new $c_sc_Iterator$$anon$20(a);
});
$c_sci_Map$Map1.prototype.valuesIterator__sc_Iterator = (function() {
  var a = this.sci_Map$Map1__f_value1;
  return new $c_sc_Iterator$$anon$20(a);
});
$c_sci_Map$Map1.prototype.updated__O__O__sci_Map = (function(key, value) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? new $c_sci_Map$Map1(this.sci_Map$Map1__f_key1, value) : new $c_sci_Map$Map2(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1, key, value));
});
$c_sci_Map$Map1.prototype.removed__O__sci_Map = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? $m_sci_Map$EmptyMap$() : this);
});
$c_sci_Map$Map1.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O(new $c_T2(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1));
});
$c_sci_Map$Map1.prototype.forall__F1__Z = (function(p) {
  return $uZ($n(p).apply__O__O(new $c_T2(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1)));
});
$c_sci_Map$Map1.prototype.filterImpl__F1__Z__sci_Map = (function(pred, isFlipped) {
  return (($uZ($n(pred).apply__O__O(new $c_T2(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1))) !== isFlipped) ? this : $m_sci_Map$EmptyMap$());
});
$c_sci_Map$Map1.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 1);
});
$c_sci_Map$Map1.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map(key);
});
$c_sci_Map$Map1.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value);
});
function $as_sci_Map$Map1(obj) {
  return (((obj instanceof $c_sci_Map$Map1) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Map$Map1"));
}
function $isArrayOf_sci_Map$Map1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Map$Map1)));
}
function $asArrayOf_sci_Map$Map1(obj, depth) {
  return (($isArrayOf_sci_Map$Map1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Map$Map1;", depth));
}
var $d_sci_Map$Map1 = new $TypeData().initClass($c_sci_Map$Map1, "scala.collection.immutable.Map$Map1", ({
  sci_Map$Map1: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Map$Map2(key1, value1, key2, value2) {
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1 = key1;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1 = value1;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2 = key2;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2 = value2;
}
$c_sci_Map$Map2.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map2.prototype.constructor = $c_sci_Map$Map2;
/** @constructor */
function $h_sci_Map$Map2() {
}
$h_sci_Map$Map2.prototype = $c_sci_Map$Map2.prototype;
$c_sci_Map$Map2.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_sci_Map$Map2.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Map$Map2.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_Map$Map2.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_sci_Map$Map2.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, false);
});
$c_sci_Map$Map2.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, true);
});
$c_sci_Map$Map2.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Map$Map2.prototype.size__I = (function() {
  return 2;
});
$c_sci_Map$Map2.prototype.knownSize__I = (function() {
  return 2;
});
$c_sci_Map$Map2.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Map$Map2.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1)) {
    return this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1;
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2)) {
    return this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2;
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$c_sci_Map$Map2.prototype.contains__O__Z = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2));
});
$c_sci_Map$Map2.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? new $c_s_Some(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? new $c_s_Some(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2) : $m_s_None$()));
});
$c_sci_Map$Map2.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2 : $n(default$1).apply__O()));
});
$c_sci_Map$Map2.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map2$$anon$1(this);
});
$c_sci_Map$Map2.prototype.keysIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map2$$anon$2(this);
});
$c_sci_Map$Map2.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map2$$anon$3(this);
});
$c_sci_Map$Map2.prototype.updated__O__O__sci_Map = (function(key, value) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? new $c_sci_Map$Map2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, value, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? new $c_sci_Map$Map2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, value) : new $c_sci_Map$Map3(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2, key, value)));
});
$c_sci_Map$Map2.prototype.removed__O__sci_Map = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? new $c_sci_Map$Map1(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? new $c_sci_Map$Map1(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1) : this));
});
$c_sci_Map$Map2.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O(new $c_T2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1));
  $n(f).apply__O__O(new $c_T2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2));
});
$c_sci_Map$Map2.prototype.forall__F1__Z = (function(p) {
  return ($uZ($n(p).apply__O__O(new $c_T2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1))) && $uZ($n(p).apply__O__O(new $c_T2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2))));
});
$c_sci_Map$Map2.prototype.filterImpl__F1__Z__sci_Map = (function(pred, isFlipped) {
  var k1 = null;
  var v1 = null;
  var n = 0;
  if (($uZ($n(pred).apply__O__O(new $c_T2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1))) !== isFlipped)) {
    k1 = this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1;
    v1 = this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1;
    n = ((1 + n) | 0);
  }
  if (($uZ($n(pred).apply__O__O(new $c_T2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2;
      v1 = this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2;
    }
    n = ((1 + n) | 0);
  }
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Map$EmptyMap$();
      break;
    }
    case 1: {
      return new $c_sci_Map$Map1(k1, v1);
      break;
    }
    case 2: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
});
$c_sci_Map$Map2.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 2);
});
$c_sci_Map$Map2.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map(key);
});
$c_sci_Map$Map2.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value);
});
function $as_sci_Map$Map2(obj) {
  return (((obj instanceof $c_sci_Map$Map2) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Map$Map2"));
}
function $isArrayOf_sci_Map$Map2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Map$Map2)));
}
function $asArrayOf_sci_Map$Map2(obj, depth) {
  return (($isArrayOf_sci_Map$Map2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Map$Map2;", depth));
}
var $d_sci_Map$Map2 = new $TypeData().initClass($c_sci_Map$Map2, "scala.collection.immutable.Map$Map2", ({
  sci_Map$Map2: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Map$Map3(key1, value1, key2, value2, key3, value3) {
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1 = key1;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1 = value1;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2 = key2;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2 = value2;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3 = key3;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3 = value3;
}
$c_sci_Map$Map3.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map3.prototype.constructor = $c_sci_Map$Map3;
/** @constructor */
function $h_sci_Map$Map3() {
}
$h_sci_Map$Map3.prototype = $c_sci_Map$Map3.prototype;
$c_sci_Map$Map3.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_sci_Map$Map3.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Map$Map3.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_Map$Map3.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_sci_Map$Map3.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, false);
});
$c_sci_Map$Map3.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, true);
});
$c_sci_Map$Map3.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Map$Map3.prototype.size__I = (function() {
  return 3;
});
$c_sci_Map$Map3.prototype.knownSize__I = (function() {
  return 3;
});
$c_sci_Map$Map3.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Map$Map3.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1)) {
    return this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1;
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2)) {
    return this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2;
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3)) {
    return this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3;
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$c_sci_Map$Map3.prototype.contains__O__Z = (function(key) {
  return (($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3));
});
$c_sci_Map$Map3.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? new $c_s_Some(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? new $c_s_Some(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? new $c_s_Some(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : $m_s_None$())));
});
$c_sci_Map$Map3.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3 : $n(default$1).apply__O())));
});
$c_sci_Map$Map3.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map3$$anon$4(this);
});
$c_sci_Map$Map3.prototype.keysIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map3$$anon$5(this);
});
$c_sci_Map$Map3.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map3$$anon$6(this);
});
$c_sci_Map$Map3.prototype.updated__O__O__sci_Map = (function(key, value) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? new $c_sci_Map$Map3(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, value, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? new $c_sci_Map$Map3(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, value, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? new $c_sci_Map$Map3(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, value) : new $c_sci_Map$Map4(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3, key, value))));
});
$c_sci_Map$Map3.prototype.removed__O__sci_Map = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? new $c_sci_Map$Map2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? new $c_sci_Map$Map2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? new $c_sci_Map$Map2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2) : this)));
});
$c_sci_Map$Map3.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1));
  $n(f).apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2));
  $n(f).apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3));
});
$c_sci_Map$Map3.prototype.forall__F1__Z = (function(p) {
  return (($uZ($n(p).apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1))) && $uZ($n(p).apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2)))) && $uZ($n(p).apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3))));
});
$c_sci_Map$Map3.prototype.filterImpl__F1__Z__sci_Map = (function(pred, isFlipped) {
  var k1 = null;
  var k2 = null;
  var v1 = null;
  var v2 = null;
  var n = 0;
  if (($uZ($n(pred).apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1))) !== isFlipped)) {
    k1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1;
    v1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1;
    n = ((1 + n) | 0);
  }
  if (($uZ($n(pred).apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2;
      v1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2;
    } else {
      k2 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2;
      v2 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2;
    }
    n = ((1 + n) | 0);
  }
  if (($uZ($n(pred).apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3;
      v1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3;
    } else if ((n === 1)) {
      k2 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3;
      v2 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3;
    }
    n = ((1 + n) | 0);
  }
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Map$EmptyMap$();
      break;
    }
    case 1: {
      return new $c_sci_Map$Map1(k1, v1);
      break;
    }
    case 2: {
      return new $c_sci_Map$Map2(k1, v1, k2, v2);
      break;
    }
    case 3: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
});
$c_sci_Map$Map3.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 3);
});
$c_sci_Map$Map3.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map(key);
});
$c_sci_Map$Map3.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value);
});
function $as_sci_Map$Map3(obj) {
  return (((obj instanceof $c_sci_Map$Map3) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Map$Map3"));
}
function $isArrayOf_sci_Map$Map3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Map$Map3)));
}
function $asArrayOf_sci_Map$Map3(obj, depth) {
  return (($isArrayOf_sci_Map$Map3(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Map$Map3;", depth));
}
var $d_sci_Map$Map3 = new $TypeData().initClass($c_sci_Map$Map3, "scala.collection.immutable.Map$Map3", ({
  sci_Map$Map3: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Map$Map4(key1, value1, key2, value2, key3, value3, key4, value4) {
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1 = key1;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1 = value1;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2 = key2;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2 = value2;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3 = key3;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3 = value3;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4 = key4;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4 = value4;
}
$c_sci_Map$Map4.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map4.prototype.constructor = $c_sci_Map$Map4;
/** @constructor */
function $h_sci_Map$Map4() {
}
$h_sci_Map$Map4.prototype = $c_sci_Map$Map4.prototype;
$c_sci_Map$Map4.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_sci_Map$Map4.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Map$Map4.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_Map$Map4.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_sci_Map$Map4.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, false);
});
$c_sci_Map$Map4.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, true);
});
$c_sci_Map$Map4.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Map$Map4.prototype.size__I = (function() {
  return 4;
});
$c_sci_Map$Map4.prototype.knownSize__I = (function() {
  return 4;
});
$c_sci_Map$Map4.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Map$Map4.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1;
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2;
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3;
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4;
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$c_sci_Map$Map4.prototype.contains__O__Z = (function(key) {
  return ((($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3)) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4));
});
$c_sci_Map$Map4.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4) : $m_s_None$()))));
});
$c_sci_Map$Map4.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4 : $n(default$1).apply__O()))));
});
$c_sci_Map$Map4.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map4$$anon$7(this);
});
$c_sci_Map$Map4.prototype.keysIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map4$$anon$8(this);
});
$c_sci_Map$Map4.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map4$$anon$9(this);
});
$c_sci_Map$Map4.prototype.updated__O__O__sci_Map = (function(key, value) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, value, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4);
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, value, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4);
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, value, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4);
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, value);
  } else {
    var this$1 = $m_sci_HashMap$();
    return $n($n($n($n($n(this$1.sci_HashMap$__f_EmptyMap).updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1)).updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2)).updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3)).updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4)).updated__O__O__sci_HashMap(key, value);
  }
});
$c_sci_Map$Map4.prototype.removed__O__sci_Map = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) ? new $c_sci_Map$Map3(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2) ? new $c_sci_Map$Map3(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3) ? new $c_sci_Map$Map3(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4) ? new $c_sci_Map$Map3(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3) : this))));
});
$c_sci_Map$Map4.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1));
  $n(f).apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2));
  $n(f).apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3));
  $n(f).apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4));
});
$c_sci_Map$Map4.prototype.forall__F1__Z = (function(p) {
  return ((($uZ($n(p).apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1))) && $uZ($n(p).apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2)))) && $uZ($n(p).apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3)))) && $uZ($n(p).apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4))));
});
$c_sci_Map$Map4.prototype.filterImpl__F1__Z__sci_Map = (function(pred, isFlipped) {
  var k1 = null;
  var k2 = null;
  var k3 = null;
  var v1 = null;
  var v2 = null;
  var v3 = null;
  var n = 0;
  if (($uZ($n(pred).apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1))) !== isFlipped)) {
    k1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1;
    v1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1;
    n = ((1 + n) | 0);
  }
  if (($uZ($n(pred).apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2;
      v1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2;
    } else {
      k2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2;
      v2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2;
    }
    n = ((1 + n) | 0);
  }
  if (($uZ($n(pred).apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3;
      v1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3;
    } else if ((n === 1)) {
      k2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3;
      v2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3;
    } else {
      k3 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3;
      v3 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3;
    }
    n = ((1 + n) | 0);
  }
  if (($uZ($n(pred).apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4;
      v1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4;
    } else if ((n === 1)) {
      k2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4;
      v2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4;
    } else if ((n === 2)) {
      k3 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4;
      v3 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4;
    }
    n = ((1 + n) | 0);
  }
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Map$EmptyMap$();
      break;
    }
    case 1: {
      return new $c_sci_Map$Map1(k1, v1);
      break;
    }
    case 2: {
      return new $c_sci_Map$Map2(k1, v1, k2, v2);
      break;
    }
    case 3: {
      return new $c_sci_Map$Map3(k1, v1, k2, v2, k3, v3);
      break;
    }
    case 4: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
});
$c_sci_Map$Map4.prototype.buildTo__sci_HashMapBuilder__sci_HashMapBuilder = (function(builder) {
  return $n($n($n($n(builder).addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1)).addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2)).addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3)).addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4);
});
$c_sci_Map$Map4.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 4);
});
$c_sci_Map$Map4.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map(key);
});
$c_sci_Map$Map4.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value);
});
function $as_sci_Map$Map4(obj) {
  return (((obj instanceof $c_sci_Map$Map4) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Map$Map4"));
}
function $isArrayOf_sci_Map$Map4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Map$Map4)));
}
function $asArrayOf_sci_Map$Map4(obj, depth) {
  return (($isArrayOf_sci_Map$Map4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Map$Map4;", depth));
}
var $d_sci_Map$Map4 = new $TypeData().initClass($c_sci_Map$Map4, "scala.collection.immutable.Map$Map4", ({
  sci_Map$Map4: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
function $f_scm_Map__withDefaultValue__O__scm_Map($thiz, d) {
  return new $c_scm_Map$WithDefault($thiz, new $c_sjsr_AnonFunction1(((x$2) => d)));
}
function $is_scm_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Map)));
}
function $as_scm_Map(obj) {
  return (($is_scm_Map(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Map"));
}
function $isArrayOf_scm_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Map)));
}
function $asArrayOf_scm_Map(obj, depth) {
  return (($isArrayOf_scm_Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Map;", depth));
}
/** @constructor */
function $c_Lcats_EvalInstances$$anon$6() {
}
$c_Lcats_EvalInstances$$anon$6.prototype = new $h_O();
$c_Lcats_EvalInstances$$anon$6.prototype.constructor = $c_Lcats_EvalInstances$$anon$6;
/** @constructor */
function $h_Lcats_EvalInstances$$anon$6() {
}
$h_Lcats_EvalInstances$$anon$6.prototype = $c_Lcats_EvalInstances$$anon$6.prototype;
$c_Lcats_EvalInstances$$anon$6.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_Lcats_Eval(fa);
  return $n(fa$1).map__F1__Lcats_Eval(f);
});
$c_Lcats_EvalInstances$$anon$6.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_EvalInstances$$anon$6.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_EvalInstances$$anon$6.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_EvalInstances$$anon$6.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_EvalInstances$$anon$6.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_EvalInstances$$anon$6.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_EvalInstances$$anon$6.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_EvalInstances$$anon$6.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_EvalInstances$$anon$6.prototype.tailRecM__O__F1__O = (function(a, f) {
  return $f_Lcats_StackSafeMonad__tailRecM__O__F1__O(this, a, f);
});
$c_Lcats_EvalInstances$$anon$6.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_Eval(fa);
  return $n(fa$1).map__F1__Lcats_Eval(f);
});
$c_Lcats_EvalInstances$$anon$6.prototype.pure__O__O = (function(x) {
  return new $c_Lcats_Now(x);
});
$c_Lcats_EvalInstances$$anon$6.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_Eval(fa);
  return $n(fa$1).flatMap__F1__Lcats_Eval(f);
});
$c_Lcats_EvalInstances$$anon$6.prototype.unit__O = (function() {
  return $m_Lcats_Eval$().Lcats_Eval$__f_Unit;
});
$c_Lcats_EvalInstances$$anon$6.prototype.void__O__O = (function(fa) {
  $as_Lcats_Eval(fa);
  return $m_Lcats_Eval$().Lcats_Eval$__f_Unit;
});
var $d_Lcats_EvalInstances$$anon$6 = new $TypeData().initClass($c_Lcats_EvalInstances$$anon$6, "cats.EvalInstances$$anon$6", ({
  Lcats_EvalInstances$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Comonad: 1,
  Lcats_Bimonad: 1,
  Lcats_StackSafeMonad: 1,
  Lcats_CommutativeApply: 1,
  Lcats_CommutativeFlatMap: 1,
  Lcats_CommutativeApplicative: 1,
  Lcats_CommutativeMonad: 1
}));
function $f_Lcats_effect_kernel_GenConcurrent$KleisliGenConcurrent__ref__O__Lcats_data_Kleisli($thiz, a) {
  var this$4 = $m_Lcats_data_Kleisli$();
  var x = $n($thiz.F__Lcats_effect_kernel_GenConcurrent()).map__O__F1__O($n($thiz.F__Lcats_effect_kernel_GenConcurrent()).ref__O__O(a), new $c_sjsr_AnonFunction1(((_$54) => {
    var _$54$1 = $as_Lcats_effect_kernel_Ref(_$54);
    var this$3 = $n(_$54$1);
    $m_Lcats_data_Kleisli$();
    var f = new $c_Lcats_data_KleisliFunctions$$anon$3();
    var F = $thiz.F__Lcats_effect_kernel_GenConcurrent();
    return new $c_Lcats_effect_kernel_Ref$TransformedRef(this$3, f, F);
  })));
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$4, x);
}
function $f_Lcats_effect_kernel_GenConcurrent$KleisliGenConcurrent__deferred__Lcats_data_Kleisli($thiz) {
  var this$4 = $m_Lcats_data_Kleisli$();
  var x = $n($thiz.F__Lcats_effect_kernel_GenConcurrent()).map__O__F1__O($n($thiz.F__Lcats_effect_kernel_GenConcurrent()).deferred__O(), new $c_sjsr_AnonFunction1(((_$56) => {
    var _$56$1 = $as_Lcats_effect_kernel_Deferred(_$56);
    var this$3 = $n(_$56$1);
    $m_Lcats_data_Kleisli$();
    var f = new $c_Lcats_data_KleisliFunctions$$anon$3();
    return new $c_Lcats_effect_kernel_Deferred$TransformedDeferred(this$3, f);
  })));
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$4, x);
}
function $is_Lcats_effect_kernel_GenTemporal(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_kernel_GenTemporal)));
}
function $as_Lcats_effect_kernel_GenTemporal(obj) {
  return (($is_Lcats_effect_kernel_GenTemporal(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.GenTemporal"));
}
function $isArrayOf_Lcats_effect_kernel_GenTemporal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_GenTemporal)));
}
function $asArrayOf_Lcats_effect_kernel_GenTemporal(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_GenTemporal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.GenTemporal;", depth));
}
/** @constructor */
function $c_Lcats_instances_EitherInstances$$anon$2() {
}
$c_Lcats_instances_EitherInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_EitherInstances$$anon$2.prototype.constructor = $c_Lcats_instances_EitherInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_EitherInstances$$anon$2() {
}
$h_Lcats_instances_EitherInstances$$anon$2.prototype = $c_Lcats_instances_EitherInstances$$anon$2.prototype;
$c_Lcats_instances_EitherInstances$$anon$2.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_s_util_Either(fa);
  return $n(fa$1).map__F1__s_util_Either(f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.maximumOption__O__Lcats_kernel_Order__s_Option = (function(fa, A) {
  return $f_Lcats_Foldable__maximumOption__O__Lcats_kernel_Order__s_Option(this, fa, A);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.fold__O__Lcats_kernel_Monoid__O = (function(fa, A) {
  return $f_Lcats_Foldable__fold__O__Lcats_kernel_Monoid__O(this, fa, A);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O(this, fa, z, f, G);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverse___O__F1__Lcats_Applicative__O(this, fa, f, G);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return this.foldMap__s_util_Either__F1__Lcats_kernel_Monoid__O($as_s_util_Either(fa), f, evidence$1);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$1) {
  return this.traverse__s_util_Either__F1__Lcats_Applicative__O($as_s_util_Either(sa), f, evidence$1);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.unit__s_util_Either = (function() {
  return $m_Lcats_syntax_EitherUtil$().Lcats_syntax_EitherUtil$__f_unit;
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.handleErrorWith__s_util_Either__F1__s_util_Either = (function(fea, f) {
  if ((fea instanceof $c_s_util_Left)) {
    var e = $n($as_s_util_Left(fea)).s_util_Left__f_value;
    return $as_s_util_Either($n(f).apply__O__O(e));
  }
  if ((fea instanceof $c_s_util_Right)) {
    var r = $as_s_util_Right(fea);
    return r;
  }
  throw new $c_s_MatchError(fea);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.tailRecM__O__F1__s_util_Either = (function(b, f) {
  var b$tailLocal1 = b;
  while (true) {
    var x26 = $as_s_util_Either($n(f).apply__O__O(b$tailLocal1));
    if ((x26 instanceof $c_s_util_Left)) {
      var left = $as_s_util_Left(x26);
      return left;
    }
    if ((x26 instanceof $c_s_util_Right)) {
      var e = $as_s_util_Either($n($as_s_util_Right(x26)).s_util_Right__f_value);
      if ((e instanceof $c_s_util_Left)) {
        var b1 = $n($as_s_util_Left(e)).s_util_Left__f_value;
        b$tailLocal1 = b1;
        continue;
      }
      if ((e instanceof $c_s_util_Right)) {
        var right = $as_s_util_Right(e);
        return right;
      }
      throw new $c_s_MatchError(e);
    }
    throw new $c_s_MatchError(x26);
  }
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.map2Eval__s_util_Either__Lcats_Eval__F2__Lcats_Eval = (function(fb, fc, f) {
  if ((fb instanceof $c_s_util_Left)) {
    var l = $as_s_util_Left(fb);
    $m_Lcats_syntax_EitherUtil$();
    return new $c_Lcats_Now(l);
  }
  if ((fb instanceof $c_s_util_Right)) {
    var b = $n($as_s_util_Right(fb)).s_util_Right__f_value;
    return $n(fc).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((_$10) => {
      var _$10$1 = $as_s_util_Either(_$10);
      var this$3 = $n(_$10$1);
      if ((this$3 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(this$3);
        var b$1 = $n(x2).s_util_Right__f_value;
        return new $c_s_util_Right($n(f).apply__O__O__O(b, b$1));
      } else {
        return this$3;
      }
    })));
  }
  throw new $c_s_MatchError(fb);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.traverse__s_util_Either__F1__Lcats_Applicative__O = (function(fa, f, F) {
  if ((fa instanceof $c_s_util_Left)) {
    var left = $as_s_util_Left(fa);
    return $n(F).pure__O__O(left);
  }
  if ((fa instanceof $c_s_util_Right)) {
    var b = $n($as_s_util_Right(fa)).s_util_Right__f_value;
    return $n(F).map__O__F1__O($n(f).apply__O__O(b), new $c_sjsr_AnonFunction1(((_$13) => new $c_s_util_Right(_$13))));
  }
  throw new $c_s_MatchError(fa);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldLeft__s_util_Either__O__F2__O = (function(fa, c, f) {
  if ((fa instanceof $c_s_util_Left)) {
    return c;
  }
  if ((fa instanceof $c_s_util_Right)) {
    var b = $n($as_s_util_Right(fa)).s_util_Right__f_value;
    return $n(f).apply__O__O__O(c, b);
  }
  throw new $c_s_MatchError(fa);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldRight__s_util_Either__Lcats_Eval__F2__Lcats_Eval = (function(fa, lc, f) {
  if ((fa instanceof $c_s_util_Left)) {
    return lc;
  }
  if ((fa instanceof $c_s_util_Right)) {
    var b = $n($as_s_util_Right(fa)).s_util_Right__f_value;
    return $as_Lcats_Eval($n(f).apply__O__O__O(b, lc));
  }
  throw new $c_s_MatchError(fa);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.reduceLeftToOption__s_util_Either__F1__F2__s_Option = (function(fab, f, g) {
  return $n($n(fab).map__F1__s_util_Either(f)).toOption__s_Option();
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.size__s_util_Either__J = (function(fab) {
  var this$1 = $n(fab);
  if ((this$1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$1);
    $n(x2);
    return new $c_RTLong(1, 0);
  } else {
    if ((!(this$1 instanceof $c_s_util_Left))) {
      throw new $c_s_MatchError(this$1);
    }
    var x3 = $as_s_util_Left(this$1);
    $n(x3);
    return $L0;
  }
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldMap__s_util_Either__F1__Lcats_kernel_Monoid__O = (function(fab, f, C) {
  var this$1 = $n(fab);
  if ((this$1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$1);
    var b = $n(x2).s_util_Right__f_value;
    return $n(f).apply__O__O(b);
  } else if ((this$1 instanceof $c_s_util_Left)) {
    var x3 = $as_s_util_Left(this$1);
    $n(x3);
    return $n(C).empty__O();
  } else {
    throw new $c_s_MatchError(this$1);
  }
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.toList__s_util_Either__sci_List = (function(fab) {
  if ((fab instanceof $c_s_util_Right)) {
    var a = $n($as_s_util_Right(fab)).s_util_Right__f_value;
    var this$1 = $m_sci_Nil$();
    return new $c_sci_$colon$colon(a, this$1);
  }
  if ((fab instanceof $c_s_util_Left)) {
    return $m_sci_Nil$();
  }
  throw new $c_s_MatchError(fab);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.void__s_util_Either__s_util_Either = (function(e) {
  return ($n(e).isRight__Z() ? $m_Lcats_syntax_EitherUtil$().Lcats_syntax_EitherUtil$__f_unit : e);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.unit__O = (function() {
  return this.unit__s_util_Either();
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.pure__O__O = (function(x) {
  return new $c_s_util_Right(x);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_s_util_Either(fa);
  return $n(fa$1).flatMap__F1__s_util_Either(f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return this.handleErrorWith__s_util_Either__F1__s_util_Either($as_s_util_Either(fa), f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.raiseError__O__O = (function(e) {
  return new $c_s_util_Left(e);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_s_util_Either(fa);
  return $n(fa$1).map__F1__s_util_Either(f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__s_util_Either(a, f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__s_util_Either__Lcats_Eval__F2__Lcats_Eval($as_s_util_Either(fa), fb, f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__s_util_Either__F1__Lcats_Applicative__O($as_s_util_Either(fa), f, evidence$1);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  return this.foldLeft__s_util_Either__O__F2__O($as_s_util_Either(fa), b, f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__s_util_Either__Lcats_Eval__F2__Lcats_Eval($as_s_util_Either(fa), lb, f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.attempt__O__O = (function(fa) {
  var fab = $as_s_util_Either(fa);
  return new $c_s_util_Right(fab);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.reduceLeftToOption__O__F1__F2__s_Option = (function(fa, f, g) {
  return this.reduceLeftToOption__s_util_Either__F1__F2__s_Option($as_s_util_Either(fa), f, g);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.reduceLeftOption__O__F2__s_Option = (function(fa, f) {
  var fab = $as_s_util_Either(fa);
  return $n(fab).toOption__s_Option();
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.size__O__J = (function(fa) {
  return this.size__s_util_Either__J($as_s_util_Either(fa));
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__s_util_Either__F1__Lcats_kernel_Monoid__O($as_s_util_Either(fa), f, B);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.toList__O__sci_List = (function(fa) {
  return this.toList__s_util_Either__sci_List($as_s_util_Either(fa));
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.toIterable__O__sc_Iterable = (function(fa) {
  var fab = $as_s_util_Either(fa);
  return this.toList__s_util_Either__sci_List(fab);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.void__O__O = (function(fa) {
  return this.void__s_util_Either__s_util_Either($as_s_util_Either(fa));
});
var $d_Lcats_instances_EitherInstances$$anon$2 = new $TypeData().initClass($c_Lcats_instances_EitherInstances$$anon$2, "cats.instances.EitherInstances$$anon$2", ({
  Lcats_instances_EitherInstances$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Align: 1
}));
/** @constructor */
function $c_Lorg_scalajs_dom_NamedNodeMapMap(namedNodeMap) {
  this.Lorg_scalajs_dom_NamedNodeMapMap__f_org$scalajs$dom$NamedNodeMapMap$$namedNodeMap = null;
  this.Lorg_scalajs_dom_NamedNodeMapMap__f_org$scalajs$dom$NamedNodeMapMap$$namedNodeMap = namedNodeMap;
}
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype = new $h_O();
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.constructor = $c_Lorg_scalajs_dom_NamedNodeMapMap;
/** @constructor */
function $h_Lorg_scalajs_dom_NamedNodeMapMap() {
}
$h_Lorg_scalajs_dom_NamedNodeMapMap.prototype = $c_Lorg_scalajs_dom_NamedNodeMapMap.prototype;
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.isEmpty__Z = (function() {
  return $f_sc_IterableOnceOps__isEmpty__Z(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.size__I = (function() {
  return $f_sc_IterableOnceOps__size__I(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.head__O = (function() {
  var this$1 = new $c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1(this);
  return this$1.next__T2();
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.headOption__s_Option = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.last__O = (function() {
  return $f_sc_IterableOps__last__O(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.filter__F1__O = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_IterableOps__partition__F1__T2(this, p);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.take__I__O = (function(n) {
  return $f_sc_IterableOps__take__I__O(this, n);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.takeWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__takeWhile__F1__O(this, p);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.drop__I__O = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IterableOps__dropRight__I__O(this, n);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.dropWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__dropWhile__F1__O(this, p);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.map__F1__O = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_IterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.className__T = (function() {
  return "Map";
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_Iterable$();
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.orElse__s_PartialFunction__s_PartialFunction = (function(that) {
  return new $c_s_PartialFunction$OrElse(this, that);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.apply__O__O = (function(key) {
  return $f_sc_MapOps__apply__O__O(this, key);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_sc_MapOps__applyOrElse__O__F1__O(this, x, default$1);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.keysIterator__sc_Iterator = (function() {
  return new $c_sc_MapOps$$anon$2(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sc_MapOps$$anon$3(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.foreachEntry__F2__V = (function(f) {
  $f_sc_MapOps__foreachEntry__F2__V(this, f);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.default__O__O = (function(key) {
  return $f_sc_MapOps__default__O__O(this, key);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.contains__O__Z = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.isDefinedAt__O__Z = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return $f_sc_MapOps__concat__sc_IterableOnce__sc_IterableOps(this, suffix);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  return $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, sb, start, sep, end);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_scm_Map$().newBuilder__scm_Builder();
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.empty__sc_IterableOps = (function() {
  return $f_sc_MapFactoryDefaults__empty__sc_IterableOps(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.equals__O__Z = (function(o) {
  return $f_sc_Map__equals__O__Z(this, o);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().mapHash__sc_Map__I(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.sizeHint__I__V = (function(size) {
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.update__O__O__V = (function(key, value) {
  $f_scm_MapOps__update__O__O__V(this, key, value);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.getOrElseUpdate__O__F0__O = (function(key, op) {
  return $f_scm_MapOps__getOrElseUpdate__O__F0__O(this, key, op);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.knownSize__I = (function() {
  return (-1);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_scm_Map$();
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.iterator__sc_Iterator = (function() {
  return new $c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.get__T__s_Option = (function(key) {
  var x1 = this.Lorg_scalajs_dom_NamedNodeMapMap__f_org$scalajs$dom$NamedNodeMapMap$$namedNodeMap.getNamedItem(key);
  if ((x1 === null)) {
    return $m_s_None$();
  }
  return new $c_s_Some(x1);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.addOne__T2__Lorg_scalajs_dom_NamedNodeMapMap = (function(kv) {
  this.Lorg_scalajs_dom_NamedNodeMapMap__f_org$scalajs$dom$NamedNodeMapMap$$namedNodeMap.setNamedItem($n(kv)._2__O());
  return this;
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.subtractOne__T__Lorg_scalajs_dom_NamedNodeMapMap = (function(key) {
  this.Lorg_scalajs_dom_NamedNodeMapMap__f_org$scalajs$dom$NamedNodeMapMap$$namedNodeMap.removeNamedItem(key);
  return this;
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.get__O__s_Option = (function(key) {
  return this.get__T__s_Option($as_T(key));
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__Lorg_scalajs_dom_NamedNodeMapMap($as_T2(elem));
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__T__Lorg_scalajs_dom_NamedNodeMapMap($as_T(elem));
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.result__O = (function() {
  return this;
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $as_sc_IterableOps($m_scm_Map$().from__sc_IterableOnce__O(coll));
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ($f_sc_MapOps__apply__O__O(this, v1));
});
var $d_Lorg_scalajs_dom_NamedNodeMapMap = new $TypeData().initClass($c_Lorg_scalajs_dom_NamedNodeMapMap, "org.scalajs.dom.NamedNodeMapMap", ({
  Lorg_scalajs_dom_NamedNodeMapMap: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_IterableOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Iterable: 1,
  scm_Iterable: 1,
  F1: 1,
  s_PartialFunction: 1,
  sc_MapOps: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sc_Map: 1,
  jl_Cloneable: 1,
  scm_Cloneable: 1,
  scm_Clearable: 1,
  scm_Growable: 1,
  scm_Builder: 1,
  scm_Shrinkable: 1,
  scm_MapOps: 1,
  scm_Map: 1
}));
function $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet($thiz, newRootNode) {
  return (($thiz.sci_HashSet__f_rootNode === newRootNode) ? $thiz : new $c_sci_HashSet(newRootNode));
}
/** @constructor */
function $c_sci_HashSet(rootNode) {
  this.sci_HashSet__f_rootNode = null;
  this.sci_HashSet__f_rootNode = rootNode;
}
$c_sci_HashSet.prototype = new $h_sci_AbstractSet();
$c_sci_HashSet.prototype.constructor = $c_sci_HashSet;
/** @constructor */
function $h_sci_HashSet() {
}
$h_sci_HashSet.prototype = $c_sci_HashSet.prototype;
$c_sci_HashSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_HashSet.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_HashSet.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_sci_HashSet.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_HashSet(pred, false);
});
$c_sci_HashSet.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_HashSet(pred, true);
});
$c_sci_HashSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_HashSet$();
});
$c_sci_HashSet.prototype.knownSize__I = (function() {
  return $n(this.sci_HashSet__f_rootNode).sci_BitmapIndexedSetNode__f_size;
});
$c_sci_HashSet.prototype.size__I = (function() {
  return $n(this.sci_HashSet__f_rootNode).sci_BitmapIndexedSetNode__f_size;
});
$c_sci_HashSet.prototype.isEmpty__Z = (function() {
  return ($n(this.sci_HashSet__f_rootNode).sci_BitmapIndexedSetNode__f_size === 0);
});
$c_sci_HashSet.prototype.iterator__sc_Iterator = (function() {
  return (this.isEmpty__Z() ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_SetIterator(this.sci_HashSet__f_rootNode));
});
$c_sci_HashSet.prototype.contains__O__Z = (function(element) {
  var elementUnimprovedHash = $m_sr_Statics$().anyHash__O__I(element);
  var elementHash = $m_sc_Hashing$().improve__I__I(elementUnimprovedHash);
  return $n(this.sci_HashSet__f_rootNode).contains__O__I__I__I__Z(element, elementUnimprovedHash, elementHash, 0);
});
$c_sci_HashSet.prototype.incl__O__sci_HashSet = (function(element) {
  var elementUnimprovedHash = $m_sr_Statics$().anyHash__O__I(element);
  var elementHash = $m_sc_Hashing$().improve__I__I(elementUnimprovedHash);
  var newRootNode = $n(this.sci_HashSet__f_rootNode).updated__O__I__I__I__sci_BitmapIndexedSetNode(element, elementUnimprovedHash, elementHash, 0);
  return $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, newRootNode);
});
$c_sci_HashSet.prototype.excl__O__sci_HashSet = (function(element) {
  var elementUnimprovedHash = $m_sr_Statics$().anyHash__O__I(element);
  var elementHash = $m_sc_Hashing$().improve__I__I(elementUnimprovedHash);
  var newRootNode = $n(this.sci_HashSet__f_rootNode).removed__O__I__I__I__sci_BitmapIndexedSetNode(element, elementUnimprovedHash, elementHash, 0);
  return $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, newRootNode);
});
$c_sci_HashSet.prototype.concat__sc_IterableOnce__sci_HashSet = (function(that) {
  if ((that instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(that);
    if (this.isEmpty__Z()) {
      return x2;
    } else {
      var newNode = $n(this.sci_HashSet__f_rootNode).concat__sci_SetNode__I__sci_BitmapIndexedSetNode($n(x2).sci_HashSet__f_rootNode, 0);
      return ((newNode === $n(x2).sci_HashSet__f_rootNode) ? x2 : $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, newNode));
    }
  } else if ((that instanceof $c_scm_HashSet)) {
    var x3 = $as_scm_HashSet(that);
    var this$1 = $n(x3);
    var iter = new $c_scm_HashSet$$anon$2(this$1);
    var current = this.sci_HashSet__f_rootNode;
    while (iter.hasNext__Z()) {
      var next = $as_scm_HashSet$Node(iter.next__O());
      var this$2 = $n(x3);
      var improvedHash = $n(next).scm_HashSet$Node__f__hash;
      var originalHash = this$2.scala$collection$mutable$HashSet$$improveHash__I__I(improvedHash);
      var improved = $m_sc_Hashing$().improve__I__I(originalHash);
      current = $n(current).updated__O__I__I__I__sci_BitmapIndexedSetNode($n(next).scm_HashSet$Node__f__key, originalHash, improved, 0);
      if ((current !== this.sci_HashSet__f_rootNode)) {
        var shallowlyMutableNodeMap = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(improved, 0));
        while (iter.hasNext__Z()) {
          var next$2 = $as_scm_HashSet$Node(iter.next__O());
          var this$3 = $n(x3);
          var improvedHash$1 = $n(next$2).scm_HashSet$Node__f__hash;
          var originalHash$2 = this$3.scala$collection$mutable$HashSet$$improveHash__I__I(improvedHash$1);
          var improved$2 = $m_sc_Hashing$().improve__I__I(originalHash$2);
          shallowlyMutableNodeMap = $n(current).updateWithShallowMutations__O__I__I__I__I__I($n(next$2).scm_HashSet$Node__f__key, originalHash$2, improved$2, 0, shallowlyMutableNodeMap);
        }
        return new $c_sci_HashSet(current);
      }
    }
    return this;
  } else if (false) {
    var x4 = $as_scm_LinkedHashSet(that);
    var iter$2 = $n(x4).entryIterator__sc_Iterator();
    var current$2 = this.sci_HashSet__f_rootNode;
    while ($n(iter$2).hasNext__Z()) {
      var next$3 = $as_scm_LinkedHashSet$Entry($n(iter$2).next__O());
      var originalHash$3 = $n(x4).unimproveHash__I__I($n(next$3).hash__I());
      var improved$3 = $m_sc_Hashing$().improve__I__I(originalHash$3);
      current$2 = $n(current$2).updated__O__I__I__I__sci_BitmapIndexedSetNode($n(next$3).key__O(), originalHash$3, improved$3, 0);
      if ((current$2 !== this.sci_HashSet__f_rootNode)) {
        var shallowlyMutableNodeMap$2 = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(improved$3, 0));
        while ($n(iter$2).hasNext__Z()) {
          var next$4 = $as_scm_LinkedHashSet$Entry($n(iter$2).next__O());
          var originalHash$4 = $n(x4).unimproveHash__I__I($n(next$4).hash__I());
          var improved$4 = $m_sc_Hashing$().improve__I__I(originalHash$4);
          shallowlyMutableNodeMap$2 = $n(current$2).updateWithShallowMutations__O__I__I__I__I__I($n(next$4).key__O(), originalHash$4, improved$4, 0, shallowlyMutableNodeMap$2);
        }
        return new $c_sci_HashSet(current$2);
      }
    }
    return this;
  } else {
    var iter$3 = $n(that).iterator__sc_Iterator();
    var current$3 = this.sci_HashSet__f_rootNode;
    while ($n(iter$3).hasNext__Z()) {
      var element = $n(iter$3).next__O();
      var originalHash$5 = $m_sr_Statics$().anyHash__O__I(element);
      var improved$5 = $m_sc_Hashing$().improve__I__I(originalHash$5);
      current$3 = $n(current$3).updated__O__I__I__I__sci_BitmapIndexedSetNode(element, originalHash$5, improved$5, 0);
      if ((current$3 !== this.sci_HashSet__f_rootNode)) {
        var shallowlyMutableNodeMap$3 = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(improved$5, 0));
        while ($n(iter$3).hasNext__Z()) {
          var element$2 = $n(iter$3).next__O();
          var originalHash$6 = $m_sr_Statics$().anyHash__O__I(element$2);
          var improved$6 = $m_sc_Hashing$().improve__I__I(originalHash$6);
          shallowlyMutableNodeMap$3 = $n(current$3).updateWithShallowMutations__O__I__I__I__I__I(element$2, originalHash$6, improved$6, 0, shallowlyMutableNodeMap$3);
        }
        return new $c_sci_HashSet(current$3);
      }
    }
    return this;
  }
});
$c_sci_HashSet.prototype.head__O = (function() {
  return $n(this.iterator__sc_Iterator()).next__O();
});
$c_sci_HashSet.prototype.last__O = (function() {
  return new $c_sci_SetReverseIterator(this.sci_HashSet__f_rootNode).next__O();
});
$c_sci_HashSet.prototype.foreach__F1__V = (function(f) {
  $n(this.sci_HashSet__f_rootNode).foreach__F1__V(f);
});
$c_sci_HashSet.prototype.subsetOf__sc_Set__Z = (function(that) {
  if (this.isEmpty__Z()) {
    return true;
  } else if ((!$n(that).isEmpty__Z())) {
    if ((that instanceof $c_sci_HashSet)) {
      var x2 = $as_sci_HashSet(that);
      return $n(this.sci_HashSet__f_rootNode).subsetOf__sci_SetNode__I__Z($n(x2).sci_HashSet__f_rootNode, 0);
    } else {
      return $f_sc_IterableOnceOps__forall__F1__Z(this, that);
    }
  } else {
    return false;
  }
});
$c_sci_HashSet.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(that);
    if ((this === x2)) {
      return true;
    } else {
      var x = this.sci_HashSet__f_rootNode;
      var x$2 = $n(x2).sci_HashSet__f_rootNode;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    }
  } else {
    return $f_sc_Set__equals__O__Z(this, that);
  }
});
$c_sci_HashSet.prototype.className__T = (function() {
  return "HashSet";
});
$c_sci_HashSet.prototype.hashCode__I = (function() {
  var it = new $c_sci_SetHashIterator(this.sci_HashSet__f_rootNode);
  var hash = $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(it, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_setSeed);
  return hash;
});
$c_sci_HashSet.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_sci_HashSet.prototype.filterImpl__F1__Z__sci_HashSet = (function(pred, isFlipped) {
  var newRootNode = $n(this.sci_HashSet__f_rootNode).filterImpl__F1__Z__sci_BitmapIndexedSetNode(pred, isFlipped);
  if ((newRootNode === this.sci_HashSet__f_rootNode)) {
    return this;
  } else if (($n(newRootNode).sci_BitmapIndexedSetNode__f_size === 0)) {
    var this$1 = $m_sci_HashSet$();
    return this$1.sci_HashSet$__f_EmptySet;
  } else {
    return new $c_sci_HashSet(newRootNode);
  }
});
$c_sci_HashSet.prototype.dropWhile__F1__O = (function(p) {
  return $as_sci_HashSet($f_sc_IterableOps__dropWhile__F1__O(this, p));
});
$c_sci_HashSet.prototype.dropRight__I__O = (function(n) {
  return $as_sci_HashSet($f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n));
});
$c_sci_HashSet.prototype.drop__I__O = (function(n) {
  return $as_sci_HashSet($f_sc_IterableOps__drop__I__O(this, n));
});
$c_sci_HashSet.prototype.takeWhile__F1__O = (function(p) {
  return $as_sci_HashSet($f_sc_IterableOps__takeWhile__F1__O(this, p));
});
$c_sci_HashSet.prototype.take__I__O = (function(n) {
  return $as_sci_HashSet($f_sc_IterableOps__take__I__O(this, n));
});
$c_sci_HashSet.prototype.tail__O = (function() {
  var elem = $n(this.iterator__sc_Iterator()).next__O();
  return this.excl__O__sci_HashSet(elem);
});
$c_sci_HashSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  return this.concat__sc_IterableOnce__sci_HashSet(that);
});
$c_sci_HashSet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_HashSet(elem);
});
$c_sci_HashSet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_HashSet(elem);
});
function $as_sci_HashSet(obj) {
  return (((obj instanceof $c_sci_HashSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashSet"));
}
function $isArrayOf_sci_HashSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashSet)));
}
function $asArrayOf_sci_HashSet(obj, depth) {
  return (($isArrayOf_sci_HashSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashSet;", depth));
}
var $d_sci_HashSet = new $TypeData().initClass($c_sci_HashSet, "scala.collection.immutable.HashSet", ({
  sci_HashSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
function $as_sci_ListSet(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ListSet"));
}
function $isArrayOf_sci_ListSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ListSet)));
}
function $asArrayOf_sci_ListSet(obj, depth) {
  return (($isArrayOf_sci_ListSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ListSet;", depth));
}
/** @constructor */
function $c_scm_AbstractSet() {
}
$c_scm_AbstractSet.prototype = new $h_sc_AbstractSet();
$c_scm_AbstractSet.prototype.constructor = $c_scm_AbstractSet;
/** @constructor */
function $h_scm_AbstractSet() {
}
$h_scm_AbstractSet.prototype = $c_scm_AbstractSet.prototype;
$c_scm_AbstractSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_Set$();
});
$c_scm_AbstractSet.prototype.add__O__Z = (function(elem) {
  return $f_scm_SetOps__add__O__Z(this, elem);
});
$c_scm_AbstractSet.prototype.knownSize__I = (function() {
  return (-1);
});
$c_scm_AbstractSet.prototype.sizeHint__I__V = (function(size) {
});
$c_scm_AbstractSet.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$c_scm_AbstractSet.prototype.result__O = (function() {
  return this;
});
/** @constructor */
function $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME$2) {
  this.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1 = null;
  this.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1 = ME$2;
}
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype = new $h_O();
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.constructor = $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10;
/** @constructor */
function $h_Lcats_data_KleisliInstances0\uff3f5$$anon$10() {
}
$h_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype = $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype;
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $n(fa$1).map__F1__Lcats_Functor__Lcats_data_Kleisli(f, this.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.unit__O = (function() {
  var this$1 = $m_Lcats_data_Kleisli$();
  var F = this.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$1, (void 0), F);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $n(fa$1).flatMap__F1__Lcats_FlatMap__Lcats_data_Kleisli(f, this.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.tailRecM__O__F1__O = (function(a, f) {
  return $f_Lcats_data_KleisliFlatMap__tailRecM__O__F1__Lcats_data_Kleisli(this, a, f);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.raiseError__O__O = (function(e) {
  return $f_Lcats_data_KleisliApplicativeError__raiseError__O__Lcats_data_Kleisli(this, e);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var kb = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_data_KleisliApplicativeError__handleErrorWith__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this, kb, f);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.pure__O__O = (function(x) {
  var this$1 = $m_Lcats_data_Kleisli$();
  var F = this.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$1, x, F);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.ap__O__O__O = (function(ff, fa) {
  var f = $as_Lcats_data_Kleisli(ff);
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $n(f).ap__Lcats_data_Kleisli__Lcats_Apply__Lcats_evidence_As__Lcats_data_Kleisli(fa$1, this.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1, $m_Lcats_evidence_As$().Lcats_evidence_As$__f_reflAny);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_data_KleisliApply__map2Eval__Lcats_data_Kleisli__Lcats_Eval__F2__Lcats_Eval(this, fa$1, fb, f);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.product__O__O__O = (function(fa, fb) {
  var fb$1 = $as_Lcats_data_Kleisli(fa);
  var fc = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_data_KleisliApply__product__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fb$1, fc);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $n(fa$1).map__F1__Lcats_Functor__Lcats_data_Kleisli(f, this.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.void__O__O = (function(fa) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_data_KleisliFunctor__void__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1);
});
var $d_Lcats_data_KleisliInstances0\uff3f5$$anon$10 = new $TypeData().initClass($c_Lcats_data_KleisliInstances0\uff3f5$$anon$10, "cats.data.KleisliInstances0_5$$anon$10", ({
  Lcats_data_KleisliInstances0\uff3f5$$anon$10: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_data_KleisliFunctor: 1,
  Lcats_data_KleisliApply: 1,
  Lcats_data_KleisliApplicative: 1,
  Lcats_data_KleisliApplicativeError: 1,
  Lcats_data_KleisliFlatMap: 1,
  Lcats_data_KleisliMonad: 1,
  Lcats_data_KleisliMonadError: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_GenConcurrent$$anon$3(F0$8) {
  this.Lcats_effect_kernel_GenConcurrent$$anon$3__f_F0$3 = null;
  this.Lcats_effect_kernel_GenConcurrent$$anon$3__f_F0$3 = F0$8;
}
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype = new $h_O();
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.constructor = $c_Lcats_effect_kernel_GenConcurrent$$anon$3;
/** @constructor */
function $h_Lcats_effect_kernel_GenConcurrent$$anon$3() {
}
$h_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype = $c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype;
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.unit__O = (function() {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenConcurrent$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  var this$3 = $m_Lcats_data_Kleisli$();
  var F = this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$3, (void 0), F);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.guarantee__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O(this, fa, fin);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.F__Lcats_effect_kernel_GenConcurrent = (function() {
  return this.Lcats_effect_kernel_GenConcurrent$$anon$3__f_F0$3;
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.F__Lcats_effect_kernel_GenSpawn = (function() {
  return this.Lcats_effect_kernel_GenConcurrent$$anon$3__f_F0$3;
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.F__Lcats_effect_kernel_MonadCancel = (function() {
  return this.Lcats_effect_kernel_GenConcurrent$$anon$3__f_F0$3;
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.ref__O__O = (function(a) {
  return $f_Lcats_effect_kernel_GenConcurrent$KleisliGenConcurrent__ref__O__Lcats_data_Kleisli(this, a);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.deferred__O = (function() {
  return $f_Lcats_effect_kernel_GenConcurrent$KleisliGenConcurrent__deferred__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.racePair__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__racePair__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.unique__O = (function() {
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__unique__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.start__O__O = (function(fa) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__start__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.never__O = (function() {
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__never__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.cede__O = (function() {
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__cede__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.both__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__both__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.raceOutcome__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__raceOutcome__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.uncancelable__F1__O = (function(body) {
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__uncancelable__F1__Lcats_data_Kleisli(this, body);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.canceled__O = (function() {
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__canceled__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.onCancel__O__O__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fin$1 = $as_Lcats_data_Kleisli(fin);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__onCancel__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fin$1);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.forceR__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__forceR__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__guaranteeCase__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this, fa$1, fin);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.pure__O__O = (function(x) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenConcurrent$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  var this$3 = $m_Lcats_data_Kleisli$();
  var F = this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$3, x, F);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.raiseError__O__O = (function(e) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenConcurrent$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliApplicativeError__raiseError__O__Lcats_data_Kleisli(this$2, e);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenConcurrent$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliApplicativeError__handleErrorWith__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this$2, fa$1, f);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenConcurrent$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $n(fa$1).flatMap__F1__Lcats_FlatMap__Lcats_data_Kleisli(f, this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.tailRecM__O__F1__O = (function(a, f) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenConcurrent$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliFlatMap__tailRecM__O__F1__Lcats_data_Kleisli(this$2, a, f);
});
var $d_Lcats_effect_kernel_GenConcurrent$$anon$3 = new $TypeData().initClass($c_Lcats_effect_kernel_GenConcurrent$$anon$3, "cats.effect.kernel.GenConcurrent$$anon$3", ({
  Lcats_effect_kernel_GenConcurrent$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lcats_effect_kernel_Unique: 1,
  Lcats_effect_kernel_GenSpawn: 1,
  Lcats_effect_kernel_GenConcurrent: 1,
  Lcats_effect_kernel_MonadCancel$KleisliMonadCancel: 1,
  Lcats_effect_kernel_GenSpawn$KleisliGenSpawn: 1,
  Lcats_effect_kernel_GenConcurrent$KleisliGenConcurrent: 1
}));
function $p_sci_LazyList__scala$collection$immutable$LazyList$$state$lzycompute__sci_LazyList$State($thiz) {
  if ((!$thiz.sci_LazyList__f_bitmap$0)) {
    if ($thiz.sci_LazyList__f_midEvaluation) {
      throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), "self-referential LazyList or a derivation thereof has no more elements");
    }
    $thiz.sci_LazyList__f_midEvaluation = true;
    try {
      var res = $as_sci_LazyList$State($n($thiz.sci_LazyList__f_lazyState).apply__O());
    } finally {
      $thiz.sci_LazyList__f_midEvaluation = false;
    }
    $thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated = true;
    $thiz.sci_LazyList__f_lazyState = null;
    $thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$state = res;
    $thiz.sci_LazyList__f_bitmap$0 = true;
  }
  return $thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$state;
}
function $p_sci_LazyList__mapImpl__F1__sci_LazyList($thiz, f) {
  $m_sci_LazyList$();
  var state = new $c_sjsr_AnonFunction0((() => {
    if ($thiz.isEmpty__Z()) {
      return $m_sci_LazyList$State$Empty$();
    } else {
      $m_sci_LazyList$();
      var hd = $n(f).apply__O__O($n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O());
      var tl = $p_sci_LazyList__mapImpl__F1__sci_LazyList($n($n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()), f);
      return new $c_sci_LazyList$State$Cons(hd, tl);
    }
  }));
  return new $c_sci_LazyList(state);
}
function $p_sci_LazyList__zipState__sc_Iterator__sci_LazyList$State($thiz, it) {
  if (($thiz.isEmpty__Z() || (!$n(it).hasNext__Z()))) {
    return $m_sci_LazyList$State$Empty$();
  } else {
    $m_sci_LazyList$();
    var hd = new $c_T2($n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O(), $n(it).next__O());
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((() => $p_sci_LazyList__zipState__sc_Iterator__sci_LazyList$State($n($n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()), it)));
    var tl = new $c_sci_LazyList(state);
    return new $c_sci_LazyList$State$Cons(hd, tl);
  }
}
function $p_sci_LazyList__dropRightState__sci_LazyList__sci_LazyList$State($thiz, scout) {
  if ($n(scout).isEmpty__Z()) {
    return $m_sci_LazyList$State$Empty$();
  } else {
    $m_sci_LazyList$();
    var hd = $n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((() => {
      var $x_1 = $n($n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList());
      var this$2 = $n(scout);
      return $p_sci_LazyList__dropRightState__sci_LazyList__sci_LazyList$State($n($x_1), $n(this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList());
    }));
    var tl = new $c_sci_LazyList(state);
    return new $c_sci_LazyList$State$Cons(hd, tl);
  }
}
function $p_sci_LazyList__takeImpl__I__sci_LazyList($thiz, n) {
  if ((n <= 0)) {
    return $m_sci_LazyList$().sci_LazyList$__f__empty;
  } else {
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((() => {
      if ($thiz.isEmpty__Z()) {
        return $m_sci_LazyList$State$Empty$();
      } else {
        $m_sci_LazyList$();
        var hd = $n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
        var tl = $p_sci_LazyList__takeImpl__I__sci_LazyList($n($n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()), (((-1) + n) | 0));
        return new $c_sci_LazyList$State$Cons(hd, tl);
      }
    }));
    return new $c_sci_LazyList(state);
  }
}
function $p_sci_LazyList__takeWhileImpl__F1__sci_LazyList($thiz, p) {
  $m_sci_LazyList$();
  var state = new $c_sjsr_AnonFunction0((() => {
    if (($thiz.isEmpty__Z() || (!$uZ($n(p).apply__O__O($n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O()))))) {
      return $m_sci_LazyList$State$Empty$();
    } else {
      $m_sci_LazyList$();
      var hd = $n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
      var tl = $p_sci_LazyList__takeWhileImpl__F1__sci_LazyList($n($n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()), p);
      return new $c_sci_LazyList$State$Cons(hd, tl);
    }
  }));
  return new $c_sci_LazyList(state);
}
function $p_sci_LazyList__reverseOnto__sci_LazyList__sci_LazyList($thiz, tl) {
  var _$this = $thiz;
  while (true) {
    if ($n(_$this).isEmpty__Z()) {
      return tl;
    } else {
      var this$1 = $n(_$this);
      var temp$_$this = $n(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
      $m_sci_LazyList$();
      var this$5 = _$this;
      var tl$2 = tl;
      var state = new $c_sjsr_AnonFunction0(((this$2, tl$1) => (() => {
        var this$3 = $n(this$2);
        $m_sci_LazyList$();
        var hd = $n(this$3.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
        return new $c_sci_LazyList$State$Cons(hd, tl$1);
      }))(this$5, tl$2));
      var temp$tl = new $c_sci_LazyList(state);
      _$this = temp$_$this;
      tl = temp$tl;
    }
  }
}
function $p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder($thiz, b, start, sep, end) {
  var this$1 = $n(b);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start);
  if ((!$thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated)) {
    var this$2 = $n(b);
    this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<not computed>");
  } else if ((!$thiz.isEmpty__Z())) {
    var this$3 = $n(b);
    var obj = $n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
    this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj);
    var elem = null;
    elem = $thiz;
    var elem$1 = $n($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
    var elem$2 = null;
    elem$2 = elem$1;
    if ((($as_sci_LazyList(elem) !== $as_sci_LazyList(elem$2)) && ((!$n($as_sci_LazyList(elem$2)).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated) || ($n($as_sci_LazyList(elem)).scala$collection$immutable$LazyList$$state__sci_LazyList$State() !== $n($as_sci_LazyList(elem$2)).scala$collection$immutable$LazyList$$state__sci_LazyList$State())))) {
      elem = $as_sci_LazyList(elem$2);
      if (($n($as_sci_LazyList(elem$2)).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (!$n($as_sci_LazyList(elem$2)).isEmpty__Z()))) {
        var this$6 = $n($as_sci_LazyList(elem$2));
        elem$2 = $n(this$6.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
        while (((($as_sci_LazyList(elem) !== $as_sci_LazyList(elem$2)) && ($n($as_sci_LazyList(elem$2)).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (!$n($as_sci_LazyList(elem$2)).isEmpty__Z()))) && ($n($as_sci_LazyList(elem)).scala$collection$immutable$LazyList$$state__sci_LazyList$State() !== $n($as_sci_LazyList(elem$2)).scala$collection$immutable$LazyList$$state__sci_LazyList$State()))) {
          var this$7 = $n(b);
          this$7.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$7.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var this$8 = $n($as_sci_LazyList(elem));
          var obj$1 = $n(this$8.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
          this$7.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$7.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$1);
          var this$9 = $n($as_sci_LazyList(elem));
          elem = $n(this$9.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
          var this$10 = $n($as_sci_LazyList(elem$2));
          elem$2 = $n(this$10.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
          if (($n($as_sci_LazyList(elem$2)).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (!$n($as_sci_LazyList(elem$2)).isEmpty__Z()))) {
            var this$11 = $n($as_sci_LazyList(elem$2));
            elem$2 = $n(this$11.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
          }
        }
      }
    }
    if ((!($n($as_sci_LazyList(elem$2)).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (!$n($as_sci_LazyList(elem$2)).isEmpty__Z())))) {
      while (($as_sci_LazyList(elem) !== $as_sci_LazyList(elem$2))) {
        var this$12 = $n(b);
        this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        var this$13 = $n($as_sci_LazyList(elem));
        var obj$2 = $n(this$13.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
        this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$2);
        var this$14 = $n($as_sci_LazyList(elem));
        elem = $n(this$14.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
      }
      if ((!$n($as_sci_LazyList(elem)).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated)) {
        var this$15 = $n(b);
        this$15.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$15.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        this$15.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$15.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<not computed>");
      }
    } else {
      var runner = $thiz;
      var k = 0;
      while (true) {
        var a = runner;
        var b$1 = $as_sci_LazyList(elem$2);
        if ((!((a === b$1) || ($n(a).scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $n(b$1).scala$collection$immutable$LazyList$$state__sci_LazyList$State())))) {
          var this$16 = $n(runner);
          runner = $n(this$16.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
          var this$17 = $n($as_sci_LazyList(elem$2));
          elem$2 = $n(this$17.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
          k = ((1 + k) | 0);
        } else {
          break;
        }
      }
      var a$1 = $as_sci_LazyList(elem);
      var b$2 = $as_sci_LazyList(elem$2);
      if ((((a$1 === b$2) || ($n(a$1).scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $n(b$2).scala$collection$immutable$LazyList$$state__sci_LazyList$State())) && (k > 0))) {
        var this$18 = $n(b);
        this$18.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$18.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        var this$19 = $n($as_sci_LazyList(elem));
        var obj$3 = $n(this$19.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
        this$18.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$18.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$3);
        var this$20 = $n($as_sci_LazyList(elem));
        elem = $n(this$20.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
      }
      while (true) {
        var a$2 = $as_sci_LazyList(elem);
        var b$3 = $as_sci_LazyList(elem$2);
        if ((!((a$2 === b$3) || ($n(a$2).scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $n(b$3).scala$collection$immutable$LazyList$$state__sci_LazyList$State())))) {
          var this$21 = $n(b);
          this$21.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$21.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var this$22 = $n($as_sci_LazyList(elem));
          var obj$4 = $n(this$22.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
          this$21.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$21.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$4);
          var this$23 = $n($as_sci_LazyList(elem));
          elem = $n(this$23.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
        } else {
          break;
        }
      }
      var this$24 = $n(b);
      this$24.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$24.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
      this$24.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$24.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<cycle>");
    }
  }
  var this$25 = $n(b);
  this$25.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$25.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end);
  return b;
}
/** @constructor */
function $c_sci_LazyList(lazyState) {
  this.sci_LazyList__f_scala$collection$immutable$LazyList$$state = null;
  this.sci_LazyList__f_lazyState = null;
  this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated = false;
  this.sci_LazyList__f_midEvaluation = false;
  this.sci_LazyList__f_bitmap$0 = false;
  this.sci_LazyList__f_lazyState = lazyState;
  this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated = false;
  this.sci_LazyList__f_midEvaluation = false;
}
$c_sci_LazyList.prototype = new $h_sci_AbstractSeq();
$c_sci_LazyList.prototype.constructor = $c_sci_LazyList;
/** @constructor */
function $h_sci_LazyList() {
}
$h_sci_LazyList.prototype = $c_sci_LazyList.prototype;
$c_sci_LazyList.prototype.stringPrefix__T = (function() {
  return "LinearSeq";
});
$c_sci_LazyList.prototype.headOption__s_Option = (function() {
  return $f_sc_LinearSeqOps__headOption__s_Option(this);
});
$c_sci_LazyList.prototype.length__I = (function() {
  return $f_sc_LinearSeqOps__length__I(this);
});
$c_sci_LazyList.prototype.last__O = (function() {
  return $f_sc_LinearSeqOps__last__O(this);
});
$c_sci_LazyList.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_LinearSeqOps__lengthCompare__I__I(this, len);
});
$c_sci_LazyList.prototype.isDefinedAt__I__Z = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x);
});
$c_sci_LazyList.prototype.apply__I__O = (function(n) {
  return $f_sc_LinearSeqOps__apply__I__O(this, n);
});
$c_sci_LazyList.prototype.exists__F1__Z = (function(p) {
  return $f_sc_LinearSeqOps__exists__F1__Z(this, p);
});
$c_sci_LazyList.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that);
});
$c_sci_LazyList.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from);
});
$c_sci_LazyList.prototype.scala$collection$immutable$LazyList$$state__sci_LazyList$State = (function() {
  return ((!this.sci_LazyList__f_bitmap$0) ? $p_sci_LazyList__scala$collection$immutable$LazyList$$state$lzycompute__sci_LazyList$State(this) : this.sci_LazyList__f_scala$collection$immutable$LazyList$$state);
});
$c_sci_LazyList.prototype.isEmpty__Z = (function() {
  return (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$());
});
$c_sci_LazyList.prototype.knownSize__I = (function() {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())) ? 0 : (-1));
});
$c_sci_LazyList.prototype.head__O = (function() {
  return $n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
});
$c_sci_LazyList.prototype.force__sci_LazyList = (function() {
  var these = this;
  var those = this;
  if ((!$n(these).isEmpty__Z())) {
    var this$1 = $n(these);
    these = $n(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
  }
  while ((those !== these)) {
    if ($n(these).isEmpty__Z()) {
      return this;
    }
    var this$2 = $n(these);
    these = $n(this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
    if ($n(these).isEmpty__Z()) {
      return this;
    }
    var this$3 = $n(these);
    these = $n(this$3.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
    if ((these === those)) {
      return this;
    }
    var this$4 = $n(those);
    those = $n(this$4.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
  }
  return this;
});
$c_sci_LazyList.prototype.iterator__sc_Iterator = (function() {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_LazyList$LazyIterator(this));
});
$c_sci_LazyList.prototype.foreach__F1__V = (function(f) {
  var _$this = this;
  while ((!$n(_$this).isEmpty__Z())) {
    var $x_1 = $n(f);
    var this$1 = $n(_$this);
    $n($x_1).apply__O__O($n(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O());
    var this$2 = $n(_$this);
    _$this = $n(this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
  }
});
$c_sci_LazyList.prototype.foldLeft__O__F2__O = (function(z, op) {
  var _$this = this;
  while (true) {
    if ($n(_$this).isEmpty__Z()) {
      return z;
    } else {
      var this$1 = $n(_$this);
      var temp$_$this = $n(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
      var $x_2 = $n(op);
      var $x_1 = z;
      var this$2 = $n(_$this);
      var temp$z = $n($x_2).apply__O__O__O($x_1, $n(this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O());
      _$this = temp$_$this;
      z = temp$z;
    }
  }
});
$c_sci_LazyList.prototype.className__T = (function() {
  return "LazyList";
});
$c_sci_LazyList.prototype.lazyAppendedAll__F0__sci_LazyList = (function(suffix) {
  $m_sci_LazyList$();
  var state = new $c_sjsr_AnonFunction0((() => {
    if (this.isEmpty__Z()) {
      var x1 = $as_sc_IterableOnce($n(suffix).apply__O());
      if ((x1 instanceof $c_sci_LazyList)) {
        var x2 = $as_sci_LazyList(x1);
        return $n(x2).scala$collection$immutable$LazyList$$state__sci_LazyList$State();
      } else {
        return (($n(x1).knownSize__I() === 0) ? $m_sci_LazyList$State$Empty$() : $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIterator__sc_Iterator__sci_LazyList$State($n(x1).iterator__sc_Iterator()));
      }
    } else {
      $m_sci_LazyList$();
      var hd = $n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
      var tl = $n($n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()).lazyAppendedAll__F0__sci_LazyList(suffix);
      return new $c_sci_LazyList$State$Cons(hd, tl);
    }
  }));
  return new $c_sci_LazyList(state);
});
$c_sci_LazyList.prototype.appendedAll__sc_IterableOnce__sci_LazyList = (function(suffix) {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())) ? $m_sci_LazyList$().from__sc_IterableOnce__sci_LazyList(suffix) : this.lazyAppendedAll__F0__sci_LazyList(new $c_sjsr_AnonFunction0((() => suffix))));
});
$c_sci_LazyList.prototype.appended__O__sci_LazyList = (function(elem) {
  if ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$()))) {
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((() => {
      $m_sci_LazyList$();
      var tl = $m_sci_LazyList$().sci_LazyList$__f__empty;
      return new $c_sci_LazyList$State$Cons(elem, tl);
    }));
    return new $c_sci_LazyList(state);
  } else {
    return this.lazyAppendedAll__F0__sci_LazyList(new $c_sjsr_AnonFunction0((() => new $c_sc_Iterator$$anon$20(elem))));
  }
});
$c_sci_LazyList.prototype.reduceLeft__F2__O = (function(f) {
  if (this.isEmpty__Z()) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
  } else {
    var reducedRes = $n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
    var left = $n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
    while ((!$n(left).isEmpty__Z())) {
      var $x_2 = $n(f);
      var $x_1 = reducedRes;
      var this$1 = $n(left);
      reducedRes = $n($x_2).apply__O__O__O($x_1, $n(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O());
      var this$2 = $n(left);
      left = $n(this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
    }
    return reducedRes;
  }
});
$c_sci_LazyList.prototype.partition__F1__T2 = (function(p) {
  return new $c_T2(this.filter__F1__sci_LazyList(p), this.filterNot__F1__sci_LazyList(p));
});
$c_sci_LazyList.prototype.filter__F1__sci_LazyList = (function(pred) {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())) ? $m_sci_LazyList$().sci_LazyList$__f__empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$filterImpl__sci_LazyList__F1__Z__sci_LazyList(this, pred, false));
});
$c_sci_LazyList.prototype.filterNot__F1__sci_LazyList = (function(pred) {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())) ? $m_sci_LazyList$().sci_LazyList$__f__empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$filterImpl__sci_LazyList__F1__Z__sci_LazyList(this, pred, true));
});
$c_sci_LazyList.prototype.prepended__O__sci_LazyList = (function(elem) {
  $m_sci_LazyList$();
  var state = new $c_sjsr_AnonFunction0((() => {
    $m_sci_LazyList$();
    return new $c_sci_LazyList$State$Cons(elem, this);
  }));
  return new $c_sci_LazyList(state);
});
$c_sci_LazyList.prototype.prependedAll__sc_IterableOnce__sci_LazyList = (function(prefix) {
  if ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$()))) {
    return $m_sci_LazyList$().from__sc_IterableOnce__sci_LazyList(prefix);
  } else if (($n(prefix).knownSize__I() === 0)) {
    return this;
  } else {
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIteratorConcatSuffix__sc_Iterator__F0__sci_LazyList$State($n(prefix).iterator__sc_Iterator(), new $c_sjsr_AnonFunction0((() => this.scala$collection$immutable$LazyList$$state__sci_LazyList$State())))));
    return new $c_sci_LazyList(state);
  }
});
$c_sci_LazyList.prototype.map__F1__sci_LazyList = (function(f) {
  if ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$()))) {
    return $m_sci_LazyList$().sci_LazyList$__f__empty;
  } else {
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((() => {
      if (this.isEmpty__Z()) {
        return $m_sci_LazyList$State$Empty$();
      } else {
        $m_sci_LazyList$();
        var hd = $n(f).apply__O__O($n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O());
        var tl = $p_sci_LazyList__mapImpl__F1__sci_LazyList($n($n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()), f);
        return new $c_sci_LazyList$State$Cons(hd, tl);
      }
    }));
    return new $c_sci_LazyList(state);
  }
});
$c_sci_LazyList.prototype.collect__s_PartialFunction__sci_LazyList = (function(pf) {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())) ? $m_sci_LazyList$().sci_LazyList$__f__empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$collectImpl__sci_LazyList__s_PartialFunction__sci_LazyList(this, pf));
});
$c_sci_LazyList.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  var _$this = this;
  while (true) {
    if ($n(_$this).isEmpty__Z()) {
      return $m_s_None$();
    } else {
      var $x_1 = $n(pf);
      var this$1 = $n(_$this);
      var res = $n($x_1).applyOrElse__O__F1__O($n(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O(), $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$anyToMarker);
      if ((res === $m_sr_Statics$PFMarker$())) {
        var this$3 = $n(_$this);
        _$this = $n(this$3.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
      } else {
        return new $c_s_Some(res);
      }
    }
  }
});
$c_sci_LazyList.prototype.find__F1__s_Option = (function(p) {
  var _$this = this;
  while (true) {
    if ($n(_$this).isEmpty__Z()) {
      return $m_s_None$();
    } else {
      var this$1 = $n(_$this);
      var elem = $n(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
      if ($uZ($n(p).apply__O__O(elem))) {
        return new $c_s_Some(elem);
      } else {
        var this$2 = $n(_$this);
        _$this = $n(this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
      }
    }
  }
});
$c_sci_LazyList.prototype.flatMap__F1__sci_LazyList = (function(f) {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())) ? $m_sci_LazyList$().sci_LazyList$__f__empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$flatMapImpl__sci_LazyList__F1__sci_LazyList(this, f));
});
$c_sci_LazyList.prototype.zip__sc_IterableOnce__sci_LazyList = (function(that) {
  if (((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())) || ($n(that).knownSize__I() === 0))) {
    return $m_sci_LazyList$().sci_LazyList$__f__empty;
  } else {
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((() => $p_sci_LazyList__zipState__sc_Iterator__sci_LazyList$State(this, $n(that).iterator__sc_Iterator())));
    return new $c_sci_LazyList(state);
  }
});
$c_sci_LazyList.prototype.zipWithIndex__sci_LazyList = (function() {
  var this$1 = $m_sci_LazyList$();
  return this.zip__sc_IterableOnce__sci_LazyList(this$1.from__I__I__sci_LazyList(0, 1));
});
$c_sci_LazyList.prototype.drop__I__sci_LazyList = (function(n) {
  return ((n <= 0) ? this : ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())) ? $m_sci_LazyList$().sci_LazyList$__f__empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$dropImpl__sci_LazyList__I__sci_LazyList(this, n)));
});
$c_sci_LazyList.prototype.dropWhile__F1__sci_LazyList = (function(p) {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())) ? $m_sci_LazyList$().sci_LazyList$__f__empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$dropWhileImpl__sci_LazyList__F1__sci_LazyList(this, p));
});
$c_sci_LazyList.prototype.dropRight__I__sci_LazyList = (function(n) {
  if ((n <= 0)) {
    return this;
  } else if ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$()))) {
    return $m_sci_LazyList$().sci_LazyList$__f__empty;
  } else {
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((() => {
      var scout = this;
      var remaining = n;
      while (((remaining > 0) && (!$n(scout).isEmpty__Z()))) {
        remaining = (((-1) + remaining) | 0);
        var this$2 = $n(scout);
        scout = $n(this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
      }
      return $p_sci_LazyList__dropRightState__sci_LazyList__sci_LazyList$State(this, scout);
    }));
    return new $c_sci_LazyList(state);
  }
});
$c_sci_LazyList.prototype.take__I__sci_LazyList = (function(n) {
  if ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$()))) {
    return $m_sci_LazyList$().sci_LazyList$__f__empty;
  } else if ((n <= 0)) {
    return $m_sci_LazyList$().sci_LazyList$__f__empty;
  } else {
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((() => {
      if (this.isEmpty__Z()) {
        return $m_sci_LazyList$State$Empty$();
      } else {
        $m_sci_LazyList$();
        var hd = $n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
        var tl = $p_sci_LazyList__takeImpl__I__sci_LazyList($n($n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()), (((-1) + n) | 0));
        return new $c_sci_LazyList$State$Cons(hd, tl);
      }
    }));
    return new $c_sci_LazyList(state);
  }
});
$c_sci_LazyList.prototype.takeWhile__F1__sci_LazyList = (function(p) {
  if ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$()))) {
    return $m_sci_LazyList$().sci_LazyList$__f__empty;
  } else {
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((() => {
      if ((this.isEmpty__Z() || (!$uZ($n(p).apply__O__O($n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O()))))) {
        return $m_sci_LazyList$State$Empty$();
      } else {
        $m_sci_LazyList$();
        var hd = $n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
        var tl = $p_sci_LazyList__takeWhileImpl__F1__sci_LazyList($n($n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()), p);
        return new $c_sci_LazyList$State$Cons(hd, tl);
      }
    }));
    return new $c_sci_LazyList(state);
  }
});
$c_sci_LazyList.prototype.scala$collection$immutable$LazyList$$lengthGt__I__Z = (function(len) {
  var _$this = this;
  while (true) {
    if ((len < 0)) {
      return true;
    } else if ($n(_$this).isEmpty__Z()) {
      return false;
    } else {
      var this$1 = $n(_$this);
      var temp$_$this = $n(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
      var temp$len = (((-1) + len) | 0);
      _$this = temp$_$this;
      len = temp$len;
    }
  }
});
$c_sci_LazyList.prototype.sliding__I__I__sc_Iterator = (function(size, step) {
  var requirement = ((size > 0) && (step > 0));
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + ((("size=" + size) + " and step=") + step)) + ", but both must be positive"));
  }
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_LazyList$SlidingIterator(this, size, step));
});
$c_sci_LazyList.prototype.padTo__I__O__sci_LazyList = (function(len, elem) {
  if ((len <= 0)) {
    return this;
  } else {
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((() => {
      if (this.isEmpty__Z()) {
        return $n($m_sci_LazyList$().fill__I__F0__sci_LazyList(len, new $c_sjsr_AnonFunction0((() => elem)))).scala$collection$immutable$LazyList$$state__sci_LazyList$State();
      } else {
        $m_sci_LazyList$();
        var hd = $n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
        var tl = $n($n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList()).padTo__I__O__sci_LazyList((((-1) + len) | 0), elem);
        return new $c_sci_LazyList$State$Cons(hd, tl);
      }
    }));
    return new $c_sci_LazyList(state);
  }
});
$c_sci_LazyList.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  this.force__sci_LazyList();
  $p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, $n(sb).scm_StringBuilder__f_underlying, start, sep, end);
  return sb;
});
$c_sci_LazyList.prototype.toString__T = (function() {
  return $n($p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), "LazyList"), "(", ", ", ")")).jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_sci_LazyList.prototype.apply__O__O = (function(v1) {
  var n = $uI(v1);
  return $f_sc_LinearSeqOps__apply__I__O(this, n);
});
$c_sci_LazyList.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = $uI(x);
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1);
});
$c_sci_LazyList.prototype.padTo__I__O__O = (function(len, elem) {
  return this.padTo__I__O__sci_LazyList(len, elem);
});
$c_sci_LazyList.prototype.reverse__O = (function() {
  return $p_sci_LazyList__reverseOnto__sci_LazyList__sci_LazyList(this, $m_sci_LazyList$().sci_LazyList$__f__empty);
});
$c_sci_LazyList.prototype.takeWhile__F1__O = (function(p) {
  return this.takeWhile__F1__sci_LazyList(p);
});
$c_sci_LazyList.prototype.take__I__O = (function(n) {
  return this.take__I__sci_LazyList(n);
});
$c_sci_LazyList.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sci_LazyList(n);
});
$c_sci_LazyList.prototype.dropWhile__F1__O = (function(p) {
  return this.dropWhile__F1__sci_LazyList(p);
});
$c_sci_LazyList.prototype.drop__I__O = (function(n) {
  return this.drop__I__sci_LazyList(n);
});
$c_sci_LazyList.prototype.zipWithIndex__O = (function() {
  return this.zipWithIndex__sci_LazyList();
});
$c_sci_LazyList.prototype.zip__sc_IterableOnce__O = (function(that) {
  return this.zip__sc_IterableOnce__sci_LazyList(that);
});
$c_sci_LazyList.prototype.flatten__F1__O = (function(asIterable) {
  return this.flatMap__F1__sci_LazyList(asIterable);
});
$c_sci_LazyList.prototype.flatMap__F1__O = (function(f) {
  return this.flatMap__F1__sci_LazyList(f);
});
$c_sci_LazyList.prototype.collect__s_PartialFunction__O = (function(pf) {
  return this.collect__s_PartialFunction__sci_LazyList(pf);
});
$c_sci_LazyList.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_LazyList(f);
});
$c_sci_LazyList.prototype.prependedAll__sc_IterableOnce__O = (function(prefix) {
  return this.prependedAll__sc_IterableOnce__sci_LazyList(prefix);
});
$c_sci_LazyList.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_LazyList(elem);
});
$c_sci_LazyList.prototype.filterNot__F1__O = (function(pred) {
  return this.filterNot__F1__sci_LazyList(pred);
});
$c_sci_LazyList.prototype.filter__F1__O = (function(pred) {
  return this.filter__F1__sci_LazyList(pred);
});
$c_sci_LazyList.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_LazyList(elem);
});
$c_sci_LazyList.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_LazyList(suffix);
});
$c_sci_LazyList.prototype.tail__O = (function() {
  return $n(this.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList();
});
$c_sci_LazyList.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_LazyList$();
});
function $as_sci_LazyList(obj) {
  return (((obj instanceof $c_sci_LazyList) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.LazyList"));
}
function $isArrayOf_sci_LazyList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_LazyList)));
}
function $asArrayOf_sci_LazyList(obj, depth) {
  return (($isArrayOf_sci_LazyList(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.LazyList;", depth));
}
var $d_sci_LazyList = new $TypeData().initClass($c_sci_LazyList, "scala.collection.immutable.LazyList", ({
  sci_LazyList: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  Ljava_io_Serializable: 1
}));
function $p_sci_Stream__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder($thiz, b, start, sep, end) {
  var this$1 = $n(b);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start);
  if ((!$thiz.isEmpty__Z())) {
    var this$2 = $n(b);
    var obj = $thiz.head__O();
    this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj);
    var elem = null;
    elem = $thiz;
    if ($thiz.tailDefined__Z()) {
      var scout = $as_sci_Stream($thiz.tail__O());
      if (($as_sci_Stream(elem) !== scout)) {
        elem = scout;
        if ($n(scout).tailDefined__Z()) {
          scout = $as_sci_Stream($n(scout).tail__O());
          while ((($as_sci_Stream(elem) !== scout) && $n(scout).tailDefined__Z())) {
            var this$4 = $n(b);
            this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
            var obj$1 = $n($as_sci_Stream(elem)).head__O();
            this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$1);
            elem = $as_sci_Stream($n($as_sci_Stream(elem)).tail__O());
            scout = $as_sci_Stream($n(scout).tail__O());
            if ($n(scout).tailDefined__Z()) {
              scout = $as_sci_Stream($n(scout).tail__O());
            }
          }
        }
      }
      if ((!$n(scout).tailDefined__Z())) {
        while (($as_sci_Stream(elem) !== scout)) {
          var this$5 = $n(b);
          this$5.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$5.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$2 = $n($as_sci_Stream(elem)).head__O();
          this$5.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$5.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$2);
          elem = $as_sci_Stream($n($as_sci_Stream(elem)).tail__O());
        }
        var this$6 = $n($as_sci_Stream(elem));
        if ((!this$6.isEmpty__Z())) {
          var this$7 = $n(b);
          this$7.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$7.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$3 = $n($as_sci_Stream(elem)).head__O();
          this$7.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$7.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$3);
        }
      } else {
        var runner = $thiz;
        var k = 0;
        while ((runner !== scout)) {
          runner = $as_sci_Stream($n(runner).tail__O());
          scout = $as_sci_Stream($n(scout).tail__O());
          k = ((1 + k) | 0);
        }
        if ((($as_sci_Stream(elem) === scout) && (k > 0))) {
          var this$8 = $n(b);
          this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$4 = $n($as_sci_Stream(elem)).head__O();
          this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$4);
          elem = $as_sci_Stream($n($as_sci_Stream(elem)).tail__O());
        }
        while (($as_sci_Stream(elem) !== scout)) {
          var this$9 = $n(b);
          this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$5 = $n($as_sci_Stream(elem)).head__O();
          this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$5);
          elem = $as_sci_Stream($n($as_sci_Stream(elem)).tail__O());
        }
      }
    }
    var this$10 = $n($as_sci_Stream(elem));
    if ((!this$10.isEmpty__Z())) {
      if ((!$n($as_sci_Stream(elem)).tailDefined__Z())) {
        var this$11 = $n(b);
        this$11.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$11.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        this$11.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$11.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<not computed>");
      } else {
        var this$12 = $n(b);
        this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<cycle>");
      }
    }
  }
  var this$13 = $n(b);
  this$13.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$13.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end);
  return b;
}
/** @constructor */
function $c_sci_Stream() {
}
$c_sci_Stream.prototype = new $h_sci_AbstractSeq();
$c_sci_Stream.prototype.constructor = $c_sci_Stream;
/** @constructor */
function $h_sci_Stream() {
}
$h_sci_Stream.prototype = $c_sci_Stream.prototype;
$c_sci_Stream.prototype.stringPrefix__T = (function() {
  return "LinearSeq";
});
$c_sci_Stream.prototype.headOption__s_Option = (function() {
  return $f_sc_LinearSeqOps__headOption__s_Option(this);
});
$c_sci_Stream.prototype.iterator__sc_Iterator = (function() {
  return $f_sc_LinearSeqOps__iterator__sc_Iterator(this);
});
$c_sci_Stream.prototype.length__I = (function() {
  return $f_sc_LinearSeqOps__length__I(this);
});
$c_sci_Stream.prototype.last__O = (function() {
  return $f_sc_LinearSeqOps__last__O(this);
});
$c_sci_Stream.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_LinearSeqOps__lengthCompare__I__I(this, len);
});
$c_sci_Stream.prototype.isDefinedAt__I__Z = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x);
});
$c_sci_Stream.prototype.apply__I__O = (function(n) {
  return $f_sc_LinearSeqOps__apply__I__O(this, n);
});
$c_sci_Stream.prototype.exists__F1__Z = (function(p) {
  return $f_sc_LinearSeqOps__exists__F1__Z(this, p);
});
$c_sci_Stream.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that);
});
$c_sci_Stream.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from);
});
$c_sci_Stream.prototype.className__T = (function() {
  return "Stream";
});
$c_sci_Stream.prototype.foreach__F1__V = (function(f) {
  var _$this = this;
  while ((!$n(_$this).isEmpty__Z())) {
    $n(f).apply__O__O($n(_$this).head__O());
    _$this = $as_sci_Stream($n(_$this).tail__O());
  }
});
$c_sci_Stream.prototype.find__F1__s_Option = (function(p) {
  var _$this = this;
  while (true) {
    if ($n(_$this).isEmpty__Z()) {
      return $m_s_None$();
    } else if ($uZ($n(p).apply__O__O($n(_$this).head__O()))) {
      return new $c_s_Some($n(_$this).head__O());
    } else {
      _$this = $as_sci_Stream($n(_$this).tail__O());
    }
  }
});
$c_sci_Stream.prototype.take__I__sci_Stream = (function(n) {
  return (((n <= 0) || this.isEmpty__Z()) ? $m_sci_Stream$Empty$() : ((n === 1) ? new $c_sci_Stream$Cons(this.head__O(), new $c_sjsr_AnonFunction0((() => $m_sci_Stream$Empty$()))) : new $c_sci_Stream$Cons(this.head__O(), new $c_sjsr_AnonFunction0((() => $n($as_sci_Stream(this.tail__O())).take__I__sci_Stream((((-1) + n) | 0)))))));
});
$c_sci_Stream.prototype.foldLeft__O__F2__O = (function(z, op) {
  var _$this = this;
  while (true) {
    if ($n(_$this).isEmpty__Z()) {
      return z;
    } else {
      var temp$_$this = $as_sci_Stream($n(_$this).tail__O());
      var temp$z = $n(op).apply__O__O__O(z, $n(_$this).head__O());
      _$this = temp$_$this;
      z = temp$z;
    }
  }
});
$c_sci_Stream.prototype.lazyAppendedAll__F0__sci_Stream = (function(suffix) {
  if (this.isEmpty__Z()) {
    var this$1 = $m_sci_Stream$();
    var source = $as_sc_IterableOnce($n(suffix).apply__O());
    return this$1.from__sc_IterableOnce__sci_Stream(source);
  } else {
    var hd = this.head__O();
    var tl = new $c_sjsr_AnonFunction0((() => $n($as_sci_Stream(this.tail__O())).lazyAppendedAll__F0__sci_Stream(suffix)));
    return new $c_sci_Stream$Cons(hd, tl);
  }
});
$c_sci_Stream.prototype.reduceLeft__F2__O = (function(f) {
  if (this.isEmpty__Z()) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
  } else {
    var reducedRes = this.head__O();
    var left = $as_sci_Stream(this.tail__O());
    while ((!$n(left).isEmpty__Z())) {
      reducedRes = $n(f).apply__O__O__O(reducedRes, $n(left).head__O());
      left = $as_sci_Stream($n(left).tail__O());
    }
    return reducedRes;
  }
});
$c_sci_Stream.prototype.partition__F1__T2 = (function(p) {
  var pred = new $c_sjsr_AnonFunction1(((x$1$2) => $uZ($n(p).apply__O__O(x$1$2))));
  var $x_1 = this.filterImpl__F1__Z__sci_Stream(pred, false);
  var pred$1 = new $c_sjsr_AnonFunction1(((x$2$2) => $uZ($n(p).apply__O__O(x$2$2))));
  return new $c_T2($x_1, this.filterImpl__F1__Z__sci_Stream(pred$1, true));
});
$c_sci_Stream.prototype.filterImpl__F1__Z__sci_Stream = (function(p, isFlipped) {
  var rest = this;
  while (true) {
    var this$1 = $n(rest);
    if (((!this$1.isEmpty__Z()) && ($uZ($n(p).apply__O__O($n(rest).head__O())) === isFlipped))) {
      rest = $as_sci_Stream($n(rest).tail__O());
    } else {
      break;
    }
  }
  var this$2 = $n(rest);
  if ((!this$2.isEmpty__Z())) {
    return $m_sci_Stream$().filteredTail__sci_Stream__F1__Z__sci_Stream(rest, p, isFlipped);
  } else {
    return $m_sci_Stream$Empty$();
  }
});
$c_sci_Stream.prototype.prepended__O__sci_Stream = (function(elem) {
  var tl = new $c_sjsr_AnonFunction0((() => this));
  return new $c_sci_Stream$Cons(elem, tl);
});
$c_sci_Stream.prototype.map__F1__sci_Stream = (function(f) {
  if (this.isEmpty__Z()) {
    return $m_sci_Stream$Empty$();
  } else {
    var hd = $n(f).apply__O__O(this.head__O());
    var tl = new $c_sjsr_AnonFunction0((() => $n($as_sci_Stream(this.tail__O())).map__F1__sci_Stream(f)));
    return new $c_sci_Stream$Cons(hd, tl);
  }
});
$c_sci_Stream.prototype.collect__s_PartialFunction__sci_Stream = (function(pf) {
  var _$this = this;
  while (true) {
    if ($n(_$this).isEmpty__Z()) {
      return $m_sci_Stream$Empty$();
    } else {
      var newHead = new $c_sr_ObjectRef(null);
      var $x_1 = $n(pf);
      var this$5 = _$this;
      var runWith = $n($x_1).runWith__F1__F1(new $c_sjsr_AnonFunction1(((this$3, newHead) => ((b$2) => {
        $n(this$3);
        newHead.sr_ObjectRef__f_elem = b$2;
      }))(this$5, newHead)));
      if ($uZ($n(runWith).apply__O__O($n(_$this).head__O()))) {
        return $m_sci_Stream$().collectedTail__O__sci_Stream__s_PartialFunction__sci_Stream(newHead.sr_ObjectRef__f_elem, _$this, pf);
      } else {
        _$this = $as_sci_Stream($n(_$this).tail__O());
      }
    }
  }
});
$c_sci_Stream.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  var _$this = this;
  while (true) {
    if ($n(_$this).isEmpty__Z()) {
      return $m_s_None$();
    } else {
      var newHead = new $c_sr_ObjectRef(null);
      var $x_1 = $n(pf);
      var this$4 = _$this;
      var runWith = $n($x_1).runWith__F1__F1(new $c_sjsr_AnonFunction1(((this$2, newHead) => ((b$2) => {
        $n(this$2);
        newHead.sr_ObjectRef__f_elem = b$2;
      }))(this$4, newHead)));
      if ($uZ($n(runWith).apply__O__O($n(_$this).head__O()))) {
        return new $c_s_Some(newHead.sr_ObjectRef__f_elem);
      } else {
        _$this = $as_sci_Stream($n(_$this).tail__O());
      }
    }
  }
});
$c_sci_Stream.prototype.flatMap__F1__sci_Stream = (function(f) {
  if (this.isEmpty__Z()) {
    return $m_sci_Stream$Empty$();
  } else {
    var nonEmptyPrefix = new $c_sr_ObjectRef(this);
    var this$3 = $m_sci_Stream$();
    var source = $as_sc_IterableOnce($n(f).apply__O__O($n($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem)).head__O()));
    var prefix = this$3.from__sc_IterableOnce__sci_Stream(source);
    while (((!$n($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem)).isEmpty__Z()) && $n(prefix).isEmpty__Z())) {
      nonEmptyPrefix.sr_ObjectRef__f_elem = $as_sci_Stream($n($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem)).tail__O());
      if ((!$n($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem)).isEmpty__Z())) {
        var this$4 = $m_sci_Stream$();
        var source$1 = $as_sc_IterableOnce($n(f).apply__O__O($n($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem)).head__O()));
        prefix = this$4.from__sc_IterableOnce__sci_Stream(source$1);
      }
    }
    return ($n($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem)).isEmpty__Z() ? $m_sci_Stream$Empty$() : $n(prefix).lazyAppendedAll__F0__sci_Stream(new $c_sjsr_AnonFunction0((() => $n($as_sci_Stream($n($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem)).tail__O())).flatMap__F1__sci_Stream(f)))));
  }
});
$c_sci_Stream.prototype.zip__sc_IterableOnce__sci_Stream = (function(that) {
  if ((this.isEmpty__Z() || $m_sc_IterableOnceExtensionMethods$().isEmpty$extension__sc_IterableOnce__Z(that))) {
    return $m_sci_Stream$Empty$();
  } else {
    if ($is_sc_Iterable(that)) {
      var x2 = $as_sc_Iterable(that);
      var thatIterable = x2;
    } else {
      var thatIterable = $m_sci_LazyList$().from__sc_IterableOnce__sci_LazyList(that);
    }
    var hd = new $c_T2(this.head__O(), $n(thatIterable).head__O());
    var tl = new $c_sjsr_AnonFunction0((() => $n($as_sci_Stream(this.tail__O())).zip__sc_IterableOnce__sci_Stream($as_sc_IterableOnce($n(thatIterable).tail__O()))));
    return new $c_sci_Stream$Cons(hd, tl);
  }
});
$c_sci_Stream.prototype.zipWithIndex__sci_Stream = (function() {
  var this$1 = $m_sci_LazyList$();
  return this.zip__sc_IterableOnce__sci_Stream(this$1.from__I__I__sci_LazyList(0, 1));
});
$c_sci_Stream.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  this.force__sci_Stream();
  $p_sci_Stream__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, $n(sb).scm_StringBuilder__f_underlying, start, sep, end);
  return sb;
});
$c_sci_Stream.prototype.toString__T = (function() {
  return $n($p_sci_Stream__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), "Stream"), "(", ", ", ")")).jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_sci_Stream.prototype.apply__O__O = (function(v1) {
  var n = $uI(v1);
  return $f_sc_LinearSeqOps__apply__I__O(this, n);
});
$c_sci_Stream.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = $uI(x);
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1);
});
$c_sci_Stream.prototype.zipWithIndex__O = (function() {
  return this.zipWithIndex__sci_Stream();
});
$c_sci_Stream.prototype.zip__sc_IterableOnce__O = (function(that) {
  return this.zip__sc_IterableOnce__sci_Stream(that);
});
$c_sci_Stream.prototype.flatMap__F1__O = (function(f) {
  return this.flatMap__F1__sci_Stream(f);
});
$c_sci_Stream.prototype.collect__s_PartialFunction__O = (function(pf) {
  return this.collect__s_PartialFunction__sci_Stream(pf);
});
$c_sci_Stream.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Stream(f);
});
$c_sci_Stream.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Stream(elem);
});
$c_sci_Stream.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Stream(pred, true);
});
$c_sci_Stream.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Stream(pred, false);
});
$c_sci_Stream.prototype.take__I__O = (function(n) {
  return this.take__I__sci_Stream(n);
});
$c_sci_Stream.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Stream$();
});
function $as_sci_Stream(obj) {
  return (((obj instanceof $c_sci_Stream) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Stream"));
}
function $isArrayOf_sci_Stream(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Stream)));
}
function $asArrayOf_sci_Stream(obj, depth) {
  return (($isArrayOf_sci_Stream(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Stream;", depth));
}
/** @constructor */
function $c_sci_WrappedString(self) {
  this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self = null;
  this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self = self;
}
$c_sci_WrappedString.prototype = new $h_sci_AbstractSeq();
$c_sci_WrappedString.prototype.constructor = $c_sci_WrappedString;
/** @constructor */
function $h_sci_WrappedString() {
}
$h_sci_WrappedString.prototype = $c_sci_WrappedString.prototype;
$c_sci_WrappedString.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this;
});
$c_sci_WrappedString.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$c_sci_WrappedString.prototype.stringPrefix__T = (function() {
  return "IndexedSeq";
});
$c_sci_WrappedString.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_StringView(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1);
});
$c_sci_WrappedString.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_StringView(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_sci_WrappedString.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sci_WrappedString.prototype.prepended__O__O = (function(elem) {
  return $f_sc_IndexedSeqOps__prepended__O__O(this, elem);
});
$c_sci_WrappedString.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n);
});
$c_sci_WrappedString.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$c_sci_WrappedString.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__dropRight__I__O(this, n);
});
$c_sci_WrappedString.prototype.map__F1__O = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f);
});
$c_sci_WrappedString.prototype.reverse__O = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this);
});
$c_sci_WrappedString.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sci_WrappedString.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sci_WrappedString.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sci_WrappedString.prototype.lengthCompare__I__I = (function(len) {
  var this$1 = $n(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
  var x = this$1.length;
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sci_WrappedString.prototype.knownSize__I = (function() {
  var this$1 = $n(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
  return this$1.length;
});
$c_sci_WrappedString.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sci_WrappedString$().newBuilder__scm_Builder();
});
$c_sci_WrappedString.prototype.length__I = (function() {
  var this$1 = $n(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
  return this$1.length;
});
$c_sci_WrappedString.prototype.toString__T = (function() {
  return this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
});
$c_sci_WrappedString.prototype.startsWith__sc_IterableOnce__I__Z = (function(that, offset) {
  if ((that instanceof $c_sci_WrappedString)) {
    var x2 = $as_sci_WrappedString(that);
    var this$1 = $n(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
    var prefix = $n(x2).sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
    if (((offset <= this$1.length) && (offset >= 0))) {
      var this$2 = $n(prefix);
      var $x_1 = this$1.substring(offset, ((offset + this$2.length) | 0));
      return ($as_T($x_1) === prefix);
    } else {
      return false;
    }
  } else {
    return $f_sc_SeqOps__startsWith__sc_IterableOnce__I__Z(this, that, offset);
  }
});
$c_sci_WrappedString.prototype.startsWith$default$2__I = (function() {
  return 0;
});
$c_sci_WrappedString.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  if ((xs instanceof $ac_C)) {
    var x2 = $asArrayOf_C(xs, 1);
    var this$1 = $n(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
    var srcLen = this$1.length;
    var destLen = $n(x2).u.length;
    var x = ((len < srcLen) ? len : srcLen);
    var y = ((destLen - start) | 0);
    var x$1 = ((x < y) ? x : y);
    var copied = ((x$1 > 0) ? x$1 : 0);
    $f_T__getChars__I__I__AC__I__V($n(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self), 0, copied, x2, start);
    return copied;
  } else {
    return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
  }
});
$c_sci_WrappedString.prototype.appendedAll__sc_IterableOnce__sci_IndexedSeq = (function(suffix) {
  if ((suffix instanceof $c_sci_WrappedString)) {
    var x2 = $as_sci_WrappedString(suffix);
    var this$1 = $n(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
    var s = $n(x2).sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
    return new $c_sci_WrappedString((this$1 + s));
  } else {
    return $as_sci_IndexedSeq($f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix));
  }
});
$c_sci_WrappedString.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  if ((o instanceof $c_sci_WrappedString)) {
    var x2 = $as_sci_WrappedString(o);
    return (this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self === $n(x2).sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
  } else {
    return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o);
  }
});
$c_sci_WrappedString.prototype.className__T = (function() {
  return "WrappedString";
});
$c_sci_WrappedString.prototype.applyPreferredMaxLength__I = (function() {
  return 2147483647;
});
$c_sci_WrappedString.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_sci_WrappedString)) {
    var x2 = $as_sci_WrappedString(other);
    return (this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self === $n(x2).sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
  } else {
    return $f_sc_Seq__equals__O__Z(this, other);
  }
});
$c_sci_WrappedString.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_IndexedSeq$();
});
$c_sci_WrappedString.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_IndexedSeq(suffix);
});
$c_sci_WrappedString.prototype.view__sc_IndexedSeqView = (function() {
  return new $c_sc_StringView(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
});
$c_sci_WrappedString.prototype.empty__sc_IterableOps = (function() {
  return $m_sci_WrappedString$().sci_WrappedString$__f_empty;
});
$c_sci_WrappedString.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $m_sci_WrappedString$().fromSpecific__sc_IterableOnce__sci_WrappedString(coll);
});
$c_sci_WrappedString.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $m_sci_WrappedString$().fromSpecific__sc_IterableOnce__sci_WrappedString(coll);
});
$c_sci_WrappedString.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  var this$1 = $n(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
  return $bC($charAt(this$1, i));
});
$c_sci_WrappedString.prototype.apply__I__O = (function(i) {
  var this$1 = $n(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
  return $bC($charAt(this$1, i));
});
function $as_sci_WrappedString(obj) {
  return (((obj instanceof $c_sci_WrappedString) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.WrappedString"));
}
function $isArrayOf_sci_WrappedString(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_WrappedString)));
}
function $asArrayOf_sci_WrappedString(obj, depth) {
  return (($isArrayOf_sci_WrappedString(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.WrappedString;", depth));
}
var $d_sci_WrappedString = new $TypeData().initClass($c_sci_WrappedString, "scala.collection.immutable.WrappedString", ({
  sci_WrappedString: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  Ljava_io_Serializable: 1
}));
function $ct_sjsr_WrappedVarArgs__sjs_js_Array__($thiz, array) {
  $thiz.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array = array;
  return $thiz;
}
function $ct_sjsr_WrappedVarArgs__($thiz) {
  $ct_sjsr_WrappedVarArgs__sjs_js_Array__($thiz, []);
  return $thiz;
}
/** @constructor */
function $c_sjsr_WrappedVarArgs() {
  this.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array = null;
}
$c_sjsr_WrappedVarArgs.prototype = new $h_O();
$c_sjsr_WrappedVarArgs.prototype.constructor = $c_sjsr_WrappedVarArgs;
/** @constructor */
function $h_sjsr_WrappedVarArgs() {
}
$h_sjsr_WrappedVarArgs.prototype = $c_sjsr_WrappedVarArgs.prototype;
$c_sjsr_WrappedVarArgs.prototype.distinctBy__F1__O = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$c_sjsr_WrappedVarArgs.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$c_sjsr_WrappedVarArgs.prototype.prepended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__prepended__O__O(this, elem);
});
$c_sjsr_WrappedVarArgs.prototype.appended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$c_sjsr_WrappedVarArgs.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$c_sjsr_WrappedVarArgs.prototype.prependedAll__sc_IterableOnce__O = (function(prefix) {
  return $f_sc_StrictOptimizedSeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$c_sjsr_WrappedVarArgs.prototype.padTo__I__O__O = (function(len, elem) {
  return $f_sc_StrictOptimizedSeqOps__padTo__I__O__O(this, len, elem);
});
$c_sjsr_WrappedVarArgs.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_sjsr_WrappedVarArgs.prototype.span__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__span__F1__T2(this, p);
});
$c_sjsr_WrappedVarArgs.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sjsr_WrappedVarArgs.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sjsr_WrappedVarArgs.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sjsr_WrappedVarArgs.prototype.flatten__F1__O = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$c_sjsr_WrappedVarArgs.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_sjsr_WrappedVarArgs.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$c_sjsr_WrappedVarArgs.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_sjsr_WrappedVarArgs.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$c_sjsr_WrappedVarArgs.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sjsr_WrappedVarArgs.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this;
});
$c_sjsr_WrappedVarArgs.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$c_sjsr_WrappedVarArgs.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o);
});
$c_sjsr_WrappedVarArgs.prototype.applyPreferredMaxLength__I = (function() {
  return $m_sci_IndexedSeqDefaults$().sci_IndexedSeqDefaults$__f_defaultApplyPreferredMaxLength;
});
$c_sjsr_WrappedVarArgs.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1);
});
$c_sjsr_WrappedVarArgs.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_sjsr_WrappedVarArgs.prototype.view__sc_IndexedSeqView = (function() {
  return new $c_sc_IndexedSeqView$Id(this);
});
$c_sjsr_WrappedVarArgs.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n);
});
$c_sjsr_WrappedVarArgs.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$c_sjsr_WrappedVarArgs.prototype.reverse__O = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this);
});
$c_sjsr_WrappedVarArgs.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sjsr_WrappedVarArgs.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sjsr_WrappedVarArgs.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sjsr_WrappedVarArgs.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sjsr_WrappedVarArgs.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sjsr_WrappedVarArgs.prototype.toSeq__sci_Seq = (function() {
  return this;
});
$c_sjsr_WrappedVarArgs.prototype.equals__O__Z = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o);
});
$c_sjsr_WrappedVarArgs.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this);
});
$c_sjsr_WrappedVarArgs.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$c_sjsr_WrappedVarArgs.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$c_sjsr_WrappedVarArgs.prototype.size__I = (function() {
  return this.length__I();
});
$c_sjsr_WrappedVarArgs.prototype.distinct__O = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$c_sjsr_WrappedVarArgs.prototype.startsWith__sc_IterableOnce__I__Z = (function(that, offset) {
  return $f_sc_SeqOps__startsWith__sc_IterableOnce__I__Z(this, that, offset);
});
$c_sjsr_WrappedVarArgs.prototype.startsWith$default$2__I = (function() {
  return 0;
});
$c_sjsr_WrappedVarArgs.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  var this$2 = $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1);
  return $f_sc_Iterator__indexWhere__F1__I__I(this$2, p, from);
});
$c_sjsr_WrappedVarArgs.prototype.sizeCompare__I__I = (function(otherSize) {
  var x = this.length__I();
  return ((x === otherSize) ? 0 : ((x < otherSize) ? (-1) : 1));
});
$c_sjsr_WrappedVarArgs.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_sjsr_WrappedVarArgs.prototype.orElse__s_PartialFunction__s_PartialFunction = (function(that) {
  return new $c_s_PartialFunction$OrElse(this, that);
});
$c_sjsr_WrappedVarArgs.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_sjsr_WrappedVarArgs.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_sjsr_WrappedVarArgs.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1);
});
$c_sjsr_WrappedVarArgs.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_sjsr_WrappedVarArgs.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__I__O(v1));
});
$c_sjsr_WrappedVarArgs.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sjsr_WrappedVarArgs.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sjsr_WrappedVarArgs$().newBuilder__scm_Builder();
});
$c_sjsr_WrappedVarArgs.prototype.splitAt__I__T2 = (function(n) {
  return $f_sc_IterableOps__splitAt__I__T2(this, n);
});
$c_sjsr_WrappedVarArgs.prototype.takeWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__takeWhile__F1__O(this, p);
});
$c_sjsr_WrappedVarArgs.prototype.dropWhile__F1__O = (function(p) {
  return $f_sc_IterableOps__dropWhile__F1__O(this, p);
});
$c_sjsr_WrappedVarArgs.prototype.sliding__I__I__sc_Iterator = (function(size, step) {
  return $f_sc_IterableOps__sliding__I__I__sc_Iterator(this, size, step);
});
$c_sjsr_WrappedVarArgs.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$c_sjsr_WrappedVarArgs.prototype.init__O = (function() {
  return $f_sc_IterableOps__init__O(this);
});
$c_sjsr_WrappedVarArgs.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$c_sjsr_WrappedVarArgs.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$c_sjsr_WrappedVarArgs.prototype.find__F1__s_Option = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$c_sjsr_WrappedVarArgs.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_sjsr_WrappedVarArgs.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_sjsr_WrappedVarArgs.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_sjsr_WrappedVarArgs.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$c_sjsr_WrappedVarArgs.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$c_sjsr_WrappedVarArgs.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_sjsr_WrappedVarArgs.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_sjsr_WrappedVarArgs.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_sjsr_WrappedVarArgs.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_sjsr_WrappedVarArgs.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_sjsr_WrappedVarArgs.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sjsr_WrappedVarArgs$();
});
$c_sjsr_WrappedVarArgs.prototype.length__I = (function() {
  return $uI(this.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array.length);
});
$c_sjsr_WrappedVarArgs.prototype.apply__I__O = (function(idx) {
  return this.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array[idx];
});
$c_sjsr_WrappedVarArgs.prototype.className__T = (function() {
  return "WrappedVarArgs";
});
$c_sjsr_WrappedVarArgs.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sjsr_WrappedVarArgs$();
  return this$1.from__sc_IterableOnce__sjsr_WrappedVarArgs(coll);
});
$c_sjsr_WrappedVarArgs.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
$c_sjsr_WrappedVarArgs.prototype.isDefinedAt__O__Z = (function(x) {
  var idx = $uI(x);
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx);
});
$c_sjsr_WrappedVarArgs.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1));
});
$c_sjsr_WrappedVarArgs.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sjsr_WrappedVarArgs$();
});
function $as_sjsr_WrappedVarArgs(obj) {
  return (((obj instanceof $c_sjsr_WrappedVarArgs) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.scalajs.runtime.WrappedVarArgs"));
}
function $isArrayOf_sjsr_WrappedVarArgs(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjsr_WrappedVarArgs)));
}
function $asArrayOf_sjsr_WrappedVarArgs(obj, depth) {
  return (($isArrayOf_sjsr_WrappedVarArgs(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.scalajs.runtime.WrappedVarArgs;", depth));
}
var $d_sjsr_WrappedVarArgs = new $TypeData().initClass($c_sjsr_WrappedVarArgs, "scala.scalajs.runtime.WrappedVarArgs", ({
  sjsr_WrappedVarArgs: 1,
  sci_IndexedSeq: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_SeqOps: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_SyncIO$$anon$2() {
  this.Lcats_effect_SyncIO$$anon$2__f_cats$effect$kernel$Sync$$Delay = null;
  this.Lcats_effect_SyncIO$$anon$2__f_cats$effect$kernel$Sync$$Blocking = null;
  this.Lcats_effect_SyncIO$$anon$2__f_cats$effect$kernel$MonadCancel$Uncancelable$$IdPoll = null;
  $f_Lcats_effect_kernel_Sync__$init$__V(this);
  this.Lcats_effect_SyncIO$$anon$2__f_cats$effect$kernel$MonadCancel$Uncancelable$$IdPoll = new $c_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9();
}
$c_Lcats_effect_SyncIO$$anon$2.prototype = new $h_O();
$c_Lcats_effect_SyncIO$$anon$2.prototype.constructor = $c_Lcats_effect_SyncIO$$anon$2;
/** @constructor */
function $h_Lcats_effect_SyncIO$$anon$2() {
}
$h_Lcats_effect_SyncIO$$anon$2.prototype = $c_Lcats_effect_SyncIO$$anon$2.prototype;
$c_Lcats_effect_SyncIO$$anon$2.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.guarantee__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O(this, fa, fin);
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guaranteeCase__O__F1__O(this, fa, fin);
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release);
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Delay_$eq__Lcats_effect_kernel_Sync$Type$Delay$__V = (function(x$0) {
  this.Lcats_effect_SyncIO$$anon$2__f_cats$effect$kernel$Sync$$Delay = x$0;
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Blocking_$eq__Lcats_effect_kernel_Sync$Type$Blocking$__V = (function(x$0) {
  this.Lcats_effect_SyncIO$$anon$2__f_cats$effect$kernel$Sync$$Blocking = x$0;
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleOnce_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleOnce$__V = (function(x$0) {
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleMany_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleMany$__V = (function(x$0) {
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.unique__O = (function() {
  return $f_Lcats_effect_kernel_Sync__unique__O(this);
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.delay__F0__O = (function(thunk) {
  var hint = this.Lcats_effect_SyncIO$$anon$2__f_cats$effect$kernel$Sync$$Delay;
  return new $c_Lcats_effect_SyncIO$Suspend(hint, thunk);
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.blocking__F0__O = (function(thunk) {
  var hint = this.Lcats_effect_SyncIO$$anon$2__f_cats$effect$kernel$Sync$$Blocking;
  return new $c_Lcats_effect_SyncIO$Suspend(hint, thunk);
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.tailRecM__O__F1__O = (function(a, f) {
  return $f_Lcats_StackSafeMonad__tailRecM__O__F1__O(this, a, f);
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.canceled__O = (function() {
  return $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__unit;
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.onCancel__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel$Uncancelable__onCancel__O__O__O(this, fa, fin);
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.uncancelable__F1__O = (function(body) {
  return $n(body).apply__O__O(this.Lcats_effect_SyncIO$$anon$2__f_cats$effect$kernel$MonadCancel$Uncancelable$$IdPoll);
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.pure__O__O = (function(x) {
  $m_Lcats_effect_SyncIO$();
  return new $c_Lcats_effect_SyncIO$Pure(x);
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.raiseError__O__O = (function(e) {
  var e$1 = $as_jl_Throwable(e);
  $m_Lcats_effect_SyncIO$();
  return new $c_Lcats_effect_SyncIO$Error(e$1);
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_effect_SyncIO(fa);
  var this$1 = $n(fa$1);
  return new $c_Lcats_effect_SyncIO$HandleErrorWith(this$1, f);
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_effect_SyncIO(fa);
  var this$1 = $n(fa$1);
  return new $c_Lcats_effect_SyncIO$FlatMap(this$1, f);
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.realTime__O = (function() {
  return $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f_realTime;
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.suspend__Lcats_effect_kernel_Sync$Type__F0__O = (function(hint, thunk) {
  return new $c_Lcats_effect_SyncIO$Suspend(hint, thunk);
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.attempt__O__O = (function(fa) {
  var fa$1 = $as_Lcats_effect_SyncIO(fa);
  var this$1 = $n(fa$1);
  return new $c_Lcats_effect_SyncIO$Attempt(this$1);
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.unit__O = (function() {
  return $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__unit;
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.forceR__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_effect_SyncIO(fa);
  var fb$1 = $as_Lcats_effect_SyncIO(fb);
  var this$1 = $n(fa$1);
  return new $c_Lcats_effect_SyncIO$Attempt(this$1).productR__Lcats_effect_SyncIO__Lcats_effect_SyncIO(fb$1);
});
var $d_Lcats_effect_SyncIO$$anon$2 = new $TypeData().initClass($c_Lcats_effect_SyncIO$$anon$2, "cats.effect.SyncIO$$anon$2", ({
  Lcats_effect_SyncIO$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lcats_effect_kernel_ClockPlatform: 1,
  Lcats_effect_kernel_Clock: 1,
  Lcats_effect_kernel_Unique: 1,
  Lcats_Defer: 1,
  Lcats_effect_kernel_Sync: 1,
  Lcats_StackSafeMonad: 1,
  Lcats_effect_kernel_MonadCancel$Uncancelable: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_ResourceConcurrent() {
}
$c_Lcats_effect_kernel_ResourceConcurrent.prototype = new $h_Lcats_effect_kernel_ResourceMonadCancel();
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.constructor = $c_Lcats_effect_kernel_ResourceConcurrent;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceConcurrent() {
}
$h_Lcats_effect_kernel_ResourceConcurrent.prototype = $c_Lcats_effect_kernel_ResourceConcurrent.prototype;
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.raceOutcome__O__O__O = (function(fa, fb) {
  return $f_Lcats_effect_kernel_GenSpawn__raceOutcome__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.racePair__O__O__O = (function(fa, fb) {
  return $f_Lcats_effect_kernel_GenConcurrent__racePair__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.unique__Lcats_effect_kernel_Resource = (function() {
  var F = this.F__Lcats_effect_kernel_GenConcurrent();
  var fa = $n(F).unique__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
});
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.never__Lcats_effect_kernel_Resource = (function() {
  var F = this.F__Lcats_effect_kernel_GenConcurrent();
  var fa = $n(F).never__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
});
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.unique__O = (function() {
  return this.unique__Lcats_effect_kernel_Resource();
});
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.never__O = (function() {
  return this.never__Lcats_effect_kernel_Resource();
});
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.cede__O = (function() {
  var F = this.F__Lcats_effect_kernel_GenConcurrent();
  var fa = $n(F).cede__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
});
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.start__O__O = (function(fa) {
  var fa$1 = $as_Lcats_effect_kernel_Resource(fa);
  return $n(fa$1).start__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(this.F__Lcats_effect_kernel_GenConcurrent());
});
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.deferred__O = (function() {
  return $m_Lcats_effect_kernel_Resource$().deferred__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(this.F__Lcats_effect_kernel_GenConcurrent());
});
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.ref__O__O = (function(a) {
  return $m_Lcats_effect_kernel_Resource$().ref__O__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(a, this.F__Lcats_effect_kernel_GenConcurrent());
});
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.both__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_effect_kernel_Resource(fa);
  var fb$1 = $as_Lcats_effect_kernel_Resource(fb);
  return $n(fa$1).both__Lcats_effect_kernel_Resource__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(fb$1, this.F__Lcats_effect_kernel_GenConcurrent());
});
function $f_Lcats_effect_kernel_Sync$KleisliSync__suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_data_Kleisli($thiz, hint, thunk) {
  var this$1 = $m_Lcats_data_Kleisli$();
  var x = $n($thiz.F__Lcats_effect_kernel_Sync()).suspend__Lcats_effect_kernel_Sync$Type__F0__O(hint, thunk);
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$1, x);
}
/** @constructor */
function $c_sci_HashMap(rootNode) {
  this.sci_HashMap__f_rootNode = null;
  this.sci_HashMap__f_rootNode = rootNode;
}
$c_sci_HashMap.prototype = new $h_sci_AbstractMap();
$c_sci_HashMap.prototype.constructor = $c_sci_HashMap;
/** @constructor */
function $h_sci_HashMap() {
}
$h_sci_HashMap.prototype = $c_sci_HashMap.prototype;
$c_sci_HashMap.prototype.map__F1__sc_IterableOps = (function(f) {
  return $f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps(this, f);
});
$c_sci_HashMap.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_HashMap.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_HashMap.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_sci_HashMap.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_HashMap(pred, false);
});
$c_sci_HashMap.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_HashMap(pred, true);
});
$c_sci_HashMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_sci_HashMap$();
});
$c_sci_HashMap.prototype.knownSize__I = (function() {
  return $n(this.sci_HashMap__f_rootNode).sci_BitmapIndexedMapNode__f_size;
});
$c_sci_HashMap.prototype.size__I = (function() {
  return $n(this.sci_HashMap__f_rootNode).sci_BitmapIndexedMapNode__f_size;
});
$c_sci_HashMap.prototype.isEmpty__Z = (function() {
  return ($n(this.sci_HashMap__f_rootNode).sci_BitmapIndexedMapNode__f_size === 0);
});
$c_sci_HashMap.prototype.keySet__sci_Set = (function() {
  return (($n(this.sci_HashMap__f_rootNode).sci_BitmapIndexedMapNode__f_size === 0) ? $m_sci_Set$EmptySet$() : new $c_sci_HashMap$HashKeySet(this));
});
$c_sci_HashMap.prototype.iterator__sc_Iterator = (function() {
  return (this.isEmpty__Z() ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_MapKeyValueTupleIterator(this.sci_HashMap__f_rootNode));
});
$c_sci_HashMap.prototype.keysIterator__sc_Iterator = (function() {
  return (this.isEmpty__Z() ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_MapKeyIterator(this.sci_HashMap__f_rootNode));
});
$c_sci_HashMap.prototype.valuesIterator__sc_Iterator = (function() {
  return (this.isEmpty__Z() ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_MapValueIterator(this.sci_HashMap__f_rootNode));
});
$c_sci_HashMap.prototype.reverseIterator__sc_Iterator = (function() {
  return (this.isEmpty__Z() ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_MapKeyValueTupleReverseIterator(this.sci_HashMap__f_rootNode));
});
$c_sci_HashMap.prototype.contains__O__Z = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return $n(this.sci_HashMap__f_rootNode).containsKey__O__I__I__I__Z(key, keyUnimprovedHash, keyHash, 0);
});
$c_sci_HashMap.prototype.apply__O__O = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return $n(this.sci_HashMap__f_rootNode).apply__O__I__I__I__O(key, keyUnimprovedHash, keyHash, 0);
});
$c_sci_HashMap.prototype.get__O__s_Option = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return $n(this.sci_HashMap__f_rootNode).get__O__I__I__I__s_Option(key, keyUnimprovedHash, keyHash, 0);
});
$c_sci_HashMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return $n(this.sci_HashMap__f_rootNode).getOrElse__O__I__I__I__F0__O(key, keyUnimprovedHash, keyHash, 0, default$1);
});
$c_sci_HashMap.prototype.updated__O__O__sci_HashMap = (function(key, value) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var newRootNode = $n(this.sci_HashMap__f_rootNode).updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(key, value, keyUnimprovedHash, $m_sc_Hashing$().improve__I__I(keyUnimprovedHash), 0, true);
  return ((newRootNode === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode));
});
$c_sci_HashMap.prototype.removed__O__sci_HashMap = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var newRootNode = $n(this.sci_HashMap__f_rootNode).removed__O__I__I__I__sci_BitmapIndexedMapNode(key, keyUnimprovedHash, $m_sc_Hashing$().improve__I__I(keyUnimprovedHash), 0);
  return ((newRootNode === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode));
});
$c_sci_HashMap.prototype.concat__sc_IterableOnce__sci_HashMap = (function(that) {
  if ((that instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(that);
    if (this.isEmpty__Z()) {
      return x2;
    } else {
      var newNode = $n(this.sci_HashMap__f_rootNode).concat__sci_MapNode__I__sci_BitmapIndexedMapNode($n(x2).sci_HashMap__f_rootNode, 0);
      if ((newNode === $n(x2).sci_HashMap__f_rootNode)) {
        return x2;
      } else {
        var newRootNode = $n(this.sci_HashMap__f_rootNode).concat__sci_MapNode__I__sci_BitmapIndexedMapNode($n(x2).sci_HashMap__f_rootNode, 0);
        return ((newRootNode === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode));
      }
    }
  } else if ((that instanceof $c_scm_HashMap)) {
    var x3 = $as_scm_HashMap(that);
    var iter = $n(x3).nodeIterator__sc_Iterator();
    var current = this.sci_HashMap__f_rootNode;
    while ($n(iter).hasNext__Z()) {
      var next = $as_scm_HashMap$Node($n(iter).next__O());
      $n(x3);
      var improvedHash = $n(next).scm_HashMap$Node__f__hash;
      var originalHash = (improvedHash ^ ((improvedHash >>> 16) | 0));
      var improved = $m_sc_Hashing$().improve__I__I(originalHash);
      current = $n(current).updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode($n(next).scm_HashMap$Node__f__key, $n(next).scm_HashMap$Node__f__value, originalHash, improved, 0, true);
      if ((current !== this.sci_HashMap__f_rootNode)) {
        var shallowlyMutableNodeMap = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(improved, 0));
        while ($n(iter).hasNext__Z()) {
          var next$2 = $as_scm_HashMap$Node($n(iter).next__O());
          $n(x3);
          var improvedHash$1 = $n(next$2).scm_HashMap$Node__f__hash;
          var originalHash$2 = (improvedHash$1 ^ ((improvedHash$1 >>> 16) | 0));
          shallowlyMutableNodeMap = $n(current).updateWithShallowMutations__O__O__I__I__I__I__I($n(next$2).scm_HashMap$Node__f__key, $n(next$2).scm_HashMap$Node__f__value, originalHash$2, $m_sc_Hashing$().improve__I__I(originalHash$2), 0, shallowlyMutableNodeMap);
        }
        return new $c_sci_HashMap(current);
      }
    }
    return this;
  } else if (false) {
    var x4 = $as_scm_LinkedHashMap(that);
    var iter$2 = $n(x4).entryIterator__sc_Iterator();
    var current$2 = this.sci_HashMap__f_rootNode;
    while ($n(iter$2).hasNext__Z()) {
      var next$3 = $as_scm_LinkedHashMap$LinkedEntry($n(iter$2).next__O());
      var originalHash$3 = $n(x4).unimproveHash__I__I($n(next$3).hash__I());
      var improved$2 = $m_sc_Hashing$().improve__I__I(originalHash$3);
      current$2 = $n(current$2).updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode($n(next$3).key__O(), $n(next$3).value__O(), originalHash$3, improved$2, 0, true);
      if ((current$2 !== this.sci_HashMap__f_rootNode)) {
        var shallowlyMutableNodeMap$2 = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(improved$2, 0));
        while ($n(iter$2).hasNext__Z()) {
          var next$4 = $as_scm_LinkedHashMap$LinkedEntry($n(iter$2).next__O());
          var originalHash$4 = $n(x4).unimproveHash__I__I($n(next$4).hash__I());
          shallowlyMutableNodeMap$2 = $n(current$2).updateWithShallowMutations__O__O__I__I__I__I__I($n(next$4).key__O(), $n(next$4).value__O(), originalHash$4, $m_sc_Hashing$().improve__I__I(originalHash$4), 0, shallowlyMutableNodeMap$2);
        }
        return new $c_sci_HashMap(current$2);
      }
    }
    return this;
  } else if ($is_sci_Map(that)) {
    var x2$2 = $as_sci_Map(that);
    if ($n(x2$2).isEmpty__Z()) {
      return this;
    } else {
      var accum = new $c_sci_HashMap$accum$1(this);
      $n(x2$2).foreachEntry__F2__V(accum);
      var newRootNode$1 = accum.sci_HashMap$accum$1__f_current;
      return ((newRootNode$1 === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode$1));
    }
  } else {
    var it = $n(that).iterator__sc_Iterator();
    var this$3 = $n(it);
    if ((!this$3.hasNext__Z())) {
      return this;
    } else {
      var accum$2 = new $c_sci_HashMap$accum$1(this);
      var this$4 = $n(it);
      $f_sc_IterableOnceOps__foreach__F1__V(this$4, accum$2);
      var newRootNode$2 = accum$2.sci_HashMap$accum$1__f_current;
      return ((newRootNode$2 === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode$2));
    }
  }
});
$c_sci_HashMap.prototype.tail__sci_HashMap = (function() {
  var key = $n($as_T2($n(this.iterator__sc_Iterator()).next__O()))._1__O();
  return this.removed__O__sci_HashMap(key);
});
$c_sci_HashMap.prototype.foreach__F1__V = (function(f) {
  $n(this.sci_HashMap__f_rootNode).foreach__F1__V(f);
});
$c_sci_HashMap.prototype.foreachEntry__F2__V = (function(f) {
  $n(this.sci_HashMap__f_rootNode).foreachEntry__F2__V(f);
});
$c_sci_HashMap.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(that);
    if ((this === x2)) {
      return true;
    } else {
      var x = this.sci_HashMap__f_rootNode;
      var x$2 = $n(x2).sci_HashMap__f_rootNode;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    }
  } else {
    return $f_sc_Map__equals__O__Z(this, that);
  }
});
$c_sci_HashMap.prototype.hashCode__I = (function() {
  if (this.isEmpty__Z()) {
    return $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_emptyMapHash;
  } else {
    var hashIterator = new $c_sci_MapKeyValueTupleHashIterator(this.sci_HashMap__f_rootNode);
    var hash = $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(hashIterator, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed);
    return hash;
  }
});
$c_sci_HashMap.prototype.className__T = (function() {
  return "HashMap";
});
$c_sci_HashMap.prototype.filterImpl__F1__Z__sci_HashMap = (function(pred, isFlipped) {
  var newRootNode = $n(this.sci_HashMap__f_rootNode).filterImpl__F1__Z__sci_BitmapIndexedMapNode(pred, isFlipped);
  if ((newRootNode === this.sci_HashMap__f_rootNode)) {
    return this;
  } else if (($n(newRootNode).sci_BitmapIndexedMapNode__f_size === 0)) {
    var this$1 = $m_sci_HashMap$();
    return this$1.sci_HashMap$__f_EmptyMap;
  } else {
    return new $c_sci_HashMap(newRootNode);
  }
});
$c_sci_HashMap.prototype.removedAll__sc_IterableOnce__sci_HashMap = (function(keys) {
  if (this.isEmpty__Z()) {
    return this;
  } else if ((keys instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(keys);
    if ($n(x2).isEmpty__Z()) {
      return this;
    } else {
      var newRootNode = new $c_sci_MapNodeRemoveAllSetNodeIterator($n(x2).sci_HashSet__f_rootNode).removeAll__sci_BitmapIndexedMapNode__sci_BitmapIndexedMapNode(this.sci_HashMap__f_rootNode);
      if ((newRootNode === this.sci_HashMap__f_rootNode)) {
        return this;
      } else if (($n(newRootNode).sci_BitmapIndexedMapNode__f_size <= 0)) {
        var this$1 = $m_sci_HashMap$();
        return this$1.sci_HashMap$__f_EmptyMap;
      } else {
        return new $c_sci_HashMap(newRootNode);
      }
    }
  } else if ((keys instanceof $c_scm_HashSet)) {
    var x3 = $as_scm_HashSet(keys);
    if ($n(x3).isEmpty__Z()) {
      return this;
    } else {
      var this$2 = $n(x3);
      var iter = new $c_scm_HashSet$$anon$2(this$2);
      var curr = this.sci_HashMap__f_rootNode;
      while (iter.hasNext__Z()) {
        var next = $as_scm_HashSet$Node(iter.next__O());
        var this$3 = $n(x3);
        var improvedHash = $n(next).scm_HashSet$Node__f__hash;
        var originalHash = this$3.scala$collection$mutable$HashSet$$improveHash__I__I(improvedHash);
        var improved = $m_sc_Hashing$().improve__I__I(originalHash);
        curr = $n(curr).removed__O__I__I__I__sci_BitmapIndexedMapNode($n(next).scm_HashSet$Node__f__key, originalHash, improved, 0);
        if (($n(curr).sci_BitmapIndexedMapNode__f_size === 0)) {
          var this$4 = $m_sci_HashMap$();
          return this$4.sci_HashMap$__f_EmptyMap;
        }
      }
      var newRootNode$1 = curr;
      return ((newRootNode$1 === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode$1));
    }
  } else if (false) {
    var x4 = $as_scm_LinkedHashSet(keys);
    if ($n(x4).isEmpty__Z()) {
      return this;
    } else {
      var iter$2 = $n(x4).entryIterator__sc_Iterator();
      var curr$2 = this.sci_HashMap__f_rootNode;
      while ($n(iter$2).hasNext__Z()) {
        var next$2 = $as_scm_LinkedHashSet$Entry($n(iter$2).next__O());
        var originalHash$2 = $n(x4).unimproveHash__I__I($n(next$2).hash__I());
        var improved$2 = $m_sc_Hashing$().improve__I__I(originalHash$2);
        curr$2 = $n(curr$2).removed__O__I__I__I__sci_BitmapIndexedMapNode($n(next$2).key__O(), originalHash$2, improved$2, 0);
        if (($n(curr$2).sci_BitmapIndexedMapNode__f_size === 0)) {
          var this$5 = $m_sci_HashMap$();
          return this$5.sci_HashMap$__f_EmptyMap;
        }
      }
      var newRootNode$2 = curr$2;
      return ((newRootNode$2 === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode$2));
    }
  } else {
    var iter$3 = $n(keys).iterator__sc_Iterator();
    var curr$3 = this.sci_HashMap__f_rootNode;
    while ($n(iter$3).hasNext__Z()) {
      var next$3 = $n(iter$3).next__O();
      var originalHash$3 = $m_sr_Statics$().anyHash__O__I(next$3);
      var improved$3 = $m_sc_Hashing$().improve__I__I(originalHash$3);
      curr$3 = $n(curr$3).removed__O__I__I__I__sci_BitmapIndexedMapNode(next$3, originalHash$3, improved$3, 0);
      if (($n(curr$3).sci_BitmapIndexedMapNode__f_size === 0)) {
        var this$6 = $m_sci_HashMap$();
        return this$6.sci_HashMap$__f_EmptyMap;
      }
    }
    var newRootNode$3 = curr$3;
    return ((newRootNode$3 === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode$3));
  }
});
$c_sci_HashMap.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_sci_HashMap.prototype.drop__I__O = (function(n) {
  return $as_sci_HashMap($f_sc_IterableOps__drop__I__O(this, n));
});
$c_sci_HashMap.prototype.dropRight__I__O = (function(n) {
  return $as_sci_HashMap($f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n));
});
$c_sci_HashMap.prototype.dropWhile__F1__O = (function(p) {
  return $as_sci_HashMap($f_sc_IterableOps__dropWhile__F1__O(this, p));
});
$c_sci_HashMap.prototype.takeWhile__F1__O = (function(p) {
  return $as_sci_HashMap($f_sc_IterableOps__takeWhile__F1__O(this, p));
});
$c_sci_HashMap.prototype.take__I__O = (function(n) {
  return $as_sci_HashMap($f_sc_IterableOps__take__I__O(this, n));
});
$c_sci_HashMap.prototype.removedAll__sc_IterableOnce__sci_MapOps = (function(keys) {
  return this.removedAll__sc_IterableOnce__sci_HashMap(keys);
});
$c_sci_HashMap.prototype.last__O = (function() {
  return $as_T2($n(this.reverseIterator__sc_Iterator()).next__O());
});
$c_sci_HashMap.prototype.head__O = (function() {
  return $as_T2($n(this.iterator__sc_Iterator()).next__O());
});
$c_sci_HashMap.prototype.tail__O = (function() {
  return this.tail__sci_HashMap();
});
$c_sci_HashMap.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return this.concat__sc_IterableOnce__sci_HashMap(suffix);
});
$c_sci_HashMap.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_HashMap(key);
});
$c_sci_HashMap.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_HashMap(key, value);
});
$c_sci_HashMap.prototype.keySet__sc_Set = (function() {
  return this.keySet__sci_Set();
});
function $as_sci_HashMap(obj) {
  return (((obj instanceof $c_sci_HashMap) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashMap"));
}
function $isArrayOf_sci_HashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashMap)));
}
function $asArrayOf_sci_HashMap(obj, depth) {
  return (($isArrayOf_sci_HashMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashMap;", depth));
}
var $d_sci_HashMap = new $TypeData().initClass($c_sci_HashMap, "scala.collection.immutable.HashMap", ({
  sci_HashMap: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sci_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Stream$Cons(head, tl) {
  this.sci_Stream$Cons__f_head = null;
  this.sci_Stream$Cons__f_tlVal = null;
  this.sci_Stream$Cons__f_tlGen = null;
  this.sci_Stream$Cons__f_head = head;
  this.sci_Stream$Cons__f_tlGen = tl;
}
$c_sci_Stream$Cons.prototype = new $h_sci_Stream();
$c_sci_Stream$Cons.prototype.constructor = $c_sci_Stream$Cons;
/** @constructor */
function $h_sci_Stream$Cons() {
}
$h_sci_Stream$Cons.prototype = $c_sci_Stream$Cons.prototype;
$c_sci_Stream$Cons.prototype.head__O = (function() {
  return this.sci_Stream$Cons__f_head;
});
$c_sci_Stream$Cons.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Stream$Cons.prototype.tailDefined__Z = (function() {
  return (this.sci_Stream$Cons__f_tlGen === null);
});
$c_sci_Stream$Cons.prototype.tail__sci_Stream = (function() {
  if ((!this.tailDefined__Z())) {
    if ((!this.tailDefined__Z())) {
      this.sci_Stream$Cons__f_tlVal = $as_sci_Stream($n(this.sci_Stream$Cons__f_tlGen).apply__O());
      this.sci_Stream$Cons__f_tlGen = null;
    }
  }
  return this.sci_Stream$Cons__f_tlVal;
});
$c_sci_Stream$Cons.prototype.force__sci_Stream$Cons = (function() {
  var these = this;
  var those = this;
  if ((!$n(these).isEmpty__Z())) {
    these = $as_sci_Stream($n(these).tail__O());
  }
  while ((those !== these)) {
    if ($n(these).isEmpty__Z()) {
      return this;
    }
    these = $as_sci_Stream($n(these).tail__O());
    if ($n(these).isEmpty__Z()) {
      return this;
    }
    these = $as_sci_Stream($n(these).tail__O());
    if ((these === those)) {
      return this;
    }
    those = $as_sci_Stream($n(those).tail__O());
  }
  return this;
});
$c_sci_Stream$Cons.prototype.force__sci_Stream = (function() {
  return this.force__sci_Stream$Cons();
});
$c_sci_Stream$Cons.prototype.tail__O = (function() {
  return this.tail__sci_Stream();
});
var $d_sci_Stream$Cons = new $TypeData().initClass($c_sci_Stream$Cons, "scala.collection.immutable.Stream$Cons", ({
  sci_Stream$Cons: 1,
  sci_Stream: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Stream$Empty$() {
}
$c_sci_Stream$Empty$.prototype = new $h_sci_Stream();
$c_sci_Stream$Empty$.prototype.constructor = $c_sci_Stream$Empty$;
/** @constructor */
function $h_sci_Stream$Empty$() {
}
$h_sci_Stream$Empty$.prototype = $c_sci_Stream$Empty$.prototype;
$c_sci_Stream$Empty$.prototype.isEmpty__Z = (function() {
  return true;
});
$c_sci_Stream$Empty$.prototype.head__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty stream");
});
$c_sci_Stream$Empty$.prototype.tail__sci_Stream = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty stream");
});
$c_sci_Stream$Empty$.prototype.knownSize__I = (function() {
  return 0;
});
$c_sci_Stream$Empty$.prototype.tailDefined__Z = (function() {
  return false;
});
$c_sci_Stream$Empty$.prototype.force__sci_Stream = (function() {
  return this;
});
$c_sci_Stream$Empty$.prototype.tail__O = (function() {
  return this.tail__sci_Stream();
});
$c_sci_Stream$Empty$.prototype.head__O = (function() {
  this.head__E();
});
var $d_sci_Stream$Empty$ = new $TypeData().initClass($c_sci_Stream$Empty$, "scala.collection.immutable.Stream$Empty$", ({
  sci_Stream$Empty$: 1,
  sci_Stream: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_Stream$Empty$;
function $m_sci_Stream$Empty$() {
  if ((!$n_sci_Stream$Empty$)) {
    $n_sci_Stream$Empty$ = new $c_sci_Stream$Empty$();
  }
  return $n_sci_Stream$Empty$;
}
/** @constructor */
function $c_sci_TreeSeqMap(ordering, mapping, ordinal, orderedBy) {
  this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$ordering = null;
  this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$mapping = null;
  this.sci_TreeSeqMap__f_ordinal = 0;
  this.sci_TreeSeqMap__f_orderedBy = null;
  this.sci_TreeSeqMap__f_size = 0;
  this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$ordering = ordering;
  this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$mapping = mapping;
  this.sci_TreeSeqMap__f_ordinal = ordinal;
  this.sci_TreeSeqMap__f_orderedBy = orderedBy;
  this.sci_TreeSeqMap__f_size = $n(mapping).size__I();
}
$c_sci_TreeSeqMap.prototype = new $h_sci_AbstractMap();
$c_sci_TreeSeqMap.prototype.constructor = $c_sci_TreeSeqMap;
/** @constructor */
function $h_sci_TreeSeqMap() {
}
$h_sci_TreeSeqMap.prototype = $c_sci_TreeSeqMap.prototype;
$c_sci_TreeSeqMap.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_sci_TreeSeqMap.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_TreeSeqMap.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_TreeSeqMap.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_sci_TreeSeqMap.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_sci_TreeSeqMap.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$c_sci_TreeSeqMap.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_TreeSeqMap.prototype.stringPrefix__T = (function() {
  return "SeqMap";
});
$c_sci_TreeSeqMap.prototype.className__T = (function() {
  return "TreeSeqMap";
});
$c_sci_TreeSeqMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_sci_TreeSeqMap$();
});
$c_sci_TreeSeqMap.prototype.size__I = (function() {
  return this.sci_TreeSeqMap__f_size;
});
$c_sci_TreeSeqMap.prototype.knownSize__I = (function() {
  return this.sci_TreeSeqMap__f_size;
});
$c_sci_TreeSeqMap.prototype.isEmpty__Z = (function() {
  return (this.sci_TreeSeqMap__f_size === 0);
});
$c_sci_TreeSeqMap.prototype.updated__O__O__sci_TreeSeqMap = (function(key, value) {
  var rc10 = false;
  var x2 = null;
  var x1 = $n(this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$mapping).get__O__s_Option(key);
  if ((this.sci_TreeSeqMap__f_ordinal === (-1))) {
    var x = this.sci_TreeSeqMap__f_orderedBy;
    var x$2 = $m_sci_TreeSeqMap$OrderBy$Modification$();
    if ((x !== null)) {
      var this$1 = $n(x);
      var $x_2 = (this$1 === x$2);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var $x_1 = true;
    } else {
      var $x_1 = $n(x1).isEmpty__Z();
    }
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var this$2 = $n($m_sci_TreeSeqMap$().empty__sci_TreeSeqMap$OrderBy__sci_TreeSeqMap(this.sci_TreeSeqMap__f_orderedBy));
    var this$5 = $n(this$2.concat__sc_IterableOnce__sci_TreeSeqMap(this));
    return this$5.updated__O__O__sci_TreeSeqMap(key, value);
  }
  if ((x1 instanceof $c_s_Some)) {
    rc10 = true;
    x2 = $as_s_Some(x1);
    var p3 = $as_T2($n(x2).s_Some__f_value);
    if ((p3 !== null)) {
      var o = $n(p3)._1$mcI$sp__I();
      var x$3 = this.sci_TreeSeqMap__f_orderedBy;
      var x$4 = $m_sci_TreeSeqMap$OrderBy$Insertion$();
      if ((x$3 !== null)) {
        var this$6 = $n(x$3);
        var $x_3 = (this$6 === x$4);
      } else {
        var $x_3 = false;
      }
      if ($x_3) {
        return new $c_sci_TreeSeqMap($n(this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$ordering).include__I__O__sci_TreeSeqMap$Ordering(o, key), $as_sci_Map($n(this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$mapping).updated__O__O__sci_MapOps(key, new $c_T2(o, value))), this.sci_TreeSeqMap__f_ordinal, this.sci_TreeSeqMap__f_orderedBy);
      }
    }
  }
  if (rc10) {
    var p6 = $as_T2($n(x2).s_Some__f_value);
    if ((p6 !== null)) {
      var o$2 = $n(p6)._1$mcI$sp__I();
      $m_sci_TreeSeqMap$();
      var ord = this.sci_TreeSeqMap__f_ordinal;
      var o1 = ((ord === 2147483647) ? (-2147483648) : ((1 + ord) | 0));
      return new $c_sci_TreeSeqMap($n($n(this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$ordering).exclude__I__sci_TreeSeqMap$Ordering(o$2)).append__I__O__sci_TreeSeqMap$Ordering(o1, key), $as_sci_Map($n(this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$mapping).updated__O__O__sci_MapOps(key, new $c_T2(o1, value))), o1, this.sci_TreeSeqMap__f_orderedBy);
    }
  }
  var x$5 = $m_s_None$();
  if ((x$5 === x1)) {
    $m_sci_TreeSeqMap$();
    var ord$1 = this.sci_TreeSeqMap__f_ordinal;
    var o1$2 = ((ord$1 === 2147483647) ? (-2147483648) : ((1 + ord$1) | 0));
    return new $c_sci_TreeSeqMap($n(this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$ordering).append__I__O__sci_TreeSeqMap$Ordering(o1$2, key), $as_sci_Map($n(this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$mapping).updated__O__O__sci_MapOps(key, new $c_T2(o1$2, value))), o1$2, this.sci_TreeSeqMap__f_orderedBy);
  }
  throw new $c_s_MatchError(x1);
});
$c_sci_TreeSeqMap.prototype.removed__O__sci_TreeSeqMap = (function(key) {
  var x1 = $n(this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$mapping).get__O__s_Option(key);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var p3 = $as_T2($n(x2).s_Some__f_value);
    if ((p3 !== null)) {
      var o = $n(p3)._1$mcI$sp__I();
      return new $c_sci_TreeSeqMap($n(this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$ordering).exclude__I__sci_TreeSeqMap$Ordering(o), $as_sci_Map($n(this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$mapping).removed__O__sci_MapOps(key)), this.sci_TreeSeqMap__f_ordinal, this.sci_TreeSeqMap__f_orderedBy);
    }
  }
  var x = $m_s_None$();
  if ((x === x1)) {
    return this;
  }
  throw new $c_s_MatchError(x1);
});
$c_sci_TreeSeqMap.prototype.get__O__s_Option = (function(key) {
  var this$1 = $n($n(this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$mapping).get__O__s_Option(key));
  if (this$1.isEmpty__Z()) {
    return $m_s_None$();
  } else {
    var arg1 = this$1.get__O();
    var p = $as_T2(arg1);
    return new $c_s_Some($n(p)._2__O());
  }
});
$c_sci_TreeSeqMap.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_TreeSeqMap$$anon$1(this);
});
$c_sci_TreeSeqMap.prototype.keysIterator__sc_Iterator = (function() {
  return new $c_sci_TreeSeqMap$$anon$2(this);
});
$c_sci_TreeSeqMap.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sci_TreeSeqMap$$anon$3(this);
});
$c_sci_TreeSeqMap.prototype.contains__O__Z = (function(key) {
  return $n(this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$mapping).contains__O__Z(key);
});
$c_sci_TreeSeqMap.prototype.head__T2 = (function() {
  var k = $n(this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$ordering).head__O();
  var qual$1 = $as_T2($n(this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$mapping).apply__O__O(k));
  var x$2 = $n(qual$1).copy$default$2__O();
  $n(qual$1);
  return new $c_T2(k, x$2);
});
$c_sci_TreeSeqMap.prototype.headOption__s_Option = (function() {
  var this$1 = $n($n(this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$ordering).headOption__s_Option());
  if (this$1.isEmpty__Z()) {
    return $m_s_None$();
  } else {
    var arg1 = this$1.get__O();
    var qual$1 = $as_T2($n(this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$mapping).apply__O__O(arg1));
    var x$2 = $n(qual$1).copy$default$2__O();
    $n(qual$1);
    return new $c_s_Some(new $c_T2(arg1, x$2));
  }
});
$c_sci_TreeSeqMap.prototype.last__T2 = (function() {
  var k = $n(this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$ordering).last__O();
  var qual$1 = $as_T2($n(this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$mapping).apply__O__O(k));
  var x$2 = $n(qual$1).copy$default$2__O();
  $n(qual$1);
  return new $c_T2(k, x$2);
});
$c_sci_TreeSeqMap.prototype.tail__sci_TreeSeqMap = (function() {
  var x1 = $n(this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$ordering).headTail__T2();
  if ((x1 === null)) {
    throw new $c_s_MatchError(x1);
  }
  var head = $n(x1)._1__O();
  var tail = $as_sci_TreeSeqMap$Ordering($n(x1)._2__O());
  return new $c_sci_TreeSeqMap(tail, $as_sci_Map($n(this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$mapping).removed__O__sci_MapOps(head)), this.sci_TreeSeqMap__f_ordinal, this.sci_TreeSeqMap__f_orderedBy);
});
$c_sci_TreeSeqMap.prototype.map__F1__sci_TreeSeqMap = (function(f) {
  $m_sci_TreeSeqMap$();
  var orderedBy = this.sci_TreeSeqMap__f_orderedBy;
  var bdr = new $c_sci_TreeSeqMap$Builder(orderedBy);
  var iter = $n(this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$ordering).iterator__sci_TreeSeqMap$Ordering$Iterator();
  while ($n(iter).hasNext__Z()) {
    var k = $n(iter).next__O();
    var x1 = $as_T2($n(this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$mapping).apply__O__O(k));
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var v = $n(x1)._2__O();
    var x1$2 = $as_T2($n(f).apply__O__O(new $c_T2(k, v)));
    if ((x1$2 === null)) {
      throw new $c_s_MatchError(x1$2);
    }
    var k2 = $n(x1$2)._1__O();
    var v2 = $n(x1$2)._2__O();
    bdr.addOne__O__O__sci_TreeSeqMap$Builder(k2, v2);
  }
  return bdr.result__sci_TreeSeqMap();
});
$c_sci_TreeSeqMap.prototype.concat__sc_IterableOnce__sci_TreeSeqMap = (function(suffix) {
  var ong = this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$ordering;
  var mng = this.sci_TreeSeqMap__f_scala$collection$immutable$TreeSeqMap$$mapping;
  $m_sci_TreeSeqMap$();
  var ord = this.sci_TreeSeqMap__f_ordinal;
  var ord$1 = ((ord === 2147483647) ? (-2147483648) : ((1 + ord) | 0));
  var iter = $n(suffix).iterator__sc_Iterator();
  while ($n(iter).hasNext__Z()) {
    var x1 = $as_T2($n(iter).next__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = $n(x1)._1__O();
    var v2 = $n(x1)._2__O();
    var x1$2 = $n(mng).get__O__s_Option(k);
    matchEnd6: {
      if ((x1$2 instanceof $c_s_Some)) {
        var x2 = $as_s_Some(x1$2);
        var p3 = $as_T2($n(x2).s_Some__f_value);
        if ((p3 !== null)) {
          var o = $n(p3)._1$mcI$sp__I();
          var v = $n(p3)._2__O();
          var x = this.sci_TreeSeqMap__f_orderedBy;
          var x$2 = $m_sci_TreeSeqMap$OrderBy$Insertion$();
          if ((x !== null)) {
            var this$2 = $n(x);
            var $x_1 = (this$2 === x$2);
          } else {
            var $x_1 = false;
          }
          if (($x_1 && (!$m_sr_BoxesRunTime$().equals__O__O__Z(v, v2)))) {
            mng = $as_sci_Map($n(mng).updated__O__O__sci_MapOps(k, new $c_T2(o, v2)));
            break matchEnd6;
          } else {
            var x$3 = this.sci_TreeSeqMap__f_orderedBy;
            var x$4 = $m_sci_TreeSeqMap$OrderBy$Modification$();
            if ((x$3 !== null)) {
              var this$3 = $n(x$3);
              var $x_2 = (this$3 === x$4);
            } else {
              var $x_2 = false;
            }
            if ($x_2) {
              mng = $as_sci_Map($n(mng).updated__O__O__sci_MapOps(k, new $c_T2(ord$1, v2)));
              ong = $n($n(ong).exclude__I__sci_TreeSeqMap$Ordering(o)).append__I__O__sci_TreeSeqMap$Ordering(ord$1, k);
              $m_sci_TreeSeqMap$();
              var ord$2 = ord$1;
              ord$1 = ((ord$2 === 2147483647) ? (-2147483648) : ((1 + ord$2) | 0));
              break matchEnd6;
            } else {
              break matchEnd6;
            }
          }
        }
      }
      var x$5 = $m_s_None$();
      if ((x$5 === x1$2)) {
        mng = $as_sci_Map($n(mng).updated__O__O__sci_MapOps(k, new $c_T2(ord$1, v2)));
        ong = $n(ong).append__I__O__sci_TreeSeqMap$Ordering(ord$1, k);
        $m_sci_TreeSeqMap$();
        var ord$3 = ord$1;
        ord$1 = ((ord$3 === 2147483647) ? (-2147483648) : ((1 + ord$3) | 0));
        break matchEnd6;
      }
      throw new $c_s_MatchError(x1$2);
    }
  }
  return new $c_sci_TreeSeqMap(ong, mng, ord$1, this.sci_TreeSeqMap__f_orderedBy);
});
$c_sci_TreeSeqMap.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return this.concat__sc_IterableOnce__sci_TreeSeqMap(suffix);
});
$c_sci_TreeSeqMap.prototype.map__F1__sc_IterableOps = (function(f) {
  return this.map__F1__sci_TreeSeqMap(f);
});
$c_sci_TreeSeqMap.prototype.tail__O = (function() {
  return this.tail__sci_TreeSeqMap();
});
$c_sci_TreeSeqMap.prototype.last__O = (function() {
  return this.last__T2();
});
$c_sci_TreeSeqMap.prototype.head__O = (function() {
  return this.head__T2();
});
$c_sci_TreeSeqMap.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_TreeSeqMap(key);
});
$c_sci_TreeSeqMap.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_TreeSeqMap(key, value);
});
function $as_sci_TreeSeqMap(obj) {
  return (((obj instanceof $c_sci_TreeSeqMap) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.TreeSeqMap"));
}
function $isArrayOf_sci_TreeSeqMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_TreeSeqMap)));
}
function $asArrayOf_sci_TreeSeqMap(obj, depth) {
  return (($isArrayOf_sci_TreeSeqMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.TreeSeqMap;", depth));
}
var $d_sci_TreeSeqMap = new $TypeData().initClass($c_sci_TreeSeqMap, "scala.collection.immutable.TreeSeqMap", ({
  sci_TreeSeqMap: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sci_SeqMap: 1,
  sc_SeqMap: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedMapOps: 1
}));
function $as_sci_VectorMap(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.VectorMap"));
}
function $isArrayOf_sci_VectorMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_VectorMap)));
}
function $asArrayOf_sci_VectorMap(obj, depth) {
  return (($isArrayOf_sci_VectorMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.VectorMap;", depth));
}
/** @constructor */
function $c_scm_AbstractBuffer() {
}
$c_scm_AbstractBuffer.prototype = new $h_scm_AbstractSeq();
$c_scm_AbstractBuffer.prototype.constructor = $c_scm_AbstractBuffer;
/** @constructor */
function $h_scm_AbstractBuffer() {
}
$h_scm_AbstractBuffer.prototype = $c_scm_AbstractBuffer.prototype;
$c_scm_AbstractBuffer.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
/** @constructor */
function $c_scm_AbstractMap() {
}
$c_scm_AbstractMap.prototype = new $h_sc_AbstractMap();
$c_scm_AbstractMap.prototype.constructor = $c_scm_AbstractMap;
/** @constructor */
function $h_scm_AbstractMap() {
}
$h_scm_AbstractMap.prototype = $c_scm_AbstractMap.prototype;
$c_scm_AbstractMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_scm_Map$();
});
$c_scm_AbstractMap.prototype.update__O__O__V = (function(key, value) {
  $f_scm_MapOps__update__O__O__V(this, key, value);
});
$c_scm_AbstractMap.prototype.getOrElseUpdate__O__F0__O = (function(key, defaultValue) {
  return $f_scm_MapOps__getOrElseUpdate__O__F0__O(this, key, defaultValue);
});
$c_scm_AbstractMap.prototype.knownSize__I = (function() {
  return (-1);
});
$c_scm_AbstractMap.prototype.sizeHint__I__V = (function(size) {
});
$c_scm_AbstractMap.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$c_scm_AbstractMap.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_Iterable$();
});
$c_scm_AbstractMap.prototype.result__O = (function() {
  return this;
});
/** @constructor */
function $c_Lcats_data_ChainInstances$$anon$3() {
}
$c_Lcats_data_ChainInstances$$anon$3.prototype = new $h_O();
$c_Lcats_data_ChainInstances$$anon$3.prototype.constructor = $c_Lcats_data_ChainInstances$$anon$3;
/** @constructor */
function $h_Lcats_data_ChainInstances$$anon$3() {
}
$h_Lcats_data_ChainInstances$$anon$3.prototype = $c_Lcats_data_ChainInstances$$anon$3.prototype;
$c_Lcats_data_ChainInstances$$anon$3.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_Lcats_data_Chain(fa);
  return $n(fa$1).map__F1__Lcats_data_Chain(f);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.reduceLeftToOption__O__F1__F2__s_Option = (function(fa, f, g) {
  return $f_Lcats_Foldable__reduceLeftToOption__O__F1__F2__s_Option(this, fa, f, g);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.reduceLeftOption__O__F2__s_Option = (function(fa, f) {
  return $f_Lcats_Foldable__reduceLeftOption__O__F2__s_Option(this, fa, f);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.maximumOption__O__Lcats_kernel_Order__s_Option = (function(fa, A) {
  return $f_Lcats_Foldable__maximumOption__O__Lcats_kernel_Order__s_Option(this, fa, A);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.fold__O__Lcats_kernel_Monoid__O = (function(fa, A) {
  return $f_Lcats_Foldable__fold__O__Lcats_kernel_Monoid__O(this, fa, A);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.toIterable__O__sc_Iterable = (function(fa) {
  return $m_Lcats_compat_FoldableCompat$().toIterable__O__Lcats_Foldable__sc_Iterable(fa, this);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O(this, fa, z, f, G);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return this.foldMap__Lcats_data_Chain__F1__Lcats_kernel_Monoid__O($as_Lcats_data_Chain(fa), f, evidence$1);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$1) {
  return this.traverse__Lcats_data_Chain__F1__Lcats_Applicative__O($as_Lcats_data_Chain(sa), f, evidence$1);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.unit__O = (function() {
  $m_Lcats_data_Chain$();
  return new $c_Lcats_data_Chain$Singleton((void 0));
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.algebra__Lcats_kernel_Monoid = (function() {
  return new $c_Lcats_MonoidK$$anon$1(this);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.foldRight__Lcats_data_Chain__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  var this$1 = $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0((() => $ps_Lcats_data_ChainInstances__loop$6__F2__Lcats_Eval__Lcats_data_Chain__Lcats_Eval(f, lb, fa)));
  return new $c_Lcats_Eval$$anon$5(a, this$1);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.foldMap__Lcats_data_Chain__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var $x_1 = $n(B);
  var this$1 = $n($n(fa).iterator__sc_Iterator());
  return $n($x_1).combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$1, f));
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.traverse__Lcats_data_Chain__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if ($n(fa).isEmpty__Z()) {
    return $n(G).pure__O__O($m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil);
  } else if ($is_Lcats_StackSafeMonad(G)) {
    var x = $as_Lcats_StackSafeMonad(G);
    return $m_Lcats_Traverse$().traverseDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O($n(fa).iterator__sc_Iterator(), f, x);
  } else {
    var $x_1 = $m_Lcats_data_Chain$();
    var this$1 = $m_scm_ArrayBuffer$();
    var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([]));
    var as = this$1.from__sc_IterableOnce__scm_ArrayBuffer(elems);
    var this$2 = $n(as);
    var elems$1 = $n(fa).iterator__sc_Iterator();
    this$2.addAll__sc_IterableOnce__scm_ArrayBuffer(elems$1);
    return $n($x_1).traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O(new $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq(as), f, G);
  }
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.traverse___Lcats_data_Chain__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if ($is_Lcats_StackSafeMonad(G)) {
    var x = $as_Lcats_StackSafeMonad(G);
    return $m_Lcats_Traverse$().traverse_Directly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O($n(fa).iterator__sc_Iterator(), f, x);
  } else {
    $m_Lcats_Eval$();
    var a = $n(G).unit__O();
    return $n(this.foldRight__Lcats_data_Chain__Lcats_Eval__F2__Lcats_Eval(fa, new $c_Lcats_Now(a), new $c_sjsr_AnonFunction2(((a$1, acc) => {
      var acc$1 = $as_Lcats_Eval(acc);
      return $n(G).map2Eval__O__Lcats_Eval__F2__Lcats_Eval($n(f).apply__O__O(a$1), acc$1, new $c_sjsr_AnonFunction2(((_$19, _$20) => {
        $as_jl_Void(_$20);
      })));
    })))).value__O();
  }
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.tailRecM__O__F1__Lcats_data_Chain = (function(a, f) {
  var elem$4 = $as_Lcats_data_Chain($n(f).apply__O__O(a));
  var this$1 = $m_sci_Nil$();
  return $s_Lcats_data_ChainInstances__cats$data$ChainInstances$$anon$3$$_$go$6__F1__sci_List__Lcats_data_Chain__Lcats_data_Chain(f, new $c_sci_$colon$colon(elem$4, this$1), $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.map2__Lcats_data_Chain__Lcats_data_Chain__F2__Lcats_data_Chain = (function(fa, fb, f) {
  if ($n(fb).isEmpty__Z()) {
    return $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil;
  } else {
    var this$1 = $n(fa);
    var this$2 = $m_Lcats_data_Chain$();
    var result = this$2.Lcats_data_Chain$__f_nil;
    var iter = this$1.iterator__sc_Iterator();
    while ($n(iter).hasNext__Z()) {
      var this$3 = $n(result);
      var arg1 = $n(iter).next__O();
      var c = $n(fb).map__F1__Lcats_data_Chain(new $c_sjsr_AnonFunction1(((f, arg1) => ((b) => $n(f).apply__O__O__O(arg1, b)))(f, arg1)));
      result = $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this$3, c);
    }
    return result;
  }
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.map2Eval__Lcats_data_Chain__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  if ($n(fa).isEmpty__Z()) {
    $m_Lcats_Eval$();
    var a = $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil;
    return new $c_Lcats_Now(a);
  } else {
    return $n(fb).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((fb$2) => {
      var fb$1 = $as_Lcats_data_Chain(fb$2);
      return this.map2__Lcats_data_Chain__Lcats_data_Chain__F2__Lcats_data_Chain(fa, fb$1, f);
    })));
  }
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  var fa$1 = $as_Lcats_data_Chain(fa);
  return $n(fa$1).foldLeft__O__F2__O(b, f);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__Lcats_data_Chain__Lcats_Eval__F2__Lcats_Eval($as_Lcats_data_Chain(fa), lb, f);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__Lcats_data_Chain__F1__Lcats_kernel_Monoid__O($as_Lcats_data_Chain(fa), f, B);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Chain(fa);
  return $n(fa$1).map__F1__Lcats_data_Chain(f);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.toList__O__sci_List = (function(fa) {
  var fa$1 = $as_Lcats_data_Chain(fa);
  return $n(fa$1).toList__sci_List();
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.size__O__J = (function(fa) {
  var fa$1 = $as_Lcats_data_Chain(fa);
  return $n(fa$1).length__J();
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__Lcats_data_Chain__F1__Lcats_Applicative__O($as_Lcats_data_Chain(fa), f, evidence$1);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return this.traverse___Lcats_data_Chain__F1__Lcats_Applicative__O($as_Lcats_data_Chain(fa), f, G);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.empty__O = (function() {
  return $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil;
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.combineK__O__O__O = (function(x, y) {
  var c = $as_Lcats_data_Chain(x);
  var c2 = $as_Lcats_data_Chain(y);
  return $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(c, c2);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.pure__O__O = (function(x) {
  $m_Lcats_data_Chain$();
  return new $c_Lcats_data_Chain$Singleton(x);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Chain(fa);
  return $n(fa$1).flatMap__F1__Lcats_data_Chain(f);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__Lcats_data_Chain(a, f);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__Lcats_data_Chain__Lcats_data_Chain__F2__Lcats_data_Chain($as_Lcats_data_Chain(fa), $as_Lcats_data_Chain(fb), f);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__Lcats_data_Chain__Lcats_Eval__F2__Lcats_Eval($as_Lcats_data_Chain(fa), fb, f);
});
var $d_Lcats_data_ChainInstances$$anon$3 = new $TypeData().initClass($c_Lcats_data_ChainInstances$$anon$3, "cats.data.ChainInstances$$anon$3", ({
  Lcats_data_ChainInstances$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_ResourceHOInstances2$$anon$13(F0$13) {
  this.Lcats_effect_kernel_ResourceHOInstances2$$anon$13__f_F0$5 = null;
  this.Lcats_effect_kernel_ResourceHOInstances2$$anon$13__f_F0$5 = F0$13;
}
$c_Lcats_effect_kernel_ResourceHOInstances2$$anon$13.prototype = new $h_Lcats_effect_kernel_ResourceConcurrent();
$c_Lcats_effect_kernel_ResourceHOInstances2$$anon$13.prototype.constructor = $c_Lcats_effect_kernel_ResourceHOInstances2$$anon$13;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceHOInstances2$$anon$13() {
}
$h_Lcats_effect_kernel_ResourceHOInstances2$$anon$13.prototype = $c_Lcats_effect_kernel_ResourceHOInstances2$$anon$13.prototype;
$c_Lcats_effect_kernel_ResourceHOInstances2$$anon$13.prototype.F__Lcats_effect_kernel_GenConcurrent = (function() {
  return this.Lcats_effect_kernel_ResourceHOInstances2$$anon$13__f_F0$5;
});
$c_Lcats_effect_kernel_ResourceHOInstances2$$anon$13.prototype.F__Lcats_effect_kernel_MonadCancel = (function() {
  return this.Lcats_effect_kernel_ResourceHOInstances2$$anon$13__f_F0$5;
});
$c_Lcats_effect_kernel_ResourceHOInstances2$$anon$13.prototype.F__Lcats_MonadError = (function() {
  return this.Lcats_effect_kernel_ResourceHOInstances2$$anon$13__f_F0$5;
});
var $d_Lcats_effect_kernel_ResourceHOInstances2$$anon$13 = new $TypeData().initClass($c_Lcats_effect_kernel_ResourceHOInstances2$$anon$13, "cats.effect.kernel.ResourceHOInstances2$$anon$13", ({
  Lcats_effect_kernel_ResourceHOInstances2$$anon$13: 1,
  Lcats_effect_kernel_ResourceConcurrent: 1,
  Lcats_effect_kernel_ResourceMonadCancel: 1,
  Lcats_effect_kernel_ResourceMonadError: 1,
  Lcats_effect_kernel_ResourceMonad: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_StackSafeMonad: 1,
  Lcats_ApplicativeError: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lcats_effect_kernel_Unique: 1,
  Lcats_effect_kernel_GenSpawn: 1,
  Lcats_effect_kernel_GenConcurrent: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Sync$$anon$6(F0$13) {
  this.Lcats_effect_kernel_Sync$$anon$6__f_F0$6 = null;
  this.Lcats_effect_kernel_Sync$$anon$6__f_cats$effect$kernel$Sync$$Delay = null;
  this.Lcats_effect_kernel_Sync$$anon$6__f_cats$effect$kernel$Sync$$Blocking = null;
  this.Lcats_effect_kernel_Sync$$anon$6__f_F0$6 = F0$13;
  $f_Lcats_effect_kernel_Sync__$init$__V(this);
}
$c_Lcats_effect_kernel_Sync$$anon$6.prototype = new $h_O();
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.constructor = $c_Lcats_effect_kernel_Sync$$anon$6;
/** @constructor */
function $h_Lcats_effect_kernel_Sync$$anon$6() {
}
$h_Lcats_effect_kernel_Sync$$anon$6.prototype = $c_Lcats_effect_kernel_Sync$$anon$6.prototype;
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.unit__O = (function() {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_Sync$$anon$6__f_F0$6;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  var this$3 = $m_Lcats_data_Kleisli$();
  var F = this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$3, (void 0), F);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.guarantee__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O(this, fa, fin);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Delay_$eq__Lcats_effect_kernel_Sync$Type$Delay$__V = (function(x$0) {
  this.Lcats_effect_kernel_Sync$$anon$6__f_cats$effect$kernel$Sync$$Delay = x$0;
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Blocking_$eq__Lcats_effect_kernel_Sync$Type$Blocking$__V = (function(x$0) {
  this.Lcats_effect_kernel_Sync$$anon$6__f_cats$effect$kernel$Sync$$Blocking = x$0;
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleOnce_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleOnce$__V = (function(x$0) {
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleMany_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleMany$__V = (function(x$0) {
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.unique__O = (function() {
  return $f_Lcats_effect_kernel_Sync__unique__O(this);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.delay__F0__O = (function(thunk) {
  var hint = this.Lcats_effect_kernel_Sync$$anon$6__f_cats$effect$kernel$Sync$$Delay;
  return $f_Lcats_effect_kernel_Sync$KleisliSync__suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_data_Kleisli(this, hint, thunk);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.blocking__F0__O = (function(thunk) {
  var hint = this.Lcats_effect_kernel_Sync$$anon$6__f_cats$effect$kernel$Sync$$Blocking;
  return $f_Lcats_effect_kernel_Sync$KleisliSync__suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_data_Kleisli(this, hint, thunk);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.C__Lcats_effect_kernel_Clock = (function() {
  return this.Lcats_effect_kernel_Sync$$anon$6__f_F0$6;
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.F__Lcats_effect_kernel_Sync = (function() {
  return this.Lcats_effect_kernel_Sync$$anon$6__f_F0$6;
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.F__Lcats_effect_kernel_MonadCancel = (function() {
  return this.Lcats_effect_kernel_Sync$$anon$6__f_F0$6;
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.suspend__Lcats_effect_kernel_Sync$Type__F0__O = (function(hint, thunk) {
  return $f_Lcats_effect_kernel_Sync$KleisliSync__suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_data_Kleisli(this, hint, thunk);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.realTime__O = (function() {
  return $f_Lcats_effect_kernel_Clock$KleisliClock__realTime__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.uncancelable__F1__O = (function(body) {
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__uncancelable__F1__Lcats_data_Kleisli(this, body);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.canceled__O = (function() {
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__canceled__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.onCancel__O__O__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fin$1 = $as_Lcats_data_Kleisli(fin);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__onCancel__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fin$1);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.forceR__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__forceR__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__guaranteeCase__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this, fa$1, fin);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.pure__O__O = (function(x) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_Sync$$anon$6__f_F0$6;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  var this$3 = $m_Lcats_data_Kleisli$();
  var F = this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$3, x, F);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.raiseError__O__O = (function(e) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_Sync$$anon$6__f_F0$6;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliApplicativeError__raiseError__O__Lcats_data_Kleisli(this$2, e);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_Sync$$anon$6__f_F0$6;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliApplicativeError__handleErrorWith__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this$2, fa$1, f);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_Sync$$anon$6__f_F0$6;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $n(fa$1).flatMap__F1__Lcats_FlatMap__Lcats_data_Kleisli(f, this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.tailRecM__O__F1__O = (function(a, f) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_Sync$$anon$6__f_F0$6;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliFlatMap__tailRecM__O__F1__Lcats_data_Kleisli(this$2, a, f);
});
var $d_Lcats_effect_kernel_Sync$$anon$6 = new $TypeData().initClass($c_Lcats_effect_kernel_Sync$$anon$6, "cats.effect.kernel.Sync$$anon$6", ({
  Lcats_effect_kernel_Sync$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lcats_effect_kernel_ClockPlatform: 1,
  Lcats_effect_kernel_Clock: 1,
  Lcats_effect_kernel_Unique: 1,
  Lcats_Defer: 1,
  Lcats_effect_kernel_Sync: 1,
  Lcats_effect_kernel_MonadCancel$KleisliMonadCancel: 1,
  Lcats_effect_kernel_Clock$KleisliClock: 1,
  Lcats_effect_kernel_Sync$KleisliSync: 1
}));
/** @constructor */
function $c_Lcats_instances_LazyListInstances$$anon$1() {
}
$c_Lcats_instances_LazyListInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.constructor = $c_Lcats_instances_LazyListInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_LazyListInstances$$anon$1() {
}
$h_Lcats_instances_LazyListInstances$$anon$1.prototype = $c_Lcats_instances_LazyListInstances$$anon$1.prototype;
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_sci_LazyList(fa);
  return $n(fa$1).map__F1__sci_LazyList(f);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.size__O__J = (function(fa) {
  return $f_Lcats_UnorderedFoldable__size__O__J(this, fa);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.reduceLeftToOption__O__F1__F2__s_Option = (function(fa, f, g) {
  return $f_Lcats_Foldable__reduceLeftToOption__O__F1__F2__s_Option(this, fa, f, g);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.maximumOption__O__Lcats_kernel_Order__s_Option = (function(fa, A) {
  return $f_Lcats_Foldable__maximumOption__O__Lcats_kernel_Order__s_Option(this, fa, A);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverse___O__F1__Lcats_Applicative__O(this, fa, f, G);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return this.foldMap__sci_LazyList__F1__Lcats_kernel_Monoid__O($as_sci_LazyList(fa), f, evidence$1);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$1) {
  return this.traverse__sci_LazyList__F1__Lcats_Applicative__O($as_sci_LazyList(sa), f, evidence$1);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.unit__O = (function() {
  return this.pure__O__sci_LazyList((void 0));
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.combineK__sci_LazyList__sci_LazyList__sci_LazyList = (function(x, y) {
  return $n(x).lazyAppendedAll__F0__sci_LazyList(new $c_sjsr_AnonFunction0((() => y)));
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.pure__O__sci_LazyList = (function(x) {
  var this$1 = $m_sci_LazyList$();
  var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([x]));
  return this$1.from__sc_IterableOnce__sci_LazyList(elems);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map2__sci_LazyList__sci_LazyList__F2__sci_LazyList = (function(fa, fb, f) {
  return ($n(fb).isEmpty__Z() ? $m_sci_LazyList$().sci_LazyList$__f__empty : $n(fa).flatMap__F1__sci_LazyList(new $c_sjsr_AnonFunction1(((a) => $n(fb).map__F1__sci_LazyList(new $c_sjsr_AnonFunction1(((b) => $n(f).apply__O__O__O(a, b))))))));
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map2Eval__sci_LazyList__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  if ($n(fa).isEmpty__Z()) {
    $m_Lcats_Eval$();
    var a = $m_sci_LazyList$().sci_LazyList$__f__empty;
    return new $c_Lcats_Now(a);
  } else {
    return $n(fb).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((fb$2) => {
      var fb$1 = $as_sci_LazyList(fb$2);
      return this.map2__sci_LazyList__sci_LazyList__F2__sci_LazyList(fa, fb$1, f);
    })));
  }
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldRight__sci_LazyList__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return new $c_Lcats_Now(fa).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((s) => {
    var s$1 = $as_sci_LazyList(s);
    if ($n(s$1).isEmpty__Z()) {
      return lb;
    } else {
      var this$3 = $n(s$1);
      var $x_1 = $n(this$3.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).head__O();
      var this$5 = $m_Lcats_Eval$();
      var a = new $c_sjsr_AnonFunction0((() => {
        var this$4 = $n(s$1);
        return this.foldRight__sci_LazyList__Lcats_Eval__F2__Lcats_Eval($n(this$4.scala$collection$immutable$LazyList$$state__sci_LazyList$State()).tail__sci_LazyList(), lb, f);
      }));
      return $as_Lcats_Eval($n(f).apply__O__O__O($x_1, new $c_Lcats_Eval$$anon$5(a, this$5)));
    }
  })));
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldMap__sci_LazyList__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var $x_1 = $n(B);
  var this$1 = $n($n(fa).iterator__sc_Iterator());
  return $n($x_1).combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$1, f));
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.traverse__sci_LazyList__F1__Lcats_Applicative__O = (function(fa, f, G) {
  var a = new $c_sjsr_AnonFunction0((() => $n(G).pure__O__O($m_sci_LazyList$().sci_LazyList$__f__empty)));
  return $n(this.foldRight__sci_LazyList__Lcats_Eval__F2__Lcats_Eval(fa, new $c_Lcats_Always(a), new $c_sjsr_AnonFunction2(((a$1, lgsb) => {
    var lgsb$1 = $as_Lcats_Eval(lgsb);
    return $n(G).map2Eval__O__Lcats_Eval__F2__Lcats_Eval($n(f).apply__O__O(a$1), lgsb$1, new $c_sjsr_AnonFunction2(((_$3, _$4) => {
      var _$4$1 = $as_sci_LazyList(_$4);
      $m_sci_LazyList$();
      var l = new $c_sjsr_AnonFunction0((() => _$4$1));
      return $m_sci_LazyList$Deferrer$().$hash$colon$colon$extension__F0__F0__sci_LazyList(l, new $c_sjsr_AnonFunction0((() => _$3)));
    })));
  })))).value__O();
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.tailRecM__O__F1__sci_LazyList = (function(a, fn) {
  var xs = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_s_util_Left.getArrayOf().constr)([new $c_s_util_Left(a)]));
  var init = $n(xs).iterator__sc_Iterator();
  var f = new $c_sjsr_AnonFunction1(((it) => {
    var it$1 = $as_sc_Iterator(it);
    if ((!$n(it$1).hasNext__Z())) {
      return $m_s_None$();
    } else {
      var x1 = $as_s_util_Either($n(it$1).next__O());
      if ((x1 instanceof $c_s_util_Left)) {
        var a$1 = $n($as_s_util_Left(x1)).s_util_Left__f_value;
        var _1 = $m_s_None$();
        var this$3 = $n($n($as_sci_LazyList($n(fn).apply__O__O(a$1))).iterator__sc_Iterator());
        var xs$1 = new $c_sjsr_AnonFunction0((() => it$1));
        var _2 = this$3.concat__F0__sc_Iterator(xs$1);
        var value = new $c_T2(_1, _2);
        return new $c_s_Some(value);
      }
      if ((x1 instanceof $c_s_util_Right)) {
        var b = $n($as_s_util_Right(x1)).s_util_Right__f_value;
        var _1$1 = new $c_s_Some(b);
        var value$1 = new $c_T2(_1$1, it$1);
        return new $c_s_Some(value$1);
      }
      throw new $c_s_MatchError(x1);
    }
  }));
  var kernel = new $c_sc_Iterator$UnfoldIterator(init, f);
  var $x_1 = $m_sci_LazyList$();
  var pf = new $c_Lcats_instances_LazyListInstances$$anon$2();
  return $n($x_1).from__sc_IterableOnce__sci_LazyList(new $c_sc_Iterator$$anon$7(kernel, pf));
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldM__sci_LazyList__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $n(G).tailRecM__O__F1__O(new $c_T2(fa, z), new $c_sjsr_AnonFunction1(((in$1) => {
    var in$2 = $as_T2(in$1);
    return $ps_Lcats_instances_LazyListInstances__step$1__Lcats_Monad__F2__T2__O(G, f, in$2);
  })));
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.algebra__Lcats_kernel_Monoid = (function() {
  return $m_Lcats_kernel_instances_LazyListMonoid$().Lcats_kernel_instances_LazyListMonoid$__f_singleton;
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.empty__O = (function() {
  return $m_sci_LazyList$().sci_LazyList$__f__empty;
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  return this.combineK__sci_LazyList__sci_LazyList__sci_LazyList($as_sci_LazyList(x), $as_sci_LazyList(y));
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return this.pure__O__sci_LazyList(x);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_LazyList(fa);
  return $n(fa$1).map__F1__sci_LazyList(f);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_LazyList(fa);
  return $n(fa$1).flatMap__F1__sci_LazyList(f);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_LazyList__sci_LazyList__F2__sci_LazyList($as_sci_LazyList(fa), $as_sci_LazyList(fb), f);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_LazyList__Lcats_Eval__F2__Lcats_Eval($as_sci_LazyList(fa), fb, f);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  var fa$1 = $as_sci_LazyList(fa);
  return $n(fa$1).foldLeft__O__F2__O(b, f);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__sci_LazyList__Lcats_Eval__F2__Lcats_Eval($as_sci_LazyList(fa), lb, f);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__sci_LazyList__F1__Lcats_kernel_Monoid__O($as_sci_LazyList(fa), f, B);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_LazyList__F1__Lcats_Applicative__O($as_sci_LazyList(fa), f, evidence$1);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_LazyList(a, f);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return this.foldM__sci_LazyList__O__F2__Lcats_Monad__O($as_sci_LazyList(fa), z, f, G);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.fold__O__Lcats_kernel_Monoid__O = (function(fa, A) {
  var fa$1 = $as_sci_LazyList(fa);
  return $n(A).combineAll__sc_IterableOnce__O(fa$1);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.toList__O__sci_List = (function(fa) {
  var fa$1 = $as_sci_LazyList(fa);
  var this$1 = $n(fa$1);
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$1);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.toIterable__O__sc_Iterable = (function(fa) {
  var fa$1 = $as_sci_LazyList(fa);
  return fa$1;
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.reduceLeftOption__O__F2__s_Option = (function(fa, f) {
  var fa$1 = $as_sci_LazyList(fa);
  var this$1 = $n(fa$1);
  return $f_sc_IterableOnceOps__reduceLeftOption__F2__s_Option(this$1, f);
});
var $d_Lcats_instances_LazyListInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_LazyListInstances$$anon$1, "cats.instances.LazyListInstances$$anon$1", ({
  Lcats_instances_LazyListInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
}));
/** @constructor */
function $c_Lcats_instances_ListInstances$$anon$1() {
  this.Lcats_instances_ListInstances$$anon$1__f_evalNil = null;
  this.Lcats_instances_ListInstances$$anon$1__f__unit = null;
  $m_Lcats_Eval$();
  var a = $m_sci_Nil$();
  this.Lcats_instances_ListInstances$$anon$1__f_evalNil = new $c_Lcats_Now(a);
  var this$3 = $m_sci_Nil$();
  this.Lcats_instances_ListInstances$$anon$1__f__unit = new $c_sci_$colon$colon((void 0), this$3);
}
$c_Lcats_instances_ListInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_ListInstances$$anon$1.prototype.constructor = $c_Lcats_instances_ListInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_ListInstances$$anon$1() {
}
$h_Lcats_instances_ListInstances$$anon$1.prototype = $c_Lcats_instances_ListInstances$$anon$1.prototype;
$c_Lcats_instances_ListInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_sci_List(fa);
  return $n(fa$1).map__F1__sci_List(f);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.size__O__J = (function(fa) {
  return $f_Lcats_UnorderedFoldable__size__O__J(this, fa);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.reduceLeftToOption__O__F1__F2__s_Option = (function(fa, f, g) {
  return $f_Lcats_Foldable__reduceLeftToOption__O__F1__F2__s_Option(this, fa, f, g);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.maximumOption__O__Lcats_kernel_Order__s_Option = (function(fa, A) {
  return $f_Lcats_Foldable__maximumOption__O__Lcats_kernel_Order__s_Option(this, fa, A);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return this.foldMap__sci_List__F1__Lcats_kernel_Monoid__O($as_sci_List(fa), f, evidence$1);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$1) {
  return this.traverse__sci_List__F1__Lcats_Applicative__O($as_sci_List(sa), f, evidence$1);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map2__sci_List__sci_List__F2__sci_List = (function(fa, fb, f) {
  if ($n(fb).isEmpty__Z()) {
    return $m_sci_Nil$();
  } else {
    var this$1 = $n(fa);
    var rest = this$1;
    var h = null;
    var t = null;
    while ((rest !== $m_sci_Nil$())) {
      var arg1 = $n(rest).head__O();
      var this$2 = $n(fb);
      var f$1 = ((f, arg1) => ((b) => $n(f).apply__O__O__O(arg1, b)))(f, arg1);
      if ((this$2 === $m_sci_Nil$())) {
        var $x_1 = $m_sci_Nil$();
      } else {
        var arg1$1 = this$2.head__O();
        var h$1 = new $c_sci_$colon$colon(f$1(arg1$1), $m_sci_Nil$());
        var t$1 = h$1;
        var rest$1 = $as_sci_List(this$2.tail__O());
        while ((rest$1 !== $m_sci_Nil$())) {
          var arg1$2 = $n(rest$1).head__O();
          var nx = new $c_sci_$colon$colon(f$1(arg1$2), $m_sci_Nil$());
          $n(t$1).sci_$colon$colon__f_next = nx;
          t$1 = nx;
          rest$1 = $as_sci_List($n(rest$1).tail__O());
        }
        var $x_1 = h$1;
      }
      var it = $n($x_1).iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        var nx$1 = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
        if ((t === null)) {
          h = nx$1;
        } else {
          $n(t).sci_$colon$colon__f_next = nx$1;
        }
        t = nx$1;
      }
      rest = $as_sci_List($n(rest).tail__O());
    }
    return ((h === null) ? $m_sci_Nil$() : h);
  }
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map2Eval__sci_List__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return ($n(fa).isEmpty__Z() ? this.Lcats_instances_ListInstances$$anon$1__f_evalNil : $n(fb).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((fb$2) => {
    var fb$1 = $as_sci_List(fb$2);
    return this.map2__sci_List__sci_List__F2__sci_List(fa, fb$1, f);
  }))));
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.tailRecM__O__F1__sci_List = (function(a, f) {
  var buf = new $c_scm_ListBuffer();
  var elem$2 = $as_sci_List($n(f).apply__O__O(a));
  var this$2 = $m_sci_Nil$();
  $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$go$1__scm_Builder__F1__sci_List__V(buf, f, new $c_sci_$colon$colon(elem$2, this$2));
  return buf.toList__sci_List();
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldRight__sci_List__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  var this$1 = $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0((() => $ps_Lcats_instances_ListInstances__loop$2__Lcats_Eval__F2__sci_List__Lcats_Eval(lb, f, fa)));
  return new $c_Lcats_Eval$$anon$5(a, this$1);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldMap__sci_List__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var $x_1 = $n(B);
  var this$1 = $n($n(fa).iterator__sc_Iterator());
  return $n($x_1).combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$1, f));
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.traverse__sci_List__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if ($n(fa).isEmpty__Z()) {
    return $n(G).pure__O__O($m_sci_Nil$());
  } else if ($is_Lcats_StackSafeMonad(G)) {
    var x = $as_Lcats_StackSafeMonad(G);
    return $n(x).map__O__F1__O($m_Lcats_Traverse$().traverseDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O(fa, f, x), new $c_sjsr_AnonFunction1(((_$3) => {
      var _$3$1 = $as_Lcats_data_Chain(_$3);
      return $n(_$3$1).toList__sci_List();
    })));
  } else {
    var $x_2 = $n(G);
    var $x_1 = $m_Lcats_data_Chain$();
    var this$1 = $m_scm_ArrayBuffer$();
    var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([]));
    var as = this$1.from__sc_IterableOnce__scm_ArrayBuffer(elems);
    var this$2 = $n(as);
    this$2.addAll__sc_IterableOnce__scm_ArrayBuffer(fa);
    return $n($x_2).map__O__F1__O($n($x_1).traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O(new $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq(as), f, G), new $c_sjsr_AnonFunction1(((_$4) => {
      var _$4$1 = $as_Lcats_data_Chain(_$4);
      return $n(_$4$1).toList__sci_List();
    })));
  }
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.traverse___sci_List__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if ($is_Lcats_StackSafeMonad(G)) {
    var x = $as_Lcats_StackSafeMonad(G);
    return $m_Lcats_Traverse$().traverse_Directly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O(fa, f, x);
  } else {
    var len = $n(fa).length__I();
    return ((len === 0) ? $n(G).unit__O() : $n($s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__F1__I__sci_List__Lcats_Eval(G, f, len, fa)).value__O());
  }
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldM__sci_List__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $n(G).tailRecM__O__F1__O(new $c_T2(fa, z), new $c_sjsr_AnonFunction1(((in$1) => {
    var in$2 = $as_T2(in$1);
    return $ps_Lcats_instances_ListInstances__step$1__Lcats_Monad__F2__T2__O(G, f, in$2);
  })));
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.algebra__Lcats_kernel_Monoid = (function() {
  return $m_Lcats_kernel_instances_ListMonoid$().Lcats_kernel_instances_ListMonoid$__f_singleton;
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.void__sci_List__sci_List = (function(fa) {
  return ($n(fa).isEmpty__Z() ? $m_sci_Nil$() : $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$build$1__sci_List__sci_List__sci_List($as_sci_List($n(fa).tail__O()), this.Lcats_instances_ListInstances$$anon$1__f__unit));
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.empty__O = (function() {
  return $m_sci_Nil$();
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  var x$1 = $as_sci_List(x);
  var y$1 = $as_sci_List(y);
  return $n(y$1).$colon$colon$colon__sci_List__sci_List(x$1);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.pure__O__O = (function(x) {
  var this$1 = $m_sci_Nil$();
  return new $c_sci_$colon$colon(x, this$1);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_List(fa);
  return $n(fa$1).map__F1__sci_List(f);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_List(fa);
  return $n(fa$1).flatMap__F1__sci_List(f);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_List__sci_List__F2__sci_List($as_sci_List(fa), $as_sci_List(fb), f);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_List__Lcats_Eval__F2__Lcats_Eval($as_sci_List(fa), fb, f);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_List(a, f);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  var fa$1 = $as_sci_List(fa);
  var this$1 = $n(fa$1);
  return $f_sc_LinearSeqOps__foldLeft__O__F2__O(this$1, b, f);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__sci_List__Lcats_Eval__F2__Lcats_Eval($as_sci_List(fa), lb, f);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__sci_List__F1__Lcats_kernel_Monoid__O($as_sci_List(fa), f, B);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_List__F1__Lcats_Applicative__O($as_sci_List(fa), f, evidence$1);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return this.traverse___sci_List__F1__Lcats_Applicative__O($as_sci_List(fa), f, G);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return this.foldM__sci_List__O__F2__Lcats_Monad__O($as_sci_List(fa), z, f, G);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.fold__O__Lcats_kernel_Monoid__O = (function(fa, A) {
  var fa$1 = $as_sci_List(fa);
  return $n(A).combineAll__sc_IterableOnce__O(fa$1);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.toList__O__sci_List = (function(fa) {
  var fa$1 = $as_sci_List(fa);
  return fa$1;
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.toIterable__O__sc_Iterable = (function(fa) {
  var fa$1 = $as_sci_List(fa);
  return fa$1;
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.reduceLeftOption__O__F2__s_Option = (function(fa, f) {
  var fa$1 = $as_sci_List(fa);
  var this$1 = $n(fa$1);
  return $f_sc_IterableOnceOps__reduceLeftOption__F2__s_Option(this$1, f);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.unit__O = (function() {
  return this.Lcats_instances_ListInstances$$anon$1__f__unit;
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return this.void__sci_List__sci_List($as_sci_List(fa));
});
var $d_Lcats_instances_ListInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_ListInstances$$anon$1, "cats.instances.ListInstances$$anon$1", ({
  Lcats_instances_ListInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
}));
/** @constructor */
function $c_Lcats_instances_SeqInstances$$anon$1() {
  this.Lcats_instances_SeqInstances$$anon$1__f_evalEmpty = null;
  $m_Lcats_Eval$();
  var a = $m_sci_Seq$().empty__sc_SeqOps();
  this.Lcats_instances_SeqInstances$$anon$1__f_evalEmpty = new $c_Lcats_Now(a);
}
$c_Lcats_instances_SeqInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_SeqInstances$$anon$1.prototype.constructor = $c_Lcats_instances_SeqInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_SeqInstances$$anon$1() {
}
$h_Lcats_instances_SeqInstances$$anon$1.prototype = $c_Lcats_instances_SeqInstances$$anon$1.prototype;
$c_Lcats_instances_SeqInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_sci_Seq(fa);
  return $as_sci_Seq($n(fa$1).map__F1__O(f));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.reduceLeftToOption__O__F1__F2__s_Option = (function(fa, f, g) {
  return $f_Lcats_Foldable__reduceLeftToOption__O__F1__F2__s_Option(this, fa, f, g);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.maximumOption__O__Lcats_kernel_Order__s_Option = (function(fa, A) {
  return $f_Lcats_Foldable__maximumOption__O__Lcats_kernel_Order__s_Option(this, fa, A);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return this.foldMap__sci_Seq__F1__Lcats_kernel_Monoid__O($as_sci_Seq(fa), f, evidence$1);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$1) {
  return this.traverse__sci_Seq__F1__Lcats_Applicative__O($as_sci_Seq(sa), f, evidence$1);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.unit__O = (function() {
  return this.pure__O__sci_Seq((void 0));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.pure__O__sci_Seq = (function(x) {
  return $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([x]))));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.map2__sci_Seq__sci_Seq__F2__sci_Seq = (function(fa, fb, f) {
  return ($n(fb).isEmpty__Z() ? $as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps()) : $as_sci_Seq($n(fa).flatMap__F1__O(new $c_sjsr_AnonFunction1(((a) => $as_sc_IterableOnce($n(fb).map__F1__O(new $c_sjsr_AnonFunction1(((b) => $n(f).apply__O__O__O(a, b))))))))));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.map2Eval__sci_Seq__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return ($n(fa).isEmpty__Z() ? this.Lcats_instances_SeqInstances$$anon$1__f_evalEmpty : $n(fb).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((fb$2) => {
    var fb$1 = $as_sci_Seq(fb$2);
    return this.map2__sci_Seq__sci_Seq__F2__sci_Seq(fa, fb$1, f);
  }))));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.foldMap__sci_Seq__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var $x_1 = $n(B);
  var this$1 = $n($n(fa).iterator__sc_Iterator());
  return $n($x_1).combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$1, f));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.tailRecM__O__F1__sci_Seq = (function(a, fn) {
  var buf = $m_sci_Seq$().newBuilder__scm_Builder();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_sc_Iterator.getArrayOf().constr)([$n($as_sc_IterableOnce($n(fn).apply__O__O(a))).iterator__sc_Iterator()]));
  var elem = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var elem$1 = null;
  elem$1 = elem;
  while (true) {
    matchResult3: {
      var x11 = $as_sci_List(elem$1);
      var x = $m_sci_Nil$();
      if (x.equals__O__Z(x11)) {
        break matchResult3;
      }
      if ((x11 instanceof $c_sci_$colon$colon)) {
        var x15 = $as_sci_$colon$colon(x11);
        var x16 = $as_sc_Iterator($n(x15).sci_$colon$colon__f_head);
        var x17 = $n(x15).sci_$colon$colon__f_next;
        var this$3 = $n(x16);
        if ((!this$3.hasNext__Z())) {
          var ev$1 = x17;
          elem$1 = ev$1;
          ev$1 = null;
          continue;
        }
        var x6 = $as_s_util_Either($n(x16).next__O());
        if ((x6 instanceof $c_s_util_Right)) {
          var b = $n($as_s_util_Right(x6)).s_util_Right__f_value;
          var this$4 = $n(buf);
          this$4.addOne__O__scm_Growable(b);
          continue;
        }
        if ((x6 instanceof $c_s_util_Left)) {
          var a$1 = $n($as_s_util_Left(x6)).s_util_Left__f_value;
          var elem$1$1 = $n($as_sc_IterableOnce($n(fn).apply__O__O(a$1))).iterator__sc_Iterator();
          var this$5 = $n(x17);
          var this$6 = new $c_sci_$colon$colon(x16, this$5);
          var ev$2 = new $c_sci_$colon$colon(elem$1$1, this$6);
          elem$1 = ev$2;
          ev$2 = null;
          continue;
        }
        throw new $c_s_MatchError(x6);
        break matchResult3;
      }
      throw new $c_s_MatchError(x11);
    }
    break;
  }
  return $as_sci_Seq($n(buf).result__O());
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.traverse__sci_Seq__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if ($is_Lcats_StackSafeMonad(G)) {
    var x = $as_Lcats_StackSafeMonad(G);
    return $n(x).map__O__F1__O($m_Lcats_Traverse$().traverseDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O(fa, f, x), new $c_sjsr_AnonFunction1(((_$3) => {
      var _$3$1 = $as_Lcats_data_Chain(_$3);
      return $n(_$3$1).toList__sci_List();
    })));
  } else {
    return $n(G).map__O__F1__O($m_Lcats_data_Chain$().traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O($n(fa).toIndexedSeq__sci_IndexedSeq(), f, G), new $c_sjsr_AnonFunction1(((_$4) => {
      var _$4$1 = $as_Lcats_data_Chain(_$4);
      return $n(_$4$1).toList__sci_List();
    })));
  }
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.traverse___sci_Seq__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if ($is_Lcats_StackSafeMonad(G)) {
    var x = $as_Lcats_StackSafeMonad(G);
    return $m_Lcats_Traverse$().traverse_Directly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O(fa, f, x);
  } else {
    $m_Lcats_Eval$();
    var a = $n(G).unit__O();
    var lb = new $c_Lcats_Now(a);
    var f$1 = new $c_sjsr_AnonFunction2(((a$1, acc) => {
      var acc$1 = $as_Lcats_Eval(acc);
      return $n(G).map2Eval__O__Lcats_Eval__F2__Lcats_Eval($n(f).apply__O__O(a$1), acc$1, new $c_sjsr_AnonFunction2(((_$6, _$7) => {
        $as_jl_Void(_$7);
      })));
    }));
    return $n($m_Lcats_Foldable$().iterateRight__sc_Iterable__Lcats_Eval__F2__Lcats_Eval(fa, lb, f$1)).value__O();
  }
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.foldM__sci_Seq__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  var length = $n(fa).length__I();
  return $n(G).tailRecM__O__F1__O(new $c_T2(z, 0), new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var b = $n(x$1$1)._1__O();
      var i = $uI($n(x$1$1)._2__O());
      return ((i < length) ? $n(G).map__O__F1__O($n(f).apply__O__O__O(b, $n(fa).apply__I__O(i)), new $c_sjsr_AnonFunction1(((b$2) => {
        var _2 = ((1 + i) | 0);
        var value = new $c_T2(b$2, _2);
        return new $c_s_util_Left(value);
      }))) : $n(G).pure__O__O(new $c_s_util_Right(b)));
    }
    throw new $c_s_MatchError(x$1$1);
  })));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.algebra__Lcats_kernel_Monoid = (function() {
  var this$1 = $m_Lcats_kernel_instances_SeqMonoid$();
  return $as_Lcats_kernel_instances_SeqMonoid(this$1.Lcats_kernel_instances_SeqMonoid$__f_singleton);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.empty__O = (function() {
  return $as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps());
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Seq(x);
  var y$1 = $as_sci_Seq(y);
  var this$1 = $n(x$1);
  return $as_sci_Seq(this$1.appendedAll__sc_IterableOnce__O(y$1));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return this.pure__O__sci_Seq(x);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Seq(fa);
  return $as_sci_Seq($n(fa$1).map__F1__O(f));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Seq(fa);
  return $as_sci_Seq($n(fa$1).flatMap__F1__O(f));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_Seq__sci_Seq__F2__sci_Seq($as_sci_Seq(fa), $as_sci_Seq(fb), f);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_Seq__Lcats_Eval__F2__Lcats_Eval($as_sci_Seq(fa), fb, f);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  var fa$1 = $as_sci_Seq(fa);
  return $n(fa$1).foldLeft__O__F2__O(b, f);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  var fa$1 = $as_sci_Seq(fa);
  return $m_Lcats_Foldable$().iterateRight__sc_Iterable__Lcats_Eval__F2__Lcats_Eval(fa$1, lb, f);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__sci_Seq__F1__Lcats_kernel_Monoid__O($as_sci_Seq(fa), f, B);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_Seq(a, f);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.size__O__J = (function(fa) {
  var fa$1 = $as_sci_Seq(fa);
  var this$1 = $n(fa$1);
  var value = this$1.length__I();
  var hi = (value >> 31);
  return new $c_RTLong(value, hi);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_Seq__F1__Lcats_Applicative__O($as_sci_Seq(fa), f, evidence$1);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return this.traverse___sci_Seq__F1__Lcats_Applicative__O($as_sci_Seq(fa), f, G);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return this.foldM__sci_Seq__O__F2__Lcats_Monad__O($as_sci_Seq(fa), z, f, G);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.fold__O__Lcats_kernel_Monoid__O = (function(fa, A) {
  var fa$1 = $as_sci_Seq(fa);
  return $n(A).combineAll__sc_IterableOnce__O(fa$1);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.toList__O__sci_List = (function(fa) {
  var fa$1 = $as_sci_Seq(fa);
  return $n(fa$1).toList__sci_List();
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.toIterable__O__sc_Iterable = (function(fa) {
  var fa$1 = $as_sci_Seq(fa);
  return fa$1;
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.reduceLeftOption__O__F2__s_Option = (function(fa, f) {
  var fa$1 = $as_sci_Seq(fa);
  var this$1 = $n(fa$1);
  return $f_sc_IterableOnceOps__reduceLeftOption__F2__s_Option(this$1, f);
});
var $d_Lcats_instances_SeqInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_SeqInstances$$anon$1, "cats.instances.SeqInstances$$anon$1", ({
  Lcats_instances_SeqInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
}));
/** @constructor */
function $c_Lcats_instances_StreamInstances$$anon$1() {
}
$c_Lcats_instances_StreamInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_StreamInstances$$anon$1.prototype.constructor = $c_Lcats_instances_StreamInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_StreamInstances$$anon$1() {
}
$h_Lcats_instances_StreamInstances$$anon$1.prototype = $c_Lcats_instances_StreamInstances$$anon$1.prototype;
$c_Lcats_instances_StreamInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_sci_Stream(fa);
  return $n(fa$1).map__F1__sci_Stream(f);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.size__O__J = (function(fa) {
  return $f_Lcats_UnorderedFoldable__size__O__J(this, fa);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.reduceLeftToOption__O__F1__F2__s_Option = (function(fa, f, g) {
  return $f_Lcats_Foldable__reduceLeftToOption__O__F1__F2__s_Option(this, fa, f, g);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.maximumOption__O__Lcats_kernel_Order__s_Option = (function(fa, A) {
  return $f_Lcats_Foldable__maximumOption__O__Lcats_kernel_Order__s_Option(this, fa, A);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverse___O__F1__Lcats_Applicative__O(this, fa, f, G);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return this.foldMap__sci_Stream__F1__Lcats_kernel_Monoid__O($as_sci_Stream(fa), f, evidence$1);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$1) {
  return this.traverse__sci_Stream__F1__Lcats_Applicative__O($as_sci_Stream(sa), f, evidence$1);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.unit__O = (function() {
  return this.pure__O__sci_Stream((void 0));
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.empty__sci_Stream = (function() {
  return $m_sci_Stream$Empty$();
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.combineK__sci_Stream__sci_Stream__sci_Stream = (function(x, y) {
  var l = new $c_sjsr_AnonFunction0((() => y));
  return $n(x).lazyAppendedAll__F0__sci_Stream(l);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.pure__O__sci_Stream = (function(x) {
  var this$1 = $m_sci_Stream$();
  var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([x]));
  return this$1.from__sc_IterableOnce__sci_Stream(elems);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map2__sci_Stream__sci_Stream__F2__sci_Stream = (function(fa, fb, f) {
  return ($n(fb).isEmpty__Z() ? $m_sci_Stream$Empty$() : $n(fa).flatMap__F1__sci_Stream(new $c_sjsr_AnonFunction1(((a) => $n(fb).map__F1__sci_Stream(new $c_sjsr_AnonFunction1(((b) => $n(f).apply__O__O__O(a, b))))))));
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map2Eval__sci_Stream__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  if ($n(fa).isEmpty__Z()) {
    $m_Lcats_Eval$();
    var a = $m_sci_Stream$Empty$();
    return new $c_Lcats_Now(a);
  } else {
    return $n(fb).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((fb$2) => {
      var fb$1 = $as_sci_Stream(fb$2);
      return this.map2__sci_Stream__sci_Stream__F2__sci_Stream(fa, fb$1, f);
    })));
  }
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldRight__sci_Stream__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return new $c_Lcats_Now(fa).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((s) => {
    var s$1 = $as_sci_Stream(s);
    if ($n(s$1).isEmpty__Z()) {
      return lb;
    } else {
      var $x_1 = $n(s$1).head__O();
      var this$3 = $m_Lcats_Eval$();
      var a = new $c_sjsr_AnonFunction0((() => this.foldRight__sci_Stream__Lcats_Eval__F2__Lcats_Eval($n(s$1).tail__sci_Stream(), lb, f)));
      return $as_Lcats_Eval($n(f).apply__O__O__O($x_1, new $c_Lcats_Eval$$anon$5(a, this$3)));
    }
  })));
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldMap__sci_Stream__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var $x_1 = $n(B);
  var this$1 = $n(fa);
  var this$2 = $n($f_sc_LinearSeqOps__iterator__sc_Iterator(this$1));
  return $n($x_1).combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$2, f));
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.traverse__sci_Stream__F1__Lcats_Applicative__O = (function(fa, f, G) {
  var a = new $c_sjsr_AnonFunction0((() => $n(G).pure__O__O($m_sci_Stream$Empty$())));
  return $n(this.foldRight__sci_Stream__Lcats_Eval__F2__Lcats_Eval(fa, new $c_Lcats_Always(a), new $c_sjsr_AnonFunction2(((a$1, lgsb) => {
    var lgsb$1 = $as_Lcats_Eval(lgsb);
    return $n(G).map2Eval__O__Lcats_Eval__F2__Lcats_Eval($n(f).apply__O__O(a$1), lgsb$1, new $c_sjsr_AnonFunction2(((_$2, _$3) => {
      var _$3$1 = $as_sci_Stream(_$3);
      var l = new $c_sjsr_AnonFunction0((() => _$3$1));
      return new $c_sci_Stream$Cons(_$2, l);
    })));
  })))).value__O();
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.tailRecM__O__F1__sci_Stream = (function(a, fn) {
  var it = new $c_Lcats_instances_StreamInstances$$anon$2(fn, a);
  var factory = $m_sci_Stream$();
  var factory$1 = new $c_sc_IterableFactory$ToFactory(factory);
  return $as_sci_Stream(factory$1.fromSpecific__sc_IterableOnce__O(it));
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldM__sci_Stream__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $n(G).tailRecM__O__F1__O(new $c_T2(fa, z), new $c_sjsr_AnonFunction1(((in$1) => {
    var in$2 = $as_T2(in$1);
    return $ps_Lcats_instances_StreamInstances__step$1__Lcats_Monad__F2__T2__O(G, f, in$2);
  })));
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.algebra__Lcats_kernel_Monoid = (function() {
  return new $c_Lcats_kernel_instances_StreamMonoid();
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.empty__O = (function() {
  return this.empty__sci_Stream();
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  return this.combineK__sci_Stream__sci_Stream__sci_Stream($as_sci_Stream(x), $as_sci_Stream(y));
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return this.pure__O__sci_Stream(x);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Stream(fa);
  return $n(fa$1).map__F1__sci_Stream(f);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Stream(fa);
  return $n(fa$1).flatMap__F1__sci_Stream(f);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_Stream__sci_Stream__F2__sci_Stream($as_sci_Stream(fa), $as_sci_Stream(fb), f);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_Stream__Lcats_Eval__F2__Lcats_Eval($as_sci_Stream(fa), fb, f);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  var fa$1 = $as_sci_Stream(fa);
  return $n(fa$1).foldLeft__O__F2__O(b, f);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__sci_Stream__Lcats_Eval__F2__Lcats_Eval($as_sci_Stream(fa), lb, f);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__sci_Stream__F1__Lcats_kernel_Monoid__O($as_sci_Stream(fa), f, B);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_Stream__F1__Lcats_Applicative__O($as_sci_Stream(fa), f, evidence$1);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_Stream(a, f);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return this.foldM__sci_Stream__O__F2__Lcats_Monad__O($as_sci_Stream(fa), z, f, G);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.fold__O__Lcats_kernel_Monoid__O = (function(fa, A) {
  var fa$1 = $as_sci_Stream(fa);
  return $n(A).combineAll__sc_IterableOnce__O(fa$1);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.toList__O__sci_List = (function(fa) {
  var fa$1 = $as_sci_Stream(fa);
  var this$1 = $n(fa$1);
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$1);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.toIterable__O__sc_Iterable = (function(fa) {
  var fa$1 = $as_sci_Stream(fa);
  return fa$1;
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.reduceLeftOption__O__F2__s_Option = (function(fa, f) {
  var fa$1 = $as_sci_Stream(fa);
  var this$1 = $n(fa$1);
  return $f_sc_IterableOnceOps__reduceLeftOption__F2__s_Option(this$1, f);
});
var $d_Lcats_instances_StreamInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_StreamInstances$$anon$1, "cats.instances.StreamInstances$$anon$1", ({
  Lcats_instances_StreamInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
}));
/** @constructor */
function $c_Lcats_instances_VectorInstances$$anon$1() {
  this.Lcats_instances_VectorInstances$$anon$1__f_evalEmpty = null;
  $m_Lcats_Eval$();
  $m_sci_Vector$();
  var a = $m_sci_Vector0$();
  this.Lcats_instances_VectorInstances$$anon$1__f_evalEmpty = new $c_Lcats_Now(a);
}
$c_Lcats_instances_VectorInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_VectorInstances$$anon$1.prototype.constructor = $c_Lcats_instances_VectorInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_VectorInstances$$anon$1() {
}
$h_Lcats_instances_VectorInstances$$anon$1.prototype = $c_Lcats_instances_VectorInstances$$anon$1.prototype;
$c_Lcats_instances_VectorInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_sci_Vector(fa);
  return $as_sci_Vector($n(fa$1).map__F1__O(f));
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.reduceLeftToOption__O__F1__F2__s_Option = (function(fa, f, g) {
  return $f_Lcats_Foldable__reduceLeftToOption__O__F1__F2__s_Option(this, fa, f, g);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.maximumOption__O__Lcats_kernel_Order__s_Option = (function(fa, A) {
  return $f_Lcats_Foldable__maximumOption__O__Lcats_kernel_Order__s_Option(this, fa, A);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return this.foldMap__sci_Vector__F1__Lcats_kernel_Monoid__O($as_sci_Vector(fa), f, evidence$1);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$1) {
  return this.traverse__sci_Vector__F1__Lcats_Applicative__O($as_sci_Vector(sa), f, evidence$1);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.unit__O = (function() {
  return this.pure__O__sci_Vector((void 0));
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.pure__O__sci_Vector = (function(x) {
  var this$1 = $m_sci_Vector$();
  var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([x]));
  return this$1.from__sc_IterableOnce__sci_Vector(elems);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map2__sci_Vector__sci_Vector__F2__sci_Vector = (function(fa, fb, f) {
  var this$1 = $n(fb);
  if ($f_sc_SeqOps__isEmpty__Z(this$1)) {
    $m_sci_Vector$();
    return $m_sci_Vector0$();
  } else {
    var this$3 = $n(fa);
    $m_sci_Vector$();
    var b = new $c_sci_VectorBuilder();
    var it = this$3.iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var arg1 = $n(it).next__O();
      var elems = $as_sc_IterableOnce($n(fb).map__F1__O(new $c_sjsr_AnonFunction1(((f, arg1) => ((b$1) => $n(f).apply__O__O__O(arg1, b$1)))(f, arg1))));
      b.addAll__sc_IterableOnce__sci_VectorBuilder(elems);
    }
    return b.result__sci_Vector();
  }
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map2Eval__sci_Vector__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  var this$1 = $n(fa);
  if ($f_sc_SeqOps__isEmpty__Z(this$1)) {
    return this.Lcats_instances_VectorInstances$$anon$1__f_evalEmpty;
  } else {
    return $n(fb).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((fb$2) => {
      var fb$1 = $as_sci_Vector(fb$2);
      return this.map2__sci_Vector__sci_Vector__F2__sci_Vector(fa, fb$1, f);
    })));
  }
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldRight__sci_Vector__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  var this$1 = $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0((() => $ps_Lcats_instances_VectorInstances__loop$2__sci_Vector__F2__Lcats_Eval__I__Lcats_Eval(fa, f, lb, 0)));
  return new $c_Lcats_Eval$$anon$5(a, this$1);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldMap__sci_Vector__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var $x_1 = $n(B);
  var this$1 = $n($n(fa).iterator__sc_Iterator());
  return $n($x_1).combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$1, f));
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.tailRecM__O__F1__sci_Vector = (function(a, fn) {
  $m_sci_Vector$();
  var buf = new $c_sci_VectorBuilder();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_sc_Iterator.getArrayOf().constr)([$n($as_sci_Vector($n(fn).apply__O__O(a))).iterator__sc_Iterator()]));
  var elem = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var elem$1 = null;
  elem$1 = elem;
  while (true) {
    matchResult3: {
      var x11 = $as_sci_List(elem$1);
      var x = $m_sci_Nil$();
      if (x.equals__O__Z(x11)) {
        break matchResult3;
      }
      if ((x11 instanceof $c_sci_$colon$colon)) {
        var x15 = $as_sci_$colon$colon(x11);
        var x16 = $as_sc_Iterator($n(x15).sci_$colon$colon__f_head);
        var x17 = $n(x15).sci_$colon$colon__f_next;
        var this$4 = $n(x16);
        if ((!this$4.hasNext__Z())) {
          var ev$1 = x17;
          elem$1 = ev$1;
          ev$1 = null;
          continue;
        }
        var x6 = $as_s_util_Either($n(x16).next__O());
        if ((x6 instanceof $c_s_util_Right)) {
          var b = $n($as_s_util_Right(x6)).s_util_Right__f_value;
          buf.addOne__O__sci_VectorBuilder(b);
          continue;
        }
        if ((x6 instanceof $c_s_util_Left)) {
          var a$1 = $n($as_s_util_Left(x6)).s_util_Left__f_value;
          var elem$1$1 = $n($as_sci_Vector($n(fn).apply__O__O(a$1))).iterator__sc_Iterator();
          var this$5 = $n(x17);
          var this$6 = new $c_sci_$colon$colon(x16, this$5);
          var ev$2 = new $c_sci_$colon$colon(elem$1$1, this$6);
          elem$1 = ev$2;
          ev$2 = null;
          continue;
        }
        throw new $c_s_MatchError(x6);
        break matchResult3;
      }
      throw new $c_s_MatchError(x11);
    }
    break;
  }
  return buf.result__sci_Vector();
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.traverse__sci_Vector__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if ($is_Lcats_StackSafeMonad(G)) {
    var x = $as_Lcats_StackSafeMonad(G);
    return $n(x).map__O__F1__O($m_Lcats_Traverse$().traverseDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O(fa, f, x), new $c_sjsr_AnonFunction1(((_$3) => {
      var _$3$1 = $as_Lcats_data_Chain(_$3);
      return $n(_$3$1).toVector__sci_Vector();
    })));
  } else {
    return $n(G).map__O__F1__O($m_Lcats_data_Chain$().traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O(fa, f, G), new $c_sjsr_AnonFunction1(((_$4) => {
      var _$4$1 = $as_Lcats_data_Chain(_$4);
      return $n(_$4$1).toVector__sci_Vector();
    })));
  }
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.traverse___sci_Vector__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if ($is_Lcats_StackSafeMonad(G)) {
    var x = $as_Lcats_StackSafeMonad(G);
    return $m_Lcats_Traverse$().traverse_Directly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O(fa, f, x);
  } else {
    var len = $n(fa).length__I();
    return ((len === 0) ? $n(G).unit__O() : $n($s_Lcats_instances_VectorInstances__cats$instances$VectorInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__sci_Vector__F1__I__I__Lcats_Eval(G, fa, f, len, 0)).value__O());
  }
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldM__sci_Vector__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  var length = $n(fa).length__I();
  return $n(G).tailRecM__O__F1__O(new $c_T2(z, 0), new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var b = $n(x$1$1)._1__O();
      var i = $uI($n(x$1$1)._2__O());
      return ((i < length) ? $n(G).map__O__F1__O($n(f).apply__O__O__O(b, $n(fa).apply__I__O(i)), new $c_sjsr_AnonFunction1(((b$2) => {
        var _2 = ((1 + i) | 0);
        var value = new $c_T2(b$2, _2);
        return new $c_s_util_Left(value);
      }))) : $n(G).pure__O__O(new $c_s_util_Right(b)));
    }
    throw new $c_s_MatchError(x$1$1);
  })));
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.algebra__Lcats_kernel_Monoid = (function() {
  return $m_Lcats_kernel_instances_VectorMonoid$().Lcats_kernel_instances_VectorMonoid$__f_singleton;
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.empty__O = (function() {
  $m_sci_Vector$();
  return $m_sci_Vector0$();
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Vector(x);
  var y$1 = $as_sci_Vector(y);
  var this$1 = $n(x$1);
  return this$1.appendedAll__sc_IterableOnce__sci_Vector(y$1);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return this.pure__O__sci_Vector(x);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Vector(fa);
  return $as_sci_Vector($n(fa$1).map__F1__O(f));
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Vector(fa);
  var this$1 = $n(fa$1);
  return $as_sci_Vector($f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this$1, f));
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_Vector__sci_Vector__F2__sci_Vector($as_sci_Vector(fa), $as_sci_Vector(fb), f);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_Vector__Lcats_Eval__F2__Lcats_Eval($as_sci_Vector(fa), fb, f);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  var fa$1 = $as_sci_Vector(fa);
  var this$1 = $n(fa$1);
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this$1, b, f);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__sci_Vector__Lcats_Eval__F2__Lcats_Eval($as_sci_Vector(fa), lb, f);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__sci_Vector__F1__Lcats_kernel_Monoid__O($as_sci_Vector(fa), f, B);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_Vector(a, f);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.size__O__J = (function(fa) {
  var fa$1 = $as_sci_Vector(fa);
  var this$1 = $n(fa$1);
  var value = this$1.length__I();
  var hi = (value >> 31);
  return new $c_RTLong(value, hi);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_Vector__F1__Lcats_Applicative__O($as_sci_Vector(fa), f, evidence$1);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return this.traverse___sci_Vector__F1__Lcats_Applicative__O($as_sci_Vector(fa), f, G);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return this.foldM__sci_Vector__O__F2__Lcats_Monad__O($as_sci_Vector(fa), z, f, G);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.fold__O__Lcats_kernel_Monoid__O = (function(fa, A) {
  var fa$1 = $as_sci_Vector(fa);
  return $n(A).combineAll__sc_IterableOnce__O(fa$1);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.toList__O__sci_List = (function(fa) {
  var fa$1 = $as_sci_Vector(fa);
  var this$1 = $n(fa$1);
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$1);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.toIterable__O__sc_Iterable = (function(fa) {
  var fa$1 = $as_sci_Vector(fa);
  return fa$1;
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.reduceLeftOption__O__F2__s_Option = (function(fa, f) {
  var fa$1 = $as_sci_Vector(fa);
  var this$1 = $n(fa$1);
  return $f_sc_IterableOnceOps__reduceLeftOption__F2__s_Option(this$1, f);
});
var $d_Lcats_instances_VectorInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_VectorInstances$$anon$1, "cats.instances.VectorInstances$$anon$1", ({
  Lcats_instances_VectorInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
}));
function $p_scm_HashSet__addElem__O__I__Z($thiz, elem, hash) {
  var idx = (hash & (((-1) + $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).u.length) | 0));
  var x1 = $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).get(idx);
  if ((x1 === null)) {
    $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).set(idx, new $c_scm_HashSet$Node(elem, hash, null));
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && ($n(n).scm_HashSet$Node__f__hash <= hash))) {
      if ((($n(n).scm_HashSet$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(elem, $n(n).scm_HashSet$Node__f__key))) {
        return false;
      }
      prev = n;
      n = $n(n).scm_HashSet$Node__f__next;
    }
    if ((prev === null)) {
      $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).set(idx, new $c_scm_HashSet$Node(elem, hash, x1));
    } else {
      $n(prev).scm_HashSet$Node__f__next = new $c_scm_HashSet$Node(elem, hash, $n(prev).scm_HashSet$Node__f__next);
    }
  }
  $thiz.scm_HashSet__f_contentSize = ((1 + $thiz.scm_HashSet__f_contentSize) | 0);
  return true;
}
function $p_scm_HashSet__remove__O__I__Z($thiz, elem, hash) {
  var idx = (hash & (((-1) + $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).u.length) | 0));
  var x1 = $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).get(idx);
  if ((x1 !== null)) {
    if ((($n(x1).scm_HashSet$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z($n(x1).scm_HashSet$Node__f__key, elem))) {
      $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).set(idx, $n(x1).scm_HashSet$Node__f__next);
      $thiz.scm_HashSet__f_contentSize = (((-1) + $thiz.scm_HashSet__f_contentSize) | 0);
      return true;
    } else {
      var prev = x1;
      var next = $n(x1).scm_HashSet$Node__f__next;
      while (((next !== null) && ($n(next).scm_HashSet$Node__f__hash <= hash))) {
        if ((($n(next).scm_HashSet$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z($n(next).scm_HashSet$Node__f__key, elem))) {
          $n(prev).scm_HashSet$Node__f__next = $n(next).scm_HashSet$Node__f__next;
          $thiz.scm_HashSet__f_contentSize = (((-1) + $thiz.scm_HashSet__f_contentSize) | 0);
          return true;
        }
        prev = next;
        next = $n(next).scm_HashSet$Node__f__next;
      }
      return false;
    }
  } else {
    return false;
  }
}
function $p_scm_HashSet__growTable__I__V($thiz, newlen) {
  var oldlen = $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).u.length;
  $thiz.scm_HashSet__f_threshold = $p_scm_HashSet__newThreshold__I__I($thiz, newlen);
  if (($thiz.scm_HashSet__f_contentSize === 0)) {
    $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table = new ($d_scm_HashSet$Node.getArrayOf().constr)(newlen);
  } else {
    var original = $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table;
    $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table = $asArrayOf_scm_HashSet$Node($m_ju_Arrays$().copyOf__AO__I__AO(original, newlen), 1);
    var preLow = new $c_scm_HashSet$Node(null, 0, null);
    var preHigh = new $c_scm_HashSet$Node(null, 0, null);
    while ((oldlen < newlen)) {
      var i = 0;
      while ((i < oldlen)) {
        var old = $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).get(i);
        if ((old !== null)) {
          preLow.scm_HashSet$Node__f__next = null;
          preHigh.scm_HashSet$Node__f__next = null;
          var lastLow = preLow;
          var lastHigh = preHigh;
          var n = old;
          while ((n !== null)) {
            var next = $n(n).scm_HashSet$Node__f__next;
            if ((($n(n).scm_HashSet$Node__f__hash & oldlen) === 0)) {
              $n(lastLow).scm_HashSet$Node__f__next = n;
              lastLow = n;
            } else {
              $n(lastHigh).scm_HashSet$Node__f__next = n;
              lastHigh = n;
            }
            n = next;
          }
          $n(lastLow).scm_HashSet$Node__f__next = null;
          if ((old !== preLow.scm_HashSet$Node__f__next)) {
            $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).set(i, preLow.scm_HashSet$Node__f__next);
          }
          if ((preHigh.scm_HashSet$Node__f__next !== null)) {
            $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).set(((i + oldlen) | 0), preHigh.scm_HashSet$Node__f__next);
            $n(lastHigh).scm_HashSet$Node__f__next = null;
          }
        }
        i = ((1 + i) | 0);
      }
      oldlen = (oldlen << 1);
    }
  }
}
function $p_scm_HashSet__tableSizeFor__I__I($thiz, capacity) {
  var x = (((-1) + capacity) | 0);
  var i = ((x > 4) ? x : 4);
  var x$1 = ((((-2147483648) >> $uI(Math.clz32(i))) & i) << 1);
  return ((x$1 < 1073741824) ? x$1 : 1073741824);
}
function $p_scm_HashSet__newThreshold__I__I($thiz, size) {
  return $doubleToInt((size * $thiz.scm_HashSet__f_loadFactor));
}
function $ct_scm_HashSet__I__D__($thiz, initialCapacity, loadFactor) {
  $thiz.scm_HashSet__f_loadFactor = loadFactor;
  $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table = new ($d_scm_HashSet$Node.getArrayOf().constr)($p_scm_HashSet__tableSizeFor__I__I($thiz, initialCapacity));
  $thiz.scm_HashSet__f_threshold = $p_scm_HashSet__newThreshold__I__I($thiz, $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).u.length);
  $thiz.scm_HashSet__f_contentSize = 0;
  return $thiz;
}
function $ct_scm_HashSet__($thiz) {
  $ct_scm_HashSet__I__D__($thiz, 16, 0.75);
  return $thiz;
}
/** @constructor */
function $c_scm_HashSet() {
  this.scm_HashSet__f_loadFactor = 0.0;
  this.scm_HashSet__f_scala$collection$mutable$HashSet$$table = null;
  this.scm_HashSet__f_threshold = 0;
  this.scm_HashSet__f_contentSize = 0;
}
$c_scm_HashSet.prototype = new $h_scm_AbstractSet();
$c_scm_HashSet.prototype.constructor = $c_scm_HashSet;
/** @constructor */
function $h_scm_HashSet() {
}
$h_scm_HashSet.prototype = $c_scm_HashSet.prototype;
$c_scm_HashSet.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_scm_HashSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_scm_HashSet.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_scm_HashSet.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_scm_HashSet.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_scm_HashSet.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$c_scm_HashSet.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_scm_HashSet.prototype.size__I = (function() {
  return this.scm_HashSet__f_contentSize;
});
$c_scm_HashSet.prototype.scala$collection$mutable$HashSet$$improveHash__I__I = (function(originalHash) {
  return (originalHash ^ ((originalHash >>> 16) | 0));
});
$c_scm_HashSet.prototype.contains__O__Z = (function(elem) {
  var hash = this.scala$collection$mutable$HashSet$$improveHash__I__I($m_sr_Statics$().anyHash__O__I(elem));
  var x1 = $n(this.scm_HashSet__f_scala$collection$mutable$HashSet$$table).get((hash & (((-1) + $n(this.scm_HashSet__f_scala$collection$mutable$HashSet$$table).u.length) | 0)));
  return (((x1 === null) ? null : $n(x1).findNode__O__I__scm_HashSet$Node(elem, hash)) !== null);
});
$c_scm_HashSet.prototype.sizeHint__I__V = (function(size) {
  var target = $p_scm_HashSet__tableSizeFor__I__I(this, $doubleToInt((((1 + size) | 0) / this.scm_HashSet__f_loadFactor)));
  if ((target > $n(this.scm_HashSet__f_scala$collection$mutable$HashSet$$table).u.length)) {
    $p_scm_HashSet__growTable__I__V(this, target);
  }
});
$c_scm_HashSet.prototype.add__O__Z = (function(elem) {
  if ((((1 + this.scm_HashSet__f_contentSize) | 0) >= this.scm_HashSet__f_threshold)) {
    $p_scm_HashSet__growTable__I__V(this, ($n(this.scm_HashSet__f_scala$collection$mutable$HashSet$$table).u.length << 1));
  }
  return $p_scm_HashSet__addElem__O__I__Z(this, elem, this.scala$collection$mutable$HashSet$$improveHash__I__I($m_sr_Statics$().anyHash__O__I(elem)));
});
$c_scm_HashSet.prototype.addAll__sc_IterableOnce__scm_HashSet = (function(xs) {
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(this, xs, 0);
  if ((xs instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(xs);
    var this$2 = $n(x2);
    var f = new $c_sjsr_AnonFunction2(((k$2, h$2) => {
      var h = $uI(h$2);
      $p_scm_HashSet__addElem__O__I__Z(this, k$2, this.scala$collection$mutable$HashSet$$improveHash__I__I(h));
    }));
    $n(this$2.sci_HashSet__f_rootNode).foreachWithHash__F2__V(f);
    return this;
  } else if ((xs instanceof $c_scm_HashSet)) {
    var x3 = $as_scm_HashSet(xs);
    var this$3 = $n(x3);
    var iter = new $c_scm_HashSet$$anon$2(this$3);
    while (iter.hasNext__Z()) {
      var next = $as_scm_HashSet$Node(iter.next__O());
      $p_scm_HashSet__addElem__O__I__Z(this, $n(next).scm_HashSet$Node__f__key, $n(next).scm_HashSet$Node__f__hash);
    }
    return this;
  } else if (false) {
    var x4 = $as_scm_LinkedHashSet(xs);
    var iter$2 = $n(x4).entryIterator__sc_Iterator();
    while ($n(iter$2).hasNext__Z()) {
      var next$2 = $as_scm_LinkedHashSet$Entry($n(iter$2).next__O());
      $p_scm_HashSet__addElem__O__I__Z(this, $n(next$2).key__O(), $n(next$2).hash__I());
    }
    return this;
  } else {
    return $as_scm_HashSet($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs));
  }
});
$c_scm_HashSet.prototype.remove__O__Z = (function(elem) {
  return $p_scm_HashSet__remove__O__I__Z(this, elem, this.scala$collection$mutable$HashSet$$improveHash__I__I($m_sr_Statics$().anyHash__O__I(elem)));
});
$c_scm_HashSet.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_HashSet$$anon$1(this);
});
$c_scm_HashSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_HashSet$();
});
$c_scm_HashSet.prototype.knownSize__I = (function() {
  return this.scm_HashSet__f_contentSize;
});
$c_scm_HashSet.prototype.isEmpty__Z = (function() {
  return (this.scm_HashSet__f_contentSize === 0);
});
$c_scm_HashSet.prototype.foreach__F1__V = (function(f) {
  var len = $n(this.scm_HashSet__f_scala$collection$mutable$HashSet$$table).u.length;
  var i = 0;
  while ((i < len)) {
    var n = $n(this.scm_HashSet__f_scala$collection$mutable$HashSet$$table).get(i);
    if ((n !== null)) {
      $n(n).foreach__F1__V(f);
    }
    i = ((1 + i) | 0);
  }
});
$c_scm_HashSet.prototype.className__T = (function() {
  return "HashSet";
});
$c_scm_HashSet.prototype.hashCode__I = (function() {
  var setIterator = new $c_scm_HashSet$$anon$1(this);
  var hashIterator = ((!setIterator.hasNext__Z()) ? setIterator : new $c_scm_HashSet$$anon$3(this));
  return $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(hashIterator, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_setSeed);
});
$c_scm_HashSet.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  this.remove__O__Z(elem);
  return this;
});
$c_scm_HashSet.prototype.addOne__O__scm_Growable = (function(elem) {
  this.add__O__Z(elem);
  return this;
});
$c_scm_HashSet.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_HashSet(elems);
});
function $as_scm_HashSet(obj) {
  return (((obj instanceof $c_scm_HashSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.HashSet"));
}
function $isArrayOf_scm_HashSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_HashSet)));
}
function $asArrayOf_scm_HashSet(obj, depth) {
  return (($isArrayOf_scm_HashSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.HashSet;", depth));
}
var $d_scm_HashSet = new $TypeData().initClass($c_scm_HashSet, "scala.collection.mutable.HashSet", ({
  scm_HashSet: 1,
  scm_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  scm_Set: 1,
  scm_Iterable: 1,
  scm_SetOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sjs_js_WrappedDictionary(dict) {
  this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict = null;
  this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict = dict;
}
$c_sjs_js_WrappedDictionary.prototype = new $h_scm_AbstractMap();
$c_sjs_js_WrappedDictionary.prototype.constructor = $c_sjs_js_WrappedDictionary;
/** @constructor */
function $h_sjs_js_WrappedDictionary() {
}
$h_sjs_js_WrappedDictionary.prototype = $c_sjs_js_WrappedDictionary.prototype;
$c_sjs_js_WrappedDictionary.prototype.fromSpecific__sc_IterableOnce__sjs_js_WrappedDictionary = (function(coll) {
  var d = new $c_sjs_js_WrappedDictionary(({}));
  $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(d, coll);
  return d;
});
$c_sjs_js_WrappedDictionary.prototype.newSpecificBuilder__scm_Builder = (function() {
  return new $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder();
});
$c_sjs_js_WrappedDictionary.prototype.get__T__s_Option = (function(key) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    return new $c_s_Some(this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key]);
  } else {
    return $m_s_None$();
  }
});
$c_sjs_js_WrappedDictionary.prototype.apply__T__O = (function(key) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    return this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key];
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$c_sjs_js_WrappedDictionary.prototype.getOrElse__T__F0__O = (function(key, default$1) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    return this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key];
  } else {
    return $n(default$1).apply__O();
  }
});
$c_sjs_js_WrappedDictionary.prototype.getOrElseUpdate__T__F0__O = (function(key, op) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    return this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key];
  } else {
    var v = $n(op).apply__O();
    this.update__T__O__V(key, v);
    return v;
  }
});
$c_sjs_js_WrappedDictionary.prototype.subtractOne__T__sjs_js_WrappedDictionary = (function(key) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    delete this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key];
  }
  return this;
});
$c_sjs_js_WrappedDictionary.prototype.update__T__O__V = (function(key, value) {
  this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key] = value;
});
$c_sjs_js_WrappedDictionary.prototype.addOne__T2__sjs_js_WrappedDictionary = (function(kv) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  var key = $as_T($n(kv)._1__O());
  var value = $n(kv)._2__O();
  dict[key] = value;
  return this;
});
$c_sjs_js_WrappedDictionary.prototype.iterator__sc_Iterator = (function() {
  return new $c_sjs_js_WrappedDictionary$DictionaryIterator(this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict);
});
$c_sjs_js_WrappedDictionary.prototype.empty__sc_IterableOps = (function() {
  return new $c_sjs_js_WrappedDictionary(({}));
});
$c_sjs_js_WrappedDictionary.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__sjs_js_WrappedDictionary($as_T2(elem));
});
$c_sjs_js_WrappedDictionary.prototype.update__O__O__V = (function(key, value) {
  this.update__T__O__V($as_T(key), value);
});
$c_sjs_js_WrappedDictionary.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__T__sjs_js_WrappedDictionary($as_T(elem));
});
$c_sjs_js_WrappedDictionary.prototype.contains__O__Z = (function(key) {
  var key$1 = $as_T(key);
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  return $uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key$1));
});
$c_sjs_js_WrappedDictionary.prototype.getOrElseUpdate__O__F0__O = (function(key, defaultValue) {
  return this.getOrElseUpdate__T__F0__O($as_T(key), defaultValue);
});
$c_sjs_js_WrappedDictionary.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return this.getOrElse__T__F0__O($as_T(key), default$1);
});
$c_sjs_js_WrappedDictionary.prototype.apply__O__O = (function(key) {
  return this.apply__T__O($as_T(key));
});
$c_sjs_js_WrappedDictionary.prototype.get__O__s_Option = (function(key) {
  return this.get__T__s_Option($as_T(key));
});
$c_sjs_js_WrappedDictionary.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sjs_js_WrappedDictionary(coll);
});
$c_sjs_js_WrappedDictionary.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sjs_js_WrappedDictionary(coll);
});
var $d_sjs_js_WrappedDictionary = new $TypeData().initClass($c_sjs_js_WrappedDictionary, "scala.scalajs.js.WrappedDictionary", ({
  sjs_js_WrappedDictionary: 1,
  scm_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  scm_Map: 1,
  scm_Iterable: 1,
  scm_MapOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1
}));
function $ct_Lcats_data_AbstractNonEmptyInstances__Lcats_Monad__Lcats_CoflatMap__Lcats_Traverse__Lcats_Alternative__($thiz, MF, CF, TF, SF) {
  $thiz.Lcats_data_AbstractNonEmptyInstances__f_monadInstance = MF;
  $thiz.Lcats_data_AbstractNonEmptyInstances__f_traverseInstance = TF;
  return $thiz;
}
/** @constructor */
function $c_Lcats_data_AbstractNonEmptyInstances() {
  this.Lcats_data_AbstractNonEmptyInstances__f_monadInstance = null;
  this.Lcats_data_AbstractNonEmptyInstances__f_traverseInstance = null;
}
$c_Lcats_data_AbstractNonEmptyInstances.prototype = new $h_O();
$c_Lcats_data_AbstractNonEmptyInstances.prototype.constructor = $c_Lcats_data_AbstractNonEmptyInstances;
/** @constructor */
function $h_Lcats_data_AbstractNonEmptyInstances() {
}
$h_Lcats_data_AbstractNonEmptyInstances.prototype = $c_Lcats_data_AbstractNonEmptyInstances.prototype;
$c_Lcats_data_AbstractNonEmptyInstances.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $n(this.Lcats_data_AbstractNonEmptyInstances__f_monadInstance).map__O__F1__O(fa, f);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.unit__O = (function() {
  return $n(this.Lcats_data_AbstractNonEmptyInstances__f_monadInstance).pure__O__O((void 0));
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.toIterable__O__sc_Iterable = (function(fa) {
  return $m_Lcats_compat_FoldableCompat$().toIterable__O__Lcats_Foldable__sc_Iterable(fa, this);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverse___O__F1__Lcats_Applicative__O(this, fa, f, G);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return $n(this.Lcats_data_AbstractNonEmptyInstances__f_traverseInstance).foldMap__O__F1__Lcats_kernel_Monoid__O(fa, f, evidence$1);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$1) {
  return $n(this.Lcats_data_AbstractNonEmptyInstances__f_traverseInstance).traverse__O__F1__Lcats_Applicative__O(sa, f, evidence$1);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.reduceLeftToOption__O__F1__F2__s_Option = (function(fa, f, g) {
  return $f_Lcats_Reducible__reduceLeftToOption__O__F1__F2__s_Option(this, fa, f, g);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.maximumOption__O__Lcats_kernel_Order__s_Option = (function(fa, A) {
  return $f_Lcats_Reducible__maximumOption__O__Lcats_kernel_Order__s_Option(this, fa, A);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.pure__O__O = (function(x) {
  return $n(this.Lcats_data_AbstractNonEmptyInstances__f_monadInstance).pure__O__O(x);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.map__O__F1__O = (function(fa, f) {
  return $n(this.Lcats_data_AbstractNonEmptyInstances__f_monadInstance).map__O__F1__O(fa, f);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.flatMap__O__F1__O = (function(fa, f) {
  return $n(this.Lcats_data_AbstractNonEmptyInstances__f_monadInstance).flatMap__O__F1__O(fa, f);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $n(this.Lcats_data_AbstractNonEmptyInstances__f_monadInstance).map2__O__O__F2__O(fa, fb, f);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $n(this.Lcats_data_AbstractNonEmptyInstances__f_monadInstance).map2Eval__O__Lcats_Eval__F2__Lcats_Eval(fa, fb, f);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.tailRecM__O__F1__O = (function(a, f) {
  return $n(this.Lcats_data_AbstractNonEmptyInstances__f_monadInstance).tailRecM__O__F1__O(a, f);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  return $n(this.Lcats_data_AbstractNonEmptyInstances__f_traverseInstance).foldLeft__O__O__F2__O(fa, b, f);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return $n(this.Lcats_data_AbstractNonEmptyInstances__f_traverseInstance).foldRight__O__Lcats_Eval__F2__Lcats_Eval(fa, lb, f);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return $n(this.Lcats_data_AbstractNonEmptyInstances__f_traverseInstance).foldMap__O__F1__Lcats_kernel_Monoid__O(fa, f, B);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $n(this.Lcats_data_AbstractNonEmptyInstances__f_traverseInstance).traverse__O__F1__Lcats_Applicative__O(fa, f, G);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $n(this.Lcats_data_AbstractNonEmptyInstances__f_traverseInstance).foldM__O__O__F2__Lcats_Monad__O(fa, z, f, G);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.fold__O__Lcats_kernel_Monoid__O = (function(fa, A) {
  return $n(this.Lcats_data_AbstractNonEmptyInstances__f_traverseInstance).fold__O__Lcats_kernel_Monoid__O(fa, A);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.toList__O__sci_List = (function(fa) {
  return $n(this.Lcats_data_AbstractNonEmptyInstances__f_traverseInstance).toList__O__sci_List(fa);
});
$c_Lcats_data_AbstractNonEmptyInstances.prototype.reduceLeftOption__O__F2__s_Option = (function(fa, f) {
  return $n(this.Lcats_data_AbstractNonEmptyInstances__f_traverseInstance).reduceLeftOption__O__F2__s_Option(fa, f);
});
function $f_Lcats_effect_kernel_Async__asyncCheckAttempt__F1__O($thiz, k) {
  var body = new $c_Lcats_effect_kernel_Async$$anon$1(k);
  return $thiz.cont__Lcats_effect_kernel_Cont__O(body);
}
function $f_Lcats_effect_kernel_Async__async__F1__O($thiz, k) {
  return $thiz.asyncCheckAttempt__F1__O(new $c_sjsr_AnonFunction1(((cb) => {
    var cb$1 = $as_F1(cb);
    return $thiz.map__O__F1__O($n(k).apply__O__O(cb$1), new $c_sjsr_AnonFunction1(((_$3) => {
      var _$3$1 = $as_s_Option(_$3);
      return new $c_s_util_Left(_$3$1);
    })));
  })));
}
function $f_Lcats_effect_kernel_Async__async___F1__O($thiz, k) {
  return $thiz.async__F1__O(new $c_sjsr_AnonFunction1(((cb) => {
    var cb$1 = $as_F1(cb);
    return $thiz.as__O__O__O($thiz.delay__F0__O(new $c_sjsr_AnonFunction0((() => {
      $n(k).apply__O__O(cb$1);
    }))), $m_s_None$());
  })));
}
function $f_Lcats_effect_kernel_Async__never__O($thiz) {
  return $thiz.async__F1__O(new $c_sjsr_AnonFunction1(((_$4) => {
    $as_F1(_$4);
    var value = $thiz.pure__O__O((void 0));
    return $thiz.pure__O__O(new $c_s_Some(value));
  })));
}
function $f_Lcats_effect_kernel_Async__fromFuture__O__O($thiz, fut) {
  return $thiz.flatMap__O__F1__O($thiz.executionContext__O(), new $c_sjsr_AnonFunction1(((ec) => {
    var ec$1 = $as_s_concurrent_ExecutionContext(ec);
    return $thiz.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((poll) => {
      var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
      return $thiz.flatMap__O__F1__O($n(poll$1).apply__O__O(fut), new $c_sjsr_AnonFunction1(((f) => {
        var f$1 = $as_s_concurrent_Future(f);
        return $thiz.async___F1__O(new $c_sjsr_AnonFunction1(((cb) => {
          var cb$1 = $as_F1(cb);
          $n(f$1).onComplete__F1__s_concurrent_ExecutionContext__V(new $c_sjsr_AnonFunction1(((t) => {
            var t$1 = $as_s_util_Try(t);
            $n(cb$1).apply__O__O($n(t$1).toEither__s_util_Either());
          })), ec$1);
        })));
      })));
    })));
  })));
}
function $is_Lcats_effect_kernel_Async(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_kernel_Async)));
}
function $as_Lcats_effect_kernel_Async(obj) {
  return (($is_Lcats_effect_kernel_Async(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Async"));
}
function $isArrayOf_Lcats_effect_kernel_Async(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Async)));
}
function $asArrayOf_Lcats_effect_kernel_Async(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Async(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Async;", depth));
}
function $as_sci_ListMap(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ListMap"));
}
function $isArrayOf_sci_ListMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ListMap)));
}
function $asArrayOf_sci_ListMap(obj, depth) {
  return (($isArrayOf_sci_ListMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ListMap;", depth));
}
function $p_sci_NumericRange__length$lzycompute__I($thiz) {
  if (((((1 & $thiz.sci_NumericRange__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.sci_NumericRange__f_length = $m_sci_NumericRange$().count__O__O__O__Z__s_math_Integral__I($thiz.sci_NumericRange__f_start, $thiz.sci_NumericRange__f_end, $thiz.sci_NumericRange__f_step, $thiz.sci_NumericRange__f_isInclusive, $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    $thiz.sci_NumericRange__f_bitmap$0 = (((1 | $thiz.sci_NumericRange__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.sci_NumericRange__f_length;
}
function $p_sci_NumericRange__isEmpty$lzycompute__Z($thiz) {
  if (((((2 & $thiz.sci_NumericRange__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var x = $thiz.sci_NumericRange__f_start;
    var y = $thiz.sci_NumericRange__f_end;
    if ($f_s_math_Ordering__gt__O__O__Z(this$1, x, y)) {
      var this$3 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
      var x$1 = $thiz.sci_NumericRange__f_step;
      var this$2 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
      var y$1 = this$2.fromInt__I__O(0);
      var $x_3 = $f_s_math_Ordering__gt__O__O__Z(this$3, x$1, y$1);
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var $x_2 = true;
    } else {
      var this$4 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
      var x$2 = $thiz.sci_NumericRange__f_start;
      var y$2 = $thiz.sci_NumericRange__f_end;
      if ($f_s_math_Ordering__lt__O__O__Z(this$4, x$2, y$2)) {
        var this$6 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
        var x$3 = $thiz.sci_NumericRange__f_step;
        var this$5 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
        var y$3 = this$5.fromInt__I__O(0);
        var $x_2 = $f_s_math_Ordering__lt__O__O__Z(this$6, x$3, y$3);
      } else {
        var $x_2 = false;
      }
    }
    if ($x_2) {
      var $x_1 = true;
    } else {
      var this$7 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
      var x$4 = $thiz.sci_NumericRange__f_start;
      var y$4 = $thiz.sci_NumericRange__f_end;
      if ($f_s_math_Ordering__equiv__O__O__Z(this$7, x$4, y$4)) {
        var $x_1 = (!$thiz.sci_NumericRange__f_isInclusive);
      } else {
        var $x_1 = false;
      }
    }
    $thiz.sci_NumericRange__f_isEmpty = $x_1;
    $thiz.sci_NumericRange__f_bitmap$0 = (((2 | $thiz.sci_NumericRange__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.sci_NumericRange__f_isEmpty;
}
function $p_sci_NumericRange__locationAfterN__I__O($thiz, n) {
  var this$1 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
  var lhs = $thiz.sci_NumericRange__f_start;
  var $x_1 = new $c_s_math_Integral$IntegralOps(this$1, lhs);
  var this$2 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
  var lhs$1 = $thiz.sci_NumericRange__f_step;
  return $x_1.$plus__O__O(new $c_s_math_Integral$IntegralOps(this$2, lhs$1).$times__O__O($n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).fromInt__I__O(n)));
}
function $p_sci_NumericRange__crossesTheEndAfterN__I__Z($thiz, n) {
  var this$1 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
  var x = $thiz.sci_NumericRange__f_end;
  var y = $thiz.sci_NumericRange__f_start;
  if ($f_s_math_Ordering__gt__O__O__Z(this$1, x, y)) {
    var this$3 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var x$1 = $thiz.sci_NumericRange__f_step;
    var this$2 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var y$1 = this$2.fromInt__I__O(0);
    var $x_1 = $f_s_math_Ordering__gt__O__O__Z(this$3, x$1, y$1);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var stepIsInTheSameDirectionAsStartToEndVector = true;
  } else {
    var this$4 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var x$2 = $thiz.sci_NumericRange__f_end;
    var y$2 = $thiz.sci_NumericRange__f_start;
    if ($f_s_math_Ordering__lt__O__O__Z(this$4, x$2, y$2)) {
      var $x_3 = $m_sr_BoxesRunTime$();
      var $x_2 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).sign__O__O($thiz.sci_NumericRange__f_step);
      var this$6 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
      var this$5 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
      var lhs = this$5.fromInt__I__O(1);
      var stepIsInTheSameDirectionAsStartToEndVector = $n($x_3).equals__O__O__Z($x_2, new $c_s_math_Integral$IntegralOps(this$6, lhs).unary_$minus__O());
    } else {
      var stepIsInTheSameDirectionAsStartToEndVector = false;
    }
  }
  var this$7 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
  var x$3 = $thiz.sci_NumericRange__f_start;
  var y$3 = $thiz.sci_NumericRange__f_end;
  if ((($f_s_math_Ordering__equiv__O__O__Z(this$7, x$3, y$3) || (n <= 0)) || (!stepIsInTheSameDirectionAsStartToEndVector))) {
    return (n >= 1);
  }
  var this$8 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
  var x$4 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).sign__O__O($thiz.sci_NumericRange__f_start);
  var y$4 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).sign__O__O($thiz.sci_NumericRange__f_end);
  var sameSign = $f_s_math_Ordering__equiv__O__O__Z(this$8, x$4, y$4);
  if (sameSign) {
    var len = $p_sci_NumericRange__unsafeRangeLength$1__sci_NumericRange__O($thiz, $thiz);
    if ($p_sci_NumericRange__fitsInInteger$1__O__Z($thiz, len)) {
      return (n >= $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).toInt__O__I(len));
    } else {
      var this$9 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
      var x$5 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).fromInt__I__O(n);
      return $f_s_math_Ordering__gteq__O__O__Z(this$9, x$5, len);
    }
  } else {
    var stepsRemainderToZero = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).rem__O__O__O($thiz.sci_NumericRange__f_start, $thiz.sci_NumericRange__f_step);
    var this$11 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var this$10 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var y$5 = this$10.fromInt__I__O(0);
    var walksOnZero = $f_s_math_Ordering__equiv__O__O__Z(this$11, stepsRemainderToZero, y$5);
    if (walksOnZero) {
      var this$12 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
      var lhs$1 = $thiz.sci_NumericRange__f_step;
      var closestToZero = new $c_s_math_Integral$IntegralOps(this$12, lhs$1).unary_$minus__O();
    } else {
      var closestToZero = stepsRemainderToZero;
    }
    var this$14 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var x$6 = $thiz.sci_NumericRange__f_start;
    var this$13 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var y$6 = this$13.fromInt__I__O(0);
    if ($f_s_math_Ordering__lt__O__O__Z(this$14, x$6, y$6)) {
      if (walksOnZero) {
        var twoStepsAfterLargestNegativeNumber = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).plus__O__O__O(closestToZero, $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).times__O__O__O($thiz.sci_NumericRange__f_step, $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).fromInt__I__O(2)));
        $m_sci_NumericRange$();
        var start = $thiz.sci_NumericRange__f_start;
        var step = $thiz.sci_NumericRange__f_step;
        var num = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
        var x1 = new $c_T3(new $c_sci_NumericRange$Exclusive(start, closestToZero, step, num), $thiz.copy__O__O__O__sci_NumericRange(twoStepsAfterLargestNegativeNumber, $thiz.sci_NumericRange__f_end, $thiz.sci_NumericRange__f_step), 2);
      } else {
        $m_sci_NumericRange$();
        var start$1 = $thiz.sci_NumericRange__f_start;
        var step$1 = $thiz.sci_NumericRange__f_step;
        var num$1 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
        var x1 = new $c_T3(new $c_sci_NumericRange$Exclusive(start$1, closestToZero, step$1, num$1), $thiz.copy__O__O__O__sci_NumericRange($n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).plus__O__O__O(closestToZero, $thiz.sci_NumericRange__f_step), $thiz.sci_NumericRange__f_end, $thiz.sci_NumericRange__f_step), 1);
      }
    } else if (walksOnZero) {
      var twoStepsAfterZero = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).times__O__O__O($thiz.sci_NumericRange__f_step, $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).fromInt__I__O(2));
      var $x_4 = $thiz.copy__O__O__O__sci_NumericRange(twoStepsAfterZero, $thiz.sci_NumericRange__f_end, $thiz.sci_NumericRange__f_step);
      $m_sci_NumericRange$();
      var start$2 = $thiz.sci_NumericRange__f_start;
      var this$17 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
      var lhs$2 = $thiz.sci_NumericRange__f_step;
      var end = new $c_s_math_Integral$IntegralOps(this$17, lhs$2).unary_$minus__O();
      var step$2 = $thiz.sci_NumericRange__f_step;
      var num$2 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
      var x1 = new $c_T3($x_4, new $c_sci_NumericRange$Inclusive(start$2, end, step$2, num$2), 2);
    } else {
      var twoStepsAfterSmallestPositiveNumber = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).plus__O__O__O(closestToZero, $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).times__O__O__O($thiz.sci_NumericRange__f_step, $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).fromInt__I__O(2)));
      var $x_5 = $thiz.copy__O__O__O__sci_NumericRange(twoStepsAfterSmallestPositiveNumber, $thiz.sci_NumericRange__f_end, $thiz.sci_NumericRange__f_step);
      $m_sci_NumericRange$();
      var start$3 = $thiz.sci_NumericRange__f_start;
      var step$3 = $thiz.sci_NumericRange__f_step;
      var num$3 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
      var x1 = new $c_T3($x_5, new $c_sci_NumericRange$Inclusive(start$3, closestToZero, step$3, num$3), 2);
    }
    matchEnd6: {
      var x$1$1___1;
      var x$1$1___2;
      var x$1$1___3;
      if ((x1 !== null)) {
        var l = $as_sci_NumericRange($n(x1).T3__f__1);
        var r = $as_sci_NumericRange($n(x1).T3__f__2);
        var carry = $uI($n(x1).T3__f__3);
        if ((l !== null)) {
          if ((r !== null)) {
            var x$1$1___1 = l;
            var x$1$1___2 = r;
            var x$1$1___3 = carry;
            break matchEnd6;
          }
        }
      }
      throw new $c_s_MatchError(x1);
    }
    var l$2 = $as_sci_NumericRange(x$1$1___1);
    var r$2 = $as_sci_NumericRange(x$1$1___2);
    var carry$2 = $uI(x$1$1___3);
    var leftLength = $p_sci_NumericRange__unsafeRangeLength$1__sci_NumericRange__O($thiz, l$2);
    var rightLength = $p_sci_NumericRange__unsafeRangeLength$1__sci_NumericRange__O($thiz, r$2);
    if (($p_sci_NumericRange__fitsInInteger$1__O__Z($thiz, leftLength) && $p_sci_NumericRange__fitsInInteger$1__O__Z($thiz, rightLength))) {
      return (((((n - $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).toInt__O__I(leftLength)) | 0) - carry$2) | 0) >= $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).toInt__O__I(rightLength));
    } else {
      var this$20 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
      var x$7 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).minus__O__O__O($n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).minus__O__O__O($n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).fromInt__I__O(n), leftLength), $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).fromInt__I__O(carry$2));
      return $f_s_math_Ordering__gteq__O__O__Z(this$20, x$7, rightLength);
    }
  }
}
function $p_sci_NumericRange__newEmptyRange__O__sci_NumericRange$Exclusive($thiz, value) {
  $m_sci_NumericRange$();
  var step = $thiz.sci_NumericRange__f_step;
  var num = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
  return new $c_sci_NumericRange$Exclusive(value, value, step, num);
}
function $p_sci_NumericRange__hashCode$lzycompute__I($thiz) {
  if (((((4 & $thiz.sci_NumericRange__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.sci_NumericRange__f_hashCode = $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I($thiz);
    $thiz.sci_NumericRange__f_bitmap$0 = (((4 | $thiz.sci_NumericRange__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.sci_NumericRange__f_hashCode;
}
function $p_sci_NumericRange__unsafeRangeLength$1__sci_NumericRange__O($thiz, r) {
  var diff = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).minus__O__O__O($n(r).sci_NumericRange__f_end, $n(r).sci_NumericRange__f_start);
  var quotient = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).quot__O__O__O(diff, $n(r).sci_NumericRange__f_step);
  var remainder = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).rem__O__O__O(diff, $n(r).sci_NumericRange__f_step);
  if ((!$n(r).sci_NumericRange__f_isInclusive)) {
    var this$2 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var this$1 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var y = this$1.fromInt__I__O(0);
    var $x_1 = $f_s_math_Ordering__equiv__O__O__Z(this$2, remainder, y);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var this$4 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var this$3 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var y$1 = this$3.fromInt__I__O(0);
    return $f_s_math_Ordering__max__O__O__O(this$4, quotient, y$1);
  } else {
    var this$7 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var $x_2 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var this$5 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var x = $n($x_2).plus__O__O__O(quotient, this$5.fromInt__I__O(1));
    var this$6 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var y$2 = this$6.fromInt__I__O(0);
    return $f_s_math_Ordering__max__O__O__O(this$7, x, y$2);
  }
}
function $p_sci_NumericRange__fitsInInteger$1__O__Z($thiz, value) {
  var this$1 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
  var x = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).fromInt__I__O($n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).toInt__O__I(value));
  return $f_s_math_Ordering__equiv__O__O__Z(this$1, x, value);
}
function $ct_sci_NumericRange__O__O__O__Z__s_math_Integral__($thiz, start, end, step, isInclusive, num) {
  $thiz.sci_NumericRange__f_start = start;
  $thiz.sci_NumericRange__f_end = end;
  $thiz.sci_NumericRange__f_step = step;
  $thiz.sci_NumericRange__f_isInclusive = isInclusive;
  $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num = num;
  return $thiz;
}
/** @constructor */
function $c_sci_NumericRange() {
  this.sci_NumericRange__f_length = 0;
  this.sci_NumericRange__f_isEmpty = false;
  this.sci_NumericRange__f_hashCode = 0;
  this.sci_NumericRange__f_start = null;
  this.sci_NumericRange__f_end = null;
  this.sci_NumericRange__f_step = null;
  this.sci_NumericRange__f_isInclusive = false;
  this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num = null;
  this.sci_NumericRange__f_bitmap$0 = 0;
}
$c_sci_NumericRange.prototype = new $h_sci_AbstractSeq();
$c_sci_NumericRange.prototype.constructor = $c_sci_NumericRange;
/** @constructor */
function $h_sci_NumericRange() {
}
$h_sci_NumericRange.prototype = $c_sci_NumericRange.prototype;
$c_sci_NumericRange.prototype.distinctBy__F1__O = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$c_sci_NumericRange.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$c_sci_NumericRange.prototype.prepended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__prepended__O__O(this, elem);
});
$c_sci_NumericRange.prototype.appended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$c_sci_NumericRange.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$c_sci_NumericRange.prototype.prependedAll__sc_IterableOnce__O = (function(prefix) {
  return $f_sc_StrictOptimizedSeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$c_sci_NumericRange.prototype.padTo__I__O__O = (function(len, elem) {
  return $f_sc_StrictOptimizedSeqOps__padTo__I__O__O(this, len, elem);
});
$c_sci_NumericRange.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_sci_NumericRange.prototype.span__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__span__F1__T2(this, p);
});
$c_sci_NumericRange.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_NumericRange.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_NumericRange.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_NumericRange.prototype.flatten__F1__O = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$c_sci_NumericRange.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_sci_NumericRange.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$c_sci_NumericRange.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_sci_NumericRange.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$c_sci_NumericRange.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_NumericRange.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this;
});
$c_sci_NumericRange.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$c_sci_NumericRange.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o);
});
$c_sci_NumericRange.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_IndexedSeq$();
});
$c_sci_NumericRange.prototype.stringPrefix__T = (function() {
  return "IndexedSeq";
});
$c_sci_NumericRange.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_sci_NumericRange.prototype.view__sc_IndexedSeqView = (function() {
  return new $c_sc_IndexedSeqView$Id(this);
});
$c_sci_NumericRange.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sci_NumericRange.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sci_NumericRange.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sci_NumericRange.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sci_NumericRange.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_NumericRange$NumericRangeIterator(this, this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
});
$c_sci_NumericRange.prototype.length__I = (function() {
  return (((((1 & this.sci_NumericRange__f_bitmap$0) << 24) >> 24) === 0) ? $p_sci_NumericRange__length$lzycompute__I(this) : this.sci_NumericRange__f_length);
});
$c_sci_NumericRange.prototype.isEmpty__Z = (function() {
  return (((((2 & this.sci_NumericRange__f_bitmap$0) << 24) >> 24) === 0) ? $p_sci_NumericRange__isEmpty$lzycompute__Z(this) : this.sci_NumericRange__f_isEmpty);
});
$c_sci_NumericRange.prototype.last__O = (function() {
  return (this.isEmpty__Z() ? $m_sci_Nil$().head__E() : $p_sci_NumericRange__locationAfterN__I__O(this, (((-1) + this.length__I()) | 0)));
});
$c_sci_NumericRange.prototype.init__sci_NumericRange = (function() {
  if (this.isEmpty__Z()) {
    $m_sci_Nil$().init__E();
  } else {
    var $x_1 = this.sci_NumericRange__f_start;
    var this$1 = $n(this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var lhs = this.sci_NumericRange__f_end;
    return $ct_sci_NumericRange__O__O__O__Z__s_math_Integral__(new $c_sci_NumericRange(), $x_1, new $c_s_math_Integral$IntegralOps(this$1, lhs).$minus__O__O(this.sci_NumericRange__f_step), this.sci_NumericRange__f_step, this.sci_NumericRange__f_isInclusive, this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
  }
});
$c_sci_NumericRange.prototype.head__O = (function() {
  return (this.isEmpty__Z() ? $m_sci_Nil$().head__E() : this.sci_NumericRange__f_start);
});
$c_sci_NumericRange.prototype.tail__sci_NumericRange = (function() {
  if (this.isEmpty__Z()) {
    $m_sci_Nil$().tail__E();
  } else if (this.sci_NumericRange__f_isInclusive) {
    var this$1 = $n(this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var lhs = this.sci_NumericRange__f_start;
    return new $c_sci_NumericRange$Inclusive(new $c_s_math_Integral$IntegralOps(this$1, lhs).$plus__O__O(this.sci_NumericRange__f_step), this.sci_NumericRange__f_end, this.sci_NumericRange__f_step, this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
  } else {
    var this$2 = $n(this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var lhs$1 = this.sci_NumericRange__f_start;
    return new $c_sci_NumericRange$Exclusive(new $c_s_math_Integral$IntegralOps(this$2, lhs$1).$plus__O__O(this.sci_NumericRange__f_step), this.sci_NumericRange__f_end, this.sci_NumericRange__f_step, this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
  }
});
$c_sci_NumericRange.prototype.copy__O__O__O__sci_NumericRange = (function(start, end, step) {
  return $ct_sci_NumericRange__O__O__O__Z__s_math_Integral__(new $c_sci_NumericRange(), start, end, step, this.sci_NumericRange__f_isInclusive, this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
});
$c_sci_NumericRange.prototype.apply__I__O = (function(idx) {
  if (((idx < 0) || (idx >= this.length__I()))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((idx + " is out of bounds (min 0, max ") + (((-1) + this.length__I()) | 0)) + ")"));
  } else {
    return $p_sci_NumericRange__locationAfterN__I__O(this, idx);
  }
});
$c_sci_NumericRange.prototype.foreach__F1__V = (function(f) {
  var count = 0;
  var current = this.sci_NumericRange__f_start;
  while ((count < this.length__I())) {
    $n(f).apply__O__O(current);
    var this$1 = $n(this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var lhs = current;
    current = new $c_s_math_Integral$IntegralOps(this$1, lhs).$plus__O__O(this.sci_NumericRange__f_step);
    count = ((1 + count) | 0);
  }
});
$c_sci_NumericRange.prototype.take__I__sci_NumericRange = (function(n) {
  return (((n <= 0) || this.isEmpty__Z()) ? $p_sci_NumericRange__newEmptyRange__O__sci_NumericRange$Exclusive(this, this.sci_NumericRange__f_start) : ($p_sci_NumericRange__crossesTheEndAfterN__I__Z(this, n) ? this : new $c_sci_NumericRange$Inclusive(this.sci_NumericRange__f_start, $p_sci_NumericRange__locationAfterN__I__O(this, (((-1) + n) | 0)), this.sci_NumericRange__f_step, this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num)));
});
$c_sci_NumericRange.prototype.drop__I__sci_NumericRange = (function(n) {
  return (((n <= 0) || this.isEmpty__Z()) ? this : ($p_sci_NumericRange__crossesTheEndAfterN__I__Z(this, n) ? $p_sci_NumericRange__newEmptyRange__O__sci_NumericRange$Exclusive(this, this.sci_NumericRange__f_end) : this.copy__O__O__O__sci_NumericRange($p_sci_NumericRange__locationAfterN__I__O(this, n), this.sci_NumericRange__f_end, this.sci_NumericRange__f_step)));
});
$c_sci_NumericRange.prototype.splitAt__I__T2 = (function(n) {
  return new $c_T2(this.take__I__sci_NumericRange(n), this.drop__I__sci_NumericRange(n));
});
$c_sci_NumericRange.prototype.reverse__sci_NumericRange = (function() {
  if (this.isEmpty__Z()) {
    return this;
  } else {
    var this$1 = $n(this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var lhs = this.sci_NumericRange__f_step;
    var newStep = new $c_s_math_Integral$IntegralOps(this$1, lhs).unary_$minus__O();
    if ($m_sr_BoxesRunTime$().equals__O__O__Z($n(this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).sign__O__O(newStep), $n(this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).sign__O__O(this.sci_NumericRange__f_step))) {
      throw new $c_jl_ArithmeticException("number type is unsigned, and .reverse requires a negative step");
    } else {
      return new $c_sci_NumericRange$Inclusive(this.last__O(), this.sci_NumericRange__f_start, newStep, this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    }
  }
});
$c_sci_NumericRange.prototype.max__s_math_Ordering__O = (function(ord) {
  if ((ord === this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num)) {
    var $x_1 = true;
  } else {
    var this$1 = $n($n($m_sci_NumericRange$().sci_NumericRange$__f_defaultOrdering).get__O__s_Option(this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num));
    if ((!this$1.isEmpty__Z())) {
      var arg1 = this$1.get__O();
      var x$3 = $as_s_math_Ordering(arg1);
      var $x_1 = (ord === x$3);
    } else {
      var $x_1 = false;
    }
  }
  if ($x_1) {
    var this$2 = $n(this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var lhs = $n(this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).sign__O__O(this.sci_NumericRange__f_step);
    var $x_2 = new $c_s_math_Ordering$OrderingOps(this$2, lhs);
    var this$3 = $n(this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    if ($x_2.$greater__O__Z(this$3.fromInt__I__O(0))) {
      return this.last__O();
    } else {
      return this.head__O();
    }
  } else {
    return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
  }
});
$c_sci_NumericRange.prototype.hashCode__I = (function() {
  return (((((4 & this.sci_NumericRange__f_bitmap$0) << 24) >> 24) === 0) ? $p_sci_NumericRange__hashCode$lzycompute__I(this) : this.sci_NumericRange__f_hashCode);
});
$c_sci_NumericRange.prototype.applyPreferredMaxLength__I = (function() {
  return 2147483647;
});
$c_sci_NumericRange.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_sci_NumericRange)) {
    var x2 = $as_sci_NumericRange(other);
    var this$1 = $n(x2);
    if (($f_sci_IndexedSeq__canEqual__O__Z(this$1, this) && (this.length__I() === $n(x2).length__I()))) {
      return (this.isEmpty__Z() || ($m_sr_BoxesRunTime$().equals__O__O__Z(this.sci_NumericRange__f_start, $n(x2).sci_NumericRange__f_start) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.last__O(), $n(x2).last__O())));
    } else {
      return false;
    }
  } else {
    return $f_sc_Seq__equals__O__Z(this, other);
  }
});
$c_sci_NumericRange.prototype.toString__T = (function() {
  var empty = (this.isEmpty__Z() ? "empty " : "");
  var preposition = (this.sci_NumericRange__f_isInclusive ? "to" : "until");
  var stepped = ($m_sr_BoxesRunTime$().equals__O__O__Z(this.sci_NumericRange__f_step, 1) ? "" : (" by " + this.sci_NumericRange__f_step));
  return (((((((empty + "NumericRange ") + this.sci_NumericRange__f_start) + " ") + preposition) + " ") + this.sci_NumericRange__f_end) + stepped);
});
$c_sci_NumericRange.prototype.className__T = (function() {
  return "NumericRange";
});
$c_sci_NumericRange.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_IndexedSeq$();
});
$c_sci_NumericRange.prototype.reverse__O = (function() {
  return this.reverse__sci_NumericRange();
});
$c_sci_NumericRange.prototype.drop__I__O = (function(n) {
  return this.drop__I__sci_NumericRange(n);
});
$c_sci_NumericRange.prototype.take__I__O = (function(n) {
  return this.take__I__sci_NumericRange(n);
});
$c_sci_NumericRange.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1));
});
$c_sci_NumericRange.prototype.tail__O = (function() {
  return this.tail__sci_NumericRange();
});
$c_sci_NumericRange.prototype.init__O = (function() {
  return this.init__sci_NumericRange();
});
function $as_sci_NumericRange(obj) {
  return (((obj instanceof $c_sci_NumericRange) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.NumericRange"));
}
function $isArrayOf_sci_NumericRange(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_NumericRange)));
}
function $asArrayOf_sci_NumericRange(obj, depth) {
  return (($isArrayOf_sci_NumericRange(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.NumericRange;", depth));
}
var $d_sci_NumericRange = new $TypeData().initClass($c_sci_NumericRange, "scala.collection.immutable.NumericRange", ({
  sci_NumericRange: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
function $as_sci_Range(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Range"));
}
function $isArrayOf_sci_Range(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Range)));
}
function $asArrayOf_sci_Range(obj, depth) {
  return (($isArrayOf_sci_Range(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Range;", depth));
}
function $as_scm_LinkedHashSet(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.LinkedHashSet"));
}
function $isArrayOf_scm_LinkedHashSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_LinkedHashSet)));
}
function $asArrayOf_scm_LinkedHashSet(obj, depth) {
  return (($isArrayOf_scm_LinkedHashSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.LinkedHashSet;", depth));
}
/** @constructor */
function $c_scm_Map$WithDefault(underlying, defaultValue) {
  this.scm_Map$WithDefault__f_underlying = null;
  this.scm_Map$WithDefault__f_defaultValue = null;
  this.scm_Map$WithDefault__f_underlying = underlying;
  this.scm_Map$WithDefault__f_defaultValue = defaultValue;
}
$c_scm_Map$WithDefault.prototype = new $h_scm_AbstractMap();
$c_scm_Map$WithDefault.prototype.constructor = $c_scm_Map$WithDefault;
/** @constructor */
function $h_scm_Map$WithDefault() {
}
$h_scm_Map$WithDefault.prototype = $c_scm_Map$WithDefault.prototype;
$c_scm_Map$WithDefault.prototype.default__O__O = (function(key) {
  return $n(this.scm_Map$WithDefault__f_defaultValue).apply__O__O(key);
});
$c_scm_Map$WithDefault.prototype.iterator__sc_Iterator = (function() {
  return $n(this.scm_Map$WithDefault__f_underlying).iterator__sc_Iterator();
});
$c_scm_Map$WithDefault.prototype.isEmpty__Z = (function() {
  return $n(this.scm_Map$WithDefault__f_underlying).isEmpty__Z();
});
$c_scm_Map$WithDefault.prototype.knownSize__I = (function() {
  return $n(this.scm_Map$WithDefault__f_underlying).knownSize__I();
});
$c_scm_Map$WithDefault.prototype.mapFactory__sc_MapFactory = (function() {
  return $n(this.scm_Map$WithDefault__f_underlying).mapFactory__sc_MapFactory();
});
$c_scm_Map$WithDefault.prototype.get__O__s_Option = (function(key) {
  return $n(this.scm_Map$WithDefault__f_underlying).get__O__s_Option(key);
});
$c_scm_Map$WithDefault.prototype.subtractOne__O__scm_Map$WithDefault = (function(elem) {
  $n(this.scm_Map$WithDefault__f_underlying).subtractOne__O__scm_Shrinkable(elem);
  return this;
});
$c_scm_Map$WithDefault.prototype.addOne__T2__scm_Map$WithDefault = (function(elem) {
  $n(this.scm_Map$WithDefault__f_underlying).addOne__O__scm_Growable(elem);
  return this;
});
$c_scm_Map$WithDefault.prototype.concat__sc_IterableOnce__scm_Map = (function(suffix) {
  var this$1 = $n($as_scm_Map($n(this.scm_Map$WithDefault__f_underlying).concat__sc_IterableOnce__sc_IterableOps(suffix)));
  var d = this.scm_Map$WithDefault__f_defaultValue;
  return new $c_scm_Map$WithDefault(this$1, d);
});
$c_scm_Map$WithDefault.prototype.empty__scm_Map$WithDefault = (function() {
  return new $c_scm_Map$WithDefault($as_scm_Map($n(this.scm_Map$WithDefault__f_underlying).empty__sc_IterableOps()), this.scm_Map$WithDefault__f_defaultValue);
});
$c_scm_Map$WithDefault.prototype.fromSpecific__sc_IterableOnce__scm_Map$WithDefault = (function(coll) {
  return new $c_scm_Map$WithDefault($as_scm_Map($n($n(this.scm_Map$WithDefault__f_underlying).mapFactory__sc_MapFactory()).from__sc_IterableOnce__O(coll)), this.scm_Map$WithDefault__f_defaultValue);
});
$c_scm_Map$WithDefault.prototype.newSpecificBuilder__scm_Builder = (function() {
  var this$2 = $n($m_scm_Map$().newBuilder__scm_Builder());
  var f = new $c_sjsr_AnonFunction1(((p$2) => {
    var p = $as_scm_Map(p$2);
    return new $c_scm_Map$WithDefault(p, this.scm_Map$WithDefault__f_defaultValue);
  }));
  return new $c_scm_Builder$$anon$1(this$2, f);
});
$c_scm_Map$WithDefault.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__scm_Map$WithDefault(coll);
});
$c_scm_Map$WithDefault.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__scm_Map$WithDefault(coll);
});
$c_scm_Map$WithDefault.prototype.empty__sc_IterableOps = (function() {
  return this.empty__scm_Map$WithDefault();
});
$c_scm_Map$WithDefault.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return this.concat__sc_IterableOnce__scm_Map(suffix);
});
$c_scm_Map$WithDefault.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__scm_Map$WithDefault($as_T2(elem));
});
$c_scm_Map$WithDefault.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_Map$WithDefault(elem);
});
var $d_scm_Map$WithDefault = new $TypeData().initClass($c_scm_Map$WithDefault, "scala.collection.mutable.Map$WithDefault", ({
  scm_Map$WithDefault: 1,
  scm_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  scm_Map: 1,
  scm_Iterable: 1,
  scm_MapOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  Ljava_io_Serializable: 1
}));
function $p_sci_ArraySeq__appendedAllArraySeq__sci_ArraySeq__sci_ArraySeq($thiz, that) {
  if ($f_sc_SeqOps__isEmpty__Z($thiz)) {
    return that;
  } else {
    var this$1 = $n(that);
    if ($f_sc_SeqOps__isEmpty__Z(this$1)) {
      return $thiz;
    } else {
      var thisIsObj = ($thiz.unsafeArray__O() instanceof $ac_O);
      var thatIsObj = ($n(that).unsafeArray__O() instanceof $ac_O);
      var mismatch = (thisIsObj !== thatIsObj);
      if (mismatch) {
        return null;
      } else if (thisIsObj) {
        var ax = $thiz.unsafeArray__O();
        var ay = $n(that).unsafeArray__O();
        var len = (($m_jl_reflect_Array$().getLength__O__I(ax) + $m_jl_reflect_Array$().getLength__O__I(ay)) | 0);
        var a = new $ac_O(len);
        var length = $m_jl_reflect_Array$().getLength__O__I(ax);
        $systemArraycopyFull($n(ax), 0, a, 0, length);
        var destPos = $m_jl_reflect_Array$().getLength__O__I(ax);
        var length$1 = $m_jl_reflect_Array$().getLength__O__I(ay);
        $systemArraycopyFull($n(ay), 0, a, destPos, length$1);
        return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(a);
      } else {
        var ax$2 = $thiz.unsafeArray__O();
        var ay$2 = $n(that).unsafeArray__O();
        var len$2 = (($m_jl_reflect_Array$().getLength__O__I(ax$2) + $m_jl_reflect_Array$().getLength__O__I(ay$2)) | 0);
        var a$2 = $n($thiz.elemTag__s_reflect_ClassTag()).newArray__I__O(len$2);
        var length$2 = $m_jl_reflect_Array$().getLength__O__I(ax$2);
        $systemArraycopyFull($n(ax$2), 0, $n(a$2), 0, length$2);
        var destPos$1 = $m_jl_reflect_Array$().getLength__O__I(ax$2);
        var length$3 = $m_jl_reflect_Array$().getLength__O__I(ay$2);
        $systemArraycopyFull($n(ay$2), 0, $n(a$2), destPos$1, length$3);
        return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(a$2);
      }
    }
  }
}
function $p_sci_ArraySeq__genericResult$1__sc_IterableOnce__sci_ArraySeq($thiz, suffix$1) {
  var k = $n(suffix$1).knownSize__I();
  if ((k === 0)) {
    return $thiz;
  } else {
    var capacity = 0;
    var jsElems = null;
    capacity = 0;
    jsElems = [];
    if ((k >= 0)) {
      var xs = $thiz.unsafeArray__O();
      $m_jl_reflect_Array$().getLength__O__I(xs);
    }
    var xs$1 = $thiz.unsafeArray__O();
    var length = $m_jl_reflect_Array$().getLength__O__I(xs$1);
    var i = 0;
    while ((i < length)) {
      var elem = $m_sr_ScalaRunTime$().array_apply__O__I__O(xs$1, i);
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
      i = ((1 + i) | 0);
    }
    var it = $n(suffix$1).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var elem$1 = $n(it).next__O();
      var unboxedElem$1 = ((elem$1 === null) ? null : elem$1);
      jsElems.push(unboxedElem$1);
    }
    return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(new $ac_O(jsElems));
  }
}
function $p_sci_ArraySeq__genericResult$2__sc_IterableOnce__sci_ArraySeq($thiz, prefix$1) {
  var k = $n(prefix$1).knownSize__I();
  if ((k === 0)) {
    return $thiz;
  } else {
    var capacity = 0;
    var jsElems = null;
    capacity = 0;
    jsElems = [];
    if ((k >= 0)) {
      var xs = $thiz.unsafeArray__O();
      $m_jl_reflect_Array$().getLength__O__I(xs);
    }
    var it = $n(prefix$1).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var elem = $n(it).next__O();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    if ((k < 0)) {
      $uI(jsElems.length);
      var xs$1 = $thiz.unsafeArray__O();
      $m_jl_reflect_Array$().getLength__O__I(xs$1);
    }
    var xs$2 = $thiz.unsafeArray__O();
    var length = $m_jl_reflect_Array$().getLength__O__I(xs$2);
    var i = 0;
    while ((i < length)) {
      var elem$1 = $m_sr_ScalaRunTime$().array_apply__O__I__O(xs$2, i);
      var unboxedElem$1 = ((elem$1 === null) ? null : elem$1);
      jsElems.push(unboxedElem$1);
      i = ((1 + i) | 0);
    }
    return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(new $ac_O(jsElems));
  }
}
/** @constructor */
function $c_sci_ArraySeq() {
}
$c_sci_ArraySeq.prototype = new $h_sci_AbstractSeq();
$c_sci_ArraySeq.prototype.constructor = $c_sci_ArraySeq;
/** @constructor */
function $h_sci_ArraySeq() {
}
$h_sci_ArraySeq.prototype = $c_sci_ArraySeq.prototype;
$c_sci_ArraySeq.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  var this$1 = $m_sci_ArraySeq$();
  var evidence$5 = this.elemTag__s_reflect_ClassTag();
  return this$1.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq(coll, evidence$5);
});
$c_sci_ArraySeq.prototype.newSpecificBuilder__scm_Builder = (function() {
  var this$1 = $m_sci_ArraySeq$();
  var evidence$12 = this.elemTag__s_reflect_ClassTag();
  return this$1.newBuilder__s_reflect_ClassTag__scm_Builder(evidence$12);
});
$c_sci_ArraySeq.prototype.empty__sc_IterableOps = (function() {
  var this$1 = $m_sci_ArraySeq$();
  this.elemTag__s_reflect_ClassTag();
  return $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef(this$1);
});
$c_sci_ArraySeq.prototype.distinctBy__F1__O = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$c_sci_ArraySeq.prototype.padTo__I__O__O = (function(len, elem) {
  return $f_sc_StrictOptimizedSeqOps__padTo__I__O__O(this, len, elem);
});
$c_sci_ArraySeq.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_sci_ArraySeq.prototype.span__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__span__F1__T2(this, p);
});
$c_sci_ArraySeq.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_ArraySeq.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_ArraySeq.prototype.flatten__F1__O = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$c_sci_ArraySeq.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$c_sci_ArraySeq.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_sci_ArraySeq.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$c_sci_ArraySeq.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this;
});
$c_sci_ArraySeq.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$c_sci_ArraySeq.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o);
});
$c_sci_ArraySeq.prototype.stringPrefix__T = (function() {
  return "IndexedSeq";
});
$c_sci_ArraySeq.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_sci_ArraySeq.prototype.view__sc_IndexedSeqView = (function() {
  return new $c_sc_IndexedSeqView$Id(this);
});
$c_sci_ArraySeq.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sci_ArraySeq.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sci_ArraySeq.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sci_ArraySeq.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sci_ArraySeq.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sci_ArraySeq.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sci_ArraySeq.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_ArraySeq$().sci_ArraySeq$__f_untagged;
});
$c_sci_ArraySeq.prototype.map__F1__sci_ArraySeq = (function(f) {
  var a = new $ac_O(this.length__I());
  var i = 0;
  while ((i < $n(a).u.length)) {
    $n(a).set(i, $n(f).apply__O__O(this.apply__I__O(i)));
    i = ((1 + i) | 0);
  }
  return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(a);
});
$c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  var $x_1 = $m_sci_ArraySeq$();
  var xs = this.unsafeArray__O();
  var len = ((1 + $m_jl_reflect_Array$().getLength__O__I(xs)) | 0);
  var dest = new $ac_O(len);
  dest.set(0, elem);
  $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, $m_jl_reflect_Array$().getLength__O__I(xs));
  return $n($x_1).unsafeWrapArray__O__sci_ArraySeq(dest);
});
$c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq = (function(elem) {
  var $x_1 = $m_sci_ArraySeq$();
  var xs = this.unsafeArray__O();
  var this$4 = $m_s_Array$();
  var newLength = ((1 + $m_jl_reflect_Array$().getLength__O__I(xs)) | 0);
  var this$5 = $n(xs);
  if ($d_O.getClassOf().isAssignableFrom__jl_Class__Z($n($objectGetClass(this$5)).getComponentType__jl_Class())) {
    if ($d_O.getClassOf().isPrimitive__Z()) {
      var dest$1 = this$4.copyOf__O__I__O(xs, newLength);
    } else {
      var original = $asArrayOf_O(xs, 1);
      var dest$1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original, newLength, $d_O.getArrayOf().getClassOf());
    }
  } else {
    var dest = new $ac_O(newLength);
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, $m_jl_reflect_Array$().getLength__O__I(xs));
    var dest$1 = dest;
  }
  $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, $m_jl_reflect_Array$().getLength__O__I(xs), elem);
  return $n($x_1).unsafeWrapArray__O__sci_ArraySeq(dest$1);
});
$c_sci_ArraySeq.prototype.appendedAll__sc_IterableOnce__sci_ArraySeq = (function(suffix) {
  if ((suffix instanceof $c_sci_ArraySeq)) {
    var x2 = $as_sci_ArraySeq(suffix);
    var result = $p_sci_ArraySeq__appendedAllArraySeq__sci_ArraySeq__sci_ArraySeq(this, x2);
    return ((result === null) ? $p_sci_ArraySeq__genericResult$1__sc_IterableOnce__sci_ArraySeq(this, suffix) : result);
  } else {
    return $p_sci_ArraySeq__genericResult$1__sc_IterableOnce__sci_ArraySeq(this, suffix);
  }
});
$c_sci_ArraySeq.prototype.prependedAll__sc_IterableOnce__sci_ArraySeq = (function(prefix) {
  if ((prefix instanceof $c_sci_ArraySeq)) {
    var x2 = $as_sci_ArraySeq(prefix);
    var result = $p_sci_ArraySeq__appendedAllArraySeq__sci_ArraySeq__sci_ArraySeq($n(x2), this);
    return ((result === null) ? $p_sci_ArraySeq__genericResult$2__sc_IterableOnce__sci_ArraySeq(this, prefix) : result);
  } else {
    return $p_sci_ArraySeq__genericResult$2__sc_IterableOnce__sci_ArraySeq(this, prefix);
  }
});
$c_sci_ArraySeq.prototype.zip__sc_IterableOnce__sci_ArraySeq = (function(that) {
  if ((that instanceof $c_sci_ArraySeq)) {
    var x2 = $as_sci_ArraySeq(that);
    var x = this.length__I();
    var that$1 = $n(x2).length__I();
    var n = ((x < that$1) ? x : that$1);
    var n1 = ((n > 0) ? n : 0);
    var elements = new ($d_T2.getArrayOf().constr)(n1);
    var i = 0;
    while ((i < n)) {
      var $x_1 = i;
      var arg1 = i;
      elements.set($x_1, new $c_T2(this.apply__I__O(arg1), $n(x2).apply__I__O(arg1)));
      i = ((1 + i) | 0);
    }
    return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(elements);
  } else {
    var b = $n($m_sci_ArraySeq$().sci_ArraySeq$__f_untagged).newBuilder__scm_Builder();
    var it1 = this.iterator__sc_Iterator();
    var it2 = $n(that).iterator__sc_Iterator();
    while (($n(it1).hasNext__Z() && $n(it2).hasNext__Z())) {
      var this$10 = $n(b);
      var elem = new $c_T2($n(it1).next__O(), $n(it2).next__O());
      this$10.addOne__O__scm_Growable(elem);
    }
    return $as_sci_ArraySeq($n(b).result__O());
  }
});
$c_sci_ArraySeq.prototype.take__I__sci_ArraySeq = (function(n) {
  var xs = this.unsafeArray__O();
  if (($m_jl_reflect_Array$().getLength__O__I(xs) <= n)) {
    return this;
  } else {
    var $x_1 = $m_sci_ArraySeq$();
    var this$ = this.unsafeArray__O();
    return $n($x_1).unsafeWrapArray__O__sci_ArraySeq($m_sc_ArrayOps$().slice$extension__O__I__I__O(this$, 0, n));
  }
});
$c_sci_ArraySeq.prototype.drop__I__sci_ArraySeq = (function(n) {
  return ((n <= 0) ? this : $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq($m_sc_ArrayOps$().drop$extension__O__I__O(this.unsafeArray__O(), n)));
});
$c_sci_ArraySeq.prototype.dropRight__I__sci_ArraySeq = (function(n) {
  return ((n <= 0) ? this : $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq($m_sc_ArrayOps$().dropRight$extension__O__I__O(this.unsafeArray__O(), n)));
});
$c_sci_ArraySeq.prototype.foldLeft__O__F2__O = (function(z, f) {
  var array = this.unsafeArray__O();
  var b = z;
  var i = 0;
  while ((i < $m_jl_reflect_Array$().getLength__O__I(array))) {
    var a = $m_sr_ScalaRunTime$().array_apply__O__I__O(array, i);
    b = $n(f).apply__O__O__O(b, a);
    i = ((1 + i) | 0);
  }
  return b;
});
$c_sci_ArraySeq.prototype.tail__sci_ArraySeq = (function() {
  return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq($m_sc_ArrayOps$().tail$extension__O__O(this.unsafeArray__O()));
});
$c_sci_ArraySeq.prototype.reverse__sci_ArraySeq = (function() {
  var $x_2 = $m_sci_ArraySeq$();
  var this$ = this.unsafeArray__O();
  var len = $m_jl_reflect_Array$().getLength__O__I(this$);
  var $x_1 = $m_s_reflect_ClassTag$();
  var this$4 = $n(this$);
  var res = $n($n($x_1).apply__jl_Class__s_reflect_ClassTag($n($objectGetClass(this$4)).getComponentType__jl_Class())).newArray__I__O(len);
  var i = 0;
  while ((i < len)) {
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(res, (((-1) + ((len - i) | 0)) | 0), $m_sr_ScalaRunTime$().array_apply__O__I__O(this$, i));
    i = ((1 + i) | 0);
  }
  return $n($x_2).unsafeWrapArray__O__sci_ArraySeq(res);
});
$c_sci_ArraySeq.prototype.className__T = (function() {
  return "ArraySeq";
});
$c_sci_ArraySeq.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var srcLen = this.length__I();
  var destLen = $m_jl_reflect_Array$().getLength__O__I(xs);
  var x = ((len < srcLen) ? len : srcLen);
  var y = ((destLen - start) | 0);
  var x$1 = ((x < y) ? x : y);
  var copied = ((x$1 > 0) ? x$1 : 0);
  if ((copied > 0)) {
    $m_s_Array$().copy__O__I__O__I__I__V(this.unsafeArray__O(), 0, xs, start, copied);
  }
  return copied;
});
$c_sci_ArraySeq.prototype.applyPreferredMaxLength__I = (function() {
  return 2147483647;
});
$c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  var xs = this.unsafeArray__O();
  if (($m_jl_reflect_Array$().getLength__O__I(xs) <= 1)) {
    return this;
  } else {
    var this$2 = $m_s_Array$();
    var original = this.unsafeArray__O();
    var newLength = this.length__I();
    var this$3 = $n(original);
    if ($d_O.getClassOf().isAssignableFrom__jl_Class__Z($n($objectGetClass(this$3)).getComponentType__jl_Class())) {
      if ($d_O.getClassOf().isPrimitive__Z()) {
        var $x_1 = this$2.copyOf__O__I__O(original, newLength);
      } else {
        var original$1 = $asArrayOf_O(original, 1);
        var $x_1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original$1, newLength, $d_O.getArrayOf().getClassOf());
      }
    } else {
      var dest = new $ac_O(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(original, 0, dest, 0, $m_jl_reflect_Array$().getLength__O__I(original));
      var $x_1 = dest;
    }
    var a = $asArrayOf_O($x_1, 1);
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(a, ord);
    return new $c_sci_ArraySeq$ofRef(a);
  }
});
$c_sci_ArraySeq.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sci_ArraySeq$();
  var evidence$5 = this.elemTag__s_reflect_ClassTag();
  return this$1.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq(coll, evidence$5);
});
$c_sci_ArraySeq.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord);
});
$c_sci_ArraySeq.prototype.reverse__O = (function() {
  return this.reverse__sci_ArraySeq();
});
$c_sci_ArraySeq.prototype.tail__O = (function() {
  return this.tail__sci_ArraySeq();
});
$c_sci_ArraySeq.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sci_ArraySeq(n);
});
$c_sci_ArraySeq.prototype.drop__I__O = (function(n) {
  return this.drop__I__sci_ArraySeq(n);
});
$c_sci_ArraySeq.prototype.take__I__O = (function(n) {
  return this.take__I__sci_ArraySeq(n);
});
$c_sci_ArraySeq.prototype.zip__sc_IterableOnce__O = (function(that) {
  return this.zip__sc_IterableOnce__sci_ArraySeq(that);
});
$c_sci_ArraySeq.prototype.prependedAll__sc_IterableOnce__O = (function(prefix) {
  return this.prependedAll__sc_IterableOnce__sci_ArraySeq(prefix);
});
$c_sci_ArraySeq.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_ArraySeq(suffix);
});
$c_sci_ArraySeq.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_ArraySeq(f);
});
$c_sci_ArraySeq.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_ArraySeq$().sci_ArraySeq$__f_untagged;
});
function $as_sci_ArraySeq(obj) {
  return (((obj instanceof $c_sci_ArraySeq) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq"));
}
function $isArrayOf_sci_ArraySeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq)));
}
function $asArrayOf_sci_ArraySeq(obj, depth) {
  return (($isArrayOf_sci_ArraySeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq;", depth));
}
/** @constructor */
function $c_sci_NumericRange$Exclusive(start, end, step, num) {
  this.sci_NumericRange__f_length = 0;
  this.sci_NumericRange__f_isEmpty = false;
  this.sci_NumericRange__f_hashCode = 0;
  this.sci_NumericRange__f_start = null;
  this.sci_NumericRange__f_end = null;
  this.sci_NumericRange__f_step = null;
  this.sci_NumericRange__f_isInclusive = false;
  this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num = null;
  this.sci_NumericRange__f_bitmap$0 = 0;
  this.sci_NumericRange$Exclusive__f_num = null;
  this.sci_NumericRange$Exclusive__f_num = num;
  $ct_sci_NumericRange__O__O__O__Z__s_math_Integral__(this, start, end, step, false, num);
}
$c_sci_NumericRange$Exclusive.prototype = new $h_sci_NumericRange();
$c_sci_NumericRange$Exclusive.prototype.constructor = $c_sci_NumericRange$Exclusive;
/** @constructor */
function $h_sci_NumericRange$Exclusive() {
}
$h_sci_NumericRange$Exclusive.prototype = $c_sci_NumericRange$Exclusive.prototype;
$c_sci_NumericRange$Exclusive.prototype.copy__O__O__O__sci_NumericRange$Exclusive = (function(start, end, step) {
  $m_sci_NumericRange$();
  var num = this.sci_NumericRange$Exclusive__f_num;
  return new $c_sci_NumericRange$Exclusive(start, end, step, num);
});
$c_sci_NumericRange$Exclusive.prototype.copy__O__O__O__sci_NumericRange = (function(start, end, step) {
  return this.copy__O__O__O__sci_NumericRange$Exclusive(start, end, step);
});
var $d_sci_NumericRange$Exclusive = new $TypeData().initClass($c_sci_NumericRange$Exclusive, "scala.collection.immutable.NumericRange$Exclusive", ({
  sci_NumericRange$Exclusive: 1,
  sci_NumericRange: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_NumericRange$Inclusive(start, end, step, num) {
  this.sci_NumericRange__f_length = 0;
  this.sci_NumericRange__f_isEmpty = false;
  this.sci_NumericRange__f_hashCode = 0;
  this.sci_NumericRange__f_start = null;
  this.sci_NumericRange__f_end = null;
  this.sci_NumericRange__f_step = null;
  this.sci_NumericRange__f_isInclusive = false;
  this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num = null;
  this.sci_NumericRange__f_bitmap$0 = 0;
  this.sci_NumericRange$Inclusive__f_num = null;
  this.sci_NumericRange$Inclusive__f_num = num;
  $ct_sci_NumericRange__O__O__O__Z__s_math_Integral__(this, start, end, step, true, num);
}
$c_sci_NumericRange$Inclusive.prototype = new $h_sci_NumericRange();
$c_sci_NumericRange$Inclusive.prototype.constructor = $c_sci_NumericRange$Inclusive;
/** @constructor */
function $h_sci_NumericRange$Inclusive() {
}
$h_sci_NumericRange$Inclusive.prototype = $c_sci_NumericRange$Inclusive.prototype;
$c_sci_NumericRange$Inclusive.prototype.copy__O__O__O__sci_NumericRange$Inclusive = (function(start, end, step) {
  $m_sci_NumericRange$();
  var num = this.sci_NumericRange$Inclusive__f_num;
  return new $c_sci_NumericRange$Inclusive(start, end, step, num);
});
$c_sci_NumericRange$Inclusive.prototype.copy__O__O__O__sci_NumericRange = (function(start, end, step) {
  return this.copy__O__O__O__sci_NumericRange$Inclusive(start, end, step);
});
var $d_sci_NumericRange$Inclusive = new $TypeData().initClass($c_sci_NumericRange$Inclusive, "scala.collection.immutable.NumericRange$Inclusive", ({
  sci_NumericRange$Inclusive: 1,
  sci_NumericRange: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
function $ct_sci_Vector__AO__($thiz, prefix1) {
  $thiz.sci_Vector__f_prefix1 = prefix1;
  return $thiz;
}
/** @constructor */
function $c_sci_Vector() {
  this.sci_Vector__f_prefix1 = null;
}
$c_sci_Vector.prototype = new $h_sci_AbstractSeq();
$c_sci_Vector.prototype.constructor = $c_sci_Vector;
/** @constructor */
function $h_sci_Vector() {
}
$h_sci_Vector.prototype = $c_sci_Vector.prototype;
$c_sci_Vector.prototype.distinctBy__F1__O = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$c_sci_Vector.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$c_sci_Vector.prototype.padTo__I__O__O = (function(len, elem) {
  return $f_sc_StrictOptimizedSeqOps__padTo__I__O__O(this, len, elem);
});
$c_sci_Vector.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_sci_Vector.prototype.span__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__span__F1__T2(this, p);
});
$c_sci_Vector.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_Vector.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_Vector.prototype.flatten__F1__O = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$c_sci_Vector.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_sci_Vector.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$c_sci_Vector.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Vector(pred, false);
});
$c_sci_Vector.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Vector(pred, true);
});
$c_sci_Vector.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this;
});
$c_sci_Vector.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$c_sci_Vector.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o);
});
$c_sci_Vector.prototype.stringPrefix__T = (function() {
  return "IndexedSeq";
});
$c_sci_Vector.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_sci_Vector.prototype.view__sc_IndexedSeqView = (function() {
  return new $c_sc_IndexedSeqView$Id(this);
});
$c_sci_Vector.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sci_Vector.prototype.reverse__O = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this);
});
$c_sci_Vector.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sci_Vector.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sci_Vector.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sci_Vector.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_Vector$();
});
$c_sci_Vector.prototype.length__I = (function() {
  return ((this instanceof $c_sci_BigVector) ? $n($as_sci_BigVector(this)).sci_BigVector__f_length0 : $n(this.sci_Vector__f_prefix1).u.length);
});
$c_sci_Vector.prototype.iterator__sc_Iterator = (function() {
  return (($m_sci_Vector0$() === this) ? $m_sci_Vector$().sci_Vector$__f_scala$collection$immutable$Vector$$emptyIterator : new $c_sci_NewVectorIterator(this, this.length__I(), this.vectorSliceCount__I()));
});
$c_sci_Vector.prototype.filterImpl__F1__Z__sci_Vector = (function(pred, isFlipped) {
  var i = 0;
  var len = $n(this.sci_Vector__f_prefix1).u.length;
  while ((i !== len)) {
    if (($uZ($n(pred).apply__O__O($n(this.sci_Vector__f_prefix1).get(i))) === isFlipped)) {
      var bitmap = 0;
      var j = ((1 + i) | 0);
      while ((j < len)) {
        if (($uZ($n(pred).apply__O__O($n(this.sci_Vector__f_prefix1).get(j))) !== isFlipped)) {
          bitmap = (bitmap | (1 << j));
        }
        j = ((1 + j) | 0);
      }
      var $x_1 = i;
      var i$1 = bitmap;
      var newLen = (($x_1 + $m_jl_Integer$().bitCount__I__I(i$1)) | 0);
      if ((this instanceof $c_sci_BigVector)) {
        var b = new $c_sci_VectorBuilder();
        var k = 0;
        while ((k < i)) {
          b.addOne__O__sci_VectorBuilder($n(this.sci_Vector__f_prefix1).get(k));
          k = ((1 + k) | 0);
        }
        k = ((1 + i) | 0);
        while ((i !== newLen)) {
          if ((((1 << k) & bitmap) !== 0)) {
            b.addOne__O__sci_VectorBuilder($n(this.sci_Vector__f_prefix1).get(k));
            i = ((1 + i) | 0);
          }
          k = ((1 + k) | 0);
        }
        $n($as_sci_BigVector(this)).foreachRest__F1__V(new $c_sjsr_AnonFunction1(((pred, isFlipped, b) => ((v$2) => (($uZ($n(pred).apply__O__O(v$2)) !== isFlipped) ? b.addOne__O__sci_VectorBuilder(v$2) : (void 0))))(pred, isFlipped, b)));
        return b.result__sci_Vector();
      } else {
        if ((newLen === 0)) {
          return $m_sci_Vector0$();
        }
        var newData = new $ac_O(newLen);
        var src = this.sci_Vector__f_prefix1;
        var length = i;
        $systemArraycopyRefs($n(src), 0, newData, 0, length);
        var k$2 = ((1 + i) | 0);
        while ((i !== newLen)) {
          if ((((1 << k$2) & bitmap) !== 0)) {
            $n(newData).set(i, $n(this.sci_Vector__f_prefix1).get(k$2));
            i = ((1 + i) | 0);
          }
          k$2 = ((1 + k$2) | 0);
        }
        return new $c_sci_Vector1(newData);
      }
    }
    i = ((1 + i) | 0);
  }
  if ((this instanceof $c_sci_BigVector)) {
    var b$2 = new $c_sci_VectorBuilder();
    b$2.initFrom__AO__V(this.sci_Vector__f_prefix1);
    $n($as_sci_BigVector(this)).foreachRest__F1__V(new $c_sjsr_AnonFunction1(((v$3$2) => (($uZ($n(pred).apply__O__O(v$3$2)) !== isFlipped) ? b$2.addOne__O__sci_VectorBuilder(v$3$2) : (void 0)))));
    return b$2.result__sci_Vector();
  } else {
    return this;
  }
});
$c_sci_Vector.prototype.prependedAll__sc_IterableOnce__sci_Vector = (function(prefix) {
  var k = $n(prefix).knownSize__I();
  return ((k === 0) ? this : ((k < 0) ? $as_sci_Vector($f_sc_StrictOptimizedSeqOps__prependedAll__sc_IterableOnce__O(this, prefix)) : this.prependedAll0__sc_IterableOnce__I__sci_Vector(prefix, k)));
});
$c_sci_Vector.prototype.appendedAll__sc_IterableOnce__sci_Vector = (function(suffix) {
  var k = $n(suffix).knownSize__I();
  return ((k === 0) ? this : ((k < 0) ? $as_sci_Vector($f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)) : this.appendedAll0__sc_IterableOnce__I__sci_Vector(suffix, k)));
});
$c_sci_Vector.prototype.prependedAll0__sc_IterableOnce__I__sci_Vector = (function(prefix, k) {
  var tinyAppendLimit = ((4 + this.vectorSliceCount__I()) | 0);
  if ((k < tinyAppendLimit)) {
    var v = this;
    var this$1 = $n($m_sci_IndexedSeq$().from__sc_IterableOnce__sci_IndexedSeq(prefix));
    var it = $n(this$1.view__sc_IndexedSeqView()).reverseIterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var rassoc$1 = $n(it).next__O();
      var this$2 = $n(v);
      v = this$2.prepended__O__sci_Vector(rassoc$1);
    }
    return v;
  } else if (((this.length__I() < ((k >>> 5) | 0)) && (prefix instanceof $c_sci_Vector))) {
    var v$2 = $as_sci_Vector(prefix);
    var it$2 = this.iterator__sc_Iterator();
    while ($n(it$2).hasNext__Z()) {
      var this$3 = $n(v$2);
      var elem = $n(it$2).next__O();
      v$2 = $as_sci_Vector(this$3.appended__O__O(elem));
    }
    return v$2;
  } else {
    return ((k < (((-64) + this.length__I()) | 0)) ? $n($n($n(new $c_sci_VectorBuilder().alignTo__I__sci_Vector__sci_VectorBuilder(k, this)).addAll__sc_IterableOnce__sci_VectorBuilder(prefix)).addAll__sc_IterableOnce__sci_VectorBuilder(this)).result__sci_Vector() : $as_sci_Vector($f_sc_StrictOptimizedSeqOps__prependedAll__sc_IterableOnce__O(this, prefix)));
  }
});
$c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var tinyAppendLimit = ((4 + this.vectorSliceCount__I()) | 0);
  if ((k < tinyAppendLimit)) {
    var v = new $c_sr_ObjectRef(this);
    if ($is_sci_Iterable(suffix)) {
      var x2 = $as_sci_Iterable(suffix);
      $n(x2).foreach__F1__V(new $c_sjsr_AnonFunction1(((x$2) => {
        v.sr_ObjectRef__f_elem = $n($as_sci_Vector(v.sr_ObjectRef__f_elem)).appended__O__sci_Vector(x$2);
      })));
    } else {
      var this$3 = $n($n(suffix).iterator__sc_Iterator());
      while (this$3.hasNext__Z()) {
        var arg1 = this$3.next__O();
        v.sr_ObjectRef__f_elem = $n($as_sci_Vector(v.sr_ObjectRef__f_elem)).appended__O__sci_Vector(arg1);
      }
    }
    return $as_sci_Vector(v.sr_ObjectRef__f_elem);
  } else if (((this.length__I() < ((k >>> 5) | 0)) && (suffix instanceof $c_sci_Vector))) {
    var v$2 = $as_sci_Vector(suffix);
    var this$4 = new $c_sc_IndexedSeqView$Id(this);
    var ri = $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$4);
    while ((ri.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0)) {
      v$2 = $n(v$2).prepended__O__sci_Vector(ri.next__O());
    }
    return v$2;
  } else if (((this.length__I() < (((-64) + k) | 0)) && (suffix instanceof $c_sci_Vector))) {
    var v$3 = $as_sci_Vector(suffix);
    return $n($n($n(new $c_sci_VectorBuilder().alignTo__I__sci_Vector__sci_VectorBuilder(this.length__I(), v$3)).addAll__sc_IterableOnce__sci_VectorBuilder(this)).addAll__sc_IterableOnce__sci_VectorBuilder(v$3)).result__sci_Vector();
  } else {
    return $n($n(new $c_sci_VectorBuilder().initFrom__sci_Vector__sci_VectorBuilder(this)).addAll__sc_IterableOnce__sci_VectorBuilder(suffix)).result__sci_Vector();
  }
});
$c_sci_Vector.prototype.className__T = (function() {
  return "Vector";
});
$c_sci_Vector.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $n(this.iterator__sc_Iterator()).copyToArray__O__I__I__I(xs, start, len);
});
$c_sci_Vector.prototype.toVector__sci_Vector = (function() {
  return this;
});
$c_sci_Vector.prototype.applyPreferredMaxLength__I = (function() {
  return $m_sci_Vector$().sci_Vector$__f_scala$collection$immutable$Vector$$defaultApplyPreferredMaxLength;
});
$c_sci_Vector.prototype.ioob__I__jl_IndexOutOfBoundsException = (function(index) {
  return $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + (((-1) + this.length__I()) | 0)) + ")"));
});
$c_sci_Vector.prototype.head__O = (function() {
  if (($n(this.sci_Vector__f_prefix1).u.length === 0)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty.head");
  } else {
    return $n(this.sci_Vector__f_prefix1).get(0);
  }
});
$c_sci_Vector.prototype.last__O = (function() {
  if ((this instanceof $c_sci_BigVector)) {
    var suffix = $n($as_sci_BigVector(this)).sci_BigVector__f_suffix1;
    if (($n(suffix).u.length === 0)) {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty.tail");
    } else {
      return $n(suffix).get((((-1) + $n(suffix).u.length) | 0));
    }
  } else {
    return $n(this.sci_Vector__f_prefix1).get((((-1) + $n(this.sci_Vector__f_prefix1).u.length) | 0));
  }
});
$c_sci_Vector.prototype.foreach__F1__V = (function(f) {
  var c = this.vectorSliceCount__I();
  var i = 0;
  while ((i < c)) {
    var $x_1 = $m_sci_VectorStatics$();
    var idx = i;
    var c$1 = ((c / 2) | 0);
    var a = ((idx - c$1) | 0);
    $n($x_1).foreachRec__I__AO__F1__V((((-1) + ((((1 + c$1) | 0) - ((a < 0) ? ((-a) | 0) : a)) | 0)) | 0), this.vectorSlice__I__AO(i), f);
    i = ((1 + i) | 0);
  }
});
$c_sci_Vector.prototype.dropRight__I__O = (function(n) {
  var until = ((this.length__I() - ((n > 0) ? n : 0)) | 0);
  return this.slice__I__I__sci_Vector(0, until);
});
$c_sci_Vector.prototype.drop__I__O = (function(n) {
  var until = this.length__I();
  return this.slice__I__I__sci_Vector(n, until);
});
$c_sci_Vector.prototype.take__I__O = (function(n) {
  return this.slice__I__I__sci_Vector(0, n);
});
$c_sci_Vector.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_Vector(suffix);
});
$c_sci_Vector.prototype.prependedAll__sc_IterableOnce__O = (function(prefix) {
  return this.prependedAll__sc_IterableOnce__sci_Vector(prefix);
});
$c_sci_Vector.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Vector$();
});
function $as_sci_Vector(obj) {
  return (((obj instanceof $c_sci_Vector) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector"));
}
function $isArrayOf_sci_Vector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector)));
}
function $asArrayOf_sci_Vector(obj, depth) {
  return (($isArrayOf_sci_Vector(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector;", depth));
}
/** @constructor */
function $c_scm_ArraySeq() {
}
$c_scm_ArraySeq.prototype = new $h_scm_AbstractSeq();
$c_scm_ArraySeq.prototype.constructor = $c_scm_ArraySeq;
/** @constructor */
function $h_scm_ArraySeq() {
}
$h_scm_ArraySeq.prototype = $c_scm_ArraySeq.prototype;
$c_scm_ArraySeq.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$c_scm_ArraySeq.prototype.prepended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__prepended__O__O(this, elem);
});
$c_scm_ArraySeq.prototype.appended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$c_scm_ArraySeq.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$c_scm_ArraySeq.prototype.prependedAll__sc_IterableOnce__O = (function(prefix) {
  return $f_sc_StrictOptimizedSeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$c_scm_ArraySeq.prototype.padTo__I__O__O = (function(len, elem) {
  return $f_sc_StrictOptimizedSeqOps__padTo__I__O__O(this, len, elem);
});
$c_scm_ArraySeq.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_scm_ArraySeq.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_scm_ArraySeq.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_scm_ArraySeq.prototype.flatten__F1__O = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$c_scm_ArraySeq.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_scm_ArraySeq.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_scm_ArraySeq.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$c_scm_ArraySeq.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_scm_ArraySeq.prototype.stringPrefix__T = (function() {
  return "IndexedSeq";
});
$c_scm_ArraySeq.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_scm_ArraySeq.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_scm_ArraySeq.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n);
});
$c_scm_ArraySeq.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$c_scm_ArraySeq.prototype.reverse__O = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this);
});
$c_scm_ArraySeq.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_scm_ArraySeq.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_scm_ArraySeq.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_scm_ArraySeq.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_scm_ArraySeq.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_scm_ArraySeq.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_ArraySeq$().scm_ArraySeq$__f_untagged;
});
$c_scm_ArraySeq.prototype.fromSpecific__sc_IterableOnce__scm_ArraySeq = (function(coll) {
  var evidence$1 = this.elemTag__s_reflect_ClassTag();
  var capacity = 0;
  var jsElems = null;
  var elementClass = $n(evidence$1).runtimeClass__jl_Class();
  capacity = 0;
  var isCharArrayBuilder = (elementClass === $d_C.getClassOf());
  jsElems = [];
  $n(coll).knownSize__I();
  var it = $n(coll).iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $n(elementClass).jl_Class__f_data.zero : elem));
    jsElems.push(unboxedElem);
  }
  var $x_1 = $m_scm_ArraySeq$();
  var elemRuntimeClass = ((elementClass === $d_V.getClassOf()) ? $d_jl_Void.getClassOf() : (((elementClass === $d_sr_Null$.getClassOf()) || (elementClass === $d_sr_Nothing$.getClassOf())) ? $d_O.getClassOf() : elementClass));
  return $n($x_1).make__O__scm_ArraySeq($n(elemRuntimeClass).jl_Class__f_data.getArrayOf().wrapArray(jsElems));
});
$c_scm_ArraySeq.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_scm_ArraySeq$().newBuilder__s_reflect_ClassTag__scm_Builder(this.elemTag__s_reflect_ClassTag());
});
$c_scm_ArraySeq.prototype.className__T = (function() {
  return "ArraySeq";
});
$c_scm_ArraySeq.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var srcLen = this.length__I();
  var destLen = $m_jl_reflect_Array$().getLength__O__I(xs);
  var x = ((len < srcLen) ? len : srcLen);
  var y = ((destLen - start) | 0);
  var x$1 = ((x < y) ? x : y);
  var copied = ((x$1 > 0) ? x$1 : 0);
  if ((copied > 0)) {
    $m_s_Array$().copy__O__I__O__I__I__V(this.array__O(), 0, xs, start, copied);
  }
  return copied;
});
$c_scm_ArraySeq.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_scm_ArraySeq)) {
    var x2 = $as_scm_ArraySeq(other);
    var xs = this.array__O();
    var $x_1 = $m_jl_reflect_Array$().getLength__O__I(xs);
    var xs$1 = $n(x2).array__O();
    if (($x_1 !== $m_jl_reflect_Array$().getLength__O__I(xs$1))) {
      return false;
    }
  }
  return $f_sc_Seq__equals__O__Z(this, other);
});
$c_scm_ArraySeq.prototype.sorted__s_math_Ordering__scm_ArraySeq = (function(ord) {
  var $x_2 = $m_scm_ArraySeq$();
  var $x_1 = $m_sc_ArrayOps$();
  var xs = this.array__O();
  return $n($x_2).make__O__scm_ArraySeq($n($x_1).sorted$extension__O__s_math_Ordering__O(xs, ord));
});
$c_scm_ArraySeq.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__scm_ArraySeq(ord);
});
$c_scm_ArraySeq.prototype.empty__sc_IterableOps = (function() {
  var this$1 = $m_scm_ArraySeq$();
  this.elemTag__s_reflect_ClassTag();
  return this$1.scm_ArraySeq$__f_EmptyArraySeq;
});
$c_scm_ArraySeq.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__scm_ArraySeq(coll);
});
$c_scm_ArraySeq.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__scm_ArraySeq(coll);
});
$c_scm_ArraySeq.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_ArraySeq$().scm_ArraySeq$__f_untagged;
});
function $as_scm_ArraySeq(obj) {
  return (((obj instanceof $c_scm_ArraySeq) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq"));
}
function $isArrayOf_scm_ArraySeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq)));
}
function $asArrayOf_scm_ArraySeq(obj, depth) {
  return (($isArrayOf_scm_ArraySeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq;", depth));
}
/** @constructor */
function $c_Lcats_data_NonEmptyChainInstances$$anon$1() {
  this.Lcats_data_AbstractNonEmptyInstances__f_monadInstance = null;
  this.Lcats_data_AbstractNonEmptyInstances__f_traverseInstance = null;
  $ct_Lcats_data_AbstractNonEmptyInstances__Lcats_Monad__Lcats_CoflatMap__Lcats_Traverse__Lcats_Alternative__(this, $as_Lcats_Monad($m_Lcats_data_Chain$().Lcats_data_ChainInstances__f_catsDataInstancesForChain), $as_Lcats_CoflatMap($m_Lcats_data_Chain$().Lcats_data_ChainInstances__f_catsDataInstancesForChain), $as_Lcats_Traverse($m_Lcats_data_Chain$().Lcats_data_ChainInstances__f_catsDataInstancesForChain), $as_Lcats_Alternative($m_Lcats_data_Chain$().Lcats_data_ChainInstances__f_catsDataInstancesForChain));
  $m_Lcats_data_Chain$();
}
$c_Lcats_data_NonEmptyChainInstances$$anon$1.prototype = new $h_Lcats_data_AbstractNonEmptyInstances();
$c_Lcats_data_NonEmptyChainInstances$$anon$1.prototype.constructor = $c_Lcats_data_NonEmptyChainInstances$$anon$1;
/** @constructor */
function $h_Lcats_data_NonEmptyChainInstances$$anon$1() {
}
$h_Lcats_data_NonEmptyChainInstances$$anon$1.prototype = $c_Lcats_data_NonEmptyChainInstances$$anon$1.prototype;
$c_Lcats_data_NonEmptyChainInstances$$anon$1.prototype.size__O__J = (function(fa) {
  $m_Lcats_data_NonEmptyChainImpl$();
  return $m_Lcats_data_NonEmptyChainOps$().length$extension__O__J(fa);
});
$c_Lcats_data_NonEmptyChainInstances$$anon$1.prototype.reduceLeft__O__F2__O = (function(fa, f) {
  $m_Lcats_data_NonEmptyChainImpl$();
  return $m_Lcats_data_NonEmptyChainOps$().reduceLeft$extension__O__F2__O(fa, f);
});
$c_Lcats_data_NonEmptyChainInstances$$anon$1.prototype.reduceLeftTo__O__F1__F2__O = (function(fa, f, g) {
  $m_Lcats_data_NonEmptyChainImpl$();
  return $m_Lcats_data_NonEmptyChainOps$().reduceLeftTo$extension__O__F1__F2__O(fa, f, g);
});
var $d_Lcats_data_NonEmptyChainInstances$$anon$1 = new $TypeData().initClass($c_Lcats_data_NonEmptyChainInstances$$anon$1, "cats.data.NonEmptyChainInstances$$anon$1", ({
  Lcats_data_NonEmptyChainInstances$$anon$1: 1,
  Lcats_data_AbstractNonEmptyInstances: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Comonad: 1,
  Lcats_Bimonad: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Reducible: 1,
  Lcats_NonEmptyTraverse: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_Align: 1
}));
/** @constructor */
function $c_Lcats_data_NonEmptyListInstances$$anon$2() {
  this.Lcats_NonEmptyReducible__f_G = null;
  $ct_Lcats_NonEmptyReducible__Lcats_Foldable__(this, ($m_Lcats_UnorderedFoldable$(), $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList)));
}
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype = new $h_Lcats_NonEmptyReducible();
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.constructor = $c_Lcats_data_NonEmptyListInstances$$anon$2;
/** @constructor */
function $h_Lcats_data_NonEmptyListInstances$$anon$2() {
}
$h_Lcats_data_NonEmptyListInstances$$anon$2.prototype = $c_Lcats_data_NonEmptyListInstances$$anon$2.prototype;
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  return $n(fa$1).map__F1__Lcats_data_NonEmptyList(f);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.unit__O = (function() {
  $m_Lcats_data_NonEmptyList$();
  $m_Lcats_data_NonEmptyList$();
  var tail = $m_sci_Nil$();
  return new $c_Lcats_data_NonEmptyList((void 0), tail);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$1) {
  var fa = $as_Lcats_data_NonEmptyList(sa);
  return $n(fa).traverse__F1__Lcats_Applicative__O(f, evidence$1);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.foldMap__Lcats_data_NonEmptyList__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var $x_1 = $n(B);
  var this$1 = $n(fa);
  var this$2 = $n(this$1.Lcats_data_NonEmptyList__f_tail);
  var elem = this$1.Lcats_data_NonEmptyList__f_head;
  var this$3 = new $c_sci_$colon$colon(elem, this$2);
  var this$4 = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  return $n($x_1).combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$4, f));
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.tailRecM__O__F1__Lcats_data_NonEmptyList = (function(a, f) {
  var buf = new $c_scm_ListBuffer();
  $s_Lcats_data_NonEmptyListInstances__cats$data$NonEmptyListInstances$$anon$2$$_$go$2__scm_ListBuffer__F1__Lcats_data_NonEmptyList__V(buf, f, $as_Lcats_data_NonEmptyList($n(f).apply__O__O(a)));
  return $m_Lcats_data_NonEmptyList$().fromListUnsafe__sci_List__Lcats_data_NonEmptyList(buf.toList__sci_List());
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.reduceLeft__O__F2__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  var this$1 = $n(fa$1);
  var this$2 = $n(this$1.Lcats_data_NonEmptyList__f_tail);
  var z = this$1.Lcats_data_NonEmptyList__f_head;
  return $f_sc_LinearSeqOps__foldLeft__O__F2__O(this$2, z, f);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  return $n(fa$1).map__F1__Lcats_data_NonEmptyList(f);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.pure__O__O = (function(x) {
  $m_Lcats_data_NonEmptyList$();
  $m_Lcats_data_NonEmptyList$();
  var tail = $m_sci_Nil$();
  return new $c_Lcats_data_NonEmptyList(x, tail);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  return $n(fa$1).flatMap__F1__Lcats_data_NonEmptyList(f);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  return $n(fa$1).traverse__F1__Lcats_Applicative__O(f, evidence$1);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  return $n(fa$1).foldLeft__O__F2__O(b, f);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  return $n(fa$1).foldRight__Lcats_Eval__F2__Lcats_Eval(lb, f);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__Lcats_data_NonEmptyList__F1__Lcats_kernel_Monoid__O($as_Lcats_data_NonEmptyList(fa), f, B);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__Lcats_data_NonEmptyList(a, f);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.fold__O__Lcats_kernel_Monoid__O = (function(fa, A) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  return $n(fa$1).reduce__Lcats_kernel_Semigroup__O(A);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.toList__O__sci_List = (function(fa) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  var this$1 = $n(fa$1);
  var this$2 = $n(this$1.Lcats_data_NonEmptyList__f_tail);
  var elem = this$1.Lcats_data_NonEmptyList__f_head;
  return new $c_sci_$colon$colon(elem, this$2);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.toIterable__O__sc_Iterable = (function(fa) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  var this$1 = $n(fa$1);
  var this$2 = $n(this$1.Lcats_data_NonEmptyList__f_tail);
  var elem = this$1.Lcats_data_NonEmptyList__f_head;
  return new $c_sci_$colon$colon(elem, this$2);
});
var $d_Lcats_data_NonEmptyListInstances$$anon$2 = new $TypeData().initClass($c_Lcats_data_NonEmptyListInstances$$anon$2, "cats.data.NonEmptyListInstances$$anon$2", ({
  Lcats_data_NonEmptyListInstances$$anon$2: 1,
  Lcats_NonEmptyReducible: 1,
  Ljava_io_Serializable: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_Reducible: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Comonad: 1,
  Lcats_Bimonad: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_NonEmptyTraverse: 1,
  Lcats_Align: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$$anon$2() {
  this.Lcats_effect_IO$$anon$2__f_cats$effect$kernel$Sync$$Delay = null;
  this.Lcats_effect_IO$$anon$2__f_cats$effect$kernel$Sync$$Blocking = null;
  this.Lcats_effect_IO$$anon$2__f_executionContext = null;
  this.Lcats_effect_IO$$anon$2__f_realTime = null;
  $f_Lcats_effect_kernel_Sync__$init$__V(this);
  this.Lcats_effect_IO$$anon$2__f_executionContext = ($m_Lcats_effect_IO$(), $m_Lcats_effect_IO$ReadEC$());
  $m_Lcats_effect_IO$();
  this.Lcats_effect_IO$$anon$2__f_realTime = ($m_Lcats_effect_IO$(), $m_Lcats_effect_IO$RealTime$());
}
$c_Lcats_effect_IO$$anon$2.prototype = new $h_O();
$c_Lcats_effect_IO$$anon$2.prototype.constructor = $c_Lcats_effect_IO$$anon$2;
/** @constructor */
function $h_Lcats_effect_IO$$anon$2() {
}
$h_Lcats_effect_IO$$anon$2.prototype = $c_Lcats_effect_IO$$anon$2.prototype;
$c_Lcats_effect_IO$$anon$2.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_Lcats_effect_IO(fa);
  return $n(fa$1).map__F1__Lcats_effect_IO(f);
});
$c_Lcats_effect_IO$$anon$2.prototype.unit__O = (function() {
  $m_Lcats_effect_IO$();
  return new $c_Lcats_effect_IO$Pure((void 0));
});
$c_Lcats_effect_IO$$anon$2.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_effect_IO$$anon$2.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_effect_IO$$anon$2.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_effect_IO$$anon$2.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_effect_IO$$anon$2.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Delay_$eq__Lcats_effect_kernel_Sync$Type$Delay$__V = (function(x$0) {
  this.Lcats_effect_IO$$anon$2__f_cats$effect$kernel$Sync$$Delay = x$0;
});
$c_Lcats_effect_IO$$anon$2.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Blocking_$eq__Lcats_effect_kernel_Sync$Type$Blocking$__V = (function(x$0) {
  this.Lcats_effect_IO$$anon$2__f_cats$effect$kernel$Sync$$Blocking = x$0;
});
$c_Lcats_effect_IO$$anon$2.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleOnce_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleOnce$__V = (function(x$0) {
});
$c_Lcats_effect_IO$$anon$2.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleMany_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleMany$__V = (function(x$0) {
});
$c_Lcats_effect_IO$$anon$2.prototype.unique__O = (function() {
  return $f_Lcats_effect_kernel_Sync__unique__O(this);
});
$c_Lcats_effect_IO$$anon$2.prototype.raceOutcome__O__O__O = (function(fa, fb) {
  return $f_Lcats_effect_kernel_GenSpawn__raceOutcome__O__O__O(this, fa, fb);
});
$c_Lcats_effect_IO$$anon$2.prototype.both__O__O__O = (function(fa, fb) {
  return $f_Lcats_effect_kernel_GenSpawn__both__O__O__O(this, fa, fb);
});
$c_Lcats_effect_IO$$anon$2.prototype.never__O = (function() {
  return $f_Lcats_effect_kernel_Async__never__O(this);
});
$c_Lcats_effect_IO$$anon$2.prototype.tailRecM__O__F1__O = (function(a, f) {
  return $f_Lcats_StackSafeMonad__tailRecM__O__F1__O(this, a, f);
});
$c_Lcats_effect_IO$$anon$2.prototype.map2Eval__Lcats_effect_IO__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, fn) {
  $m_Lcats_Eval$();
  var a$1 = $n(fa).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((a) => $n($as_Lcats_effect_IO($n(fb).value__O())).map__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((b) => $n(fn).apply__O__O__O(a, b)))))));
  return new $c_Lcats_Now(a$1);
});
$c_Lcats_effect_IO$$anon$2.prototype.asyncCheckAttempt__F1__O = (function(k) {
  return $m_Lcats_effect_IO$().asyncCheckAttempt__F1__Lcats_effect_IO(k);
});
$c_Lcats_effect_IO$$anon$2.prototype.async__F1__O = (function(k) {
  return $m_Lcats_effect_IO$().async__F1__Lcats_effect_IO(k);
});
$c_Lcats_effect_IO$$anon$2.prototype.async___F1__O = (function(k) {
  return $m_Lcats_effect_IO$().async___F1__Lcats_effect_IO(k);
});
$c_Lcats_effect_IO$$anon$2.prototype.as__O__O__O = (function(fa, b) {
  var ioa = $as_Lcats_effect_IO(fa);
  return $n(ioa).as__O__Lcats_effect_IO(b);
});
$c_Lcats_effect_IO$$anon$2.prototype.attempt__O__O = (function(fa) {
  var ioa = $as_Lcats_effect_IO(fa);
  var this$1 = $n(ioa);
  return new $c_Lcats_effect_IO$Attempt(this$1);
});
$c_Lcats_effect_IO$$anon$2.prototype.forceR__O__O__O = (function(fa, fb) {
  var left = $as_Lcats_effect_IO(fa);
  var right = $as_Lcats_effect_IO(fb);
  return $n(left).forceR__Lcats_effect_IO__Lcats_effect_IO(right);
});
$c_Lcats_effect_IO$$anon$2.prototype.pure__O__O = (function(x) {
  $m_Lcats_effect_IO$();
  return new $c_Lcats_effect_IO$Pure(x);
});
$c_Lcats_effect_IO$$anon$2.prototype.guarantee__O__O__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_effect_IO(fa);
  var fin$1 = $as_Lcats_effect_IO(fin);
  return $n(fa$1).guarantee__Lcats_effect_IO__Lcats_effect_IO(fin$1);
});
$c_Lcats_effect_IO$$anon$2.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_effect_IO(fa);
  return $n(fa$1).guaranteeCase__F1__Lcats_effect_IO(fin);
});
$c_Lcats_effect_IO$$anon$2.prototype.handleError__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_effect_IO(fa);
  return $n(fa$1).handleError__F1__Lcats_effect_IO(f);
});
$c_Lcats_effect_IO$$anon$2.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_effect_IO(fa);
  return $n(fa$1).handleErrorWith__F1__Lcats_effect_IO(f);
});
$c_Lcats_effect_IO$$anon$2.prototype.raiseError__O__O = (function(e) {
  var e$1 = $as_jl_Throwable(e);
  $m_Lcats_effect_IO$();
  return new $c_Lcats_effect_IO$Error(e$1);
});
$c_Lcats_effect_IO$$anon$2.prototype.cont__Lcats_effect_kernel_Cont__O = (function(body) {
  return $m_Lcats_effect_IO$().cont__Lcats_effect_kernel_Cont__Lcats_effect_IO(body);
});
$c_Lcats_effect_IO$$anon$2.prototype.executionContext__O = (function() {
  return this.Lcats_effect_IO$$anon$2__f_executionContext;
});
$c_Lcats_effect_IO$$anon$2.prototype.onCancel__O__O__O = (function(fa, fin) {
  var ioa = $as_Lcats_effect_IO(fa);
  var fin$1 = $as_Lcats_effect_IO(fin);
  var this$1 = $n(ioa);
  return new $c_Lcats_effect_IO$OnCancel(this$1, fin$1);
});
$c_Lcats_effect_IO$$anon$2.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $m_Lcats_effect_IO$().bracketFull__F1__F1__F2__Lcats_effect_IO(acquire, use, release);
});
$c_Lcats_effect_IO$$anon$2.prototype.realTime__O = (function() {
  return this.Lcats_effect_IO$$anon$2__f_realTime;
});
$c_Lcats_effect_IO$$anon$2.prototype.canceled__O = (function() {
  $m_Lcats_effect_IO$();
  return $m_Lcats_effect_IO$Canceled$();
});
$c_Lcats_effect_IO$$anon$2.prototype.cede__O = (function() {
  $m_Lcats_effect_IO$();
  return $m_Lcats_effect_IO$Cede$();
});
$c_Lcats_effect_IO$$anon$2.prototype.productL__O__O__O = (function(fa, fb) {
  var left = $as_Lcats_effect_IO(fa);
  var right = $as_Lcats_effect_IO(fb);
  return $n(left).productL__Lcats_effect_IO__Lcats_effect_IO(right);
});
$c_Lcats_effect_IO$$anon$2.prototype.productR__O__O__O = (function(fa, fb) {
  var left = $as_Lcats_effect_IO(fa);
  var right = $as_Lcats_effect_IO(fb);
  return $n(left).productR__Lcats_effect_IO__Lcats_effect_IO(right);
});
$c_Lcats_effect_IO$$anon$2.prototype.start__O__O = (function(fa) {
  var fa$1 = $as_Lcats_effect_IO(fa);
  var this$1 = $n(fa$1);
  return new $c_Lcats_effect_IO$Start(this$1);
});
$c_Lcats_effect_IO$$anon$2.prototype.racePair__O__O__O = (function(fa, fb) {
  var left = $as_Lcats_effect_IO(fa);
  var right = $as_Lcats_effect_IO(fb);
  $m_Lcats_effect_IO$();
  return new $c_Lcats_effect_IO$RacePair(left, right);
});
$c_Lcats_effect_IO$$anon$2.prototype.uncancelable__F1__O = (function(body) {
  return $m_Lcats_effect_IO$().uncancelable__F1__Lcats_effect_IO(body);
});
$c_Lcats_effect_IO$$anon$2.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_effect_IO(fa);
  return $n(fa$1).map__F1__Lcats_effect_IO(f);
});
$c_Lcats_effect_IO$$anon$2.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_effect_IO(fa);
  return $n(fa$1).flatMap__F1__Lcats_effect_IO(f);
});
$c_Lcats_effect_IO$$anon$2.prototype.delay__F0__O = (function(thunk) {
  var this$1 = $m_Lcats_effect_IO$();
  return this$1.delay__F0__Lcats_effect_IO(thunk);
});
$c_Lcats_effect_IO$$anon$2.prototype.blocking__F0__O = (function(thunk) {
  var this$1 = $m_Lcats_effect_IO$();
  return this$1.delay__F0__Lcats_effect_IO(thunk);
});
$c_Lcats_effect_IO$$anon$2.prototype.suspend__Lcats_effect_kernel_Sync$Type__F0__O = (function(hint, thunk) {
  return $m_Lcats_effect_IO$().suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_effect_IO(hint, thunk);
});
$c_Lcats_effect_IO$$anon$2.prototype.void__O__O = (function(fa) {
  var ioa = $as_Lcats_effect_IO(fa);
  return $n(ioa).void__Lcats_effect_IO();
});
$c_Lcats_effect_IO$$anon$2.prototype.redeemWith__O__F1__F1__O = (function(fa, recover, bind) {
  var fa$1 = $as_Lcats_effect_IO(fa);
  return $n(fa$1).redeemWith__F1__F1__Lcats_effect_IO(recover, bind);
});
$c_Lcats_effect_IO$$anon$2.prototype.ref__O__O = (function(a) {
  return $m_Lcats_effect_IO$().ref__O__Lcats_effect_IO(a);
});
$c_Lcats_effect_IO$$anon$2.prototype.deferred__O = (function() {
  return $m_Lcats_effect_IO$().deferred__Lcats_effect_IO();
});
$c_Lcats_effect_IO$$anon$2.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__Lcats_effect_IO__Lcats_Eval__F2__Lcats_Eval($as_Lcats_effect_IO(fa), fb, f);
});
var $d_Lcats_effect_IO$$anon$2 = new $TypeData().initClass($c_Lcats_effect_IO$$anon$2, "cats.effect.IO$$anon$2", ({
  Lcats_effect_IO$$anon$2: 1,
  Lcats_effect_kernel_AsyncPlatform: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lcats_effect_kernel_ClockPlatform: 1,
  Lcats_effect_kernel_Clock: 1,
  Lcats_effect_kernel_Unique: 1,
  Lcats_Defer: 1,
  Lcats_effect_kernel_Sync: 1,
  Lcats_effect_kernel_GenSpawn: 1,
  Lcats_effect_kernel_GenConcurrent: 1,
  Lcats_effect_kernel_GenTemporal: 1,
  Lcats_effect_kernel_Async: 1,
  Lcats_StackSafeMonad: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_GenTemporal$$anon$3(F0$8) {
  this.Lcats_effect_kernel_GenTemporal$$anon$3__f_F0$3 = null;
  this.Lcats_effect_kernel_GenTemporal$$anon$3__f_F0$3 = F0$8;
}
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype = new $h_O();
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.constructor = $c_Lcats_effect_kernel_GenTemporal$$anon$3;
/** @constructor */
function $h_Lcats_effect_kernel_GenTemporal$$anon$3() {
}
$h_Lcats_effect_kernel_GenTemporal$$anon$3.prototype = $c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype;
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.unit__O = (function() {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenTemporal$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  var this$3 = $m_Lcats_data_Kleisli$();
  var F = this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$3, (void 0), F);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.guarantee__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O(this, fa, fin);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.C__Lcats_effect_kernel_Clock = (function() {
  return this.Lcats_effect_kernel_GenTemporal$$anon$3__f_F0$3;
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.F__Lcats_effect_kernel_GenConcurrent = (function() {
  return this.Lcats_effect_kernel_GenTemporal$$anon$3__f_F0$3;
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.F__Lcats_effect_kernel_GenSpawn = (function() {
  return this.Lcats_effect_kernel_GenTemporal$$anon$3__f_F0$3;
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.F__Lcats_effect_kernel_MonadCancel = (function() {
  return this.Lcats_effect_kernel_GenTemporal$$anon$3__f_F0$3;
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.realTime__O = (function() {
  return $f_Lcats_effect_kernel_Clock$KleisliClock__realTime__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.ref__O__O = (function(a) {
  return $f_Lcats_effect_kernel_GenConcurrent$KleisliGenConcurrent__ref__O__Lcats_data_Kleisli(this, a);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.deferred__O = (function() {
  return $f_Lcats_effect_kernel_GenConcurrent$KleisliGenConcurrent__deferred__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.racePair__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__racePair__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.unique__O = (function() {
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__unique__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.start__O__O = (function(fa) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__start__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.never__O = (function() {
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__never__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.cede__O = (function() {
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__cede__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.both__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__both__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.raceOutcome__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__raceOutcome__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.uncancelable__F1__O = (function(body) {
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__uncancelable__F1__Lcats_data_Kleisli(this, body);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.canceled__O = (function() {
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__canceled__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.onCancel__O__O__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fin$1 = $as_Lcats_data_Kleisli(fin);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__onCancel__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fin$1);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.forceR__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__forceR__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__guaranteeCase__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this, fa$1, fin);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.pure__O__O = (function(x) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenTemporal$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  var this$3 = $m_Lcats_data_Kleisli$();
  var F = this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$3, x, F);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.raiseError__O__O = (function(e) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenTemporal$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliApplicativeError__raiseError__O__Lcats_data_Kleisli(this$2, e);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenTemporal$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliApplicativeError__handleErrorWith__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this$2, fa$1, f);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenTemporal$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $n(fa$1).flatMap__F1__Lcats_FlatMap__Lcats_data_Kleisli(f, this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.tailRecM__O__F1__O = (function(a, f) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenTemporal$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliFlatMap__tailRecM__O__F1__Lcats_data_Kleisli(this$2, a, f);
});
var $d_Lcats_effect_kernel_GenTemporal$$anon$3 = new $TypeData().initClass($c_Lcats_effect_kernel_GenTemporal$$anon$3, "cats.effect.kernel.GenTemporal$$anon$3", ({
  Lcats_effect_kernel_GenTemporal$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lcats_effect_kernel_Unique: 1,
  Lcats_effect_kernel_GenSpawn: 1,
  Lcats_effect_kernel_GenConcurrent: 1,
  Lcats_effect_kernel_ClockPlatform: 1,
  Lcats_effect_kernel_Clock: 1,
  Lcats_effect_kernel_GenTemporal: 1,
  Lcats_effect_kernel_MonadCancel$KleisliMonadCancel: 1,
  Lcats_effect_kernel_GenSpawn$KleisliGenSpawn: 1,
  Lcats_effect_kernel_GenConcurrent$KleisliGenConcurrent: 1,
  Lcats_effect_kernel_Clock$KleisliClock: 1,
  Lcats_effect_kernel_GenTemporal$KleisliTemporal: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofBoolean(unsafeArray) {
  this.sci_ArraySeq$ofBoolean__f_unsafeArray = null;
  this.sci_ArraySeq$ofBoolean__f_unsafeArray = unsafeArray;
}
$c_sci_ArraySeq$ofBoolean.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofBoolean.prototype.constructor = $c_sci_ArraySeq$ofBoolean;
/** @constructor */
function $h_sci_ArraySeq$ofBoolean() {
}
$h_sci_ArraySeq$ofBoolean.prototype = $c_sci_ArraySeq$ofBoolean.prototype;
$c_sci_ArraySeq$ofBoolean.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofBoolean__f_unsafeArray).u.length;
});
$c_sci_ArraySeq$ofBoolean.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofBoolean__f_unsafeArray;
  return this$1.arrayHash$mZc$sp__AZ__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofBoolean.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofBoolean)) {
    var x2 = $as_sci_ArraySeq$ofBoolean(that);
    var a = this.sci_ArraySeq$ofBoolean__f_unsafeArray;
    var b = $n(x2).sci_ArraySeq$ofBoolean__f_unsafeArray;
    return $m_ju_Arrays$().equals__AZ__AZ__Z(a, b);
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofBoolean.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.length__I() <= 1)) {
    return this;
  } else if ((ord === $m_s_math_Ordering$Boolean$())) {
    var this$1 = $n(this.sci_ArraySeq$ofBoolean__f_unsafeArray);
    var a = $n(this$1).clone__O();
    var this$2 = $m_s_util_Sorting$();
    var evidence$3 = $m_s_math_Ordering$Boolean$();
    this$2.stableSort__O__I__I__s_math_Ordering__V(a, 0, $n(a).u.length, evidence$3);
    return new $c_sci_ArraySeq$ofBoolean(a);
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord);
  }
});
$c_sci_ArraySeq$ofBoolean.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcZ$sp(this.sci_ArraySeq$ofBoolean__f_unsafeArray);
});
$c_sci_ArraySeq$ofBoolean.prototype.appended__O__sci_ArraySeq = (function(elem) {
  if (((typeof elem) === "boolean")) {
    var x2 = $uZ(elem);
    var xs = this.sci_ArraySeq$ofBoolean__f_unsafeArray;
    var this$3 = $m_s_Array$();
    var newLength = ((1 + $n(xs).u.length) | 0);
    var this$4 = $n(xs);
    if ($d_Z.getClassOf().isAssignableFrom__jl_Class__Z($objectGetClass(this$4).getComponentType__jl_Class())) {
      if ($d_Z.getClassOf().isPrimitive__Z()) {
        var dest$1 = this$3.copyOf__O__I__O(xs, newLength);
      } else {
        var original = $asArrayOf_O(xs, 1);
        var dest$1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original, newLength, $d_Z.getArrayOf().getClassOf());
      }
    } else {
      var dest = new $ac_Z(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, $n(xs).u.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, $n(xs).u.length, x2);
    return new $c_sci_ArraySeq$ofBoolean($asArrayOf_Z(dest$1, 1));
  } else {
    return $c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofBoolean.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  if (((typeof elem) === "boolean")) {
    var x2 = $uZ(elem);
    var xs = this.sci_ArraySeq$ofBoolean__f_unsafeArray;
    var len = ((1 + $n(xs).u.length) | 0);
    var dest = new $ac_Z(len);
    dest.set(0, x2);
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, $n(xs).u.length);
    return new $c_sci_ArraySeq$ofBoolean(dest);
  } else {
    return $c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofBoolean.prototype.apply$mcZI$sp__I__Z = (function(i) {
  return $n(this.sci_ArraySeq$ofBoolean__f_unsafeArray).get(i);
});
$c_sci_ArraySeq$ofBoolean.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofBoolean.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofBoolean.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord);
});
$c_sci_ArraySeq$ofBoolean.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return this.apply$mcZI$sp__I__Z(i);
});
$c_sci_ArraySeq$ofBoolean.prototype.apply__I__O = (function(i) {
  return this.apply$mcZI$sp__I__Z(i);
});
$c_sci_ArraySeq$ofBoolean.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$BooleanManifest$();
});
$c_sci_ArraySeq$ofBoolean.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofBoolean__f_unsafeArray;
});
function $as_sci_ArraySeq$ofBoolean(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofBoolean) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofBoolean"));
}
function $isArrayOf_sci_ArraySeq$ofBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofBoolean)));
}
function $asArrayOf_sci_ArraySeq$ofBoolean(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofBoolean(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofBoolean;", depth));
}
var $d_sci_ArraySeq$ofBoolean = new $TypeData().initClass($c_sci_ArraySeq$ofBoolean, "scala.collection.immutable.ArraySeq$ofBoolean", ({
  sci_ArraySeq$ofBoolean: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofByte(unsafeArray) {
  this.sci_ArraySeq$ofByte__f_unsafeArray = null;
  this.sci_ArraySeq$ofByte__f_unsafeArray = unsafeArray;
}
$c_sci_ArraySeq$ofByte.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofByte.prototype.constructor = $c_sci_ArraySeq$ofByte;
/** @constructor */
function $h_sci_ArraySeq$ofByte() {
}
$h_sci_ArraySeq$ofByte.prototype = $c_sci_ArraySeq$ofByte.prototype;
$c_sci_ArraySeq$ofByte.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofByte__f_unsafeArray).u.length;
});
$c_sci_ArraySeq$ofByte.prototype.apply__I__B = (function(i) {
  return $n(this.sci_ArraySeq$ofByte__f_unsafeArray).get(i);
});
$c_sci_ArraySeq$ofByte.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofByte__f_unsafeArray;
  return this$1.arrayHash$mBc$sp__AB__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofByte.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofByte)) {
    var x2 = $as_sci_ArraySeq$ofByte(that);
    var a = this.sci_ArraySeq$ofByte__f_unsafeArray;
    var b = $n(x2).sci_ArraySeq$ofByte__f_unsafeArray;
    return $m_ju_Arrays$().equals__AB__AB__Z(a, b);
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofByte.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.length__I() <= 1)) {
    return this;
  } else if ((ord === $m_s_math_Ordering$Byte$())) {
    var this$1 = $n(this.sci_ArraySeq$ofByte__f_unsafeArray);
    var a = $n(this$1).clone__O();
    $m_ju_Arrays$().sort__AB__V(a);
    return new $c_sci_ArraySeq$ofByte(a);
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord);
  }
});
$c_sci_ArraySeq$ofByte.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcB$sp(this.sci_ArraySeq$ofByte__f_unsafeArray);
});
$c_sci_ArraySeq$ofByte.prototype.appended__O__sci_ArraySeq = (function(elem) {
  if ($isByte(elem)) {
    var x2 = $uB(elem);
    var xs = this.sci_ArraySeq$ofByte__f_unsafeArray;
    var this$3 = $m_s_Array$();
    var newLength = ((1 + $n(xs).u.length) | 0);
    var this$4 = $n(xs);
    if ($d_B.getClassOf().isAssignableFrom__jl_Class__Z($objectGetClass(this$4).getComponentType__jl_Class())) {
      if ($d_B.getClassOf().isPrimitive__Z()) {
        var dest$1 = this$3.copyOf__O__I__O(xs, newLength);
      } else {
        var original = $asArrayOf_O(xs, 1);
        var dest$1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original, newLength, $d_B.getArrayOf().getClassOf());
      }
    } else {
      var dest = new $ac_B(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, $n(xs).u.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, $n(xs).u.length, x2);
    return new $c_sci_ArraySeq$ofByte($asArrayOf_B(dest$1, 1));
  } else {
    return $c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofByte.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  if ($isByte(elem)) {
    var x2 = $uB(elem);
    var xs = this.sci_ArraySeq$ofByte__f_unsafeArray;
    var len = ((1 + $n(xs).u.length) | 0);
    var dest = new $ac_B(len);
    dest.set(0, x2);
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, $n(xs).u.length);
    return new $c_sci_ArraySeq$ofByte(dest);
  } else {
    return $c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofByte.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofByte.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofByte.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord);
});
$c_sci_ArraySeq$ofByte.prototype.apply__O__O = (function(v1) {
  return this.apply__I__B($uI(v1));
});
$c_sci_ArraySeq$ofByte.prototype.apply__I__O = (function(i) {
  return this.apply__I__B(i);
});
$c_sci_ArraySeq$ofByte.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$ByteManifest$();
});
$c_sci_ArraySeq$ofByte.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofByte__f_unsafeArray;
});
function $as_sci_ArraySeq$ofByte(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofByte) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofByte"));
}
function $isArrayOf_sci_ArraySeq$ofByte(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofByte)));
}
function $asArrayOf_sci_ArraySeq$ofByte(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofByte(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofByte;", depth));
}
var $d_sci_ArraySeq$ofByte = new $TypeData().initClass($c_sci_ArraySeq$ofByte, "scala.collection.immutable.ArraySeq$ofByte", ({
  sci_ArraySeq$ofByte: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofChar(unsafeArray) {
  this.sci_ArraySeq$ofChar__f_unsafeArray = null;
  this.sci_ArraySeq$ofChar__f_unsafeArray = unsafeArray;
}
$c_sci_ArraySeq$ofChar.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofChar.prototype.constructor = $c_sci_ArraySeq$ofChar;
/** @constructor */
function $h_sci_ArraySeq$ofChar() {
}
$h_sci_ArraySeq$ofChar.prototype = $c_sci_ArraySeq$ofChar.prototype;
$c_sci_ArraySeq$ofChar.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofChar__f_unsafeArray).u.length;
});
$c_sci_ArraySeq$ofChar.prototype.apply__I__C = (function(i) {
  return $n(this.sci_ArraySeq$ofChar__f_unsafeArray).get(i);
});
$c_sci_ArraySeq$ofChar.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofChar__f_unsafeArray;
  return this$1.arrayHash$mCc$sp__AC__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofChar.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofChar)) {
    var x2 = $as_sci_ArraySeq$ofChar(that);
    var a = this.sci_ArraySeq$ofChar__f_unsafeArray;
    var b = $n(x2).sci_ArraySeq$ofChar__f_unsafeArray;
    return $m_ju_Arrays$().equals__AC__AC__Z(a, b);
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofChar.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.length__I() <= 1)) {
    return this;
  } else if ((ord === $m_s_math_Ordering$Char$())) {
    var this$1 = $n(this.sci_ArraySeq$ofChar__f_unsafeArray);
    var a = $n(this$1).clone__O();
    $m_ju_Arrays$().sort__AC__V(a);
    return new $c_sci_ArraySeq$ofChar(a);
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord);
  }
});
$c_sci_ArraySeq$ofChar.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcC$sp(this.sci_ArraySeq$ofChar__f_unsafeArray);
});
$c_sci_ArraySeq$ofChar.prototype.appended__O__sci_ArraySeq = (function(elem) {
  if ((elem instanceof $Char)) {
    var x2 = $uC(elem);
    var xs = this.sci_ArraySeq$ofChar__f_unsafeArray;
    var this$3 = $m_s_Array$();
    var newLength = ((1 + $n(xs).u.length) | 0);
    var this$4 = $n(xs);
    if ($d_C.getClassOf().isAssignableFrom__jl_Class__Z($objectGetClass(this$4).getComponentType__jl_Class())) {
      if ($d_C.getClassOf().isPrimitive__Z()) {
        var dest$1 = this$3.copyOf__O__I__O(xs, newLength);
      } else {
        var original = $asArrayOf_O(xs, 1);
        var dest$1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original, newLength, $d_C.getArrayOf().getClassOf());
      }
    } else {
      var dest = new $ac_C(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, $n(xs).u.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, $n(xs).u.length, $bC(x2));
    return new $c_sci_ArraySeq$ofChar($asArrayOf_C(dest$1, 1));
  } else {
    return $c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofChar.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  if ((elem instanceof $Char)) {
    var x2 = $uC(elem);
    var xs = this.sci_ArraySeq$ofChar__f_unsafeArray;
    var len = ((1 + $n(xs).u.length) | 0);
    var dest = new $ac_C(len);
    dest.set(0, x2);
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, $n(xs).u.length);
    return new $c_sci_ArraySeq$ofChar(dest);
  } else {
    return $c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofChar.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  return new $c_scm_ArraySeq$ofChar(this.sci_ArraySeq$ofChar__f_unsafeArray).addString__scm_StringBuilder__T__T__T__scm_StringBuilder(sb, start, sep, end);
});
$c_sci_ArraySeq$ofChar.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofChar.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofChar.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord);
});
$c_sci_ArraySeq$ofChar.prototype.apply__O__O = (function(v1) {
  return $bC(this.apply__I__C($uI(v1)));
});
$c_sci_ArraySeq$ofChar.prototype.apply__I__O = (function(i) {
  return $bC(this.apply__I__C(i));
});
$c_sci_ArraySeq$ofChar.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$CharManifest$();
});
$c_sci_ArraySeq$ofChar.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofChar__f_unsafeArray;
});
function $as_sci_ArraySeq$ofChar(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofChar) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofChar"));
}
function $isArrayOf_sci_ArraySeq$ofChar(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofChar)));
}
function $asArrayOf_sci_ArraySeq$ofChar(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofChar(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofChar;", depth));
}
var $d_sci_ArraySeq$ofChar = new $TypeData().initClass($c_sci_ArraySeq$ofChar, "scala.collection.immutable.ArraySeq$ofChar", ({
  sci_ArraySeq$ofChar: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofDouble(unsafeArray) {
  this.sci_ArraySeq$ofDouble__f_unsafeArray = null;
  this.sci_ArraySeq$ofDouble__f_unsafeArray = unsafeArray;
}
$c_sci_ArraySeq$ofDouble.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofDouble.prototype.constructor = $c_sci_ArraySeq$ofDouble;
/** @constructor */
function $h_sci_ArraySeq$ofDouble() {
}
$h_sci_ArraySeq$ofDouble.prototype = $c_sci_ArraySeq$ofDouble.prototype;
$c_sci_ArraySeq$ofDouble.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofDouble__f_unsafeArray).u.length;
});
$c_sci_ArraySeq$ofDouble.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofDouble__f_unsafeArray;
  return this$1.arrayHash$mDc$sp__AD__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofDouble.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofDouble)) {
    var x2 = $as_sci_ArraySeq$ofDouble(that);
    var a = this.sci_ArraySeq$ofDouble__f_unsafeArray;
    var b = $n(x2).sci_ArraySeq$ofDouble__f_unsafeArray;
    return $m_ju_Arrays$().equals__AD__AD__Z(a, b);
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofDouble.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcD$sp(this.sci_ArraySeq$ofDouble__f_unsafeArray);
});
$c_sci_ArraySeq$ofDouble.prototype.appended__O__sci_ArraySeq = (function(elem) {
  if (((typeof elem) === "number")) {
    var x2 = $uD(elem);
    var xs = this.sci_ArraySeq$ofDouble__f_unsafeArray;
    var this$3 = $m_s_Array$();
    var newLength = ((1 + $n(xs).u.length) | 0);
    var this$4 = $n(xs);
    if ($d_D.getClassOf().isAssignableFrom__jl_Class__Z($objectGetClass(this$4).getComponentType__jl_Class())) {
      if ($d_D.getClassOf().isPrimitive__Z()) {
        var dest$1 = this$3.copyOf__O__I__O(xs, newLength);
      } else {
        var original = $asArrayOf_O(xs, 1);
        var dest$1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original, newLength, $d_D.getArrayOf().getClassOf());
      }
    } else {
      var dest = new $ac_D(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, $n(xs).u.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, $n(xs).u.length, x2);
    return new $c_sci_ArraySeq$ofDouble($asArrayOf_D(dest$1, 1));
  } else {
    return $c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofDouble.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  if (((typeof elem) === "number")) {
    var x2 = $uD(elem);
    var xs = this.sci_ArraySeq$ofDouble__f_unsafeArray;
    var len = ((1 + $n(xs).u.length) | 0);
    var dest = new $ac_D(len);
    dest.set(0, x2);
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, $n(xs).u.length);
    return new $c_sci_ArraySeq$ofDouble(dest);
  } else {
    return $c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofDouble.prototype.apply$mcDI$sp__I__D = (function(i) {
  return $n(this.sci_ArraySeq$ofDouble__f_unsafeArray).get(i);
});
$c_sci_ArraySeq$ofDouble.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofDouble.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofDouble.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return this.apply$mcDI$sp__I__D(i);
});
$c_sci_ArraySeq$ofDouble.prototype.apply__I__O = (function(i) {
  return this.apply$mcDI$sp__I__D(i);
});
$c_sci_ArraySeq$ofDouble.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$DoubleManifest$();
});
$c_sci_ArraySeq$ofDouble.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofDouble__f_unsafeArray;
});
function $as_sci_ArraySeq$ofDouble(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofDouble) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofDouble"));
}
function $isArrayOf_sci_ArraySeq$ofDouble(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofDouble)));
}
function $asArrayOf_sci_ArraySeq$ofDouble(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofDouble(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofDouble;", depth));
}
var $d_sci_ArraySeq$ofDouble = new $TypeData().initClass($c_sci_ArraySeq$ofDouble, "scala.collection.immutable.ArraySeq$ofDouble", ({
  sci_ArraySeq$ofDouble: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofFloat(unsafeArray) {
  this.sci_ArraySeq$ofFloat__f_unsafeArray = null;
  this.sci_ArraySeq$ofFloat__f_unsafeArray = unsafeArray;
}
$c_sci_ArraySeq$ofFloat.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofFloat.prototype.constructor = $c_sci_ArraySeq$ofFloat;
/** @constructor */
function $h_sci_ArraySeq$ofFloat() {
}
$h_sci_ArraySeq$ofFloat.prototype = $c_sci_ArraySeq$ofFloat.prototype;
$c_sci_ArraySeq$ofFloat.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofFloat__f_unsafeArray).u.length;
});
$c_sci_ArraySeq$ofFloat.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofFloat__f_unsafeArray;
  return this$1.arrayHash$mFc$sp__AF__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofFloat.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofFloat)) {
    var x2 = $as_sci_ArraySeq$ofFloat(that);
    var a = this.sci_ArraySeq$ofFloat__f_unsafeArray;
    var b = $n(x2).sci_ArraySeq$ofFloat__f_unsafeArray;
    return $m_ju_Arrays$().equals__AF__AF__Z(a, b);
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofFloat.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcF$sp(this.sci_ArraySeq$ofFloat__f_unsafeArray);
});
$c_sci_ArraySeq$ofFloat.prototype.appended__O__sci_ArraySeq = (function(elem) {
  if ($isFloat(elem)) {
    var x2 = $uF(elem);
    var xs = this.sci_ArraySeq$ofFloat__f_unsafeArray;
    var this$3 = $m_s_Array$();
    var newLength = ((1 + $n(xs).u.length) | 0);
    var this$4 = $n(xs);
    if ($d_F.getClassOf().isAssignableFrom__jl_Class__Z($objectGetClass(this$4).getComponentType__jl_Class())) {
      if ($d_F.getClassOf().isPrimitive__Z()) {
        var dest$1 = this$3.copyOf__O__I__O(xs, newLength);
      } else {
        var original = $asArrayOf_O(xs, 1);
        var dest$1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original, newLength, $d_F.getArrayOf().getClassOf());
      }
    } else {
      var dest = new $ac_F(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, $n(xs).u.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, $n(xs).u.length, x2);
    return new $c_sci_ArraySeq$ofFloat($asArrayOf_F(dest$1, 1));
  } else {
    return $c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofFloat.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  if ($isFloat(elem)) {
    var x2 = $uF(elem);
    var xs = this.sci_ArraySeq$ofFloat__f_unsafeArray;
    var len = ((1 + $n(xs).u.length) | 0);
    var dest = new $ac_F(len);
    dest.set(0, x2);
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, $n(xs).u.length);
    return new $c_sci_ArraySeq$ofFloat(dest);
  } else {
    return $c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofFloat.prototype.apply$mcFI$sp__I__F = (function(i) {
  return $n(this.sci_ArraySeq$ofFloat__f_unsafeArray).get(i);
});
$c_sci_ArraySeq$ofFloat.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofFloat.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofFloat.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return this.apply$mcFI$sp__I__F(i);
});
$c_sci_ArraySeq$ofFloat.prototype.apply__I__O = (function(i) {
  return this.apply$mcFI$sp__I__F(i);
});
$c_sci_ArraySeq$ofFloat.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$FloatManifest$();
});
$c_sci_ArraySeq$ofFloat.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofFloat__f_unsafeArray;
});
function $as_sci_ArraySeq$ofFloat(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofFloat) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofFloat"));
}
function $isArrayOf_sci_ArraySeq$ofFloat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofFloat)));
}
function $asArrayOf_sci_ArraySeq$ofFloat(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofFloat(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofFloat;", depth));
}
var $d_sci_ArraySeq$ofFloat = new $TypeData().initClass($c_sci_ArraySeq$ofFloat, "scala.collection.immutable.ArraySeq$ofFloat", ({
  sci_ArraySeq$ofFloat: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofInt(unsafeArray) {
  this.sci_ArraySeq$ofInt__f_unsafeArray = null;
  this.sci_ArraySeq$ofInt__f_unsafeArray = unsafeArray;
}
$c_sci_ArraySeq$ofInt.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofInt.prototype.constructor = $c_sci_ArraySeq$ofInt;
/** @constructor */
function $h_sci_ArraySeq$ofInt() {
}
$h_sci_ArraySeq$ofInt.prototype = $c_sci_ArraySeq$ofInt.prototype;
$c_sci_ArraySeq$ofInt.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofInt__f_unsafeArray).u.length;
});
$c_sci_ArraySeq$ofInt.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofInt__f_unsafeArray;
  return this$1.arrayHash$mIc$sp__AI__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofInt.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofInt)) {
    var x2 = $as_sci_ArraySeq$ofInt(that);
    var a = this.sci_ArraySeq$ofInt__f_unsafeArray;
    var b = $n(x2).sci_ArraySeq$ofInt__f_unsafeArray;
    return $m_ju_Arrays$().equals__AI__AI__Z(a, b);
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofInt.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.length__I() <= 1)) {
    return this;
  } else if ((ord === $m_s_math_Ordering$Int$())) {
    var this$1 = $n(this.sci_ArraySeq$ofInt__f_unsafeArray);
    var a = $n(this$1).clone__O();
    $m_ju_Arrays$().sort__AI__V(a);
    return new $c_sci_ArraySeq$ofInt(a);
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord);
  }
});
$c_sci_ArraySeq$ofInt.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcI$sp(this.sci_ArraySeq$ofInt__f_unsafeArray);
});
$c_sci_ArraySeq$ofInt.prototype.appended__O__sci_ArraySeq = (function(elem) {
  if ($isInt(elem)) {
    var x2 = $uI(elem);
    var xs = this.sci_ArraySeq$ofInt__f_unsafeArray;
    var this$3 = $m_s_Array$();
    var newLength = ((1 + $n(xs).u.length) | 0);
    var this$4 = $n(xs);
    if ($d_I.getClassOf().isAssignableFrom__jl_Class__Z($objectGetClass(this$4).getComponentType__jl_Class())) {
      if ($d_I.getClassOf().isPrimitive__Z()) {
        var dest$1 = this$3.copyOf__O__I__O(xs, newLength);
      } else {
        var original = $asArrayOf_O(xs, 1);
        var dest$1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original, newLength, $d_I.getArrayOf().getClassOf());
      }
    } else {
      var dest = new $ac_I(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, $n(xs).u.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, $n(xs).u.length, x2);
    return new $c_sci_ArraySeq$ofInt($asArrayOf_I(dest$1, 1));
  } else {
    return $c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofInt.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  if ($isInt(elem)) {
    var x2 = $uI(elem);
    var xs = this.sci_ArraySeq$ofInt__f_unsafeArray;
    var len = ((1 + $n(xs).u.length) | 0);
    var dest = new $ac_I(len);
    dest.set(0, x2);
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, $n(xs).u.length);
    return new $c_sci_ArraySeq$ofInt(dest);
  } else {
    return $c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofInt.prototype.apply$mcII$sp__I__I = (function(i) {
  return $n(this.sci_ArraySeq$ofInt__f_unsafeArray).get(i);
});
$c_sci_ArraySeq$ofInt.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofInt.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofInt.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord);
});
$c_sci_ArraySeq$ofInt.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return this.apply$mcII$sp__I__I(i);
});
$c_sci_ArraySeq$ofInt.prototype.apply__I__O = (function(i) {
  return this.apply$mcII$sp__I__I(i);
});
$c_sci_ArraySeq$ofInt.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$IntManifest$();
});
$c_sci_ArraySeq$ofInt.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofInt__f_unsafeArray;
});
function $as_sci_ArraySeq$ofInt(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofInt) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofInt"));
}
function $isArrayOf_sci_ArraySeq$ofInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofInt)));
}
function $asArrayOf_sci_ArraySeq$ofInt(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofInt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofInt;", depth));
}
var $d_sci_ArraySeq$ofInt = new $TypeData().initClass($c_sci_ArraySeq$ofInt, "scala.collection.immutable.ArraySeq$ofInt", ({
  sci_ArraySeq$ofInt: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofLong(unsafeArray) {
  this.sci_ArraySeq$ofLong__f_unsafeArray = null;
  this.sci_ArraySeq$ofLong__f_unsafeArray = unsafeArray;
}
$c_sci_ArraySeq$ofLong.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofLong.prototype.constructor = $c_sci_ArraySeq$ofLong;
/** @constructor */
function $h_sci_ArraySeq$ofLong() {
}
$h_sci_ArraySeq$ofLong.prototype = $c_sci_ArraySeq$ofLong.prototype;
$c_sci_ArraySeq$ofLong.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofLong__f_unsafeArray).u.length;
});
$c_sci_ArraySeq$ofLong.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofLong__f_unsafeArray;
  return this$1.arrayHash$mJc$sp__AJ__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofLong.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofLong)) {
    var x2 = $as_sci_ArraySeq$ofLong(that);
    var a = this.sci_ArraySeq$ofLong__f_unsafeArray;
    var b = $n(x2).sci_ArraySeq$ofLong__f_unsafeArray;
    return $m_ju_Arrays$().equals__AJ__AJ__Z(a, b);
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofLong.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.length__I() <= 1)) {
    return this;
  } else if ((ord === $m_s_math_Ordering$Long$())) {
    var this$1 = $n(this.sci_ArraySeq$ofLong__f_unsafeArray);
    var a = $n(this$1).clone__O();
    $m_ju_Arrays$().sort__AJ__V(a);
    return new $c_sci_ArraySeq$ofLong(a);
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord);
  }
});
$c_sci_ArraySeq$ofLong.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcJ$sp(this.sci_ArraySeq$ofLong__f_unsafeArray);
});
$c_sci_ArraySeq$ofLong.prototype.appended__O__sci_ArraySeq = (function(elem) {
  if ((elem instanceof $c_RTLong)) {
    var t = $uJ(elem);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var xs = this.sci_ArraySeq$ofLong__f_unsafeArray;
    var this$3 = $m_s_Array$();
    var newLength = ((1 + $n(xs).u.length) | 0);
    var this$4 = $n(xs);
    if ($d_J.getClassOf().isAssignableFrom__jl_Class__Z($objectGetClass(this$4).getComponentType__jl_Class())) {
      if ($d_J.getClassOf().isPrimitive__Z()) {
        var dest$1 = this$3.copyOf__O__I__O(xs, newLength);
      } else {
        var original = $asArrayOf_O(xs, 1);
        var dest$1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original, newLength, $d_J.getArrayOf().getClassOf());
      }
    } else {
      var dest = new $ac_J(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, $n(xs).u.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, $n(xs).u.length, new $c_RTLong(lo, hi));
    return new $c_sci_ArraySeq$ofLong($asArrayOf_J(dest$1, 1));
  } else {
    return $c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofLong.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  if ((elem instanceof $c_RTLong)) {
    var t = $uJ(elem);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var xs = this.sci_ArraySeq$ofLong__f_unsafeArray;
    var len = ((1 + $n(xs).u.length) | 0);
    var dest = new $ac_J(len);
    dest.set(0, $uJ(new $c_RTLong(lo, hi)));
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, $n(xs).u.length);
    return new $c_sci_ArraySeq$ofLong(dest);
  } else {
    return $c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofLong.prototype.apply$mcJI$sp__I__J = (function(i) {
  return $n(this.sci_ArraySeq$ofLong__f_unsafeArray).get(i);
});
$c_sci_ArraySeq$ofLong.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofLong.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofLong.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord);
});
$c_sci_ArraySeq$ofLong.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return this.apply$mcJI$sp__I__J(i);
});
$c_sci_ArraySeq$ofLong.prototype.apply__I__O = (function(i) {
  return this.apply$mcJI$sp__I__J(i);
});
$c_sci_ArraySeq$ofLong.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$LongManifest$();
});
$c_sci_ArraySeq$ofLong.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofLong__f_unsafeArray;
});
function $as_sci_ArraySeq$ofLong(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofLong) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofLong"));
}
function $isArrayOf_sci_ArraySeq$ofLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofLong)));
}
function $asArrayOf_sci_ArraySeq$ofLong(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofLong;", depth));
}
var $d_sci_ArraySeq$ofLong = new $TypeData().initClass($c_sci_ArraySeq$ofLong, "scala.collection.immutable.ArraySeq$ofLong", ({
  sci_ArraySeq$ofLong: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofRef(unsafeArray) {
  this.sci_ArraySeq$ofRef__f_unsafeArray = null;
  this.sci_ArraySeq$ofRef__f_unsafeArray = unsafeArray;
}
$c_sci_ArraySeq$ofRef.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofRef.prototype.constructor = $c_sci_ArraySeq$ofRef;
/** @constructor */
function $h_sci_ArraySeq$ofRef() {
}
$h_sci_ArraySeq$ofRef.prototype = $c_sci_ArraySeq$ofRef.prototype;
$c_sci_ArraySeq$ofRef.prototype.elemTag__s_reflect_ClassTag = (function() {
  var $x_1 = $m_s_reflect_ClassTag$();
  var this$1 = $n(this.sci_ArraySeq$ofRef__f_unsafeArray);
  return $n($x_1).apply__jl_Class__s_reflect_ClassTag($objectGetClass(this$1).getComponentType__jl_Class());
});
$c_sci_ArraySeq$ofRef.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofRef__f_unsafeArray).u.length;
});
$c_sci_ArraySeq$ofRef.prototype.apply__I__O = (function(i) {
  return $n(this.sci_ArraySeq$ofRef__f_unsafeArray).get(i);
});
$c_sci_ArraySeq$ofRef.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofRef__f_unsafeArray;
  return this$1.arrayHash__O__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofRef.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofRef)) {
    var x2 = $as_sci_ArraySeq$ofRef(that);
    return $m_s_Array$().equals__AO__AO__Z(this.sci_ArraySeq$ofRef__f_unsafeArray, $n(x2).sci_ArraySeq$ofRef__f_unsafeArray);
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofRef.prototype.sorted__s_math_Ordering__sci_ArraySeq$ofRef = (function(ord) {
  if (($n(this.sci_ArraySeq$ofRef__f_unsafeArray).u.length <= 1)) {
    return this;
  } else {
    var this$1 = $n(this.sci_ArraySeq$ofRef__f_unsafeArray);
    var a = $n(this$1).clone__O();
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(a, ord);
    return new $c_sci_ArraySeq$ofRef(a);
  }
});
$c_sci_ArraySeq$ofRef.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_ArrayOps$ArrayIterator__O__(new $c_sc_ArrayOps$ArrayIterator(), this.sci_ArraySeq$ofRef__f_unsafeArray);
});
$c_sci_ArraySeq$ofRef.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq$ofRef(ord);
});
$c_sci_ArraySeq$ofRef.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq$ofRef(ord);
});
$c_sci_ArraySeq$ofRef.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1));
});
$c_sci_ArraySeq$ofRef.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofRef__f_unsafeArray;
});
function $as_sci_ArraySeq$ofRef(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofRef) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofRef"));
}
function $isArrayOf_sci_ArraySeq$ofRef(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofRef)));
}
function $asArrayOf_sci_ArraySeq$ofRef(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofRef(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofRef;", depth));
}
var $d_sci_ArraySeq$ofRef = new $TypeData().initClass($c_sci_ArraySeq$ofRef, "scala.collection.immutable.ArraySeq$ofRef", ({
  sci_ArraySeq$ofRef: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofShort(unsafeArray) {
  this.sci_ArraySeq$ofShort__f_unsafeArray = null;
  this.sci_ArraySeq$ofShort__f_unsafeArray = unsafeArray;
}
$c_sci_ArraySeq$ofShort.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofShort.prototype.constructor = $c_sci_ArraySeq$ofShort;
/** @constructor */
function $h_sci_ArraySeq$ofShort() {
}
$h_sci_ArraySeq$ofShort.prototype = $c_sci_ArraySeq$ofShort.prototype;
$c_sci_ArraySeq$ofShort.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofShort__f_unsafeArray).u.length;
});
$c_sci_ArraySeq$ofShort.prototype.apply__I__S = (function(i) {
  return $n(this.sci_ArraySeq$ofShort__f_unsafeArray).get(i);
});
$c_sci_ArraySeq$ofShort.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofShort__f_unsafeArray;
  return this$1.arrayHash$mSc$sp__AS__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofShort.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofShort)) {
    var x2 = $as_sci_ArraySeq$ofShort(that);
    var a = this.sci_ArraySeq$ofShort__f_unsafeArray;
    var b = $n(x2).sci_ArraySeq$ofShort__f_unsafeArray;
    return $m_ju_Arrays$().equals__AS__AS__Z(a, b);
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofShort.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.length__I() <= 1)) {
    return this;
  } else if ((ord === $m_s_math_Ordering$Short$())) {
    var this$1 = $n(this.sci_ArraySeq$ofShort__f_unsafeArray);
    var a = $n(this$1).clone__O();
    $m_ju_Arrays$().sort__AS__V(a);
    return new $c_sci_ArraySeq$ofShort(a);
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord);
  }
});
$c_sci_ArraySeq$ofShort.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcS$sp(this.sci_ArraySeq$ofShort__f_unsafeArray);
});
$c_sci_ArraySeq$ofShort.prototype.appended__O__sci_ArraySeq = (function(elem) {
  if ($isShort(elem)) {
    var x2 = $uS(elem);
    var xs = this.sci_ArraySeq$ofShort__f_unsafeArray;
    var this$3 = $m_s_Array$();
    var newLength = ((1 + $n(xs).u.length) | 0);
    var this$4 = $n(xs);
    if ($d_S.getClassOf().isAssignableFrom__jl_Class__Z($objectGetClass(this$4).getComponentType__jl_Class())) {
      if ($d_S.getClassOf().isPrimitive__Z()) {
        var dest$1 = this$3.copyOf__O__I__O(xs, newLength);
      } else {
        var original = $asArrayOf_O(xs, 1);
        var dest$1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original, newLength, $d_S.getArrayOf().getClassOf());
      }
    } else {
      var dest = new $ac_S(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, $n(xs).u.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, $n(xs).u.length, x2);
    return new $c_sci_ArraySeq$ofShort($asArrayOf_S(dest$1, 1));
  } else {
    return $c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofShort.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  if ($isShort(elem)) {
    var x2 = $uS(elem);
    var xs = this.sci_ArraySeq$ofShort__f_unsafeArray;
    var len = ((1 + $n(xs).u.length) | 0);
    var dest = new $ac_S(len);
    dest.set(0, x2);
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, $n(xs).u.length);
    return new $c_sci_ArraySeq$ofShort(dest);
  } else {
    return $c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofShort.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofShort.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofShort.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord);
});
$c_sci_ArraySeq$ofShort.prototype.apply__O__O = (function(v1) {
  return this.apply__I__S($uI(v1));
});
$c_sci_ArraySeq$ofShort.prototype.apply__I__O = (function(i) {
  return this.apply__I__S(i);
});
$c_sci_ArraySeq$ofShort.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$ShortManifest$();
});
$c_sci_ArraySeq$ofShort.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofShort__f_unsafeArray;
});
function $as_sci_ArraySeq$ofShort(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofShort) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofShort"));
}
function $isArrayOf_sci_ArraySeq$ofShort(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofShort)));
}
function $asArrayOf_sci_ArraySeq$ofShort(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofShort(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofShort;", depth));
}
var $d_sci_ArraySeq$ofShort = new $TypeData().initClass($c_sci_ArraySeq$ofShort, "scala.collection.immutable.ArraySeq$ofShort", ({
  sci_ArraySeq$ofShort: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofUnit(unsafeArray) {
  this.sci_ArraySeq$ofUnit__f_unsafeArray = null;
  this.sci_ArraySeq$ofUnit__f_unsafeArray = unsafeArray;
}
$c_sci_ArraySeq$ofUnit.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofUnit.prototype.constructor = $c_sci_ArraySeq$ofUnit;
/** @constructor */
function $h_sci_ArraySeq$ofUnit() {
}
$h_sci_ArraySeq$ofUnit.prototype = $c_sci_ArraySeq$ofUnit.prototype;
$c_sci_ArraySeq$ofUnit.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofUnit__f_unsafeArray).u.length;
});
$c_sci_ArraySeq$ofUnit.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofUnit__f_unsafeArray;
  return this$1.arrayHash$mVc$sp__Ajl_Void__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofUnit.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofUnit)) {
    var x2 = $as_sci_ArraySeq$ofUnit(that);
    return ($n(this.sci_ArraySeq$ofUnit__f_unsafeArray).u.length === $n($n(x2).sci_ArraySeq$ofUnit__f_unsafeArray).u.length);
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofUnit.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcV$sp(this.sci_ArraySeq$ofUnit__f_unsafeArray);
});
$c_sci_ArraySeq$ofUnit.prototype.apply$mcVI$sp__I__V = (function(i) {
  $n(this.sci_ArraySeq$ofUnit__f_unsafeArray).get(i);
});
$c_sci_ArraySeq$ofUnit.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  this.apply$mcVI$sp__I__V(i);
});
$c_sci_ArraySeq$ofUnit.prototype.apply__I__O = (function(i) {
  this.apply$mcVI$sp__I__V(i);
});
$c_sci_ArraySeq$ofUnit.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$UnitManifest$();
});
$c_sci_ArraySeq$ofUnit.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofUnit__f_unsafeArray;
});
function $as_sci_ArraySeq$ofUnit(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofUnit) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofUnit"));
}
function $isArrayOf_sci_ArraySeq$ofUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofUnit)));
}
function $asArrayOf_sci_ArraySeq$ofUnit(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofUnit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofUnit;", depth));
}
var $d_sci_ArraySeq$ofUnit = new $TypeData().initClass($c_sci_ArraySeq$ofUnit, "scala.collection.immutable.ArraySeq$ofUnit", ({
  sci_ArraySeq$ofUnit: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
function $p_sci_List__filterCommon__F1__Z__sci_List($thiz, p, isFlipped) {
  var result = $p_sci_List__noneIn$1__sci_List__F1__Z__sci_List($thiz, $thiz, p, isFlipped);
  return result;
}
function $p_sci_List__loop$2__I__sci_List__I__I($thiz, i, xs, len$1) {
  while (true) {
    if ((i === len$1)) {
      return ($n(xs).isEmpty__Z() ? 0 : 1);
    } else if ($n(xs).isEmpty__Z()) {
      return (-1);
    } else {
      var temp$i = ((1 + i) | 0);
      var temp$xs = $as_sci_List($n(xs).tail__O());
      i = temp$i;
      xs = temp$xs;
    }
  }
}
function $p_sci_List__noneIn$1__sci_List__F1__Z__sci_List($thiz, l, p$1, isFlipped$1) {
  while (true) {
    if ($n(l).isEmpty__Z()) {
      return $m_sci_Nil$();
    } else {
      var h = $n(l).head__O();
      var t = $as_sci_List($n(l).tail__O());
      if (($uZ($n(p$1).apply__O__O(h)) !== isFlipped$1)) {
        return $p_sci_List__allIn$1__sci_List__sci_List__F1__Z__sci_List($thiz, l, t, p$1, isFlipped$1);
      } else {
        l = t;
      }
    }
  }
}
function $p_sci_List__allIn$1__sci_List__sci_List__F1__Z__sci_List($thiz, start, remaining, p$1, isFlipped$1) {
  while (true) {
    if ($n(remaining).isEmpty__Z()) {
      return start;
    } else {
      var x = $n(remaining).head__O();
      if (($uZ($n(p$1).apply__O__O(x)) !== isFlipped$1)) {
        remaining = $as_sci_List($n(remaining).tail__O());
      } else {
        return $p_sci_List__partialFill$1__sci_List__sci_List__F1__Z__sci_List($thiz, start, remaining, p$1, isFlipped$1);
      }
    }
  }
}
function $p_sci_List__partialFill$1__sci_List__sci_List__F1__Z__sci_List($thiz, origStart, firstMiss, p$1, isFlipped$1) {
  var newHead = new $c_sci_$colon$colon($n(origStart).head__O(), $m_sci_Nil$());
  var toProcess = $as_sci_List($n(origStart).tail__O());
  var currentLast = newHead;
  while ((toProcess !== firstMiss)) {
    var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
    $n(currentLast).sci_$colon$colon__f_next = newElem;
    currentLast = newElem;
    toProcess = $as_sci_List($n(toProcess).tail__O());
  }
  var next = $as_sci_List($n(firstMiss).tail__O());
  var nextToCopy = next;
  while ((!$n(next).isEmpty__Z())) {
    var head = $n(next).head__O();
    if (($uZ($n(p$1).apply__O__O(head)) !== isFlipped$1)) {
      next = $as_sci_List($n(next).tail__O());
    } else {
      while ((nextToCopy !== next)) {
        var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
        $n(currentLast).sci_$colon$colon__f_next = newElem$2;
        currentLast = newElem$2;
        nextToCopy = $as_sci_List($n(nextToCopy).tail__O());
      }
      nextToCopy = $as_sci_List($n(next).tail__O());
      next = $as_sci_List($n(next).tail__O());
    }
  }
  if ((!$n(nextToCopy).isEmpty__Z())) {
    $n(currentLast).sci_$colon$colon__f_next = nextToCopy;
  }
  return newHead;
}
function $p_sci_List__listEq$1__sci_List__sci_List__Z($thiz, a, b) {
  while (true) {
    if ((a === b)) {
      return true;
    } else {
      var aEmpty = $n(a).isEmpty__Z();
      var bEmpty = $n(b).isEmpty__Z();
      if (((!(aEmpty || bEmpty)) && $m_sr_BoxesRunTime$().equals__O__O__Z($n(a).head__O(), $n(b).head__O()))) {
        var temp$a = $as_sci_List($n(a).tail__O());
        var temp$b = $as_sci_List($n(b).tail__O());
        a = temp$a;
        b = temp$b;
      } else {
        return (aEmpty && bEmpty);
      }
    }
  }
}
/** @constructor */
function $c_sci_List() {
}
$c_sci_List.prototype = new $h_sci_AbstractSeq();
$c_sci_List.prototype.constructor = $c_sci_List;
/** @constructor */
function $h_sci_List() {
}
$h_sci_List.prototype = $c_sci_List.prototype;
$c_sci_List.prototype.distinctBy__F1__O = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$c_sci_List.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$c_sci_List.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this);
});
$c_sci_List.prototype.appended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$c_sci_List.prototype.padTo__I__O__O = (function(len, elem) {
  return $f_sc_StrictOptimizedSeqOps__padTo__I__O__O(this, len, elem);
});
$c_sci_List.prototype.flatten__F1__O = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$c_sci_List.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_sci_List.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$c_sci_List.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_List.prototype.stringPrefix__T = (function() {
  return "LinearSeq";
});
$c_sci_List.prototype.isDefinedAt__I__Z = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x);
});
$c_sci_List.prototype.apply__I__O = (function(n) {
  return $f_sc_LinearSeqOps__apply__I__O(this, n);
});
$c_sci_List.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_LinearSeqOps__foldLeft__O__F2__O(this, z, op);
});
$c_sci_List.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that);
});
$c_sci_List.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from);
});
$c_sci_List.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_List$();
});
$c_sci_List.prototype.$colon$colon$colon__sci_List__sci_List = (function(prefix) {
  if (this.isEmpty__Z()) {
    return prefix;
  } else if ($n(prefix).isEmpty__Z()) {
    return this;
  } else {
    var result = new $c_sci_$colon$colon($n(prefix).head__O(), this);
    var curr = result;
    var that = $as_sci_List($n(prefix).tail__O());
    while ((!$n(that).isEmpty__Z())) {
      var temp = new $c_sci_$colon$colon($n(that).head__O(), this);
      $n(curr).sci_$colon$colon__f_next = temp;
      curr = temp;
      that = $as_sci_List($n(that).tail__O());
    }
    return result;
  }
});
$c_sci_List.prototype.reverse_$colon$colon$colon__sci_List__sci_List = (function(prefix) {
  var these = this;
  var pres = prefix;
  while ((!$n(pres).isEmpty__Z())) {
    var rassoc$1 = $n(pres).head__O();
    var this$1 = $n(these);
    these = new $c_sci_$colon$colon(rassoc$1, this$1);
    pres = $as_sci_List($n(pres).tail__O());
  }
  return these;
});
$c_sci_List.prototype.isEmpty__Z = (function() {
  return (this === $m_sci_Nil$());
});
$c_sci_List.prototype.prepended__O__sci_List = (function(elem) {
  return new $c_sci_$colon$colon(elem, this);
});
$c_sci_List.prototype.prependedAll__sc_IterableOnce__sci_List = (function(prefix) {
  if ((prefix instanceof $c_sci_List)) {
    var x2 = $as_sci_List(prefix);
    return this.$colon$colon$colon__sci_List__sci_List(x2);
  }
  if (($n(prefix).knownSize__I() === 0)) {
    return this;
  }
  if ((prefix instanceof $c_scm_ListBuffer)) {
    var x3 = $as_scm_ListBuffer(prefix);
    if (this.isEmpty__Z()) {
      return $n(x3).toList__sci_List();
    }
  }
  var iter = $n(prefix).iterator__sc_Iterator();
  if ($n(iter).hasNext__Z()) {
    var result = new $c_sci_$colon$colon($n(iter).next__O(), this);
    var curr = result;
    while ($n(iter).hasNext__Z()) {
      var temp = new $c_sci_$colon$colon($n(iter).next__O(), this);
      $n(curr).sci_$colon$colon__f_next = temp;
      curr = temp;
    }
    return result;
  } else {
    return this;
  }
});
$c_sci_List.prototype.appendedAll__sc_IterableOnce__sci_List = (function(suffix) {
  if ((suffix instanceof $c_sci_List)) {
    var x2 = $as_sci_List(suffix);
    return $n(x2).$colon$colon$colon__sci_List__sci_List(this);
  } else {
    return $as_sci_List($f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix));
  }
});
$c_sci_List.prototype.take__I__sci_List = (function(n) {
  if ((this.isEmpty__Z() || (n <= 0))) {
    return $m_sci_Nil$();
  } else {
    var h = new $c_sci_$colon$colon(this.head__O(), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this.tail__O());
    var i = 1;
    while (true) {
      if ($n(rest).isEmpty__Z()) {
        return this;
      }
      if ((i < n)) {
        i = ((1 + i) | 0);
        var nx = new $c_sci_$colon$colon($n(rest).head__O(), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O());
      } else {
        break;
      }
    }
    return h;
  }
});
$c_sci_List.prototype.splitAt__I__T2 = (function(n) {
  var b = new $c_scm_ListBuffer();
  var i = 0;
  var these = this;
  while (((!$n(these).isEmpty__Z()) && (i < n))) {
    i = ((1 + i) | 0);
    var elem = $n(these).head__O();
    b.addOne__O__scm_ListBuffer(elem);
    these = $as_sci_List($n(these).tail__O());
  }
  return new $c_T2(b.toList__sci_List(), these);
});
$c_sci_List.prototype.map__F1__sci_List = (function(f) {
  if ((this === $m_sci_Nil$())) {
    return $m_sci_Nil$();
  } else {
    var h = new $c_sci_$colon$colon($n(f).apply__O__O(this.head__O()), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var nx = new $c_sci_$colon$colon($n(f).apply__O__O($n(rest).head__O()), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O());
    }
    return h;
  }
});
$c_sci_List.prototype.collect__s_PartialFunction__sci_List = (function(pf) {
  if ((this === $m_sci_Nil$())) {
    return $m_sci_Nil$();
  } else {
    var rest = this;
    var h = null;
    var x = null;
    while ((h === null)) {
      x = $n(pf).applyOrElse__O__F1__O($n(rest).head__O(), $m_sci_List$().sci_List$__f_partialNotApplied);
      if ((x !== $m_sci_List$().sci_List$__f_partialNotApplied)) {
        h = new $c_sci_$colon$colon(x, $m_sci_Nil$());
      }
      rest = $as_sci_List($n(rest).tail__O());
      if ((rest === $m_sci_Nil$())) {
        return ((h === null) ? $m_sci_Nil$() : h);
      }
    }
    var t = h;
    while ((rest !== $m_sci_Nil$())) {
      x = $n(pf).applyOrElse__O__F1__O($n(rest).head__O(), $m_sci_List$().sci_List$__f_partialNotApplied);
      if ((x !== $m_sci_List$().sci_List$__f_partialNotApplied)) {
        var nx = new $c_sci_$colon$colon(x, $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
      }
      rest = $as_sci_List($n(rest).tail__O());
    }
    return h;
  }
});
$c_sci_List.prototype.flatMap__F1__sci_List = (function(f) {
  var rest = this;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var it = $n($as_sc_IterableOnce($n(f).apply__O__O($n(rest).head__O()))).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var nx = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        $n(t).sci_$colon$colon__f_next = nx;
      }
      t = nx;
    }
    rest = $as_sci_List($n(rest).tail__O());
  }
  return ((h === null) ? $m_sci_Nil$() : h);
});
$c_sci_List.prototype.span__F1__T2 = (function(p) {
  var b = new $c_scm_ListBuffer();
  var these = this;
  while (((!$n(these).isEmpty__Z()) && $uZ($n(p).apply__O__O($n(these).head__O())))) {
    var elem = $n(these).head__O();
    b.addOne__O__scm_ListBuffer(elem);
    these = $as_sci_List($n(these).tail__O());
  }
  return new $c_T2(b.toList__sci_List(), these);
});
$c_sci_List.prototype.foreach__F1__V = (function(f) {
  var these = this;
  while ((!$n(these).isEmpty__Z())) {
    $n(f).apply__O__O($n(these).head__O());
    these = $as_sci_List($n(these).tail__O());
  }
});
$c_sci_List.prototype.reverse__sci_List = (function() {
  var result = $m_sci_Nil$();
  var these = this;
  while ((!$n(these).isEmpty__Z())) {
    var rassoc$6 = $n(these).head__O();
    var this$1 = $n(result);
    result = new $c_sci_$colon$colon(rassoc$6, this$1);
    these = $as_sci_List($n(these).tail__O());
  }
  return result;
});
$c_sci_List.prototype.length__I = (function() {
  var these = this;
  var len = 0;
  while ((!$n(these).isEmpty__Z())) {
    len = ((1 + len) | 0);
    these = $as_sci_List($n(these).tail__O());
  }
  return len;
});
$c_sci_List.prototype.lengthCompare__I__I = (function(len) {
  return ((len < 0) ? 1 : $p_sci_List__loop$2__I__sci_List__I__I(this, 0, this, len));
});
$c_sci_List.prototype.exists__F1__Z = (function(p) {
  var these = this;
  while ((!$n(these).isEmpty__Z())) {
    if ($uZ($n(p).apply__O__O($n(these).head__O()))) {
      return true;
    }
    these = $as_sci_List($n(these).tail__O());
  }
  return false;
});
$c_sci_List.prototype.contains__O__Z = (function(elem) {
  var these = this;
  while ((!$n(these).isEmpty__Z())) {
    if ($m_sr_BoxesRunTime$().equals__O__O__Z($n(these).head__O(), elem)) {
      return true;
    }
    these = $as_sci_List($n(these).tail__O());
  }
  return false;
});
$c_sci_List.prototype.find__F1__s_Option = (function(p) {
  var these = this;
  while ((!$n(these).isEmpty__Z())) {
    if ($uZ($n(p).apply__O__O($n(these).head__O()))) {
      return new $c_s_Some($n(these).head__O());
    }
    these = $as_sci_List($n(these).tail__O());
  }
  return $m_s_None$();
});
$c_sci_List.prototype.last__O = (function() {
  if (this.isEmpty__Z()) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "List.last");
  } else {
    var these = this;
    var scout = $as_sci_List(this.tail__O());
    while ((!$n(scout).isEmpty__Z())) {
      these = scout;
      scout = $as_sci_List($n(scout).tail__O());
    }
    return $n(these).head__O();
  }
});
$c_sci_List.prototype.className__T = (function() {
  return "List";
});
$c_sci_List.prototype.partition__F1__T2 = (function(p) {
  if (this.isEmpty__Z()) {
    return $m_sci_List$().sci_List$__f_scala$collection$immutable$List$$TupleOfNil;
  } else {
    var x1 = $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
    if ((x1 !== null)) {
      var p2 = $as_sci_List($n(x1)._1__O());
      var x = $m_sci_Nil$();
      if (x.equals__O__Z(p2)) {
        return new $c_T2($m_sci_Nil$(), this);
      }
    }
    if ((x1 !== null)) {
      var p4 = $as_sci_List($n(x1)._2__O());
      var x$3 = $m_sci_Nil$();
      if (x$3.equals__O__Z(p4)) {
        return new $c_T2(this, $m_sci_Nil$());
      }
    }
    return x1;
  }
});
$c_sci_List.prototype.toList__sci_List = (function() {
  return this;
});
$c_sci_List.prototype.equals__O__Z = (function(o) {
  if ((o instanceof $c_sci_List)) {
    var x2 = $as_sci_List(o);
    return $p_sci_List__listEq$1__sci_List__sci_List__Z(this, this, x2);
  } else {
    return $f_sc_Seq__equals__O__Z(this, o);
  }
});
$c_sci_List.prototype.apply__O__O = (function(v1) {
  var n = $uI(v1);
  return $f_sc_LinearSeqOps__apply__I__O(this, n);
});
$c_sci_List.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = $uI(x);
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1);
});
$c_sci_List.prototype.dropWhile__F1__O = (function(p) {
  return $p_sc_StrictOptimizedLinearSeqOps__loop$3__sc_LinearSeq__F1__sc_LinearSeq(this, this, p);
});
$c_sci_List.prototype.drop__I__O = (function(n) {
  return $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this, n, this);
});
$c_sci_List.prototype.filterNot__F1__O = (function(pred) {
  return $p_sci_List__filterCommon__F1__Z__sci_List(this, pred, true);
});
$c_sci_List.prototype.filter__F1__O = (function(pred) {
  return $p_sci_List__filterCommon__F1__Z__sci_List(this, pred, false);
});
$c_sci_List.prototype.reverse__O = (function() {
  return this.reverse__sci_List();
});
$c_sci_List.prototype.takeWhile__F1__O = (function(p) {
  var b = new $c_scm_ListBuffer();
  var these = this;
  while (((!$n(these).isEmpty__Z()) && $uZ($n(p).apply__O__O($n(these).head__O())))) {
    var elem = $n(these).head__O();
    b.addOne__O__scm_ListBuffer(elem);
    these = $as_sci_List($n(these).tail__O());
  }
  return b.toList__sci_List();
});
$c_sci_List.prototype.flatMap__F1__O = (function(f) {
  return this.flatMap__F1__sci_List(f);
});
$c_sci_List.prototype.collect__s_PartialFunction__O = (function(pf) {
  return this.collect__s_PartialFunction__sci_List(pf);
});
$c_sci_List.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_List(f);
});
$c_sci_List.prototype.take__I__O = (function(n) {
  return this.take__I__sci_List(n);
});
$c_sci_List.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_List(suffix);
});
$c_sci_List.prototype.prependedAll__sc_IterableOnce__O = (function(prefix) {
  return this.prependedAll__sc_IterableOnce__sci_List(prefix);
});
$c_sci_List.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_List(elem);
});
$c_sci_List.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_List$();
});
function $as_sci_List(obj) {
  return (((obj instanceof $c_sci_List) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.List"));
}
function $isArrayOf_sci_List(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_List)));
}
function $asArrayOf_sci_List(obj, depth) {
  return (($isArrayOf_sci_List(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.List;", depth));
}
function $p_sci_Queue__indexOutOfRange$1__I__E($thiz, n$1) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n$1));
}
function $ct_sci_Queue__sci_List__sci_List__($thiz, in$1, out) {
  $thiz.sci_Queue__f_in = in$1;
  $thiz.sci_Queue__f_out = out;
  return $thiz;
}
/** @constructor */
function $c_sci_Queue() {
  this.sci_Queue__f_in = null;
  this.sci_Queue__f_out = null;
}
$c_sci_Queue.prototype = new $h_sci_AbstractSeq();
$c_sci_Queue.prototype.constructor = $c_sci_Queue;
/** @constructor */
function $h_sci_Queue() {
}
$h_sci_Queue.prototype = $c_sci_Queue.prototype;
$c_sci_Queue.prototype.distinctBy__F1__O = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$c_sci_Queue.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$c_sci_Queue.prototype.prependedAll__sc_IterableOnce__O = (function(prefix) {
  return $f_sc_StrictOptimizedSeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$c_sci_Queue.prototype.padTo__I__O__O = (function(len, elem) {
  return $f_sc_StrictOptimizedSeqOps__padTo__I__O__O(this, len, elem);
});
$c_sci_Queue.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_sci_Queue.prototype.span__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__span__F1__T2(this, p);
});
$c_sci_Queue.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Queue.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_Queue.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_Queue.prototype.flatten__F1__O = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$c_sci_Queue.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_sci_Queue.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this);
});
$c_sci_Queue.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_sci_Queue.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$c_sci_Queue.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Queue.prototype.stringPrefix__T = (function() {
  return "LinearSeq";
});
$c_sci_Queue.prototype.headOption__s_Option = (function() {
  return $f_sc_LinearSeqOps__headOption__s_Option(this);
});
$c_sci_Queue.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_LinearSeqOps__lengthCompare__I__I(this, len);
});
$c_sci_Queue.prototype.isDefinedAt__I__Z = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x);
});
$c_sci_Queue.prototype.foreach__F1__V = (function(f) {
  $f_sc_LinearSeqOps__foreach__F1__V(this, f);
});
$c_sci_Queue.prototype.find__F1__s_Option = (function(p) {
  return $f_sc_LinearSeqOps__find__F1__s_Option(this, p);
});
$c_sci_Queue.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_LinearSeqOps__foldLeft__O__F2__O(this, z, op);
});
$c_sci_Queue.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that);
});
$c_sci_Queue.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from);
});
$c_sci_Queue.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_Queue$();
});
$c_sci_Queue.prototype.apply__I__O = (function(n) {
  var index = 0;
  var curr = this.sci_Queue__f_out;
  while (true) {
    if ((index < n)) {
      var this$1 = $n(curr);
      var $x_1 = (!this$1.isEmpty__Z());
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      index = ((1 + index) | 0);
      curr = $as_sci_List($n(curr).tail__O());
    } else {
      break;
    }
  }
  if ((index === n)) {
    var this$2 = $n(curr);
    if ((!this$2.isEmpty__Z())) {
      return $n(curr).head__O();
    } else {
      var this$3 = $n(this.sci_Queue__f_in);
      if ((!this$3.isEmpty__Z())) {
        return $n(this.sci_Queue__f_in).last__O();
      } else {
        $p_sci_Queue__indexOutOfRange$1__I__E(this, n);
      }
    }
  } else {
    var indexFromBack = ((n - index) | 0);
    var inLength = $n(this.sci_Queue__f_in).length__I();
    if ((indexFromBack >= inLength)) {
      $p_sci_Queue__indexOutOfRange$1__I__E(this, n);
    } else {
      var this$4 = $n(this.sci_Queue__f_in);
      var n$1 = (((-1) + ((inLength - indexFromBack) | 0)) | 0);
      return $f_sc_LinearSeqOps__apply__I__O(this$4, n$1);
    }
  }
});
$c_sci_Queue.prototype.iterator__sc_Iterator = (function() {
  return $n($n(this.sci_Queue__f_out).iterator__sc_Iterator()).concat__F0__sc_Iterator(new $c_sjsr_AnonFunction0((() => $n(this.sci_Queue__f_in).reverse__sci_List())));
});
$c_sci_Queue.prototype.isEmpty__Z = (function() {
  return ($n(this.sci_Queue__f_in).isEmpty__Z() && $n(this.sci_Queue__f_out).isEmpty__Z());
});
$c_sci_Queue.prototype.head__O = (function() {
  var this$1 = $n(this.sci_Queue__f_out);
  if ((!this$1.isEmpty__Z())) {
    return $n(this.sci_Queue__f_out).head__O();
  } else {
    var this$2 = $n(this.sci_Queue__f_in);
    if ((!this$2.isEmpty__Z())) {
      return $n(this.sci_Queue__f_in).last__O();
    } else {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head on empty queue");
    }
  }
});
$c_sci_Queue.prototype.tail__sci_Queue = (function() {
  var this$1 = $n(this.sci_Queue__f_out);
  if ((!this$1.isEmpty__Z())) {
    return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), this.sci_Queue__f_in, $as_sci_List($n(this.sci_Queue__f_out).tail__O()));
  } else {
    var this$2 = $n(this.sci_Queue__f_in);
    if ((!this$2.isEmpty__Z())) {
      return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), $as_sci_List($n($n(this.sci_Queue__f_in).reverse__sci_List()).tail__O()));
    } else {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "tail on empty queue");
    }
  }
});
$c_sci_Queue.prototype.last__O = (function() {
  var this$1 = $n(this.sci_Queue__f_in);
  if ((!this$1.isEmpty__Z())) {
    return $n(this.sci_Queue__f_in).head__O();
  } else {
    var this$2 = $n(this.sci_Queue__f_out);
    if ((!this$2.isEmpty__Z())) {
      return $n(this.sci_Queue__f_out).last__O();
    } else {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last on empty queue");
    }
  }
});
$c_sci_Queue.prototype.exists__F1__Z = (function(p) {
  return ($n(this.sci_Queue__f_in).exists__F1__Z(p) || $n(this.sci_Queue__f_out).exists__F1__Z(p));
});
$c_sci_Queue.prototype.className__T = (function() {
  return "Queue";
});
$c_sci_Queue.prototype.length__I = (function() {
  return (($n(this.sci_Queue__f_in).length__I() + $n(this.sci_Queue__f_out).length__I()) | 0);
});
$c_sci_Queue.prototype.prepended__O__sci_Queue = (function(elem) {
  var $x_1 = this.sci_Queue__f_in;
  var this$1 = $n(this.sci_Queue__f_out);
  return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $x_1, new $c_sci_$colon$colon(elem, this$1));
});
$c_sci_Queue.prototype.appendedAll__sc_IterableOnce__sci_Queue = (function(that) {
  if ((that instanceof $c_sci_Queue)) {
    var x2 = $as_sci_Queue(that);
    var this$1 = $n($n(x2).sci_Queue__f_in);
    var rassoc$2 = $n(x2).sci_Queue__f_out;
    var suffix = $n(this.sci_Queue__f_in).reverse_$colon$colon$colon__sci_List__sci_List(rassoc$2);
    var newIn = this$1.appendedAll__sc_IterableOnce__sci_List(suffix);
  } else if ((that instanceof $c_sci_List)) {
    var x3 = $as_sci_List(that);
    var newIn = $n(this.sci_Queue__f_in).reverse_$colon$colon$colon__sci_List__sci_List(x3);
  } else {
    var result = this.sci_Queue__f_in;
    var iter = $n(that).iterator__sc_Iterator();
    while ($n(iter).hasNext__Z()) {
      var rassoc$4 = $n(iter).next__O();
      var this$2 = $n(result);
      result = new $c_sci_$colon$colon(rassoc$4, this$2);
    }
    var newIn = result;
  }
  return ((newIn === this.sci_Queue__f_in) ? this : $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), newIn, this.sci_Queue__f_out));
});
$c_sci_Queue.prototype.enqueue__O__sci_Queue = (function(elem) {
  var this$1 = $n(this.sci_Queue__f_in);
  return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), new $c_sci_$colon$colon(elem, this$1), this.sci_Queue__f_out);
});
$c_sci_Queue.prototype.dequeue__T2 = (function() {
  var x1 = this.sci_Queue__f_out;
  var x = $m_sci_Nil$();
  if ((x.equals__O__Z(x1) && (!$n(this.sci_Queue__f_in).isEmpty__Z()))) {
    var rev = $n(this.sci_Queue__f_in).reverse__sci_List();
    return new $c_T2($n(rev).head__O(), $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), $as_sci_List($n(rev).tail__O())));
  } else if ((x1 instanceof $c_sci_$colon$colon)) {
    var x3 = $as_sci_$colon$colon(x1);
    var x$3 = $n(x3).sci_$colon$colon__f_head;
    var xs = $n(x3).sci_$colon$colon__f_next;
    return new $c_T2(x$3, $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), this.sci_Queue__f_in, xs));
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "dequeue on empty queue");
  }
});
$c_sci_Queue.prototype.toString__T = (function() {
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this, "Queue(", ", ", ")");
});
$c_sci_Queue.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = $uI(x);
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1);
});
$c_sci_Queue.prototype.dropWhile__F1__O = (function(p) {
  return $p_sc_StrictOptimizedLinearSeqOps__loop$3__sc_LinearSeq__F1__sc_LinearSeq(this, this, p);
});
$c_sci_Queue.prototype.drop__I__O = (function(n) {
  return $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this, n, this);
});
$c_sci_Queue.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_Queue(suffix);
});
$c_sci_Queue.prototype.appended__O__O = (function(elem) {
  return this.enqueue__O__sci_Queue(elem);
});
$c_sci_Queue.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Queue(elem);
});
$c_sci_Queue.prototype.tail__O = (function() {
  return this.tail__sci_Queue();
});
$c_sci_Queue.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1));
});
$c_sci_Queue.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Queue$();
});
function $as_sci_Queue(obj) {
  return (((obj instanceof $c_sci_Queue) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Queue"));
}
function $isArrayOf_sci_Queue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Queue)));
}
function $asArrayOf_sci_Queue(obj, depth) {
  return (($isArrayOf_sci_Queue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Queue;", depth));
}
var $d_sci_Queue = new $TypeData().initClass($c_sci_Queue, "scala.collection.immutable.Queue", ({
  sci_Queue: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_VectorImpl() {
  this.sci_Vector__f_prefix1 = null;
}
$c_sci_VectorImpl.prototype = new $h_sci_Vector();
$c_sci_VectorImpl.prototype.constructor = $c_sci_VectorImpl;
/** @constructor */
function $h_sci_VectorImpl() {
}
$h_sci_VectorImpl.prototype = $c_sci_VectorImpl.prototype;
$c_sci_VectorImpl.prototype.slice__I__I__sci_Vector = (function(from, until) {
  var lo = ((from > 0) ? from : 0);
  var b = this.length__I();
  var hi = ((until < b) ? until : b);
  return ((hi <= lo) ? $m_sci_Vector0$() : ((((hi - lo) | 0) === this.length__I()) ? this : this.slice0__I__I__sci_Vector(lo, hi)));
});
/** @constructor */
function $c_scm_ArraySeq$ofBoolean(array) {
  this.scm_ArraySeq$ofBoolean__f_array = null;
  this.scm_ArraySeq$ofBoolean__f_array = array;
}
$c_scm_ArraySeq$ofBoolean.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofBoolean.prototype.constructor = $c_scm_ArraySeq$ofBoolean;
/** @constructor */
function $h_scm_ArraySeq$ofBoolean() {
}
$h_scm_ArraySeq$ofBoolean.prototype = $c_scm_ArraySeq$ofBoolean.prototype;
$c_scm_ArraySeq$ofBoolean.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofBoolean__f_array).u.length;
});
$c_scm_ArraySeq$ofBoolean.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofBoolean__f_array;
  return this$1.arrayHash$mZc$sp__AZ__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofBoolean.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofBoolean)) {
    var x2 = $as_scm_ArraySeq$ofBoolean(that);
    var a = this.scm_ArraySeq$ofBoolean__f_array;
    var b = $n(x2).scm_ArraySeq$ofBoolean__f_array;
    return $m_ju_Arrays$().equals__AZ__AZ__Z(a, b);
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofBoolean.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcZ$sp(this.scm_ArraySeq$ofBoolean__f_array);
});
$c_scm_ArraySeq$ofBoolean.prototype.apply$mcZI$sp__I__Z = (function(index) {
  return $n(this.scm_ArraySeq$ofBoolean__f_array).get(index);
});
$c_scm_ArraySeq$ofBoolean.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcZI$sp__I__Z(index);
});
$c_scm_ArraySeq$ofBoolean.prototype.apply__I__O = (function(i) {
  return this.apply$mcZI$sp__I__Z(i);
});
$c_scm_ArraySeq$ofBoolean.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$BooleanManifest$();
});
$c_scm_ArraySeq$ofBoolean.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofBoolean__f_array;
});
function $as_scm_ArraySeq$ofBoolean(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofBoolean) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofBoolean"));
}
function $isArrayOf_scm_ArraySeq$ofBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofBoolean)));
}
function $asArrayOf_scm_ArraySeq$ofBoolean(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofBoolean(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofBoolean;", depth));
}
var $d_scm_ArraySeq$ofBoolean = new $TypeData().initClass($c_scm_ArraySeq$ofBoolean, "scala.collection.mutable.ArraySeq$ofBoolean", ({
  scm_ArraySeq$ofBoolean: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofByte(array) {
  this.scm_ArraySeq$ofByte__f_array = null;
  this.scm_ArraySeq$ofByte__f_array = array;
}
$c_scm_ArraySeq$ofByte.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofByte.prototype.constructor = $c_scm_ArraySeq$ofByte;
/** @constructor */
function $h_scm_ArraySeq$ofByte() {
}
$h_scm_ArraySeq$ofByte.prototype = $c_scm_ArraySeq$ofByte.prototype;
$c_scm_ArraySeq$ofByte.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofByte__f_array).u.length;
});
$c_scm_ArraySeq$ofByte.prototype.apply__I__B = (function(index) {
  return $n(this.scm_ArraySeq$ofByte__f_array).get(index);
});
$c_scm_ArraySeq$ofByte.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofByte__f_array;
  return this$1.arrayHash$mBc$sp__AB__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofByte.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofByte)) {
    var x2 = $as_scm_ArraySeq$ofByte(that);
    var a = this.scm_ArraySeq$ofByte__f_array;
    var b = $n(x2).scm_ArraySeq$ofByte__f_array;
    return $m_ju_Arrays$().equals__AB__AB__Z(a, b);
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofByte.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcB$sp(this.scm_ArraySeq$ofByte__f_array);
});
$c_scm_ArraySeq$ofByte.prototype.apply__O__O = (function(v1) {
  return this.apply__I__B($uI(v1));
});
$c_scm_ArraySeq$ofByte.prototype.apply__I__O = (function(i) {
  return this.apply__I__B(i);
});
$c_scm_ArraySeq$ofByte.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$ByteManifest$();
});
$c_scm_ArraySeq$ofByte.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofByte__f_array;
});
function $as_scm_ArraySeq$ofByte(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofByte) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofByte"));
}
function $isArrayOf_scm_ArraySeq$ofByte(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofByte)));
}
function $asArrayOf_scm_ArraySeq$ofByte(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofByte(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofByte;", depth));
}
var $d_scm_ArraySeq$ofByte = new $TypeData().initClass($c_scm_ArraySeq$ofByte, "scala.collection.mutable.ArraySeq$ofByte", ({
  scm_ArraySeq$ofByte: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofChar(array) {
  this.scm_ArraySeq$ofChar__f_array = null;
  this.scm_ArraySeq$ofChar__f_array = array;
}
$c_scm_ArraySeq$ofChar.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofChar.prototype.constructor = $c_scm_ArraySeq$ofChar;
/** @constructor */
function $h_scm_ArraySeq$ofChar() {
}
$h_scm_ArraySeq$ofChar.prototype = $c_scm_ArraySeq$ofChar.prototype;
$c_scm_ArraySeq$ofChar.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofChar__f_array).u.length;
});
$c_scm_ArraySeq$ofChar.prototype.apply__I__C = (function(index) {
  return $n(this.scm_ArraySeq$ofChar__f_array).get(index);
});
$c_scm_ArraySeq$ofChar.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofChar__f_array;
  return this$1.arrayHash$mCc$sp__AC__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofChar.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofChar)) {
    var x2 = $as_scm_ArraySeq$ofChar(that);
    var a = this.scm_ArraySeq$ofChar__f_array;
    var b = $n(x2).scm_ArraySeq$ofChar__f_array;
    return $m_ju_Arrays$().equals__AC__AC__Z(a, b);
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofChar.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcC$sp(this.scm_ArraySeq$ofChar__f_array);
});
$c_scm_ArraySeq$ofChar.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  var jsb = $n(sb).scm_StringBuilder__f_underlying;
  var this$1 = $n(start);
  if ((this$1.length !== 0)) {
    var this$2 = $n(jsb);
    this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start);
  }
  var len = $n(this.scm_ArraySeq$ofChar__f_array).u.length;
  if ((len !== 0)) {
    var this$3 = $n(sep);
    if ((this$3 === "")) {
      $n(jsb).append__AC__jl_StringBuilder(this.scm_ArraySeq$ofChar__f_array);
    } else {
      $n(jsb);
      $n(jsb).length__I();
      $n(end);
      $n(sep);
      var this$6 = $n(jsb);
      var c = $n(this.scm_ArraySeq$ofChar__f_array).get(0);
      var str = ("" + $cToS(c));
      this$6.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$6.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
      var i = 1;
      while ((i < len)) {
        var this$8 = $n(jsb);
        this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        var this$9 = $n(jsb);
        var c$1 = $n(this.scm_ArraySeq$ofChar__f_array).get(i);
        var str$1 = ("" + $cToS(c$1));
        this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$1);
        i = ((1 + i) | 0);
      }
    }
  }
  var this$11 = $n(end);
  if ((this$11.length !== 0)) {
    var this$12 = $n(jsb);
    this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end);
  }
  return sb;
});
$c_scm_ArraySeq$ofChar.prototype.apply__O__O = (function(v1) {
  return $bC(this.apply__I__C($uI(v1)));
});
$c_scm_ArraySeq$ofChar.prototype.apply__I__O = (function(i) {
  return $bC(this.apply__I__C(i));
});
$c_scm_ArraySeq$ofChar.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$CharManifest$();
});
$c_scm_ArraySeq$ofChar.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofChar__f_array;
});
function $as_scm_ArraySeq$ofChar(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofChar) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofChar"));
}
function $isArrayOf_scm_ArraySeq$ofChar(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofChar)));
}
function $asArrayOf_scm_ArraySeq$ofChar(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofChar(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofChar;", depth));
}
var $d_scm_ArraySeq$ofChar = new $TypeData().initClass($c_scm_ArraySeq$ofChar, "scala.collection.mutable.ArraySeq$ofChar", ({
  scm_ArraySeq$ofChar: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofDouble(array) {
  this.scm_ArraySeq$ofDouble__f_array = null;
  this.scm_ArraySeq$ofDouble__f_array = array;
}
$c_scm_ArraySeq$ofDouble.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofDouble.prototype.constructor = $c_scm_ArraySeq$ofDouble;
/** @constructor */
function $h_scm_ArraySeq$ofDouble() {
}
$h_scm_ArraySeq$ofDouble.prototype = $c_scm_ArraySeq$ofDouble.prototype;
$c_scm_ArraySeq$ofDouble.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofDouble__f_array).u.length;
});
$c_scm_ArraySeq$ofDouble.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofDouble__f_array;
  return this$1.arrayHash$mDc$sp__AD__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofDouble.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofDouble)) {
    var x2 = $as_scm_ArraySeq$ofDouble(that);
    var a = this.scm_ArraySeq$ofDouble__f_array;
    var b = $n(x2).scm_ArraySeq$ofDouble__f_array;
    return $m_ju_Arrays$().equals__AD__AD__Z(a, b);
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofDouble.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcD$sp(this.scm_ArraySeq$ofDouble__f_array);
});
$c_scm_ArraySeq$ofDouble.prototype.apply$mcDI$sp__I__D = (function(index) {
  return $n(this.scm_ArraySeq$ofDouble__f_array).get(index);
});
$c_scm_ArraySeq$ofDouble.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcDI$sp__I__D(index);
});
$c_scm_ArraySeq$ofDouble.prototype.apply__I__O = (function(i) {
  return this.apply$mcDI$sp__I__D(i);
});
$c_scm_ArraySeq$ofDouble.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$DoubleManifest$();
});
$c_scm_ArraySeq$ofDouble.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofDouble__f_array;
});
function $as_scm_ArraySeq$ofDouble(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofDouble) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofDouble"));
}
function $isArrayOf_scm_ArraySeq$ofDouble(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofDouble)));
}
function $asArrayOf_scm_ArraySeq$ofDouble(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofDouble(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofDouble;", depth));
}
var $d_scm_ArraySeq$ofDouble = new $TypeData().initClass($c_scm_ArraySeq$ofDouble, "scala.collection.mutable.ArraySeq$ofDouble", ({
  scm_ArraySeq$ofDouble: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofFloat(array) {
  this.scm_ArraySeq$ofFloat__f_array = null;
  this.scm_ArraySeq$ofFloat__f_array = array;
}
$c_scm_ArraySeq$ofFloat.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofFloat.prototype.constructor = $c_scm_ArraySeq$ofFloat;
/** @constructor */
function $h_scm_ArraySeq$ofFloat() {
}
$h_scm_ArraySeq$ofFloat.prototype = $c_scm_ArraySeq$ofFloat.prototype;
$c_scm_ArraySeq$ofFloat.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofFloat__f_array).u.length;
});
$c_scm_ArraySeq$ofFloat.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofFloat__f_array;
  return this$1.arrayHash$mFc$sp__AF__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofFloat.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofFloat)) {
    var x2 = $as_scm_ArraySeq$ofFloat(that);
    var a = this.scm_ArraySeq$ofFloat__f_array;
    var b = $n(x2).scm_ArraySeq$ofFloat__f_array;
    return $m_ju_Arrays$().equals__AF__AF__Z(a, b);
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofFloat.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcF$sp(this.scm_ArraySeq$ofFloat__f_array);
});
$c_scm_ArraySeq$ofFloat.prototype.apply$mcFI$sp__I__F = (function(index) {
  return $n(this.scm_ArraySeq$ofFloat__f_array).get(index);
});
$c_scm_ArraySeq$ofFloat.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcFI$sp__I__F(index);
});
$c_scm_ArraySeq$ofFloat.prototype.apply__I__O = (function(i) {
  return this.apply$mcFI$sp__I__F(i);
});
$c_scm_ArraySeq$ofFloat.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$FloatManifest$();
});
$c_scm_ArraySeq$ofFloat.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofFloat__f_array;
});
function $as_scm_ArraySeq$ofFloat(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofFloat) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofFloat"));
}
function $isArrayOf_scm_ArraySeq$ofFloat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofFloat)));
}
function $asArrayOf_scm_ArraySeq$ofFloat(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofFloat(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofFloat;", depth));
}
var $d_scm_ArraySeq$ofFloat = new $TypeData().initClass($c_scm_ArraySeq$ofFloat, "scala.collection.mutable.ArraySeq$ofFloat", ({
  scm_ArraySeq$ofFloat: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofInt(array) {
  this.scm_ArraySeq$ofInt__f_array = null;
  this.scm_ArraySeq$ofInt__f_array = array;
}
$c_scm_ArraySeq$ofInt.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofInt.prototype.constructor = $c_scm_ArraySeq$ofInt;
/** @constructor */
function $h_scm_ArraySeq$ofInt() {
}
$h_scm_ArraySeq$ofInt.prototype = $c_scm_ArraySeq$ofInt.prototype;
$c_scm_ArraySeq$ofInt.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofInt__f_array).u.length;
});
$c_scm_ArraySeq$ofInt.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofInt__f_array;
  return this$1.arrayHash$mIc$sp__AI__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofInt.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofInt)) {
    var x2 = $as_scm_ArraySeq$ofInt(that);
    var a = this.scm_ArraySeq$ofInt__f_array;
    var b = $n(x2).scm_ArraySeq$ofInt__f_array;
    return $m_ju_Arrays$().equals__AI__AI__Z(a, b);
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofInt.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcI$sp(this.scm_ArraySeq$ofInt__f_array);
});
$c_scm_ArraySeq$ofInt.prototype.apply$mcII$sp__I__I = (function(index) {
  return $n(this.scm_ArraySeq$ofInt__f_array).get(index);
});
$c_scm_ArraySeq$ofInt.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcII$sp__I__I(index);
});
$c_scm_ArraySeq$ofInt.prototype.apply__I__O = (function(i) {
  return this.apply$mcII$sp__I__I(i);
});
$c_scm_ArraySeq$ofInt.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$IntManifest$();
});
$c_scm_ArraySeq$ofInt.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofInt__f_array;
});
function $as_scm_ArraySeq$ofInt(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofInt) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofInt"));
}
function $isArrayOf_scm_ArraySeq$ofInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofInt)));
}
function $asArrayOf_scm_ArraySeq$ofInt(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofInt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofInt;", depth));
}
var $d_scm_ArraySeq$ofInt = new $TypeData().initClass($c_scm_ArraySeq$ofInt, "scala.collection.mutable.ArraySeq$ofInt", ({
  scm_ArraySeq$ofInt: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofLong(array) {
  this.scm_ArraySeq$ofLong__f_array = null;
  this.scm_ArraySeq$ofLong__f_array = array;
}
$c_scm_ArraySeq$ofLong.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofLong.prototype.constructor = $c_scm_ArraySeq$ofLong;
/** @constructor */
function $h_scm_ArraySeq$ofLong() {
}
$h_scm_ArraySeq$ofLong.prototype = $c_scm_ArraySeq$ofLong.prototype;
$c_scm_ArraySeq$ofLong.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofLong__f_array).u.length;
});
$c_scm_ArraySeq$ofLong.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofLong__f_array;
  return this$1.arrayHash$mJc$sp__AJ__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofLong.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofLong)) {
    var x2 = $as_scm_ArraySeq$ofLong(that);
    var a = this.scm_ArraySeq$ofLong__f_array;
    var b = $n(x2).scm_ArraySeq$ofLong__f_array;
    return $m_ju_Arrays$().equals__AJ__AJ__Z(a, b);
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofLong.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcJ$sp(this.scm_ArraySeq$ofLong__f_array);
});
$c_scm_ArraySeq$ofLong.prototype.apply$mcJI$sp__I__J = (function(index) {
  return $n(this.scm_ArraySeq$ofLong__f_array).get(index);
});
$c_scm_ArraySeq$ofLong.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcJI$sp__I__J(index);
});
$c_scm_ArraySeq$ofLong.prototype.apply__I__O = (function(i) {
  return this.apply$mcJI$sp__I__J(i);
});
$c_scm_ArraySeq$ofLong.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$LongManifest$();
});
$c_scm_ArraySeq$ofLong.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofLong__f_array;
});
function $as_scm_ArraySeq$ofLong(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofLong) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofLong"));
}
function $isArrayOf_scm_ArraySeq$ofLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofLong)));
}
function $asArrayOf_scm_ArraySeq$ofLong(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofLong;", depth));
}
var $d_scm_ArraySeq$ofLong = new $TypeData().initClass($c_scm_ArraySeq$ofLong, "scala.collection.mutable.ArraySeq$ofLong", ({
  scm_ArraySeq$ofLong: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofRef(array) {
  this.scm_ArraySeq$ofRef__f_array = null;
  this.scm_ArraySeq$ofRef__f_array = array;
}
$c_scm_ArraySeq$ofRef.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofRef.prototype.constructor = $c_scm_ArraySeq$ofRef;
/** @constructor */
function $h_scm_ArraySeq$ofRef() {
}
$h_scm_ArraySeq$ofRef.prototype = $c_scm_ArraySeq$ofRef.prototype;
$c_scm_ArraySeq$ofRef.prototype.elemTag__s_reflect_ClassTag = (function() {
  var $x_1 = $m_s_reflect_ClassTag$();
  var this$1 = $n(this.scm_ArraySeq$ofRef__f_array);
  return $n($x_1).apply__jl_Class__s_reflect_ClassTag($objectGetClass(this$1).getComponentType__jl_Class());
});
$c_scm_ArraySeq$ofRef.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofRef__f_array).u.length;
});
$c_scm_ArraySeq$ofRef.prototype.apply__I__O = (function(index) {
  return $n(this.scm_ArraySeq$ofRef__f_array).get(index);
});
$c_scm_ArraySeq$ofRef.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofRef__f_array;
  return this$1.arrayHash__O__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofRef.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofRef)) {
    var x2 = $as_scm_ArraySeq$ofRef(that);
    return $m_s_Array$().equals__AO__AO__Z(this.scm_ArraySeq$ofRef__f_array, $n(x2).scm_ArraySeq$ofRef__f_array);
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofRef.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_ArrayOps$ArrayIterator__O__(new $c_sc_ArrayOps$ArrayIterator(), this.scm_ArraySeq$ofRef__f_array);
});
$c_scm_ArraySeq$ofRef.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1));
});
$c_scm_ArraySeq$ofRef.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofRef__f_array;
});
function $as_scm_ArraySeq$ofRef(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofRef) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofRef"));
}
function $isArrayOf_scm_ArraySeq$ofRef(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofRef)));
}
function $asArrayOf_scm_ArraySeq$ofRef(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofRef(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofRef;", depth));
}
var $d_scm_ArraySeq$ofRef = new $TypeData().initClass($c_scm_ArraySeq$ofRef, "scala.collection.mutable.ArraySeq$ofRef", ({
  scm_ArraySeq$ofRef: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofShort(array) {
  this.scm_ArraySeq$ofShort__f_array = null;
  this.scm_ArraySeq$ofShort__f_array = array;
}
$c_scm_ArraySeq$ofShort.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofShort.prototype.constructor = $c_scm_ArraySeq$ofShort;
/** @constructor */
function $h_scm_ArraySeq$ofShort() {
}
$h_scm_ArraySeq$ofShort.prototype = $c_scm_ArraySeq$ofShort.prototype;
$c_scm_ArraySeq$ofShort.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofShort__f_array).u.length;
});
$c_scm_ArraySeq$ofShort.prototype.apply__I__S = (function(index) {
  return $n(this.scm_ArraySeq$ofShort__f_array).get(index);
});
$c_scm_ArraySeq$ofShort.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofShort__f_array;
  return this$1.arrayHash$mSc$sp__AS__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofShort.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofShort)) {
    var x2 = $as_scm_ArraySeq$ofShort(that);
    var a = this.scm_ArraySeq$ofShort__f_array;
    var b = $n(x2).scm_ArraySeq$ofShort__f_array;
    return $m_ju_Arrays$().equals__AS__AS__Z(a, b);
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofShort.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcS$sp(this.scm_ArraySeq$ofShort__f_array);
});
$c_scm_ArraySeq$ofShort.prototype.apply__O__O = (function(v1) {
  return this.apply__I__S($uI(v1));
});
$c_scm_ArraySeq$ofShort.prototype.apply__I__O = (function(i) {
  return this.apply__I__S(i);
});
$c_scm_ArraySeq$ofShort.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$ShortManifest$();
});
$c_scm_ArraySeq$ofShort.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofShort__f_array;
});
function $as_scm_ArraySeq$ofShort(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofShort) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofShort"));
}
function $isArrayOf_scm_ArraySeq$ofShort(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofShort)));
}
function $asArrayOf_scm_ArraySeq$ofShort(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofShort(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofShort;", depth));
}
var $d_scm_ArraySeq$ofShort = new $TypeData().initClass($c_scm_ArraySeq$ofShort, "scala.collection.mutable.ArraySeq$ofShort", ({
  scm_ArraySeq$ofShort: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofUnit(array) {
  this.scm_ArraySeq$ofUnit__f_array = null;
  this.scm_ArraySeq$ofUnit__f_array = array;
}
$c_scm_ArraySeq$ofUnit.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofUnit.prototype.constructor = $c_scm_ArraySeq$ofUnit;
/** @constructor */
function $h_scm_ArraySeq$ofUnit() {
}
$h_scm_ArraySeq$ofUnit.prototype = $c_scm_ArraySeq$ofUnit.prototype;
$c_scm_ArraySeq$ofUnit.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofUnit__f_array).u.length;
});
$c_scm_ArraySeq$ofUnit.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofUnit__f_array;
  return this$1.arrayHash$mVc$sp__Ajl_Void__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofUnit.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofUnit)) {
    var x2 = $as_scm_ArraySeq$ofUnit(that);
    return ($n(this.scm_ArraySeq$ofUnit__f_array).u.length === $n($n(x2).scm_ArraySeq$ofUnit__f_array).u.length);
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofUnit.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcV$sp(this.scm_ArraySeq$ofUnit__f_array);
});
$c_scm_ArraySeq$ofUnit.prototype.apply$mcVI$sp__I__V = (function(index) {
  $n(this.scm_ArraySeq$ofUnit__f_array).get(index);
});
$c_scm_ArraySeq$ofUnit.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  this.apply$mcVI$sp__I__V(index);
});
$c_scm_ArraySeq$ofUnit.prototype.apply__I__O = (function(i) {
  this.apply$mcVI$sp__I__V(i);
});
$c_scm_ArraySeq$ofUnit.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$UnitManifest$();
});
$c_scm_ArraySeq$ofUnit.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofUnit__f_array;
});
function $as_scm_ArraySeq$ofUnit(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofUnit) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofUnit"));
}
function $isArrayOf_scm_ArraySeq$ofUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofUnit)));
}
function $asArrayOf_scm_ArraySeq$ofUnit(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofUnit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofUnit;", depth));
}
var $d_scm_ArraySeq$ofUnit = new $TypeData().initClass($c_scm_ArraySeq$ofUnit, "scala.collection.mutable.ArraySeq$ofUnit", ({
  scm_ArraySeq$ofUnit: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
function $p_scm_HashMap__put0__O__O__I__Z__s_Some($thiz, key, value, hash, getOld) {
  if ((((1 + $thiz.scm_HashMap__f_contentSize) | 0) >= $thiz.scm_HashMap__f_threshold)) {
    $p_scm_HashMap__growTable__I__V($thiz, ($n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length << 1));
  }
  var idx = (hash & (((-1) + $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length) | 0));
  return $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, idx);
}
function $p_scm_HashMap__put0__O__O__Z__s_Some($thiz, key, value, getOld) {
  if ((((1 + $thiz.scm_HashMap__f_contentSize) | 0) >= $thiz.scm_HashMap__f_threshold)) {
    $p_scm_HashMap__growTable__I__V($thiz, ($n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length << 1));
  }
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var idx = (hash & (((-1) + $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length) | 0));
  return $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, idx);
}
function $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, idx) {
  var x1 = $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get(idx);
  if ((x1 === null)) {
    $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).set(idx, new $c_scm_HashMap$Node(key, hash, value, null));
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && ($n(n).scm_HashMap$Node__f__hash <= hash))) {
      if ((($n(n).scm_HashMap$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key, $n(n).scm_HashMap$Node__f__key))) {
        var old = $n(n).scm_HashMap$Node__f__value;
        $n(n).scm_HashMap$Node__f__value = value;
        return (getOld ? new $c_s_Some(old) : null);
      }
      prev = n;
      n = $n(n).scm_HashMap$Node__f__next;
    }
    if ((prev === null)) {
      $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).set(idx, new $c_scm_HashMap$Node(key, hash, value, x1));
    } else {
      $n(prev).scm_HashMap$Node__f__next = new $c_scm_HashMap$Node(key, hash, value, $n(prev).scm_HashMap$Node__f__next);
    }
  }
  $thiz.scm_HashMap__f_contentSize = ((1 + $thiz.scm_HashMap__f_contentSize) | 0);
  return null;
}
function $p_scm_HashMap__remove0__O__scm_HashMap$Node($thiz, elem) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(elem);
  return $p_scm_HashMap__remove0__O__I__scm_HashMap$Node($thiz, elem, (originalHash ^ ((originalHash >>> 16) | 0)));
}
function $p_scm_HashMap__remove0__O__I__scm_HashMap$Node($thiz, elem, hash) {
  var idx = (hash & (((-1) + $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length) | 0));
  var x1 = $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get(idx);
  if ((x1 === null)) {
    return null;
  } else if ((($n(x1).scm_HashMap$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z($n(x1).scm_HashMap$Node__f__key, elem))) {
    $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).set(idx, $n(x1).scm_HashMap$Node__f__next);
    $thiz.scm_HashMap__f_contentSize = (((-1) + $thiz.scm_HashMap__f_contentSize) | 0);
    return x1;
  } else {
    var prev = x1;
    var next = $n(x1).scm_HashMap$Node__f__next;
    while (((next !== null) && ($n(next).scm_HashMap$Node__f__hash <= hash))) {
      if ((($n(next).scm_HashMap$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z($n(next).scm_HashMap$Node__f__key, elem))) {
        $n(prev).scm_HashMap$Node__f__next = $n(next).scm_HashMap$Node__f__next;
        $thiz.scm_HashMap__f_contentSize = (((-1) + $thiz.scm_HashMap__f_contentSize) | 0);
        return next;
      }
      prev = next;
      next = $n(next).scm_HashMap$Node__f__next;
    }
    return null;
  }
}
function $p_scm_HashMap__growTable__I__V($thiz, newlen) {
  if ((newlen < 0)) {
    throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), (("new HashMap table size " + newlen) + " exceeds maximum"));
  }
  var oldlen = $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length;
  $thiz.scm_HashMap__f_threshold = $p_scm_HashMap__newThreshold__I__I($thiz, newlen);
  if (($thiz.scm_HashMap__f_contentSize === 0)) {
    $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table = new ($d_scm_HashMap$Node.getArrayOf().constr)(newlen);
  } else {
    var original = $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table;
    $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table = $asArrayOf_scm_HashMap$Node($m_ju_Arrays$().copyOf__AO__I__AO(original, newlen), 1);
    var preLow = new $c_scm_HashMap$Node(null, 0, null, null);
    var preHigh = new $c_scm_HashMap$Node(null, 0, null, null);
    while ((oldlen < newlen)) {
      var i = 0;
      while ((i < oldlen)) {
        var old = $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get(i);
        if ((old !== null)) {
          preLow.scm_HashMap$Node__f__next = null;
          preHigh.scm_HashMap$Node__f__next = null;
          var lastLow = preLow;
          var lastHigh = preHigh;
          var n = old;
          while ((n !== null)) {
            var next = $n(n).scm_HashMap$Node__f__next;
            if ((($n(n).scm_HashMap$Node__f__hash & oldlen) === 0)) {
              $n(lastLow).scm_HashMap$Node__f__next = n;
              lastLow = n;
            } else {
              $n(lastHigh).scm_HashMap$Node__f__next = n;
              lastHigh = n;
            }
            n = next;
          }
          $n(lastLow).scm_HashMap$Node__f__next = null;
          if ((old !== preLow.scm_HashMap$Node__f__next)) {
            $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).set(i, preLow.scm_HashMap$Node__f__next);
          }
          if ((preHigh.scm_HashMap$Node__f__next !== null)) {
            $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).set(((i + oldlen) | 0), preHigh.scm_HashMap$Node__f__next);
            $n(lastHigh).scm_HashMap$Node__f__next = null;
          }
        }
        i = ((1 + i) | 0);
      }
      oldlen = (oldlen << 1);
    }
  }
}
function $p_scm_HashMap__tableSizeFor__I__I($thiz, capacity) {
  var x = (((-1) + capacity) | 0);
  var i = ((x > 4) ? x : 4);
  var x$1 = ((((-2147483648) >> $uI(Math.clz32(i))) & i) << 1);
  return ((x$1 < 1073741824) ? x$1 : 1073741824);
}
function $p_scm_HashMap__newThreshold__I__I($thiz, size) {
  return $doubleToInt((size * $thiz.scm_HashMap__f_loadFactor));
}
function $ct_scm_HashMap__I__D__($thiz, initialCapacity, loadFactor) {
  $thiz.scm_HashMap__f_loadFactor = loadFactor;
  $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table = new ($d_scm_HashMap$Node.getArrayOf().constr)($p_scm_HashMap__tableSizeFor__I__I($thiz, initialCapacity));
  $thiz.scm_HashMap__f_threshold = $p_scm_HashMap__newThreshold__I__I($thiz, $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length);
  $thiz.scm_HashMap__f_contentSize = 0;
  return $thiz;
}
function $ct_scm_HashMap__($thiz) {
  $ct_scm_HashMap__I__D__($thiz, 16, 0.75);
  return $thiz;
}
/** @constructor */
function $c_scm_HashMap() {
  this.scm_HashMap__f_loadFactor = 0.0;
  this.scm_HashMap__f_scala$collection$mutable$HashMap$$table = null;
  this.scm_HashMap__f_threshold = 0;
  this.scm_HashMap__f_contentSize = 0;
}
$c_scm_HashMap.prototype = new $h_scm_AbstractMap();
$c_scm_HashMap.prototype.constructor = $c_scm_HashMap;
/** @constructor */
function $h_scm_HashMap() {
}
$h_scm_HashMap.prototype = $c_scm_HashMap.prototype;
$c_scm_HashMap.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return $f_sc_StrictOptimizedMapOps__concat__sc_IterableOnce__sc_IterableOps(this, suffix);
});
$c_scm_HashMap.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_scm_HashMap.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_scm_HashMap.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_scm_HashMap.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_scm_HashMap.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_scm_HashMap.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$c_scm_HashMap.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_scm_HashMap.prototype.size__I = (function() {
  return this.scm_HashMap__f_contentSize;
});
$c_scm_HashMap.prototype.contains__O__Z = (function(key) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get((hash & (((-1) + $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length) | 0)));
  return (((x1 === null) ? null : $n(x1).findNode__O__I__scm_HashMap$Node(key, hash)) !== null);
});
$c_scm_HashMap.prototype.sizeHint__I__V = (function(size) {
  var target = $p_scm_HashMap__tableSizeFor__I__I(this, $doubleToInt((((1 + size) | 0) / this.scm_HashMap__f_loadFactor)));
  if ((target > $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length)) {
    $p_scm_HashMap__growTable__I__V(this, target);
  }
});
$c_scm_HashMap.prototype.addAll__sc_IterableOnce__scm_HashMap = (function(xs) {
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(this, xs, 0);
  if ((xs instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(xs);
    var this$2 = $n(x2);
    var f = new $c_sjsr_AnonFunction3(((k$2, v$2, h$2) => {
      var h = $uI(h$2);
      $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, k$2, v$2, (h ^ ((h >>> 16) | 0)), false);
    }));
    $n(this$2.sci_HashMap__f_rootNode).foreachWithHash__F3__V(f);
    return this;
  } else if ((xs instanceof $c_scm_HashMap)) {
    var x3 = $as_scm_HashMap(xs);
    var iter = $n(x3).nodeIterator__sc_Iterator();
    while ($n(iter).hasNext__Z()) {
      var next = $as_scm_HashMap$Node($n(iter).next__O());
      $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, $n(next).scm_HashMap$Node__f__key, $n(next).scm_HashMap$Node__f__value, $n(next).scm_HashMap$Node__f__hash, false);
    }
    return this;
  } else if (false) {
    var x4 = $as_scm_LinkedHashMap(xs);
    var iter$2 = $n(x4).entryIterator__sc_Iterator();
    while ($n(iter$2).hasNext__Z()) {
      var entry = $as_scm_LinkedHashMap$LinkedEntry($n(iter$2).next__O());
      $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, $n(entry).key__O(), $n(entry).value__O(), $n(entry).hash__I(), false);
    }
    return this;
  } else if ($is_scm_Map(xs)) {
    var x5 = $as_scm_Map(xs);
    $n(x5).foreachEntry__F2__V(new $c_sjsr_AnonFunction2(((key$2, value$2) => {
      var originalHash = $m_sr_Statics$().anyHash__O__I(key$2);
      return $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, key$2, value$2, (originalHash ^ ((originalHash >>> 16) | 0)), false);
    })));
    return this;
  } else {
    return $as_scm_HashMap($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs));
  }
});
$c_scm_HashMap.prototype.iterator__sc_Iterator = (function() {
  return ((this.scm_HashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_HashMap$$anon$1(this));
});
$c_scm_HashMap.prototype.keysIterator__sc_Iterator = (function() {
  return ((this.scm_HashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_HashMap$$anon$2(this));
});
$c_scm_HashMap.prototype.valuesIterator__sc_Iterator = (function() {
  return ((this.scm_HashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_HashMap$$anon$3(this));
});
$c_scm_HashMap.prototype.nodeIterator__sc_Iterator = (function() {
  return ((this.scm_HashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_HashMap$$anon$4(this));
});
$c_scm_HashMap.prototype.get__O__s_Option = (function(key) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get((hash & (((-1) + $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length) | 0)));
  var x1$1 = ((x1 === null) ? null : $n(x1).findNode__O__I__scm_HashMap$Node(key, hash));
  return ((x1$1 === null) ? $m_s_None$() : new $c_s_Some($n(x1$1).scm_HashMap$Node__f__value));
});
$c_scm_HashMap.prototype.apply__O__O = (function(key) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get((hash & (((-1) + $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length) | 0)));
  var x1$1 = ((x1 === null) ? null : $n(x1).findNode__O__I__scm_HashMap$Node(key, hash));
  return ((x1$1 === null) ? $f_sc_MapOps__default__O__O(this, key) : $n(x1$1).scm_HashMap$Node__f__value);
});
$c_scm_HashMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  var x = $objectGetClass(this);
  if ((!(x === $d_scm_HashMap.getClassOf()))) {
    return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1);
  } else {
    var originalHash = $m_sr_Statics$().anyHash__O__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1 = $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get((hash & (((-1) + $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length) | 0)));
    var nd = ((x1 === null) ? null : $n(x1).findNode__O__I__scm_HashMap$Node(key, hash));
    return ((nd === null) ? $n(default$1).apply__O() : $n(nd).scm_HashMap$Node__f__value);
  }
});
$c_scm_HashMap.prototype.getOrElseUpdate__O__F0__O = (function(key, defaultValue) {
  var x = $objectGetClass(this);
  if ((!(x === $d_scm_HashMap.getClassOf()))) {
    return $f_scm_MapOps__getOrElseUpdate__O__F0__O(this, key, defaultValue);
  } else {
    var originalHash = $m_sr_Statics$().anyHash__O__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var idx = (hash & (((-1) + $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length) | 0));
    var x1 = $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get(idx);
    var nd = ((x1 === null) ? null : $n(x1).findNode__O__I__scm_HashMap$Node(key, hash));
    if ((nd !== null)) {
      return $n(nd).scm_HashMap$Node__f__value;
    } else {
      var table0 = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table;
      var default$1 = $n(defaultValue).apply__O();
      if ((((1 + this.scm_HashMap__f_contentSize) | 0) >= this.scm_HashMap__f_threshold)) {
        $p_scm_HashMap__growTable__I__V(this, ($n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length << 1));
      }
      var newIdx = ((table0 === this.scm_HashMap__f_scala$collection$mutable$HashMap$$table) ? idx : (hash & (((-1) + $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length) | 0)));
      $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(this, key, default$1, false, hash, newIdx);
      return default$1;
    }
  }
});
$c_scm_HashMap.prototype.update__O__O__V = (function(key, value) {
  $p_scm_HashMap__put0__O__O__Z__s_Some(this, key, value, false);
});
$c_scm_HashMap.prototype.addOne__T2__scm_HashMap = (function(elem) {
  $p_scm_HashMap__put0__O__O__Z__s_Some(this, $n(elem)._1__O(), $n(elem)._2__O(), false);
  return this;
});
$c_scm_HashMap.prototype.subtractOne__O__scm_HashMap = (function(elem) {
  $p_scm_HashMap__remove0__O__scm_HashMap$Node(this, elem);
  return this;
});
$c_scm_HashMap.prototype.knownSize__I = (function() {
  return this.scm_HashMap__f_contentSize;
});
$c_scm_HashMap.prototype.isEmpty__Z = (function() {
  return (this.scm_HashMap__f_contentSize === 0);
});
$c_scm_HashMap.prototype.foreach__F1__V = (function(f) {
  var len = $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length;
  var i = 0;
  while ((i < len)) {
    var n = $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get(i);
    if ((n !== null)) {
      $n(n).foreach__F1__V(f);
    }
    i = ((1 + i) | 0);
  }
});
$c_scm_HashMap.prototype.foreachEntry__F2__V = (function(f) {
  var len = $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length;
  var i = 0;
  while ((i < len)) {
    var n = $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get(i);
    if ((n !== null)) {
      $n(n).foreachEntry__F2__V(f);
    }
    i = ((1 + i) | 0);
  }
});
$c_scm_HashMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_scm_HashMap$();
});
$c_scm_HashMap.prototype.stringPrefix__T = (function() {
  return "HashMap";
});
$c_scm_HashMap.prototype.hashCode__I = (function() {
  if (this.isEmpty__Z()) {
    return $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_emptyMapHash;
  } else {
    var tupleHashIterator = new $c_scm_HashMap$$anon$5(this);
    return $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(tupleHashIterator, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed);
  }
});
$c_scm_HashMap.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_HashMap(elem);
});
$c_scm_HashMap.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__scm_HashMap($as_T2(elem));
});
$c_scm_HashMap.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_HashMap(elems);
});
function $as_scm_HashMap(obj) {
  return (((obj instanceof $c_scm_HashMap) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.HashMap"));
}
function $isArrayOf_scm_HashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_HashMap)));
}
function $asArrayOf_scm_HashMap(obj, depth) {
  return (($isArrayOf_scm_HashMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.HashMap;", depth));
}
var $d_scm_HashMap = new $TypeData().initClass($c_scm_HashMap, "scala.collection.mutable.HashMap", ({
  scm_HashMap: 1,
  scm_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  scm_Map: 1,
  scm_Iterable: 1,
  scm_MapOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_StrictOptimizedMapOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_package$$anon$1() {
}
$c_Lcats_package$$anon$1.prototype = new $h_O();
$c_Lcats_package$$anon$1.prototype.constructor = $c_Lcats_package$$anon$1;
/** @constructor */
function $h_Lcats_package$$anon$1() {
}
$h_Lcats_package$$anon$1.prototype = $c_Lcats_package$$anon$1.prototype;
$c_Lcats_package$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_package$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_package$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_package$$anon$1.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_package$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_package$$anon$1.prototype.unit__O = (function() {
  return (void 0);
});
$c_Lcats_package$$anon$1.prototype.reduceLeftOption__O__F2__s_Option = (function(fa, f) {
  return $f_Lcats_Foldable__reduceLeftOption__O__F2__s_Option(this, fa, f);
});
$c_Lcats_package$$anon$1.prototype.fold__O__Lcats_kernel_Monoid__O = (function(fa, A) {
  return $f_Lcats_Foldable__fold__O__Lcats_kernel_Monoid__O(this, fa, A);
});
$c_Lcats_package$$anon$1.prototype.toIterable__O__sc_Iterable = (function(fa) {
  return $m_Lcats_compat_FoldableCompat$().toIterable__O__Lcats_Foldable__sc_Iterable(fa, this);
});
$c_Lcats_package$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O(this, fa, z, f, G);
});
$c_Lcats_package$$anon$1.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverse___O__F1__Lcats_Applicative__O(this, fa, f, G);
});
$c_Lcats_package$$anon$1.prototype.toList__O__sci_List = (function(fa) {
  return $f_Lcats_Foldable__toList__O__sci_List(this, fa);
});
$c_Lcats_package$$anon$1.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return $n(f).apply__O__O(fa);
});
$c_Lcats_package$$anon$1.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$1) {
  return $n(f).apply__O__O(sa);
});
$c_Lcats_package$$anon$1.prototype.maximumOption__O__Lcats_kernel_Order__s_Option = (function(fa, A) {
  return $f_Lcats_Reducible__maximumOption__O__Lcats_kernel_Order__s_Option(this, fa, A);
});
$c_Lcats_package$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return $n(f).apply__O__O(fa);
});
$c_Lcats_package$$anon$1.prototype.pure__O__O = (function(a) {
  return a;
});
$c_Lcats_package$$anon$1.prototype.flatMap__O__F1__O = (function(a, f) {
  return $n(f).apply__O__O(a);
});
$c_Lcats_package$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  var a$tailLocal1 = a;
  while (true) {
    var x1 = $as_s_util_Either($n(f).apply__O__O(a$tailLocal1));
    if ((x1 instanceof $c_s_util_Left)) {
      var a1 = $n($as_s_util_Left(x1)).s_util_Left__f_value;
      a$tailLocal1 = a1;
      continue;
    }
    if ((x1 instanceof $c_s_util_Right)) {
      var b = $n($as_s_util_Right(x1)).s_util_Right__f_value;
      return b;
    }
    throw new $c_s_MatchError(x1);
  }
});
$c_Lcats_package$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  return $n(f).apply__O__O(fa);
});
$c_Lcats_package$$anon$1.prototype.flatten__O__O = (function(ffa) {
  return ffa;
});
$c_Lcats_package$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $n(f).apply__O__O__O(fa, fb);
});
$c_Lcats_package$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $n(fb).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((_$8) => $n(f).apply__O__O__O(fa, _$8))));
});
$c_Lcats_package$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  return $n(f).apply__O__O(fa);
});
$c_Lcats_package$$anon$1.prototype.foldLeft__O__O__F2__O = (function(a, b, f) {
  return $n(f).apply__O__O__O(b, a);
});
$c_Lcats_package$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(a, lb, f) {
  return $as_Lcats_Eval($n(f).apply__O__O__O(a, lb));
});
$c_Lcats_package$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return $n(f).apply__O__O(fa);
});
$c_Lcats_package$$anon$1.prototype.reduceLeftTo__O__F1__F2__O = (function(fa, f, g) {
  return $n(f).apply__O__O(fa);
});
$c_Lcats_package$$anon$1.prototype.reduceLeft__O__F2__O = (function(fa, f) {
  return fa;
});
$c_Lcats_package$$anon$1.prototype.reduceLeftToOption__O__F1__F2__s_Option = (function(fa, f, g) {
  var value = $n(f).apply__O__O(fa);
  return new $c_s_Some(value);
});
$c_Lcats_package$$anon$1.prototype.size__O__J = (function(fa) {
  return new $c_RTLong(1, 0);
});
$c_Lcats_package$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  var ff$1 = $as_F1(ff);
  return $n(ff$1).apply__O__O(fa);
});
var $d_Lcats_package$$anon$1 = new $TypeData().initClass($c_Lcats_package$$anon$1, "cats.package$$anon$1", ({
  Lcats_package$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Comonad: 1,
  Lcats_Bimonad: 1,
  Lcats_CommutativeApply: 1,
  Lcats_CommutativeFlatMap: 1,
  Lcats_CommutativeApplicative: 1,
  Lcats_CommutativeMonad: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Reducible: 1,
  Lcats_NonEmptyTraverse: 1,
  Lcats_Distributive: 1
}));
function $ct_sci_BigVector__AO__AO__I__($thiz, _prefix1, suffix1, length0) {
  $thiz.sci_BigVector__f_suffix1 = suffix1;
  $thiz.sci_BigVector__f_length0 = length0;
  $ct_sci_Vector__AO__($thiz, _prefix1);
  return $thiz;
}
/** @constructor */
function $c_sci_BigVector() {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
}
$c_sci_BigVector.prototype = new $h_sci_VectorImpl();
$c_sci_BigVector.prototype.constructor = $c_sci_BigVector;
/** @constructor */
function $h_sci_BigVector() {
}
$h_sci_BigVector.prototype = $c_sci_BigVector.prototype;
$c_sci_BigVector.prototype.foreachRest__F1__V = (function(f) {
  var c = this.vectorSliceCount__I();
  var i = 1;
  while ((i < c)) {
    var $x_1 = $m_sci_VectorStatics$();
    var idx = i;
    var c$1 = ((c / 2) | 0);
    var a = ((idx - c$1) | 0);
    $n($x_1).foreachRec__I__AO__F1__V((((-1) + ((((1 + c$1) | 0) - ((a < 0) ? ((-a) | 0) : a)) | 0)) | 0), this.vectorSlice__I__AO(i), f);
    i = ((1 + i) | 0);
  }
});
function $as_sci_BigVector(obj) {
  return (((obj instanceof $c_sci_BigVector) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.BigVector"));
}
function $isArrayOf_sci_BigVector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BigVector)));
}
function $asArrayOf_sci_BigVector(obj, depth) {
  return (($isArrayOf_sci_BigVector(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.BigVector;", depth));
}
/** @constructor */
function $c_sci_Queue$EmptyQueue$() {
  this.sci_Queue__f_in = null;
  this.sci_Queue__f_out = null;
  $ct_sci_Queue__sci_List__sci_List__(this, $m_sci_Nil$(), $m_sci_Nil$());
}
$c_sci_Queue$EmptyQueue$.prototype = new $h_sci_Queue();
$c_sci_Queue$EmptyQueue$.prototype.constructor = $c_sci_Queue$EmptyQueue$;
/** @constructor */
function $h_sci_Queue$EmptyQueue$() {
}
$h_sci_Queue$EmptyQueue$.prototype = $c_sci_Queue$EmptyQueue$.prototype;
var $d_sci_Queue$EmptyQueue$ = new $TypeData().initClass($c_sci_Queue$EmptyQueue$, "scala.collection.immutable.Queue$EmptyQueue$", ({
  sci_Queue$EmptyQueue$: 1,
  sci_Queue: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_Queue$EmptyQueue$;
function $m_sci_Queue$EmptyQueue$() {
  if ((!$n_sci_Queue$EmptyQueue$)) {
    $n_sci_Queue$EmptyQueue$ = new $c_sci_Queue$EmptyQueue$();
  }
  return $n_sci_Queue$EmptyQueue$;
}
/** @constructor */
function $c_sci_Vector1(_data1) {
  this.sci_Vector__f_prefix1 = null;
  $ct_sci_Vector__AO__(this, _data1);
}
$c_sci_Vector1.prototype = new $h_sci_VectorImpl();
$c_sci_Vector1.prototype.constructor = $c_sci_Vector1;
/** @constructor */
function $h_sci_Vector1() {
}
$h_sci_Vector1.prototype = $c_sci_Vector1.prototype;
$c_sci_Vector1.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < $n(this.sci_Vector__f_prefix1).u.length))) {
    return $n(this.sci_Vector__f_prefix1).get(index);
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
$c_sci_Vector1.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < $n(this.sci_Vector__f_prefix1).u.length))) {
    var a1 = this.sci_Vector__f_prefix1;
    var this$2 = $n(a1);
    var a1c = $n(this$2).clone__O();
    $n(a1c).set(index, elem);
    return new $c_sci_Vector1(a1c);
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
$c_sci_Vector1.prototype.appended__O__sci_Vector = (function(elem) {
  var len1 = $n(this.sci_Vector__f_prefix1).u.length;
  if ((len1 < 32)) {
    return new $c_sci_Vector1($m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_Vector__f_prefix1, elem));
  } else {
    var $x_2 = this.sci_Vector__f_prefix1;
    var $x_1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a = new $ac_O(1);
    $n(a).set(0, elem);
    return new $c_sci_Vector2($x_2, 32, $x_1, a, 33);
  }
});
$c_sci_Vector1.prototype.prepended__O__sci_Vector = (function(elem) {
  var len1 = $n(this.sci_Vector__f_prefix1).u.length;
  if ((len1 < 32)) {
    return new $c_sci_Vector1($m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1));
  } else {
    var a = new $ac_O(1);
    $n(a).set(0, elem);
    return new $c_sci_Vector2(a, 1, $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2, this.sci_Vector__f_prefix1, ((1 + len1) | 0));
  }
});
$c_sci_Vector1.prototype.map__F1__sci_Vector = (function(f) {
  return new $c_sci_Vector1($m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f));
});
$c_sci_Vector1.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var original = this.sci_Vector__f_prefix1;
  return new $c_sci_Vector1($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original, lo, hi));
});
$c_sci_Vector1.prototype.tail__sci_Vector = (function() {
  if (($n(this.sci_Vector__f_prefix1).u.length === 1)) {
    return $m_sci_Vector0$();
  } else {
    var a = this.sci_Vector__f_prefix1;
    var to = $n(a).u.length;
    return new $c_sci_Vector1($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to));
  }
});
$c_sci_Vector1.prototype.init__sci_Vector = (function() {
  if (($n(this.sci_Vector__f_prefix1).u.length === 1)) {
    return $m_sci_Vector0$();
  } else {
    var a = this.sci_Vector__f_prefix1;
    var to = (((-1) + $n(a).u.length) | 0);
    return new $c_sci_Vector1($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, to));
  }
});
$c_sci_Vector1.prototype.vectorSliceCount__I = (function() {
  return 1;
});
$c_sci_Vector1.prototype.vectorSlice__I__AO = (function(idx) {
  return this.sci_Vector__f_prefix1;
});
$c_sci_Vector1.prototype.prependedAll0__sc_IterableOnce__I__sci_Vector = (function(prefix, k) {
  var x1 = $m_sci_VectorStatics$().prepend1IfSpace__AO__sc_IterableOnce__AO(this.sci_Vector__f_prefix1, prefix);
  return ((x1 === null) ? $c_sci_Vector.prototype.prependedAll0__sc_IterableOnce__I__sci_Vector.call(this, prefix, k) : new $c_sci_Vector1(x1));
});
$c_sci_Vector1.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var data1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_Vector__f_prefix1, suffix);
  return ((data1b !== null) ? new $c_sci_Vector1(data1b) : $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k));
});
$c_sci_Vector1.prototype.init__O = (function() {
  return this.init__sci_Vector();
});
$c_sci_Vector1.prototype.tail__O = (function() {
  return this.tail__sci_Vector();
});
$c_sci_Vector1.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f);
});
$c_sci_Vector1.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Vector(elem);
});
$c_sci_Vector1.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem);
});
$c_sci_Vector1.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < $n(this.sci_Vector__f_prefix1).u.length))) {
    return $n(this.sci_Vector__f_prefix1).get(index);
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
function $as_sci_Vector1(obj) {
  return (((obj instanceof $c_sci_Vector1) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector1"));
}
function $isArrayOf_sci_Vector1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector1)));
}
function $asArrayOf_sci_Vector1(obj, depth) {
  return (($isArrayOf_sci_Vector1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector1;", depth));
}
var $d_sci_Vector1 = new $TypeData().initClass($c_sci_Vector1, "scala.collection.immutable.Vector1", ({
  sci_Vector1: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_$colon$colon(head, next) {
  this.sci_$colon$colon__f_head = null;
  this.sci_$colon$colon__f_next = null;
  this.sci_$colon$colon__f_head = head;
  this.sci_$colon$colon__f_next = next;
}
$c_sci_$colon$colon.prototype = new $h_sci_List();
$c_sci_$colon$colon.prototype.constructor = $c_sci_$colon$colon;
/** @constructor */
function $h_sci_$colon$colon() {
}
$h_sci_$colon$colon.prototype = $c_sci_$colon$colon.prototype;
$c_sci_$colon$colon.prototype.head__O = (function() {
  return this.sci_$colon$colon__f_head;
});
$c_sci_$colon$colon.prototype.productPrefix__T = (function() {
  return "::";
});
$c_sci_$colon$colon.prototype.productArity__I = (function() {
  return 2;
});
$c_sci_$colon$colon.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.sci_$colon$colon__f_head;
      break;
    }
    case 1: {
      return this.sci_$colon$colon__f_next;
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_sci_$colon$colon.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_sci_$colon$colon.prototype.tail__O = (function() {
  return this.sci_$colon$colon__f_next;
});
$c_sci_$colon$colon.prototype.headOption__s_Option = (function() {
  return new $c_s_Some(this.sci_$colon$colon__f_head);
});
function $as_sci_$colon$colon(obj) {
  return (((obj instanceof $c_sci_$colon$colon) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.$colon$colon"));
}
function $isArrayOf_sci_$colon$colon(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_$colon$colon)));
}
function $asArrayOf_sci_$colon$colon(obj, depth) {
  return (($isArrayOf_sci_$colon$colon(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.$colon$colon;", depth));
}
var $d_sci_$colon$colon = new $TypeData().initClass($c_sci_$colon$colon, "scala.collection.immutable.$colon$colon", ({
  sci_$colon$colon: 1,
  sci_List: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1
}));
/** @constructor */
function $c_sci_Nil$() {
}
$c_sci_Nil$.prototype = new $h_sci_List();
$c_sci_Nil$.prototype.constructor = $c_sci_Nil$;
/** @constructor */
function $h_sci_Nil$() {
}
$h_sci_Nil$.prototype = $c_sci_Nil$.prototype;
$c_sci_Nil$.prototype.head__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty list");
});
$c_sci_Nil$.prototype.tail__E = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty list");
});
$c_sci_Nil$.prototype.last__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last of empty list");
});
$c_sci_Nil$.prototype.init__E = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "init of empty list");
});
$c_sci_Nil$.prototype.knownSize__I = (function() {
  return 0;
});
$c_sci_Nil$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
});
$c_sci_Nil$.prototype.productPrefix__T = (function() {
  return "Nil";
});
$c_sci_Nil$.prototype.productArity__I = (function() {
  return 0;
});
$c_sci_Nil$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1);
});
$c_sci_Nil$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_sci_Nil$.prototype.init__O = (function() {
  this.init__E();
});
$c_sci_Nil$.prototype.last__O = (function() {
  this.last__E();
});
$c_sci_Nil$.prototype.tail__O = (function() {
  this.tail__E();
});
$c_sci_Nil$.prototype.headOption__s_Option = (function() {
  return $m_s_None$();
});
$c_sci_Nil$.prototype.head__O = (function() {
  this.head__E();
});
var $d_sci_Nil$ = new $TypeData().initClass($c_sci_Nil$, "scala.collection.immutable.Nil$", ({
  sci_Nil$: 1,
  sci_List: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1
}));
var $n_sci_Nil$;
function $m_sci_Nil$() {
  if ((!$n_sci_Nil$)) {
    $n_sci_Nil$ = new $c_sci_Nil$();
  }
  return $n_sci_Nil$;
}
function $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet($thiz, t) {
  return ((t === $thiz.sci_TreeSet__f_tree) ? $thiz : $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), t, $thiz.sci_TreeSet__f_ordering));
}
function $p_sci_TreeSet__countWhile__F1__I($thiz, p) {
  var result = 0;
  var tree = $thiz.sci_TreeSet__f_tree;
  var start = $m_s_None$();
  var evidence$17 = $thiz.sci_TreeSet__f_ordering;
  var it = new $c_sci_RedBlackTree$KeysIterator(tree, start, evidence$17);
  while ((it.hasNext__Z() && $uZ($n(p).apply__O__O(it.next__O())))) {
    result = ((1 + result) | 0);
  }
  return result;
}
function $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__($thiz, tree, ordering) {
  $thiz.sci_TreeSet__f_tree = tree;
  $thiz.sci_TreeSet__f_ordering = ordering;
  if ((ordering === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "ordering must not be null");
  }
  return $thiz;
}
function $ct_sci_TreeSet__s_math_Ordering__($thiz, ordering) {
  $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__($thiz, null, ordering);
  return $thiz;
}
/** @constructor */
function $c_sci_TreeSet() {
  this.sci_TreeSet__f_tree = null;
  this.sci_TreeSet__f_ordering = null;
}
$c_sci_TreeSet.prototype = new $h_sci_AbstractSet();
$c_sci_TreeSet.prototype.constructor = $c_sci_TreeSet;
/** @constructor */
function $h_sci_TreeSet() {
}
$h_sci_TreeSet.prototype = $c_sci_TreeSet.prototype;
$c_sci_TreeSet.prototype.map__F1__s_math_Ordering__sc_SortedSet = (function(f, ev) {
  return $f_sc_StrictOptimizedSortedSetOps__map__F1__s_math_Ordering__sc_SortedSet(this, f, ev);
});
$c_sci_TreeSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_TreeSet.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_TreeSet.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_sci_TreeSet.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$c_sci_TreeSet.prototype.stringPrefix__T = (function() {
  return "SortedSet";
});
$c_sci_TreeSet.prototype.newSpecificBuilder__scm_Builder = (function() {
  var evidence$12 = this.sci_TreeSet__f_ordering;
  return new $c_sci_TreeSet$TreeSetBuilder(evidence$12);
});
$c_sci_TreeSet.prototype.ordering__s_math_Ordering = (function() {
  return this.sci_TreeSet__f_ordering;
});
$c_sci_TreeSet.prototype.size__I = (function() {
  return $m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeSet__f_tree);
});
$c_sci_TreeSet.prototype.isEmpty__Z = (function() {
  return ($m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeSet__f_tree) === 0);
});
$c_sci_TreeSet.prototype.head__O = (function() {
  var this$1 = $n($m_sci_RedBlackTree$().smallest__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree));
  return this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
});
$c_sci_TreeSet.prototype.last__O = (function() {
  var this$1 = $n($m_sci_RedBlackTree$().greatest__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree));
  return this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
});
$c_sci_TreeSet.prototype.tail__sci_TreeSet = (function() {
  return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), $m_sci_RedBlackTree$().tail__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree), this.sci_TreeSet__f_ordering);
});
$c_sci_TreeSet.prototype.max__s_math_Ordering__O = (function(ord) {
  return (((ord === this.sci_TreeSet__f_ordering) && (!this.isEmpty__Z())) ? this.last__O() : $f_sc_SortedSetOps__max__s_math_Ordering__O(this, ord));
});
$c_sci_TreeSet.prototype.drop__I__sci_TreeSet = (function(n) {
  if ((n <= 0)) {
    return this;
  } else if ((n >= $m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeSet__f_tree))) {
    var evidence$6 = this.sci_TreeSet__f_ordering;
    return $ct_sci_TreeSet__s_math_Ordering__(new $c_sci_TreeSet(), evidence$6);
  } else {
    return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), $m_sci_RedBlackTree$().drop__sci_RedBlackTree$Tree__I__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, n, this.sci_TreeSet__f_ordering), this.sci_TreeSet__f_ordering);
  }
});
$c_sci_TreeSet.prototype.take__I__sci_TreeSet = (function(n) {
  if ((n <= 0)) {
    var evidence$6 = this.sci_TreeSet__f_ordering;
    return $ct_sci_TreeSet__s_math_Ordering__(new $c_sci_TreeSet(), evidence$6);
  } else {
    return ((n >= $m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeSet__f_tree)) ? this : $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), $m_sci_RedBlackTree$().take__sci_RedBlackTree$Tree__I__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, n, this.sci_TreeSet__f_ordering), this.sci_TreeSet__f_ordering));
  }
});
$c_sci_TreeSet.prototype.dropRight__I__sci_TreeSet = (function(n) {
  return this.take__I__sci_TreeSet((($m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeSet__f_tree) - ((n > 0) ? n : 0)) | 0));
});
$c_sci_TreeSet.prototype.dropWhile__F1__sci_TreeSet = (function(p) {
  return this.drop__I__sci_TreeSet($p_sci_TreeSet__countWhile__F1__I(this, p));
});
$c_sci_TreeSet.prototype.takeWhile__F1__sci_TreeSet = (function(p) {
  return this.take__I__sci_TreeSet($p_sci_TreeSet__countWhile__F1__I(this, p));
});
$c_sci_TreeSet.prototype.foreach__F1__V = (function(f) {
  $m_sci_RedBlackTree$().foreachKey__sci_RedBlackTree$Tree__F1__V(this.sci_TreeSet__f_tree, f);
});
$c_sci_TreeSet.prototype.iterator__sc_Iterator = (function() {
  var tree = this.sci_TreeSet__f_tree;
  var start = $m_s_None$();
  var evidence$17 = this.sci_TreeSet__f_ordering;
  return new $c_sci_RedBlackTree$KeysIterator(tree, start, evidence$17);
});
$c_sci_TreeSet.prototype.contains__O__Z = (function(elem) {
  return $m_sci_RedBlackTree$().contains__sci_RedBlackTree$Tree__O__s_math_Ordering__Z(this.sci_TreeSet__f_tree, elem, this.sci_TreeSet__f_ordering);
});
$c_sci_TreeSet.prototype.incl__O__sci_TreeSet = (function(elem) {
  return $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet(this, $m_sci_RedBlackTree$().update__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, elem, null, false, this.sci_TreeSet__f_ordering));
});
$c_sci_TreeSet.prototype.excl__O__sci_TreeSet = (function(elem) {
  return $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet(this, $m_sci_RedBlackTree$().delete__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, elem, this.sci_TreeSet__f_ordering));
});
$c_sci_TreeSet.prototype.concat__sc_IterableOnce__sci_TreeSet = (function(that) {
  matchEnd4: {
    var t$2;
    if ((that instanceof $c_sci_TreeSet)) {
      var x2 = $as_sci_TreeSet(that);
      var x = this.sci_TreeSet__f_ordering;
      var x$2 = $n(x2).sci_TreeSet__f_ordering;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var t$2 = $m_sci_RedBlackTree$().union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, $n(x2).sci_TreeSet__f_tree, this.sci_TreeSet__f_ordering);
        break matchEnd4;
      }
    }
    var it = $n(that).iterator__sc_Iterator();
    var t = this.sci_TreeSet__f_tree;
    while ($n(it).hasNext__Z()) {
      t = $m_sci_RedBlackTree$().update__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree(t, $n(it).next__O(), null, false, this.sci_TreeSet__f_ordering);
    }
    var t$2 = t;
  }
  return $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet(this, t$2);
});
$c_sci_TreeSet.prototype.filter__F1__sci_TreeSet = (function(f) {
  return $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet(this, $m_sci_RedBlackTree$().filterEntries__sci_RedBlackTree$Tree__F2__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, new $c_sjsr_AnonFunction2(((k$2, x$13$2) => $uZ($n(f).apply__O__O(k$2))))));
});
$c_sci_TreeSet.prototype.partition__F1__T2 = (function(p) {
  var x1 = $m_sci_RedBlackTree$().partitionEntries__sci_RedBlackTree$Tree__F2__T2(this.sci_TreeSet__f_tree, new $c_sjsr_AnonFunction2(((a$2, x$14$2) => $uZ($n(p).apply__O__O(a$2)))));
  if ((x1 === null)) {
    throw new $c_s_MatchError(x1);
  }
  var l = $as_sci_RedBlackTree$Tree($n(x1)._1__O());
  var r = $as_sci_RedBlackTree$Tree($n(x1)._2__O());
  return new $c_T2($p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet(this, l), $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet(this, r));
});
$c_sci_TreeSet.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_sci_TreeSet)) {
    var x2 = $as_sci_TreeSet(obj);
    var x = this.sci_TreeSet__f_ordering;
    var x$2 = $n(x2).sci_TreeSet__f_ordering;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      return $m_sci_RedBlackTree$().keysEqual__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__Z(this.sci_TreeSet__f_tree, $n(x2).sci_TreeSet__f_tree, this.sci_TreeSet__f_ordering);
    }
  }
  return $f_sc_SortedSet__equals__O__Z(this, obj);
});
$c_sci_TreeSet.prototype.className__T = (function() {
  return "TreeSet";
});
$c_sci_TreeSet.prototype.empty__O = (function() {
  var evidence$6 = this.sci_TreeSet__f_ordering;
  return $ct_sci_TreeSet__s_math_Ordering__(new $c_sci_TreeSet(), evidence$6);
});
$c_sci_TreeSet.prototype.empty__sc_IterableOps = (function() {
  var evidence$6 = this.sci_TreeSet__f_ordering;
  return $ct_sci_TreeSet__s_math_Ordering__(new $c_sci_TreeSet(), evidence$6);
});
$c_sci_TreeSet.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sci_TreeSet$();
  var evidence$5 = this.sci_TreeSet__f_ordering;
  return this$1.from__sc_IterableOnce__s_math_Ordering__sci_TreeSet(coll, evidence$5);
});
$c_sci_TreeSet.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  var this$1 = $m_sci_TreeSet$();
  var evidence$5 = this.sci_TreeSet__f_ordering;
  return this$1.from__sc_IterableOnce__s_math_Ordering__sci_TreeSet(coll, evidence$5);
});
$c_sci_TreeSet.prototype.filter__F1__O = (function(pred) {
  return this.filter__F1__sci_TreeSet(pred);
});
$c_sci_TreeSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  return this.concat__sc_IterableOnce__sci_TreeSet(that);
});
$c_sci_TreeSet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_TreeSet(elem);
});
$c_sci_TreeSet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_TreeSet(elem);
});
$c_sci_TreeSet.prototype.takeWhile__F1__O = (function(p) {
  return this.takeWhile__F1__sci_TreeSet(p);
});
$c_sci_TreeSet.prototype.dropWhile__F1__O = (function(p) {
  return this.dropWhile__F1__sci_TreeSet(p);
});
$c_sci_TreeSet.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sci_TreeSet(n);
});
$c_sci_TreeSet.prototype.take__I__O = (function(n) {
  return this.take__I__sci_TreeSet(n);
});
$c_sci_TreeSet.prototype.drop__I__O = (function(n) {
  return this.drop__I__sci_TreeSet(n);
});
$c_sci_TreeSet.prototype.tail__O = (function() {
  return this.tail__sci_TreeSet();
});
$c_sci_TreeSet.prototype.sortedIterableFactory__sc_SortedIterableFactory = (function() {
  return $m_sci_TreeSet$();
});
function $as_sci_TreeSet(obj) {
  return (((obj instanceof $c_sci_TreeSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.TreeSet"));
}
function $isArrayOf_sci_TreeSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_TreeSet)));
}
function $asArrayOf_sci_TreeSet(obj, depth) {
  return (($isArrayOf_sci_TreeSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.TreeSet;", depth));
}
var $d_sci_TreeSet = new $TypeData().initClass($c_sci_TreeSet, "scala.collection.immutable.TreeSet", ({
  sci_TreeSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  sci_SortedSetOps: 1,
  sci_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSetOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Vector0$() {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  $ct_sci_BigVector__AO__AO__I__(this, $m_sci_VectorStatics$().sci_VectorStatics$__f_empty1, $m_sci_VectorStatics$().sci_VectorStatics$__f_empty1, 0);
}
$c_sci_Vector0$.prototype = new $h_sci_BigVector();
$c_sci_Vector0$.prototype.constructor = $c_sci_Vector0$;
/** @constructor */
function $h_sci_Vector0$() {
}
$h_sci_Vector0$.prototype = $c_sci_Vector0$.prototype;
$c_sci_Vector0$.prototype.apply__I__E = (function(index) {
  throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
});
$c_sci_Vector0$.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
});
$c_sci_Vector0$.prototype.appended__O__sci_Vector = (function(elem) {
  var a = new $ac_O(1);
  $n(a).set(0, elem);
  return new $c_sci_Vector1(a);
});
$c_sci_Vector0$.prototype.prepended__O__sci_Vector = (function(elem) {
  var a = new $ac_O(1);
  $n(a).set(0, elem);
  return new $c_sci_Vector1(a);
});
$c_sci_Vector0$.prototype.tail__sci_Vector = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.tail");
});
$c_sci_Vector0$.prototype.init__sci_Vector = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.init");
});
$c_sci_Vector0$.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  return this;
});
$c_sci_Vector0$.prototype.vectorSliceCount__I = (function() {
  return 0;
});
$c_sci_Vector0$.prototype.vectorSlice__I__AO = (function(idx) {
  return null;
});
$c_sci_Vector0$.prototype.equals__O__Z = (function(o) {
  return ((this === o) || ((!(o instanceof $c_sci_Vector)) && $f_sc_Seq__equals__O__Z(this, o)));
});
$c_sci_Vector0$.prototype.prependedAll0__sc_IterableOnce__I__sci_Vector = (function(prefix, k) {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(prefix);
});
$c_sci_Vector0$.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(suffix);
});
$c_sci_Vector0$.prototype.ioob__I__jl_IndexOutOfBoundsException = (function(index) {
  return $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (index + " is out of bounds (empty vector)"));
});
$c_sci_Vector0$.prototype.init__O = (function() {
  return this.init__sci_Vector();
});
$c_sci_Vector0$.prototype.tail__O = (function() {
  return this.tail__sci_Vector();
});
$c_sci_Vector0$.prototype.map__F1__O = (function(f) {
  return this;
});
$c_sci_Vector0$.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Vector(elem);
});
$c_sci_Vector0$.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem);
});
$c_sci_Vector0$.prototype.apply__O__O = (function(v1) {
  this.apply__I__E($uI(v1));
});
$c_sci_Vector0$.prototype.apply__I__O = (function(i) {
  this.apply__I__E(i);
});
var $d_sci_Vector0$ = new $TypeData().initClass($c_sci_Vector0$, "scala.collection.immutable.Vector0$", ({
  sci_Vector0$: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_Vector0$;
function $m_sci_Vector0$() {
  if ((!$n_sci_Vector0$)) {
    $n_sci_Vector0$ = new $c_sci_Vector0$();
  }
  return $n_sci_Vector0$;
}
/** @constructor */
function $c_sci_Vector2(_prefix1, len1, data2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector2__f_len1 = 0;
  this.sci_Vector2__f_data2 = null;
  this.sci_Vector2__f_len1 = len1;
  this.sci_Vector2__f_data2 = data2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0);
}
$c_sci_Vector2.prototype = new $h_sci_BigVector();
$c_sci_Vector2.prototype.constructor = $c_sci_Vector2;
/** @constructor */
function $h_sci_Vector2() {
}
$h_sci_Vector2.prototype = $c_sci_Vector2.prototype;
$c_sci_Vector2.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector2__f_len1) | 0);
    if ((io >= 0)) {
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      return ((i2 < $n(this.sci_Vector2__f_data2).u.length) ? $n($n(this.sci_Vector2__f_data2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get((31 & io)));
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
$c_sci_Vector2.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector2__f_len1)) {
      var io = ((index - this.sci_Vector2__f_len1) | 0);
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      if ((i2 < $n(this.sci_Vector2__f_data2).u.length)) {
        var a2 = this.sci_Vector2__f_data2;
        var this$2 = $n(a2);
        var a2c = $n(this$2).clone__O();
        var $x_1 = $n(a2c);
        var a1 = $n(a2c).get(i2);
        var this$3 = $n(a1);
        var a1c = $n(this$3).clone__O();
        $n(a1c).set(i1, elem);
        $x_1.set(i2, a1c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector2__f_len1;
        var x$4 = this.sci_BigVector__f_suffix1;
        var x$5 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector2(x$2, x$3, a2c, x$4, x$5);
      } else {
        var a1$1 = this.sci_BigVector__f_suffix1;
        var this$5 = $n(a1$1);
        var a1c$1 = $n(this$5).clone__O();
        $n(a1c$1).set(i1, elem);
        var x$7 = this.sci_Vector__f_prefix1;
        var x$8 = this.sci_Vector2__f_len1;
        var x$9 = this.sci_Vector2__f_data2;
        var x$10 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector2(x$7, x$8, x$9, a1c$1, x$10);
      }
    } else {
      var a1$2 = this.sci_Vector__f_prefix1;
      var this$7 = $n(a1$2);
      var a1c$2 = $n(this$7).clone__O();
      $n(a1c$2).set(index, elem);
      var len1 = this.sci_Vector2__f_len1;
      var data2 = this.sci_Vector2__f_data2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector2(a1c$2, len1, data2, suffix1, length0);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
$c_sci_Vector2.prototype.appended__O__sci_Vector = (function(elem) {
  if (($n(this.sci_BigVector__f_suffix1).u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector2__f_len1;
    var x$5 = this.sci_Vector2__f_data2;
    return new $c_sci_Vector2(x$3, x$4, x$5, x$1, x$2);
  } else if (($n(this.sci_Vector2__f_data2).u.length < 30)) {
    var x$6 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector2__f_data2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    $n(a).set(0, elem);
    var x$8 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$9 = this.sci_Vector__f_prefix1;
    var x$10 = this.sci_Vector2__f_len1;
    return new $c_sci_Vector2(x$9, x$10, x$6, a, x$8);
  } else {
    var $x_5 = this.sci_Vector__f_prefix1;
    var $x_4 = this.sci_Vector2__f_len1;
    var $x_3 = this.sci_Vector2__f_data2;
    var $x_2 = this.sci_Vector2__f_len1;
    var $x_1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x = this.sci_BigVector__f_suffix1;
    var a$1 = new ($d_O.getArrayOf().getArrayOf().constr)(1);
    $n(a$1).set(0, x);
    var a$2 = new $ac_O(1);
    $n(a$2).set(0, elem);
    return new $c_sci_Vector3($x_5, $x_4, $x_3, ((960 + $x_2) | 0), $x_1, a$1, a$2, ((1 + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector2.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector2__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector2__f_len1) | 0);
    var x$3 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$4 = this.sci_Vector2__f_data2;
    var x$5 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector2(x$1, x$2, x$4, x$5, x$3);
  } else if (($n(this.sci_Vector2__f_data2).u.length < 30)) {
    var a = new $ac_O(1);
    $n(a).set(0, elem);
    var x$8 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector2__f_data2), 2);
    var x$9 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$10 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector2(a, 1, x$8, x$10, x$9);
  } else {
    var a$1 = new $ac_O(1);
    $n(a$1).set(0, elem);
    var x = this.sci_Vector__f_prefix1;
    var a$2 = new ($d_O.getArrayOf().getArrayOf().constr)(1);
    $n(a$2).set(0, x);
    return new $c_sci_Vector3(a$1, 1, a$2, ((1 + this.sci_Vector2__f_len1) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3, this.sci_Vector2__f_data2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector2.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector2__f_data2, f), 2);
  var x$3 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$4 = this.sci_Vector2__f_len1;
  var x$5 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector2(x$1, x$4, x$2, x$3, x$5);
});
$c_sci_Vector2.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector2__f_data2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector();
});
$c_sci_Vector2.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector2__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = $n(a).u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector2__f_len1) | 0);
    var x$3 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$4 = this.sci_Vector2__f_data2;
    var x$5 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector2(x$1, x$2, x$4, x$5, x$3);
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0);
  }
});
$c_sci_Vector2.prototype.init__sci_Vector = (function() {
  if (($n(this.sci_BigVector__f_suffix1).u.length > 1)) {
    var a = this.sci_BigVector__f_suffix1;
    var to = (((-1) + $n(a).u.length) | 0);
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, to);
    var x$2 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector2__f_len1;
    var x$5 = this.sci_Vector2__f_data2;
    return new $c_sci_Vector2(x$3, x$4, x$5, x$1, x$2);
  } else {
    return this.slice0__I__I__sci_Vector(0, (((-1) + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector2.prototype.vectorSliceCount__I = (function() {
  return 3;
});
$c_sci_Vector2.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break;
    }
    case 1: {
      return this.sci_Vector2__f_data2;
      break;
    }
    case 2: {
      return this.sci_BigVector__f_suffix1;
      break;
    }
    default: {
      throw new $c_s_MatchError(idx);
    }
  }
});
$c_sci_Vector2.prototype.prependedAll0__sc_IterableOnce__I__sci_Vector = (function(prefix, k) {
  var x1 = $m_sci_VectorStatics$().prepend1IfSpace__AO__sc_IterableOnce__AO(this.sci_Vector__f_prefix1, prefix);
  if ((x1 === null)) {
    return $c_sci_Vector.prototype.prependedAll0__sc_IterableOnce__I__sci_Vector.call(this, prefix, k);
  } else {
    var diff = (($n(x1).u.length - $n(this.sci_Vector__f_prefix1).u.length) | 0);
    var x$2 = ((this.sci_Vector2__f_len1 + diff) | 0);
    var x$3 = ((this.sci_BigVector__f_length0 + diff) | 0);
    var x$4 = this.sci_Vector2__f_data2;
    var x$5 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector2(x1, x$2, x$4, x$5, x$3);
  }
});
$c_sci_Vector2.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - $n(this.sci_BigVector__f_suffix1).u.length) | 0) + $n(suffix1b).u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector2__f_len1;
    var x$5 = this.sci_Vector2__f_data2;
    return new $c_sci_Vector2(x$3, x$4, x$5, suffix1b, x$2);
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k);
  }
});
$c_sci_Vector2.prototype.init__O = (function() {
  return this.init__sci_Vector();
});
$c_sci_Vector2.prototype.tail__O = (function() {
  return this.tail__sci_Vector();
});
$c_sci_Vector2.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f);
});
$c_sci_Vector2.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Vector(elem);
});
$c_sci_Vector2.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem);
});
$c_sci_Vector2.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector2__f_len1) | 0);
    if ((io >= 0)) {
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      return ((i2 < $n(this.sci_Vector2__f_data2).u.length) ? $n($n(this.sci_Vector2__f_data2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get((31 & io)));
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
function $as_sci_Vector2(obj) {
  return (((obj instanceof $c_sci_Vector2) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector2"));
}
function $isArrayOf_sci_Vector2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector2)));
}
function $asArrayOf_sci_Vector2(obj, depth) {
  return (($isArrayOf_sci_Vector2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector2;", depth));
}
var $d_sci_Vector2 = new $TypeData().initClass($c_sci_Vector2, "scala.collection.immutable.Vector2", ({
  sci_Vector2: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Vector3(_prefix1, len1, prefix2, len12, data3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector3__f_len1 = 0;
  this.sci_Vector3__f_prefix2 = null;
  this.sci_Vector3__f_len12 = 0;
  this.sci_Vector3__f_data3 = null;
  this.sci_Vector3__f_suffix2 = null;
  this.sci_Vector3__f_len1 = len1;
  this.sci_Vector3__f_prefix2 = prefix2;
  this.sci_Vector3__f_len12 = len12;
  this.sci_Vector3__f_data3 = data3;
  this.sci_Vector3__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0);
}
$c_sci_Vector3.prototype = new $h_sci_BigVector();
$c_sci_Vector3.prototype.constructor = $c_sci_Vector3;
/** @constructor */
function $h_sci_Vector3() {
}
$h_sci_Vector3.prototype = $c_sci_Vector3.prototype;
$c_sci_Vector3.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector3__f_len12) | 0);
    if ((io >= 0)) {
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i3 < $n(this.sci_Vector3__f_data3).u.length) ? $n($n($n(this.sci_Vector3__f_data3).get(i3)).get(i2)).get(i1) : ((i2 < $n(this.sci_Vector3__f_suffix2).u.length) ? $n($n(this.sci_Vector3__f_suffix2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get(i1)));
    } else if ((index >= this.sci_Vector3__f_len1)) {
      var io$2 = ((index - this.sci_Vector3__f_len1) | 0);
      return $n($n(this.sci_Vector3__f_prefix2).get(((io$2 >>> 5) | 0))).get((31 & io$2));
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
$c_sci_Vector3.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector3__f_len12)) {
      var io = ((index - this.sci_Vector3__f_len12) | 0);
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i3 < $n(this.sci_Vector3__f_data3).u.length)) {
        var a3 = this.sci_Vector3__f_data3;
        var this$2 = $n(a3);
        var a3c = $n(this$2).clone__O();
        var $x_2 = $n(a3c);
        var a2 = $n(a3c).get(i3);
        var this$3 = $n(a2);
        var a2c = $n(this$3).clone__O();
        var $x_1 = $n(a2c);
        var a1 = $n(a2c).get(i2);
        var this$4 = $n(a1);
        var a1c = $n(this$4).clone__O();
        $n(a1c).set(i1, elem);
        $x_1.set(i2, a1c);
        $x_2.set(i3, a2c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector3__f_len1;
        var x$4 = this.sci_Vector3__f_prefix2;
        var x$5 = this.sci_Vector3__f_len12;
        var x$6 = this.sci_Vector3__f_suffix2;
        var x$7 = this.sci_BigVector__f_suffix1;
        var x$8 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector3(x$2, x$3, x$4, x$5, a3c, x$6, x$7, x$8);
      } else if ((i2 < $n(this.sci_Vector3__f_suffix2).u.length)) {
        var a2$1 = this.sci_Vector3__f_suffix2;
        var this$6 = $n(a2$1);
        var a2c$1 = $n(this$6).clone__O();
        var $x_3 = $n(a2c$1);
        var a1$1 = $n(a2c$1).get(i2);
        var this$7 = $n(a1$1);
        var a1c$1 = $n(this$7).clone__O();
        $n(a1c$1).set(i1, elem);
        $x_3.set(i2, a1c$1);
        var x$10 = this.sci_Vector__f_prefix1;
        var x$11 = this.sci_Vector3__f_len1;
        var x$12 = this.sci_Vector3__f_prefix2;
        var x$13 = this.sci_Vector3__f_len12;
        var x$14 = this.sci_Vector3__f_data3;
        var x$15 = this.sci_BigVector__f_suffix1;
        var x$16 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector3(x$10, x$11, x$12, x$13, x$14, a2c$1, x$15, x$16);
      } else {
        var a1$2 = this.sci_BigVector__f_suffix1;
        var this$9 = $n(a1$2);
        var a1c$2 = $n(this$9).clone__O();
        $n(a1c$2).set(i1, elem);
        var x$18 = this.sci_Vector__f_prefix1;
        var x$19 = this.sci_Vector3__f_len1;
        var x$20 = this.sci_Vector3__f_prefix2;
        var x$21 = this.sci_Vector3__f_len12;
        var x$22 = this.sci_Vector3__f_data3;
        var x$23 = this.sci_Vector3__f_suffix2;
        var x$24 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector3(x$18, x$19, x$20, x$21, x$22, x$23, a1c$2, x$24);
      }
    } else if ((index >= this.sci_Vector3__f_len1)) {
      var io$2 = ((index - this.sci_Vector3__f_len1) | 0);
      var a2$2 = this.sci_Vector3__f_prefix2;
      var idx2 = ((io$2 >>> 5) | 0);
      var idx1 = (31 & io$2);
      var this$11 = $n(a2$2);
      var a2c$2 = $n(this$11).clone__O();
      var $x_4 = $n(a2c$2);
      var a1$3 = $n(a2c$2).get(idx2);
      var this$12 = $n(a1$3);
      var a1c$3 = $n(this$12).clone__O();
      $n(a1c$3).set(idx1, elem);
      $x_4.set(idx2, a1c$3);
      var x$26 = this.sci_Vector__f_prefix1;
      var x$27 = this.sci_Vector3__f_len1;
      var x$28 = this.sci_Vector3__f_len12;
      var x$29 = this.sci_Vector3__f_data3;
      var x$30 = this.sci_Vector3__f_suffix2;
      var x$31 = this.sci_BigVector__f_suffix1;
      var x$32 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector3(x$26, x$27, a2c$2, x$28, x$29, x$30, x$31, x$32);
    } else {
      var a1$4 = this.sci_Vector__f_prefix1;
      var this$14 = $n(a1$4);
      var a1c$4 = $n(this$14).clone__O();
      $n(a1c$4).set(index, elem);
      var len1 = this.sci_Vector3__f_len1;
      var prefix2 = this.sci_Vector3__f_prefix2;
      var len12 = this.sci_Vector3__f_len12;
      var data3 = this.sci_Vector3__f_data3;
      var suffix2 = this.sci_Vector3__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector3(a1c$4, len1, prefix2, len12, data3, suffix2, suffix1, length0);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
$c_sci_Vector3.prototype.appended__O__sci_Vector = (function(elem) {
  if (($n(this.sci_BigVector__f_suffix1).u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector3__f_len1;
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_len12;
    var x$7 = this.sci_Vector3__f_data3;
    var x$8 = this.sci_Vector3__f_suffix2;
    return new $c_sci_Vector3(x$3, x$4, x$5, x$6, x$7, x$8, x$1, x$2);
  } else if (($n(this.sci_Vector3__f_suffix2).u.length < 31)) {
    var x$9 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    $n(a).set(0, elem);
    var x$11 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$12 = this.sci_Vector__f_prefix1;
    var x$13 = this.sci_Vector3__f_len1;
    var x$14 = this.sci_Vector3__f_prefix2;
    var x$15 = this.sci_Vector3__f_len12;
    var x$16 = this.sci_Vector3__f_data3;
    return new $c_sci_Vector3(x$12, x$13, x$14, x$15, x$16, x$9, a, x$11);
  } else if (($n(this.sci_Vector3__f_data3).u.length < 30)) {
    var x$17 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_data3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var x$18 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    $n(a$1).set(0, elem);
    var x$20 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$21 = this.sci_Vector__f_prefix1;
    var x$22 = this.sci_Vector3__f_len1;
    var x$23 = this.sci_Vector3__f_prefix2;
    var x$24 = this.sci_Vector3__f_len12;
    return new $c_sci_Vector3(x$21, x$22, x$23, x$24, x$17, x$18, a$1, x$20);
  } else {
    var $x_8 = this.sci_Vector__f_prefix1;
    var $x_7 = this.sci_Vector3__f_len1;
    var $x_6 = this.sci_Vector3__f_prefix2;
    var $x_5 = this.sci_Vector3__f_len12;
    var $x_4 = this.sci_Vector3__f_data3;
    var $x_3 = this.sci_Vector3__f_len12;
    var $x_2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a$2 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(1);
    $n(a$2).set(0, x);
    var $x_1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$3 = new $ac_O(1);
    $n(a$3).set(0, elem);
    return new $c_sci_Vector4($x_8, $x_7, $x_6, $x_5, $x_4, ((30720 + $x_3) | 0), $x_2, a$2, $x_1, a$3, ((1 + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector3.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector3__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector3__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector3__f_len12) | 0);
    var x$4 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_data3;
    var x$7 = this.sci_Vector3__f_suffix2;
    var x$8 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(x$1, x$2, x$5, x$3, x$6, x$7, x$8, x$4);
  } else if ((this.sci_Vector3__f_len12 < 1024)) {
    var a = new $ac_O(1);
    $n(a).set(0, elem);
    var x$11 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector3__f_prefix2), 2);
    var x$12 = ((1 + this.sci_Vector3__f_len12) | 0);
    var x$13 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$14 = this.sci_Vector3__f_data3;
    var x$15 = this.sci_Vector3__f_suffix2;
    var x$16 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(a, 1, x$11, x$12, x$14, x$15, x$16, x$13);
  } else if (($n(this.sci_Vector3__f_data3).u.length < 30)) {
    var a$1 = new $ac_O(1);
    $n(a$1).set(0, elem);
    var x$19 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$21 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector3__f_prefix2), this.sci_Vector3__f_data3), 3);
    var x$22 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$23 = this.sci_Vector3__f_suffix2;
    var x$24 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(a$1, 1, x$19, 1, x$21, x$23, x$24, x$22);
  } else {
    var a$2 = new $ac_O(1);
    $n(a$2).set(0, elem);
    var $x_1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector3__f_prefix2), 2);
    var a$3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(1);
    $n(a$3).set(0, x);
    return new $c_sci_Vector4(a$2, 1, $x_1, 1, a$3, ((1 + this.sci_Vector3__f_len12) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4, this.sci_Vector3__f_data3, this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector3.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector3__f_prefix2, f), 2);
  var x$3 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector3__f_data3, f), 3);
  var x$4 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector3__f_suffix2, f), 2);
  var x$5 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$6 = this.sci_Vector3__f_len1;
  var x$7 = this.sci_Vector3__f_len12;
  var x$8 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector3(x$1, x$6, x$2, x$7, x$3, x$4, x$5, x$8);
});
$c_sci_Vector3.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector3__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector3__f_data3);
  b.consider__I__AO__V(2, this.sci_Vector3__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector();
});
$c_sci_Vector3.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector3__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = $n(a).u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector3__f_len1) | 0);
    var x$3 = (((-1) + this.sci_Vector3__f_len12) | 0);
    var x$4 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_data3;
    var x$7 = this.sci_Vector3__f_suffix2;
    var x$8 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(x$1, x$2, x$5, x$3, x$6, x$7, x$8, x$4);
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0);
  }
});
$c_sci_Vector3.prototype.init__sci_Vector = (function() {
  if (($n(this.sci_BigVector__f_suffix1).u.length > 1)) {
    var a = this.sci_BigVector__f_suffix1;
    var to = (((-1) + $n(a).u.length) | 0);
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, to);
    var x$2 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector3__f_len1;
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_len12;
    var x$7 = this.sci_Vector3__f_data3;
    var x$8 = this.sci_Vector3__f_suffix2;
    return new $c_sci_Vector3(x$3, x$4, x$5, x$6, x$7, x$8, x$1, x$2);
  } else {
    return this.slice0__I__I__sci_Vector(0, (((-1) + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector3.prototype.vectorSliceCount__I = (function() {
  return 5;
});
$c_sci_Vector3.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break;
    }
    case 1: {
      return this.sci_Vector3__f_prefix2;
      break;
    }
    case 2: {
      return this.sci_Vector3__f_data3;
      break;
    }
    case 3: {
      return this.sci_Vector3__f_suffix2;
      break;
    }
    case 4: {
      return this.sci_BigVector__f_suffix1;
      break;
    }
    default: {
      throw new $c_s_MatchError(idx);
    }
  }
});
$c_sci_Vector3.prototype.prependedAll0__sc_IterableOnce__I__sci_Vector = (function(prefix, k) {
  var x1 = $m_sci_VectorStatics$().prepend1IfSpace__AO__sc_IterableOnce__AO(this.sci_Vector__f_prefix1, prefix);
  if ((x1 === null)) {
    return $c_sci_Vector.prototype.prependedAll0__sc_IterableOnce__I__sci_Vector.call(this, prefix, k);
  } else {
    var diff = (($n(x1).u.length - $n(this.sci_Vector__f_prefix1).u.length) | 0);
    var x$2 = ((this.sci_Vector3__f_len1 + diff) | 0);
    var x$3 = ((this.sci_Vector3__f_len12 + diff) | 0);
    var x$4 = ((this.sci_BigVector__f_length0 + diff) | 0);
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_data3;
    var x$7 = this.sci_Vector3__f_suffix2;
    var x$8 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(x1, x$2, x$5, x$3, x$6, x$7, x$8, x$4);
  }
});
$c_sci_Vector3.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - $n(this.sci_BigVector__f_suffix1).u.length) | 0) + $n(suffix1b).u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector3__f_len1;
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_len12;
    var x$7 = this.sci_Vector3__f_data3;
    var x$8 = this.sci_Vector3__f_suffix2;
    return new $c_sci_Vector3(x$3, x$4, x$5, x$6, x$7, x$8, suffix1b, x$2);
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k);
  }
});
$c_sci_Vector3.prototype.init__O = (function() {
  return this.init__sci_Vector();
});
$c_sci_Vector3.prototype.tail__O = (function() {
  return this.tail__sci_Vector();
});
$c_sci_Vector3.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f);
});
$c_sci_Vector3.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Vector(elem);
});
$c_sci_Vector3.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem);
});
$c_sci_Vector3.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector3__f_len12) | 0);
    if ((io >= 0)) {
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i3 < $n(this.sci_Vector3__f_data3).u.length) ? $n($n($n(this.sci_Vector3__f_data3).get(i3)).get(i2)).get(i1) : ((i2 < $n(this.sci_Vector3__f_suffix2).u.length) ? $n($n(this.sci_Vector3__f_suffix2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get(i1)));
    } else if ((index >= this.sci_Vector3__f_len1)) {
      var io$2 = ((index - this.sci_Vector3__f_len1) | 0);
      return $n($n(this.sci_Vector3__f_prefix2).get(((io$2 >>> 5) | 0))).get((31 & io$2));
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
function $as_sci_Vector3(obj) {
  return (((obj instanceof $c_sci_Vector3) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector3"));
}
function $isArrayOf_sci_Vector3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector3)));
}
function $asArrayOf_sci_Vector3(obj, depth) {
  return (($isArrayOf_sci_Vector3(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector3;", depth));
}
var $d_sci_Vector3 = new $TypeData().initClass($c_sci_Vector3, "scala.collection.immutable.Vector3", ({
  sci_Vector3: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Vector4(_prefix1, len1, prefix2, len12, prefix3, len123, data4, suffix3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector4__f_len1 = 0;
  this.sci_Vector4__f_prefix2 = null;
  this.sci_Vector4__f_len12 = 0;
  this.sci_Vector4__f_prefix3 = null;
  this.sci_Vector4__f_len123 = 0;
  this.sci_Vector4__f_data4 = null;
  this.sci_Vector4__f_suffix3 = null;
  this.sci_Vector4__f_suffix2 = null;
  this.sci_Vector4__f_len1 = len1;
  this.sci_Vector4__f_prefix2 = prefix2;
  this.sci_Vector4__f_len12 = len12;
  this.sci_Vector4__f_prefix3 = prefix3;
  this.sci_Vector4__f_len123 = len123;
  this.sci_Vector4__f_data4 = data4;
  this.sci_Vector4__f_suffix3 = suffix3;
  this.sci_Vector4__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0);
}
$c_sci_Vector4.prototype = new $h_sci_BigVector();
$c_sci_Vector4.prototype.constructor = $c_sci_Vector4;
/** @constructor */
function $h_sci_Vector4() {
}
$h_sci_Vector4.prototype = $c_sci_Vector4.prototype;
$c_sci_Vector4.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector4__f_len123) | 0);
    if ((io >= 0)) {
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i4 < $n(this.sci_Vector4__f_data4).u.length) ? $n($n($n($n(this.sci_Vector4__f_data4).get(i4)).get(i3)).get(i2)).get(i1) : ((i3 < $n(this.sci_Vector4__f_suffix3).u.length) ? $n($n($n(this.sci_Vector4__f_suffix3).get(i3)).get(i2)).get(i1) : ((i2 < $n(this.sci_Vector4__f_suffix2).u.length) ? $n($n(this.sci_Vector4__f_suffix2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get(i1))));
    } else if ((index >= this.sci_Vector4__f_len12)) {
      var io$2 = ((index - this.sci_Vector4__f_len12) | 0);
      return $n($n($n(this.sci_Vector4__f_prefix3).get(((io$2 >>> 10) | 0))).get((31 & ((io$2 >>> 5) | 0)))).get((31 & io$2));
    } else if ((index >= this.sci_Vector4__f_len1)) {
      var io$3 = ((index - this.sci_Vector4__f_len1) | 0);
      return $n($n(this.sci_Vector4__f_prefix2).get(((io$3 >>> 5) | 0))).get((31 & io$3));
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
$c_sci_Vector4.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector4__f_len123)) {
      var io = ((index - this.sci_Vector4__f_len123) | 0);
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i4 < $n(this.sci_Vector4__f_data4).u.length)) {
        var a4 = this.sci_Vector4__f_data4;
        var this$2 = $n(a4);
        var a4c = $n(this$2).clone__O();
        var $x_3 = $n(a4c);
        var a3 = $n(a4c).get(i4);
        var this$3 = $n(a3);
        var a3c = $n(this$3).clone__O();
        var $x_2 = $n(a3c);
        var a2 = $n(a3c).get(i3);
        var this$4 = $n(a2);
        var a2c = $n(this$4).clone__O();
        var $x_1 = $n(a2c);
        var a1 = $n(a2c).get(i2);
        var this$5 = $n(a1);
        var a1c = $n(this$5).clone__O();
        $n(a1c).set(i1, elem);
        $x_1.set(i2, a1c);
        $x_2.set(i3, a2c);
        $x_3.set(i4, a3c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector4__f_len1;
        var x$4 = this.sci_Vector4__f_prefix2;
        var x$5 = this.sci_Vector4__f_len12;
        var x$6 = this.sci_Vector4__f_prefix3;
        var x$7 = this.sci_Vector4__f_len123;
        var x$8 = this.sci_Vector4__f_suffix3;
        var x$9 = this.sci_Vector4__f_suffix2;
        var x$10 = this.sci_BigVector__f_suffix1;
        var x$11 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$2, x$3, x$4, x$5, x$6, x$7, a4c, x$8, x$9, x$10, x$11);
      } else if ((i3 < $n(this.sci_Vector4__f_suffix3).u.length)) {
        var a3$1 = this.sci_Vector4__f_suffix3;
        var this$7 = $n(a3$1);
        var a3c$1 = $n(this$7).clone__O();
        var $x_5 = $n(a3c$1);
        var a2$1 = $n(a3c$1).get(i3);
        var this$8 = $n(a2$1);
        var a2c$1 = $n(this$8).clone__O();
        var $x_4 = $n(a2c$1);
        var a1$1 = $n(a2c$1).get(i2);
        var this$9 = $n(a1$1);
        var a1c$1 = $n(this$9).clone__O();
        $n(a1c$1).set(i1, elem);
        $x_4.set(i2, a1c$1);
        $x_5.set(i3, a2c$1);
        var x$13 = this.sci_Vector__f_prefix1;
        var x$14 = this.sci_Vector4__f_len1;
        var x$15 = this.sci_Vector4__f_prefix2;
        var x$16 = this.sci_Vector4__f_len12;
        var x$17 = this.sci_Vector4__f_prefix3;
        var x$18 = this.sci_Vector4__f_len123;
        var x$19 = this.sci_Vector4__f_data4;
        var x$20 = this.sci_Vector4__f_suffix2;
        var x$21 = this.sci_BigVector__f_suffix1;
        var x$22 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$13, x$14, x$15, x$16, x$17, x$18, x$19, a3c$1, x$20, x$21, x$22);
      } else if ((i2 < $n(this.sci_Vector4__f_suffix2).u.length)) {
        var a2$2 = this.sci_Vector4__f_suffix2;
        var this$11 = $n(a2$2);
        var a2c$2 = $n(this$11).clone__O();
        var $x_6 = $n(a2c$2);
        var a1$2 = $n(a2c$2).get(i2);
        var this$12 = $n(a1$2);
        var a1c$2 = $n(this$12).clone__O();
        $n(a1c$2).set(i1, elem);
        $x_6.set(i2, a1c$2);
        var x$24 = this.sci_Vector__f_prefix1;
        var x$25 = this.sci_Vector4__f_len1;
        var x$26 = this.sci_Vector4__f_prefix2;
        var x$27 = this.sci_Vector4__f_len12;
        var x$28 = this.sci_Vector4__f_prefix3;
        var x$29 = this.sci_Vector4__f_len123;
        var x$30 = this.sci_Vector4__f_data4;
        var x$31 = this.sci_Vector4__f_suffix3;
        var x$32 = this.sci_BigVector__f_suffix1;
        var x$33 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$24, x$25, x$26, x$27, x$28, x$29, x$30, x$31, a2c$2, x$32, x$33);
      } else {
        var a1$3 = this.sci_BigVector__f_suffix1;
        var this$14 = $n(a1$3);
        var a1c$3 = $n(this$14).clone__O();
        $n(a1c$3).set(i1, elem);
        var x$35 = this.sci_Vector__f_prefix1;
        var x$36 = this.sci_Vector4__f_len1;
        var x$37 = this.sci_Vector4__f_prefix2;
        var x$38 = this.sci_Vector4__f_len12;
        var x$39 = this.sci_Vector4__f_prefix3;
        var x$40 = this.sci_Vector4__f_len123;
        var x$41 = this.sci_Vector4__f_data4;
        var x$42 = this.sci_Vector4__f_suffix3;
        var x$43 = this.sci_Vector4__f_suffix2;
        var x$44 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$35, x$36, x$37, x$38, x$39, x$40, x$41, x$42, x$43, a1c$3, x$44);
      }
    } else if ((index >= this.sci_Vector4__f_len12)) {
      var io$2 = ((index - this.sci_Vector4__f_len12) | 0);
      var a3$2 = this.sci_Vector4__f_prefix3;
      var idx3 = ((io$2 >>> 10) | 0);
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var this$16 = $n(a3$2);
      var a3c$2 = $n(this$16).clone__O();
      var $x_8 = $n(a3c$2);
      var a2$3 = $n(a3c$2).get(idx3);
      var this$17 = $n(a2$3);
      var a2c$3 = $n(this$17).clone__O();
      var $x_7 = $n(a2c$3);
      var a1$4 = $n(a2c$3).get(idx2);
      var this$18 = $n(a1$4);
      var a1c$4 = $n(this$18).clone__O();
      $n(a1c$4).set(idx1, elem);
      $x_7.set(idx2, a1c$4);
      $x_8.set(idx3, a2c$3);
      var x$46 = this.sci_Vector__f_prefix1;
      var x$47 = this.sci_Vector4__f_len1;
      var x$48 = this.sci_Vector4__f_prefix2;
      var x$49 = this.sci_Vector4__f_len12;
      var x$50 = this.sci_Vector4__f_len123;
      var x$51 = this.sci_Vector4__f_data4;
      var x$52 = this.sci_Vector4__f_suffix3;
      var x$53 = this.sci_Vector4__f_suffix2;
      var x$54 = this.sci_BigVector__f_suffix1;
      var x$55 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector4(x$46, x$47, x$48, x$49, a3c$2, x$50, x$51, x$52, x$53, x$54, x$55);
    } else if ((index >= this.sci_Vector4__f_len1)) {
      var io$3 = ((index - this.sci_Vector4__f_len1) | 0);
      var a2$4 = this.sci_Vector4__f_prefix2;
      var idx2$1 = ((io$3 >>> 5) | 0);
      var idx1$1 = (31 & io$3);
      var this$20 = $n(a2$4);
      var a2c$4 = $n(this$20).clone__O();
      var $x_9 = $n(a2c$4);
      var a1$5 = $n(a2c$4).get(idx2$1);
      var this$21 = $n(a1$5);
      var a1c$5 = $n(this$21).clone__O();
      $n(a1c$5).set(idx1$1, elem);
      $x_9.set(idx2$1, a1c$5);
      var x$57 = this.sci_Vector__f_prefix1;
      var x$58 = this.sci_Vector4__f_len1;
      var x$59 = this.sci_Vector4__f_len12;
      var x$60 = this.sci_Vector4__f_prefix3;
      var x$61 = this.sci_Vector4__f_len123;
      var x$62 = this.sci_Vector4__f_data4;
      var x$63 = this.sci_Vector4__f_suffix3;
      var x$64 = this.sci_Vector4__f_suffix2;
      var x$65 = this.sci_BigVector__f_suffix1;
      var x$66 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector4(x$57, x$58, a2c$4, x$59, x$60, x$61, x$62, x$63, x$64, x$65, x$66);
    } else {
      var a1$6 = this.sci_Vector__f_prefix1;
      var this$23 = $n(a1$6);
      var a1c$6 = $n(this$23).clone__O();
      $n(a1c$6).set(index, elem);
      var len1 = this.sci_Vector4__f_len1;
      var prefix2 = this.sci_Vector4__f_prefix2;
      var len12 = this.sci_Vector4__f_len12;
      var prefix3 = this.sci_Vector4__f_prefix3;
      var len123 = this.sci_Vector4__f_len123;
      var data4 = this.sci_Vector4__f_data4;
      var suffix3 = this.sci_Vector4__f_suffix3;
      var suffix2 = this.sci_Vector4__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector4(a1c$6, len1, prefix2, len12, prefix3, len123, data4, suffix3, suffix2, suffix1, length0);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
$c_sci_Vector4.prototype.appended__O__sci_Vector = (function(elem) {
  if (($n(this.sci_BigVector__f_suffix1).u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector4__f_len1;
    var x$5 = this.sci_Vector4__f_prefix2;
    var x$6 = this.sci_Vector4__f_len12;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_len123;
    var x$9 = this.sci_Vector4__f_data4;
    var x$10 = this.sci_Vector4__f_suffix3;
    var x$11 = this.sci_Vector4__f_suffix2;
    return new $c_sci_Vector4(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$1, x$2);
  } else if (($n(this.sci_Vector4__f_suffix2).u.length < 31)) {
    var x$12 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    $n(a).set(0, elem);
    var x$14 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$15 = this.sci_Vector__f_prefix1;
    var x$16 = this.sci_Vector4__f_len1;
    var x$17 = this.sci_Vector4__f_prefix2;
    var x$18 = this.sci_Vector4__f_len12;
    var x$19 = this.sci_Vector4__f_prefix3;
    var x$20 = this.sci_Vector4__f_len123;
    var x$21 = this.sci_Vector4__f_data4;
    var x$22 = this.sci_Vector4__f_suffix3;
    return new $c_sci_Vector4(x$15, x$16, x$17, x$18, x$19, x$20, x$21, x$22, x$12, a, x$14);
  } else if (($n(this.sci_Vector4__f_suffix3).u.length < 31)) {
    var x$23 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var x$24 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    $n(a$1).set(0, elem);
    var x$26 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$27 = this.sci_Vector__f_prefix1;
    var x$28 = this.sci_Vector4__f_len1;
    var x$29 = this.sci_Vector4__f_prefix2;
    var x$30 = this.sci_Vector4__f_len12;
    var x$31 = this.sci_Vector4__f_prefix3;
    var x$32 = this.sci_Vector4__f_len123;
    var x$33 = this.sci_Vector4__f_data4;
    return new $c_sci_Vector4(x$27, x$28, x$29, x$30, x$31, x$32, x$33, x$23, x$24, a$1, x$26);
  } else if (($n(this.sci_Vector4__f_data4).u.length < 30)) {
    var x$34 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_data4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1))), 4);
    var x$35 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$36 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$2 = new $ac_O(1);
    $n(a$2).set(0, elem);
    var x$38 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$39 = this.sci_Vector__f_prefix1;
    var x$40 = this.sci_Vector4__f_len1;
    var x$41 = this.sci_Vector4__f_prefix2;
    var x$42 = this.sci_Vector4__f_len12;
    var x$43 = this.sci_Vector4__f_prefix3;
    var x$44 = this.sci_Vector4__f_len123;
    return new $c_sci_Vector4(x$39, x$40, x$41, x$42, x$43, x$44, x$34, x$35, x$36, a$2, x$38);
  } else {
    var $x_11 = this.sci_Vector__f_prefix1;
    var $x_10 = this.sci_Vector4__f_len1;
    var $x_9 = this.sci_Vector4__f_prefix2;
    var $x_8 = this.sci_Vector4__f_len12;
    var $x_7 = this.sci_Vector4__f_prefix3;
    var $x_6 = this.sci_Vector4__f_len123;
    var $x_5 = this.sci_Vector4__f_data4;
    var $x_4 = this.sci_Vector4__f_len123;
    var $x_3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var a$3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    $n(a$3).set(0, x);
    var $x_2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var $x_1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$4 = new $ac_O(1);
    $n(a$4).set(0, elem);
    return new $c_sci_Vector5($x_11, $x_10, $x_9, $x_8, $x_7, $x_6, $x_5, ((983040 + $x_4) | 0), $x_3, a$3, $x_2, $x_1, a$4, ((1 + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector4.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector4__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector4__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector4__f_len12) | 0);
    var x$4 = ((1 + this.sci_Vector4__f_len123) | 0);
    var x$5 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$6 = this.sci_Vector4__f_prefix2;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_data4;
    var x$9 = this.sci_Vector4__f_suffix3;
    var x$10 = this.sci_Vector4__f_suffix2;
    var x$11 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(x$1, x$2, x$6, x$3, x$7, x$4, x$8, x$9, x$10, x$11, x$5);
  } else if ((this.sci_Vector4__f_len12 < 1024)) {
    var a = new $ac_O(1);
    $n(a).set(0, elem);
    var x$14 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), 2);
    var x$15 = ((1 + this.sci_Vector4__f_len12) | 0);
    var x$16 = ((1 + this.sci_Vector4__f_len123) | 0);
    var x$17 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$18 = this.sci_Vector4__f_prefix3;
    var x$19 = this.sci_Vector4__f_data4;
    var x$20 = this.sci_Vector4__f_suffix3;
    var x$21 = this.sci_Vector4__f_suffix2;
    var x$22 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(a, 1, x$14, x$15, x$18, x$16, x$19, x$20, x$21, x$22, x$17);
  } else if ((this.sci_Vector4__f_len123 < 32768)) {
    var a$1 = new $ac_O(1);
    $n(a$1).set(0, elem);
    var x$25 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$27 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), this.sci_Vector4__f_prefix3), 3);
    var x$28 = ((1 + this.sci_Vector4__f_len123) | 0);
    var x$29 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$30 = this.sci_Vector4__f_data4;
    var x$31 = this.sci_Vector4__f_suffix3;
    var x$32 = this.sci_Vector4__f_suffix2;
    var x$33 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(a$1, 1, x$25, 1, x$27, x$28, x$30, x$31, x$32, x$33, x$29);
  } else if (($n(this.sci_Vector4__f_data4).u.length < 30)) {
    var a$2 = new $ac_O(1);
    $n(a$2).set(0, elem);
    var x$36 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$38 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$40 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), this.sci_Vector4__f_prefix3), this.sci_Vector4__f_data4), 4);
    var x$41 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$42 = this.sci_Vector4__f_suffix3;
    var x$43 = this.sci_Vector4__f_suffix2;
    var x$44 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(a$2, 1, x$36, 1, x$38, 1, x$40, x$42, x$43, x$44, x$41);
  } else {
    var a$3 = new $ac_O(1);
    $n(a$3).set(0, elem);
    var $x_2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var $x_1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), this.sci_Vector4__f_prefix3), 3);
    var a$4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    $n(a$4).set(0, x);
    return new $c_sci_Vector5(a$3, 1, $x_2, 1, $x_1, 1, a$4, ((1 + this.sci_Vector4__f_len123) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5, this.sci_Vector4__f_data4, this.sci_Vector4__f_suffix3, this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector4.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector4__f_prefix2, f), 2);
  var x$3 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector4__f_prefix3, f), 3);
  var x$4 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector4__f_data4, f), 4);
  var x$5 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector4__f_suffix3, f), 3);
  var x$6 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector4__f_suffix2, f), 2);
  var x$7 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$8 = this.sci_Vector4__f_len1;
  var x$9 = this.sci_Vector4__f_len12;
  var x$10 = this.sci_Vector4__f_len123;
  var x$11 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector4(x$1, x$8, x$2, x$9, x$3, x$10, x$4, x$5, x$6, x$7, x$11);
});
$c_sci_Vector4.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector4__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector4__f_prefix3);
  b.consider__I__AO__V(4, this.sci_Vector4__f_data4);
  b.consider__I__AO__V(3, this.sci_Vector4__f_suffix3);
  b.consider__I__AO__V(2, this.sci_Vector4__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector();
});
$c_sci_Vector4.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector4__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = $n(a).u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector4__f_len1) | 0);
    var x$3 = (((-1) + this.sci_Vector4__f_len12) | 0);
    var x$4 = (((-1) + this.sci_Vector4__f_len123) | 0);
    var x$5 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$6 = this.sci_Vector4__f_prefix2;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_data4;
    var x$9 = this.sci_Vector4__f_suffix3;
    var x$10 = this.sci_Vector4__f_suffix2;
    var x$11 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(x$1, x$2, x$6, x$3, x$7, x$4, x$8, x$9, x$10, x$11, x$5);
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0);
  }
});
$c_sci_Vector4.prototype.init__sci_Vector = (function() {
  if (($n(this.sci_BigVector__f_suffix1).u.length > 1)) {
    var a = this.sci_BigVector__f_suffix1;
    var to = (((-1) + $n(a).u.length) | 0);
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, to);
    var x$2 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector4__f_len1;
    var x$5 = this.sci_Vector4__f_prefix2;
    var x$6 = this.sci_Vector4__f_len12;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_len123;
    var x$9 = this.sci_Vector4__f_data4;
    var x$10 = this.sci_Vector4__f_suffix3;
    var x$11 = this.sci_Vector4__f_suffix2;
    return new $c_sci_Vector4(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$1, x$2);
  } else {
    return this.slice0__I__I__sci_Vector(0, (((-1) + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector4.prototype.vectorSliceCount__I = (function() {
  return 7;
});
$c_sci_Vector4.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break;
    }
    case 1: {
      return this.sci_Vector4__f_prefix2;
      break;
    }
    case 2: {
      return this.sci_Vector4__f_prefix3;
      break;
    }
    case 3: {
      return this.sci_Vector4__f_data4;
      break;
    }
    case 4: {
      return this.sci_Vector4__f_suffix3;
      break;
    }
    case 5: {
      return this.sci_Vector4__f_suffix2;
      break;
    }
    case 6: {
      return this.sci_BigVector__f_suffix1;
      break;
    }
    default: {
      throw new $c_s_MatchError(idx);
    }
  }
});
$c_sci_Vector4.prototype.prependedAll0__sc_IterableOnce__I__sci_Vector = (function(prefix, k) {
  var x1 = $m_sci_VectorStatics$().prepend1IfSpace__AO__sc_IterableOnce__AO(this.sci_Vector__f_prefix1, prefix);
  if ((x1 === null)) {
    return $c_sci_Vector.prototype.prependedAll0__sc_IterableOnce__I__sci_Vector.call(this, prefix, k);
  } else {
    var diff = (($n(x1).u.length - $n(this.sci_Vector__f_prefix1).u.length) | 0);
    var x$2 = ((this.sci_Vector4__f_len1 + diff) | 0);
    var x$3 = ((this.sci_Vector4__f_len12 + diff) | 0);
    var x$4 = ((this.sci_Vector4__f_len123 + diff) | 0);
    var x$5 = ((this.sci_BigVector__f_length0 + diff) | 0);
    var x$6 = this.sci_Vector4__f_prefix2;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_data4;
    var x$9 = this.sci_Vector4__f_suffix3;
    var x$10 = this.sci_Vector4__f_suffix2;
    var x$11 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(x1, x$2, x$6, x$3, x$7, x$4, x$8, x$9, x$10, x$11, x$5);
  }
});
$c_sci_Vector4.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - $n(this.sci_BigVector__f_suffix1).u.length) | 0) + $n(suffix1b).u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector4__f_len1;
    var x$5 = this.sci_Vector4__f_prefix2;
    var x$6 = this.sci_Vector4__f_len12;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_len123;
    var x$9 = this.sci_Vector4__f_data4;
    var x$10 = this.sci_Vector4__f_suffix3;
    var x$11 = this.sci_Vector4__f_suffix2;
    return new $c_sci_Vector4(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, suffix1b, x$2);
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k);
  }
});
$c_sci_Vector4.prototype.init__O = (function() {
  return this.init__sci_Vector();
});
$c_sci_Vector4.prototype.tail__O = (function() {
  return this.tail__sci_Vector();
});
$c_sci_Vector4.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f);
});
$c_sci_Vector4.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Vector(elem);
});
$c_sci_Vector4.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem);
});
$c_sci_Vector4.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector4__f_len123) | 0);
    if ((io >= 0)) {
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i4 < $n(this.sci_Vector4__f_data4).u.length) ? $n($n($n($n(this.sci_Vector4__f_data4).get(i4)).get(i3)).get(i2)).get(i1) : ((i3 < $n(this.sci_Vector4__f_suffix3).u.length) ? $n($n($n(this.sci_Vector4__f_suffix3).get(i3)).get(i2)).get(i1) : ((i2 < $n(this.sci_Vector4__f_suffix2).u.length) ? $n($n(this.sci_Vector4__f_suffix2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get(i1))));
    } else if ((index >= this.sci_Vector4__f_len12)) {
      var io$2 = ((index - this.sci_Vector4__f_len12) | 0);
      return $n($n($n(this.sci_Vector4__f_prefix3).get(((io$2 >>> 10) | 0))).get((31 & ((io$2 >>> 5) | 0)))).get((31 & io$2));
    } else if ((index >= this.sci_Vector4__f_len1)) {
      var io$3 = ((index - this.sci_Vector4__f_len1) | 0);
      return $n($n(this.sci_Vector4__f_prefix2).get(((io$3 >>> 5) | 0))).get((31 & io$3));
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
function $as_sci_Vector4(obj) {
  return (((obj instanceof $c_sci_Vector4) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector4"));
}
function $isArrayOf_sci_Vector4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector4)));
}
function $asArrayOf_sci_Vector4(obj, depth) {
  return (($isArrayOf_sci_Vector4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector4;", depth));
}
var $d_sci_Vector4 = new $TypeData().initClass($c_sci_Vector4, "scala.collection.immutable.Vector4", ({
  sci_Vector4: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Vector5(_prefix1, len1, prefix2, len12, prefix3, len123, prefix4, len1234, data5, suffix4, suffix3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector5__f_len1 = 0;
  this.sci_Vector5__f_prefix2 = null;
  this.sci_Vector5__f_len12 = 0;
  this.sci_Vector5__f_prefix3 = null;
  this.sci_Vector5__f_len123 = 0;
  this.sci_Vector5__f_prefix4 = null;
  this.sci_Vector5__f_len1234 = 0;
  this.sci_Vector5__f_data5 = null;
  this.sci_Vector5__f_suffix4 = null;
  this.sci_Vector5__f_suffix3 = null;
  this.sci_Vector5__f_suffix2 = null;
  this.sci_Vector5__f_len1 = len1;
  this.sci_Vector5__f_prefix2 = prefix2;
  this.sci_Vector5__f_len12 = len12;
  this.sci_Vector5__f_prefix3 = prefix3;
  this.sci_Vector5__f_len123 = len123;
  this.sci_Vector5__f_prefix4 = prefix4;
  this.sci_Vector5__f_len1234 = len1234;
  this.sci_Vector5__f_data5 = data5;
  this.sci_Vector5__f_suffix4 = suffix4;
  this.sci_Vector5__f_suffix3 = suffix3;
  this.sci_Vector5__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0);
}
$c_sci_Vector5.prototype = new $h_sci_BigVector();
$c_sci_Vector5.prototype.constructor = $c_sci_Vector5;
/** @constructor */
function $h_sci_Vector5() {
}
$h_sci_Vector5.prototype = $c_sci_Vector5.prototype;
$c_sci_Vector5.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector5__f_len1234) | 0);
    if ((io >= 0)) {
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i5 < $n(this.sci_Vector5__f_data5).u.length) ? $n($n($n($n($n(this.sci_Vector5__f_data5).get(i5)).get(i4)).get(i3)).get(i2)).get(i1) : ((i4 < $n(this.sci_Vector5__f_suffix4).u.length) ? $n($n($n($n(this.sci_Vector5__f_suffix4).get(i4)).get(i3)).get(i2)).get(i1) : ((i3 < $n(this.sci_Vector5__f_suffix3).u.length) ? $n($n($n(this.sci_Vector5__f_suffix3).get(i3)).get(i2)).get(i1) : ((i2 < $n(this.sci_Vector5__f_suffix2).u.length) ? $n($n(this.sci_Vector5__f_suffix2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get(i1)))));
    } else if ((index >= this.sci_Vector5__f_len123)) {
      var io$2 = ((index - this.sci_Vector5__f_len123) | 0);
      return $n($n($n($n(this.sci_Vector5__f_prefix4).get(((io$2 >>> 15) | 0))).get((31 & ((io$2 >>> 10) | 0)))).get((31 & ((io$2 >>> 5) | 0)))).get((31 & io$2));
    } else if ((index >= this.sci_Vector5__f_len12)) {
      var io$3 = ((index - this.sci_Vector5__f_len12) | 0);
      return $n($n($n(this.sci_Vector5__f_prefix3).get(((io$3 >>> 10) | 0))).get((31 & ((io$3 >>> 5) | 0)))).get((31 & io$3));
    } else if ((index >= this.sci_Vector5__f_len1)) {
      var io$4 = ((index - this.sci_Vector5__f_len1) | 0);
      return $n($n(this.sci_Vector5__f_prefix2).get(((io$4 >>> 5) | 0))).get((31 & io$4));
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
$c_sci_Vector5.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector5__f_len1234)) {
      var io = ((index - this.sci_Vector5__f_len1234) | 0);
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i5 < $n(this.sci_Vector5__f_data5).u.length)) {
        var a5 = this.sci_Vector5__f_data5;
        var this$2 = $n(a5);
        var a5c = $n(this$2).clone__O();
        var $x_4 = $n(a5c);
        var a4 = $n(a5c).get(i5);
        var this$3 = $n(a4);
        var a4c = $n(this$3).clone__O();
        var $x_3 = $n(a4c);
        var a3 = $n(a4c).get(i4);
        var this$4 = $n(a3);
        var a3c = $n(this$4).clone__O();
        var $x_2 = $n(a3c);
        var a2 = $n(a3c).get(i3);
        var this$5 = $n(a2);
        var a2c = $n(this$5).clone__O();
        var $x_1 = $n(a2c);
        var a1 = $n(a2c).get(i2);
        var this$6 = $n(a1);
        var a1c = $n(this$6).clone__O();
        $n(a1c).set(i1, elem);
        $x_1.set(i2, a1c);
        $x_2.set(i3, a2c);
        $x_3.set(i4, a3c);
        $x_4.set(i5, a4c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector5__f_len1;
        var x$4 = this.sci_Vector5__f_prefix2;
        var x$5 = this.sci_Vector5__f_len12;
        var x$6 = this.sci_Vector5__f_prefix3;
        var x$7 = this.sci_Vector5__f_len123;
        var x$8 = this.sci_Vector5__f_prefix4;
        var x$9 = this.sci_Vector5__f_len1234;
        var x$10 = this.sci_Vector5__f_suffix4;
        var x$11 = this.sci_Vector5__f_suffix3;
        var x$12 = this.sci_Vector5__f_suffix2;
        var x$13 = this.sci_BigVector__f_suffix1;
        var x$14 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$2, x$3, x$4, x$5, x$6, x$7, x$8, x$9, a5c, x$10, x$11, x$12, x$13, x$14);
      } else if ((i4 < $n(this.sci_Vector5__f_suffix4).u.length)) {
        var a4$1 = this.sci_Vector5__f_suffix4;
        var this$8 = $n(a4$1);
        var a4c$1 = $n(this$8).clone__O();
        var $x_7 = $n(a4c$1);
        var a3$1 = $n(a4c$1).get(i4);
        var this$9 = $n(a3$1);
        var a3c$1 = $n(this$9).clone__O();
        var $x_6 = $n(a3c$1);
        var a2$1 = $n(a3c$1).get(i3);
        var this$10 = $n(a2$1);
        var a2c$1 = $n(this$10).clone__O();
        var $x_5 = $n(a2c$1);
        var a1$1 = $n(a2c$1).get(i2);
        var this$11 = $n(a1$1);
        var a1c$1 = $n(this$11).clone__O();
        $n(a1c$1).set(i1, elem);
        $x_5.set(i2, a1c$1);
        $x_6.set(i3, a2c$1);
        $x_7.set(i4, a3c$1);
        var x$16 = this.sci_Vector__f_prefix1;
        var x$17 = this.sci_Vector5__f_len1;
        var x$18 = this.sci_Vector5__f_prefix2;
        var x$19 = this.sci_Vector5__f_len12;
        var x$20 = this.sci_Vector5__f_prefix3;
        var x$21 = this.sci_Vector5__f_len123;
        var x$22 = this.sci_Vector5__f_prefix4;
        var x$23 = this.sci_Vector5__f_len1234;
        var x$24 = this.sci_Vector5__f_data5;
        var x$25 = this.sci_Vector5__f_suffix3;
        var x$26 = this.sci_Vector5__f_suffix2;
        var x$27 = this.sci_BigVector__f_suffix1;
        var x$28 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$16, x$17, x$18, x$19, x$20, x$21, x$22, x$23, x$24, a4c$1, x$25, x$26, x$27, x$28);
      } else if ((i3 < $n(this.sci_Vector5__f_suffix3).u.length)) {
        var a3$2 = this.sci_Vector5__f_suffix3;
        var this$13 = $n(a3$2);
        var a3c$2 = $n(this$13).clone__O();
        var $x_9 = $n(a3c$2);
        var a2$2 = $n(a3c$2).get(i3);
        var this$14 = $n(a2$2);
        var a2c$2 = $n(this$14).clone__O();
        var $x_8 = $n(a2c$2);
        var a1$2 = $n(a2c$2).get(i2);
        var this$15 = $n(a1$2);
        var a1c$2 = $n(this$15).clone__O();
        $n(a1c$2).set(i1, elem);
        $x_8.set(i2, a1c$2);
        $x_9.set(i3, a2c$2);
        var x$30 = this.sci_Vector__f_prefix1;
        var x$31 = this.sci_Vector5__f_len1;
        var x$32 = this.sci_Vector5__f_prefix2;
        var x$33 = this.sci_Vector5__f_len12;
        var x$34 = this.sci_Vector5__f_prefix3;
        var x$35 = this.sci_Vector5__f_len123;
        var x$36 = this.sci_Vector5__f_prefix4;
        var x$37 = this.sci_Vector5__f_len1234;
        var x$38 = this.sci_Vector5__f_data5;
        var x$39 = this.sci_Vector5__f_suffix4;
        var x$40 = this.sci_Vector5__f_suffix2;
        var x$41 = this.sci_BigVector__f_suffix1;
        var x$42 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$30, x$31, x$32, x$33, x$34, x$35, x$36, x$37, x$38, x$39, a3c$2, x$40, x$41, x$42);
      } else if ((i2 < $n(this.sci_Vector5__f_suffix2).u.length)) {
        var a2$3 = this.sci_Vector5__f_suffix2;
        var this$17 = $n(a2$3);
        var a2c$3 = $n(this$17).clone__O();
        var $x_10 = $n(a2c$3);
        var a1$3 = $n(a2c$3).get(i2);
        var this$18 = $n(a1$3);
        var a1c$3 = $n(this$18).clone__O();
        $n(a1c$3).set(i1, elem);
        $x_10.set(i2, a1c$3);
        var x$44 = this.sci_Vector__f_prefix1;
        var x$45 = this.sci_Vector5__f_len1;
        var x$46 = this.sci_Vector5__f_prefix2;
        var x$47 = this.sci_Vector5__f_len12;
        var x$48 = this.sci_Vector5__f_prefix3;
        var x$49 = this.sci_Vector5__f_len123;
        var x$50 = this.sci_Vector5__f_prefix4;
        var x$51 = this.sci_Vector5__f_len1234;
        var x$52 = this.sci_Vector5__f_data5;
        var x$53 = this.sci_Vector5__f_suffix4;
        var x$54 = this.sci_Vector5__f_suffix3;
        var x$55 = this.sci_BigVector__f_suffix1;
        var x$56 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$44, x$45, x$46, x$47, x$48, x$49, x$50, x$51, x$52, x$53, x$54, a2c$3, x$55, x$56);
      } else {
        var a1$4 = this.sci_BigVector__f_suffix1;
        var this$20 = $n(a1$4);
        var a1c$4 = $n(this$20).clone__O();
        $n(a1c$4).set(i1, elem);
        var x$58 = this.sci_Vector__f_prefix1;
        var x$59 = this.sci_Vector5__f_len1;
        var x$60 = this.sci_Vector5__f_prefix2;
        var x$61 = this.sci_Vector5__f_len12;
        var x$62 = this.sci_Vector5__f_prefix3;
        var x$63 = this.sci_Vector5__f_len123;
        var x$64 = this.sci_Vector5__f_prefix4;
        var x$65 = this.sci_Vector5__f_len1234;
        var x$66 = this.sci_Vector5__f_data5;
        var x$67 = this.sci_Vector5__f_suffix4;
        var x$68 = this.sci_Vector5__f_suffix3;
        var x$69 = this.sci_Vector5__f_suffix2;
        var x$70 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$58, x$59, x$60, x$61, x$62, x$63, x$64, x$65, x$66, x$67, x$68, x$69, a1c$4, x$70);
      }
    } else if ((index >= this.sci_Vector5__f_len123)) {
      var io$2 = ((index - this.sci_Vector5__f_len123) | 0);
      var a4$2 = this.sci_Vector5__f_prefix4;
      var idx4 = ((io$2 >>> 15) | 0);
      var idx3 = (31 & ((io$2 >>> 10) | 0));
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var this$22 = $n(a4$2);
      var a4c$2 = $n(this$22).clone__O();
      var $x_13 = $n(a4c$2);
      var a3$3 = $n(a4c$2).get(idx4);
      var this$23 = $n(a3$3);
      var a3c$3 = $n(this$23).clone__O();
      var $x_12 = $n(a3c$3);
      var a2$4 = $n(a3c$3).get(idx3);
      var this$24 = $n(a2$4);
      var a2c$4 = $n(this$24).clone__O();
      var $x_11 = $n(a2c$4);
      var a1$5 = $n(a2c$4).get(idx2);
      var this$25 = $n(a1$5);
      var a1c$5 = $n(this$25).clone__O();
      $n(a1c$5).set(idx1, elem);
      $x_11.set(idx2, a1c$5);
      $x_12.set(idx3, a2c$4);
      $x_13.set(idx4, a3c$3);
      var x$72 = this.sci_Vector__f_prefix1;
      var x$73 = this.sci_Vector5__f_len1;
      var x$74 = this.sci_Vector5__f_prefix2;
      var x$75 = this.sci_Vector5__f_len12;
      var x$76 = this.sci_Vector5__f_prefix3;
      var x$77 = this.sci_Vector5__f_len123;
      var x$78 = this.sci_Vector5__f_len1234;
      var x$79 = this.sci_Vector5__f_data5;
      var x$80 = this.sci_Vector5__f_suffix4;
      var x$81 = this.sci_Vector5__f_suffix3;
      var x$82 = this.sci_Vector5__f_suffix2;
      var x$83 = this.sci_BigVector__f_suffix1;
      var x$84 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(x$72, x$73, x$74, x$75, x$76, x$77, a4c$2, x$78, x$79, x$80, x$81, x$82, x$83, x$84);
    } else if ((index >= this.sci_Vector5__f_len12)) {
      var io$3 = ((index - this.sci_Vector5__f_len12) | 0);
      var a3$4 = this.sci_Vector5__f_prefix3;
      var idx3$1 = ((io$3 >>> 10) | 0);
      var idx2$1 = (31 & ((io$3 >>> 5) | 0));
      var idx1$1 = (31 & io$3);
      var this$27 = $n(a3$4);
      var a3c$4 = $n(this$27).clone__O();
      var $x_15 = $n(a3c$4);
      var a2$5 = $n(a3c$4).get(idx3$1);
      var this$28 = $n(a2$5);
      var a2c$5 = $n(this$28).clone__O();
      var $x_14 = $n(a2c$5);
      var a1$6 = $n(a2c$5).get(idx2$1);
      var this$29 = $n(a1$6);
      var a1c$6 = $n(this$29).clone__O();
      $n(a1c$6).set(idx1$1, elem);
      $x_14.set(idx2$1, a1c$6);
      $x_15.set(idx3$1, a2c$5);
      var x$86 = this.sci_Vector__f_prefix1;
      var x$87 = this.sci_Vector5__f_len1;
      var x$88 = this.sci_Vector5__f_prefix2;
      var x$89 = this.sci_Vector5__f_len12;
      var x$90 = this.sci_Vector5__f_len123;
      var x$91 = this.sci_Vector5__f_prefix4;
      var x$92 = this.sci_Vector5__f_len1234;
      var x$93 = this.sci_Vector5__f_data5;
      var x$94 = this.sci_Vector5__f_suffix4;
      var x$95 = this.sci_Vector5__f_suffix3;
      var x$96 = this.sci_Vector5__f_suffix2;
      var x$97 = this.sci_BigVector__f_suffix1;
      var x$98 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(x$86, x$87, x$88, x$89, a3c$4, x$90, x$91, x$92, x$93, x$94, x$95, x$96, x$97, x$98);
    } else if ((index >= this.sci_Vector5__f_len1)) {
      var io$4 = ((index - this.sci_Vector5__f_len1) | 0);
      var a2$6 = this.sci_Vector5__f_prefix2;
      var idx2$2 = ((io$4 >>> 5) | 0);
      var idx1$2 = (31 & io$4);
      var this$31 = $n(a2$6);
      var a2c$6 = $n(this$31).clone__O();
      var $x_16 = $n(a2c$6);
      var a1$7 = $n(a2c$6).get(idx2$2);
      var this$32 = $n(a1$7);
      var a1c$7 = $n(this$32).clone__O();
      $n(a1c$7).set(idx1$2, elem);
      $x_16.set(idx2$2, a1c$7);
      var x$100 = this.sci_Vector__f_prefix1;
      var x$101 = this.sci_Vector5__f_len1;
      var x$102 = this.sci_Vector5__f_len12;
      var x$103 = this.sci_Vector5__f_prefix3;
      var x$104 = this.sci_Vector5__f_len123;
      var x$105 = this.sci_Vector5__f_prefix4;
      var x$106 = this.sci_Vector5__f_len1234;
      var x$107 = this.sci_Vector5__f_data5;
      var x$108 = this.sci_Vector5__f_suffix4;
      var x$109 = this.sci_Vector5__f_suffix3;
      var x$110 = this.sci_Vector5__f_suffix2;
      var x$111 = this.sci_BigVector__f_suffix1;
      var x$112 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(x$100, x$101, a2c$6, x$102, x$103, x$104, x$105, x$106, x$107, x$108, x$109, x$110, x$111, x$112);
    } else {
      var a1$8 = this.sci_Vector__f_prefix1;
      var this$34 = $n(a1$8);
      var a1c$8 = $n(this$34).clone__O();
      $n(a1c$8).set(index, elem);
      var len1 = this.sci_Vector5__f_len1;
      var prefix2 = this.sci_Vector5__f_prefix2;
      var len12 = this.sci_Vector5__f_len12;
      var prefix3 = this.sci_Vector5__f_prefix3;
      var len123 = this.sci_Vector5__f_len123;
      var prefix4 = this.sci_Vector5__f_prefix4;
      var len1234 = this.sci_Vector5__f_len1234;
      var data5 = this.sci_Vector5__f_data5;
      var suffix4 = this.sci_Vector5__f_suffix4;
      var suffix3 = this.sci_Vector5__f_suffix3;
      var suffix2 = this.sci_Vector5__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(a1c$8, len1, prefix2, len12, prefix3, len123, prefix4, len1234, data5, suffix4, suffix3, suffix2, suffix1, length0);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
$c_sci_Vector5.prototype.appended__O__sci_Vector = (function(elem) {
  if (($n(this.sci_BigVector__f_suffix1).u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector5__f_len1;
    var x$5 = this.sci_Vector5__f_prefix2;
    var x$6 = this.sci_Vector5__f_len12;
    var x$7 = this.sci_Vector5__f_prefix3;
    var x$8 = this.sci_Vector5__f_len123;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_len1234;
    var x$11 = this.sci_Vector5__f_data5;
    var x$12 = this.sci_Vector5__f_suffix4;
    var x$13 = this.sci_Vector5__f_suffix3;
    var x$14 = this.sci_Vector5__f_suffix2;
    return new $c_sci_Vector5(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$1, x$2);
  } else if (($n(this.sci_Vector5__f_suffix2).u.length < 31)) {
    var x$15 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    $n(a).set(0, elem);
    var x$17 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$18 = this.sci_Vector__f_prefix1;
    var x$19 = this.sci_Vector5__f_len1;
    var x$20 = this.sci_Vector5__f_prefix2;
    var x$21 = this.sci_Vector5__f_len12;
    var x$22 = this.sci_Vector5__f_prefix3;
    var x$23 = this.sci_Vector5__f_len123;
    var x$24 = this.sci_Vector5__f_prefix4;
    var x$25 = this.sci_Vector5__f_len1234;
    var x$26 = this.sci_Vector5__f_data5;
    var x$27 = this.sci_Vector5__f_suffix4;
    var x$28 = this.sci_Vector5__f_suffix3;
    return new $c_sci_Vector5(x$18, x$19, x$20, x$21, x$22, x$23, x$24, x$25, x$26, x$27, x$28, x$15, a, x$17);
  } else if (($n(this.sci_Vector5__f_suffix3).u.length < 31)) {
    var x$29 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var x$30 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    $n(a$1).set(0, elem);
    var x$32 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$33 = this.sci_Vector__f_prefix1;
    var x$34 = this.sci_Vector5__f_len1;
    var x$35 = this.sci_Vector5__f_prefix2;
    var x$36 = this.sci_Vector5__f_len12;
    var x$37 = this.sci_Vector5__f_prefix3;
    var x$38 = this.sci_Vector5__f_len123;
    var x$39 = this.sci_Vector5__f_prefix4;
    var x$40 = this.sci_Vector5__f_len1234;
    var x$41 = this.sci_Vector5__f_data5;
    var x$42 = this.sci_Vector5__f_suffix4;
    return new $c_sci_Vector5(x$33, x$34, x$35, x$36, x$37, x$38, x$39, x$40, x$41, x$42, x$29, x$30, a$1, x$32);
  } else if (($n(this.sci_Vector5__f_suffix4).u.length < 31)) {
    var x$43 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1))), 4);
    var x$44 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$45 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$2 = new $ac_O(1);
    $n(a$2).set(0, elem);
    var x$47 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$48 = this.sci_Vector__f_prefix1;
    var x$49 = this.sci_Vector5__f_len1;
    var x$50 = this.sci_Vector5__f_prefix2;
    var x$51 = this.sci_Vector5__f_len12;
    var x$52 = this.sci_Vector5__f_prefix3;
    var x$53 = this.sci_Vector5__f_len123;
    var x$54 = this.sci_Vector5__f_prefix4;
    var x$55 = this.sci_Vector5__f_len1234;
    var x$56 = this.sci_Vector5__f_data5;
    return new $c_sci_Vector5(x$48, x$49, x$50, x$51, x$52, x$53, x$54, x$55, x$56, x$43, x$44, x$45, a$2, x$47);
  } else if (($n(this.sci_Vector5__f_data5).u.length < 30)) {
    var x$57 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_data5, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1)))), 5);
    var x$58 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$59 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$60 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$3 = new $ac_O(1);
    $n(a$3).set(0, elem);
    var x$62 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$63 = this.sci_Vector__f_prefix1;
    var x$64 = this.sci_Vector5__f_len1;
    var x$65 = this.sci_Vector5__f_prefix2;
    var x$66 = this.sci_Vector5__f_len12;
    var x$67 = this.sci_Vector5__f_prefix3;
    var x$68 = this.sci_Vector5__f_len123;
    var x$69 = this.sci_Vector5__f_prefix4;
    var x$70 = this.sci_Vector5__f_len1234;
    return new $c_sci_Vector5(x$63, x$64, x$65, x$66, x$67, x$68, x$69, x$70, x$57, x$58, x$59, x$60, a$3, x$62);
  } else {
    var $x_14 = this.sci_Vector__f_prefix1;
    var $x_13 = this.sci_Vector5__f_len1;
    var $x_12 = this.sci_Vector5__f_prefix2;
    var $x_11 = this.sci_Vector5__f_len12;
    var $x_10 = this.sci_Vector5__f_prefix3;
    var $x_9 = this.sci_Vector5__f_len123;
    var $x_8 = this.sci_Vector5__f_prefix4;
    var $x_7 = this.sci_Vector5__f_len1234;
    var $x_6 = this.sci_Vector5__f_data5;
    var $x_5 = this.sci_Vector5__f_len1234;
    var $x_4 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty6;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1))), 4);
    var a$4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    $n(a$4).set(0, x);
    var $x_3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var $x_2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var $x_1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$5 = new $ac_O(1);
    $n(a$5).set(0, elem);
    return new $c_sci_Vector6($x_14, $x_13, $x_12, $x_11, $x_10, $x_9, $x_8, $x_7, $x_6, ((31457280 + $x_5) | 0), $x_4, a$4, $x_3, $x_2, $x_1, a$5, ((1 + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector5.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector5__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector5__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector5__f_len12) | 0);
    var x$4 = ((1 + this.sci_Vector5__f_len123) | 0);
    var x$5 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$6 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$7 = this.sci_Vector5__f_prefix2;
    var x$8 = this.sci_Vector5__f_prefix3;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_data5;
    var x$11 = this.sci_Vector5__f_suffix4;
    var x$12 = this.sci_Vector5__f_suffix3;
    var x$13 = this.sci_Vector5__f_suffix2;
    var x$14 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(x$1, x$2, x$7, x$3, x$8, x$4, x$9, x$5, x$10, x$11, x$12, x$13, x$14, x$6);
  } else if ((this.sci_Vector5__f_len12 < 1024)) {
    var a = new $ac_O(1);
    $n(a).set(0, elem);
    var x$17 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), 2);
    var x$18 = ((1 + this.sci_Vector5__f_len12) | 0);
    var x$19 = ((1 + this.sci_Vector5__f_len123) | 0);
    var x$20 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$21 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$22 = this.sci_Vector5__f_prefix3;
    var x$23 = this.sci_Vector5__f_prefix4;
    var x$24 = this.sci_Vector5__f_data5;
    var x$25 = this.sci_Vector5__f_suffix4;
    var x$26 = this.sci_Vector5__f_suffix3;
    var x$27 = this.sci_Vector5__f_suffix2;
    var x$28 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a, 1, x$17, x$18, x$22, x$19, x$23, x$20, x$24, x$25, x$26, x$27, x$28, x$21);
  } else if ((this.sci_Vector5__f_len123 < 32768)) {
    var a$1 = new $ac_O(1);
    $n(a$1).set(0, elem);
    var x$31 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$33 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), 3);
    var x$34 = ((1 + this.sci_Vector5__f_len123) | 0);
    var x$35 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$36 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$37 = this.sci_Vector5__f_prefix4;
    var x$38 = this.sci_Vector5__f_data5;
    var x$39 = this.sci_Vector5__f_suffix4;
    var x$40 = this.sci_Vector5__f_suffix3;
    var x$41 = this.sci_Vector5__f_suffix2;
    var x$42 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a$1, 1, x$31, 1, x$33, x$34, x$37, x$35, x$38, x$39, x$40, x$41, x$42, x$36);
  } else if ((this.sci_Vector5__f_len1234 < 1048576)) {
    var a$2 = new $ac_O(1);
    $n(a$2).set(0, elem);
    var x$45 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$47 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$49 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), this.sci_Vector5__f_prefix4), 4);
    var x$50 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$51 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$52 = this.sci_Vector5__f_data5;
    var x$53 = this.sci_Vector5__f_suffix4;
    var x$54 = this.sci_Vector5__f_suffix3;
    var x$55 = this.sci_Vector5__f_suffix2;
    var x$56 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a$2, 1, x$45, 1, x$47, 1, x$49, x$50, x$52, x$53, x$54, x$55, x$56, x$51);
  } else if (($n(this.sci_Vector5__f_data5).u.length < 30)) {
    var a$3 = new $ac_O(1);
    $n(a$3).set(0, elem);
    var x$59 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$61 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$63 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$65 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), this.sci_Vector5__f_prefix4), this.sci_Vector5__f_data5), 5);
    var x$66 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$67 = this.sci_Vector5__f_suffix4;
    var x$68 = this.sci_Vector5__f_suffix3;
    var x$69 = this.sci_Vector5__f_suffix2;
    var x$70 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a$3, 1, x$59, 1, x$61, 1, x$63, 1, x$65, x$67, x$68, x$69, x$70, x$66);
  } else {
    var a$4 = new $ac_O(1);
    $n(a$4).set(0, elem);
    var $x_3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var $x_2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var $x_1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), this.sci_Vector5__f_prefix4), 4);
    var a$5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    $n(a$5).set(0, x);
    return new $c_sci_Vector6(a$4, 1, $x_3, 1, $x_2, 1, $x_1, 1, a$5, ((1 + this.sci_Vector5__f_len1234) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty6, this.sci_Vector5__f_data5, this.sci_Vector5__f_suffix4, this.sci_Vector5__f_suffix3, this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector5.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector5__f_prefix2, f), 2);
  var x$3 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector5__f_prefix3, f), 3);
  var x$4 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector5__f_prefix4, f), 4);
  var x$5 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(5, this.sci_Vector5__f_data5, f), 5);
  var x$6 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector5__f_suffix4, f), 4);
  var x$7 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector5__f_suffix3, f), 3);
  var x$8 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector5__f_suffix2, f), 2);
  var x$9 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$10 = this.sci_Vector5__f_len1;
  var x$11 = this.sci_Vector5__f_len12;
  var x$12 = this.sci_Vector5__f_len123;
  var x$13 = this.sci_Vector5__f_len1234;
  var x$14 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector5(x$1, x$10, x$2, x$11, x$3, x$12, x$4, x$13, x$5, x$6, x$7, x$8, x$9, x$14);
});
$c_sci_Vector5.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector5__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector5__f_prefix3);
  b.consider__I__AO__V(4, this.sci_Vector5__f_prefix4);
  b.consider__I__AO__V(5, this.sci_Vector5__f_data5);
  b.consider__I__AO__V(4, this.sci_Vector5__f_suffix4);
  b.consider__I__AO__V(3, this.sci_Vector5__f_suffix3);
  b.consider__I__AO__V(2, this.sci_Vector5__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector();
});
$c_sci_Vector5.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector5__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = $n(a).u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector5__f_len1) | 0);
    var x$3 = (((-1) + this.sci_Vector5__f_len12) | 0);
    var x$4 = (((-1) + this.sci_Vector5__f_len123) | 0);
    var x$5 = (((-1) + this.sci_Vector5__f_len1234) | 0);
    var x$6 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$7 = this.sci_Vector5__f_prefix2;
    var x$8 = this.sci_Vector5__f_prefix3;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_data5;
    var x$11 = this.sci_Vector5__f_suffix4;
    var x$12 = this.sci_Vector5__f_suffix3;
    var x$13 = this.sci_Vector5__f_suffix2;
    var x$14 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(x$1, x$2, x$7, x$3, x$8, x$4, x$9, x$5, x$10, x$11, x$12, x$13, x$14, x$6);
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0);
  }
});
$c_sci_Vector5.prototype.init__sci_Vector = (function() {
  if (($n(this.sci_BigVector__f_suffix1).u.length > 1)) {
    var a = this.sci_BigVector__f_suffix1;
    var to = (((-1) + $n(a).u.length) | 0);
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, to);
    var x$2 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector5__f_len1;
    var x$5 = this.sci_Vector5__f_prefix2;
    var x$6 = this.sci_Vector5__f_len12;
    var x$7 = this.sci_Vector5__f_prefix3;
    var x$8 = this.sci_Vector5__f_len123;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_len1234;
    var x$11 = this.sci_Vector5__f_data5;
    var x$12 = this.sci_Vector5__f_suffix4;
    var x$13 = this.sci_Vector5__f_suffix3;
    var x$14 = this.sci_Vector5__f_suffix2;
    return new $c_sci_Vector5(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$1, x$2);
  } else {
    return this.slice0__I__I__sci_Vector(0, (((-1) + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector5.prototype.vectorSliceCount__I = (function() {
  return 9;
});
$c_sci_Vector5.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break;
    }
    case 1: {
      return this.sci_Vector5__f_prefix2;
      break;
    }
    case 2: {
      return this.sci_Vector5__f_prefix3;
      break;
    }
    case 3: {
      return this.sci_Vector5__f_prefix4;
      break;
    }
    case 4: {
      return this.sci_Vector5__f_data5;
      break;
    }
    case 5: {
      return this.sci_Vector5__f_suffix4;
      break;
    }
    case 6: {
      return this.sci_Vector5__f_suffix3;
      break;
    }
    case 7: {
      return this.sci_Vector5__f_suffix2;
      break;
    }
    case 8: {
      return this.sci_BigVector__f_suffix1;
      break;
    }
    default: {
      throw new $c_s_MatchError(idx);
    }
  }
});
$c_sci_Vector5.prototype.prependedAll0__sc_IterableOnce__I__sci_Vector = (function(prefix, k) {
  var x1 = $m_sci_VectorStatics$().prepend1IfSpace__AO__sc_IterableOnce__AO(this.sci_Vector__f_prefix1, prefix);
  if ((x1 === null)) {
    return $c_sci_Vector.prototype.prependedAll0__sc_IterableOnce__I__sci_Vector.call(this, prefix, k);
  } else {
    var diff = (($n(x1).u.length - $n(this.sci_Vector__f_prefix1).u.length) | 0);
    var x$2 = ((this.sci_Vector5__f_len1 + diff) | 0);
    var x$3 = ((this.sci_Vector5__f_len12 + diff) | 0);
    var x$4 = ((this.sci_Vector5__f_len123 + diff) | 0);
    var x$5 = ((this.sci_Vector5__f_len1234 + diff) | 0);
    var x$6 = ((this.sci_BigVector__f_length0 + diff) | 0);
    var x$7 = this.sci_Vector5__f_prefix2;
    var x$8 = this.sci_Vector5__f_prefix3;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_data5;
    var x$11 = this.sci_Vector5__f_suffix4;
    var x$12 = this.sci_Vector5__f_suffix3;
    var x$13 = this.sci_Vector5__f_suffix2;
    var x$14 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(x1, x$2, x$7, x$3, x$8, x$4, x$9, x$5, x$10, x$11, x$12, x$13, x$14, x$6);
  }
});
$c_sci_Vector5.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - $n(this.sci_BigVector__f_suffix1).u.length) | 0) + $n(suffix1b).u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector5__f_len1;
    var x$5 = this.sci_Vector5__f_prefix2;
    var x$6 = this.sci_Vector5__f_len12;
    var x$7 = this.sci_Vector5__f_prefix3;
    var x$8 = this.sci_Vector5__f_len123;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_len1234;
    var x$11 = this.sci_Vector5__f_data5;
    var x$12 = this.sci_Vector5__f_suffix4;
    var x$13 = this.sci_Vector5__f_suffix3;
    var x$14 = this.sci_Vector5__f_suffix2;
    return new $c_sci_Vector5(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, suffix1b, x$2);
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k);
  }
});
$c_sci_Vector5.prototype.init__O = (function() {
  return this.init__sci_Vector();
});
$c_sci_Vector5.prototype.tail__O = (function() {
  return this.tail__sci_Vector();
});
$c_sci_Vector5.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f);
});
$c_sci_Vector5.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Vector(elem);
});
$c_sci_Vector5.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem);
});
$c_sci_Vector5.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector5__f_len1234) | 0);
    if ((io >= 0)) {
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i5 < $n(this.sci_Vector5__f_data5).u.length) ? $n($n($n($n($n(this.sci_Vector5__f_data5).get(i5)).get(i4)).get(i3)).get(i2)).get(i1) : ((i4 < $n(this.sci_Vector5__f_suffix4).u.length) ? $n($n($n($n(this.sci_Vector5__f_suffix4).get(i4)).get(i3)).get(i2)).get(i1) : ((i3 < $n(this.sci_Vector5__f_suffix3).u.length) ? $n($n($n(this.sci_Vector5__f_suffix3).get(i3)).get(i2)).get(i1) : ((i2 < $n(this.sci_Vector5__f_suffix2).u.length) ? $n($n(this.sci_Vector5__f_suffix2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get(i1)))));
    } else if ((index >= this.sci_Vector5__f_len123)) {
      var io$2 = ((index - this.sci_Vector5__f_len123) | 0);
      return $n($n($n($n(this.sci_Vector5__f_prefix4).get(((io$2 >>> 15) | 0))).get((31 & ((io$2 >>> 10) | 0)))).get((31 & ((io$2 >>> 5) | 0)))).get((31 & io$2));
    } else if ((index >= this.sci_Vector5__f_len12)) {
      var io$3 = ((index - this.sci_Vector5__f_len12) | 0);
      return $n($n($n(this.sci_Vector5__f_prefix3).get(((io$3 >>> 10) | 0))).get((31 & ((io$3 >>> 5) | 0)))).get((31 & io$3));
    } else if ((index >= this.sci_Vector5__f_len1)) {
      var io$4 = ((index - this.sci_Vector5__f_len1) | 0);
      return $n($n(this.sci_Vector5__f_prefix2).get(((io$4 >>> 5) | 0))).get((31 & io$4));
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
function $as_sci_Vector5(obj) {
  return (((obj instanceof $c_sci_Vector5) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector5"));
}
function $isArrayOf_sci_Vector5(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector5)));
}
function $asArrayOf_sci_Vector5(obj, depth) {
  return (($isArrayOf_sci_Vector5(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector5;", depth));
}
var $d_sci_Vector5 = new $TypeData().initClass($c_sci_Vector5, "scala.collection.immutable.Vector5", ({
  sci_Vector5: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Vector6(_prefix1, len1, prefix2, len12, prefix3, len123, prefix4, len1234, prefix5, len12345, data6, suffix5, suffix4, suffix3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector6__f_len1 = 0;
  this.sci_Vector6__f_prefix2 = null;
  this.sci_Vector6__f_len12 = 0;
  this.sci_Vector6__f_prefix3 = null;
  this.sci_Vector6__f_len123 = 0;
  this.sci_Vector6__f_prefix4 = null;
  this.sci_Vector6__f_len1234 = 0;
  this.sci_Vector6__f_prefix5 = null;
  this.sci_Vector6__f_len12345 = 0;
  this.sci_Vector6__f_data6 = null;
  this.sci_Vector6__f_suffix5 = null;
  this.sci_Vector6__f_suffix4 = null;
  this.sci_Vector6__f_suffix3 = null;
  this.sci_Vector6__f_suffix2 = null;
  this.sci_Vector6__f_len1 = len1;
  this.sci_Vector6__f_prefix2 = prefix2;
  this.sci_Vector6__f_len12 = len12;
  this.sci_Vector6__f_prefix3 = prefix3;
  this.sci_Vector6__f_len123 = len123;
  this.sci_Vector6__f_prefix4 = prefix4;
  this.sci_Vector6__f_len1234 = len1234;
  this.sci_Vector6__f_prefix5 = prefix5;
  this.sci_Vector6__f_len12345 = len12345;
  this.sci_Vector6__f_data6 = data6;
  this.sci_Vector6__f_suffix5 = suffix5;
  this.sci_Vector6__f_suffix4 = suffix4;
  this.sci_Vector6__f_suffix3 = suffix3;
  this.sci_Vector6__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0);
}
$c_sci_Vector6.prototype = new $h_sci_BigVector();
$c_sci_Vector6.prototype.constructor = $c_sci_Vector6;
/** @constructor */
function $h_sci_Vector6() {
}
$h_sci_Vector6.prototype = $c_sci_Vector6.prototype;
$c_sci_Vector6.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector6__f_len12345) | 0);
    if ((io >= 0)) {
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i6 < $n(this.sci_Vector6__f_data6).u.length) ? $n($n($n($n($n($n(this.sci_Vector6__f_data6).get(i6)).get(i5)).get(i4)).get(i3)).get(i2)).get(i1) : ((i5 < $n(this.sci_Vector6__f_suffix5).u.length) ? $n($n($n($n($n(this.sci_Vector6__f_suffix5).get(i5)).get(i4)).get(i3)).get(i2)).get(i1) : ((i4 < $n(this.sci_Vector6__f_suffix4).u.length) ? $n($n($n($n(this.sci_Vector6__f_suffix4).get(i4)).get(i3)).get(i2)).get(i1) : ((i3 < $n(this.sci_Vector6__f_suffix3).u.length) ? $n($n($n(this.sci_Vector6__f_suffix3).get(i3)).get(i2)).get(i1) : ((i2 < $n(this.sci_Vector6__f_suffix2).u.length) ? $n($n(this.sci_Vector6__f_suffix2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get(i1))))));
    } else if ((index >= this.sci_Vector6__f_len1234)) {
      var io$2 = ((index - this.sci_Vector6__f_len1234) | 0);
      return $n($n($n($n($n(this.sci_Vector6__f_prefix5).get(((io$2 >>> 20) | 0))).get((31 & ((io$2 >>> 15) | 0)))).get((31 & ((io$2 >>> 10) | 0)))).get((31 & ((io$2 >>> 5) | 0)))).get((31 & io$2));
    } else if ((index >= this.sci_Vector6__f_len123)) {
      var io$3 = ((index - this.sci_Vector6__f_len123) | 0);
      return $n($n($n($n(this.sci_Vector6__f_prefix4).get(((io$3 >>> 15) | 0))).get((31 & ((io$3 >>> 10) | 0)))).get((31 & ((io$3 >>> 5) | 0)))).get((31 & io$3));
    } else if ((index >= this.sci_Vector6__f_len12)) {
      var io$4 = ((index - this.sci_Vector6__f_len12) | 0);
      return $n($n($n(this.sci_Vector6__f_prefix3).get(((io$4 >>> 10) | 0))).get((31 & ((io$4 >>> 5) | 0)))).get((31 & io$4));
    } else if ((index >= this.sci_Vector6__f_len1)) {
      var io$5 = ((index - this.sci_Vector6__f_len1) | 0);
      return $n($n(this.sci_Vector6__f_prefix2).get(((io$5 >>> 5) | 0))).get((31 & io$5));
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
$c_sci_Vector6.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector6__f_len12345)) {
      var io = ((index - this.sci_Vector6__f_len12345) | 0);
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i6 < $n(this.sci_Vector6__f_data6).u.length)) {
        var a6 = this.sci_Vector6__f_data6;
        var this$2 = $n(a6);
        var a6c = $n(this$2).clone__O();
        var $x_5 = $n(a6c);
        var a5 = $n(a6c).get(i6);
        var this$3 = $n(a5);
        var a5c = $n(this$3).clone__O();
        var $x_4 = $n(a5c);
        var a4 = $n(a5c).get(i5);
        var this$4 = $n(a4);
        var a4c = $n(this$4).clone__O();
        var $x_3 = $n(a4c);
        var a3 = $n(a4c).get(i4);
        var this$5 = $n(a3);
        var a3c = $n(this$5).clone__O();
        var $x_2 = $n(a3c);
        var a2 = $n(a3c).get(i3);
        var this$6 = $n(a2);
        var a2c = $n(this$6).clone__O();
        var $x_1 = $n(a2c);
        var a1 = $n(a2c).get(i2);
        var this$7 = $n(a1);
        var a1c = $n(this$7).clone__O();
        $n(a1c).set(i1, elem);
        $x_1.set(i2, a1c);
        $x_2.set(i3, a2c);
        $x_3.set(i4, a3c);
        $x_4.set(i5, a4c);
        $x_5.set(i6, a5c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector6__f_len1;
        var x$4 = this.sci_Vector6__f_prefix2;
        var x$5 = this.sci_Vector6__f_len12;
        var x$6 = this.sci_Vector6__f_prefix3;
        var x$7 = this.sci_Vector6__f_len123;
        var x$8 = this.sci_Vector6__f_prefix4;
        var x$9 = this.sci_Vector6__f_len1234;
        var x$10 = this.sci_Vector6__f_prefix5;
        var x$11 = this.sci_Vector6__f_len12345;
        var x$12 = this.sci_Vector6__f_suffix5;
        var x$13 = this.sci_Vector6__f_suffix4;
        var x$14 = this.sci_Vector6__f_suffix3;
        var x$15 = this.sci_Vector6__f_suffix2;
        var x$16 = this.sci_BigVector__f_suffix1;
        var x$17 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$2, x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, a6c, x$12, x$13, x$14, x$15, x$16, x$17);
      } else if ((i5 < $n(this.sci_Vector6__f_suffix5).u.length)) {
        var a5$1 = this.sci_Vector6__f_suffix5;
        var this$9 = $n(a5$1);
        var a5c$1 = $n(this$9).clone__O();
        var $x_9 = $n(a5c$1);
        var a4$1 = $n(a5c$1).get(i5);
        var this$10 = $n(a4$1);
        var a4c$1 = $n(this$10).clone__O();
        var $x_8 = $n(a4c$1);
        var a3$1 = $n(a4c$1).get(i4);
        var this$11 = $n(a3$1);
        var a3c$1 = $n(this$11).clone__O();
        var $x_7 = $n(a3c$1);
        var a2$1 = $n(a3c$1).get(i3);
        var this$12 = $n(a2$1);
        var a2c$1 = $n(this$12).clone__O();
        var $x_6 = $n(a2c$1);
        var a1$1 = $n(a2c$1).get(i2);
        var this$13 = $n(a1$1);
        var a1c$1 = $n(this$13).clone__O();
        $n(a1c$1).set(i1, elem);
        $x_6.set(i2, a1c$1);
        $x_7.set(i3, a2c$1);
        $x_8.set(i4, a3c$1);
        $x_9.set(i5, a4c$1);
        var x$19 = this.sci_Vector__f_prefix1;
        var x$20 = this.sci_Vector6__f_len1;
        var x$21 = this.sci_Vector6__f_prefix2;
        var x$22 = this.sci_Vector6__f_len12;
        var x$23 = this.sci_Vector6__f_prefix3;
        var x$24 = this.sci_Vector6__f_len123;
        var x$25 = this.sci_Vector6__f_prefix4;
        var x$26 = this.sci_Vector6__f_len1234;
        var x$27 = this.sci_Vector6__f_prefix5;
        var x$28 = this.sci_Vector6__f_len12345;
        var x$29 = this.sci_Vector6__f_data6;
        var x$30 = this.sci_Vector6__f_suffix4;
        var x$31 = this.sci_Vector6__f_suffix3;
        var x$32 = this.sci_Vector6__f_suffix2;
        var x$33 = this.sci_BigVector__f_suffix1;
        var x$34 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$19, x$20, x$21, x$22, x$23, x$24, x$25, x$26, x$27, x$28, x$29, a5c$1, x$30, x$31, x$32, x$33, x$34);
      } else if ((i4 < $n(this.sci_Vector6__f_suffix4).u.length)) {
        var a4$2 = this.sci_Vector6__f_suffix4;
        var this$15 = $n(a4$2);
        var a4c$2 = $n(this$15).clone__O();
        var $x_12 = $n(a4c$2);
        var a3$2 = $n(a4c$2).get(i4);
        var this$16 = $n(a3$2);
        var a3c$2 = $n(this$16).clone__O();
        var $x_11 = $n(a3c$2);
        var a2$2 = $n(a3c$2).get(i3);
        var this$17 = $n(a2$2);
        var a2c$2 = $n(this$17).clone__O();
        var $x_10 = $n(a2c$2);
        var a1$2 = $n(a2c$2).get(i2);
        var this$18 = $n(a1$2);
        var a1c$2 = $n(this$18).clone__O();
        $n(a1c$2).set(i1, elem);
        $x_10.set(i2, a1c$2);
        $x_11.set(i3, a2c$2);
        $x_12.set(i4, a3c$2);
        var x$36 = this.sci_Vector__f_prefix1;
        var x$37 = this.sci_Vector6__f_len1;
        var x$38 = this.sci_Vector6__f_prefix2;
        var x$39 = this.sci_Vector6__f_len12;
        var x$40 = this.sci_Vector6__f_prefix3;
        var x$41 = this.sci_Vector6__f_len123;
        var x$42 = this.sci_Vector6__f_prefix4;
        var x$43 = this.sci_Vector6__f_len1234;
        var x$44 = this.sci_Vector6__f_prefix5;
        var x$45 = this.sci_Vector6__f_len12345;
        var x$46 = this.sci_Vector6__f_data6;
        var x$47 = this.sci_Vector6__f_suffix5;
        var x$48 = this.sci_Vector6__f_suffix3;
        var x$49 = this.sci_Vector6__f_suffix2;
        var x$50 = this.sci_BigVector__f_suffix1;
        var x$51 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$36, x$37, x$38, x$39, x$40, x$41, x$42, x$43, x$44, x$45, x$46, x$47, a4c$2, x$48, x$49, x$50, x$51);
      } else if ((i3 < $n(this.sci_Vector6__f_suffix3).u.length)) {
        var a3$3 = this.sci_Vector6__f_suffix3;
        var this$20 = $n(a3$3);
        var a3c$3 = $n(this$20).clone__O();
        var $x_14 = $n(a3c$3);
        var a2$3 = $n(a3c$3).get(i3);
        var this$21 = $n(a2$3);
        var a2c$3 = $n(this$21).clone__O();
        var $x_13 = $n(a2c$3);
        var a1$3 = $n(a2c$3).get(i2);
        var this$22 = $n(a1$3);
        var a1c$3 = $n(this$22).clone__O();
        $n(a1c$3).set(i1, elem);
        $x_13.set(i2, a1c$3);
        $x_14.set(i3, a2c$3);
        var x$53 = this.sci_Vector__f_prefix1;
        var x$54 = this.sci_Vector6__f_len1;
        var x$55 = this.sci_Vector6__f_prefix2;
        var x$56 = this.sci_Vector6__f_len12;
        var x$57 = this.sci_Vector6__f_prefix3;
        var x$58 = this.sci_Vector6__f_len123;
        var x$59 = this.sci_Vector6__f_prefix4;
        var x$60 = this.sci_Vector6__f_len1234;
        var x$61 = this.sci_Vector6__f_prefix5;
        var x$62 = this.sci_Vector6__f_len12345;
        var x$63 = this.sci_Vector6__f_data6;
        var x$64 = this.sci_Vector6__f_suffix5;
        var x$65 = this.sci_Vector6__f_suffix4;
        var x$66 = this.sci_Vector6__f_suffix2;
        var x$67 = this.sci_BigVector__f_suffix1;
        var x$68 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$53, x$54, x$55, x$56, x$57, x$58, x$59, x$60, x$61, x$62, x$63, x$64, x$65, a3c$3, x$66, x$67, x$68);
      } else if ((i2 < $n(this.sci_Vector6__f_suffix2).u.length)) {
        var a2$4 = this.sci_Vector6__f_suffix2;
        var this$24 = $n(a2$4);
        var a2c$4 = $n(this$24).clone__O();
        var $x_15 = $n(a2c$4);
        var a1$4 = $n(a2c$4).get(i2);
        var this$25 = $n(a1$4);
        var a1c$4 = $n(this$25).clone__O();
        $n(a1c$4).set(i1, elem);
        $x_15.set(i2, a1c$4);
        var x$70 = this.sci_Vector__f_prefix1;
        var x$71 = this.sci_Vector6__f_len1;
        var x$72 = this.sci_Vector6__f_prefix2;
        var x$73 = this.sci_Vector6__f_len12;
        var x$74 = this.sci_Vector6__f_prefix3;
        var x$75 = this.sci_Vector6__f_len123;
        var x$76 = this.sci_Vector6__f_prefix4;
        var x$77 = this.sci_Vector6__f_len1234;
        var x$78 = this.sci_Vector6__f_prefix5;
        var x$79 = this.sci_Vector6__f_len12345;
        var x$80 = this.sci_Vector6__f_data6;
        var x$81 = this.sci_Vector6__f_suffix5;
        var x$82 = this.sci_Vector6__f_suffix4;
        var x$83 = this.sci_Vector6__f_suffix3;
        var x$84 = this.sci_BigVector__f_suffix1;
        var x$85 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$70, x$71, x$72, x$73, x$74, x$75, x$76, x$77, x$78, x$79, x$80, x$81, x$82, x$83, a2c$4, x$84, x$85);
      } else {
        var a1$5 = this.sci_BigVector__f_suffix1;
        var this$27 = $n(a1$5);
        var a1c$5 = $n(this$27).clone__O();
        $n(a1c$5).set(i1, elem);
        var x$87 = this.sci_Vector__f_prefix1;
        var x$88 = this.sci_Vector6__f_len1;
        var x$89 = this.sci_Vector6__f_prefix2;
        var x$90 = this.sci_Vector6__f_len12;
        var x$91 = this.sci_Vector6__f_prefix3;
        var x$92 = this.sci_Vector6__f_len123;
        var x$93 = this.sci_Vector6__f_prefix4;
        var x$94 = this.sci_Vector6__f_len1234;
        var x$95 = this.sci_Vector6__f_prefix5;
        var x$96 = this.sci_Vector6__f_len12345;
        var x$97 = this.sci_Vector6__f_data6;
        var x$98 = this.sci_Vector6__f_suffix5;
        var x$99 = this.sci_Vector6__f_suffix4;
        var x$100 = this.sci_Vector6__f_suffix3;
        var x$101 = this.sci_Vector6__f_suffix2;
        var x$102 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$87, x$88, x$89, x$90, x$91, x$92, x$93, x$94, x$95, x$96, x$97, x$98, x$99, x$100, x$101, a1c$5, x$102);
      }
    } else if ((index >= this.sci_Vector6__f_len1234)) {
      var io$2 = ((index - this.sci_Vector6__f_len1234) | 0);
      var a5$2 = this.sci_Vector6__f_prefix5;
      var idx5 = ((io$2 >>> 20) | 0);
      var idx4 = (31 & ((io$2 >>> 15) | 0));
      var idx3 = (31 & ((io$2 >>> 10) | 0));
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var this$29 = $n(a5$2);
      var a5c$2 = $n(this$29).clone__O();
      var $x_19 = $n(a5c$2);
      var a4$3 = $n(a5c$2).get(idx5);
      var this$30 = $n(a4$3);
      var a4c$3 = $n(this$30).clone__O();
      var $x_18 = $n(a4c$3);
      var a3$4 = $n(a4c$3).get(idx4);
      var this$31 = $n(a3$4);
      var a3c$4 = $n(this$31).clone__O();
      var $x_17 = $n(a3c$4);
      var a2$5 = $n(a3c$4).get(idx3);
      var this$32 = $n(a2$5);
      var a2c$5 = $n(this$32).clone__O();
      var $x_16 = $n(a2c$5);
      var a1$6 = $n(a2c$5).get(idx2);
      var this$33 = $n(a1$6);
      var a1c$6 = $n(this$33).clone__O();
      $n(a1c$6).set(idx1, elem);
      $x_16.set(idx2, a1c$6);
      $x_17.set(idx3, a2c$5);
      $x_18.set(idx4, a3c$4);
      $x_19.set(idx5, a4c$3);
      var x$104 = this.sci_Vector__f_prefix1;
      var x$105 = this.sci_Vector6__f_len1;
      var x$106 = this.sci_Vector6__f_prefix2;
      var x$107 = this.sci_Vector6__f_len12;
      var x$108 = this.sci_Vector6__f_prefix3;
      var x$109 = this.sci_Vector6__f_len123;
      var x$110 = this.sci_Vector6__f_prefix4;
      var x$111 = this.sci_Vector6__f_len1234;
      var x$112 = this.sci_Vector6__f_len12345;
      var x$113 = this.sci_Vector6__f_data6;
      var x$114 = this.sci_Vector6__f_suffix5;
      var x$115 = this.sci_Vector6__f_suffix4;
      var x$116 = this.sci_Vector6__f_suffix3;
      var x$117 = this.sci_Vector6__f_suffix2;
      var x$118 = this.sci_BigVector__f_suffix1;
      var x$119 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$104, x$105, x$106, x$107, x$108, x$109, x$110, x$111, a5c$2, x$112, x$113, x$114, x$115, x$116, x$117, x$118, x$119);
    } else if ((index >= this.sci_Vector6__f_len123)) {
      var io$3 = ((index - this.sci_Vector6__f_len123) | 0);
      var a4$4 = this.sci_Vector6__f_prefix4;
      var idx4$1 = ((io$3 >>> 15) | 0);
      var idx3$1 = (31 & ((io$3 >>> 10) | 0));
      var idx2$1 = (31 & ((io$3 >>> 5) | 0));
      var idx1$1 = (31 & io$3);
      var this$35 = $n(a4$4);
      var a4c$4 = $n(this$35).clone__O();
      var $x_22 = $n(a4c$4);
      var a3$5 = $n(a4c$4).get(idx4$1);
      var this$36 = $n(a3$5);
      var a3c$5 = $n(this$36).clone__O();
      var $x_21 = $n(a3c$5);
      var a2$6 = $n(a3c$5).get(idx3$1);
      var this$37 = $n(a2$6);
      var a2c$6 = $n(this$37).clone__O();
      var $x_20 = $n(a2c$6);
      var a1$7 = $n(a2c$6).get(idx2$1);
      var this$38 = $n(a1$7);
      var a1c$7 = $n(this$38).clone__O();
      $n(a1c$7).set(idx1$1, elem);
      $x_20.set(idx2$1, a1c$7);
      $x_21.set(idx3$1, a2c$6);
      $x_22.set(idx4$1, a3c$5);
      var x$121 = this.sci_Vector__f_prefix1;
      var x$122 = this.sci_Vector6__f_len1;
      var x$123 = this.sci_Vector6__f_prefix2;
      var x$124 = this.sci_Vector6__f_len12;
      var x$125 = this.sci_Vector6__f_prefix3;
      var x$126 = this.sci_Vector6__f_len123;
      var x$127 = this.sci_Vector6__f_len1234;
      var x$128 = this.sci_Vector6__f_prefix5;
      var x$129 = this.sci_Vector6__f_len12345;
      var x$130 = this.sci_Vector6__f_data6;
      var x$131 = this.sci_Vector6__f_suffix5;
      var x$132 = this.sci_Vector6__f_suffix4;
      var x$133 = this.sci_Vector6__f_suffix3;
      var x$134 = this.sci_Vector6__f_suffix2;
      var x$135 = this.sci_BigVector__f_suffix1;
      var x$136 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$121, x$122, x$123, x$124, x$125, x$126, a4c$4, x$127, x$128, x$129, x$130, x$131, x$132, x$133, x$134, x$135, x$136);
    } else if ((index >= this.sci_Vector6__f_len12)) {
      var io$4 = ((index - this.sci_Vector6__f_len12) | 0);
      var a3$6 = this.sci_Vector6__f_prefix3;
      var idx3$2 = ((io$4 >>> 10) | 0);
      var idx2$2 = (31 & ((io$4 >>> 5) | 0));
      var idx1$2 = (31 & io$4);
      var this$40 = $n(a3$6);
      var a3c$6 = $n(this$40).clone__O();
      var $x_24 = $n(a3c$6);
      var a2$7 = $n(a3c$6).get(idx3$2);
      var this$41 = $n(a2$7);
      var a2c$7 = $n(this$41).clone__O();
      var $x_23 = $n(a2c$7);
      var a1$8 = $n(a2c$7).get(idx2$2);
      var this$42 = $n(a1$8);
      var a1c$8 = $n(this$42).clone__O();
      $n(a1c$8).set(idx1$2, elem);
      $x_23.set(idx2$2, a1c$8);
      $x_24.set(idx3$2, a2c$7);
      var x$138 = this.sci_Vector__f_prefix1;
      var x$139 = this.sci_Vector6__f_len1;
      var x$140 = this.sci_Vector6__f_prefix2;
      var x$141 = this.sci_Vector6__f_len12;
      var x$142 = this.sci_Vector6__f_len123;
      var x$143 = this.sci_Vector6__f_prefix4;
      var x$144 = this.sci_Vector6__f_len1234;
      var x$145 = this.sci_Vector6__f_prefix5;
      var x$146 = this.sci_Vector6__f_len12345;
      var x$147 = this.sci_Vector6__f_data6;
      var x$148 = this.sci_Vector6__f_suffix5;
      var x$149 = this.sci_Vector6__f_suffix4;
      var x$150 = this.sci_Vector6__f_suffix3;
      var x$151 = this.sci_Vector6__f_suffix2;
      var x$152 = this.sci_BigVector__f_suffix1;
      var x$153 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$138, x$139, x$140, x$141, a3c$6, x$142, x$143, x$144, x$145, x$146, x$147, x$148, x$149, x$150, x$151, x$152, x$153);
    } else if ((index >= this.sci_Vector6__f_len1)) {
      var io$5 = ((index - this.sci_Vector6__f_len1) | 0);
      var a2$8 = this.sci_Vector6__f_prefix2;
      var idx2$3 = ((io$5 >>> 5) | 0);
      var idx1$3 = (31 & io$5);
      var this$44 = $n(a2$8);
      var a2c$8 = $n(this$44).clone__O();
      var $x_25 = $n(a2c$8);
      var a1$9 = $n(a2c$8).get(idx2$3);
      var this$45 = $n(a1$9);
      var a1c$9 = $n(this$45).clone__O();
      $n(a1c$9).set(idx1$3, elem);
      $x_25.set(idx2$3, a1c$9);
      var x$155 = this.sci_Vector__f_prefix1;
      var x$156 = this.sci_Vector6__f_len1;
      var x$157 = this.sci_Vector6__f_len12;
      var x$158 = this.sci_Vector6__f_prefix3;
      var x$159 = this.sci_Vector6__f_len123;
      var x$160 = this.sci_Vector6__f_prefix4;
      var x$161 = this.sci_Vector6__f_len1234;
      var x$162 = this.sci_Vector6__f_prefix5;
      var x$163 = this.sci_Vector6__f_len12345;
      var x$164 = this.sci_Vector6__f_data6;
      var x$165 = this.sci_Vector6__f_suffix5;
      var x$166 = this.sci_Vector6__f_suffix4;
      var x$167 = this.sci_Vector6__f_suffix3;
      var x$168 = this.sci_Vector6__f_suffix2;
      var x$169 = this.sci_BigVector__f_suffix1;
      var x$170 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$155, x$156, a2c$8, x$157, x$158, x$159, x$160, x$161, x$162, x$163, x$164, x$165, x$166, x$167, x$168, x$169, x$170);
    } else {
      var a1$10 = this.sci_Vector__f_prefix1;
      var this$47 = $n(a1$10);
      var a1c$10 = $n(this$47).clone__O();
      $n(a1c$10).set(index, elem);
      var len1 = this.sci_Vector6__f_len1;
      var prefix2 = this.sci_Vector6__f_prefix2;
      var len12 = this.sci_Vector6__f_len12;
      var prefix3 = this.sci_Vector6__f_prefix3;
      var len123 = this.sci_Vector6__f_len123;
      var prefix4 = this.sci_Vector6__f_prefix4;
      var len1234 = this.sci_Vector6__f_len1234;
      var prefix5 = this.sci_Vector6__f_prefix5;
      var len12345 = this.sci_Vector6__f_len12345;
      var data6 = this.sci_Vector6__f_data6;
      var suffix5 = this.sci_Vector6__f_suffix5;
      var suffix4 = this.sci_Vector6__f_suffix4;
      var suffix3 = this.sci_Vector6__f_suffix3;
      var suffix2 = this.sci_Vector6__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(a1c$10, len1, prefix2, len12, prefix3, len123, prefix4, len1234, prefix5, len12345, data6, suffix5, suffix4, suffix3, suffix2, suffix1, length0);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
$c_sci_Vector6.prototype.appended__O__sci_Vector = (function(elem) {
  if (($n(this.sci_BigVector__f_suffix1).u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector6__f_len1;
    var x$5 = this.sci_Vector6__f_prefix2;
    var x$6 = this.sci_Vector6__f_len12;
    var x$7 = this.sci_Vector6__f_prefix3;
    var x$8 = this.sci_Vector6__f_len123;
    var x$9 = this.sci_Vector6__f_prefix4;
    var x$10 = this.sci_Vector6__f_len1234;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_len12345;
    var x$13 = this.sci_Vector6__f_data6;
    var x$14 = this.sci_Vector6__f_suffix5;
    var x$15 = this.sci_Vector6__f_suffix4;
    var x$16 = this.sci_Vector6__f_suffix3;
    var x$17 = this.sci_Vector6__f_suffix2;
    return new $c_sci_Vector6(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16, x$17, x$1, x$2);
  } else if (($n(this.sci_Vector6__f_suffix2).u.length < 31)) {
    var x$18 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    $n(a).set(0, elem);
    var x$20 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$21 = this.sci_Vector__f_prefix1;
    var x$22 = this.sci_Vector6__f_len1;
    var x$23 = this.sci_Vector6__f_prefix2;
    var x$24 = this.sci_Vector6__f_len12;
    var x$25 = this.sci_Vector6__f_prefix3;
    var x$26 = this.sci_Vector6__f_len123;
    var x$27 = this.sci_Vector6__f_prefix4;
    var x$28 = this.sci_Vector6__f_len1234;
    var x$29 = this.sci_Vector6__f_prefix5;
    var x$30 = this.sci_Vector6__f_len12345;
    var x$31 = this.sci_Vector6__f_data6;
    var x$32 = this.sci_Vector6__f_suffix5;
    var x$33 = this.sci_Vector6__f_suffix4;
    var x$34 = this.sci_Vector6__f_suffix3;
    return new $c_sci_Vector6(x$21, x$22, x$23, x$24, x$25, x$26, x$27, x$28, x$29, x$30, x$31, x$32, x$33, x$34, x$18, a, x$20);
  } else if (($n(this.sci_Vector6__f_suffix3).u.length < 31)) {
    var x$35 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var x$36 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    $n(a$1).set(0, elem);
    var x$38 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$39 = this.sci_Vector__f_prefix1;
    var x$40 = this.sci_Vector6__f_len1;
    var x$41 = this.sci_Vector6__f_prefix2;
    var x$42 = this.sci_Vector6__f_len12;
    var x$43 = this.sci_Vector6__f_prefix3;
    var x$44 = this.sci_Vector6__f_len123;
    var x$45 = this.sci_Vector6__f_prefix4;
    var x$46 = this.sci_Vector6__f_len1234;
    var x$47 = this.sci_Vector6__f_prefix5;
    var x$48 = this.sci_Vector6__f_len12345;
    var x$49 = this.sci_Vector6__f_data6;
    var x$50 = this.sci_Vector6__f_suffix5;
    var x$51 = this.sci_Vector6__f_suffix4;
    return new $c_sci_Vector6(x$39, x$40, x$41, x$42, x$43, x$44, x$45, x$46, x$47, x$48, x$49, x$50, x$51, x$35, x$36, a$1, x$38);
  } else if (($n(this.sci_Vector6__f_suffix4).u.length < 31)) {
    var x$52 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1))), 4);
    var x$53 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$54 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$2 = new $ac_O(1);
    $n(a$2).set(0, elem);
    var x$56 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$57 = this.sci_Vector__f_prefix1;
    var x$58 = this.sci_Vector6__f_len1;
    var x$59 = this.sci_Vector6__f_prefix2;
    var x$60 = this.sci_Vector6__f_len12;
    var x$61 = this.sci_Vector6__f_prefix3;
    var x$62 = this.sci_Vector6__f_len123;
    var x$63 = this.sci_Vector6__f_prefix4;
    var x$64 = this.sci_Vector6__f_len1234;
    var x$65 = this.sci_Vector6__f_prefix5;
    var x$66 = this.sci_Vector6__f_len12345;
    var x$67 = this.sci_Vector6__f_data6;
    var x$68 = this.sci_Vector6__f_suffix5;
    return new $c_sci_Vector6(x$57, x$58, x$59, x$60, x$61, x$62, x$63, x$64, x$65, x$66, x$67, x$68, x$52, x$53, x$54, a$2, x$56);
  } else if (($n(this.sci_Vector6__f_suffix5).u.length < 31)) {
    var x$69 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix5, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1)))), 5);
    var x$70 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$71 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$72 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$3 = new $ac_O(1);
    $n(a$3).set(0, elem);
    var x$74 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$75 = this.sci_Vector__f_prefix1;
    var x$76 = this.sci_Vector6__f_len1;
    var x$77 = this.sci_Vector6__f_prefix2;
    var x$78 = this.sci_Vector6__f_len12;
    var x$79 = this.sci_Vector6__f_prefix3;
    var x$80 = this.sci_Vector6__f_len123;
    var x$81 = this.sci_Vector6__f_prefix4;
    var x$82 = this.sci_Vector6__f_len1234;
    var x$83 = this.sci_Vector6__f_prefix5;
    var x$84 = this.sci_Vector6__f_len12345;
    var x$85 = this.sci_Vector6__f_data6;
    return new $c_sci_Vector6(x$75, x$76, x$77, x$78, x$79, x$80, x$81, x$82, x$83, x$84, x$85, x$69, x$70, x$71, x$72, a$3, x$74);
  } else if (($n(this.sci_Vector6__f_data6).u.length < 62)) {
    var x$86 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_data6, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix5, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1))))), 6);
    var x$87 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
    var x$88 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$89 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$90 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$4 = new $ac_O(1);
    $n(a$4).set(0, elem);
    var x$92 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$93 = this.sci_Vector__f_prefix1;
    var x$94 = this.sci_Vector6__f_len1;
    var x$95 = this.sci_Vector6__f_prefix2;
    var x$96 = this.sci_Vector6__f_len12;
    var x$97 = this.sci_Vector6__f_prefix3;
    var x$98 = this.sci_Vector6__f_len123;
    var x$99 = this.sci_Vector6__f_prefix4;
    var x$100 = this.sci_Vector6__f_len1234;
    var x$101 = this.sci_Vector6__f_prefix5;
    var x$102 = this.sci_Vector6__f_len12345;
    return new $c_sci_Vector6(x$93, x$94, x$95, x$96, x$97, x$98, x$99, x$100, x$101, x$102, x$86, x$87, x$88, x$89, x$90, a$4, x$92);
  } else {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
});
$c_sci_Vector6.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector6__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector6__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector6__f_len12) | 0);
    var x$4 = ((1 + this.sci_Vector6__f_len123) | 0);
    var x$5 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$6 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$7 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$8 = this.sci_Vector6__f_prefix2;
    var x$9 = this.sci_Vector6__f_prefix3;
    var x$10 = this.sci_Vector6__f_prefix4;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_data6;
    var x$13 = this.sci_Vector6__f_suffix5;
    var x$14 = this.sci_Vector6__f_suffix4;
    var x$15 = this.sci_Vector6__f_suffix3;
    var x$16 = this.sci_Vector6__f_suffix2;
    var x$17 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(x$1, x$2, x$8, x$3, x$9, x$4, x$10, x$5, x$11, x$6, x$12, x$13, x$14, x$15, x$16, x$17, x$7);
  } else if ((this.sci_Vector6__f_len12 < 1024)) {
    var a = new $ac_O(1);
    $n(a).set(0, elem);
    var x$20 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), 2);
    var x$21 = ((1 + this.sci_Vector6__f_len12) | 0);
    var x$22 = ((1 + this.sci_Vector6__f_len123) | 0);
    var x$23 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$24 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$25 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$26 = this.sci_Vector6__f_prefix3;
    var x$27 = this.sci_Vector6__f_prefix4;
    var x$28 = this.sci_Vector6__f_prefix5;
    var x$29 = this.sci_Vector6__f_data6;
    var x$30 = this.sci_Vector6__f_suffix5;
    var x$31 = this.sci_Vector6__f_suffix4;
    var x$32 = this.sci_Vector6__f_suffix3;
    var x$33 = this.sci_Vector6__f_suffix2;
    var x$34 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a, 1, x$20, x$21, x$26, x$22, x$27, x$23, x$28, x$24, x$29, x$30, x$31, x$32, x$33, x$34, x$25);
  } else if ((this.sci_Vector6__f_len123 < 32768)) {
    var a$1 = new $ac_O(1);
    $n(a$1).set(0, elem);
    var x$37 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$39 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), 3);
    var x$40 = ((1 + this.sci_Vector6__f_len123) | 0);
    var x$41 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$42 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$43 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$44 = this.sci_Vector6__f_prefix4;
    var x$45 = this.sci_Vector6__f_prefix5;
    var x$46 = this.sci_Vector6__f_data6;
    var x$47 = this.sci_Vector6__f_suffix5;
    var x$48 = this.sci_Vector6__f_suffix4;
    var x$49 = this.sci_Vector6__f_suffix3;
    var x$50 = this.sci_Vector6__f_suffix2;
    var x$51 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$1, 1, x$37, 1, x$39, x$40, x$44, x$41, x$45, x$42, x$46, x$47, x$48, x$49, x$50, x$51, x$43);
  } else if ((this.sci_Vector6__f_len1234 < 1048576)) {
    var a$2 = new $ac_O(1);
    $n(a$2).set(0, elem);
    var x$54 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$56 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$58 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), this.sci_Vector6__f_prefix4), 4);
    var x$59 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$60 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$61 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$62 = this.sci_Vector6__f_prefix5;
    var x$63 = this.sci_Vector6__f_data6;
    var x$64 = this.sci_Vector6__f_suffix5;
    var x$65 = this.sci_Vector6__f_suffix4;
    var x$66 = this.sci_Vector6__f_suffix3;
    var x$67 = this.sci_Vector6__f_suffix2;
    var x$68 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$2, 1, x$54, 1, x$56, 1, x$58, x$59, x$62, x$60, x$63, x$64, x$65, x$66, x$67, x$68, x$61);
  } else if ((this.sci_Vector6__f_len12345 < 33554432)) {
    var a$3 = new $ac_O(1);
    $n(a$3).set(0, elem);
    var x$71 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$73 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$75 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$77 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), this.sci_Vector6__f_prefix4), this.sci_Vector6__f_prefix5), 5);
    var x$78 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$79 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$80 = this.sci_Vector6__f_data6;
    var x$81 = this.sci_Vector6__f_suffix5;
    var x$82 = this.sci_Vector6__f_suffix4;
    var x$83 = this.sci_Vector6__f_suffix3;
    var x$84 = this.sci_Vector6__f_suffix2;
    var x$85 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$3, 1, x$71, 1, x$73, 1, x$75, 1, x$77, x$78, x$80, x$81, x$82, x$83, x$84, x$85, x$79);
  } else if (($n(this.sci_Vector6__f_data6).u.length < 62)) {
    var a$4 = new $ac_O(1);
    $n(a$4).set(0, elem);
    var x$88 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$90 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$92 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$94 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
    var x$96 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), this.sci_Vector6__f_prefix4), this.sci_Vector6__f_prefix5), this.sci_Vector6__f_data6), 6);
    var x$97 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$98 = this.sci_Vector6__f_suffix5;
    var x$99 = this.sci_Vector6__f_suffix4;
    var x$100 = this.sci_Vector6__f_suffix3;
    var x$101 = this.sci_Vector6__f_suffix2;
    var x$102 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$4, 1, x$88, 1, x$90, 1, x$92, 1, x$94, 1, x$96, x$98, x$99, x$100, x$101, x$102, x$97);
  } else {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
});
$c_sci_Vector6.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector6__f_prefix2, f), 2);
  var x$3 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector6__f_prefix3, f), 3);
  var x$4 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector6__f_prefix4, f), 4);
  var x$5 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(5, this.sci_Vector6__f_prefix5, f), 5);
  var x$6 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(6, this.sci_Vector6__f_data6, f), 6);
  var x$7 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(5, this.sci_Vector6__f_suffix5, f), 5);
  var x$8 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector6__f_suffix4, f), 4);
  var x$9 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector6__f_suffix3, f), 3);
  var x$10 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector6__f_suffix2, f), 2);
  var x$11 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$12 = this.sci_Vector6__f_len1;
  var x$13 = this.sci_Vector6__f_len12;
  var x$14 = this.sci_Vector6__f_len123;
  var x$15 = this.sci_Vector6__f_len1234;
  var x$16 = this.sci_Vector6__f_len12345;
  var x$17 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector6(x$1, x$12, x$2, x$13, x$3, x$14, x$4, x$15, x$5, x$16, x$6, x$7, x$8, x$9, x$10, x$11, x$17);
});
$c_sci_Vector6.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector6__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector6__f_prefix3);
  b.consider__I__AO__V(4, this.sci_Vector6__f_prefix4);
  b.consider__I__AO__V(5, this.sci_Vector6__f_prefix5);
  b.consider__I__AO__V(6, this.sci_Vector6__f_data6);
  b.consider__I__AO__V(5, this.sci_Vector6__f_suffix5);
  b.consider__I__AO__V(4, this.sci_Vector6__f_suffix4);
  b.consider__I__AO__V(3, this.sci_Vector6__f_suffix3);
  b.consider__I__AO__V(2, this.sci_Vector6__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector();
});
$c_sci_Vector6.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector6__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = $n(a).u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector6__f_len1) | 0);
    var x$3 = (((-1) + this.sci_Vector6__f_len12) | 0);
    var x$4 = (((-1) + this.sci_Vector6__f_len123) | 0);
    var x$5 = (((-1) + this.sci_Vector6__f_len1234) | 0);
    var x$6 = (((-1) + this.sci_Vector6__f_len12345) | 0);
    var x$7 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$8 = this.sci_Vector6__f_prefix2;
    var x$9 = this.sci_Vector6__f_prefix3;
    var x$10 = this.sci_Vector6__f_prefix4;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_data6;
    var x$13 = this.sci_Vector6__f_suffix5;
    var x$14 = this.sci_Vector6__f_suffix4;
    var x$15 = this.sci_Vector6__f_suffix3;
    var x$16 = this.sci_Vector6__f_suffix2;
    var x$17 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(x$1, x$2, x$8, x$3, x$9, x$4, x$10, x$5, x$11, x$6, x$12, x$13, x$14, x$15, x$16, x$17, x$7);
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0);
  }
});
$c_sci_Vector6.prototype.init__sci_Vector = (function() {
  if (($n(this.sci_BigVector__f_suffix1).u.length > 1)) {
    var a = this.sci_BigVector__f_suffix1;
    var to = (((-1) + $n(a).u.length) | 0);
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, to);
    var x$2 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector6__f_len1;
    var x$5 = this.sci_Vector6__f_prefix2;
    var x$6 = this.sci_Vector6__f_len12;
    var x$7 = this.sci_Vector6__f_prefix3;
    var x$8 = this.sci_Vector6__f_len123;
    var x$9 = this.sci_Vector6__f_prefix4;
    var x$10 = this.sci_Vector6__f_len1234;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_len12345;
    var x$13 = this.sci_Vector6__f_data6;
    var x$14 = this.sci_Vector6__f_suffix5;
    var x$15 = this.sci_Vector6__f_suffix4;
    var x$16 = this.sci_Vector6__f_suffix3;
    var x$17 = this.sci_Vector6__f_suffix2;
    return new $c_sci_Vector6(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16, x$17, x$1, x$2);
  } else {
    return this.slice0__I__I__sci_Vector(0, (((-1) + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector6.prototype.vectorSliceCount__I = (function() {
  return 11;
});
$c_sci_Vector6.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break;
    }
    case 1: {
      return this.sci_Vector6__f_prefix2;
      break;
    }
    case 2: {
      return this.sci_Vector6__f_prefix3;
      break;
    }
    case 3: {
      return this.sci_Vector6__f_prefix4;
      break;
    }
    case 4: {
      return this.sci_Vector6__f_prefix5;
      break;
    }
    case 5: {
      return this.sci_Vector6__f_data6;
      break;
    }
    case 6: {
      return this.sci_Vector6__f_suffix5;
      break;
    }
    case 7: {
      return this.sci_Vector6__f_suffix4;
      break;
    }
    case 8: {
      return this.sci_Vector6__f_suffix3;
      break;
    }
    case 9: {
      return this.sci_Vector6__f_suffix2;
      break;
    }
    case 10: {
      return this.sci_BigVector__f_suffix1;
      break;
    }
    default: {
      throw new $c_s_MatchError(idx);
    }
  }
});
$c_sci_Vector6.prototype.prependedAll0__sc_IterableOnce__I__sci_Vector = (function(prefix, k) {
  var x1 = $m_sci_VectorStatics$().prepend1IfSpace__AO__sc_IterableOnce__AO(this.sci_Vector__f_prefix1, prefix);
  if ((x1 === null)) {
    return $c_sci_Vector.prototype.prependedAll0__sc_IterableOnce__I__sci_Vector.call(this, prefix, k);
  } else {
    var diff = (($n(x1).u.length - $n(this.sci_Vector__f_prefix1).u.length) | 0);
    var x$2 = ((this.sci_Vector6__f_len1 + diff) | 0);
    var x$3 = ((this.sci_Vector6__f_len12 + diff) | 0);
    var x$4 = ((this.sci_Vector6__f_len123 + diff) | 0);
    var x$5 = ((this.sci_Vector6__f_len1234 + diff) | 0);
    var x$6 = ((this.sci_Vector6__f_len12345 + diff) | 0);
    var x$7 = ((this.sci_BigVector__f_length0 + diff) | 0);
    var x$8 = this.sci_Vector6__f_prefix2;
    var x$9 = this.sci_Vector6__f_prefix3;
    var x$10 = this.sci_Vector6__f_prefix4;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_data6;
    var x$13 = this.sci_Vector6__f_suffix5;
    var x$14 = this.sci_Vector6__f_suffix4;
    var x$15 = this.sci_Vector6__f_suffix3;
    var x$16 = this.sci_Vector6__f_suffix2;
    var x$17 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(x1, x$2, x$8, x$3, x$9, x$4, x$10, x$5, x$11, x$6, x$12, x$13, x$14, x$15, x$16, x$17, x$7);
  }
});
$c_sci_Vector6.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - $n(this.sci_BigVector__f_suffix1).u.length) | 0) + $n(suffix1b).u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector6__f_len1;
    var x$5 = this.sci_Vector6__f_prefix2;
    var x$6 = this.sci_Vector6__f_len12;
    var x$7 = this.sci_Vector6__f_prefix3;
    var x$8 = this.sci_Vector6__f_len123;
    var x$9 = this.sci_Vector6__f_prefix4;
    var x$10 = this.sci_Vector6__f_len1234;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_len12345;
    var x$13 = this.sci_Vector6__f_data6;
    var x$14 = this.sci_Vector6__f_suffix5;
    var x$15 = this.sci_Vector6__f_suffix4;
    var x$16 = this.sci_Vector6__f_suffix3;
    var x$17 = this.sci_Vector6__f_suffix2;
    return new $c_sci_Vector6(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16, x$17, suffix1b, x$2);
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k);
  }
});
$c_sci_Vector6.prototype.init__O = (function() {
  return this.init__sci_Vector();
});
$c_sci_Vector6.prototype.tail__O = (function() {
  return this.tail__sci_Vector();
});
$c_sci_Vector6.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f);
});
$c_sci_Vector6.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Vector(elem);
});
$c_sci_Vector6.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem);
});
$c_sci_Vector6.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector6__f_len12345) | 0);
    if ((io >= 0)) {
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i6 < $n(this.sci_Vector6__f_data6).u.length) ? $n($n($n($n($n($n(this.sci_Vector6__f_data6).get(i6)).get(i5)).get(i4)).get(i3)).get(i2)).get(i1) : ((i5 < $n(this.sci_Vector6__f_suffix5).u.length) ? $n($n($n($n($n(this.sci_Vector6__f_suffix5).get(i5)).get(i4)).get(i3)).get(i2)).get(i1) : ((i4 < $n(this.sci_Vector6__f_suffix4).u.length) ? $n($n($n($n(this.sci_Vector6__f_suffix4).get(i4)).get(i3)).get(i2)).get(i1) : ((i3 < $n(this.sci_Vector6__f_suffix3).u.length) ? $n($n($n(this.sci_Vector6__f_suffix3).get(i3)).get(i2)).get(i1) : ((i2 < $n(this.sci_Vector6__f_suffix2).u.length) ? $n($n(this.sci_Vector6__f_suffix2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get(i1))))));
    } else if ((index >= this.sci_Vector6__f_len1234)) {
      var io$2 = ((index - this.sci_Vector6__f_len1234) | 0);
      return $n($n($n($n($n(this.sci_Vector6__f_prefix5).get(((io$2 >>> 20) | 0))).get((31 & ((io$2 >>> 15) | 0)))).get((31 & ((io$2 >>> 10) | 0)))).get((31 & ((io$2 >>> 5) | 0)))).get((31 & io$2));
    } else if ((index >= this.sci_Vector6__f_len123)) {
      var io$3 = ((index - this.sci_Vector6__f_len123) | 0);
      return $n($n($n($n(this.sci_Vector6__f_prefix4).get(((io$3 >>> 15) | 0))).get((31 & ((io$3 >>> 10) | 0)))).get((31 & ((io$3 >>> 5) | 0)))).get((31 & io$3));
    } else if ((index >= this.sci_Vector6__f_len12)) {
      var io$4 = ((index - this.sci_Vector6__f_len12) | 0);
      return $n($n($n(this.sci_Vector6__f_prefix3).get(((io$4 >>> 10) | 0))).get((31 & ((io$4 >>> 5) | 0)))).get((31 & io$4));
    } else if ((index >= this.sci_Vector6__f_len1)) {
      var io$5 = ((index - this.sci_Vector6__f_len1) | 0);
      return $n($n(this.sci_Vector6__f_prefix2).get(((io$5 >>> 5) | 0))).get((31 & io$5));
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
function $as_sci_Vector6(obj) {
  return (((obj instanceof $c_sci_Vector6) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector6"));
}
function $isArrayOf_sci_Vector6(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector6)));
}
function $asArrayOf_sci_Vector6(obj, depth) {
  return (($isArrayOf_sci_Vector6(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector6;", depth));
}
var $d_sci_Vector6 = new $TypeData().initClass($c_sci_Vector6, "scala.collection.immutable.Vector6", ({
  sci_Vector6: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_scm_StringBuilder__jl_StringBuilder__($thiz, underlying) {
  $thiz.scm_StringBuilder__f_underlying = underlying;
  return $thiz;
}
function $ct_scm_StringBuilder__($thiz) {
  $ct_scm_StringBuilder__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__(new $c_jl_StringBuilder()));
  return $thiz;
}
function $ct_scm_StringBuilder__T__($thiz, str) {
  $ct_scm_StringBuilder__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), str));
  return $thiz;
}
/** @constructor */
function $c_scm_StringBuilder() {
  this.scm_StringBuilder__f_underlying = null;
}
$c_scm_StringBuilder.prototype = new $h_scm_AbstractSeq();
$c_scm_StringBuilder.prototype.constructor = $c_scm_StringBuilder;
/** @constructor */
function $h_scm_StringBuilder() {
}
$h_scm_StringBuilder.prototype = $c_scm_StringBuilder.prototype;
$c_scm_StringBuilder.prototype.stringPrefix__T = (function() {
  return "IndexedSeq";
});
$c_scm_StringBuilder.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1);
});
$c_scm_StringBuilder.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_scm_StringBuilder.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_scm_StringBuilder.prototype.prepended__O__O = (function(elem) {
  return $f_sc_IndexedSeqOps__prepended__O__O(this, elem);
});
$c_scm_StringBuilder.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n);
});
$c_scm_StringBuilder.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$c_scm_StringBuilder.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__dropRight__I__O(this, n);
});
$c_scm_StringBuilder.prototype.map__F1__O = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f);
});
$c_scm_StringBuilder.prototype.reverse__O = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this);
});
$c_scm_StringBuilder.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_scm_StringBuilder.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_scm_StringBuilder.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_scm_StringBuilder.prototype.lengthCompare__I__I = (function(len) {
  var x = $n(this.scm_StringBuilder__f_underlying).length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_scm_StringBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_scm_StringBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$c_scm_StringBuilder.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_StringBuilder__(new $c_scm_StringBuilder()));
});
$c_scm_StringBuilder.prototype.length__I = (function() {
  return $n(this.scm_StringBuilder__f_underlying).length__I();
});
$c_scm_StringBuilder.prototype.knownSize__I = (function() {
  return $n(this.scm_StringBuilder__f_underlying).length__I();
});
$c_scm_StringBuilder.prototype.addOne__C__scm_StringBuilder = (function(x) {
  var this$1 = $n(this.scm_StringBuilder__f_underlying);
  var str = ("" + $cToS(x));
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
  return this;
});
$c_scm_StringBuilder.prototype.addAll__T__scm_StringBuilder = (function(s) {
  var this$1 = $n(this.scm_StringBuilder__f_underlying);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s);
  return this;
});
$c_scm_StringBuilder.prototype.toString__T = (function() {
  return $n(this.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_scm_StringBuilder.prototype.toArray__s_reflect_ClassTag__O = (function(ct) {
  var x1 = $n(ct).runtimeClass__jl_Class();
  return ((x1 === $d_C.getClassOf()) ? this.toCharArray__AC() : $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, ct));
});
$c_scm_StringBuilder.prototype.toCharArray__AC = (function() {
  var len = $n(this.scm_StringBuilder__f_underlying).length__I();
  var arr = new $ac_C(len);
  $n(this.scm_StringBuilder__f_underlying).getChars__I__I__AC__I__V(0, len, arr, 0);
  return arr;
});
$c_scm_StringBuilder.prototype.append__T__scm_StringBuilder = (function(s) {
  var this$1 = $n(this.scm_StringBuilder__f_underlying);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s);
  return this;
});
$c_scm_StringBuilder.prototype.appendAll__sc_IterableOnce__scm_StringBuilder = (function(xs) {
  if ((xs instanceof $c_sci_WrappedString)) {
    var x2 = $as_sci_WrappedString(xs);
    var this$3 = $n(this.scm_StringBuilder__f_underlying);
    var str = $n(x2).sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
    this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  } else if ((xs instanceof $c_scm_ArraySeq$ofChar)) {
    var x3 = $as_scm_ArraySeq$ofChar(xs);
    $n(this.scm_StringBuilder__f_underlying).append__AC__jl_StringBuilder($n(x3).scm_ArraySeq$ofChar__f_array);
  } else if ((xs instanceof $c_scm_StringBuilder)) {
    var x4 = $as_scm_StringBuilder(xs);
    var this$4 = $n(this.scm_StringBuilder__f_underlying);
    var s = $n(x4).scm_StringBuilder__f_underlying;
    this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s);
  } else {
    var ks = $n(xs).knownSize__I();
    if ((ks !== 0)) {
      var b = this.scm_StringBuilder__f_underlying;
      if ((ks > 0)) {
        $n(b);
        $n(b).length__I();
      }
      var it = $n(xs).iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        var this$5 = $n(b);
        var c = $uC($n(it).next__O());
        var str$1 = ("" + $cToS(c));
        this$5.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$5.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$1);
      }
    }
  }
  return this;
});
$c_scm_StringBuilder.prototype.append__C__scm_StringBuilder = (function(x) {
  var this$1 = $n(this.scm_StringBuilder__f_underlying);
  var str = ("" + $cToS(x));
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
  return this;
});
$c_scm_StringBuilder.prototype.charAt__I__C = (function(index) {
  return $n(this.scm_StringBuilder__f_underlying).charAt__I__C(index);
});
$c_scm_StringBuilder.prototype.subSequence__I__I__jl_CharSequence = (function(start, end) {
  return $n(this.scm_StringBuilder__f_underlying).substring__I__I__T(start, end);
});
$c_scm_StringBuilder.prototype.isEmpty__Z = (function() {
  return ($n(this.scm_StringBuilder__f_underlying).length__I() === 0);
});
$c_scm_StringBuilder.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_IndexedSeq$();
});
$c_scm_StringBuilder.prototype.result__O = (function() {
  return $n(this.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_scm_StringBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__C__scm_StringBuilder($uC(elem));
});
$c_scm_StringBuilder.prototype.empty__sc_IterableOps = (function() {
  return $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
});
$c_scm_StringBuilder.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $ct_scm_StringBuilder__(new $c_scm_StringBuilder()).appendAll__sc_IterableOnce__scm_StringBuilder(coll);
});
$c_scm_StringBuilder.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $ct_scm_StringBuilder__(new $c_scm_StringBuilder()).appendAll__sc_IterableOnce__scm_StringBuilder(coll);
});
$c_scm_StringBuilder.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return $bC($n(this.scm_StringBuilder__f_underlying).charAt__I__C(i));
});
$c_scm_StringBuilder.prototype.apply__I__O = (function(i) {
  return $bC($n(this.scm_StringBuilder__f_underlying).charAt__I__C(i));
});
function $as_scm_StringBuilder(obj) {
  return (((obj instanceof $c_scm_StringBuilder) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.StringBuilder"));
}
function $isArrayOf_scm_StringBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_StringBuilder)));
}
function $asArrayOf_scm_StringBuilder(obj, depth) {
  return (($isArrayOf_scm_StringBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.StringBuilder;", depth));
}
var $d_scm_StringBuilder = new $TypeData().initClass($c_scm_StringBuilder, "scala.collection.mutable.StringBuilder", ({
  scm_StringBuilder: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  jl_CharSequence: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_instances_OptionInstances$$anon$1() {
  this.Lcats_instances_OptionInstances$$anon$1__f_someUnit = null;
  this.Lcats_instances_OptionInstances$$anon$1__f_someUnit = new $c_s_Some((void 0));
}
$c_Lcats_instances_OptionInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_OptionInstances$$anon$1.prototype.constructor = $c_Lcats_instances_OptionInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_OptionInstances$$anon$1() {
}
$h_Lcats_instances_OptionInstances$$anon$1.prototype = $c_Lcats_instances_OptionInstances$$anon$1.prototype;
$c_Lcats_instances_OptionInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_s_Option(fa);
  var this$1 = $n(fa$1);
  return (this$1.isEmpty__Z() ? $m_s_None$() : new $c_s_Some($n(f).apply__O__O(this$1.get__O())));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.fold__O__Lcats_kernel_Monoid__O = (function(fa, A) {
  return $f_Lcats_Foldable__fold__O__Lcats_kernel_Monoid__O(this, fa, A);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.toIterable__O__sc_Iterable = (function(fa) {
  return $m_Lcats_compat_FoldableCompat$().toIterable__O__Lcats_Foldable__sc_Iterable(fa, this);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O(this, fa, z, f, G);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverse___O__F1__Lcats_Applicative__O(this, fa, f, G);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return this.foldMap__s_Option__F1__Lcats_kernel_Monoid__O($as_s_Option(fa), f, evidence$1);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$1) {
  return this.traverse__s_Option__F1__Lcats_Applicative__O($as_s_Option(sa), f, evidence$1);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.algebra__Lcats_kernel_Monoid = (function() {
  return new $c_Lcats_MonoidK$$anon$1(this);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.combineK__s_Option__s_Option__s_Option = (function(x, y) {
  var this$1 = $n(x);
  if ((!this$1.isEmpty__Z())) {
    return x;
  } else {
    return y;
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.tailRecM__O__F1__s_Option = (function(a, f) {
  var a$tailLocal1 = a;
  while (true) {
    var x4 = $as_s_Option($n(f).apply__O__O(a$tailLocal1));
    var x = $m_s_None$();
    if ((x === x4)) {
      return $m_s_None$();
    }
    if ((x4 instanceof $c_s_Some)) {
      var x10 = $as_s_util_Either($n($as_s_Some(x4)).s_Some__f_value);
      if ((x10 instanceof $c_s_util_Left)) {
        var a1 = $n($as_s_util_Left(x10)).s_util_Left__f_value;
        a$tailLocal1 = a1;
        continue;
      }
      if ((x10 instanceof $c_s_util_Right)) {
        var b = $n($as_s_util_Right(x10)).s_util_Right__f_value;
        return new $c_s_Some(b);
      }
    }
    throw new $c_s_MatchError(x4);
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map2__s_Option__s_Option__F2__s_Option = (function(fa, fb, f) {
  var this$1 = $n(fa);
  if ((!this$1.isEmpty__Z())) {
    var this$2 = $n(fb);
    var $x_1 = (!this$2.isEmpty__Z());
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var value = $n(f).apply__O__O__O($n(fa).get__O(), $n(fb).get__O());
    return new $c_s_Some(value);
  } else {
    return $m_s_None$();
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.product__s_Option__s_Option__s_Option = (function(fa, fb) {
  var this$1 = $n(fa);
  if ((!this$1.isEmpty__Z())) {
    var this$2 = $n(fb);
    var $x_1 = (!this$2.isEmpty__Z());
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var _1 = $n(fa).get__O();
    var _2 = $n(fb).get__O();
    var value = new $c_T2(_1, _2);
    return new $c_s_Some(value);
  } else {
    return $m_s_None$();
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.productR__s_Option__s_Option__s_Option = (function(fa, fb) {
  var this$1 = $n(fa);
  if ((!this$1.isEmpty__Z())) {
    return fb;
  } else {
    return $m_s_None$();
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.productL__s_Option__s_Option__s_Option = (function(fa, fb) {
  var this$1 = $n(fb);
  if ((!this$1.isEmpty__Z())) {
    return fa;
  } else {
    return $m_s_None$();
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.ap__s_Option__s_Option__s_Option = (function(f, fa) {
  var this$1 = $n(f);
  if ((!this$1.isEmpty__Z())) {
    var this$2 = $n(fa);
    var $x_1 = (!this$2.isEmpty__Z());
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var value = $n($as_F1($n(f).get__O())).apply__O__O($n(fa).get__O());
    return new $c_s_Some(value);
  } else {
    return $m_s_None$();
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map2Eval__s_Option__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  var x = $m_s_None$();
  if ((x === fa)) {
    var value = $m_s_None$();
    return new $c_Lcats_Now(value);
  }
  if ((fa instanceof $c_s_Some)) {
    var a = $n($as_s_Some(fa)).s_Some__f_value;
    return $n(fb).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((x$1) => {
      var x$1$1 = $as_s_Option(x$1);
      if ((x$1$1 instanceof $c_s_Some)) {
        var b = $n($as_s_Some(x$1$1)).s_Some__f_value;
        var value$1 = $n(f).apply__O__O__O(a, b);
        return new $c_s_Some(value$1);
      }
      var x$2 = $m_s_None$();
      if ((x$2 === x$1$1)) {
        return $m_s_None$();
      }
      throw new $c_s_MatchError(x$1$1);
    })));
  }
  throw new $c_s_MatchError(fa);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldLeft__s_Option__O__F2__O = (function(fa, b, f) {
  var x = $m_s_None$();
  if ((x === fa)) {
    return b;
  }
  if ((fa instanceof $c_s_Some)) {
    var a = $n($as_s_Some(fa)).s_Some__f_value;
    return $n(f).apply__O__O__O(b, a);
  }
  throw new $c_s_MatchError(fa);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldRight__s_Option__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  var x = $m_s_None$();
  if ((x === fa)) {
    return lb;
  }
  if ((fa instanceof $c_s_Some)) {
    var a = $n($as_s_Some(fa)).s_Some__f_value;
    return $as_Lcats_Eval($n(f).apply__O__O__O(a, lb));
  }
  throw new $c_s_MatchError(fa);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.handleErrorWith__s_Option__F1__s_Option = (function(fa, f) {
  var this$1 = $n(fa);
  return (this$1.isEmpty__Z() ? $as_s_Option($n(f).apply__O__O((void 0))) : this$1);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.traverse__s_Option__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  var x = $m_s_None$();
  if ((x === fa)) {
    return $n(evidence$1).pure__O__O($m_s_None$());
  }
  if ((fa instanceof $c_s_Some)) {
    var a = $n($as_s_Some(fa)).s_Some__f_value;
    return $n(evidence$1).map__O__F1__O($n(f).apply__O__O(a), new $c_sjsr_AnonFunction1(((_$2) => new $c_s_Some(_$2))));
  }
  throw new $c_s_MatchError(fa);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.size__s_Option__J = (function(fa) {
  var this$1 = $n(fa);
  return (this$1.isEmpty__Z() ? $L0 : (this$1.get__O(), new $c_RTLong(1, 0)));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldMap__s_Option__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var this$1 = $n(fa);
  return (this$1.isEmpty__Z() ? $n(B).empty__O() : $n(f).apply__O__O(this$1.get__O()));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.void__s_Option__s_Option = (function(oa) {
  var this$1 = $n(oa);
  if ((!this$1.isEmpty__Z())) {
    return this.Lcats_instances_OptionInstances$$anon$1__f_someUnit;
  } else {
    return $m_s_None$();
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.empty__O = (function() {
  return $m_s_None$();
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  return this.combineK__s_Option__s_Option__s_Option($as_s_Option(x), $as_s_Option(y));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return new $c_s_Some(x);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_s_Option(fa);
  var this$1 = $n(fa$1);
  return (this$1.isEmpty__Z() ? $m_s_None$() : new $c_s_Some($n(f).apply__O__O(this$1.get__O())));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_s_Option(fa);
  var this$1 = $n(fa$1);
  return (this$1.isEmpty__Z() ? $m_s_None$() : $as_s_Option($n(f).apply__O__O(this$1.get__O())));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__s_Option(a, f);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__s_Option__s_Option__F2__s_Option($as_s_Option(fa), $as_s_Option(fb), f);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return this.product__s_Option__s_Option__s_Option($as_s_Option(fa), $as_s_Option(fb));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.productR__O__O__O = (function(fa, fb) {
  return this.productR__s_Option__s_Option__s_Option($as_s_Option(fa), $as_s_Option(fb));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return this.productL__s_Option__s_Option__s_Option($as_s_Option(fa), $as_s_Option(fb));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return this.ap__s_Option__s_Option__s_Option($as_s_Option(ff), $as_s_Option(fa));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__s_Option__Lcats_Eval__F2__Lcats_Eval($as_s_Option(fa), fb, f);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  return this.foldLeft__s_Option__O__F2__O($as_s_Option(fa), b, f);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__s_Option__Lcats_Eval__F2__Lcats_Eval($as_s_Option(fa), lb, f);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.raiseError__O__O = (function(e) {
  $as_jl_Void(e);
  return $m_s_None$();
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return this.handleErrorWith__s_Option__F1__s_Option($as_s_Option(fa), f);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__s_Option__F1__Lcats_Applicative__O($as_s_Option(fa), f, evidence$1);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.reduceLeftToOption__O__F1__F2__s_Option = (function(fa, f, g) {
  var fa$1 = $as_s_Option(fa);
  var this$1 = $n(fa$1);
  return (this$1.isEmpty__Z() ? $m_s_None$() : new $c_s_Some($n(f).apply__O__O(this$1.get__O())));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.reduceLeftOption__O__F2__s_Option = (function(fa, f) {
  var fa$1 = $as_s_Option(fa);
  return fa$1;
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.maximumOption__O__Lcats_kernel_Order__s_Option = (function(fa, A) {
  var fa$1 = $as_s_Option(fa);
  return fa$1;
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.size__O__J = (function(fa) {
  return this.size__s_Option__J($as_s_Option(fa));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__s_Option__F1__Lcats_kernel_Monoid__O($as_s_Option(fa), f, B);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.toList__O__sci_List = (function(fa) {
  var fa$1 = $as_s_Option(fa);
  return $n(fa$1).toList__sci_List();
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.unit__O = (function() {
  return this.Lcats_instances_OptionInstances$$anon$1__f_someUnit;
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return this.void__s_Option__s_Option($as_s_Option(fa));
});
var $d_Lcats_instances_OptionInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_OptionInstances$$anon$1, "cats.instances.OptionInstances$$anon$1", ({
  Lcats_instances_OptionInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_CommutativeApply: 1,
  Lcats_CommutativeFlatMap: 1,
  Lcats_CommutativeApplicative: 1,
  Lcats_CommutativeMonad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
}));
/** @constructor */
function $c_sci_BitSet() {
}
$c_sci_BitSet.prototype = new $h_sci_AbstractSet();
$c_sci_BitSet.prototype.constructor = $c_sci_BitSet;
/** @constructor */
function $h_sci_BitSet() {
}
$h_sci_BitSet.prototype = $c_sci_BitSet.prototype;
$c_sci_BitSet.prototype.stringPrefix__T = (function() {
  return "BitSet";
});
$c_sci_BitSet.prototype.scala$collection$BitSetOps$$super$max__s_math_Ordering__I = (function(ord) {
  return $uI($f_sc_SortedSetOps__max__s_math_Ordering__O(this, ord));
});
$c_sci_BitSet.prototype.scala$collection$BitSetOps$$super$concat__sc_IterableOnce__sc_BitSet = (function(that) {
  return $as_sc_BitSet($f_sci_StrictOptimizedSetOps__concat__sc_IterableOnce__sci_SetOps(this, that));
});
$c_sci_BitSet.prototype.scala$collection$BitSetOps$$super$diff__sc_Set__sc_BitSet = (function(that) {
  return $as_sc_BitSet($f_sci_SetOps__diff__sc_Set__sci_SetOps(this, that));
});
$c_sci_BitSet.prototype.ordering__s_math_Ordering = (function() {
  return $m_s_math_Ordering$Int$();
});
$c_sci_BitSet.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_BitSetOps$$anon$1(this, 0);
});
$c_sci_BitSet.prototype.size__I = (function() {
  return $f_sc_BitSetOps__size__I(this);
});
$c_sci_BitSet.prototype.isEmpty__Z = (function() {
  return $f_sc_BitSetOps__isEmpty__Z(this);
});
$c_sci_BitSet.prototype.foreach__F1__V = (function(f) {
  $f_sc_BitSetOps__foreach__F1__V(this, f);
});
$c_sci_BitSet.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_BitSetOps__partition__F1__T2(this, p);
});
$c_sci_BitSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_BitSet.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_BitSet.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_sci_BitSet.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_BitSet(pred, false);
});
$c_sci_BitSet.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_BitSet(pred, true);
});
$c_sci_BitSet.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_BitSet.prototype.sortedIterableFactory__sc_SortedIterableFactory = (function() {
  return $m_sci_SortedSet$();
});
$c_sci_BitSet.prototype.equals__O__Z = (function(that) {
  return $f_sc_SortedSet__equals__O__Z(this, that);
});
$c_sci_BitSet.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sci_BitSet$().newBuilder__scm_Builder();
});
$c_sci_BitSet.prototype.incl__I__sci_BitSet = (function(elem) {
  var requirement = (elem >= 0);
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: bitset element must be >= 0");
  }
  if ($f_sc_BitSetOps__contains__I__Z(this, elem)) {
    return this;
  } else {
    var idx = (elem >> 6);
    var this$2 = this.word__I__J(idx);
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (this$2.RTLong__f_lo | lo);
    var hi$1 = (this$2.RTLong__f_hi | hi);
    return this.updateWord__I__J__sci_BitSet(idx, new $c_RTLong(lo$1, hi$1));
  }
});
$c_sci_BitSet.prototype.excl__I__sci_BitSet = (function(elem) {
  var requirement = (elem >= 0);
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: bitset element must be >= 0");
  }
  if ($f_sc_BitSetOps__contains__I__Z(this, elem)) {
    var idx = (elem >> 6);
    var this$2 = this.word__I__J(idx);
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (~lo);
    var hi$1 = (~hi);
    var lo$2 = (this$2.RTLong__f_lo & lo$1);
    var hi$2 = (this$2.RTLong__f_hi & hi$1);
    return this.updateWord__I__J__sci_BitSet(idx, new $c_RTLong(lo$2, hi$2));
  } else {
    return this;
  }
});
$c_sci_BitSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  return $f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet(this, that);
});
$c_sci_BitSet.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_BitSetOps__max__s_math_Ordering__I(this, ord);
});
$c_sci_BitSet.prototype.contains__O__Z = (function(elem) {
  var elem$1 = $uI(elem);
  return $f_sc_BitSetOps__contains__I__Z(this, elem$1);
});
$c_sci_BitSet.prototype.map__F1__s_math_Ordering__sc_SortedSet = (function(f, ev) {
  return $as_sci_SortedSet($f_sc_StrictOptimizedSortedSetOps__map__F1__s_math_Ordering__sc_SortedSet(this, f, ev));
});
$c_sci_BitSet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__I__sci_BitSet($uI(elem));
});
$c_sci_BitSet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__I__sci_BitSet($uI(elem));
});
$c_sci_BitSet.prototype.fromBitMaskNoCopy__AJ__sc_BitSet = (function(elems) {
  return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(elems);
});
$c_sci_BitSet.prototype.empty__O = (function() {
  return $m_sci_BitSet$().sci_BitSet$__f_empty;
});
$c_sci_BitSet.prototype.empty__sc_IterableOps = (function() {
  return $m_sci_BitSet$().sci_BitSet$__f_empty;
});
$c_sci_BitSet.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $m_sci_BitSet$().fromSpecific__sc_IterableOnce__sci_BitSet(coll);
});
$c_sci_BitSet.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $m_sci_BitSet$().fromSpecific__sc_IterableOnce__sci_BitSet(coll);
});
function $as_sci_BitSet(obj) {
  return (((obj instanceof $c_sci_BitSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.BitSet"));
}
function $isArrayOf_sci_BitSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BitSet)));
}
function $asArrayOf_sci_BitSet(obj, depth) {
  return (($isArrayOf_sci_BitSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.BitSet;", depth));
}
function $as_scm_LinkedHashMap(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.LinkedHashMap"));
}
function $isArrayOf_scm_LinkedHashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_LinkedHashMap)));
}
function $asArrayOf_scm_LinkedHashMap(obj, depth) {
  return (($isArrayOf_scm_LinkedHashMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.LinkedHashMap;", depth));
}
function $p_scm_ListBuffer__copyElems__V($thiz) {
  var buf = new $c_scm_ListBuffer().scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer($thiz);
  $thiz.scm_ListBuffer__f_first = $n(buf).scm_ListBuffer__f_first;
  $thiz.scm_ListBuffer__f_last0 = $n(buf).scm_ListBuffer__f_last0;
  $thiz.scm_ListBuffer__f_aliased = false;
}
function $p_scm_ListBuffer__ensureUnaliased__V($thiz) {
  $thiz.scm_ListBuffer__f_mutationCount = ((1 + $thiz.scm_ListBuffer__f_mutationCount) | 0);
  if ($thiz.scm_ListBuffer__f_aliased) {
    $p_scm_ListBuffer__copyElems__V($thiz);
  }
}
/** @constructor */
function $c_scm_ListBuffer() {
  this.scm_ListBuffer__f_mutationCount = 0;
  this.scm_ListBuffer__f_first = null;
  this.scm_ListBuffer__f_last0 = null;
  this.scm_ListBuffer__f_aliased = false;
  this.scm_ListBuffer__f_len = 0;
  this.scm_ListBuffer__f_mutationCount = 0;
  this.scm_ListBuffer__f_first = $m_sci_Nil$();
  this.scm_ListBuffer__f_last0 = null;
  this.scm_ListBuffer__f_aliased = false;
  this.scm_ListBuffer__f_len = 0;
}
$c_scm_ListBuffer.prototype = new $h_scm_AbstractBuffer();
$c_scm_ListBuffer.prototype.constructor = $c_scm_ListBuffer;
/** @constructor */
function $h_scm_ListBuffer() {
}
$h_scm_ListBuffer.prototype = $c_scm_ListBuffer.prototype;
$c_scm_ListBuffer.prototype.sizeHint__I__V = (function(size) {
});
$c_scm_ListBuffer.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$c_scm_ListBuffer.prototype.prepended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__prepended__O__O(this, elem);
});
$c_scm_ListBuffer.prototype.appended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$c_scm_ListBuffer.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$c_scm_ListBuffer.prototype.prependedAll__sc_IterableOnce__O = (function(prefix) {
  return $f_sc_StrictOptimizedSeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$c_scm_ListBuffer.prototype.padTo__I__O__O = (function(len, elem) {
  return $f_sc_StrictOptimizedSeqOps__padTo__I__O__O(this, len, elem);
});
$c_scm_ListBuffer.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_scm_ListBuffer.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_scm_ListBuffer.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_scm_ListBuffer.prototype.flatten__F1__O = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$c_scm_ListBuffer.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_scm_ListBuffer.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_scm_ListBuffer.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$c_scm_ListBuffer.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_scm_ListBuffer.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_MutationTracker$CheckedIterator($n(this.scm_ListBuffer__f_first).iterator__sc_Iterator(), new $c_sjsr_AnonFunction0((() => this.scm_ListBuffer__f_mutationCount)));
});
$c_scm_ListBuffer.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_ListBuffer$();
});
$c_scm_ListBuffer.prototype.apply__I__O = (function(i) {
  var this$1 = $n(this.scm_ListBuffer__f_first);
  return $f_sc_LinearSeqOps__apply__I__O(this$1, i);
});
$c_scm_ListBuffer.prototype.length__I = (function() {
  return this.scm_ListBuffer__f_len;
});
$c_scm_ListBuffer.prototype.knownSize__I = (function() {
  return this.scm_ListBuffer__f_len;
});
$c_scm_ListBuffer.prototype.isEmpty__Z = (function() {
  return (this.scm_ListBuffer__f_len === 0);
});
$c_scm_ListBuffer.prototype.toList__sci_List = (function() {
  this.scm_ListBuffer__f_aliased = (!this.isEmpty__Z());
  return this.scm_ListBuffer__f_first;
});
$c_scm_ListBuffer.prototype.addOne__O__scm_ListBuffer = (function(elem) {
  $p_scm_ListBuffer__ensureUnaliased__V(this);
  var last1 = new $c_sci_$colon$colon(elem, $m_sci_Nil$());
  if ((this.scm_ListBuffer__f_len === 0)) {
    this.scm_ListBuffer__f_first = last1;
  } else {
    $n(this.scm_ListBuffer__f_last0).sci_$colon$colon__f_next = last1;
  }
  this.scm_ListBuffer__f_last0 = last1;
  this.scm_ListBuffer__f_len = ((1 + this.scm_ListBuffer__f_len) | 0);
  return this;
});
$c_scm_ListBuffer.prototype.scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer = (function(xs) {
  var it = $n(xs).iterator__sc_Iterator();
  if ($n(it).hasNext__Z()) {
    var len = 1;
    var last0 = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
    this.scm_ListBuffer__f_first = last0;
    while ($n(it).hasNext__Z()) {
      var last1 = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
      $n(last0).sci_$colon$colon__f_next = last1;
      last0 = last1;
      len = ((1 + len) | 0);
    }
    this.scm_ListBuffer__f_len = len;
    this.scm_ListBuffer__f_last0 = last0;
  }
  return this;
});
$c_scm_ListBuffer.prototype.addAll__sc_IterableOnce__scm_ListBuffer = (function(xs) {
  var it = $n(xs).iterator__sc_Iterator();
  if ($n(it).hasNext__Z()) {
    var fresh = new $c_scm_ListBuffer().scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer(it);
    $p_scm_ListBuffer__ensureUnaliased__V(this);
    if ((this.scm_ListBuffer__f_len === 0)) {
      this.scm_ListBuffer__f_first = $n(fresh).scm_ListBuffer__f_first;
    } else {
      $n(this.scm_ListBuffer__f_last0).sci_$colon$colon__f_next = $n(fresh).scm_ListBuffer__f_first;
    }
    this.scm_ListBuffer__f_last0 = $n(fresh).scm_ListBuffer__f_last0;
    this.scm_ListBuffer__f_len = ((this.scm_ListBuffer__f_len + $n(fresh).scm_ListBuffer__f_len) | 0);
  }
  return this;
});
$c_scm_ListBuffer.prototype.last__O = (function() {
  if ((this.scm_ListBuffer__f_last0 === null)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last of empty ListBuffer");
  } else {
    return $n(this.scm_ListBuffer__f_last0).sci_$colon$colon__f_head;
  }
});
$c_scm_ListBuffer.prototype.stringPrefix__T = (function() {
  return "ListBuffer";
});
$c_scm_ListBuffer.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_ListBuffer(elems);
});
$c_scm_ListBuffer.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ListBuffer(elem);
});
$c_scm_ListBuffer.prototype.result__O = (function() {
  return this.toList__sci_List();
});
$c_scm_ListBuffer.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  var this$1 = $n(this.scm_ListBuffer__f_first);
  return $f_sc_LinearSeqOps__apply__I__O(this$1, i);
});
$c_scm_ListBuffer.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_ListBuffer$();
});
function $as_scm_ListBuffer(obj) {
  return (((obj instanceof $c_scm_ListBuffer) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ListBuffer"));
}
function $isArrayOf_scm_ListBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ListBuffer)));
}
function $asArrayOf_scm_ListBuffer(obj, depth) {
  return (($isArrayOf_scm_ListBuffer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ListBuffer;", depth));
}
var $d_scm_ListBuffer = new $TypeData().initClass($c_scm_ListBuffer, "scala.collection.mutable.ListBuffer", ({
  scm_ListBuffer: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_BitSet$BitSet1(elems) {
  this.sci_BitSet$BitSet1__f_elems = $L0;
  this.sci_BitSet$BitSet1__f_elems = elems;
}
$c_sci_BitSet$BitSet1.prototype = new $h_sci_BitSet();
$c_sci_BitSet$BitSet1.prototype.constructor = $c_sci_BitSet$BitSet1;
/** @constructor */
function $h_sci_BitSet$BitSet1() {
}
$h_sci_BitSet$BitSet1.prototype = $c_sci_BitSet$BitSet1.prototype;
$c_sci_BitSet$BitSet1.prototype.nwords__I = (function() {
  return 1;
});
$c_sci_BitSet$BitSet1.prototype.word__I__J = (function(idx) {
  return ((idx === 0) ? this.sci_BitSet$BitSet1__f_elems : $L0);
});
$c_sci_BitSet$BitSet1.prototype.updateWord__I__J__sci_BitSet = (function(idx, w) {
  if ((idx === 0)) {
    return new $c_sci_BitSet$BitSet1(w);
  } else if ((idx === 1)) {
    return $m_sci_BitSet$().scala$collection$immutable$BitSet$$createSmall__J__J__sci_BitSet(this.sci_BitSet$BitSet1__f_elems, w);
  } else {
    var elems = $m_sc_BitSetOps$().updateArray__AJ__I__J__AJ(new $ac_J([this.sci_BitSet$BitSet1__f_elems]), idx, w);
    return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(elems);
  }
});
$c_sci_BitSet$BitSet1.prototype.diff__sc_Set__sci_BitSet = (function(other) {
  if ($is_sc_BitSet(other)) {
    var x2 = $as_sc_BitSet(other);
    var x1$2 = $n(x2).nwords__I();
    if ((x1$2 === 0)) {
      return this;
    } else {
      var this$1 = this.sci_BitSet$BitSet1__f_elems;
      var b = $n(x2).word__I__J(0);
      var lo = (~b.RTLong__f_lo);
      var hi = (~b.RTLong__f_hi);
      var lo$1 = (this$1.RTLong__f_lo & lo);
      var hi$1 = (this$1.RTLong__f_hi & hi);
      return (((lo$1 === 0) && (hi$1 === 0)) ? $m_sci_BitSet$().sci_BitSet$__f_empty : new $c_sci_BitSet$BitSet1(new $c_RTLong(lo$1, hi$1)));
    }
  } else {
    return $as_sci_BitSet($f_sc_BitSetOps__diff__sc_Set__sc_BitSet(this, other));
  }
});
$c_sci_BitSet$BitSet1.prototype.filterImpl__F1__Z__sci_BitSet = (function(pred, isFlipped) {
  var t = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, this.sci_BitSet$BitSet1__f_elems, 0);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return (((lo === 0) && (hi === 0)) ? $m_sci_BitSet$().sci_BitSet$__f_empty : new $c_sci_BitSet$BitSet1(new $c_RTLong(lo, hi)));
});
$c_sci_BitSet$BitSet1.prototype.filterImpl__F1__Z__O = (function(pred, isFlipped) {
  return this.filterImpl__F1__Z__sci_BitSet(pred, isFlipped);
});
$c_sci_BitSet$BitSet1.prototype.diff__sc_Set__sc_SetOps = (function(that) {
  return this.diff__sc_Set__sci_BitSet(that);
});
var $d_sci_BitSet$BitSet1 = new $TypeData().initClass($c_sci_BitSet$BitSet1, "scala.collection.immutable.BitSet$BitSet1", ({
  sci_BitSet$BitSet1: 1,
  sci_BitSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  sci_SortedSetOps: 1,
  sci_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_BitSet: 1,
  sc_BitSetOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_BitSet$BitSet2(elems0, elems1) {
  this.sci_BitSet$BitSet2__f_elems0 = $L0;
  this.sci_BitSet$BitSet2__f_elems1 = $L0;
  this.sci_BitSet$BitSet2__f_elems0 = elems0;
  this.sci_BitSet$BitSet2__f_elems1 = elems1;
}
$c_sci_BitSet$BitSet2.prototype = new $h_sci_BitSet();
$c_sci_BitSet$BitSet2.prototype.constructor = $c_sci_BitSet$BitSet2;
/** @constructor */
function $h_sci_BitSet$BitSet2() {
}
$h_sci_BitSet$BitSet2.prototype = $c_sci_BitSet$BitSet2.prototype;
$c_sci_BitSet$BitSet2.prototype.nwords__I = (function() {
  return 2;
});
$c_sci_BitSet$BitSet2.prototype.word__I__J = (function(idx) {
  return ((idx === 0) ? this.sci_BitSet$BitSet2__f_elems0 : ((idx === 1) ? this.sci_BitSet$BitSet2__f_elems1 : $L0));
});
$c_sci_BitSet$BitSet2.prototype.updateWord__I__J__sci_BitSet = (function(idx, w) {
  if ((idx === 0)) {
    return new $c_sci_BitSet$BitSet2(w, this.sci_BitSet$BitSet2__f_elems1);
  } else if ((idx === 1)) {
    return $m_sci_BitSet$().scala$collection$immutable$BitSet$$createSmall__J__J__sci_BitSet(this.sci_BitSet$BitSet2__f_elems0, w);
  } else {
    var elems = $m_sc_BitSetOps$().updateArray__AJ__I__J__AJ(new $ac_J([this.sci_BitSet$BitSet2__f_elems0, this.sci_BitSet$BitSet2__f_elems1]), idx, w);
    return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(elems);
  }
});
$c_sci_BitSet$BitSet2.prototype.diff__sc_Set__sci_BitSet = (function(other) {
  if ($is_sc_BitSet(other)) {
    var x2 = $as_sc_BitSet(other);
    var x1$2 = $n(x2).nwords__I();
    switch (x1$2) {
      case 0: {
        return this;
        break;
      }
      case 1: {
        var this$1 = this.sci_BitSet$BitSet2__f_elems0;
        var b = $n(x2).word__I__J(0);
        var lo = (~b.RTLong__f_lo);
        var hi = (~b.RTLong__f_hi);
        var lo$1 = (this$1.RTLong__f_lo & lo);
        var hi$1 = (this$1.RTLong__f_hi & hi);
        return new $c_sci_BitSet$BitSet2(new $c_RTLong(lo$1, hi$1), this.sci_BitSet$BitSet2__f_elems1);
        break;
      }
      default: {
        var this$2 = this.sci_BitSet$BitSet2__f_elems0;
        var b$1 = $n(x2).word__I__J(0);
        var lo$2 = (~b$1.RTLong__f_lo);
        var hi$2 = (~b$1.RTLong__f_hi);
        var lo$3 = (this$2.RTLong__f_lo & lo$2);
        var hi$3 = (this$2.RTLong__f_hi & hi$2);
        var this$3 = this.sci_BitSet$BitSet2__f_elems1;
        var b$2 = $n(x2).word__I__J(1);
        var lo$4 = (~b$2.RTLong__f_lo);
        var hi$4 = (~b$2.RTLong__f_hi);
        var lo$5 = (this$3.RTLong__f_lo & lo$4);
        var hi$5 = (this$3.RTLong__f_hi & hi$4);
        return (((lo$5 === 0) && (hi$5 === 0)) ? (((lo$3 === 0) && (hi$3 === 0)) ? $m_sci_BitSet$().sci_BitSet$__f_empty : new $c_sci_BitSet$BitSet1(new $c_RTLong(lo$3, hi$3))) : new $c_sci_BitSet$BitSet2(new $c_RTLong(lo$3, hi$3), new $c_RTLong(lo$5, hi$5)));
      }
    }
  } else {
    return $as_sci_BitSet($f_sc_BitSetOps__diff__sc_Set__sc_BitSet(this, other));
  }
});
$c_sci_BitSet$BitSet2.prototype.filterImpl__F1__Z__sci_BitSet = (function(pred, isFlipped) {
  var t = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, this.sci_BitSet$BitSet2__f_elems0, 0);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, this.sci_BitSet$BitSet2__f_elems1, 1);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return (((lo$1 === 0) && (hi$1 === 0)) ? (((lo === 0) && (hi === 0)) ? $m_sci_BitSet$().sci_BitSet$__f_empty : new $c_sci_BitSet$BitSet1(new $c_RTLong(lo, hi))) : new $c_sci_BitSet$BitSet2(new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1)));
});
$c_sci_BitSet$BitSet2.prototype.filterImpl__F1__Z__O = (function(pred, isFlipped) {
  return this.filterImpl__F1__Z__sci_BitSet(pred, isFlipped);
});
$c_sci_BitSet$BitSet2.prototype.diff__sc_Set__sc_SetOps = (function(that) {
  return this.diff__sc_Set__sci_BitSet(that);
});
var $d_sci_BitSet$BitSet2 = new $TypeData().initClass($c_sci_BitSet$BitSet2, "scala.collection.immutable.BitSet$BitSet2", ({
  sci_BitSet$BitSet2: 1,
  sci_BitSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  sci_SortedSetOps: 1,
  sci_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_BitSet: 1,
  sc_BitSetOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_BitSet$BitSetN(elems) {
  this.sci_BitSet$BitSetN__f_elems = null;
  this.sci_BitSet$BitSetN__f_elems = elems;
}
$c_sci_BitSet$BitSetN.prototype = new $h_sci_BitSet();
$c_sci_BitSet$BitSetN.prototype.constructor = $c_sci_BitSet$BitSetN;
/** @constructor */
function $h_sci_BitSet$BitSetN() {
}
$h_sci_BitSet$BitSetN.prototype = $c_sci_BitSet$BitSetN.prototype;
$c_sci_BitSet$BitSetN.prototype.nwords__I = (function() {
  return $n(this.sci_BitSet$BitSetN__f_elems).u.length;
});
$c_sci_BitSet$BitSetN.prototype.word__I__J = (function(idx) {
  return ((idx < this.nwords__I()) ? $n(this.sci_BitSet$BitSetN__f_elems).get(idx) : $L0);
});
$c_sci_BitSet$BitSetN.prototype.updateWord__I__J__sci_BitSet = (function(idx, w) {
  var elems = $m_sc_BitSetOps$().updateArray__AJ__I__J__AJ(this.sci_BitSet$BitSetN__f_elems, idx, w);
  return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(elems);
});
$c_sci_BitSet$BitSetN.prototype.diff__sc_Set__sci_BitSet = (function(that) {
  if ($is_sc_BitSet(that)) {
    var x2 = $as_sc_BitSet(that);
    var bsnwords = $n(x2).nwords__I();
    var thisnwords = this.nwords__I();
    if ((bsnwords >= thisnwords)) {
      var i = (((-1) + thisnwords) | 0);
      var currentWord__lo = 0;
      var currentWord__hi = 0;
      var anyChanges = false;
      while (true) {
        if ((i >= 0)) {
          var this$1__lo = currentWord__lo;
          var this$1__hi = currentWord__hi;
          var $x_2 = ((this$1__lo === 0) && (this$1__hi === 0));
        } else {
          var $x_2 = false;
        }
        if ($x_2) {
          var t = this.word__I__J(i);
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          var b = $n(x2).word__I__J(i);
          var lo$1 = (~b.RTLong__f_lo);
          var hi$1 = (~b.RTLong__f_hi);
          var lo$2 = (lo & lo$1);
          var hi$2 = (hi & hi$1);
          var $x_1__lo = lo$2;
          var $x_1__hi = hi$2;
          currentWord__lo = $x_1__lo;
          currentWord__hi = $x_1__hi;
          if (anyChanges) {
            anyChanges = true;
          } else {
            var this$2__lo = currentWord__lo;
            var this$2__hi = currentWord__hi;
            anyChanges = (!((this$2__lo === lo) && (this$2__hi === hi)));
          }
          i = (((-1) + i) | 0);
        } else {
          break;
        }
      }
      var x1$2 = i;
      switch (x1$2) {
        case (-1): {
          if (anyChanges) {
            var this$3__lo = currentWord__lo;
            var this$3__hi = currentWord__hi;
            if (((this$3__lo === 0) && (this$3__hi === 0))) {
              return $m_sci_BitSet$().sci_BitSet$__f_empty;
            } else {
              return new $c_sci_BitSet$BitSet1(new $c_RTLong(currentWord__lo, currentWord__hi));
            }
          } else {
            return this;
          }
          break;
        }
        case 0: {
          var t$1 = this.word__I__J(0);
          var lo$3 = t$1.RTLong__f_lo;
          var hi$3 = t$1.RTLong__f_hi;
          var b$1 = $n(x2).word__I__J(0);
          var lo$4 = (~b$1.RTLong__f_lo);
          var hi$4 = (~b$1.RTLong__f_hi);
          var lo$5 = (lo$3 & lo$4);
          var hi$5 = (hi$3 & hi$4);
          anyChanges = (anyChanges || (!((lo$5 === lo$3) && (hi$5 === hi$3))));
          return (anyChanges ? new $c_sci_BitSet$BitSet2(new $c_RTLong(lo$5, hi$5), new $c_RTLong(currentWord__lo, currentWord__hi)) : this);
          break;
        }
        default: {
          var minimumNonZeroIndex = ((1 + i) | 0);
          while (((!anyChanges) && (i >= 0))) {
            var t$2 = this.word__I__J(i);
            var lo$6 = t$2.RTLong__f_lo;
            var hi$6 = t$2.RTLong__f_hi;
            var b$2 = $n(x2).word__I__J(i);
            var lo$7 = (~b$2.RTLong__f_lo);
            var hi$7 = (~b$2.RTLong__f_hi);
            var lo$8 = (lo$6 & lo$7);
            var hi$8 = (hi$6 & hi$7);
            var $x_3__lo = lo$8;
            var $x_3__hi = hi$8;
            currentWord__lo = $x_3__lo;
            currentWord__hi = $x_3__hi;
            if (anyChanges) {
              anyChanges = true;
            } else {
              var this$4__lo = currentWord__lo;
              var this$4__hi = currentWord__hi;
              anyChanges = (!((this$4__lo === lo$6) && (this$4__hi === hi$6)));
            }
            i = (((-1) + i) | 0);
          }
          if (anyChanges) {
            var xs = this.sci_BitSet$BitSetN__f_elems;
            var n = ((1 + minimumNonZeroIndex) | 0);
            var newArray = $asArrayOf_J($m_sc_ArrayOps$().slice$extension__O__I__I__O(xs, 0, n), 1);
            $n(newArray).set(((1 + i) | 0), new $c_RTLong(currentWord__lo, currentWord__hi));
            while ((i >= 0)) {
              var $x_5 = $n(newArray);
              var $x_4 = i;
              var this$7 = this.word__I__J(i);
              var b$3 = $n(x2).word__I__J(i);
              var lo$9 = (~b$3.RTLong__f_lo);
              var hi$9 = (~b$3.RTLong__f_hi);
              var lo$10 = (this$7.RTLong__f_lo & lo$9);
              var hi$10 = (this$7.RTLong__f_hi & hi$9);
              $x_5.set($x_4, new $c_RTLong(lo$10, hi$10));
              i = (((-1) + i) | 0);
            }
            return new $c_sci_BitSet$BitSetN(newArray);
          } else {
            return this;
          }
        }
      }
    } else {
      var i$2 = (((-1) + bsnwords) | 0);
      var anyChanges$2 = false;
      var currentWord$2__lo = 0;
      var currentWord$2__hi = 0;
      while (((i$2 >= 0) && (!anyChanges$2))) {
        var t$3 = this.word__I__J(i$2);
        var lo$11 = t$3.RTLong__f_lo;
        var hi$11 = t$3.RTLong__f_hi;
        var b$4 = $n(x2).word__I__J(i$2);
        var lo$12 = (~b$4.RTLong__f_lo);
        var hi$12 = (~b$4.RTLong__f_hi);
        var lo$13 = (lo$11 & lo$12);
        var hi$13 = (hi$11 & hi$12);
        var $x_6__lo = lo$13;
        var $x_6__hi = hi$13;
        currentWord$2__lo = $x_6__lo;
        currentWord$2__hi = $x_6__hi;
        if (anyChanges$2) {
          anyChanges$2 = true;
        } else {
          var this$8__lo = currentWord$2__lo;
          var this$8__hi = currentWord$2__hi;
          anyChanges$2 = (!((this$8__lo === lo$11) && (this$8__hi === hi$11)));
        }
        i$2 = (((-1) + i$2) | 0);
      }
      if (anyChanges$2) {
        var this$9 = $n(this.sci_BitSet$BitSetN__f_elems);
        var newElems = $n(this$9).clone__O();
        $n(newElems).set(((1 + i$2) | 0), new $c_RTLong(currentWord$2__lo, currentWord$2__hi));
        while ((i$2 >= 0)) {
          var $x_8 = $n(newElems);
          var $x_7 = i$2;
          var this$10 = this.word__I__J(i$2);
          var b$5 = $n(x2).word__I__J(i$2);
          var lo$14 = (~b$5.RTLong__f_lo);
          var hi$14 = (~b$5.RTLong__f_hi);
          var lo$15 = (this$10.RTLong__f_lo & lo$14);
          var hi$15 = (this$10.RTLong__f_hi & hi$14);
          $x_8.set($x_7, new $c_RTLong(lo$15, hi$15));
          i$2 = (((-1) + i$2) | 0);
        }
        return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(newElems);
      } else {
        return this;
      }
    }
  } else {
    return $as_sci_BitSet($f_sc_BitSetOps__diff__sc_Set__sc_BitSet(this, that));
  }
});
$c_sci_BitSet$BitSetN.prototype.filterImpl__F1__Z__sci_BitSet = (function(pred, isFlipped) {
  var i = (((-1) + this.nwords__I()) | 0);
  var currentWord__lo = 0;
  var currentWord__hi = 0;
  var anyChanges = false;
  while (true) {
    if ((i >= 0)) {
      var this$1__lo = currentWord__lo;
      var this$1__hi = currentWord__hi;
      var $x_2 = ((this$1__lo === 0) && (this$1__hi === 0));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var t = this.word__I__J(i);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var t$1 = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, new $c_RTLong(lo, hi), i);
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      var $x_1__lo = lo$1;
      var $x_1__hi = hi$1;
      currentWord__lo = $x_1__lo;
      currentWord__hi = $x_1__hi;
      if (anyChanges) {
        anyChanges = true;
      } else {
        var this$2__lo = currentWord__lo;
        var this$2__hi = currentWord__hi;
        anyChanges = (!((this$2__lo === lo) && (this$2__hi === hi)));
      }
      i = (((-1) + i) | 0);
    } else {
      break;
    }
  }
  var x1 = i;
  switch (x1) {
    case (-1): {
      if (anyChanges) {
        var this$3__lo = currentWord__lo;
        var this$3__hi = currentWord__hi;
        if (((this$3__lo === 0) && (this$3__hi === 0))) {
          return $m_sci_BitSet$().sci_BitSet$__f_empty;
        } else {
          return new $c_sci_BitSet$BitSet1(new $c_RTLong(currentWord__lo, currentWord__hi));
        }
      } else {
        return this;
      }
      break;
    }
    case 0: {
      var t$2 = this.word__I__J(0);
      var lo$2 = t$2.RTLong__f_lo;
      var hi$2 = t$2.RTLong__f_hi;
      var t$3 = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, new $c_RTLong(lo$2, hi$2), 0);
      var lo$3 = t$3.RTLong__f_lo;
      var hi$3 = t$3.RTLong__f_hi;
      anyChanges = (anyChanges || (!((lo$3 === lo$2) && (hi$3 === hi$2))));
      return (anyChanges ? new $c_sci_BitSet$BitSet2(new $c_RTLong(lo$3, hi$3), new $c_RTLong(currentWord__lo, currentWord__hi)) : this);
      break;
    }
    default: {
      var minimumNonZeroIndex = ((1 + i) | 0);
      while (((!anyChanges) && (i >= 0))) {
        var t$4 = this.word__I__J(i);
        var lo$4 = t$4.RTLong__f_lo;
        var hi$4 = t$4.RTLong__f_hi;
        var t$5 = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, new $c_RTLong(lo$4, hi$4), i);
        var lo$5 = t$5.RTLong__f_lo;
        var hi$5 = t$5.RTLong__f_hi;
        var $x_3__lo = lo$5;
        var $x_3__hi = hi$5;
        currentWord__lo = $x_3__lo;
        currentWord__hi = $x_3__hi;
        if (anyChanges) {
          anyChanges = true;
        } else {
          var this$4__lo = currentWord__lo;
          var this$4__hi = currentWord__hi;
          anyChanges = (!((this$4__lo === lo$4) && (this$4__hi === hi$4)));
        }
        i = (((-1) + i) | 0);
      }
      if (anyChanges) {
        var xs = this.sci_BitSet$BitSetN__f_elems;
        var n = ((1 + minimumNonZeroIndex) | 0);
        var newArray = $asArrayOf_J($m_sc_ArrayOps$().slice$extension__O__I__I__O(xs, 0, n), 1);
        $n(newArray).set(((1 + i) | 0), new $c_RTLong(currentWord__lo, currentWord__hi));
        while ((i >= 0)) {
          $n(newArray).set(i, $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, this.word__I__J(i), i));
          i = (((-1) + i) | 0);
        }
        return new $c_sci_BitSet$BitSetN(newArray);
      } else {
        return this;
      }
    }
  }
});
$c_sci_BitSet$BitSetN.prototype.filterImpl__F1__Z__O = (function(pred, isFlipped) {
  return this.filterImpl__F1__Z__sci_BitSet(pred, isFlipped);
});
$c_sci_BitSet$BitSetN.prototype.diff__sc_Set__sc_SetOps = (function(that) {
  return this.diff__sc_Set__sci_BitSet(that);
});
var $d_sci_BitSet$BitSetN = new $TypeData().initClass($c_sci_BitSet$BitSetN, "scala.collection.immutable.BitSet$BitSetN", ({
  sci_BitSet$BitSetN: 1,
  sci_BitSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  sci_SortedSetOps: 1,
  sci_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_BitSet: 1,
  sc_BitSetOps: 1,
  Ljava_io_Serializable: 1
}));
function $as_sci_TreeMap(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.TreeMap"));
}
function $isArrayOf_sci_TreeMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_TreeMap)));
}
function $asArrayOf_sci_TreeMap(obj, depth) {
  return (($isArrayOf_sci_TreeMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.TreeMap;", depth));
}
function $f_Lcats_effect_kernel_Async$KleisliAsync__unique__Lcats_data_Kleisli($thiz) {
  var thunk = new $c_sjsr_AnonFunction0((() => new $c_Lcats_effect_kernel_Unique$Token()));
  var hint = $thiz.Lcats_effect_kernel_Async$$anon$8__f_cats$effect$kernel$Sync$$Delay;
  return $f_Lcats_effect_kernel_Sync$KleisliSync__suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_data_Kleisli($thiz, hint, thunk);
}
function $f_Lcats_effect_kernel_Async$KleisliAsync__cont__Lcats_effect_kernel_Cont__Lcats_data_Kleisli($thiz, body) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((r) => $n($thiz.Lcats_effect_kernel_Async$$anon$8__f_F0$5).cont__Lcats_effect_kernel_Cont__O(new $c_Lcats_effect_kernel_Async$KleisliAsync$$anon$17(body, r))));
  return new $c_Lcats_data_Kleisli(run);
}
function $f_Lcats_effect_kernel_Async$KleisliAsync__executionContext__Lcats_data_Kleisli($thiz) {
  var this$1 = $m_Lcats_data_Kleisli$();
  var x = $n($thiz.Lcats_effect_kernel_Async$$anon$8__f_F0$5).executionContext__O();
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$1, x);
}
function $f_Lcats_effect_kernel_Async$KleisliAsync__never__Lcats_data_Kleisli($thiz) {
  var this$1 = $m_Lcats_data_Kleisli$();
  var x = $n($thiz.Lcats_effect_kernel_Async$$anon$8__f_F0$5).never__O();
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$1, x);
}
/** @constructor */
function $c_Lcats_effect_kernel_Async$$anon$8(F0$10) {
  this.Lcats_effect_kernel_Async$$anon$8__f_F0$5 = null;
  this.Lcats_effect_kernel_Async$$anon$8__f_cats$effect$kernel$Sync$$Delay = null;
  this.Lcats_effect_kernel_Async$$anon$8__f_cats$effect$kernel$Sync$$Blocking = null;
  this.Lcats_effect_kernel_Async$$anon$8__f_F0$5 = F0$10;
  $f_Lcats_effect_kernel_Sync__$init$__V(this);
}
$c_Lcats_effect_kernel_Async$$anon$8.prototype = new $h_O();
$c_Lcats_effect_kernel_Async$$anon$8.prototype.constructor = $c_Lcats_effect_kernel_Async$$anon$8;
/** @constructor */
function $h_Lcats_effect_kernel_Async$$anon$8() {
}
$h_Lcats_effect_kernel_Async$$anon$8.prototype = $c_Lcats_effect_kernel_Async$$anon$8.prototype;
$c_Lcats_effect_kernel_Async$$anon$8.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.unit__O = (function() {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_Async$$anon$8__f_F0$5;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  var this$3 = $m_Lcats_data_Kleisli$();
  var F = this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$3, (void 0), F);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.redeemWith__O__F1__F1__O = (function(fa, recover, bind) {
  return $f_Lcats_MonadError__redeemWith__O__F1__F1__O(this, fa, recover, bind);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.guarantee__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O(this, fa, fin);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Delay_$eq__Lcats_effect_kernel_Sync$Type$Delay$__V = (function(x$0) {
  this.Lcats_effect_kernel_Async$$anon$8__f_cats$effect$kernel$Sync$$Delay = x$0;
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Blocking_$eq__Lcats_effect_kernel_Sync$Type$Blocking$__V = (function(x$0) {
  this.Lcats_effect_kernel_Async$$anon$8__f_cats$effect$kernel$Sync$$Blocking = x$0;
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleOnce_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleOnce$__V = (function(x$0) {
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleMany_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleMany$__V = (function(x$0) {
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.delay__F0__O = (function(thunk) {
  var hint = this.Lcats_effect_kernel_Async$$anon$8__f_cats$effect$kernel$Sync$$Delay;
  return $f_Lcats_effect_kernel_Sync$KleisliSync__suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_data_Kleisli(this, hint, thunk);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.blocking__F0__O = (function(thunk) {
  var hint = this.Lcats_effect_kernel_Async$$anon$8__f_cats$effect$kernel$Sync$$Blocking;
  return $f_Lcats_effect_kernel_Sync$KleisliSync__suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_data_Kleisli(this, hint, thunk);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.asyncCheckAttempt__F1__O = (function(k) {
  return $f_Lcats_effect_kernel_Async__asyncCheckAttempt__F1__O(this, k);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.async__F1__O = (function(k) {
  return $f_Lcats_effect_kernel_Async__async__F1__O(this, k);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.async___F1__O = (function(k) {
  return $f_Lcats_effect_kernel_Async__async___F1__O(this, k);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.C__Lcats_effect_kernel_Clock = (function() {
  return this.Lcats_effect_kernel_Async$$anon$8__f_F0$5;
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.F__Lcats_effect_kernel_GenConcurrent = (function() {
  return this.Lcats_effect_kernel_Async$$anon$8__f_F0$5;
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.F__Lcats_effect_kernel_GenSpawn = (function() {
  return this.Lcats_effect_kernel_Async$$anon$8__f_F0$5;
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.F__Lcats_effect_kernel_Sync = (function() {
  return this.Lcats_effect_kernel_Async$$anon$8__f_F0$5;
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.F__Lcats_effect_kernel_MonadCancel = (function() {
  return this.Lcats_effect_kernel_Async$$anon$8__f_F0$5;
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.unique__O = (function() {
  return $f_Lcats_effect_kernel_Async$KleisliAsync__unique__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.cont__Lcats_effect_kernel_Cont__O = (function(body) {
  return $f_Lcats_effect_kernel_Async$KleisliAsync__cont__Lcats_effect_kernel_Cont__Lcats_data_Kleisli(this, body);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.executionContext__O = (function() {
  return $f_Lcats_effect_kernel_Async$KleisliAsync__executionContext__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.never__O = (function() {
  return $f_Lcats_effect_kernel_Async$KleisliAsync__never__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.ap__O__O__O = (function(ff, fa) {
  var ff$1 = $as_Lcats_data_Kleisli(ff);
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_Async$$anon$8__f_F0$5;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $n(ff$1).ap__Lcats_data_Kleisli__Lcats_Apply__Lcats_evidence_As__Lcats_data_Kleisli(fa$1, this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1, $m_Lcats_evidence_As$().Lcats_evidence_As$__f_reflAny);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.pure__O__O = (function(x) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_Async$$anon$8__f_F0$5;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  var this$3 = $m_Lcats_data_Kleisli$();
  var F = this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$3, x, F);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_Async$$anon$8__f_F0$5;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $n(fa$1).flatMap__F1__Lcats_FlatMap__Lcats_data_Kleisli(f, this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.tailRecM__O__F1__O = (function(a, f) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_Async$$anon$8__f_F0$5;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliFlatMap__tailRecM__O__F1__Lcats_data_Kleisli(this$2, a, f);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.raiseError__O__O = (function(e) {
  var e$1 = $as_jl_Throwable(e);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_Async$$anon$8__f_F0$5;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliApplicativeError__raiseError__O__Lcats_data_Kleisli(this$2, e$1);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_Async$$anon$8__f_F0$5;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliApplicativeError__handleErrorWith__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this$2, fa$1, f);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.ref__O__O = (function(a) {
  return $f_Lcats_effect_kernel_GenConcurrent$KleisliGenConcurrent__ref__O__Lcats_data_Kleisli(this, a);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.deferred__O = (function() {
  return $f_Lcats_effect_kernel_GenConcurrent$KleisliGenConcurrent__deferred__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.racePair__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__racePair__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.start__O__O = (function(fa) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__start__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.cede__O = (function() {
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__cede__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.both__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__both__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.raceOutcome__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__raceOutcome__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.suspend__Lcats_effect_kernel_Sync$Type__F0__O = (function(hint, thunk) {
  return $f_Lcats_effect_kernel_Sync$KleisliSync__suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_data_Kleisli(this, hint, thunk);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.realTime__O = (function() {
  return $f_Lcats_effect_kernel_Clock$KleisliClock__realTime__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.uncancelable__F1__O = (function(body) {
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__uncancelable__F1__Lcats_data_Kleisli(this, body);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.canceled__O = (function() {
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__canceled__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.onCancel__O__O__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fin$1 = $as_Lcats_data_Kleisli(fin);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__onCancel__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fin$1);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.forceR__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__forceR__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_Async$$anon$8.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__guaranteeCase__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this, fa$1, fin);
});
var $d_Lcats_effect_kernel_Async$$anon$8 = new $TypeData().initClass($c_Lcats_effect_kernel_Async$$anon$8, "cats.effect.kernel.Async$$anon$8", ({
  Lcats_effect_kernel_Async$$anon$8: 1,
  Lcats_effect_kernel_AsyncPlatform: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lcats_effect_kernel_ClockPlatform: 1,
  Lcats_effect_kernel_Clock: 1,
  Lcats_effect_kernel_Unique: 1,
  Lcats_Defer: 1,
  Lcats_effect_kernel_Sync: 1,
  Lcats_effect_kernel_GenSpawn: 1,
  Lcats_effect_kernel_GenConcurrent: 1,
  Lcats_effect_kernel_GenTemporal: 1,
  Lcats_effect_kernel_Async: 1,
  Lcats_effect_kernel_MonadCancel$KleisliMonadCancel: 1,
  Lcats_effect_kernel_Clock$KleisliClock: 1,
  Lcats_effect_kernel_Sync$KleisliSync: 1,
  Lcats_effect_kernel_GenSpawn$KleisliGenSpawn: 1,
  Lcats_effect_kernel_GenConcurrent$KleisliGenConcurrent: 1,
  Lcats_effect_kernel_GenTemporal$KleisliTemporal: 1,
  Lcats_effect_kernel_Async$KleisliAsync: 1
}));
function $p_scm_ArrayBuffer__foldl__I__I__O__F2__O($thiz, start, end, z, op) {
  while (true) {
    if ((start === end)) {
      return z;
    } else {
      var temp$start = ((1 + start) | 0);
      var temp$z = $n(op).apply__O__O__O(z, $n($thiz.scm_ArrayBuffer__f_array).get(start));
      start = temp$start;
      z = temp$z;
    }
  }
}
function $ct_scm_ArrayBuffer__AO__I__($thiz, initialElements, initialSize) {
  $thiz.scm_ArrayBuffer__f_mutationCount = 0;
  $thiz.scm_ArrayBuffer__f_array = initialElements;
  $thiz.scm_ArrayBuffer__f_size0 = initialSize;
  return $thiz;
}
function $ct_scm_ArrayBuffer__($thiz) {
  $ct_scm_ArrayBuffer__AO__I__($thiz, new $ac_O(16), 0);
  return $thiz;
}
function $ct_scm_ArrayBuffer__I__($thiz, initialSize) {
  $ct_scm_ArrayBuffer__AO__I__($thiz, new $ac_O(((initialSize > 1) ? initialSize : 1)), 0);
  return $thiz;
}
/** @constructor */
function $c_scm_ArrayBuffer() {
  this.scm_ArrayBuffer__f_mutationCount = 0;
  this.scm_ArrayBuffer__f_array = null;
  this.scm_ArrayBuffer__f_size0 = 0;
}
$c_scm_ArrayBuffer.prototype = new $h_scm_AbstractBuffer();
$c_scm_ArrayBuffer.prototype.constructor = $c_scm_ArrayBuffer;
/** @constructor */
function $h_scm_ArrayBuffer() {
}
$h_scm_ArrayBuffer.prototype = $c_scm_ArrayBuffer.prototype;
$c_scm_ArrayBuffer.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$c_scm_ArrayBuffer.prototype.prepended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__prepended__O__O(this, elem);
});
$c_scm_ArrayBuffer.prototype.appended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$c_scm_ArrayBuffer.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$c_scm_ArrayBuffer.prototype.prependedAll__sc_IterableOnce__O = (function(prefix) {
  return $f_sc_StrictOptimizedSeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$c_scm_ArrayBuffer.prototype.padTo__I__O__O = (function(len, elem) {
  return $f_sc_StrictOptimizedSeqOps__padTo__I__O__O(this, len, elem);
});
$c_scm_ArrayBuffer.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_scm_ArrayBuffer.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_scm_ArrayBuffer.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_scm_ArrayBuffer.prototype.flatten__F1__O = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$c_scm_ArrayBuffer.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_scm_ArrayBuffer.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_scm_ArrayBuffer.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$c_scm_ArrayBuffer.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_scm_ArrayBuffer.prototype.iterator__sc_Iterator = (function() {
  return $n(this.view__scm_ArrayBufferView()).iterator__sc_Iterator();
});
$c_scm_ArrayBuffer.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.view__scm_ArrayBufferView()).reverseIterator__sc_Iterator();
});
$c_scm_ArrayBuffer.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_scm_ArrayBuffer.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n);
});
$c_scm_ArrayBuffer.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$c_scm_ArrayBuffer.prototype.reverse__O = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this);
});
$c_scm_ArrayBuffer.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_scm_ArrayBuffer.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_scm_ArrayBuffer.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_scm_ArrayBuffer.prototype.lengthCompare__I__I = (function(len) {
  var x = this.scm_ArrayBuffer__f_size0;
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_scm_ArrayBuffer.prototype.knownSize__I = (function() {
  return this.scm_ArrayBuffer__f_size0;
});
$c_scm_ArrayBuffer.prototype.ensureSize__I__V = (function(n) {
  this.scm_ArrayBuffer__f_array = $m_scm_ArrayBuffer$().scala$collection$mutable$ArrayBuffer$$ensureSize__AO__I__I__AO(this.scm_ArrayBuffer__f_array, this.scm_ArrayBuffer__f_size0, n);
});
$c_scm_ArrayBuffer.prototype.sizeHint__I__V = (function(size) {
  if (((size > this.scm_ArrayBuffer__f_size0) && (size >= 1))) {
    this.ensureSize__I__V(size);
  }
});
$c_scm_ArrayBuffer.prototype.apply__I__O = (function(n) {
  var hi = ((1 + n) | 0);
  if ((n < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((n + " is out of bounds (min 0, max ") + (((-1) + this.scm_ArrayBuffer__f_size0) | 0)) + ")"));
  }
  if ((hi > this.scm_ArrayBuffer__f_size0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ((((((-1) + hi) | 0) + " is out of bounds (min 0, max ") + (((-1) + this.scm_ArrayBuffer__f_size0) | 0)) + ")"));
  }
  return $n(this.scm_ArrayBuffer__f_array).get(n);
});
$c_scm_ArrayBuffer.prototype.update__I__O__V = (function(index, elem) {
  var hi = ((1 + index) | 0);
  if ((index < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + (((-1) + this.scm_ArrayBuffer__f_size0) | 0)) + ")"));
  }
  if ((hi > this.scm_ArrayBuffer__f_size0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ((((((-1) + hi) | 0) + " is out of bounds (min 0, max ") + (((-1) + this.scm_ArrayBuffer__f_size0) | 0)) + ")"));
  }
  this.scm_ArrayBuffer__f_mutationCount = ((1 + this.scm_ArrayBuffer__f_mutationCount) | 0);
  $n(this.scm_ArrayBuffer__f_array).set(index, elem);
});
$c_scm_ArrayBuffer.prototype.length__I = (function() {
  return this.scm_ArrayBuffer__f_size0;
});
$c_scm_ArrayBuffer.prototype.view__scm_ArrayBufferView = (function() {
  return new $c_scm_ArrayBufferView(this, new $c_sjsr_AnonFunction0((() => this.scm_ArrayBuffer__f_mutationCount)));
});
$c_scm_ArrayBuffer.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_ArrayBuffer$();
});
$c_scm_ArrayBuffer.prototype.addOne__O__scm_ArrayBuffer = (function(elem) {
  this.scm_ArrayBuffer__f_mutationCount = ((1 + this.scm_ArrayBuffer__f_mutationCount) | 0);
  var newSize = ((1 + this.scm_ArrayBuffer__f_size0) | 0);
  this.ensureSize__I__V(newSize);
  this.scm_ArrayBuffer__f_size0 = newSize;
  this.update__I__O__V((((-1) + this.scm_ArrayBuffer__f_size0) | 0), elem);
  return this;
});
$c_scm_ArrayBuffer.prototype.addAll__sc_IterableOnce__scm_ArrayBuffer = (function(elems) {
  if ((elems instanceof $c_scm_ArrayBuffer)) {
    var x2 = $as_scm_ArrayBuffer(elems);
    var elemsLength = $n(x2).scm_ArrayBuffer__f_size0;
    if ((elemsLength > 0)) {
      this.scm_ArrayBuffer__f_mutationCount = ((1 + this.scm_ArrayBuffer__f_mutationCount) | 0);
      this.ensureSize__I__V(((this.scm_ArrayBuffer__f_size0 + elemsLength) | 0));
      $m_s_Array$().copy__O__I__O__I__I__V($n(x2).scm_ArrayBuffer__f_array, 0, this.scm_ArrayBuffer__f_array, this.scm_ArrayBuffer__f_size0, elemsLength);
      this.scm_ArrayBuffer__f_size0 = ((this.scm_ArrayBuffer__f_size0 + elemsLength) | 0);
    }
  } else {
    $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
  }
  return this;
});
$c_scm_ArrayBuffer.prototype.stringPrefix__T = (function() {
  return "ArrayBuffer";
});
$c_scm_ArrayBuffer.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var srcLen = this.scm_ArrayBuffer__f_size0;
  var destLen = $m_jl_reflect_Array$().getLength__O__I(xs);
  var x = ((len < srcLen) ? len : srcLen);
  var y = ((destLen - start) | 0);
  var x$1 = ((x < y) ? x : y);
  var copied = ((x$1 > 0) ? x$1 : 0);
  if ((copied > 0)) {
    $m_s_Array$().copy__O__I__O__I__I__V(this.scm_ArrayBuffer__f_array, 0, xs, start, copied);
  }
  return copied;
});
$c_scm_ArrayBuffer.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $p_scm_ArrayBuffer__foldl__I__I__O__F2__O(this, 0, this.scm_ArrayBuffer__f_size0, z, op);
});
$c_scm_ArrayBuffer.prototype.reduceLeft__F2__O = (function(op) {
  return ((this.scm_ArrayBuffer__f_size0 > 0) ? $p_scm_ArrayBuffer__foldl__I__I__O__F2__O(this, 1, this.scm_ArrayBuffer__f_size0, $n(this.scm_ArrayBuffer__f_array).get(0), op) : $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op));
});
$c_scm_ArrayBuffer.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_ArrayBuffer(elems);
});
$c_scm_ArrayBuffer.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ArrayBuffer(elem);
});
$c_scm_ArrayBuffer.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_ArrayBuffer$();
});
$c_scm_ArrayBuffer.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1));
});
function $as_scm_ArrayBuffer(obj) {
  return (((obj instanceof $c_scm_ArrayBuffer) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArrayBuffer"));
}
function $isArrayOf_scm_ArrayBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArrayBuffer)));
}
function $asArrayOf_scm_ArrayBuffer(obj, depth) {
  return (($isArrayOf_scm_ArrayBuffer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArrayBuffer;", depth));
}
var $d_scm_ArrayBuffer = new $TypeData().initClass($c_scm_ArrayBuffer, "scala.collection.mutable.ArrayBuffer", ({
  scm_ArrayBuffer: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_IndexedBuffer: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_scm_TreeSet__scm_RedBlackTree$Tree__s_math_Ordering__($thiz, tree, ordering) {
  $thiz.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree = tree;
  $thiz.scm_TreeSet__f_ordering = ordering;
  if ((ordering === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "ordering must not be null");
  }
  return $thiz;
}
function $ct_scm_TreeSet__s_math_Ordering__($thiz, ord) {
  $ct_scm_TreeSet__scm_RedBlackTree$Tree__s_math_Ordering__($thiz, new $c_scm_RedBlackTree$Tree(null, 0), ord);
  return $thiz;
}
/** @constructor */
function $c_scm_TreeSet() {
  this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree = null;
  this.scm_TreeSet__f_ordering = null;
}
$c_scm_TreeSet.prototype = new $h_scm_AbstractSet();
$c_scm_TreeSet.prototype.constructor = $c_scm_TreeSet;
/** @constructor */
function $h_scm_TreeSet() {
}
$h_scm_TreeSet.prototype = $c_scm_TreeSet.prototype;
$c_scm_TreeSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  var evidence$12 = this.scm_TreeSet__f_ordering;
  var b = new $c_scm_TreeSet$$anon$1(evidence$12);
  $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(b, this);
  $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(b, that);
  return b.result__scm_TreeSet();
});
$c_scm_TreeSet.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_scm_TreeSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_scm_TreeSet.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_scm_TreeSet.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_scm_TreeSet.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_scm_TreeSet.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$c_scm_TreeSet.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_scm_TreeSet.prototype.stringPrefix__T = (function() {
  return "SortedSet";
});
$c_scm_TreeSet.prototype.equals__O__Z = (function(that) {
  return $f_sc_SortedSet__equals__O__Z(this, that);
});
$c_scm_TreeSet.prototype.newSpecificBuilder__scm_Builder = (function() {
  var evidence$12 = this.scm_TreeSet__f_ordering;
  return new $c_scm_TreeSet$$anon$1(evidence$12);
});
$c_scm_TreeSet.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_SortedSetOps__max__s_math_Ordering__O(this, ord);
});
$c_scm_TreeSet.prototype.ordering__s_math_Ordering = (function() {
  return this.scm_TreeSet__f_ordering;
});
$c_scm_TreeSet.prototype.sortedIterableFactory__sc_SortedIterableFactory = (function() {
  return $m_scm_TreeSet$();
});
$c_scm_TreeSet.prototype.iterator__sc_Iterator = (function() {
  var tree = this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree;
  var start = $m_s_None$();
  var end = $m_s_None$();
  var evidence$4 = this.scm_TreeSet__f_ordering;
  return new $c_scm_RedBlackTree$KeysIterator(tree, start, end, evidence$4);
});
$c_scm_TreeSet.prototype.addOne__O__scm_TreeSet = (function(elem) {
  $m_scm_RedBlackTree$().insert__scm_RedBlackTree$Tree__O__O__s_math_Ordering__V(this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree, elem, null, this.scm_TreeSet__f_ordering);
  return this;
});
$c_scm_TreeSet.prototype.subtractOne__O__scm_TreeSet = (function(elem) {
  $m_scm_RedBlackTree$().delete__scm_RedBlackTree$Tree__O__s_math_Ordering__V(this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree, elem, this.scm_TreeSet__f_ordering);
  return this;
});
$c_scm_TreeSet.prototype.contains__O__Z = (function(elem) {
  return $m_scm_RedBlackTree$().contains__scm_RedBlackTree$Tree__O__s_math_Ordering__Z(this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree, elem, this.scm_TreeSet__f_ordering);
});
$c_scm_TreeSet.prototype.className__T = (function() {
  return "TreeSet";
});
$c_scm_TreeSet.prototype.size__I = (function() {
  var tree = this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree;
  return $n(tree).scm_RedBlackTree$Tree__f_size;
});
$c_scm_TreeSet.prototype.knownSize__I = (function() {
  var tree = this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree;
  return $n(tree).scm_RedBlackTree$Tree__f_size;
});
$c_scm_TreeSet.prototype.isEmpty__Z = (function() {
  return $m_scm_RedBlackTree$().isEmpty__scm_RedBlackTree$Tree__Z(this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree);
});
$c_scm_TreeSet.prototype.head__O = (function() {
  return $n($m_scm_RedBlackTree$().minKey__scm_RedBlackTree$Tree__s_Option(this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree)).get__O();
});
$c_scm_TreeSet.prototype.last__O = (function() {
  return $n($m_scm_RedBlackTree$().maxKey__scm_RedBlackTree$Tree__s_Option(this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree)).get__O();
});
$c_scm_TreeSet.prototype.foreach__F1__V = (function(f) {
  $m_scm_RedBlackTree$().foreachKey__scm_RedBlackTree$Tree__F1__V(this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree, f);
});
$c_scm_TreeSet.prototype.empty__O = (function() {
  var evidence$6 = this.scm_TreeSet__f_ordering;
  return $ct_scm_TreeSet__s_math_Ordering__(new $c_scm_TreeSet(), evidence$6);
});
$c_scm_TreeSet.prototype.empty__sc_IterableOps = (function() {
  var evidence$6 = this.scm_TreeSet__f_ordering;
  return $ct_scm_TreeSet__s_math_Ordering__(new $c_scm_TreeSet(), evidence$6);
});
$c_scm_TreeSet.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_scm_TreeSet$();
  var evidence$5 = this.scm_TreeSet__f_ordering;
  return this$1.from__sc_IterableOnce__s_math_Ordering__scm_TreeSet(coll, evidence$5);
});
$c_scm_TreeSet.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  var this$1 = $m_scm_TreeSet$();
  var evidence$5 = this.scm_TreeSet__f_ordering;
  return this$1.from__sc_IterableOnce__s_math_Ordering__scm_TreeSet(coll, evidence$5);
});
$c_scm_TreeSet.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_TreeSet(elem);
});
$c_scm_TreeSet.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_TreeSet(elem);
});
function $as_scm_TreeSet(obj) {
  return (((obj instanceof $c_scm_TreeSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.TreeSet"));
}
function $isArrayOf_scm_TreeSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_TreeSet)));
}
function $asArrayOf_scm_TreeSet(obj, depth) {
  return (($isArrayOf_scm_TreeSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.TreeSet;", depth));
}
var $d_scm_TreeSet = new $TypeData().initClass($c_scm_TreeSet, "scala.collection.mutable.TreeSet", ({
  scm_TreeSet: 1,
  scm_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  scm_Set: 1,
  scm_Iterable: 1,
  scm_SetOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  scm_SortedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_sjs_js_WrappedArray__sjs_js_Array__($thiz, array) {
  $thiz.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array = array;
  return $thiz;
}
function $ct_sjs_js_WrappedArray__($thiz) {
  $ct_sjs_js_WrappedArray__sjs_js_Array__($thiz, []);
  return $thiz;
}
/** @constructor */
function $c_sjs_js_WrappedArray() {
  this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array = null;
}
$c_sjs_js_WrappedArray.prototype = new $h_scm_AbstractBuffer();
$c_sjs_js_WrappedArray.prototype.constructor = $c_sjs_js_WrappedArray;
/** @constructor */
function $h_sjs_js_WrappedArray() {
}
$h_sjs_js_WrappedArray.prototype = $c_sjs_js_WrappedArray.prototype;
$c_sjs_js_WrappedArray.prototype.sizeHint__I__V = (function(size) {
});
$c_sjs_js_WrappedArray.prototype.stringPrefix__T = (function() {
  return "IndexedSeq";
});
$c_sjs_js_WrappedArray.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1);
});
$c_sjs_js_WrappedArray.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_sjs_js_WrappedArray.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sjs_js_WrappedArray.prototype.prepended__O__O = (function(elem) {
  return $f_sc_IndexedSeqOps__prepended__O__O(this, elem);
});
$c_sjs_js_WrappedArray.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n);
});
$c_sjs_js_WrappedArray.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$c_sjs_js_WrappedArray.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__dropRight__I__O(this, n);
});
$c_sjs_js_WrappedArray.prototype.map__F1__O = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f);
});
$c_sjs_js_WrappedArray.prototype.reverse__O = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this);
});
$c_sjs_js_WrappedArray.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sjs_js_WrappedArray.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sjs_js_WrappedArray.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sjs_js_WrappedArray.prototype.lengthCompare__I__I = (function(len) {
  var x = $uI(this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.length);
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sjs_js_WrappedArray.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$c_sjs_js_WrappedArray.prototype.appended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$c_sjs_js_WrappedArray.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$c_sjs_js_WrappedArray.prototype.prependedAll__sc_IterableOnce__O = (function(prefix) {
  return $f_sc_StrictOptimizedSeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$c_sjs_js_WrappedArray.prototype.padTo__I__O__O = (function(len, elem) {
  return $f_sc_StrictOptimizedSeqOps__padTo__I__O__O(this, len, elem);
});
$c_sjs_js_WrappedArray.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_sjs_js_WrappedArray.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sjs_js_WrappedArray.prototype.flatten__F1__O = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$c_sjs_js_WrappedArray.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_sjs_js_WrappedArray.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_sjs_js_WrappedArray.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$c_sjs_js_WrappedArray.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sjs_js_WrappedArray$();
});
$c_sjs_js_WrappedArray.prototype.apply__I__O = (function(index) {
  return this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array[index];
});
$c_sjs_js_WrappedArray.prototype.length__I = (function() {
  return $uI(this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.length);
});
$c_sjs_js_WrappedArray.prototype.knownSize__I = (function() {
  return $uI(this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.length);
});
$c_sjs_js_WrappedArray.prototype.className__T = (function() {
  return "WrappedArray";
});
$c_sjs_js_WrappedArray.prototype.result__O = (function() {
  return this;
});
$c_sjs_js_WrappedArray.prototype.addOne__O__scm_Growable = (function(elem) {
  this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.push(elem);
  return this;
});
$c_sjs_js_WrappedArray.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array[index];
});
$c_sjs_js_WrappedArray.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sjs_js_WrappedArray$();
});
function $as_sjs_js_WrappedArray(obj) {
  return (((obj instanceof $c_sjs_js_WrappedArray) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.scalajs.js.WrappedArray"));
}
function $isArrayOf_sjs_js_WrappedArray(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjs_js_WrappedArray)));
}
function $asArrayOf_sjs_js_WrappedArray(obj, depth) {
  return (($isArrayOf_sjs_js_WrappedArray(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.scalajs.js.WrappedArray;", depth));
}
var $d_sjs_js_WrappedArray = new $TypeData().initClass($c_sjs_js_WrappedArray, "scala.scalajs.js.WrappedArray", ({
  sjs_js_WrappedArray: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  scm_IndexedBuffer: 1,
  scm_Builder: 1,
  Ljava_io_Serializable: 1
}));
function $ct_Lcats_effect_kernel_ResourceAsync__($thiz) {
  $f_Lcats_effect_kernel_Sync__$init$__V($thiz);
  return $thiz;
}
/** @constructor */
function $c_Lcats_effect_kernel_ResourceAsync() {
  this.Lcats_effect_kernel_ResourceAsync__f_cats$effect$kernel$Sync$$Delay = null;
  this.Lcats_effect_kernel_ResourceAsync__f_cats$effect$kernel$Sync$$Blocking = null;
}
$c_Lcats_effect_kernel_ResourceAsync.prototype = new $h_Lcats_effect_kernel_ResourceConcurrent();
$c_Lcats_effect_kernel_ResourceAsync.prototype.constructor = $c_Lcats_effect_kernel_ResourceAsync;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceAsync() {
}
$h_Lcats_effect_kernel_ResourceAsync.prototype = $c_Lcats_effect_kernel_ResourceAsync.prototype;
$c_Lcats_effect_kernel_ResourceAsync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Delay_$eq__Lcats_effect_kernel_Sync$Type$Delay$__V = (function(x$0) {
  this.Lcats_effect_kernel_ResourceAsync__f_cats$effect$kernel$Sync$$Delay = x$0;
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Blocking_$eq__Lcats_effect_kernel_Sync$Type$Blocking$__V = (function(x$0) {
  this.Lcats_effect_kernel_ResourceAsync__f_cats$effect$kernel$Sync$$Blocking = x$0;
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleOnce_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleOnce$__V = (function(x$0) {
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleMany_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleMany$__V = (function(x$0) {
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.delay__F0__O = (function(thunk) {
  var hint = this.Lcats_effect_kernel_ResourceAsync__f_cats$effect$kernel$Sync$$Delay;
  return $m_Lcats_effect_kernel_Resource$().suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_effect_kernel_Sync__Lcats_effect_kernel_Resource(hint, thunk, this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1);
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.blocking__F0__O = (function(thunk) {
  var hint = this.Lcats_effect_kernel_ResourceAsync__f_cats$effect$kernel$Sync$$Blocking;
  return $m_Lcats_effect_kernel_Resource$().suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_effect_kernel_Sync__Lcats_effect_kernel_Resource(hint, thunk, this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1);
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.asyncCheckAttempt__F1__O = (function(k) {
  return $f_Lcats_effect_kernel_Async__asyncCheckAttempt__F1__O(this, k);
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.async__F1__O = (function(k) {
  return $f_Lcats_effect_kernel_Async__async__F1__O(this, k);
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.async___F1__O = (function(k) {
  return $f_Lcats_effect_kernel_Async__async___F1__O(this, k);
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.unique__Lcats_effect_kernel_Resource = (function() {
  var F = this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1;
  var fa = $n(F).unique__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.never__Lcats_effect_kernel_Resource = (function() {
  var F = this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1;
  var fa = $n(F).never__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.unique__O = (function() {
  var F = this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1;
  var fa = $n(F).unique__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.never__O = (function() {
  var F = this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1;
  var fa = $n(F).never__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.cont__Lcats_effect_kernel_Cont__O = (function(body) {
  return $m_Lcats_effect_kernel_Resource$().cont__Lcats_effect_kernel_Cont__Lcats_effect_kernel_Async__Lcats_effect_kernel_Resource(body, this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1);
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.executionContext__O = (function() {
  var F = this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1;
  var fa = $n(F).executionContext__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.suspend__Lcats_effect_kernel_Sync$Type__F0__O = (function(hint, thunk) {
  return $m_Lcats_effect_kernel_Resource$().suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_effect_kernel_Sync__Lcats_effect_kernel_Resource(hint, thunk, this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1);
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.realTime__O = (function() {
  var F = this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1;
  var fa = $n(F).realTime__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
});
function $p_scm_ArrayDeque__reset__AO__I__I__V($thiz, array, start, end) {
  var assertion = (($n(array).u.length & (((-1) + $n(array).u.length) | 0)) === 0);
  if ((!assertion)) {
    throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "assertion failed: Array.length must be power of 2");
  }
  var until = $n(array).u.length;
  if (((start < 0) || (start >= until))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((start + " is out of bounds (min 0, max ") + (((-1) + until) | 0)) + ")"));
  }
  var until$1 = $n(array).u.length;
  if (((end < 0) || (end >= until$1))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((end + " is out of bounds (min 0, max ") + (((-1) + until$1) | 0)) + ")"));
  }
  $thiz.scm_ArrayDeque__f_array = array;
  $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = start;
  $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = end;
}
function $ct_scm_ArrayDeque__AO__I__I__($thiz, array, start, end) {
  $thiz.scm_ArrayDeque__f_array = array;
  $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = start;
  $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = end;
  $p_scm_ArrayDeque__reset__AO__I__I__V($thiz, $thiz.scm_ArrayDeque__f_array, $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start, $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end);
  return $thiz;
}
function $ct_scm_ArrayDeque__I__($thiz, initialSize) {
  $ct_scm_ArrayDeque__AO__I__I__($thiz, $m_scm_ArrayDeque$().alloc__I__AO(initialSize), 0, 0);
  return $thiz;
}
/** @constructor */
function $c_scm_ArrayDeque() {
  this.scm_ArrayDeque__f_array = null;
  this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = 0;
  this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = 0;
}
$c_scm_ArrayDeque.prototype = new $h_scm_AbstractBuffer();
$c_scm_ArrayDeque.prototype.constructor = $c_scm_ArrayDeque;
/** @constructor */
function $h_scm_ArrayDeque() {
}
$h_scm_ArrayDeque.prototype = $c_scm_ArrayDeque.prototype;
$c_scm_ArrayDeque.prototype.reverse__O = (function() {
  return $f_scm_ArrayDequeOps__reverse__O(this);
});
$c_scm_ArrayDeque.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$c_scm_ArrayDeque.prototype.prepended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__prepended__O__O(this, elem);
});
$c_scm_ArrayDeque.prototype.appended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$c_scm_ArrayDeque.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$c_scm_ArrayDeque.prototype.prependedAll__sc_IterableOnce__O = (function(prefix) {
  return $f_sc_StrictOptimizedSeqOps__prependedAll__sc_IterableOnce__O(this, prefix);
});
$c_scm_ArrayDeque.prototype.padTo__I__O__O = (function(len, elem) {
  return $f_sc_StrictOptimizedSeqOps__padTo__I__O__O(this, len, elem);
});
$c_scm_ArrayDeque.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_scm_ArrayDeque.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_scm_ArrayDeque.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_scm_ArrayDeque.prototype.flatten__F1__O = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$c_scm_ArrayDeque.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_scm_ArrayDeque.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_scm_ArrayDeque.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$c_scm_ArrayDeque.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_scm_ArrayDeque.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1);
});
$c_scm_ArrayDeque.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_scm_ArrayDeque.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_scm_ArrayDeque.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n);
});
$c_scm_ArrayDeque.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$c_scm_ArrayDeque.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_scm_ArrayDeque.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_scm_ArrayDeque.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_scm_ArrayDeque.prototype.lengthCompare__I__I = (function(len) {
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var x = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0));
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_scm_ArrayDeque.prototype.knownSize__I = (function() {
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  return (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0));
});
$c_scm_ArrayDeque.prototype.apply__I__O = (function(idx) {
  var idx$1 = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var until = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0));
  if (((idx < 0) || (idx >= until))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((idx + " is out of bounds (min 0, max ") + (((-1) + until) | 0)) + ")"));
  }
  return $n(this.scm_ArrayDeque__f_array).get((((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + idx) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0)));
});
$c_scm_ArrayDeque.prototype.addOne__O__scm_ArrayDeque = (function(elem) {
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var hint = ((1 + (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0))) | 0);
  var idx$1 = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  if (((hint > (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0))) && (hint >= $n(this.scm_ArrayDeque__f_array).u.length))) {
    this.scala$collection$mutable$ArrayDeque$$resize__I__V(hint);
  }
  $n(this.scm_ArrayDeque__f_array).set(this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end, elem);
  this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = (((1 + this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0));
  return this;
});
$c_scm_ArrayDeque.prototype.addAll__sc_IterableOnce__scm_ArrayDeque = (function(elems) {
  var x1 = $n(elems).knownSize__I();
  if ((x1 > 0)) {
    var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
    var hint = ((x1 + (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0))) | 0);
    var idx$1 = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
    if (((hint > (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0))) && (hint >= $n(this.scm_ArrayDeque__f_array).u.length))) {
      this.scala$collection$mutable$ArrayDeque$$resize__I__V(hint);
    }
    var this$1 = $n($n(elems).iterator__sc_Iterator());
    while (this$1.hasNext__Z()) {
      var arg1 = this$1.next__O();
      $n(this.scm_ArrayDeque__f_array).set(this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end, arg1);
      this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = (((1 + this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0));
    }
  } else {
    var this$2 = $n($n(elems).iterator__sc_Iterator());
    while (this$2.hasNext__Z()) {
      var arg1$1 = this$2.next__O();
      this.addOne__O__scm_ArrayDeque(arg1$1);
    }
  }
  return this;
});
$c_scm_ArrayDeque.prototype.removeHead__Z__O = (function(resizeInternalRepr) {
  if (this.isEmpty__Z()) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty collection");
  } else {
    var elem = $n(this.scm_ArrayDeque__f_array).get(this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start);
    $n(this.scm_ArrayDeque__f_array).set(this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start, null);
    this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = (((1 + this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0));
    if (resizeInternalRepr) {
      var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
      this.scala$collection$mutable$ArrayDeque$$resize__I__V((((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0)));
    }
    return elem;
  }
});
$c_scm_ArrayDeque.prototype.length__I = (function() {
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  return (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0));
});
$c_scm_ArrayDeque.prototype.isEmpty__Z = (function() {
  return (this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start === this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end);
});
$c_scm_ArrayDeque.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_ArrayDeque$();
});
$c_scm_ArrayDeque.prototype.ofArray__AO__I__scm_ArrayDeque = (function(array, end) {
  return $ct_scm_ArrayDeque__AO__I__I__(new $c_scm_ArrayDeque(), array, 0, end);
});
$c_scm_ArrayDeque.prototype.copyToArray__O__I__I__I = (function(dest, destStart, len) {
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var srcLen = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0));
  var destLen = $m_jl_reflect_Array$().getLength__O__I(dest);
  var x = ((len < srcLen) ? len : srcLen);
  var y = ((destLen - destStart) | 0);
  var x$1 = ((x < y) ? x : y);
  var copied = ((x$1 > 0) ? x$1 : 0);
  if ((copied > 0)) {
    $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, 0, dest, destStart, len);
  }
  return copied;
});
$c_scm_ArrayDeque.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$1) {
  var $x_1 = $n(evidence$1);
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var dest = $n($x_1).newArray__I__O((((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0)));
  var idx$1 = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var maxItems = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0));
  return $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, 0, dest, 0, maxItems);
});
$c_scm_ArrayDeque.prototype.scala$collection$mutable$ArrayDeque$$resize__I__V = (function(len) {
  if (((len >= $n(this.scm_ArrayDeque__f_array).u.length) || (($n(this.scm_ArrayDeque__f_array).u.length > 16) && ((($n(this.scm_ArrayDeque__f_array).u.length - len) | 0) > len)))) {
    var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
    var n = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $n(this.scm_ArrayDeque__f_array).u.length) | 0));
    var dest = $m_scm_ArrayDeque$().alloc__I__AO(len);
    var array2 = $asArrayOf_O($f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, 0, dest, 0, n), 1);
    $p_scm_ArrayDeque__reset__AO__I__I__V(this, array2, 0, n);
  }
});
$c_scm_ArrayDeque.prototype.stringPrefix__T = (function() {
  return "ArrayDeque";
});
$c_scm_ArrayDeque.prototype.ofArray__AO__I__O = (function(array, end) {
  return this.ofArray__AO__I__scm_ArrayDeque(array, end);
});
$c_scm_ArrayDeque.prototype.iterableFactory__sc_IterableFactory = (function() {
  return this.iterableFactory__sc_SeqFactory();
});
$c_scm_ArrayDeque.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_ArrayDeque(elems);
});
$c_scm_ArrayDeque.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ArrayDeque(elem);
});
$c_scm_ArrayDeque.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1));
});
function $as_scm_ArrayDeque(obj) {
  return (((obj instanceof $c_scm_ArrayDeque) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArrayDeque"));
}
function $isArrayOf_scm_ArrayDeque(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArrayDeque)));
}
function $asArrayOf_scm_ArrayDeque(obj, depth) {
  return (($isArrayOf_scm_ArrayDeque(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArrayDeque;", depth));
}
var $d_scm_ArrayDeque = new $TypeData().initClass($c_scm_ArrayDeque, "scala.collection.mutable.ArrayDeque", ({
  scm_ArrayDeque: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_IndexedBuffer: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scm_ArrayDequeOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_scm_BitSet__AJ__($thiz, elems) {
  $thiz.scm_BitSet__f_elems = elems;
  return $thiz;
}
function $ct_scm_BitSet__I__($thiz, initSize) {
  var x = (((63 + initSize) | 0) >> 6);
  $ct_scm_BitSet__AJ__($thiz, new $ac_J(((x > 1) ? x : 1)));
  return $thiz;
}
function $ct_scm_BitSet__($thiz) {
  $ct_scm_BitSet__I__($thiz, 0);
  return $thiz;
}
/** @constructor */
function $c_scm_BitSet() {
  this.scm_BitSet__f_elems = null;
}
$c_scm_BitSet.prototype = new $h_scm_AbstractSet();
$c_scm_BitSet.prototype.constructor = $c_scm_BitSet;
/** @constructor */
function $h_scm_BitSet() {
}
$h_scm_BitSet.prototype = $c_scm_BitSet.prototype;
$c_scm_BitSet.prototype.stringPrefix__T = (function() {
  return "BitSet";
});
$c_scm_BitSet.prototype.scala$collection$BitSetOps$$super$max__s_math_Ordering__I = (function(ord) {
  return $uI($f_sc_SortedSetOps__max__s_math_Ordering__O(this, ord));
});
$c_scm_BitSet.prototype.scala$collection$BitSetOps$$super$concat__sc_IterableOnce__sc_BitSet = (function(that) {
  var b = $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_BitSet__(new $c_scm_BitSet()));
  b.addAll__sc_IterableOnce__scm_GrowableBuilder(this);
  b.addAll__sc_IterableOnce__scm_GrowableBuilder(that);
  return $as_sc_BitSet($as_sc_SetOps(b.scm_GrowableBuilder__f_elems));
});
$c_scm_BitSet.prototype.scala$collection$BitSetOps$$super$diff__sc_Set__sc_BitSet = (function(that) {
  return $as_sc_BitSet($f_scm_SetOps__diff__sc_Set__scm_SetOps(this, that));
});
$c_scm_BitSet.prototype.ordering__s_math_Ordering = (function() {
  return $m_s_math_Ordering$Int$();
});
$c_scm_BitSet.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_BitSetOps$$anon$1(this, 0);
});
$c_scm_BitSet.prototype.size__I = (function() {
  return $f_sc_BitSetOps__size__I(this);
});
$c_scm_BitSet.prototype.isEmpty__Z = (function() {
  return $f_sc_BitSetOps__isEmpty__Z(this);
});
$c_scm_BitSet.prototype.foreach__F1__V = (function(f) {
  $f_sc_BitSetOps__foreach__F1__V(this, f);
});
$c_scm_BitSet.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_BitSetOps__partition__F1__T2(this, p);
});
$c_scm_BitSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_scm_BitSet.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_scm_BitSet.prototype.zip__sc_IterableOnce__O = (function(that) {
  return $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$c_scm_BitSet.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__scm_BitSet(pred, false);
});
$c_scm_BitSet.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__scm_BitSet(pred, true);
});
$c_scm_BitSet.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_scm_BitSet.prototype.sortedIterableFactory__sc_SortedIterableFactory = (function() {
  return $m_scm_SortedSet$();
});
$c_scm_BitSet.prototype.equals__O__Z = (function(that) {
  return $f_sc_SortedSet__equals__O__Z(this, that);
});
$c_scm_BitSet.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_BitSet__(new $c_scm_BitSet()));
});
$c_scm_BitSet.prototype.nwords__I = (function() {
  return $n(this.scm_BitSet__f_elems).u.length;
});
$c_scm_BitSet.prototype.word__I__J = (function(idx) {
  return ((idx < this.nwords__I()) ? $n(this.scm_BitSet__f_elems).get(idx) : $L0);
});
$c_scm_BitSet.prototype.fromBitMaskNoCopy__AJ__scm_BitSet = (function(elems) {
  return (($n(elems).u.length === 0) ? $ct_scm_BitSet__(new $c_scm_BitSet()) : $ct_scm_BitSet__AJ__(new $c_scm_BitSet(), elems));
});
$c_scm_BitSet.prototype.addOne__I__scm_BitSet = (function(elem) {
  $m_s_Predef$().require__Z__V((elem >= 0));
  if ((!$f_sc_BitSetOps__contains__I__Z(this, elem))) {
    var idx = (elem >> 6);
    var this$1 = this.word__I__J(idx);
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (this$1.RTLong__f_lo | lo);
    var hi$1 = (this$1.RTLong__f_hi | hi);
    this.updateWord__I__J__V(idx, new $c_RTLong(lo$1, hi$1));
  }
  return this;
});
$c_scm_BitSet.prototype.subtractOne__I__scm_BitSet = (function(elem) {
  $m_s_Predef$().require__Z__V((elem >= 0));
  if ($f_sc_BitSetOps__contains__I__Z(this, elem)) {
    var idx = (elem >> 6);
    var this$1 = this.word__I__J(idx);
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (~lo);
    var hi$1 = (~hi);
    var lo$2 = (this$1.RTLong__f_lo & lo$1);
    var hi$2 = (this$1.RTLong__f_hi & hi$1);
    this.updateWord__I__J__V(idx, new $c_RTLong(lo$2, hi$2));
  }
  return this;
});
$c_scm_BitSet.prototype.updateWord__I__J__V = (function(idx, w) {
  this.ensureCapacity__I__V(idx);
  $n(this.scm_BitSet__f_elems).set(idx, w);
});
$c_scm_BitSet.prototype.ensureCapacity__I__V = (function(idx) {
  $m_s_Predef$().require__Z__V((idx < 33554432));
  if ((idx >= this.nwords__I())) {
    var newlen = this.nwords__I();
    while ((idx >= newlen)) {
      var x = (newlen << 1);
      newlen = ((x < 33554432) ? x : 33554432);
    }
    var elems1 = new $ac_J(newlen);
    $m_s_Array$().copy__O__I__O__I__I__V(this.scm_BitSet__f_elems, 0, elems1, 0, this.nwords__I());
    this.scm_BitSet__f_elems = elems1;
  }
});
$c_scm_BitSet.prototype.$bar$eq__sc_BitSet__scm_BitSet = (function(other) {
  this.ensureCapacity__I__V((((-1) + $n(other).nwords__I()) | 0));
  var i = 0;
  var othernwords = $n(other).nwords__I();
  while ((i < othernwords)) {
    var $x_2 = $n(this.scm_BitSet__f_elems);
    var $x_1 = i;
    var this$1 = $n(this.scm_BitSet__f_elems).get(i);
    var b = $n(other).word__I__J(i);
    var lo = (this$1.RTLong__f_lo | b.RTLong__f_lo);
    var hi = (this$1.RTLong__f_hi | b.RTLong__f_hi);
    $x_2.set($x_1, new $c_RTLong(lo, hi));
    i = ((1 + i) | 0);
  }
  return this;
});
$c_scm_BitSet.prototype.addAll__sc_IterableOnce__scm_BitSet = (function(xs) {
  if ($is_sc_BitSet(xs)) {
    var x2 = $as_sc_BitSet(xs);
    return this.$bar$eq__sc_BitSet__scm_BitSet(x2);
  } else if (false) {
    var x3 = $as_sci_Range(xs);
    var this$1 = $n(x3);
    if ((!this$1.sci_Range__f_isEmpty)) {
      var start = $n(x3).min__s_math_Ordering__I($m_s_math_Ordering$Int$());
      if ((start >= 0)) {
        var end = $n(x3).max__s_math_Ordering__I($m_s_math_Ordering$Int$());
        var endIdx = (end >> 6);
        this.ensureCapacity__I__V(endIdx);
        if ((($n(x3).sci_Range__f_step === 1) || ($n(x3).sci_Range__f_step === (-1)))) {
          var startIdx = (start >> 6);
          var wordStart = (startIdx << 6);
          var n = ((start - wordStart) | 0);
          var lo = (((32 & n) === 0) ? ((-1) << n) : 0);
          var hi = (((32 & n) === 0) ? (((2147483647 >>> ((31 - n) | 0)) | 0) | ((-1) << n)) : ((-1) << n));
          if ((endIdx > startIdx)) {
            var ev$1 = this.scm_BitSet__f_elems;
            var $x_1 = $n(ev$1);
            var this$2 = $n(ev$1).get(startIdx);
            var lo$1 = (this$2.RTLong__f_lo | lo);
            var hi$1 = (this$2.RTLong__f_hi | hi);
            $x_1.set(startIdx, new $c_RTLong(lo$1, hi$1));
            var a = this.scm_BitSet__f_elems;
            var fromIndex = ((1 + startIdx) | 0);
            $m_ju_Arrays$().fill__AJ__I__I__J__V(a, fromIndex, endIdx, new $c_RTLong((-1), (-1)));
            var ev$2 = this.scm_BitSet__f_elems;
            var $x_2 = $n(ev$2);
            var this$3 = $n(ev$2).get(endIdx);
            var n$1 = ((63 - ((end - (endIdx << 6)) | 0)) | 0);
            var lo$2 = (((32 & n$1) === 0) ? ((((-1) >>> n$1) | 0) | ((-2) << ((31 - n$1) | 0))) : (((-1) >>> n$1) | 0));
            var hi$2 = (((32 & n$1) === 0) ? (((-1) >>> n$1) | 0) : 0);
            var lo$3 = (this$3.RTLong__f_lo | lo$2);
            var hi$3 = (this$3.RTLong__f_hi | hi$2);
            $x_2.set(endIdx, new $c_RTLong(lo$3, hi$3));
          } else {
            var ev$3 = this.scm_BitSet__f_elems;
            var $x_3 = $n(ev$3);
            var this$4 = $n(ev$3).get(endIdx);
            var n$2 = ((63 - ((end - wordStart) | 0)) | 0);
            var lo$4 = (((32 & n$2) === 0) ? ((((-1) >>> n$2) | 0) | ((-2) << ((31 - n$2) | 0))) : (((-1) >>> n$2) | 0));
            var hi$4 = (((32 & n$2) === 0) ? (((-1) >>> n$2) | 0) : 0);
            var lo$5 = (lo & lo$4);
            var hi$5 = (hi & hi$4);
            var lo$6 = (this$4.RTLong__f_lo | lo$5);
            var hi$6 = (this$4.RTLong__f_hi | hi$5);
            $x_3.set(endIdx, new $c_RTLong(lo$6, hi$6));
          }
        } else {
          $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, x3);
        }
      } else {
        $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, x3);
      }
    }
    return this;
  } else if ($is_sc_SortedSet(xs)) {
    var x4 = $as_sc_SortedSet(xs);
    var this$5 = $n(x4);
    if ((!this$5.isEmpty__Z())) {
      var ord = $n(x4).ordering__s_math_Ordering();
      if ((ord === $m_s_math_Ordering$Int$())) {
        var this$6 = $n(x4);
        this.ensureCapacity__I__V(($uI(this$6.last__O()) >> 6));
      } else {
        var this$7 = $m_s_math_Ordering$Int$();
        if ((ord === this$7.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse)) {
          var this$8 = $n(x4);
          this.ensureCapacity__I__V(($uI(this$8.head__O()) >> 6));
        }
      }
      var iter = $n(x4).iterator__sc_Iterator();
      while ($n(iter).hasNext__Z()) {
        this.addOne__I__scm_BitSet($uI($n(iter).next__O()));
      }
    }
    return this;
  } else {
    return $as_scm_BitSet($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs));
  }
});
$c_scm_BitSet.prototype.subsetOf__sc_Set__Z = (function(that) {
  if ($is_sc_BitSet(that)) {
    var x2 = $as_sc_BitSet(that);
    var thisnwords = this.nwords__I();
    var bsnwords = $n(x2).nwords__I();
    var minWords = ((thisnwords < bsnwords) ? thisnwords : bsnwords);
    var i = bsnwords;
    while ((i < thisnwords)) {
      var this$2 = this.word__I__J(i);
      if ((!((this$2.RTLong__f_lo === 0) && (this$2.RTLong__f_hi === 0)))) {
        return false;
      }
      i = ((1 + i) | 0);
    }
    var j = 0;
    while ((j < minWords)) {
      var this$3 = this.word__I__J(j);
      var b = $n(x2).word__I__J(j);
      var lo = (~b.RTLong__f_lo);
      var hi = (~b.RTLong__f_hi);
      var lo$1 = (this$3.RTLong__f_lo & lo);
      var hi$1 = (this$3.RTLong__f_hi & hi);
      if ((!((lo$1 === 0) && (hi$1 === 0)))) {
        return false;
      }
      j = ((1 + j) | 0);
    }
    return true;
  } else {
    return $f_sc_IterableOnceOps__forall__F1__Z(this, that);
  }
});
$c_scm_BitSet.prototype.diff__sc_Set__scm_BitSet = (function(that) {
  if ($is_sc_BitSet(that)) {
    var x2 = $as_sc_BitSet(that);
    var bsnwords = $n(x2).nwords__I();
    var thisnwords = this.nwords__I();
    if ((bsnwords >= thisnwords)) {
      var i = (((-1) + thisnwords) | 0);
      var currentWord__lo = 0;
      var currentWord__hi = 0;
      while (true) {
        if ((i >= 0)) {
          var this$1__lo = currentWord__lo;
          var this$1__hi = currentWord__hi;
          var $x_2 = ((this$1__lo === 0) && (this$1__hi === 0));
        } else {
          var $x_2 = false;
        }
        if ($x_2) {
          var t = this.word__I__J(i);
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          var b = $n(x2).word__I__J(i);
          var lo$1 = (~b.RTLong__f_lo);
          var hi$1 = (~b.RTLong__f_hi);
          var lo$2 = (lo & lo$1);
          var hi$2 = (hi & hi$1);
          var $x_1__lo = lo$2;
          var $x_1__hi = hi$2;
          currentWord__lo = $x_1__lo;
          currentWord__hi = $x_1__hi;
          i = (((-1) + i) | 0);
        } else {
          break;
        }
      }
      if ((i < 0)) {
        return this.fromBitMaskNoCopy__AJ__scm_BitSet(new $ac_J([new $c_RTLong(currentWord__lo, currentWord__hi)]));
      } else {
        var minimumNonZeroIndex = ((1 + i) | 0);
        var xs = this.scm_BitSet__f_elems;
        var n = ((1 + minimumNonZeroIndex) | 0);
        var newArray = $asArrayOf_J($m_sc_ArrayOps$().slice$extension__O__I__I__O(xs, 0, n), 1);
        $n(newArray).set(((1 + i) | 0), new $c_RTLong(currentWord__lo, currentWord__hi));
        while ((i >= 0)) {
          var $x_4 = $n(newArray);
          var $x_3 = i;
          var this$4 = this.word__I__J(i);
          var b$1 = $n(x2).word__I__J(i);
          var lo$3 = (~b$1.RTLong__f_lo);
          var hi$3 = (~b$1.RTLong__f_hi);
          var lo$4 = (this$4.RTLong__f_lo & lo$3);
          var hi$4 = (this$4.RTLong__f_hi & hi$3);
          $x_4.set($x_3, new $c_RTLong(lo$4, hi$4));
          i = (((-1) + i) | 0);
        }
        return this.fromBitMaskNoCopy__AJ__scm_BitSet(newArray);
      }
    } else {
      var this$5 = $n(this.scm_BitSet__f_elems);
      var newElems = $n(this$5).clone__O();
      var i$2 = (((-1) + bsnwords) | 0);
      while ((i$2 >= 0)) {
        var $x_6 = $n(newElems);
        var $x_5 = i$2;
        var this$6 = this.word__I__J(i$2);
        var b$2 = $n(x2).word__I__J(i$2);
        var lo$5 = (~b$2.RTLong__f_lo);
        var hi$5 = (~b$2.RTLong__f_hi);
        var lo$6 = (this$6.RTLong__f_lo & lo$5);
        var hi$6 = (this$6.RTLong__f_hi & hi$5);
        $x_6.set($x_5, new $c_RTLong(lo$6, hi$6));
        i$2 = (((-1) + i$2) | 0);
      }
      return this.fromBitMaskNoCopy__AJ__scm_BitSet(newElems);
    }
  } else {
    return $as_scm_BitSet($f_sc_BitSetOps__diff__sc_Set__sc_BitSet(this, that));
  }
});
$c_scm_BitSet.prototype.filterImpl__F1__Z__scm_BitSet = (function(pred, isFlipped) {
  var i = (((-1) + this.nwords__I()) | 0);
  var newArray = null;
  while ((i >= 0)) {
    var t = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, this.word__I__J(i), i);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    if ((!((lo === 0) && (hi === 0)))) {
      if ((newArray === null)) {
        newArray = new $ac_J(((1 + i) | 0));
      }
      $n(newArray).set(i, new $c_RTLong(lo, hi));
    }
    i = (((-1) + i) | 0);
  }
  return ((newArray === null) ? $ct_scm_BitSet__(new $c_scm_BitSet()) : this.fromBitMaskNoCopy__AJ__scm_BitSet(newArray));
});
$c_scm_BitSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  return $f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet(this, that);
});
$c_scm_BitSet.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_BitSetOps__max__s_math_Ordering__I(this, ord);
});
$c_scm_BitSet.prototype.contains__O__Z = (function(elem) {
  var elem$1 = $uI(elem);
  return $f_sc_BitSetOps__contains__I__Z(this, elem$1);
});
$c_scm_BitSet.prototype.filterImpl__F1__Z__O = (function(pred, isFlipped) {
  return this.filterImpl__F1__Z__scm_BitSet(pred, isFlipped);
});
$c_scm_BitSet.prototype.diff__sc_Set__sc_SetOps = (function(that) {
  return this.diff__sc_Set__scm_BitSet(that);
});
$c_scm_BitSet.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_BitSet(elems);
});
$c_scm_BitSet.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__I__scm_BitSet($uI(elem));
});
$c_scm_BitSet.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__I__scm_BitSet($uI(elem));
});
$c_scm_BitSet.prototype.fromBitMaskNoCopy__AJ__sc_BitSet = (function(elems) {
  return this.fromBitMaskNoCopy__AJ__scm_BitSet(elems);
});
$c_scm_BitSet.prototype.empty__O = (function() {
  return $ct_scm_BitSet__(new $c_scm_BitSet());
});
$c_scm_BitSet.prototype.empty__sc_IterableOps = (function() {
  return $ct_scm_BitSet__(new $c_scm_BitSet());
});
$c_scm_BitSet.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var empty = $ct_scm_BitSet__(new $c_scm_BitSet());
  return empty.addAll__sc_IterableOnce__scm_BitSet(coll);
});
$c_scm_BitSet.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  var empty = $ct_scm_BitSet__(new $c_scm_BitSet());
  return empty.addAll__sc_IterableOnce__scm_BitSet(coll);
});
function $as_scm_BitSet(obj) {
  return (((obj instanceof $c_scm_BitSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.BitSet"));
}
function $isArrayOf_scm_BitSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_BitSet)));
}
function $asArrayOf_scm_BitSet(obj, depth) {
  return (($isArrayOf_scm_BitSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.BitSet;", depth));
}
var $d_scm_BitSet = new $TypeData().initClass($c_scm_BitSet, "scala.collection.mutable.BitSet", ({
  scm_BitSet: 1,
  scm_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  scm_Set: 1,
  scm_Iterable: 1,
  scm_SetOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  scm_SortedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_BitSet: 1,
  sc_BitSetOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_ResourceHOInstances0$$anon$9(F0$9) {
  this.Lcats_effect_kernel_ResourceAsync__f_cats$effect$kernel$Sync$$Delay = null;
  this.Lcats_effect_kernel_ResourceAsync__f_cats$effect$kernel$Sync$$Blocking = null;
  this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1 = null;
  this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1 = F0$9;
  $ct_Lcats_effect_kernel_ResourceAsync__(this);
}
$c_Lcats_effect_kernel_ResourceHOInstances0$$anon$9.prototype = new $h_Lcats_effect_kernel_ResourceAsync();
$c_Lcats_effect_kernel_ResourceHOInstances0$$anon$9.prototype.constructor = $c_Lcats_effect_kernel_ResourceHOInstances0$$anon$9;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceHOInstances0$$anon$9() {
}
$h_Lcats_effect_kernel_ResourceHOInstances0$$anon$9.prototype = $c_Lcats_effect_kernel_ResourceHOInstances0$$anon$9.prototype;
$c_Lcats_effect_kernel_ResourceHOInstances0$$anon$9.prototype.F__Lcats_effect_kernel_GenConcurrent = (function() {
  return this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1;
});
$c_Lcats_effect_kernel_ResourceHOInstances0$$anon$9.prototype.F__Lcats_effect_kernel_MonadCancel = (function() {
  return this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1;
});
$c_Lcats_effect_kernel_ResourceHOInstances0$$anon$9.prototype.F__Lcats_MonadError = (function() {
  return this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1;
});
var $d_Lcats_effect_kernel_ResourceHOInstances0$$anon$9 = new $TypeData().initClass($c_Lcats_effect_kernel_ResourceHOInstances0$$anon$9, "cats.effect.kernel.ResourceHOInstances0$$anon$9", ({
  Lcats_effect_kernel_ResourceHOInstances0$$anon$9: 1,
  Lcats_effect_kernel_ResourceAsync: 1,
  Lcats_effect_kernel_ResourceConcurrent: 1,
  Lcats_effect_kernel_ResourceMonadCancel: 1,
  Lcats_effect_kernel_ResourceMonadError: 1,
  Lcats_effect_kernel_ResourceMonad: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_StackSafeMonad: 1,
  Lcats_ApplicativeError: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lcats_effect_kernel_Unique: 1,
  Lcats_effect_kernel_GenSpawn: 1,
  Lcats_effect_kernel_GenConcurrent: 1,
  Lcats_effect_kernel_ClockPlatform: 1,
  Lcats_effect_kernel_Clock: 1,
  Lcats_effect_kernel_ResourceClock: 1,
  Lcats_effect_kernel_GenTemporal: 1,
  Lcats_effect_kernel_ResourceTemporal: 1,
  Lcats_Defer: 1,
  Lcats_effect_kernel_Sync: 1,
  Lcats_effect_kernel_ResourceSync: 1,
  Lcats_effect_kernel_AsyncPlatform: 1,
  Lcats_effect_kernel_Async: 1
}));
function $ct_scm_Queue__AO__I__I__($thiz, array, start, end) {
  $ct_scm_ArrayDeque__AO__I__I__($thiz, array, start, end);
  return $thiz;
}
function $ct_scm_Queue__I__($thiz, initialSize) {
  var array = $m_scm_ArrayDeque$().alloc__I__AO(initialSize);
  $ct_scm_ArrayDeque__AO__I__I__($thiz, array, 0, 0);
  return $thiz;
}
/** @constructor */
function $c_scm_Queue() {
  this.scm_ArrayDeque__f_array = null;
  this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = 0;
  this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = 0;
}
$c_scm_Queue.prototype = new $h_scm_ArrayDeque();
$c_scm_Queue.prototype.constructor = $c_scm_Queue;
/** @constructor */
function $h_scm_Queue() {
}
$h_scm_Queue.prototype = $c_scm_Queue.prototype;
$c_scm_Queue.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_Queue$();
});
$c_scm_Queue.prototype.stringPrefix__T = (function() {
  return "Queue";
});
$c_scm_Queue.prototype.ofArray__AO__I__O = (function(array, end) {
  return $ct_scm_Queue__AO__I__I__(new $c_scm_Queue(), array, 0, end);
});
$c_scm_Queue.prototype.ofArray__AO__I__scm_ArrayDeque = (function(array, end) {
  return $ct_scm_Queue__AO__I__I__(new $c_scm_Queue(), array, 0, end);
});
$c_scm_Queue.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_Queue$();
});
function $as_scm_Queue(obj) {
  return (((obj instanceof $c_scm_Queue) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Queue"));
}
function $isArrayOf_scm_Queue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Queue)));
}
function $asArrayOf_scm_Queue(obj, depth) {
  return (($isArrayOf_scm_Queue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Queue;", depth));
}
var $d_scm_Queue = new $TypeData().initClass($c_scm_Queue, "scala.collection.mutable.Queue", ({
  scm_Queue: 1,
  scm_ArrayDeque: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_IndexedBuffer: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scm_ArrayDequeOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_Lcats_instances_AllInstancesBinCompat__($thiz) {
  $f_Lcats_kernel_instances_IntInstances__$init$__V($thiz);
  var this$1 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$1);
  $f_Lcats_kernel_instances_ByteInstances__$init$__V($thiz);
  var this$2 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$2);
  var this$3 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$3);
  $f_Lcats_kernel_instances_LongInstances__$init$__V($thiz);
  var this$4 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$4);
  $f_Lcats_kernel_instances_ShortInstances__$init$__V($thiz);
  var this$5 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$5);
  $f_Lcats_kernel_instances_FloatInstances__$init$__V($thiz);
  var this$6 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$6);
  $f_Lcats_kernel_instances_DoubleInstances__$init$__V($thiz);
  var this$7 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$7);
  var this$8 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$8);
  $f_Lcats_kernel_instances_UnitInstances__$init$__V($thiz);
  var this$9 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$9);
  $f_Lcats_kernel_instances_BigIntInstances__$init$__V($thiz);
  var this$10 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$10);
  $f_Lcats_kernel_instances_BigDecimalInstances__$init$__V($thiz);
  var this$11 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$11);
  $f_Lcats_kernel_instances_BitSetInstances__$init$__V($thiz);
  $f_Lcats_instances_Function1Instances__$init$__V($thiz);
  $f_Lcats_instances_InvariantMonoidalInstances__$init$__V($thiz);
  $f_Lcats_instances_LazyListInstances__$init$__V($thiz);
  new $c_Lcats_instances_ListInstances$$anon$1();
  new $c_Lcats_instances_OptionInstances$$anon$1();
  $f_Lcats_kernel_instances_StringInstances__$init$__V($thiz);
  var this$12 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$12);
  var this$13 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$13);
  var this$14 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$14);
  new $c_Lcats_instances_VectorInstances$$anon$1();
  new $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1();
  new $c_Lcats_instances_OptionInstancesBinCompat0$$anon$3();
  new $c_Lcats_instances_ListInstancesBinCompat0$$anon$6();
  new $c_Lcats_instances_VectorInstancesBinCompat0$$anon$6();
  new $c_Lcats_instances_StreamInstancesBinCompat0$$anon$7();
  $f_Lcats_kernel_instances_DurationInstances__$init$__V($thiz);
  $f_Lcats_kernel_instances_FiniteDurationInstances__$init$__V($thiz);
  var this$15 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$15);
  var this$16 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$16);
  $f_Lcats_instances_SeqInstances__$init$__V($thiz);
  $f_Lcats_instances_InvariantInstances__$init$__V($thiz);
  return $thiz;
}
/** @constructor */
function $c_Lcats_instances_AllInstancesBinCompat() {
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForFunction1 = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForLazyList = null;
}
$c_Lcats_instances_AllInstancesBinCompat.prototype = new $h_O();
$c_Lcats_instances_AllInstancesBinCompat.prototype.constructor = $c_Lcats_instances_AllInstancesBinCompat;
/** @constructor */
function $h_Lcats_instances_AllInstancesBinCompat() {
}
$h_Lcats_instances_AllInstancesBinCompat.prototype = $c_Lcats_instances_AllInstancesBinCompat.prototype;
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$IntInstances$_setter_$catsKernelStdOrderForInt_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$IntInstances$_setter_$catsKernelStdGroupForInt_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdOrderForByte_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdGroupForByte_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdOrderForLong_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdGroupForLong_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdOrderForShort_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdGroupForShort_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdOrderForFloat_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdGroupForFloat_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdOrderForDouble_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdGroupForDouble_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdOrderForUnit_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdAlgebraForUnit_$eq__Lcats_kernel_BoundedSemilattice__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdOrderForBigInt_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdGroupForBigInt_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdOrderForBigDecimal_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdGroupForBigDecimal_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdOrderForBitSet_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdSemilatticeForBitSet_$eq__Lcats_kernel_BoundedSemilattice__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.catsStdInstancesForFunction1__Lcats_arrow_ArrowChoice = (function() {
  return this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForFunction1;
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$Function1Instances$_setter_$catsStdInstancesForFunction1_$eq__Lcats_arrow_ArrowChoice__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForFunction1 = x$0;
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$Function1Instances$_setter_$catsStdMonoidKForFunction1_$eq__Lcats_MonoidK__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalCommutativeSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.catsStdInstancesForLazyList__Lcats_Align = (function() {
  return this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForLazyList;
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$LazyListInstances$_setter_$catsStdInstancesForLazyList_$eq__Lcats_Align__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForLazyList = x$0;
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$LazyListInstances$_setter_$catsStdTraverseFilterForLazyList_$eq__Lcats_TraverseFilter__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdOrderForString_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdMonoidForString_$eq__Lcats_kernel_Monoid__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdOrderForDuration_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdGroupForDuration_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdOrderForFiniteDuration_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdGroupForFiniteDuration_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$SeqInstances$_setter_$catsStdInstancesForSeq_$eq__Lcats_Align__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$SeqInstances$_setter_$catsStdTraverseFilterForSeq_$eq__Lcats_TraverseFilter__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$InvariantInstances$_setter_$catsInvariantForNumeric_$eq__Lcats_Invariant__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$InvariantInstances$_setter_$catsInvariantForIntegral_$eq__Lcats_Invariant__V = (function(x$0) {
});
/** @constructor */
function $c_Lcats_instances_package$all$() {
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForFunction1 = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForLazyList = null;
  $ct_Lcats_instances_AllInstancesBinCompat__(this);
}
$c_Lcats_instances_package$all$.prototype = new $h_Lcats_instances_AllInstancesBinCompat();
$c_Lcats_instances_package$all$.prototype.constructor = $c_Lcats_instances_package$all$;
/** @constructor */
function $h_Lcats_instances_package$all$() {
}
$h_Lcats_instances_package$all$.prototype = $c_Lcats_instances_package$all$.prototype;
var $d_Lcats_instances_package$all$ = new $TypeData().initClass($c_Lcats_instances_package$all$, "cats.instances.package$all$", ({
  Lcats_instances_package$all$: 1,
  Lcats_instances_AllInstancesBinCompat: 1,
  Lcats_kernel_instances_IntInstances: 1,
  Lcats_instances_IntInstances: 1,
  Lcats_kernel_instances_ByteInstances: 1,
  Lcats_instances_ByteInstances: 1,
  Lcats_kernel_instances_CharInstances: 1,
  Lcats_instances_CharInstances: 1,
  Lcats_kernel_instances_LongInstances: 1,
  Lcats_instances_LongInstances: 1,
  Lcats_kernel_instances_ShortInstances: 1,
  Lcats_instances_ShortInstances: 1,
  Lcats_kernel_instances_FloatInstances: 1,
  Lcats_instances_FloatInstances: 1,
  Lcats_kernel_instances_DoubleInstances: 1,
  Lcats_instances_DoubleInstances: 1,
  Lcats_kernel_instances_BooleanInstances: 1,
  Lcats_instances_BooleanInstances: 1,
  Lcats_kernel_instances_UnitInstances: 1,
  Lcats_instances_UnitInstances: 1,
  Lcats_instances_Tuple2Instances4: 1,
  Lcats_instances_Tuple2Instances3: 1,
  Lcats_instances_Tuple2Instances2: 1,
  Lcats_instances_Tuple2Instances1: 1,
  Lcats_instances_Tuple2Instances: 1,
  Lcats_kernel_instances_TupleInstances3: 1,
  Lcats_kernel_instances_TupleInstances2: 1,
  Lcats_kernel_instances_TupleInstances1: 1,
  Lcats_kernel_instances_TupleInstances: 1,
  Lcats_instances_TupleInstances: 1,
  Lcats_instances_AnyValInstances: 1,
  Lcats_kernel_instances_ArraySeqInstances$ArraySeqInstances2: 1,
  Lcats_kernel_instances_ArraySeqInstances$ArraySeqInstances1: 1,
  Lcats_kernel_instances_ArraySeqInstances: 1,
  Lcats_instances_ArraySeqInstances: 1,
  Lcats_kernel_instances_BigIntInstances: 1,
  Lcats_instances_BigIntInstances: 1,
  Lcats_kernel_instances_BigDecimalInstances: 1,
  Lcats_instances_BigDecimalInstances: 1,
  Lcats_kernel_instances_BitSetInstances: 1,
  Lcats_instances_BitSetInstances: 1,
  Lcats_kernel_instances_EitherInstances1: 1,
  Lcats_kernel_instances_EitherInstances0: 1,
  Lcats_kernel_instances_EitherInstances: 1,
  Lcats_instances_EitherInstances: 1,
  Lcats_kernel_EqToEquivConversion: 1,
  Lcats_kernel_instances_EqInstances: 1,
  Lcats_instances_EqInstances: 1,
  Lcats_instances_EquivInstances: 1,
  Lcats_kernel_instances_FunctionInstances4: 1,
  Lcats_kernel_instances_FunctionInstances3: 1,
  Lcats_kernel_instances_FunctionInstances2: 1,
  Lcats_kernel_instances_FunctionInstances1: 1,
  Lcats_kernel_instances_FunctionInstances0: 1,
  Lcats_kernel_instances_FunctionInstances: 1,
  Lcats_instances_Function0Instances0: 1,
  Lcats_instances_Function0Instances: 1,
  Lcats_instances_Function1Instances0: 1,
  Lcats_instances_Function1Instances: 1,
  Lcats_instances_FunctionInstances: 1,
  Lcats_instances_FutureInstances2: 1,
  Lcats_instances_FutureInstances1: 1,
  Lcats_instances_FutureInstances: 1,
  Lcats_kernel_HashToHashingConversion: 1,
  Lcats_kernel_instances_HashInstances: 1,
  Lcats_instances_HashInstances: 1,
  Lcats_instances_InvariantMonoidalInstances: 1,
  Lcats_kernel_instances_LazyListInstances2: 1,
  Lcats_kernel_instances_LazyListInstances1: 1,
  Lcats_kernel_instances_LazyListInstances: 1,
  Lcats_instances_LazyListInstances: 1,
  Lcats_kernel_instances_ListInstances2: 1,
  Lcats_kernel_instances_ListInstances1: 1,
  Lcats_kernel_instances_ListInstances: 1,
  Lcats_instances_ListInstances: 1,
  Lcats_kernel_instances_MapInstances1: 1,
  Lcats_kernel_instances_MapInstances: 1,
  Lcats_instances_MapInstances: 1,
  Lcats_kernel_instances_OptionInstances2: 1,
  Lcats_kernel_instances_OptionInstances1: 1,
  Lcats_kernel_instances_OptionInstances0: 1,
  Lcats_kernel_instances_OptionInstances: 1,
  Lcats_instances_OptionInstances: 1,
  Lcats_kernel_OrderToOrderingConversion: 1,
  Lcats_kernel_instances_OrderInstances: 1,
  Lcats_instances_OrderInstances: 1,
  Lcats_instances_OrderingInstances: 1,
  Lcats_instances_ParallelInstances1: 1,
  Lcats_instances_ParallelInstances: 1,
  Lcats_kernel_PartialOrderToPartialOrderingConversion: 1,
  Lcats_kernel_instances_PartialOrderInstances: 1,
  Lcats_instances_PartialOrderInstances: 1,
  Lcats_instances_PartialOrderingInstances: 1,
  Lcats_kernel_instances_QueueInstances2: 1,
  Lcats_kernel_instances_QueueInstances1: 1,
  Lcats_kernel_instances_QueueInstances: 1,
  Lcats_instances_QueueInstances: 1,
  Lcats_kernel_instances_SetInstances1: 1,
  Lcats_kernel_instances_SetInstances: 1,
  Lcats_instances_SetInstances: 1,
  Lcats_instances_SortedMapInstances1: 1,
  Lcats_instances_SortedMapInstances2: 1,
  Lcats_instances_SortedMapInstances: 1,
  Lcats_instances_SortedSetInstances1: 1,
  Lcats_instances_SortedSetInstances: 1,
  Lcats_instances_ShowInstances: 1,
  Lcats_kernel_instances_StreamInstances2: 1,
  Lcats_kernel_instances_StreamInstances1: 1,
  Lcats_kernel_instances_StreamInstances: 1,
  Lcats_instances_StreamInstances: 1,
  Lcats_kernel_instances_StringInstances: 1,
  Lcats_instances_StringInstances: 1,
  Lcats_kernel_instances_SymbolInstances: 1,
  Lcats_instances_SymbolInstances: 1,
  Lcats_instances_TailRecInstances: 1,
  Lcats_instances_TryInstances2: 1,
  Lcats_instances_TryInstances1: 1,
  Lcats_instances_TryInstances: 1,
  Lcats_kernel_instances_UUIDInstances: 1,
  Lcats_instances_UUIDInstances: 1,
  Lcats_kernel_instances_VectorInstances2: 1,
  Lcats_kernel_instances_VectorInstances1: 1,
  Lcats_kernel_instances_VectorInstances: 1,
  Lcats_instances_VectorInstances: 1,
  Lcats_instances_PartialFunctionInstances: 1,
  Lcats_instances_AllInstances: 1,
  Lcats_instances_FunctionInstancesBinCompat0: 1,
  Lcats_instances_Tuple2InstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat0: 1,
  Lcats_instances_OptionInstancesBinCompat0: 1,
  Lcats_instances_ListInstancesBinCompat0: 1,
  Lcats_instances_VectorInstancesBinCompat0: 1,
  Lcats_instances_StreamInstancesBinCompat0: 1,
  Lcats_instances_MapInstancesBinCompat0: 1,
  Lcats_instances_SortedMapInstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat1: 1,
  Lcats_kernel_instances_DurationInstances: 1,
  Lcats_instances_DurationInstances: 1,
  Lcats_kernel_instances_FiniteDurationInstances: 1,
  Lcats_instances_FiniteDurationInstances: 1,
  Lcats_instances_AllInstancesBinCompat2: 1,
  Lcats_instances_CoreDurationInstances: 1,
  Lcats_instances_CoreFiniteDurationInstances: 1,
  Lcats_instances_AllCoreDurationInstances: 1,
  Lcats_instances_AllInstancesBinCompat3: 1,
  Lcats_instances_SortedMapInstancesBinCompat1: 1,
  Lcats_instances_MapInstancesBinCompat1: 1,
  Lcats_instances_AllInstancesBinCompat4: 1,
  Lcats_instances_SortedSetInstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat5: 1,
  Lcats_kernel_instances_SortedSetInstances1: 1,
  Lcats_kernel_instances_SortedSetInstances: 1,
  Lcats_instances_LowPrioritySortedSetInstancesBinCompat1: 1,
  Lcats_instances_SortedSetInstancesBinCompat1: 1,
  Lcats_kernel_instances_SortedMapInstances1: 1,
  Lcats_kernel_instances_SortedMapInstances2: 1,
  Lcats_kernel_instances_SortedMapInstances3: 1,
  Lcats_kernel_instances_SortedMapInstances: 1,
  Lcats_instances_SortedMapInstancesBinCompat2: 1,
  Lcats_instances_AllInstancesBinCompat6: 1,
  Lcats_kernel_instances_SeqInstances2: 1,
  Lcats_kernel_instances_SeqInstances1: 1,
  Lcats_kernel_instances_SeqInstances: 1,
  Lcats_instances_SeqInstances: 1,
  Lcats_instances_AllInstancesBinCompat7: 1,
  Lcats_instances_InvariantInstances: 1,
  Lcats_instances_AllInstancesBinCompat8: 1,
  Lcats_kernel_instances_DeadlineInstances: 1,
  Lcats_instances_DeadlineInstances: 1,
  Lcats_instances_AllInstancesBinCompat9: 1
}));
var $n_Lcats_instances_package$all$;
function $m_Lcats_instances_package$all$() {
  if ((!$n_Lcats_instances_package$all$)) {
    $n_Lcats_instances_package$all$ = new $c_Lcats_instances_package$all$();
  }
  return $n_Lcats_instances_package$all$;
}
/** @constructor */
function $c_Lcats_implicits$() {
  this.Lcats_implicits$__f_catsStdInstancesForFunction1 = null;
  this.Lcats_implicits$__f_catsStdInstancesForLazyList = null;
  $n_Lcats_implicits$ = this;
  $f_Lcats_kernel_instances_IntInstances__$init$__V(this);
  var this$1 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$1);
  $f_Lcats_kernel_instances_ByteInstances__$init$__V(this);
  var this$2 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$2);
  var this$3 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$3);
  $f_Lcats_kernel_instances_LongInstances__$init$__V(this);
  var this$4 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$4);
  $f_Lcats_kernel_instances_ShortInstances__$init$__V(this);
  var this$5 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$5);
  $f_Lcats_kernel_instances_FloatInstances__$init$__V(this);
  var this$6 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$6);
  $f_Lcats_kernel_instances_DoubleInstances__$init$__V(this);
  var this$7 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$7);
  var this$8 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$8);
  $f_Lcats_kernel_instances_UnitInstances__$init$__V(this);
  var this$9 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$9);
  $f_Lcats_kernel_instances_BigIntInstances__$init$__V(this);
  var this$10 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$10);
  $f_Lcats_kernel_instances_BigDecimalInstances__$init$__V(this);
  var this$11 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$11);
  $f_Lcats_kernel_instances_BitSetInstances__$init$__V(this);
  $f_Lcats_instances_Function1Instances__$init$__V(this);
  $f_Lcats_instances_InvariantMonoidalInstances__$init$__V(this);
  $f_Lcats_instances_LazyListInstances__$init$__V(this);
  new $c_Lcats_instances_ListInstances$$anon$1();
  new $c_Lcats_instances_OptionInstances$$anon$1();
  $f_Lcats_kernel_instances_StringInstances__$init$__V(this);
  var this$12 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$12);
  var this$13 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$13);
  var this$14 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$14);
  new $c_Lcats_instances_VectorInstances$$anon$1();
  new $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1();
  new $c_Lcats_instances_OptionInstancesBinCompat0$$anon$3();
  new $c_Lcats_instances_ListInstancesBinCompat0$$anon$6();
  new $c_Lcats_instances_VectorInstancesBinCompat0$$anon$6();
  new $c_Lcats_instances_StreamInstancesBinCompat0$$anon$7();
  $f_Lcats_kernel_instances_DurationInstances__$init$__V(this);
  $f_Lcats_kernel_instances_FiniteDurationInstances__$init$__V(this);
  var this$15 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$15);
  var this$16 = $m_Lcats_Show$();
  new $c_Lcats_Show$$anon$5(this$16);
}
$c_Lcats_implicits$.prototype = new $h_O();
$c_Lcats_implicits$.prototype.constructor = $c_Lcats_implicits$;
/** @constructor */
function $h_Lcats_implicits$() {
}
$h_Lcats_implicits$.prototype = $c_Lcats_implicits$.prototype;
$c_Lcats_implicits$.prototype.cats$kernel$instances$IntInstances$_setter_$catsKernelStdOrderForInt_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$IntInstances$_setter_$catsKernelStdGroupForInt_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdOrderForByte_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdGroupForByte_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdOrderForLong_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdGroupForLong_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdOrderForShort_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdGroupForShort_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdOrderForFloat_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdGroupForFloat_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdOrderForDouble_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdGroupForDouble_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdOrderForUnit_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdAlgebraForUnit_$eq__Lcats_kernel_BoundedSemilattice__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdOrderForBigInt_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdGroupForBigInt_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdOrderForBigDecimal_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdGroupForBigDecimal_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdOrderForBitSet_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdSemilatticeForBitSet_$eq__Lcats_kernel_BoundedSemilattice__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.catsStdInstancesForFunction1__Lcats_arrow_ArrowChoice = (function() {
  return this.Lcats_implicits$__f_catsStdInstancesForFunction1;
});
$c_Lcats_implicits$.prototype.cats$instances$Function1Instances$_setter_$catsStdInstancesForFunction1_$eq__Lcats_arrow_ArrowChoice__V = (function(x$0) {
  this.Lcats_implicits$__f_catsStdInstancesForFunction1 = x$0;
});
$c_Lcats_implicits$.prototype.cats$instances$Function1Instances$_setter_$catsStdMonoidKForFunction1_$eq__Lcats_MonoidK__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalCommutativeSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.catsStdInstancesForLazyList__Lcats_Align = (function() {
  return this.Lcats_implicits$__f_catsStdInstancesForLazyList;
});
$c_Lcats_implicits$.prototype.cats$instances$LazyListInstances$_setter_$catsStdInstancesForLazyList_$eq__Lcats_Align__V = (function(x$0) {
  this.Lcats_implicits$__f_catsStdInstancesForLazyList = x$0;
});
$c_Lcats_implicits$.prototype.cats$instances$LazyListInstances$_setter_$catsStdTraverseFilterForLazyList_$eq__Lcats_TraverseFilter__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdOrderForString_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdMonoidForString_$eq__Lcats_kernel_Monoid__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdOrderForDuration_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdGroupForDuration_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdOrderForFiniteDuration_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdGroupForFiniteDuration_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
var $d_Lcats_implicits$ = new $TypeData().initClass($c_Lcats_implicits$, "cats.implicits$", ({
  Lcats_implicits$: 1,
  Lcats_syntax_AlternativeSyntax: 1,
  Lcats_syntax_NonEmptyAlternativeSyntax: 1,
  Ljava_io_Serializable: 1,
  Lcats_Align$ToAlignOps: 1,
  Lcats_syntax_AlignSyntax: 1,
  Lcats_syntax_ApplicativeSyntax: 1,
  Lcats_syntax_ApplicativeErrorSyntax: 1,
  Lcats_syntax_TupleSemigroupalSyntax: 1,
  Lcats_syntax_ApplySyntax: 1,
  Lcats_arrow_Arrow$ToArrowOps: 1,
  Lcats_syntax_ArrowSyntax: 1,
  Lcats_arrow_ArrowChoice$ToArrowChoiceOps: 1,
  Lcats_syntax_ArrowChoiceSyntax: 1,
  Lcats_Bifunctor$ToBifunctorOps: 1,
  Lcats_syntax_BifunctorSyntax: 1,
  Lcats_Bifoldable$ToBifoldableOps: 1,
  Lcats_syntax_BifoldableSyntax: 1,
  Lcats_syntax_BitraverseSyntax1: 1,
  Lcats_syntax_BitraverseSyntax: 1,
  Lcats_syntax_SemigroupalSyntax: 1,
  Lcats_CoflatMap$ToCoflatMapOps: 1,
  Lcats_syntax_CoflatMapSyntax: 1,
  Lcats_Comonad$ToComonadOps: 1,
  Lcats_syntax_ComonadSyntax: 1,
  Lcats_arrow_Compose$ToComposeOps: 1,
  Lcats_syntax_ComposeSyntax: 1,
  Lcats_Contravariant$ToContravariantOps: 1,
  Lcats_syntax_ContravariantSyntax: 1,
  Lcats_Distributive$ToDistributiveOps: 1,
  Lcats_syntax_DistributiveSyntax: 1,
  Lcats_syntax_ContravariantMonoidalSyntax: 1,
  Lcats_syntax_ContravariantSemigroupalSyntax: 1,
  Lcats_syntax_EitherKSyntax: 1,
  Lcats_syntax_EitherSyntax: 1,
  Lcats_syntax_EqSyntax: 1,
  Lcats_FlatMap$ToFlatMapOps: 1,
  Lcats_syntax_FlatMapSyntax: 1,
  Lcats_Foldable$ToFoldableOps: 1,
  Lcats_UnorderedFoldable$ToUnorderedFoldableOps: 1,
  Lcats_syntax_FoldableSyntax: 1,
  Lcats_Functor$ToFunctorOps: 1,
  Lcats_syntax_FunctorSyntax: 1,
  Lcats_syntax_SemigroupSyntax: 1,
  Lcats_syntax_GroupSyntax: 1,
  Lcats_syntax_HashSyntax: 1,
  Lcats_Invariant$ToInvariantOps: 1,
  Lcats_syntax_InvariantSyntax: 1,
  Lcats_syntax_IorSyntax: 1,
  Lcats_syntax_ListSyntax: 1,
  Lcats_syntax_MonadErrorSyntax: 1,
  Lcats_syntax_MonadSyntax: 1,
  Lcats_syntax_MonoidSyntax: 1,
  Lcats_syntax_OptionSyntax: 1,
  Lcats_syntax_PartialOrderSyntax: 1,
  Lcats_syntax_OrderSyntax: 1,
  Lcats_syntax_TupleParallelSyntax: 1,
  Lcats_syntax_ParallelSyntax: 1,
  Lcats_arrow_Profunctor$ToProfunctorOps: 1,
  Lcats_syntax_ProfunctorSyntax: 1,
  Lcats_Reducible$ToReducibleOps: 1,
  Lcats_syntax_ReducibleSyntax: 1,
  Lcats_SemigroupK$ToSemigroupKOps: 1,
  Lcats_syntax_SemigroupKSyntax: 1,
  Lcats_Show$ToShowOps: 1,
  Lcats_syntax_ShowSyntax: 1,
  Lcats_arrow_Strong$ToStrongOps: 1,
  Lcats_syntax_StrongSyntax: 1,
  Lcats_Traverse$ToTraverseOps: 1,
  Lcats_syntax_TraverseSyntax: 1,
  Lcats_NonEmptyTraverse$ToNonEmptyTraverseOps: 1,
  Lcats_syntax_NonEmptyTraverseSyntax: 1,
  Lcats_syntax_ValidatedSyntax: 1,
  Lcats_syntax_VectorSyntax: 1,
  Lcats_syntax_WriterSyntax: 1,
  Lcats_syntax_ParallelFoldMapASyntax: 1,
  Lcats_syntax_ParallelTraverseFilterSyntax: 1,
  Lcats_syntax_ParallelReduceMapASyntax: 1,
  Lcats_syntax_AllSyntax: 1,
  Lcats_UnorderedTraverse$ToUnorderedTraverseOps: 1,
  Lcats_syntax_UnorderedTraverseSyntax: 1,
  Lcats_syntax_ApplicativeErrorExtension: 1,
  Lcats_syntax_TrySyntax: 1,
  Lcats_syntax_AllSyntaxBinCompat0: 1,
  Lcats_syntax_FlatMapOptionSyntax: 1,
  Lcats_arrow_Choice$ToChoiceOps: 1,
  Lcats_syntax_ChoiceSyntax: 1,
  Lcats_syntax_NestedSyntax: 1,
  Lcats_syntax_BinestedSyntax: 1,
  Lcats_syntax_ParallelFlatSyntax: 1,
  Lcats_syntax_SetSyntax: 1,
  Lcats_syntax_ValidatedExtensionSyntax: 1,
  Lcats_syntax_RepresentableSyntax: 1,
  Lcats_syntax_AllSyntaxBinCompat1: 1,
  Lcats_syntax_ParallelTraverseSyntax: 1,
  Lcats_TraverseFilter$ToTraverseFilterOps: 1,
  Lcats_syntax_TraverseFilterSyntax: 1,
  Lcats_FunctorFilter$ToFunctorFilterOps: 1,
  Lcats_syntax_FunctorFilterSyntax: 1,
  Lcats_syntax_EitherSyntaxBinCompat0: 1,
  Lcats_syntax_ListSyntaxBinCompat0: 1,
  Lcats_syntax_ValidatedSyntaxBincompat0: 1,
  Lcats_syntax_AllSyntaxBinCompat2: 1,
  Lcats_syntax_UnorderedFoldableSyntax: 1,
  Lcats_syntax_Function1Syntax: 1,
  Lcats_syntax_AllSyntaxBinCompat3: 1,
  Lcats_syntax_TraverseFilterSyntaxBinCompat0: 1,
  Lcats_syntax_ApplySyntaxBinCompat0: 1,
  Lcats_syntax_ParallelApplySyntax: 1,
  Lcats_syntax_FoldableSyntaxBinCompat0: 1,
  Lcats_syntax_ReducibleSyntaxBinCompat0: 1,
  Lcats_syntax_FoldableSyntaxBinCompat1: 1,
  Lcats_syntax_BitraverseSyntaxBinCompat0: 1,
  Lcats_syntax_AllSyntaxBinCompat4: 1,
  Lcats_syntax_ParallelBitraverseSyntax: 1,
  Lcats_syntax_AllSyntaxBinCompat5: 1,
  Lcats_syntax_ParallelUnorderedTraverseSyntax: 1,
  Lcats_syntax_AllSyntaxBinCompat6: 1,
  Lcats_kernel_instances_IntInstances: 1,
  Lcats_instances_IntInstances: 1,
  Lcats_kernel_instances_ByteInstances: 1,
  Lcats_instances_ByteInstances: 1,
  Lcats_kernel_instances_CharInstances: 1,
  Lcats_instances_CharInstances: 1,
  Lcats_kernel_instances_LongInstances: 1,
  Lcats_instances_LongInstances: 1,
  Lcats_kernel_instances_ShortInstances: 1,
  Lcats_instances_ShortInstances: 1,
  Lcats_kernel_instances_FloatInstances: 1,
  Lcats_instances_FloatInstances: 1,
  Lcats_kernel_instances_DoubleInstances: 1,
  Lcats_instances_DoubleInstances: 1,
  Lcats_kernel_instances_BooleanInstances: 1,
  Lcats_instances_BooleanInstances: 1,
  Lcats_kernel_instances_UnitInstances: 1,
  Lcats_instances_UnitInstances: 1,
  Lcats_instances_Tuple2Instances4: 1,
  Lcats_instances_Tuple2Instances3: 1,
  Lcats_instances_Tuple2Instances2: 1,
  Lcats_instances_Tuple2Instances1: 1,
  Lcats_instances_Tuple2Instances: 1,
  Lcats_kernel_instances_TupleInstances3: 1,
  Lcats_kernel_instances_TupleInstances2: 1,
  Lcats_kernel_instances_TupleInstances1: 1,
  Lcats_kernel_instances_TupleInstances: 1,
  Lcats_instances_TupleInstances: 1,
  Lcats_instances_AnyValInstances: 1,
  Lcats_kernel_instances_ArraySeqInstances$ArraySeqInstances2: 1,
  Lcats_kernel_instances_ArraySeqInstances$ArraySeqInstances1: 1,
  Lcats_kernel_instances_ArraySeqInstances: 1,
  Lcats_instances_ArraySeqInstances: 1,
  Lcats_kernel_instances_BigIntInstances: 1,
  Lcats_instances_BigIntInstances: 1,
  Lcats_kernel_instances_BigDecimalInstances: 1,
  Lcats_instances_BigDecimalInstances: 1,
  Lcats_kernel_instances_BitSetInstances: 1,
  Lcats_instances_BitSetInstances: 1,
  Lcats_kernel_instances_EitherInstances1: 1,
  Lcats_kernel_instances_EitherInstances0: 1,
  Lcats_kernel_instances_EitherInstances: 1,
  Lcats_instances_EitherInstances: 1,
  Lcats_kernel_EqToEquivConversion: 1,
  Lcats_kernel_instances_EqInstances: 1,
  Lcats_instances_EqInstances: 1,
  Lcats_instances_EquivInstances: 1,
  Lcats_kernel_instances_FunctionInstances4: 1,
  Lcats_kernel_instances_FunctionInstances3: 1,
  Lcats_kernel_instances_FunctionInstances2: 1,
  Lcats_kernel_instances_FunctionInstances1: 1,
  Lcats_kernel_instances_FunctionInstances0: 1,
  Lcats_kernel_instances_FunctionInstances: 1,
  Lcats_instances_Function0Instances0: 1,
  Lcats_instances_Function0Instances: 1,
  Lcats_instances_Function1Instances0: 1,
  Lcats_instances_Function1Instances: 1,
  Lcats_instances_FunctionInstances: 1,
  Lcats_instances_FutureInstances2: 1,
  Lcats_instances_FutureInstances1: 1,
  Lcats_instances_FutureInstances: 1,
  Lcats_kernel_HashToHashingConversion: 1,
  Lcats_kernel_instances_HashInstances: 1,
  Lcats_instances_HashInstances: 1,
  Lcats_instances_InvariantMonoidalInstances: 1,
  Lcats_kernel_instances_LazyListInstances2: 1,
  Lcats_kernel_instances_LazyListInstances1: 1,
  Lcats_kernel_instances_LazyListInstances: 1,
  Lcats_instances_LazyListInstances: 1,
  Lcats_kernel_instances_ListInstances2: 1,
  Lcats_kernel_instances_ListInstances1: 1,
  Lcats_kernel_instances_ListInstances: 1,
  Lcats_instances_ListInstances: 1,
  Lcats_kernel_instances_MapInstances1: 1,
  Lcats_kernel_instances_MapInstances: 1,
  Lcats_instances_MapInstances: 1,
  Lcats_kernel_instances_OptionInstances2: 1,
  Lcats_kernel_instances_OptionInstances1: 1,
  Lcats_kernel_instances_OptionInstances0: 1,
  Lcats_kernel_instances_OptionInstances: 1,
  Lcats_instances_OptionInstances: 1,
  Lcats_kernel_OrderToOrderingConversion: 1,
  Lcats_kernel_instances_OrderInstances: 1,
  Lcats_instances_OrderInstances: 1,
  Lcats_instances_OrderingInstances: 1,
  Lcats_instances_ParallelInstances1: 1,
  Lcats_instances_ParallelInstances: 1,
  Lcats_kernel_PartialOrderToPartialOrderingConversion: 1,
  Lcats_kernel_instances_PartialOrderInstances: 1,
  Lcats_instances_PartialOrderInstances: 1,
  Lcats_instances_PartialOrderingInstances: 1,
  Lcats_kernel_instances_QueueInstances2: 1,
  Lcats_kernel_instances_QueueInstances1: 1,
  Lcats_kernel_instances_QueueInstances: 1,
  Lcats_instances_QueueInstances: 1,
  Lcats_kernel_instances_SetInstances1: 1,
  Lcats_kernel_instances_SetInstances: 1,
  Lcats_instances_SetInstances: 1,
  Lcats_instances_SortedMapInstances1: 1,
  Lcats_instances_SortedMapInstances2: 1,
  Lcats_instances_SortedMapInstances: 1,
  Lcats_instances_SortedSetInstances1: 1,
  Lcats_instances_SortedSetInstances: 1,
  Lcats_instances_ShowInstances: 1,
  Lcats_kernel_instances_StreamInstances2: 1,
  Lcats_kernel_instances_StreamInstances1: 1,
  Lcats_kernel_instances_StreamInstances: 1,
  Lcats_instances_StreamInstances: 1,
  Lcats_kernel_instances_StringInstances: 1,
  Lcats_instances_StringInstances: 1,
  Lcats_kernel_instances_SymbolInstances: 1,
  Lcats_instances_SymbolInstances: 1,
  Lcats_instances_TailRecInstances: 1,
  Lcats_instances_TryInstances2: 1,
  Lcats_instances_TryInstances1: 1,
  Lcats_instances_TryInstances: 1,
  Lcats_kernel_instances_UUIDInstances: 1,
  Lcats_instances_UUIDInstances: 1,
  Lcats_kernel_instances_VectorInstances2: 1,
  Lcats_kernel_instances_VectorInstances1: 1,
  Lcats_kernel_instances_VectorInstances: 1,
  Lcats_instances_VectorInstances: 1,
  Lcats_instances_PartialFunctionInstances: 1,
  Lcats_instances_AllInstances: 1,
  Lcats_instances_FunctionInstancesBinCompat0: 1,
  Lcats_instances_Tuple2InstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat0: 1,
  Lcats_instances_OptionInstancesBinCompat0: 1,
  Lcats_instances_ListInstancesBinCompat0: 1,
  Lcats_instances_VectorInstancesBinCompat0: 1,
  Lcats_instances_StreamInstancesBinCompat0: 1,
  Lcats_instances_MapInstancesBinCompat0: 1,
  Lcats_instances_SortedMapInstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat1: 1,
  Lcats_kernel_instances_DurationInstances: 1,
  Lcats_instances_DurationInstances: 1,
  Lcats_kernel_instances_FiniteDurationInstances: 1,
  Lcats_instances_FiniteDurationInstances: 1,
  Lcats_instances_AllInstancesBinCompat2: 1,
  Lcats_instances_CoreDurationInstances: 1,
  Lcats_instances_CoreFiniteDurationInstances: 1,
  Lcats_instances_AllCoreDurationInstances: 1,
  Lcats_instances_AllInstancesBinCompat3: 1,
  Lcats_instances_SortedMapInstancesBinCompat1: 1,
  Lcats_instances_MapInstancesBinCompat1: 1,
  Lcats_instances_AllInstancesBinCompat4: 1,
  Lcats_instances_SortedSetInstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat5: 1,
  Lcats_kernel_instances_SortedSetInstances1: 1,
  Lcats_kernel_instances_SortedSetInstances: 1,
  Lcats_instances_LowPrioritySortedSetInstancesBinCompat1: 1,
  Lcats_instances_SortedSetInstancesBinCompat1: 1,
  Lcats_kernel_instances_SortedMapInstances1: 1,
  Lcats_kernel_instances_SortedMapInstances2: 1,
  Lcats_kernel_instances_SortedMapInstances3: 1,
  Lcats_kernel_instances_SortedMapInstances: 1,
  Lcats_instances_SortedMapInstancesBinCompat2: 1,
  Lcats_instances_AllInstancesBinCompat6: 1
}));
var $n_Lcats_implicits$;
function $m_Lcats_implicits$() {
  if ((!$n_Lcats_implicits$)) {
    $n_Lcats_implicits$ = new $c_Lcats_implicits$();
  }
  return $n_Lcats_implicits$;
}
$L0 = new $c_RTLong(0, 0);
$d_J.zero = $L0;
var $t_Ltyrian_runtime_RendererState$__Idle = null;
$s_Ldev_sungkm_enchantedrealm_Main__main__AT__V(new ($d_T.getArrayOf().constr)([]));
